var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __require = /* @__PURE__ */ ((x) => typeof require !== "undefined" ? require : typeof Proxy !== "undefined" ? new Proxy(x, {
  get: (a, b) => (typeof require !== "undefined" ? require : a)[b]
}) : x)(function(x) {
  if (typeof require !== "undefined") return require.apply(this, arguments);
  throw Error('Dynamic require of "' + x + '" is not supported');
});
var __commonJS = (cb, mod) => function __require2() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from2, except, desc) => {
  if (from2 && typeof from2 === "object" || typeof from2 === "function") {
    for (let key2 of __getOwnPropNames(from2))
      if (!__hasOwnProp.call(to, key2) && key2 !== except)
        __defProp(to, key2, { get: () => from2[key2], enumerable: !(desc = __getOwnPropDesc(from2, key2)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// ../../node_modules/object-assign/index.js
var require_object_assign = __commonJS({
  "../../node_modules/object-assign/index.js"(exports2, module2) {
    "use strict";
    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var hasOwnProperty15 = Object.prototype.hasOwnProperty;
    var propIsEnumerable = Object.prototype.propertyIsEnumerable;
    function toObject(val) {
      if (val === null || val === void 0) {
        throw new TypeError("Object.assign cannot be called with null or undefined");
      }
      return Object(val);
    }
    function shouldUseNative() {
      try {
        if (!Object.assign) {
          return false;
        }
        var test1 = new String("abc");
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") {
          return false;
        }
        var test2 = {};
        for (var i = 0; i < 10; i++) {
          test2["_" + String.fromCharCode(i)] = i;
        }
        var order2 = Object.getOwnPropertyNames(test2).map(function(n2) {
          return test2[n2];
        });
        if (order2.join("") !== "0123456789") {
          return false;
        }
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
          test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
          return false;
        }
        return true;
      } catch (err) {
        return false;
      }
    }
    module2.exports = shouldUseNative() ? Object.assign : function(target, source) {
      var from2;
      var to = toObject(target);
      var symbols;
      for (var s = 1; s < arguments.length; s++) {
        from2 = Object(arguments[s]);
        for (var key2 in from2) {
          if (hasOwnProperty15.call(from2, key2)) {
            to[key2] = from2[key2];
          }
        }
        if (getOwnPropertySymbols) {
          symbols = getOwnPropertySymbols(from2);
          for (var i = 0; i < symbols.length; i++) {
            if (propIsEnumerable.call(from2, symbols[i])) {
              to[symbols[i]] = from2[symbols[i]];
            }
          }
        }
      }
      return to;
    };
  }
});

// ../../node_modules/prop-types/lib/ReactPropTypesSecret.js
var require_ReactPropTypesSecret = __commonJS({
  "../../node_modules/prop-types/lib/ReactPropTypesSecret.js"(exports2, module2) {
    "use strict";
    var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
    module2.exports = ReactPropTypesSecret;
  }
});

// ../../node_modules/prop-types/lib/has.js
var require_has = __commonJS({
  "../../node_modules/prop-types/lib/has.js"(exports2, module2) {
    module2.exports = Function.call.bind(Object.prototype.hasOwnProperty);
  }
});

// ../../node_modules/prop-types/checkPropTypes.js
var require_checkPropTypes = __commonJS({
  "../../node_modules/prop-types/checkPropTypes.js"(exports2, module2) {
    "use strict";
    var printWarning = function() {
    };
    if (true) {
      ReactPropTypesSecret = require_ReactPropTypesSecret();
      loggedTypeFailures = {};
      has2 = require_has();
      printWarning = function(text) {
        var message2 = "Warning: " + text;
        if (typeof console !== "undefined") {
          console.error(message2);
        }
        try {
          throw new Error(message2);
        } catch (x) {
        }
      };
    }
    var ReactPropTypesSecret;
    var loggedTypeFailures;
    var has2;
    function checkPropTypes(typeSpecs, values, location2, componentName, getStack) {
      if (true) {
        for (var typeSpecName in typeSpecs) {
          if (has2(typeSpecs, typeSpecName)) {
            var error2;
            try {
              if (typeof typeSpecs[typeSpecName] !== "function") {
                var err = Error(
                  (componentName || "React class") + ": " + location2 + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
                );
                err.name = "Invariant Violation";
                throw err;
              }
              error2 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location2, null, ReactPropTypesSecret);
            } catch (ex) {
              error2 = ex;
            }
            if (error2 && !(error2 instanceof Error)) {
              printWarning(
                (componentName || "React class") + ": type specification of " + location2 + " `" + typeSpecName + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof error2 + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
              );
            }
            if (error2 instanceof Error && !(error2.message in loggedTypeFailures)) {
              loggedTypeFailures[error2.message] = true;
              var stack = getStack ? getStack() : "";
              printWarning(
                "Failed " + location2 + " type: " + error2.message + (stack != null ? stack : "")
              );
            }
          }
        }
      }
    }
    checkPropTypes.resetWarningCache = function() {
      if (true) {
        loggedTypeFailures = {};
      }
    };
    module2.exports = checkPropTypes;
  }
});

// ../../node_modules/react/cjs/react.development.js
var require_react_development = __commonJS({
  "../../node_modules/react/cjs/react.development.js"(exports2) {
    "use strict";
    if (true) {
      (function() {
        "use strict";
        var _assign = require_object_assign();
        var checkPropTypes = require_checkPropTypes();
        var ReactVersion = "16.14.0";
        var hasSymbol = typeof Symbol === "function" && Symbol.for;
        var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 60103;
        var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 60106;
        var REACT_FRAGMENT_TYPE2 = hasSymbol ? Symbol.for("react.fragment") : 60107;
        var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 60108;
        var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 60114;
        var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 60109;
        var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 60110;
        var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 60111;
        var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 60112;
        var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 60113;
        var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 60120;
        var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 60115;
        var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 60116;
        var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 60121;
        var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 60117;
        var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 60118;
        var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 60119;
        var MAYBE_ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
        var FAUX_ITERATOR_SYMBOL = "@@iterator";
        function getIteratorFn(maybeIterable) {
          if (maybeIterable === null || typeof maybeIterable !== "object") {
            return null;
          }
          var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
          if (typeof maybeIterator === "function") {
            return maybeIterator;
          }
          return null;
        }
        var ReactCurrentDispatcher = {
          /**
           * @internal
           * @type {ReactComponent}
           */
          current: null
        };
        var ReactCurrentBatchConfig = {
          suspense: null
        };
        var ReactCurrentOwner = {
          /**
           * @internal
           * @type {ReactComponent}
           */
          current: null
        };
        var BEFORE_SLASH_RE = /^(.*)[\\\/]/;
        function describeComponentFrame(name, source, ownerName) {
          var sourceInfo = "";
          if (source) {
            var path2 = source.fileName;
            var fileName = path2.replace(BEFORE_SLASH_RE, "");
            {
              if (/^index\./.test(fileName)) {
                var match2 = path2.match(BEFORE_SLASH_RE);
                if (match2) {
                  var pathBeforeSlash = match2[1];
                  if (pathBeforeSlash) {
                    var folderName = pathBeforeSlash.replace(BEFORE_SLASH_RE, "");
                    fileName = folderName + "/" + fileName;
                  }
                }
              }
            }
            sourceInfo = " (at " + fileName + ":" + source.lineNumber + ")";
          } else if (ownerName) {
            sourceInfo = " (created by " + ownerName + ")";
          }
          return "\n    in " + (name || "Unknown") + sourceInfo;
        }
        var Resolved = 1;
        function refineResolvedLazyComponent(lazyComponent) {
          return lazyComponent._status === Resolved ? lazyComponent._result : null;
        }
        function getWrappedName(outerType, innerType, wrapperName) {
          var functionName = innerType.displayName || innerType.name || "";
          return outerType.displayName || (functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName);
        }
        function getComponentName(type5) {
          if (type5 == null) {
            return null;
          }
          {
            if (typeof type5.tag === "number") {
              error2("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue.");
            }
          }
          if (typeof type5 === "function") {
            return type5.displayName || type5.name || null;
          }
          if (typeof type5 === "string") {
            return type5;
          }
          switch (type5) {
            case REACT_FRAGMENT_TYPE2:
              return "Fragment";
            case REACT_PORTAL_TYPE:
              return "Portal";
            case REACT_PROFILER_TYPE:
              return "Profiler";
            case REACT_STRICT_MODE_TYPE:
              return "StrictMode";
            case REACT_SUSPENSE_TYPE:
              return "Suspense";
            case REACT_SUSPENSE_LIST_TYPE:
              return "SuspenseList";
          }
          if (typeof type5 === "object") {
            switch (type5.$$typeof) {
              case REACT_CONTEXT_TYPE:
                return "Context.Consumer";
              case REACT_PROVIDER_TYPE:
                return "Context.Provider";
              case REACT_FORWARD_REF_TYPE:
                return getWrappedName(type5, type5.render, "ForwardRef");
              case REACT_MEMO_TYPE:
                return getComponentName(type5.type);
              case REACT_BLOCK_TYPE:
                return getComponentName(type5.render);
              case REACT_LAZY_TYPE: {
                var thenable = type5;
                var resolvedThenable = refineResolvedLazyComponent(thenable);
                if (resolvedThenable) {
                  return getComponentName(resolvedThenable);
                }
                break;
              }
            }
          }
          return null;
        }
        var ReactDebugCurrentFrame = {};
        var currentlyValidatingElement = null;
        function setCurrentlyValidatingElement(element) {
          {
            currentlyValidatingElement = element;
          }
        }
        {
          ReactDebugCurrentFrame.getCurrentStack = null;
          ReactDebugCurrentFrame.getStackAddendum = function() {
            var stack = "";
            if (currentlyValidatingElement) {
              var name = getComponentName(currentlyValidatingElement.type);
              var owner = currentlyValidatingElement._owner;
              stack += describeComponentFrame(name, currentlyValidatingElement._source, owner && getComponentName(owner.type));
            }
            var impl = ReactDebugCurrentFrame.getCurrentStack;
            if (impl) {
              stack += impl() || "";
            }
            return stack;
          };
        }
        var IsSomeRendererActing = {
          current: false
        };
        var ReactSharedInternals = {
          ReactCurrentDispatcher,
          ReactCurrentBatchConfig,
          ReactCurrentOwner,
          IsSomeRendererActing,
          // Used by renderers to avoid bundling object-assign twice in UMD bundles:
          assign: _assign
        };
        {
          _assign(ReactSharedInternals, {
            // These should not be included in production.
            ReactDebugCurrentFrame,
            // Shim for React DOM 16.0.0 which still destructured (but not used) this.
            // TODO: remove in React 17.0.
            ReactComponentTreeHook: {}
          });
        }
        function warn(format3) {
          {
            for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
              args[_key - 1] = arguments[_key];
            }
            printWarning("warn", format3, args);
          }
        }
        function error2(format3) {
          {
            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }
            printWarning("error", format3, args);
          }
        }
        function printWarning(level, format3, args) {
          {
            var hasExistingStack = args.length > 0 && typeof args[args.length - 1] === "string" && args[args.length - 1].indexOf("\n    in") === 0;
            if (!hasExistingStack) {
              var ReactDebugCurrentFrame2 = ReactSharedInternals.ReactDebugCurrentFrame;
              var stack = ReactDebugCurrentFrame2.getStackAddendum();
              if (stack !== "") {
                format3 += "%s";
                args = args.concat([stack]);
              }
            }
            var argsWithFormat = args.map(function(item) {
              return "" + item;
            });
            argsWithFormat.unshift("Warning: " + format3);
            Function.prototype.apply.call(console[level], console, argsWithFormat);
            try {
              var argIndex = 0;
              var message2 = "Warning: " + format3.replace(/%s/g, function() {
                return args[argIndex++];
              });
              throw new Error(message2);
            } catch (x) {
            }
          }
        }
        var didWarnStateUpdateForUnmountedComponent = {};
        function warnNoop(publicInstance, callerName) {
          {
            var _constructor = publicInstance.constructor;
            var componentName = _constructor && (_constructor.displayName || _constructor.name) || "ReactClass";
            var warningKey = componentName + "." + callerName;
            if (didWarnStateUpdateForUnmountedComponent[warningKey]) {
              return;
            }
            error2("Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.", callerName, componentName);
            didWarnStateUpdateForUnmountedComponent[warningKey] = true;
          }
        }
        var ReactNoopUpdateQueue = {
          /**
           * Checks whether or not this composite component is mounted.
           * @param {ReactClass} publicInstance The instance we want to test.
           * @return {boolean} True if mounted, false otherwise.
           * @protected
           * @final
           */
          isMounted: function(publicInstance) {
            return false;
          },
          /**
           * Forces an update. This should only be invoked when it is known with
           * certainty that we are **not** in a DOM transaction.
           *
           * You may want to call this when you know that some deeper aspect of the
           * component's state has changed but `setState` was not called.
           *
           * This will not invoke `shouldComponentUpdate`, but it will invoke
           * `componentWillUpdate` and `componentDidUpdate`.
           *
           * @param {ReactClass} publicInstance The instance that should rerender.
           * @param {?function} callback Called after component is updated.
           * @param {?string} callerName name of the calling function in the public API.
           * @internal
           */
          enqueueForceUpdate: function(publicInstance, callback, callerName) {
            warnNoop(publicInstance, "forceUpdate");
          },
          /**
           * Replaces all of the state. Always use this or `setState` to mutate state.
           * You should treat `this.state` as immutable.
           *
           * There is no guarantee that `this.state` will be immediately updated, so
           * accessing `this.state` after calling this method may return the old value.
           *
           * @param {ReactClass} publicInstance The instance that should rerender.
           * @param {object} completeState Next state.
           * @param {?function} callback Called after component is updated.
           * @param {?string} callerName name of the calling function in the public API.
           * @internal
           */
          enqueueReplaceState: function(publicInstance, completeState, callback, callerName) {
            warnNoop(publicInstance, "replaceState");
          },
          /**
           * Sets a subset of the state. This only exists because _pendingState is
           * internal. This provides a merging strategy that is not available to deep
           * properties which is confusing. TODO: Expose pendingState or don't use it
           * during the merge.
           *
           * @param {ReactClass} publicInstance The instance that should rerender.
           * @param {object} partialState Next partial state to be merged with state.
           * @param {?function} callback Called after component is updated.
           * @param {?string} Name of the calling function in the public API.
           * @internal
           */
          enqueueSetState: function(publicInstance, partialState, callback, callerName) {
            warnNoop(publicInstance, "setState");
          }
        };
        var emptyObject = {};
        {
          Object.freeze(emptyObject);
        }
        function Component10(props, context, updater) {
          this.props = props;
          this.context = context;
          this.refs = emptyObject;
          this.updater = updater || ReactNoopUpdateQueue;
        }
        Component10.prototype.isReactComponent = {};
        Component10.prototype.setState = function(partialState, callback) {
          if (!(typeof partialState === "object" || typeof partialState === "function" || partialState == null)) {
            {
              throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
            }
          }
          this.updater.enqueueSetState(this, partialState, callback, "setState");
        };
        Component10.prototype.forceUpdate = function(callback) {
          this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
        };
        {
          var deprecatedAPIs = {
            isMounted: ["isMounted", "Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."],
            replaceState: ["replaceState", "Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."]
          };
          var defineDeprecationWarning = function(methodName, info) {
            Object.defineProperty(Component10.prototype, methodName, {
              get: function() {
                warn("%s(...) is deprecated in plain JavaScript React classes. %s", info[0], info[1]);
                return void 0;
              }
            });
          };
          for (var fnName in deprecatedAPIs) {
            if (deprecatedAPIs.hasOwnProperty(fnName)) {
              defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
            }
          }
        }
        function ComponentDummy() {
        }
        ComponentDummy.prototype = Component10.prototype;
        function PureComponent5(props, context, updater) {
          this.props = props;
          this.context = context;
          this.refs = emptyObject;
          this.updater = updater || ReactNoopUpdateQueue;
        }
        var pureComponentPrototype = PureComponent5.prototype = new ComponentDummy();
        pureComponentPrototype.constructor = PureComponent5;
        _assign(pureComponentPrototype, Component10.prototype);
        pureComponentPrototype.isPureReactComponent = true;
        function createRef4() {
          var refObject = {
            current: null
          };
          {
            Object.seal(refObject);
          }
          return refObject;
        }
        var hasOwnProperty15 = Object.prototype.hasOwnProperty;
        var RESERVED_PROPS = {
          key: true,
          ref: true,
          __self: true,
          __source: true
        };
        var specialPropKeyWarningShown, specialPropRefWarningShown, didWarnAboutStringRefs;
        {
          didWarnAboutStringRefs = {};
        }
        function hasValidRef(config) {
          {
            if (hasOwnProperty15.call(config, "ref")) {
              var getter = Object.getOwnPropertyDescriptor(config, "ref").get;
              if (getter && getter.isReactWarning) {
                return false;
              }
            }
          }
          return config.ref !== void 0;
        }
        function hasValidKey(config) {
          {
            if (hasOwnProperty15.call(config, "key")) {
              var getter = Object.getOwnPropertyDescriptor(config, "key").get;
              if (getter && getter.isReactWarning) {
                return false;
              }
            }
          }
          return config.key !== void 0;
        }
        function defineKeyPropWarningGetter(props, displayName) {
          var warnAboutAccessingKey = function() {
            {
              if (!specialPropKeyWarningShown) {
                specialPropKeyWarningShown = true;
                error2("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://fb.me/react-special-props)", displayName);
              }
            }
          };
          warnAboutAccessingKey.isReactWarning = true;
          Object.defineProperty(props, "key", {
            get: warnAboutAccessingKey,
            configurable: true
          });
        }
        function defineRefPropWarningGetter(props, displayName) {
          var warnAboutAccessingRef = function() {
            {
              if (!specialPropRefWarningShown) {
                specialPropRefWarningShown = true;
                error2("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://fb.me/react-special-props)", displayName);
              }
            }
          };
          warnAboutAccessingRef.isReactWarning = true;
          Object.defineProperty(props, "ref", {
            get: warnAboutAccessingRef,
            configurable: true
          });
        }
        function warnIfStringRefCannotBeAutoConverted(config) {
          {
            if (typeof config.ref === "string" && ReactCurrentOwner.current && config.__self && ReactCurrentOwner.current.stateNode !== config.__self) {
              var componentName = getComponentName(ReactCurrentOwner.current.type);
              if (!didWarnAboutStringRefs[componentName]) {
                error2('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://fb.me/react-strict-mode-string-ref', getComponentName(ReactCurrentOwner.current.type), config.ref);
                didWarnAboutStringRefs[componentName] = true;
              }
            }
          }
        }
        var ReactElement = function(type5, key2, ref3, self2, source, owner, props) {
          var element = {
            // This tag allows us to uniquely identify this as a React Element
            $$typeof: REACT_ELEMENT_TYPE,
            // Built-in properties that belong on the element
            type: type5,
            key: key2,
            ref: ref3,
            props,
            // Record the component responsible for creating this element.
            _owner: owner
          };
          {
            element._store = {};
            Object.defineProperty(element._store, "validated", {
              configurable: false,
              enumerable: false,
              writable: true,
              value: false
            });
            Object.defineProperty(element, "_self", {
              configurable: false,
              enumerable: false,
              writable: false,
              value: self2
            });
            Object.defineProperty(element, "_source", {
              configurable: false,
              enumerable: false,
              writable: false,
              value: source
            });
            if (Object.freeze) {
              Object.freeze(element.props);
              Object.freeze(element);
            }
          }
          return element;
        };
        function createElement330(type5, config, children) {
          var propName;
          var props = {};
          var key2 = null;
          var ref3 = null;
          var self2 = null;
          var source = null;
          if (config != null) {
            if (hasValidRef(config)) {
              ref3 = config.ref;
              {
                warnIfStringRefCannotBeAutoConverted(config);
              }
            }
            if (hasValidKey(config)) {
              key2 = "" + config.key;
            }
            self2 = config.__self === void 0 ? null : config.__self;
            source = config.__source === void 0 ? null : config.__source;
            for (propName in config) {
              if (hasOwnProperty15.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
                props[propName] = config[propName];
              }
            }
          }
          var childrenLength = arguments.length - 2;
          if (childrenLength === 1) {
            props.children = children;
          } else if (childrenLength > 1) {
            var childArray = Array(childrenLength);
            for (var i = 0; i < childrenLength; i++) {
              childArray[i] = arguments[i + 2];
            }
            {
              if (Object.freeze) {
                Object.freeze(childArray);
              }
            }
            props.children = childArray;
          }
          if (type5 && type5.defaultProps) {
            var defaultProps2 = type5.defaultProps;
            for (propName in defaultProps2) {
              if (props[propName] === void 0) {
                props[propName] = defaultProps2[propName];
              }
            }
          }
          {
            if (key2 || ref3) {
              var displayName = typeof type5 === "function" ? type5.displayName || type5.name || "Unknown" : type5;
              if (key2) {
                defineKeyPropWarningGetter(props, displayName);
              }
              if (ref3) {
                defineRefPropWarningGetter(props, displayName);
              }
            }
          }
          return ReactElement(type5, key2, ref3, self2, source, ReactCurrentOwner.current, props);
        }
        function cloneAndReplaceKey(oldElement, newKey) {
          var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
          return newElement;
        }
        function cloneElement19(element, config, children) {
          if (!!(element === null || element === void 0)) {
            {
              throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + element + ".");
            }
          }
          var propName;
          var props = _assign({}, element.props);
          var key2 = element.key;
          var ref3 = element.ref;
          var self2 = element._self;
          var source = element._source;
          var owner = element._owner;
          if (config != null) {
            if (hasValidRef(config)) {
              ref3 = config.ref;
              owner = ReactCurrentOwner.current;
            }
            if (hasValidKey(config)) {
              key2 = "" + config.key;
            }
            var defaultProps2;
            if (element.type && element.type.defaultProps) {
              defaultProps2 = element.type.defaultProps;
            }
            for (propName in config) {
              if (hasOwnProperty15.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
                if (config[propName] === void 0 && defaultProps2 !== void 0) {
                  props[propName] = defaultProps2[propName];
                } else {
                  props[propName] = config[propName];
                }
              }
            }
          }
          var childrenLength = arguments.length - 2;
          if (childrenLength === 1) {
            props.children = children;
          } else if (childrenLength > 1) {
            var childArray = Array(childrenLength);
            for (var i = 0; i < childrenLength; i++) {
              childArray[i] = arguments[i + 2];
            }
            props.children = childArray;
          }
          return ReactElement(element.type, key2, ref3, self2, source, owner, props);
        }
        function isValidElement31(object4) {
          return typeof object4 === "object" && object4 !== null && object4.$$typeof === REACT_ELEMENT_TYPE;
        }
        var SEPARATOR = ".";
        var SUBSEPARATOR = ":";
        function escape2(key2) {
          var escapeRegex = /[=:]/g;
          var escaperLookup = {
            "=": "=0",
            ":": "=2"
          };
          var escapedString = ("" + key2).replace(escapeRegex, function(match2) {
            return escaperLookup[match2];
          });
          return "$" + escapedString;
        }
        var didWarnAboutMaps = false;
        var userProvidedKeyEscapeRegex = /\/+/g;
        function escapeUserProvidedKey(text) {
          return ("" + text).replace(userProvidedKeyEscapeRegex, "$&/");
        }
        var POOL_SIZE = 10;
        var traverseContextPool = [];
        function getPooledTraverseContext(mapResult, keyPrefix, mapFunction, mapContext) {
          if (traverseContextPool.length) {
            var traverseContext = traverseContextPool.pop();
            traverseContext.result = mapResult;
            traverseContext.keyPrefix = keyPrefix;
            traverseContext.func = mapFunction;
            traverseContext.context = mapContext;
            traverseContext.count = 0;
            return traverseContext;
          } else {
            return {
              result: mapResult,
              keyPrefix,
              func: mapFunction,
              context: mapContext,
              count: 0
            };
          }
        }
        function releaseTraverseContext(traverseContext) {
          traverseContext.result = null;
          traverseContext.keyPrefix = null;
          traverseContext.func = null;
          traverseContext.context = null;
          traverseContext.count = 0;
          if (traverseContextPool.length < POOL_SIZE) {
            traverseContextPool.push(traverseContext);
          }
        }
        function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
          var type5 = typeof children;
          if (type5 === "undefined" || type5 === "boolean") {
            children = null;
          }
          var invokeCallback = false;
          if (children === null) {
            invokeCallback = true;
          } else {
            switch (type5) {
              case "string":
              case "number":
                invokeCallback = true;
                break;
              case "object":
                switch (children.$$typeof) {
                  case REACT_ELEMENT_TYPE:
                  case REACT_PORTAL_TYPE:
                    invokeCallback = true;
                }
            }
          }
          if (invokeCallback) {
            callback(
              traverseContext,
              children,
              // If it's the only child, treat the name as if it was wrapped in an array
              // so that it's consistent if the number of children grows.
              nameSoFar === "" ? SEPARATOR + getComponentKey(children, 0) : nameSoFar
            );
            return 1;
          }
          var child;
          var nextName;
          var subtreeCount = 0;
          var nextNamePrefix = nameSoFar === "" ? SEPARATOR : nameSoFar + SUBSEPARATOR;
          if (Array.isArray(children)) {
            for (var i = 0; i < children.length; i++) {
              child = children[i];
              nextName = nextNamePrefix + getComponentKey(child, i);
              subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
            }
          } else {
            var iteratorFn = getIteratorFn(children);
            if (typeof iteratorFn === "function") {
              {
                if (iteratorFn === children.entries) {
                  if (!didWarnAboutMaps) {
                    warn("Using Maps as children is deprecated and will be removed in a future major release. Consider converting children to an array of keyed ReactElements instead.");
                  }
                  didWarnAboutMaps = true;
                }
              }
              var iterator = iteratorFn.call(children);
              var step;
              var ii = 0;
              while (!(step = iterator.next()).done) {
                child = step.value;
                nextName = nextNamePrefix + getComponentKey(child, ii++);
                subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
              }
            } else if (type5 === "object") {
              var addendum = "";
              {
                addendum = " If you meant to render a collection of children, use an array instead." + ReactDebugCurrentFrame.getStackAddendum();
              }
              var childrenString = "" + children;
              {
                {
                  throw Error("Objects are not valid as a React child (found: " + (childrenString === "[object Object]" ? "object with keys {" + Object.keys(children).join(", ") + "}" : childrenString) + ")." + addendum);
                }
              }
            }
          }
          return subtreeCount;
        }
        function traverseAllChildren(children, callback, traverseContext) {
          if (children == null) {
            return 0;
          }
          return traverseAllChildrenImpl(children, "", callback, traverseContext);
        }
        function getComponentKey(component, index3) {
          if (typeof component === "object" && component !== null && component.key != null) {
            return escape2(component.key);
          }
          return index3.toString(36);
        }
        function forEachSingleChild(bookKeeping, child, name) {
          var func = bookKeeping.func, context = bookKeeping.context;
          func.call(context, child, bookKeeping.count++);
        }
        function forEachChildren(children, forEachFunc, forEachContext) {
          if (children == null) {
            return children;
          }
          var traverseContext = getPooledTraverseContext(null, null, forEachFunc, forEachContext);
          traverseAllChildren(children, forEachSingleChild, traverseContext);
          releaseTraverseContext(traverseContext);
        }
        function mapSingleChildIntoContext(bookKeeping, child, childKey) {
          var result = bookKeeping.result, keyPrefix = bookKeeping.keyPrefix, func = bookKeeping.func, context = bookKeeping.context;
          var mappedChild = func.call(context, child, bookKeeping.count++);
          if (Array.isArray(mappedChild)) {
            mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, function(c) {
              return c;
            });
          } else if (mappedChild != null) {
            if (isValidElement31(mappedChild)) {
              mappedChild = cloneAndReplaceKey(
                mappedChild,
                // Keep both the (mapped) and old keys if they differ, just as
                // traverseAllChildren used to do for objects as children
                keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + "/" : "") + childKey
              );
            }
            result.push(mappedChild);
          }
        }
        function mapIntoWithKeyPrefixInternal(children, array4, prefix3, func, context) {
          var escapedPrefix = "";
          if (prefix3 != null) {
            escapedPrefix = escapeUserProvidedKey(prefix3) + "/";
          }
          var traverseContext = getPooledTraverseContext(array4, escapedPrefix, func, context);
          traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
          releaseTraverseContext(traverseContext);
        }
        function mapChildren(children, func, context) {
          if (children == null) {
            return children;
          }
          var result = [];
          mapIntoWithKeyPrefixInternal(children, result, null, func, context);
          return result;
        }
        function countChildren(children) {
          return traverseAllChildren(children, function() {
            return null;
          }, null);
        }
        function toArray11(children) {
          var result = [];
          mapIntoWithKeyPrefixInternal(children, result, null, function(child) {
            return child;
          });
          return result;
        }
        function onlyChild(children) {
          if (!isValidElement31(children)) {
            {
              throw Error("React.Children.only expected to receive a single React element child.");
            }
          }
          return children;
        }
        function createContext55(defaultValue2, calculateChangedBits) {
          if (calculateChangedBits === void 0) {
            calculateChangedBits = null;
          } else {
            {
              if (calculateChangedBits !== null && typeof calculateChangedBits !== "function") {
                error2("createContext: Expected the optional second argument to be a function. Instead received: %s", calculateChangedBits);
              }
            }
          }
          var context = {
            $$typeof: REACT_CONTEXT_TYPE,
            _calculateChangedBits: calculateChangedBits,
            // As a workaround to support multiple concurrent renderers, we categorize
            // some renderers as primary and others as secondary. We only expect
            // there to be two concurrent renderers at most: React Native (primary) and
            // Fabric (secondary); React DOM (primary) and React ART (secondary).
            // Secondary renderers store their context values on separate fields.
            _currentValue: defaultValue2,
            _currentValue2: defaultValue2,
            // Used to track how many concurrent renderers this context currently
            // supports within in a single renderer. Such as parallel server rendering.
            _threadCount: 0,
            // These are circular
            Provider: null,
            Consumer: null
          };
          context.Provider = {
            $$typeof: REACT_PROVIDER_TYPE,
            _context: context
          };
          var hasWarnedAboutUsingNestedContextConsumers = false;
          var hasWarnedAboutUsingConsumerProvider = false;
          {
            var Consumer = {
              $$typeof: REACT_CONTEXT_TYPE,
              _context: context,
              _calculateChangedBits: context._calculateChangedBits
            };
            Object.defineProperties(Consumer, {
              Provider: {
                get: function() {
                  if (!hasWarnedAboutUsingConsumerProvider) {
                    hasWarnedAboutUsingConsumerProvider = true;
                    error2("Rendering <Context.Consumer.Provider> is not supported and will be removed in a future major release. Did you mean to render <Context.Provider> instead?");
                  }
                  return context.Provider;
                },
                set: function(_Provider) {
                  context.Provider = _Provider;
                }
              },
              _currentValue: {
                get: function() {
                  return context._currentValue;
                },
                set: function(_currentValue) {
                  context._currentValue = _currentValue;
                }
              },
              _currentValue2: {
                get: function() {
                  return context._currentValue2;
                },
                set: function(_currentValue2) {
                  context._currentValue2 = _currentValue2;
                }
              },
              _threadCount: {
                get: function() {
                  return context._threadCount;
                },
                set: function(_threadCount) {
                  context._threadCount = _threadCount;
                }
              },
              Consumer: {
                get: function() {
                  if (!hasWarnedAboutUsingNestedContextConsumers) {
                    hasWarnedAboutUsingNestedContextConsumers = true;
                    error2("Rendering <Context.Consumer.Consumer> is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?");
                  }
                  return context.Consumer;
                }
              }
            });
            context.Consumer = Consumer;
          }
          {
            context._currentRenderer = null;
            context._currentRenderer2 = null;
          }
          return context;
        }
        function lazy(ctor) {
          var lazyType2 = {
            $$typeof: REACT_LAZY_TYPE,
            _ctor: ctor,
            // React uses these fields to store the result.
            _status: -1,
            _result: null
          };
          {
            var defaultProps2;
            var propTypes;
            Object.defineProperties(lazyType2, {
              defaultProps: {
                configurable: true,
                get: function() {
                  return defaultProps2;
                },
                set: function(newDefaultProps) {
                  error2("React.lazy(...): It is not supported to assign `defaultProps` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it.");
                  defaultProps2 = newDefaultProps;
                  Object.defineProperty(lazyType2, "defaultProps", {
                    enumerable: true
                  });
                }
              },
              propTypes: {
                configurable: true,
                get: function() {
                  return propTypes;
                },
                set: function(newPropTypes) {
                  error2("React.lazy(...): It is not supported to assign `propTypes` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it.");
                  propTypes = newPropTypes;
                  Object.defineProperty(lazyType2, "propTypes", {
                    enumerable: true
                  });
                }
              }
            });
          }
          return lazyType2;
        }
        function forwardRef180(render4) {
          {
            if (render4 != null && render4.$$typeof === REACT_MEMO_TYPE) {
              error2("forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...)).");
            } else if (typeof render4 !== "function") {
              error2("forwardRef requires a render function but was given %s.", render4 === null ? "null" : typeof render4);
            } else {
              if (render4.length !== 0 && render4.length !== 2) {
                error2("forwardRef render functions accept exactly two parameters: props and ref. %s", render4.length === 1 ? "Did you forget to use the ref parameter?" : "Any additional parameter will be undefined.");
              }
            }
            if (render4 != null) {
              if (render4.defaultProps != null || render4.propTypes != null) {
                error2("forwardRef render functions do not support propTypes or defaultProps. Did you accidentally pass a React component?");
              }
            }
          }
          return {
            $$typeof: REACT_FORWARD_REF_TYPE,
            render: render4
          };
        }
        function isValidElementType(type5) {
          return typeof type5 === "string" || typeof type5 === "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
          type5 === REACT_FRAGMENT_TYPE2 || type5 === REACT_CONCURRENT_MODE_TYPE || type5 === REACT_PROFILER_TYPE || type5 === REACT_STRICT_MODE_TYPE || type5 === REACT_SUSPENSE_TYPE || type5 === REACT_SUSPENSE_LIST_TYPE || typeof type5 === "object" && type5 !== null && (type5.$$typeof === REACT_LAZY_TYPE || type5.$$typeof === REACT_MEMO_TYPE || type5.$$typeof === REACT_PROVIDER_TYPE || type5.$$typeof === REACT_CONTEXT_TYPE || type5.$$typeof === REACT_FORWARD_REF_TYPE || type5.$$typeof === REACT_FUNDAMENTAL_TYPE || type5.$$typeof === REACT_RESPONDER_TYPE || type5.$$typeof === REACT_SCOPE_TYPE || type5.$$typeof === REACT_BLOCK_TYPE);
        }
        function memo14(type5, compare) {
          {
            if (!isValidElementType(type5)) {
              error2("memo: The first argument must be a component. Instead received: %s", type5 === null ? "null" : typeof type5);
            }
          }
          return {
            $$typeof: REACT_MEMO_TYPE,
            type: type5,
            compare: compare === void 0 ? null : compare
          };
        }
        function resolveDispatcher() {
          var dispatcher = ReactCurrentDispatcher.current;
          if (!(dispatcher !== null)) {
            {
              throw Error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://fb.me/react-invalid-hook-call for tips about how to debug and fix this problem.");
            }
          }
          return dispatcher;
        }
        function useContext197(Context4, unstable_observedBits) {
          var dispatcher = resolveDispatcher();
          {
            if (unstable_observedBits !== void 0) {
              error2("useContext() second argument is reserved for future use in React. Passing it is not supported. You passed: %s.%s", unstable_observedBits, typeof unstable_observedBits === "number" && Array.isArray(arguments[2]) ? "\n\nDid you call array.map(useContext)? Calling Hooks inside a loop is not supported. Learn more at https://fb.me/rules-of-hooks" : "");
            }
            if (Context4._context !== void 0) {
              var realContext = Context4._context;
              if (realContext.Consumer === Context4) {
                error2("Calling useContext(Context.Consumer) is not supported, may cause bugs, and will be removed in a future major release. Did you mean to call useContext(Context) instead?");
              } else if (realContext.Provider === Context4) {
                error2("Calling useContext(Context.Provider) is not supported. Did you mean to call useContext(Context) instead?");
              }
            }
          }
          return dispatcher.useContext(Context4, unstable_observedBits);
        }
        function useState135(initialState) {
          var dispatcher = resolveDispatcher();
          return dispatcher.useState(initialState);
        }
        function useReducer4(reducer2, initialArg, init2) {
          var dispatcher = resolveDispatcher();
          return dispatcher.useReducer(reducer2, initialArg, init2);
        }
        function useRef189(initialValue) {
          var dispatcher = resolveDispatcher();
          return dispatcher.useRef(initialValue);
        }
        function useEffect142(create, deps) {
          var dispatcher = resolveDispatcher();
          return dispatcher.useEffect(create, deps);
        }
        function useLayoutEffect10(create, deps) {
          var dispatcher = resolveDispatcher();
          return dispatcher.useLayoutEffect(create, deps);
        }
        function useCallback48(callback, deps) {
          var dispatcher = resolveDispatcher();
          return dispatcher.useCallback(callback, deps);
        }
        function useMemo166(create, deps) {
          var dispatcher = resolveDispatcher();
          return dispatcher.useMemo(create, deps);
        }
        function useImperativeHandle48(ref3, create, deps) {
          var dispatcher = resolveDispatcher();
          return dispatcher.useImperativeHandle(ref3, create, deps);
        }
        function useDebugValue3(value, formatterFn) {
          {
            var dispatcher = resolveDispatcher();
            return dispatcher.useDebugValue(value, formatterFn);
          }
        }
        var propTypesMisspellWarningShown;
        {
          propTypesMisspellWarningShown = false;
        }
        function getDeclarationErrorAddendum() {
          if (ReactCurrentOwner.current) {
            var name = getComponentName(ReactCurrentOwner.current.type);
            if (name) {
              return "\n\nCheck the render method of `" + name + "`.";
            }
          }
          return "";
        }
        function getSourceInfoErrorAddendum(source) {
          if (source !== void 0) {
            var fileName = source.fileName.replace(/^.*[\\\/]/, "");
            var lineNumber = source.lineNumber;
            return "\n\nCheck your code at " + fileName + ":" + lineNumber + ".";
          }
          return "";
        }
        function getSourceInfoErrorAddendumForProps(elementProps) {
          if (elementProps !== null && elementProps !== void 0) {
            return getSourceInfoErrorAddendum(elementProps.__source);
          }
          return "";
        }
        var ownerHasKeyUseWarning = {};
        function getCurrentComponentErrorInfo(parentType) {
          var info = getDeclarationErrorAddendum();
          if (!info) {
            var parentName = typeof parentType === "string" ? parentType : parentType.displayName || parentType.name;
            if (parentName) {
              info = "\n\nCheck the top-level render call using <" + parentName + ">.";
            }
          }
          return info;
        }
        function validateExplicitKey(element, parentType) {
          if (!element._store || element._store.validated || element.key != null) {
            return;
          }
          element._store.validated = true;
          var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
          if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
            return;
          }
          ownerHasKeyUseWarning[currentComponentErrorInfo] = true;
          var childOwner = "";
          if (element && element._owner && element._owner !== ReactCurrentOwner.current) {
            childOwner = " It was passed a child from " + getComponentName(element._owner.type) + ".";
          }
          setCurrentlyValidatingElement(element);
          {
            error2('Each child in a list should have a unique "key" prop.%s%s See https://fb.me/react-warning-keys for more information.', currentComponentErrorInfo, childOwner);
          }
          setCurrentlyValidatingElement(null);
        }
        function validateChildKeys(node2, parentType) {
          if (typeof node2 !== "object") {
            return;
          }
          if (Array.isArray(node2)) {
            for (var i = 0; i < node2.length; i++) {
              var child = node2[i];
              if (isValidElement31(child)) {
                validateExplicitKey(child, parentType);
              }
            }
          } else if (isValidElement31(node2)) {
            if (node2._store) {
              node2._store.validated = true;
            }
          } else if (node2) {
            var iteratorFn = getIteratorFn(node2);
            if (typeof iteratorFn === "function") {
              if (iteratorFn !== node2.entries) {
                var iterator = iteratorFn.call(node2);
                var step;
                while (!(step = iterator.next()).done) {
                  if (isValidElement31(step.value)) {
                    validateExplicitKey(step.value, parentType);
                  }
                }
              }
            }
          }
        }
        function validatePropTypes(element) {
          {
            var type5 = element.type;
            if (type5 === null || type5 === void 0 || typeof type5 === "string") {
              return;
            }
            var name = getComponentName(type5);
            var propTypes;
            if (typeof type5 === "function") {
              propTypes = type5.propTypes;
            } else if (typeof type5 === "object" && (type5.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
            // Inner props are checked in the reconciler.
            type5.$$typeof === REACT_MEMO_TYPE)) {
              propTypes = type5.propTypes;
            } else {
              return;
            }
            if (propTypes) {
              setCurrentlyValidatingElement(element);
              checkPropTypes(propTypes, element.props, "prop", name, ReactDebugCurrentFrame.getStackAddendum);
              setCurrentlyValidatingElement(null);
            } else if (type5.PropTypes !== void 0 && !propTypesMisspellWarningShown) {
              propTypesMisspellWarningShown = true;
              error2("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", name || "Unknown");
            }
            if (typeof type5.getDefaultProps === "function" && !type5.getDefaultProps.isReactClassApproved) {
              error2("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
            }
          }
        }
        function validateFragmentProps(fragment) {
          {
            setCurrentlyValidatingElement(fragment);
            var keys4 = Object.keys(fragment.props);
            for (var i = 0; i < keys4.length; i++) {
              var key2 = keys4[i];
              if (key2 !== "children" && key2 !== "key") {
                error2("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", key2);
                break;
              }
            }
            if (fragment.ref !== null) {
              error2("Invalid attribute `ref` supplied to `React.Fragment`.");
            }
            setCurrentlyValidatingElement(null);
          }
        }
        function createElementWithValidation(type5, props, children) {
          var validType = isValidElementType(type5);
          if (!validType) {
            var info = "";
            if (type5 === void 0 || typeof type5 === "object" && type5 !== null && Object.keys(type5).length === 0) {
              info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
            }
            var sourceInfo = getSourceInfoErrorAddendumForProps(props);
            if (sourceInfo) {
              info += sourceInfo;
            } else {
              info += getDeclarationErrorAddendum();
            }
            var typeString;
            if (type5 === null) {
              typeString = "null";
            } else if (Array.isArray(type5)) {
              typeString = "array";
            } else if (type5 !== void 0 && type5.$$typeof === REACT_ELEMENT_TYPE) {
              typeString = "<" + (getComponentName(type5.type) || "Unknown") + " />";
              info = " Did you accidentally export a JSX literal instead of a component?";
            } else {
              typeString = typeof type5;
            }
            {
              error2("React.createElement: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", typeString, info);
            }
          }
          var element = createElement330.apply(this, arguments);
          if (element == null) {
            return element;
          }
          if (validType) {
            for (var i = 2; i < arguments.length; i++) {
              validateChildKeys(arguments[i], type5);
            }
          }
          if (type5 === REACT_FRAGMENT_TYPE2) {
            validateFragmentProps(element);
          } else {
            validatePropTypes(element);
          }
          return element;
        }
        var didWarnAboutDeprecatedCreateFactory = false;
        function createFactoryWithValidation(type5) {
          var validatedFactory = createElementWithValidation.bind(null, type5);
          validatedFactory.type = type5;
          {
            if (!didWarnAboutDeprecatedCreateFactory) {
              didWarnAboutDeprecatedCreateFactory = true;
              warn("React.createFactory() is deprecated and will be removed in a future major release. Consider using JSX or use React.createElement() directly instead.");
            }
            Object.defineProperty(validatedFactory, "type", {
              enumerable: false,
              get: function() {
                warn("Factory.type is deprecated. Access the class directly before passing it to createFactory.");
                Object.defineProperty(this, "type", {
                  value: type5
                });
                return type5;
              }
            });
          }
          return validatedFactory;
        }
        function cloneElementWithValidation(element, props, children) {
          var newElement = cloneElement19.apply(this, arguments);
          for (var i = 2; i < arguments.length; i++) {
            validateChildKeys(arguments[i], newElement.type);
          }
          validatePropTypes(newElement);
          return newElement;
        }
        {
          try {
            var frozenObject = Object.freeze({});
            var testMap = /* @__PURE__ */ new Map([[frozenObject, null]]);
            var testSet = /* @__PURE__ */ new Set([frozenObject]);
            testMap.set(0, 0);
            testSet.add(0);
          } catch (e3) {
          }
        }
        var createElement$1 = createElementWithValidation;
        var cloneElement$1 = cloneElementWithValidation;
        var createFactory = createFactoryWithValidation;
        var Children8 = {
          map: mapChildren,
          forEach: forEachChildren,
          count: countChildren,
          toArray: toArray11,
          only: onlyChild
        };
        exports2.Children = Children8;
        exports2.Component = Component10;
        exports2.Fragment = REACT_FRAGMENT_TYPE2;
        exports2.Profiler = REACT_PROFILER_TYPE;
        exports2.PureComponent = PureComponent5;
        exports2.StrictMode = REACT_STRICT_MODE_TYPE;
        exports2.Suspense = REACT_SUSPENSE_TYPE;
        exports2.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ReactSharedInternals;
        exports2.cloneElement = cloneElement$1;
        exports2.createContext = createContext55;
        exports2.createElement = createElement$1;
        exports2.createFactory = createFactory;
        exports2.createRef = createRef4;
        exports2.forwardRef = forwardRef180;
        exports2.isValidElement = isValidElement31;
        exports2.lazy = lazy;
        exports2.memo = memo14;
        exports2.useCallback = useCallback48;
        exports2.useContext = useContext197;
        exports2.useDebugValue = useDebugValue3;
        exports2.useEffect = useEffect142;
        exports2.useImperativeHandle = useImperativeHandle48;
        exports2.useLayoutEffect = useLayoutEffect10;
        exports2.useMemo = useMemo166;
        exports2.useReducer = useReducer4;
        exports2.useRef = useRef189;
        exports2.useState = useState135;
        exports2.version = ReactVersion;
      })();
    }
  }
});

// ../../node_modules/react/index.js
var require_react = __commonJS({
  "../../node_modules/react/index.js"(exports2, module2) {
    "use strict";
    if (false) {
      module2.exports = null;
    } else {
      module2.exports = require_react_development();
    }
  }
});

// ../../node_modules/scheduler/cjs/scheduler.development.js
var require_scheduler_development = __commonJS({
  "../../node_modules/scheduler/cjs/scheduler.development.js"(exports2) {
    "use strict";
    if (true) {
      (function() {
        "use strict";
        var enableSchedulerDebugging = false;
        var enableProfiling = true;
        var requestHostCallback;
        var requestHostTimeout;
        var cancelHostTimeout;
        var shouldYieldToHost;
        var requestPaint;
        if (
          // If Scheduler runs in a non-DOM environment, it falls back to a naive
          // implementation using setTimeout.
          typeof window === "undefined" || // Check if MessageChannel is supported, too.
          typeof MessageChannel !== "function"
        ) {
          var _callback = null;
          var _timeoutID = null;
          var _flushCallback = function() {
            if (_callback !== null) {
              try {
                var currentTime = exports2.unstable_now();
                var hasRemainingTime = true;
                _callback(hasRemainingTime, currentTime);
                _callback = null;
              } catch (e3) {
                setTimeout(_flushCallback, 0);
                throw e3;
              }
            }
          };
          var initialTime = Date.now();
          exports2.unstable_now = function() {
            return Date.now() - initialTime;
          };
          requestHostCallback = function(cb) {
            if (_callback !== null) {
              setTimeout(requestHostCallback, 0, cb);
            } else {
              _callback = cb;
              setTimeout(_flushCallback, 0);
            }
          };
          requestHostTimeout = function(cb, ms) {
            _timeoutID = setTimeout(cb, ms);
          };
          cancelHostTimeout = function() {
            clearTimeout(_timeoutID);
          };
          shouldYieldToHost = function() {
            return false;
          };
          requestPaint = exports2.unstable_forceFrameRate = function() {
          };
        } else {
          var performance2 = window.performance;
          var _Date = window.Date;
          var _setTimeout = window.setTimeout;
          var _clearTimeout = window.clearTimeout;
          if (typeof console !== "undefined") {
            var requestAnimationFrame3 = window.requestAnimationFrame;
            var cancelAnimationFrame3 = window.cancelAnimationFrame;
            if (typeof requestAnimationFrame3 !== "function") {
              console["error"]("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
            }
            if (typeof cancelAnimationFrame3 !== "function") {
              console["error"]("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
            }
          }
          if (typeof performance2 === "object" && typeof performance2.now === "function") {
            exports2.unstable_now = function() {
              return performance2.now();
            };
          } else {
            var _initialTime = _Date.now();
            exports2.unstable_now = function() {
              return _Date.now() - _initialTime;
            };
          }
          var isMessageLoopRunning = false;
          var scheduledHostCallback = null;
          var taskTimeoutID = -1;
          var yieldInterval = 5;
          var deadline = 0;
          {
            shouldYieldToHost = function() {
              return exports2.unstable_now() >= deadline;
            };
            requestPaint = function() {
            };
          }
          exports2.unstable_forceFrameRate = function(fps) {
            if (fps < 0 || fps > 125) {
              console["error"]("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported");
              return;
            }
            if (fps > 0) {
              yieldInterval = Math.floor(1e3 / fps);
            } else {
              yieldInterval = 5;
            }
          };
          var performWorkUntilDeadline = function() {
            if (scheduledHostCallback !== null) {
              var currentTime = exports2.unstable_now();
              deadline = currentTime + yieldInterval;
              var hasTimeRemaining = true;
              try {
                var hasMoreWork = scheduledHostCallback(hasTimeRemaining, currentTime);
                if (!hasMoreWork) {
                  isMessageLoopRunning = false;
                  scheduledHostCallback = null;
                } else {
                  port.postMessage(null);
                }
              } catch (error2) {
                port.postMessage(null);
                throw error2;
              }
            } else {
              isMessageLoopRunning = false;
            }
          };
          var channel = new MessageChannel();
          var port = channel.port2;
          channel.port1.onmessage = performWorkUntilDeadline;
          requestHostCallback = function(callback) {
            scheduledHostCallback = callback;
            if (!isMessageLoopRunning) {
              isMessageLoopRunning = true;
              port.postMessage(null);
            }
          };
          requestHostTimeout = function(callback, ms) {
            taskTimeoutID = _setTimeout(function() {
              callback(exports2.unstable_now());
            }, ms);
          };
          cancelHostTimeout = function() {
            _clearTimeout(taskTimeoutID);
            taskTimeoutID = -1;
          };
        }
        function push(heap, node2) {
          var index3 = heap.length;
          heap.push(node2);
          siftUp(heap, node2, index3);
        }
        function peek2(heap) {
          var first = heap[0];
          return first === void 0 ? null : first;
        }
        function pop(heap) {
          var first = heap[0];
          if (first !== void 0) {
            var last2 = heap.pop();
            if (last2 !== first) {
              heap[0] = last2;
              siftDown(heap, last2, 0);
            }
            return first;
          } else {
            return null;
          }
        }
        function siftUp(heap, node2, i) {
          var index3 = i;
          while (true) {
            var parentIndex = index3 - 1 >>> 1;
            var parent2 = heap[parentIndex];
            if (parent2 !== void 0 && compare(parent2, node2) > 0) {
              heap[parentIndex] = node2;
              heap[index3] = parent2;
              index3 = parentIndex;
            } else {
              return;
            }
          }
        }
        function siftDown(heap, node2, i) {
          var index3 = i;
          var length2 = heap.length;
          while (index3 < length2) {
            var leftIndex = (index3 + 1) * 2 - 1;
            var left2 = heap[leftIndex];
            var rightIndex = leftIndex + 1;
            var right2 = heap[rightIndex];
            if (left2 !== void 0 && compare(left2, node2) < 0) {
              if (right2 !== void 0 && compare(right2, left2) < 0) {
                heap[index3] = right2;
                heap[rightIndex] = node2;
                index3 = rightIndex;
              } else {
                heap[index3] = left2;
                heap[leftIndex] = node2;
                index3 = leftIndex;
              }
            } else if (right2 !== void 0 && compare(right2, node2) < 0) {
              heap[index3] = right2;
              heap[rightIndex] = node2;
              index3 = rightIndex;
            } else {
              return;
            }
          }
        }
        function compare(a, b) {
          var diff3 = a.sortIndex - b.sortIndex;
          return diff3 !== 0 ? diff3 : a.id - b.id;
        }
        var NoPriority = 0;
        var ImmediatePriority = 1;
        var UserBlockingPriority = 2;
        var NormalPriority = 3;
        var LowPriority = 4;
        var IdlePriority = 5;
        var runIdCounter = 0;
        var mainThreadIdCounter = 0;
        var profilingStateSize = 4;
        var sharedProfilingBuffer = (
          // $FlowFixMe Flow doesn't know about SharedArrayBuffer
          typeof SharedArrayBuffer === "function" ? new SharedArrayBuffer(profilingStateSize * Int32Array.BYTES_PER_ELEMENT) : (
            // $FlowFixMe Flow doesn't know about ArrayBuffer
            typeof ArrayBuffer === "function" ? new ArrayBuffer(profilingStateSize * Int32Array.BYTES_PER_ELEMENT) : null
          )
        );
        var profilingState = sharedProfilingBuffer !== null ? new Int32Array(sharedProfilingBuffer) : [];
        var PRIORITY = 0;
        var CURRENT_TASK_ID = 1;
        var CURRENT_RUN_ID = 2;
        var QUEUE_SIZE = 3;
        {
          profilingState[PRIORITY] = NoPriority;
          profilingState[QUEUE_SIZE] = 0;
          profilingState[CURRENT_TASK_ID] = 0;
        }
        var INITIAL_EVENT_LOG_SIZE = 131072;
        var MAX_EVENT_LOG_SIZE = 524288;
        var eventLogSize = 0;
        var eventLogBuffer = null;
        var eventLog = null;
        var eventLogIndex = 0;
        var TaskStartEvent = 1;
        var TaskCompleteEvent = 2;
        var TaskErrorEvent = 3;
        var TaskCancelEvent = 4;
        var TaskRunEvent = 5;
        var TaskYieldEvent = 6;
        var SchedulerSuspendEvent = 7;
        var SchedulerResumeEvent = 8;
        function logEvent(entries) {
          if (eventLog !== null) {
            var offset4 = eventLogIndex;
            eventLogIndex += entries.length;
            if (eventLogIndex + 1 > eventLogSize) {
              eventLogSize *= 2;
              if (eventLogSize > MAX_EVENT_LOG_SIZE) {
                console["error"]("Scheduler Profiling: Event log exceeded maximum size. Don't forget to call `stopLoggingProfilingEvents()`.");
                stopLoggingProfilingEvents();
                return;
              }
              var newEventLog = new Int32Array(eventLogSize * 4);
              newEventLog.set(eventLog);
              eventLogBuffer = newEventLog.buffer;
              eventLog = newEventLog;
            }
            eventLog.set(entries, offset4);
          }
        }
        function startLoggingProfilingEvents() {
          eventLogSize = INITIAL_EVENT_LOG_SIZE;
          eventLogBuffer = new ArrayBuffer(eventLogSize * 4);
          eventLog = new Int32Array(eventLogBuffer);
          eventLogIndex = 0;
        }
        function stopLoggingProfilingEvents() {
          var buffer = eventLogBuffer;
          eventLogSize = 0;
          eventLogBuffer = null;
          eventLog = null;
          eventLogIndex = 0;
          return buffer;
        }
        function markTaskStart(task, ms) {
          {
            profilingState[QUEUE_SIZE]++;
            if (eventLog !== null) {
              logEvent([TaskStartEvent, ms * 1e3, task.id, task.priorityLevel]);
            }
          }
        }
        function markTaskCompleted(task, ms) {
          {
            profilingState[PRIORITY] = NoPriority;
            profilingState[CURRENT_TASK_ID] = 0;
            profilingState[QUEUE_SIZE]--;
            if (eventLog !== null) {
              logEvent([TaskCompleteEvent, ms * 1e3, task.id]);
            }
          }
        }
        function markTaskCanceled(task, ms) {
          {
            profilingState[QUEUE_SIZE]--;
            if (eventLog !== null) {
              logEvent([TaskCancelEvent, ms * 1e3, task.id]);
            }
          }
        }
        function markTaskErrored(task, ms) {
          {
            profilingState[PRIORITY] = NoPriority;
            profilingState[CURRENT_TASK_ID] = 0;
            profilingState[QUEUE_SIZE]--;
            if (eventLog !== null) {
              logEvent([TaskErrorEvent, ms * 1e3, task.id]);
            }
          }
        }
        function markTaskRun(task, ms) {
          {
            runIdCounter++;
            profilingState[PRIORITY] = task.priorityLevel;
            profilingState[CURRENT_TASK_ID] = task.id;
            profilingState[CURRENT_RUN_ID] = runIdCounter;
            if (eventLog !== null) {
              logEvent([TaskRunEvent, ms * 1e3, task.id, runIdCounter]);
            }
          }
        }
        function markTaskYield(task, ms) {
          {
            profilingState[PRIORITY] = NoPriority;
            profilingState[CURRENT_TASK_ID] = 0;
            profilingState[CURRENT_RUN_ID] = 0;
            if (eventLog !== null) {
              logEvent([TaskYieldEvent, ms * 1e3, task.id, runIdCounter]);
            }
          }
        }
        function markSchedulerSuspended(ms) {
          {
            mainThreadIdCounter++;
            if (eventLog !== null) {
              logEvent([SchedulerSuspendEvent, ms * 1e3, mainThreadIdCounter]);
            }
          }
        }
        function markSchedulerUnsuspended(ms) {
          {
            if (eventLog !== null) {
              logEvent([SchedulerResumeEvent, ms * 1e3, mainThreadIdCounter]);
            }
          }
        }
        var maxSigned31BitInt = 1073741823;
        var IMMEDIATE_PRIORITY_TIMEOUT = -1;
        var USER_BLOCKING_PRIORITY = 250;
        var NORMAL_PRIORITY_TIMEOUT = 5e3;
        var LOW_PRIORITY_TIMEOUT = 1e4;
        var IDLE_PRIORITY = maxSigned31BitInt;
        var taskQueue2 = [];
        var timerQueue = [];
        var taskIdCounter = 1;
        var currentTask = null;
        var currentPriorityLevel = NormalPriority;
        var isPerformingWork = false;
        var isHostCallbackScheduled = false;
        var isHostTimeoutScheduled = false;
        function advanceTimers(currentTime) {
          var timer = peek2(timerQueue);
          while (timer !== null) {
            if (timer.callback === null) {
              pop(timerQueue);
            } else if (timer.startTime <= currentTime) {
              pop(timerQueue);
              timer.sortIndex = timer.expirationTime;
              push(taskQueue2, timer);
              {
                markTaskStart(timer, currentTime);
                timer.isQueued = true;
              }
            } else {
              return;
            }
            timer = peek2(timerQueue);
          }
        }
        function handleTimeout(currentTime) {
          isHostTimeoutScheduled = false;
          advanceTimers(currentTime);
          if (!isHostCallbackScheduled) {
            if (peek2(taskQueue2) !== null) {
              isHostCallbackScheduled = true;
              requestHostCallback(flushWork);
            } else {
              var firstTimer = peek2(timerQueue);
              if (firstTimer !== null) {
                requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
              }
            }
          }
        }
        function flushWork(hasTimeRemaining, initialTime2) {
          {
            markSchedulerUnsuspended(initialTime2);
          }
          isHostCallbackScheduled = false;
          if (isHostTimeoutScheduled) {
            isHostTimeoutScheduled = false;
            cancelHostTimeout();
          }
          isPerformingWork = true;
          var previousPriorityLevel = currentPriorityLevel;
          try {
            if (enableProfiling) {
              try {
                return workLoop(hasTimeRemaining, initialTime2);
              } catch (error2) {
                if (currentTask !== null) {
                  var currentTime = exports2.unstable_now();
                  markTaskErrored(currentTask, currentTime);
                  currentTask.isQueued = false;
                }
                throw error2;
              }
            } else {
              return workLoop(hasTimeRemaining, initialTime2);
            }
          } finally {
            currentTask = null;
            currentPriorityLevel = previousPriorityLevel;
            isPerformingWork = false;
            {
              var _currentTime = exports2.unstable_now();
              markSchedulerSuspended(_currentTime);
            }
          }
        }
        function workLoop(hasTimeRemaining, initialTime2) {
          var currentTime = initialTime2;
          advanceTimers(currentTime);
          currentTask = peek2(taskQueue2);
          while (currentTask !== null && !enableSchedulerDebugging) {
            if (currentTask.expirationTime > currentTime && (!hasTimeRemaining || shouldYieldToHost())) {
              break;
            }
            var callback = currentTask.callback;
            if (callback !== null) {
              currentTask.callback = null;
              currentPriorityLevel = currentTask.priorityLevel;
              var didUserCallbackTimeout = currentTask.expirationTime <= currentTime;
              markTaskRun(currentTask, currentTime);
              var continuationCallback = callback(didUserCallbackTimeout);
              currentTime = exports2.unstable_now();
              if (typeof continuationCallback === "function") {
                currentTask.callback = continuationCallback;
                markTaskYield(currentTask, currentTime);
              } else {
                {
                  markTaskCompleted(currentTask, currentTime);
                  currentTask.isQueued = false;
                }
                if (currentTask === peek2(taskQueue2)) {
                  pop(taskQueue2);
                }
              }
              advanceTimers(currentTime);
            } else {
              pop(taskQueue2);
            }
            currentTask = peek2(taskQueue2);
          }
          if (currentTask !== null) {
            return true;
          } else {
            var firstTimer = peek2(timerQueue);
            if (firstTimer !== null) {
              requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
            }
            return false;
          }
        }
        function unstable_runWithPriority(priorityLevel, eventHandler2) {
          switch (priorityLevel) {
            case ImmediatePriority:
            case UserBlockingPriority:
            case NormalPriority:
            case LowPriority:
            case IdlePriority:
              break;
            default:
              priorityLevel = NormalPriority;
          }
          var previousPriorityLevel = currentPriorityLevel;
          currentPriorityLevel = priorityLevel;
          try {
            return eventHandler2();
          } finally {
            currentPriorityLevel = previousPriorityLevel;
          }
        }
        function unstable_next(eventHandler2) {
          var priorityLevel;
          switch (currentPriorityLevel) {
            case ImmediatePriority:
            case UserBlockingPriority:
            case NormalPriority:
              priorityLevel = NormalPriority;
              break;
            default:
              priorityLevel = currentPriorityLevel;
              break;
          }
          var previousPriorityLevel = currentPriorityLevel;
          currentPriorityLevel = priorityLevel;
          try {
            return eventHandler2();
          } finally {
            currentPriorityLevel = previousPriorityLevel;
          }
        }
        function unstable_wrapCallback(callback) {
          var parentPriorityLevel = currentPriorityLevel;
          return function() {
            var previousPriorityLevel = currentPriorityLevel;
            currentPriorityLevel = parentPriorityLevel;
            try {
              return callback.apply(this, arguments);
            } finally {
              currentPriorityLevel = previousPriorityLevel;
            }
          };
        }
        function timeoutForPriorityLevel(priorityLevel) {
          switch (priorityLevel) {
            case ImmediatePriority:
              return IMMEDIATE_PRIORITY_TIMEOUT;
            case UserBlockingPriority:
              return USER_BLOCKING_PRIORITY;
            case IdlePriority:
              return IDLE_PRIORITY;
            case LowPriority:
              return LOW_PRIORITY_TIMEOUT;
            case NormalPriority:
            default:
              return NORMAL_PRIORITY_TIMEOUT;
          }
        }
        function unstable_scheduleCallback(priorityLevel, callback, options) {
          var currentTime = exports2.unstable_now();
          var startTime;
          var timeout;
          if (typeof options === "object" && options !== null) {
            var delay = options.delay;
            if (typeof delay === "number" && delay > 0) {
              startTime = currentTime + delay;
            } else {
              startTime = currentTime;
            }
            timeout = typeof options.timeout === "number" ? options.timeout : timeoutForPriorityLevel(priorityLevel);
          } else {
            timeout = timeoutForPriorityLevel(priorityLevel);
            startTime = currentTime;
          }
          var expirationTime = startTime + timeout;
          var newTask = {
            id: taskIdCounter++,
            callback,
            priorityLevel,
            startTime,
            expirationTime,
            sortIndex: -1
          };
          {
            newTask.isQueued = false;
          }
          if (startTime > currentTime) {
            newTask.sortIndex = startTime;
            push(timerQueue, newTask);
            if (peek2(taskQueue2) === null && newTask === peek2(timerQueue)) {
              if (isHostTimeoutScheduled) {
                cancelHostTimeout();
              } else {
                isHostTimeoutScheduled = true;
              }
              requestHostTimeout(handleTimeout, startTime - currentTime);
            }
          } else {
            newTask.sortIndex = expirationTime;
            push(taskQueue2, newTask);
            {
              markTaskStart(newTask, currentTime);
              newTask.isQueued = true;
            }
            if (!isHostCallbackScheduled && !isPerformingWork) {
              isHostCallbackScheduled = true;
              requestHostCallback(flushWork);
            }
          }
          return newTask;
        }
        function unstable_pauseExecution() {
        }
        function unstable_continueExecution() {
          if (!isHostCallbackScheduled && !isPerformingWork) {
            isHostCallbackScheduled = true;
            requestHostCallback(flushWork);
          }
        }
        function unstable_getFirstCallbackNode() {
          return peek2(taskQueue2);
        }
        function unstable_cancelCallback(task) {
          {
            if (task.isQueued) {
              var currentTime = exports2.unstable_now();
              markTaskCanceled(task, currentTime);
              task.isQueued = false;
            }
          }
          task.callback = null;
        }
        function unstable_getCurrentPriorityLevel() {
          return currentPriorityLevel;
        }
        function unstable_shouldYield() {
          var currentTime = exports2.unstable_now();
          advanceTimers(currentTime);
          var firstTask = peek2(taskQueue2);
          return firstTask !== currentTask && currentTask !== null && firstTask !== null && firstTask.callback !== null && firstTask.startTime <= currentTime && firstTask.expirationTime < currentTask.expirationTime || shouldYieldToHost();
        }
        var unstable_requestPaint = requestPaint;
        var unstable_Profiling = {
          startLoggingProfilingEvents,
          stopLoggingProfilingEvents,
          sharedProfilingBuffer
        };
        exports2.unstable_IdlePriority = IdlePriority;
        exports2.unstable_ImmediatePriority = ImmediatePriority;
        exports2.unstable_LowPriority = LowPriority;
        exports2.unstable_NormalPriority = NormalPriority;
        exports2.unstable_Profiling = unstable_Profiling;
        exports2.unstable_UserBlockingPriority = UserBlockingPriority;
        exports2.unstable_cancelCallback = unstable_cancelCallback;
        exports2.unstable_continueExecution = unstable_continueExecution;
        exports2.unstable_getCurrentPriorityLevel = unstable_getCurrentPriorityLevel;
        exports2.unstable_getFirstCallbackNode = unstable_getFirstCallbackNode;
        exports2.unstable_next = unstable_next;
        exports2.unstable_pauseExecution = unstable_pauseExecution;
        exports2.unstable_requestPaint = unstable_requestPaint;
        exports2.unstable_runWithPriority = unstable_runWithPriority;
        exports2.unstable_scheduleCallback = unstable_scheduleCallback;
        exports2.unstable_shouldYield = unstable_shouldYield;
        exports2.unstable_wrapCallback = unstable_wrapCallback;
      })();
    }
  }
});

// ../../node_modules/scheduler/index.js
var require_scheduler = __commonJS({
  "../../node_modules/scheduler/index.js"(exports2, module2) {
    "use strict";
    if (false) {
      module2.exports = null;
    } else {
      module2.exports = require_scheduler_development();
    }
  }
});

// ../../node_modules/scheduler/cjs/scheduler-tracing.development.js
var require_scheduler_tracing_development = __commonJS({
  "../../node_modules/scheduler/cjs/scheduler-tracing.development.js"(exports2) {
    "use strict";
    if (true) {
      (function() {
        "use strict";
        var DEFAULT_THREAD_ID = 0;
        var interactionIDCounter = 0;
        var threadIDCounter = 0;
        exports2.__interactionsRef = null;
        exports2.__subscriberRef = null;
        {
          exports2.__interactionsRef = {
            current: /* @__PURE__ */ new Set()
          };
          exports2.__subscriberRef = {
            current: null
          };
        }
        function unstable_clear(callback) {
          var prevInteractions = exports2.__interactionsRef.current;
          exports2.__interactionsRef.current = /* @__PURE__ */ new Set();
          try {
            return callback();
          } finally {
            exports2.__interactionsRef.current = prevInteractions;
          }
        }
        function unstable_getCurrent() {
          {
            return exports2.__interactionsRef.current;
          }
        }
        function unstable_getThreadID() {
          return ++threadIDCounter;
        }
        function unstable_trace(name, timestamp, callback) {
          var threadID = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : DEFAULT_THREAD_ID;
          var interaction = {
            __count: 1,
            id: interactionIDCounter++,
            name,
            timestamp
          };
          var prevInteractions = exports2.__interactionsRef.current;
          var interactions = new Set(prevInteractions);
          interactions.add(interaction);
          exports2.__interactionsRef.current = interactions;
          var subscriber = exports2.__subscriberRef.current;
          var returnValue;
          try {
            if (subscriber !== null) {
              subscriber.onInteractionTraced(interaction);
            }
          } finally {
            try {
              if (subscriber !== null) {
                subscriber.onWorkStarted(interactions, threadID);
              }
            } finally {
              try {
                returnValue = callback();
              } finally {
                exports2.__interactionsRef.current = prevInteractions;
                try {
                  if (subscriber !== null) {
                    subscriber.onWorkStopped(interactions, threadID);
                  }
                } finally {
                  interaction.__count--;
                  if (subscriber !== null && interaction.__count === 0) {
                    subscriber.onInteractionScheduledWorkCompleted(interaction);
                  }
                }
              }
            }
          }
          return returnValue;
        }
        function unstable_wrap(callback) {
          var threadID = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : DEFAULT_THREAD_ID;
          var wrappedInteractions = exports2.__interactionsRef.current;
          var subscriber = exports2.__subscriberRef.current;
          if (subscriber !== null) {
            subscriber.onWorkScheduled(wrappedInteractions, threadID);
          }
          wrappedInteractions.forEach(function(interaction) {
            interaction.__count++;
          });
          var hasRun = false;
          function wrapped() {
            var prevInteractions = exports2.__interactionsRef.current;
            exports2.__interactionsRef.current = wrappedInteractions;
            subscriber = exports2.__subscriberRef.current;
            try {
              var returnValue;
              try {
                if (subscriber !== null) {
                  subscriber.onWorkStarted(wrappedInteractions, threadID);
                }
              } finally {
                try {
                  returnValue = callback.apply(void 0, arguments);
                } finally {
                  exports2.__interactionsRef.current = prevInteractions;
                  if (subscriber !== null) {
                    subscriber.onWorkStopped(wrappedInteractions, threadID);
                  }
                }
              }
              return returnValue;
            } finally {
              if (!hasRun) {
                hasRun = true;
                wrappedInteractions.forEach(function(interaction) {
                  interaction.__count--;
                  if (subscriber !== null && interaction.__count === 0) {
                    subscriber.onInteractionScheduledWorkCompleted(interaction);
                  }
                });
              }
            }
          }
          wrapped.cancel = function cancel() {
            subscriber = exports2.__subscriberRef.current;
            try {
              if (subscriber !== null) {
                subscriber.onWorkCanceled(wrappedInteractions, threadID);
              }
            } finally {
              wrappedInteractions.forEach(function(interaction) {
                interaction.__count--;
                if (subscriber && interaction.__count === 0) {
                  subscriber.onInteractionScheduledWorkCompleted(interaction);
                }
              });
            }
          };
          return wrapped;
        }
        var subscribers = null;
        {
          subscribers = /* @__PURE__ */ new Set();
        }
        function unstable_subscribe(subscriber) {
          {
            subscribers.add(subscriber);
            if (subscribers.size === 1) {
              exports2.__subscriberRef.current = {
                onInteractionScheduledWorkCompleted,
                onInteractionTraced,
                onWorkCanceled,
                onWorkScheduled,
                onWorkStarted,
                onWorkStopped
              };
            }
          }
        }
        function unstable_unsubscribe(subscriber) {
          {
            subscribers.delete(subscriber);
            if (subscribers.size === 0) {
              exports2.__subscriberRef.current = null;
            }
          }
        }
        function onInteractionTraced(interaction) {
          var didCatchError = false;
          var caughtError = null;
          subscribers.forEach(function(subscriber) {
            try {
              subscriber.onInteractionTraced(interaction);
            } catch (error2) {
              if (!didCatchError) {
                didCatchError = true;
                caughtError = error2;
              }
            }
          });
          if (didCatchError) {
            throw caughtError;
          }
        }
        function onInteractionScheduledWorkCompleted(interaction) {
          var didCatchError = false;
          var caughtError = null;
          subscribers.forEach(function(subscriber) {
            try {
              subscriber.onInteractionScheduledWorkCompleted(interaction);
            } catch (error2) {
              if (!didCatchError) {
                didCatchError = true;
                caughtError = error2;
              }
            }
          });
          if (didCatchError) {
            throw caughtError;
          }
        }
        function onWorkScheduled(interactions, threadID) {
          var didCatchError = false;
          var caughtError = null;
          subscribers.forEach(function(subscriber) {
            try {
              subscriber.onWorkScheduled(interactions, threadID);
            } catch (error2) {
              if (!didCatchError) {
                didCatchError = true;
                caughtError = error2;
              }
            }
          });
          if (didCatchError) {
            throw caughtError;
          }
        }
        function onWorkStarted(interactions, threadID) {
          var didCatchError = false;
          var caughtError = null;
          subscribers.forEach(function(subscriber) {
            try {
              subscriber.onWorkStarted(interactions, threadID);
            } catch (error2) {
              if (!didCatchError) {
                didCatchError = true;
                caughtError = error2;
              }
            }
          });
          if (didCatchError) {
            throw caughtError;
          }
        }
        function onWorkStopped(interactions, threadID) {
          var didCatchError = false;
          var caughtError = null;
          subscribers.forEach(function(subscriber) {
            try {
              subscriber.onWorkStopped(interactions, threadID);
            } catch (error2) {
              if (!didCatchError) {
                didCatchError = true;
                caughtError = error2;
              }
            }
          });
          if (didCatchError) {
            throw caughtError;
          }
        }
        function onWorkCanceled(interactions, threadID) {
          var didCatchError = false;
          var caughtError = null;
          subscribers.forEach(function(subscriber) {
            try {
              subscriber.onWorkCanceled(interactions, threadID);
            } catch (error2) {
              if (!didCatchError) {
                didCatchError = true;
                caughtError = error2;
              }
            }
          });
          if (didCatchError) {
            throw caughtError;
          }
        }
        exports2.unstable_clear = unstable_clear;
        exports2.unstable_getCurrent = unstable_getCurrent;
        exports2.unstable_getThreadID = unstable_getThreadID;
        exports2.unstable_subscribe = unstable_subscribe;
        exports2.unstable_trace = unstable_trace;
        exports2.unstable_unsubscribe = unstable_unsubscribe;
        exports2.unstable_wrap = unstable_wrap;
      })();
    }
  }
});

// ../../node_modules/scheduler/tracing.js
var require_tracing = __commonJS({
  "../../node_modules/scheduler/tracing.js"(exports2, module2) {
    "use strict";
    if (false) {
      module2.exports = null;
    } else {
      module2.exports = require_scheduler_tracing_development();
    }
  }
});

// ../../node_modules/react-dom/cjs/react-dom.development.js
var require_react_dom_development = __commonJS({
  "../../node_modules/react-dom/cjs/react-dom.development.js"(exports2) {
    "use strict";
    if (true) {
      (function() {
        "use strict";
        var React615 = require_react();
        var _assign = require_object_assign();
        var Scheduler = require_scheduler();
        var checkPropTypes = require_checkPropTypes();
        var tracing = require_tracing();
        var ReactSharedInternals = React615.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
        if (!ReactSharedInternals.hasOwnProperty("ReactCurrentDispatcher")) {
          ReactSharedInternals.ReactCurrentDispatcher = {
            current: null
          };
        }
        if (!ReactSharedInternals.hasOwnProperty("ReactCurrentBatchConfig")) {
          ReactSharedInternals.ReactCurrentBatchConfig = {
            suspense: null
          };
        }
        function warn(format3) {
          {
            for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
              args[_key - 1] = arguments[_key];
            }
            printWarning("warn", format3, args);
          }
        }
        function error2(format3) {
          {
            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }
            printWarning("error", format3, args);
          }
        }
        function printWarning(level, format3, args) {
          {
            var hasExistingStack = args.length > 0 && typeof args[args.length - 1] === "string" && args[args.length - 1].indexOf("\n    in") === 0;
            if (!hasExistingStack) {
              var ReactDebugCurrentFrame2 = ReactSharedInternals.ReactDebugCurrentFrame;
              var stack = ReactDebugCurrentFrame2.getStackAddendum();
              if (stack !== "") {
                format3 += "%s";
                args = args.concat([stack]);
              }
            }
            var argsWithFormat = args.map(function(item) {
              return "" + item;
            });
            argsWithFormat.unshift("Warning: " + format3);
            Function.prototype.apply.call(console[level], console, argsWithFormat);
            try {
              var argIndex = 0;
              var message2 = "Warning: " + format3.replace(/%s/g, function() {
                return args[argIndex++];
              });
              throw new Error(message2);
            } catch (x) {
            }
          }
        }
        if (!React615) {
          {
            throw Error("ReactDOM was loaded before React. Make sure you load the React package before loading ReactDOM.");
          }
        }
        var invokeGuardedCallbackImpl = function(name, func, context, a, b, c, d, e3, f) {
          var funcArgs = Array.prototype.slice.call(arguments, 3);
          try {
            func.apply(context, funcArgs);
          } catch (error3) {
            this.onError(error3);
          }
        };
        {
          if (typeof window !== "undefined" && typeof window.dispatchEvent === "function" && typeof document !== "undefined" && typeof document.createEvent === "function") {
            var fakeNode = document.createElement("react");
            var invokeGuardedCallbackDev = function(name, func, context, a, b, c, d, e3, f) {
              if (!(typeof document !== "undefined")) {
                {
                  throw Error("The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.");
                }
              }
              var evt = document.createEvent("Event");
              var didError = true;
              var windowEvent = window.event;
              var windowEventDescriptor = Object.getOwnPropertyDescriptor(window, "event");
              var funcArgs = Array.prototype.slice.call(arguments, 3);
              function callCallback2() {
                fakeNode.removeEventListener(evtType, callCallback2, false);
                if (typeof window.event !== "undefined" && window.hasOwnProperty("event")) {
                  window.event = windowEvent;
                }
                func.apply(context, funcArgs);
                didError = false;
              }
              var error3;
              var didSetError = false;
              var isCrossOriginError = false;
              function handleWindowError(event) {
                error3 = event.error;
                didSetError = true;
                if (error3 === null && event.colno === 0 && event.lineno === 0) {
                  isCrossOriginError = true;
                }
                if (event.defaultPrevented) {
                  if (error3 != null && typeof error3 === "object") {
                    try {
                      error3._suppressLogging = true;
                    } catch (inner) {
                    }
                  }
                }
              }
              var evtType = "react-" + (name ? name : "invokeguardedcallback");
              window.addEventListener("error", handleWindowError);
              fakeNode.addEventListener(evtType, callCallback2, false);
              evt.initEvent(evtType, false, false);
              fakeNode.dispatchEvent(evt);
              if (windowEventDescriptor) {
                Object.defineProperty(window, "event", windowEventDescriptor);
              }
              if (didError) {
                if (!didSetError) {
                  error3 = new Error(`An error was thrown inside one of your components, but React doesn't know what it was. This is likely due to browser flakiness. React does its best to preserve the "Pause on exceptions" behavior of the DevTools, which requires some DEV-mode only tricks. It's possible that these don't work in your browser. Try triggering the error in production mode, or switching to a modern browser. If you suspect that this is actually an issue with React, please file an issue.`);
                } else if (isCrossOriginError) {
                  error3 = new Error("A cross-origin error was thrown. React doesn't have access to the actual error object in development. See https://fb.me/react-crossorigin-error for more information.");
                }
                this.onError(error3);
              }
              window.removeEventListener("error", handleWindowError);
            };
            invokeGuardedCallbackImpl = invokeGuardedCallbackDev;
          }
        }
        var invokeGuardedCallbackImpl$1 = invokeGuardedCallbackImpl;
        var hasError = false;
        var caughtError = null;
        var hasRethrowError = false;
        var rethrowError = null;
        var reporter = {
          onError: function(error3) {
            hasError = true;
            caughtError = error3;
          }
        };
        function invokeGuardedCallback(name, func, context, a, b, c, d, e3, f) {
          hasError = false;
          caughtError = null;
          invokeGuardedCallbackImpl$1.apply(reporter, arguments);
        }
        function invokeGuardedCallbackAndCatchFirstError(name, func, context, a, b, c, d, e3, f) {
          invokeGuardedCallback.apply(this, arguments);
          if (hasError) {
            var error3 = clearCaughtError();
            if (!hasRethrowError) {
              hasRethrowError = true;
              rethrowError = error3;
            }
          }
        }
        function rethrowCaughtError() {
          if (hasRethrowError) {
            var error3 = rethrowError;
            hasRethrowError = false;
            rethrowError = null;
            throw error3;
          }
        }
        function hasCaughtError() {
          return hasError;
        }
        function clearCaughtError() {
          if (hasError) {
            var error3 = caughtError;
            hasError = false;
            caughtError = null;
            return error3;
          } else {
            {
              {
                throw Error("clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.");
              }
            }
          }
        }
        var getFiberCurrentPropsFromNode = null;
        var getInstanceFromNode = null;
        var getNodeFromInstance = null;
        function setComponentTree(getFiberCurrentPropsFromNodeImpl, getInstanceFromNodeImpl, getNodeFromInstanceImpl) {
          getFiberCurrentPropsFromNode = getFiberCurrentPropsFromNodeImpl;
          getInstanceFromNode = getInstanceFromNodeImpl;
          getNodeFromInstance = getNodeFromInstanceImpl;
          {
            if (!getNodeFromInstance || !getInstanceFromNode) {
              error2("EventPluginUtils.setComponentTree(...): Injected module is missing getNodeFromInstance or getInstanceFromNode.");
            }
          }
        }
        var validateEventDispatches;
        {
          validateEventDispatches = function(event) {
            var dispatchListeners = event._dispatchListeners;
            var dispatchInstances = event._dispatchInstances;
            var listenersIsArr = Array.isArray(dispatchListeners);
            var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
            var instancesIsArr = Array.isArray(dispatchInstances);
            var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
            if (instancesIsArr !== listenersIsArr || instancesLen !== listenersLen) {
              error2("EventPluginUtils: Invalid `event`.");
            }
          };
        }
        function executeDispatch(event, listener, inst) {
          var type5 = event.type || "unknown-event";
          event.currentTarget = getNodeFromInstance(inst);
          invokeGuardedCallbackAndCatchFirstError(type5, listener, void 0, event);
          event.currentTarget = null;
        }
        function executeDispatchesInOrder(event) {
          var dispatchListeners = event._dispatchListeners;
          var dispatchInstances = event._dispatchInstances;
          {
            validateEventDispatches(event);
          }
          if (Array.isArray(dispatchListeners)) {
            for (var i = 0; i < dispatchListeners.length; i++) {
              if (event.isPropagationStopped()) {
                break;
              }
              executeDispatch(event, dispatchListeners[i], dispatchInstances[i]);
            }
          } else if (dispatchListeners) {
            executeDispatch(event, dispatchListeners, dispatchInstances);
          }
          event._dispatchListeners = null;
          event._dispatchInstances = null;
        }
        var FunctionComponent = 0;
        var ClassComponent = 1;
        var IndeterminateComponent = 2;
        var HostRoot = 3;
        var HostPortal = 4;
        var HostComponent = 5;
        var HostText = 6;
        var Fragment35 = 7;
        var Mode3 = 8;
        var ContextConsumer = 9;
        var ContextProvider = 10;
        var ForwardRef2 = 11;
        var Profiler = 12;
        var SuspenseComponent = 13;
        var MemoComponent = 14;
        var SimpleMemoComponent = 15;
        var LazyComponent = 16;
        var IncompleteClassComponent = 17;
        var DehydratedFragment = 18;
        var SuspenseListComponent = 19;
        var FundamentalComponent = 20;
        var ScopeComponent = 21;
        var Block3 = 22;
        var eventPluginOrder = null;
        var namesToPlugins = {};
        function recomputePluginOrdering() {
          if (!eventPluginOrder) {
            return;
          }
          for (var pluginName in namesToPlugins) {
            var pluginModule = namesToPlugins[pluginName];
            var pluginIndex = eventPluginOrder.indexOf(pluginName);
            if (!(pluginIndex > -1)) {
              {
                throw Error("EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `" + pluginName + "`.");
              }
            }
            if (plugins[pluginIndex]) {
              continue;
            }
            if (!pluginModule.extractEvents) {
              {
                throw Error("EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `" + pluginName + "` does not.");
              }
            }
            plugins[pluginIndex] = pluginModule;
            var publishedEvents = pluginModule.eventTypes;
            for (var eventName in publishedEvents) {
              if (!publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName)) {
                {
                  throw Error("EventPluginRegistry: Failed to publish event `" + eventName + "` for plugin `" + pluginName + "`.");
                }
              }
            }
          }
        }
        function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
          if (!!eventNameDispatchConfigs.hasOwnProperty(eventName)) {
            {
              throw Error("EventPluginRegistry: More than one plugin attempted to publish the same event name, `" + eventName + "`.");
            }
          }
          eventNameDispatchConfigs[eventName] = dispatchConfig;
          var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
          if (phasedRegistrationNames) {
            for (var phaseName in phasedRegistrationNames) {
              if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
                var phasedRegistrationName = phasedRegistrationNames[phaseName];
                publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
              }
            }
            return true;
          } else if (dispatchConfig.registrationName) {
            publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
            return true;
          }
          return false;
        }
        function publishRegistrationName(registrationName, pluginModule, eventName) {
          if (!!registrationNameModules[registrationName]) {
            {
              throw Error("EventPluginRegistry: More than one plugin attempted to publish the same registration name, `" + registrationName + "`.");
            }
          }
          registrationNameModules[registrationName] = pluginModule;
          registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
          {
            var lowerCasedName = registrationName.toLowerCase();
            possibleRegistrationNames[lowerCasedName] = registrationName;
            if (registrationName === "onDoubleClick") {
              possibleRegistrationNames.ondblclick = registrationName;
            }
          }
        }
        var plugins = [];
        var eventNameDispatchConfigs = {};
        var registrationNameModules = {};
        var registrationNameDependencies = {};
        var possibleRegistrationNames = {};
        function injectEventPluginOrder(injectedEventPluginOrder) {
          if (!!eventPluginOrder) {
            {
              throw Error("EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.");
            }
          }
          eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
          recomputePluginOrdering();
        }
        function injectEventPluginsByName(injectedNamesToPlugins) {
          var isOrderingDirty = false;
          for (var pluginName in injectedNamesToPlugins) {
            if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
              continue;
            }
            var pluginModule = injectedNamesToPlugins[pluginName];
            if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
              if (!!namesToPlugins[pluginName]) {
                {
                  throw Error("EventPluginRegistry: Cannot inject two different event plugins using the same name, `" + pluginName + "`.");
                }
              }
              namesToPlugins[pluginName] = pluginModule;
              isOrderingDirty = true;
            }
          }
          if (isOrderingDirty) {
            recomputePluginOrdering();
          }
        }
        var canUseDOM2 = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
        var PLUGIN_EVENT_SYSTEM = 1;
        var IS_REPLAYED = 1 << 5;
        var IS_FIRST_ANCESTOR = 1 << 6;
        var restoreImpl = null;
        var restoreTarget = null;
        var restoreQueue = null;
        function restoreStateOfTarget(target) {
          var internalInstance = getInstanceFromNode(target);
          if (!internalInstance) {
            return;
          }
          if (!(typeof restoreImpl === "function")) {
            {
              throw Error("setRestoreImplementation() needs to be called to handle a target for controlled events. This error is likely caused by a bug in React. Please file an issue.");
            }
          }
          var stateNode = internalInstance.stateNode;
          if (stateNode) {
            var _props = getFiberCurrentPropsFromNode(stateNode);
            restoreImpl(internalInstance.stateNode, internalInstance.type, _props);
          }
        }
        function setRestoreImplementation(impl) {
          restoreImpl = impl;
        }
        function enqueueStateRestore(target) {
          if (restoreTarget) {
            if (restoreQueue) {
              restoreQueue.push(target);
            } else {
              restoreQueue = [target];
            }
          } else {
            restoreTarget = target;
          }
        }
        function needsStateRestore() {
          return restoreTarget !== null || restoreQueue !== null;
        }
        function restoreStateIfNeeded() {
          if (!restoreTarget) {
            return;
          }
          var target = restoreTarget;
          var queuedTargets = restoreQueue;
          restoreTarget = null;
          restoreQueue = null;
          restoreStateOfTarget(target);
          if (queuedTargets) {
            for (var i = 0; i < queuedTargets.length; i++) {
              restoreStateOfTarget(queuedTargets[i]);
            }
          }
        }
        var enableProfilerTimer = true;
        var enableDeprecatedFlareAPI = false;
        var enableFundamentalAPI = false;
        var warnAboutStringRefs = false;
        var batchedUpdatesImpl = function(fn, bookkeeping) {
          return fn(bookkeeping);
        };
        var discreteUpdatesImpl = function(fn, a, b, c, d) {
          return fn(a, b, c, d);
        };
        var flushDiscreteUpdatesImpl = function() {
        };
        var batchedEventUpdatesImpl = batchedUpdatesImpl;
        var isInsideEventHandler = false;
        var isBatchingEventUpdates = false;
        function finishEventHandler() {
          var controlledComponentsHavePendingUpdates = needsStateRestore();
          if (controlledComponentsHavePendingUpdates) {
            flushDiscreteUpdatesImpl();
            restoreStateIfNeeded();
          }
        }
        function batchedUpdates(fn, bookkeeping) {
          if (isInsideEventHandler) {
            return fn(bookkeeping);
          }
          isInsideEventHandler = true;
          try {
            return batchedUpdatesImpl(fn, bookkeeping);
          } finally {
            isInsideEventHandler = false;
            finishEventHandler();
          }
        }
        function batchedEventUpdates(fn, a, b) {
          if (isBatchingEventUpdates) {
            return fn(a, b);
          }
          isBatchingEventUpdates = true;
          try {
            return batchedEventUpdatesImpl(fn, a, b);
          } finally {
            isBatchingEventUpdates = false;
            finishEventHandler();
          }
        }
        function discreteUpdates(fn, a, b, c, d) {
          var prevIsInsideEventHandler = isInsideEventHandler;
          isInsideEventHandler = true;
          try {
            return discreteUpdatesImpl(fn, a, b, c, d);
          } finally {
            isInsideEventHandler = prevIsInsideEventHandler;
            if (!isInsideEventHandler) {
              finishEventHandler();
            }
          }
        }
        function flushDiscreteUpdatesIfNeeded(timeStamp) {
          if (!isInsideEventHandler && !enableDeprecatedFlareAPI) {
            flushDiscreteUpdatesImpl();
          }
        }
        function setBatchingImplementation(_batchedUpdatesImpl, _discreteUpdatesImpl, _flushDiscreteUpdatesImpl, _batchedEventUpdatesImpl) {
          batchedUpdatesImpl = _batchedUpdatesImpl;
          discreteUpdatesImpl = _discreteUpdatesImpl;
          flushDiscreteUpdatesImpl = _flushDiscreteUpdatesImpl;
          batchedEventUpdatesImpl = _batchedEventUpdatesImpl;
        }
        var DiscreteEvent = 0;
        var UserBlockingEvent = 1;
        var ContinuousEvent = 2;
        var RESERVED = 0;
        var STRING2 = 1;
        var BOOLEANISH_STRING = 2;
        var BOOLEAN = 3;
        var OVERLOADED_BOOLEAN = 4;
        var NUMERIC = 5;
        var POSITIVE_NUMERIC = 6;
        var ATTRIBUTE_NAME_START_CHAR = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD";
        var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040";
        var ROOT_ATTRIBUTE_NAME = "data-reactroot";
        var VALID_ATTRIBUTE_NAME_REGEX = new RegExp("^[" + ATTRIBUTE_NAME_START_CHAR + "][" + ATTRIBUTE_NAME_CHAR + "]*$");
        var hasOwnProperty15 = Object.prototype.hasOwnProperty;
        var illegalAttributeNameCache = {};
        var validatedAttributeNameCache = {};
        function isAttributeNameSafe(attributeName) {
          if (hasOwnProperty15.call(validatedAttributeNameCache, attributeName)) {
            return true;
          }
          if (hasOwnProperty15.call(illegalAttributeNameCache, attributeName)) {
            return false;
          }
          if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
            validatedAttributeNameCache[attributeName] = true;
            return true;
          }
          illegalAttributeNameCache[attributeName] = true;
          {
            error2("Invalid attribute name: `%s`", attributeName);
          }
          return false;
        }
        function shouldIgnoreAttribute(name, propertyInfo, isCustomComponentTag) {
          if (propertyInfo !== null) {
            return propertyInfo.type === RESERVED;
          }
          if (isCustomComponentTag) {
            return false;
          }
          if (name.length > 2 && (name[0] === "o" || name[0] === "O") && (name[1] === "n" || name[1] === "N")) {
            return true;
          }
          return false;
        }
        function shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag) {
          if (propertyInfo !== null && propertyInfo.type === RESERVED) {
            return false;
          }
          switch (typeof value) {
            case "function":
            // $FlowIssue symbol is perfectly valid here
            case "symbol":
              return true;
            case "boolean": {
              if (isCustomComponentTag) {
                return false;
              }
              if (propertyInfo !== null) {
                return !propertyInfo.acceptsBooleans;
              } else {
                var prefix3 = name.toLowerCase().slice(0, 5);
                return prefix3 !== "data-" && prefix3 !== "aria-";
              }
            }
            default:
              return false;
          }
        }
        function shouldRemoveAttribute(name, value, propertyInfo, isCustomComponentTag) {
          if (value === null || typeof value === "undefined") {
            return true;
          }
          if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag)) {
            return true;
          }
          if (isCustomComponentTag) {
            return false;
          }
          if (propertyInfo !== null) {
            switch (propertyInfo.type) {
              case BOOLEAN:
                return !value;
              case OVERLOADED_BOOLEAN:
                return value === false;
              case NUMERIC:
                return isNaN(value);
              case POSITIVE_NUMERIC:
                return isNaN(value) || value < 1;
            }
          }
          return false;
        }
        function getPropertyInfo(name) {
          return properties2.hasOwnProperty(name) ? properties2[name] : null;
        }
        function PropertyInfoRecord(name, type5, mustUseProperty, attributeName, attributeNamespace, sanitizeURL2) {
          this.acceptsBooleans = type5 === BOOLEANISH_STRING || type5 === BOOLEAN || type5 === OVERLOADED_BOOLEAN;
          this.attributeName = attributeName;
          this.attributeNamespace = attributeNamespace;
          this.mustUseProperty = mustUseProperty;
          this.propertyName = name;
          this.type = type5;
          this.sanitizeURL = sanitizeURL2;
        }
        var properties2 = {};
        var reservedProps = [
          "children",
          "dangerouslySetInnerHTML",
          // TODO: This prevents the assignment of defaultValue to regular
          // elements (not just inputs). Now that ReactDOMInput assigns to the
          // defaultValue property -- do we need this?
          "defaultValue",
          "defaultChecked",
          "innerHTML",
          "suppressContentEditableWarning",
          "suppressHydrationWarning",
          "style"
        ];
        reservedProps.forEach(function(name) {
          properties2[name] = new PropertyInfoRecord(
            name,
            RESERVED,
            false,
            // mustUseProperty
            name,
            // attributeName
            null,
            // attributeNamespace
            false
          );
        });
        [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(_ref) {
          var name = _ref[0], attributeName = _ref[1];
          properties2[name] = new PropertyInfoRecord(
            name,
            STRING2,
            false,
            // mustUseProperty
            attributeName,
            // attributeName
            null,
            // attributeNamespace
            false
          );
        });
        ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(name) {
          properties2[name] = new PropertyInfoRecord(
            name,
            BOOLEANISH_STRING,
            false,
            // mustUseProperty
            name.toLowerCase(),
            // attributeName
            null,
            // attributeNamespace
            false
          );
        });
        ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(name) {
          properties2[name] = new PropertyInfoRecord(
            name,
            BOOLEANISH_STRING,
            false,
            // mustUseProperty
            name,
            // attributeName
            null,
            // attributeNamespace
            false
          );
        });
        [
          "allowFullScreen",
          "async",
          // Note: there is a special case that prevents it from being written to the DOM
          // on the client side because the browsers are inconsistent. Instead we call focus().
          "autoFocus",
          "autoPlay",
          "controls",
          "default",
          "defer",
          "disabled",
          "disablePictureInPicture",
          "formNoValidate",
          "hidden",
          "loop",
          "noModule",
          "noValidate",
          "open",
          "playsInline",
          "readOnly",
          "required",
          "reversed",
          "scoped",
          "seamless",
          // Microdata
          "itemScope"
        ].forEach(function(name) {
          properties2[name] = new PropertyInfoRecord(
            name,
            BOOLEAN,
            false,
            // mustUseProperty
            name.toLowerCase(),
            // attributeName
            null,
            // attributeNamespace
            false
          );
        });
        [
          "checked",
          // Note: `option.selected` is not updated if `select.multiple` is
          // disabled with `removeAttribute`. We have special logic for handling this.
          "multiple",
          "muted",
          "selected"
          // NOTE: if you add a camelCased prop to this list,
          // you'll need to set attributeName to name.toLowerCase()
          // instead in the assignment below.
        ].forEach(function(name) {
          properties2[name] = new PropertyInfoRecord(
            name,
            BOOLEAN,
            true,
            // mustUseProperty
            name,
            // attributeName
            null,
            // attributeNamespace
            false
          );
        });
        [
          "capture",
          "download"
          // NOTE: if you add a camelCased prop to this list,
          // you'll need to set attributeName to name.toLowerCase()
          // instead in the assignment below.
        ].forEach(function(name) {
          properties2[name] = new PropertyInfoRecord(
            name,
            OVERLOADED_BOOLEAN,
            false,
            // mustUseProperty
            name,
            // attributeName
            null,
            // attributeNamespace
            false
          );
        });
        [
          "cols",
          "rows",
          "size",
          "span"
          // NOTE: if you add a camelCased prop to this list,
          // you'll need to set attributeName to name.toLowerCase()
          // instead in the assignment below.
        ].forEach(function(name) {
          properties2[name] = new PropertyInfoRecord(
            name,
            POSITIVE_NUMERIC,
            false,
            // mustUseProperty
            name,
            // attributeName
            null,
            // attributeNamespace
            false
          );
        });
        ["rowSpan", "start"].forEach(function(name) {
          properties2[name] = new PropertyInfoRecord(
            name,
            NUMERIC,
            false,
            // mustUseProperty
            name.toLowerCase(),
            // attributeName
            null,
            // attributeNamespace
            false
          );
        });
        var CAMELIZE = /[\-\:]([a-z])/g;
        var capitalize = function(token2) {
          return token2[1].toUpperCase();
        };
        [
          "accent-height",
          "alignment-baseline",
          "arabic-form",
          "baseline-shift",
          "cap-height",
          "clip-path",
          "clip-rule",
          "color-interpolation",
          "color-interpolation-filters",
          "color-profile",
          "color-rendering",
          "dominant-baseline",
          "enable-background",
          "fill-opacity",
          "fill-rule",
          "flood-color",
          "flood-opacity",
          "font-family",
          "font-size",
          "font-size-adjust",
          "font-stretch",
          "font-style",
          "font-variant",
          "font-weight",
          "glyph-name",
          "glyph-orientation-horizontal",
          "glyph-orientation-vertical",
          "horiz-adv-x",
          "horiz-origin-x",
          "image-rendering",
          "letter-spacing",
          "lighting-color",
          "marker-end",
          "marker-mid",
          "marker-start",
          "overline-position",
          "overline-thickness",
          "paint-order",
          "panose-1",
          "pointer-events",
          "rendering-intent",
          "shape-rendering",
          "stop-color",
          "stop-opacity",
          "strikethrough-position",
          "strikethrough-thickness",
          "stroke-dasharray",
          "stroke-dashoffset",
          "stroke-linecap",
          "stroke-linejoin",
          "stroke-miterlimit",
          "stroke-opacity",
          "stroke-width",
          "text-anchor",
          "text-decoration",
          "text-rendering",
          "underline-position",
          "underline-thickness",
          "unicode-bidi",
          "unicode-range",
          "units-per-em",
          "v-alphabetic",
          "v-hanging",
          "v-ideographic",
          "v-mathematical",
          "vector-effect",
          "vert-adv-y",
          "vert-origin-x",
          "vert-origin-y",
          "word-spacing",
          "writing-mode",
          "xmlns:xlink",
          "x-height"
          // NOTE: if you add a camelCased prop to this list,
          // you'll need to set attributeName to name.toLowerCase()
          // instead in the assignment below.
        ].forEach(function(attributeName) {
          var name = attributeName.replace(CAMELIZE, capitalize);
          properties2[name] = new PropertyInfoRecord(
            name,
            STRING2,
            false,
            // mustUseProperty
            attributeName,
            null,
            // attributeNamespace
            false
          );
        });
        [
          "xlink:actuate",
          "xlink:arcrole",
          "xlink:role",
          "xlink:show",
          "xlink:title",
          "xlink:type"
          // NOTE: if you add a camelCased prop to this list,
          // you'll need to set attributeName to name.toLowerCase()
          // instead in the assignment below.
        ].forEach(function(attributeName) {
          var name = attributeName.replace(CAMELIZE, capitalize);
          properties2[name] = new PropertyInfoRecord(
            name,
            STRING2,
            false,
            // mustUseProperty
            attributeName,
            "http://www.w3.org/1999/xlink",
            false
          );
        });
        [
          "xml:base",
          "xml:lang",
          "xml:space"
          // NOTE: if you add a camelCased prop to this list,
          // you'll need to set attributeName to name.toLowerCase()
          // instead in the assignment below.
        ].forEach(function(attributeName) {
          var name = attributeName.replace(CAMELIZE, capitalize);
          properties2[name] = new PropertyInfoRecord(
            name,
            STRING2,
            false,
            // mustUseProperty
            attributeName,
            "http://www.w3.org/XML/1998/namespace",
            false
          );
        });
        ["tabIndex", "crossOrigin"].forEach(function(attributeName) {
          properties2[attributeName] = new PropertyInfoRecord(
            attributeName,
            STRING2,
            false,
            // mustUseProperty
            attributeName.toLowerCase(),
            // attributeName
            null,
            // attributeNamespace
            false
          );
        });
        var xlinkHref = "xlinkHref";
        properties2[xlinkHref] = new PropertyInfoRecord(
          "xlinkHref",
          STRING2,
          false,
          // mustUseProperty
          "xlink:href",
          "http://www.w3.org/1999/xlink",
          true
        );
        ["src", "href", "action", "formAction"].forEach(function(attributeName) {
          properties2[attributeName] = new PropertyInfoRecord(
            attributeName,
            STRING2,
            false,
            // mustUseProperty
            attributeName.toLowerCase(),
            // attributeName
            null,
            // attributeNamespace
            true
          );
        });
        var ReactDebugCurrentFrame = null;
        {
          ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
        }
        var isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i;
        var didWarn = false;
        function sanitizeURL(url2) {
          {
            if (!didWarn && isJavaScriptProtocol.test(url2)) {
              didWarn = true;
              error2("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(url2));
            }
          }
        }
        function getValueForProperty(node2, name, expected, propertyInfo) {
          {
            if (propertyInfo.mustUseProperty) {
              var propertyName = propertyInfo.propertyName;
              return node2[propertyName];
            } else {
              if (propertyInfo.sanitizeURL) {
                sanitizeURL("" + expected);
              }
              var attributeName = propertyInfo.attributeName;
              var stringValue = null;
              if (propertyInfo.type === OVERLOADED_BOOLEAN) {
                if (node2.hasAttribute(attributeName)) {
                  var value = node2.getAttribute(attributeName);
                  if (value === "") {
                    return true;
                  }
                  if (shouldRemoveAttribute(name, expected, propertyInfo, false)) {
                    return value;
                  }
                  if (value === "" + expected) {
                    return expected;
                  }
                  return value;
                }
              } else if (node2.hasAttribute(attributeName)) {
                if (shouldRemoveAttribute(name, expected, propertyInfo, false)) {
                  return node2.getAttribute(attributeName);
                }
                if (propertyInfo.type === BOOLEAN) {
                  return expected;
                }
                stringValue = node2.getAttribute(attributeName);
              }
              if (shouldRemoveAttribute(name, expected, propertyInfo, false)) {
                return stringValue === null ? expected : stringValue;
              } else if (stringValue === "" + expected) {
                return expected;
              } else {
                return stringValue;
              }
            }
          }
        }
        function getValueForAttribute(node2, name, expected) {
          {
            if (!isAttributeNameSafe(name)) {
              return;
            }
            if (!node2.hasAttribute(name)) {
              return expected === void 0 ? void 0 : null;
            }
            var value = node2.getAttribute(name);
            if (value === "" + expected) {
              return expected;
            }
            return value;
          }
        }
        function setValueForProperty(node2, name, value, isCustomComponentTag) {
          var propertyInfo = getPropertyInfo(name);
          if (shouldIgnoreAttribute(name, propertyInfo, isCustomComponentTag)) {
            return;
          }
          if (shouldRemoveAttribute(name, value, propertyInfo, isCustomComponentTag)) {
            value = null;
          }
          if (isCustomComponentTag || propertyInfo === null) {
            if (isAttributeNameSafe(name)) {
              var _attributeName = name;
              if (value === null) {
                node2.removeAttribute(_attributeName);
              } else {
                node2.setAttribute(_attributeName, "" + value);
              }
            }
            return;
          }
          var mustUseProperty = propertyInfo.mustUseProperty;
          if (mustUseProperty) {
            var propertyName = propertyInfo.propertyName;
            if (value === null) {
              var type5 = propertyInfo.type;
              node2[propertyName] = type5 === BOOLEAN ? false : "";
            } else {
              node2[propertyName] = value;
            }
            return;
          }
          var attributeName = propertyInfo.attributeName, attributeNamespace = propertyInfo.attributeNamespace;
          if (value === null) {
            node2.removeAttribute(attributeName);
          } else {
            var _type = propertyInfo.type;
            var attributeValue;
            if (_type === BOOLEAN || _type === OVERLOADED_BOOLEAN && value === true) {
              attributeValue = "";
            } else {
              {
                attributeValue = "" + value;
              }
              if (propertyInfo.sanitizeURL) {
                sanitizeURL(attributeValue.toString());
              }
            }
            if (attributeNamespace) {
              node2.setAttributeNS(attributeNamespace, attributeName, attributeValue);
            } else {
              node2.setAttribute(attributeName, attributeValue);
            }
          }
        }
        var BEFORE_SLASH_RE = /^(.*)[\\\/]/;
        function describeComponentFrame(name, source, ownerName) {
          var sourceInfo = "";
          if (source) {
            var path2 = source.fileName;
            var fileName = path2.replace(BEFORE_SLASH_RE, "");
            {
              if (/^index\./.test(fileName)) {
                var match2 = path2.match(BEFORE_SLASH_RE);
                if (match2) {
                  var pathBeforeSlash = match2[1];
                  if (pathBeforeSlash) {
                    var folderName = pathBeforeSlash.replace(BEFORE_SLASH_RE, "");
                    fileName = folderName + "/" + fileName;
                  }
                }
              }
            }
            sourceInfo = " (at " + fileName + ":" + source.lineNumber + ")";
          } else if (ownerName) {
            sourceInfo = " (created by " + ownerName + ")";
          }
          return "\n    in " + (name || "Unknown") + sourceInfo;
        }
        var hasSymbol = typeof Symbol === "function" && Symbol.for;
        var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 60103;
        var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 60106;
        var REACT_FRAGMENT_TYPE2 = hasSymbol ? Symbol.for("react.fragment") : 60107;
        var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 60108;
        var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 60114;
        var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 60109;
        var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 60110;
        var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 60111;
        var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 60112;
        var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 60113;
        var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 60120;
        var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 60115;
        var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 60116;
        var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 60121;
        var MAYBE_ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
        var FAUX_ITERATOR_SYMBOL = "@@iterator";
        function getIteratorFn(maybeIterable) {
          if (maybeIterable === null || typeof maybeIterable !== "object") {
            return null;
          }
          var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
          if (typeof maybeIterator === "function") {
            return maybeIterator;
          }
          return null;
        }
        var Uninitialized = -1;
        var Pending = 0;
        var Resolved = 1;
        var Rejected = 2;
        function refineResolvedLazyComponent(lazyComponent) {
          return lazyComponent._status === Resolved ? lazyComponent._result : null;
        }
        function initializeLazyComponentType(lazyComponent) {
          if (lazyComponent._status === Uninitialized) {
            lazyComponent._status = Pending;
            var ctor = lazyComponent._ctor;
            var thenable = ctor();
            lazyComponent._result = thenable;
            thenable.then(function(moduleObject) {
              if (lazyComponent._status === Pending) {
                var defaultExport = moduleObject.default;
                {
                  if (defaultExport === void 0) {
                    error2("lazy: Expected the result of a dynamic import() call. Instead received: %s\n\nYour code should look like: \n  const MyComponent = lazy(() => import('./MyComponent'))", moduleObject);
                  }
                }
                lazyComponent._status = Resolved;
                lazyComponent._result = defaultExport;
              }
            }, function(error3) {
              if (lazyComponent._status === Pending) {
                lazyComponent._status = Rejected;
                lazyComponent._result = error3;
              }
            });
          }
        }
        function getWrappedName(outerType, innerType, wrapperName) {
          var functionName = innerType.displayName || innerType.name || "";
          return outerType.displayName || (functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName);
        }
        function getComponentName(type5) {
          if (type5 == null) {
            return null;
          }
          {
            if (typeof type5.tag === "number") {
              error2("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue.");
            }
          }
          if (typeof type5 === "function") {
            return type5.displayName || type5.name || null;
          }
          if (typeof type5 === "string") {
            return type5;
          }
          switch (type5) {
            case REACT_FRAGMENT_TYPE2:
              return "Fragment";
            case REACT_PORTAL_TYPE:
              return "Portal";
            case REACT_PROFILER_TYPE:
              return "Profiler";
            case REACT_STRICT_MODE_TYPE:
              return "StrictMode";
            case REACT_SUSPENSE_TYPE:
              return "Suspense";
            case REACT_SUSPENSE_LIST_TYPE:
              return "SuspenseList";
          }
          if (typeof type5 === "object") {
            switch (type5.$$typeof) {
              case REACT_CONTEXT_TYPE:
                return "Context.Consumer";
              case REACT_PROVIDER_TYPE:
                return "Context.Provider";
              case REACT_FORWARD_REF_TYPE:
                return getWrappedName(type5, type5.render, "ForwardRef");
              case REACT_MEMO_TYPE:
                return getComponentName(type5.type);
              case REACT_BLOCK_TYPE:
                return getComponentName(type5.render);
              case REACT_LAZY_TYPE: {
                var thenable = type5;
                var resolvedThenable = refineResolvedLazyComponent(thenable);
                if (resolvedThenable) {
                  return getComponentName(resolvedThenable);
                }
                break;
              }
            }
          }
          return null;
        }
        var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
        function describeFiber(fiber) {
          switch (fiber.tag) {
            case HostRoot:
            case HostPortal:
            case HostText:
            case Fragment35:
            case ContextProvider:
            case ContextConsumer:
              return "";
            default:
              var owner = fiber._debugOwner;
              var source = fiber._debugSource;
              var name = getComponentName(fiber.type);
              var ownerName = null;
              if (owner) {
                ownerName = getComponentName(owner.type);
              }
              return describeComponentFrame(name, source, ownerName);
          }
        }
        function getStackByFiberInDevAndProd(workInProgress2) {
          var info = "";
          var node2 = workInProgress2;
          do {
            info += describeFiber(node2);
            node2 = node2.return;
          } while (node2);
          return info;
        }
        var current2 = null;
        var isRendering = false;
        function getCurrentFiberOwnerNameInDevOrNull() {
          {
            if (current2 === null) {
              return null;
            }
            var owner = current2._debugOwner;
            if (owner !== null && typeof owner !== "undefined") {
              return getComponentName(owner.type);
            }
          }
          return null;
        }
        function getCurrentFiberStackInDev() {
          {
            if (current2 === null) {
              return "";
            }
            return getStackByFiberInDevAndProd(current2);
          }
        }
        function resetCurrentFiber() {
          {
            ReactDebugCurrentFrame$1.getCurrentStack = null;
            current2 = null;
            isRendering = false;
          }
        }
        function setCurrentFiber(fiber) {
          {
            ReactDebugCurrentFrame$1.getCurrentStack = getCurrentFiberStackInDev;
            current2 = fiber;
            isRendering = false;
          }
        }
        function setIsRendering(rendering) {
          {
            isRendering = rendering;
          }
        }
        function toString3(value) {
          return "" + value;
        }
        function getToStringValue(value) {
          switch (typeof value) {
            case "boolean":
            case "number":
            case "object":
            case "string":
            case "undefined":
              return value;
            default:
              return "";
          }
        }
        var ReactDebugCurrentFrame$2 = null;
        var ReactControlledValuePropTypes = {
          checkPropTypes: null
        };
        {
          ReactDebugCurrentFrame$2 = ReactSharedInternals.ReactDebugCurrentFrame;
          var hasReadOnlyValue = {
            button: true,
            checkbox: true,
            image: true,
            hidden: true,
            radio: true,
            reset: true,
            submit: true
          };
          var propTypes = {
            value: function(props, propName, componentName) {
              if (hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled || props[propName] == null || enableDeprecatedFlareAPI) {
                return null;
              }
              return new Error("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`.");
            },
            checked: function(props, propName, componentName) {
              if (props.onChange || props.readOnly || props.disabled || props[propName] == null || enableDeprecatedFlareAPI) {
                return null;
              }
              return new Error("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
            }
          };
          ReactControlledValuePropTypes.checkPropTypes = function(tagName, props) {
            checkPropTypes(propTypes, props, "prop", tagName, ReactDebugCurrentFrame$2.getStackAddendum);
          };
        }
        function isCheckable(elem) {
          var type5 = elem.type;
          var nodeName = elem.nodeName;
          return nodeName && nodeName.toLowerCase() === "input" && (type5 === "checkbox" || type5 === "radio");
        }
        function getTracker(node2) {
          return node2._valueTracker;
        }
        function detachTracker(node2) {
          node2._valueTracker = null;
        }
        function getValueFromNode(node2) {
          var value = "";
          if (!node2) {
            return value;
          }
          if (isCheckable(node2)) {
            value = node2.checked ? "true" : "false";
          } else {
            value = node2.value;
          }
          return value;
        }
        function trackValueOnNode(node2) {
          var valueField = isCheckable(node2) ? "checked" : "value";
          var descriptor = Object.getOwnPropertyDescriptor(node2.constructor.prototype, valueField);
          var currentValue = "" + node2[valueField];
          if (node2.hasOwnProperty(valueField) || typeof descriptor === "undefined" || typeof descriptor.get !== "function" || typeof descriptor.set !== "function") {
            return;
          }
          var get4 = descriptor.get, set5 = descriptor.set;
          Object.defineProperty(node2, valueField, {
            configurable: true,
            get: function() {
              return get4.call(this);
            },
            set: function(value) {
              currentValue = "" + value;
              set5.call(this, value);
            }
          });
          Object.defineProperty(node2, valueField, {
            enumerable: descriptor.enumerable
          });
          var tracker = {
            getValue: function() {
              return currentValue;
            },
            setValue: function(value) {
              currentValue = "" + value;
            },
            stopTracking: function() {
              detachTracker(node2);
              delete node2[valueField];
            }
          };
          return tracker;
        }
        function track(node2) {
          if (getTracker(node2)) {
            return;
          }
          node2._valueTracker = trackValueOnNode(node2);
        }
        function updateValueIfChanged(node2) {
          if (!node2) {
            return false;
          }
          var tracker = getTracker(node2);
          if (!tracker) {
            return true;
          }
          var lastValue = tracker.getValue();
          var nextValue = getValueFromNode(node2);
          if (nextValue !== lastValue) {
            tracker.setValue(nextValue);
            return true;
          }
          return false;
        }
        var didWarnValueDefaultValue = false;
        var didWarnCheckedDefaultChecked = false;
        var didWarnControlledToUncontrolled = false;
        var didWarnUncontrolledToControlled = false;
        function isControlled(props) {
          var usesChecked = props.type === "checkbox" || props.type === "radio";
          return usesChecked ? props.checked != null : props.value != null;
        }
        function getHostProps(element, props) {
          var node2 = element;
          var checked = props.checked;
          var hostProps = _assign({}, props, {
            defaultChecked: void 0,
            defaultValue: void 0,
            value: void 0,
            checked: checked != null ? checked : node2._wrapperState.initialChecked
          });
          return hostProps;
        }
        function initWrapperState(element, props) {
          {
            ReactControlledValuePropTypes.checkPropTypes("input", props);
            if (props.checked !== void 0 && props.defaultChecked !== void 0 && !didWarnCheckedDefaultChecked) {
              error2("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://fb.me/react-controlled-components", getCurrentFiberOwnerNameInDevOrNull() || "A component", props.type);
              didWarnCheckedDefaultChecked = true;
            }
            if (props.value !== void 0 && props.defaultValue !== void 0 && !didWarnValueDefaultValue) {
              error2("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://fb.me/react-controlled-components", getCurrentFiberOwnerNameInDevOrNull() || "A component", props.type);
              didWarnValueDefaultValue = true;
            }
          }
          var node2 = element;
          var defaultValue2 = props.defaultValue == null ? "" : props.defaultValue;
          node2._wrapperState = {
            initialChecked: props.checked != null ? props.checked : props.defaultChecked,
            initialValue: getToStringValue(props.value != null ? props.value : defaultValue2),
            controlled: isControlled(props)
          };
        }
        function updateChecked(element, props) {
          var node2 = element;
          var checked = props.checked;
          if (checked != null) {
            setValueForProperty(node2, "checked", checked, false);
          }
        }
        function updateWrapper(element, props) {
          var node2 = element;
          {
            var controlled = isControlled(props);
            if (!node2._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
              error2("A component is changing an uncontrolled input of type %s to be controlled. Input elements should not switch from uncontrolled to controlled (or vice versa). Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://fb.me/react-controlled-components", props.type);
              didWarnUncontrolledToControlled = true;
            }
            if (node2._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
              error2("A component is changing a controlled input of type %s to be uncontrolled. Input elements should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://fb.me/react-controlled-components", props.type);
              didWarnControlledToUncontrolled = true;
            }
          }
          updateChecked(element, props);
          var value = getToStringValue(props.value);
          var type5 = props.type;
          if (value != null) {
            if (type5 === "number") {
              if (value === 0 && node2.value === "" || // We explicitly want to coerce to number here if possible.
              // eslint-disable-next-line
              node2.value != value) {
                node2.value = toString3(value);
              }
            } else if (node2.value !== toString3(value)) {
              node2.value = toString3(value);
            }
          } else if (type5 === "submit" || type5 === "reset") {
            node2.removeAttribute("value");
            return;
          }
          {
            if (props.hasOwnProperty("value")) {
              setDefaultValue(node2, props.type, value);
            } else if (props.hasOwnProperty("defaultValue")) {
              setDefaultValue(node2, props.type, getToStringValue(props.defaultValue));
            }
          }
          {
            if (props.checked == null && props.defaultChecked != null) {
              node2.defaultChecked = !!props.defaultChecked;
            }
          }
        }
        function postMountWrapper(element, props, isHydrating2) {
          var node2 = element;
          if (props.hasOwnProperty("value") || props.hasOwnProperty("defaultValue")) {
            var type5 = props.type;
            var isButton = type5 === "submit" || type5 === "reset";
            if (isButton && (props.value === void 0 || props.value === null)) {
              return;
            }
            var initialValue = toString3(node2._wrapperState.initialValue);
            if (!isHydrating2) {
              {
                if (initialValue !== node2.value) {
                  node2.value = initialValue;
                }
              }
            }
            {
              node2.defaultValue = initialValue;
            }
          }
          var name = node2.name;
          if (name !== "") {
            node2.name = "";
          }
          {
            node2.defaultChecked = !node2.defaultChecked;
            node2.defaultChecked = !!node2._wrapperState.initialChecked;
          }
          if (name !== "") {
            node2.name = name;
          }
        }
        function restoreControlledState(element, props) {
          var node2 = element;
          updateWrapper(node2, props);
          updateNamedCousins(node2, props);
        }
        function updateNamedCousins(rootNode, props) {
          var name = props.name;
          if (props.type === "radio" && name != null) {
            var queryRoot = rootNode;
            while (queryRoot.parentNode) {
              queryRoot = queryRoot.parentNode;
            }
            var group = queryRoot.querySelectorAll("input[name=" + JSON.stringify("" + name) + '][type="radio"]');
            for (var i = 0; i < group.length; i++) {
              var otherNode = group[i];
              if (otherNode === rootNode || otherNode.form !== rootNode.form) {
                continue;
              }
              var otherProps = getFiberCurrentPropsFromNode$1(otherNode);
              if (!otherProps) {
                {
                  throw Error("ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.");
                }
              }
              updateValueIfChanged(otherNode);
              updateWrapper(otherNode, otherProps);
            }
          }
        }
        function setDefaultValue(node2, type5, value) {
          if (
            // Focused number inputs synchronize on blur. See ChangeEventPlugin.js
            type5 !== "number" || node2.ownerDocument.activeElement !== node2
          ) {
            if (value == null) {
              node2.defaultValue = toString3(node2._wrapperState.initialValue);
            } else if (node2.defaultValue !== toString3(value)) {
              node2.defaultValue = toString3(value);
            }
          }
        }
        var didWarnSelectedSetOnOption = false;
        var didWarnInvalidChild = false;
        function flattenChildren(children) {
          var content = "";
          React615.Children.forEach(children, function(child) {
            if (child == null) {
              return;
            }
            content += child;
          });
          return content;
        }
        function validateProps(element, props) {
          {
            if (typeof props.children === "object" && props.children !== null) {
              React615.Children.forEach(props.children, function(child) {
                if (child == null) {
                  return;
                }
                if (typeof child === "string" || typeof child === "number") {
                  return;
                }
                if (typeof child.type !== "string") {
                  return;
                }
                if (!didWarnInvalidChild) {
                  didWarnInvalidChild = true;
                  error2("Only strings and numbers are supported as <option> children.");
                }
              });
            }
            if (props.selected != null && !didWarnSelectedSetOnOption) {
              error2("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>.");
              didWarnSelectedSetOnOption = true;
            }
          }
        }
        function postMountWrapper$1(element, props) {
          if (props.value != null) {
            element.setAttribute("value", toString3(getToStringValue(props.value)));
          }
        }
        function getHostProps$1(element, props) {
          var hostProps = _assign({
            children: void 0
          }, props);
          var content = flattenChildren(props.children);
          if (content) {
            hostProps.children = content;
          }
          return hostProps;
        }
        var didWarnValueDefaultValue$1;
        {
          didWarnValueDefaultValue$1 = false;
        }
        function getDeclarationErrorAddendum() {
          var ownerName = getCurrentFiberOwnerNameInDevOrNull();
          if (ownerName) {
            return "\n\nCheck the render method of `" + ownerName + "`.";
          }
          return "";
        }
        var valuePropNames = ["value", "defaultValue"];
        function checkSelectPropTypes(props) {
          {
            ReactControlledValuePropTypes.checkPropTypes("select", props);
            for (var i = 0; i < valuePropNames.length; i++) {
              var propName = valuePropNames[i];
              if (props[propName] == null) {
                continue;
              }
              var isArray7 = Array.isArray(props[propName]);
              if (props.multiple && !isArray7) {
                error2("The `%s` prop supplied to <select> must be an array if `multiple` is true.%s", propName, getDeclarationErrorAddendum());
              } else if (!props.multiple && isArray7) {
                error2("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s", propName, getDeclarationErrorAddendum());
              }
            }
          }
        }
        function updateOptions(node2, multiple, propValue, setDefaultSelected) {
          var options = node2.options;
          if (multiple) {
            var selectedValues = propValue;
            var selectedValue = {};
            for (var i = 0; i < selectedValues.length; i++) {
              selectedValue["$" + selectedValues[i]] = true;
            }
            for (var _i = 0; _i < options.length; _i++) {
              var selected = selectedValue.hasOwnProperty("$" + options[_i].value);
              if (options[_i].selected !== selected) {
                options[_i].selected = selected;
              }
              if (selected && setDefaultSelected) {
                options[_i].defaultSelected = true;
              }
            }
          } else {
            var _selectedValue = toString3(getToStringValue(propValue));
            var defaultSelected = null;
            for (var _i2 = 0; _i2 < options.length; _i2++) {
              if (options[_i2].value === _selectedValue) {
                options[_i2].selected = true;
                if (setDefaultSelected) {
                  options[_i2].defaultSelected = true;
                }
                return;
              }
              if (defaultSelected === null && !options[_i2].disabled) {
                defaultSelected = options[_i2];
              }
            }
            if (defaultSelected !== null) {
              defaultSelected.selected = true;
            }
          }
        }
        function getHostProps$2(element, props) {
          return _assign({}, props, {
            value: void 0
          });
        }
        function initWrapperState$1(element, props) {
          var node2 = element;
          {
            checkSelectPropTypes(props);
          }
          node2._wrapperState = {
            wasMultiple: !!props.multiple
          };
          {
            if (props.value !== void 0 && props.defaultValue !== void 0 && !didWarnValueDefaultValue$1) {
              error2("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://fb.me/react-controlled-components");
              didWarnValueDefaultValue$1 = true;
            }
          }
        }
        function postMountWrapper$2(element, props) {
          var node2 = element;
          node2.multiple = !!props.multiple;
          var value = props.value;
          if (value != null) {
            updateOptions(node2, !!props.multiple, value, false);
          } else if (props.defaultValue != null) {
            updateOptions(node2, !!props.multiple, props.defaultValue, true);
          }
        }
        function postUpdateWrapper(element, props) {
          var node2 = element;
          var wasMultiple = node2._wrapperState.wasMultiple;
          node2._wrapperState.wasMultiple = !!props.multiple;
          var value = props.value;
          if (value != null) {
            updateOptions(node2, !!props.multiple, value, false);
          } else if (wasMultiple !== !!props.multiple) {
            if (props.defaultValue != null) {
              updateOptions(node2, !!props.multiple, props.defaultValue, true);
            } else {
              updateOptions(node2, !!props.multiple, props.multiple ? [] : "", false);
            }
          }
        }
        function restoreControlledState$1(element, props) {
          var node2 = element;
          var value = props.value;
          if (value != null) {
            updateOptions(node2, !!props.multiple, value, false);
          }
        }
        var didWarnValDefaultVal = false;
        function getHostProps$3(element, props) {
          var node2 = element;
          if (!(props.dangerouslySetInnerHTML == null)) {
            {
              throw Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
            }
          }
          var hostProps = _assign({}, props, {
            value: void 0,
            defaultValue: void 0,
            children: toString3(node2._wrapperState.initialValue)
          });
          return hostProps;
        }
        function initWrapperState$2(element, props) {
          var node2 = element;
          {
            ReactControlledValuePropTypes.checkPropTypes("textarea", props);
            if (props.value !== void 0 && props.defaultValue !== void 0 && !didWarnValDefaultVal) {
              error2("%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://fb.me/react-controlled-components", getCurrentFiberOwnerNameInDevOrNull() || "A component");
              didWarnValDefaultVal = true;
            }
          }
          var initialValue = props.value;
          if (initialValue == null) {
            var children = props.children, defaultValue2 = props.defaultValue;
            if (children != null) {
              {
                error2("Use the `defaultValue` or `value` props instead of setting children on <textarea>.");
              }
              {
                if (!(defaultValue2 == null)) {
                  {
                    throw Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
                  }
                }
                if (Array.isArray(children)) {
                  if (!(children.length <= 1)) {
                    {
                      throw Error("<textarea> can only have at most one child.");
                    }
                  }
                  children = children[0];
                }
                defaultValue2 = children;
              }
            }
            if (defaultValue2 == null) {
              defaultValue2 = "";
            }
            initialValue = defaultValue2;
          }
          node2._wrapperState = {
            initialValue: getToStringValue(initialValue)
          };
        }
        function updateWrapper$1(element, props) {
          var node2 = element;
          var value = getToStringValue(props.value);
          var defaultValue2 = getToStringValue(props.defaultValue);
          if (value != null) {
            var newValue = toString3(value);
            if (newValue !== node2.value) {
              node2.value = newValue;
            }
            if (props.defaultValue == null && node2.defaultValue !== newValue) {
              node2.defaultValue = newValue;
            }
          }
          if (defaultValue2 != null) {
            node2.defaultValue = toString3(defaultValue2);
          }
        }
        function postMountWrapper$3(element, props) {
          var node2 = element;
          var textContent = node2.textContent;
          if (textContent === node2._wrapperState.initialValue) {
            if (textContent !== "" && textContent !== null) {
              node2.value = textContent;
            }
          }
        }
        function restoreControlledState$2(element, props) {
          updateWrapper$1(element, props);
        }
        var HTML_NAMESPACE = "http://www.w3.org/1999/xhtml";
        var MATH_NAMESPACE = "http://www.w3.org/1998/Math/MathML";
        var SVG_NAMESPACE = "http://www.w3.org/2000/svg";
        var Namespaces = {
          html: HTML_NAMESPACE,
          mathml: MATH_NAMESPACE,
          svg: SVG_NAMESPACE
        };
        function getIntrinsicNamespace(type5) {
          switch (type5) {
            case "svg":
              return SVG_NAMESPACE;
            case "math":
              return MATH_NAMESPACE;
            default:
              return HTML_NAMESPACE;
          }
        }
        function getChildNamespace(parentNamespace, type5) {
          if (parentNamespace == null || parentNamespace === HTML_NAMESPACE) {
            return getIntrinsicNamespace(type5);
          }
          if (parentNamespace === SVG_NAMESPACE && type5 === "foreignObject") {
            return HTML_NAMESPACE;
          }
          return parentNamespace;
        }
        var createMicrosoftUnsafeLocalFunction = function(func) {
          if (typeof MSApp !== "undefined" && MSApp.execUnsafeLocalFunction) {
            return function(arg0, arg1, arg2, arg3) {
              MSApp.execUnsafeLocalFunction(function() {
                return func(arg0, arg1, arg2, arg3);
              });
            };
          } else {
            return func;
          }
        };
        var reusableSVGContainer;
        var setInnerHTML = createMicrosoftUnsafeLocalFunction(function(node2, html2) {
          if (node2.namespaceURI === Namespaces.svg) {
            if (!("innerHTML" in node2)) {
              reusableSVGContainer = reusableSVGContainer || document.createElement("div");
              reusableSVGContainer.innerHTML = "<svg>" + html2.valueOf().toString() + "</svg>";
              var svgNode = reusableSVGContainer.firstChild;
              while (node2.firstChild) {
                node2.removeChild(node2.firstChild);
              }
              while (svgNode.firstChild) {
                node2.appendChild(svgNode.firstChild);
              }
              return;
            }
          }
          node2.innerHTML = html2;
        });
        var ELEMENT_NODE = 1;
        var TEXT_NODE = 3;
        var COMMENT_NODE = 8;
        var DOCUMENT_NODE = 9;
        var DOCUMENT_FRAGMENT_NODE = 11;
        var setTextContent = function(node2, text) {
          if (text) {
            var firstChild = node2.firstChild;
            if (firstChild && firstChild === node2.lastChild && firstChild.nodeType === TEXT_NODE) {
              firstChild.nodeValue = text;
              return;
            }
          }
          node2.textContent = text;
        };
        function unsafeCastStringToDOMTopLevelType(topLevelType) {
          return topLevelType;
        }
        function unsafeCastDOMTopLevelTypeToString(topLevelType) {
          return topLevelType;
        }
        function makePrefixMap2(styleProp, eventName) {
          var prefixes2 = {};
          prefixes2[styleProp.toLowerCase()] = eventName.toLowerCase();
          prefixes2["Webkit" + styleProp] = "webkit" + eventName;
          prefixes2["Moz" + styleProp] = "moz" + eventName;
          return prefixes2;
        }
        var vendorPrefixes2 = {
          animationend: makePrefixMap2("Animation", "AnimationEnd"),
          animationiteration: makePrefixMap2("Animation", "AnimationIteration"),
          animationstart: makePrefixMap2("Animation", "AnimationStart"),
          transitionend: makePrefixMap2("Transition", "TransitionEnd")
        };
        var prefixedEventNames2 = {};
        var style2 = {};
        if (canUseDOM2) {
          style2 = document.createElement("div").style;
          if (!("AnimationEvent" in window)) {
            delete vendorPrefixes2.animationend.animation;
            delete vendorPrefixes2.animationiteration.animation;
            delete vendorPrefixes2.animationstart.animation;
          }
          if (!("TransitionEvent" in window)) {
            delete vendorPrefixes2.transitionend.transition;
          }
        }
        function getVendorPrefixedEventName2(eventName) {
          if (prefixedEventNames2[eventName]) {
            return prefixedEventNames2[eventName];
          } else if (!vendorPrefixes2[eventName]) {
            return eventName;
          }
          var prefixMap = vendorPrefixes2[eventName];
          for (var styleProp in prefixMap) {
            if (prefixMap.hasOwnProperty(styleProp) && styleProp in style2) {
              return prefixedEventNames2[eventName] = prefixMap[styleProp];
            }
          }
          return eventName;
        }
        var TOP_ABORT = unsafeCastStringToDOMTopLevelType("abort");
        var TOP_ANIMATION_END = unsafeCastStringToDOMTopLevelType(getVendorPrefixedEventName2("animationend"));
        var TOP_ANIMATION_ITERATION = unsafeCastStringToDOMTopLevelType(getVendorPrefixedEventName2("animationiteration"));
        var TOP_ANIMATION_START = unsafeCastStringToDOMTopLevelType(getVendorPrefixedEventName2("animationstart"));
        var TOP_BLUR = unsafeCastStringToDOMTopLevelType("blur");
        var TOP_CAN_PLAY = unsafeCastStringToDOMTopLevelType("canplay");
        var TOP_CAN_PLAY_THROUGH = unsafeCastStringToDOMTopLevelType("canplaythrough");
        var TOP_CANCEL = unsafeCastStringToDOMTopLevelType("cancel");
        var TOP_CHANGE = unsafeCastStringToDOMTopLevelType("change");
        var TOP_CLICK = unsafeCastStringToDOMTopLevelType("click");
        var TOP_CLOSE = unsafeCastStringToDOMTopLevelType("close");
        var TOP_COMPOSITION_END = unsafeCastStringToDOMTopLevelType("compositionend");
        var TOP_COMPOSITION_START = unsafeCastStringToDOMTopLevelType("compositionstart");
        var TOP_COMPOSITION_UPDATE = unsafeCastStringToDOMTopLevelType("compositionupdate");
        var TOP_CONTEXT_MENU = unsafeCastStringToDOMTopLevelType("contextmenu");
        var TOP_COPY = unsafeCastStringToDOMTopLevelType("copy");
        var TOP_CUT = unsafeCastStringToDOMTopLevelType("cut");
        var TOP_DOUBLE_CLICK = unsafeCastStringToDOMTopLevelType("dblclick");
        var TOP_AUX_CLICK = unsafeCastStringToDOMTopLevelType("auxclick");
        var TOP_DRAG = unsafeCastStringToDOMTopLevelType("drag");
        var TOP_DRAG_END = unsafeCastStringToDOMTopLevelType("dragend");
        var TOP_DRAG_ENTER = unsafeCastStringToDOMTopLevelType("dragenter");
        var TOP_DRAG_EXIT = unsafeCastStringToDOMTopLevelType("dragexit");
        var TOP_DRAG_LEAVE = unsafeCastStringToDOMTopLevelType("dragleave");
        var TOP_DRAG_OVER = unsafeCastStringToDOMTopLevelType("dragover");
        var TOP_DRAG_START = unsafeCastStringToDOMTopLevelType("dragstart");
        var TOP_DROP = unsafeCastStringToDOMTopLevelType("drop");
        var TOP_DURATION_CHANGE = unsafeCastStringToDOMTopLevelType("durationchange");
        var TOP_EMPTIED = unsafeCastStringToDOMTopLevelType("emptied");
        var TOP_ENCRYPTED = unsafeCastStringToDOMTopLevelType("encrypted");
        var TOP_ENDED = unsafeCastStringToDOMTopLevelType("ended");
        var TOP_ERROR = unsafeCastStringToDOMTopLevelType("error");
        var TOP_FOCUS = unsafeCastStringToDOMTopLevelType("focus");
        var TOP_GOT_POINTER_CAPTURE = unsafeCastStringToDOMTopLevelType("gotpointercapture");
        var TOP_INPUT = unsafeCastStringToDOMTopLevelType("input");
        var TOP_INVALID = unsafeCastStringToDOMTopLevelType("invalid");
        var TOP_KEY_DOWN = unsafeCastStringToDOMTopLevelType("keydown");
        var TOP_KEY_PRESS = unsafeCastStringToDOMTopLevelType("keypress");
        var TOP_KEY_UP = unsafeCastStringToDOMTopLevelType("keyup");
        var TOP_LOAD = unsafeCastStringToDOMTopLevelType("load");
        var TOP_LOAD_START = unsafeCastStringToDOMTopLevelType("loadstart");
        var TOP_LOADED_DATA = unsafeCastStringToDOMTopLevelType("loadeddata");
        var TOP_LOADED_METADATA = unsafeCastStringToDOMTopLevelType("loadedmetadata");
        var TOP_LOST_POINTER_CAPTURE = unsafeCastStringToDOMTopLevelType("lostpointercapture");
        var TOP_MOUSE_DOWN = unsafeCastStringToDOMTopLevelType("mousedown");
        var TOP_MOUSE_MOVE = unsafeCastStringToDOMTopLevelType("mousemove");
        var TOP_MOUSE_OUT = unsafeCastStringToDOMTopLevelType("mouseout");
        var TOP_MOUSE_OVER = unsafeCastStringToDOMTopLevelType("mouseover");
        var TOP_MOUSE_UP = unsafeCastStringToDOMTopLevelType("mouseup");
        var TOP_PASTE = unsafeCastStringToDOMTopLevelType("paste");
        var TOP_PAUSE = unsafeCastStringToDOMTopLevelType("pause");
        var TOP_PLAY = unsafeCastStringToDOMTopLevelType("play");
        var TOP_PLAYING = unsafeCastStringToDOMTopLevelType("playing");
        var TOP_POINTER_CANCEL = unsafeCastStringToDOMTopLevelType("pointercancel");
        var TOP_POINTER_DOWN = unsafeCastStringToDOMTopLevelType("pointerdown");
        var TOP_POINTER_MOVE = unsafeCastStringToDOMTopLevelType("pointermove");
        var TOP_POINTER_OUT = unsafeCastStringToDOMTopLevelType("pointerout");
        var TOP_POINTER_OVER = unsafeCastStringToDOMTopLevelType("pointerover");
        var TOP_POINTER_UP = unsafeCastStringToDOMTopLevelType("pointerup");
        var TOP_PROGRESS = unsafeCastStringToDOMTopLevelType("progress");
        var TOP_RATE_CHANGE = unsafeCastStringToDOMTopLevelType("ratechange");
        var TOP_RESET = unsafeCastStringToDOMTopLevelType("reset");
        var TOP_SCROLL = unsafeCastStringToDOMTopLevelType("scroll");
        var TOP_SEEKED = unsafeCastStringToDOMTopLevelType("seeked");
        var TOP_SEEKING = unsafeCastStringToDOMTopLevelType("seeking");
        var TOP_SELECTION_CHANGE = unsafeCastStringToDOMTopLevelType("selectionchange");
        var TOP_STALLED = unsafeCastStringToDOMTopLevelType("stalled");
        var TOP_SUBMIT = unsafeCastStringToDOMTopLevelType("submit");
        var TOP_SUSPEND = unsafeCastStringToDOMTopLevelType("suspend");
        var TOP_TEXT_INPUT = unsafeCastStringToDOMTopLevelType("textInput");
        var TOP_TIME_UPDATE = unsafeCastStringToDOMTopLevelType("timeupdate");
        var TOP_TOGGLE = unsafeCastStringToDOMTopLevelType("toggle");
        var TOP_TOUCH_CANCEL = unsafeCastStringToDOMTopLevelType("touchcancel");
        var TOP_TOUCH_END = unsafeCastStringToDOMTopLevelType("touchend");
        var TOP_TOUCH_MOVE = unsafeCastStringToDOMTopLevelType("touchmove");
        var TOP_TOUCH_START = unsafeCastStringToDOMTopLevelType("touchstart");
        var TOP_TRANSITION_END = unsafeCastStringToDOMTopLevelType(getVendorPrefixedEventName2("transitionend"));
        var TOP_VOLUME_CHANGE = unsafeCastStringToDOMTopLevelType("volumechange");
        var TOP_WAITING = unsafeCastStringToDOMTopLevelType("waiting");
        var TOP_WHEEL = unsafeCastStringToDOMTopLevelType("wheel");
        var mediaEventTypes = [TOP_ABORT, TOP_CAN_PLAY, TOP_CAN_PLAY_THROUGH, TOP_DURATION_CHANGE, TOP_EMPTIED, TOP_ENCRYPTED, TOP_ENDED, TOP_ERROR, TOP_LOADED_DATA, TOP_LOADED_METADATA, TOP_LOAD_START, TOP_PAUSE, TOP_PLAY, TOP_PLAYING, TOP_PROGRESS, TOP_RATE_CHANGE, TOP_SEEKED, TOP_SEEKING, TOP_STALLED, TOP_SUSPEND, TOP_TIME_UPDATE, TOP_VOLUME_CHANGE, TOP_WAITING];
        function getRawEventName(topLevelType) {
          return unsafeCastDOMTopLevelTypeToString(topLevelType);
        }
        var PossiblyWeakMap = typeof WeakMap === "function" ? WeakMap : Map;
        var elementListenerMap = new PossiblyWeakMap();
        function getListenerMapForElement(element) {
          var listenerMap = elementListenerMap.get(element);
          if (listenerMap === void 0) {
            listenerMap = /* @__PURE__ */ new Map();
            elementListenerMap.set(element, listenerMap);
          }
          return listenerMap;
        }
        function get3(key2) {
          return key2._reactInternalFiber;
        }
        function has2(key2) {
          return key2._reactInternalFiber !== void 0;
        }
        function set4(key2, value) {
          key2._reactInternalFiber = value;
        }
        var NoEffect = (
          /*              */
          0
        );
        var PerformedWork = (
          /*         */
          1
        );
        var Placement = (
          /*             */
          2
        );
        var Update = (
          /*                */
          4
        );
        var PlacementAndUpdate = (
          /*    */
          6
        );
        var Deletion = (
          /*              */
          8
        );
        var ContentReset = (
          /*          */
          16
        );
        var Callback = (
          /*              */
          32
        );
        var DidCapture = (
          /*            */
          64
        );
        var Ref5 = (
          /*                   */
          128
        );
        var Snapshot = (
          /*              */
          256
        );
        var Passive = (
          /*               */
          512
        );
        var Hydrating = (
          /*             */
          1024
        );
        var HydratingAndUpdate = (
          /*    */
          1028
        );
        var LifecycleEffectMask = (
          /*   */
          932
        );
        var HostEffectMask = (
          /*        */
          2047
        );
        var Incomplete = (
          /*            */
          2048
        );
        var ShouldCapture = (
          /*         */
          4096
        );
        var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
        function getNearestMountedFiber(fiber) {
          var node2 = fiber;
          var nearestMounted = fiber;
          if (!fiber.alternate) {
            var nextNode = node2;
            do {
              node2 = nextNode;
              if ((node2.effectTag & (Placement | Hydrating)) !== NoEffect) {
                nearestMounted = node2.return;
              }
              nextNode = node2.return;
            } while (nextNode);
          } else {
            while (node2.return) {
              node2 = node2.return;
            }
          }
          if (node2.tag === HostRoot) {
            return nearestMounted;
          }
          return null;
        }
        function getSuspenseInstanceFromFiber(fiber) {
          if (fiber.tag === SuspenseComponent) {
            var suspenseState = fiber.memoizedState;
            if (suspenseState === null) {
              var current3 = fiber.alternate;
              if (current3 !== null) {
                suspenseState = current3.memoizedState;
              }
            }
            if (suspenseState !== null) {
              return suspenseState.dehydrated;
            }
          }
          return null;
        }
        function getContainerFromFiber(fiber) {
          return fiber.tag === HostRoot ? fiber.stateNode.containerInfo : null;
        }
        function isFiberMounted(fiber) {
          return getNearestMountedFiber(fiber) === fiber;
        }
        function isMounted(component) {
          {
            var owner = ReactCurrentOwner.current;
            if (owner !== null && owner.tag === ClassComponent) {
              var ownerFiber = owner;
              var instance = ownerFiber.stateNode;
              if (!instance._warnedAboutRefsInRender) {
                error2("%s is accessing isMounted inside its render() function. render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", getComponentName(ownerFiber.type) || "A component");
              }
              instance._warnedAboutRefsInRender = true;
            }
          }
          var fiber = get3(component);
          if (!fiber) {
            return false;
          }
          return getNearestMountedFiber(fiber) === fiber;
        }
        function assertIsMounted(fiber) {
          if (!(getNearestMountedFiber(fiber) === fiber)) {
            {
              throw Error("Unable to find node on an unmounted component.");
            }
          }
        }
        function findCurrentFiberUsingSlowPath(fiber) {
          var alternate = fiber.alternate;
          if (!alternate) {
            var nearestMounted = getNearestMountedFiber(fiber);
            if (!(nearestMounted !== null)) {
              {
                throw Error("Unable to find node on an unmounted component.");
              }
            }
            if (nearestMounted !== fiber) {
              return null;
            }
            return fiber;
          }
          var a = fiber;
          var b = alternate;
          while (true) {
            var parentA = a.return;
            if (parentA === null) {
              break;
            }
            var parentB = parentA.alternate;
            if (parentB === null) {
              var nextParent = parentA.return;
              if (nextParent !== null) {
                a = b = nextParent;
                continue;
              }
              break;
            }
            if (parentA.child === parentB.child) {
              var child = parentA.child;
              while (child) {
                if (child === a) {
                  assertIsMounted(parentA);
                  return fiber;
                }
                if (child === b) {
                  assertIsMounted(parentA);
                  return alternate;
                }
                child = child.sibling;
              }
              {
                {
                  throw Error("Unable to find node on an unmounted component.");
                }
              }
            }
            if (a.return !== b.return) {
              a = parentA;
              b = parentB;
            } else {
              var didFindChild = false;
              var _child = parentA.child;
              while (_child) {
                if (_child === a) {
                  didFindChild = true;
                  a = parentA;
                  b = parentB;
                  break;
                }
                if (_child === b) {
                  didFindChild = true;
                  b = parentA;
                  a = parentB;
                  break;
                }
                _child = _child.sibling;
              }
              if (!didFindChild) {
                _child = parentB.child;
                while (_child) {
                  if (_child === a) {
                    didFindChild = true;
                    a = parentB;
                    b = parentA;
                    break;
                  }
                  if (_child === b) {
                    didFindChild = true;
                    b = parentB;
                    a = parentA;
                    break;
                  }
                  _child = _child.sibling;
                }
                if (!didFindChild) {
                  {
                    throw Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
                  }
                }
              }
            }
            if (!(a.alternate === b)) {
              {
                throw Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
              }
            }
          }
          if (!(a.tag === HostRoot)) {
            {
              throw Error("Unable to find node on an unmounted component.");
            }
          }
          if (a.stateNode.current === a) {
            return fiber;
          }
          return alternate;
        }
        function findCurrentHostFiber(parent2) {
          var currentParent = findCurrentFiberUsingSlowPath(parent2);
          if (!currentParent) {
            return null;
          }
          var node2 = currentParent;
          while (true) {
            if (node2.tag === HostComponent || node2.tag === HostText) {
              return node2;
            } else if (node2.child) {
              node2.child.return = node2;
              node2 = node2.child;
              continue;
            }
            if (node2 === currentParent) {
              return null;
            }
            while (!node2.sibling) {
              if (!node2.return || node2.return === currentParent) {
                return null;
              }
              node2 = node2.return;
            }
            node2.sibling.return = node2.return;
            node2 = node2.sibling;
          }
          return null;
        }
        function findCurrentHostFiberWithNoPortals(parent2) {
          var currentParent = findCurrentFiberUsingSlowPath(parent2);
          if (!currentParent) {
            return null;
          }
          var node2 = currentParent;
          while (true) {
            if (node2.tag === HostComponent || node2.tag === HostText || enableFundamentalAPI) {
              return node2;
            } else if (node2.child && node2.tag !== HostPortal) {
              node2.child.return = node2;
              node2 = node2.child;
              continue;
            }
            if (node2 === currentParent) {
              return null;
            }
            while (!node2.sibling) {
              if (!node2.return || node2.return === currentParent) {
                return null;
              }
              node2 = node2.return;
            }
            node2.sibling.return = node2.return;
            node2 = node2.sibling;
          }
          return null;
        }
        function accumulateInto(current3, next2) {
          if (!(next2 != null)) {
            {
              throw Error("accumulateInto(...): Accumulated items must not be null or undefined.");
            }
          }
          if (current3 == null) {
            return next2;
          }
          if (Array.isArray(current3)) {
            if (Array.isArray(next2)) {
              current3.push.apply(current3, next2);
              return current3;
            }
            current3.push(next2);
            return current3;
          }
          if (Array.isArray(next2)) {
            return [current3].concat(next2);
          }
          return [current3, next2];
        }
        function forEachAccumulated(arr, cb, scope) {
          if (Array.isArray(arr)) {
            arr.forEach(cb, scope);
          } else if (arr) {
            cb.call(scope, arr);
          }
        }
        var eventQueue = null;
        var executeDispatchesAndRelease = function(event) {
          if (event) {
            executeDispatchesInOrder(event);
            if (!event.isPersistent()) {
              event.constructor.release(event);
            }
          }
        };
        var executeDispatchesAndReleaseTopLevel = function(e3) {
          return executeDispatchesAndRelease(e3);
        };
        function runEventsInBatch(events2) {
          if (events2 !== null) {
            eventQueue = accumulateInto(eventQueue, events2);
          }
          var processingEventQueue = eventQueue;
          eventQueue = null;
          if (!processingEventQueue) {
            return;
          }
          forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
          if (!!eventQueue) {
            {
              throw Error("processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.");
            }
          }
          rethrowCaughtError();
        }
        function getEventTarget(nativeEvent) {
          var target = nativeEvent.target || nativeEvent.srcElement || window;
          if (target.correspondingUseElement) {
            target = target.correspondingUseElement;
          }
          return target.nodeType === TEXT_NODE ? target.parentNode : target;
        }
        function isEventSupported(eventNameSuffix) {
          if (!canUseDOM2) {
            return false;
          }
          var eventName = "on" + eventNameSuffix;
          var isSupported = eventName in document;
          if (!isSupported) {
            var element = document.createElement("div");
            element.setAttribute(eventName, "return;");
            isSupported = typeof element[eventName] === "function";
          }
          return isSupported;
        }
        var CALLBACK_BOOKKEEPING_POOL_SIZE = 10;
        var callbackBookkeepingPool = [];
        function releaseTopLevelCallbackBookKeeping(instance) {
          instance.topLevelType = null;
          instance.nativeEvent = null;
          instance.targetInst = null;
          instance.ancestors.length = 0;
          if (callbackBookkeepingPool.length < CALLBACK_BOOKKEEPING_POOL_SIZE) {
            callbackBookkeepingPool.push(instance);
          }
        }
        function getTopLevelCallbackBookKeeping(topLevelType, nativeEvent, targetInst, eventSystemFlags) {
          if (callbackBookkeepingPool.length) {
            var instance = callbackBookkeepingPool.pop();
            instance.topLevelType = topLevelType;
            instance.eventSystemFlags = eventSystemFlags;
            instance.nativeEvent = nativeEvent;
            instance.targetInst = targetInst;
            return instance;
          }
          return {
            topLevelType,
            eventSystemFlags,
            nativeEvent,
            targetInst,
            ancestors: []
          };
        }
        function findRootContainerNode(inst) {
          if (inst.tag === HostRoot) {
            return inst.stateNode.containerInfo;
          }
          while (inst.return) {
            inst = inst.return;
          }
          if (inst.tag !== HostRoot) {
            return null;
          }
          return inst.stateNode.containerInfo;
        }
        function extractPluginEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags) {
          var events2 = null;
          for (var i = 0; i < plugins.length; i++) {
            var possiblePlugin = plugins[i];
            if (possiblePlugin) {
              var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags);
              if (extractedEvents) {
                events2 = accumulateInto(events2, extractedEvents);
              }
            }
          }
          return events2;
        }
        function runExtractedPluginEventsInBatch(topLevelType, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags) {
          var events2 = extractPluginEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags);
          runEventsInBatch(events2);
        }
        function handleTopLevel(bookKeeping) {
          var targetInst = bookKeeping.targetInst;
          var ancestor = targetInst;
          do {
            if (!ancestor) {
              var ancestors = bookKeeping.ancestors;
              ancestors.push(ancestor);
              break;
            }
            var root3 = findRootContainerNode(ancestor);
            if (!root3) {
              break;
            }
            var tag = ancestor.tag;
            if (tag === HostComponent || tag === HostText) {
              bookKeeping.ancestors.push(ancestor);
            }
            ancestor = getClosestInstanceFromNode(root3);
          } while (ancestor);
          for (var i = 0; i < bookKeeping.ancestors.length; i++) {
            targetInst = bookKeeping.ancestors[i];
            var eventTarget = getEventTarget(bookKeeping.nativeEvent);
            var topLevelType = bookKeeping.topLevelType;
            var nativeEvent = bookKeeping.nativeEvent;
            var eventSystemFlags = bookKeeping.eventSystemFlags;
            if (i === 0) {
              eventSystemFlags |= IS_FIRST_ANCESTOR;
            }
            runExtractedPluginEventsInBatch(topLevelType, targetInst, nativeEvent, eventTarget, eventSystemFlags);
          }
        }
        function dispatchEventForLegacyPluginEventSystem(topLevelType, eventSystemFlags, nativeEvent, targetInst) {
          var bookKeeping = getTopLevelCallbackBookKeeping(topLevelType, nativeEvent, targetInst, eventSystemFlags);
          try {
            batchedEventUpdates(handleTopLevel, bookKeeping);
          } finally {
            releaseTopLevelCallbackBookKeeping(bookKeeping);
          }
        }
        function legacyListenToEvent(registrationName, mountAt) {
          var listenerMap = getListenerMapForElement(mountAt);
          var dependencies = registrationNameDependencies[registrationName];
          for (var i = 0; i < dependencies.length; i++) {
            var dependency = dependencies[i];
            legacyListenToTopLevelEvent(dependency, mountAt, listenerMap);
          }
        }
        function legacyListenToTopLevelEvent(topLevelType, mountAt, listenerMap) {
          if (!listenerMap.has(topLevelType)) {
            switch (topLevelType) {
              case TOP_SCROLL:
                trapCapturedEvent(TOP_SCROLL, mountAt);
                break;
              case TOP_FOCUS:
              case TOP_BLUR:
                trapCapturedEvent(TOP_FOCUS, mountAt);
                trapCapturedEvent(TOP_BLUR, mountAt);
                listenerMap.set(TOP_BLUR, null);
                listenerMap.set(TOP_FOCUS, null);
                break;
              case TOP_CANCEL:
              case TOP_CLOSE:
                if (isEventSupported(getRawEventName(topLevelType))) {
                  trapCapturedEvent(topLevelType, mountAt);
                }
                break;
              case TOP_INVALID:
              case TOP_SUBMIT:
              case TOP_RESET:
                break;
              default:
                var isMediaEvent = mediaEventTypes.indexOf(topLevelType) !== -1;
                if (!isMediaEvent) {
                  trapBubbledEvent(topLevelType, mountAt);
                }
                break;
            }
            listenerMap.set(topLevelType, null);
          }
        }
        function isListeningToAllDependencies(registrationName, mountAt) {
          var listenerMap = getListenerMapForElement(mountAt);
          var dependencies = registrationNameDependencies[registrationName];
          for (var i = 0; i < dependencies.length; i++) {
            var dependency = dependencies[i];
            if (!listenerMap.has(dependency)) {
              return false;
            }
          }
          return true;
        }
        var attemptUserBlockingHydration;
        function setAttemptUserBlockingHydration(fn) {
          attemptUserBlockingHydration = fn;
        }
        var attemptContinuousHydration;
        function setAttemptContinuousHydration(fn) {
          attemptContinuousHydration = fn;
        }
        var attemptHydrationAtCurrentPriority;
        function setAttemptHydrationAtCurrentPriority(fn) {
          attemptHydrationAtCurrentPriority = fn;
        }
        var hasScheduledReplayAttempt = false;
        var queuedDiscreteEvents = [];
        var queuedFocus = null;
        var queuedDrag = null;
        var queuedMouse = null;
        var queuedPointers = /* @__PURE__ */ new Map();
        var queuedPointerCaptures = /* @__PURE__ */ new Map();
        var queuedExplicitHydrationTargets = [];
        function hasQueuedDiscreteEvents() {
          return queuedDiscreteEvents.length > 0;
        }
        var discreteReplayableEvents = [TOP_MOUSE_DOWN, TOP_MOUSE_UP, TOP_TOUCH_CANCEL, TOP_TOUCH_END, TOP_TOUCH_START, TOP_AUX_CLICK, TOP_DOUBLE_CLICK, TOP_POINTER_CANCEL, TOP_POINTER_DOWN, TOP_POINTER_UP, TOP_DRAG_END, TOP_DRAG_START, TOP_DROP, TOP_COMPOSITION_END, TOP_COMPOSITION_START, TOP_KEY_DOWN, TOP_KEY_PRESS, TOP_KEY_UP, TOP_INPUT, TOP_TEXT_INPUT, TOP_CLOSE, TOP_CANCEL, TOP_COPY, TOP_CUT, TOP_PASTE, TOP_CLICK, TOP_CHANGE, TOP_CONTEXT_MENU, TOP_RESET, TOP_SUBMIT];
        var continuousReplayableEvents = [TOP_FOCUS, TOP_BLUR, TOP_DRAG_ENTER, TOP_DRAG_LEAVE, TOP_MOUSE_OVER, TOP_MOUSE_OUT, TOP_POINTER_OVER, TOP_POINTER_OUT, TOP_GOT_POINTER_CAPTURE, TOP_LOST_POINTER_CAPTURE];
        function isReplayableDiscreteEvent(eventType) {
          return discreteReplayableEvents.indexOf(eventType) > -1;
        }
        function trapReplayableEventForDocument(topLevelType, document2, listenerMap) {
          legacyListenToTopLevelEvent(topLevelType, document2, listenerMap);
        }
        function eagerlyTrapReplayableEvents(container, document2) {
          var listenerMapForDoc = getListenerMapForElement(document2);
          discreteReplayableEvents.forEach(function(topLevelType) {
            trapReplayableEventForDocument(topLevelType, document2, listenerMapForDoc);
          });
          continuousReplayableEvents.forEach(function(topLevelType) {
            trapReplayableEventForDocument(topLevelType, document2, listenerMapForDoc);
          });
        }
        function createQueuedReplayableEvent(blockedOn, topLevelType, eventSystemFlags, container, nativeEvent) {
          return {
            blockedOn,
            topLevelType,
            eventSystemFlags: eventSystemFlags | IS_REPLAYED,
            nativeEvent,
            container
          };
        }
        function queueDiscreteEvent(blockedOn, topLevelType, eventSystemFlags, container, nativeEvent) {
          var queuedEvent = createQueuedReplayableEvent(blockedOn, topLevelType, eventSystemFlags, container, nativeEvent);
          queuedDiscreteEvents.push(queuedEvent);
        }
        function clearIfContinuousEvent(topLevelType, nativeEvent) {
          switch (topLevelType) {
            case TOP_FOCUS:
            case TOP_BLUR:
              queuedFocus = null;
              break;
            case TOP_DRAG_ENTER:
            case TOP_DRAG_LEAVE:
              queuedDrag = null;
              break;
            case TOP_MOUSE_OVER:
            case TOP_MOUSE_OUT:
              queuedMouse = null;
              break;
            case TOP_POINTER_OVER:
            case TOP_POINTER_OUT: {
              var pointerId = nativeEvent.pointerId;
              queuedPointers.delete(pointerId);
              break;
            }
            case TOP_GOT_POINTER_CAPTURE:
            case TOP_LOST_POINTER_CAPTURE: {
              var _pointerId = nativeEvent.pointerId;
              queuedPointerCaptures.delete(_pointerId);
              break;
            }
          }
        }
        function accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, topLevelType, eventSystemFlags, container, nativeEvent) {
          if (existingQueuedEvent === null || existingQueuedEvent.nativeEvent !== nativeEvent) {
            var queuedEvent = createQueuedReplayableEvent(blockedOn, topLevelType, eventSystemFlags, container, nativeEvent);
            if (blockedOn !== null) {
              var _fiber2 = getInstanceFromNode$1(blockedOn);
              if (_fiber2 !== null) {
                attemptContinuousHydration(_fiber2);
              }
            }
            return queuedEvent;
          }
          existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
          return existingQueuedEvent;
        }
        function queueIfContinuousEvent(blockedOn, topLevelType, eventSystemFlags, container, nativeEvent) {
          switch (topLevelType) {
            case TOP_FOCUS: {
              var focusEvent = nativeEvent;
              queuedFocus = accumulateOrCreateContinuousQueuedReplayableEvent(queuedFocus, blockedOn, topLevelType, eventSystemFlags, container, focusEvent);
              return true;
            }
            case TOP_DRAG_ENTER: {
              var dragEvent = nativeEvent;
              queuedDrag = accumulateOrCreateContinuousQueuedReplayableEvent(queuedDrag, blockedOn, topLevelType, eventSystemFlags, container, dragEvent);
              return true;
            }
            case TOP_MOUSE_OVER: {
              var mouseEvent = nativeEvent;
              queuedMouse = accumulateOrCreateContinuousQueuedReplayableEvent(queuedMouse, blockedOn, topLevelType, eventSystemFlags, container, mouseEvent);
              return true;
            }
            case TOP_POINTER_OVER: {
              var pointerEvent = nativeEvent;
              var pointerId = pointerEvent.pointerId;
              queuedPointers.set(pointerId, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointers.get(pointerId) || null, blockedOn, topLevelType, eventSystemFlags, container, pointerEvent));
              return true;
            }
            case TOP_GOT_POINTER_CAPTURE: {
              var _pointerEvent = nativeEvent;
              var _pointerId2 = _pointerEvent.pointerId;
              queuedPointerCaptures.set(_pointerId2, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointerCaptures.get(_pointerId2) || null, blockedOn, topLevelType, eventSystemFlags, container, _pointerEvent));
              return true;
            }
          }
          return false;
        }
        function attemptExplicitHydrationTarget(queuedTarget) {
          var targetInst = getClosestInstanceFromNode(queuedTarget.target);
          if (targetInst !== null) {
            var nearestMounted = getNearestMountedFiber(targetInst);
            if (nearestMounted !== null) {
              var tag = nearestMounted.tag;
              if (tag === SuspenseComponent) {
                var instance = getSuspenseInstanceFromFiber(nearestMounted);
                if (instance !== null) {
                  queuedTarget.blockedOn = instance;
                  Scheduler.unstable_runWithPriority(queuedTarget.priority, function() {
                    attemptHydrationAtCurrentPriority(nearestMounted);
                  });
                  return;
                }
              } else if (tag === HostRoot) {
                var root3 = nearestMounted.stateNode;
                if (root3.hydrate) {
                  queuedTarget.blockedOn = getContainerFromFiber(nearestMounted);
                  return;
                }
              }
            }
          }
          queuedTarget.blockedOn = null;
        }
        function attemptReplayContinuousQueuedEvent(queuedEvent) {
          if (queuedEvent.blockedOn !== null) {
            return false;
          }
          var nextBlockedOn = attemptToDispatchEvent(queuedEvent.topLevelType, queuedEvent.eventSystemFlags, queuedEvent.container, queuedEvent.nativeEvent);
          if (nextBlockedOn !== null) {
            var _fiber3 = getInstanceFromNode$1(nextBlockedOn);
            if (_fiber3 !== null) {
              attemptContinuousHydration(_fiber3);
            }
            queuedEvent.blockedOn = nextBlockedOn;
            return false;
          }
          return true;
        }
        function attemptReplayContinuousQueuedEventInMap(queuedEvent, key2, map) {
          if (attemptReplayContinuousQueuedEvent(queuedEvent)) {
            map.delete(key2);
          }
        }
        function replayUnblockedEvents() {
          hasScheduledReplayAttempt = false;
          while (queuedDiscreteEvents.length > 0) {
            var nextDiscreteEvent = queuedDiscreteEvents[0];
            if (nextDiscreteEvent.blockedOn !== null) {
              var _fiber4 = getInstanceFromNode$1(nextDiscreteEvent.blockedOn);
              if (_fiber4 !== null) {
                attemptUserBlockingHydration(_fiber4);
              }
              break;
            }
            var nextBlockedOn = attemptToDispatchEvent(nextDiscreteEvent.topLevelType, nextDiscreteEvent.eventSystemFlags, nextDiscreteEvent.container, nextDiscreteEvent.nativeEvent);
            if (nextBlockedOn !== null) {
              nextDiscreteEvent.blockedOn = nextBlockedOn;
            } else {
              queuedDiscreteEvents.shift();
            }
          }
          if (queuedFocus !== null && attemptReplayContinuousQueuedEvent(queuedFocus)) {
            queuedFocus = null;
          }
          if (queuedDrag !== null && attemptReplayContinuousQueuedEvent(queuedDrag)) {
            queuedDrag = null;
          }
          if (queuedMouse !== null && attemptReplayContinuousQueuedEvent(queuedMouse)) {
            queuedMouse = null;
          }
          queuedPointers.forEach(attemptReplayContinuousQueuedEventInMap);
          queuedPointerCaptures.forEach(attemptReplayContinuousQueuedEventInMap);
        }
        function scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
          if (queuedEvent.blockedOn === unblocked) {
            queuedEvent.blockedOn = null;
            if (!hasScheduledReplayAttempt) {
              hasScheduledReplayAttempt = true;
              Scheduler.unstable_scheduleCallback(Scheduler.unstable_NormalPriority, replayUnblockedEvents);
            }
          }
        }
        function retryIfBlockedOn(unblocked) {
          if (queuedDiscreteEvents.length > 0) {
            scheduleCallbackIfUnblocked(queuedDiscreteEvents[0], unblocked);
            for (var i = 1; i < queuedDiscreteEvents.length; i++) {
              var queuedEvent = queuedDiscreteEvents[i];
              if (queuedEvent.blockedOn === unblocked) {
                queuedEvent.blockedOn = null;
              }
            }
          }
          if (queuedFocus !== null) {
            scheduleCallbackIfUnblocked(queuedFocus, unblocked);
          }
          if (queuedDrag !== null) {
            scheduleCallbackIfUnblocked(queuedDrag, unblocked);
          }
          if (queuedMouse !== null) {
            scheduleCallbackIfUnblocked(queuedMouse, unblocked);
          }
          var unblock = function(queuedEvent2) {
            return scheduleCallbackIfUnblocked(queuedEvent2, unblocked);
          };
          queuedPointers.forEach(unblock);
          queuedPointerCaptures.forEach(unblock);
          for (var _i = 0; _i < queuedExplicitHydrationTargets.length; _i++) {
            var queuedTarget = queuedExplicitHydrationTargets[_i];
            if (queuedTarget.blockedOn === unblocked) {
              queuedTarget.blockedOn = null;
            }
          }
          while (queuedExplicitHydrationTargets.length > 0) {
            var nextExplicitTarget = queuedExplicitHydrationTargets[0];
            if (nextExplicitTarget.blockedOn !== null) {
              break;
            } else {
              attemptExplicitHydrationTarget(nextExplicitTarget);
              if (nextExplicitTarget.blockedOn === null) {
                queuedExplicitHydrationTargets.shift();
              }
            }
          }
        }
        function addEventBubbleListener(element, eventType, listener) {
          element.addEventListener(eventType, listener, false);
        }
        function addEventCaptureListener(element, eventType, listener) {
          element.addEventListener(eventType, listener, true);
        }
        var simpleEventPluginEventTypes = {};
        var topLevelEventsToDispatchConfig = /* @__PURE__ */ new Map();
        var eventPriorities = /* @__PURE__ */ new Map();
        var discreteEventPairsForSimpleEventPlugin = [TOP_BLUR, "blur", TOP_CANCEL, "cancel", TOP_CLICK, "click", TOP_CLOSE, "close", TOP_CONTEXT_MENU, "contextMenu", TOP_COPY, "copy", TOP_CUT, "cut", TOP_AUX_CLICK, "auxClick", TOP_DOUBLE_CLICK, "doubleClick", TOP_DRAG_END, "dragEnd", TOP_DRAG_START, "dragStart", TOP_DROP, "drop", TOP_FOCUS, "focus", TOP_INPUT, "input", TOP_INVALID, "invalid", TOP_KEY_DOWN, "keyDown", TOP_KEY_PRESS, "keyPress", TOP_KEY_UP, "keyUp", TOP_MOUSE_DOWN, "mouseDown", TOP_MOUSE_UP, "mouseUp", TOP_PASTE, "paste", TOP_PAUSE, "pause", TOP_PLAY, "play", TOP_POINTER_CANCEL, "pointerCancel", TOP_POINTER_DOWN, "pointerDown", TOP_POINTER_UP, "pointerUp", TOP_RATE_CHANGE, "rateChange", TOP_RESET, "reset", TOP_SEEKED, "seeked", TOP_SUBMIT, "submit", TOP_TOUCH_CANCEL, "touchCancel", TOP_TOUCH_END, "touchEnd", TOP_TOUCH_START, "touchStart", TOP_VOLUME_CHANGE, "volumeChange"];
        var otherDiscreteEvents = [TOP_CHANGE, TOP_SELECTION_CHANGE, TOP_TEXT_INPUT, TOP_COMPOSITION_START, TOP_COMPOSITION_END, TOP_COMPOSITION_UPDATE];
        var userBlockingPairsForSimpleEventPlugin = [TOP_DRAG, "drag", TOP_DRAG_ENTER, "dragEnter", TOP_DRAG_EXIT, "dragExit", TOP_DRAG_LEAVE, "dragLeave", TOP_DRAG_OVER, "dragOver", TOP_MOUSE_MOVE, "mouseMove", TOP_MOUSE_OUT, "mouseOut", TOP_MOUSE_OVER, "mouseOver", TOP_POINTER_MOVE, "pointerMove", TOP_POINTER_OUT, "pointerOut", TOP_POINTER_OVER, "pointerOver", TOP_SCROLL, "scroll", TOP_TOGGLE, "toggle", TOP_TOUCH_MOVE, "touchMove", TOP_WHEEL, "wheel"];
        var continuousPairsForSimpleEventPlugin = [TOP_ABORT, "abort", TOP_ANIMATION_END, "animationEnd", TOP_ANIMATION_ITERATION, "animationIteration", TOP_ANIMATION_START, "animationStart", TOP_CAN_PLAY, "canPlay", TOP_CAN_PLAY_THROUGH, "canPlayThrough", TOP_DURATION_CHANGE, "durationChange", TOP_EMPTIED, "emptied", TOP_ENCRYPTED, "encrypted", TOP_ENDED, "ended", TOP_ERROR, "error", TOP_GOT_POINTER_CAPTURE, "gotPointerCapture", TOP_LOAD, "load", TOP_LOADED_DATA, "loadedData", TOP_LOADED_METADATA, "loadedMetadata", TOP_LOAD_START, "loadStart", TOP_LOST_POINTER_CAPTURE, "lostPointerCapture", TOP_PLAYING, "playing", TOP_PROGRESS, "progress", TOP_SEEKING, "seeking", TOP_STALLED, "stalled", TOP_SUSPEND, "suspend", TOP_TIME_UPDATE, "timeUpdate", TOP_TRANSITION_END, "transitionEnd", TOP_WAITING, "waiting"];
        function processSimpleEventPluginPairsByPriority(eventTypes2, priority) {
          for (var i = 0; i < eventTypes2.length; i += 2) {
            var topEvent = eventTypes2[i];
            var event = eventTypes2[i + 1];
            var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
            var onEvent = "on" + capitalizedEvent;
            var config = {
              phasedRegistrationNames: {
                bubbled: onEvent,
                captured: onEvent + "Capture"
              },
              dependencies: [topEvent],
              eventPriority: priority
            };
            eventPriorities.set(topEvent, priority);
            topLevelEventsToDispatchConfig.set(topEvent, config);
            simpleEventPluginEventTypes[event] = config;
          }
        }
        function processTopEventPairsByPriority(eventTypes2, priority) {
          for (var i = 0; i < eventTypes2.length; i++) {
            eventPriorities.set(eventTypes2[i], priority);
          }
        }
        processSimpleEventPluginPairsByPriority(discreteEventPairsForSimpleEventPlugin, DiscreteEvent);
        processSimpleEventPluginPairsByPriority(userBlockingPairsForSimpleEventPlugin, UserBlockingEvent);
        processSimpleEventPluginPairsByPriority(continuousPairsForSimpleEventPlugin, ContinuousEvent);
        processTopEventPairsByPriority(otherDiscreteEvents, DiscreteEvent);
        function getEventPriorityForPluginSystem(topLevelType) {
          var priority = eventPriorities.get(topLevelType);
          return priority === void 0 ? ContinuousEvent : priority;
        }
        var UserBlockingPriority = Scheduler.unstable_UserBlockingPriority, runWithPriority = Scheduler.unstable_runWithPriority;
        var _enabled = true;
        function setEnabled(enabled) {
          _enabled = !!enabled;
        }
        function isEnabled() {
          return _enabled;
        }
        function trapBubbledEvent(topLevelType, element) {
          trapEventForPluginEventSystem(element, topLevelType, false);
        }
        function trapCapturedEvent(topLevelType, element) {
          trapEventForPluginEventSystem(element, topLevelType, true);
        }
        function trapEventForPluginEventSystem(container, topLevelType, capture) {
          var listener;
          switch (getEventPriorityForPluginSystem(topLevelType)) {
            case DiscreteEvent:
              listener = dispatchDiscreteEvent.bind(null, topLevelType, PLUGIN_EVENT_SYSTEM, container);
              break;
            case UserBlockingEvent:
              listener = dispatchUserBlockingUpdate.bind(null, topLevelType, PLUGIN_EVENT_SYSTEM, container);
              break;
            case ContinuousEvent:
            default:
              listener = dispatchEvent.bind(null, topLevelType, PLUGIN_EVENT_SYSTEM, container);
              break;
          }
          var rawEventName = getRawEventName(topLevelType);
          if (capture) {
            addEventCaptureListener(container, rawEventName, listener);
          } else {
            addEventBubbleListener(container, rawEventName, listener);
          }
        }
        function dispatchDiscreteEvent(topLevelType, eventSystemFlags, container, nativeEvent) {
          flushDiscreteUpdatesIfNeeded(nativeEvent.timeStamp);
          discreteUpdates(dispatchEvent, topLevelType, eventSystemFlags, container, nativeEvent);
        }
        function dispatchUserBlockingUpdate(topLevelType, eventSystemFlags, container, nativeEvent) {
          runWithPriority(UserBlockingPriority, dispatchEvent.bind(null, topLevelType, eventSystemFlags, container, nativeEvent));
        }
        function dispatchEvent(topLevelType, eventSystemFlags, container, nativeEvent) {
          if (!_enabled) {
            return;
          }
          if (hasQueuedDiscreteEvents() && isReplayableDiscreteEvent(topLevelType)) {
            queueDiscreteEvent(
              null,
              // Flags that we're not actually blocked on anything as far as we know.
              topLevelType,
              eventSystemFlags,
              container,
              nativeEvent
            );
            return;
          }
          var blockedOn = attemptToDispatchEvent(topLevelType, eventSystemFlags, container, nativeEvent);
          if (blockedOn === null) {
            clearIfContinuousEvent(topLevelType, nativeEvent);
            return;
          }
          if (isReplayableDiscreteEvent(topLevelType)) {
            queueDiscreteEvent(blockedOn, topLevelType, eventSystemFlags, container, nativeEvent);
            return;
          }
          if (queueIfContinuousEvent(blockedOn, topLevelType, eventSystemFlags, container, nativeEvent)) {
            return;
          }
          clearIfContinuousEvent(topLevelType, nativeEvent);
          {
            dispatchEventForLegacyPluginEventSystem(topLevelType, eventSystemFlags, nativeEvent, null);
          }
        }
        function attemptToDispatchEvent(topLevelType, eventSystemFlags, container, nativeEvent) {
          var nativeEventTarget = getEventTarget(nativeEvent);
          var targetInst = getClosestInstanceFromNode(nativeEventTarget);
          if (targetInst !== null) {
            var nearestMounted = getNearestMountedFiber(targetInst);
            if (nearestMounted === null) {
              targetInst = null;
            } else {
              var tag = nearestMounted.tag;
              if (tag === SuspenseComponent) {
                var instance = getSuspenseInstanceFromFiber(nearestMounted);
                if (instance !== null) {
                  return instance;
                }
                targetInst = null;
              } else if (tag === HostRoot) {
                var root3 = nearestMounted.stateNode;
                if (root3.hydrate) {
                  return getContainerFromFiber(nearestMounted);
                }
                targetInst = null;
              } else if (nearestMounted !== targetInst) {
                targetInst = null;
              }
            }
          }
          {
            dispatchEventForLegacyPluginEventSystem(topLevelType, eventSystemFlags, nativeEvent, targetInst);
          }
          return null;
        }
        var shorthandToLonghand = {
          animation: ["animationDelay", "animationDirection", "animationDuration", "animationFillMode", "animationIterationCount", "animationName", "animationPlayState", "animationTimingFunction"],
          background: ["backgroundAttachment", "backgroundClip", "backgroundColor", "backgroundImage", "backgroundOrigin", "backgroundPositionX", "backgroundPositionY", "backgroundRepeat", "backgroundSize"],
          backgroundPosition: ["backgroundPositionX", "backgroundPositionY"],
          border: ["borderBottomColor", "borderBottomStyle", "borderBottomWidth", "borderImageOutset", "borderImageRepeat", "borderImageSlice", "borderImageSource", "borderImageWidth", "borderLeftColor", "borderLeftStyle", "borderLeftWidth", "borderRightColor", "borderRightStyle", "borderRightWidth", "borderTopColor", "borderTopStyle", "borderTopWidth"],
          borderBlockEnd: ["borderBlockEndColor", "borderBlockEndStyle", "borderBlockEndWidth"],
          borderBlockStart: ["borderBlockStartColor", "borderBlockStartStyle", "borderBlockStartWidth"],
          borderBottom: ["borderBottomColor", "borderBottomStyle", "borderBottomWidth"],
          borderColor: ["borderBottomColor", "borderLeftColor", "borderRightColor", "borderTopColor"],
          borderImage: ["borderImageOutset", "borderImageRepeat", "borderImageSlice", "borderImageSource", "borderImageWidth"],
          borderInlineEnd: ["borderInlineEndColor", "borderInlineEndStyle", "borderInlineEndWidth"],
          borderInlineStart: ["borderInlineStartColor", "borderInlineStartStyle", "borderInlineStartWidth"],
          borderLeft: ["borderLeftColor", "borderLeftStyle", "borderLeftWidth"],
          borderRadius: ["borderBottomLeftRadius", "borderBottomRightRadius", "borderTopLeftRadius", "borderTopRightRadius"],
          borderRight: ["borderRightColor", "borderRightStyle", "borderRightWidth"],
          borderStyle: ["borderBottomStyle", "borderLeftStyle", "borderRightStyle", "borderTopStyle"],
          borderTop: ["borderTopColor", "borderTopStyle", "borderTopWidth"],
          borderWidth: ["borderBottomWidth", "borderLeftWidth", "borderRightWidth", "borderTopWidth"],
          columnRule: ["columnRuleColor", "columnRuleStyle", "columnRuleWidth"],
          columns: ["columnCount", "columnWidth"],
          flex: ["flexBasis", "flexGrow", "flexShrink"],
          flexFlow: ["flexDirection", "flexWrap"],
          font: ["fontFamily", "fontFeatureSettings", "fontKerning", "fontLanguageOverride", "fontSize", "fontSizeAdjust", "fontStretch", "fontStyle", "fontVariant", "fontVariantAlternates", "fontVariantCaps", "fontVariantEastAsian", "fontVariantLigatures", "fontVariantNumeric", "fontVariantPosition", "fontWeight", "lineHeight"],
          fontVariant: ["fontVariantAlternates", "fontVariantCaps", "fontVariantEastAsian", "fontVariantLigatures", "fontVariantNumeric", "fontVariantPosition"],
          gap: ["columnGap", "rowGap"],
          grid: ["gridAutoColumns", "gridAutoFlow", "gridAutoRows", "gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"],
          gridArea: ["gridColumnEnd", "gridColumnStart", "gridRowEnd", "gridRowStart"],
          gridColumn: ["gridColumnEnd", "gridColumnStart"],
          gridColumnGap: ["columnGap"],
          gridGap: ["columnGap", "rowGap"],
          gridRow: ["gridRowEnd", "gridRowStart"],
          gridRowGap: ["rowGap"],
          gridTemplate: ["gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"],
          listStyle: ["listStyleImage", "listStylePosition", "listStyleType"],
          margin: ["marginBottom", "marginLeft", "marginRight", "marginTop"],
          marker: ["markerEnd", "markerMid", "markerStart"],
          mask: ["maskClip", "maskComposite", "maskImage", "maskMode", "maskOrigin", "maskPositionX", "maskPositionY", "maskRepeat", "maskSize"],
          maskPosition: ["maskPositionX", "maskPositionY"],
          outline: ["outlineColor", "outlineStyle", "outlineWidth"],
          overflow: ["overflowX", "overflowY"],
          padding: ["paddingBottom", "paddingLeft", "paddingRight", "paddingTop"],
          placeContent: ["alignContent", "justifyContent"],
          placeItems: ["alignItems", "justifyItems"],
          placeSelf: ["alignSelf", "justifySelf"],
          textDecoration: ["textDecorationColor", "textDecorationLine", "textDecorationStyle"],
          textEmphasis: ["textEmphasisColor", "textEmphasisStyle"],
          transition: ["transitionDelay", "transitionDuration", "transitionProperty", "transitionTimingFunction"],
          wordWrap: ["overflowWrap"]
        };
        var isUnitlessNumber = {
          animationIterationCount: true,
          borderImageOutset: true,
          borderImageSlice: true,
          borderImageWidth: true,
          boxFlex: true,
          boxFlexGroup: true,
          boxOrdinalGroup: true,
          columnCount: true,
          columns: true,
          flex: true,
          flexGrow: true,
          flexPositive: true,
          flexShrink: true,
          flexNegative: true,
          flexOrder: true,
          gridArea: true,
          gridRow: true,
          gridRowEnd: true,
          gridRowSpan: true,
          gridRowStart: true,
          gridColumn: true,
          gridColumnEnd: true,
          gridColumnSpan: true,
          gridColumnStart: true,
          fontWeight: true,
          lineClamp: true,
          lineHeight: true,
          opacity: true,
          order: true,
          orphans: true,
          tabSize: true,
          widows: true,
          zIndex: true,
          zoom: true,
          // SVG-related properties
          fillOpacity: true,
          floodOpacity: true,
          stopOpacity: true,
          strokeDasharray: true,
          strokeDashoffset: true,
          strokeMiterlimit: true,
          strokeOpacity: true,
          strokeWidth: true
        };
        function prefixKey(prefix3, key2) {
          return prefix3 + key2.charAt(0).toUpperCase() + key2.substring(1);
        }
        var prefixes = ["Webkit", "ms", "Moz", "O"];
        Object.keys(isUnitlessNumber).forEach(function(prop) {
          prefixes.forEach(function(prefix3) {
            isUnitlessNumber[prefixKey(prefix3, prop)] = isUnitlessNumber[prop];
          });
        });
        function dangerousStyleValue(name, value, isCustomProperty) {
          var isEmpty2 = value == null || typeof value === "boolean" || value === "";
          if (isEmpty2) {
            return "";
          }
          if (!isCustomProperty && typeof value === "number" && value !== 0 && !(isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name])) {
            return value + "px";
          }
          return ("" + value).trim();
        }
        var uppercasePattern = /([A-Z])/g;
        var msPattern = /^ms-/;
        function hyphenateStyleName(name) {
          return name.replace(uppercasePattern, "-$1").toLowerCase().replace(msPattern, "-ms-");
        }
        var warnValidStyle = function() {
        };
        {
          var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
          var msPattern$1 = /^-ms-/;
          var hyphenPattern = /-(.)/g;
          var badStyleValueWithSemicolonPattern = /;\s*$/;
          var warnedStyleNames = {};
          var warnedStyleValues = {};
          var warnedForNaNValue = false;
          var warnedForInfinityValue = false;
          var camelize2 = function(string3) {
            return string3.replace(hyphenPattern, function(_, character2) {
              return character2.toUpperCase();
            });
          };
          var warnHyphenatedStyleName = function(name) {
            if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
              return;
            }
            warnedStyleNames[name] = true;
            error2(
              "Unsupported style property %s. Did you mean %s?",
              name,
              // As Andi Smith suggests
              // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
              // is converted to lowercase `ms`.
              camelize2(name.replace(msPattern$1, "ms-"))
            );
          };
          var warnBadVendoredStyleName = function(name) {
            if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
              return;
            }
            warnedStyleNames[name] = true;
            error2("Unsupported vendor-prefixed style property %s. Did you mean %s?", name, name.charAt(0).toUpperCase() + name.slice(1));
          };
          var warnStyleValueWithSemicolon = function(name, value) {
            if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
              return;
            }
            warnedStyleValues[value] = true;
            error2(`Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`, name, value.replace(badStyleValueWithSemicolonPattern, ""));
          };
          var warnStyleValueIsNaN = function(name, value) {
            if (warnedForNaNValue) {
              return;
            }
            warnedForNaNValue = true;
            error2("`NaN` is an invalid value for the `%s` css style property.", name);
          };
          var warnStyleValueIsInfinity = function(name, value) {
            if (warnedForInfinityValue) {
              return;
            }
            warnedForInfinityValue = true;
            error2("`Infinity` is an invalid value for the `%s` css style property.", name);
          };
          warnValidStyle = function(name, value) {
            if (name.indexOf("-") > -1) {
              warnHyphenatedStyleName(name);
            } else if (badVendoredStyleNamePattern.test(name)) {
              warnBadVendoredStyleName(name);
            } else if (badStyleValueWithSemicolonPattern.test(value)) {
              warnStyleValueWithSemicolon(name, value);
            }
            if (typeof value === "number") {
              if (isNaN(value)) {
                warnStyleValueIsNaN(name, value);
              } else if (!isFinite(value)) {
                warnStyleValueIsInfinity(name, value);
              }
            }
          };
        }
        var warnValidStyle$1 = warnValidStyle;
        function createDangerousStringForStyles(styles) {
          {
            var serialized = "";
            var delimiter2 = "";
            for (var styleName in styles) {
              if (!styles.hasOwnProperty(styleName)) {
                continue;
              }
              var styleValue = styles[styleName];
              if (styleValue != null) {
                var isCustomProperty = styleName.indexOf("--") === 0;
                serialized += delimiter2 + (isCustomProperty ? styleName : hyphenateStyleName(styleName)) + ":";
                serialized += dangerousStyleValue(styleName, styleValue, isCustomProperty);
                delimiter2 = ";";
              }
            }
            return serialized || null;
          }
        }
        function setValueForStyles(node2, styles) {
          var style3 = node2.style;
          for (var styleName in styles) {
            if (!styles.hasOwnProperty(styleName)) {
              continue;
            }
            var isCustomProperty = styleName.indexOf("--") === 0;
            {
              if (!isCustomProperty) {
                warnValidStyle$1(styleName, styles[styleName]);
              }
            }
            var styleValue = dangerousStyleValue(styleName, styles[styleName], isCustomProperty);
            if (styleName === "float") {
              styleName = "cssFloat";
            }
            if (isCustomProperty) {
              style3.setProperty(styleName, styleValue);
            } else {
              style3[styleName] = styleValue;
            }
          }
        }
        function isValueEmpty(value) {
          return value == null || typeof value === "boolean" || value === "";
        }
        function expandShorthandMap(styles) {
          var expanded = {};
          for (var key2 in styles) {
            var longhands = shorthandToLonghand[key2] || [key2];
            for (var i = 0; i < longhands.length; i++) {
              expanded[longhands[i]] = key2;
            }
          }
          return expanded;
        }
        function validateShorthandPropertyCollisionInDev(styleUpdates, nextStyles) {
          {
            if (!nextStyles) {
              return;
            }
            var expandedUpdates = expandShorthandMap(styleUpdates);
            var expandedStyles = expandShorthandMap(nextStyles);
            var warnedAbout = {};
            for (var key2 in expandedUpdates) {
              var originalKey = expandedUpdates[key2];
              var correctOriginalKey = expandedStyles[key2];
              if (correctOriginalKey && originalKey !== correctOriginalKey) {
                var warningKey = originalKey + "," + correctOriginalKey;
                if (warnedAbout[warningKey]) {
                  continue;
                }
                warnedAbout[warningKey] = true;
                error2("%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.", isValueEmpty(styleUpdates[originalKey]) ? "Removing" : "Updating", originalKey, correctOriginalKey);
              }
            }
          }
        }
        var omittedCloseTags = {
          area: true,
          base: true,
          br: true,
          col: true,
          embed: true,
          hr: true,
          img: true,
          input: true,
          keygen: true,
          link: true,
          meta: true,
          param: true,
          source: true,
          track: true,
          wbr: true
          // NOTE: menuitem's close tag should be omitted, but that causes problems.
        };
        var voidElementTags = _assign({
          menuitem: true
        }, omittedCloseTags);
        var HTML = "__html";
        var ReactDebugCurrentFrame$3 = null;
        {
          ReactDebugCurrentFrame$3 = ReactSharedInternals.ReactDebugCurrentFrame;
        }
        function assertValidProps(tag, props) {
          if (!props) {
            return;
          }
          if (voidElementTags[tag]) {
            if (!(props.children == null && props.dangerouslySetInnerHTML == null)) {
              {
                throw Error(tag + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`." + ReactDebugCurrentFrame$3.getStackAddendum());
              }
            }
          }
          if (props.dangerouslySetInnerHTML != null) {
            if (!(props.children == null)) {
              {
                throw Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
              }
            }
            if (!(typeof props.dangerouslySetInnerHTML === "object" && HTML in props.dangerouslySetInnerHTML)) {
              {
                throw Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.");
              }
            }
          }
          {
            if (!props.suppressContentEditableWarning && props.contentEditable && props.children != null) {
              error2("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional.");
            }
          }
          if (!(props.style == null || typeof props.style === "object")) {
            {
              throw Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX." + ReactDebugCurrentFrame$3.getStackAddendum());
            }
          }
        }
        function isCustomComponent(tagName, props) {
          if (tagName.indexOf("-") === -1) {
            return typeof props.is === "string";
          }
          switch (tagName) {
            // These are reserved SVG and MathML elements.
            // We don't mind this whitelist too much because we expect it to never grow.
            // The alternative is to track the namespace in a few places which is convoluted.
            // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
            case "annotation-xml":
            case "color-profile":
            case "font-face":
            case "font-face-src":
            case "font-face-uri":
            case "font-face-format":
            case "font-face-name":
            case "missing-glyph":
              return false;
            default:
              return true;
          }
        }
        var possibleStandardNames = {
          // HTML
          accept: "accept",
          acceptcharset: "acceptCharset",
          "accept-charset": "acceptCharset",
          accesskey: "accessKey",
          action: "action",
          allowfullscreen: "allowFullScreen",
          alt: "alt",
          as: "as",
          async: "async",
          autocapitalize: "autoCapitalize",
          autocomplete: "autoComplete",
          autocorrect: "autoCorrect",
          autofocus: "autoFocus",
          autoplay: "autoPlay",
          autosave: "autoSave",
          capture: "capture",
          cellpadding: "cellPadding",
          cellspacing: "cellSpacing",
          challenge: "challenge",
          charset: "charSet",
          checked: "checked",
          children: "children",
          cite: "cite",
          class: "className",
          classid: "classID",
          classname: "className",
          cols: "cols",
          colspan: "colSpan",
          content: "content",
          contenteditable: "contentEditable",
          contextmenu: "contextMenu",
          controls: "controls",
          controlslist: "controlsList",
          coords: "coords",
          crossorigin: "crossOrigin",
          dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
          data: "data",
          datetime: "dateTime",
          default: "default",
          defaultchecked: "defaultChecked",
          defaultvalue: "defaultValue",
          defer: "defer",
          dir: "dir",
          disabled: "disabled",
          disablepictureinpicture: "disablePictureInPicture",
          download: "download",
          draggable: "draggable",
          enctype: "encType",
          for: "htmlFor",
          form: "form",
          formmethod: "formMethod",
          formaction: "formAction",
          formenctype: "formEncType",
          formnovalidate: "formNoValidate",
          formtarget: "formTarget",
          frameborder: "frameBorder",
          headers: "headers",
          height: "height",
          hidden: "hidden",
          high: "high",
          href: "href",
          hreflang: "hrefLang",
          htmlfor: "htmlFor",
          httpequiv: "httpEquiv",
          "http-equiv": "httpEquiv",
          icon: "icon",
          id: "id",
          innerhtml: "innerHTML",
          inputmode: "inputMode",
          integrity: "integrity",
          is: "is",
          itemid: "itemID",
          itemprop: "itemProp",
          itemref: "itemRef",
          itemscope: "itemScope",
          itemtype: "itemType",
          keyparams: "keyParams",
          keytype: "keyType",
          kind: "kind",
          label: "label",
          lang: "lang",
          list: "list",
          loop: "loop",
          low: "low",
          manifest: "manifest",
          marginwidth: "marginWidth",
          marginheight: "marginHeight",
          max: "max",
          maxlength: "maxLength",
          media: "media",
          mediagroup: "mediaGroup",
          method: "method",
          min: "min",
          minlength: "minLength",
          multiple: "multiple",
          muted: "muted",
          name: "name",
          nomodule: "noModule",
          nonce: "nonce",
          novalidate: "noValidate",
          open: "open",
          optimum: "optimum",
          pattern: "pattern",
          placeholder: "placeholder",
          playsinline: "playsInline",
          poster: "poster",
          preload: "preload",
          profile: "profile",
          radiogroup: "radioGroup",
          readonly: "readOnly",
          referrerpolicy: "referrerPolicy",
          rel: "rel",
          required: "required",
          reversed: "reversed",
          role: "role",
          rows: "rows",
          rowspan: "rowSpan",
          sandbox: "sandbox",
          scope: "scope",
          scoped: "scoped",
          scrolling: "scrolling",
          seamless: "seamless",
          selected: "selected",
          shape: "shape",
          size: "size",
          sizes: "sizes",
          span: "span",
          spellcheck: "spellCheck",
          src: "src",
          srcdoc: "srcDoc",
          srclang: "srcLang",
          srcset: "srcSet",
          start: "start",
          step: "step",
          style: "style",
          summary: "summary",
          tabindex: "tabIndex",
          target: "target",
          title: "title",
          type: "type",
          usemap: "useMap",
          value: "value",
          width: "width",
          wmode: "wmode",
          wrap: "wrap",
          // SVG
          about: "about",
          accentheight: "accentHeight",
          "accent-height": "accentHeight",
          accumulate: "accumulate",
          additive: "additive",
          alignmentbaseline: "alignmentBaseline",
          "alignment-baseline": "alignmentBaseline",
          allowreorder: "allowReorder",
          alphabetic: "alphabetic",
          amplitude: "amplitude",
          arabicform: "arabicForm",
          "arabic-form": "arabicForm",
          ascent: "ascent",
          attributename: "attributeName",
          attributetype: "attributeType",
          autoreverse: "autoReverse",
          azimuth: "azimuth",
          basefrequency: "baseFrequency",
          baselineshift: "baselineShift",
          "baseline-shift": "baselineShift",
          baseprofile: "baseProfile",
          bbox: "bbox",
          begin: "begin",
          bias: "bias",
          by: "by",
          calcmode: "calcMode",
          capheight: "capHeight",
          "cap-height": "capHeight",
          clip: "clip",
          clippath: "clipPath",
          "clip-path": "clipPath",
          clippathunits: "clipPathUnits",
          cliprule: "clipRule",
          "clip-rule": "clipRule",
          color: "color",
          colorinterpolation: "colorInterpolation",
          "color-interpolation": "colorInterpolation",
          colorinterpolationfilters: "colorInterpolationFilters",
          "color-interpolation-filters": "colorInterpolationFilters",
          colorprofile: "colorProfile",
          "color-profile": "colorProfile",
          colorrendering: "colorRendering",
          "color-rendering": "colorRendering",
          contentscripttype: "contentScriptType",
          contentstyletype: "contentStyleType",
          cursor: "cursor",
          cx: "cx",
          cy: "cy",
          d: "d",
          datatype: "datatype",
          decelerate: "decelerate",
          descent: "descent",
          diffuseconstant: "diffuseConstant",
          direction: "direction",
          display: "display",
          divisor: "divisor",
          dominantbaseline: "dominantBaseline",
          "dominant-baseline": "dominantBaseline",
          dur: "dur",
          dx: "dx",
          dy: "dy",
          edgemode: "edgeMode",
          elevation: "elevation",
          enablebackground: "enableBackground",
          "enable-background": "enableBackground",
          end: "end",
          exponent: "exponent",
          externalresourcesrequired: "externalResourcesRequired",
          fill: "fill",
          fillopacity: "fillOpacity",
          "fill-opacity": "fillOpacity",
          fillrule: "fillRule",
          "fill-rule": "fillRule",
          filter: "filter",
          filterres: "filterRes",
          filterunits: "filterUnits",
          floodopacity: "floodOpacity",
          "flood-opacity": "floodOpacity",
          floodcolor: "floodColor",
          "flood-color": "floodColor",
          focusable: "focusable",
          fontfamily: "fontFamily",
          "font-family": "fontFamily",
          fontsize: "fontSize",
          "font-size": "fontSize",
          fontsizeadjust: "fontSizeAdjust",
          "font-size-adjust": "fontSizeAdjust",
          fontstretch: "fontStretch",
          "font-stretch": "fontStretch",
          fontstyle: "fontStyle",
          "font-style": "fontStyle",
          fontvariant: "fontVariant",
          "font-variant": "fontVariant",
          fontweight: "fontWeight",
          "font-weight": "fontWeight",
          format: "format",
          from: "from",
          fx: "fx",
          fy: "fy",
          g1: "g1",
          g2: "g2",
          glyphname: "glyphName",
          "glyph-name": "glyphName",
          glyphorientationhorizontal: "glyphOrientationHorizontal",
          "glyph-orientation-horizontal": "glyphOrientationHorizontal",
          glyphorientationvertical: "glyphOrientationVertical",
          "glyph-orientation-vertical": "glyphOrientationVertical",
          glyphref: "glyphRef",
          gradienttransform: "gradientTransform",
          gradientunits: "gradientUnits",
          hanging: "hanging",
          horizadvx: "horizAdvX",
          "horiz-adv-x": "horizAdvX",
          horizoriginx: "horizOriginX",
          "horiz-origin-x": "horizOriginX",
          ideographic: "ideographic",
          imagerendering: "imageRendering",
          "image-rendering": "imageRendering",
          in2: "in2",
          in: "in",
          inlist: "inlist",
          intercept: "intercept",
          k1: "k1",
          k2: "k2",
          k3: "k3",
          k4: "k4",
          k: "k",
          kernelmatrix: "kernelMatrix",
          kernelunitlength: "kernelUnitLength",
          kerning: "kerning",
          keypoints: "keyPoints",
          keysplines: "keySplines",
          keytimes: "keyTimes",
          lengthadjust: "lengthAdjust",
          letterspacing: "letterSpacing",
          "letter-spacing": "letterSpacing",
          lightingcolor: "lightingColor",
          "lighting-color": "lightingColor",
          limitingconeangle: "limitingConeAngle",
          local: "local",
          markerend: "markerEnd",
          "marker-end": "markerEnd",
          markerheight: "markerHeight",
          markermid: "markerMid",
          "marker-mid": "markerMid",
          markerstart: "markerStart",
          "marker-start": "markerStart",
          markerunits: "markerUnits",
          markerwidth: "markerWidth",
          mask: "mask",
          maskcontentunits: "maskContentUnits",
          maskunits: "maskUnits",
          mathematical: "mathematical",
          mode: "mode",
          numoctaves: "numOctaves",
          offset: "offset",
          opacity: "opacity",
          operator: "operator",
          order: "order",
          orient: "orient",
          orientation: "orientation",
          origin: "origin",
          overflow: "overflow",
          overlineposition: "overlinePosition",
          "overline-position": "overlinePosition",
          overlinethickness: "overlineThickness",
          "overline-thickness": "overlineThickness",
          paintorder: "paintOrder",
          "paint-order": "paintOrder",
          panose1: "panose1",
          "panose-1": "panose1",
          pathlength: "pathLength",
          patterncontentunits: "patternContentUnits",
          patterntransform: "patternTransform",
          patternunits: "patternUnits",
          pointerevents: "pointerEvents",
          "pointer-events": "pointerEvents",
          points: "points",
          pointsatx: "pointsAtX",
          pointsaty: "pointsAtY",
          pointsatz: "pointsAtZ",
          prefix: "prefix",
          preservealpha: "preserveAlpha",
          preserveaspectratio: "preserveAspectRatio",
          primitiveunits: "primitiveUnits",
          property: "property",
          r: "r",
          radius: "radius",
          refx: "refX",
          refy: "refY",
          renderingintent: "renderingIntent",
          "rendering-intent": "renderingIntent",
          repeatcount: "repeatCount",
          repeatdur: "repeatDur",
          requiredextensions: "requiredExtensions",
          requiredfeatures: "requiredFeatures",
          resource: "resource",
          restart: "restart",
          result: "result",
          results: "results",
          rotate: "rotate",
          rx: "rx",
          ry: "ry",
          scale: "scale",
          security: "security",
          seed: "seed",
          shaperendering: "shapeRendering",
          "shape-rendering": "shapeRendering",
          slope: "slope",
          spacing: "spacing",
          specularconstant: "specularConstant",
          specularexponent: "specularExponent",
          speed: "speed",
          spreadmethod: "spreadMethod",
          startoffset: "startOffset",
          stddeviation: "stdDeviation",
          stemh: "stemh",
          stemv: "stemv",
          stitchtiles: "stitchTiles",
          stopcolor: "stopColor",
          "stop-color": "stopColor",
          stopopacity: "stopOpacity",
          "stop-opacity": "stopOpacity",
          strikethroughposition: "strikethroughPosition",
          "strikethrough-position": "strikethroughPosition",
          strikethroughthickness: "strikethroughThickness",
          "strikethrough-thickness": "strikethroughThickness",
          string: "string",
          stroke: "stroke",
          strokedasharray: "strokeDasharray",
          "stroke-dasharray": "strokeDasharray",
          strokedashoffset: "strokeDashoffset",
          "stroke-dashoffset": "strokeDashoffset",
          strokelinecap: "strokeLinecap",
          "stroke-linecap": "strokeLinecap",
          strokelinejoin: "strokeLinejoin",
          "stroke-linejoin": "strokeLinejoin",
          strokemiterlimit: "strokeMiterlimit",
          "stroke-miterlimit": "strokeMiterlimit",
          strokewidth: "strokeWidth",
          "stroke-width": "strokeWidth",
          strokeopacity: "strokeOpacity",
          "stroke-opacity": "strokeOpacity",
          suppresscontenteditablewarning: "suppressContentEditableWarning",
          suppresshydrationwarning: "suppressHydrationWarning",
          surfacescale: "surfaceScale",
          systemlanguage: "systemLanguage",
          tablevalues: "tableValues",
          targetx: "targetX",
          targety: "targetY",
          textanchor: "textAnchor",
          "text-anchor": "textAnchor",
          textdecoration: "textDecoration",
          "text-decoration": "textDecoration",
          textlength: "textLength",
          textrendering: "textRendering",
          "text-rendering": "textRendering",
          to: "to",
          transform: "transform",
          typeof: "typeof",
          u1: "u1",
          u2: "u2",
          underlineposition: "underlinePosition",
          "underline-position": "underlinePosition",
          underlinethickness: "underlineThickness",
          "underline-thickness": "underlineThickness",
          unicode: "unicode",
          unicodebidi: "unicodeBidi",
          "unicode-bidi": "unicodeBidi",
          unicoderange: "unicodeRange",
          "unicode-range": "unicodeRange",
          unitsperem: "unitsPerEm",
          "units-per-em": "unitsPerEm",
          unselectable: "unselectable",
          valphabetic: "vAlphabetic",
          "v-alphabetic": "vAlphabetic",
          values: "values",
          vectoreffect: "vectorEffect",
          "vector-effect": "vectorEffect",
          version: "version",
          vertadvy: "vertAdvY",
          "vert-adv-y": "vertAdvY",
          vertoriginx: "vertOriginX",
          "vert-origin-x": "vertOriginX",
          vertoriginy: "vertOriginY",
          "vert-origin-y": "vertOriginY",
          vhanging: "vHanging",
          "v-hanging": "vHanging",
          videographic: "vIdeographic",
          "v-ideographic": "vIdeographic",
          viewbox: "viewBox",
          viewtarget: "viewTarget",
          visibility: "visibility",
          vmathematical: "vMathematical",
          "v-mathematical": "vMathematical",
          vocab: "vocab",
          widths: "widths",
          wordspacing: "wordSpacing",
          "word-spacing": "wordSpacing",
          writingmode: "writingMode",
          "writing-mode": "writingMode",
          x1: "x1",
          x2: "x2",
          x: "x",
          xchannelselector: "xChannelSelector",
          xheight: "xHeight",
          "x-height": "xHeight",
          xlinkactuate: "xlinkActuate",
          "xlink:actuate": "xlinkActuate",
          xlinkarcrole: "xlinkArcrole",
          "xlink:arcrole": "xlinkArcrole",
          xlinkhref: "xlinkHref",
          "xlink:href": "xlinkHref",
          xlinkrole: "xlinkRole",
          "xlink:role": "xlinkRole",
          xlinkshow: "xlinkShow",
          "xlink:show": "xlinkShow",
          xlinktitle: "xlinkTitle",
          "xlink:title": "xlinkTitle",
          xlinktype: "xlinkType",
          "xlink:type": "xlinkType",
          xmlbase: "xmlBase",
          "xml:base": "xmlBase",
          xmllang: "xmlLang",
          "xml:lang": "xmlLang",
          xmlns: "xmlns",
          "xml:space": "xmlSpace",
          xmlnsxlink: "xmlnsXlink",
          "xmlns:xlink": "xmlnsXlink",
          xmlspace: "xmlSpace",
          y1: "y1",
          y2: "y2",
          y: "y",
          ychannelselector: "yChannelSelector",
          z: "z",
          zoomandpan: "zoomAndPan"
        };
        var ariaProperties = {
          "aria-current": 0,
          // state
          "aria-details": 0,
          "aria-disabled": 0,
          // state
          "aria-hidden": 0,
          // state
          "aria-invalid": 0,
          // state
          "aria-keyshortcuts": 0,
          "aria-label": 0,
          "aria-roledescription": 0,
          // Widget Attributes
          "aria-autocomplete": 0,
          "aria-checked": 0,
          "aria-expanded": 0,
          "aria-haspopup": 0,
          "aria-level": 0,
          "aria-modal": 0,
          "aria-multiline": 0,
          "aria-multiselectable": 0,
          "aria-orientation": 0,
          "aria-placeholder": 0,
          "aria-pressed": 0,
          "aria-readonly": 0,
          "aria-required": 0,
          "aria-selected": 0,
          "aria-sort": 0,
          "aria-valuemax": 0,
          "aria-valuemin": 0,
          "aria-valuenow": 0,
          "aria-valuetext": 0,
          // Live Region Attributes
          "aria-atomic": 0,
          "aria-busy": 0,
          "aria-live": 0,
          "aria-relevant": 0,
          // Drag-and-Drop Attributes
          "aria-dropeffect": 0,
          "aria-grabbed": 0,
          // Relationship Attributes
          "aria-activedescendant": 0,
          "aria-colcount": 0,
          "aria-colindex": 0,
          "aria-colspan": 0,
          "aria-controls": 0,
          "aria-describedby": 0,
          "aria-errormessage": 0,
          "aria-flowto": 0,
          "aria-labelledby": 0,
          "aria-owns": 0,
          "aria-posinset": 0,
          "aria-rowcount": 0,
          "aria-rowindex": 0,
          "aria-rowspan": 0,
          "aria-setsize": 0
        };
        var warnedProperties = {};
        var rARIA = new RegExp("^(aria)-[" + ATTRIBUTE_NAME_CHAR + "]*$");
        var rARIACamel = new RegExp("^(aria)[A-Z][" + ATTRIBUTE_NAME_CHAR + "]*$");
        var hasOwnProperty$1 = Object.prototype.hasOwnProperty;
        function validateProperty(tagName, name) {
          {
            if (hasOwnProperty$1.call(warnedProperties, name) && warnedProperties[name]) {
              return true;
            }
            if (rARIACamel.test(name)) {
              var ariaName = "aria-" + name.slice(4).toLowerCase();
              var correctName = ariaProperties.hasOwnProperty(ariaName) ? ariaName : null;
              if (correctName == null) {
                error2("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", name);
                warnedProperties[name] = true;
                return true;
              }
              if (name !== correctName) {
                error2("Invalid ARIA attribute `%s`. Did you mean `%s`?", name, correctName);
                warnedProperties[name] = true;
                return true;
              }
            }
            if (rARIA.test(name)) {
              var lowerCasedName = name.toLowerCase();
              var standardName = ariaProperties.hasOwnProperty(lowerCasedName) ? lowerCasedName : null;
              if (standardName == null) {
                warnedProperties[name] = true;
                return false;
              }
              if (name !== standardName) {
                error2("Unknown ARIA attribute `%s`. Did you mean `%s`?", name, standardName);
                warnedProperties[name] = true;
                return true;
              }
            }
          }
          return true;
        }
        function warnInvalidARIAProps(type5, props) {
          {
            var invalidProps = [];
            for (var key2 in props) {
              var isValid2 = validateProperty(type5, key2);
              if (!isValid2) {
                invalidProps.push(key2);
              }
            }
            var unknownPropString = invalidProps.map(function(prop) {
              return "`" + prop + "`";
            }).join(", ");
            if (invalidProps.length === 1) {
              error2("Invalid aria prop %s on <%s> tag. For details, see https://fb.me/invalid-aria-prop", unknownPropString, type5);
            } else if (invalidProps.length > 1) {
              error2("Invalid aria props %s on <%s> tag. For details, see https://fb.me/invalid-aria-prop", unknownPropString, type5);
            }
          }
        }
        function validateProperties(type5, props) {
          if (isCustomComponent(type5, props)) {
            return;
          }
          warnInvalidARIAProps(type5, props);
        }
        var didWarnValueNull = false;
        function validateProperties$1(type5, props) {
          {
            if (type5 !== "input" && type5 !== "textarea" && type5 !== "select") {
              return;
            }
            if (props != null && props.value === null && !didWarnValueNull) {
              didWarnValueNull = true;
              if (type5 === "select" && props.multiple) {
                error2("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", type5);
              } else {
                error2("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", type5);
              }
            }
          }
        }
        var validateProperty$1 = function() {
        };
        {
          var warnedProperties$1 = {};
          var _hasOwnProperty = Object.prototype.hasOwnProperty;
          var EVENT_NAME_REGEX = /^on./;
          var INVALID_EVENT_NAME_REGEX = /^on[^A-Z]/;
          var rARIA$1 = new RegExp("^(aria)-[" + ATTRIBUTE_NAME_CHAR + "]*$");
          var rARIACamel$1 = new RegExp("^(aria)[A-Z][" + ATTRIBUTE_NAME_CHAR + "]*$");
          validateProperty$1 = function(tagName, name, value, canUseEventSystem) {
            if (_hasOwnProperty.call(warnedProperties$1, name) && warnedProperties$1[name]) {
              return true;
            }
            var lowerCasedName = name.toLowerCase();
            if (lowerCasedName === "onfocusin" || lowerCasedName === "onfocusout") {
              error2("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React.");
              warnedProperties$1[name] = true;
              return true;
            }
            if (canUseEventSystem) {
              if (registrationNameModules.hasOwnProperty(name)) {
                return true;
              }
              var registrationName = possibleRegistrationNames.hasOwnProperty(lowerCasedName) ? possibleRegistrationNames[lowerCasedName] : null;
              if (registrationName != null) {
                error2("Invalid event handler property `%s`. Did you mean `%s`?", name, registrationName);
                warnedProperties$1[name] = true;
                return true;
              }
              if (EVENT_NAME_REGEX.test(name)) {
                error2("Unknown event handler property `%s`. It will be ignored.", name);
                warnedProperties$1[name] = true;
                return true;
              }
            } else if (EVENT_NAME_REGEX.test(name)) {
              if (INVALID_EVENT_NAME_REGEX.test(name)) {
                error2("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", name);
              }
              warnedProperties$1[name] = true;
              return true;
            }
            if (rARIA$1.test(name) || rARIACamel$1.test(name)) {
              return true;
            }
            if (lowerCasedName === "innerhtml") {
              error2("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`.");
              warnedProperties$1[name] = true;
              return true;
            }
            if (lowerCasedName === "aria") {
              error2("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead.");
              warnedProperties$1[name] = true;
              return true;
            }
            if (lowerCasedName === "is" && value !== null && value !== void 0 && typeof value !== "string") {
              error2("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof value);
              warnedProperties$1[name] = true;
              return true;
            }
            if (typeof value === "number" && isNaN(value)) {
              error2("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", name);
              warnedProperties$1[name] = true;
              return true;
            }
            var propertyInfo = getPropertyInfo(name);
            var isReserved = propertyInfo !== null && propertyInfo.type === RESERVED;
            if (possibleStandardNames.hasOwnProperty(lowerCasedName)) {
              var standardName = possibleStandardNames[lowerCasedName];
              if (standardName !== name) {
                error2("Invalid DOM property `%s`. Did you mean `%s`?", name, standardName);
                warnedProperties$1[name] = true;
                return true;
              }
            } else if (!isReserved && name !== lowerCasedName) {
              error2("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", name, lowerCasedName);
              warnedProperties$1[name] = true;
              return true;
            }
            if (typeof value === "boolean" && shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
              if (value) {
                error2('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', value, name, name, value, name);
              } else {
                error2('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', value, name, name, value, name, name, name);
              }
              warnedProperties$1[name] = true;
              return true;
            }
            if (isReserved) {
              return true;
            }
            if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
              warnedProperties$1[name] = true;
              return false;
            }
            if ((value === "false" || value === "true") && propertyInfo !== null && propertyInfo.type === BOOLEAN) {
              error2("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", value, name, value === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', name, value);
              warnedProperties$1[name] = true;
              return true;
            }
            return true;
          };
        }
        var warnUnknownProperties = function(type5, props, canUseEventSystem) {
          {
            var unknownProps = [];
            for (var key2 in props) {
              var isValid2 = validateProperty$1(type5, key2, props[key2], canUseEventSystem);
              if (!isValid2) {
                unknownProps.push(key2);
              }
            }
            var unknownPropString = unknownProps.map(function(prop) {
              return "`" + prop + "`";
            }).join(", ");
            if (unknownProps.length === 1) {
              error2("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://fb.me/react-attribute-behavior", unknownPropString, type5);
            } else if (unknownProps.length > 1) {
              error2("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://fb.me/react-attribute-behavior", unknownPropString, type5);
            }
          }
        };
        function validateProperties$2(type5, props, canUseEventSystem) {
          if (isCustomComponent(type5, props)) {
            return;
          }
          warnUnknownProperties(type5, props, canUseEventSystem);
        }
        var didWarnInvalidHydration = false;
        var DANGEROUSLY_SET_INNER_HTML = "dangerouslySetInnerHTML";
        var SUPPRESS_CONTENT_EDITABLE_WARNING = "suppressContentEditableWarning";
        var SUPPRESS_HYDRATION_WARNING = "suppressHydrationWarning";
        var AUTOFOCUS = "autoFocus";
        var CHILDREN = "children";
        var STYLE = "style";
        var HTML$1 = "__html";
        var HTML_NAMESPACE$1 = Namespaces.html;
        var warnedUnknownTags;
        var suppressHydrationWarning;
        var validatePropertiesInDevelopment;
        var warnForTextDifference;
        var warnForPropDifference;
        var warnForExtraAttributes;
        var warnForInvalidEventListener;
        var canDiffStyleForHydrationWarning;
        var normalizeMarkupForTextOrAttribute;
        var normalizeHTML;
        {
          warnedUnknownTags = {
            // Chrome is the only major browser not shipping <time>. But as of July
            // 2017 it intends to ship it due to widespread usage. We intentionally
            // *don't* warn for <time> even if it's unrecognized by Chrome because
            // it soon will be, and many apps have been using it anyway.
            time: true,
            // There are working polyfills for <dialog>. Let people use it.
            dialog: true,
            // Electron ships a custom <webview> tag to display external web content in
            // an isolated frame and process.
            // This tag is not present in non Electron environments such as JSDom which
            // is often used for testing purposes.
            // @see https://electronjs.org/docs/api/webview-tag
            webview: true
          };
          validatePropertiesInDevelopment = function(type5, props) {
            validateProperties(type5, props);
            validateProperties$1(type5, props);
            validateProperties$2(
              type5,
              props,
              /* canUseEventSystem */
              true
            );
          };
          canDiffStyleForHydrationWarning = canUseDOM2 && !document.documentMode;
          var NORMALIZE_NEWLINES_REGEX = /\r\n?/g;
          var NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
          normalizeMarkupForTextOrAttribute = function(markup) {
            var markupString = typeof markup === "string" ? markup : "" + markup;
            return markupString.replace(NORMALIZE_NEWLINES_REGEX, "\n").replace(NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
          };
          warnForTextDifference = function(serverText, clientText) {
            if (didWarnInvalidHydration) {
              return;
            }
            var normalizedClientText = normalizeMarkupForTextOrAttribute(clientText);
            var normalizedServerText = normalizeMarkupForTextOrAttribute(serverText);
            if (normalizedServerText === normalizedClientText) {
              return;
            }
            didWarnInvalidHydration = true;
            error2('Text content did not match. Server: "%s" Client: "%s"', normalizedServerText, normalizedClientText);
          };
          warnForPropDifference = function(propName, serverValue, clientValue) {
            if (didWarnInvalidHydration) {
              return;
            }
            var normalizedClientValue = normalizeMarkupForTextOrAttribute(clientValue);
            var normalizedServerValue = normalizeMarkupForTextOrAttribute(serverValue);
            if (normalizedServerValue === normalizedClientValue) {
              return;
            }
            didWarnInvalidHydration = true;
            error2("Prop `%s` did not match. Server: %s Client: %s", propName, JSON.stringify(normalizedServerValue), JSON.stringify(normalizedClientValue));
          };
          warnForExtraAttributes = function(attributeNames) {
            if (didWarnInvalidHydration) {
              return;
            }
            didWarnInvalidHydration = true;
            var names2 = [];
            attributeNames.forEach(function(name) {
              names2.push(name);
            });
            error2("Extra attributes from the server: %s", names2);
          };
          warnForInvalidEventListener = function(registrationName, listener) {
            if (listener === false) {
              error2("Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.", registrationName, registrationName, registrationName);
            } else {
              error2("Expected `%s` listener to be a function, instead got a value of `%s` type.", registrationName, typeof listener);
            }
          };
          normalizeHTML = function(parent2, html2) {
            var testElement = parent2.namespaceURI === HTML_NAMESPACE$1 ? parent2.ownerDocument.createElement(parent2.tagName) : parent2.ownerDocument.createElementNS(parent2.namespaceURI, parent2.tagName);
            testElement.innerHTML = html2;
            return testElement.innerHTML;
          };
        }
        function ensureListeningTo(rootContainerElement, registrationName) {
          var isDocumentOrFragment = rootContainerElement.nodeType === DOCUMENT_NODE || rootContainerElement.nodeType === DOCUMENT_FRAGMENT_NODE;
          var doc2 = isDocumentOrFragment ? rootContainerElement : rootContainerElement.ownerDocument;
          legacyListenToEvent(registrationName, doc2);
        }
        function getOwnerDocumentFromRootContainer(rootContainerElement) {
          return rootContainerElement.nodeType === DOCUMENT_NODE ? rootContainerElement : rootContainerElement.ownerDocument;
        }
        function noop7() {
        }
        function trapClickOnNonInteractiveElement(node2) {
          node2.onclick = noop7;
        }
        function setInitialDOMProperties(tag, domElement, rootContainerElement, nextProps, isCustomComponentTag) {
          for (var propKey in nextProps) {
            if (!nextProps.hasOwnProperty(propKey)) {
              continue;
            }
            var nextProp = nextProps[propKey];
            if (propKey === STYLE) {
              {
                if (nextProp) {
                  Object.freeze(nextProp);
                }
              }
              setValueForStyles(domElement, nextProp);
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
              var nextHtml = nextProp ? nextProp[HTML$1] : void 0;
              if (nextHtml != null) {
                setInnerHTML(domElement, nextHtml);
              }
            } else if (propKey === CHILDREN) {
              if (typeof nextProp === "string") {
                var canSetTextContent = tag !== "textarea" || nextProp !== "";
                if (canSetTextContent) {
                  setTextContent(domElement, nextProp);
                }
              } else if (typeof nextProp === "number") {
                setTextContent(domElement, "" + nextProp);
              }
            } else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;
            else if (propKey === AUTOFOCUS) ;
            else if (registrationNameModules.hasOwnProperty(propKey)) {
              if (nextProp != null) {
                if (typeof nextProp !== "function") {
                  warnForInvalidEventListener(propKey, nextProp);
                }
                ensureListeningTo(rootContainerElement, propKey);
              }
            } else if (nextProp != null) {
              setValueForProperty(domElement, propKey, nextProp, isCustomComponentTag);
            }
          }
        }
        function updateDOMProperties(domElement, updatePayload, wasCustomComponentTag, isCustomComponentTag) {
          for (var i = 0; i < updatePayload.length; i += 2) {
            var propKey = updatePayload[i];
            var propValue = updatePayload[i + 1];
            if (propKey === STYLE) {
              setValueForStyles(domElement, propValue);
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
              setInnerHTML(domElement, propValue);
            } else if (propKey === CHILDREN) {
              setTextContent(domElement, propValue);
            } else {
              setValueForProperty(domElement, propKey, propValue, isCustomComponentTag);
            }
          }
        }
        function createElement330(type5, props, rootContainerElement, parentNamespace) {
          var isCustomComponentTag;
          var ownerDocument = getOwnerDocumentFromRootContainer(rootContainerElement);
          var domElement;
          var namespaceURI = parentNamespace;
          if (namespaceURI === HTML_NAMESPACE$1) {
            namespaceURI = getIntrinsicNamespace(type5);
          }
          if (namespaceURI === HTML_NAMESPACE$1) {
            {
              isCustomComponentTag = isCustomComponent(type5, props);
              if (!isCustomComponentTag && type5 !== type5.toLowerCase()) {
                error2("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", type5);
              }
            }
            if (type5 === "script") {
              var div = ownerDocument.createElement("div");
              div.innerHTML = "<script><\/script>";
              var firstChild = div.firstChild;
              domElement = div.removeChild(firstChild);
            } else if (typeof props.is === "string") {
              domElement = ownerDocument.createElement(type5, {
                is: props.is
              });
            } else {
              domElement = ownerDocument.createElement(type5);
              if (type5 === "select") {
                var node2 = domElement;
                if (props.multiple) {
                  node2.multiple = true;
                } else if (props.size) {
                  node2.size = props.size;
                }
              }
            }
          } else {
            domElement = ownerDocument.createElementNS(namespaceURI, type5);
          }
          {
            if (namespaceURI === HTML_NAMESPACE$1) {
              if (!isCustomComponentTag && Object.prototype.toString.call(domElement) === "[object HTMLUnknownElement]" && !Object.prototype.hasOwnProperty.call(warnedUnknownTags, type5)) {
                warnedUnknownTags[type5] = true;
                error2("The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.", type5);
              }
            }
          }
          return domElement;
        }
        function createTextNode(text, rootContainerElement) {
          return getOwnerDocumentFromRootContainer(rootContainerElement).createTextNode(text);
        }
        function setInitialProperties(domElement, tag, rawProps, rootContainerElement) {
          var isCustomComponentTag = isCustomComponent(tag, rawProps);
          {
            validatePropertiesInDevelopment(tag, rawProps);
          }
          var props;
          switch (tag) {
            case "iframe":
            case "object":
            case "embed":
              trapBubbledEvent(TOP_LOAD, domElement);
              props = rawProps;
              break;
            case "video":
            case "audio":
              for (var i = 0; i < mediaEventTypes.length; i++) {
                trapBubbledEvent(mediaEventTypes[i], domElement);
              }
              props = rawProps;
              break;
            case "source":
              trapBubbledEvent(TOP_ERROR, domElement);
              props = rawProps;
              break;
            case "img":
            case "image":
            case "link":
              trapBubbledEvent(TOP_ERROR, domElement);
              trapBubbledEvent(TOP_LOAD, domElement);
              props = rawProps;
              break;
            case "form":
              trapBubbledEvent(TOP_RESET, domElement);
              trapBubbledEvent(TOP_SUBMIT, domElement);
              props = rawProps;
              break;
            case "details":
              trapBubbledEvent(TOP_TOGGLE, domElement);
              props = rawProps;
              break;
            case "input":
              initWrapperState(domElement, rawProps);
              props = getHostProps(domElement, rawProps);
              trapBubbledEvent(TOP_INVALID, domElement);
              ensureListeningTo(rootContainerElement, "onChange");
              break;
            case "option":
              validateProps(domElement, rawProps);
              props = getHostProps$1(domElement, rawProps);
              break;
            case "select":
              initWrapperState$1(domElement, rawProps);
              props = getHostProps$2(domElement, rawProps);
              trapBubbledEvent(TOP_INVALID, domElement);
              ensureListeningTo(rootContainerElement, "onChange");
              break;
            case "textarea":
              initWrapperState$2(domElement, rawProps);
              props = getHostProps$3(domElement, rawProps);
              trapBubbledEvent(TOP_INVALID, domElement);
              ensureListeningTo(rootContainerElement, "onChange");
              break;
            default:
              props = rawProps;
          }
          assertValidProps(tag, props);
          setInitialDOMProperties(tag, domElement, rootContainerElement, props, isCustomComponentTag);
          switch (tag) {
            case "input":
              track(domElement);
              postMountWrapper(domElement, rawProps, false);
              break;
            case "textarea":
              track(domElement);
              postMountWrapper$3(domElement);
              break;
            case "option":
              postMountWrapper$1(domElement, rawProps);
              break;
            case "select":
              postMountWrapper$2(domElement, rawProps);
              break;
            default:
              if (typeof props.onClick === "function") {
                trapClickOnNonInteractiveElement(domElement);
              }
              break;
          }
        }
        function diffProperties(domElement, tag, lastRawProps, nextRawProps, rootContainerElement) {
          {
            validatePropertiesInDevelopment(tag, nextRawProps);
          }
          var updatePayload = null;
          var lastProps;
          var nextProps;
          switch (tag) {
            case "input":
              lastProps = getHostProps(domElement, lastRawProps);
              nextProps = getHostProps(domElement, nextRawProps);
              updatePayload = [];
              break;
            case "option":
              lastProps = getHostProps$1(domElement, lastRawProps);
              nextProps = getHostProps$1(domElement, nextRawProps);
              updatePayload = [];
              break;
            case "select":
              lastProps = getHostProps$2(domElement, lastRawProps);
              nextProps = getHostProps$2(domElement, nextRawProps);
              updatePayload = [];
              break;
            case "textarea":
              lastProps = getHostProps$3(domElement, lastRawProps);
              nextProps = getHostProps$3(domElement, nextRawProps);
              updatePayload = [];
              break;
            default:
              lastProps = lastRawProps;
              nextProps = nextRawProps;
              if (typeof lastProps.onClick !== "function" && typeof nextProps.onClick === "function") {
                trapClickOnNonInteractiveElement(domElement);
              }
              break;
          }
          assertValidProps(tag, nextProps);
          var propKey;
          var styleName;
          var styleUpdates = null;
          for (propKey in lastProps) {
            if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
              continue;
            }
            if (propKey === STYLE) {
              var lastStyle = lastProps[propKey];
              for (styleName in lastStyle) {
                if (lastStyle.hasOwnProperty(styleName)) {
                  if (!styleUpdates) {
                    styleUpdates = {};
                  }
                  styleUpdates[styleName] = "";
                }
              }
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML || propKey === CHILDREN) ;
            else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;
            else if (propKey === AUTOFOCUS) ;
            else if (registrationNameModules.hasOwnProperty(propKey)) {
              if (!updatePayload) {
                updatePayload = [];
              }
            } else {
              (updatePayload = updatePayload || []).push(propKey, null);
            }
          }
          for (propKey in nextProps) {
            var nextProp = nextProps[propKey];
            var lastProp = lastProps != null ? lastProps[propKey] : void 0;
            if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
              continue;
            }
            if (propKey === STYLE) {
              {
                if (nextProp) {
                  Object.freeze(nextProp);
                }
              }
              if (lastProp) {
                for (styleName in lastProp) {
                  if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
                    if (!styleUpdates) {
                      styleUpdates = {};
                    }
                    styleUpdates[styleName] = "";
                  }
                }
                for (styleName in nextProp) {
                  if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
                    if (!styleUpdates) {
                      styleUpdates = {};
                    }
                    styleUpdates[styleName] = nextProp[styleName];
                  }
                }
              } else {
                if (!styleUpdates) {
                  if (!updatePayload) {
                    updatePayload = [];
                  }
                  updatePayload.push(propKey, styleUpdates);
                }
                styleUpdates = nextProp;
              }
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
              var nextHtml = nextProp ? nextProp[HTML$1] : void 0;
              var lastHtml = lastProp ? lastProp[HTML$1] : void 0;
              if (nextHtml != null) {
                if (lastHtml !== nextHtml) {
                  (updatePayload = updatePayload || []).push(propKey, nextHtml);
                }
              }
            } else if (propKey === CHILDREN) {
              if (lastProp !== nextProp && (typeof nextProp === "string" || typeof nextProp === "number")) {
                (updatePayload = updatePayload || []).push(propKey, "" + nextProp);
              }
            } else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;
            else if (registrationNameModules.hasOwnProperty(propKey)) {
              if (nextProp != null) {
                if (typeof nextProp !== "function") {
                  warnForInvalidEventListener(propKey, nextProp);
                }
                ensureListeningTo(rootContainerElement, propKey);
              }
              if (!updatePayload && lastProp !== nextProp) {
                updatePayload = [];
              }
            } else {
              (updatePayload = updatePayload || []).push(propKey, nextProp);
            }
          }
          if (styleUpdates) {
            {
              validateShorthandPropertyCollisionInDev(styleUpdates, nextProps[STYLE]);
            }
            (updatePayload = updatePayload || []).push(STYLE, styleUpdates);
          }
          return updatePayload;
        }
        function updateProperties(domElement, updatePayload, tag, lastRawProps, nextRawProps) {
          if (tag === "input" && nextRawProps.type === "radio" && nextRawProps.name != null) {
            updateChecked(domElement, nextRawProps);
          }
          var wasCustomComponentTag = isCustomComponent(tag, lastRawProps);
          var isCustomComponentTag = isCustomComponent(tag, nextRawProps);
          updateDOMProperties(domElement, updatePayload, wasCustomComponentTag, isCustomComponentTag);
          switch (tag) {
            case "input":
              updateWrapper(domElement, nextRawProps);
              break;
            case "textarea":
              updateWrapper$1(domElement, nextRawProps);
              break;
            case "select":
              postUpdateWrapper(domElement, nextRawProps);
              break;
          }
        }
        function getPossibleStandardName(propName) {
          {
            var lowerCasedName = propName.toLowerCase();
            if (!possibleStandardNames.hasOwnProperty(lowerCasedName)) {
              return null;
            }
            return possibleStandardNames[lowerCasedName] || null;
          }
        }
        function diffHydratedProperties(domElement, tag, rawProps, parentNamespace, rootContainerElement) {
          var isCustomComponentTag;
          var extraAttributeNames;
          {
            suppressHydrationWarning = rawProps[SUPPRESS_HYDRATION_WARNING] === true;
            isCustomComponentTag = isCustomComponent(tag, rawProps);
            validatePropertiesInDevelopment(tag, rawProps);
          }
          switch (tag) {
            case "iframe":
            case "object":
            case "embed":
              trapBubbledEvent(TOP_LOAD, domElement);
              break;
            case "video":
            case "audio":
              for (var i = 0; i < mediaEventTypes.length; i++) {
                trapBubbledEvent(mediaEventTypes[i], domElement);
              }
              break;
            case "source":
              trapBubbledEvent(TOP_ERROR, domElement);
              break;
            case "img":
            case "image":
            case "link":
              trapBubbledEvent(TOP_ERROR, domElement);
              trapBubbledEvent(TOP_LOAD, domElement);
              break;
            case "form":
              trapBubbledEvent(TOP_RESET, domElement);
              trapBubbledEvent(TOP_SUBMIT, domElement);
              break;
            case "details":
              trapBubbledEvent(TOP_TOGGLE, domElement);
              break;
            case "input":
              initWrapperState(domElement, rawProps);
              trapBubbledEvent(TOP_INVALID, domElement);
              ensureListeningTo(rootContainerElement, "onChange");
              break;
            case "option":
              validateProps(domElement, rawProps);
              break;
            case "select":
              initWrapperState$1(domElement, rawProps);
              trapBubbledEvent(TOP_INVALID, domElement);
              ensureListeningTo(rootContainerElement, "onChange");
              break;
            case "textarea":
              initWrapperState$2(domElement, rawProps);
              trapBubbledEvent(TOP_INVALID, domElement);
              ensureListeningTo(rootContainerElement, "onChange");
              break;
          }
          assertValidProps(tag, rawProps);
          {
            extraAttributeNames = /* @__PURE__ */ new Set();
            var attributes2 = domElement.attributes;
            for (var _i = 0; _i < attributes2.length; _i++) {
              var name = attributes2[_i].name.toLowerCase();
              switch (name) {
                // Built-in SSR attribute is whitelisted
                case "data-reactroot":
                  break;
                // Controlled attributes are not validated
                // TODO: Only ignore them on controlled tags.
                case "value":
                  break;
                case "checked":
                  break;
                case "selected":
                  break;
                default:
                  extraAttributeNames.add(attributes2[_i].name);
              }
            }
          }
          var updatePayload = null;
          for (var propKey in rawProps) {
            if (!rawProps.hasOwnProperty(propKey)) {
              continue;
            }
            var nextProp = rawProps[propKey];
            if (propKey === CHILDREN) {
              if (typeof nextProp === "string") {
                if (domElement.textContent !== nextProp) {
                  if (!suppressHydrationWarning) {
                    warnForTextDifference(domElement.textContent, nextProp);
                  }
                  updatePayload = [CHILDREN, nextProp];
                }
              } else if (typeof nextProp === "number") {
                if (domElement.textContent !== "" + nextProp) {
                  if (!suppressHydrationWarning) {
                    warnForTextDifference(domElement.textContent, nextProp);
                  }
                  updatePayload = [CHILDREN, "" + nextProp];
                }
              }
            } else if (registrationNameModules.hasOwnProperty(propKey)) {
              if (nextProp != null) {
                if (typeof nextProp !== "function") {
                  warnForInvalidEventListener(propKey, nextProp);
                }
                ensureListeningTo(rootContainerElement, propKey);
              }
            } else if (
              // Convince Flow we've calculated it (it's DEV-only in this method.)
              typeof isCustomComponentTag === "boolean"
            ) {
              var serverValue = void 0;
              var propertyInfo = getPropertyInfo(propKey);
              if (suppressHydrationWarning) ;
              else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING || // Controlled attributes are not validated
              // TODO: Only ignore them on controlled tags.
              propKey === "value" || propKey === "checked" || propKey === "selected") ;
              else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
                var serverHTML = domElement.innerHTML;
                var nextHtml = nextProp ? nextProp[HTML$1] : void 0;
                var expectedHTML = normalizeHTML(domElement, nextHtml != null ? nextHtml : "");
                if (expectedHTML !== serverHTML) {
                  warnForPropDifference(propKey, serverHTML, expectedHTML);
                }
              } else if (propKey === STYLE) {
                extraAttributeNames.delete(propKey);
                if (canDiffStyleForHydrationWarning) {
                  var expectedStyle = createDangerousStringForStyles(nextProp);
                  serverValue = domElement.getAttribute("style");
                  if (expectedStyle !== serverValue) {
                    warnForPropDifference(propKey, serverValue, expectedStyle);
                  }
                }
              } else if (isCustomComponentTag) {
                extraAttributeNames.delete(propKey.toLowerCase());
                serverValue = getValueForAttribute(domElement, propKey, nextProp);
                if (nextProp !== serverValue) {
                  warnForPropDifference(propKey, serverValue, nextProp);
                }
              } else if (!shouldIgnoreAttribute(propKey, propertyInfo, isCustomComponentTag) && !shouldRemoveAttribute(propKey, nextProp, propertyInfo, isCustomComponentTag)) {
                var isMismatchDueToBadCasing = false;
                if (propertyInfo !== null) {
                  extraAttributeNames.delete(propertyInfo.attributeName);
                  serverValue = getValueForProperty(domElement, propKey, nextProp, propertyInfo);
                } else {
                  var ownNamespace = parentNamespace;
                  if (ownNamespace === HTML_NAMESPACE$1) {
                    ownNamespace = getIntrinsicNamespace(tag);
                  }
                  if (ownNamespace === HTML_NAMESPACE$1) {
                    extraAttributeNames.delete(propKey.toLowerCase());
                  } else {
                    var standardName = getPossibleStandardName(propKey);
                    if (standardName !== null && standardName !== propKey) {
                      isMismatchDueToBadCasing = true;
                      extraAttributeNames.delete(standardName);
                    }
                    extraAttributeNames.delete(propKey);
                  }
                  serverValue = getValueForAttribute(domElement, propKey, nextProp);
                }
                if (nextProp !== serverValue && !isMismatchDueToBadCasing) {
                  warnForPropDifference(propKey, serverValue, nextProp);
                }
              }
            }
          }
          {
            if (extraAttributeNames.size > 0 && !suppressHydrationWarning) {
              warnForExtraAttributes(extraAttributeNames);
            }
          }
          switch (tag) {
            case "input":
              track(domElement);
              postMountWrapper(domElement, rawProps, true);
              break;
            case "textarea":
              track(domElement);
              postMountWrapper$3(domElement);
              break;
            case "select":
            case "option":
              break;
            default:
              if (typeof rawProps.onClick === "function") {
                trapClickOnNonInteractiveElement(domElement);
              }
              break;
          }
          return updatePayload;
        }
        function diffHydratedText(textNode, text) {
          var isDifferent = textNode.nodeValue !== text;
          return isDifferent;
        }
        function warnForUnmatchedText(textNode, text) {
          {
            warnForTextDifference(textNode.nodeValue, text);
          }
        }
        function warnForDeletedHydratableElement(parentNode, child) {
          {
            if (didWarnInvalidHydration) {
              return;
            }
            didWarnInvalidHydration = true;
            error2("Did not expect server HTML to contain a <%s> in <%s>.", child.nodeName.toLowerCase(), parentNode.nodeName.toLowerCase());
          }
        }
        function warnForDeletedHydratableText(parentNode, child) {
          {
            if (didWarnInvalidHydration) {
              return;
            }
            didWarnInvalidHydration = true;
            error2('Did not expect server HTML to contain the text node "%s" in <%s>.', child.nodeValue, parentNode.nodeName.toLowerCase());
          }
        }
        function warnForInsertedHydratedElement(parentNode, tag, props) {
          {
            if (didWarnInvalidHydration) {
              return;
            }
            didWarnInvalidHydration = true;
            error2("Expected server HTML to contain a matching <%s> in <%s>.", tag, parentNode.nodeName.toLowerCase());
          }
        }
        function warnForInsertedHydratedText(parentNode, text) {
          {
            if (text === "") {
              return;
            }
            if (didWarnInvalidHydration) {
              return;
            }
            didWarnInvalidHydration = true;
            error2('Expected server HTML to contain a matching text node for "%s" in <%s>.', text, parentNode.nodeName.toLowerCase());
          }
        }
        function restoreControlledState$3(domElement, tag, props) {
          switch (tag) {
            case "input":
              restoreControlledState(domElement, props);
              return;
            case "textarea":
              restoreControlledState$2(domElement, props);
              return;
            case "select":
              restoreControlledState$1(domElement, props);
              return;
          }
        }
        function getActiveElement(doc2) {
          doc2 = doc2 || (typeof document !== "undefined" ? document : void 0);
          if (typeof doc2 === "undefined") {
            return null;
          }
          try {
            return doc2.activeElement || doc2.body;
          } catch (e3) {
            return doc2.body;
          }
        }
        function getLeafNode(node2) {
          while (node2 && node2.firstChild) {
            node2 = node2.firstChild;
          }
          return node2;
        }
        function getSiblingNode(node2) {
          while (node2) {
            if (node2.nextSibling) {
              return node2.nextSibling;
            }
            node2 = node2.parentNode;
          }
        }
        function getNodeForCharacterOffset(root3, offset4) {
          var node2 = getLeafNode(root3);
          var nodeStart = 0;
          var nodeEnd = 0;
          while (node2) {
            if (node2.nodeType === TEXT_NODE) {
              nodeEnd = nodeStart + node2.textContent.length;
              if (nodeStart <= offset4 && nodeEnd >= offset4) {
                return {
                  node: node2,
                  offset: offset4 - nodeStart
                };
              }
              nodeStart = nodeEnd;
            }
            node2 = getLeafNode(getSiblingNode(node2));
          }
        }
        function getOffsets(outerNode) {
          var ownerDocument = outerNode.ownerDocument;
          var win = ownerDocument && ownerDocument.defaultView || window;
          var selection = win.getSelection && win.getSelection();
          if (!selection || selection.rangeCount === 0) {
            return null;
          }
          var anchorNode = selection.anchorNode, anchorOffset = selection.anchorOffset, focusNode = selection.focusNode, focusOffset = selection.focusOffset;
          try {
            anchorNode.nodeType;
            focusNode.nodeType;
          } catch (e3) {
            return null;
          }
          return getModernOffsetsFromPoints(outerNode, anchorNode, anchorOffset, focusNode, focusOffset);
        }
        function getModernOffsetsFromPoints(outerNode, anchorNode, anchorOffset, focusNode, focusOffset) {
          var length2 = 0;
          var start = -1;
          var end = -1;
          var indexWithinAnchor = 0;
          var indexWithinFocus = 0;
          var node2 = outerNode;
          var parentNode = null;
          outer: while (true) {
            var next2 = null;
            while (true) {
              if (node2 === anchorNode && (anchorOffset === 0 || node2.nodeType === TEXT_NODE)) {
                start = length2 + anchorOffset;
              }
              if (node2 === focusNode && (focusOffset === 0 || node2.nodeType === TEXT_NODE)) {
                end = length2 + focusOffset;
              }
              if (node2.nodeType === TEXT_NODE) {
                length2 += node2.nodeValue.length;
              }
              if ((next2 = node2.firstChild) === null) {
                break;
              }
              parentNode = node2;
              node2 = next2;
            }
            while (true) {
              if (node2 === outerNode) {
                break outer;
              }
              if (parentNode === anchorNode && ++indexWithinAnchor === anchorOffset) {
                start = length2;
              }
              if (parentNode === focusNode && ++indexWithinFocus === focusOffset) {
                end = length2;
              }
              if ((next2 = node2.nextSibling) !== null) {
                break;
              }
              node2 = parentNode;
              parentNode = node2.parentNode;
            }
            node2 = next2;
          }
          if (start === -1 || end === -1) {
            return null;
          }
          return {
            start,
            end
          };
        }
        function setOffsets(node2, offsets) {
          var doc2 = node2.ownerDocument || document;
          var win = doc2 && doc2.defaultView || window;
          if (!win.getSelection) {
            return;
          }
          var selection = win.getSelection();
          var length2 = node2.textContent.length;
          var start = Math.min(offsets.start, length2);
          var end = offsets.end === void 0 ? start : Math.min(offsets.end, length2);
          if (!selection.extend && start > end) {
            var temp = end;
            end = start;
            start = temp;
          }
          var startMarker = getNodeForCharacterOffset(node2, start);
          var endMarker = getNodeForCharacterOffset(node2, end);
          if (startMarker && endMarker) {
            if (selection.rangeCount === 1 && selection.anchorNode === startMarker.node && selection.anchorOffset === startMarker.offset && selection.focusNode === endMarker.node && selection.focusOffset === endMarker.offset) {
              return;
            }
            var range3 = doc2.createRange();
            range3.setStart(startMarker.node, startMarker.offset);
            selection.removeAllRanges();
            if (start > end) {
              selection.addRange(range3);
              selection.extend(endMarker.node, endMarker.offset);
            } else {
              range3.setEnd(endMarker.node, endMarker.offset);
              selection.addRange(range3);
            }
          }
        }
        function isTextNode(node2) {
          return node2 && node2.nodeType === TEXT_NODE;
        }
        function containsNode(outerNode, innerNode) {
          if (!outerNode || !innerNode) {
            return false;
          } else if (outerNode === innerNode) {
            return true;
          } else if (isTextNode(outerNode)) {
            return false;
          } else if (isTextNode(innerNode)) {
            return containsNode(outerNode, innerNode.parentNode);
          } else if ("contains" in outerNode) {
            return outerNode.contains(innerNode);
          } else if (outerNode.compareDocumentPosition) {
            return !!(outerNode.compareDocumentPosition(innerNode) & 16);
          } else {
            return false;
          }
        }
        function isInDocument(node2) {
          return node2 && node2.ownerDocument && containsNode(node2.ownerDocument.documentElement, node2);
        }
        function isSameOriginFrame(iframe) {
          try {
            return typeof iframe.contentWindow.location.href === "string";
          } catch (err) {
            return false;
          }
        }
        function getActiveElementDeep() {
          var win = window;
          var element = getActiveElement();
          while (element instanceof win.HTMLIFrameElement) {
            if (isSameOriginFrame(element)) {
              win = element.contentWindow;
            } else {
              return element;
            }
            element = getActiveElement(win.document);
          }
          return element;
        }
        function hasSelectionCapabilities(elem) {
          var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
          return nodeName && (nodeName === "input" && (elem.type === "text" || elem.type === "search" || elem.type === "tel" || elem.type === "url" || elem.type === "password") || nodeName === "textarea" || elem.contentEditable === "true");
        }
        function getSelectionInformation() {
          var focusedElem = getActiveElementDeep();
          return {
            // Used by Flare
            activeElementDetached: null,
            focusedElem,
            selectionRange: hasSelectionCapabilities(focusedElem) ? getSelection(focusedElem) : null
          };
        }
        function restoreSelection(priorSelectionInformation) {
          var curFocusedElem = getActiveElementDeep();
          var priorFocusedElem = priorSelectionInformation.focusedElem;
          var priorSelectionRange = priorSelectionInformation.selectionRange;
          if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
            if (priorSelectionRange !== null && hasSelectionCapabilities(priorFocusedElem)) {
              setSelection(priorFocusedElem, priorSelectionRange);
            }
            var ancestors = [];
            var ancestor = priorFocusedElem;
            while (ancestor = ancestor.parentNode) {
              if (ancestor.nodeType === ELEMENT_NODE) {
                ancestors.push({
                  element: ancestor,
                  left: ancestor.scrollLeft,
                  top: ancestor.scrollTop
                });
              }
            }
            if (typeof priorFocusedElem.focus === "function") {
              priorFocusedElem.focus();
            }
            for (var i = 0; i < ancestors.length; i++) {
              var info = ancestors[i];
              info.element.scrollLeft = info.left;
              info.element.scrollTop = info.top;
            }
          }
        }
        function getSelection(input) {
          var selection;
          if ("selectionStart" in input) {
            selection = {
              start: input.selectionStart,
              end: input.selectionEnd
            };
          } else {
            selection = getOffsets(input);
          }
          return selection || {
            start: 0,
            end: 0
          };
        }
        function setSelection(input, offsets) {
          var start = offsets.start, end = offsets.end;
          if (end === void 0) {
            end = start;
          }
          if ("selectionStart" in input) {
            input.selectionStart = start;
            input.selectionEnd = Math.min(end, input.value.length);
          } else {
            setOffsets(input, offsets);
          }
        }
        var validateDOMNesting = function() {
        };
        var updatedAncestorInfo = function() {
        };
        {
          var specialTags = ["address", "applet", "area", "article", "aside", "base", "basefont", "bgsound", "blockquote", "body", "br", "button", "caption", "center", "col", "colgroup", "dd", "details", "dir", "div", "dl", "dt", "embed", "fieldset", "figcaption", "figure", "footer", "form", "frame", "frameset", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "iframe", "img", "input", "isindex", "li", "link", "listing", "main", "marquee", "menu", "menuitem", "meta", "nav", "noembed", "noframes", "noscript", "object", "ol", "p", "param", "plaintext", "pre", "script", "section", "select", "source", "style", "summary", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "title", "tr", "track", "ul", "wbr", "xmp"];
          var inScopeTags = [
            "applet",
            "caption",
            "html",
            "table",
            "td",
            "th",
            "marquee",
            "object",
            "template",
            // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
            // TODO: Distinguish by namespace here -- for <title>, including it here
            // errs on the side of fewer warnings
            "foreignObject",
            "desc",
            "title"
          ];
          var buttonScopeTags = inScopeTags.concat(["button"]);
          var impliedEndTags = ["dd", "dt", "li", "option", "optgroup", "p", "rp", "rt"];
          var emptyAncestorInfo = {
            current: null,
            formTag: null,
            aTagInScope: null,
            buttonTagInScope: null,
            nobrTagInScope: null,
            pTagInButtonScope: null,
            listItemTagAutoclosing: null,
            dlItemTagAutoclosing: null
          };
          updatedAncestorInfo = function(oldInfo, tag) {
            var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
            var info = {
              tag
            };
            if (inScopeTags.indexOf(tag) !== -1) {
              ancestorInfo.aTagInScope = null;
              ancestorInfo.buttonTagInScope = null;
              ancestorInfo.nobrTagInScope = null;
            }
            if (buttonScopeTags.indexOf(tag) !== -1) {
              ancestorInfo.pTagInButtonScope = null;
            }
            if (specialTags.indexOf(tag) !== -1 && tag !== "address" && tag !== "div" && tag !== "p") {
              ancestorInfo.listItemTagAutoclosing = null;
              ancestorInfo.dlItemTagAutoclosing = null;
            }
            ancestorInfo.current = info;
            if (tag === "form") {
              ancestorInfo.formTag = info;
            }
            if (tag === "a") {
              ancestorInfo.aTagInScope = info;
            }
            if (tag === "button") {
              ancestorInfo.buttonTagInScope = info;
            }
            if (tag === "nobr") {
              ancestorInfo.nobrTagInScope = info;
            }
            if (tag === "p") {
              ancestorInfo.pTagInButtonScope = info;
            }
            if (tag === "li") {
              ancestorInfo.listItemTagAutoclosing = info;
            }
            if (tag === "dd" || tag === "dt") {
              ancestorInfo.dlItemTagAutoclosing = info;
            }
            return ancestorInfo;
          };
          var isTagValidWithParent = function(tag, parentTag) {
            switch (parentTag) {
              // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
              case "select":
                return tag === "option" || tag === "optgroup" || tag === "#text";
              case "optgroup":
                return tag === "option" || tag === "#text";
              // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
              // but
              case "option":
                return tag === "#text";
              // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
              // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
              // No special behavior since these rules fall back to "in body" mode for
              // all except special table nodes which cause bad parsing behavior anyway.
              // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
              case "tr":
                return tag === "th" || tag === "td" || tag === "style" || tag === "script" || tag === "template";
              // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
              case "tbody":
              case "thead":
              case "tfoot":
                return tag === "tr" || tag === "style" || tag === "script" || tag === "template";
              // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
              case "colgroup":
                return tag === "col" || tag === "template";
              // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
              case "table":
                return tag === "caption" || tag === "colgroup" || tag === "tbody" || tag === "tfoot" || tag === "thead" || tag === "style" || tag === "script" || tag === "template";
              // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
              case "head":
                return tag === "base" || tag === "basefont" || tag === "bgsound" || tag === "link" || tag === "meta" || tag === "title" || tag === "noscript" || tag === "noframes" || tag === "style" || tag === "script" || tag === "template";
              // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
              case "html":
                return tag === "head" || tag === "body" || tag === "frameset";
              case "frameset":
                return tag === "frame";
              case "#document":
                return tag === "html";
            }
            switch (tag) {
              case "h1":
              case "h2":
              case "h3":
              case "h4":
              case "h5":
              case "h6":
                return parentTag !== "h1" && parentTag !== "h2" && parentTag !== "h3" && parentTag !== "h4" && parentTag !== "h5" && parentTag !== "h6";
              case "rp":
              case "rt":
                return impliedEndTags.indexOf(parentTag) === -1;
              case "body":
              case "caption":
              case "col":
              case "colgroup":
              case "frameset":
              case "frame":
              case "head":
              case "html":
              case "tbody":
              case "td":
              case "tfoot":
              case "th":
              case "thead":
              case "tr":
                return parentTag == null;
            }
            return true;
          };
          var findInvalidAncestorForTag = function(tag, ancestorInfo) {
            switch (tag) {
              case "address":
              case "article":
              case "aside":
              case "blockquote":
              case "center":
              case "details":
              case "dialog":
              case "dir":
              case "div":
              case "dl":
              case "fieldset":
              case "figcaption":
              case "figure":
              case "footer":
              case "header":
              case "hgroup":
              case "main":
              case "menu":
              case "nav":
              case "ol":
              case "p":
              case "section":
              case "summary":
              case "ul":
              case "pre":
              case "listing":
              case "table":
              case "hr":
              case "xmp":
              case "h1":
              case "h2":
              case "h3":
              case "h4":
              case "h5":
              case "h6":
                return ancestorInfo.pTagInButtonScope;
              case "form":
                return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
              case "li":
                return ancestorInfo.listItemTagAutoclosing;
              case "dd":
              case "dt":
                return ancestorInfo.dlItemTagAutoclosing;
              case "button":
                return ancestorInfo.buttonTagInScope;
              case "a":
                return ancestorInfo.aTagInScope;
              case "nobr":
                return ancestorInfo.nobrTagInScope;
            }
            return null;
          };
          var didWarn$1 = {};
          validateDOMNesting = function(childTag, childText, ancestorInfo) {
            ancestorInfo = ancestorInfo || emptyAncestorInfo;
            var parentInfo = ancestorInfo.current;
            var parentTag = parentInfo && parentInfo.tag;
            if (childText != null) {
              if (childTag != null) {
                error2("validateDOMNesting: when childText is passed, childTag should be null");
              }
              childTag = "#text";
            }
            var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
            var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
            var invalidParentOrAncestor = invalidParent || invalidAncestor;
            if (!invalidParentOrAncestor) {
              return;
            }
            var ancestorTag = invalidParentOrAncestor.tag;
            var addendum = getCurrentFiberStackInDev();
            var warnKey = !!invalidParent + "|" + childTag + "|" + ancestorTag + "|" + addendum;
            if (didWarn$1[warnKey]) {
              return;
            }
            didWarn$1[warnKey] = true;
            var tagDisplayName = childTag;
            var whitespaceInfo = "";
            if (childTag === "#text") {
              if (/\S/.test(childText)) {
                tagDisplayName = "Text nodes";
              } else {
                tagDisplayName = "Whitespace text nodes";
                whitespaceInfo = " Make sure you don't have any extra whitespace between tags on each line of your source code.";
              }
            } else {
              tagDisplayName = "<" + childTag + ">";
            }
            if (invalidParent) {
              var info = "";
              if (ancestorTag === "table" && childTag === "tr") {
                info += " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser.";
              }
              error2("validateDOMNesting(...): %s cannot appear as a child of <%s>.%s%s", tagDisplayName, ancestorTag, whitespaceInfo, info);
            } else {
              error2("validateDOMNesting(...): %s cannot appear as a descendant of <%s>.", tagDisplayName, ancestorTag);
            }
          };
        }
        var SUPPRESS_HYDRATION_WARNING$1;
        {
          SUPPRESS_HYDRATION_WARNING$1 = "suppressHydrationWarning";
        }
        var SUSPENSE_START_DATA = "$";
        var SUSPENSE_END_DATA = "/$";
        var SUSPENSE_PENDING_START_DATA = "$?";
        var SUSPENSE_FALLBACK_START_DATA = "$!";
        var STYLE$1 = "style";
        var eventsEnabled = null;
        var selectionInformation = null;
        function shouldAutoFocusHostComponent(type5, props) {
          switch (type5) {
            case "button":
            case "input":
            case "select":
            case "textarea":
              return !!props.autoFocus;
          }
          return false;
        }
        function getRootHostContext(rootContainerInstance) {
          var type5;
          var namespace;
          var nodeType = rootContainerInstance.nodeType;
          switch (nodeType) {
            case DOCUMENT_NODE:
            case DOCUMENT_FRAGMENT_NODE: {
              type5 = nodeType === DOCUMENT_NODE ? "#document" : "#fragment";
              var root3 = rootContainerInstance.documentElement;
              namespace = root3 ? root3.namespaceURI : getChildNamespace(null, "");
              break;
            }
            default: {
              var container = nodeType === COMMENT_NODE ? rootContainerInstance.parentNode : rootContainerInstance;
              var ownNamespace = container.namespaceURI || null;
              type5 = container.tagName;
              namespace = getChildNamespace(ownNamespace, type5);
              break;
            }
          }
          {
            var validatedTag = type5.toLowerCase();
            var ancestorInfo = updatedAncestorInfo(null, validatedTag);
            return {
              namespace,
              ancestorInfo
            };
          }
        }
        function getChildHostContext(parentHostContext, type5, rootContainerInstance) {
          {
            var parentHostContextDev = parentHostContext;
            var namespace = getChildNamespace(parentHostContextDev.namespace, type5);
            var ancestorInfo = updatedAncestorInfo(parentHostContextDev.ancestorInfo, type5);
            return {
              namespace,
              ancestorInfo
            };
          }
        }
        function getPublicInstance(instance) {
          return instance;
        }
        function prepareForCommit(containerInfo) {
          eventsEnabled = isEnabled();
          selectionInformation = getSelectionInformation();
          setEnabled(false);
        }
        function resetAfterCommit(containerInfo) {
          restoreSelection(selectionInformation);
          setEnabled(eventsEnabled);
          eventsEnabled = null;
          selectionInformation = null;
        }
        function createInstance(type5, props, rootContainerInstance, hostContext, internalInstanceHandle) {
          var parentNamespace;
          {
            var hostContextDev = hostContext;
            validateDOMNesting(type5, null, hostContextDev.ancestorInfo);
            if (typeof props.children === "string" || typeof props.children === "number") {
              var string3 = "" + props.children;
              var ownAncestorInfo = updatedAncestorInfo(hostContextDev.ancestorInfo, type5);
              validateDOMNesting(null, string3, ownAncestorInfo);
            }
            parentNamespace = hostContextDev.namespace;
          }
          var domElement = createElement330(type5, props, rootContainerInstance, parentNamespace);
          precacheFiberNode(internalInstanceHandle, domElement);
          updateFiberProps(domElement, props);
          return domElement;
        }
        function appendInitialChild(parentInstance, child) {
          parentInstance.appendChild(child);
        }
        function finalizeInitialChildren(domElement, type5, props, rootContainerInstance, hostContext) {
          setInitialProperties(domElement, type5, props, rootContainerInstance);
          return shouldAutoFocusHostComponent(type5, props);
        }
        function prepareUpdate(domElement, type5, oldProps, newProps, rootContainerInstance, hostContext) {
          {
            var hostContextDev = hostContext;
            if (typeof newProps.children !== typeof oldProps.children && (typeof newProps.children === "string" || typeof newProps.children === "number")) {
              var string3 = "" + newProps.children;
              var ownAncestorInfo = updatedAncestorInfo(hostContextDev.ancestorInfo, type5);
              validateDOMNesting(null, string3, ownAncestorInfo);
            }
          }
          return diffProperties(domElement, type5, oldProps, newProps, rootContainerInstance);
        }
        function shouldSetTextContent(type5, props) {
          return type5 === "textarea" || type5 === "option" || type5 === "noscript" || typeof props.children === "string" || typeof props.children === "number" || typeof props.dangerouslySetInnerHTML === "object" && props.dangerouslySetInnerHTML !== null && props.dangerouslySetInnerHTML.__html != null;
        }
        function shouldDeprioritizeSubtree(type5, props) {
          return !!props.hidden;
        }
        function createTextInstance(text, rootContainerInstance, hostContext, internalInstanceHandle) {
          {
            var hostContextDev = hostContext;
            validateDOMNesting(null, text, hostContextDev.ancestorInfo);
          }
          var textNode = createTextNode(text, rootContainerInstance);
          precacheFiberNode(internalInstanceHandle, textNode);
          return textNode;
        }
        var scheduleTimeout = typeof setTimeout === "function" ? setTimeout : void 0;
        var cancelTimeout = typeof clearTimeout === "function" ? clearTimeout : void 0;
        var noTimeout = -1;
        function commitMount(domElement, type5, newProps, internalInstanceHandle) {
          if (shouldAutoFocusHostComponent(type5, newProps)) {
            domElement.focus();
          }
        }
        function commitUpdate(domElement, updatePayload, type5, oldProps, newProps, internalInstanceHandle) {
          updateFiberProps(domElement, newProps);
          updateProperties(domElement, updatePayload, type5, oldProps, newProps);
        }
        function resetTextContent(domElement) {
          setTextContent(domElement, "");
        }
        function commitTextUpdate(textInstance, oldText, newText) {
          textInstance.nodeValue = newText;
        }
        function appendChild(parentInstance, child) {
          parentInstance.appendChild(child);
        }
        function appendChildToContainer(container, child) {
          var parentNode;
          if (container.nodeType === COMMENT_NODE) {
            parentNode = container.parentNode;
            parentNode.insertBefore(child, container);
          } else {
            parentNode = container;
            parentNode.appendChild(child);
          }
          var reactRootContainer = container._reactRootContainer;
          if ((reactRootContainer === null || reactRootContainer === void 0) && parentNode.onclick === null) {
            trapClickOnNonInteractiveElement(parentNode);
          }
        }
        function insertBefore(parentInstance, child, beforeChild) {
          parentInstance.insertBefore(child, beforeChild);
        }
        function insertInContainerBefore(container, child, beforeChild) {
          if (container.nodeType === COMMENT_NODE) {
            container.parentNode.insertBefore(child, beforeChild);
          } else {
            container.insertBefore(child, beforeChild);
          }
        }
        function removeChild(parentInstance, child) {
          parentInstance.removeChild(child);
        }
        function removeChildFromContainer(container, child) {
          if (container.nodeType === COMMENT_NODE) {
            container.parentNode.removeChild(child);
          } else {
            container.removeChild(child);
          }
        }
        function hideInstance(instance) {
          instance = instance;
          var style3 = instance.style;
          if (typeof style3.setProperty === "function") {
            style3.setProperty("display", "none", "important");
          } else {
            style3.display = "none";
          }
        }
        function hideTextInstance(textInstance) {
          textInstance.nodeValue = "";
        }
        function unhideInstance(instance, props) {
          instance = instance;
          var styleProp = props[STYLE$1];
          var display = styleProp !== void 0 && styleProp !== null && styleProp.hasOwnProperty("display") ? styleProp.display : null;
          instance.style.display = dangerousStyleValue("display", display);
        }
        function unhideTextInstance(textInstance, text) {
          textInstance.nodeValue = text;
        }
        function canHydrateInstance(instance, type5, props) {
          if (instance.nodeType !== ELEMENT_NODE || type5.toLowerCase() !== instance.nodeName.toLowerCase()) {
            return null;
          }
          return instance;
        }
        function canHydrateTextInstance(instance, text) {
          if (text === "" || instance.nodeType !== TEXT_NODE) {
            return null;
          }
          return instance;
        }
        function isSuspenseInstancePending(instance) {
          return instance.data === SUSPENSE_PENDING_START_DATA;
        }
        function isSuspenseInstanceFallback(instance) {
          return instance.data === SUSPENSE_FALLBACK_START_DATA;
        }
        function getNextHydratable(node2) {
          for (; node2 != null; node2 = node2.nextSibling) {
            var nodeType = node2.nodeType;
            if (nodeType === ELEMENT_NODE || nodeType === TEXT_NODE) {
              break;
            }
          }
          return node2;
        }
        function getNextHydratableSibling(instance) {
          return getNextHydratable(instance.nextSibling);
        }
        function getFirstHydratableChild(parentInstance) {
          return getNextHydratable(parentInstance.firstChild);
        }
        function hydrateInstance(instance, type5, props, rootContainerInstance, hostContext, internalInstanceHandle) {
          precacheFiberNode(internalInstanceHandle, instance);
          updateFiberProps(instance, props);
          var parentNamespace;
          {
            var hostContextDev = hostContext;
            parentNamespace = hostContextDev.namespace;
          }
          return diffHydratedProperties(instance, type5, props, parentNamespace, rootContainerInstance);
        }
        function hydrateTextInstance(textInstance, text, internalInstanceHandle) {
          precacheFiberNode(internalInstanceHandle, textInstance);
          return diffHydratedText(textInstance, text);
        }
        function getNextHydratableInstanceAfterSuspenseInstance(suspenseInstance) {
          var node2 = suspenseInstance.nextSibling;
          var depth = 0;
          while (node2) {
            if (node2.nodeType === COMMENT_NODE) {
              var data2 = node2.data;
              if (data2 === SUSPENSE_END_DATA) {
                if (depth === 0) {
                  return getNextHydratableSibling(node2);
                } else {
                  depth--;
                }
              } else if (data2 === SUSPENSE_START_DATA || data2 === SUSPENSE_FALLBACK_START_DATA || data2 === SUSPENSE_PENDING_START_DATA) {
                depth++;
              }
            }
            node2 = node2.nextSibling;
          }
          return null;
        }
        function getParentSuspenseInstance(targetInstance) {
          var node2 = targetInstance.previousSibling;
          var depth = 0;
          while (node2) {
            if (node2.nodeType === COMMENT_NODE) {
              var data2 = node2.data;
              if (data2 === SUSPENSE_START_DATA || data2 === SUSPENSE_FALLBACK_START_DATA || data2 === SUSPENSE_PENDING_START_DATA) {
                if (depth === 0) {
                  return node2;
                } else {
                  depth--;
                }
              } else if (data2 === SUSPENSE_END_DATA) {
                depth++;
              }
            }
            node2 = node2.previousSibling;
          }
          return null;
        }
        function commitHydratedContainer(container) {
          retryIfBlockedOn(container);
        }
        function commitHydratedSuspenseInstance(suspenseInstance) {
          retryIfBlockedOn(suspenseInstance);
        }
        function didNotMatchHydratedContainerTextInstance(parentContainer, textInstance, text) {
          {
            warnForUnmatchedText(textInstance, text);
          }
        }
        function didNotMatchHydratedTextInstance(parentType, parentProps, parentInstance, textInstance, text) {
          if (parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
            warnForUnmatchedText(textInstance, text);
          }
        }
        function didNotHydrateContainerInstance(parentContainer, instance) {
          {
            if (instance.nodeType === ELEMENT_NODE) {
              warnForDeletedHydratableElement(parentContainer, instance);
            } else if (instance.nodeType === COMMENT_NODE) ;
            else {
              warnForDeletedHydratableText(parentContainer, instance);
            }
          }
        }
        function didNotHydrateInstance(parentType, parentProps, parentInstance, instance) {
          if (parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
            if (instance.nodeType === ELEMENT_NODE) {
              warnForDeletedHydratableElement(parentInstance, instance);
            } else if (instance.nodeType === COMMENT_NODE) ;
            else {
              warnForDeletedHydratableText(parentInstance, instance);
            }
          }
        }
        function didNotFindHydratableContainerInstance(parentContainer, type5, props) {
          {
            warnForInsertedHydratedElement(parentContainer, type5);
          }
        }
        function didNotFindHydratableContainerTextInstance(parentContainer, text) {
          {
            warnForInsertedHydratedText(parentContainer, text);
          }
        }
        function didNotFindHydratableInstance(parentType, parentProps, parentInstance, type5, props) {
          if (parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
            warnForInsertedHydratedElement(parentInstance, type5);
          }
        }
        function didNotFindHydratableTextInstance(parentType, parentProps, parentInstance, text) {
          if (parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
            warnForInsertedHydratedText(parentInstance, text);
          }
        }
        function didNotFindHydratableSuspenseInstance(parentType, parentProps, parentInstance) {
          if (parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) ;
        }
        var randomKey = Math.random().toString(36).slice(2);
        var internalInstanceKey = "__reactInternalInstance$" + randomKey;
        var internalEventHandlersKey = "__reactEventHandlers$" + randomKey;
        var internalContainerInstanceKey = "__reactContainere$" + randomKey;
        function precacheFiberNode(hostInst, node2) {
          node2[internalInstanceKey] = hostInst;
        }
        function markContainerAsRoot(hostRoot, node2) {
          node2[internalContainerInstanceKey] = hostRoot;
        }
        function unmarkContainerAsRoot(node2) {
          node2[internalContainerInstanceKey] = null;
        }
        function isContainerMarkedAsRoot(node2) {
          return !!node2[internalContainerInstanceKey];
        }
        function getClosestInstanceFromNode(targetNode) {
          var targetInst = targetNode[internalInstanceKey];
          if (targetInst) {
            return targetInst;
          }
          var parentNode = targetNode.parentNode;
          while (parentNode) {
            targetInst = parentNode[internalContainerInstanceKey] || parentNode[internalInstanceKey];
            if (targetInst) {
              var alternate = targetInst.alternate;
              if (targetInst.child !== null || alternate !== null && alternate.child !== null) {
                var suspenseInstance = getParentSuspenseInstance(targetNode);
                while (suspenseInstance !== null) {
                  var targetSuspenseInst = suspenseInstance[internalInstanceKey];
                  if (targetSuspenseInst) {
                    return targetSuspenseInst;
                  }
                  suspenseInstance = getParentSuspenseInstance(suspenseInstance);
                }
              }
              return targetInst;
            }
            targetNode = parentNode;
            parentNode = targetNode.parentNode;
          }
          return null;
        }
        function getInstanceFromNode$1(node2) {
          var inst = node2[internalInstanceKey] || node2[internalContainerInstanceKey];
          if (inst) {
            if (inst.tag === HostComponent || inst.tag === HostText || inst.tag === SuspenseComponent || inst.tag === HostRoot) {
              return inst;
            } else {
              return null;
            }
          }
          return null;
        }
        function getNodeFromInstance$1(inst) {
          if (inst.tag === HostComponent || inst.tag === HostText) {
            return inst.stateNode;
          }
          {
            {
              throw Error("getNodeFromInstance: Invalid argument.");
            }
          }
        }
        function getFiberCurrentPropsFromNode$1(node2) {
          return node2[internalEventHandlersKey] || null;
        }
        function updateFiberProps(node2, props) {
          node2[internalEventHandlersKey] = props;
        }
        function getParent(inst) {
          do {
            inst = inst.return;
          } while (inst && inst.tag !== HostComponent);
          if (inst) {
            return inst;
          }
          return null;
        }
        function getLowestCommonAncestor(instA, instB) {
          var depthA = 0;
          for (var tempA = instA; tempA; tempA = getParent(tempA)) {
            depthA++;
          }
          var depthB = 0;
          for (var tempB = instB; tempB; tempB = getParent(tempB)) {
            depthB++;
          }
          while (depthA - depthB > 0) {
            instA = getParent(instA);
            depthA--;
          }
          while (depthB - depthA > 0) {
            instB = getParent(instB);
            depthB--;
          }
          var depth = depthA;
          while (depth--) {
            if (instA === instB || instA === instB.alternate) {
              return instA;
            }
            instA = getParent(instA);
            instB = getParent(instB);
          }
          return null;
        }
        function traverseTwoPhase(inst, fn, arg) {
          var path2 = [];
          while (inst) {
            path2.push(inst);
            inst = getParent(inst);
          }
          var i;
          for (i = path2.length; i-- > 0; ) {
            fn(path2[i], "captured", arg);
          }
          for (i = 0; i < path2.length; i++) {
            fn(path2[i], "bubbled", arg);
          }
        }
        function traverseEnterLeave(from2, to, fn, argFrom, argTo) {
          var common = from2 && to ? getLowestCommonAncestor(from2, to) : null;
          var pathFrom = [];
          while (true) {
            if (!from2) {
              break;
            }
            if (from2 === common) {
              break;
            }
            var alternate = from2.alternate;
            if (alternate !== null && alternate === common) {
              break;
            }
            pathFrom.push(from2);
            from2 = getParent(from2);
          }
          var pathTo = [];
          while (true) {
            if (!to) {
              break;
            }
            if (to === common) {
              break;
            }
            var _alternate = to.alternate;
            if (_alternate !== null && _alternate === common) {
              break;
            }
            pathTo.push(to);
            to = getParent(to);
          }
          for (var i = 0; i < pathFrom.length; i++) {
            fn(pathFrom[i], "bubbled", argFrom);
          }
          for (var _i = pathTo.length; _i-- > 0; ) {
            fn(pathTo[_i], "captured", argTo);
          }
        }
        function isInteractive(tag) {
          return tag === "button" || tag === "input" || tag === "select" || tag === "textarea";
        }
        function shouldPreventMouseEvent(name, type5, props) {
          switch (name) {
            case "onClick":
            case "onClickCapture":
            case "onDoubleClick":
            case "onDoubleClickCapture":
            case "onMouseDown":
            case "onMouseDownCapture":
            case "onMouseMove":
            case "onMouseMoveCapture":
            case "onMouseUp":
            case "onMouseUpCapture":
            case "onMouseEnter":
              return !!(props.disabled && isInteractive(type5));
            default:
              return false;
          }
        }
        function getListener(inst, registrationName) {
          var listener;
          var stateNode = inst.stateNode;
          if (!stateNode) {
            return null;
          }
          var props = getFiberCurrentPropsFromNode(stateNode);
          if (!props) {
            return null;
          }
          listener = props[registrationName];
          if (shouldPreventMouseEvent(registrationName, inst.type, props)) {
            return null;
          }
          if (!(!listener || typeof listener === "function")) {
            {
              throw Error("Expected `" + registrationName + "` listener to be a function, instead got a value of `" + typeof listener + "` type.");
            }
          }
          return listener;
        }
        function listenerAtPhase(inst, event, propagationPhase) {
          var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
          return getListener(inst, registrationName);
        }
        function accumulateDirectionalDispatches(inst, phase, event) {
          {
            if (!inst) {
              error2("Dispatching inst must not be null");
            }
          }
          var listener = listenerAtPhase(inst, event, phase);
          if (listener) {
            event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
            event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
          }
        }
        function accumulateTwoPhaseDispatchesSingle(event) {
          if (event && event.dispatchConfig.phasedRegistrationNames) {
            traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
          }
        }
        function accumulateDispatches(inst, ignoredDirection, event) {
          if (inst && event && event.dispatchConfig.registrationName) {
            var registrationName = event.dispatchConfig.registrationName;
            var listener = getListener(inst, registrationName);
            if (listener) {
              event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
              event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
            }
          }
        }
        function accumulateDirectDispatchesSingle(event) {
          if (event && event.dispatchConfig.registrationName) {
            accumulateDispatches(event._targetInst, null, event);
          }
        }
        function accumulateTwoPhaseDispatches(events2) {
          forEachAccumulated(events2, accumulateTwoPhaseDispatchesSingle);
        }
        function accumulateEnterLeaveDispatches(leave, enter, from2, to) {
          traverseEnterLeave(from2, to, accumulateDispatches, leave, enter);
        }
        function accumulateDirectDispatches(events2) {
          forEachAccumulated(events2, accumulateDirectDispatchesSingle);
        }
        var root2 = null;
        var startText = null;
        var fallbackText = null;
        function initialize(nativeEventTarget) {
          root2 = nativeEventTarget;
          startText = getText();
          return true;
        }
        function reset2() {
          root2 = null;
          startText = null;
          fallbackText = null;
        }
        function getData() {
          if (fallbackText) {
            return fallbackText;
          }
          var start;
          var startValue = startText;
          var startLength = startValue.length;
          var end;
          var endValue = getText();
          var endLength = endValue.length;
          for (start = 0; start < startLength; start++) {
            if (startValue[start] !== endValue[start]) {
              break;
            }
          }
          var minEnd = startLength - start;
          for (end = 1; end <= minEnd; end++) {
            if (startValue[startLength - end] !== endValue[endLength - end]) {
              break;
            }
          }
          var sliceTail = end > 1 ? 1 - end : void 0;
          fallbackText = endValue.slice(start, sliceTail);
          return fallbackText;
        }
        function getText() {
          if ("value" in root2) {
            return root2.value;
          }
          return root2.textContent;
        }
        var EVENT_POOL_SIZE = 10;
        var EventInterface = {
          type: null,
          target: null,
          // currentTarget is set when dispatching; no use in copying it here
          currentTarget: function() {
            return null;
          },
          eventPhase: null,
          bubbles: null,
          cancelable: null,
          timeStamp: function(event) {
            return event.timeStamp || Date.now();
          },
          defaultPrevented: null,
          isTrusted: null
        };
        function functionThatReturnsTrue() {
          return true;
        }
        function functionThatReturnsFalse() {
          return false;
        }
        function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
          {
            delete this.nativeEvent;
            delete this.preventDefault;
            delete this.stopPropagation;
            delete this.isDefaultPrevented;
            delete this.isPropagationStopped;
          }
          this.dispatchConfig = dispatchConfig;
          this._targetInst = targetInst;
          this.nativeEvent = nativeEvent;
          var Interface = this.constructor.Interface;
          for (var propName in Interface) {
            if (!Interface.hasOwnProperty(propName)) {
              continue;
            }
            {
              delete this[propName];
            }
            var normalize2 = Interface[propName];
            if (normalize2) {
              this[propName] = normalize2(nativeEvent);
            } else {
              if (propName === "target") {
                this.target = nativeEventTarget;
              } else {
                this[propName] = nativeEvent[propName];
              }
            }
          }
          var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
          if (defaultPrevented) {
            this.isDefaultPrevented = functionThatReturnsTrue;
          } else {
            this.isDefaultPrevented = functionThatReturnsFalse;
          }
          this.isPropagationStopped = functionThatReturnsFalse;
          return this;
        }
        _assign(SyntheticEvent.prototype, {
          preventDefault: function() {
            this.defaultPrevented = true;
            var event = this.nativeEvent;
            if (!event) {
              return;
            }
            if (event.preventDefault) {
              event.preventDefault();
            } else if (typeof event.returnValue !== "unknown") {
              event.returnValue = false;
            }
            this.isDefaultPrevented = functionThatReturnsTrue;
          },
          stopPropagation: function() {
            var event = this.nativeEvent;
            if (!event) {
              return;
            }
            if (event.stopPropagation) {
              event.stopPropagation();
            } else if (typeof event.cancelBubble !== "unknown") {
              event.cancelBubble = true;
            }
            this.isPropagationStopped = functionThatReturnsTrue;
          },
          /**
           * We release all dispatched `SyntheticEvent`s after each event loop, adding
           * them back into the pool. This allows a way to hold onto a reference that
           * won't be added back into the pool.
           */
          persist: function() {
            this.isPersistent = functionThatReturnsTrue;
          },
          /**
           * Checks if this event should be released back into the pool.
           *
           * @return {boolean} True if this should not be released, false otherwise.
           */
          isPersistent: functionThatReturnsFalse,
          /**
           * `PooledClass` looks for `destructor` on each instance it releases.
           */
          destructor: function() {
            var Interface = this.constructor.Interface;
            for (var propName in Interface) {
              {
                Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
              }
            }
            this.dispatchConfig = null;
            this._targetInst = null;
            this.nativeEvent = null;
            this.isDefaultPrevented = functionThatReturnsFalse;
            this.isPropagationStopped = functionThatReturnsFalse;
            this._dispatchListeners = null;
            this._dispatchInstances = null;
            {
              Object.defineProperty(this, "nativeEvent", getPooledWarningPropertyDefinition("nativeEvent", null));
              Object.defineProperty(this, "isDefaultPrevented", getPooledWarningPropertyDefinition("isDefaultPrevented", functionThatReturnsFalse));
              Object.defineProperty(this, "isPropagationStopped", getPooledWarningPropertyDefinition("isPropagationStopped", functionThatReturnsFalse));
              Object.defineProperty(this, "preventDefault", getPooledWarningPropertyDefinition("preventDefault", function() {
              }));
              Object.defineProperty(this, "stopPropagation", getPooledWarningPropertyDefinition("stopPropagation", function() {
              }));
            }
          }
        });
        SyntheticEvent.Interface = EventInterface;
        SyntheticEvent.extend = function(Interface) {
          var Super = this;
          var E = function() {
          };
          E.prototype = Super.prototype;
          var prototype = new E();
          function Class() {
            return Super.apply(this, arguments);
          }
          _assign(prototype, Class.prototype);
          Class.prototype = prototype;
          Class.prototype.constructor = Class;
          Class.Interface = _assign({}, Super.Interface, Interface);
          Class.extend = Super.extend;
          addEventPoolingTo(Class);
          return Class;
        };
        addEventPoolingTo(SyntheticEvent);
        function getPooledWarningPropertyDefinition(propName, getVal) {
          var isFunction6 = typeof getVal === "function";
          return {
            configurable: true,
            set: set5,
            get: get4
          };
          function set5(val) {
            var action = isFunction6 ? "setting the method" : "setting the property";
            warn2(action, "This is effectively a no-op");
            return val;
          }
          function get4() {
            var action = isFunction6 ? "accessing the method" : "accessing the property";
            var result = isFunction6 ? "This is a no-op function" : "This is set to null";
            warn2(action, result);
            return getVal;
          }
          function warn2(action, result) {
            {
              error2("This synthetic event is reused for performance reasons. If you're seeing this, you're %s `%s` on a released/nullified synthetic event. %s. If you must keep the original synthetic event around, use event.persist(). See https://fb.me/react-event-pooling for more information.", action, propName, result);
            }
          }
        }
        function getPooledEvent(dispatchConfig, targetInst, nativeEvent, nativeInst) {
          var EventConstructor = this;
          if (EventConstructor.eventPool.length) {
            var instance = EventConstructor.eventPool.pop();
            EventConstructor.call(instance, dispatchConfig, targetInst, nativeEvent, nativeInst);
            return instance;
          }
          return new EventConstructor(dispatchConfig, targetInst, nativeEvent, nativeInst);
        }
        function releasePooledEvent(event) {
          var EventConstructor = this;
          if (!(event instanceof EventConstructor)) {
            {
              throw Error("Trying to release an event instance into a pool of a different type.");
            }
          }
          event.destructor();
          if (EventConstructor.eventPool.length < EVENT_POOL_SIZE) {
            EventConstructor.eventPool.push(event);
          }
        }
        function addEventPoolingTo(EventConstructor) {
          EventConstructor.eventPool = [];
          EventConstructor.getPooled = getPooledEvent;
          EventConstructor.release = releasePooledEvent;
        }
        var SyntheticCompositionEvent = SyntheticEvent.extend({
          data: null
        });
        var SyntheticInputEvent = SyntheticEvent.extend({
          data: null
        });
        var END_KEYCODES = [9, 13, 27, 32];
        var START_KEYCODE = 229;
        var canUseCompositionEvent = canUseDOM2 && "CompositionEvent" in window;
        var documentMode = null;
        if (canUseDOM2 && "documentMode" in document) {
          documentMode = document.documentMode;
        }
        var canUseTextInputEvent = canUseDOM2 && "TextEvent" in window && !documentMode;
        var useFallbackCompositionData = canUseDOM2 && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
        var SPACEBAR_CODE = 32;
        var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
        var eventTypes = {
          beforeInput: {
            phasedRegistrationNames: {
              bubbled: "onBeforeInput",
              captured: "onBeforeInputCapture"
            },
            dependencies: [TOP_COMPOSITION_END, TOP_KEY_PRESS, TOP_TEXT_INPUT, TOP_PASTE]
          },
          compositionEnd: {
            phasedRegistrationNames: {
              bubbled: "onCompositionEnd",
              captured: "onCompositionEndCapture"
            },
            dependencies: [TOP_BLUR, TOP_COMPOSITION_END, TOP_KEY_DOWN, TOP_KEY_PRESS, TOP_KEY_UP, TOP_MOUSE_DOWN]
          },
          compositionStart: {
            phasedRegistrationNames: {
              bubbled: "onCompositionStart",
              captured: "onCompositionStartCapture"
            },
            dependencies: [TOP_BLUR, TOP_COMPOSITION_START, TOP_KEY_DOWN, TOP_KEY_PRESS, TOP_KEY_UP, TOP_MOUSE_DOWN]
          },
          compositionUpdate: {
            phasedRegistrationNames: {
              bubbled: "onCompositionUpdate",
              captured: "onCompositionUpdateCapture"
            },
            dependencies: [TOP_BLUR, TOP_COMPOSITION_UPDATE, TOP_KEY_DOWN, TOP_KEY_PRESS, TOP_KEY_UP, TOP_MOUSE_DOWN]
          }
        };
        var hasSpaceKeypress = false;
        function isKeypressCommand(nativeEvent) {
          return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) && // ctrlKey && altKey is equivalent to AltGr, and is not a command.
          !(nativeEvent.ctrlKey && nativeEvent.altKey);
        }
        function getCompositionEventType(topLevelType) {
          switch (topLevelType) {
            case TOP_COMPOSITION_START:
              return eventTypes.compositionStart;
            case TOP_COMPOSITION_END:
              return eventTypes.compositionEnd;
            case TOP_COMPOSITION_UPDATE:
              return eventTypes.compositionUpdate;
          }
        }
        function isFallbackCompositionStart(topLevelType, nativeEvent) {
          return topLevelType === TOP_KEY_DOWN && nativeEvent.keyCode === START_KEYCODE;
        }
        function isFallbackCompositionEnd(topLevelType, nativeEvent) {
          switch (topLevelType) {
            case TOP_KEY_UP:
              return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
            case TOP_KEY_DOWN:
              return nativeEvent.keyCode !== START_KEYCODE;
            case TOP_KEY_PRESS:
            case TOP_MOUSE_DOWN:
            case TOP_BLUR:
              return true;
            default:
              return false;
          }
        }
        function getDataFromCustomEvent(nativeEvent) {
          var detail = nativeEvent.detail;
          if (typeof detail === "object" && "data" in detail) {
            return detail.data;
          }
          return null;
        }
        function isUsingKoreanIME(nativeEvent) {
          return nativeEvent.locale === "ko";
        }
        var isComposing = false;
        function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
          var eventType;
          var fallbackData;
          if (canUseCompositionEvent) {
            eventType = getCompositionEventType(topLevelType);
          } else if (!isComposing) {
            if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
              eventType = eventTypes.compositionStart;
            }
          } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
            eventType = eventTypes.compositionEnd;
          }
          if (!eventType) {
            return null;
          }
          if (useFallbackCompositionData && !isUsingKoreanIME(nativeEvent)) {
            if (!isComposing && eventType === eventTypes.compositionStart) {
              isComposing = initialize(nativeEventTarget);
            } else if (eventType === eventTypes.compositionEnd) {
              if (isComposing) {
                fallbackData = getData();
              }
            }
          }
          var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
          if (fallbackData) {
            event.data = fallbackData;
          } else {
            var customData = getDataFromCustomEvent(nativeEvent);
            if (customData !== null) {
              event.data = customData;
            }
          }
          accumulateTwoPhaseDispatches(event);
          return event;
        }
        function getNativeBeforeInputChars(topLevelType, nativeEvent) {
          switch (topLevelType) {
            case TOP_COMPOSITION_END:
              return getDataFromCustomEvent(nativeEvent);
            case TOP_KEY_PRESS:
              var which = nativeEvent.which;
              if (which !== SPACEBAR_CODE) {
                return null;
              }
              hasSpaceKeypress = true;
              return SPACEBAR_CHAR;
            case TOP_TEXT_INPUT:
              var chars = nativeEvent.data;
              if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
                return null;
              }
              return chars;
            default:
              return null;
          }
        }
        function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
          if (isComposing) {
            if (topLevelType === TOP_COMPOSITION_END || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
              var chars = getData();
              reset2();
              isComposing = false;
              return chars;
            }
            return null;
          }
          switch (topLevelType) {
            case TOP_PASTE:
              return null;
            case TOP_KEY_PRESS:
              if (!isKeypressCommand(nativeEvent)) {
                if (nativeEvent.char && nativeEvent.char.length > 1) {
                  return nativeEvent.char;
                } else if (nativeEvent.which) {
                  return String.fromCharCode(nativeEvent.which);
                }
              }
              return null;
            case TOP_COMPOSITION_END:
              return useFallbackCompositionData && !isUsingKoreanIME(nativeEvent) ? null : nativeEvent.data;
            default:
              return null;
          }
        }
        function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
          var chars;
          if (canUseTextInputEvent) {
            chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
          } else {
            chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
          }
          if (!chars) {
            return null;
          }
          var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
          event.data = chars;
          accumulateTwoPhaseDispatches(event);
          return event;
        }
        var BeforeInputEventPlugin = {
          eventTypes,
          extractEvents: function(topLevelType, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags) {
            var composition = extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget);
            var beforeInput = extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget);
            if (composition === null) {
              return beforeInput;
            }
            if (beforeInput === null) {
              return composition;
            }
            return [composition, beforeInput];
          }
        };
        var supportedInputTypes = {
          color: true,
          date: true,
          datetime: true,
          "datetime-local": true,
          email: true,
          month: true,
          number: true,
          password: true,
          range: true,
          search: true,
          tel: true,
          text: true,
          time: true,
          url: true,
          week: true
        };
        function isTextInputElement(elem) {
          var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
          if (nodeName === "input") {
            return !!supportedInputTypes[elem.type];
          }
          if (nodeName === "textarea") {
            return true;
          }
          return false;
        }
        var eventTypes$1 = {
          change: {
            phasedRegistrationNames: {
              bubbled: "onChange",
              captured: "onChangeCapture"
            },
            dependencies: [TOP_BLUR, TOP_CHANGE, TOP_CLICK, TOP_FOCUS, TOP_INPUT, TOP_KEY_DOWN, TOP_KEY_UP, TOP_SELECTION_CHANGE]
          }
        };
        function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
          var event = SyntheticEvent.getPooled(eventTypes$1.change, inst, nativeEvent, target);
          event.type = "change";
          enqueueStateRestore(target);
          accumulateTwoPhaseDispatches(event);
          return event;
        }
        var activeElement = null;
        var activeElementInst = null;
        function shouldUseChangeEvent(elem) {
          var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
          return nodeName === "select" || nodeName === "input" && elem.type === "file";
        }
        function manualDispatchChangeEvent(nativeEvent) {
          var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));
          batchedUpdates(runEventInBatch, event);
        }
        function runEventInBatch(event) {
          runEventsInBatch(event);
        }
        function getInstIfValueChanged(targetInst) {
          var targetNode = getNodeFromInstance$1(targetInst);
          if (updateValueIfChanged(targetNode)) {
            return targetInst;
          }
        }
        function getTargetInstForChangeEvent(topLevelType, targetInst) {
          if (topLevelType === TOP_CHANGE) {
            return targetInst;
          }
        }
        var isInputEventSupported = false;
        if (canUseDOM2) {
          isInputEventSupported = isEventSupported("input") && (!document.documentMode || document.documentMode > 9);
        }
        function startWatchingForValueChange(target, targetInst) {
          activeElement = target;
          activeElementInst = targetInst;
          activeElement.attachEvent("onpropertychange", handlePropertyChange);
        }
        function stopWatchingForValueChange() {
          if (!activeElement) {
            return;
          }
          activeElement.detachEvent("onpropertychange", handlePropertyChange);
          activeElement = null;
          activeElementInst = null;
        }
        function handlePropertyChange(nativeEvent) {
          if (nativeEvent.propertyName !== "value") {
            return;
          }
          if (getInstIfValueChanged(activeElementInst)) {
            manualDispatchChangeEvent(nativeEvent);
          }
        }
        function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
          if (topLevelType === TOP_FOCUS) {
            stopWatchingForValueChange();
            startWatchingForValueChange(target, targetInst);
          } else if (topLevelType === TOP_BLUR) {
            stopWatchingForValueChange();
          }
        }
        function getTargetInstForInputEventPolyfill(topLevelType, targetInst) {
          if (topLevelType === TOP_SELECTION_CHANGE || topLevelType === TOP_KEY_UP || topLevelType === TOP_KEY_DOWN) {
            return getInstIfValueChanged(activeElementInst);
          }
        }
        function shouldUseClickEvent(elem) {
          var nodeName = elem.nodeName;
          return nodeName && nodeName.toLowerCase() === "input" && (elem.type === "checkbox" || elem.type === "radio");
        }
        function getTargetInstForClickEvent(topLevelType, targetInst) {
          if (topLevelType === TOP_CLICK) {
            return getInstIfValueChanged(targetInst);
          }
        }
        function getTargetInstForInputOrChangeEvent(topLevelType, targetInst) {
          if (topLevelType === TOP_INPUT || topLevelType === TOP_CHANGE) {
            return getInstIfValueChanged(targetInst);
          }
        }
        function handleControlledInputBlur(node2) {
          var state = node2._wrapperState;
          if (!state || !state.controlled || node2.type !== "number") {
            return;
          }
          {
            setDefaultValue(node2, "number", node2.value);
          }
        }
        var ChangeEventPlugin = {
          eventTypes: eventTypes$1,
          _isInputEventSupported: isInputEventSupported,
          extractEvents: function(topLevelType, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags) {
            var targetNode = targetInst ? getNodeFromInstance$1(targetInst) : window;
            var getTargetInstFunc, handleEventFunc;
            if (shouldUseChangeEvent(targetNode)) {
              getTargetInstFunc = getTargetInstForChangeEvent;
            } else if (isTextInputElement(targetNode)) {
              if (isInputEventSupported) {
                getTargetInstFunc = getTargetInstForInputOrChangeEvent;
              } else {
                getTargetInstFunc = getTargetInstForInputEventPolyfill;
                handleEventFunc = handleEventsForInputEventPolyfill;
              }
            } else if (shouldUseClickEvent(targetNode)) {
              getTargetInstFunc = getTargetInstForClickEvent;
            }
            if (getTargetInstFunc) {
              var inst = getTargetInstFunc(topLevelType, targetInst);
              if (inst) {
                var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
                return event;
              }
            }
            if (handleEventFunc) {
              handleEventFunc(topLevelType, targetNode, targetInst);
            }
            if (topLevelType === TOP_BLUR) {
              handleControlledInputBlur(targetNode);
            }
          }
        };
        var SyntheticUIEvent = SyntheticEvent.extend({
          view: null,
          detail: null
        });
        var modifierKeyToProp = {
          Alt: "altKey",
          Control: "ctrlKey",
          Meta: "metaKey",
          Shift: "shiftKey"
        };
        function modifierStateGetter(keyArg) {
          var syntheticEvent = this;
          var nativeEvent = syntheticEvent.nativeEvent;
          if (nativeEvent.getModifierState) {
            return nativeEvent.getModifierState(keyArg);
          }
          var keyProp = modifierKeyToProp[keyArg];
          return keyProp ? !!nativeEvent[keyProp] : false;
        }
        function getEventModifierState(nativeEvent) {
          return modifierStateGetter;
        }
        var previousScreenX = 0;
        var previousScreenY = 0;
        var isMovementXSet = false;
        var isMovementYSet = false;
        var SyntheticMouseEvent = SyntheticUIEvent.extend({
          screenX: null,
          screenY: null,
          clientX: null,
          clientY: null,
          pageX: null,
          pageY: null,
          ctrlKey: null,
          shiftKey: null,
          altKey: null,
          metaKey: null,
          getModifierState: getEventModifierState,
          button: null,
          buttons: null,
          relatedTarget: function(event) {
            return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
          },
          movementX: function(event) {
            if ("movementX" in event) {
              return event.movementX;
            }
            var screenX = previousScreenX;
            previousScreenX = event.screenX;
            if (!isMovementXSet) {
              isMovementXSet = true;
              return 0;
            }
            return event.type === "mousemove" ? event.screenX - screenX : 0;
          },
          movementY: function(event) {
            if ("movementY" in event) {
              return event.movementY;
            }
            var screenY = previousScreenY;
            previousScreenY = event.screenY;
            if (!isMovementYSet) {
              isMovementYSet = true;
              return 0;
            }
            return event.type === "mousemove" ? event.screenY - screenY : 0;
          }
        });
        var SyntheticPointerEvent = SyntheticMouseEvent.extend({
          pointerId: null,
          width: null,
          height: null,
          pressure: null,
          tangentialPressure: null,
          tiltX: null,
          tiltY: null,
          twist: null,
          pointerType: null,
          isPrimary: null
        });
        var eventTypes$2 = {
          mouseEnter: {
            registrationName: "onMouseEnter",
            dependencies: [TOP_MOUSE_OUT, TOP_MOUSE_OVER]
          },
          mouseLeave: {
            registrationName: "onMouseLeave",
            dependencies: [TOP_MOUSE_OUT, TOP_MOUSE_OVER]
          },
          pointerEnter: {
            registrationName: "onPointerEnter",
            dependencies: [TOP_POINTER_OUT, TOP_POINTER_OVER]
          },
          pointerLeave: {
            registrationName: "onPointerLeave",
            dependencies: [TOP_POINTER_OUT, TOP_POINTER_OVER]
          }
        };
        var EnterLeaveEventPlugin = {
          eventTypes: eventTypes$2,
          /**
           * For almost every interaction we care about, there will be both a top-level
           * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
           * we do not extract duplicate events. However, moving the mouse into the
           * browser from outside will not fire a `mouseout` event. In this case, we use
           * the `mouseover` top-level event.
           */
          extractEvents: function(topLevelType, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags) {
            var isOverEvent = topLevelType === TOP_MOUSE_OVER || topLevelType === TOP_POINTER_OVER;
            var isOutEvent = topLevelType === TOP_MOUSE_OUT || topLevelType === TOP_POINTER_OUT;
            if (isOverEvent && (eventSystemFlags & IS_REPLAYED) === 0 && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
              return null;
            }
            if (!isOutEvent && !isOverEvent) {
              return null;
            }
            var win;
            if (nativeEventTarget.window === nativeEventTarget) {
              win = nativeEventTarget;
            } else {
              var doc2 = nativeEventTarget.ownerDocument;
              if (doc2) {
                win = doc2.defaultView || doc2.parentWindow;
              } else {
                win = window;
              }
            }
            var from2;
            var to;
            if (isOutEvent) {
              from2 = targetInst;
              var related = nativeEvent.relatedTarget || nativeEvent.toElement;
              to = related ? getClosestInstanceFromNode(related) : null;
              if (to !== null) {
                var nearestMounted = getNearestMountedFiber(to);
                if (to !== nearestMounted || to.tag !== HostComponent && to.tag !== HostText) {
                  to = null;
                }
              }
            } else {
              from2 = null;
              to = targetInst;
            }
            if (from2 === to) {
              return null;
            }
            var eventInterface, leaveEventType, enterEventType, eventTypePrefix;
            if (topLevelType === TOP_MOUSE_OUT || topLevelType === TOP_MOUSE_OVER) {
              eventInterface = SyntheticMouseEvent;
              leaveEventType = eventTypes$2.mouseLeave;
              enterEventType = eventTypes$2.mouseEnter;
              eventTypePrefix = "mouse";
            } else if (topLevelType === TOP_POINTER_OUT || topLevelType === TOP_POINTER_OVER) {
              eventInterface = SyntheticPointerEvent;
              leaveEventType = eventTypes$2.pointerLeave;
              enterEventType = eventTypes$2.pointerEnter;
              eventTypePrefix = "pointer";
            }
            var fromNode = from2 == null ? win : getNodeFromInstance$1(from2);
            var toNode = to == null ? win : getNodeFromInstance$1(to);
            var leave = eventInterface.getPooled(leaveEventType, from2, nativeEvent, nativeEventTarget);
            leave.type = eventTypePrefix + "leave";
            leave.target = fromNode;
            leave.relatedTarget = toNode;
            var enter = eventInterface.getPooled(enterEventType, to, nativeEvent, nativeEventTarget);
            enter.type = eventTypePrefix + "enter";
            enter.target = toNode;
            enter.relatedTarget = fromNode;
            accumulateEnterLeaveDispatches(leave, enter, from2, to);
            if ((eventSystemFlags & IS_FIRST_ANCESTOR) === 0) {
              return [leave];
            }
            return [leave, enter];
          }
        };
        function is(x, y) {
          return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y;
        }
        var objectIs = typeof Object.is === "function" ? Object.is : is;
        var hasOwnProperty$2 = Object.prototype.hasOwnProperty;
        function shallowEqual(objA, objB) {
          if (objectIs(objA, objB)) {
            return true;
          }
          if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) {
            return false;
          }
          var keysA = Object.keys(objA);
          var keysB = Object.keys(objB);
          if (keysA.length !== keysB.length) {
            return false;
          }
          for (var i = 0; i < keysA.length; i++) {
            if (!hasOwnProperty$2.call(objB, keysA[i]) || !objectIs(objA[keysA[i]], objB[keysA[i]])) {
              return false;
            }
          }
          return true;
        }
        var skipSelectionChangeEvent = canUseDOM2 && "documentMode" in document && document.documentMode <= 11;
        var eventTypes$3 = {
          select: {
            phasedRegistrationNames: {
              bubbled: "onSelect",
              captured: "onSelectCapture"
            },
            dependencies: [TOP_BLUR, TOP_CONTEXT_MENU, TOP_DRAG_END, TOP_FOCUS, TOP_KEY_DOWN, TOP_KEY_UP, TOP_MOUSE_DOWN, TOP_MOUSE_UP, TOP_SELECTION_CHANGE]
          }
        };
        var activeElement$1 = null;
        var activeElementInst$1 = null;
        var lastSelection = null;
        var mouseDown = false;
        function getSelection$1(node2) {
          if ("selectionStart" in node2 && hasSelectionCapabilities(node2)) {
            return {
              start: node2.selectionStart,
              end: node2.selectionEnd
            };
          } else {
            var win = node2.ownerDocument && node2.ownerDocument.defaultView || window;
            var selection = win.getSelection();
            return {
              anchorNode: selection.anchorNode,
              anchorOffset: selection.anchorOffset,
              focusNode: selection.focusNode,
              focusOffset: selection.focusOffset
            };
          }
        }
        function getEventTargetDocument(eventTarget) {
          return eventTarget.window === eventTarget ? eventTarget.document : eventTarget.nodeType === DOCUMENT_NODE ? eventTarget : eventTarget.ownerDocument;
        }
        function constructSelectEvent(nativeEvent, nativeEventTarget) {
          var doc2 = getEventTargetDocument(nativeEventTarget);
          if (mouseDown || activeElement$1 == null || activeElement$1 !== getActiveElement(doc2)) {
            return null;
          }
          var currentSelection = getSelection$1(activeElement$1);
          if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
            lastSelection = currentSelection;
            var syntheticEvent = SyntheticEvent.getPooled(eventTypes$3.select, activeElementInst$1, nativeEvent, nativeEventTarget);
            syntheticEvent.type = "select";
            syntheticEvent.target = activeElement$1;
            accumulateTwoPhaseDispatches(syntheticEvent);
            return syntheticEvent;
          }
          return null;
        }
        var SelectEventPlugin = {
          eventTypes: eventTypes$3,
          extractEvents: function(topLevelType, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, container) {
            var containerOrDoc = container || getEventTargetDocument(nativeEventTarget);
            if (!containerOrDoc || !isListeningToAllDependencies("onSelect", containerOrDoc)) {
              return null;
            }
            var targetNode = targetInst ? getNodeFromInstance$1(targetInst) : window;
            switch (topLevelType) {
              // Track the input node that has focus.
              case TOP_FOCUS:
                if (isTextInputElement(targetNode) || targetNode.contentEditable === "true") {
                  activeElement$1 = targetNode;
                  activeElementInst$1 = targetInst;
                  lastSelection = null;
                }
                break;
              case TOP_BLUR:
                activeElement$1 = null;
                activeElementInst$1 = null;
                lastSelection = null;
                break;
              // Don't fire the event while the user is dragging. This matches the
              // semantics of the native select event.
              case TOP_MOUSE_DOWN:
                mouseDown = true;
                break;
              case TOP_CONTEXT_MENU:
              case TOP_MOUSE_UP:
              case TOP_DRAG_END:
                mouseDown = false;
                return constructSelectEvent(nativeEvent, nativeEventTarget);
              // Chrome and IE fire non-standard event when selection is changed (and
              // sometimes when it hasn't). IE's event fires out of order with respect
              // to key and input events on deletion, so we discard it.
              //
              // Firefox doesn't support selectionchange, so check selection status
              // after each key entry. The selection changes after keydown and before
              // keyup, but we check on keydown as well in the case of holding down a
              // key, when multiple keydown events are fired but only one keyup is.
              // This is also our approach for IE handling, for the reason above.
              case TOP_SELECTION_CHANGE:
                if (skipSelectionChangeEvent) {
                  break;
                }
              // falls through
              case TOP_KEY_DOWN:
              case TOP_KEY_UP:
                return constructSelectEvent(nativeEvent, nativeEventTarget);
            }
            return null;
          }
        };
        var SyntheticAnimationEvent = SyntheticEvent.extend({
          animationName: null,
          elapsedTime: null,
          pseudoElement: null
        });
        var SyntheticClipboardEvent = SyntheticEvent.extend({
          clipboardData: function(event) {
            return "clipboardData" in event ? event.clipboardData : window.clipboardData;
          }
        });
        var SyntheticFocusEvent = SyntheticUIEvent.extend({
          relatedTarget: null
        });
        function getEventCharCode(nativeEvent) {
          var charCode;
          var keyCode = nativeEvent.keyCode;
          if ("charCode" in nativeEvent) {
            charCode = nativeEvent.charCode;
            if (charCode === 0 && keyCode === 13) {
              charCode = 13;
            }
          } else {
            charCode = keyCode;
          }
          if (charCode === 10) {
            charCode = 13;
          }
          if (charCode >= 32 || charCode === 13) {
            return charCode;
          }
          return 0;
        }
        var normalizeKey = {
          Esc: "Escape",
          Spacebar: " ",
          Left: "ArrowLeft",
          Up: "ArrowUp",
          Right: "ArrowRight",
          Down: "ArrowDown",
          Del: "Delete",
          Win: "OS",
          Menu: "ContextMenu",
          Apps: "ContextMenu",
          Scroll: "ScrollLock",
          MozPrintableKey: "Unidentified"
        };
        var translateToKey = {
          "8": "Backspace",
          "9": "Tab",
          "12": "Clear",
          "13": "Enter",
          "16": "Shift",
          "17": "Control",
          "18": "Alt",
          "19": "Pause",
          "20": "CapsLock",
          "27": "Escape",
          "32": " ",
          "33": "PageUp",
          "34": "PageDown",
          "35": "End",
          "36": "Home",
          "37": "ArrowLeft",
          "38": "ArrowUp",
          "39": "ArrowRight",
          "40": "ArrowDown",
          "45": "Insert",
          "46": "Delete",
          "112": "F1",
          "113": "F2",
          "114": "F3",
          "115": "F4",
          "116": "F5",
          "117": "F6",
          "118": "F7",
          "119": "F8",
          "120": "F9",
          "121": "F10",
          "122": "F11",
          "123": "F12",
          "144": "NumLock",
          "145": "ScrollLock",
          "224": "Meta"
        };
        function getEventKey(nativeEvent) {
          if (nativeEvent.key) {
            var key2 = normalizeKey[nativeEvent.key] || nativeEvent.key;
            if (key2 !== "Unidentified") {
              return key2;
            }
          }
          if (nativeEvent.type === "keypress") {
            var charCode = getEventCharCode(nativeEvent);
            return charCode === 13 ? "Enter" : String.fromCharCode(charCode);
          }
          if (nativeEvent.type === "keydown" || nativeEvent.type === "keyup") {
            return translateToKey[nativeEvent.keyCode] || "Unidentified";
          }
          return "";
        }
        var SyntheticKeyboardEvent = SyntheticUIEvent.extend({
          key: getEventKey,
          location: null,
          ctrlKey: null,
          shiftKey: null,
          altKey: null,
          metaKey: null,
          repeat: null,
          locale: null,
          getModifierState: getEventModifierState,
          // Legacy Interface
          charCode: function(event) {
            if (event.type === "keypress") {
              return getEventCharCode(event);
            }
            return 0;
          },
          keyCode: function(event) {
            if (event.type === "keydown" || event.type === "keyup") {
              return event.keyCode;
            }
            return 0;
          },
          which: function(event) {
            if (event.type === "keypress") {
              return getEventCharCode(event);
            }
            if (event.type === "keydown" || event.type === "keyup") {
              return event.keyCode;
            }
            return 0;
          }
        });
        var SyntheticDragEvent = SyntheticMouseEvent.extend({
          dataTransfer: null
        });
        var SyntheticTouchEvent = SyntheticUIEvent.extend({
          touches: null,
          targetTouches: null,
          changedTouches: null,
          altKey: null,
          metaKey: null,
          ctrlKey: null,
          shiftKey: null,
          getModifierState: getEventModifierState
        });
        var SyntheticTransitionEvent = SyntheticEvent.extend({
          propertyName: null,
          elapsedTime: null,
          pseudoElement: null
        });
        var SyntheticWheelEvent = SyntheticMouseEvent.extend({
          deltaX: function(event) {
            return "deltaX" in event ? event.deltaX : (
              // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
              "wheelDeltaX" in event ? -event.wheelDeltaX : 0
            );
          },
          deltaY: function(event) {
            return "deltaY" in event ? event.deltaY : (
              // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
              "wheelDeltaY" in event ? -event.wheelDeltaY : (
                // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
                "wheelDelta" in event ? -event.wheelDelta : 0
              )
            );
          },
          deltaZ: null,
          // Browsers without "deltaMode" is reporting in raw wheel delta where one
          // notch on the scroll is always +/- 120, roughly equivalent to pixels.
          // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
          // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
          deltaMode: null
        });
        var knownHTMLTopLevelTypes = [TOP_ABORT, TOP_CANCEL, TOP_CAN_PLAY, TOP_CAN_PLAY_THROUGH, TOP_CLOSE, TOP_DURATION_CHANGE, TOP_EMPTIED, TOP_ENCRYPTED, TOP_ENDED, TOP_ERROR, TOP_INPUT, TOP_INVALID, TOP_LOAD, TOP_LOADED_DATA, TOP_LOADED_METADATA, TOP_LOAD_START, TOP_PAUSE, TOP_PLAY, TOP_PLAYING, TOP_PROGRESS, TOP_RATE_CHANGE, TOP_RESET, TOP_SEEKED, TOP_SEEKING, TOP_STALLED, TOP_SUBMIT, TOP_SUSPEND, TOP_TIME_UPDATE, TOP_TOGGLE, TOP_VOLUME_CHANGE, TOP_WAITING];
        var SimpleEventPlugin = {
          // simpleEventPluginEventTypes gets populated from
          // the DOMEventProperties module.
          eventTypes: simpleEventPluginEventTypes,
          extractEvents: function(topLevelType, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags) {
            var dispatchConfig = topLevelEventsToDispatchConfig.get(topLevelType);
            if (!dispatchConfig) {
              return null;
            }
            var EventConstructor;
            switch (topLevelType) {
              case TOP_KEY_PRESS:
                if (getEventCharCode(nativeEvent) === 0) {
                  return null;
                }
              /* falls through */
              case TOP_KEY_DOWN:
              case TOP_KEY_UP:
                EventConstructor = SyntheticKeyboardEvent;
                break;
              case TOP_BLUR:
              case TOP_FOCUS:
                EventConstructor = SyntheticFocusEvent;
                break;
              case TOP_CLICK:
                if (nativeEvent.button === 2) {
                  return null;
                }
              /* falls through */
              case TOP_AUX_CLICK:
              case TOP_DOUBLE_CLICK:
              case TOP_MOUSE_DOWN:
              case TOP_MOUSE_MOVE:
              case TOP_MOUSE_UP:
              // TODO: Disabled elements should not respond to mouse events
              /* falls through */
              case TOP_MOUSE_OUT:
              case TOP_MOUSE_OVER:
              case TOP_CONTEXT_MENU:
                EventConstructor = SyntheticMouseEvent;
                break;
              case TOP_DRAG:
              case TOP_DRAG_END:
              case TOP_DRAG_ENTER:
              case TOP_DRAG_EXIT:
              case TOP_DRAG_LEAVE:
              case TOP_DRAG_OVER:
              case TOP_DRAG_START:
              case TOP_DROP:
                EventConstructor = SyntheticDragEvent;
                break;
              case TOP_TOUCH_CANCEL:
              case TOP_TOUCH_END:
              case TOP_TOUCH_MOVE:
              case TOP_TOUCH_START:
                EventConstructor = SyntheticTouchEvent;
                break;
              case TOP_ANIMATION_END:
              case TOP_ANIMATION_ITERATION:
              case TOP_ANIMATION_START:
                EventConstructor = SyntheticAnimationEvent;
                break;
              case TOP_TRANSITION_END:
                EventConstructor = SyntheticTransitionEvent;
                break;
              case TOP_SCROLL:
                EventConstructor = SyntheticUIEvent;
                break;
              case TOP_WHEEL:
                EventConstructor = SyntheticWheelEvent;
                break;
              case TOP_COPY:
              case TOP_CUT:
              case TOP_PASTE:
                EventConstructor = SyntheticClipboardEvent;
                break;
              case TOP_GOT_POINTER_CAPTURE:
              case TOP_LOST_POINTER_CAPTURE:
              case TOP_POINTER_CANCEL:
              case TOP_POINTER_DOWN:
              case TOP_POINTER_MOVE:
              case TOP_POINTER_OUT:
              case TOP_POINTER_OVER:
              case TOP_POINTER_UP:
                EventConstructor = SyntheticPointerEvent;
                break;
              default:
                {
                  if (knownHTMLTopLevelTypes.indexOf(topLevelType) === -1) {
                    error2("SimpleEventPlugin: Unhandled event type, `%s`. This warning is likely caused by a bug in React. Please file an issue.", topLevelType);
                  }
                }
                EventConstructor = SyntheticEvent;
                break;
            }
            var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
            accumulateTwoPhaseDispatches(event);
            return event;
          }
        };
        var DOMEventPluginOrder = ["ResponderEventPlugin", "SimpleEventPlugin", "EnterLeaveEventPlugin", "ChangeEventPlugin", "SelectEventPlugin", "BeforeInputEventPlugin"];
        injectEventPluginOrder(DOMEventPluginOrder);
        setComponentTree(getFiberCurrentPropsFromNode$1, getInstanceFromNode$1, getNodeFromInstance$1);
        injectEventPluginsByName({
          SimpleEventPlugin,
          EnterLeaveEventPlugin,
          ChangeEventPlugin,
          SelectEventPlugin,
          BeforeInputEventPlugin
        });
        var reactEmoji = "\u269B";
        var warningEmoji = "\u26D4";
        var supportsUserTiming = typeof performance !== "undefined" && typeof performance.mark === "function" && typeof performance.clearMarks === "function" && typeof performance.measure === "function" && typeof performance.clearMeasures === "function";
        var currentFiber = null;
        var currentPhase = null;
        var currentPhaseFiber = null;
        var isCommitting = false;
        var hasScheduledUpdateInCurrentCommit = false;
        var hasScheduledUpdateInCurrentPhase = false;
        var commitCountInCurrentWorkLoop = 0;
        var effectCountInCurrentCommit = 0;
        var labelsInCurrentCommit = /* @__PURE__ */ new Set();
        var formatMarkName = function(markName) {
          return reactEmoji + " " + markName;
        };
        var formatLabel = function(label, warning6) {
          var prefix3 = warning6 ? warningEmoji + " " : reactEmoji + " ";
          var suffix = warning6 ? " Warning: " + warning6 : "";
          return "" + prefix3 + label + suffix;
        };
        var beginMark = function(markName) {
          performance.mark(formatMarkName(markName));
        };
        var clearMark = function(markName) {
          performance.clearMarks(formatMarkName(markName));
        };
        var endMark = function(label, markName, warning6) {
          var formattedMarkName = formatMarkName(markName);
          var formattedLabel = formatLabel(label, warning6);
          try {
            performance.measure(formattedLabel, formattedMarkName);
          } catch (err) {
          }
          performance.clearMarks(formattedMarkName);
          performance.clearMeasures(formattedLabel);
        };
        var getFiberMarkName = function(label, debugID) {
          return label + " (#" + debugID + ")";
        };
        var getFiberLabel = function(componentName, isMounted2, phase) {
          if (phase === null) {
            return componentName + " [" + (isMounted2 ? "update" : "mount") + "]";
          } else {
            return componentName + "." + phase;
          }
        };
        var beginFiberMark = function(fiber, phase) {
          var componentName = getComponentName(fiber.type) || "Unknown";
          var debugID = fiber._debugID;
          var isMounted2 = fiber.alternate !== null;
          var label = getFiberLabel(componentName, isMounted2, phase);
          if (isCommitting && labelsInCurrentCommit.has(label)) {
            return false;
          }
          labelsInCurrentCommit.add(label);
          var markName = getFiberMarkName(label, debugID);
          beginMark(markName);
          return true;
        };
        var clearFiberMark = function(fiber, phase) {
          var componentName = getComponentName(fiber.type) || "Unknown";
          var debugID = fiber._debugID;
          var isMounted2 = fiber.alternate !== null;
          var label = getFiberLabel(componentName, isMounted2, phase);
          var markName = getFiberMarkName(label, debugID);
          clearMark(markName);
        };
        var endFiberMark = function(fiber, phase, warning6) {
          var componentName = getComponentName(fiber.type) || "Unknown";
          var debugID = fiber._debugID;
          var isMounted2 = fiber.alternate !== null;
          var label = getFiberLabel(componentName, isMounted2, phase);
          var markName = getFiberMarkName(label, debugID);
          endMark(label, markName, warning6);
        };
        var shouldIgnoreFiber = function(fiber) {
          switch (fiber.tag) {
            case HostRoot:
            case HostComponent:
            case HostText:
            case HostPortal:
            case Fragment35:
            case ContextProvider:
            case ContextConsumer:
            case Mode3:
              return true;
            default:
              return false;
          }
        };
        var clearPendingPhaseMeasurement = function() {
          if (currentPhase !== null && currentPhaseFiber !== null) {
            clearFiberMark(currentPhaseFiber, currentPhase);
          }
          currentPhaseFiber = null;
          currentPhase = null;
          hasScheduledUpdateInCurrentPhase = false;
        };
        var pauseTimers = function() {
          var fiber = currentFiber;
          while (fiber) {
            if (fiber._debugIsCurrentlyTiming) {
              endFiberMark(fiber, null, null);
            }
            fiber = fiber.return;
          }
        };
        var resumeTimersRecursively = function(fiber) {
          if (fiber.return !== null) {
            resumeTimersRecursively(fiber.return);
          }
          if (fiber._debugIsCurrentlyTiming) {
            beginFiberMark(fiber, null);
          }
        };
        var resumeTimers = function() {
          if (currentFiber !== null) {
            resumeTimersRecursively(currentFiber);
          }
        };
        function recordEffect() {
          {
            effectCountInCurrentCommit++;
          }
        }
        function recordScheduleUpdate() {
          {
            if (isCommitting) {
              hasScheduledUpdateInCurrentCommit = true;
            }
            if (currentPhase !== null && currentPhase !== "componentWillMount" && currentPhase !== "componentWillReceiveProps") {
              hasScheduledUpdateInCurrentPhase = true;
            }
          }
        }
        function startWorkTimer(fiber) {
          {
            if (!supportsUserTiming || shouldIgnoreFiber(fiber)) {
              return;
            }
            currentFiber = fiber;
            if (!beginFiberMark(fiber, null)) {
              return;
            }
            fiber._debugIsCurrentlyTiming = true;
          }
        }
        function cancelWorkTimer(fiber) {
          {
            if (!supportsUserTiming || shouldIgnoreFiber(fiber)) {
              return;
            }
            fiber._debugIsCurrentlyTiming = false;
            clearFiberMark(fiber, null);
          }
        }
        function stopWorkTimer(fiber) {
          {
            if (!supportsUserTiming || shouldIgnoreFiber(fiber)) {
              return;
            }
            currentFiber = fiber.return;
            if (!fiber._debugIsCurrentlyTiming) {
              return;
            }
            fiber._debugIsCurrentlyTiming = false;
            endFiberMark(fiber, null, null);
          }
        }
        function stopFailedWorkTimer(fiber) {
          {
            if (!supportsUserTiming || shouldIgnoreFiber(fiber)) {
              return;
            }
            currentFiber = fiber.return;
            if (!fiber._debugIsCurrentlyTiming) {
              return;
            }
            fiber._debugIsCurrentlyTiming = false;
            var warning6 = fiber.tag === SuspenseComponent ? "Rendering was suspended" : "An error was thrown inside this error boundary";
            endFiberMark(fiber, null, warning6);
          }
        }
        function startPhaseTimer(fiber, phase) {
          {
            if (!supportsUserTiming) {
              return;
            }
            clearPendingPhaseMeasurement();
            if (!beginFiberMark(fiber, phase)) {
              return;
            }
            currentPhaseFiber = fiber;
            currentPhase = phase;
          }
        }
        function stopPhaseTimer() {
          {
            if (!supportsUserTiming) {
              return;
            }
            if (currentPhase !== null && currentPhaseFiber !== null) {
              var warning6 = hasScheduledUpdateInCurrentPhase ? "Scheduled a cascading update" : null;
              endFiberMark(currentPhaseFiber, currentPhase, warning6);
            }
            currentPhase = null;
            currentPhaseFiber = null;
          }
        }
        function startWorkLoopTimer(nextUnitOfWork) {
          {
            currentFiber = nextUnitOfWork;
            if (!supportsUserTiming) {
              return;
            }
            commitCountInCurrentWorkLoop = 0;
            beginMark("(React Tree Reconciliation)");
            resumeTimers();
          }
        }
        function stopWorkLoopTimer(interruptedBy2, didCompleteRoot) {
          {
            if (!supportsUserTiming) {
              return;
            }
            var warning6 = null;
            if (interruptedBy2 !== null) {
              if (interruptedBy2.tag === HostRoot) {
                warning6 = "A top-level update interrupted the previous render";
              } else {
                var componentName = getComponentName(interruptedBy2.type) || "Unknown";
                warning6 = "An update to " + componentName + " interrupted the previous render";
              }
            } else if (commitCountInCurrentWorkLoop > 1) {
              warning6 = "There were cascading updates";
            }
            commitCountInCurrentWorkLoop = 0;
            var label = didCompleteRoot ? "(React Tree Reconciliation: Completed Root)" : "(React Tree Reconciliation: Yielded)";
            pauseTimers();
            endMark(label, "(React Tree Reconciliation)", warning6);
          }
        }
        function startCommitTimer() {
          {
            if (!supportsUserTiming) {
              return;
            }
            isCommitting = true;
            hasScheduledUpdateInCurrentCommit = false;
            labelsInCurrentCommit.clear();
            beginMark("(Committing Changes)");
          }
        }
        function stopCommitTimer() {
          {
            if (!supportsUserTiming) {
              return;
            }
            var warning6 = null;
            if (hasScheduledUpdateInCurrentCommit) {
              warning6 = "Lifecycle hook scheduled a cascading update";
            } else if (commitCountInCurrentWorkLoop > 0) {
              warning6 = "Caused by a cascading update in earlier commit";
            }
            hasScheduledUpdateInCurrentCommit = false;
            commitCountInCurrentWorkLoop++;
            isCommitting = false;
            labelsInCurrentCommit.clear();
            endMark("(Committing Changes)", "(Committing Changes)", warning6);
          }
        }
        function startCommitSnapshotEffectsTimer() {
          {
            if (!supportsUserTiming) {
              return;
            }
            effectCountInCurrentCommit = 0;
            beginMark("(Committing Snapshot Effects)");
          }
        }
        function stopCommitSnapshotEffectsTimer() {
          {
            if (!supportsUserTiming) {
              return;
            }
            var count = effectCountInCurrentCommit;
            effectCountInCurrentCommit = 0;
            endMark("(Committing Snapshot Effects: " + count + " Total)", "(Committing Snapshot Effects)", null);
          }
        }
        function startCommitHostEffectsTimer() {
          {
            if (!supportsUserTiming) {
              return;
            }
            effectCountInCurrentCommit = 0;
            beginMark("(Committing Host Effects)");
          }
        }
        function stopCommitHostEffectsTimer() {
          {
            if (!supportsUserTiming) {
              return;
            }
            var count = effectCountInCurrentCommit;
            effectCountInCurrentCommit = 0;
            endMark("(Committing Host Effects: " + count + " Total)", "(Committing Host Effects)", null);
          }
        }
        function startCommitLifeCyclesTimer() {
          {
            if (!supportsUserTiming) {
              return;
            }
            effectCountInCurrentCommit = 0;
            beginMark("(Calling Lifecycle Methods)");
          }
        }
        function stopCommitLifeCyclesTimer() {
          {
            if (!supportsUserTiming) {
              return;
            }
            var count = effectCountInCurrentCommit;
            effectCountInCurrentCommit = 0;
            endMark("(Calling Lifecycle Methods: " + count + " Total)", "(Calling Lifecycle Methods)", null);
          }
        }
        var valueStack = [];
        var fiberStack;
        {
          fiberStack = [];
        }
        var index3 = -1;
        function createCursor(defaultValue2) {
          return {
            current: defaultValue2
          };
        }
        function pop(cursor, fiber) {
          if (index3 < 0) {
            {
              error2("Unexpected pop.");
            }
            return;
          }
          {
            if (fiber !== fiberStack[index3]) {
              error2("Unexpected Fiber popped.");
            }
          }
          cursor.current = valueStack[index3];
          valueStack[index3] = null;
          {
            fiberStack[index3] = null;
          }
          index3--;
        }
        function push(cursor, value, fiber) {
          index3++;
          valueStack[index3] = cursor.current;
          {
            fiberStack[index3] = fiber;
          }
          cursor.current = value;
        }
        var warnedAboutMissingGetChildContext;
        {
          warnedAboutMissingGetChildContext = {};
        }
        var emptyContextObject = {};
        {
          Object.freeze(emptyContextObject);
        }
        var contextStackCursor = createCursor(emptyContextObject);
        var didPerformWorkStackCursor = createCursor(false);
        var previousContext = emptyContextObject;
        function getUnmaskedContext(workInProgress2, Component10, didPushOwnContextIfProvider) {
          {
            if (didPushOwnContextIfProvider && isContextProvider(Component10)) {
              return previousContext;
            }
            return contextStackCursor.current;
          }
        }
        function cacheContext(workInProgress2, unmaskedContext, maskedContext) {
          {
            var instance = workInProgress2.stateNode;
            instance.__reactInternalMemoizedUnmaskedChildContext = unmaskedContext;
            instance.__reactInternalMemoizedMaskedChildContext = maskedContext;
          }
        }
        function getMaskedContext(workInProgress2, unmaskedContext) {
          {
            var type5 = workInProgress2.type;
            var contextTypes = type5.contextTypes;
            if (!contextTypes) {
              return emptyContextObject;
            }
            var instance = workInProgress2.stateNode;
            if (instance && instance.__reactInternalMemoizedUnmaskedChildContext === unmaskedContext) {
              return instance.__reactInternalMemoizedMaskedChildContext;
            }
            var context = {};
            for (var key2 in contextTypes) {
              context[key2] = unmaskedContext[key2];
            }
            {
              var name = getComponentName(type5) || "Unknown";
              checkPropTypes(contextTypes, context, "context", name, getCurrentFiberStackInDev);
            }
            if (instance) {
              cacheContext(workInProgress2, unmaskedContext, context);
            }
            return context;
          }
        }
        function hasContextChanged() {
          {
            return didPerformWorkStackCursor.current;
          }
        }
        function isContextProvider(type5) {
          {
            var childContextTypes = type5.childContextTypes;
            return childContextTypes !== null && childContextTypes !== void 0;
          }
        }
        function popContext(fiber) {
          {
            pop(didPerformWorkStackCursor, fiber);
            pop(contextStackCursor, fiber);
          }
        }
        function popTopLevelContextObject(fiber) {
          {
            pop(didPerformWorkStackCursor, fiber);
            pop(contextStackCursor, fiber);
          }
        }
        function pushTopLevelContextObject(fiber, context, didChange) {
          {
            if (!(contextStackCursor.current === emptyContextObject)) {
              {
                throw Error("Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue.");
              }
            }
            push(contextStackCursor, context, fiber);
            push(didPerformWorkStackCursor, didChange, fiber);
          }
        }
        function processChildContext(fiber, type5, parentContext) {
          {
            var instance = fiber.stateNode;
            var childContextTypes = type5.childContextTypes;
            if (typeof instance.getChildContext !== "function") {
              {
                var componentName = getComponentName(type5) || "Unknown";
                if (!warnedAboutMissingGetChildContext[componentName]) {
                  warnedAboutMissingGetChildContext[componentName] = true;
                  error2("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", componentName, componentName);
                }
              }
              return parentContext;
            }
            var childContext;
            startPhaseTimer(fiber, "getChildContext");
            childContext = instance.getChildContext();
            stopPhaseTimer();
            for (var contextKey in childContext) {
              if (!(contextKey in childContextTypes)) {
                {
                  throw Error((getComponentName(type5) || "Unknown") + '.getChildContext(): key "' + contextKey + '" is not defined in childContextTypes.');
                }
              }
            }
            {
              var name = getComponentName(type5) || "Unknown";
              checkPropTypes(
                childContextTypes,
                childContext,
                "child context",
                name,
                // In practice, there is one case in which we won't get a stack. It's when
                // somebody calls unstable_renderSubtreeIntoContainer() and we process
                // context from the parent component instance. The stack will be missing
                // because it's outside of the reconciliation, and so the pointer has not
                // been set. This is rare and doesn't matter. We'll also remove that API.
                getCurrentFiberStackInDev
              );
            }
            return _assign({}, parentContext, {}, childContext);
          }
        }
        function pushContextProvider(workInProgress2) {
          {
            var instance = workInProgress2.stateNode;
            var memoizedMergedChildContext = instance && instance.__reactInternalMemoizedMergedChildContext || emptyContextObject;
            previousContext = contextStackCursor.current;
            push(contextStackCursor, memoizedMergedChildContext, workInProgress2);
            push(didPerformWorkStackCursor, didPerformWorkStackCursor.current, workInProgress2);
            return true;
          }
        }
        function invalidateContextProvider(workInProgress2, type5, didChange) {
          {
            var instance = workInProgress2.stateNode;
            if (!instance) {
              {
                throw Error("Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue.");
              }
            }
            if (didChange) {
              var mergedContext = processChildContext(workInProgress2, type5, previousContext);
              instance.__reactInternalMemoizedMergedChildContext = mergedContext;
              pop(didPerformWorkStackCursor, workInProgress2);
              pop(contextStackCursor, workInProgress2);
              push(contextStackCursor, mergedContext, workInProgress2);
              push(didPerformWorkStackCursor, didChange, workInProgress2);
            } else {
              pop(didPerformWorkStackCursor, workInProgress2);
              push(didPerformWorkStackCursor, didChange, workInProgress2);
            }
          }
        }
        function findCurrentUnmaskedContext(fiber) {
          {
            if (!(isFiberMounted(fiber) && fiber.tag === ClassComponent)) {
              {
                throw Error("Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue.");
              }
            }
            var node2 = fiber;
            do {
              switch (node2.tag) {
                case HostRoot:
                  return node2.stateNode.context;
                case ClassComponent: {
                  var Component10 = node2.type;
                  if (isContextProvider(Component10)) {
                    return node2.stateNode.__reactInternalMemoizedMergedChildContext;
                  }
                  break;
                }
              }
              node2 = node2.return;
            } while (node2 !== null);
            {
              {
                throw Error("Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue.");
              }
            }
          }
        }
        var LegacyRoot = 0;
        var BlockingRoot = 1;
        var ConcurrentRoot = 2;
        var Scheduler_runWithPriority = Scheduler.unstable_runWithPriority, Scheduler_scheduleCallback = Scheduler.unstable_scheduleCallback, Scheduler_cancelCallback = Scheduler.unstable_cancelCallback, Scheduler_shouldYield = Scheduler.unstable_shouldYield, Scheduler_requestPaint = Scheduler.unstable_requestPaint, Scheduler_now = Scheduler.unstable_now, Scheduler_getCurrentPriorityLevel = Scheduler.unstable_getCurrentPriorityLevel, Scheduler_ImmediatePriority = Scheduler.unstable_ImmediatePriority, Scheduler_UserBlockingPriority = Scheduler.unstable_UserBlockingPriority, Scheduler_NormalPriority = Scheduler.unstable_NormalPriority, Scheduler_LowPriority = Scheduler.unstable_LowPriority, Scheduler_IdlePriority = Scheduler.unstable_IdlePriority;
        {
          if (!(tracing.__interactionsRef != null && tracing.__interactionsRef.current != null)) {
            {
              throw Error("It is not supported to run the profiling version of a renderer (for example, `react-dom/profiling`) without also replacing the `scheduler/tracing` module with `scheduler/tracing-profiling`. Your bundler might have a setting for aliasing both modules. Learn more at http://fb.me/react-profiling");
            }
          }
        }
        var fakeCallbackNode = {};
        var ImmediatePriority = 99;
        var UserBlockingPriority$1 = 98;
        var NormalPriority = 97;
        var LowPriority = 96;
        var IdlePriority = 95;
        var NoPriority = 90;
        var shouldYield = Scheduler_shouldYield;
        var requestPaint = (
          // Fall back gracefully if we're running an older version of Scheduler.
          Scheduler_requestPaint !== void 0 ? Scheduler_requestPaint : function() {
          }
        );
        var syncQueue = null;
        var immediateQueueCallbackNode = null;
        var isFlushingSyncQueue = false;
        var initialTimeMs = Scheduler_now();
        var now4 = initialTimeMs < 1e4 ? Scheduler_now : function() {
          return Scheduler_now() - initialTimeMs;
        };
        function getCurrentPriorityLevel() {
          switch (Scheduler_getCurrentPriorityLevel()) {
            case Scheduler_ImmediatePriority:
              return ImmediatePriority;
            case Scheduler_UserBlockingPriority:
              return UserBlockingPriority$1;
            case Scheduler_NormalPriority:
              return NormalPriority;
            case Scheduler_LowPriority:
              return LowPriority;
            case Scheduler_IdlePriority:
              return IdlePriority;
            default: {
              {
                throw Error("Unknown priority level.");
              }
            }
          }
        }
        function reactPriorityToSchedulerPriority(reactPriorityLevel) {
          switch (reactPriorityLevel) {
            case ImmediatePriority:
              return Scheduler_ImmediatePriority;
            case UserBlockingPriority$1:
              return Scheduler_UserBlockingPriority;
            case NormalPriority:
              return Scheduler_NormalPriority;
            case LowPriority:
              return Scheduler_LowPriority;
            case IdlePriority:
              return Scheduler_IdlePriority;
            default: {
              {
                throw Error("Unknown priority level.");
              }
            }
          }
        }
        function runWithPriority$1(reactPriorityLevel, fn) {
          var priorityLevel = reactPriorityToSchedulerPriority(reactPriorityLevel);
          return Scheduler_runWithPriority(priorityLevel, fn);
        }
        function scheduleCallback(reactPriorityLevel, callback, options) {
          var priorityLevel = reactPriorityToSchedulerPriority(reactPriorityLevel);
          return Scheduler_scheduleCallback(priorityLevel, callback, options);
        }
        function scheduleSyncCallback(callback) {
          if (syncQueue === null) {
            syncQueue = [callback];
            immediateQueueCallbackNode = Scheduler_scheduleCallback(Scheduler_ImmediatePriority, flushSyncCallbackQueueImpl);
          } else {
            syncQueue.push(callback);
          }
          return fakeCallbackNode;
        }
        function cancelCallback(callbackNode) {
          if (callbackNode !== fakeCallbackNode) {
            Scheduler_cancelCallback(callbackNode);
          }
        }
        function flushSyncCallbackQueue() {
          if (immediateQueueCallbackNode !== null) {
            var node2 = immediateQueueCallbackNode;
            immediateQueueCallbackNode = null;
            Scheduler_cancelCallback(node2);
          }
          flushSyncCallbackQueueImpl();
        }
        function flushSyncCallbackQueueImpl() {
          if (!isFlushingSyncQueue && syncQueue !== null) {
            isFlushingSyncQueue = true;
            var i = 0;
            try {
              var _isSync = true;
              var queue = syncQueue;
              runWithPriority$1(ImmediatePriority, function() {
                for (; i < queue.length; i++) {
                  var callback = queue[i];
                  do {
                    callback = callback(_isSync);
                  } while (callback !== null);
                }
              });
              syncQueue = null;
            } catch (error3) {
              if (syncQueue !== null) {
                syncQueue = syncQueue.slice(i + 1);
              }
              Scheduler_scheduleCallback(Scheduler_ImmediatePriority, flushSyncCallbackQueue);
              throw error3;
            } finally {
              isFlushingSyncQueue = false;
            }
          }
        }
        var NoMode = 0;
        var StrictMode = 1;
        var BlockingMode = 2;
        var ConcurrentMode = 4;
        var ProfileMode = 8;
        var MAX_SIGNED_31_BIT_INT = 1073741823;
        var NoWork = 0;
        var Never = 1;
        var Idle = 2;
        var ContinuousHydration = 3;
        var Sync = MAX_SIGNED_31_BIT_INT;
        var Batched = Sync - 1;
        var UNIT_SIZE = 10;
        var MAGIC_NUMBER_OFFSET = Batched - 1;
        function msToExpirationTime(ms) {
          return MAGIC_NUMBER_OFFSET - (ms / UNIT_SIZE | 0);
        }
        function expirationTimeToMs(expirationTime) {
          return (MAGIC_NUMBER_OFFSET - expirationTime) * UNIT_SIZE;
        }
        function ceiling(num, precision) {
          return ((num / precision | 0) + 1) * precision;
        }
        function computeExpirationBucket(currentTime, expirationInMs, bucketSizeMs) {
          return MAGIC_NUMBER_OFFSET - ceiling(MAGIC_NUMBER_OFFSET - currentTime + expirationInMs / UNIT_SIZE, bucketSizeMs / UNIT_SIZE);
        }
        var LOW_PRIORITY_EXPIRATION = 5e3;
        var LOW_PRIORITY_BATCH_SIZE = 250;
        function computeAsyncExpiration(currentTime) {
          return computeExpirationBucket(currentTime, LOW_PRIORITY_EXPIRATION, LOW_PRIORITY_BATCH_SIZE);
        }
        function computeSuspenseExpiration(currentTime, timeoutMs) {
          return computeExpirationBucket(currentTime, timeoutMs, LOW_PRIORITY_BATCH_SIZE);
        }
        var HIGH_PRIORITY_EXPIRATION = 500;
        var HIGH_PRIORITY_BATCH_SIZE = 100;
        function computeInteractiveExpiration(currentTime) {
          return computeExpirationBucket(currentTime, HIGH_PRIORITY_EXPIRATION, HIGH_PRIORITY_BATCH_SIZE);
        }
        function inferPriorityFromExpirationTime(currentTime, expirationTime) {
          if (expirationTime === Sync) {
            return ImmediatePriority;
          }
          if (expirationTime === Never || expirationTime === Idle) {
            return IdlePriority;
          }
          var msUntil = expirationTimeToMs(expirationTime) - expirationTimeToMs(currentTime);
          if (msUntil <= 0) {
            return ImmediatePriority;
          }
          if (msUntil <= HIGH_PRIORITY_EXPIRATION + HIGH_PRIORITY_BATCH_SIZE) {
            return UserBlockingPriority$1;
          }
          if (msUntil <= LOW_PRIORITY_EXPIRATION + LOW_PRIORITY_BATCH_SIZE) {
            return NormalPriority;
          }
          return IdlePriority;
        }
        var ReactStrictModeWarnings = {
          recordUnsafeLifecycleWarnings: function(fiber, instance) {
          },
          flushPendingUnsafeLifecycleWarnings: function() {
          },
          recordLegacyContextWarning: function(fiber, instance) {
          },
          flushLegacyContextWarning: function() {
          },
          discardPendingWarnings: function() {
          }
        };
        {
          var findStrictRoot = function(fiber) {
            var maybeStrictRoot = null;
            var node2 = fiber;
            while (node2 !== null) {
              if (node2.mode & StrictMode) {
                maybeStrictRoot = node2;
              }
              node2 = node2.return;
            }
            return maybeStrictRoot;
          };
          var setToSortedString = function(set5) {
            var array4 = [];
            set5.forEach(function(value) {
              array4.push(value);
            });
            return array4.sort().join(", ");
          };
          var pendingComponentWillMountWarnings = [];
          var pendingUNSAFE_ComponentWillMountWarnings = [];
          var pendingComponentWillReceivePropsWarnings = [];
          var pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
          var pendingComponentWillUpdateWarnings = [];
          var pendingUNSAFE_ComponentWillUpdateWarnings = [];
          var didWarnAboutUnsafeLifecycles = /* @__PURE__ */ new Set();
          ReactStrictModeWarnings.recordUnsafeLifecycleWarnings = function(fiber, instance) {
            if (didWarnAboutUnsafeLifecycles.has(fiber.type)) {
              return;
            }
            if (typeof instance.componentWillMount === "function" && // Don't warn about react-lifecycles-compat polyfilled components.
            instance.componentWillMount.__suppressDeprecationWarning !== true) {
              pendingComponentWillMountWarnings.push(fiber);
            }
            if (fiber.mode & StrictMode && typeof instance.UNSAFE_componentWillMount === "function") {
              pendingUNSAFE_ComponentWillMountWarnings.push(fiber);
            }
            if (typeof instance.componentWillReceiveProps === "function" && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) {
              pendingComponentWillReceivePropsWarnings.push(fiber);
            }
            if (fiber.mode & StrictMode && typeof instance.UNSAFE_componentWillReceiveProps === "function") {
              pendingUNSAFE_ComponentWillReceivePropsWarnings.push(fiber);
            }
            if (typeof instance.componentWillUpdate === "function" && instance.componentWillUpdate.__suppressDeprecationWarning !== true) {
              pendingComponentWillUpdateWarnings.push(fiber);
            }
            if (fiber.mode & StrictMode && typeof instance.UNSAFE_componentWillUpdate === "function") {
              pendingUNSAFE_ComponentWillUpdateWarnings.push(fiber);
            }
          };
          ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings = function() {
            var componentWillMountUniqueNames = /* @__PURE__ */ new Set();
            if (pendingComponentWillMountWarnings.length > 0) {
              pendingComponentWillMountWarnings.forEach(function(fiber) {
                componentWillMountUniqueNames.add(getComponentName(fiber.type) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
              });
              pendingComponentWillMountWarnings = [];
            }
            var UNSAFE_componentWillMountUniqueNames = /* @__PURE__ */ new Set();
            if (pendingUNSAFE_ComponentWillMountWarnings.length > 0) {
              pendingUNSAFE_ComponentWillMountWarnings.forEach(function(fiber) {
                UNSAFE_componentWillMountUniqueNames.add(getComponentName(fiber.type) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
              });
              pendingUNSAFE_ComponentWillMountWarnings = [];
            }
            var componentWillReceivePropsUniqueNames = /* @__PURE__ */ new Set();
            if (pendingComponentWillReceivePropsWarnings.length > 0) {
              pendingComponentWillReceivePropsWarnings.forEach(function(fiber) {
                componentWillReceivePropsUniqueNames.add(getComponentName(fiber.type) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
              });
              pendingComponentWillReceivePropsWarnings = [];
            }
            var UNSAFE_componentWillReceivePropsUniqueNames = /* @__PURE__ */ new Set();
            if (pendingUNSAFE_ComponentWillReceivePropsWarnings.length > 0) {
              pendingUNSAFE_ComponentWillReceivePropsWarnings.forEach(function(fiber) {
                UNSAFE_componentWillReceivePropsUniqueNames.add(getComponentName(fiber.type) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
              });
              pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
            }
            var componentWillUpdateUniqueNames = /* @__PURE__ */ new Set();
            if (pendingComponentWillUpdateWarnings.length > 0) {
              pendingComponentWillUpdateWarnings.forEach(function(fiber) {
                componentWillUpdateUniqueNames.add(getComponentName(fiber.type) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
              });
              pendingComponentWillUpdateWarnings = [];
            }
            var UNSAFE_componentWillUpdateUniqueNames = /* @__PURE__ */ new Set();
            if (pendingUNSAFE_ComponentWillUpdateWarnings.length > 0) {
              pendingUNSAFE_ComponentWillUpdateWarnings.forEach(function(fiber) {
                UNSAFE_componentWillUpdateUniqueNames.add(getComponentName(fiber.type) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
              });
              pendingUNSAFE_ComponentWillUpdateWarnings = [];
            }
            if (UNSAFE_componentWillMountUniqueNames.size > 0) {
              var sortedNames = setToSortedString(UNSAFE_componentWillMountUniqueNames);
              error2("Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://fb.me/react-unsafe-component-lifecycles for details.\n\n* Move code with side effects to componentDidMount, and set initial state in the constructor.\n\nPlease update the following components: %s", sortedNames);
            }
            if (UNSAFE_componentWillReceivePropsUniqueNames.size > 0) {
              var _sortedNames = setToSortedString(UNSAFE_componentWillReceivePropsUniqueNames);
              error2("Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://fb.me/react-unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://fb.me/react-derived-state\n\nPlease update the following components: %s", _sortedNames);
            }
            if (UNSAFE_componentWillUpdateUniqueNames.size > 0) {
              var _sortedNames2 = setToSortedString(UNSAFE_componentWillUpdateUniqueNames);
              error2("Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://fb.me/react-unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n\nPlease update the following components: %s", _sortedNames2);
            }
            if (componentWillMountUniqueNames.size > 0) {
              var _sortedNames3 = setToSortedString(componentWillMountUniqueNames);
              warn("componentWillMount has been renamed, and is not recommended for use. See https://fb.me/react-unsafe-component-lifecycles for details.\n\n* Move code with side effects to componentDidMount, and set initial state in the constructor.\n* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 17.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames3);
            }
            if (componentWillReceivePropsUniqueNames.size > 0) {
              var _sortedNames4 = setToSortedString(componentWillReceivePropsUniqueNames);
              warn("componentWillReceiveProps has been renamed, and is not recommended for use. See https://fb.me/react-unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://fb.me/react-derived-state\n* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 17.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames4);
            }
            if (componentWillUpdateUniqueNames.size > 0) {
              var _sortedNames5 = setToSortedString(componentWillUpdateUniqueNames);
              warn("componentWillUpdate has been renamed, and is not recommended for use. See https://fb.me/react-unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 17.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames5);
            }
          };
          var pendingLegacyContextWarning = /* @__PURE__ */ new Map();
          var didWarnAboutLegacyContext = /* @__PURE__ */ new Set();
          ReactStrictModeWarnings.recordLegacyContextWarning = function(fiber, instance) {
            var strictRoot = findStrictRoot(fiber);
            if (strictRoot === null) {
              error2("Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue.");
              return;
            }
            if (didWarnAboutLegacyContext.has(fiber.type)) {
              return;
            }
            var warningsForRoot = pendingLegacyContextWarning.get(strictRoot);
            if (fiber.type.contextTypes != null || fiber.type.childContextTypes != null || instance !== null && typeof instance.getChildContext === "function") {
              if (warningsForRoot === void 0) {
                warningsForRoot = [];
                pendingLegacyContextWarning.set(strictRoot, warningsForRoot);
              }
              warningsForRoot.push(fiber);
            }
          };
          ReactStrictModeWarnings.flushLegacyContextWarning = function() {
            pendingLegacyContextWarning.forEach(function(fiberArray, strictRoot) {
              if (fiberArray.length === 0) {
                return;
              }
              var firstFiber = fiberArray[0];
              var uniqueNames = /* @__PURE__ */ new Set();
              fiberArray.forEach(function(fiber) {
                uniqueNames.add(getComponentName(fiber.type) || "Component");
                didWarnAboutLegacyContext.add(fiber.type);
              });
              var sortedNames = setToSortedString(uniqueNames);
              var firstComponentStack = getStackByFiberInDevAndProd(firstFiber);
              error2("Legacy context API has been detected within a strict-mode tree.\n\nThe old API will be supported in all 16.x releases, but applications using it should migrate to the new version.\n\nPlease update the following components: %s\n\nLearn more about this warning here: https://fb.me/react-legacy-context%s", sortedNames, firstComponentStack);
            });
          };
          ReactStrictModeWarnings.discardPendingWarnings = function() {
            pendingComponentWillMountWarnings = [];
            pendingUNSAFE_ComponentWillMountWarnings = [];
            pendingComponentWillReceivePropsWarnings = [];
            pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
            pendingComponentWillUpdateWarnings = [];
            pendingUNSAFE_ComponentWillUpdateWarnings = [];
            pendingLegacyContextWarning = /* @__PURE__ */ new Map();
          };
        }
        var resolveFamily = null;
        var failedBoundaries = null;
        var setRefreshHandler = function(handler) {
          {
            resolveFamily = handler;
          }
        };
        function resolveFunctionForHotReloading(type5) {
          {
            if (resolveFamily === null) {
              return type5;
            }
            var family = resolveFamily(type5);
            if (family === void 0) {
              return type5;
            }
            return family.current;
          }
        }
        function resolveClassForHotReloading(type5) {
          return resolveFunctionForHotReloading(type5);
        }
        function resolveForwardRefForHotReloading(type5) {
          {
            if (resolveFamily === null) {
              return type5;
            }
            var family = resolveFamily(type5);
            if (family === void 0) {
              if (type5 !== null && type5 !== void 0 && typeof type5.render === "function") {
                var currentRender = resolveFunctionForHotReloading(type5.render);
                if (type5.render !== currentRender) {
                  var syntheticType = {
                    $$typeof: REACT_FORWARD_REF_TYPE,
                    render: currentRender
                  };
                  if (type5.displayName !== void 0) {
                    syntheticType.displayName = type5.displayName;
                  }
                  return syntheticType;
                }
              }
              return type5;
            }
            return family.current;
          }
        }
        function isCompatibleFamilyForHotReloading(fiber, element) {
          {
            if (resolveFamily === null) {
              return false;
            }
            var prevType = fiber.elementType;
            var nextType = element.type;
            var needsCompareFamilies = false;
            var $$typeofNextType = typeof nextType === "object" && nextType !== null ? nextType.$$typeof : null;
            switch (fiber.tag) {
              case ClassComponent: {
                if (typeof nextType === "function") {
                  needsCompareFamilies = true;
                }
                break;
              }
              case FunctionComponent: {
                if (typeof nextType === "function") {
                  needsCompareFamilies = true;
                } else if ($$typeofNextType === REACT_LAZY_TYPE) {
                  needsCompareFamilies = true;
                }
                break;
              }
              case ForwardRef2: {
                if ($$typeofNextType === REACT_FORWARD_REF_TYPE) {
                  needsCompareFamilies = true;
                } else if ($$typeofNextType === REACT_LAZY_TYPE) {
                  needsCompareFamilies = true;
                }
                break;
              }
              case MemoComponent:
              case SimpleMemoComponent: {
                if ($$typeofNextType === REACT_MEMO_TYPE) {
                  needsCompareFamilies = true;
                } else if ($$typeofNextType === REACT_LAZY_TYPE) {
                  needsCompareFamilies = true;
                }
                break;
              }
              default:
                return false;
            }
            if (needsCompareFamilies) {
              var prevFamily = resolveFamily(prevType);
              if (prevFamily !== void 0 && prevFamily === resolveFamily(nextType)) {
                return true;
              }
            }
            return false;
          }
        }
        function markFailedErrorBoundaryForHotReloading(fiber) {
          {
            if (resolveFamily === null) {
              return;
            }
            if (typeof WeakSet !== "function") {
              return;
            }
            if (failedBoundaries === null) {
              failedBoundaries = /* @__PURE__ */ new WeakSet();
            }
            failedBoundaries.add(fiber);
          }
        }
        var scheduleRefresh = function(root3, update) {
          {
            if (resolveFamily === null) {
              return;
            }
            var staleFamilies = update.staleFamilies, updatedFamilies = update.updatedFamilies;
            flushPassiveEffects();
            flushSync5(function() {
              scheduleFibersWithFamiliesRecursively(root3.current, updatedFamilies, staleFamilies);
            });
          }
        };
        var scheduleRoot = function(root3, element) {
          {
            if (root3.context !== emptyContextObject) {
              return;
            }
            flushPassiveEffects();
            syncUpdates(function() {
              updateContainer(element, root3, null, null);
            });
          }
        };
        function scheduleFibersWithFamiliesRecursively(fiber, updatedFamilies, staleFamilies) {
          {
            var alternate = fiber.alternate, child = fiber.child, sibling2 = fiber.sibling, tag = fiber.tag, type5 = fiber.type;
            var candidateType = null;
            switch (tag) {
              case FunctionComponent:
              case SimpleMemoComponent:
              case ClassComponent:
                candidateType = type5;
                break;
              case ForwardRef2:
                candidateType = type5.render;
                break;
            }
            if (resolveFamily === null) {
              throw new Error("Expected resolveFamily to be set during hot reload.");
            }
            var needsRender = false;
            var needsRemount = false;
            if (candidateType !== null) {
              var family = resolveFamily(candidateType);
              if (family !== void 0) {
                if (staleFamilies.has(family)) {
                  needsRemount = true;
                } else if (updatedFamilies.has(family)) {
                  if (tag === ClassComponent) {
                    needsRemount = true;
                  } else {
                    needsRender = true;
                  }
                }
              }
            }
            if (failedBoundaries !== null) {
              if (failedBoundaries.has(fiber) || alternate !== null && failedBoundaries.has(alternate)) {
                needsRemount = true;
              }
            }
            if (needsRemount) {
              fiber._debugNeedsRemount = true;
            }
            if (needsRemount || needsRender) {
              scheduleWork(fiber, Sync);
            }
            if (child !== null && !needsRemount) {
              scheduleFibersWithFamiliesRecursively(child, updatedFamilies, staleFamilies);
            }
            if (sibling2 !== null) {
              scheduleFibersWithFamiliesRecursively(sibling2, updatedFamilies, staleFamilies);
            }
          }
        }
        var findHostInstancesForRefresh = function(root3, families) {
          {
            var hostInstances = /* @__PURE__ */ new Set();
            var types3 = new Set(families.map(function(family) {
              return family.current;
            }));
            findHostInstancesForMatchingFibersRecursively(root3.current, types3, hostInstances);
            return hostInstances;
          }
        };
        function findHostInstancesForMatchingFibersRecursively(fiber, types3, hostInstances) {
          {
            var child = fiber.child, sibling2 = fiber.sibling, tag = fiber.tag, type5 = fiber.type;
            var candidateType = null;
            switch (tag) {
              case FunctionComponent:
              case SimpleMemoComponent:
              case ClassComponent:
                candidateType = type5;
                break;
              case ForwardRef2:
                candidateType = type5.render;
                break;
            }
            var didMatch = false;
            if (candidateType !== null) {
              if (types3.has(candidateType)) {
                didMatch = true;
              }
            }
            if (didMatch) {
              findHostInstancesForFiberShallowly(fiber, hostInstances);
            } else {
              if (child !== null) {
                findHostInstancesForMatchingFibersRecursively(child, types3, hostInstances);
              }
            }
            if (sibling2 !== null) {
              findHostInstancesForMatchingFibersRecursively(sibling2, types3, hostInstances);
            }
          }
        }
        function findHostInstancesForFiberShallowly(fiber, hostInstances) {
          {
            var foundHostInstances = findChildHostInstancesForFiberShallowly(fiber, hostInstances);
            if (foundHostInstances) {
              return;
            }
            var node2 = fiber;
            while (true) {
              switch (node2.tag) {
                case HostComponent:
                  hostInstances.add(node2.stateNode);
                  return;
                case HostPortal:
                  hostInstances.add(node2.stateNode.containerInfo);
                  return;
                case HostRoot:
                  hostInstances.add(node2.stateNode.containerInfo);
                  return;
              }
              if (node2.return === null) {
                throw new Error("Expected to reach root first.");
              }
              node2 = node2.return;
            }
          }
        }
        function findChildHostInstancesForFiberShallowly(fiber, hostInstances) {
          {
            var node2 = fiber;
            var foundHostInstances = false;
            while (true) {
              if (node2.tag === HostComponent) {
                foundHostInstances = true;
                hostInstances.add(node2.stateNode);
              } else if (node2.child !== null) {
                node2.child.return = node2;
                node2 = node2.child;
                continue;
              }
              if (node2 === fiber) {
                return foundHostInstances;
              }
              while (node2.sibling === null) {
                if (node2.return === null || node2.return === fiber) {
                  return foundHostInstances;
                }
                node2 = node2.return;
              }
              node2.sibling.return = node2.return;
              node2 = node2.sibling;
            }
          }
          return false;
        }
        function resolveDefaultProps(Component10, baseProps) {
          if (Component10 && Component10.defaultProps) {
            var props = _assign({}, baseProps);
            var defaultProps2 = Component10.defaultProps;
            for (var propName in defaultProps2) {
              if (props[propName] === void 0) {
                props[propName] = defaultProps2[propName];
              }
            }
            return props;
          }
          return baseProps;
        }
        function readLazyComponentType(lazyComponent) {
          initializeLazyComponentType(lazyComponent);
          if (lazyComponent._status !== Resolved) {
            throw lazyComponent._result;
          }
          return lazyComponent._result;
        }
        var valueCursor = createCursor(null);
        var rendererSigil;
        {
          rendererSigil = {};
        }
        var currentlyRenderingFiber = null;
        var lastContextDependency = null;
        var lastContextWithAllBitsObserved = null;
        var isDisallowedContextReadInDEV = false;
        function resetContextDependencies() {
          currentlyRenderingFiber = null;
          lastContextDependency = null;
          lastContextWithAllBitsObserved = null;
          {
            isDisallowedContextReadInDEV = false;
          }
        }
        function enterDisallowedContextReadInDEV() {
          {
            isDisallowedContextReadInDEV = true;
          }
        }
        function exitDisallowedContextReadInDEV() {
          {
            isDisallowedContextReadInDEV = false;
          }
        }
        function pushProvider(providerFiber, nextValue) {
          var context = providerFiber.type._context;
          {
            push(valueCursor, context._currentValue, providerFiber);
            context._currentValue = nextValue;
            {
              if (context._currentRenderer !== void 0 && context._currentRenderer !== null && context._currentRenderer !== rendererSigil) {
                error2("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported.");
              }
              context._currentRenderer = rendererSigil;
            }
          }
        }
        function popProvider(providerFiber) {
          var currentValue = valueCursor.current;
          pop(valueCursor, providerFiber);
          var context = providerFiber.type._context;
          {
            context._currentValue = currentValue;
          }
        }
        function calculateChangedBits(context, newValue, oldValue) {
          if (objectIs(oldValue, newValue)) {
            return 0;
          } else {
            var changedBits = typeof context._calculateChangedBits === "function" ? context._calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
            {
              if ((changedBits & MAX_SIGNED_31_BIT_INT) !== changedBits) {
                error2("calculateChangedBits: Expected the return value to be a 31-bit integer. Instead received: %s", changedBits);
              }
            }
            return changedBits | 0;
          }
        }
        function scheduleWorkOnParentPath(parent2, renderExpirationTime2) {
          var node2 = parent2;
          while (node2 !== null) {
            var alternate = node2.alternate;
            if (node2.childExpirationTime < renderExpirationTime2) {
              node2.childExpirationTime = renderExpirationTime2;
              if (alternate !== null && alternate.childExpirationTime < renderExpirationTime2) {
                alternate.childExpirationTime = renderExpirationTime2;
              }
            } else if (alternate !== null && alternate.childExpirationTime < renderExpirationTime2) {
              alternate.childExpirationTime = renderExpirationTime2;
            } else {
              break;
            }
            node2 = node2.return;
          }
        }
        function propagateContextChange(workInProgress2, context, changedBits, renderExpirationTime2) {
          var fiber = workInProgress2.child;
          if (fiber !== null) {
            fiber.return = workInProgress2;
          }
          while (fiber !== null) {
            var nextFiber = void 0;
            var list = fiber.dependencies;
            if (list !== null) {
              nextFiber = fiber.child;
              var dependency = list.firstContext;
              while (dependency !== null) {
                if (dependency.context === context && (dependency.observedBits & changedBits) !== 0) {
                  if (fiber.tag === ClassComponent) {
                    var update = createUpdate(renderExpirationTime2, null);
                    update.tag = ForceUpdate;
                    enqueueUpdate(fiber, update);
                  }
                  if (fiber.expirationTime < renderExpirationTime2) {
                    fiber.expirationTime = renderExpirationTime2;
                  }
                  var alternate = fiber.alternate;
                  if (alternate !== null && alternate.expirationTime < renderExpirationTime2) {
                    alternate.expirationTime = renderExpirationTime2;
                  }
                  scheduleWorkOnParentPath(fiber.return, renderExpirationTime2);
                  if (list.expirationTime < renderExpirationTime2) {
                    list.expirationTime = renderExpirationTime2;
                  }
                  break;
                }
                dependency = dependency.next;
              }
            } else if (fiber.tag === ContextProvider) {
              nextFiber = fiber.type === workInProgress2.type ? null : fiber.child;
            } else {
              nextFiber = fiber.child;
            }
            if (nextFiber !== null) {
              nextFiber.return = fiber;
            } else {
              nextFiber = fiber;
              while (nextFiber !== null) {
                if (nextFiber === workInProgress2) {
                  nextFiber = null;
                  break;
                }
                var sibling2 = nextFiber.sibling;
                if (sibling2 !== null) {
                  sibling2.return = nextFiber.return;
                  nextFiber = sibling2;
                  break;
                }
                nextFiber = nextFiber.return;
              }
            }
            fiber = nextFiber;
          }
        }
        function prepareToReadContext(workInProgress2, renderExpirationTime2) {
          currentlyRenderingFiber = workInProgress2;
          lastContextDependency = null;
          lastContextWithAllBitsObserved = null;
          var dependencies = workInProgress2.dependencies;
          if (dependencies !== null) {
            var firstContext = dependencies.firstContext;
            if (firstContext !== null) {
              if (dependencies.expirationTime >= renderExpirationTime2) {
                markWorkInProgressReceivedUpdate();
              }
              dependencies.firstContext = null;
            }
          }
        }
        function readContext(context, observedBits) {
          {
            if (isDisallowedContextReadInDEV) {
              error2("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
            }
          }
          if (lastContextWithAllBitsObserved === context) ;
          else if (observedBits === false || observedBits === 0) ;
          else {
            var resolvedObservedBits;
            if (typeof observedBits !== "number" || observedBits === MAX_SIGNED_31_BIT_INT) {
              lastContextWithAllBitsObserved = context;
              resolvedObservedBits = MAX_SIGNED_31_BIT_INT;
            } else {
              resolvedObservedBits = observedBits;
            }
            var contextItem = {
              context,
              observedBits: resolvedObservedBits,
              next: null
            };
            if (lastContextDependency === null) {
              if (!(currentlyRenderingFiber !== null)) {
                {
                  throw Error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
                }
              }
              lastContextDependency = contextItem;
              currentlyRenderingFiber.dependencies = {
                expirationTime: NoWork,
                firstContext: contextItem,
                responders: null
              };
            } else {
              lastContextDependency = lastContextDependency.next = contextItem;
            }
          }
          return context._currentValue;
        }
        var UpdateState = 0;
        var ReplaceState = 1;
        var ForceUpdate = 2;
        var CaptureUpdate = 3;
        var hasForceUpdate = false;
        var didWarnUpdateInsideUpdate;
        var currentlyProcessingQueue;
        {
          didWarnUpdateInsideUpdate = false;
          currentlyProcessingQueue = null;
        }
        function initializeUpdateQueue(fiber) {
          var queue = {
            baseState: fiber.memoizedState,
            baseQueue: null,
            shared: {
              pending: null
            },
            effects: null
          };
          fiber.updateQueue = queue;
        }
        function cloneUpdateQueue(current3, workInProgress2) {
          var queue = workInProgress2.updateQueue;
          var currentQueue = current3.updateQueue;
          if (queue === currentQueue) {
            var clone = {
              baseState: currentQueue.baseState,
              baseQueue: currentQueue.baseQueue,
              shared: currentQueue.shared,
              effects: currentQueue.effects
            };
            workInProgress2.updateQueue = clone;
          }
        }
        function createUpdate(expirationTime, suspenseConfig) {
          var update = {
            expirationTime,
            suspenseConfig,
            tag: UpdateState,
            payload: null,
            callback: null,
            next: null
          };
          update.next = update;
          {
            update.priority = getCurrentPriorityLevel();
          }
          return update;
        }
        function enqueueUpdate(fiber, update) {
          var updateQueue = fiber.updateQueue;
          if (updateQueue === null) {
            return;
          }
          var sharedQueue = updateQueue.shared;
          var pending = sharedQueue.pending;
          if (pending === null) {
            update.next = update;
          } else {
            update.next = pending.next;
            pending.next = update;
          }
          sharedQueue.pending = update;
          {
            if (currentlyProcessingQueue === sharedQueue && !didWarnUpdateInsideUpdate) {
              error2("An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback.");
              didWarnUpdateInsideUpdate = true;
            }
          }
        }
        function enqueueCapturedUpdate(workInProgress2, update) {
          var current3 = workInProgress2.alternate;
          if (current3 !== null) {
            cloneUpdateQueue(current3, workInProgress2);
          }
          var queue = workInProgress2.updateQueue;
          var last2 = queue.baseQueue;
          if (last2 === null) {
            queue.baseQueue = update.next = update;
            update.next = update;
          } else {
            update.next = last2.next;
            last2.next = update;
          }
        }
        function getStateFromUpdate(workInProgress2, queue, update, prevState, nextProps, instance) {
          switch (update.tag) {
            case ReplaceState: {
              var payload = update.payload;
              if (typeof payload === "function") {
                {
                  enterDisallowedContextReadInDEV();
                  if (workInProgress2.mode & StrictMode) {
                    payload.call(instance, prevState, nextProps);
                  }
                }
                var nextState = payload.call(instance, prevState, nextProps);
                {
                  exitDisallowedContextReadInDEV();
                }
                return nextState;
              }
              return payload;
            }
            case CaptureUpdate: {
              workInProgress2.effectTag = workInProgress2.effectTag & ~ShouldCapture | DidCapture;
            }
            // Intentional fallthrough
            case UpdateState: {
              var _payload = update.payload;
              var partialState;
              if (typeof _payload === "function") {
                {
                  enterDisallowedContextReadInDEV();
                  if (workInProgress2.mode & StrictMode) {
                    _payload.call(instance, prevState, nextProps);
                  }
                }
                partialState = _payload.call(instance, prevState, nextProps);
                {
                  exitDisallowedContextReadInDEV();
                }
              } else {
                partialState = _payload;
              }
              if (partialState === null || partialState === void 0) {
                return prevState;
              }
              return _assign({}, prevState, partialState);
            }
            case ForceUpdate: {
              hasForceUpdate = true;
              return prevState;
            }
          }
          return prevState;
        }
        function processUpdateQueue(workInProgress2, props, instance, renderExpirationTime2) {
          var queue = workInProgress2.updateQueue;
          hasForceUpdate = false;
          {
            currentlyProcessingQueue = queue.shared;
          }
          var baseQueue = queue.baseQueue;
          var pendingQueue = queue.shared.pending;
          if (pendingQueue !== null) {
            if (baseQueue !== null) {
              var baseFirst = baseQueue.next;
              var pendingFirst = pendingQueue.next;
              baseQueue.next = pendingFirst;
              pendingQueue.next = baseFirst;
            }
            baseQueue = pendingQueue;
            queue.shared.pending = null;
            var current3 = workInProgress2.alternate;
            if (current3 !== null) {
              var currentQueue = current3.updateQueue;
              if (currentQueue !== null) {
                currentQueue.baseQueue = pendingQueue;
              }
            }
          }
          if (baseQueue !== null) {
            var first = baseQueue.next;
            var newState = queue.baseState;
            var newExpirationTime = NoWork;
            var newBaseState = null;
            var newBaseQueueFirst = null;
            var newBaseQueueLast = null;
            if (first !== null) {
              var update = first;
              do {
                var updateExpirationTime = update.expirationTime;
                if (updateExpirationTime < renderExpirationTime2) {
                  var clone = {
                    expirationTime: update.expirationTime,
                    suspenseConfig: update.suspenseConfig,
                    tag: update.tag,
                    payload: update.payload,
                    callback: update.callback,
                    next: null
                  };
                  if (newBaseQueueLast === null) {
                    newBaseQueueFirst = newBaseQueueLast = clone;
                    newBaseState = newState;
                  } else {
                    newBaseQueueLast = newBaseQueueLast.next = clone;
                  }
                  if (updateExpirationTime > newExpirationTime) {
                    newExpirationTime = updateExpirationTime;
                  }
                } else {
                  if (newBaseQueueLast !== null) {
                    var _clone = {
                      expirationTime: Sync,
                      // This update is going to be committed so we never want uncommit it.
                      suspenseConfig: update.suspenseConfig,
                      tag: update.tag,
                      payload: update.payload,
                      callback: update.callback,
                      next: null
                    };
                    newBaseQueueLast = newBaseQueueLast.next = _clone;
                  }
                  markRenderEventTimeAndConfig(updateExpirationTime, update.suspenseConfig);
                  newState = getStateFromUpdate(workInProgress2, queue, update, newState, props, instance);
                  var callback = update.callback;
                  if (callback !== null) {
                    workInProgress2.effectTag |= Callback;
                    var effects = queue.effects;
                    if (effects === null) {
                      queue.effects = [update];
                    } else {
                      effects.push(update);
                    }
                  }
                }
                update = update.next;
                if (update === null || update === first) {
                  pendingQueue = queue.shared.pending;
                  if (pendingQueue === null) {
                    break;
                  } else {
                    update = baseQueue.next = pendingQueue.next;
                    pendingQueue.next = first;
                    queue.baseQueue = baseQueue = pendingQueue;
                    queue.shared.pending = null;
                  }
                }
              } while (true);
            }
            if (newBaseQueueLast === null) {
              newBaseState = newState;
            } else {
              newBaseQueueLast.next = newBaseQueueFirst;
            }
            queue.baseState = newBaseState;
            queue.baseQueue = newBaseQueueLast;
            markUnprocessedUpdateTime(newExpirationTime);
            workInProgress2.expirationTime = newExpirationTime;
            workInProgress2.memoizedState = newState;
          }
          {
            currentlyProcessingQueue = null;
          }
        }
        function callCallback(callback, context) {
          if (!(typeof callback === "function")) {
            {
              throw Error("Invalid argument passed as callback. Expected a function. Instead received: " + callback);
            }
          }
          callback.call(context);
        }
        function resetHasForceUpdateBeforeProcessing() {
          hasForceUpdate = false;
        }
        function checkHasForceUpdateAfterProcessing() {
          return hasForceUpdate;
        }
        function commitUpdateQueue(finishedWork, finishedQueue, instance) {
          var effects = finishedQueue.effects;
          finishedQueue.effects = null;
          if (effects !== null) {
            for (var i = 0; i < effects.length; i++) {
              var effect = effects[i];
              var callback = effect.callback;
              if (callback !== null) {
                effect.callback = null;
                callCallback(callback, instance);
              }
            }
          }
        }
        var ReactCurrentBatchConfig = ReactSharedInternals.ReactCurrentBatchConfig;
        function requestCurrentSuspenseConfig() {
          return ReactCurrentBatchConfig.suspense;
        }
        var fakeInternalInstance = {};
        var isArray6 = Array.isArray;
        var emptyRefsObject = new React615.Component().refs;
        var didWarnAboutStateAssignmentForComponent;
        var didWarnAboutUninitializedState;
        var didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate;
        var didWarnAboutLegacyLifecyclesAndDerivedState;
        var didWarnAboutUndefinedDerivedState;
        var warnOnUndefinedDerivedState;
        var warnOnInvalidCallback;
        var didWarnAboutDirectlyAssigningPropsToState;
        var didWarnAboutContextTypeAndContextTypes;
        var didWarnAboutInvalidateContextType;
        {
          didWarnAboutStateAssignmentForComponent = /* @__PURE__ */ new Set();
          didWarnAboutUninitializedState = /* @__PURE__ */ new Set();
          didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate = /* @__PURE__ */ new Set();
          didWarnAboutLegacyLifecyclesAndDerivedState = /* @__PURE__ */ new Set();
          didWarnAboutDirectlyAssigningPropsToState = /* @__PURE__ */ new Set();
          didWarnAboutUndefinedDerivedState = /* @__PURE__ */ new Set();
          didWarnAboutContextTypeAndContextTypes = /* @__PURE__ */ new Set();
          didWarnAboutInvalidateContextType = /* @__PURE__ */ new Set();
          var didWarnOnInvalidCallback = /* @__PURE__ */ new Set();
          warnOnInvalidCallback = function(callback, callerName) {
            if (callback === null || typeof callback === "function") {
              return;
            }
            var key2 = callerName + "_" + callback;
            if (!didWarnOnInvalidCallback.has(key2)) {
              didWarnOnInvalidCallback.add(key2);
              error2("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callerName, callback);
            }
          };
          warnOnUndefinedDerivedState = function(type5, partialState) {
            if (partialState === void 0) {
              var componentName = getComponentName(type5) || "Component";
              if (!didWarnAboutUndefinedDerivedState.has(componentName)) {
                didWarnAboutUndefinedDerivedState.add(componentName);
                error2("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", componentName);
              }
            }
          };
          Object.defineProperty(fakeInternalInstance, "_processChildContext", {
            enumerable: false,
            value: function() {
              {
                {
                  throw Error("_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn't supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal).");
                }
              }
            }
          });
          Object.freeze(fakeInternalInstance);
        }
        function applyDerivedStateFromProps(workInProgress2, ctor, getDerivedStateFromProps, nextProps) {
          var prevState = workInProgress2.memoizedState;
          {
            if (workInProgress2.mode & StrictMode) {
              getDerivedStateFromProps(nextProps, prevState);
            }
          }
          var partialState = getDerivedStateFromProps(nextProps, prevState);
          {
            warnOnUndefinedDerivedState(ctor, partialState);
          }
          var memoizedState = partialState === null || partialState === void 0 ? prevState : _assign({}, prevState, partialState);
          workInProgress2.memoizedState = memoizedState;
          if (workInProgress2.expirationTime === NoWork) {
            var updateQueue = workInProgress2.updateQueue;
            updateQueue.baseState = memoizedState;
          }
        }
        var classComponentUpdater = {
          isMounted,
          enqueueSetState: function(inst, payload, callback) {
            var fiber = get3(inst);
            var currentTime = requestCurrentTimeForUpdate();
            var suspenseConfig = requestCurrentSuspenseConfig();
            var expirationTime = computeExpirationForFiber(currentTime, fiber, suspenseConfig);
            var update = createUpdate(expirationTime, suspenseConfig);
            update.payload = payload;
            if (callback !== void 0 && callback !== null) {
              {
                warnOnInvalidCallback(callback, "setState");
              }
              update.callback = callback;
            }
            enqueueUpdate(fiber, update);
            scheduleWork(fiber, expirationTime);
          },
          enqueueReplaceState: function(inst, payload, callback) {
            var fiber = get3(inst);
            var currentTime = requestCurrentTimeForUpdate();
            var suspenseConfig = requestCurrentSuspenseConfig();
            var expirationTime = computeExpirationForFiber(currentTime, fiber, suspenseConfig);
            var update = createUpdate(expirationTime, suspenseConfig);
            update.tag = ReplaceState;
            update.payload = payload;
            if (callback !== void 0 && callback !== null) {
              {
                warnOnInvalidCallback(callback, "replaceState");
              }
              update.callback = callback;
            }
            enqueueUpdate(fiber, update);
            scheduleWork(fiber, expirationTime);
          },
          enqueueForceUpdate: function(inst, callback) {
            var fiber = get3(inst);
            var currentTime = requestCurrentTimeForUpdate();
            var suspenseConfig = requestCurrentSuspenseConfig();
            var expirationTime = computeExpirationForFiber(currentTime, fiber, suspenseConfig);
            var update = createUpdate(expirationTime, suspenseConfig);
            update.tag = ForceUpdate;
            if (callback !== void 0 && callback !== null) {
              {
                warnOnInvalidCallback(callback, "forceUpdate");
              }
              update.callback = callback;
            }
            enqueueUpdate(fiber, update);
            scheduleWork(fiber, expirationTime);
          }
        };
        function checkShouldComponentUpdate(workInProgress2, ctor, oldProps, newProps, oldState, newState, nextContext) {
          var instance = workInProgress2.stateNode;
          if (typeof instance.shouldComponentUpdate === "function") {
            {
              if (workInProgress2.mode & StrictMode) {
                instance.shouldComponentUpdate(newProps, newState, nextContext);
              }
            }
            startPhaseTimer(workInProgress2, "shouldComponentUpdate");
            var shouldUpdate = instance.shouldComponentUpdate(newProps, newState, nextContext);
            stopPhaseTimer();
            {
              if (shouldUpdate === void 0) {
                error2("%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.", getComponentName(ctor) || "Component");
              }
            }
            return shouldUpdate;
          }
          if (ctor.prototype && ctor.prototype.isPureReactComponent) {
            return !shallowEqual(oldProps, newProps) || !shallowEqual(oldState, newState);
          }
          return true;
        }
        function checkClassInstance(workInProgress2, ctor, newProps) {
          var instance = workInProgress2.stateNode;
          {
            var name = getComponentName(ctor) || "Component";
            var renderPresent = instance.render;
            if (!renderPresent) {
              if (ctor.prototype && typeof ctor.prototype.render === "function") {
                error2("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", name);
              } else {
                error2("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", name);
              }
            }
            if (instance.getInitialState && !instance.getInitialState.isReactClassApproved && !instance.state) {
              error2("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", name);
            }
            if (instance.getDefaultProps && !instance.getDefaultProps.isReactClassApproved) {
              error2("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", name);
            }
            if (instance.propTypes) {
              error2("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", name);
            }
            if (instance.contextType) {
              error2("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", name);
            }
            {
              if (instance.contextTypes) {
                error2("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", name);
              }
              if (ctor.contextType && ctor.contextTypes && !didWarnAboutContextTypeAndContextTypes.has(ctor)) {
                didWarnAboutContextTypeAndContextTypes.add(ctor);
                error2("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", name);
              }
            }
            if (typeof instance.componentShouldUpdate === "function") {
              error2("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", name);
            }
            if (ctor.prototype && ctor.prototype.isPureReactComponent && typeof instance.shouldComponentUpdate !== "undefined") {
              error2("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", getComponentName(ctor) || "A pure component");
            }
            if (typeof instance.componentDidUnmount === "function") {
              error2("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", name);
            }
            if (typeof instance.componentDidReceiveProps === "function") {
              error2("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", name);
            }
            if (typeof instance.componentWillRecieveProps === "function") {
              error2("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", name);
            }
            if (typeof instance.UNSAFE_componentWillRecieveProps === "function") {
              error2("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", name);
            }
            var hasMutatedProps = instance.props !== newProps;
            if (instance.props !== void 0 && hasMutatedProps) {
              error2("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", name, name);
            }
            if (instance.defaultProps) {
              error2("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", name, name);
            }
            if (typeof instance.getSnapshotBeforeUpdate === "function" && typeof instance.componentDidUpdate !== "function" && !didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.has(ctor)) {
              didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.add(ctor);
              error2("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", getComponentName(ctor));
            }
            if (typeof instance.getDerivedStateFromProps === "function") {
              error2("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", name);
            }
            if (typeof instance.getDerivedStateFromError === "function") {
              error2("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", name);
            }
            if (typeof ctor.getSnapshotBeforeUpdate === "function") {
              error2("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", name);
            }
            var _state = instance.state;
            if (_state && (typeof _state !== "object" || isArray6(_state))) {
              error2("%s.state: must be set to an object or null", name);
            }
            if (typeof instance.getChildContext === "function" && typeof ctor.childContextTypes !== "object") {
              error2("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", name);
            }
          }
        }
        function adoptClassInstance(workInProgress2, instance) {
          instance.updater = classComponentUpdater;
          workInProgress2.stateNode = instance;
          set4(instance, workInProgress2);
          {
            instance._reactInternalInstance = fakeInternalInstance;
          }
        }
        function constructClassInstance(workInProgress2, ctor, props) {
          var isLegacyContextConsumer = false;
          var unmaskedContext = emptyContextObject;
          var context = emptyContextObject;
          var contextType = ctor.contextType;
          {
            if ("contextType" in ctor) {
              var isValid2 = (
                // Allow null for conditional declaration
                contextType === null || contextType !== void 0 && contextType.$$typeof === REACT_CONTEXT_TYPE && contextType._context === void 0
              );
              if (!isValid2 && !didWarnAboutInvalidateContextType.has(ctor)) {
                didWarnAboutInvalidateContextType.add(ctor);
                var addendum = "";
                if (contextType === void 0) {
                  addendum = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file.";
                } else if (typeof contextType !== "object") {
                  addendum = " However, it is set to a " + typeof contextType + ".";
                } else if (contextType.$$typeof === REACT_PROVIDER_TYPE) {
                  addendum = " Did you accidentally pass the Context.Provider instead?";
                } else if (contextType._context !== void 0) {
                  addendum = " Did you accidentally pass the Context.Consumer instead?";
                } else {
                  addendum = " However, it is set to an object with keys {" + Object.keys(contextType).join(", ") + "}.";
                }
                error2("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", getComponentName(ctor) || "Component", addendum);
              }
            }
          }
          if (typeof contextType === "object" && contextType !== null) {
            context = readContext(contextType);
          } else {
            unmaskedContext = getUnmaskedContext(workInProgress2, ctor, true);
            var contextTypes = ctor.contextTypes;
            isLegacyContextConsumer = contextTypes !== null && contextTypes !== void 0;
            context = isLegacyContextConsumer ? getMaskedContext(workInProgress2, unmaskedContext) : emptyContextObject;
          }
          {
            if (workInProgress2.mode & StrictMode) {
              new ctor(props, context);
            }
          }
          var instance = new ctor(props, context);
          var state = workInProgress2.memoizedState = instance.state !== null && instance.state !== void 0 ? instance.state : null;
          adoptClassInstance(workInProgress2, instance);
          {
            if (typeof ctor.getDerivedStateFromProps === "function" && state === null) {
              var componentName = getComponentName(ctor) || "Component";
              if (!didWarnAboutUninitializedState.has(componentName)) {
                didWarnAboutUninitializedState.add(componentName);
                error2("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", componentName, instance.state === null ? "null" : "undefined", componentName);
              }
            }
            if (typeof ctor.getDerivedStateFromProps === "function" || typeof instance.getSnapshotBeforeUpdate === "function") {
              var foundWillMountName = null;
              var foundWillReceivePropsName = null;
              var foundWillUpdateName = null;
              if (typeof instance.componentWillMount === "function" && instance.componentWillMount.__suppressDeprecationWarning !== true) {
                foundWillMountName = "componentWillMount";
              } else if (typeof instance.UNSAFE_componentWillMount === "function") {
                foundWillMountName = "UNSAFE_componentWillMount";
              }
              if (typeof instance.componentWillReceiveProps === "function" && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) {
                foundWillReceivePropsName = "componentWillReceiveProps";
              } else if (typeof instance.UNSAFE_componentWillReceiveProps === "function") {
                foundWillReceivePropsName = "UNSAFE_componentWillReceiveProps";
              }
              if (typeof instance.componentWillUpdate === "function" && instance.componentWillUpdate.__suppressDeprecationWarning !== true) {
                foundWillUpdateName = "componentWillUpdate";
              } else if (typeof instance.UNSAFE_componentWillUpdate === "function") {
                foundWillUpdateName = "UNSAFE_componentWillUpdate";
              }
              if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
                var _componentName = getComponentName(ctor) || "Component";
                var newApiName = typeof ctor.getDerivedStateFromProps === "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
                if (!didWarnAboutLegacyLifecyclesAndDerivedState.has(_componentName)) {
                  didWarnAboutLegacyLifecyclesAndDerivedState.add(_componentName);
                  error2("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n%s uses %s but also contains the following legacy lifecycles:%s%s%s\n\nThe above lifecycles should be removed. Learn more about this warning here:\nhttps://fb.me/react-unsafe-component-lifecycles", _componentName, newApiName, foundWillMountName !== null ? "\n  " + foundWillMountName : "", foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : "", foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : "");
                }
              }
            }
          }
          if (isLegacyContextConsumer) {
            cacheContext(workInProgress2, unmaskedContext, context);
          }
          return instance;
        }
        function callComponentWillMount(workInProgress2, instance) {
          startPhaseTimer(workInProgress2, "componentWillMount");
          var oldState = instance.state;
          if (typeof instance.componentWillMount === "function") {
            instance.componentWillMount();
          }
          if (typeof instance.UNSAFE_componentWillMount === "function") {
            instance.UNSAFE_componentWillMount();
          }
          stopPhaseTimer();
          if (oldState !== instance.state) {
            {
              error2("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", getComponentName(workInProgress2.type) || "Component");
            }
            classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
          }
        }
        function callComponentWillReceiveProps(workInProgress2, instance, newProps, nextContext) {
          var oldState = instance.state;
          startPhaseTimer(workInProgress2, "componentWillReceiveProps");
          if (typeof instance.componentWillReceiveProps === "function") {
            instance.componentWillReceiveProps(newProps, nextContext);
          }
          if (typeof instance.UNSAFE_componentWillReceiveProps === "function") {
            instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
          }
          stopPhaseTimer();
          if (instance.state !== oldState) {
            {
              var componentName = getComponentName(workInProgress2.type) || "Component";
              if (!didWarnAboutStateAssignmentForComponent.has(componentName)) {
                didWarnAboutStateAssignmentForComponent.add(componentName);
                error2("%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", componentName);
              }
            }
            classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
          }
        }
        function mountClassInstance(workInProgress2, ctor, newProps, renderExpirationTime2) {
          {
            checkClassInstance(workInProgress2, ctor, newProps);
          }
          var instance = workInProgress2.stateNode;
          instance.props = newProps;
          instance.state = workInProgress2.memoizedState;
          instance.refs = emptyRefsObject;
          initializeUpdateQueue(workInProgress2);
          var contextType = ctor.contextType;
          if (typeof contextType === "object" && contextType !== null) {
            instance.context = readContext(contextType);
          } else {
            var unmaskedContext = getUnmaskedContext(workInProgress2, ctor, true);
            instance.context = getMaskedContext(workInProgress2, unmaskedContext);
          }
          {
            if (instance.state === newProps) {
              var componentName = getComponentName(ctor) || "Component";
              if (!didWarnAboutDirectlyAssigningPropsToState.has(componentName)) {
                didWarnAboutDirectlyAssigningPropsToState.add(componentName);
                error2("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", componentName);
              }
            }
            if (workInProgress2.mode & StrictMode) {
              ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress2, instance);
            }
            {
              ReactStrictModeWarnings.recordUnsafeLifecycleWarnings(workInProgress2, instance);
            }
          }
          processUpdateQueue(workInProgress2, newProps, instance, renderExpirationTime2);
          instance.state = workInProgress2.memoizedState;
          var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
          if (typeof getDerivedStateFromProps === "function") {
            applyDerivedStateFromProps(workInProgress2, ctor, getDerivedStateFromProps, newProps);
            instance.state = workInProgress2.memoizedState;
          }
          if (typeof ctor.getDerivedStateFromProps !== "function" && typeof instance.getSnapshotBeforeUpdate !== "function" && (typeof instance.UNSAFE_componentWillMount === "function" || typeof instance.componentWillMount === "function")) {
            callComponentWillMount(workInProgress2, instance);
            processUpdateQueue(workInProgress2, newProps, instance, renderExpirationTime2);
            instance.state = workInProgress2.memoizedState;
          }
          if (typeof instance.componentDidMount === "function") {
            workInProgress2.effectTag |= Update;
          }
        }
        function resumeMountClassInstance(workInProgress2, ctor, newProps, renderExpirationTime2) {
          var instance = workInProgress2.stateNode;
          var oldProps = workInProgress2.memoizedProps;
          instance.props = oldProps;
          var oldContext = instance.context;
          var contextType = ctor.contextType;
          var nextContext = emptyContextObject;
          if (typeof contextType === "object" && contextType !== null) {
            nextContext = readContext(contextType);
          } else {
            var nextLegacyUnmaskedContext = getUnmaskedContext(workInProgress2, ctor, true);
            nextContext = getMaskedContext(workInProgress2, nextLegacyUnmaskedContext);
          }
          var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
          var hasNewLifecycles = typeof getDerivedStateFromProps === "function" || typeof instance.getSnapshotBeforeUpdate === "function";
          if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillReceiveProps === "function" || typeof instance.componentWillReceiveProps === "function")) {
            if (oldProps !== newProps || oldContext !== nextContext) {
              callComponentWillReceiveProps(workInProgress2, instance, newProps, nextContext);
            }
          }
          resetHasForceUpdateBeforeProcessing();
          var oldState = workInProgress2.memoizedState;
          var newState = instance.state = oldState;
          processUpdateQueue(workInProgress2, newProps, instance, renderExpirationTime2);
          newState = workInProgress2.memoizedState;
          if (oldProps === newProps && oldState === newState && !hasContextChanged() && !checkHasForceUpdateAfterProcessing()) {
            if (typeof instance.componentDidMount === "function") {
              workInProgress2.effectTag |= Update;
            }
            return false;
          }
          if (typeof getDerivedStateFromProps === "function") {
            applyDerivedStateFromProps(workInProgress2, ctor, getDerivedStateFromProps, newProps);
            newState = workInProgress2.memoizedState;
          }
          var shouldUpdate = checkHasForceUpdateAfterProcessing() || checkShouldComponentUpdate(workInProgress2, ctor, oldProps, newProps, oldState, newState, nextContext);
          if (shouldUpdate) {
            if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillMount === "function" || typeof instance.componentWillMount === "function")) {
              startPhaseTimer(workInProgress2, "componentWillMount");
              if (typeof instance.componentWillMount === "function") {
                instance.componentWillMount();
              }
              if (typeof instance.UNSAFE_componentWillMount === "function") {
                instance.UNSAFE_componentWillMount();
              }
              stopPhaseTimer();
            }
            if (typeof instance.componentDidMount === "function") {
              workInProgress2.effectTag |= Update;
            }
          } else {
            if (typeof instance.componentDidMount === "function") {
              workInProgress2.effectTag |= Update;
            }
            workInProgress2.memoizedProps = newProps;
            workInProgress2.memoizedState = newState;
          }
          instance.props = newProps;
          instance.state = newState;
          instance.context = nextContext;
          return shouldUpdate;
        }
        function updateClassInstance(current3, workInProgress2, ctor, newProps, renderExpirationTime2) {
          var instance = workInProgress2.stateNode;
          cloneUpdateQueue(current3, workInProgress2);
          var oldProps = workInProgress2.memoizedProps;
          instance.props = workInProgress2.type === workInProgress2.elementType ? oldProps : resolveDefaultProps(workInProgress2.type, oldProps);
          var oldContext = instance.context;
          var contextType = ctor.contextType;
          var nextContext = emptyContextObject;
          if (typeof contextType === "object" && contextType !== null) {
            nextContext = readContext(contextType);
          } else {
            var nextUnmaskedContext = getUnmaskedContext(workInProgress2, ctor, true);
            nextContext = getMaskedContext(workInProgress2, nextUnmaskedContext);
          }
          var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
          var hasNewLifecycles = typeof getDerivedStateFromProps === "function" || typeof instance.getSnapshotBeforeUpdate === "function";
          if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillReceiveProps === "function" || typeof instance.componentWillReceiveProps === "function")) {
            if (oldProps !== newProps || oldContext !== nextContext) {
              callComponentWillReceiveProps(workInProgress2, instance, newProps, nextContext);
            }
          }
          resetHasForceUpdateBeforeProcessing();
          var oldState = workInProgress2.memoizedState;
          var newState = instance.state = oldState;
          processUpdateQueue(workInProgress2, newProps, instance, renderExpirationTime2);
          newState = workInProgress2.memoizedState;
          if (oldProps === newProps && oldState === newState && !hasContextChanged() && !checkHasForceUpdateAfterProcessing()) {
            if (typeof instance.componentDidUpdate === "function") {
              if (oldProps !== current3.memoizedProps || oldState !== current3.memoizedState) {
                workInProgress2.effectTag |= Update;
              }
            }
            if (typeof instance.getSnapshotBeforeUpdate === "function") {
              if (oldProps !== current3.memoizedProps || oldState !== current3.memoizedState) {
                workInProgress2.effectTag |= Snapshot;
              }
            }
            return false;
          }
          if (typeof getDerivedStateFromProps === "function") {
            applyDerivedStateFromProps(workInProgress2, ctor, getDerivedStateFromProps, newProps);
            newState = workInProgress2.memoizedState;
          }
          var shouldUpdate = checkHasForceUpdateAfterProcessing() || checkShouldComponentUpdate(workInProgress2, ctor, oldProps, newProps, oldState, newState, nextContext);
          if (shouldUpdate) {
            if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillUpdate === "function" || typeof instance.componentWillUpdate === "function")) {
              startPhaseTimer(workInProgress2, "componentWillUpdate");
              if (typeof instance.componentWillUpdate === "function") {
                instance.componentWillUpdate(newProps, newState, nextContext);
              }
              if (typeof instance.UNSAFE_componentWillUpdate === "function") {
                instance.UNSAFE_componentWillUpdate(newProps, newState, nextContext);
              }
              stopPhaseTimer();
            }
            if (typeof instance.componentDidUpdate === "function") {
              workInProgress2.effectTag |= Update;
            }
            if (typeof instance.getSnapshotBeforeUpdate === "function") {
              workInProgress2.effectTag |= Snapshot;
            }
          } else {
            if (typeof instance.componentDidUpdate === "function") {
              if (oldProps !== current3.memoizedProps || oldState !== current3.memoizedState) {
                workInProgress2.effectTag |= Update;
              }
            }
            if (typeof instance.getSnapshotBeforeUpdate === "function") {
              if (oldProps !== current3.memoizedProps || oldState !== current3.memoizedState) {
                workInProgress2.effectTag |= Snapshot;
              }
            }
            workInProgress2.memoizedProps = newProps;
            workInProgress2.memoizedState = newState;
          }
          instance.props = newProps;
          instance.state = newState;
          instance.context = nextContext;
          return shouldUpdate;
        }
        var didWarnAboutMaps;
        var didWarnAboutGenerators;
        var didWarnAboutStringRefs;
        var ownerHasKeyUseWarning;
        var ownerHasFunctionTypeWarning;
        var warnForMissingKey = function(child) {
        };
        {
          didWarnAboutMaps = false;
          didWarnAboutGenerators = false;
          didWarnAboutStringRefs = {};
          ownerHasKeyUseWarning = {};
          ownerHasFunctionTypeWarning = {};
          warnForMissingKey = function(child) {
            if (child === null || typeof child !== "object") {
              return;
            }
            if (!child._store || child._store.validated || child.key != null) {
              return;
            }
            if (!(typeof child._store === "object")) {
              {
                throw Error("React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.");
              }
            }
            child._store.validated = true;
            var currentComponentErrorInfo = 'Each child in a list should have a unique "key" prop. See https://fb.me/react-warning-keys for more information.' + getCurrentFiberStackInDev();
            if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
              return;
            }
            ownerHasKeyUseWarning[currentComponentErrorInfo] = true;
            error2('Each child in a list should have a unique "key" prop. See https://fb.me/react-warning-keys for more information.');
          };
        }
        var isArray$1 = Array.isArray;
        function coerceRef(returnFiber, current3, element) {
          var mixedRef = element.ref;
          if (mixedRef !== null && typeof mixedRef !== "function" && typeof mixedRef !== "object") {
            {
              if ((returnFiber.mode & StrictMode || warnAboutStringRefs) && // We warn in ReactElement.js if owner and self are equal for string refs
              // because these cannot be automatically converted to an arrow function
              // using a codemod. Therefore, we don't have to warn about string refs again.
              !(element._owner && element._self && element._owner.stateNode !== element._self)) {
                var componentName = getComponentName(returnFiber.type) || "Component";
                if (!didWarnAboutStringRefs[componentName]) {
                  {
                    error2('A string ref, "%s", has been found within a strict mode tree. String refs are a source of potential bugs and should be avoided. We recommend using useRef() or createRef() instead. Learn more about using refs safely here: https://fb.me/react-strict-mode-string-ref%s', mixedRef, getStackByFiberInDevAndProd(returnFiber));
                  }
                  didWarnAboutStringRefs[componentName] = true;
                }
              }
            }
            if (element._owner) {
              var owner = element._owner;
              var inst;
              if (owner) {
                var ownerFiber = owner;
                if (!(ownerFiber.tag === ClassComponent)) {
                  {
                    throw Error("Function components cannot have string refs. We recommend using useRef() instead. Learn more about using refs safely here: https://fb.me/react-strict-mode-string-ref");
                  }
                }
                inst = ownerFiber.stateNode;
              }
              if (!inst) {
                {
                  throw Error("Missing owner for string ref " + mixedRef + ". This error is likely caused by a bug in React. Please file an issue.");
                }
              }
              var stringRef = "" + mixedRef;
              if (current3 !== null && current3.ref !== null && typeof current3.ref === "function" && current3.ref._stringRef === stringRef) {
                return current3.ref;
              }
              var ref3 = function(value) {
                var refs2 = inst.refs;
                if (refs2 === emptyRefsObject) {
                  refs2 = inst.refs = {};
                }
                if (value === null) {
                  delete refs2[stringRef];
                } else {
                  refs2[stringRef] = value;
                }
              };
              ref3._stringRef = stringRef;
              return ref3;
            } else {
              if (!(typeof mixedRef === "string")) {
                {
                  throw Error("Expected ref to be a function, a string, an object returned by React.createRef(), or null.");
                }
              }
              if (!element._owner) {
                {
                  throw Error("Element ref was specified as a string (" + mixedRef + ") but no owner was set. This could happen for one of the following reasons:\n1. You may be adding a ref to a function component\n2. You may be adding a ref to a component that was not created inside a component's render method\n3. You have multiple copies of React loaded\nSee https://fb.me/react-refs-must-have-owner for more information.");
                }
              }
            }
          }
          return mixedRef;
        }
        function throwOnInvalidObjectType(returnFiber, newChild) {
          if (returnFiber.type !== "textarea") {
            var addendum = "";
            {
              addendum = " If you meant to render a collection of children, use an array instead." + getCurrentFiberStackInDev();
            }
            {
              {
                throw Error("Objects are not valid as a React child (found: " + (Object.prototype.toString.call(newChild) === "[object Object]" ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : newChild) + ")." + addendum);
              }
            }
          }
        }
        function warnOnFunctionType() {
          {
            var currentComponentErrorInfo = "Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it." + getCurrentFiberStackInDev();
            if (ownerHasFunctionTypeWarning[currentComponentErrorInfo]) {
              return;
            }
            ownerHasFunctionTypeWarning[currentComponentErrorInfo] = true;
            error2("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
          }
        }
        function ChildReconciler(shouldTrackSideEffects) {
          function deleteChild(returnFiber, childToDelete) {
            if (!shouldTrackSideEffects) {
              return;
            }
            var last2 = returnFiber.lastEffect;
            if (last2 !== null) {
              last2.nextEffect = childToDelete;
              returnFiber.lastEffect = childToDelete;
            } else {
              returnFiber.firstEffect = returnFiber.lastEffect = childToDelete;
            }
            childToDelete.nextEffect = null;
            childToDelete.effectTag = Deletion;
          }
          function deleteRemainingChildren(returnFiber, currentFirstChild) {
            if (!shouldTrackSideEffects) {
              return null;
            }
            var childToDelete = currentFirstChild;
            while (childToDelete !== null) {
              deleteChild(returnFiber, childToDelete);
              childToDelete = childToDelete.sibling;
            }
            return null;
          }
          function mapRemainingChildren(returnFiber, currentFirstChild) {
            var existingChildren = /* @__PURE__ */ new Map();
            var existingChild = currentFirstChild;
            while (existingChild !== null) {
              if (existingChild.key !== null) {
                existingChildren.set(existingChild.key, existingChild);
              } else {
                existingChildren.set(existingChild.index, existingChild);
              }
              existingChild = existingChild.sibling;
            }
            return existingChildren;
          }
          function useFiber(fiber, pendingProps) {
            var clone = createWorkInProgress(fiber, pendingProps);
            clone.index = 0;
            clone.sibling = null;
            return clone;
          }
          function placeChild(newFiber, lastPlacedIndex, newIndex) {
            newFiber.index = newIndex;
            if (!shouldTrackSideEffects) {
              return lastPlacedIndex;
            }
            var current3 = newFiber.alternate;
            if (current3 !== null) {
              var oldIndex = current3.index;
              if (oldIndex < lastPlacedIndex) {
                newFiber.effectTag = Placement;
                return lastPlacedIndex;
              } else {
                return oldIndex;
              }
            } else {
              newFiber.effectTag = Placement;
              return lastPlacedIndex;
            }
          }
          function placeSingleChild(newFiber) {
            if (shouldTrackSideEffects && newFiber.alternate === null) {
              newFiber.effectTag = Placement;
            }
            return newFiber;
          }
          function updateTextNode(returnFiber, current3, textContent, expirationTime) {
            if (current3 === null || current3.tag !== HostText) {
              var created = createFiberFromText(textContent, returnFiber.mode, expirationTime);
              created.return = returnFiber;
              return created;
            } else {
              var existing = useFiber(current3, textContent);
              existing.return = returnFiber;
              return existing;
            }
          }
          function updateElement(returnFiber, current3, element, expirationTime) {
            if (current3 !== null) {
              if (current3.elementType === element.type || // Keep this check inline so it only runs on the false path:
              isCompatibleFamilyForHotReloading(current3, element)) {
                var existing = useFiber(current3, element.props);
                existing.ref = coerceRef(returnFiber, current3, element);
                existing.return = returnFiber;
                {
                  existing._debugSource = element._source;
                  existing._debugOwner = element._owner;
                }
                return existing;
              }
            }
            var created = createFiberFromElement(element, returnFiber.mode, expirationTime);
            created.ref = coerceRef(returnFiber, current3, element);
            created.return = returnFiber;
            return created;
          }
          function updatePortal(returnFiber, current3, portal, expirationTime) {
            if (current3 === null || current3.tag !== HostPortal || current3.stateNode.containerInfo !== portal.containerInfo || current3.stateNode.implementation !== portal.implementation) {
              var created = createFiberFromPortal(portal, returnFiber.mode, expirationTime);
              created.return = returnFiber;
              return created;
            } else {
              var existing = useFiber(current3, portal.children || []);
              existing.return = returnFiber;
              return existing;
            }
          }
          function updateFragment2(returnFiber, current3, fragment, expirationTime, key2) {
            if (current3 === null || current3.tag !== Fragment35) {
              var created = createFiberFromFragment(fragment, returnFiber.mode, expirationTime, key2);
              created.return = returnFiber;
              return created;
            } else {
              var existing = useFiber(current3, fragment);
              existing.return = returnFiber;
              return existing;
            }
          }
          function createChild(returnFiber, newChild, expirationTime) {
            if (typeof newChild === "string" || typeof newChild === "number") {
              var created = createFiberFromText("" + newChild, returnFiber.mode, expirationTime);
              created.return = returnFiber;
              return created;
            }
            if (typeof newChild === "object" && newChild !== null) {
              switch (newChild.$$typeof) {
                case REACT_ELEMENT_TYPE: {
                  var _created = createFiberFromElement(newChild, returnFiber.mode, expirationTime);
                  _created.ref = coerceRef(returnFiber, null, newChild);
                  _created.return = returnFiber;
                  return _created;
                }
                case REACT_PORTAL_TYPE: {
                  var _created2 = createFiberFromPortal(newChild, returnFiber.mode, expirationTime);
                  _created2.return = returnFiber;
                  return _created2;
                }
              }
              if (isArray$1(newChild) || getIteratorFn(newChild)) {
                var _created3 = createFiberFromFragment(newChild, returnFiber.mode, expirationTime, null);
                _created3.return = returnFiber;
                return _created3;
              }
              throwOnInvalidObjectType(returnFiber, newChild);
            }
            {
              if (typeof newChild === "function") {
                warnOnFunctionType();
              }
            }
            return null;
          }
          function updateSlot(returnFiber, oldFiber, newChild, expirationTime) {
            var key2 = oldFiber !== null ? oldFiber.key : null;
            if (typeof newChild === "string" || typeof newChild === "number") {
              if (key2 !== null) {
                return null;
              }
              return updateTextNode(returnFiber, oldFiber, "" + newChild, expirationTime);
            }
            if (typeof newChild === "object" && newChild !== null) {
              switch (newChild.$$typeof) {
                case REACT_ELEMENT_TYPE: {
                  if (newChild.key === key2) {
                    if (newChild.type === REACT_FRAGMENT_TYPE2) {
                      return updateFragment2(returnFiber, oldFiber, newChild.props.children, expirationTime, key2);
                    }
                    return updateElement(returnFiber, oldFiber, newChild, expirationTime);
                  } else {
                    return null;
                  }
                }
                case REACT_PORTAL_TYPE: {
                  if (newChild.key === key2) {
                    return updatePortal(returnFiber, oldFiber, newChild, expirationTime);
                  } else {
                    return null;
                  }
                }
              }
              if (isArray$1(newChild) || getIteratorFn(newChild)) {
                if (key2 !== null) {
                  return null;
                }
                return updateFragment2(returnFiber, oldFiber, newChild, expirationTime, null);
              }
              throwOnInvalidObjectType(returnFiber, newChild);
            }
            {
              if (typeof newChild === "function") {
                warnOnFunctionType();
              }
            }
            return null;
          }
          function updateFromMap(existingChildren, returnFiber, newIdx, newChild, expirationTime) {
            if (typeof newChild === "string" || typeof newChild === "number") {
              var matchedFiber = existingChildren.get(newIdx) || null;
              return updateTextNode(returnFiber, matchedFiber, "" + newChild, expirationTime);
            }
            if (typeof newChild === "object" && newChild !== null) {
              switch (newChild.$$typeof) {
                case REACT_ELEMENT_TYPE: {
                  var _matchedFiber = existingChildren.get(newChild.key === null ? newIdx : newChild.key) || null;
                  if (newChild.type === REACT_FRAGMENT_TYPE2) {
                    return updateFragment2(returnFiber, _matchedFiber, newChild.props.children, expirationTime, newChild.key);
                  }
                  return updateElement(returnFiber, _matchedFiber, newChild, expirationTime);
                }
                case REACT_PORTAL_TYPE: {
                  var _matchedFiber2 = existingChildren.get(newChild.key === null ? newIdx : newChild.key) || null;
                  return updatePortal(returnFiber, _matchedFiber2, newChild, expirationTime);
                }
              }
              if (isArray$1(newChild) || getIteratorFn(newChild)) {
                var _matchedFiber3 = existingChildren.get(newIdx) || null;
                return updateFragment2(returnFiber, _matchedFiber3, newChild, expirationTime, null);
              }
              throwOnInvalidObjectType(returnFiber, newChild);
            }
            {
              if (typeof newChild === "function") {
                warnOnFunctionType();
              }
            }
            return null;
          }
          function warnOnInvalidKey(child, knownKeys) {
            {
              if (typeof child !== "object" || child === null) {
                return knownKeys;
              }
              switch (child.$$typeof) {
                case REACT_ELEMENT_TYPE:
                case REACT_PORTAL_TYPE:
                  warnForMissingKey(child);
                  var key2 = child.key;
                  if (typeof key2 !== "string") {
                    break;
                  }
                  if (knownKeys === null) {
                    knownKeys = /* @__PURE__ */ new Set();
                    knownKeys.add(key2);
                    break;
                  }
                  if (!knownKeys.has(key2)) {
                    knownKeys.add(key2);
                    break;
                  }
                  error2("Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted \u2014 the behavior is unsupported and could change in a future version.", key2);
                  break;
              }
            }
            return knownKeys;
          }
          function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, expirationTime) {
            {
              var knownKeys = null;
              for (var i = 0; i < newChildren.length; i++) {
                var child = newChildren[i];
                knownKeys = warnOnInvalidKey(child, knownKeys);
              }
            }
            var resultingFirstChild = null;
            var previousNewFiber = null;
            var oldFiber = currentFirstChild;
            var lastPlacedIndex = 0;
            var newIdx = 0;
            var nextOldFiber = null;
            for (; oldFiber !== null && newIdx < newChildren.length; newIdx++) {
              if (oldFiber.index > newIdx) {
                nextOldFiber = oldFiber;
                oldFiber = null;
              } else {
                nextOldFiber = oldFiber.sibling;
              }
              var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], expirationTime);
              if (newFiber === null) {
                if (oldFiber === null) {
                  oldFiber = nextOldFiber;
                }
                break;
              }
              if (shouldTrackSideEffects) {
                if (oldFiber && newFiber.alternate === null) {
                  deleteChild(returnFiber, oldFiber);
                }
              }
              lastPlacedIndex = placeChild(newFiber, lastPlacedIndex, newIdx);
              if (previousNewFiber === null) {
                resultingFirstChild = newFiber;
              } else {
                previousNewFiber.sibling = newFiber;
              }
              previousNewFiber = newFiber;
              oldFiber = nextOldFiber;
            }
            if (newIdx === newChildren.length) {
              deleteRemainingChildren(returnFiber, oldFiber);
              return resultingFirstChild;
            }
            if (oldFiber === null) {
              for (; newIdx < newChildren.length; newIdx++) {
                var _newFiber = createChild(returnFiber, newChildren[newIdx], expirationTime);
                if (_newFiber === null) {
                  continue;
                }
                lastPlacedIndex = placeChild(_newFiber, lastPlacedIndex, newIdx);
                if (previousNewFiber === null) {
                  resultingFirstChild = _newFiber;
                } else {
                  previousNewFiber.sibling = _newFiber;
                }
                previousNewFiber = _newFiber;
              }
              return resultingFirstChild;
            }
            var existingChildren = mapRemainingChildren(returnFiber, oldFiber);
            for (; newIdx < newChildren.length; newIdx++) {
              var _newFiber2 = updateFromMap(existingChildren, returnFiber, newIdx, newChildren[newIdx], expirationTime);
              if (_newFiber2 !== null) {
                if (shouldTrackSideEffects) {
                  if (_newFiber2.alternate !== null) {
                    existingChildren.delete(_newFiber2.key === null ? newIdx : _newFiber2.key);
                  }
                }
                lastPlacedIndex = placeChild(_newFiber2, lastPlacedIndex, newIdx);
                if (previousNewFiber === null) {
                  resultingFirstChild = _newFiber2;
                } else {
                  previousNewFiber.sibling = _newFiber2;
                }
                previousNewFiber = _newFiber2;
              }
            }
            if (shouldTrackSideEffects) {
              existingChildren.forEach(function(child2) {
                return deleteChild(returnFiber, child2);
              });
            }
            return resultingFirstChild;
          }
          function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildrenIterable, expirationTime) {
            var iteratorFn = getIteratorFn(newChildrenIterable);
            if (!(typeof iteratorFn === "function")) {
              {
                throw Error("An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.");
              }
            }
            {
              if (typeof Symbol === "function" && // $FlowFixMe Flow doesn't know about toStringTag
              newChildrenIterable[Symbol.toStringTag] === "Generator") {
                if (!didWarnAboutGenerators) {
                  error2("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers.");
                }
                didWarnAboutGenerators = true;
              }
              if (newChildrenIterable.entries === iteratorFn) {
                if (!didWarnAboutMaps) {
                  error2("Using Maps as children is unsupported and will likely yield unexpected results. Convert it to a sequence/iterable of keyed ReactElements instead.");
                }
                didWarnAboutMaps = true;
              }
              var _newChildren = iteratorFn.call(newChildrenIterable);
              if (_newChildren) {
                var knownKeys = null;
                var _step = _newChildren.next();
                for (; !_step.done; _step = _newChildren.next()) {
                  var child = _step.value;
                  knownKeys = warnOnInvalidKey(child, knownKeys);
                }
              }
            }
            var newChildren = iteratorFn.call(newChildrenIterable);
            if (!(newChildren != null)) {
              {
                throw Error("An iterable object provided no iterator.");
              }
            }
            var resultingFirstChild = null;
            var previousNewFiber = null;
            var oldFiber = currentFirstChild;
            var lastPlacedIndex = 0;
            var newIdx = 0;
            var nextOldFiber = null;
            var step = newChildren.next();
            for (; oldFiber !== null && !step.done; newIdx++, step = newChildren.next()) {
              if (oldFiber.index > newIdx) {
                nextOldFiber = oldFiber;
                oldFiber = null;
              } else {
                nextOldFiber = oldFiber.sibling;
              }
              var newFiber = updateSlot(returnFiber, oldFiber, step.value, expirationTime);
              if (newFiber === null) {
                if (oldFiber === null) {
                  oldFiber = nextOldFiber;
                }
                break;
              }
              if (shouldTrackSideEffects) {
                if (oldFiber && newFiber.alternate === null) {
                  deleteChild(returnFiber, oldFiber);
                }
              }
              lastPlacedIndex = placeChild(newFiber, lastPlacedIndex, newIdx);
              if (previousNewFiber === null) {
                resultingFirstChild = newFiber;
              } else {
                previousNewFiber.sibling = newFiber;
              }
              previousNewFiber = newFiber;
              oldFiber = nextOldFiber;
            }
            if (step.done) {
              deleteRemainingChildren(returnFiber, oldFiber);
              return resultingFirstChild;
            }
            if (oldFiber === null) {
              for (; !step.done; newIdx++, step = newChildren.next()) {
                var _newFiber3 = createChild(returnFiber, step.value, expirationTime);
                if (_newFiber3 === null) {
                  continue;
                }
                lastPlacedIndex = placeChild(_newFiber3, lastPlacedIndex, newIdx);
                if (previousNewFiber === null) {
                  resultingFirstChild = _newFiber3;
                } else {
                  previousNewFiber.sibling = _newFiber3;
                }
                previousNewFiber = _newFiber3;
              }
              return resultingFirstChild;
            }
            var existingChildren = mapRemainingChildren(returnFiber, oldFiber);
            for (; !step.done; newIdx++, step = newChildren.next()) {
              var _newFiber4 = updateFromMap(existingChildren, returnFiber, newIdx, step.value, expirationTime);
              if (_newFiber4 !== null) {
                if (shouldTrackSideEffects) {
                  if (_newFiber4.alternate !== null) {
                    existingChildren.delete(_newFiber4.key === null ? newIdx : _newFiber4.key);
                  }
                }
                lastPlacedIndex = placeChild(_newFiber4, lastPlacedIndex, newIdx);
                if (previousNewFiber === null) {
                  resultingFirstChild = _newFiber4;
                } else {
                  previousNewFiber.sibling = _newFiber4;
                }
                previousNewFiber = _newFiber4;
              }
            }
            if (shouldTrackSideEffects) {
              existingChildren.forEach(function(child2) {
                return deleteChild(returnFiber, child2);
              });
            }
            return resultingFirstChild;
          }
          function reconcileSingleTextNode(returnFiber, currentFirstChild, textContent, expirationTime) {
            if (currentFirstChild !== null && currentFirstChild.tag === HostText) {
              deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
              var existing = useFiber(currentFirstChild, textContent);
              existing.return = returnFiber;
              return existing;
            }
            deleteRemainingChildren(returnFiber, currentFirstChild);
            var created = createFiberFromText(textContent, returnFiber.mode, expirationTime);
            created.return = returnFiber;
            return created;
          }
          function reconcileSingleElement(returnFiber, currentFirstChild, element, expirationTime) {
            var key2 = element.key;
            var child = currentFirstChild;
            while (child !== null) {
              if (child.key === key2) {
                switch (child.tag) {
                  case Fragment35: {
                    if (element.type === REACT_FRAGMENT_TYPE2) {
                      deleteRemainingChildren(returnFiber, child.sibling);
                      var existing = useFiber(child, element.props.children);
                      existing.return = returnFiber;
                      {
                        existing._debugSource = element._source;
                        existing._debugOwner = element._owner;
                      }
                      return existing;
                    }
                    break;
                  }
                  case Block3:
                  // We intentionally fallthrough here if enableBlocksAPI is not on.
                  // eslint-disable-next-lined no-fallthrough
                  default: {
                    if (child.elementType === element.type || // Keep this check inline so it only runs on the false path:
                    isCompatibleFamilyForHotReloading(child, element)) {
                      deleteRemainingChildren(returnFiber, child.sibling);
                      var _existing3 = useFiber(child, element.props);
                      _existing3.ref = coerceRef(returnFiber, child, element);
                      _existing3.return = returnFiber;
                      {
                        _existing3._debugSource = element._source;
                        _existing3._debugOwner = element._owner;
                      }
                      return _existing3;
                    }
                    break;
                  }
                }
                deleteRemainingChildren(returnFiber, child);
                break;
              } else {
                deleteChild(returnFiber, child);
              }
              child = child.sibling;
            }
            if (element.type === REACT_FRAGMENT_TYPE2) {
              var created = createFiberFromFragment(element.props.children, returnFiber.mode, expirationTime, element.key);
              created.return = returnFiber;
              return created;
            } else {
              var _created4 = createFiberFromElement(element, returnFiber.mode, expirationTime);
              _created4.ref = coerceRef(returnFiber, currentFirstChild, element);
              _created4.return = returnFiber;
              return _created4;
            }
          }
          function reconcileSinglePortal(returnFiber, currentFirstChild, portal, expirationTime) {
            var key2 = portal.key;
            var child = currentFirstChild;
            while (child !== null) {
              if (child.key === key2) {
                if (child.tag === HostPortal && child.stateNode.containerInfo === portal.containerInfo && child.stateNode.implementation === portal.implementation) {
                  deleteRemainingChildren(returnFiber, child.sibling);
                  var existing = useFiber(child, portal.children || []);
                  existing.return = returnFiber;
                  return existing;
                } else {
                  deleteRemainingChildren(returnFiber, child);
                  break;
                }
              } else {
                deleteChild(returnFiber, child);
              }
              child = child.sibling;
            }
            var created = createFiberFromPortal(portal, returnFiber.mode, expirationTime);
            created.return = returnFiber;
            return created;
          }
          function reconcileChildFibers2(returnFiber, currentFirstChild, newChild, expirationTime) {
            var isUnkeyedTopLevelFragment = typeof newChild === "object" && newChild !== null && newChild.type === REACT_FRAGMENT_TYPE2 && newChild.key === null;
            if (isUnkeyedTopLevelFragment) {
              newChild = newChild.props.children;
            }
            var isObject7 = typeof newChild === "object" && newChild !== null;
            if (isObject7) {
              switch (newChild.$$typeof) {
                case REACT_ELEMENT_TYPE:
                  return placeSingleChild(reconcileSingleElement(returnFiber, currentFirstChild, newChild, expirationTime));
                case REACT_PORTAL_TYPE:
                  return placeSingleChild(reconcileSinglePortal(returnFiber, currentFirstChild, newChild, expirationTime));
              }
            }
            if (typeof newChild === "string" || typeof newChild === "number") {
              return placeSingleChild(reconcileSingleTextNode(returnFiber, currentFirstChild, "" + newChild, expirationTime));
            }
            if (isArray$1(newChild)) {
              return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, expirationTime);
            }
            if (getIteratorFn(newChild)) {
              return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, expirationTime);
            }
            if (isObject7) {
              throwOnInvalidObjectType(returnFiber, newChild);
            }
            {
              if (typeof newChild === "function") {
                warnOnFunctionType();
              }
            }
            if (typeof newChild === "undefined" && !isUnkeyedTopLevelFragment) {
              switch (returnFiber.tag) {
                case ClassComponent: {
                  {
                    var instance = returnFiber.stateNode;
                    if (instance.render._isMockFunction) {
                      break;
                    }
                  }
                }
                // Intentionally fall through to the next case, which handles both
                // functions and classes
                // eslint-disable-next-lined no-fallthrough
                case FunctionComponent: {
                  var Component10 = returnFiber.type;
                  {
                    {
                      throw Error((Component10.displayName || Component10.name || "Component") + "(...): Nothing was returned from render. This usually means a return statement is missing. Or, to render nothing, return null.");
                    }
                  }
                }
              }
            }
            return deleteRemainingChildren(returnFiber, currentFirstChild);
          }
          return reconcileChildFibers2;
        }
        var reconcileChildFibers = ChildReconciler(true);
        var mountChildFibers = ChildReconciler(false);
        function cloneChildFibers(current3, workInProgress2) {
          if (!(current3 === null || workInProgress2.child === current3.child)) {
            {
              throw Error("Resuming work not yet implemented.");
            }
          }
          if (workInProgress2.child === null) {
            return;
          }
          var currentChild = workInProgress2.child;
          var newChild = createWorkInProgress(currentChild, currentChild.pendingProps);
          workInProgress2.child = newChild;
          newChild.return = workInProgress2;
          while (currentChild.sibling !== null) {
            currentChild = currentChild.sibling;
            newChild = newChild.sibling = createWorkInProgress(currentChild, currentChild.pendingProps);
            newChild.return = workInProgress2;
          }
          newChild.sibling = null;
        }
        function resetChildFibers(workInProgress2, renderExpirationTime2) {
          var child = workInProgress2.child;
          while (child !== null) {
            resetWorkInProgress(child, renderExpirationTime2);
            child = child.sibling;
          }
        }
        var NO_CONTEXT = {};
        var contextStackCursor$1 = createCursor(NO_CONTEXT);
        var contextFiberStackCursor = createCursor(NO_CONTEXT);
        var rootInstanceStackCursor = createCursor(NO_CONTEXT);
        function requiredContext(c) {
          if (!(c !== NO_CONTEXT)) {
            {
              throw Error("Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.");
            }
          }
          return c;
        }
        function getRootHostContainer() {
          var rootInstance = requiredContext(rootInstanceStackCursor.current);
          return rootInstance;
        }
        function pushHostContainer(fiber, nextRootInstance) {
          push(rootInstanceStackCursor, nextRootInstance, fiber);
          push(contextFiberStackCursor, fiber, fiber);
          push(contextStackCursor$1, NO_CONTEXT, fiber);
          var nextRootContext = getRootHostContext(nextRootInstance);
          pop(contextStackCursor$1, fiber);
          push(contextStackCursor$1, nextRootContext, fiber);
        }
        function popHostContainer(fiber) {
          pop(contextStackCursor$1, fiber);
          pop(contextFiberStackCursor, fiber);
          pop(rootInstanceStackCursor, fiber);
        }
        function getHostContext() {
          var context = requiredContext(contextStackCursor$1.current);
          return context;
        }
        function pushHostContext(fiber) {
          var rootInstance = requiredContext(rootInstanceStackCursor.current);
          var context = requiredContext(contextStackCursor$1.current);
          var nextContext = getChildHostContext(context, fiber.type);
          if (context === nextContext) {
            return;
          }
          push(contextFiberStackCursor, fiber, fiber);
          push(contextStackCursor$1, nextContext, fiber);
        }
        function popHostContext(fiber) {
          if (contextFiberStackCursor.current !== fiber) {
            return;
          }
          pop(contextStackCursor$1, fiber);
          pop(contextFiberStackCursor, fiber);
        }
        var DefaultSuspenseContext = 0;
        var SubtreeSuspenseContextMask = 1;
        var InvisibleParentSuspenseContext = 1;
        var ForceSuspenseFallback = 2;
        var suspenseStackCursor = createCursor(DefaultSuspenseContext);
        function hasSuspenseContext(parentContext, flag) {
          return (parentContext & flag) !== 0;
        }
        function setDefaultShallowSuspenseContext(parentContext) {
          return parentContext & SubtreeSuspenseContextMask;
        }
        function setShallowSuspenseContext(parentContext, shallowContext) {
          return parentContext & SubtreeSuspenseContextMask | shallowContext;
        }
        function addSubtreeSuspenseContext(parentContext, subtreeContext) {
          return parentContext | subtreeContext;
        }
        function pushSuspenseContext(fiber, newContext) {
          push(suspenseStackCursor, newContext, fiber);
        }
        function popSuspenseContext(fiber) {
          pop(suspenseStackCursor, fiber);
        }
        function shouldCaptureSuspense(workInProgress2, hasInvisibleParent) {
          var nextState = workInProgress2.memoizedState;
          if (nextState !== null) {
            if (nextState.dehydrated !== null) {
              return true;
            }
            return false;
          }
          var props = workInProgress2.memoizedProps;
          if (props.fallback === void 0) {
            return false;
          }
          if (props.unstable_avoidThisFallback !== true) {
            return true;
          }
          if (hasInvisibleParent) {
            return false;
          }
          return true;
        }
        function findFirstSuspended(row) {
          var node2 = row;
          while (node2 !== null) {
            if (node2.tag === SuspenseComponent) {
              var state = node2.memoizedState;
              if (state !== null) {
                var dehydrated = state.dehydrated;
                if (dehydrated === null || isSuspenseInstancePending(dehydrated) || isSuspenseInstanceFallback(dehydrated)) {
                  return node2;
                }
              }
            } else if (node2.tag === SuspenseListComponent && // revealOrder undefined can't be trusted because it don't
            // keep track of whether it suspended or not.
            node2.memoizedProps.revealOrder !== void 0) {
              var didSuspend = (node2.effectTag & DidCapture) !== NoEffect;
              if (didSuspend) {
                return node2;
              }
            } else if (node2.child !== null) {
              node2.child.return = node2;
              node2 = node2.child;
              continue;
            }
            if (node2 === row) {
              return null;
            }
            while (node2.sibling === null) {
              if (node2.return === null || node2.return === row) {
                return null;
              }
              node2 = node2.return;
            }
            node2.sibling.return = node2.return;
            node2 = node2.sibling;
          }
          return null;
        }
        function createDeprecatedResponderListener(responder, props) {
          var eventResponderListener = {
            responder,
            props
          };
          {
            Object.freeze(eventResponderListener);
          }
          return eventResponderListener;
        }
        var HasEffect = (
          /* */
          1
        );
        var Layout = (
          /*    */
          2
        );
        var Passive$1 = (
          /*   */
          4
        );
        var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher, ReactCurrentBatchConfig$1 = ReactSharedInternals.ReactCurrentBatchConfig;
        var didWarnAboutMismatchedHooksForComponent;
        {
          didWarnAboutMismatchedHooksForComponent = /* @__PURE__ */ new Set();
        }
        var renderExpirationTime = NoWork;
        var currentlyRenderingFiber$1 = null;
        var currentHook = null;
        var workInProgressHook = null;
        var didScheduleRenderPhaseUpdate = false;
        var RE_RENDER_LIMIT = 25;
        var currentHookNameInDev = null;
        var hookTypesDev = null;
        var hookTypesUpdateIndexDev = -1;
        var ignorePreviousDependencies = false;
        function mountHookTypesDev() {
          {
            var hookName = currentHookNameInDev;
            if (hookTypesDev === null) {
              hookTypesDev = [hookName];
            } else {
              hookTypesDev.push(hookName);
            }
          }
        }
        function updateHookTypesDev() {
          {
            var hookName = currentHookNameInDev;
            if (hookTypesDev !== null) {
              hookTypesUpdateIndexDev++;
              if (hookTypesDev[hookTypesUpdateIndexDev] !== hookName) {
                warnOnHookMismatchInDev(hookName);
              }
            }
          }
        }
        function checkDepsAreArrayDev(deps) {
          {
            if (deps !== void 0 && deps !== null && !Array.isArray(deps)) {
              error2("%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.", currentHookNameInDev, typeof deps);
            }
          }
        }
        function warnOnHookMismatchInDev(currentHookName) {
          {
            var componentName = getComponentName(currentlyRenderingFiber$1.type);
            if (!didWarnAboutMismatchedHooksForComponent.has(componentName)) {
              didWarnAboutMismatchedHooksForComponent.add(componentName);
              if (hookTypesDev !== null) {
                var table = "";
                var secondColumnStart = 30;
                for (var i = 0; i <= hookTypesUpdateIndexDev; i++) {
                  var oldHookName = hookTypesDev[i];
                  var newHookName = i === hookTypesUpdateIndexDev ? currentHookName : oldHookName;
                  var row = i + 1 + ". " + oldHookName;
                  while (row.length < secondColumnStart) {
                    row += " ";
                  }
                  row += newHookName + "\n";
                  table += row;
                }
                error2("React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://fb.me/rules-of-hooks\n\n   Previous render            Next render\n   ------------------------------------------------------\n%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^\n", componentName, table);
              }
            }
          }
        }
        function throwInvalidHookError() {
          {
            {
              throw Error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://fb.me/react-invalid-hook-call for tips about how to debug and fix this problem.");
            }
          }
        }
        function areHookInputsEqual(nextDeps, prevDeps) {
          {
            if (ignorePreviousDependencies) {
              return false;
            }
          }
          if (prevDeps === null) {
            {
              error2("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", currentHookNameInDev);
            }
            return false;
          }
          {
            if (nextDeps.length !== prevDeps.length) {
              error2("The final argument passed to %s changed size between renders. The order and size of this array must remain constant.\n\nPrevious: %s\nIncoming: %s", currentHookNameInDev, "[" + prevDeps.join(", ") + "]", "[" + nextDeps.join(", ") + "]");
            }
          }
          for (var i = 0; i < prevDeps.length && i < nextDeps.length; i++) {
            if (objectIs(nextDeps[i], prevDeps[i])) {
              continue;
            }
            return false;
          }
          return true;
        }
        function renderWithHooks(current3, workInProgress2, Component10, props, secondArg, nextRenderExpirationTime) {
          renderExpirationTime = nextRenderExpirationTime;
          currentlyRenderingFiber$1 = workInProgress2;
          {
            hookTypesDev = current3 !== null ? current3._debugHookTypes : null;
            hookTypesUpdateIndexDev = -1;
            ignorePreviousDependencies = current3 !== null && current3.type !== workInProgress2.type;
          }
          workInProgress2.memoizedState = null;
          workInProgress2.updateQueue = null;
          workInProgress2.expirationTime = NoWork;
          {
            if (current3 !== null && current3.memoizedState !== null) {
              ReactCurrentDispatcher.current = HooksDispatcherOnUpdateInDEV;
            } else if (hookTypesDev !== null) {
              ReactCurrentDispatcher.current = HooksDispatcherOnMountWithHookTypesInDEV;
            } else {
              ReactCurrentDispatcher.current = HooksDispatcherOnMountInDEV;
            }
          }
          var children = Component10(props, secondArg);
          if (workInProgress2.expirationTime === renderExpirationTime) {
            var numberOfReRenders = 0;
            do {
              workInProgress2.expirationTime = NoWork;
              if (!(numberOfReRenders < RE_RENDER_LIMIT)) {
                {
                  throw Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
                }
              }
              numberOfReRenders += 1;
              {
                ignorePreviousDependencies = false;
              }
              currentHook = null;
              workInProgressHook = null;
              workInProgress2.updateQueue = null;
              {
                hookTypesUpdateIndexDev = -1;
              }
              ReactCurrentDispatcher.current = HooksDispatcherOnRerenderInDEV;
              children = Component10(props, secondArg);
            } while (workInProgress2.expirationTime === renderExpirationTime);
          }
          ReactCurrentDispatcher.current = ContextOnlyDispatcher;
          {
            workInProgress2._debugHookTypes = hookTypesDev;
          }
          var didRenderTooFewHooks = currentHook !== null && currentHook.next !== null;
          renderExpirationTime = NoWork;
          currentlyRenderingFiber$1 = null;
          currentHook = null;
          workInProgressHook = null;
          {
            currentHookNameInDev = null;
            hookTypesDev = null;
            hookTypesUpdateIndexDev = -1;
          }
          didScheduleRenderPhaseUpdate = false;
          if (!!didRenderTooFewHooks) {
            {
              throw Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
            }
          }
          return children;
        }
        function bailoutHooks(current3, workInProgress2, expirationTime) {
          workInProgress2.updateQueue = current3.updateQueue;
          workInProgress2.effectTag &= ~(Passive | Update);
          if (current3.expirationTime <= expirationTime) {
            current3.expirationTime = NoWork;
          }
        }
        function resetHooksAfterThrow() {
          ReactCurrentDispatcher.current = ContextOnlyDispatcher;
          if (didScheduleRenderPhaseUpdate) {
            var hook = currentlyRenderingFiber$1.memoizedState;
            while (hook !== null) {
              var queue = hook.queue;
              if (queue !== null) {
                queue.pending = null;
              }
              hook = hook.next;
            }
          }
          renderExpirationTime = NoWork;
          currentlyRenderingFiber$1 = null;
          currentHook = null;
          workInProgressHook = null;
          {
            hookTypesDev = null;
            hookTypesUpdateIndexDev = -1;
            currentHookNameInDev = null;
          }
          didScheduleRenderPhaseUpdate = false;
        }
        function mountWorkInProgressHook() {
          var hook = {
            memoizedState: null,
            baseState: null,
            baseQueue: null,
            queue: null,
            next: null
          };
          if (workInProgressHook === null) {
            currentlyRenderingFiber$1.memoizedState = workInProgressHook = hook;
          } else {
            workInProgressHook = workInProgressHook.next = hook;
          }
          return workInProgressHook;
        }
        function updateWorkInProgressHook() {
          var nextCurrentHook;
          if (currentHook === null) {
            var current3 = currentlyRenderingFiber$1.alternate;
            if (current3 !== null) {
              nextCurrentHook = current3.memoizedState;
            } else {
              nextCurrentHook = null;
            }
          } else {
            nextCurrentHook = currentHook.next;
          }
          var nextWorkInProgressHook;
          if (workInProgressHook === null) {
            nextWorkInProgressHook = currentlyRenderingFiber$1.memoizedState;
          } else {
            nextWorkInProgressHook = workInProgressHook.next;
          }
          if (nextWorkInProgressHook !== null) {
            workInProgressHook = nextWorkInProgressHook;
            nextWorkInProgressHook = workInProgressHook.next;
            currentHook = nextCurrentHook;
          } else {
            if (!(nextCurrentHook !== null)) {
              {
                throw Error("Rendered more hooks than during the previous render.");
              }
            }
            currentHook = nextCurrentHook;
            var newHook = {
              memoizedState: currentHook.memoizedState,
              baseState: currentHook.baseState,
              baseQueue: currentHook.baseQueue,
              queue: currentHook.queue,
              next: null
            };
            if (workInProgressHook === null) {
              currentlyRenderingFiber$1.memoizedState = workInProgressHook = newHook;
            } else {
              workInProgressHook = workInProgressHook.next = newHook;
            }
          }
          return workInProgressHook;
        }
        function createFunctionComponentUpdateQueue() {
          return {
            lastEffect: null
          };
        }
        function basicStateReducer(state, action) {
          return typeof action === "function" ? action(state) : action;
        }
        function mountReducer(reducer2, initialArg, init2) {
          var hook = mountWorkInProgressHook();
          var initialState;
          if (init2 !== void 0) {
            initialState = init2(initialArg);
          } else {
            initialState = initialArg;
          }
          hook.memoizedState = hook.baseState = initialState;
          var queue = hook.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: reducer2,
            lastRenderedState: initialState
          };
          var dispatch2 = queue.dispatch = dispatchAction.bind(null, currentlyRenderingFiber$1, queue);
          return [hook.memoizedState, dispatch2];
        }
        function updateReducer(reducer2, initialArg, init2) {
          var hook = updateWorkInProgressHook();
          var queue = hook.queue;
          if (!(queue !== null)) {
            {
              throw Error("Should have a queue. This is likely a bug in React. Please file an issue.");
            }
          }
          queue.lastRenderedReducer = reducer2;
          var current3 = currentHook;
          var baseQueue = current3.baseQueue;
          var pendingQueue = queue.pending;
          if (pendingQueue !== null) {
            if (baseQueue !== null) {
              var baseFirst = baseQueue.next;
              var pendingFirst = pendingQueue.next;
              baseQueue.next = pendingFirst;
              pendingQueue.next = baseFirst;
            }
            current3.baseQueue = baseQueue = pendingQueue;
            queue.pending = null;
          }
          if (baseQueue !== null) {
            var first = baseQueue.next;
            var newState = current3.baseState;
            var newBaseState = null;
            var newBaseQueueFirst = null;
            var newBaseQueueLast = null;
            var update = first;
            do {
              var updateExpirationTime = update.expirationTime;
              if (updateExpirationTime < renderExpirationTime) {
                var clone = {
                  expirationTime: update.expirationTime,
                  suspenseConfig: update.suspenseConfig,
                  action: update.action,
                  eagerReducer: update.eagerReducer,
                  eagerState: update.eagerState,
                  next: null
                };
                if (newBaseQueueLast === null) {
                  newBaseQueueFirst = newBaseQueueLast = clone;
                  newBaseState = newState;
                } else {
                  newBaseQueueLast = newBaseQueueLast.next = clone;
                }
                if (updateExpirationTime > currentlyRenderingFiber$1.expirationTime) {
                  currentlyRenderingFiber$1.expirationTime = updateExpirationTime;
                  markUnprocessedUpdateTime(updateExpirationTime);
                }
              } else {
                if (newBaseQueueLast !== null) {
                  var _clone = {
                    expirationTime: Sync,
                    // This update is going to be committed so we never want uncommit it.
                    suspenseConfig: update.suspenseConfig,
                    action: update.action,
                    eagerReducer: update.eagerReducer,
                    eagerState: update.eagerState,
                    next: null
                  };
                  newBaseQueueLast = newBaseQueueLast.next = _clone;
                }
                markRenderEventTimeAndConfig(updateExpirationTime, update.suspenseConfig);
                if (update.eagerReducer === reducer2) {
                  newState = update.eagerState;
                } else {
                  var action = update.action;
                  newState = reducer2(newState, action);
                }
              }
              update = update.next;
            } while (update !== null && update !== first);
            if (newBaseQueueLast === null) {
              newBaseState = newState;
            } else {
              newBaseQueueLast.next = newBaseQueueFirst;
            }
            if (!objectIs(newState, hook.memoizedState)) {
              markWorkInProgressReceivedUpdate();
            }
            hook.memoizedState = newState;
            hook.baseState = newBaseState;
            hook.baseQueue = newBaseQueueLast;
            queue.lastRenderedState = newState;
          }
          var dispatch2 = queue.dispatch;
          return [hook.memoizedState, dispatch2];
        }
        function rerenderReducer(reducer2, initialArg, init2) {
          var hook = updateWorkInProgressHook();
          var queue = hook.queue;
          if (!(queue !== null)) {
            {
              throw Error("Should have a queue. This is likely a bug in React. Please file an issue.");
            }
          }
          queue.lastRenderedReducer = reducer2;
          var dispatch2 = queue.dispatch;
          var lastRenderPhaseUpdate = queue.pending;
          var newState = hook.memoizedState;
          if (lastRenderPhaseUpdate !== null) {
            queue.pending = null;
            var firstRenderPhaseUpdate = lastRenderPhaseUpdate.next;
            var update = firstRenderPhaseUpdate;
            do {
              var action = update.action;
              newState = reducer2(newState, action);
              update = update.next;
            } while (update !== firstRenderPhaseUpdate);
            if (!objectIs(newState, hook.memoizedState)) {
              markWorkInProgressReceivedUpdate();
            }
            hook.memoizedState = newState;
            if (hook.baseQueue === null) {
              hook.baseState = newState;
            }
            queue.lastRenderedState = newState;
          }
          return [newState, dispatch2];
        }
        function mountState(initialState) {
          var hook = mountWorkInProgressHook();
          if (typeof initialState === "function") {
            initialState = initialState();
          }
          hook.memoizedState = hook.baseState = initialState;
          var queue = hook.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: basicStateReducer,
            lastRenderedState: initialState
          };
          var dispatch2 = queue.dispatch = dispatchAction.bind(null, currentlyRenderingFiber$1, queue);
          return [hook.memoizedState, dispatch2];
        }
        function updateState(initialState) {
          return updateReducer(basicStateReducer);
        }
        function rerenderState(initialState) {
          return rerenderReducer(basicStateReducer);
        }
        function pushEffect(tag, create, destroy2, deps) {
          var effect = {
            tag,
            create,
            destroy: destroy2,
            deps,
            // Circular
            next: null
          };
          var componentUpdateQueue = currentlyRenderingFiber$1.updateQueue;
          if (componentUpdateQueue === null) {
            componentUpdateQueue = createFunctionComponentUpdateQueue();
            currentlyRenderingFiber$1.updateQueue = componentUpdateQueue;
            componentUpdateQueue.lastEffect = effect.next = effect;
          } else {
            var lastEffect = componentUpdateQueue.lastEffect;
            if (lastEffect === null) {
              componentUpdateQueue.lastEffect = effect.next = effect;
            } else {
              var firstEffect = lastEffect.next;
              lastEffect.next = effect;
              effect.next = firstEffect;
              componentUpdateQueue.lastEffect = effect;
            }
          }
          return effect;
        }
        function mountRef(initialValue) {
          var hook = mountWorkInProgressHook();
          var ref3 = {
            current: initialValue
          };
          {
            Object.seal(ref3);
          }
          hook.memoizedState = ref3;
          return ref3;
        }
        function updateRef(initialValue) {
          var hook = updateWorkInProgressHook();
          return hook.memoizedState;
        }
        function mountEffectImpl(fiberEffectTag, hookEffectTag, create, deps) {
          var hook = mountWorkInProgressHook();
          var nextDeps = deps === void 0 ? null : deps;
          currentlyRenderingFiber$1.effectTag |= fiberEffectTag;
          hook.memoizedState = pushEffect(HasEffect | hookEffectTag, create, void 0, nextDeps);
        }
        function updateEffectImpl(fiberEffectTag, hookEffectTag, create, deps) {
          var hook = updateWorkInProgressHook();
          var nextDeps = deps === void 0 ? null : deps;
          var destroy2 = void 0;
          if (currentHook !== null) {
            var prevEffect = currentHook.memoizedState;
            destroy2 = prevEffect.destroy;
            if (nextDeps !== null) {
              var prevDeps = prevEffect.deps;
              if (areHookInputsEqual(nextDeps, prevDeps)) {
                pushEffect(hookEffectTag, create, destroy2, nextDeps);
                return;
              }
            }
          }
          currentlyRenderingFiber$1.effectTag |= fiberEffectTag;
          hook.memoizedState = pushEffect(HasEffect | hookEffectTag, create, destroy2, nextDeps);
        }
        function mountEffect(create, deps) {
          {
            if ("undefined" !== typeof jest) {
              warnIfNotCurrentlyActingEffectsInDEV(currentlyRenderingFiber$1);
            }
          }
          return mountEffectImpl(Update | Passive, Passive$1, create, deps);
        }
        function updateEffect(create, deps) {
          {
            if ("undefined" !== typeof jest) {
              warnIfNotCurrentlyActingEffectsInDEV(currentlyRenderingFiber$1);
            }
          }
          return updateEffectImpl(Update | Passive, Passive$1, create, deps);
        }
        function mountLayoutEffect(create, deps) {
          return mountEffectImpl(Update, Layout, create, deps);
        }
        function updateLayoutEffect(create, deps) {
          return updateEffectImpl(Update, Layout, create, deps);
        }
        function imperativeHandleEffect(create, ref3) {
          if (typeof ref3 === "function") {
            var refCallback = ref3;
            var _inst = create();
            refCallback(_inst);
            return function() {
              refCallback(null);
            };
          } else if (ref3 !== null && ref3 !== void 0) {
            var refObject = ref3;
            {
              if (!refObject.hasOwnProperty("current")) {
                error2("Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.", "an object with keys {" + Object.keys(refObject).join(", ") + "}");
              }
            }
            var _inst2 = create();
            refObject.current = _inst2;
            return function() {
              refObject.current = null;
            };
          }
        }
        function mountImperativeHandle(ref3, create, deps) {
          {
            if (typeof create !== "function") {
              error2("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", create !== null ? typeof create : "null");
            }
          }
          var effectDeps = deps !== null && deps !== void 0 ? deps.concat([ref3]) : null;
          return mountEffectImpl(Update, Layout, imperativeHandleEffect.bind(null, create, ref3), effectDeps);
        }
        function updateImperativeHandle(ref3, create, deps) {
          {
            if (typeof create !== "function") {
              error2("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", create !== null ? typeof create : "null");
            }
          }
          var effectDeps = deps !== null && deps !== void 0 ? deps.concat([ref3]) : null;
          return updateEffectImpl(Update, Layout, imperativeHandleEffect.bind(null, create, ref3), effectDeps);
        }
        function mountDebugValue(value, formatterFn) {
        }
        var updateDebugValue = mountDebugValue;
        function mountCallback(callback, deps) {
          var hook = mountWorkInProgressHook();
          var nextDeps = deps === void 0 ? null : deps;
          hook.memoizedState = [callback, nextDeps];
          return callback;
        }
        function updateCallback(callback, deps) {
          var hook = updateWorkInProgressHook();
          var nextDeps = deps === void 0 ? null : deps;
          var prevState = hook.memoizedState;
          if (prevState !== null) {
            if (nextDeps !== null) {
              var prevDeps = prevState[1];
              if (areHookInputsEqual(nextDeps, prevDeps)) {
                return prevState[0];
              }
            }
          }
          hook.memoizedState = [callback, nextDeps];
          return callback;
        }
        function mountMemo(nextCreate, deps) {
          var hook = mountWorkInProgressHook();
          var nextDeps = deps === void 0 ? null : deps;
          var nextValue = nextCreate();
          hook.memoizedState = [nextValue, nextDeps];
          return nextValue;
        }
        function updateMemo(nextCreate, deps) {
          var hook = updateWorkInProgressHook();
          var nextDeps = deps === void 0 ? null : deps;
          var prevState = hook.memoizedState;
          if (prevState !== null) {
            if (nextDeps !== null) {
              var prevDeps = prevState[1];
              if (areHookInputsEqual(nextDeps, prevDeps)) {
                return prevState[0];
              }
            }
          }
          var nextValue = nextCreate();
          hook.memoizedState = [nextValue, nextDeps];
          return nextValue;
        }
        function mountDeferredValue(value, config) {
          var _mountState = mountState(value), prevValue = _mountState[0], setValue = _mountState[1];
          mountEffect(function() {
            var previousConfig = ReactCurrentBatchConfig$1.suspense;
            ReactCurrentBatchConfig$1.suspense = config === void 0 ? null : config;
            try {
              setValue(value);
            } finally {
              ReactCurrentBatchConfig$1.suspense = previousConfig;
            }
          }, [value, config]);
          return prevValue;
        }
        function updateDeferredValue(value, config) {
          var _updateState = updateState(), prevValue = _updateState[0], setValue = _updateState[1];
          updateEffect(function() {
            var previousConfig = ReactCurrentBatchConfig$1.suspense;
            ReactCurrentBatchConfig$1.suspense = config === void 0 ? null : config;
            try {
              setValue(value);
            } finally {
              ReactCurrentBatchConfig$1.suspense = previousConfig;
            }
          }, [value, config]);
          return prevValue;
        }
        function rerenderDeferredValue(value, config) {
          var _rerenderState = rerenderState(), prevValue = _rerenderState[0], setValue = _rerenderState[1];
          updateEffect(function() {
            var previousConfig = ReactCurrentBatchConfig$1.suspense;
            ReactCurrentBatchConfig$1.suspense = config === void 0 ? null : config;
            try {
              setValue(value);
            } finally {
              ReactCurrentBatchConfig$1.suspense = previousConfig;
            }
          }, [value, config]);
          return prevValue;
        }
        function startTransition(setPending, config, callback) {
          var priorityLevel = getCurrentPriorityLevel();
          runWithPriority$1(priorityLevel < UserBlockingPriority$1 ? UserBlockingPriority$1 : priorityLevel, function() {
            setPending(true);
          });
          runWithPriority$1(priorityLevel > NormalPriority ? NormalPriority : priorityLevel, function() {
            var previousConfig = ReactCurrentBatchConfig$1.suspense;
            ReactCurrentBatchConfig$1.suspense = config === void 0 ? null : config;
            try {
              setPending(false);
              callback();
            } finally {
              ReactCurrentBatchConfig$1.suspense = previousConfig;
            }
          });
        }
        function mountTransition(config) {
          var _mountState2 = mountState(false), isPending = _mountState2[0], setPending = _mountState2[1];
          var start = mountCallback(startTransition.bind(null, setPending, config), [setPending, config]);
          return [start, isPending];
        }
        function updateTransition(config) {
          var _updateState2 = updateState(), isPending = _updateState2[0], setPending = _updateState2[1];
          var start = updateCallback(startTransition.bind(null, setPending, config), [setPending, config]);
          return [start, isPending];
        }
        function rerenderTransition(config) {
          var _rerenderState2 = rerenderState(), isPending = _rerenderState2[0], setPending = _rerenderState2[1];
          var start = updateCallback(startTransition.bind(null, setPending, config), [setPending, config]);
          return [start, isPending];
        }
        function dispatchAction(fiber, queue, action) {
          {
            if (typeof arguments[3] === "function") {
              error2("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
            }
          }
          var currentTime = requestCurrentTimeForUpdate();
          var suspenseConfig = requestCurrentSuspenseConfig();
          var expirationTime = computeExpirationForFiber(currentTime, fiber, suspenseConfig);
          var update = {
            expirationTime,
            suspenseConfig,
            action,
            eagerReducer: null,
            eagerState: null,
            next: null
          };
          {
            update.priority = getCurrentPriorityLevel();
          }
          var pending = queue.pending;
          if (pending === null) {
            update.next = update;
          } else {
            update.next = pending.next;
            pending.next = update;
          }
          queue.pending = update;
          var alternate = fiber.alternate;
          if (fiber === currentlyRenderingFiber$1 || alternate !== null && alternate === currentlyRenderingFiber$1) {
            didScheduleRenderPhaseUpdate = true;
            update.expirationTime = renderExpirationTime;
            currentlyRenderingFiber$1.expirationTime = renderExpirationTime;
          } else {
            if (fiber.expirationTime === NoWork && (alternate === null || alternate.expirationTime === NoWork)) {
              var lastRenderedReducer = queue.lastRenderedReducer;
              if (lastRenderedReducer !== null) {
                var prevDispatcher;
                {
                  prevDispatcher = ReactCurrentDispatcher.current;
                  ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
                }
                try {
                  var currentState = queue.lastRenderedState;
                  var eagerState = lastRenderedReducer(currentState, action);
                  update.eagerReducer = lastRenderedReducer;
                  update.eagerState = eagerState;
                  if (objectIs(eagerState, currentState)) {
                    return;
                  }
                } catch (error3) {
                } finally {
                  {
                    ReactCurrentDispatcher.current = prevDispatcher;
                  }
                }
              }
            }
            {
              if ("undefined" !== typeof jest) {
                warnIfNotScopedWithMatchingAct(fiber);
                warnIfNotCurrentlyActingUpdatesInDev(fiber);
              }
            }
            scheduleWork(fiber, expirationTime);
          }
        }
        var ContextOnlyDispatcher = {
          readContext,
          useCallback: throwInvalidHookError,
          useContext: throwInvalidHookError,
          useEffect: throwInvalidHookError,
          useImperativeHandle: throwInvalidHookError,
          useLayoutEffect: throwInvalidHookError,
          useMemo: throwInvalidHookError,
          useReducer: throwInvalidHookError,
          useRef: throwInvalidHookError,
          useState: throwInvalidHookError,
          useDebugValue: throwInvalidHookError,
          useResponder: throwInvalidHookError,
          useDeferredValue: throwInvalidHookError,
          useTransition: throwInvalidHookError
        };
        var HooksDispatcherOnMountInDEV = null;
        var HooksDispatcherOnMountWithHookTypesInDEV = null;
        var HooksDispatcherOnUpdateInDEV = null;
        var HooksDispatcherOnRerenderInDEV = null;
        var InvalidNestedHooksDispatcherOnMountInDEV = null;
        var InvalidNestedHooksDispatcherOnUpdateInDEV = null;
        var InvalidNestedHooksDispatcherOnRerenderInDEV = null;
        {
          var warnInvalidContextAccess = function() {
            error2("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
          };
          var warnInvalidHookAccess = function() {
            error2("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://fb.me/rules-of-hooks");
          };
          HooksDispatcherOnMountInDEV = {
            readContext: function(context, observedBits) {
              return readContext(context, observedBits);
            },
            useCallback: function(callback, deps) {
              currentHookNameInDev = "useCallback";
              mountHookTypesDev();
              checkDepsAreArrayDev(deps);
              return mountCallback(callback, deps);
            },
            useContext: function(context, observedBits) {
              currentHookNameInDev = "useContext";
              mountHookTypesDev();
              return readContext(context, observedBits);
            },
            useEffect: function(create, deps) {
              currentHookNameInDev = "useEffect";
              mountHookTypesDev();
              checkDepsAreArrayDev(deps);
              return mountEffect(create, deps);
            },
            useImperativeHandle: function(ref3, create, deps) {
              currentHookNameInDev = "useImperativeHandle";
              mountHookTypesDev();
              checkDepsAreArrayDev(deps);
              return mountImperativeHandle(ref3, create, deps);
            },
            useLayoutEffect: function(create, deps) {
              currentHookNameInDev = "useLayoutEffect";
              mountHookTypesDev();
              checkDepsAreArrayDev(deps);
              return mountLayoutEffect(create, deps);
            },
            useMemo: function(create, deps) {
              currentHookNameInDev = "useMemo";
              mountHookTypesDev();
              checkDepsAreArrayDev(deps);
              var prevDispatcher = ReactCurrentDispatcher.current;
              ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnMountInDEV;
              try {
                return mountMemo(create, deps);
              } finally {
                ReactCurrentDispatcher.current = prevDispatcher;
              }
            },
            useReducer: function(reducer2, initialArg, init2) {
              currentHookNameInDev = "useReducer";
              mountHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher.current;
              ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnMountInDEV;
              try {
                return mountReducer(reducer2, initialArg, init2);
              } finally {
                ReactCurrentDispatcher.current = prevDispatcher;
              }
            },
            useRef: function(initialValue) {
              currentHookNameInDev = "useRef";
              mountHookTypesDev();
              return mountRef(initialValue);
            },
            useState: function(initialState) {
              currentHookNameInDev = "useState";
              mountHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher.current;
              ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnMountInDEV;
              try {
                return mountState(initialState);
              } finally {
                ReactCurrentDispatcher.current = prevDispatcher;
              }
            },
            useDebugValue: function(value, formatterFn) {
              currentHookNameInDev = "useDebugValue";
              mountHookTypesDev();
              return mountDebugValue();
            },
            useResponder: function(responder, props) {
              currentHookNameInDev = "useResponder";
              mountHookTypesDev();
              return createDeprecatedResponderListener(responder, props);
            },
            useDeferredValue: function(value, config) {
              currentHookNameInDev = "useDeferredValue";
              mountHookTypesDev();
              return mountDeferredValue(value, config);
            },
            useTransition: function(config) {
              currentHookNameInDev = "useTransition";
              mountHookTypesDev();
              return mountTransition(config);
            }
          };
          HooksDispatcherOnMountWithHookTypesInDEV = {
            readContext: function(context, observedBits) {
              return readContext(context, observedBits);
            },
            useCallback: function(callback, deps) {
              currentHookNameInDev = "useCallback";
              updateHookTypesDev();
              return mountCallback(callback, deps);
            },
            useContext: function(context, observedBits) {
              currentHookNameInDev = "useContext";
              updateHookTypesDev();
              return readContext(context, observedBits);
            },
            useEffect: function(create, deps) {
              currentHookNameInDev = "useEffect";
              updateHookTypesDev();
              return mountEffect(create, deps);
            },
            useImperativeHandle: function(ref3, create, deps) {
              currentHookNameInDev = "useImperativeHandle";
              updateHookTypesDev();
              return mountImperativeHandle(ref3, create, deps);
            },
            useLayoutEffect: function(create, deps) {
              currentHookNameInDev = "useLayoutEffect";
              updateHookTypesDev();
              return mountLayoutEffect(create, deps);
            },
            useMemo: function(create, deps) {
              currentHookNameInDev = "useMemo";
              updateHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher.current;
              ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnMountInDEV;
              try {
                return mountMemo(create, deps);
              } finally {
                ReactCurrentDispatcher.current = prevDispatcher;
              }
            },
            useReducer: function(reducer2, initialArg, init2) {
              currentHookNameInDev = "useReducer";
              updateHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher.current;
              ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnMountInDEV;
              try {
                return mountReducer(reducer2, initialArg, init2);
              } finally {
                ReactCurrentDispatcher.current = prevDispatcher;
              }
            },
            useRef: function(initialValue) {
              currentHookNameInDev = "useRef";
              updateHookTypesDev();
              return mountRef(initialValue);
            },
            useState: function(initialState) {
              currentHookNameInDev = "useState";
              updateHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher.current;
              ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnMountInDEV;
              try {
                return mountState(initialState);
              } finally {
                ReactCurrentDispatcher.current = prevDispatcher;
              }
            },
            useDebugValue: function(value, formatterFn) {
              currentHookNameInDev = "useDebugValue";
              updateHookTypesDev();
              return mountDebugValue();
            },
            useResponder: function(responder, props) {
              currentHookNameInDev = "useResponder";
              updateHookTypesDev();
              return createDeprecatedResponderListener(responder, props);
            },
            useDeferredValue: function(value, config) {
              currentHookNameInDev = "useDeferredValue";
              updateHookTypesDev();
              return mountDeferredValue(value, config);
            },
            useTransition: function(config) {
              currentHookNameInDev = "useTransition";
              updateHookTypesDev();
              return mountTransition(config);
            }
          };
          HooksDispatcherOnUpdateInDEV = {
            readContext: function(context, observedBits) {
              return readContext(context, observedBits);
            },
            useCallback: function(callback, deps) {
              currentHookNameInDev = "useCallback";
              updateHookTypesDev();
              return updateCallback(callback, deps);
            },
            useContext: function(context, observedBits) {
              currentHookNameInDev = "useContext";
              updateHookTypesDev();
              return readContext(context, observedBits);
            },
            useEffect: function(create, deps) {
              currentHookNameInDev = "useEffect";
              updateHookTypesDev();
              return updateEffect(create, deps);
            },
            useImperativeHandle: function(ref3, create, deps) {
              currentHookNameInDev = "useImperativeHandle";
              updateHookTypesDev();
              return updateImperativeHandle(ref3, create, deps);
            },
            useLayoutEffect: function(create, deps) {
              currentHookNameInDev = "useLayoutEffect";
              updateHookTypesDev();
              return updateLayoutEffect(create, deps);
            },
            useMemo: function(create, deps) {
              currentHookNameInDev = "useMemo";
              updateHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher.current;
              ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
              try {
                return updateMemo(create, deps);
              } finally {
                ReactCurrentDispatcher.current = prevDispatcher;
              }
            },
            useReducer: function(reducer2, initialArg, init2) {
              currentHookNameInDev = "useReducer";
              updateHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher.current;
              ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
              try {
                return updateReducer(reducer2, initialArg, init2);
              } finally {
                ReactCurrentDispatcher.current = prevDispatcher;
              }
            },
            useRef: function(initialValue) {
              currentHookNameInDev = "useRef";
              updateHookTypesDev();
              return updateRef();
            },
            useState: function(initialState) {
              currentHookNameInDev = "useState";
              updateHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher.current;
              ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
              try {
                return updateState(initialState);
              } finally {
                ReactCurrentDispatcher.current = prevDispatcher;
              }
            },
            useDebugValue: function(value, formatterFn) {
              currentHookNameInDev = "useDebugValue";
              updateHookTypesDev();
              return updateDebugValue();
            },
            useResponder: function(responder, props) {
              currentHookNameInDev = "useResponder";
              updateHookTypesDev();
              return createDeprecatedResponderListener(responder, props);
            },
            useDeferredValue: function(value, config) {
              currentHookNameInDev = "useDeferredValue";
              updateHookTypesDev();
              return updateDeferredValue(value, config);
            },
            useTransition: function(config) {
              currentHookNameInDev = "useTransition";
              updateHookTypesDev();
              return updateTransition(config);
            }
          };
          HooksDispatcherOnRerenderInDEV = {
            readContext: function(context, observedBits) {
              return readContext(context, observedBits);
            },
            useCallback: function(callback, deps) {
              currentHookNameInDev = "useCallback";
              updateHookTypesDev();
              return updateCallback(callback, deps);
            },
            useContext: function(context, observedBits) {
              currentHookNameInDev = "useContext";
              updateHookTypesDev();
              return readContext(context, observedBits);
            },
            useEffect: function(create, deps) {
              currentHookNameInDev = "useEffect";
              updateHookTypesDev();
              return updateEffect(create, deps);
            },
            useImperativeHandle: function(ref3, create, deps) {
              currentHookNameInDev = "useImperativeHandle";
              updateHookTypesDev();
              return updateImperativeHandle(ref3, create, deps);
            },
            useLayoutEffect: function(create, deps) {
              currentHookNameInDev = "useLayoutEffect";
              updateHookTypesDev();
              return updateLayoutEffect(create, deps);
            },
            useMemo: function(create, deps) {
              currentHookNameInDev = "useMemo";
              updateHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher.current;
              ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
              try {
                return updateMemo(create, deps);
              } finally {
                ReactCurrentDispatcher.current = prevDispatcher;
              }
            },
            useReducer: function(reducer2, initialArg, init2) {
              currentHookNameInDev = "useReducer";
              updateHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher.current;
              ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
              try {
                return rerenderReducer(reducer2, initialArg, init2);
              } finally {
                ReactCurrentDispatcher.current = prevDispatcher;
              }
            },
            useRef: function(initialValue) {
              currentHookNameInDev = "useRef";
              updateHookTypesDev();
              return updateRef();
            },
            useState: function(initialState) {
              currentHookNameInDev = "useState";
              updateHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher.current;
              ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
              try {
                return rerenderState(initialState);
              } finally {
                ReactCurrentDispatcher.current = prevDispatcher;
              }
            },
            useDebugValue: function(value, formatterFn) {
              currentHookNameInDev = "useDebugValue";
              updateHookTypesDev();
              return updateDebugValue();
            },
            useResponder: function(responder, props) {
              currentHookNameInDev = "useResponder";
              updateHookTypesDev();
              return createDeprecatedResponderListener(responder, props);
            },
            useDeferredValue: function(value, config) {
              currentHookNameInDev = "useDeferredValue";
              updateHookTypesDev();
              return rerenderDeferredValue(value, config);
            },
            useTransition: function(config) {
              currentHookNameInDev = "useTransition";
              updateHookTypesDev();
              return rerenderTransition(config);
            }
          };
          InvalidNestedHooksDispatcherOnMountInDEV = {
            readContext: function(context, observedBits) {
              warnInvalidContextAccess();
              return readContext(context, observedBits);
            },
            useCallback: function(callback, deps) {
              currentHookNameInDev = "useCallback";
              warnInvalidHookAccess();
              mountHookTypesDev();
              return mountCallback(callback, deps);
            },
            useContext: function(context, observedBits) {
              currentHookNameInDev = "useContext";
              warnInvalidHookAccess();
              mountHookTypesDev();
              return readContext(context, observedBits);
            },
            useEffect: function(create, deps) {
              currentHookNameInDev = "useEffect";
              warnInvalidHookAccess();
              mountHookTypesDev();
              return mountEffect(create, deps);
            },
            useImperativeHandle: function(ref3, create, deps) {
              currentHookNameInDev = "useImperativeHandle";
              warnInvalidHookAccess();
              mountHookTypesDev();
              return mountImperativeHandle(ref3, create, deps);
            },
            useLayoutEffect: function(create, deps) {
              currentHookNameInDev = "useLayoutEffect";
              warnInvalidHookAccess();
              mountHookTypesDev();
              return mountLayoutEffect(create, deps);
            },
            useMemo: function(create, deps) {
              currentHookNameInDev = "useMemo";
              warnInvalidHookAccess();
              mountHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher.current;
              ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnMountInDEV;
              try {
                return mountMemo(create, deps);
              } finally {
                ReactCurrentDispatcher.current = prevDispatcher;
              }
            },
            useReducer: function(reducer2, initialArg, init2) {
              currentHookNameInDev = "useReducer";
              warnInvalidHookAccess();
              mountHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher.current;
              ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnMountInDEV;
              try {
                return mountReducer(reducer2, initialArg, init2);
              } finally {
                ReactCurrentDispatcher.current = prevDispatcher;
              }
            },
            useRef: function(initialValue) {
              currentHookNameInDev = "useRef";
              warnInvalidHookAccess();
              mountHookTypesDev();
              return mountRef(initialValue);
            },
            useState: function(initialState) {
              currentHookNameInDev = "useState";
              warnInvalidHookAccess();
              mountHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher.current;
              ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnMountInDEV;
              try {
                return mountState(initialState);
              } finally {
                ReactCurrentDispatcher.current = prevDispatcher;
              }
            },
            useDebugValue: function(value, formatterFn) {
              currentHookNameInDev = "useDebugValue";
              warnInvalidHookAccess();
              mountHookTypesDev();
              return mountDebugValue();
            },
            useResponder: function(responder, props) {
              currentHookNameInDev = "useResponder";
              warnInvalidHookAccess();
              mountHookTypesDev();
              return createDeprecatedResponderListener(responder, props);
            },
            useDeferredValue: function(value, config) {
              currentHookNameInDev = "useDeferredValue";
              warnInvalidHookAccess();
              mountHookTypesDev();
              return mountDeferredValue(value, config);
            },
            useTransition: function(config) {
              currentHookNameInDev = "useTransition";
              warnInvalidHookAccess();
              mountHookTypesDev();
              return mountTransition(config);
            }
          };
          InvalidNestedHooksDispatcherOnUpdateInDEV = {
            readContext: function(context, observedBits) {
              warnInvalidContextAccess();
              return readContext(context, observedBits);
            },
            useCallback: function(callback, deps) {
              currentHookNameInDev = "useCallback";
              warnInvalidHookAccess();
              updateHookTypesDev();
              return updateCallback(callback, deps);
            },
            useContext: function(context, observedBits) {
              currentHookNameInDev = "useContext";
              warnInvalidHookAccess();
              updateHookTypesDev();
              return readContext(context, observedBits);
            },
            useEffect: function(create, deps) {
              currentHookNameInDev = "useEffect";
              warnInvalidHookAccess();
              updateHookTypesDev();
              return updateEffect(create, deps);
            },
            useImperativeHandle: function(ref3, create, deps) {
              currentHookNameInDev = "useImperativeHandle";
              warnInvalidHookAccess();
              updateHookTypesDev();
              return updateImperativeHandle(ref3, create, deps);
            },
            useLayoutEffect: function(create, deps) {
              currentHookNameInDev = "useLayoutEffect";
              warnInvalidHookAccess();
              updateHookTypesDev();
              return updateLayoutEffect(create, deps);
            },
            useMemo: function(create, deps) {
              currentHookNameInDev = "useMemo";
              warnInvalidHookAccess();
              updateHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher.current;
              ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
              try {
                return updateMemo(create, deps);
              } finally {
                ReactCurrentDispatcher.current = prevDispatcher;
              }
            },
            useReducer: function(reducer2, initialArg, init2) {
              currentHookNameInDev = "useReducer";
              warnInvalidHookAccess();
              updateHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher.current;
              ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
              try {
                return updateReducer(reducer2, initialArg, init2);
              } finally {
                ReactCurrentDispatcher.current = prevDispatcher;
              }
            },
            useRef: function(initialValue) {
              currentHookNameInDev = "useRef";
              warnInvalidHookAccess();
              updateHookTypesDev();
              return updateRef();
            },
            useState: function(initialState) {
              currentHookNameInDev = "useState";
              warnInvalidHookAccess();
              updateHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher.current;
              ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
              try {
                return updateState(initialState);
              } finally {
                ReactCurrentDispatcher.current = prevDispatcher;
              }
            },
            useDebugValue: function(value, formatterFn) {
              currentHookNameInDev = "useDebugValue";
              warnInvalidHookAccess();
              updateHookTypesDev();
              return updateDebugValue();
            },
            useResponder: function(responder, props) {
              currentHookNameInDev = "useResponder";
              warnInvalidHookAccess();
              updateHookTypesDev();
              return createDeprecatedResponderListener(responder, props);
            },
            useDeferredValue: function(value, config) {
              currentHookNameInDev = "useDeferredValue";
              warnInvalidHookAccess();
              updateHookTypesDev();
              return updateDeferredValue(value, config);
            },
            useTransition: function(config) {
              currentHookNameInDev = "useTransition";
              warnInvalidHookAccess();
              updateHookTypesDev();
              return updateTransition(config);
            }
          };
          InvalidNestedHooksDispatcherOnRerenderInDEV = {
            readContext: function(context, observedBits) {
              warnInvalidContextAccess();
              return readContext(context, observedBits);
            },
            useCallback: function(callback, deps) {
              currentHookNameInDev = "useCallback";
              warnInvalidHookAccess();
              updateHookTypesDev();
              return updateCallback(callback, deps);
            },
            useContext: function(context, observedBits) {
              currentHookNameInDev = "useContext";
              warnInvalidHookAccess();
              updateHookTypesDev();
              return readContext(context, observedBits);
            },
            useEffect: function(create, deps) {
              currentHookNameInDev = "useEffect";
              warnInvalidHookAccess();
              updateHookTypesDev();
              return updateEffect(create, deps);
            },
            useImperativeHandle: function(ref3, create, deps) {
              currentHookNameInDev = "useImperativeHandle";
              warnInvalidHookAccess();
              updateHookTypesDev();
              return updateImperativeHandle(ref3, create, deps);
            },
            useLayoutEffect: function(create, deps) {
              currentHookNameInDev = "useLayoutEffect";
              warnInvalidHookAccess();
              updateHookTypesDev();
              return updateLayoutEffect(create, deps);
            },
            useMemo: function(create, deps) {
              currentHookNameInDev = "useMemo";
              warnInvalidHookAccess();
              updateHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher.current;
              ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
              try {
                return updateMemo(create, deps);
              } finally {
                ReactCurrentDispatcher.current = prevDispatcher;
              }
            },
            useReducer: function(reducer2, initialArg, init2) {
              currentHookNameInDev = "useReducer";
              warnInvalidHookAccess();
              updateHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher.current;
              ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
              try {
                return rerenderReducer(reducer2, initialArg, init2);
              } finally {
                ReactCurrentDispatcher.current = prevDispatcher;
              }
            },
            useRef: function(initialValue) {
              currentHookNameInDev = "useRef";
              warnInvalidHookAccess();
              updateHookTypesDev();
              return updateRef();
            },
            useState: function(initialState) {
              currentHookNameInDev = "useState";
              warnInvalidHookAccess();
              updateHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher.current;
              ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
              try {
                return rerenderState(initialState);
              } finally {
                ReactCurrentDispatcher.current = prevDispatcher;
              }
            },
            useDebugValue: function(value, formatterFn) {
              currentHookNameInDev = "useDebugValue";
              warnInvalidHookAccess();
              updateHookTypesDev();
              return updateDebugValue();
            },
            useResponder: function(responder, props) {
              currentHookNameInDev = "useResponder";
              warnInvalidHookAccess();
              updateHookTypesDev();
              return createDeprecatedResponderListener(responder, props);
            },
            useDeferredValue: function(value, config) {
              currentHookNameInDev = "useDeferredValue";
              warnInvalidHookAccess();
              updateHookTypesDev();
              return rerenderDeferredValue(value, config);
            },
            useTransition: function(config) {
              currentHookNameInDev = "useTransition";
              warnInvalidHookAccess();
              updateHookTypesDev();
              return rerenderTransition(config);
            }
          };
        }
        var now$1 = Scheduler.unstable_now;
        var commitTime = 0;
        var profilerStartTime = -1;
        function getCommitTime() {
          return commitTime;
        }
        function recordCommitTime() {
          commitTime = now$1();
        }
        function startProfilerTimer(fiber) {
          profilerStartTime = now$1();
          if (fiber.actualStartTime < 0) {
            fiber.actualStartTime = now$1();
          }
        }
        function stopProfilerTimerIfRunning(fiber) {
          profilerStartTime = -1;
        }
        function stopProfilerTimerIfRunningAndRecordDelta(fiber, overrideBaseTime) {
          if (profilerStartTime >= 0) {
            var elapsedTime = now$1() - profilerStartTime;
            fiber.actualDuration += elapsedTime;
            if (overrideBaseTime) {
              fiber.selfBaseDuration = elapsedTime;
            }
            profilerStartTime = -1;
          }
        }
        var hydrationParentFiber = null;
        var nextHydratableInstance = null;
        var isHydrating = false;
        function enterHydrationState(fiber) {
          var parentInstance = fiber.stateNode.containerInfo;
          nextHydratableInstance = getFirstHydratableChild(parentInstance);
          hydrationParentFiber = fiber;
          isHydrating = true;
          return true;
        }
        function deleteHydratableInstance(returnFiber, instance) {
          {
            switch (returnFiber.tag) {
              case HostRoot:
                didNotHydrateContainerInstance(returnFiber.stateNode.containerInfo, instance);
                break;
              case HostComponent:
                didNotHydrateInstance(returnFiber.type, returnFiber.memoizedProps, returnFiber.stateNode, instance);
                break;
            }
          }
          var childToDelete = createFiberFromHostInstanceForDeletion();
          childToDelete.stateNode = instance;
          childToDelete.return = returnFiber;
          childToDelete.effectTag = Deletion;
          if (returnFiber.lastEffect !== null) {
            returnFiber.lastEffect.nextEffect = childToDelete;
            returnFiber.lastEffect = childToDelete;
          } else {
            returnFiber.firstEffect = returnFiber.lastEffect = childToDelete;
          }
        }
        function insertNonHydratedInstance(returnFiber, fiber) {
          fiber.effectTag = fiber.effectTag & ~Hydrating | Placement;
          {
            switch (returnFiber.tag) {
              case HostRoot: {
                var parentContainer = returnFiber.stateNode.containerInfo;
                switch (fiber.tag) {
                  case HostComponent:
                    var type5 = fiber.type;
                    var props = fiber.pendingProps;
                    didNotFindHydratableContainerInstance(parentContainer, type5);
                    break;
                  case HostText:
                    var text = fiber.pendingProps;
                    didNotFindHydratableContainerTextInstance(parentContainer, text);
                    break;
                }
                break;
              }
              case HostComponent: {
                var parentType = returnFiber.type;
                var parentProps = returnFiber.memoizedProps;
                var parentInstance = returnFiber.stateNode;
                switch (fiber.tag) {
                  case HostComponent:
                    var _type = fiber.type;
                    var _props = fiber.pendingProps;
                    didNotFindHydratableInstance(parentType, parentProps, parentInstance, _type);
                    break;
                  case HostText:
                    var _text = fiber.pendingProps;
                    didNotFindHydratableTextInstance(parentType, parentProps, parentInstance, _text);
                    break;
                  case SuspenseComponent:
                    didNotFindHydratableSuspenseInstance(parentType, parentProps);
                    break;
                }
                break;
              }
              default:
                return;
            }
          }
        }
        function tryHydrate(fiber, nextInstance) {
          switch (fiber.tag) {
            case HostComponent: {
              var type5 = fiber.type;
              var props = fiber.pendingProps;
              var instance = canHydrateInstance(nextInstance, type5);
              if (instance !== null) {
                fiber.stateNode = instance;
                return true;
              }
              return false;
            }
            case HostText: {
              var text = fiber.pendingProps;
              var textInstance = canHydrateTextInstance(nextInstance, text);
              if (textInstance !== null) {
                fiber.stateNode = textInstance;
                return true;
              }
              return false;
            }
            case SuspenseComponent: {
              return false;
            }
            default:
              return false;
          }
        }
        function tryToClaimNextHydratableInstance(fiber) {
          if (!isHydrating) {
            return;
          }
          var nextInstance = nextHydratableInstance;
          if (!nextInstance) {
            insertNonHydratedInstance(hydrationParentFiber, fiber);
            isHydrating = false;
            hydrationParentFiber = fiber;
            return;
          }
          var firstAttemptedInstance = nextInstance;
          if (!tryHydrate(fiber, nextInstance)) {
            nextInstance = getNextHydratableSibling(firstAttemptedInstance);
            if (!nextInstance || !tryHydrate(fiber, nextInstance)) {
              insertNonHydratedInstance(hydrationParentFiber, fiber);
              isHydrating = false;
              hydrationParentFiber = fiber;
              return;
            }
            deleteHydratableInstance(hydrationParentFiber, firstAttemptedInstance);
          }
          hydrationParentFiber = fiber;
          nextHydratableInstance = getFirstHydratableChild(nextInstance);
        }
        function prepareToHydrateHostInstance(fiber, rootContainerInstance, hostContext) {
          var instance = fiber.stateNode;
          var updatePayload = hydrateInstance(instance, fiber.type, fiber.memoizedProps, rootContainerInstance, hostContext, fiber);
          fiber.updateQueue = updatePayload;
          if (updatePayload !== null) {
            return true;
          }
          return false;
        }
        function prepareToHydrateHostTextInstance(fiber) {
          var textInstance = fiber.stateNode;
          var textContent = fiber.memoizedProps;
          var shouldUpdate = hydrateTextInstance(textInstance, textContent, fiber);
          {
            if (shouldUpdate) {
              var returnFiber = hydrationParentFiber;
              if (returnFiber !== null) {
                switch (returnFiber.tag) {
                  case HostRoot: {
                    var parentContainer = returnFiber.stateNode.containerInfo;
                    didNotMatchHydratedContainerTextInstance(parentContainer, textInstance, textContent);
                    break;
                  }
                  case HostComponent: {
                    var parentType = returnFiber.type;
                    var parentProps = returnFiber.memoizedProps;
                    var parentInstance = returnFiber.stateNode;
                    didNotMatchHydratedTextInstance(parentType, parentProps, parentInstance, textInstance, textContent);
                    break;
                  }
                }
              }
            }
          }
          return shouldUpdate;
        }
        function skipPastDehydratedSuspenseInstance(fiber) {
          var suspenseState = fiber.memoizedState;
          var suspenseInstance = suspenseState !== null ? suspenseState.dehydrated : null;
          if (!suspenseInstance) {
            {
              throw Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
            }
          }
          return getNextHydratableInstanceAfterSuspenseInstance(suspenseInstance);
        }
        function popToNextHostParent(fiber) {
          var parent2 = fiber.return;
          while (parent2 !== null && parent2.tag !== HostComponent && parent2.tag !== HostRoot && parent2.tag !== SuspenseComponent) {
            parent2 = parent2.return;
          }
          hydrationParentFiber = parent2;
        }
        function popHydrationState(fiber) {
          if (fiber !== hydrationParentFiber) {
            return false;
          }
          if (!isHydrating) {
            popToNextHostParent(fiber);
            isHydrating = true;
            return false;
          }
          var type5 = fiber.type;
          if (fiber.tag !== HostComponent || type5 !== "head" && type5 !== "body" && !shouldSetTextContent(type5, fiber.memoizedProps)) {
            var nextInstance = nextHydratableInstance;
            while (nextInstance) {
              deleteHydratableInstance(fiber, nextInstance);
              nextInstance = getNextHydratableSibling(nextInstance);
            }
          }
          popToNextHostParent(fiber);
          if (fiber.tag === SuspenseComponent) {
            nextHydratableInstance = skipPastDehydratedSuspenseInstance(fiber);
          } else {
            nextHydratableInstance = hydrationParentFiber ? getNextHydratableSibling(fiber.stateNode) : null;
          }
          return true;
        }
        function resetHydrationState() {
          hydrationParentFiber = null;
          nextHydratableInstance = null;
          isHydrating = false;
        }
        var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
        var didReceiveUpdate = false;
        var didWarnAboutBadClass;
        var didWarnAboutModulePatternComponent;
        var didWarnAboutContextTypeOnFunctionComponent;
        var didWarnAboutGetDerivedStateOnFunctionComponent;
        var didWarnAboutFunctionRefs;
        var didWarnAboutReassigningProps;
        var didWarnAboutRevealOrder;
        var didWarnAboutTailOptions;
        {
          didWarnAboutBadClass = {};
          didWarnAboutModulePatternComponent = {};
          didWarnAboutContextTypeOnFunctionComponent = {};
          didWarnAboutGetDerivedStateOnFunctionComponent = {};
          didWarnAboutFunctionRefs = {};
          didWarnAboutReassigningProps = false;
          didWarnAboutRevealOrder = {};
          didWarnAboutTailOptions = {};
        }
        function reconcileChildren(current3, workInProgress2, nextChildren, renderExpirationTime2) {
          if (current3 === null) {
            workInProgress2.child = mountChildFibers(workInProgress2, null, nextChildren, renderExpirationTime2);
          } else {
            workInProgress2.child = reconcileChildFibers(workInProgress2, current3.child, nextChildren, renderExpirationTime2);
          }
        }
        function forceUnmountCurrentAndReconcile(current3, workInProgress2, nextChildren, renderExpirationTime2) {
          workInProgress2.child = reconcileChildFibers(workInProgress2, current3.child, null, renderExpirationTime2);
          workInProgress2.child = reconcileChildFibers(workInProgress2, null, nextChildren, renderExpirationTime2);
        }
        function updateForwardRef(current3, workInProgress2, Component10, nextProps, renderExpirationTime2) {
          {
            if (workInProgress2.type !== workInProgress2.elementType) {
              var innerPropTypes = Component10.propTypes;
              if (innerPropTypes) {
                checkPropTypes(
                  innerPropTypes,
                  nextProps,
                  // Resolved props
                  "prop",
                  getComponentName(Component10),
                  getCurrentFiberStackInDev
                );
              }
            }
          }
          var render5 = Component10.render;
          var ref3 = workInProgress2.ref;
          var nextChildren;
          prepareToReadContext(workInProgress2, renderExpirationTime2);
          {
            ReactCurrentOwner$1.current = workInProgress2;
            setIsRendering(true);
            nextChildren = renderWithHooks(current3, workInProgress2, render5, nextProps, ref3, renderExpirationTime2);
            if (workInProgress2.mode & StrictMode) {
              if (workInProgress2.memoizedState !== null) {
                nextChildren = renderWithHooks(current3, workInProgress2, render5, nextProps, ref3, renderExpirationTime2);
              }
            }
            setIsRendering(false);
          }
          if (current3 !== null && !didReceiveUpdate) {
            bailoutHooks(current3, workInProgress2, renderExpirationTime2);
            return bailoutOnAlreadyFinishedWork(current3, workInProgress2, renderExpirationTime2);
          }
          workInProgress2.effectTag |= PerformedWork;
          reconcileChildren(current3, workInProgress2, nextChildren, renderExpirationTime2);
          return workInProgress2.child;
        }
        function updateMemoComponent(current3, workInProgress2, Component10, nextProps, updateExpirationTime, renderExpirationTime2) {
          if (current3 === null) {
            var type5 = Component10.type;
            if (isSimpleFunctionComponent(type5) && Component10.compare === null && // SimpleMemoComponent codepath doesn't resolve outer props either.
            Component10.defaultProps === void 0) {
              var resolvedType = type5;
              {
                resolvedType = resolveFunctionForHotReloading(type5);
              }
              workInProgress2.tag = SimpleMemoComponent;
              workInProgress2.type = resolvedType;
              {
                validateFunctionComponentInDev(workInProgress2, type5);
              }
              return updateSimpleMemoComponent(current3, workInProgress2, resolvedType, nextProps, updateExpirationTime, renderExpirationTime2);
            }
            {
              var innerPropTypes = type5.propTypes;
              if (innerPropTypes) {
                checkPropTypes(
                  innerPropTypes,
                  nextProps,
                  // Resolved props
                  "prop",
                  getComponentName(type5),
                  getCurrentFiberStackInDev
                );
              }
            }
            var child = createFiberFromTypeAndProps(Component10.type, null, nextProps, null, workInProgress2.mode, renderExpirationTime2);
            child.ref = workInProgress2.ref;
            child.return = workInProgress2;
            workInProgress2.child = child;
            return child;
          }
          {
            var _type = Component10.type;
            var _innerPropTypes = _type.propTypes;
            if (_innerPropTypes) {
              checkPropTypes(
                _innerPropTypes,
                nextProps,
                // Resolved props
                "prop",
                getComponentName(_type),
                getCurrentFiberStackInDev
              );
            }
          }
          var currentChild = current3.child;
          if (updateExpirationTime < renderExpirationTime2) {
            var prevProps = currentChild.memoizedProps;
            var compare = Component10.compare;
            compare = compare !== null ? compare : shallowEqual;
            if (compare(prevProps, nextProps) && current3.ref === workInProgress2.ref) {
              return bailoutOnAlreadyFinishedWork(current3, workInProgress2, renderExpirationTime2);
            }
          }
          workInProgress2.effectTag |= PerformedWork;
          var newChild = createWorkInProgress(currentChild, nextProps);
          newChild.ref = workInProgress2.ref;
          newChild.return = workInProgress2;
          workInProgress2.child = newChild;
          return newChild;
        }
        function updateSimpleMemoComponent(current3, workInProgress2, Component10, nextProps, updateExpirationTime, renderExpirationTime2) {
          {
            if (workInProgress2.type !== workInProgress2.elementType) {
              var outerMemoType = workInProgress2.elementType;
              if (outerMemoType.$$typeof === REACT_LAZY_TYPE) {
                outerMemoType = refineResolvedLazyComponent(outerMemoType);
              }
              var outerPropTypes = outerMemoType && outerMemoType.propTypes;
              if (outerPropTypes) {
                checkPropTypes(
                  outerPropTypes,
                  nextProps,
                  // Resolved (SimpleMemoComponent has no defaultProps)
                  "prop",
                  getComponentName(outerMemoType),
                  getCurrentFiberStackInDev
                );
              }
            }
          }
          if (current3 !== null) {
            var prevProps = current3.memoizedProps;
            if (shallowEqual(prevProps, nextProps) && current3.ref === workInProgress2.ref && // Prevent bailout if the implementation changed due to hot reload.
            workInProgress2.type === current3.type) {
              didReceiveUpdate = false;
              if (updateExpirationTime < renderExpirationTime2) {
                workInProgress2.expirationTime = current3.expirationTime;
                return bailoutOnAlreadyFinishedWork(current3, workInProgress2, renderExpirationTime2);
              }
            }
          }
          return updateFunctionComponent(current3, workInProgress2, Component10, nextProps, renderExpirationTime2);
        }
        function updateFragment(current3, workInProgress2, renderExpirationTime2) {
          var nextChildren = workInProgress2.pendingProps;
          reconcileChildren(current3, workInProgress2, nextChildren, renderExpirationTime2);
          return workInProgress2.child;
        }
        function updateMode(current3, workInProgress2, renderExpirationTime2) {
          var nextChildren = workInProgress2.pendingProps.children;
          reconcileChildren(current3, workInProgress2, nextChildren, renderExpirationTime2);
          return workInProgress2.child;
        }
        function updateProfiler(current3, workInProgress2, renderExpirationTime2) {
          {
            workInProgress2.effectTag |= Update;
          }
          var nextProps = workInProgress2.pendingProps;
          var nextChildren = nextProps.children;
          reconcileChildren(current3, workInProgress2, nextChildren, renderExpirationTime2);
          return workInProgress2.child;
        }
        function markRef(current3, workInProgress2) {
          var ref3 = workInProgress2.ref;
          if (current3 === null && ref3 !== null || current3 !== null && current3.ref !== ref3) {
            workInProgress2.effectTag |= Ref5;
          }
        }
        function updateFunctionComponent(current3, workInProgress2, Component10, nextProps, renderExpirationTime2) {
          {
            if (workInProgress2.type !== workInProgress2.elementType) {
              var innerPropTypes = Component10.propTypes;
              if (innerPropTypes) {
                checkPropTypes(
                  innerPropTypes,
                  nextProps,
                  // Resolved props
                  "prop",
                  getComponentName(Component10),
                  getCurrentFiberStackInDev
                );
              }
            }
          }
          var context;
          {
            var unmaskedContext = getUnmaskedContext(workInProgress2, Component10, true);
            context = getMaskedContext(workInProgress2, unmaskedContext);
          }
          var nextChildren;
          prepareToReadContext(workInProgress2, renderExpirationTime2);
          {
            ReactCurrentOwner$1.current = workInProgress2;
            setIsRendering(true);
            nextChildren = renderWithHooks(current3, workInProgress2, Component10, nextProps, context, renderExpirationTime2);
            if (workInProgress2.mode & StrictMode) {
              if (workInProgress2.memoizedState !== null) {
                nextChildren = renderWithHooks(current3, workInProgress2, Component10, nextProps, context, renderExpirationTime2);
              }
            }
            setIsRendering(false);
          }
          if (current3 !== null && !didReceiveUpdate) {
            bailoutHooks(current3, workInProgress2, renderExpirationTime2);
            return bailoutOnAlreadyFinishedWork(current3, workInProgress2, renderExpirationTime2);
          }
          workInProgress2.effectTag |= PerformedWork;
          reconcileChildren(current3, workInProgress2, nextChildren, renderExpirationTime2);
          return workInProgress2.child;
        }
        function updateClassComponent(current3, workInProgress2, Component10, nextProps, renderExpirationTime2) {
          {
            if (workInProgress2.type !== workInProgress2.elementType) {
              var innerPropTypes = Component10.propTypes;
              if (innerPropTypes) {
                checkPropTypes(
                  innerPropTypes,
                  nextProps,
                  // Resolved props
                  "prop",
                  getComponentName(Component10),
                  getCurrentFiberStackInDev
                );
              }
            }
          }
          var hasContext;
          if (isContextProvider(Component10)) {
            hasContext = true;
            pushContextProvider(workInProgress2);
          } else {
            hasContext = false;
          }
          prepareToReadContext(workInProgress2, renderExpirationTime2);
          var instance = workInProgress2.stateNode;
          var shouldUpdate;
          if (instance === null) {
            if (current3 !== null) {
              current3.alternate = null;
              workInProgress2.alternate = null;
              workInProgress2.effectTag |= Placement;
            }
            constructClassInstance(workInProgress2, Component10, nextProps);
            mountClassInstance(workInProgress2, Component10, nextProps, renderExpirationTime2);
            shouldUpdate = true;
          } else if (current3 === null) {
            shouldUpdate = resumeMountClassInstance(workInProgress2, Component10, nextProps, renderExpirationTime2);
          } else {
            shouldUpdate = updateClassInstance(current3, workInProgress2, Component10, nextProps, renderExpirationTime2);
          }
          var nextUnitOfWork = finishClassComponent(current3, workInProgress2, Component10, shouldUpdate, hasContext, renderExpirationTime2);
          {
            var inst = workInProgress2.stateNode;
            if (inst.props !== nextProps) {
              if (!didWarnAboutReassigningProps) {
                error2("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", getComponentName(workInProgress2.type) || "a component");
              }
              didWarnAboutReassigningProps = true;
            }
          }
          return nextUnitOfWork;
        }
        function finishClassComponent(current3, workInProgress2, Component10, shouldUpdate, hasContext, renderExpirationTime2) {
          markRef(current3, workInProgress2);
          var didCaptureError = (workInProgress2.effectTag & DidCapture) !== NoEffect;
          if (!shouldUpdate && !didCaptureError) {
            if (hasContext) {
              invalidateContextProvider(workInProgress2, Component10, false);
            }
            return bailoutOnAlreadyFinishedWork(current3, workInProgress2, renderExpirationTime2);
          }
          var instance = workInProgress2.stateNode;
          ReactCurrentOwner$1.current = workInProgress2;
          var nextChildren;
          if (didCaptureError && typeof Component10.getDerivedStateFromError !== "function") {
            nextChildren = null;
            {
              stopProfilerTimerIfRunning();
            }
          } else {
            {
              setIsRendering(true);
              nextChildren = instance.render();
              if (workInProgress2.mode & StrictMode) {
                instance.render();
              }
              setIsRendering(false);
            }
          }
          workInProgress2.effectTag |= PerformedWork;
          if (current3 !== null && didCaptureError) {
            forceUnmountCurrentAndReconcile(current3, workInProgress2, nextChildren, renderExpirationTime2);
          } else {
            reconcileChildren(current3, workInProgress2, nextChildren, renderExpirationTime2);
          }
          workInProgress2.memoizedState = instance.state;
          if (hasContext) {
            invalidateContextProvider(workInProgress2, Component10, true);
          }
          return workInProgress2.child;
        }
        function pushHostRootContext(workInProgress2) {
          var root3 = workInProgress2.stateNode;
          if (root3.pendingContext) {
            pushTopLevelContextObject(workInProgress2, root3.pendingContext, root3.pendingContext !== root3.context);
          } else if (root3.context) {
            pushTopLevelContextObject(workInProgress2, root3.context, false);
          }
          pushHostContainer(workInProgress2, root3.containerInfo);
        }
        function updateHostRoot(current3, workInProgress2, renderExpirationTime2) {
          pushHostRootContext(workInProgress2);
          var updateQueue = workInProgress2.updateQueue;
          if (!(current3 !== null && updateQueue !== null)) {
            {
              throw Error("If the root does not have an updateQueue, we should have already bailed out. This error is likely caused by a bug in React. Please file an issue.");
            }
          }
          var nextProps = workInProgress2.pendingProps;
          var prevState = workInProgress2.memoizedState;
          var prevChildren = prevState !== null ? prevState.element : null;
          cloneUpdateQueue(current3, workInProgress2);
          processUpdateQueue(workInProgress2, nextProps, null, renderExpirationTime2);
          var nextState = workInProgress2.memoizedState;
          var nextChildren = nextState.element;
          if (nextChildren === prevChildren) {
            resetHydrationState();
            return bailoutOnAlreadyFinishedWork(current3, workInProgress2, renderExpirationTime2);
          }
          var root3 = workInProgress2.stateNode;
          if (root3.hydrate && enterHydrationState(workInProgress2)) {
            var child = mountChildFibers(workInProgress2, null, nextChildren, renderExpirationTime2);
            workInProgress2.child = child;
            var node2 = child;
            while (node2) {
              node2.effectTag = node2.effectTag & ~Placement | Hydrating;
              node2 = node2.sibling;
            }
          } else {
            reconcileChildren(current3, workInProgress2, nextChildren, renderExpirationTime2);
            resetHydrationState();
          }
          return workInProgress2.child;
        }
        function updateHostComponent(current3, workInProgress2, renderExpirationTime2) {
          pushHostContext(workInProgress2);
          if (current3 === null) {
            tryToClaimNextHydratableInstance(workInProgress2);
          }
          var type5 = workInProgress2.type;
          var nextProps = workInProgress2.pendingProps;
          var prevProps = current3 !== null ? current3.memoizedProps : null;
          var nextChildren = nextProps.children;
          var isDirectTextChild = shouldSetTextContent(type5, nextProps);
          if (isDirectTextChild) {
            nextChildren = null;
          } else if (prevProps !== null && shouldSetTextContent(type5, prevProps)) {
            workInProgress2.effectTag |= ContentReset;
          }
          markRef(current3, workInProgress2);
          if (workInProgress2.mode & ConcurrentMode && renderExpirationTime2 !== Never && shouldDeprioritizeSubtree(type5, nextProps)) {
            {
              markSpawnedWork(Never);
            }
            workInProgress2.expirationTime = workInProgress2.childExpirationTime = Never;
            return null;
          }
          reconcileChildren(current3, workInProgress2, nextChildren, renderExpirationTime2);
          return workInProgress2.child;
        }
        function updateHostText(current3, workInProgress2) {
          if (current3 === null) {
            tryToClaimNextHydratableInstance(workInProgress2);
          }
          return null;
        }
        function mountLazyComponent(_current, workInProgress2, elementType, updateExpirationTime, renderExpirationTime2) {
          if (_current !== null) {
            _current.alternate = null;
            workInProgress2.alternate = null;
            workInProgress2.effectTag |= Placement;
          }
          var props = workInProgress2.pendingProps;
          cancelWorkTimer(workInProgress2);
          var Component10 = readLazyComponentType(elementType);
          workInProgress2.type = Component10;
          var resolvedTag = workInProgress2.tag = resolveLazyComponentTag(Component10);
          startWorkTimer(workInProgress2);
          var resolvedProps = resolveDefaultProps(Component10, props);
          var child;
          switch (resolvedTag) {
            case FunctionComponent: {
              {
                validateFunctionComponentInDev(workInProgress2, Component10);
                workInProgress2.type = Component10 = resolveFunctionForHotReloading(Component10);
              }
              child = updateFunctionComponent(null, workInProgress2, Component10, resolvedProps, renderExpirationTime2);
              return child;
            }
            case ClassComponent: {
              {
                workInProgress2.type = Component10 = resolveClassForHotReloading(Component10);
              }
              child = updateClassComponent(null, workInProgress2, Component10, resolvedProps, renderExpirationTime2);
              return child;
            }
            case ForwardRef2: {
              {
                workInProgress2.type = Component10 = resolveForwardRefForHotReloading(Component10);
              }
              child = updateForwardRef(null, workInProgress2, Component10, resolvedProps, renderExpirationTime2);
              return child;
            }
            case MemoComponent: {
              {
                if (workInProgress2.type !== workInProgress2.elementType) {
                  var outerPropTypes = Component10.propTypes;
                  if (outerPropTypes) {
                    checkPropTypes(
                      outerPropTypes,
                      resolvedProps,
                      // Resolved for outer only
                      "prop",
                      getComponentName(Component10),
                      getCurrentFiberStackInDev
                    );
                  }
                }
              }
              child = updateMemoComponent(
                null,
                workInProgress2,
                Component10,
                resolveDefaultProps(Component10.type, resolvedProps),
                // The inner type can have defaults too
                updateExpirationTime,
                renderExpirationTime2
              );
              return child;
            }
          }
          var hint = "";
          {
            if (Component10 !== null && typeof Component10 === "object" && Component10.$$typeof === REACT_LAZY_TYPE) {
              hint = " Did you wrap a component in React.lazy() more than once?";
            }
          }
          {
            {
              throw Error("Element type is invalid. Received a promise that resolves to: " + Component10 + ". Lazy element type must resolve to a class or function." + hint);
            }
          }
        }
        function mountIncompleteClassComponent(_current, workInProgress2, Component10, nextProps, renderExpirationTime2) {
          if (_current !== null) {
            _current.alternate = null;
            workInProgress2.alternate = null;
            workInProgress2.effectTag |= Placement;
          }
          workInProgress2.tag = ClassComponent;
          var hasContext;
          if (isContextProvider(Component10)) {
            hasContext = true;
            pushContextProvider(workInProgress2);
          } else {
            hasContext = false;
          }
          prepareToReadContext(workInProgress2, renderExpirationTime2);
          constructClassInstance(workInProgress2, Component10, nextProps);
          mountClassInstance(workInProgress2, Component10, nextProps, renderExpirationTime2);
          return finishClassComponent(null, workInProgress2, Component10, true, hasContext, renderExpirationTime2);
        }
        function mountIndeterminateComponent(_current, workInProgress2, Component10, renderExpirationTime2) {
          if (_current !== null) {
            _current.alternate = null;
            workInProgress2.alternate = null;
            workInProgress2.effectTag |= Placement;
          }
          var props = workInProgress2.pendingProps;
          var context;
          {
            var unmaskedContext = getUnmaskedContext(workInProgress2, Component10, false);
            context = getMaskedContext(workInProgress2, unmaskedContext);
          }
          prepareToReadContext(workInProgress2, renderExpirationTime2);
          var value;
          {
            if (Component10.prototype && typeof Component10.prototype.render === "function") {
              var componentName = getComponentName(Component10) || "Unknown";
              if (!didWarnAboutBadClass[componentName]) {
                error2("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", componentName, componentName);
                didWarnAboutBadClass[componentName] = true;
              }
            }
            if (workInProgress2.mode & StrictMode) {
              ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress2, null);
            }
            setIsRendering(true);
            ReactCurrentOwner$1.current = workInProgress2;
            value = renderWithHooks(null, workInProgress2, Component10, props, context, renderExpirationTime2);
            setIsRendering(false);
          }
          workInProgress2.effectTag |= PerformedWork;
          if (typeof value === "object" && value !== null && typeof value.render === "function" && value.$$typeof === void 0) {
            {
              var _componentName = getComponentName(Component10) || "Unknown";
              if (!didWarnAboutModulePatternComponent[_componentName]) {
                error2("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", _componentName, _componentName, _componentName);
                didWarnAboutModulePatternComponent[_componentName] = true;
              }
            }
            workInProgress2.tag = ClassComponent;
            workInProgress2.memoizedState = null;
            workInProgress2.updateQueue = null;
            var hasContext = false;
            if (isContextProvider(Component10)) {
              hasContext = true;
              pushContextProvider(workInProgress2);
            } else {
              hasContext = false;
            }
            workInProgress2.memoizedState = value.state !== null && value.state !== void 0 ? value.state : null;
            initializeUpdateQueue(workInProgress2);
            var getDerivedStateFromProps = Component10.getDerivedStateFromProps;
            if (typeof getDerivedStateFromProps === "function") {
              applyDerivedStateFromProps(workInProgress2, Component10, getDerivedStateFromProps, props);
            }
            adoptClassInstance(workInProgress2, value);
            mountClassInstance(workInProgress2, Component10, props, renderExpirationTime2);
            return finishClassComponent(null, workInProgress2, Component10, true, hasContext, renderExpirationTime2);
          } else {
            workInProgress2.tag = FunctionComponent;
            {
              if (workInProgress2.mode & StrictMode) {
                if (workInProgress2.memoizedState !== null) {
                  value = renderWithHooks(null, workInProgress2, Component10, props, context, renderExpirationTime2);
                }
              }
            }
            reconcileChildren(null, workInProgress2, value, renderExpirationTime2);
            {
              validateFunctionComponentInDev(workInProgress2, Component10);
            }
            return workInProgress2.child;
          }
        }
        function validateFunctionComponentInDev(workInProgress2, Component10) {
          {
            if (Component10) {
              if (Component10.childContextTypes) {
                error2("%s(...): childContextTypes cannot be defined on a function component.", Component10.displayName || Component10.name || "Component");
              }
            }
            if (workInProgress2.ref !== null) {
              var info = "";
              var ownerName = getCurrentFiberOwnerNameInDevOrNull();
              if (ownerName) {
                info += "\n\nCheck the render method of `" + ownerName + "`.";
              }
              var warningKey = ownerName || workInProgress2._debugID || "";
              var debugSource = workInProgress2._debugSource;
              if (debugSource) {
                warningKey = debugSource.fileName + ":" + debugSource.lineNumber;
              }
              if (!didWarnAboutFunctionRefs[warningKey]) {
                didWarnAboutFunctionRefs[warningKey] = true;
                error2("Function components cannot be given refs. Attempts to access this ref will fail. Did you mean to use React.forwardRef()?%s", info);
              }
            }
            if (typeof Component10.getDerivedStateFromProps === "function") {
              var _componentName2 = getComponentName(Component10) || "Unknown";
              if (!didWarnAboutGetDerivedStateOnFunctionComponent[_componentName2]) {
                error2("%s: Function components do not support getDerivedStateFromProps.", _componentName2);
                didWarnAboutGetDerivedStateOnFunctionComponent[_componentName2] = true;
              }
            }
            if (typeof Component10.contextType === "object" && Component10.contextType !== null) {
              var _componentName3 = getComponentName(Component10) || "Unknown";
              if (!didWarnAboutContextTypeOnFunctionComponent[_componentName3]) {
                error2("%s: Function components do not support contextType.", _componentName3);
                didWarnAboutContextTypeOnFunctionComponent[_componentName3] = true;
              }
            }
          }
        }
        var SUSPENDED_MARKER = {
          dehydrated: null,
          retryTime: NoWork
        };
        function shouldRemainOnFallback(suspenseContext, current3, workInProgress2) {
          return hasSuspenseContext(suspenseContext, ForceSuspenseFallback) && (current3 === null || current3.memoizedState !== null);
        }
        function updateSuspenseComponent(current3, workInProgress2, renderExpirationTime2) {
          var mode = workInProgress2.mode;
          var nextProps = workInProgress2.pendingProps;
          {
            if (shouldSuspend(workInProgress2)) {
              workInProgress2.effectTag |= DidCapture;
            }
          }
          var suspenseContext = suspenseStackCursor.current;
          var nextDidTimeout = false;
          var didSuspend = (workInProgress2.effectTag & DidCapture) !== NoEffect;
          if (didSuspend || shouldRemainOnFallback(suspenseContext, current3)) {
            nextDidTimeout = true;
            workInProgress2.effectTag &= ~DidCapture;
          } else {
            if (current3 === null || current3.memoizedState !== null) {
              if (nextProps.fallback !== void 0 && nextProps.unstable_avoidThisFallback !== true) {
                suspenseContext = addSubtreeSuspenseContext(suspenseContext, InvisibleParentSuspenseContext);
              }
            }
          }
          suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
          pushSuspenseContext(workInProgress2, suspenseContext);
          if (current3 === null) {
            if (nextProps.fallback !== void 0) {
              tryToClaimNextHydratableInstance(workInProgress2);
            }
            if (nextDidTimeout) {
              var nextFallbackChildren = nextProps.fallback;
              var primaryChildFragment = createFiberFromFragment(null, mode, NoWork, null);
              primaryChildFragment.return = workInProgress2;
              if ((workInProgress2.mode & BlockingMode) === NoMode) {
                var progressedState = workInProgress2.memoizedState;
                var progressedPrimaryChild = progressedState !== null ? workInProgress2.child.child : workInProgress2.child;
                primaryChildFragment.child = progressedPrimaryChild;
                var progressedChild = progressedPrimaryChild;
                while (progressedChild !== null) {
                  progressedChild.return = primaryChildFragment;
                  progressedChild = progressedChild.sibling;
                }
              }
              var fallbackChildFragment = createFiberFromFragment(nextFallbackChildren, mode, renderExpirationTime2, null);
              fallbackChildFragment.return = workInProgress2;
              primaryChildFragment.sibling = fallbackChildFragment;
              workInProgress2.memoizedState = SUSPENDED_MARKER;
              workInProgress2.child = primaryChildFragment;
              return fallbackChildFragment;
            } else {
              var nextPrimaryChildren = nextProps.children;
              workInProgress2.memoizedState = null;
              return workInProgress2.child = mountChildFibers(workInProgress2, null, nextPrimaryChildren, renderExpirationTime2);
            }
          } else {
            var prevState = current3.memoizedState;
            if (prevState !== null) {
              var currentPrimaryChildFragment = current3.child;
              var currentFallbackChildFragment = currentPrimaryChildFragment.sibling;
              if (nextDidTimeout) {
                var _nextFallbackChildren2 = nextProps.fallback;
                var _primaryChildFragment2 = createWorkInProgress(currentPrimaryChildFragment, currentPrimaryChildFragment.pendingProps);
                _primaryChildFragment2.return = workInProgress2;
                if ((workInProgress2.mode & BlockingMode) === NoMode) {
                  var _progressedState = workInProgress2.memoizedState;
                  var _progressedPrimaryChild = _progressedState !== null ? workInProgress2.child.child : workInProgress2.child;
                  if (_progressedPrimaryChild !== currentPrimaryChildFragment.child) {
                    _primaryChildFragment2.child = _progressedPrimaryChild;
                    var _progressedChild2 = _progressedPrimaryChild;
                    while (_progressedChild2 !== null) {
                      _progressedChild2.return = _primaryChildFragment2;
                      _progressedChild2 = _progressedChild2.sibling;
                    }
                  }
                }
                if (workInProgress2.mode & ProfileMode) {
                  var _treeBaseDuration = 0;
                  var _hiddenChild = _primaryChildFragment2.child;
                  while (_hiddenChild !== null) {
                    _treeBaseDuration += _hiddenChild.treeBaseDuration;
                    _hiddenChild = _hiddenChild.sibling;
                  }
                  _primaryChildFragment2.treeBaseDuration = _treeBaseDuration;
                }
                var _fallbackChildFragment2 = createWorkInProgress(currentFallbackChildFragment, _nextFallbackChildren2);
                _fallbackChildFragment2.return = workInProgress2;
                _primaryChildFragment2.sibling = _fallbackChildFragment2;
                _primaryChildFragment2.childExpirationTime = NoWork;
                workInProgress2.memoizedState = SUSPENDED_MARKER;
                workInProgress2.child = _primaryChildFragment2;
                return _fallbackChildFragment2;
              } else {
                var _nextPrimaryChildren = nextProps.children;
                var currentPrimaryChild = currentPrimaryChildFragment.child;
                var primaryChild = reconcileChildFibers(workInProgress2, currentPrimaryChild, _nextPrimaryChildren, renderExpirationTime2);
                workInProgress2.memoizedState = null;
                return workInProgress2.child = primaryChild;
              }
            } else {
              var _currentPrimaryChild = current3.child;
              if (nextDidTimeout) {
                var _nextFallbackChildren3 = nextProps.fallback;
                var _primaryChildFragment3 = createFiberFromFragment(
                  // It shouldn't matter what the pending props are because we aren't
                  // going to render this fragment.
                  null,
                  mode,
                  NoWork,
                  null
                );
                _primaryChildFragment3.return = workInProgress2;
                _primaryChildFragment3.child = _currentPrimaryChild;
                if (_currentPrimaryChild !== null) {
                  _currentPrimaryChild.return = _primaryChildFragment3;
                }
                if ((workInProgress2.mode & BlockingMode) === NoMode) {
                  var _progressedState2 = workInProgress2.memoizedState;
                  var _progressedPrimaryChild2 = _progressedState2 !== null ? workInProgress2.child.child : workInProgress2.child;
                  _primaryChildFragment3.child = _progressedPrimaryChild2;
                  var _progressedChild3 = _progressedPrimaryChild2;
                  while (_progressedChild3 !== null) {
                    _progressedChild3.return = _primaryChildFragment3;
                    _progressedChild3 = _progressedChild3.sibling;
                  }
                }
                if (workInProgress2.mode & ProfileMode) {
                  var _treeBaseDuration2 = 0;
                  var _hiddenChild2 = _primaryChildFragment3.child;
                  while (_hiddenChild2 !== null) {
                    _treeBaseDuration2 += _hiddenChild2.treeBaseDuration;
                    _hiddenChild2 = _hiddenChild2.sibling;
                  }
                  _primaryChildFragment3.treeBaseDuration = _treeBaseDuration2;
                }
                var _fallbackChildFragment3 = createFiberFromFragment(_nextFallbackChildren3, mode, renderExpirationTime2, null);
                _fallbackChildFragment3.return = workInProgress2;
                _primaryChildFragment3.sibling = _fallbackChildFragment3;
                _fallbackChildFragment3.effectTag |= Placement;
                _primaryChildFragment3.childExpirationTime = NoWork;
                workInProgress2.memoizedState = SUSPENDED_MARKER;
                workInProgress2.child = _primaryChildFragment3;
                return _fallbackChildFragment3;
              } else {
                workInProgress2.memoizedState = null;
                var _nextPrimaryChildren2 = nextProps.children;
                return workInProgress2.child = reconcileChildFibers(workInProgress2, _currentPrimaryChild, _nextPrimaryChildren2, renderExpirationTime2);
              }
            }
          }
        }
        function scheduleWorkOnFiber(fiber, renderExpirationTime2) {
          if (fiber.expirationTime < renderExpirationTime2) {
            fiber.expirationTime = renderExpirationTime2;
          }
          var alternate = fiber.alternate;
          if (alternate !== null && alternate.expirationTime < renderExpirationTime2) {
            alternate.expirationTime = renderExpirationTime2;
          }
          scheduleWorkOnParentPath(fiber.return, renderExpirationTime2);
        }
        function propagateSuspenseContextChange(workInProgress2, firstChild, renderExpirationTime2) {
          var node2 = firstChild;
          while (node2 !== null) {
            if (node2.tag === SuspenseComponent) {
              var state = node2.memoizedState;
              if (state !== null) {
                scheduleWorkOnFiber(node2, renderExpirationTime2);
              }
            } else if (node2.tag === SuspenseListComponent) {
              scheduleWorkOnFiber(node2, renderExpirationTime2);
            } else if (node2.child !== null) {
              node2.child.return = node2;
              node2 = node2.child;
              continue;
            }
            if (node2 === workInProgress2) {
              return;
            }
            while (node2.sibling === null) {
              if (node2.return === null || node2.return === workInProgress2) {
                return;
              }
              node2 = node2.return;
            }
            node2.sibling.return = node2.return;
            node2 = node2.sibling;
          }
        }
        function findLastContentRow(firstChild) {
          var row = firstChild;
          var lastContentRow = null;
          while (row !== null) {
            var currentRow = row.alternate;
            if (currentRow !== null && findFirstSuspended(currentRow) === null) {
              lastContentRow = row;
            }
            row = row.sibling;
          }
          return lastContentRow;
        }
        function validateRevealOrder(revealOrder) {
          {
            if (revealOrder !== void 0 && revealOrder !== "forwards" && revealOrder !== "backwards" && revealOrder !== "together" && !didWarnAboutRevealOrder[revealOrder]) {
              didWarnAboutRevealOrder[revealOrder] = true;
              if (typeof revealOrder === "string") {
                switch (revealOrder.toLowerCase()) {
                  case "together":
                  case "forwards":
                  case "backwards": {
                    error2('"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.', revealOrder, revealOrder.toLowerCase());
                    break;
                  }
                  case "forward":
                  case "backward": {
                    error2('"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.', revealOrder, revealOrder.toLowerCase());
                    break;
                  }
                  default:
                    error2('"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', revealOrder);
                    break;
                }
              } else {
                error2('%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', revealOrder);
              }
            }
          }
        }
        function validateTailOptions(tailMode, revealOrder) {
          {
            if (tailMode !== void 0 && !didWarnAboutTailOptions[tailMode]) {
              if (tailMode !== "collapsed" && tailMode !== "hidden") {
                didWarnAboutTailOptions[tailMode] = true;
                error2('"%s" is not a supported value for tail on <SuspenseList />. Did you mean "collapsed" or "hidden"?', tailMode);
              } else if (revealOrder !== "forwards" && revealOrder !== "backwards") {
                didWarnAboutTailOptions[tailMode] = true;
                error2('<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?', tailMode);
              }
            }
          }
        }
        function validateSuspenseListNestedChild(childSlot, index4) {
          {
            var isArray7 = Array.isArray(childSlot);
            var isIterable = !isArray7 && typeof getIteratorFn(childSlot) === "function";
            if (isArray7 || isIterable) {
              var type5 = isArray7 ? "array" : "iterable";
              error2("A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>", type5, index4, type5);
              return false;
            }
          }
          return true;
        }
        function validateSuspenseListChildren(children, revealOrder) {
          {
            if ((revealOrder === "forwards" || revealOrder === "backwards") && children !== void 0 && children !== null && children !== false) {
              if (Array.isArray(children)) {
                for (var i = 0; i < children.length; i++) {
                  if (!validateSuspenseListNestedChild(children[i], i)) {
                    return;
                  }
                }
              } else {
                var iteratorFn = getIteratorFn(children);
                if (typeof iteratorFn === "function") {
                  var childrenIterator = iteratorFn.call(children);
                  if (childrenIterator) {
                    var step = childrenIterator.next();
                    var _i = 0;
                    for (; !step.done; step = childrenIterator.next()) {
                      if (!validateSuspenseListNestedChild(step.value, _i)) {
                        return;
                      }
                      _i++;
                    }
                  }
                } else {
                  error2('A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?', revealOrder);
                }
              }
            }
          }
        }
        function initSuspenseListRenderState(workInProgress2, isBackwards, tail, lastContentRow, tailMode, lastEffectBeforeRendering) {
          var renderState = workInProgress2.memoizedState;
          if (renderState === null) {
            workInProgress2.memoizedState = {
              isBackwards,
              rendering: null,
              renderingStartTime: 0,
              last: lastContentRow,
              tail,
              tailExpiration: 0,
              tailMode,
              lastEffect: lastEffectBeforeRendering
            };
          } else {
            renderState.isBackwards = isBackwards;
            renderState.rendering = null;
            renderState.renderingStartTime = 0;
            renderState.last = lastContentRow;
            renderState.tail = tail;
            renderState.tailExpiration = 0;
            renderState.tailMode = tailMode;
            renderState.lastEffect = lastEffectBeforeRendering;
          }
        }
        function updateSuspenseListComponent(current3, workInProgress2, renderExpirationTime2) {
          var nextProps = workInProgress2.pendingProps;
          var revealOrder = nextProps.revealOrder;
          var tailMode = nextProps.tail;
          var newChildren = nextProps.children;
          validateRevealOrder(revealOrder);
          validateTailOptions(tailMode, revealOrder);
          validateSuspenseListChildren(newChildren, revealOrder);
          reconcileChildren(current3, workInProgress2, newChildren, renderExpirationTime2);
          var suspenseContext = suspenseStackCursor.current;
          var shouldForceFallback = hasSuspenseContext(suspenseContext, ForceSuspenseFallback);
          if (shouldForceFallback) {
            suspenseContext = setShallowSuspenseContext(suspenseContext, ForceSuspenseFallback);
            workInProgress2.effectTag |= DidCapture;
          } else {
            var didSuspendBefore = current3 !== null && (current3.effectTag & DidCapture) !== NoEffect;
            if (didSuspendBefore) {
              propagateSuspenseContextChange(workInProgress2, workInProgress2.child, renderExpirationTime2);
            }
            suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
          }
          pushSuspenseContext(workInProgress2, suspenseContext);
          if ((workInProgress2.mode & BlockingMode) === NoMode) {
            workInProgress2.memoizedState = null;
          } else {
            switch (revealOrder) {
              case "forwards": {
                var lastContentRow = findLastContentRow(workInProgress2.child);
                var tail;
                if (lastContentRow === null) {
                  tail = workInProgress2.child;
                  workInProgress2.child = null;
                } else {
                  tail = lastContentRow.sibling;
                  lastContentRow.sibling = null;
                }
                initSuspenseListRenderState(
                  workInProgress2,
                  false,
                  // isBackwards
                  tail,
                  lastContentRow,
                  tailMode,
                  workInProgress2.lastEffect
                );
                break;
              }
              case "backwards": {
                var _tail = null;
                var row = workInProgress2.child;
                workInProgress2.child = null;
                while (row !== null) {
                  var currentRow = row.alternate;
                  if (currentRow !== null && findFirstSuspended(currentRow) === null) {
                    workInProgress2.child = row;
                    break;
                  }
                  var nextRow = row.sibling;
                  row.sibling = _tail;
                  _tail = row;
                  row = nextRow;
                }
                initSuspenseListRenderState(
                  workInProgress2,
                  true,
                  // isBackwards
                  _tail,
                  null,
                  // last
                  tailMode,
                  workInProgress2.lastEffect
                );
                break;
              }
              case "together": {
                initSuspenseListRenderState(
                  workInProgress2,
                  false,
                  // isBackwards
                  null,
                  // tail
                  null,
                  // last
                  void 0,
                  workInProgress2.lastEffect
                );
                break;
              }
              default: {
                workInProgress2.memoizedState = null;
              }
            }
          }
          return workInProgress2.child;
        }
        function updatePortalComponent(current3, workInProgress2, renderExpirationTime2) {
          pushHostContainer(workInProgress2, workInProgress2.stateNode.containerInfo);
          var nextChildren = workInProgress2.pendingProps;
          if (current3 === null) {
            workInProgress2.child = reconcileChildFibers(workInProgress2, null, nextChildren, renderExpirationTime2);
          } else {
            reconcileChildren(current3, workInProgress2, nextChildren, renderExpirationTime2);
          }
          return workInProgress2.child;
        }
        function updateContextProvider(current3, workInProgress2, renderExpirationTime2) {
          var providerType = workInProgress2.type;
          var context = providerType._context;
          var newProps = workInProgress2.pendingProps;
          var oldProps = workInProgress2.memoizedProps;
          var newValue = newProps.value;
          {
            var providerPropTypes = workInProgress2.type.propTypes;
            if (providerPropTypes) {
              checkPropTypes(providerPropTypes, newProps, "prop", "Context.Provider", getCurrentFiberStackInDev);
            }
          }
          pushProvider(workInProgress2, newValue);
          if (oldProps !== null) {
            var oldValue = oldProps.value;
            var changedBits = calculateChangedBits(context, newValue, oldValue);
            if (changedBits === 0) {
              if (oldProps.children === newProps.children && !hasContextChanged()) {
                return bailoutOnAlreadyFinishedWork(current3, workInProgress2, renderExpirationTime2);
              }
            } else {
              propagateContextChange(workInProgress2, context, changedBits, renderExpirationTime2);
            }
          }
          var newChildren = newProps.children;
          reconcileChildren(current3, workInProgress2, newChildren, renderExpirationTime2);
          return workInProgress2.child;
        }
        var hasWarnedAboutUsingContextAsConsumer = false;
        function updateContextConsumer(current3, workInProgress2, renderExpirationTime2) {
          var context = workInProgress2.type;
          {
            if (context._context === void 0) {
              if (context !== context.Consumer) {
                if (!hasWarnedAboutUsingContextAsConsumer) {
                  hasWarnedAboutUsingContextAsConsumer = true;
                  error2("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?");
                }
              }
            } else {
              context = context._context;
            }
          }
          var newProps = workInProgress2.pendingProps;
          var render5 = newProps.children;
          {
            if (typeof render5 !== "function") {
              error2("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it.");
            }
          }
          prepareToReadContext(workInProgress2, renderExpirationTime2);
          var newValue = readContext(context, newProps.unstable_observedBits);
          var newChildren;
          {
            ReactCurrentOwner$1.current = workInProgress2;
            setIsRendering(true);
            newChildren = render5(newValue);
            setIsRendering(false);
          }
          workInProgress2.effectTag |= PerformedWork;
          reconcileChildren(current3, workInProgress2, newChildren, renderExpirationTime2);
          return workInProgress2.child;
        }
        function markWorkInProgressReceivedUpdate() {
          didReceiveUpdate = true;
        }
        function bailoutOnAlreadyFinishedWork(current3, workInProgress2, renderExpirationTime2) {
          cancelWorkTimer(workInProgress2);
          if (current3 !== null) {
            workInProgress2.dependencies = current3.dependencies;
          }
          {
            stopProfilerTimerIfRunning();
          }
          var updateExpirationTime = workInProgress2.expirationTime;
          if (updateExpirationTime !== NoWork) {
            markUnprocessedUpdateTime(updateExpirationTime);
          }
          var childExpirationTime = workInProgress2.childExpirationTime;
          if (childExpirationTime < renderExpirationTime2) {
            return null;
          } else {
            cloneChildFibers(current3, workInProgress2);
            return workInProgress2.child;
          }
        }
        function remountFiber(current3, oldWorkInProgress, newWorkInProgress) {
          {
            var returnFiber = oldWorkInProgress.return;
            if (returnFiber === null) {
              throw new Error("Cannot swap the root fiber.");
            }
            current3.alternate = null;
            oldWorkInProgress.alternate = null;
            newWorkInProgress.index = oldWorkInProgress.index;
            newWorkInProgress.sibling = oldWorkInProgress.sibling;
            newWorkInProgress.return = oldWorkInProgress.return;
            newWorkInProgress.ref = oldWorkInProgress.ref;
            if (oldWorkInProgress === returnFiber.child) {
              returnFiber.child = newWorkInProgress;
            } else {
              var prevSibling = returnFiber.child;
              if (prevSibling === null) {
                throw new Error("Expected parent to have a child.");
              }
              while (prevSibling.sibling !== oldWorkInProgress) {
                prevSibling = prevSibling.sibling;
                if (prevSibling === null) {
                  throw new Error("Expected to find the previous sibling.");
                }
              }
              prevSibling.sibling = newWorkInProgress;
            }
            var last2 = returnFiber.lastEffect;
            if (last2 !== null) {
              last2.nextEffect = current3;
              returnFiber.lastEffect = current3;
            } else {
              returnFiber.firstEffect = returnFiber.lastEffect = current3;
            }
            current3.nextEffect = null;
            current3.effectTag = Deletion;
            newWorkInProgress.effectTag |= Placement;
            return newWorkInProgress;
          }
        }
        function beginWork(current3, workInProgress2, renderExpirationTime2) {
          var updateExpirationTime = workInProgress2.expirationTime;
          {
            if (workInProgress2._debugNeedsRemount && current3 !== null) {
              return remountFiber(current3, workInProgress2, createFiberFromTypeAndProps(workInProgress2.type, workInProgress2.key, workInProgress2.pendingProps, workInProgress2._debugOwner || null, workInProgress2.mode, workInProgress2.expirationTime));
            }
          }
          if (current3 !== null) {
            var oldProps = current3.memoizedProps;
            var newProps = workInProgress2.pendingProps;
            if (oldProps !== newProps || hasContextChanged() || // Force a re-render if the implementation changed due to hot reload:
            workInProgress2.type !== current3.type) {
              didReceiveUpdate = true;
            } else if (updateExpirationTime < renderExpirationTime2) {
              didReceiveUpdate = false;
              switch (workInProgress2.tag) {
                case HostRoot:
                  pushHostRootContext(workInProgress2);
                  resetHydrationState();
                  break;
                case HostComponent:
                  pushHostContext(workInProgress2);
                  if (workInProgress2.mode & ConcurrentMode && renderExpirationTime2 !== Never && shouldDeprioritizeSubtree(workInProgress2.type, newProps)) {
                    {
                      markSpawnedWork(Never);
                    }
                    workInProgress2.expirationTime = workInProgress2.childExpirationTime = Never;
                    return null;
                  }
                  break;
                case ClassComponent: {
                  var Component10 = workInProgress2.type;
                  if (isContextProvider(Component10)) {
                    pushContextProvider(workInProgress2);
                  }
                  break;
                }
                case HostPortal:
                  pushHostContainer(workInProgress2, workInProgress2.stateNode.containerInfo);
                  break;
                case ContextProvider: {
                  var newValue = workInProgress2.memoizedProps.value;
                  pushProvider(workInProgress2, newValue);
                  break;
                }
                case Profiler:
                  {
                    var hasChildWork = workInProgress2.childExpirationTime >= renderExpirationTime2;
                    if (hasChildWork) {
                      workInProgress2.effectTag |= Update;
                    }
                  }
                  break;
                case SuspenseComponent: {
                  var state = workInProgress2.memoizedState;
                  if (state !== null) {
                    var primaryChildFragment = workInProgress2.child;
                    var primaryChildExpirationTime = primaryChildFragment.childExpirationTime;
                    if (primaryChildExpirationTime !== NoWork && primaryChildExpirationTime >= renderExpirationTime2) {
                      return updateSuspenseComponent(current3, workInProgress2, renderExpirationTime2);
                    } else {
                      pushSuspenseContext(workInProgress2, setDefaultShallowSuspenseContext(suspenseStackCursor.current));
                      var child = bailoutOnAlreadyFinishedWork(current3, workInProgress2, renderExpirationTime2);
                      if (child !== null) {
                        return child.sibling;
                      } else {
                        return null;
                      }
                    }
                  } else {
                    pushSuspenseContext(workInProgress2, setDefaultShallowSuspenseContext(suspenseStackCursor.current));
                  }
                  break;
                }
                case SuspenseListComponent: {
                  var didSuspendBefore = (current3.effectTag & DidCapture) !== NoEffect;
                  var _hasChildWork = workInProgress2.childExpirationTime >= renderExpirationTime2;
                  if (didSuspendBefore) {
                    if (_hasChildWork) {
                      return updateSuspenseListComponent(current3, workInProgress2, renderExpirationTime2);
                    }
                    workInProgress2.effectTag |= DidCapture;
                  }
                  var renderState = workInProgress2.memoizedState;
                  if (renderState !== null) {
                    renderState.rendering = null;
                    renderState.tail = null;
                  }
                  pushSuspenseContext(workInProgress2, suspenseStackCursor.current);
                  if (_hasChildWork) {
                    break;
                  } else {
                    return null;
                  }
                }
              }
              return bailoutOnAlreadyFinishedWork(current3, workInProgress2, renderExpirationTime2);
            } else {
              didReceiveUpdate = false;
            }
          } else {
            didReceiveUpdate = false;
          }
          workInProgress2.expirationTime = NoWork;
          switch (workInProgress2.tag) {
            case IndeterminateComponent: {
              return mountIndeterminateComponent(current3, workInProgress2, workInProgress2.type, renderExpirationTime2);
            }
            case LazyComponent: {
              var elementType = workInProgress2.elementType;
              return mountLazyComponent(current3, workInProgress2, elementType, updateExpirationTime, renderExpirationTime2);
            }
            case FunctionComponent: {
              var _Component = workInProgress2.type;
              var unresolvedProps = workInProgress2.pendingProps;
              var resolvedProps = workInProgress2.elementType === _Component ? unresolvedProps : resolveDefaultProps(_Component, unresolvedProps);
              return updateFunctionComponent(current3, workInProgress2, _Component, resolvedProps, renderExpirationTime2);
            }
            case ClassComponent: {
              var _Component2 = workInProgress2.type;
              var _unresolvedProps = workInProgress2.pendingProps;
              var _resolvedProps = workInProgress2.elementType === _Component2 ? _unresolvedProps : resolveDefaultProps(_Component2, _unresolvedProps);
              return updateClassComponent(current3, workInProgress2, _Component2, _resolvedProps, renderExpirationTime2);
            }
            case HostRoot:
              return updateHostRoot(current3, workInProgress2, renderExpirationTime2);
            case HostComponent:
              return updateHostComponent(current3, workInProgress2, renderExpirationTime2);
            case HostText:
              return updateHostText(current3, workInProgress2);
            case SuspenseComponent:
              return updateSuspenseComponent(current3, workInProgress2, renderExpirationTime2);
            case HostPortal:
              return updatePortalComponent(current3, workInProgress2, renderExpirationTime2);
            case ForwardRef2: {
              var type5 = workInProgress2.type;
              var _unresolvedProps2 = workInProgress2.pendingProps;
              var _resolvedProps2 = workInProgress2.elementType === type5 ? _unresolvedProps2 : resolveDefaultProps(type5, _unresolvedProps2);
              return updateForwardRef(current3, workInProgress2, type5, _resolvedProps2, renderExpirationTime2);
            }
            case Fragment35:
              return updateFragment(current3, workInProgress2, renderExpirationTime2);
            case Mode3:
              return updateMode(current3, workInProgress2, renderExpirationTime2);
            case Profiler:
              return updateProfiler(current3, workInProgress2, renderExpirationTime2);
            case ContextProvider:
              return updateContextProvider(current3, workInProgress2, renderExpirationTime2);
            case ContextConsumer:
              return updateContextConsumer(current3, workInProgress2, renderExpirationTime2);
            case MemoComponent: {
              var _type2 = workInProgress2.type;
              var _unresolvedProps3 = workInProgress2.pendingProps;
              var _resolvedProps3 = resolveDefaultProps(_type2, _unresolvedProps3);
              {
                if (workInProgress2.type !== workInProgress2.elementType) {
                  var outerPropTypes = _type2.propTypes;
                  if (outerPropTypes) {
                    checkPropTypes(
                      outerPropTypes,
                      _resolvedProps3,
                      // Resolved for outer only
                      "prop",
                      getComponentName(_type2),
                      getCurrentFiberStackInDev
                    );
                  }
                }
              }
              _resolvedProps3 = resolveDefaultProps(_type2.type, _resolvedProps3);
              return updateMemoComponent(current3, workInProgress2, _type2, _resolvedProps3, updateExpirationTime, renderExpirationTime2);
            }
            case SimpleMemoComponent: {
              return updateSimpleMemoComponent(current3, workInProgress2, workInProgress2.type, workInProgress2.pendingProps, updateExpirationTime, renderExpirationTime2);
            }
            case IncompleteClassComponent: {
              var _Component3 = workInProgress2.type;
              var _unresolvedProps4 = workInProgress2.pendingProps;
              var _resolvedProps4 = workInProgress2.elementType === _Component3 ? _unresolvedProps4 : resolveDefaultProps(_Component3, _unresolvedProps4);
              return mountIncompleteClassComponent(current3, workInProgress2, _Component3, _resolvedProps4, renderExpirationTime2);
            }
            case SuspenseListComponent: {
              return updateSuspenseListComponent(current3, workInProgress2, renderExpirationTime2);
            }
          }
          {
            {
              throw Error("Unknown unit of work tag (" + workInProgress2.tag + "). This error is likely caused by a bug in React. Please file an issue.");
            }
          }
        }
        function markUpdate(workInProgress2) {
          workInProgress2.effectTag |= Update;
        }
        function markRef$1(workInProgress2) {
          workInProgress2.effectTag |= Ref5;
        }
        var appendAllChildren;
        var updateHostContainer;
        var updateHostComponent$1;
        var updateHostText$1;
        {
          appendAllChildren = function(parent2, workInProgress2, needsVisibilityToggle, isHidden) {
            var node2 = workInProgress2.child;
            while (node2 !== null) {
              if (node2.tag === HostComponent || node2.tag === HostText) {
                appendInitialChild(parent2, node2.stateNode);
              } else if (node2.tag === HostPortal) ;
              else if (node2.child !== null) {
                node2.child.return = node2;
                node2 = node2.child;
                continue;
              }
              if (node2 === workInProgress2) {
                return;
              }
              while (node2.sibling === null) {
                if (node2.return === null || node2.return === workInProgress2) {
                  return;
                }
                node2 = node2.return;
              }
              node2.sibling.return = node2.return;
              node2 = node2.sibling;
            }
          };
          updateHostContainer = function(workInProgress2) {
          };
          updateHostComponent$1 = function(current3, workInProgress2, type5, newProps, rootContainerInstance) {
            var oldProps = current3.memoizedProps;
            if (oldProps === newProps) {
              return;
            }
            var instance = workInProgress2.stateNode;
            var currentHostContext = getHostContext();
            var updatePayload = prepareUpdate(instance, type5, oldProps, newProps, rootContainerInstance, currentHostContext);
            workInProgress2.updateQueue = updatePayload;
            if (updatePayload) {
              markUpdate(workInProgress2);
            }
          };
          updateHostText$1 = function(current3, workInProgress2, oldText, newText) {
            if (oldText !== newText) {
              markUpdate(workInProgress2);
            }
          };
        }
        function cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
          switch (renderState.tailMode) {
            case "hidden": {
              var tailNode = renderState.tail;
              var lastTailNode = null;
              while (tailNode !== null) {
                if (tailNode.alternate !== null) {
                  lastTailNode = tailNode;
                }
                tailNode = tailNode.sibling;
              }
              if (lastTailNode === null) {
                renderState.tail = null;
              } else {
                lastTailNode.sibling = null;
              }
              break;
            }
            case "collapsed": {
              var _tailNode = renderState.tail;
              var _lastTailNode = null;
              while (_tailNode !== null) {
                if (_tailNode.alternate !== null) {
                  _lastTailNode = _tailNode;
                }
                _tailNode = _tailNode.sibling;
              }
              if (_lastTailNode === null) {
                if (!hasRenderedATailFallback && renderState.tail !== null) {
                  renderState.tail.sibling = null;
                } else {
                  renderState.tail = null;
                }
              } else {
                _lastTailNode.sibling = null;
              }
              break;
            }
          }
        }
        function completeWork(current3, workInProgress2, renderExpirationTime2) {
          var newProps = workInProgress2.pendingProps;
          switch (workInProgress2.tag) {
            case IndeterminateComponent:
            case LazyComponent:
            case SimpleMemoComponent:
            case FunctionComponent:
            case ForwardRef2:
            case Fragment35:
            case Mode3:
            case Profiler:
            case ContextConsumer:
            case MemoComponent:
              return null;
            case ClassComponent: {
              var Component10 = workInProgress2.type;
              if (isContextProvider(Component10)) {
                popContext(workInProgress2);
              }
              return null;
            }
            case HostRoot: {
              popHostContainer(workInProgress2);
              popTopLevelContextObject(workInProgress2);
              var fiberRoot = workInProgress2.stateNode;
              if (fiberRoot.pendingContext) {
                fiberRoot.context = fiberRoot.pendingContext;
                fiberRoot.pendingContext = null;
              }
              if (current3 === null || current3.child === null) {
                var wasHydrated = popHydrationState(workInProgress2);
                if (wasHydrated) {
                  markUpdate(workInProgress2);
                }
              }
              updateHostContainer(workInProgress2);
              return null;
            }
            case HostComponent: {
              popHostContext(workInProgress2);
              var rootContainerInstance = getRootHostContainer();
              var type5 = workInProgress2.type;
              if (current3 !== null && workInProgress2.stateNode != null) {
                updateHostComponent$1(current3, workInProgress2, type5, newProps, rootContainerInstance);
                if (current3.ref !== workInProgress2.ref) {
                  markRef$1(workInProgress2);
                }
              } else {
                if (!newProps) {
                  if (!(workInProgress2.stateNode !== null)) {
                    {
                      throw Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                    }
                  }
                  return null;
                }
                var currentHostContext = getHostContext();
                var _wasHydrated = popHydrationState(workInProgress2);
                if (_wasHydrated) {
                  if (prepareToHydrateHostInstance(workInProgress2, rootContainerInstance, currentHostContext)) {
                    markUpdate(workInProgress2);
                  }
                } else {
                  var instance = createInstance(type5, newProps, rootContainerInstance, currentHostContext, workInProgress2);
                  appendAllChildren(instance, workInProgress2, false, false);
                  workInProgress2.stateNode = instance;
                  if (finalizeInitialChildren(instance, type5, newProps, rootContainerInstance)) {
                    markUpdate(workInProgress2);
                  }
                }
                if (workInProgress2.ref !== null) {
                  markRef$1(workInProgress2);
                }
              }
              return null;
            }
            case HostText: {
              var newText = newProps;
              if (current3 && workInProgress2.stateNode != null) {
                var oldText = current3.memoizedProps;
                updateHostText$1(current3, workInProgress2, oldText, newText);
              } else {
                if (typeof newText !== "string") {
                  if (!(workInProgress2.stateNode !== null)) {
                    {
                      throw Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                    }
                  }
                }
                var _rootContainerInstance = getRootHostContainer();
                var _currentHostContext = getHostContext();
                var _wasHydrated2 = popHydrationState(workInProgress2);
                if (_wasHydrated2) {
                  if (prepareToHydrateHostTextInstance(workInProgress2)) {
                    markUpdate(workInProgress2);
                  }
                } else {
                  workInProgress2.stateNode = createTextInstance(newText, _rootContainerInstance, _currentHostContext, workInProgress2);
                }
              }
              return null;
            }
            case SuspenseComponent: {
              popSuspenseContext(workInProgress2);
              var nextState = workInProgress2.memoizedState;
              if ((workInProgress2.effectTag & DidCapture) !== NoEffect) {
                workInProgress2.expirationTime = renderExpirationTime2;
                return workInProgress2;
              }
              var nextDidTimeout = nextState !== null;
              var prevDidTimeout = false;
              if (current3 === null) {
                if (workInProgress2.memoizedProps.fallback !== void 0) {
                  popHydrationState(workInProgress2);
                }
              } else {
                var prevState = current3.memoizedState;
                prevDidTimeout = prevState !== null;
                if (!nextDidTimeout && prevState !== null) {
                  var currentFallbackChild = current3.child.sibling;
                  if (currentFallbackChild !== null) {
                    var first = workInProgress2.firstEffect;
                    if (first !== null) {
                      workInProgress2.firstEffect = currentFallbackChild;
                      currentFallbackChild.nextEffect = first;
                    } else {
                      workInProgress2.firstEffect = workInProgress2.lastEffect = currentFallbackChild;
                      currentFallbackChild.nextEffect = null;
                    }
                    currentFallbackChild.effectTag = Deletion;
                  }
                }
              }
              if (nextDidTimeout && !prevDidTimeout) {
                if ((workInProgress2.mode & BlockingMode) !== NoMode) {
                  var hasInvisibleChildContext = current3 === null && workInProgress2.memoizedProps.unstable_avoidThisFallback !== true;
                  if (hasInvisibleChildContext || hasSuspenseContext(suspenseStackCursor.current, InvisibleParentSuspenseContext)) {
                    renderDidSuspend();
                  } else {
                    renderDidSuspendDelayIfPossible();
                  }
                }
              }
              {
                if (nextDidTimeout || prevDidTimeout) {
                  workInProgress2.effectTag |= Update;
                }
              }
              return null;
            }
            case HostPortal:
              popHostContainer(workInProgress2);
              updateHostContainer(workInProgress2);
              return null;
            case ContextProvider:
              popProvider(workInProgress2);
              return null;
            case IncompleteClassComponent: {
              var _Component = workInProgress2.type;
              if (isContextProvider(_Component)) {
                popContext(workInProgress2);
              }
              return null;
            }
            case SuspenseListComponent: {
              popSuspenseContext(workInProgress2);
              var renderState = workInProgress2.memoizedState;
              if (renderState === null) {
                return null;
              }
              var didSuspendAlready = (workInProgress2.effectTag & DidCapture) !== NoEffect;
              var renderedTail = renderState.rendering;
              if (renderedTail === null) {
                if (!didSuspendAlready) {
                  var cannotBeSuspended = renderHasNotSuspendedYet() && (current3 === null || (current3.effectTag & DidCapture) === NoEffect);
                  if (!cannotBeSuspended) {
                    var row = workInProgress2.child;
                    while (row !== null) {
                      var suspended = findFirstSuspended(row);
                      if (suspended !== null) {
                        didSuspendAlready = true;
                        workInProgress2.effectTag |= DidCapture;
                        cutOffTailIfNeeded(renderState, false);
                        var newThennables = suspended.updateQueue;
                        if (newThennables !== null) {
                          workInProgress2.updateQueue = newThennables;
                          workInProgress2.effectTag |= Update;
                        }
                        if (renderState.lastEffect === null) {
                          workInProgress2.firstEffect = null;
                        }
                        workInProgress2.lastEffect = renderState.lastEffect;
                        resetChildFibers(workInProgress2, renderExpirationTime2);
                        pushSuspenseContext(workInProgress2, setShallowSuspenseContext(suspenseStackCursor.current, ForceSuspenseFallback));
                        return workInProgress2.child;
                      }
                      row = row.sibling;
                    }
                  }
                } else {
                  cutOffTailIfNeeded(renderState, false);
                }
              } else {
                if (!didSuspendAlready) {
                  var _suspended = findFirstSuspended(renderedTail);
                  if (_suspended !== null) {
                    workInProgress2.effectTag |= DidCapture;
                    didSuspendAlready = true;
                    var _newThennables = _suspended.updateQueue;
                    if (_newThennables !== null) {
                      workInProgress2.updateQueue = _newThennables;
                      workInProgress2.effectTag |= Update;
                    }
                    cutOffTailIfNeeded(renderState, true);
                    if (renderState.tail === null && renderState.tailMode === "hidden" && !renderedTail.alternate) {
                      var lastEffect = workInProgress2.lastEffect = renderState.lastEffect;
                      if (lastEffect !== null) {
                        lastEffect.nextEffect = null;
                      }
                      return null;
                    }
                  } else if (
                    // The time it took to render last row is greater than time until
                    // the expiration.
                    now4() * 2 - renderState.renderingStartTime > renderState.tailExpiration && renderExpirationTime2 > Never
                  ) {
                    workInProgress2.effectTag |= DidCapture;
                    didSuspendAlready = true;
                    cutOffTailIfNeeded(renderState, false);
                    var nextPriority = renderExpirationTime2 - 1;
                    workInProgress2.expirationTime = workInProgress2.childExpirationTime = nextPriority;
                    {
                      markSpawnedWork(nextPriority);
                    }
                  }
                }
                if (renderState.isBackwards) {
                  renderedTail.sibling = workInProgress2.child;
                  workInProgress2.child = renderedTail;
                } else {
                  var previousSibling = renderState.last;
                  if (previousSibling !== null) {
                    previousSibling.sibling = renderedTail;
                  } else {
                    workInProgress2.child = renderedTail;
                  }
                  renderState.last = renderedTail;
                }
              }
              if (renderState.tail !== null) {
                if (renderState.tailExpiration === 0) {
                  var TAIL_EXPIRATION_TIMEOUT_MS = 500;
                  renderState.tailExpiration = now4() + TAIL_EXPIRATION_TIMEOUT_MS;
                }
                var next2 = renderState.tail;
                renderState.rendering = next2;
                renderState.tail = next2.sibling;
                renderState.lastEffect = workInProgress2.lastEffect;
                renderState.renderingStartTime = now4();
                next2.sibling = null;
                var suspenseContext = suspenseStackCursor.current;
                if (didSuspendAlready) {
                  suspenseContext = setShallowSuspenseContext(suspenseContext, ForceSuspenseFallback);
                } else {
                  suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
                }
                pushSuspenseContext(workInProgress2, suspenseContext);
                return next2;
              }
              return null;
            }
          }
          {
            {
              throw Error("Unknown unit of work tag (" + workInProgress2.tag + "). This error is likely caused by a bug in React. Please file an issue.");
            }
          }
        }
        function unwindWork(workInProgress2, renderExpirationTime2) {
          switch (workInProgress2.tag) {
            case ClassComponent: {
              var Component10 = workInProgress2.type;
              if (isContextProvider(Component10)) {
                popContext(workInProgress2);
              }
              var effectTag = workInProgress2.effectTag;
              if (effectTag & ShouldCapture) {
                workInProgress2.effectTag = effectTag & ~ShouldCapture | DidCapture;
                return workInProgress2;
              }
              return null;
            }
            case HostRoot: {
              popHostContainer(workInProgress2);
              popTopLevelContextObject(workInProgress2);
              var _effectTag = workInProgress2.effectTag;
              if (!((_effectTag & DidCapture) === NoEffect)) {
                {
                  throw Error("The root failed to unmount after an error. This is likely a bug in React. Please file an issue.");
                }
              }
              workInProgress2.effectTag = _effectTag & ~ShouldCapture | DidCapture;
              return workInProgress2;
            }
            case HostComponent: {
              popHostContext(workInProgress2);
              return null;
            }
            case SuspenseComponent: {
              popSuspenseContext(workInProgress2);
              var _effectTag2 = workInProgress2.effectTag;
              if (_effectTag2 & ShouldCapture) {
                workInProgress2.effectTag = _effectTag2 & ~ShouldCapture | DidCapture;
                return workInProgress2;
              }
              return null;
            }
            case SuspenseListComponent: {
              popSuspenseContext(workInProgress2);
              return null;
            }
            case HostPortal:
              popHostContainer(workInProgress2);
              return null;
            case ContextProvider:
              popProvider(workInProgress2);
              return null;
            default:
              return null;
          }
        }
        function unwindInterruptedWork(interruptedWork) {
          switch (interruptedWork.tag) {
            case ClassComponent: {
              var childContextTypes = interruptedWork.type.childContextTypes;
              if (childContextTypes !== null && childContextTypes !== void 0) {
                popContext(interruptedWork);
              }
              break;
            }
            case HostRoot: {
              popHostContainer(interruptedWork);
              popTopLevelContextObject(interruptedWork);
              break;
            }
            case HostComponent: {
              popHostContext(interruptedWork);
              break;
            }
            case HostPortal:
              popHostContainer(interruptedWork);
              break;
            case SuspenseComponent:
              popSuspenseContext(interruptedWork);
              break;
            case SuspenseListComponent:
              popSuspenseContext(interruptedWork);
              break;
            case ContextProvider:
              popProvider(interruptedWork);
              break;
          }
        }
        function createCapturedValue(value, source) {
          return {
            value,
            source,
            stack: getStackByFiberInDevAndProd(source)
          };
        }
        function logCapturedError(capturedError) {
          var error3 = capturedError.error;
          {
            var componentName = capturedError.componentName, componentStack = capturedError.componentStack, errorBoundaryName = capturedError.errorBoundaryName, errorBoundaryFound = capturedError.errorBoundaryFound, willRetry = capturedError.willRetry;
            if (error3 != null && error3._suppressLogging) {
              if (errorBoundaryFound && willRetry) {
                return;
              }
              console["error"](error3);
            }
            var componentNameMessage = componentName ? "The above error occurred in the <" + componentName + "> component:" : "The above error occurred in one of your React components:";
            var errorBoundaryMessage;
            if (errorBoundaryFound && errorBoundaryName) {
              if (willRetry) {
                errorBoundaryMessage = "React will try to recreate this component tree from scratch " + ("using the error boundary you provided, " + errorBoundaryName + ".");
              } else {
                errorBoundaryMessage = "This error was initially handled by the error boundary " + errorBoundaryName + ".\nRecreating the tree from scratch failed so React will unmount the tree.";
              }
            } else {
              errorBoundaryMessage = "Consider adding an error boundary to your tree to customize error handling behavior.\nVisit https://fb.me/react-error-boundaries to learn more about error boundaries.";
            }
            var combinedMessage = "" + componentNameMessage + componentStack + "\n\n" + ("" + errorBoundaryMessage);
            console["error"](combinedMessage);
          }
        }
        var didWarnAboutUndefinedSnapshotBeforeUpdate = null;
        {
          didWarnAboutUndefinedSnapshotBeforeUpdate = /* @__PURE__ */ new Set();
        }
        var PossiblyWeakSet = typeof WeakSet === "function" ? WeakSet : Set;
        function logError(boundary, errorInfo) {
          var source = errorInfo.source;
          var stack = errorInfo.stack;
          if (stack === null && source !== null) {
            stack = getStackByFiberInDevAndProd(source);
          }
          var capturedError = {
            componentName: source !== null ? getComponentName(source.type) : null,
            componentStack: stack !== null ? stack : "",
            error: errorInfo.value,
            errorBoundary: null,
            errorBoundaryName: null,
            errorBoundaryFound: false,
            willRetry: false
          };
          if (boundary !== null && boundary.tag === ClassComponent) {
            capturedError.errorBoundary = boundary.stateNode;
            capturedError.errorBoundaryName = getComponentName(boundary.type);
            capturedError.errorBoundaryFound = true;
            capturedError.willRetry = true;
          }
          try {
            logCapturedError(capturedError);
          } catch (e3) {
            setTimeout(function() {
              throw e3;
            });
          }
        }
        var callComponentWillUnmountWithTimer = function(current3, instance) {
          startPhaseTimer(current3, "componentWillUnmount");
          instance.props = current3.memoizedProps;
          instance.state = current3.memoizedState;
          instance.componentWillUnmount();
          stopPhaseTimer();
        };
        function safelyCallComponentWillUnmount(current3, instance) {
          {
            invokeGuardedCallback(null, callComponentWillUnmountWithTimer, null, current3, instance);
            if (hasCaughtError()) {
              var unmountError = clearCaughtError();
              captureCommitPhaseError(current3, unmountError);
            }
          }
        }
        function safelyDetachRef(current3) {
          var ref3 = current3.ref;
          if (ref3 !== null) {
            if (typeof ref3 === "function") {
              {
                invokeGuardedCallback(null, ref3, null, null);
                if (hasCaughtError()) {
                  var refError = clearCaughtError();
                  captureCommitPhaseError(current3, refError);
                }
              }
            } else {
              ref3.current = null;
            }
          }
        }
        function safelyCallDestroy(current3, destroy2) {
          {
            invokeGuardedCallback(null, destroy2, null);
            if (hasCaughtError()) {
              var error3 = clearCaughtError();
              captureCommitPhaseError(current3, error3);
            }
          }
        }
        function commitBeforeMutationLifeCycles(current3, finishedWork) {
          switch (finishedWork.tag) {
            case FunctionComponent:
            case ForwardRef2:
            case SimpleMemoComponent:
            case Block3: {
              return;
            }
            case ClassComponent: {
              if (finishedWork.effectTag & Snapshot) {
                if (current3 !== null) {
                  var prevProps = current3.memoizedProps;
                  var prevState = current3.memoizedState;
                  startPhaseTimer(finishedWork, "getSnapshotBeforeUpdate");
                  var instance = finishedWork.stateNode;
                  {
                    if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                      if (instance.props !== finishedWork.memoizedProps) {
                        error2("Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentName(finishedWork.type) || "instance");
                      }
                      if (instance.state !== finishedWork.memoizedState) {
                        error2("Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentName(finishedWork.type) || "instance");
                      }
                    }
                  }
                  var snapshot = instance.getSnapshotBeforeUpdate(finishedWork.elementType === finishedWork.type ? prevProps : resolveDefaultProps(finishedWork.type, prevProps), prevState);
                  {
                    var didWarnSet = didWarnAboutUndefinedSnapshotBeforeUpdate;
                    if (snapshot === void 0 && !didWarnSet.has(finishedWork.type)) {
                      didWarnSet.add(finishedWork.type);
                      error2("%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.", getComponentName(finishedWork.type));
                    }
                  }
                  instance.__reactInternalSnapshotBeforeUpdate = snapshot;
                  stopPhaseTimer();
                }
              }
              return;
            }
            case HostRoot:
            case HostComponent:
            case HostText:
            case HostPortal:
            case IncompleteClassComponent:
              return;
          }
          {
            {
              throw Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
            }
          }
        }
        function commitHookEffectListUnmount(tag, finishedWork) {
          var updateQueue = finishedWork.updateQueue;
          var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;
          if (lastEffect !== null) {
            var firstEffect = lastEffect.next;
            var effect = firstEffect;
            do {
              if ((effect.tag & tag) === tag) {
                var destroy2 = effect.destroy;
                effect.destroy = void 0;
                if (destroy2 !== void 0) {
                  destroy2();
                }
              }
              effect = effect.next;
            } while (effect !== firstEffect);
          }
        }
        function commitHookEffectListMount(tag, finishedWork) {
          var updateQueue = finishedWork.updateQueue;
          var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;
          if (lastEffect !== null) {
            var firstEffect = lastEffect.next;
            var effect = firstEffect;
            do {
              if ((effect.tag & tag) === tag) {
                var create = effect.create;
                effect.destroy = create();
                {
                  var destroy2 = effect.destroy;
                  if (destroy2 !== void 0 && typeof destroy2 !== "function") {
                    var addendum = void 0;
                    if (destroy2 === null) {
                      addendum = " You returned null. If your effect does not require clean up, return undefined (or nothing).";
                    } else if (typeof destroy2.then === "function") {
                      addendum = "\n\nIt looks like you wrote useEffect(async () => ...) or returned a Promise. Instead, write the async function inside your effect and call it immediately:\n\nuseEffect(() => {\n  async function fetchData() {\n    // You can await here\n    const response = await MyAPI.getData(someId);\n    // ...\n  }\n  fetchData();\n}, [someId]); // Or [] if effect doesn't need props or state\n\nLearn more about data fetching with Hooks: https://fb.me/react-hooks-data-fetching";
                    } else {
                      addendum = " You returned: " + destroy2;
                    }
                    error2("An effect function must not return anything besides a function, which is used for clean-up.%s%s", addendum, getStackByFiberInDevAndProd(finishedWork));
                  }
                }
              }
              effect = effect.next;
            } while (effect !== firstEffect);
          }
        }
        function commitPassiveHookEffects(finishedWork) {
          if ((finishedWork.effectTag & Passive) !== NoEffect) {
            switch (finishedWork.tag) {
              case FunctionComponent:
              case ForwardRef2:
              case SimpleMemoComponent:
              case Block3: {
                commitHookEffectListUnmount(Passive$1 | HasEffect, finishedWork);
                commitHookEffectListMount(Passive$1 | HasEffect, finishedWork);
                break;
              }
            }
          }
        }
        function commitLifeCycles(finishedRoot, current3, finishedWork, committedExpirationTime) {
          switch (finishedWork.tag) {
            case FunctionComponent:
            case ForwardRef2:
            case SimpleMemoComponent:
            case Block3: {
              commitHookEffectListMount(Layout | HasEffect, finishedWork);
              return;
            }
            case ClassComponent: {
              var instance = finishedWork.stateNode;
              if (finishedWork.effectTag & Update) {
                if (current3 === null) {
                  startPhaseTimer(finishedWork, "componentDidMount");
                  {
                    if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                      if (instance.props !== finishedWork.memoizedProps) {
                        error2("Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentName(finishedWork.type) || "instance");
                      }
                      if (instance.state !== finishedWork.memoizedState) {
                        error2("Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentName(finishedWork.type) || "instance");
                      }
                    }
                  }
                  instance.componentDidMount();
                  stopPhaseTimer();
                } else {
                  var prevProps = finishedWork.elementType === finishedWork.type ? current3.memoizedProps : resolveDefaultProps(finishedWork.type, current3.memoizedProps);
                  var prevState = current3.memoizedState;
                  startPhaseTimer(finishedWork, "componentDidUpdate");
                  {
                    if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                      if (instance.props !== finishedWork.memoizedProps) {
                        error2("Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentName(finishedWork.type) || "instance");
                      }
                      if (instance.state !== finishedWork.memoizedState) {
                        error2("Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentName(finishedWork.type) || "instance");
                      }
                    }
                  }
                  instance.componentDidUpdate(prevProps, prevState, instance.__reactInternalSnapshotBeforeUpdate);
                  stopPhaseTimer();
                }
              }
              var updateQueue = finishedWork.updateQueue;
              if (updateQueue !== null) {
                {
                  if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                    if (instance.props !== finishedWork.memoizedProps) {
                      error2("Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentName(finishedWork.type) || "instance");
                    }
                    if (instance.state !== finishedWork.memoizedState) {
                      error2("Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentName(finishedWork.type) || "instance");
                    }
                  }
                }
                commitUpdateQueue(finishedWork, updateQueue, instance);
              }
              return;
            }
            case HostRoot: {
              var _updateQueue = finishedWork.updateQueue;
              if (_updateQueue !== null) {
                var _instance = null;
                if (finishedWork.child !== null) {
                  switch (finishedWork.child.tag) {
                    case HostComponent:
                      _instance = getPublicInstance(finishedWork.child.stateNode);
                      break;
                    case ClassComponent:
                      _instance = finishedWork.child.stateNode;
                      break;
                  }
                }
                commitUpdateQueue(finishedWork, _updateQueue, _instance);
              }
              return;
            }
            case HostComponent: {
              var _instance2 = finishedWork.stateNode;
              if (current3 === null && finishedWork.effectTag & Update) {
                var type5 = finishedWork.type;
                var props = finishedWork.memoizedProps;
                commitMount(_instance2, type5, props);
              }
              return;
            }
            case HostText: {
              return;
            }
            case HostPortal: {
              return;
            }
            case Profiler: {
              {
                var onRender = finishedWork.memoizedProps.onRender;
                if (typeof onRender === "function") {
                  {
                    onRender(finishedWork.memoizedProps.id, current3 === null ? "mount" : "update", finishedWork.actualDuration, finishedWork.treeBaseDuration, finishedWork.actualStartTime, getCommitTime(), finishedRoot.memoizedInteractions);
                  }
                }
              }
              return;
            }
            case SuspenseComponent: {
              commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
              return;
            }
            case SuspenseListComponent:
            case IncompleteClassComponent:
            case FundamentalComponent:
            case ScopeComponent:
              return;
          }
          {
            {
              throw Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
            }
          }
        }
        function hideOrUnhideAllChildren(finishedWork, isHidden) {
          {
            var node2 = finishedWork;
            while (true) {
              if (node2.tag === HostComponent) {
                var instance = node2.stateNode;
                if (isHidden) {
                  hideInstance(instance);
                } else {
                  unhideInstance(node2.stateNode, node2.memoizedProps);
                }
              } else if (node2.tag === HostText) {
                var _instance3 = node2.stateNode;
                if (isHidden) {
                  hideTextInstance(_instance3);
                } else {
                  unhideTextInstance(_instance3, node2.memoizedProps);
                }
              } else if (node2.tag === SuspenseComponent && node2.memoizedState !== null && node2.memoizedState.dehydrated === null) {
                var fallbackChildFragment = node2.child.sibling;
                fallbackChildFragment.return = node2;
                node2 = fallbackChildFragment;
                continue;
              } else if (node2.child !== null) {
                node2.child.return = node2;
                node2 = node2.child;
                continue;
              }
              if (node2 === finishedWork) {
                return;
              }
              while (node2.sibling === null) {
                if (node2.return === null || node2.return === finishedWork) {
                  return;
                }
                node2 = node2.return;
              }
              node2.sibling.return = node2.return;
              node2 = node2.sibling;
            }
          }
        }
        function commitAttachRef(finishedWork) {
          var ref3 = finishedWork.ref;
          if (ref3 !== null) {
            var instance = finishedWork.stateNode;
            var instanceToUse;
            switch (finishedWork.tag) {
              case HostComponent:
                instanceToUse = getPublicInstance(instance);
                break;
              default:
                instanceToUse = instance;
            }
            if (typeof ref3 === "function") {
              ref3(instanceToUse);
            } else {
              {
                if (!ref3.hasOwnProperty("current")) {
                  error2("Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().%s", getComponentName(finishedWork.type), getStackByFiberInDevAndProd(finishedWork));
                }
              }
              ref3.current = instanceToUse;
            }
          }
        }
        function commitDetachRef(current3) {
          var currentRef = current3.ref;
          if (currentRef !== null) {
            if (typeof currentRef === "function") {
              currentRef(null);
            } else {
              currentRef.current = null;
            }
          }
        }
        function commitUnmount(finishedRoot, current3, renderPriorityLevel) {
          onCommitUnmount(current3);
          switch (current3.tag) {
            case FunctionComponent:
            case ForwardRef2:
            case MemoComponent:
            case SimpleMemoComponent:
            case Block3: {
              var updateQueue = current3.updateQueue;
              if (updateQueue !== null) {
                var lastEffect = updateQueue.lastEffect;
                if (lastEffect !== null) {
                  var firstEffect = lastEffect.next;
                  {
                    var priorityLevel = renderPriorityLevel > NormalPriority ? NormalPriority : renderPriorityLevel;
                    runWithPriority$1(priorityLevel, function() {
                      var effect = firstEffect;
                      do {
                        var _destroy = effect.destroy;
                        if (_destroy !== void 0) {
                          safelyCallDestroy(current3, _destroy);
                        }
                        effect = effect.next;
                      } while (effect !== firstEffect);
                    });
                  }
                }
              }
              return;
            }
            case ClassComponent: {
              safelyDetachRef(current3);
              var instance = current3.stateNode;
              if (typeof instance.componentWillUnmount === "function") {
                safelyCallComponentWillUnmount(current3, instance);
              }
              return;
            }
            case HostComponent: {
              safelyDetachRef(current3);
              return;
            }
            case HostPortal: {
              {
                unmountHostComponents(finishedRoot, current3, renderPriorityLevel);
              }
              return;
            }
            case FundamentalComponent: {
              return;
            }
            case DehydratedFragment: {
              return;
            }
            case ScopeComponent: {
              return;
            }
          }
        }
        function commitNestedUnmounts(finishedRoot, root3, renderPriorityLevel) {
          var node2 = root3;
          while (true) {
            commitUnmount(finishedRoot, node2, renderPriorityLevel);
            if (node2.child !== null && // If we use mutation we drill down into portals using commitUnmount above.
            // If we don't use mutation we drill down into portals here instead.
            node2.tag !== HostPortal) {
              node2.child.return = node2;
              node2 = node2.child;
              continue;
            }
            if (node2 === root3) {
              return;
            }
            while (node2.sibling === null) {
              if (node2.return === null || node2.return === root3) {
                return;
              }
              node2 = node2.return;
            }
            node2.sibling.return = node2.return;
            node2 = node2.sibling;
          }
        }
        function detachFiber(current3) {
          var alternate = current3.alternate;
          current3.return = null;
          current3.child = null;
          current3.memoizedState = null;
          current3.updateQueue = null;
          current3.dependencies = null;
          current3.alternate = null;
          current3.firstEffect = null;
          current3.lastEffect = null;
          current3.pendingProps = null;
          current3.memoizedProps = null;
          current3.stateNode = null;
          if (alternate !== null) {
            detachFiber(alternate);
          }
        }
        function getHostParentFiber(fiber) {
          var parent2 = fiber.return;
          while (parent2 !== null) {
            if (isHostParent(parent2)) {
              return parent2;
            }
            parent2 = parent2.return;
          }
          {
            {
              throw Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
            }
          }
        }
        function isHostParent(fiber) {
          return fiber.tag === HostComponent || fiber.tag === HostRoot || fiber.tag === HostPortal;
        }
        function getHostSibling(fiber) {
          var node2 = fiber;
          siblings: while (true) {
            while (node2.sibling === null) {
              if (node2.return === null || isHostParent(node2.return)) {
                return null;
              }
              node2 = node2.return;
            }
            node2.sibling.return = node2.return;
            node2 = node2.sibling;
            while (node2.tag !== HostComponent && node2.tag !== HostText && node2.tag !== DehydratedFragment) {
              if (node2.effectTag & Placement) {
                continue siblings;
              }
              if (node2.child === null || node2.tag === HostPortal) {
                continue siblings;
              } else {
                node2.child.return = node2;
                node2 = node2.child;
              }
            }
            if (!(node2.effectTag & Placement)) {
              return node2.stateNode;
            }
          }
        }
        function commitPlacement(finishedWork) {
          var parentFiber = getHostParentFiber(finishedWork);
          var parent2;
          var isContainer;
          var parentStateNode = parentFiber.stateNode;
          switch (parentFiber.tag) {
            case HostComponent:
              parent2 = parentStateNode;
              isContainer = false;
              break;
            case HostRoot:
              parent2 = parentStateNode.containerInfo;
              isContainer = true;
              break;
            case HostPortal:
              parent2 = parentStateNode.containerInfo;
              isContainer = true;
              break;
            case FundamentalComponent:
            // eslint-disable-next-line-no-fallthrough
            default: {
              {
                throw Error("Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.");
              }
            }
          }
          if (parentFiber.effectTag & ContentReset) {
            resetTextContent(parent2);
            parentFiber.effectTag &= ~ContentReset;
          }
          var before = getHostSibling(finishedWork);
          if (isContainer) {
            insertOrAppendPlacementNodeIntoContainer(finishedWork, before, parent2);
          } else {
            insertOrAppendPlacementNode(finishedWork, before, parent2);
          }
        }
        function insertOrAppendPlacementNodeIntoContainer(node2, before, parent2) {
          var tag = node2.tag;
          var isHost = tag === HostComponent || tag === HostText;
          if (isHost || enableFundamentalAPI) {
            var stateNode = isHost ? node2.stateNode : node2.stateNode.instance;
            if (before) {
              insertInContainerBefore(parent2, stateNode, before);
            } else {
              appendChildToContainer(parent2, stateNode);
            }
          } else if (tag === HostPortal) ;
          else {
            var child = node2.child;
            if (child !== null) {
              insertOrAppendPlacementNodeIntoContainer(child, before, parent2);
              var sibling2 = child.sibling;
              while (sibling2 !== null) {
                insertOrAppendPlacementNodeIntoContainer(sibling2, before, parent2);
                sibling2 = sibling2.sibling;
              }
            }
          }
        }
        function insertOrAppendPlacementNode(node2, before, parent2) {
          var tag = node2.tag;
          var isHost = tag === HostComponent || tag === HostText;
          if (isHost || enableFundamentalAPI) {
            var stateNode = isHost ? node2.stateNode : node2.stateNode.instance;
            if (before) {
              insertBefore(parent2, stateNode, before);
            } else {
              appendChild(parent2, stateNode);
            }
          } else if (tag === HostPortal) ;
          else {
            var child = node2.child;
            if (child !== null) {
              insertOrAppendPlacementNode(child, before, parent2);
              var sibling2 = child.sibling;
              while (sibling2 !== null) {
                insertOrAppendPlacementNode(sibling2, before, parent2);
                sibling2 = sibling2.sibling;
              }
            }
          }
        }
        function unmountHostComponents(finishedRoot, current3, renderPriorityLevel) {
          var node2 = current3;
          var currentParentIsValid = false;
          var currentParent;
          var currentParentIsContainer;
          while (true) {
            if (!currentParentIsValid) {
              var parent2 = node2.return;
              findParent: while (true) {
                if (!(parent2 !== null)) {
                  {
                    throw Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
                  }
                }
                var parentStateNode = parent2.stateNode;
                switch (parent2.tag) {
                  case HostComponent:
                    currentParent = parentStateNode;
                    currentParentIsContainer = false;
                    break findParent;
                  case HostRoot:
                    currentParent = parentStateNode.containerInfo;
                    currentParentIsContainer = true;
                    break findParent;
                  case HostPortal:
                    currentParent = parentStateNode.containerInfo;
                    currentParentIsContainer = true;
                    break findParent;
                }
                parent2 = parent2.return;
              }
              currentParentIsValid = true;
            }
            if (node2.tag === HostComponent || node2.tag === HostText) {
              commitNestedUnmounts(finishedRoot, node2, renderPriorityLevel);
              if (currentParentIsContainer) {
                removeChildFromContainer(currentParent, node2.stateNode);
              } else {
                removeChild(currentParent, node2.stateNode);
              }
            } else if (node2.tag === HostPortal) {
              if (node2.child !== null) {
                currentParent = node2.stateNode.containerInfo;
                currentParentIsContainer = true;
                node2.child.return = node2;
                node2 = node2.child;
                continue;
              }
            } else {
              commitUnmount(finishedRoot, node2, renderPriorityLevel);
              if (node2.child !== null) {
                node2.child.return = node2;
                node2 = node2.child;
                continue;
              }
            }
            if (node2 === current3) {
              return;
            }
            while (node2.sibling === null) {
              if (node2.return === null || node2.return === current3) {
                return;
              }
              node2 = node2.return;
              if (node2.tag === HostPortal) {
                currentParentIsValid = false;
              }
            }
            node2.sibling.return = node2.return;
            node2 = node2.sibling;
          }
        }
        function commitDeletion(finishedRoot, current3, renderPriorityLevel) {
          {
            unmountHostComponents(finishedRoot, current3, renderPriorityLevel);
          }
          detachFiber(current3);
        }
        function commitWork(current3, finishedWork) {
          switch (finishedWork.tag) {
            case FunctionComponent:
            case ForwardRef2:
            case MemoComponent:
            case SimpleMemoComponent:
            case Block3: {
              commitHookEffectListUnmount(Layout | HasEffect, finishedWork);
              return;
            }
            case ClassComponent: {
              return;
            }
            case HostComponent: {
              var instance = finishedWork.stateNode;
              if (instance != null) {
                var newProps = finishedWork.memoizedProps;
                var oldProps = current3 !== null ? current3.memoizedProps : newProps;
                var type5 = finishedWork.type;
                var updatePayload = finishedWork.updateQueue;
                finishedWork.updateQueue = null;
                if (updatePayload !== null) {
                  commitUpdate(instance, updatePayload, type5, oldProps, newProps);
                }
              }
              return;
            }
            case HostText: {
              if (!(finishedWork.stateNode !== null)) {
                {
                  throw Error("This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.");
                }
              }
              var textInstance = finishedWork.stateNode;
              var newText = finishedWork.memoizedProps;
              var oldText = current3 !== null ? current3.memoizedProps : newText;
              commitTextUpdate(textInstance, oldText, newText);
              return;
            }
            case HostRoot: {
              {
                var _root = finishedWork.stateNode;
                if (_root.hydrate) {
                  _root.hydrate = false;
                  commitHydratedContainer(_root.containerInfo);
                }
              }
              return;
            }
            case Profiler: {
              return;
            }
            case SuspenseComponent: {
              commitSuspenseComponent(finishedWork);
              attachSuspenseRetryListeners(finishedWork);
              return;
            }
            case SuspenseListComponent: {
              attachSuspenseRetryListeners(finishedWork);
              return;
            }
            case IncompleteClassComponent: {
              return;
            }
          }
          {
            {
              throw Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
            }
          }
        }
        function commitSuspenseComponent(finishedWork) {
          var newState = finishedWork.memoizedState;
          var newDidTimeout;
          var primaryChildParent = finishedWork;
          if (newState === null) {
            newDidTimeout = false;
          } else {
            newDidTimeout = true;
            primaryChildParent = finishedWork.child;
            markCommitTimeOfFallback();
          }
          if (primaryChildParent !== null) {
            hideOrUnhideAllChildren(primaryChildParent, newDidTimeout);
          }
        }
        function commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
          var newState = finishedWork.memoizedState;
          if (newState === null) {
            var current3 = finishedWork.alternate;
            if (current3 !== null) {
              var prevState = current3.memoizedState;
              if (prevState !== null) {
                var suspenseInstance = prevState.dehydrated;
                if (suspenseInstance !== null) {
                  commitHydratedSuspenseInstance(suspenseInstance);
                }
              }
            }
          }
        }
        function attachSuspenseRetryListeners(finishedWork) {
          var thenables = finishedWork.updateQueue;
          if (thenables !== null) {
            finishedWork.updateQueue = null;
            var retryCache = finishedWork.stateNode;
            if (retryCache === null) {
              retryCache = finishedWork.stateNode = new PossiblyWeakSet();
            }
            thenables.forEach(function(thenable) {
              var retry = resolveRetryThenable.bind(null, finishedWork, thenable);
              if (!retryCache.has(thenable)) {
                {
                  if (thenable.__reactDoNotTraceInteractions !== true) {
                    retry = tracing.unstable_wrap(retry);
                  }
                }
                retryCache.add(thenable);
                thenable.then(retry, retry);
              }
            });
          }
        }
        function commitResetTextContent(current3) {
          resetTextContent(current3.stateNode);
        }
        var PossiblyWeakMap$1 = typeof WeakMap === "function" ? WeakMap : Map;
        function createRootErrorUpdate(fiber, errorInfo, expirationTime) {
          var update = createUpdate(expirationTime, null);
          update.tag = CaptureUpdate;
          update.payload = {
            element: null
          };
          var error3 = errorInfo.value;
          update.callback = function() {
            onUncaughtError(error3);
            logError(fiber, errorInfo);
          };
          return update;
        }
        function createClassErrorUpdate(fiber, errorInfo, expirationTime) {
          var update = createUpdate(expirationTime, null);
          update.tag = CaptureUpdate;
          var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
          if (typeof getDerivedStateFromError === "function") {
            var error$1 = errorInfo.value;
            update.payload = function() {
              logError(fiber, errorInfo);
              return getDerivedStateFromError(error$1);
            };
          }
          var inst = fiber.stateNode;
          if (inst !== null && typeof inst.componentDidCatch === "function") {
            update.callback = function callback() {
              {
                markFailedErrorBoundaryForHotReloading(fiber);
              }
              if (typeof getDerivedStateFromError !== "function") {
                markLegacyErrorBoundaryAsFailed(this);
                logError(fiber, errorInfo);
              }
              var error$12 = errorInfo.value;
              var stack = errorInfo.stack;
              this.componentDidCatch(error$12, {
                componentStack: stack !== null ? stack : ""
              });
              {
                if (typeof getDerivedStateFromError !== "function") {
                  if (fiber.expirationTime !== Sync) {
                    error2("%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.", getComponentName(fiber.type) || "Unknown");
                  }
                }
              }
            };
          } else {
            update.callback = function() {
              markFailedErrorBoundaryForHotReloading(fiber);
            };
          }
          return update;
        }
        function attachPingListener(root3, renderExpirationTime2, thenable) {
          var pingCache = root3.pingCache;
          var threadIDs;
          if (pingCache === null) {
            pingCache = root3.pingCache = new PossiblyWeakMap$1();
            threadIDs = /* @__PURE__ */ new Set();
            pingCache.set(thenable, threadIDs);
          } else {
            threadIDs = pingCache.get(thenable);
            if (threadIDs === void 0) {
              threadIDs = /* @__PURE__ */ new Set();
              pingCache.set(thenable, threadIDs);
            }
          }
          if (!threadIDs.has(renderExpirationTime2)) {
            threadIDs.add(renderExpirationTime2);
            var ping = pingSuspendedRoot.bind(null, root3, thenable, renderExpirationTime2);
            thenable.then(ping, ping);
          }
        }
        function throwException(root3, returnFiber, sourceFiber, value, renderExpirationTime2) {
          sourceFiber.effectTag |= Incomplete;
          sourceFiber.firstEffect = sourceFiber.lastEffect = null;
          if (value !== null && typeof value === "object" && typeof value.then === "function") {
            var thenable = value;
            if ((sourceFiber.mode & BlockingMode) === NoMode) {
              var currentSource = sourceFiber.alternate;
              if (currentSource) {
                sourceFiber.updateQueue = currentSource.updateQueue;
                sourceFiber.memoizedState = currentSource.memoizedState;
                sourceFiber.expirationTime = currentSource.expirationTime;
              } else {
                sourceFiber.updateQueue = null;
                sourceFiber.memoizedState = null;
              }
            }
            var hasInvisibleParentBoundary = hasSuspenseContext(suspenseStackCursor.current, InvisibleParentSuspenseContext);
            var _workInProgress = returnFiber;
            do {
              if (_workInProgress.tag === SuspenseComponent && shouldCaptureSuspense(_workInProgress, hasInvisibleParentBoundary)) {
                var thenables = _workInProgress.updateQueue;
                if (thenables === null) {
                  var updateQueue = /* @__PURE__ */ new Set();
                  updateQueue.add(thenable);
                  _workInProgress.updateQueue = updateQueue;
                } else {
                  thenables.add(thenable);
                }
                if ((_workInProgress.mode & BlockingMode) === NoMode) {
                  _workInProgress.effectTag |= DidCapture;
                  sourceFiber.effectTag &= ~(LifecycleEffectMask | Incomplete);
                  if (sourceFiber.tag === ClassComponent) {
                    var currentSourceFiber = sourceFiber.alternate;
                    if (currentSourceFiber === null) {
                      sourceFiber.tag = IncompleteClassComponent;
                    } else {
                      var update = createUpdate(Sync, null);
                      update.tag = ForceUpdate;
                      enqueueUpdate(sourceFiber, update);
                    }
                  }
                  sourceFiber.expirationTime = Sync;
                  return;
                }
                attachPingListener(root3, renderExpirationTime2, thenable);
                _workInProgress.effectTag |= ShouldCapture;
                _workInProgress.expirationTime = renderExpirationTime2;
                return;
              }
              _workInProgress = _workInProgress.return;
            } while (_workInProgress !== null);
            value = new Error((getComponentName(sourceFiber.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display." + getStackByFiberInDevAndProd(sourceFiber));
          }
          renderDidError();
          value = createCapturedValue(value, sourceFiber);
          var workInProgress2 = returnFiber;
          do {
            switch (workInProgress2.tag) {
              case HostRoot: {
                var _errorInfo = value;
                workInProgress2.effectTag |= ShouldCapture;
                workInProgress2.expirationTime = renderExpirationTime2;
                var _update = createRootErrorUpdate(workInProgress2, _errorInfo, renderExpirationTime2);
                enqueueCapturedUpdate(workInProgress2, _update);
                return;
              }
              case ClassComponent:
                var errorInfo = value;
                var ctor = workInProgress2.type;
                var instance = workInProgress2.stateNode;
                if ((workInProgress2.effectTag & DidCapture) === NoEffect && (typeof ctor.getDerivedStateFromError === "function" || instance !== null && typeof instance.componentDidCatch === "function" && !isAlreadyFailedLegacyErrorBoundary(instance))) {
                  workInProgress2.effectTag |= ShouldCapture;
                  workInProgress2.expirationTime = renderExpirationTime2;
                  var _update2 = createClassErrorUpdate(workInProgress2, errorInfo, renderExpirationTime2);
                  enqueueCapturedUpdate(workInProgress2, _update2);
                  return;
                }
                break;
            }
            workInProgress2 = workInProgress2.return;
          } while (workInProgress2 !== null);
        }
        var ceil = Math.ceil;
        var ReactCurrentDispatcher$1 = ReactSharedInternals.ReactCurrentDispatcher, ReactCurrentOwner$2 = ReactSharedInternals.ReactCurrentOwner, IsSomeRendererActing = ReactSharedInternals.IsSomeRendererActing;
        var NoContext = (
          /*                    */
          0
        );
        var BatchedContext = (
          /*               */
          1
        );
        var EventContext = (
          /*                 */
          2
        );
        var DiscreteEventContext = (
          /*         */
          4
        );
        var LegacyUnbatchedContext = (
          /*       */
          8
        );
        var RenderContext = (
          /*                */
          16
        );
        var CommitContext = (
          /*                */
          32
        );
        var RootIncomplete = 0;
        var RootFatalErrored = 1;
        var RootErrored = 2;
        var RootSuspended = 3;
        var RootSuspendedWithDelay = 4;
        var RootCompleted = 5;
        var executionContext = NoContext;
        var workInProgressRoot = null;
        var workInProgress = null;
        var renderExpirationTime$1 = NoWork;
        var workInProgressRootExitStatus = RootIncomplete;
        var workInProgressRootFatalError = null;
        var workInProgressRootLatestProcessedExpirationTime = Sync;
        var workInProgressRootLatestSuspenseTimeout = Sync;
        var workInProgressRootCanSuspendUsingConfig = null;
        var workInProgressRootNextUnprocessedUpdateTime = NoWork;
        var workInProgressRootHasPendingPing = false;
        var globalMostRecentFallbackTime = 0;
        var FALLBACK_THROTTLE_MS = 500;
        var nextEffect = null;
        var hasUncaughtError = false;
        var firstUncaughtError = null;
        var legacyErrorBoundariesThatAlreadyFailed = null;
        var rootDoesHavePassiveEffects = false;
        var rootWithPendingPassiveEffects = null;
        var pendingPassiveEffectsRenderPriority = NoPriority;
        var pendingPassiveEffectsExpirationTime = NoWork;
        var rootsWithPendingDiscreteUpdates = null;
        var NESTED_UPDATE_LIMIT = 50;
        var nestedUpdateCount = 0;
        var rootWithNestedUpdates = null;
        var NESTED_PASSIVE_UPDATE_LIMIT = 50;
        var nestedPassiveUpdateCount = 0;
        var interruptedBy = null;
        var spawnedWorkDuringRender = null;
        var currentEventTime = NoWork;
        function requestCurrentTimeForUpdate() {
          if ((executionContext & (RenderContext | CommitContext)) !== NoContext) {
            return msToExpirationTime(now4());
          }
          if (currentEventTime !== NoWork) {
            return currentEventTime;
          }
          currentEventTime = msToExpirationTime(now4());
          return currentEventTime;
        }
        function getCurrentTime() {
          return msToExpirationTime(now4());
        }
        function computeExpirationForFiber(currentTime, fiber, suspenseConfig) {
          var mode = fiber.mode;
          if ((mode & BlockingMode) === NoMode) {
            return Sync;
          }
          var priorityLevel = getCurrentPriorityLevel();
          if ((mode & ConcurrentMode) === NoMode) {
            return priorityLevel === ImmediatePriority ? Sync : Batched;
          }
          if ((executionContext & RenderContext) !== NoContext) {
            return renderExpirationTime$1;
          }
          var expirationTime;
          if (suspenseConfig !== null) {
            expirationTime = computeSuspenseExpiration(currentTime, suspenseConfig.timeoutMs | 0 || LOW_PRIORITY_EXPIRATION);
          } else {
            switch (priorityLevel) {
              case ImmediatePriority:
                expirationTime = Sync;
                break;
              case UserBlockingPriority$1:
                expirationTime = computeInteractiveExpiration(currentTime);
                break;
              case NormalPriority:
              case LowPriority:
                expirationTime = computeAsyncExpiration(currentTime);
                break;
              case IdlePriority:
                expirationTime = Idle;
                break;
              default: {
                {
                  throw Error("Expected a valid priority level");
                }
              }
            }
          }
          if (workInProgressRoot !== null && expirationTime === renderExpirationTime$1) {
            expirationTime -= 1;
          }
          return expirationTime;
        }
        function scheduleUpdateOnFiber(fiber, expirationTime) {
          checkForNestedUpdates();
          warnAboutRenderPhaseUpdatesInDEV(fiber);
          var root3 = markUpdateTimeFromFiberToRoot(fiber, expirationTime);
          if (root3 === null) {
            warnAboutUpdateOnUnmountedFiberInDEV(fiber);
            return;
          }
          checkForInterruption(fiber, expirationTime);
          recordScheduleUpdate();
          var priorityLevel = getCurrentPriorityLevel();
          if (expirationTime === Sync) {
            if (
              // Check if we're inside unbatchedUpdates
              (executionContext & LegacyUnbatchedContext) !== NoContext && // Check if we're not already rendering
              (executionContext & (RenderContext | CommitContext)) === NoContext
            ) {
              schedulePendingInteractions(root3, expirationTime);
              performSyncWorkOnRoot(root3);
            } else {
              ensureRootIsScheduled(root3);
              schedulePendingInteractions(root3, expirationTime);
              if (executionContext === NoContext) {
                flushSyncCallbackQueue();
              }
            }
          } else {
            ensureRootIsScheduled(root3);
            schedulePendingInteractions(root3, expirationTime);
          }
          if ((executionContext & DiscreteEventContext) !== NoContext && // Only updates at user-blocking priority or greater are considered
          // discrete, even inside a discrete event.
          (priorityLevel === UserBlockingPriority$1 || priorityLevel === ImmediatePriority)) {
            if (rootsWithPendingDiscreteUpdates === null) {
              rootsWithPendingDiscreteUpdates = /* @__PURE__ */ new Map([[root3, expirationTime]]);
            } else {
              var lastDiscreteTime = rootsWithPendingDiscreteUpdates.get(root3);
              if (lastDiscreteTime === void 0 || lastDiscreteTime > expirationTime) {
                rootsWithPendingDiscreteUpdates.set(root3, expirationTime);
              }
            }
          }
        }
        var scheduleWork = scheduleUpdateOnFiber;
        function markUpdateTimeFromFiberToRoot(fiber, expirationTime) {
          if (fiber.expirationTime < expirationTime) {
            fiber.expirationTime = expirationTime;
          }
          var alternate = fiber.alternate;
          if (alternate !== null && alternate.expirationTime < expirationTime) {
            alternate.expirationTime = expirationTime;
          }
          var node2 = fiber.return;
          var root3 = null;
          if (node2 === null && fiber.tag === HostRoot) {
            root3 = fiber.stateNode;
          } else {
            while (node2 !== null) {
              alternate = node2.alternate;
              if (node2.childExpirationTime < expirationTime) {
                node2.childExpirationTime = expirationTime;
                if (alternate !== null && alternate.childExpirationTime < expirationTime) {
                  alternate.childExpirationTime = expirationTime;
                }
              } else if (alternate !== null && alternate.childExpirationTime < expirationTime) {
                alternate.childExpirationTime = expirationTime;
              }
              if (node2.return === null && node2.tag === HostRoot) {
                root3 = node2.stateNode;
                break;
              }
              node2 = node2.return;
            }
          }
          if (root3 !== null) {
            if (workInProgressRoot === root3) {
              markUnprocessedUpdateTime(expirationTime);
              if (workInProgressRootExitStatus === RootSuspendedWithDelay) {
                markRootSuspendedAtTime(root3, renderExpirationTime$1);
              }
            }
            markRootUpdatedAtTime(root3, expirationTime);
          }
          return root3;
        }
        function getNextRootExpirationTimeToWorkOn(root3) {
          var lastExpiredTime = root3.lastExpiredTime;
          if (lastExpiredTime !== NoWork) {
            return lastExpiredTime;
          }
          var firstPendingTime = root3.firstPendingTime;
          if (!isRootSuspendedAtTime(root3, firstPendingTime)) {
            return firstPendingTime;
          }
          var lastPingedTime = root3.lastPingedTime;
          var nextKnownPendingLevel = root3.nextKnownPendingLevel;
          var nextLevel = lastPingedTime > nextKnownPendingLevel ? lastPingedTime : nextKnownPendingLevel;
          if (nextLevel <= Idle && firstPendingTime !== nextLevel) {
            return NoWork;
          }
          return nextLevel;
        }
        function ensureRootIsScheduled(root3) {
          var lastExpiredTime = root3.lastExpiredTime;
          if (lastExpiredTime !== NoWork) {
            root3.callbackExpirationTime = Sync;
            root3.callbackPriority = ImmediatePriority;
            root3.callbackNode = scheduleSyncCallback(performSyncWorkOnRoot.bind(null, root3));
            return;
          }
          var expirationTime = getNextRootExpirationTimeToWorkOn(root3);
          var existingCallbackNode = root3.callbackNode;
          if (expirationTime === NoWork) {
            if (existingCallbackNode !== null) {
              root3.callbackNode = null;
              root3.callbackExpirationTime = NoWork;
              root3.callbackPriority = NoPriority;
            }
            return;
          }
          var currentTime = requestCurrentTimeForUpdate();
          var priorityLevel = inferPriorityFromExpirationTime(currentTime, expirationTime);
          if (existingCallbackNode !== null) {
            var existingCallbackPriority = root3.callbackPriority;
            var existingCallbackExpirationTime = root3.callbackExpirationTime;
            if (
              // Callback must have the exact same expiration time.
              existingCallbackExpirationTime === expirationTime && // Callback must have greater or equal priority.
              existingCallbackPriority >= priorityLevel
            ) {
              return;
            }
            cancelCallback(existingCallbackNode);
          }
          root3.callbackExpirationTime = expirationTime;
          root3.callbackPriority = priorityLevel;
          var callbackNode;
          if (expirationTime === Sync) {
            callbackNode = scheduleSyncCallback(performSyncWorkOnRoot.bind(null, root3));
          } else {
            callbackNode = scheduleCallback(
              priorityLevel,
              performConcurrentWorkOnRoot.bind(null, root3),
              // Compute a task timeout based on the expiration time. This also affects
              // ordering because tasks are processed in timeout order.
              {
                timeout: expirationTimeToMs(expirationTime) - now4()
              }
            );
          }
          root3.callbackNode = callbackNode;
        }
        function performConcurrentWorkOnRoot(root3, didTimeout) {
          currentEventTime = NoWork;
          if (didTimeout) {
            var currentTime = requestCurrentTimeForUpdate();
            markRootExpiredAtTime(root3, currentTime);
            ensureRootIsScheduled(root3);
            return null;
          }
          var expirationTime = getNextRootExpirationTimeToWorkOn(root3);
          if (expirationTime !== NoWork) {
            var originalCallbackNode = root3.callbackNode;
            if (!((executionContext & (RenderContext | CommitContext)) === NoContext)) {
              {
                throw Error("Should not already be working.");
              }
            }
            flushPassiveEffects();
            if (root3 !== workInProgressRoot || expirationTime !== renderExpirationTime$1) {
              prepareFreshStack(root3, expirationTime);
              startWorkOnPendingInteractions(root3, expirationTime);
            }
            if (workInProgress !== null) {
              var prevExecutionContext = executionContext;
              executionContext |= RenderContext;
              var prevDispatcher = pushDispatcher();
              var prevInteractions = pushInteractions(root3);
              startWorkLoopTimer(workInProgress);
              do {
                try {
                  workLoopConcurrent();
                  break;
                } catch (thrownValue) {
                  handleError(root3, thrownValue);
                }
              } while (true);
              resetContextDependencies();
              executionContext = prevExecutionContext;
              popDispatcher(prevDispatcher);
              {
                popInteractions(prevInteractions);
              }
              if (workInProgressRootExitStatus === RootFatalErrored) {
                var fatalError = workInProgressRootFatalError;
                stopInterruptedWorkLoopTimer();
                prepareFreshStack(root3, expirationTime);
                markRootSuspendedAtTime(root3, expirationTime);
                ensureRootIsScheduled(root3);
                throw fatalError;
              }
              if (workInProgress !== null) {
                stopInterruptedWorkLoopTimer();
              } else {
                stopFinishedWorkLoopTimer();
                var finishedWork = root3.finishedWork = root3.current.alternate;
                root3.finishedExpirationTime = expirationTime;
                finishConcurrentRender(root3, finishedWork, workInProgressRootExitStatus, expirationTime);
              }
              ensureRootIsScheduled(root3);
              if (root3.callbackNode === originalCallbackNode) {
                return performConcurrentWorkOnRoot.bind(null, root3);
              }
            }
          }
          return null;
        }
        function finishConcurrentRender(root3, finishedWork, exitStatus, expirationTime) {
          workInProgressRoot = null;
          switch (exitStatus) {
            case RootIncomplete:
            case RootFatalErrored: {
              {
                {
                  throw Error("Root did not complete. This is a bug in React.");
                }
              }
            }
            // Flow knows about invariant, so it complains if I add a break
            // statement, but eslint doesn't know about invariant, so it complains
            // if I do. eslint-disable-next-line no-fallthrough
            case RootErrored: {
              markRootExpiredAtTime(root3, expirationTime > Idle ? Idle : expirationTime);
              break;
            }
            case RootSuspended: {
              markRootSuspendedAtTime(root3, expirationTime);
              var lastSuspendedTime = root3.lastSuspendedTime;
              if (expirationTime === lastSuspendedTime) {
                root3.nextKnownPendingLevel = getRemainingExpirationTime(finishedWork);
              }
              var hasNotProcessedNewUpdates = workInProgressRootLatestProcessedExpirationTime === Sync;
              if (hasNotProcessedNewUpdates && // do not delay if we're inside an act() scope
              !IsThisRendererActing.current) {
                var msUntilTimeout = globalMostRecentFallbackTime + FALLBACK_THROTTLE_MS - now4();
                if (msUntilTimeout > 10) {
                  if (workInProgressRootHasPendingPing) {
                    var lastPingedTime = root3.lastPingedTime;
                    if (lastPingedTime === NoWork || lastPingedTime >= expirationTime) {
                      root3.lastPingedTime = expirationTime;
                      prepareFreshStack(root3, expirationTime);
                      break;
                    }
                  }
                  var nextTime = getNextRootExpirationTimeToWorkOn(root3);
                  if (nextTime !== NoWork && nextTime !== expirationTime) {
                    break;
                  }
                  if (lastSuspendedTime !== NoWork && lastSuspendedTime !== expirationTime) {
                    root3.lastPingedTime = lastSuspendedTime;
                    break;
                  }
                  root3.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root3), msUntilTimeout);
                  break;
                }
              }
              commitRoot(root3);
              break;
            }
            case RootSuspendedWithDelay: {
              markRootSuspendedAtTime(root3, expirationTime);
              var _lastSuspendedTime = root3.lastSuspendedTime;
              if (expirationTime === _lastSuspendedTime) {
                root3.nextKnownPendingLevel = getRemainingExpirationTime(finishedWork);
              }
              if (
                // do not delay if we're inside an act() scope
                !IsThisRendererActing.current
              ) {
                if (workInProgressRootHasPendingPing) {
                  var _lastPingedTime = root3.lastPingedTime;
                  if (_lastPingedTime === NoWork || _lastPingedTime >= expirationTime) {
                    root3.lastPingedTime = expirationTime;
                    prepareFreshStack(root3, expirationTime);
                    break;
                  }
                }
                var _nextTime = getNextRootExpirationTimeToWorkOn(root3);
                if (_nextTime !== NoWork && _nextTime !== expirationTime) {
                  break;
                }
                if (_lastSuspendedTime !== NoWork && _lastSuspendedTime !== expirationTime) {
                  root3.lastPingedTime = _lastSuspendedTime;
                  break;
                }
                var _msUntilTimeout;
                if (workInProgressRootLatestSuspenseTimeout !== Sync) {
                  _msUntilTimeout = expirationTimeToMs(workInProgressRootLatestSuspenseTimeout) - now4();
                } else if (workInProgressRootLatestProcessedExpirationTime === Sync) {
                  _msUntilTimeout = 0;
                } else {
                  var eventTimeMs = inferTimeFromExpirationTime(workInProgressRootLatestProcessedExpirationTime);
                  var currentTimeMs = now4();
                  var timeUntilExpirationMs = expirationTimeToMs(expirationTime) - currentTimeMs;
                  var timeElapsed = currentTimeMs - eventTimeMs;
                  if (timeElapsed < 0) {
                    timeElapsed = 0;
                  }
                  _msUntilTimeout = jnd(timeElapsed) - timeElapsed;
                  if (timeUntilExpirationMs < _msUntilTimeout) {
                    _msUntilTimeout = timeUntilExpirationMs;
                  }
                }
                if (_msUntilTimeout > 10) {
                  root3.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root3), _msUntilTimeout);
                  break;
                }
              }
              commitRoot(root3);
              break;
            }
            case RootCompleted: {
              if (
                // do not delay if we're inside an act() scope
                !IsThisRendererActing.current && workInProgressRootLatestProcessedExpirationTime !== Sync && workInProgressRootCanSuspendUsingConfig !== null
              ) {
                var _msUntilTimeout2 = computeMsUntilSuspenseLoadingDelay(workInProgressRootLatestProcessedExpirationTime, expirationTime, workInProgressRootCanSuspendUsingConfig);
                if (_msUntilTimeout2 > 10) {
                  markRootSuspendedAtTime(root3, expirationTime);
                  root3.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root3), _msUntilTimeout2);
                  break;
                }
              }
              commitRoot(root3);
              break;
            }
            default: {
              {
                {
                  throw Error("Unknown root exit status.");
                }
              }
            }
          }
        }
        function performSyncWorkOnRoot(root3) {
          var lastExpiredTime = root3.lastExpiredTime;
          var expirationTime = lastExpiredTime !== NoWork ? lastExpiredTime : Sync;
          if (!((executionContext & (RenderContext | CommitContext)) === NoContext)) {
            {
              throw Error("Should not already be working.");
            }
          }
          flushPassiveEffects();
          if (root3 !== workInProgressRoot || expirationTime !== renderExpirationTime$1) {
            prepareFreshStack(root3, expirationTime);
            startWorkOnPendingInteractions(root3, expirationTime);
          }
          if (workInProgress !== null) {
            var prevExecutionContext = executionContext;
            executionContext |= RenderContext;
            var prevDispatcher = pushDispatcher();
            var prevInteractions = pushInteractions(root3);
            startWorkLoopTimer(workInProgress);
            do {
              try {
                workLoopSync();
                break;
              } catch (thrownValue) {
                handleError(root3, thrownValue);
              }
            } while (true);
            resetContextDependencies();
            executionContext = prevExecutionContext;
            popDispatcher(prevDispatcher);
            {
              popInteractions(prevInteractions);
            }
            if (workInProgressRootExitStatus === RootFatalErrored) {
              var fatalError = workInProgressRootFatalError;
              stopInterruptedWorkLoopTimer();
              prepareFreshStack(root3, expirationTime);
              markRootSuspendedAtTime(root3, expirationTime);
              ensureRootIsScheduled(root3);
              throw fatalError;
            }
            if (workInProgress !== null) {
              {
                {
                  throw Error("Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue.");
                }
              }
            } else {
              stopFinishedWorkLoopTimer();
              root3.finishedWork = root3.current.alternate;
              root3.finishedExpirationTime = expirationTime;
              finishSyncRender(root3);
            }
            ensureRootIsScheduled(root3);
          }
          return null;
        }
        function finishSyncRender(root3) {
          workInProgressRoot = null;
          commitRoot(root3);
        }
        function flushDiscreteUpdates() {
          if ((executionContext & (BatchedContext | RenderContext | CommitContext)) !== NoContext) {
            {
              if ((executionContext & RenderContext) !== NoContext) {
                error2("unstable_flushDiscreteUpdates: Cannot flush updates when React is already rendering.");
              }
            }
            return;
          }
          flushPendingDiscreteUpdates();
          flushPassiveEffects();
        }
        function syncUpdates(fn, a, b, c) {
          return runWithPriority$1(ImmediatePriority, fn.bind(null, a, b, c));
        }
        function flushPendingDiscreteUpdates() {
          if (rootsWithPendingDiscreteUpdates !== null) {
            var roots = rootsWithPendingDiscreteUpdates;
            rootsWithPendingDiscreteUpdates = null;
            roots.forEach(function(expirationTime, root3) {
              markRootExpiredAtTime(root3, expirationTime);
              ensureRootIsScheduled(root3);
            });
            flushSyncCallbackQueue();
          }
        }
        function batchedUpdates$1(fn, a) {
          var prevExecutionContext = executionContext;
          executionContext |= BatchedContext;
          try {
            return fn(a);
          } finally {
            executionContext = prevExecutionContext;
            if (executionContext === NoContext) {
              flushSyncCallbackQueue();
            }
          }
        }
        function batchedEventUpdates$1(fn, a) {
          var prevExecutionContext = executionContext;
          executionContext |= EventContext;
          try {
            return fn(a);
          } finally {
            executionContext = prevExecutionContext;
            if (executionContext === NoContext) {
              flushSyncCallbackQueue();
            }
          }
        }
        function discreteUpdates$1(fn, a, b, c, d) {
          var prevExecutionContext = executionContext;
          executionContext |= DiscreteEventContext;
          try {
            return runWithPriority$1(UserBlockingPriority$1, fn.bind(null, a, b, c, d));
          } finally {
            executionContext = prevExecutionContext;
            if (executionContext === NoContext) {
              flushSyncCallbackQueue();
            }
          }
        }
        function unbatchedUpdates(fn, a) {
          var prevExecutionContext = executionContext;
          executionContext &= ~BatchedContext;
          executionContext |= LegacyUnbatchedContext;
          try {
            return fn(a);
          } finally {
            executionContext = prevExecutionContext;
            if (executionContext === NoContext) {
              flushSyncCallbackQueue();
            }
          }
        }
        function flushSync5(fn, a) {
          if ((executionContext & (RenderContext | CommitContext)) !== NoContext) {
            {
              {
                throw Error("flushSync was called from inside a lifecycle method. It cannot be called when React is already rendering.");
              }
            }
          }
          var prevExecutionContext = executionContext;
          executionContext |= BatchedContext;
          try {
            return runWithPriority$1(ImmediatePriority, fn.bind(null, a));
          } finally {
            executionContext = prevExecutionContext;
            flushSyncCallbackQueue();
          }
        }
        function prepareFreshStack(root3, expirationTime) {
          root3.finishedWork = null;
          root3.finishedExpirationTime = NoWork;
          var timeoutHandle = root3.timeoutHandle;
          if (timeoutHandle !== noTimeout) {
            root3.timeoutHandle = noTimeout;
            cancelTimeout(timeoutHandle);
          }
          if (workInProgress !== null) {
            var interruptedWork = workInProgress.return;
            while (interruptedWork !== null) {
              unwindInterruptedWork(interruptedWork);
              interruptedWork = interruptedWork.return;
            }
          }
          workInProgressRoot = root3;
          workInProgress = createWorkInProgress(root3.current, null);
          renderExpirationTime$1 = expirationTime;
          workInProgressRootExitStatus = RootIncomplete;
          workInProgressRootFatalError = null;
          workInProgressRootLatestProcessedExpirationTime = Sync;
          workInProgressRootLatestSuspenseTimeout = Sync;
          workInProgressRootCanSuspendUsingConfig = null;
          workInProgressRootNextUnprocessedUpdateTime = NoWork;
          workInProgressRootHasPendingPing = false;
          {
            spawnedWorkDuringRender = null;
          }
          {
            ReactStrictModeWarnings.discardPendingWarnings();
          }
        }
        function handleError(root3, thrownValue) {
          do {
            try {
              resetContextDependencies();
              resetHooksAfterThrow();
              resetCurrentFiber();
              if (workInProgress === null || workInProgress.return === null) {
                workInProgressRootExitStatus = RootFatalErrored;
                workInProgressRootFatalError = thrownValue;
                workInProgress = null;
                return null;
              }
              if (enableProfilerTimer && workInProgress.mode & ProfileMode) {
                stopProfilerTimerIfRunningAndRecordDelta(workInProgress, true);
              }
              throwException(root3, workInProgress.return, workInProgress, thrownValue, renderExpirationTime$1);
              workInProgress = completeUnitOfWork(workInProgress);
            } catch (yetAnotherThrownValue) {
              thrownValue = yetAnotherThrownValue;
              continue;
            }
            return;
          } while (true);
        }
        function pushDispatcher(root3) {
          var prevDispatcher = ReactCurrentDispatcher$1.current;
          ReactCurrentDispatcher$1.current = ContextOnlyDispatcher;
          if (prevDispatcher === null) {
            return ContextOnlyDispatcher;
          } else {
            return prevDispatcher;
          }
        }
        function popDispatcher(prevDispatcher) {
          ReactCurrentDispatcher$1.current = prevDispatcher;
        }
        function pushInteractions(root3) {
          {
            var prevInteractions = tracing.__interactionsRef.current;
            tracing.__interactionsRef.current = root3.memoizedInteractions;
            return prevInteractions;
          }
        }
        function popInteractions(prevInteractions) {
          {
            tracing.__interactionsRef.current = prevInteractions;
          }
        }
        function markCommitTimeOfFallback() {
          globalMostRecentFallbackTime = now4();
        }
        function markRenderEventTimeAndConfig(expirationTime, suspenseConfig) {
          if (expirationTime < workInProgressRootLatestProcessedExpirationTime && expirationTime > Idle) {
            workInProgressRootLatestProcessedExpirationTime = expirationTime;
          }
          if (suspenseConfig !== null) {
            if (expirationTime < workInProgressRootLatestSuspenseTimeout && expirationTime > Idle) {
              workInProgressRootLatestSuspenseTimeout = expirationTime;
              workInProgressRootCanSuspendUsingConfig = suspenseConfig;
            }
          }
        }
        function markUnprocessedUpdateTime(expirationTime) {
          if (expirationTime > workInProgressRootNextUnprocessedUpdateTime) {
            workInProgressRootNextUnprocessedUpdateTime = expirationTime;
          }
        }
        function renderDidSuspend() {
          if (workInProgressRootExitStatus === RootIncomplete) {
            workInProgressRootExitStatus = RootSuspended;
          }
        }
        function renderDidSuspendDelayIfPossible() {
          if (workInProgressRootExitStatus === RootIncomplete || workInProgressRootExitStatus === RootSuspended) {
            workInProgressRootExitStatus = RootSuspendedWithDelay;
          }
          if (workInProgressRootNextUnprocessedUpdateTime !== NoWork && workInProgressRoot !== null) {
            markRootSuspendedAtTime(workInProgressRoot, renderExpirationTime$1);
            markRootUpdatedAtTime(workInProgressRoot, workInProgressRootNextUnprocessedUpdateTime);
          }
        }
        function renderDidError() {
          if (workInProgressRootExitStatus !== RootCompleted) {
            workInProgressRootExitStatus = RootErrored;
          }
        }
        function renderHasNotSuspendedYet() {
          return workInProgressRootExitStatus === RootIncomplete;
        }
        function inferTimeFromExpirationTime(expirationTime) {
          var earliestExpirationTimeMs = expirationTimeToMs(expirationTime);
          return earliestExpirationTimeMs - LOW_PRIORITY_EXPIRATION;
        }
        function inferTimeFromExpirationTimeWithSuspenseConfig(expirationTime, suspenseConfig) {
          var earliestExpirationTimeMs = expirationTimeToMs(expirationTime);
          return earliestExpirationTimeMs - (suspenseConfig.timeoutMs | 0 || LOW_PRIORITY_EXPIRATION);
        }
        function workLoopSync() {
          while (workInProgress !== null) {
            workInProgress = performUnitOfWork(workInProgress);
          }
        }
        function workLoopConcurrent() {
          while (workInProgress !== null && !shouldYield()) {
            workInProgress = performUnitOfWork(workInProgress);
          }
        }
        function performUnitOfWork(unitOfWork) {
          var current3 = unitOfWork.alternate;
          startWorkTimer(unitOfWork);
          setCurrentFiber(unitOfWork);
          var next2;
          if ((unitOfWork.mode & ProfileMode) !== NoMode) {
            startProfilerTimer(unitOfWork);
            next2 = beginWork$1(current3, unitOfWork, renderExpirationTime$1);
            stopProfilerTimerIfRunningAndRecordDelta(unitOfWork, true);
          } else {
            next2 = beginWork$1(current3, unitOfWork, renderExpirationTime$1);
          }
          resetCurrentFiber();
          unitOfWork.memoizedProps = unitOfWork.pendingProps;
          if (next2 === null) {
            next2 = completeUnitOfWork(unitOfWork);
          }
          ReactCurrentOwner$2.current = null;
          return next2;
        }
        function completeUnitOfWork(unitOfWork) {
          workInProgress = unitOfWork;
          do {
            var current3 = workInProgress.alternate;
            var returnFiber = workInProgress.return;
            if ((workInProgress.effectTag & Incomplete) === NoEffect) {
              setCurrentFiber(workInProgress);
              var next2 = void 0;
              if ((workInProgress.mode & ProfileMode) === NoMode) {
                next2 = completeWork(current3, workInProgress, renderExpirationTime$1);
              } else {
                startProfilerTimer(workInProgress);
                next2 = completeWork(current3, workInProgress, renderExpirationTime$1);
                stopProfilerTimerIfRunningAndRecordDelta(workInProgress, false);
              }
              stopWorkTimer(workInProgress);
              resetCurrentFiber();
              resetChildExpirationTime(workInProgress);
              if (next2 !== null) {
                return next2;
              }
              if (returnFiber !== null && // Do not append effects to parents if a sibling failed to complete
              (returnFiber.effectTag & Incomplete) === NoEffect) {
                if (returnFiber.firstEffect === null) {
                  returnFiber.firstEffect = workInProgress.firstEffect;
                }
                if (workInProgress.lastEffect !== null) {
                  if (returnFiber.lastEffect !== null) {
                    returnFiber.lastEffect.nextEffect = workInProgress.firstEffect;
                  }
                  returnFiber.lastEffect = workInProgress.lastEffect;
                }
                var effectTag = workInProgress.effectTag;
                if (effectTag > PerformedWork) {
                  if (returnFiber.lastEffect !== null) {
                    returnFiber.lastEffect.nextEffect = workInProgress;
                  } else {
                    returnFiber.firstEffect = workInProgress;
                  }
                  returnFiber.lastEffect = workInProgress;
                }
              }
            } else {
              var _next = unwindWork(workInProgress);
              if ((workInProgress.mode & ProfileMode) !== NoMode) {
                stopProfilerTimerIfRunningAndRecordDelta(workInProgress, false);
                var actualDuration = workInProgress.actualDuration;
                var child = workInProgress.child;
                while (child !== null) {
                  actualDuration += child.actualDuration;
                  child = child.sibling;
                }
                workInProgress.actualDuration = actualDuration;
              }
              if (_next !== null) {
                stopFailedWorkTimer(workInProgress);
                _next.effectTag &= HostEffectMask;
                return _next;
              }
              stopWorkTimer(workInProgress);
              if (returnFiber !== null) {
                returnFiber.firstEffect = returnFiber.lastEffect = null;
                returnFiber.effectTag |= Incomplete;
              }
            }
            var siblingFiber = workInProgress.sibling;
            if (siblingFiber !== null) {
              return siblingFiber;
            }
            workInProgress = returnFiber;
          } while (workInProgress !== null);
          if (workInProgressRootExitStatus === RootIncomplete) {
            workInProgressRootExitStatus = RootCompleted;
          }
          return null;
        }
        function getRemainingExpirationTime(fiber) {
          var updateExpirationTime = fiber.expirationTime;
          var childExpirationTime = fiber.childExpirationTime;
          return updateExpirationTime > childExpirationTime ? updateExpirationTime : childExpirationTime;
        }
        function resetChildExpirationTime(completedWork) {
          if (renderExpirationTime$1 !== Never && completedWork.childExpirationTime === Never) {
            return;
          }
          var newChildExpirationTime = NoWork;
          if ((completedWork.mode & ProfileMode) !== NoMode) {
            var actualDuration = completedWork.actualDuration;
            var treeBaseDuration = completedWork.selfBaseDuration;
            var shouldBubbleActualDurations = completedWork.alternate === null || completedWork.child !== completedWork.alternate.child;
            var child = completedWork.child;
            while (child !== null) {
              var childUpdateExpirationTime = child.expirationTime;
              var childChildExpirationTime = child.childExpirationTime;
              if (childUpdateExpirationTime > newChildExpirationTime) {
                newChildExpirationTime = childUpdateExpirationTime;
              }
              if (childChildExpirationTime > newChildExpirationTime) {
                newChildExpirationTime = childChildExpirationTime;
              }
              if (shouldBubbleActualDurations) {
                actualDuration += child.actualDuration;
              }
              treeBaseDuration += child.treeBaseDuration;
              child = child.sibling;
            }
            completedWork.actualDuration = actualDuration;
            completedWork.treeBaseDuration = treeBaseDuration;
          } else {
            var _child = completedWork.child;
            while (_child !== null) {
              var _childUpdateExpirationTime = _child.expirationTime;
              var _childChildExpirationTime = _child.childExpirationTime;
              if (_childUpdateExpirationTime > newChildExpirationTime) {
                newChildExpirationTime = _childUpdateExpirationTime;
              }
              if (_childChildExpirationTime > newChildExpirationTime) {
                newChildExpirationTime = _childChildExpirationTime;
              }
              _child = _child.sibling;
            }
          }
          completedWork.childExpirationTime = newChildExpirationTime;
        }
        function commitRoot(root3) {
          var renderPriorityLevel = getCurrentPriorityLevel();
          runWithPriority$1(ImmediatePriority, commitRootImpl.bind(null, root3, renderPriorityLevel));
          return null;
        }
        function commitRootImpl(root3, renderPriorityLevel) {
          do {
            flushPassiveEffects();
          } while (rootWithPendingPassiveEffects !== null);
          flushRenderPhaseStrictModeWarningsInDEV();
          if (!((executionContext & (RenderContext | CommitContext)) === NoContext)) {
            {
              throw Error("Should not already be working.");
            }
          }
          var finishedWork = root3.finishedWork;
          var expirationTime = root3.finishedExpirationTime;
          if (finishedWork === null) {
            return null;
          }
          root3.finishedWork = null;
          root3.finishedExpirationTime = NoWork;
          if (!(finishedWork !== root3.current)) {
            {
              throw Error("Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.");
            }
          }
          root3.callbackNode = null;
          root3.callbackExpirationTime = NoWork;
          root3.callbackPriority = NoPriority;
          root3.nextKnownPendingLevel = NoWork;
          startCommitTimer();
          var remainingExpirationTimeBeforeCommit = getRemainingExpirationTime(finishedWork);
          markRootFinishedAtTime(root3, expirationTime, remainingExpirationTimeBeforeCommit);
          if (root3 === workInProgressRoot) {
            workInProgressRoot = null;
            workInProgress = null;
            renderExpirationTime$1 = NoWork;
          }
          var firstEffect;
          if (finishedWork.effectTag > PerformedWork) {
            if (finishedWork.lastEffect !== null) {
              finishedWork.lastEffect.nextEffect = finishedWork;
              firstEffect = finishedWork.firstEffect;
            } else {
              firstEffect = finishedWork;
            }
          } else {
            firstEffect = finishedWork.firstEffect;
          }
          if (firstEffect !== null) {
            var prevExecutionContext = executionContext;
            executionContext |= CommitContext;
            var prevInteractions = pushInteractions(root3);
            ReactCurrentOwner$2.current = null;
            startCommitSnapshotEffectsTimer();
            prepareForCommit(root3.containerInfo);
            nextEffect = firstEffect;
            do {
              {
                invokeGuardedCallback(null, commitBeforeMutationEffects, null);
                if (hasCaughtError()) {
                  if (!(nextEffect !== null)) {
                    {
                      throw Error("Should be working on an effect.");
                    }
                  }
                  var error3 = clearCaughtError();
                  captureCommitPhaseError(nextEffect, error3);
                  nextEffect = nextEffect.nextEffect;
                }
              }
            } while (nextEffect !== null);
            stopCommitSnapshotEffectsTimer();
            {
              recordCommitTime();
            }
            startCommitHostEffectsTimer();
            nextEffect = firstEffect;
            do {
              {
                invokeGuardedCallback(null, commitMutationEffects, null, root3, renderPriorityLevel);
                if (hasCaughtError()) {
                  if (!(nextEffect !== null)) {
                    {
                      throw Error("Should be working on an effect.");
                    }
                  }
                  var _error = clearCaughtError();
                  captureCommitPhaseError(nextEffect, _error);
                  nextEffect = nextEffect.nextEffect;
                }
              }
            } while (nextEffect !== null);
            stopCommitHostEffectsTimer();
            resetAfterCommit(root3.containerInfo);
            root3.current = finishedWork;
            startCommitLifeCyclesTimer();
            nextEffect = firstEffect;
            do {
              {
                invokeGuardedCallback(null, commitLayoutEffects, null, root3, expirationTime);
                if (hasCaughtError()) {
                  if (!(nextEffect !== null)) {
                    {
                      throw Error("Should be working on an effect.");
                    }
                  }
                  var _error2 = clearCaughtError();
                  captureCommitPhaseError(nextEffect, _error2);
                  nextEffect = nextEffect.nextEffect;
                }
              }
            } while (nextEffect !== null);
            stopCommitLifeCyclesTimer();
            nextEffect = null;
            requestPaint();
            {
              popInteractions(prevInteractions);
            }
            executionContext = prevExecutionContext;
          } else {
            root3.current = finishedWork;
            startCommitSnapshotEffectsTimer();
            stopCommitSnapshotEffectsTimer();
            {
              recordCommitTime();
            }
            startCommitHostEffectsTimer();
            stopCommitHostEffectsTimer();
            startCommitLifeCyclesTimer();
            stopCommitLifeCyclesTimer();
          }
          stopCommitTimer();
          var rootDidHavePassiveEffects = rootDoesHavePassiveEffects;
          if (rootDoesHavePassiveEffects) {
            rootDoesHavePassiveEffects = false;
            rootWithPendingPassiveEffects = root3;
            pendingPassiveEffectsExpirationTime = expirationTime;
            pendingPassiveEffectsRenderPriority = renderPriorityLevel;
          } else {
            nextEffect = firstEffect;
            while (nextEffect !== null) {
              var nextNextEffect = nextEffect.nextEffect;
              nextEffect.nextEffect = null;
              nextEffect = nextNextEffect;
            }
          }
          var remainingExpirationTime = root3.firstPendingTime;
          if (remainingExpirationTime !== NoWork) {
            {
              if (spawnedWorkDuringRender !== null) {
                var expirationTimes = spawnedWorkDuringRender;
                spawnedWorkDuringRender = null;
                for (var i = 0; i < expirationTimes.length; i++) {
                  scheduleInteractions(root3, expirationTimes[i], root3.memoizedInteractions);
                }
              }
              schedulePendingInteractions(root3, remainingExpirationTime);
            }
          } else {
            legacyErrorBoundariesThatAlreadyFailed = null;
          }
          {
            if (!rootDidHavePassiveEffects) {
              finishPendingInteractions(root3, expirationTime);
            }
          }
          if (remainingExpirationTime === Sync) {
            if (root3 === rootWithNestedUpdates) {
              nestedUpdateCount++;
            } else {
              nestedUpdateCount = 0;
              rootWithNestedUpdates = root3;
            }
          } else {
            nestedUpdateCount = 0;
          }
          onCommitRoot(finishedWork.stateNode, expirationTime);
          ensureRootIsScheduled(root3);
          if (hasUncaughtError) {
            hasUncaughtError = false;
            var _error3 = firstUncaughtError;
            firstUncaughtError = null;
            throw _error3;
          }
          if ((executionContext & LegacyUnbatchedContext) !== NoContext) {
            return null;
          }
          flushSyncCallbackQueue();
          return null;
        }
        function commitBeforeMutationEffects() {
          while (nextEffect !== null) {
            var effectTag = nextEffect.effectTag;
            if ((effectTag & Snapshot) !== NoEffect) {
              setCurrentFiber(nextEffect);
              recordEffect();
              var current3 = nextEffect.alternate;
              commitBeforeMutationLifeCycles(current3, nextEffect);
              resetCurrentFiber();
            }
            if ((effectTag & Passive) !== NoEffect) {
              if (!rootDoesHavePassiveEffects) {
                rootDoesHavePassiveEffects = true;
                scheduleCallback(NormalPriority, function() {
                  flushPassiveEffects();
                  return null;
                });
              }
            }
            nextEffect = nextEffect.nextEffect;
          }
        }
        function commitMutationEffects(root3, renderPriorityLevel) {
          while (nextEffect !== null) {
            setCurrentFiber(nextEffect);
            var effectTag = nextEffect.effectTag;
            if (effectTag & ContentReset) {
              commitResetTextContent(nextEffect);
            }
            if (effectTag & Ref5) {
              var current3 = nextEffect.alternate;
              if (current3 !== null) {
                commitDetachRef(current3);
              }
            }
            var primaryEffectTag = effectTag & (Placement | Update | Deletion | Hydrating);
            switch (primaryEffectTag) {
              case Placement: {
                commitPlacement(nextEffect);
                nextEffect.effectTag &= ~Placement;
                break;
              }
              case PlacementAndUpdate: {
                commitPlacement(nextEffect);
                nextEffect.effectTag &= ~Placement;
                var _current = nextEffect.alternate;
                commitWork(_current, nextEffect);
                break;
              }
              case Hydrating: {
                nextEffect.effectTag &= ~Hydrating;
                break;
              }
              case HydratingAndUpdate: {
                nextEffect.effectTag &= ~Hydrating;
                var _current2 = nextEffect.alternate;
                commitWork(_current2, nextEffect);
                break;
              }
              case Update: {
                var _current3 = nextEffect.alternate;
                commitWork(_current3, nextEffect);
                break;
              }
              case Deletion: {
                commitDeletion(root3, nextEffect, renderPriorityLevel);
                break;
              }
            }
            recordEffect();
            resetCurrentFiber();
            nextEffect = nextEffect.nextEffect;
          }
        }
        function commitLayoutEffects(root3, committedExpirationTime) {
          while (nextEffect !== null) {
            setCurrentFiber(nextEffect);
            var effectTag = nextEffect.effectTag;
            if (effectTag & (Update | Callback)) {
              recordEffect();
              var current3 = nextEffect.alternate;
              commitLifeCycles(root3, current3, nextEffect);
            }
            if (effectTag & Ref5) {
              recordEffect();
              commitAttachRef(nextEffect);
            }
            resetCurrentFiber();
            nextEffect = nextEffect.nextEffect;
          }
        }
        function flushPassiveEffects() {
          if (pendingPassiveEffectsRenderPriority !== NoPriority) {
            var priorityLevel = pendingPassiveEffectsRenderPriority > NormalPriority ? NormalPriority : pendingPassiveEffectsRenderPriority;
            pendingPassiveEffectsRenderPriority = NoPriority;
            return runWithPriority$1(priorityLevel, flushPassiveEffectsImpl);
          }
        }
        function flushPassiveEffectsImpl() {
          if (rootWithPendingPassiveEffects === null) {
            return false;
          }
          var root3 = rootWithPendingPassiveEffects;
          var expirationTime = pendingPassiveEffectsExpirationTime;
          rootWithPendingPassiveEffects = null;
          pendingPassiveEffectsExpirationTime = NoWork;
          if (!((executionContext & (RenderContext | CommitContext)) === NoContext)) {
            {
              throw Error("Cannot flush passive effects while already rendering.");
            }
          }
          var prevExecutionContext = executionContext;
          executionContext |= CommitContext;
          var prevInteractions = pushInteractions(root3);
          {
            var _effect2 = root3.current.firstEffect;
            while (_effect2 !== null) {
              {
                setCurrentFiber(_effect2);
                invokeGuardedCallback(null, commitPassiveHookEffects, null, _effect2);
                if (hasCaughtError()) {
                  if (!(_effect2 !== null)) {
                    {
                      throw Error("Should be working on an effect.");
                    }
                  }
                  var _error5 = clearCaughtError();
                  captureCommitPhaseError(_effect2, _error5);
                }
                resetCurrentFiber();
              }
              var nextNextEffect = _effect2.nextEffect;
              _effect2.nextEffect = null;
              _effect2 = nextNextEffect;
            }
          }
          {
            popInteractions(prevInteractions);
            finishPendingInteractions(root3, expirationTime);
          }
          executionContext = prevExecutionContext;
          flushSyncCallbackQueue();
          nestedPassiveUpdateCount = rootWithPendingPassiveEffects === null ? 0 : nestedPassiveUpdateCount + 1;
          return true;
        }
        function isAlreadyFailedLegacyErrorBoundary(instance) {
          return legacyErrorBoundariesThatAlreadyFailed !== null && legacyErrorBoundariesThatAlreadyFailed.has(instance);
        }
        function markLegacyErrorBoundaryAsFailed(instance) {
          if (legacyErrorBoundariesThatAlreadyFailed === null) {
            legacyErrorBoundariesThatAlreadyFailed = /* @__PURE__ */ new Set([instance]);
          } else {
            legacyErrorBoundariesThatAlreadyFailed.add(instance);
          }
        }
        function prepareToThrowUncaughtError(error3) {
          if (!hasUncaughtError) {
            hasUncaughtError = true;
            firstUncaughtError = error3;
          }
        }
        var onUncaughtError = prepareToThrowUncaughtError;
        function captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error3) {
          var errorInfo = createCapturedValue(error3, sourceFiber);
          var update = createRootErrorUpdate(rootFiber, errorInfo, Sync);
          enqueueUpdate(rootFiber, update);
          var root3 = markUpdateTimeFromFiberToRoot(rootFiber, Sync);
          if (root3 !== null) {
            ensureRootIsScheduled(root3);
            schedulePendingInteractions(root3, Sync);
          }
        }
        function captureCommitPhaseError(sourceFiber, error3) {
          if (sourceFiber.tag === HostRoot) {
            captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error3);
            return;
          }
          var fiber = sourceFiber.return;
          while (fiber !== null) {
            if (fiber.tag === HostRoot) {
              captureCommitPhaseErrorOnRoot(fiber, sourceFiber, error3);
              return;
            } else if (fiber.tag === ClassComponent) {
              var ctor = fiber.type;
              var instance = fiber.stateNode;
              if (typeof ctor.getDerivedStateFromError === "function" || typeof instance.componentDidCatch === "function" && !isAlreadyFailedLegacyErrorBoundary(instance)) {
                var errorInfo = createCapturedValue(error3, sourceFiber);
                var update = createClassErrorUpdate(
                  fiber,
                  errorInfo,
                  // TODO: This is always sync
                  Sync
                );
                enqueueUpdate(fiber, update);
                var root3 = markUpdateTimeFromFiberToRoot(fiber, Sync);
                if (root3 !== null) {
                  ensureRootIsScheduled(root3);
                  schedulePendingInteractions(root3, Sync);
                }
                return;
              }
            }
            fiber = fiber.return;
          }
        }
        function pingSuspendedRoot(root3, thenable, suspendedTime) {
          var pingCache = root3.pingCache;
          if (pingCache !== null) {
            pingCache.delete(thenable);
          }
          if (workInProgressRoot === root3 && renderExpirationTime$1 === suspendedTime) {
            if (workInProgressRootExitStatus === RootSuspendedWithDelay || workInProgressRootExitStatus === RootSuspended && workInProgressRootLatestProcessedExpirationTime === Sync && now4() - globalMostRecentFallbackTime < FALLBACK_THROTTLE_MS) {
              prepareFreshStack(root3, renderExpirationTime$1);
            } else {
              workInProgressRootHasPendingPing = true;
            }
            return;
          }
          if (!isRootSuspendedAtTime(root3, suspendedTime)) {
            return;
          }
          var lastPingedTime = root3.lastPingedTime;
          if (lastPingedTime !== NoWork && lastPingedTime < suspendedTime) {
            return;
          }
          root3.lastPingedTime = suspendedTime;
          ensureRootIsScheduled(root3);
          schedulePendingInteractions(root3, suspendedTime);
        }
        function retryTimedOutBoundary(boundaryFiber, retryTime) {
          if (retryTime === NoWork) {
            var suspenseConfig = null;
            var currentTime = requestCurrentTimeForUpdate();
            retryTime = computeExpirationForFiber(currentTime, boundaryFiber, suspenseConfig);
          }
          var root3 = markUpdateTimeFromFiberToRoot(boundaryFiber, retryTime);
          if (root3 !== null) {
            ensureRootIsScheduled(root3);
            schedulePendingInteractions(root3, retryTime);
          }
        }
        function resolveRetryThenable(boundaryFiber, thenable) {
          var retryTime = NoWork;
          var retryCache;
          {
            retryCache = boundaryFiber.stateNode;
          }
          if (retryCache !== null) {
            retryCache.delete(thenable);
          }
          retryTimedOutBoundary(boundaryFiber, retryTime);
        }
        function jnd(timeElapsed) {
          return timeElapsed < 120 ? 120 : timeElapsed < 480 ? 480 : timeElapsed < 1080 ? 1080 : timeElapsed < 1920 ? 1920 : timeElapsed < 3e3 ? 3e3 : timeElapsed < 4320 ? 4320 : ceil(timeElapsed / 1960) * 1960;
        }
        function computeMsUntilSuspenseLoadingDelay(mostRecentEventTime, committedExpirationTime, suspenseConfig) {
          var busyMinDurationMs = suspenseConfig.busyMinDurationMs | 0;
          if (busyMinDurationMs <= 0) {
            return 0;
          }
          var busyDelayMs = suspenseConfig.busyDelayMs | 0;
          var currentTimeMs = now4();
          var eventTimeMs = inferTimeFromExpirationTimeWithSuspenseConfig(mostRecentEventTime, suspenseConfig);
          var timeElapsed = currentTimeMs - eventTimeMs;
          if (timeElapsed <= busyDelayMs) {
            return 0;
          }
          var msUntilTimeout = busyDelayMs + busyMinDurationMs - timeElapsed;
          return msUntilTimeout;
        }
        function checkForNestedUpdates() {
          if (nestedUpdateCount > NESTED_UPDATE_LIMIT) {
            nestedUpdateCount = 0;
            rootWithNestedUpdates = null;
            {
              {
                throw Error("Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.");
              }
            }
          }
          {
            if (nestedPassiveUpdateCount > NESTED_PASSIVE_UPDATE_LIMIT) {
              nestedPassiveUpdateCount = 0;
              error2("Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render.");
            }
          }
        }
        function flushRenderPhaseStrictModeWarningsInDEV() {
          {
            ReactStrictModeWarnings.flushLegacyContextWarning();
            {
              ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings();
            }
          }
        }
        function stopFinishedWorkLoopTimer() {
          var didCompleteRoot = true;
          stopWorkLoopTimer(interruptedBy, didCompleteRoot);
          interruptedBy = null;
        }
        function stopInterruptedWorkLoopTimer() {
          var didCompleteRoot = false;
          stopWorkLoopTimer(interruptedBy, didCompleteRoot);
          interruptedBy = null;
        }
        function checkForInterruption(fiberThatReceivedUpdate, updateExpirationTime) {
          if (workInProgressRoot !== null && updateExpirationTime > renderExpirationTime$1) {
            interruptedBy = fiberThatReceivedUpdate;
          }
        }
        var didWarnStateUpdateForUnmountedComponent = null;
        function warnAboutUpdateOnUnmountedFiberInDEV(fiber) {
          {
            var tag = fiber.tag;
            if (tag !== HostRoot && tag !== ClassComponent && tag !== FunctionComponent && tag !== ForwardRef2 && tag !== MemoComponent && tag !== SimpleMemoComponent && tag !== Block3) {
              return;
            }
            var componentName = getComponentName(fiber.type) || "ReactComponent";
            if (didWarnStateUpdateForUnmountedComponent !== null) {
              if (didWarnStateUpdateForUnmountedComponent.has(componentName)) {
                return;
              }
              didWarnStateUpdateForUnmountedComponent.add(componentName);
            } else {
              didWarnStateUpdateForUnmountedComponent = /* @__PURE__ */ new Set([componentName]);
            }
            error2("Can't perform a React state update on an unmounted component. This is a no-op, but it indicates a memory leak in your application. To fix, cancel all subscriptions and asynchronous tasks in %s.%s", tag === ClassComponent ? "the componentWillUnmount method" : "a useEffect cleanup function", getStackByFiberInDevAndProd(fiber));
          }
        }
        var beginWork$1;
        {
          var dummyFiber = null;
          beginWork$1 = function(current3, unitOfWork, expirationTime) {
            var originalWorkInProgressCopy = assignFiberPropertiesInDEV(dummyFiber, unitOfWork);
            try {
              return beginWork(current3, unitOfWork, expirationTime);
            } catch (originalError) {
              if (originalError !== null && typeof originalError === "object" && typeof originalError.then === "function") {
                throw originalError;
              }
              resetContextDependencies();
              resetHooksAfterThrow();
              unwindInterruptedWork(unitOfWork);
              assignFiberPropertiesInDEV(unitOfWork, originalWorkInProgressCopy);
              if (unitOfWork.mode & ProfileMode) {
                startProfilerTimer(unitOfWork);
              }
              invokeGuardedCallback(null, beginWork, null, current3, unitOfWork, expirationTime);
              if (hasCaughtError()) {
                var replayError = clearCaughtError();
                throw replayError;
              } else {
                throw originalError;
              }
            }
          };
        }
        var didWarnAboutUpdateInRender = false;
        var didWarnAboutUpdateInRenderForAnotherComponent;
        {
          didWarnAboutUpdateInRenderForAnotherComponent = /* @__PURE__ */ new Set();
        }
        function warnAboutRenderPhaseUpdatesInDEV(fiber) {
          {
            if (isRendering && (executionContext & RenderContext) !== NoContext) {
              switch (fiber.tag) {
                case FunctionComponent:
                case ForwardRef2:
                case SimpleMemoComponent: {
                  var renderingComponentName = workInProgress && getComponentName(workInProgress.type) || "Unknown";
                  var dedupeKey = renderingComponentName;
                  if (!didWarnAboutUpdateInRenderForAnotherComponent.has(dedupeKey)) {
                    didWarnAboutUpdateInRenderForAnotherComponent.add(dedupeKey);
                    var setStateComponentName = getComponentName(fiber.type) || "Unknown";
                    error2("Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://fb.me/setstate-in-render", setStateComponentName, renderingComponentName, renderingComponentName);
                  }
                  break;
                }
                case ClassComponent: {
                  if (!didWarnAboutUpdateInRender) {
                    error2("Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state.");
                    didWarnAboutUpdateInRender = true;
                  }
                  break;
                }
              }
            }
          }
        }
        var IsThisRendererActing = {
          current: false
        };
        function warnIfNotScopedWithMatchingAct(fiber) {
          {
            if (IsSomeRendererActing.current === true && IsThisRendererActing.current !== true) {
              error2("It looks like you're using the wrong act() around your test interactions.\nBe sure to use the matching version of act() corresponding to your renderer:\n\n// for react-dom:\nimport {act} from 'react-dom/test-utils';\n// ...\nact(() => ...);\n\n// for react-test-renderer:\nimport TestRenderer from 'react-test-renderer';\nconst {act} = TestRenderer;\n// ...\nact(() => ...);%s", getStackByFiberInDevAndProd(fiber));
            }
          }
        }
        function warnIfNotCurrentlyActingEffectsInDEV(fiber) {
          {
            if ((fiber.mode & StrictMode) !== NoMode && IsSomeRendererActing.current === false && IsThisRendererActing.current === false) {
              error2("An update to %s ran an effect, but was not wrapped in act(...).\n\nWhen testing, code that causes React state updates should be wrapped into act(...):\n\nact(() => {\n  /* fire events that update state */\n});\n/* assert on the output */\n\nThis ensures that you're testing the behavior the user would see in the browser. Learn more at https://fb.me/react-wrap-tests-with-act%s", getComponentName(fiber.type), getStackByFiberInDevAndProd(fiber));
            }
          }
        }
        function warnIfNotCurrentlyActingUpdatesInDEV(fiber) {
          {
            if (executionContext === NoContext && IsSomeRendererActing.current === false && IsThisRendererActing.current === false) {
              error2("An update to %s inside a test was not wrapped in act(...).\n\nWhen testing, code that causes React state updates should be wrapped into act(...):\n\nact(() => {\n  /* fire events that update state */\n});\n/* assert on the output */\n\nThis ensures that you're testing the behavior the user would see in the browser. Learn more at https://fb.me/react-wrap-tests-with-act%s", getComponentName(fiber.type), getStackByFiberInDevAndProd(fiber));
            }
          }
        }
        var warnIfNotCurrentlyActingUpdatesInDev = warnIfNotCurrentlyActingUpdatesInDEV;
        var didWarnAboutUnmockedScheduler = false;
        function warnIfUnmockedScheduler(fiber) {
          {
            if (didWarnAboutUnmockedScheduler === false && Scheduler.unstable_flushAllWithoutAsserting === void 0) {
              if (fiber.mode & BlockingMode || fiber.mode & ConcurrentMode) {
                didWarnAboutUnmockedScheduler = true;
                error2(`In Concurrent or Sync modes, the "scheduler" module needs to be mocked to guarantee consistent behaviour across tests and browsers. For example, with jest: 
jest.mock('scheduler', () => require('scheduler/unstable_mock'));

For more info, visit https://fb.me/react-mock-scheduler`);
              }
            }
          }
        }
        function computeThreadID(root3, expirationTime) {
          return expirationTime * 1e3 + root3.interactionThreadID;
        }
        function markSpawnedWork(expirationTime) {
          if (spawnedWorkDuringRender === null) {
            spawnedWorkDuringRender = [expirationTime];
          } else {
            spawnedWorkDuringRender.push(expirationTime);
          }
        }
        function scheduleInteractions(root3, expirationTime, interactions) {
          if (interactions.size > 0) {
            var pendingInteractionMap = root3.pendingInteractionMap;
            var pendingInteractions = pendingInteractionMap.get(expirationTime);
            if (pendingInteractions != null) {
              interactions.forEach(function(interaction) {
                if (!pendingInteractions.has(interaction)) {
                  interaction.__count++;
                }
                pendingInteractions.add(interaction);
              });
            } else {
              pendingInteractionMap.set(expirationTime, new Set(interactions));
              interactions.forEach(function(interaction) {
                interaction.__count++;
              });
            }
            var subscriber = tracing.__subscriberRef.current;
            if (subscriber !== null) {
              var threadID = computeThreadID(root3, expirationTime);
              subscriber.onWorkScheduled(interactions, threadID);
            }
          }
        }
        function schedulePendingInteractions(root3, expirationTime) {
          scheduleInteractions(root3, expirationTime, tracing.__interactionsRef.current);
        }
        function startWorkOnPendingInteractions(root3, expirationTime) {
          var interactions = /* @__PURE__ */ new Set();
          root3.pendingInteractionMap.forEach(function(scheduledInteractions, scheduledExpirationTime) {
            if (scheduledExpirationTime >= expirationTime) {
              scheduledInteractions.forEach(function(interaction) {
                return interactions.add(interaction);
              });
            }
          });
          root3.memoizedInteractions = interactions;
          if (interactions.size > 0) {
            var subscriber = tracing.__subscriberRef.current;
            if (subscriber !== null) {
              var threadID = computeThreadID(root3, expirationTime);
              try {
                subscriber.onWorkStarted(interactions, threadID);
              } catch (error3) {
                scheduleCallback(ImmediatePriority, function() {
                  throw error3;
                });
              }
            }
          }
        }
        function finishPendingInteractions(root3, committedExpirationTime) {
          var earliestRemainingTimeAfterCommit = root3.firstPendingTime;
          var subscriber;
          try {
            subscriber = tracing.__subscriberRef.current;
            if (subscriber !== null && root3.memoizedInteractions.size > 0) {
              var threadID = computeThreadID(root3, committedExpirationTime);
              subscriber.onWorkStopped(root3.memoizedInteractions, threadID);
            }
          } catch (error3) {
            scheduleCallback(ImmediatePriority, function() {
              throw error3;
            });
          } finally {
            var pendingInteractionMap = root3.pendingInteractionMap;
            pendingInteractionMap.forEach(function(scheduledInteractions, scheduledExpirationTime) {
              if (scheduledExpirationTime > earliestRemainingTimeAfterCommit) {
                pendingInteractionMap.delete(scheduledExpirationTime);
                scheduledInteractions.forEach(function(interaction) {
                  interaction.__count--;
                  if (subscriber !== null && interaction.__count === 0) {
                    try {
                      subscriber.onInteractionScheduledWorkCompleted(interaction);
                    } catch (error3) {
                      scheduleCallback(ImmediatePriority, function() {
                        throw error3;
                      });
                    }
                  }
                });
              }
            });
          }
        }
        var onScheduleFiberRoot = null;
        var onCommitFiberRoot = null;
        var onCommitFiberUnmount = null;
        var hasLoggedError = false;
        var isDevToolsPresent = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined";
        function injectInternals(internals) {
          if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined") {
            return false;
          }
          var hook = __REACT_DEVTOOLS_GLOBAL_HOOK__;
          if (hook.isDisabled) {
            return true;
          }
          if (!hook.supportsFiber) {
            {
              error2("The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://fb.me/react-devtools");
            }
            return true;
          }
          try {
            var rendererID = hook.inject(internals);
            if (true) {
              if (typeof hook.onScheduleFiberRoot === "function") {
                onScheduleFiberRoot = function(root3, children) {
                  try {
                    hook.onScheduleFiberRoot(rendererID, root3, children);
                  } catch (err) {
                    if (!hasLoggedError) {
                      hasLoggedError = true;
                      error2("React instrumentation encountered an error: %s", err);
                    }
                  }
                };
              }
            }
            onCommitFiberRoot = function(root3, expirationTime) {
              try {
                var didError = (root3.current.effectTag & DidCapture) === DidCapture;
                if (enableProfilerTimer) {
                  var currentTime = getCurrentTime();
                  var priorityLevel = inferPriorityFromExpirationTime(currentTime, expirationTime);
                  hook.onCommitFiberRoot(rendererID, root3, priorityLevel, didError);
                } else {
                  hook.onCommitFiberRoot(rendererID, root3, void 0, didError);
                }
              } catch (err) {
                if (true) {
                  if (!hasLoggedError) {
                    hasLoggedError = true;
                    error2("React instrumentation encountered an error: %s", err);
                  }
                }
              }
            };
            onCommitFiberUnmount = function(fiber) {
              try {
                hook.onCommitFiberUnmount(rendererID, fiber);
              } catch (err) {
                if (true) {
                  if (!hasLoggedError) {
                    hasLoggedError = true;
                    error2("React instrumentation encountered an error: %s", err);
                  }
                }
              }
            };
          } catch (err) {
            {
              error2("React instrumentation encountered an error: %s.", err);
            }
          }
          return true;
        }
        function onScheduleRoot(root3, children) {
          if (typeof onScheduleFiberRoot === "function") {
            onScheduleFiberRoot(root3, children);
          }
        }
        function onCommitRoot(root3, expirationTime) {
          if (typeof onCommitFiberRoot === "function") {
            onCommitFiberRoot(root3, expirationTime);
          }
        }
        function onCommitUnmount(fiber) {
          if (typeof onCommitFiberUnmount === "function") {
            onCommitFiberUnmount(fiber);
          }
        }
        var hasBadMapPolyfill;
        {
          hasBadMapPolyfill = false;
          try {
            var nonExtensibleObject = Object.preventExtensions({});
            var testMap = /* @__PURE__ */ new Map([[nonExtensibleObject, null]]);
            var testSet = /* @__PURE__ */ new Set([nonExtensibleObject]);
            testMap.set(0, 0);
            testSet.add(0);
          } catch (e3) {
            hasBadMapPolyfill = true;
          }
        }
        var debugCounter = 1;
        function FiberNode(tag, pendingProps, key2, mode) {
          this.tag = tag;
          this.key = key2;
          this.elementType = null;
          this.type = null;
          this.stateNode = null;
          this.return = null;
          this.child = null;
          this.sibling = null;
          this.index = 0;
          this.ref = null;
          this.pendingProps = pendingProps;
          this.memoizedProps = null;
          this.updateQueue = null;
          this.memoizedState = null;
          this.dependencies = null;
          this.mode = mode;
          this.effectTag = NoEffect;
          this.nextEffect = null;
          this.firstEffect = null;
          this.lastEffect = null;
          this.expirationTime = NoWork;
          this.childExpirationTime = NoWork;
          this.alternate = null;
          {
            this.actualDuration = Number.NaN;
            this.actualStartTime = Number.NaN;
            this.selfBaseDuration = Number.NaN;
            this.treeBaseDuration = Number.NaN;
            this.actualDuration = 0;
            this.actualStartTime = -1;
            this.selfBaseDuration = 0;
            this.treeBaseDuration = 0;
          }
          {
            this._debugID = debugCounter++;
            this._debugIsCurrentlyTiming = false;
          }
          {
            this._debugSource = null;
            this._debugOwner = null;
            this._debugNeedsRemount = false;
            this._debugHookTypes = null;
            if (!hasBadMapPolyfill && typeof Object.preventExtensions === "function") {
              Object.preventExtensions(this);
            }
          }
        }
        var createFiber = function(tag, pendingProps, key2, mode) {
          return new FiberNode(tag, pendingProps, key2, mode);
        };
        function shouldConstruct(Component10) {
          var prototype = Component10.prototype;
          return !!(prototype && prototype.isReactComponent);
        }
        function isSimpleFunctionComponent(type5) {
          return typeof type5 === "function" && !shouldConstruct(type5) && type5.defaultProps === void 0;
        }
        function resolveLazyComponentTag(Component10) {
          if (typeof Component10 === "function") {
            return shouldConstruct(Component10) ? ClassComponent : FunctionComponent;
          } else if (Component10 !== void 0 && Component10 !== null) {
            var $$typeof = Component10.$$typeof;
            if ($$typeof === REACT_FORWARD_REF_TYPE) {
              return ForwardRef2;
            }
            if ($$typeof === REACT_MEMO_TYPE) {
              return MemoComponent;
            }
          }
          return IndeterminateComponent;
        }
        function createWorkInProgress(current3, pendingProps) {
          var workInProgress2 = current3.alternate;
          if (workInProgress2 === null) {
            workInProgress2 = createFiber(current3.tag, pendingProps, current3.key, current3.mode);
            workInProgress2.elementType = current3.elementType;
            workInProgress2.type = current3.type;
            workInProgress2.stateNode = current3.stateNode;
            {
              {
                workInProgress2._debugID = current3._debugID;
              }
              workInProgress2._debugSource = current3._debugSource;
              workInProgress2._debugOwner = current3._debugOwner;
              workInProgress2._debugHookTypes = current3._debugHookTypes;
            }
            workInProgress2.alternate = current3;
            current3.alternate = workInProgress2;
          } else {
            workInProgress2.pendingProps = pendingProps;
            workInProgress2.effectTag = NoEffect;
            workInProgress2.nextEffect = null;
            workInProgress2.firstEffect = null;
            workInProgress2.lastEffect = null;
            {
              workInProgress2.actualDuration = 0;
              workInProgress2.actualStartTime = -1;
            }
          }
          workInProgress2.childExpirationTime = current3.childExpirationTime;
          workInProgress2.expirationTime = current3.expirationTime;
          workInProgress2.child = current3.child;
          workInProgress2.memoizedProps = current3.memoizedProps;
          workInProgress2.memoizedState = current3.memoizedState;
          workInProgress2.updateQueue = current3.updateQueue;
          var currentDependencies = current3.dependencies;
          workInProgress2.dependencies = currentDependencies === null ? null : {
            expirationTime: currentDependencies.expirationTime,
            firstContext: currentDependencies.firstContext,
            responders: currentDependencies.responders
          };
          workInProgress2.sibling = current3.sibling;
          workInProgress2.index = current3.index;
          workInProgress2.ref = current3.ref;
          {
            workInProgress2.selfBaseDuration = current3.selfBaseDuration;
            workInProgress2.treeBaseDuration = current3.treeBaseDuration;
          }
          {
            workInProgress2._debugNeedsRemount = current3._debugNeedsRemount;
            switch (workInProgress2.tag) {
              case IndeterminateComponent:
              case FunctionComponent:
              case SimpleMemoComponent:
                workInProgress2.type = resolveFunctionForHotReloading(current3.type);
                break;
              case ClassComponent:
                workInProgress2.type = resolveClassForHotReloading(current3.type);
                break;
              case ForwardRef2:
                workInProgress2.type = resolveForwardRefForHotReloading(current3.type);
                break;
            }
          }
          return workInProgress2;
        }
        function resetWorkInProgress(workInProgress2, renderExpirationTime2) {
          workInProgress2.effectTag &= Placement;
          workInProgress2.nextEffect = null;
          workInProgress2.firstEffect = null;
          workInProgress2.lastEffect = null;
          var current3 = workInProgress2.alternate;
          if (current3 === null) {
            workInProgress2.childExpirationTime = NoWork;
            workInProgress2.expirationTime = renderExpirationTime2;
            workInProgress2.child = null;
            workInProgress2.memoizedProps = null;
            workInProgress2.memoizedState = null;
            workInProgress2.updateQueue = null;
            workInProgress2.dependencies = null;
            {
              workInProgress2.selfBaseDuration = 0;
              workInProgress2.treeBaseDuration = 0;
            }
          } else {
            workInProgress2.childExpirationTime = current3.childExpirationTime;
            workInProgress2.expirationTime = current3.expirationTime;
            workInProgress2.child = current3.child;
            workInProgress2.memoizedProps = current3.memoizedProps;
            workInProgress2.memoizedState = current3.memoizedState;
            workInProgress2.updateQueue = current3.updateQueue;
            var currentDependencies = current3.dependencies;
            workInProgress2.dependencies = currentDependencies === null ? null : {
              expirationTime: currentDependencies.expirationTime,
              firstContext: currentDependencies.firstContext,
              responders: currentDependencies.responders
            };
            {
              workInProgress2.selfBaseDuration = current3.selfBaseDuration;
              workInProgress2.treeBaseDuration = current3.treeBaseDuration;
            }
          }
          return workInProgress2;
        }
        function createHostRootFiber(tag) {
          var mode;
          if (tag === ConcurrentRoot) {
            mode = ConcurrentMode | BlockingMode | StrictMode;
          } else if (tag === BlockingRoot) {
            mode = BlockingMode | StrictMode;
          } else {
            mode = NoMode;
          }
          if (isDevToolsPresent) {
            mode |= ProfileMode;
          }
          return createFiber(HostRoot, null, null, mode);
        }
        function createFiberFromTypeAndProps(type5, key2, pendingProps, owner, mode, expirationTime) {
          var fiber;
          var fiberTag = IndeterminateComponent;
          var resolvedType = type5;
          if (typeof type5 === "function") {
            if (shouldConstruct(type5)) {
              fiberTag = ClassComponent;
              {
                resolvedType = resolveClassForHotReloading(resolvedType);
              }
            } else {
              {
                resolvedType = resolveFunctionForHotReloading(resolvedType);
              }
            }
          } else if (typeof type5 === "string") {
            fiberTag = HostComponent;
          } else {
            getTag: switch (type5) {
              case REACT_FRAGMENT_TYPE2:
                return createFiberFromFragment(pendingProps.children, mode, expirationTime, key2);
              case REACT_CONCURRENT_MODE_TYPE:
                fiberTag = Mode3;
                mode |= ConcurrentMode | BlockingMode | StrictMode;
                break;
              case REACT_STRICT_MODE_TYPE:
                fiberTag = Mode3;
                mode |= StrictMode;
                break;
              case REACT_PROFILER_TYPE:
                return createFiberFromProfiler(pendingProps, mode, expirationTime, key2);
              case REACT_SUSPENSE_TYPE:
                return createFiberFromSuspense(pendingProps, mode, expirationTime, key2);
              case REACT_SUSPENSE_LIST_TYPE:
                return createFiberFromSuspenseList(pendingProps, mode, expirationTime, key2);
              default: {
                if (typeof type5 === "object" && type5 !== null) {
                  switch (type5.$$typeof) {
                    case REACT_PROVIDER_TYPE:
                      fiberTag = ContextProvider;
                      break getTag;
                    case REACT_CONTEXT_TYPE:
                      fiberTag = ContextConsumer;
                      break getTag;
                    case REACT_FORWARD_REF_TYPE:
                      fiberTag = ForwardRef2;
                      {
                        resolvedType = resolveForwardRefForHotReloading(resolvedType);
                      }
                      break getTag;
                    case REACT_MEMO_TYPE:
                      fiberTag = MemoComponent;
                      break getTag;
                    case REACT_LAZY_TYPE:
                      fiberTag = LazyComponent;
                      resolvedType = null;
                      break getTag;
                    case REACT_BLOCK_TYPE:
                      fiberTag = Block3;
                      break getTag;
                  }
                }
                var info = "";
                {
                  if (type5 === void 0 || typeof type5 === "object" && type5 !== null && Object.keys(type5).length === 0) {
                    info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
                  }
                  var ownerName = owner ? getComponentName(owner.type) : null;
                  if (ownerName) {
                    info += "\n\nCheck the render method of `" + ownerName + "`.";
                  }
                }
                {
                  {
                    throw Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: " + (type5 == null ? type5 : typeof type5) + "." + info);
                  }
                }
              }
            }
          }
          fiber = createFiber(fiberTag, pendingProps, key2, mode);
          fiber.elementType = type5;
          fiber.type = resolvedType;
          fiber.expirationTime = expirationTime;
          return fiber;
        }
        function createFiberFromElement(element, mode, expirationTime) {
          var owner = null;
          {
            owner = element._owner;
          }
          var type5 = element.type;
          var key2 = element.key;
          var pendingProps = element.props;
          var fiber = createFiberFromTypeAndProps(type5, key2, pendingProps, owner, mode, expirationTime);
          {
            fiber._debugSource = element._source;
            fiber._debugOwner = element._owner;
          }
          return fiber;
        }
        function createFiberFromFragment(elements, mode, expirationTime, key2) {
          var fiber = createFiber(Fragment35, elements, key2, mode);
          fiber.expirationTime = expirationTime;
          return fiber;
        }
        function createFiberFromProfiler(pendingProps, mode, expirationTime, key2) {
          {
            if (typeof pendingProps.id !== "string" || typeof pendingProps.onRender !== "function") {
              error2('Profiler must specify an "id" string and "onRender" function as props');
            }
          }
          var fiber = createFiber(Profiler, pendingProps, key2, mode | ProfileMode);
          fiber.elementType = REACT_PROFILER_TYPE;
          fiber.type = REACT_PROFILER_TYPE;
          fiber.expirationTime = expirationTime;
          return fiber;
        }
        function createFiberFromSuspense(pendingProps, mode, expirationTime, key2) {
          var fiber = createFiber(SuspenseComponent, pendingProps, key2, mode);
          fiber.type = REACT_SUSPENSE_TYPE;
          fiber.elementType = REACT_SUSPENSE_TYPE;
          fiber.expirationTime = expirationTime;
          return fiber;
        }
        function createFiberFromSuspenseList(pendingProps, mode, expirationTime, key2) {
          var fiber = createFiber(SuspenseListComponent, pendingProps, key2, mode);
          {
            fiber.type = REACT_SUSPENSE_LIST_TYPE;
          }
          fiber.elementType = REACT_SUSPENSE_LIST_TYPE;
          fiber.expirationTime = expirationTime;
          return fiber;
        }
        function createFiberFromText(content, mode, expirationTime) {
          var fiber = createFiber(HostText, content, null, mode);
          fiber.expirationTime = expirationTime;
          return fiber;
        }
        function createFiberFromHostInstanceForDeletion() {
          var fiber = createFiber(HostComponent, null, null, NoMode);
          fiber.elementType = "DELETED";
          fiber.type = "DELETED";
          return fiber;
        }
        function createFiberFromPortal(portal, mode, expirationTime) {
          var pendingProps = portal.children !== null ? portal.children : [];
          var fiber = createFiber(HostPortal, pendingProps, portal.key, mode);
          fiber.expirationTime = expirationTime;
          fiber.stateNode = {
            containerInfo: portal.containerInfo,
            pendingChildren: null,
            // Used by persistent updates
            implementation: portal.implementation
          };
          return fiber;
        }
        function assignFiberPropertiesInDEV(target, source) {
          if (target === null) {
            target = createFiber(IndeterminateComponent, null, null, NoMode);
          }
          target.tag = source.tag;
          target.key = source.key;
          target.elementType = source.elementType;
          target.type = source.type;
          target.stateNode = source.stateNode;
          target.return = source.return;
          target.child = source.child;
          target.sibling = source.sibling;
          target.index = source.index;
          target.ref = source.ref;
          target.pendingProps = source.pendingProps;
          target.memoizedProps = source.memoizedProps;
          target.updateQueue = source.updateQueue;
          target.memoizedState = source.memoizedState;
          target.dependencies = source.dependencies;
          target.mode = source.mode;
          target.effectTag = source.effectTag;
          target.nextEffect = source.nextEffect;
          target.firstEffect = source.firstEffect;
          target.lastEffect = source.lastEffect;
          target.expirationTime = source.expirationTime;
          target.childExpirationTime = source.childExpirationTime;
          target.alternate = source.alternate;
          {
            target.actualDuration = source.actualDuration;
            target.actualStartTime = source.actualStartTime;
            target.selfBaseDuration = source.selfBaseDuration;
            target.treeBaseDuration = source.treeBaseDuration;
          }
          {
            target._debugID = source._debugID;
          }
          target._debugSource = source._debugSource;
          target._debugOwner = source._debugOwner;
          target._debugIsCurrentlyTiming = source._debugIsCurrentlyTiming;
          target._debugNeedsRemount = source._debugNeedsRemount;
          target._debugHookTypes = source._debugHookTypes;
          return target;
        }
        function FiberRootNode(containerInfo, tag, hydrate2) {
          this.tag = tag;
          this.current = null;
          this.containerInfo = containerInfo;
          this.pendingChildren = null;
          this.pingCache = null;
          this.finishedExpirationTime = NoWork;
          this.finishedWork = null;
          this.timeoutHandle = noTimeout;
          this.context = null;
          this.pendingContext = null;
          this.hydrate = hydrate2;
          this.callbackNode = null;
          this.callbackPriority = NoPriority;
          this.firstPendingTime = NoWork;
          this.firstSuspendedTime = NoWork;
          this.lastSuspendedTime = NoWork;
          this.nextKnownPendingLevel = NoWork;
          this.lastPingedTime = NoWork;
          this.lastExpiredTime = NoWork;
          {
            this.interactionThreadID = tracing.unstable_getThreadID();
            this.memoizedInteractions = /* @__PURE__ */ new Set();
            this.pendingInteractionMap = /* @__PURE__ */ new Map();
          }
        }
        function createFiberRoot(containerInfo, tag, hydrate2, hydrationCallbacks) {
          var root3 = new FiberRootNode(containerInfo, tag, hydrate2);
          var uninitializedFiber = createHostRootFiber(tag);
          root3.current = uninitializedFiber;
          uninitializedFiber.stateNode = root3;
          initializeUpdateQueue(uninitializedFiber);
          return root3;
        }
        function isRootSuspendedAtTime(root3, expirationTime) {
          var firstSuspendedTime = root3.firstSuspendedTime;
          var lastSuspendedTime = root3.lastSuspendedTime;
          return firstSuspendedTime !== NoWork && firstSuspendedTime >= expirationTime && lastSuspendedTime <= expirationTime;
        }
        function markRootSuspendedAtTime(root3, expirationTime) {
          var firstSuspendedTime = root3.firstSuspendedTime;
          var lastSuspendedTime = root3.lastSuspendedTime;
          if (firstSuspendedTime < expirationTime) {
            root3.firstSuspendedTime = expirationTime;
          }
          if (lastSuspendedTime > expirationTime || firstSuspendedTime === NoWork) {
            root3.lastSuspendedTime = expirationTime;
          }
          if (expirationTime <= root3.lastPingedTime) {
            root3.lastPingedTime = NoWork;
          }
          if (expirationTime <= root3.lastExpiredTime) {
            root3.lastExpiredTime = NoWork;
          }
        }
        function markRootUpdatedAtTime(root3, expirationTime) {
          var firstPendingTime = root3.firstPendingTime;
          if (expirationTime > firstPendingTime) {
            root3.firstPendingTime = expirationTime;
          }
          var firstSuspendedTime = root3.firstSuspendedTime;
          if (firstSuspendedTime !== NoWork) {
            if (expirationTime >= firstSuspendedTime) {
              root3.firstSuspendedTime = root3.lastSuspendedTime = root3.nextKnownPendingLevel = NoWork;
            } else if (expirationTime >= root3.lastSuspendedTime) {
              root3.lastSuspendedTime = expirationTime + 1;
            }
            if (expirationTime > root3.nextKnownPendingLevel) {
              root3.nextKnownPendingLevel = expirationTime;
            }
          }
        }
        function markRootFinishedAtTime(root3, finishedExpirationTime, remainingExpirationTime) {
          root3.firstPendingTime = remainingExpirationTime;
          if (finishedExpirationTime <= root3.lastSuspendedTime) {
            root3.firstSuspendedTime = root3.lastSuspendedTime = root3.nextKnownPendingLevel = NoWork;
          } else if (finishedExpirationTime <= root3.firstSuspendedTime) {
            root3.firstSuspendedTime = finishedExpirationTime - 1;
          }
          if (finishedExpirationTime <= root3.lastPingedTime) {
            root3.lastPingedTime = NoWork;
          }
          if (finishedExpirationTime <= root3.lastExpiredTime) {
            root3.lastExpiredTime = NoWork;
          }
        }
        function markRootExpiredAtTime(root3, expirationTime) {
          var lastExpiredTime = root3.lastExpiredTime;
          if (lastExpiredTime === NoWork || lastExpiredTime > expirationTime) {
            root3.lastExpiredTime = expirationTime;
          }
        }
        var didWarnAboutNestedUpdates;
        var didWarnAboutFindNodeInStrictMode;
        {
          didWarnAboutNestedUpdates = false;
          didWarnAboutFindNodeInStrictMode = {};
        }
        function getContextForSubtree(parentComponent) {
          if (!parentComponent) {
            return emptyContextObject;
          }
          var fiber = get3(parentComponent);
          var parentContext = findCurrentUnmaskedContext(fiber);
          if (fiber.tag === ClassComponent) {
            var Component10 = fiber.type;
            if (isContextProvider(Component10)) {
              return processChildContext(fiber, Component10, parentContext);
            }
          }
          return parentContext;
        }
        function findHostInstanceWithWarning(component, methodName) {
          {
            var fiber = get3(component);
            if (fiber === void 0) {
              if (typeof component.render === "function") {
                {
                  {
                    throw Error("Unable to find node on an unmounted component.");
                  }
                }
              } else {
                {
                  {
                    throw Error("Argument appears to not be a ReactComponent. Keys: " + Object.keys(component));
                  }
                }
              }
            }
            var hostFiber = findCurrentHostFiber(fiber);
            if (hostFiber === null) {
              return null;
            }
            if (hostFiber.mode & StrictMode) {
              var componentName = getComponentName(fiber.type) || "Component";
              if (!didWarnAboutFindNodeInStrictMode[componentName]) {
                didWarnAboutFindNodeInStrictMode[componentName] = true;
                if (fiber.mode & StrictMode) {
                  error2("%s is deprecated in StrictMode. %s was passed an instance of %s which is inside StrictMode. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://fb.me/react-strict-mode-find-node%s", methodName, methodName, componentName, getStackByFiberInDevAndProd(hostFiber));
                } else {
                  error2("%s is deprecated in StrictMode. %s was passed an instance of %s which renders StrictMode children. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://fb.me/react-strict-mode-find-node%s", methodName, methodName, componentName, getStackByFiberInDevAndProd(hostFiber));
                }
              }
            }
            return hostFiber.stateNode;
          }
        }
        function createContainer(containerInfo, tag, hydrate2, hydrationCallbacks) {
          return createFiberRoot(containerInfo, tag, hydrate2);
        }
        function updateContainer(element, container, parentComponent, callback) {
          {
            onScheduleRoot(container, element);
          }
          var current$1 = container.current;
          var currentTime = requestCurrentTimeForUpdate();
          {
            if ("undefined" !== typeof jest) {
              warnIfUnmockedScheduler(current$1);
              warnIfNotScopedWithMatchingAct(current$1);
            }
          }
          var suspenseConfig = requestCurrentSuspenseConfig();
          var expirationTime = computeExpirationForFiber(currentTime, current$1, suspenseConfig);
          var context = getContextForSubtree(parentComponent);
          if (container.context === null) {
            container.context = context;
          } else {
            container.pendingContext = context;
          }
          {
            if (isRendering && current2 !== null && !didWarnAboutNestedUpdates) {
              didWarnAboutNestedUpdates = true;
              error2("Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.\n\nCheck the render method of %s.", getComponentName(current2.type) || "Unknown");
            }
          }
          var update = createUpdate(expirationTime, suspenseConfig);
          update.payload = {
            element
          };
          callback = callback === void 0 ? null : callback;
          if (callback !== null) {
            {
              if (typeof callback !== "function") {
                error2("render(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callback);
              }
            }
            update.callback = callback;
          }
          enqueueUpdate(current$1, update);
          scheduleWork(current$1, expirationTime);
          return expirationTime;
        }
        function getPublicRootInstance(container) {
          var containerFiber = container.current;
          if (!containerFiber.child) {
            return null;
          }
          switch (containerFiber.child.tag) {
            case HostComponent:
              return getPublicInstance(containerFiber.child.stateNode);
            default:
              return containerFiber.child.stateNode;
          }
        }
        function markRetryTimeImpl(fiber, retryTime) {
          var suspenseState = fiber.memoizedState;
          if (suspenseState !== null && suspenseState.dehydrated !== null) {
            if (suspenseState.retryTime < retryTime) {
              suspenseState.retryTime = retryTime;
            }
          }
        }
        function markRetryTimeIfNotHydrated(fiber, retryTime) {
          markRetryTimeImpl(fiber, retryTime);
          var alternate = fiber.alternate;
          if (alternate) {
            markRetryTimeImpl(alternate, retryTime);
          }
        }
        function attemptUserBlockingHydration$1(fiber) {
          if (fiber.tag !== SuspenseComponent) {
            return;
          }
          var expTime = computeInteractiveExpiration(requestCurrentTimeForUpdate());
          scheduleWork(fiber, expTime);
          markRetryTimeIfNotHydrated(fiber, expTime);
        }
        function attemptContinuousHydration$1(fiber) {
          if (fiber.tag !== SuspenseComponent) {
            return;
          }
          scheduleWork(fiber, ContinuousHydration);
          markRetryTimeIfNotHydrated(fiber, ContinuousHydration);
        }
        function attemptHydrationAtCurrentPriority$1(fiber) {
          if (fiber.tag !== SuspenseComponent) {
            return;
          }
          var currentTime = requestCurrentTimeForUpdate();
          var expTime = computeExpirationForFiber(currentTime, fiber, null);
          scheduleWork(fiber, expTime);
          markRetryTimeIfNotHydrated(fiber, expTime);
        }
        function findHostInstanceWithNoPortals(fiber) {
          var hostFiber = findCurrentHostFiberWithNoPortals(fiber);
          if (hostFiber === null) {
            return null;
          }
          if (hostFiber.tag === FundamentalComponent) {
            return hostFiber.stateNode.instance;
          }
          return hostFiber.stateNode;
        }
        var shouldSuspendImpl = function(fiber) {
          return false;
        };
        function shouldSuspend(fiber) {
          return shouldSuspendImpl(fiber);
        }
        var overrideHookState = null;
        var overrideProps = null;
        var scheduleUpdate = null;
        var setSuspenseHandler = null;
        {
          var copyWithSetImpl = function(obj, path2, idx, value) {
            if (idx >= path2.length) {
              return value;
            }
            var key2 = path2[idx];
            var updated = Array.isArray(obj) ? obj.slice() : _assign({}, obj);
            updated[key2] = copyWithSetImpl(obj[key2], path2, idx + 1, value);
            return updated;
          };
          var copyWithSet = function(obj, path2, value) {
            return copyWithSetImpl(obj, path2, 0, value);
          };
          overrideHookState = function(fiber, id, path2, value) {
            var currentHook2 = fiber.memoizedState;
            while (currentHook2 !== null && id > 0) {
              currentHook2 = currentHook2.next;
              id--;
            }
            if (currentHook2 !== null) {
              var newState = copyWithSet(currentHook2.memoizedState, path2, value);
              currentHook2.memoizedState = newState;
              currentHook2.baseState = newState;
              fiber.memoizedProps = _assign({}, fiber.memoizedProps);
              scheduleWork(fiber, Sync);
            }
          };
          overrideProps = function(fiber, path2, value) {
            fiber.pendingProps = copyWithSet(fiber.memoizedProps, path2, value);
            if (fiber.alternate) {
              fiber.alternate.pendingProps = fiber.pendingProps;
            }
            scheduleWork(fiber, Sync);
          };
          scheduleUpdate = function(fiber) {
            scheduleWork(fiber, Sync);
          };
          setSuspenseHandler = function(newShouldSuspendImpl) {
            shouldSuspendImpl = newShouldSuspendImpl;
          };
        }
        function injectIntoDevTools(devToolsConfig) {
          var findFiberByHostInstance = devToolsConfig.findFiberByHostInstance;
          var ReactCurrentDispatcher2 = ReactSharedInternals.ReactCurrentDispatcher;
          return injectInternals(_assign({}, devToolsConfig, {
            overrideHookState,
            overrideProps,
            setSuspenseHandler,
            scheduleUpdate,
            currentDispatcherRef: ReactCurrentDispatcher2,
            findHostInstanceByFiber: function(fiber) {
              var hostFiber = findCurrentHostFiber(fiber);
              if (hostFiber === null) {
                return null;
              }
              return hostFiber.stateNode;
            },
            findFiberByHostInstance: function(instance) {
              if (!findFiberByHostInstance) {
                return null;
              }
              return findFiberByHostInstance(instance);
            },
            // React Refresh
            findHostInstancesForRefresh,
            scheduleRefresh,
            scheduleRoot,
            setRefreshHandler,
            // Enables DevTools to append owner stacks to error messages in DEV mode.
            getCurrentFiber: function() {
              return current2;
            }
          }));
        }
        var IsSomeRendererActing$1 = ReactSharedInternals.IsSomeRendererActing;
        function ReactDOMRoot(container, options) {
          this._internalRoot = createRootImpl(container, ConcurrentRoot, options);
        }
        function ReactDOMBlockingRoot(container, tag, options) {
          this._internalRoot = createRootImpl(container, tag, options);
        }
        ReactDOMRoot.prototype.render = ReactDOMBlockingRoot.prototype.render = function(children) {
          var root3 = this._internalRoot;
          {
            if (typeof arguments[1] === "function") {
              error2("render(...): does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
            }
            var container = root3.containerInfo;
            if (container.nodeType !== COMMENT_NODE) {
              var hostInstance = findHostInstanceWithNoPortals(root3.current);
              if (hostInstance) {
                if (hostInstance.parentNode !== container) {
                  error2("render(...): It looks like the React-rendered content of the root container was removed without using React. This is not supported and will cause errors. Instead, call root.unmount() to empty a root's container.");
                }
              }
            }
          }
          updateContainer(children, root3, null, null);
        };
        ReactDOMRoot.prototype.unmount = ReactDOMBlockingRoot.prototype.unmount = function() {
          {
            if (typeof arguments[0] === "function") {
              error2("unmount(...): does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
            }
          }
          var root3 = this._internalRoot;
          var container = root3.containerInfo;
          updateContainer(null, root3, null, function() {
            unmarkContainerAsRoot(container);
          });
        };
        function createRootImpl(container, tag, options) {
          var hydrate2 = options != null && options.hydrate === true;
          var hydrationCallbacks = options != null && options.hydrationOptions || null;
          var root3 = createContainer(container, tag, hydrate2);
          markContainerAsRoot(root3.current, container);
          if (hydrate2 && tag !== LegacyRoot) {
            var doc2 = container.nodeType === DOCUMENT_NODE ? container : container.ownerDocument;
            eagerlyTrapReplayableEvents(container, doc2);
          }
          return root3;
        }
        function createLegacyRoot(container, options) {
          return new ReactDOMBlockingRoot(container, LegacyRoot, options);
        }
        function isValidContainer(node2) {
          return !!(node2 && (node2.nodeType === ELEMENT_NODE || node2.nodeType === DOCUMENT_NODE || node2.nodeType === DOCUMENT_FRAGMENT_NODE || node2.nodeType === COMMENT_NODE && node2.nodeValue === " react-mount-point-unstable "));
        }
        var ReactCurrentOwner$3 = ReactSharedInternals.ReactCurrentOwner;
        var topLevelUpdateWarnings;
        var warnedAboutHydrateAPI = false;
        {
          topLevelUpdateWarnings = function(container) {
            if (container._reactRootContainer && container.nodeType !== COMMENT_NODE) {
              var hostInstance = findHostInstanceWithNoPortals(container._reactRootContainer._internalRoot.current);
              if (hostInstance) {
                if (hostInstance.parentNode !== container) {
                  error2("render(...): It looks like the React-rendered content of this container was removed without using React. This is not supported and will cause errors. Instead, call ReactDOM.unmountComponentAtNode to empty a container.");
                }
              }
            }
            var isRootRenderedBySomeReact = !!container._reactRootContainer;
            var rootEl = getReactRootElementInContainer(container);
            var hasNonRootReactChild = !!(rootEl && getInstanceFromNode$1(rootEl));
            if (hasNonRootReactChild && !isRootRenderedBySomeReact) {
              error2("render(...): Replacing React-rendered children with a new root component. If you intended to update the children of this node, you should instead have the existing children update their state and render the new components instead of calling ReactDOM.render.");
            }
            if (container.nodeType === ELEMENT_NODE && container.tagName && container.tagName.toUpperCase() === "BODY") {
              error2("render(): Rendering components directly into document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try rendering into a container element created for your app.");
            }
          };
        }
        function getReactRootElementInContainer(container) {
          if (!container) {
            return null;
          }
          if (container.nodeType === DOCUMENT_NODE) {
            return container.documentElement;
          } else {
            return container.firstChild;
          }
        }
        function shouldHydrateDueToLegacyHeuristic(container) {
          var rootElement = getReactRootElementInContainer(container);
          return !!(rootElement && rootElement.nodeType === ELEMENT_NODE && rootElement.hasAttribute(ROOT_ATTRIBUTE_NAME));
        }
        function legacyCreateRootFromDOMContainer(container, forceHydrate) {
          var shouldHydrate = forceHydrate || shouldHydrateDueToLegacyHeuristic(container);
          if (!shouldHydrate) {
            var warned2 = false;
            var rootSibling;
            while (rootSibling = container.lastChild) {
              {
                if (!warned2 && rootSibling.nodeType === ELEMENT_NODE && rootSibling.hasAttribute(ROOT_ATTRIBUTE_NAME)) {
                  warned2 = true;
                  error2("render(): Target node has markup rendered by React, but there are unrelated nodes as well. This is most commonly caused by white-space inserted around server-rendered markup.");
                }
              }
              container.removeChild(rootSibling);
            }
          }
          {
            if (shouldHydrate && !forceHydrate && !warnedAboutHydrateAPI) {
              warnedAboutHydrateAPI = true;
              warn("render(): Calling ReactDOM.render() to hydrate server-rendered markup will stop working in React v17. Replace the ReactDOM.render() call with ReactDOM.hydrate() if you want React to attach to the server HTML.");
            }
          }
          return createLegacyRoot(container, shouldHydrate ? {
            hydrate: true
          } : void 0);
        }
        function warnOnInvalidCallback$1(callback, callerName) {
          {
            if (callback !== null && typeof callback !== "function") {
              error2("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callerName, callback);
            }
          }
        }
        function legacyRenderSubtreeIntoContainer(parentComponent, children, container, forceHydrate, callback) {
          {
            topLevelUpdateWarnings(container);
            warnOnInvalidCallback$1(callback === void 0 ? null : callback, "render");
          }
          var root3 = container._reactRootContainer;
          var fiberRoot;
          if (!root3) {
            root3 = container._reactRootContainer = legacyCreateRootFromDOMContainer(container, forceHydrate);
            fiberRoot = root3._internalRoot;
            if (typeof callback === "function") {
              var originalCallback = callback;
              callback = function() {
                var instance = getPublicRootInstance(fiberRoot);
                originalCallback.call(instance);
              };
            }
            unbatchedUpdates(function() {
              updateContainer(children, fiberRoot, parentComponent, callback);
            });
          } else {
            fiberRoot = root3._internalRoot;
            if (typeof callback === "function") {
              var _originalCallback = callback;
              callback = function() {
                var instance = getPublicRootInstance(fiberRoot);
                _originalCallback.call(instance);
              };
            }
            updateContainer(children, fiberRoot, parentComponent, callback);
          }
          return getPublicRootInstance(fiberRoot);
        }
        function findDOMNode2(componentOrElement) {
          {
            var owner = ReactCurrentOwner$3.current;
            if (owner !== null && owner.stateNode !== null) {
              var warnedAboutRefsInRender = owner.stateNode._warnedAboutRefsInRender;
              if (!warnedAboutRefsInRender) {
                error2("%s is accessing findDOMNode inside its render(). render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", getComponentName(owner.type) || "A component");
              }
              owner.stateNode._warnedAboutRefsInRender = true;
            }
          }
          if (componentOrElement == null) {
            return null;
          }
          if (componentOrElement.nodeType === ELEMENT_NODE) {
            return componentOrElement;
          }
          {
            return findHostInstanceWithWarning(componentOrElement, "findDOMNode");
          }
        }
        function hydrate(element, container, callback) {
          if (!isValidContainer(container)) {
            {
              throw Error("Target container is not a DOM element.");
            }
          }
          {
            var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === void 0;
            if (isModernRoot) {
              error2("You are calling ReactDOM.hydrate() on a container that was previously passed to ReactDOM.createRoot(). This is not supported. Did you mean to call createRoot(container, {hydrate: true}).render(element)?");
            }
          }
          return legacyRenderSubtreeIntoContainer(null, element, container, true, callback);
        }
        function render4(element, container, callback) {
          if (!isValidContainer(container)) {
            {
              throw Error("Target container is not a DOM element.");
            }
          }
          {
            var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === void 0;
            if (isModernRoot) {
              error2("You are calling ReactDOM.render() on a container that was previously passed to ReactDOM.createRoot(). This is not supported. Did you mean to call root.render(element)?");
            }
          }
          return legacyRenderSubtreeIntoContainer(null, element, container, false, callback);
        }
        function unstable_renderSubtreeIntoContainer(parentComponent, element, containerNode, callback) {
          if (!isValidContainer(containerNode)) {
            {
              throw Error("Target container is not a DOM element.");
            }
          }
          if (!(parentComponent != null && has2(parentComponent))) {
            {
              throw Error("parentComponent must be a valid React Component");
            }
          }
          return legacyRenderSubtreeIntoContainer(parentComponent, element, containerNode, false, callback);
        }
        function unmountComponentAtNode2(container) {
          if (!isValidContainer(container)) {
            {
              throw Error("unmountComponentAtNode(...): Target container is not a DOM element.");
            }
          }
          {
            var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === void 0;
            if (isModernRoot) {
              error2("You are calling ReactDOM.unmountComponentAtNode() on a container that was previously passed to ReactDOM.createRoot(). This is not supported. Did you mean to call root.unmount()?");
            }
          }
          if (container._reactRootContainer) {
            {
              var rootEl = getReactRootElementInContainer(container);
              var renderedByDifferentReact = rootEl && !getInstanceFromNode$1(rootEl);
              if (renderedByDifferentReact) {
                error2("unmountComponentAtNode(): The node you're attempting to unmount was rendered by another copy of React.");
              }
            }
            unbatchedUpdates(function() {
              legacyRenderSubtreeIntoContainer(null, null, container, false, function() {
                container._reactRootContainer = null;
                unmarkContainerAsRoot(container);
              });
            });
            return true;
          } else {
            {
              var _rootEl = getReactRootElementInContainer(container);
              var hasNonRootReactChild = !!(_rootEl && getInstanceFromNode$1(_rootEl));
              var isContainerReactRoot = container.nodeType === ELEMENT_NODE && isValidContainer(container.parentNode) && !!container.parentNode._reactRootContainer;
              if (hasNonRootReactChild) {
                error2("unmountComponentAtNode(): The node you're attempting to unmount was rendered by React and is not a top-level container. %s", isContainerReactRoot ? "You may have accidentally passed in a React root node instead of its container." : "Instead, have the parent component update its state and rerender in order to remove this component.");
              }
            }
            return false;
          }
        }
        function createPortal5(children, containerInfo, implementation) {
          var key2 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
          return {
            // This tag allow us to uniquely identify this as a React Portal
            $$typeof: REACT_PORTAL_TYPE,
            key: key2 == null ? null : "" + key2,
            children,
            containerInfo,
            implementation
          };
        }
        var ReactVersion = "16.14.0";
        setAttemptUserBlockingHydration(attemptUserBlockingHydration$1);
        setAttemptContinuousHydration(attemptContinuousHydration$1);
        setAttemptHydrationAtCurrentPriority(attemptHydrationAtCurrentPriority$1);
        var didWarnAboutUnstableCreatePortal = false;
        {
          if (typeof Map !== "function" || // $FlowIssue Flow incorrectly thinks Map has no prototype
          Map.prototype == null || typeof Map.prototype.forEach !== "function" || typeof Set !== "function" || // $FlowIssue Flow incorrectly thinks Set has no prototype
          Set.prototype == null || typeof Set.prototype.clear !== "function" || typeof Set.prototype.forEach !== "function") {
            error2("React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
          }
        }
        setRestoreImplementation(restoreControlledState$3);
        setBatchingImplementation(batchedUpdates$1, discreteUpdates$1, flushDiscreteUpdates, batchedEventUpdates$1);
        function createPortal$1(children, container) {
          var key2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
          if (!isValidContainer(container)) {
            {
              throw Error("Target container is not a DOM element.");
            }
          }
          return createPortal5(children, container, null, key2);
        }
        function renderSubtreeIntoContainer(parentComponent, element, containerNode, callback) {
          return unstable_renderSubtreeIntoContainer(parentComponent, element, containerNode, callback);
        }
        function unstable_createPortal(children, container) {
          var key2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
          {
            if (!didWarnAboutUnstableCreatePortal) {
              didWarnAboutUnstableCreatePortal = true;
              warn('The ReactDOM.unstable_createPortal() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactDOM.createPortal() instead. It has the exact same API, but without the "unstable_" prefix.');
            }
          }
          return createPortal$1(children, container, key2);
        }
        var Internals = {
          // Keep in sync with ReactDOMUnstableNativeDependencies.js
          // ReactTestUtils.js, and ReactTestUtilsAct.js. This is an array for better minification.
          Events: [getInstanceFromNode$1, getNodeFromInstance$1, getFiberCurrentPropsFromNode$1, injectEventPluginsByName, eventNameDispatchConfigs, accumulateTwoPhaseDispatches, accumulateDirectDispatches, enqueueStateRestore, restoreStateIfNeeded, dispatchEvent, runEventsInBatch, flushPassiveEffects, IsThisRendererActing]
        };
        var foundDevTools = injectIntoDevTools({
          findFiberByHostInstance: getClosestInstanceFromNode,
          bundleType: 1,
          version: ReactVersion,
          rendererPackageName: "react-dom"
        });
        {
          if (!foundDevTools && canUseDOM2 && window.top === window.self) {
            if (navigator.userAgent.indexOf("Chrome") > -1 && navigator.userAgent.indexOf("Edge") === -1 || navigator.userAgent.indexOf("Firefox") > -1) {
              var protocol = window.location.protocol;
              if (/^(https?|file):$/.test(protocol)) {
                console.info("%cDownload the React DevTools for a better development experience: https://fb.me/react-devtools" + (protocol === "file:" ? "\nYou might need to use a local HTTP server (instead of file://): https://fb.me/react-devtools-faq" : ""), "font-weight:bold");
              }
            }
          }
        }
        exports2.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = Internals;
        exports2.createPortal = createPortal$1;
        exports2.findDOMNode = findDOMNode2;
        exports2.flushSync = flushSync5;
        exports2.hydrate = hydrate;
        exports2.render = render4;
        exports2.unmountComponentAtNode = unmountComponentAtNode2;
        exports2.unstable_batchedUpdates = batchedUpdates$1;
        exports2.unstable_createPortal = unstable_createPortal;
        exports2.unstable_renderSubtreeIntoContainer = renderSubtreeIntoContainer;
        exports2.version = ReactVersion;
      })();
    }
  }
});

// ../../node_modules/react-dom/index.js
var require_react_dom = __commonJS({
  "../../node_modules/react-dom/index.js"(exports2, module2) {
    "use strict";
    if (false) {
      checkDCE();
      module2.exports = null;
    } else {
      module2.exports = require_react_dom_development();
    }
  }
});

// ../../node_modules/base64-js/index.js
var require_base64_js = __commonJS({
  "../../node_modules/base64-js/index.js"(exports2) {
    "use strict";
    exports2.byteLength = byteLength2;
    exports2.toByteArray = toByteArray;
    exports2.fromByteArray = fromByteArray;
    var lookup = [];
    var revLookup = [];
    var Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
    var code2 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    for (i = 0, len = code2.length; i < len; ++i) {
      lookup[i] = code2[i];
      revLookup[code2.charCodeAt(i)] = i;
    }
    var i;
    var len;
    revLookup["-".charCodeAt(0)] = 62;
    revLookup["_".charCodeAt(0)] = 63;
    function getLens(b64) {
      var len2 = b64.length;
      if (len2 % 4 > 0) {
        throw new Error("Invalid string. Length must be a multiple of 4");
      }
      var validLen = b64.indexOf("=");
      if (validLen === -1) validLen = len2;
      var placeHoldersLen = validLen === len2 ? 0 : 4 - validLen % 4;
      return [validLen, placeHoldersLen];
    }
    function byteLength2(b64) {
      var lens = getLens(b64);
      var validLen = lens[0];
      var placeHoldersLen = lens[1];
      return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
    }
    function _byteLength(b64, validLen, placeHoldersLen) {
      return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
    }
    function toByteArray(b64) {
      var tmp;
      var lens = getLens(b64);
      var validLen = lens[0];
      var placeHoldersLen = lens[1];
      var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
      var curByte = 0;
      var len2 = placeHoldersLen > 0 ? validLen - 4 : validLen;
      var i2;
      for (i2 = 0; i2 < len2; i2 += 4) {
        tmp = revLookup[b64.charCodeAt(i2)] << 18 | revLookup[b64.charCodeAt(i2 + 1)] << 12 | revLookup[b64.charCodeAt(i2 + 2)] << 6 | revLookup[b64.charCodeAt(i2 + 3)];
        arr[curByte++] = tmp >> 16 & 255;
        arr[curByte++] = tmp >> 8 & 255;
        arr[curByte++] = tmp & 255;
      }
      if (placeHoldersLen === 2) {
        tmp = revLookup[b64.charCodeAt(i2)] << 2 | revLookup[b64.charCodeAt(i2 + 1)] >> 4;
        arr[curByte++] = tmp & 255;
      }
      if (placeHoldersLen === 1) {
        tmp = revLookup[b64.charCodeAt(i2)] << 10 | revLookup[b64.charCodeAt(i2 + 1)] << 4 | revLookup[b64.charCodeAt(i2 + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 255;
        arr[curByte++] = tmp & 255;
      }
      return arr;
    }
    function tripletToBase64(num) {
      return lookup[num >> 18 & 63] + lookup[num >> 12 & 63] + lookup[num >> 6 & 63] + lookup[num & 63];
    }
    function encodeChunk(uint82, start, end) {
      var tmp;
      var output = [];
      for (var i2 = start; i2 < end; i2 += 3) {
        tmp = (uint82[i2] << 16 & 16711680) + (uint82[i2 + 1] << 8 & 65280) + (uint82[i2 + 2] & 255);
        output.push(tripletToBase64(tmp));
      }
      return output.join("");
    }
    function fromByteArray(uint82) {
      var tmp;
      var len2 = uint82.length;
      var extraBytes = len2 % 3;
      var parts = [];
      var maxChunkLength = 16383;
      for (var i2 = 0, len22 = len2 - extraBytes; i2 < len22; i2 += maxChunkLength) {
        parts.push(encodeChunk(uint82, i2, i2 + maxChunkLength > len22 ? len22 : i2 + maxChunkLength));
      }
      if (extraBytes === 1) {
        tmp = uint82[len2 - 1];
        parts.push(
          lookup[tmp >> 2] + lookup[tmp << 4 & 63] + "=="
        );
      } else if (extraBytes === 2) {
        tmp = (uint82[len2 - 2] << 8) + uint82[len2 - 1];
        parts.push(
          lookup[tmp >> 10] + lookup[tmp >> 4 & 63] + lookup[tmp << 2 & 63] + "="
        );
      }
      return parts.join("");
    }
  }
});

// ../../node_modules/ieee754/index.js
var require_ieee754 = __commonJS({
  "../../node_modules/ieee754/index.js"(exports2) {
    exports2.read = function(buffer, offset4, isLE, mLen, nBytes) {
      var e3, m;
      var eLen = nBytes * 8 - mLen - 1;
      var eMax = (1 << eLen) - 1;
      var eBias = eMax >> 1;
      var nBits = -7;
      var i = isLE ? nBytes - 1 : 0;
      var d = isLE ? -1 : 1;
      var s = buffer[offset4 + i];
      i += d;
      e3 = s & (1 << -nBits) - 1;
      s >>= -nBits;
      nBits += eLen;
      for (; nBits > 0; e3 = e3 * 256 + buffer[offset4 + i], i += d, nBits -= 8) {
      }
      m = e3 & (1 << -nBits) - 1;
      e3 >>= -nBits;
      nBits += mLen;
      for (; nBits > 0; m = m * 256 + buffer[offset4 + i], i += d, nBits -= 8) {
      }
      if (e3 === 0) {
        e3 = 1 - eBias;
      } else if (e3 === eMax) {
        return m ? NaN : (s ? -1 : 1) * Infinity;
      } else {
        m = m + Math.pow(2, mLen);
        e3 = e3 - eBias;
      }
      return (s ? -1 : 1) * m * Math.pow(2, e3 - mLen);
    };
    exports2.write = function(buffer, value, offset4, isLE, mLen, nBytes) {
      var e3, m, c;
      var eLen = nBytes * 8 - mLen - 1;
      var eMax = (1 << eLen) - 1;
      var eBias = eMax >> 1;
      var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
      var i = isLE ? 0 : nBytes - 1;
      var d = isLE ? 1 : -1;
      var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
      value = Math.abs(value);
      if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e3 = eMax;
      } else {
        e3 = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e3)) < 1) {
          e3--;
          c *= 2;
        }
        if (e3 + eBias >= 1) {
          value += rt / c;
        } else {
          value += rt * Math.pow(2, 1 - eBias);
        }
        if (value * c >= 2) {
          e3++;
          c /= 2;
        }
        if (e3 + eBias >= eMax) {
          m = 0;
          e3 = eMax;
        } else if (e3 + eBias >= 1) {
          m = (value * c - 1) * Math.pow(2, mLen);
          e3 = e3 + eBias;
        } else {
          m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
          e3 = 0;
        }
      }
      for (; mLen >= 8; buffer[offset4 + i] = m & 255, i += d, m /= 256, mLen -= 8) {
      }
      e3 = e3 << mLen | m;
      eLen += mLen;
      for (; eLen > 0; buffer[offset4 + i] = e3 & 255, i += d, e3 /= 256, eLen -= 8) {
      }
      buffer[offset4 + i - d] |= s * 128;
    };
  }
});

// ../../node_modules/buffer/index.js
var require_buffer = __commonJS({
  "../../node_modules/buffer/index.js"(exports2) {
    "use strict";
    var base64 = require_base64_js();
    var ieee754 = require_ieee754();
    var customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" ? Symbol["for"]("nodejs.util.inspect.custom") : null;
    exports2.Buffer = Buffer6;
    exports2.SlowBuffer = SlowBuffer;
    exports2.INSPECT_MAX_BYTES = 50;
    var K_MAX_LENGTH = 2147483647;
    exports2.kMaxLength = K_MAX_LENGTH;
    Buffer6.TYPED_ARRAY_SUPPORT = typedArraySupport();
    if (!Buffer6.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") {
      console.error(
        "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
      );
    }
    function typedArraySupport() {
      try {
        const arr = new Uint8Array(1);
        const proto = { foo: function() {
          return 42;
        } };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
      } catch (e3) {
        return false;
      }
    }
    Object.defineProperty(Buffer6.prototype, "parent", {
      enumerable: true,
      get: function() {
        if (!Buffer6.isBuffer(this)) return void 0;
        return this.buffer;
      }
    });
    Object.defineProperty(Buffer6.prototype, "offset", {
      enumerable: true,
      get: function() {
        if (!Buffer6.isBuffer(this)) return void 0;
        return this.byteOffset;
      }
    });
    function createBuffer(length2) {
      if (length2 > K_MAX_LENGTH) {
        throw new RangeError('The value "' + length2 + '" is invalid for option "size"');
      }
      const buf = new Uint8Array(length2);
      Object.setPrototypeOf(buf, Buffer6.prototype);
      return buf;
    }
    function Buffer6(arg, encodingOrOffset, length2) {
      if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") {
          throw new TypeError(
            'The "string" argument must be of type string. Received type number'
          );
        }
        return allocUnsafe2(arg);
      }
      return from2(arg, encodingOrOffset, length2);
    }
    Buffer6.poolSize = 8192;
    function from2(value, encodingOrOffset, length2) {
      if (typeof value === "string") {
        return fromString(value, encodingOrOffset);
      }
      if (ArrayBuffer.isView(value)) {
        return fromArrayView(value);
      }
      if (value == null) {
        throw new TypeError(
          "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value
        );
      }
      if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) {
        return fromArrayBuffer(value, encodingOrOffset, length2);
      }
      if (typeof SharedArrayBuffer !== "undefined" && (isInstance(value, SharedArrayBuffer) || value && isInstance(value.buffer, SharedArrayBuffer))) {
        return fromArrayBuffer(value, encodingOrOffset, length2);
      }
      if (typeof value === "number") {
        throw new TypeError(
          'The "value" argument must not be of type number. Received type number'
        );
      }
      const valueOf = value.valueOf && value.valueOf();
      if (valueOf != null && valueOf !== value) {
        return Buffer6.from(valueOf, encodingOrOffset, length2);
      }
      const b = fromObject(value);
      if (b) return b;
      if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") {
        return Buffer6.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length2);
      }
      throw new TypeError(
        "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value
      );
    }
    Buffer6.from = function(value, encodingOrOffset, length2) {
      return from2(value, encodingOrOffset, length2);
    };
    Object.setPrototypeOf(Buffer6.prototype, Uint8Array.prototype);
    Object.setPrototypeOf(Buffer6, Uint8Array);
    function assertSize(size) {
      if (typeof size !== "number") {
        throw new TypeError('"size" argument must be of type number');
      } else if (size < 0) {
        throw new RangeError('The value "' + size + '" is invalid for option "size"');
      }
    }
    function alloc2(size, fill, encoding) {
      assertSize(size);
      if (size <= 0) {
        return createBuffer(size);
      }
      if (fill !== void 0) {
        return typeof encoding === "string" ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
      }
      return createBuffer(size);
    }
    Buffer6.alloc = function(size, fill, encoding) {
      return alloc2(size, fill, encoding);
    };
    function allocUnsafe2(size) {
      assertSize(size);
      return createBuffer(size < 0 ? 0 : checked(size) | 0);
    }
    Buffer6.allocUnsafe = function(size) {
      return allocUnsafe2(size);
    };
    Buffer6.allocUnsafeSlow = function(size) {
      return allocUnsafe2(size);
    };
    function fromString(string3, encoding) {
      if (typeof encoding !== "string" || encoding === "") {
        encoding = "utf8";
      }
      if (!Buffer6.isEncoding(encoding)) {
        throw new TypeError("Unknown encoding: " + encoding);
      }
      const length2 = byteLength2(string3, encoding) | 0;
      let buf = createBuffer(length2);
      const actual = buf.write(string3, encoding);
      if (actual !== length2) {
        buf = buf.slice(0, actual);
      }
      return buf;
    }
    function fromArrayLike(array4) {
      const length2 = array4.length < 0 ? 0 : checked(array4.length) | 0;
      const buf = createBuffer(length2);
      for (let i = 0; i < length2; i += 1) {
        buf[i] = array4[i] & 255;
      }
      return buf;
    }
    function fromArrayView(arrayView) {
      if (isInstance(arrayView, Uint8Array)) {
        const copy2 = new Uint8Array(arrayView);
        return fromArrayBuffer(copy2.buffer, copy2.byteOffset, copy2.byteLength);
      }
      return fromArrayLike(arrayView);
    }
    function fromArrayBuffer(array4, byteOffset, length2) {
      if (byteOffset < 0 || array4.byteLength < byteOffset) {
        throw new RangeError('"offset" is outside of buffer bounds');
      }
      if (array4.byteLength < byteOffset + (length2 || 0)) {
        throw new RangeError('"length" is outside of buffer bounds');
      }
      let buf;
      if (byteOffset === void 0 && length2 === void 0) {
        buf = new Uint8Array(array4);
      } else if (length2 === void 0) {
        buf = new Uint8Array(array4, byteOffset);
      } else {
        buf = new Uint8Array(array4, byteOffset, length2);
      }
      Object.setPrototypeOf(buf, Buffer6.prototype);
      return buf;
    }
    function fromObject(obj) {
      if (Buffer6.isBuffer(obj)) {
        const len = checked(obj.length) | 0;
        const buf = createBuffer(len);
        if (buf.length === 0) {
          return buf;
        }
        obj.copy(buf, 0, 0, len);
        return buf;
      }
      if (obj.length !== void 0) {
        if (typeof obj.length !== "number" || numberIsNaN(obj.length)) {
          return createBuffer(0);
        }
        return fromArrayLike(obj);
      }
      if (obj.type === "Buffer" && Array.isArray(obj.data)) {
        return fromArrayLike(obj.data);
      }
    }
    function checked(length2) {
      if (length2 >= K_MAX_LENGTH) {
        throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + " bytes");
      }
      return length2 | 0;
    }
    function SlowBuffer(length2) {
      if (+length2 != length2) {
        length2 = 0;
      }
      return Buffer6.alloc(+length2);
    }
    Buffer6.isBuffer = function isBuffer2(b) {
      return b != null && b._isBuffer === true && b !== Buffer6.prototype;
    };
    Buffer6.compare = function compare(a, b) {
      if (isInstance(a, Uint8Array)) a = Buffer6.from(a, a.offset, a.byteLength);
      if (isInstance(b, Uint8Array)) b = Buffer6.from(b, b.offset, b.byteLength);
      if (!Buffer6.isBuffer(a) || !Buffer6.isBuffer(b)) {
        throw new TypeError(
          'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
        );
      }
      if (a === b) return 0;
      let x = a.length;
      let y = b.length;
      for (let i = 0, len = Math.min(x, y); i < len; ++i) {
        if (a[i] !== b[i]) {
          x = a[i];
          y = b[i];
          break;
        }
      }
      if (x < y) return -1;
      if (y < x) return 1;
      return 0;
    };
    Buffer6.isEncoding = function isEncoding(encoding) {
      switch (String(encoding).toLowerCase()) {
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return true;
        default:
          return false;
      }
    };
    Buffer6.concat = function concat(list, length2) {
      if (!Array.isArray(list)) {
        throw new TypeError('"list" argument must be an Array of Buffers');
      }
      if (list.length === 0) {
        return Buffer6.alloc(0);
      }
      let i;
      if (length2 === void 0) {
        length2 = 0;
        for (i = 0; i < list.length; ++i) {
          length2 += list[i].length;
        }
      }
      const buffer = Buffer6.allocUnsafe(length2);
      let pos = 0;
      for (i = 0; i < list.length; ++i) {
        let buf = list[i];
        if (isInstance(buf, Uint8Array)) {
          if (pos + buf.length > buffer.length) {
            if (!Buffer6.isBuffer(buf)) buf = Buffer6.from(buf);
            buf.copy(buffer, pos);
          } else {
            Uint8Array.prototype.set.call(
              buffer,
              buf,
              pos
            );
          }
        } else if (!Buffer6.isBuffer(buf)) {
          throw new TypeError('"list" argument must be an Array of Buffers');
        } else {
          buf.copy(buffer, pos);
        }
        pos += buf.length;
      }
      return buffer;
    };
    function byteLength2(string3, encoding) {
      if (Buffer6.isBuffer(string3)) {
        return string3.length;
      }
      if (ArrayBuffer.isView(string3) || isInstance(string3, ArrayBuffer)) {
        return string3.byteLength;
      }
      if (typeof string3 !== "string") {
        throw new TypeError(
          'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string3
        );
      }
      const len = string3.length;
      const mustMatch = arguments.length > 2 && arguments[2] === true;
      if (!mustMatch && len === 0) return 0;
      let loweredCase = false;
      for (; ; ) {
        switch (encoding) {
          case "ascii":
          case "latin1":
          case "binary":
            return len;
          case "utf8":
          case "utf-8":
            return utf8ToBytes(string3).length;
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return len * 2;
          case "hex":
            return len >>> 1;
          case "base64":
            return base64ToBytes(string3).length;
          default:
            if (loweredCase) {
              return mustMatch ? -1 : utf8ToBytes(string3).length;
            }
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
        }
      }
    }
    Buffer6.byteLength = byteLength2;
    function slowToString(encoding, start, end) {
      let loweredCase = false;
      if (start === void 0 || start < 0) {
        start = 0;
      }
      if (start > this.length) {
        return "";
      }
      if (end === void 0 || end > this.length) {
        end = this.length;
      }
      if (end <= 0) {
        return "";
      }
      end >>>= 0;
      start >>>= 0;
      if (end <= start) {
        return "";
      }
      if (!encoding) encoding = "utf8";
      while (true) {
        switch (encoding) {
          case "hex":
            return hexSlice(this, start, end);
          case "utf8":
          case "utf-8":
            return utf8Slice(this, start, end);
          case "ascii":
            return asciiSlice(this, start, end);
          case "latin1":
          case "binary":
            return latin1Slice(this, start, end);
          case "base64":
            return base64Slice(this, start, end);
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return utf16leSlice(this, start, end);
          default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
        }
      }
    }
    Buffer6.prototype._isBuffer = true;
    function swap2(b, n2, m) {
      const i = b[n2];
      b[n2] = b[m];
      b[m] = i;
    }
    Buffer6.prototype.swap16 = function swap16() {
      const len = this.length;
      if (len % 2 !== 0) {
        throw new RangeError("Buffer size must be a multiple of 16-bits");
      }
      for (let i = 0; i < len; i += 2) {
        swap2(this, i, i + 1);
      }
      return this;
    };
    Buffer6.prototype.swap32 = function swap32() {
      const len = this.length;
      if (len % 4 !== 0) {
        throw new RangeError("Buffer size must be a multiple of 32-bits");
      }
      for (let i = 0; i < len; i += 4) {
        swap2(this, i, i + 3);
        swap2(this, i + 1, i + 2);
      }
      return this;
    };
    Buffer6.prototype.swap64 = function swap64() {
      const len = this.length;
      if (len % 8 !== 0) {
        throw new RangeError("Buffer size must be a multiple of 64-bits");
      }
      for (let i = 0; i < len; i += 8) {
        swap2(this, i, i + 7);
        swap2(this, i + 1, i + 6);
        swap2(this, i + 2, i + 5);
        swap2(this, i + 3, i + 4);
      }
      return this;
    };
    Buffer6.prototype.toString = function toString3() {
      const length2 = this.length;
      if (length2 === 0) return "";
      if (arguments.length === 0) return utf8Slice(this, 0, length2);
      return slowToString.apply(this, arguments);
    };
    Buffer6.prototype.toLocaleString = Buffer6.prototype.toString;
    Buffer6.prototype.equals = function equals2(b) {
      if (!Buffer6.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
      if (this === b) return true;
      return Buffer6.compare(this, b) === 0;
    };
    Buffer6.prototype.inspect = function inspect() {
      let str = "";
      const max = exports2.INSPECT_MAX_BYTES;
      str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
      if (this.length > max) str += " ... ";
      return "<Buffer " + str + ">";
    };
    if (customInspectSymbol) {
      Buffer6.prototype[customInspectSymbol] = Buffer6.prototype.inspect;
    }
    Buffer6.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
      if (isInstance(target, Uint8Array)) {
        target = Buffer6.from(target, target.offset, target.byteLength);
      }
      if (!Buffer6.isBuffer(target)) {
        throw new TypeError(
          'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target
        );
      }
      if (start === void 0) {
        start = 0;
      }
      if (end === void 0) {
        end = target ? target.length : 0;
      }
      if (thisStart === void 0) {
        thisStart = 0;
      }
      if (thisEnd === void 0) {
        thisEnd = this.length;
      }
      if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
        throw new RangeError("out of range index");
      }
      if (thisStart >= thisEnd && start >= end) {
        return 0;
      }
      if (thisStart >= thisEnd) {
        return -1;
      }
      if (start >= end) {
        return 1;
      }
      start >>>= 0;
      end >>>= 0;
      thisStart >>>= 0;
      thisEnd >>>= 0;
      if (this === target) return 0;
      let x = thisEnd - thisStart;
      let y = end - start;
      const len = Math.min(x, y);
      const thisCopy = this.slice(thisStart, thisEnd);
      const targetCopy = target.slice(start, end);
      for (let i = 0; i < len; ++i) {
        if (thisCopy[i] !== targetCopy[i]) {
          x = thisCopy[i];
          y = targetCopy[i];
          break;
        }
      }
      if (x < y) return -1;
      if (y < x) return 1;
      return 0;
    };
    function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
      if (buffer.length === 0) return -1;
      if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
      } else if (byteOffset > 2147483647) {
        byteOffset = 2147483647;
      } else if (byteOffset < -2147483648) {
        byteOffset = -2147483648;
      }
      byteOffset = +byteOffset;
      if (numberIsNaN(byteOffset)) {
        byteOffset = dir ? 0 : buffer.length - 1;
      }
      if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
      if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
      } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
      }
      if (typeof val === "string") {
        val = Buffer6.from(val, encoding);
      }
      if (Buffer6.isBuffer(val)) {
        if (val.length === 0) {
          return -1;
        }
        return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
      } else if (typeof val === "number") {
        val = val & 255;
        if (typeof Uint8Array.prototype.indexOf === "function") {
          if (dir) {
            return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
          } else {
            return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
          }
        }
        return arrayIndexOf(buffer, [val], byteOffset, encoding, dir);
      }
      throw new TypeError("val must be string, number or Buffer");
    }
    function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
      let indexSize = 1;
      let arrLength = arr.length;
      let valLength = val.length;
      if (encoding !== void 0) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
          if (arr.length < 2 || val.length < 2) {
            return -1;
          }
          indexSize = 2;
          arrLength /= 2;
          valLength /= 2;
          byteOffset /= 2;
        }
      }
      function read(buf, i2) {
        if (indexSize === 1) {
          return buf[i2];
        } else {
          return buf.readUInt16BE(i2 * indexSize);
        }
      }
      let i;
      if (dir) {
        let foundIndex = -1;
        for (i = byteOffset; i < arrLength; i++) {
          if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
          } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
          }
        }
      } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for (i = byteOffset; i >= 0; i--) {
          let found = true;
          for (let j = 0; j < valLength; j++) {
            if (read(arr, i + j) !== read(val, j)) {
              found = false;
              break;
            }
          }
          if (found) return i;
        }
      }
      return -1;
    }
    Buffer6.prototype.includes = function includes2(val, byteOffset, encoding) {
      return this.indexOf(val, byteOffset, encoding) !== -1;
    };
    Buffer6.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
      return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
    };
    Buffer6.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
      return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
    };
    function hexWrite(buf, string3, offset4, length2) {
      offset4 = Number(offset4) || 0;
      const remaining = buf.length - offset4;
      if (!length2) {
        length2 = remaining;
      } else {
        length2 = Number(length2);
        if (length2 > remaining) {
          length2 = remaining;
        }
      }
      const strLen = string3.length;
      if (length2 > strLen / 2) {
        length2 = strLen / 2;
      }
      let i;
      for (i = 0; i < length2; ++i) {
        const parsed = parseInt(string3.substr(i * 2, 2), 16);
        if (numberIsNaN(parsed)) return i;
        buf[offset4 + i] = parsed;
      }
      return i;
    }
    function utf8Write(buf, string3, offset4, length2) {
      return blitBuffer(utf8ToBytes(string3, buf.length - offset4), buf, offset4, length2);
    }
    function asciiWrite(buf, string3, offset4, length2) {
      return blitBuffer(asciiToBytes(string3), buf, offset4, length2);
    }
    function base64Write(buf, string3, offset4, length2) {
      return blitBuffer(base64ToBytes(string3), buf, offset4, length2);
    }
    function ucs2Write(buf, string3, offset4, length2) {
      return blitBuffer(utf16leToBytes(string3, buf.length - offset4), buf, offset4, length2);
    }
    Buffer6.prototype.write = function write(string3, offset4, length2, encoding) {
      if (offset4 === void 0) {
        encoding = "utf8";
        length2 = this.length;
        offset4 = 0;
      } else if (length2 === void 0 && typeof offset4 === "string") {
        encoding = offset4;
        length2 = this.length;
        offset4 = 0;
      } else if (isFinite(offset4)) {
        offset4 = offset4 >>> 0;
        if (isFinite(length2)) {
          length2 = length2 >>> 0;
          if (encoding === void 0) encoding = "utf8";
        } else {
          encoding = length2;
          length2 = void 0;
        }
      } else {
        throw new Error(
          "Buffer.write(string, encoding, offset[, length]) is no longer supported"
        );
      }
      const remaining = this.length - offset4;
      if (length2 === void 0 || length2 > remaining) length2 = remaining;
      if (string3.length > 0 && (length2 < 0 || offset4 < 0) || offset4 > this.length) {
        throw new RangeError("Attempt to write outside buffer bounds");
      }
      if (!encoding) encoding = "utf8";
      let loweredCase = false;
      for (; ; ) {
        switch (encoding) {
          case "hex":
            return hexWrite(this, string3, offset4, length2);
          case "utf8":
          case "utf-8":
            return utf8Write(this, string3, offset4, length2);
          case "ascii":
          case "latin1":
          case "binary":
            return asciiWrite(this, string3, offset4, length2);
          case "base64":
            return base64Write(this, string3, offset4, length2);
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return ucs2Write(this, string3, offset4, length2);
          default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
        }
      }
    };
    Buffer6.prototype.toJSON = function toJSON() {
      return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
      };
    };
    function base64Slice(buf, start, end) {
      if (start === 0 && end === buf.length) {
        return base64.fromByteArray(buf);
      } else {
        return base64.fromByteArray(buf.slice(start, end));
      }
    }
    function utf8Slice(buf, start, end) {
      end = Math.min(buf.length, end);
      const res = [];
      let i = start;
      while (i < end) {
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 239 ? 4 : firstByte > 223 ? 3 : firstByte > 191 ? 2 : 1;
        if (i + bytesPerSequence <= end) {
          let secondByte, thirdByte, fourthByte, tempCodePoint;
          switch (bytesPerSequence) {
            case 1:
              if (firstByte < 128) {
                codePoint = firstByte;
              }
              break;
            case 2:
              secondByte = buf[i + 1];
              if ((secondByte & 192) === 128) {
                tempCodePoint = (firstByte & 31) << 6 | secondByte & 63;
                if (tempCodePoint > 127) {
                  codePoint = tempCodePoint;
                }
              }
              break;
            case 3:
              secondByte = buf[i + 1];
              thirdByte = buf[i + 2];
              if ((secondByte & 192) === 128 && (thirdByte & 192) === 128) {
                tempCodePoint = (firstByte & 15) << 12 | (secondByte & 63) << 6 | thirdByte & 63;
                if (tempCodePoint > 2047 && (tempCodePoint < 55296 || tempCodePoint > 57343)) {
                  codePoint = tempCodePoint;
                }
              }
              break;
            case 4:
              secondByte = buf[i + 1];
              thirdByte = buf[i + 2];
              fourthByte = buf[i + 3];
              if ((secondByte & 192) === 128 && (thirdByte & 192) === 128 && (fourthByte & 192) === 128) {
                tempCodePoint = (firstByte & 15) << 18 | (secondByte & 63) << 12 | (thirdByte & 63) << 6 | fourthByte & 63;
                if (tempCodePoint > 65535 && tempCodePoint < 1114112) {
                  codePoint = tempCodePoint;
                }
              }
          }
        }
        if (codePoint === null) {
          codePoint = 65533;
          bytesPerSequence = 1;
        } else if (codePoint > 65535) {
          codePoint -= 65536;
          res.push(codePoint >>> 10 & 1023 | 55296);
          codePoint = 56320 | codePoint & 1023;
        }
        res.push(codePoint);
        i += bytesPerSequence;
      }
      return decodeCodePointsArray(res);
    }
    var MAX_ARGUMENTS_LENGTH = 4096;
    function decodeCodePointsArray(codePoints) {
      const len = codePoints.length;
      if (len <= MAX_ARGUMENTS_LENGTH) {
        return String.fromCharCode.apply(String, codePoints);
      }
      let res = "";
      let i = 0;
      while (i < len) {
        res += String.fromCharCode.apply(
          String,
          codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
        );
      }
      return res;
    }
    function asciiSlice(buf, start, end) {
      let ret = "";
      end = Math.min(buf.length, end);
      for (let i = start; i < end; ++i) {
        ret += String.fromCharCode(buf[i] & 127);
      }
      return ret;
    }
    function latin1Slice(buf, start, end) {
      let ret = "";
      end = Math.min(buf.length, end);
      for (let i = start; i < end; ++i) {
        ret += String.fromCharCode(buf[i]);
      }
      return ret;
    }
    function hexSlice(buf, start, end) {
      const len = buf.length;
      if (!start || start < 0) start = 0;
      if (!end || end < 0 || end > len) end = len;
      let out = "";
      for (let i = start; i < end; ++i) {
        out += hexSliceLookupTable[buf[i]];
      }
      return out;
    }
    function utf16leSlice(buf, start, end) {
      const bytes = buf.slice(start, end);
      let res = "";
      for (let i = 0; i < bytes.length - 1; i += 2) {
        res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
      }
      return res;
    }
    Buffer6.prototype.slice = function slice2(start, end) {
      const len = this.length;
      start = ~~start;
      end = end === void 0 ? len : ~~end;
      if (start < 0) {
        start += len;
        if (start < 0) start = 0;
      } else if (start > len) {
        start = len;
      }
      if (end < 0) {
        end += len;
        if (end < 0) end = 0;
      } else if (end > len) {
        end = len;
      }
      if (end < start) end = start;
      const newBuf = this.subarray(start, end);
      Object.setPrototypeOf(newBuf, Buffer6.prototype);
      return newBuf;
    };
    function checkOffset(offset4, ext, length2) {
      if (offset4 % 1 !== 0 || offset4 < 0) throw new RangeError("offset is not uint");
      if (offset4 + ext > length2) throw new RangeError("Trying to access beyond buffer length");
    }
    Buffer6.prototype.readUintLE = Buffer6.prototype.readUIntLE = function readUIntLE(offset4, byteLength3, noAssert) {
      offset4 = offset4 >>> 0;
      byteLength3 = byteLength3 >>> 0;
      if (!noAssert) checkOffset(offset4, byteLength3, this.length);
      let val = this[offset4];
      let mul = 1;
      let i = 0;
      while (++i < byteLength3 && (mul *= 256)) {
        val += this[offset4 + i] * mul;
      }
      return val;
    };
    Buffer6.prototype.readUintBE = Buffer6.prototype.readUIntBE = function readUIntBE(offset4, byteLength3, noAssert) {
      offset4 = offset4 >>> 0;
      byteLength3 = byteLength3 >>> 0;
      if (!noAssert) {
        checkOffset(offset4, byteLength3, this.length);
      }
      let val = this[offset4 + --byteLength3];
      let mul = 1;
      while (byteLength3 > 0 && (mul *= 256)) {
        val += this[offset4 + --byteLength3] * mul;
      }
      return val;
    };
    Buffer6.prototype.readUint8 = Buffer6.prototype.readUInt8 = function readUInt8(offset4, noAssert) {
      offset4 = offset4 >>> 0;
      if (!noAssert) checkOffset(offset4, 1, this.length);
      return this[offset4];
    };
    Buffer6.prototype.readUint16LE = Buffer6.prototype.readUInt16LE = function readUInt16LE(offset4, noAssert) {
      offset4 = offset4 >>> 0;
      if (!noAssert) checkOffset(offset4, 2, this.length);
      return this[offset4] | this[offset4 + 1] << 8;
    };
    Buffer6.prototype.readUint16BE = Buffer6.prototype.readUInt16BE = function readUInt16BE(offset4, noAssert) {
      offset4 = offset4 >>> 0;
      if (!noAssert) checkOffset(offset4, 2, this.length);
      return this[offset4] << 8 | this[offset4 + 1];
    };
    Buffer6.prototype.readUint32LE = Buffer6.prototype.readUInt32LE = function readUInt32LE(offset4, noAssert) {
      offset4 = offset4 >>> 0;
      if (!noAssert) checkOffset(offset4, 4, this.length);
      return (this[offset4] | this[offset4 + 1] << 8 | this[offset4 + 2] << 16) + this[offset4 + 3] * 16777216;
    };
    Buffer6.prototype.readUint32BE = Buffer6.prototype.readUInt32BE = function readUInt32BE(offset4, noAssert) {
      offset4 = offset4 >>> 0;
      if (!noAssert) checkOffset(offset4, 4, this.length);
      return this[offset4] * 16777216 + (this[offset4 + 1] << 16 | this[offset4 + 2] << 8 | this[offset4 + 3]);
    };
    Buffer6.prototype.readBigUInt64LE = defineBigIntMethod(function readBigUInt64LE(offset4) {
      offset4 = offset4 >>> 0;
      validateNumber2(offset4, "offset");
      const first = this[offset4];
      const last2 = this[offset4 + 7];
      if (first === void 0 || last2 === void 0) {
        boundsError(offset4, this.length - 8);
      }
      const lo = first + this[++offset4] * 2 ** 8 + this[++offset4] * 2 ** 16 + this[++offset4] * 2 ** 24;
      const hi = this[++offset4] + this[++offset4] * 2 ** 8 + this[++offset4] * 2 ** 16 + last2 * 2 ** 24;
      return BigInt(lo) + (BigInt(hi) << BigInt(32));
    });
    Buffer6.prototype.readBigUInt64BE = defineBigIntMethod(function readBigUInt64BE(offset4) {
      offset4 = offset4 >>> 0;
      validateNumber2(offset4, "offset");
      const first = this[offset4];
      const last2 = this[offset4 + 7];
      if (first === void 0 || last2 === void 0) {
        boundsError(offset4, this.length - 8);
      }
      const hi = first * 2 ** 24 + this[++offset4] * 2 ** 16 + this[++offset4] * 2 ** 8 + this[++offset4];
      const lo = this[++offset4] * 2 ** 24 + this[++offset4] * 2 ** 16 + this[++offset4] * 2 ** 8 + last2;
      return (BigInt(hi) << BigInt(32)) + BigInt(lo);
    });
    Buffer6.prototype.readIntLE = function readIntLE(offset4, byteLength3, noAssert) {
      offset4 = offset4 >>> 0;
      byteLength3 = byteLength3 >>> 0;
      if (!noAssert) checkOffset(offset4, byteLength3, this.length);
      let val = this[offset4];
      let mul = 1;
      let i = 0;
      while (++i < byteLength3 && (mul *= 256)) {
        val += this[offset4 + i] * mul;
      }
      mul *= 128;
      if (val >= mul) val -= Math.pow(2, 8 * byteLength3);
      return val;
    };
    Buffer6.prototype.readIntBE = function readIntBE(offset4, byteLength3, noAssert) {
      offset4 = offset4 >>> 0;
      byteLength3 = byteLength3 >>> 0;
      if (!noAssert) checkOffset(offset4, byteLength3, this.length);
      let i = byteLength3;
      let mul = 1;
      let val = this[offset4 + --i];
      while (i > 0 && (mul *= 256)) {
        val += this[offset4 + --i] * mul;
      }
      mul *= 128;
      if (val >= mul) val -= Math.pow(2, 8 * byteLength3);
      return val;
    };
    Buffer6.prototype.readInt8 = function readInt8(offset4, noAssert) {
      offset4 = offset4 >>> 0;
      if (!noAssert) checkOffset(offset4, 1, this.length);
      if (!(this[offset4] & 128)) return this[offset4];
      return (255 - this[offset4] + 1) * -1;
    };
    Buffer6.prototype.readInt16LE = function readInt16LE(offset4, noAssert) {
      offset4 = offset4 >>> 0;
      if (!noAssert) checkOffset(offset4, 2, this.length);
      const val = this[offset4] | this[offset4 + 1] << 8;
      return val & 32768 ? val | 4294901760 : val;
    };
    Buffer6.prototype.readInt16BE = function readInt16BE(offset4, noAssert) {
      offset4 = offset4 >>> 0;
      if (!noAssert) checkOffset(offset4, 2, this.length);
      const val = this[offset4 + 1] | this[offset4] << 8;
      return val & 32768 ? val | 4294901760 : val;
    };
    Buffer6.prototype.readInt32LE = function readInt32LE(offset4, noAssert) {
      offset4 = offset4 >>> 0;
      if (!noAssert) checkOffset(offset4, 4, this.length);
      return this[offset4] | this[offset4 + 1] << 8 | this[offset4 + 2] << 16 | this[offset4 + 3] << 24;
    };
    Buffer6.prototype.readInt32BE = function readInt32BE(offset4, noAssert) {
      offset4 = offset4 >>> 0;
      if (!noAssert) checkOffset(offset4, 4, this.length);
      return this[offset4] << 24 | this[offset4 + 1] << 16 | this[offset4 + 2] << 8 | this[offset4 + 3];
    };
    Buffer6.prototype.readBigInt64LE = defineBigIntMethod(function readBigInt64LE(offset4) {
      offset4 = offset4 >>> 0;
      validateNumber2(offset4, "offset");
      const first = this[offset4];
      const last2 = this[offset4 + 7];
      if (first === void 0 || last2 === void 0) {
        boundsError(offset4, this.length - 8);
      }
      const val = this[offset4 + 4] + this[offset4 + 5] * 2 ** 8 + this[offset4 + 6] * 2 ** 16 + (last2 << 24);
      return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset4] * 2 ** 8 + this[++offset4] * 2 ** 16 + this[++offset4] * 2 ** 24);
    });
    Buffer6.prototype.readBigInt64BE = defineBigIntMethod(function readBigInt64BE(offset4) {
      offset4 = offset4 >>> 0;
      validateNumber2(offset4, "offset");
      const first = this[offset4];
      const last2 = this[offset4 + 7];
      if (first === void 0 || last2 === void 0) {
        boundsError(offset4, this.length - 8);
      }
      const val = (first << 24) + // Overflow
      this[++offset4] * 2 ** 16 + this[++offset4] * 2 ** 8 + this[++offset4];
      return (BigInt(val) << BigInt(32)) + BigInt(this[++offset4] * 2 ** 24 + this[++offset4] * 2 ** 16 + this[++offset4] * 2 ** 8 + last2);
    });
    Buffer6.prototype.readFloatLE = function readFloatLE(offset4, noAssert) {
      offset4 = offset4 >>> 0;
      if (!noAssert) checkOffset(offset4, 4, this.length);
      return ieee754.read(this, offset4, true, 23, 4);
    };
    Buffer6.prototype.readFloatBE = function readFloatBE(offset4, noAssert) {
      offset4 = offset4 >>> 0;
      if (!noAssert) checkOffset(offset4, 4, this.length);
      return ieee754.read(this, offset4, false, 23, 4);
    };
    Buffer6.prototype.readDoubleLE = function readDoubleLE(offset4, noAssert) {
      offset4 = offset4 >>> 0;
      if (!noAssert) checkOffset(offset4, 8, this.length);
      return ieee754.read(this, offset4, true, 52, 8);
    };
    Buffer6.prototype.readDoubleBE = function readDoubleBE(offset4, noAssert) {
      offset4 = offset4 >>> 0;
      if (!noAssert) checkOffset(offset4, 8, this.length);
      return ieee754.read(this, offset4, false, 52, 8);
    };
    function checkInt(buf, value, offset4, ext, max, min) {
      if (!Buffer6.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
      if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
      if (offset4 + ext > buf.length) throw new RangeError("Index out of range");
    }
    Buffer6.prototype.writeUintLE = Buffer6.prototype.writeUIntLE = function writeUIntLE(value, offset4, byteLength3, noAssert) {
      value = +value;
      offset4 = offset4 >>> 0;
      byteLength3 = byteLength3 >>> 0;
      if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength3) - 1;
        checkInt(this, value, offset4, byteLength3, maxBytes, 0);
      }
      let mul = 1;
      let i = 0;
      this[offset4] = value & 255;
      while (++i < byteLength3 && (mul *= 256)) {
        this[offset4 + i] = value / mul & 255;
      }
      return offset4 + byteLength3;
    };
    Buffer6.prototype.writeUintBE = Buffer6.prototype.writeUIntBE = function writeUIntBE(value, offset4, byteLength3, noAssert) {
      value = +value;
      offset4 = offset4 >>> 0;
      byteLength3 = byteLength3 >>> 0;
      if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength3) - 1;
        checkInt(this, value, offset4, byteLength3, maxBytes, 0);
      }
      let i = byteLength3 - 1;
      let mul = 1;
      this[offset4 + i] = value & 255;
      while (--i >= 0 && (mul *= 256)) {
        this[offset4 + i] = value / mul & 255;
      }
      return offset4 + byteLength3;
    };
    Buffer6.prototype.writeUint8 = Buffer6.prototype.writeUInt8 = function writeUInt8(value, offset4, noAssert) {
      value = +value;
      offset4 = offset4 >>> 0;
      if (!noAssert) checkInt(this, value, offset4, 1, 255, 0);
      this[offset4] = value & 255;
      return offset4 + 1;
    };
    Buffer6.prototype.writeUint16LE = Buffer6.prototype.writeUInt16LE = function writeUInt16LE(value, offset4, noAssert) {
      value = +value;
      offset4 = offset4 >>> 0;
      if (!noAssert) checkInt(this, value, offset4, 2, 65535, 0);
      this[offset4] = value & 255;
      this[offset4 + 1] = value >>> 8;
      return offset4 + 2;
    };
    Buffer6.prototype.writeUint16BE = Buffer6.prototype.writeUInt16BE = function writeUInt16BE(value, offset4, noAssert) {
      value = +value;
      offset4 = offset4 >>> 0;
      if (!noAssert) checkInt(this, value, offset4, 2, 65535, 0);
      this[offset4] = value >>> 8;
      this[offset4 + 1] = value & 255;
      return offset4 + 2;
    };
    Buffer6.prototype.writeUint32LE = Buffer6.prototype.writeUInt32LE = function writeUInt32LE(value, offset4, noAssert) {
      value = +value;
      offset4 = offset4 >>> 0;
      if (!noAssert) checkInt(this, value, offset4, 4, 4294967295, 0);
      this[offset4 + 3] = value >>> 24;
      this[offset4 + 2] = value >>> 16;
      this[offset4 + 1] = value >>> 8;
      this[offset4] = value & 255;
      return offset4 + 4;
    };
    Buffer6.prototype.writeUint32BE = Buffer6.prototype.writeUInt32BE = function writeUInt32BE(value, offset4, noAssert) {
      value = +value;
      offset4 = offset4 >>> 0;
      if (!noAssert) checkInt(this, value, offset4, 4, 4294967295, 0);
      this[offset4] = value >>> 24;
      this[offset4 + 1] = value >>> 16;
      this[offset4 + 2] = value >>> 8;
      this[offset4 + 3] = value & 255;
      return offset4 + 4;
    };
    function wrtBigUInt64LE(buf, value, offset4, min, max) {
      checkIntBI(value, min, max, buf, offset4, 7);
      let lo = Number(value & BigInt(4294967295));
      buf[offset4++] = lo;
      lo = lo >> 8;
      buf[offset4++] = lo;
      lo = lo >> 8;
      buf[offset4++] = lo;
      lo = lo >> 8;
      buf[offset4++] = lo;
      let hi = Number(value >> BigInt(32) & BigInt(4294967295));
      buf[offset4++] = hi;
      hi = hi >> 8;
      buf[offset4++] = hi;
      hi = hi >> 8;
      buf[offset4++] = hi;
      hi = hi >> 8;
      buf[offset4++] = hi;
      return offset4;
    }
    function wrtBigUInt64BE(buf, value, offset4, min, max) {
      checkIntBI(value, min, max, buf, offset4, 7);
      let lo = Number(value & BigInt(4294967295));
      buf[offset4 + 7] = lo;
      lo = lo >> 8;
      buf[offset4 + 6] = lo;
      lo = lo >> 8;
      buf[offset4 + 5] = lo;
      lo = lo >> 8;
      buf[offset4 + 4] = lo;
      let hi = Number(value >> BigInt(32) & BigInt(4294967295));
      buf[offset4 + 3] = hi;
      hi = hi >> 8;
      buf[offset4 + 2] = hi;
      hi = hi >> 8;
      buf[offset4 + 1] = hi;
      hi = hi >> 8;
      buf[offset4] = hi;
      return offset4 + 8;
    }
    Buffer6.prototype.writeBigUInt64LE = defineBigIntMethod(function writeBigUInt64LE(value, offset4 = 0) {
      return wrtBigUInt64LE(this, value, offset4, BigInt(0), BigInt("0xffffffffffffffff"));
    });
    Buffer6.prototype.writeBigUInt64BE = defineBigIntMethod(function writeBigUInt64BE(value, offset4 = 0) {
      return wrtBigUInt64BE(this, value, offset4, BigInt(0), BigInt("0xffffffffffffffff"));
    });
    Buffer6.prototype.writeIntLE = function writeIntLE(value, offset4, byteLength3, noAssert) {
      value = +value;
      offset4 = offset4 >>> 0;
      if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength3 - 1);
        checkInt(this, value, offset4, byteLength3, limit - 1, -limit);
      }
      let i = 0;
      let mul = 1;
      let sub = 0;
      this[offset4] = value & 255;
      while (++i < byteLength3 && (mul *= 256)) {
        if (value < 0 && sub === 0 && this[offset4 + i - 1] !== 0) {
          sub = 1;
        }
        this[offset4 + i] = (value / mul >> 0) - sub & 255;
      }
      return offset4 + byteLength3;
    };
    Buffer6.prototype.writeIntBE = function writeIntBE(value, offset4, byteLength3, noAssert) {
      value = +value;
      offset4 = offset4 >>> 0;
      if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength3 - 1);
        checkInt(this, value, offset4, byteLength3, limit - 1, -limit);
      }
      let i = byteLength3 - 1;
      let mul = 1;
      let sub = 0;
      this[offset4 + i] = value & 255;
      while (--i >= 0 && (mul *= 256)) {
        if (value < 0 && sub === 0 && this[offset4 + i + 1] !== 0) {
          sub = 1;
        }
        this[offset4 + i] = (value / mul >> 0) - sub & 255;
      }
      return offset4 + byteLength3;
    };
    Buffer6.prototype.writeInt8 = function writeInt8(value, offset4, noAssert) {
      value = +value;
      offset4 = offset4 >>> 0;
      if (!noAssert) checkInt(this, value, offset4, 1, 127, -128);
      if (value < 0) value = 255 + value + 1;
      this[offset4] = value & 255;
      return offset4 + 1;
    };
    Buffer6.prototype.writeInt16LE = function writeInt16LE(value, offset4, noAssert) {
      value = +value;
      offset4 = offset4 >>> 0;
      if (!noAssert) checkInt(this, value, offset4, 2, 32767, -32768);
      this[offset4] = value & 255;
      this[offset4 + 1] = value >>> 8;
      return offset4 + 2;
    };
    Buffer6.prototype.writeInt16BE = function writeInt16BE(value, offset4, noAssert) {
      value = +value;
      offset4 = offset4 >>> 0;
      if (!noAssert) checkInt(this, value, offset4, 2, 32767, -32768);
      this[offset4] = value >>> 8;
      this[offset4 + 1] = value & 255;
      return offset4 + 2;
    };
    Buffer6.prototype.writeInt32LE = function writeInt32LE(value, offset4, noAssert) {
      value = +value;
      offset4 = offset4 >>> 0;
      if (!noAssert) checkInt(this, value, offset4, 4, 2147483647, -2147483648);
      this[offset4] = value & 255;
      this[offset4 + 1] = value >>> 8;
      this[offset4 + 2] = value >>> 16;
      this[offset4 + 3] = value >>> 24;
      return offset4 + 4;
    };
    Buffer6.prototype.writeInt32BE = function writeInt32BE(value, offset4, noAssert) {
      value = +value;
      offset4 = offset4 >>> 0;
      if (!noAssert) checkInt(this, value, offset4, 4, 2147483647, -2147483648);
      if (value < 0) value = 4294967295 + value + 1;
      this[offset4] = value >>> 24;
      this[offset4 + 1] = value >>> 16;
      this[offset4 + 2] = value >>> 8;
      this[offset4 + 3] = value & 255;
      return offset4 + 4;
    };
    Buffer6.prototype.writeBigInt64LE = defineBigIntMethod(function writeBigInt64LE(value, offset4 = 0) {
      return wrtBigUInt64LE(this, value, offset4, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
    });
    Buffer6.prototype.writeBigInt64BE = defineBigIntMethod(function writeBigInt64BE(value, offset4 = 0) {
      return wrtBigUInt64BE(this, value, offset4, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
    });
    function checkIEEE754(buf, value, offset4, ext, max, min) {
      if (offset4 + ext > buf.length) throw new RangeError("Index out of range");
      if (offset4 < 0) throw new RangeError("Index out of range");
    }
    function writeFloat(buf, value, offset4, littleEndian, noAssert) {
      value = +value;
      offset4 = offset4 >>> 0;
      if (!noAssert) {
        checkIEEE754(buf, value, offset4, 4, 34028234663852886e22, -34028234663852886e22);
      }
      ieee754.write(buf, value, offset4, littleEndian, 23, 4);
      return offset4 + 4;
    }
    Buffer6.prototype.writeFloatLE = function writeFloatLE(value, offset4, noAssert) {
      return writeFloat(this, value, offset4, true, noAssert);
    };
    Buffer6.prototype.writeFloatBE = function writeFloatBE(value, offset4, noAssert) {
      return writeFloat(this, value, offset4, false, noAssert);
    };
    function writeDouble(buf, value, offset4, littleEndian, noAssert) {
      value = +value;
      offset4 = offset4 >>> 0;
      if (!noAssert) {
        checkIEEE754(buf, value, offset4, 8, 17976931348623157e292, -17976931348623157e292);
      }
      ieee754.write(buf, value, offset4, littleEndian, 52, 8);
      return offset4 + 8;
    }
    Buffer6.prototype.writeDoubleLE = function writeDoubleLE(value, offset4, noAssert) {
      return writeDouble(this, value, offset4, true, noAssert);
    };
    Buffer6.prototype.writeDoubleBE = function writeDoubleBE(value, offset4, noAssert) {
      return writeDouble(this, value, offset4, false, noAssert);
    };
    Buffer6.prototype.copy = function copy2(target, targetStart, start, end) {
      if (!Buffer6.isBuffer(target)) throw new TypeError("argument should be a Buffer");
      if (!start) start = 0;
      if (!end && end !== 0) end = this.length;
      if (targetStart >= target.length) targetStart = target.length;
      if (!targetStart) targetStart = 0;
      if (end > 0 && end < start) end = start;
      if (end === start) return 0;
      if (target.length === 0 || this.length === 0) return 0;
      if (targetStart < 0) {
        throw new RangeError("targetStart out of bounds");
      }
      if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
      if (end < 0) throw new RangeError("sourceEnd out of bounds");
      if (end > this.length) end = this.length;
      if (target.length - targetStart < end - start) {
        end = target.length - targetStart + start;
      }
      const len = end - start;
      if (this === target && typeof Uint8Array.prototype.copyWithin === "function") {
        this.copyWithin(targetStart, start, end);
      } else {
        Uint8Array.prototype.set.call(
          target,
          this.subarray(start, end),
          targetStart
        );
      }
      return len;
    };
    Buffer6.prototype.fill = function fill(val, start, end, encoding) {
      if (typeof val === "string") {
        if (typeof start === "string") {
          encoding = start;
          start = 0;
          end = this.length;
        } else if (typeof end === "string") {
          encoding = end;
          end = this.length;
        }
        if (encoding !== void 0 && typeof encoding !== "string") {
          throw new TypeError("encoding must be a string");
        }
        if (typeof encoding === "string" && !Buffer6.isEncoding(encoding)) {
          throw new TypeError("Unknown encoding: " + encoding);
        }
        if (val.length === 1) {
          const code2 = val.charCodeAt(0);
          if (encoding === "utf8" && code2 < 128 || encoding === "latin1") {
            val = code2;
          }
        }
      } else if (typeof val === "number") {
        val = val & 255;
      } else if (typeof val === "boolean") {
        val = Number(val);
      }
      if (start < 0 || this.length < start || this.length < end) {
        throw new RangeError("Out of range index");
      }
      if (end <= start) {
        return this;
      }
      start = start >>> 0;
      end = end === void 0 ? this.length : end >>> 0;
      if (!val) val = 0;
      let i;
      if (typeof val === "number") {
        for (i = start; i < end; ++i) {
          this[i] = val;
        }
      } else {
        const bytes = Buffer6.isBuffer(val) ? val : Buffer6.from(val, encoding);
        const len = bytes.length;
        if (len === 0) {
          throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        }
        for (i = 0; i < end - start; ++i) {
          this[i + start] = bytes[i % len];
        }
      }
      return this;
    };
    var errors = {};
    function E(sym, getMessage, Base3) {
      errors[sym] = class NodeError extends Base3 {
        constructor() {
          super();
          Object.defineProperty(this, "message", {
            value: getMessage.apply(this, arguments),
            writable: true,
            configurable: true
          });
          this.name = `${this.name} [${sym}]`;
          this.stack;
          delete this.name;
        }
        get code() {
          return sym;
        }
        set code(value) {
          Object.defineProperty(this, "code", {
            configurable: true,
            enumerable: true,
            value,
            writable: true
          });
        }
        toString() {
          return `${this.name} [${sym}]: ${this.message}`;
        }
      };
    }
    E(
      "ERR_BUFFER_OUT_OF_BOUNDS",
      function(name) {
        if (name) {
          return `${name} is outside of buffer bounds`;
        }
        return "Attempt to access memory outside buffer bounds";
      },
      RangeError
    );
    E(
      "ERR_INVALID_ARG_TYPE",
      function(name, actual) {
        return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
      },
      TypeError
    );
    E(
      "ERR_OUT_OF_RANGE",
      function(str, range3, input) {
        let msg = `The value of "${str}" is out of range.`;
        let received = input;
        if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) {
          received = addNumericalSeparator(String(input));
        } else if (typeof input === "bigint") {
          received = String(input);
          if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) {
            received = addNumericalSeparator(received);
          }
          received += "n";
        }
        msg += ` It must be ${range3}. Received ${received}`;
        return msg;
      },
      RangeError
    );
    function addNumericalSeparator(val) {
      let res = "";
      let i = val.length;
      const start = val[0] === "-" ? 1 : 0;
      for (; i >= start + 4; i -= 3) {
        res = `_${val.slice(i - 3, i)}${res}`;
      }
      return `${val.slice(0, i)}${res}`;
    }
    function checkBounds2(buf, offset4, byteLength3) {
      validateNumber2(offset4, "offset");
      if (buf[offset4] === void 0 || buf[offset4 + byteLength3] === void 0) {
        boundsError(offset4, buf.length - (byteLength3 + 1));
      }
    }
    function checkIntBI(value, min, max, buf, offset4, byteLength3) {
      if (value > max || value < min) {
        const n2 = typeof min === "bigint" ? "n" : "";
        let range3;
        if (byteLength3 > 3) {
          if (min === 0 || min === BigInt(0)) {
            range3 = `>= 0${n2} and < 2${n2} ** ${(byteLength3 + 1) * 8}${n2}`;
          } else {
            range3 = `>= -(2${n2} ** ${(byteLength3 + 1) * 8 - 1}${n2}) and < 2 ** ${(byteLength3 + 1) * 8 - 1}${n2}`;
          }
        } else {
          range3 = `>= ${min}${n2} and <= ${max}${n2}`;
        }
        throw new errors.ERR_OUT_OF_RANGE("value", range3, value);
      }
      checkBounds2(buf, offset4, byteLength3);
    }
    function validateNumber2(value, name) {
      if (typeof value !== "number") {
        throw new errors.ERR_INVALID_ARG_TYPE(name, "number", value);
      }
    }
    function boundsError(value, length2, type5) {
      if (Math.floor(value) !== value) {
        validateNumber2(value, type5);
        throw new errors.ERR_OUT_OF_RANGE(type5 || "offset", "an integer", value);
      }
      if (length2 < 0) {
        throw new errors.ERR_BUFFER_OUT_OF_BOUNDS();
      }
      throw new errors.ERR_OUT_OF_RANGE(
        type5 || "offset",
        `>= ${type5 ? 1 : 0} and <= ${length2}`,
        value
      );
    }
    var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
    function base64clean(str) {
      str = str.split("=")[0];
      str = str.trim().replace(INVALID_BASE64_RE, "");
      if (str.length < 2) return "";
      while (str.length % 4 !== 0) {
        str = str + "=";
      }
      return str;
    }
    function utf8ToBytes(string3, units) {
      units = units || Infinity;
      let codePoint;
      const length2 = string3.length;
      let leadSurrogate = null;
      const bytes = [];
      for (let i = 0; i < length2; ++i) {
        codePoint = string3.charCodeAt(i);
        if (codePoint > 55295 && codePoint < 57344) {
          if (!leadSurrogate) {
            if (codePoint > 56319) {
              if ((units -= 3) > -1) bytes.push(239, 191, 189);
              continue;
            } else if (i + 1 === length2) {
              if ((units -= 3) > -1) bytes.push(239, 191, 189);
              continue;
            }
            leadSurrogate = codePoint;
            continue;
          }
          if (codePoint < 56320) {
            if ((units -= 3) > -1) bytes.push(239, 191, 189);
            leadSurrogate = codePoint;
            continue;
          }
          codePoint = (leadSurrogate - 55296 << 10 | codePoint - 56320) + 65536;
        } else if (leadSurrogate) {
          if ((units -= 3) > -1) bytes.push(239, 191, 189);
        }
        leadSurrogate = null;
        if (codePoint < 128) {
          if ((units -= 1) < 0) break;
          bytes.push(codePoint);
        } else if (codePoint < 2048) {
          if ((units -= 2) < 0) break;
          bytes.push(
            codePoint >> 6 | 192,
            codePoint & 63 | 128
          );
        } else if (codePoint < 65536) {
          if ((units -= 3) < 0) break;
          bytes.push(
            codePoint >> 12 | 224,
            codePoint >> 6 & 63 | 128,
            codePoint & 63 | 128
          );
        } else if (codePoint < 1114112) {
          if ((units -= 4) < 0) break;
          bytes.push(
            codePoint >> 18 | 240,
            codePoint >> 12 & 63 | 128,
            codePoint >> 6 & 63 | 128,
            codePoint & 63 | 128
          );
        } else {
          throw new Error("Invalid code point");
        }
      }
      return bytes;
    }
    function asciiToBytes(str) {
      const byteArray = [];
      for (let i = 0; i < str.length; ++i) {
        byteArray.push(str.charCodeAt(i) & 255);
      }
      return byteArray;
    }
    function utf16leToBytes(str, units) {
      let c, hi, lo;
      const byteArray = [];
      for (let i = 0; i < str.length; ++i) {
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
      }
      return byteArray;
    }
    function base64ToBytes(str) {
      return base64.toByteArray(base64clean(str));
    }
    function blitBuffer(src, dst, offset4, length2) {
      let i;
      for (i = 0; i < length2; ++i) {
        if (i + offset4 >= dst.length || i >= src.length) break;
        dst[i + offset4] = src[i];
      }
      return i;
    }
    function isInstance(obj, type5) {
      return obj instanceof type5 || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type5.name;
    }
    function numberIsNaN(obj) {
      return obj !== obj;
    }
    var hexSliceLookupTable = (function() {
      const alphabet = "0123456789abcdef";
      const table = new Array(256);
      for (let i = 0; i < 16; ++i) {
        const i16 = i * 16;
        for (let j = 0; j < 16; ++j) {
          table[i16 + j] = alphabet[i] + alphabet[j];
        }
      }
      return table;
    })();
    function defineBigIntMethod(fn) {
      return typeof BigInt === "undefined" ? BufferBigIntNotDefined : fn;
    }
    function BufferBigIntNotDefined() {
      throw new Error("BigInt not supported");
    }
  }
});

// (disabled):fs
var require_fs = __commonJS({
  "(disabled):fs"() {
  }
});

// (disabled):../../node_modules/canvas/browser.js
var require_browser = __commonJS({
  "(disabled):../../node_modules/canvas/browser.js"() {
  }
});

// (disabled):url
var require_url = __commonJS({
  "(disabled):url"() {
  }
});

// (disabled):http
var require_http = __commonJS({
  "(disabled):http"() {
  }
});

// (disabled):https
var require_https = __commonJS({
  "(disabled):https"() {
  }
});

// (disabled):zlib
var require_zlib = __commonJS({
  "(disabled):zlib"() {
  }
});

// ../../node_modules/pdfjs-dist/build/pdf.js
var require_pdf = __commonJS({
  "../../node_modules/pdfjs-dist/build/pdf.js"(exports, module) {
    (function webpackUniversalModuleDefinition(root2, factory) {
      if (typeof exports === "object" && typeof module === "object")
        module.exports = root2.pdfjsLib = factory();
      else if (typeof define === "function" && define.amd)
        define("pdfjs-dist/build/pdf", [], () => {
          return root2.pdfjsLib = factory();
        });
      else if (typeof exports === "object")
        exports["pdfjs-dist/build/pdf"] = root2.pdfjsLib = factory();
      else
        root2["pdfjs-dist/build/pdf"] = root2.pdfjsLib = factory();
    })(globalThis, () => {
      return (
        /******/
        (() => {
          "use strict";
          var __webpack_modules__ = [
            ,
            /* 1 */
            /***/
            ((__unused_webpack_module2, exports2) => {
              Object.defineProperty(exports2, "__esModule", {
                value: true
              });
              exports2.VerbosityLevel = exports2.Util = exports2.UnknownErrorException = exports2.UnexpectedResponseException = exports2.TextRenderingMode = exports2.RenderingIntentFlag = exports2.PromiseCapability = exports2.PermissionFlag = exports2.PasswordResponses = exports2.PasswordException = exports2.PageActionEventType = exports2.OPS = exports2.MissingPDFException = exports2.MAX_IMAGE_SIZE_TO_CACHE = exports2.LINE_FACTOR = exports2.LINE_DESCENT_FACTOR = exports2.InvalidPDFException = exports2.ImageKind = exports2.IDENTITY_MATRIX = exports2.FormatError = exports2.FeatureTest = exports2.FONT_IDENTITY_MATRIX = exports2.DocumentActionEventType = exports2.CMapCompressionType = exports2.BaseException = exports2.BASELINE_FACTOR = exports2.AnnotationType = exports2.AnnotationReplyType = exports2.AnnotationPrefix = exports2.AnnotationMode = exports2.AnnotationFlag = exports2.AnnotationFieldFlag = exports2.AnnotationEditorType = exports2.AnnotationEditorPrefix = exports2.AnnotationEditorParamsType = exports2.AnnotationBorderStyleType = exports2.AnnotationActionEventType = exports2.AbortException = void 0;
              exports2.assert = assert;
              exports2.bytesToString = bytesToString;
              exports2.createValidAbsoluteUrl = createValidAbsoluteUrl;
              exports2.getModificationDate = getModificationDate;
              exports2.getUuid = getUuid;
              exports2.getVerbosityLevel = getVerbosityLevel;
              exports2.info = info;
              exports2.isArrayBuffer = isArrayBuffer;
              exports2.isArrayEqual = isArrayEqual;
              exports2.isNodeJS = void 0;
              exports2.normalizeUnicode = normalizeUnicode;
              exports2.objectFromMap = objectFromMap;
              exports2.objectSize = objectSize;
              exports2.setVerbosityLevel = setVerbosityLevel;
              exports2.shadow = shadow;
              exports2.string32 = string32;
              exports2.stringToBytes = stringToBytes;
              exports2.stringToPDFString = stringToPDFString;
              exports2.stringToUTF8String = stringToUTF8String;
              exports2.unreachable = unreachable;
              exports2.utf8StringToString = utf8StringToString;
              exports2.warn = warn;
              const isNodeJS = typeof process === "object" && process + "" === "[object process]" && !process.versions.nw && !(process.versions.electron && process.type && process.type !== "browser");
              exports2.isNodeJS = isNodeJS;
              const IDENTITY_MATRIX = [1, 0, 0, 1, 0, 0];
              exports2.IDENTITY_MATRIX = IDENTITY_MATRIX;
              const FONT_IDENTITY_MATRIX = [1e-3, 0, 0, 1e-3, 0, 0];
              exports2.FONT_IDENTITY_MATRIX = FONT_IDENTITY_MATRIX;
              const MAX_IMAGE_SIZE_TO_CACHE = 1e7;
              exports2.MAX_IMAGE_SIZE_TO_CACHE = MAX_IMAGE_SIZE_TO_CACHE;
              const LINE_FACTOR = 1.35;
              exports2.LINE_FACTOR = LINE_FACTOR;
              const LINE_DESCENT_FACTOR = 0.35;
              exports2.LINE_DESCENT_FACTOR = LINE_DESCENT_FACTOR;
              const BASELINE_FACTOR = LINE_DESCENT_FACTOR / LINE_FACTOR;
              exports2.BASELINE_FACTOR = BASELINE_FACTOR;
              const RenderingIntentFlag = {
                ANY: 1,
                DISPLAY: 2,
                PRINT: 4,
                SAVE: 8,
                ANNOTATIONS_FORMS: 16,
                ANNOTATIONS_STORAGE: 32,
                ANNOTATIONS_DISABLE: 64,
                OPLIST: 256
              };
              exports2.RenderingIntentFlag = RenderingIntentFlag;
              const AnnotationMode = {
                DISABLE: 0,
                ENABLE: 1,
                ENABLE_FORMS: 2,
                ENABLE_STORAGE: 3
              };
              exports2.AnnotationMode = AnnotationMode;
              const AnnotationEditorPrefix = "pdfjs_internal_editor_";
              exports2.AnnotationEditorPrefix = AnnotationEditorPrefix;
              const AnnotationEditorType = {
                DISABLE: -1,
                NONE: 0,
                FREETEXT: 3,
                STAMP: 13,
                INK: 15
              };
              exports2.AnnotationEditorType = AnnotationEditorType;
              const AnnotationEditorParamsType = {
                RESIZE: 1,
                CREATE: 2,
                FREETEXT_SIZE: 11,
                FREETEXT_COLOR: 12,
                FREETEXT_OPACITY: 13,
                INK_COLOR: 21,
                INK_THICKNESS: 22,
                INK_OPACITY: 23
              };
              exports2.AnnotationEditorParamsType = AnnotationEditorParamsType;
              const PermissionFlag = {
                PRINT: 4,
                MODIFY_CONTENTS: 8,
                COPY: 16,
                MODIFY_ANNOTATIONS: 32,
                FILL_INTERACTIVE_FORMS: 256,
                COPY_FOR_ACCESSIBILITY: 512,
                ASSEMBLE: 1024,
                PRINT_HIGH_QUALITY: 2048
              };
              exports2.PermissionFlag = PermissionFlag;
              const TextRenderingMode = {
                FILL: 0,
                STROKE: 1,
                FILL_STROKE: 2,
                INVISIBLE: 3,
                FILL_ADD_TO_PATH: 4,
                STROKE_ADD_TO_PATH: 5,
                FILL_STROKE_ADD_TO_PATH: 6,
                ADD_TO_PATH: 7,
                FILL_STROKE_MASK: 3,
                ADD_TO_PATH_FLAG: 4
              };
              exports2.TextRenderingMode = TextRenderingMode;
              const ImageKind = {
                GRAYSCALE_1BPP: 1,
                RGB_24BPP: 2,
                RGBA_32BPP: 3
              };
              exports2.ImageKind = ImageKind;
              const AnnotationType = {
                TEXT: 1,
                LINK: 2,
                FREETEXT: 3,
                LINE: 4,
                SQUARE: 5,
                CIRCLE: 6,
                POLYGON: 7,
                POLYLINE: 8,
                HIGHLIGHT: 9,
                UNDERLINE: 10,
                SQUIGGLY: 11,
                STRIKEOUT: 12,
                STAMP: 13,
                CARET: 14,
                INK: 15,
                POPUP: 16,
                FILEATTACHMENT: 17,
                SOUND: 18,
                MOVIE: 19,
                WIDGET: 20,
                SCREEN: 21,
                PRINTERMARK: 22,
                TRAPNET: 23,
                WATERMARK: 24,
                THREED: 25,
                REDACT: 26
              };
              exports2.AnnotationType = AnnotationType;
              const AnnotationReplyType = {
                GROUP: "Group",
                REPLY: "R"
              };
              exports2.AnnotationReplyType = AnnotationReplyType;
              const AnnotationFlag = {
                INVISIBLE: 1,
                HIDDEN: 2,
                PRINT: 4,
                NOZOOM: 8,
                NOROTATE: 16,
                NOVIEW: 32,
                READONLY: 64,
                LOCKED: 128,
                TOGGLENOVIEW: 256,
                LOCKEDCONTENTS: 512
              };
              exports2.AnnotationFlag = AnnotationFlag;
              const AnnotationFieldFlag = {
                READONLY: 1,
                REQUIRED: 2,
                NOEXPORT: 4,
                MULTILINE: 4096,
                PASSWORD: 8192,
                NOTOGGLETOOFF: 16384,
                RADIO: 32768,
                PUSHBUTTON: 65536,
                COMBO: 131072,
                EDIT: 262144,
                SORT: 524288,
                FILESELECT: 1048576,
                MULTISELECT: 2097152,
                DONOTSPELLCHECK: 4194304,
                DONOTSCROLL: 8388608,
                COMB: 16777216,
                RICHTEXT: 33554432,
                RADIOSINUNISON: 33554432,
                COMMITONSELCHANGE: 67108864
              };
              exports2.AnnotationFieldFlag = AnnotationFieldFlag;
              const AnnotationBorderStyleType = {
                SOLID: 1,
                DASHED: 2,
                BEVELED: 3,
                INSET: 4,
                UNDERLINE: 5
              };
              exports2.AnnotationBorderStyleType = AnnotationBorderStyleType;
              const AnnotationActionEventType = {
                E: "Mouse Enter",
                X: "Mouse Exit",
                D: "Mouse Down",
                U: "Mouse Up",
                Fo: "Focus",
                Bl: "Blur",
                PO: "PageOpen",
                PC: "PageClose",
                PV: "PageVisible",
                PI: "PageInvisible",
                K: "Keystroke",
                F: "Format",
                V: "Validate",
                C: "Calculate"
              };
              exports2.AnnotationActionEventType = AnnotationActionEventType;
              const DocumentActionEventType = {
                WC: "WillClose",
                WS: "WillSave",
                DS: "DidSave",
                WP: "WillPrint",
                DP: "DidPrint"
              };
              exports2.DocumentActionEventType = DocumentActionEventType;
              const PageActionEventType = {
                O: "PageOpen",
                C: "PageClose"
              };
              exports2.PageActionEventType = PageActionEventType;
              const VerbosityLevel = {
                ERRORS: 0,
                WARNINGS: 1,
                INFOS: 5
              };
              exports2.VerbosityLevel = VerbosityLevel;
              const CMapCompressionType = {
                NONE: 0,
                BINARY: 1
              };
              exports2.CMapCompressionType = CMapCompressionType;
              const OPS = {
                dependency: 1,
                setLineWidth: 2,
                setLineCap: 3,
                setLineJoin: 4,
                setMiterLimit: 5,
                setDash: 6,
                setRenderingIntent: 7,
                setFlatness: 8,
                setGState: 9,
                save: 10,
                restore: 11,
                transform: 12,
                moveTo: 13,
                lineTo: 14,
                curveTo: 15,
                curveTo2: 16,
                curveTo3: 17,
                closePath: 18,
                rectangle: 19,
                stroke: 20,
                closeStroke: 21,
                fill: 22,
                eoFill: 23,
                fillStroke: 24,
                eoFillStroke: 25,
                closeFillStroke: 26,
                closeEOFillStroke: 27,
                endPath: 28,
                clip: 29,
                eoClip: 30,
                beginText: 31,
                endText: 32,
                setCharSpacing: 33,
                setWordSpacing: 34,
                setHScale: 35,
                setLeading: 36,
                setFont: 37,
                setTextRenderingMode: 38,
                setTextRise: 39,
                moveText: 40,
                setLeadingMoveText: 41,
                setTextMatrix: 42,
                nextLine: 43,
                showText: 44,
                showSpacedText: 45,
                nextLineShowText: 46,
                nextLineSetSpacingShowText: 47,
                setCharWidth: 48,
                setCharWidthAndBounds: 49,
                setStrokeColorSpace: 50,
                setFillColorSpace: 51,
                setStrokeColor: 52,
                setStrokeColorN: 53,
                setFillColor: 54,
                setFillColorN: 55,
                setStrokeGray: 56,
                setFillGray: 57,
                setStrokeRGBColor: 58,
                setFillRGBColor: 59,
                setStrokeCMYKColor: 60,
                setFillCMYKColor: 61,
                shadingFill: 62,
                beginInlineImage: 63,
                beginImageData: 64,
                endInlineImage: 65,
                paintXObject: 66,
                markPoint: 67,
                markPointProps: 68,
                beginMarkedContent: 69,
                beginMarkedContentProps: 70,
                endMarkedContent: 71,
                beginCompat: 72,
                endCompat: 73,
                paintFormXObjectBegin: 74,
                paintFormXObjectEnd: 75,
                beginGroup: 76,
                endGroup: 77,
                beginAnnotation: 80,
                endAnnotation: 81,
                paintImageMaskXObject: 83,
                paintImageMaskXObjectGroup: 84,
                paintImageXObject: 85,
                paintInlineImageXObject: 86,
                paintInlineImageXObjectGroup: 87,
                paintImageXObjectRepeat: 88,
                paintImageMaskXObjectRepeat: 89,
                paintSolidColorImageMask: 90,
                constructPath: 91
              };
              exports2.OPS = OPS;
              const PasswordResponses = {
                NEED_PASSWORD: 1,
                INCORRECT_PASSWORD: 2
              };
              exports2.PasswordResponses = PasswordResponses;
              let verbosity = VerbosityLevel.WARNINGS;
              function setVerbosityLevel(level) {
                if (Number.isInteger(level)) {
                  verbosity = level;
                }
              }
              function getVerbosityLevel() {
                return verbosity;
              }
              function info(msg) {
                if (verbosity >= VerbosityLevel.INFOS) {
                  console.log(`Info: ${msg}`);
                }
              }
              function warn(msg) {
                if (verbosity >= VerbosityLevel.WARNINGS) {
                  console.log(`Warning: ${msg}`);
                }
              }
              function unreachable(msg) {
                throw new Error(msg);
              }
              function assert(cond, msg) {
                if (!cond) {
                  unreachable(msg);
                }
              }
              function _isValidProtocol(url2) {
                switch (url2?.protocol) {
                  case "http:":
                  case "https:":
                  case "ftp:":
                  case "mailto:":
                  case "tel:":
                    return true;
                  default:
                    return false;
                }
              }
              function createValidAbsoluteUrl(url2, baseUrl = null, options = null) {
                if (!url2) {
                  return null;
                }
                try {
                  if (options && typeof url2 === "string") {
                    if (options.addDefaultProtocol && url2.startsWith("www.")) {
                      const dots = url2.match(/\./g);
                      if (dots?.length >= 2) {
                        url2 = `http://${url2}`;
                      }
                    }
                    if (options.tryConvertEncoding) {
                      try {
                        url2 = stringToUTF8String(url2);
                      } catch {
                      }
                    }
                  }
                  const absoluteUrl = baseUrl ? new URL(url2, baseUrl) : new URL(url2);
                  if (_isValidProtocol(absoluteUrl)) {
                    return absoluteUrl;
                  }
                } catch {
                }
                return null;
              }
              function shadow(obj, prop, value, nonSerializable = false) {
                Object.defineProperty(obj, prop, {
                  value,
                  enumerable: !nonSerializable,
                  configurable: true,
                  writable: false
                });
                return value;
              }
              const BaseException = (function BaseExceptionClosure() {
                function BaseException2(message2, name) {
                  if (this.constructor === BaseException2) {
                    unreachable("Cannot initialize BaseException.");
                  }
                  this.message = message2;
                  this.name = name;
                }
                BaseException2.prototype = new Error();
                BaseException2.constructor = BaseException2;
                return BaseException2;
              })();
              exports2.BaseException = BaseException;
              class PasswordException extends BaseException {
                constructor(msg, code2) {
                  super(msg, "PasswordException");
                  this.code = code2;
                }
              }
              exports2.PasswordException = PasswordException;
              class UnknownErrorException extends BaseException {
                constructor(msg, details) {
                  super(msg, "UnknownErrorException");
                  this.details = details;
                }
              }
              exports2.UnknownErrorException = UnknownErrorException;
              class InvalidPDFException extends BaseException {
                constructor(msg) {
                  super(msg, "InvalidPDFException");
                }
              }
              exports2.InvalidPDFException = InvalidPDFException;
              class MissingPDFException extends BaseException {
                constructor(msg) {
                  super(msg, "MissingPDFException");
                }
              }
              exports2.MissingPDFException = MissingPDFException;
              class UnexpectedResponseException extends BaseException {
                constructor(msg, status) {
                  super(msg, "UnexpectedResponseException");
                  this.status = status;
                }
              }
              exports2.UnexpectedResponseException = UnexpectedResponseException;
              class FormatError extends BaseException {
                constructor(msg) {
                  super(msg, "FormatError");
                }
              }
              exports2.FormatError = FormatError;
              class AbortException extends BaseException {
                constructor(msg) {
                  super(msg, "AbortException");
                }
              }
              exports2.AbortException = AbortException;
              function bytesToString(bytes) {
                if (typeof bytes !== "object" || bytes?.length === void 0) {
                  unreachable("Invalid argument for bytesToString");
                }
                const length2 = bytes.length;
                const MAX_ARGUMENT_COUNT = 8192;
                if (length2 < MAX_ARGUMENT_COUNT) {
                  return String.fromCharCode.apply(null, bytes);
                }
                const strBuf = [];
                for (let i = 0; i < length2; i += MAX_ARGUMENT_COUNT) {
                  const chunkEnd = Math.min(i + MAX_ARGUMENT_COUNT, length2);
                  const chunk = bytes.subarray(i, chunkEnd);
                  strBuf.push(String.fromCharCode.apply(null, chunk));
                }
                return strBuf.join("");
              }
              function stringToBytes(str) {
                if (typeof str !== "string") {
                  unreachable("Invalid argument for stringToBytes");
                }
                const length2 = str.length;
                const bytes = new Uint8Array(length2);
                for (let i = 0; i < length2; ++i) {
                  bytes[i] = str.charCodeAt(i) & 255;
                }
                return bytes;
              }
              function string32(value) {
                return String.fromCharCode(value >> 24 & 255, value >> 16 & 255, value >> 8 & 255, value & 255);
              }
              function objectSize(obj) {
                return Object.keys(obj).length;
              }
              function objectFromMap(map) {
                const obj = /* @__PURE__ */ Object.create(null);
                for (const [key2, value] of map) {
                  obj[key2] = value;
                }
                return obj;
              }
              function isLittleEndian() {
                const buffer8 = new Uint8Array(4);
                buffer8[0] = 1;
                const view32 = new Uint32Array(buffer8.buffer, 0, 1);
                return view32[0] === 1;
              }
              function isEvalSupported() {
                try {
                  new Function("");
                  return true;
                } catch {
                  return false;
                }
              }
              class FeatureTest {
                static get isLittleEndian() {
                  return shadow(this, "isLittleEndian", isLittleEndian());
                }
                static get isEvalSupported() {
                  return shadow(this, "isEvalSupported", isEvalSupported());
                }
                static get isOffscreenCanvasSupported() {
                  return shadow(this, "isOffscreenCanvasSupported", typeof OffscreenCanvas !== "undefined");
                }
                static get platform() {
                  if (typeof navigator === "undefined") {
                    return shadow(this, "platform", {
                      isWin: false,
                      isMac: false
                    });
                  }
                  return shadow(this, "platform", {
                    isWin: navigator.platform.includes("Win"),
                    isMac: navigator.platform.includes("Mac")
                  });
                }
                static get isCSSRoundSupported() {
                  return shadow(this, "isCSSRoundSupported", globalThis.CSS?.supports?.("width: round(1.5px, 1px)"));
                }
              }
              exports2.FeatureTest = FeatureTest;
              const hexNumbers = [...Array(256).keys()].map((n2) => n2.toString(16).padStart(2, "0"));
              class Util {
                static makeHexColor(r2, g, b) {
                  return `#${hexNumbers[r2]}${hexNumbers[g]}${hexNumbers[b]}`;
                }
                static scaleMinMax(transform, minMax) {
                  let temp;
                  if (transform[0]) {
                    if (transform[0] < 0) {
                      temp = minMax[0];
                      minMax[0] = minMax[1];
                      minMax[1] = temp;
                    }
                    minMax[0] *= transform[0];
                    minMax[1] *= transform[0];
                    if (transform[3] < 0) {
                      temp = minMax[2];
                      minMax[2] = minMax[3];
                      minMax[3] = temp;
                    }
                    minMax[2] *= transform[3];
                    minMax[3] *= transform[3];
                  } else {
                    temp = minMax[0];
                    minMax[0] = minMax[2];
                    minMax[2] = temp;
                    temp = minMax[1];
                    minMax[1] = minMax[3];
                    minMax[3] = temp;
                    if (transform[1] < 0) {
                      temp = minMax[2];
                      minMax[2] = minMax[3];
                      minMax[3] = temp;
                    }
                    minMax[2] *= transform[1];
                    minMax[3] *= transform[1];
                    if (transform[2] < 0) {
                      temp = minMax[0];
                      minMax[0] = minMax[1];
                      minMax[1] = temp;
                    }
                    minMax[0] *= transform[2];
                    minMax[1] *= transform[2];
                  }
                  minMax[0] += transform[4];
                  minMax[1] += transform[4];
                  minMax[2] += transform[5];
                  minMax[3] += transform[5];
                }
                static transform(m1, m2) {
                  return [m1[0] * m2[0] + m1[2] * m2[1], m1[1] * m2[0] + m1[3] * m2[1], m1[0] * m2[2] + m1[2] * m2[3], m1[1] * m2[2] + m1[3] * m2[3], m1[0] * m2[4] + m1[2] * m2[5] + m1[4], m1[1] * m2[4] + m1[3] * m2[5] + m1[5]];
                }
                static applyTransform(p, m) {
                  const xt = p[0] * m[0] + p[1] * m[2] + m[4];
                  const yt = p[0] * m[1] + p[1] * m[3] + m[5];
                  return [xt, yt];
                }
                static applyInverseTransform(p, m) {
                  const d = m[0] * m[3] - m[1] * m[2];
                  const xt = (p[0] * m[3] - p[1] * m[2] + m[2] * m[5] - m[4] * m[3]) / d;
                  const yt = (-p[0] * m[1] + p[1] * m[0] + m[4] * m[1] - m[5] * m[0]) / d;
                  return [xt, yt];
                }
                static getAxialAlignedBoundingBox(r2, m) {
                  const p1 = this.applyTransform(r2, m);
                  const p2 = this.applyTransform(r2.slice(2, 4), m);
                  const p3 = this.applyTransform([r2[0], r2[3]], m);
                  const p4 = this.applyTransform([r2[2], r2[1]], m);
                  return [Math.min(p1[0], p2[0], p3[0], p4[0]), Math.min(p1[1], p2[1], p3[1], p4[1]), Math.max(p1[0], p2[0], p3[0], p4[0]), Math.max(p1[1], p2[1], p3[1], p4[1])];
                }
                static inverseTransform(m) {
                  const d = m[0] * m[3] - m[1] * m[2];
                  return [m[3] / d, -m[1] / d, -m[2] / d, m[0] / d, (m[2] * m[5] - m[4] * m[3]) / d, (m[4] * m[1] - m[5] * m[0]) / d];
                }
                static singularValueDecompose2dScale(m) {
                  const transpose2 = [m[0], m[2], m[1], m[3]];
                  const a = m[0] * transpose2[0] + m[1] * transpose2[2];
                  const b = m[0] * transpose2[1] + m[1] * transpose2[3];
                  const c = m[2] * transpose2[0] + m[3] * transpose2[2];
                  const d = m[2] * transpose2[1] + m[3] * transpose2[3];
                  const first = (a + d) / 2;
                  const second = Math.sqrt((a + d) ** 2 - 4 * (a * d - c * b)) / 2;
                  const sx = first + second || 1;
                  const sy = first - second || 1;
                  return [Math.sqrt(sx), Math.sqrt(sy)];
                }
                static normalizeRect(rect) {
                  const r2 = rect.slice(0);
                  if (rect[0] > rect[2]) {
                    r2[0] = rect[2];
                    r2[2] = rect[0];
                  }
                  if (rect[1] > rect[3]) {
                    r2[1] = rect[3];
                    r2[3] = rect[1];
                  }
                  return r2;
                }
                static intersect(rect1, rect2) {
                  const xLow = Math.max(Math.min(rect1[0], rect1[2]), Math.min(rect2[0], rect2[2]));
                  const xHigh = Math.min(Math.max(rect1[0], rect1[2]), Math.max(rect2[0], rect2[2]));
                  if (xLow > xHigh) {
                    return null;
                  }
                  const yLow = Math.max(Math.min(rect1[1], rect1[3]), Math.min(rect2[1], rect2[3]));
                  const yHigh = Math.min(Math.max(rect1[1], rect1[3]), Math.max(rect2[1], rect2[3]));
                  if (yLow > yHigh) {
                    return null;
                  }
                  return [xLow, yLow, xHigh, yHigh];
                }
                static bezierBoundingBox(x0, y0, x1, y1, x2, y2, x3, y3) {
                  const tvalues = [], bounds = [[], []];
                  let a, b, c, t2, t1, t22, b2ac, sqrtb2ac;
                  for (let i = 0; i < 2; ++i) {
                    if (i === 0) {
                      b = 6 * x0 - 12 * x1 + 6 * x2;
                      a = -3 * x0 + 9 * x1 - 9 * x2 + 3 * x3;
                      c = 3 * x1 - 3 * x0;
                    } else {
                      b = 6 * y0 - 12 * y1 + 6 * y2;
                      a = -3 * y0 + 9 * y1 - 9 * y2 + 3 * y3;
                      c = 3 * y1 - 3 * y0;
                    }
                    if (Math.abs(a) < 1e-12) {
                      if (Math.abs(b) < 1e-12) {
                        continue;
                      }
                      t2 = -c / b;
                      if (0 < t2 && t2 < 1) {
                        tvalues.push(t2);
                      }
                      continue;
                    }
                    b2ac = b * b - 4 * c * a;
                    sqrtb2ac = Math.sqrt(b2ac);
                    if (b2ac < 0) {
                      continue;
                    }
                    t1 = (-b + sqrtb2ac) / (2 * a);
                    if (0 < t1 && t1 < 1) {
                      tvalues.push(t1);
                    }
                    t22 = (-b - sqrtb2ac) / (2 * a);
                    if (0 < t22 && t22 < 1) {
                      tvalues.push(t22);
                    }
                  }
                  let j = tvalues.length, mt;
                  const jlen = j;
                  while (j--) {
                    t2 = tvalues[j];
                    mt = 1 - t2;
                    bounds[0][j] = mt * mt * mt * x0 + 3 * mt * mt * t2 * x1 + 3 * mt * t2 * t2 * x2 + t2 * t2 * t2 * x3;
                    bounds[1][j] = mt * mt * mt * y0 + 3 * mt * mt * t2 * y1 + 3 * mt * t2 * t2 * y2 + t2 * t2 * t2 * y3;
                  }
                  bounds[0][jlen] = x0;
                  bounds[1][jlen] = y0;
                  bounds[0][jlen + 1] = x3;
                  bounds[1][jlen + 1] = y3;
                  bounds[0].length = bounds[1].length = jlen + 2;
                  return [Math.min(...bounds[0]), Math.min(...bounds[1]), Math.max(...bounds[0]), Math.max(...bounds[1])];
                }
              }
              exports2.Util = Util;
              const PDFStringTranslateTable = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 728, 711, 710, 729, 733, 731, 730, 732, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 8226, 8224, 8225, 8230, 8212, 8211, 402, 8260, 8249, 8250, 8722, 8240, 8222, 8220, 8221, 8216, 8217, 8218, 8482, 64257, 64258, 321, 338, 352, 376, 381, 305, 322, 339, 353, 382, 0, 8364];
              function stringToPDFString(str) {
                if (str[0] >= "\xEF") {
                  let encoding;
                  if (str[0] === "\xFE" && str[1] === "\xFF") {
                    encoding = "utf-16be";
                  } else if (str[0] === "\xFF" && str[1] === "\xFE") {
                    encoding = "utf-16le";
                  } else if (str[0] === "\xEF" && str[1] === "\xBB" && str[2] === "\xBF") {
                    encoding = "utf-8";
                  }
                  if (encoding) {
                    try {
                      const decoder = new TextDecoder(encoding, {
                        fatal: true
                      });
                      const buffer = stringToBytes(str);
                      return decoder.decode(buffer);
                    } catch (ex) {
                      warn(`stringToPDFString: "${ex}".`);
                    }
                  }
                }
                const strBuf = [];
                for (let i = 0, ii = str.length; i < ii; i++) {
                  const code2 = PDFStringTranslateTable[str.charCodeAt(i)];
                  strBuf.push(code2 ? String.fromCharCode(code2) : str.charAt(i));
                }
                return strBuf.join("");
              }
              function stringToUTF8String(str) {
                return decodeURIComponent(escape(str));
              }
              function utf8StringToString(str) {
                return unescape(encodeURIComponent(str));
              }
              function isArrayBuffer(v) {
                return typeof v === "object" && v?.byteLength !== void 0;
              }
              function isArrayEqual(arr1, arr2) {
                if (arr1.length !== arr2.length) {
                  return false;
                }
                for (let i = 0, ii = arr1.length; i < ii; i++) {
                  if (arr1[i] !== arr2[i]) {
                    return false;
                  }
                }
                return true;
              }
              function getModificationDate(date4 = /* @__PURE__ */ new Date()) {
                const buffer = [date4.getUTCFullYear().toString(), (date4.getUTCMonth() + 1).toString().padStart(2, "0"), date4.getUTCDate().toString().padStart(2, "0"), date4.getUTCHours().toString().padStart(2, "0"), date4.getUTCMinutes().toString().padStart(2, "0"), date4.getUTCSeconds().toString().padStart(2, "0")];
                return buffer.join("");
              }
              class PromiseCapability {
                #settled = false;
                constructor() {
                  this.promise = new Promise((resolve, reject) => {
                    this.resolve = (data2) => {
                      this.#settled = true;
                      resolve(data2);
                    };
                    this.reject = (reason) => {
                      this.#settled = true;
                      reject(reason);
                    };
                  });
                }
                get settled() {
                  return this.#settled;
                }
              }
              exports2.PromiseCapability = PromiseCapability;
              let NormalizeRegex = null;
              let NormalizationMap = null;
              function normalizeUnicode(str) {
                if (!NormalizeRegex) {
                  NormalizeRegex = /([\u00a0\u00b5\u037e\u0eb3\u2000-\u200a\u202f\u2126\ufb00-\ufb04\ufb06\ufb20-\ufb36\ufb38-\ufb3c\ufb3e\ufb40-\ufb41\ufb43-\ufb44\ufb46-\ufba1\ufba4-\ufba9\ufbae-\ufbb1\ufbd3-\ufbdc\ufbde-\ufbe7\ufbea-\ufbf8\ufbfc-\ufbfd\ufc00-\ufc5d\ufc64-\ufcf1\ufcf5-\ufd3d\ufd88\ufdf4\ufdfa-\ufdfb\ufe71\ufe77\ufe79\ufe7b\ufe7d]+)|(\ufb05+)/gu;
                  NormalizationMap = /* @__PURE__ */ new Map([["\uFB05", "\u017Ft"]]);
                }
                return str.replaceAll(NormalizeRegex, (_, p1, p2) => {
                  return p1 ? p1.normalize("NFKC") : NormalizationMap.get(p2);
                });
              }
              function getUuid() {
                if (typeof crypto !== "undefined" && typeof crypto?.randomUUID === "function") {
                  return crypto.randomUUID();
                }
                const buf = new Uint8Array(32);
                if (typeof crypto !== "undefined" && typeof crypto?.getRandomValues === "function") {
                  crypto.getRandomValues(buf);
                } else {
                  for (let i = 0; i < 32; i++) {
                    buf[i] = Math.floor(Math.random() * 255);
                  }
                }
                return bytesToString(buf);
              }
              const AnnotationPrefix = "pdfjs_internal_id_";
              exports2.AnnotationPrefix = AnnotationPrefix;
            }),
            /* 2 */
            /***/
            ((__unused_webpack_module, exports, __w_pdfjs_require__) => {
              Object.defineProperty(exports, "__esModule", {
                value: true
              });
              exports.RenderTask = exports.PDFWorkerUtil = exports.PDFWorker = exports.PDFPageProxy = exports.PDFDocumentProxy = exports.PDFDocumentLoadingTask = exports.PDFDataRangeTransport = exports.LoopbackPort = exports.DefaultStandardFontDataFactory = exports.DefaultFilterFactory = exports.DefaultCanvasFactory = exports.DefaultCMapReaderFactory = void 0;
              Object.defineProperty(exports, "SVGGraphics", {
                enumerable: true,
                get: function() {
                  return _displaySvg.SVGGraphics;
                }
              });
              exports.build = void 0;
              exports.getDocument = getDocument;
              exports.version = void 0;
              var _util = __w_pdfjs_require__(1);
              var _annotation_storage = __w_pdfjs_require__(3);
              var _display_utils = __w_pdfjs_require__(6);
              var _font_loader = __w_pdfjs_require__(9);
              var _displayNode_utils = __w_pdfjs_require__(10);
              var _canvas = __w_pdfjs_require__(11);
              var _worker_options = __w_pdfjs_require__(14);
              var _message_handler = __w_pdfjs_require__(15);
              var _metadata = __w_pdfjs_require__(16);
              var _optional_content_config = __w_pdfjs_require__(17);
              var _transport_stream = __w_pdfjs_require__(18);
              var _displayFetch_stream = __w_pdfjs_require__(19);
              var _displayNetwork = __w_pdfjs_require__(22);
              var _displayNode_stream = __w_pdfjs_require__(23);
              var _displaySvg = __w_pdfjs_require__(24);
              var _xfa_text = __w_pdfjs_require__(25);
              const DEFAULT_RANGE_CHUNK_SIZE = 65536;
              const RENDERING_CANCELLED_TIMEOUT = 100;
              const DELAYED_CLEANUP_TIMEOUT = 5e3;
              const DefaultCanvasFactory = _util.isNodeJS ? _displayNode_utils.NodeCanvasFactory : _display_utils.DOMCanvasFactory;
              exports.DefaultCanvasFactory = DefaultCanvasFactory;
              const DefaultCMapReaderFactory = _util.isNodeJS ? _displayNode_utils.NodeCMapReaderFactory : _display_utils.DOMCMapReaderFactory;
              exports.DefaultCMapReaderFactory = DefaultCMapReaderFactory;
              const DefaultFilterFactory = _util.isNodeJS ? _displayNode_utils.NodeFilterFactory : _display_utils.DOMFilterFactory;
              exports.DefaultFilterFactory = DefaultFilterFactory;
              const DefaultStandardFontDataFactory = _util.isNodeJS ? _displayNode_utils.NodeStandardFontDataFactory : _display_utils.DOMStandardFontDataFactory;
              exports.DefaultStandardFontDataFactory = DefaultStandardFontDataFactory;
              function getDocument(src) {
                if (typeof src === "string" || src instanceof URL) {
                  src = {
                    url: src
                  };
                } else if ((0, _util.isArrayBuffer)(src)) {
                  src = {
                    data: src
                  };
                }
                if (typeof src !== "object") {
                  throw new Error("Invalid parameter in getDocument, need parameter object.");
                }
                if (!src.url && !src.data && !src.range) {
                  throw new Error("Invalid parameter object: need either .data, .range or .url");
                }
                const task = new PDFDocumentLoadingTask();
                const {
                  docId
                } = task;
                const url2 = src.url ? getUrlProp(src.url) : null;
                const data2 = src.data ? getDataProp(src.data) : null;
                const httpHeaders = src.httpHeaders || null;
                const withCredentials = src.withCredentials === true;
                const password = src.password ?? null;
                const rangeTransport = src.range instanceof PDFDataRangeTransport ? src.range : null;
                const rangeChunkSize = Number.isInteger(src.rangeChunkSize) && src.rangeChunkSize > 0 ? src.rangeChunkSize : DEFAULT_RANGE_CHUNK_SIZE;
                let worker2 = src.worker instanceof PDFWorker ? src.worker : null;
                const verbosity = src.verbosity;
                const docBaseUrl = typeof src.docBaseUrl === "string" && !(0, _display_utils.isDataScheme)(src.docBaseUrl) ? src.docBaseUrl : null;
                const cMapUrl = typeof src.cMapUrl === "string" ? src.cMapUrl : null;
                const cMapPacked = src.cMapPacked !== false;
                const CMapReaderFactory = src.CMapReaderFactory || DefaultCMapReaderFactory;
                const standardFontDataUrl = typeof src.standardFontDataUrl === "string" ? src.standardFontDataUrl : null;
                const StandardFontDataFactory = src.StandardFontDataFactory || DefaultStandardFontDataFactory;
                const ignoreErrors = src.stopAtErrors !== true;
                const maxImageSize = Number.isInteger(src.maxImageSize) && src.maxImageSize > -1 ? src.maxImageSize : -1;
                const isEvalSupported = src.isEvalSupported !== false;
                const isOffscreenCanvasSupported = typeof src.isOffscreenCanvasSupported === "boolean" ? src.isOffscreenCanvasSupported : !_util.isNodeJS;
                const canvasMaxAreaInBytes = Number.isInteger(src.canvasMaxAreaInBytes) ? src.canvasMaxAreaInBytes : -1;
                const disableFontFace = typeof src.disableFontFace === "boolean" ? src.disableFontFace : _util.isNodeJS;
                const fontExtraProperties = src.fontExtraProperties === true;
                const enableXfa = src.enableXfa === true;
                const ownerDocument = src.ownerDocument || globalThis.document;
                const disableRange = src.disableRange === true;
                const disableStream = src.disableStream === true;
                const disableAutoFetch = src.disableAutoFetch === true;
                const pdfBug = src.pdfBug === true;
                const length2 = rangeTransport ? rangeTransport.length : src.length ?? NaN;
                const useSystemFonts = typeof src.useSystemFonts === "boolean" ? src.useSystemFonts : !_util.isNodeJS && !disableFontFace;
                const useWorkerFetch = typeof src.useWorkerFetch === "boolean" ? src.useWorkerFetch : CMapReaderFactory === _display_utils.DOMCMapReaderFactory && StandardFontDataFactory === _display_utils.DOMStandardFontDataFactory && cMapUrl && standardFontDataUrl && (0, _display_utils.isValidFetchUrl)(cMapUrl, document.baseURI) && (0, _display_utils.isValidFetchUrl)(standardFontDataUrl, document.baseURI);
                const canvasFactory = src.canvasFactory || new DefaultCanvasFactory({
                  ownerDocument
                });
                const filterFactory = src.filterFactory || new DefaultFilterFactory({
                  docId,
                  ownerDocument
                });
                const styleElement = null;
                (0, _util.setVerbosityLevel)(verbosity);
                const transportFactory = {
                  canvasFactory,
                  filterFactory
                };
                if (!useWorkerFetch) {
                  transportFactory.cMapReaderFactory = new CMapReaderFactory({
                    baseUrl: cMapUrl,
                    isCompressed: cMapPacked
                  });
                  transportFactory.standardFontDataFactory = new StandardFontDataFactory({
                    baseUrl: standardFontDataUrl
                  });
                }
                if (!worker2) {
                  const workerParams = {
                    verbosity,
                    port: _worker_options.GlobalWorkerOptions.workerPort
                  };
                  worker2 = workerParams.port ? PDFWorker.fromPort(workerParams) : new PDFWorker(workerParams);
                  task._worker = worker2;
                }
                const fetchDocParams = {
                  docId,
                  apiVersion: "3.11.174",
                  data: data2,
                  password,
                  disableAutoFetch,
                  rangeChunkSize,
                  length: length2,
                  docBaseUrl,
                  enableXfa,
                  evaluatorOptions: {
                    maxImageSize,
                    disableFontFace,
                    ignoreErrors,
                    isEvalSupported,
                    isOffscreenCanvasSupported,
                    canvasMaxAreaInBytes,
                    fontExtraProperties,
                    useSystemFonts,
                    cMapUrl: useWorkerFetch ? cMapUrl : null,
                    standardFontDataUrl: useWorkerFetch ? standardFontDataUrl : null
                  }
                };
                const transportParams = {
                  ignoreErrors,
                  isEvalSupported,
                  disableFontFace,
                  fontExtraProperties,
                  enableXfa,
                  ownerDocument,
                  disableAutoFetch,
                  pdfBug,
                  styleElement
                };
                worker2.promise.then(function() {
                  if (task.destroyed) {
                    throw new Error("Loading aborted");
                  }
                  const workerIdPromise = _fetchDocument(worker2, fetchDocParams);
                  const networkStreamPromise = new Promise(function(resolve) {
                    let networkStream;
                    if (rangeTransport) {
                      networkStream = new _transport_stream.PDFDataTransportStream({
                        length: length2,
                        initialData: rangeTransport.initialData,
                        progressiveDone: rangeTransport.progressiveDone,
                        contentDispositionFilename: rangeTransport.contentDispositionFilename,
                        disableRange,
                        disableStream
                      }, rangeTransport);
                    } else if (!data2) {
                      const createPDFNetworkStream = (params) => {
                        if (_util.isNodeJS) {
                          return new _displayNode_stream.PDFNodeStream(params);
                        }
                        return (0, _display_utils.isValidFetchUrl)(params.url) ? new _displayFetch_stream.PDFFetchStream(params) : new _displayNetwork.PDFNetworkStream(params);
                      };
                      networkStream = createPDFNetworkStream({
                        url: url2,
                        length: length2,
                        httpHeaders,
                        withCredentials,
                        rangeChunkSize,
                        disableRange,
                        disableStream
                      });
                    }
                    resolve(networkStream);
                  });
                  return Promise.all([workerIdPromise, networkStreamPromise]).then(function([workerId, networkStream]) {
                    if (task.destroyed) {
                      throw new Error("Loading aborted");
                    }
                    const messageHandler = new _message_handler.MessageHandler(docId, workerId, worker2.port);
                    const transport = new WorkerTransport(messageHandler, task, networkStream, transportParams, transportFactory);
                    task._transport = transport;
                    messageHandler.send("Ready", null);
                  });
                }).catch(task._capability.reject);
                return task;
              }
              async function _fetchDocument(worker2, source) {
                if (worker2.destroyed) {
                  throw new Error("Worker was destroyed");
                }
                const workerId = await worker2.messageHandler.sendWithPromise("GetDocRequest", source, source.data ? [source.data.buffer] : null);
                if (worker2.destroyed) {
                  throw new Error("Worker was destroyed");
                }
                return workerId;
              }
              function getUrlProp(val) {
                if (val instanceof URL) {
                  return val.href;
                }
                try {
                  return new URL(val, window.location).href;
                } catch {
                  if (_util.isNodeJS && typeof val === "string") {
                    return val;
                  }
                }
                throw new Error("Invalid PDF url data: either string or URL-object is expected in the url property.");
              }
              function getDataProp(val) {
                if (_util.isNodeJS && typeof Buffer !== "undefined" && val instanceof Buffer) {
                  throw new Error("Please provide binary data as `Uint8Array`, rather than `Buffer`.");
                }
                if (val instanceof Uint8Array && val.byteLength === val.buffer.byteLength) {
                  return val;
                }
                if (typeof val === "string") {
                  return (0, _util.stringToBytes)(val);
                }
                if (typeof val === "object" && !isNaN(val?.length) || (0, _util.isArrayBuffer)(val)) {
                  return new Uint8Array(val);
                }
                throw new Error("Invalid PDF binary data: either TypedArray, string, or array-like object is expected in the data property.");
              }
              class PDFDocumentLoadingTask {
                static #docId = 0;
                constructor() {
                  this._capability = new _util.PromiseCapability();
                  this._transport = null;
                  this._worker = null;
                  this.docId = `d${PDFDocumentLoadingTask.#docId++}`;
                  this.destroyed = false;
                  this.onPassword = null;
                  this.onProgress = null;
                }
                get promise() {
                  return this._capability.promise;
                }
                async destroy() {
                  this.destroyed = true;
                  try {
                    if (this._worker?.port) {
                      this._worker._pendingDestroy = true;
                    }
                    await this._transport?.destroy();
                  } catch (ex) {
                    if (this._worker?.port) {
                      delete this._worker._pendingDestroy;
                    }
                    throw ex;
                  }
                  this._transport = null;
                  if (this._worker) {
                    this._worker.destroy();
                    this._worker = null;
                  }
                }
              }
              exports.PDFDocumentLoadingTask = PDFDocumentLoadingTask;
              class PDFDataRangeTransport {
                constructor(length2, initialData, progressiveDone = false, contentDispositionFilename = null) {
                  this.length = length2;
                  this.initialData = initialData;
                  this.progressiveDone = progressiveDone;
                  this.contentDispositionFilename = contentDispositionFilename;
                  this._rangeListeners = [];
                  this._progressListeners = [];
                  this._progressiveReadListeners = [];
                  this._progressiveDoneListeners = [];
                  this._readyCapability = new _util.PromiseCapability();
                }
                addRangeListener(listener) {
                  this._rangeListeners.push(listener);
                }
                addProgressListener(listener) {
                  this._progressListeners.push(listener);
                }
                addProgressiveReadListener(listener) {
                  this._progressiveReadListeners.push(listener);
                }
                addProgressiveDoneListener(listener) {
                  this._progressiveDoneListeners.push(listener);
                }
                onDataRange(begin, chunk) {
                  for (const listener of this._rangeListeners) {
                    listener(begin, chunk);
                  }
                }
                onDataProgress(loaded, total) {
                  this._readyCapability.promise.then(() => {
                    for (const listener of this._progressListeners) {
                      listener(loaded, total);
                    }
                  });
                }
                onDataProgressiveRead(chunk) {
                  this._readyCapability.promise.then(() => {
                    for (const listener of this._progressiveReadListeners) {
                      listener(chunk);
                    }
                  });
                }
                onDataProgressiveDone() {
                  this._readyCapability.promise.then(() => {
                    for (const listener of this._progressiveDoneListeners) {
                      listener();
                    }
                  });
                }
                transportReady() {
                  this._readyCapability.resolve();
                }
                requestDataRange(begin, end) {
                  (0, _util.unreachable)("Abstract method PDFDataRangeTransport.requestDataRange");
                }
                abort() {
                }
              }
              exports.PDFDataRangeTransport = PDFDataRangeTransport;
              class PDFDocumentProxy {
                constructor(pdfInfo, transport) {
                  this._pdfInfo = pdfInfo;
                  this._transport = transport;
                  Object.defineProperty(this, "getJavaScript", {
                    value: () => {
                      (0, _display_utils.deprecated)("`PDFDocumentProxy.getJavaScript`, please use `PDFDocumentProxy.getJSActions` instead.");
                      return this.getJSActions().then((js) => {
                        if (!js) {
                          return js;
                        }
                        const jsArr = [];
                        for (const name in js) {
                          jsArr.push(...js[name]);
                        }
                        return jsArr;
                      });
                    }
                  });
                }
                get annotationStorage() {
                  return this._transport.annotationStorage;
                }
                get filterFactory() {
                  return this._transport.filterFactory;
                }
                get numPages() {
                  return this._pdfInfo.numPages;
                }
                get fingerprints() {
                  return this._pdfInfo.fingerprints;
                }
                get isPureXfa() {
                  return (0, _util.shadow)(this, "isPureXfa", !!this._transport._htmlForXfa);
                }
                get allXfaHtml() {
                  return this._transport._htmlForXfa;
                }
                getPage(pageNumber) {
                  return this._transport.getPage(pageNumber);
                }
                getPageIndex(ref3) {
                  return this._transport.getPageIndex(ref3);
                }
                getDestinations() {
                  return this._transport.getDestinations();
                }
                getDestination(id) {
                  return this._transport.getDestination(id);
                }
                getPageLabels() {
                  return this._transport.getPageLabels();
                }
                getPageLayout() {
                  return this._transport.getPageLayout();
                }
                getPageMode() {
                  return this._transport.getPageMode();
                }
                getViewerPreferences() {
                  return this._transport.getViewerPreferences();
                }
                getOpenAction() {
                  return this._transport.getOpenAction();
                }
                getAttachments() {
                  return this._transport.getAttachments();
                }
                getJSActions() {
                  return this._transport.getDocJSActions();
                }
                getOutline() {
                  return this._transport.getOutline();
                }
                getOptionalContentConfig() {
                  return this._transport.getOptionalContentConfig();
                }
                getPermissions() {
                  return this._transport.getPermissions();
                }
                getMetadata() {
                  return this._transport.getMetadata();
                }
                getMarkInfo() {
                  return this._transport.getMarkInfo();
                }
                getData() {
                  return this._transport.getData();
                }
                saveDocument() {
                  return this._transport.saveDocument();
                }
                getDownloadInfo() {
                  return this._transport.downloadInfoCapability.promise;
                }
                cleanup(keepLoadedFonts = false) {
                  return this._transport.startCleanup(keepLoadedFonts || this.isPureXfa);
                }
                destroy() {
                  return this.loadingTask.destroy();
                }
                get loadingParams() {
                  return this._transport.loadingParams;
                }
                get loadingTask() {
                  return this._transport.loadingTask;
                }
                getFieldObjects() {
                  return this._transport.getFieldObjects();
                }
                hasJSActions() {
                  return this._transport.hasJSActions();
                }
                getCalculationOrderIds() {
                  return this._transport.getCalculationOrderIds();
                }
              }
              exports.PDFDocumentProxy = PDFDocumentProxy;
              class PDFPageProxy {
                #delayedCleanupTimeout = null;
                #pendingCleanup = false;
                constructor(pageIndex, pageInfo, transport, pdfBug = false) {
                  this._pageIndex = pageIndex;
                  this._pageInfo = pageInfo;
                  this._transport = transport;
                  this._stats = pdfBug ? new _display_utils.StatTimer() : null;
                  this._pdfBug = pdfBug;
                  this.commonObjs = transport.commonObjs;
                  this.objs = new PDFObjects();
                  this._maybeCleanupAfterRender = false;
                  this._intentStates = /* @__PURE__ */ new Map();
                  this.destroyed = false;
                }
                get pageNumber() {
                  return this._pageIndex + 1;
                }
                get rotate() {
                  return this._pageInfo.rotate;
                }
                get ref() {
                  return this._pageInfo.ref;
                }
                get userUnit() {
                  return this._pageInfo.userUnit;
                }
                get view() {
                  return this._pageInfo.view;
                }
                getViewport({
                  scale,
                  rotation = this.rotate,
                  offsetX = 0,
                  offsetY = 0,
                  dontFlip = false
                } = {}) {
                  return new _display_utils.PageViewport({
                    viewBox: this.view,
                    scale,
                    rotation,
                    offsetX,
                    offsetY,
                    dontFlip
                  });
                }
                getAnnotations({
                  intent = "display"
                } = {}) {
                  const intentArgs = this._transport.getRenderingIntent(intent);
                  return this._transport.getAnnotations(this._pageIndex, intentArgs.renderingIntent);
                }
                getJSActions() {
                  return this._transport.getPageJSActions(this._pageIndex);
                }
                get filterFactory() {
                  return this._transport.filterFactory;
                }
                get isPureXfa() {
                  return (0, _util.shadow)(this, "isPureXfa", !!this._transport._htmlForXfa);
                }
                async getXfa() {
                  return this._transport._htmlForXfa?.children[this._pageIndex] || null;
                }
                render({
                  canvasContext,
                  viewport,
                  intent = "display",
                  annotationMode = _util.AnnotationMode.ENABLE,
                  transform = null,
                  background = null,
                  optionalContentConfigPromise = null,
                  annotationCanvasMap = null,
                  pageColors = null,
                  printAnnotationStorage = null
                }) {
                  this._stats?.time("Overall");
                  const intentArgs = this._transport.getRenderingIntent(intent, annotationMode, printAnnotationStorage);
                  this.#pendingCleanup = false;
                  this.#abortDelayedCleanup();
                  if (!optionalContentConfigPromise) {
                    optionalContentConfigPromise = this._transport.getOptionalContentConfig();
                  }
                  let intentState = this._intentStates.get(intentArgs.cacheKey);
                  if (!intentState) {
                    intentState = /* @__PURE__ */ Object.create(null);
                    this._intentStates.set(intentArgs.cacheKey, intentState);
                  }
                  if (intentState.streamReaderCancelTimeout) {
                    clearTimeout(intentState.streamReaderCancelTimeout);
                    intentState.streamReaderCancelTimeout = null;
                  }
                  const intentPrint = !!(intentArgs.renderingIntent & _util.RenderingIntentFlag.PRINT);
                  if (!intentState.displayReadyCapability) {
                    intentState.displayReadyCapability = new _util.PromiseCapability();
                    intentState.operatorList = {
                      fnArray: [],
                      argsArray: [],
                      lastChunk: false,
                      separateAnnots: null
                    };
                    this._stats?.time("Page Request");
                    this._pumpOperatorList(intentArgs);
                  }
                  const complete = (error2) => {
                    intentState.renderTasks.delete(internalRenderTask);
                    if (this._maybeCleanupAfterRender || intentPrint) {
                      this.#pendingCleanup = true;
                    }
                    this.#tryCleanup(!intentPrint);
                    if (error2) {
                      internalRenderTask.capability.reject(error2);
                      this._abortOperatorList({
                        intentState,
                        reason: error2 instanceof Error ? error2 : new Error(error2)
                      });
                    } else {
                      internalRenderTask.capability.resolve();
                    }
                    this._stats?.timeEnd("Rendering");
                    this._stats?.timeEnd("Overall");
                  };
                  const internalRenderTask = new InternalRenderTask({
                    callback: complete,
                    params: {
                      canvasContext,
                      viewport,
                      transform,
                      background
                    },
                    objs: this.objs,
                    commonObjs: this.commonObjs,
                    annotationCanvasMap,
                    operatorList: intentState.operatorList,
                    pageIndex: this._pageIndex,
                    canvasFactory: this._transport.canvasFactory,
                    filterFactory: this._transport.filterFactory,
                    useRequestAnimationFrame: !intentPrint,
                    pdfBug: this._pdfBug,
                    pageColors
                  });
                  (intentState.renderTasks ||= /* @__PURE__ */ new Set()).add(internalRenderTask);
                  const renderTask = internalRenderTask.task;
                  Promise.all([intentState.displayReadyCapability.promise, optionalContentConfigPromise]).then(([transparency, optionalContentConfig]) => {
                    if (this.destroyed) {
                      complete();
                      return;
                    }
                    this._stats?.time("Rendering");
                    internalRenderTask.initializeGraphics({
                      transparency,
                      optionalContentConfig
                    });
                    internalRenderTask.operatorListChanged();
                  }).catch(complete);
                  return renderTask;
                }
                getOperatorList({
                  intent = "display",
                  annotationMode = _util.AnnotationMode.ENABLE,
                  printAnnotationStorage = null
                } = {}) {
                  function operatorListChanged() {
                    if (intentState.operatorList.lastChunk) {
                      intentState.opListReadCapability.resolve(intentState.operatorList);
                      intentState.renderTasks.delete(opListTask);
                    }
                  }
                  const intentArgs = this._transport.getRenderingIntent(intent, annotationMode, printAnnotationStorage, true);
                  let intentState = this._intentStates.get(intentArgs.cacheKey);
                  if (!intentState) {
                    intentState = /* @__PURE__ */ Object.create(null);
                    this._intentStates.set(intentArgs.cacheKey, intentState);
                  }
                  let opListTask;
                  if (!intentState.opListReadCapability) {
                    opListTask = /* @__PURE__ */ Object.create(null);
                    opListTask.operatorListChanged = operatorListChanged;
                    intentState.opListReadCapability = new _util.PromiseCapability();
                    (intentState.renderTasks ||= /* @__PURE__ */ new Set()).add(opListTask);
                    intentState.operatorList = {
                      fnArray: [],
                      argsArray: [],
                      lastChunk: false,
                      separateAnnots: null
                    };
                    this._stats?.time("Page Request");
                    this._pumpOperatorList(intentArgs);
                  }
                  return intentState.opListReadCapability.promise;
                }
                streamTextContent({
                  includeMarkedContent = false,
                  disableNormalization = false
                } = {}) {
                  const TEXT_CONTENT_CHUNK_SIZE = 100;
                  return this._transport.messageHandler.sendWithStream("GetTextContent", {
                    pageIndex: this._pageIndex,
                    includeMarkedContent: includeMarkedContent === true,
                    disableNormalization: disableNormalization === true
                  }, {
                    highWaterMark: TEXT_CONTENT_CHUNK_SIZE,
                    size(textContent) {
                      return textContent.items.length;
                    }
                  });
                }
                getTextContent(params = {}) {
                  if (this._transport._htmlForXfa) {
                    return this.getXfa().then((xfa) => {
                      return _xfa_text.XfaText.textContent(xfa);
                    });
                  }
                  const readableStream = this.streamTextContent(params);
                  return new Promise(function(resolve, reject) {
                    function pump() {
                      reader.read().then(function({
                        value,
                        done
                      }) {
                        if (done) {
                          resolve(textContent);
                          return;
                        }
                        Object.assign(textContent.styles, value.styles);
                        textContent.items.push(...value.items);
                        pump();
                      }, reject);
                    }
                    const reader = readableStream.getReader();
                    const textContent = {
                      items: [],
                      styles: /* @__PURE__ */ Object.create(null)
                    };
                    pump();
                  });
                }
                getStructTree() {
                  return this._transport.getStructTree(this._pageIndex);
                }
                _destroy() {
                  this.destroyed = true;
                  const waitOn = [];
                  for (const intentState of this._intentStates.values()) {
                    this._abortOperatorList({
                      intentState,
                      reason: new Error("Page was destroyed."),
                      force: true
                    });
                    if (intentState.opListReadCapability) {
                      continue;
                    }
                    for (const internalRenderTask of intentState.renderTasks) {
                      waitOn.push(internalRenderTask.completed);
                      internalRenderTask.cancel();
                    }
                  }
                  this.objs.clear();
                  this.#pendingCleanup = false;
                  this.#abortDelayedCleanup();
                  return Promise.all(waitOn);
                }
                cleanup(resetStats = false) {
                  this.#pendingCleanup = true;
                  const success = this.#tryCleanup(false);
                  if (resetStats && success) {
                    this._stats &&= new _display_utils.StatTimer();
                  }
                  return success;
                }
                #tryCleanup(delayed = false) {
                  this.#abortDelayedCleanup();
                  if (!this.#pendingCleanup || this.destroyed) {
                    return false;
                  }
                  if (delayed) {
                    this.#delayedCleanupTimeout = setTimeout(() => {
                      this.#delayedCleanupTimeout = null;
                      this.#tryCleanup(false);
                    }, DELAYED_CLEANUP_TIMEOUT);
                    return false;
                  }
                  for (const {
                    renderTasks,
                    operatorList
                  } of this._intentStates.values()) {
                    if (renderTasks.size > 0 || !operatorList.lastChunk) {
                      return false;
                    }
                  }
                  this._intentStates.clear();
                  this.objs.clear();
                  this.#pendingCleanup = false;
                  return true;
                }
                #abortDelayedCleanup() {
                  if (this.#delayedCleanupTimeout) {
                    clearTimeout(this.#delayedCleanupTimeout);
                    this.#delayedCleanupTimeout = null;
                  }
                }
                _startRenderPage(transparency, cacheKey) {
                  const intentState = this._intentStates.get(cacheKey);
                  if (!intentState) {
                    return;
                  }
                  this._stats?.timeEnd("Page Request");
                  intentState.displayReadyCapability?.resolve(transparency);
                }
                _renderPageChunk(operatorListChunk, intentState) {
                  for (let i = 0, ii = operatorListChunk.length; i < ii; i++) {
                    intentState.operatorList.fnArray.push(operatorListChunk.fnArray[i]);
                    intentState.operatorList.argsArray.push(operatorListChunk.argsArray[i]);
                  }
                  intentState.operatorList.lastChunk = operatorListChunk.lastChunk;
                  intentState.operatorList.separateAnnots = operatorListChunk.separateAnnots;
                  for (const internalRenderTask of intentState.renderTasks) {
                    internalRenderTask.operatorListChanged();
                  }
                  if (operatorListChunk.lastChunk) {
                    this.#tryCleanup(true);
                  }
                }
                _pumpOperatorList({
                  renderingIntent,
                  cacheKey,
                  annotationStorageSerializable
                }) {
                  const {
                    map,
                    transfers
                  } = annotationStorageSerializable;
                  const readableStream = this._transport.messageHandler.sendWithStream("GetOperatorList", {
                    pageIndex: this._pageIndex,
                    intent: renderingIntent,
                    cacheKey,
                    annotationStorage: map
                  }, transfers);
                  const reader = readableStream.getReader();
                  const intentState = this._intentStates.get(cacheKey);
                  intentState.streamReader = reader;
                  const pump = () => {
                    reader.read().then(({
                      value,
                      done
                    }) => {
                      if (done) {
                        intentState.streamReader = null;
                        return;
                      }
                      if (this._transport.destroyed) {
                        return;
                      }
                      this._renderPageChunk(value, intentState);
                      pump();
                    }, (reason) => {
                      intentState.streamReader = null;
                      if (this._transport.destroyed) {
                        return;
                      }
                      if (intentState.operatorList) {
                        intentState.operatorList.lastChunk = true;
                        for (const internalRenderTask of intentState.renderTasks) {
                          internalRenderTask.operatorListChanged();
                        }
                        this.#tryCleanup(true);
                      }
                      if (intentState.displayReadyCapability) {
                        intentState.displayReadyCapability.reject(reason);
                      } else if (intentState.opListReadCapability) {
                        intentState.opListReadCapability.reject(reason);
                      } else {
                        throw reason;
                      }
                    });
                  };
                  pump();
                }
                _abortOperatorList({
                  intentState,
                  reason,
                  force = false
                }) {
                  if (!intentState.streamReader) {
                    return;
                  }
                  if (intentState.streamReaderCancelTimeout) {
                    clearTimeout(intentState.streamReaderCancelTimeout);
                    intentState.streamReaderCancelTimeout = null;
                  }
                  if (!force) {
                    if (intentState.renderTasks.size > 0) {
                      return;
                    }
                    if (reason instanceof _display_utils.RenderingCancelledException) {
                      let delay = RENDERING_CANCELLED_TIMEOUT;
                      if (reason.extraDelay > 0 && reason.extraDelay < 1e3) {
                        delay += reason.extraDelay;
                      }
                      intentState.streamReaderCancelTimeout = setTimeout(() => {
                        intentState.streamReaderCancelTimeout = null;
                        this._abortOperatorList({
                          intentState,
                          reason,
                          force: true
                        });
                      }, delay);
                      return;
                    }
                  }
                  intentState.streamReader.cancel(new _util.AbortException(reason.message)).catch(() => {
                  });
                  intentState.streamReader = null;
                  if (this._transport.destroyed) {
                    return;
                  }
                  for (const [curCacheKey, curIntentState] of this._intentStates) {
                    if (curIntentState === intentState) {
                      this._intentStates.delete(curCacheKey);
                      break;
                    }
                  }
                  this.cleanup();
                }
                get stats() {
                  return this._stats;
                }
              }
              exports.PDFPageProxy = PDFPageProxy;
              class LoopbackPort {
                #listeners = /* @__PURE__ */ new Set();
                #deferred = Promise.resolve();
                postMessage(obj, transfer) {
                  const event = {
                    data: structuredClone(obj, transfer ? {
                      transfer
                    } : null)
                  };
                  this.#deferred.then(() => {
                    for (const listener of this.#listeners) {
                      listener.call(this, event);
                    }
                  });
                }
                addEventListener(name, listener) {
                  this.#listeners.add(listener);
                }
                removeEventListener(name, listener) {
                  this.#listeners.delete(listener);
                }
                terminate() {
                  this.#listeners.clear();
                }
              }
              exports.LoopbackPort = LoopbackPort;
              const PDFWorkerUtil = {
                isWorkerDisabled: false,
                fallbackWorkerSrc: null,
                fakeWorkerId: 0
              };
              exports.PDFWorkerUtil = PDFWorkerUtil;
              {
                if (_util.isNodeJS && typeof __require === "function") {
                  PDFWorkerUtil.isWorkerDisabled = true;
                  PDFWorkerUtil.fallbackWorkerSrc = "./pdf.worker.js";
                } else if (typeof document === "object") {
                  const pdfjsFilePath = document?.currentScript?.src;
                  if (pdfjsFilePath) {
                    PDFWorkerUtil.fallbackWorkerSrc = pdfjsFilePath.replace(/(\.(?:min\.)?js)(\?.*)?$/i, ".worker$1$2");
                  }
                }
                PDFWorkerUtil.isSameOrigin = function(baseUrl, otherUrl) {
                  let base;
                  try {
                    base = new URL(baseUrl);
                    if (!base.origin || base.origin === "null") {
                      return false;
                    }
                  } catch {
                    return false;
                  }
                  const other = new URL(otherUrl, base);
                  return base.origin === other.origin;
                };
                PDFWorkerUtil.createCDNWrapper = function(url2) {
                  const wrapper = `importScripts("${url2}");`;
                  return URL.createObjectURL(new Blob([wrapper]));
                };
              }
              class PDFWorker {
                static #workerPorts;
                constructor({
                  name = null,
                  port = null,
                  verbosity = (0, _util.getVerbosityLevel)()
                } = {}) {
                  this.name = name;
                  this.destroyed = false;
                  this.verbosity = verbosity;
                  this._readyCapability = new _util.PromiseCapability();
                  this._port = null;
                  this._webWorker = null;
                  this._messageHandler = null;
                  if (port) {
                    if (PDFWorker.#workerPorts?.has(port)) {
                      throw new Error("Cannot use more than one PDFWorker per port.");
                    }
                    (PDFWorker.#workerPorts ||= /* @__PURE__ */ new WeakMap()).set(port, this);
                    this._initializeFromPort(port);
                    return;
                  }
                  this._initialize();
                }
                get promise() {
                  return this._readyCapability.promise;
                }
                get port() {
                  return this._port;
                }
                get messageHandler() {
                  return this._messageHandler;
                }
                _initializeFromPort(port) {
                  this._port = port;
                  this._messageHandler = new _message_handler.MessageHandler("main", "worker", port);
                  this._messageHandler.on("ready", function() {
                  });
                  this._readyCapability.resolve();
                  this._messageHandler.send("configure", {
                    verbosity: this.verbosity
                  });
                }
                _initialize() {
                  if (!PDFWorkerUtil.isWorkerDisabled && !PDFWorker._mainThreadWorkerMessageHandler) {
                    let {
                      workerSrc
                    } = PDFWorker;
                    try {
                      if (!PDFWorkerUtil.isSameOrigin(window.location.href, workerSrc)) {
                        workerSrc = PDFWorkerUtil.createCDNWrapper(new URL(workerSrc, window.location).href);
                      }
                      const worker2 = new Worker(workerSrc);
                      const messageHandler = new _message_handler.MessageHandler("main", "worker", worker2);
                      const terminateEarly = () => {
                        worker2.removeEventListener("error", onWorkerError);
                        messageHandler.destroy();
                        worker2.terminate();
                        if (this.destroyed) {
                          this._readyCapability.reject(new Error("Worker was destroyed"));
                        } else {
                          this._setupFakeWorker();
                        }
                      };
                      const onWorkerError = () => {
                        if (!this._webWorker) {
                          terminateEarly();
                        }
                      };
                      worker2.addEventListener("error", onWorkerError);
                      messageHandler.on("test", (data2) => {
                        worker2.removeEventListener("error", onWorkerError);
                        if (this.destroyed) {
                          terminateEarly();
                          return;
                        }
                        if (data2) {
                          this._messageHandler = messageHandler;
                          this._port = worker2;
                          this._webWorker = worker2;
                          this._readyCapability.resolve();
                          messageHandler.send("configure", {
                            verbosity: this.verbosity
                          });
                        } else {
                          this._setupFakeWorker();
                          messageHandler.destroy();
                          worker2.terminate();
                        }
                      });
                      messageHandler.on("ready", (data2) => {
                        worker2.removeEventListener("error", onWorkerError);
                        if (this.destroyed) {
                          terminateEarly();
                          return;
                        }
                        try {
                          sendTest();
                        } catch {
                          this._setupFakeWorker();
                        }
                      });
                      const sendTest = () => {
                        const testObj = new Uint8Array();
                        messageHandler.send("test", testObj, [testObj.buffer]);
                      };
                      sendTest();
                      return;
                    } catch {
                      (0, _util.info)("The worker has been disabled.");
                    }
                  }
                  this._setupFakeWorker();
                }
                _setupFakeWorker() {
                  if (!PDFWorkerUtil.isWorkerDisabled) {
                    (0, _util.warn)("Setting up fake worker.");
                    PDFWorkerUtil.isWorkerDisabled = true;
                  }
                  PDFWorker._setupFakeWorkerGlobal.then((WorkerMessageHandler) => {
                    if (this.destroyed) {
                      this._readyCapability.reject(new Error("Worker was destroyed"));
                      return;
                    }
                    const port = new LoopbackPort();
                    this._port = port;
                    const id = `fake${PDFWorkerUtil.fakeWorkerId++}`;
                    const workerHandler = new _message_handler.MessageHandler(id + "_worker", id, port);
                    WorkerMessageHandler.setup(workerHandler, port);
                    const messageHandler = new _message_handler.MessageHandler(id, id + "_worker", port);
                    this._messageHandler = messageHandler;
                    this._readyCapability.resolve();
                    messageHandler.send("configure", {
                      verbosity: this.verbosity
                    });
                  }).catch((reason) => {
                    this._readyCapability.reject(new Error(`Setting up fake worker failed: "${reason.message}".`));
                  });
                }
                destroy() {
                  this.destroyed = true;
                  if (this._webWorker) {
                    this._webWorker.terminate();
                    this._webWorker = null;
                  }
                  PDFWorker.#workerPorts?.delete(this._port);
                  this._port = null;
                  if (this._messageHandler) {
                    this._messageHandler.destroy();
                    this._messageHandler = null;
                  }
                }
                static fromPort(params) {
                  if (!params?.port) {
                    throw new Error("PDFWorker.fromPort - invalid method signature.");
                  }
                  const cachedPort = this.#workerPorts?.get(params.port);
                  if (cachedPort) {
                    if (cachedPort._pendingDestroy) {
                      throw new Error("PDFWorker.fromPort - the worker is being destroyed.\nPlease remember to await `PDFDocumentLoadingTask.destroy()`-calls.");
                    }
                    return cachedPort;
                  }
                  return new PDFWorker(params);
                }
                static get workerSrc() {
                  if (_worker_options.GlobalWorkerOptions.workerSrc) {
                    return _worker_options.GlobalWorkerOptions.workerSrc;
                  }
                  if (PDFWorkerUtil.fallbackWorkerSrc !== null) {
                    if (!_util.isNodeJS) {
                      (0, _display_utils.deprecated)('No "GlobalWorkerOptions.workerSrc" specified.');
                    }
                    return PDFWorkerUtil.fallbackWorkerSrc;
                  }
                  throw new Error('No "GlobalWorkerOptions.workerSrc" specified.');
                }
                static get _mainThreadWorkerMessageHandler() {
                  try {
                    return globalThis.pdfjsWorker?.WorkerMessageHandler || null;
                  } catch {
                    return null;
                  }
                }
                static get _setupFakeWorkerGlobal() {
                  const loader = async () => {
                    const mainWorkerMessageHandler = this._mainThreadWorkerMessageHandler;
                    if (mainWorkerMessageHandler) {
                      return mainWorkerMessageHandler;
                    }
                    if (_util.isNodeJS && typeof __require === "function") {
                      const worker = eval("require")(this.workerSrc);
                      return worker.WorkerMessageHandler;
                    }
                    await (0, _display_utils.loadScript)(this.workerSrc);
                    return window.pdfjsWorker.WorkerMessageHandler;
                  };
                  return (0, _util.shadow)(this, "_setupFakeWorkerGlobal", loader());
                }
              }
              exports.PDFWorker = PDFWorker;
              class WorkerTransport {
                #methodPromises = /* @__PURE__ */ new Map();
                #pageCache = /* @__PURE__ */ new Map();
                #pagePromises = /* @__PURE__ */ new Map();
                #passwordCapability = null;
                constructor(messageHandler, loadingTask, networkStream, params, factory) {
                  this.messageHandler = messageHandler;
                  this.loadingTask = loadingTask;
                  this.commonObjs = new PDFObjects();
                  this.fontLoader = new _font_loader.FontLoader({
                    ownerDocument: params.ownerDocument,
                    styleElement: params.styleElement
                  });
                  this._params = params;
                  this.canvasFactory = factory.canvasFactory;
                  this.filterFactory = factory.filterFactory;
                  this.cMapReaderFactory = factory.cMapReaderFactory;
                  this.standardFontDataFactory = factory.standardFontDataFactory;
                  this.destroyed = false;
                  this.destroyCapability = null;
                  this._networkStream = networkStream;
                  this._fullReader = null;
                  this._lastProgress = null;
                  this.downloadInfoCapability = new _util.PromiseCapability();
                  this.setupMessageHandler();
                }
                #cacheSimpleMethod(name, data2 = null) {
                  const cachedPromise = this.#methodPromises.get(name);
                  if (cachedPromise) {
                    return cachedPromise;
                  }
                  const promise = this.messageHandler.sendWithPromise(name, data2);
                  this.#methodPromises.set(name, promise);
                  return promise;
                }
                get annotationStorage() {
                  return (0, _util.shadow)(this, "annotationStorage", new _annotation_storage.AnnotationStorage());
                }
                getRenderingIntent(intent, annotationMode = _util.AnnotationMode.ENABLE, printAnnotationStorage = null, isOpList = false) {
                  let renderingIntent = _util.RenderingIntentFlag.DISPLAY;
                  let annotationStorageSerializable = _annotation_storage.SerializableEmpty;
                  switch (intent) {
                    case "any":
                      renderingIntent = _util.RenderingIntentFlag.ANY;
                      break;
                    case "display":
                      break;
                    case "print":
                      renderingIntent = _util.RenderingIntentFlag.PRINT;
                      break;
                    default:
                      (0, _util.warn)(`getRenderingIntent - invalid intent: ${intent}`);
                  }
                  switch (annotationMode) {
                    case _util.AnnotationMode.DISABLE:
                      renderingIntent += _util.RenderingIntentFlag.ANNOTATIONS_DISABLE;
                      break;
                    case _util.AnnotationMode.ENABLE:
                      break;
                    case _util.AnnotationMode.ENABLE_FORMS:
                      renderingIntent += _util.RenderingIntentFlag.ANNOTATIONS_FORMS;
                      break;
                    case _util.AnnotationMode.ENABLE_STORAGE:
                      renderingIntent += _util.RenderingIntentFlag.ANNOTATIONS_STORAGE;
                      const annotationStorage = renderingIntent & _util.RenderingIntentFlag.PRINT && printAnnotationStorage instanceof _annotation_storage.PrintAnnotationStorage ? printAnnotationStorage : this.annotationStorage;
                      annotationStorageSerializable = annotationStorage.serializable;
                      break;
                    default:
                      (0, _util.warn)(`getRenderingIntent - invalid annotationMode: ${annotationMode}`);
                  }
                  if (isOpList) {
                    renderingIntent += _util.RenderingIntentFlag.OPLIST;
                  }
                  return {
                    renderingIntent,
                    cacheKey: `${renderingIntent}_${annotationStorageSerializable.hash}`,
                    annotationStorageSerializable
                  };
                }
                destroy() {
                  if (this.destroyCapability) {
                    return this.destroyCapability.promise;
                  }
                  this.destroyed = true;
                  this.destroyCapability = new _util.PromiseCapability();
                  this.#passwordCapability?.reject(new Error("Worker was destroyed during onPassword callback"));
                  const waitOn = [];
                  for (const page of this.#pageCache.values()) {
                    waitOn.push(page._destroy());
                  }
                  this.#pageCache.clear();
                  this.#pagePromises.clear();
                  if (this.hasOwnProperty("annotationStorage")) {
                    this.annotationStorage.resetModified();
                  }
                  const terminated = this.messageHandler.sendWithPromise("Terminate", null);
                  waitOn.push(terminated);
                  Promise.all(waitOn).then(() => {
                    this.commonObjs.clear();
                    this.fontLoader.clear();
                    this.#methodPromises.clear();
                    this.filterFactory.destroy();
                    this._networkStream?.cancelAllRequests(new _util.AbortException("Worker was terminated."));
                    if (this.messageHandler) {
                      this.messageHandler.destroy();
                      this.messageHandler = null;
                    }
                    this.destroyCapability.resolve();
                  }, this.destroyCapability.reject);
                  return this.destroyCapability.promise;
                }
                setupMessageHandler() {
                  const {
                    messageHandler,
                    loadingTask
                  } = this;
                  messageHandler.on("GetReader", (data2, sink) => {
                    (0, _util.assert)(this._networkStream, "GetReader - no `IPDFStream` instance available.");
                    this._fullReader = this._networkStream.getFullReader();
                    this._fullReader.onProgress = (evt) => {
                      this._lastProgress = {
                        loaded: evt.loaded,
                        total: evt.total
                      };
                    };
                    sink.onPull = () => {
                      this._fullReader.read().then(function({
                        value,
                        done
                      }) {
                        if (done) {
                          sink.close();
                          return;
                        }
                        (0, _util.assert)(value instanceof ArrayBuffer, "GetReader - expected an ArrayBuffer.");
                        sink.enqueue(new Uint8Array(value), 1, [value]);
                      }).catch((reason) => {
                        sink.error(reason);
                      });
                    };
                    sink.onCancel = (reason) => {
                      this._fullReader.cancel(reason);
                      sink.ready.catch((readyReason) => {
                        if (this.destroyed) {
                          return;
                        }
                        throw readyReason;
                      });
                    };
                  });
                  messageHandler.on("ReaderHeadersReady", (data2) => {
                    const headersCapability = new _util.PromiseCapability();
                    const fullReader = this._fullReader;
                    fullReader.headersReady.then(() => {
                      if (!fullReader.isStreamingSupported || !fullReader.isRangeSupported) {
                        if (this._lastProgress) {
                          loadingTask.onProgress?.(this._lastProgress);
                        }
                        fullReader.onProgress = (evt) => {
                          loadingTask.onProgress?.({
                            loaded: evt.loaded,
                            total: evt.total
                          });
                        };
                      }
                      headersCapability.resolve({
                        isStreamingSupported: fullReader.isStreamingSupported,
                        isRangeSupported: fullReader.isRangeSupported,
                        contentLength: fullReader.contentLength
                      });
                    }, headersCapability.reject);
                    return headersCapability.promise;
                  });
                  messageHandler.on("GetRangeReader", (data2, sink) => {
                    (0, _util.assert)(this._networkStream, "GetRangeReader - no `IPDFStream` instance available.");
                    const rangeReader = this._networkStream.getRangeReader(data2.begin, data2.end);
                    if (!rangeReader) {
                      sink.close();
                      return;
                    }
                    sink.onPull = () => {
                      rangeReader.read().then(function({
                        value,
                        done
                      }) {
                        if (done) {
                          sink.close();
                          return;
                        }
                        (0, _util.assert)(value instanceof ArrayBuffer, "GetRangeReader - expected an ArrayBuffer.");
                        sink.enqueue(new Uint8Array(value), 1, [value]);
                      }).catch((reason) => {
                        sink.error(reason);
                      });
                    };
                    sink.onCancel = (reason) => {
                      rangeReader.cancel(reason);
                      sink.ready.catch((readyReason) => {
                        if (this.destroyed) {
                          return;
                        }
                        throw readyReason;
                      });
                    };
                  });
                  messageHandler.on("GetDoc", ({
                    pdfInfo
                  }) => {
                    this._numPages = pdfInfo.numPages;
                    this._htmlForXfa = pdfInfo.htmlForXfa;
                    delete pdfInfo.htmlForXfa;
                    loadingTask._capability.resolve(new PDFDocumentProxy(pdfInfo, this));
                  });
                  messageHandler.on("DocException", function(ex) {
                    let reason;
                    switch (ex.name) {
                      case "PasswordException":
                        reason = new _util.PasswordException(ex.message, ex.code);
                        break;
                      case "InvalidPDFException":
                        reason = new _util.InvalidPDFException(ex.message);
                        break;
                      case "MissingPDFException":
                        reason = new _util.MissingPDFException(ex.message);
                        break;
                      case "UnexpectedResponseException":
                        reason = new _util.UnexpectedResponseException(ex.message, ex.status);
                        break;
                      case "UnknownErrorException":
                        reason = new _util.UnknownErrorException(ex.message, ex.details);
                        break;
                      default:
                        (0, _util.unreachable)("DocException - expected a valid Error.");
                    }
                    loadingTask._capability.reject(reason);
                  });
                  messageHandler.on("PasswordRequest", (exception) => {
                    this.#passwordCapability = new _util.PromiseCapability();
                    if (loadingTask.onPassword) {
                      const updatePassword = (password) => {
                        if (password instanceof Error) {
                          this.#passwordCapability.reject(password);
                        } else {
                          this.#passwordCapability.resolve({
                            password
                          });
                        }
                      };
                      try {
                        loadingTask.onPassword(updatePassword, exception.code);
                      } catch (ex) {
                        this.#passwordCapability.reject(ex);
                      }
                    } else {
                      this.#passwordCapability.reject(new _util.PasswordException(exception.message, exception.code));
                    }
                    return this.#passwordCapability.promise;
                  });
                  messageHandler.on("DataLoaded", (data2) => {
                    loadingTask.onProgress?.({
                      loaded: data2.length,
                      total: data2.length
                    });
                    this.downloadInfoCapability.resolve(data2);
                  });
                  messageHandler.on("StartRenderPage", (data2) => {
                    if (this.destroyed) {
                      return;
                    }
                    const page = this.#pageCache.get(data2.pageIndex);
                    page._startRenderPage(data2.transparency, data2.cacheKey);
                  });
                  messageHandler.on("commonobj", ([id, type5, exportedData]) => {
                    if (this.destroyed) {
                      return;
                    }
                    if (this.commonObjs.has(id)) {
                      return;
                    }
                    switch (type5) {
                      case "Font":
                        const params = this._params;
                        if ("error" in exportedData) {
                          const exportedError = exportedData.error;
                          (0, _util.warn)(`Error during font loading: ${exportedError}`);
                          this.commonObjs.resolve(id, exportedError);
                          break;
                        }
                        const inspectFont = params.pdfBug && globalThis.FontInspector?.enabled ? (font2, url2) => globalThis.FontInspector.fontAdded(font2, url2) : null;
                        const font = new _font_loader.FontFaceObject(exportedData, {
                          isEvalSupported: params.isEvalSupported,
                          disableFontFace: params.disableFontFace,
                          ignoreErrors: params.ignoreErrors,
                          inspectFont
                        });
                        this.fontLoader.bind(font).catch((reason) => {
                          return messageHandler.sendWithPromise("FontFallback", {
                            id
                          });
                        }).finally(() => {
                          if (!params.fontExtraProperties && font.data) {
                            font.data = null;
                          }
                          this.commonObjs.resolve(id, font);
                        });
                        break;
                      case "FontPath":
                      case "Image":
                      case "Pattern":
                        this.commonObjs.resolve(id, exportedData);
                        break;
                      default:
                        throw new Error(`Got unknown common object type ${type5}`);
                    }
                  });
                  messageHandler.on("obj", ([id, pageIndex, type5, imageData]) => {
                    if (this.destroyed) {
                      return;
                    }
                    const pageProxy = this.#pageCache.get(pageIndex);
                    if (pageProxy.objs.has(id)) {
                      return;
                    }
                    switch (type5) {
                      case "Image":
                        pageProxy.objs.resolve(id, imageData);
                        if (imageData) {
                          let length2;
                          if (imageData.bitmap) {
                            const {
                              width,
                              height
                            } = imageData;
                            length2 = width * height * 4;
                          } else {
                            length2 = imageData.data?.length || 0;
                          }
                          if (length2 > _util.MAX_IMAGE_SIZE_TO_CACHE) {
                            pageProxy._maybeCleanupAfterRender = true;
                          }
                        }
                        break;
                      case "Pattern":
                        pageProxy.objs.resolve(id, imageData);
                        break;
                      default:
                        throw new Error(`Got unknown object type ${type5}`);
                    }
                  });
                  messageHandler.on("DocProgress", (data2) => {
                    if (this.destroyed) {
                      return;
                    }
                    loadingTask.onProgress?.({
                      loaded: data2.loaded,
                      total: data2.total
                    });
                  });
                  messageHandler.on("FetchBuiltInCMap", (data2) => {
                    if (this.destroyed) {
                      return Promise.reject(new Error("Worker was destroyed."));
                    }
                    if (!this.cMapReaderFactory) {
                      return Promise.reject(new Error("CMapReaderFactory not initialized, see the `useWorkerFetch` parameter."));
                    }
                    return this.cMapReaderFactory.fetch(data2);
                  });
                  messageHandler.on("FetchStandardFontData", (data2) => {
                    if (this.destroyed) {
                      return Promise.reject(new Error("Worker was destroyed."));
                    }
                    if (!this.standardFontDataFactory) {
                      return Promise.reject(new Error("StandardFontDataFactory not initialized, see the `useWorkerFetch` parameter."));
                    }
                    return this.standardFontDataFactory.fetch(data2);
                  });
                }
                getData() {
                  return this.messageHandler.sendWithPromise("GetData", null);
                }
                saveDocument() {
                  if (this.annotationStorage.size <= 0) {
                    (0, _util.warn)("saveDocument called while `annotationStorage` is empty, please use the getData-method instead.");
                  }
                  const {
                    map,
                    transfers
                  } = this.annotationStorage.serializable;
                  return this.messageHandler.sendWithPromise("SaveDocument", {
                    isPureXfa: !!this._htmlForXfa,
                    numPages: this._numPages,
                    annotationStorage: map,
                    filename: this._fullReader?.filename ?? null
                  }, transfers).finally(() => {
                    this.annotationStorage.resetModified();
                  });
                }
                getPage(pageNumber) {
                  if (!Number.isInteger(pageNumber) || pageNumber <= 0 || pageNumber > this._numPages) {
                    return Promise.reject(new Error("Invalid page request."));
                  }
                  const pageIndex = pageNumber - 1, cachedPromise = this.#pagePromises.get(pageIndex);
                  if (cachedPromise) {
                    return cachedPromise;
                  }
                  const promise = this.messageHandler.sendWithPromise("GetPage", {
                    pageIndex
                  }).then((pageInfo) => {
                    if (this.destroyed) {
                      throw new Error("Transport destroyed");
                    }
                    const page = new PDFPageProxy(pageIndex, pageInfo, this, this._params.pdfBug);
                    this.#pageCache.set(pageIndex, page);
                    return page;
                  });
                  this.#pagePromises.set(pageIndex, promise);
                  return promise;
                }
                getPageIndex(ref3) {
                  if (typeof ref3 !== "object" || ref3 === null || !Number.isInteger(ref3.num) || ref3.num < 0 || !Number.isInteger(ref3.gen) || ref3.gen < 0) {
                    return Promise.reject(new Error("Invalid pageIndex request."));
                  }
                  return this.messageHandler.sendWithPromise("GetPageIndex", {
                    num: ref3.num,
                    gen: ref3.gen
                  });
                }
                getAnnotations(pageIndex, intent) {
                  return this.messageHandler.sendWithPromise("GetAnnotations", {
                    pageIndex,
                    intent
                  });
                }
                getFieldObjects() {
                  return this.#cacheSimpleMethod("GetFieldObjects");
                }
                hasJSActions() {
                  return this.#cacheSimpleMethod("HasJSActions");
                }
                getCalculationOrderIds() {
                  return this.messageHandler.sendWithPromise("GetCalculationOrderIds", null);
                }
                getDestinations() {
                  return this.messageHandler.sendWithPromise("GetDestinations", null);
                }
                getDestination(id) {
                  if (typeof id !== "string") {
                    return Promise.reject(new Error("Invalid destination request."));
                  }
                  return this.messageHandler.sendWithPromise("GetDestination", {
                    id
                  });
                }
                getPageLabels() {
                  return this.messageHandler.sendWithPromise("GetPageLabels", null);
                }
                getPageLayout() {
                  return this.messageHandler.sendWithPromise("GetPageLayout", null);
                }
                getPageMode() {
                  return this.messageHandler.sendWithPromise("GetPageMode", null);
                }
                getViewerPreferences() {
                  return this.messageHandler.sendWithPromise("GetViewerPreferences", null);
                }
                getOpenAction() {
                  return this.messageHandler.sendWithPromise("GetOpenAction", null);
                }
                getAttachments() {
                  return this.messageHandler.sendWithPromise("GetAttachments", null);
                }
                getDocJSActions() {
                  return this.#cacheSimpleMethod("GetDocJSActions");
                }
                getPageJSActions(pageIndex) {
                  return this.messageHandler.sendWithPromise("GetPageJSActions", {
                    pageIndex
                  });
                }
                getStructTree(pageIndex) {
                  return this.messageHandler.sendWithPromise("GetStructTree", {
                    pageIndex
                  });
                }
                getOutline() {
                  return this.messageHandler.sendWithPromise("GetOutline", null);
                }
                getOptionalContentConfig() {
                  return this.messageHandler.sendWithPromise("GetOptionalContentConfig", null).then((results) => {
                    return new _optional_content_config.OptionalContentConfig(results);
                  });
                }
                getPermissions() {
                  return this.messageHandler.sendWithPromise("GetPermissions", null);
                }
                getMetadata() {
                  const name = "GetMetadata", cachedPromise = this.#methodPromises.get(name);
                  if (cachedPromise) {
                    return cachedPromise;
                  }
                  const promise = this.messageHandler.sendWithPromise(name, null).then((results) => {
                    return {
                      info: results[0],
                      metadata: results[1] ? new _metadata.Metadata(results[1]) : null,
                      contentDispositionFilename: this._fullReader?.filename ?? null,
                      contentLength: this._fullReader?.contentLength ?? null
                    };
                  });
                  this.#methodPromises.set(name, promise);
                  return promise;
                }
                getMarkInfo() {
                  return this.messageHandler.sendWithPromise("GetMarkInfo", null);
                }
                async startCleanup(keepLoadedFonts = false) {
                  if (this.destroyed) {
                    return;
                  }
                  await this.messageHandler.sendWithPromise("Cleanup", null);
                  for (const page of this.#pageCache.values()) {
                    const cleanupSuccessful = page.cleanup();
                    if (!cleanupSuccessful) {
                      throw new Error(`startCleanup: Page ${page.pageNumber} is currently rendering.`);
                    }
                  }
                  this.commonObjs.clear();
                  if (!keepLoadedFonts) {
                    this.fontLoader.clear();
                  }
                  this.#methodPromises.clear();
                  this.filterFactory.destroy(true);
                }
                get loadingParams() {
                  const {
                    disableAutoFetch,
                    enableXfa
                  } = this._params;
                  return (0, _util.shadow)(this, "loadingParams", {
                    disableAutoFetch,
                    enableXfa
                  });
                }
              }
              class PDFObjects {
                #objs = /* @__PURE__ */ Object.create(null);
                #ensureObj(objId) {
                  return this.#objs[objId] ||= {
                    capability: new _util.PromiseCapability(),
                    data: null
                  };
                }
                get(objId, callback = null) {
                  if (callback) {
                    const obj2 = this.#ensureObj(objId);
                    obj2.capability.promise.then(() => callback(obj2.data));
                    return null;
                  }
                  const obj = this.#objs[objId];
                  if (!obj?.capability.settled) {
                    throw new Error(`Requesting object that isn't resolved yet ${objId}.`);
                  }
                  return obj.data;
                }
                has(objId) {
                  const obj = this.#objs[objId];
                  return obj?.capability.settled || false;
                }
                resolve(objId, data2 = null) {
                  const obj = this.#ensureObj(objId);
                  obj.data = data2;
                  obj.capability.resolve();
                }
                clear() {
                  for (const objId in this.#objs) {
                    const {
                      data: data2
                    } = this.#objs[objId];
                    data2?.bitmap?.close();
                  }
                  this.#objs = /* @__PURE__ */ Object.create(null);
                }
              }
              class RenderTask {
                #internalRenderTask = null;
                constructor(internalRenderTask) {
                  this.#internalRenderTask = internalRenderTask;
                  this.onContinue = null;
                }
                get promise() {
                  return this.#internalRenderTask.capability.promise;
                }
                cancel(extraDelay = 0) {
                  this.#internalRenderTask.cancel(null, extraDelay);
                }
                get separateAnnots() {
                  const {
                    separateAnnots
                  } = this.#internalRenderTask.operatorList;
                  if (!separateAnnots) {
                    return false;
                  }
                  const {
                    annotationCanvasMap
                  } = this.#internalRenderTask;
                  return separateAnnots.form || separateAnnots.canvas && annotationCanvasMap?.size > 0;
                }
              }
              exports.RenderTask = RenderTask;
              class InternalRenderTask {
                static #canvasInUse = /* @__PURE__ */ new WeakSet();
                constructor({
                  callback,
                  params,
                  objs,
                  commonObjs,
                  annotationCanvasMap,
                  operatorList,
                  pageIndex,
                  canvasFactory,
                  filterFactory,
                  useRequestAnimationFrame = false,
                  pdfBug = false,
                  pageColors = null
                }) {
                  this.callback = callback;
                  this.params = params;
                  this.objs = objs;
                  this.commonObjs = commonObjs;
                  this.annotationCanvasMap = annotationCanvasMap;
                  this.operatorListIdx = null;
                  this.operatorList = operatorList;
                  this._pageIndex = pageIndex;
                  this.canvasFactory = canvasFactory;
                  this.filterFactory = filterFactory;
                  this._pdfBug = pdfBug;
                  this.pageColors = pageColors;
                  this.running = false;
                  this.graphicsReadyCallback = null;
                  this.graphicsReady = false;
                  this._useRequestAnimationFrame = useRequestAnimationFrame === true && typeof window !== "undefined";
                  this.cancelled = false;
                  this.capability = new _util.PromiseCapability();
                  this.task = new RenderTask(this);
                  this._cancelBound = this.cancel.bind(this);
                  this._continueBound = this._continue.bind(this);
                  this._scheduleNextBound = this._scheduleNext.bind(this);
                  this._nextBound = this._next.bind(this);
                  this._canvas = params.canvasContext.canvas;
                }
                get completed() {
                  return this.capability.promise.catch(function() {
                  });
                }
                initializeGraphics({
                  transparency = false,
                  optionalContentConfig
                }) {
                  if (this.cancelled) {
                    return;
                  }
                  if (this._canvas) {
                    if (InternalRenderTask.#canvasInUse.has(this._canvas)) {
                      throw new Error("Cannot use the same canvas during multiple render() operations. Use different canvas or ensure previous operations were cancelled or completed.");
                    }
                    InternalRenderTask.#canvasInUse.add(this._canvas);
                  }
                  if (this._pdfBug && globalThis.StepperManager?.enabled) {
                    this.stepper = globalThis.StepperManager.create(this._pageIndex);
                    this.stepper.init(this.operatorList);
                    this.stepper.nextBreakPoint = this.stepper.getNextBreakPoint();
                  }
                  const {
                    canvasContext,
                    viewport,
                    transform,
                    background
                  } = this.params;
                  this.gfx = new _canvas.CanvasGraphics(canvasContext, this.commonObjs, this.objs, this.canvasFactory, this.filterFactory, {
                    optionalContentConfig
                  }, this.annotationCanvasMap, this.pageColors);
                  this.gfx.beginDrawing({
                    transform,
                    viewport,
                    transparency,
                    background
                  });
                  this.operatorListIdx = 0;
                  this.graphicsReady = true;
                  this.graphicsReadyCallback?.();
                }
                cancel(error2 = null, extraDelay = 0) {
                  this.running = false;
                  this.cancelled = true;
                  this.gfx?.endDrawing();
                  InternalRenderTask.#canvasInUse.delete(this._canvas);
                  this.callback(error2 || new _display_utils.RenderingCancelledException(`Rendering cancelled, page ${this._pageIndex + 1}`, extraDelay));
                }
                operatorListChanged() {
                  if (!this.graphicsReady) {
                    this.graphicsReadyCallback ||= this._continueBound;
                    return;
                  }
                  this.stepper?.updateOperatorList(this.operatorList);
                  if (this.running) {
                    return;
                  }
                  this._continue();
                }
                _continue() {
                  this.running = true;
                  if (this.cancelled) {
                    return;
                  }
                  if (this.task.onContinue) {
                    this.task.onContinue(this._scheduleNextBound);
                  } else {
                    this._scheduleNext();
                  }
                }
                _scheduleNext() {
                  if (this._useRequestAnimationFrame) {
                    window.requestAnimationFrame(() => {
                      this._nextBound().catch(this._cancelBound);
                    });
                  } else {
                    Promise.resolve().then(this._nextBound).catch(this._cancelBound);
                  }
                }
                async _next() {
                  if (this.cancelled) {
                    return;
                  }
                  this.operatorListIdx = this.gfx.executeOperatorList(this.operatorList, this.operatorListIdx, this._continueBound, this.stepper);
                  if (this.operatorListIdx === this.operatorList.argsArray.length) {
                    this.running = false;
                    if (this.operatorList.lastChunk) {
                      this.gfx.endDrawing();
                      InternalRenderTask.#canvasInUse.delete(this._canvas);
                      this.callback();
                    }
                  }
                }
              }
              const version = "3.11.174";
              exports.version = version;
              const build = "ce8716743";
              exports.build = build;
            }),
            /* 3 */
            /***/
            ((__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
              Object.defineProperty(exports2, "__esModule", {
                value: true
              });
              exports2.SerializableEmpty = exports2.PrintAnnotationStorage = exports2.AnnotationStorage = void 0;
              var _util2 = __w_pdfjs_require__2(1);
              var _editor = __w_pdfjs_require__2(4);
              var _murmurhash = __w_pdfjs_require__2(8);
              const SerializableEmpty = Object.freeze({
                map: null,
                hash: "",
                transfers: void 0
              });
              exports2.SerializableEmpty = SerializableEmpty;
              class AnnotationStorage {
                #modified = false;
                #storage = /* @__PURE__ */ new Map();
                constructor() {
                  this.onSetModified = null;
                  this.onResetModified = null;
                  this.onAnnotationEditor = null;
                }
                getValue(key2, defaultValue2) {
                  const value = this.#storage.get(key2);
                  if (value === void 0) {
                    return defaultValue2;
                  }
                  return Object.assign(defaultValue2, value);
                }
                getRawValue(key2) {
                  return this.#storage.get(key2);
                }
                remove(key2) {
                  this.#storage.delete(key2);
                  if (this.#storage.size === 0) {
                    this.resetModified();
                  }
                  if (typeof this.onAnnotationEditor === "function") {
                    for (const value of this.#storage.values()) {
                      if (value instanceof _editor.AnnotationEditor) {
                        return;
                      }
                    }
                    this.onAnnotationEditor(null);
                  }
                }
                setValue(key2, value) {
                  const obj = this.#storage.get(key2);
                  let modified = false;
                  if (obj !== void 0) {
                    for (const [entry, val] of Object.entries(value)) {
                      if (obj[entry] !== val) {
                        modified = true;
                        obj[entry] = val;
                      }
                    }
                  } else {
                    modified = true;
                    this.#storage.set(key2, value);
                  }
                  if (modified) {
                    this.#setModified();
                  }
                  if (value instanceof _editor.AnnotationEditor && typeof this.onAnnotationEditor === "function") {
                    this.onAnnotationEditor(value.constructor._type);
                  }
                }
                has(key2) {
                  return this.#storage.has(key2);
                }
                getAll() {
                  return this.#storage.size > 0 ? (0, _util2.objectFromMap)(this.#storage) : null;
                }
                setAll(obj) {
                  for (const [key2, val] of Object.entries(obj)) {
                    this.setValue(key2, val);
                  }
                }
                get size() {
                  return this.#storage.size;
                }
                #setModified() {
                  if (!this.#modified) {
                    this.#modified = true;
                    if (typeof this.onSetModified === "function") {
                      this.onSetModified();
                    }
                  }
                }
                resetModified() {
                  if (this.#modified) {
                    this.#modified = false;
                    if (typeof this.onResetModified === "function") {
                      this.onResetModified();
                    }
                  }
                }
                get print() {
                  return new PrintAnnotationStorage(this);
                }
                get serializable() {
                  if (this.#storage.size === 0) {
                    return SerializableEmpty;
                  }
                  const map = /* @__PURE__ */ new Map(), hash2 = new _murmurhash.MurmurHash3_64(), transfers = [];
                  const context = /* @__PURE__ */ Object.create(null);
                  let hasBitmap = false;
                  for (const [key2, val] of this.#storage) {
                    const serialized = val instanceof _editor.AnnotationEditor ? val.serialize(false, context) : val;
                    if (serialized) {
                      map.set(key2, serialized);
                      hash2.update(`${key2}:${JSON.stringify(serialized)}`);
                      hasBitmap ||= !!serialized.bitmap;
                    }
                  }
                  if (hasBitmap) {
                    for (const value of map.values()) {
                      if (value.bitmap) {
                        transfers.push(value.bitmap);
                      }
                    }
                  }
                  return map.size > 0 ? {
                    map,
                    hash: hash2.hexdigest(),
                    transfers
                  } : SerializableEmpty;
                }
              }
              exports2.AnnotationStorage = AnnotationStorage;
              class PrintAnnotationStorage extends AnnotationStorage {
                #serializable;
                constructor(parent2) {
                  super();
                  const {
                    map,
                    hash: hash2,
                    transfers
                  } = parent2.serializable;
                  const clone = structuredClone(map, transfers ? {
                    transfer: transfers
                  } : null);
                  this.#serializable = {
                    map: clone,
                    hash: hash2,
                    transfers
                  };
                }
                get print() {
                  (0, _util2.unreachable)("Should not call PrintAnnotationStorage.print");
                }
                get serializable() {
                  return this.#serializable;
                }
              }
              exports2.PrintAnnotationStorage = PrintAnnotationStorage;
            }),
            /* 4 */
            /***/
            ((__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
              Object.defineProperty(exports2, "__esModule", {
                value: true
              });
              exports2.AnnotationEditor = void 0;
              var _tools = __w_pdfjs_require__2(5);
              var _util2 = __w_pdfjs_require__2(1);
              var _display_utils2 = __w_pdfjs_require__2(6);
              class AnnotationEditor {
                #altText = "";
                #altTextDecorative = false;
                #altTextButton = null;
                #altTextTooltip = null;
                #altTextTooltipTimeout = null;
                #keepAspectRatio = false;
                #resizersDiv = null;
                #boundFocusin = this.focusin.bind(this);
                #boundFocusout = this.focusout.bind(this);
                #hasBeenClicked = false;
                #isEditing = false;
                #isInEditMode = false;
                _initialOptions = /* @__PURE__ */ Object.create(null);
                _uiManager = null;
                _focusEventsAllowed = true;
                _l10nPromise = null;
                #isDraggable = false;
                #zIndex = AnnotationEditor._zIndex++;
                static _borderLineWidth = -1;
                static _colorManager = new _tools.ColorManager();
                static _zIndex = 1;
                static SMALL_EDITOR_SIZE = 0;
                constructor(parameters) {
                  if (this.constructor === AnnotationEditor) {
                    (0, _util2.unreachable)("Cannot initialize AnnotationEditor.");
                  }
                  this.parent = parameters.parent;
                  this.id = parameters.id;
                  this.width = this.height = null;
                  this.pageIndex = parameters.parent.pageIndex;
                  this.name = parameters.name;
                  this.div = null;
                  this._uiManager = parameters.uiManager;
                  this.annotationElementId = null;
                  this._willKeepAspectRatio = false;
                  this._initialOptions.isCentered = parameters.isCentered;
                  this._structTreeParentId = null;
                  const {
                    rotation,
                    rawDims: {
                      pageWidth,
                      pageHeight,
                      pageX,
                      pageY
                    }
                  } = this.parent.viewport;
                  this.rotation = rotation;
                  this.pageRotation = (360 + rotation - this._uiManager.viewParameters.rotation) % 360;
                  this.pageDimensions = [pageWidth, pageHeight];
                  this.pageTranslation = [pageX, pageY];
                  const [width, height] = this.parentDimensions;
                  this.x = parameters.x / width;
                  this.y = parameters.y / height;
                  this.isAttachedToDOM = false;
                  this.deleted = false;
                }
                get editorType() {
                  return Object.getPrototypeOf(this).constructor._type;
                }
                static get _defaultLineColor() {
                  return (0, _util2.shadow)(this, "_defaultLineColor", this._colorManager.getHexCode("CanvasText"));
                }
                static deleteAnnotationElement(editor) {
                  const fakeEditor = new FakeEditor({
                    id: editor.parent.getNextId(),
                    parent: editor.parent,
                    uiManager: editor._uiManager
                  });
                  fakeEditor.annotationElementId = editor.annotationElementId;
                  fakeEditor.deleted = true;
                  fakeEditor._uiManager.addToAnnotationStorage(fakeEditor);
                }
                static initialize(l10n, options = null) {
                  AnnotationEditor._l10nPromise ||= new Map(["editor_alt_text_button_label", "editor_alt_text_edit_button_label", "editor_alt_text_decorative_tooltip"].map((str) => [str, l10n.get(str)]));
                  if (options?.strings) {
                    for (const str of options.strings) {
                      AnnotationEditor._l10nPromise.set(str, l10n.get(str));
                    }
                  }
                  if (AnnotationEditor._borderLineWidth !== -1) {
                    return;
                  }
                  const style2 = getComputedStyle(document.documentElement);
                  AnnotationEditor._borderLineWidth = parseFloat(style2.getPropertyValue("--outline-width")) || 0;
                }
                static updateDefaultParams(_type, _value) {
                }
                static get defaultPropertiesToUpdate() {
                  return [];
                }
                static isHandlingMimeForPasting(mime) {
                  return false;
                }
                static paste(item, parent2) {
                  (0, _util2.unreachable)("Not implemented");
                }
                get propertiesToUpdate() {
                  return [];
                }
                get _isDraggable() {
                  return this.#isDraggable;
                }
                set _isDraggable(value) {
                  this.#isDraggable = value;
                  this.div?.classList.toggle("draggable", value);
                }
                center() {
                  const [pageWidth, pageHeight] = this.pageDimensions;
                  switch (this.parentRotation) {
                    case 90:
                      this.x -= this.height * pageHeight / (pageWidth * 2);
                      this.y += this.width * pageWidth / (pageHeight * 2);
                      break;
                    case 180:
                      this.x += this.width / 2;
                      this.y += this.height / 2;
                      break;
                    case 270:
                      this.x += this.height * pageHeight / (pageWidth * 2);
                      this.y -= this.width * pageWidth / (pageHeight * 2);
                      break;
                    default:
                      this.x -= this.width / 2;
                      this.y -= this.height / 2;
                      break;
                  }
                  this.fixAndSetPosition();
                }
                addCommands(params) {
                  this._uiManager.addCommands(params);
                }
                get currentLayer() {
                  return this._uiManager.currentLayer;
                }
                setInBackground() {
                  this.div.style.zIndex = 0;
                }
                setInForeground() {
                  this.div.style.zIndex = this.#zIndex;
                }
                setParent(parent2) {
                  if (parent2 !== null) {
                    this.pageIndex = parent2.pageIndex;
                    this.pageDimensions = parent2.pageDimensions;
                  }
                  this.parent = parent2;
                }
                focusin(event) {
                  if (!this._focusEventsAllowed) {
                    return;
                  }
                  if (!this.#hasBeenClicked) {
                    this.parent.setSelected(this);
                  } else {
                    this.#hasBeenClicked = false;
                  }
                }
                focusout(event) {
                  if (!this._focusEventsAllowed) {
                    return;
                  }
                  if (!this.isAttachedToDOM) {
                    return;
                  }
                  const target = event.relatedTarget;
                  if (target?.closest(`#${this.id}`)) {
                    return;
                  }
                  event.preventDefault();
                  if (!this.parent?.isMultipleSelection) {
                    this.commitOrRemove();
                  }
                }
                commitOrRemove() {
                  if (this.isEmpty()) {
                    this.remove();
                  } else {
                    this.commit();
                  }
                }
                commit() {
                  this.addToAnnotationStorage();
                }
                addToAnnotationStorage() {
                  this._uiManager.addToAnnotationStorage(this);
                }
                setAt(x, y, tx, ty) {
                  const [width, height] = this.parentDimensions;
                  [tx, ty] = this.screenToPageTranslation(tx, ty);
                  this.x = (x + tx) / width;
                  this.y = (y + ty) / height;
                  this.fixAndSetPosition();
                }
                #translate([width, height], x, y) {
                  [x, y] = this.screenToPageTranslation(x, y);
                  this.x += x / width;
                  this.y += y / height;
                  this.fixAndSetPosition();
                }
                translate(x, y) {
                  this.#translate(this.parentDimensions, x, y);
                }
                translateInPage(x, y) {
                  this.#translate(this.pageDimensions, x, y);
                  this.div.scrollIntoView({
                    block: "nearest"
                  });
                }
                drag(tx, ty) {
                  const [parentWidth, parentHeight] = this.parentDimensions;
                  this.x += tx / parentWidth;
                  this.y += ty / parentHeight;
                  if (this.parent && (this.x < 0 || this.x > 1 || this.y < 0 || this.y > 1)) {
                    const {
                      x: x2,
                      y: y2
                    } = this.div.getBoundingClientRect();
                    if (this.parent.findNewParent(this, x2, y2)) {
                      this.x -= Math.floor(this.x);
                      this.y -= Math.floor(this.y);
                    }
                  }
                  let {
                    x,
                    y
                  } = this;
                  const [bx, by] = this.#getBaseTranslation();
                  x += bx;
                  y += by;
                  this.div.style.left = `${(100 * x).toFixed(2)}%`;
                  this.div.style.top = `${(100 * y).toFixed(2)}%`;
                  this.div.scrollIntoView({
                    block: "nearest"
                  });
                }
                #getBaseTranslation() {
                  const [parentWidth, parentHeight] = this.parentDimensions;
                  const {
                    _borderLineWidth
                  } = AnnotationEditor;
                  const x = _borderLineWidth / parentWidth;
                  const y = _borderLineWidth / parentHeight;
                  switch (this.rotation) {
                    case 90:
                      return [-x, y];
                    case 180:
                      return [x, y];
                    case 270:
                      return [x, -y];
                    default:
                      return [-x, -y];
                  }
                }
                fixAndSetPosition() {
                  const [pageWidth, pageHeight] = this.pageDimensions;
                  let {
                    x,
                    y,
                    width,
                    height
                  } = this;
                  width *= pageWidth;
                  height *= pageHeight;
                  x *= pageWidth;
                  y *= pageHeight;
                  switch (this.rotation) {
                    case 0:
                      x = Math.max(0, Math.min(pageWidth - width, x));
                      y = Math.max(0, Math.min(pageHeight - height, y));
                      break;
                    case 90:
                      x = Math.max(0, Math.min(pageWidth - height, x));
                      y = Math.min(pageHeight, Math.max(width, y));
                      break;
                    case 180:
                      x = Math.min(pageWidth, Math.max(width, x));
                      y = Math.min(pageHeight, Math.max(height, y));
                      break;
                    case 270:
                      x = Math.min(pageWidth, Math.max(height, x));
                      y = Math.max(0, Math.min(pageHeight - width, y));
                      break;
                  }
                  this.x = x /= pageWidth;
                  this.y = y /= pageHeight;
                  const [bx, by] = this.#getBaseTranslation();
                  x += bx;
                  y += by;
                  const {
                    style: style2
                  } = this.div;
                  style2.left = `${(100 * x).toFixed(2)}%`;
                  style2.top = `${(100 * y).toFixed(2)}%`;
                  this.moveInDOM();
                }
                static #rotatePoint(x, y, angle) {
                  switch (angle) {
                    case 90:
                      return [y, -x];
                    case 180:
                      return [-x, -y];
                    case 270:
                      return [-y, x];
                    default:
                      return [x, y];
                  }
                }
                screenToPageTranslation(x, y) {
                  return AnnotationEditor.#rotatePoint(x, y, this.parentRotation);
                }
                pageTranslationToScreen(x, y) {
                  return AnnotationEditor.#rotatePoint(x, y, 360 - this.parentRotation);
                }
                #getRotationMatrix(rotation) {
                  switch (rotation) {
                    case 90: {
                      const [pageWidth, pageHeight] = this.pageDimensions;
                      return [0, -pageWidth / pageHeight, pageHeight / pageWidth, 0];
                    }
                    case 180:
                      return [-1, 0, 0, -1];
                    case 270: {
                      const [pageWidth, pageHeight] = this.pageDimensions;
                      return [0, pageWidth / pageHeight, -pageHeight / pageWidth, 0];
                    }
                    default:
                      return [1, 0, 0, 1];
                  }
                }
                get parentScale() {
                  return this._uiManager.viewParameters.realScale;
                }
                get parentRotation() {
                  return (this._uiManager.viewParameters.rotation + this.pageRotation) % 360;
                }
                get parentDimensions() {
                  const {
                    parentScale,
                    pageDimensions: [pageWidth, pageHeight]
                  } = this;
                  const scaledWidth = pageWidth * parentScale;
                  const scaledHeight = pageHeight * parentScale;
                  return _util2.FeatureTest.isCSSRoundSupported ? [Math.round(scaledWidth), Math.round(scaledHeight)] : [scaledWidth, scaledHeight];
                }
                setDims(width, height) {
                  const [parentWidth, parentHeight] = this.parentDimensions;
                  this.div.style.width = `${(100 * width / parentWidth).toFixed(2)}%`;
                  if (!this.#keepAspectRatio) {
                    this.div.style.height = `${(100 * height / parentHeight).toFixed(2)}%`;
                  }
                  this.#altTextButton?.classList.toggle("small", width < AnnotationEditor.SMALL_EDITOR_SIZE || height < AnnotationEditor.SMALL_EDITOR_SIZE);
                }
                fixDims() {
                  const {
                    style: style2
                  } = this.div;
                  const {
                    height,
                    width
                  } = style2;
                  const widthPercent = width.endsWith("%");
                  const heightPercent = !this.#keepAspectRatio && height.endsWith("%");
                  if (widthPercent && heightPercent) {
                    return;
                  }
                  const [parentWidth, parentHeight] = this.parentDimensions;
                  if (!widthPercent) {
                    style2.width = `${(100 * parseFloat(width) / parentWidth).toFixed(2)}%`;
                  }
                  if (!this.#keepAspectRatio && !heightPercent) {
                    style2.height = `${(100 * parseFloat(height) / parentHeight).toFixed(2)}%`;
                  }
                }
                getInitialTranslation() {
                  return [0, 0];
                }
                #createResizers() {
                  if (this.#resizersDiv) {
                    return;
                  }
                  this.#resizersDiv = document.createElement("div");
                  this.#resizersDiv.classList.add("resizers");
                  const classes = ["topLeft", "topRight", "bottomRight", "bottomLeft"];
                  if (!this._willKeepAspectRatio) {
                    classes.push("topMiddle", "middleRight", "bottomMiddle", "middleLeft");
                  }
                  for (const name of classes) {
                    const div = document.createElement("div");
                    this.#resizersDiv.append(div);
                    div.classList.add("resizer", name);
                    div.addEventListener("pointerdown", this.#resizerPointerdown.bind(this, name));
                    div.addEventListener("contextmenu", _display_utils2.noContextMenu);
                  }
                  this.div.prepend(this.#resizersDiv);
                }
                #resizerPointerdown(name, event) {
                  event.preventDefault();
                  const {
                    isMac
                  } = _util2.FeatureTest.platform;
                  if (event.button !== 0 || event.ctrlKey && isMac) {
                    return;
                  }
                  const boundResizerPointermove = this.#resizerPointermove.bind(this, name);
                  const savedDraggable = this._isDraggable;
                  this._isDraggable = false;
                  const pointerMoveOptions = {
                    passive: true,
                    capture: true
                  };
                  window.addEventListener("pointermove", boundResizerPointermove, pointerMoveOptions);
                  const savedX = this.x;
                  const savedY = this.y;
                  const savedWidth = this.width;
                  const savedHeight = this.height;
                  const savedParentCursor = this.parent.div.style.cursor;
                  const savedCursor = this.div.style.cursor;
                  this.div.style.cursor = this.parent.div.style.cursor = window.getComputedStyle(event.target).cursor;
                  const pointerUpCallback = () => {
                    this._isDraggable = savedDraggable;
                    window.removeEventListener("pointerup", pointerUpCallback);
                    window.removeEventListener("blur", pointerUpCallback);
                    window.removeEventListener("pointermove", boundResizerPointermove, pointerMoveOptions);
                    this.parent.div.style.cursor = savedParentCursor;
                    this.div.style.cursor = savedCursor;
                    const newX = this.x;
                    const newY = this.y;
                    const newWidth = this.width;
                    const newHeight = this.height;
                    if (newX === savedX && newY === savedY && newWidth === savedWidth && newHeight === savedHeight) {
                      return;
                    }
                    this.addCommands({
                      cmd: () => {
                        this.width = newWidth;
                        this.height = newHeight;
                        this.x = newX;
                        this.y = newY;
                        const [parentWidth, parentHeight] = this.parentDimensions;
                        this.setDims(parentWidth * newWidth, parentHeight * newHeight);
                        this.fixAndSetPosition();
                      },
                      undo: () => {
                        this.width = savedWidth;
                        this.height = savedHeight;
                        this.x = savedX;
                        this.y = savedY;
                        const [parentWidth, parentHeight] = this.parentDimensions;
                        this.setDims(parentWidth * savedWidth, parentHeight * savedHeight);
                        this.fixAndSetPosition();
                      },
                      mustExec: true
                    });
                  };
                  window.addEventListener("pointerup", pointerUpCallback);
                  window.addEventListener("blur", pointerUpCallback);
                }
                #resizerPointermove(name, event) {
                  const [parentWidth, parentHeight] = this.parentDimensions;
                  const savedX = this.x;
                  const savedY = this.y;
                  const savedWidth = this.width;
                  const savedHeight = this.height;
                  const minWidth = AnnotationEditor.MIN_SIZE / parentWidth;
                  const minHeight = AnnotationEditor.MIN_SIZE / parentHeight;
                  const round3 = (x) => Math.round(x * 1e4) / 1e4;
                  const rotationMatrix = this.#getRotationMatrix(this.rotation);
                  const transf = (x, y) => [rotationMatrix[0] * x + rotationMatrix[2] * y, rotationMatrix[1] * x + rotationMatrix[3] * y];
                  const invRotationMatrix = this.#getRotationMatrix(360 - this.rotation);
                  const invTransf = (x, y) => [invRotationMatrix[0] * x + invRotationMatrix[2] * y, invRotationMatrix[1] * x + invRotationMatrix[3] * y];
                  let getPoint;
                  let getOpposite;
                  let isDiagonal = false;
                  let isHorizontal = false;
                  switch (name) {
                    case "topLeft":
                      isDiagonal = true;
                      getPoint = (w, h2) => [0, 0];
                      getOpposite = (w, h2) => [w, h2];
                      break;
                    case "topMiddle":
                      getPoint = (w, h2) => [w / 2, 0];
                      getOpposite = (w, h2) => [w / 2, h2];
                      break;
                    case "topRight":
                      isDiagonal = true;
                      getPoint = (w, h2) => [w, 0];
                      getOpposite = (w, h2) => [0, h2];
                      break;
                    case "middleRight":
                      isHorizontal = true;
                      getPoint = (w, h2) => [w, h2 / 2];
                      getOpposite = (w, h2) => [0, h2 / 2];
                      break;
                    case "bottomRight":
                      isDiagonal = true;
                      getPoint = (w, h2) => [w, h2];
                      getOpposite = (w, h2) => [0, 0];
                      break;
                    case "bottomMiddle":
                      getPoint = (w, h2) => [w / 2, h2];
                      getOpposite = (w, h2) => [w / 2, 0];
                      break;
                    case "bottomLeft":
                      isDiagonal = true;
                      getPoint = (w, h2) => [0, h2];
                      getOpposite = (w, h2) => [w, 0];
                      break;
                    case "middleLeft":
                      isHorizontal = true;
                      getPoint = (w, h2) => [0, h2 / 2];
                      getOpposite = (w, h2) => [w, h2 / 2];
                      break;
                  }
                  const point = getPoint(savedWidth, savedHeight);
                  const oppositePoint = getOpposite(savedWidth, savedHeight);
                  let transfOppositePoint = transf(...oppositePoint);
                  const oppositeX = round3(savedX + transfOppositePoint[0]);
                  const oppositeY = round3(savedY + transfOppositePoint[1]);
                  let ratioX = 1;
                  let ratioY = 1;
                  let [deltaX, deltaY] = this.screenToPageTranslation(event.movementX, event.movementY);
                  [deltaX, deltaY] = invTransf(deltaX / parentWidth, deltaY / parentHeight);
                  if (isDiagonal) {
                    const oldDiag = Math.hypot(savedWidth, savedHeight);
                    ratioX = ratioY = Math.max(Math.min(Math.hypot(oppositePoint[0] - point[0] - deltaX, oppositePoint[1] - point[1] - deltaY) / oldDiag, 1 / savedWidth, 1 / savedHeight), minWidth / savedWidth, minHeight / savedHeight);
                  } else if (isHorizontal) {
                    ratioX = Math.max(minWidth, Math.min(1, Math.abs(oppositePoint[0] - point[0] - deltaX))) / savedWidth;
                  } else {
                    ratioY = Math.max(minHeight, Math.min(1, Math.abs(oppositePoint[1] - point[1] - deltaY))) / savedHeight;
                  }
                  const newWidth = round3(savedWidth * ratioX);
                  const newHeight = round3(savedHeight * ratioY);
                  transfOppositePoint = transf(...getOpposite(newWidth, newHeight));
                  const newX = oppositeX - transfOppositePoint[0];
                  const newY = oppositeY - transfOppositePoint[1];
                  this.width = newWidth;
                  this.height = newHeight;
                  this.x = newX;
                  this.y = newY;
                  this.setDims(parentWidth * newWidth, parentHeight * newHeight);
                  this.fixAndSetPosition();
                }
                async addAltTextButton() {
                  if (this.#altTextButton) {
                    return;
                  }
                  const altText = this.#altTextButton = document.createElement("button");
                  altText.className = "altText";
                  const msg = await AnnotationEditor._l10nPromise.get("editor_alt_text_button_label");
                  altText.textContent = msg;
                  altText.setAttribute("aria-label", msg);
                  altText.tabIndex = "0";
                  altText.addEventListener("contextmenu", _display_utils2.noContextMenu);
                  altText.addEventListener("pointerdown", (event) => event.stopPropagation());
                  altText.addEventListener("click", (event) => {
                    event.preventDefault();
                    this._uiManager.editAltText(this);
                  }, {
                    capture: true
                  });
                  altText.addEventListener("keydown", (event) => {
                    if (event.target === altText && event.key === "Enter") {
                      event.preventDefault();
                      this._uiManager.editAltText(this);
                    }
                  });
                  this.#setAltTextButtonState();
                  this.div.append(altText);
                  if (!AnnotationEditor.SMALL_EDITOR_SIZE) {
                    const PERCENT = 40;
                    AnnotationEditor.SMALL_EDITOR_SIZE = Math.min(128, Math.round(altText.getBoundingClientRect().width * (1 + PERCENT / 100)));
                  }
                }
                async #setAltTextButtonState() {
                  const button = this.#altTextButton;
                  if (!button) {
                    return;
                  }
                  if (!this.#altText && !this.#altTextDecorative) {
                    button.classList.remove("done");
                    this.#altTextTooltip?.remove();
                    return;
                  }
                  AnnotationEditor._l10nPromise.get("editor_alt_text_edit_button_label").then((msg) => {
                    button.setAttribute("aria-label", msg);
                  });
                  let tooltip = this.#altTextTooltip;
                  if (!tooltip) {
                    this.#altTextTooltip = tooltip = document.createElement("span");
                    tooltip.className = "tooltip";
                    tooltip.setAttribute("role", "tooltip");
                    const id = tooltip.id = `alt-text-tooltip-${this.id}`;
                    button.setAttribute("aria-describedby", id);
                    const DELAY_TO_SHOW_TOOLTIP = 100;
                    button.addEventListener("mouseenter", () => {
                      this.#altTextTooltipTimeout = setTimeout(() => {
                        this.#altTextTooltipTimeout = null;
                        this.#altTextTooltip.classList.add("show");
                        this._uiManager._eventBus.dispatch("reporttelemetry", {
                          source: this,
                          details: {
                            type: "editing",
                            subtype: this.editorType,
                            data: {
                              action: "alt_text_tooltip"
                            }
                          }
                        });
                      }, DELAY_TO_SHOW_TOOLTIP);
                    });
                    button.addEventListener("mouseleave", () => {
                      clearTimeout(this.#altTextTooltipTimeout);
                      this.#altTextTooltipTimeout = null;
                      this.#altTextTooltip?.classList.remove("show");
                    });
                  }
                  button.classList.add("done");
                  tooltip.innerText = this.#altTextDecorative ? await AnnotationEditor._l10nPromise.get("editor_alt_text_decorative_tooltip") : this.#altText;
                  if (!tooltip.parentNode) {
                    button.append(tooltip);
                  }
                }
                getClientDimensions() {
                  return this.div.getBoundingClientRect();
                }
                get altTextData() {
                  return {
                    altText: this.#altText,
                    decorative: this.#altTextDecorative
                  };
                }
                set altTextData({
                  altText,
                  decorative
                }) {
                  if (this.#altText === altText && this.#altTextDecorative === decorative) {
                    return;
                  }
                  this.#altText = altText;
                  this.#altTextDecorative = decorative;
                  this.#setAltTextButtonState();
                }
                render() {
                  this.div = document.createElement("div");
                  this.div.setAttribute("data-editor-rotation", (360 - this.rotation) % 360);
                  this.div.className = this.name;
                  this.div.setAttribute("id", this.id);
                  this.div.setAttribute("tabIndex", 0);
                  this.setInForeground();
                  this.div.addEventListener("focusin", this.#boundFocusin);
                  this.div.addEventListener("focusout", this.#boundFocusout);
                  const [parentWidth, parentHeight] = this.parentDimensions;
                  if (this.parentRotation % 180 !== 0) {
                    this.div.style.maxWidth = `${(100 * parentHeight / parentWidth).toFixed(2)}%`;
                    this.div.style.maxHeight = `${(100 * parentWidth / parentHeight).toFixed(2)}%`;
                  }
                  const [tx, ty] = this.getInitialTranslation();
                  this.translate(tx, ty);
                  (0, _tools.bindEvents)(this, this.div, ["pointerdown"]);
                  return this.div;
                }
                pointerdown(event) {
                  const {
                    isMac
                  } = _util2.FeatureTest.platform;
                  if (event.button !== 0 || event.ctrlKey && isMac) {
                    event.preventDefault();
                    return;
                  }
                  this.#hasBeenClicked = true;
                  this.#setUpDragSession(event);
                }
                #setUpDragSession(event) {
                  if (!this._isDraggable) {
                    return;
                  }
                  const isSelected = this._uiManager.isSelected(this);
                  this._uiManager.setUpDragSession();
                  let pointerMoveOptions, pointerMoveCallback;
                  if (isSelected) {
                    pointerMoveOptions = {
                      passive: true,
                      capture: true
                    };
                    pointerMoveCallback = (e3) => {
                      const [tx, ty] = this.screenToPageTranslation(e3.movementX, e3.movementY);
                      this._uiManager.dragSelectedEditors(tx, ty);
                    };
                    window.addEventListener("pointermove", pointerMoveCallback, pointerMoveOptions);
                  }
                  const pointerUpCallback = () => {
                    window.removeEventListener("pointerup", pointerUpCallback);
                    window.removeEventListener("blur", pointerUpCallback);
                    if (isSelected) {
                      window.removeEventListener("pointermove", pointerMoveCallback, pointerMoveOptions);
                    }
                    this.#hasBeenClicked = false;
                    if (!this._uiManager.endDragSession()) {
                      const {
                        isMac
                      } = _util2.FeatureTest.platform;
                      if (event.ctrlKey && !isMac || event.shiftKey || event.metaKey && isMac) {
                        this.parent.toggleSelected(this);
                      } else {
                        this.parent.setSelected(this);
                      }
                    }
                  };
                  window.addEventListener("pointerup", pointerUpCallback);
                  window.addEventListener("blur", pointerUpCallback);
                }
                moveInDOM() {
                  this.parent?.moveEditorInDOM(this);
                }
                _setParentAndPosition(parent2, x, y) {
                  parent2.changeParent(this);
                  this.x = x;
                  this.y = y;
                  this.fixAndSetPosition();
                }
                getRect(tx, ty) {
                  const scale = this.parentScale;
                  const [pageWidth, pageHeight] = this.pageDimensions;
                  const [pageX, pageY] = this.pageTranslation;
                  const shiftX = tx / scale;
                  const shiftY = ty / scale;
                  const x = this.x * pageWidth;
                  const y = this.y * pageHeight;
                  const width = this.width * pageWidth;
                  const height = this.height * pageHeight;
                  switch (this.rotation) {
                    case 0:
                      return [x + shiftX + pageX, pageHeight - y - shiftY - height + pageY, x + shiftX + width + pageX, pageHeight - y - shiftY + pageY];
                    case 90:
                      return [x + shiftY + pageX, pageHeight - y + shiftX + pageY, x + shiftY + height + pageX, pageHeight - y + shiftX + width + pageY];
                    case 180:
                      return [x - shiftX - width + pageX, pageHeight - y + shiftY + pageY, x - shiftX + pageX, pageHeight - y + shiftY + height + pageY];
                    case 270:
                      return [x - shiftY - height + pageX, pageHeight - y - shiftX - width + pageY, x - shiftY + pageX, pageHeight - y - shiftX + pageY];
                    default:
                      throw new Error("Invalid rotation");
                  }
                }
                getRectInCurrentCoords(rect, pageHeight) {
                  const [x1, y1, x2, y2] = rect;
                  const width = x2 - x1;
                  const height = y2 - y1;
                  switch (this.rotation) {
                    case 0:
                      return [x1, pageHeight - y2, width, height];
                    case 90:
                      return [x1, pageHeight - y1, height, width];
                    case 180:
                      return [x2, pageHeight - y1, width, height];
                    case 270:
                      return [x2, pageHeight - y2, height, width];
                    default:
                      throw new Error("Invalid rotation");
                  }
                }
                onceAdded() {
                }
                isEmpty() {
                  return false;
                }
                enableEditMode() {
                  this.#isInEditMode = true;
                }
                disableEditMode() {
                  this.#isInEditMode = false;
                }
                isInEditMode() {
                  return this.#isInEditMode;
                }
                shouldGetKeyboardEvents() {
                  return false;
                }
                needsToBeRebuilt() {
                  return this.div && !this.isAttachedToDOM;
                }
                rebuild() {
                  this.div?.addEventListener("focusin", this.#boundFocusin);
                  this.div?.addEventListener("focusout", this.#boundFocusout);
                }
                serialize(isForCopying = false, context = null) {
                  (0, _util2.unreachable)("An editor must be serializable");
                }
                static deserialize(data2, parent2, uiManager) {
                  const editor = new this.prototype.constructor({
                    parent: parent2,
                    id: parent2.getNextId(),
                    uiManager
                  });
                  editor.rotation = data2.rotation;
                  const [pageWidth, pageHeight] = editor.pageDimensions;
                  const [x, y, width, height] = editor.getRectInCurrentCoords(data2.rect, pageHeight);
                  editor.x = x / pageWidth;
                  editor.y = y / pageHeight;
                  editor.width = width / pageWidth;
                  editor.height = height / pageHeight;
                  return editor;
                }
                remove() {
                  this.div.removeEventListener("focusin", this.#boundFocusin);
                  this.div.removeEventListener("focusout", this.#boundFocusout);
                  if (!this.isEmpty()) {
                    this.commit();
                  }
                  if (this.parent) {
                    this.parent.remove(this);
                  } else {
                    this._uiManager.removeEditor(this);
                  }
                  this.#altTextButton?.remove();
                  this.#altTextButton = null;
                  this.#altTextTooltip = null;
                }
                get isResizable() {
                  return false;
                }
                makeResizable() {
                  if (this.isResizable) {
                    this.#createResizers();
                    this.#resizersDiv.classList.remove("hidden");
                  }
                }
                select() {
                  this.makeResizable();
                  this.div?.classList.add("selectedEditor");
                }
                unselect() {
                  this.#resizersDiv?.classList.add("hidden");
                  this.div?.classList.remove("selectedEditor");
                  if (this.div?.contains(document.activeElement)) {
                    this._uiManager.currentLayer.div.focus();
                  }
                }
                updateParams(type5, value) {
                }
                disableEditing() {
                  if (this.#altTextButton) {
                    this.#altTextButton.hidden = true;
                  }
                }
                enableEditing() {
                  if (this.#altTextButton) {
                    this.#altTextButton.hidden = false;
                  }
                }
                enterInEditMode() {
                }
                get contentDiv() {
                  return this.div;
                }
                get isEditing() {
                  return this.#isEditing;
                }
                set isEditing(value) {
                  this.#isEditing = value;
                  if (!this.parent) {
                    return;
                  }
                  if (value) {
                    this.parent.setSelected(this);
                    this.parent.setActiveEditor(this);
                  } else {
                    this.parent.setActiveEditor(null);
                  }
                }
                setAspectRatio(width, height) {
                  this.#keepAspectRatio = true;
                  const aspectRatio = width / height;
                  const {
                    style: style2
                  } = this.div;
                  style2.aspectRatio = aspectRatio;
                  style2.height = "auto";
                }
                static get MIN_SIZE() {
                  return 16;
                }
              }
              exports2.AnnotationEditor = AnnotationEditor;
              class FakeEditor extends AnnotationEditor {
                constructor(params) {
                  super(params);
                  this.annotationElementId = params.annotationElementId;
                  this.deleted = true;
                }
                serialize() {
                  return {
                    id: this.annotationElementId,
                    deleted: true,
                    pageIndex: this.pageIndex
                  };
                }
              }
            }),
            /* 5 */
            /***/
            ((__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
              Object.defineProperty(exports2, "__esModule", {
                value: true
              });
              exports2.KeyboardManager = exports2.CommandManager = exports2.ColorManager = exports2.AnnotationEditorUIManager = void 0;
              exports2.bindEvents = bindEvents;
              exports2.opacityToHex = opacityToHex;
              var _util2 = __w_pdfjs_require__2(1);
              var _display_utils2 = __w_pdfjs_require__2(6);
              function bindEvents(obj, element, names2) {
                for (const name of names2) {
                  element.addEventListener(name, obj[name].bind(obj));
                }
              }
              function opacityToHex(opacity) {
                return Math.round(Math.min(255, Math.max(1, 255 * opacity))).toString(16).padStart(2, "0");
              }
              class IdManager {
                #id = 0;
                getId() {
                  return `${_util2.AnnotationEditorPrefix}${this.#id++}`;
                }
              }
              class ImageManager {
                #baseId = (0, _util2.getUuid)();
                #id = 0;
                #cache = null;
                static get _isSVGFittingCanvas() {
                  const svg = `data:image/svg+xml;charset=UTF-8,<svg viewBox="0 0 1 1" width="1" height="1" xmlns="http://www.w3.org/2000/svg"><rect width="1" height="1" style="fill:red;"/></svg>`;
                  const canvas = new OffscreenCanvas(1, 3);
                  const ctx = canvas.getContext("2d");
                  const image = new Image();
                  image.src = svg;
                  const promise = image.decode().then(() => {
                    ctx.drawImage(image, 0, 0, 1, 1, 0, 0, 1, 3);
                    return new Uint32Array(ctx.getImageData(0, 0, 1, 1).data.buffer)[0] === 0;
                  });
                  return (0, _util2.shadow)(this, "_isSVGFittingCanvas", promise);
                }
                async #get(key2, rawData) {
                  this.#cache ||= /* @__PURE__ */ new Map();
                  let data2 = this.#cache.get(key2);
                  if (data2 === null) {
                    return null;
                  }
                  if (data2?.bitmap) {
                    data2.refCounter += 1;
                    return data2;
                  }
                  try {
                    data2 ||= {
                      bitmap: null,
                      id: `image_${this.#baseId}_${this.#id++}`,
                      refCounter: 0,
                      isSvg: false
                    };
                    let image;
                    if (typeof rawData === "string") {
                      data2.url = rawData;
                      const response = await fetch(rawData);
                      if (!response.ok) {
                        throw new Error(response.statusText);
                      }
                      image = await response.blob();
                    } else {
                      image = data2.file = rawData;
                    }
                    if (image.type === "image/svg+xml") {
                      const mustRemoveAspectRatioPromise = ImageManager._isSVGFittingCanvas;
                      const fileReader = new FileReader();
                      const imageElement = new Image();
                      const imagePromise = new Promise((resolve, reject) => {
                        imageElement.onload = () => {
                          data2.bitmap = imageElement;
                          data2.isSvg = true;
                          resolve();
                        };
                        fileReader.onload = async () => {
                          const url2 = data2.svgUrl = fileReader.result;
                          imageElement.src = await mustRemoveAspectRatioPromise ? `${url2}#svgView(preserveAspectRatio(none))` : url2;
                        };
                        imageElement.onerror = fileReader.onerror = reject;
                      });
                      fileReader.readAsDataURL(image);
                      await imagePromise;
                    } else {
                      data2.bitmap = await createImageBitmap(image);
                    }
                    data2.refCounter = 1;
                  } catch (e3) {
                    console.error(e3);
                    data2 = null;
                  }
                  this.#cache.set(key2, data2);
                  if (data2) {
                    this.#cache.set(data2.id, data2);
                  }
                  return data2;
                }
                async getFromFile(file) {
                  const {
                    lastModified,
                    name,
                    size,
                    type: type5
                  } = file;
                  return this.#get(`${lastModified}_${name}_${size}_${type5}`, file);
                }
                async getFromUrl(url2) {
                  return this.#get(url2, url2);
                }
                async getFromId(id) {
                  this.#cache ||= /* @__PURE__ */ new Map();
                  const data2 = this.#cache.get(id);
                  if (!data2) {
                    return null;
                  }
                  if (data2.bitmap) {
                    data2.refCounter += 1;
                    return data2;
                  }
                  if (data2.file) {
                    return this.getFromFile(data2.file);
                  }
                  return this.getFromUrl(data2.url);
                }
                getSvgUrl(id) {
                  const data2 = this.#cache.get(id);
                  if (!data2?.isSvg) {
                    return null;
                  }
                  return data2.svgUrl;
                }
                deleteId(id) {
                  this.#cache ||= /* @__PURE__ */ new Map();
                  const data2 = this.#cache.get(id);
                  if (!data2) {
                    return;
                  }
                  data2.refCounter -= 1;
                  if (data2.refCounter !== 0) {
                    return;
                  }
                  data2.bitmap = null;
                }
                isValidId(id) {
                  return id.startsWith(`image_${this.#baseId}_`);
                }
              }
              class CommandManager {
                #commands = [];
                #locked = false;
                #maxSize;
                #position = -1;
                constructor(maxSize = 128) {
                  this.#maxSize = maxSize;
                }
                add({
                  cmd,
                  undo,
                  mustExec,
                  type: type5 = NaN,
                  overwriteIfSameType = false,
                  keepUndo = false
                }) {
                  if (mustExec) {
                    cmd();
                  }
                  if (this.#locked) {
                    return;
                  }
                  const save = {
                    cmd,
                    undo,
                    type: type5
                  };
                  if (this.#position === -1) {
                    if (this.#commands.length > 0) {
                      this.#commands.length = 0;
                    }
                    this.#position = 0;
                    this.#commands.push(save);
                    return;
                  }
                  if (overwriteIfSameType && this.#commands[this.#position].type === type5) {
                    if (keepUndo) {
                      save.undo = this.#commands[this.#position].undo;
                    }
                    this.#commands[this.#position] = save;
                    return;
                  }
                  const next2 = this.#position + 1;
                  if (next2 === this.#maxSize) {
                    this.#commands.splice(0, 1);
                  } else {
                    this.#position = next2;
                    if (next2 < this.#commands.length) {
                      this.#commands.splice(next2);
                    }
                  }
                  this.#commands.push(save);
                }
                undo() {
                  if (this.#position === -1) {
                    return;
                  }
                  this.#locked = true;
                  this.#commands[this.#position].undo();
                  this.#locked = false;
                  this.#position -= 1;
                }
                redo() {
                  if (this.#position < this.#commands.length - 1) {
                    this.#position += 1;
                    this.#locked = true;
                    this.#commands[this.#position].cmd();
                    this.#locked = false;
                  }
                }
                hasSomethingToUndo() {
                  return this.#position !== -1;
                }
                hasSomethingToRedo() {
                  return this.#position < this.#commands.length - 1;
                }
                destroy() {
                  this.#commands = null;
                }
              }
              exports2.CommandManager = CommandManager;
              class KeyboardManager {
                constructor(callbacks) {
                  this.buffer = [];
                  this.callbacks = /* @__PURE__ */ new Map();
                  this.allKeys = /* @__PURE__ */ new Set();
                  const {
                    isMac
                  } = _util2.FeatureTest.platform;
                  for (const [keys4, callback, options = {}] of callbacks) {
                    for (const key2 of keys4) {
                      const isMacKey = key2.startsWith("mac+");
                      if (isMac && isMacKey) {
                        this.callbacks.set(key2.slice(4), {
                          callback,
                          options
                        });
                        this.allKeys.add(key2.split("+").at(-1));
                      } else if (!isMac && !isMacKey) {
                        this.callbacks.set(key2, {
                          callback,
                          options
                        });
                        this.allKeys.add(key2.split("+").at(-1));
                      }
                    }
                  }
                }
                #serialize(event) {
                  if (event.altKey) {
                    this.buffer.push("alt");
                  }
                  if (event.ctrlKey) {
                    this.buffer.push("ctrl");
                  }
                  if (event.metaKey) {
                    this.buffer.push("meta");
                  }
                  if (event.shiftKey) {
                    this.buffer.push("shift");
                  }
                  this.buffer.push(event.key);
                  const str = this.buffer.join("+");
                  this.buffer.length = 0;
                  return str;
                }
                exec(self2, event) {
                  if (!this.allKeys.has(event.key)) {
                    return;
                  }
                  const info = this.callbacks.get(this.#serialize(event));
                  if (!info) {
                    return;
                  }
                  const {
                    callback,
                    options: {
                      bubbles = false,
                      args = [],
                      checker = null
                    }
                  } = info;
                  if (checker && !checker(self2, event)) {
                    return;
                  }
                  callback.bind(self2, ...args)();
                  if (!bubbles) {
                    event.stopPropagation();
                    event.preventDefault();
                  }
                }
              }
              exports2.KeyboardManager = KeyboardManager;
              class ColorManager {
                static _colorsMapping = /* @__PURE__ */ new Map([["CanvasText", [0, 0, 0]], ["Canvas", [255, 255, 255]]]);
                get _colors() {
                  const colors = /* @__PURE__ */ new Map([["CanvasText", null], ["Canvas", null]]);
                  (0, _display_utils2.getColorValues)(colors);
                  return (0, _util2.shadow)(this, "_colors", colors);
                }
                convert(color) {
                  const rgb2 = (0, _display_utils2.getRGB)(color);
                  if (!window.matchMedia("(forced-colors: active)").matches) {
                    return rgb2;
                  }
                  for (const [name, RGB2] of this._colors) {
                    if (RGB2.every((x, i) => x === rgb2[i])) {
                      return ColorManager._colorsMapping.get(name);
                    }
                  }
                  return rgb2;
                }
                getHexCode(name) {
                  const rgb2 = this._colors.get(name);
                  if (!rgb2) {
                    return name;
                  }
                  return _util2.Util.makeHexColor(...rgb2);
                }
              }
              exports2.ColorManager = ColorManager;
              class AnnotationEditorUIManager {
                #activeEditor = null;
                #allEditors = /* @__PURE__ */ new Map();
                #allLayers = /* @__PURE__ */ new Map();
                #altTextManager = null;
                #annotationStorage = null;
                #commandManager = new CommandManager();
                #currentPageIndex = 0;
                #deletedAnnotationsElementIds = /* @__PURE__ */ new Set();
                #draggingEditors = null;
                #editorTypes = null;
                #editorsToRescale = /* @__PURE__ */ new Set();
                #filterFactory = null;
                #idManager = new IdManager();
                #isEnabled = false;
                #isWaiting = false;
                #lastActiveElement = null;
                #mode = _util2.AnnotationEditorType.NONE;
                #selectedEditors = /* @__PURE__ */ new Set();
                #pageColors = null;
                #boundBlur = this.blur.bind(this);
                #boundFocus = this.focus.bind(this);
                #boundCopy = this.copy.bind(this);
                #boundCut = this.cut.bind(this);
                #boundPaste = this.paste.bind(this);
                #boundKeydown = this.keydown.bind(this);
                #boundOnEditingAction = this.onEditingAction.bind(this);
                #boundOnPageChanging = this.onPageChanging.bind(this);
                #boundOnScaleChanging = this.onScaleChanging.bind(this);
                #boundOnRotationChanging = this.onRotationChanging.bind(this);
                #previousStates = {
                  isEditing: false,
                  isEmpty: true,
                  hasSomethingToUndo: false,
                  hasSomethingToRedo: false,
                  hasSelectedEditor: false
                };
                #translation = [0, 0];
                #translationTimeoutId = null;
                #container = null;
                #viewer = null;
                static TRANSLATE_SMALL = 1;
                static TRANSLATE_BIG = 10;
                static get _keyboardManager() {
                  const proto = AnnotationEditorUIManager.prototype;
                  const arrowChecker = (self2) => {
                    const {
                      activeElement
                    } = document;
                    return activeElement && self2.#container.contains(activeElement) && self2.hasSomethingToControl();
                  };
                  const small = this.TRANSLATE_SMALL;
                  const big = this.TRANSLATE_BIG;
                  return (0, _util2.shadow)(this, "_keyboardManager", new KeyboardManager([[["ctrl+a", "mac+meta+a"], proto.selectAll], [["ctrl+z", "mac+meta+z"], proto.undo], [["ctrl+y", "ctrl+shift+z", "mac+meta+shift+z", "ctrl+shift+Z", "mac+meta+shift+Z"], proto.redo], [["Backspace", "alt+Backspace", "ctrl+Backspace", "shift+Backspace", "mac+Backspace", "mac+alt+Backspace", "mac+ctrl+Backspace", "Delete", "ctrl+Delete", "shift+Delete", "mac+Delete"], proto.delete], [["Escape", "mac+Escape"], proto.unselectAll], [["ArrowLeft", "mac+ArrowLeft"], proto.translateSelectedEditors, {
                    args: [-small, 0],
                    checker: arrowChecker
                  }], [["ctrl+ArrowLeft", "mac+shift+ArrowLeft"], proto.translateSelectedEditors, {
                    args: [-big, 0],
                    checker: arrowChecker
                  }], [["ArrowRight", "mac+ArrowRight"], proto.translateSelectedEditors, {
                    args: [small, 0],
                    checker: arrowChecker
                  }], [["ctrl+ArrowRight", "mac+shift+ArrowRight"], proto.translateSelectedEditors, {
                    args: [big, 0],
                    checker: arrowChecker
                  }], [["ArrowUp", "mac+ArrowUp"], proto.translateSelectedEditors, {
                    args: [0, -small],
                    checker: arrowChecker
                  }], [["ctrl+ArrowUp", "mac+shift+ArrowUp"], proto.translateSelectedEditors, {
                    args: [0, -big],
                    checker: arrowChecker
                  }], [["ArrowDown", "mac+ArrowDown"], proto.translateSelectedEditors, {
                    args: [0, small],
                    checker: arrowChecker
                  }], [["ctrl+ArrowDown", "mac+shift+ArrowDown"], proto.translateSelectedEditors, {
                    args: [0, big],
                    checker: arrowChecker
                  }]]));
                }
                constructor(container, viewer, altTextManager, eventBus, pdfDocument, pageColors) {
                  this.#container = container;
                  this.#viewer = viewer;
                  this.#altTextManager = altTextManager;
                  this._eventBus = eventBus;
                  this._eventBus._on("editingaction", this.#boundOnEditingAction);
                  this._eventBus._on("pagechanging", this.#boundOnPageChanging);
                  this._eventBus._on("scalechanging", this.#boundOnScaleChanging);
                  this._eventBus._on("rotationchanging", this.#boundOnRotationChanging);
                  this.#annotationStorage = pdfDocument.annotationStorage;
                  this.#filterFactory = pdfDocument.filterFactory;
                  this.#pageColors = pageColors;
                  this.viewParameters = {
                    realScale: _display_utils2.PixelsPerInch.PDF_TO_CSS_UNITS,
                    rotation: 0
                  };
                }
                destroy() {
                  this.#removeKeyboardManager();
                  this.#removeFocusManager();
                  this._eventBus._off("editingaction", this.#boundOnEditingAction);
                  this._eventBus._off("pagechanging", this.#boundOnPageChanging);
                  this._eventBus._off("scalechanging", this.#boundOnScaleChanging);
                  this._eventBus._off("rotationchanging", this.#boundOnRotationChanging);
                  for (const layer of this.#allLayers.values()) {
                    layer.destroy();
                  }
                  this.#allLayers.clear();
                  this.#allEditors.clear();
                  this.#editorsToRescale.clear();
                  this.#activeEditor = null;
                  this.#selectedEditors.clear();
                  this.#commandManager.destroy();
                  this.#altTextManager.destroy();
                }
                get hcmFilter() {
                  return (0, _util2.shadow)(this, "hcmFilter", this.#pageColors ? this.#filterFactory.addHCMFilter(this.#pageColors.foreground, this.#pageColors.background) : "none");
                }
                get direction() {
                  return (0, _util2.shadow)(this, "direction", getComputedStyle(this.#container).direction);
                }
                editAltText(editor) {
                  this.#altTextManager?.editAltText(this, editor);
                }
                onPageChanging({
                  pageNumber
                }) {
                  this.#currentPageIndex = pageNumber - 1;
                }
                focusMainContainer() {
                  this.#container.focus();
                }
                findParent(x, y) {
                  for (const layer of this.#allLayers.values()) {
                    const {
                      x: layerX,
                      y: layerY,
                      width,
                      height
                    } = layer.div.getBoundingClientRect();
                    if (x >= layerX && x <= layerX + width && y >= layerY && y <= layerY + height) {
                      return layer;
                    }
                  }
                  return null;
                }
                disableUserSelect(value = false) {
                  this.#viewer.classList.toggle("noUserSelect", value);
                }
                addShouldRescale(editor) {
                  this.#editorsToRescale.add(editor);
                }
                removeShouldRescale(editor) {
                  this.#editorsToRescale.delete(editor);
                }
                onScaleChanging({
                  scale
                }) {
                  this.commitOrRemove();
                  this.viewParameters.realScale = scale * _display_utils2.PixelsPerInch.PDF_TO_CSS_UNITS;
                  for (const editor of this.#editorsToRescale) {
                    editor.onScaleChanging();
                  }
                }
                onRotationChanging({
                  pagesRotation
                }) {
                  this.commitOrRemove();
                  this.viewParameters.rotation = pagesRotation;
                }
                addToAnnotationStorage(editor) {
                  if (!editor.isEmpty() && this.#annotationStorage && !this.#annotationStorage.has(editor.id)) {
                    this.#annotationStorage.setValue(editor.id, editor);
                  }
                }
                #addFocusManager() {
                  window.addEventListener("focus", this.#boundFocus);
                  window.addEventListener("blur", this.#boundBlur);
                }
                #removeFocusManager() {
                  window.removeEventListener("focus", this.#boundFocus);
                  window.removeEventListener("blur", this.#boundBlur);
                }
                blur() {
                  if (!this.hasSelection) {
                    return;
                  }
                  const {
                    activeElement
                  } = document;
                  for (const editor of this.#selectedEditors) {
                    if (editor.div.contains(activeElement)) {
                      this.#lastActiveElement = [editor, activeElement];
                      editor._focusEventsAllowed = false;
                      break;
                    }
                  }
                }
                focus() {
                  if (!this.#lastActiveElement) {
                    return;
                  }
                  const [lastEditor, lastActiveElement] = this.#lastActiveElement;
                  this.#lastActiveElement = null;
                  lastActiveElement.addEventListener("focusin", () => {
                    lastEditor._focusEventsAllowed = true;
                  }, {
                    once: true
                  });
                  lastActiveElement.focus();
                }
                #addKeyboardManager() {
                  window.addEventListener("keydown", this.#boundKeydown, {
                    capture: true
                  });
                }
                #removeKeyboardManager() {
                  window.removeEventListener("keydown", this.#boundKeydown, {
                    capture: true
                  });
                }
                #addCopyPasteListeners() {
                  document.addEventListener("copy", this.#boundCopy);
                  document.addEventListener("cut", this.#boundCut);
                  document.addEventListener("paste", this.#boundPaste);
                }
                #removeCopyPasteListeners() {
                  document.removeEventListener("copy", this.#boundCopy);
                  document.removeEventListener("cut", this.#boundCut);
                  document.removeEventListener("paste", this.#boundPaste);
                }
                addEditListeners() {
                  this.#addKeyboardManager();
                  this.#addCopyPasteListeners();
                }
                removeEditListeners() {
                  this.#removeKeyboardManager();
                  this.#removeCopyPasteListeners();
                }
                copy(event) {
                  event.preventDefault();
                  this.#activeEditor?.commitOrRemove();
                  if (!this.hasSelection) {
                    return;
                  }
                  const editors = [];
                  for (const editor of this.#selectedEditors) {
                    const serialized = editor.serialize(true);
                    if (serialized) {
                      editors.push(serialized);
                    }
                  }
                  if (editors.length === 0) {
                    return;
                  }
                  event.clipboardData.setData("application/pdfjs", JSON.stringify(editors));
                }
                cut(event) {
                  this.copy(event);
                  this.delete();
                }
                paste(event) {
                  event.preventDefault();
                  const {
                    clipboardData
                  } = event;
                  for (const item of clipboardData.items) {
                    for (const editorType of this.#editorTypes) {
                      if (editorType.isHandlingMimeForPasting(item.type)) {
                        editorType.paste(item, this.currentLayer);
                        return;
                      }
                    }
                  }
                  let data2 = clipboardData.getData("application/pdfjs");
                  if (!data2) {
                    return;
                  }
                  try {
                    data2 = JSON.parse(data2);
                  } catch (ex) {
                    (0, _util2.warn)(`paste: "${ex.message}".`);
                    return;
                  }
                  if (!Array.isArray(data2)) {
                    return;
                  }
                  this.unselectAll();
                  const layer = this.currentLayer;
                  try {
                    const newEditors = [];
                    for (const editor of data2) {
                      const deserializedEditor = layer.deserialize(editor);
                      if (!deserializedEditor) {
                        return;
                      }
                      newEditors.push(deserializedEditor);
                    }
                    const cmd = () => {
                      for (const editor of newEditors) {
                        this.#addEditorToLayer(editor);
                      }
                      this.#selectEditors(newEditors);
                    };
                    const undo = () => {
                      for (const editor of newEditors) {
                        editor.remove();
                      }
                    };
                    this.addCommands({
                      cmd,
                      undo,
                      mustExec: true
                    });
                  } catch (ex) {
                    (0, _util2.warn)(`paste: "${ex.message}".`);
                  }
                }
                keydown(event) {
                  if (!this.getActive()?.shouldGetKeyboardEvents()) {
                    AnnotationEditorUIManager._keyboardManager.exec(this, event);
                  }
                }
                onEditingAction(details) {
                  if (["undo", "redo", "delete", "selectAll"].includes(details.name)) {
                    this[details.name]();
                  }
                }
                #dispatchUpdateStates(details) {
                  const hasChanged = Object.entries(details).some(([key2, value]) => this.#previousStates[key2] !== value);
                  if (hasChanged) {
                    this._eventBus.dispatch("annotationeditorstateschanged", {
                      source: this,
                      details: Object.assign(this.#previousStates, details)
                    });
                  }
                }
                #dispatchUpdateUI(details) {
                  this._eventBus.dispatch("annotationeditorparamschanged", {
                    source: this,
                    details
                  });
                }
                setEditingState(isEditing) {
                  if (isEditing) {
                    this.#addFocusManager();
                    this.#addKeyboardManager();
                    this.#addCopyPasteListeners();
                    this.#dispatchUpdateStates({
                      isEditing: this.#mode !== _util2.AnnotationEditorType.NONE,
                      isEmpty: this.#isEmpty(),
                      hasSomethingToUndo: this.#commandManager.hasSomethingToUndo(),
                      hasSomethingToRedo: this.#commandManager.hasSomethingToRedo(),
                      hasSelectedEditor: false
                    });
                  } else {
                    this.#removeFocusManager();
                    this.#removeKeyboardManager();
                    this.#removeCopyPasteListeners();
                    this.#dispatchUpdateStates({
                      isEditing: false
                    });
                    this.disableUserSelect(false);
                  }
                }
                registerEditorTypes(types3) {
                  if (this.#editorTypes) {
                    return;
                  }
                  this.#editorTypes = types3;
                  for (const editorType of this.#editorTypes) {
                    this.#dispatchUpdateUI(editorType.defaultPropertiesToUpdate);
                  }
                }
                getId() {
                  return this.#idManager.getId();
                }
                get currentLayer() {
                  return this.#allLayers.get(this.#currentPageIndex);
                }
                getLayer(pageIndex) {
                  return this.#allLayers.get(pageIndex);
                }
                get currentPageIndex() {
                  return this.#currentPageIndex;
                }
                addLayer(layer) {
                  this.#allLayers.set(layer.pageIndex, layer);
                  if (this.#isEnabled) {
                    layer.enable();
                  } else {
                    layer.disable();
                  }
                }
                removeLayer(layer) {
                  this.#allLayers.delete(layer.pageIndex);
                }
                updateMode(mode, editId = null) {
                  if (this.#mode === mode) {
                    return;
                  }
                  this.#mode = mode;
                  if (mode === _util2.AnnotationEditorType.NONE) {
                    this.setEditingState(false);
                    this.#disableAll();
                    return;
                  }
                  this.setEditingState(true);
                  this.#enableAll();
                  this.unselectAll();
                  for (const layer of this.#allLayers.values()) {
                    layer.updateMode(mode);
                  }
                  if (!editId) {
                    return;
                  }
                  for (const editor of this.#allEditors.values()) {
                    if (editor.annotationElementId === editId) {
                      this.setSelected(editor);
                      editor.enterInEditMode();
                      break;
                    }
                  }
                }
                updateToolbar(mode) {
                  if (mode === this.#mode) {
                    return;
                  }
                  this._eventBus.dispatch("switchannotationeditormode", {
                    source: this,
                    mode
                  });
                }
                updateParams(type5, value) {
                  if (!this.#editorTypes) {
                    return;
                  }
                  if (type5 === _util2.AnnotationEditorParamsType.CREATE) {
                    this.currentLayer.addNewEditor(type5);
                    return;
                  }
                  for (const editor of this.#selectedEditors) {
                    editor.updateParams(type5, value);
                  }
                  for (const editorType of this.#editorTypes) {
                    editorType.updateDefaultParams(type5, value);
                  }
                }
                enableWaiting(mustWait = false) {
                  if (this.#isWaiting === mustWait) {
                    return;
                  }
                  this.#isWaiting = mustWait;
                  for (const layer of this.#allLayers.values()) {
                    if (mustWait) {
                      layer.disableClick();
                    } else {
                      layer.enableClick();
                    }
                    layer.div.classList.toggle("waiting", mustWait);
                  }
                }
                #enableAll() {
                  if (!this.#isEnabled) {
                    this.#isEnabled = true;
                    for (const layer of this.#allLayers.values()) {
                      layer.enable();
                    }
                  }
                }
                #disableAll() {
                  this.unselectAll();
                  if (this.#isEnabled) {
                    this.#isEnabled = false;
                    for (const layer of this.#allLayers.values()) {
                      layer.disable();
                    }
                  }
                }
                getEditors(pageIndex) {
                  const editors = [];
                  for (const editor of this.#allEditors.values()) {
                    if (editor.pageIndex === pageIndex) {
                      editors.push(editor);
                    }
                  }
                  return editors;
                }
                getEditor(id) {
                  return this.#allEditors.get(id);
                }
                addEditor(editor) {
                  this.#allEditors.set(editor.id, editor);
                }
                removeEditor(editor) {
                  this.#allEditors.delete(editor.id);
                  this.unselect(editor);
                  if (!editor.annotationElementId || !this.#deletedAnnotationsElementIds.has(editor.annotationElementId)) {
                    this.#annotationStorage?.remove(editor.id);
                  }
                }
                addDeletedAnnotationElement(editor) {
                  this.#deletedAnnotationsElementIds.add(editor.annotationElementId);
                  editor.deleted = true;
                }
                isDeletedAnnotationElement(annotationElementId) {
                  return this.#deletedAnnotationsElementIds.has(annotationElementId);
                }
                removeDeletedAnnotationElement(editor) {
                  this.#deletedAnnotationsElementIds.delete(editor.annotationElementId);
                  editor.deleted = false;
                }
                #addEditorToLayer(editor) {
                  const layer = this.#allLayers.get(editor.pageIndex);
                  if (layer) {
                    layer.addOrRebuild(editor);
                  } else {
                    this.addEditor(editor);
                  }
                }
                setActiveEditor(editor) {
                  if (this.#activeEditor === editor) {
                    return;
                  }
                  this.#activeEditor = editor;
                  if (editor) {
                    this.#dispatchUpdateUI(editor.propertiesToUpdate);
                  }
                }
                toggleSelected(editor) {
                  if (this.#selectedEditors.has(editor)) {
                    this.#selectedEditors.delete(editor);
                    editor.unselect();
                    this.#dispatchUpdateStates({
                      hasSelectedEditor: this.hasSelection
                    });
                    return;
                  }
                  this.#selectedEditors.add(editor);
                  editor.select();
                  this.#dispatchUpdateUI(editor.propertiesToUpdate);
                  this.#dispatchUpdateStates({
                    hasSelectedEditor: true
                  });
                }
                setSelected(editor) {
                  for (const ed of this.#selectedEditors) {
                    if (ed !== editor) {
                      ed.unselect();
                    }
                  }
                  this.#selectedEditors.clear();
                  this.#selectedEditors.add(editor);
                  editor.select();
                  this.#dispatchUpdateUI(editor.propertiesToUpdate);
                  this.#dispatchUpdateStates({
                    hasSelectedEditor: true
                  });
                }
                isSelected(editor) {
                  return this.#selectedEditors.has(editor);
                }
                unselect(editor) {
                  editor.unselect();
                  this.#selectedEditors.delete(editor);
                  this.#dispatchUpdateStates({
                    hasSelectedEditor: this.hasSelection
                  });
                }
                get hasSelection() {
                  return this.#selectedEditors.size !== 0;
                }
                undo() {
                  this.#commandManager.undo();
                  this.#dispatchUpdateStates({
                    hasSomethingToUndo: this.#commandManager.hasSomethingToUndo(),
                    hasSomethingToRedo: true,
                    isEmpty: this.#isEmpty()
                  });
                }
                redo() {
                  this.#commandManager.redo();
                  this.#dispatchUpdateStates({
                    hasSomethingToUndo: true,
                    hasSomethingToRedo: this.#commandManager.hasSomethingToRedo(),
                    isEmpty: this.#isEmpty()
                  });
                }
                addCommands(params) {
                  this.#commandManager.add(params);
                  this.#dispatchUpdateStates({
                    hasSomethingToUndo: true,
                    hasSomethingToRedo: false,
                    isEmpty: this.#isEmpty()
                  });
                }
                #isEmpty() {
                  if (this.#allEditors.size === 0) {
                    return true;
                  }
                  if (this.#allEditors.size === 1) {
                    for (const editor of this.#allEditors.values()) {
                      return editor.isEmpty();
                    }
                  }
                  return false;
                }
                delete() {
                  this.commitOrRemove();
                  if (!this.hasSelection) {
                    return;
                  }
                  const editors = [...this.#selectedEditors];
                  const cmd = () => {
                    for (const editor of editors) {
                      editor.remove();
                    }
                  };
                  const undo = () => {
                    for (const editor of editors) {
                      this.#addEditorToLayer(editor);
                    }
                  };
                  this.addCommands({
                    cmd,
                    undo,
                    mustExec: true
                  });
                }
                commitOrRemove() {
                  this.#activeEditor?.commitOrRemove();
                }
                hasSomethingToControl() {
                  return this.#activeEditor || this.hasSelection;
                }
                #selectEditors(editors) {
                  this.#selectedEditors.clear();
                  for (const editor of editors) {
                    if (editor.isEmpty()) {
                      continue;
                    }
                    this.#selectedEditors.add(editor);
                    editor.select();
                  }
                  this.#dispatchUpdateStates({
                    hasSelectedEditor: true
                  });
                }
                selectAll() {
                  for (const editor of this.#selectedEditors) {
                    editor.commit();
                  }
                  this.#selectEditors(this.#allEditors.values());
                }
                unselectAll() {
                  if (this.#activeEditor) {
                    this.#activeEditor.commitOrRemove();
                    return;
                  }
                  if (!this.hasSelection) {
                    return;
                  }
                  for (const editor of this.#selectedEditors) {
                    editor.unselect();
                  }
                  this.#selectedEditors.clear();
                  this.#dispatchUpdateStates({
                    hasSelectedEditor: false
                  });
                }
                translateSelectedEditors(x, y, noCommit = false) {
                  if (!noCommit) {
                    this.commitOrRemove();
                  }
                  if (!this.hasSelection) {
                    return;
                  }
                  this.#translation[0] += x;
                  this.#translation[1] += y;
                  const [totalX, totalY] = this.#translation;
                  const editors = [...this.#selectedEditors];
                  const TIME_TO_WAIT = 1e3;
                  if (this.#translationTimeoutId) {
                    clearTimeout(this.#translationTimeoutId);
                  }
                  this.#translationTimeoutId = setTimeout(() => {
                    this.#translationTimeoutId = null;
                    this.#translation[0] = this.#translation[1] = 0;
                    this.addCommands({
                      cmd: () => {
                        for (const editor of editors) {
                          if (this.#allEditors.has(editor.id)) {
                            editor.translateInPage(totalX, totalY);
                          }
                        }
                      },
                      undo: () => {
                        for (const editor of editors) {
                          if (this.#allEditors.has(editor.id)) {
                            editor.translateInPage(-totalX, -totalY);
                          }
                        }
                      },
                      mustExec: false
                    });
                  }, TIME_TO_WAIT);
                  for (const editor of editors) {
                    editor.translateInPage(x, y);
                  }
                }
                setUpDragSession() {
                  if (!this.hasSelection) {
                    return;
                  }
                  this.disableUserSelect(true);
                  this.#draggingEditors = /* @__PURE__ */ new Map();
                  for (const editor of this.#selectedEditors) {
                    this.#draggingEditors.set(editor, {
                      savedX: editor.x,
                      savedY: editor.y,
                      savedPageIndex: editor.pageIndex,
                      newX: 0,
                      newY: 0,
                      newPageIndex: -1
                    });
                  }
                }
                endDragSession() {
                  if (!this.#draggingEditors) {
                    return false;
                  }
                  this.disableUserSelect(false);
                  const map = this.#draggingEditors;
                  this.#draggingEditors = null;
                  let mustBeAddedInUndoStack = false;
                  for (const [{
                    x,
                    y,
                    pageIndex
                  }, value] of map) {
                    value.newX = x;
                    value.newY = y;
                    value.newPageIndex = pageIndex;
                    mustBeAddedInUndoStack ||= x !== value.savedX || y !== value.savedY || pageIndex !== value.savedPageIndex;
                  }
                  if (!mustBeAddedInUndoStack) {
                    return false;
                  }
                  const move2 = (editor, x, y, pageIndex) => {
                    if (this.#allEditors.has(editor.id)) {
                      const parent2 = this.#allLayers.get(pageIndex);
                      if (parent2) {
                        editor._setParentAndPosition(parent2, x, y);
                      } else {
                        editor.pageIndex = pageIndex;
                        editor.x = x;
                        editor.y = y;
                      }
                    }
                  };
                  this.addCommands({
                    cmd: () => {
                      for (const [editor, {
                        newX,
                        newY,
                        newPageIndex
                      }] of map) {
                        move2(editor, newX, newY, newPageIndex);
                      }
                    },
                    undo: () => {
                      for (const [editor, {
                        savedX,
                        savedY,
                        savedPageIndex
                      }] of map) {
                        move2(editor, savedX, savedY, savedPageIndex);
                      }
                    },
                    mustExec: true
                  });
                  return true;
                }
                dragSelectedEditors(tx, ty) {
                  if (!this.#draggingEditors) {
                    return;
                  }
                  for (const editor of this.#draggingEditors.keys()) {
                    editor.drag(tx, ty);
                  }
                }
                rebuild(editor) {
                  if (editor.parent === null) {
                    const parent2 = this.getLayer(editor.pageIndex);
                    if (parent2) {
                      parent2.changeParent(editor);
                      parent2.addOrRebuild(editor);
                    } else {
                      this.addEditor(editor);
                      this.addToAnnotationStorage(editor);
                      editor.rebuild();
                    }
                  } else {
                    editor.parent.addOrRebuild(editor);
                  }
                }
                isActive(editor) {
                  return this.#activeEditor === editor;
                }
                getActive() {
                  return this.#activeEditor;
                }
                getMode() {
                  return this.#mode;
                }
                get imageManager() {
                  return (0, _util2.shadow)(this, "imageManager", new ImageManager());
                }
              }
              exports2.AnnotationEditorUIManager = AnnotationEditorUIManager;
            }),
            /* 6 */
            /***/
            ((__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
              Object.defineProperty(exports2, "__esModule", {
                value: true
              });
              exports2.StatTimer = exports2.RenderingCancelledException = exports2.PixelsPerInch = exports2.PageViewport = exports2.PDFDateString = exports2.DOMStandardFontDataFactory = exports2.DOMSVGFactory = exports2.DOMFilterFactory = exports2.DOMCanvasFactory = exports2.DOMCMapReaderFactory = void 0;
              exports2.deprecated = deprecated;
              exports2.getColorValues = getColorValues;
              exports2.getCurrentTransform = getCurrentTransform;
              exports2.getCurrentTransformInverse = getCurrentTransformInverse;
              exports2.getFilenameFromUrl = getFilenameFromUrl;
              exports2.getPdfFilenameFromUrl = getPdfFilenameFromUrl;
              exports2.getRGB = getRGB;
              exports2.getXfaPageViewport = getXfaPageViewport;
              exports2.isDataScheme = isDataScheme;
              exports2.isPdfFile = isPdfFile;
              exports2.isValidFetchUrl = isValidFetchUrl;
              exports2.loadScript = loadScript;
              exports2.noContextMenu = noContextMenu;
              exports2.setLayerDimensions = setLayerDimensions;
              var _base_factory = __w_pdfjs_require__2(7);
              var _util2 = __w_pdfjs_require__2(1);
              const SVG_NS = "http://www.w3.org/2000/svg";
              class PixelsPerInch {
                static CSS = 96;
                static PDF = 72;
                static PDF_TO_CSS_UNITS = this.CSS / this.PDF;
              }
              exports2.PixelsPerInch = PixelsPerInch;
              class DOMFilterFactory extends _base_factory.BaseFilterFactory {
                #_cache;
                #_defs;
                #docId;
                #document;
                #hcmFilter;
                #hcmKey;
                #hcmUrl;
                #hcmHighlightFilter;
                #hcmHighlightKey;
                #hcmHighlightUrl;
                #id = 0;
                constructor({
                  docId,
                  ownerDocument = globalThis.document
                } = {}) {
                  super();
                  this.#docId = docId;
                  this.#document = ownerDocument;
                }
                get #cache() {
                  return this.#_cache ||= /* @__PURE__ */ new Map();
                }
                get #defs() {
                  if (!this.#_defs) {
                    const div = this.#document.createElement("div");
                    const {
                      style: style2
                    } = div;
                    style2.visibility = "hidden";
                    style2.contain = "strict";
                    style2.width = style2.height = 0;
                    style2.position = "absolute";
                    style2.top = style2.left = 0;
                    style2.zIndex = -1;
                    const svg = this.#document.createElementNS(SVG_NS, "svg");
                    svg.setAttribute("width", 0);
                    svg.setAttribute("height", 0);
                    this.#_defs = this.#document.createElementNS(SVG_NS, "defs");
                    div.append(svg);
                    svg.append(this.#_defs);
                    this.#document.body.append(div);
                  }
                  return this.#_defs;
                }
                addFilter(maps) {
                  if (!maps) {
                    return "none";
                  }
                  let value = this.#cache.get(maps);
                  if (value) {
                    return value;
                  }
                  let tableR, tableG, tableB, key2;
                  if (maps.length === 1) {
                    const mapR = maps[0];
                    const buffer = new Array(256);
                    for (let i = 0; i < 256; i++) {
                      buffer[i] = mapR[i] / 255;
                    }
                    key2 = tableR = tableG = tableB = buffer.join(",");
                  } else {
                    const [mapR, mapG, mapB] = maps;
                    const bufferR = new Array(256);
                    const bufferG = new Array(256);
                    const bufferB = new Array(256);
                    for (let i = 0; i < 256; i++) {
                      bufferR[i] = mapR[i] / 255;
                      bufferG[i] = mapG[i] / 255;
                      bufferB[i] = mapB[i] / 255;
                    }
                    tableR = bufferR.join(",");
                    tableG = bufferG.join(",");
                    tableB = bufferB.join(",");
                    key2 = `${tableR}${tableG}${tableB}`;
                  }
                  value = this.#cache.get(key2);
                  if (value) {
                    this.#cache.set(maps, value);
                    return value;
                  }
                  const id = `g_${this.#docId}_transfer_map_${this.#id++}`;
                  const url2 = `url(#${id})`;
                  this.#cache.set(maps, url2);
                  this.#cache.set(key2, url2);
                  const filter3 = this.#createFilter(id);
                  this.#addTransferMapConversion(tableR, tableG, tableB, filter3);
                  return url2;
                }
                addHCMFilter(fgColor, bgColor) {
                  const key2 = `${fgColor}-${bgColor}`;
                  if (this.#hcmKey === key2) {
                    return this.#hcmUrl;
                  }
                  this.#hcmKey = key2;
                  this.#hcmUrl = "none";
                  this.#hcmFilter?.remove();
                  if (!fgColor || !bgColor) {
                    return this.#hcmUrl;
                  }
                  const fgRGB = this.#getRGB(fgColor);
                  fgColor = _util2.Util.makeHexColor(...fgRGB);
                  const bgRGB = this.#getRGB(bgColor);
                  bgColor = _util2.Util.makeHexColor(...bgRGB);
                  this.#defs.style.color = "";
                  if (fgColor === "#000000" && bgColor === "#ffffff" || fgColor === bgColor) {
                    return this.#hcmUrl;
                  }
                  const map = new Array(256);
                  for (let i = 0; i <= 255; i++) {
                    const x = i / 255;
                    map[i] = x <= 0.03928 ? x / 12.92 : ((x + 0.055) / 1.055) ** 2.4;
                  }
                  const table = map.join(",");
                  const id = `g_${this.#docId}_hcm_filter`;
                  const filter3 = this.#hcmHighlightFilter = this.#createFilter(id);
                  this.#addTransferMapConversion(table, table, table, filter3);
                  this.#addGrayConversion(filter3);
                  const getSteps = (c, n2) => {
                    const start = fgRGB[c] / 255;
                    const end = bgRGB[c] / 255;
                    const arr = new Array(n2 + 1);
                    for (let i = 0; i <= n2; i++) {
                      arr[i] = start + i / n2 * (end - start);
                    }
                    return arr.join(",");
                  };
                  this.#addTransferMapConversion(getSteps(0, 5), getSteps(1, 5), getSteps(2, 5), filter3);
                  this.#hcmUrl = `url(#${id})`;
                  return this.#hcmUrl;
                }
                addHighlightHCMFilter(fgColor, bgColor, newFgColor, newBgColor) {
                  const key2 = `${fgColor}-${bgColor}-${newFgColor}-${newBgColor}`;
                  if (this.#hcmHighlightKey === key2) {
                    return this.#hcmHighlightUrl;
                  }
                  this.#hcmHighlightKey = key2;
                  this.#hcmHighlightUrl = "none";
                  this.#hcmHighlightFilter?.remove();
                  if (!fgColor || !bgColor) {
                    return this.#hcmHighlightUrl;
                  }
                  const [fgRGB, bgRGB] = [fgColor, bgColor].map(this.#getRGB.bind(this));
                  let fgGray = Math.round(0.2126 * fgRGB[0] + 0.7152 * fgRGB[1] + 0.0722 * fgRGB[2]);
                  let bgGray = Math.round(0.2126 * bgRGB[0] + 0.7152 * bgRGB[1] + 0.0722 * bgRGB[2]);
                  let [newFgRGB, newBgRGB] = [newFgColor, newBgColor].map(this.#getRGB.bind(this));
                  if (bgGray < fgGray) {
                    [fgGray, bgGray, newFgRGB, newBgRGB] = [bgGray, fgGray, newBgRGB, newFgRGB];
                  }
                  this.#defs.style.color = "";
                  const getSteps = (fg, bg, n2) => {
                    const arr = new Array(256);
                    const step = (bgGray - fgGray) / n2;
                    const newStart = fg / 255;
                    const newStep = (bg - fg) / (255 * n2);
                    let prev2 = 0;
                    for (let i = 0; i <= n2; i++) {
                      const k = Math.round(fgGray + i * step);
                      const value = newStart + i * newStep;
                      for (let j = prev2; j <= k; j++) {
                        arr[j] = value;
                      }
                      prev2 = k + 1;
                    }
                    for (let i = prev2; i < 256; i++) {
                      arr[i] = arr[prev2 - 1];
                    }
                    return arr.join(",");
                  };
                  const id = `g_${this.#docId}_hcm_highlight_filter`;
                  const filter3 = this.#hcmHighlightFilter = this.#createFilter(id);
                  this.#addGrayConversion(filter3);
                  this.#addTransferMapConversion(getSteps(newFgRGB[0], newBgRGB[0], 5), getSteps(newFgRGB[1], newBgRGB[1], 5), getSteps(newFgRGB[2], newBgRGB[2], 5), filter3);
                  this.#hcmHighlightUrl = `url(#${id})`;
                  return this.#hcmHighlightUrl;
                }
                destroy(keepHCM = false) {
                  if (keepHCM && (this.#hcmUrl || this.#hcmHighlightUrl)) {
                    return;
                  }
                  if (this.#_defs) {
                    this.#_defs.parentNode.parentNode.remove();
                    this.#_defs = null;
                  }
                  if (this.#_cache) {
                    this.#_cache.clear();
                    this.#_cache = null;
                  }
                  this.#id = 0;
                }
                #addGrayConversion(filter3) {
                  const feColorMatrix = this.#document.createElementNS(SVG_NS, "feColorMatrix");
                  feColorMatrix.setAttribute("type", "matrix");
                  feColorMatrix.setAttribute("values", "0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0");
                  filter3.append(feColorMatrix);
                }
                #createFilter(id) {
                  const filter3 = this.#document.createElementNS(SVG_NS, "filter");
                  filter3.setAttribute("color-interpolation-filters", "sRGB");
                  filter3.setAttribute("id", id);
                  this.#defs.append(filter3);
                  return filter3;
                }
                #appendFeFunc(feComponentTransfer, func, table) {
                  const feFunc = this.#document.createElementNS(SVG_NS, func);
                  feFunc.setAttribute("type", "discrete");
                  feFunc.setAttribute("tableValues", table);
                  feComponentTransfer.append(feFunc);
                }
                #addTransferMapConversion(rTable, gTable, bTable, filter3) {
                  const feComponentTransfer = this.#document.createElementNS(SVG_NS, "feComponentTransfer");
                  filter3.append(feComponentTransfer);
                  this.#appendFeFunc(feComponentTransfer, "feFuncR", rTable);
                  this.#appendFeFunc(feComponentTransfer, "feFuncG", gTable);
                  this.#appendFeFunc(feComponentTransfer, "feFuncB", bTable);
                }
                #getRGB(color) {
                  this.#defs.style.color = color;
                  return getRGB(getComputedStyle(this.#defs).getPropertyValue("color"));
                }
              }
              exports2.DOMFilterFactory = DOMFilterFactory;
              class DOMCanvasFactory extends _base_factory.BaseCanvasFactory {
                constructor({
                  ownerDocument = globalThis.document
                } = {}) {
                  super();
                  this._document = ownerDocument;
                }
                _createCanvas(width, height) {
                  const canvas = this._document.createElement("canvas");
                  canvas.width = width;
                  canvas.height = height;
                  return canvas;
                }
              }
              exports2.DOMCanvasFactory = DOMCanvasFactory;
              async function fetchData(url2, asTypedArray = false) {
                if (isValidFetchUrl(url2, document.baseURI)) {
                  const response = await fetch(url2);
                  if (!response.ok) {
                    throw new Error(response.statusText);
                  }
                  return asTypedArray ? new Uint8Array(await response.arrayBuffer()) : (0, _util2.stringToBytes)(await response.text());
                }
                return new Promise((resolve, reject) => {
                  const request = new XMLHttpRequest();
                  request.open("GET", url2, true);
                  if (asTypedArray) {
                    request.responseType = "arraybuffer";
                  }
                  request.onreadystatechange = () => {
                    if (request.readyState !== XMLHttpRequest.DONE) {
                      return;
                    }
                    if (request.status === 200 || request.status === 0) {
                      let data2;
                      if (asTypedArray && request.response) {
                        data2 = new Uint8Array(request.response);
                      } else if (!asTypedArray && request.responseText) {
                        data2 = (0, _util2.stringToBytes)(request.responseText);
                      }
                      if (data2) {
                        resolve(data2);
                        return;
                      }
                    }
                    reject(new Error(request.statusText));
                  };
                  request.send(null);
                });
              }
              class DOMCMapReaderFactory extends _base_factory.BaseCMapReaderFactory {
                _fetchData(url2, compressionType) {
                  return fetchData(url2, this.isCompressed).then((data2) => {
                    return {
                      cMapData: data2,
                      compressionType
                    };
                  });
                }
              }
              exports2.DOMCMapReaderFactory = DOMCMapReaderFactory;
              class DOMStandardFontDataFactory extends _base_factory.BaseStandardFontDataFactory {
                _fetchData(url2) {
                  return fetchData(url2, true);
                }
              }
              exports2.DOMStandardFontDataFactory = DOMStandardFontDataFactory;
              class DOMSVGFactory extends _base_factory.BaseSVGFactory {
                _createSVG(type5) {
                  return document.createElementNS(SVG_NS, type5);
                }
              }
              exports2.DOMSVGFactory = DOMSVGFactory;
              class PageViewport {
                constructor({
                  viewBox,
                  scale,
                  rotation,
                  offsetX = 0,
                  offsetY = 0,
                  dontFlip = false
                }) {
                  this.viewBox = viewBox;
                  this.scale = scale;
                  this.rotation = rotation;
                  this.offsetX = offsetX;
                  this.offsetY = offsetY;
                  const centerX = (viewBox[2] + viewBox[0]) / 2;
                  const centerY = (viewBox[3] + viewBox[1]) / 2;
                  let rotateA, rotateB, rotateC, rotateD;
                  rotation %= 360;
                  if (rotation < 0) {
                    rotation += 360;
                  }
                  switch (rotation) {
                    case 180:
                      rotateA = -1;
                      rotateB = 0;
                      rotateC = 0;
                      rotateD = 1;
                      break;
                    case 90:
                      rotateA = 0;
                      rotateB = 1;
                      rotateC = 1;
                      rotateD = 0;
                      break;
                    case 270:
                      rotateA = 0;
                      rotateB = -1;
                      rotateC = -1;
                      rotateD = 0;
                      break;
                    case 0:
                      rotateA = 1;
                      rotateB = 0;
                      rotateC = 0;
                      rotateD = -1;
                      break;
                    default:
                      throw new Error("PageViewport: Invalid rotation, must be a multiple of 90 degrees.");
                  }
                  if (dontFlip) {
                    rotateC = -rotateC;
                    rotateD = -rotateD;
                  }
                  let offsetCanvasX, offsetCanvasY;
                  let width, height;
                  if (rotateA === 0) {
                    offsetCanvasX = Math.abs(centerY - viewBox[1]) * scale + offsetX;
                    offsetCanvasY = Math.abs(centerX - viewBox[0]) * scale + offsetY;
                    width = (viewBox[3] - viewBox[1]) * scale;
                    height = (viewBox[2] - viewBox[0]) * scale;
                  } else {
                    offsetCanvasX = Math.abs(centerX - viewBox[0]) * scale + offsetX;
                    offsetCanvasY = Math.abs(centerY - viewBox[1]) * scale + offsetY;
                    width = (viewBox[2] - viewBox[0]) * scale;
                    height = (viewBox[3] - viewBox[1]) * scale;
                  }
                  this.transform = [rotateA * scale, rotateB * scale, rotateC * scale, rotateD * scale, offsetCanvasX - rotateA * scale * centerX - rotateC * scale * centerY, offsetCanvasY - rotateB * scale * centerX - rotateD * scale * centerY];
                  this.width = width;
                  this.height = height;
                }
                get rawDims() {
                  const {
                    viewBox
                  } = this;
                  return (0, _util2.shadow)(this, "rawDims", {
                    pageWidth: viewBox[2] - viewBox[0],
                    pageHeight: viewBox[3] - viewBox[1],
                    pageX: viewBox[0],
                    pageY: viewBox[1]
                  });
                }
                clone({
                  scale = this.scale,
                  rotation = this.rotation,
                  offsetX = this.offsetX,
                  offsetY = this.offsetY,
                  dontFlip = false
                } = {}) {
                  return new PageViewport({
                    viewBox: this.viewBox.slice(),
                    scale,
                    rotation,
                    offsetX,
                    offsetY,
                    dontFlip
                  });
                }
                convertToViewportPoint(x, y) {
                  return _util2.Util.applyTransform([x, y], this.transform);
                }
                convertToViewportRectangle(rect) {
                  const topLeft = _util2.Util.applyTransform([rect[0], rect[1]], this.transform);
                  const bottomRight = _util2.Util.applyTransform([rect[2], rect[3]], this.transform);
                  return [topLeft[0], topLeft[1], bottomRight[0], bottomRight[1]];
                }
                convertToPdfPoint(x, y) {
                  return _util2.Util.applyInverseTransform([x, y], this.transform);
                }
              }
              exports2.PageViewport = PageViewport;
              class RenderingCancelledException extends _util2.BaseException {
                constructor(msg, extraDelay = 0) {
                  super(msg, "RenderingCancelledException");
                  this.extraDelay = extraDelay;
                }
              }
              exports2.RenderingCancelledException = RenderingCancelledException;
              function isDataScheme(url2) {
                const ii = url2.length;
                let i = 0;
                while (i < ii && url2[i].trim() === "") {
                  i++;
                }
                return url2.substring(i, i + 5).toLowerCase() === "data:";
              }
              function isPdfFile(filename) {
                return typeof filename === "string" && /\.pdf$/i.test(filename);
              }
              function getFilenameFromUrl(url2, onlyStripPath = false) {
                if (!onlyStripPath) {
                  [url2] = url2.split(/[#?]/, 1);
                }
                return url2.substring(url2.lastIndexOf("/") + 1);
              }
              function getPdfFilenameFromUrl(url2, defaultFilename = "document.pdf") {
                if (typeof url2 !== "string") {
                  return defaultFilename;
                }
                if (isDataScheme(url2)) {
                  (0, _util2.warn)('getPdfFilenameFromUrl: ignore "data:"-URL for performance reasons.');
                  return defaultFilename;
                }
                const reURI = /^(?:(?:[^:]+:)?\/\/[^/]+)?([^?#]*)(\?[^#]*)?(#.*)?$/;
                const reFilename = /[^/?#=]+\.pdf\b(?!.*\.pdf\b)/i;
                const splitURI = reURI.exec(url2);
                let suggestedFilename = reFilename.exec(splitURI[1]) || reFilename.exec(splitURI[2]) || reFilename.exec(splitURI[3]);
                if (suggestedFilename) {
                  suggestedFilename = suggestedFilename[0];
                  if (suggestedFilename.includes("%")) {
                    try {
                      suggestedFilename = reFilename.exec(decodeURIComponent(suggestedFilename))[0];
                    } catch {
                    }
                  }
                }
                return suggestedFilename || defaultFilename;
              }
              class StatTimer {
                started = /* @__PURE__ */ Object.create(null);
                times = [];
                time(name) {
                  if (name in this.started) {
                    (0, _util2.warn)(`Timer is already running for ${name}`);
                  }
                  this.started[name] = Date.now();
                }
                timeEnd(name) {
                  if (!(name in this.started)) {
                    (0, _util2.warn)(`Timer has not been started for ${name}`);
                  }
                  this.times.push({
                    name,
                    start: this.started[name],
                    end: Date.now()
                  });
                  delete this.started[name];
                }
                toString() {
                  const outBuf = [];
                  let longest = 0;
                  for (const {
                    name
                  } of this.times) {
                    longest = Math.max(name.length, longest);
                  }
                  for (const {
                    name,
                    start,
                    end
                  } of this.times) {
                    outBuf.push(`${name.padEnd(longest)} ${end - start}ms
`);
                  }
                  return outBuf.join("");
                }
              }
              exports2.StatTimer = StatTimer;
              function isValidFetchUrl(url2, baseUrl) {
                try {
                  const {
                    protocol
                  } = baseUrl ? new URL(url2, baseUrl) : new URL(url2);
                  return protocol === "http:" || protocol === "https:";
                } catch {
                  return false;
                }
              }
              function noContextMenu(e3) {
                e3.preventDefault();
              }
              function loadScript(src, removeScriptElement = false) {
                return new Promise((resolve, reject) => {
                  const script = document.createElement("script");
                  script.src = src;
                  script.onload = function(evt) {
                    if (removeScriptElement) {
                      script.remove();
                    }
                    resolve(evt);
                  };
                  script.onerror = function() {
                    reject(new Error(`Cannot load script at: ${script.src}`));
                  };
                  (document.head || document.documentElement).append(script);
                });
              }
              function deprecated(details) {
                console.log("Deprecated API usage: " + details);
              }
              let pdfDateStringRegex;
              class PDFDateString {
                static toDateObject(input) {
                  if (!input || typeof input !== "string") {
                    return null;
                  }
                  pdfDateStringRegex ||= new RegExp("^D:(\\d{4})(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?([Z|+|-])?(\\d{2})?'?(\\d{2})?'?");
                  const matches = pdfDateStringRegex.exec(input);
                  if (!matches) {
                    return null;
                  }
                  const year = parseInt(matches[1], 10);
                  let month = parseInt(matches[2], 10);
                  month = month >= 1 && month <= 12 ? month - 1 : 0;
                  let day = parseInt(matches[3], 10);
                  day = day >= 1 && day <= 31 ? day : 1;
                  let hour = parseInt(matches[4], 10);
                  hour = hour >= 0 && hour <= 23 ? hour : 0;
                  let minute = parseInt(matches[5], 10);
                  minute = minute >= 0 && minute <= 59 ? minute : 0;
                  let second = parseInt(matches[6], 10);
                  second = second >= 0 && second <= 59 ? second : 0;
                  const universalTimeRelation = matches[7] || "Z";
                  let offsetHour = parseInt(matches[8], 10);
                  offsetHour = offsetHour >= 0 && offsetHour <= 23 ? offsetHour : 0;
                  let offsetMinute = parseInt(matches[9], 10) || 0;
                  offsetMinute = offsetMinute >= 0 && offsetMinute <= 59 ? offsetMinute : 0;
                  if (universalTimeRelation === "-") {
                    hour += offsetHour;
                    minute += offsetMinute;
                  } else if (universalTimeRelation === "+") {
                    hour -= offsetHour;
                    minute -= offsetMinute;
                  }
                  return new Date(Date.UTC(year, month, day, hour, minute, second));
                }
              }
              exports2.PDFDateString = PDFDateString;
              function getXfaPageViewport(xfaPage, {
                scale = 1,
                rotation = 0
              }) {
                const {
                  width,
                  height
                } = xfaPage.attributes.style;
                const viewBox = [0, 0, parseInt(width), parseInt(height)];
                return new PageViewport({
                  viewBox,
                  scale,
                  rotation
                });
              }
              function getRGB(color) {
                if (color.startsWith("#")) {
                  const colorRGB = parseInt(color.slice(1), 16);
                  return [(colorRGB & 16711680) >> 16, (colorRGB & 65280) >> 8, colorRGB & 255];
                }
                if (color.startsWith("rgb(")) {
                  return color.slice(4, -1).split(",").map((x) => parseInt(x));
                }
                if (color.startsWith("rgba(")) {
                  return color.slice(5, -1).split(",").map((x) => parseInt(x)).slice(0, 3);
                }
                (0, _util2.warn)(`Not a valid color format: "${color}"`);
                return [0, 0, 0];
              }
              function getColorValues(colors) {
                const span = document.createElement("span");
                span.style.visibility = "hidden";
                document.body.append(span);
                for (const name of colors.keys()) {
                  span.style.color = name;
                  const computedColor = window.getComputedStyle(span).color;
                  colors.set(name, getRGB(computedColor));
                }
                span.remove();
              }
              function getCurrentTransform(ctx) {
                const {
                  a,
                  b,
                  c,
                  d,
                  e: e3,
                  f
                } = ctx.getTransform();
                return [a, b, c, d, e3, f];
              }
              function getCurrentTransformInverse(ctx) {
                const {
                  a,
                  b,
                  c,
                  d,
                  e: e3,
                  f
                } = ctx.getTransform().invertSelf();
                return [a, b, c, d, e3, f];
              }
              function setLayerDimensions(div, viewport, mustFlip = false, mustRotate = true) {
                if (viewport instanceof PageViewport) {
                  const {
                    pageWidth,
                    pageHeight
                  } = viewport.rawDims;
                  const {
                    style: style2
                  } = div;
                  const useRound = _util2.FeatureTest.isCSSRoundSupported;
                  const w = `var(--scale-factor) * ${pageWidth}px`, h2 = `var(--scale-factor) * ${pageHeight}px`;
                  const widthStr = useRound ? `round(${w}, 1px)` : `calc(${w})`, heightStr = useRound ? `round(${h2}, 1px)` : `calc(${h2})`;
                  if (!mustFlip || viewport.rotation % 180 === 0) {
                    style2.width = widthStr;
                    style2.height = heightStr;
                  } else {
                    style2.width = heightStr;
                    style2.height = widthStr;
                  }
                }
                if (mustRotate) {
                  div.setAttribute("data-main-rotation", viewport.rotation);
                }
              }
            }),
            /* 7 */
            /***/
            ((__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
              Object.defineProperty(exports2, "__esModule", {
                value: true
              });
              exports2.BaseStandardFontDataFactory = exports2.BaseSVGFactory = exports2.BaseFilterFactory = exports2.BaseCanvasFactory = exports2.BaseCMapReaderFactory = void 0;
              var _util2 = __w_pdfjs_require__2(1);
              class BaseFilterFactory {
                constructor() {
                  if (this.constructor === BaseFilterFactory) {
                    (0, _util2.unreachable)("Cannot initialize BaseFilterFactory.");
                  }
                }
                addFilter(maps) {
                  return "none";
                }
                addHCMFilter(fgColor, bgColor) {
                  return "none";
                }
                addHighlightHCMFilter(fgColor, bgColor, newFgColor, newBgColor) {
                  return "none";
                }
                destroy(keepHCM = false) {
                }
              }
              exports2.BaseFilterFactory = BaseFilterFactory;
              class BaseCanvasFactory {
                constructor() {
                  if (this.constructor === BaseCanvasFactory) {
                    (0, _util2.unreachable)("Cannot initialize BaseCanvasFactory.");
                  }
                }
                create(width, height) {
                  if (width <= 0 || height <= 0) {
                    throw new Error("Invalid canvas size");
                  }
                  const canvas = this._createCanvas(width, height);
                  return {
                    canvas,
                    context: canvas.getContext("2d")
                  };
                }
                reset(canvasAndContext, width, height) {
                  if (!canvasAndContext.canvas) {
                    throw new Error("Canvas is not specified");
                  }
                  if (width <= 0 || height <= 0) {
                    throw new Error("Invalid canvas size");
                  }
                  canvasAndContext.canvas.width = width;
                  canvasAndContext.canvas.height = height;
                }
                destroy(canvasAndContext) {
                  if (!canvasAndContext.canvas) {
                    throw new Error("Canvas is not specified");
                  }
                  canvasAndContext.canvas.width = 0;
                  canvasAndContext.canvas.height = 0;
                  canvasAndContext.canvas = null;
                  canvasAndContext.context = null;
                }
                _createCanvas(width, height) {
                  (0, _util2.unreachable)("Abstract method `_createCanvas` called.");
                }
              }
              exports2.BaseCanvasFactory = BaseCanvasFactory;
              class BaseCMapReaderFactory {
                constructor({
                  baseUrl = null,
                  isCompressed = true
                }) {
                  if (this.constructor === BaseCMapReaderFactory) {
                    (0, _util2.unreachable)("Cannot initialize BaseCMapReaderFactory.");
                  }
                  this.baseUrl = baseUrl;
                  this.isCompressed = isCompressed;
                }
                async fetch({
                  name
                }) {
                  if (!this.baseUrl) {
                    throw new Error('The CMap "baseUrl" parameter must be specified, ensure that the "cMapUrl" and "cMapPacked" API parameters are provided.');
                  }
                  if (!name) {
                    throw new Error("CMap name must be specified.");
                  }
                  const url2 = this.baseUrl + name + (this.isCompressed ? ".bcmap" : "");
                  const compressionType = this.isCompressed ? _util2.CMapCompressionType.BINARY : _util2.CMapCompressionType.NONE;
                  return this._fetchData(url2, compressionType).catch((reason) => {
                    throw new Error(`Unable to load ${this.isCompressed ? "binary " : ""}CMap at: ${url2}`);
                  });
                }
                _fetchData(url2, compressionType) {
                  (0, _util2.unreachable)("Abstract method `_fetchData` called.");
                }
              }
              exports2.BaseCMapReaderFactory = BaseCMapReaderFactory;
              class BaseStandardFontDataFactory {
                constructor({
                  baseUrl = null
                }) {
                  if (this.constructor === BaseStandardFontDataFactory) {
                    (0, _util2.unreachable)("Cannot initialize BaseStandardFontDataFactory.");
                  }
                  this.baseUrl = baseUrl;
                }
                async fetch({
                  filename
                }) {
                  if (!this.baseUrl) {
                    throw new Error('The standard font "baseUrl" parameter must be specified, ensure that the "standardFontDataUrl" API parameter is provided.');
                  }
                  if (!filename) {
                    throw new Error("Font filename must be specified.");
                  }
                  const url2 = `${this.baseUrl}${filename}`;
                  return this._fetchData(url2).catch((reason) => {
                    throw new Error(`Unable to load font data at: ${url2}`);
                  });
                }
                _fetchData(url2) {
                  (0, _util2.unreachable)("Abstract method `_fetchData` called.");
                }
              }
              exports2.BaseStandardFontDataFactory = BaseStandardFontDataFactory;
              class BaseSVGFactory {
                constructor() {
                  if (this.constructor === BaseSVGFactory) {
                    (0, _util2.unreachable)("Cannot initialize BaseSVGFactory.");
                  }
                }
                create(width, height, skipDimensions = false) {
                  if (width <= 0 || height <= 0) {
                    throw new Error("Invalid SVG dimensions");
                  }
                  const svg = this._createSVG("svg:svg");
                  svg.setAttribute("version", "1.1");
                  if (!skipDimensions) {
                    svg.setAttribute("width", `${width}px`);
                    svg.setAttribute("height", `${height}px`);
                  }
                  svg.setAttribute("preserveAspectRatio", "none");
                  svg.setAttribute("viewBox", `0 0 ${width} ${height}`);
                  return svg;
                }
                createElement(type5) {
                  if (typeof type5 !== "string") {
                    throw new Error("Invalid SVG element type");
                  }
                  return this._createSVG(type5);
                }
                _createSVG(type5) {
                  (0, _util2.unreachable)("Abstract method `_createSVG` called.");
                }
              }
              exports2.BaseSVGFactory = BaseSVGFactory;
            }),
            /* 8 */
            /***/
            ((__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
              Object.defineProperty(exports2, "__esModule", {
                value: true
              });
              exports2.MurmurHash3_64 = void 0;
              var _util2 = __w_pdfjs_require__2(1);
              const SEED = 3285377520;
              const MASK_HIGH = 4294901760;
              const MASK_LOW = 65535;
              class MurmurHash3_64 {
                constructor(seed) {
                  this.h1 = seed ? seed & 4294967295 : SEED;
                  this.h2 = seed ? seed & 4294967295 : SEED;
                }
                update(input) {
                  let data2, length2;
                  if (typeof input === "string") {
                    data2 = new Uint8Array(input.length * 2);
                    length2 = 0;
                    for (let i = 0, ii = input.length; i < ii; i++) {
                      const code2 = input.charCodeAt(i);
                      if (code2 <= 255) {
                        data2[length2++] = code2;
                      } else {
                        data2[length2++] = code2 >>> 8;
                        data2[length2++] = code2 & 255;
                      }
                    }
                  } else if ((0, _util2.isArrayBuffer)(input)) {
                    data2 = input.slice();
                    length2 = data2.byteLength;
                  } else {
                    throw new Error("Wrong data format in MurmurHash3_64_update. Input must be a string or array.");
                  }
                  const blockCounts = length2 >> 2;
                  const tailLength = length2 - blockCounts * 4;
                  const dataUint32 = new Uint32Array(data2.buffer, 0, blockCounts);
                  let k1 = 0, k2 = 0;
                  let h1 = this.h1, h2 = this.h2;
                  const C1 = 3432918353, C2 = 461845907;
                  const C1_LOW = C1 & MASK_LOW, C2_LOW = C2 & MASK_LOW;
                  for (let i = 0; i < blockCounts; i++) {
                    if (i & 1) {
                      k1 = dataUint32[i];
                      k1 = k1 * C1 & MASK_HIGH | k1 * C1_LOW & MASK_LOW;
                      k1 = k1 << 15 | k1 >>> 17;
                      k1 = k1 * C2 & MASK_HIGH | k1 * C2_LOW & MASK_LOW;
                      h1 ^= k1;
                      h1 = h1 << 13 | h1 >>> 19;
                      h1 = h1 * 5 + 3864292196;
                    } else {
                      k2 = dataUint32[i];
                      k2 = k2 * C1 & MASK_HIGH | k2 * C1_LOW & MASK_LOW;
                      k2 = k2 << 15 | k2 >>> 17;
                      k2 = k2 * C2 & MASK_HIGH | k2 * C2_LOW & MASK_LOW;
                      h2 ^= k2;
                      h2 = h2 << 13 | h2 >>> 19;
                      h2 = h2 * 5 + 3864292196;
                    }
                  }
                  k1 = 0;
                  switch (tailLength) {
                    case 3:
                      k1 ^= data2[blockCounts * 4 + 2] << 16;
                    case 2:
                      k1 ^= data2[blockCounts * 4 + 1] << 8;
                    case 1:
                      k1 ^= data2[blockCounts * 4];
                      k1 = k1 * C1 & MASK_HIGH | k1 * C1_LOW & MASK_LOW;
                      k1 = k1 << 15 | k1 >>> 17;
                      k1 = k1 * C2 & MASK_HIGH | k1 * C2_LOW & MASK_LOW;
                      if (blockCounts & 1) {
                        h1 ^= k1;
                      } else {
                        h2 ^= k1;
                      }
                  }
                  this.h1 = h1;
                  this.h2 = h2;
                }
                hexdigest() {
                  let h1 = this.h1, h2 = this.h2;
                  h1 ^= h2 >>> 1;
                  h1 = h1 * 3981806797 & MASK_HIGH | h1 * 36045 & MASK_LOW;
                  h2 = h2 * 4283543511 & MASK_HIGH | ((h2 << 16 | h1 >>> 16) * 2950163797 & MASK_HIGH) >>> 16;
                  h1 ^= h2 >>> 1;
                  h1 = h1 * 444984403 & MASK_HIGH | h1 * 60499 & MASK_LOW;
                  h2 = h2 * 3301882366 & MASK_HIGH | ((h2 << 16 | h1 >>> 16) * 3120437893 & MASK_HIGH) >>> 16;
                  h1 ^= h2 >>> 1;
                  return (h1 >>> 0).toString(16).padStart(8, "0") + (h2 >>> 0).toString(16).padStart(8, "0");
                }
              }
              exports2.MurmurHash3_64 = MurmurHash3_64;
            }),
            /* 9 */
            /***/
            ((__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
              Object.defineProperty(exports2, "__esModule", {
                value: true
              });
              exports2.FontLoader = exports2.FontFaceObject = void 0;
              var _util2 = __w_pdfjs_require__2(1);
              class FontLoader {
                #systemFonts = /* @__PURE__ */ new Set();
                constructor({
                  ownerDocument = globalThis.document,
                  styleElement = null
                }) {
                  this._document = ownerDocument;
                  this.nativeFontFaces = /* @__PURE__ */ new Set();
                  this.styleElement = null;
                  this.loadingRequests = [];
                  this.loadTestFontId = 0;
                }
                addNativeFontFace(nativeFontFace) {
                  this.nativeFontFaces.add(nativeFontFace);
                  this._document.fonts.add(nativeFontFace);
                }
                removeNativeFontFace(nativeFontFace) {
                  this.nativeFontFaces.delete(nativeFontFace);
                  this._document.fonts.delete(nativeFontFace);
                }
                insertRule(rule) {
                  if (!this.styleElement) {
                    this.styleElement = this._document.createElement("style");
                    this._document.documentElement.getElementsByTagName("head")[0].append(this.styleElement);
                  }
                  const styleSheet = this.styleElement.sheet;
                  styleSheet.insertRule(rule, styleSheet.cssRules.length);
                }
                clear() {
                  for (const nativeFontFace of this.nativeFontFaces) {
                    this._document.fonts.delete(nativeFontFace);
                  }
                  this.nativeFontFaces.clear();
                  this.#systemFonts.clear();
                  if (this.styleElement) {
                    this.styleElement.remove();
                    this.styleElement = null;
                  }
                }
                async loadSystemFont(info) {
                  if (!info || this.#systemFonts.has(info.loadedName)) {
                    return;
                  }
                  (0, _util2.assert)(!this.disableFontFace, "loadSystemFont shouldn't be called when `disableFontFace` is set.");
                  if (this.isFontLoadingAPISupported) {
                    const {
                      loadedName,
                      src,
                      style: style2
                    } = info;
                    const fontFace = new FontFace(loadedName, src, style2);
                    this.addNativeFontFace(fontFace);
                    try {
                      await fontFace.load();
                      this.#systemFonts.add(loadedName);
                    } catch {
                      (0, _util2.warn)(`Cannot load system font: ${info.baseFontName}, installing it could help to improve PDF rendering.`);
                      this.removeNativeFontFace(fontFace);
                    }
                    return;
                  }
                  (0, _util2.unreachable)("Not implemented: loadSystemFont without the Font Loading API.");
                }
                async bind(font) {
                  if (font.attached || font.missingFile && !font.systemFontInfo) {
                    return;
                  }
                  font.attached = true;
                  if (font.systemFontInfo) {
                    await this.loadSystemFont(font.systemFontInfo);
                    return;
                  }
                  if (this.isFontLoadingAPISupported) {
                    const nativeFontFace = font.createNativeFontFace();
                    if (nativeFontFace) {
                      this.addNativeFontFace(nativeFontFace);
                      try {
                        await nativeFontFace.loaded;
                      } catch (ex) {
                        (0, _util2.warn)(`Failed to load font '${nativeFontFace.family}': '${ex}'.`);
                        font.disableFontFace = true;
                        throw ex;
                      }
                    }
                    return;
                  }
                  const rule = font.createFontFaceRule();
                  if (rule) {
                    this.insertRule(rule);
                    if (this.isSyncFontLoadingSupported) {
                      return;
                    }
                    await new Promise((resolve) => {
                      const request = this._queueLoadingCallback(resolve);
                      this._prepareFontLoadEvent(font, request);
                    });
                  }
                }
                get isFontLoadingAPISupported() {
                  const hasFonts = !!this._document?.fonts;
                  return (0, _util2.shadow)(this, "isFontLoadingAPISupported", hasFonts);
                }
                get isSyncFontLoadingSupported() {
                  let supported = false;
                  if (_util2.isNodeJS) {
                    supported = true;
                  } else if (typeof navigator !== "undefined" && /Mozilla\/5.0.*?rv:\d+.*? Gecko/.test(navigator.userAgent)) {
                    supported = true;
                  }
                  return (0, _util2.shadow)(this, "isSyncFontLoadingSupported", supported);
                }
                _queueLoadingCallback(callback) {
                  function completeRequest() {
                    (0, _util2.assert)(!request.done, "completeRequest() cannot be called twice.");
                    request.done = true;
                    while (loadingRequests.length > 0 && loadingRequests[0].done) {
                      const otherRequest = loadingRequests.shift();
                      setTimeout(otherRequest.callback, 0);
                    }
                  }
                  const {
                    loadingRequests
                  } = this;
                  const request = {
                    done: false,
                    complete: completeRequest,
                    callback
                  };
                  loadingRequests.push(request);
                  return request;
                }
                get _loadTestFont() {
                  const testFont = atob("T1RUTwALAIAAAwAwQ0ZGIDHtZg4AAAOYAAAAgUZGVE1lkzZwAAAEHAAAABxHREVGABQAFQAABDgAAAAeT1MvMlYNYwkAAAEgAAAAYGNtYXABDQLUAAACNAAAAUJoZWFk/xVFDQAAALwAAAA2aGhlYQdkA+oAAAD0AAAAJGhtdHgD6AAAAAAEWAAAAAZtYXhwAAJQAAAAARgAAAAGbmFtZVjmdH4AAAGAAAAAsXBvc3T/hgAzAAADeAAAACAAAQAAAAEAALZRFsRfDzz1AAsD6AAAAADOBOTLAAAAAM4KHDwAAAAAA+gDIQAAAAgAAgAAAAAAAAABAAADIQAAAFoD6AAAAAAD6AABAAAAAAAAAAAAAAAAAAAAAQAAUAAAAgAAAAQD6AH0AAUAAAKKArwAAACMAooCvAAAAeAAMQECAAACAAYJAAAAAAAAAAAAAQAAAAAAAAAAAAAAAFBmRWQAwAAuAC4DIP84AFoDIQAAAAAAAQAAAAAAAAAAACAAIAABAAAADgCuAAEAAAAAAAAAAQAAAAEAAAAAAAEAAQAAAAEAAAAAAAIAAQAAAAEAAAAAAAMAAQAAAAEAAAAAAAQAAQAAAAEAAAAAAAUAAQAAAAEAAAAAAAYAAQAAAAMAAQQJAAAAAgABAAMAAQQJAAEAAgABAAMAAQQJAAIAAgABAAMAAQQJAAMAAgABAAMAAQQJAAQAAgABAAMAAQQJAAUAAgABAAMAAQQJAAYAAgABWABYAAAAAAAAAwAAAAMAAAAcAAEAAAAAADwAAwABAAAAHAAEACAAAAAEAAQAAQAAAC7//wAAAC7////TAAEAAAAAAAABBgAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAAAAAAAD/gwAyAAAAAQAAAAAAAAAAAAAAAAAAAAABAAQEAAEBAQJYAAEBASH4DwD4GwHEAvgcA/gXBIwMAYuL+nz5tQXkD5j3CBLnEQACAQEBIVhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYAAABAQAADwACAQEEE/t3Dov6fAH6fAT+fPp8+nwHDosMCvm1Cvm1DAz6fBQAAAAAAAABAAAAAMmJbzEAAAAAzgTjFQAAAADOBOQpAAEAAAAAAAAADAAUAAQAAAABAAAAAgABAAAAAAAAAAAD6AAAAAAAAA==");
                  return (0, _util2.shadow)(this, "_loadTestFont", testFont);
                }
                _prepareFontLoadEvent(font, request) {
                  function int322(data3, offset4) {
                    return data3.charCodeAt(offset4) << 24 | data3.charCodeAt(offset4 + 1) << 16 | data3.charCodeAt(offset4 + 2) << 8 | data3.charCodeAt(offset4 + 3) & 255;
                  }
                  function spliceString(s, offset4, remove, insert) {
                    const chunk1 = s.substring(0, offset4);
                    const chunk2 = s.substring(offset4 + remove);
                    return chunk1 + insert + chunk2;
                  }
                  let i, ii;
                  const canvas = this._document.createElement("canvas");
                  canvas.width = 1;
                  canvas.height = 1;
                  const ctx = canvas.getContext("2d");
                  let called = 0;
                  function isFontReady(name, callback) {
                    if (++called > 30) {
                      (0, _util2.warn)("Load test font never loaded.");
                      callback();
                      return;
                    }
                    ctx.font = "30px " + name;
                    ctx.fillText(".", 0, 20);
                    const imageData = ctx.getImageData(0, 0, 1, 1);
                    if (imageData.data[3] > 0) {
                      callback();
                      return;
                    }
                    setTimeout(isFontReady.bind(null, name, callback));
                  }
                  const loadTestFontId = `lt${Date.now()}${this.loadTestFontId++}`;
                  let data2 = this._loadTestFont;
                  const COMMENT_OFFSET = 976;
                  data2 = spliceString(data2, COMMENT_OFFSET, loadTestFontId.length, loadTestFontId);
                  const CFF_CHECKSUM_OFFSET = 16;
                  const XXXX_VALUE = 1482184792;
                  let checksum = int322(data2, CFF_CHECKSUM_OFFSET);
                  for (i = 0, ii = loadTestFontId.length - 3; i < ii; i += 4) {
                    checksum = checksum - XXXX_VALUE + int322(loadTestFontId, i) | 0;
                  }
                  if (i < loadTestFontId.length) {
                    checksum = checksum - XXXX_VALUE + int322(loadTestFontId + "XXX", i) | 0;
                  }
                  data2 = spliceString(data2, CFF_CHECKSUM_OFFSET, 4, (0, _util2.string32)(checksum));
                  const url2 = `url(data:font/opentype;base64,${btoa(data2)});`;
                  const rule = `@font-face {font-family:"${loadTestFontId}";src:${url2}}`;
                  this.insertRule(rule);
                  const div = this._document.createElement("div");
                  div.style.visibility = "hidden";
                  div.style.width = div.style.height = "10px";
                  div.style.position = "absolute";
                  div.style.top = div.style.left = "0px";
                  for (const name of [font.loadedName, loadTestFontId]) {
                    const span = this._document.createElement("span");
                    span.textContent = "Hi";
                    span.style.fontFamily = name;
                    div.append(span);
                  }
                  this._document.body.append(div);
                  isFontReady(loadTestFontId, () => {
                    div.remove();
                    request.complete();
                  });
                }
              }
              exports2.FontLoader = FontLoader;
              class FontFaceObject {
                constructor(translatedData, {
                  isEvalSupported = true,
                  disableFontFace = false,
                  ignoreErrors = false,
                  inspectFont = null
                }) {
                  this.compiledGlyphs = /* @__PURE__ */ Object.create(null);
                  for (const i in translatedData) {
                    this[i] = translatedData[i];
                  }
                  this.isEvalSupported = isEvalSupported !== false;
                  this.disableFontFace = disableFontFace === true;
                  this.ignoreErrors = ignoreErrors === true;
                  this._inspectFont = inspectFont;
                }
                createNativeFontFace() {
                  if (!this.data || this.disableFontFace) {
                    return null;
                  }
                  let nativeFontFace;
                  if (!this.cssFontInfo) {
                    nativeFontFace = new FontFace(this.loadedName, this.data, {});
                  } else {
                    const css2 = {
                      weight: this.cssFontInfo.fontWeight
                    };
                    if (this.cssFontInfo.italicAngle) {
                      css2.style = `oblique ${this.cssFontInfo.italicAngle}deg`;
                    }
                    nativeFontFace = new FontFace(this.cssFontInfo.fontFamily, this.data, css2);
                  }
                  this._inspectFont?.(this);
                  return nativeFontFace;
                }
                createFontFaceRule() {
                  if (!this.data || this.disableFontFace) {
                    return null;
                  }
                  const data2 = (0, _util2.bytesToString)(this.data);
                  const url2 = `url(data:${this.mimetype};base64,${btoa(data2)});`;
                  let rule;
                  if (!this.cssFontInfo) {
                    rule = `@font-face {font-family:"${this.loadedName}";src:${url2}}`;
                  } else {
                    let css2 = `font-weight: ${this.cssFontInfo.fontWeight};`;
                    if (this.cssFontInfo.italicAngle) {
                      css2 += `font-style: oblique ${this.cssFontInfo.italicAngle}deg;`;
                    }
                    rule = `@font-face {font-family:"${this.cssFontInfo.fontFamily}";${css2}src:${url2}}`;
                  }
                  this._inspectFont?.(this, url2);
                  return rule;
                }
                getPathGenerator(objs, character2) {
                  if (this.compiledGlyphs[character2] !== void 0) {
                    return this.compiledGlyphs[character2];
                  }
                  let cmds;
                  try {
                    cmds = objs.get(this.loadedName + "_path_" + character2);
                  } catch (ex) {
                    if (!this.ignoreErrors) {
                      throw ex;
                    }
                    (0, _util2.warn)(`getPathGenerator - ignoring character: "${ex}".`);
                    return this.compiledGlyphs[character2] = function(c, size) {
                    };
                  }
                  if (this.isEvalSupported && _util2.FeatureTest.isEvalSupported) {
                    const jsBuf = [];
                    for (const current2 of cmds) {
                      const args = current2.args !== void 0 ? current2.args.join(",") : "";
                      jsBuf.push("c.", current2.cmd, "(", args, ");\n");
                    }
                    return this.compiledGlyphs[character2] = new Function("c", "size", jsBuf.join(""));
                  }
                  return this.compiledGlyphs[character2] = function(c, size) {
                    for (const current2 of cmds) {
                      if (current2.cmd === "scale") {
                        current2.args = [size, -size];
                      }
                      c[current2.cmd].apply(c, current2.args);
                    }
                  };
                }
              }
              exports2.FontFaceObject = FontFaceObject;
            }),
            /* 10 */
            /***/
            ((__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
              Object.defineProperty(exports2, "__esModule", {
                value: true
              });
              exports2.NodeStandardFontDataFactory = exports2.NodeFilterFactory = exports2.NodeCanvasFactory = exports2.NodeCMapReaderFactory = void 0;
              var _base_factory = __w_pdfjs_require__2(7);
              var _util2 = __w_pdfjs_require__2(1);
              ;
              ;
              const fetchData = function(url2) {
                return new Promise((resolve, reject) => {
                  const fs = require_fs();
                  fs.readFile(url2, (error2, data2) => {
                    if (error2 || !data2) {
                      reject(new Error(error2));
                      return;
                    }
                    resolve(new Uint8Array(data2));
                  });
                });
              };
              class NodeFilterFactory extends _base_factory.BaseFilterFactory {
              }
              exports2.NodeFilterFactory = NodeFilterFactory;
              class NodeCanvasFactory extends _base_factory.BaseCanvasFactory {
                _createCanvas(width, height) {
                  const Canvas2 = require_browser();
                  return Canvas2.createCanvas(width, height);
                }
              }
              exports2.NodeCanvasFactory = NodeCanvasFactory;
              class NodeCMapReaderFactory extends _base_factory.BaseCMapReaderFactory {
                _fetchData(url2, compressionType) {
                  return fetchData(url2).then((data2) => {
                    return {
                      cMapData: data2,
                      compressionType
                    };
                  });
                }
              }
              exports2.NodeCMapReaderFactory = NodeCMapReaderFactory;
              class NodeStandardFontDataFactory extends _base_factory.BaseStandardFontDataFactory {
                _fetchData(url2) {
                  return fetchData(url2);
                }
              }
              exports2.NodeStandardFontDataFactory = NodeStandardFontDataFactory;
            }),
            /* 11 */
            /***/
            ((__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
              Object.defineProperty(exports2, "__esModule", {
                value: true
              });
              exports2.CanvasGraphics = void 0;
              var _util2 = __w_pdfjs_require__2(1);
              var _display_utils2 = __w_pdfjs_require__2(6);
              var _pattern_helper = __w_pdfjs_require__2(12);
              var _image_utils = __w_pdfjs_require__2(13);
              const MIN_FONT_SIZE = 16;
              const MAX_FONT_SIZE = 100;
              const MAX_GROUP_SIZE = 4096;
              const EXECUTION_TIME = 15;
              const EXECUTION_STEPS = 10;
              const MAX_SIZE_TO_COMPILE = 1e3;
              const FULL_CHUNK_HEIGHT = 16;
              function mirrorContextOperations(ctx, destCtx) {
                if (ctx._removeMirroring) {
                  throw new Error("Context is already forwarding operations.");
                }
                ctx.__originalSave = ctx.save;
                ctx.__originalRestore = ctx.restore;
                ctx.__originalRotate = ctx.rotate;
                ctx.__originalScale = ctx.scale;
                ctx.__originalTranslate = ctx.translate;
                ctx.__originalTransform = ctx.transform;
                ctx.__originalSetTransform = ctx.setTransform;
                ctx.__originalResetTransform = ctx.resetTransform;
                ctx.__originalClip = ctx.clip;
                ctx.__originalMoveTo = ctx.moveTo;
                ctx.__originalLineTo = ctx.lineTo;
                ctx.__originalBezierCurveTo = ctx.bezierCurveTo;
                ctx.__originalRect = ctx.rect;
                ctx.__originalClosePath = ctx.closePath;
                ctx.__originalBeginPath = ctx.beginPath;
                ctx._removeMirroring = () => {
                  ctx.save = ctx.__originalSave;
                  ctx.restore = ctx.__originalRestore;
                  ctx.rotate = ctx.__originalRotate;
                  ctx.scale = ctx.__originalScale;
                  ctx.translate = ctx.__originalTranslate;
                  ctx.transform = ctx.__originalTransform;
                  ctx.setTransform = ctx.__originalSetTransform;
                  ctx.resetTransform = ctx.__originalResetTransform;
                  ctx.clip = ctx.__originalClip;
                  ctx.moveTo = ctx.__originalMoveTo;
                  ctx.lineTo = ctx.__originalLineTo;
                  ctx.bezierCurveTo = ctx.__originalBezierCurveTo;
                  ctx.rect = ctx.__originalRect;
                  ctx.closePath = ctx.__originalClosePath;
                  ctx.beginPath = ctx.__originalBeginPath;
                  delete ctx._removeMirroring;
                };
                ctx.save = function ctxSave() {
                  destCtx.save();
                  this.__originalSave();
                };
                ctx.restore = function ctxRestore() {
                  destCtx.restore();
                  this.__originalRestore();
                };
                ctx.translate = function ctxTranslate(x, y) {
                  destCtx.translate(x, y);
                  this.__originalTranslate(x, y);
                };
                ctx.scale = function ctxScale(x, y) {
                  destCtx.scale(x, y);
                  this.__originalScale(x, y);
                };
                ctx.transform = function ctxTransform(a, b, c, d, e3, f) {
                  destCtx.transform(a, b, c, d, e3, f);
                  this.__originalTransform(a, b, c, d, e3, f);
                };
                ctx.setTransform = function ctxSetTransform(a, b, c, d, e3, f) {
                  destCtx.setTransform(a, b, c, d, e3, f);
                  this.__originalSetTransform(a, b, c, d, e3, f);
                };
                ctx.resetTransform = function ctxResetTransform() {
                  destCtx.resetTransform();
                  this.__originalResetTransform();
                };
                ctx.rotate = function ctxRotate(angle) {
                  destCtx.rotate(angle);
                  this.__originalRotate(angle);
                };
                ctx.clip = function ctxRotate(rule) {
                  destCtx.clip(rule);
                  this.__originalClip(rule);
                };
                ctx.moveTo = function(x, y) {
                  destCtx.moveTo(x, y);
                  this.__originalMoveTo(x, y);
                };
                ctx.lineTo = function(x, y) {
                  destCtx.lineTo(x, y);
                  this.__originalLineTo(x, y);
                };
                ctx.bezierCurveTo = function(cp1x, cp1y, cp2x, cp2y, x, y) {
                  destCtx.bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y);
                  this.__originalBezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y);
                };
                ctx.rect = function(x, y, width, height) {
                  destCtx.rect(x, y, width, height);
                  this.__originalRect(x, y, width, height);
                };
                ctx.closePath = function() {
                  destCtx.closePath();
                  this.__originalClosePath();
                };
                ctx.beginPath = function() {
                  destCtx.beginPath();
                  this.__originalBeginPath();
                };
              }
              class CachedCanvases {
                constructor(canvasFactory) {
                  this.canvasFactory = canvasFactory;
                  this.cache = /* @__PURE__ */ Object.create(null);
                }
                getCanvas(id, width, height) {
                  let canvasEntry;
                  if (this.cache[id] !== void 0) {
                    canvasEntry = this.cache[id];
                    this.canvasFactory.reset(canvasEntry, width, height);
                  } else {
                    canvasEntry = this.canvasFactory.create(width, height);
                    this.cache[id] = canvasEntry;
                  }
                  return canvasEntry;
                }
                delete(id) {
                  delete this.cache[id];
                }
                clear() {
                  for (const id in this.cache) {
                    const canvasEntry = this.cache[id];
                    this.canvasFactory.destroy(canvasEntry);
                    delete this.cache[id];
                  }
                }
              }
              function drawImageAtIntegerCoords(ctx, srcImg, srcX, srcY, srcW, srcH, destX, destY, destW, destH) {
                const [a, b, c, d, tx, ty] = (0, _display_utils2.getCurrentTransform)(ctx);
                if (b === 0 && c === 0) {
                  const tlX = destX * a + tx;
                  const rTlX = Math.round(tlX);
                  const tlY = destY * d + ty;
                  const rTlY = Math.round(tlY);
                  const brX = (destX + destW) * a + tx;
                  const rWidth = Math.abs(Math.round(brX) - rTlX) || 1;
                  const brY = (destY + destH) * d + ty;
                  const rHeight = Math.abs(Math.round(brY) - rTlY) || 1;
                  ctx.setTransform(Math.sign(a), 0, 0, Math.sign(d), rTlX, rTlY);
                  ctx.drawImage(srcImg, srcX, srcY, srcW, srcH, 0, 0, rWidth, rHeight);
                  ctx.setTransform(a, b, c, d, tx, ty);
                  return [rWidth, rHeight];
                }
                if (a === 0 && d === 0) {
                  const tlX = destY * c + tx;
                  const rTlX = Math.round(tlX);
                  const tlY = destX * b + ty;
                  const rTlY = Math.round(tlY);
                  const brX = (destY + destH) * c + tx;
                  const rWidth = Math.abs(Math.round(brX) - rTlX) || 1;
                  const brY = (destX + destW) * b + ty;
                  const rHeight = Math.abs(Math.round(brY) - rTlY) || 1;
                  ctx.setTransform(0, Math.sign(b), Math.sign(c), 0, rTlX, rTlY);
                  ctx.drawImage(srcImg, srcX, srcY, srcW, srcH, 0, 0, rHeight, rWidth);
                  ctx.setTransform(a, b, c, d, tx, ty);
                  return [rHeight, rWidth];
                }
                ctx.drawImage(srcImg, srcX, srcY, srcW, srcH, destX, destY, destW, destH);
                const scaleX = Math.hypot(a, b);
                const scaleY = Math.hypot(c, d);
                return [scaleX * destW, scaleY * destH];
              }
              function compileType3Glyph(imgData) {
                const {
                  width,
                  height
                } = imgData;
                if (width > MAX_SIZE_TO_COMPILE || height > MAX_SIZE_TO_COMPILE) {
                  return null;
                }
                const POINT_TO_PROCESS_LIMIT = 1e3;
                const POINT_TYPES = new Uint8Array([0, 2, 4, 0, 1, 0, 5, 4, 8, 10, 0, 8, 0, 2, 1, 0]);
                const width1 = width + 1;
                let points = new Uint8Array(width1 * (height + 1));
                let i, j, j0;
                const lineSize = width + 7 & ~7;
                let data2 = new Uint8Array(lineSize * height), pos = 0;
                for (const elem of imgData.data) {
                  let mask = 128;
                  while (mask > 0) {
                    data2[pos++] = elem & mask ? 0 : 255;
                    mask >>= 1;
                  }
                }
                let count = 0;
                pos = 0;
                if (data2[pos] !== 0) {
                  points[0] = 1;
                  ++count;
                }
                for (j = 1; j < width; j++) {
                  if (data2[pos] !== data2[pos + 1]) {
                    points[j] = data2[pos] ? 2 : 1;
                    ++count;
                  }
                  pos++;
                }
                if (data2[pos] !== 0) {
                  points[j] = 2;
                  ++count;
                }
                for (i = 1; i < height; i++) {
                  pos = i * lineSize;
                  j0 = i * width1;
                  if (data2[pos - lineSize] !== data2[pos]) {
                    points[j0] = data2[pos] ? 1 : 8;
                    ++count;
                  }
                  let sum2 = (data2[pos] ? 4 : 0) + (data2[pos - lineSize] ? 8 : 0);
                  for (j = 1; j < width; j++) {
                    sum2 = (sum2 >> 2) + (data2[pos + 1] ? 4 : 0) + (data2[pos - lineSize + 1] ? 8 : 0);
                    if (POINT_TYPES[sum2]) {
                      points[j0 + j] = POINT_TYPES[sum2];
                      ++count;
                    }
                    pos++;
                  }
                  if (data2[pos - lineSize] !== data2[pos]) {
                    points[j0 + j] = data2[pos] ? 2 : 4;
                    ++count;
                  }
                  if (count > POINT_TO_PROCESS_LIMIT) {
                    return null;
                  }
                }
                pos = lineSize * (height - 1);
                j0 = i * width1;
                if (data2[pos] !== 0) {
                  points[j0] = 8;
                  ++count;
                }
                for (j = 1; j < width; j++) {
                  if (data2[pos] !== data2[pos + 1]) {
                    points[j0 + j] = data2[pos] ? 4 : 8;
                    ++count;
                  }
                  pos++;
                }
                if (data2[pos] !== 0) {
                  points[j0 + j] = 4;
                  ++count;
                }
                if (count > POINT_TO_PROCESS_LIMIT) {
                  return null;
                }
                const steps = new Int32Array([0, width1, -1, 0, -width1, 0, 0, 0, 1]);
                const path2 = new Path2D();
                for (i = 0; count && i <= height; i++) {
                  let p = i * width1;
                  const end = p + width;
                  while (p < end && !points[p]) {
                    p++;
                  }
                  if (p === end) {
                    continue;
                  }
                  path2.moveTo(p % width1, i);
                  const p0 = p;
                  let type5 = points[p];
                  do {
                    const step = steps[type5];
                    do {
                      p += step;
                    } while (!points[p]);
                    const pp2 = points[p];
                    if (pp2 !== 5 && pp2 !== 10) {
                      type5 = pp2;
                      points[p] = 0;
                    } else {
                      type5 = pp2 & 51 * type5 >> 4;
                      points[p] &= type5 >> 2 | type5 << 2;
                    }
                    path2.lineTo(p % width1, p / width1 | 0);
                    if (!points[p]) {
                      --count;
                    }
                  } while (p0 !== p);
                  --i;
                }
                data2 = null;
                points = null;
                const drawOutline = function(c) {
                  c.save();
                  c.scale(1 / width, -1 / height);
                  c.translate(0, -height);
                  c.fill(path2);
                  c.beginPath();
                  c.restore();
                };
                return drawOutline;
              }
              class CanvasExtraState {
                constructor(width, height) {
                  this.alphaIsShape = false;
                  this.fontSize = 0;
                  this.fontSizeScale = 1;
                  this.textMatrix = _util2.IDENTITY_MATRIX;
                  this.textMatrixScale = 1;
                  this.fontMatrix = _util2.FONT_IDENTITY_MATRIX;
                  this.leading = 0;
                  this.x = 0;
                  this.y = 0;
                  this.lineX = 0;
                  this.lineY = 0;
                  this.charSpacing = 0;
                  this.wordSpacing = 0;
                  this.textHScale = 1;
                  this.textRenderingMode = _util2.TextRenderingMode.FILL;
                  this.textRise = 0;
                  this.fillColor = "#000000";
                  this.strokeColor = "#000000";
                  this.patternFill = false;
                  this.fillAlpha = 1;
                  this.strokeAlpha = 1;
                  this.lineWidth = 1;
                  this.activeSMask = null;
                  this.transferMaps = "none";
                  this.startNewPathAndClipBox([0, 0, width, height]);
                }
                clone() {
                  const clone = Object.create(this);
                  clone.clipBox = this.clipBox.slice();
                  return clone;
                }
                setCurrentPoint(x, y) {
                  this.x = x;
                  this.y = y;
                }
                updatePathMinMax(transform, x, y) {
                  [x, y] = _util2.Util.applyTransform([x, y], transform);
                  this.minX = Math.min(this.minX, x);
                  this.minY = Math.min(this.minY, y);
                  this.maxX = Math.max(this.maxX, x);
                  this.maxY = Math.max(this.maxY, y);
                }
                updateRectMinMax(transform, rect) {
                  const p1 = _util2.Util.applyTransform(rect, transform);
                  const p2 = _util2.Util.applyTransform(rect.slice(2), transform);
                  this.minX = Math.min(this.minX, p1[0], p2[0]);
                  this.minY = Math.min(this.minY, p1[1], p2[1]);
                  this.maxX = Math.max(this.maxX, p1[0], p2[0]);
                  this.maxY = Math.max(this.maxY, p1[1], p2[1]);
                }
                updateScalingPathMinMax(transform, minMax) {
                  _util2.Util.scaleMinMax(transform, minMax);
                  this.minX = Math.min(this.minX, minMax[0]);
                  this.maxX = Math.max(this.maxX, minMax[1]);
                  this.minY = Math.min(this.minY, minMax[2]);
                  this.maxY = Math.max(this.maxY, minMax[3]);
                }
                updateCurvePathMinMax(transform, x0, y0, x1, y1, x2, y2, x3, y3, minMax) {
                  const box2 = _util2.Util.bezierBoundingBox(x0, y0, x1, y1, x2, y2, x3, y3);
                  if (minMax) {
                    minMax[0] = Math.min(minMax[0], box2[0], box2[2]);
                    minMax[1] = Math.max(minMax[1], box2[0], box2[2]);
                    minMax[2] = Math.min(minMax[2], box2[1], box2[3]);
                    minMax[3] = Math.max(minMax[3], box2[1], box2[3]);
                    return;
                  }
                  this.updateRectMinMax(transform, box2);
                }
                getPathBoundingBox(pathType = _pattern_helper.PathType.FILL, transform = null) {
                  const box2 = [this.minX, this.minY, this.maxX, this.maxY];
                  if (pathType === _pattern_helper.PathType.STROKE) {
                    if (!transform) {
                      (0, _util2.unreachable)("Stroke bounding box must include transform.");
                    }
                    const scale = _util2.Util.singularValueDecompose2dScale(transform);
                    const xStrokePad = scale[0] * this.lineWidth / 2;
                    const yStrokePad = scale[1] * this.lineWidth / 2;
                    box2[0] -= xStrokePad;
                    box2[1] -= yStrokePad;
                    box2[2] += xStrokePad;
                    box2[3] += yStrokePad;
                  }
                  return box2;
                }
                updateClipFromPath() {
                  const intersect = _util2.Util.intersect(this.clipBox, this.getPathBoundingBox());
                  this.startNewPathAndClipBox(intersect || [0, 0, 0, 0]);
                }
                isEmptyClip() {
                  return this.minX === Infinity;
                }
                startNewPathAndClipBox(box2) {
                  this.clipBox = box2;
                  this.minX = Infinity;
                  this.minY = Infinity;
                  this.maxX = 0;
                  this.maxY = 0;
                }
                getClippedPathBoundingBox(pathType = _pattern_helper.PathType.FILL, transform = null) {
                  return _util2.Util.intersect(this.clipBox, this.getPathBoundingBox(pathType, transform));
                }
              }
              function putBinaryImageData(ctx, imgData) {
                if (typeof ImageData !== "undefined" && imgData instanceof ImageData) {
                  ctx.putImageData(imgData, 0, 0);
                  return;
                }
                const height = imgData.height, width = imgData.width;
                const partialChunkHeight = height % FULL_CHUNK_HEIGHT;
                const fullChunks = (height - partialChunkHeight) / FULL_CHUNK_HEIGHT;
                const totalChunks = partialChunkHeight === 0 ? fullChunks : fullChunks + 1;
                const chunkImgData = ctx.createImageData(width, FULL_CHUNK_HEIGHT);
                let srcPos = 0, destPos;
                const src = imgData.data;
                const dest = chunkImgData.data;
                let i, j, thisChunkHeight, elemsInThisChunk;
                if (imgData.kind === _util2.ImageKind.GRAYSCALE_1BPP) {
                  const srcLength = src.byteLength;
                  const dest32 = new Uint32Array(dest.buffer, 0, dest.byteLength >> 2);
                  const dest32DataLength = dest32.length;
                  const fullSrcDiff = width + 7 >> 3;
                  const white = 4294967295;
                  const black = _util2.FeatureTest.isLittleEndian ? 4278190080 : 255;
                  for (i = 0; i < totalChunks; i++) {
                    thisChunkHeight = i < fullChunks ? FULL_CHUNK_HEIGHT : partialChunkHeight;
                    destPos = 0;
                    for (j = 0; j < thisChunkHeight; j++) {
                      const srcDiff = srcLength - srcPos;
                      let k = 0;
                      const kEnd = srcDiff > fullSrcDiff ? width : srcDiff * 8 - 7;
                      const kEndUnrolled = kEnd & ~7;
                      let mask = 0;
                      let srcByte = 0;
                      for (; k < kEndUnrolled; k += 8) {
                        srcByte = src[srcPos++];
                        dest32[destPos++] = srcByte & 128 ? white : black;
                        dest32[destPos++] = srcByte & 64 ? white : black;
                        dest32[destPos++] = srcByte & 32 ? white : black;
                        dest32[destPos++] = srcByte & 16 ? white : black;
                        dest32[destPos++] = srcByte & 8 ? white : black;
                        dest32[destPos++] = srcByte & 4 ? white : black;
                        dest32[destPos++] = srcByte & 2 ? white : black;
                        dest32[destPos++] = srcByte & 1 ? white : black;
                      }
                      for (; k < kEnd; k++) {
                        if (mask === 0) {
                          srcByte = src[srcPos++];
                          mask = 128;
                        }
                        dest32[destPos++] = srcByte & mask ? white : black;
                        mask >>= 1;
                      }
                    }
                    while (destPos < dest32DataLength) {
                      dest32[destPos++] = 0;
                    }
                    ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
                  }
                } else if (imgData.kind === _util2.ImageKind.RGBA_32BPP) {
                  j = 0;
                  elemsInThisChunk = width * FULL_CHUNK_HEIGHT * 4;
                  for (i = 0; i < fullChunks; i++) {
                    dest.set(src.subarray(srcPos, srcPos + elemsInThisChunk));
                    srcPos += elemsInThisChunk;
                    ctx.putImageData(chunkImgData, 0, j);
                    j += FULL_CHUNK_HEIGHT;
                  }
                  if (i < totalChunks) {
                    elemsInThisChunk = width * partialChunkHeight * 4;
                    dest.set(src.subarray(srcPos, srcPos + elemsInThisChunk));
                    ctx.putImageData(chunkImgData, 0, j);
                  }
                } else if (imgData.kind === _util2.ImageKind.RGB_24BPP) {
                  thisChunkHeight = FULL_CHUNK_HEIGHT;
                  elemsInThisChunk = width * thisChunkHeight;
                  for (i = 0; i < totalChunks; i++) {
                    if (i >= fullChunks) {
                      thisChunkHeight = partialChunkHeight;
                      elemsInThisChunk = width * thisChunkHeight;
                    }
                    destPos = 0;
                    for (j = elemsInThisChunk; j--; ) {
                      dest[destPos++] = src[srcPos++];
                      dest[destPos++] = src[srcPos++];
                      dest[destPos++] = src[srcPos++];
                      dest[destPos++] = 255;
                    }
                    ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
                  }
                } else {
                  throw new Error(`bad image kind: ${imgData.kind}`);
                }
              }
              function putBinaryImageMask(ctx, imgData) {
                if (imgData.bitmap) {
                  ctx.drawImage(imgData.bitmap, 0, 0);
                  return;
                }
                const height = imgData.height, width = imgData.width;
                const partialChunkHeight = height % FULL_CHUNK_HEIGHT;
                const fullChunks = (height - partialChunkHeight) / FULL_CHUNK_HEIGHT;
                const totalChunks = partialChunkHeight === 0 ? fullChunks : fullChunks + 1;
                const chunkImgData = ctx.createImageData(width, FULL_CHUNK_HEIGHT);
                let srcPos = 0;
                const src = imgData.data;
                const dest = chunkImgData.data;
                for (let i = 0; i < totalChunks; i++) {
                  const thisChunkHeight = i < fullChunks ? FULL_CHUNK_HEIGHT : partialChunkHeight;
                  ({
                    srcPos
                  } = (0, _image_utils.convertBlackAndWhiteToRGBA)({
                    src,
                    srcPos,
                    dest,
                    width,
                    height: thisChunkHeight,
                    nonBlackColor: 0
                  }));
                  ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
                }
              }
              function copyCtxState(sourceCtx, destCtx) {
                const properties2 = ["strokeStyle", "fillStyle", "fillRule", "globalAlpha", "lineWidth", "lineCap", "lineJoin", "miterLimit", "globalCompositeOperation", "font", "filter"];
                for (const property2 of properties2) {
                  if (sourceCtx[property2] !== void 0) {
                    destCtx[property2] = sourceCtx[property2];
                  }
                }
                if (sourceCtx.setLineDash !== void 0) {
                  destCtx.setLineDash(sourceCtx.getLineDash());
                  destCtx.lineDashOffset = sourceCtx.lineDashOffset;
                }
              }
              function resetCtxToDefault(ctx) {
                ctx.strokeStyle = ctx.fillStyle = "#000000";
                ctx.fillRule = "nonzero";
                ctx.globalAlpha = 1;
                ctx.lineWidth = 1;
                ctx.lineCap = "butt";
                ctx.lineJoin = "miter";
                ctx.miterLimit = 10;
                ctx.globalCompositeOperation = "source-over";
                ctx.font = "10px sans-serif";
                if (ctx.setLineDash !== void 0) {
                  ctx.setLineDash([]);
                  ctx.lineDashOffset = 0;
                }
                if (!_util2.isNodeJS) {
                  const {
                    filter: filter3
                  } = ctx;
                  if (filter3 !== "none" && filter3 !== "") {
                    ctx.filter = "none";
                  }
                }
              }
              function composeSMaskBackdrop(bytes, r0, g0, b0) {
                const length2 = bytes.length;
                for (let i = 3; i < length2; i += 4) {
                  const alpha = bytes[i];
                  if (alpha === 0) {
                    bytes[i - 3] = r0;
                    bytes[i - 2] = g0;
                    bytes[i - 1] = b0;
                  } else if (alpha < 255) {
                    const alpha_ = 255 - alpha;
                    bytes[i - 3] = bytes[i - 3] * alpha + r0 * alpha_ >> 8;
                    bytes[i - 2] = bytes[i - 2] * alpha + g0 * alpha_ >> 8;
                    bytes[i - 1] = bytes[i - 1] * alpha + b0 * alpha_ >> 8;
                  }
                }
              }
              function composeSMaskAlpha(maskData, layerData, transferMap) {
                const length2 = maskData.length;
                const scale = 1 / 255;
                for (let i = 3; i < length2; i += 4) {
                  const alpha = transferMap ? transferMap[maskData[i]] : maskData[i];
                  layerData[i] = layerData[i] * alpha * scale | 0;
                }
              }
              function composeSMaskLuminosity(maskData, layerData, transferMap) {
                const length2 = maskData.length;
                for (let i = 3; i < length2; i += 4) {
                  const y = maskData[i - 3] * 77 + maskData[i - 2] * 152 + maskData[i - 1] * 28;
                  layerData[i] = transferMap ? layerData[i] * transferMap[y >> 8] >> 8 : layerData[i] * y >> 16;
                }
              }
              function genericComposeSMask(maskCtx, layerCtx, width, height, subtype, backdrop, transferMap, layerOffsetX, layerOffsetY, maskOffsetX, maskOffsetY) {
                const hasBackdrop = !!backdrop;
                const r0 = hasBackdrop ? backdrop[0] : 0;
                const g0 = hasBackdrop ? backdrop[1] : 0;
                const b0 = hasBackdrop ? backdrop[2] : 0;
                const composeFn = subtype === "Luminosity" ? composeSMaskLuminosity : composeSMaskAlpha;
                const PIXELS_TO_PROCESS = 1048576;
                const chunkSize = Math.min(height, Math.ceil(PIXELS_TO_PROCESS / width));
                for (let row = 0; row < height; row += chunkSize) {
                  const chunkHeight = Math.min(chunkSize, height - row);
                  const maskData = maskCtx.getImageData(layerOffsetX - maskOffsetX, row + (layerOffsetY - maskOffsetY), width, chunkHeight);
                  const layerData = layerCtx.getImageData(layerOffsetX, row + layerOffsetY, width, chunkHeight);
                  if (hasBackdrop) {
                    composeSMaskBackdrop(maskData.data, r0, g0, b0);
                  }
                  composeFn(maskData.data, layerData.data, transferMap);
                  layerCtx.putImageData(layerData, layerOffsetX, row + layerOffsetY);
                }
              }
              function composeSMask(ctx, smask, layerCtx, layerBox) {
                const layerOffsetX = layerBox[0];
                const layerOffsetY = layerBox[1];
                const layerWidth = layerBox[2] - layerOffsetX;
                const layerHeight = layerBox[3] - layerOffsetY;
                if (layerWidth === 0 || layerHeight === 0) {
                  return;
                }
                genericComposeSMask(smask.context, layerCtx, layerWidth, layerHeight, smask.subtype, smask.backdrop, smask.transferMap, layerOffsetX, layerOffsetY, smask.offsetX, smask.offsetY);
                ctx.save();
                ctx.globalAlpha = 1;
                ctx.globalCompositeOperation = "source-over";
                ctx.setTransform(1, 0, 0, 1, 0, 0);
                ctx.drawImage(layerCtx.canvas, 0, 0);
                ctx.restore();
              }
              function getImageSmoothingEnabled(transform, interpolate) {
                const scale = _util2.Util.singularValueDecompose2dScale(transform);
                scale[0] = Math.fround(scale[0]);
                scale[1] = Math.fround(scale[1]);
                const actualScale = Math.fround((globalThis.devicePixelRatio || 1) * _display_utils2.PixelsPerInch.PDF_TO_CSS_UNITS);
                if (interpolate !== void 0) {
                  return interpolate;
                } else if (scale[0] <= actualScale || scale[1] <= actualScale) {
                  return true;
                }
                return false;
              }
              const LINE_CAP_STYLES = ["butt", "round", "square"];
              const LINE_JOIN_STYLES = ["miter", "round", "bevel"];
              const NORMAL_CLIP = {};
              const EO_CLIP = {};
              class CanvasGraphics {
                constructor(canvasCtx, commonObjs, objs, canvasFactory, filterFactory, {
                  optionalContentConfig,
                  markedContentStack = null
                }, annotationCanvasMap, pageColors) {
                  this.ctx = canvasCtx;
                  this.current = new CanvasExtraState(this.ctx.canvas.width, this.ctx.canvas.height);
                  this.stateStack = [];
                  this.pendingClip = null;
                  this.pendingEOFill = false;
                  this.res = null;
                  this.xobjs = null;
                  this.commonObjs = commonObjs;
                  this.objs = objs;
                  this.canvasFactory = canvasFactory;
                  this.filterFactory = filterFactory;
                  this.groupStack = [];
                  this.processingType3 = null;
                  this.baseTransform = null;
                  this.baseTransformStack = [];
                  this.groupLevel = 0;
                  this.smaskStack = [];
                  this.smaskCounter = 0;
                  this.tempSMask = null;
                  this.suspendedCtx = null;
                  this.contentVisible = true;
                  this.markedContentStack = markedContentStack || [];
                  this.optionalContentConfig = optionalContentConfig;
                  this.cachedCanvases = new CachedCanvases(this.canvasFactory);
                  this.cachedPatterns = /* @__PURE__ */ new Map();
                  this.annotationCanvasMap = annotationCanvasMap;
                  this.viewportScale = 1;
                  this.outputScaleX = 1;
                  this.outputScaleY = 1;
                  this.pageColors = pageColors;
                  this._cachedScaleForStroking = [-1, 0];
                  this._cachedGetSinglePixelWidth = null;
                  this._cachedBitmapsMap = /* @__PURE__ */ new Map();
                }
                getObject(data2, fallback = null) {
                  if (typeof data2 === "string") {
                    return data2.startsWith("g_") ? this.commonObjs.get(data2) : this.objs.get(data2);
                  }
                  return fallback;
                }
                beginDrawing({
                  transform,
                  viewport,
                  transparency = false,
                  background = null
                }) {
                  const width = this.ctx.canvas.width;
                  const height = this.ctx.canvas.height;
                  const savedFillStyle = this.ctx.fillStyle;
                  this.ctx.fillStyle = background || "#ffffff";
                  this.ctx.fillRect(0, 0, width, height);
                  this.ctx.fillStyle = savedFillStyle;
                  if (transparency) {
                    const transparentCanvas = this.cachedCanvases.getCanvas("transparent", width, height);
                    this.compositeCtx = this.ctx;
                    this.transparentCanvas = transparentCanvas.canvas;
                    this.ctx = transparentCanvas.context;
                    this.ctx.save();
                    this.ctx.transform(...(0, _display_utils2.getCurrentTransform)(this.compositeCtx));
                  }
                  this.ctx.save();
                  resetCtxToDefault(this.ctx);
                  if (transform) {
                    this.ctx.transform(...transform);
                    this.outputScaleX = transform[0];
                    this.outputScaleY = transform[0];
                  }
                  this.ctx.transform(...viewport.transform);
                  this.viewportScale = viewport.scale;
                  this.baseTransform = (0, _display_utils2.getCurrentTransform)(this.ctx);
                }
                executeOperatorList(operatorList, executionStartIdx, continueCallback, stepper) {
                  const argsArray = operatorList.argsArray;
                  const fnArray = operatorList.fnArray;
                  let i = executionStartIdx || 0;
                  const argsArrayLen = argsArray.length;
                  if (argsArrayLen === i) {
                    return i;
                  }
                  const chunkOperations = argsArrayLen - i > EXECUTION_STEPS && typeof continueCallback === "function";
                  const endTime = chunkOperations ? Date.now() + EXECUTION_TIME : 0;
                  let steps = 0;
                  const commonObjs = this.commonObjs;
                  const objs = this.objs;
                  let fnId;
                  while (true) {
                    if (stepper !== void 0 && i === stepper.nextBreakPoint) {
                      stepper.breakIt(i, continueCallback);
                      return i;
                    }
                    fnId = fnArray[i];
                    if (fnId !== _util2.OPS.dependency) {
                      this[fnId].apply(this, argsArray[i]);
                    } else {
                      for (const depObjId of argsArray[i]) {
                        const objsPool = depObjId.startsWith("g_") ? commonObjs : objs;
                        if (!objsPool.has(depObjId)) {
                          objsPool.get(depObjId, continueCallback);
                          return i;
                        }
                      }
                    }
                    i++;
                    if (i === argsArrayLen) {
                      return i;
                    }
                    if (chunkOperations && ++steps > EXECUTION_STEPS) {
                      if (Date.now() > endTime) {
                        continueCallback();
                        return i;
                      }
                      steps = 0;
                    }
                  }
                }
                #restoreInitialState() {
                  while (this.stateStack.length || this.inSMaskMode) {
                    this.restore();
                  }
                  this.ctx.restore();
                  if (this.transparentCanvas) {
                    this.ctx = this.compositeCtx;
                    this.ctx.save();
                    this.ctx.setTransform(1, 0, 0, 1, 0, 0);
                    this.ctx.drawImage(this.transparentCanvas, 0, 0);
                    this.ctx.restore();
                    this.transparentCanvas = null;
                  }
                }
                endDrawing() {
                  this.#restoreInitialState();
                  this.cachedCanvases.clear();
                  this.cachedPatterns.clear();
                  for (const cache of this._cachedBitmapsMap.values()) {
                    for (const canvas of cache.values()) {
                      if (typeof HTMLCanvasElement !== "undefined" && canvas instanceof HTMLCanvasElement) {
                        canvas.width = canvas.height = 0;
                      }
                    }
                    cache.clear();
                  }
                  this._cachedBitmapsMap.clear();
                  this.#drawFilter();
                }
                #drawFilter() {
                  if (this.pageColors) {
                    const hcmFilterId = this.filterFactory.addHCMFilter(this.pageColors.foreground, this.pageColors.background);
                    if (hcmFilterId !== "none") {
                      const savedFilter = this.ctx.filter;
                      this.ctx.filter = hcmFilterId;
                      this.ctx.drawImage(this.ctx.canvas, 0, 0);
                      this.ctx.filter = savedFilter;
                    }
                  }
                }
                _scaleImage(img, inverseTransform2) {
                  const width = img.width;
                  const height = img.height;
                  let widthScale = Math.max(Math.hypot(inverseTransform2[0], inverseTransform2[1]), 1);
                  let heightScale = Math.max(Math.hypot(inverseTransform2[2], inverseTransform2[3]), 1);
                  let paintWidth = width, paintHeight = height;
                  let tmpCanvasId = "prescale1";
                  let tmpCanvas, tmpCtx;
                  while (widthScale > 2 && paintWidth > 1 || heightScale > 2 && paintHeight > 1) {
                    let newWidth = paintWidth, newHeight = paintHeight;
                    if (widthScale > 2 && paintWidth > 1) {
                      newWidth = paintWidth >= 16384 ? Math.floor(paintWidth / 2) - 1 || 1 : Math.ceil(paintWidth / 2);
                      widthScale /= paintWidth / newWidth;
                    }
                    if (heightScale > 2 && paintHeight > 1) {
                      newHeight = paintHeight >= 16384 ? Math.floor(paintHeight / 2) - 1 || 1 : Math.ceil(paintHeight) / 2;
                      heightScale /= paintHeight / newHeight;
                    }
                    tmpCanvas = this.cachedCanvases.getCanvas(tmpCanvasId, newWidth, newHeight);
                    tmpCtx = tmpCanvas.context;
                    tmpCtx.clearRect(0, 0, newWidth, newHeight);
                    tmpCtx.drawImage(img, 0, 0, paintWidth, paintHeight, 0, 0, newWidth, newHeight);
                    img = tmpCanvas.canvas;
                    paintWidth = newWidth;
                    paintHeight = newHeight;
                    tmpCanvasId = tmpCanvasId === "prescale1" ? "prescale2" : "prescale1";
                  }
                  return {
                    img,
                    paintWidth,
                    paintHeight
                  };
                }
                _createMaskCanvas(img) {
                  const ctx = this.ctx;
                  const {
                    width,
                    height
                  } = img;
                  const fillColor = this.current.fillColor;
                  const isPatternFill = this.current.patternFill;
                  const currentTransform = (0, _display_utils2.getCurrentTransform)(ctx);
                  let cache, cacheKey, scaled, maskCanvas;
                  if ((img.bitmap || img.data) && img.count > 1) {
                    const mainKey = img.bitmap || img.data.buffer;
                    cacheKey = JSON.stringify(isPatternFill ? currentTransform : [currentTransform.slice(0, 4), fillColor]);
                    cache = this._cachedBitmapsMap.get(mainKey);
                    if (!cache) {
                      cache = /* @__PURE__ */ new Map();
                      this._cachedBitmapsMap.set(mainKey, cache);
                    }
                    const cachedImage = cache.get(cacheKey);
                    if (cachedImage && !isPatternFill) {
                      const offsetX2 = Math.round(Math.min(currentTransform[0], currentTransform[2]) + currentTransform[4]);
                      const offsetY2 = Math.round(Math.min(currentTransform[1], currentTransform[3]) + currentTransform[5]);
                      return {
                        canvas: cachedImage,
                        offsetX: offsetX2,
                        offsetY: offsetY2
                      };
                    }
                    scaled = cachedImage;
                  }
                  if (!scaled) {
                    maskCanvas = this.cachedCanvases.getCanvas("maskCanvas", width, height);
                    putBinaryImageMask(maskCanvas.context, img);
                  }
                  let maskToCanvas = _util2.Util.transform(currentTransform, [1 / width, 0, 0, -1 / height, 0, 0]);
                  maskToCanvas = _util2.Util.transform(maskToCanvas, [1, 0, 0, 1, 0, -height]);
                  const cord1 = _util2.Util.applyTransform([0, 0], maskToCanvas);
                  const cord2 = _util2.Util.applyTransform([width, height], maskToCanvas);
                  const rect = _util2.Util.normalizeRect([cord1[0], cord1[1], cord2[0], cord2[1]]);
                  const drawnWidth = Math.round(rect[2] - rect[0]) || 1;
                  const drawnHeight = Math.round(rect[3] - rect[1]) || 1;
                  const fillCanvas = this.cachedCanvases.getCanvas("fillCanvas", drawnWidth, drawnHeight);
                  const fillCtx = fillCanvas.context;
                  const offsetX = Math.min(cord1[0], cord2[0]);
                  const offsetY = Math.min(cord1[1], cord2[1]);
                  fillCtx.translate(-offsetX, -offsetY);
                  fillCtx.transform(...maskToCanvas);
                  if (!scaled) {
                    scaled = this._scaleImage(maskCanvas.canvas, (0, _display_utils2.getCurrentTransformInverse)(fillCtx));
                    scaled = scaled.img;
                    if (cache && isPatternFill) {
                      cache.set(cacheKey, scaled);
                    }
                  }
                  fillCtx.imageSmoothingEnabled = getImageSmoothingEnabled((0, _display_utils2.getCurrentTransform)(fillCtx), img.interpolate);
                  drawImageAtIntegerCoords(fillCtx, scaled, 0, 0, scaled.width, scaled.height, 0, 0, width, height);
                  fillCtx.globalCompositeOperation = "source-in";
                  const inverse = _util2.Util.transform((0, _display_utils2.getCurrentTransformInverse)(fillCtx), [1, 0, 0, 1, -offsetX, -offsetY]);
                  fillCtx.fillStyle = isPatternFill ? fillColor.getPattern(ctx, this, inverse, _pattern_helper.PathType.FILL) : fillColor;
                  fillCtx.fillRect(0, 0, width, height);
                  if (cache && !isPatternFill) {
                    this.cachedCanvases.delete("fillCanvas");
                    cache.set(cacheKey, fillCanvas.canvas);
                  }
                  return {
                    canvas: fillCanvas.canvas,
                    offsetX: Math.round(offsetX),
                    offsetY: Math.round(offsetY)
                  };
                }
                setLineWidth(width) {
                  if (width !== this.current.lineWidth) {
                    this._cachedScaleForStroking[0] = -1;
                  }
                  this.current.lineWidth = width;
                  this.ctx.lineWidth = width;
                }
                setLineCap(style2) {
                  this.ctx.lineCap = LINE_CAP_STYLES[style2];
                }
                setLineJoin(style2) {
                  this.ctx.lineJoin = LINE_JOIN_STYLES[style2];
                }
                setMiterLimit(limit) {
                  this.ctx.miterLimit = limit;
                }
                setDash(dashArray, dashPhase) {
                  const ctx = this.ctx;
                  if (ctx.setLineDash !== void 0) {
                    ctx.setLineDash(dashArray);
                    ctx.lineDashOffset = dashPhase;
                  }
                }
                setRenderingIntent(intent) {
                }
                setFlatness(flatness) {
                }
                setGState(states) {
                  for (const [key2, value] of states) {
                    switch (key2) {
                      case "LW":
                        this.setLineWidth(value);
                        break;
                      case "LC":
                        this.setLineCap(value);
                        break;
                      case "LJ":
                        this.setLineJoin(value);
                        break;
                      case "ML":
                        this.setMiterLimit(value);
                        break;
                      case "D":
                        this.setDash(value[0], value[1]);
                        break;
                      case "RI":
                        this.setRenderingIntent(value);
                        break;
                      case "FL":
                        this.setFlatness(value);
                        break;
                      case "Font":
                        this.setFont(value[0], value[1]);
                        break;
                      case "CA":
                        this.current.strokeAlpha = value;
                        break;
                      case "ca":
                        this.current.fillAlpha = value;
                        this.ctx.globalAlpha = value;
                        break;
                      case "BM":
                        this.ctx.globalCompositeOperation = value;
                        break;
                      case "SMask":
                        this.current.activeSMask = value ? this.tempSMask : null;
                        this.tempSMask = null;
                        this.checkSMaskState();
                        break;
                      case "TR":
                        this.ctx.filter = this.current.transferMaps = this.filterFactory.addFilter(value);
                        break;
                    }
                  }
                }
                get inSMaskMode() {
                  return !!this.suspendedCtx;
                }
                checkSMaskState() {
                  const inSMaskMode = this.inSMaskMode;
                  if (this.current.activeSMask && !inSMaskMode) {
                    this.beginSMaskMode();
                  } else if (!this.current.activeSMask && inSMaskMode) {
                    this.endSMaskMode();
                  }
                }
                beginSMaskMode() {
                  if (this.inSMaskMode) {
                    throw new Error("beginSMaskMode called while already in smask mode");
                  }
                  const drawnWidth = this.ctx.canvas.width;
                  const drawnHeight = this.ctx.canvas.height;
                  const cacheId = "smaskGroupAt" + this.groupLevel;
                  const scratchCanvas = this.cachedCanvases.getCanvas(cacheId, drawnWidth, drawnHeight);
                  this.suspendedCtx = this.ctx;
                  this.ctx = scratchCanvas.context;
                  const ctx = this.ctx;
                  ctx.setTransform(...(0, _display_utils2.getCurrentTransform)(this.suspendedCtx));
                  copyCtxState(this.suspendedCtx, ctx);
                  mirrorContextOperations(ctx, this.suspendedCtx);
                  this.setGState([["BM", "source-over"], ["ca", 1], ["CA", 1]]);
                }
                endSMaskMode() {
                  if (!this.inSMaskMode) {
                    throw new Error("endSMaskMode called while not in smask mode");
                  }
                  this.ctx._removeMirroring();
                  copyCtxState(this.ctx, this.suspendedCtx);
                  this.ctx = this.suspendedCtx;
                  this.suspendedCtx = null;
                }
                compose(dirtyBox) {
                  if (!this.current.activeSMask) {
                    return;
                  }
                  if (!dirtyBox) {
                    dirtyBox = [0, 0, this.ctx.canvas.width, this.ctx.canvas.height];
                  } else {
                    dirtyBox[0] = Math.floor(dirtyBox[0]);
                    dirtyBox[1] = Math.floor(dirtyBox[1]);
                    dirtyBox[2] = Math.ceil(dirtyBox[2]);
                    dirtyBox[3] = Math.ceil(dirtyBox[3]);
                  }
                  const smask = this.current.activeSMask;
                  const suspendedCtx = this.suspendedCtx;
                  composeSMask(suspendedCtx, smask, this.ctx, dirtyBox);
                  this.ctx.save();
                  this.ctx.setTransform(1, 0, 0, 1, 0, 0);
                  this.ctx.clearRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height);
                  this.ctx.restore();
                }
                save() {
                  if (this.inSMaskMode) {
                    copyCtxState(this.ctx, this.suspendedCtx);
                    this.suspendedCtx.save();
                  } else {
                    this.ctx.save();
                  }
                  const old = this.current;
                  this.stateStack.push(old);
                  this.current = old.clone();
                }
                restore() {
                  if (this.stateStack.length === 0 && this.inSMaskMode) {
                    this.endSMaskMode();
                  }
                  if (this.stateStack.length !== 0) {
                    this.current = this.stateStack.pop();
                    if (this.inSMaskMode) {
                      this.suspendedCtx.restore();
                      copyCtxState(this.suspendedCtx, this.ctx);
                    } else {
                      this.ctx.restore();
                    }
                    this.checkSMaskState();
                    this.pendingClip = null;
                    this._cachedScaleForStroking[0] = -1;
                    this._cachedGetSinglePixelWidth = null;
                  }
                }
                transform(a, b, c, d, e3, f) {
                  this.ctx.transform(a, b, c, d, e3, f);
                  this._cachedScaleForStroking[0] = -1;
                  this._cachedGetSinglePixelWidth = null;
                }
                constructPath(ops, args, minMax) {
                  const ctx = this.ctx;
                  const current2 = this.current;
                  let x = current2.x, y = current2.y;
                  let startX, startY;
                  const currentTransform = (0, _display_utils2.getCurrentTransform)(ctx);
                  const isScalingMatrix = currentTransform[0] === 0 && currentTransform[3] === 0 || currentTransform[1] === 0 && currentTransform[2] === 0;
                  const minMaxForBezier = isScalingMatrix ? minMax.slice(0) : null;
                  for (let i = 0, j = 0, ii = ops.length; i < ii; i++) {
                    switch (ops[i] | 0) {
                      case _util2.OPS.rectangle:
                        x = args[j++];
                        y = args[j++];
                        const width = args[j++];
                        const height = args[j++];
                        const xw = x + width;
                        const yh = y + height;
                        ctx.moveTo(x, y);
                        if (width === 0 || height === 0) {
                          ctx.lineTo(xw, yh);
                        } else {
                          ctx.lineTo(xw, y);
                          ctx.lineTo(xw, yh);
                          ctx.lineTo(x, yh);
                        }
                        if (!isScalingMatrix) {
                          current2.updateRectMinMax(currentTransform, [x, y, xw, yh]);
                        }
                        ctx.closePath();
                        break;
                      case _util2.OPS.moveTo:
                        x = args[j++];
                        y = args[j++];
                        ctx.moveTo(x, y);
                        if (!isScalingMatrix) {
                          current2.updatePathMinMax(currentTransform, x, y);
                        }
                        break;
                      case _util2.OPS.lineTo:
                        x = args[j++];
                        y = args[j++];
                        ctx.lineTo(x, y);
                        if (!isScalingMatrix) {
                          current2.updatePathMinMax(currentTransform, x, y);
                        }
                        break;
                      case _util2.OPS.curveTo:
                        startX = x;
                        startY = y;
                        x = args[j + 4];
                        y = args[j + 5];
                        ctx.bezierCurveTo(args[j], args[j + 1], args[j + 2], args[j + 3], x, y);
                        current2.updateCurvePathMinMax(currentTransform, startX, startY, args[j], args[j + 1], args[j + 2], args[j + 3], x, y, minMaxForBezier);
                        j += 6;
                        break;
                      case _util2.OPS.curveTo2:
                        startX = x;
                        startY = y;
                        ctx.bezierCurveTo(x, y, args[j], args[j + 1], args[j + 2], args[j + 3]);
                        current2.updateCurvePathMinMax(currentTransform, startX, startY, x, y, args[j], args[j + 1], args[j + 2], args[j + 3], minMaxForBezier);
                        x = args[j + 2];
                        y = args[j + 3];
                        j += 4;
                        break;
                      case _util2.OPS.curveTo3:
                        startX = x;
                        startY = y;
                        x = args[j + 2];
                        y = args[j + 3];
                        ctx.bezierCurveTo(args[j], args[j + 1], x, y, x, y);
                        current2.updateCurvePathMinMax(currentTransform, startX, startY, args[j], args[j + 1], x, y, x, y, minMaxForBezier);
                        j += 4;
                        break;
                      case _util2.OPS.closePath:
                        ctx.closePath();
                        break;
                    }
                  }
                  if (isScalingMatrix) {
                    current2.updateScalingPathMinMax(currentTransform, minMaxForBezier);
                  }
                  current2.setCurrentPoint(x, y);
                }
                closePath() {
                  this.ctx.closePath();
                }
                stroke(consumePath = true) {
                  const ctx = this.ctx;
                  const strokeColor = this.current.strokeColor;
                  ctx.globalAlpha = this.current.strokeAlpha;
                  if (this.contentVisible) {
                    if (typeof strokeColor === "object" && strokeColor?.getPattern) {
                      ctx.save();
                      ctx.strokeStyle = strokeColor.getPattern(ctx, this, (0, _display_utils2.getCurrentTransformInverse)(ctx), _pattern_helper.PathType.STROKE);
                      this.rescaleAndStroke(false);
                      ctx.restore();
                    } else {
                      this.rescaleAndStroke(true);
                    }
                  }
                  if (consumePath) {
                    this.consumePath(this.current.getClippedPathBoundingBox());
                  }
                  ctx.globalAlpha = this.current.fillAlpha;
                }
                closeStroke() {
                  this.closePath();
                  this.stroke();
                }
                fill(consumePath = true) {
                  const ctx = this.ctx;
                  const fillColor = this.current.fillColor;
                  const isPatternFill = this.current.patternFill;
                  let needRestore = false;
                  if (isPatternFill) {
                    ctx.save();
                    ctx.fillStyle = fillColor.getPattern(ctx, this, (0, _display_utils2.getCurrentTransformInverse)(ctx), _pattern_helper.PathType.FILL);
                    needRestore = true;
                  }
                  const intersect = this.current.getClippedPathBoundingBox();
                  if (this.contentVisible && intersect !== null) {
                    if (this.pendingEOFill) {
                      ctx.fill("evenodd");
                      this.pendingEOFill = false;
                    } else {
                      ctx.fill();
                    }
                  }
                  if (needRestore) {
                    ctx.restore();
                  }
                  if (consumePath) {
                    this.consumePath(intersect);
                  }
                }
                eoFill() {
                  this.pendingEOFill = true;
                  this.fill();
                }
                fillStroke() {
                  this.fill(false);
                  this.stroke(false);
                  this.consumePath();
                }
                eoFillStroke() {
                  this.pendingEOFill = true;
                  this.fillStroke();
                }
                closeFillStroke() {
                  this.closePath();
                  this.fillStroke();
                }
                closeEOFillStroke() {
                  this.pendingEOFill = true;
                  this.closePath();
                  this.fillStroke();
                }
                endPath() {
                  this.consumePath();
                }
                clip() {
                  this.pendingClip = NORMAL_CLIP;
                }
                eoClip() {
                  this.pendingClip = EO_CLIP;
                }
                beginText() {
                  this.current.textMatrix = _util2.IDENTITY_MATRIX;
                  this.current.textMatrixScale = 1;
                  this.current.x = this.current.lineX = 0;
                  this.current.y = this.current.lineY = 0;
                }
                endText() {
                  const paths = this.pendingTextPaths;
                  const ctx = this.ctx;
                  if (paths === void 0) {
                    ctx.beginPath();
                    return;
                  }
                  ctx.save();
                  ctx.beginPath();
                  for (const path2 of paths) {
                    ctx.setTransform(...path2.transform);
                    ctx.translate(path2.x, path2.y);
                    path2.addToPath(ctx, path2.fontSize);
                  }
                  ctx.restore();
                  ctx.clip();
                  ctx.beginPath();
                  delete this.pendingTextPaths;
                }
                setCharSpacing(spacing) {
                  this.current.charSpacing = spacing;
                }
                setWordSpacing(spacing) {
                  this.current.wordSpacing = spacing;
                }
                setHScale(scale) {
                  this.current.textHScale = scale / 100;
                }
                setLeading(leading) {
                  this.current.leading = -leading;
                }
                setFont(fontRefName, size) {
                  const fontObj = this.commonObjs.get(fontRefName);
                  const current2 = this.current;
                  if (!fontObj) {
                    throw new Error(`Can't find font for ${fontRefName}`);
                  }
                  current2.fontMatrix = fontObj.fontMatrix || _util2.FONT_IDENTITY_MATRIX;
                  if (current2.fontMatrix[0] === 0 || current2.fontMatrix[3] === 0) {
                    (0, _util2.warn)("Invalid font matrix for font " + fontRefName);
                  }
                  if (size < 0) {
                    size = -size;
                    current2.fontDirection = -1;
                  } else {
                    current2.fontDirection = 1;
                  }
                  this.current.font = fontObj;
                  this.current.fontSize = size;
                  if (fontObj.isType3Font) {
                    return;
                  }
                  const name = fontObj.loadedName || "sans-serif";
                  const typeface = fontObj.systemFontInfo?.css || `"${name}", ${fontObj.fallbackName}`;
                  let bold = "normal";
                  if (fontObj.black) {
                    bold = "900";
                  } else if (fontObj.bold) {
                    bold = "bold";
                  }
                  const italic = fontObj.italic ? "italic" : "normal";
                  let browserFontSize = size;
                  if (size < MIN_FONT_SIZE) {
                    browserFontSize = MIN_FONT_SIZE;
                  } else if (size > MAX_FONT_SIZE) {
                    browserFontSize = MAX_FONT_SIZE;
                  }
                  this.current.fontSizeScale = size / browserFontSize;
                  this.ctx.font = `${italic} ${bold} ${browserFontSize}px ${typeface}`;
                }
                setTextRenderingMode(mode) {
                  this.current.textRenderingMode = mode;
                }
                setTextRise(rise) {
                  this.current.textRise = rise;
                }
                moveText(x, y) {
                  this.current.x = this.current.lineX += x;
                  this.current.y = this.current.lineY += y;
                }
                setLeadingMoveText(x, y) {
                  this.setLeading(-y);
                  this.moveText(x, y);
                }
                setTextMatrix(a, b, c, d, e3, f) {
                  this.current.textMatrix = [a, b, c, d, e3, f];
                  this.current.textMatrixScale = Math.hypot(a, b);
                  this.current.x = this.current.lineX = 0;
                  this.current.y = this.current.lineY = 0;
                }
                nextLine() {
                  this.moveText(0, this.current.leading);
                }
                paintChar(character2, x, y, patternTransform) {
                  const ctx = this.ctx;
                  const current2 = this.current;
                  const font = current2.font;
                  const textRenderingMode = current2.textRenderingMode;
                  const fontSize = current2.fontSize / current2.fontSizeScale;
                  const fillStrokeMode = textRenderingMode & _util2.TextRenderingMode.FILL_STROKE_MASK;
                  const isAddToPathSet = !!(textRenderingMode & _util2.TextRenderingMode.ADD_TO_PATH_FLAG);
                  const patternFill = current2.patternFill && !font.missingFile;
                  let addToPath;
                  if (font.disableFontFace || isAddToPathSet || patternFill) {
                    addToPath = font.getPathGenerator(this.commonObjs, character2);
                  }
                  if (font.disableFontFace || patternFill) {
                    ctx.save();
                    ctx.translate(x, y);
                    ctx.beginPath();
                    addToPath(ctx, fontSize);
                    if (patternTransform) {
                      ctx.setTransform(...patternTransform);
                    }
                    if (fillStrokeMode === _util2.TextRenderingMode.FILL || fillStrokeMode === _util2.TextRenderingMode.FILL_STROKE) {
                      ctx.fill();
                    }
                    if (fillStrokeMode === _util2.TextRenderingMode.STROKE || fillStrokeMode === _util2.TextRenderingMode.FILL_STROKE) {
                      ctx.stroke();
                    }
                    ctx.restore();
                  } else {
                    if (fillStrokeMode === _util2.TextRenderingMode.FILL || fillStrokeMode === _util2.TextRenderingMode.FILL_STROKE) {
                      ctx.fillText(character2, x, y);
                    }
                    if (fillStrokeMode === _util2.TextRenderingMode.STROKE || fillStrokeMode === _util2.TextRenderingMode.FILL_STROKE) {
                      ctx.strokeText(character2, x, y);
                    }
                  }
                  if (isAddToPathSet) {
                    const paths = this.pendingTextPaths ||= [];
                    paths.push({
                      transform: (0, _display_utils2.getCurrentTransform)(ctx),
                      x,
                      y,
                      fontSize,
                      addToPath
                    });
                  }
                }
                get isFontSubpixelAAEnabled() {
                  const {
                    context: ctx
                  } = this.cachedCanvases.getCanvas("isFontSubpixelAAEnabled", 10, 10);
                  ctx.scale(1.5, 1);
                  ctx.fillText("I", 0, 10);
                  const data2 = ctx.getImageData(0, 0, 10, 10).data;
                  let enabled = false;
                  for (let i = 3; i < data2.length; i += 4) {
                    if (data2[i] > 0 && data2[i] < 255) {
                      enabled = true;
                      break;
                    }
                  }
                  return (0, _util2.shadow)(this, "isFontSubpixelAAEnabled", enabled);
                }
                showText(glyphs) {
                  const current2 = this.current;
                  const font = current2.font;
                  if (font.isType3Font) {
                    return this.showType3Text(glyphs);
                  }
                  const fontSize = current2.fontSize;
                  if (fontSize === 0) {
                    return void 0;
                  }
                  const ctx = this.ctx;
                  const fontSizeScale = current2.fontSizeScale;
                  const charSpacing = current2.charSpacing;
                  const wordSpacing = current2.wordSpacing;
                  const fontDirection = current2.fontDirection;
                  const textHScale = current2.textHScale * fontDirection;
                  const glyphsLength = glyphs.length;
                  const vertical = font.vertical;
                  const spacingDir = vertical ? 1 : -1;
                  const defaultVMetrics = font.defaultVMetrics;
                  const widthAdvanceScale = fontSize * current2.fontMatrix[0];
                  const simpleFillText = current2.textRenderingMode === _util2.TextRenderingMode.FILL && !font.disableFontFace && !current2.patternFill;
                  ctx.save();
                  ctx.transform(...current2.textMatrix);
                  ctx.translate(current2.x, current2.y + current2.textRise);
                  if (fontDirection > 0) {
                    ctx.scale(textHScale, -1);
                  } else {
                    ctx.scale(textHScale, 1);
                  }
                  let patternTransform;
                  if (current2.patternFill) {
                    ctx.save();
                    const pattern6 = current2.fillColor.getPattern(ctx, this, (0, _display_utils2.getCurrentTransformInverse)(ctx), _pattern_helper.PathType.FILL);
                    patternTransform = (0, _display_utils2.getCurrentTransform)(ctx);
                    ctx.restore();
                    ctx.fillStyle = pattern6;
                  }
                  let lineWidth = current2.lineWidth;
                  const scale = current2.textMatrixScale;
                  if (scale === 0 || lineWidth === 0) {
                    const fillStrokeMode = current2.textRenderingMode & _util2.TextRenderingMode.FILL_STROKE_MASK;
                    if (fillStrokeMode === _util2.TextRenderingMode.STROKE || fillStrokeMode === _util2.TextRenderingMode.FILL_STROKE) {
                      lineWidth = this.getSinglePixelWidth();
                    }
                  } else {
                    lineWidth /= scale;
                  }
                  if (fontSizeScale !== 1) {
                    ctx.scale(fontSizeScale, fontSizeScale);
                    lineWidth /= fontSizeScale;
                  }
                  ctx.lineWidth = lineWidth;
                  if (font.isInvalidPDFjsFont) {
                    const chars = [];
                    let width = 0;
                    for (const glyph of glyphs) {
                      chars.push(glyph.unicode);
                      width += glyph.width;
                    }
                    ctx.fillText(chars.join(""), 0, 0);
                    current2.x += width * widthAdvanceScale * textHScale;
                    ctx.restore();
                    this.compose();
                    return void 0;
                  }
                  let x = 0, i;
                  for (i = 0; i < glyphsLength; ++i) {
                    const glyph = glyphs[i];
                    if (typeof glyph === "number") {
                      x += spacingDir * glyph * fontSize / 1e3;
                      continue;
                    }
                    let restoreNeeded = false;
                    const spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
                    const character2 = glyph.fontChar;
                    const accent = glyph.accent;
                    let scaledX, scaledY;
                    let width = glyph.width;
                    if (vertical) {
                      const vmetric = glyph.vmetric || defaultVMetrics;
                      const vx = -(glyph.vmetric ? vmetric[1] : width * 0.5) * widthAdvanceScale;
                      const vy = vmetric[2] * widthAdvanceScale;
                      width = vmetric ? -vmetric[0] : width;
                      scaledX = vx / fontSizeScale;
                      scaledY = (x + vy) / fontSizeScale;
                    } else {
                      scaledX = x / fontSizeScale;
                      scaledY = 0;
                    }
                    if (font.remeasure && width > 0) {
                      const measuredWidth = ctx.measureText(character2).width * 1e3 / fontSize * fontSizeScale;
                      if (width < measuredWidth && this.isFontSubpixelAAEnabled) {
                        const characterScaleX = width / measuredWidth;
                        restoreNeeded = true;
                        ctx.save();
                        ctx.scale(characterScaleX, 1);
                        scaledX /= characterScaleX;
                      } else if (width !== measuredWidth) {
                        scaledX += (width - measuredWidth) / 2e3 * fontSize / fontSizeScale;
                      }
                    }
                    if (this.contentVisible && (glyph.isInFont || font.missingFile)) {
                      if (simpleFillText && !accent) {
                        ctx.fillText(character2, scaledX, scaledY);
                      } else {
                        this.paintChar(character2, scaledX, scaledY, patternTransform);
                        if (accent) {
                          const scaledAccentX = scaledX + fontSize * accent.offset.x / fontSizeScale;
                          const scaledAccentY = scaledY - fontSize * accent.offset.y / fontSizeScale;
                          this.paintChar(accent.fontChar, scaledAccentX, scaledAccentY, patternTransform);
                        }
                      }
                    }
                    const charWidth = vertical ? width * widthAdvanceScale - spacing * fontDirection : width * widthAdvanceScale + spacing * fontDirection;
                    x += charWidth;
                    if (restoreNeeded) {
                      ctx.restore();
                    }
                  }
                  if (vertical) {
                    current2.y -= x;
                  } else {
                    current2.x += x * textHScale;
                  }
                  ctx.restore();
                  this.compose();
                  return void 0;
                }
                showType3Text(glyphs) {
                  const ctx = this.ctx;
                  const current2 = this.current;
                  const font = current2.font;
                  const fontSize = current2.fontSize;
                  const fontDirection = current2.fontDirection;
                  const spacingDir = font.vertical ? 1 : -1;
                  const charSpacing = current2.charSpacing;
                  const wordSpacing = current2.wordSpacing;
                  const textHScale = current2.textHScale * fontDirection;
                  const fontMatrix = current2.fontMatrix || _util2.FONT_IDENTITY_MATRIX;
                  const glyphsLength = glyphs.length;
                  const isTextInvisible = current2.textRenderingMode === _util2.TextRenderingMode.INVISIBLE;
                  let i, glyph, width, spacingLength;
                  if (isTextInvisible || fontSize === 0) {
                    return;
                  }
                  this._cachedScaleForStroking[0] = -1;
                  this._cachedGetSinglePixelWidth = null;
                  ctx.save();
                  ctx.transform(...current2.textMatrix);
                  ctx.translate(current2.x, current2.y);
                  ctx.scale(textHScale, fontDirection);
                  for (i = 0; i < glyphsLength; ++i) {
                    glyph = glyphs[i];
                    if (typeof glyph === "number") {
                      spacingLength = spacingDir * glyph * fontSize / 1e3;
                      this.ctx.translate(spacingLength, 0);
                      current2.x += spacingLength * textHScale;
                      continue;
                    }
                    const spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
                    const operatorList = font.charProcOperatorList[glyph.operatorListId];
                    if (!operatorList) {
                      (0, _util2.warn)(`Type3 character "${glyph.operatorListId}" is not available.`);
                      continue;
                    }
                    if (this.contentVisible) {
                      this.processingType3 = glyph;
                      this.save();
                      ctx.scale(fontSize, fontSize);
                      ctx.transform(...fontMatrix);
                      this.executeOperatorList(operatorList);
                      this.restore();
                    }
                    const transformed = _util2.Util.applyTransform([glyph.width, 0], fontMatrix);
                    width = transformed[0] * fontSize + spacing;
                    ctx.translate(width, 0);
                    current2.x += width * textHScale;
                  }
                  ctx.restore();
                  this.processingType3 = null;
                }
                setCharWidth(xWidth, yWidth) {
                }
                setCharWidthAndBounds(xWidth, yWidth, llx, lly, urx, ury) {
                  this.ctx.rect(llx, lly, urx - llx, ury - lly);
                  this.ctx.clip();
                  this.endPath();
                }
                getColorN_Pattern(IR) {
                  let pattern6;
                  if (IR[0] === "TilingPattern") {
                    const color = IR[1];
                    const baseTransform = this.baseTransform || (0, _display_utils2.getCurrentTransform)(this.ctx);
                    const canvasGraphicsFactory = {
                      createCanvasGraphics: (ctx) => {
                        return new CanvasGraphics(ctx, this.commonObjs, this.objs, this.canvasFactory, this.filterFactory, {
                          optionalContentConfig: this.optionalContentConfig,
                          markedContentStack: this.markedContentStack
                        });
                      }
                    };
                    pattern6 = new _pattern_helper.TilingPattern(IR, color, this.ctx, canvasGraphicsFactory, baseTransform);
                  } else {
                    pattern6 = this._getPattern(IR[1], IR[2]);
                  }
                  return pattern6;
                }
                setStrokeColorN() {
                  this.current.strokeColor = this.getColorN_Pattern(arguments);
                }
                setFillColorN() {
                  this.current.fillColor = this.getColorN_Pattern(arguments);
                  this.current.patternFill = true;
                }
                setStrokeRGBColor(r2, g, b) {
                  const color = _util2.Util.makeHexColor(r2, g, b);
                  this.ctx.strokeStyle = color;
                  this.current.strokeColor = color;
                }
                setFillRGBColor(r2, g, b) {
                  const color = _util2.Util.makeHexColor(r2, g, b);
                  this.ctx.fillStyle = color;
                  this.current.fillColor = color;
                  this.current.patternFill = false;
                }
                _getPattern(objId, matrix = null) {
                  let pattern6;
                  if (this.cachedPatterns.has(objId)) {
                    pattern6 = this.cachedPatterns.get(objId);
                  } else {
                    pattern6 = (0, _pattern_helper.getShadingPattern)(this.getObject(objId));
                    this.cachedPatterns.set(objId, pattern6);
                  }
                  if (matrix) {
                    pattern6.matrix = matrix;
                  }
                  return pattern6;
                }
                shadingFill(objId) {
                  if (!this.contentVisible) {
                    return;
                  }
                  const ctx = this.ctx;
                  this.save();
                  const pattern6 = this._getPattern(objId);
                  ctx.fillStyle = pattern6.getPattern(ctx, this, (0, _display_utils2.getCurrentTransformInverse)(ctx), _pattern_helper.PathType.SHADING);
                  const inv = (0, _display_utils2.getCurrentTransformInverse)(ctx);
                  if (inv) {
                    const {
                      width,
                      height
                    } = ctx.canvas;
                    const [x0, y0, x1, y1] = _util2.Util.getAxialAlignedBoundingBox([0, 0, width, height], inv);
                    this.ctx.fillRect(x0, y0, x1 - x0, y1 - y0);
                  } else {
                    this.ctx.fillRect(-1e10, -1e10, 2e10, 2e10);
                  }
                  this.compose(this.current.getClippedPathBoundingBox());
                  this.restore();
                }
                beginInlineImage() {
                  (0, _util2.unreachable)("Should not call beginInlineImage");
                }
                beginImageData() {
                  (0, _util2.unreachable)("Should not call beginImageData");
                }
                paintFormXObjectBegin(matrix, bbox) {
                  if (!this.contentVisible) {
                    return;
                  }
                  this.save();
                  this.baseTransformStack.push(this.baseTransform);
                  if (Array.isArray(matrix) && matrix.length === 6) {
                    this.transform(...matrix);
                  }
                  this.baseTransform = (0, _display_utils2.getCurrentTransform)(this.ctx);
                  if (bbox) {
                    const width = bbox[2] - bbox[0];
                    const height = bbox[3] - bbox[1];
                    this.ctx.rect(bbox[0], bbox[1], width, height);
                    this.current.updateRectMinMax((0, _display_utils2.getCurrentTransform)(this.ctx), bbox);
                    this.clip();
                    this.endPath();
                  }
                }
                paintFormXObjectEnd() {
                  if (!this.contentVisible) {
                    return;
                  }
                  this.restore();
                  this.baseTransform = this.baseTransformStack.pop();
                }
                beginGroup(group) {
                  if (!this.contentVisible) {
                    return;
                  }
                  this.save();
                  if (this.inSMaskMode) {
                    this.endSMaskMode();
                    this.current.activeSMask = null;
                  }
                  const currentCtx = this.ctx;
                  if (!group.isolated) {
                    (0, _util2.info)("TODO: Support non-isolated groups.");
                  }
                  if (group.knockout) {
                    (0, _util2.warn)("Knockout groups not supported.");
                  }
                  const currentTransform = (0, _display_utils2.getCurrentTransform)(currentCtx);
                  if (group.matrix) {
                    currentCtx.transform(...group.matrix);
                  }
                  if (!group.bbox) {
                    throw new Error("Bounding box is required.");
                  }
                  let bounds = _util2.Util.getAxialAlignedBoundingBox(group.bbox, (0, _display_utils2.getCurrentTransform)(currentCtx));
                  const canvasBounds = [0, 0, currentCtx.canvas.width, currentCtx.canvas.height];
                  bounds = _util2.Util.intersect(bounds, canvasBounds) || [0, 0, 0, 0];
                  const offsetX = Math.floor(bounds[0]);
                  const offsetY = Math.floor(bounds[1]);
                  let drawnWidth = Math.max(Math.ceil(bounds[2]) - offsetX, 1);
                  let drawnHeight = Math.max(Math.ceil(bounds[3]) - offsetY, 1);
                  let scaleX = 1, scaleY = 1;
                  if (drawnWidth > MAX_GROUP_SIZE) {
                    scaleX = drawnWidth / MAX_GROUP_SIZE;
                    drawnWidth = MAX_GROUP_SIZE;
                  }
                  if (drawnHeight > MAX_GROUP_SIZE) {
                    scaleY = drawnHeight / MAX_GROUP_SIZE;
                    drawnHeight = MAX_GROUP_SIZE;
                  }
                  this.current.startNewPathAndClipBox([0, 0, drawnWidth, drawnHeight]);
                  let cacheId = "groupAt" + this.groupLevel;
                  if (group.smask) {
                    cacheId += "_smask_" + this.smaskCounter++ % 2;
                  }
                  const scratchCanvas = this.cachedCanvases.getCanvas(cacheId, drawnWidth, drawnHeight);
                  const groupCtx = scratchCanvas.context;
                  groupCtx.scale(1 / scaleX, 1 / scaleY);
                  groupCtx.translate(-offsetX, -offsetY);
                  groupCtx.transform(...currentTransform);
                  if (group.smask) {
                    this.smaskStack.push({
                      canvas: scratchCanvas.canvas,
                      context: groupCtx,
                      offsetX,
                      offsetY,
                      scaleX,
                      scaleY,
                      subtype: group.smask.subtype,
                      backdrop: group.smask.backdrop,
                      transferMap: group.smask.transferMap || null,
                      startTransformInverse: null
                    });
                  } else {
                    currentCtx.setTransform(1, 0, 0, 1, 0, 0);
                    currentCtx.translate(offsetX, offsetY);
                    currentCtx.scale(scaleX, scaleY);
                    currentCtx.save();
                  }
                  copyCtxState(currentCtx, groupCtx);
                  this.ctx = groupCtx;
                  this.setGState([["BM", "source-over"], ["ca", 1], ["CA", 1]]);
                  this.groupStack.push(currentCtx);
                  this.groupLevel++;
                }
                endGroup(group) {
                  if (!this.contentVisible) {
                    return;
                  }
                  this.groupLevel--;
                  const groupCtx = this.ctx;
                  const ctx = this.groupStack.pop();
                  this.ctx = ctx;
                  this.ctx.imageSmoothingEnabled = false;
                  if (group.smask) {
                    this.tempSMask = this.smaskStack.pop();
                    this.restore();
                  } else {
                    this.ctx.restore();
                    const currentMtx = (0, _display_utils2.getCurrentTransform)(this.ctx);
                    this.restore();
                    this.ctx.save();
                    this.ctx.setTransform(...currentMtx);
                    const dirtyBox = _util2.Util.getAxialAlignedBoundingBox([0, 0, groupCtx.canvas.width, groupCtx.canvas.height], currentMtx);
                    this.ctx.drawImage(groupCtx.canvas, 0, 0);
                    this.ctx.restore();
                    this.compose(dirtyBox);
                  }
                }
                beginAnnotation(id, rect, transform, matrix, hasOwnCanvas) {
                  this.#restoreInitialState();
                  resetCtxToDefault(this.ctx);
                  this.ctx.save();
                  this.save();
                  if (this.baseTransform) {
                    this.ctx.setTransform(...this.baseTransform);
                  }
                  if (Array.isArray(rect) && rect.length === 4) {
                    const width = rect[2] - rect[0];
                    const height = rect[3] - rect[1];
                    if (hasOwnCanvas && this.annotationCanvasMap) {
                      transform = transform.slice();
                      transform[4] -= rect[0];
                      transform[5] -= rect[1];
                      rect = rect.slice();
                      rect[0] = rect[1] = 0;
                      rect[2] = width;
                      rect[3] = height;
                      const [scaleX, scaleY] = _util2.Util.singularValueDecompose2dScale((0, _display_utils2.getCurrentTransform)(this.ctx));
                      const {
                        viewportScale
                      } = this;
                      const canvasWidth = Math.ceil(width * this.outputScaleX * viewportScale);
                      const canvasHeight = Math.ceil(height * this.outputScaleY * viewportScale);
                      this.annotationCanvas = this.canvasFactory.create(canvasWidth, canvasHeight);
                      const {
                        canvas,
                        context
                      } = this.annotationCanvas;
                      this.annotationCanvasMap.set(id, canvas);
                      this.annotationCanvas.savedCtx = this.ctx;
                      this.ctx = context;
                      this.ctx.save();
                      this.ctx.setTransform(scaleX, 0, 0, -scaleY, 0, height * scaleY);
                      resetCtxToDefault(this.ctx);
                    } else {
                      resetCtxToDefault(this.ctx);
                      this.ctx.rect(rect[0], rect[1], width, height);
                      this.ctx.clip();
                      this.endPath();
                    }
                  }
                  this.current = new CanvasExtraState(this.ctx.canvas.width, this.ctx.canvas.height);
                  this.transform(...transform);
                  this.transform(...matrix);
                }
                endAnnotation() {
                  if (this.annotationCanvas) {
                    this.ctx.restore();
                    this.#drawFilter();
                    this.ctx = this.annotationCanvas.savedCtx;
                    delete this.annotationCanvas.savedCtx;
                    delete this.annotationCanvas;
                  }
                }
                paintImageMaskXObject(img) {
                  if (!this.contentVisible) {
                    return;
                  }
                  const count = img.count;
                  img = this.getObject(img.data, img);
                  img.count = count;
                  const ctx = this.ctx;
                  const glyph = this.processingType3;
                  if (glyph) {
                    if (glyph.compiled === void 0) {
                      glyph.compiled = compileType3Glyph(img);
                    }
                    if (glyph.compiled) {
                      glyph.compiled(ctx);
                      return;
                    }
                  }
                  const mask = this._createMaskCanvas(img);
                  const maskCanvas = mask.canvas;
                  ctx.save();
                  ctx.setTransform(1, 0, 0, 1, 0, 0);
                  ctx.drawImage(maskCanvas, mask.offsetX, mask.offsetY);
                  ctx.restore();
                  this.compose();
                }
                paintImageMaskXObjectRepeat(img, scaleX, skewX = 0, skewY = 0, scaleY, positions) {
                  if (!this.contentVisible) {
                    return;
                  }
                  img = this.getObject(img.data, img);
                  const ctx = this.ctx;
                  ctx.save();
                  const currentTransform = (0, _display_utils2.getCurrentTransform)(ctx);
                  ctx.transform(scaleX, skewX, skewY, scaleY, 0, 0);
                  const mask = this._createMaskCanvas(img);
                  ctx.setTransform(1, 0, 0, 1, mask.offsetX - currentTransform[4], mask.offsetY - currentTransform[5]);
                  for (let i = 0, ii = positions.length; i < ii; i += 2) {
                    const trans = _util2.Util.transform(currentTransform, [scaleX, skewX, skewY, scaleY, positions[i], positions[i + 1]]);
                    const [x, y] = _util2.Util.applyTransform([0, 0], trans);
                    ctx.drawImage(mask.canvas, x, y);
                  }
                  ctx.restore();
                  this.compose();
                }
                paintImageMaskXObjectGroup(images) {
                  if (!this.contentVisible) {
                    return;
                  }
                  const ctx = this.ctx;
                  const fillColor = this.current.fillColor;
                  const isPatternFill = this.current.patternFill;
                  for (const image of images) {
                    const {
                      data: data2,
                      width,
                      height,
                      transform
                    } = image;
                    const maskCanvas = this.cachedCanvases.getCanvas("maskCanvas", width, height);
                    const maskCtx = maskCanvas.context;
                    maskCtx.save();
                    const img = this.getObject(data2, image);
                    putBinaryImageMask(maskCtx, img);
                    maskCtx.globalCompositeOperation = "source-in";
                    maskCtx.fillStyle = isPatternFill ? fillColor.getPattern(maskCtx, this, (0, _display_utils2.getCurrentTransformInverse)(ctx), _pattern_helper.PathType.FILL) : fillColor;
                    maskCtx.fillRect(0, 0, width, height);
                    maskCtx.restore();
                    ctx.save();
                    ctx.transform(...transform);
                    ctx.scale(1, -1);
                    drawImageAtIntegerCoords(ctx, maskCanvas.canvas, 0, 0, width, height, 0, -1, 1, 1);
                    ctx.restore();
                  }
                  this.compose();
                }
                paintImageXObject(objId) {
                  if (!this.contentVisible) {
                    return;
                  }
                  const imgData = this.getObject(objId);
                  if (!imgData) {
                    (0, _util2.warn)("Dependent image isn't ready yet");
                    return;
                  }
                  this.paintInlineImageXObject(imgData);
                }
                paintImageXObjectRepeat(objId, scaleX, scaleY, positions) {
                  if (!this.contentVisible) {
                    return;
                  }
                  const imgData = this.getObject(objId);
                  if (!imgData) {
                    (0, _util2.warn)("Dependent image isn't ready yet");
                    return;
                  }
                  const width = imgData.width;
                  const height = imgData.height;
                  const map = [];
                  for (let i = 0, ii = positions.length; i < ii; i += 2) {
                    map.push({
                      transform: [scaleX, 0, 0, scaleY, positions[i], positions[i + 1]],
                      x: 0,
                      y: 0,
                      w: width,
                      h: height
                    });
                  }
                  this.paintInlineImageXObjectGroup(imgData, map);
                }
                applyTransferMapsToCanvas(ctx) {
                  if (this.current.transferMaps !== "none") {
                    ctx.filter = this.current.transferMaps;
                    ctx.drawImage(ctx.canvas, 0, 0);
                    ctx.filter = "none";
                  }
                  return ctx.canvas;
                }
                applyTransferMapsToBitmap(imgData) {
                  if (this.current.transferMaps === "none") {
                    return imgData.bitmap;
                  }
                  const {
                    bitmap,
                    width,
                    height
                  } = imgData;
                  const tmpCanvas = this.cachedCanvases.getCanvas("inlineImage", width, height);
                  const tmpCtx = tmpCanvas.context;
                  tmpCtx.filter = this.current.transferMaps;
                  tmpCtx.drawImage(bitmap, 0, 0);
                  tmpCtx.filter = "none";
                  return tmpCanvas.canvas;
                }
                paintInlineImageXObject(imgData) {
                  if (!this.contentVisible) {
                    return;
                  }
                  const width = imgData.width;
                  const height = imgData.height;
                  const ctx = this.ctx;
                  this.save();
                  if (!_util2.isNodeJS) {
                    const {
                      filter: filter3
                    } = ctx;
                    if (filter3 !== "none" && filter3 !== "") {
                      ctx.filter = "none";
                    }
                  }
                  ctx.scale(1 / width, -1 / height);
                  let imgToPaint;
                  if (imgData.bitmap) {
                    imgToPaint = this.applyTransferMapsToBitmap(imgData);
                  } else if (typeof HTMLElement === "function" && imgData instanceof HTMLElement || !imgData.data) {
                    imgToPaint = imgData;
                  } else {
                    const tmpCanvas = this.cachedCanvases.getCanvas("inlineImage", width, height);
                    const tmpCtx = tmpCanvas.context;
                    putBinaryImageData(tmpCtx, imgData);
                    imgToPaint = this.applyTransferMapsToCanvas(tmpCtx);
                  }
                  const scaled = this._scaleImage(imgToPaint, (0, _display_utils2.getCurrentTransformInverse)(ctx));
                  ctx.imageSmoothingEnabled = getImageSmoothingEnabled((0, _display_utils2.getCurrentTransform)(ctx), imgData.interpolate);
                  drawImageAtIntegerCoords(ctx, scaled.img, 0, 0, scaled.paintWidth, scaled.paintHeight, 0, -height, width, height);
                  this.compose();
                  this.restore();
                }
                paintInlineImageXObjectGroup(imgData, map) {
                  if (!this.contentVisible) {
                    return;
                  }
                  const ctx = this.ctx;
                  let imgToPaint;
                  if (imgData.bitmap) {
                    imgToPaint = imgData.bitmap;
                  } else {
                    const w = imgData.width;
                    const h2 = imgData.height;
                    const tmpCanvas = this.cachedCanvases.getCanvas("inlineImage", w, h2);
                    const tmpCtx = tmpCanvas.context;
                    putBinaryImageData(tmpCtx, imgData);
                    imgToPaint = this.applyTransferMapsToCanvas(tmpCtx);
                  }
                  for (const entry of map) {
                    ctx.save();
                    ctx.transform(...entry.transform);
                    ctx.scale(1, -1);
                    drawImageAtIntegerCoords(ctx, imgToPaint, entry.x, entry.y, entry.w, entry.h, 0, -1, 1, 1);
                    ctx.restore();
                  }
                  this.compose();
                }
                paintSolidColorImageMask() {
                  if (!this.contentVisible) {
                    return;
                  }
                  this.ctx.fillRect(0, 0, 1, 1);
                  this.compose();
                }
                markPoint(tag) {
                }
                markPointProps(tag, properties2) {
                }
                beginMarkedContent(tag) {
                  this.markedContentStack.push({
                    visible: true
                  });
                }
                beginMarkedContentProps(tag, properties2) {
                  if (tag === "OC") {
                    this.markedContentStack.push({
                      visible: this.optionalContentConfig.isVisible(properties2)
                    });
                  } else {
                    this.markedContentStack.push({
                      visible: true
                    });
                  }
                  this.contentVisible = this.isContentVisible();
                }
                endMarkedContent() {
                  this.markedContentStack.pop();
                  this.contentVisible = this.isContentVisible();
                }
                beginCompat() {
                }
                endCompat() {
                }
                consumePath(clipBox) {
                  const isEmpty2 = this.current.isEmptyClip();
                  if (this.pendingClip) {
                    this.current.updateClipFromPath();
                  }
                  if (!this.pendingClip) {
                    this.compose(clipBox);
                  }
                  const ctx = this.ctx;
                  if (this.pendingClip) {
                    if (!isEmpty2) {
                      if (this.pendingClip === EO_CLIP) {
                        ctx.clip("evenodd");
                      } else {
                        ctx.clip();
                      }
                    }
                    this.pendingClip = null;
                  }
                  this.current.startNewPathAndClipBox(this.current.clipBox);
                  ctx.beginPath();
                }
                getSinglePixelWidth() {
                  if (!this._cachedGetSinglePixelWidth) {
                    const m = (0, _display_utils2.getCurrentTransform)(this.ctx);
                    if (m[1] === 0 && m[2] === 0) {
                      this._cachedGetSinglePixelWidth = 1 / Math.min(Math.abs(m[0]), Math.abs(m[3]));
                    } else {
                      const absDet = Math.abs(m[0] * m[3] - m[2] * m[1]);
                      const normX = Math.hypot(m[0], m[2]);
                      const normY = Math.hypot(m[1], m[3]);
                      this._cachedGetSinglePixelWidth = Math.max(normX, normY) / absDet;
                    }
                  }
                  return this._cachedGetSinglePixelWidth;
                }
                getScaleForStroking() {
                  if (this._cachedScaleForStroking[0] === -1) {
                    const {
                      lineWidth
                    } = this.current;
                    const {
                      a,
                      b,
                      c,
                      d
                    } = this.ctx.getTransform();
                    let scaleX, scaleY;
                    if (b === 0 && c === 0) {
                      const normX = Math.abs(a);
                      const normY = Math.abs(d);
                      if (normX === normY) {
                        if (lineWidth === 0) {
                          scaleX = scaleY = 1 / normX;
                        } else {
                          const scaledLineWidth = normX * lineWidth;
                          scaleX = scaleY = scaledLineWidth < 1 ? 1 / scaledLineWidth : 1;
                        }
                      } else if (lineWidth === 0) {
                        scaleX = 1 / normX;
                        scaleY = 1 / normY;
                      } else {
                        const scaledXLineWidth = normX * lineWidth;
                        const scaledYLineWidth = normY * lineWidth;
                        scaleX = scaledXLineWidth < 1 ? 1 / scaledXLineWidth : 1;
                        scaleY = scaledYLineWidth < 1 ? 1 / scaledYLineWidth : 1;
                      }
                    } else {
                      const absDet = Math.abs(a * d - b * c);
                      const normX = Math.hypot(a, b);
                      const normY = Math.hypot(c, d);
                      if (lineWidth === 0) {
                        scaleX = normY / absDet;
                        scaleY = normX / absDet;
                      } else {
                        const baseArea = lineWidth * absDet;
                        scaleX = normY > baseArea ? normY / baseArea : 1;
                        scaleY = normX > baseArea ? normX / baseArea : 1;
                      }
                    }
                    this._cachedScaleForStroking[0] = scaleX;
                    this._cachedScaleForStroking[1] = scaleY;
                  }
                  return this._cachedScaleForStroking;
                }
                rescaleAndStroke(saveRestore) {
                  const {
                    ctx
                  } = this;
                  const {
                    lineWidth
                  } = this.current;
                  const [scaleX, scaleY] = this.getScaleForStroking();
                  ctx.lineWidth = lineWidth || 1;
                  if (scaleX === 1 && scaleY === 1) {
                    ctx.stroke();
                    return;
                  }
                  const dashes = ctx.getLineDash();
                  if (saveRestore) {
                    ctx.save();
                  }
                  ctx.scale(scaleX, scaleY);
                  if (dashes.length > 0) {
                    const scale = Math.max(scaleX, scaleY);
                    ctx.setLineDash(dashes.map((x) => x / scale));
                    ctx.lineDashOffset /= scale;
                  }
                  ctx.stroke();
                  if (saveRestore) {
                    ctx.restore();
                  }
                }
                isContentVisible() {
                  for (let i = this.markedContentStack.length - 1; i >= 0; i--) {
                    if (!this.markedContentStack[i].visible) {
                      return false;
                    }
                  }
                  return true;
                }
              }
              exports2.CanvasGraphics = CanvasGraphics;
              for (const op in _util2.OPS) {
                if (CanvasGraphics.prototype[op] !== void 0) {
                  CanvasGraphics.prototype[_util2.OPS[op]] = CanvasGraphics.prototype[op];
                }
              }
            }),
            /* 12 */
            /***/
            ((__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
              Object.defineProperty(exports2, "__esModule", {
                value: true
              });
              exports2.TilingPattern = exports2.PathType = void 0;
              exports2.getShadingPattern = getShadingPattern;
              var _util2 = __w_pdfjs_require__2(1);
              var _display_utils2 = __w_pdfjs_require__2(6);
              const PathType = {
                FILL: "Fill",
                STROKE: "Stroke",
                SHADING: "Shading"
              };
              exports2.PathType = PathType;
              function applyBoundingBox(ctx, bbox) {
                if (!bbox) {
                  return;
                }
                const width = bbox[2] - bbox[0];
                const height = bbox[3] - bbox[1];
                const region = new Path2D();
                region.rect(bbox[0], bbox[1], width, height);
                ctx.clip(region);
              }
              class BaseShadingPattern {
                constructor() {
                  if (this.constructor === BaseShadingPattern) {
                    (0, _util2.unreachable)("Cannot initialize BaseShadingPattern.");
                  }
                }
                getPattern() {
                  (0, _util2.unreachable)("Abstract method `getPattern` called.");
                }
              }
              class RadialAxialShadingPattern extends BaseShadingPattern {
                constructor(IR) {
                  super();
                  this._type = IR[1];
                  this._bbox = IR[2];
                  this._colorStops = IR[3];
                  this._p0 = IR[4];
                  this._p1 = IR[5];
                  this._r0 = IR[6];
                  this._r1 = IR[7];
                  this.matrix = null;
                }
                _createGradient(ctx) {
                  let grad;
                  if (this._type === "axial") {
                    grad = ctx.createLinearGradient(this._p0[0], this._p0[1], this._p1[0], this._p1[1]);
                  } else if (this._type === "radial") {
                    grad = ctx.createRadialGradient(this._p0[0], this._p0[1], this._r0, this._p1[0], this._p1[1], this._r1);
                  }
                  for (const colorStop of this._colorStops) {
                    grad.addColorStop(colorStop[0], colorStop[1]);
                  }
                  return grad;
                }
                getPattern(ctx, owner, inverse, pathType) {
                  let pattern6;
                  if (pathType === PathType.STROKE || pathType === PathType.FILL) {
                    const ownerBBox = owner.current.getClippedPathBoundingBox(pathType, (0, _display_utils2.getCurrentTransform)(ctx)) || [0, 0, 0, 0];
                    const width = Math.ceil(ownerBBox[2] - ownerBBox[0]) || 1;
                    const height = Math.ceil(ownerBBox[3] - ownerBBox[1]) || 1;
                    const tmpCanvas = owner.cachedCanvases.getCanvas("pattern", width, height, true);
                    const tmpCtx = tmpCanvas.context;
                    tmpCtx.clearRect(0, 0, tmpCtx.canvas.width, tmpCtx.canvas.height);
                    tmpCtx.beginPath();
                    tmpCtx.rect(0, 0, tmpCtx.canvas.width, tmpCtx.canvas.height);
                    tmpCtx.translate(-ownerBBox[0], -ownerBBox[1]);
                    inverse = _util2.Util.transform(inverse, [1, 0, 0, 1, ownerBBox[0], ownerBBox[1]]);
                    tmpCtx.transform(...owner.baseTransform);
                    if (this.matrix) {
                      tmpCtx.transform(...this.matrix);
                    }
                    applyBoundingBox(tmpCtx, this._bbox);
                    tmpCtx.fillStyle = this._createGradient(tmpCtx);
                    tmpCtx.fill();
                    pattern6 = ctx.createPattern(tmpCanvas.canvas, "no-repeat");
                    const domMatrix = new DOMMatrix(inverse);
                    pattern6.setTransform(domMatrix);
                  } else {
                    applyBoundingBox(ctx, this._bbox);
                    pattern6 = this._createGradient(ctx);
                  }
                  return pattern6;
                }
              }
              function drawTriangle(data2, context, p1, p2, p3, c1, c2, c3) {
                const coords = context.coords, colors = context.colors;
                const bytes = data2.data, rowSize = data2.width * 4;
                let tmp;
                if (coords[p1 + 1] > coords[p2 + 1]) {
                  tmp = p1;
                  p1 = p2;
                  p2 = tmp;
                  tmp = c1;
                  c1 = c2;
                  c2 = tmp;
                }
                if (coords[p2 + 1] > coords[p3 + 1]) {
                  tmp = p2;
                  p2 = p3;
                  p3 = tmp;
                  tmp = c2;
                  c2 = c3;
                  c3 = tmp;
                }
                if (coords[p1 + 1] > coords[p2 + 1]) {
                  tmp = p1;
                  p1 = p2;
                  p2 = tmp;
                  tmp = c1;
                  c1 = c2;
                  c2 = tmp;
                }
                const x1 = (coords[p1] + context.offsetX) * context.scaleX;
                const y1 = (coords[p1 + 1] + context.offsetY) * context.scaleY;
                const x2 = (coords[p2] + context.offsetX) * context.scaleX;
                const y2 = (coords[p2 + 1] + context.offsetY) * context.scaleY;
                const x3 = (coords[p3] + context.offsetX) * context.scaleX;
                const y3 = (coords[p3 + 1] + context.offsetY) * context.scaleY;
                if (y1 >= y3) {
                  return;
                }
                const c1r = colors[c1], c1g = colors[c1 + 1], c1b = colors[c1 + 2];
                const c2r = colors[c2], c2g = colors[c2 + 1], c2b = colors[c2 + 2];
                const c3r = colors[c3], c3g = colors[c3 + 1], c3b = colors[c3 + 2];
                const minY = Math.round(y1), maxY = Math.round(y3);
                let xa, car, cag, cab;
                let xb, cbr, cbg, cbb;
                for (let y = minY; y <= maxY; y++) {
                  if (y < y2) {
                    const k2 = y < y1 ? 0 : (y1 - y) / (y1 - y2);
                    xa = x1 - (x1 - x2) * k2;
                    car = c1r - (c1r - c2r) * k2;
                    cag = c1g - (c1g - c2g) * k2;
                    cab = c1b - (c1b - c2b) * k2;
                  } else {
                    let k2;
                    if (y > y3) {
                      k2 = 1;
                    } else if (y2 === y3) {
                      k2 = 0;
                    } else {
                      k2 = (y2 - y) / (y2 - y3);
                    }
                    xa = x2 - (x2 - x3) * k2;
                    car = c2r - (c2r - c3r) * k2;
                    cag = c2g - (c2g - c3g) * k2;
                    cab = c2b - (c2b - c3b) * k2;
                  }
                  let k;
                  if (y < y1) {
                    k = 0;
                  } else if (y > y3) {
                    k = 1;
                  } else {
                    k = (y1 - y) / (y1 - y3);
                  }
                  xb = x1 - (x1 - x3) * k;
                  cbr = c1r - (c1r - c3r) * k;
                  cbg = c1g - (c1g - c3g) * k;
                  cbb = c1b - (c1b - c3b) * k;
                  const x1_ = Math.round(Math.min(xa, xb));
                  const x2_ = Math.round(Math.max(xa, xb));
                  let j = rowSize * y + x1_ * 4;
                  for (let x = x1_; x <= x2_; x++) {
                    k = (xa - x) / (xa - xb);
                    if (k < 0) {
                      k = 0;
                    } else if (k > 1) {
                      k = 1;
                    }
                    bytes[j++] = car - (car - cbr) * k | 0;
                    bytes[j++] = cag - (cag - cbg) * k | 0;
                    bytes[j++] = cab - (cab - cbb) * k | 0;
                    bytes[j++] = 255;
                  }
                }
              }
              function drawFigure(data2, figure, context) {
                const ps = figure.coords;
                const cs = figure.colors;
                let i, ii;
                switch (figure.type) {
                  case "lattice":
                    const verticesPerRow = figure.verticesPerRow;
                    const rows = Math.floor(ps.length / verticesPerRow) - 1;
                    const cols = verticesPerRow - 1;
                    for (i = 0; i < rows; i++) {
                      let q = i * verticesPerRow;
                      for (let j = 0; j < cols; j++, q++) {
                        drawTriangle(data2, context, ps[q], ps[q + 1], ps[q + verticesPerRow], cs[q], cs[q + 1], cs[q + verticesPerRow]);
                        drawTriangle(data2, context, ps[q + verticesPerRow + 1], ps[q + 1], ps[q + verticesPerRow], cs[q + verticesPerRow + 1], cs[q + 1], cs[q + verticesPerRow]);
                      }
                    }
                    break;
                  case "triangles":
                    for (i = 0, ii = ps.length; i < ii; i += 3) {
                      drawTriangle(data2, context, ps[i], ps[i + 1], ps[i + 2], cs[i], cs[i + 1], cs[i + 2]);
                    }
                    break;
                  default:
                    throw new Error("illegal figure");
                }
              }
              class MeshShadingPattern extends BaseShadingPattern {
                constructor(IR) {
                  super();
                  this._coords = IR[2];
                  this._colors = IR[3];
                  this._figures = IR[4];
                  this._bounds = IR[5];
                  this._bbox = IR[7];
                  this._background = IR[8];
                  this.matrix = null;
                }
                _createMeshCanvas(combinedScale, backgroundColor, cachedCanvases) {
                  const EXPECTED_SCALE = 1.1;
                  const MAX_PATTERN_SIZE = 3e3;
                  const BORDER_SIZE = 2;
                  const offsetX = Math.floor(this._bounds[0]);
                  const offsetY = Math.floor(this._bounds[1]);
                  const boundsWidth = Math.ceil(this._bounds[2]) - offsetX;
                  const boundsHeight = Math.ceil(this._bounds[3]) - offsetY;
                  const width = Math.min(Math.ceil(Math.abs(boundsWidth * combinedScale[0] * EXPECTED_SCALE)), MAX_PATTERN_SIZE);
                  const height = Math.min(Math.ceil(Math.abs(boundsHeight * combinedScale[1] * EXPECTED_SCALE)), MAX_PATTERN_SIZE);
                  const scaleX = boundsWidth / width;
                  const scaleY = boundsHeight / height;
                  const context = {
                    coords: this._coords,
                    colors: this._colors,
                    offsetX: -offsetX,
                    offsetY: -offsetY,
                    scaleX: 1 / scaleX,
                    scaleY: 1 / scaleY
                  };
                  const paddedWidth = width + BORDER_SIZE * 2;
                  const paddedHeight = height + BORDER_SIZE * 2;
                  const tmpCanvas = cachedCanvases.getCanvas("mesh", paddedWidth, paddedHeight, false);
                  const tmpCtx = tmpCanvas.context;
                  const data2 = tmpCtx.createImageData(width, height);
                  if (backgroundColor) {
                    const bytes = data2.data;
                    for (let i = 0, ii = bytes.length; i < ii; i += 4) {
                      bytes[i] = backgroundColor[0];
                      bytes[i + 1] = backgroundColor[1];
                      bytes[i + 2] = backgroundColor[2];
                      bytes[i + 3] = 255;
                    }
                  }
                  for (const figure of this._figures) {
                    drawFigure(data2, figure, context);
                  }
                  tmpCtx.putImageData(data2, BORDER_SIZE, BORDER_SIZE);
                  const canvas = tmpCanvas.canvas;
                  return {
                    canvas,
                    offsetX: offsetX - BORDER_SIZE * scaleX,
                    offsetY: offsetY - BORDER_SIZE * scaleY,
                    scaleX,
                    scaleY
                  };
                }
                getPattern(ctx, owner, inverse, pathType) {
                  applyBoundingBox(ctx, this._bbox);
                  let scale;
                  if (pathType === PathType.SHADING) {
                    scale = _util2.Util.singularValueDecompose2dScale((0, _display_utils2.getCurrentTransform)(ctx));
                  } else {
                    scale = _util2.Util.singularValueDecompose2dScale(owner.baseTransform);
                    if (this.matrix) {
                      const matrixScale = _util2.Util.singularValueDecompose2dScale(this.matrix);
                      scale = [scale[0] * matrixScale[0], scale[1] * matrixScale[1]];
                    }
                  }
                  const temporaryPatternCanvas = this._createMeshCanvas(scale, pathType === PathType.SHADING ? null : this._background, owner.cachedCanvases);
                  if (pathType !== PathType.SHADING) {
                    ctx.setTransform(...owner.baseTransform);
                    if (this.matrix) {
                      ctx.transform(...this.matrix);
                    }
                  }
                  ctx.translate(temporaryPatternCanvas.offsetX, temporaryPatternCanvas.offsetY);
                  ctx.scale(temporaryPatternCanvas.scaleX, temporaryPatternCanvas.scaleY);
                  return ctx.createPattern(temporaryPatternCanvas.canvas, "no-repeat");
                }
              }
              class DummyShadingPattern extends BaseShadingPattern {
                getPattern() {
                  return "hotpink";
                }
              }
              function getShadingPattern(IR) {
                switch (IR[0]) {
                  case "RadialAxial":
                    return new RadialAxialShadingPattern(IR);
                  case "Mesh":
                    return new MeshShadingPattern(IR);
                  case "Dummy":
                    return new DummyShadingPattern();
                }
                throw new Error(`Unknown IR type: ${IR[0]}`);
              }
              const PaintType = {
                COLORED: 1,
                UNCOLORED: 2
              };
              class TilingPattern {
                static MAX_PATTERN_SIZE = 3e3;
                constructor(IR, color, ctx, canvasGraphicsFactory, baseTransform) {
                  this.operatorList = IR[2];
                  this.matrix = IR[3] || [1, 0, 0, 1, 0, 0];
                  this.bbox = IR[4];
                  this.xstep = IR[5];
                  this.ystep = IR[6];
                  this.paintType = IR[7];
                  this.tilingType = IR[8];
                  this.color = color;
                  this.ctx = ctx;
                  this.canvasGraphicsFactory = canvasGraphicsFactory;
                  this.baseTransform = baseTransform;
                }
                createPatternCanvas(owner) {
                  const operatorList = this.operatorList;
                  const bbox = this.bbox;
                  const xstep = this.xstep;
                  const ystep = this.ystep;
                  const paintType = this.paintType;
                  const tilingType = this.tilingType;
                  const color = this.color;
                  const canvasGraphicsFactory = this.canvasGraphicsFactory;
                  (0, _util2.info)("TilingType: " + tilingType);
                  const x0 = bbox[0], y0 = bbox[1], x1 = bbox[2], y1 = bbox[3];
                  const matrixScale = _util2.Util.singularValueDecompose2dScale(this.matrix);
                  const curMatrixScale = _util2.Util.singularValueDecompose2dScale(this.baseTransform);
                  const combinedScale = [matrixScale[0] * curMatrixScale[0], matrixScale[1] * curMatrixScale[1]];
                  const dimx = this.getSizeAndScale(xstep, this.ctx.canvas.width, combinedScale[0]);
                  const dimy = this.getSizeAndScale(ystep, this.ctx.canvas.height, combinedScale[1]);
                  const tmpCanvas = owner.cachedCanvases.getCanvas("pattern", dimx.size, dimy.size, true);
                  const tmpCtx = tmpCanvas.context;
                  const graphics = canvasGraphicsFactory.createCanvasGraphics(tmpCtx);
                  graphics.groupLevel = owner.groupLevel;
                  this.setFillAndStrokeStyleToContext(graphics, paintType, color);
                  let adjustedX0 = x0;
                  let adjustedY0 = y0;
                  let adjustedX1 = x1;
                  let adjustedY1 = y1;
                  if (x0 < 0) {
                    adjustedX0 = 0;
                    adjustedX1 += Math.abs(x0);
                  }
                  if (y0 < 0) {
                    adjustedY0 = 0;
                    adjustedY1 += Math.abs(y0);
                  }
                  tmpCtx.translate(-(dimx.scale * adjustedX0), -(dimy.scale * adjustedY0));
                  graphics.transform(dimx.scale, 0, 0, dimy.scale, 0, 0);
                  tmpCtx.save();
                  this.clipBbox(graphics, adjustedX0, adjustedY0, adjustedX1, adjustedY1);
                  graphics.baseTransform = (0, _display_utils2.getCurrentTransform)(graphics.ctx);
                  graphics.executeOperatorList(operatorList);
                  graphics.endDrawing();
                  return {
                    canvas: tmpCanvas.canvas,
                    scaleX: dimx.scale,
                    scaleY: dimy.scale,
                    offsetX: adjustedX0,
                    offsetY: adjustedY0
                  };
                }
                getSizeAndScale(step, realOutputSize, scale) {
                  step = Math.abs(step);
                  const maxSize = Math.max(TilingPattern.MAX_PATTERN_SIZE, realOutputSize);
                  let size = Math.ceil(step * scale);
                  if (size >= maxSize) {
                    size = maxSize;
                  } else {
                    scale = size / step;
                  }
                  return {
                    scale,
                    size
                  };
                }
                clipBbox(graphics, x0, y0, x1, y1) {
                  const bboxWidth = x1 - x0;
                  const bboxHeight = y1 - y0;
                  graphics.ctx.rect(x0, y0, bboxWidth, bboxHeight);
                  graphics.current.updateRectMinMax((0, _display_utils2.getCurrentTransform)(graphics.ctx), [x0, y0, x1, y1]);
                  graphics.clip();
                  graphics.endPath();
                }
                setFillAndStrokeStyleToContext(graphics, paintType, color) {
                  const context = graphics.ctx, current2 = graphics.current;
                  switch (paintType) {
                    case PaintType.COLORED:
                      const ctx = this.ctx;
                      context.fillStyle = ctx.fillStyle;
                      context.strokeStyle = ctx.strokeStyle;
                      current2.fillColor = ctx.fillStyle;
                      current2.strokeColor = ctx.strokeStyle;
                      break;
                    case PaintType.UNCOLORED:
                      const cssColor = _util2.Util.makeHexColor(color[0], color[1], color[2]);
                      context.fillStyle = cssColor;
                      context.strokeStyle = cssColor;
                      current2.fillColor = cssColor;
                      current2.strokeColor = cssColor;
                      break;
                    default:
                      throw new _util2.FormatError(`Unsupported paint type: ${paintType}`);
                  }
                }
                getPattern(ctx, owner, inverse, pathType) {
                  let matrix = inverse;
                  if (pathType !== PathType.SHADING) {
                    matrix = _util2.Util.transform(matrix, owner.baseTransform);
                    if (this.matrix) {
                      matrix = _util2.Util.transform(matrix, this.matrix);
                    }
                  }
                  const temporaryPatternCanvas = this.createPatternCanvas(owner);
                  let domMatrix = new DOMMatrix(matrix);
                  domMatrix = domMatrix.translate(temporaryPatternCanvas.offsetX, temporaryPatternCanvas.offsetY);
                  domMatrix = domMatrix.scale(1 / temporaryPatternCanvas.scaleX, 1 / temporaryPatternCanvas.scaleY);
                  const pattern6 = ctx.createPattern(temporaryPatternCanvas.canvas, "repeat");
                  pattern6.setTransform(domMatrix);
                  return pattern6;
                }
              }
              exports2.TilingPattern = TilingPattern;
            }),
            /* 13 */
            /***/
            ((__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
              Object.defineProperty(exports2, "__esModule", {
                value: true
              });
              exports2.convertBlackAndWhiteToRGBA = convertBlackAndWhiteToRGBA;
              exports2.convertToRGBA = convertToRGBA;
              exports2.grayToRGBA = grayToRGBA;
              var _util2 = __w_pdfjs_require__2(1);
              function convertToRGBA(params) {
                switch (params.kind) {
                  case _util2.ImageKind.GRAYSCALE_1BPP:
                    return convertBlackAndWhiteToRGBA(params);
                  case _util2.ImageKind.RGB_24BPP:
                    return convertRGBToRGBA(params);
                }
                return null;
              }
              function convertBlackAndWhiteToRGBA({
                src,
                srcPos = 0,
                dest,
                width,
                height,
                nonBlackColor = 4294967295,
                inverseDecode = false
              }) {
                const black = _util2.FeatureTest.isLittleEndian ? 4278190080 : 255;
                const [zeroMapping, oneMapping] = inverseDecode ? [nonBlackColor, black] : [black, nonBlackColor];
                const widthInSource = width >> 3;
                const widthRemainder = width & 7;
                const srcLength = src.length;
                dest = new Uint32Array(dest.buffer);
                let destPos = 0;
                for (let i = 0; i < height; i++) {
                  for (const max = srcPos + widthInSource; srcPos < max; srcPos++) {
                    const elem2 = srcPos < srcLength ? src[srcPos] : 255;
                    dest[destPos++] = elem2 & 128 ? oneMapping : zeroMapping;
                    dest[destPos++] = elem2 & 64 ? oneMapping : zeroMapping;
                    dest[destPos++] = elem2 & 32 ? oneMapping : zeroMapping;
                    dest[destPos++] = elem2 & 16 ? oneMapping : zeroMapping;
                    dest[destPos++] = elem2 & 8 ? oneMapping : zeroMapping;
                    dest[destPos++] = elem2 & 4 ? oneMapping : zeroMapping;
                    dest[destPos++] = elem2 & 2 ? oneMapping : zeroMapping;
                    dest[destPos++] = elem2 & 1 ? oneMapping : zeroMapping;
                  }
                  if (widthRemainder === 0) {
                    continue;
                  }
                  const elem = srcPos < srcLength ? src[srcPos++] : 255;
                  for (let j = 0; j < widthRemainder; j++) {
                    dest[destPos++] = elem & 1 << 7 - j ? oneMapping : zeroMapping;
                  }
                }
                return {
                  srcPos,
                  destPos
                };
              }
              function convertRGBToRGBA({
                src,
                srcPos = 0,
                dest,
                destPos = 0,
                width,
                height
              }) {
                let i = 0;
                const len32 = src.length >> 2;
                const src32 = new Uint32Array(src.buffer, srcPos, len32);
                if (_util2.FeatureTest.isLittleEndian) {
                  for (; i < len32 - 2; i += 3, destPos += 4) {
                    const s1 = src32[i];
                    const s2 = src32[i + 1];
                    const s3 = src32[i + 2];
                    dest[destPos] = s1 | 4278190080;
                    dest[destPos + 1] = s1 >>> 24 | s2 << 8 | 4278190080;
                    dest[destPos + 2] = s2 >>> 16 | s3 << 16 | 4278190080;
                    dest[destPos + 3] = s3 >>> 8 | 4278190080;
                  }
                  for (let j = i * 4, jj = src.length; j < jj; j += 3) {
                    dest[destPos++] = src[j] | src[j + 1] << 8 | src[j + 2] << 16 | 4278190080;
                  }
                } else {
                  for (; i < len32 - 2; i += 3, destPos += 4) {
                    const s1 = src32[i];
                    const s2 = src32[i + 1];
                    const s3 = src32[i + 2];
                    dest[destPos] = s1 | 255;
                    dest[destPos + 1] = s1 << 24 | s2 >>> 8 | 255;
                    dest[destPos + 2] = s2 << 16 | s3 >>> 16 | 255;
                    dest[destPos + 3] = s3 << 8 | 255;
                  }
                  for (let j = i * 4, jj = src.length; j < jj; j += 3) {
                    dest[destPos++] = src[j] << 24 | src[j + 1] << 16 | src[j + 2] << 8 | 255;
                  }
                }
                return {
                  srcPos,
                  destPos
                };
              }
              function grayToRGBA(src, dest) {
                if (_util2.FeatureTest.isLittleEndian) {
                  for (let i = 0, ii = src.length; i < ii; i++) {
                    dest[i] = src[i] * 65793 | 4278190080;
                  }
                } else {
                  for (let i = 0, ii = src.length; i < ii; i++) {
                    dest[i] = src[i] * 16843008 | 255;
                  }
                }
              }
            }),
            /* 14 */
            /***/
            ((__unused_webpack_module2, exports2) => {
              Object.defineProperty(exports2, "__esModule", {
                value: true
              });
              exports2.GlobalWorkerOptions = void 0;
              const GlobalWorkerOptions2 = /* @__PURE__ */ Object.create(null);
              exports2.GlobalWorkerOptions = GlobalWorkerOptions2;
              GlobalWorkerOptions2.workerPort = null;
              GlobalWorkerOptions2.workerSrc = "";
            }),
            /* 15 */
            /***/
            ((__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
              Object.defineProperty(exports2, "__esModule", {
                value: true
              });
              exports2.MessageHandler = void 0;
              var _util2 = __w_pdfjs_require__2(1);
              const CallbackKind = {
                UNKNOWN: 0,
                DATA: 1,
                ERROR: 2
              };
              const StreamKind = {
                UNKNOWN: 0,
                CANCEL: 1,
                CANCEL_COMPLETE: 2,
                CLOSE: 3,
                ENQUEUE: 4,
                ERROR: 5,
                PULL: 6,
                PULL_COMPLETE: 7,
                START_COMPLETE: 8
              };
              function wrapReason(reason) {
                if (!(reason instanceof Error || typeof reason === "object" && reason !== null)) {
                  (0, _util2.unreachable)('wrapReason: Expected "reason" to be a (possibly cloned) Error.');
                }
                switch (reason.name) {
                  case "AbortException":
                    return new _util2.AbortException(reason.message);
                  case "MissingPDFException":
                    return new _util2.MissingPDFException(reason.message);
                  case "PasswordException":
                    return new _util2.PasswordException(reason.message, reason.code);
                  case "UnexpectedResponseException":
                    return new _util2.UnexpectedResponseException(reason.message, reason.status);
                  case "UnknownErrorException":
                    return new _util2.UnknownErrorException(reason.message, reason.details);
                  default:
                    return new _util2.UnknownErrorException(reason.message, reason.toString());
                }
              }
              class MessageHandler {
                constructor(sourceName, targetName, comObj) {
                  this.sourceName = sourceName;
                  this.targetName = targetName;
                  this.comObj = comObj;
                  this.callbackId = 1;
                  this.streamId = 1;
                  this.streamSinks = /* @__PURE__ */ Object.create(null);
                  this.streamControllers = /* @__PURE__ */ Object.create(null);
                  this.callbackCapabilities = /* @__PURE__ */ Object.create(null);
                  this.actionHandler = /* @__PURE__ */ Object.create(null);
                  this._onComObjOnMessage = (event) => {
                    const data2 = event.data;
                    if (data2.targetName !== this.sourceName) {
                      return;
                    }
                    if (data2.stream) {
                      this.#processStreamMessage(data2);
                      return;
                    }
                    if (data2.callback) {
                      const callbackId = data2.callbackId;
                      const capability = this.callbackCapabilities[callbackId];
                      if (!capability) {
                        throw new Error(`Cannot resolve callback ${callbackId}`);
                      }
                      delete this.callbackCapabilities[callbackId];
                      if (data2.callback === CallbackKind.DATA) {
                        capability.resolve(data2.data);
                      } else if (data2.callback === CallbackKind.ERROR) {
                        capability.reject(wrapReason(data2.reason));
                      } else {
                        throw new Error("Unexpected callback case");
                      }
                      return;
                    }
                    const action = this.actionHandler[data2.action];
                    if (!action) {
                      throw new Error(`Unknown action from worker: ${data2.action}`);
                    }
                    if (data2.callbackId) {
                      const cbSourceName = this.sourceName;
                      const cbTargetName = data2.sourceName;
                      new Promise(function(resolve) {
                        resolve(action(data2.data));
                      }).then(function(result) {
                        comObj.postMessage({
                          sourceName: cbSourceName,
                          targetName: cbTargetName,
                          callback: CallbackKind.DATA,
                          callbackId: data2.callbackId,
                          data: result
                        });
                      }, function(reason) {
                        comObj.postMessage({
                          sourceName: cbSourceName,
                          targetName: cbTargetName,
                          callback: CallbackKind.ERROR,
                          callbackId: data2.callbackId,
                          reason: wrapReason(reason)
                        });
                      });
                      return;
                    }
                    if (data2.streamId) {
                      this.#createStreamSink(data2);
                      return;
                    }
                    action(data2.data);
                  };
                  comObj.addEventListener("message", this._onComObjOnMessage);
                }
                on(actionName, handler) {
                  const ah = this.actionHandler;
                  if (ah[actionName]) {
                    throw new Error(`There is already an actionName called "${actionName}"`);
                  }
                  ah[actionName] = handler;
                }
                send(actionName, data2, transfers) {
                  this.comObj.postMessage({
                    sourceName: this.sourceName,
                    targetName: this.targetName,
                    action: actionName,
                    data: data2
                  }, transfers);
                }
                sendWithPromise(actionName, data2, transfers) {
                  const callbackId = this.callbackId++;
                  const capability = new _util2.PromiseCapability();
                  this.callbackCapabilities[callbackId] = capability;
                  try {
                    this.comObj.postMessage({
                      sourceName: this.sourceName,
                      targetName: this.targetName,
                      action: actionName,
                      callbackId,
                      data: data2
                    }, transfers);
                  } catch (ex) {
                    capability.reject(ex);
                  }
                  return capability.promise;
                }
                sendWithStream(actionName, data2, queueingStrategy, transfers) {
                  const streamId = this.streamId++, sourceName = this.sourceName, targetName = this.targetName, comObj = this.comObj;
                  return new ReadableStream({
                    start: (controller) => {
                      const startCapability = new _util2.PromiseCapability();
                      this.streamControllers[streamId] = {
                        controller,
                        startCall: startCapability,
                        pullCall: null,
                        cancelCall: null,
                        isClosed: false
                      };
                      comObj.postMessage({
                        sourceName,
                        targetName,
                        action: actionName,
                        streamId,
                        data: data2,
                        desiredSize: controller.desiredSize
                      }, transfers);
                      return startCapability.promise;
                    },
                    pull: (controller) => {
                      const pullCapability = new _util2.PromiseCapability();
                      this.streamControllers[streamId].pullCall = pullCapability;
                      comObj.postMessage({
                        sourceName,
                        targetName,
                        stream: StreamKind.PULL,
                        streamId,
                        desiredSize: controller.desiredSize
                      });
                      return pullCapability.promise;
                    },
                    cancel: (reason) => {
                      (0, _util2.assert)(reason instanceof Error, "cancel must have a valid reason");
                      const cancelCapability = new _util2.PromiseCapability();
                      this.streamControllers[streamId].cancelCall = cancelCapability;
                      this.streamControllers[streamId].isClosed = true;
                      comObj.postMessage({
                        sourceName,
                        targetName,
                        stream: StreamKind.CANCEL,
                        streamId,
                        reason: wrapReason(reason)
                      });
                      return cancelCapability.promise;
                    }
                  }, queueingStrategy);
                }
                #createStreamSink(data2) {
                  const streamId = data2.streamId, sourceName = this.sourceName, targetName = data2.sourceName, comObj = this.comObj;
                  const self2 = this, action = this.actionHandler[data2.action];
                  const streamSink = {
                    enqueue(chunk, size = 1, transfers) {
                      if (this.isCancelled) {
                        return;
                      }
                      const lastDesiredSize = this.desiredSize;
                      this.desiredSize -= size;
                      if (lastDesiredSize > 0 && this.desiredSize <= 0) {
                        this.sinkCapability = new _util2.PromiseCapability();
                        this.ready = this.sinkCapability.promise;
                      }
                      comObj.postMessage({
                        sourceName,
                        targetName,
                        stream: StreamKind.ENQUEUE,
                        streamId,
                        chunk
                      }, transfers);
                    },
                    close() {
                      if (this.isCancelled) {
                        return;
                      }
                      this.isCancelled = true;
                      comObj.postMessage({
                        sourceName,
                        targetName,
                        stream: StreamKind.CLOSE,
                        streamId
                      });
                      delete self2.streamSinks[streamId];
                    },
                    error(reason) {
                      (0, _util2.assert)(reason instanceof Error, "error must have a valid reason");
                      if (this.isCancelled) {
                        return;
                      }
                      this.isCancelled = true;
                      comObj.postMessage({
                        sourceName,
                        targetName,
                        stream: StreamKind.ERROR,
                        streamId,
                        reason: wrapReason(reason)
                      });
                    },
                    sinkCapability: new _util2.PromiseCapability(),
                    onPull: null,
                    onCancel: null,
                    isCancelled: false,
                    desiredSize: data2.desiredSize,
                    ready: null
                  };
                  streamSink.sinkCapability.resolve();
                  streamSink.ready = streamSink.sinkCapability.promise;
                  this.streamSinks[streamId] = streamSink;
                  new Promise(function(resolve) {
                    resolve(action(data2.data, streamSink));
                  }).then(function() {
                    comObj.postMessage({
                      sourceName,
                      targetName,
                      stream: StreamKind.START_COMPLETE,
                      streamId,
                      success: true
                    });
                  }, function(reason) {
                    comObj.postMessage({
                      sourceName,
                      targetName,
                      stream: StreamKind.START_COMPLETE,
                      streamId,
                      reason: wrapReason(reason)
                    });
                  });
                }
                #processStreamMessage(data2) {
                  const streamId = data2.streamId, sourceName = this.sourceName, targetName = data2.sourceName, comObj = this.comObj;
                  const streamController = this.streamControllers[streamId], streamSink = this.streamSinks[streamId];
                  switch (data2.stream) {
                    case StreamKind.START_COMPLETE:
                      if (data2.success) {
                        streamController.startCall.resolve();
                      } else {
                        streamController.startCall.reject(wrapReason(data2.reason));
                      }
                      break;
                    case StreamKind.PULL_COMPLETE:
                      if (data2.success) {
                        streamController.pullCall.resolve();
                      } else {
                        streamController.pullCall.reject(wrapReason(data2.reason));
                      }
                      break;
                    case StreamKind.PULL:
                      if (!streamSink) {
                        comObj.postMessage({
                          sourceName,
                          targetName,
                          stream: StreamKind.PULL_COMPLETE,
                          streamId,
                          success: true
                        });
                        break;
                      }
                      if (streamSink.desiredSize <= 0 && data2.desiredSize > 0) {
                        streamSink.sinkCapability.resolve();
                      }
                      streamSink.desiredSize = data2.desiredSize;
                      new Promise(function(resolve) {
                        resolve(streamSink.onPull?.());
                      }).then(function() {
                        comObj.postMessage({
                          sourceName,
                          targetName,
                          stream: StreamKind.PULL_COMPLETE,
                          streamId,
                          success: true
                        });
                      }, function(reason) {
                        comObj.postMessage({
                          sourceName,
                          targetName,
                          stream: StreamKind.PULL_COMPLETE,
                          streamId,
                          reason: wrapReason(reason)
                        });
                      });
                      break;
                    case StreamKind.ENQUEUE:
                      (0, _util2.assert)(streamController, "enqueue should have stream controller");
                      if (streamController.isClosed) {
                        break;
                      }
                      streamController.controller.enqueue(data2.chunk);
                      break;
                    case StreamKind.CLOSE:
                      (0, _util2.assert)(streamController, "close should have stream controller");
                      if (streamController.isClosed) {
                        break;
                      }
                      streamController.isClosed = true;
                      streamController.controller.close();
                      this.#deleteStreamController(streamController, streamId);
                      break;
                    case StreamKind.ERROR:
                      (0, _util2.assert)(streamController, "error should have stream controller");
                      streamController.controller.error(wrapReason(data2.reason));
                      this.#deleteStreamController(streamController, streamId);
                      break;
                    case StreamKind.CANCEL_COMPLETE:
                      if (data2.success) {
                        streamController.cancelCall.resolve();
                      } else {
                        streamController.cancelCall.reject(wrapReason(data2.reason));
                      }
                      this.#deleteStreamController(streamController, streamId);
                      break;
                    case StreamKind.CANCEL:
                      if (!streamSink) {
                        break;
                      }
                      new Promise(function(resolve) {
                        resolve(streamSink.onCancel?.(wrapReason(data2.reason)));
                      }).then(function() {
                        comObj.postMessage({
                          sourceName,
                          targetName,
                          stream: StreamKind.CANCEL_COMPLETE,
                          streamId,
                          success: true
                        });
                      }, function(reason) {
                        comObj.postMessage({
                          sourceName,
                          targetName,
                          stream: StreamKind.CANCEL_COMPLETE,
                          streamId,
                          reason: wrapReason(reason)
                        });
                      });
                      streamSink.sinkCapability.reject(wrapReason(data2.reason));
                      streamSink.isCancelled = true;
                      delete this.streamSinks[streamId];
                      break;
                    default:
                      throw new Error("Unexpected stream case");
                  }
                }
                async #deleteStreamController(streamController, streamId) {
                  await Promise.allSettled([streamController.startCall?.promise, streamController.pullCall?.promise, streamController.cancelCall?.promise]);
                  delete this.streamControllers[streamId];
                }
                destroy() {
                  this.comObj.removeEventListener("message", this._onComObjOnMessage);
                }
              }
              exports2.MessageHandler = MessageHandler;
            }),
            /* 16 */
            /***/
            ((__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
              Object.defineProperty(exports2, "__esModule", {
                value: true
              });
              exports2.Metadata = void 0;
              var _util2 = __w_pdfjs_require__2(1);
              class Metadata {
                #metadataMap;
                #data;
                constructor({
                  parsedData,
                  rawData
                }) {
                  this.#metadataMap = parsedData;
                  this.#data = rawData;
                }
                getRaw() {
                  return this.#data;
                }
                get(name) {
                  return this.#metadataMap.get(name) ?? null;
                }
                getAll() {
                  return (0, _util2.objectFromMap)(this.#metadataMap);
                }
                has(name) {
                  return this.#metadataMap.has(name);
                }
              }
              exports2.Metadata = Metadata;
            }),
            /* 17 */
            /***/
            ((__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
              Object.defineProperty(exports2, "__esModule", {
                value: true
              });
              exports2.OptionalContentConfig = void 0;
              var _util2 = __w_pdfjs_require__2(1);
              var _murmurhash = __w_pdfjs_require__2(8);
              const INTERNAL = Symbol("INTERNAL");
              class OptionalContentGroup {
                #visible = true;
                constructor(name, intent) {
                  this.name = name;
                  this.intent = intent;
                }
                get visible() {
                  return this.#visible;
                }
                _setVisible(internal, visible) {
                  if (internal !== INTERNAL) {
                    (0, _util2.unreachable)("Internal method `_setVisible` called.");
                  }
                  this.#visible = visible;
                }
              }
              class OptionalContentConfig {
                #cachedGetHash = null;
                #groups = /* @__PURE__ */ new Map();
                #initialHash = null;
                #order = null;
                constructor(data2) {
                  this.name = null;
                  this.creator = null;
                  if (data2 === null) {
                    return;
                  }
                  this.name = data2.name;
                  this.creator = data2.creator;
                  this.#order = data2.order;
                  for (const group of data2.groups) {
                    this.#groups.set(group.id, new OptionalContentGroup(group.name, group.intent));
                  }
                  if (data2.baseState === "OFF") {
                    for (const group of this.#groups.values()) {
                      group._setVisible(INTERNAL, false);
                    }
                  }
                  for (const on of data2.on) {
                    this.#groups.get(on)._setVisible(INTERNAL, true);
                  }
                  for (const off of data2.off) {
                    this.#groups.get(off)._setVisible(INTERNAL, false);
                  }
                  this.#initialHash = this.getHash();
                }
                #evaluateVisibilityExpression(array4) {
                  const length2 = array4.length;
                  if (length2 < 2) {
                    return true;
                  }
                  const operator = array4[0];
                  for (let i = 1; i < length2; i++) {
                    const element = array4[i];
                    let state;
                    if (Array.isArray(element)) {
                      state = this.#evaluateVisibilityExpression(element);
                    } else if (this.#groups.has(element)) {
                      state = this.#groups.get(element).visible;
                    } else {
                      (0, _util2.warn)(`Optional content group not found: ${element}`);
                      return true;
                    }
                    switch (operator) {
                      case "And":
                        if (!state) {
                          return false;
                        }
                        break;
                      case "Or":
                        if (state) {
                          return true;
                        }
                        break;
                      case "Not":
                        return !state;
                      default:
                        return true;
                    }
                  }
                  return operator === "And";
                }
                isVisible(group) {
                  if (this.#groups.size === 0) {
                    return true;
                  }
                  if (!group) {
                    (0, _util2.warn)("Optional content group not defined.");
                    return true;
                  }
                  if (group.type === "OCG") {
                    if (!this.#groups.has(group.id)) {
                      (0, _util2.warn)(`Optional content group not found: ${group.id}`);
                      return true;
                    }
                    return this.#groups.get(group.id).visible;
                  } else if (group.type === "OCMD") {
                    if (group.expression) {
                      return this.#evaluateVisibilityExpression(group.expression);
                    }
                    if (!group.policy || group.policy === "AnyOn") {
                      for (const id of group.ids) {
                        if (!this.#groups.has(id)) {
                          (0, _util2.warn)(`Optional content group not found: ${id}`);
                          return true;
                        }
                        if (this.#groups.get(id).visible) {
                          return true;
                        }
                      }
                      return false;
                    } else if (group.policy === "AllOn") {
                      for (const id of group.ids) {
                        if (!this.#groups.has(id)) {
                          (0, _util2.warn)(`Optional content group not found: ${id}`);
                          return true;
                        }
                        if (!this.#groups.get(id).visible) {
                          return false;
                        }
                      }
                      return true;
                    } else if (group.policy === "AnyOff") {
                      for (const id of group.ids) {
                        if (!this.#groups.has(id)) {
                          (0, _util2.warn)(`Optional content group not found: ${id}`);
                          return true;
                        }
                        if (!this.#groups.get(id).visible) {
                          return true;
                        }
                      }
                      return false;
                    } else if (group.policy === "AllOff") {
                      for (const id of group.ids) {
                        if (!this.#groups.has(id)) {
                          (0, _util2.warn)(`Optional content group not found: ${id}`);
                          return true;
                        }
                        if (this.#groups.get(id).visible) {
                          return false;
                        }
                      }
                      return true;
                    }
                    (0, _util2.warn)(`Unknown optional content policy ${group.policy}.`);
                    return true;
                  }
                  (0, _util2.warn)(`Unknown group type ${group.type}.`);
                  return true;
                }
                setVisibility(id, visible = true) {
                  if (!this.#groups.has(id)) {
                    (0, _util2.warn)(`Optional content group not found: ${id}`);
                    return;
                  }
                  this.#groups.get(id)._setVisible(INTERNAL, !!visible);
                  this.#cachedGetHash = null;
                }
                get hasInitialVisibility() {
                  return this.#initialHash === null || this.getHash() === this.#initialHash;
                }
                getOrder() {
                  if (!this.#groups.size) {
                    return null;
                  }
                  if (this.#order) {
                    return this.#order.slice();
                  }
                  return [...this.#groups.keys()];
                }
                getGroups() {
                  return this.#groups.size > 0 ? (0, _util2.objectFromMap)(this.#groups) : null;
                }
                getGroup(id) {
                  return this.#groups.get(id) || null;
                }
                getHash() {
                  if (this.#cachedGetHash !== null) {
                    return this.#cachedGetHash;
                  }
                  const hash2 = new _murmurhash.MurmurHash3_64();
                  for (const [id, group] of this.#groups) {
                    hash2.update(`${id}:${group.visible}`);
                  }
                  return this.#cachedGetHash = hash2.hexdigest();
                }
              }
              exports2.OptionalContentConfig = OptionalContentConfig;
            }),
            /* 18 */
            /***/
            ((__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
              Object.defineProperty(exports2, "__esModule", {
                value: true
              });
              exports2.PDFDataTransportStream = void 0;
              var _util2 = __w_pdfjs_require__2(1);
              var _display_utils2 = __w_pdfjs_require__2(6);
              class PDFDataTransportStream {
                constructor({
                  length: length2,
                  initialData,
                  progressiveDone = false,
                  contentDispositionFilename = null,
                  disableRange = false,
                  disableStream = false
                }, pdfDataRangeTransport) {
                  (0, _util2.assert)(pdfDataRangeTransport, 'PDFDataTransportStream - missing required "pdfDataRangeTransport" argument.');
                  this._queuedChunks = [];
                  this._progressiveDone = progressiveDone;
                  this._contentDispositionFilename = contentDispositionFilename;
                  if (initialData?.length > 0) {
                    const buffer = initialData instanceof Uint8Array && initialData.byteLength === initialData.buffer.byteLength ? initialData.buffer : new Uint8Array(initialData).buffer;
                    this._queuedChunks.push(buffer);
                  }
                  this._pdfDataRangeTransport = pdfDataRangeTransport;
                  this._isStreamingSupported = !disableStream;
                  this._isRangeSupported = !disableRange;
                  this._contentLength = length2;
                  this._fullRequestReader = null;
                  this._rangeReaders = [];
                  this._pdfDataRangeTransport.addRangeListener((begin, chunk) => {
                    this._onReceiveData({
                      begin,
                      chunk
                    });
                  });
                  this._pdfDataRangeTransport.addProgressListener((loaded, total) => {
                    this._onProgress({
                      loaded,
                      total
                    });
                  });
                  this._pdfDataRangeTransport.addProgressiveReadListener((chunk) => {
                    this._onReceiveData({
                      chunk
                    });
                  });
                  this._pdfDataRangeTransport.addProgressiveDoneListener(() => {
                    this._onProgressiveDone();
                  });
                  this._pdfDataRangeTransport.transportReady();
                }
                _onReceiveData({
                  begin,
                  chunk
                }) {
                  const buffer = chunk instanceof Uint8Array && chunk.byteLength === chunk.buffer.byteLength ? chunk.buffer : new Uint8Array(chunk).buffer;
                  if (begin === void 0) {
                    if (this._fullRequestReader) {
                      this._fullRequestReader._enqueue(buffer);
                    } else {
                      this._queuedChunks.push(buffer);
                    }
                  } else {
                    const found = this._rangeReaders.some(function(rangeReader) {
                      if (rangeReader._begin !== begin) {
                        return false;
                      }
                      rangeReader._enqueue(buffer);
                      return true;
                    });
                    (0, _util2.assert)(found, "_onReceiveData - no `PDFDataTransportStreamRangeReader` instance found.");
                  }
                }
                get _progressiveDataLength() {
                  return this._fullRequestReader?._loaded ?? 0;
                }
                _onProgress(evt) {
                  if (evt.total === void 0) {
                    this._rangeReaders[0]?.onProgress?.({
                      loaded: evt.loaded
                    });
                  } else {
                    this._fullRequestReader?.onProgress?.({
                      loaded: evt.loaded,
                      total: evt.total
                    });
                  }
                }
                _onProgressiveDone() {
                  this._fullRequestReader?.progressiveDone();
                  this._progressiveDone = true;
                }
                _removeRangeReader(reader) {
                  const i = this._rangeReaders.indexOf(reader);
                  if (i >= 0) {
                    this._rangeReaders.splice(i, 1);
                  }
                }
                getFullReader() {
                  (0, _util2.assert)(!this._fullRequestReader, "PDFDataTransportStream.getFullReader can only be called once.");
                  const queuedChunks = this._queuedChunks;
                  this._queuedChunks = null;
                  return new PDFDataTransportStreamReader(this, queuedChunks, this._progressiveDone, this._contentDispositionFilename);
                }
                getRangeReader(begin, end) {
                  if (end <= this._progressiveDataLength) {
                    return null;
                  }
                  const reader = new PDFDataTransportStreamRangeReader(this, begin, end);
                  this._pdfDataRangeTransport.requestDataRange(begin, end);
                  this._rangeReaders.push(reader);
                  return reader;
                }
                cancelAllRequests(reason) {
                  this._fullRequestReader?.cancel(reason);
                  for (const reader of this._rangeReaders.slice(0)) {
                    reader.cancel(reason);
                  }
                  this._pdfDataRangeTransport.abort();
                }
              }
              exports2.PDFDataTransportStream = PDFDataTransportStream;
              class PDFDataTransportStreamReader {
                constructor(stream, queuedChunks, progressiveDone = false, contentDispositionFilename = null) {
                  this._stream = stream;
                  this._done = progressiveDone || false;
                  this._filename = (0, _display_utils2.isPdfFile)(contentDispositionFilename) ? contentDispositionFilename : null;
                  this._queuedChunks = queuedChunks || [];
                  this._loaded = 0;
                  for (const chunk of this._queuedChunks) {
                    this._loaded += chunk.byteLength;
                  }
                  this._requests = [];
                  this._headersReady = Promise.resolve();
                  stream._fullRequestReader = this;
                  this.onProgress = null;
                }
                _enqueue(chunk) {
                  if (this._done) {
                    return;
                  }
                  if (this._requests.length > 0) {
                    const requestCapability = this._requests.shift();
                    requestCapability.resolve({
                      value: chunk,
                      done: false
                    });
                  } else {
                    this._queuedChunks.push(chunk);
                  }
                  this._loaded += chunk.byteLength;
                }
                get headersReady() {
                  return this._headersReady;
                }
                get filename() {
                  return this._filename;
                }
                get isRangeSupported() {
                  return this._stream._isRangeSupported;
                }
                get isStreamingSupported() {
                  return this._stream._isStreamingSupported;
                }
                get contentLength() {
                  return this._stream._contentLength;
                }
                async read() {
                  if (this._queuedChunks.length > 0) {
                    const chunk = this._queuedChunks.shift();
                    return {
                      value: chunk,
                      done: false
                    };
                  }
                  if (this._done) {
                    return {
                      value: void 0,
                      done: true
                    };
                  }
                  const requestCapability = new _util2.PromiseCapability();
                  this._requests.push(requestCapability);
                  return requestCapability.promise;
                }
                cancel(reason) {
                  this._done = true;
                  for (const requestCapability of this._requests) {
                    requestCapability.resolve({
                      value: void 0,
                      done: true
                    });
                  }
                  this._requests.length = 0;
                }
                progressiveDone() {
                  if (this._done) {
                    return;
                  }
                  this._done = true;
                }
              }
              class PDFDataTransportStreamRangeReader {
                constructor(stream, begin, end) {
                  this._stream = stream;
                  this._begin = begin;
                  this._end = end;
                  this._queuedChunk = null;
                  this._requests = [];
                  this._done = false;
                  this.onProgress = null;
                }
                _enqueue(chunk) {
                  if (this._done) {
                    return;
                  }
                  if (this._requests.length === 0) {
                    this._queuedChunk = chunk;
                  } else {
                    const requestsCapability = this._requests.shift();
                    requestsCapability.resolve({
                      value: chunk,
                      done: false
                    });
                    for (const requestCapability of this._requests) {
                      requestCapability.resolve({
                        value: void 0,
                        done: true
                      });
                    }
                    this._requests.length = 0;
                  }
                  this._done = true;
                  this._stream._removeRangeReader(this);
                }
                get isStreamingSupported() {
                  return false;
                }
                async read() {
                  if (this._queuedChunk) {
                    const chunk = this._queuedChunk;
                    this._queuedChunk = null;
                    return {
                      value: chunk,
                      done: false
                    };
                  }
                  if (this._done) {
                    return {
                      value: void 0,
                      done: true
                    };
                  }
                  const requestCapability = new _util2.PromiseCapability();
                  this._requests.push(requestCapability);
                  return requestCapability.promise;
                }
                cancel(reason) {
                  this._done = true;
                  for (const requestCapability of this._requests) {
                    requestCapability.resolve({
                      value: void 0,
                      done: true
                    });
                  }
                  this._requests.length = 0;
                  this._stream._removeRangeReader(this);
                }
              }
            }),
            /* 19 */
            /***/
            ((__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
              Object.defineProperty(exports2, "__esModule", {
                value: true
              });
              exports2.PDFFetchStream = void 0;
              var _util2 = __w_pdfjs_require__2(1);
              var _network_utils = __w_pdfjs_require__2(20);
              ;
              function createFetchOptions(headers, withCredentials, abortController) {
                return {
                  method: "GET",
                  headers,
                  signal: abortController.signal,
                  mode: "cors",
                  credentials: withCredentials ? "include" : "same-origin",
                  redirect: "follow"
                };
              }
              function createHeaders(httpHeaders) {
                const headers = new Headers();
                for (const property2 in httpHeaders) {
                  const value = httpHeaders[property2];
                  if (value === void 0) {
                    continue;
                  }
                  headers.append(property2, value);
                }
                return headers;
              }
              function getArrayBuffer(val) {
                if (val instanceof Uint8Array) {
                  return val.buffer;
                }
                if (val instanceof ArrayBuffer) {
                  return val;
                }
                (0, _util2.warn)(`getArrayBuffer - unexpected data format: ${val}`);
                return new Uint8Array(val).buffer;
              }
              class PDFFetchStream {
                constructor(source) {
                  this.source = source;
                  this.isHttp = /^https?:/i.test(source.url);
                  this.httpHeaders = this.isHttp && source.httpHeaders || {};
                  this._fullRequestReader = null;
                  this._rangeRequestReaders = [];
                }
                get _progressiveDataLength() {
                  return this._fullRequestReader?._loaded ?? 0;
                }
                getFullReader() {
                  (0, _util2.assert)(!this._fullRequestReader, "PDFFetchStream.getFullReader can only be called once.");
                  this._fullRequestReader = new PDFFetchStreamReader(this);
                  return this._fullRequestReader;
                }
                getRangeReader(begin, end) {
                  if (end <= this._progressiveDataLength) {
                    return null;
                  }
                  const reader = new PDFFetchStreamRangeReader(this, begin, end);
                  this._rangeRequestReaders.push(reader);
                  return reader;
                }
                cancelAllRequests(reason) {
                  this._fullRequestReader?.cancel(reason);
                  for (const reader of this._rangeRequestReaders.slice(0)) {
                    reader.cancel(reason);
                  }
                }
              }
              exports2.PDFFetchStream = PDFFetchStream;
              class PDFFetchStreamReader {
                constructor(stream) {
                  this._stream = stream;
                  this._reader = null;
                  this._loaded = 0;
                  this._filename = null;
                  const source = stream.source;
                  this._withCredentials = source.withCredentials || false;
                  this._contentLength = source.length;
                  this._headersCapability = new _util2.PromiseCapability();
                  this._disableRange = source.disableRange || false;
                  this._rangeChunkSize = source.rangeChunkSize;
                  if (!this._rangeChunkSize && !this._disableRange) {
                    this._disableRange = true;
                  }
                  this._abortController = new AbortController();
                  this._isStreamingSupported = !source.disableStream;
                  this._isRangeSupported = !source.disableRange;
                  this._headers = createHeaders(this._stream.httpHeaders);
                  const url2 = source.url;
                  fetch(url2, createFetchOptions(this._headers, this._withCredentials, this._abortController)).then((response) => {
                    if (!(0, _network_utils.validateResponseStatus)(response.status)) {
                      throw (0, _network_utils.createResponseStatusError)(response.status, url2);
                    }
                    this._reader = response.body.getReader();
                    this._headersCapability.resolve();
                    const getResponseHeader = (name) => {
                      return response.headers.get(name);
                    };
                    const {
                      allowRangeRequests,
                      suggestedLength
                    } = (0, _network_utils.validateRangeRequestCapabilities)({
                      getResponseHeader,
                      isHttp: this._stream.isHttp,
                      rangeChunkSize: this._rangeChunkSize,
                      disableRange: this._disableRange
                    });
                    this._isRangeSupported = allowRangeRequests;
                    this._contentLength = suggestedLength || this._contentLength;
                    this._filename = (0, _network_utils.extractFilenameFromHeader)(getResponseHeader);
                    if (!this._isStreamingSupported && this._isRangeSupported) {
                      this.cancel(new _util2.AbortException("Streaming is disabled."));
                    }
                  }).catch(this._headersCapability.reject);
                  this.onProgress = null;
                }
                get headersReady() {
                  return this._headersCapability.promise;
                }
                get filename() {
                  return this._filename;
                }
                get contentLength() {
                  return this._contentLength;
                }
                get isRangeSupported() {
                  return this._isRangeSupported;
                }
                get isStreamingSupported() {
                  return this._isStreamingSupported;
                }
                async read() {
                  await this._headersCapability.promise;
                  const {
                    value,
                    done
                  } = await this._reader.read();
                  if (done) {
                    return {
                      value,
                      done
                    };
                  }
                  this._loaded += value.byteLength;
                  this.onProgress?.({
                    loaded: this._loaded,
                    total: this._contentLength
                  });
                  return {
                    value: getArrayBuffer(value),
                    done: false
                  };
                }
                cancel(reason) {
                  this._reader?.cancel(reason);
                  this._abortController.abort();
                }
              }
              class PDFFetchStreamRangeReader {
                constructor(stream, begin, end) {
                  this._stream = stream;
                  this._reader = null;
                  this._loaded = 0;
                  const source = stream.source;
                  this._withCredentials = source.withCredentials || false;
                  this._readCapability = new _util2.PromiseCapability();
                  this._isStreamingSupported = !source.disableStream;
                  this._abortController = new AbortController();
                  this._headers = createHeaders(this._stream.httpHeaders);
                  this._headers.append("Range", `bytes=${begin}-${end - 1}`);
                  const url2 = source.url;
                  fetch(url2, createFetchOptions(this._headers, this._withCredentials, this._abortController)).then((response) => {
                    if (!(0, _network_utils.validateResponseStatus)(response.status)) {
                      throw (0, _network_utils.createResponseStatusError)(response.status, url2);
                    }
                    this._readCapability.resolve();
                    this._reader = response.body.getReader();
                  }).catch(this._readCapability.reject);
                  this.onProgress = null;
                }
                get isStreamingSupported() {
                  return this._isStreamingSupported;
                }
                async read() {
                  await this._readCapability.promise;
                  const {
                    value,
                    done
                  } = await this._reader.read();
                  if (done) {
                    return {
                      value,
                      done
                    };
                  }
                  this._loaded += value.byteLength;
                  this.onProgress?.({
                    loaded: this._loaded
                  });
                  return {
                    value: getArrayBuffer(value),
                    done: false
                  };
                }
                cancel(reason) {
                  this._reader?.cancel(reason);
                  this._abortController.abort();
                }
              }
            }),
            /* 20 */
            /***/
            ((__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
              Object.defineProperty(exports2, "__esModule", {
                value: true
              });
              exports2.createResponseStatusError = createResponseStatusError;
              exports2.extractFilenameFromHeader = extractFilenameFromHeader;
              exports2.validateRangeRequestCapabilities = validateRangeRequestCapabilities;
              exports2.validateResponseStatus = validateResponseStatus;
              var _util2 = __w_pdfjs_require__2(1);
              var _content_disposition = __w_pdfjs_require__2(21);
              var _display_utils2 = __w_pdfjs_require__2(6);
              function validateRangeRequestCapabilities({
                getResponseHeader,
                isHttp,
                rangeChunkSize,
                disableRange
              }) {
                const returnValues = {
                  allowRangeRequests: false,
                  suggestedLength: void 0
                };
                const length2 = parseInt(getResponseHeader("Content-Length"), 10);
                if (!Number.isInteger(length2)) {
                  return returnValues;
                }
                returnValues.suggestedLength = length2;
                if (length2 <= 2 * rangeChunkSize) {
                  return returnValues;
                }
                if (disableRange || !isHttp) {
                  return returnValues;
                }
                if (getResponseHeader("Accept-Ranges") !== "bytes") {
                  return returnValues;
                }
                const contentEncoding = getResponseHeader("Content-Encoding") || "identity";
                if (contentEncoding !== "identity") {
                  return returnValues;
                }
                returnValues.allowRangeRequests = true;
                return returnValues;
              }
              function extractFilenameFromHeader(getResponseHeader) {
                const contentDisposition = getResponseHeader("Content-Disposition");
                if (contentDisposition) {
                  let filename = (0, _content_disposition.getFilenameFromContentDispositionHeader)(contentDisposition);
                  if (filename.includes("%")) {
                    try {
                      filename = decodeURIComponent(filename);
                    } catch {
                    }
                  }
                  if ((0, _display_utils2.isPdfFile)(filename)) {
                    return filename;
                  }
                }
                return null;
              }
              function createResponseStatusError(status, url2) {
                if (status === 404 || status === 0 && url2.startsWith("file:")) {
                  return new _util2.MissingPDFException('Missing PDF "' + url2 + '".');
                }
                return new _util2.UnexpectedResponseException(`Unexpected server response (${status}) while retrieving PDF "${url2}".`, status);
              }
              function validateResponseStatus(status) {
                return status === 200 || status === 206;
              }
            }),
            /* 21 */
            /***/
            ((__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
              Object.defineProperty(exports2, "__esModule", {
                value: true
              });
              exports2.getFilenameFromContentDispositionHeader = getFilenameFromContentDispositionHeader;
              var _util2 = __w_pdfjs_require__2(1);
              function getFilenameFromContentDispositionHeader(contentDisposition) {
                let needsEncodingFixup = true;
                let tmp = toParamRegExp("filename\\*", "i").exec(contentDisposition);
                if (tmp) {
                  tmp = tmp[1];
                  let filename = rfc2616unquote(tmp);
                  filename = unescape(filename);
                  filename = rfc5987decode(filename);
                  filename = rfc2047decode(filename);
                  return fixupEncoding(filename);
                }
                tmp = rfc2231getparam(contentDisposition);
                if (tmp) {
                  const filename = rfc2047decode(tmp);
                  return fixupEncoding(filename);
                }
                tmp = toParamRegExp("filename", "i").exec(contentDisposition);
                if (tmp) {
                  tmp = tmp[1];
                  let filename = rfc2616unquote(tmp);
                  filename = rfc2047decode(filename);
                  return fixupEncoding(filename);
                }
                function toParamRegExp(attributePattern, flags) {
                  return new RegExp("(?:^|;)\\s*" + attributePattern + '\\s*=\\s*([^";\\s][^;\\s]*|"(?:[^"\\\\]|\\\\"?)+"?)', flags);
                }
                function textdecode(encoding, value) {
                  if (encoding) {
                    if (!/^[\x00-\xFF]+$/.test(value)) {
                      return value;
                    }
                    try {
                      const decoder = new TextDecoder(encoding, {
                        fatal: true
                      });
                      const buffer = (0, _util2.stringToBytes)(value);
                      value = decoder.decode(buffer);
                      needsEncodingFixup = false;
                    } catch {
                    }
                  }
                  return value;
                }
                function fixupEncoding(value) {
                  if (needsEncodingFixup && /[\x80-\xff]/.test(value)) {
                    value = textdecode("utf-8", value);
                    if (needsEncodingFixup) {
                      value = textdecode("iso-8859-1", value);
                    }
                  }
                  return value;
                }
                function rfc2231getparam(contentDispositionStr) {
                  const matches = [];
                  let match2;
                  const iter = toParamRegExp("filename\\*((?!0\\d)\\d+)(\\*?)", "ig");
                  while ((match2 = iter.exec(contentDispositionStr)) !== null) {
                    let [, n2, quot, part] = match2;
                    n2 = parseInt(n2, 10);
                    if (n2 in matches) {
                      if (n2 === 0) {
                        break;
                      }
                      continue;
                    }
                    matches[n2] = [quot, part];
                  }
                  const parts = [];
                  for (let n2 = 0; n2 < matches.length; ++n2) {
                    if (!(n2 in matches)) {
                      break;
                    }
                    let [quot, part] = matches[n2];
                    part = rfc2616unquote(part);
                    if (quot) {
                      part = unescape(part);
                      if (n2 === 0) {
                        part = rfc5987decode(part);
                      }
                    }
                    parts.push(part);
                  }
                  return parts.join("");
                }
                function rfc2616unquote(value) {
                  if (value.startsWith('"')) {
                    const parts = value.slice(1).split('\\"');
                    for (let i = 0; i < parts.length; ++i) {
                      const quotindex = parts[i].indexOf('"');
                      if (quotindex !== -1) {
                        parts[i] = parts[i].slice(0, quotindex);
                        parts.length = i + 1;
                      }
                      parts[i] = parts[i].replaceAll(/\\(.)/g, "$1");
                    }
                    value = parts.join('"');
                  }
                  return value;
                }
                function rfc5987decode(extvalue) {
                  const encodingend = extvalue.indexOf("'");
                  if (encodingend === -1) {
                    return extvalue;
                  }
                  const encoding = extvalue.slice(0, encodingend);
                  const langvalue = extvalue.slice(encodingend + 1);
                  const value = langvalue.replace(/^[^']*'/, "");
                  return textdecode(encoding, value);
                }
                function rfc2047decode(value) {
                  if (!value.startsWith("=?") || /[\x00-\x19\x80-\xff]/.test(value)) {
                    return value;
                  }
                  return value.replaceAll(/=\?([\w-]*)\?([QqBb])\?((?:[^?]|\?(?!=))*)\?=/g, function(matches, charset, encoding, text) {
                    if (encoding === "q" || encoding === "Q") {
                      text = text.replaceAll("_", " ");
                      text = text.replaceAll(/=([0-9a-fA-F]{2})/g, function(match2, hex2) {
                        return String.fromCharCode(parseInt(hex2, 16));
                      });
                      return textdecode(charset, text);
                    }
                    try {
                      text = atob(text);
                    } catch {
                    }
                    return textdecode(charset, text);
                  });
                }
                return "";
              }
            }),
            /* 22 */
            /***/
            ((__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
              Object.defineProperty(exports2, "__esModule", {
                value: true
              });
              exports2.PDFNetworkStream = void 0;
              var _util2 = __w_pdfjs_require__2(1);
              var _network_utils = __w_pdfjs_require__2(20);
              ;
              const OK_RESPONSE = 200;
              const PARTIAL_CONTENT_RESPONSE = 206;
              function getArrayBuffer(xhr) {
                const data2 = xhr.response;
                if (typeof data2 !== "string") {
                  return data2;
                }
                return (0, _util2.stringToBytes)(data2).buffer;
              }
              class NetworkManager {
                constructor(url2, args = {}) {
                  this.url = url2;
                  this.isHttp = /^https?:/i.test(url2);
                  this.httpHeaders = this.isHttp && args.httpHeaders || /* @__PURE__ */ Object.create(null);
                  this.withCredentials = args.withCredentials || false;
                  this.currXhrId = 0;
                  this.pendingRequests = /* @__PURE__ */ Object.create(null);
                }
                requestRange(begin, end, listeners) {
                  const args = {
                    begin,
                    end
                  };
                  for (const prop in listeners) {
                    args[prop] = listeners[prop];
                  }
                  return this.request(args);
                }
                requestFull(listeners) {
                  return this.request(listeners);
                }
                request(args) {
                  const xhr = new XMLHttpRequest();
                  const xhrId = this.currXhrId++;
                  const pendingRequest = this.pendingRequests[xhrId] = {
                    xhr
                  };
                  xhr.open("GET", this.url);
                  xhr.withCredentials = this.withCredentials;
                  for (const property2 in this.httpHeaders) {
                    const value = this.httpHeaders[property2];
                    if (value === void 0) {
                      continue;
                    }
                    xhr.setRequestHeader(property2, value);
                  }
                  if (this.isHttp && "begin" in args && "end" in args) {
                    xhr.setRequestHeader("Range", `bytes=${args.begin}-${args.end - 1}`);
                    pendingRequest.expectedStatus = PARTIAL_CONTENT_RESPONSE;
                  } else {
                    pendingRequest.expectedStatus = OK_RESPONSE;
                  }
                  xhr.responseType = "arraybuffer";
                  if (args.onError) {
                    xhr.onerror = function(evt) {
                      args.onError(xhr.status);
                    };
                  }
                  xhr.onreadystatechange = this.onStateChange.bind(this, xhrId);
                  xhr.onprogress = this.onProgress.bind(this, xhrId);
                  pendingRequest.onHeadersReceived = args.onHeadersReceived;
                  pendingRequest.onDone = args.onDone;
                  pendingRequest.onError = args.onError;
                  pendingRequest.onProgress = args.onProgress;
                  xhr.send(null);
                  return xhrId;
                }
                onProgress(xhrId, evt) {
                  const pendingRequest = this.pendingRequests[xhrId];
                  if (!pendingRequest) {
                    return;
                  }
                  pendingRequest.onProgress?.(evt);
                }
                onStateChange(xhrId, evt) {
                  const pendingRequest = this.pendingRequests[xhrId];
                  if (!pendingRequest) {
                    return;
                  }
                  const xhr = pendingRequest.xhr;
                  if (xhr.readyState >= 2 && pendingRequest.onHeadersReceived) {
                    pendingRequest.onHeadersReceived();
                    delete pendingRequest.onHeadersReceived;
                  }
                  if (xhr.readyState !== 4) {
                    return;
                  }
                  if (!(xhrId in this.pendingRequests)) {
                    return;
                  }
                  delete this.pendingRequests[xhrId];
                  if (xhr.status === 0 && this.isHttp) {
                    pendingRequest.onError?.(xhr.status);
                    return;
                  }
                  const xhrStatus = xhr.status || OK_RESPONSE;
                  const ok_response_on_range_request = xhrStatus === OK_RESPONSE && pendingRequest.expectedStatus === PARTIAL_CONTENT_RESPONSE;
                  if (!ok_response_on_range_request && xhrStatus !== pendingRequest.expectedStatus) {
                    pendingRequest.onError?.(xhr.status);
                    return;
                  }
                  const chunk = getArrayBuffer(xhr);
                  if (xhrStatus === PARTIAL_CONTENT_RESPONSE) {
                    const rangeHeader = xhr.getResponseHeader("Content-Range");
                    const matches = /bytes (\d+)-(\d+)\/(\d+)/.exec(rangeHeader);
                    pendingRequest.onDone({
                      begin: parseInt(matches[1], 10),
                      chunk
                    });
                  } else if (chunk) {
                    pendingRequest.onDone({
                      begin: 0,
                      chunk
                    });
                  } else {
                    pendingRequest.onError?.(xhr.status);
                  }
                }
                getRequestXhr(xhrId) {
                  return this.pendingRequests[xhrId].xhr;
                }
                isPendingRequest(xhrId) {
                  return xhrId in this.pendingRequests;
                }
                abortRequest(xhrId) {
                  const xhr = this.pendingRequests[xhrId].xhr;
                  delete this.pendingRequests[xhrId];
                  xhr.abort();
                }
              }
              class PDFNetworkStream {
                constructor(source) {
                  this._source = source;
                  this._manager = new NetworkManager(source.url, {
                    httpHeaders: source.httpHeaders,
                    withCredentials: source.withCredentials
                  });
                  this._rangeChunkSize = source.rangeChunkSize;
                  this._fullRequestReader = null;
                  this._rangeRequestReaders = [];
                }
                _onRangeRequestReaderClosed(reader) {
                  const i = this._rangeRequestReaders.indexOf(reader);
                  if (i >= 0) {
                    this._rangeRequestReaders.splice(i, 1);
                  }
                }
                getFullReader() {
                  (0, _util2.assert)(!this._fullRequestReader, "PDFNetworkStream.getFullReader can only be called once.");
                  this._fullRequestReader = new PDFNetworkStreamFullRequestReader(this._manager, this._source);
                  return this._fullRequestReader;
                }
                getRangeReader(begin, end) {
                  const reader = new PDFNetworkStreamRangeRequestReader(this._manager, begin, end);
                  reader.onClosed = this._onRangeRequestReaderClosed.bind(this);
                  this._rangeRequestReaders.push(reader);
                  return reader;
                }
                cancelAllRequests(reason) {
                  this._fullRequestReader?.cancel(reason);
                  for (const reader of this._rangeRequestReaders.slice(0)) {
                    reader.cancel(reason);
                  }
                }
              }
              exports2.PDFNetworkStream = PDFNetworkStream;
              class PDFNetworkStreamFullRequestReader {
                constructor(manager, source) {
                  this._manager = manager;
                  const args = {
                    onHeadersReceived: this._onHeadersReceived.bind(this),
                    onDone: this._onDone.bind(this),
                    onError: this._onError.bind(this),
                    onProgress: this._onProgress.bind(this)
                  };
                  this._url = source.url;
                  this._fullRequestId = manager.requestFull(args);
                  this._headersReceivedCapability = new _util2.PromiseCapability();
                  this._disableRange = source.disableRange || false;
                  this._contentLength = source.length;
                  this._rangeChunkSize = source.rangeChunkSize;
                  if (!this._rangeChunkSize && !this._disableRange) {
                    this._disableRange = true;
                  }
                  this._isStreamingSupported = false;
                  this._isRangeSupported = false;
                  this._cachedChunks = [];
                  this._requests = [];
                  this._done = false;
                  this._storedError = void 0;
                  this._filename = null;
                  this.onProgress = null;
                }
                _onHeadersReceived() {
                  const fullRequestXhrId = this._fullRequestId;
                  const fullRequestXhr = this._manager.getRequestXhr(fullRequestXhrId);
                  const getResponseHeader = (name) => {
                    return fullRequestXhr.getResponseHeader(name);
                  };
                  const {
                    allowRangeRequests,
                    suggestedLength
                  } = (0, _network_utils.validateRangeRequestCapabilities)({
                    getResponseHeader,
                    isHttp: this._manager.isHttp,
                    rangeChunkSize: this._rangeChunkSize,
                    disableRange: this._disableRange
                  });
                  if (allowRangeRequests) {
                    this._isRangeSupported = true;
                  }
                  this._contentLength = suggestedLength || this._contentLength;
                  this._filename = (0, _network_utils.extractFilenameFromHeader)(getResponseHeader);
                  if (this._isRangeSupported) {
                    this._manager.abortRequest(fullRequestXhrId);
                  }
                  this._headersReceivedCapability.resolve();
                }
                _onDone(data2) {
                  if (data2) {
                    if (this._requests.length > 0) {
                      const requestCapability = this._requests.shift();
                      requestCapability.resolve({
                        value: data2.chunk,
                        done: false
                      });
                    } else {
                      this._cachedChunks.push(data2.chunk);
                    }
                  }
                  this._done = true;
                  if (this._cachedChunks.length > 0) {
                    return;
                  }
                  for (const requestCapability of this._requests) {
                    requestCapability.resolve({
                      value: void 0,
                      done: true
                    });
                  }
                  this._requests.length = 0;
                }
                _onError(status) {
                  this._storedError = (0, _network_utils.createResponseStatusError)(status, this._url);
                  this._headersReceivedCapability.reject(this._storedError);
                  for (const requestCapability of this._requests) {
                    requestCapability.reject(this._storedError);
                  }
                  this._requests.length = 0;
                  this._cachedChunks.length = 0;
                }
                _onProgress(evt) {
                  this.onProgress?.({
                    loaded: evt.loaded,
                    total: evt.lengthComputable ? evt.total : this._contentLength
                  });
                }
                get filename() {
                  return this._filename;
                }
                get isRangeSupported() {
                  return this._isRangeSupported;
                }
                get isStreamingSupported() {
                  return this._isStreamingSupported;
                }
                get contentLength() {
                  return this._contentLength;
                }
                get headersReady() {
                  return this._headersReceivedCapability.promise;
                }
                async read() {
                  if (this._storedError) {
                    throw this._storedError;
                  }
                  if (this._cachedChunks.length > 0) {
                    const chunk = this._cachedChunks.shift();
                    return {
                      value: chunk,
                      done: false
                    };
                  }
                  if (this._done) {
                    return {
                      value: void 0,
                      done: true
                    };
                  }
                  const requestCapability = new _util2.PromiseCapability();
                  this._requests.push(requestCapability);
                  return requestCapability.promise;
                }
                cancel(reason) {
                  this._done = true;
                  this._headersReceivedCapability.reject(reason);
                  for (const requestCapability of this._requests) {
                    requestCapability.resolve({
                      value: void 0,
                      done: true
                    });
                  }
                  this._requests.length = 0;
                  if (this._manager.isPendingRequest(this._fullRequestId)) {
                    this._manager.abortRequest(this._fullRequestId);
                  }
                  this._fullRequestReader = null;
                }
              }
              class PDFNetworkStreamRangeRequestReader {
                constructor(manager, begin, end) {
                  this._manager = manager;
                  const args = {
                    onDone: this._onDone.bind(this),
                    onError: this._onError.bind(this),
                    onProgress: this._onProgress.bind(this)
                  };
                  this._url = manager.url;
                  this._requestId = manager.requestRange(begin, end, args);
                  this._requests = [];
                  this._queuedChunk = null;
                  this._done = false;
                  this._storedError = void 0;
                  this.onProgress = null;
                  this.onClosed = null;
                }
                _close() {
                  this.onClosed?.(this);
                }
                _onDone(data2) {
                  const chunk = data2.chunk;
                  if (this._requests.length > 0) {
                    const requestCapability = this._requests.shift();
                    requestCapability.resolve({
                      value: chunk,
                      done: false
                    });
                  } else {
                    this._queuedChunk = chunk;
                  }
                  this._done = true;
                  for (const requestCapability of this._requests) {
                    requestCapability.resolve({
                      value: void 0,
                      done: true
                    });
                  }
                  this._requests.length = 0;
                  this._close();
                }
                _onError(status) {
                  this._storedError = (0, _network_utils.createResponseStatusError)(status, this._url);
                  for (const requestCapability of this._requests) {
                    requestCapability.reject(this._storedError);
                  }
                  this._requests.length = 0;
                  this._queuedChunk = null;
                }
                _onProgress(evt) {
                  if (!this.isStreamingSupported) {
                    this.onProgress?.({
                      loaded: evt.loaded
                    });
                  }
                }
                get isStreamingSupported() {
                  return false;
                }
                async read() {
                  if (this._storedError) {
                    throw this._storedError;
                  }
                  if (this._queuedChunk !== null) {
                    const chunk = this._queuedChunk;
                    this._queuedChunk = null;
                    return {
                      value: chunk,
                      done: false
                    };
                  }
                  if (this._done) {
                    return {
                      value: void 0,
                      done: true
                    };
                  }
                  const requestCapability = new _util2.PromiseCapability();
                  this._requests.push(requestCapability);
                  return requestCapability.promise;
                }
                cancel(reason) {
                  this._done = true;
                  for (const requestCapability of this._requests) {
                    requestCapability.resolve({
                      value: void 0,
                      done: true
                    });
                  }
                  this._requests.length = 0;
                  if (this._manager.isPendingRequest(this._requestId)) {
                    this._manager.abortRequest(this._requestId);
                  }
                  this._close();
                }
              }
            }),
            /* 23 */
            /***/
            ((__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
              Object.defineProperty(exports2, "__esModule", {
                value: true
              });
              exports2.PDFNodeStream = void 0;
              var _util2 = __w_pdfjs_require__2(1);
              var _network_utils = __w_pdfjs_require__2(20);
              ;
              const fileUriRegex = /^file:\/\/\/[a-zA-Z]:\//;
              function parseUrl(sourceUrl) {
                const url2 = require_url();
                const parsedUrl = url2.parse(sourceUrl);
                if (parsedUrl.protocol === "file:" || parsedUrl.host) {
                  return parsedUrl;
                }
                if (/^[a-z]:[/\\]/i.test(sourceUrl)) {
                  return url2.parse(`file:///${sourceUrl}`);
                }
                if (!parsedUrl.host) {
                  parsedUrl.protocol = "file:";
                }
                return parsedUrl;
              }
              class PDFNodeStream {
                constructor(source) {
                  this.source = source;
                  this.url = parseUrl(source.url);
                  this.isHttp = this.url.protocol === "http:" || this.url.protocol === "https:";
                  this.isFsUrl = this.url.protocol === "file:";
                  this.httpHeaders = this.isHttp && source.httpHeaders || {};
                  this._fullRequestReader = null;
                  this._rangeRequestReaders = [];
                }
                get _progressiveDataLength() {
                  return this._fullRequestReader?._loaded ?? 0;
                }
                getFullReader() {
                  (0, _util2.assert)(!this._fullRequestReader, "PDFNodeStream.getFullReader can only be called once.");
                  this._fullRequestReader = this.isFsUrl ? new PDFNodeStreamFsFullReader(this) : new PDFNodeStreamFullReader(this);
                  return this._fullRequestReader;
                }
                getRangeReader(start, end) {
                  if (end <= this._progressiveDataLength) {
                    return null;
                  }
                  const rangeReader = this.isFsUrl ? new PDFNodeStreamFsRangeReader(this, start, end) : new PDFNodeStreamRangeReader(this, start, end);
                  this._rangeRequestReaders.push(rangeReader);
                  return rangeReader;
                }
                cancelAllRequests(reason) {
                  this._fullRequestReader?.cancel(reason);
                  for (const reader of this._rangeRequestReaders.slice(0)) {
                    reader.cancel(reason);
                  }
                }
              }
              exports2.PDFNodeStream = PDFNodeStream;
              class BaseFullReader {
                constructor(stream) {
                  this._url = stream.url;
                  this._done = false;
                  this._storedError = null;
                  this.onProgress = null;
                  const source = stream.source;
                  this._contentLength = source.length;
                  this._loaded = 0;
                  this._filename = null;
                  this._disableRange = source.disableRange || false;
                  this._rangeChunkSize = source.rangeChunkSize;
                  if (!this._rangeChunkSize && !this._disableRange) {
                    this._disableRange = true;
                  }
                  this._isStreamingSupported = !source.disableStream;
                  this._isRangeSupported = !source.disableRange;
                  this._readableStream = null;
                  this._readCapability = new _util2.PromiseCapability();
                  this._headersCapability = new _util2.PromiseCapability();
                }
                get headersReady() {
                  return this._headersCapability.promise;
                }
                get filename() {
                  return this._filename;
                }
                get contentLength() {
                  return this._contentLength;
                }
                get isRangeSupported() {
                  return this._isRangeSupported;
                }
                get isStreamingSupported() {
                  return this._isStreamingSupported;
                }
                async read() {
                  await this._readCapability.promise;
                  if (this._done) {
                    return {
                      value: void 0,
                      done: true
                    };
                  }
                  if (this._storedError) {
                    throw this._storedError;
                  }
                  const chunk = this._readableStream.read();
                  if (chunk === null) {
                    this._readCapability = new _util2.PromiseCapability();
                    return this.read();
                  }
                  this._loaded += chunk.length;
                  this.onProgress?.({
                    loaded: this._loaded,
                    total: this._contentLength
                  });
                  const buffer = new Uint8Array(chunk).buffer;
                  return {
                    value: buffer,
                    done: false
                  };
                }
                cancel(reason) {
                  if (!this._readableStream) {
                    this._error(reason);
                    return;
                  }
                  this._readableStream.destroy(reason);
                }
                _error(reason) {
                  this._storedError = reason;
                  this._readCapability.resolve();
                }
                _setReadableStream(readableStream) {
                  this._readableStream = readableStream;
                  readableStream.on("readable", () => {
                    this._readCapability.resolve();
                  });
                  readableStream.on("end", () => {
                    readableStream.destroy();
                    this._done = true;
                    this._readCapability.resolve();
                  });
                  readableStream.on("error", (reason) => {
                    this._error(reason);
                  });
                  if (!this._isStreamingSupported && this._isRangeSupported) {
                    this._error(new _util2.AbortException("streaming is disabled"));
                  }
                  if (this._storedError) {
                    this._readableStream.destroy(this._storedError);
                  }
                }
              }
              class BaseRangeReader {
                constructor(stream) {
                  this._url = stream.url;
                  this._done = false;
                  this._storedError = null;
                  this.onProgress = null;
                  this._loaded = 0;
                  this._readableStream = null;
                  this._readCapability = new _util2.PromiseCapability();
                  const source = stream.source;
                  this._isStreamingSupported = !source.disableStream;
                }
                get isStreamingSupported() {
                  return this._isStreamingSupported;
                }
                async read() {
                  await this._readCapability.promise;
                  if (this._done) {
                    return {
                      value: void 0,
                      done: true
                    };
                  }
                  if (this._storedError) {
                    throw this._storedError;
                  }
                  const chunk = this._readableStream.read();
                  if (chunk === null) {
                    this._readCapability = new _util2.PromiseCapability();
                    return this.read();
                  }
                  this._loaded += chunk.length;
                  this.onProgress?.({
                    loaded: this._loaded
                  });
                  const buffer = new Uint8Array(chunk).buffer;
                  return {
                    value: buffer,
                    done: false
                  };
                }
                cancel(reason) {
                  if (!this._readableStream) {
                    this._error(reason);
                    return;
                  }
                  this._readableStream.destroy(reason);
                }
                _error(reason) {
                  this._storedError = reason;
                  this._readCapability.resolve();
                }
                _setReadableStream(readableStream) {
                  this._readableStream = readableStream;
                  readableStream.on("readable", () => {
                    this._readCapability.resolve();
                  });
                  readableStream.on("end", () => {
                    readableStream.destroy();
                    this._done = true;
                    this._readCapability.resolve();
                  });
                  readableStream.on("error", (reason) => {
                    this._error(reason);
                  });
                  if (this._storedError) {
                    this._readableStream.destroy(this._storedError);
                  }
                }
              }
              function createRequestOptions(parsedUrl, headers) {
                return {
                  protocol: parsedUrl.protocol,
                  auth: parsedUrl.auth,
                  host: parsedUrl.hostname,
                  port: parsedUrl.port,
                  path: parsedUrl.path,
                  method: "GET",
                  headers
                };
              }
              class PDFNodeStreamFullReader extends BaseFullReader {
                constructor(stream) {
                  super(stream);
                  const handleResponse = (response) => {
                    if (response.statusCode === 404) {
                      const error2 = new _util2.MissingPDFException(`Missing PDF "${this._url}".`);
                      this._storedError = error2;
                      this._headersCapability.reject(error2);
                      return;
                    }
                    this._headersCapability.resolve();
                    this._setReadableStream(response);
                    const getResponseHeader = (name) => {
                      return this._readableStream.headers[name.toLowerCase()];
                    };
                    const {
                      allowRangeRequests,
                      suggestedLength
                    } = (0, _network_utils.validateRangeRequestCapabilities)({
                      getResponseHeader,
                      isHttp: stream.isHttp,
                      rangeChunkSize: this._rangeChunkSize,
                      disableRange: this._disableRange
                    });
                    this._isRangeSupported = allowRangeRequests;
                    this._contentLength = suggestedLength || this._contentLength;
                    this._filename = (0, _network_utils.extractFilenameFromHeader)(getResponseHeader);
                  };
                  this._request = null;
                  if (this._url.protocol === "http:") {
                    const http = require_http();
                    this._request = http.request(createRequestOptions(this._url, stream.httpHeaders), handleResponse);
                  } else {
                    const https = require_https();
                    this._request = https.request(createRequestOptions(this._url, stream.httpHeaders), handleResponse);
                  }
                  this._request.on("error", (reason) => {
                    this._storedError = reason;
                    this._headersCapability.reject(reason);
                  });
                  this._request.end();
                }
              }
              class PDFNodeStreamRangeReader extends BaseRangeReader {
                constructor(stream, start, end) {
                  super(stream);
                  this._httpHeaders = {};
                  for (const property2 in stream.httpHeaders) {
                    const value = stream.httpHeaders[property2];
                    if (value === void 0) {
                      continue;
                    }
                    this._httpHeaders[property2] = value;
                  }
                  this._httpHeaders.Range = `bytes=${start}-${end - 1}`;
                  const handleResponse = (response) => {
                    if (response.statusCode === 404) {
                      const error2 = new _util2.MissingPDFException(`Missing PDF "${this._url}".`);
                      this._storedError = error2;
                      return;
                    }
                    this._setReadableStream(response);
                  };
                  this._request = null;
                  if (this._url.protocol === "http:") {
                    const http = require_http();
                    this._request = http.request(createRequestOptions(this._url, this._httpHeaders), handleResponse);
                  } else {
                    const https = require_https();
                    this._request = https.request(createRequestOptions(this._url, this._httpHeaders), handleResponse);
                  }
                  this._request.on("error", (reason) => {
                    this._storedError = reason;
                  });
                  this._request.end();
                }
              }
              class PDFNodeStreamFsFullReader extends BaseFullReader {
                constructor(stream) {
                  super(stream);
                  let path2 = decodeURIComponent(this._url.path);
                  if (fileUriRegex.test(this._url.href)) {
                    path2 = path2.replace(/^\//, "");
                  }
                  const fs = require_fs();
                  fs.lstat(path2, (error2, stat) => {
                    if (error2) {
                      if (error2.code === "ENOENT") {
                        error2 = new _util2.MissingPDFException(`Missing PDF "${path2}".`);
                      }
                      this._storedError = error2;
                      this._headersCapability.reject(error2);
                      return;
                    }
                    this._contentLength = stat.size;
                    this._setReadableStream(fs.createReadStream(path2));
                    this._headersCapability.resolve();
                  });
                }
              }
              class PDFNodeStreamFsRangeReader extends BaseRangeReader {
                constructor(stream, start, end) {
                  super(stream);
                  let path2 = decodeURIComponent(this._url.path);
                  if (fileUriRegex.test(this._url.href)) {
                    path2 = path2.replace(/^\//, "");
                  }
                  const fs = require_fs();
                  this._setReadableStream(fs.createReadStream(path2, {
                    start,
                    end: end - 1
                  }));
                }
              }
            }),
            /* 24 */
            /***/
            ((__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
              Object.defineProperty(exports2, "__esModule", {
                value: true
              });
              exports2.SVGGraphics = void 0;
              var _display_utils2 = __w_pdfjs_require__2(6);
              var _util2 = __w_pdfjs_require__2(1);
              ;
              const SVG_DEFAULTS = {
                fontStyle: "normal",
                fontWeight: "normal",
                fillColor: "#000000"
              };
              const XML_NS = "http://www.w3.org/XML/1998/namespace";
              const XLINK_NS = "http://www.w3.org/1999/xlink";
              const LINE_CAP_STYLES = ["butt", "round", "square"];
              const LINE_JOIN_STYLES = ["miter", "round", "bevel"];
              const createObjectURL = function(data2, contentType = "", forceDataSchema = false) {
                if (URL.createObjectURL && typeof Blob !== "undefined" && !forceDataSchema) {
                  return URL.createObjectURL(new Blob([data2], {
                    type: contentType
                  }));
                }
                const digits = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
                let buffer = `data:${contentType};base64,`;
                for (let i = 0, ii = data2.length; i < ii; i += 3) {
                  const b1 = data2[i] & 255;
                  const b2 = data2[i + 1] & 255;
                  const b3 = data2[i + 2] & 255;
                  const d1 = b1 >> 2, d2 = (b1 & 3) << 4 | b2 >> 4;
                  const d3 = i + 1 < ii ? (b2 & 15) << 2 | b3 >> 6 : 64;
                  const d4 = i + 2 < ii ? b3 & 63 : 64;
                  buffer += digits[d1] + digits[d2] + digits[d3] + digits[d4];
                }
                return buffer;
              };
              const convertImgDataToPng = (function() {
                const PNG_HEADER = new Uint8Array([137, 80, 78, 71, 13, 10, 26, 10]);
                const CHUNK_WRAPPER_SIZE = 12;
                const crcTable = new Int32Array(256);
                for (let i = 0; i < 256; i++) {
                  let c = i;
                  for (let h2 = 0; h2 < 8; h2++) {
                    c = c & 1 ? 3988292384 ^ c >> 1 & 2147483647 : c >> 1 & 2147483647;
                  }
                  crcTable[i] = c;
                }
                function crc32(data2, start, end) {
                  let crc = -1;
                  for (let i = start; i < end; i++) {
                    const a = (crc ^ data2[i]) & 255;
                    const b = crcTable[a];
                    crc = crc >>> 8 ^ b;
                  }
                  return crc ^ -1;
                }
                function writePngChunk(type5, body, data2, offset4) {
                  let p = offset4;
                  const len = body.length;
                  data2[p] = len >> 24 & 255;
                  data2[p + 1] = len >> 16 & 255;
                  data2[p + 2] = len >> 8 & 255;
                  data2[p + 3] = len & 255;
                  p += 4;
                  data2[p] = type5.charCodeAt(0) & 255;
                  data2[p + 1] = type5.charCodeAt(1) & 255;
                  data2[p + 2] = type5.charCodeAt(2) & 255;
                  data2[p + 3] = type5.charCodeAt(3) & 255;
                  p += 4;
                  data2.set(body, p);
                  p += body.length;
                  const crc = crc32(data2, offset4 + 4, p);
                  data2[p] = crc >> 24 & 255;
                  data2[p + 1] = crc >> 16 & 255;
                  data2[p + 2] = crc >> 8 & 255;
                  data2[p + 3] = crc & 255;
                }
                function adler32(data2, start, end) {
                  let a = 1;
                  let b = 0;
                  for (let i = start; i < end; ++i) {
                    a = (a + (data2[i] & 255)) % 65521;
                    b = (b + a) % 65521;
                  }
                  return b << 16 | a;
                }
                function deflateSync(literals) {
                  if (!_util2.isNodeJS) {
                    return deflateSyncUncompressed(literals);
                  }
                  try {
                    const input = parseInt(process.versions.node) >= 8 ? literals : Buffer.from(literals);
                    const output = require_zlib().deflateSync(input, {
                      level: 9
                    });
                    return output instanceof Uint8Array ? output : new Uint8Array(output);
                  } catch (e3) {
                    (0, _util2.warn)("Not compressing PNG because zlib.deflateSync is unavailable: " + e3);
                  }
                  return deflateSyncUncompressed(literals);
                }
                function deflateSyncUncompressed(literals) {
                  let len = literals.length;
                  const maxBlockLength = 65535;
                  const deflateBlocks = Math.ceil(len / maxBlockLength);
                  const idat = new Uint8Array(2 + len + deflateBlocks * 5 + 4);
                  let pi = 0;
                  idat[pi++] = 120;
                  idat[pi++] = 156;
                  let pos = 0;
                  while (len > maxBlockLength) {
                    idat[pi++] = 0;
                    idat[pi++] = 255;
                    idat[pi++] = 255;
                    idat[pi++] = 0;
                    idat[pi++] = 0;
                    idat.set(literals.subarray(pos, pos + maxBlockLength), pi);
                    pi += maxBlockLength;
                    pos += maxBlockLength;
                    len -= maxBlockLength;
                  }
                  idat[pi++] = 1;
                  idat[pi++] = len & 255;
                  idat[pi++] = len >> 8 & 255;
                  idat[pi++] = ~len & 65535 & 255;
                  idat[pi++] = (~len & 65535) >> 8 & 255;
                  idat.set(literals.subarray(pos), pi);
                  pi += literals.length - pos;
                  const adler = adler32(literals, 0, literals.length);
                  idat[pi++] = adler >> 24 & 255;
                  idat[pi++] = adler >> 16 & 255;
                  idat[pi++] = adler >> 8 & 255;
                  idat[pi++] = adler & 255;
                  return idat;
                }
                function encode(imgData, kind, forceDataSchema, isMask) {
                  const width = imgData.width;
                  const height = imgData.height;
                  let bitDepth, colorType, lineSize;
                  const bytes = imgData.data;
                  switch (kind) {
                    case _util2.ImageKind.GRAYSCALE_1BPP:
                      colorType = 0;
                      bitDepth = 1;
                      lineSize = width + 7 >> 3;
                      break;
                    case _util2.ImageKind.RGB_24BPP:
                      colorType = 2;
                      bitDepth = 8;
                      lineSize = width * 3;
                      break;
                    case _util2.ImageKind.RGBA_32BPP:
                      colorType = 6;
                      bitDepth = 8;
                      lineSize = width * 4;
                      break;
                    default:
                      throw new Error("invalid format");
                  }
                  const literals = new Uint8Array((1 + lineSize) * height);
                  let offsetLiterals = 0, offsetBytes = 0;
                  for (let y = 0; y < height; ++y) {
                    literals[offsetLiterals++] = 0;
                    literals.set(bytes.subarray(offsetBytes, offsetBytes + lineSize), offsetLiterals);
                    offsetBytes += lineSize;
                    offsetLiterals += lineSize;
                  }
                  if (kind === _util2.ImageKind.GRAYSCALE_1BPP && isMask) {
                    offsetLiterals = 0;
                    for (let y = 0; y < height; y++) {
                      offsetLiterals++;
                      for (let i = 0; i < lineSize; i++) {
                        literals[offsetLiterals++] ^= 255;
                      }
                    }
                  }
                  const ihdr = new Uint8Array([width >> 24 & 255, width >> 16 & 255, width >> 8 & 255, width & 255, height >> 24 & 255, height >> 16 & 255, height >> 8 & 255, height & 255, bitDepth, colorType, 0, 0, 0]);
                  const idat = deflateSync(literals);
                  const pngLength = PNG_HEADER.length + CHUNK_WRAPPER_SIZE * 3 + ihdr.length + idat.length;
                  const data2 = new Uint8Array(pngLength);
                  let offset4 = 0;
                  data2.set(PNG_HEADER, offset4);
                  offset4 += PNG_HEADER.length;
                  writePngChunk("IHDR", ihdr, data2, offset4);
                  offset4 += CHUNK_WRAPPER_SIZE + ihdr.length;
                  writePngChunk("IDATA", idat, data2, offset4);
                  offset4 += CHUNK_WRAPPER_SIZE + idat.length;
                  writePngChunk("IEND", new Uint8Array(0), data2, offset4);
                  return createObjectURL(data2, "image/png", forceDataSchema);
                }
                return function convertImgDataToPng2(imgData, forceDataSchema, isMask) {
                  const kind = imgData.kind === void 0 ? _util2.ImageKind.GRAYSCALE_1BPP : imgData.kind;
                  return encode(imgData, kind, forceDataSchema, isMask);
                };
              })();
              class SVGExtraState {
                constructor() {
                  this.fontSizeScale = 1;
                  this.fontWeight = SVG_DEFAULTS.fontWeight;
                  this.fontSize = 0;
                  this.textMatrix = _util2.IDENTITY_MATRIX;
                  this.fontMatrix = _util2.FONT_IDENTITY_MATRIX;
                  this.leading = 0;
                  this.textRenderingMode = _util2.TextRenderingMode.FILL;
                  this.textMatrixScale = 1;
                  this.x = 0;
                  this.y = 0;
                  this.lineX = 0;
                  this.lineY = 0;
                  this.charSpacing = 0;
                  this.wordSpacing = 0;
                  this.textHScale = 1;
                  this.textRise = 0;
                  this.fillColor = SVG_DEFAULTS.fillColor;
                  this.strokeColor = "#000000";
                  this.fillAlpha = 1;
                  this.strokeAlpha = 1;
                  this.lineWidth = 1;
                  this.lineJoin = "";
                  this.lineCap = "";
                  this.miterLimit = 0;
                  this.dashArray = [];
                  this.dashPhase = 0;
                  this.dependencies = [];
                  this.activeClipUrl = null;
                  this.clipGroup = null;
                  this.maskId = "";
                }
                clone() {
                  return Object.create(this);
                }
                setCurrentPoint(x, y) {
                  this.x = x;
                  this.y = y;
                }
              }
              function opListToTree(opList) {
                let opTree = [];
                const tmp = [];
                for (const opListElement of opList) {
                  if (opListElement.fn === "save") {
                    opTree.push({
                      fnId: 92,
                      fn: "group",
                      items: []
                    });
                    tmp.push(opTree);
                    opTree = opTree.at(-1).items;
                    continue;
                  }
                  if (opListElement.fn === "restore") {
                    opTree = tmp.pop();
                  } else {
                    opTree.push(opListElement);
                  }
                }
                return opTree;
              }
              function pf(value) {
                if (Number.isInteger(value)) {
                  return value.toString();
                }
                const s = value.toFixed(10);
                let i = s.length - 1;
                if (s[i] !== "0") {
                  return s;
                }
                do {
                  i--;
                } while (s[i] === "0");
                return s.substring(0, s[i] === "." ? i : i + 1);
              }
              function pm(m) {
                if (m[4] === 0 && m[5] === 0) {
                  if (m[1] === 0 && m[2] === 0) {
                    if (m[0] === 1 && m[3] === 1) {
                      return "";
                    }
                    return `scale(${pf(m[0])} ${pf(m[3])})`;
                  }
                  if (m[0] === m[3] && m[1] === -m[2]) {
                    const a = Math.acos(m[0]) * 180 / Math.PI;
                    return `rotate(${pf(a)})`;
                  }
                } else if (m[0] === 1 && m[1] === 0 && m[2] === 0 && m[3] === 1) {
                  return `translate(${pf(m[4])} ${pf(m[5])})`;
                }
                return `matrix(${pf(m[0])} ${pf(m[1])} ${pf(m[2])} ${pf(m[3])} ${pf(m[4])} ${pf(m[5])})`;
              }
              let clipCount = 0;
              let maskCount = 0;
              let shadingCount = 0;
              class SVGGraphics {
                constructor(commonObjs, objs, forceDataSchema = false) {
                  (0, _display_utils2.deprecated)("The SVG back-end is no longer maintained and *may* be removed in the future.");
                  this.svgFactory = new _display_utils2.DOMSVGFactory();
                  this.current = new SVGExtraState();
                  this.transformMatrix = _util2.IDENTITY_MATRIX;
                  this.transformStack = [];
                  this.extraStack = [];
                  this.commonObjs = commonObjs;
                  this.objs = objs;
                  this.pendingClip = null;
                  this.pendingEOFill = false;
                  this.embedFonts = false;
                  this.embeddedFonts = /* @__PURE__ */ Object.create(null);
                  this.cssStyle = null;
                  this.forceDataSchema = !!forceDataSchema;
                  this._operatorIdMapping = [];
                  for (const op in _util2.OPS) {
                    this._operatorIdMapping[_util2.OPS[op]] = op;
                  }
                }
                getObject(data2, fallback = null) {
                  if (typeof data2 === "string") {
                    return data2.startsWith("g_") ? this.commonObjs.get(data2) : this.objs.get(data2);
                  }
                  return fallback;
                }
                save() {
                  this.transformStack.push(this.transformMatrix);
                  const old = this.current;
                  this.extraStack.push(old);
                  this.current = old.clone();
                }
                restore() {
                  this.transformMatrix = this.transformStack.pop();
                  this.current = this.extraStack.pop();
                  this.pendingClip = null;
                  this.tgrp = null;
                }
                group(items) {
                  this.save();
                  this.executeOpTree(items);
                  this.restore();
                }
                loadDependencies(operatorList) {
                  const fnArray = operatorList.fnArray;
                  const argsArray = operatorList.argsArray;
                  for (let i = 0, ii = fnArray.length; i < ii; i++) {
                    if (fnArray[i] !== _util2.OPS.dependency) {
                      continue;
                    }
                    for (const obj of argsArray[i]) {
                      const objsPool = obj.startsWith("g_") ? this.commonObjs : this.objs;
                      const promise = new Promise((resolve) => {
                        objsPool.get(obj, resolve);
                      });
                      this.current.dependencies.push(promise);
                    }
                  }
                  return Promise.all(this.current.dependencies);
                }
                transform(a, b, c, d, e3, f) {
                  const transformMatrix = [a, b, c, d, e3, f];
                  this.transformMatrix = _util2.Util.transform(this.transformMatrix, transformMatrix);
                  this.tgrp = null;
                }
                getSVG(operatorList, viewport) {
                  this.viewport = viewport;
                  const svgElement = this._initialize(viewport);
                  return this.loadDependencies(operatorList).then(() => {
                    this.transformMatrix = _util2.IDENTITY_MATRIX;
                    this.executeOpTree(this.convertOpList(operatorList));
                    return svgElement;
                  });
                }
                convertOpList(operatorList) {
                  const operatorIdMapping = this._operatorIdMapping;
                  const argsArray = operatorList.argsArray;
                  const fnArray = operatorList.fnArray;
                  const opList = [];
                  for (let i = 0, ii = fnArray.length; i < ii; i++) {
                    const fnId = fnArray[i];
                    opList.push({
                      fnId,
                      fn: operatorIdMapping[fnId],
                      args: argsArray[i]
                    });
                  }
                  return opListToTree(opList);
                }
                executeOpTree(opTree) {
                  for (const opTreeElement of opTree) {
                    const fn = opTreeElement.fn;
                    const fnId = opTreeElement.fnId;
                    const args = opTreeElement.args;
                    switch (fnId | 0) {
                      case _util2.OPS.beginText:
                        this.beginText();
                        break;
                      case _util2.OPS.dependency:
                        break;
                      case _util2.OPS.setLeading:
                        this.setLeading(args);
                        break;
                      case _util2.OPS.setLeadingMoveText:
                        this.setLeadingMoveText(args[0], args[1]);
                        break;
                      case _util2.OPS.setFont:
                        this.setFont(args);
                        break;
                      case _util2.OPS.showText:
                        this.showText(args[0]);
                        break;
                      case _util2.OPS.showSpacedText:
                        this.showText(args[0]);
                        break;
                      case _util2.OPS.endText:
                        this.endText();
                        break;
                      case _util2.OPS.moveText:
                        this.moveText(args[0], args[1]);
                        break;
                      case _util2.OPS.setCharSpacing:
                        this.setCharSpacing(args[0]);
                        break;
                      case _util2.OPS.setWordSpacing:
                        this.setWordSpacing(args[0]);
                        break;
                      case _util2.OPS.setHScale:
                        this.setHScale(args[0]);
                        break;
                      case _util2.OPS.setTextMatrix:
                        this.setTextMatrix(args[0], args[1], args[2], args[3], args[4], args[5]);
                        break;
                      case _util2.OPS.setTextRise:
                        this.setTextRise(args[0]);
                        break;
                      case _util2.OPS.setTextRenderingMode:
                        this.setTextRenderingMode(args[0]);
                        break;
                      case _util2.OPS.setLineWidth:
                        this.setLineWidth(args[0]);
                        break;
                      case _util2.OPS.setLineJoin:
                        this.setLineJoin(args[0]);
                        break;
                      case _util2.OPS.setLineCap:
                        this.setLineCap(args[0]);
                        break;
                      case _util2.OPS.setMiterLimit:
                        this.setMiterLimit(args[0]);
                        break;
                      case _util2.OPS.setFillRGBColor:
                        this.setFillRGBColor(args[0], args[1], args[2]);
                        break;
                      case _util2.OPS.setStrokeRGBColor:
                        this.setStrokeRGBColor(args[0], args[1], args[2]);
                        break;
                      case _util2.OPS.setStrokeColorN:
                        this.setStrokeColorN(args);
                        break;
                      case _util2.OPS.setFillColorN:
                        this.setFillColorN(args);
                        break;
                      case _util2.OPS.shadingFill:
                        this.shadingFill(args[0]);
                        break;
                      case _util2.OPS.setDash:
                        this.setDash(args[0], args[1]);
                        break;
                      case _util2.OPS.setRenderingIntent:
                        this.setRenderingIntent(args[0]);
                        break;
                      case _util2.OPS.setFlatness:
                        this.setFlatness(args[0]);
                        break;
                      case _util2.OPS.setGState:
                        this.setGState(args[0]);
                        break;
                      case _util2.OPS.fill:
                        this.fill();
                        break;
                      case _util2.OPS.eoFill:
                        this.eoFill();
                        break;
                      case _util2.OPS.stroke:
                        this.stroke();
                        break;
                      case _util2.OPS.fillStroke:
                        this.fillStroke();
                        break;
                      case _util2.OPS.eoFillStroke:
                        this.eoFillStroke();
                        break;
                      case _util2.OPS.clip:
                        this.clip("nonzero");
                        break;
                      case _util2.OPS.eoClip:
                        this.clip("evenodd");
                        break;
                      case _util2.OPS.paintSolidColorImageMask:
                        this.paintSolidColorImageMask();
                        break;
                      case _util2.OPS.paintImageXObject:
                        this.paintImageXObject(args[0]);
                        break;
                      case _util2.OPS.paintInlineImageXObject:
                        this.paintInlineImageXObject(args[0]);
                        break;
                      case _util2.OPS.paintImageMaskXObject:
                        this.paintImageMaskXObject(args[0]);
                        break;
                      case _util2.OPS.paintFormXObjectBegin:
                        this.paintFormXObjectBegin(args[0], args[1]);
                        break;
                      case _util2.OPS.paintFormXObjectEnd:
                        this.paintFormXObjectEnd();
                        break;
                      case _util2.OPS.closePath:
                        this.closePath();
                        break;
                      case _util2.OPS.closeStroke:
                        this.closeStroke();
                        break;
                      case _util2.OPS.closeFillStroke:
                        this.closeFillStroke();
                        break;
                      case _util2.OPS.closeEOFillStroke:
                        this.closeEOFillStroke();
                        break;
                      case _util2.OPS.nextLine:
                        this.nextLine();
                        break;
                      case _util2.OPS.transform:
                        this.transform(args[0], args[1], args[2], args[3], args[4], args[5]);
                        break;
                      case _util2.OPS.constructPath:
                        this.constructPath(args[0], args[1]);
                        break;
                      case _util2.OPS.endPath:
                        this.endPath();
                        break;
                      case 92:
                        this.group(opTreeElement.items);
                        break;
                      default:
                        (0, _util2.warn)(`Unimplemented operator ${fn}`);
                        break;
                    }
                  }
                }
                setWordSpacing(wordSpacing) {
                  this.current.wordSpacing = wordSpacing;
                }
                setCharSpacing(charSpacing) {
                  this.current.charSpacing = charSpacing;
                }
                nextLine() {
                  this.moveText(0, this.current.leading);
                }
                setTextMatrix(a, b, c, d, e3, f) {
                  const current2 = this.current;
                  current2.textMatrix = current2.lineMatrix = [a, b, c, d, e3, f];
                  current2.textMatrixScale = Math.hypot(a, b);
                  current2.x = current2.lineX = 0;
                  current2.y = current2.lineY = 0;
                  current2.xcoords = [];
                  current2.ycoords = [];
                  current2.tspan = this.svgFactory.createElement("svg:tspan");
                  current2.tspan.setAttributeNS(null, "font-family", current2.fontFamily);
                  current2.tspan.setAttributeNS(null, "font-size", `${pf(current2.fontSize)}px`);
                  current2.tspan.setAttributeNS(null, "y", pf(-current2.y));
                  current2.txtElement = this.svgFactory.createElement("svg:text");
                  current2.txtElement.append(current2.tspan);
                }
                beginText() {
                  const current2 = this.current;
                  current2.x = current2.lineX = 0;
                  current2.y = current2.lineY = 0;
                  current2.textMatrix = _util2.IDENTITY_MATRIX;
                  current2.lineMatrix = _util2.IDENTITY_MATRIX;
                  current2.textMatrixScale = 1;
                  current2.tspan = this.svgFactory.createElement("svg:tspan");
                  current2.txtElement = this.svgFactory.createElement("svg:text");
                  current2.txtgrp = this.svgFactory.createElement("svg:g");
                  current2.xcoords = [];
                  current2.ycoords = [];
                }
                moveText(x, y) {
                  const current2 = this.current;
                  current2.x = current2.lineX += x;
                  current2.y = current2.lineY += y;
                  current2.xcoords = [];
                  current2.ycoords = [];
                  current2.tspan = this.svgFactory.createElement("svg:tspan");
                  current2.tspan.setAttributeNS(null, "font-family", current2.fontFamily);
                  current2.tspan.setAttributeNS(null, "font-size", `${pf(current2.fontSize)}px`);
                  current2.tspan.setAttributeNS(null, "y", pf(-current2.y));
                }
                showText(glyphs) {
                  const current2 = this.current;
                  const font = current2.font;
                  const fontSize = current2.fontSize;
                  if (fontSize === 0) {
                    return;
                  }
                  const fontSizeScale = current2.fontSizeScale;
                  const charSpacing = current2.charSpacing;
                  const wordSpacing = current2.wordSpacing;
                  const fontDirection = current2.fontDirection;
                  const textHScale = current2.textHScale * fontDirection;
                  const vertical = font.vertical;
                  const spacingDir = vertical ? 1 : -1;
                  const defaultVMetrics = font.defaultVMetrics;
                  const widthAdvanceScale = fontSize * current2.fontMatrix[0];
                  let x = 0;
                  for (const glyph of glyphs) {
                    if (glyph === null) {
                      x += fontDirection * wordSpacing;
                      continue;
                    } else if (typeof glyph === "number") {
                      x += spacingDir * glyph * fontSize / 1e3;
                      continue;
                    }
                    const spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
                    const character2 = glyph.fontChar;
                    let scaledX, scaledY;
                    let width = glyph.width;
                    if (vertical) {
                      let vx;
                      const vmetric = glyph.vmetric || defaultVMetrics;
                      vx = glyph.vmetric ? vmetric[1] : width * 0.5;
                      vx = -vx * widthAdvanceScale;
                      const vy = vmetric[2] * widthAdvanceScale;
                      width = vmetric ? -vmetric[0] : width;
                      scaledX = vx / fontSizeScale;
                      scaledY = (x + vy) / fontSizeScale;
                    } else {
                      scaledX = x / fontSizeScale;
                      scaledY = 0;
                    }
                    if (glyph.isInFont || font.missingFile) {
                      current2.xcoords.push(current2.x + scaledX);
                      if (vertical) {
                        current2.ycoords.push(-current2.y + scaledY);
                      }
                      current2.tspan.textContent += character2;
                    } else {
                    }
                    const charWidth = vertical ? width * widthAdvanceScale - spacing * fontDirection : width * widthAdvanceScale + spacing * fontDirection;
                    x += charWidth;
                  }
                  current2.tspan.setAttributeNS(null, "x", current2.xcoords.map(pf).join(" "));
                  if (vertical) {
                    current2.tspan.setAttributeNS(null, "y", current2.ycoords.map(pf).join(" "));
                  } else {
                    current2.tspan.setAttributeNS(null, "y", pf(-current2.y));
                  }
                  if (vertical) {
                    current2.y -= x;
                  } else {
                    current2.x += x * textHScale;
                  }
                  current2.tspan.setAttributeNS(null, "font-family", current2.fontFamily);
                  current2.tspan.setAttributeNS(null, "font-size", `${pf(current2.fontSize)}px`);
                  if (current2.fontStyle !== SVG_DEFAULTS.fontStyle) {
                    current2.tspan.setAttributeNS(null, "font-style", current2.fontStyle);
                  }
                  if (current2.fontWeight !== SVG_DEFAULTS.fontWeight) {
                    current2.tspan.setAttributeNS(null, "font-weight", current2.fontWeight);
                  }
                  const fillStrokeMode = current2.textRenderingMode & _util2.TextRenderingMode.FILL_STROKE_MASK;
                  if (fillStrokeMode === _util2.TextRenderingMode.FILL || fillStrokeMode === _util2.TextRenderingMode.FILL_STROKE) {
                    if (current2.fillColor !== SVG_DEFAULTS.fillColor) {
                      current2.tspan.setAttributeNS(null, "fill", current2.fillColor);
                    }
                    if (current2.fillAlpha < 1) {
                      current2.tspan.setAttributeNS(null, "fill-opacity", current2.fillAlpha);
                    }
                  } else if (current2.textRenderingMode === _util2.TextRenderingMode.ADD_TO_PATH) {
                    current2.tspan.setAttributeNS(null, "fill", "transparent");
                  } else {
                    current2.tspan.setAttributeNS(null, "fill", "none");
                  }
                  if (fillStrokeMode === _util2.TextRenderingMode.STROKE || fillStrokeMode === _util2.TextRenderingMode.FILL_STROKE) {
                    const lineWidthScale = 1 / (current2.textMatrixScale || 1);
                    this._setStrokeAttributes(current2.tspan, lineWidthScale);
                  }
                  let textMatrix = current2.textMatrix;
                  if (current2.textRise !== 0) {
                    textMatrix = textMatrix.slice();
                    textMatrix[5] += current2.textRise;
                  }
                  current2.txtElement.setAttributeNS(null, "transform", `${pm(textMatrix)} scale(${pf(textHScale)}, -1)`);
                  current2.txtElement.setAttributeNS(XML_NS, "xml:space", "preserve");
                  current2.txtElement.append(current2.tspan);
                  current2.txtgrp.append(current2.txtElement);
                  this._ensureTransformGroup().append(current2.txtElement);
                }
                setLeadingMoveText(x, y) {
                  this.setLeading(-y);
                  this.moveText(x, y);
                }
                addFontStyle(fontObj) {
                  if (!fontObj.data) {
                    throw new Error('addFontStyle: No font data available, ensure that the "fontExtraProperties" API parameter is set.');
                  }
                  if (!this.cssStyle) {
                    this.cssStyle = this.svgFactory.createElement("svg:style");
                    this.cssStyle.setAttributeNS(null, "type", "text/css");
                    this.defs.append(this.cssStyle);
                  }
                  const url2 = createObjectURL(fontObj.data, fontObj.mimetype, this.forceDataSchema);
                  this.cssStyle.textContent += `@font-face { font-family: "${fontObj.loadedName}"; src: url(${url2}); }
`;
                }
                setFont(details) {
                  const current2 = this.current;
                  const fontObj = this.commonObjs.get(details[0]);
                  let size = details[1];
                  current2.font = fontObj;
                  if (this.embedFonts && !fontObj.missingFile && !this.embeddedFonts[fontObj.loadedName]) {
                    this.addFontStyle(fontObj);
                    this.embeddedFonts[fontObj.loadedName] = fontObj;
                  }
                  current2.fontMatrix = fontObj.fontMatrix || _util2.FONT_IDENTITY_MATRIX;
                  let bold = "normal";
                  if (fontObj.black) {
                    bold = "900";
                  } else if (fontObj.bold) {
                    bold = "bold";
                  }
                  const italic = fontObj.italic ? "italic" : "normal";
                  if (size < 0) {
                    size = -size;
                    current2.fontDirection = -1;
                  } else {
                    current2.fontDirection = 1;
                  }
                  current2.fontSize = size;
                  current2.fontFamily = fontObj.loadedName;
                  current2.fontWeight = bold;
                  current2.fontStyle = italic;
                  current2.tspan = this.svgFactory.createElement("svg:tspan");
                  current2.tspan.setAttributeNS(null, "y", pf(-current2.y));
                  current2.xcoords = [];
                  current2.ycoords = [];
                }
                endText() {
                  const current2 = this.current;
                  if (current2.textRenderingMode & _util2.TextRenderingMode.ADD_TO_PATH_FLAG && current2.txtElement?.hasChildNodes()) {
                    current2.element = current2.txtElement;
                    this.clip("nonzero");
                    this.endPath();
                  }
                }
                setLineWidth(width) {
                  if (width > 0) {
                    this.current.lineWidth = width;
                  }
                }
                setLineCap(style2) {
                  this.current.lineCap = LINE_CAP_STYLES[style2];
                }
                setLineJoin(style2) {
                  this.current.lineJoin = LINE_JOIN_STYLES[style2];
                }
                setMiterLimit(limit) {
                  this.current.miterLimit = limit;
                }
                setStrokeAlpha(strokeAlpha) {
                  this.current.strokeAlpha = strokeAlpha;
                }
                setStrokeRGBColor(r2, g, b) {
                  this.current.strokeColor = _util2.Util.makeHexColor(r2, g, b);
                }
                setFillAlpha(fillAlpha) {
                  this.current.fillAlpha = fillAlpha;
                }
                setFillRGBColor(r2, g, b) {
                  this.current.fillColor = _util2.Util.makeHexColor(r2, g, b);
                  this.current.tspan = this.svgFactory.createElement("svg:tspan");
                  this.current.xcoords = [];
                  this.current.ycoords = [];
                }
                setStrokeColorN(args) {
                  this.current.strokeColor = this._makeColorN_Pattern(args);
                }
                setFillColorN(args) {
                  this.current.fillColor = this._makeColorN_Pattern(args);
                }
                shadingFill(args) {
                  const {
                    width,
                    height
                  } = this.viewport;
                  const inv = _util2.Util.inverseTransform(this.transformMatrix);
                  const [x0, y0, x1, y1] = _util2.Util.getAxialAlignedBoundingBox([0, 0, width, height], inv);
                  const rect = this.svgFactory.createElement("svg:rect");
                  rect.setAttributeNS(null, "x", x0);
                  rect.setAttributeNS(null, "y", y0);
                  rect.setAttributeNS(null, "width", x1 - x0);
                  rect.setAttributeNS(null, "height", y1 - y0);
                  rect.setAttributeNS(null, "fill", this._makeShadingPattern(args));
                  if (this.current.fillAlpha < 1) {
                    rect.setAttributeNS(null, "fill-opacity", this.current.fillAlpha);
                  }
                  this._ensureTransformGroup().append(rect);
                }
                _makeColorN_Pattern(args) {
                  if (args[0] === "TilingPattern") {
                    return this._makeTilingPattern(args);
                  }
                  return this._makeShadingPattern(args);
                }
                _makeTilingPattern(args) {
                  const color = args[1];
                  const operatorList = args[2];
                  const matrix = args[3] || _util2.IDENTITY_MATRIX;
                  const [x0, y0, x1, y1] = args[4];
                  const xstep = args[5];
                  const ystep = args[6];
                  const paintType = args[7];
                  const tilingId = `shading${shadingCount++}`;
                  const [tx0, ty0, tx1, ty1] = _util2.Util.normalizeRect([..._util2.Util.applyTransform([x0, y0], matrix), ..._util2.Util.applyTransform([x1, y1], matrix)]);
                  const [xscale, yscale] = _util2.Util.singularValueDecompose2dScale(matrix);
                  const txstep = xstep * xscale;
                  const tystep = ystep * yscale;
                  const tiling = this.svgFactory.createElement("svg:pattern");
                  tiling.setAttributeNS(null, "id", tilingId);
                  tiling.setAttributeNS(null, "patternUnits", "userSpaceOnUse");
                  tiling.setAttributeNS(null, "width", txstep);
                  tiling.setAttributeNS(null, "height", tystep);
                  tiling.setAttributeNS(null, "x", `${tx0}`);
                  tiling.setAttributeNS(null, "y", `${ty0}`);
                  const svg = this.svg;
                  const transformMatrix = this.transformMatrix;
                  const fillColor = this.current.fillColor;
                  const strokeColor = this.current.strokeColor;
                  const bbox = this.svgFactory.create(tx1 - tx0, ty1 - ty0);
                  this.svg = bbox;
                  this.transformMatrix = matrix;
                  if (paintType === 2) {
                    const cssColor = _util2.Util.makeHexColor(...color);
                    this.current.fillColor = cssColor;
                    this.current.strokeColor = cssColor;
                  }
                  this.executeOpTree(this.convertOpList(operatorList));
                  this.svg = svg;
                  this.transformMatrix = transformMatrix;
                  this.current.fillColor = fillColor;
                  this.current.strokeColor = strokeColor;
                  tiling.append(bbox.childNodes[0]);
                  this.defs.append(tiling);
                  return `url(#${tilingId})`;
                }
                _makeShadingPattern(args) {
                  if (typeof args === "string") {
                    args = this.objs.get(args);
                  }
                  switch (args[0]) {
                    case "RadialAxial":
                      const shadingId = `shading${shadingCount++}`;
                      const colorStops = args[3];
                      let gradient;
                      switch (args[1]) {
                        case "axial":
                          const point0 = args[4];
                          const point1 = args[5];
                          gradient = this.svgFactory.createElement("svg:linearGradient");
                          gradient.setAttributeNS(null, "id", shadingId);
                          gradient.setAttributeNS(null, "gradientUnits", "userSpaceOnUse");
                          gradient.setAttributeNS(null, "x1", point0[0]);
                          gradient.setAttributeNS(null, "y1", point0[1]);
                          gradient.setAttributeNS(null, "x2", point1[0]);
                          gradient.setAttributeNS(null, "y2", point1[1]);
                          break;
                        case "radial":
                          const focalPoint = args[4];
                          const circlePoint = args[5];
                          const focalRadius = args[6];
                          const circleRadius = args[7];
                          gradient = this.svgFactory.createElement("svg:radialGradient");
                          gradient.setAttributeNS(null, "id", shadingId);
                          gradient.setAttributeNS(null, "gradientUnits", "userSpaceOnUse");
                          gradient.setAttributeNS(null, "cx", circlePoint[0]);
                          gradient.setAttributeNS(null, "cy", circlePoint[1]);
                          gradient.setAttributeNS(null, "r", circleRadius);
                          gradient.setAttributeNS(null, "fx", focalPoint[0]);
                          gradient.setAttributeNS(null, "fy", focalPoint[1]);
                          gradient.setAttributeNS(null, "fr", focalRadius);
                          break;
                        default:
                          throw new Error(`Unknown RadialAxial type: ${args[1]}`);
                      }
                      for (const colorStop of colorStops) {
                        const stop = this.svgFactory.createElement("svg:stop");
                        stop.setAttributeNS(null, "offset", colorStop[0]);
                        stop.setAttributeNS(null, "stop-color", colorStop[1]);
                        gradient.append(stop);
                      }
                      this.defs.append(gradient);
                      return `url(#${shadingId})`;
                    case "Mesh":
                      (0, _util2.warn)("Unimplemented pattern Mesh");
                      return null;
                    case "Dummy":
                      return "hotpink";
                    default:
                      throw new Error(`Unknown IR type: ${args[0]}`);
                  }
                }
                setDash(dashArray, dashPhase) {
                  this.current.dashArray = dashArray;
                  this.current.dashPhase = dashPhase;
                }
                constructPath(ops, args) {
                  const current2 = this.current;
                  let x = current2.x, y = current2.y;
                  let d = [];
                  let j = 0;
                  for (const op of ops) {
                    switch (op | 0) {
                      case _util2.OPS.rectangle:
                        x = args[j++];
                        y = args[j++];
                        const width = args[j++];
                        const height = args[j++];
                        const xw = x + width;
                        const yh = y + height;
                        d.push("M", pf(x), pf(y), "L", pf(xw), pf(y), "L", pf(xw), pf(yh), "L", pf(x), pf(yh), "Z");
                        break;
                      case _util2.OPS.moveTo:
                        x = args[j++];
                        y = args[j++];
                        d.push("M", pf(x), pf(y));
                        break;
                      case _util2.OPS.lineTo:
                        x = args[j++];
                        y = args[j++];
                        d.push("L", pf(x), pf(y));
                        break;
                      case _util2.OPS.curveTo:
                        x = args[j + 4];
                        y = args[j + 5];
                        d.push("C", pf(args[j]), pf(args[j + 1]), pf(args[j + 2]), pf(args[j + 3]), pf(x), pf(y));
                        j += 6;
                        break;
                      case _util2.OPS.curveTo2:
                        d.push("C", pf(x), pf(y), pf(args[j]), pf(args[j + 1]), pf(args[j + 2]), pf(args[j + 3]));
                        x = args[j + 2];
                        y = args[j + 3];
                        j += 4;
                        break;
                      case _util2.OPS.curveTo3:
                        x = args[j + 2];
                        y = args[j + 3];
                        d.push("C", pf(args[j]), pf(args[j + 1]), pf(x), pf(y), pf(x), pf(y));
                        j += 4;
                        break;
                      case _util2.OPS.closePath:
                        d.push("Z");
                        break;
                    }
                  }
                  d = d.join(" ");
                  if (current2.path && ops.length > 0 && ops[0] !== _util2.OPS.rectangle && ops[0] !== _util2.OPS.moveTo) {
                    d = current2.path.getAttributeNS(null, "d") + d;
                  } else {
                    current2.path = this.svgFactory.createElement("svg:path");
                    this._ensureTransformGroup().append(current2.path);
                  }
                  current2.path.setAttributeNS(null, "d", d);
                  current2.path.setAttributeNS(null, "fill", "none");
                  current2.element = current2.path;
                  current2.setCurrentPoint(x, y);
                }
                endPath() {
                  const current2 = this.current;
                  current2.path = null;
                  if (!this.pendingClip) {
                    return;
                  }
                  if (!current2.element) {
                    this.pendingClip = null;
                    return;
                  }
                  const clipId = `clippath${clipCount++}`;
                  const clipPath = this.svgFactory.createElement("svg:clipPath");
                  clipPath.setAttributeNS(null, "id", clipId);
                  clipPath.setAttributeNS(null, "transform", pm(this.transformMatrix));
                  const clipElement = current2.element.cloneNode(true);
                  if (this.pendingClip === "evenodd") {
                    clipElement.setAttributeNS(null, "clip-rule", "evenodd");
                  } else {
                    clipElement.setAttributeNS(null, "clip-rule", "nonzero");
                  }
                  this.pendingClip = null;
                  clipPath.append(clipElement);
                  this.defs.append(clipPath);
                  if (current2.activeClipUrl) {
                    current2.clipGroup = null;
                    for (const prev2 of this.extraStack) {
                      prev2.clipGroup = null;
                    }
                    clipPath.setAttributeNS(null, "clip-path", current2.activeClipUrl);
                  }
                  current2.activeClipUrl = `url(#${clipId})`;
                  this.tgrp = null;
                }
                clip(type5) {
                  this.pendingClip = type5;
                }
                closePath() {
                  const current2 = this.current;
                  if (current2.path) {
                    const d = `${current2.path.getAttributeNS(null, "d")}Z`;
                    current2.path.setAttributeNS(null, "d", d);
                  }
                }
                setLeading(leading) {
                  this.current.leading = -leading;
                }
                setTextRise(textRise) {
                  this.current.textRise = textRise;
                }
                setTextRenderingMode(textRenderingMode) {
                  this.current.textRenderingMode = textRenderingMode;
                }
                setHScale(scale) {
                  this.current.textHScale = scale / 100;
                }
                setRenderingIntent(intent) {
                }
                setFlatness(flatness) {
                }
                setGState(states) {
                  for (const [key2, value] of states) {
                    switch (key2) {
                      case "LW":
                        this.setLineWidth(value);
                        break;
                      case "LC":
                        this.setLineCap(value);
                        break;
                      case "LJ":
                        this.setLineJoin(value);
                        break;
                      case "ML":
                        this.setMiterLimit(value);
                        break;
                      case "D":
                        this.setDash(value[0], value[1]);
                        break;
                      case "RI":
                        this.setRenderingIntent(value);
                        break;
                      case "FL":
                        this.setFlatness(value);
                        break;
                      case "Font":
                        this.setFont(value);
                        break;
                      case "CA":
                        this.setStrokeAlpha(value);
                        break;
                      case "ca":
                        this.setFillAlpha(value);
                        break;
                      default:
                        (0, _util2.warn)(`Unimplemented graphic state operator ${key2}`);
                        break;
                    }
                  }
                }
                fill() {
                  const current2 = this.current;
                  if (current2.element) {
                    current2.element.setAttributeNS(null, "fill", current2.fillColor);
                    current2.element.setAttributeNS(null, "fill-opacity", current2.fillAlpha);
                    this.endPath();
                  }
                }
                stroke() {
                  const current2 = this.current;
                  if (current2.element) {
                    this._setStrokeAttributes(current2.element);
                    current2.element.setAttributeNS(null, "fill", "none");
                    this.endPath();
                  }
                }
                _setStrokeAttributes(element, lineWidthScale = 1) {
                  const current2 = this.current;
                  let dashArray = current2.dashArray;
                  if (lineWidthScale !== 1 && dashArray.length > 0) {
                    dashArray = dashArray.map(function(value) {
                      return lineWidthScale * value;
                    });
                  }
                  element.setAttributeNS(null, "stroke", current2.strokeColor);
                  element.setAttributeNS(null, "stroke-opacity", current2.strokeAlpha);
                  element.setAttributeNS(null, "stroke-miterlimit", pf(current2.miterLimit));
                  element.setAttributeNS(null, "stroke-linecap", current2.lineCap);
                  element.setAttributeNS(null, "stroke-linejoin", current2.lineJoin);
                  element.setAttributeNS(null, "stroke-width", pf(lineWidthScale * current2.lineWidth) + "px");
                  element.setAttributeNS(null, "stroke-dasharray", dashArray.map(pf).join(" "));
                  element.setAttributeNS(null, "stroke-dashoffset", pf(lineWidthScale * current2.dashPhase) + "px");
                }
                eoFill() {
                  this.current.element?.setAttributeNS(null, "fill-rule", "evenodd");
                  this.fill();
                }
                fillStroke() {
                  this.stroke();
                  this.fill();
                }
                eoFillStroke() {
                  this.current.element?.setAttributeNS(null, "fill-rule", "evenodd");
                  this.fillStroke();
                }
                closeStroke() {
                  this.closePath();
                  this.stroke();
                }
                closeFillStroke() {
                  this.closePath();
                  this.fillStroke();
                }
                closeEOFillStroke() {
                  this.closePath();
                  this.eoFillStroke();
                }
                paintSolidColorImageMask() {
                  const rect = this.svgFactory.createElement("svg:rect");
                  rect.setAttributeNS(null, "x", "0");
                  rect.setAttributeNS(null, "y", "0");
                  rect.setAttributeNS(null, "width", "1px");
                  rect.setAttributeNS(null, "height", "1px");
                  rect.setAttributeNS(null, "fill", this.current.fillColor);
                  this._ensureTransformGroup().append(rect);
                }
                paintImageXObject(objId) {
                  const imgData = this.getObject(objId);
                  if (!imgData) {
                    (0, _util2.warn)(`Dependent image with object ID ${objId} is not ready yet`);
                    return;
                  }
                  this.paintInlineImageXObject(imgData);
                }
                paintInlineImageXObject(imgData, mask) {
                  const width = imgData.width;
                  const height = imgData.height;
                  const imgSrc = convertImgDataToPng(imgData, this.forceDataSchema, !!mask);
                  const cliprect = this.svgFactory.createElement("svg:rect");
                  cliprect.setAttributeNS(null, "x", "0");
                  cliprect.setAttributeNS(null, "y", "0");
                  cliprect.setAttributeNS(null, "width", pf(width));
                  cliprect.setAttributeNS(null, "height", pf(height));
                  this.current.element = cliprect;
                  this.clip("nonzero");
                  const imgEl = this.svgFactory.createElement("svg:image");
                  imgEl.setAttributeNS(XLINK_NS, "xlink:href", imgSrc);
                  imgEl.setAttributeNS(null, "x", "0");
                  imgEl.setAttributeNS(null, "y", pf(-height));
                  imgEl.setAttributeNS(null, "width", pf(width) + "px");
                  imgEl.setAttributeNS(null, "height", pf(height) + "px");
                  imgEl.setAttributeNS(null, "transform", `scale(${pf(1 / width)} ${pf(-1 / height)})`);
                  if (mask) {
                    mask.append(imgEl);
                  } else {
                    this._ensureTransformGroup().append(imgEl);
                  }
                }
                paintImageMaskXObject(img) {
                  const imgData = this.getObject(img.data, img);
                  if (imgData.bitmap) {
                    (0, _util2.warn)("paintImageMaskXObject: ImageBitmap support is not implemented, ensure that the `isOffscreenCanvasSupported` API parameter is disabled.");
                    return;
                  }
                  const current2 = this.current;
                  const width = imgData.width;
                  const height = imgData.height;
                  const fillColor = current2.fillColor;
                  current2.maskId = `mask${maskCount++}`;
                  const mask = this.svgFactory.createElement("svg:mask");
                  mask.setAttributeNS(null, "id", current2.maskId);
                  const rect = this.svgFactory.createElement("svg:rect");
                  rect.setAttributeNS(null, "x", "0");
                  rect.setAttributeNS(null, "y", "0");
                  rect.setAttributeNS(null, "width", pf(width));
                  rect.setAttributeNS(null, "height", pf(height));
                  rect.setAttributeNS(null, "fill", fillColor);
                  rect.setAttributeNS(null, "mask", `url(#${current2.maskId})`);
                  this.defs.append(mask);
                  this._ensureTransformGroup().append(rect);
                  this.paintInlineImageXObject(imgData, mask);
                }
                paintFormXObjectBegin(matrix, bbox) {
                  if (Array.isArray(matrix) && matrix.length === 6) {
                    this.transform(matrix[0], matrix[1], matrix[2], matrix[3], matrix[4], matrix[5]);
                  }
                  if (bbox) {
                    const width = bbox[2] - bbox[0];
                    const height = bbox[3] - bbox[1];
                    const cliprect = this.svgFactory.createElement("svg:rect");
                    cliprect.setAttributeNS(null, "x", bbox[0]);
                    cliprect.setAttributeNS(null, "y", bbox[1]);
                    cliprect.setAttributeNS(null, "width", pf(width));
                    cliprect.setAttributeNS(null, "height", pf(height));
                    this.current.element = cliprect;
                    this.clip("nonzero");
                    this.endPath();
                  }
                }
                paintFormXObjectEnd() {
                }
                _initialize(viewport) {
                  const svg = this.svgFactory.create(viewport.width, viewport.height);
                  const definitions = this.svgFactory.createElement("svg:defs");
                  svg.append(definitions);
                  this.defs = definitions;
                  const rootGroup = this.svgFactory.createElement("svg:g");
                  rootGroup.setAttributeNS(null, "transform", pm(viewport.transform));
                  svg.append(rootGroup);
                  this.svg = rootGroup;
                  return svg;
                }
                _ensureClipGroup() {
                  if (!this.current.clipGroup) {
                    const clipGroup = this.svgFactory.createElement("svg:g");
                    clipGroup.setAttributeNS(null, "clip-path", this.current.activeClipUrl);
                    this.svg.append(clipGroup);
                    this.current.clipGroup = clipGroup;
                  }
                  return this.current.clipGroup;
                }
                _ensureTransformGroup() {
                  if (!this.tgrp) {
                    this.tgrp = this.svgFactory.createElement("svg:g");
                    this.tgrp.setAttributeNS(null, "transform", pm(this.transformMatrix));
                    if (this.current.activeClipUrl) {
                      this._ensureClipGroup().append(this.tgrp);
                    } else {
                      this.svg.append(this.tgrp);
                    }
                  }
                  return this.tgrp;
                }
              }
              exports2.SVGGraphics = SVGGraphics;
            }),
            /* 25 */
            /***/
            ((__unused_webpack_module2, exports2) => {
              Object.defineProperty(exports2, "__esModule", {
                value: true
              });
              exports2.XfaText = void 0;
              class XfaText {
                static textContent(xfa) {
                  const items = [];
                  const output = {
                    items,
                    styles: /* @__PURE__ */ Object.create(null)
                  };
                  function walk(node2) {
                    if (!node2) {
                      return;
                    }
                    let str = null;
                    const name = node2.name;
                    if (name === "#text") {
                      str = node2.value;
                    } else if (!XfaText.shouldBuildText(name)) {
                      return;
                    } else if (node2?.attributes?.textContent) {
                      str = node2.attributes.textContent;
                    } else if (node2.value) {
                      str = node2.value;
                    }
                    if (str !== null) {
                      items.push({
                        str
                      });
                    }
                    if (!node2.children) {
                      return;
                    }
                    for (const child of node2.children) {
                      walk(child);
                    }
                  }
                  walk(xfa);
                  return output;
                }
                static shouldBuildText(name) {
                  return !(name === "textarea" || name === "input" || name === "option" || name === "select");
                }
              }
              exports2.XfaText = XfaText;
            }),
            /* 26 */
            /***/
            ((__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
              Object.defineProperty(exports2, "__esModule", {
                value: true
              });
              exports2.TextLayerRenderTask = void 0;
              exports2.renderTextLayer = renderTextLayer;
              exports2.updateTextLayer = updateTextLayer;
              var _util2 = __w_pdfjs_require__2(1);
              var _display_utils2 = __w_pdfjs_require__2(6);
              const MAX_TEXT_DIVS_TO_RENDER = 1e5;
              const DEFAULT_FONT_SIZE2 = 30;
              const DEFAULT_FONT_ASCENT = 0.8;
              const ascentCache = /* @__PURE__ */ new Map();
              function getCtx(size, isOffscreenCanvasSupported) {
                let ctx;
                if (isOffscreenCanvasSupported && _util2.FeatureTest.isOffscreenCanvasSupported) {
                  ctx = new OffscreenCanvas(size, size).getContext("2d", {
                    alpha: false
                  });
                } else {
                  const canvas = document.createElement("canvas");
                  canvas.width = canvas.height = size;
                  ctx = canvas.getContext("2d", {
                    alpha: false
                  });
                }
                return ctx;
              }
              function getAscent(fontFamily, isOffscreenCanvasSupported) {
                const cachedAscent = ascentCache.get(fontFamily);
                if (cachedAscent) {
                  return cachedAscent;
                }
                const ctx = getCtx(DEFAULT_FONT_SIZE2, isOffscreenCanvasSupported);
                ctx.font = `${DEFAULT_FONT_SIZE2}px ${fontFamily}`;
                const metrics = ctx.measureText("");
                let ascent = metrics.fontBoundingBoxAscent;
                let descent = Math.abs(metrics.fontBoundingBoxDescent);
                if (ascent) {
                  const ratio = ascent / (ascent + descent);
                  ascentCache.set(fontFamily, ratio);
                  ctx.canvas.width = ctx.canvas.height = 0;
                  return ratio;
                }
                ctx.strokeStyle = "red";
                ctx.clearRect(0, 0, DEFAULT_FONT_SIZE2, DEFAULT_FONT_SIZE2);
                ctx.strokeText("g", 0, 0);
                let pixels = ctx.getImageData(0, 0, DEFAULT_FONT_SIZE2, DEFAULT_FONT_SIZE2).data;
                descent = 0;
                for (let i = pixels.length - 1 - 3; i >= 0; i -= 4) {
                  if (pixels[i] > 0) {
                    descent = Math.ceil(i / 4 / DEFAULT_FONT_SIZE2);
                    break;
                  }
                }
                ctx.clearRect(0, 0, DEFAULT_FONT_SIZE2, DEFAULT_FONT_SIZE2);
                ctx.strokeText("A", 0, DEFAULT_FONT_SIZE2);
                pixels = ctx.getImageData(0, 0, DEFAULT_FONT_SIZE2, DEFAULT_FONT_SIZE2).data;
                ascent = 0;
                for (let i = 0, ii = pixels.length; i < ii; i += 4) {
                  if (pixels[i] > 0) {
                    ascent = DEFAULT_FONT_SIZE2 - Math.floor(i / 4 / DEFAULT_FONT_SIZE2);
                    break;
                  }
                }
                ctx.canvas.width = ctx.canvas.height = 0;
                if (ascent) {
                  const ratio = ascent / (ascent + descent);
                  ascentCache.set(fontFamily, ratio);
                  return ratio;
                }
                ascentCache.set(fontFamily, DEFAULT_FONT_ASCENT);
                return DEFAULT_FONT_ASCENT;
              }
              function appendText(task, geom, styles) {
                const textDiv = document.createElement("span");
                const textDivProperties = {
                  angle: 0,
                  canvasWidth: 0,
                  hasText: geom.str !== "",
                  hasEOL: geom.hasEOL,
                  fontSize: 0
                };
                task._textDivs.push(textDiv);
                const tx = _util2.Util.transform(task._transform, geom.transform);
                let angle = Math.atan2(tx[1], tx[0]);
                const style2 = styles[geom.fontName];
                if (style2.vertical) {
                  angle += Math.PI / 2;
                }
                const fontHeight = Math.hypot(tx[2], tx[3]);
                const fontAscent = fontHeight * getAscent(style2.fontFamily, task._isOffscreenCanvasSupported);
                let left2, top;
                if (angle === 0) {
                  left2 = tx[4];
                  top = tx[5] - fontAscent;
                } else {
                  left2 = tx[4] + fontAscent * Math.sin(angle);
                  top = tx[5] - fontAscent * Math.cos(angle);
                }
                const scaleFactorStr = "calc(var(--scale-factor)*";
                const divStyle = textDiv.style;
                if (task._container === task._rootContainer) {
                  divStyle.left = `${(100 * left2 / task._pageWidth).toFixed(2)}%`;
                  divStyle.top = `${(100 * top / task._pageHeight).toFixed(2)}%`;
                } else {
                  divStyle.left = `${scaleFactorStr}${left2.toFixed(2)}px)`;
                  divStyle.top = `${scaleFactorStr}${top.toFixed(2)}px)`;
                }
                divStyle.fontSize = `${scaleFactorStr}${fontHeight.toFixed(2)}px)`;
                divStyle.fontFamily = style2.fontFamily;
                textDivProperties.fontSize = fontHeight;
                textDiv.setAttribute("role", "presentation");
                textDiv.textContent = geom.str;
                textDiv.dir = geom.dir;
                if (task._fontInspectorEnabled) {
                  textDiv.dataset.fontName = geom.fontName;
                }
                if (angle !== 0) {
                  textDivProperties.angle = angle * (180 / Math.PI);
                }
                let shouldScaleText = false;
                if (geom.str.length > 1) {
                  shouldScaleText = true;
                } else if (geom.str !== " " && geom.transform[0] !== geom.transform[3]) {
                  const absScaleX = Math.abs(geom.transform[0]), absScaleY = Math.abs(geom.transform[3]);
                  if (absScaleX !== absScaleY && Math.max(absScaleX, absScaleY) / Math.min(absScaleX, absScaleY) > 1.5) {
                    shouldScaleText = true;
                  }
                }
                if (shouldScaleText) {
                  textDivProperties.canvasWidth = style2.vertical ? geom.height : geom.width;
                }
                task._textDivProperties.set(textDiv, textDivProperties);
                if (task._isReadableStream) {
                  task._layoutText(textDiv);
                }
              }
              function layout(params) {
                const {
                  div,
                  scale,
                  properties: properties2,
                  ctx,
                  prevFontSize,
                  prevFontFamily
                } = params;
                const {
                  style: style2
                } = div;
                let transform = "";
                if (properties2.canvasWidth !== 0 && properties2.hasText) {
                  const {
                    fontFamily
                  } = style2;
                  const {
                    canvasWidth,
                    fontSize
                  } = properties2;
                  if (prevFontSize !== fontSize || prevFontFamily !== fontFamily) {
                    ctx.font = `${fontSize * scale}px ${fontFamily}`;
                    params.prevFontSize = fontSize;
                    params.prevFontFamily = fontFamily;
                  }
                  const {
                    width
                  } = ctx.measureText(div.textContent);
                  if (width > 0) {
                    transform = `scaleX(${canvasWidth * scale / width})`;
                  }
                }
                if (properties2.angle !== 0) {
                  transform = `rotate(${properties2.angle}deg) ${transform}`;
                }
                if (transform.length > 0) {
                  style2.transform = transform;
                }
              }
              function render4(task) {
                if (task._canceled) {
                  return;
                }
                const textDivs = task._textDivs;
                const capability = task._capability;
                const textDivsLength = textDivs.length;
                if (textDivsLength > MAX_TEXT_DIVS_TO_RENDER) {
                  capability.resolve();
                  return;
                }
                if (!task._isReadableStream) {
                  for (const textDiv of textDivs) {
                    task._layoutText(textDiv);
                  }
                }
                capability.resolve();
              }
              class TextLayerRenderTask {
                constructor({
                  textContentSource,
                  container,
                  viewport,
                  textDivs,
                  textDivProperties,
                  textContentItemsStr,
                  isOffscreenCanvasSupported
                }) {
                  this._textContentSource = textContentSource;
                  this._isReadableStream = textContentSource instanceof ReadableStream;
                  this._container = this._rootContainer = container;
                  this._textDivs = textDivs || [];
                  this._textContentItemsStr = textContentItemsStr || [];
                  this._isOffscreenCanvasSupported = isOffscreenCanvasSupported;
                  this._fontInspectorEnabled = !!globalThis.FontInspector?.enabled;
                  this._reader = null;
                  this._textDivProperties = textDivProperties || /* @__PURE__ */ new WeakMap();
                  this._canceled = false;
                  this._capability = new _util2.PromiseCapability();
                  this._layoutTextParams = {
                    prevFontSize: null,
                    prevFontFamily: null,
                    div: null,
                    scale: viewport.scale * (globalThis.devicePixelRatio || 1),
                    properties: null,
                    ctx: getCtx(0, isOffscreenCanvasSupported)
                  };
                  const {
                    pageWidth,
                    pageHeight,
                    pageX,
                    pageY
                  } = viewport.rawDims;
                  this._transform = [1, 0, 0, -1, -pageX, pageY + pageHeight];
                  this._pageWidth = pageWidth;
                  this._pageHeight = pageHeight;
                  (0, _display_utils2.setLayerDimensions)(container, viewport);
                  this._capability.promise.finally(() => {
                    this._layoutTextParams = null;
                  }).catch(() => {
                  });
                }
                get promise() {
                  return this._capability.promise;
                }
                cancel() {
                  this._canceled = true;
                  if (this._reader) {
                    this._reader.cancel(new _util2.AbortException("TextLayer task cancelled.")).catch(() => {
                    });
                    this._reader = null;
                  }
                  this._capability.reject(new _util2.AbortException("TextLayer task cancelled."));
                }
                _processItems(items, styleCache) {
                  for (const item of items) {
                    if (item.str === void 0) {
                      if (item.type === "beginMarkedContentProps" || item.type === "beginMarkedContent") {
                        const parent2 = this._container;
                        this._container = document.createElement("span");
                        this._container.classList.add("markedContent");
                        if (item.id !== null) {
                          this._container.setAttribute("id", `${item.id}`);
                        }
                        parent2.append(this._container);
                      } else if (item.type === "endMarkedContent") {
                        this._container = this._container.parentNode;
                      }
                      continue;
                    }
                    this._textContentItemsStr.push(item.str);
                    appendText(this, item, styleCache);
                  }
                }
                _layoutText(textDiv) {
                  const textDivProperties = this._layoutTextParams.properties = this._textDivProperties.get(textDiv);
                  this._layoutTextParams.div = textDiv;
                  layout(this._layoutTextParams);
                  if (textDivProperties.hasText) {
                    this._container.append(textDiv);
                  }
                  if (textDivProperties.hasEOL) {
                    const br = document.createElement("br");
                    br.setAttribute("role", "presentation");
                    this._container.append(br);
                  }
                }
                _render() {
                  const capability = new _util2.PromiseCapability();
                  let styleCache = /* @__PURE__ */ Object.create(null);
                  if (this._isReadableStream) {
                    const pump = () => {
                      this._reader.read().then(({
                        value,
                        done
                      }) => {
                        if (done) {
                          capability.resolve();
                          return;
                        }
                        Object.assign(styleCache, value.styles);
                        this._processItems(value.items, styleCache);
                        pump();
                      }, capability.reject);
                    };
                    this._reader = this._textContentSource.getReader();
                    pump();
                  } else if (this._textContentSource) {
                    const {
                      items,
                      styles
                    } = this._textContentSource;
                    this._processItems(items, styles);
                    capability.resolve();
                  } else {
                    throw new Error('No "textContentSource" parameter specified.');
                  }
                  capability.promise.then(() => {
                    styleCache = null;
                    render4(this);
                  }, this._capability.reject);
                }
              }
              exports2.TextLayerRenderTask = TextLayerRenderTask;
              function renderTextLayer(params) {
                if (!params.textContentSource && (params.textContent || params.textContentStream)) {
                  (0, _display_utils2.deprecated)("The TextLayerRender `textContent`/`textContentStream` parameters will be removed in the future, please use `textContentSource` instead.");
                  params.textContentSource = params.textContent || params.textContentStream;
                }
                const {
                  container,
                  viewport
                } = params;
                const style2 = getComputedStyle(container);
                const visibility = style2.getPropertyValue("visibility");
                const scaleFactor = parseFloat(style2.getPropertyValue("--scale-factor"));
                if (visibility === "visible" && (!scaleFactor || Math.abs(scaleFactor - viewport.scale) > 1e-5)) {
                  console.error("The `--scale-factor` CSS-variable must be set, to the same value as `viewport.scale`, either on the `container`-element itself or higher up in the DOM.");
                }
                const task = new TextLayerRenderTask(params);
                task._render();
                return task;
              }
              function updateTextLayer({
                container,
                viewport,
                textDivs,
                textDivProperties,
                isOffscreenCanvasSupported,
                mustRotate = true,
                mustRescale = true
              }) {
                if (mustRotate) {
                  (0, _display_utils2.setLayerDimensions)(container, {
                    rotation: viewport.rotation
                  });
                }
                if (mustRescale) {
                  const ctx = getCtx(0, isOffscreenCanvasSupported);
                  const scale = viewport.scale * (globalThis.devicePixelRatio || 1);
                  const params = {
                    prevFontSize: null,
                    prevFontFamily: null,
                    div: null,
                    scale,
                    properties: null,
                    ctx
                  };
                  for (const div of textDivs) {
                    params.properties = textDivProperties.get(div);
                    params.div = div;
                    layout(params);
                  }
                }
              }
            }),
            /* 27 */
            /***/
            ((__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
              Object.defineProperty(exports2, "__esModule", {
                value: true
              });
              exports2.AnnotationEditorLayer = void 0;
              var _util2 = __w_pdfjs_require__2(1);
              var _editor = __w_pdfjs_require__2(4);
              var _freetext = __w_pdfjs_require__2(28);
              var _ink = __w_pdfjs_require__2(33);
              var _display_utils2 = __w_pdfjs_require__2(6);
              var _stamp = __w_pdfjs_require__2(34);
              class AnnotationEditorLayer {
                #accessibilityManager;
                #allowClick = false;
                #annotationLayer = null;
                #boundPointerup = this.pointerup.bind(this);
                #boundPointerdown = this.pointerdown.bind(this);
                #editors = /* @__PURE__ */ new Map();
                #hadPointerDown = false;
                #isCleaningUp = false;
                #isDisabling = false;
                #uiManager;
                static _initialized = false;
                constructor({
                  uiManager,
                  pageIndex,
                  div,
                  accessibilityManager,
                  annotationLayer,
                  viewport,
                  l10n
                }) {
                  const editorTypes = [_freetext.FreeTextEditor, _ink.InkEditor, _stamp.StampEditor];
                  if (!AnnotationEditorLayer._initialized) {
                    AnnotationEditorLayer._initialized = true;
                    for (const editorType of editorTypes) {
                      editorType.initialize(l10n);
                    }
                  }
                  uiManager.registerEditorTypes(editorTypes);
                  this.#uiManager = uiManager;
                  this.pageIndex = pageIndex;
                  this.div = div;
                  this.#accessibilityManager = accessibilityManager;
                  this.#annotationLayer = annotationLayer;
                  this.viewport = viewport;
                  this.#uiManager.addLayer(this);
                }
                get isEmpty() {
                  return this.#editors.size === 0;
                }
                updateToolbar(mode) {
                  this.#uiManager.updateToolbar(mode);
                }
                updateMode(mode = this.#uiManager.getMode()) {
                  this.#cleanup();
                  if (mode === _util2.AnnotationEditorType.INK) {
                    this.addInkEditorIfNeeded(false);
                    this.disableClick();
                  } else {
                    this.enableClick();
                  }
                  if (mode !== _util2.AnnotationEditorType.NONE) {
                    this.div.classList.toggle("freeTextEditing", mode === _util2.AnnotationEditorType.FREETEXT);
                    this.div.classList.toggle("inkEditing", mode === _util2.AnnotationEditorType.INK);
                    this.div.classList.toggle("stampEditing", mode === _util2.AnnotationEditorType.STAMP);
                    this.div.hidden = false;
                  }
                }
                addInkEditorIfNeeded(isCommitting) {
                  if (!isCommitting && this.#uiManager.getMode() !== _util2.AnnotationEditorType.INK) {
                    return;
                  }
                  if (!isCommitting) {
                    for (const editor2 of this.#editors.values()) {
                      if (editor2.isEmpty()) {
                        editor2.setInBackground();
                        return;
                      }
                    }
                  }
                  const editor = this.#createAndAddNewEditor({
                    offsetX: 0,
                    offsetY: 0
                  }, false);
                  editor.setInBackground();
                }
                setEditingState(isEditing) {
                  this.#uiManager.setEditingState(isEditing);
                }
                addCommands(params) {
                  this.#uiManager.addCommands(params);
                }
                enable() {
                  this.div.style.pointerEvents = "auto";
                  const annotationElementIds = /* @__PURE__ */ new Set();
                  for (const editor of this.#editors.values()) {
                    editor.enableEditing();
                    if (editor.annotationElementId) {
                      annotationElementIds.add(editor.annotationElementId);
                    }
                  }
                  if (!this.#annotationLayer) {
                    return;
                  }
                  const editables = this.#annotationLayer.getEditableAnnotations();
                  for (const editable of editables) {
                    editable.hide();
                    if (this.#uiManager.isDeletedAnnotationElement(editable.data.id)) {
                      continue;
                    }
                    if (annotationElementIds.has(editable.data.id)) {
                      continue;
                    }
                    const editor = this.deserialize(editable);
                    if (!editor) {
                      continue;
                    }
                    this.addOrRebuild(editor);
                    editor.enableEditing();
                  }
                }
                disable() {
                  this.#isDisabling = true;
                  this.div.style.pointerEvents = "none";
                  const hiddenAnnotationIds = /* @__PURE__ */ new Set();
                  for (const editor of this.#editors.values()) {
                    editor.disableEditing();
                    if (!editor.annotationElementId || editor.serialize() !== null) {
                      hiddenAnnotationIds.add(editor.annotationElementId);
                      continue;
                    }
                    this.getEditableAnnotation(editor.annotationElementId)?.show();
                    editor.remove();
                  }
                  if (this.#annotationLayer) {
                    const editables = this.#annotationLayer.getEditableAnnotations();
                    for (const editable of editables) {
                      const {
                        id
                      } = editable.data;
                      if (hiddenAnnotationIds.has(id) || this.#uiManager.isDeletedAnnotationElement(id)) {
                        continue;
                      }
                      editable.show();
                    }
                  }
                  this.#cleanup();
                  if (this.isEmpty) {
                    this.div.hidden = true;
                  }
                  this.#isDisabling = false;
                }
                getEditableAnnotation(id) {
                  return this.#annotationLayer?.getEditableAnnotation(id) || null;
                }
                setActiveEditor(editor) {
                  const currentActive = this.#uiManager.getActive();
                  if (currentActive === editor) {
                    return;
                  }
                  this.#uiManager.setActiveEditor(editor);
                }
                enableClick() {
                  this.div.addEventListener("pointerdown", this.#boundPointerdown);
                  this.div.addEventListener("pointerup", this.#boundPointerup);
                }
                disableClick() {
                  this.div.removeEventListener("pointerdown", this.#boundPointerdown);
                  this.div.removeEventListener("pointerup", this.#boundPointerup);
                }
                attach(editor) {
                  this.#editors.set(editor.id, editor);
                  const {
                    annotationElementId
                  } = editor;
                  if (annotationElementId && this.#uiManager.isDeletedAnnotationElement(annotationElementId)) {
                    this.#uiManager.removeDeletedAnnotationElement(editor);
                  }
                }
                detach(editor) {
                  this.#editors.delete(editor.id);
                  this.#accessibilityManager?.removePointerInTextLayer(editor.contentDiv);
                  if (!this.#isDisabling && editor.annotationElementId) {
                    this.#uiManager.addDeletedAnnotationElement(editor);
                  }
                }
                remove(editor) {
                  this.detach(editor);
                  this.#uiManager.removeEditor(editor);
                  if (editor.div.contains(document.activeElement)) {
                    setTimeout(() => {
                      this.#uiManager.focusMainContainer();
                    }, 0);
                  }
                  editor.div.remove();
                  editor.isAttachedToDOM = false;
                  if (!this.#isCleaningUp) {
                    this.addInkEditorIfNeeded(false);
                  }
                }
                changeParent(editor) {
                  if (editor.parent === this) {
                    return;
                  }
                  if (editor.annotationElementId) {
                    this.#uiManager.addDeletedAnnotationElement(editor.annotationElementId);
                    _editor.AnnotationEditor.deleteAnnotationElement(editor);
                    editor.annotationElementId = null;
                  }
                  this.attach(editor);
                  editor.parent?.detach(editor);
                  editor.setParent(this);
                  if (editor.div && editor.isAttachedToDOM) {
                    editor.div.remove();
                    this.div.append(editor.div);
                  }
                }
                add(editor) {
                  this.changeParent(editor);
                  this.#uiManager.addEditor(editor);
                  this.attach(editor);
                  if (!editor.isAttachedToDOM) {
                    const div = editor.render();
                    this.div.append(div);
                    editor.isAttachedToDOM = true;
                  }
                  editor.fixAndSetPosition();
                  editor.onceAdded();
                  this.#uiManager.addToAnnotationStorage(editor);
                }
                moveEditorInDOM(editor) {
                  if (!editor.isAttachedToDOM) {
                    return;
                  }
                  const {
                    activeElement
                  } = document;
                  if (editor.div.contains(activeElement)) {
                    editor._focusEventsAllowed = false;
                    setTimeout(() => {
                      if (!editor.div.contains(document.activeElement)) {
                        editor.div.addEventListener("focusin", () => {
                          editor._focusEventsAllowed = true;
                        }, {
                          once: true
                        });
                        activeElement.focus();
                      } else {
                        editor._focusEventsAllowed = true;
                      }
                    }, 0);
                  }
                  editor._structTreeParentId = this.#accessibilityManager?.moveElementInDOM(this.div, editor.div, editor.contentDiv, true);
                }
                addOrRebuild(editor) {
                  if (editor.needsToBeRebuilt()) {
                    editor.rebuild();
                  } else {
                    this.add(editor);
                  }
                }
                addUndoableEditor(editor) {
                  const cmd = () => editor._uiManager.rebuild(editor);
                  const undo = () => {
                    editor.remove();
                  };
                  this.addCommands({
                    cmd,
                    undo,
                    mustExec: false
                  });
                }
                getNextId() {
                  return this.#uiManager.getId();
                }
                #createNewEditor(params) {
                  switch (this.#uiManager.getMode()) {
                    case _util2.AnnotationEditorType.FREETEXT:
                      return new _freetext.FreeTextEditor(params);
                    case _util2.AnnotationEditorType.INK:
                      return new _ink.InkEditor(params);
                    case _util2.AnnotationEditorType.STAMP:
                      return new _stamp.StampEditor(params);
                  }
                  return null;
                }
                pasteEditor(mode, params) {
                  this.#uiManager.updateToolbar(mode);
                  this.#uiManager.updateMode(mode);
                  const {
                    offsetX,
                    offsetY
                  } = this.#getCenterPoint();
                  const id = this.getNextId();
                  const editor = this.#createNewEditor({
                    parent: this,
                    id,
                    x: offsetX,
                    y: offsetY,
                    uiManager: this.#uiManager,
                    isCentered: true,
                    ...params
                  });
                  if (editor) {
                    this.add(editor);
                  }
                }
                deserialize(data2) {
                  switch (data2.annotationType ?? data2.annotationEditorType) {
                    case _util2.AnnotationEditorType.FREETEXT:
                      return _freetext.FreeTextEditor.deserialize(data2, this, this.#uiManager);
                    case _util2.AnnotationEditorType.INK:
                      return _ink.InkEditor.deserialize(data2, this, this.#uiManager);
                    case _util2.AnnotationEditorType.STAMP:
                      return _stamp.StampEditor.deserialize(data2, this, this.#uiManager);
                  }
                  return null;
                }
                #createAndAddNewEditor(event, isCentered) {
                  const id = this.getNextId();
                  const editor = this.#createNewEditor({
                    parent: this,
                    id,
                    x: event.offsetX,
                    y: event.offsetY,
                    uiManager: this.#uiManager,
                    isCentered
                  });
                  if (editor) {
                    this.add(editor);
                  }
                  return editor;
                }
                #getCenterPoint() {
                  const {
                    x,
                    y,
                    width,
                    height
                  } = this.div.getBoundingClientRect();
                  const tlX = Math.max(0, x);
                  const tlY = Math.max(0, y);
                  const brX = Math.min(window.innerWidth, x + width);
                  const brY = Math.min(window.innerHeight, y + height);
                  const centerX = (tlX + brX) / 2 - x;
                  const centerY = (tlY + brY) / 2 - y;
                  const [offsetX, offsetY] = this.viewport.rotation % 180 === 0 ? [centerX, centerY] : [centerY, centerX];
                  return {
                    offsetX,
                    offsetY
                  };
                }
                addNewEditor() {
                  this.#createAndAddNewEditor(this.#getCenterPoint(), true);
                }
                setSelected(editor) {
                  this.#uiManager.setSelected(editor);
                }
                toggleSelected(editor) {
                  this.#uiManager.toggleSelected(editor);
                }
                isSelected(editor) {
                  return this.#uiManager.isSelected(editor);
                }
                unselect(editor) {
                  this.#uiManager.unselect(editor);
                }
                pointerup(event) {
                  const {
                    isMac
                  } = _util2.FeatureTest.platform;
                  if (event.button !== 0 || event.ctrlKey && isMac) {
                    return;
                  }
                  if (event.target !== this.div) {
                    return;
                  }
                  if (!this.#hadPointerDown) {
                    return;
                  }
                  this.#hadPointerDown = false;
                  if (!this.#allowClick) {
                    this.#allowClick = true;
                    return;
                  }
                  if (this.#uiManager.getMode() === _util2.AnnotationEditorType.STAMP) {
                    this.#uiManager.unselectAll();
                    return;
                  }
                  this.#createAndAddNewEditor(event, false);
                }
                pointerdown(event) {
                  if (this.#hadPointerDown) {
                    this.#hadPointerDown = false;
                    return;
                  }
                  const {
                    isMac
                  } = _util2.FeatureTest.platform;
                  if (event.button !== 0 || event.ctrlKey && isMac) {
                    return;
                  }
                  if (event.target !== this.div) {
                    return;
                  }
                  this.#hadPointerDown = true;
                  const editor = this.#uiManager.getActive();
                  this.#allowClick = !editor || editor.isEmpty();
                }
                findNewParent(editor, x, y) {
                  const layer = this.#uiManager.findParent(x, y);
                  if (layer === null || layer === this) {
                    return false;
                  }
                  layer.changeParent(editor);
                  return true;
                }
                destroy() {
                  if (this.#uiManager.getActive()?.parent === this) {
                    this.#uiManager.commitOrRemove();
                    this.#uiManager.setActiveEditor(null);
                  }
                  for (const editor of this.#editors.values()) {
                    this.#accessibilityManager?.removePointerInTextLayer(editor.contentDiv);
                    editor.setParent(null);
                    editor.isAttachedToDOM = false;
                    editor.div.remove();
                  }
                  this.div = null;
                  this.#editors.clear();
                  this.#uiManager.removeLayer(this);
                }
                #cleanup() {
                  this.#isCleaningUp = true;
                  for (const editor of this.#editors.values()) {
                    if (editor.isEmpty()) {
                      editor.remove();
                    }
                  }
                  this.#isCleaningUp = false;
                }
                render({
                  viewport
                }) {
                  this.viewport = viewport;
                  (0, _display_utils2.setLayerDimensions)(this.div, viewport);
                  for (const editor of this.#uiManager.getEditors(this.pageIndex)) {
                    this.add(editor);
                  }
                  this.updateMode();
                }
                update({
                  viewport
                }) {
                  this.#uiManager.commitOrRemove();
                  this.viewport = viewport;
                  (0, _display_utils2.setLayerDimensions)(this.div, {
                    rotation: viewport.rotation
                  });
                  this.updateMode();
                }
                get pageDimensions() {
                  const {
                    pageWidth,
                    pageHeight
                  } = this.viewport.rawDims;
                  return [pageWidth, pageHeight];
                }
              }
              exports2.AnnotationEditorLayer = AnnotationEditorLayer;
            }),
            /* 28 */
            /***/
            ((__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
              Object.defineProperty(exports2, "__esModule", {
                value: true
              });
              exports2.FreeTextEditor = void 0;
              var _util2 = __w_pdfjs_require__2(1);
              var _tools = __w_pdfjs_require__2(5);
              var _editor = __w_pdfjs_require__2(4);
              var _annotation_layer = __w_pdfjs_require__2(29);
              class FreeTextEditor extends _editor.AnnotationEditor {
                #boundEditorDivBlur = this.editorDivBlur.bind(this);
                #boundEditorDivFocus = this.editorDivFocus.bind(this);
                #boundEditorDivInput = this.editorDivInput.bind(this);
                #boundEditorDivKeydown = this.editorDivKeydown.bind(this);
                #color;
                #content = "";
                #editorDivId = `${this.id}-editor`;
                #fontSize;
                #initialData = null;
                static _freeTextDefaultContent = "";
                static _internalPadding = 0;
                static _defaultColor = null;
                static _defaultFontSize = 10;
                static get _keyboardManager() {
                  const proto = FreeTextEditor.prototype;
                  const arrowChecker = (self2) => self2.isEmpty();
                  const small = _tools.AnnotationEditorUIManager.TRANSLATE_SMALL;
                  const big = _tools.AnnotationEditorUIManager.TRANSLATE_BIG;
                  return (0, _util2.shadow)(this, "_keyboardManager", new _tools.KeyboardManager([[["ctrl+s", "mac+meta+s", "ctrl+p", "mac+meta+p"], proto.commitOrRemove, {
                    bubbles: true
                  }], [["ctrl+Enter", "mac+meta+Enter", "Escape", "mac+Escape"], proto.commitOrRemove], [["ArrowLeft", "mac+ArrowLeft"], proto._translateEmpty, {
                    args: [-small, 0],
                    checker: arrowChecker
                  }], [["ctrl+ArrowLeft", "mac+shift+ArrowLeft"], proto._translateEmpty, {
                    args: [-big, 0],
                    checker: arrowChecker
                  }], [["ArrowRight", "mac+ArrowRight"], proto._translateEmpty, {
                    args: [small, 0],
                    checker: arrowChecker
                  }], [["ctrl+ArrowRight", "mac+shift+ArrowRight"], proto._translateEmpty, {
                    args: [big, 0],
                    checker: arrowChecker
                  }], [["ArrowUp", "mac+ArrowUp"], proto._translateEmpty, {
                    args: [0, -small],
                    checker: arrowChecker
                  }], [["ctrl+ArrowUp", "mac+shift+ArrowUp"], proto._translateEmpty, {
                    args: [0, -big],
                    checker: arrowChecker
                  }], [["ArrowDown", "mac+ArrowDown"], proto._translateEmpty, {
                    args: [0, small],
                    checker: arrowChecker
                  }], [["ctrl+ArrowDown", "mac+shift+ArrowDown"], proto._translateEmpty, {
                    args: [0, big],
                    checker: arrowChecker
                  }]]));
                }
                static _type = "freetext";
                constructor(params) {
                  super({
                    ...params,
                    name: "freeTextEditor"
                  });
                  this.#color = params.color || FreeTextEditor._defaultColor || _editor.AnnotationEditor._defaultLineColor;
                  this.#fontSize = params.fontSize || FreeTextEditor._defaultFontSize;
                }
                static initialize(l10n) {
                  _editor.AnnotationEditor.initialize(l10n, {
                    strings: ["free_text2_default_content", "editor_free_text2_aria_label"]
                  });
                  const style2 = getComputedStyle(document.documentElement);
                  this._internalPadding = parseFloat(style2.getPropertyValue("--freetext-padding"));
                }
                static updateDefaultParams(type5, value) {
                  switch (type5) {
                    case _util2.AnnotationEditorParamsType.FREETEXT_SIZE:
                      FreeTextEditor._defaultFontSize = value;
                      break;
                    case _util2.AnnotationEditorParamsType.FREETEXT_COLOR:
                      FreeTextEditor._defaultColor = value;
                      break;
                  }
                }
                updateParams(type5, value) {
                  switch (type5) {
                    case _util2.AnnotationEditorParamsType.FREETEXT_SIZE:
                      this.#updateFontSize(value);
                      break;
                    case _util2.AnnotationEditorParamsType.FREETEXT_COLOR:
                      this.#updateColor(value);
                      break;
                  }
                }
                static get defaultPropertiesToUpdate() {
                  return [[_util2.AnnotationEditorParamsType.FREETEXT_SIZE, FreeTextEditor._defaultFontSize], [_util2.AnnotationEditorParamsType.FREETEXT_COLOR, FreeTextEditor._defaultColor || _editor.AnnotationEditor._defaultLineColor]];
                }
                get propertiesToUpdate() {
                  return [[_util2.AnnotationEditorParamsType.FREETEXT_SIZE, this.#fontSize], [_util2.AnnotationEditorParamsType.FREETEXT_COLOR, this.#color]];
                }
                #updateFontSize(fontSize) {
                  const setFontsize = (size) => {
                    this.editorDiv.style.fontSize = `calc(${size}px * var(--scale-factor))`;
                    this.translate(0, -(size - this.#fontSize) * this.parentScale);
                    this.#fontSize = size;
                    this.#setEditorDimensions();
                  };
                  const savedFontsize = this.#fontSize;
                  this.addCommands({
                    cmd: () => {
                      setFontsize(fontSize);
                    },
                    undo: () => {
                      setFontsize(savedFontsize);
                    },
                    mustExec: true,
                    type: _util2.AnnotationEditorParamsType.FREETEXT_SIZE,
                    overwriteIfSameType: true,
                    keepUndo: true
                  });
                }
                #updateColor(color) {
                  const savedColor = this.#color;
                  this.addCommands({
                    cmd: () => {
                      this.#color = this.editorDiv.style.color = color;
                    },
                    undo: () => {
                      this.#color = this.editorDiv.style.color = savedColor;
                    },
                    mustExec: true,
                    type: _util2.AnnotationEditorParamsType.FREETEXT_COLOR,
                    overwriteIfSameType: true,
                    keepUndo: true
                  });
                }
                _translateEmpty(x, y) {
                  this._uiManager.translateSelectedEditors(x, y, true);
                }
                getInitialTranslation() {
                  const scale = this.parentScale;
                  return [-FreeTextEditor._internalPadding * scale, -(FreeTextEditor._internalPadding + this.#fontSize) * scale];
                }
                rebuild() {
                  if (!this.parent) {
                    return;
                  }
                  super.rebuild();
                  if (this.div === null) {
                    return;
                  }
                  if (!this.isAttachedToDOM) {
                    this.parent.add(this);
                  }
                }
                enableEditMode() {
                  if (this.isInEditMode()) {
                    return;
                  }
                  this.parent.setEditingState(false);
                  this.parent.updateToolbar(_util2.AnnotationEditorType.FREETEXT);
                  super.enableEditMode();
                  this.overlayDiv.classList.remove("enabled");
                  this.editorDiv.contentEditable = true;
                  this._isDraggable = false;
                  this.div.removeAttribute("aria-activedescendant");
                  this.editorDiv.addEventListener("keydown", this.#boundEditorDivKeydown);
                  this.editorDiv.addEventListener("focus", this.#boundEditorDivFocus);
                  this.editorDiv.addEventListener("blur", this.#boundEditorDivBlur);
                  this.editorDiv.addEventListener("input", this.#boundEditorDivInput);
                }
                disableEditMode() {
                  if (!this.isInEditMode()) {
                    return;
                  }
                  this.parent.setEditingState(true);
                  super.disableEditMode();
                  this.overlayDiv.classList.add("enabled");
                  this.editorDiv.contentEditable = false;
                  this.div.setAttribute("aria-activedescendant", this.#editorDivId);
                  this._isDraggable = true;
                  this.editorDiv.removeEventListener("keydown", this.#boundEditorDivKeydown);
                  this.editorDiv.removeEventListener("focus", this.#boundEditorDivFocus);
                  this.editorDiv.removeEventListener("blur", this.#boundEditorDivBlur);
                  this.editorDiv.removeEventListener("input", this.#boundEditorDivInput);
                  this.div.focus({
                    preventScroll: true
                  });
                  this.isEditing = false;
                  this.parent.div.classList.add("freeTextEditing");
                }
                focusin(event) {
                  if (!this._focusEventsAllowed) {
                    return;
                  }
                  super.focusin(event);
                  if (event.target !== this.editorDiv) {
                    this.editorDiv.focus();
                  }
                }
                onceAdded() {
                  if (this.width) {
                    this.#cheatInitialRect();
                    return;
                  }
                  this.enableEditMode();
                  this.editorDiv.focus();
                  if (this._initialOptions?.isCentered) {
                    this.center();
                  }
                  this._initialOptions = null;
                }
                isEmpty() {
                  return !this.editorDiv || this.editorDiv.innerText.trim() === "";
                }
                remove() {
                  this.isEditing = false;
                  if (this.parent) {
                    this.parent.setEditingState(true);
                    this.parent.div.classList.add("freeTextEditing");
                  }
                  super.remove();
                }
                #extractText() {
                  const divs = this.editorDiv.getElementsByTagName("div");
                  if (divs.length === 0) {
                    return this.editorDiv.innerText;
                  }
                  const buffer = [];
                  for (const div of divs) {
                    buffer.push(div.innerText.replace(/\r\n?|\n/, ""));
                  }
                  return buffer.join("\n");
                }
                #setEditorDimensions() {
                  const [parentWidth, parentHeight] = this.parentDimensions;
                  let rect;
                  if (this.isAttachedToDOM) {
                    rect = this.div.getBoundingClientRect();
                  } else {
                    const {
                      currentLayer,
                      div
                    } = this;
                    const savedDisplay = div.style.display;
                    div.style.display = "hidden";
                    currentLayer.div.append(this.div);
                    rect = div.getBoundingClientRect();
                    div.remove();
                    div.style.display = savedDisplay;
                  }
                  if (this.rotation % 180 === this.parentRotation % 180) {
                    this.width = rect.width / parentWidth;
                    this.height = rect.height / parentHeight;
                  } else {
                    this.width = rect.height / parentWidth;
                    this.height = rect.width / parentHeight;
                  }
                  this.fixAndSetPosition();
                }
                commit() {
                  if (!this.isInEditMode()) {
                    return;
                  }
                  super.commit();
                  this.disableEditMode();
                  const savedText = this.#content;
                  const newText = this.#content = this.#extractText().trimEnd();
                  if (savedText === newText) {
                    return;
                  }
                  const setText = (text) => {
                    this.#content = text;
                    if (!text) {
                      this.remove();
                      return;
                    }
                    this.#setContent();
                    this._uiManager.rebuild(this);
                    this.#setEditorDimensions();
                  };
                  this.addCommands({
                    cmd: () => {
                      setText(newText);
                    },
                    undo: () => {
                      setText(savedText);
                    },
                    mustExec: false
                  });
                  this.#setEditorDimensions();
                }
                shouldGetKeyboardEvents() {
                  return this.isInEditMode();
                }
                enterInEditMode() {
                  this.enableEditMode();
                  this.editorDiv.focus();
                }
                dblclick(event) {
                  this.enterInEditMode();
                }
                keydown(event) {
                  if (event.target === this.div && event.key === "Enter") {
                    this.enterInEditMode();
                    event.preventDefault();
                  }
                }
                editorDivKeydown(event) {
                  FreeTextEditor._keyboardManager.exec(this, event);
                }
                editorDivFocus(event) {
                  this.isEditing = true;
                }
                editorDivBlur(event) {
                  this.isEditing = false;
                }
                editorDivInput(event) {
                  this.parent.div.classList.toggle("freeTextEditing", this.isEmpty());
                }
                disableEditing() {
                  this.editorDiv.setAttribute("role", "comment");
                  this.editorDiv.removeAttribute("aria-multiline");
                }
                enableEditing() {
                  this.editorDiv.setAttribute("role", "textbox");
                  this.editorDiv.setAttribute("aria-multiline", true);
                }
                render() {
                  if (this.div) {
                    return this.div;
                  }
                  let baseX, baseY;
                  if (this.width) {
                    baseX = this.x;
                    baseY = this.y;
                  }
                  super.render();
                  this.editorDiv = document.createElement("div");
                  this.editorDiv.className = "internal";
                  this.editorDiv.setAttribute("id", this.#editorDivId);
                  this.enableEditing();
                  _editor.AnnotationEditor._l10nPromise.get("editor_free_text2_aria_label").then((msg) => this.editorDiv?.setAttribute("aria-label", msg));
                  _editor.AnnotationEditor._l10nPromise.get("free_text2_default_content").then((msg) => this.editorDiv?.setAttribute("default-content", msg));
                  this.editorDiv.contentEditable = true;
                  const {
                    style: style2
                  } = this.editorDiv;
                  style2.fontSize = `calc(${this.#fontSize}px * var(--scale-factor))`;
                  style2.color = this.#color;
                  this.div.append(this.editorDiv);
                  this.overlayDiv = document.createElement("div");
                  this.overlayDiv.classList.add("overlay", "enabled");
                  this.div.append(this.overlayDiv);
                  (0, _tools.bindEvents)(this, this.div, ["dblclick", "keydown"]);
                  if (this.width) {
                    const [parentWidth, parentHeight] = this.parentDimensions;
                    if (this.annotationElementId) {
                      const {
                        position: position3
                      } = this.#initialData;
                      let [tx, ty] = this.getInitialTranslation();
                      [tx, ty] = this.pageTranslationToScreen(tx, ty);
                      const [pageWidth, pageHeight] = this.pageDimensions;
                      const [pageX, pageY] = this.pageTranslation;
                      let posX, posY;
                      switch (this.rotation) {
                        case 0:
                          posX = baseX + (position3[0] - pageX) / pageWidth;
                          posY = baseY + this.height - (position3[1] - pageY) / pageHeight;
                          break;
                        case 90:
                          posX = baseX + (position3[0] - pageX) / pageWidth;
                          posY = baseY - (position3[1] - pageY) / pageHeight;
                          [tx, ty] = [ty, -tx];
                          break;
                        case 180:
                          posX = baseX - this.width + (position3[0] - pageX) / pageWidth;
                          posY = baseY - (position3[1] - pageY) / pageHeight;
                          [tx, ty] = [-tx, -ty];
                          break;
                        case 270:
                          posX = baseX + (position3[0] - pageX - this.height * pageHeight) / pageWidth;
                          posY = baseY + (position3[1] - pageY - this.width * pageWidth) / pageHeight;
                          [tx, ty] = [-ty, tx];
                          break;
                      }
                      this.setAt(posX * parentWidth, posY * parentHeight, tx, ty);
                    } else {
                      this.setAt(baseX * parentWidth, baseY * parentHeight, this.width * parentWidth, this.height * parentHeight);
                    }
                    this.#setContent();
                    this._isDraggable = true;
                    this.editorDiv.contentEditable = false;
                  } else {
                    this._isDraggable = false;
                    this.editorDiv.contentEditable = true;
                  }
                  return this.div;
                }
                #setContent() {
                  this.editorDiv.replaceChildren();
                  if (!this.#content) {
                    return;
                  }
                  for (const line2 of this.#content.split("\n")) {
                    const div = document.createElement("div");
                    div.append(line2 ? document.createTextNode(line2) : document.createElement("br"));
                    this.editorDiv.append(div);
                  }
                }
                get contentDiv() {
                  return this.editorDiv;
                }
                static deserialize(data2, parent2, uiManager) {
                  let initialData = null;
                  if (data2 instanceof _annotation_layer.FreeTextAnnotationElement) {
                    const {
                      data: {
                        defaultAppearanceData: {
                          fontSize,
                          fontColor
                        },
                        rect,
                        rotation,
                        id
                      },
                      textContent,
                      textPosition,
                      parent: {
                        page: {
                          pageNumber
                        }
                      }
                    } = data2;
                    if (!textContent || textContent.length === 0) {
                      return null;
                    }
                    initialData = data2 = {
                      annotationType: _util2.AnnotationEditorType.FREETEXT,
                      color: Array.from(fontColor),
                      fontSize,
                      value: textContent.join("\n"),
                      position: textPosition,
                      pageIndex: pageNumber - 1,
                      rect,
                      rotation,
                      id,
                      deleted: false
                    };
                  }
                  const editor = super.deserialize(data2, parent2, uiManager);
                  editor.#fontSize = data2.fontSize;
                  editor.#color = _util2.Util.makeHexColor(...data2.color);
                  editor.#content = data2.value;
                  editor.annotationElementId = data2.id || null;
                  editor.#initialData = initialData;
                  return editor;
                }
                serialize(isForCopying = false) {
                  if (this.isEmpty()) {
                    return null;
                  }
                  if (this.deleted) {
                    return {
                      pageIndex: this.pageIndex,
                      id: this.annotationElementId,
                      deleted: true
                    };
                  }
                  const padding = FreeTextEditor._internalPadding * this.parentScale;
                  const rect = this.getRect(padding, padding);
                  const color = _editor.AnnotationEditor._colorManager.convert(this.isAttachedToDOM ? getComputedStyle(this.editorDiv).color : this.#color);
                  const serialized = {
                    annotationType: _util2.AnnotationEditorType.FREETEXT,
                    color,
                    fontSize: this.#fontSize,
                    value: this.#content,
                    pageIndex: this.pageIndex,
                    rect,
                    rotation: this.rotation,
                    structTreeParentId: this._structTreeParentId
                  };
                  if (isForCopying) {
                    return serialized;
                  }
                  if (this.annotationElementId && !this.#hasElementChanged(serialized)) {
                    return null;
                  }
                  serialized.id = this.annotationElementId;
                  return serialized;
                }
                #hasElementChanged(serialized) {
                  const {
                    value,
                    fontSize,
                    color,
                    rect,
                    pageIndex
                  } = this.#initialData;
                  return serialized.value !== value || serialized.fontSize !== fontSize || serialized.rect.some((x, i) => Math.abs(x - rect[i]) >= 1) || serialized.color.some((c, i) => c !== color[i]) || serialized.pageIndex !== pageIndex;
                }
                #cheatInitialRect(delayed = false) {
                  if (!this.annotationElementId) {
                    return;
                  }
                  this.#setEditorDimensions();
                  if (!delayed && (this.width === 0 || this.height === 0)) {
                    setTimeout(() => this.#cheatInitialRect(true), 0);
                    return;
                  }
                  const padding = FreeTextEditor._internalPadding * this.parentScale;
                  this.#initialData.rect = this.getRect(padding, padding);
                }
              }
              exports2.FreeTextEditor = FreeTextEditor;
            }),
            /* 29 */
            /***/
            ((__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
              Object.defineProperty(exports2, "__esModule", {
                value: true
              });
              exports2.StampAnnotationElement = exports2.InkAnnotationElement = exports2.FreeTextAnnotationElement = exports2.AnnotationLayer = void 0;
              var _util2 = __w_pdfjs_require__2(1);
              var _display_utils2 = __w_pdfjs_require__2(6);
              var _annotation_storage2 = __w_pdfjs_require__2(3);
              var _scripting_utils = __w_pdfjs_require__2(30);
              var _displayL10n_utils = __w_pdfjs_require__2(31);
              var _xfa_layer = __w_pdfjs_require__2(32);
              const DEFAULT_TAB_INDEX = 1e3;
              const DEFAULT_FONT_SIZE2 = 9;
              const GetElementsByNameSet = /* @__PURE__ */ new WeakSet();
              function getRectDims(rect) {
                return {
                  width: rect[2] - rect[0],
                  height: rect[3] - rect[1]
                };
              }
              class AnnotationElementFactory {
                static create(parameters) {
                  const subtype = parameters.data.annotationType;
                  switch (subtype) {
                    case _util2.AnnotationType.LINK:
                      return new LinkAnnotationElement(parameters);
                    case _util2.AnnotationType.TEXT:
                      return new TextAnnotationElement(parameters);
                    case _util2.AnnotationType.WIDGET:
                      const fieldType = parameters.data.fieldType;
                      switch (fieldType) {
                        case "Tx":
                          return new TextWidgetAnnotationElement(parameters);
                        case "Btn":
                          if (parameters.data.radioButton) {
                            return new RadioButtonWidgetAnnotationElement(parameters);
                          } else if (parameters.data.checkBox) {
                            return new CheckboxWidgetAnnotationElement(parameters);
                          }
                          return new PushButtonWidgetAnnotationElement(parameters);
                        case "Ch":
                          return new ChoiceWidgetAnnotationElement(parameters);
                        case "Sig":
                          return new SignatureWidgetAnnotationElement(parameters);
                      }
                      return new WidgetAnnotationElement(parameters);
                    case _util2.AnnotationType.POPUP:
                      return new PopupAnnotationElement(parameters);
                    case _util2.AnnotationType.FREETEXT:
                      return new FreeTextAnnotationElement(parameters);
                    case _util2.AnnotationType.LINE:
                      return new LineAnnotationElement(parameters);
                    case _util2.AnnotationType.SQUARE:
                      return new SquareAnnotationElement(parameters);
                    case _util2.AnnotationType.CIRCLE:
                      return new CircleAnnotationElement(parameters);
                    case _util2.AnnotationType.POLYLINE:
                      return new PolylineAnnotationElement(parameters);
                    case _util2.AnnotationType.CARET:
                      return new CaretAnnotationElement(parameters);
                    case _util2.AnnotationType.INK:
                      return new InkAnnotationElement(parameters);
                    case _util2.AnnotationType.POLYGON:
                      return new PolygonAnnotationElement(parameters);
                    case _util2.AnnotationType.HIGHLIGHT:
                      return new HighlightAnnotationElement(parameters);
                    case _util2.AnnotationType.UNDERLINE:
                      return new UnderlineAnnotationElement(parameters);
                    case _util2.AnnotationType.SQUIGGLY:
                      return new SquigglyAnnotationElement(parameters);
                    case _util2.AnnotationType.STRIKEOUT:
                      return new StrikeOutAnnotationElement(parameters);
                    case _util2.AnnotationType.STAMP:
                      return new StampAnnotationElement(parameters);
                    case _util2.AnnotationType.FILEATTACHMENT:
                      return new FileAttachmentAnnotationElement(parameters);
                    default:
                      return new AnnotationElement(parameters);
                  }
                }
              }
              class AnnotationElement {
                #hasBorder = false;
                constructor(parameters, {
                  isRenderable = false,
                  ignoreBorder = false,
                  createQuadrilaterals = false
                } = {}) {
                  this.isRenderable = isRenderable;
                  this.data = parameters.data;
                  this.layer = parameters.layer;
                  this.linkService = parameters.linkService;
                  this.downloadManager = parameters.downloadManager;
                  this.imageResourcesPath = parameters.imageResourcesPath;
                  this.renderForms = parameters.renderForms;
                  this.svgFactory = parameters.svgFactory;
                  this.annotationStorage = parameters.annotationStorage;
                  this.enableScripting = parameters.enableScripting;
                  this.hasJSActions = parameters.hasJSActions;
                  this._fieldObjects = parameters.fieldObjects;
                  this.parent = parameters.parent;
                  if (isRenderable) {
                    this.container = this._createContainer(ignoreBorder);
                  }
                  if (createQuadrilaterals) {
                    this._createQuadrilaterals();
                  }
                }
                static _hasPopupData({
                  titleObj,
                  contentsObj,
                  richText
                }) {
                  return !!(titleObj?.str || contentsObj?.str || richText?.str);
                }
                get hasPopupData() {
                  return AnnotationElement._hasPopupData(this.data);
                }
                _createContainer(ignoreBorder) {
                  const {
                    data: data2,
                    parent: {
                      page,
                      viewport
                    }
                  } = this;
                  const container = document.createElement("section");
                  container.setAttribute("data-annotation-id", data2.id);
                  if (!(this instanceof WidgetAnnotationElement)) {
                    container.tabIndex = DEFAULT_TAB_INDEX;
                  }
                  container.style.zIndex = this.parent.zIndex++;
                  if (this.data.popupRef) {
                    container.setAttribute("aria-haspopup", "dialog");
                  }
                  if (data2.noRotate) {
                    container.classList.add("norotate");
                  }
                  const {
                    pageWidth,
                    pageHeight,
                    pageX,
                    pageY
                  } = viewport.rawDims;
                  if (!data2.rect || this instanceof PopupAnnotationElement) {
                    const {
                      rotation: rotation2
                    } = data2;
                    if (!data2.hasOwnCanvas && rotation2 !== 0) {
                      this.setRotation(rotation2, container);
                    }
                    return container;
                  }
                  const {
                    width,
                    height
                  } = getRectDims(data2.rect);
                  const rect = _util2.Util.normalizeRect([data2.rect[0], page.view[3] - data2.rect[1] + page.view[1], data2.rect[2], page.view[3] - data2.rect[3] + page.view[1]]);
                  if (!ignoreBorder && data2.borderStyle.width > 0) {
                    container.style.borderWidth = `${data2.borderStyle.width}px`;
                    const horizontalRadius = data2.borderStyle.horizontalCornerRadius;
                    const verticalRadius = data2.borderStyle.verticalCornerRadius;
                    if (horizontalRadius > 0 || verticalRadius > 0) {
                      const radius2 = `calc(${horizontalRadius}px * var(--scale-factor)) / calc(${verticalRadius}px * var(--scale-factor))`;
                      container.style.borderRadius = radius2;
                    } else if (this instanceof RadioButtonWidgetAnnotationElement) {
                      const radius2 = `calc(${width}px * var(--scale-factor)) / calc(${height}px * var(--scale-factor))`;
                      container.style.borderRadius = radius2;
                    }
                    switch (data2.borderStyle.style) {
                      case _util2.AnnotationBorderStyleType.SOLID:
                        container.style.borderStyle = "solid";
                        break;
                      case _util2.AnnotationBorderStyleType.DASHED:
                        container.style.borderStyle = "dashed";
                        break;
                      case _util2.AnnotationBorderStyleType.BEVELED:
                        (0, _util2.warn)("Unimplemented border style: beveled");
                        break;
                      case _util2.AnnotationBorderStyleType.INSET:
                        (0, _util2.warn)("Unimplemented border style: inset");
                        break;
                      case _util2.AnnotationBorderStyleType.UNDERLINE:
                        container.style.borderBottomStyle = "solid";
                        break;
                      default:
                        break;
                    }
                    const borderColor = data2.borderColor || null;
                    if (borderColor) {
                      this.#hasBorder = true;
                      container.style.borderColor = _util2.Util.makeHexColor(borderColor[0] | 0, borderColor[1] | 0, borderColor[2] | 0);
                    } else {
                      container.style.borderWidth = 0;
                    }
                  }
                  container.style.left = `${100 * (rect[0] - pageX) / pageWidth}%`;
                  container.style.top = `${100 * (rect[1] - pageY) / pageHeight}%`;
                  const {
                    rotation
                  } = data2;
                  if (data2.hasOwnCanvas || rotation === 0) {
                    container.style.width = `${100 * width / pageWidth}%`;
                    container.style.height = `${100 * height / pageHeight}%`;
                  } else {
                    this.setRotation(rotation, container);
                  }
                  return container;
                }
                setRotation(angle, container = this.container) {
                  if (!this.data.rect) {
                    return;
                  }
                  const {
                    pageWidth,
                    pageHeight
                  } = this.parent.viewport.rawDims;
                  const {
                    width,
                    height
                  } = getRectDims(this.data.rect);
                  let elementWidth, elementHeight;
                  if (angle % 180 === 0) {
                    elementWidth = 100 * width / pageWidth;
                    elementHeight = 100 * height / pageHeight;
                  } else {
                    elementWidth = 100 * height / pageWidth;
                    elementHeight = 100 * width / pageHeight;
                  }
                  container.style.width = `${elementWidth}%`;
                  container.style.height = `${elementHeight}%`;
                  container.setAttribute("data-main-rotation", (360 - angle) % 360);
                }
                get _commonActions() {
                  const setColor = (jsName, styleName, event) => {
                    const color = event.detail[jsName];
                    const colorType = color[0];
                    const colorArray = color.slice(1);
                    event.target.style[styleName] = _scripting_utils.ColorConverters[`${colorType}_HTML`](colorArray);
                    this.annotationStorage.setValue(this.data.id, {
                      [styleName]: _scripting_utils.ColorConverters[`${colorType}_rgb`](colorArray)
                    });
                  };
                  return (0, _util2.shadow)(this, "_commonActions", {
                    display: (event) => {
                      const {
                        display
                      } = event.detail;
                      const hidden = display % 2 === 1;
                      this.container.style.visibility = hidden ? "hidden" : "visible";
                      this.annotationStorage.setValue(this.data.id, {
                        noView: hidden,
                        noPrint: display === 1 || display === 2
                      });
                    },
                    print: (event) => {
                      this.annotationStorage.setValue(this.data.id, {
                        noPrint: !event.detail.print
                      });
                    },
                    hidden: (event) => {
                      const {
                        hidden
                      } = event.detail;
                      this.container.style.visibility = hidden ? "hidden" : "visible";
                      this.annotationStorage.setValue(this.data.id, {
                        noPrint: hidden,
                        noView: hidden
                      });
                    },
                    focus: (event) => {
                      setTimeout(() => event.target.focus({
                        preventScroll: false
                      }), 0);
                    },
                    userName: (event) => {
                      event.target.title = event.detail.userName;
                    },
                    readonly: (event) => {
                      event.target.disabled = event.detail.readonly;
                    },
                    required: (event) => {
                      this._setRequired(event.target, event.detail.required);
                    },
                    bgColor: (event) => {
                      setColor("bgColor", "backgroundColor", event);
                    },
                    fillColor: (event) => {
                      setColor("fillColor", "backgroundColor", event);
                    },
                    fgColor: (event) => {
                      setColor("fgColor", "color", event);
                    },
                    textColor: (event) => {
                      setColor("textColor", "color", event);
                    },
                    borderColor: (event) => {
                      setColor("borderColor", "borderColor", event);
                    },
                    strokeColor: (event) => {
                      setColor("strokeColor", "borderColor", event);
                    },
                    rotation: (event) => {
                      const angle = event.detail.rotation;
                      this.setRotation(angle);
                      this.annotationStorage.setValue(this.data.id, {
                        rotation: angle
                      });
                    }
                  });
                }
                _dispatchEventFromSandbox(actions, jsEvent) {
                  const commonActions = this._commonActions;
                  for (const name of Object.keys(jsEvent.detail)) {
                    const action = actions[name] || commonActions[name];
                    action?.(jsEvent);
                  }
                }
                _setDefaultPropertiesFromJS(element) {
                  if (!this.enableScripting) {
                    return;
                  }
                  const storedData = this.annotationStorage.getRawValue(this.data.id);
                  if (!storedData) {
                    return;
                  }
                  const commonActions = this._commonActions;
                  for (const [actionName, detail] of Object.entries(storedData)) {
                    const action = commonActions[actionName];
                    if (action) {
                      const eventProxy = {
                        detail: {
                          [actionName]: detail
                        },
                        target: element
                      };
                      action(eventProxy);
                      delete storedData[actionName];
                    }
                  }
                }
                _createQuadrilaterals() {
                  if (!this.container) {
                    return;
                  }
                  const {
                    quadPoints
                  } = this.data;
                  if (!quadPoints) {
                    return;
                  }
                  const [rectBlX, rectBlY, rectTrX, rectTrY] = this.data.rect;
                  if (quadPoints.length === 1) {
                    const [, {
                      x: trX,
                      y: trY
                    }, {
                      x: blX,
                      y: blY
                    }] = quadPoints[0];
                    if (rectTrX === trX && rectTrY === trY && rectBlX === blX && rectBlY === blY) {
                      return;
                    }
                  }
                  const {
                    style: style2
                  } = this.container;
                  let svgBuffer;
                  if (this.#hasBorder) {
                    const {
                      borderColor,
                      borderWidth: borderWidth2
                    } = style2;
                    style2.borderWidth = 0;
                    svgBuffer = ["url('data:image/svg+xml;utf8,", `<svg xmlns="http://www.w3.org/2000/svg"`, ` preserveAspectRatio="none" viewBox="0 0 1 1">`, `<g fill="transparent" stroke="${borderColor}" stroke-width="${borderWidth2}">`];
                    this.container.classList.add("hasBorder");
                  }
                  const width = rectTrX - rectBlX;
                  const height = rectTrY - rectBlY;
                  const {
                    svgFactory
                  } = this;
                  const svg = svgFactory.createElement("svg");
                  svg.classList.add("quadrilateralsContainer");
                  svg.setAttribute("width", 0);
                  svg.setAttribute("height", 0);
                  const defs = svgFactory.createElement("defs");
                  svg.append(defs);
                  const clipPath = svgFactory.createElement("clipPath");
                  const id = `clippath_${this.data.id}`;
                  clipPath.setAttribute("id", id);
                  clipPath.setAttribute("clipPathUnits", "objectBoundingBox");
                  defs.append(clipPath);
                  for (const [, {
                    x: trX,
                    y: trY
                  }, {
                    x: blX,
                    y: blY
                  }] of quadPoints) {
                    const rect = svgFactory.createElement("rect");
                    const x = (blX - rectBlX) / width;
                    const y = (rectTrY - trY) / height;
                    const rectWidth = (trX - blX) / width;
                    const rectHeight = (trY - blY) / height;
                    rect.setAttribute("x", x);
                    rect.setAttribute("y", y);
                    rect.setAttribute("width", rectWidth);
                    rect.setAttribute("height", rectHeight);
                    clipPath.append(rect);
                    svgBuffer?.push(`<rect vector-effect="non-scaling-stroke" x="${x}" y="${y}" width="${rectWidth}" height="${rectHeight}"/>`);
                  }
                  if (this.#hasBorder) {
                    svgBuffer.push(`</g></svg>')`);
                    style2.backgroundImage = svgBuffer.join("");
                  }
                  this.container.append(svg);
                  this.container.style.clipPath = `url(#${id})`;
                }
                _createPopup() {
                  const {
                    container,
                    data: data2
                  } = this;
                  container.setAttribute("aria-haspopup", "dialog");
                  const popup = new PopupAnnotationElement({
                    data: {
                      color: data2.color,
                      titleObj: data2.titleObj,
                      modificationDate: data2.modificationDate,
                      contentsObj: data2.contentsObj,
                      richText: data2.richText,
                      parentRect: data2.rect,
                      borderStyle: 0,
                      id: `popup_${data2.id}`,
                      rotation: data2.rotation
                    },
                    parent: this.parent,
                    elements: [this]
                  });
                  this.parent.div.append(popup.render());
                }
                render() {
                  (0, _util2.unreachable)("Abstract method `AnnotationElement.render` called");
                }
                _getElementsByName(name, skipId = null) {
                  const fields = [];
                  if (this._fieldObjects) {
                    const fieldObj = this._fieldObjects[name];
                    if (fieldObj) {
                      for (const {
                        page,
                        id,
                        exportValues
                      } of fieldObj) {
                        if (page === -1) {
                          continue;
                        }
                        if (id === skipId) {
                          continue;
                        }
                        const exportValue = typeof exportValues === "string" ? exportValues : null;
                        const domElement = document.querySelector(`[data-element-id="${id}"]`);
                        if (domElement && !GetElementsByNameSet.has(domElement)) {
                          (0, _util2.warn)(`_getElementsByName - element not allowed: ${id}`);
                          continue;
                        }
                        fields.push({
                          id,
                          exportValue,
                          domElement
                        });
                      }
                    }
                    return fields;
                  }
                  for (const domElement of document.getElementsByName(name)) {
                    const {
                      exportValue
                    } = domElement;
                    const id = domElement.getAttribute("data-element-id");
                    if (id === skipId) {
                      continue;
                    }
                    if (!GetElementsByNameSet.has(domElement)) {
                      continue;
                    }
                    fields.push({
                      id,
                      exportValue,
                      domElement
                    });
                  }
                  return fields;
                }
                show() {
                  if (this.container) {
                    this.container.hidden = false;
                  }
                  this.popup?.maybeShow();
                }
                hide() {
                  if (this.container) {
                    this.container.hidden = true;
                  }
                  this.popup?.forceHide();
                }
                getElementsToTriggerPopup() {
                  return this.container;
                }
                addHighlightArea() {
                  const triggers = this.getElementsToTriggerPopup();
                  if (Array.isArray(triggers)) {
                    for (const element of triggers) {
                      element.classList.add("highlightArea");
                    }
                  } else {
                    triggers.classList.add("highlightArea");
                  }
                }
                _editOnDoubleClick() {
                  const {
                    annotationEditorType: mode,
                    data: {
                      id: editId
                    }
                  } = this;
                  this.container.addEventListener("dblclick", () => {
                    this.linkService.eventBus?.dispatch("switchannotationeditormode", {
                      source: this,
                      mode,
                      editId
                    });
                  });
                }
              }
              class LinkAnnotationElement extends AnnotationElement {
                constructor(parameters, options = null) {
                  super(parameters, {
                    isRenderable: true,
                    ignoreBorder: !!options?.ignoreBorder,
                    createQuadrilaterals: true
                  });
                  this.isTooltipOnly = parameters.data.isTooltipOnly;
                }
                render() {
                  const {
                    data: data2,
                    linkService
                  } = this;
                  const link = document.createElement("a");
                  link.setAttribute("data-element-id", data2.id);
                  let isBound = false;
                  if (data2.url) {
                    linkService.addLinkAttributes(link, data2.url, data2.newWindow);
                    isBound = true;
                  } else if (data2.action) {
                    this._bindNamedAction(link, data2.action);
                    isBound = true;
                  } else if (data2.attachment) {
                    this._bindAttachment(link, data2.attachment);
                    isBound = true;
                  } else if (data2.setOCGState) {
                    this.#bindSetOCGState(link, data2.setOCGState);
                    isBound = true;
                  } else if (data2.dest) {
                    this._bindLink(link, data2.dest);
                    isBound = true;
                  } else {
                    if (data2.actions && (data2.actions.Action || data2.actions["Mouse Up"] || data2.actions["Mouse Down"]) && this.enableScripting && this.hasJSActions) {
                      this._bindJSAction(link, data2);
                      isBound = true;
                    }
                    if (data2.resetForm) {
                      this._bindResetFormAction(link, data2.resetForm);
                      isBound = true;
                    } else if (this.isTooltipOnly && !isBound) {
                      this._bindLink(link, "");
                      isBound = true;
                    }
                  }
                  this.container.classList.add("linkAnnotation");
                  if (isBound) {
                    this.container.append(link);
                  }
                  return this.container;
                }
                #setInternalLink() {
                  this.container.setAttribute("data-internal-link", "");
                }
                _bindLink(link, destination) {
                  link.href = this.linkService.getDestinationHash(destination);
                  link.onclick = () => {
                    if (destination) {
                      this.linkService.goToDestination(destination);
                    }
                    return false;
                  };
                  if (destination || destination === "") {
                    this.#setInternalLink();
                  }
                }
                _bindNamedAction(link, action) {
                  link.href = this.linkService.getAnchorUrl("");
                  link.onclick = () => {
                    this.linkService.executeNamedAction(action);
                    return false;
                  };
                  this.#setInternalLink();
                }
                _bindAttachment(link, attachment) {
                  link.href = this.linkService.getAnchorUrl("");
                  link.onclick = () => {
                    this.downloadManager?.openOrDownloadData(this.container, attachment.content, attachment.filename);
                    return false;
                  };
                  this.#setInternalLink();
                }
                #bindSetOCGState(link, action) {
                  link.href = this.linkService.getAnchorUrl("");
                  link.onclick = () => {
                    this.linkService.executeSetOCGState(action);
                    return false;
                  };
                  this.#setInternalLink();
                }
                _bindJSAction(link, data2) {
                  link.href = this.linkService.getAnchorUrl("");
                  const map = /* @__PURE__ */ new Map([["Action", "onclick"], ["Mouse Up", "onmouseup"], ["Mouse Down", "onmousedown"]]);
                  for (const name of Object.keys(data2.actions)) {
                    const jsName = map.get(name);
                    if (!jsName) {
                      continue;
                    }
                    link[jsName] = () => {
                      this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                        source: this,
                        detail: {
                          id: data2.id,
                          name
                        }
                      });
                      return false;
                    };
                  }
                  if (!link.onclick) {
                    link.onclick = () => false;
                  }
                  this.#setInternalLink();
                }
                _bindResetFormAction(link, resetForm2) {
                  const otherClickAction = link.onclick;
                  if (!otherClickAction) {
                    link.href = this.linkService.getAnchorUrl("");
                  }
                  this.#setInternalLink();
                  if (!this._fieldObjects) {
                    (0, _util2.warn)(`_bindResetFormAction - "resetForm" action not supported, ensure that the \`fieldObjects\` parameter is provided.`);
                    if (!otherClickAction) {
                      link.onclick = () => false;
                    }
                    return;
                  }
                  link.onclick = () => {
                    otherClickAction?.();
                    const {
                      fields: resetFormFields,
                      refs: resetFormRefs,
                      include
                    } = resetForm2;
                    const allFields = [];
                    if (resetFormFields.length !== 0 || resetFormRefs.length !== 0) {
                      const fieldIds = new Set(resetFormRefs);
                      for (const fieldName of resetFormFields) {
                        const fields = this._fieldObjects[fieldName] || [];
                        for (const {
                          id
                        } of fields) {
                          fieldIds.add(id);
                        }
                      }
                      for (const fields of Object.values(this._fieldObjects)) {
                        for (const field of fields) {
                          if (fieldIds.has(field.id) === include) {
                            allFields.push(field);
                          }
                        }
                      }
                    } else {
                      for (const fields of Object.values(this._fieldObjects)) {
                        allFields.push(...fields);
                      }
                    }
                    const storage = this.annotationStorage;
                    const allIds = [];
                    for (const field of allFields) {
                      const {
                        id
                      } = field;
                      allIds.push(id);
                      switch (field.type) {
                        case "text": {
                          const value = field.defaultValue || "";
                          storage.setValue(id, {
                            value
                          });
                          break;
                        }
                        case "checkbox":
                        case "radiobutton": {
                          const value = field.defaultValue === field.exportValues;
                          storage.setValue(id, {
                            value
                          });
                          break;
                        }
                        case "combobox":
                        case "listbox": {
                          const value = field.defaultValue || "";
                          storage.setValue(id, {
                            value
                          });
                          break;
                        }
                        default:
                          continue;
                      }
                      const domElement = document.querySelector(`[data-element-id="${id}"]`);
                      if (!domElement) {
                        continue;
                      } else if (!GetElementsByNameSet.has(domElement)) {
                        (0, _util2.warn)(`_bindResetFormAction - element not allowed: ${id}`);
                        continue;
                      }
                      domElement.dispatchEvent(new Event("resetform"));
                    }
                    if (this.enableScripting) {
                      this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                        source: this,
                        detail: {
                          id: "app",
                          ids: allIds,
                          name: "ResetForm"
                        }
                      });
                    }
                    return false;
                  };
                }
              }
              class TextAnnotationElement extends AnnotationElement {
                constructor(parameters) {
                  super(parameters, {
                    isRenderable: true
                  });
                }
                render() {
                  this.container.classList.add("textAnnotation");
                  const image = document.createElement("img");
                  image.src = this.imageResourcesPath + "annotation-" + this.data.name.toLowerCase() + ".svg";
                  image.alt = "[{{type}} Annotation]";
                  image.dataset.l10nId = "text_annotation_type";
                  image.dataset.l10nArgs = JSON.stringify({
                    type: this.data.name
                  });
                  if (!this.data.popupRef && this.hasPopupData) {
                    this._createPopup();
                  }
                  this.container.append(image);
                  return this.container;
                }
              }
              class WidgetAnnotationElement extends AnnotationElement {
                render() {
                  if (this.data.alternativeText) {
                    this.container.title = this.data.alternativeText;
                  }
                  return this.container;
                }
                showElementAndHideCanvas(element) {
                  if (this.data.hasOwnCanvas) {
                    if (element.previousSibling?.nodeName === "CANVAS") {
                      element.previousSibling.hidden = true;
                    }
                    element.hidden = false;
                  }
                }
                _getKeyModifier(event) {
                  const {
                    isWin,
                    isMac
                  } = _util2.FeatureTest.platform;
                  return isWin && event.ctrlKey || isMac && event.metaKey;
                }
                _setEventListener(element, elementData, baseName, eventName, valueGetter) {
                  if (baseName.includes("mouse")) {
                    element.addEventListener(baseName, (event) => {
                      this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                        source: this,
                        detail: {
                          id: this.data.id,
                          name: eventName,
                          value: valueGetter(event),
                          shift: event.shiftKey,
                          modifier: this._getKeyModifier(event)
                        }
                      });
                    });
                  } else {
                    element.addEventListener(baseName, (event) => {
                      if (baseName === "blur") {
                        if (!elementData.focused || !event.relatedTarget) {
                          return;
                        }
                        elementData.focused = false;
                      } else if (baseName === "focus") {
                        if (elementData.focused) {
                          return;
                        }
                        elementData.focused = true;
                      }
                      if (!valueGetter) {
                        return;
                      }
                      this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                        source: this,
                        detail: {
                          id: this.data.id,
                          name: eventName,
                          value: valueGetter(event)
                        }
                      });
                    });
                  }
                }
                _setEventListeners(element, elementData, names2, getter) {
                  for (const [baseName, eventName] of names2) {
                    if (eventName === "Action" || this.data.actions?.[eventName]) {
                      if (eventName === "Focus" || eventName === "Blur") {
                        elementData ||= {
                          focused: false
                        };
                      }
                      this._setEventListener(element, elementData, baseName, eventName, getter);
                      if (eventName === "Focus" && !this.data.actions?.Blur) {
                        this._setEventListener(element, elementData, "blur", "Blur", null);
                      } else if (eventName === "Blur" && !this.data.actions?.Focus) {
                        this._setEventListener(element, elementData, "focus", "Focus", null);
                      }
                    }
                  }
                }
                _setBackgroundColor(element) {
                  const color = this.data.backgroundColor || null;
                  element.style.backgroundColor = color === null ? "transparent" : _util2.Util.makeHexColor(color[0], color[1], color[2]);
                }
                _setTextStyle(element) {
                  const TEXT_ALIGNMENT = ["left", "center", "right"];
                  const {
                    fontColor
                  } = this.data.defaultAppearanceData;
                  const fontSize = this.data.defaultAppearanceData.fontSize || DEFAULT_FONT_SIZE2;
                  const style2 = element.style;
                  let computedFontSize;
                  const BORDER_SIZE = 2;
                  const roundToOneDecimal = (x) => Math.round(10 * x) / 10;
                  if (this.data.multiLine) {
                    const height = Math.abs(this.data.rect[3] - this.data.rect[1] - BORDER_SIZE);
                    const numberOfLines = Math.round(height / (_util2.LINE_FACTOR * fontSize)) || 1;
                    const lineHeight = height / numberOfLines;
                    computedFontSize = Math.min(fontSize, roundToOneDecimal(lineHeight / _util2.LINE_FACTOR));
                  } else {
                    const height = Math.abs(this.data.rect[3] - this.data.rect[1] - BORDER_SIZE);
                    computedFontSize = Math.min(fontSize, roundToOneDecimal(height / _util2.LINE_FACTOR));
                  }
                  style2.fontSize = `calc(${computedFontSize}px * var(--scale-factor))`;
                  style2.color = _util2.Util.makeHexColor(fontColor[0], fontColor[1], fontColor[2]);
                  if (this.data.textAlignment !== null) {
                    style2.textAlign = TEXT_ALIGNMENT[this.data.textAlignment];
                  }
                }
                _setRequired(element, isRequired) {
                  if (isRequired) {
                    element.setAttribute("required", true);
                  } else {
                    element.removeAttribute("required");
                  }
                  element.setAttribute("aria-required", isRequired);
                }
              }
              class TextWidgetAnnotationElement extends WidgetAnnotationElement {
                constructor(parameters) {
                  const isRenderable = parameters.renderForms || !parameters.data.hasAppearance && !!parameters.data.fieldValue;
                  super(parameters, {
                    isRenderable
                  });
                }
                setPropertyOnSiblings(base, key2, value, keyInStorage) {
                  const storage = this.annotationStorage;
                  for (const element of this._getElementsByName(base.name, base.id)) {
                    if (element.domElement) {
                      element.domElement[key2] = value;
                    }
                    storage.setValue(element.id, {
                      [keyInStorage]: value
                    });
                  }
                }
                render() {
                  const storage = this.annotationStorage;
                  const id = this.data.id;
                  this.container.classList.add("textWidgetAnnotation");
                  let element = null;
                  if (this.renderForms) {
                    const storedData = storage.getValue(id, {
                      value: this.data.fieldValue
                    });
                    let textContent = storedData.value || "";
                    const maxLen = storage.getValue(id, {
                      charLimit: this.data.maxLen
                    }).charLimit;
                    if (maxLen && textContent.length > maxLen) {
                      textContent = textContent.slice(0, maxLen);
                    }
                    let fieldFormattedValues = storedData.formattedValue || this.data.textContent?.join("\n") || null;
                    if (fieldFormattedValues && this.data.comb) {
                      fieldFormattedValues = fieldFormattedValues.replaceAll(/\s+/g, "");
                    }
                    const elementData = {
                      userValue: textContent,
                      formattedValue: fieldFormattedValues,
                      lastCommittedValue: null,
                      commitKey: 1,
                      focused: false
                    };
                    if (this.data.multiLine) {
                      element = document.createElement("textarea");
                      element.textContent = fieldFormattedValues ?? textContent;
                      if (this.data.doNotScroll) {
                        element.style.overflowY = "hidden";
                      }
                    } else {
                      element = document.createElement("input");
                      element.type = "text";
                      element.setAttribute("value", fieldFormattedValues ?? textContent);
                      if (this.data.doNotScroll) {
                        element.style.overflowX = "hidden";
                      }
                    }
                    if (this.data.hasOwnCanvas) {
                      element.hidden = true;
                    }
                    GetElementsByNameSet.add(element);
                    element.setAttribute("data-element-id", id);
                    element.disabled = this.data.readOnly;
                    element.name = this.data.fieldName;
                    element.tabIndex = DEFAULT_TAB_INDEX;
                    this._setRequired(element, this.data.required);
                    if (maxLen) {
                      element.maxLength = maxLen;
                    }
                    element.addEventListener("input", (event) => {
                      storage.setValue(id, {
                        value: event.target.value
                      });
                      this.setPropertyOnSiblings(element, "value", event.target.value, "value");
                      elementData.formattedValue = null;
                    });
                    element.addEventListener("resetform", (event) => {
                      const defaultValue2 = this.data.defaultFieldValue ?? "";
                      element.value = elementData.userValue = defaultValue2;
                      elementData.formattedValue = null;
                    });
                    let blurListener = (event) => {
                      const {
                        formattedValue
                      } = elementData;
                      if (formattedValue !== null && formattedValue !== void 0) {
                        event.target.value = formattedValue;
                      }
                      event.target.scrollLeft = 0;
                    };
                    if (this.enableScripting && this.hasJSActions) {
                      element.addEventListener("focus", (event) => {
                        if (elementData.focused) {
                          return;
                        }
                        const {
                          target
                        } = event;
                        if (elementData.userValue) {
                          target.value = elementData.userValue;
                        }
                        elementData.lastCommittedValue = target.value;
                        elementData.commitKey = 1;
                        elementData.focused = true;
                      });
                      element.addEventListener("updatefromsandbox", (jsEvent) => {
                        this.showElementAndHideCanvas(jsEvent.target);
                        const actions = {
                          value(event) {
                            elementData.userValue = event.detail.value ?? "";
                            storage.setValue(id, {
                              value: elementData.userValue.toString()
                            });
                            event.target.value = elementData.userValue;
                          },
                          formattedValue(event) {
                            const {
                              formattedValue
                            } = event.detail;
                            elementData.formattedValue = formattedValue;
                            if (formattedValue !== null && formattedValue !== void 0 && event.target !== document.activeElement) {
                              event.target.value = formattedValue;
                            }
                            storage.setValue(id, {
                              formattedValue
                            });
                          },
                          selRange(event) {
                            event.target.setSelectionRange(...event.detail.selRange);
                          },
                          charLimit: (event) => {
                            const {
                              charLimit
                            } = event.detail;
                            const {
                              target
                            } = event;
                            if (charLimit === 0) {
                              target.removeAttribute("maxLength");
                              return;
                            }
                            target.setAttribute("maxLength", charLimit);
                            let value = elementData.userValue;
                            if (!value || value.length <= charLimit) {
                              return;
                            }
                            value = value.slice(0, charLimit);
                            target.value = elementData.userValue = value;
                            storage.setValue(id, {
                              value
                            });
                            this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                              source: this,
                              detail: {
                                id,
                                name: "Keystroke",
                                value,
                                willCommit: true,
                                commitKey: 1,
                                selStart: target.selectionStart,
                                selEnd: target.selectionEnd
                              }
                            });
                          }
                        };
                        this._dispatchEventFromSandbox(actions, jsEvent);
                      });
                      element.addEventListener("keydown", (event) => {
                        elementData.commitKey = 1;
                        let commitKey = -1;
                        if (event.key === "Escape") {
                          commitKey = 0;
                        } else if (event.key === "Enter" && !this.data.multiLine) {
                          commitKey = 2;
                        } else if (event.key === "Tab") {
                          elementData.commitKey = 3;
                        }
                        if (commitKey === -1) {
                          return;
                        }
                        const {
                          value
                        } = event.target;
                        if (elementData.lastCommittedValue === value) {
                          return;
                        }
                        elementData.lastCommittedValue = value;
                        elementData.userValue = value;
                        this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                          source: this,
                          detail: {
                            id,
                            name: "Keystroke",
                            value,
                            willCommit: true,
                            commitKey,
                            selStart: event.target.selectionStart,
                            selEnd: event.target.selectionEnd
                          }
                        });
                      });
                      const _blurListener = blurListener;
                      blurListener = null;
                      element.addEventListener("blur", (event) => {
                        if (!elementData.focused || !event.relatedTarget) {
                          return;
                        }
                        elementData.focused = false;
                        const {
                          value
                        } = event.target;
                        elementData.userValue = value;
                        if (elementData.lastCommittedValue !== value) {
                          this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                            source: this,
                            detail: {
                              id,
                              name: "Keystroke",
                              value,
                              willCommit: true,
                              commitKey: elementData.commitKey,
                              selStart: event.target.selectionStart,
                              selEnd: event.target.selectionEnd
                            }
                          });
                        }
                        _blurListener(event);
                      });
                      if (this.data.actions?.Keystroke) {
                        element.addEventListener("beforeinput", (event) => {
                          elementData.lastCommittedValue = null;
                          const {
                            data: data2,
                            target
                          } = event;
                          const {
                            value,
                            selectionStart,
                            selectionEnd
                          } = target;
                          let selStart = selectionStart, selEnd = selectionEnd;
                          switch (event.inputType) {
                            case "deleteWordBackward": {
                              const match2 = value.substring(0, selectionStart).match(/\w*[^\w]*$/);
                              if (match2) {
                                selStart -= match2[0].length;
                              }
                              break;
                            }
                            case "deleteWordForward": {
                              const match2 = value.substring(selectionStart).match(/^[^\w]*\w*/);
                              if (match2) {
                                selEnd += match2[0].length;
                              }
                              break;
                            }
                            case "deleteContentBackward":
                              if (selectionStart === selectionEnd) {
                                selStart -= 1;
                              }
                              break;
                            case "deleteContentForward":
                              if (selectionStart === selectionEnd) {
                                selEnd += 1;
                              }
                              break;
                          }
                          event.preventDefault();
                          this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                            source: this,
                            detail: {
                              id,
                              name: "Keystroke",
                              value,
                              change: data2 || "",
                              willCommit: false,
                              selStart,
                              selEnd
                            }
                          });
                        });
                      }
                      this._setEventListeners(element, elementData, [["focus", "Focus"], ["blur", "Blur"], ["mousedown", "Mouse Down"], ["mouseenter", "Mouse Enter"], ["mouseleave", "Mouse Exit"], ["mouseup", "Mouse Up"]], (event) => event.target.value);
                    }
                    if (blurListener) {
                      element.addEventListener("blur", blurListener);
                    }
                    if (this.data.comb) {
                      const fieldWidth = this.data.rect[2] - this.data.rect[0];
                      const combWidth = fieldWidth / maxLen;
                      element.classList.add("comb");
                      element.style.letterSpacing = `calc(${combWidth}px * var(--scale-factor) - 1ch)`;
                    }
                  } else {
                    element = document.createElement("div");
                    element.textContent = this.data.fieldValue;
                    element.style.verticalAlign = "middle";
                    element.style.display = "table-cell";
                  }
                  this._setTextStyle(element);
                  this._setBackgroundColor(element);
                  this._setDefaultPropertiesFromJS(element);
                  this.container.append(element);
                  return this.container;
                }
              }
              class SignatureWidgetAnnotationElement extends WidgetAnnotationElement {
                constructor(parameters) {
                  super(parameters, {
                    isRenderable: !!parameters.data.hasOwnCanvas
                  });
                }
              }
              class CheckboxWidgetAnnotationElement extends WidgetAnnotationElement {
                constructor(parameters) {
                  super(parameters, {
                    isRenderable: parameters.renderForms
                  });
                }
                render() {
                  const storage = this.annotationStorage;
                  const data2 = this.data;
                  const id = data2.id;
                  let value = storage.getValue(id, {
                    value: data2.exportValue === data2.fieldValue
                  }).value;
                  if (typeof value === "string") {
                    value = value !== "Off";
                    storage.setValue(id, {
                      value
                    });
                  }
                  this.container.classList.add("buttonWidgetAnnotation", "checkBox");
                  const element = document.createElement("input");
                  GetElementsByNameSet.add(element);
                  element.setAttribute("data-element-id", id);
                  element.disabled = data2.readOnly;
                  this._setRequired(element, this.data.required);
                  element.type = "checkbox";
                  element.name = data2.fieldName;
                  if (value) {
                    element.setAttribute("checked", true);
                  }
                  element.setAttribute("exportValue", data2.exportValue);
                  element.tabIndex = DEFAULT_TAB_INDEX;
                  element.addEventListener("change", (event) => {
                    const {
                      name,
                      checked
                    } = event.target;
                    for (const checkbox of this._getElementsByName(name, id)) {
                      const curChecked = checked && checkbox.exportValue === data2.exportValue;
                      if (checkbox.domElement) {
                        checkbox.domElement.checked = curChecked;
                      }
                      storage.setValue(checkbox.id, {
                        value: curChecked
                      });
                    }
                    storage.setValue(id, {
                      value: checked
                    });
                  });
                  element.addEventListener("resetform", (event) => {
                    const defaultValue2 = data2.defaultFieldValue || "Off";
                    event.target.checked = defaultValue2 === data2.exportValue;
                  });
                  if (this.enableScripting && this.hasJSActions) {
                    element.addEventListener("updatefromsandbox", (jsEvent) => {
                      const actions = {
                        value(event) {
                          event.target.checked = event.detail.value !== "Off";
                          storage.setValue(id, {
                            value: event.target.checked
                          });
                        }
                      };
                      this._dispatchEventFromSandbox(actions, jsEvent);
                    });
                    this._setEventListeners(element, null, [["change", "Validate"], ["change", "Action"], ["focus", "Focus"], ["blur", "Blur"], ["mousedown", "Mouse Down"], ["mouseenter", "Mouse Enter"], ["mouseleave", "Mouse Exit"], ["mouseup", "Mouse Up"]], (event) => event.target.checked);
                  }
                  this._setBackgroundColor(element);
                  this._setDefaultPropertiesFromJS(element);
                  this.container.append(element);
                  return this.container;
                }
              }
              class RadioButtonWidgetAnnotationElement extends WidgetAnnotationElement {
                constructor(parameters) {
                  super(parameters, {
                    isRenderable: parameters.renderForms
                  });
                }
                render() {
                  this.container.classList.add("buttonWidgetAnnotation", "radioButton");
                  const storage = this.annotationStorage;
                  const data2 = this.data;
                  const id = data2.id;
                  let value = storage.getValue(id, {
                    value: data2.fieldValue === data2.buttonValue
                  }).value;
                  if (typeof value === "string") {
                    value = value !== data2.buttonValue;
                    storage.setValue(id, {
                      value
                    });
                  }
                  const element = document.createElement("input");
                  GetElementsByNameSet.add(element);
                  element.setAttribute("data-element-id", id);
                  element.disabled = data2.readOnly;
                  this._setRequired(element, this.data.required);
                  element.type = "radio";
                  element.name = data2.fieldName;
                  if (value) {
                    element.setAttribute("checked", true);
                  }
                  element.tabIndex = DEFAULT_TAB_INDEX;
                  element.addEventListener("change", (event) => {
                    const {
                      name,
                      checked
                    } = event.target;
                    for (const radio of this._getElementsByName(name, id)) {
                      storage.setValue(radio.id, {
                        value: false
                      });
                    }
                    storage.setValue(id, {
                      value: checked
                    });
                  });
                  element.addEventListener("resetform", (event) => {
                    const defaultValue2 = data2.defaultFieldValue;
                    event.target.checked = defaultValue2 !== null && defaultValue2 !== void 0 && defaultValue2 === data2.buttonValue;
                  });
                  if (this.enableScripting && this.hasJSActions) {
                    const pdfButtonValue = data2.buttonValue;
                    element.addEventListener("updatefromsandbox", (jsEvent) => {
                      const actions = {
                        value: (event) => {
                          const checked = pdfButtonValue === event.detail.value;
                          for (const radio of this._getElementsByName(event.target.name)) {
                            const curChecked = checked && radio.id === id;
                            if (radio.domElement) {
                              radio.domElement.checked = curChecked;
                            }
                            storage.setValue(radio.id, {
                              value: curChecked
                            });
                          }
                        }
                      };
                      this._dispatchEventFromSandbox(actions, jsEvent);
                    });
                    this._setEventListeners(element, null, [["change", "Validate"], ["change", "Action"], ["focus", "Focus"], ["blur", "Blur"], ["mousedown", "Mouse Down"], ["mouseenter", "Mouse Enter"], ["mouseleave", "Mouse Exit"], ["mouseup", "Mouse Up"]], (event) => event.target.checked);
                  }
                  this._setBackgroundColor(element);
                  this._setDefaultPropertiesFromJS(element);
                  this.container.append(element);
                  return this.container;
                }
              }
              class PushButtonWidgetAnnotationElement extends LinkAnnotationElement {
                constructor(parameters) {
                  super(parameters, {
                    ignoreBorder: parameters.data.hasAppearance
                  });
                }
                render() {
                  const container = super.render();
                  container.classList.add("buttonWidgetAnnotation", "pushButton");
                  if (this.data.alternativeText) {
                    container.title = this.data.alternativeText;
                  }
                  const linkElement = container.lastChild;
                  if (this.enableScripting && this.hasJSActions && linkElement) {
                    this._setDefaultPropertiesFromJS(linkElement);
                    linkElement.addEventListener("updatefromsandbox", (jsEvent) => {
                      this._dispatchEventFromSandbox({}, jsEvent);
                    });
                  }
                  return container;
                }
              }
              class ChoiceWidgetAnnotationElement extends WidgetAnnotationElement {
                constructor(parameters) {
                  super(parameters, {
                    isRenderable: parameters.renderForms
                  });
                }
                render() {
                  this.container.classList.add("choiceWidgetAnnotation");
                  const storage = this.annotationStorage;
                  const id = this.data.id;
                  const storedData = storage.getValue(id, {
                    value: this.data.fieldValue
                  });
                  const selectElement = document.createElement("select");
                  GetElementsByNameSet.add(selectElement);
                  selectElement.setAttribute("data-element-id", id);
                  selectElement.disabled = this.data.readOnly;
                  this._setRequired(selectElement, this.data.required);
                  selectElement.name = this.data.fieldName;
                  selectElement.tabIndex = DEFAULT_TAB_INDEX;
                  let addAnEmptyEntry = this.data.combo && this.data.options.length > 0;
                  if (!this.data.combo) {
                    selectElement.size = this.data.options.length;
                    if (this.data.multiSelect) {
                      selectElement.multiple = true;
                    }
                  }
                  selectElement.addEventListener("resetform", (event) => {
                    const defaultValue2 = this.data.defaultFieldValue;
                    for (const option of selectElement.options) {
                      option.selected = option.value === defaultValue2;
                    }
                  });
                  for (const option of this.data.options) {
                    const optionElement = document.createElement("option");
                    optionElement.textContent = option.displayValue;
                    optionElement.value = option.exportValue;
                    if (storedData.value.includes(option.exportValue)) {
                      optionElement.setAttribute("selected", true);
                      addAnEmptyEntry = false;
                    }
                    selectElement.append(optionElement);
                  }
                  let removeEmptyEntry = null;
                  if (addAnEmptyEntry) {
                    const noneOptionElement = document.createElement("option");
                    noneOptionElement.value = " ";
                    noneOptionElement.setAttribute("hidden", true);
                    noneOptionElement.setAttribute("selected", true);
                    selectElement.prepend(noneOptionElement);
                    removeEmptyEntry = () => {
                      noneOptionElement.remove();
                      selectElement.removeEventListener("input", removeEmptyEntry);
                      removeEmptyEntry = null;
                    };
                    selectElement.addEventListener("input", removeEmptyEntry);
                  }
                  const getValue4 = (isExport) => {
                    const name = isExport ? "value" : "textContent";
                    const {
                      options,
                      multiple
                    } = selectElement;
                    if (!multiple) {
                      return options.selectedIndex === -1 ? null : options[options.selectedIndex][name];
                    }
                    return Array.prototype.filter.call(options, (option) => option.selected).map((option) => option[name]);
                  };
                  let selectedValues = getValue4(false);
                  const getItems = (event) => {
                    const options = event.target.options;
                    return Array.prototype.map.call(options, (option) => {
                      return {
                        displayValue: option.textContent,
                        exportValue: option.value
                      };
                    });
                  };
                  if (this.enableScripting && this.hasJSActions) {
                    selectElement.addEventListener("updatefromsandbox", (jsEvent) => {
                      const actions = {
                        value(event) {
                          removeEmptyEntry?.();
                          const value = event.detail.value;
                          const values = new Set(Array.isArray(value) ? value : [value]);
                          for (const option of selectElement.options) {
                            option.selected = values.has(option.value);
                          }
                          storage.setValue(id, {
                            value: getValue4(true)
                          });
                          selectedValues = getValue4(false);
                        },
                        multipleSelection(event) {
                          selectElement.multiple = true;
                        },
                        remove(event) {
                          const options = selectElement.options;
                          const index3 = event.detail.remove;
                          options[index3].selected = false;
                          selectElement.remove(index3);
                          if (options.length > 0) {
                            const i = Array.prototype.findIndex.call(options, (option) => option.selected);
                            if (i === -1) {
                              options[0].selected = true;
                            }
                          }
                          storage.setValue(id, {
                            value: getValue4(true),
                            items: getItems(event)
                          });
                          selectedValues = getValue4(false);
                        },
                        clear(event) {
                          while (selectElement.length !== 0) {
                            selectElement.remove(0);
                          }
                          storage.setValue(id, {
                            value: null,
                            items: []
                          });
                          selectedValues = getValue4(false);
                        },
                        insert(event) {
                          const {
                            index: index3,
                            displayValue,
                            exportValue
                          } = event.detail.insert;
                          const selectChild = selectElement.children[index3];
                          const optionElement = document.createElement("option");
                          optionElement.textContent = displayValue;
                          optionElement.value = exportValue;
                          if (selectChild) {
                            selectChild.before(optionElement);
                          } else {
                            selectElement.append(optionElement);
                          }
                          storage.setValue(id, {
                            value: getValue4(true),
                            items: getItems(event)
                          });
                          selectedValues = getValue4(false);
                        },
                        items(event) {
                          const {
                            items
                          } = event.detail;
                          while (selectElement.length !== 0) {
                            selectElement.remove(0);
                          }
                          for (const item of items) {
                            const {
                              displayValue,
                              exportValue
                            } = item;
                            const optionElement = document.createElement("option");
                            optionElement.textContent = displayValue;
                            optionElement.value = exportValue;
                            selectElement.append(optionElement);
                          }
                          if (selectElement.options.length > 0) {
                            selectElement.options[0].selected = true;
                          }
                          storage.setValue(id, {
                            value: getValue4(true),
                            items: getItems(event)
                          });
                          selectedValues = getValue4(false);
                        },
                        indices(event) {
                          const indices = new Set(event.detail.indices);
                          for (const option of event.target.options) {
                            option.selected = indices.has(option.index);
                          }
                          storage.setValue(id, {
                            value: getValue4(true)
                          });
                          selectedValues = getValue4(false);
                        },
                        editable(event) {
                          event.target.disabled = !event.detail.editable;
                        }
                      };
                      this._dispatchEventFromSandbox(actions, jsEvent);
                    });
                    selectElement.addEventListener("input", (event) => {
                      const exportValue = getValue4(true);
                      storage.setValue(id, {
                        value: exportValue
                      });
                      event.preventDefault();
                      this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                        source: this,
                        detail: {
                          id,
                          name: "Keystroke",
                          value: selectedValues,
                          changeEx: exportValue,
                          willCommit: false,
                          commitKey: 1,
                          keyDown: false
                        }
                      });
                    });
                    this._setEventListeners(selectElement, null, [["focus", "Focus"], ["blur", "Blur"], ["mousedown", "Mouse Down"], ["mouseenter", "Mouse Enter"], ["mouseleave", "Mouse Exit"], ["mouseup", "Mouse Up"], ["input", "Action"], ["input", "Validate"]], (event) => event.target.value);
                  } else {
                    selectElement.addEventListener("input", function(event) {
                      storage.setValue(id, {
                        value: getValue4(true)
                      });
                    });
                  }
                  if (this.data.combo) {
                    this._setTextStyle(selectElement);
                  } else {
                  }
                  this._setBackgroundColor(selectElement);
                  this._setDefaultPropertiesFromJS(selectElement);
                  this.container.append(selectElement);
                  return this.container;
                }
              }
              class PopupAnnotationElement extends AnnotationElement {
                constructor(parameters) {
                  const {
                    data: data2,
                    elements
                  } = parameters;
                  super(parameters, {
                    isRenderable: AnnotationElement._hasPopupData(data2)
                  });
                  this.elements = elements;
                }
                render() {
                  this.container.classList.add("popupAnnotation");
                  const popup = new PopupElement({
                    container: this.container,
                    color: this.data.color,
                    titleObj: this.data.titleObj,
                    modificationDate: this.data.modificationDate,
                    contentsObj: this.data.contentsObj,
                    richText: this.data.richText,
                    rect: this.data.rect,
                    parentRect: this.data.parentRect || null,
                    parent: this.parent,
                    elements: this.elements,
                    open: this.data.open
                  });
                  const elementIds = [];
                  for (const element of this.elements) {
                    element.popup = popup;
                    elementIds.push(element.data.id);
                    element.addHighlightArea();
                  }
                  this.container.setAttribute("aria-controls", elementIds.map((id) => `${_util2.AnnotationPrefix}${id}`).join(","));
                  return this.container;
                }
              }
              class PopupElement {
                #dateTimePromise = null;
                #boundKeyDown = this.#keyDown.bind(this);
                #boundHide = this.#hide.bind(this);
                #boundShow = this.#show.bind(this);
                #boundToggle = this.#toggle.bind(this);
                #color = null;
                #container = null;
                #contentsObj = null;
                #elements = null;
                #parent = null;
                #parentRect = null;
                #pinned = false;
                #popup = null;
                #rect = null;
                #richText = null;
                #titleObj = null;
                #wasVisible = false;
                constructor({
                  container,
                  color,
                  elements,
                  titleObj,
                  modificationDate,
                  contentsObj,
                  richText,
                  parent: parent2,
                  rect,
                  parentRect,
                  open: open2
                }) {
                  this.#container = container;
                  this.#titleObj = titleObj;
                  this.#contentsObj = contentsObj;
                  this.#richText = richText;
                  this.#parent = parent2;
                  this.#color = color;
                  this.#rect = rect;
                  this.#parentRect = parentRect;
                  this.#elements = elements;
                  const dateObject = _display_utils2.PDFDateString.toDateObject(modificationDate);
                  if (dateObject) {
                    this.#dateTimePromise = parent2.l10n.get("annotation_date_string", {
                      date: dateObject.toLocaleDateString(),
                      time: dateObject.toLocaleTimeString()
                    });
                  }
                  this.trigger = elements.flatMap((e3) => e3.getElementsToTriggerPopup());
                  for (const element of this.trigger) {
                    element.addEventListener("click", this.#boundToggle);
                    element.addEventListener("mouseenter", this.#boundShow);
                    element.addEventListener("mouseleave", this.#boundHide);
                    element.classList.add("popupTriggerArea");
                  }
                  for (const element of elements) {
                    element.container?.addEventListener("keydown", this.#boundKeyDown);
                  }
                  this.#container.hidden = true;
                  if (open2) {
                    this.#toggle();
                  }
                }
                render() {
                  if (this.#popup) {
                    return;
                  }
                  const {
                    page: {
                      view
                    },
                    viewport: {
                      rawDims: {
                        pageWidth,
                        pageHeight,
                        pageX,
                        pageY
                      }
                    }
                  } = this.#parent;
                  const popup = this.#popup = document.createElement("div");
                  popup.className = "popup";
                  if (this.#color) {
                    const baseColor = popup.style.outlineColor = _util2.Util.makeHexColor(...this.#color);
                    if (CSS.supports("background-color", "color-mix(in srgb, red 30%, white)")) {
                      popup.style.backgroundColor = `color-mix(in srgb, ${baseColor} 30%, white)`;
                    } else {
                      const BACKGROUND_ENLIGHT = 0.7;
                      popup.style.backgroundColor = _util2.Util.makeHexColor(...this.#color.map((c) => Math.floor(BACKGROUND_ENLIGHT * (255 - c) + c)));
                    }
                  }
                  const header = document.createElement("span");
                  header.className = "header";
                  const title = document.createElement("h1");
                  header.append(title);
                  ({
                    dir: title.dir,
                    str: title.textContent
                  } = this.#titleObj);
                  popup.append(header);
                  if (this.#dateTimePromise) {
                    const modificationDate = document.createElement("span");
                    modificationDate.classList.add("popupDate");
                    this.#dateTimePromise.then((localized) => {
                      modificationDate.textContent = localized;
                    });
                    header.append(modificationDate);
                  }
                  const contentsObj = this.#contentsObj;
                  const richText = this.#richText;
                  if (richText?.str && (!contentsObj?.str || contentsObj.str === richText.str)) {
                    _xfa_layer.XfaLayer.render({
                      xfaHtml: richText.html,
                      intent: "richText",
                      div: popup
                    });
                    popup.lastChild.classList.add("richText", "popupContent");
                  } else {
                    const contents = this._formatContents(contentsObj);
                    popup.append(contents);
                  }
                  let useParentRect = !!this.#parentRect;
                  let rect = useParentRect ? this.#parentRect : this.#rect;
                  for (const element of this.#elements) {
                    if (!rect || _util2.Util.intersect(element.data.rect, rect) !== null) {
                      rect = element.data.rect;
                      useParentRect = true;
                      break;
                    }
                  }
                  const normalizedRect = _util2.Util.normalizeRect([rect[0], view[3] - rect[1] + view[1], rect[2], view[3] - rect[3] + view[1]]);
                  const HORIZONTAL_SPACE_AFTER_ANNOTATION = 5;
                  const parentWidth = useParentRect ? rect[2] - rect[0] + HORIZONTAL_SPACE_AFTER_ANNOTATION : 0;
                  const popupLeft = normalizedRect[0] + parentWidth;
                  const popupTop = normalizedRect[1];
                  const {
                    style: style2
                  } = this.#container;
                  style2.left = `${100 * (popupLeft - pageX) / pageWidth}%`;
                  style2.top = `${100 * (popupTop - pageY) / pageHeight}%`;
                  this.#container.append(popup);
                }
                _formatContents({
                  str,
                  dir
                }) {
                  const p = document.createElement("p");
                  p.classList.add("popupContent");
                  p.dir = dir;
                  const lines = str.split(/(?:\r\n?|\n)/);
                  for (let i = 0, ii = lines.length; i < ii; ++i) {
                    const line2 = lines[i];
                    p.append(document.createTextNode(line2));
                    if (i < ii - 1) {
                      p.append(document.createElement("br"));
                    }
                  }
                  return p;
                }
                #keyDown(event) {
                  if (event.altKey || event.shiftKey || event.ctrlKey || event.metaKey) {
                    return;
                  }
                  if (event.key === "Enter" || event.key === "Escape" && this.#pinned) {
                    this.#toggle();
                  }
                }
                #toggle() {
                  this.#pinned = !this.#pinned;
                  if (this.#pinned) {
                    this.#show();
                    this.#container.addEventListener("click", this.#boundToggle);
                    this.#container.addEventListener("keydown", this.#boundKeyDown);
                  } else {
                    this.#hide();
                    this.#container.removeEventListener("click", this.#boundToggle);
                    this.#container.removeEventListener("keydown", this.#boundKeyDown);
                  }
                }
                #show() {
                  if (!this.#popup) {
                    this.render();
                  }
                  if (!this.isVisible) {
                    this.#container.hidden = false;
                    this.#container.style.zIndex = parseInt(this.#container.style.zIndex) + 1e3;
                  } else if (this.#pinned) {
                    this.#container.classList.add("focused");
                  }
                }
                #hide() {
                  this.#container.classList.remove("focused");
                  if (this.#pinned || !this.isVisible) {
                    return;
                  }
                  this.#container.hidden = true;
                  this.#container.style.zIndex = parseInt(this.#container.style.zIndex) - 1e3;
                }
                forceHide() {
                  this.#wasVisible = this.isVisible;
                  if (!this.#wasVisible) {
                    return;
                  }
                  this.#container.hidden = true;
                }
                maybeShow() {
                  if (!this.#wasVisible) {
                    return;
                  }
                  this.#wasVisible = false;
                  this.#container.hidden = false;
                }
                get isVisible() {
                  return this.#container.hidden === false;
                }
              }
              class FreeTextAnnotationElement extends AnnotationElement {
                constructor(parameters) {
                  super(parameters, {
                    isRenderable: true,
                    ignoreBorder: true
                  });
                  this.textContent = parameters.data.textContent;
                  this.textPosition = parameters.data.textPosition;
                  this.annotationEditorType = _util2.AnnotationEditorType.FREETEXT;
                }
                render() {
                  this.container.classList.add("freeTextAnnotation");
                  if (this.textContent) {
                    const content = document.createElement("div");
                    content.classList.add("annotationTextContent");
                    content.setAttribute("role", "comment");
                    for (const line2 of this.textContent) {
                      const lineSpan = document.createElement("span");
                      lineSpan.textContent = line2;
                      content.append(lineSpan);
                    }
                    this.container.append(content);
                  }
                  if (!this.data.popupRef && this.hasPopupData) {
                    this._createPopup();
                  }
                  this._editOnDoubleClick();
                  return this.container;
                }
              }
              exports2.FreeTextAnnotationElement = FreeTextAnnotationElement;
              class LineAnnotationElement extends AnnotationElement {
                #line = null;
                constructor(parameters) {
                  super(parameters, {
                    isRenderable: true,
                    ignoreBorder: true
                  });
                }
                render() {
                  this.container.classList.add("lineAnnotation");
                  const data2 = this.data;
                  const {
                    width,
                    height
                  } = getRectDims(data2.rect);
                  const svg = this.svgFactory.create(width, height, true);
                  const line2 = this.#line = this.svgFactory.createElement("svg:line");
                  line2.setAttribute("x1", data2.rect[2] - data2.lineCoordinates[0]);
                  line2.setAttribute("y1", data2.rect[3] - data2.lineCoordinates[1]);
                  line2.setAttribute("x2", data2.rect[2] - data2.lineCoordinates[2]);
                  line2.setAttribute("y2", data2.rect[3] - data2.lineCoordinates[3]);
                  line2.setAttribute("stroke-width", data2.borderStyle.width || 1);
                  line2.setAttribute("stroke", "transparent");
                  line2.setAttribute("fill", "transparent");
                  svg.append(line2);
                  this.container.append(svg);
                  if (!data2.popupRef && this.hasPopupData) {
                    this._createPopup();
                  }
                  return this.container;
                }
                getElementsToTriggerPopup() {
                  return this.#line;
                }
                addHighlightArea() {
                  this.container.classList.add("highlightArea");
                }
              }
              class SquareAnnotationElement extends AnnotationElement {
                #square = null;
                constructor(parameters) {
                  super(parameters, {
                    isRenderable: true,
                    ignoreBorder: true
                  });
                }
                render() {
                  this.container.classList.add("squareAnnotation");
                  const data2 = this.data;
                  const {
                    width,
                    height
                  } = getRectDims(data2.rect);
                  const svg = this.svgFactory.create(width, height, true);
                  const borderWidth2 = data2.borderStyle.width;
                  const square = this.#square = this.svgFactory.createElement("svg:rect");
                  square.setAttribute("x", borderWidth2 / 2);
                  square.setAttribute("y", borderWidth2 / 2);
                  square.setAttribute("width", width - borderWidth2);
                  square.setAttribute("height", height - borderWidth2);
                  square.setAttribute("stroke-width", borderWidth2 || 1);
                  square.setAttribute("stroke", "transparent");
                  square.setAttribute("fill", "transparent");
                  svg.append(square);
                  this.container.append(svg);
                  if (!data2.popupRef && this.hasPopupData) {
                    this._createPopup();
                  }
                  return this.container;
                }
                getElementsToTriggerPopup() {
                  return this.#square;
                }
                addHighlightArea() {
                  this.container.classList.add("highlightArea");
                }
              }
              class CircleAnnotationElement extends AnnotationElement {
                #circle = null;
                constructor(parameters) {
                  super(parameters, {
                    isRenderable: true,
                    ignoreBorder: true
                  });
                }
                render() {
                  this.container.classList.add("circleAnnotation");
                  const data2 = this.data;
                  const {
                    width,
                    height
                  } = getRectDims(data2.rect);
                  const svg = this.svgFactory.create(width, height, true);
                  const borderWidth2 = data2.borderStyle.width;
                  const circle = this.#circle = this.svgFactory.createElement("svg:ellipse");
                  circle.setAttribute("cx", width / 2);
                  circle.setAttribute("cy", height / 2);
                  circle.setAttribute("rx", width / 2 - borderWidth2 / 2);
                  circle.setAttribute("ry", height / 2 - borderWidth2 / 2);
                  circle.setAttribute("stroke-width", borderWidth2 || 1);
                  circle.setAttribute("stroke", "transparent");
                  circle.setAttribute("fill", "transparent");
                  svg.append(circle);
                  this.container.append(svg);
                  if (!data2.popupRef && this.hasPopupData) {
                    this._createPopup();
                  }
                  return this.container;
                }
                getElementsToTriggerPopup() {
                  return this.#circle;
                }
                addHighlightArea() {
                  this.container.classList.add("highlightArea");
                }
              }
              class PolylineAnnotationElement extends AnnotationElement {
                #polyline = null;
                constructor(parameters) {
                  super(parameters, {
                    isRenderable: true,
                    ignoreBorder: true
                  });
                  this.containerClassName = "polylineAnnotation";
                  this.svgElementName = "svg:polyline";
                }
                render() {
                  this.container.classList.add(this.containerClassName);
                  const data2 = this.data;
                  const {
                    width,
                    height
                  } = getRectDims(data2.rect);
                  const svg = this.svgFactory.create(width, height, true);
                  let points = [];
                  for (const coordinate of data2.vertices) {
                    const x = coordinate.x - data2.rect[0];
                    const y = data2.rect[3] - coordinate.y;
                    points.push(x + "," + y);
                  }
                  points = points.join(" ");
                  const polyline = this.#polyline = this.svgFactory.createElement(this.svgElementName);
                  polyline.setAttribute("points", points);
                  polyline.setAttribute("stroke-width", data2.borderStyle.width || 1);
                  polyline.setAttribute("stroke", "transparent");
                  polyline.setAttribute("fill", "transparent");
                  svg.append(polyline);
                  this.container.append(svg);
                  if (!data2.popupRef && this.hasPopupData) {
                    this._createPopup();
                  }
                  return this.container;
                }
                getElementsToTriggerPopup() {
                  return this.#polyline;
                }
                addHighlightArea() {
                  this.container.classList.add("highlightArea");
                }
              }
              class PolygonAnnotationElement extends PolylineAnnotationElement {
                constructor(parameters) {
                  super(parameters);
                  this.containerClassName = "polygonAnnotation";
                  this.svgElementName = "svg:polygon";
                }
              }
              class CaretAnnotationElement extends AnnotationElement {
                constructor(parameters) {
                  super(parameters, {
                    isRenderable: true,
                    ignoreBorder: true
                  });
                }
                render() {
                  this.container.classList.add("caretAnnotation");
                  if (!this.data.popupRef && this.hasPopupData) {
                    this._createPopup();
                  }
                  return this.container;
                }
              }
              class InkAnnotationElement extends AnnotationElement {
                #polylines = [];
                constructor(parameters) {
                  super(parameters, {
                    isRenderable: true,
                    ignoreBorder: true
                  });
                  this.containerClassName = "inkAnnotation";
                  this.svgElementName = "svg:polyline";
                  this.annotationEditorType = _util2.AnnotationEditorType.INK;
                }
                render() {
                  this.container.classList.add(this.containerClassName);
                  const data2 = this.data;
                  const {
                    width,
                    height
                  } = getRectDims(data2.rect);
                  const svg = this.svgFactory.create(width, height, true);
                  for (const inkList of data2.inkLists) {
                    let points = [];
                    for (const coordinate of inkList) {
                      const x = coordinate.x - data2.rect[0];
                      const y = data2.rect[3] - coordinate.y;
                      points.push(`${x},${y}`);
                    }
                    points = points.join(" ");
                    const polyline = this.svgFactory.createElement(this.svgElementName);
                    this.#polylines.push(polyline);
                    polyline.setAttribute("points", points);
                    polyline.setAttribute("stroke-width", data2.borderStyle.width || 1);
                    polyline.setAttribute("stroke", "transparent");
                    polyline.setAttribute("fill", "transparent");
                    if (!data2.popupRef && this.hasPopupData) {
                      this._createPopup();
                    }
                    svg.append(polyline);
                  }
                  this.container.append(svg);
                  return this.container;
                }
                getElementsToTriggerPopup() {
                  return this.#polylines;
                }
                addHighlightArea() {
                  this.container.classList.add("highlightArea");
                }
              }
              exports2.InkAnnotationElement = InkAnnotationElement;
              class HighlightAnnotationElement extends AnnotationElement {
                constructor(parameters) {
                  super(parameters, {
                    isRenderable: true,
                    ignoreBorder: true,
                    createQuadrilaterals: true
                  });
                }
                render() {
                  if (!this.data.popupRef && this.hasPopupData) {
                    this._createPopup();
                  }
                  this.container.classList.add("highlightAnnotation");
                  return this.container;
                }
              }
              class UnderlineAnnotationElement extends AnnotationElement {
                constructor(parameters) {
                  super(parameters, {
                    isRenderable: true,
                    ignoreBorder: true,
                    createQuadrilaterals: true
                  });
                }
                render() {
                  if (!this.data.popupRef && this.hasPopupData) {
                    this._createPopup();
                  }
                  this.container.classList.add("underlineAnnotation");
                  return this.container;
                }
              }
              class SquigglyAnnotationElement extends AnnotationElement {
                constructor(parameters) {
                  super(parameters, {
                    isRenderable: true,
                    ignoreBorder: true,
                    createQuadrilaterals: true
                  });
                }
                render() {
                  if (!this.data.popupRef && this.hasPopupData) {
                    this._createPopup();
                  }
                  this.container.classList.add("squigglyAnnotation");
                  return this.container;
                }
              }
              class StrikeOutAnnotationElement extends AnnotationElement {
                constructor(parameters) {
                  super(parameters, {
                    isRenderable: true,
                    ignoreBorder: true,
                    createQuadrilaterals: true
                  });
                }
                render() {
                  if (!this.data.popupRef && this.hasPopupData) {
                    this._createPopup();
                  }
                  this.container.classList.add("strikeoutAnnotation");
                  return this.container;
                }
              }
              class StampAnnotationElement extends AnnotationElement {
                constructor(parameters) {
                  super(parameters, {
                    isRenderable: true,
                    ignoreBorder: true
                  });
                }
                render() {
                  this.container.classList.add("stampAnnotation");
                  if (!this.data.popupRef && this.hasPopupData) {
                    this._createPopup();
                  }
                  return this.container;
                }
              }
              exports2.StampAnnotationElement = StampAnnotationElement;
              class FileAttachmentAnnotationElement extends AnnotationElement {
                #trigger = null;
                constructor(parameters) {
                  super(parameters, {
                    isRenderable: true
                  });
                  const {
                    filename,
                    content
                  } = this.data.file;
                  this.filename = (0, _display_utils2.getFilenameFromUrl)(filename, true);
                  this.content = content;
                  this.linkService.eventBus?.dispatch("fileattachmentannotation", {
                    source: this,
                    filename,
                    content
                  });
                }
                render() {
                  this.container.classList.add("fileAttachmentAnnotation");
                  const {
                    container,
                    data: data2
                  } = this;
                  let trigger2;
                  if (data2.hasAppearance || data2.fillAlpha === 0) {
                    trigger2 = document.createElement("div");
                  } else {
                    trigger2 = document.createElement("img");
                    trigger2.src = `${this.imageResourcesPath}annotation-${/paperclip/i.test(data2.name) ? "paperclip" : "pushpin"}.svg`;
                    if (data2.fillAlpha && data2.fillAlpha < 1) {
                      trigger2.style = `filter: opacity(${Math.round(data2.fillAlpha * 100)}%);`;
                    }
                  }
                  trigger2.addEventListener("dblclick", this.#download.bind(this));
                  this.#trigger = trigger2;
                  const {
                    isMac
                  } = _util2.FeatureTest.platform;
                  container.addEventListener("keydown", (evt) => {
                    if (evt.key === "Enter" && (isMac ? evt.metaKey : evt.ctrlKey)) {
                      this.#download();
                    }
                  });
                  if (!data2.popupRef && this.hasPopupData) {
                    this._createPopup();
                  } else {
                    trigger2.classList.add("popupTriggerArea");
                  }
                  container.append(trigger2);
                  return container;
                }
                getElementsToTriggerPopup() {
                  return this.#trigger;
                }
                addHighlightArea() {
                  this.container.classList.add("highlightArea");
                }
                #download() {
                  this.downloadManager?.openOrDownloadData(this.container, this.content, this.filename);
                }
              }
              class AnnotationLayer {
                #accessibilityManager = null;
                #annotationCanvasMap = null;
                #editableAnnotations = /* @__PURE__ */ new Map();
                constructor({
                  div,
                  accessibilityManager,
                  annotationCanvasMap,
                  l10n,
                  page,
                  viewport
                }) {
                  this.div = div;
                  this.#accessibilityManager = accessibilityManager;
                  this.#annotationCanvasMap = annotationCanvasMap;
                  this.l10n = l10n;
                  this.page = page;
                  this.viewport = viewport;
                  this.zIndex = 0;
                  this.l10n ||= _displayL10n_utils.NullL10n;
                }
                #appendElement(element, id) {
                  const contentElement = element.firstChild || element;
                  contentElement.id = `${_util2.AnnotationPrefix}${id}`;
                  this.div.append(element);
                  this.#accessibilityManager?.moveElementInDOM(this.div, element, contentElement, false);
                }
                async render(params) {
                  const {
                    annotations
                  } = params;
                  const layer = this.div;
                  (0, _display_utils2.setLayerDimensions)(layer, this.viewport);
                  const popupToElements = /* @__PURE__ */ new Map();
                  const elementParams = {
                    data: null,
                    layer,
                    linkService: params.linkService,
                    downloadManager: params.downloadManager,
                    imageResourcesPath: params.imageResourcesPath || "",
                    renderForms: params.renderForms !== false,
                    svgFactory: new _display_utils2.DOMSVGFactory(),
                    annotationStorage: params.annotationStorage || new _annotation_storage2.AnnotationStorage(),
                    enableScripting: params.enableScripting === true,
                    hasJSActions: params.hasJSActions,
                    fieldObjects: params.fieldObjects,
                    parent: this,
                    elements: null
                  };
                  for (const data2 of annotations) {
                    if (data2.noHTML) {
                      continue;
                    }
                    const isPopupAnnotation = data2.annotationType === _util2.AnnotationType.POPUP;
                    if (!isPopupAnnotation) {
                      const {
                        width,
                        height
                      } = getRectDims(data2.rect);
                      if (width <= 0 || height <= 0) {
                        continue;
                      }
                    } else {
                      const elements = popupToElements.get(data2.id);
                      if (!elements) {
                        continue;
                      }
                      elementParams.elements = elements;
                    }
                    elementParams.data = data2;
                    const element = AnnotationElementFactory.create(elementParams);
                    if (!element.isRenderable) {
                      continue;
                    }
                    if (!isPopupAnnotation && data2.popupRef) {
                      const elements = popupToElements.get(data2.popupRef);
                      if (!elements) {
                        popupToElements.set(data2.popupRef, [element]);
                      } else {
                        elements.push(element);
                      }
                    }
                    if (element.annotationEditorType > 0) {
                      this.#editableAnnotations.set(element.data.id, element);
                    }
                    const rendered = element.render();
                    if (data2.hidden) {
                      rendered.style.visibility = "hidden";
                    }
                    this.#appendElement(rendered, data2.id);
                  }
                  this.#setAnnotationCanvasMap();
                  await this.l10n.translate(layer);
                }
                update({
                  viewport
                }) {
                  const layer = this.div;
                  this.viewport = viewport;
                  (0, _display_utils2.setLayerDimensions)(layer, {
                    rotation: viewport.rotation
                  });
                  this.#setAnnotationCanvasMap();
                  layer.hidden = false;
                }
                #setAnnotationCanvasMap() {
                  if (!this.#annotationCanvasMap) {
                    return;
                  }
                  const layer = this.div;
                  for (const [id, canvas] of this.#annotationCanvasMap) {
                    const element = layer.querySelector(`[data-annotation-id="${id}"]`);
                    if (!element) {
                      continue;
                    }
                    const {
                      firstChild
                    } = element;
                    if (!firstChild) {
                      element.append(canvas);
                    } else if (firstChild.nodeName === "CANVAS") {
                      firstChild.replaceWith(canvas);
                    } else {
                      firstChild.before(canvas);
                    }
                  }
                  this.#annotationCanvasMap.clear();
                }
                getEditableAnnotations() {
                  return Array.from(this.#editableAnnotations.values());
                }
                getEditableAnnotation(id) {
                  return this.#editableAnnotations.get(id);
                }
              }
              exports2.AnnotationLayer = AnnotationLayer;
            }),
            /* 30 */
            /***/
            ((__unused_webpack_module2, exports2) => {
              Object.defineProperty(exports2, "__esModule", {
                value: true
              });
              exports2.ColorConverters = void 0;
              function makeColorComp(n2) {
                return Math.floor(Math.max(0, Math.min(1, n2)) * 255).toString(16).padStart(2, "0");
              }
              function scaleAndClamp(x) {
                return Math.max(0, Math.min(255, 255 * x));
              }
              class ColorConverters {
                static CMYK_G([c, y, m, k]) {
                  return ["G", 1 - Math.min(1, 0.3 * c + 0.59 * m + 0.11 * y + k)];
                }
                static G_CMYK([g]) {
                  return ["CMYK", 0, 0, 0, 1 - g];
                }
                static G_RGB([g]) {
                  return ["RGB", g, g, g];
                }
                static G_rgb([g]) {
                  g = scaleAndClamp(g);
                  return [g, g, g];
                }
                static G_HTML([g]) {
                  const G = makeColorComp(g);
                  return `#${G}${G}${G}`;
                }
                static RGB_G([r2, g, b]) {
                  return ["G", 0.3 * r2 + 0.59 * g + 0.11 * b];
                }
                static RGB_rgb(color) {
                  return color.map(scaleAndClamp);
                }
                static RGB_HTML(color) {
                  return `#${color.map(makeColorComp).join("")}`;
                }
                static T_HTML() {
                  return "#00000000";
                }
                static T_rgb() {
                  return [null];
                }
                static CMYK_RGB([c, y, m, k]) {
                  return ["RGB", 1 - Math.min(1, c + k), 1 - Math.min(1, m + k), 1 - Math.min(1, y + k)];
                }
                static CMYK_rgb([c, y, m, k]) {
                  return [scaleAndClamp(1 - Math.min(1, c + k)), scaleAndClamp(1 - Math.min(1, m + k)), scaleAndClamp(1 - Math.min(1, y + k))];
                }
                static CMYK_HTML(components) {
                  const rgb2 = this.CMYK_RGB(components).slice(1);
                  return this.RGB_HTML(rgb2);
                }
                static RGB_CMYK([r2, g, b]) {
                  const c = 1 - r2;
                  const m = 1 - g;
                  const y = 1 - b;
                  const k = Math.min(c, m, y);
                  return ["CMYK", c, m, y, k];
                }
              }
              exports2.ColorConverters = ColorConverters;
            }),
            /* 31 */
            /***/
            ((__unused_webpack_module2, exports2) => {
              Object.defineProperty(exports2, "__esModule", {
                value: true
              });
              exports2.NullL10n = void 0;
              exports2.getL10nFallback = getL10nFallback;
              const DEFAULT_L10N_STRINGS = {
                of_pages: "of {{pagesCount}}",
                page_of_pages: "({{pageNumber}} of {{pagesCount}})",
                document_properties_kb: "{{size_kb}} KB ({{size_b}} bytes)",
                document_properties_mb: "{{size_mb}} MB ({{size_b}} bytes)",
                document_properties_date_string: "{{date}}, {{time}}",
                document_properties_page_size_unit_inches: "in",
                document_properties_page_size_unit_millimeters: "mm",
                document_properties_page_size_orientation_portrait: "portrait",
                document_properties_page_size_orientation_landscape: "landscape",
                document_properties_page_size_name_a3: "A3",
                document_properties_page_size_name_a4: "A4",
                document_properties_page_size_name_letter: "Letter",
                document_properties_page_size_name_legal: "Legal",
                document_properties_page_size_dimension_string: "{{width}} \xD7 {{height}} {{unit}} ({{orientation}})",
                document_properties_page_size_dimension_name_string: "{{width}} \xD7 {{height}} {{unit}} ({{name}}, {{orientation}})",
                document_properties_linearized_yes: "Yes",
                document_properties_linearized_no: "No",
                additional_layers: "Additional Layers",
                page_landmark: "Page {{page}}",
                thumb_page_title: "Page {{page}}",
                thumb_page_canvas: "Thumbnail of Page {{page}}",
                find_reached_top: "Reached top of document, continued from bottom",
                find_reached_bottom: "Reached end of document, continued from top",
                "find_match_count[one]": "{{current}} of {{total}} match",
                "find_match_count[other]": "{{current}} of {{total}} matches",
                "find_match_count_limit[one]": "More than {{limit}} match",
                "find_match_count_limit[other]": "More than {{limit}} matches",
                find_not_found: "Phrase not found",
                page_scale_width: "Page Width",
                page_scale_fit: "Page Fit",
                page_scale_auto: "Automatic Zoom",
                page_scale_actual: "Actual Size",
                page_scale_percent: "{{scale}}%",
                loading_error: "An error occurred while loading the PDF.",
                invalid_file_error: "Invalid or corrupted PDF file.",
                missing_file_error: "Missing PDF file.",
                unexpected_response_error: "Unexpected server response.",
                rendering_error: "An error occurred while rendering the page.",
                annotation_date_string: "{{date}}, {{time}}",
                printing_not_supported: "Warning: Printing is not fully supported by this browser.",
                printing_not_ready: "Warning: The PDF is not fully loaded for printing.",
                web_fonts_disabled: "Web fonts are disabled: unable to use embedded PDF fonts.",
                free_text2_default_content: "Start typing\u2026",
                editor_free_text2_aria_label: "Text Editor",
                editor_ink2_aria_label: "Draw Editor",
                editor_ink_canvas_aria_label: "User-created image",
                editor_alt_text_button_label: "Alt text",
                editor_alt_text_edit_button_label: "Edit alt text",
                editor_alt_text_decorative_tooltip: "Marked as decorative"
              };
              {
                DEFAULT_L10N_STRINGS.print_progress_percent = "{{progress}}%";
              }
              function getL10nFallback(key2, args) {
                switch (key2) {
                  case "find_match_count":
                    key2 = `find_match_count[${args.total === 1 ? "one" : "other"}]`;
                    break;
                  case "find_match_count_limit":
                    key2 = `find_match_count_limit[${args.limit === 1 ? "one" : "other"}]`;
                    break;
                }
                return DEFAULT_L10N_STRINGS[key2] || "";
              }
              function formatL10nValue(text, args) {
                if (!args) {
                  return text;
                }
                return text.replaceAll(/\{\{\s*(\w+)\s*\}\}/g, (all, name) => {
                  return name in args ? args[name] : "{{" + name + "}}";
                });
              }
              const NullL10n = {
                async getLanguage() {
                  return "en-us";
                },
                async getDirection() {
                  return "ltr";
                },
                async get(key2, args = null, fallback = getL10nFallback(key2, args)) {
                  return formatL10nValue(fallback, args);
                },
                async translate(element) {
                }
              };
              exports2.NullL10n = NullL10n;
            }),
            /* 32 */
            /***/
            ((__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
              Object.defineProperty(exports2, "__esModule", {
                value: true
              });
              exports2.XfaLayer = void 0;
              var _xfa_text2 = __w_pdfjs_require__2(25);
              class XfaLayer {
                static setupStorage(html2, id, element, storage, intent) {
                  const storedData = storage.getValue(id, {
                    value: null
                  });
                  switch (element.name) {
                    case "textarea":
                      if (storedData.value !== null) {
                        html2.textContent = storedData.value;
                      }
                      if (intent === "print") {
                        break;
                      }
                      html2.addEventListener("input", (event) => {
                        storage.setValue(id, {
                          value: event.target.value
                        });
                      });
                      break;
                    case "input":
                      if (element.attributes.type === "radio" || element.attributes.type === "checkbox") {
                        if (storedData.value === element.attributes.xfaOn) {
                          html2.setAttribute("checked", true);
                        } else if (storedData.value === element.attributes.xfaOff) {
                          html2.removeAttribute("checked");
                        }
                        if (intent === "print") {
                          break;
                        }
                        html2.addEventListener("change", (event) => {
                          storage.setValue(id, {
                            value: event.target.checked ? event.target.getAttribute("xfaOn") : event.target.getAttribute("xfaOff")
                          });
                        });
                      } else {
                        if (storedData.value !== null) {
                          html2.setAttribute("value", storedData.value);
                        }
                        if (intent === "print") {
                          break;
                        }
                        html2.addEventListener("input", (event) => {
                          storage.setValue(id, {
                            value: event.target.value
                          });
                        });
                      }
                      break;
                    case "select":
                      if (storedData.value !== null) {
                        html2.setAttribute("value", storedData.value);
                        for (const option of element.children) {
                          if (option.attributes.value === storedData.value) {
                            option.attributes.selected = true;
                          } else if (option.attributes.hasOwnProperty("selected")) {
                            delete option.attributes.selected;
                          }
                        }
                      }
                      html2.addEventListener("input", (event) => {
                        const options = event.target.options;
                        const value = options.selectedIndex === -1 ? "" : options[options.selectedIndex].value;
                        storage.setValue(id, {
                          value
                        });
                      });
                      break;
                  }
                }
                static setAttributes({
                  html: html2,
                  element,
                  storage = null,
                  intent,
                  linkService
                }) {
                  const {
                    attributes: attributes2
                  } = element;
                  const isHTMLAnchorElement = html2 instanceof HTMLAnchorElement;
                  if (attributes2.type === "radio") {
                    attributes2.name = `${attributes2.name}-${intent}`;
                  }
                  for (const [key2, value] of Object.entries(attributes2)) {
                    if (value === null || value === void 0) {
                      continue;
                    }
                    switch (key2) {
                      case "class":
                        if (value.length) {
                          html2.setAttribute(key2, value.join(" "));
                        }
                        break;
                      case "dataId":
                        break;
                      case "id":
                        html2.setAttribute("data-element-id", value);
                        break;
                      case "style":
                        Object.assign(html2.style, value);
                        break;
                      case "textContent":
                        html2.textContent = value;
                        break;
                      default:
                        if (!isHTMLAnchorElement || key2 !== "href" && key2 !== "newWindow") {
                          html2.setAttribute(key2, value);
                        }
                    }
                  }
                  if (isHTMLAnchorElement) {
                    linkService.addLinkAttributes(html2, attributes2.href, attributes2.newWindow);
                  }
                  if (storage && attributes2.dataId) {
                    this.setupStorage(html2, attributes2.dataId, element, storage);
                  }
                }
                static render(parameters) {
                  const storage = parameters.annotationStorage;
                  const linkService = parameters.linkService;
                  const root2 = parameters.xfaHtml;
                  const intent = parameters.intent || "display";
                  const rootHtml = document.createElement(root2.name);
                  if (root2.attributes) {
                    this.setAttributes({
                      html: rootHtml,
                      element: root2,
                      intent,
                      linkService
                    });
                  }
                  const stack = [[root2, -1, rootHtml]];
                  const rootDiv = parameters.div;
                  rootDiv.append(rootHtml);
                  if (parameters.viewport) {
                    const transform = `matrix(${parameters.viewport.transform.join(",")})`;
                    rootDiv.style.transform = transform;
                  }
                  if (intent !== "richText") {
                    rootDiv.setAttribute("class", "xfaLayer xfaFont");
                  }
                  const textDivs = [];
                  while (stack.length > 0) {
                    const [parent2, i, html2] = stack.at(-1);
                    if (i + 1 === parent2.children.length) {
                      stack.pop();
                      continue;
                    }
                    const child = parent2.children[++stack.at(-1)[1]];
                    if (child === null) {
                      continue;
                    }
                    const {
                      name
                    } = child;
                    if (name === "#text") {
                      const node2 = document.createTextNode(child.value);
                      textDivs.push(node2);
                      html2.append(node2);
                      continue;
                    }
                    const childHtml = child?.attributes?.xmlns ? document.createElementNS(child.attributes.xmlns, name) : document.createElement(name);
                    html2.append(childHtml);
                    if (child.attributes) {
                      this.setAttributes({
                        html: childHtml,
                        element: child,
                        storage,
                        intent,
                        linkService
                      });
                    }
                    if (child.children && child.children.length > 0) {
                      stack.push([child, -1, childHtml]);
                    } else if (child.value) {
                      const node2 = document.createTextNode(child.value);
                      if (_xfa_text2.XfaText.shouldBuildText(name)) {
                        textDivs.push(node2);
                      }
                      childHtml.append(node2);
                    }
                  }
                  for (const el of rootDiv.querySelectorAll(".xfaNonInteractive input, .xfaNonInteractive textarea")) {
                    el.setAttribute("readOnly", true);
                  }
                  return {
                    textDivs
                  };
                }
                static update(parameters) {
                  const transform = `matrix(${parameters.viewport.transform.join(",")})`;
                  parameters.div.style.transform = transform;
                  parameters.div.hidden = false;
                }
              }
              exports2.XfaLayer = XfaLayer;
            }),
            /* 33 */
            /***/
            ((__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
              Object.defineProperty(exports2, "__esModule", {
                value: true
              });
              exports2.InkEditor = void 0;
              var _util2 = __w_pdfjs_require__2(1);
              var _editor = __w_pdfjs_require__2(4);
              var _annotation_layer = __w_pdfjs_require__2(29);
              var _display_utils2 = __w_pdfjs_require__2(6);
              var _tools = __w_pdfjs_require__2(5);
              class InkEditor extends _editor.AnnotationEditor {
                #baseHeight = 0;
                #baseWidth = 0;
                #boundCanvasPointermove = this.canvasPointermove.bind(this);
                #boundCanvasPointerleave = this.canvasPointerleave.bind(this);
                #boundCanvasPointerup = this.canvasPointerup.bind(this);
                #boundCanvasPointerdown = this.canvasPointerdown.bind(this);
                #currentPath2D = new Path2D();
                #disableEditing = false;
                #hasSomethingToDraw = false;
                #isCanvasInitialized = false;
                #observer = null;
                #realWidth = 0;
                #realHeight = 0;
                #requestFrameCallback = null;
                static _defaultColor = null;
                static _defaultOpacity = 1;
                static _defaultThickness = 1;
                static _type = "ink";
                constructor(params) {
                  super({
                    ...params,
                    name: "inkEditor"
                  });
                  this.color = params.color || null;
                  this.thickness = params.thickness || null;
                  this.opacity = params.opacity || null;
                  this.paths = [];
                  this.bezierPath2D = [];
                  this.allRawPaths = [];
                  this.currentPath = [];
                  this.scaleFactor = 1;
                  this.translationX = this.translationY = 0;
                  this.x = 0;
                  this.y = 0;
                  this._willKeepAspectRatio = true;
                }
                static initialize(l10n) {
                  _editor.AnnotationEditor.initialize(l10n, {
                    strings: ["editor_ink_canvas_aria_label", "editor_ink2_aria_label"]
                  });
                }
                static updateDefaultParams(type5, value) {
                  switch (type5) {
                    case _util2.AnnotationEditorParamsType.INK_THICKNESS:
                      InkEditor._defaultThickness = value;
                      break;
                    case _util2.AnnotationEditorParamsType.INK_COLOR:
                      InkEditor._defaultColor = value;
                      break;
                    case _util2.AnnotationEditorParamsType.INK_OPACITY:
                      InkEditor._defaultOpacity = value / 100;
                      break;
                  }
                }
                updateParams(type5, value) {
                  switch (type5) {
                    case _util2.AnnotationEditorParamsType.INK_THICKNESS:
                      this.#updateThickness(value);
                      break;
                    case _util2.AnnotationEditorParamsType.INK_COLOR:
                      this.#updateColor(value);
                      break;
                    case _util2.AnnotationEditorParamsType.INK_OPACITY:
                      this.#updateOpacity(value);
                      break;
                  }
                }
                static get defaultPropertiesToUpdate() {
                  return [[_util2.AnnotationEditorParamsType.INK_THICKNESS, InkEditor._defaultThickness], [_util2.AnnotationEditorParamsType.INK_COLOR, InkEditor._defaultColor || _editor.AnnotationEditor._defaultLineColor], [_util2.AnnotationEditorParamsType.INK_OPACITY, Math.round(InkEditor._defaultOpacity * 100)]];
                }
                get propertiesToUpdate() {
                  return [[_util2.AnnotationEditorParamsType.INK_THICKNESS, this.thickness || InkEditor._defaultThickness], [_util2.AnnotationEditorParamsType.INK_COLOR, this.color || InkEditor._defaultColor || _editor.AnnotationEditor._defaultLineColor], [_util2.AnnotationEditorParamsType.INK_OPACITY, Math.round(100 * (this.opacity ?? InkEditor._defaultOpacity))]];
                }
                #updateThickness(thickness) {
                  const savedThickness = this.thickness;
                  this.addCommands({
                    cmd: () => {
                      this.thickness = thickness;
                      this.#fitToContent();
                    },
                    undo: () => {
                      this.thickness = savedThickness;
                      this.#fitToContent();
                    },
                    mustExec: true,
                    type: _util2.AnnotationEditorParamsType.INK_THICKNESS,
                    overwriteIfSameType: true,
                    keepUndo: true
                  });
                }
                #updateColor(color) {
                  const savedColor = this.color;
                  this.addCommands({
                    cmd: () => {
                      this.color = color;
                      this.#redraw();
                    },
                    undo: () => {
                      this.color = savedColor;
                      this.#redraw();
                    },
                    mustExec: true,
                    type: _util2.AnnotationEditorParamsType.INK_COLOR,
                    overwriteIfSameType: true,
                    keepUndo: true
                  });
                }
                #updateOpacity(opacity) {
                  opacity /= 100;
                  const savedOpacity = this.opacity;
                  this.addCommands({
                    cmd: () => {
                      this.opacity = opacity;
                      this.#redraw();
                    },
                    undo: () => {
                      this.opacity = savedOpacity;
                      this.#redraw();
                    },
                    mustExec: true,
                    type: _util2.AnnotationEditorParamsType.INK_OPACITY,
                    overwriteIfSameType: true,
                    keepUndo: true
                  });
                }
                rebuild() {
                  if (!this.parent) {
                    return;
                  }
                  super.rebuild();
                  if (this.div === null) {
                    return;
                  }
                  if (!this.canvas) {
                    this.#createCanvas();
                    this.#createObserver();
                  }
                  if (!this.isAttachedToDOM) {
                    this.parent.add(this);
                    this.#setCanvasDims();
                  }
                  this.#fitToContent();
                }
                remove() {
                  if (this.canvas === null) {
                    return;
                  }
                  if (!this.isEmpty()) {
                    this.commit();
                  }
                  this.canvas.width = this.canvas.height = 0;
                  this.canvas.remove();
                  this.canvas = null;
                  this.#observer.disconnect();
                  this.#observer = null;
                  super.remove();
                }
                setParent(parent2) {
                  if (!this.parent && parent2) {
                    this._uiManager.removeShouldRescale(this);
                  } else if (this.parent && parent2 === null) {
                    this._uiManager.addShouldRescale(this);
                  }
                  super.setParent(parent2);
                }
                onScaleChanging() {
                  const [parentWidth, parentHeight] = this.parentDimensions;
                  const width = this.width * parentWidth;
                  const height = this.height * parentHeight;
                  this.setDimensions(width, height);
                }
                enableEditMode() {
                  if (this.#disableEditing || this.canvas === null) {
                    return;
                  }
                  super.enableEditMode();
                  this._isDraggable = false;
                  this.canvas.addEventListener("pointerdown", this.#boundCanvasPointerdown);
                }
                disableEditMode() {
                  if (!this.isInEditMode() || this.canvas === null) {
                    return;
                  }
                  super.disableEditMode();
                  this._isDraggable = !this.isEmpty();
                  this.div.classList.remove("editing");
                  this.canvas.removeEventListener("pointerdown", this.#boundCanvasPointerdown);
                }
                onceAdded() {
                  this._isDraggable = !this.isEmpty();
                }
                isEmpty() {
                  return this.paths.length === 0 || this.paths.length === 1 && this.paths[0].length === 0;
                }
                #getInitialBBox() {
                  const {
                    parentRotation,
                    parentDimensions: [width, height]
                  } = this;
                  switch (parentRotation) {
                    case 90:
                      return [0, height, height, width];
                    case 180:
                      return [width, height, width, height];
                    case 270:
                      return [width, 0, height, width];
                    default:
                      return [0, 0, width, height];
                  }
                }
                #setStroke() {
                  const {
                    ctx,
                    color,
                    opacity,
                    thickness,
                    parentScale,
                    scaleFactor
                  } = this;
                  ctx.lineWidth = thickness * parentScale / scaleFactor;
                  ctx.lineCap = "round";
                  ctx.lineJoin = "round";
                  ctx.miterLimit = 10;
                  ctx.strokeStyle = `${color}${(0, _tools.opacityToHex)(opacity)}`;
                }
                #startDrawing(x, y) {
                  this.canvas.addEventListener("contextmenu", _display_utils2.noContextMenu);
                  this.canvas.addEventListener("pointerleave", this.#boundCanvasPointerleave);
                  this.canvas.addEventListener("pointermove", this.#boundCanvasPointermove);
                  this.canvas.addEventListener("pointerup", this.#boundCanvasPointerup);
                  this.canvas.removeEventListener("pointerdown", this.#boundCanvasPointerdown);
                  this.isEditing = true;
                  if (!this.#isCanvasInitialized) {
                    this.#isCanvasInitialized = true;
                    this.#setCanvasDims();
                    this.thickness ||= InkEditor._defaultThickness;
                    this.color ||= InkEditor._defaultColor || _editor.AnnotationEditor._defaultLineColor;
                    this.opacity ??= InkEditor._defaultOpacity;
                  }
                  this.currentPath.push([x, y]);
                  this.#hasSomethingToDraw = false;
                  this.#setStroke();
                  this.#requestFrameCallback = () => {
                    this.#drawPoints();
                    if (this.#requestFrameCallback) {
                      window.requestAnimationFrame(this.#requestFrameCallback);
                    }
                  };
                  window.requestAnimationFrame(this.#requestFrameCallback);
                }
                #draw(x, y) {
                  const [lastX, lastY] = this.currentPath.at(-1);
                  if (this.currentPath.length > 1 && x === lastX && y === lastY) {
                    return;
                  }
                  const currentPath = this.currentPath;
                  let path2D = this.#currentPath2D;
                  currentPath.push([x, y]);
                  this.#hasSomethingToDraw = true;
                  if (currentPath.length <= 2) {
                    path2D.moveTo(...currentPath[0]);
                    path2D.lineTo(x, y);
                    return;
                  }
                  if (currentPath.length === 3) {
                    this.#currentPath2D = path2D = new Path2D();
                    path2D.moveTo(...currentPath[0]);
                  }
                  this.#makeBezierCurve(path2D, ...currentPath.at(-3), ...currentPath.at(-2), x, y);
                }
                #endPath() {
                  if (this.currentPath.length === 0) {
                    return;
                  }
                  const lastPoint = this.currentPath.at(-1);
                  this.#currentPath2D.lineTo(...lastPoint);
                }
                #stopDrawing(x, y) {
                  this.#requestFrameCallback = null;
                  x = Math.min(Math.max(x, 0), this.canvas.width);
                  y = Math.min(Math.max(y, 0), this.canvas.height);
                  this.#draw(x, y);
                  this.#endPath();
                  let bezier;
                  if (this.currentPath.length !== 1) {
                    bezier = this.#generateBezierPoints();
                  } else {
                    const xy = [x, y];
                    bezier = [[xy, xy.slice(), xy.slice(), xy]];
                  }
                  const path2D = this.#currentPath2D;
                  const currentPath = this.currentPath;
                  this.currentPath = [];
                  this.#currentPath2D = new Path2D();
                  const cmd = () => {
                    this.allRawPaths.push(currentPath);
                    this.paths.push(bezier);
                    this.bezierPath2D.push(path2D);
                    this.rebuild();
                  };
                  const undo = () => {
                    this.allRawPaths.pop();
                    this.paths.pop();
                    this.bezierPath2D.pop();
                    if (this.paths.length === 0) {
                      this.remove();
                    } else {
                      if (!this.canvas) {
                        this.#createCanvas();
                        this.#createObserver();
                      }
                      this.#fitToContent();
                    }
                  };
                  this.addCommands({
                    cmd,
                    undo,
                    mustExec: true
                  });
                }
                #drawPoints() {
                  if (!this.#hasSomethingToDraw) {
                    return;
                  }
                  this.#hasSomethingToDraw = false;
                  const thickness = Math.ceil(this.thickness * this.parentScale);
                  const lastPoints = this.currentPath.slice(-3);
                  const x = lastPoints.map((xy) => xy[0]);
                  const y = lastPoints.map((xy) => xy[1]);
                  const xMin = Math.min(...x) - thickness;
                  const xMax = Math.max(...x) + thickness;
                  const yMin = Math.min(...y) - thickness;
                  const yMax = Math.max(...y) + thickness;
                  const {
                    ctx
                  } = this;
                  ctx.save();
                  ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
                  for (const path2 of this.bezierPath2D) {
                    ctx.stroke(path2);
                  }
                  ctx.stroke(this.#currentPath2D);
                  ctx.restore();
                }
                #makeBezierCurve(path2D, x0, y0, x1, y1, x2, y2) {
                  const prevX = (x0 + x1) / 2;
                  const prevY = (y0 + y1) / 2;
                  const x3 = (x1 + x2) / 2;
                  const y3 = (y1 + y2) / 2;
                  path2D.bezierCurveTo(prevX + 2 * (x1 - prevX) / 3, prevY + 2 * (y1 - prevY) / 3, x3 + 2 * (x1 - x3) / 3, y3 + 2 * (y1 - y3) / 3, x3, y3);
                }
                #generateBezierPoints() {
                  const path2 = this.currentPath;
                  if (path2.length <= 2) {
                    return [[path2[0], path2[0], path2.at(-1), path2.at(-1)]];
                  }
                  const bezierPoints = [];
                  let i;
                  let [x0, y0] = path2[0];
                  for (i = 1; i < path2.length - 2; i++) {
                    const [x12, y12] = path2[i];
                    const [x22, y22] = path2[i + 1];
                    const x3 = (x12 + x22) / 2;
                    const y3 = (y12 + y22) / 2;
                    const control12 = [x0 + 2 * (x12 - x0) / 3, y0 + 2 * (y12 - y0) / 3];
                    const control22 = [x3 + 2 * (x12 - x3) / 3, y3 + 2 * (y12 - y3) / 3];
                    bezierPoints.push([[x0, y0], control12, control22, [x3, y3]]);
                    [x0, y0] = [x3, y3];
                  }
                  const [x1, y1] = path2[i];
                  const [x2, y2] = path2[i + 1];
                  const control1 = [x0 + 2 * (x1 - x0) / 3, y0 + 2 * (y1 - y0) / 3];
                  const control2 = [x2 + 2 * (x1 - x2) / 3, y2 + 2 * (y1 - y2) / 3];
                  bezierPoints.push([[x0, y0], control1, control2, [x2, y2]]);
                  return bezierPoints;
                }
                #redraw() {
                  if (this.isEmpty()) {
                    this.#updateTransform();
                    return;
                  }
                  this.#setStroke();
                  const {
                    canvas,
                    ctx
                  } = this;
                  ctx.setTransform(1, 0, 0, 1, 0, 0);
                  ctx.clearRect(0, 0, canvas.width, canvas.height);
                  this.#updateTransform();
                  for (const path2 of this.bezierPath2D) {
                    ctx.stroke(path2);
                  }
                }
                commit() {
                  if (this.#disableEditing) {
                    return;
                  }
                  super.commit();
                  this.isEditing = false;
                  this.disableEditMode();
                  this.setInForeground();
                  this.#disableEditing = true;
                  this.div.classList.add("disabled");
                  this.#fitToContent(true);
                  this.makeResizable();
                  this.parent.addInkEditorIfNeeded(true);
                  this.moveInDOM();
                  this.div.focus({
                    preventScroll: true
                  });
                }
                focusin(event) {
                  if (!this._focusEventsAllowed) {
                    return;
                  }
                  super.focusin(event);
                  this.enableEditMode();
                }
                canvasPointerdown(event) {
                  if (event.button !== 0 || !this.isInEditMode() || this.#disableEditing) {
                    return;
                  }
                  this.setInForeground();
                  event.preventDefault();
                  if (event.type !== "mouse") {
                    this.div.focus();
                  }
                  this.#startDrawing(event.offsetX, event.offsetY);
                }
                canvasPointermove(event) {
                  event.preventDefault();
                  this.#draw(event.offsetX, event.offsetY);
                }
                canvasPointerup(event) {
                  event.preventDefault();
                  this.#endDrawing(event);
                }
                canvasPointerleave(event) {
                  this.#endDrawing(event);
                }
                #endDrawing(event) {
                  this.canvas.removeEventListener("pointerleave", this.#boundCanvasPointerleave);
                  this.canvas.removeEventListener("pointermove", this.#boundCanvasPointermove);
                  this.canvas.removeEventListener("pointerup", this.#boundCanvasPointerup);
                  this.canvas.addEventListener("pointerdown", this.#boundCanvasPointerdown);
                  setTimeout(() => {
                    this.canvas.removeEventListener("contextmenu", _display_utils2.noContextMenu);
                  }, 10);
                  this.#stopDrawing(event.offsetX, event.offsetY);
                  this.addToAnnotationStorage();
                  this.setInBackground();
                }
                #createCanvas() {
                  this.canvas = document.createElement("canvas");
                  this.canvas.width = this.canvas.height = 0;
                  this.canvas.className = "inkEditorCanvas";
                  _editor.AnnotationEditor._l10nPromise.get("editor_ink_canvas_aria_label").then((msg) => this.canvas?.setAttribute("aria-label", msg));
                  this.div.append(this.canvas);
                  this.ctx = this.canvas.getContext("2d");
                }
                #createObserver() {
                  this.#observer = new ResizeObserver((entries) => {
                    const rect = entries[0].contentRect;
                    if (rect.width && rect.height) {
                      this.setDimensions(rect.width, rect.height);
                    }
                  });
                  this.#observer.observe(this.div);
                }
                get isResizable() {
                  return !this.isEmpty() && this.#disableEditing;
                }
                render() {
                  if (this.div) {
                    return this.div;
                  }
                  let baseX, baseY;
                  if (this.width) {
                    baseX = this.x;
                    baseY = this.y;
                  }
                  super.render();
                  _editor.AnnotationEditor._l10nPromise.get("editor_ink2_aria_label").then((msg) => this.div?.setAttribute("aria-label", msg));
                  const [x, y, w, h2] = this.#getInitialBBox();
                  this.setAt(x, y, 0, 0);
                  this.setDims(w, h2);
                  this.#createCanvas();
                  if (this.width) {
                    const [parentWidth, parentHeight] = this.parentDimensions;
                    this.setAspectRatio(this.width * parentWidth, this.height * parentHeight);
                    this.setAt(baseX * parentWidth, baseY * parentHeight, this.width * parentWidth, this.height * parentHeight);
                    this.#isCanvasInitialized = true;
                    this.#setCanvasDims();
                    this.setDims(this.width * parentWidth, this.height * parentHeight);
                    this.#redraw();
                    this.div.classList.add("disabled");
                  } else {
                    this.div.classList.add("editing");
                    this.enableEditMode();
                  }
                  this.#createObserver();
                  return this.div;
                }
                #setCanvasDims() {
                  if (!this.#isCanvasInitialized) {
                    return;
                  }
                  const [parentWidth, parentHeight] = this.parentDimensions;
                  this.canvas.width = Math.ceil(this.width * parentWidth);
                  this.canvas.height = Math.ceil(this.height * parentHeight);
                  this.#updateTransform();
                }
                setDimensions(width, height) {
                  const roundedWidth = Math.round(width);
                  const roundedHeight = Math.round(height);
                  if (this.#realWidth === roundedWidth && this.#realHeight === roundedHeight) {
                    return;
                  }
                  this.#realWidth = roundedWidth;
                  this.#realHeight = roundedHeight;
                  this.canvas.style.visibility = "hidden";
                  const [parentWidth, parentHeight] = this.parentDimensions;
                  this.width = width / parentWidth;
                  this.height = height / parentHeight;
                  this.fixAndSetPosition();
                  if (this.#disableEditing) {
                    this.#setScaleFactor(width, height);
                  }
                  this.#setCanvasDims();
                  this.#redraw();
                  this.canvas.style.visibility = "visible";
                  this.fixDims();
                }
                #setScaleFactor(width, height) {
                  const padding = this.#getPadding();
                  const scaleFactorW = (width - padding) / this.#baseWidth;
                  const scaleFactorH = (height - padding) / this.#baseHeight;
                  this.scaleFactor = Math.min(scaleFactorW, scaleFactorH);
                }
                #updateTransform() {
                  const padding = this.#getPadding() / 2;
                  this.ctx.setTransform(this.scaleFactor, 0, 0, this.scaleFactor, this.translationX * this.scaleFactor + padding, this.translationY * this.scaleFactor + padding);
                }
                static #buildPath2D(bezier) {
                  const path2D = new Path2D();
                  for (let i = 0, ii = bezier.length; i < ii; i++) {
                    const [first, control1, control2, second] = bezier[i];
                    if (i === 0) {
                      path2D.moveTo(...first);
                    }
                    path2D.bezierCurveTo(control1[0], control1[1], control2[0], control2[1], second[0], second[1]);
                  }
                  return path2D;
                }
                static #toPDFCoordinates(points, rect, rotation) {
                  const [blX, blY, trX, trY] = rect;
                  switch (rotation) {
                    case 0:
                      for (let i = 0, ii = points.length; i < ii; i += 2) {
                        points[i] += blX;
                        points[i + 1] = trY - points[i + 1];
                      }
                      break;
                    case 90:
                      for (let i = 0, ii = points.length; i < ii; i += 2) {
                        const x = points[i];
                        points[i] = points[i + 1] + blX;
                        points[i + 1] = x + blY;
                      }
                      break;
                    case 180:
                      for (let i = 0, ii = points.length; i < ii; i += 2) {
                        points[i] = trX - points[i];
                        points[i + 1] += blY;
                      }
                      break;
                    case 270:
                      for (let i = 0, ii = points.length; i < ii; i += 2) {
                        const x = points[i];
                        points[i] = trX - points[i + 1];
                        points[i + 1] = trY - x;
                      }
                      break;
                    default:
                      throw new Error("Invalid rotation");
                  }
                  return points;
                }
                static #fromPDFCoordinates(points, rect, rotation) {
                  const [blX, blY, trX, trY] = rect;
                  switch (rotation) {
                    case 0:
                      for (let i = 0, ii = points.length; i < ii; i += 2) {
                        points[i] -= blX;
                        points[i + 1] = trY - points[i + 1];
                      }
                      break;
                    case 90:
                      for (let i = 0, ii = points.length; i < ii; i += 2) {
                        const x = points[i];
                        points[i] = points[i + 1] - blY;
                        points[i + 1] = x - blX;
                      }
                      break;
                    case 180:
                      for (let i = 0, ii = points.length; i < ii; i += 2) {
                        points[i] = trX - points[i];
                        points[i + 1] -= blY;
                      }
                      break;
                    case 270:
                      for (let i = 0, ii = points.length; i < ii; i += 2) {
                        const x = points[i];
                        points[i] = trY - points[i + 1];
                        points[i + 1] = trX - x;
                      }
                      break;
                    default:
                      throw new Error("Invalid rotation");
                  }
                  return points;
                }
                #serializePaths(s, tx, ty, rect) {
                  const paths = [];
                  const padding = this.thickness / 2;
                  const shiftX = s * tx + padding;
                  const shiftY = s * ty + padding;
                  for (const bezier of this.paths) {
                    const buffer = [];
                    const points = [];
                    for (let j = 0, jj = bezier.length; j < jj; j++) {
                      const [first, control1, control2, second] = bezier[j];
                      const p10 = s * first[0] + shiftX;
                      const p11 = s * first[1] + shiftY;
                      const p20 = s * control1[0] + shiftX;
                      const p21 = s * control1[1] + shiftY;
                      const p30 = s * control2[0] + shiftX;
                      const p31 = s * control2[1] + shiftY;
                      const p40 = s * second[0] + shiftX;
                      const p41 = s * second[1] + shiftY;
                      if (j === 0) {
                        buffer.push(p10, p11);
                        points.push(p10, p11);
                      }
                      buffer.push(p20, p21, p30, p31, p40, p41);
                      points.push(p20, p21);
                      if (j === jj - 1) {
                        points.push(p40, p41);
                      }
                    }
                    paths.push({
                      bezier: InkEditor.#toPDFCoordinates(buffer, rect, this.rotation),
                      points: InkEditor.#toPDFCoordinates(points, rect, this.rotation)
                    });
                  }
                  return paths;
                }
                #getBbox() {
                  let xMin = Infinity;
                  let xMax = -Infinity;
                  let yMin = Infinity;
                  let yMax = -Infinity;
                  for (const path2 of this.paths) {
                    for (const [first, control1, control2, second] of path2) {
                      const bbox = _util2.Util.bezierBoundingBox(...first, ...control1, ...control2, ...second);
                      xMin = Math.min(xMin, bbox[0]);
                      yMin = Math.min(yMin, bbox[1]);
                      xMax = Math.max(xMax, bbox[2]);
                      yMax = Math.max(yMax, bbox[3]);
                    }
                  }
                  return [xMin, yMin, xMax, yMax];
                }
                #getPadding() {
                  return this.#disableEditing ? Math.ceil(this.thickness * this.parentScale) : 0;
                }
                #fitToContent(firstTime = false) {
                  if (this.isEmpty()) {
                    return;
                  }
                  if (!this.#disableEditing) {
                    this.#redraw();
                    return;
                  }
                  const bbox = this.#getBbox();
                  const padding = this.#getPadding();
                  this.#baseWidth = Math.max(_editor.AnnotationEditor.MIN_SIZE, bbox[2] - bbox[0]);
                  this.#baseHeight = Math.max(_editor.AnnotationEditor.MIN_SIZE, bbox[3] - bbox[1]);
                  const width = Math.ceil(padding + this.#baseWidth * this.scaleFactor);
                  const height = Math.ceil(padding + this.#baseHeight * this.scaleFactor);
                  const [parentWidth, parentHeight] = this.parentDimensions;
                  this.width = width / parentWidth;
                  this.height = height / parentHeight;
                  this.setAspectRatio(width, height);
                  const prevTranslationX = this.translationX;
                  const prevTranslationY = this.translationY;
                  this.translationX = -bbox[0];
                  this.translationY = -bbox[1];
                  this.#setCanvasDims();
                  this.#redraw();
                  this.#realWidth = width;
                  this.#realHeight = height;
                  this.setDims(width, height);
                  const unscaledPadding = firstTime ? padding / this.scaleFactor / 2 : 0;
                  this.translate(prevTranslationX - this.translationX - unscaledPadding, prevTranslationY - this.translationY - unscaledPadding);
                }
                static deserialize(data2, parent2, uiManager) {
                  if (data2 instanceof _annotation_layer.InkAnnotationElement) {
                    return null;
                  }
                  const editor = super.deserialize(data2, parent2, uiManager);
                  editor.thickness = data2.thickness;
                  editor.color = _util2.Util.makeHexColor(...data2.color);
                  editor.opacity = data2.opacity;
                  const [pageWidth, pageHeight] = editor.pageDimensions;
                  const width = editor.width * pageWidth;
                  const height = editor.height * pageHeight;
                  const scaleFactor = editor.parentScale;
                  const padding = data2.thickness / 2;
                  editor.#disableEditing = true;
                  editor.#realWidth = Math.round(width);
                  editor.#realHeight = Math.round(height);
                  const {
                    paths,
                    rect,
                    rotation
                  } = data2;
                  for (let {
                    bezier
                  } of paths) {
                    bezier = InkEditor.#fromPDFCoordinates(bezier, rect, rotation);
                    const path2 = [];
                    editor.paths.push(path2);
                    let p0 = scaleFactor * (bezier[0] - padding);
                    let p1 = scaleFactor * (bezier[1] - padding);
                    for (let i = 2, ii = bezier.length; i < ii; i += 6) {
                      const p10 = scaleFactor * (bezier[i] - padding);
                      const p11 = scaleFactor * (bezier[i + 1] - padding);
                      const p20 = scaleFactor * (bezier[i + 2] - padding);
                      const p21 = scaleFactor * (bezier[i + 3] - padding);
                      const p30 = scaleFactor * (bezier[i + 4] - padding);
                      const p31 = scaleFactor * (bezier[i + 5] - padding);
                      path2.push([[p0, p1], [p10, p11], [p20, p21], [p30, p31]]);
                      p0 = p30;
                      p1 = p31;
                    }
                    const path2D = this.#buildPath2D(path2);
                    editor.bezierPath2D.push(path2D);
                  }
                  const bbox = editor.#getBbox();
                  editor.#baseWidth = Math.max(_editor.AnnotationEditor.MIN_SIZE, bbox[2] - bbox[0]);
                  editor.#baseHeight = Math.max(_editor.AnnotationEditor.MIN_SIZE, bbox[3] - bbox[1]);
                  editor.#setScaleFactor(width, height);
                  return editor;
                }
                serialize() {
                  if (this.isEmpty()) {
                    return null;
                  }
                  const rect = this.getRect(0, 0);
                  const color = _editor.AnnotationEditor._colorManager.convert(this.ctx.strokeStyle);
                  return {
                    annotationType: _util2.AnnotationEditorType.INK,
                    color,
                    thickness: this.thickness,
                    opacity: this.opacity,
                    paths: this.#serializePaths(this.scaleFactor / this.parentScale, this.translationX, this.translationY, rect),
                    pageIndex: this.pageIndex,
                    rect,
                    rotation: this.rotation,
                    structTreeParentId: this._structTreeParentId
                  };
                }
              }
              exports2.InkEditor = InkEditor;
            }),
            /* 34 */
            /***/
            ((__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
              Object.defineProperty(exports2, "__esModule", {
                value: true
              });
              exports2.StampEditor = void 0;
              var _util2 = __w_pdfjs_require__2(1);
              var _editor = __w_pdfjs_require__2(4);
              var _display_utils2 = __w_pdfjs_require__2(6);
              var _annotation_layer = __w_pdfjs_require__2(29);
              class StampEditor extends _editor.AnnotationEditor {
                #bitmap = null;
                #bitmapId = null;
                #bitmapPromise = null;
                #bitmapUrl = null;
                #bitmapFile = null;
                #canvas = null;
                #observer = null;
                #resizeTimeoutId = null;
                #isSvg = false;
                #hasBeenAddedInUndoStack = false;
                static _type = "stamp";
                constructor(params) {
                  super({
                    ...params,
                    name: "stampEditor"
                  });
                  this.#bitmapUrl = params.bitmapUrl;
                  this.#bitmapFile = params.bitmapFile;
                }
                static initialize(l10n) {
                  _editor.AnnotationEditor.initialize(l10n);
                }
                static get supportedTypes() {
                  const types3 = ["apng", "avif", "bmp", "gif", "jpeg", "png", "svg+xml", "webp", "x-icon"];
                  return (0, _util2.shadow)(this, "supportedTypes", types3.map((type5) => `image/${type5}`));
                }
                static get supportedTypesStr() {
                  return (0, _util2.shadow)(this, "supportedTypesStr", this.supportedTypes.join(","));
                }
                static isHandlingMimeForPasting(mime) {
                  return this.supportedTypes.includes(mime);
                }
                static paste(item, parent2) {
                  parent2.pasteEditor(_util2.AnnotationEditorType.STAMP, {
                    bitmapFile: item.getAsFile()
                  });
                }
                #getBitmapFetched(data2, fromId = false) {
                  if (!data2) {
                    this.remove();
                    return;
                  }
                  this.#bitmap = data2.bitmap;
                  if (!fromId) {
                    this.#bitmapId = data2.id;
                    this.#isSvg = data2.isSvg;
                  }
                  this.#createCanvas();
                }
                #getBitmapDone() {
                  this.#bitmapPromise = null;
                  this._uiManager.enableWaiting(false);
                  if (this.#canvas) {
                    this.div.focus();
                  }
                }
                #getBitmap() {
                  if (this.#bitmapId) {
                    this._uiManager.enableWaiting(true);
                    this._uiManager.imageManager.getFromId(this.#bitmapId).then((data2) => this.#getBitmapFetched(data2, true)).finally(() => this.#getBitmapDone());
                    return;
                  }
                  if (this.#bitmapUrl) {
                    const url2 = this.#bitmapUrl;
                    this.#bitmapUrl = null;
                    this._uiManager.enableWaiting(true);
                    this.#bitmapPromise = this._uiManager.imageManager.getFromUrl(url2).then((data2) => this.#getBitmapFetched(data2)).finally(() => this.#getBitmapDone());
                    return;
                  }
                  if (this.#bitmapFile) {
                    const file = this.#bitmapFile;
                    this.#bitmapFile = null;
                    this._uiManager.enableWaiting(true);
                    this.#bitmapPromise = this._uiManager.imageManager.getFromFile(file).then((data2) => this.#getBitmapFetched(data2)).finally(() => this.#getBitmapDone());
                    return;
                  }
                  const input = document.createElement("input");
                  input.type = "file";
                  input.accept = StampEditor.supportedTypesStr;
                  this.#bitmapPromise = new Promise((resolve) => {
                    input.addEventListener("change", async () => {
                      if (!input.files || input.files.length === 0) {
                        this.remove();
                      } else {
                        this._uiManager.enableWaiting(true);
                        const data2 = await this._uiManager.imageManager.getFromFile(input.files[0]);
                        this.#getBitmapFetched(data2);
                      }
                      resolve();
                    });
                    input.addEventListener("cancel", () => {
                      this.remove();
                      resolve();
                    });
                  }).finally(() => this.#getBitmapDone());
                  input.click();
                }
                remove() {
                  if (this.#bitmapId) {
                    this.#bitmap = null;
                    this._uiManager.imageManager.deleteId(this.#bitmapId);
                    this.#canvas?.remove();
                    this.#canvas = null;
                    this.#observer?.disconnect();
                    this.#observer = null;
                  }
                  super.remove();
                }
                rebuild() {
                  if (!this.parent) {
                    if (this.#bitmapId) {
                      this.#getBitmap();
                    }
                    return;
                  }
                  super.rebuild();
                  if (this.div === null) {
                    return;
                  }
                  if (this.#bitmapId) {
                    this.#getBitmap();
                  }
                  if (!this.isAttachedToDOM) {
                    this.parent.add(this);
                  }
                }
                onceAdded() {
                  this._isDraggable = true;
                  this.div.focus();
                }
                isEmpty() {
                  return !(this.#bitmapPromise || this.#bitmap || this.#bitmapUrl || this.#bitmapFile);
                }
                get isResizable() {
                  return true;
                }
                render() {
                  if (this.div) {
                    return this.div;
                  }
                  let baseX, baseY;
                  if (this.width) {
                    baseX = this.x;
                    baseY = this.y;
                  }
                  super.render();
                  this.div.hidden = true;
                  if (this.#bitmap) {
                    this.#createCanvas();
                  } else {
                    this.#getBitmap();
                  }
                  if (this.width) {
                    const [parentWidth, parentHeight] = this.parentDimensions;
                    this.setAt(baseX * parentWidth, baseY * parentHeight, this.width * parentWidth, this.height * parentHeight);
                  }
                  return this.div;
                }
                #createCanvas() {
                  const {
                    div
                  } = this;
                  let {
                    width,
                    height
                  } = this.#bitmap;
                  const [pageWidth, pageHeight] = this.pageDimensions;
                  const MAX_RATIO = 0.75;
                  if (this.width) {
                    width = this.width * pageWidth;
                    height = this.height * pageHeight;
                  } else if (width > MAX_RATIO * pageWidth || height > MAX_RATIO * pageHeight) {
                    const factor = Math.min(MAX_RATIO * pageWidth / width, MAX_RATIO * pageHeight / height);
                    width *= factor;
                    height *= factor;
                  }
                  const [parentWidth, parentHeight] = this.parentDimensions;
                  this.setDims(width * parentWidth / pageWidth, height * parentHeight / pageHeight);
                  this._uiManager.enableWaiting(false);
                  const canvas = this.#canvas = document.createElement("canvas");
                  div.append(canvas);
                  div.hidden = false;
                  this.#drawBitmap(width, height);
                  this.#createObserver();
                  if (!this.#hasBeenAddedInUndoStack) {
                    this.parent.addUndoableEditor(this);
                    this.#hasBeenAddedInUndoStack = true;
                  }
                  this._uiManager._eventBus.dispatch("reporttelemetry", {
                    source: this,
                    details: {
                      type: "editing",
                      subtype: this.editorType,
                      data: {
                        action: "inserted_image"
                      }
                    }
                  });
                  this.addAltTextButton();
                }
                #setDimensions(width, height) {
                  const [parentWidth, parentHeight] = this.parentDimensions;
                  this.width = width / parentWidth;
                  this.height = height / parentHeight;
                  this.setDims(width, height);
                  if (this._initialOptions?.isCentered) {
                    this.center();
                  } else {
                    this.fixAndSetPosition();
                  }
                  this._initialOptions = null;
                  if (this.#resizeTimeoutId !== null) {
                    clearTimeout(this.#resizeTimeoutId);
                  }
                  const TIME_TO_WAIT = 200;
                  this.#resizeTimeoutId = setTimeout(() => {
                    this.#resizeTimeoutId = null;
                    this.#drawBitmap(width, height);
                  }, TIME_TO_WAIT);
                }
                #scaleBitmap(width, height) {
                  const {
                    width: bitmapWidth,
                    height: bitmapHeight
                  } = this.#bitmap;
                  let newWidth = bitmapWidth;
                  let newHeight = bitmapHeight;
                  let bitmap = this.#bitmap;
                  while (newWidth > 2 * width || newHeight > 2 * height) {
                    const prevWidth = newWidth;
                    const prevHeight = newHeight;
                    if (newWidth > 2 * width) {
                      newWidth = newWidth >= 16384 ? Math.floor(newWidth / 2) - 1 : Math.ceil(newWidth / 2);
                    }
                    if (newHeight > 2 * height) {
                      newHeight = newHeight >= 16384 ? Math.floor(newHeight / 2) - 1 : Math.ceil(newHeight / 2);
                    }
                    const offscreen = new OffscreenCanvas(newWidth, newHeight);
                    const ctx = offscreen.getContext("2d");
                    ctx.drawImage(bitmap, 0, 0, prevWidth, prevHeight, 0, 0, newWidth, newHeight);
                    bitmap = offscreen.transferToImageBitmap();
                  }
                  return bitmap;
                }
                #drawBitmap(width, height) {
                  width = Math.ceil(width);
                  height = Math.ceil(height);
                  const canvas = this.#canvas;
                  if (!canvas || canvas.width === width && canvas.height === height) {
                    return;
                  }
                  canvas.width = width;
                  canvas.height = height;
                  const bitmap = this.#isSvg ? this.#bitmap : this.#scaleBitmap(width, height);
                  const ctx = canvas.getContext("2d");
                  ctx.filter = this._uiManager.hcmFilter;
                  ctx.drawImage(bitmap, 0, 0, bitmap.width, bitmap.height, 0, 0, width, height);
                }
                #serializeBitmap(toUrl) {
                  if (toUrl) {
                    if (this.#isSvg) {
                      const url2 = this._uiManager.imageManager.getSvgUrl(this.#bitmapId);
                      if (url2) {
                        return url2;
                      }
                    }
                    const canvas = document.createElement("canvas");
                    ({
                      width: canvas.width,
                      height: canvas.height
                    } = this.#bitmap);
                    const ctx = canvas.getContext("2d");
                    ctx.drawImage(this.#bitmap, 0, 0);
                    return canvas.toDataURL();
                  }
                  if (this.#isSvg) {
                    const [pageWidth, pageHeight] = this.pageDimensions;
                    const width = Math.round(this.width * pageWidth * _display_utils2.PixelsPerInch.PDF_TO_CSS_UNITS);
                    const height = Math.round(this.height * pageHeight * _display_utils2.PixelsPerInch.PDF_TO_CSS_UNITS);
                    const offscreen = new OffscreenCanvas(width, height);
                    const ctx = offscreen.getContext("2d");
                    ctx.drawImage(this.#bitmap, 0, 0, this.#bitmap.width, this.#bitmap.height, 0, 0, width, height);
                    return offscreen.transferToImageBitmap();
                  }
                  return structuredClone(this.#bitmap);
                }
                #createObserver() {
                  this.#observer = new ResizeObserver((entries) => {
                    const rect = entries[0].contentRect;
                    if (rect.width && rect.height) {
                      this.#setDimensions(rect.width, rect.height);
                    }
                  });
                  this.#observer.observe(this.div);
                }
                static deserialize(data2, parent2, uiManager) {
                  if (data2 instanceof _annotation_layer.StampAnnotationElement) {
                    return null;
                  }
                  const editor = super.deserialize(data2, parent2, uiManager);
                  const {
                    rect,
                    bitmapUrl,
                    bitmapId,
                    isSvg,
                    accessibilityData
                  } = data2;
                  if (bitmapId && uiManager.imageManager.isValidId(bitmapId)) {
                    editor.#bitmapId = bitmapId;
                  } else {
                    editor.#bitmapUrl = bitmapUrl;
                  }
                  editor.#isSvg = isSvg;
                  const [parentWidth, parentHeight] = editor.pageDimensions;
                  editor.width = (rect[2] - rect[0]) / parentWidth;
                  editor.height = (rect[3] - rect[1]) / parentHeight;
                  if (accessibilityData) {
                    editor.altTextData = accessibilityData;
                  }
                  return editor;
                }
                serialize(isForCopying = false, context = null) {
                  if (this.isEmpty()) {
                    return null;
                  }
                  const serialized = {
                    annotationType: _util2.AnnotationEditorType.STAMP,
                    bitmapId: this.#bitmapId,
                    pageIndex: this.pageIndex,
                    rect: this.getRect(0, 0),
                    rotation: this.rotation,
                    isSvg: this.#isSvg,
                    structTreeParentId: this._structTreeParentId
                  };
                  if (isForCopying) {
                    serialized.bitmapUrl = this.#serializeBitmap(true);
                    serialized.accessibilityData = this.altTextData;
                    return serialized;
                  }
                  const {
                    decorative,
                    altText
                  } = this.altTextData;
                  if (!decorative && altText) {
                    serialized.accessibilityData = {
                      type: "Figure",
                      alt: altText
                    };
                  }
                  if (context === null) {
                    return serialized;
                  }
                  context.stamps ||= /* @__PURE__ */ new Map();
                  const area = this.#isSvg ? (serialized.rect[2] - serialized.rect[0]) * (serialized.rect[3] - serialized.rect[1]) : null;
                  if (!context.stamps.has(this.#bitmapId)) {
                    context.stamps.set(this.#bitmapId, {
                      area,
                      serialized
                    });
                    serialized.bitmap = this.#serializeBitmap(false);
                  } else if (this.#isSvg) {
                    const prevData = context.stamps.get(this.#bitmapId);
                    if (area > prevData.area) {
                      prevData.area = area;
                      prevData.serialized.bitmap.close();
                      prevData.serialized.bitmap = this.#serializeBitmap(false);
                    }
                  }
                  return serialized;
                }
              }
              exports2.StampEditor = StampEditor;
            })
            /******/
          ];
          var __webpack_module_cache__ = {};
          function __w_pdfjs_require__(moduleId) {
            var cachedModule = __webpack_module_cache__[moduleId];
            if (cachedModule !== void 0) {
              return cachedModule.exports;
            }
            var module2 = __webpack_module_cache__[moduleId] = {
              /******/
              // no module.id needed
              /******/
              // no module.loaded needed
              /******/
              exports: {}
              /******/
            };
            __webpack_modules__[moduleId](module2, module2.exports, __w_pdfjs_require__);
            return module2.exports;
          }
          var __webpack_exports__ = {};
          (() => {
            var exports2 = __webpack_exports__;
            Object.defineProperty(exports2, "__esModule", {
              value: true
            });
            Object.defineProperty(exports2, "AbortException", {
              enumerable: true,
              get: function() {
                return _util2.AbortException;
              }
            });
            Object.defineProperty(exports2, "AnnotationEditorLayer", {
              enumerable: true,
              get: function() {
                return _annotation_editor_layer.AnnotationEditorLayer;
              }
            });
            Object.defineProperty(exports2, "AnnotationEditorParamsType", {
              enumerable: true,
              get: function() {
                return _util2.AnnotationEditorParamsType;
              }
            });
            Object.defineProperty(exports2, "AnnotationEditorType", {
              enumerable: true,
              get: function() {
                return _util2.AnnotationEditorType;
              }
            });
            Object.defineProperty(exports2, "AnnotationEditorUIManager", {
              enumerable: true,
              get: function() {
                return _tools.AnnotationEditorUIManager;
              }
            });
            Object.defineProperty(exports2, "AnnotationLayer", {
              enumerable: true,
              get: function() {
                return _annotation_layer.AnnotationLayer;
              }
            });
            Object.defineProperty(exports2, "AnnotationMode", {
              enumerable: true,
              get: function() {
                return _util2.AnnotationMode;
              }
            });
            Object.defineProperty(exports2, "CMapCompressionType", {
              enumerable: true,
              get: function() {
                return _util2.CMapCompressionType;
              }
            });
            Object.defineProperty(exports2, "DOMSVGFactory", {
              enumerable: true,
              get: function() {
                return _display_utils2.DOMSVGFactory;
              }
            });
            Object.defineProperty(exports2, "FeatureTest", {
              enumerable: true,
              get: function() {
                return _util2.FeatureTest;
              }
            });
            Object.defineProperty(exports2, "GlobalWorkerOptions", {
              enumerable: true,
              get: function() {
                return _worker_options2.GlobalWorkerOptions;
              }
            });
            Object.defineProperty(exports2, "ImageKind", {
              enumerable: true,
              get: function() {
                return _util2.ImageKind;
              }
            });
            Object.defineProperty(exports2, "InvalidPDFException", {
              enumerable: true,
              get: function() {
                return _util2.InvalidPDFException;
              }
            });
            Object.defineProperty(exports2, "MissingPDFException", {
              enumerable: true,
              get: function() {
                return _util2.MissingPDFException;
              }
            });
            Object.defineProperty(exports2, "OPS", {
              enumerable: true,
              get: function() {
                return _util2.OPS;
              }
            });
            Object.defineProperty(exports2, "PDFDataRangeTransport", {
              enumerable: true,
              get: function() {
                return _api2.PDFDataRangeTransport;
              }
            });
            Object.defineProperty(exports2, "PDFDateString", {
              enumerable: true,
              get: function() {
                return _display_utils2.PDFDateString;
              }
            });
            Object.defineProperty(exports2, "PDFWorker", {
              enumerable: true,
              get: function() {
                return _api2.PDFWorker;
              }
            });
            Object.defineProperty(exports2, "PasswordResponses", {
              enumerable: true,
              get: function() {
                return _util2.PasswordResponses;
              }
            });
            Object.defineProperty(exports2, "PermissionFlag", {
              enumerable: true,
              get: function() {
                return _util2.PermissionFlag;
              }
            });
            Object.defineProperty(exports2, "PixelsPerInch", {
              enumerable: true,
              get: function() {
                return _display_utils2.PixelsPerInch;
              }
            });
            Object.defineProperty(exports2, "PromiseCapability", {
              enumerable: true,
              get: function() {
                return _util2.PromiseCapability;
              }
            });
            Object.defineProperty(exports2, "RenderingCancelledException", {
              enumerable: true,
              get: function() {
                return _display_utils2.RenderingCancelledException;
              }
            });
            Object.defineProperty(exports2, "SVGGraphics", {
              enumerable: true,
              get: function() {
                return _api2.SVGGraphics;
              }
            });
            Object.defineProperty(exports2, "UnexpectedResponseException", {
              enumerable: true,
              get: function() {
                return _util2.UnexpectedResponseException;
              }
            });
            Object.defineProperty(exports2, "Util", {
              enumerable: true,
              get: function() {
                return _util2.Util;
              }
            });
            Object.defineProperty(exports2, "VerbosityLevel", {
              enumerable: true,
              get: function() {
                return _util2.VerbosityLevel;
              }
            });
            Object.defineProperty(exports2, "XfaLayer", {
              enumerable: true,
              get: function() {
                return _xfa_layer.XfaLayer;
              }
            });
            Object.defineProperty(exports2, "build", {
              enumerable: true,
              get: function() {
                return _api2.build;
              }
            });
            Object.defineProperty(exports2, "createValidAbsoluteUrl", {
              enumerable: true,
              get: function() {
                return _util2.createValidAbsoluteUrl;
              }
            });
            Object.defineProperty(exports2, "getDocument", {
              enumerable: true,
              get: function() {
                return _api2.getDocument;
              }
            });
            Object.defineProperty(exports2, "getFilenameFromUrl", {
              enumerable: true,
              get: function() {
                return _display_utils2.getFilenameFromUrl;
              }
            });
            Object.defineProperty(exports2, "getPdfFilenameFromUrl", {
              enumerable: true,
              get: function() {
                return _display_utils2.getPdfFilenameFromUrl;
              }
            });
            Object.defineProperty(exports2, "getXfaPageViewport", {
              enumerable: true,
              get: function() {
                return _display_utils2.getXfaPageViewport;
              }
            });
            Object.defineProperty(exports2, "isDataScheme", {
              enumerable: true,
              get: function() {
                return _display_utils2.isDataScheme;
              }
            });
            Object.defineProperty(exports2, "isPdfFile", {
              enumerable: true,
              get: function() {
                return _display_utils2.isPdfFile;
              }
            });
            Object.defineProperty(exports2, "loadScript", {
              enumerable: true,
              get: function() {
                return _display_utils2.loadScript;
              }
            });
            Object.defineProperty(exports2, "noContextMenu", {
              enumerable: true,
              get: function() {
                return _display_utils2.noContextMenu;
              }
            });
            Object.defineProperty(exports2, "normalizeUnicode", {
              enumerable: true,
              get: function() {
                return _util2.normalizeUnicode;
              }
            });
            Object.defineProperty(exports2, "renderTextLayer", {
              enumerable: true,
              get: function() {
                return _text_layer.renderTextLayer;
              }
            });
            Object.defineProperty(exports2, "setLayerDimensions", {
              enumerable: true,
              get: function() {
                return _display_utils2.setLayerDimensions;
              }
            });
            Object.defineProperty(exports2, "shadow", {
              enumerable: true,
              get: function() {
                return _util2.shadow;
              }
            });
            Object.defineProperty(exports2, "updateTextLayer", {
              enumerable: true,
              get: function() {
                return _text_layer.updateTextLayer;
              }
            });
            Object.defineProperty(exports2, "version", {
              enumerable: true,
              get: function() {
                return _api2.version;
              }
            });
            var _util2 = __w_pdfjs_require__(1);
            var _api2 = __w_pdfjs_require__(2);
            var _display_utils2 = __w_pdfjs_require__(6);
            var _text_layer = __w_pdfjs_require__(26);
            var _annotation_editor_layer = __w_pdfjs_require__(27);
            var _tools = __w_pdfjs_require__(5);
            var _annotation_layer = __w_pdfjs_require__(29);
            var _worker_options2 = __w_pdfjs_require__(14);
            var _xfa_layer = __w_pdfjs_require__(32);
            const pdfjsVersion = "3.11.174";
            const pdfjsBuild = "ce8716743";
          })();
          return __webpack_exports__;
        })()
      );
    });
  }
});

// ../../node_modules/pdfjs-dist/build/pdf.worker.js
var require_pdf_worker = __commonJS({
  "../../node_modules/pdfjs-dist/build/pdf.worker.js"(exports2, module2) {
    (function webpackUniversalModuleDefinition(root2, factory) {
      if (typeof exports2 === "object" && typeof module2 === "object")
        module2.exports = root2.pdfjsWorker = factory();
      else if (typeof define === "function" && define.amd)
        define("pdfjs-dist/build/pdf.worker", [], () => {
          return root2.pdfjsWorker = factory();
        });
      else if (typeof exports2 === "object")
        exports2["pdfjs-dist/build/pdf.worker"] = root2.pdfjsWorker = factory();
      else
        root2["pdfjs-dist/build/pdf.worker"] = root2.pdfjsWorker = factory();
    })(globalThis, () => {
      return (
        /******/
        (() => {
          "use strict";
          var __webpack_modules__2 = [
            ,
            /* 1 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.WorkerTask = exports3.WorkerMessageHandler = void 0;
              var _util2 = __w_pdfjs_require__3(2);
              var _core_utils = __w_pdfjs_require__3(3);
              var _primitives = __w_pdfjs_require__3(4);
              var _pdf_manager = __w_pdfjs_require__3(6);
              var _annotation = __w_pdfjs_require__3(10);
              var _cleanup_helper = __w_pdfjs_require__3(68);
              var _writer = __w_pdfjs_require__3(73);
              var _message_handler2 = __w_pdfjs_require__3(104);
              var _worker_stream = __w_pdfjs_require__3(105);
              var _struct_tree = __w_pdfjs_require__3(72);
              class WorkerTask {
                constructor(name) {
                  this.name = name;
                  this.terminated = false;
                  this._capability = new _util2.PromiseCapability();
                }
                get finished() {
                  return this._capability.promise;
                }
                finish() {
                  this._capability.resolve();
                }
                terminate() {
                  this.terminated = true;
                }
                ensureNotTerminated() {
                  if (this.terminated) {
                    throw new Error("Worker task was terminated");
                  }
                }
              }
              exports3.WorkerTask = WorkerTask;
              class WorkerMessageHandler {
                static setup(handler, port) {
                  let testMessageProcessed = false;
                  handler.on("test", function(data2) {
                    if (testMessageProcessed) {
                      return;
                    }
                    testMessageProcessed = true;
                    handler.send("test", data2 instanceof Uint8Array);
                  });
                  handler.on("configure", function(data2) {
                    (0, _util2.setVerbosityLevel)(data2.verbosity);
                  });
                  handler.on("GetDocRequest", function(data2) {
                    return WorkerMessageHandler.createDocumentHandler(data2, port);
                  });
                }
                static createDocumentHandler(docParams, port) {
                  let pdfManager;
                  let terminated = false;
                  let cancelXHRs = null;
                  const WorkerTasks = /* @__PURE__ */ new Set();
                  const verbosity = (0, _util2.getVerbosityLevel)();
                  const {
                    docId,
                    apiVersion
                  } = docParams;
                  const workerVersion = "3.11.174";
                  if (apiVersion !== workerVersion) {
                    throw new Error(`The API version "${apiVersion}" does not match the Worker version "${workerVersion}".`);
                  }
                  const enumerableProperties = [];
                  for (const property2 in []) {
                    enumerableProperties.push(property2);
                  }
                  if (enumerableProperties.length) {
                    throw new Error("The `Array.prototype` contains unexpected enumerable properties: " + enumerableProperties.join(", ") + "; thus breaking e.g. `for...in` iteration of `Array`s.");
                  }
                  const workerHandlerName = docId + "_worker";
                  let handler = new _message_handler2.MessageHandler(workerHandlerName, docId, port);
                  function ensureNotTerminated() {
                    if (terminated) {
                      throw new Error("Worker was terminated");
                    }
                  }
                  function startWorkerTask(task) {
                    WorkerTasks.add(task);
                  }
                  function finishWorkerTask(task) {
                    task.finish();
                    WorkerTasks.delete(task);
                  }
                  async function loadDocument(recoveryMode) {
                    await pdfManager.ensureDoc("checkHeader");
                    await pdfManager.ensureDoc("parseStartXRef");
                    await pdfManager.ensureDoc("parse", [recoveryMode]);
                    await pdfManager.ensureDoc("checkFirstPage", [recoveryMode]);
                    await pdfManager.ensureDoc("checkLastPage", [recoveryMode]);
                    const isPureXfa = await pdfManager.ensureDoc("isPureXfa");
                    if (isPureXfa) {
                      const task = new WorkerTask("loadXfaFonts");
                      startWorkerTask(task);
                      await Promise.all([pdfManager.loadXfaFonts(handler, task).catch((reason) => {
                      }).then(() => finishWorkerTask(task)), pdfManager.loadXfaImages()]);
                    }
                    const [numPages, fingerprints] = await Promise.all([pdfManager.ensureDoc("numPages"), pdfManager.ensureDoc("fingerprints")]);
                    const htmlForXfa = isPureXfa ? await pdfManager.ensureDoc("htmlForXfa") : null;
                    return {
                      numPages,
                      fingerprints,
                      htmlForXfa
                    };
                  }
                  function getPdfManager({
                    data: data2,
                    password,
                    disableAutoFetch,
                    rangeChunkSize,
                    length: length2,
                    docBaseUrl,
                    enableXfa,
                    evaluatorOptions
                  }) {
                    const pdfManagerArgs = {
                      source: null,
                      disableAutoFetch,
                      docBaseUrl,
                      docId,
                      enableXfa,
                      evaluatorOptions,
                      handler,
                      length: length2,
                      password,
                      rangeChunkSize
                    };
                    const pdfManagerCapability = new _util2.PromiseCapability();
                    let newPdfManager;
                    if (data2) {
                      try {
                        pdfManagerArgs.source = data2;
                        newPdfManager = new _pdf_manager.LocalPdfManager(pdfManagerArgs);
                        pdfManagerCapability.resolve(newPdfManager);
                      } catch (ex) {
                        pdfManagerCapability.reject(ex);
                      }
                      return pdfManagerCapability.promise;
                    }
                    let pdfStream, cachedChunks = [];
                    try {
                      pdfStream = new _worker_stream.PDFWorkerStream(handler);
                    } catch (ex) {
                      pdfManagerCapability.reject(ex);
                      return pdfManagerCapability.promise;
                    }
                    const fullRequest = pdfStream.getFullReader();
                    fullRequest.headersReady.then(function() {
                      if (!fullRequest.isRangeSupported) {
                        return;
                      }
                      pdfManagerArgs.source = pdfStream;
                      pdfManagerArgs.length = fullRequest.contentLength;
                      pdfManagerArgs.disableAutoFetch ||= fullRequest.isStreamingSupported;
                      newPdfManager = new _pdf_manager.NetworkPdfManager(pdfManagerArgs);
                      for (const chunk of cachedChunks) {
                        newPdfManager.sendProgressiveData(chunk);
                      }
                      cachedChunks = [];
                      pdfManagerCapability.resolve(newPdfManager);
                      cancelXHRs = null;
                    }).catch(function(reason) {
                      pdfManagerCapability.reject(reason);
                      cancelXHRs = null;
                    });
                    let loaded = 0;
                    const flushChunks = function() {
                      const pdfFile = (0, _core_utils.arrayBuffersToBytes)(cachedChunks);
                      if (length2 && pdfFile.length !== length2) {
                        (0, _util2.warn)("reported HTTP length is different from actual");
                      }
                      try {
                        pdfManagerArgs.source = pdfFile;
                        newPdfManager = new _pdf_manager.LocalPdfManager(pdfManagerArgs);
                        pdfManagerCapability.resolve(newPdfManager);
                      } catch (ex) {
                        pdfManagerCapability.reject(ex);
                      }
                      cachedChunks = [];
                    };
                    new Promise(function(resolve, reject) {
                      const readChunk = function({
                        value,
                        done
                      }) {
                        try {
                          ensureNotTerminated();
                          if (done) {
                            if (!newPdfManager) {
                              flushChunks();
                            }
                            cancelXHRs = null;
                            return;
                          }
                          loaded += value.byteLength;
                          if (!fullRequest.isStreamingSupported) {
                            handler.send("DocProgress", {
                              loaded,
                              total: Math.max(loaded, fullRequest.contentLength || 0)
                            });
                          }
                          if (newPdfManager) {
                            newPdfManager.sendProgressiveData(value);
                          } else {
                            cachedChunks.push(value);
                          }
                          fullRequest.read().then(readChunk, reject);
                        } catch (e3) {
                          reject(e3);
                        }
                      };
                      fullRequest.read().then(readChunk, reject);
                    }).catch(function(e3) {
                      pdfManagerCapability.reject(e3);
                      cancelXHRs = null;
                    });
                    cancelXHRs = function(reason) {
                      pdfStream.cancelAllRequests(reason);
                    };
                    return pdfManagerCapability.promise;
                  }
                  function setupDoc(data2) {
                    function onSuccess(doc2) {
                      ensureNotTerminated();
                      handler.send("GetDoc", {
                        pdfInfo: doc2
                      });
                    }
                    function onFailure(ex) {
                      ensureNotTerminated();
                      if (ex instanceof _util2.PasswordException) {
                        const task = new WorkerTask(`PasswordException: response ${ex.code}`);
                        startWorkerTask(task);
                        handler.sendWithPromise("PasswordRequest", ex).then(function({
                          password
                        }) {
                          finishWorkerTask(task);
                          pdfManager.updatePassword(password);
                          pdfManagerReady();
                        }).catch(function() {
                          finishWorkerTask(task);
                          handler.send("DocException", ex);
                        });
                      } else if (ex instanceof _util2.InvalidPDFException || ex instanceof _util2.MissingPDFException || ex instanceof _util2.UnexpectedResponseException || ex instanceof _util2.UnknownErrorException) {
                        handler.send("DocException", ex);
                      } else {
                        handler.send("DocException", new _util2.UnknownErrorException(ex.message, ex.toString()));
                      }
                    }
                    function pdfManagerReady() {
                      ensureNotTerminated();
                      loadDocument(false).then(onSuccess, function(reason) {
                        ensureNotTerminated();
                        if (!(reason instanceof _core_utils.XRefParseException)) {
                          onFailure(reason);
                          return;
                        }
                        pdfManager.requestLoadedStream().then(function() {
                          ensureNotTerminated();
                          loadDocument(true).then(onSuccess, onFailure);
                        });
                      });
                    }
                    ensureNotTerminated();
                    getPdfManager(data2).then(function(newPdfManager) {
                      if (terminated) {
                        newPdfManager.terminate(new _util2.AbortException("Worker was terminated."));
                        throw new Error("Worker was terminated");
                      }
                      pdfManager = newPdfManager;
                      pdfManager.requestLoadedStream(true).then((stream) => {
                        handler.send("DataLoaded", {
                          length: stream.bytes.byteLength
                        });
                      });
                    }).then(pdfManagerReady, onFailure);
                  }
                  handler.on("GetPage", function(data2) {
                    return pdfManager.getPage(data2.pageIndex).then(function(page) {
                      return Promise.all([pdfManager.ensure(page, "rotate"), pdfManager.ensure(page, "ref"), pdfManager.ensure(page, "userUnit"), pdfManager.ensure(page, "view")]).then(function([rotate2, ref3, userUnit, view]) {
                        return {
                          rotate: rotate2,
                          ref: ref3,
                          userUnit,
                          view
                        };
                      });
                    });
                  });
                  handler.on("GetPageIndex", function(data2) {
                    const pageRef = _primitives.Ref.get(data2.num, data2.gen);
                    return pdfManager.ensureCatalog("getPageIndex", [pageRef]);
                  });
                  handler.on("GetDestinations", function(data2) {
                    return pdfManager.ensureCatalog("destinations");
                  });
                  handler.on("GetDestination", function(data2) {
                    return pdfManager.ensureCatalog("getDestination", [data2.id]);
                  });
                  handler.on("GetPageLabels", function(data2) {
                    return pdfManager.ensureCatalog("pageLabels");
                  });
                  handler.on("GetPageLayout", function(data2) {
                    return pdfManager.ensureCatalog("pageLayout");
                  });
                  handler.on("GetPageMode", function(data2) {
                    return pdfManager.ensureCatalog("pageMode");
                  });
                  handler.on("GetViewerPreferences", function(data2) {
                    return pdfManager.ensureCatalog("viewerPreferences");
                  });
                  handler.on("GetOpenAction", function(data2) {
                    return pdfManager.ensureCatalog("openAction");
                  });
                  handler.on("GetAttachments", function(data2) {
                    return pdfManager.ensureCatalog("attachments");
                  });
                  handler.on("GetDocJSActions", function(data2) {
                    return pdfManager.ensureCatalog("jsActions");
                  });
                  handler.on("GetPageJSActions", function({
                    pageIndex
                  }) {
                    return pdfManager.getPage(pageIndex).then(function(page) {
                      return pdfManager.ensure(page, "jsActions");
                    });
                  });
                  handler.on("GetOutline", function(data2) {
                    return pdfManager.ensureCatalog("documentOutline");
                  });
                  handler.on("GetOptionalContentConfig", function(data2) {
                    return pdfManager.ensureCatalog("optionalContentConfig");
                  });
                  handler.on("GetPermissions", function(data2) {
                    return pdfManager.ensureCatalog("permissions");
                  });
                  handler.on("GetMetadata", function(data2) {
                    return Promise.all([pdfManager.ensureDoc("documentInfo"), pdfManager.ensureCatalog("metadata")]);
                  });
                  handler.on("GetMarkInfo", function(data2) {
                    return pdfManager.ensureCatalog("markInfo");
                  });
                  handler.on("GetData", function(data2) {
                    return pdfManager.requestLoadedStream().then(function(stream) {
                      return stream.bytes;
                    });
                  });
                  handler.on("GetAnnotations", function({
                    pageIndex,
                    intent
                  }) {
                    return pdfManager.getPage(pageIndex).then(function(page) {
                      const task = new WorkerTask(`GetAnnotations: page ${pageIndex}`);
                      startWorkerTask(task);
                      return page.getAnnotationsData(handler, task, intent).then((data2) => {
                        finishWorkerTask(task);
                        return data2;
                      }, (reason) => {
                        finishWorkerTask(task);
                        throw reason;
                      });
                    });
                  });
                  handler.on("GetFieldObjects", function(data2) {
                    return pdfManager.ensureDoc("fieldObjects");
                  });
                  handler.on("HasJSActions", function(data2) {
                    return pdfManager.ensureDoc("hasJSActions");
                  });
                  handler.on("GetCalculationOrderIds", function(data2) {
                    return pdfManager.ensureDoc("calculationOrderIds");
                  });
                  handler.on("SaveDocument", async function({
                    isPureXfa,
                    numPages,
                    annotationStorage,
                    filename
                  }) {
                    const globalPromises = [pdfManager.requestLoadedStream(), pdfManager.ensureCatalog("acroForm"), pdfManager.ensureCatalog("acroFormRef"), pdfManager.ensureDoc("startXRef"), pdfManager.ensureDoc("xref"), pdfManager.ensureDoc("linearization"), pdfManager.ensureCatalog("structTreeRoot")];
                    const promises = [];
                    const newAnnotationsByPage = !isPureXfa ? (0, _core_utils.getNewAnnotationsMap)(annotationStorage) : null;
                    const [stream, acroForm, acroFormRef, startXRef, xref, linearization, _structTreeRoot] = await Promise.all(globalPromises);
                    const catalogRef = xref.trailer.getRaw("Root") || null;
                    let structTreeRoot;
                    if (newAnnotationsByPage) {
                      if (!_structTreeRoot) {
                        if (await _struct_tree.StructTreeRoot.canCreateStructureTree({
                          catalogRef,
                          pdfManager,
                          newAnnotationsByPage
                        })) {
                          structTreeRoot = null;
                        }
                      } else if (await _structTreeRoot.canUpdateStructTree({
                        pdfManager,
                        newAnnotationsByPage
                      })) {
                        structTreeRoot = _structTreeRoot;
                      }
                      const imagePromises = _annotation.AnnotationFactory.generateImages(annotationStorage.values(), xref, pdfManager.evaluatorOptions.isOffscreenCanvasSupported);
                      const newAnnotationPromises = structTreeRoot === void 0 ? promises : [];
                      for (const [pageIndex, annotations] of newAnnotationsByPage) {
                        newAnnotationPromises.push(pdfManager.getPage(pageIndex).then((page) => {
                          const task = new WorkerTask(`Save (editor): page ${pageIndex}`);
                          return page.saveNewAnnotations(handler, task, annotations, imagePromises).finally(function() {
                            finishWorkerTask(task);
                          });
                        }));
                      }
                      if (structTreeRoot === null) {
                        promises.push(Promise.all(newAnnotationPromises).then(async (newRefs2) => {
                          await _struct_tree.StructTreeRoot.createStructureTree({
                            newAnnotationsByPage,
                            xref,
                            catalogRef,
                            pdfManager,
                            newRefs: newRefs2
                          });
                          return newRefs2;
                        }));
                      } else if (structTreeRoot) {
                        promises.push(Promise.all(newAnnotationPromises).then(async (newRefs2) => {
                          await structTreeRoot.updateStructureTree({
                            newAnnotationsByPage,
                            pdfManager,
                            newRefs: newRefs2
                          });
                          return newRefs2;
                        }));
                      }
                    }
                    if (isPureXfa) {
                      promises.push(pdfManager.serializeXfaData(annotationStorage));
                    } else {
                      for (let pageIndex = 0; pageIndex < numPages; pageIndex++) {
                        promises.push(pdfManager.getPage(pageIndex).then(function(page) {
                          const task = new WorkerTask(`Save: page ${pageIndex}`);
                          return page.save(handler, task, annotationStorage).finally(function() {
                            finishWorkerTask(task);
                          });
                        }));
                      }
                    }
                    const refs2 = await Promise.all(promises);
                    let newRefs = [];
                    let xfaData = null;
                    if (isPureXfa) {
                      xfaData = refs2[0];
                      if (!xfaData) {
                        return stream.bytes;
                      }
                    } else {
                      newRefs = refs2.flat(2);
                      if (newRefs.length === 0) {
                        return stream.bytes;
                      }
                    }
                    const needAppearances = acroFormRef && acroForm instanceof _primitives.Dict && newRefs.some((ref3) => ref3.needAppearances);
                    const xfa = acroForm instanceof _primitives.Dict && acroForm.get("XFA") || null;
                    let xfaDatasetsRef = null;
                    let hasXfaDatasetsEntry = false;
                    if (Array.isArray(xfa)) {
                      for (let i = 0, ii = xfa.length; i < ii; i += 2) {
                        if (xfa[i] === "datasets") {
                          xfaDatasetsRef = xfa[i + 1];
                          hasXfaDatasetsEntry = true;
                        }
                      }
                      if (xfaDatasetsRef === null) {
                        xfaDatasetsRef = xref.getNewTemporaryRef();
                      }
                    } else if (xfa) {
                      (0, _util2.warn)("Unsupported XFA type.");
                    }
                    let newXrefInfo = /* @__PURE__ */ Object.create(null);
                    if (xref.trailer) {
                      const infoObj = /* @__PURE__ */ Object.create(null);
                      const xrefInfo = xref.trailer.get("Info") || null;
                      if (xrefInfo instanceof _primitives.Dict) {
                        xrefInfo.forEach((key2, value) => {
                          if (typeof value === "string") {
                            infoObj[key2] = (0, _util2.stringToPDFString)(value);
                          }
                        });
                      }
                      newXrefInfo = {
                        rootRef: catalogRef,
                        encryptRef: xref.trailer.getRaw("Encrypt") || null,
                        newRef: xref.getNewTemporaryRef(),
                        infoRef: xref.trailer.getRaw("Info") || null,
                        info: infoObj,
                        fileIds: xref.trailer.get("ID") || null,
                        startXRef: linearization ? startXRef : xref.lastXRefStreamPos ?? startXRef,
                        filename
                      };
                    }
                    return (0, _writer.incrementalUpdate)({
                      originalData: stream.bytes,
                      xrefInfo: newXrefInfo,
                      newRefs,
                      xref,
                      hasXfa: !!xfa,
                      xfaDatasetsRef,
                      hasXfaDatasetsEntry,
                      needAppearances,
                      acroFormRef,
                      acroForm,
                      xfaData
                    }).finally(() => {
                      xref.resetNewTemporaryRef();
                    });
                  });
                  handler.on("GetOperatorList", function(data2, sink) {
                    const pageIndex = data2.pageIndex;
                    pdfManager.getPage(pageIndex).then(function(page) {
                      const task = new WorkerTask(`GetOperatorList: page ${pageIndex}`);
                      startWorkerTask(task);
                      const start = verbosity >= _util2.VerbosityLevel.INFOS ? Date.now() : 0;
                      page.getOperatorList({
                        handler,
                        sink,
                        task,
                        intent: data2.intent,
                        cacheKey: data2.cacheKey,
                        annotationStorage: data2.annotationStorage
                      }).then(function(operatorListInfo) {
                        finishWorkerTask(task);
                        if (start) {
                          (0, _util2.info)(`page=${pageIndex + 1} - getOperatorList: time=${Date.now() - start}ms, len=${operatorListInfo.length}`);
                        }
                        sink.close();
                      }, function(reason) {
                        finishWorkerTask(task);
                        if (task.terminated) {
                          return;
                        }
                        sink.error(reason);
                      });
                    });
                  });
                  handler.on("GetTextContent", function(data2, sink) {
                    const {
                      pageIndex,
                      includeMarkedContent,
                      disableNormalization
                    } = data2;
                    pdfManager.getPage(pageIndex).then(function(page) {
                      const task = new WorkerTask("GetTextContent: page " + pageIndex);
                      startWorkerTask(task);
                      const start = verbosity >= _util2.VerbosityLevel.INFOS ? Date.now() : 0;
                      page.extractTextContent({
                        handler,
                        task,
                        sink,
                        includeMarkedContent,
                        disableNormalization
                      }).then(function() {
                        finishWorkerTask(task);
                        if (start) {
                          (0, _util2.info)(`page=${pageIndex + 1} - getTextContent: time=${Date.now() - start}ms`);
                        }
                        sink.close();
                      }, function(reason) {
                        finishWorkerTask(task);
                        if (task.terminated) {
                          return;
                        }
                        sink.error(reason);
                      });
                    });
                  });
                  handler.on("GetStructTree", function(data2) {
                    return pdfManager.getPage(data2.pageIndex).then(function(page) {
                      return pdfManager.ensure(page, "getStructTree");
                    });
                  });
                  handler.on("FontFallback", function(data2) {
                    return pdfManager.fontFallback(data2.id, handler);
                  });
                  handler.on("Cleanup", function(data2) {
                    return pdfManager.cleanup(true);
                  });
                  handler.on("Terminate", function(data2) {
                    terminated = true;
                    const waitOn = [];
                    if (pdfManager) {
                      pdfManager.terminate(new _util2.AbortException("Worker was terminated."));
                      const cleanupPromise = pdfManager.cleanup();
                      waitOn.push(cleanupPromise);
                      pdfManager = null;
                    } else {
                      (0, _cleanup_helper.clearGlobalCaches)();
                    }
                    if (cancelXHRs) {
                      cancelXHRs(new _util2.AbortException("Worker was terminated."));
                    }
                    for (const task of WorkerTasks) {
                      waitOn.push(task.finished);
                      task.terminate();
                    }
                    return Promise.all(waitOn).then(function() {
                      handler.destroy();
                      handler = null;
                    });
                  });
                  handler.on("Ready", function(data2) {
                    setupDoc(docParams);
                    docParams = null;
                  });
                  return workerHandlerName;
                }
                static initializeFromPort(port) {
                  const handler = new _message_handler2.MessageHandler("worker", "main", port);
                  WorkerMessageHandler.setup(handler, port);
                  handler.send("ready", null);
                }
              }
              exports3.WorkerMessageHandler = WorkerMessageHandler;
              function isMessagePort(maybePort) {
                return typeof maybePort.postMessage === "function" && "onmessage" in maybePort;
              }
              if (typeof window === "undefined" && !_util2.isNodeJS && typeof self !== "undefined" && isMessagePort(self)) {
                WorkerMessageHandler.initializeFromPort(self);
              }
            }),
            /* 2 */
            /***/
            ((__unused_webpack_module2, exports3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.VerbosityLevel = exports3.Util = exports3.UnknownErrorException = exports3.UnexpectedResponseException = exports3.TextRenderingMode = exports3.RenderingIntentFlag = exports3.PromiseCapability = exports3.PermissionFlag = exports3.PasswordResponses = exports3.PasswordException = exports3.PageActionEventType = exports3.OPS = exports3.MissingPDFException = exports3.MAX_IMAGE_SIZE_TO_CACHE = exports3.LINE_FACTOR = exports3.LINE_DESCENT_FACTOR = exports3.InvalidPDFException = exports3.ImageKind = exports3.IDENTITY_MATRIX = exports3.FormatError = exports3.FeatureTest = exports3.FONT_IDENTITY_MATRIX = exports3.DocumentActionEventType = exports3.CMapCompressionType = exports3.BaseException = exports3.BASELINE_FACTOR = exports3.AnnotationType = exports3.AnnotationReplyType = exports3.AnnotationPrefix = exports3.AnnotationMode = exports3.AnnotationFlag = exports3.AnnotationFieldFlag = exports3.AnnotationEditorType = exports3.AnnotationEditorPrefix = exports3.AnnotationEditorParamsType = exports3.AnnotationBorderStyleType = exports3.AnnotationActionEventType = exports3.AbortException = void 0;
              exports3.assert = assert;
              exports3.bytesToString = bytesToString;
              exports3.createValidAbsoluteUrl = createValidAbsoluteUrl;
              exports3.getModificationDate = getModificationDate;
              exports3.getUuid = getUuid;
              exports3.getVerbosityLevel = getVerbosityLevel;
              exports3.info = info;
              exports3.isArrayBuffer = isArrayBuffer;
              exports3.isArrayEqual = isArrayEqual;
              exports3.isNodeJS = void 0;
              exports3.normalizeUnicode = normalizeUnicode;
              exports3.objectFromMap = objectFromMap;
              exports3.objectSize = objectSize;
              exports3.setVerbosityLevel = setVerbosityLevel;
              exports3.shadow = shadow;
              exports3.string32 = string32;
              exports3.stringToBytes = stringToBytes;
              exports3.stringToPDFString = stringToPDFString;
              exports3.stringToUTF8String = stringToUTF8String;
              exports3.unreachable = unreachable;
              exports3.utf8StringToString = utf8StringToString;
              exports3.warn = warn;
              const isNodeJS = typeof process === "object" && process + "" === "[object process]" && !process.versions.nw && !(process.versions.electron && process.type && process.type !== "browser");
              exports3.isNodeJS = isNodeJS;
              const IDENTITY_MATRIX = [1, 0, 0, 1, 0, 0];
              exports3.IDENTITY_MATRIX = IDENTITY_MATRIX;
              const FONT_IDENTITY_MATRIX = [1e-3, 0, 0, 1e-3, 0, 0];
              exports3.FONT_IDENTITY_MATRIX = FONT_IDENTITY_MATRIX;
              const MAX_IMAGE_SIZE_TO_CACHE = 1e7;
              exports3.MAX_IMAGE_SIZE_TO_CACHE = MAX_IMAGE_SIZE_TO_CACHE;
              const LINE_FACTOR = 1.35;
              exports3.LINE_FACTOR = LINE_FACTOR;
              const LINE_DESCENT_FACTOR = 0.35;
              exports3.LINE_DESCENT_FACTOR = LINE_DESCENT_FACTOR;
              const BASELINE_FACTOR = LINE_DESCENT_FACTOR / LINE_FACTOR;
              exports3.BASELINE_FACTOR = BASELINE_FACTOR;
              const RenderingIntentFlag = {
                ANY: 1,
                DISPLAY: 2,
                PRINT: 4,
                SAVE: 8,
                ANNOTATIONS_FORMS: 16,
                ANNOTATIONS_STORAGE: 32,
                ANNOTATIONS_DISABLE: 64,
                OPLIST: 256
              };
              exports3.RenderingIntentFlag = RenderingIntentFlag;
              const AnnotationMode = {
                DISABLE: 0,
                ENABLE: 1,
                ENABLE_FORMS: 2,
                ENABLE_STORAGE: 3
              };
              exports3.AnnotationMode = AnnotationMode;
              const AnnotationEditorPrefix = "pdfjs_internal_editor_";
              exports3.AnnotationEditorPrefix = AnnotationEditorPrefix;
              const AnnotationEditorType = {
                DISABLE: -1,
                NONE: 0,
                FREETEXT: 3,
                STAMP: 13,
                INK: 15
              };
              exports3.AnnotationEditorType = AnnotationEditorType;
              const AnnotationEditorParamsType = {
                RESIZE: 1,
                CREATE: 2,
                FREETEXT_SIZE: 11,
                FREETEXT_COLOR: 12,
                FREETEXT_OPACITY: 13,
                INK_COLOR: 21,
                INK_THICKNESS: 22,
                INK_OPACITY: 23
              };
              exports3.AnnotationEditorParamsType = AnnotationEditorParamsType;
              const PermissionFlag = {
                PRINT: 4,
                MODIFY_CONTENTS: 8,
                COPY: 16,
                MODIFY_ANNOTATIONS: 32,
                FILL_INTERACTIVE_FORMS: 256,
                COPY_FOR_ACCESSIBILITY: 512,
                ASSEMBLE: 1024,
                PRINT_HIGH_QUALITY: 2048
              };
              exports3.PermissionFlag = PermissionFlag;
              const TextRenderingMode = {
                FILL: 0,
                STROKE: 1,
                FILL_STROKE: 2,
                INVISIBLE: 3,
                FILL_ADD_TO_PATH: 4,
                STROKE_ADD_TO_PATH: 5,
                FILL_STROKE_ADD_TO_PATH: 6,
                ADD_TO_PATH: 7,
                FILL_STROKE_MASK: 3,
                ADD_TO_PATH_FLAG: 4
              };
              exports3.TextRenderingMode = TextRenderingMode;
              const ImageKind = {
                GRAYSCALE_1BPP: 1,
                RGB_24BPP: 2,
                RGBA_32BPP: 3
              };
              exports3.ImageKind = ImageKind;
              const AnnotationType = {
                TEXT: 1,
                LINK: 2,
                FREETEXT: 3,
                LINE: 4,
                SQUARE: 5,
                CIRCLE: 6,
                POLYGON: 7,
                POLYLINE: 8,
                HIGHLIGHT: 9,
                UNDERLINE: 10,
                SQUIGGLY: 11,
                STRIKEOUT: 12,
                STAMP: 13,
                CARET: 14,
                INK: 15,
                POPUP: 16,
                FILEATTACHMENT: 17,
                SOUND: 18,
                MOVIE: 19,
                WIDGET: 20,
                SCREEN: 21,
                PRINTERMARK: 22,
                TRAPNET: 23,
                WATERMARK: 24,
                THREED: 25,
                REDACT: 26
              };
              exports3.AnnotationType = AnnotationType;
              const AnnotationReplyType = {
                GROUP: "Group",
                REPLY: "R"
              };
              exports3.AnnotationReplyType = AnnotationReplyType;
              const AnnotationFlag = {
                INVISIBLE: 1,
                HIDDEN: 2,
                PRINT: 4,
                NOZOOM: 8,
                NOROTATE: 16,
                NOVIEW: 32,
                READONLY: 64,
                LOCKED: 128,
                TOGGLENOVIEW: 256,
                LOCKEDCONTENTS: 512
              };
              exports3.AnnotationFlag = AnnotationFlag;
              const AnnotationFieldFlag = {
                READONLY: 1,
                REQUIRED: 2,
                NOEXPORT: 4,
                MULTILINE: 4096,
                PASSWORD: 8192,
                NOTOGGLETOOFF: 16384,
                RADIO: 32768,
                PUSHBUTTON: 65536,
                COMBO: 131072,
                EDIT: 262144,
                SORT: 524288,
                FILESELECT: 1048576,
                MULTISELECT: 2097152,
                DONOTSPELLCHECK: 4194304,
                DONOTSCROLL: 8388608,
                COMB: 16777216,
                RICHTEXT: 33554432,
                RADIOSINUNISON: 33554432,
                COMMITONSELCHANGE: 67108864
              };
              exports3.AnnotationFieldFlag = AnnotationFieldFlag;
              const AnnotationBorderStyleType = {
                SOLID: 1,
                DASHED: 2,
                BEVELED: 3,
                INSET: 4,
                UNDERLINE: 5
              };
              exports3.AnnotationBorderStyleType = AnnotationBorderStyleType;
              const AnnotationActionEventType = {
                E: "Mouse Enter",
                X: "Mouse Exit",
                D: "Mouse Down",
                U: "Mouse Up",
                Fo: "Focus",
                Bl: "Blur",
                PO: "PageOpen",
                PC: "PageClose",
                PV: "PageVisible",
                PI: "PageInvisible",
                K: "Keystroke",
                F: "Format",
                V: "Validate",
                C: "Calculate"
              };
              exports3.AnnotationActionEventType = AnnotationActionEventType;
              const DocumentActionEventType = {
                WC: "WillClose",
                WS: "WillSave",
                DS: "DidSave",
                WP: "WillPrint",
                DP: "DidPrint"
              };
              exports3.DocumentActionEventType = DocumentActionEventType;
              const PageActionEventType = {
                O: "PageOpen",
                C: "PageClose"
              };
              exports3.PageActionEventType = PageActionEventType;
              const VerbosityLevel = {
                ERRORS: 0,
                WARNINGS: 1,
                INFOS: 5
              };
              exports3.VerbosityLevel = VerbosityLevel;
              const CMapCompressionType = {
                NONE: 0,
                BINARY: 1
              };
              exports3.CMapCompressionType = CMapCompressionType;
              const OPS = {
                dependency: 1,
                setLineWidth: 2,
                setLineCap: 3,
                setLineJoin: 4,
                setMiterLimit: 5,
                setDash: 6,
                setRenderingIntent: 7,
                setFlatness: 8,
                setGState: 9,
                save: 10,
                restore: 11,
                transform: 12,
                moveTo: 13,
                lineTo: 14,
                curveTo: 15,
                curveTo2: 16,
                curveTo3: 17,
                closePath: 18,
                rectangle: 19,
                stroke: 20,
                closeStroke: 21,
                fill: 22,
                eoFill: 23,
                fillStroke: 24,
                eoFillStroke: 25,
                closeFillStroke: 26,
                closeEOFillStroke: 27,
                endPath: 28,
                clip: 29,
                eoClip: 30,
                beginText: 31,
                endText: 32,
                setCharSpacing: 33,
                setWordSpacing: 34,
                setHScale: 35,
                setLeading: 36,
                setFont: 37,
                setTextRenderingMode: 38,
                setTextRise: 39,
                moveText: 40,
                setLeadingMoveText: 41,
                setTextMatrix: 42,
                nextLine: 43,
                showText: 44,
                showSpacedText: 45,
                nextLineShowText: 46,
                nextLineSetSpacingShowText: 47,
                setCharWidth: 48,
                setCharWidthAndBounds: 49,
                setStrokeColorSpace: 50,
                setFillColorSpace: 51,
                setStrokeColor: 52,
                setStrokeColorN: 53,
                setFillColor: 54,
                setFillColorN: 55,
                setStrokeGray: 56,
                setFillGray: 57,
                setStrokeRGBColor: 58,
                setFillRGBColor: 59,
                setStrokeCMYKColor: 60,
                setFillCMYKColor: 61,
                shadingFill: 62,
                beginInlineImage: 63,
                beginImageData: 64,
                endInlineImage: 65,
                paintXObject: 66,
                markPoint: 67,
                markPointProps: 68,
                beginMarkedContent: 69,
                beginMarkedContentProps: 70,
                endMarkedContent: 71,
                beginCompat: 72,
                endCompat: 73,
                paintFormXObjectBegin: 74,
                paintFormXObjectEnd: 75,
                beginGroup: 76,
                endGroup: 77,
                beginAnnotation: 80,
                endAnnotation: 81,
                paintImageMaskXObject: 83,
                paintImageMaskXObjectGroup: 84,
                paintImageXObject: 85,
                paintInlineImageXObject: 86,
                paintInlineImageXObjectGroup: 87,
                paintImageXObjectRepeat: 88,
                paintImageMaskXObjectRepeat: 89,
                paintSolidColorImageMask: 90,
                constructPath: 91
              };
              exports3.OPS = OPS;
              const PasswordResponses = {
                NEED_PASSWORD: 1,
                INCORRECT_PASSWORD: 2
              };
              exports3.PasswordResponses = PasswordResponses;
              let verbosity = VerbosityLevel.WARNINGS;
              function setVerbosityLevel(level) {
                if (Number.isInteger(level)) {
                  verbosity = level;
                }
              }
              function getVerbosityLevel() {
                return verbosity;
              }
              function info(msg) {
                if (verbosity >= VerbosityLevel.INFOS) {
                  console.log(`Info: ${msg}`);
                }
              }
              function warn(msg) {
                if (verbosity >= VerbosityLevel.WARNINGS) {
                  console.log(`Warning: ${msg}`);
                }
              }
              function unreachable(msg) {
                throw new Error(msg);
              }
              function assert(cond, msg) {
                if (!cond) {
                  unreachable(msg);
                }
              }
              function _isValidProtocol(url2) {
                switch (url2?.protocol) {
                  case "http:":
                  case "https:":
                  case "ftp:":
                  case "mailto:":
                  case "tel:":
                    return true;
                  default:
                    return false;
                }
              }
              function createValidAbsoluteUrl(url2, baseUrl = null, options = null) {
                if (!url2) {
                  return null;
                }
                try {
                  if (options && typeof url2 === "string") {
                    if (options.addDefaultProtocol && url2.startsWith("www.")) {
                      const dots = url2.match(/\./g);
                      if (dots?.length >= 2) {
                        url2 = `http://${url2}`;
                      }
                    }
                    if (options.tryConvertEncoding) {
                      try {
                        url2 = stringToUTF8String(url2);
                      } catch {
                      }
                    }
                  }
                  const absoluteUrl = baseUrl ? new URL(url2, baseUrl) : new URL(url2);
                  if (_isValidProtocol(absoluteUrl)) {
                    return absoluteUrl;
                  }
                } catch {
                }
                return null;
              }
              function shadow(obj, prop, value, nonSerializable = false) {
                Object.defineProperty(obj, prop, {
                  value,
                  enumerable: !nonSerializable,
                  configurable: true,
                  writable: false
                });
                return value;
              }
              const BaseException = (function BaseExceptionClosure() {
                function BaseException2(message2, name) {
                  if (this.constructor === BaseException2) {
                    unreachable("Cannot initialize BaseException.");
                  }
                  this.message = message2;
                  this.name = name;
                }
                BaseException2.prototype = new Error();
                BaseException2.constructor = BaseException2;
                return BaseException2;
              })();
              exports3.BaseException = BaseException;
              class PasswordException extends BaseException {
                constructor(msg, code2) {
                  super(msg, "PasswordException");
                  this.code = code2;
                }
              }
              exports3.PasswordException = PasswordException;
              class UnknownErrorException extends BaseException {
                constructor(msg, details) {
                  super(msg, "UnknownErrorException");
                  this.details = details;
                }
              }
              exports3.UnknownErrorException = UnknownErrorException;
              class InvalidPDFException extends BaseException {
                constructor(msg) {
                  super(msg, "InvalidPDFException");
                }
              }
              exports3.InvalidPDFException = InvalidPDFException;
              class MissingPDFException extends BaseException {
                constructor(msg) {
                  super(msg, "MissingPDFException");
                }
              }
              exports3.MissingPDFException = MissingPDFException;
              class UnexpectedResponseException extends BaseException {
                constructor(msg, status) {
                  super(msg, "UnexpectedResponseException");
                  this.status = status;
                }
              }
              exports3.UnexpectedResponseException = UnexpectedResponseException;
              class FormatError extends BaseException {
                constructor(msg) {
                  super(msg, "FormatError");
                }
              }
              exports3.FormatError = FormatError;
              class AbortException extends BaseException {
                constructor(msg) {
                  super(msg, "AbortException");
                }
              }
              exports3.AbortException = AbortException;
              function bytesToString(bytes) {
                if (typeof bytes !== "object" || bytes?.length === void 0) {
                  unreachable("Invalid argument for bytesToString");
                }
                const length2 = bytes.length;
                const MAX_ARGUMENT_COUNT = 8192;
                if (length2 < MAX_ARGUMENT_COUNT) {
                  return String.fromCharCode.apply(null, bytes);
                }
                const strBuf = [];
                for (let i = 0; i < length2; i += MAX_ARGUMENT_COUNT) {
                  const chunkEnd = Math.min(i + MAX_ARGUMENT_COUNT, length2);
                  const chunk = bytes.subarray(i, chunkEnd);
                  strBuf.push(String.fromCharCode.apply(null, chunk));
                }
                return strBuf.join("");
              }
              function stringToBytes(str) {
                if (typeof str !== "string") {
                  unreachable("Invalid argument for stringToBytes");
                }
                const length2 = str.length;
                const bytes = new Uint8Array(length2);
                for (let i = 0; i < length2; ++i) {
                  bytes[i] = str.charCodeAt(i) & 255;
                }
                return bytes;
              }
              function string32(value) {
                return String.fromCharCode(value >> 24 & 255, value >> 16 & 255, value >> 8 & 255, value & 255);
              }
              function objectSize(obj) {
                return Object.keys(obj).length;
              }
              function objectFromMap(map) {
                const obj = /* @__PURE__ */ Object.create(null);
                for (const [key2, value] of map) {
                  obj[key2] = value;
                }
                return obj;
              }
              function isLittleEndian() {
                const buffer8 = new Uint8Array(4);
                buffer8[0] = 1;
                const view32 = new Uint32Array(buffer8.buffer, 0, 1);
                return view32[0] === 1;
              }
              function isEvalSupported() {
                try {
                  new Function("");
                  return true;
                } catch {
                  return false;
                }
              }
              class FeatureTest {
                static get isLittleEndian() {
                  return shadow(this, "isLittleEndian", isLittleEndian());
                }
                static get isEvalSupported() {
                  return shadow(this, "isEvalSupported", isEvalSupported());
                }
                static get isOffscreenCanvasSupported() {
                  return shadow(this, "isOffscreenCanvasSupported", typeof OffscreenCanvas !== "undefined");
                }
                static get platform() {
                  if (typeof navigator === "undefined") {
                    return shadow(this, "platform", {
                      isWin: false,
                      isMac: false
                    });
                  }
                  return shadow(this, "platform", {
                    isWin: navigator.platform.includes("Win"),
                    isMac: navigator.platform.includes("Mac")
                  });
                }
                static get isCSSRoundSupported() {
                  return shadow(this, "isCSSRoundSupported", globalThis.CSS?.supports?.("width: round(1.5px, 1px)"));
                }
              }
              exports3.FeatureTest = FeatureTest;
              const hexNumbers = [...Array(256).keys()].map((n2) => n2.toString(16).padStart(2, "0"));
              class Util {
                static makeHexColor(r2, g, b) {
                  return `#${hexNumbers[r2]}${hexNumbers[g]}${hexNumbers[b]}`;
                }
                static scaleMinMax(transform, minMax) {
                  let temp;
                  if (transform[0]) {
                    if (transform[0] < 0) {
                      temp = minMax[0];
                      minMax[0] = minMax[1];
                      minMax[1] = temp;
                    }
                    minMax[0] *= transform[0];
                    minMax[1] *= transform[0];
                    if (transform[3] < 0) {
                      temp = minMax[2];
                      minMax[2] = minMax[3];
                      minMax[3] = temp;
                    }
                    minMax[2] *= transform[3];
                    minMax[3] *= transform[3];
                  } else {
                    temp = minMax[0];
                    minMax[0] = minMax[2];
                    minMax[2] = temp;
                    temp = minMax[1];
                    minMax[1] = minMax[3];
                    minMax[3] = temp;
                    if (transform[1] < 0) {
                      temp = minMax[2];
                      minMax[2] = minMax[3];
                      minMax[3] = temp;
                    }
                    minMax[2] *= transform[1];
                    minMax[3] *= transform[1];
                    if (transform[2] < 0) {
                      temp = minMax[0];
                      minMax[0] = minMax[1];
                      minMax[1] = temp;
                    }
                    minMax[0] *= transform[2];
                    minMax[1] *= transform[2];
                  }
                  minMax[0] += transform[4];
                  minMax[1] += transform[4];
                  minMax[2] += transform[5];
                  minMax[3] += transform[5];
                }
                static transform(m1, m2) {
                  return [m1[0] * m2[0] + m1[2] * m2[1], m1[1] * m2[0] + m1[3] * m2[1], m1[0] * m2[2] + m1[2] * m2[3], m1[1] * m2[2] + m1[3] * m2[3], m1[0] * m2[4] + m1[2] * m2[5] + m1[4], m1[1] * m2[4] + m1[3] * m2[5] + m1[5]];
                }
                static applyTransform(p, m) {
                  const xt = p[0] * m[0] + p[1] * m[2] + m[4];
                  const yt = p[0] * m[1] + p[1] * m[3] + m[5];
                  return [xt, yt];
                }
                static applyInverseTransform(p, m) {
                  const d = m[0] * m[3] - m[1] * m[2];
                  const xt = (p[0] * m[3] - p[1] * m[2] + m[2] * m[5] - m[4] * m[3]) / d;
                  const yt = (-p[0] * m[1] + p[1] * m[0] + m[4] * m[1] - m[5] * m[0]) / d;
                  return [xt, yt];
                }
                static getAxialAlignedBoundingBox(r2, m) {
                  const p1 = this.applyTransform(r2, m);
                  const p2 = this.applyTransform(r2.slice(2, 4), m);
                  const p3 = this.applyTransform([r2[0], r2[3]], m);
                  const p4 = this.applyTransform([r2[2], r2[1]], m);
                  return [Math.min(p1[0], p2[0], p3[0], p4[0]), Math.min(p1[1], p2[1], p3[1], p4[1]), Math.max(p1[0], p2[0], p3[0], p4[0]), Math.max(p1[1], p2[1], p3[1], p4[1])];
                }
                static inverseTransform(m) {
                  const d = m[0] * m[3] - m[1] * m[2];
                  return [m[3] / d, -m[1] / d, -m[2] / d, m[0] / d, (m[2] * m[5] - m[4] * m[3]) / d, (m[4] * m[1] - m[5] * m[0]) / d];
                }
                static singularValueDecompose2dScale(m) {
                  const transpose2 = [m[0], m[2], m[1], m[3]];
                  const a = m[0] * transpose2[0] + m[1] * transpose2[2];
                  const b = m[0] * transpose2[1] + m[1] * transpose2[3];
                  const c = m[2] * transpose2[0] + m[3] * transpose2[2];
                  const d = m[2] * transpose2[1] + m[3] * transpose2[3];
                  const first = (a + d) / 2;
                  const second = Math.sqrt((a + d) ** 2 - 4 * (a * d - c * b)) / 2;
                  const sx = first + second || 1;
                  const sy = first - second || 1;
                  return [Math.sqrt(sx), Math.sqrt(sy)];
                }
                static normalizeRect(rect) {
                  const r2 = rect.slice(0);
                  if (rect[0] > rect[2]) {
                    r2[0] = rect[2];
                    r2[2] = rect[0];
                  }
                  if (rect[1] > rect[3]) {
                    r2[1] = rect[3];
                    r2[3] = rect[1];
                  }
                  return r2;
                }
                static intersect(rect1, rect2) {
                  const xLow = Math.max(Math.min(rect1[0], rect1[2]), Math.min(rect2[0], rect2[2]));
                  const xHigh = Math.min(Math.max(rect1[0], rect1[2]), Math.max(rect2[0], rect2[2]));
                  if (xLow > xHigh) {
                    return null;
                  }
                  const yLow = Math.max(Math.min(rect1[1], rect1[3]), Math.min(rect2[1], rect2[3]));
                  const yHigh = Math.min(Math.max(rect1[1], rect1[3]), Math.max(rect2[1], rect2[3]));
                  if (yLow > yHigh) {
                    return null;
                  }
                  return [xLow, yLow, xHigh, yHigh];
                }
                static bezierBoundingBox(x0, y0, x1, y1, x2, y2, x3, y3) {
                  const tvalues = [], bounds = [[], []];
                  let a, b, c, t2, t1, t22, b2ac, sqrtb2ac;
                  for (let i = 0; i < 2; ++i) {
                    if (i === 0) {
                      b = 6 * x0 - 12 * x1 + 6 * x2;
                      a = -3 * x0 + 9 * x1 - 9 * x2 + 3 * x3;
                      c = 3 * x1 - 3 * x0;
                    } else {
                      b = 6 * y0 - 12 * y1 + 6 * y2;
                      a = -3 * y0 + 9 * y1 - 9 * y2 + 3 * y3;
                      c = 3 * y1 - 3 * y0;
                    }
                    if (Math.abs(a) < 1e-12) {
                      if (Math.abs(b) < 1e-12) {
                        continue;
                      }
                      t2 = -c / b;
                      if (0 < t2 && t2 < 1) {
                        tvalues.push(t2);
                      }
                      continue;
                    }
                    b2ac = b * b - 4 * c * a;
                    sqrtb2ac = Math.sqrt(b2ac);
                    if (b2ac < 0) {
                      continue;
                    }
                    t1 = (-b + sqrtb2ac) / (2 * a);
                    if (0 < t1 && t1 < 1) {
                      tvalues.push(t1);
                    }
                    t22 = (-b - sqrtb2ac) / (2 * a);
                    if (0 < t22 && t22 < 1) {
                      tvalues.push(t22);
                    }
                  }
                  let j = tvalues.length, mt;
                  const jlen = j;
                  while (j--) {
                    t2 = tvalues[j];
                    mt = 1 - t2;
                    bounds[0][j] = mt * mt * mt * x0 + 3 * mt * mt * t2 * x1 + 3 * mt * t2 * t2 * x2 + t2 * t2 * t2 * x3;
                    bounds[1][j] = mt * mt * mt * y0 + 3 * mt * mt * t2 * y1 + 3 * mt * t2 * t2 * y2 + t2 * t2 * t2 * y3;
                  }
                  bounds[0][jlen] = x0;
                  bounds[1][jlen] = y0;
                  bounds[0][jlen + 1] = x3;
                  bounds[1][jlen + 1] = y3;
                  bounds[0].length = bounds[1].length = jlen + 2;
                  return [Math.min(...bounds[0]), Math.min(...bounds[1]), Math.max(...bounds[0]), Math.max(...bounds[1])];
                }
              }
              exports3.Util = Util;
              const PDFStringTranslateTable = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 728, 711, 710, 729, 733, 731, 730, 732, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 8226, 8224, 8225, 8230, 8212, 8211, 402, 8260, 8249, 8250, 8722, 8240, 8222, 8220, 8221, 8216, 8217, 8218, 8482, 64257, 64258, 321, 338, 352, 376, 381, 305, 322, 339, 353, 382, 0, 8364];
              function stringToPDFString(str) {
                if (str[0] >= "\xEF") {
                  let encoding;
                  if (str[0] === "\xFE" && str[1] === "\xFF") {
                    encoding = "utf-16be";
                  } else if (str[0] === "\xFF" && str[1] === "\xFE") {
                    encoding = "utf-16le";
                  } else if (str[0] === "\xEF" && str[1] === "\xBB" && str[2] === "\xBF") {
                    encoding = "utf-8";
                  }
                  if (encoding) {
                    try {
                      const decoder = new TextDecoder(encoding, {
                        fatal: true
                      });
                      const buffer = stringToBytes(str);
                      return decoder.decode(buffer);
                    } catch (ex) {
                      warn(`stringToPDFString: "${ex}".`);
                    }
                  }
                }
                const strBuf = [];
                for (let i = 0, ii = str.length; i < ii; i++) {
                  const code2 = PDFStringTranslateTable[str.charCodeAt(i)];
                  strBuf.push(code2 ? String.fromCharCode(code2) : str.charAt(i));
                }
                return strBuf.join("");
              }
              function stringToUTF8String(str) {
                return decodeURIComponent(escape(str));
              }
              function utf8StringToString(str) {
                return unescape(encodeURIComponent(str));
              }
              function isArrayBuffer(v) {
                return typeof v === "object" && v?.byteLength !== void 0;
              }
              function isArrayEqual(arr1, arr2) {
                if (arr1.length !== arr2.length) {
                  return false;
                }
                for (let i = 0, ii = arr1.length; i < ii; i++) {
                  if (arr1[i] !== arr2[i]) {
                    return false;
                  }
                }
                return true;
              }
              function getModificationDate(date4 = /* @__PURE__ */ new Date()) {
                const buffer = [date4.getUTCFullYear().toString(), (date4.getUTCMonth() + 1).toString().padStart(2, "0"), date4.getUTCDate().toString().padStart(2, "0"), date4.getUTCHours().toString().padStart(2, "0"), date4.getUTCMinutes().toString().padStart(2, "0"), date4.getUTCSeconds().toString().padStart(2, "0")];
                return buffer.join("");
              }
              class PromiseCapability {
                #settled = false;
                constructor() {
                  this.promise = new Promise((resolve, reject) => {
                    this.resolve = (data2) => {
                      this.#settled = true;
                      resolve(data2);
                    };
                    this.reject = (reason) => {
                      this.#settled = true;
                      reject(reason);
                    };
                  });
                }
                get settled() {
                  return this.#settled;
                }
              }
              exports3.PromiseCapability = PromiseCapability;
              let NormalizeRegex = null;
              let NormalizationMap = null;
              function normalizeUnicode(str) {
                if (!NormalizeRegex) {
                  NormalizeRegex = /([\u00a0\u00b5\u037e\u0eb3\u2000-\u200a\u202f\u2126\ufb00-\ufb04\ufb06\ufb20-\ufb36\ufb38-\ufb3c\ufb3e\ufb40-\ufb41\ufb43-\ufb44\ufb46-\ufba1\ufba4-\ufba9\ufbae-\ufbb1\ufbd3-\ufbdc\ufbde-\ufbe7\ufbea-\ufbf8\ufbfc-\ufbfd\ufc00-\ufc5d\ufc64-\ufcf1\ufcf5-\ufd3d\ufd88\ufdf4\ufdfa-\ufdfb\ufe71\ufe77\ufe79\ufe7b\ufe7d]+)|(\ufb05+)/gu;
                  NormalizationMap = /* @__PURE__ */ new Map([["\uFB05", "\u017Ft"]]);
                }
                return str.replaceAll(NormalizeRegex, (_, p1, p2) => {
                  return p1 ? p1.normalize("NFKC") : NormalizationMap.get(p2);
                });
              }
              function getUuid() {
                if (typeof crypto !== "undefined" && typeof crypto?.randomUUID === "function") {
                  return crypto.randomUUID();
                }
                const buf = new Uint8Array(32);
                if (typeof crypto !== "undefined" && typeof crypto?.getRandomValues === "function") {
                  crypto.getRandomValues(buf);
                } else {
                  for (let i = 0; i < 32; i++) {
                    buf[i] = Math.floor(Math.random() * 255);
                  }
                }
                return bytesToString(buf);
              }
              const AnnotationPrefix = "pdfjs_internal_id_";
              exports3.AnnotationPrefix = AnnotationPrefix;
            }),
            /* 3 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.XRefParseException = exports3.XRefEntryException = exports3.ParserEOFException = exports3.PDF_VERSION_REGEXP = exports3.MissingDataException = void 0;
              exports3.arrayBuffersToBytes = arrayBuffersToBytes;
              exports3.collectActions = collectActions;
              exports3.encodeToXmlString = encodeToXmlString;
              exports3.escapePDFName = escapePDFName;
              exports3.escapeString = escapeString;
              exports3.getInheritableProperty = getInheritableProperty;
              exports3.getLookupTableFactory = getLookupTableFactory;
              exports3.getNewAnnotationsMap = getNewAnnotationsMap;
              exports3.getRotationMatrix = getRotationMatrix;
              exports3.isAscii = isAscii;
              exports3.isWhiteSpace = isWhiteSpace;
              exports3.log2 = log2;
              exports3.numberToString = numberToString;
              exports3.parseXFAPath = parseXFAPath;
              exports3.readInt8 = readInt8;
              exports3.readUint16 = readUint16;
              exports3.readUint32 = readUint32;
              exports3.recoverJsURL = recoverJsURL;
              exports3.stringToUTF16HexString = stringToUTF16HexString;
              exports3.stringToUTF16String = stringToUTF16String;
              exports3.toRomanNumerals = toRomanNumerals;
              exports3.validateCSSFont = validateCSSFont;
              exports3.validateFontName = validateFontName;
              var _util2 = __w_pdfjs_require__3(2);
              var _primitives = __w_pdfjs_require__3(4);
              var _base_stream = __w_pdfjs_require__3(5);
              const PDF_VERSION_REGEXP = /^[1-9]\.\d$/;
              exports3.PDF_VERSION_REGEXP = PDF_VERSION_REGEXP;
              function getLookupTableFactory(initializer) {
                let lookup;
                return function() {
                  if (initializer) {
                    lookup = /* @__PURE__ */ Object.create(null);
                    initializer(lookup);
                    initializer = null;
                  }
                  return lookup;
                };
              }
              class MissingDataException extends _util2.BaseException {
                constructor(begin, end) {
                  super(`Missing data [${begin}, ${end})`, "MissingDataException");
                  this.begin = begin;
                  this.end = end;
                }
              }
              exports3.MissingDataException = MissingDataException;
              class ParserEOFException extends _util2.BaseException {
                constructor(msg) {
                  super(msg, "ParserEOFException");
                }
              }
              exports3.ParserEOFException = ParserEOFException;
              class XRefEntryException extends _util2.BaseException {
                constructor(msg) {
                  super(msg, "XRefEntryException");
                }
              }
              exports3.XRefEntryException = XRefEntryException;
              class XRefParseException extends _util2.BaseException {
                constructor(msg) {
                  super(msg, "XRefParseException");
                }
              }
              exports3.XRefParseException = XRefParseException;
              function arrayBuffersToBytes(arr) {
                const length2 = arr.length;
                if (length2 === 0) {
                  return new Uint8Array(0);
                }
                if (length2 === 1) {
                  return new Uint8Array(arr[0]);
                }
                let dataLength = 0;
                for (let i = 0; i < length2; i++) {
                  dataLength += arr[i].byteLength;
                }
                const data2 = new Uint8Array(dataLength);
                let pos = 0;
                for (let i = 0; i < length2; i++) {
                  const item = new Uint8Array(arr[i]);
                  data2.set(item, pos);
                  pos += item.byteLength;
                }
                return data2;
              }
              function getInheritableProperty({
                dict,
                key: key2,
                getArray: getArray3 = false,
                stopWhenFound = true
              }) {
                let values;
                const visited = new _primitives.RefSet();
                while (dict instanceof _primitives.Dict && !(dict.objId && visited.has(dict.objId))) {
                  if (dict.objId) {
                    visited.put(dict.objId);
                  }
                  const value = getArray3 ? dict.getArray(key2) : dict.get(key2);
                  if (value !== void 0) {
                    if (stopWhenFound) {
                      return value;
                    }
                    (values ||= []).push(value);
                  }
                  dict = dict.get("Parent");
                }
                return values;
              }
              const ROMAN_NUMBER_MAP = ["", "C", "CC", "CCC", "CD", "D", "DC", "DCC", "DCCC", "CM", "", "X", "XX", "XXX", "XL", "L", "LX", "LXX", "LXXX", "XC", "", "I", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX"];
              function toRomanNumerals(number4, lowerCase = false) {
                (0, _util2.assert)(Number.isInteger(number4) && number4 > 0, "The number should be a positive integer.");
                const romanBuf = [];
                let pos;
                while (number4 >= 1e3) {
                  number4 -= 1e3;
                  romanBuf.push("M");
                }
                pos = number4 / 100 | 0;
                number4 %= 100;
                romanBuf.push(ROMAN_NUMBER_MAP[pos]);
                pos = number4 / 10 | 0;
                number4 %= 10;
                romanBuf.push(ROMAN_NUMBER_MAP[10 + pos]);
                romanBuf.push(ROMAN_NUMBER_MAP[20 + number4]);
                const romanStr = romanBuf.join("");
                return lowerCase ? romanStr.toLowerCase() : romanStr;
              }
              function log2(x) {
                if (x <= 0) {
                  return 0;
                }
                return Math.ceil(Math.log2(x));
              }
              function readInt8(data2, offset4) {
                return data2[offset4] << 24 >> 24;
              }
              function readUint16(data2, offset4) {
                return data2[offset4] << 8 | data2[offset4 + 1];
              }
              function readUint32(data2, offset4) {
                return (data2[offset4] << 24 | data2[offset4 + 1] << 16 | data2[offset4 + 2] << 8 | data2[offset4 + 3]) >>> 0;
              }
              function isWhiteSpace(ch) {
                return ch === 32 || ch === 9 || ch === 13 || ch === 10;
              }
              function parseXFAPath(path2) {
                const positionPattern = /(.+)\[(\d+)\]$/;
                return path2.split(".").map((component) => {
                  const m = component.match(positionPattern);
                  if (m) {
                    return {
                      name: m[1],
                      pos: parseInt(m[2], 10)
                    };
                  }
                  return {
                    name: component,
                    pos: 0
                  };
                });
              }
              function escapePDFName(str) {
                const buffer = [];
                let start = 0;
                for (let i = 0, ii = str.length; i < ii; i++) {
                  const char2 = str.charCodeAt(i);
                  if (char2 < 33 || char2 > 126 || char2 === 35 || char2 === 40 || char2 === 41 || char2 === 60 || char2 === 62 || char2 === 91 || char2 === 93 || char2 === 123 || char2 === 125 || char2 === 47 || char2 === 37) {
                    if (start < i) {
                      buffer.push(str.substring(start, i));
                    }
                    buffer.push(`#${char2.toString(16)}`);
                    start = i + 1;
                  }
                }
                if (buffer.length === 0) {
                  return str;
                }
                if (start < str.length) {
                  buffer.push(str.substring(start, str.length));
                }
                return buffer.join("");
              }
              function escapeString(str) {
                return str.replaceAll(/([()\\\n\r])/g, (match2) => {
                  if (match2 === "\n") {
                    return "\\n";
                  } else if (match2 === "\r") {
                    return "\\r";
                  }
                  return `\\${match2}`;
                });
              }
              function _collectJS(entry, xref, list, parents) {
                if (!entry) {
                  return;
                }
                let parent2 = null;
                if (entry instanceof _primitives.Ref) {
                  if (parents.has(entry)) {
                    return;
                  }
                  parent2 = entry;
                  parents.put(parent2);
                  entry = xref.fetch(entry);
                }
                if (Array.isArray(entry)) {
                  for (const element of entry) {
                    _collectJS(element, xref, list, parents);
                  }
                } else if (entry instanceof _primitives.Dict) {
                  if ((0, _primitives.isName)(entry.get("S"), "JavaScript")) {
                    const js = entry.get("JS");
                    let code2;
                    if (js instanceof _base_stream.BaseStream) {
                      code2 = js.getString();
                    } else if (typeof js === "string") {
                      code2 = js;
                    }
                    code2 &&= (0, _util2.stringToPDFString)(code2).replaceAll("\0", "");
                    if (code2) {
                      list.push(code2);
                    }
                  }
                  _collectJS(entry.getRaw("Next"), xref, list, parents);
                }
                if (parent2) {
                  parents.remove(parent2);
                }
              }
              function collectActions(xref, dict, eventType) {
                const actions = /* @__PURE__ */ Object.create(null);
                const additionalActionsDicts = getInheritableProperty({
                  dict,
                  key: "AA",
                  stopWhenFound: false
                });
                if (additionalActionsDicts) {
                  for (let i = additionalActionsDicts.length - 1; i >= 0; i--) {
                    const additionalActions = additionalActionsDicts[i];
                    if (!(additionalActions instanceof _primitives.Dict)) {
                      continue;
                    }
                    for (const key2 of additionalActions.getKeys()) {
                      const action = eventType[key2];
                      if (!action) {
                        continue;
                      }
                      const actionDict = additionalActions.getRaw(key2);
                      const parents = new _primitives.RefSet();
                      const list = [];
                      _collectJS(actionDict, xref, list, parents);
                      if (list.length > 0) {
                        actions[action] = list;
                      }
                    }
                  }
                }
                if (dict.has("A")) {
                  const actionDict = dict.get("A");
                  const parents = new _primitives.RefSet();
                  const list = [];
                  _collectJS(actionDict, xref, list, parents);
                  if (list.length > 0) {
                    actions.Action = list;
                  }
                }
                return (0, _util2.objectSize)(actions) > 0 ? actions : null;
              }
              const XMLEntities = {
                60: "&lt;",
                62: "&gt;",
                38: "&amp;",
                34: "&quot;",
                39: "&apos;"
              };
              function encodeToXmlString(str) {
                const buffer = [];
                let start = 0;
                for (let i = 0, ii = str.length; i < ii; i++) {
                  const char2 = str.codePointAt(i);
                  if (32 <= char2 && char2 <= 126) {
                    const entity = XMLEntities[char2];
                    if (entity) {
                      if (start < i) {
                        buffer.push(str.substring(start, i));
                      }
                      buffer.push(entity);
                      start = i + 1;
                    }
                  } else {
                    if (start < i) {
                      buffer.push(str.substring(start, i));
                    }
                    buffer.push(`&#x${char2.toString(16).toUpperCase()};`);
                    if (char2 > 55295 && (char2 < 57344 || char2 > 65533)) {
                      i++;
                    }
                    start = i + 1;
                  }
                }
                if (buffer.length === 0) {
                  return str;
                }
                if (start < str.length) {
                  buffer.push(str.substring(start, str.length));
                }
                return buffer.join("");
              }
              function validateFontName(fontFamily, mustWarn = false) {
                const m = /^("|').*("|')$/.exec(fontFamily);
                if (m && m[1] === m[2]) {
                  const re = new RegExp(`[^\\\\]${m[1]}`);
                  if (re.test(fontFamily.slice(1, -1))) {
                    if (mustWarn) {
                      (0, _util2.warn)(`FontFamily contains unescaped ${m[1]}: ${fontFamily}.`);
                    }
                    return false;
                  }
                } else {
                  for (const ident of fontFamily.split(/[ \t]+/)) {
                    if (/^(\d|(-(\d|-)))/.test(ident) || !/^[\w-\\]+$/.test(ident)) {
                      if (mustWarn) {
                        (0, _util2.warn)(`FontFamily contains invalid <custom-ident>: ${fontFamily}.`);
                      }
                      return false;
                    }
                  }
                }
                return true;
              }
              function validateCSSFont(cssFontInfo) {
                const DEFAULT_CSS_FONT_OBLIQUE = "14";
                const DEFAULT_CSS_FONT_WEIGHT = "400";
                const CSS_FONT_WEIGHT_VALUES = /* @__PURE__ */ new Set(["100", "200", "300", "400", "500", "600", "700", "800", "900", "1000", "normal", "bold", "bolder", "lighter"]);
                const {
                  fontFamily,
                  fontWeight,
                  italicAngle
                } = cssFontInfo;
                if (!validateFontName(fontFamily, true)) {
                  return false;
                }
                const weight = fontWeight ? fontWeight.toString() : "";
                cssFontInfo.fontWeight = CSS_FONT_WEIGHT_VALUES.has(weight) ? weight : DEFAULT_CSS_FONT_WEIGHT;
                const angle = parseFloat(italicAngle);
                cssFontInfo.italicAngle = isNaN(angle) || angle < -90 || angle > 90 ? DEFAULT_CSS_FONT_OBLIQUE : italicAngle.toString();
                return true;
              }
              function recoverJsURL(str) {
                const URL_OPEN_METHODS = ["app.launchURL", "window.open", "xfa.host.gotoURL"];
                const regex = new RegExp("^\\s*(" + URL_OPEN_METHODS.join("|").replaceAll(".", "\\.") + `)\\((?:'|")([^'"]*)(?:'|")(?:,\\s*(\\w+)\\)|\\))`, "i");
                const jsUrl = regex.exec(str);
                if (jsUrl?.[2]) {
                  const url2 = jsUrl[2];
                  let newWindow = false;
                  if (jsUrl[3] === "true" && jsUrl[1] === "app.launchURL") {
                    newWindow = true;
                  }
                  return {
                    url: url2,
                    newWindow
                  };
                }
                return null;
              }
              function numberToString(value) {
                if (Number.isInteger(value)) {
                  return value.toString();
                }
                const roundedValue = Math.round(value * 100);
                if (roundedValue % 100 === 0) {
                  return (roundedValue / 100).toString();
                }
                if (roundedValue % 10 === 0) {
                  return value.toFixed(1);
                }
                return value.toFixed(2);
              }
              function getNewAnnotationsMap(annotationStorage) {
                if (!annotationStorage) {
                  return null;
                }
                const newAnnotationsByPage = /* @__PURE__ */ new Map();
                for (const [key2, value] of annotationStorage) {
                  if (!key2.startsWith(_util2.AnnotationEditorPrefix)) {
                    continue;
                  }
                  let annotations = newAnnotationsByPage.get(value.pageIndex);
                  if (!annotations) {
                    annotations = [];
                    newAnnotationsByPage.set(value.pageIndex, annotations);
                  }
                  annotations.push(value);
                }
                return newAnnotationsByPage.size > 0 ? newAnnotationsByPage : null;
              }
              function isAscii(str) {
                return /^[\x00-\x7F]*$/.test(str);
              }
              function stringToUTF16HexString(str) {
                const buf = [];
                for (let i = 0, ii = str.length; i < ii; i++) {
                  const char2 = str.charCodeAt(i);
                  buf.push((char2 >> 8 & 255).toString(16).padStart(2, "0"), (char2 & 255).toString(16).padStart(2, "0"));
                }
                return buf.join("");
              }
              function stringToUTF16String(str, bigEndian = false) {
                const buf = [];
                if (bigEndian) {
                  buf.push("\xFE\xFF");
                }
                for (let i = 0, ii = str.length; i < ii; i++) {
                  const char2 = str.charCodeAt(i);
                  buf.push(String.fromCharCode(char2 >> 8 & 255), String.fromCharCode(char2 & 255));
                }
                return buf.join("");
              }
              function getRotationMatrix(rotation, width, height) {
                switch (rotation) {
                  case 90:
                    return [0, 1, -1, 0, width, 0];
                  case 180:
                    return [-1, 0, 0, -1, width, height];
                  case 270:
                    return [0, -1, 1, 0, 0, height];
                  default:
                    throw new Error("Invalid rotation");
                }
              }
            }),
            /* 4 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.RefSetCache = exports3.RefSet = exports3.Ref = exports3.Name = exports3.EOF = exports3.Dict = exports3.Cmd = exports3.CIRCULAR_REF = void 0;
              exports3.clearPrimitiveCaches = clearPrimitiveCaches;
              exports3.isCmd = isCmd;
              exports3.isDict = isDict;
              exports3.isName = isName;
              exports3.isRefsEqual = isRefsEqual;
              var _util2 = __w_pdfjs_require__3(2);
              const CIRCULAR_REF = Symbol("CIRCULAR_REF");
              exports3.CIRCULAR_REF = CIRCULAR_REF;
              const EOF = Symbol("EOF");
              exports3.EOF = EOF;
              let CmdCache = /* @__PURE__ */ Object.create(null);
              let NameCache = /* @__PURE__ */ Object.create(null);
              let RefCache = /* @__PURE__ */ Object.create(null);
              function clearPrimitiveCaches() {
                CmdCache = /* @__PURE__ */ Object.create(null);
                NameCache = /* @__PURE__ */ Object.create(null);
                RefCache = /* @__PURE__ */ Object.create(null);
              }
              class Name {
                constructor(name) {
                  this.name = name;
                }
                static get(name) {
                  return NameCache[name] ||= new Name(name);
                }
              }
              exports3.Name = Name;
              class Cmd {
                constructor(cmd) {
                  this.cmd = cmd;
                }
                static get(cmd) {
                  return CmdCache[cmd] ||= new Cmd(cmd);
                }
              }
              exports3.Cmd = Cmd;
              const nonSerializable = function nonSerializableClosure() {
                return nonSerializable;
              };
              class Dict2 {
                constructor(xref = null) {
                  this._map = /* @__PURE__ */ Object.create(null);
                  this.xref = xref;
                  this.objId = null;
                  this.suppressEncryption = false;
                  this.__nonSerializable__ = nonSerializable;
                }
                assignXref(newXref) {
                  this.xref = newXref;
                }
                get size() {
                  return Object.keys(this._map).length;
                }
                get(key1, key2, key3) {
                  let value = this._map[key1];
                  if (value === void 0 && key2 !== void 0) {
                    value = this._map[key2];
                    if (value === void 0 && key3 !== void 0) {
                      value = this._map[key3];
                    }
                  }
                  if (value instanceof Ref5 && this.xref) {
                    return this.xref.fetch(value, this.suppressEncryption);
                  }
                  return value;
                }
                async getAsync(key1, key2, key3) {
                  let value = this._map[key1];
                  if (value === void 0 && key2 !== void 0) {
                    value = this._map[key2];
                    if (value === void 0 && key3 !== void 0) {
                      value = this._map[key3];
                    }
                  }
                  if (value instanceof Ref5 && this.xref) {
                    return this.xref.fetchAsync(value, this.suppressEncryption);
                  }
                  return value;
                }
                getArray(key1, key2, key3) {
                  let value = this._map[key1];
                  if (value === void 0 && key2 !== void 0) {
                    value = this._map[key2];
                    if (value === void 0 && key3 !== void 0) {
                      value = this._map[key3];
                    }
                  }
                  if (value instanceof Ref5 && this.xref) {
                    value = this.xref.fetch(value, this.suppressEncryption);
                  }
                  if (Array.isArray(value)) {
                    value = value.slice();
                    for (let i = 0, ii = value.length; i < ii; i++) {
                      if (value[i] instanceof Ref5 && this.xref) {
                        value[i] = this.xref.fetch(value[i], this.suppressEncryption);
                      }
                    }
                  }
                  return value;
                }
                getRaw(key2) {
                  return this._map[key2];
                }
                getKeys() {
                  return Object.keys(this._map);
                }
                getRawValues() {
                  return Object.values(this._map);
                }
                set(key2, value) {
                  this._map[key2] = value;
                }
                has(key2) {
                  return this._map[key2] !== void 0;
                }
                forEach(callback) {
                  for (const key2 in this._map) {
                    callback(key2, this.get(key2));
                  }
                }
                static get empty() {
                  const emptyDict = new Dict2(null);
                  emptyDict.set = (key2, value) => {
                    (0, _util2.unreachable)("Should not call `set` on the empty dictionary.");
                  };
                  return (0, _util2.shadow)(this, "empty", emptyDict);
                }
                static merge({
                  xref,
                  dictArray,
                  mergeSubDicts = false
                }) {
                  const mergedDict = new Dict2(xref), properties2 = /* @__PURE__ */ new Map();
                  for (const dict of dictArray) {
                    if (!(dict instanceof Dict2)) {
                      continue;
                    }
                    for (const [key2, value] of Object.entries(dict._map)) {
                      let property2 = properties2.get(key2);
                      if (property2 === void 0) {
                        property2 = [];
                        properties2.set(key2, property2);
                      } else if (!mergeSubDicts || !(value instanceof Dict2)) {
                        continue;
                      }
                      property2.push(value);
                    }
                  }
                  for (const [name, values] of properties2) {
                    if (values.length === 1 || !(values[0] instanceof Dict2)) {
                      mergedDict._map[name] = values[0];
                      continue;
                    }
                    const subDict = new Dict2(xref);
                    for (const dict of values) {
                      for (const [key2, value] of Object.entries(dict._map)) {
                        if (subDict._map[key2] === void 0) {
                          subDict._map[key2] = value;
                        }
                      }
                    }
                    if (subDict.size > 0) {
                      mergedDict._map[name] = subDict;
                    }
                  }
                  properties2.clear();
                  return mergedDict.size > 0 ? mergedDict : Dict2.empty;
                }
                clone() {
                  const dict = new Dict2(this.xref);
                  for (const key2 of this.getKeys()) {
                    dict.set(key2, this.getRaw(key2));
                  }
                  return dict;
                }
              }
              exports3.Dict = Dict2;
              class Ref5 {
                constructor(num, gen) {
                  this.num = num;
                  this.gen = gen;
                }
                toString() {
                  if (this.gen === 0) {
                    return `${this.num}R`;
                  }
                  return `${this.num}R${this.gen}`;
                }
                static fromString(str) {
                  const ref3 = RefCache[str];
                  if (ref3) {
                    return ref3;
                  }
                  const m = /^(\d+)R(\d*)$/.exec(str);
                  if (!m || m[1] === "0") {
                    return null;
                  }
                  return RefCache[str] = new Ref5(parseInt(m[1]), !m[2] ? 0 : parseInt(m[2]));
                }
                static get(num, gen) {
                  const key2 = gen === 0 ? `${num}R` : `${num}R${gen}`;
                  return RefCache[key2] ||= new Ref5(num, gen);
                }
              }
              exports3.Ref = Ref5;
              class RefSet {
                constructor(parent2 = null) {
                  this._set = new Set(parent2?._set);
                }
                has(ref3) {
                  return this._set.has(ref3.toString());
                }
                put(ref3) {
                  this._set.add(ref3.toString());
                }
                remove(ref3) {
                  this._set.delete(ref3.toString());
                }
                [Symbol.iterator]() {
                  return this._set.values();
                }
                clear() {
                  this._set.clear();
                }
              }
              exports3.RefSet = RefSet;
              class RefSetCache {
                constructor() {
                  this._map = /* @__PURE__ */ new Map();
                }
                get size() {
                  return this._map.size;
                }
                get(ref3) {
                  return this._map.get(ref3.toString());
                }
                has(ref3) {
                  return this._map.has(ref3.toString());
                }
                put(ref3, obj) {
                  this._map.set(ref3.toString(), obj);
                }
                putAlias(ref3, aliasRef) {
                  this._map.set(ref3.toString(), this.get(aliasRef));
                }
                [Symbol.iterator]() {
                  return this._map.values();
                }
                clear() {
                  this._map.clear();
                }
              }
              exports3.RefSetCache = RefSetCache;
              function isName(v, name) {
                return v instanceof Name && (name === void 0 || v.name === name);
              }
              function isCmd(v, cmd) {
                return v instanceof Cmd && (cmd === void 0 || v.cmd === cmd);
              }
              function isDict(v, type5) {
                return v instanceof Dict2 && (type5 === void 0 || isName(v.get("Type"), type5));
              }
              function isRefsEqual(v1, v2) {
                return v1.num === v2.num && v1.gen === v2.gen;
              }
            }),
            /* 5 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.BaseStream = void 0;
              var _util2 = __w_pdfjs_require__3(2);
              class BaseStream {
                constructor() {
                  if (this.constructor === BaseStream) {
                    (0, _util2.unreachable)("Cannot initialize BaseStream.");
                  }
                }
                get length() {
                  (0, _util2.unreachable)("Abstract getter `length` accessed");
                }
                get isEmpty() {
                  (0, _util2.unreachable)("Abstract getter `isEmpty` accessed");
                }
                get isDataLoaded() {
                  return (0, _util2.shadow)(this, "isDataLoaded", true);
                }
                getByte() {
                  (0, _util2.unreachable)("Abstract method `getByte` called");
                }
                getBytes(length2) {
                  (0, _util2.unreachable)("Abstract method `getBytes` called");
                }
                peekByte() {
                  const peekedByte = this.getByte();
                  if (peekedByte !== -1) {
                    this.pos--;
                  }
                  return peekedByte;
                }
                peekBytes(length2) {
                  const bytes = this.getBytes(length2);
                  this.pos -= bytes.length;
                  return bytes;
                }
                getUint16() {
                  const b0 = this.getByte();
                  const b1 = this.getByte();
                  if (b0 === -1 || b1 === -1) {
                    return -1;
                  }
                  return (b0 << 8) + b1;
                }
                getInt32() {
                  const b0 = this.getByte();
                  const b1 = this.getByte();
                  const b2 = this.getByte();
                  const b3 = this.getByte();
                  return (b0 << 24) + (b1 << 16) + (b2 << 8) + b3;
                }
                getByteRange(begin, end) {
                  (0, _util2.unreachable)("Abstract method `getByteRange` called");
                }
                getString(length2) {
                  return (0, _util2.bytesToString)(this.getBytes(length2));
                }
                skip(n2) {
                  this.pos += n2 || 1;
                }
                reset() {
                  (0, _util2.unreachable)("Abstract method `reset` called");
                }
                moveStart() {
                  (0, _util2.unreachable)("Abstract method `moveStart` called");
                }
                makeSubStream(start, length2, dict = null) {
                  (0, _util2.unreachable)("Abstract method `makeSubStream` called");
                }
                getBaseStreams() {
                  return null;
                }
              }
              exports3.BaseStream = BaseStream;
            }),
            /* 6 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.NetworkPdfManager = exports3.LocalPdfManager = void 0;
              var _util2 = __w_pdfjs_require__3(2);
              var _chunked_stream = __w_pdfjs_require__3(7);
              var _core_utils = __w_pdfjs_require__3(3);
              var _document = __w_pdfjs_require__3(9);
              var _stream = __w_pdfjs_require__3(8);
              function parseDocBaseUrl(url2) {
                if (url2) {
                  const absoluteUrl = (0, _util2.createValidAbsoluteUrl)(url2);
                  if (absoluteUrl) {
                    return absoluteUrl.href;
                  }
                  (0, _util2.warn)(`Invalid absolute docBaseUrl: "${url2}".`);
                }
                return null;
              }
              class BasePdfManager {
                constructor(args) {
                  if (this.constructor === BasePdfManager) {
                    (0, _util2.unreachable)("Cannot initialize BasePdfManager.");
                  }
                  this._docBaseUrl = parseDocBaseUrl(args.docBaseUrl);
                  this._docId = args.docId;
                  this._password = args.password;
                  this.enableXfa = args.enableXfa;
                  args.evaluatorOptions.isOffscreenCanvasSupported &&= _util2.FeatureTest.isOffscreenCanvasSupported;
                  this.evaluatorOptions = args.evaluatorOptions;
                }
                get docId() {
                  return this._docId;
                }
                get password() {
                  return this._password;
                }
                get docBaseUrl() {
                  return this._docBaseUrl;
                }
                get catalog() {
                  return this.pdfDocument.catalog;
                }
                ensureDoc(prop, args) {
                  return this.ensure(this.pdfDocument, prop, args);
                }
                ensureXRef(prop, args) {
                  return this.ensure(this.pdfDocument.xref, prop, args);
                }
                ensureCatalog(prop, args) {
                  return this.ensure(this.pdfDocument.catalog, prop, args);
                }
                getPage(pageIndex) {
                  return this.pdfDocument.getPage(pageIndex);
                }
                fontFallback(id, handler) {
                  return this.pdfDocument.fontFallback(id, handler);
                }
                loadXfaFonts(handler, task) {
                  return this.pdfDocument.loadXfaFonts(handler, task);
                }
                loadXfaImages() {
                  return this.pdfDocument.loadXfaImages();
                }
                serializeXfaData(annotationStorage) {
                  return this.pdfDocument.serializeXfaData(annotationStorage);
                }
                cleanup(manuallyTriggered = false) {
                  return this.pdfDocument.cleanup(manuallyTriggered);
                }
                async ensure(obj, prop, args) {
                  (0, _util2.unreachable)("Abstract method `ensure` called");
                }
                requestRange(begin, end) {
                  (0, _util2.unreachable)("Abstract method `requestRange` called");
                }
                requestLoadedStream(noFetch = false) {
                  (0, _util2.unreachable)("Abstract method `requestLoadedStream` called");
                }
                sendProgressiveData(chunk) {
                  (0, _util2.unreachable)("Abstract method `sendProgressiveData` called");
                }
                updatePassword(password) {
                  this._password = password;
                }
                terminate(reason) {
                  (0, _util2.unreachable)("Abstract method `terminate` called");
                }
              }
              class LocalPdfManager extends BasePdfManager {
                constructor(args) {
                  super(args);
                  const stream = new _stream.Stream(args.source);
                  this.pdfDocument = new _document.PDFDocument(this, stream);
                  this._loadedStreamPromise = Promise.resolve(stream);
                }
                async ensure(obj, prop, args) {
                  const value = obj[prop];
                  if (typeof value === "function") {
                    return value.apply(obj, args);
                  }
                  return value;
                }
                requestRange(begin, end) {
                  return Promise.resolve();
                }
                requestLoadedStream(noFetch = false) {
                  return this._loadedStreamPromise;
                }
                terminate(reason) {
                }
              }
              exports3.LocalPdfManager = LocalPdfManager;
              class NetworkPdfManager extends BasePdfManager {
                constructor(args) {
                  super(args);
                  this.streamManager = new _chunked_stream.ChunkedStreamManager(args.source, {
                    msgHandler: args.handler,
                    length: args.length,
                    disableAutoFetch: args.disableAutoFetch,
                    rangeChunkSize: args.rangeChunkSize
                  });
                  this.pdfDocument = new _document.PDFDocument(this, this.streamManager.getStream());
                }
                async ensure(obj, prop, args) {
                  try {
                    const value = obj[prop];
                    if (typeof value === "function") {
                      return value.apply(obj, args);
                    }
                    return value;
                  } catch (ex) {
                    if (!(ex instanceof _core_utils.MissingDataException)) {
                      throw ex;
                    }
                    await this.requestRange(ex.begin, ex.end);
                    return this.ensure(obj, prop, args);
                  }
                }
                requestRange(begin, end) {
                  return this.streamManager.requestRange(begin, end);
                }
                requestLoadedStream(noFetch = false) {
                  return this.streamManager.requestAllChunks(noFetch);
                }
                sendProgressiveData(chunk) {
                  this.streamManager.onReceiveData({
                    chunk
                  });
                }
                terminate(reason) {
                  this.streamManager.abort(reason);
                }
              }
              exports3.NetworkPdfManager = NetworkPdfManager;
            }),
            /* 7 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.ChunkedStreamManager = exports3.ChunkedStream = void 0;
              var _core_utils = __w_pdfjs_require__3(3);
              var _util2 = __w_pdfjs_require__3(2);
              var _stream = __w_pdfjs_require__3(8);
              class ChunkedStream extends _stream.Stream {
                constructor(length2, chunkSize, manager) {
                  super(new Uint8Array(length2), 0, length2, null);
                  this.chunkSize = chunkSize;
                  this._loadedChunks = /* @__PURE__ */ new Set();
                  this.numChunks = Math.ceil(length2 / chunkSize);
                  this.manager = manager;
                  this.progressiveDataLength = 0;
                  this.lastSuccessfulEnsureByteChunk = -1;
                }
                getMissingChunks() {
                  const chunks = [];
                  for (let chunk = 0, n2 = this.numChunks; chunk < n2; ++chunk) {
                    if (!this._loadedChunks.has(chunk)) {
                      chunks.push(chunk);
                    }
                  }
                  return chunks;
                }
                get numChunksLoaded() {
                  return this._loadedChunks.size;
                }
                get isDataLoaded() {
                  return this.numChunksLoaded === this.numChunks;
                }
                onReceiveData(begin, chunk) {
                  const chunkSize = this.chunkSize;
                  if (begin % chunkSize !== 0) {
                    throw new Error(`Bad begin offset: ${begin}`);
                  }
                  const end = begin + chunk.byteLength;
                  if (end % chunkSize !== 0 && end !== this.bytes.length) {
                    throw new Error(`Bad end offset: ${end}`);
                  }
                  this.bytes.set(new Uint8Array(chunk), begin);
                  const beginChunk = Math.floor(begin / chunkSize);
                  const endChunk = Math.floor((end - 1) / chunkSize) + 1;
                  for (let curChunk = beginChunk; curChunk < endChunk; ++curChunk) {
                    this._loadedChunks.add(curChunk);
                  }
                }
                onReceiveProgressiveData(data2) {
                  let position3 = this.progressiveDataLength;
                  const beginChunk = Math.floor(position3 / this.chunkSize);
                  this.bytes.set(new Uint8Array(data2), position3);
                  position3 += data2.byteLength;
                  this.progressiveDataLength = position3;
                  const endChunk = position3 >= this.end ? this.numChunks : Math.floor(position3 / this.chunkSize);
                  for (let curChunk = beginChunk; curChunk < endChunk; ++curChunk) {
                    this._loadedChunks.add(curChunk);
                  }
                }
                ensureByte(pos) {
                  if (pos < this.progressiveDataLength) {
                    return;
                  }
                  const chunk = Math.floor(pos / this.chunkSize);
                  if (chunk > this.numChunks) {
                    return;
                  }
                  if (chunk === this.lastSuccessfulEnsureByteChunk) {
                    return;
                  }
                  if (!this._loadedChunks.has(chunk)) {
                    throw new _core_utils.MissingDataException(pos, pos + 1);
                  }
                  this.lastSuccessfulEnsureByteChunk = chunk;
                }
                ensureRange(begin, end) {
                  if (begin >= end) {
                    return;
                  }
                  if (end <= this.progressiveDataLength) {
                    return;
                  }
                  const beginChunk = Math.floor(begin / this.chunkSize);
                  if (beginChunk > this.numChunks) {
                    return;
                  }
                  const endChunk = Math.min(Math.floor((end - 1) / this.chunkSize) + 1, this.numChunks);
                  for (let chunk = beginChunk; chunk < endChunk; ++chunk) {
                    if (!this._loadedChunks.has(chunk)) {
                      throw new _core_utils.MissingDataException(begin, end);
                    }
                  }
                }
                nextEmptyChunk(beginChunk) {
                  const numChunks = this.numChunks;
                  for (let i = 0; i < numChunks; ++i) {
                    const chunk = (beginChunk + i) % numChunks;
                    if (!this._loadedChunks.has(chunk)) {
                      return chunk;
                    }
                  }
                  return null;
                }
                hasChunk(chunk) {
                  return this._loadedChunks.has(chunk);
                }
                getByte() {
                  const pos = this.pos;
                  if (pos >= this.end) {
                    return -1;
                  }
                  if (pos >= this.progressiveDataLength) {
                    this.ensureByte(pos);
                  }
                  return this.bytes[this.pos++];
                }
                getBytes(length2) {
                  const bytes = this.bytes;
                  const pos = this.pos;
                  const strEnd = this.end;
                  if (!length2) {
                    if (strEnd > this.progressiveDataLength) {
                      this.ensureRange(pos, strEnd);
                    }
                    return bytes.subarray(pos, strEnd);
                  }
                  let end = pos + length2;
                  if (end > strEnd) {
                    end = strEnd;
                  }
                  if (end > this.progressiveDataLength) {
                    this.ensureRange(pos, end);
                  }
                  this.pos = end;
                  return bytes.subarray(pos, end);
                }
                getByteRange(begin, end) {
                  if (begin < 0) {
                    begin = 0;
                  }
                  if (end > this.end) {
                    end = this.end;
                  }
                  if (end > this.progressiveDataLength) {
                    this.ensureRange(begin, end);
                  }
                  return this.bytes.subarray(begin, end);
                }
                makeSubStream(start, length2, dict = null) {
                  if (length2) {
                    if (start + length2 > this.progressiveDataLength) {
                      this.ensureRange(start, start + length2);
                    }
                  } else if (start >= this.progressiveDataLength) {
                    this.ensureByte(start);
                  }
                  function ChunkedStreamSubstream() {
                  }
                  ChunkedStreamSubstream.prototype = Object.create(this);
                  ChunkedStreamSubstream.prototype.getMissingChunks = function() {
                    const chunkSize = this.chunkSize;
                    const beginChunk = Math.floor(this.start / chunkSize);
                    const endChunk = Math.floor((this.end - 1) / chunkSize) + 1;
                    const missingChunks = [];
                    for (let chunk = beginChunk; chunk < endChunk; ++chunk) {
                      if (!this._loadedChunks.has(chunk)) {
                        missingChunks.push(chunk);
                      }
                    }
                    return missingChunks;
                  };
                  Object.defineProperty(ChunkedStreamSubstream.prototype, "isDataLoaded", {
                    get() {
                      if (this.numChunksLoaded === this.numChunks) {
                        return true;
                      }
                      return this.getMissingChunks().length === 0;
                    },
                    configurable: true
                  });
                  const subStream = new ChunkedStreamSubstream();
                  subStream.pos = subStream.start = start;
                  subStream.end = start + length2 || this.end;
                  subStream.dict = dict;
                  return subStream;
                }
                getBaseStreams() {
                  return [this];
                }
              }
              exports3.ChunkedStream = ChunkedStream;
              class ChunkedStreamManager {
                constructor(pdfNetworkStream, args) {
                  this.length = args.length;
                  this.chunkSize = args.rangeChunkSize;
                  this.stream = new ChunkedStream(this.length, this.chunkSize, this);
                  this.pdfNetworkStream = pdfNetworkStream;
                  this.disableAutoFetch = args.disableAutoFetch;
                  this.msgHandler = args.msgHandler;
                  this.currRequestId = 0;
                  this._chunksNeededByRequest = /* @__PURE__ */ new Map();
                  this._requestsByChunk = /* @__PURE__ */ new Map();
                  this._promisesByRequest = /* @__PURE__ */ new Map();
                  this.progressiveDataLength = 0;
                  this.aborted = false;
                  this._loadedStreamCapability = new _util2.PromiseCapability();
                }
                sendRequest(begin, end) {
                  const rangeReader = this.pdfNetworkStream.getRangeReader(begin, end);
                  if (!rangeReader.isStreamingSupported) {
                    rangeReader.onProgress = this.onProgress.bind(this);
                  }
                  let chunks = [], loaded = 0;
                  return new Promise((resolve, reject) => {
                    const readChunk = ({
                      value,
                      done
                    }) => {
                      try {
                        if (done) {
                          const chunkData = (0, _core_utils.arrayBuffersToBytes)(chunks);
                          chunks = null;
                          resolve(chunkData);
                          return;
                        }
                        loaded += value.byteLength;
                        if (rangeReader.isStreamingSupported) {
                          this.onProgress({
                            loaded
                          });
                        }
                        chunks.push(value);
                        rangeReader.read().then(readChunk, reject);
                      } catch (e3) {
                        reject(e3);
                      }
                    };
                    rangeReader.read().then(readChunk, reject);
                  }).then((data2) => {
                    if (this.aborted) {
                      return;
                    }
                    this.onReceiveData({
                      chunk: data2,
                      begin
                    });
                  });
                }
                requestAllChunks(noFetch = false) {
                  if (!noFetch) {
                    const missingChunks = this.stream.getMissingChunks();
                    this._requestChunks(missingChunks);
                  }
                  return this._loadedStreamCapability.promise;
                }
                _requestChunks(chunks) {
                  const requestId = this.currRequestId++;
                  const chunksNeeded = /* @__PURE__ */ new Set();
                  this._chunksNeededByRequest.set(requestId, chunksNeeded);
                  for (const chunk of chunks) {
                    if (!this.stream.hasChunk(chunk)) {
                      chunksNeeded.add(chunk);
                    }
                  }
                  if (chunksNeeded.size === 0) {
                    return Promise.resolve();
                  }
                  const capability = new _util2.PromiseCapability();
                  this._promisesByRequest.set(requestId, capability);
                  const chunksToRequest = [];
                  for (const chunk of chunksNeeded) {
                    let requestIds = this._requestsByChunk.get(chunk);
                    if (!requestIds) {
                      requestIds = [];
                      this._requestsByChunk.set(chunk, requestIds);
                      chunksToRequest.push(chunk);
                    }
                    requestIds.push(requestId);
                  }
                  if (chunksToRequest.length > 0) {
                    const groupedChunksToRequest = this.groupChunks(chunksToRequest);
                    for (const groupedChunk of groupedChunksToRequest) {
                      const begin = groupedChunk.beginChunk * this.chunkSize;
                      const end = Math.min(groupedChunk.endChunk * this.chunkSize, this.length);
                      this.sendRequest(begin, end).catch(capability.reject);
                    }
                  }
                  return capability.promise.catch((reason) => {
                    if (this.aborted) {
                      return;
                    }
                    throw reason;
                  });
                }
                getStream() {
                  return this.stream;
                }
                requestRange(begin, end) {
                  end = Math.min(end, this.length);
                  const beginChunk = this.getBeginChunk(begin);
                  const endChunk = this.getEndChunk(end);
                  const chunks = [];
                  for (let chunk = beginChunk; chunk < endChunk; ++chunk) {
                    chunks.push(chunk);
                  }
                  return this._requestChunks(chunks);
                }
                requestRanges(ranges = []) {
                  const chunksToRequest = [];
                  for (const range3 of ranges) {
                    const beginChunk = this.getBeginChunk(range3.begin);
                    const endChunk = this.getEndChunk(range3.end);
                    for (let chunk = beginChunk; chunk < endChunk; ++chunk) {
                      if (!chunksToRequest.includes(chunk)) {
                        chunksToRequest.push(chunk);
                      }
                    }
                  }
                  chunksToRequest.sort(function(a, b) {
                    return a - b;
                  });
                  return this._requestChunks(chunksToRequest);
                }
                groupChunks(chunks) {
                  const groupedChunks = [];
                  let beginChunk = -1;
                  let prevChunk = -1;
                  for (let i = 0, ii = chunks.length; i < ii; ++i) {
                    const chunk = chunks[i];
                    if (beginChunk < 0) {
                      beginChunk = chunk;
                    }
                    if (prevChunk >= 0 && prevChunk + 1 !== chunk) {
                      groupedChunks.push({
                        beginChunk,
                        endChunk: prevChunk + 1
                      });
                      beginChunk = chunk;
                    }
                    if (i + 1 === chunks.length) {
                      groupedChunks.push({
                        beginChunk,
                        endChunk: chunk + 1
                      });
                    }
                    prevChunk = chunk;
                  }
                  return groupedChunks;
                }
                onProgress(args) {
                  this.msgHandler.send("DocProgress", {
                    loaded: this.stream.numChunksLoaded * this.chunkSize + args.loaded,
                    total: this.length
                  });
                }
                onReceiveData(args) {
                  const chunk = args.chunk;
                  const isProgressive = args.begin === void 0;
                  const begin = isProgressive ? this.progressiveDataLength : args.begin;
                  const end = begin + chunk.byteLength;
                  const beginChunk = Math.floor(begin / this.chunkSize);
                  const endChunk = end < this.length ? Math.floor(end / this.chunkSize) : Math.ceil(end / this.chunkSize);
                  if (isProgressive) {
                    this.stream.onReceiveProgressiveData(chunk);
                    this.progressiveDataLength = end;
                  } else {
                    this.stream.onReceiveData(begin, chunk);
                  }
                  if (this.stream.isDataLoaded) {
                    this._loadedStreamCapability.resolve(this.stream);
                  }
                  const loadedRequests = [];
                  for (let curChunk = beginChunk; curChunk < endChunk; ++curChunk) {
                    const requestIds = this._requestsByChunk.get(curChunk);
                    if (!requestIds) {
                      continue;
                    }
                    this._requestsByChunk.delete(curChunk);
                    for (const requestId of requestIds) {
                      const chunksNeeded = this._chunksNeededByRequest.get(requestId);
                      if (chunksNeeded.has(curChunk)) {
                        chunksNeeded.delete(curChunk);
                      }
                      if (chunksNeeded.size > 0) {
                        continue;
                      }
                      loadedRequests.push(requestId);
                    }
                  }
                  if (!this.disableAutoFetch && this._requestsByChunk.size === 0) {
                    let nextEmptyChunk;
                    if (this.stream.numChunksLoaded === 1) {
                      const lastChunk = this.stream.numChunks - 1;
                      if (!this.stream.hasChunk(lastChunk)) {
                        nextEmptyChunk = lastChunk;
                      }
                    } else {
                      nextEmptyChunk = this.stream.nextEmptyChunk(endChunk);
                    }
                    if (Number.isInteger(nextEmptyChunk)) {
                      this._requestChunks([nextEmptyChunk]);
                    }
                  }
                  for (const requestId of loadedRequests) {
                    const capability = this._promisesByRequest.get(requestId);
                    this._promisesByRequest.delete(requestId);
                    capability.resolve();
                  }
                  this.msgHandler.send("DocProgress", {
                    loaded: this.stream.numChunksLoaded * this.chunkSize,
                    total: this.length
                  });
                }
                onError(err) {
                  this._loadedStreamCapability.reject(err);
                }
                getBeginChunk(begin) {
                  return Math.floor(begin / this.chunkSize);
                }
                getEndChunk(end) {
                  return Math.floor((end - 1) / this.chunkSize) + 1;
                }
                abort(reason) {
                  this.aborted = true;
                  this.pdfNetworkStream?.cancelAllRequests(reason);
                  for (const capability of this._promisesByRequest.values()) {
                    capability.reject(reason);
                  }
                }
              }
              exports3.ChunkedStreamManager = ChunkedStreamManager;
            }),
            /* 8 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.StringStream = exports3.Stream = exports3.NullStream = void 0;
              var _base_stream = __w_pdfjs_require__3(5);
              var _util2 = __w_pdfjs_require__3(2);
              class Stream extends _base_stream.BaseStream {
                constructor(arrayBuffer, start, length2, dict) {
                  super();
                  this.bytes = arrayBuffer instanceof Uint8Array ? arrayBuffer : new Uint8Array(arrayBuffer);
                  this.start = start || 0;
                  this.pos = this.start;
                  this.end = start + length2 || this.bytes.length;
                  this.dict = dict;
                }
                get length() {
                  return this.end - this.start;
                }
                get isEmpty() {
                  return this.length === 0;
                }
                getByte() {
                  if (this.pos >= this.end) {
                    return -1;
                  }
                  return this.bytes[this.pos++];
                }
                getBytes(length2) {
                  const bytes = this.bytes;
                  const pos = this.pos;
                  const strEnd = this.end;
                  if (!length2) {
                    return bytes.subarray(pos, strEnd);
                  }
                  let end = pos + length2;
                  if (end > strEnd) {
                    end = strEnd;
                  }
                  this.pos = end;
                  return bytes.subarray(pos, end);
                }
                getByteRange(begin, end) {
                  if (begin < 0) {
                    begin = 0;
                  }
                  if (end > this.end) {
                    end = this.end;
                  }
                  return this.bytes.subarray(begin, end);
                }
                reset() {
                  this.pos = this.start;
                }
                moveStart() {
                  this.start = this.pos;
                }
                makeSubStream(start, length2, dict = null) {
                  return new Stream(this.bytes.buffer, start, length2, dict);
                }
              }
              exports3.Stream = Stream;
              class StringStream extends Stream {
                constructor(str) {
                  super((0, _util2.stringToBytes)(str));
                }
              }
              exports3.StringStream = StringStream;
              class NullStream extends Stream {
                constructor() {
                  super(new Uint8Array(0));
                }
              }
              exports3.NullStream = NullStream;
            }),
            /* 9 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.Page = exports3.PDFDocument = void 0;
              var _util2 = __w_pdfjs_require__3(2);
              var _annotation = __w_pdfjs_require__3(10);
              var _core_utils = __w_pdfjs_require__3(3);
              var _primitives = __w_pdfjs_require__3(4);
              var _xfa_fonts = __w_pdfjs_require__3(51);
              var _base_stream = __w_pdfjs_require__3(5);
              var _crypto = __w_pdfjs_require__3(74);
              var _catalog = __w_pdfjs_require__3(66);
              var _cleanup_helper = __w_pdfjs_require__3(68);
              var _dataset_reader = __w_pdfjs_require__3(102);
              var _parser = __w_pdfjs_require__3(16);
              var _stream = __w_pdfjs_require__3(8);
              var _object_loader = __w_pdfjs_require__3(76);
              var _operator_list = __w_pdfjs_require__3(64);
              var _evaluator = __w_pdfjs_require__3(13);
              var _decode_stream = __w_pdfjs_require__3(18);
              var _struct_tree = __w_pdfjs_require__3(72);
              var _writer = __w_pdfjs_require__3(73);
              var _factory = __w_pdfjs_require__3(77);
              var _xref = __w_pdfjs_require__3(103);
              const DEFAULT_USER_UNIT = 1;
              const LETTER_SIZE_MEDIABOX = [0, 0, 612, 792];
              class Page {
                constructor({
                  pdfManager,
                  xref,
                  pageIndex,
                  pageDict,
                  ref: ref3,
                  globalIdFactory,
                  fontCache,
                  builtInCMapCache,
                  standardFontDataCache,
                  globalImageCache,
                  systemFontCache,
                  nonBlendModesSet,
                  xfaFactory
                }) {
                  this.pdfManager = pdfManager;
                  this.pageIndex = pageIndex;
                  this.pageDict = pageDict;
                  this.xref = xref;
                  this.ref = ref3;
                  this.fontCache = fontCache;
                  this.builtInCMapCache = builtInCMapCache;
                  this.standardFontDataCache = standardFontDataCache;
                  this.globalImageCache = globalImageCache;
                  this.systemFontCache = systemFontCache;
                  this.nonBlendModesSet = nonBlendModesSet;
                  this.evaluatorOptions = pdfManager.evaluatorOptions;
                  this.resourcesPromise = null;
                  this.xfaFactory = xfaFactory;
                  const idCounters = {
                    obj: 0
                  };
                  this._localIdFactory = class extends globalIdFactory {
                    static createObjId() {
                      return `p${pageIndex}_${++idCounters.obj}`;
                    }
                    static getPageObjId() {
                      return `p${ref3.toString()}`;
                    }
                  };
                }
                _getInheritableProperty(key2, getArray3 = false) {
                  const value = (0, _core_utils.getInheritableProperty)({
                    dict: this.pageDict,
                    key: key2,
                    getArray: getArray3,
                    stopWhenFound: false
                  });
                  if (!Array.isArray(value)) {
                    return value;
                  }
                  if (value.length === 1 || !(value[0] instanceof _primitives.Dict)) {
                    return value[0];
                  }
                  return _primitives.Dict.merge({
                    xref: this.xref,
                    dictArray: value
                  });
                }
                get content() {
                  return this.pageDict.getArray("Contents");
                }
                get resources() {
                  const resources = this._getInheritableProperty("Resources");
                  return (0, _util2.shadow)(this, "resources", resources instanceof _primitives.Dict ? resources : _primitives.Dict.empty);
                }
                _getBoundingBox(name) {
                  if (this.xfaData) {
                    return this.xfaData.bbox;
                  }
                  let box2 = this._getInheritableProperty(name, true);
                  if (Array.isArray(box2) && box2.length === 4) {
                    box2 = _util2.Util.normalizeRect(box2);
                    if (box2[2] - box2[0] > 0 && box2[3] - box2[1] > 0) {
                      return box2;
                    }
                    (0, _util2.warn)(`Empty, or invalid, /${name} entry.`);
                  }
                  return null;
                }
                get mediaBox() {
                  return (0, _util2.shadow)(this, "mediaBox", this._getBoundingBox("MediaBox") || LETTER_SIZE_MEDIABOX);
                }
                get cropBox() {
                  return (0, _util2.shadow)(this, "cropBox", this._getBoundingBox("CropBox") || this.mediaBox);
                }
                get userUnit() {
                  let obj = this.pageDict.get("UserUnit");
                  if (typeof obj !== "number" || obj <= 0) {
                    obj = DEFAULT_USER_UNIT;
                  }
                  return (0, _util2.shadow)(this, "userUnit", obj);
                }
                get view() {
                  const {
                    cropBox,
                    mediaBox
                  } = this;
                  if (cropBox !== mediaBox && !(0, _util2.isArrayEqual)(cropBox, mediaBox)) {
                    const box2 = _util2.Util.intersect(cropBox, mediaBox);
                    if (box2 && box2[2] - box2[0] > 0 && box2[3] - box2[1] > 0) {
                      return (0, _util2.shadow)(this, "view", box2);
                    }
                    (0, _util2.warn)("Empty /CropBox and /MediaBox intersection.");
                  }
                  return (0, _util2.shadow)(this, "view", mediaBox);
                }
                get rotate() {
                  let rotate2 = this._getInheritableProperty("Rotate") || 0;
                  if (rotate2 % 90 !== 0) {
                    rotate2 = 0;
                  } else if (rotate2 >= 360) {
                    rotate2 %= 360;
                  } else if (rotate2 < 0) {
                    rotate2 = (rotate2 % 360 + 360) % 360;
                  }
                  return (0, _util2.shadow)(this, "rotate", rotate2);
                }
                _onSubStreamError(reason, objId) {
                  if (this.evaluatorOptions.ignoreErrors) {
                    (0, _util2.warn)(`getContentStream - ignoring sub-stream (${objId}): "${reason}".`);
                    return;
                  }
                  throw reason;
                }
                getContentStream() {
                  return this.pdfManager.ensure(this, "content").then((content) => {
                    if (content instanceof _base_stream.BaseStream) {
                      return content;
                    }
                    if (Array.isArray(content)) {
                      return new _decode_stream.StreamsSequenceStream(content, this._onSubStreamError.bind(this));
                    }
                    return new _stream.NullStream();
                  });
                }
                get xfaData() {
                  return (0, _util2.shadow)(this, "xfaData", this.xfaFactory ? {
                    bbox: this.xfaFactory.getBoundingBox(this.pageIndex)
                  } : null);
                }
                #replaceIdByRef(annotations, deletedAnnotations, existingAnnotations) {
                  for (const annotation of annotations) {
                    if (annotation.id) {
                      const ref3 = _primitives.Ref.fromString(annotation.id);
                      if (!ref3) {
                        (0, _util2.warn)(`A non-linked annotation cannot be modified: ${annotation.id}`);
                        continue;
                      }
                      if (annotation.deleted) {
                        deletedAnnotations.put(ref3);
                        continue;
                      }
                      existingAnnotations?.put(ref3);
                      annotation.ref = ref3;
                      delete annotation.id;
                    }
                  }
                }
                async saveNewAnnotations(handler, task, annotations, imagePromises) {
                  if (this.xfaFactory) {
                    throw new Error("XFA: Cannot save new annotations.");
                  }
                  const partialEvaluator = new _evaluator.PartialEvaluator({
                    xref: this.xref,
                    handler,
                    pageIndex: this.pageIndex,
                    idFactory: this._localIdFactory,
                    fontCache: this.fontCache,
                    builtInCMapCache: this.builtInCMapCache,
                    standardFontDataCache: this.standardFontDataCache,
                    globalImageCache: this.globalImageCache,
                    systemFontCache: this.systemFontCache,
                    options: this.evaluatorOptions
                  });
                  const deletedAnnotations = new _primitives.RefSet();
                  const existingAnnotations = new _primitives.RefSet();
                  this.#replaceIdByRef(annotations, deletedAnnotations, existingAnnotations);
                  const pageDict = this.pageDict;
                  const annotationsArray = this.annotations.filter((a) => !(a instanceof _primitives.Ref && deletedAnnotations.has(a)));
                  const newData = await _annotation.AnnotationFactory.saveNewAnnotations(partialEvaluator, task, annotations, imagePromises);
                  for (const {
                    ref: ref3
                  } of newData.annotations) {
                    if (ref3 instanceof _primitives.Ref && !existingAnnotations.has(ref3)) {
                      annotationsArray.push(ref3);
                    }
                  }
                  const savedDict = pageDict.get("Annots");
                  pageDict.set("Annots", annotationsArray);
                  const buffer = [];
                  await (0, _writer.writeObject)(this.ref, pageDict, buffer, this.xref);
                  if (savedDict) {
                    pageDict.set("Annots", savedDict);
                  }
                  const objects = newData.dependencies;
                  objects.push({
                    ref: this.ref,
                    data: buffer.join("")
                  }, ...newData.annotations);
                  return objects;
                }
                save(handler, task, annotationStorage) {
                  const partialEvaluator = new _evaluator.PartialEvaluator({
                    xref: this.xref,
                    handler,
                    pageIndex: this.pageIndex,
                    idFactory: this._localIdFactory,
                    fontCache: this.fontCache,
                    builtInCMapCache: this.builtInCMapCache,
                    standardFontDataCache: this.standardFontDataCache,
                    globalImageCache: this.globalImageCache,
                    systemFontCache: this.systemFontCache,
                    options: this.evaluatorOptions
                  });
                  return this._parsedAnnotations.then(function(annotations) {
                    const newRefsPromises = [];
                    for (const annotation of annotations) {
                      if (!annotation.mustBePrinted(annotationStorage)) {
                        continue;
                      }
                      newRefsPromises.push(annotation.save(partialEvaluator, task, annotationStorage).catch(function(reason) {
                        (0, _util2.warn)(`save - ignoring annotation data during "${task.name}" task: "${reason}".`);
                        return null;
                      }));
                    }
                    return Promise.all(newRefsPromises).then(function(newRefs) {
                      return newRefs.filter((newRef) => !!newRef);
                    });
                  });
                }
                loadResources(keys4) {
                  if (!this.resourcesPromise) {
                    this.resourcesPromise = this.pdfManager.ensure(this, "resources");
                  }
                  return this.resourcesPromise.then(() => {
                    const objectLoader = new _object_loader.ObjectLoader(this.resources, keys4, this.xref);
                    return objectLoader.load();
                  });
                }
                getOperatorList({
                  handler,
                  sink,
                  task,
                  intent,
                  cacheKey,
                  annotationStorage = null
                }) {
                  const contentStreamPromise = this.getContentStream();
                  const resourcesPromise = this.loadResources(["ColorSpace", "ExtGState", "Font", "Pattern", "Properties", "Shading", "XObject"]);
                  const partialEvaluator = new _evaluator.PartialEvaluator({
                    xref: this.xref,
                    handler,
                    pageIndex: this.pageIndex,
                    idFactory: this._localIdFactory,
                    fontCache: this.fontCache,
                    builtInCMapCache: this.builtInCMapCache,
                    standardFontDataCache: this.standardFontDataCache,
                    globalImageCache: this.globalImageCache,
                    systemFontCache: this.systemFontCache,
                    options: this.evaluatorOptions
                  });
                  const newAnnotationsByPage = !this.xfaFactory ? (0, _core_utils.getNewAnnotationsMap)(annotationStorage) : null;
                  let deletedAnnotations = null;
                  let newAnnotationsPromise = Promise.resolve(null);
                  if (newAnnotationsByPage) {
                    const newAnnotations = newAnnotationsByPage.get(this.pageIndex);
                    if (newAnnotations) {
                      const annotationGlobalsPromise = this.pdfManager.ensureDoc("annotationGlobals");
                      let imagePromises;
                      const missingBitmaps = /* @__PURE__ */ new Set();
                      for (const {
                        bitmapId,
                        bitmap
                      } of newAnnotations) {
                        if (bitmapId && !bitmap && !missingBitmaps.has(bitmapId)) {
                          missingBitmaps.add(bitmapId);
                        }
                      }
                      const {
                        isOffscreenCanvasSupported
                      } = this.evaluatorOptions;
                      if (missingBitmaps.size > 0) {
                        const annotationWithBitmaps = newAnnotations.slice();
                        for (const [key2, annotation] of annotationStorage) {
                          if (!key2.startsWith(_util2.AnnotationEditorPrefix)) {
                            continue;
                          }
                          if (annotation.bitmap && missingBitmaps.has(annotation.bitmapId)) {
                            annotationWithBitmaps.push(annotation);
                          }
                        }
                        imagePromises = _annotation.AnnotationFactory.generateImages(annotationWithBitmaps, this.xref, isOffscreenCanvasSupported);
                      } else {
                        imagePromises = _annotation.AnnotationFactory.generateImages(newAnnotations, this.xref, isOffscreenCanvasSupported);
                      }
                      deletedAnnotations = new _primitives.RefSet();
                      this.#replaceIdByRef(newAnnotations, deletedAnnotations, null);
                      newAnnotationsPromise = annotationGlobalsPromise.then((annotationGlobals) => {
                        if (!annotationGlobals) {
                          return null;
                        }
                        return _annotation.AnnotationFactory.printNewAnnotations(annotationGlobals, partialEvaluator, task, newAnnotations, imagePromises);
                      });
                    }
                  }
                  const dataPromises = Promise.all([contentStreamPromise, resourcesPromise]);
                  const pageListPromise = dataPromises.then(([contentStream]) => {
                    const opList = new _operator_list.OperatorList(intent, sink);
                    handler.send("StartRenderPage", {
                      transparency: partialEvaluator.hasBlendModes(this.resources, this.nonBlendModesSet),
                      pageIndex: this.pageIndex,
                      cacheKey
                    });
                    return partialEvaluator.getOperatorList({
                      stream: contentStream,
                      task,
                      resources: this.resources,
                      operatorList: opList
                    }).then(function() {
                      return opList;
                    });
                  });
                  return Promise.all([pageListPromise, this._parsedAnnotations, newAnnotationsPromise]).then(function([pageOpList, annotations, newAnnotations]) {
                    if (newAnnotations) {
                      annotations = annotations.filter((a) => !(a.ref && deletedAnnotations.has(a.ref)));
                      for (let i = 0, ii = newAnnotations.length; i < ii; i++) {
                        const newAnnotation = newAnnotations[i];
                        if (newAnnotation.refToReplace) {
                          const j = annotations.findIndex((a) => a.ref && (0, _primitives.isRefsEqual)(a.ref, newAnnotation.refToReplace));
                          if (j >= 0) {
                            annotations.splice(j, 1, newAnnotation);
                            newAnnotations.splice(i--, 1);
                            ii--;
                          }
                        }
                      }
                      annotations = annotations.concat(newAnnotations);
                    }
                    if (annotations.length === 0 || intent & _util2.RenderingIntentFlag.ANNOTATIONS_DISABLE) {
                      pageOpList.flush(true);
                      return {
                        length: pageOpList.totalLength
                      };
                    }
                    const renderForms = !!(intent & _util2.RenderingIntentFlag.ANNOTATIONS_FORMS), intentAny = !!(intent & _util2.RenderingIntentFlag.ANY), intentDisplay = !!(intent & _util2.RenderingIntentFlag.DISPLAY), intentPrint = !!(intent & _util2.RenderingIntentFlag.PRINT);
                    const opListPromises = [];
                    for (const annotation of annotations) {
                      if (intentAny || intentDisplay && annotation.mustBeViewed(annotationStorage, renderForms) || intentPrint && annotation.mustBePrinted(annotationStorage)) {
                        opListPromises.push(annotation.getOperatorList(partialEvaluator, task, intent, renderForms, annotationStorage).catch(function(reason) {
                          (0, _util2.warn)(`getOperatorList - ignoring annotation data during "${task.name}" task: "${reason}".`);
                          return {
                            opList: null,
                            separateForm: false,
                            separateCanvas: false
                          };
                        }));
                      }
                    }
                    return Promise.all(opListPromises).then(function(opLists) {
                      let form = false, canvas = false;
                      for (const {
                        opList,
                        separateForm,
                        separateCanvas
                      } of opLists) {
                        pageOpList.addOpList(opList);
                        form ||= separateForm;
                        canvas ||= separateCanvas;
                      }
                      pageOpList.flush(true, {
                        form,
                        canvas
                      });
                      return {
                        length: pageOpList.totalLength
                      };
                    });
                  });
                }
                extractTextContent({
                  handler,
                  task,
                  includeMarkedContent,
                  disableNormalization,
                  sink
                }) {
                  const contentStreamPromise = this.getContentStream();
                  const resourcesPromise = this.loadResources(["ExtGState", "Font", "Properties", "XObject"]);
                  const dataPromises = Promise.all([contentStreamPromise, resourcesPromise]);
                  return dataPromises.then(([contentStream]) => {
                    const partialEvaluator = new _evaluator.PartialEvaluator({
                      xref: this.xref,
                      handler,
                      pageIndex: this.pageIndex,
                      idFactory: this._localIdFactory,
                      fontCache: this.fontCache,
                      builtInCMapCache: this.builtInCMapCache,
                      standardFontDataCache: this.standardFontDataCache,
                      globalImageCache: this.globalImageCache,
                      systemFontCache: this.systemFontCache,
                      options: this.evaluatorOptions
                    });
                    return partialEvaluator.getTextContent({
                      stream: contentStream,
                      task,
                      resources: this.resources,
                      includeMarkedContent,
                      disableNormalization,
                      sink,
                      viewBox: this.view
                    });
                  });
                }
                async getStructTree() {
                  const structTreeRoot = await this.pdfManager.ensureCatalog("structTreeRoot");
                  if (!structTreeRoot) {
                    return null;
                  }
                  await this._parsedAnnotations;
                  const structTree = await this.pdfManager.ensure(this, "_parseStructTree", [structTreeRoot]);
                  return structTree.serializable;
                }
                _parseStructTree(structTreeRoot) {
                  const tree = new _struct_tree.StructTreePage(structTreeRoot, this.pageDict);
                  tree.parse(this.ref);
                  return tree;
                }
                async getAnnotationsData(handler, task, intent) {
                  const annotations = await this._parsedAnnotations;
                  if (annotations.length === 0) {
                    return annotations;
                  }
                  const annotationsData = [], textContentPromises = [];
                  let partialEvaluator;
                  const intentAny = !!(intent & _util2.RenderingIntentFlag.ANY), intentDisplay = !!(intent & _util2.RenderingIntentFlag.DISPLAY), intentPrint = !!(intent & _util2.RenderingIntentFlag.PRINT);
                  for (const annotation of annotations) {
                    const isVisible = intentAny || intentDisplay && annotation.viewable;
                    if (isVisible || intentPrint && annotation.printable) {
                      annotationsData.push(annotation.data);
                    }
                    if (annotation.hasTextContent && isVisible) {
                      partialEvaluator ||= new _evaluator.PartialEvaluator({
                        xref: this.xref,
                        handler,
                        pageIndex: this.pageIndex,
                        idFactory: this._localIdFactory,
                        fontCache: this.fontCache,
                        builtInCMapCache: this.builtInCMapCache,
                        standardFontDataCache: this.standardFontDataCache,
                        globalImageCache: this.globalImageCache,
                        systemFontCache: this.systemFontCache,
                        options: this.evaluatorOptions
                      });
                      textContentPromises.push(annotation.extractTextContent(partialEvaluator, task, [-Infinity, -Infinity, Infinity, Infinity]).catch(function(reason) {
                        (0, _util2.warn)(`getAnnotationsData - ignoring textContent during "${task.name}" task: "${reason}".`);
                      }));
                    }
                  }
                  await Promise.all(textContentPromises);
                  return annotationsData;
                }
                get annotations() {
                  const annots = this._getInheritableProperty("Annots");
                  return (0, _util2.shadow)(this, "annotations", Array.isArray(annots) ? annots : []);
                }
                get _parsedAnnotations() {
                  const promise = this.pdfManager.ensure(this, "annotations").then(async (annots) => {
                    if (annots.length === 0) {
                      return annots;
                    }
                    const annotationGlobals = await this.pdfManager.ensureDoc("annotationGlobals");
                    if (!annotationGlobals) {
                      return [];
                    }
                    const annotationPromises = [];
                    for (const annotationRef of annots) {
                      annotationPromises.push(_annotation.AnnotationFactory.create(this.xref, annotationRef, annotationGlobals, this._localIdFactory, false, this.ref).catch(function(reason) {
                        (0, _util2.warn)(`_parsedAnnotations: "${reason}".`);
                        return null;
                      }));
                    }
                    const sortedAnnotations = [];
                    let popupAnnotations;
                    for (const annotation of await Promise.all(annotationPromises)) {
                      if (!annotation) {
                        continue;
                      }
                      if (annotation instanceof _annotation.PopupAnnotation) {
                        (popupAnnotations ||= []).push(annotation);
                        continue;
                      }
                      sortedAnnotations.push(annotation);
                    }
                    if (popupAnnotations) {
                      sortedAnnotations.push(...popupAnnotations);
                    }
                    return sortedAnnotations;
                  });
                  return (0, _util2.shadow)(this, "_parsedAnnotations", promise);
                }
                get jsActions() {
                  const actions = (0, _core_utils.collectActions)(this.xref, this.pageDict, _util2.PageActionEventType);
                  return (0, _util2.shadow)(this, "jsActions", actions);
                }
              }
              exports3.Page = Page;
              const PDF_HEADER_SIGNATURE = new Uint8Array([37, 80, 68, 70, 45]);
              const STARTXREF_SIGNATURE = new Uint8Array([115, 116, 97, 114, 116, 120, 114, 101, 102]);
              const ENDOBJ_SIGNATURE = new Uint8Array([101, 110, 100, 111, 98, 106]);
              const FINGERPRINT_FIRST_BYTES = 1024;
              const EMPTY_FINGERPRINT = "\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0";
              function find3(stream, signature, limit = 1024, backwards = false) {
                const signatureLength = signature.length;
                const scanBytes = stream.peekBytes(limit);
                const scanLength = scanBytes.length - signatureLength;
                if (scanLength <= 0) {
                  return false;
                }
                if (backwards) {
                  const signatureEnd = signatureLength - 1;
                  let pos = scanBytes.length - 1;
                  while (pos >= signatureEnd) {
                    let j = 0;
                    while (j < signatureLength && scanBytes[pos - j] === signature[signatureEnd - j]) {
                      j++;
                    }
                    if (j >= signatureLength) {
                      stream.pos += pos - signatureEnd;
                      return true;
                    }
                    pos--;
                  }
                } else {
                  let pos = 0;
                  while (pos <= scanLength) {
                    let j = 0;
                    while (j < signatureLength && scanBytes[pos + j] === signature[j]) {
                      j++;
                    }
                    if (j >= signatureLength) {
                      stream.pos += pos;
                      return true;
                    }
                    pos++;
                  }
                }
                return false;
              }
              class PDFDocument {
                constructor(pdfManager, stream) {
                  if (stream.length <= 0) {
                    throw new _util2.InvalidPDFException("The PDF file is empty, i.e. its size is zero bytes.");
                  }
                  this.pdfManager = pdfManager;
                  this.stream = stream;
                  this.xref = new _xref.XRef(stream, pdfManager);
                  this._pagePromises = /* @__PURE__ */ new Map();
                  this._version = null;
                  const idCounters = {
                    font: 0
                  };
                  this._globalIdFactory = class {
                    static getDocId() {
                      return `g_${pdfManager.docId}`;
                    }
                    static createFontId() {
                      return `f${++idCounters.font}`;
                    }
                    static createObjId() {
                      (0, _util2.unreachable)("Abstract method `createObjId` called.");
                    }
                    static getPageObjId() {
                      (0, _util2.unreachable)("Abstract method `getPageObjId` called.");
                    }
                  };
                }
                parse(recoveryMode) {
                  this.xref.parse(recoveryMode);
                  this.catalog = new _catalog.Catalog(this.pdfManager, this.xref);
                }
                get linearization() {
                  let linearization = null;
                  try {
                    linearization = _parser.Linearization.create(this.stream);
                  } catch (err) {
                    if (err instanceof _core_utils.MissingDataException) {
                      throw err;
                    }
                    (0, _util2.info)(err);
                  }
                  return (0, _util2.shadow)(this, "linearization", linearization);
                }
                get startXRef() {
                  const stream = this.stream;
                  let startXRef = 0;
                  if (this.linearization) {
                    stream.reset();
                    if (find3(stream, ENDOBJ_SIGNATURE)) {
                      startXRef = stream.pos + 6 - stream.start;
                    }
                  } else {
                    const step = 1024;
                    const startXRefLength = STARTXREF_SIGNATURE.length;
                    let found = false, pos = stream.end;
                    while (!found && pos > 0) {
                      pos -= step - startXRefLength;
                      if (pos < 0) {
                        pos = 0;
                      }
                      stream.pos = pos;
                      found = find3(stream, STARTXREF_SIGNATURE, step, true);
                    }
                    if (found) {
                      stream.skip(9);
                      let ch;
                      do {
                        ch = stream.getByte();
                      } while ((0, _core_utils.isWhiteSpace)(ch));
                      let str = "";
                      while (ch >= 32 && ch <= 57) {
                        str += String.fromCharCode(ch);
                        ch = stream.getByte();
                      }
                      startXRef = parseInt(str, 10);
                      if (isNaN(startXRef)) {
                        startXRef = 0;
                      }
                    }
                  }
                  return (0, _util2.shadow)(this, "startXRef", startXRef);
                }
                checkHeader() {
                  const stream = this.stream;
                  stream.reset();
                  if (!find3(stream, PDF_HEADER_SIGNATURE)) {
                    return;
                  }
                  stream.moveStart();
                  stream.skip(PDF_HEADER_SIGNATURE.length);
                  let version7 = "", ch;
                  while ((ch = stream.getByte()) > 32 && version7.length < 7) {
                    version7 += String.fromCharCode(ch);
                  }
                  if (_core_utils.PDF_VERSION_REGEXP.test(version7)) {
                    this._version = version7;
                  } else {
                    (0, _util2.warn)(`Invalid PDF header version: ${version7}`);
                  }
                }
                parseStartXRef() {
                  this.xref.setStartXRef(this.startXRef);
                }
                get numPages() {
                  let num = 0;
                  if (this.catalog.hasActualNumPages) {
                    num = this.catalog.numPages;
                  } else if (this.xfaFactory) {
                    num = this.xfaFactory.getNumPages();
                  } else if (this.linearization) {
                    num = this.linearization.numPages;
                  } else {
                    num = this.catalog.numPages;
                  }
                  return (0, _util2.shadow)(this, "numPages", num);
                }
                _hasOnlyDocumentSignatures(fields, recursionDepth = 0) {
                  const RECURSION_LIMIT = 10;
                  if (!Array.isArray(fields)) {
                    return false;
                  }
                  return fields.every((field) => {
                    field = this.xref.fetchIfRef(field);
                    if (!(field instanceof _primitives.Dict)) {
                      return false;
                    }
                    if (field.has("Kids")) {
                      if (++recursionDepth > RECURSION_LIMIT) {
                        (0, _util2.warn)("_hasOnlyDocumentSignatures: maximum recursion depth reached");
                        return false;
                      }
                      return this._hasOnlyDocumentSignatures(field.get("Kids"), recursionDepth);
                    }
                    const isSignature = (0, _primitives.isName)(field.get("FT"), "Sig");
                    const rectangle = field.get("Rect");
                    const isInvisible = Array.isArray(rectangle) && rectangle.every((value) => value === 0);
                    return isSignature && isInvisible;
                  });
                }
                get _xfaStreams() {
                  const acroForm = this.catalog.acroForm;
                  if (!acroForm) {
                    return null;
                  }
                  const xfa = acroForm.get("XFA");
                  const entries = {
                    "xdp:xdp": "",
                    template: "",
                    datasets: "",
                    config: "",
                    connectionSet: "",
                    localeSet: "",
                    stylesheet: "",
                    "/xdp:xdp": ""
                  };
                  if (xfa instanceof _base_stream.BaseStream && !xfa.isEmpty) {
                    entries["xdp:xdp"] = xfa;
                    return entries;
                  }
                  if (!Array.isArray(xfa) || xfa.length === 0) {
                    return null;
                  }
                  for (let i = 0, ii = xfa.length; i < ii; i += 2) {
                    let name;
                    if (i === 0) {
                      name = "xdp:xdp";
                    } else if (i === ii - 2) {
                      name = "/xdp:xdp";
                    } else {
                      name = xfa[i];
                    }
                    if (!entries.hasOwnProperty(name)) {
                      continue;
                    }
                    const data2 = this.xref.fetchIfRef(xfa[i + 1]);
                    if (!(data2 instanceof _base_stream.BaseStream) || data2.isEmpty) {
                      continue;
                    }
                    entries[name] = data2;
                  }
                  return entries;
                }
                get xfaDatasets() {
                  const streams = this._xfaStreams;
                  if (!streams) {
                    return (0, _util2.shadow)(this, "xfaDatasets", null);
                  }
                  for (const key2 of ["datasets", "xdp:xdp"]) {
                    const stream = streams[key2];
                    if (!stream) {
                      continue;
                    }
                    try {
                      const str = (0, _util2.stringToUTF8String)(stream.getString());
                      const data2 = {
                        [key2]: str
                      };
                      return (0, _util2.shadow)(this, "xfaDatasets", new _dataset_reader.DatasetReader(data2));
                    } catch {
                      (0, _util2.warn)("XFA - Invalid utf-8 string.");
                      break;
                    }
                  }
                  return (0, _util2.shadow)(this, "xfaDatasets", null);
                }
                get xfaData() {
                  const streams = this._xfaStreams;
                  if (!streams) {
                    return null;
                  }
                  const data2 = /* @__PURE__ */ Object.create(null);
                  for (const [key2, stream] of Object.entries(streams)) {
                    if (!stream) {
                      continue;
                    }
                    try {
                      data2[key2] = (0, _util2.stringToUTF8String)(stream.getString());
                    } catch {
                      (0, _util2.warn)("XFA - Invalid utf-8 string.");
                      return null;
                    }
                  }
                  return data2;
                }
                get xfaFactory() {
                  let data2;
                  if (this.pdfManager.enableXfa && this.catalog.needsRendering && this.formInfo.hasXfa && !this.formInfo.hasAcroForm) {
                    data2 = this.xfaData;
                  }
                  return (0, _util2.shadow)(this, "xfaFactory", data2 ? new _factory.XFAFactory(data2) : null);
                }
                get isPureXfa() {
                  return this.xfaFactory ? this.xfaFactory.isValid() : false;
                }
                get htmlForXfa() {
                  return this.xfaFactory ? this.xfaFactory.getPages() : null;
                }
                async loadXfaImages() {
                  const xfaImagesDict = await this.pdfManager.ensureCatalog("xfaImages");
                  if (!xfaImagesDict) {
                    return;
                  }
                  const keys4 = xfaImagesDict.getKeys();
                  const objectLoader = new _object_loader.ObjectLoader(xfaImagesDict, keys4, this.xref);
                  await objectLoader.load();
                  const xfaImages = /* @__PURE__ */ new Map();
                  for (const key2 of keys4) {
                    const stream = xfaImagesDict.get(key2);
                    if (stream instanceof _base_stream.BaseStream) {
                      xfaImages.set(key2, stream.getBytes());
                    }
                  }
                  this.xfaFactory.setImages(xfaImages);
                }
                async loadXfaFonts(handler, task) {
                  const acroForm = await this.pdfManager.ensureCatalog("acroForm");
                  if (!acroForm) {
                    return;
                  }
                  const resources = await acroForm.getAsync("DR");
                  if (!(resources instanceof _primitives.Dict)) {
                    return;
                  }
                  const objectLoader = new _object_loader.ObjectLoader(resources, ["Font"], this.xref);
                  await objectLoader.load();
                  const fontRes = resources.get("Font");
                  if (!(fontRes instanceof _primitives.Dict)) {
                    return;
                  }
                  const options = Object.assign(/* @__PURE__ */ Object.create(null), this.pdfManager.evaluatorOptions);
                  options.useSystemFonts = false;
                  const partialEvaluator = new _evaluator.PartialEvaluator({
                    xref: this.xref,
                    handler,
                    pageIndex: -1,
                    idFactory: this._globalIdFactory,
                    fontCache: this.catalog.fontCache,
                    builtInCMapCache: this.catalog.builtInCMapCache,
                    standardFontDataCache: this.catalog.standardFontDataCache,
                    options
                  });
                  const operatorList = new _operator_list.OperatorList();
                  const pdfFonts = [];
                  const initialState = {
                    get font() {
                      return pdfFonts.at(-1);
                    },
                    set font(font) {
                      pdfFonts.push(font);
                    },
                    clone() {
                      return this;
                    }
                  };
                  const fonts = /* @__PURE__ */ new Map();
                  fontRes.forEach((fontName, font) => {
                    fonts.set(fontName, font);
                  });
                  const promises = [];
                  for (const [fontName, font] of fonts) {
                    const descriptor = font.get("FontDescriptor");
                    if (!(descriptor instanceof _primitives.Dict)) {
                      continue;
                    }
                    let fontFamily = descriptor.get("FontFamily");
                    fontFamily = fontFamily.replaceAll(/[ ]+(\d)/g, "$1");
                    const fontWeight = descriptor.get("FontWeight");
                    const italicAngle = -descriptor.get("ItalicAngle");
                    const cssFontInfo = {
                      fontFamily,
                      fontWeight,
                      italicAngle
                    };
                    if (!(0, _core_utils.validateCSSFont)(cssFontInfo)) {
                      continue;
                    }
                    promises.push(partialEvaluator.handleSetFont(resources, [_primitives.Name.get(fontName), 1], null, operatorList, task, initialState, null, cssFontInfo).catch(function(reason) {
                      (0, _util2.warn)(`loadXfaFonts: "${reason}".`);
                      return null;
                    }));
                  }
                  await Promise.all(promises);
                  const missingFonts = this.xfaFactory.setFonts(pdfFonts);
                  if (!missingFonts) {
                    return;
                  }
                  options.ignoreErrors = true;
                  promises.length = 0;
                  pdfFonts.length = 0;
                  const reallyMissingFonts = /* @__PURE__ */ new Set();
                  for (const missing of missingFonts) {
                    if (!(0, _xfa_fonts.getXfaFontName)(`${missing}-Regular`)) {
                      reallyMissingFonts.add(missing);
                    }
                  }
                  if (reallyMissingFonts.size) {
                    missingFonts.push("PdfJS-Fallback");
                  }
                  for (const missing of missingFonts) {
                    if (reallyMissingFonts.has(missing)) {
                      continue;
                    }
                    for (const fontInfo of [{
                      name: "Regular",
                      fontWeight: 400,
                      italicAngle: 0
                    }, {
                      name: "Bold",
                      fontWeight: 700,
                      italicAngle: 0
                    }, {
                      name: "Italic",
                      fontWeight: 400,
                      italicAngle: 12
                    }, {
                      name: "BoldItalic",
                      fontWeight: 700,
                      italicAngle: 12
                    }]) {
                      const name = `${missing}-${fontInfo.name}`;
                      const dict = (0, _xfa_fonts.getXfaFontDict)(name);
                      promises.push(partialEvaluator.handleSetFont(resources, [_primitives.Name.get(name), 1], null, operatorList, task, initialState, dict, {
                        fontFamily: missing,
                        fontWeight: fontInfo.fontWeight,
                        italicAngle: fontInfo.italicAngle
                      }).catch(function(reason) {
                        (0, _util2.warn)(`loadXfaFonts: "${reason}".`);
                        return null;
                      }));
                    }
                  }
                  await Promise.all(promises);
                  this.xfaFactory.appendFonts(pdfFonts, reallyMissingFonts);
                }
                async serializeXfaData(annotationStorage) {
                  return this.xfaFactory ? this.xfaFactory.serializeData(annotationStorage) : null;
                }
                get version() {
                  return this.catalog.version || this._version;
                }
                get formInfo() {
                  const formInfo = {
                    hasFields: false,
                    hasAcroForm: false,
                    hasXfa: false,
                    hasSignatures: false
                  };
                  const acroForm = this.catalog.acroForm;
                  if (!acroForm) {
                    return (0, _util2.shadow)(this, "formInfo", formInfo);
                  }
                  try {
                    const fields = acroForm.get("Fields");
                    const hasFields = Array.isArray(fields) && fields.length > 0;
                    formInfo.hasFields = hasFields;
                    const xfa = acroForm.get("XFA");
                    formInfo.hasXfa = Array.isArray(xfa) && xfa.length > 0 || xfa instanceof _base_stream.BaseStream && !xfa.isEmpty;
                    const sigFlags = acroForm.get("SigFlags");
                    const hasSignatures = !!(sigFlags & 1);
                    const hasOnlyDocumentSignatures = hasSignatures && this._hasOnlyDocumentSignatures(fields);
                    formInfo.hasAcroForm = hasFields && !hasOnlyDocumentSignatures;
                    formInfo.hasSignatures = hasSignatures;
                  } catch (ex) {
                    if (ex instanceof _core_utils.MissingDataException) {
                      throw ex;
                    }
                    (0, _util2.warn)(`Cannot fetch form information: "${ex}".`);
                  }
                  return (0, _util2.shadow)(this, "formInfo", formInfo);
                }
                get documentInfo() {
                  const docInfo = {
                    PDFFormatVersion: this.version,
                    Language: this.catalog.lang,
                    EncryptFilterName: this.xref.encrypt ? this.xref.encrypt.filterName : null,
                    IsLinearized: !!this.linearization,
                    IsAcroFormPresent: this.formInfo.hasAcroForm,
                    IsXFAPresent: this.formInfo.hasXfa,
                    IsCollectionPresent: !!this.catalog.collection,
                    IsSignaturesPresent: this.formInfo.hasSignatures
                  };
                  let infoDict;
                  try {
                    infoDict = this.xref.trailer.get("Info");
                  } catch (err) {
                    if (err instanceof _core_utils.MissingDataException) {
                      throw err;
                    }
                    (0, _util2.info)("The document information dictionary is invalid.");
                  }
                  if (!(infoDict instanceof _primitives.Dict)) {
                    return (0, _util2.shadow)(this, "documentInfo", docInfo);
                  }
                  for (const key2 of infoDict.getKeys()) {
                    const value = infoDict.get(key2);
                    switch (key2) {
                      case "Title":
                      case "Author":
                      case "Subject":
                      case "Keywords":
                      case "Creator":
                      case "Producer":
                      case "CreationDate":
                      case "ModDate":
                        if (typeof value === "string") {
                          docInfo[key2] = (0, _util2.stringToPDFString)(value);
                          continue;
                        }
                        break;
                      case "Trapped":
                        if (value instanceof _primitives.Name) {
                          docInfo[key2] = value;
                          continue;
                        }
                        break;
                      default:
                        let customValue;
                        switch (typeof value) {
                          case "string":
                            customValue = (0, _util2.stringToPDFString)(value);
                            break;
                          case "number":
                          case "boolean":
                            customValue = value;
                            break;
                          default:
                            if (value instanceof _primitives.Name) {
                              customValue = value;
                            }
                            break;
                        }
                        if (customValue === void 0) {
                          (0, _util2.warn)(`Bad value, for custom key "${key2}", in Info: ${value}.`);
                          continue;
                        }
                        if (!docInfo.Custom) {
                          docInfo.Custom = /* @__PURE__ */ Object.create(null);
                        }
                        docInfo.Custom[key2] = customValue;
                        continue;
                    }
                    (0, _util2.warn)(`Bad value, for key "${key2}", in Info: ${value}.`);
                  }
                  return (0, _util2.shadow)(this, "documentInfo", docInfo);
                }
                get fingerprints() {
                  function validate(data2) {
                    return typeof data2 === "string" && data2.length > 0 && data2 !== EMPTY_FINGERPRINT;
                  }
                  function hexString(hash2) {
                    const buf = [];
                    for (const num of hash2) {
                      const hex2 = num.toString(16);
                      buf.push(hex2.padStart(2, "0"));
                    }
                    return buf.join("");
                  }
                  const idArray = this.xref.trailer.get("ID");
                  let hashOriginal, hashModified;
                  if (Array.isArray(idArray) && validate(idArray[0])) {
                    hashOriginal = (0, _util2.stringToBytes)(idArray[0]);
                    if (idArray[1] !== idArray[0] && validate(idArray[1])) {
                      hashModified = (0, _util2.stringToBytes)(idArray[1]);
                    }
                  } else {
                    hashOriginal = (0, _crypto.calculateMD5)(this.stream.getByteRange(0, FINGERPRINT_FIRST_BYTES), 0, FINGERPRINT_FIRST_BYTES);
                  }
                  return (0, _util2.shadow)(this, "fingerprints", [hexString(hashOriginal), hashModified ? hexString(hashModified) : null]);
                }
                async _getLinearizationPage(pageIndex) {
                  const {
                    catalog,
                    linearization,
                    xref
                  } = this;
                  const ref3 = _primitives.Ref.get(linearization.objectNumberFirst, 0);
                  try {
                    const obj = await xref.fetchAsync(ref3);
                    if (obj instanceof _primitives.Dict) {
                      let type5 = obj.getRaw("Type");
                      if (type5 instanceof _primitives.Ref) {
                        type5 = await xref.fetchAsync(type5);
                      }
                      if ((0, _primitives.isName)(type5, "Page") || !obj.has("Type") && !obj.has("Kids")) {
                        if (!catalog.pageKidsCountCache.has(ref3)) {
                          catalog.pageKidsCountCache.put(ref3, 1);
                        }
                        if (!catalog.pageIndexCache.has(ref3)) {
                          catalog.pageIndexCache.put(ref3, 0);
                        }
                        return [obj, ref3];
                      }
                    }
                    throw new _util2.FormatError("The Linearization dictionary doesn't point to a valid Page dictionary.");
                  } catch (reason) {
                    (0, _util2.warn)(`_getLinearizationPage: "${reason.message}".`);
                    return catalog.getPageDict(pageIndex);
                  }
                }
                getPage(pageIndex) {
                  const cachedPromise = this._pagePromises.get(pageIndex);
                  if (cachedPromise) {
                    return cachedPromise;
                  }
                  const {
                    catalog,
                    linearization,
                    xfaFactory
                  } = this;
                  let promise;
                  if (xfaFactory) {
                    promise = Promise.resolve([_primitives.Dict.empty, null]);
                  } else if (linearization?.pageFirst === pageIndex) {
                    promise = this._getLinearizationPage(pageIndex);
                  } else {
                    promise = catalog.getPageDict(pageIndex);
                  }
                  promise = promise.then(([pageDict, ref3]) => {
                    return new Page({
                      pdfManager: this.pdfManager,
                      xref: this.xref,
                      pageIndex,
                      pageDict,
                      ref: ref3,
                      globalIdFactory: this._globalIdFactory,
                      fontCache: catalog.fontCache,
                      builtInCMapCache: catalog.builtInCMapCache,
                      standardFontDataCache: catalog.standardFontDataCache,
                      globalImageCache: catalog.globalImageCache,
                      systemFontCache: catalog.systemFontCache,
                      nonBlendModesSet: catalog.nonBlendModesSet,
                      xfaFactory
                    });
                  });
                  this._pagePromises.set(pageIndex, promise);
                  return promise;
                }
                async checkFirstPage(recoveryMode = false) {
                  if (recoveryMode) {
                    return;
                  }
                  try {
                    await this.getPage(0);
                  } catch (reason) {
                    if (reason instanceof _core_utils.XRefEntryException) {
                      this._pagePromises.delete(0);
                      await this.cleanup();
                      throw new _core_utils.XRefParseException();
                    }
                  }
                }
                async checkLastPage(recoveryMode = false) {
                  const {
                    catalog,
                    pdfManager
                  } = this;
                  catalog.setActualNumPages();
                  let numPages;
                  try {
                    await Promise.all([pdfManager.ensureDoc("xfaFactory"), pdfManager.ensureDoc("linearization"), pdfManager.ensureCatalog("numPages")]);
                    if (this.xfaFactory) {
                      return;
                    } else if (this.linearization) {
                      numPages = this.linearization.numPages;
                    } else {
                      numPages = catalog.numPages;
                    }
                    if (!Number.isInteger(numPages)) {
                      throw new _util2.FormatError("Page count is not an integer.");
                    } else if (numPages <= 1) {
                      return;
                    }
                    await this.getPage(numPages - 1);
                  } catch (reason) {
                    this._pagePromises.delete(numPages - 1);
                    await this.cleanup();
                    if (reason instanceof _core_utils.XRefEntryException && !recoveryMode) {
                      throw new _core_utils.XRefParseException();
                    }
                    (0, _util2.warn)(`checkLastPage - invalid /Pages tree /Count: ${numPages}.`);
                    let pagesTree;
                    try {
                      pagesTree = await catalog.getAllPageDicts(recoveryMode);
                    } catch (reasonAll) {
                      if (reasonAll instanceof _core_utils.XRefEntryException && !recoveryMode) {
                        throw new _core_utils.XRefParseException();
                      }
                      catalog.setActualNumPages(1);
                      return;
                    }
                    for (const [pageIndex, [pageDict, ref3]] of pagesTree) {
                      let promise;
                      if (pageDict instanceof Error) {
                        promise = Promise.reject(pageDict);
                        promise.catch(() => {
                        });
                      } else {
                        promise = Promise.resolve(new Page({
                          pdfManager,
                          xref: this.xref,
                          pageIndex,
                          pageDict,
                          ref: ref3,
                          globalIdFactory: this._globalIdFactory,
                          fontCache: catalog.fontCache,
                          builtInCMapCache: catalog.builtInCMapCache,
                          standardFontDataCache: catalog.standardFontDataCache,
                          globalImageCache: catalog.globalImageCache,
                          systemFontCache: catalog.systemFontCache,
                          nonBlendModesSet: catalog.nonBlendModesSet,
                          xfaFactory: null
                        }));
                      }
                      this._pagePromises.set(pageIndex, promise);
                    }
                    catalog.setActualNumPages(pagesTree.size);
                  }
                }
                fontFallback(id, handler) {
                  return this.catalog.fontFallback(id, handler);
                }
                async cleanup(manuallyTriggered = false) {
                  return this.catalog ? this.catalog.cleanup(manuallyTriggered) : (0, _cleanup_helper.clearGlobalCaches)();
                }
                #collectFieldObjects(name, fieldRef, promises, annotationGlobals) {
                  const field = this.xref.fetchIfRef(fieldRef);
                  if (field.has("T")) {
                    const partName = (0, _util2.stringToPDFString)(field.get("T"));
                    name = name === "" ? partName : `${name}.${partName}`;
                  }
                  if (!promises.has(name)) {
                    promises.set(name, []);
                  }
                  promises.get(name).push(_annotation.AnnotationFactory.create(this.xref, fieldRef, annotationGlobals, this._localIdFactory, true, null).then((annotation) => annotation?.getFieldObject()).catch(function(reason) {
                    (0, _util2.warn)(`#collectFieldObjects: "${reason}".`);
                    return null;
                  }));
                  if (field.has("Kids")) {
                    for (const kid of field.get("Kids")) {
                      this.#collectFieldObjects(name, kid, promises, annotationGlobals);
                    }
                  }
                }
                get fieldObjects() {
                  if (!this.formInfo.hasFields) {
                    return (0, _util2.shadow)(this, "fieldObjects", Promise.resolve(null));
                  }
                  const promise = this.pdfManager.ensureDoc("annotationGlobals").then(async (annotationGlobals) => {
                    if (!annotationGlobals) {
                      return null;
                    }
                    const allFields = /* @__PURE__ */ Object.create(null);
                    const fieldPromises = /* @__PURE__ */ new Map();
                    for (const fieldRef of this.catalog.acroForm.get("Fields")) {
                      this.#collectFieldObjects("", fieldRef, fieldPromises, annotationGlobals);
                    }
                    const allPromises = [];
                    for (const [name, promises] of fieldPromises) {
                      allPromises.push(Promise.all(promises).then((fields) => {
                        fields = fields.filter((field) => !!field);
                        if (fields.length > 0) {
                          allFields[name] = fields;
                        }
                      }));
                    }
                    await Promise.all(allPromises);
                    return allFields;
                  });
                  return (0, _util2.shadow)(this, "fieldObjects", promise);
                }
                get hasJSActions() {
                  const promise = this.pdfManager.ensureDoc("_parseHasJSActions");
                  return (0, _util2.shadow)(this, "hasJSActions", promise);
                }
                async _parseHasJSActions() {
                  const [catalogJsActions, fieldObjects] = await Promise.all([this.pdfManager.ensureCatalog("jsActions"), this.pdfManager.ensureDoc("fieldObjects")]);
                  if (catalogJsActions) {
                    return true;
                  }
                  if (fieldObjects) {
                    return Object.values(fieldObjects).some((fieldObject) => fieldObject.some((object4) => object4.actions !== null));
                  }
                  return false;
                }
                get calculationOrderIds() {
                  const acroForm = this.catalog.acroForm;
                  if (!acroForm?.has("CO")) {
                    return (0, _util2.shadow)(this, "calculationOrderIds", null);
                  }
                  const calculationOrder = acroForm.get("CO");
                  if (!Array.isArray(calculationOrder) || calculationOrder.length === 0) {
                    return (0, _util2.shadow)(this, "calculationOrderIds", null);
                  }
                  const ids2 = [];
                  for (const id of calculationOrder) {
                    if (id instanceof _primitives.Ref) {
                      ids2.push(id.toString());
                    }
                  }
                  if (ids2.length === 0) {
                    return (0, _util2.shadow)(this, "calculationOrderIds", null);
                  }
                  return (0, _util2.shadow)(this, "calculationOrderIds", ids2);
                }
                get annotationGlobals() {
                  return (0, _util2.shadow)(this, "annotationGlobals", _annotation.AnnotationFactory.createGlobals(this.pdfManager));
                }
              }
              exports3.PDFDocument = PDFDocument;
            }),
            /* 10 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.PopupAnnotation = exports3.MarkupAnnotation = exports3.AnnotationFactory = exports3.AnnotationBorderStyle = exports3.Annotation = void 0;
              exports3.getQuadPoints = getQuadPoints;
              var _util2 = __w_pdfjs_require__3(2);
              var _core_utils = __w_pdfjs_require__3(3);
              var _default_appearance = __w_pdfjs_require__3(11);
              var _primitives = __w_pdfjs_require__3(4);
              var _stream = __w_pdfjs_require__3(8);
              var _base_stream = __w_pdfjs_require__3(5);
              var _bidi = __w_pdfjs_require__3(60);
              var _catalog = __w_pdfjs_require__3(66);
              var _colorspace = __w_pdfjs_require__3(12);
              var _file_spec = __w_pdfjs_require__3(69);
              var _jpeg_stream = __w_pdfjs_require__3(26);
              var _object_loader = __w_pdfjs_require__3(76);
              var _operator_list = __w_pdfjs_require__3(64);
              var _writer = __w_pdfjs_require__3(73);
              var _factory = __w_pdfjs_require__3(77);
              class AnnotationFactory {
                static createGlobals(pdfManager) {
                  return Promise.all([pdfManager.ensureCatalog("acroForm"), pdfManager.ensureDoc("xfaDatasets"), pdfManager.ensureCatalog("structTreeRoot"), pdfManager.ensureCatalog("baseUrl"), pdfManager.ensureCatalog("attachments")]).then(([acroForm, xfaDatasets, structTreeRoot, baseUrl, attachments]) => {
                    return {
                      pdfManager,
                      acroForm: acroForm instanceof _primitives.Dict ? acroForm : _primitives.Dict.empty,
                      xfaDatasets,
                      structTreeRoot,
                      baseUrl,
                      attachments
                    };
                  }, (reason) => {
                    (0, _util2.warn)(`createGlobals: "${reason}".`);
                    return null;
                  });
                }
                static async create(xref, ref3, annotationGlobals, idFactory, collectFields, pageRef) {
                  const pageIndex = collectFields ? await this._getPageIndex(xref, ref3, annotationGlobals.pdfManager) : null;
                  return annotationGlobals.pdfManager.ensure(this, "_create", [xref, ref3, annotationGlobals, idFactory, collectFields, pageIndex, pageRef]);
                }
                static _create(xref, ref3, annotationGlobals, idFactory, collectFields = false, pageIndex = null, pageRef = null) {
                  const dict = xref.fetchIfRef(ref3);
                  if (!(dict instanceof _primitives.Dict)) {
                    return void 0;
                  }
                  const {
                    acroForm,
                    pdfManager
                  } = annotationGlobals;
                  const id = ref3 instanceof _primitives.Ref ? ref3.toString() : `annot_${idFactory.createObjId()}`;
                  let subtype = dict.get("Subtype");
                  subtype = subtype instanceof _primitives.Name ? subtype.name : null;
                  const parameters = {
                    xref,
                    ref: ref3,
                    dict,
                    subtype,
                    id,
                    annotationGlobals,
                    collectFields,
                    needAppearances: !collectFields && acroForm.get("NeedAppearances") === true,
                    pageIndex,
                    evaluatorOptions: pdfManager.evaluatorOptions,
                    pageRef
                  };
                  switch (subtype) {
                    case "Link":
                      return new LinkAnnotation(parameters);
                    case "Text":
                      return new TextAnnotation(parameters);
                    case "Widget":
                      let fieldType = (0, _core_utils.getInheritableProperty)({
                        dict,
                        key: "FT"
                      });
                      fieldType = fieldType instanceof _primitives.Name ? fieldType.name : null;
                      switch (fieldType) {
                        case "Tx":
                          return new TextWidgetAnnotation(parameters);
                        case "Btn":
                          return new ButtonWidgetAnnotation(parameters);
                        case "Ch":
                          return new ChoiceWidgetAnnotation(parameters);
                        case "Sig":
                          return new SignatureWidgetAnnotation(parameters);
                      }
                      (0, _util2.warn)(`Unimplemented widget field type "${fieldType}", falling back to base field type.`);
                      return new WidgetAnnotation(parameters);
                    case "Popup":
                      return new PopupAnnotation(parameters);
                    case "FreeText":
                      return new FreeTextAnnotation(parameters);
                    case "Line":
                      return new LineAnnotation(parameters);
                    case "Square":
                      return new SquareAnnotation(parameters);
                    case "Circle":
                      return new CircleAnnotation(parameters);
                    case "PolyLine":
                      return new PolylineAnnotation(parameters);
                    case "Polygon":
                      return new PolygonAnnotation(parameters);
                    case "Caret":
                      return new CaretAnnotation(parameters);
                    case "Ink":
                      return new InkAnnotation(parameters);
                    case "Highlight":
                      return new HighlightAnnotation(parameters);
                    case "Underline":
                      return new UnderlineAnnotation(parameters);
                    case "Squiggly":
                      return new SquigglyAnnotation(parameters);
                    case "StrikeOut":
                      return new StrikeOutAnnotation(parameters);
                    case "Stamp":
                      return new StampAnnotation(parameters);
                    case "FileAttachment":
                      return new FileAttachmentAnnotation(parameters);
                    default:
                      if (!collectFields) {
                        if (!subtype) {
                          (0, _util2.warn)("Annotation is missing the required /Subtype.");
                        } else {
                          (0, _util2.warn)(`Unimplemented annotation type "${subtype}", falling back to base annotation.`);
                        }
                      }
                      return new Annotation(parameters);
                  }
                }
                static async _getPageIndex(xref, ref3, pdfManager) {
                  try {
                    const annotDict = await xref.fetchIfRefAsync(ref3);
                    if (!(annotDict instanceof _primitives.Dict)) {
                      return -1;
                    }
                    const pageRef = annotDict.getRaw("P");
                    if (pageRef instanceof _primitives.Ref) {
                      try {
                        const pageIndex = await pdfManager.ensureCatalog("getPageIndex", [pageRef]);
                        return pageIndex;
                      } catch (ex) {
                        (0, _util2.info)(`_getPageIndex -- not a valid page reference: "${ex}".`);
                      }
                    }
                    if (annotDict.has("Kids")) {
                      return -1;
                    }
                    const numPages = await pdfManager.ensureDoc("numPages");
                    for (let pageIndex = 0; pageIndex < numPages; pageIndex++) {
                      const page = await pdfManager.getPage(pageIndex);
                      const annotations = await pdfManager.ensure(page, "annotations");
                      for (const annotRef of annotations) {
                        if (annotRef instanceof _primitives.Ref && (0, _primitives.isRefsEqual)(annotRef, ref3)) {
                          return pageIndex;
                        }
                      }
                    }
                  } catch (ex) {
                    (0, _util2.warn)(`_getPageIndex: "${ex}".`);
                  }
                  return -1;
                }
                static generateImages(annotations, xref, isOffscreenCanvasSupported) {
                  if (!isOffscreenCanvasSupported) {
                    (0, _util2.warn)("generateImages: OffscreenCanvas is not supported, cannot save or print some annotations with images.");
                    return null;
                  }
                  let imagePromises;
                  for (const {
                    bitmapId,
                    bitmap
                  } of annotations) {
                    if (!bitmap) {
                      continue;
                    }
                    imagePromises ||= /* @__PURE__ */ new Map();
                    imagePromises.set(bitmapId, StampAnnotation.createImage(bitmap, xref));
                  }
                  return imagePromises;
                }
                static async saveNewAnnotations(evaluator, task, annotations, imagePromises) {
                  const xref = evaluator.xref;
                  let baseFontRef;
                  const dependencies = [];
                  const promises = [];
                  const {
                    isOffscreenCanvasSupported
                  } = evaluator.options;
                  for (const annotation of annotations) {
                    if (annotation.deleted) {
                      continue;
                    }
                    switch (annotation.annotationType) {
                      case _util2.AnnotationEditorType.FREETEXT:
                        if (!baseFontRef) {
                          const baseFont = new _primitives.Dict(xref);
                          baseFont.set("BaseFont", _primitives.Name.get("Helvetica"));
                          baseFont.set("Type", _primitives.Name.get("Font"));
                          baseFont.set("Subtype", _primitives.Name.get("Type1"));
                          baseFont.set("Encoding", _primitives.Name.get("WinAnsiEncoding"));
                          const buffer = [];
                          baseFontRef = xref.getNewTemporaryRef();
                          await (0, _writer.writeObject)(baseFontRef, baseFont, buffer, xref);
                          dependencies.push({
                            ref: baseFontRef,
                            data: buffer.join("")
                          });
                        }
                        promises.push(FreeTextAnnotation.createNewAnnotation(xref, annotation, dependencies, {
                          evaluator,
                          task,
                          baseFontRef
                        }));
                        break;
                      case _util2.AnnotationEditorType.INK:
                        promises.push(InkAnnotation.createNewAnnotation(xref, annotation, dependencies));
                        break;
                      case _util2.AnnotationEditorType.STAMP:
                        if (!isOffscreenCanvasSupported) {
                          break;
                        }
                        const image = await imagePromises.get(annotation.bitmapId);
                        if (image.imageStream) {
                          const {
                            imageStream,
                            smaskStream
                          } = image;
                          const buffer = [];
                          if (smaskStream) {
                            const smaskRef = xref.getNewTemporaryRef();
                            await (0, _writer.writeObject)(smaskRef, smaskStream, buffer, xref);
                            dependencies.push({
                              ref: smaskRef,
                              data: buffer.join("")
                            });
                            imageStream.dict.set("SMask", smaskRef);
                            buffer.length = 0;
                          }
                          const imageRef = image.imageRef = xref.getNewTemporaryRef();
                          await (0, _writer.writeObject)(imageRef, imageStream, buffer, xref);
                          dependencies.push({
                            ref: imageRef,
                            data: buffer.join("")
                          });
                          image.imageStream = image.smaskStream = null;
                        }
                        promises.push(StampAnnotation.createNewAnnotation(xref, annotation, dependencies, {
                          image
                        }));
                        break;
                    }
                  }
                  return {
                    annotations: await Promise.all(promises),
                    dependencies
                  };
                }
                static async printNewAnnotations(annotationGlobals, evaluator, task, annotations, imagePromises) {
                  if (!annotations) {
                    return null;
                  }
                  const {
                    options,
                    xref
                  } = evaluator;
                  const promises = [];
                  for (const annotation of annotations) {
                    if (annotation.deleted) {
                      continue;
                    }
                    switch (annotation.annotationType) {
                      case _util2.AnnotationEditorType.FREETEXT:
                        promises.push(FreeTextAnnotation.createNewPrintAnnotation(annotationGlobals, xref, annotation, {
                          evaluator,
                          task,
                          evaluatorOptions: options
                        }));
                        break;
                      case _util2.AnnotationEditorType.INK:
                        promises.push(InkAnnotation.createNewPrintAnnotation(annotationGlobals, xref, annotation, {
                          evaluatorOptions: options
                        }));
                        break;
                      case _util2.AnnotationEditorType.STAMP:
                        if (!options.isOffscreenCanvasSupported) {
                          break;
                        }
                        const image = await imagePromises.get(annotation.bitmapId);
                        if (image.imageStream) {
                          const {
                            imageStream,
                            smaskStream
                          } = image;
                          if (smaskStream) {
                            imageStream.dict.set("SMask", smaskStream);
                          }
                          image.imageRef = new _jpeg_stream.JpegStream(imageStream, imageStream.length);
                          image.imageStream = image.smaskStream = null;
                        }
                        promises.push(StampAnnotation.createNewPrintAnnotation(annotationGlobals, xref, annotation, {
                          image,
                          evaluatorOptions: options
                        }));
                        break;
                    }
                  }
                  return Promise.all(promises);
                }
              }
              exports3.AnnotationFactory = AnnotationFactory;
              function getRgbColor(color, defaultColor2 = new Uint8ClampedArray(3)) {
                if (!Array.isArray(color)) {
                  return defaultColor2;
                }
                const rgbColor = defaultColor2 || new Uint8ClampedArray(3);
                switch (color.length) {
                  case 0:
                    return null;
                  case 1:
                    _colorspace.ColorSpace.singletons.gray.getRgbItem(color, 0, rgbColor, 0);
                    return rgbColor;
                  case 3:
                    _colorspace.ColorSpace.singletons.rgb.getRgbItem(color, 0, rgbColor, 0);
                    return rgbColor;
                  case 4:
                    _colorspace.ColorSpace.singletons.cmyk.getRgbItem(color, 0, rgbColor, 0);
                    return rgbColor;
                  default:
                    return defaultColor2;
                }
              }
              function getPdfColorArray(color) {
                return Array.from(color, (c) => c / 255);
              }
              function getQuadPoints(dict, rect) {
                const quadPoints = dict.getArray("QuadPoints");
                if (!Array.isArray(quadPoints) || quadPoints.length === 0 || quadPoints.length % 8 > 0) {
                  return null;
                }
                const quadPointsLists = [];
                for (let i = 0, ii = quadPoints.length / 8; i < ii; i++) {
                  let minX = Infinity, maxX = -Infinity, minY = Infinity, maxY = -Infinity;
                  for (let j = i * 8, jj = i * 8 + 8; j < jj; j += 2) {
                    const x = quadPoints[j];
                    const y = quadPoints[j + 1];
                    minX = Math.min(x, minX);
                    maxX = Math.max(x, maxX);
                    minY = Math.min(y, minY);
                    maxY = Math.max(y, maxY);
                  }
                  if (rect !== null && (minX < rect[0] || maxX > rect[2] || minY < rect[1] || maxY > rect[3])) {
                    return null;
                  }
                  quadPointsLists.push([{
                    x: minX,
                    y: maxY
                  }, {
                    x: maxX,
                    y: maxY
                  }, {
                    x: minX,
                    y: minY
                  }, {
                    x: maxX,
                    y: minY
                  }]);
                }
                return quadPointsLists;
              }
              function getTransformMatrix2(rect, bbox, matrix) {
                const [minX, minY, maxX, maxY] = _util2.Util.getAxialAlignedBoundingBox(bbox, matrix);
                if (minX === maxX || minY === maxY) {
                  return [1, 0, 0, 1, rect[0], rect[1]];
                }
                const xRatio = (rect[2] - rect[0]) / (maxX - minX);
                const yRatio = (rect[3] - rect[1]) / (maxY - minY);
                return [xRatio, 0, 0, yRatio, rect[0] - minX * xRatio, rect[1] - minY * yRatio];
              }
              class Annotation {
                constructor(params) {
                  const {
                    dict,
                    xref,
                    annotationGlobals
                  } = params;
                  this.setTitle(dict.get("T"));
                  this.setContents(dict.get("Contents"));
                  this.setModificationDate(dict.get("M"));
                  this.setFlags(dict.get("F"));
                  this.setRectangle(dict.getArray("Rect"));
                  this.setColor(dict.getArray("C"));
                  this.setBorderStyle(dict);
                  this.setAppearance(dict);
                  this.setOptionalContent(dict);
                  const MK = dict.get("MK");
                  this.setBorderAndBackgroundColors(MK);
                  this.setRotation(MK, dict);
                  this.ref = params.ref instanceof _primitives.Ref ? params.ref : null;
                  this._streams = [];
                  if (this.appearance) {
                    this._streams.push(this.appearance);
                  }
                  const isLocked = !!(this.flags & _util2.AnnotationFlag.LOCKED);
                  const isContentLocked = !!(this.flags & _util2.AnnotationFlag.LOCKEDCONTENTS);
                  if (annotationGlobals.structTreeRoot) {
                    let structParent = dict.get("StructParent");
                    structParent = Number.isInteger(structParent) && structParent >= 0 ? structParent : -1;
                    annotationGlobals.structTreeRoot.addAnnotationIdToPage(params.pageRef, structParent);
                  }
                  this.data = {
                    annotationFlags: this.flags,
                    borderStyle: this.borderStyle,
                    color: this.color,
                    backgroundColor: this.backgroundColor,
                    borderColor: this.borderColor,
                    rotation: this.rotation,
                    contentsObj: this._contents,
                    hasAppearance: !!this.appearance,
                    id: params.id,
                    modificationDate: this.modificationDate,
                    rect: this.rectangle,
                    subtype: params.subtype,
                    hasOwnCanvas: false,
                    noRotate: !!(this.flags & _util2.AnnotationFlag.NOROTATE),
                    noHTML: isLocked && isContentLocked
                  };
                  if (params.collectFields) {
                    const kids = dict.get("Kids");
                    if (Array.isArray(kids)) {
                      const kidIds = [];
                      for (const kid of kids) {
                        if (kid instanceof _primitives.Ref) {
                          kidIds.push(kid.toString());
                        }
                      }
                      if (kidIds.length !== 0) {
                        this.data.kidIds = kidIds;
                      }
                    }
                    this.data.actions = (0, _core_utils.collectActions)(xref, dict, _util2.AnnotationActionEventType);
                    this.data.fieldName = this._constructFieldName(dict);
                    this.data.pageIndex = params.pageIndex;
                  }
                  this._isOffscreenCanvasSupported = params.evaluatorOptions.isOffscreenCanvasSupported;
                  this._fallbackFontDict = null;
                  this._needAppearances = false;
                }
                _hasFlag(flags, flag) {
                  return !!(flags & flag);
                }
                _isViewable(flags) {
                  return !this._hasFlag(flags, _util2.AnnotationFlag.INVISIBLE) && !this._hasFlag(flags, _util2.AnnotationFlag.NOVIEW);
                }
                _isPrintable(flags) {
                  return this._hasFlag(flags, _util2.AnnotationFlag.PRINT) && !this._hasFlag(flags, _util2.AnnotationFlag.HIDDEN) && !this._hasFlag(flags, _util2.AnnotationFlag.INVISIBLE);
                }
                mustBeViewed(annotationStorage, _renderForms) {
                  const noView = annotationStorage?.get(this.data.id)?.noView;
                  if (noView !== void 0) {
                    return !noView;
                  }
                  return this.viewable && !this._hasFlag(this.flags, _util2.AnnotationFlag.HIDDEN);
                }
                mustBePrinted(annotationStorage) {
                  const noPrint = annotationStorage?.get(this.data.id)?.noPrint;
                  if (noPrint !== void 0) {
                    return !noPrint;
                  }
                  return this.printable;
                }
                get viewable() {
                  if (this.data.quadPoints === null) {
                    return false;
                  }
                  if (this.flags === 0) {
                    return true;
                  }
                  return this._isViewable(this.flags);
                }
                get printable() {
                  if (this.data.quadPoints === null) {
                    return false;
                  }
                  if (this.flags === 0) {
                    return false;
                  }
                  return this._isPrintable(this.flags);
                }
                _parseStringHelper(data2) {
                  const str = typeof data2 === "string" ? (0, _util2.stringToPDFString)(data2) : "";
                  const dir = str && (0, _bidi.bidi)(str).dir === "rtl" ? "rtl" : "ltr";
                  return {
                    str,
                    dir
                  };
                }
                setDefaultAppearance(params) {
                  const {
                    dict,
                    annotationGlobals
                  } = params;
                  const defaultAppearance = (0, _core_utils.getInheritableProperty)({
                    dict,
                    key: "DA"
                  }) || annotationGlobals.acroForm.get("DA");
                  this._defaultAppearance = typeof defaultAppearance === "string" ? defaultAppearance : "";
                  this.data.defaultAppearanceData = (0, _default_appearance.parseDefaultAppearance)(this._defaultAppearance);
                }
                setTitle(title) {
                  this._title = this._parseStringHelper(title);
                }
                setContents(contents) {
                  this._contents = this._parseStringHelper(contents);
                }
                setModificationDate(modificationDate) {
                  this.modificationDate = typeof modificationDate === "string" ? modificationDate : null;
                }
                setFlags(flags) {
                  this.flags = Number.isInteger(flags) && flags > 0 ? flags : 0;
                }
                hasFlag(flag) {
                  return this._hasFlag(this.flags, flag);
                }
                setRectangle(rectangle) {
                  this.rectangle = Array.isArray(rectangle) && rectangle.length === 4 ? _util2.Util.normalizeRect(rectangle) : [0, 0, 0, 0];
                }
                setColor(color) {
                  this.color = getRgbColor(color);
                }
                setLineEndings(lineEndings) {
                  this.lineEndings = ["None", "None"];
                  if (Array.isArray(lineEndings) && lineEndings.length === 2) {
                    for (let i = 0; i < 2; i++) {
                      const obj = lineEndings[i];
                      if (obj instanceof _primitives.Name) {
                        switch (obj.name) {
                          case "None":
                            continue;
                          case "Square":
                          case "Circle":
                          case "Diamond":
                          case "OpenArrow":
                          case "ClosedArrow":
                          case "Butt":
                          case "ROpenArrow":
                          case "RClosedArrow":
                          case "Slash":
                            this.lineEndings[i] = obj.name;
                            continue;
                        }
                      }
                      (0, _util2.warn)(`Ignoring invalid lineEnding: ${obj}`);
                    }
                  }
                }
                setRotation(mk, dict) {
                  this.rotation = 0;
                  let angle = mk instanceof _primitives.Dict ? mk.get("R") || 0 : dict.get("Rotate") || 0;
                  if (Number.isInteger(angle) && angle !== 0) {
                    angle %= 360;
                    if (angle < 0) {
                      angle += 360;
                    }
                    if (angle % 90 === 0) {
                      this.rotation = angle;
                    }
                  }
                }
                setBorderAndBackgroundColors(mk) {
                  if (mk instanceof _primitives.Dict) {
                    this.borderColor = getRgbColor(mk.getArray("BC"), null);
                    this.backgroundColor = getRgbColor(mk.getArray("BG"), null);
                  } else {
                    this.borderColor = this.backgroundColor = null;
                  }
                }
                setBorderStyle(borderStyle) {
                  this.borderStyle = new AnnotationBorderStyle();
                  if (!(borderStyle instanceof _primitives.Dict)) {
                    return;
                  }
                  if (borderStyle.has("BS")) {
                    const dict = borderStyle.get("BS");
                    const dictType = dict.get("Type");
                    if (!dictType || (0, _primitives.isName)(dictType, "Border")) {
                      this.borderStyle.setWidth(dict.get("W"), this.rectangle);
                      this.borderStyle.setStyle(dict.get("S"));
                      this.borderStyle.setDashArray(dict.getArray("D"));
                    }
                  } else if (borderStyle.has("Border")) {
                    const array4 = borderStyle.getArray("Border");
                    if (Array.isArray(array4) && array4.length >= 3) {
                      this.borderStyle.setHorizontalCornerRadius(array4[0]);
                      this.borderStyle.setVerticalCornerRadius(array4[1]);
                      this.borderStyle.setWidth(array4[2], this.rectangle);
                      if (array4.length === 4) {
                        this.borderStyle.setDashArray(array4[3], true);
                      }
                    }
                  } else {
                    this.borderStyle.setWidth(0);
                  }
                }
                setAppearance(dict) {
                  this.appearance = null;
                  const appearanceStates = dict.get("AP");
                  if (!(appearanceStates instanceof _primitives.Dict)) {
                    return;
                  }
                  const normalAppearanceState = appearanceStates.get("N");
                  if (normalAppearanceState instanceof _base_stream.BaseStream) {
                    this.appearance = normalAppearanceState;
                    return;
                  }
                  if (!(normalAppearanceState instanceof _primitives.Dict)) {
                    return;
                  }
                  const as = dict.get("AS");
                  if (!(as instanceof _primitives.Name) || !normalAppearanceState.has(as.name)) {
                    return;
                  }
                  const appearance = normalAppearanceState.get(as.name);
                  if (appearance instanceof _base_stream.BaseStream) {
                    this.appearance = appearance;
                  }
                }
                setOptionalContent(dict) {
                  this.oc = null;
                  const oc = dict.get("OC");
                  if (oc instanceof _primitives.Name) {
                    (0, _util2.warn)("setOptionalContent: Support for /Name-entry is not implemented.");
                  } else if (oc instanceof _primitives.Dict) {
                    this.oc = oc;
                  }
                }
                loadResources(keys4, appearance) {
                  return appearance.dict.getAsync("Resources").then((resources) => {
                    if (!resources) {
                      return void 0;
                    }
                    const objectLoader = new _object_loader.ObjectLoader(resources, keys4, resources.xref);
                    return objectLoader.load().then(function() {
                      return resources;
                    });
                  });
                }
                async getOperatorList(evaluator, task, intent, renderForms, annotationStorage) {
                  const data2 = this.data;
                  let appearance = this.appearance;
                  const isUsingOwnCanvas = !!(this.data.hasOwnCanvas && intent & _util2.RenderingIntentFlag.DISPLAY);
                  if (!appearance) {
                    if (!isUsingOwnCanvas) {
                      return {
                        opList: new _operator_list.OperatorList(),
                        separateForm: false,
                        separateCanvas: false
                      };
                    }
                    appearance = new _stream.StringStream("");
                    appearance.dict = new _primitives.Dict();
                  }
                  const appearanceDict = appearance.dict;
                  const resources = await this.loadResources(["ExtGState", "ColorSpace", "Pattern", "Shading", "XObject", "Font"], appearance);
                  const bbox = appearanceDict.getArray("BBox") || [0, 0, 1, 1];
                  const matrix = appearanceDict.getArray("Matrix") || [1, 0, 0, 1, 0, 0];
                  const transform = getTransformMatrix2(data2.rect, bbox, matrix);
                  const opList = new _operator_list.OperatorList();
                  let optionalContent;
                  if (this.oc) {
                    optionalContent = await evaluator.parseMarkedContentProps(this.oc, null);
                  }
                  if (optionalContent !== void 0) {
                    opList.addOp(_util2.OPS.beginMarkedContentProps, ["OC", optionalContent]);
                  }
                  opList.addOp(_util2.OPS.beginAnnotation, [data2.id, data2.rect, transform, matrix, isUsingOwnCanvas]);
                  await evaluator.getOperatorList({
                    stream: appearance,
                    task,
                    resources,
                    operatorList: opList,
                    fallbackFontDict: this._fallbackFontDict
                  });
                  opList.addOp(_util2.OPS.endAnnotation, []);
                  if (optionalContent !== void 0) {
                    opList.addOp(_util2.OPS.endMarkedContent, []);
                  }
                  this.reset();
                  return {
                    opList,
                    separateForm: false,
                    separateCanvas: isUsingOwnCanvas
                  };
                }
                async save(evaluator, task, annotationStorage) {
                  return null;
                }
                get hasTextContent() {
                  return false;
                }
                async extractTextContent(evaluator, task, viewBox) {
                  if (!this.appearance) {
                    return;
                  }
                  const resources = await this.loadResources(["ExtGState", "Font", "Properties", "XObject"], this.appearance);
                  const text = [];
                  const buffer = [];
                  let firstPosition = null;
                  const sink = {
                    desiredSize: Math.Infinity,
                    ready: true,
                    enqueue(chunk, size) {
                      for (const item of chunk.items) {
                        if (item.str === void 0) {
                          continue;
                        }
                        firstPosition ||= item.transform.slice(-2);
                        buffer.push(item.str);
                        if (item.hasEOL) {
                          text.push(buffer.join(""));
                          buffer.length = 0;
                        }
                      }
                    }
                  };
                  await evaluator.getTextContent({
                    stream: this.appearance,
                    task,
                    resources,
                    includeMarkedContent: true,
                    sink,
                    viewBox
                  });
                  this.reset();
                  if (buffer.length) {
                    text.push(buffer.join(""));
                  }
                  if (text.length > 1 || text[0]) {
                    const appearanceDict = this.appearance.dict;
                    const bbox = appearanceDict.getArray("BBox") || [0, 0, 1, 1];
                    const matrix = appearanceDict.getArray("Matrix") || [1, 0, 0, 1, 0, 0];
                    const rect = this.data.rect;
                    const transform = getTransformMatrix2(rect, bbox, matrix);
                    transform[4] -= rect[0];
                    transform[5] -= rect[1];
                    firstPosition = _util2.Util.applyTransform(firstPosition, transform);
                    firstPosition = _util2.Util.applyTransform(firstPosition, matrix);
                    this.data.textPosition = firstPosition;
                    this.data.textContent = text;
                  }
                }
                getFieldObject() {
                  if (this.data.kidIds) {
                    return {
                      id: this.data.id,
                      actions: this.data.actions,
                      name: this.data.fieldName,
                      strokeColor: this.data.borderColor,
                      fillColor: this.data.backgroundColor,
                      type: "",
                      kidIds: this.data.kidIds,
                      page: this.data.pageIndex,
                      rotation: this.rotation
                    };
                  }
                  return null;
                }
                reset() {
                  for (const stream of this._streams) {
                    stream.reset();
                  }
                }
                _constructFieldName(dict) {
                  if (!dict.has("T") && !dict.has("Parent")) {
                    (0, _util2.warn)("Unknown field name, falling back to empty field name.");
                    return "";
                  }
                  if (!dict.has("Parent")) {
                    return (0, _util2.stringToPDFString)(dict.get("T"));
                  }
                  const fieldName = [];
                  if (dict.has("T")) {
                    fieldName.unshift((0, _util2.stringToPDFString)(dict.get("T")));
                  }
                  let loopDict = dict;
                  const visited = new _primitives.RefSet();
                  if (dict.objId) {
                    visited.put(dict.objId);
                  }
                  while (loopDict.has("Parent")) {
                    loopDict = loopDict.get("Parent");
                    if (!(loopDict instanceof _primitives.Dict) || loopDict.objId && visited.has(loopDict.objId)) {
                      break;
                    }
                    if (loopDict.objId) {
                      visited.put(loopDict.objId);
                    }
                    if (loopDict.has("T")) {
                      fieldName.unshift((0, _util2.stringToPDFString)(loopDict.get("T")));
                    }
                  }
                  return fieldName.join(".");
                }
              }
              exports3.Annotation = Annotation;
              class AnnotationBorderStyle {
                constructor() {
                  this.width = 1;
                  this.style = _util2.AnnotationBorderStyleType.SOLID;
                  this.dashArray = [3];
                  this.horizontalCornerRadius = 0;
                  this.verticalCornerRadius = 0;
                }
                setWidth(width, rect = [0, 0, 0, 0]) {
                  if (width instanceof _primitives.Name) {
                    this.width = 0;
                    return;
                  }
                  if (typeof width === "number") {
                    if (width > 0) {
                      const maxWidth = (rect[2] - rect[0]) / 2;
                      const maxHeight = (rect[3] - rect[1]) / 2;
                      if (maxWidth > 0 && maxHeight > 0 && (width > maxWidth || width > maxHeight)) {
                        (0, _util2.warn)(`AnnotationBorderStyle.setWidth - ignoring width: ${width}`);
                        width = 1;
                      }
                    }
                    this.width = width;
                  }
                }
                setStyle(style2) {
                  if (!(style2 instanceof _primitives.Name)) {
                    return;
                  }
                  switch (style2.name) {
                    case "S":
                      this.style = _util2.AnnotationBorderStyleType.SOLID;
                      break;
                    case "D":
                      this.style = _util2.AnnotationBorderStyleType.DASHED;
                      break;
                    case "B":
                      this.style = _util2.AnnotationBorderStyleType.BEVELED;
                      break;
                    case "I":
                      this.style = _util2.AnnotationBorderStyleType.INSET;
                      break;
                    case "U":
                      this.style = _util2.AnnotationBorderStyleType.UNDERLINE;
                      break;
                    default:
                      break;
                  }
                }
                setDashArray(dashArray, forceStyle = false) {
                  if (Array.isArray(dashArray) && dashArray.length > 0) {
                    let isValid2 = true;
                    let allZeros = true;
                    for (const element of dashArray) {
                      const validNumber = +element >= 0;
                      if (!validNumber) {
                        isValid2 = false;
                        break;
                      } else if (element > 0) {
                        allZeros = false;
                      }
                    }
                    if (isValid2 && !allZeros) {
                      this.dashArray = dashArray;
                      if (forceStyle) {
                        this.setStyle(_primitives.Name.get("D"));
                      }
                    } else {
                      this.width = 0;
                    }
                  } else if (dashArray) {
                    this.width = 0;
                  }
                }
                setHorizontalCornerRadius(radius2) {
                  if (Number.isInteger(radius2)) {
                    this.horizontalCornerRadius = radius2;
                  }
                }
                setVerticalCornerRadius(radius2) {
                  if (Number.isInteger(radius2)) {
                    this.verticalCornerRadius = radius2;
                  }
                }
              }
              exports3.AnnotationBorderStyle = AnnotationBorderStyle;
              class MarkupAnnotation extends Annotation {
                constructor(params) {
                  super(params);
                  const {
                    dict
                  } = params;
                  if (dict.has("IRT")) {
                    const rawIRT = dict.getRaw("IRT");
                    this.data.inReplyTo = rawIRT instanceof _primitives.Ref ? rawIRT.toString() : null;
                    const rt = dict.get("RT");
                    this.data.replyType = rt instanceof _primitives.Name ? rt.name : _util2.AnnotationReplyType.REPLY;
                  }
                  let popupRef = null;
                  if (this.data.replyType === _util2.AnnotationReplyType.GROUP) {
                    const parent2 = dict.get("IRT");
                    this.setTitle(parent2.get("T"));
                    this.data.titleObj = this._title;
                    this.setContents(parent2.get("Contents"));
                    this.data.contentsObj = this._contents;
                    if (!parent2.has("CreationDate")) {
                      this.data.creationDate = null;
                    } else {
                      this.setCreationDate(parent2.get("CreationDate"));
                      this.data.creationDate = this.creationDate;
                    }
                    if (!parent2.has("M")) {
                      this.data.modificationDate = null;
                    } else {
                      this.setModificationDate(parent2.get("M"));
                      this.data.modificationDate = this.modificationDate;
                    }
                    popupRef = parent2.getRaw("Popup");
                    if (!parent2.has("C")) {
                      this.data.color = null;
                    } else {
                      this.setColor(parent2.getArray("C"));
                      this.data.color = this.color;
                    }
                  } else {
                    this.data.titleObj = this._title;
                    this.setCreationDate(dict.get("CreationDate"));
                    this.data.creationDate = this.creationDate;
                    popupRef = dict.getRaw("Popup");
                    if (!dict.has("C")) {
                      this.data.color = null;
                    }
                  }
                  this.data.popupRef = popupRef instanceof _primitives.Ref ? popupRef.toString() : null;
                  if (dict.has("RC")) {
                    this.data.richText = _factory.XFAFactory.getRichTextAsHtml(dict.get("RC"));
                  }
                }
                setCreationDate(creationDate) {
                  this.creationDate = typeof creationDate === "string" ? creationDate : null;
                }
                _setDefaultAppearance({
                  xref,
                  extra,
                  strokeColor,
                  fillColor,
                  blendMode,
                  strokeAlpha,
                  fillAlpha,
                  pointsCallback
                }) {
                  let minX = Number.MAX_VALUE;
                  let minY = Number.MAX_VALUE;
                  let maxX = Number.MIN_VALUE;
                  let maxY = Number.MIN_VALUE;
                  const buffer = ["q"];
                  if (extra) {
                    buffer.push(extra);
                  }
                  if (strokeColor) {
                    buffer.push(`${strokeColor[0]} ${strokeColor[1]} ${strokeColor[2]} RG`);
                  }
                  if (fillColor) {
                    buffer.push(`${fillColor[0]} ${fillColor[1]} ${fillColor[2]} rg`);
                  }
                  let pointsArray = this.data.quadPoints;
                  if (!pointsArray) {
                    pointsArray = [[{
                      x: this.rectangle[0],
                      y: this.rectangle[3]
                    }, {
                      x: this.rectangle[2],
                      y: this.rectangle[3]
                    }, {
                      x: this.rectangle[0],
                      y: this.rectangle[1]
                    }, {
                      x: this.rectangle[2],
                      y: this.rectangle[1]
                    }]];
                  }
                  for (const points of pointsArray) {
                    const [mX, MX, mY, MY] = pointsCallback(buffer, points);
                    minX = Math.min(minX, mX);
                    maxX = Math.max(maxX, MX);
                    minY = Math.min(minY, mY);
                    maxY = Math.max(maxY, MY);
                  }
                  buffer.push("Q");
                  const formDict = new _primitives.Dict(xref);
                  const appearanceStreamDict = new _primitives.Dict(xref);
                  appearanceStreamDict.set("Subtype", _primitives.Name.get("Form"));
                  const appearanceStream = new _stream.StringStream(buffer.join(" "));
                  appearanceStream.dict = appearanceStreamDict;
                  formDict.set("Fm0", appearanceStream);
                  const gsDict = new _primitives.Dict(xref);
                  if (blendMode) {
                    gsDict.set("BM", _primitives.Name.get(blendMode));
                  }
                  if (typeof strokeAlpha === "number") {
                    gsDict.set("CA", strokeAlpha);
                  }
                  if (typeof fillAlpha === "number") {
                    gsDict.set("ca", fillAlpha);
                  }
                  const stateDict = new _primitives.Dict(xref);
                  stateDict.set("GS0", gsDict);
                  const resources = new _primitives.Dict(xref);
                  resources.set("ExtGState", stateDict);
                  resources.set("XObject", formDict);
                  const appearanceDict = new _primitives.Dict(xref);
                  appearanceDict.set("Resources", resources);
                  const bbox = this.data.rect = [minX, minY, maxX, maxY];
                  appearanceDict.set("BBox", bbox);
                  this.appearance = new _stream.StringStream("/GS0 gs /Fm0 Do");
                  this.appearance.dict = appearanceDict;
                  this._streams.push(this.appearance, appearanceStream);
                }
                static async createNewAnnotation(xref, annotation, dependencies, params) {
                  const annotationRef = annotation.ref ||= xref.getNewTemporaryRef();
                  const ap = await this.createNewAppearanceStream(annotation, xref, params);
                  const buffer = [];
                  let annotationDict;
                  if (ap) {
                    const apRef = xref.getNewTemporaryRef();
                    annotationDict = this.createNewDict(annotation, xref, {
                      apRef
                    });
                    await (0, _writer.writeObject)(apRef, ap, buffer, xref);
                    dependencies.push({
                      ref: apRef,
                      data: buffer.join("")
                    });
                  } else {
                    annotationDict = this.createNewDict(annotation, xref, {});
                  }
                  if (Number.isInteger(annotation.parentTreeId)) {
                    annotationDict.set("StructParent", annotation.parentTreeId);
                  }
                  buffer.length = 0;
                  await (0, _writer.writeObject)(annotationRef, annotationDict, buffer, xref);
                  return {
                    ref: annotationRef,
                    data: buffer.join("")
                  };
                }
                static async createNewPrintAnnotation(annotationGlobals, xref, annotation, params) {
                  const ap = await this.createNewAppearanceStream(annotation, xref, params);
                  const annotationDict = this.createNewDict(annotation, xref, {
                    ap
                  });
                  const newAnnotation = new this.prototype.constructor({
                    dict: annotationDict,
                    xref,
                    annotationGlobals,
                    evaluatorOptions: params.evaluatorOptions
                  });
                  if (annotation.ref) {
                    newAnnotation.ref = newAnnotation.refToReplace = annotation.ref;
                  }
                  return newAnnotation;
                }
              }
              exports3.MarkupAnnotation = MarkupAnnotation;
              class WidgetAnnotation extends Annotation {
                constructor(params) {
                  super(params);
                  const {
                    dict,
                    xref,
                    annotationGlobals
                  } = params;
                  const data2 = this.data;
                  this._needAppearances = params.needAppearances;
                  data2.annotationType = _util2.AnnotationType.WIDGET;
                  if (data2.fieldName === void 0) {
                    data2.fieldName = this._constructFieldName(dict);
                  }
                  if (data2.actions === void 0) {
                    data2.actions = (0, _core_utils.collectActions)(xref, dict, _util2.AnnotationActionEventType);
                  }
                  let fieldValue = (0, _core_utils.getInheritableProperty)({
                    dict,
                    key: "V",
                    getArray: true
                  });
                  data2.fieldValue = this._decodeFormValue(fieldValue);
                  const defaultFieldValue = (0, _core_utils.getInheritableProperty)({
                    dict,
                    key: "DV",
                    getArray: true
                  });
                  data2.defaultFieldValue = this._decodeFormValue(defaultFieldValue);
                  if (fieldValue === void 0 && annotationGlobals.xfaDatasets) {
                    const path2 = this._title.str;
                    if (path2) {
                      this._hasValueFromXFA = true;
                      data2.fieldValue = fieldValue = annotationGlobals.xfaDatasets.getValue(path2);
                    }
                  }
                  if (fieldValue === void 0 && data2.defaultFieldValue !== null) {
                    data2.fieldValue = data2.defaultFieldValue;
                  }
                  data2.alternativeText = (0, _util2.stringToPDFString)(dict.get("TU") || "");
                  this.setDefaultAppearance(params);
                  data2.hasAppearance ||= this._needAppearances && data2.fieldValue !== void 0 && data2.fieldValue !== null;
                  const fieldType = (0, _core_utils.getInheritableProperty)({
                    dict,
                    key: "FT"
                  });
                  data2.fieldType = fieldType instanceof _primitives.Name ? fieldType.name : null;
                  const localResources = (0, _core_utils.getInheritableProperty)({
                    dict,
                    key: "DR"
                  });
                  const acroFormResources = annotationGlobals.acroForm.get("DR");
                  const appearanceResources = this.appearance?.dict.get("Resources");
                  this._fieldResources = {
                    localResources,
                    acroFormResources,
                    appearanceResources,
                    mergedResources: _primitives.Dict.merge({
                      xref,
                      dictArray: [localResources, appearanceResources, acroFormResources],
                      mergeSubDicts: true
                    })
                  };
                  data2.fieldFlags = (0, _core_utils.getInheritableProperty)({
                    dict,
                    key: "Ff"
                  });
                  if (!Number.isInteger(data2.fieldFlags) || data2.fieldFlags < 0) {
                    data2.fieldFlags = 0;
                  }
                  data2.readOnly = this.hasFieldFlag(_util2.AnnotationFieldFlag.READONLY);
                  data2.required = this.hasFieldFlag(_util2.AnnotationFieldFlag.REQUIRED);
                  data2.hidden = this._hasFlag(data2.annotationFlags, _util2.AnnotationFlag.HIDDEN) || this._hasFlag(data2.annotationFlags, _util2.AnnotationFlag.NOVIEW);
                }
                _decodeFormValue(formValue) {
                  if (Array.isArray(formValue)) {
                    return formValue.filter((item) => typeof item === "string").map((item) => (0, _util2.stringToPDFString)(item));
                  } else if (formValue instanceof _primitives.Name) {
                    return (0, _util2.stringToPDFString)(formValue.name);
                  } else if (typeof formValue === "string") {
                    return (0, _util2.stringToPDFString)(formValue);
                  }
                  return null;
                }
                hasFieldFlag(flag) {
                  return !!(this.data.fieldFlags & flag);
                }
                _isViewable(flags) {
                  return !this._hasFlag(flags, _util2.AnnotationFlag.INVISIBLE);
                }
                mustBeViewed(annotationStorage, renderForms) {
                  if (renderForms) {
                    return this.viewable;
                  }
                  return super.mustBeViewed(annotationStorage, renderForms) && !this._hasFlag(this.flags, _util2.AnnotationFlag.NOVIEW);
                }
                getRotationMatrix(annotationStorage) {
                  let rotation = annotationStorage?.get(this.data.id)?.rotation;
                  if (rotation === void 0) {
                    rotation = this.rotation;
                  }
                  if (rotation === 0) {
                    return _util2.IDENTITY_MATRIX;
                  }
                  const width = this.data.rect[2] - this.data.rect[0];
                  const height = this.data.rect[3] - this.data.rect[1];
                  return (0, _core_utils.getRotationMatrix)(rotation, width, height);
                }
                getBorderAndBackgroundAppearances(annotationStorage) {
                  let rotation = annotationStorage?.get(this.data.id)?.rotation;
                  if (rotation === void 0) {
                    rotation = this.rotation;
                  }
                  if (!this.backgroundColor && !this.borderColor) {
                    return "";
                  }
                  const width = this.data.rect[2] - this.data.rect[0];
                  const height = this.data.rect[3] - this.data.rect[1];
                  const rect = rotation === 0 || rotation === 180 ? `0 0 ${width} ${height} re` : `0 0 ${height} ${width} re`;
                  let str = "";
                  if (this.backgroundColor) {
                    str = `${(0, _default_appearance.getPdfColor)(this.backgroundColor, true)} ${rect} f `;
                  }
                  if (this.borderColor) {
                    const borderWidth2 = this.borderStyle.width || 1;
                    str += `${borderWidth2} w ${(0, _default_appearance.getPdfColor)(this.borderColor, false)} ${rect} S `;
                  }
                  return str;
                }
                async getOperatorList(evaluator, task, intent, renderForms, annotationStorage) {
                  if (renderForms && !(this instanceof SignatureWidgetAnnotation) && !this.data.noHTML && !this.data.hasOwnCanvas) {
                    return {
                      opList: new _operator_list.OperatorList(),
                      separateForm: true,
                      separateCanvas: false
                    };
                  }
                  if (!this._hasText) {
                    return super.getOperatorList(evaluator, task, intent, renderForms, annotationStorage);
                  }
                  const content = await this._getAppearance(evaluator, task, intent, annotationStorage);
                  if (this.appearance && content === null) {
                    return super.getOperatorList(evaluator, task, intent, renderForms, annotationStorage);
                  }
                  const opList = new _operator_list.OperatorList();
                  if (!this._defaultAppearance || content === null) {
                    return {
                      opList,
                      separateForm: false,
                      separateCanvas: false
                    };
                  }
                  const isUsingOwnCanvas = !!(this.data.hasOwnCanvas && intent & _util2.RenderingIntentFlag.DISPLAY);
                  const matrix = [1, 0, 0, 1, 0, 0];
                  const bbox = [0, 0, this.data.rect[2] - this.data.rect[0], this.data.rect[3] - this.data.rect[1]];
                  const transform = getTransformMatrix2(this.data.rect, bbox, matrix);
                  let optionalContent;
                  if (this.oc) {
                    optionalContent = await evaluator.parseMarkedContentProps(this.oc, null);
                  }
                  if (optionalContent !== void 0) {
                    opList.addOp(_util2.OPS.beginMarkedContentProps, ["OC", optionalContent]);
                  }
                  opList.addOp(_util2.OPS.beginAnnotation, [this.data.id, this.data.rect, transform, this.getRotationMatrix(annotationStorage), isUsingOwnCanvas]);
                  const stream = new _stream.StringStream(content);
                  await evaluator.getOperatorList({
                    stream,
                    task,
                    resources: this._fieldResources.mergedResources,
                    operatorList: opList
                  });
                  opList.addOp(_util2.OPS.endAnnotation, []);
                  if (optionalContent !== void 0) {
                    opList.addOp(_util2.OPS.endMarkedContent, []);
                  }
                  return {
                    opList,
                    separateForm: false,
                    separateCanvas: isUsingOwnCanvas
                  };
                }
                _getMKDict(rotation) {
                  const mk = new _primitives.Dict(null);
                  if (rotation) {
                    mk.set("R", rotation);
                  }
                  if (this.borderColor) {
                    mk.set("BC", getPdfColorArray(this.borderColor));
                  }
                  if (this.backgroundColor) {
                    mk.set("BG", getPdfColorArray(this.backgroundColor));
                  }
                  return mk.size > 0 ? mk : null;
                }
                amendSavedDict(annotationStorage, dict) {
                }
                async save(evaluator, task, annotationStorage) {
                  const storageEntry = annotationStorage?.get(this.data.id);
                  let value = storageEntry?.value, rotation = storageEntry?.rotation;
                  if (value === this.data.fieldValue || value === void 0) {
                    if (!this._hasValueFromXFA && rotation === void 0) {
                      return null;
                    }
                    value ||= this.data.fieldValue;
                  }
                  if (rotation === void 0 && !this._hasValueFromXFA && Array.isArray(value) && Array.isArray(this.data.fieldValue) && value.length === this.data.fieldValue.length && value.every((x, i) => x === this.data.fieldValue[i])) {
                    return null;
                  }
                  if (rotation === void 0) {
                    rotation = this.rotation;
                  }
                  let appearance = null;
                  if (!this._needAppearances) {
                    appearance = await this._getAppearance(evaluator, task, _util2.RenderingIntentFlag.SAVE, annotationStorage);
                    if (appearance === null) {
                      return null;
                    }
                  } else {
                  }
                  let needAppearances = false;
                  if (appearance?.needAppearances) {
                    needAppearances = true;
                    appearance = null;
                  }
                  const {
                    xref
                  } = evaluator;
                  const originalDict = xref.fetchIfRef(this.ref);
                  if (!(originalDict instanceof _primitives.Dict)) {
                    return null;
                  }
                  const dict = new _primitives.Dict(xref);
                  for (const key2 of originalDict.getKeys()) {
                    if (key2 !== "AP") {
                      dict.set(key2, originalDict.getRaw(key2));
                    }
                  }
                  const xfa = {
                    path: this.data.fieldName,
                    value
                  };
                  const encoder = (val) => {
                    return (0, _core_utils.isAscii)(val) ? val : (0, _core_utils.stringToUTF16String)(val, true);
                  };
                  dict.set("V", Array.isArray(value) ? value.map(encoder) : encoder(value));
                  this.amendSavedDict(annotationStorage, dict);
                  const maybeMK = this._getMKDict(rotation);
                  if (maybeMK) {
                    dict.set("MK", maybeMK);
                  }
                  const buffer = [];
                  const changes = [{
                    ref: this.ref,
                    data: "",
                    xfa,
                    needAppearances
                  }];
                  if (appearance !== null) {
                    const newRef = xref.getNewTemporaryRef();
                    const AP = new _primitives.Dict(xref);
                    dict.set("AP", AP);
                    AP.set("N", newRef);
                    const resources = this._getSaveFieldResources(xref);
                    const appearanceStream = new _stream.StringStream(appearance);
                    const appearanceDict = appearanceStream.dict = new _primitives.Dict(xref);
                    appearanceDict.set("Subtype", _primitives.Name.get("Form"));
                    appearanceDict.set("Resources", resources);
                    appearanceDict.set("BBox", [0, 0, this.data.rect[2] - this.data.rect[0], this.data.rect[3] - this.data.rect[1]]);
                    const rotationMatrix = this.getRotationMatrix(annotationStorage);
                    if (rotationMatrix !== _util2.IDENTITY_MATRIX) {
                      appearanceDict.set("Matrix", rotationMatrix);
                    }
                    await (0, _writer.writeObject)(newRef, appearanceStream, buffer, xref);
                    changes.push({
                      ref: newRef,
                      data: buffer.join(""),
                      xfa: null,
                      needAppearances: false
                    });
                    buffer.length = 0;
                  }
                  dict.set("M", `D:${(0, _util2.getModificationDate)()}`);
                  await (0, _writer.writeObject)(this.ref, dict, buffer, xref);
                  changes[0].data = buffer.join("");
                  return changes;
                }
                async _getAppearance(evaluator, task, intent, annotationStorage) {
                  const isPassword = this.hasFieldFlag(_util2.AnnotationFieldFlag.PASSWORD);
                  if (isPassword) {
                    return null;
                  }
                  const storageEntry = annotationStorage?.get(this.data.id);
                  let value, rotation;
                  if (storageEntry) {
                    value = storageEntry.formattedValue || storageEntry.value;
                    rotation = storageEntry.rotation;
                  }
                  if (rotation === void 0 && value === void 0 && !this._needAppearances) {
                    if (!this._hasValueFromXFA || this.appearance) {
                      return null;
                    }
                  }
                  const colors = this.getBorderAndBackgroundAppearances(annotationStorage);
                  if (value === void 0) {
                    value = this.data.fieldValue;
                    if (!value) {
                      return `/Tx BMC q ${colors}Q EMC`;
                    }
                  }
                  if (Array.isArray(value) && value.length === 1) {
                    value = value[0];
                  }
                  (0, _util2.assert)(typeof value === "string", "Expected `value` to be a string.");
                  value = value.trim();
                  if (this.data.combo) {
                    const option = this.data.options.find(({
                      exportValue
                    }) => value === exportValue);
                    value = option?.displayValue || value;
                  }
                  if (value === "") {
                    return `/Tx BMC q ${colors}Q EMC`;
                  }
                  if (rotation === void 0) {
                    rotation = this.rotation;
                  }
                  let lineCount = -1;
                  let lines;
                  if (this.data.multiLine) {
                    lines = value.split(/\r\n?|\n/).map((line2) => line2.normalize("NFC"));
                    lineCount = lines.length;
                  } else {
                    lines = [value.replace(/\r\n?|\n/, "").normalize("NFC")];
                  }
                  const defaultPadding = 1;
                  const defaultHPadding = 2;
                  let totalHeight = this.data.rect[3] - this.data.rect[1];
                  let totalWidth = this.data.rect[2] - this.data.rect[0];
                  if (rotation === 90 || rotation === 270) {
                    [totalWidth, totalHeight] = [totalHeight, totalWidth];
                  }
                  if (!this._defaultAppearance) {
                    this.data.defaultAppearanceData = (0, _default_appearance.parseDefaultAppearance)(this._defaultAppearance = "/Helvetica 0 Tf 0 g");
                  }
                  let font = await WidgetAnnotation._getFontData(evaluator, task, this.data.defaultAppearanceData, this._fieldResources.mergedResources);
                  let defaultAppearance, fontSize, lineHeight;
                  const encodedLines = [];
                  let encodingError = false;
                  for (const line2 of lines) {
                    const encodedString = font.encodeString(line2);
                    if (encodedString.length > 1) {
                      encodingError = true;
                    }
                    encodedLines.push(encodedString.join(""));
                  }
                  if (encodingError && intent & _util2.RenderingIntentFlag.SAVE) {
                    return {
                      needAppearances: true
                    };
                  }
                  if (encodingError && this._isOffscreenCanvasSupported) {
                    const fontFamily = this.data.comb ? "monospace" : "sans-serif";
                    const fakeUnicodeFont = new _default_appearance.FakeUnicodeFont(evaluator.xref, fontFamily);
                    const resources = fakeUnicodeFont.createFontResources(lines.join(""));
                    const newFont = resources.getRaw("Font");
                    if (this._fieldResources.mergedResources.has("Font")) {
                      const oldFont = this._fieldResources.mergedResources.get("Font");
                      for (const key2 of newFont.getKeys()) {
                        oldFont.set(key2, newFont.getRaw(key2));
                      }
                    } else {
                      this._fieldResources.mergedResources.set("Font", newFont);
                    }
                    const fontName = fakeUnicodeFont.fontName.name;
                    font = await WidgetAnnotation._getFontData(evaluator, task, {
                      fontName,
                      fontSize: 0
                    }, resources);
                    for (let i = 0, ii = encodedLines.length; i < ii; i++) {
                      encodedLines[i] = (0, _core_utils.stringToUTF16String)(lines[i]);
                    }
                    const savedDefaultAppearance = Object.assign(/* @__PURE__ */ Object.create(null), this.data.defaultAppearanceData);
                    this.data.defaultAppearanceData.fontSize = 0;
                    this.data.defaultAppearanceData.fontName = fontName;
                    [defaultAppearance, fontSize, lineHeight] = this._computeFontSize(totalHeight - 2 * defaultPadding, totalWidth - 2 * defaultHPadding, value, font, lineCount);
                    this.data.defaultAppearanceData = savedDefaultAppearance;
                  } else {
                    if (!this._isOffscreenCanvasSupported) {
                      (0, _util2.warn)("_getAppearance: OffscreenCanvas is not supported, annotation may not render correctly.");
                    }
                    [defaultAppearance, fontSize, lineHeight] = this._computeFontSize(totalHeight - 2 * defaultPadding, totalWidth - 2 * defaultHPadding, value, font, lineCount);
                  }
                  let descent = font.descent;
                  if (isNaN(descent)) {
                    descent = _util2.BASELINE_FACTOR * lineHeight;
                  } else {
                    descent = Math.max(_util2.BASELINE_FACTOR * lineHeight, Math.abs(descent) * fontSize);
                  }
                  const defaultVPadding = Math.min(Math.floor((totalHeight - fontSize) / 2), defaultPadding);
                  const alignment = this.data.textAlignment;
                  if (this.data.multiLine) {
                    return this._getMultilineAppearance(defaultAppearance, encodedLines, font, fontSize, totalWidth, totalHeight, alignment, defaultHPadding, defaultVPadding, descent, lineHeight, annotationStorage);
                  }
                  if (this.data.comb) {
                    return this._getCombAppearance(defaultAppearance, font, encodedLines[0], fontSize, totalWidth, totalHeight, defaultHPadding, defaultVPadding, descent, lineHeight, annotationStorage);
                  }
                  const bottomPadding = defaultVPadding + descent;
                  if (alignment === 0 || alignment > 2) {
                    return `/Tx BMC q ${colors}BT ` + defaultAppearance + ` 1 0 0 1 ${(0, _core_utils.numberToString)(defaultHPadding)} ${(0, _core_utils.numberToString)(bottomPadding)} Tm (${(0, _core_utils.escapeString)(encodedLines[0])}) Tj ET Q EMC`;
                  }
                  const prevInfo = {
                    shift: 0
                  };
                  const renderedText = this._renderText(encodedLines[0], font, fontSize, totalWidth, alignment, prevInfo, defaultHPadding, bottomPadding);
                  return `/Tx BMC q ${colors}BT ` + defaultAppearance + ` 1 0 0 1 0 0 Tm ${renderedText} ET Q EMC`;
                }
                static async _getFontData(evaluator, task, appearanceData, resources) {
                  const operatorList = new _operator_list.OperatorList();
                  const initialState = {
                    font: null,
                    clone() {
                      return this;
                    }
                  };
                  const {
                    fontName,
                    fontSize
                  } = appearanceData;
                  await evaluator.handleSetFont(resources, [fontName && _primitives.Name.get(fontName), fontSize], null, operatorList, task, initialState, null);
                  return initialState.font;
                }
                _getTextWidth(text, font) {
                  return font.charsToGlyphs(text).reduce((width, glyph) => width + glyph.width, 0) / 1e3;
                }
                _computeFontSize(height, width, text, font, lineCount) {
                  let {
                    fontSize
                  } = this.data.defaultAppearanceData;
                  let lineHeight = (fontSize || 12) * _util2.LINE_FACTOR, numberOfLines = Math.round(height / lineHeight);
                  if (!fontSize) {
                    const roundWithTwoDigits = (x) => Math.floor(x * 100) / 100;
                    if (lineCount === -1) {
                      const textWidth = this._getTextWidth(text, font);
                      fontSize = roundWithTwoDigits(Math.min(height / _util2.LINE_FACTOR, textWidth > width ? width / textWidth : Infinity));
                      numberOfLines = 1;
                    } else {
                      const lines = text.split(/\r\n?|\n/);
                      const cachedLines = [];
                      for (const line2 of lines) {
                        const encoded = font.encodeString(line2).join("");
                        const glyphs = font.charsToGlyphs(encoded);
                        const positions = font.getCharPositions(encoded);
                        cachedLines.push({
                          line: encoded,
                          glyphs,
                          positions
                        });
                      }
                      const isTooBig = (fsize) => {
                        let totalHeight = 0;
                        for (const cache of cachedLines) {
                          const chunks = this._splitLine(null, font, fsize, width, cache);
                          totalHeight += chunks.length * fsize;
                          if (totalHeight > height) {
                            return true;
                          }
                        }
                        return false;
                      };
                      numberOfLines = Math.max(numberOfLines, lineCount);
                      while (true) {
                        lineHeight = height / numberOfLines;
                        fontSize = roundWithTwoDigits(lineHeight / _util2.LINE_FACTOR);
                        if (isTooBig(fontSize)) {
                          numberOfLines++;
                          continue;
                        }
                        break;
                      }
                    }
                    const {
                      fontName,
                      fontColor
                    } = this.data.defaultAppearanceData;
                    this._defaultAppearance = (0, _default_appearance.createDefaultAppearance)({
                      fontSize,
                      fontName,
                      fontColor
                    });
                  }
                  return [this._defaultAppearance, fontSize, height / numberOfLines];
                }
                _renderText(text, font, fontSize, totalWidth, alignment, prevInfo, hPadding, vPadding) {
                  let shift2;
                  if (alignment === 1) {
                    const width = this._getTextWidth(text, font) * fontSize;
                    shift2 = (totalWidth - width) / 2;
                  } else if (alignment === 2) {
                    const width = this._getTextWidth(text, font) * fontSize;
                    shift2 = totalWidth - width - hPadding;
                  } else {
                    shift2 = hPadding;
                  }
                  const shiftStr = (0, _core_utils.numberToString)(shift2 - prevInfo.shift);
                  prevInfo.shift = shift2;
                  vPadding = (0, _core_utils.numberToString)(vPadding);
                  return `${shiftStr} ${vPadding} Td (${(0, _core_utils.escapeString)(text)}) Tj`;
                }
                _getSaveFieldResources(xref) {
                  const {
                    localResources,
                    appearanceResources,
                    acroFormResources
                  } = this._fieldResources;
                  const fontName = this.data.defaultAppearanceData?.fontName;
                  if (!fontName) {
                    return localResources || _primitives.Dict.empty;
                  }
                  for (const resources of [localResources, appearanceResources]) {
                    if (resources instanceof _primitives.Dict) {
                      const localFont = resources.get("Font");
                      if (localFont instanceof _primitives.Dict && localFont.has(fontName)) {
                        return resources;
                      }
                    }
                  }
                  if (acroFormResources instanceof _primitives.Dict) {
                    const acroFormFont = acroFormResources.get("Font");
                    if (acroFormFont instanceof _primitives.Dict && acroFormFont.has(fontName)) {
                      const subFontDict = new _primitives.Dict(xref);
                      subFontDict.set(fontName, acroFormFont.getRaw(fontName));
                      const subResourcesDict = new _primitives.Dict(xref);
                      subResourcesDict.set("Font", subFontDict);
                      return _primitives.Dict.merge({
                        xref,
                        dictArray: [subResourcesDict, localResources],
                        mergeSubDicts: true
                      });
                    }
                  }
                  return localResources || _primitives.Dict.empty;
                }
                getFieldObject() {
                  return null;
                }
              }
              class TextWidgetAnnotation extends WidgetAnnotation {
                constructor(params) {
                  super(params);
                  this.data.hasOwnCanvas = this.data.readOnly && !this.data.noHTML;
                  this._hasText = true;
                  const dict = params.dict;
                  if (typeof this.data.fieldValue !== "string") {
                    this.data.fieldValue = "";
                  }
                  let alignment = (0, _core_utils.getInheritableProperty)({
                    dict,
                    key: "Q"
                  });
                  if (!Number.isInteger(alignment) || alignment < 0 || alignment > 2) {
                    alignment = null;
                  }
                  this.data.textAlignment = alignment;
                  let maximumLength = (0, _core_utils.getInheritableProperty)({
                    dict,
                    key: "MaxLen"
                  });
                  if (!Number.isInteger(maximumLength) || maximumLength < 0) {
                    maximumLength = 0;
                  }
                  this.data.maxLen = maximumLength;
                  this.data.multiLine = this.hasFieldFlag(_util2.AnnotationFieldFlag.MULTILINE);
                  this.data.comb = this.hasFieldFlag(_util2.AnnotationFieldFlag.COMB) && !this.hasFieldFlag(_util2.AnnotationFieldFlag.MULTILINE) && !this.hasFieldFlag(_util2.AnnotationFieldFlag.PASSWORD) && !this.hasFieldFlag(_util2.AnnotationFieldFlag.FILESELECT) && this.data.maxLen !== 0;
                  this.data.doNotScroll = this.hasFieldFlag(_util2.AnnotationFieldFlag.DONOTSCROLL);
                }
                get hasTextContent() {
                  return !!this.appearance && !this._needAppearances;
                }
                _getCombAppearance(defaultAppearance, font, text, fontSize, width, height, hPadding, vPadding, descent, lineHeight, annotationStorage) {
                  const combWidth = width / this.data.maxLen;
                  const colors = this.getBorderAndBackgroundAppearances(annotationStorage);
                  const buf = [];
                  const positions = font.getCharPositions(text);
                  for (const [start, end] of positions) {
                    buf.push(`(${(0, _core_utils.escapeString)(text.substring(start, end))}) Tj`);
                  }
                  const renderedComb = buf.join(` ${(0, _core_utils.numberToString)(combWidth)} 0 Td `);
                  return `/Tx BMC q ${colors}BT ` + defaultAppearance + ` 1 0 0 1 ${(0, _core_utils.numberToString)(hPadding)} ${(0, _core_utils.numberToString)(vPadding + descent)} Tm ${renderedComb} ET Q EMC`;
                }
                _getMultilineAppearance(defaultAppearance, lines, font, fontSize, width, height, alignment, hPadding, vPadding, descent, lineHeight, annotationStorage) {
                  const buf = [];
                  const totalWidth = width - 2 * hPadding;
                  const prevInfo = {
                    shift: 0
                  };
                  for (let i = 0, ii = lines.length; i < ii; i++) {
                    const line2 = lines[i];
                    const chunks = this._splitLine(line2, font, fontSize, totalWidth);
                    for (let j = 0, jj = chunks.length; j < jj; j++) {
                      const chunk = chunks[j];
                      const vShift = i === 0 && j === 0 ? -vPadding - (lineHeight - descent) : -lineHeight;
                      buf.push(this._renderText(chunk, font, fontSize, width, alignment, prevInfo, hPadding, vShift));
                    }
                  }
                  const colors = this.getBorderAndBackgroundAppearances(annotationStorage);
                  const renderedText = buf.join("\n");
                  return `/Tx BMC q ${colors}BT ` + defaultAppearance + ` 1 0 0 1 0 ${(0, _core_utils.numberToString)(height)} Tm ${renderedText} ET Q EMC`;
                }
                _splitLine(line2, font, fontSize, width, cache = {}) {
                  line2 = cache.line || line2;
                  const glyphs = cache.glyphs || font.charsToGlyphs(line2);
                  if (glyphs.length <= 1) {
                    return [line2];
                  }
                  const positions = cache.positions || font.getCharPositions(line2);
                  const scale = fontSize / 1e3;
                  const chunks = [];
                  let lastSpacePosInStringStart = -1, lastSpacePosInStringEnd = -1, lastSpacePos = -1, startChunk = 0, currentWidth = 0;
                  for (let i = 0, ii = glyphs.length; i < ii; i++) {
                    const [start, end] = positions[i];
                    const glyph = glyphs[i];
                    const glyphWidth = glyph.width * scale;
                    if (glyph.unicode === " ") {
                      if (currentWidth + glyphWidth > width) {
                        chunks.push(line2.substring(startChunk, start));
                        startChunk = start;
                        currentWidth = glyphWidth;
                        lastSpacePosInStringStart = -1;
                        lastSpacePos = -1;
                      } else {
                        currentWidth += glyphWidth;
                        lastSpacePosInStringStart = start;
                        lastSpacePosInStringEnd = end;
                        lastSpacePos = i;
                      }
                    } else if (currentWidth + glyphWidth > width) {
                      if (lastSpacePosInStringStart !== -1) {
                        chunks.push(line2.substring(startChunk, lastSpacePosInStringEnd));
                        startChunk = lastSpacePosInStringEnd;
                        i = lastSpacePos + 1;
                        lastSpacePosInStringStart = -1;
                        currentWidth = 0;
                      } else {
                        chunks.push(line2.substring(startChunk, start));
                        startChunk = start;
                        currentWidth = glyphWidth;
                      }
                    } else {
                      currentWidth += glyphWidth;
                    }
                  }
                  if (startChunk < line2.length) {
                    chunks.push(line2.substring(startChunk, line2.length));
                  }
                  return chunks;
                }
                getFieldObject() {
                  return {
                    id: this.data.id,
                    value: this.data.fieldValue,
                    defaultValue: this.data.defaultFieldValue || "",
                    multiline: this.data.multiLine,
                    password: this.hasFieldFlag(_util2.AnnotationFieldFlag.PASSWORD),
                    charLimit: this.data.maxLen,
                    comb: this.data.comb,
                    editable: !this.data.readOnly,
                    hidden: this.data.hidden,
                    name: this.data.fieldName,
                    rect: this.data.rect,
                    actions: this.data.actions,
                    page: this.data.pageIndex,
                    strokeColor: this.data.borderColor,
                    fillColor: this.data.backgroundColor,
                    rotation: this.rotation,
                    type: "text"
                  };
                }
              }
              class ButtonWidgetAnnotation extends WidgetAnnotation {
                constructor(params) {
                  super(params);
                  this.checkedAppearance = null;
                  this.uncheckedAppearance = null;
                  this.data.checkBox = !this.hasFieldFlag(_util2.AnnotationFieldFlag.RADIO) && !this.hasFieldFlag(_util2.AnnotationFieldFlag.PUSHBUTTON);
                  this.data.radioButton = this.hasFieldFlag(_util2.AnnotationFieldFlag.RADIO) && !this.hasFieldFlag(_util2.AnnotationFieldFlag.PUSHBUTTON);
                  this.data.pushButton = this.hasFieldFlag(_util2.AnnotationFieldFlag.PUSHBUTTON);
                  this.data.isTooltipOnly = false;
                  if (this.data.checkBox) {
                    this._processCheckBox(params);
                  } else if (this.data.radioButton) {
                    this._processRadioButton(params);
                  } else if (this.data.pushButton) {
                    this.data.hasOwnCanvas = true;
                    this._processPushButton(params);
                  } else {
                    (0, _util2.warn)("Invalid field flags for button widget annotation");
                  }
                }
                async getOperatorList(evaluator, task, intent, renderForms, annotationStorage) {
                  if (this.data.pushButton) {
                    return super.getOperatorList(evaluator, task, intent, false, annotationStorage);
                  }
                  let value = null;
                  let rotation = null;
                  if (annotationStorage) {
                    const storageEntry = annotationStorage.get(this.data.id);
                    value = storageEntry ? storageEntry.value : null;
                    rotation = storageEntry ? storageEntry.rotation : null;
                  }
                  if (value === null && this.appearance) {
                    return super.getOperatorList(evaluator, task, intent, renderForms, annotationStorage);
                  }
                  if (value === null || value === void 0) {
                    value = this.data.checkBox ? this.data.fieldValue === this.data.exportValue : this.data.fieldValue === this.data.buttonValue;
                  }
                  const appearance = value ? this.checkedAppearance : this.uncheckedAppearance;
                  if (appearance) {
                    const savedAppearance = this.appearance;
                    const savedMatrix = appearance.dict.getArray("Matrix") || _util2.IDENTITY_MATRIX;
                    if (rotation) {
                      appearance.dict.set("Matrix", this.getRotationMatrix(annotationStorage));
                    }
                    this.appearance = appearance;
                    const operatorList = super.getOperatorList(evaluator, task, intent, renderForms, annotationStorage);
                    this.appearance = savedAppearance;
                    appearance.dict.set("Matrix", savedMatrix);
                    return operatorList;
                  }
                  return {
                    opList: new _operator_list.OperatorList(),
                    separateForm: false,
                    separateCanvas: false
                  };
                }
                async save(evaluator, task, annotationStorage) {
                  if (this.data.checkBox) {
                    return this._saveCheckbox(evaluator, task, annotationStorage);
                  }
                  if (this.data.radioButton) {
                    return this._saveRadioButton(evaluator, task, annotationStorage);
                  }
                  return null;
                }
                async _saveCheckbox(evaluator, task, annotationStorage) {
                  if (!annotationStorage) {
                    return null;
                  }
                  const storageEntry = annotationStorage.get(this.data.id);
                  let rotation = storageEntry?.rotation, value = storageEntry?.value;
                  if (rotation === void 0) {
                    if (value === void 0) {
                      return null;
                    }
                    const defaultValue2 = this.data.fieldValue === this.data.exportValue;
                    if (defaultValue2 === value) {
                      return null;
                    }
                  }
                  const dict = evaluator.xref.fetchIfRef(this.ref);
                  if (!(dict instanceof _primitives.Dict)) {
                    return null;
                  }
                  if (rotation === void 0) {
                    rotation = this.rotation;
                  }
                  if (value === void 0) {
                    value = this.data.fieldValue === this.data.exportValue;
                  }
                  const xfa = {
                    path: this.data.fieldName,
                    value: value ? this.data.exportValue : ""
                  };
                  const name = _primitives.Name.get(value ? this.data.exportValue : "Off");
                  dict.set("V", name);
                  dict.set("AS", name);
                  dict.set("M", `D:${(0, _util2.getModificationDate)()}`);
                  const maybeMK = this._getMKDict(rotation);
                  if (maybeMK) {
                    dict.set("MK", maybeMK);
                  }
                  const buffer = [];
                  await (0, _writer.writeObject)(this.ref, dict, buffer, evaluator.xref);
                  return [{
                    ref: this.ref,
                    data: buffer.join(""),
                    xfa
                  }];
                }
                async _saveRadioButton(evaluator, task, annotationStorage) {
                  if (!annotationStorage) {
                    return null;
                  }
                  const storageEntry = annotationStorage.get(this.data.id);
                  let rotation = storageEntry?.rotation, value = storageEntry?.value;
                  if (rotation === void 0) {
                    if (value === void 0) {
                      return null;
                    }
                    const defaultValue2 = this.data.fieldValue === this.data.buttonValue;
                    if (defaultValue2 === value) {
                      return null;
                    }
                  }
                  const dict = evaluator.xref.fetchIfRef(this.ref);
                  if (!(dict instanceof _primitives.Dict)) {
                    return null;
                  }
                  if (value === void 0) {
                    value = this.data.fieldValue === this.data.buttonValue;
                  }
                  if (rotation === void 0) {
                    rotation = this.rotation;
                  }
                  const xfa = {
                    path: this.data.fieldName,
                    value: value ? this.data.buttonValue : ""
                  };
                  const name = _primitives.Name.get(value ? this.data.buttonValue : "Off");
                  const buffer = [];
                  let parentData = null;
                  if (value) {
                    if (this.parent instanceof _primitives.Ref) {
                      const parent2 = evaluator.xref.fetch(this.parent);
                      parent2.set("V", name);
                      await (0, _writer.writeObject)(this.parent, parent2, buffer, evaluator.xref);
                      parentData = buffer.join("");
                      buffer.length = 0;
                    } else if (this.parent instanceof _primitives.Dict) {
                      this.parent.set("V", name);
                    }
                  }
                  dict.set("AS", name);
                  dict.set("M", `D:${(0, _util2.getModificationDate)()}`);
                  const maybeMK = this._getMKDict(rotation);
                  if (maybeMK) {
                    dict.set("MK", maybeMK);
                  }
                  await (0, _writer.writeObject)(this.ref, dict, buffer, evaluator.xref);
                  const newRefs = [{
                    ref: this.ref,
                    data: buffer.join(""),
                    xfa
                  }];
                  if (parentData) {
                    newRefs.push({
                      ref: this.parent,
                      data: parentData,
                      xfa: null
                    });
                  }
                  return newRefs;
                }
                _getDefaultCheckedAppearance(params, type5) {
                  const width = this.data.rect[2] - this.data.rect[0];
                  const height = this.data.rect[3] - this.data.rect[1];
                  const bbox = [0, 0, width, height];
                  const FONT_RATIO = 0.8;
                  const fontSize = Math.min(width, height) * FONT_RATIO;
                  let metrics, char2;
                  if (type5 === "check") {
                    metrics = {
                      width: 0.755 * fontSize,
                      height: 0.705 * fontSize
                    };
                    char2 = "3";
                  } else if (type5 === "disc") {
                    metrics = {
                      width: 0.791 * fontSize,
                      height: 0.705 * fontSize
                    };
                    char2 = "l";
                  } else {
                    (0, _util2.unreachable)(`_getDefaultCheckedAppearance - unsupported type: ${type5}`);
                  }
                  const xShift = (0, _core_utils.numberToString)((width - metrics.width) / 2);
                  const yShift = (0, _core_utils.numberToString)((height - metrics.height) / 2);
                  const appearance = `q BT /PdfJsZaDb ${fontSize} Tf 0 g ${xShift} ${yShift} Td (${char2}) Tj ET Q`;
                  const appearanceStreamDict = new _primitives.Dict(params.xref);
                  appearanceStreamDict.set("FormType", 1);
                  appearanceStreamDict.set("Subtype", _primitives.Name.get("Form"));
                  appearanceStreamDict.set("Type", _primitives.Name.get("XObject"));
                  appearanceStreamDict.set("BBox", bbox);
                  appearanceStreamDict.set("Matrix", [1, 0, 0, 1, 0, 0]);
                  appearanceStreamDict.set("Length", appearance.length);
                  const resources = new _primitives.Dict(params.xref);
                  const font = new _primitives.Dict(params.xref);
                  font.set("PdfJsZaDb", this.fallbackFontDict);
                  resources.set("Font", font);
                  appearanceStreamDict.set("Resources", resources);
                  this.checkedAppearance = new _stream.StringStream(appearance);
                  this.checkedAppearance.dict = appearanceStreamDict;
                  this._streams.push(this.checkedAppearance);
                }
                _processCheckBox(params) {
                  const customAppearance = params.dict.get("AP");
                  if (!(customAppearance instanceof _primitives.Dict)) {
                    return;
                  }
                  const normalAppearance = customAppearance.get("N");
                  if (!(normalAppearance instanceof _primitives.Dict)) {
                    return;
                  }
                  const asValue = this._decodeFormValue(params.dict.get("AS"));
                  if (typeof asValue === "string") {
                    this.data.fieldValue = asValue;
                  }
                  const yes = this.data.fieldValue !== null && this.data.fieldValue !== "Off" ? this.data.fieldValue : "Yes";
                  const exportValues = normalAppearance.getKeys();
                  if (exportValues.length === 0) {
                    exportValues.push("Off", yes);
                  } else if (exportValues.length === 1) {
                    if (exportValues[0] === "Off") {
                      exportValues.push(yes);
                    } else {
                      exportValues.unshift("Off");
                    }
                  } else if (exportValues.includes(yes)) {
                    exportValues.length = 0;
                    exportValues.push("Off", yes);
                  } else {
                    const otherYes = exportValues.find((v) => v !== "Off");
                    exportValues.length = 0;
                    exportValues.push("Off", otherYes);
                  }
                  if (!exportValues.includes(this.data.fieldValue)) {
                    this.data.fieldValue = "Off";
                  }
                  this.data.exportValue = exportValues[1];
                  const checkedAppearance = normalAppearance.get(this.data.exportValue);
                  this.checkedAppearance = checkedAppearance instanceof _base_stream.BaseStream ? checkedAppearance : null;
                  const uncheckedAppearance = normalAppearance.get("Off");
                  this.uncheckedAppearance = uncheckedAppearance instanceof _base_stream.BaseStream ? uncheckedAppearance : null;
                  if (this.checkedAppearance) {
                    this._streams.push(this.checkedAppearance);
                  } else {
                    this._getDefaultCheckedAppearance(params, "check");
                  }
                  if (this.uncheckedAppearance) {
                    this._streams.push(this.uncheckedAppearance);
                  }
                  this._fallbackFontDict = this.fallbackFontDict;
                  if (this.data.defaultFieldValue === null) {
                    this.data.defaultFieldValue = "Off";
                  }
                }
                _processRadioButton(params) {
                  this.data.fieldValue = this.data.buttonValue = null;
                  const fieldParent = params.dict.get("Parent");
                  if (fieldParent instanceof _primitives.Dict) {
                    this.parent = params.dict.getRaw("Parent");
                    const fieldParentValue = fieldParent.get("V");
                    if (fieldParentValue instanceof _primitives.Name) {
                      this.data.fieldValue = this._decodeFormValue(fieldParentValue);
                    }
                  }
                  const appearanceStates = params.dict.get("AP");
                  if (!(appearanceStates instanceof _primitives.Dict)) {
                    return;
                  }
                  const normalAppearance = appearanceStates.get("N");
                  if (!(normalAppearance instanceof _primitives.Dict)) {
                    return;
                  }
                  for (const key2 of normalAppearance.getKeys()) {
                    if (key2 !== "Off") {
                      this.data.buttonValue = this._decodeFormValue(key2);
                      break;
                    }
                  }
                  const checkedAppearance = normalAppearance.get(this.data.buttonValue);
                  this.checkedAppearance = checkedAppearance instanceof _base_stream.BaseStream ? checkedAppearance : null;
                  const uncheckedAppearance = normalAppearance.get("Off");
                  this.uncheckedAppearance = uncheckedAppearance instanceof _base_stream.BaseStream ? uncheckedAppearance : null;
                  if (this.checkedAppearance) {
                    this._streams.push(this.checkedAppearance);
                  } else {
                    this._getDefaultCheckedAppearance(params, "disc");
                  }
                  if (this.uncheckedAppearance) {
                    this._streams.push(this.uncheckedAppearance);
                  }
                  this._fallbackFontDict = this.fallbackFontDict;
                  if (this.data.defaultFieldValue === null) {
                    this.data.defaultFieldValue = "Off";
                  }
                }
                _processPushButton(params) {
                  const {
                    dict,
                    annotationGlobals
                  } = params;
                  if (!dict.has("A") && !dict.has("AA") && !this.data.alternativeText) {
                    (0, _util2.warn)("Push buttons without action dictionaries are not supported");
                    return;
                  }
                  this.data.isTooltipOnly = !dict.has("A") && !dict.has("AA");
                  _catalog.Catalog.parseDestDictionary({
                    destDict: dict,
                    resultObj: this.data,
                    docBaseUrl: annotationGlobals.baseUrl,
                    docAttachments: annotationGlobals.attachments
                  });
                }
                getFieldObject() {
                  let type5 = "button";
                  let exportValues;
                  if (this.data.checkBox) {
                    type5 = "checkbox";
                    exportValues = this.data.exportValue;
                  } else if (this.data.radioButton) {
                    type5 = "radiobutton";
                    exportValues = this.data.buttonValue;
                  }
                  return {
                    id: this.data.id,
                    value: this.data.fieldValue || "Off",
                    defaultValue: this.data.defaultFieldValue,
                    exportValues,
                    editable: !this.data.readOnly,
                    name: this.data.fieldName,
                    rect: this.data.rect,
                    hidden: this.data.hidden,
                    actions: this.data.actions,
                    page: this.data.pageIndex,
                    strokeColor: this.data.borderColor,
                    fillColor: this.data.backgroundColor,
                    rotation: this.rotation,
                    type: type5
                  };
                }
                get fallbackFontDict() {
                  const dict = new _primitives.Dict();
                  dict.set("BaseFont", _primitives.Name.get("ZapfDingbats"));
                  dict.set("Type", _primitives.Name.get("FallbackType"));
                  dict.set("Subtype", _primitives.Name.get("FallbackType"));
                  dict.set("Encoding", _primitives.Name.get("ZapfDingbatsEncoding"));
                  return (0, _util2.shadow)(this, "fallbackFontDict", dict);
                }
              }
              class ChoiceWidgetAnnotation extends WidgetAnnotation {
                constructor(params) {
                  super(params);
                  const {
                    dict,
                    xref
                  } = params;
                  this.indices = dict.getArray("I");
                  this.hasIndices = Array.isArray(this.indices) && this.indices.length > 0;
                  this.data.options = [];
                  const options = (0, _core_utils.getInheritableProperty)({
                    dict,
                    key: "Opt"
                  });
                  if (Array.isArray(options)) {
                    for (let i = 0, ii = options.length; i < ii; i++) {
                      const option = xref.fetchIfRef(options[i]);
                      const isOptionArray = Array.isArray(option);
                      this.data.options[i] = {
                        exportValue: this._decodeFormValue(isOptionArray ? xref.fetchIfRef(option[0]) : option),
                        displayValue: this._decodeFormValue(isOptionArray ? xref.fetchIfRef(option[1]) : option)
                      };
                    }
                  }
                  if (!this.hasIndices) {
                    if (typeof this.data.fieldValue === "string") {
                      this.data.fieldValue = [this.data.fieldValue];
                    } else if (!this.data.fieldValue) {
                      this.data.fieldValue = [];
                    }
                  } else {
                    this.data.fieldValue = [];
                    const ii = this.data.options.length;
                    for (const i of this.indices) {
                      if (Number.isInteger(i) && i >= 0 && i < ii) {
                        this.data.fieldValue.push(this.data.options[i].exportValue);
                      }
                    }
                  }
                  this.data.combo = this.hasFieldFlag(_util2.AnnotationFieldFlag.COMBO);
                  this.data.multiSelect = this.hasFieldFlag(_util2.AnnotationFieldFlag.MULTISELECT);
                  this._hasText = true;
                }
                getFieldObject() {
                  const type5 = this.data.combo ? "combobox" : "listbox";
                  const value = this.data.fieldValue.length > 0 ? this.data.fieldValue[0] : null;
                  return {
                    id: this.data.id,
                    value,
                    defaultValue: this.data.defaultFieldValue,
                    editable: !this.data.readOnly,
                    name: this.data.fieldName,
                    rect: this.data.rect,
                    numItems: this.data.fieldValue.length,
                    multipleSelection: this.data.multiSelect,
                    hidden: this.data.hidden,
                    actions: this.data.actions,
                    items: this.data.options,
                    page: this.data.pageIndex,
                    strokeColor: this.data.borderColor,
                    fillColor: this.data.backgroundColor,
                    rotation: this.rotation,
                    type: type5
                  };
                }
                amendSavedDict(annotationStorage, dict) {
                  if (!this.hasIndices) {
                    return;
                  }
                  let values = annotationStorage?.get(this.data.id)?.value;
                  if (!Array.isArray(values)) {
                    values = [values];
                  }
                  const indices = [];
                  const {
                    options
                  } = this.data;
                  for (let i = 0, j = 0, ii = options.length; i < ii; i++) {
                    if (options[i].exportValue === values[j]) {
                      indices.push(i);
                      j += 1;
                    }
                  }
                  dict.set("I", indices);
                }
                async _getAppearance(evaluator, task, intent, annotationStorage) {
                  if (this.data.combo) {
                    return super._getAppearance(evaluator, task, intent, annotationStorage);
                  }
                  let exportedValue, rotation;
                  const storageEntry = annotationStorage?.get(this.data.id);
                  if (storageEntry) {
                    rotation = storageEntry.rotation;
                    exportedValue = storageEntry.value;
                  }
                  if (rotation === void 0 && exportedValue === void 0 && !this._needAppearances) {
                    return null;
                  }
                  if (exportedValue === void 0) {
                    exportedValue = this.data.fieldValue;
                  } else if (!Array.isArray(exportedValue)) {
                    exportedValue = [exportedValue];
                  }
                  const defaultPadding = 1;
                  const defaultHPadding = 2;
                  let totalHeight = this.data.rect[3] - this.data.rect[1];
                  let totalWidth = this.data.rect[2] - this.data.rect[0];
                  if (rotation === 90 || rotation === 270) {
                    [totalWidth, totalHeight] = [totalHeight, totalWidth];
                  }
                  const lineCount = this.data.options.length;
                  const valueIndices = [];
                  for (let i = 0; i < lineCount; i++) {
                    const {
                      exportValue
                    } = this.data.options[i];
                    if (exportedValue.includes(exportValue)) {
                      valueIndices.push(i);
                    }
                  }
                  if (!this._defaultAppearance) {
                    this.data.defaultAppearanceData = (0, _default_appearance.parseDefaultAppearance)(this._defaultAppearance = "/Helvetica 0 Tf 0 g");
                  }
                  const font = await WidgetAnnotation._getFontData(evaluator, task, this.data.defaultAppearanceData, this._fieldResources.mergedResources);
                  let defaultAppearance;
                  let {
                    fontSize
                  } = this.data.defaultAppearanceData;
                  if (!fontSize) {
                    const lineHeight2 = (totalHeight - defaultPadding) / lineCount;
                    let lineWidth = -1;
                    let value;
                    for (const {
                      displayValue
                    } of this.data.options) {
                      const width = this._getTextWidth(displayValue, font);
                      if (width > lineWidth) {
                        lineWidth = width;
                        value = displayValue;
                      }
                    }
                    [defaultAppearance, fontSize] = this._computeFontSize(lineHeight2, totalWidth - 2 * defaultHPadding, value, font, -1);
                  } else {
                    defaultAppearance = this._defaultAppearance;
                  }
                  const lineHeight = fontSize * _util2.LINE_FACTOR;
                  const vPadding = (lineHeight - fontSize) / 2;
                  const numberOfVisibleLines = Math.floor(totalHeight / lineHeight);
                  let firstIndex = 0;
                  if (valueIndices.length > 0) {
                    const minIndex = Math.min(...valueIndices);
                    const maxIndex = Math.max(...valueIndices);
                    firstIndex = Math.max(0, maxIndex - numberOfVisibleLines + 1);
                    if (firstIndex > minIndex) {
                      firstIndex = minIndex;
                    }
                  }
                  const end = Math.min(firstIndex + numberOfVisibleLines + 1, lineCount);
                  const buf = ["/Tx BMC q", `1 1 ${totalWidth} ${totalHeight} re W n`];
                  if (valueIndices.length) {
                    buf.push("0.600006 0.756866 0.854904 rg");
                    for (const index3 of valueIndices) {
                      if (firstIndex <= index3 && index3 < end) {
                        buf.push(`1 ${totalHeight - (index3 - firstIndex + 1) * lineHeight} ${totalWidth} ${lineHeight} re f`);
                      }
                    }
                  }
                  buf.push("BT", defaultAppearance, `1 0 0 1 0 ${totalHeight} Tm`);
                  const prevInfo = {
                    shift: 0
                  };
                  for (let i = firstIndex; i < end; i++) {
                    const {
                      displayValue
                    } = this.data.options[i];
                    const vpadding = i === firstIndex ? vPadding : 0;
                    buf.push(this._renderText(displayValue, font, fontSize, totalWidth, 0, prevInfo, defaultHPadding, -lineHeight + vpadding));
                  }
                  buf.push("ET Q EMC");
                  return buf.join("\n");
                }
              }
              class SignatureWidgetAnnotation extends WidgetAnnotation {
                constructor(params) {
                  super(params);
                  this.data.fieldValue = null;
                  this.data.hasOwnCanvas = this.data.noRotate;
                }
                getFieldObject() {
                  return {
                    id: this.data.id,
                    value: null,
                    page: this.data.pageIndex,
                    type: "signature"
                  };
                }
              }
              class TextAnnotation extends MarkupAnnotation {
                constructor(params) {
                  const DEFAULT_ICON_SIZE = 22;
                  super(params);
                  this.data.noRotate = true;
                  this.data.hasOwnCanvas = this.data.noRotate;
                  const {
                    dict
                  } = params;
                  this.data.annotationType = _util2.AnnotationType.TEXT;
                  if (this.data.hasAppearance) {
                    this.data.name = "NoIcon";
                  } else {
                    this.data.rect[1] = this.data.rect[3] - DEFAULT_ICON_SIZE;
                    this.data.rect[2] = this.data.rect[0] + DEFAULT_ICON_SIZE;
                    this.data.name = dict.has("Name") ? dict.get("Name").name : "Note";
                  }
                  if (dict.has("State")) {
                    this.data.state = dict.get("State") || null;
                    this.data.stateModel = dict.get("StateModel") || null;
                  } else {
                    this.data.state = null;
                    this.data.stateModel = null;
                  }
                }
              }
              class LinkAnnotation extends Annotation {
                constructor(params) {
                  super(params);
                  const {
                    dict,
                    annotationGlobals
                  } = params;
                  this.data.annotationType = _util2.AnnotationType.LINK;
                  const quadPoints = getQuadPoints(dict, this.rectangle);
                  if (quadPoints) {
                    this.data.quadPoints = quadPoints;
                  }
                  this.data.borderColor ||= this.data.color;
                  _catalog.Catalog.parseDestDictionary({
                    destDict: dict,
                    resultObj: this.data,
                    docBaseUrl: annotationGlobals.baseUrl,
                    docAttachments: annotationGlobals.attachments
                  });
                }
              }
              class PopupAnnotation extends Annotation {
                constructor(params) {
                  super(params);
                  const {
                    dict
                  } = params;
                  this.data.annotationType = _util2.AnnotationType.POPUP;
                  if (this.data.rect[0] === this.data.rect[2] || this.data.rect[1] === this.data.rect[3]) {
                    this.data.rect = null;
                  }
                  let parentItem = dict.get("Parent");
                  if (!parentItem) {
                    (0, _util2.warn)("Popup annotation has a missing or invalid parent annotation.");
                    return;
                  }
                  const parentRect = parentItem.getArray("Rect");
                  this.data.parentRect = Array.isArray(parentRect) && parentRect.length === 4 ? _util2.Util.normalizeRect(parentRect) : null;
                  const rt = parentItem.get("RT");
                  if ((0, _primitives.isName)(rt, _util2.AnnotationReplyType.GROUP)) {
                    parentItem = parentItem.get("IRT");
                  }
                  if (!parentItem.has("M")) {
                    this.data.modificationDate = null;
                  } else {
                    this.setModificationDate(parentItem.get("M"));
                    this.data.modificationDate = this.modificationDate;
                  }
                  if (!parentItem.has("C")) {
                    this.data.color = null;
                  } else {
                    this.setColor(parentItem.getArray("C"));
                    this.data.color = this.color;
                  }
                  if (!this.viewable) {
                    const parentFlags = parentItem.get("F");
                    if (this._isViewable(parentFlags)) {
                      this.setFlags(parentFlags);
                    }
                  }
                  this.setTitle(parentItem.get("T"));
                  this.data.titleObj = this._title;
                  this.setContents(parentItem.get("Contents"));
                  this.data.contentsObj = this._contents;
                  if (parentItem.has("RC")) {
                    this.data.richText = _factory.XFAFactory.getRichTextAsHtml(parentItem.get("RC"));
                  }
                  this.data.open = !!dict.get("Open");
                }
              }
              exports3.PopupAnnotation = PopupAnnotation;
              class FreeTextAnnotation extends MarkupAnnotation {
                constructor(params) {
                  super(params);
                  this.data.hasOwnCanvas = true;
                  const {
                    evaluatorOptions,
                    xref
                  } = params;
                  this.data.annotationType = _util2.AnnotationType.FREETEXT;
                  this.setDefaultAppearance(params);
                  if (this.appearance) {
                    const {
                      fontColor,
                      fontSize
                    } = (0, _default_appearance.parseAppearanceStream)(this.appearance, evaluatorOptions, xref);
                    this.data.defaultAppearanceData.fontColor = fontColor;
                    this.data.defaultAppearanceData.fontSize = fontSize || 10;
                  } else if (this._isOffscreenCanvasSupported) {
                    const strokeAlpha = params.dict.get("CA");
                    const fakeUnicodeFont = new _default_appearance.FakeUnicodeFont(xref, "sans-serif");
                    this.data.defaultAppearanceData.fontSize ||= 10;
                    const {
                      fontColor,
                      fontSize
                    } = this.data.defaultAppearanceData;
                    this.appearance = fakeUnicodeFont.createAppearance(this._contents.str, this.rectangle, this.rotation, fontSize, fontColor, strokeAlpha);
                    this._streams.push(this.appearance, _default_appearance.FakeUnicodeFont.toUnicodeStream);
                  } else {
                    (0, _util2.warn)("FreeTextAnnotation: OffscreenCanvas is not supported, annotation may not render correctly.");
                  }
                }
                get hasTextContent() {
                  return !!this.appearance;
                }
                static createNewDict(annotation, xref, {
                  apRef,
                  ap
                }) {
                  const {
                    color,
                    fontSize,
                    rect,
                    rotation,
                    user,
                    value
                  } = annotation;
                  const freetext = new _primitives.Dict(xref);
                  freetext.set("Type", _primitives.Name.get("Annot"));
                  freetext.set("Subtype", _primitives.Name.get("FreeText"));
                  freetext.set("CreationDate", `D:${(0, _util2.getModificationDate)()}`);
                  freetext.set("Rect", rect);
                  const da = `/Helv ${fontSize} Tf ${(0, _default_appearance.getPdfColor)(color, true)}`;
                  freetext.set("DA", da);
                  freetext.set("Contents", (0, _core_utils.isAscii)(value) ? value : (0, _core_utils.stringToUTF16String)(value, true));
                  freetext.set("F", 4);
                  freetext.set("Border", [0, 0, 0]);
                  freetext.set("Rotate", rotation);
                  if (user) {
                    freetext.set("T", (0, _core_utils.isAscii)(user) ? user : (0, _core_utils.stringToUTF16String)(user, true));
                  }
                  if (apRef || ap) {
                    const n2 = new _primitives.Dict(xref);
                    freetext.set("AP", n2);
                    if (apRef) {
                      n2.set("N", apRef);
                    } else {
                      n2.set("N", ap);
                    }
                  }
                  return freetext;
                }
                static async createNewAppearanceStream(annotation, xref, params) {
                  const {
                    baseFontRef,
                    evaluator,
                    task
                  } = params;
                  const {
                    color,
                    fontSize,
                    rect,
                    rotation,
                    value
                  } = annotation;
                  const resources = new _primitives.Dict(xref);
                  const font = new _primitives.Dict(xref);
                  if (baseFontRef) {
                    font.set("Helv", baseFontRef);
                  } else {
                    const baseFont = new _primitives.Dict(xref);
                    baseFont.set("BaseFont", _primitives.Name.get("Helvetica"));
                    baseFont.set("Type", _primitives.Name.get("Font"));
                    baseFont.set("Subtype", _primitives.Name.get("Type1"));
                    baseFont.set("Encoding", _primitives.Name.get("WinAnsiEncoding"));
                    font.set("Helv", baseFont);
                  }
                  resources.set("Font", font);
                  const helv = await WidgetAnnotation._getFontData(evaluator, task, {
                    fontName: "Helv",
                    fontSize
                  }, resources);
                  const [x1, y1, x2, y2] = rect;
                  let w = x2 - x1;
                  let h2 = y2 - y1;
                  if (rotation % 180 !== 0) {
                    [w, h2] = [h2, w];
                  }
                  const lines = value.split("\n");
                  const scale = fontSize / 1e3;
                  let totalWidth = -Infinity;
                  const encodedLines = [];
                  for (let line2 of lines) {
                    const encoded = helv.encodeString(line2);
                    if (encoded.length > 1) {
                      return null;
                    }
                    line2 = encoded.join("");
                    encodedLines.push(line2);
                    let lineWidth = 0;
                    const glyphs = helv.charsToGlyphs(line2);
                    for (const glyph of glyphs) {
                      lineWidth += glyph.width * scale;
                    }
                    totalWidth = Math.max(totalWidth, lineWidth);
                  }
                  let hscale = 1;
                  if (totalWidth > w) {
                    hscale = w / totalWidth;
                  }
                  let vscale = 1;
                  const lineHeight = _util2.LINE_FACTOR * fontSize;
                  const lineAscent = (_util2.LINE_FACTOR - _util2.LINE_DESCENT_FACTOR) * fontSize;
                  const totalHeight = lineHeight * lines.length;
                  if (totalHeight > h2) {
                    vscale = h2 / totalHeight;
                  }
                  const fscale = Math.min(hscale, vscale);
                  const newFontSize = fontSize * fscale;
                  let firstPoint, clipBox, matrix;
                  switch (rotation) {
                    case 0:
                      matrix = [1, 0, 0, 1];
                      clipBox = [rect[0], rect[1], w, h2];
                      firstPoint = [rect[0], rect[3] - lineAscent];
                      break;
                    case 90:
                      matrix = [0, 1, -1, 0];
                      clipBox = [rect[1], -rect[2], w, h2];
                      firstPoint = [rect[1], -rect[0] - lineAscent];
                      break;
                    case 180:
                      matrix = [-1, 0, 0, -1];
                      clipBox = [-rect[2], -rect[3], w, h2];
                      firstPoint = [-rect[2], -rect[1] - lineAscent];
                      break;
                    case 270:
                      matrix = [0, -1, 1, 0];
                      clipBox = [-rect[3], rect[0], w, h2];
                      firstPoint = [-rect[3], rect[2] - lineAscent];
                      break;
                  }
                  const buffer = ["q", `${matrix.join(" ")} 0 0 cm`, `${clipBox.join(" ")} re W n`, `BT`, `${(0, _default_appearance.getPdfColor)(color, true)}`, `0 Tc /Helv ${(0, _core_utils.numberToString)(newFontSize)} Tf`];
                  buffer.push(`${firstPoint.join(" ")} Td (${(0, _core_utils.escapeString)(encodedLines[0])}) Tj`);
                  const vShift = (0, _core_utils.numberToString)(lineHeight);
                  for (let i = 1, ii = encodedLines.length; i < ii; i++) {
                    const line2 = encodedLines[i];
                    buffer.push(`0 -${vShift} Td (${(0, _core_utils.escapeString)(line2)}) Tj`);
                  }
                  buffer.push("ET", "Q");
                  const appearance = buffer.join("\n");
                  const appearanceStreamDict = new _primitives.Dict(xref);
                  appearanceStreamDict.set("FormType", 1);
                  appearanceStreamDict.set("Subtype", _primitives.Name.get("Form"));
                  appearanceStreamDict.set("Type", _primitives.Name.get("XObject"));
                  appearanceStreamDict.set("BBox", rect);
                  appearanceStreamDict.set("Resources", resources);
                  appearanceStreamDict.set("Matrix", [1, 0, 0, 1, -rect[0], -rect[1]]);
                  const ap = new _stream.StringStream(appearance);
                  ap.dict = appearanceStreamDict;
                  return ap;
                }
              }
              class LineAnnotation extends MarkupAnnotation {
                constructor(params) {
                  super(params);
                  const {
                    dict,
                    xref
                  } = params;
                  this.data.annotationType = _util2.AnnotationType.LINE;
                  this.data.hasOwnCanvas = this.data.noRotate;
                  const lineCoordinates = dict.getArray("L");
                  this.data.lineCoordinates = _util2.Util.normalizeRect(lineCoordinates);
                  this.setLineEndings(dict.getArray("LE"));
                  this.data.lineEndings = this.lineEndings;
                  if (!this.appearance) {
                    const strokeColor = this.color ? getPdfColorArray(this.color) : [0, 0, 0];
                    const strokeAlpha = dict.get("CA");
                    const interiorColor = getRgbColor(dict.getArray("IC"), null);
                    const fillColor = interiorColor ? getPdfColorArray(interiorColor) : null;
                    const fillAlpha = fillColor ? strokeAlpha : null;
                    const borderWidth2 = this.borderStyle.width || 1, borderAdjust = 2 * borderWidth2;
                    const bbox = [this.data.lineCoordinates[0] - borderAdjust, this.data.lineCoordinates[1] - borderAdjust, this.data.lineCoordinates[2] + borderAdjust, this.data.lineCoordinates[3] + borderAdjust];
                    if (!_util2.Util.intersect(this.rectangle, bbox)) {
                      this.rectangle = bbox;
                    }
                    this._setDefaultAppearance({
                      xref,
                      extra: `${borderWidth2} w`,
                      strokeColor,
                      fillColor,
                      strokeAlpha,
                      fillAlpha,
                      pointsCallback: (buffer, points) => {
                        buffer.push(`${lineCoordinates[0]} ${lineCoordinates[1]} m`, `${lineCoordinates[2]} ${lineCoordinates[3]} l`, "S");
                        return [points[0].x - borderWidth2, points[1].x + borderWidth2, points[3].y - borderWidth2, points[1].y + borderWidth2];
                      }
                    });
                  }
                }
              }
              class SquareAnnotation extends MarkupAnnotation {
                constructor(params) {
                  super(params);
                  const {
                    dict,
                    xref
                  } = params;
                  this.data.annotationType = _util2.AnnotationType.SQUARE;
                  this.data.hasOwnCanvas = this.data.noRotate;
                  if (!this.appearance) {
                    const strokeColor = this.color ? getPdfColorArray(this.color) : [0, 0, 0];
                    const strokeAlpha = dict.get("CA");
                    const interiorColor = getRgbColor(dict.getArray("IC"), null);
                    const fillColor = interiorColor ? getPdfColorArray(interiorColor) : null;
                    const fillAlpha = fillColor ? strokeAlpha : null;
                    if (this.borderStyle.width === 0 && !fillColor) {
                      return;
                    }
                    this._setDefaultAppearance({
                      xref,
                      extra: `${this.borderStyle.width} w`,
                      strokeColor,
                      fillColor,
                      strokeAlpha,
                      fillAlpha,
                      pointsCallback: (buffer, points) => {
                        const x = points[2].x + this.borderStyle.width / 2;
                        const y = points[2].y + this.borderStyle.width / 2;
                        const width = points[3].x - points[2].x - this.borderStyle.width;
                        const height = points[1].y - points[3].y - this.borderStyle.width;
                        buffer.push(`${x} ${y} ${width} ${height} re`);
                        if (fillColor) {
                          buffer.push("B");
                        } else {
                          buffer.push("S");
                        }
                        return [points[0].x, points[1].x, points[3].y, points[1].y];
                      }
                    });
                  }
                }
              }
              class CircleAnnotation extends MarkupAnnotation {
                constructor(params) {
                  super(params);
                  const {
                    dict,
                    xref
                  } = params;
                  this.data.annotationType = _util2.AnnotationType.CIRCLE;
                  if (!this.appearance) {
                    const strokeColor = this.color ? getPdfColorArray(this.color) : [0, 0, 0];
                    const strokeAlpha = dict.get("CA");
                    const interiorColor = getRgbColor(dict.getArray("IC"), null);
                    const fillColor = interiorColor ? getPdfColorArray(interiorColor) : null;
                    const fillAlpha = fillColor ? strokeAlpha : null;
                    if (this.borderStyle.width === 0 && !fillColor) {
                      return;
                    }
                    const controlPointsDistance = 4 / 3 * Math.tan(Math.PI / (2 * 4));
                    this._setDefaultAppearance({
                      xref,
                      extra: `${this.borderStyle.width} w`,
                      strokeColor,
                      fillColor,
                      strokeAlpha,
                      fillAlpha,
                      pointsCallback: (buffer, points) => {
                        const x0 = points[0].x + this.borderStyle.width / 2;
                        const y0 = points[0].y - this.borderStyle.width / 2;
                        const x1 = points[3].x - this.borderStyle.width / 2;
                        const y1 = points[3].y + this.borderStyle.width / 2;
                        const xMid = x0 + (x1 - x0) / 2;
                        const yMid = y0 + (y1 - y0) / 2;
                        const xOffset = (x1 - x0) / 2 * controlPointsDistance;
                        const yOffset = (y1 - y0) / 2 * controlPointsDistance;
                        buffer.push(`${xMid} ${y1} m`, `${xMid + xOffset} ${y1} ${x1} ${yMid + yOffset} ${x1} ${yMid} c`, `${x1} ${yMid - yOffset} ${xMid + xOffset} ${y0} ${xMid} ${y0} c`, `${xMid - xOffset} ${y0} ${x0} ${yMid - yOffset} ${x0} ${yMid} c`, `${x0} ${yMid + yOffset} ${xMid - xOffset} ${y1} ${xMid} ${y1} c`, "h");
                        if (fillColor) {
                          buffer.push("B");
                        } else {
                          buffer.push("S");
                        }
                        return [points[0].x, points[1].x, points[3].y, points[1].y];
                      }
                    });
                  }
                }
              }
              class PolylineAnnotation extends MarkupAnnotation {
                constructor(params) {
                  super(params);
                  const {
                    dict,
                    xref
                  } = params;
                  this.data.annotationType = _util2.AnnotationType.POLYLINE;
                  this.data.hasOwnCanvas = this.data.noRotate;
                  this.data.vertices = [];
                  if (!(this instanceof PolygonAnnotation)) {
                    this.setLineEndings(dict.getArray("LE"));
                    this.data.lineEndings = this.lineEndings;
                  }
                  const rawVertices = dict.getArray("Vertices");
                  if (!Array.isArray(rawVertices)) {
                    return;
                  }
                  for (let i = 0, ii = rawVertices.length; i < ii; i += 2) {
                    this.data.vertices.push({
                      x: rawVertices[i],
                      y: rawVertices[i + 1]
                    });
                  }
                  if (!this.appearance) {
                    const strokeColor = this.color ? getPdfColorArray(this.color) : [0, 0, 0];
                    const strokeAlpha = dict.get("CA");
                    const borderWidth2 = this.borderStyle.width || 1, borderAdjust = 2 * borderWidth2;
                    const bbox = [Infinity, Infinity, -Infinity, -Infinity];
                    for (const vertex of this.data.vertices) {
                      bbox[0] = Math.min(bbox[0], vertex.x - borderAdjust);
                      bbox[1] = Math.min(bbox[1], vertex.y - borderAdjust);
                      bbox[2] = Math.max(bbox[2], vertex.x + borderAdjust);
                      bbox[3] = Math.max(bbox[3], vertex.y + borderAdjust);
                    }
                    if (!_util2.Util.intersect(this.rectangle, bbox)) {
                      this.rectangle = bbox;
                    }
                    this._setDefaultAppearance({
                      xref,
                      extra: `${borderWidth2} w`,
                      strokeColor,
                      strokeAlpha,
                      pointsCallback: (buffer, points) => {
                        const vertices = this.data.vertices;
                        for (let i = 0, ii = vertices.length; i < ii; i++) {
                          buffer.push(`${vertices[i].x} ${vertices[i].y} ${i === 0 ? "m" : "l"}`);
                        }
                        buffer.push("S");
                        return [points[0].x, points[1].x, points[3].y, points[1].y];
                      }
                    });
                  }
                }
              }
              class PolygonAnnotation extends PolylineAnnotation {
                constructor(params) {
                  super(params);
                  this.data.annotationType = _util2.AnnotationType.POLYGON;
                }
              }
              class CaretAnnotation extends MarkupAnnotation {
                constructor(params) {
                  super(params);
                  this.data.annotationType = _util2.AnnotationType.CARET;
                }
              }
              class InkAnnotation extends MarkupAnnotation {
                constructor(params) {
                  super(params);
                  this.data.hasOwnCanvas = this.data.noRotate;
                  const {
                    dict,
                    xref
                  } = params;
                  this.data.annotationType = _util2.AnnotationType.INK;
                  this.data.inkLists = [];
                  const rawInkLists = dict.getArray("InkList");
                  if (!Array.isArray(rawInkLists)) {
                    return;
                  }
                  for (let i = 0, ii = rawInkLists.length; i < ii; ++i) {
                    this.data.inkLists.push([]);
                    for (let j = 0, jj = rawInkLists[i].length; j < jj; j += 2) {
                      this.data.inkLists[i].push({
                        x: xref.fetchIfRef(rawInkLists[i][j]),
                        y: xref.fetchIfRef(rawInkLists[i][j + 1])
                      });
                    }
                  }
                  if (!this.appearance) {
                    const strokeColor = this.color ? getPdfColorArray(this.color) : [0, 0, 0];
                    const strokeAlpha = dict.get("CA");
                    const borderWidth2 = this.borderStyle.width || 1, borderAdjust = 2 * borderWidth2;
                    const bbox = [Infinity, Infinity, -Infinity, -Infinity];
                    for (const inkLists of this.data.inkLists) {
                      for (const vertex of inkLists) {
                        bbox[0] = Math.min(bbox[0], vertex.x - borderAdjust);
                        bbox[1] = Math.min(bbox[1], vertex.y - borderAdjust);
                        bbox[2] = Math.max(bbox[2], vertex.x + borderAdjust);
                        bbox[3] = Math.max(bbox[3], vertex.y + borderAdjust);
                      }
                    }
                    if (!_util2.Util.intersect(this.rectangle, bbox)) {
                      this.rectangle = bbox;
                    }
                    this._setDefaultAppearance({
                      xref,
                      extra: `${borderWidth2} w`,
                      strokeColor,
                      strokeAlpha,
                      pointsCallback: (buffer, points) => {
                        for (const inkList of this.data.inkLists) {
                          for (let i = 0, ii = inkList.length; i < ii; i++) {
                            buffer.push(`${inkList[i].x} ${inkList[i].y} ${i === 0 ? "m" : "l"}`);
                          }
                          buffer.push("S");
                        }
                        return [points[0].x, points[1].x, points[3].y, points[1].y];
                      }
                    });
                  }
                }
                static createNewDict(annotation, xref, {
                  apRef,
                  ap
                }) {
                  const {
                    color,
                    opacity,
                    paths,
                    rect,
                    rotation,
                    thickness
                  } = annotation;
                  const ink = new _primitives.Dict(xref);
                  ink.set("Type", _primitives.Name.get("Annot"));
                  ink.set("Subtype", _primitives.Name.get("Ink"));
                  ink.set("CreationDate", `D:${(0, _util2.getModificationDate)()}`);
                  ink.set("Rect", rect);
                  ink.set("InkList", paths.map((p) => p.points));
                  ink.set("F", 4);
                  ink.set("Rotate", rotation);
                  const bs = new _primitives.Dict(xref);
                  ink.set("BS", bs);
                  bs.set("W", thickness);
                  ink.set("C", Array.from(color, (c) => c / 255));
                  ink.set("CA", opacity);
                  const n2 = new _primitives.Dict(xref);
                  ink.set("AP", n2);
                  if (apRef) {
                    n2.set("N", apRef);
                  } else {
                    n2.set("N", ap);
                  }
                  return ink;
                }
                static async createNewAppearanceStream(annotation, xref, params) {
                  const {
                    color,
                    rect,
                    paths,
                    thickness,
                    opacity
                  } = annotation;
                  const appearanceBuffer = [`${thickness} w 1 J 1 j`, `${(0, _default_appearance.getPdfColor)(color, false)}`];
                  if (opacity !== 1) {
                    appearanceBuffer.push("/R0 gs");
                  }
                  const buffer = [];
                  for (const {
                    bezier
                  } of paths) {
                    buffer.length = 0;
                    buffer.push(`${(0, _core_utils.numberToString)(bezier[0])} ${(0, _core_utils.numberToString)(bezier[1])} m`);
                    for (let i = 2, ii = bezier.length; i < ii; i += 6) {
                      const curve = bezier.slice(i, i + 6).map(_core_utils.numberToString).join(" ");
                      buffer.push(`${curve} c`);
                    }
                    buffer.push("S");
                    appearanceBuffer.push(buffer.join("\n"));
                  }
                  const appearance = appearanceBuffer.join("\n");
                  const appearanceStreamDict = new _primitives.Dict(xref);
                  appearanceStreamDict.set("FormType", 1);
                  appearanceStreamDict.set("Subtype", _primitives.Name.get("Form"));
                  appearanceStreamDict.set("Type", _primitives.Name.get("XObject"));
                  appearanceStreamDict.set("BBox", rect);
                  appearanceStreamDict.set("Length", appearance.length);
                  if (opacity !== 1) {
                    const resources = new _primitives.Dict(xref);
                    const extGState = new _primitives.Dict(xref);
                    const r0 = new _primitives.Dict(xref);
                    r0.set("CA", opacity);
                    r0.set("Type", _primitives.Name.get("ExtGState"));
                    extGState.set("R0", r0);
                    resources.set("ExtGState", extGState);
                    appearanceStreamDict.set("Resources", resources);
                  }
                  const ap = new _stream.StringStream(appearance);
                  ap.dict = appearanceStreamDict;
                  return ap;
                }
              }
              class HighlightAnnotation extends MarkupAnnotation {
                constructor(params) {
                  super(params);
                  const {
                    dict,
                    xref
                  } = params;
                  this.data.annotationType = _util2.AnnotationType.HIGHLIGHT;
                  const quadPoints = this.data.quadPoints = getQuadPoints(dict, null);
                  if (quadPoints) {
                    const resources = this.appearance?.dict.get("Resources");
                    if (!this.appearance || !resources?.has("ExtGState")) {
                      if (this.appearance) {
                        (0, _util2.warn)("HighlightAnnotation - ignoring built-in appearance stream.");
                      }
                      const fillColor = this.color ? getPdfColorArray(this.color) : [1, 1, 0];
                      const fillAlpha = dict.get("CA");
                      this._setDefaultAppearance({
                        xref,
                        fillColor,
                        blendMode: "Multiply",
                        fillAlpha,
                        pointsCallback: (buffer, points) => {
                          buffer.push(`${points[0].x} ${points[0].y} m`, `${points[1].x} ${points[1].y} l`, `${points[3].x} ${points[3].y} l`, `${points[2].x} ${points[2].y} l`, "f");
                          return [points[0].x, points[1].x, points[3].y, points[1].y];
                        }
                      });
                    }
                  } else {
                    this.data.popupRef = null;
                  }
                }
              }
              class UnderlineAnnotation extends MarkupAnnotation {
                constructor(params) {
                  super(params);
                  const {
                    dict,
                    xref
                  } = params;
                  this.data.annotationType = _util2.AnnotationType.UNDERLINE;
                  const quadPoints = this.data.quadPoints = getQuadPoints(dict, null);
                  if (quadPoints) {
                    if (!this.appearance) {
                      const strokeColor = this.color ? getPdfColorArray(this.color) : [0, 0, 0];
                      const strokeAlpha = dict.get("CA");
                      this._setDefaultAppearance({
                        xref,
                        extra: "[] 0 d 0.571 w",
                        strokeColor,
                        strokeAlpha,
                        pointsCallback: (buffer, points) => {
                          buffer.push(`${points[2].x} ${points[2].y + 1.3} m`, `${points[3].x} ${points[3].y + 1.3} l`, "S");
                          return [points[0].x, points[1].x, points[3].y, points[1].y];
                        }
                      });
                    }
                  } else {
                    this.data.popupRef = null;
                  }
                }
              }
              class SquigglyAnnotation extends MarkupAnnotation {
                constructor(params) {
                  super(params);
                  const {
                    dict,
                    xref
                  } = params;
                  this.data.annotationType = _util2.AnnotationType.SQUIGGLY;
                  const quadPoints = this.data.quadPoints = getQuadPoints(dict, null);
                  if (quadPoints) {
                    if (!this.appearance) {
                      const strokeColor = this.color ? getPdfColorArray(this.color) : [0, 0, 0];
                      const strokeAlpha = dict.get("CA");
                      this._setDefaultAppearance({
                        xref,
                        extra: "[] 0 d 1 w",
                        strokeColor,
                        strokeAlpha,
                        pointsCallback: (buffer, points) => {
                          const dy = (points[0].y - points[2].y) / 6;
                          let shift2 = dy;
                          let x = points[2].x;
                          const y = points[2].y;
                          const xEnd = points[3].x;
                          buffer.push(`${x} ${y + shift2} m`);
                          do {
                            x += 2;
                            shift2 = shift2 === 0 ? dy : 0;
                            buffer.push(`${x} ${y + shift2} l`);
                          } while (x < xEnd);
                          buffer.push("S");
                          return [points[2].x, xEnd, y - 2 * dy, y + 2 * dy];
                        }
                      });
                    }
                  } else {
                    this.data.popupRef = null;
                  }
                }
              }
              class StrikeOutAnnotation extends MarkupAnnotation {
                constructor(params) {
                  super(params);
                  const {
                    dict,
                    xref
                  } = params;
                  this.data.annotationType = _util2.AnnotationType.STRIKEOUT;
                  const quadPoints = this.data.quadPoints = getQuadPoints(dict, null);
                  if (quadPoints) {
                    if (!this.appearance) {
                      const strokeColor = this.color ? getPdfColorArray(this.color) : [0, 0, 0];
                      const strokeAlpha = dict.get("CA");
                      this._setDefaultAppearance({
                        xref,
                        extra: "[] 0 d 1 w",
                        strokeColor,
                        strokeAlpha,
                        pointsCallback: (buffer, points) => {
                          buffer.push(`${(points[0].x + points[2].x) / 2} ${(points[0].y + points[2].y) / 2} m`, `${(points[1].x + points[3].x) / 2} ${(points[1].y + points[3].y) / 2} l`, "S");
                          return [points[0].x, points[1].x, points[3].y, points[1].y];
                        }
                      });
                    }
                  } else {
                    this.data.popupRef = null;
                  }
                }
              }
              class StampAnnotation extends MarkupAnnotation {
                constructor(params) {
                  super(params);
                  this.data.annotationType = _util2.AnnotationType.STAMP;
                  this.data.hasOwnCanvas = this.data.noRotate;
                }
                static async createImage(bitmap, xref) {
                  const {
                    width,
                    height
                  } = bitmap;
                  const canvas = new OffscreenCanvas(width, height);
                  const ctx = canvas.getContext("2d", {
                    alpha: true
                  });
                  ctx.drawImage(bitmap, 0, 0);
                  const data2 = ctx.getImageData(0, 0, width, height).data;
                  const buf32 = new Uint32Array(data2.buffer);
                  const hasAlpha = buf32.some(_util2.FeatureTest.isLittleEndian ? (x) => x >>> 24 !== 255 : (x) => (x & 255) !== 255);
                  if (hasAlpha) {
                    ctx.fillStyle = "white";
                    ctx.fillRect(0, 0, width, height);
                    ctx.drawImage(bitmap, 0, 0);
                  }
                  const jpegBufferPromise = canvas.convertToBlob({
                    type: "image/jpeg",
                    quality: 1
                  }).then((blob) => {
                    return blob.arrayBuffer();
                  });
                  const xobjectName = _primitives.Name.get("XObject");
                  const imageName = _primitives.Name.get("Image");
                  const image = new _primitives.Dict(xref);
                  image.set("Type", xobjectName);
                  image.set("Subtype", imageName);
                  image.set("BitsPerComponent", 8);
                  image.set("ColorSpace", _primitives.Name.get("DeviceRGB"));
                  image.set("Filter", _primitives.Name.get("DCTDecode"));
                  image.set("BBox", [0, 0, width, height]);
                  image.set("Width", width);
                  image.set("Height", height);
                  let smaskStream = null;
                  if (hasAlpha) {
                    const alphaBuffer = new Uint8Array(buf32.length);
                    if (_util2.FeatureTest.isLittleEndian) {
                      for (let i = 0, ii = buf32.length; i < ii; i++) {
                        alphaBuffer[i] = buf32[i] >>> 24;
                      }
                    } else {
                      for (let i = 0, ii = buf32.length; i < ii; i++) {
                        alphaBuffer[i] = buf32[i] & 255;
                      }
                    }
                    const smask = new _primitives.Dict(xref);
                    smask.set("Type", xobjectName);
                    smask.set("Subtype", imageName);
                    smask.set("BitsPerComponent", 8);
                    smask.set("ColorSpace", _primitives.Name.get("DeviceGray"));
                    smask.set("Width", width);
                    smask.set("Height", height);
                    smaskStream = new _stream.Stream(alphaBuffer, 0, 0, smask);
                  }
                  const imageStream = new _stream.Stream(await jpegBufferPromise, 0, 0, image);
                  return {
                    imageStream,
                    smaskStream,
                    width,
                    height
                  };
                }
                static createNewDict(annotation, xref, {
                  apRef,
                  ap
                }) {
                  const {
                    rect,
                    rotation,
                    user
                  } = annotation;
                  const stamp = new _primitives.Dict(xref);
                  stamp.set("Type", _primitives.Name.get("Annot"));
                  stamp.set("Subtype", _primitives.Name.get("Stamp"));
                  stamp.set("CreationDate", `D:${(0, _util2.getModificationDate)()}`);
                  stamp.set("Rect", rect);
                  stamp.set("F", 4);
                  stamp.set("Border", [0, 0, 0]);
                  stamp.set("Rotate", rotation);
                  if (user) {
                    stamp.set("T", (0, _core_utils.isAscii)(user) ? user : (0, _core_utils.stringToUTF16String)(user, true));
                  }
                  if (apRef || ap) {
                    const n2 = new _primitives.Dict(xref);
                    stamp.set("AP", n2);
                    if (apRef) {
                      n2.set("N", apRef);
                    } else {
                      n2.set("N", ap);
                    }
                  }
                  return stamp;
                }
                static async createNewAppearanceStream(annotation, xref, params) {
                  const {
                    rotation
                  } = annotation;
                  const {
                    imageRef,
                    width,
                    height
                  } = params.image;
                  const resources = new _primitives.Dict(xref);
                  const xobject = new _primitives.Dict(xref);
                  resources.set("XObject", xobject);
                  xobject.set("Im0", imageRef);
                  const appearance = `q ${width} 0 0 ${height} 0 0 cm /Im0 Do Q`;
                  const appearanceStreamDict = new _primitives.Dict(xref);
                  appearanceStreamDict.set("FormType", 1);
                  appearanceStreamDict.set("Subtype", _primitives.Name.get("Form"));
                  appearanceStreamDict.set("Type", _primitives.Name.get("XObject"));
                  appearanceStreamDict.set("BBox", [0, 0, width, height]);
                  appearanceStreamDict.set("Resources", resources);
                  if (rotation) {
                    const matrix = (0, _core_utils.getRotationMatrix)(rotation, width, height);
                    appearanceStreamDict.set("Matrix", matrix);
                  }
                  const ap = new _stream.StringStream(appearance);
                  ap.dict = appearanceStreamDict;
                  return ap;
                }
              }
              class FileAttachmentAnnotation extends MarkupAnnotation {
                constructor(params) {
                  super(params);
                  const {
                    dict,
                    xref
                  } = params;
                  const file = new _file_spec.FileSpec(dict.get("FS"), xref);
                  this.data.annotationType = _util2.AnnotationType.FILEATTACHMENT;
                  this.data.hasOwnCanvas = this.data.noRotate;
                  this.data.file = file.serializable;
                  const name = dict.get("Name");
                  this.data.name = name instanceof _primitives.Name ? (0, _util2.stringToPDFString)(name.name) : "PushPin";
                  const fillAlpha = dict.get("ca");
                  this.data.fillAlpha = typeof fillAlpha === "number" && fillAlpha >= 0 && fillAlpha <= 1 ? fillAlpha : null;
                }
              }
            }),
            /* 11 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.FakeUnicodeFont = void 0;
              exports3.createDefaultAppearance = createDefaultAppearance;
              exports3.getPdfColor = getPdfColor;
              exports3.parseAppearanceStream = parseAppearanceStream;
              exports3.parseDefaultAppearance = parseDefaultAppearance;
              var _primitives = __w_pdfjs_require__3(4);
              var _core_utils = __w_pdfjs_require__3(3);
              var _util2 = __w_pdfjs_require__3(2);
              var _colorspace = __w_pdfjs_require__3(12);
              var _evaluator = __w_pdfjs_require__3(13);
              var _image_utils = __w_pdfjs_require__3(59);
              var _function = __w_pdfjs_require__3(57);
              var _stream = __w_pdfjs_require__3(8);
              class DefaultAppearanceEvaluator extends _evaluator.EvaluatorPreprocessor {
                constructor(str) {
                  super(new _stream.StringStream(str));
                }
                parse() {
                  const operation = {
                    fn: 0,
                    args: []
                  };
                  const result = {
                    fontSize: 0,
                    fontName: "",
                    fontColor: new Uint8ClampedArray(3)
                  };
                  try {
                    while (true) {
                      operation.args.length = 0;
                      if (!this.read(operation)) {
                        break;
                      }
                      if (this.savedStatesDepth !== 0) {
                        continue;
                      }
                      const {
                        fn,
                        args
                      } = operation;
                      switch (fn | 0) {
                        case _util2.OPS.setFont:
                          const [fontName, fontSize] = args;
                          if (fontName instanceof _primitives.Name) {
                            result.fontName = fontName.name;
                          }
                          if (typeof fontSize === "number" && fontSize > 0) {
                            result.fontSize = fontSize;
                          }
                          break;
                        case _util2.OPS.setFillRGBColor:
                          _colorspace.ColorSpace.singletons.rgb.getRgbItem(args, 0, result.fontColor, 0);
                          break;
                        case _util2.OPS.setFillGray:
                          _colorspace.ColorSpace.singletons.gray.getRgbItem(args, 0, result.fontColor, 0);
                          break;
                        case _util2.OPS.setFillCMYKColor:
                          _colorspace.ColorSpace.singletons.cmyk.getRgbItem(args, 0, result.fontColor, 0);
                          break;
                      }
                    }
                  } catch (reason) {
                    (0, _util2.warn)(`parseDefaultAppearance - ignoring errors: "${reason}".`);
                  }
                  return result;
                }
              }
              function parseDefaultAppearance(str) {
                return new DefaultAppearanceEvaluator(str).parse();
              }
              class AppearanceStreamEvaluator extends _evaluator.EvaluatorPreprocessor {
                constructor(stream, evaluatorOptions, xref) {
                  super(stream);
                  this.stream = stream;
                  this.evaluatorOptions = evaluatorOptions;
                  this.xref = xref;
                  this.resources = stream.dict?.get("Resources");
                }
                parse() {
                  const operation = {
                    fn: 0,
                    args: []
                  };
                  let result = {
                    scaleFactor: 1,
                    fontSize: 0,
                    fontName: "",
                    fontColor: new Uint8ClampedArray(3),
                    fillColorSpace: _colorspace.ColorSpace.singletons.gray
                  };
                  let breakLoop = false;
                  const stack = [];
                  try {
                    while (true) {
                      operation.args.length = 0;
                      if (breakLoop || !this.read(operation)) {
                        break;
                      }
                      const {
                        fn,
                        args
                      } = operation;
                      switch (fn | 0) {
                        case _util2.OPS.save:
                          stack.push({
                            scaleFactor: result.scaleFactor,
                            fontSize: result.fontSize,
                            fontName: result.fontName,
                            fontColor: result.fontColor.slice(),
                            fillColorSpace: result.fillColorSpace
                          });
                          break;
                        case _util2.OPS.restore:
                          result = stack.pop() || result;
                          break;
                        case _util2.OPS.setTextMatrix:
                          result.scaleFactor *= Math.hypot(args[0], args[1]);
                          break;
                        case _util2.OPS.setFont:
                          const [fontName, fontSize] = args;
                          if (fontName instanceof _primitives.Name) {
                            result.fontName = fontName.name;
                          }
                          if (typeof fontSize === "number" && fontSize > 0) {
                            result.fontSize = fontSize * result.scaleFactor;
                          }
                          break;
                        case _util2.OPS.setFillColorSpace:
                          result.fillColorSpace = _colorspace.ColorSpace.parse({
                            cs: args[0],
                            xref: this.xref,
                            resources: this.resources,
                            pdfFunctionFactory: this._pdfFunctionFactory,
                            localColorSpaceCache: this._localColorSpaceCache
                          });
                          break;
                        case _util2.OPS.setFillColor:
                          const cs = result.fillColorSpace;
                          cs.getRgbItem(args, 0, result.fontColor, 0);
                          break;
                        case _util2.OPS.setFillRGBColor:
                          _colorspace.ColorSpace.singletons.rgb.getRgbItem(args, 0, result.fontColor, 0);
                          break;
                        case _util2.OPS.setFillGray:
                          _colorspace.ColorSpace.singletons.gray.getRgbItem(args, 0, result.fontColor, 0);
                          break;
                        case _util2.OPS.setFillCMYKColor:
                          _colorspace.ColorSpace.singletons.cmyk.getRgbItem(args, 0, result.fontColor, 0);
                          break;
                        case _util2.OPS.showText:
                        case _util2.OPS.showSpacedText:
                        case _util2.OPS.nextLineShowText:
                        case _util2.OPS.nextLineSetSpacingShowText:
                          breakLoop = true;
                          break;
                      }
                    }
                  } catch (reason) {
                    (0, _util2.warn)(`parseAppearanceStream - ignoring errors: "${reason}".`);
                  }
                  this.stream.reset();
                  delete result.scaleFactor;
                  delete result.fillColorSpace;
                  return result;
                }
                get _localColorSpaceCache() {
                  return (0, _util2.shadow)(this, "_localColorSpaceCache", new _image_utils.LocalColorSpaceCache());
                }
                get _pdfFunctionFactory() {
                  const pdfFunctionFactory = new _function.PDFFunctionFactory({
                    xref: this.xref,
                    isEvalSupported: this.evaluatorOptions.isEvalSupported
                  });
                  return (0, _util2.shadow)(this, "_pdfFunctionFactory", pdfFunctionFactory);
                }
              }
              function parseAppearanceStream(stream, evaluatorOptions, xref) {
                return new AppearanceStreamEvaluator(stream, evaluatorOptions, xref).parse();
              }
              function getPdfColor(color, isFill) {
                if (color[0] === color[1] && color[1] === color[2]) {
                  const gray = color[0] / 255;
                  return `${(0, _core_utils.numberToString)(gray)} ${isFill ? "g" : "G"}`;
                }
                return Array.from(color, (c) => (0, _core_utils.numberToString)(c / 255)).join(" ") + ` ${isFill ? "rg" : "RG"}`;
              }
              function createDefaultAppearance({
                fontSize,
                fontName,
                fontColor
              }) {
                return `/${(0, _core_utils.escapePDFName)(fontName)} ${fontSize} Tf ${getPdfColor(fontColor, true)}`;
              }
              class FakeUnicodeFont {
                constructor(xref, fontFamily) {
                  this.xref = xref;
                  this.widths = null;
                  this.firstChar = Infinity;
                  this.lastChar = -Infinity;
                  this.fontFamily = fontFamily;
                  const canvas = new OffscreenCanvas(1, 1);
                  this.ctxMeasure = canvas.getContext("2d");
                  if (!FakeUnicodeFont._fontNameId) {
                    FakeUnicodeFont._fontNameId = 1;
                  }
                  this.fontName = _primitives.Name.get(`InvalidPDFjsFont_${fontFamily}_${FakeUnicodeFont._fontNameId++}`);
                }
                get toUnicodeRef() {
                  if (!FakeUnicodeFont._toUnicodeRef) {
                    const toUnicode = `/CIDInit /ProcSet findresource begin
12 dict begin
begincmap
/CIDSystemInfo
<< /Registry (Adobe)
/Ordering (UCS) /Supplement 0 >> def
/CMapName /Adobe-Identity-UCS def
/CMapType 2 def
1 begincodespacerange
<0000> <FFFF>
endcodespacerange
1 beginbfrange
<0000> <FFFF> <0000>
endbfrange
endcmap CMapName currentdict /CMap defineresource pop end end`;
                    const toUnicodeStream = FakeUnicodeFont.toUnicodeStream = new _stream.StringStream(toUnicode);
                    const toUnicodeDict = new _primitives.Dict(this.xref);
                    toUnicodeStream.dict = toUnicodeDict;
                    toUnicodeDict.set("Length", toUnicode.length);
                    FakeUnicodeFont._toUnicodeRef = this.xref.getNewPersistentRef(toUnicodeStream);
                  }
                  return FakeUnicodeFont._toUnicodeRef;
                }
                get fontDescriptorRef() {
                  if (!FakeUnicodeFont._fontDescriptorRef) {
                    const fontDescriptor = new _primitives.Dict(this.xref);
                    fontDescriptor.set("Type", _primitives.Name.get("FontDescriptor"));
                    fontDescriptor.set("FontName", this.fontName);
                    fontDescriptor.set("FontFamily", "MyriadPro Regular");
                    fontDescriptor.set("FontBBox", [0, 0, 0, 0]);
                    fontDescriptor.set("FontStretch", _primitives.Name.get("Normal"));
                    fontDescriptor.set("FontWeight", 400);
                    fontDescriptor.set("ItalicAngle", 0);
                    FakeUnicodeFont._fontDescriptorRef = this.xref.getNewPersistentRef(fontDescriptor);
                  }
                  return FakeUnicodeFont._fontDescriptorRef;
                }
                get descendantFontRef() {
                  const descendantFont = new _primitives.Dict(this.xref);
                  descendantFont.set("BaseFont", this.fontName);
                  descendantFont.set("Type", _primitives.Name.get("Font"));
                  descendantFont.set("Subtype", _primitives.Name.get("CIDFontType0"));
                  descendantFont.set("CIDToGIDMap", _primitives.Name.get("Identity"));
                  descendantFont.set("FirstChar", this.firstChar);
                  descendantFont.set("LastChar", this.lastChar);
                  descendantFont.set("FontDescriptor", this.fontDescriptorRef);
                  descendantFont.set("DW", 1e3);
                  const widths = [];
                  const chars = [...this.widths.entries()].sort();
                  let currentChar = null;
                  let currentWidths = null;
                  for (const [char2, width] of chars) {
                    if (!currentChar) {
                      currentChar = char2;
                      currentWidths = [width];
                      continue;
                    }
                    if (char2 === currentChar + currentWidths.length) {
                      currentWidths.push(width);
                    } else {
                      widths.push(currentChar, currentWidths);
                      currentChar = char2;
                      currentWidths = [width];
                    }
                  }
                  if (currentChar) {
                    widths.push(currentChar, currentWidths);
                  }
                  descendantFont.set("W", widths);
                  const cidSystemInfo = new _primitives.Dict(this.xref);
                  cidSystemInfo.set("Ordering", "Identity");
                  cidSystemInfo.set("Registry", "Adobe");
                  cidSystemInfo.set("Supplement", 0);
                  descendantFont.set("CIDSystemInfo", cidSystemInfo);
                  return this.xref.getNewPersistentRef(descendantFont);
                }
                get baseFontRef() {
                  const baseFont = new _primitives.Dict(this.xref);
                  baseFont.set("BaseFont", this.fontName);
                  baseFont.set("Type", _primitives.Name.get("Font"));
                  baseFont.set("Subtype", _primitives.Name.get("Type0"));
                  baseFont.set("Encoding", _primitives.Name.get("Identity-H"));
                  baseFont.set("DescendantFonts", [this.descendantFontRef]);
                  baseFont.set("ToUnicode", this.toUnicodeRef);
                  return this.xref.getNewPersistentRef(baseFont);
                }
                get resources() {
                  const resources = new _primitives.Dict(this.xref);
                  const font = new _primitives.Dict(this.xref);
                  font.set(this.fontName.name, this.baseFontRef);
                  resources.set("Font", font);
                  return resources;
                }
                _createContext() {
                  this.widths = /* @__PURE__ */ new Map();
                  this.ctxMeasure.font = `1000px ${this.fontFamily}`;
                  return this.ctxMeasure;
                }
                createFontResources(text) {
                  const ctx = this._createContext();
                  for (const line2 of text.split(/\r\n?|\n/)) {
                    for (const char2 of line2.split("")) {
                      const code2 = char2.charCodeAt(0);
                      if (this.widths.has(code2)) {
                        continue;
                      }
                      const metrics = ctx.measureText(char2);
                      const width = Math.ceil(metrics.width);
                      this.widths.set(code2, width);
                      this.firstChar = Math.min(code2, this.firstChar);
                      this.lastChar = Math.max(code2, this.lastChar);
                    }
                  }
                  return this.resources;
                }
                createAppearance(text, rect, rotation, fontSize, bgColor, strokeAlpha) {
                  const ctx = this._createContext();
                  const lines = [];
                  let maxWidth = -Infinity;
                  for (const line2 of text.split(/\r\n?|\n/)) {
                    lines.push(line2);
                    const lineWidth = ctx.measureText(line2).width;
                    maxWidth = Math.max(maxWidth, lineWidth);
                    for (const char2 of line2.split("")) {
                      const code2 = char2.charCodeAt(0);
                      let width = this.widths.get(code2);
                      if (width === void 0) {
                        const metrics = ctx.measureText(char2);
                        width = Math.ceil(metrics.width);
                        this.widths.set(code2, width);
                        this.firstChar = Math.min(code2, this.firstChar);
                        this.lastChar = Math.max(code2, this.lastChar);
                      }
                    }
                  }
                  maxWidth *= fontSize / 1e3;
                  const [x1, y1, x2, y2] = rect;
                  let w = x2 - x1;
                  let h2 = y2 - y1;
                  if (rotation % 180 !== 0) {
                    [w, h2] = [h2, w];
                  }
                  let hscale = 1;
                  if (maxWidth > w) {
                    hscale = w / maxWidth;
                  }
                  let vscale = 1;
                  const lineHeight = _util2.LINE_FACTOR * fontSize;
                  const lineDescent = _util2.LINE_DESCENT_FACTOR * fontSize;
                  const maxHeight = lineHeight * lines.length;
                  if (maxHeight > h2) {
                    vscale = h2 / maxHeight;
                  }
                  const fscale = Math.min(hscale, vscale);
                  const newFontSize = fontSize * fscale;
                  const buffer = ["q", `0 0 ${(0, _core_utils.numberToString)(w)} ${(0, _core_utils.numberToString)(h2)} re W n`, `BT`, `1 0 0 1 0 ${(0, _core_utils.numberToString)(h2 + lineDescent)} Tm 0 Tc ${getPdfColor(bgColor, true)}`, `/${this.fontName.name} ${(0, _core_utils.numberToString)(newFontSize)} Tf`];
                  const {
                    resources
                  } = this;
                  strokeAlpha = typeof strokeAlpha === "number" && strokeAlpha >= 0 && strokeAlpha <= 1 ? strokeAlpha : 1;
                  if (strokeAlpha !== 1) {
                    buffer.push("/R0 gs");
                    const extGState = new _primitives.Dict(this.xref);
                    const r0 = new _primitives.Dict(this.xref);
                    r0.set("ca", strokeAlpha);
                    r0.set("CA", strokeAlpha);
                    r0.set("Type", _primitives.Name.get("ExtGState"));
                    extGState.set("R0", r0);
                    resources.set("ExtGState", extGState);
                  }
                  const vShift = (0, _core_utils.numberToString)(lineHeight);
                  for (const line2 of lines) {
                    buffer.push(`0 -${vShift} Td <${(0, _core_utils.stringToUTF16HexString)(line2)}> Tj`);
                  }
                  buffer.push("ET", "Q");
                  const appearance = buffer.join("\n");
                  const appearanceStreamDict = new _primitives.Dict(this.xref);
                  appearanceStreamDict.set("Subtype", _primitives.Name.get("Form"));
                  appearanceStreamDict.set("Type", _primitives.Name.get("XObject"));
                  appearanceStreamDict.set("BBox", [0, 0, w, h2]);
                  appearanceStreamDict.set("Length", appearance.length);
                  appearanceStreamDict.set("Resources", resources);
                  if (rotation) {
                    const matrix = (0, _core_utils.getRotationMatrix)(rotation, w, h2);
                    appearanceStreamDict.set("Matrix", matrix);
                  }
                  const ap = new _stream.StringStream(appearance);
                  ap.dict = appearanceStreamDict;
                  return ap;
                }
              }
              exports3.FakeUnicodeFont = FakeUnicodeFont;
            }),
            /* 12 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.ColorSpace = void 0;
              var _util2 = __w_pdfjs_require__3(2);
              var _primitives = __w_pdfjs_require__3(4);
              var _base_stream = __w_pdfjs_require__3(5);
              var _core_utils = __w_pdfjs_require__3(3);
              function resizeRgbImage(src, dest, w1, h1, w2, h2, alpha01) {
                const COMPONENTS = 3;
                alpha01 = alpha01 !== 1 ? 0 : alpha01;
                const xRatio = w1 / w2;
                const yRatio = h1 / h2;
                let newIndex = 0, oldIndex;
                const xScaled = new Uint16Array(w2);
                const w1Scanline = w1 * COMPONENTS;
                for (let i = 0; i < w2; i++) {
                  xScaled[i] = Math.floor(i * xRatio) * COMPONENTS;
                }
                for (let i = 0; i < h2; i++) {
                  const py = Math.floor(i * yRatio) * w1Scanline;
                  for (let j = 0; j < w2; j++) {
                    oldIndex = py + xScaled[j];
                    dest[newIndex++] = src[oldIndex++];
                    dest[newIndex++] = src[oldIndex++];
                    dest[newIndex++] = src[oldIndex++];
                    newIndex += alpha01;
                  }
                }
              }
              class ColorSpace {
                constructor(name, numComps) {
                  if (this.constructor === ColorSpace) {
                    (0, _util2.unreachable)("Cannot initialize ColorSpace.");
                  }
                  this.name = name;
                  this.numComps = numComps;
                }
                getRgb(src, srcOffset) {
                  const rgb2 = new Uint8ClampedArray(3);
                  this.getRgbItem(src, srcOffset, rgb2, 0);
                  return rgb2;
                }
                getRgbItem(src, srcOffset, dest, destOffset) {
                  (0, _util2.unreachable)("Should not call ColorSpace.getRgbItem");
                }
                getRgbBuffer(src, srcOffset, count, dest, destOffset, bits, alpha01) {
                  (0, _util2.unreachable)("Should not call ColorSpace.getRgbBuffer");
                }
                getOutputLength(inputLength, alpha01) {
                  (0, _util2.unreachable)("Should not call ColorSpace.getOutputLength");
                }
                isPassthrough(bits) {
                  return false;
                }
                isDefaultDecode(decodeMap, bpc) {
                  return ColorSpace.isDefaultDecode(decodeMap, this.numComps);
                }
                fillRgb(dest, originalWidth, originalHeight, width, height, actualHeight, bpc, comps, alpha01) {
                  const count = originalWidth * originalHeight;
                  let rgbBuf = null;
                  const numComponentColors = 1 << bpc;
                  const needsResizing = originalHeight !== height || originalWidth !== width;
                  if (this.isPassthrough(bpc)) {
                    rgbBuf = comps;
                  } else if (this.numComps === 1 && count > numComponentColors && this.name !== "DeviceGray" && this.name !== "DeviceRGB") {
                    const allColors = bpc <= 8 ? new Uint8Array(numComponentColors) : new Uint16Array(numComponentColors);
                    for (let i = 0; i < numComponentColors; i++) {
                      allColors[i] = i;
                    }
                    const colorMap = new Uint8ClampedArray(numComponentColors * 3);
                    this.getRgbBuffer(allColors, 0, numComponentColors, colorMap, 0, bpc, 0);
                    if (!needsResizing) {
                      let destPos = 0;
                      for (let i = 0; i < count; ++i) {
                        const key2 = comps[i] * 3;
                        dest[destPos++] = colorMap[key2];
                        dest[destPos++] = colorMap[key2 + 1];
                        dest[destPos++] = colorMap[key2 + 2];
                        destPos += alpha01;
                      }
                    } else {
                      rgbBuf = new Uint8Array(count * 3);
                      let rgbPos = 0;
                      for (let i = 0; i < count; ++i) {
                        const key2 = comps[i] * 3;
                        rgbBuf[rgbPos++] = colorMap[key2];
                        rgbBuf[rgbPos++] = colorMap[key2 + 1];
                        rgbBuf[rgbPos++] = colorMap[key2 + 2];
                      }
                    }
                  } else if (!needsResizing) {
                    this.getRgbBuffer(comps, 0, width * actualHeight, dest, 0, bpc, alpha01);
                  } else {
                    rgbBuf = new Uint8ClampedArray(count * 3);
                    this.getRgbBuffer(comps, 0, count, rgbBuf, 0, bpc, 0);
                  }
                  if (rgbBuf) {
                    if (needsResizing) {
                      resizeRgbImage(rgbBuf, dest, originalWidth, originalHeight, width, height, alpha01);
                    } else {
                      let destPos = 0, rgbPos = 0;
                      for (let i = 0, ii = width * actualHeight; i < ii; i++) {
                        dest[destPos++] = rgbBuf[rgbPos++];
                        dest[destPos++] = rgbBuf[rgbPos++];
                        dest[destPos++] = rgbBuf[rgbPos++];
                        destPos += alpha01;
                      }
                    }
                  }
                }
                get usesZeroToOneRange() {
                  return (0, _util2.shadow)(this, "usesZeroToOneRange", true);
                }
                static _cache(cacheKey, xref, localColorSpaceCache, parsedColorSpace) {
                  if (!localColorSpaceCache) {
                    throw new Error('ColorSpace._cache - expected "localColorSpaceCache" argument.');
                  }
                  if (!parsedColorSpace) {
                    throw new Error('ColorSpace._cache - expected "parsedColorSpace" argument.');
                  }
                  let csName, csRef;
                  if (cacheKey instanceof _primitives.Ref) {
                    csRef = cacheKey;
                    cacheKey = xref.fetch(cacheKey);
                  }
                  if (cacheKey instanceof _primitives.Name) {
                    csName = cacheKey.name;
                  }
                  if (csName || csRef) {
                    localColorSpaceCache.set(csName, csRef, parsedColorSpace);
                  }
                }
                static getCached(cacheKey, xref, localColorSpaceCache) {
                  if (!localColorSpaceCache) {
                    throw new Error('ColorSpace.getCached - expected "localColorSpaceCache" argument.');
                  }
                  if (cacheKey instanceof _primitives.Ref) {
                    const localColorSpace = localColorSpaceCache.getByRef(cacheKey);
                    if (localColorSpace) {
                      return localColorSpace;
                    }
                    try {
                      cacheKey = xref.fetch(cacheKey);
                    } catch (ex) {
                      if (ex instanceof _core_utils.MissingDataException) {
                        throw ex;
                      }
                    }
                  }
                  if (cacheKey instanceof _primitives.Name) {
                    const localColorSpace = localColorSpaceCache.getByName(cacheKey.name);
                    if (localColorSpace) {
                      return localColorSpace;
                    }
                  }
                  return null;
                }
                static async parseAsync({
                  cs,
                  xref,
                  resources = null,
                  pdfFunctionFactory,
                  localColorSpaceCache
                }) {
                  const parsedColorSpace = this._parse(cs, xref, resources, pdfFunctionFactory);
                  this._cache(cs, xref, localColorSpaceCache, parsedColorSpace);
                  return parsedColorSpace;
                }
                static parse({
                  cs,
                  xref,
                  resources = null,
                  pdfFunctionFactory,
                  localColorSpaceCache
                }) {
                  const cachedColorSpace = this.getCached(cs, xref, localColorSpaceCache);
                  if (cachedColorSpace) {
                    return cachedColorSpace;
                  }
                  const parsedColorSpace = this._parse(cs, xref, resources, pdfFunctionFactory);
                  this._cache(cs, xref, localColorSpaceCache, parsedColorSpace);
                  return parsedColorSpace;
                }
                static _parse(cs, xref, resources = null, pdfFunctionFactory) {
                  cs = xref.fetchIfRef(cs);
                  if (cs instanceof _primitives.Name) {
                    switch (cs.name) {
                      case "G":
                      case "DeviceGray":
                        return this.singletons.gray;
                      case "RGB":
                      case "DeviceRGB":
                        return this.singletons.rgb;
                      case "CMYK":
                      case "DeviceCMYK":
                        return this.singletons.cmyk;
                      case "Pattern":
                        return new PatternCS(null);
                      default:
                        if (resources instanceof _primitives.Dict) {
                          const colorSpaces = resources.get("ColorSpace");
                          if (colorSpaces instanceof _primitives.Dict) {
                            const resourcesCS = colorSpaces.get(cs.name);
                            if (resourcesCS) {
                              if (resourcesCS instanceof _primitives.Name) {
                                return this._parse(resourcesCS, xref, resources, pdfFunctionFactory);
                              }
                              cs = resourcesCS;
                              break;
                            }
                          }
                        }
                        throw new _util2.FormatError(`Unrecognized ColorSpace: ${cs.name}`);
                    }
                  }
                  if (Array.isArray(cs)) {
                    const mode = xref.fetchIfRef(cs[0]).name;
                    let params, numComps, baseCS, whitePoint, blackPoint, gamma;
                    switch (mode) {
                      case "G":
                      case "DeviceGray":
                        return this.singletons.gray;
                      case "RGB":
                      case "DeviceRGB":
                        return this.singletons.rgb;
                      case "CMYK":
                      case "DeviceCMYK":
                        return this.singletons.cmyk;
                      case "CalGray":
                        params = xref.fetchIfRef(cs[1]);
                        whitePoint = params.getArray("WhitePoint");
                        blackPoint = params.getArray("BlackPoint");
                        gamma = params.get("Gamma");
                        return new CalGrayCS(whitePoint, blackPoint, gamma);
                      case "CalRGB":
                        params = xref.fetchIfRef(cs[1]);
                        whitePoint = params.getArray("WhitePoint");
                        blackPoint = params.getArray("BlackPoint");
                        gamma = params.getArray("Gamma");
                        const matrix = params.getArray("Matrix");
                        return new CalRGBCS(whitePoint, blackPoint, gamma, matrix);
                      case "ICCBased":
                        const stream = xref.fetchIfRef(cs[1]);
                        const dict = stream.dict;
                        numComps = dict.get("N");
                        const alt = dict.get("Alternate");
                        if (alt) {
                          const altCS = this._parse(alt, xref, resources, pdfFunctionFactory);
                          if (altCS.numComps === numComps) {
                            return altCS;
                          }
                          (0, _util2.warn)("ICCBased color space: Ignoring incorrect /Alternate entry.");
                        }
                        if (numComps === 1) {
                          return this.singletons.gray;
                        } else if (numComps === 3) {
                          return this.singletons.rgb;
                        } else if (numComps === 4) {
                          return this.singletons.cmyk;
                        }
                        break;
                      case "Pattern":
                        baseCS = cs[1] || null;
                        if (baseCS) {
                          baseCS = this._parse(baseCS, xref, resources, pdfFunctionFactory);
                        }
                        return new PatternCS(baseCS);
                      case "I":
                      case "Indexed":
                        baseCS = this._parse(cs[1], xref, resources, pdfFunctionFactory);
                        const hiVal = xref.fetchIfRef(cs[2]) + 1;
                        const lookup = xref.fetchIfRef(cs[3]);
                        return new IndexedCS(baseCS, hiVal, lookup);
                      case "Separation":
                      case "DeviceN":
                        const name = xref.fetchIfRef(cs[1]);
                        numComps = Array.isArray(name) ? name.length : 1;
                        baseCS = this._parse(cs[2], xref, resources, pdfFunctionFactory);
                        const tintFn = pdfFunctionFactory.create(cs[3]);
                        return new AlternateCS(numComps, baseCS, tintFn);
                      case "Lab":
                        params = xref.fetchIfRef(cs[1]);
                        whitePoint = params.getArray("WhitePoint");
                        blackPoint = params.getArray("BlackPoint");
                        const range3 = params.getArray("Range");
                        return new LabCS(whitePoint, blackPoint, range3);
                      default:
                        throw new _util2.FormatError(`Unimplemented ColorSpace object: ${mode}`);
                    }
                  }
                  throw new _util2.FormatError(`Unrecognized ColorSpace object: ${cs}`);
                }
                static isDefaultDecode(decode, numComps) {
                  if (!Array.isArray(decode)) {
                    return true;
                  }
                  if (numComps * 2 !== decode.length) {
                    (0, _util2.warn)("The decode map is not the correct length");
                    return true;
                  }
                  for (let i = 0, ii = decode.length; i < ii; i += 2) {
                    if (decode[i] !== 0 || decode[i + 1] !== 1) {
                      return false;
                    }
                  }
                  return true;
                }
                static get singletons() {
                  return (0, _util2.shadow)(this, "singletons", {
                    get gray() {
                      return (0, _util2.shadow)(this, "gray", new DeviceGrayCS());
                    },
                    get rgb() {
                      return (0, _util2.shadow)(this, "rgb", new DeviceRgbCS());
                    },
                    get cmyk() {
                      return (0, _util2.shadow)(this, "cmyk", new DeviceCmykCS());
                    }
                  });
                }
              }
              exports3.ColorSpace = ColorSpace;
              class AlternateCS extends ColorSpace {
                constructor(numComps, base, tintFn) {
                  super("Alternate", numComps);
                  this.base = base;
                  this.tintFn = tintFn;
                  this.tmpBuf = new Float32Array(base.numComps);
                }
                getRgbItem(src, srcOffset, dest, destOffset) {
                  const tmpBuf = this.tmpBuf;
                  this.tintFn(src, srcOffset, tmpBuf, 0);
                  this.base.getRgbItem(tmpBuf, 0, dest, destOffset);
                }
                getRgbBuffer(src, srcOffset, count, dest, destOffset, bits, alpha01) {
                  const tintFn = this.tintFn;
                  const base = this.base;
                  const scale = 1 / ((1 << bits) - 1);
                  const baseNumComps = base.numComps;
                  const usesZeroToOneRange = base.usesZeroToOneRange;
                  const isPassthrough = (base.isPassthrough(8) || !usesZeroToOneRange) && alpha01 === 0;
                  let pos = isPassthrough ? destOffset : 0;
                  const baseBuf = isPassthrough ? dest : new Uint8ClampedArray(baseNumComps * count);
                  const numComps = this.numComps;
                  const scaled = new Float32Array(numComps);
                  const tinted = new Float32Array(baseNumComps);
                  let i, j;
                  for (i = 0; i < count; i++) {
                    for (j = 0; j < numComps; j++) {
                      scaled[j] = src[srcOffset++] * scale;
                    }
                    tintFn(scaled, 0, tinted, 0);
                    if (usesZeroToOneRange) {
                      for (j = 0; j < baseNumComps; j++) {
                        baseBuf[pos++] = tinted[j] * 255;
                      }
                    } else {
                      base.getRgbItem(tinted, 0, baseBuf, pos);
                      pos += baseNumComps;
                    }
                  }
                  if (!isPassthrough) {
                    base.getRgbBuffer(baseBuf, 0, count, dest, destOffset, 8, alpha01);
                  }
                }
                getOutputLength(inputLength, alpha01) {
                  return this.base.getOutputLength(inputLength * this.base.numComps / this.numComps, alpha01);
                }
              }
              class PatternCS extends ColorSpace {
                constructor(baseCS) {
                  super("Pattern", null);
                  this.base = baseCS;
                }
                isDefaultDecode(decodeMap, bpc) {
                  (0, _util2.unreachable)("Should not call PatternCS.isDefaultDecode");
                }
              }
              class IndexedCS extends ColorSpace {
                constructor(base, highVal, lookup) {
                  super("Indexed", 1);
                  this.base = base;
                  this.highVal = highVal;
                  const length2 = base.numComps * highVal;
                  this.lookup = new Uint8Array(length2);
                  if (lookup instanceof _base_stream.BaseStream) {
                    const bytes = lookup.getBytes(length2);
                    this.lookup.set(bytes);
                  } else if (typeof lookup === "string") {
                    for (let i = 0; i < length2; ++i) {
                      this.lookup[i] = lookup.charCodeAt(i) & 255;
                    }
                  } else {
                    throw new _util2.FormatError(`IndexedCS - unrecognized lookup table: ${lookup}`);
                  }
                }
                getRgbItem(src, srcOffset, dest, destOffset) {
                  const numComps = this.base.numComps;
                  const start = src[srcOffset] * numComps;
                  this.base.getRgbBuffer(this.lookup, start, 1, dest, destOffset, 8, 0);
                }
                getRgbBuffer(src, srcOffset, count, dest, destOffset, bits, alpha01) {
                  const base = this.base;
                  const numComps = base.numComps;
                  const outputDelta = base.getOutputLength(numComps, alpha01);
                  const lookup = this.lookup;
                  for (let i = 0; i < count; ++i) {
                    const lookupPos = src[srcOffset++] * numComps;
                    base.getRgbBuffer(lookup, lookupPos, 1, dest, destOffset, 8, alpha01);
                    destOffset += outputDelta;
                  }
                }
                getOutputLength(inputLength, alpha01) {
                  return this.base.getOutputLength(inputLength * this.base.numComps, alpha01);
                }
                isDefaultDecode(decodeMap, bpc) {
                  if (!Array.isArray(decodeMap)) {
                    return true;
                  }
                  if (decodeMap.length !== 2) {
                    (0, _util2.warn)("Decode map length is not correct");
                    return true;
                  }
                  if (!Number.isInteger(bpc) || bpc < 1) {
                    (0, _util2.warn)("Bits per component is not correct");
                    return true;
                  }
                  return decodeMap[0] === 0 && decodeMap[1] === (1 << bpc) - 1;
                }
              }
              class DeviceGrayCS extends ColorSpace {
                constructor() {
                  super("DeviceGray", 1);
                }
                getRgbItem(src, srcOffset, dest, destOffset) {
                  const c = src[srcOffset] * 255;
                  dest[destOffset] = dest[destOffset + 1] = dest[destOffset + 2] = c;
                }
                getRgbBuffer(src, srcOffset, count, dest, destOffset, bits, alpha01) {
                  const scale = 255 / ((1 << bits) - 1);
                  let j = srcOffset, q = destOffset;
                  for (let i = 0; i < count; ++i) {
                    const c = scale * src[j++];
                    dest[q++] = c;
                    dest[q++] = c;
                    dest[q++] = c;
                    q += alpha01;
                  }
                }
                getOutputLength(inputLength, alpha01) {
                  return inputLength * (3 + alpha01);
                }
              }
              class DeviceRgbCS extends ColorSpace {
                constructor() {
                  super("DeviceRGB", 3);
                }
                getRgbItem(src, srcOffset, dest, destOffset) {
                  dest[destOffset] = src[srcOffset] * 255;
                  dest[destOffset + 1] = src[srcOffset + 1] * 255;
                  dest[destOffset + 2] = src[srcOffset + 2] * 255;
                }
                getRgbBuffer(src, srcOffset, count, dest, destOffset, bits, alpha01) {
                  if (bits === 8 && alpha01 === 0) {
                    dest.set(src.subarray(srcOffset, srcOffset + count * 3), destOffset);
                    return;
                  }
                  const scale = 255 / ((1 << bits) - 1);
                  let j = srcOffset, q = destOffset;
                  for (let i = 0; i < count; ++i) {
                    dest[q++] = scale * src[j++];
                    dest[q++] = scale * src[j++];
                    dest[q++] = scale * src[j++];
                    q += alpha01;
                  }
                }
                getOutputLength(inputLength, alpha01) {
                  return inputLength * (3 + alpha01) / 3 | 0;
                }
                isPassthrough(bits) {
                  return bits === 8;
                }
              }
              class DeviceCmykCS extends ColorSpace {
                constructor() {
                  super("DeviceCMYK", 4);
                }
                #toRgb(src, srcOffset, srcScale, dest, destOffset) {
                  const c = src[srcOffset] * srcScale;
                  const m = src[srcOffset + 1] * srcScale;
                  const y = src[srcOffset + 2] * srcScale;
                  const k = src[srcOffset + 3] * srcScale;
                  dest[destOffset] = 255 + c * (-4.387332384609988 * c + 54.48615194189176 * m + 18.82290502165302 * y + 212.25662451639585 * k + -285.2331026137004) + m * (1.7149763477362134 * m - 5.6096736904047315 * y + -17.873870861415444 * k - 5.497006427196366) + y * (-2.5217340131683033 * y - 21.248923337353073 * k + 17.5119270841813) + k * (-21.86122147463605 * k - 189.48180835922747);
                  dest[destOffset + 1] = 255 + c * (8.841041422036149 * c + 60.118027045597366 * m + 6.871425592049007 * y + 31.159100130055922 * k + -79.2970844816548) + m * (-15.310361306967817 * m + 17.575251261109482 * y + 131.35250912493976 * k - 190.9453302588951) + y * (4.444339102852739 * y + 9.8632861493405 * k - 24.86741582555878) + k * (-20.737325471181034 * k - 187.80453709719578);
                  dest[destOffset + 2] = 255 + c * (0.8842522430003296 * c + 8.078677503112928 * m + 30.89978309703729 * y - 0.23883238689178934 * k + -14.183576799673286) + m * (10.49593273432072 * m + 63.02378494754052 * y + 50.606957656360734 * k - 112.23884253719248) + y * (0.03296041114873217 * y + 115.60384449646641 * k + -193.58209356861505) + k * (-22.33816807309886 * k - 180.12613974708367);
                }
                getRgbItem(src, srcOffset, dest, destOffset) {
                  this.#toRgb(src, srcOffset, 1, dest, destOffset);
                }
                getRgbBuffer(src, srcOffset, count, dest, destOffset, bits, alpha01) {
                  const scale = 1 / ((1 << bits) - 1);
                  for (let i = 0; i < count; i++) {
                    this.#toRgb(src, srcOffset, scale, dest, destOffset);
                    srcOffset += 4;
                    destOffset += 3 + alpha01;
                  }
                }
                getOutputLength(inputLength, alpha01) {
                  return inputLength / 4 * (3 + alpha01) | 0;
                }
              }
              class CalGrayCS extends ColorSpace {
                constructor(whitePoint, blackPoint, gamma) {
                  super("CalGray", 1);
                  if (!whitePoint) {
                    throw new _util2.FormatError("WhitePoint missing - required for color space CalGray");
                  }
                  [this.XW, this.YW, this.ZW] = whitePoint;
                  [this.XB, this.YB, this.ZB] = blackPoint || [0, 0, 0];
                  this.G = gamma || 1;
                  if (this.XW < 0 || this.ZW < 0 || this.YW !== 1) {
                    throw new _util2.FormatError(`Invalid WhitePoint components for ${this.name}, no fallback available`);
                  }
                  if (this.XB < 0 || this.YB < 0 || this.ZB < 0) {
                    (0, _util2.info)(`Invalid BlackPoint for ${this.name}, falling back to default.`);
                    this.XB = this.YB = this.ZB = 0;
                  }
                  if (this.XB !== 0 || this.YB !== 0 || this.ZB !== 0) {
                    (0, _util2.warn)(`${this.name}, BlackPoint: XB: ${this.XB}, YB: ${this.YB}, ZB: ${this.ZB}, only default values are supported.`);
                  }
                  if (this.G < 1) {
                    (0, _util2.info)(`Invalid Gamma: ${this.G} for ${this.name}, falling back to default.`);
                    this.G = 1;
                  }
                }
                #toRgb(src, srcOffset, dest, destOffset, scale) {
                  const A = src[srcOffset] * scale;
                  const AG = A ** this.G;
                  const L = this.YW * AG;
                  const val = Math.max(295.8 * L ** 0.3333333333333333 - 40.8, 0);
                  dest[destOffset] = val;
                  dest[destOffset + 1] = val;
                  dest[destOffset + 2] = val;
                }
                getRgbItem(src, srcOffset, dest, destOffset) {
                  this.#toRgb(src, srcOffset, dest, destOffset, 1);
                }
                getRgbBuffer(src, srcOffset, count, dest, destOffset, bits, alpha01) {
                  const scale = 1 / ((1 << bits) - 1);
                  for (let i = 0; i < count; ++i) {
                    this.#toRgb(src, srcOffset, dest, destOffset, scale);
                    srcOffset += 1;
                    destOffset += 3 + alpha01;
                  }
                }
                getOutputLength(inputLength, alpha01) {
                  return inputLength * (3 + alpha01);
                }
              }
              class CalRGBCS extends ColorSpace {
                static #BRADFORD_SCALE_MATRIX = new Float32Array([0.8951, 0.2664, -0.1614, -0.7502, 1.7135, 0.0367, 0.0389, -0.0685, 1.0296]);
                static #BRADFORD_SCALE_INVERSE_MATRIX = new Float32Array([0.9869929, -0.1470543, 0.1599627, 0.4323053, 0.5183603, 0.0492912, -85287e-7, 0.0400428, 0.9684867]);
                static #SRGB_D65_XYZ_TO_RGB_MATRIX = new Float32Array([3.2404542, -1.5371385, -0.4985314, -0.969266, 1.8760108, 0.041556, 0.0556434, -0.2040259, 1.0572252]);
                static #FLAT_WHITEPOINT_MATRIX = new Float32Array([1, 1, 1]);
                static #tempNormalizeMatrix = new Float32Array(3);
                static #tempConvertMatrix1 = new Float32Array(3);
                static #tempConvertMatrix2 = new Float32Array(3);
                static #DECODE_L_CONSTANT = ((8 + 16) / 116) ** 3 / 8;
                constructor(whitePoint, blackPoint, gamma, matrix) {
                  super("CalRGB", 3);
                  if (!whitePoint) {
                    throw new _util2.FormatError("WhitePoint missing - required for color space CalRGB");
                  }
                  const [XW, YW, ZW] = this.whitePoint = whitePoint;
                  const [XB, YB, ZB] = this.blackPoint = blackPoint || new Float32Array(3);
                  [this.GR, this.GG, this.GB] = gamma || new Float32Array([1, 1, 1]);
                  [this.MXA, this.MYA, this.MZA, this.MXB, this.MYB, this.MZB, this.MXC, this.MYC, this.MZC] = matrix || new Float32Array([1, 0, 0, 0, 1, 0, 0, 0, 1]);
                  if (XW < 0 || ZW < 0 || YW !== 1) {
                    throw new _util2.FormatError(`Invalid WhitePoint components for ${this.name}, no fallback available`);
                  }
                  if (XB < 0 || YB < 0 || ZB < 0) {
                    (0, _util2.info)(`Invalid BlackPoint for ${this.name} [${XB}, ${YB}, ${ZB}], falling back to default.`);
                    this.blackPoint = new Float32Array(3);
                  }
                  if (this.GR < 0 || this.GG < 0 || this.GB < 0) {
                    (0, _util2.info)(`Invalid Gamma [${this.GR}, ${this.GG}, ${this.GB}] for ${this.name}, falling back to default.`);
                    this.GR = this.GG = this.GB = 1;
                  }
                }
                #matrixProduct(a, b, result) {
                  result[0] = a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
                  result[1] = a[3] * b[0] + a[4] * b[1] + a[5] * b[2];
                  result[2] = a[6] * b[0] + a[7] * b[1] + a[8] * b[2];
                }
                #toFlat(sourceWhitePoint, LMS, result) {
                  result[0] = LMS[0] * 1 / sourceWhitePoint[0];
                  result[1] = LMS[1] * 1 / sourceWhitePoint[1];
                  result[2] = LMS[2] * 1 / sourceWhitePoint[2];
                }
                #toD65(sourceWhitePoint, LMS, result) {
                  const D65X = 0.95047;
                  const D65Y = 1;
                  const D65Z = 1.08883;
                  result[0] = LMS[0] * D65X / sourceWhitePoint[0];
                  result[1] = LMS[1] * D65Y / sourceWhitePoint[1];
                  result[2] = LMS[2] * D65Z / sourceWhitePoint[2];
                }
                #sRGBTransferFunction(color) {
                  if (color <= 31308e-7) {
                    return this.#adjustToRange(0, 1, 12.92 * color);
                  }
                  if (color >= 0.99554525) {
                    return 1;
                  }
                  return this.#adjustToRange(0, 1, (1 + 0.055) * color ** (1 / 2.4) - 0.055);
                }
                #adjustToRange(min, max, value) {
                  return Math.max(min, Math.min(max, value));
                }
                #decodeL(L) {
                  if (L < 0) {
                    return -this.#decodeL(-L);
                  }
                  if (L > 8) {
                    return ((L + 16) / 116) ** 3;
                  }
                  return L * CalRGBCS.#DECODE_L_CONSTANT;
                }
                #compensateBlackPoint(sourceBlackPoint, XYZ_Flat, result) {
                  if (sourceBlackPoint[0] === 0 && sourceBlackPoint[1] === 0 && sourceBlackPoint[2] === 0) {
                    result[0] = XYZ_Flat[0];
                    result[1] = XYZ_Flat[1];
                    result[2] = XYZ_Flat[2];
                    return;
                  }
                  const zeroDecodeL = this.#decodeL(0);
                  const X_DST = zeroDecodeL;
                  const X_SRC = this.#decodeL(sourceBlackPoint[0]);
                  const Y_DST = zeroDecodeL;
                  const Y_SRC = this.#decodeL(sourceBlackPoint[1]);
                  const Z_DST = zeroDecodeL;
                  const Z_SRC = this.#decodeL(sourceBlackPoint[2]);
                  const X_Scale = (1 - X_DST) / (1 - X_SRC);
                  const X_Offset = 1 - X_Scale;
                  const Y_Scale = (1 - Y_DST) / (1 - Y_SRC);
                  const Y_Offset = 1 - Y_Scale;
                  const Z_Scale = (1 - Z_DST) / (1 - Z_SRC);
                  const Z_Offset = 1 - Z_Scale;
                  result[0] = XYZ_Flat[0] * X_Scale + X_Offset;
                  result[1] = XYZ_Flat[1] * Y_Scale + Y_Offset;
                  result[2] = XYZ_Flat[2] * Z_Scale + Z_Offset;
                }
                #normalizeWhitePointToFlat(sourceWhitePoint, XYZ_In, result) {
                  if (sourceWhitePoint[0] === 1 && sourceWhitePoint[2] === 1) {
                    result[0] = XYZ_In[0];
                    result[1] = XYZ_In[1];
                    result[2] = XYZ_In[2];
                    return;
                  }
                  const LMS = result;
                  this.#matrixProduct(CalRGBCS.#BRADFORD_SCALE_MATRIX, XYZ_In, LMS);
                  const LMS_Flat = CalRGBCS.#tempNormalizeMatrix;
                  this.#toFlat(sourceWhitePoint, LMS, LMS_Flat);
                  this.#matrixProduct(CalRGBCS.#BRADFORD_SCALE_INVERSE_MATRIX, LMS_Flat, result);
                }
                #normalizeWhitePointToD65(sourceWhitePoint, XYZ_In, result) {
                  const LMS = result;
                  this.#matrixProduct(CalRGBCS.#BRADFORD_SCALE_MATRIX, XYZ_In, LMS);
                  const LMS_D65 = CalRGBCS.#tempNormalizeMatrix;
                  this.#toD65(sourceWhitePoint, LMS, LMS_D65);
                  this.#matrixProduct(CalRGBCS.#BRADFORD_SCALE_INVERSE_MATRIX, LMS_D65, result);
                }
                #toRgb(src, srcOffset, dest, destOffset, scale) {
                  const A = this.#adjustToRange(0, 1, src[srcOffset] * scale);
                  const B = this.#adjustToRange(0, 1, src[srcOffset + 1] * scale);
                  const C = this.#adjustToRange(0, 1, src[srcOffset + 2] * scale);
                  const AGR = A === 1 ? 1 : A ** this.GR;
                  const BGG = B === 1 ? 1 : B ** this.GG;
                  const CGB = C === 1 ? 1 : C ** this.GB;
                  const X2 = this.MXA * AGR + this.MXB * BGG + this.MXC * CGB;
                  const Y = this.MYA * AGR + this.MYB * BGG + this.MYC * CGB;
                  const Z = this.MZA * AGR + this.MZB * BGG + this.MZC * CGB;
                  const XYZ = CalRGBCS.#tempConvertMatrix1;
                  XYZ[0] = X2;
                  XYZ[1] = Y;
                  XYZ[2] = Z;
                  const XYZ_Flat = CalRGBCS.#tempConvertMatrix2;
                  this.#normalizeWhitePointToFlat(this.whitePoint, XYZ, XYZ_Flat);
                  const XYZ_Black = CalRGBCS.#tempConvertMatrix1;
                  this.#compensateBlackPoint(this.blackPoint, XYZ_Flat, XYZ_Black);
                  const XYZ_D65 = CalRGBCS.#tempConvertMatrix2;
                  this.#normalizeWhitePointToD65(CalRGBCS.#FLAT_WHITEPOINT_MATRIX, XYZ_Black, XYZ_D65);
                  const SRGB = CalRGBCS.#tempConvertMatrix1;
                  this.#matrixProduct(CalRGBCS.#SRGB_D65_XYZ_TO_RGB_MATRIX, XYZ_D65, SRGB);
                  dest[destOffset] = this.#sRGBTransferFunction(SRGB[0]) * 255;
                  dest[destOffset + 1] = this.#sRGBTransferFunction(SRGB[1]) * 255;
                  dest[destOffset + 2] = this.#sRGBTransferFunction(SRGB[2]) * 255;
                }
                getRgbItem(src, srcOffset, dest, destOffset) {
                  this.#toRgb(src, srcOffset, dest, destOffset, 1);
                }
                getRgbBuffer(src, srcOffset, count, dest, destOffset, bits, alpha01) {
                  const scale = 1 / ((1 << bits) - 1);
                  for (let i = 0; i < count; ++i) {
                    this.#toRgb(src, srcOffset, dest, destOffset, scale);
                    srcOffset += 3;
                    destOffset += 3 + alpha01;
                  }
                }
                getOutputLength(inputLength, alpha01) {
                  return inputLength * (3 + alpha01) / 3 | 0;
                }
              }
              class LabCS extends ColorSpace {
                constructor(whitePoint, blackPoint, range3) {
                  super("Lab", 3);
                  if (!whitePoint) {
                    throw new _util2.FormatError("WhitePoint missing - required for color space Lab");
                  }
                  [this.XW, this.YW, this.ZW] = whitePoint;
                  [this.amin, this.amax, this.bmin, this.bmax] = range3 || [-100, 100, -100, 100];
                  [this.XB, this.YB, this.ZB] = blackPoint || [0, 0, 0];
                  if (this.XW < 0 || this.ZW < 0 || this.YW !== 1) {
                    throw new _util2.FormatError("Invalid WhitePoint components, no fallback available");
                  }
                  if (this.XB < 0 || this.YB < 0 || this.ZB < 0) {
                    (0, _util2.info)("Invalid BlackPoint, falling back to default");
                    this.XB = this.YB = this.ZB = 0;
                  }
                  if (this.amin > this.amax || this.bmin > this.bmax) {
                    (0, _util2.info)("Invalid Range, falling back to defaults");
                    this.amin = -100;
                    this.amax = 100;
                    this.bmin = -100;
                    this.bmax = 100;
                  }
                }
                #fn_g(x) {
                  return x >= 6 / 29 ? x ** 3 : 108 / 841 * (x - 4 / 29);
                }
                #decode(value, high1, low2, high2) {
                  return low2 + value * (high2 - low2) / high1;
                }
                #toRgb(src, srcOffset, maxVal, dest, destOffset) {
                  let Ls = src[srcOffset];
                  let as = src[srcOffset + 1];
                  let bs = src[srcOffset + 2];
                  if (maxVal !== false) {
                    Ls = this.#decode(Ls, maxVal, 0, 100);
                    as = this.#decode(as, maxVal, this.amin, this.amax);
                    bs = this.#decode(bs, maxVal, this.bmin, this.bmax);
                  }
                  if (as > this.amax) {
                    as = this.amax;
                  } else if (as < this.amin) {
                    as = this.amin;
                  }
                  if (bs > this.bmax) {
                    bs = this.bmax;
                  } else if (bs < this.bmin) {
                    bs = this.bmin;
                  }
                  const M = (Ls + 16) / 116;
                  const L = M + as / 500;
                  const N = M - bs / 200;
                  const X2 = this.XW * this.#fn_g(L);
                  const Y = this.YW * this.#fn_g(M);
                  const Z = this.ZW * this.#fn_g(N);
                  let r2, g, b;
                  if (this.ZW < 1) {
                    r2 = X2 * 3.1339 + Y * -1.617 + Z * -0.4906;
                    g = X2 * -0.9785 + Y * 1.916 + Z * 0.0333;
                    b = X2 * 0.072 + Y * -0.229 + Z * 1.4057;
                  } else {
                    r2 = X2 * 3.2406 + Y * -1.5372 + Z * -0.4986;
                    g = X2 * -0.9689 + Y * 1.8758 + Z * 0.0415;
                    b = X2 * 0.0557 + Y * -0.204 + Z * 1.057;
                  }
                  dest[destOffset] = Math.sqrt(r2) * 255;
                  dest[destOffset + 1] = Math.sqrt(g) * 255;
                  dest[destOffset + 2] = Math.sqrt(b) * 255;
                }
                getRgbItem(src, srcOffset, dest, destOffset) {
                  this.#toRgb(src, srcOffset, false, dest, destOffset);
                }
                getRgbBuffer(src, srcOffset, count, dest, destOffset, bits, alpha01) {
                  const maxVal = (1 << bits) - 1;
                  for (let i = 0; i < count; i++) {
                    this.#toRgb(src, srcOffset, maxVal, dest, destOffset);
                    srcOffset += 3;
                    destOffset += 3 + alpha01;
                  }
                }
                getOutputLength(inputLength, alpha01) {
                  return inputLength * (3 + alpha01) / 3 | 0;
                }
                isDefaultDecode(decodeMap, bpc) {
                  return true;
                }
                get usesZeroToOneRange() {
                  return (0, _util2.shadow)(this, "usesZeroToOneRange", false);
                }
              }
            }),
            /* 13 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.PartialEvaluator = exports3.EvaluatorPreprocessor = void 0;
              var _util2 = __w_pdfjs_require__3(2);
              var _cmap = __w_pdfjs_require__3(14);
              var _primitives = __w_pdfjs_require__3(4);
              var _fonts = __w_pdfjs_require__3(34);
              var _encodings = __w_pdfjs_require__3(37);
              var _standard_fonts = __w_pdfjs_require__3(41);
              var _pattern = __w_pdfjs_require__3(50);
              var _xfa_fonts = __w_pdfjs_require__3(51);
              var _to_unicode_map = __w_pdfjs_require__3(42);
              var _function = __w_pdfjs_require__3(57);
              var _parser = __w_pdfjs_require__3(16);
              var _image_utils = __w_pdfjs_require__3(59);
              var _stream = __w_pdfjs_require__3(8);
              var _base_stream = __w_pdfjs_require__3(5);
              var _bidi = __w_pdfjs_require__3(60);
              var _colorspace = __w_pdfjs_require__3(12);
              var _decode_stream = __w_pdfjs_require__3(18);
              var _fonts_utils = __w_pdfjs_require__3(38);
              var _font_substitutions = __w_pdfjs_require__3(61);
              var _glyphlist = __w_pdfjs_require__3(39);
              var _metrics = __w_pdfjs_require__3(45);
              var _unicode = __w_pdfjs_require__3(40);
              var _image_resizer = __w_pdfjs_require__3(62);
              var _murmurhash = __w_pdfjs_require__3(63);
              var _operator_list = __w_pdfjs_require__3(64);
              var _image = __w_pdfjs_require__3(65);
              const DefaultPartialEvaluatorOptions = Object.freeze({
                maxImageSize: -1,
                disableFontFace: false,
                ignoreErrors: false,
                isEvalSupported: true,
                isOffscreenCanvasSupported: false,
                canvasMaxAreaInBytes: -1,
                fontExtraProperties: false,
                useSystemFonts: true,
                cMapUrl: null,
                standardFontDataUrl: null
              });
              const PatternType = {
                TILING: 1,
                SHADING: 2
              };
              const TEXT_CHUNK_BATCH_SIZE = 10;
              const deferred = Promise.resolve();
              function normalizeBlendMode(value, parsingArray = false) {
                if (Array.isArray(value)) {
                  for (const val of value) {
                    const maybeBM = normalizeBlendMode(val, true);
                    if (maybeBM) {
                      return maybeBM;
                    }
                  }
                  (0, _util2.warn)(`Unsupported blend mode Array: ${value}`);
                  return "source-over";
                }
                if (!(value instanceof _primitives.Name)) {
                  if (parsingArray) {
                    return null;
                  }
                  return "source-over";
                }
                switch (value.name) {
                  case "Normal":
                  case "Compatible":
                    return "source-over";
                  case "Multiply":
                    return "multiply";
                  case "Screen":
                    return "screen";
                  case "Overlay":
                    return "overlay";
                  case "Darken":
                    return "darken";
                  case "Lighten":
                    return "lighten";
                  case "ColorDodge":
                    return "color-dodge";
                  case "ColorBurn":
                    return "color-burn";
                  case "HardLight":
                    return "hard-light";
                  case "SoftLight":
                    return "soft-light";
                  case "Difference":
                    return "difference";
                  case "Exclusion":
                    return "exclusion";
                  case "Hue":
                    return "hue";
                  case "Saturation":
                    return "saturation";
                  case "Color":
                    return "color";
                  case "Luminosity":
                    return "luminosity";
                }
                if (parsingArray) {
                  return null;
                }
                (0, _util2.warn)(`Unsupported blend mode: ${value.name}`);
                return "source-over";
              }
              function incrementCachedImageMaskCount(data2) {
                if (data2.fn === _util2.OPS.paintImageMaskXObject && data2.args[0]?.count > 0) {
                  data2.args[0].count++;
                }
              }
              class TimeSlotManager {
                static TIME_SLOT_DURATION_MS = 20;
                static CHECK_TIME_EVERY = 100;
                constructor() {
                  this.reset();
                }
                check() {
                  if (++this.checked < TimeSlotManager.CHECK_TIME_EVERY) {
                    return false;
                  }
                  this.checked = 0;
                  return this.endTime <= Date.now();
                }
                reset() {
                  this.endTime = Date.now() + TimeSlotManager.TIME_SLOT_DURATION_MS;
                  this.checked = 0;
                }
              }
              class PartialEvaluator {
                constructor({
                  xref,
                  handler,
                  pageIndex,
                  idFactory,
                  fontCache,
                  builtInCMapCache,
                  standardFontDataCache,
                  globalImageCache,
                  systemFontCache,
                  options = null
                }) {
                  this.xref = xref;
                  this.handler = handler;
                  this.pageIndex = pageIndex;
                  this.idFactory = idFactory;
                  this.fontCache = fontCache;
                  this.builtInCMapCache = builtInCMapCache;
                  this.standardFontDataCache = standardFontDataCache;
                  this.globalImageCache = globalImageCache;
                  this.systemFontCache = systemFontCache;
                  this.options = options || DefaultPartialEvaluatorOptions;
                  this.parsingType3Font = false;
                  this._regionalImageCache = new _image_utils.RegionalImageCache();
                  this._fetchBuiltInCMapBound = this.fetchBuiltInCMap.bind(this);
                  _image_resizer.ImageResizer.setMaxArea(this.options.canvasMaxAreaInBytes);
                }
                get _pdfFunctionFactory() {
                  const pdfFunctionFactory = new _function.PDFFunctionFactory({
                    xref: this.xref,
                    isEvalSupported: this.options.isEvalSupported
                  });
                  return (0, _util2.shadow)(this, "_pdfFunctionFactory", pdfFunctionFactory);
                }
                clone(newOptions = null) {
                  const newEvaluator = Object.create(this);
                  newEvaluator.options = Object.assign(/* @__PURE__ */ Object.create(null), this.options, newOptions);
                  return newEvaluator;
                }
                hasBlendModes(resources, nonBlendModesSet) {
                  if (!(resources instanceof _primitives.Dict)) {
                    return false;
                  }
                  if (resources.objId && nonBlendModesSet.has(resources.objId)) {
                    return false;
                  }
                  const processed = new _primitives.RefSet(nonBlendModesSet);
                  if (resources.objId) {
                    processed.put(resources.objId);
                  }
                  const nodes = [resources], xref = this.xref;
                  while (nodes.length) {
                    const node2 = nodes.shift();
                    const graphicStates = node2.get("ExtGState");
                    if (graphicStates instanceof _primitives.Dict) {
                      for (let graphicState of graphicStates.getRawValues()) {
                        if (graphicState instanceof _primitives.Ref) {
                          if (processed.has(graphicState)) {
                            continue;
                          }
                          try {
                            graphicState = xref.fetch(graphicState);
                          } catch (ex) {
                            processed.put(graphicState);
                            (0, _util2.info)(`hasBlendModes - ignoring ExtGState: "${ex}".`);
                            continue;
                          }
                        }
                        if (!(graphicState instanceof _primitives.Dict)) {
                          continue;
                        }
                        if (graphicState.objId) {
                          processed.put(graphicState.objId);
                        }
                        const bm = graphicState.get("BM");
                        if (bm instanceof _primitives.Name) {
                          if (bm.name !== "Normal") {
                            return true;
                          }
                          continue;
                        }
                        if (bm !== void 0 && Array.isArray(bm)) {
                          for (const element of bm) {
                            if (element instanceof _primitives.Name && element.name !== "Normal") {
                              return true;
                            }
                          }
                        }
                      }
                    }
                    const xObjects = node2.get("XObject");
                    if (!(xObjects instanceof _primitives.Dict)) {
                      continue;
                    }
                    for (let xObject of xObjects.getRawValues()) {
                      if (xObject instanceof _primitives.Ref) {
                        if (processed.has(xObject)) {
                          continue;
                        }
                        try {
                          xObject = xref.fetch(xObject);
                        } catch (ex) {
                          processed.put(xObject);
                          (0, _util2.info)(`hasBlendModes - ignoring XObject: "${ex}".`);
                          continue;
                        }
                      }
                      if (!(xObject instanceof _base_stream.BaseStream)) {
                        continue;
                      }
                      if (xObject.dict.objId) {
                        processed.put(xObject.dict.objId);
                      }
                      const xResources = xObject.dict.get("Resources");
                      if (!(xResources instanceof _primitives.Dict)) {
                        continue;
                      }
                      if (xResources.objId && processed.has(xResources.objId)) {
                        continue;
                      }
                      nodes.push(xResources);
                      if (xResources.objId) {
                        processed.put(xResources.objId);
                      }
                    }
                  }
                  for (const ref3 of processed) {
                    nonBlendModesSet.put(ref3);
                  }
                  return false;
                }
                async fetchBuiltInCMap(name) {
                  const cachedData = this.builtInCMapCache.get(name);
                  if (cachedData) {
                    return cachedData;
                  }
                  let data2;
                  if (this.options.cMapUrl !== null) {
                    const url2 = `${this.options.cMapUrl}${name}.bcmap`;
                    const response = await fetch(url2);
                    if (!response.ok) {
                      throw new Error(`fetchBuiltInCMap: failed to fetch file "${url2}" with "${response.statusText}".`);
                    }
                    data2 = {
                      cMapData: new Uint8Array(await response.arrayBuffer()),
                      compressionType: _util2.CMapCompressionType.BINARY
                    };
                  } else {
                    data2 = await this.handler.sendWithPromise("FetchBuiltInCMap", {
                      name
                    });
                  }
                  if (data2.compressionType !== _util2.CMapCompressionType.NONE) {
                    this.builtInCMapCache.set(name, data2);
                  }
                  return data2;
                }
                async fetchStandardFontData(name) {
                  const cachedData = this.standardFontDataCache.get(name);
                  if (cachedData) {
                    return new _stream.Stream(cachedData);
                  }
                  if (this.options.useSystemFonts && name !== "Symbol" && name !== "ZapfDingbats") {
                    return null;
                  }
                  const standardFontNameToFileName = (0, _standard_fonts.getFontNameToFileMap)(), filename = standardFontNameToFileName[name];
                  let data2;
                  if (this.options.standardFontDataUrl !== null) {
                    const url2 = `${this.options.standardFontDataUrl}${filename}`;
                    const response = await fetch(url2);
                    if (!response.ok) {
                      (0, _util2.warn)(`fetchStandardFontData: failed to fetch file "${url2}" with "${response.statusText}".`);
                    } else {
                      data2 = await response.arrayBuffer();
                    }
                  } else {
                    try {
                      data2 = await this.handler.sendWithPromise("FetchStandardFontData", {
                        filename
                      });
                    } catch (e3) {
                      (0, _util2.warn)(`fetchStandardFontData: failed to fetch file "${filename}" with "${e3}".`);
                    }
                  }
                  if (!data2) {
                    return null;
                  }
                  this.standardFontDataCache.set(name, data2);
                  return new _stream.Stream(data2);
                }
                async buildFormXObject(resources, xobj, smask, operatorList, task, initialState, localColorSpaceCache) {
                  const dict = xobj.dict;
                  const matrix = dict.getArray("Matrix");
                  let bbox = dict.getArray("BBox");
                  bbox = Array.isArray(bbox) && bbox.length === 4 ? _util2.Util.normalizeRect(bbox) : null;
                  let optionalContent, groupOptions;
                  if (dict.has("OC")) {
                    optionalContent = await this.parseMarkedContentProps(dict.get("OC"), resources);
                  }
                  if (optionalContent !== void 0) {
                    operatorList.addOp(_util2.OPS.beginMarkedContentProps, ["OC", optionalContent]);
                  }
                  const group = dict.get("Group");
                  if (group) {
                    groupOptions = {
                      matrix,
                      bbox,
                      smask,
                      isolated: false,
                      knockout: false
                    };
                    const groupSubtype = group.get("S");
                    let colorSpace = null;
                    if ((0, _primitives.isName)(groupSubtype, "Transparency")) {
                      groupOptions.isolated = group.get("I") || false;
                      groupOptions.knockout = group.get("K") || false;
                      if (group.has("CS")) {
                        const cs = group.getRaw("CS");
                        const cachedColorSpace = _colorspace.ColorSpace.getCached(cs, this.xref, localColorSpaceCache);
                        if (cachedColorSpace) {
                          colorSpace = cachedColorSpace;
                        } else {
                          colorSpace = await this.parseColorSpace({
                            cs,
                            resources,
                            localColorSpaceCache
                          });
                        }
                      }
                    }
                    if (smask?.backdrop) {
                      colorSpace ||= _colorspace.ColorSpace.singletons.rgb;
                      smask.backdrop = colorSpace.getRgb(smask.backdrop, 0);
                    }
                    operatorList.addOp(_util2.OPS.beginGroup, [groupOptions]);
                  }
                  const args = group ? [matrix, null] : [matrix, bbox];
                  operatorList.addOp(_util2.OPS.paintFormXObjectBegin, args);
                  return this.getOperatorList({
                    stream: xobj,
                    task,
                    resources: dict.get("Resources") || resources,
                    operatorList,
                    initialState
                  }).then(function() {
                    operatorList.addOp(_util2.OPS.paintFormXObjectEnd, []);
                    if (group) {
                      operatorList.addOp(_util2.OPS.endGroup, [groupOptions]);
                    }
                    if (optionalContent !== void 0) {
                      operatorList.addOp(_util2.OPS.endMarkedContent, []);
                    }
                  });
                }
                _sendImgData(objId, imgData, cacheGlobally = false) {
                  const transfers = imgData ? [imgData.bitmap || imgData.data.buffer] : null;
                  if (this.parsingType3Font || cacheGlobally) {
                    return this.handler.send("commonobj", [objId, "Image", imgData], transfers);
                  }
                  return this.handler.send("obj", [objId, this.pageIndex, "Image", imgData], transfers);
                }
                async buildPaintImageXObject({
                  resources,
                  image,
                  isInline = false,
                  operatorList,
                  cacheKey,
                  localImageCache,
                  localColorSpaceCache
                }) {
                  const dict = image.dict;
                  const imageRef = dict.objId;
                  const w = dict.get("W", "Width");
                  const h2 = dict.get("H", "Height");
                  if (!(w && typeof w === "number") || !(h2 && typeof h2 === "number")) {
                    (0, _util2.warn)("Image dimensions are missing, or not numbers.");
                    return;
                  }
                  const maxImageSize = this.options.maxImageSize;
                  if (maxImageSize !== -1 && w * h2 > maxImageSize) {
                    const msg = "Image exceeded maximum allowed size and was removed.";
                    if (this.options.ignoreErrors) {
                      (0, _util2.warn)(msg);
                      return;
                    }
                    throw new Error(msg);
                  }
                  let optionalContent;
                  if (dict.has("OC")) {
                    optionalContent = await this.parseMarkedContentProps(dict.get("OC"), resources);
                  }
                  const imageMask = dict.get("IM", "ImageMask") || false;
                  let imgData, args;
                  if (imageMask) {
                    const interpolate = dict.get("I", "Interpolate");
                    const bitStrideLength = w + 7 >> 3;
                    const imgArray = image.getBytes(bitStrideLength * h2);
                    const decode = dict.getArray("D", "Decode");
                    if (this.parsingType3Font) {
                      imgData = _image.PDFImage.createRawMask({
                        imgArray,
                        width: w,
                        height: h2,
                        imageIsFromDecodeStream: image instanceof _decode_stream.DecodeStream,
                        inverseDecode: decode?.[0] > 0,
                        interpolate
                      });
                      imgData.cached = !!cacheKey;
                      args = [imgData];
                      operatorList.addImageOps(_util2.OPS.paintImageMaskXObject, args, optionalContent);
                      if (cacheKey) {
                        const cacheData = {
                          fn: _util2.OPS.paintImageMaskXObject,
                          args,
                          optionalContent
                        };
                        localImageCache.set(cacheKey, imageRef, cacheData);
                        if (imageRef) {
                          this._regionalImageCache.set(null, imageRef, cacheData);
                        }
                      }
                      return;
                    }
                    imgData = await _image.PDFImage.createMask({
                      imgArray,
                      width: w,
                      height: h2,
                      imageIsFromDecodeStream: image instanceof _decode_stream.DecodeStream,
                      inverseDecode: decode?.[0] > 0,
                      interpolate,
                      isOffscreenCanvasSupported: this.options.isOffscreenCanvasSupported
                    });
                    if (imgData.isSingleOpaquePixel) {
                      operatorList.addImageOps(_util2.OPS.paintSolidColorImageMask, [], optionalContent);
                      if (cacheKey) {
                        const cacheData = {
                          fn: _util2.OPS.paintSolidColorImageMask,
                          args: [],
                          optionalContent
                        };
                        localImageCache.set(cacheKey, imageRef, cacheData);
                        if (imageRef) {
                          this._regionalImageCache.set(null, imageRef, cacheData);
                        }
                      }
                      return;
                    }
                    const objId2 = `mask_${this.idFactory.createObjId()}`;
                    operatorList.addDependency(objId2);
                    this._sendImgData(objId2, imgData);
                    args = [{
                      data: objId2,
                      width: imgData.width,
                      height: imgData.height,
                      interpolate: imgData.interpolate,
                      count: 1
                    }];
                    operatorList.addImageOps(_util2.OPS.paintImageMaskXObject, args, optionalContent);
                    if (cacheKey) {
                      const cacheData = {
                        fn: _util2.OPS.paintImageMaskXObject,
                        args,
                        optionalContent
                      };
                      localImageCache.set(cacheKey, imageRef, cacheData);
                      if (imageRef) {
                        this._regionalImageCache.set(null, imageRef, cacheData);
                      }
                    }
                    return;
                  }
                  const SMALL_IMAGE_DIMENSIONS = 200;
                  if (isInline && !dict.has("SMask") && !dict.has("Mask") && w + h2 < SMALL_IMAGE_DIMENSIONS) {
                    const imageObj = new _image.PDFImage({
                      xref: this.xref,
                      res: resources,
                      image,
                      isInline,
                      pdfFunctionFactory: this._pdfFunctionFactory,
                      localColorSpaceCache
                    });
                    imgData = await imageObj.createImageData(true, false);
                    operatorList.isOffscreenCanvasSupported = this.options.isOffscreenCanvasSupported;
                    operatorList.addImageOps(_util2.OPS.paintInlineImageXObject, [imgData], optionalContent);
                    return;
                  }
                  let objId = `img_${this.idFactory.createObjId()}`, cacheGlobally = false;
                  if (this.parsingType3Font) {
                    objId = `${this.idFactory.getDocId()}_type3_${objId}`;
                  } else if (imageRef) {
                    cacheGlobally = this.globalImageCache.shouldCache(imageRef, this.pageIndex);
                    if (cacheGlobally) {
                      objId = `${this.idFactory.getDocId()}_${objId}`;
                    }
                  }
                  operatorList.addDependency(objId);
                  args = [objId, w, h2];
                  _image.PDFImage.buildImage({
                    xref: this.xref,
                    res: resources,
                    image,
                    isInline,
                    pdfFunctionFactory: this._pdfFunctionFactory,
                    localColorSpaceCache
                  }).then(async (imageObj) => {
                    imgData = await imageObj.createImageData(false, this.options.isOffscreenCanvasSupported);
                    if (cacheKey && imageRef && cacheGlobally) {
                      const length2 = imgData.bitmap ? imgData.width * imgData.height * 4 : imgData.data.length;
                      this.globalImageCache.addByteSize(imageRef, length2);
                    }
                    return this._sendImgData(objId, imgData, cacheGlobally);
                  }).catch((reason) => {
                    (0, _util2.warn)(`Unable to decode image "${objId}": "${reason}".`);
                    return this._sendImgData(objId, null, cacheGlobally);
                  });
                  operatorList.addImageOps(_util2.OPS.paintImageXObject, args, optionalContent);
                  if (cacheKey) {
                    const cacheData = {
                      fn: _util2.OPS.paintImageXObject,
                      args,
                      optionalContent
                    };
                    localImageCache.set(cacheKey, imageRef, cacheData);
                    if (imageRef) {
                      this._regionalImageCache.set(null, imageRef, cacheData);
                      if (cacheGlobally) {
                        (0, _util2.assert)(!isInline, "Cannot cache an inline image globally.");
                        this.globalImageCache.setData(imageRef, {
                          objId,
                          fn: _util2.OPS.paintImageXObject,
                          args,
                          optionalContent,
                          byteSize: 0
                        });
                      }
                    }
                  }
                }
                handleSMask(smask, resources, operatorList, task, stateManager, localColorSpaceCache) {
                  const smaskContent = smask.get("G");
                  const smaskOptions = {
                    subtype: smask.get("S").name,
                    backdrop: smask.get("BC")
                  };
                  const transferObj = smask.get("TR");
                  if ((0, _function.isPDFFunction)(transferObj)) {
                    const transferFn = this._pdfFunctionFactory.create(transferObj);
                    const transferMap = new Uint8Array(256);
                    const tmp = new Float32Array(1);
                    for (let i = 0; i < 256; i++) {
                      tmp[0] = i / 255;
                      transferFn(tmp, 0, tmp, 0);
                      transferMap[i] = tmp[0] * 255 | 0;
                    }
                    smaskOptions.transferMap = transferMap;
                  }
                  return this.buildFormXObject(resources, smaskContent, smaskOptions, operatorList, task, stateManager.state.clone(), localColorSpaceCache);
                }
                handleTransferFunction(tr) {
                  let transferArray;
                  if (Array.isArray(tr)) {
                    transferArray = tr;
                  } else if ((0, _function.isPDFFunction)(tr)) {
                    transferArray = [tr];
                  } else {
                    return null;
                  }
                  const transferMaps = [];
                  let numFns = 0, numEffectfulFns = 0;
                  for (const entry of transferArray) {
                    const transferObj = this.xref.fetchIfRef(entry);
                    numFns++;
                    if ((0, _primitives.isName)(transferObj, "Identity")) {
                      transferMaps.push(null);
                      continue;
                    } else if (!(0, _function.isPDFFunction)(transferObj)) {
                      return null;
                    }
                    const transferFn = this._pdfFunctionFactory.create(transferObj);
                    const transferMap = new Uint8Array(256), tmp = new Float32Array(1);
                    for (let j = 0; j < 256; j++) {
                      tmp[0] = j / 255;
                      transferFn(tmp, 0, tmp, 0);
                      transferMap[j] = tmp[0] * 255 | 0;
                    }
                    transferMaps.push(transferMap);
                    numEffectfulFns++;
                  }
                  if (!(numFns === 1 || numFns === 4)) {
                    return null;
                  }
                  if (numEffectfulFns === 0) {
                    return null;
                  }
                  return transferMaps;
                }
                handleTilingType(fn, color, resources, pattern6, patternDict, operatorList, task, localTilingPatternCache) {
                  const tilingOpList = new _operator_list.OperatorList();
                  const patternResources = _primitives.Dict.merge({
                    xref: this.xref,
                    dictArray: [patternDict.get("Resources"), resources]
                  });
                  return this.getOperatorList({
                    stream: pattern6,
                    task,
                    resources: patternResources,
                    operatorList: tilingOpList
                  }).then(function() {
                    const operatorListIR = tilingOpList.getIR();
                    const tilingPatternIR = (0, _pattern.getTilingPatternIR)(operatorListIR, patternDict, color);
                    operatorList.addDependencies(tilingOpList.dependencies);
                    operatorList.addOp(fn, tilingPatternIR);
                    if (patternDict.objId) {
                      localTilingPatternCache.set(null, patternDict.objId, {
                        operatorListIR,
                        dict: patternDict
                      });
                    }
                  }).catch((reason) => {
                    if (reason instanceof _util2.AbortException) {
                      return;
                    }
                    if (this.options.ignoreErrors) {
                      (0, _util2.warn)(`handleTilingType - ignoring pattern: "${reason}".`);
                      return;
                    }
                    throw reason;
                  });
                }
                handleSetFont(resources, fontArgs, fontRef, operatorList, task, state, fallbackFontDict = null, cssFontInfo = null) {
                  const fontName = fontArgs?.[0] instanceof _primitives.Name ? fontArgs[0].name : null;
                  return this.loadFont(fontName, fontRef, resources, fallbackFontDict, cssFontInfo).then((translated) => {
                    if (!translated.font.isType3Font) {
                      return translated;
                    }
                    return translated.loadType3Data(this, resources, task).then(function() {
                      operatorList.addDependencies(translated.type3Dependencies);
                      return translated;
                    }).catch((reason) => {
                      return new TranslatedFont({
                        loadedName: "g_font_error",
                        font: new _fonts.ErrorFont(`Type3 font load error: ${reason}`),
                        dict: translated.font,
                        evaluatorOptions: this.options
                      });
                    });
                  }).then((translated) => {
                    state.font = translated.font;
                    translated.send(this.handler);
                    return translated.loadedName;
                  });
                }
                handleText(chars, state) {
                  const font = state.font;
                  const glyphs = font.charsToGlyphs(chars);
                  if (font.data) {
                    const isAddToPathSet = !!(state.textRenderingMode & _util2.TextRenderingMode.ADD_TO_PATH_FLAG);
                    if (isAddToPathSet || state.fillColorSpace.name === "Pattern" || font.disableFontFace || this.options.disableFontFace) {
                      PartialEvaluator.buildFontPaths(font, glyphs, this.handler, this.options);
                    }
                  }
                  return glyphs;
                }
                ensureStateFont(state) {
                  if (state.font) {
                    return;
                  }
                  const reason = new _util2.FormatError("Missing setFont (Tf) operator before text rendering operator.");
                  if (this.options.ignoreErrors) {
                    (0, _util2.warn)(`ensureStateFont: "${reason}".`);
                    return;
                  }
                  throw reason;
                }
                async setGState({
                  resources,
                  gState,
                  operatorList,
                  cacheKey,
                  task,
                  stateManager,
                  localGStateCache,
                  localColorSpaceCache
                }) {
                  const gStateRef = gState.objId;
                  let isSimpleGState = true;
                  const gStateObj = [];
                  let promise = Promise.resolve();
                  for (const key2 of gState.getKeys()) {
                    const value = gState.get(key2);
                    switch (key2) {
                      case "Type":
                        break;
                      case "LW":
                      case "LC":
                      case "LJ":
                      case "ML":
                      case "D":
                      case "RI":
                      case "FL":
                      case "CA":
                      case "ca":
                        gStateObj.push([key2, value]);
                        break;
                      case "Font":
                        isSimpleGState = false;
                        promise = promise.then(() => {
                          return this.handleSetFont(resources, null, value[0], operatorList, task, stateManager.state).then(function(loadedName) {
                            operatorList.addDependency(loadedName);
                            gStateObj.push([key2, [loadedName, value[1]]]);
                          });
                        });
                        break;
                      case "BM":
                        gStateObj.push([key2, normalizeBlendMode(value)]);
                        break;
                      case "SMask":
                        if ((0, _primitives.isName)(value, "None")) {
                          gStateObj.push([key2, false]);
                          break;
                        }
                        if (value instanceof _primitives.Dict) {
                          isSimpleGState = false;
                          promise = promise.then(() => {
                            return this.handleSMask(value, resources, operatorList, task, stateManager, localColorSpaceCache);
                          });
                          gStateObj.push([key2, true]);
                        } else {
                          (0, _util2.warn)("Unsupported SMask type");
                        }
                        break;
                      case "TR":
                        const transferMaps = this.handleTransferFunction(value);
                        gStateObj.push([key2, transferMaps]);
                        break;
                      case "OP":
                      case "op":
                      case "OPM":
                      case "BG":
                      case "BG2":
                      case "UCR":
                      case "UCR2":
                      case "TR2":
                      case "HT":
                      case "SM":
                      case "SA":
                      case "AIS":
                      case "TK":
                        (0, _util2.info)("graphic state operator " + key2);
                        break;
                      default:
                        (0, _util2.info)("Unknown graphic state operator " + key2);
                        break;
                    }
                  }
                  return promise.then(function() {
                    if (gStateObj.length > 0) {
                      operatorList.addOp(_util2.OPS.setGState, [gStateObj]);
                    }
                    if (isSimpleGState) {
                      localGStateCache.set(cacheKey, gStateRef, gStateObj);
                    }
                  });
                }
                loadFont(fontName, font, resources, fallbackFontDict = null, cssFontInfo = null) {
                  const errorFont = async () => {
                    return new TranslatedFont({
                      loadedName: "g_font_error",
                      font: new _fonts.ErrorFont(`Font "${fontName}" is not available.`),
                      dict: font,
                      evaluatorOptions: this.options
                    });
                  };
                  let fontRef;
                  if (font) {
                    if (font instanceof _primitives.Ref) {
                      fontRef = font;
                    }
                  } else {
                    const fontRes = resources.get("Font");
                    if (fontRes) {
                      fontRef = fontRes.getRaw(fontName);
                    }
                  }
                  if (fontRef) {
                    if (this.parsingType3Font && this.type3FontRefs.has(fontRef)) {
                      return errorFont();
                    }
                    if (this.fontCache.has(fontRef)) {
                      return this.fontCache.get(fontRef);
                    }
                    font = this.xref.fetchIfRef(fontRef);
                  }
                  if (!(font instanceof _primitives.Dict)) {
                    if (!this.options.ignoreErrors && !this.parsingType3Font) {
                      (0, _util2.warn)(`Font "${fontName}" is not available.`);
                      return errorFont();
                    }
                    (0, _util2.warn)(`Font "${fontName}" is not available -- attempting to fallback to a default font.`);
                    font = fallbackFontDict || PartialEvaluator.fallbackFontDict;
                  }
                  if (font.cacheKey && this.fontCache.has(font.cacheKey)) {
                    return this.fontCache.get(font.cacheKey);
                  }
                  const fontCapability = new _util2.PromiseCapability();
                  let preEvaluatedFont;
                  try {
                    preEvaluatedFont = this.preEvaluateFont(font);
                    preEvaluatedFont.cssFontInfo = cssFontInfo;
                  } catch (reason) {
                    (0, _util2.warn)(`loadFont - preEvaluateFont failed: "${reason}".`);
                    return errorFont();
                  }
                  const {
                    descriptor,
                    hash: hash2
                  } = preEvaluatedFont;
                  const fontRefIsRef = fontRef instanceof _primitives.Ref;
                  let fontID;
                  if (hash2 && descriptor instanceof _primitives.Dict) {
                    const fontAliases = descriptor.fontAliases ||= /* @__PURE__ */ Object.create(null);
                    if (fontAliases[hash2]) {
                      const aliasFontRef = fontAliases[hash2].aliasRef;
                      if (fontRefIsRef && aliasFontRef && this.fontCache.has(aliasFontRef)) {
                        this.fontCache.putAlias(fontRef, aliasFontRef);
                        return this.fontCache.get(fontRef);
                      }
                    } else {
                      fontAliases[hash2] = {
                        fontID: this.idFactory.createFontId()
                      };
                    }
                    if (fontRefIsRef) {
                      fontAliases[hash2].aliasRef = fontRef;
                    }
                    fontID = fontAliases[hash2].fontID;
                  } else {
                    fontID = this.idFactory.createFontId();
                  }
                  (0, _util2.assert)(fontID?.startsWith("f"), 'The "fontID" must be (correctly) defined.');
                  if (fontRefIsRef) {
                    this.fontCache.put(fontRef, fontCapability.promise);
                  } else {
                    font.cacheKey = `cacheKey_${fontID}`;
                    this.fontCache.put(font.cacheKey, fontCapability.promise);
                  }
                  font.loadedName = `${this.idFactory.getDocId()}_${fontID}`;
                  this.translateFont(preEvaluatedFont).then((translatedFont) => {
                    fontCapability.resolve(new TranslatedFont({
                      loadedName: font.loadedName,
                      font: translatedFont,
                      dict: font,
                      evaluatorOptions: this.options
                    }));
                  }).catch((reason) => {
                    (0, _util2.warn)(`loadFont - translateFont failed: "${reason}".`);
                    fontCapability.resolve(new TranslatedFont({
                      loadedName: font.loadedName,
                      font: new _fonts.ErrorFont(reason instanceof Error ? reason.message : reason),
                      dict: font,
                      evaluatorOptions: this.options
                    }));
                  });
                  return fontCapability.promise;
                }
                buildPath(operatorList, fn, args, parsingText = false) {
                  const lastIndex = operatorList.length - 1;
                  if (!args) {
                    args = [];
                  }
                  if (lastIndex < 0 || operatorList.fnArray[lastIndex] !== _util2.OPS.constructPath) {
                    if (parsingText) {
                      (0, _util2.warn)(`Encountered path operator "${fn}" inside of a text object.`);
                      operatorList.addOp(_util2.OPS.save, null);
                    }
                    let minMax;
                    switch (fn) {
                      case _util2.OPS.rectangle:
                        const x = args[0] + args[2];
                        const y = args[1] + args[3];
                        minMax = [Math.min(args[0], x), Math.max(args[0], x), Math.min(args[1], y), Math.max(args[1], y)];
                        break;
                      case _util2.OPS.moveTo:
                      case _util2.OPS.lineTo:
                        minMax = [args[0], args[0], args[1], args[1]];
                        break;
                      default:
                        minMax = [Infinity, -Infinity, Infinity, -Infinity];
                        break;
                    }
                    operatorList.addOp(_util2.OPS.constructPath, [[fn], args, minMax]);
                    if (parsingText) {
                      operatorList.addOp(_util2.OPS.restore, null);
                    }
                  } else {
                    const opArgs = operatorList.argsArray[lastIndex];
                    opArgs[0].push(fn);
                    opArgs[1].push(...args);
                    const minMax = opArgs[2];
                    switch (fn) {
                      case _util2.OPS.rectangle:
                        const x = args[0] + args[2];
                        const y = args[1] + args[3];
                        minMax[0] = Math.min(minMax[0], args[0], x);
                        minMax[1] = Math.max(minMax[1], args[0], x);
                        minMax[2] = Math.min(minMax[2], args[1], y);
                        minMax[3] = Math.max(minMax[3], args[1], y);
                        break;
                      case _util2.OPS.moveTo:
                      case _util2.OPS.lineTo:
                        minMax[0] = Math.min(minMax[0], args[0]);
                        minMax[1] = Math.max(minMax[1], args[0]);
                        minMax[2] = Math.min(minMax[2], args[1]);
                        minMax[3] = Math.max(minMax[3], args[1]);
                        break;
                    }
                  }
                }
                parseColorSpace({
                  cs,
                  resources,
                  localColorSpaceCache
                }) {
                  return _colorspace.ColorSpace.parseAsync({
                    cs,
                    xref: this.xref,
                    resources,
                    pdfFunctionFactory: this._pdfFunctionFactory,
                    localColorSpaceCache
                  }).catch((reason) => {
                    if (reason instanceof _util2.AbortException) {
                      return null;
                    }
                    if (this.options.ignoreErrors) {
                      (0, _util2.warn)(`parseColorSpace - ignoring ColorSpace: "${reason}".`);
                      return null;
                    }
                    throw reason;
                  });
                }
                parseShading({
                  shading,
                  resources,
                  localColorSpaceCache,
                  localShadingPatternCache
                }) {
                  let id = localShadingPatternCache.get(shading);
                  if (!id) {
                    var shadingFill = _pattern.Pattern.parseShading(shading, this.xref, resources, this._pdfFunctionFactory, localColorSpaceCache);
                    const patternIR = shadingFill.getIR();
                    id = `pattern_${this.idFactory.createObjId()}`;
                    if (this.parsingType3Font) {
                      id = `${this.idFactory.getDocId()}_type3_${id}`;
                    }
                    localShadingPatternCache.set(shading, id);
                    if (this.parsingType3Font) {
                      this.handler.send("commonobj", [id, "Pattern", patternIR]);
                    } else {
                      this.handler.send("obj", [id, this.pageIndex, "Pattern", patternIR]);
                    }
                  }
                  return id;
                }
                handleColorN(operatorList, fn, args, cs, patterns, resources, task, localColorSpaceCache, localTilingPatternCache, localShadingPatternCache) {
                  const patternName = args.pop();
                  if (patternName instanceof _primitives.Name) {
                    const rawPattern = patterns.getRaw(patternName.name);
                    const localTilingPattern = rawPattern instanceof _primitives.Ref && localTilingPatternCache.getByRef(rawPattern);
                    if (localTilingPattern) {
                      try {
                        const color = cs.base ? cs.base.getRgb(args, 0) : null;
                        const tilingPatternIR = (0, _pattern.getTilingPatternIR)(localTilingPattern.operatorListIR, localTilingPattern.dict, color);
                        operatorList.addOp(fn, tilingPatternIR);
                        return void 0;
                      } catch {
                      }
                    }
                    const pattern6 = this.xref.fetchIfRef(rawPattern);
                    if (pattern6) {
                      const dict = pattern6 instanceof _base_stream.BaseStream ? pattern6.dict : pattern6;
                      const typeNum = dict.get("PatternType");
                      if (typeNum === PatternType.TILING) {
                        const color = cs.base ? cs.base.getRgb(args, 0) : null;
                        return this.handleTilingType(fn, color, resources, pattern6, dict, operatorList, task, localTilingPatternCache);
                      } else if (typeNum === PatternType.SHADING) {
                        const shading = dict.get("Shading");
                        const matrix = dict.getArray("Matrix");
                        const objId = this.parseShading({
                          shading,
                          resources,
                          localColorSpaceCache,
                          localShadingPatternCache
                        });
                        operatorList.addOp(fn, ["Shading", objId, matrix]);
                        return void 0;
                      }
                      throw new _util2.FormatError(`Unknown PatternType: ${typeNum}`);
                    }
                  }
                  throw new _util2.FormatError(`Unknown PatternName: ${patternName}`);
                }
                _parseVisibilityExpression(array4, nestingCounter, currentResult) {
                  const MAX_NESTING = 10;
                  if (++nestingCounter > MAX_NESTING) {
                    (0, _util2.warn)("Visibility expression is too deeply nested");
                    return;
                  }
                  const length2 = array4.length;
                  const operator = this.xref.fetchIfRef(array4[0]);
                  if (length2 < 2 || !(operator instanceof _primitives.Name)) {
                    (0, _util2.warn)("Invalid visibility expression");
                    return;
                  }
                  switch (operator.name) {
                    case "And":
                    case "Or":
                    case "Not":
                      currentResult.push(operator.name);
                      break;
                    default:
                      (0, _util2.warn)(`Invalid operator ${operator.name} in visibility expression`);
                      return;
                  }
                  for (let i = 1; i < length2; i++) {
                    const raw = array4[i];
                    const object4 = this.xref.fetchIfRef(raw);
                    if (Array.isArray(object4)) {
                      const nestedResult = [];
                      currentResult.push(nestedResult);
                      this._parseVisibilityExpression(object4, nestingCounter, nestedResult);
                    } else if (raw instanceof _primitives.Ref) {
                      currentResult.push(raw.toString());
                    }
                  }
                }
                async parseMarkedContentProps(contentProperties, resources) {
                  let optionalContent;
                  if (contentProperties instanceof _primitives.Name) {
                    const properties2 = resources.get("Properties");
                    optionalContent = properties2.get(contentProperties.name);
                  } else if (contentProperties instanceof _primitives.Dict) {
                    optionalContent = contentProperties;
                  } else {
                    throw new _util2.FormatError("Optional content properties malformed.");
                  }
                  const optionalContentType = optionalContent.get("Type")?.name;
                  if (optionalContentType === "OCG") {
                    return {
                      type: optionalContentType,
                      id: optionalContent.objId
                    };
                  } else if (optionalContentType === "OCMD") {
                    const expression = optionalContent.get("VE");
                    if (Array.isArray(expression)) {
                      const result = [];
                      this._parseVisibilityExpression(expression, 0, result);
                      if (result.length > 0) {
                        return {
                          type: "OCMD",
                          expression: result
                        };
                      }
                    }
                    const optionalContentGroups = optionalContent.get("OCGs");
                    if (Array.isArray(optionalContentGroups) || optionalContentGroups instanceof _primitives.Dict) {
                      const groupIds = [];
                      if (Array.isArray(optionalContentGroups)) {
                        for (const ocg of optionalContentGroups) {
                          groupIds.push(ocg.toString());
                        }
                      } else {
                        groupIds.push(optionalContentGroups.objId);
                      }
                      return {
                        type: optionalContentType,
                        ids: groupIds,
                        policy: optionalContent.get("P") instanceof _primitives.Name ? optionalContent.get("P").name : null,
                        expression: null
                      };
                    } else if (optionalContentGroups instanceof _primitives.Ref) {
                      return {
                        type: optionalContentType,
                        id: optionalContentGroups.toString()
                      };
                    }
                  }
                  return null;
                }
                getOperatorList({
                  stream,
                  task,
                  resources,
                  operatorList,
                  initialState = null,
                  fallbackFontDict = null
                }) {
                  resources ||= _primitives.Dict.empty;
                  initialState ||= new EvalState();
                  if (!operatorList) {
                    throw new Error('getOperatorList: missing "operatorList" parameter');
                  }
                  const self2 = this;
                  const xref = this.xref;
                  let parsingText = false;
                  const localImageCache = new _image_utils.LocalImageCache();
                  const localColorSpaceCache = new _image_utils.LocalColorSpaceCache();
                  const localGStateCache = new _image_utils.LocalGStateCache();
                  const localTilingPatternCache = new _image_utils.LocalTilingPatternCache();
                  const localShadingPatternCache = /* @__PURE__ */ new Map();
                  const xobjs = resources.get("XObject") || _primitives.Dict.empty;
                  const patterns = resources.get("Pattern") || _primitives.Dict.empty;
                  const stateManager = new StateManager(initialState);
                  const preprocessor = new EvaluatorPreprocessor(stream, xref, stateManager);
                  const timeSlotManager = new TimeSlotManager();
                  function closePendingRestoreOPS(argument) {
                    for (let i = 0, ii = preprocessor.savedStatesDepth; i < ii; i++) {
                      operatorList.addOp(_util2.OPS.restore, []);
                    }
                  }
                  return new Promise(function promiseBody(resolve, reject) {
                    const next2 = function(promise) {
                      Promise.all([promise, operatorList.ready]).then(function() {
                        try {
                          promiseBody(resolve, reject);
                        } catch (ex) {
                          reject(ex);
                        }
                      }, reject);
                    };
                    task.ensureNotTerminated();
                    timeSlotManager.reset();
                    const operation = {};
                    let stop, i, ii, cs, name, isValidName;
                    while (!(stop = timeSlotManager.check())) {
                      operation.args = null;
                      if (!preprocessor.read(operation)) {
                        break;
                      }
                      let args = operation.args;
                      let fn = operation.fn;
                      switch (fn | 0) {
                        case _util2.OPS.paintXObject:
                          isValidName = args[0] instanceof _primitives.Name;
                          name = args[0].name;
                          if (isValidName) {
                            const localImage = localImageCache.getByName(name);
                            if (localImage) {
                              operatorList.addImageOps(localImage.fn, localImage.args, localImage.optionalContent);
                              incrementCachedImageMaskCount(localImage);
                              args = null;
                              continue;
                            }
                          }
                          next2(new Promise(function(resolveXObject, rejectXObject) {
                            if (!isValidName) {
                              throw new _util2.FormatError("XObject must be referred to by name.");
                            }
                            let xobj = xobjs.getRaw(name);
                            if (xobj instanceof _primitives.Ref) {
                              const localImage = localImageCache.getByRef(xobj) || self2._regionalImageCache.getByRef(xobj);
                              if (localImage) {
                                operatorList.addImageOps(localImage.fn, localImage.args, localImage.optionalContent);
                                incrementCachedImageMaskCount(localImage);
                                resolveXObject();
                                return;
                              }
                              const globalImage = self2.globalImageCache.getData(xobj, self2.pageIndex);
                              if (globalImage) {
                                operatorList.addDependency(globalImage.objId);
                                operatorList.addImageOps(globalImage.fn, globalImage.args, globalImage.optionalContent);
                                resolveXObject();
                                return;
                              }
                              xobj = xref.fetch(xobj);
                            }
                            if (!(xobj instanceof _base_stream.BaseStream)) {
                              throw new _util2.FormatError("XObject should be a stream");
                            }
                            const type5 = xobj.dict.get("Subtype");
                            if (!(type5 instanceof _primitives.Name)) {
                              throw new _util2.FormatError("XObject should have a Name subtype");
                            }
                            if (type5.name === "Form") {
                              stateManager.save();
                              self2.buildFormXObject(resources, xobj, null, operatorList, task, stateManager.state.clone(), localColorSpaceCache).then(function() {
                                stateManager.restore();
                                resolveXObject();
                              }, rejectXObject);
                              return;
                            } else if (type5.name === "Image") {
                              self2.buildPaintImageXObject({
                                resources,
                                image: xobj,
                                operatorList,
                                cacheKey: name,
                                localImageCache,
                                localColorSpaceCache
                              }).then(resolveXObject, rejectXObject);
                              return;
                            } else if (type5.name === "PS") {
                              (0, _util2.info)("Ignored XObject subtype PS");
                            } else {
                              throw new _util2.FormatError(`Unhandled XObject subtype ${type5.name}`);
                            }
                            resolveXObject();
                          }).catch(function(reason) {
                            if (reason instanceof _util2.AbortException) {
                              return;
                            }
                            if (self2.options.ignoreErrors) {
                              (0, _util2.warn)(`getOperatorList - ignoring XObject: "${reason}".`);
                              return;
                            }
                            throw reason;
                          }));
                          return;
                        case _util2.OPS.setFont:
                          var fontSize = args[1];
                          next2(self2.handleSetFont(resources, args, null, operatorList, task, stateManager.state, fallbackFontDict).then(function(loadedName) {
                            operatorList.addDependency(loadedName);
                            operatorList.addOp(_util2.OPS.setFont, [loadedName, fontSize]);
                          }));
                          return;
                        case _util2.OPS.beginText:
                          parsingText = true;
                          break;
                        case _util2.OPS.endText:
                          parsingText = false;
                          break;
                        case _util2.OPS.endInlineImage:
                          var cacheKey = args[0].cacheKey;
                          if (cacheKey) {
                            const localImage = localImageCache.getByName(cacheKey);
                            if (localImage) {
                              operatorList.addImageOps(localImage.fn, localImage.args, localImage.optionalContent);
                              incrementCachedImageMaskCount(localImage);
                              args = null;
                              continue;
                            }
                          }
                          next2(self2.buildPaintImageXObject({
                            resources,
                            image: args[0],
                            isInline: true,
                            operatorList,
                            cacheKey,
                            localImageCache,
                            localColorSpaceCache
                          }));
                          return;
                        case _util2.OPS.showText:
                          if (!stateManager.state.font) {
                            self2.ensureStateFont(stateManager.state);
                            continue;
                          }
                          args[0] = self2.handleText(args[0], stateManager.state);
                          break;
                        case _util2.OPS.showSpacedText:
                          if (!stateManager.state.font) {
                            self2.ensureStateFont(stateManager.state);
                            continue;
                          }
                          var combinedGlyphs = [];
                          var state = stateManager.state;
                          for (const arrItem of args[0]) {
                            if (typeof arrItem === "string") {
                              combinedGlyphs.push(...self2.handleText(arrItem, state));
                            } else if (typeof arrItem === "number") {
                              combinedGlyphs.push(arrItem);
                            }
                          }
                          args[0] = combinedGlyphs;
                          fn = _util2.OPS.showText;
                          break;
                        case _util2.OPS.nextLineShowText:
                          if (!stateManager.state.font) {
                            self2.ensureStateFont(stateManager.state);
                            continue;
                          }
                          operatorList.addOp(_util2.OPS.nextLine);
                          args[0] = self2.handleText(args[0], stateManager.state);
                          fn = _util2.OPS.showText;
                          break;
                        case _util2.OPS.nextLineSetSpacingShowText:
                          if (!stateManager.state.font) {
                            self2.ensureStateFont(stateManager.state);
                            continue;
                          }
                          operatorList.addOp(_util2.OPS.nextLine);
                          operatorList.addOp(_util2.OPS.setWordSpacing, [args.shift()]);
                          operatorList.addOp(_util2.OPS.setCharSpacing, [args.shift()]);
                          args[0] = self2.handleText(args[0], stateManager.state);
                          fn = _util2.OPS.showText;
                          break;
                        case _util2.OPS.setTextRenderingMode:
                          stateManager.state.textRenderingMode = args[0];
                          break;
                        case _util2.OPS.setFillColorSpace: {
                          const cachedColorSpace = _colorspace.ColorSpace.getCached(args[0], xref, localColorSpaceCache);
                          if (cachedColorSpace) {
                            stateManager.state.fillColorSpace = cachedColorSpace;
                            continue;
                          }
                          next2(self2.parseColorSpace({
                            cs: args[0],
                            resources,
                            localColorSpaceCache
                          }).then(function(colorSpace) {
                            if (colorSpace) {
                              stateManager.state.fillColorSpace = colorSpace;
                            }
                          }));
                          return;
                        }
                        case _util2.OPS.setStrokeColorSpace: {
                          const cachedColorSpace = _colorspace.ColorSpace.getCached(args[0], xref, localColorSpaceCache);
                          if (cachedColorSpace) {
                            stateManager.state.strokeColorSpace = cachedColorSpace;
                            continue;
                          }
                          next2(self2.parseColorSpace({
                            cs: args[0],
                            resources,
                            localColorSpaceCache
                          }).then(function(colorSpace) {
                            if (colorSpace) {
                              stateManager.state.strokeColorSpace = colorSpace;
                            }
                          }));
                          return;
                        }
                        case _util2.OPS.setFillColor:
                          cs = stateManager.state.fillColorSpace;
                          args = cs.getRgb(args, 0);
                          fn = _util2.OPS.setFillRGBColor;
                          break;
                        case _util2.OPS.setStrokeColor:
                          cs = stateManager.state.strokeColorSpace;
                          args = cs.getRgb(args, 0);
                          fn = _util2.OPS.setStrokeRGBColor;
                          break;
                        case _util2.OPS.setFillGray:
                          stateManager.state.fillColorSpace = _colorspace.ColorSpace.singletons.gray;
                          args = _colorspace.ColorSpace.singletons.gray.getRgb(args, 0);
                          fn = _util2.OPS.setFillRGBColor;
                          break;
                        case _util2.OPS.setStrokeGray:
                          stateManager.state.strokeColorSpace = _colorspace.ColorSpace.singletons.gray;
                          args = _colorspace.ColorSpace.singletons.gray.getRgb(args, 0);
                          fn = _util2.OPS.setStrokeRGBColor;
                          break;
                        case _util2.OPS.setFillCMYKColor:
                          stateManager.state.fillColorSpace = _colorspace.ColorSpace.singletons.cmyk;
                          args = _colorspace.ColorSpace.singletons.cmyk.getRgb(args, 0);
                          fn = _util2.OPS.setFillRGBColor;
                          break;
                        case _util2.OPS.setStrokeCMYKColor:
                          stateManager.state.strokeColorSpace = _colorspace.ColorSpace.singletons.cmyk;
                          args = _colorspace.ColorSpace.singletons.cmyk.getRgb(args, 0);
                          fn = _util2.OPS.setStrokeRGBColor;
                          break;
                        case _util2.OPS.setFillRGBColor:
                          stateManager.state.fillColorSpace = _colorspace.ColorSpace.singletons.rgb;
                          args = _colorspace.ColorSpace.singletons.rgb.getRgb(args, 0);
                          break;
                        case _util2.OPS.setStrokeRGBColor:
                          stateManager.state.strokeColorSpace = _colorspace.ColorSpace.singletons.rgb;
                          args = _colorspace.ColorSpace.singletons.rgb.getRgb(args, 0);
                          break;
                        case _util2.OPS.setFillColorN:
                          cs = stateManager.state.fillColorSpace;
                          if (cs.name === "Pattern") {
                            next2(self2.handleColorN(operatorList, _util2.OPS.setFillColorN, args, cs, patterns, resources, task, localColorSpaceCache, localTilingPatternCache, localShadingPatternCache));
                            return;
                          }
                          args = cs.getRgb(args, 0);
                          fn = _util2.OPS.setFillRGBColor;
                          break;
                        case _util2.OPS.setStrokeColorN:
                          cs = stateManager.state.strokeColorSpace;
                          if (cs.name === "Pattern") {
                            next2(self2.handleColorN(operatorList, _util2.OPS.setStrokeColorN, args, cs, patterns, resources, task, localColorSpaceCache, localTilingPatternCache, localShadingPatternCache));
                            return;
                          }
                          args = cs.getRgb(args, 0);
                          fn = _util2.OPS.setStrokeRGBColor;
                          break;
                        case _util2.OPS.shadingFill:
                          var shadingRes = resources.get("Shading");
                          if (!shadingRes) {
                            throw new _util2.FormatError("No shading resource found");
                          }
                          var shading = shadingRes.get(args[0].name);
                          if (!shading) {
                            throw new _util2.FormatError("No shading object found");
                          }
                          const patternId = self2.parseShading({
                            shading,
                            resources,
                            localColorSpaceCache,
                            localShadingPatternCache
                          });
                          args = [patternId];
                          fn = _util2.OPS.shadingFill;
                          break;
                        case _util2.OPS.setGState:
                          isValidName = args[0] instanceof _primitives.Name;
                          name = args[0].name;
                          if (isValidName) {
                            const localGStateObj = localGStateCache.getByName(name);
                            if (localGStateObj) {
                              if (localGStateObj.length > 0) {
                                operatorList.addOp(_util2.OPS.setGState, [localGStateObj]);
                              }
                              args = null;
                              continue;
                            }
                          }
                          next2(new Promise(function(resolveGState, rejectGState) {
                            if (!isValidName) {
                              throw new _util2.FormatError("GState must be referred to by name.");
                            }
                            const extGState = resources.get("ExtGState");
                            if (!(extGState instanceof _primitives.Dict)) {
                              throw new _util2.FormatError("ExtGState should be a dictionary.");
                            }
                            const gState = extGState.get(name);
                            if (!(gState instanceof _primitives.Dict)) {
                              throw new _util2.FormatError("GState should be a dictionary.");
                            }
                            self2.setGState({
                              resources,
                              gState,
                              operatorList,
                              cacheKey: name,
                              task,
                              stateManager,
                              localGStateCache,
                              localColorSpaceCache
                            }).then(resolveGState, rejectGState);
                          }).catch(function(reason) {
                            if (reason instanceof _util2.AbortException) {
                              return;
                            }
                            if (self2.options.ignoreErrors) {
                              (0, _util2.warn)(`getOperatorList - ignoring ExtGState: "${reason}".`);
                              return;
                            }
                            throw reason;
                          }));
                          return;
                        case _util2.OPS.moveTo:
                        case _util2.OPS.lineTo:
                        case _util2.OPS.curveTo:
                        case _util2.OPS.curveTo2:
                        case _util2.OPS.curveTo3:
                        case _util2.OPS.closePath:
                        case _util2.OPS.rectangle:
                          self2.buildPath(operatorList, fn, args, parsingText);
                          continue;
                        case _util2.OPS.markPoint:
                        case _util2.OPS.markPointProps:
                        case _util2.OPS.beginCompat:
                        case _util2.OPS.endCompat:
                          continue;
                        case _util2.OPS.beginMarkedContentProps:
                          if (!(args[0] instanceof _primitives.Name)) {
                            (0, _util2.warn)(`Expected name for beginMarkedContentProps arg0=${args[0]}`);
                            continue;
                          }
                          if (args[0].name === "OC") {
                            next2(self2.parseMarkedContentProps(args[1], resources).then((data2) => {
                              operatorList.addOp(_util2.OPS.beginMarkedContentProps, ["OC", data2]);
                            }).catch((reason) => {
                              if (reason instanceof _util2.AbortException) {
                                return;
                              }
                              if (self2.options.ignoreErrors) {
                                (0, _util2.warn)(`getOperatorList - ignoring beginMarkedContentProps: "${reason}".`);
                                return;
                              }
                              throw reason;
                            }));
                            return;
                          }
                          args = [args[0].name, args[1] instanceof _primitives.Dict ? args[1].get("MCID") : null];
                          break;
                        case _util2.OPS.beginMarkedContent:
                        case _util2.OPS.endMarkedContent:
                        default:
                          if (args !== null) {
                            for (i = 0, ii = args.length; i < ii; i++) {
                              if (args[i] instanceof _primitives.Dict) {
                                break;
                              }
                            }
                            if (i < ii) {
                              (0, _util2.warn)("getOperatorList - ignoring operator: " + fn);
                              continue;
                            }
                          }
                      }
                      operatorList.addOp(fn, args);
                    }
                    if (stop) {
                      next2(deferred);
                      return;
                    }
                    closePendingRestoreOPS();
                    resolve();
                  }).catch((reason) => {
                    if (reason instanceof _util2.AbortException) {
                      return;
                    }
                    if (this.options.ignoreErrors) {
                      (0, _util2.warn)(`getOperatorList - ignoring errors during "${task.name}" task: "${reason}".`);
                      closePendingRestoreOPS();
                      return;
                    }
                    throw reason;
                  });
                }
                getTextContent({
                  stream,
                  task,
                  resources,
                  stateManager = null,
                  includeMarkedContent = false,
                  sink,
                  seenStyles = /* @__PURE__ */ new Set(),
                  viewBox,
                  markedContentData = null,
                  disableNormalization = false
                }) {
                  resources ||= _primitives.Dict.empty;
                  stateManager ||= new StateManager(new TextState());
                  if (includeMarkedContent) {
                    markedContentData ||= {
                      level: 0
                    };
                  }
                  const textContent = {
                    items: [],
                    styles: /* @__PURE__ */ Object.create(null)
                  };
                  const textContentItem = {
                    initialized: false,
                    str: [],
                    totalWidth: 0,
                    totalHeight: 0,
                    width: 0,
                    height: 0,
                    vertical: false,
                    prevTransform: null,
                    textAdvanceScale: 0,
                    spaceInFlowMin: 0,
                    spaceInFlowMax: 0,
                    trackingSpaceMin: Infinity,
                    negativeSpaceMax: -Infinity,
                    notASpace: -Infinity,
                    transform: null,
                    fontName: null,
                    hasEOL: false
                  };
                  const twoLastChars = [" ", " "];
                  let twoLastCharsPos = 0;
                  function saveLastChar(char2) {
                    const nextPos = (twoLastCharsPos + 1) % 2;
                    const ret = twoLastChars[twoLastCharsPos] !== " " && twoLastChars[nextPos] === " ";
                    twoLastChars[twoLastCharsPos] = char2;
                    twoLastCharsPos = nextPos;
                    return ret;
                  }
                  function shouldAddWhitepsace() {
                    return twoLastChars[twoLastCharsPos] !== " " && twoLastChars[(twoLastCharsPos + 1) % 2] === " ";
                  }
                  function resetLastChars() {
                    twoLastChars[0] = twoLastChars[1] = " ";
                    twoLastCharsPos = 0;
                  }
                  const TRACKING_SPACE_FACTOR = 0.102;
                  const NOT_A_SPACE_FACTOR = 0.03;
                  const NEGATIVE_SPACE_FACTOR = -0.2;
                  const SPACE_IN_FLOW_MIN_FACTOR = 0.102;
                  const SPACE_IN_FLOW_MAX_FACTOR = 0.6;
                  const VERTICAL_SHIFT_RATIO = 0.25;
                  const self2 = this;
                  const xref = this.xref;
                  const showSpacedTextBuffer = [];
                  let xobjs = null;
                  const emptyXObjectCache = new _image_utils.LocalImageCache();
                  const emptyGStateCache = new _image_utils.LocalGStateCache();
                  const preprocessor = new EvaluatorPreprocessor(stream, xref, stateManager);
                  let textState;
                  function pushWhitespace({
                    width = 0,
                    height = 0,
                    transform = textContentItem.prevTransform,
                    fontName = textContentItem.fontName
                  }) {
                    textContent.items.push({
                      str: " ",
                      dir: "ltr",
                      width,
                      height,
                      transform,
                      fontName,
                      hasEOL: false
                    });
                  }
                  function getCurrentTextTransform() {
                    const font = textState.font;
                    const tsm = [textState.fontSize * textState.textHScale, 0, 0, textState.fontSize, 0, textState.textRise];
                    if (font.isType3Font && (textState.fontSize <= 1 || font.isCharBBox) && !(0, _util2.isArrayEqual)(textState.fontMatrix, _util2.FONT_IDENTITY_MATRIX)) {
                      const glyphHeight = font.bbox[3] - font.bbox[1];
                      if (glyphHeight > 0) {
                        tsm[3] *= glyphHeight * textState.fontMatrix[3];
                      }
                    }
                    return _util2.Util.transform(textState.ctm, _util2.Util.transform(textState.textMatrix, tsm));
                  }
                  function ensureTextContentItem() {
                    if (textContentItem.initialized) {
                      return textContentItem;
                    }
                    const {
                      font,
                      loadedName
                    } = textState;
                    if (!seenStyles.has(loadedName)) {
                      seenStyles.add(loadedName);
                      textContent.styles[loadedName] = {
                        fontFamily: font.fallbackName,
                        ascent: font.ascent,
                        descent: font.descent,
                        vertical: font.vertical
                      };
                    }
                    textContentItem.fontName = loadedName;
                    const trm = textContentItem.transform = getCurrentTextTransform();
                    if (!font.vertical) {
                      textContentItem.width = textContentItem.totalWidth = 0;
                      textContentItem.height = textContentItem.totalHeight = Math.hypot(trm[2], trm[3]);
                      textContentItem.vertical = false;
                    } else {
                      textContentItem.width = textContentItem.totalWidth = Math.hypot(trm[0], trm[1]);
                      textContentItem.height = textContentItem.totalHeight = 0;
                      textContentItem.vertical = true;
                    }
                    const scaleLineX = Math.hypot(textState.textLineMatrix[0], textState.textLineMatrix[1]);
                    const scaleCtmX = Math.hypot(textState.ctm[0], textState.ctm[1]);
                    textContentItem.textAdvanceScale = scaleCtmX * scaleLineX;
                    const {
                      fontSize
                    } = textState;
                    textContentItem.trackingSpaceMin = fontSize * TRACKING_SPACE_FACTOR;
                    textContentItem.notASpace = fontSize * NOT_A_SPACE_FACTOR;
                    textContentItem.negativeSpaceMax = fontSize * NEGATIVE_SPACE_FACTOR;
                    textContentItem.spaceInFlowMin = fontSize * SPACE_IN_FLOW_MIN_FACTOR;
                    textContentItem.spaceInFlowMax = fontSize * SPACE_IN_FLOW_MAX_FACTOR;
                    textContentItem.hasEOL = false;
                    textContentItem.initialized = true;
                    return textContentItem;
                  }
                  function updateAdvanceScale() {
                    if (!textContentItem.initialized) {
                      return;
                    }
                    const scaleLineX = Math.hypot(textState.textLineMatrix[0], textState.textLineMatrix[1]);
                    const scaleCtmX = Math.hypot(textState.ctm[0], textState.ctm[1]);
                    const scaleFactor = scaleCtmX * scaleLineX;
                    if (scaleFactor === textContentItem.textAdvanceScale) {
                      return;
                    }
                    if (!textContentItem.vertical) {
                      textContentItem.totalWidth += textContentItem.width * textContentItem.textAdvanceScale;
                      textContentItem.width = 0;
                    } else {
                      textContentItem.totalHeight += textContentItem.height * textContentItem.textAdvanceScale;
                      textContentItem.height = 0;
                    }
                    textContentItem.textAdvanceScale = scaleFactor;
                  }
                  function runBidiTransform(textChunk) {
                    let text = textChunk.str.join("");
                    if (!disableNormalization) {
                      text = (0, _util2.normalizeUnicode)(text);
                    }
                    const bidiResult = (0, _bidi.bidi)(text, -1, textChunk.vertical);
                    return {
                      str: bidiResult.str,
                      dir: bidiResult.dir,
                      width: Math.abs(textChunk.totalWidth),
                      height: Math.abs(textChunk.totalHeight),
                      transform: textChunk.transform,
                      fontName: textChunk.fontName,
                      hasEOL: textChunk.hasEOL
                    };
                  }
                  function handleSetFont(fontName, fontRef) {
                    return self2.loadFont(fontName, fontRef, resources).then(function(translated) {
                      if (!translated.font.isType3Font) {
                        return translated;
                      }
                      return translated.loadType3Data(self2, resources, task).catch(function() {
                      }).then(function() {
                        return translated;
                      });
                    }).then(function(translated) {
                      textState.loadedName = translated.loadedName;
                      textState.font = translated.font;
                      textState.fontMatrix = translated.font.fontMatrix || _util2.FONT_IDENTITY_MATRIX;
                    });
                  }
                  function applyInverseRotation(x, y, matrix) {
                    const scale = Math.hypot(matrix[0], matrix[1]);
                    return [(matrix[0] * x + matrix[1] * y) / scale, (matrix[2] * x + matrix[3] * y) / scale];
                  }
                  function compareWithLastPosition(glyphWidth) {
                    const currentTransform = getCurrentTextTransform();
                    let posX = currentTransform[4];
                    let posY = currentTransform[5];
                    if (textState.font?.vertical) {
                      if (posX < viewBox[0] || posX > viewBox[2] || posY + glyphWidth < viewBox[1] || posY > viewBox[3]) {
                        return false;
                      }
                    } else if (posX + glyphWidth < viewBox[0] || posX > viewBox[2] || posY < viewBox[1] || posY > viewBox[3]) {
                      return false;
                    }
                    if (!textState.font || !textContentItem.prevTransform) {
                      return true;
                    }
                    let lastPosX = textContentItem.prevTransform[4];
                    let lastPosY = textContentItem.prevTransform[5];
                    if (lastPosX === posX && lastPosY === posY) {
                      return true;
                    }
                    let rotate2 = -1;
                    if (currentTransform[0] && currentTransform[1] === 0 && currentTransform[2] === 0) {
                      rotate2 = currentTransform[0] > 0 ? 0 : 180;
                    } else if (currentTransform[1] && currentTransform[0] === 0 && currentTransform[3] === 0) {
                      rotate2 = currentTransform[1] > 0 ? 90 : 270;
                    }
                    switch (rotate2) {
                      case 0:
                        break;
                      case 90:
                        [posX, posY] = [posY, posX];
                        [lastPosX, lastPosY] = [lastPosY, lastPosX];
                        break;
                      case 180:
                        [posX, posY, lastPosX, lastPosY] = [-posX, -posY, -lastPosX, -lastPosY];
                        break;
                      case 270:
                        [posX, posY] = [-posY, -posX];
                        [lastPosX, lastPosY] = [-lastPosY, -lastPosX];
                        break;
                      default:
                        [posX, posY] = applyInverseRotation(posX, posY, currentTransform);
                        [lastPosX, lastPosY] = applyInverseRotation(lastPosX, lastPosY, textContentItem.prevTransform);
                    }
                    if (textState.font.vertical) {
                      const advanceY2 = (lastPosY - posY) / textContentItem.textAdvanceScale;
                      const advanceX2 = posX - lastPosX;
                      const textOrientation2 = Math.sign(textContentItem.height);
                      if (advanceY2 < textOrientation2 * textContentItem.negativeSpaceMax) {
                        if (Math.abs(advanceX2) > 0.5 * textContentItem.width) {
                          appendEOL();
                          return true;
                        }
                        resetLastChars();
                        flushTextContentItem();
                        return true;
                      }
                      if (Math.abs(advanceX2) > textContentItem.width) {
                        appendEOL();
                        return true;
                      }
                      if (advanceY2 <= textOrientation2 * textContentItem.notASpace) {
                        resetLastChars();
                      }
                      if (advanceY2 <= textOrientation2 * textContentItem.trackingSpaceMin) {
                        if (shouldAddWhitepsace()) {
                          resetLastChars();
                          flushTextContentItem();
                          pushWhitespace({
                            height: Math.abs(advanceY2)
                          });
                        } else {
                          textContentItem.height += advanceY2;
                        }
                      } else if (!addFakeSpaces(advanceY2, textContentItem.prevTransform, textOrientation2)) {
                        if (textContentItem.str.length === 0) {
                          resetLastChars();
                          pushWhitespace({
                            height: Math.abs(advanceY2)
                          });
                        } else {
                          textContentItem.height += advanceY2;
                        }
                      }
                      if (Math.abs(advanceX2) > textContentItem.width * VERTICAL_SHIFT_RATIO) {
                        flushTextContentItem();
                      }
                      return true;
                    }
                    const advanceX = (posX - lastPosX) / textContentItem.textAdvanceScale;
                    const advanceY = posY - lastPosY;
                    const textOrientation = Math.sign(textContentItem.width);
                    if (advanceX < textOrientation * textContentItem.negativeSpaceMax) {
                      if (Math.abs(advanceY) > 0.5 * textContentItem.height) {
                        appendEOL();
                        return true;
                      }
                      resetLastChars();
                      flushTextContentItem();
                      return true;
                    }
                    if (Math.abs(advanceY) > textContentItem.height) {
                      appendEOL();
                      return true;
                    }
                    if (advanceX <= textOrientation * textContentItem.notASpace) {
                      resetLastChars();
                    }
                    if (advanceX <= textOrientation * textContentItem.trackingSpaceMin) {
                      if (shouldAddWhitepsace()) {
                        resetLastChars();
                        flushTextContentItem();
                        pushWhitespace({
                          width: Math.abs(advanceX)
                        });
                      } else {
                        textContentItem.width += advanceX;
                      }
                    } else if (!addFakeSpaces(advanceX, textContentItem.prevTransform, textOrientation)) {
                      if (textContentItem.str.length === 0) {
                        resetLastChars();
                        pushWhitespace({
                          width: Math.abs(advanceX)
                        });
                      } else {
                        textContentItem.width += advanceX;
                      }
                    }
                    if (Math.abs(advanceY) > textContentItem.height * VERTICAL_SHIFT_RATIO) {
                      flushTextContentItem();
                    }
                    return true;
                  }
                  function buildTextContentItem({
                    chars,
                    extraSpacing
                  }) {
                    const font = textState.font;
                    if (!chars) {
                      const charSpacing = textState.charSpacing + extraSpacing;
                      if (charSpacing) {
                        if (!font.vertical) {
                          textState.translateTextMatrix(charSpacing * textState.textHScale, 0);
                        } else {
                          textState.translateTextMatrix(0, -charSpacing);
                        }
                      }
                      return;
                    }
                    const glyphs = font.charsToGlyphs(chars);
                    const scale = textState.fontMatrix[0] * textState.fontSize;
                    for (let i = 0, ii = glyphs.length; i < ii; i++) {
                      const glyph = glyphs[i];
                      const {
                        category
                      } = glyph;
                      if (category.isInvisibleFormatMark) {
                        continue;
                      }
                      let charSpacing = textState.charSpacing + (i + 1 === ii ? extraSpacing : 0);
                      let glyphWidth = glyph.width;
                      if (font.vertical) {
                        glyphWidth = glyph.vmetric ? glyph.vmetric[0] : -glyphWidth;
                      }
                      let scaledDim = glyphWidth * scale;
                      if (category.isWhitespace) {
                        if (!font.vertical) {
                          charSpacing += scaledDim + textState.wordSpacing;
                          textState.translateTextMatrix(charSpacing * textState.textHScale, 0);
                        } else {
                          charSpacing += -scaledDim + textState.wordSpacing;
                          textState.translateTextMatrix(0, -charSpacing);
                        }
                        saveLastChar(" ");
                        continue;
                      }
                      if (!category.isZeroWidthDiacritic && !compareWithLastPosition(scaledDim)) {
                        if (!font.vertical) {
                          textState.translateTextMatrix(scaledDim * textState.textHScale, 0);
                        } else {
                          textState.translateTextMatrix(0, scaledDim);
                        }
                        continue;
                      }
                      const textChunk = ensureTextContentItem();
                      if (category.isZeroWidthDiacritic) {
                        scaledDim = 0;
                      }
                      if (!font.vertical) {
                        scaledDim *= textState.textHScale;
                        textState.translateTextMatrix(scaledDim, 0);
                        textChunk.width += scaledDim;
                      } else {
                        textState.translateTextMatrix(0, scaledDim);
                        scaledDim = Math.abs(scaledDim);
                        textChunk.height += scaledDim;
                      }
                      if (scaledDim) {
                        textChunk.prevTransform = getCurrentTextTransform();
                      }
                      const glyphUnicode = glyph.unicode;
                      if (saveLastChar(glyphUnicode)) {
                        textChunk.str.push(" ");
                      }
                      textChunk.str.push(glyphUnicode);
                      if (charSpacing) {
                        if (!font.vertical) {
                          textState.translateTextMatrix(charSpacing * textState.textHScale, 0);
                        } else {
                          textState.translateTextMatrix(0, -charSpacing);
                        }
                      }
                    }
                  }
                  function appendEOL() {
                    resetLastChars();
                    if (textContentItem.initialized) {
                      textContentItem.hasEOL = true;
                      flushTextContentItem();
                    } else {
                      textContent.items.push({
                        str: "",
                        dir: "ltr",
                        width: 0,
                        height: 0,
                        transform: getCurrentTextTransform(),
                        fontName: textState.loadedName,
                        hasEOL: true
                      });
                    }
                  }
                  function addFakeSpaces(width, transf, textOrientation) {
                    if (textOrientation * textContentItem.spaceInFlowMin <= width && width <= textOrientation * textContentItem.spaceInFlowMax) {
                      if (textContentItem.initialized) {
                        resetLastChars();
                        textContentItem.str.push(" ");
                      }
                      return false;
                    }
                    const fontName = textContentItem.fontName;
                    let height = 0;
                    if (textContentItem.vertical) {
                      height = width;
                      width = 0;
                    }
                    flushTextContentItem();
                    resetLastChars();
                    pushWhitespace({
                      width: Math.abs(width),
                      height: Math.abs(height),
                      transform: transf || getCurrentTextTransform(),
                      fontName
                    });
                    return true;
                  }
                  function flushTextContentItem() {
                    if (!textContentItem.initialized || !textContentItem.str) {
                      return;
                    }
                    if (!textContentItem.vertical) {
                      textContentItem.totalWidth += textContentItem.width * textContentItem.textAdvanceScale;
                    } else {
                      textContentItem.totalHeight += textContentItem.height * textContentItem.textAdvanceScale;
                    }
                    textContent.items.push(runBidiTransform(textContentItem));
                    textContentItem.initialized = false;
                    textContentItem.str.length = 0;
                  }
                  function enqueueChunk(batch = false) {
                    const length2 = textContent.items.length;
                    if (length2 === 0) {
                      return;
                    }
                    if (batch && length2 < TEXT_CHUNK_BATCH_SIZE) {
                      return;
                    }
                    sink.enqueue(textContent, length2);
                    textContent.items = [];
                    textContent.styles = /* @__PURE__ */ Object.create(null);
                  }
                  const timeSlotManager = new TimeSlotManager();
                  return new Promise(function promiseBody(resolve, reject) {
                    const next2 = function(promise) {
                      enqueueChunk(true);
                      Promise.all([promise, sink.ready]).then(function() {
                        try {
                          promiseBody(resolve, reject);
                        } catch (ex) {
                          reject(ex);
                        }
                      }, reject);
                    };
                    task.ensureNotTerminated();
                    timeSlotManager.reset();
                    const operation = {};
                    let stop, args = [];
                    while (!(stop = timeSlotManager.check())) {
                      args.length = 0;
                      operation.args = args;
                      if (!preprocessor.read(operation)) {
                        break;
                      }
                      const previousState = textState;
                      textState = stateManager.state;
                      const fn = operation.fn;
                      args = operation.args;
                      switch (fn | 0) {
                        case _util2.OPS.setFont:
                          var fontNameArg = args[0].name, fontSizeArg = args[1];
                          if (textState.font && fontNameArg === textState.fontName && fontSizeArg === textState.fontSize) {
                            break;
                          }
                          flushTextContentItem();
                          textState.fontName = fontNameArg;
                          textState.fontSize = fontSizeArg;
                          next2(handleSetFont(fontNameArg, null));
                          return;
                        case _util2.OPS.setTextRise:
                          textState.textRise = args[0];
                          break;
                        case _util2.OPS.setHScale:
                          textState.textHScale = args[0] / 100;
                          break;
                        case _util2.OPS.setLeading:
                          textState.leading = args[0];
                          break;
                        case _util2.OPS.moveText:
                          textState.translateTextLineMatrix(args[0], args[1]);
                          textState.textMatrix = textState.textLineMatrix.slice();
                          break;
                        case _util2.OPS.setLeadingMoveText:
                          textState.leading = -args[1];
                          textState.translateTextLineMatrix(args[0], args[1]);
                          textState.textMatrix = textState.textLineMatrix.slice();
                          break;
                        case _util2.OPS.nextLine:
                          textState.carriageReturn();
                          break;
                        case _util2.OPS.setTextMatrix:
                          textState.setTextMatrix(args[0], args[1], args[2], args[3], args[4], args[5]);
                          textState.setTextLineMatrix(args[0], args[1], args[2], args[3], args[4], args[5]);
                          updateAdvanceScale();
                          break;
                        case _util2.OPS.setCharSpacing:
                          textState.charSpacing = args[0];
                          break;
                        case _util2.OPS.setWordSpacing:
                          textState.wordSpacing = args[0];
                          break;
                        case _util2.OPS.beginText:
                          textState.textMatrix = _util2.IDENTITY_MATRIX.slice();
                          textState.textLineMatrix = _util2.IDENTITY_MATRIX.slice();
                          break;
                        case _util2.OPS.showSpacedText:
                          if (!stateManager.state.font) {
                            self2.ensureStateFont(stateManager.state);
                            continue;
                          }
                          const spaceFactor = (textState.font.vertical ? 1 : -1) * textState.fontSize / 1e3;
                          const elements = args[0];
                          for (let i = 0, ii = elements.length; i < ii; i++) {
                            const item = elements[i];
                            if (typeof item === "string") {
                              showSpacedTextBuffer.push(item);
                            } else if (typeof item === "number" && item !== 0) {
                              const str = showSpacedTextBuffer.join("");
                              showSpacedTextBuffer.length = 0;
                              buildTextContentItem({
                                chars: str,
                                extraSpacing: item * spaceFactor
                              });
                            }
                          }
                          if (showSpacedTextBuffer.length > 0) {
                            const str = showSpacedTextBuffer.join("");
                            showSpacedTextBuffer.length = 0;
                            buildTextContentItem({
                              chars: str,
                              extraSpacing: 0
                            });
                          }
                          break;
                        case _util2.OPS.showText:
                          if (!stateManager.state.font) {
                            self2.ensureStateFont(stateManager.state);
                            continue;
                          }
                          buildTextContentItem({
                            chars: args[0],
                            extraSpacing: 0
                          });
                          break;
                        case _util2.OPS.nextLineShowText:
                          if (!stateManager.state.font) {
                            self2.ensureStateFont(stateManager.state);
                            continue;
                          }
                          textState.carriageReturn();
                          buildTextContentItem({
                            chars: args[0],
                            extraSpacing: 0
                          });
                          break;
                        case _util2.OPS.nextLineSetSpacingShowText:
                          if (!stateManager.state.font) {
                            self2.ensureStateFont(stateManager.state);
                            continue;
                          }
                          textState.wordSpacing = args[0];
                          textState.charSpacing = args[1];
                          textState.carriageReturn();
                          buildTextContentItem({
                            chars: args[2],
                            extraSpacing: 0
                          });
                          break;
                        case _util2.OPS.paintXObject:
                          flushTextContentItem();
                          if (!xobjs) {
                            xobjs = resources.get("XObject") || _primitives.Dict.empty;
                          }
                          var isValidName = args[0] instanceof _primitives.Name;
                          var name = args[0].name;
                          if (isValidName && emptyXObjectCache.getByName(name)) {
                            break;
                          }
                          next2(new Promise(function(resolveXObject, rejectXObject) {
                            if (!isValidName) {
                              throw new _util2.FormatError("XObject must be referred to by name.");
                            }
                            let xobj = xobjs.getRaw(name);
                            if (xobj instanceof _primitives.Ref) {
                              if (emptyXObjectCache.getByRef(xobj)) {
                                resolveXObject();
                                return;
                              }
                              const globalImage = self2.globalImageCache.getData(xobj, self2.pageIndex);
                              if (globalImage) {
                                resolveXObject();
                                return;
                              }
                              xobj = xref.fetch(xobj);
                            }
                            if (!(xobj instanceof _base_stream.BaseStream)) {
                              throw new _util2.FormatError("XObject should be a stream");
                            }
                            const type5 = xobj.dict.get("Subtype");
                            if (!(type5 instanceof _primitives.Name)) {
                              throw new _util2.FormatError("XObject should have a Name subtype");
                            }
                            if (type5.name !== "Form") {
                              emptyXObjectCache.set(name, xobj.dict.objId, true);
                              resolveXObject();
                              return;
                            }
                            const currentState = stateManager.state.clone();
                            const xObjStateManager = new StateManager(currentState);
                            const matrix = xobj.dict.getArray("Matrix");
                            if (Array.isArray(matrix) && matrix.length === 6) {
                              xObjStateManager.transform(matrix);
                            }
                            enqueueChunk();
                            const sinkWrapper = {
                              enqueueInvoked: false,
                              enqueue(chunk, size) {
                                this.enqueueInvoked = true;
                                sink.enqueue(chunk, size);
                              },
                              get desiredSize() {
                                return sink.desiredSize;
                              },
                              get ready() {
                                return sink.ready;
                              }
                            };
                            self2.getTextContent({
                              stream: xobj,
                              task,
                              resources: xobj.dict.get("Resources") || resources,
                              stateManager: xObjStateManager,
                              includeMarkedContent,
                              sink: sinkWrapper,
                              seenStyles,
                              viewBox,
                              markedContentData,
                              disableNormalization
                            }).then(function() {
                              if (!sinkWrapper.enqueueInvoked) {
                                emptyXObjectCache.set(name, xobj.dict.objId, true);
                              }
                              resolveXObject();
                            }, rejectXObject);
                          }).catch(function(reason) {
                            if (reason instanceof _util2.AbortException) {
                              return;
                            }
                            if (self2.options.ignoreErrors) {
                              (0, _util2.warn)(`getTextContent - ignoring XObject: "${reason}".`);
                              return;
                            }
                            throw reason;
                          }));
                          return;
                        case _util2.OPS.setGState:
                          isValidName = args[0] instanceof _primitives.Name;
                          name = args[0].name;
                          if (isValidName && emptyGStateCache.getByName(name)) {
                            break;
                          }
                          next2(new Promise(function(resolveGState, rejectGState) {
                            if (!isValidName) {
                              throw new _util2.FormatError("GState must be referred to by name.");
                            }
                            const extGState = resources.get("ExtGState");
                            if (!(extGState instanceof _primitives.Dict)) {
                              throw new _util2.FormatError("ExtGState should be a dictionary.");
                            }
                            const gState = extGState.get(name);
                            if (!(gState instanceof _primitives.Dict)) {
                              throw new _util2.FormatError("GState should be a dictionary.");
                            }
                            const gStateFont = gState.get("Font");
                            if (!gStateFont) {
                              emptyGStateCache.set(name, gState.objId, true);
                              resolveGState();
                              return;
                            }
                            flushTextContentItem();
                            textState.fontName = null;
                            textState.fontSize = gStateFont[1];
                            handleSetFont(null, gStateFont[0]).then(resolveGState, rejectGState);
                          }).catch(function(reason) {
                            if (reason instanceof _util2.AbortException) {
                              return;
                            }
                            if (self2.options.ignoreErrors) {
                              (0, _util2.warn)(`getTextContent - ignoring ExtGState: "${reason}".`);
                              return;
                            }
                            throw reason;
                          }));
                          return;
                        case _util2.OPS.beginMarkedContent:
                          flushTextContentItem();
                          if (includeMarkedContent) {
                            markedContentData.level++;
                            textContent.items.push({
                              type: "beginMarkedContent",
                              tag: args[0] instanceof _primitives.Name ? args[0].name : null
                            });
                          }
                          break;
                        case _util2.OPS.beginMarkedContentProps:
                          flushTextContentItem();
                          if (includeMarkedContent) {
                            markedContentData.level++;
                            let mcid = null;
                            if (args[1] instanceof _primitives.Dict) {
                              mcid = args[1].get("MCID");
                            }
                            textContent.items.push({
                              type: "beginMarkedContentProps",
                              id: Number.isInteger(mcid) ? `${self2.idFactory.getPageObjId()}_mc${mcid}` : null,
                              tag: args[0] instanceof _primitives.Name ? args[0].name : null
                            });
                          }
                          break;
                        case _util2.OPS.endMarkedContent:
                          flushTextContentItem();
                          if (includeMarkedContent) {
                            if (markedContentData.level === 0) {
                              break;
                            }
                            markedContentData.level--;
                            textContent.items.push({
                              type: "endMarkedContent"
                            });
                          }
                          break;
                        case _util2.OPS.restore:
                          if (previousState && (previousState.font !== textState.font || previousState.fontSize !== textState.fontSize || previousState.fontName !== textState.fontName)) {
                            flushTextContentItem();
                          }
                          break;
                      }
                      if (textContent.items.length >= sink.desiredSize) {
                        stop = true;
                        break;
                      }
                    }
                    if (stop) {
                      next2(deferred);
                      return;
                    }
                    flushTextContentItem();
                    enqueueChunk();
                    resolve();
                  }).catch((reason) => {
                    if (reason instanceof _util2.AbortException) {
                      return;
                    }
                    if (this.options.ignoreErrors) {
                      (0, _util2.warn)(`getTextContent - ignoring errors during "${task.name}" task: "${reason}".`);
                      flushTextContentItem();
                      enqueueChunk();
                      return;
                    }
                    throw reason;
                  });
                }
                extractDataStructures(dict, baseDict, properties2) {
                  const xref = this.xref;
                  let cidToGidBytes;
                  const toUnicodePromise = this.readToUnicode(properties2.toUnicode || dict.get("ToUnicode") || baseDict.get("ToUnicode"));
                  if (properties2.composite) {
                    const cidSystemInfo = dict.get("CIDSystemInfo");
                    if (cidSystemInfo instanceof _primitives.Dict) {
                      properties2.cidSystemInfo = {
                        registry: (0, _util2.stringToPDFString)(cidSystemInfo.get("Registry")),
                        ordering: (0, _util2.stringToPDFString)(cidSystemInfo.get("Ordering")),
                        supplement: cidSystemInfo.get("Supplement")
                      };
                    }
                    try {
                      const cidToGidMap = dict.get("CIDToGIDMap");
                      if (cidToGidMap instanceof _base_stream.BaseStream) {
                        cidToGidBytes = cidToGidMap.getBytes();
                      }
                    } catch (ex) {
                      if (!this.options.ignoreErrors) {
                        throw ex;
                      }
                      (0, _util2.warn)(`extractDataStructures - ignoring CIDToGIDMap data: "${ex}".`);
                    }
                  }
                  const differences = [];
                  let baseEncodingName = null;
                  let encoding;
                  if (dict.has("Encoding")) {
                    encoding = dict.get("Encoding");
                    if (encoding instanceof _primitives.Dict) {
                      baseEncodingName = encoding.get("BaseEncoding");
                      baseEncodingName = baseEncodingName instanceof _primitives.Name ? baseEncodingName.name : null;
                      if (encoding.has("Differences")) {
                        const diffEncoding = encoding.get("Differences");
                        let index3 = 0;
                        for (const entry of diffEncoding) {
                          const data2 = xref.fetchIfRef(entry);
                          if (typeof data2 === "number") {
                            index3 = data2;
                          } else if (data2 instanceof _primitives.Name) {
                            differences[index3++] = data2.name;
                          } else {
                            throw new _util2.FormatError(`Invalid entry in 'Differences' array: ${data2}`);
                          }
                        }
                      }
                    } else if (encoding instanceof _primitives.Name) {
                      baseEncodingName = encoding.name;
                    } else {
                      const msg = "Encoding is not a Name nor a Dict";
                      if (!this.options.ignoreErrors) {
                        throw new _util2.FormatError(msg);
                      }
                      (0, _util2.warn)(msg);
                    }
                    if (baseEncodingName !== "MacRomanEncoding" && baseEncodingName !== "MacExpertEncoding" && baseEncodingName !== "WinAnsiEncoding") {
                      baseEncodingName = null;
                    }
                  }
                  const nonEmbeddedFont = !properties2.file || properties2.isInternalFont, isSymbolsFontName = (0, _standard_fonts.getSymbolsFonts)()[properties2.name];
                  if (baseEncodingName && nonEmbeddedFont && isSymbolsFontName) {
                    baseEncodingName = null;
                  }
                  if (baseEncodingName) {
                    properties2.defaultEncoding = (0, _encodings.getEncoding)(baseEncodingName);
                  } else {
                    const isSymbolicFont = !!(properties2.flags & _fonts_utils.FontFlags.Symbolic);
                    const isNonsymbolicFont = !!(properties2.flags & _fonts_utils.FontFlags.Nonsymbolic);
                    encoding = _encodings.StandardEncoding;
                    if (properties2.type === "TrueType" && !isNonsymbolicFont) {
                      encoding = _encodings.WinAnsiEncoding;
                    }
                    if (isSymbolicFont || isSymbolsFontName) {
                      encoding = _encodings.MacRomanEncoding;
                      if (nonEmbeddedFont) {
                        if (/Symbol/i.test(properties2.name)) {
                          encoding = _encodings.SymbolSetEncoding;
                        } else if (/Dingbats/i.test(properties2.name)) {
                          encoding = _encodings.ZapfDingbatsEncoding;
                        } else if (/Wingdings/i.test(properties2.name)) {
                          encoding = _encodings.WinAnsiEncoding;
                        }
                      }
                    }
                    properties2.defaultEncoding = encoding;
                  }
                  properties2.differences = differences;
                  properties2.baseEncodingName = baseEncodingName;
                  properties2.hasEncoding = !!baseEncodingName || differences.length > 0;
                  properties2.dict = dict;
                  return toUnicodePromise.then((readToUnicode) => {
                    properties2.toUnicode = readToUnicode;
                    return this.buildToUnicode(properties2);
                  }).then((builtToUnicode) => {
                    properties2.toUnicode = builtToUnicode;
                    if (cidToGidBytes) {
                      properties2.cidToGidMap = this.readCidToGidMap(cidToGidBytes, builtToUnicode);
                    }
                    return properties2;
                  });
                }
                _simpleFontToUnicode(properties2, forceGlyphs = false) {
                  (0, _util2.assert)(!properties2.composite, "Must be a simple font.");
                  const toUnicode = [];
                  const encoding = properties2.defaultEncoding.slice();
                  const baseEncodingName = properties2.baseEncodingName;
                  const differences = properties2.differences;
                  for (const charcode in differences) {
                    const glyphName = differences[charcode];
                    if (glyphName === ".notdef") {
                      continue;
                    }
                    encoding[charcode] = glyphName;
                  }
                  const glyphsUnicodeMap = (0, _glyphlist.getGlyphsUnicode)();
                  for (const charcode in encoding) {
                    let glyphName = encoding[charcode];
                    if (glyphName === "") {
                      continue;
                    }
                    let unicode = glyphsUnicodeMap[glyphName];
                    if (unicode !== void 0) {
                      toUnicode[charcode] = String.fromCharCode(unicode);
                      continue;
                    }
                    let code2 = 0;
                    switch (glyphName[0]) {
                      case "G":
                        if (glyphName.length === 3) {
                          code2 = parseInt(glyphName.substring(1), 16);
                        }
                        break;
                      case "g":
                        if (glyphName.length === 5) {
                          code2 = parseInt(glyphName.substring(1), 16);
                        }
                        break;
                      case "C":
                      case "c":
                        if (glyphName.length >= 3 && glyphName.length <= 4) {
                          const codeStr = glyphName.substring(1);
                          if (forceGlyphs) {
                            code2 = parseInt(codeStr, 16);
                            break;
                          }
                          code2 = +codeStr;
                          if (Number.isNaN(code2) && Number.isInteger(parseInt(codeStr, 16))) {
                            return this._simpleFontToUnicode(properties2, true);
                          }
                        }
                        break;
                      case "u":
                        unicode = (0, _unicode.getUnicodeForGlyph)(glyphName, glyphsUnicodeMap);
                        if (unicode !== -1) {
                          code2 = unicode;
                        }
                        break;
                      default:
                        switch (glyphName) {
                          case "f_h":
                          case "f_t":
                          case "T_h":
                            toUnicode[charcode] = glyphName.replaceAll("_", "");
                            continue;
                        }
                        break;
                    }
                    if (code2 > 0 && code2 <= 1114111 && Number.isInteger(code2)) {
                      if (baseEncodingName && code2 === +charcode) {
                        const baseEncoding = (0, _encodings.getEncoding)(baseEncodingName);
                        if (baseEncoding && (glyphName = baseEncoding[charcode])) {
                          toUnicode[charcode] = String.fromCharCode(glyphsUnicodeMap[glyphName]);
                          continue;
                        }
                      }
                      toUnicode[charcode] = String.fromCodePoint(code2);
                    }
                  }
                  return toUnicode;
                }
                async buildToUnicode(properties2) {
                  properties2.hasIncludedToUnicodeMap = properties2.toUnicode?.length > 0;
                  if (properties2.hasIncludedToUnicodeMap) {
                    if (!properties2.composite && properties2.hasEncoding) {
                      properties2.fallbackToUnicode = this._simpleFontToUnicode(properties2);
                    }
                    return properties2.toUnicode;
                  }
                  if (!properties2.composite) {
                    return new _to_unicode_map.ToUnicodeMap(this._simpleFontToUnicode(properties2));
                  }
                  if (properties2.composite && (properties2.cMap.builtInCMap && !(properties2.cMap instanceof _cmap.IdentityCMap) || properties2.cidSystemInfo.registry === "Adobe" && (properties2.cidSystemInfo.ordering === "GB1" || properties2.cidSystemInfo.ordering === "CNS1" || properties2.cidSystemInfo.ordering === "Japan1" || properties2.cidSystemInfo.ordering === "Korea1"))) {
                    const {
                      registry,
                      ordering
                    } = properties2.cidSystemInfo;
                    const ucs2CMapName = _primitives.Name.get(`${registry}-${ordering}-UCS2`);
                    const ucs2CMap = await _cmap.CMapFactory.create({
                      encoding: ucs2CMapName,
                      fetchBuiltInCMap: this._fetchBuiltInCMapBound,
                      useCMap: null
                    });
                    const toUnicode = [], buf = [];
                    properties2.cMap.forEach(function(charcode, cid) {
                      if (cid > 65535) {
                        throw new _util2.FormatError("Max size of CID is 65,535");
                      }
                      const ucs2 = ucs2CMap.lookup(cid);
                      if (ucs2) {
                        buf.length = 0;
                        for (let i = 0, ii = ucs2.length; i < ii; i += 2) {
                          buf.push((ucs2.charCodeAt(i) << 8) + ucs2.charCodeAt(i + 1));
                        }
                        toUnicode[charcode] = String.fromCharCode(...buf);
                      }
                    });
                    return new _to_unicode_map.ToUnicodeMap(toUnicode);
                  }
                  return new _to_unicode_map.IdentityToUnicodeMap(properties2.firstChar, properties2.lastChar);
                }
                readToUnicode(cmapObj) {
                  if (!cmapObj) {
                    return Promise.resolve(null);
                  }
                  if (cmapObj instanceof _primitives.Name) {
                    return _cmap.CMapFactory.create({
                      encoding: cmapObj,
                      fetchBuiltInCMap: this._fetchBuiltInCMapBound,
                      useCMap: null
                    }).then(function(cmap) {
                      if (cmap instanceof _cmap.IdentityCMap) {
                        return new _to_unicode_map.IdentityToUnicodeMap(0, 65535);
                      }
                      return new _to_unicode_map.ToUnicodeMap(cmap.getMap());
                    });
                  } else if (cmapObj instanceof _base_stream.BaseStream) {
                    return _cmap.CMapFactory.create({
                      encoding: cmapObj,
                      fetchBuiltInCMap: this._fetchBuiltInCMapBound,
                      useCMap: null
                    }).then(function(cmap) {
                      if (cmap instanceof _cmap.IdentityCMap) {
                        return new _to_unicode_map.IdentityToUnicodeMap(0, 65535);
                      }
                      const map = new Array(cmap.length);
                      cmap.forEach(function(charCode, token2) {
                        if (typeof token2 === "number") {
                          map[charCode] = String.fromCodePoint(token2);
                          return;
                        }
                        const str = [];
                        for (let k = 0; k < token2.length; k += 2) {
                          const w1 = token2.charCodeAt(k) << 8 | token2.charCodeAt(k + 1);
                          if ((w1 & 63488) !== 55296) {
                            str.push(w1);
                            continue;
                          }
                          k += 2;
                          const w2 = token2.charCodeAt(k) << 8 | token2.charCodeAt(k + 1);
                          str.push(((w1 & 1023) << 10) + (w2 & 1023) + 65536);
                        }
                        map[charCode] = String.fromCodePoint(...str);
                      });
                      return new _to_unicode_map.ToUnicodeMap(map);
                    }, (reason) => {
                      if (reason instanceof _util2.AbortException) {
                        return null;
                      }
                      if (this.options.ignoreErrors) {
                        (0, _util2.warn)(`readToUnicode - ignoring ToUnicode data: "${reason}".`);
                        return null;
                      }
                      throw reason;
                    });
                  }
                  return Promise.resolve(null);
                }
                readCidToGidMap(glyphsData, toUnicode) {
                  const result = [];
                  for (let j = 0, jj = glyphsData.length; j < jj; j++) {
                    const glyphID = glyphsData[j++] << 8 | glyphsData[j];
                    const code2 = j >> 1;
                    if (glyphID === 0 && !toUnicode.has(code2)) {
                      continue;
                    }
                    result[code2] = glyphID;
                  }
                  return result;
                }
                extractWidths(dict, descriptor, properties2) {
                  const xref = this.xref;
                  let glyphsWidths = [];
                  let defaultWidth = 0;
                  const glyphsVMetrics = [];
                  let defaultVMetrics;
                  let i, ii, j, jj, start, code2, widths;
                  if (properties2.composite) {
                    defaultWidth = dict.has("DW") ? dict.get("DW") : 1e3;
                    widths = dict.get("W");
                    if (widths) {
                      for (i = 0, ii = widths.length; i < ii; i++) {
                        start = xref.fetchIfRef(widths[i++]);
                        code2 = xref.fetchIfRef(widths[i]);
                        if (Array.isArray(code2)) {
                          for (j = 0, jj = code2.length; j < jj; j++) {
                            glyphsWidths[start++] = xref.fetchIfRef(code2[j]);
                          }
                        } else {
                          const width = xref.fetchIfRef(widths[++i]);
                          for (j = start; j <= code2; j++) {
                            glyphsWidths[j] = width;
                          }
                        }
                      }
                    }
                    if (properties2.vertical) {
                      let vmetrics = dict.getArray("DW2") || [880, -1e3];
                      defaultVMetrics = [vmetrics[1], defaultWidth * 0.5, vmetrics[0]];
                      vmetrics = dict.get("W2");
                      if (vmetrics) {
                        for (i = 0, ii = vmetrics.length; i < ii; i++) {
                          start = xref.fetchIfRef(vmetrics[i++]);
                          code2 = xref.fetchIfRef(vmetrics[i]);
                          if (Array.isArray(code2)) {
                            for (j = 0, jj = code2.length; j < jj; j++) {
                              glyphsVMetrics[start++] = [xref.fetchIfRef(code2[j++]), xref.fetchIfRef(code2[j++]), xref.fetchIfRef(code2[j])];
                            }
                          } else {
                            const vmetric = [xref.fetchIfRef(vmetrics[++i]), xref.fetchIfRef(vmetrics[++i]), xref.fetchIfRef(vmetrics[++i])];
                            for (j = start; j <= code2; j++) {
                              glyphsVMetrics[j] = vmetric;
                            }
                          }
                        }
                      }
                    }
                  } else {
                    const firstChar = properties2.firstChar;
                    widths = dict.get("Widths");
                    if (widths) {
                      j = firstChar;
                      for (i = 0, ii = widths.length; i < ii; i++) {
                        glyphsWidths[j++] = xref.fetchIfRef(widths[i]);
                      }
                      defaultWidth = parseFloat(descriptor.get("MissingWidth")) || 0;
                    } else {
                      const baseFontName = dict.get("BaseFont");
                      if (baseFontName instanceof _primitives.Name) {
                        const metrics = this.getBaseFontMetrics(baseFontName.name);
                        glyphsWidths = this.buildCharCodeToWidth(metrics.widths, properties2);
                        defaultWidth = metrics.defaultWidth;
                      }
                    }
                  }
                  let isMonospace = true;
                  let firstWidth = defaultWidth;
                  for (const glyph in glyphsWidths) {
                    const glyphWidth = glyphsWidths[glyph];
                    if (!glyphWidth) {
                      continue;
                    }
                    if (!firstWidth) {
                      firstWidth = glyphWidth;
                      continue;
                    }
                    if (firstWidth !== glyphWidth) {
                      isMonospace = false;
                      break;
                    }
                  }
                  if (isMonospace) {
                    properties2.flags |= _fonts_utils.FontFlags.FixedPitch;
                  } else {
                    properties2.flags &= ~_fonts_utils.FontFlags.FixedPitch;
                  }
                  properties2.defaultWidth = defaultWidth;
                  properties2.widths = glyphsWidths;
                  properties2.defaultVMetrics = defaultVMetrics;
                  properties2.vmetrics = glyphsVMetrics;
                }
                isSerifFont(baseFontName) {
                  const fontNameWoStyle = baseFontName.split("-")[0];
                  return fontNameWoStyle in (0, _standard_fonts.getSerifFonts)() || /serif/gi.test(fontNameWoStyle);
                }
                getBaseFontMetrics(name) {
                  let defaultWidth = 0;
                  let widths = /* @__PURE__ */ Object.create(null);
                  let monospace = false;
                  const stdFontMap = (0, _standard_fonts.getStdFontMap)();
                  let lookupName = stdFontMap[name] || name;
                  const Metrics = (0, _metrics.getMetrics)();
                  if (!(lookupName in Metrics)) {
                    lookupName = this.isSerifFont(name) ? "Times-Roman" : "Helvetica";
                  }
                  const glyphWidths = Metrics[lookupName];
                  if (typeof glyphWidths === "number") {
                    defaultWidth = glyphWidths;
                    monospace = true;
                  } else {
                    widths = glyphWidths();
                  }
                  return {
                    defaultWidth,
                    monospace,
                    widths
                  };
                }
                buildCharCodeToWidth(widthsByGlyphName, properties2) {
                  const widths = /* @__PURE__ */ Object.create(null);
                  const differences = properties2.differences;
                  const encoding = properties2.defaultEncoding;
                  for (let charCode = 0; charCode < 256; charCode++) {
                    if (charCode in differences && widthsByGlyphName[differences[charCode]]) {
                      widths[charCode] = widthsByGlyphName[differences[charCode]];
                      continue;
                    }
                    if (charCode in encoding && widthsByGlyphName[encoding[charCode]]) {
                      widths[charCode] = widthsByGlyphName[encoding[charCode]];
                      continue;
                    }
                  }
                  return widths;
                }
                preEvaluateFont(dict) {
                  const baseDict = dict;
                  let type5 = dict.get("Subtype");
                  if (!(type5 instanceof _primitives.Name)) {
                    throw new _util2.FormatError("invalid font Subtype");
                  }
                  let composite = false;
                  let hash2, toUnicode;
                  if (type5.name === "Type0") {
                    const df = dict.get("DescendantFonts");
                    if (!df) {
                      throw new _util2.FormatError("Descendant fonts are not specified");
                    }
                    dict = Array.isArray(df) ? this.xref.fetchIfRef(df[0]) : df;
                    if (!(dict instanceof _primitives.Dict)) {
                      throw new _util2.FormatError("Descendant font is not a dictionary.");
                    }
                    type5 = dict.get("Subtype");
                    if (!(type5 instanceof _primitives.Name)) {
                      throw new _util2.FormatError("invalid font Subtype");
                    }
                    composite = true;
                  }
                  const firstChar = dict.get("FirstChar") || 0, lastChar = dict.get("LastChar") || (composite ? 65535 : 255);
                  const descriptor = dict.get("FontDescriptor");
                  if (descriptor) {
                    hash2 = new _murmurhash.MurmurHash3_64();
                    const encoding = baseDict.getRaw("Encoding");
                    if (encoding instanceof _primitives.Name) {
                      hash2.update(encoding.name);
                    } else if (encoding instanceof _primitives.Ref) {
                      hash2.update(encoding.toString());
                    } else if (encoding instanceof _primitives.Dict) {
                      for (const entry of encoding.getRawValues()) {
                        if (entry instanceof _primitives.Name) {
                          hash2.update(entry.name);
                        } else if (entry instanceof _primitives.Ref) {
                          hash2.update(entry.toString());
                        } else if (Array.isArray(entry)) {
                          const diffLength = entry.length, diffBuf = new Array(diffLength);
                          for (let j = 0; j < diffLength; j++) {
                            const diffEntry = entry[j];
                            if (diffEntry instanceof _primitives.Name) {
                              diffBuf[j] = diffEntry.name;
                            } else if (typeof diffEntry === "number" || diffEntry instanceof _primitives.Ref) {
                              diffBuf[j] = diffEntry.toString();
                            }
                          }
                          hash2.update(diffBuf.join());
                        }
                      }
                    }
                    hash2.update(`${firstChar}-${lastChar}`);
                    toUnicode = dict.get("ToUnicode") || baseDict.get("ToUnicode");
                    if (toUnicode instanceof _base_stream.BaseStream) {
                      const stream = toUnicode.str || toUnicode;
                      const uint8array = stream.buffer ? new Uint8Array(stream.buffer.buffer, 0, stream.bufferLength) : new Uint8Array(stream.bytes.buffer, stream.start, stream.end - stream.start);
                      hash2.update(uint8array);
                    } else if (toUnicode instanceof _primitives.Name) {
                      hash2.update(toUnicode.name);
                    }
                    const widths = dict.get("Widths") || baseDict.get("Widths");
                    if (Array.isArray(widths)) {
                      const widthsBuf = [];
                      for (const entry of widths) {
                        if (typeof entry === "number" || entry instanceof _primitives.Ref) {
                          widthsBuf.push(entry.toString());
                        }
                      }
                      hash2.update(widthsBuf.join());
                    }
                    if (composite) {
                      hash2.update("compositeFont");
                      const compositeWidths = dict.get("W") || baseDict.get("W");
                      if (Array.isArray(compositeWidths)) {
                        const widthsBuf = [];
                        for (const entry of compositeWidths) {
                          if (typeof entry === "number" || entry instanceof _primitives.Ref) {
                            widthsBuf.push(entry.toString());
                          } else if (Array.isArray(entry)) {
                            const subWidthsBuf = [];
                            for (const element of entry) {
                              if (typeof element === "number" || element instanceof _primitives.Ref) {
                                subWidthsBuf.push(element.toString());
                              }
                            }
                            widthsBuf.push(`[${subWidthsBuf.join()}]`);
                          }
                        }
                        hash2.update(widthsBuf.join());
                      }
                      const cidToGidMap = dict.getRaw("CIDToGIDMap") || baseDict.getRaw("CIDToGIDMap");
                      if (cidToGidMap instanceof _primitives.Name) {
                        hash2.update(cidToGidMap.name);
                      } else if (cidToGidMap instanceof _primitives.Ref) {
                        hash2.update(cidToGidMap.toString());
                      } else if (cidToGidMap instanceof _base_stream.BaseStream) {
                        hash2.update(cidToGidMap.peekBytes());
                      }
                    }
                  }
                  return {
                    descriptor,
                    dict,
                    baseDict,
                    composite,
                    type: type5.name,
                    firstChar,
                    lastChar,
                    toUnicode,
                    hash: hash2 ? hash2.hexdigest() : ""
                  };
                }
                async translateFont({
                  descriptor,
                  dict,
                  baseDict,
                  composite,
                  type: type5,
                  firstChar,
                  lastChar,
                  toUnicode,
                  cssFontInfo
                }) {
                  const isType3Font = type5 === "Type3";
                  let properties2;
                  if (!descriptor) {
                    if (isType3Font) {
                      descriptor = new _primitives.Dict(null);
                      descriptor.set("FontName", _primitives.Name.get(type5));
                      descriptor.set("FontBBox", dict.getArray("FontBBox") || [0, 0, 0, 0]);
                    } else {
                      let baseFontName = dict.get("BaseFont");
                      if (!(baseFontName instanceof _primitives.Name)) {
                        throw new _util2.FormatError("Base font is not specified");
                      }
                      baseFontName = baseFontName.name.replaceAll(/[,_]/g, "-");
                      const metrics = this.getBaseFontMetrics(baseFontName);
                      const fontNameWoStyle = baseFontName.split("-")[0];
                      const flags = (this.isSerifFont(fontNameWoStyle) ? _fonts_utils.FontFlags.Serif : 0) | (metrics.monospace ? _fonts_utils.FontFlags.FixedPitch : 0) | ((0, _standard_fonts.getSymbolsFonts)()[fontNameWoStyle] ? _fonts_utils.FontFlags.Symbolic : _fonts_utils.FontFlags.Nonsymbolic);
                      properties2 = {
                        type: type5,
                        name: baseFontName,
                        loadedName: baseDict.loadedName,
                        systemFontInfo: null,
                        widths: metrics.widths,
                        defaultWidth: metrics.defaultWidth,
                        isSimulatedFlags: true,
                        flags,
                        firstChar,
                        lastChar,
                        toUnicode,
                        xHeight: 0,
                        capHeight: 0,
                        italicAngle: 0,
                        isType3Font
                      };
                      const widths = dict.get("Widths");
                      const standardFontName = (0, _standard_fonts.getStandardFontName)(baseFontName);
                      let file = null;
                      if (standardFontName) {
                        file = await this.fetchStandardFontData(standardFontName);
                        properties2.isInternalFont = !!file;
                      }
                      if (!properties2.isInternalFont && this.options.useSystemFonts) {
                        properties2.systemFontInfo = (0, _font_substitutions.getFontSubstitution)(this.systemFontCache, this.idFactory, this.options.standardFontDataUrl, baseFontName, standardFontName);
                      }
                      return this.extractDataStructures(dict, dict, properties2).then((newProperties) => {
                        if (widths) {
                          const glyphWidths = [];
                          let j = firstChar;
                          for (const width of widths) {
                            glyphWidths[j++] = this.xref.fetchIfRef(width);
                          }
                          newProperties.widths = glyphWidths;
                        } else {
                          newProperties.widths = this.buildCharCodeToWidth(metrics.widths, newProperties);
                        }
                        return new _fonts.Font(baseFontName, file, newProperties);
                      });
                    }
                  }
                  let fontName = descriptor.get("FontName");
                  let baseFont = dict.get("BaseFont");
                  if (typeof fontName === "string") {
                    fontName = _primitives.Name.get(fontName);
                  }
                  if (typeof baseFont === "string") {
                    baseFont = _primitives.Name.get(baseFont);
                  }
                  const fontNameStr = fontName?.name;
                  const baseFontStr = baseFont?.name;
                  if (!isType3Font && fontNameStr !== baseFontStr) {
                    (0, _util2.info)(`The FontDescriptor's FontName is "${fontNameStr}" but should be the same as the Font's BaseFont "${baseFontStr}".`);
                    if (fontNameStr && baseFontStr && (baseFontStr.startsWith(fontNameStr) || !(0, _standard_fonts.isKnownFontName)(fontNameStr) && (0, _standard_fonts.isKnownFontName)(baseFontStr))) {
                      fontName = null;
                    }
                  }
                  fontName ||= baseFont;
                  if (!(fontName instanceof _primitives.Name)) {
                    throw new _util2.FormatError("invalid font name");
                  }
                  let fontFile, subtype, length1, length2, length3;
                  try {
                    fontFile = descriptor.get("FontFile", "FontFile2", "FontFile3");
                  } catch (ex) {
                    if (!this.options.ignoreErrors) {
                      throw ex;
                    }
                    (0, _util2.warn)(`translateFont - fetching "${fontName.name}" font file: "${ex}".`);
                    fontFile = new _stream.NullStream();
                  }
                  let isInternalFont = false;
                  let glyphScaleFactors = null;
                  let systemFontInfo = null;
                  if (fontFile) {
                    if (fontFile.dict) {
                      const subtypeEntry = fontFile.dict.get("Subtype");
                      if (subtypeEntry instanceof _primitives.Name) {
                        subtype = subtypeEntry.name;
                      }
                      length1 = fontFile.dict.get("Length1");
                      length2 = fontFile.dict.get("Length2");
                      length3 = fontFile.dict.get("Length3");
                    }
                  } else if (cssFontInfo) {
                    const standardFontName = (0, _xfa_fonts.getXfaFontName)(fontName.name);
                    if (standardFontName) {
                      cssFontInfo.fontFamily = `${cssFontInfo.fontFamily}-PdfJS-XFA`;
                      cssFontInfo.metrics = standardFontName.metrics || null;
                      glyphScaleFactors = standardFontName.factors || null;
                      fontFile = await this.fetchStandardFontData(standardFontName.name);
                      isInternalFont = !!fontFile;
                      baseDict = dict = (0, _xfa_fonts.getXfaFontDict)(fontName.name);
                      composite = true;
                    }
                  } else if (!isType3Font) {
                    const standardFontName = (0, _standard_fonts.getStandardFontName)(fontName.name);
                    if (standardFontName) {
                      fontFile = await this.fetchStandardFontData(standardFontName);
                      isInternalFont = !!fontFile;
                    }
                    if (!isInternalFont && this.options.useSystemFonts) {
                      systemFontInfo = (0, _font_substitutions.getFontSubstitution)(this.systemFontCache, this.idFactory, this.options.standardFontDataUrl, fontName.name, standardFontName);
                    }
                  }
                  properties2 = {
                    type: type5,
                    name: fontName.name,
                    subtype,
                    file: fontFile,
                    length1,
                    length2,
                    length3,
                    isInternalFont,
                    loadedName: baseDict.loadedName,
                    composite,
                    fixedPitch: false,
                    fontMatrix: dict.getArray("FontMatrix") || _util2.FONT_IDENTITY_MATRIX,
                    firstChar,
                    lastChar,
                    toUnicode,
                    bbox: descriptor.getArray("FontBBox") || dict.getArray("FontBBox"),
                    ascent: descriptor.get("Ascent"),
                    descent: descriptor.get("Descent"),
                    xHeight: descriptor.get("XHeight") || 0,
                    capHeight: descriptor.get("CapHeight") || 0,
                    flags: descriptor.get("Flags"),
                    italicAngle: descriptor.get("ItalicAngle") || 0,
                    isType3Font,
                    cssFontInfo,
                    scaleFactors: glyphScaleFactors,
                    systemFontInfo
                  };
                  if (composite) {
                    const cidEncoding = baseDict.get("Encoding");
                    if (cidEncoding instanceof _primitives.Name) {
                      properties2.cidEncoding = cidEncoding.name;
                    }
                    const cMap = await _cmap.CMapFactory.create({
                      encoding: cidEncoding,
                      fetchBuiltInCMap: this._fetchBuiltInCMapBound,
                      useCMap: null
                    });
                    properties2.cMap = cMap;
                    properties2.vertical = properties2.cMap.vertical;
                  }
                  return this.extractDataStructures(dict, baseDict, properties2).then((newProperties) => {
                    this.extractWidths(dict, descriptor, newProperties);
                    return new _fonts.Font(fontName.name, fontFile, newProperties);
                  });
                }
                static buildFontPaths(font, glyphs, handler, evaluatorOptions) {
                  function buildPath(fontChar) {
                    const glyphName = `${font.loadedName}_path_${fontChar}`;
                    try {
                      if (font.renderer.hasBuiltPath(fontChar)) {
                        return;
                      }
                      handler.send("commonobj", [glyphName, "FontPath", font.renderer.getPathJs(fontChar)]);
                    } catch (reason) {
                      if (evaluatorOptions.ignoreErrors) {
                        (0, _util2.warn)(`buildFontPaths - ignoring ${glyphName} glyph: "${reason}".`);
                        return;
                      }
                      throw reason;
                    }
                  }
                  for (const glyph of glyphs) {
                    buildPath(glyph.fontChar);
                    const accent = glyph.accent;
                    if (accent?.fontChar) {
                      buildPath(accent.fontChar);
                    }
                  }
                }
                static get fallbackFontDict() {
                  const dict = new _primitives.Dict();
                  dict.set("BaseFont", _primitives.Name.get("Helvetica"));
                  dict.set("Type", _primitives.Name.get("FallbackType"));
                  dict.set("Subtype", _primitives.Name.get("FallbackType"));
                  dict.set("Encoding", _primitives.Name.get("WinAnsiEncoding"));
                  return (0, _util2.shadow)(this, "fallbackFontDict", dict);
                }
              }
              exports3.PartialEvaluator = PartialEvaluator;
              class TranslatedFont {
                constructor({
                  loadedName,
                  font,
                  dict,
                  evaluatorOptions
                }) {
                  this.loadedName = loadedName;
                  this.font = font;
                  this.dict = dict;
                  this._evaluatorOptions = evaluatorOptions || DefaultPartialEvaluatorOptions;
                  this.type3Loaded = null;
                  this.type3Dependencies = font.isType3Font ? /* @__PURE__ */ new Set() : null;
                  this.sent = false;
                }
                send(handler) {
                  if (this.sent) {
                    return;
                  }
                  this.sent = true;
                  handler.send("commonobj", [this.loadedName, "Font", this.font.exportData(this._evaluatorOptions.fontExtraProperties)]);
                }
                fallback(handler) {
                  if (!this.font.data) {
                    return;
                  }
                  this.font.disableFontFace = true;
                  PartialEvaluator.buildFontPaths(this.font, this.font.glyphCacheValues, handler, this._evaluatorOptions);
                }
                loadType3Data(evaluator, resources, task) {
                  if (this.type3Loaded) {
                    return this.type3Loaded;
                  }
                  if (!this.font.isType3Font) {
                    throw new Error("Must be a Type3 font.");
                  }
                  const type3Evaluator = evaluator.clone({
                    ignoreErrors: false
                  });
                  type3Evaluator.parsingType3Font = true;
                  const type3FontRefs = new _primitives.RefSet(evaluator.type3FontRefs);
                  if (this.dict.objId && !type3FontRefs.has(this.dict.objId)) {
                    type3FontRefs.put(this.dict.objId);
                  }
                  type3Evaluator.type3FontRefs = type3FontRefs;
                  const translatedFont = this.font, type3Dependencies = this.type3Dependencies;
                  let loadCharProcsPromise = Promise.resolve();
                  const charProcs = this.dict.get("CharProcs");
                  const fontResources = this.dict.get("Resources") || resources;
                  const charProcOperatorList = /* @__PURE__ */ Object.create(null);
                  const fontBBox = _util2.Util.normalizeRect(translatedFont.bbox || [0, 0, 0, 0]), width = fontBBox[2] - fontBBox[0], height = fontBBox[3] - fontBBox[1];
                  const fontBBoxSize = Math.hypot(width, height);
                  for (const key2 of charProcs.getKeys()) {
                    loadCharProcsPromise = loadCharProcsPromise.then(() => {
                      const glyphStream = charProcs.get(key2);
                      const operatorList = new _operator_list.OperatorList();
                      return type3Evaluator.getOperatorList({
                        stream: glyphStream,
                        task,
                        resources: fontResources,
                        operatorList
                      }).then(() => {
                        if (operatorList.fnArray[0] === _util2.OPS.setCharWidthAndBounds) {
                          this._removeType3ColorOperators(operatorList, fontBBoxSize);
                        }
                        charProcOperatorList[key2] = operatorList.getIR();
                        for (const dependency of operatorList.dependencies) {
                          type3Dependencies.add(dependency);
                        }
                      }).catch(function(reason) {
                        (0, _util2.warn)(`Type3 font resource "${key2}" is not available.`);
                        const dummyOperatorList = new _operator_list.OperatorList();
                        charProcOperatorList[key2] = dummyOperatorList.getIR();
                      });
                    });
                  }
                  this.type3Loaded = loadCharProcsPromise.then(() => {
                    translatedFont.charProcOperatorList = charProcOperatorList;
                    if (this._bbox) {
                      translatedFont.isCharBBox = true;
                      translatedFont.bbox = this._bbox;
                    }
                  });
                  return this.type3Loaded;
                }
                _removeType3ColorOperators(operatorList, fontBBoxSize = NaN) {
                  const charBBox = _util2.Util.normalizeRect(operatorList.argsArray[0].slice(2)), width = charBBox[2] - charBBox[0], height = charBBox[3] - charBBox[1];
                  const charBBoxSize = Math.hypot(width, height);
                  if (width === 0 || height === 0) {
                    operatorList.fnArray.splice(0, 1);
                    operatorList.argsArray.splice(0, 1);
                  } else if (fontBBoxSize === 0 || Math.round(charBBoxSize / fontBBoxSize) >= 10) {
                    if (!this._bbox) {
                      this._bbox = [Infinity, Infinity, -Infinity, -Infinity];
                    }
                    this._bbox[0] = Math.min(this._bbox[0], charBBox[0]);
                    this._bbox[1] = Math.min(this._bbox[1], charBBox[1]);
                    this._bbox[2] = Math.max(this._bbox[2], charBBox[2]);
                    this._bbox[3] = Math.max(this._bbox[3], charBBox[3]);
                  }
                  let i = 0, ii = operatorList.length;
                  while (i < ii) {
                    switch (operatorList.fnArray[i]) {
                      case _util2.OPS.setCharWidthAndBounds:
                        break;
                      case _util2.OPS.setStrokeColorSpace:
                      case _util2.OPS.setFillColorSpace:
                      case _util2.OPS.setStrokeColor:
                      case _util2.OPS.setStrokeColorN:
                      case _util2.OPS.setFillColor:
                      case _util2.OPS.setFillColorN:
                      case _util2.OPS.setStrokeGray:
                      case _util2.OPS.setFillGray:
                      case _util2.OPS.setStrokeRGBColor:
                      case _util2.OPS.setFillRGBColor:
                      case _util2.OPS.setStrokeCMYKColor:
                      case _util2.OPS.setFillCMYKColor:
                      case _util2.OPS.shadingFill:
                      case _util2.OPS.setRenderingIntent:
                        operatorList.fnArray.splice(i, 1);
                        operatorList.argsArray.splice(i, 1);
                        ii--;
                        continue;
                      case _util2.OPS.setGState:
                        const [gStateObj] = operatorList.argsArray[i];
                        let j = 0, jj = gStateObj.length;
                        while (j < jj) {
                          const [gStateKey] = gStateObj[j];
                          switch (gStateKey) {
                            case "TR":
                            case "TR2":
                            case "HT":
                            case "BG":
                            case "BG2":
                            case "UCR":
                            case "UCR2":
                              gStateObj.splice(j, 1);
                              jj--;
                              continue;
                          }
                          j++;
                        }
                        break;
                    }
                    i++;
                  }
                }
              }
              class StateManager {
                constructor(initialState = new EvalState()) {
                  this.state = initialState;
                  this.stateStack = [];
                }
                save() {
                  const old = this.state;
                  this.stateStack.push(this.state);
                  this.state = old.clone();
                }
                restore() {
                  const prev2 = this.stateStack.pop();
                  if (prev2) {
                    this.state = prev2;
                  }
                }
                transform(args) {
                  this.state.ctm = _util2.Util.transform(this.state.ctm, args);
                }
              }
              class TextState {
                constructor() {
                  this.ctm = new Float32Array(_util2.IDENTITY_MATRIX);
                  this.fontName = null;
                  this.fontSize = 0;
                  this.loadedName = null;
                  this.font = null;
                  this.fontMatrix = _util2.FONT_IDENTITY_MATRIX;
                  this.textMatrix = _util2.IDENTITY_MATRIX.slice();
                  this.textLineMatrix = _util2.IDENTITY_MATRIX.slice();
                  this.charSpacing = 0;
                  this.wordSpacing = 0;
                  this.leading = 0;
                  this.textHScale = 1;
                  this.textRise = 0;
                }
                setTextMatrix(a, b, c, d, e3, f) {
                  const m = this.textMatrix;
                  m[0] = a;
                  m[1] = b;
                  m[2] = c;
                  m[3] = d;
                  m[4] = e3;
                  m[5] = f;
                }
                setTextLineMatrix(a, b, c, d, e3, f) {
                  const m = this.textLineMatrix;
                  m[0] = a;
                  m[1] = b;
                  m[2] = c;
                  m[3] = d;
                  m[4] = e3;
                  m[5] = f;
                }
                translateTextMatrix(x, y) {
                  const m = this.textMatrix;
                  m[4] = m[0] * x + m[2] * y + m[4];
                  m[5] = m[1] * x + m[3] * y + m[5];
                }
                translateTextLineMatrix(x, y) {
                  const m = this.textLineMatrix;
                  m[4] = m[0] * x + m[2] * y + m[4];
                  m[5] = m[1] * x + m[3] * y + m[5];
                }
                carriageReturn() {
                  this.translateTextLineMatrix(0, -this.leading);
                  this.textMatrix = this.textLineMatrix.slice();
                }
                clone() {
                  const clone = Object.create(this);
                  clone.textMatrix = this.textMatrix.slice();
                  clone.textLineMatrix = this.textLineMatrix.slice();
                  clone.fontMatrix = this.fontMatrix.slice();
                  return clone;
                }
              }
              class EvalState {
                constructor() {
                  this.ctm = new Float32Array(_util2.IDENTITY_MATRIX);
                  this.font = null;
                  this.textRenderingMode = _util2.TextRenderingMode.FILL;
                  this.fillColorSpace = _colorspace.ColorSpace.singletons.gray;
                  this.strokeColorSpace = _colorspace.ColorSpace.singletons.gray;
                }
                clone() {
                  return Object.create(this);
                }
              }
              class EvaluatorPreprocessor {
                static get opMap() {
                  return (0, _util2.shadow)(this, "opMap", {
                    w: {
                      id: _util2.OPS.setLineWidth,
                      numArgs: 1,
                      variableArgs: false
                    },
                    J: {
                      id: _util2.OPS.setLineCap,
                      numArgs: 1,
                      variableArgs: false
                    },
                    j: {
                      id: _util2.OPS.setLineJoin,
                      numArgs: 1,
                      variableArgs: false
                    },
                    M: {
                      id: _util2.OPS.setMiterLimit,
                      numArgs: 1,
                      variableArgs: false
                    },
                    d: {
                      id: _util2.OPS.setDash,
                      numArgs: 2,
                      variableArgs: false
                    },
                    ri: {
                      id: _util2.OPS.setRenderingIntent,
                      numArgs: 1,
                      variableArgs: false
                    },
                    i: {
                      id: _util2.OPS.setFlatness,
                      numArgs: 1,
                      variableArgs: false
                    },
                    gs: {
                      id: _util2.OPS.setGState,
                      numArgs: 1,
                      variableArgs: false
                    },
                    q: {
                      id: _util2.OPS.save,
                      numArgs: 0,
                      variableArgs: false
                    },
                    Q: {
                      id: _util2.OPS.restore,
                      numArgs: 0,
                      variableArgs: false
                    },
                    cm: {
                      id: _util2.OPS.transform,
                      numArgs: 6,
                      variableArgs: false
                    },
                    m: {
                      id: _util2.OPS.moveTo,
                      numArgs: 2,
                      variableArgs: false
                    },
                    l: {
                      id: _util2.OPS.lineTo,
                      numArgs: 2,
                      variableArgs: false
                    },
                    c: {
                      id: _util2.OPS.curveTo,
                      numArgs: 6,
                      variableArgs: false
                    },
                    v: {
                      id: _util2.OPS.curveTo2,
                      numArgs: 4,
                      variableArgs: false
                    },
                    y: {
                      id: _util2.OPS.curveTo3,
                      numArgs: 4,
                      variableArgs: false
                    },
                    h: {
                      id: _util2.OPS.closePath,
                      numArgs: 0,
                      variableArgs: false
                    },
                    re: {
                      id: _util2.OPS.rectangle,
                      numArgs: 4,
                      variableArgs: false
                    },
                    S: {
                      id: _util2.OPS.stroke,
                      numArgs: 0,
                      variableArgs: false
                    },
                    s: {
                      id: _util2.OPS.closeStroke,
                      numArgs: 0,
                      variableArgs: false
                    },
                    f: {
                      id: _util2.OPS.fill,
                      numArgs: 0,
                      variableArgs: false
                    },
                    F: {
                      id: _util2.OPS.fill,
                      numArgs: 0,
                      variableArgs: false
                    },
                    "f*": {
                      id: _util2.OPS.eoFill,
                      numArgs: 0,
                      variableArgs: false
                    },
                    B: {
                      id: _util2.OPS.fillStroke,
                      numArgs: 0,
                      variableArgs: false
                    },
                    "B*": {
                      id: _util2.OPS.eoFillStroke,
                      numArgs: 0,
                      variableArgs: false
                    },
                    b: {
                      id: _util2.OPS.closeFillStroke,
                      numArgs: 0,
                      variableArgs: false
                    },
                    "b*": {
                      id: _util2.OPS.closeEOFillStroke,
                      numArgs: 0,
                      variableArgs: false
                    },
                    n: {
                      id: _util2.OPS.endPath,
                      numArgs: 0,
                      variableArgs: false
                    },
                    W: {
                      id: _util2.OPS.clip,
                      numArgs: 0,
                      variableArgs: false
                    },
                    "W*": {
                      id: _util2.OPS.eoClip,
                      numArgs: 0,
                      variableArgs: false
                    },
                    BT: {
                      id: _util2.OPS.beginText,
                      numArgs: 0,
                      variableArgs: false
                    },
                    ET: {
                      id: _util2.OPS.endText,
                      numArgs: 0,
                      variableArgs: false
                    },
                    Tc: {
                      id: _util2.OPS.setCharSpacing,
                      numArgs: 1,
                      variableArgs: false
                    },
                    Tw: {
                      id: _util2.OPS.setWordSpacing,
                      numArgs: 1,
                      variableArgs: false
                    },
                    Tz: {
                      id: _util2.OPS.setHScale,
                      numArgs: 1,
                      variableArgs: false
                    },
                    TL: {
                      id: _util2.OPS.setLeading,
                      numArgs: 1,
                      variableArgs: false
                    },
                    Tf: {
                      id: _util2.OPS.setFont,
                      numArgs: 2,
                      variableArgs: false
                    },
                    Tr: {
                      id: _util2.OPS.setTextRenderingMode,
                      numArgs: 1,
                      variableArgs: false
                    },
                    Ts: {
                      id: _util2.OPS.setTextRise,
                      numArgs: 1,
                      variableArgs: false
                    },
                    Td: {
                      id: _util2.OPS.moveText,
                      numArgs: 2,
                      variableArgs: false
                    },
                    TD: {
                      id: _util2.OPS.setLeadingMoveText,
                      numArgs: 2,
                      variableArgs: false
                    },
                    Tm: {
                      id: _util2.OPS.setTextMatrix,
                      numArgs: 6,
                      variableArgs: false
                    },
                    "T*": {
                      id: _util2.OPS.nextLine,
                      numArgs: 0,
                      variableArgs: false
                    },
                    Tj: {
                      id: _util2.OPS.showText,
                      numArgs: 1,
                      variableArgs: false
                    },
                    TJ: {
                      id: _util2.OPS.showSpacedText,
                      numArgs: 1,
                      variableArgs: false
                    },
                    "'": {
                      id: _util2.OPS.nextLineShowText,
                      numArgs: 1,
                      variableArgs: false
                    },
                    '"': {
                      id: _util2.OPS.nextLineSetSpacingShowText,
                      numArgs: 3,
                      variableArgs: false
                    },
                    d0: {
                      id: _util2.OPS.setCharWidth,
                      numArgs: 2,
                      variableArgs: false
                    },
                    d1: {
                      id: _util2.OPS.setCharWidthAndBounds,
                      numArgs: 6,
                      variableArgs: false
                    },
                    CS: {
                      id: _util2.OPS.setStrokeColorSpace,
                      numArgs: 1,
                      variableArgs: false
                    },
                    cs: {
                      id: _util2.OPS.setFillColorSpace,
                      numArgs: 1,
                      variableArgs: false
                    },
                    SC: {
                      id: _util2.OPS.setStrokeColor,
                      numArgs: 4,
                      variableArgs: true
                    },
                    SCN: {
                      id: _util2.OPS.setStrokeColorN,
                      numArgs: 33,
                      variableArgs: true
                    },
                    sc: {
                      id: _util2.OPS.setFillColor,
                      numArgs: 4,
                      variableArgs: true
                    },
                    scn: {
                      id: _util2.OPS.setFillColorN,
                      numArgs: 33,
                      variableArgs: true
                    },
                    G: {
                      id: _util2.OPS.setStrokeGray,
                      numArgs: 1,
                      variableArgs: false
                    },
                    g: {
                      id: _util2.OPS.setFillGray,
                      numArgs: 1,
                      variableArgs: false
                    },
                    RG: {
                      id: _util2.OPS.setStrokeRGBColor,
                      numArgs: 3,
                      variableArgs: false
                    },
                    rg: {
                      id: _util2.OPS.setFillRGBColor,
                      numArgs: 3,
                      variableArgs: false
                    },
                    K: {
                      id: _util2.OPS.setStrokeCMYKColor,
                      numArgs: 4,
                      variableArgs: false
                    },
                    k: {
                      id: _util2.OPS.setFillCMYKColor,
                      numArgs: 4,
                      variableArgs: false
                    },
                    sh: {
                      id: _util2.OPS.shadingFill,
                      numArgs: 1,
                      variableArgs: false
                    },
                    BI: {
                      id: _util2.OPS.beginInlineImage,
                      numArgs: 0,
                      variableArgs: false
                    },
                    ID: {
                      id: _util2.OPS.beginImageData,
                      numArgs: 0,
                      variableArgs: false
                    },
                    EI: {
                      id: _util2.OPS.endInlineImage,
                      numArgs: 1,
                      variableArgs: false
                    },
                    Do: {
                      id: _util2.OPS.paintXObject,
                      numArgs: 1,
                      variableArgs: false
                    },
                    MP: {
                      id: _util2.OPS.markPoint,
                      numArgs: 1,
                      variableArgs: false
                    },
                    DP: {
                      id: _util2.OPS.markPointProps,
                      numArgs: 2,
                      variableArgs: false
                    },
                    BMC: {
                      id: _util2.OPS.beginMarkedContent,
                      numArgs: 1,
                      variableArgs: false
                    },
                    BDC: {
                      id: _util2.OPS.beginMarkedContentProps,
                      numArgs: 2,
                      variableArgs: false
                    },
                    EMC: {
                      id: _util2.OPS.endMarkedContent,
                      numArgs: 0,
                      variableArgs: false
                    },
                    BX: {
                      id: _util2.OPS.beginCompat,
                      numArgs: 0,
                      variableArgs: false
                    },
                    EX: {
                      id: _util2.OPS.endCompat,
                      numArgs: 0,
                      variableArgs: false
                    },
                    BM: null,
                    BD: null,
                    true: null,
                    fa: null,
                    fal: null,
                    fals: null,
                    false: null,
                    nu: null,
                    nul: null,
                    null: null
                  });
                }
                static MAX_INVALID_PATH_OPS = 10;
                constructor(stream, xref, stateManager = new StateManager()) {
                  this.parser = new _parser.Parser({
                    lexer: new _parser.Lexer(stream, EvaluatorPreprocessor.opMap),
                    xref
                  });
                  this.stateManager = stateManager;
                  this.nonProcessedArgs = [];
                  this._isPathOp = false;
                  this._numInvalidPathOPS = 0;
                }
                get savedStatesDepth() {
                  return this.stateManager.stateStack.length;
                }
                read(operation) {
                  let args = operation.args;
                  while (true) {
                    const obj = this.parser.getObj();
                    if (obj instanceof _primitives.Cmd) {
                      const cmd = obj.cmd;
                      const opSpec = EvaluatorPreprocessor.opMap[cmd];
                      if (!opSpec) {
                        (0, _util2.warn)(`Unknown command "${cmd}".`);
                        continue;
                      }
                      const fn = opSpec.id;
                      const numArgs = opSpec.numArgs;
                      let argsLength = args !== null ? args.length : 0;
                      if (!this._isPathOp) {
                        this._numInvalidPathOPS = 0;
                      }
                      this._isPathOp = fn >= _util2.OPS.moveTo && fn <= _util2.OPS.endPath;
                      if (!opSpec.variableArgs) {
                        if (argsLength !== numArgs) {
                          const nonProcessedArgs = this.nonProcessedArgs;
                          while (argsLength > numArgs) {
                            nonProcessedArgs.push(args.shift());
                            argsLength--;
                          }
                          while (argsLength < numArgs && nonProcessedArgs.length !== 0) {
                            if (args === null) {
                              args = [];
                            }
                            args.unshift(nonProcessedArgs.pop());
                            argsLength++;
                          }
                        }
                        if (argsLength < numArgs) {
                          const partialMsg = `command ${cmd}: expected ${numArgs} args, but received ${argsLength} args.`;
                          if (this._isPathOp && ++this._numInvalidPathOPS > EvaluatorPreprocessor.MAX_INVALID_PATH_OPS) {
                            throw new _util2.FormatError(`Invalid ${partialMsg}`);
                          }
                          (0, _util2.warn)(`Skipping ${partialMsg}`);
                          if (args !== null) {
                            args.length = 0;
                          }
                          continue;
                        }
                      } else if (argsLength > numArgs) {
                        (0, _util2.info)(`Command ${cmd}: expected [0, ${numArgs}] args, but received ${argsLength} args.`);
                      }
                      this.preprocessCommand(fn, args);
                      operation.fn = fn;
                      operation.args = args;
                      return true;
                    }
                    if (obj === _primitives.EOF) {
                      return false;
                    }
                    if (obj !== null) {
                      if (args === null) {
                        args = [];
                      }
                      args.push(obj);
                      if (args.length > 33) {
                        throw new _util2.FormatError("Too many arguments");
                      }
                    }
                  }
                }
                preprocessCommand(fn, args) {
                  switch (fn | 0) {
                    case _util2.OPS.save:
                      this.stateManager.save();
                      break;
                    case _util2.OPS.restore:
                      this.stateManager.restore();
                      break;
                    case _util2.OPS.transform:
                      this.stateManager.transform(args);
                      break;
                  }
                }
              }
              exports3.EvaluatorPreprocessor = EvaluatorPreprocessor;
            }),
            /* 14 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.IdentityCMap = exports3.CMapFactory = exports3.CMap = void 0;
              var _util2 = __w_pdfjs_require__3(2);
              var _primitives = __w_pdfjs_require__3(4);
              var _base_stream = __w_pdfjs_require__3(5);
              var _binary_cmap = __w_pdfjs_require__3(15);
              var _parser = __w_pdfjs_require__3(16);
              var _core_utils = __w_pdfjs_require__3(3);
              var _stream = __w_pdfjs_require__3(8);
              const BUILT_IN_CMAPS = ["Adobe-GB1-UCS2", "Adobe-CNS1-UCS2", "Adobe-Japan1-UCS2", "Adobe-Korea1-UCS2", "78-EUC-H", "78-EUC-V", "78-H", "78-RKSJ-H", "78-RKSJ-V", "78-V", "78ms-RKSJ-H", "78ms-RKSJ-V", "83pv-RKSJ-H", "90ms-RKSJ-H", "90ms-RKSJ-V", "90msp-RKSJ-H", "90msp-RKSJ-V", "90pv-RKSJ-H", "90pv-RKSJ-V", "Add-H", "Add-RKSJ-H", "Add-RKSJ-V", "Add-V", "Adobe-CNS1-0", "Adobe-CNS1-1", "Adobe-CNS1-2", "Adobe-CNS1-3", "Adobe-CNS1-4", "Adobe-CNS1-5", "Adobe-CNS1-6", "Adobe-GB1-0", "Adobe-GB1-1", "Adobe-GB1-2", "Adobe-GB1-3", "Adobe-GB1-4", "Adobe-GB1-5", "Adobe-Japan1-0", "Adobe-Japan1-1", "Adobe-Japan1-2", "Adobe-Japan1-3", "Adobe-Japan1-4", "Adobe-Japan1-5", "Adobe-Japan1-6", "Adobe-Korea1-0", "Adobe-Korea1-1", "Adobe-Korea1-2", "B5-H", "B5-V", "B5pc-H", "B5pc-V", "CNS-EUC-H", "CNS-EUC-V", "CNS1-H", "CNS1-V", "CNS2-H", "CNS2-V", "ETHK-B5-H", "ETHK-B5-V", "ETen-B5-H", "ETen-B5-V", "ETenms-B5-H", "ETenms-B5-V", "EUC-H", "EUC-V", "Ext-H", "Ext-RKSJ-H", "Ext-RKSJ-V", "Ext-V", "GB-EUC-H", "GB-EUC-V", "GB-H", "GB-V", "GBK-EUC-H", "GBK-EUC-V", "GBK2K-H", "GBK2K-V", "GBKp-EUC-H", "GBKp-EUC-V", "GBT-EUC-H", "GBT-EUC-V", "GBT-H", "GBT-V", "GBTpc-EUC-H", "GBTpc-EUC-V", "GBpc-EUC-H", "GBpc-EUC-V", "H", "HKdla-B5-H", "HKdla-B5-V", "HKdlb-B5-H", "HKdlb-B5-V", "HKgccs-B5-H", "HKgccs-B5-V", "HKm314-B5-H", "HKm314-B5-V", "HKm471-B5-H", "HKm471-B5-V", "HKscs-B5-H", "HKscs-B5-V", "Hankaku", "Hiragana", "KSC-EUC-H", "KSC-EUC-V", "KSC-H", "KSC-Johab-H", "KSC-Johab-V", "KSC-V", "KSCms-UHC-H", "KSCms-UHC-HW-H", "KSCms-UHC-HW-V", "KSCms-UHC-V", "KSCpc-EUC-H", "KSCpc-EUC-V", "Katakana", "NWP-H", "NWP-V", "RKSJ-H", "RKSJ-V", "Roman", "UniCNS-UCS2-H", "UniCNS-UCS2-V", "UniCNS-UTF16-H", "UniCNS-UTF16-V", "UniCNS-UTF32-H", "UniCNS-UTF32-V", "UniCNS-UTF8-H", "UniCNS-UTF8-V", "UniGB-UCS2-H", "UniGB-UCS2-V", "UniGB-UTF16-H", "UniGB-UTF16-V", "UniGB-UTF32-H", "UniGB-UTF32-V", "UniGB-UTF8-H", "UniGB-UTF8-V", "UniJIS-UCS2-H", "UniJIS-UCS2-HW-H", "UniJIS-UCS2-HW-V", "UniJIS-UCS2-V", "UniJIS-UTF16-H", "UniJIS-UTF16-V", "UniJIS-UTF32-H", "UniJIS-UTF32-V", "UniJIS-UTF8-H", "UniJIS-UTF8-V", "UniJIS2004-UTF16-H", "UniJIS2004-UTF16-V", "UniJIS2004-UTF32-H", "UniJIS2004-UTF32-V", "UniJIS2004-UTF8-H", "UniJIS2004-UTF8-V", "UniJISPro-UCS2-HW-V", "UniJISPro-UCS2-V", "UniJISPro-UTF8-V", "UniJISX0213-UTF32-H", "UniJISX0213-UTF32-V", "UniJISX02132004-UTF32-H", "UniJISX02132004-UTF32-V", "UniKS-UCS2-H", "UniKS-UCS2-V", "UniKS-UTF16-H", "UniKS-UTF16-V", "UniKS-UTF32-H", "UniKS-UTF32-V", "UniKS-UTF8-H", "UniKS-UTF8-V", "V", "WP-Symbol"];
              const MAX_MAP_RANGE = 2 ** 24 - 1;
              class CMap {
                constructor(builtInCMap = false) {
                  this.codespaceRanges = [[], [], [], []];
                  this.numCodespaceRanges = 0;
                  this._map = [];
                  this.name = "";
                  this.vertical = false;
                  this.useCMap = null;
                  this.builtInCMap = builtInCMap;
                }
                addCodespaceRange(n2, low, high) {
                  this.codespaceRanges[n2 - 1].push(low, high);
                  this.numCodespaceRanges++;
                }
                mapCidRange(low, high, dstLow) {
                  if (high - low > MAX_MAP_RANGE) {
                    throw new Error("mapCidRange - ignoring data above MAX_MAP_RANGE.");
                  }
                  while (low <= high) {
                    this._map[low++] = dstLow++;
                  }
                }
                mapBfRange(low, high, dstLow) {
                  if (high - low > MAX_MAP_RANGE) {
                    throw new Error("mapBfRange - ignoring data above MAX_MAP_RANGE.");
                  }
                  const lastByte = dstLow.length - 1;
                  while (low <= high) {
                    this._map[low++] = dstLow;
                    const nextCharCode = dstLow.charCodeAt(lastByte) + 1;
                    if (nextCharCode > 255) {
                      dstLow = dstLow.substring(0, lastByte - 1) + String.fromCharCode(dstLow.charCodeAt(lastByte - 1) + 1) + "\0";
                      continue;
                    }
                    dstLow = dstLow.substring(0, lastByte) + String.fromCharCode(nextCharCode);
                  }
                }
                mapBfRangeToArray(low, high, array4) {
                  if (high - low > MAX_MAP_RANGE) {
                    throw new Error("mapBfRangeToArray - ignoring data above MAX_MAP_RANGE.");
                  }
                  const ii = array4.length;
                  let i = 0;
                  while (low <= high && i < ii) {
                    this._map[low] = array4[i++];
                    ++low;
                  }
                }
                mapOne(src, dst) {
                  this._map[src] = dst;
                }
                lookup(code2) {
                  return this._map[code2];
                }
                contains(code2) {
                  return this._map[code2] !== void 0;
                }
                forEach(callback) {
                  const map = this._map;
                  const length2 = map.length;
                  if (length2 <= 65536) {
                    for (let i = 0; i < length2; i++) {
                      if (map[i] !== void 0) {
                        callback(i, map[i]);
                      }
                    }
                  } else {
                    for (const i in map) {
                      callback(i, map[i]);
                    }
                  }
                }
                charCodeOf(value) {
                  const map = this._map;
                  if (map.length <= 65536) {
                    return map.indexOf(value);
                  }
                  for (const charCode in map) {
                    if (map[charCode] === value) {
                      return charCode | 0;
                    }
                  }
                  return -1;
                }
                getMap() {
                  return this._map;
                }
                readCharCode(str, offset4, out) {
                  let c = 0;
                  const codespaceRanges = this.codespaceRanges;
                  for (let n2 = 0, nn = codespaceRanges.length; n2 < nn; n2++) {
                    c = (c << 8 | str.charCodeAt(offset4 + n2)) >>> 0;
                    const codespaceRange = codespaceRanges[n2];
                    for (let k = 0, kk = codespaceRange.length; k < kk; ) {
                      const low = codespaceRange[k++];
                      const high = codespaceRange[k++];
                      if (c >= low && c <= high) {
                        out.charcode = c;
                        out.length = n2 + 1;
                        return;
                      }
                    }
                  }
                  out.charcode = 0;
                  out.length = 1;
                }
                getCharCodeLength(charCode) {
                  const codespaceRanges = this.codespaceRanges;
                  for (let n2 = 0, nn = codespaceRanges.length; n2 < nn; n2++) {
                    const codespaceRange = codespaceRanges[n2];
                    for (let k = 0, kk = codespaceRange.length; k < kk; ) {
                      const low = codespaceRange[k++];
                      const high = codespaceRange[k++];
                      if (charCode >= low && charCode <= high) {
                        return n2 + 1;
                      }
                    }
                  }
                  return 1;
                }
                get length() {
                  return this._map.length;
                }
                get isIdentityCMap() {
                  if (!(this.name === "Identity-H" || this.name === "Identity-V")) {
                    return false;
                  }
                  if (this._map.length !== 65536) {
                    return false;
                  }
                  for (let i = 0; i < 65536; i++) {
                    if (this._map[i] !== i) {
                      return false;
                    }
                  }
                  return true;
                }
              }
              exports3.CMap = CMap;
              class IdentityCMap extends CMap {
                constructor(vertical, n2) {
                  super();
                  this.vertical = vertical;
                  this.addCodespaceRange(n2, 0, 65535);
                }
                mapCidRange(low, high, dstLow) {
                  (0, _util2.unreachable)("should not call mapCidRange");
                }
                mapBfRange(low, high, dstLow) {
                  (0, _util2.unreachable)("should not call mapBfRange");
                }
                mapBfRangeToArray(low, high, array4) {
                  (0, _util2.unreachable)("should not call mapBfRangeToArray");
                }
                mapOne(src, dst) {
                  (0, _util2.unreachable)("should not call mapCidOne");
                }
                lookup(code2) {
                  return Number.isInteger(code2) && code2 <= 65535 ? code2 : void 0;
                }
                contains(code2) {
                  return Number.isInteger(code2) && code2 <= 65535;
                }
                forEach(callback) {
                  for (let i = 0; i <= 65535; i++) {
                    callback(i, i);
                  }
                }
                charCodeOf(value) {
                  return Number.isInteger(value) && value <= 65535 ? value : -1;
                }
                getMap() {
                  const map = new Array(65536);
                  for (let i = 0; i <= 65535; i++) {
                    map[i] = i;
                  }
                  return map;
                }
                get length() {
                  return 65536;
                }
                get isIdentityCMap() {
                  (0, _util2.unreachable)("should not access .isIdentityCMap");
                }
              }
              exports3.IdentityCMap = IdentityCMap;
              function strToInt(str) {
                let a = 0;
                for (let i = 0; i < str.length; i++) {
                  a = a << 8 | str.charCodeAt(i);
                }
                return a >>> 0;
              }
              function expectString(obj) {
                if (typeof obj !== "string") {
                  throw new _util2.FormatError("Malformed CMap: expected string.");
                }
              }
              function expectInt(obj) {
                if (!Number.isInteger(obj)) {
                  throw new _util2.FormatError("Malformed CMap: expected int.");
                }
              }
              function parseBfChar(cMap, lexer) {
                while (true) {
                  let obj = lexer.getObj();
                  if (obj === _primitives.EOF) {
                    break;
                  }
                  if ((0, _primitives.isCmd)(obj, "endbfchar")) {
                    return;
                  }
                  expectString(obj);
                  const src = strToInt(obj);
                  obj = lexer.getObj();
                  expectString(obj);
                  const dst = obj;
                  cMap.mapOne(src, dst);
                }
              }
              function parseBfRange(cMap, lexer) {
                while (true) {
                  let obj = lexer.getObj();
                  if (obj === _primitives.EOF) {
                    break;
                  }
                  if ((0, _primitives.isCmd)(obj, "endbfrange")) {
                    return;
                  }
                  expectString(obj);
                  const low = strToInt(obj);
                  obj = lexer.getObj();
                  expectString(obj);
                  const high = strToInt(obj);
                  obj = lexer.getObj();
                  if (Number.isInteger(obj) || typeof obj === "string") {
                    const dstLow = Number.isInteger(obj) ? String.fromCharCode(obj) : obj;
                    cMap.mapBfRange(low, high, dstLow);
                  } else if ((0, _primitives.isCmd)(obj, "[")) {
                    obj = lexer.getObj();
                    const array4 = [];
                    while (!(0, _primitives.isCmd)(obj, "]") && obj !== _primitives.EOF) {
                      array4.push(obj);
                      obj = lexer.getObj();
                    }
                    cMap.mapBfRangeToArray(low, high, array4);
                  } else {
                    break;
                  }
                }
                throw new _util2.FormatError("Invalid bf range.");
              }
              function parseCidChar(cMap, lexer) {
                while (true) {
                  let obj = lexer.getObj();
                  if (obj === _primitives.EOF) {
                    break;
                  }
                  if ((0, _primitives.isCmd)(obj, "endcidchar")) {
                    return;
                  }
                  expectString(obj);
                  const src = strToInt(obj);
                  obj = lexer.getObj();
                  expectInt(obj);
                  const dst = obj;
                  cMap.mapOne(src, dst);
                }
              }
              function parseCidRange(cMap, lexer) {
                while (true) {
                  let obj = lexer.getObj();
                  if (obj === _primitives.EOF) {
                    break;
                  }
                  if ((0, _primitives.isCmd)(obj, "endcidrange")) {
                    return;
                  }
                  expectString(obj);
                  const low = strToInt(obj);
                  obj = lexer.getObj();
                  expectString(obj);
                  const high = strToInt(obj);
                  obj = lexer.getObj();
                  expectInt(obj);
                  const dstLow = obj;
                  cMap.mapCidRange(low, high, dstLow);
                }
              }
              function parseCodespaceRange(cMap, lexer) {
                while (true) {
                  let obj = lexer.getObj();
                  if (obj === _primitives.EOF) {
                    break;
                  }
                  if ((0, _primitives.isCmd)(obj, "endcodespacerange")) {
                    return;
                  }
                  if (typeof obj !== "string") {
                    break;
                  }
                  const low = strToInt(obj);
                  obj = lexer.getObj();
                  if (typeof obj !== "string") {
                    break;
                  }
                  const high = strToInt(obj);
                  cMap.addCodespaceRange(obj.length, low, high);
                }
                throw new _util2.FormatError("Invalid codespace range.");
              }
              function parseWMode(cMap, lexer) {
                const obj = lexer.getObj();
                if (Number.isInteger(obj)) {
                  cMap.vertical = !!obj;
                }
              }
              function parseCMapName(cMap, lexer) {
                const obj = lexer.getObj();
                if (obj instanceof _primitives.Name) {
                  cMap.name = obj.name;
                }
              }
              async function parseCMap(cMap, lexer, fetchBuiltInCMap, useCMap) {
                let previous, embeddedUseCMap;
                objLoop: while (true) {
                  try {
                    const obj = lexer.getObj();
                    if (obj === _primitives.EOF) {
                      break;
                    } else if (obj instanceof _primitives.Name) {
                      if (obj.name === "WMode") {
                        parseWMode(cMap, lexer);
                      } else if (obj.name === "CMapName") {
                        parseCMapName(cMap, lexer);
                      }
                      previous = obj;
                    } else if (obj instanceof _primitives.Cmd) {
                      switch (obj.cmd) {
                        case "endcmap":
                          break objLoop;
                        case "usecmap":
                          if (previous instanceof _primitives.Name) {
                            embeddedUseCMap = previous.name;
                          }
                          break;
                        case "begincodespacerange":
                          parseCodespaceRange(cMap, lexer);
                          break;
                        case "beginbfchar":
                          parseBfChar(cMap, lexer);
                          break;
                        case "begincidchar":
                          parseCidChar(cMap, lexer);
                          break;
                        case "beginbfrange":
                          parseBfRange(cMap, lexer);
                          break;
                        case "begincidrange":
                          parseCidRange(cMap, lexer);
                          break;
                      }
                    }
                  } catch (ex) {
                    if (ex instanceof _core_utils.MissingDataException) {
                      throw ex;
                    }
                    (0, _util2.warn)("Invalid cMap data: " + ex);
                    continue;
                  }
                }
                if (!useCMap && embeddedUseCMap) {
                  useCMap = embeddedUseCMap;
                }
                if (useCMap) {
                  return extendCMap(cMap, fetchBuiltInCMap, useCMap);
                }
                return cMap;
              }
              async function extendCMap(cMap, fetchBuiltInCMap, useCMap) {
                cMap.useCMap = await createBuiltInCMap(useCMap, fetchBuiltInCMap);
                if (cMap.numCodespaceRanges === 0) {
                  const useCodespaceRanges = cMap.useCMap.codespaceRanges;
                  for (let i = 0; i < useCodespaceRanges.length; i++) {
                    cMap.codespaceRanges[i] = useCodespaceRanges[i].slice();
                  }
                  cMap.numCodespaceRanges = cMap.useCMap.numCodespaceRanges;
                }
                cMap.useCMap.forEach(function(key2, value) {
                  if (!cMap.contains(key2)) {
                    cMap.mapOne(key2, cMap.useCMap.lookup(key2));
                  }
                });
                return cMap;
              }
              async function createBuiltInCMap(name, fetchBuiltInCMap) {
                if (name === "Identity-H") {
                  return new IdentityCMap(false, 2);
                } else if (name === "Identity-V") {
                  return new IdentityCMap(true, 2);
                }
                if (!BUILT_IN_CMAPS.includes(name)) {
                  throw new Error("Unknown CMap name: " + name);
                }
                if (!fetchBuiltInCMap) {
                  throw new Error("Built-in CMap parameters are not provided.");
                }
                const {
                  cMapData,
                  compressionType
                } = await fetchBuiltInCMap(name);
                const cMap = new CMap(true);
                if (compressionType === _util2.CMapCompressionType.BINARY) {
                  return new _binary_cmap.BinaryCMapReader().process(cMapData, cMap, (useCMap) => {
                    return extendCMap(cMap, fetchBuiltInCMap, useCMap);
                  });
                }
                if (compressionType === _util2.CMapCompressionType.NONE) {
                  const lexer = new _parser.Lexer(new _stream.Stream(cMapData));
                  return parseCMap(cMap, lexer, fetchBuiltInCMap, null);
                }
                throw new Error(`Invalid CMap "compressionType" value: ${compressionType}`);
              }
              class CMapFactory {
                static async create({
                  encoding,
                  fetchBuiltInCMap,
                  useCMap
                }) {
                  if (encoding instanceof _primitives.Name) {
                    return createBuiltInCMap(encoding.name, fetchBuiltInCMap);
                  } else if (encoding instanceof _base_stream.BaseStream) {
                    const parsedCMap = await parseCMap(new CMap(), new _parser.Lexer(encoding), fetchBuiltInCMap, useCMap);
                    if (parsedCMap.isIdentityCMap) {
                      return createBuiltInCMap(parsedCMap.name, fetchBuiltInCMap);
                    }
                    return parsedCMap;
                  }
                  throw new Error("Encoding required.");
                }
              }
              exports3.CMapFactory = CMapFactory;
            }),
            /* 15 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.BinaryCMapReader = void 0;
              var _util2 = __w_pdfjs_require__3(2);
              function hexToInt2(a, size) {
                let n2 = 0;
                for (let i = 0; i <= size; i++) {
                  n2 = n2 << 8 | a[i];
                }
                return n2 >>> 0;
              }
              function hexToStr(a, size) {
                if (size === 1) {
                  return String.fromCharCode(a[0], a[1]);
                }
                if (size === 3) {
                  return String.fromCharCode(a[0], a[1], a[2], a[3]);
                }
                return String.fromCharCode(...a.subarray(0, size + 1));
              }
              function addHex(a, b, size) {
                let c = 0;
                for (let i = size; i >= 0; i--) {
                  c += a[i] + b[i];
                  a[i] = c & 255;
                  c >>= 8;
                }
              }
              function incHex(a, size) {
                let c = 1;
                for (let i = size; i >= 0 && c > 0; i--) {
                  c += a[i];
                  a[i] = c & 255;
                  c >>= 8;
                }
              }
              const MAX_NUM_SIZE = 16;
              const MAX_ENCODED_NUM_SIZE = 19;
              class BinaryCMapStream {
                constructor(data2) {
                  this.buffer = data2;
                  this.pos = 0;
                  this.end = data2.length;
                  this.tmpBuf = new Uint8Array(MAX_ENCODED_NUM_SIZE);
                }
                readByte() {
                  if (this.pos >= this.end) {
                    return -1;
                  }
                  return this.buffer[this.pos++];
                }
                readNumber() {
                  let n2 = 0;
                  let last2;
                  do {
                    const b = this.readByte();
                    if (b < 0) {
                      throw new _util2.FormatError("unexpected EOF in bcmap");
                    }
                    last2 = !(b & 128);
                    n2 = n2 << 7 | b & 127;
                  } while (!last2);
                  return n2;
                }
                readSigned() {
                  const n2 = this.readNumber();
                  return n2 & 1 ? ~(n2 >>> 1) : n2 >>> 1;
                }
                readHex(num, size) {
                  num.set(this.buffer.subarray(this.pos, this.pos + size + 1));
                  this.pos += size + 1;
                }
                readHexNumber(num, size) {
                  let last2;
                  const stack = this.tmpBuf;
                  let sp = 0;
                  do {
                    const b = this.readByte();
                    if (b < 0) {
                      throw new _util2.FormatError("unexpected EOF in bcmap");
                    }
                    last2 = !(b & 128);
                    stack[sp++] = b & 127;
                  } while (!last2);
                  let i = size, buffer = 0, bufferSize = 0;
                  while (i >= 0) {
                    while (bufferSize < 8 && stack.length > 0) {
                      buffer |= stack[--sp] << bufferSize;
                      bufferSize += 7;
                    }
                    num[i] = buffer & 255;
                    i--;
                    buffer >>= 8;
                    bufferSize -= 8;
                  }
                }
                readHexSigned(num, size) {
                  this.readHexNumber(num, size);
                  const sign2 = num[size] & 1 ? 255 : 0;
                  let c = 0;
                  for (let i = 0; i <= size; i++) {
                    c = (c & 1) << 8 | num[i];
                    num[i] = c >> 1 ^ sign2;
                  }
                }
                readString() {
                  const len = this.readNumber(), buf = new Array(len);
                  for (let i = 0; i < len; i++) {
                    buf[i] = this.readNumber();
                  }
                  return String.fromCharCode(...buf);
                }
              }
              class BinaryCMapReader {
                async process(data2, cMap, extend2) {
                  const stream = new BinaryCMapStream(data2);
                  const header = stream.readByte();
                  cMap.vertical = !!(header & 1);
                  let useCMap = null;
                  const start = new Uint8Array(MAX_NUM_SIZE);
                  const end = new Uint8Array(MAX_NUM_SIZE);
                  const char2 = new Uint8Array(MAX_NUM_SIZE);
                  const charCode = new Uint8Array(MAX_NUM_SIZE);
                  const tmp = new Uint8Array(MAX_NUM_SIZE);
                  let code2;
                  let b;
                  while ((b = stream.readByte()) >= 0) {
                    const type5 = b >> 5;
                    if (type5 === 7) {
                      switch (b & 31) {
                        case 0:
                          stream.readString();
                          break;
                        case 1:
                          useCMap = stream.readString();
                          break;
                      }
                      continue;
                    }
                    const sequence = !!(b & 16);
                    const dataSize = b & 15;
                    if (dataSize + 1 > MAX_NUM_SIZE) {
                      throw new Error("BinaryCMapReader.process: Invalid dataSize.");
                    }
                    const ucs2DataSize = 1;
                    const subitemsCount = stream.readNumber();
                    switch (type5) {
                      case 0:
                        stream.readHex(start, dataSize);
                        stream.readHexNumber(end, dataSize);
                        addHex(end, start, dataSize);
                        cMap.addCodespaceRange(dataSize + 1, hexToInt2(start, dataSize), hexToInt2(end, dataSize));
                        for (let i = 1; i < subitemsCount; i++) {
                          incHex(end, dataSize);
                          stream.readHexNumber(start, dataSize);
                          addHex(start, end, dataSize);
                          stream.readHexNumber(end, dataSize);
                          addHex(end, start, dataSize);
                          cMap.addCodespaceRange(dataSize + 1, hexToInt2(start, dataSize), hexToInt2(end, dataSize));
                        }
                        break;
                      case 1:
                        stream.readHex(start, dataSize);
                        stream.readHexNumber(end, dataSize);
                        addHex(end, start, dataSize);
                        stream.readNumber();
                        for (let i = 1; i < subitemsCount; i++) {
                          incHex(end, dataSize);
                          stream.readHexNumber(start, dataSize);
                          addHex(start, end, dataSize);
                          stream.readHexNumber(end, dataSize);
                          addHex(end, start, dataSize);
                          stream.readNumber();
                        }
                        break;
                      case 2:
                        stream.readHex(char2, dataSize);
                        code2 = stream.readNumber();
                        cMap.mapOne(hexToInt2(char2, dataSize), code2);
                        for (let i = 1; i < subitemsCount; i++) {
                          incHex(char2, dataSize);
                          if (!sequence) {
                            stream.readHexNumber(tmp, dataSize);
                            addHex(char2, tmp, dataSize);
                          }
                          code2 = stream.readSigned() + (code2 + 1);
                          cMap.mapOne(hexToInt2(char2, dataSize), code2);
                        }
                        break;
                      case 3:
                        stream.readHex(start, dataSize);
                        stream.readHexNumber(end, dataSize);
                        addHex(end, start, dataSize);
                        code2 = stream.readNumber();
                        cMap.mapCidRange(hexToInt2(start, dataSize), hexToInt2(end, dataSize), code2);
                        for (let i = 1; i < subitemsCount; i++) {
                          incHex(end, dataSize);
                          if (!sequence) {
                            stream.readHexNumber(start, dataSize);
                            addHex(start, end, dataSize);
                          } else {
                            start.set(end);
                          }
                          stream.readHexNumber(end, dataSize);
                          addHex(end, start, dataSize);
                          code2 = stream.readNumber();
                          cMap.mapCidRange(hexToInt2(start, dataSize), hexToInt2(end, dataSize), code2);
                        }
                        break;
                      case 4:
                        stream.readHex(char2, ucs2DataSize);
                        stream.readHex(charCode, dataSize);
                        cMap.mapOne(hexToInt2(char2, ucs2DataSize), hexToStr(charCode, dataSize));
                        for (let i = 1; i < subitemsCount; i++) {
                          incHex(char2, ucs2DataSize);
                          if (!sequence) {
                            stream.readHexNumber(tmp, ucs2DataSize);
                            addHex(char2, tmp, ucs2DataSize);
                          }
                          incHex(charCode, dataSize);
                          stream.readHexSigned(tmp, dataSize);
                          addHex(charCode, tmp, dataSize);
                          cMap.mapOne(hexToInt2(char2, ucs2DataSize), hexToStr(charCode, dataSize));
                        }
                        break;
                      case 5:
                        stream.readHex(start, ucs2DataSize);
                        stream.readHexNumber(end, ucs2DataSize);
                        addHex(end, start, ucs2DataSize);
                        stream.readHex(charCode, dataSize);
                        cMap.mapBfRange(hexToInt2(start, ucs2DataSize), hexToInt2(end, ucs2DataSize), hexToStr(charCode, dataSize));
                        for (let i = 1; i < subitemsCount; i++) {
                          incHex(end, ucs2DataSize);
                          if (!sequence) {
                            stream.readHexNumber(start, ucs2DataSize);
                            addHex(start, end, ucs2DataSize);
                          } else {
                            start.set(end);
                          }
                          stream.readHexNumber(end, ucs2DataSize);
                          addHex(end, start, ucs2DataSize);
                          stream.readHex(charCode, dataSize);
                          cMap.mapBfRange(hexToInt2(start, ucs2DataSize), hexToInt2(end, ucs2DataSize), hexToStr(charCode, dataSize));
                        }
                        break;
                      default:
                        throw new Error(`BinaryCMapReader.process - unknown type: ${type5}`);
                    }
                  }
                  if (useCMap) {
                    return extend2(useCMap);
                  }
                  return cMap;
                }
              }
              exports3.BinaryCMapReader = BinaryCMapReader;
            }),
            /* 16 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.Parser = exports3.Linearization = exports3.Lexer = void 0;
              var _util2 = __w_pdfjs_require__3(2);
              var _primitives = __w_pdfjs_require__3(4);
              var _core_utils = __w_pdfjs_require__3(3);
              var _stream = __w_pdfjs_require__3(8);
              var _ascii_85_stream = __w_pdfjs_require__3(17);
              var _ascii_hex_stream = __w_pdfjs_require__3(19);
              var _ccitt_stream = __w_pdfjs_require__3(20);
              var _flate_stream = __w_pdfjs_require__3(22);
              var _jbig2_stream = __w_pdfjs_require__3(23);
              var _jpeg_stream = __w_pdfjs_require__3(26);
              var _jpx_stream = __w_pdfjs_require__3(29);
              var _lzw_stream = __w_pdfjs_require__3(31);
              var _predictor_stream = __w_pdfjs_require__3(32);
              var _run_length_stream = __w_pdfjs_require__3(33);
              const MAX_LENGTH_TO_CACHE = 1e3;
              function getInlineImageCacheKey(bytes) {
                const strBuf = [], ii = bytes.length;
                let i = 0;
                while (i < ii - 1) {
                  strBuf.push(bytes[i++] << 8 | bytes[i++]);
                }
                if (i < ii) {
                  strBuf.push(bytes[i]);
                }
                return ii + "_" + String.fromCharCode.apply(null, strBuf);
              }
              class Parser3 {
                constructor({
                  lexer,
                  xref,
                  allowStreams = false,
                  recoveryMode = false
                }) {
                  this.lexer = lexer;
                  this.xref = xref;
                  this.allowStreams = allowStreams;
                  this.recoveryMode = recoveryMode;
                  this.imageCache = /* @__PURE__ */ Object.create(null);
                  this._imageId = 0;
                  this.refill();
                }
                refill() {
                  this.buf1 = this.lexer.getObj();
                  this.buf2 = this.lexer.getObj();
                }
                shift() {
                  if (this.buf2 instanceof _primitives.Cmd && this.buf2.cmd === "ID") {
                    this.buf1 = this.buf2;
                    this.buf2 = null;
                  } else {
                    this.buf1 = this.buf2;
                    this.buf2 = this.lexer.getObj();
                  }
                }
                tryShift() {
                  try {
                    this.shift();
                    return true;
                  } catch (e3) {
                    if (e3 instanceof _core_utils.MissingDataException) {
                      throw e3;
                    }
                    return false;
                  }
                }
                getObj(cipherTransform = null) {
                  const buf1 = this.buf1;
                  this.shift();
                  if (buf1 instanceof _primitives.Cmd) {
                    switch (buf1.cmd) {
                      case "BI":
                        return this.makeInlineImage(cipherTransform);
                      case "[":
                        const array4 = [];
                        while (!(0, _primitives.isCmd)(this.buf1, "]") && this.buf1 !== _primitives.EOF) {
                          array4.push(this.getObj(cipherTransform));
                        }
                        if (this.buf1 === _primitives.EOF) {
                          if (this.recoveryMode) {
                            return array4;
                          }
                          throw new _core_utils.ParserEOFException("End of file inside array.");
                        }
                        this.shift();
                        return array4;
                      case "<<":
                        const dict = new _primitives.Dict(this.xref);
                        while (!(0, _primitives.isCmd)(this.buf1, ">>") && this.buf1 !== _primitives.EOF) {
                          if (!(this.buf1 instanceof _primitives.Name)) {
                            (0, _util2.info)("Malformed dictionary: key must be a name object");
                            this.shift();
                            continue;
                          }
                          const key2 = this.buf1.name;
                          this.shift();
                          if (this.buf1 === _primitives.EOF) {
                            break;
                          }
                          dict.set(key2, this.getObj(cipherTransform));
                        }
                        if (this.buf1 === _primitives.EOF) {
                          if (this.recoveryMode) {
                            return dict;
                          }
                          throw new _core_utils.ParserEOFException("End of file inside dictionary.");
                        }
                        if ((0, _primitives.isCmd)(this.buf2, "stream")) {
                          return this.allowStreams ? this.makeStream(dict, cipherTransform) : dict;
                        }
                        this.shift();
                        return dict;
                      default:
                        return buf1;
                    }
                  }
                  if (Number.isInteger(buf1)) {
                    if (Number.isInteger(this.buf1) && (0, _primitives.isCmd)(this.buf2, "R")) {
                      const ref3 = _primitives.Ref.get(buf1, this.buf1);
                      this.shift();
                      this.shift();
                      return ref3;
                    }
                    return buf1;
                  }
                  if (typeof buf1 === "string") {
                    if (cipherTransform) {
                      return cipherTransform.decryptString(buf1);
                    }
                    return buf1;
                  }
                  return buf1;
                }
                findDefaultInlineStreamEnd(stream) {
                  const E = 69, I = 73, SPACE = 32, LF = 10, CR = 13, NUL = 0;
                  const {
                    knownCommands
                  } = this.lexer, startPos = stream.pos, n2 = 15;
                  let state = 0, ch, maybeEIPos;
                  while ((ch = stream.getByte()) !== -1) {
                    if (state === 0) {
                      state = ch === E ? 1 : 0;
                    } else if (state === 1) {
                      state = ch === I ? 2 : 0;
                    } else {
                      if (ch === SPACE || ch === LF || ch === CR) {
                        maybeEIPos = stream.pos;
                        const followingBytes = stream.peekBytes(n2);
                        const ii = followingBytes.length;
                        if (ii === 0) {
                          break;
                        }
                        for (let i = 0; i < ii; i++) {
                          ch = followingBytes[i];
                          if (ch === NUL && followingBytes[i + 1] !== NUL) {
                            continue;
                          }
                          if (ch !== LF && ch !== CR && (ch < SPACE || ch > 127)) {
                            state = 0;
                            break;
                          }
                        }
                        if (state !== 2) {
                          continue;
                        }
                        if (!knownCommands) {
                          (0, _util2.warn)("findDefaultInlineStreamEnd - `lexer.knownCommands` is undefined.");
                          continue;
                        }
                        const tmpLexer = new Lexer(new _stream.Stream(followingBytes.slice()), knownCommands);
                        tmpLexer._hexStringWarn = () => {
                        };
                        let numArgs = 0;
                        while (true) {
                          const nextObj = tmpLexer.getObj();
                          if (nextObj === _primitives.EOF) {
                            state = 0;
                            break;
                          }
                          if (nextObj instanceof _primitives.Cmd) {
                            const knownCommand = knownCommands[nextObj.cmd];
                            if (!knownCommand) {
                              state = 0;
                              break;
                            } else if (knownCommand.variableArgs ? numArgs <= knownCommand.numArgs : numArgs === knownCommand.numArgs) {
                              break;
                            }
                            numArgs = 0;
                            continue;
                          }
                          numArgs++;
                        }
                        if (state === 2) {
                          break;
                        }
                      } else {
                        state = 0;
                      }
                    }
                  }
                  if (ch === -1) {
                    (0, _util2.warn)("findDefaultInlineStreamEnd: Reached the end of the stream without finding a valid EI marker");
                    if (maybeEIPos) {
                      (0, _util2.warn)('... trying to recover by using the last "EI" occurrence.');
                      stream.skip(-(stream.pos - maybeEIPos));
                    }
                  }
                  let endOffset = 4;
                  stream.skip(-endOffset);
                  ch = stream.peekByte();
                  stream.skip(endOffset);
                  if (!(0, _core_utils.isWhiteSpace)(ch)) {
                    endOffset--;
                  }
                  return stream.pos - endOffset - startPos;
                }
                findDCTDecodeInlineStreamEnd(stream) {
                  const startPos = stream.pos;
                  let foundEOI = false, b, markerLength;
                  while ((b = stream.getByte()) !== -1) {
                    if (b !== 255) {
                      continue;
                    }
                    switch (stream.getByte()) {
                      case 0:
                        break;
                      case 255:
                        stream.skip(-1);
                        break;
                      case 217:
                        foundEOI = true;
                        break;
                      case 192:
                      case 193:
                      case 194:
                      case 195:
                      case 197:
                      case 198:
                      case 199:
                      case 201:
                      case 202:
                      case 203:
                      case 205:
                      case 206:
                      case 207:
                      case 196:
                      case 204:
                      case 218:
                      case 219:
                      case 220:
                      case 221:
                      case 222:
                      case 223:
                      case 224:
                      case 225:
                      case 226:
                      case 227:
                      case 228:
                      case 229:
                      case 230:
                      case 231:
                      case 232:
                      case 233:
                      case 234:
                      case 235:
                      case 236:
                      case 237:
                      case 238:
                      case 239:
                      case 254:
                        markerLength = stream.getUint16();
                        if (markerLength > 2) {
                          stream.skip(markerLength - 2);
                        } else {
                          stream.skip(-2);
                        }
                        break;
                    }
                    if (foundEOI) {
                      break;
                    }
                  }
                  const length2 = stream.pos - startPos;
                  if (b === -1) {
                    (0, _util2.warn)("Inline DCTDecode image stream: EOI marker not found, searching for /EI/ instead.");
                    stream.skip(-length2);
                    return this.findDefaultInlineStreamEnd(stream);
                  }
                  this.inlineStreamSkipEI(stream);
                  return length2;
                }
                findASCII85DecodeInlineStreamEnd(stream) {
                  const TILDE = 126, GT = 62;
                  const startPos = stream.pos;
                  let ch;
                  while ((ch = stream.getByte()) !== -1) {
                    if (ch === TILDE) {
                      const tildePos = stream.pos;
                      ch = stream.peekByte();
                      while ((0, _core_utils.isWhiteSpace)(ch)) {
                        stream.skip();
                        ch = stream.peekByte();
                      }
                      if (ch === GT) {
                        stream.skip();
                        break;
                      }
                      if (stream.pos > tildePos) {
                        const maybeEI = stream.peekBytes(2);
                        if (maybeEI[0] === 69 && maybeEI[1] === 73) {
                          break;
                        }
                      }
                    }
                  }
                  const length2 = stream.pos - startPos;
                  if (ch === -1) {
                    (0, _util2.warn)("Inline ASCII85Decode image stream: EOD marker not found, searching for /EI/ instead.");
                    stream.skip(-length2);
                    return this.findDefaultInlineStreamEnd(stream);
                  }
                  this.inlineStreamSkipEI(stream);
                  return length2;
                }
                findASCIIHexDecodeInlineStreamEnd(stream) {
                  const GT = 62;
                  const startPos = stream.pos;
                  let ch;
                  while ((ch = stream.getByte()) !== -1) {
                    if (ch === GT) {
                      break;
                    }
                  }
                  const length2 = stream.pos - startPos;
                  if (ch === -1) {
                    (0, _util2.warn)("Inline ASCIIHexDecode image stream: EOD marker not found, searching for /EI/ instead.");
                    stream.skip(-length2);
                    return this.findDefaultInlineStreamEnd(stream);
                  }
                  this.inlineStreamSkipEI(stream);
                  return length2;
                }
                inlineStreamSkipEI(stream) {
                  const E = 69, I = 73;
                  let state = 0, ch;
                  while ((ch = stream.getByte()) !== -1) {
                    if (state === 0) {
                      state = ch === E ? 1 : 0;
                    } else if (state === 1) {
                      state = ch === I ? 2 : 0;
                    } else if (state === 2) {
                      break;
                    }
                  }
                }
                makeInlineImage(cipherTransform) {
                  const lexer = this.lexer;
                  const stream = lexer.stream;
                  const dictMap = /* @__PURE__ */ Object.create(null);
                  let dictLength;
                  while (!(0, _primitives.isCmd)(this.buf1, "ID") && this.buf1 !== _primitives.EOF) {
                    if (!(this.buf1 instanceof _primitives.Name)) {
                      throw new _util2.FormatError("Dictionary key must be a name object");
                    }
                    const key2 = this.buf1.name;
                    this.shift();
                    if (this.buf1 === _primitives.EOF) {
                      break;
                    }
                    dictMap[key2] = this.getObj(cipherTransform);
                  }
                  if (lexer.beginInlineImagePos !== -1) {
                    dictLength = stream.pos - lexer.beginInlineImagePos;
                  }
                  const filter3 = this.xref.fetchIfRef(dictMap.F || dictMap.Filter);
                  let filterName;
                  if (filter3 instanceof _primitives.Name) {
                    filterName = filter3.name;
                  } else if (Array.isArray(filter3)) {
                    const filterZero = this.xref.fetchIfRef(filter3[0]);
                    if (filterZero instanceof _primitives.Name) {
                      filterName = filterZero.name;
                    }
                  }
                  const startPos = stream.pos;
                  let length2;
                  switch (filterName) {
                    case "DCT":
                    case "DCTDecode":
                      length2 = this.findDCTDecodeInlineStreamEnd(stream);
                      break;
                    case "A85":
                    case "ASCII85Decode":
                      length2 = this.findASCII85DecodeInlineStreamEnd(stream);
                      break;
                    case "AHx":
                    case "ASCIIHexDecode":
                      length2 = this.findASCIIHexDecodeInlineStreamEnd(stream);
                      break;
                    default:
                      length2 = this.findDefaultInlineStreamEnd(stream);
                  }
                  let cacheKey;
                  if (length2 < MAX_LENGTH_TO_CACHE && dictLength > 0) {
                    const initialStreamPos = stream.pos;
                    stream.pos = lexer.beginInlineImagePos;
                    cacheKey = getInlineImageCacheKey(stream.getBytes(dictLength + length2));
                    stream.pos = initialStreamPos;
                    const cacheEntry = this.imageCache[cacheKey];
                    if (cacheEntry !== void 0) {
                      this.buf2 = _primitives.Cmd.get("EI");
                      this.shift();
                      cacheEntry.reset();
                      return cacheEntry;
                    }
                  }
                  const dict = new _primitives.Dict(this.xref);
                  for (const key2 in dictMap) {
                    dict.set(key2, dictMap[key2]);
                  }
                  let imageStream = stream.makeSubStream(startPos, length2, dict);
                  if (cipherTransform) {
                    imageStream = cipherTransform.createStream(imageStream, length2);
                  }
                  imageStream = this.filter(imageStream, dict, length2);
                  imageStream.dict = dict;
                  if (cacheKey !== void 0) {
                    imageStream.cacheKey = `inline_img_${++this._imageId}`;
                    this.imageCache[cacheKey] = imageStream;
                  }
                  this.buf2 = _primitives.Cmd.get("EI");
                  this.shift();
                  return imageStream;
                }
                _findStreamLength(startPos, signature) {
                  const {
                    stream
                  } = this.lexer;
                  stream.pos = startPos;
                  const SCAN_BLOCK_LENGTH = 2048;
                  const signatureLength = signature.length;
                  while (stream.pos < stream.end) {
                    const scanBytes = stream.peekBytes(SCAN_BLOCK_LENGTH);
                    const scanLength = scanBytes.length - signatureLength;
                    if (scanLength <= 0) {
                      break;
                    }
                    let pos = 0;
                    while (pos < scanLength) {
                      let j = 0;
                      while (j < signatureLength && scanBytes[pos + j] === signature[j]) {
                        j++;
                      }
                      if (j >= signatureLength) {
                        stream.pos += pos;
                        return stream.pos - startPos;
                      }
                      pos++;
                    }
                    stream.pos += scanLength;
                  }
                  return -1;
                }
                makeStream(dict, cipherTransform) {
                  const lexer = this.lexer;
                  let stream = lexer.stream;
                  lexer.skipToNextLine();
                  const startPos = stream.pos - 1;
                  let length2 = dict.get("Length");
                  if (!Number.isInteger(length2)) {
                    (0, _util2.info)(`Bad length "${length2 && length2.toString()}" in stream.`);
                    length2 = 0;
                  }
                  stream.pos = startPos + length2;
                  lexer.nextChar();
                  if (this.tryShift() && (0, _primitives.isCmd)(this.buf2, "endstream")) {
                    this.shift();
                  } else {
                    const ENDSTREAM_SIGNATURE = new Uint8Array([101, 110, 100, 115, 116, 114, 101, 97, 109]);
                    let actualLength = this._findStreamLength(startPos, ENDSTREAM_SIGNATURE);
                    if (actualLength < 0) {
                      const MAX_TRUNCATION = 1;
                      for (let i = 1; i <= MAX_TRUNCATION; i++) {
                        const end = ENDSTREAM_SIGNATURE.length - i;
                        const TRUNCATED_SIGNATURE = ENDSTREAM_SIGNATURE.slice(0, end);
                        const maybeLength = this._findStreamLength(startPos, TRUNCATED_SIGNATURE);
                        if (maybeLength >= 0) {
                          const lastByte = stream.peekBytes(end + 1)[end];
                          if (!(0, _core_utils.isWhiteSpace)(lastByte)) {
                            break;
                          }
                          (0, _util2.info)(`Found "${(0, _util2.bytesToString)(TRUNCATED_SIGNATURE)}" when searching for endstream command.`);
                          actualLength = maybeLength;
                          break;
                        }
                      }
                      if (actualLength < 0) {
                        throw new _util2.FormatError("Missing endstream command.");
                      }
                    }
                    length2 = actualLength;
                    lexer.nextChar();
                    this.shift();
                    this.shift();
                  }
                  this.shift();
                  stream = stream.makeSubStream(startPos, length2, dict);
                  if (cipherTransform) {
                    stream = cipherTransform.createStream(stream, length2);
                  }
                  stream = this.filter(stream, dict, length2);
                  stream.dict = dict;
                  return stream;
                }
                filter(stream, dict, length2) {
                  let filter3 = dict.get("F", "Filter");
                  let params = dict.get("DP", "DecodeParms");
                  if (filter3 instanceof _primitives.Name) {
                    if (Array.isArray(params)) {
                      (0, _util2.warn)("/DecodeParms should not be an Array, when /Filter is a Name.");
                    }
                    return this.makeFilter(stream, filter3.name, length2, params);
                  }
                  let maybeLength = length2;
                  if (Array.isArray(filter3)) {
                    const filterArray = filter3;
                    const paramsArray = params;
                    for (let i = 0, ii = filterArray.length; i < ii; ++i) {
                      filter3 = this.xref.fetchIfRef(filterArray[i]);
                      if (!(filter3 instanceof _primitives.Name)) {
                        throw new _util2.FormatError(`Bad filter name "${filter3}"`);
                      }
                      params = null;
                      if (Array.isArray(paramsArray) && i in paramsArray) {
                        params = this.xref.fetchIfRef(paramsArray[i]);
                      }
                      stream = this.makeFilter(stream, filter3.name, maybeLength, params);
                      maybeLength = null;
                    }
                  }
                  return stream;
                }
                makeFilter(stream, name, maybeLength, params) {
                  if (maybeLength === 0) {
                    (0, _util2.warn)(`Empty "${name}" stream.`);
                    return new _stream.NullStream();
                  }
                  try {
                    switch (name) {
                      case "Fl":
                      case "FlateDecode":
                        if (params) {
                          return new _predictor_stream.PredictorStream(new _flate_stream.FlateStream(stream, maybeLength), maybeLength, params);
                        }
                        return new _flate_stream.FlateStream(stream, maybeLength);
                      case "LZW":
                      case "LZWDecode":
                        let earlyChange = 1;
                        if (params) {
                          if (params.has("EarlyChange")) {
                            earlyChange = params.get("EarlyChange");
                          }
                          return new _predictor_stream.PredictorStream(new _lzw_stream.LZWStream(stream, maybeLength, earlyChange), maybeLength, params);
                        }
                        return new _lzw_stream.LZWStream(stream, maybeLength, earlyChange);
                      case "DCT":
                      case "DCTDecode":
                        return new _jpeg_stream.JpegStream(stream, maybeLength, params);
                      case "JPX":
                      case "JPXDecode":
                        return new _jpx_stream.JpxStream(stream, maybeLength, params);
                      case "A85":
                      case "ASCII85Decode":
                        return new _ascii_85_stream.Ascii85Stream(stream, maybeLength);
                      case "AHx":
                      case "ASCIIHexDecode":
                        return new _ascii_hex_stream.AsciiHexStream(stream, maybeLength);
                      case "CCF":
                      case "CCITTFaxDecode":
                        return new _ccitt_stream.CCITTFaxStream(stream, maybeLength, params);
                      case "RL":
                      case "RunLengthDecode":
                        return new _run_length_stream.RunLengthStream(stream, maybeLength);
                      case "JBIG2Decode":
                        return new _jbig2_stream.Jbig2Stream(stream, maybeLength, params);
                    }
                    (0, _util2.warn)(`Filter "${name}" is not supported.`);
                    return stream;
                  } catch (ex) {
                    if (ex instanceof _core_utils.MissingDataException) {
                      throw ex;
                    }
                    (0, _util2.warn)(`Invalid stream: "${ex}"`);
                    return new _stream.NullStream();
                  }
                }
              }
              exports3.Parser = Parser3;
              const specialChars = [1, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 2, 0, 0, 2, 2, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
              function toHexDigit(ch) {
                if (ch >= 48 && ch <= 57) {
                  return ch & 15;
                }
                if (ch >= 65 && ch <= 70 || ch >= 97 && ch <= 102) {
                  return (ch & 15) + 9;
                }
                return -1;
              }
              class Lexer {
                constructor(stream, knownCommands = null) {
                  this.stream = stream;
                  this.nextChar();
                  this.strBuf = [];
                  this.knownCommands = knownCommands;
                  this._hexStringNumWarn = 0;
                  this.beginInlineImagePos = -1;
                }
                nextChar() {
                  return this.currentChar = this.stream.getByte();
                }
                peekChar() {
                  return this.stream.peekByte();
                }
                getNumber() {
                  let ch = this.currentChar;
                  let eNotation = false;
                  let divideBy = 0;
                  let sign2 = 1;
                  if (ch === 45) {
                    sign2 = -1;
                    ch = this.nextChar();
                    if (ch === 45) {
                      ch = this.nextChar();
                    }
                  } else if (ch === 43) {
                    ch = this.nextChar();
                  }
                  if (ch === 10 || ch === 13) {
                    do {
                      ch = this.nextChar();
                    } while (ch === 10 || ch === 13);
                  }
                  if (ch === 46) {
                    divideBy = 10;
                    ch = this.nextChar();
                  }
                  if (ch < 48 || ch > 57) {
                    const msg = `Invalid number: ${String.fromCharCode(ch)} (charCode ${ch})`;
                    if ((0, _core_utils.isWhiteSpace)(ch) || ch === -1) {
                      (0, _util2.info)(`Lexer.getNumber - "${msg}".`);
                      return 0;
                    }
                    throw new _util2.FormatError(msg);
                  }
                  let baseValue = ch - 48;
                  let powerValue = 0;
                  let powerValueSign = 1;
                  while ((ch = this.nextChar()) >= 0) {
                    if (ch >= 48 && ch <= 57) {
                      const currentDigit = ch - 48;
                      if (eNotation) {
                        powerValue = powerValue * 10 + currentDigit;
                      } else {
                        if (divideBy !== 0) {
                          divideBy *= 10;
                        }
                        baseValue = baseValue * 10 + currentDigit;
                      }
                    } else if (ch === 46) {
                      if (divideBy === 0) {
                        divideBy = 1;
                      } else {
                        break;
                      }
                    } else if (ch === 45) {
                      (0, _util2.warn)("Badly formatted number: minus sign in the middle");
                    } else if (ch === 69 || ch === 101) {
                      ch = this.peekChar();
                      if (ch === 43 || ch === 45) {
                        powerValueSign = ch === 45 ? -1 : 1;
                        this.nextChar();
                      } else if (ch < 48 || ch > 57) {
                        break;
                      }
                      eNotation = true;
                    } else {
                      break;
                    }
                  }
                  if (divideBy !== 0) {
                    baseValue /= divideBy;
                  }
                  if (eNotation) {
                    baseValue *= 10 ** (powerValueSign * powerValue);
                  }
                  return sign2 * baseValue;
                }
                getString() {
                  let numParen = 1;
                  let done = false;
                  const strBuf = this.strBuf;
                  strBuf.length = 0;
                  let ch = this.nextChar();
                  while (true) {
                    let charBuffered = false;
                    switch (ch | 0) {
                      case -1:
                        (0, _util2.warn)("Unterminated string");
                        done = true;
                        break;
                      case 40:
                        ++numParen;
                        strBuf.push("(");
                        break;
                      case 41:
                        if (--numParen === 0) {
                          this.nextChar();
                          done = true;
                        } else {
                          strBuf.push(")");
                        }
                        break;
                      case 92:
                        ch = this.nextChar();
                        switch (ch) {
                          case -1:
                            (0, _util2.warn)("Unterminated string");
                            done = true;
                            break;
                          case 110:
                            strBuf.push("\n");
                            break;
                          case 114:
                            strBuf.push("\r");
                            break;
                          case 116:
                            strBuf.push("	");
                            break;
                          case 98:
                            strBuf.push("\b");
                            break;
                          case 102:
                            strBuf.push("\f");
                            break;
                          case 92:
                          case 40:
                          case 41:
                            strBuf.push(String.fromCharCode(ch));
                            break;
                          case 48:
                          case 49:
                          case 50:
                          case 51:
                          case 52:
                          case 53:
                          case 54:
                          case 55:
                            let x = ch & 15;
                            ch = this.nextChar();
                            charBuffered = true;
                            if (ch >= 48 && ch <= 55) {
                              x = (x << 3) + (ch & 15);
                              ch = this.nextChar();
                              if (ch >= 48 && ch <= 55) {
                                charBuffered = false;
                                x = (x << 3) + (ch & 15);
                              }
                            }
                            strBuf.push(String.fromCharCode(x));
                            break;
                          case 13:
                            if (this.peekChar() === 10) {
                              this.nextChar();
                            }
                            break;
                          case 10:
                            break;
                          default:
                            strBuf.push(String.fromCharCode(ch));
                            break;
                        }
                        break;
                      default:
                        strBuf.push(String.fromCharCode(ch));
                        break;
                    }
                    if (done) {
                      break;
                    }
                    if (!charBuffered) {
                      ch = this.nextChar();
                    }
                  }
                  return strBuf.join("");
                }
                getName() {
                  let ch, previousCh;
                  const strBuf = this.strBuf;
                  strBuf.length = 0;
                  while ((ch = this.nextChar()) >= 0 && !specialChars[ch]) {
                    if (ch === 35) {
                      ch = this.nextChar();
                      if (specialChars[ch]) {
                        (0, _util2.warn)("Lexer_getName: NUMBER SIGN (#) should be followed by a hexadecimal number.");
                        strBuf.push("#");
                        break;
                      }
                      const x = toHexDigit(ch);
                      if (x !== -1) {
                        previousCh = ch;
                        ch = this.nextChar();
                        const x2 = toHexDigit(ch);
                        if (x2 === -1) {
                          (0, _util2.warn)(`Lexer_getName: Illegal digit (${String.fromCharCode(ch)}) in hexadecimal number.`);
                          strBuf.push("#", String.fromCharCode(previousCh));
                          if (specialChars[ch]) {
                            break;
                          }
                          strBuf.push(String.fromCharCode(ch));
                          continue;
                        }
                        strBuf.push(String.fromCharCode(x << 4 | x2));
                      } else {
                        strBuf.push("#", String.fromCharCode(ch));
                      }
                    } else {
                      strBuf.push(String.fromCharCode(ch));
                    }
                  }
                  if (strBuf.length > 127) {
                    (0, _util2.warn)(`Name token is longer than allowed by the spec: ${strBuf.length}`);
                  }
                  return _primitives.Name.get(strBuf.join(""));
                }
                _hexStringWarn(ch) {
                  const MAX_HEX_STRING_NUM_WARN = 5;
                  if (this._hexStringNumWarn++ === MAX_HEX_STRING_NUM_WARN) {
                    (0, _util2.warn)("getHexString - ignoring additional invalid characters.");
                    return;
                  }
                  if (this._hexStringNumWarn > MAX_HEX_STRING_NUM_WARN) {
                    return;
                  }
                  (0, _util2.warn)(`getHexString - ignoring invalid character: ${ch}`);
                }
                getHexString() {
                  const strBuf = this.strBuf;
                  strBuf.length = 0;
                  let ch = this.currentChar;
                  let isFirstHex = true;
                  let firstDigit, secondDigit;
                  this._hexStringNumWarn = 0;
                  while (true) {
                    if (ch < 0) {
                      (0, _util2.warn)("Unterminated hex string");
                      break;
                    } else if (ch === 62) {
                      this.nextChar();
                      break;
                    } else if (specialChars[ch] === 1) {
                      ch = this.nextChar();
                      continue;
                    } else {
                      if (isFirstHex) {
                        firstDigit = toHexDigit(ch);
                        if (firstDigit === -1) {
                          this._hexStringWarn(ch);
                          ch = this.nextChar();
                          continue;
                        }
                      } else {
                        secondDigit = toHexDigit(ch);
                        if (secondDigit === -1) {
                          this._hexStringWarn(ch);
                          ch = this.nextChar();
                          continue;
                        }
                        strBuf.push(String.fromCharCode(firstDigit << 4 | secondDigit));
                      }
                      isFirstHex = !isFirstHex;
                      ch = this.nextChar();
                    }
                  }
                  return strBuf.join("");
                }
                getObj() {
                  let comment2 = false;
                  let ch = this.currentChar;
                  while (true) {
                    if (ch < 0) {
                      return _primitives.EOF;
                    }
                    if (comment2) {
                      if (ch === 10 || ch === 13) {
                        comment2 = false;
                      }
                    } else if (ch === 37) {
                      comment2 = true;
                    } else if (specialChars[ch] !== 1) {
                      break;
                    }
                    ch = this.nextChar();
                  }
                  switch (ch | 0) {
                    case 48:
                    case 49:
                    case 50:
                    case 51:
                    case 52:
                    case 53:
                    case 54:
                    case 55:
                    case 56:
                    case 57:
                    case 43:
                    case 45:
                    case 46:
                      return this.getNumber();
                    case 40:
                      return this.getString();
                    case 47:
                      return this.getName();
                    case 91:
                      this.nextChar();
                      return _primitives.Cmd.get("[");
                    case 93:
                      this.nextChar();
                      return _primitives.Cmd.get("]");
                    case 60:
                      ch = this.nextChar();
                      if (ch === 60) {
                        this.nextChar();
                        return _primitives.Cmd.get("<<");
                      }
                      return this.getHexString();
                    case 62:
                      ch = this.nextChar();
                      if (ch === 62) {
                        this.nextChar();
                        return _primitives.Cmd.get(">>");
                      }
                      return _primitives.Cmd.get(">");
                    case 123:
                      this.nextChar();
                      return _primitives.Cmd.get("{");
                    case 125:
                      this.nextChar();
                      return _primitives.Cmd.get("}");
                    case 41:
                      this.nextChar();
                      throw new _util2.FormatError(`Illegal character: ${ch}`);
                  }
                  let str = String.fromCharCode(ch);
                  if (ch < 32 || ch > 127) {
                    const nextCh = this.peekChar();
                    if (nextCh >= 32 && nextCh <= 127) {
                      this.nextChar();
                      return _primitives.Cmd.get(str);
                    }
                  }
                  const knownCommands = this.knownCommands;
                  let knownCommandFound = knownCommands?.[str] !== void 0;
                  while ((ch = this.nextChar()) >= 0 && !specialChars[ch]) {
                    const possibleCommand = str + String.fromCharCode(ch);
                    if (knownCommandFound && knownCommands[possibleCommand] === void 0) {
                      break;
                    }
                    if (str.length === 128) {
                      throw new _util2.FormatError(`Command token too long: ${str.length}`);
                    }
                    str = possibleCommand;
                    knownCommandFound = knownCommands?.[str] !== void 0;
                  }
                  if (str === "true") {
                    return true;
                  }
                  if (str === "false") {
                    return false;
                  }
                  if (str === "null") {
                    return null;
                  }
                  if (str === "BI") {
                    this.beginInlineImagePos = this.stream.pos;
                  }
                  return _primitives.Cmd.get(str);
                }
                skipToNextLine() {
                  let ch = this.currentChar;
                  while (ch >= 0) {
                    if (ch === 13) {
                      ch = this.nextChar();
                      if (ch === 10) {
                        this.nextChar();
                      }
                      break;
                    } else if (ch === 10) {
                      this.nextChar();
                      break;
                    }
                    ch = this.nextChar();
                  }
                }
              }
              exports3.Lexer = Lexer;
              class Linearization {
                static create(stream) {
                  function getInt(linDict2, name, allowZeroValue = false) {
                    const obj4 = linDict2.get(name);
                    if (Number.isInteger(obj4) && (allowZeroValue ? obj4 >= 0 : obj4 > 0)) {
                      return obj4;
                    }
                    throw new Error(`The "${name}" parameter in the linearization dictionary is invalid.`);
                  }
                  function getHints(linDict2) {
                    const hints = linDict2.get("H");
                    let hintsLength;
                    if (Array.isArray(hints) && ((hintsLength = hints.length) === 2 || hintsLength === 4)) {
                      for (let index3 = 0; index3 < hintsLength; index3++) {
                        const hint = hints[index3];
                        if (!(Number.isInteger(hint) && hint > 0)) {
                          throw new Error(`Hint (${index3}) in the linearization dictionary is invalid.`);
                        }
                      }
                      return hints;
                    }
                    throw new Error("Hint array in the linearization dictionary is invalid.");
                  }
                  const parser = new Parser3({
                    lexer: new Lexer(stream),
                    xref: null
                  });
                  const obj1 = parser.getObj();
                  const obj2 = parser.getObj();
                  const obj3 = parser.getObj();
                  const linDict = parser.getObj();
                  let obj, length2;
                  if (!(Number.isInteger(obj1) && Number.isInteger(obj2) && (0, _primitives.isCmd)(obj3, "obj") && linDict instanceof _primitives.Dict && typeof (obj = linDict.get("Linearized")) === "number" && obj > 0)) {
                    return null;
                  } else if ((length2 = getInt(linDict, "L")) !== stream.length) {
                    throw new Error('The "L" parameter in the linearization dictionary does not equal the stream length.');
                  }
                  return {
                    length: length2,
                    hints: getHints(linDict),
                    objectNumberFirst: getInt(linDict, "O"),
                    endFirst: getInt(linDict, "E"),
                    numPages: getInt(linDict, "N"),
                    mainXRefEntriesOffset: getInt(linDict, "T"),
                    pageFirst: linDict.has("P") ? getInt(linDict, "P", true) : 0
                  };
                }
              }
              exports3.Linearization = Linearization;
            }),
            /* 17 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.Ascii85Stream = void 0;
              var _decode_stream = __w_pdfjs_require__3(18);
              var _core_utils = __w_pdfjs_require__3(3);
              class Ascii85Stream extends _decode_stream.DecodeStream {
                constructor(str, maybeLength) {
                  if (maybeLength) {
                    maybeLength *= 0.8;
                  }
                  super(maybeLength);
                  this.str = str;
                  this.dict = str.dict;
                  this.input = new Uint8Array(5);
                }
                readBlock() {
                  const TILDA_CHAR = 126;
                  const Z_LOWER_CHAR = 122;
                  const EOF = -1;
                  const str = this.str;
                  let c = str.getByte();
                  while ((0, _core_utils.isWhiteSpace)(c)) {
                    c = str.getByte();
                  }
                  if (c === EOF || c === TILDA_CHAR) {
                    this.eof = true;
                    return;
                  }
                  const bufferLength = this.bufferLength;
                  let buffer, i;
                  if (c === Z_LOWER_CHAR) {
                    buffer = this.ensureBuffer(bufferLength + 4);
                    for (i = 0; i < 4; ++i) {
                      buffer[bufferLength + i] = 0;
                    }
                    this.bufferLength += 4;
                  } else {
                    const input = this.input;
                    input[0] = c;
                    for (i = 1; i < 5; ++i) {
                      c = str.getByte();
                      while ((0, _core_utils.isWhiteSpace)(c)) {
                        c = str.getByte();
                      }
                      input[i] = c;
                      if (c === EOF || c === TILDA_CHAR) {
                        break;
                      }
                    }
                    buffer = this.ensureBuffer(bufferLength + i - 1);
                    this.bufferLength += i - 1;
                    if (i < 5) {
                      for (; i < 5; ++i) {
                        input[i] = 33 + 84;
                      }
                      this.eof = true;
                    }
                    let t2 = 0;
                    for (i = 0; i < 5; ++i) {
                      t2 = t2 * 85 + (input[i] - 33);
                    }
                    for (i = 3; i >= 0; --i) {
                      buffer[bufferLength + i] = t2 & 255;
                      t2 >>= 8;
                    }
                  }
                }
              }
              exports3.Ascii85Stream = Ascii85Stream;
            }),
            /* 18 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.StreamsSequenceStream = exports3.DecodeStream = void 0;
              var _base_stream = __w_pdfjs_require__3(5);
              var _stream = __w_pdfjs_require__3(8);
              const emptyBuffer = new Uint8Array(0);
              class DecodeStream2 extends _base_stream.BaseStream {
                constructor(maybeMinBufferLength) {
                  super();
                  this._rawMinBufferLength = maybeMinBufferLength || 0;
                  this.pos = 0;
                  this.bufferLength = 0;
                  this.eof = false;
                  this.buffer = emptyBuffer;
                  this.minBufferLength = 512;
                  if (maybeMinBufferLength) {
                    while (this.minBufferLength < maybeMinBufferLength) {
                      this.minBufferLength *= 2;
                    }
                  }
                }
                get isEmpty() {
                  while (!this.eof && this.bufferLength === 0) {
                    this.readBlock();
                  }
                  return this.bufferLength === 0;
                }
                ensureBuffer(requested) {
                  const buffer = this.buffer;
                  if (requested <= buffer.byteLength) {
                    return buffer;
                  }
                  let size = this.minBufferLength;
                  while (size < requested) {
                    size *= 2;
                  }
                  const buffer2 = new Uint8Array(size);
                  buffer2.set(buffer);
                  return this.buffer = buffer2;
                }
                getByte() {
                  const pos = this.pos;
                  while (this.bufferLength <= pos) {
                    if (this.eof) {
                      return -1;
                    }
                    this.readBlock();
                  }
                  return this.buffer[this.pos++];
                }
                getBytes(length2) {
                  const pos = this.pos;
                  let end;
                  if (length2) {
                    this.ensureBuffer(pos + length2);
                    end = pos + length2;
                    while (!this.eof && this.bufferLength < end) {
                      this.readBlock();
                    }
                    const bufEnd = this.bufferLength;
                    if (end > bufEnd) {
                      end = bufEnd;
                    }
                  } else {
                    while (!this.eof) {
                      this.readBlock();
                    }
                    end = this.bufferLength;
                  }
                  this.pos = end;
                  return this.buffer.subarray(pos, end);
                }
                reset() {
                  this.pos = 0;
                }
                makeSubStream(start, length2, dict = null) {
                  if (length2 === void 0) {
                    while (!this.eof) {
                      this.readBlock();
                    }
                  } else {
                    const end = start + length2;
                    while (this.bufferLength <= end && !this.eof) {
                      this.readBlock();
                    }
                  }
                  return new _stream.Stream(this.buffer, start, length2, dict);
                }
                getBaseStreams() {
                  return this.str ? this.str.getBaseStreams() : null;
                }
              }
              exports3.DecodeStream = DecodeStream2;
              class StreamsSequenceStream extends DecodeStream2 {
                constructor(streams, onError = null) {
                  let maybeLength = 0;
                  for (const stream of streams) {
                    maybeLength += stream instanceof DecodeStream2 ? stream._rawMinBufferLength : stream.length;
                  }
                  super(maybeLength);
                  this.streams = streams;
                  this._onError = onError;
                }
                readBlock() {
                  const streams = this.streams;
                  if (streams.length === 0) {
                    this.eof = true;
                    return;
                  }
                  const stream = streams.shift();
                  let chunk;
                  try {
                    chunk = stream.getBytes();
                  } catch (reason) {
                    if (this._onError) {
                      this._onError(reason, stream.dict?.objId);
                      return;
                    }
                    throw reason;
                  }
                  const bufferLength = this.bufferLength;
                  const newLength = bufferLength + chunk.length;
                  const buffer = this.ensureBuffer(newLength);
                  buffer.set(chunk, bufferLength);
                  this.bufferLength = newLength;
                }
                getBaseStreams() {
                  const baseStreamsBuf = [];
                  for (const stream of this.streams) {
                    const baseStreams = stream.getBaseStreams();
                    if (baseStreams) {
                      baseStreamsBuf.push(...baseStreams);
                    }
                  }
                  return baseStreamsBuf.length > 0 ? baseStreamsBuf : null;
                }
              }
              exports3.StreamsSequenceStream = StreamsSequenceStream;
            }),
            /* 19 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.AsciiHexStream = void 0;
              var _decode_stream = __w_pdfjs_require__3(18);
              class AsciiHexStream extends _decode_stream.DecodeStream {
                constructor(str, maybeLength) {
                  if (maybeLength) {
                    maybeLength *= 0.5;
                  }
                  super(maybeLength);
                  this.str = str;
                  this.dict = str.dict;
                  this.firstDigit = -1;
                }
                readBlock() {
                  const UPSTREAM_BLOCK_SIZE = 8e3;
                  const bytes = this.str.getBytes(UPSTREAM_BLOCK_SIZE);
                  if (!bytes.length) {
                    this.eof = true;
                    return;
                  }
                  const maxDecodeLength = bytes.length + 1 >> 1;
                  const buffer = this.ensureBuffer(this.bufferLength + maxDecodeLength);
                  let bufferLength = this.bufferLength;
                  let firstDigit = this.firstDigit;
                  for (const ch of bytes) {
                    let digit;
                    if (ch >= 48 && ch <= 57) {
                      digit = ch & 15;
                    } else if (ch >= 65 && ch <= 70 || ch >= 97 && ch <= 102) {
                      digit = (ch & 15) + 9;
                    } else if (ch === 62) {
                      this.eof = true;
                      break;
                    } else {
                      continue;
                    }
                    if (firstDigit < 0) {
                      firstDigit = digit;
                    } else {
                      buffer[bufferLength++] = firstDigit << 4 | digit;
                      firstDigit = -1;
                    }
                  }
                  if (firstDigit >= 0 && this.eof) {
                    buffer[bufferLength++] = firstDigit << 4;
                    firstDigit = -1;
                  }
                  this.firstDigit = firstDigit;
                  this.bufferLength = bufferLength;
                }
              }
              exports3.AsciiHexStream = AsciiHexStream;
            }),
            /* 20 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.CCITTFaxStream = void 0;
              var _ccitt = __w_pdfjs_require__3(21);
              var _decode_stream = __w_pdfjs_require__3(18);
              var _primitives = __w_pdfjs_require__3(4);
              class CCITTFaxStream extends _decode_stream.DecodeStream {
                constructor(str, maybeLength, params) {
                  super(maybeLength);
                  this.str = str;
                  this.dict = str.dict;
                  if (!(params instanceof _primitives.Dict)) {
                    params = _primitives.Dict.empty;
                  }
                  const source = {
                    next() {
                      return str.getByte();
                    }
                  };
                  this.ccittFaxDecoder = new _ccitt.CCITTFaxDecoder(source, {
                    K: params.get("K"),
                    EndOfLine: params.get("EndOfLine"),
                    EncodedByteAlign: params.get("EncodedByteAlign"),
                    Columns: params.get("Columns"),
                    Rows: params.get("Rows"),
                    EndOfBlock: params.get("EndOfBlock"),
                    BlackIs1: params.get("BlackIs1")
                  });
                }
                readBlock() {
                  while (!this.eof) {
                    const c = this.ccittFaxDecoder.readNextChar();
                    if (c === -1) {
                      this.eof = true;
                      return;
                    }
                    this.ensureBuffer(this.bufferLength + 1);
                    this.buffer[this.bufferLength++] = c;
                  }
                }
              }
              exports3.CCITTFaxStream = CCITTFaxStream;
            }),
            /* 21 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.CCITTFaxDecoder = void 0;
              var _util2 = __w_pdfjs_require__3(2);
              const ccittEOL = -2;
              const ccittEOF = -1;
              const twoDimPass = 0;
              const twoDimHoriz = 1;
              const twoDimVert0 = 2;
              const twoDimVertR1 = 3;
              const twoDimVertL1 = 4;
              const twoDimVertR2 = 5;
              const twoDimVertL2 = 6;
              const twoDimVertR3 = 7;
              const twoDimVertL3 = 8;
              const twoDimTable = [[-1, -1], [-1, -1], [7, twoDimVertL3], [7, twoDimVertR3], [6, twoDimVertL2], [6, twoDimVertL2], [6, twoDimVertR2], [6, twoDimVertR2], [4, twoDimPass], [4, twoDimPass], [4, twoDimPass], [4, twoDimPass], [4, twoDimPass], [4, twoDimPass], [4, twoDimPass], [4, twoDimPass], [3, twoDimHoriz], [3, twoDimHoriz], [3, twoDimHoriz], [3, twoDimHoriz], [3, twoDimHoriz], [3, twoDimHoriz], [3, twoDimHoriz], [3, twoDimHoriz], [3, twoDimHoriz], [3, twoDimHoriz], [3, twoDimHoriz], [3, twoDimHoriz], [3, twoDimHoriz], [3, twoDimHoriz], [3, twoDimHoriz], [3, twoDimHoriz], [3, twoDimVertL1], [3, twoDimVertL1], [3, twoDimVertL1], [3, twoDimVertL1], [3, twoDimVertL1], [3, twoDimVertL1], [3, twoDimVertL1], [3, twoDimVertL1], [3, twoDimVertL1], [3, twoDimVertL1], [3, twoDimVertL1], [3, twoDimVertL1], [3, twoDimVertL1], [3, twoDimVertL1], [3, twoDimVertL1], [3, twoDimVertL1], [3, twoDimVertR1], [3, twoDimVertR1], [3, twoDimVertR1], [3, twoDimVertR1], [3, twoDimVertR1], [3, twoDimVertR1], [3, twoDimVertR1], [3, twoDimVertR1], [3, twoDimVertR1], [3, twoDimVertR1], [3, twoDimVertR1], [3, twoDimVertR1], [3, twoDimVertR1], [3, twoDimVertR1], [3, twoDimVertR1], [3, twoDimVertR1], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0]];
              const whiteTable1 = [[-1, -1], [12, ccittEOL], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [11, 1792], [11, 1792], [12, 1984], [12, 2048], [12, 2112], [12, 2176], [12, 2240], [12, 2304], [11, 1856], [11, 1856], [11, 1920], [11, 1920], [12, 2368], [12, 2432], [12, 2496], [12, 2560]];
              const whiteTable2 = [[-1, -1], [-1, -1], [-1, -1], [-1, -1], [8, 29], [8, 29], [8, 30], [8, 30], [8, 45], [8, 45], [8, 46], [8, 46], [7, 22], [7, 22], [7, 22], [7, 22], [7, 23], [7, 23], [7, 23], [7, 23], [8, 47], [8, 47], [8, 48], [8, 48], [6, 13], [6, 13], [6, 13], [6, 13], [6, 13], [6, 13], [6, 13], [6, 13], [7, 20], [7, 20], [7, 20], [7, 20], [8, 33], [8, 33], [8, 34], [8, 34], [8, 35], [8, 35], [8, 36], [8, 36], [8, 37], [8, 37], [8, 38], [8, 38], [7, 19], [7, 19], [7, 19], [7, 19], [8, 31], [8, 31], [8, 32], [8, 32], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 12], [6, 12], [6, 12], [6, 12], [6, 12], [6, 12], [6, 12], [6, 12], [8, 53], [8, 53], [8, 54], [8, 54], [7, 26], [7, 26], [7, 26], [7, 26], [8, 39], [8, 39], [8, 40], [8, 40], [8, 41], [8, 41], [8, 42], [8, 42], [8, 43], [8, 43], [8, 44], [8, 44], [7, 21], [7, 21], [7, 21], [7, 21], [7, 28], [7, 28], [7, 28], [7, 28], [8, 61], [8, 61], [8, 62], [8, 62], [8, 63], [8, 63], [8, 0], [8, 0], [8, 320], [8, 320], [8, 384], [8, 384], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [7, 27], [7, 27], [7, 27], [7, 27], [8, 59], [8, 59], [8, 60], [8, 60], [9, 1472], [9, 1536], [9, 1600], [9, 1728], [7, 18], [7, 18], [7, 18], [7, 18], [7, 24], [7, 24], [7, 24], [7, 24], [8, 49], [8, 49], [8, 50], [8, 50], [8, 51], [8, 51], [8, 52], [8, 52], [7, 25], [7, 25], [7, 25], [7, 25], [8, 55], [8, 55], [8, 56], [8, 56], [8, 57], [8, 57], [8, 58], [8, 58], [6, 192], [6, 192], [6, 192], [6, 192], [6, 192], [6, 192], [6, 192], [6, 192], [6, 1664], [6, 1664], [6, 1664], [6, 1664], [6, 1664], [6, 1664], [6, 1664], [6, 1664], [8, 448], [8, 448], [8, 512], [8, 512], [9, 704], [9, 768], [8, 640], [8, 640], [8, 576], [8, 576], [9, 832], [9, 896], [9, 960], [9, 1024], [9, 1088], [9, 1152], [9, 1216], [9, 1280], [9, 1344], [9, 1408], [7, 256], [7, 256], [7, 256], [7, 256], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [6, 16], [6, 16], [6, 16], [6, 16], [6, 16], [6, 16], [6, 16], [6, 16], [6, 17], [6, 17], [6, 17], [6, 17], [6, 17], [6, 17], [6, 17], [6, 17], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [6, 14], [6, 14], [6, 14], [6, 14], [6, 14], [6, 14], [6, 14], [6, 14], [6, 15], [6, 15], [6, 15], [6, 15], [6, 15], [6, 15], [6, 15], [6, 15], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7]];
              const blackTable1 = [[-1, -1], [-1, -1], [12, ccittEOL], [12, ccittEOL], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [11, 1792], [11, 1792], [11, 1792], [11, 1792], [12, 1984], [12, 1984], [12, 2048], [12, 2048], [12, 2112], [12, 2112], [12, 2176], [12, 2176], [12, 2240], [12, 2240], [12, 2304], [12, 2304], [11, 1856], [11, 1856], [11, 1856], [11, 1856], [11, 1920], [11, 1920], [11, 1920], [11, 1920], [12, 2368], [12, 2368], [12, 2432], [12, 2432], [12, 2496], [12, 2496], [12, 2560], [12, 2560], [10, 18], [10, 18], [10, 18], [10, 18], [10, 18], [10, 18], [10, 18], [10, 18], [12, 52], [12, 52], [13, 640], [13, 704], [13, 768], [13, 832], [12, 55], [12, 55], [12, 56], [12, 56], [13, 1280], [13, 1344], [13, 1408], [13, 1472], [12, 59], [12, 59], [12, 60], [12, 60], [13, 1536], [13, 1600], [11, 24], [11, 24], [11, 24], [11, 24], [11, 25], [11, 25], [11, 25], [11, 25], [13, 1664], [13, 1728], [12, 320], [12, 320], [12, 384], [12, 384], [12, 448], [12, 448], [13, 512], [13, 576], [12, 53], [12, 53], [12, 54], [12, 54], [13, 896], [13, 960], [13, 1024], [13, 1088], [13, 1152], [13, 1216], [10, 64], [10, 64], [10, 64], [10, 64], [10, 64], [10, 64], [10, 64], [10, 64]];
              const blackTable2 = [[8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [11, 23], [11, 23], [12, 50], [12, 51], [12, 44], [12, 45], [12, 46], [12, 47], [12, 57], [12, 58], [12, 61], [12, 256], [10, 16], [10, 16], [10, 16], [10, 16], [10, 17], [10, 17], [10, 17], [10, 17], [12, 48], [12, 49], [12, 62], [12, 63], [12, 30], [12, 31], [12, 32], [12, 33], [12, 40], [12, 41], [11, 22], [11, 22], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [9, 15], [9, 15], [9, 15], [9, 15], [9, 15], [9, 15], [9, 15], [9, 15], [12, 128], [12, 192], [12, 26], [12, 27], [12, 28], [12, 29], [11, 19], [11, 19], [11, 20], [11, 20], [12, 34], [12, 35], [12, 36], [12, 37], [12, 38], [12, 39], [11, 21], [11, 21], [12, 42], [12, 43], [10, 0], [10, 0], [10, 0], [10, 0], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12]];
              const blackTable3 = [[-1, -1], [-1, -1], [-1, -1], [-1, -1], [6, 9], [6, 8], [5, 7], [5, 7], [4, 6], [4, 6], [4, 6], [4, 6], [4, 5], [4, 5], [4, 5], [4, 5], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2]];
              class CCITTFaxDecoder {
                constructor(source, options = {}) {
                  if (!source || typeof source.next !== "function") {
                    throw new Error('CCITTFaxDecoder - invalid "source" parameter.');
                  }
                  this.source = source;
                  this.eof = false;
                  this.encoding = options.K || 0;
                  this.eoline = options.EndOfLine || false;
                  this.byteAlign = options.EncodedByteAlign || false;
                  this.columns = options.Columns || 1728;
                  this.rows = options.Rows || 0;
                  this.eoblock = options.EndOfBlock ?? true;
                  this.black = options.BlackIs1 || false;
                  this.codingLine = new Uint32Array(this.columns + 1);
                  this.refLine = new Uint32Array(this.columns + 2);
                  this.codingLine[0] = this.columns;
                  this.codingPos = 0;
                  this.row = 0;
                  this.nextLine2D = this.encoding < 0;
                  this.inputBits = 0;
                  this.inputBuf = 0;
                  this.outputBits = 0;
                  this.rowsDone = false;
                  let code1;
                  while ((code1 = this._lookBits(12)) === 0) {
                    this._eatBits(1);
                  }
                  if (code1 === 1) {
                    this._eatBits(12);
                  }
                  if (this.encoding > 0) {
                    this.nextLine2D = !this._lookBits(1);
                    this._eatBits(1);
                  }
                }
                readNextChar() {
                  if (this.eof) {
                    return -1;
                  }
                  const refLine = this.refLine;
                  const codingLine = this.codingLine;
                  const columns = this.columns;
                  let refPos, blackPixels, bits, i;
                  if (this.outputBits === 0) {
                    if (this.rowsDone) {
                      this.eof = true;
                    }
                    if (this.eof) {
                      return -1;
                    }
                    this.err = false;
                    let code1, code2, code3;
                    if (this.nextLine2D) {
                      for (i = 0; codingLine[i] < columns; ++i) {
                        refLine[i] = codingLine[i];
                      }
                      refLine[i++] = columns;
                      refLine[i] = columns;
                      codingLine[0] = 0;
                      this.codingPos = 0;
                      refPos = 0;
                      blackPixels = 0;
                      while (codingLine[this.codingPos] < columns) {
                        code1 = this._getTwoDimCode();
                        switch (code1) {
                          case twoDimPass:
                            this._addPixels(refLine[refPos + 1], blackPixels);
                            if (refLine[refPos + 1] < columns) {
                              refPos += 2;
                            }
                            break;
                          case twoDimHoriz:
                            code1 = code2 = 0;
                            if (blackPixels) {
                              do {
                                code1 += code3 = this._getBlackCode();
                              } while (code3 >= 64);
                              do {
                                code2 += code3 = this._getWhiteCode();
                              } while (code3 >= 64);
                            } else {
                              do {
                                code1 += code3 = this._getWhiteCode();
                              } while (code3 >= 64);
                              do {
                                code2 += code3 = this._getBlackCode();
                              } while (code3 >= 64);
                            }
                            this._addPixels(codingLine[this.codingPos] + code1, blackPixels);
                            if (codingLine[this.codingPos] < columns) {
                              this._addPixels(codingLine[this.codingPos] + code2, blackPixels ^ 1);
                            }
                            while (refLine[refPos] <= codingLine[this.codingPos] && refLine[refPos] < columns) {
                              refPos += 2;
                            }
                            break;
                          case twoDimVertR3:
                            this._addPixels(refLine[refPos] + 3, blackPixels);
                            blackPixels ^= 1;
                            if (codingLine[this.codingPos] < columns) {
                              ++refPos;
                              while (refLine[refPos] <= codingLine[this.codingPos] && refLine[refPos] < columns) {
                                refPos += 2;
                              }
                            }
                            break;
                          case twoDimVertR2:
                            this._addPixels(refLine[refPos] + 2, blackPixels);
                            blackPixels ^= 1;
                            if (codingLine[this.codingPos] < columns) {
                              ++refPos;
                              while (refLine[refPos] <= codingLine[this.codingPos] && refLine[refPos] < columns) {
                                refPos += 2;
                              }
                            }
                            break;
                          case twoDimVertR1:
                            this._addPixels(refLine[refPos] + 1, blackPixels);
                            blackPixels ^= 1;
                            if (codingLine[this.codingPos] < columns) {
                              ++refPos;
                              while (refLine[refPos] <= codingLine[this.codingPos] && refLine[refPos] < columns) {
                                refPos += 2;
                              }
                            }
                            break;
                          case twoDimVert0:
                            this._addPixels(refLine[refPos], blackPixels);
                            blackPixels ^= 1;
                            if (codingLine[this.codingPos] < columns) {
                              ++refPos;
                              while (refLine[refPos] <= codingLine[this.codingPos] && refLine[refPos] < columns) {
                                refPos += 2;
                              }
                            }
                            break;
                          case twoDimVertL3:
                            this._addPixelsNeg(refLine[refPos] - 3, blackPixels);
                            blackPixels ^= 1;
                            if (codingLine[this.codingPos] < columns) {
                              if (refPos > 0) {
                                --refPos;
                              } else {
                                ++refPos;
                              }
                              while (refLine[refPos] <= codingLine[this.codingPos] && refLine[refPos] < columns) {
                                refPos += 2;
                              }
                            }
                            break;
                          case twoDimVertL2:
                            this._addPixelsNeg(refLine[refPos] - 2, blackPixels);
                            blackPixels ^= 1;
                            if (codingLine[this.codingPos] < columns) {
                              if (refPos > 0) {
                                --refPos;
                              } else {
                                ++refPos;
                              }
                              while (refLine[refPos] <= codingLine[this.codingPos] && refLine[refPos] < columns) {
                                refPos += 2;
                              }
                            }
                            break;
                          case twoDimVertL1:
                            this._addPixelsNeg(refLine[refPos] - 1, blackPixels);
                            blackPixels ^= 1;
                            if (codingLine[this.codingPos] < columns) {
                              if (refPos > 0) {
                                --refPos;
                              } else {
                                ++refPos;
                              }
                              while (refLine[refPos] <= codingLine[this.codingPos] && refLine[refPos] < columns) {
                                refPos += 2;
                              }
                            }
                            break;
                          case ccittEOF:
                            this._addPixels(columns, 0);
                            this.eof = true;
                            break;
                          default:
                            (0, _util2.info)("bad 2d code");
                            this._addPixels(columns, 0);
                            this.err = true;
                        }
                      }
                    } else {
                      codingLine[0] = 0;
                      this.codingPos = 0;
                      blackPixels = 0;
                      while (codingLine[this.codingPos] < columns) {
                        code1 = 0;
                        if (blackPixels) {
                          do {
                            code1 += code3 = this._getBlackCode();
                          } while (code3 >= 64);
                        } else {
                          do {
                            code1 += code3 = this._getWhiteCode();
                          } while (code3 >= 64);
                        }
                        this._addPixels(codingLine[this.codingPos] + code1, blackPixels);
                        blackPixels ^= 1;
                      }
                    }
                    let gotEOL = false;
                    if (this.byteAlign) {
                      this.inputBits &= ~7;
                    }
                    if (!this.eoblock && this.row === this.rows - 1) {
                      this.rowsDone = true;
                    } else {
                      code1 = this._lookBits(12);
                      if (this.eoline) {
                        while (code1 !== ccittEOF && code1 !== 1) {
                          this._eatBits(1);
                          code1 = this._lookBits(12);
                        }
                      } else {
                        while (code1 === 0) {
                          this._eatBits(1);
                          code1 = this._lookBits(12);
                        }
                      }
                      if (code1 === 1) {
                        this._eatBits(12);
                        gotEOL = true;
                      } else if (code1 === ccittEOF) {
                        this.eof = true;
                      }
                    }
                    if (!this.eof && this.encoding > 0 && !this.rowsDone) {
                      this.nextLine2D = !this._lookBits(1);
                      this._eatBits(1);
                    }
                    if (this.eoblock && gotEOL && this.byteAlign) {
                      code1 = this._lookBits(12);
                      if (code1 === 1) {
                        this._eatBits(12);
                        if (this.encoding > 0) {
                          this._lookBits(1);
                          this._eatBits(1);
                        }
                        if (this.encoding >= 0) {
                          for (i = 0; i < 4; ++i) {
                            code1 = this._lookBits(12);
                            if (code1 !== 1) {
                              (0, _util2.info)("bad rtc code: " + code1);
                            }
                            this._eatBits(12);
                            if (this.encoding > 0) {
                              this._lookBits(1);
                              this._eatBits(1);
                            }
                          }
                        }
                        this.eof = true;
                      }
                    } else if (this.err && this.eoline) {
                      while (true) {
                        code1 = this._lookBits(13);
                        if (code1 === ccittEOF) {
                          this.eof = true;
                          return -1;
                        }
                        if (code1 >> 1 === 1) {
                          break;
                        }
                        this._eatBits(1);
                      }
                      this._eatBits(12);
                      if (this.encoding > 0) {
                        this._eatBits(1);
                        this.nextLine2D = !(code1 & 1);
                      }
                    }
                    this.outputBits = codingLine[0] > 0 ? codingLine[this.codingPos = 0] : codingLine[this.codingPos = 1];
                    this.row++;
                  }
                  let c;
                  if (this.outputBits >= 8) {
                    c = this.codingPos & 1 ? 0 : 255;
                    this.outputBits -= 8;
                    if (this.outputBits === 0 && codingLine[this.codingPos] < columns) {
                      this.codingPos++;
                      this.outputBits = codingLine[this.codingPos] - codingLine[this.codingPos - 1];
                    }
                  } else {
                    bits = 8;
                    c = 0;
                    do {
                      if (typeof this.outputBits !== "number") {
                        throw new _util2.FormatError('Invalid /CCITTFaxDecode data, "outputBits" must be a number.');
                      }
                      if (this.outputBits > bits) {
                        c <<= bits;
                        if (!(this.codingPos & 1)) {
                          c |= 255 >> 8 - bits;
                        }
                        this.outputBits -= bits;
                        bits = 0;
                      } else {
                        c <<= this.outputBits;
                        if (!(this.codingPos & 1)) {
                          c |= 255 >> 8 - this.outputBits;
                        }
                        bits -= this.outputBits;
                        this.outputBits = 0;
                        if (codingLine[this.codingPos] < columns) {
                          this.codingPos++;
                          this.outputBits = codingLine[this.codingPos] - codingLine[this.codingPos - 1];
                        } else if (bits > 0) {
                          c <<= bits;
                          bits = 0;
                        }
                      }
                    } while (bits);
                  }
                  if (this.black) {
                    c ^= 255;
                  }
                  return c;
                }
                _addPixels(a1, blackPixels) {
                  const codingLine = this.codingLine;
                  let codingPos = this.codingPos;
                  if (a1 > codingLine[codingPos]) {
                    if (a1 > this.columns) {
                      (0, _util2.info)("row is wrong length");
                      this.err = true;
                      a1 = this.columns;
                    }
                    if (codingPos & 1 ^ blackPixels) {
                      ++codingPos;
                    }
                    codingLine[codingPos] = a1;
                  }
                  this.codingPos = codingPos;
                }
                _addPixelsNeg(a1, blackPixels) {
                  const codingLine = this.codingLine;
                  let codingPos = this.codingPos;
                  if (a1 > codingLine[codingPos]) {
                    if (a1 > this.columns) {
                      (0, _util2.info)("row is wrong length");
                      this.err = true;
                      a1 = this.columns;
                    }
                    if (codingPos & 1 ^ blackPixels) {
                      ++codingPos;
                    }
                    codingLine[codingPos] = a1;
                  } else if (a1 < codingLine[codingPos]) {
                    if (a1 < 0) {
                      (0, _util2.info)("invalid code");
                      this.err = true;
                      a1 = 0;
                    }
                    while (codingPos > 0 && a1 < codingLine[codingPos - 1]) {
                      --codingPos;
                    }
                    codingLine[codingPos] = a1;
                  }
                  this.codingPos = codingPos;
                }
                _findTableCode(start, end, table, limit) {
                  const limitValue = limit || 0;
                  for (let i = start; i <= end; ++i) {
                    let code2 = this._lookBits(i);
                    if (code2 === ccittEOF) {
                      return [true, 1, false];
                    }
                    if (i < end) {
                      code2 <<= end - i;
                    }
                    if (!limitValue || code2 >= limitValue) {
                      const p = table[code2 - limitValue];
                      if (p[0] === i) {
                        this._eatBits(i);
                        return [true, p[1], true];
                      }
                    }
                  }
                  return [false, 0, false];
                }
                _getTwoDimCode() {
                  let code2 = 0;
                  let p;
                  if (this.eoblock) {
                    code2 = this._lookBits(7);
                    p = twoDimTable[code2];
                    if (p?.[0] > 0) {
                      this._eatBits(p[0]);
                      return p[1];
                    }
                  } else {
                    const result = this._findTableCode(1, 7, twoDimTable);
                    if (result[0] && result[2]) {
                      return result[1];
                    }
                  }
                  (0, _util2.info)("Bad two dim code");
                  return ccittEOF;
                }
                _getWhiteCode() {
                  let code2 = 0;
                  let p;
                  if (this.eoblock) {
                    code2 = this._lookBits(12);
                    if (code2 === ccittEOF) {
                      return 1;
                    }
                    p = code2 >> 5 === 0 ? whiteTable1[code2] : whiteTable2[code2 >> 3];
                    if (p[0] > 0) {
                      this._eatBits(p[0]);
                      return p[1];
                    }
                  } else {
                    let result = this._findTableCode(1, 9, whiteTable2);
                    if (result[0]) {
                      return result[1];
                    }
                    result = this._findTableCode(11, 12, whiteTable1);
                    if (result[0]) {
                      return result[1];
                    }
                  }
                  (0, _util2.info)("bad white code");
                  this._eatBits(1);
                  return 1;
                }
                _getBlackCode() {
                  let code2, p;
                  if (this.eoblock) {
                    code2 = this._lookBits(13);
                    if (code2 === ccittEOF) {
                      return 1;
                    }
                    if (code2 >> 7 === 0) {
                      p = blackTable1[code2];
                    } else if (code2 >> 9 === 0 && code2 >> 7 !== 0) {
                      p = blackTable2[(code2 >> 1) - 64];
                    } else {
                      p = blackTable3[code2 >> 7];
                    }
                    if (p[0] > 0) {
                      this._eatBits(p[0]);
                      return p[1];
                    }
                  } else {
                    let result = this._findTableCode(2, 6, blackTable3);
                    if (result[0]) {
                      return result[1];
                    }
                    result = this._findTableCode(7, 12, blackTable2, 64);
                    if (result[0]) {
                      return result[1];
                    }
                    result = this._findTableCode(10, 13, blackTable1);
                    if (result[0]) {
                      return result[1];
                    }
                  }
                  (0, _util2.info)("bad black code");
                  this._eatBits(1);
                  return 1;
                }
                _lookBits(n2) {
                  let c;
                  while (this.inputBits < n2) {
                    if ((c = this.source.next()) === -1) {
                      if (this.inputBits === 0) {
                        return ccittEOF;
                      }
                      return this.inputBuf << n2 - this.inputBits & 65535 >> 16 - n2;
                    }
                    this.inputBuf = this.inputBuf << 8 | c;
                    this.inputBits += 8;
                  }
                  return this.inputBuf >> this.inputBits - n2 & 65535 >> 16 - n2;
                }
                _eatBits(n2) {
                  if ((this.inputBits -= n2) < 0) {
                    this.inputBits = 0;
                  }
                }
              }
              exports3.CCITTFaxDecoder = CCITTFaxDecoder;
            }),
            /* 22 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.FlateStream = void 0;
              var _decode_stream = __w_pdfjs_require__3(18);
              var _util2 = __w_pdfjs_require__3(2);
              const codeLenCodeMap = new Int32Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]);
              const lengthDecode = new Int32Array([3, 4, 5, 6, 7, 8, 9, 10, 65547, 65549, 65551, 65553, 131091, 131095, 131099, 131103, 196643, 196651, 196659, 196667, 262211, 262227, 262243, 262259, 327811, 327843, 327875, 327907, 258, 258, 258]);
              const distDecode = new Int32Array([1, 2, 3, 4, 65541, 65543, 131081, 131085, 196625, 196633, 262177, 262193, 327745, 327777, 393345, 393409, 459009, 459137, 524801, 525057, 590849, 591361, 657409, 658433, 724993, 727041, 794625, 798721, 868353, 876545]);
              const fixedLitCodeTab = [new Int32Array([459008, 524368, 524304, 524568, 459024, 524400, 524336, 590016, 459016, 524384, 524320, 589984, 524288, 524416, 524352, 590048, 459012, 524376, 524312, 589968, 459028, 524408, 524344, 590032, 459020, 524392, 524328, 59e4, 524296, 524424, 524360, 590064, 459010, 524372, 524308, 524572, 459026, 524404, 524340, 590024, 459018, 524388, 524324, 589992, 524292, 524420, 524356, 590056, 459014, 524380, 524316, 589976, 459030, 524412, 524348, 590040, 459022, 524396, 524332, 590008, 524300, 524428, 524364, 590072, 459009, 524370, 524306, 524570, 459025, 524402, 524338, 590020, 459017, 524386, 524322, 589988, 524290, 524418, 524354, 590052, 459013, 524378, 524314, 589972, 459029, 524410, 524346, 590036, 459021, 524394, 524330, 590004, 524298, 524426, 524362, 590068, 459011, 524374, 524310, 524574, 459027, 524406, 524342, 590028, 459019, 524390, 524326, 589996, 524294, 524422, 524358, 590060, 459015, 524382, 524318, 589980, 459031, 524414, 524350, 590044, 459023, 524398, 524334, 590012, 524302, 524430, 524366, 590076, 459008, 524369, 524305, 524569, 459024, 524401, 524337, 590018, 459016, 524385, 524321, 589986, 524289, 524417, 524353, 590050, 459012, 524377, 524313, 589970, 459028, 524409, 524345, 590034, 459020, 524393, 524329, 590002, 524297, 524425, 524361, 590066, 459010, 524373, 524309, 524573, 459026, 524405, 524341, 590026, 459018, 524389, 524325, 589994, 524293, 524421, 524357, 590058, 459014, 524381, 524317, 589978, 459030, 524413, 524349, 590042, 459022, 524397, 524333, 590010, 524301, 524429, 524365, 590074, 459009, 524371, 524307, 524571, 459025, 524403, 524339, 590022, 459017, 524387, 524323, 589990, 524291, 524419, 524355, 590054, 459013, 524379, 524315, 589974, 459029, 524411, 524347, 590038, 459021, 524395, 524331, 590006, 524299, 524427, 524363, 590070, 459011, 524375, 524311, 524575, 459027, 524407, 524343, 590030, 459019, 524391, 524327, 589998, 524295, 524423, 524359, 590062, 459015, 524383, 524319, 589982, 459031, 524415, 524351, 590046, 459023, 524399, 524335, 590014, 524303, 524431, 524367, 590078, 459008, 524368, 524304, 524568, 459024, 524400, 524336, 590017, 459016, 524384, 524320, 589985, 524288, 524416, 524352, 590049, 459012, 524376, 524312, 589969, 459028, 524408, 524344, 590033, 459020, 524392, 524328, 590001, 524296, 524424, 524360, 590065, 459010, 524372, 524308, 524572, 459026, 524404, 524340, 590025, 459018, 524388, 524324, 589993, 524292, 524420, 524356, 590057, 459014, 524380, 524316, 589977, 459030, 524412, 524348, 590041, 459022, 524396, 524332, 590009, 524300, 524428, 524364, 590073, 459009, 524370, 524306, 524570, 459025, 524402, 524338, 590021, 459017, 524386, 524322, 589989, 524290, 524418, 524354, 590053, 459013, 524378, 524314, 589973, 459029, 524410, 524346, 590037, 459021, 524394, 524330, 590005, 524298, 524426, 524362, 590069, 459011, 524374, 524310, 524574, 459027, 524406, 524342, 590029, 459019, 524390, 524326, 589997, 524294, 524422, 524358, 590061, 459015, 524382, 524318, 589981, 459031, 524414, 524350, 590045, 459023, 524398, 524334, 590013, 524302, 524430, 524366, 590077, 459008, 524369, 524305, 524569, 459024, 524401, 524337, 590019, 459016, 524385, 524321, 589987, 524289, 524417, 524353, 590051, 459012, 524377, 524313, 589971, 459028, 524409, 524345, 590035, 459020, 524393, 524329, 590003, 524297, 524425, 524361, 590067, 459010, 524373, 524309, 524573, 459026, 524405, 524341, 590027, 459018, 524389, 524325, 589995, 524293, 524421, 524357, 590059, 459014, 524381, 524317, 589979, 459030, 524413, 524349, 590043, 459022, 524397, 524333, 590011, 524301, 524429, 524365, 590075, 459009, 524371, 524307, 524571, 459025, 524403, 524339, 590023, 459017, 524387, 524323, 589991, 524291, 524419, 524355, 590055, 459013, 524379, 524315, 589975, 459029, 524411, 524347, 590039, 459021, 524395, 524331, 590007, 524299, 524427, 524363, 590071, 459011, 524375, 524311, 524575, 459027, 524407, 524343, 590031, 459019, 524391, 524327, 589999, 524295, 524423, 524359, 590063, 459015, 524383, 524319, 589983, 459031, 524415, 524351, 590047, 459023, 524399, 524335, 590015, 524303, 524431, 524367, 590079]), 9];
              const fixedDistCodeTab = [new Int32Array([327680, 327696, 327688, 327704, 327684, 327700, 327692, 327708, 327682, 327698, 327690, 327706, 327686, 327702, 327694, 0, 327681, 327697, 327689, 327705, 327685, 327701, 327693, 327709, 327683, 327699, 327691, 327707, 327687, 327703, 327695, 0]), 5];
              class FlateStream extends _decode_stream.DecodeStream {
                constructor(str, maybeLength) {
                  super(maybeLength);
                  this.str = str;
                  this.dict = str.dict;
                  const cmf = str.getByte();
                  const flg = str.getByte();
                  if (cmf === -1 || flg === -1) {
                    throw new _util2.FormatError(`Invalid header in flate stream: ${cmf}, ${flg}`);
                  }
                  if ((cmf & 15) !== 8) {
                    throw new _util2.FormatError(`Unknown compression method in flate stream: ${cmf}, ${flg}`);
                  }
                  if (((cmf << 8) + flg) % 31 !== 0) {
                    throw new _util2.FormatError(`Bad FCHECK in flate stream: ${cmf}, ${flg}`);
                  }
                  if (flg & 32) {
                    throw new _util2.FormatError(`FDICT bit set in flate stream: ${cmf}, ${flg}`);
                  }
                  this.codeSize = 0;
                  this.codeBuf = 0;
                }
                getBits(bits) {
                  const str = this.str;
                  let codeSize = this.codeSize;
                  let codeBuf = this.codeBuf;
                  let b;
                  while (codeSize < bits) {
                    if ((b = str.getByte()) === -1) {
                      throw new _util2.FormatError("Bad encoding in flate stream");
                    }
                    codeBuf |= b << codeSize;
                    codeSize += 8;
                  }
                  b = codeBuf & (1 << bits) - 1;
                  this.codeBuf = codeBuf >> bits;
                  this.codeSize = codeSize -= bits;
                  return b;
                }
                getCode(table) {
                  const str = this.str;
                  const codes = table[0];
                  const maxLen = table[1];
                  let codeSize = this.codeSize;
                  let codeBuf = this.codeBuf;
                  let b;
                  while (codeSize < maxLen) {
                    if ((b = str.getByte()) === -1) {
                      break;
                    }
                    codeBuf |= b << codeSize;
                    codeSize += 8;
                  }
                  const code2 = codes[codeBuf & (1 << maxLen) - 1];
                  const codeLen = code2 >> 16;
                  const codeVal = code2 & 65535;
                  if (codeLen < 1 || codeSize < codeLen) {
                    throw new _util2.FormatError("Bad encoding in flate stream");
                  }
                  this.codeBuf = codeBuf >> codeLen;
                  this.codeSize = codeSize - codeLen;
                  return codeVal;
                }
                generateHuffmanTable(lengths) {
                  const n2 = lengths.length;
                  let maxLen = 0;
                  let i;
                  for (i = 0; i < n2; ++i) {
                    if (lengths[i] > maxLen) {
                      maxLen = lengths[i];
                    }
                  }
                  const size = 1 << maxLen;
                  const codes = new Int32Array(size);
                  for (let len = 1, code2 = 0, skip = 2; len <= maxLen; ++len, code2 <<= 1, skip <<= 1) {
                    for (let val = 0; val < n2; ++val) {
                      if (lengths[val] === len) {
                        let code22 = 0;
                        let t2 = code2;
                        for (i = 0; i < len; ++i) {
                          code22 = code22 << 1 | t2 & 1;
                          t2 >>= 1;
                        }
                        for (i = code22; i < size; i += skip) {
                          codes[i] = len << 16 | val;
                        }
                        ++code2;
                      }
                    }
                  }
                  return [codes, maxLen];
                }
                readBlock() {
                  let buffer, len;
                  const str = this.str;
                  let hdr = this.getBits(3);
                  if (hdr & 1) {
                    this.eof = true;
                  }
                  hdr >>= 1;
                  if (hdr === 0) {
                    let b;
                    if ((b = str.getByte()) === -1) {
                      throw new _util2.FormatError("Bad block header in flate stream");
                    }
                    let blockLen = b;
                    if ((b = str.getByte()) === -1) {
                      throw new _util2.FormatError("Bad block header in flate stream");
                    }
                    blockLen |= b << 8;
                    if ((b = str.getByte()) === -1) {
                      throw new _util2.FormatError("Bad block header in flate stream");
                    }
                    let check = b;
                    if ((b = str.getByte()) === -1) {
                      throw new _util2.FormatError("Bad block header in flate stream");
                    }
                    check |= b << 8;
                    if (check !== (~blockLen & 65535) && (blockLen !== 0 || check !== 0)) {
                      throw new _util2.FormatError("Bad uncompressed block length in flate stream");
                    }
                    this.codeBuf = 0;
                    this.codeSize = 0;
                    const bufferLength = this.bufferLength, end = bufferLength + blockLen;
                    buffer = this.ensureBuffer(end);
                    this.bufferLength = end;
                    if (blockLen === 0) {
                      if (str.peekByte() === -1) {
                        this.eof = true;
                      }
                    } else {
                      const block = str.getBytes(blockLen);
                      buffer.set(block, bufferLength);
                      if (block.length < blockLen) {
                        this.eof = true;
                      }
                    }
                    return;
                  }
                  let litCodeTable;
                  let distCodeTable;
                  if (hdr === 1) {
                    litCodeTable = fixedLitCodeTab;
                    distCodeTable = fixedDistCodeTab;
                  } else if (hdr === 2) {
                    const numLitCodes = this.getBits(5) + 257;
                    const numDistCodes = this.getBits(5) + 1;
                    const numCodeLenCodes = this.getBits(4) + 4;
                    const codeLenCodeLengths = new Uint8Array(codeLenCodeMap.length);
                    let i;
                    for (i = 0; i < numCodeLenCodes; ++i) {
                      codeLenCodeLengths[codeLenCodeMap[i]] = this.getBits(3);
                    }
                    const codeLenCodeTab = this.generateHuffmanTable(codeLenCodeLengths);
                    len = 0;
                    i = 0;
                    const codes = numLitCodes + numDistCodes;
                    const codeLengths = new Uint8Array(codes);
                    let bitsLength, bitsOffset, what;
                    while (i < codes) {
                      const code2 = this.getCode(codeLenCodeTab);
                      if (code2 === 16) {
                        bitsLength = 2;
                        bitsOffset = 3;
                        what = len;
                      } else if (code2 === 17) {
                        bitsLength = 3;
                        bitsOffset = 3;
                        what = len = 0;
                      } else if (code2 === 18) {
                        bitsLength = 7;
                        bitsOffset = 11;
                        what = len = 0;
                      } else {
                        codeLengths[i++] = len = code2;
                        continue;
                      }
                      let repeatLength = this.getBits(bitsLength) + bitsOffset;
                      while (repeatLength-- > 0) {
                        codeLengths[i++] = what;
                      }
                    }
                    litCodeTable = this.generateHuffmanTable(codeLengths.subarray(0, numLitCodes));
                    distCodeTable = this.generateHuffmanTable(codeLengths.subarray(numLitCodes, codes));
                  } else {
                    throw new _util2.FormatError("Unknown block type in flate stream");
                  }
                  buffer = this.buffer;
                  let limit = buffer ? buffer.length : 0;
                  let pos = this.bufferLength;
                  while (true) {
                    let code1 = this.getCode(litCodeTable);
                    if (code1 < 256) {
                      if (pos + 1 >= limit) {
                        buffer = this.ensureBuffer(pos + 1);
                        limit = buffer.length;
                      }
                      buffer[pos++] = code1;
                      continue;
                    }
                    if (code1 === 256) {
                      this.bufferLength = pos;
                      return;
                    }
                    code1 -= 257;
                    code1 = lengthDecode[code1];
                    let code2 = code1 >> 16;
                    if (code2 > 0) {
                      code2 = this.getBits(code2);
                    }
                    len = (code1 & 65535) + code2;
                    code1 = this.getCode(distCodeTable);
                    code1 = distDecode[code1];
                    code2 = code1 >> 16;
                    if (code2 > 0) {
                      code2 = this.getBits(code2);
                    }
                    const dist = (code1 & 65535) + code2;
                    if (pos + len >= limit) {
                      buffer = this.ensureBuffer(pos + len);
                      limit = buffer.length;
                    }
                    for (let k = 0; k < len; ++k, ++pos) {
                      buffer[pos] = buffer[pos - dist];
                    }
                  }
                }
              }
              exports3.FlateStream = FlateStream;
            }),
            /* 23 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.Jbig2Stream = void 0;
              var _base_stream = __w_pdfjs_require__3(5);
              var _decode_stream = __w_pdfjs_require__3(18);
              var _primitives = __w_pdfjs_require__3(4);
              var _jbig = __w_pdfjs_require__3(24);
              var _util2 = __w_pdfjs_require__3(2);
              class Jbig2Stream extends _decode_stream.DecodeStream {
                constructor(stream, maybeLength, params) {
                  super(maybeLength);
                  this.stream = stream;
                  this.dict = stream.dict;
                  this.maybeLength = maybeLength;
                  this.params = params;
                }
                get bytes() {
                  return (0, _util2.shadow)(this, "bytes", this.stream.getBytes(this.maybeLength));
                }
                ensureBuffer(requested) {
                }
                readBlock() {
                  if (this.eof) {
                    return;
                  }
                  const jbig2Image = new _jbig.Jbig2Image();
                  const chunks = [];
                  if (this.params instanceof _primitives.Dict) {
                    const globalsStream = this.params.get("JBIG2Globals");
                    if (globalsStream instanceof _base_stream.BaseStream) {
                      const globals = globalsStream.getBytes();
                      chunks.push({
                        data: globals,
                        start: 0,
                        end: globals.length
                      });
                    }
                  }
                  chunks.push({
                    data: this.bytes,
                    start: 0,
                    end: this.bytes.length
                  });
                  const data2 = jbig2Image.parseChunks(chunks);
                  const dataLength = data2.length;
                  for (let i = 0; i < dataLength; i++) {
                    data2[i] ^= 255;
                  }
                  this.buffer = data2;
                  this.bufferLength = dataLength;
                  this.eof = true;
                }
              }
              exports3.Jbig2Stream = Jbig2Stream;
            }),
            /* 24 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.Jbig2Image = void 0;
              var _util2 = __w_pdfjs_require__3(2);
              var _core_utils = __w_pdfjs_require__3(3);
              var _arithmetic_decoder = __w_pdfjs_require__3(25);
              var _ccitt = __w_pdfjs_require__3(21);
              class Jbig2Error extends _util2.BaseException {
                constructor(msg) {
                  super(`JBIG2 error: ${msg}`, "Jbig2Error");
                }
              }
              class ContextCache {
                getContexts(id) {
                  if (id in this) {
                    return this[id];
                  }
                  return this[id] = new Int8Array(1 << 16);
                }
              }
              class DecodingContext {
                constructor(data2, start, end) {
                  this.data = data2;
                  this.start = start;
                  this.end = end;
                }
                get decoder() {
                  const decoder = new _arithmetic_decoder.ArithmeticDecoder(this.data, this.start, this.end);
                  return (0, _util2.shadow)(this, "decoder", decoder);
                }
                get contextCache() {
                  const cache = new ContextCache();
                  return (0, _util2.shadow)(this, "contextCache", cache);
                }
              }
              const MAX_INT_32 = 2 ** 31 - 1;
              const MIN_INT_32 = -(2 ** 31);
              function decodeInteger(contextCache, procedure, decoder) {
                const contexts = contextCache.getContexts(procedure);
                let prev2 = 1;
                function readBits(length2) {
                  let v = 0;
                  for (let i = 0; i < length2; i++) {
                    const bit = decoder.readBit(contexts, prev2);
                    prev2 = prev2 < 256 ? prev2 << 1 | bit : (prev2 << 1 | bit) & 511 | 256;
                    v = v << 1 | bit;
                  }
                  return v >>> 0;
                }
                const sign2 = readBits(1);
                const value = readBits(1) ? readBits(1) ? readBits(1) ? readBits(1) ? readBits(1) ? readBits(32) + 4436 : readBits(12) + 340 : readBits(8) + 84 : readBits(6) + 20 : readBits(4) + 4 : readBits(2);
                let signedValue;
                if (sign2 === 0) {
                  signedValue = value;
                } else if (value > 0) {
                  signedValue = -value;
                }
                if (signedValue >= MIN_INT_32 && signedValue <= MAX_INT_32) {
                  return signedValue;
                }
                return null;
              }
              function decodeIAID(contextCache, decoder, codeLength) {
                const contexts = contextCache.getContexts("IAID");
                let prev2 = 1;
                for (let i = 0; i < codeLength; i++) {
                  const bit = decoder.readBit(contexts, prev2);
                  prev2 = prev2 << 1 | bit;
                }
                if (codeLength < 31) {
                  return prev2 & (1 << codeLength) - 1;
                }
                return prev2 & 2147483647;
              }
              const SegmentTypes = ["SymbolDictionary", null, null, null, "IntermediateTextRegion", null, "ImmediateTextRegion", "ImmediateLosslessTextRegion", null, null, null, null, null, null, null, null, "PatternDictionary", null, null, null, "IntermediateHalftoneRegion", null, "ImmediateHalftoneRegion", "ImmediateLosslessHalftoneRegion", null, null, null, null, null, null, null, null, null, null, null, null, "IntermediateGenericRegion", null, "ImmediateGenericRegion", "ImmediateLosslessGenericRegion", "IntermediateGenericRefinementRegion", null, "ImmediateGenericRefinementRegion", "ImmediateLosslessGenericRefinementRegion", null, null, null, null, "PageInformation", "EndOfPage", "EndOfStripe", "EndOfFile", "Profiles", "Tables", null, null, null, null, null, null, null, null, "Extension"];
              const CodingTemplates = [[{
                x: -1,
                y: -2
              }, {
                x: 0,
                y: -2
              }, {
                x: 1,
                y: -2
              }, {
                x: -2,
                y: -1
              }, {
                x: -1,
                y: -1
              }, {
                x: 0,
                y: -1
              }, {
                x: 1,
                y: -1
              }, {
                x: 2,
                y: -1
              }, {
                x: -4,
                y: 0
              }, {
                x: -3,
                y: 0
              }, {
                x: -2,
                y: 0
              }, {
                x: -1,
                y: 0
              }], [{
                x: -1,
                y: -2
              }, {
                x: 0,
                y: -2
              }, {
                x: 1,
                y: -2
              }, {
                x: 2,
                y: -2
              }, {
                x: -2,
                y: -1
              }, {
                x: -1,
                y: -1
              }, {
                x: 0,
                y: -1
              }, {
                x: 1,
                y: -1
              }, {
                x: 2,
                y: -1
              }, {
                x: -3,
                y: 0
              }, {
                x: -2,
                y: 0
              }, {
                x: -1,
                y: 0
              }], [{
                x: -1,
                y: -2
              }, {
                x: 0,
                y: -2
              }, {
                x: 1,
                y: -2
              }, {
                x: -2,
                y: -1
              }, {
                x: -1,
                y: -1
              }, {
                x: 0,
                y: -1
              }, {
                x: 1,
                y: -1
              }, {
                x: -2,
                y: 0
              }, {
                x: -1,
                y: 0
              }], [{
                x: -3,
                y: -1
              }, {
                x: -2,
                y: -1
              }, {
                x: -1,
                y: -1
              }, {
                x: 0,
                y: -1
              }, {
                x: 1,
                y: -1
              }, {
                x: -4,
                y: 0
              }, {
                x: -3,
                y: 0
              }, {
                x: -2,
                y: 0
              }, {
                x: -1,
                y: 0
              }]];
              const RefinementTemplates = [{
                coding: [{
                  x: 0,
                  y: -1
                }, {
                  x: 1,
                  y: -1
                }, {
                  x: -1,
                  y: 0
                }],
                reference: [{
                  x: 0,
                  y: -1
                }, {
                  x: 1,
                  y: -1
                }, {
                  x: -1,
                  y: 0
                }, {
                  x: 0,
                  y: 0
                }, {
                  x: 1,
                  y: 0
                }, {
                  x: -1,
                  y: 1
                }, {
                  x: 0,
                  y: 1
                }, {
                  x: 1,
                  y: 1
                }]
              }, {
                coding: [{
                  x: -1,
                  y: -1
                }, {
                  x: 0,
                  y: -1
                }, {
                  x: 1,
                  y: -1
                }, {
                  x: -1,
                  y: 0
                }],
                reference: [{
                  x: 0,
                  y: -1
                }, {
                  x: -1,
                  y: 0
                }, {
                  x: 0,
                  y: 0
                }, {
                  x: 1,
                  y: 0
                }, {
                  x: 0,
                  y: 1
                }, {
                  x: 1,
                  y: 1
                }]
              }];
              const ReusedContexts = [39717, 1941, 229, 405];
              const RefinementReusedContexts = [32, 8];
              function decodeBitmapTemplate0(width, height, decodingContext) {
                const decoder = decodingContext.decoder;
                const contexts = decodingContext.contextCache.getContexts("GB");
                const bitmap = [];
                let contextLabel, i, j, pixel, row, row1, row2;
                const OLD_PIXEL_MASK = 31735;
                for (i = 0; i < height; i++) {
                  row = bitmap[i] = new Uint8Array(width);
                  row1 = i < 1 ? row : bitmap[i - 1];
                  row2 = i < 2 ? row : bitmap[i - 2];
                  contextLabel = row2[0] << 13 | row2[1] << 12 | row2[2] << 11 | row1[0] << 7 | row1[1] << 6 | row1[2] << 5 | row1[3] << 4;
                  for (j = 0; j < width; j++) {
                    row[j] = pixel = decoder.readBit(contexts, contextLabel);
                    contextLabel = (contextLabel & OLD_PIXEL_MASK) << 1 | (j + 3 < width ? row2[j + 3] << 11 : 0) | (j + 4 < width ? row1[j + 4] << 4 : 0) | pixel;
                  }
                }
                return bitmap;
              }
              function decodeBitmap(mmr, width, height, templateIndex, prediction, skip, at2, decodingContext) {
                if (mmr) {
                  const input = new Reader(decodingContext.data, decodingContext.start, decodingContext.end);
                  return decodeMMRBitmap(input, width, height, false);
                }
                if (templateIndex === 0 && !skip && !prediction && at2.length === 4 && at2[0].x === 3 && at2[0].y === -1 && at2[1].x === -3 && at2[1].y === -1 && at2[2].x === 2 && at2[2].y === -2 && at2[3].x === -2 && at2[3].y === -2) {
                  return decodeBitmapTemplate0(width, height, decodingContext);
                }
                const useskip = !!skip;
                const template = CodingTemplates[templateIndex].concat(at2);
                template.sort(function(a, b) {
                  return a.y - b.y || a.x - b.x;
                });
                const templateLength = template.length;
                const templateX = new Int8Array(templateLength);
                const templateY = new Int8Array(templateLength);
                const changingTemplateEntries = [];
                let reuseMask = 0, minX = 0, maxX = 0, minY = 0;
                let c, k;
                for (k = 0; k < templateLength; k++) {
                  templateX[k] = template[k].x;
                  templateY[k] = template[k].y;
                  minX = Math.min(minX, template[k].x);
                  maxX = Math.max(maxX, template[k].x);
                  minY = Math.min(minY, template[k].y);
                  if (k < templateLength - 1 && template[k].y === template[k + 1].y && template[k].x === template[k + 1].x - 1) {
                    reuseMask |= 1 << templateLength - 1 - k;
                  } else {
                    changingTemplateEntries.push(k);
                  }
                }
                const changingEntriesLength = changingTemplateEntries.length;
                const changingTemplateX = new Int8Array(changingEntriesLength);
                const changingTemplateY = new Int8Array(changingEntriesLength);
                const changingTemplateBit = new Uint16Array(changingEntriesLength);
                for (c = 0; c < changingEntriesLength; c++) {
                  k = changingTemplateEntries[c];
                  changingTemplateX[c] = template[k].x;
                  changingTemplateY[c] = template[k].y;
                  changingTemplateBit[c] = 1 << templateLength - 1 - k;
                }
                const sbb_left = -minX;
                const sbb_top = -minY;
                const sbb_right = width - maxX;
                const pseudoPixelContext = ReusedContexts[templateIndex];
                let row = new Uint8Array(width);
                const bitmap = [];
                const decoder = decodingContext.decoder;
                const contexts = decodingContext.contextCache.getContexts("GB");
                let ltp = 0, j, i0, j0, contextLabel = 0, bit, shift2;
                for (let i = 0; i < height; i++) {
                  if (prediction) {
                    const sltp = decoder.readBit(contexts, pseudoPixelContext);
                    ltp ^= sltp;
                    if (ltp) {
                      bitmap.push(row);
                      continue;
                    }
                  }
                  row = new Uint8Array(row);
                  bitmap.push(row);
                  for (j = 0; j < width; j++) {
                    if (useskip && skip[i][j]) {
                      row[j] = 0;
                      continue;
                    }
                    if (j >= sbb_left && j < sbb_right && i >= sbb_top) {
                      contextLabel = contextLabel << 1 & reuseMask;
                      for (k = 0; k < changingEntriesLength; k++) {
                        i0 = i + changingTemplateY[k];
                        j0 = j + changingTemplateX[k];
                        bit = bitmap[i0][j0];
                        if (bit) {
                          bit = changingTemplateBit[k];
                          contextLabel |= bit;
                        }
                      }
                    } else {
                      contextLabel = 0;
                      shift2 = templateLength - 1;
                      for (k = 0; k < templateLength; k++, shift2--) {
                        j0 = j + templateX[k];
                        if (j0 >= 0 && j0 < width) {
                          i0 = i + templateY[k];
                          if (i0 >= 0) {
                            bit = bitmap[i0][j0];
                            if (bit) {
                              contextLabel |= bit << shift2;
                            }
                          }
                        }
                      }
                    }
                    const pixel = decoder.readBit(contexts, contextLabel);
                    row[j] = pixel;
                  }
                }
                return bitmap;
              }
              function decodeRefinement(width, height, templateIndex, referenceBitmap, offsetX, offsetY, prediction, at2, decodingContext) {
                let codingTemplate = RefinementTemplates[templateIndex].coding;
                if (templateIndex === 0) {
                  codingTemplate = codingTemplate.concat([at2[0]]);
                }
                const codingTemplateLength = codingTemplate.length;
                const codingTemplateX = new Int32Array(codingTemplateLength);
                const codingTemplateY = new Int32Array(codingTemplateLength);
                let k;
                for (k = 0; k < codingTemplateLength; k++) {
                  codingTemplateX[k] = codingTemplate[k].x;
                  codingTemplateY[k] = codingTemplate[k].y;
                }
                let referenceTemplate = RefinementTemplates[templateIndex].reference;
                if (templateIndex === 0) {
                  referenceTemplate = referenceTemplate.concat([at2[1]]);
                }
                const referenceTemplateLength = referenceTemplate.length;
                const referenceTemplateX = new Int32Array(referenceTemplateLength);
                const referenceTemplateY = new Int32Array(referenceTemplateLength);
                for (k = 0; k < referenceTemplateLength; k++) {
                  referenceTemplateX[k] = referenceTemplate[k].x;
                  referenceTemplateY[k] = referenceTemplate[k].y;
                }
                const referenceWidth = referenceBitmap[0].length;
                const referenceHeight = referenceBitmap.length;
                const pseudoPixelContext = RefinementReusedContexts[templateIndex];
                const bitmap = [];
                const decoder = decodingContext.decoder;
                const contexts = decodingContext.contextCache.getContexts("GR");
                let ltp = 0;
                for (let i = 0; i < height; i++) {
                  if (prediction) {
                    const sltp = decoder.readBit(contexts, pseudoPixelContext);
                    ltp ^= sltp;
                    if (ltp) {
                      throw new Jbig2Error("prediction is not supported");
                    }
                  }
                  const row = new Uint8Array(width);
                  bitmap.push(row);
                  for (let j = 0; j < width; j++) {
                    let i0, j0;
                    let contextLabel = 0;
                    for (k = 0; k < codingTemplateLength; k++) {
                      i0 = i + codingTemplateY[k];
                      j0 = j + codingTemplateX[k];
                      if (i0 < 0 || j0 < 0 || j0 >= width) {
                        contextLabel <<= 1;
                      } else {
                        contextLabel = contextLabel << 1 | bitmap[i0][j0];
                      }
                    }
                    for (k = 0; k < referenceTemplateLength; k++) {
                      i0 = i + referenceTemplateY[k] - offsetY;
                      j0 = j + referenceTemplateX[k] - offsetX;
                      if (i0 < 0 || i0 >= referenceHeight || j0 < 0 || j0 >= referenceWidth) {
                        contextLabel <<= 1;
                      } else {
                        contextLabel = contextLabel << 1 | referenceBitmap[i0][j0];
                      }
                    }
                    const pixel = decoder.readBit(contexts, contextLabel);
                    row[j] = pixel;
                  }
                }
                return bitmap;
              }
              function decodeSymbolDictionary(huffman, refinement, symbols, numberOfNewSymbols, numberOfExportedSymbols, huffmanTables, templateIndex, at2, refinementTemplateIndex, refinementAt, decodingContext, huffmanInput) {
                if (huffman && refinement) {
                  throw new Jbig2Error("symbol refinement with Huffman is not supported");
                }
                const newSymbols = [];
                let currentHeight = 0;
                let symbolCodeLength = (0, _core_utils.log2)(symbols.length + numberOfNewSymbols);
                const decoder = decodingContext.decoder;
                const contextCache = decodingContext.contextCache;
                let tableB1, symbolWidths;
                if (huffman) {
                  tableB1 = getStandardTable(1);
                  symbolWidths = [];
                  symbolCodeLength = Math.max(symbolCodeLength, 1);
                }
                while (newSymbols.length < numberOfNewSymbols) {
                  const deltaHeight = huffman ? huffmanTables.tableDeltaHeight.decode(huffmanInput) : decodeInteger(contextCache, "IADH", decoder);
                  currentHeight += deltaHeight;
                  let currentWidth = 0, totalWidth = 0;
                  const firstSymbol = huffman ? symbolWidths.length : 0;
                  while (true) {
                    const deltaWidth = huffman ? huffmanTables.tableDeltaWidth.decode(huffmanInput) : decodeInteger(contextCache, "IADW", decoder);
                    if (deltaWidth === null) {
                      break;
                    }
                    currentWidth += deltaWidth;
                    totalWidth += currentWidth;
                    let bitmap;
                    if (refinement) {
                      const numberOfInstances = decodeInteger(contextCache, "IAAI", decoder);
                      if (numberOfInstances > 1) {
                        bitmap = decodeTextRegion(huffman, refinement, currentWidth, currentHeight, 0, numberOfInstances, 1, symbols.concat(newSymbols), symbolCodeLength, 0, 0, 1, 0, huffmanTables, refinementTemplateIndex, refinementAt, decodingContext, 0, huffmanInput);
                      } else {
                        const symbolId = decodeIAID(contextCache, decoder, symbolCodeLength);
                        const rdx = decodeInteger(contextCache, "IARDX", decoder);
                        const rdy = decodeInteger(contextCache, "IARDY", decoder);
                        const symbol = symbolId < symbols.length ? symbols[symbolId] : newSymbols[symbolId - symbols.length];
                        bitmap = decodeRefinement(currentWidth, currentHeight, refinementTemplateIndex, symbol, rdx, rdy, false, refinementAt, decodingContext);
                      }
                      newSymbols.push(bitmap);
                    } else if (huffman) {
                      symbolWidths.push(currentWidth);
                    } else {
                      bitmap = decodeBitmap(false, currentWidth, currentHeight, templateIndex, false, null, at2, decodingContext);
                      newSymbols.push(bitmap);
                    }
                  }
                  if (huffman && !refinement) {
                    const bitmapSize = huffmanTables.tableBitmapSize.decode(huffmanInput);
                    huffmanInput.byteAlign();
                    let collectiveBitmap;
                    if (bitmapSize === 0) {
                      collectiveBitmap = readUncompressedBitmap(huffmanInput, totalWidth, currentHeight);
                    } else {
                      const originalEnd = huffmanInput.end;
                      const bitmapEnd = huffmanInput.position + bitmapSize;
                      huffmanInput.end = bitmapEnd;
                      collectiveBitmap = decodeMMRBitmap(huffmanInput, totalWidth, currentHeight, false);
                      huffmanInput.end = originalEnd;
                      huffmanInput.position = bitmapEnd;
                    }
                    const numberOfSymbolsDecoded = symbolWidths.length;
                    if (firstSymbol === numberOfSymbolsDecoded - 1) {
                      newSymbols.push(collectiveBitmap);
                    } else {
                      let i2, y, xMin = 0, xMax, bitmapWidth, symbolBitmap;
                      for (i2 = firstSymbol; i2 < numberOfSymbolsDecoded; i2++) {
                        bitmapWidth = symbolWidths[i2];
                        xMax = xMin + bitmapWidth;
                        symbolBitmap = [];
                        for (y = 0; y < currentHeight; y++) {
                          symbolBitmap.push(collectiveBitmap[y].subarray(xMin, xMax));
                        }
                        newSymbols.push(symbolBitmap);
                        xMin = xMax;
                      }
                    }
                  }
                }
                const exportedSymbols = [], flags = [];
                let currentFlag = false, i, ii;
                const totalSymbolsLength = symbols.length + numberOfNewSymbols;
                while (flags.length < totalSymbolsLength) {
                  let runLength = huffman ? tableB1.decode(huffmanInput) : decodeInteger(contextCache, "IAEX", decoder);
                  while (runLength--) {
                    flags.push(currentFlag);
                  }
                  currentFlag = !currentFlag;
                }
                for (i = 0, ii = symbols.length; i < ii; i++) {
                  if (flags[i]) {
                    exportedSymbols.push(symbols[i]);
                  }
                }
                for (let j = 0; j < numberOfNewSymbols; i++, j++) {
                  if (flags[i]) {
                    exportedSymbols.push(newSymbols[j]);
                  }
                }
                return exportedSymbols;
              }
              function decodeTextRegion(huffman, refinement, width, height, defaultPixelValue, numberOfSymbolInstances, stripSize, inputSymbols, symbolCodeLength, transposed, dsOffset, referenceCorner, combinationOperator, huffmanTables, refinementTemplateIndex, refinementAt, decodingContext, logStripSize, huffmanInput) {
                if (huffman && refinement) {
                  throw new Jbig2Error("refinement with Huffman is not supported");
                }
                const bitmap = [];
                let i, row;
                for (i = 0; i < height; i++) {
                  row = new Uint8Array(width);
                  if (defaultPixelValue) {
                    for (let j = 0; j < width; j++) {
                      row[j] = defaultPixelValue;
                    }
                  }
                  bitmap.push(row);
                }
                const decoder = decodingContext.decoder;
                const contextCache = decodingContext.contextCache;
                let stripT = huffman ? -huffmanTables.tableDeltaT.decode(huffmanInput) : -decodeInteger(contextCache, "IADT", decoder);
                let firstS = 0;
                i = 0;
                while (i < numberOfSymbolInstances) {
                  const deltaT = huffman ? huffmanTables.tableDeltaT.decode(huffmanInput) : decodeInteger(contextCache, "IADT", decoder);
                  stripT += deltaT;
                  const deltaFirstS = huffman ? huffmanTables.tableFirstS.decode(huffmanInput) : decodeInteger(contextCache, "IAFS", decoder);
                  firstS += deltaFirstS;
                  let currentS = firstS;
                  do {
                    let currentT = 0;
                    if (stripSize > 1) {
                      currentT = huffman ? huffmanInput.readBits(logStripSize) : decodeInteger(contextCache, "IAIT", decoder);
                    }
                    const t2 = stripSize * stripT + currentT;
                    const symbolId = huffman ? huffmanTables.symbolIDTable.decode(huffmanInput) : decodeIAID(contextCache, decoder, symbolCodeLength);
                    const applyRefinement = refinement && (huffman ? huffmanInput.readBit() : decodeInteger(contextCache, "IARI", decoder));
                    let symbolBitmap = inputSymbols[symbolId];
                    let symbolWidth = symbolBitmap[0].length;
                    let symbolHeight = symbolBitmap.length;
                    if (applyRefinement) {
                      const rdw = decodeInteger(contextCache, "IARDW", decoder);
                      const rdh = decodeInteger(contextCache, "IARDH", decoder);
                      const rdx = decodeInteger(contextCache, "IARDX", decoder);
                      const rdy = decodeInteger(contextCache, "IARDY", decoder);
                      symbolWidth += rdw;
                      symbolHeight += rdh;
                      symbolBitmap = decodeRefinement(symbolWidth, symbolHeight, refinementTemplateIndex, symbolBitmap, (rdw >> 1) + rdx, (rdh >> 1) + rdy, false, refinementAt, decodingContext);
                    }
                    const offsetT = t2 - (referenceCorner & 1 ? 0 : symbolHeight - 1);
                    const offsetS = currentS - (referenceCorner & 2 ? symbolWidth - 1 : 0);
                    let s2, t22, symbolRow;
                    if (transposed) {
                      for (s2 = 0; s2 < symbolHeight; s2++) {
                        row = bitmap[offsetS + s2];
                        if (!row) {
                          continue;
                        }
                        symbolRow = symbolBitmap[s2];
                        const maxWidth = Math.min(width - offsetT, symbolWidth);
                        switch (combinationOperator) {
                          case 0:
                            for (t22 = 0; t22 < maxWidth; t22++) {
                              row[offsetT + t22] |= symbolRow[t22];
                            }
                            break;
                          case 2:
                            for (t22 = 0; t22 < maxWidth; t22++) {
                              row[offsetT + t22] ^= symbolRow[t22];
                            }
                            break;
                          default:
                            throw new Jbig2Error(`operator ${combinationOperator} is not supported`);
                        }
                      }
                      currentS += symbolHeight - 1;
                    } else {
                      for (t22 = 0; t22 < symbolHeight; t22++) {
                        row = bitmap[offsetT + t22];
                        if (!row) {
                          continue;
                        }
                        symbolRow = symbolBitmap[t22];
                        switch (combinationOperator) {
                          case 0:
                            for (s2 = 0; s2 < symbolWidth; s2++) {
                              row[offsetS + s2] |= symbolRow[s2];
                            }
                            break;
                          case 2:
                            for (s2 = 0; s2 < symbolWidth; s2++) {
                              row[offsetS + s2] ^= symbolRow[s2];
                            }
                            break;
                          default:
                            throw new Jbig2Error(`operator ${combinationOperator} is not supported`);
                        }
                      }
                      currentS += symbolWidth - 1;
                    }
                    i++;
                    const deltaS = huffman ? huffmanTables.tableDeltaS.decode(huffmanInput) : decodeInteger(contextCache, "IADS", decoder);
                    if (deltaS === null) {
                      break;
                    }
                    currentS += deltaS + dsOffset;
                  } while (true);
                }
                return bitmap;
              }
              function decodePatternDictionary(mmr, patternWidth, patternHeight, maxPatternIndex, template, decodingContext) {
                const at2 = [];
                if (!mmr) {
                  at2.push({
                    x: -patternWidth,
                    y: 0
                  });
                  if (template === 0) {
                    at2.push({
                      x: -3,
                      y: -1
                    }, {
                      x: 2,
                      y: -2
                    }, {
                      x: -2,
                      y: -2
                    });
                  }
                }
                const collectiveWidth = (maxPatternIndex + 1) * patternWidth;
                const collectiveBitmap = decodeBitmap(mmr, collectiveWidth, patternHeight, template, false, null, at2, decodingContext);
                const patterns = [];
                for (let i = 0; i <= maxPatternIndex; i++) {
                  const patternBitmap = [];
                  const xMin = patternWidth * i;
                  const xMax = xMin + patternWidth;
                  for (let y = 0; y < patternHeight; y++) {
                    patternBitmap.push(collectiveBitmap[y].subarray(xMin, xMax));
                  }
                  patterns.push(patternBitmap);
                }
                return patterns;
              }
              function decodeHalftoneRegion(mmr, patterns, template, regionWidth, regionHeight, defaultPixelValue, enableSkip, combinationOperator, gridWidth, gridHeight, gridOffsetX, gridOffsetY, gridVectorX, gridVectorY, decodingContext) {
                const skip = null;
                if (enableSkip) {
                  throw new Jbig2Error("skip is not supported");
                }
                if (combinationOperator !== 0) {
                  throw new Jbig2Error(`operator "${combinationOperator}" is not supported in halftone region`);
                }
                const regionBitmap = [];
                let i, j, row;
                for (i = 0; i < regionHeight; i++) {
                  row = new Uint8Array(regionWidth);
                  if (defaultPixelValue) {
                    for (j = 0; j < regionWidth; j++) {
                      row[j] = defaultPixelValue;
                    }
                  }
                  regionBitmap.push(row);
                }
                const numberOfPatterns = patterns.length;
                const pattern0 = patterns[0];
                const patternWidth = pattern0[0].length, patternHeight = pattern0.length;
                const bitsPerValue = (0, _core_utils.log2)(numberOfPatterns);
                const at2 = [];
                if (!mmr) {
                  at2.push({
                    x: template <= 1 ? 3 : 2,
                    y: -1
                  });
                  if (template === 0) {
                    at2.push({
                      x: -3,
                      y: -1
                    }, {
                      x: 2,
                      y: -2
                    }, {
                      x: -2,
                      y: -2
                    });
                  }
                }
                const grayScaleBitPlanes = [];
                let mmrInput, bitmap;
                if (mmr) {
                  mmrInput = new Reader(decodingContext.data, decodingContext.start, decodingContext.end);
                }
                for (i = bitsPerValue - 1; i >= 0; i--) {
                  if (mmr) {
                    bitmap = decodeMMRBitmap(mmrInput, gridWidth, gridHeight, true);
                  } else {
                    bitmap = decodeBitmap(false, gridWidth, gridHeight, template, false, skip, at2, decodingContext);
                  }
                  grayScaleBitPlanes[i] = bitmap;
                }
                let mg, ng, bit, patternIndex, patternBitmap, x, y, patternRow, regionRow;
                for (mg = 0; mg < gridHeight; mg++) {
                  for (ng = 0; ng < gridWidth; ng++) {
                    bit = 0;
                    patternIndex = 0;
                    for (j = bitsPerValue - 1; j >= 0; j--) {
                      bit ^= grayScaleBitPlanes[j][mg][ng];
                      patternIndex |= bit << j;
                    }
                    patternBitmap = patterns[patternIndex];
                    x = gridOffsetX + mg * gridVectorY + ng * gridVectorX >> 8;
                    y = gridOffsetY + mg * gridVectorX - ng * gridVectorY >> 8;
                    if (x >= 0 && x + patternWidth <= regionWidth && y >= 0 && y + patternHeight <= regionHeight) {
                      for (i = 0; i < patternHeight; i++) {
                        regionRow = regionBitmap[y + i];
                        patternRow = patternBitmap[i];
                        for (j = 0; j < patternWidth; j++) {
                          regionRow[x + j] |= patternRow[j];
                        }
                      }
                    } else {
                      let regionX, regionY;
                      for (i = 0; i < patternHeight; i++) {
                        regionY = y + i;
                        if (regionY < 0 || regionY >= regionHeight) {
                          continue;
                        }
                        regionRow = regionBitmap[regionY];
                        patternRow = patternBitmap[i];
                        for (j = 0; j < patternWidth; j++) {
                          regionX = x + j;
                          if (regionX >= 0 && regionX < regionWidth) {
                            regionRow[regionX] |= patternRow[j];
                          }
                        }
                      }
                    }
                  }
                }
                return regionBitmap;
              }
              function readSegmentHeader(data2, start) {
                const segmentHeader = {};
                segmentHeader.number = (0, _core_utils.readUint32)(data2, start);
                const flags = data2[start + 4];
                const segmentType = flags & 63;
                if (!SegmentTypes[segmentType]) {
                  throw new Jbig2Error("invalid segment type: " + segmentType);
                }
                segmentHeader.type = segmentType;
                segmentHeader.typeName = SegmentTypes[segmentType];
                segmentHeader.deferredNonRetain = !!(flags & 128);
                const pageAssociationFieldSize = !!(flags & 64);
                const referredFlags = data2[start + 5];
                let referredToCount = referredFlags >> 5 & 7;
                const retainBits = [referredFlags & 31];
                let position3 = start + 6;
                if (referredFlags === 7) {
                  referredToCount = (0, _core_utils.readUint32)(data2, position3 - 1) & 536870911;
                  position3 += 3;
                  let bytes = referredToCount + 7 >> 3;
                  retainBits[0] = data2[position3++];
                  while (--bytes > 0) {
                    retainBits.push(data2[position3++]);
                  }
                } else if (referredFlags === 5 || referredFlags === 6) {
                  throw new Jbig2Error("invalid referred-to flags");
                }
                segmentHeader.retainBits = retainBits;
                let referredToSegmentNumberSize = 4;
                if (segmentHeader.number <= 256) {
                  referredToSegmentNumberSize = 1;
                } else if (segmentHeader.number <= 65536) {
                  referredToSegmentNumberSize = 2;
                }
                const referredTo = [];
                let i, ii;
                for (i = 0; i < referredToCount; i++) {
                  let number4;
                  if (referredToSegmentNumberSize === 1) {
                    number4 = data2[position3];
                  } else if (referredToSegmentNumberSize === 2) {
                    number4 = (0, _core_utils.readUint16)(data2, position3);
                  } else {
                    number4 = (0, _core_utils.readUint32)(data2, position3);
                  }
                  referredTo.push(number4);
                  position3 += referredToSegmentNumberSize;
                }
                segmentHeader.referredTo = referredTo;
                if (!pageAssociationFieldSize) {
                  segmentHeader.pageAssociation = data2[position3++];
                } else {
                  segmentHeader.pageAssociation = (0, _core_utils.readUint32)(data2, position3);
                  position3 += 4;
                }
                segmentHeader.length = (0, _core_utils.readUint32)(data2, position3);
                position3 += 4;
                if (segmentHeader.length === 4294967295) {
                  if (segmentType === 38) {
                    const genericRegionInfo = readRegionSegmentInformation(data2, position3);
                    const genericRegionSegmentFlags = data2[position3 + RegionSegmentInformationFieldLength];
                    const genericRegionMmr = !!(genericRegionSegmentFlags & 1);
                    const searchPatternLength = 6;
                    const searchPattern = new Uint8Array(searchPatternLength);
                    if (!genericRegionMmr) {
                      searchPattern[0] = 255;
                      searchPattern[1] = 172;
                    }
                    searchPattern[2] = genericRegionInfo.height >>> 24 & 255;
                    searchPattern[3] = genericRegionInfo.height >> 16 & 255;
                    searchPattern[4] = genericRegionInfo.height >> 8 & 255;
                    searchPattern[5] = genericRegionInfo.height & 255;
                    for (i = position3, ii = data2.length; i < ii; i++) {
                      let j = 0;
                      while (j < searchPatternLength && searchPattern[j] === data2[i + j]) {
                        j++;
                      }
                      if (j === searchPatternLength) {
                        segmentHeader.length = i + searchPatternLength;
                        break;
                      }
                    }
                    if (segmentHeader.length === 4294967295) {
                      throw new Jbig2Error("segment end was not found");
                    }
                  } else {
                    throw new Jbig2Error("invalid unknown segment length");
                  }
                }
                segmentHeader.headerEnd = position3;
                return segmentHeader;
              }
              function readSegments(header, data2, start, end) {
                const segments = [];
                let position3 = start;
                while (position3 < end) {
                  const segmentHeader = readSegmentHeader(data2, position3);
                  position3 = segmentHeader.headerEnd;
                  const segment = {
                    header: segmentHeader,
                    data: data2
                  };
                  if (!header.randomAccess) {
                    segment.start = position3;
                    position3 += segmentHeader.length;
                    segment.end = position3;
                  }
                  segments.push(segment);
                  if (segmentHeader.type === 51) {
                    break;
                  }
                }
                if (header.randomAccess) {
                  for (let i = 0, ii = segments.length; i < ii; i++) {
                    segments[i].start = position3;
                    position3 += segments[i].header.length;
                    segments[i].end = position3;
                  }
                }
                return segments;
              }
              function readRegionSegmentInformation(data2, start) {
                return {
                  width: (0, _core_utils.readUint32)(data2, start),
                  height: (0, _core_utils.readUint32)(data2, start + 4),
                  x: (0, _core_utils.readUint32)(data2, start + 8),
                  y: (0, _core_utils.readUint32)(data2, start + 12),
                  combinationOperator: data2[start + 16] & 7
                };
              }
              const RegionSegmentInformationFieldLength = 17;
              function processSegment(segment, visitor) {
                const header = segment.header;
                const data2 = segment.data, end = segment.end;
                let position3 = segment.start;
                let args, at2, i, atLength;
                switch (header.type) {
                  case 0:
                    const dictionary = {};
                    const dictionaryFlags = (0, _core_utils.readUint16)(data2, position3);
                    dictionary.huffman = !!(dictionaryFlags & 1);
                    dictionary.refinement = !!(dictionaryFlags & 2);
                    dictionary.huffmanDHSelector = dictionaryFlags >> 2 & 3;
                    dictionary.huffmanDWSelector = dictionaryFlags >> 4 & 3;
                    dictionary.bitmapSizeSelector = dictionaryFlags >> 6 & 1;
                    dictionary.aggregationInstancesSelector = dictionaryFlags >> 7 & 1;
                    dictionary.bitmapCodingContextUsed = !!(dictionaryFlags & 256);
                    dictionary.bitmapCodingContextRetained = !!(dictionaryFlags & 512);
                    dictionary.template = dictionaryFlags >> 10 & 3;
                    dictionary.refinementTemplate = dictionaryFlags >> 12 & 1;
                    position3 += 2;
                    if (!dictionary.huffman) {
                      atLength = dictionary.template === 0 ? 4 : 1;
                      at2 = [];
                      for (i = 0; i < atLength; i++) {
                        at2.push({
                          x: (0, _core_utils.readInt8)(data2, position3),
                          y: (0, _core_utils.readInt8)(data2, position3 + 1)
                        });
                        position3 += 2;
                      }
                      dictionary.at = at2;
                    }
                    if (dictionary.refinement && !dictionary.refinementTemplate) {
                      at2 = [];
                      for (i = 0; i < 2; i++) {
                        at2.push({
                          x: (0, _core_utils.readInt8)(data2, position3),
                          y: (0, _core_utils.readInt8)(data2, position3 + 1)
                        });
                        position3 += 2;
                      }
                      dictionary.refinementAt = at2;
                    }
                    dictionary.numberOfExportedSymbols = (0, _core_utils.readUint32)(data2, position3);
                    position3 += 4;
                    dictionary.numberOfNewSymbols = (0, _core_utils.readUint32)(data2, position3);
                    position3 += 4;
                    args = [dictionary, header.number, header.referredTo, data2, position3, end];
                    break;
                  case 6:
                  case 7:
                    const textRegion = {};
                    textRegion.info = readRegionSegmentInformation(data2, position3);
                    position3 += RegionSegmentInformationFieldLength;
                    const textRegionSegmentFlags = (0, _core_utils.readUint16)(data2, position3);
                    position3 += 2;
                    textRegion.huffman = !!(textRegionSegmentFlags & 1);
                    textRegion.refinement = !!(textRegionSegmentFlags & 2);
                    textRegion.logStripSize = textRegionSegmentFlags >> 2 & 3;
                    textRegion.stripSize = 1 << textRegion.logStripSize;
                    textRegion.referenceCorner = textRegionSegmentFlags >> 4 & 3;
                    textRegion.transposed = !!(textRegionSegmentFlags & 64);
                    textRegion.combinationOperator = textRegionSegmentFlags >> 7 & 3;
                    textRegion.defaultPixelValue = textRegionSegmentFlags >> 9 & 1;
                    textRegion.dsOffset = textRegionSegmentFlags << 17 >> 27;
                    textRegion.refinementTemplate = textRegionSegmentFlags >> 15 & 1;
                    if (textRegion.huffman) {
                      const textRegionHuffmanFlags = (0, _core_utils.readUint16)(data2, position3);
                      position3 += 2;
                      textRegion.huffmanFS = textRegionHuffmanFlags & 3;
                      textRegion.huffmanDS = textRegionHuffmanFlags >> 2 & 3;
                      textRegion.huffmanDT = textRegionHuffmanFlags >> 4 & 3;
                      textRegion.huffmanRefinementDW = textRegionHuffmanFlags >> 6 & 3;
                      textRegion.huffmanRefinementDH = textRegionHuffmanFlags >> 8 & 3;
                      textRegion.huffmanRefinementDX = textRegionHuffmanFlags >> 10 & 3;
                      textRegion.huffmanRefinementDY = textRegionHuffmanFlags >> 12 & 3;
                      textRegion.huffmanRefinementSizeSelector = !!(textRegionHuffmanFlags & 16384);
                    }
                    if (textRegion.refinement && !textRegion.refinementTemplate) {
                      at2 = [];
                      for (i = 0; i < 2; i++) {
                        at2.push({
                          x: (0, _core_utils.readInt8)(data2, position3),
                          y: (0, _core_utils.readInt8)(data2, position3 + 1)
                        });
                        position3 += 2;
                      }
                      textRegion.refinementAt = at2;
                    }
                    textRegion.numberOfSymbolInstances = (0, _core_utils.readUint32)(data2, position3);
                    position3 += 4;
                    args = [textRegion, header.referredTo, data2, position3, end];
                    break;
                  case 16:
                    const patternDictionary = {};
                    const patternDictionaryFlags = data2[position3++];
                    patternDictionary.mmr = !!(patternDictionaryFlags & 1);
                    patternDictionary.template = patternDictionaryFlags >> 1 & 3;
                    patternDictionary.patternWidth = data2[position3++];
                    patternDictionary.patternHeight = data2[position3++];
                    patternDictionary.maxPatternIndex = (0, _core_utils.readUint32)(data2, position3);
                    position3 += 4;
                    args = [patternDictionary, header.number, data2, position3, end];
                    break;
                  case 22:
                  case 23:
                    const halftoneRegion = {};
                    halftoneRegion.info = readRegionSegmentInformation(data2, position3);
                    position3 += RegionSegmentInformationFieldLength;
                    const halftoneRegionFlags = data2[position3++];
                    halftoneRegion.mmr = !!(halftoneRegionFlags & 1);
                    halftoneRegion.template = halftoneRegionFlags >> 1 & 3;
                    halftoneRegion.enableSkip = !!(halftoneRegionFlags & 8);
                    halftoneRegion.combinationOperator = halftoneRegionFlags >> 4 & 7;
                    halftoneRegion.defaultPixelValue = halftoneRegionFlags >> 7 & 1;
                    halftoneRegion.gridWidth = (0, _core_utils.readUint32)(data2, position3);
                    position3 += 4;
                    halftoneRegion.gridHeight = (0, _core_utils.readUint32)(data2, position3);
                    position3 += 4;
                    halftoneRegion.gridOffsetX = (0, _core_utils.readUint32)(data2, position3) & 4294967295;
                    position3 += 4;
                    halftoneRegion.gridOffsetY = (0, _core_utils.readUint32)(data2, position3) & 4294967295;
                    position3 += 4;
                    halftoneRegion.gridVectorX = (0, _core_utils.readUint16)(data2, position3);
                    position3 += 2;
                    halftoneRegion.gridVectorY = (0, _core_utils.readUint16)(data2, position3);
                    position3 += 2;
                    args = [halftoneRegion, header.referredTo, data2, position3, end];
                    break;
                  case 38:
                  case 39:
                    const genericRegion = {};
                    genericRegion.info = readRegionSegmentInformation(data2, position3);
                    position3 += RegionSegmentInformationFieldLength;
                    const genericRegionSegmentFlags = data2[position3++];
                    genericRegion.mmr = !!(genericRegionSegmentFlags & 1);
                    genericRegion.template = genericRegionSegmentFlags >> 1 & 3;
                    genericRegion.prediction = !!(genericRegionSegmentFlags & 8);
                    if (!genericRegion.mmr) {
                      atLength = genericRegion.template === 0 ? 4 : 1;
                      at2 = [];
                      for (i = 0; i < atLength; i++) {
                        at2.push({
                          x: (0, _core_utils.readInt8)(data2, position3),
                          y: (0, _core_utils.readInt8)(data2, position3 + 1)
                        });
                        position3 += 2;
                      }
                      genericRegion.at = at2;
                    }
                    args = [genericRegion, data2, position3, end];
                    break;
                  case 48:
                    const pageInfo = {
                      width: (0, _core_utils.readUint32)(data2, position3),
                      height: (0, _core_utils.readUint32)(data2, position3 + 4),
                      resolutionX: (0, _core_utils.readUint32)(data2, position3 + 8),
                      resolutionY: (0, _core_utils.readUint32)(data2, position3 + 12)
                    };
                    if (pageInfo.height === 4294967295) {
                      delete pageInfo.height;
                    }
                    const pageSegmentFlags = data2[position3 + 16];
                    (0, _core_utils.readUint16)(data2, position3 + 17);
                    pageInfo.lossless = !!(pageSegmentFlags & 1);
                    pageInfo.refinement = !!(pageSegmentFlags & 2);
                    pageInfo.defaultPixelValue = pageSegmentFlags >> 2 & 1;
                    pageInfo.combinationOperator = pageSegmentFlags >> 3 & 3;
                    pageInfo.requiresBuffer = !!(pageSegmentFlags & 32);
                    pageInfo.combinationOperatorOverride = !!(pageSegmentFlags & 64);
                    args = [pageInfo];
                    break;
                  case 49:
                    break;
                  case 50:
                    break;
                  case 51:
                    break;
                  case 53:
                    args = [header.number, data2, position3, end];
                    break;
                  case 62:
                    break;
                  default:
                    throw new Jbig2Error(`segment type ${header.typeName}(${header.type}) is not implemented`);
                }
                const callbackName = "on" + header.typeName;
                if (callbackName in visitor) {
                  visitor[callbackName].apply(visitor, args);
                }
              }
              function processSegments(segments, visitor) {
                for (let i = 0, ii = segments.length; i < ii; i++) {
                  processSegment(segments[i], visitor);
                }
              }
              function parseJbig2Chunks(chunks) {
                const visitor = new SimpleSegmentVisitor();
                for (let i = 0, ii = chunks.length; i < ii; i++) {
                  const chunk = chunks[i];
                  const segments = readSegments({}, chunk.data, chunk.start, chunk.end);
                  processSegments(segments, visitor);
                }
                return visitor.buffer;
              }
              function parseJbig2(data2) {
                throw new Error("Not implemented: parseJbig2");
              }
              class SimpleSegmentVisitor {
                onPageInformation(info) {
                  this.currentPageInfo = info;
                  const rowSize = info.width + 7 >> 3;
                  const buffer = new Uint8ClampedArray(rowSize * info.height);
                  if (info.defaultPixelValue) {
                    buffer.fill(255);
                  }
                  this.buffer = buffer;
                }
                drawBitmap(regionInfo, bitmap) {
                  const pageInfo = this.currentPageInfo;
                  const width = regionInfo.width, height = regionInfo.height;
                  const rowSize = pageInfo.width + 7 >> 3;
                  const combinationOperator = pageInfo.combinationOperatorOverride ? regionInfo.combinationOperator : pageInfo.combinationOperator;
                  const buffer = this.buffer;
                  const mask0 = 128 >> (regionInfo.x & 7);
                  let offset0 = regionInfo.y * rowSize + (regionInfo.x >> 3);
                  let i, j, mask, offset4;
                  switch (combinationOperator) {
                    case 0:
                      for (i = 0; i < height; i++) {
                        mask = mask0;
                        offset4 = offset0;
                        for (j = 0; j < width; j++) {
                          if (bitmap[i][j]) {
                            buffer[offset4] |= mask;
                          }
                          mask >>= 1;
                          if (!mask) {
                            mask = 128;
                            offset4++;
                          }
                        }
                        offset0 += rowSize;
                      }
                      break;
                    case 2:
                      for (i = 0; i < height; i++) {
                        mask = mask0;
                        offset4 = offset0;
                        for (j = 0; j < width; j++) {
                          if (bitmap[i][j]) {
                            buffer[offset4] ^= mask;
                          }
                          mask >>= 1;
                          if (!mask) {
                            mask = 128;
                            offset4++;
                          }
                        }
                        offset0 += rowSize;
                      }
                      break;
                    default:
                      throw new Jbig2Error(`operator ${combinationOperator} is not supported`);
                  }
                }
                onImmediateGenericRegion(region, data2, start, end) {
                  const regionInfo = region.info;
                  const decodingContext = new DecodingContext(data2, start, end);
                  const bitmap = decodeBitmap(region.mmr, regionInfo.width, regionInfo.height, region.template, region.prediction, null, region.at, decodingContext);
                  this.drawBitmap(regionInfo, bitmap);
                }
                onImmediateLosslessGenericRegion() {
                  this.onImmediateGenericRegion(...arguments);
                }
                onSymbolDictionary(dictionary, currentSegment, referredSegments, data2, start, end) {
                  let huffmanTables, huffmanInput;
                  if (dictionary.huffman) {
                    huffmanTables = getSymbolDictionaryHuffmanTables(dictionary, referredSegments, this.customTables);
                    huffmanInput = new Reader(data2, start, end);
                  }
                  let symbols = this.symbols;
                  if (!symbols) {
                    this.symbols = symbols = {};
                  }
                  const inputSymbols = [];
                  for (const referredSegment of referredSegments) {
                    const referredSymbols = symbols[referredSegment];
                    if (referredSymbols) {
                      inputSymbols.push(...referredSymbols);
                    }
                  }
                  const decodingContext = new DecodingContext(data2, start, end);
                  symbols[currentSegment] = decodeSymbolDictionary(dictionary.huffman, dictionary.refinement, inputSymbols, dictionary.numberOfNewSymbols, dictionary.numberOfExportedSymbols, huffmanTables, dictionary.template, dictionary.at, dictionary.refinementTemplate, dictionary.refinementAt, decodingContext, huffmanInput);
                }
                onImmediateTextRegion(region, referredSegments, data2, start, end) {
                  const regionInfo = region.info;
                  let huffmanTables, huffmanInput;
                  const symbols = this.symbols;
                  const inputSymbols = [];
                  for (const referredSegment of referredSegments) {
                    const referredSymbols = symbols[referredSegment];
                    if (referredSymbols) {
                      inputSymbols.push(...referredSymbols);
                    }
                  }
                  const symbolCodeLength = (0, _core_utils.log2)(inputSymbols.length);
                  if (region.huffman) {
                    huffmanInput = new Reader(data2, start, end);
                    huffmanTables = getTextRegionHuffmanTables(region, referredSegments, this.customTables, inputSymbols.length, huffmanInput);
                  }
                  const decodingContext = new DecodingContext(data2, start, end);
                  const bitmap = decodeTextRegion(region.huffman, region.refinement, regionInfo.width, regionInfo.height, region.defaultPixelValue, region.numberOfSymbolInstances, region.stripSize, inputSymbols, symbolCodeLength, region.transposed, region.dsOffset, region.referenceCorner, region.combinationOperator, huffmanTables, region.refinementTemplate, region.refinementAt, decodingContext, region.logStripSize, huffmanInput);
                  this.drawBitmap(regionInfo, bitmap);
                }
                onImmediateLosslessTextRegion() {
                  this.onImmediateTextRegion(...arguments);
                }
                onPatternDictionary(dictionary, currentSegment, data2, start, end) {
                  let patterns = this.patterns;
                  if (!patterns) {
                    this.patterns = patterns = {};
                  }
                  const decodingContext = new DecodingContext(data2, start, end);
                  patterns[currentSegment] = decodePatternDictionary(dictionary.mmr, dictionary.patternWidth, dictionary.patternHeight, dictionary.maxPatternIndex, dictionary.template, decodingContext);
                }
                onImmediateHalftoneRegion(region, referredSegments, data2, start, end) {
                  const patterns = this.patterns[referredSegments[0]];
                  const regionInfo = region.info;
                  const decodingContext = new DecodingContext(data2, start, end);
                  const bitmap = decodeHalftoneRegion(region.mmr, patterns, region.template, regionInfo.width, regionInfo.height, region.defaultPixelValue, region.enableSkip, region.combinationOperator, region.gridWidth, region.gridHeight, region.gridOffsetX, region.gridOffsetY, region.gridVectorX, region.gridVectorY, decodingContext);
                  this.drawBitmap(regionInfo, bitmap);
                }
                onImmediateLosslessHalftoneRegion() {
                  this.onImmediateHalftoneRegion(...arguments);
                }
                onTables(currentSegment, data2, start, end) {
                  let customTables = this.customTables;
                  if (!customTables) {
                    this.customTables = customTables = {};
                  }
                  customTables[currentSegment] = decodeTablesSegment(data2, start, end);
                }
              }
              class HuffmanLine {
                constructor(lineData) {
                  if (lineData.length === 2) {
                    this.isOOB = true;
                    this.rangeLow = 0;
                    this.prefixLength = lineData[0];
                    this.rangeLength = 0;
                    this.prefixCode = lineData[1];
                    this.isLowerRange = false;
                  } else {
                    this.isOOB = false;
                    this.rangeLow = lineData[0];
                    this.prefixLength = lineData[1];
                    this.rangeLength = lineData[2];
                    this.prefixCode = lineData[3];
                    this.isLowerRange = lineData[4] === "lower";
                  }
                }
              }
              class HuffmanTreeNode {
                constructor(line2) {
                  this.children = [];
                  if (line2) {
                    this.isLeaf = true;
                    this.rangeLength = line2.rangeLength;
                    this.rangeLow = line2.rangeLow;
                    this.isLowerRange = line2.isLowerRange;
                    this.isOOB = line2.isOOB;
                  } else {
                    this.isLeaf = false;
                  }
                }
                buildTree(line2, shift2) {
                  const bit = line2.prefixCode >> shift2 & 1;
                  if (shift2 <= 0) {
                    this.children[bit] = new HuffmanTreeNode(line2);
                  } else {
                    let node2 = this.children[bit];
                    if (!node2) {
                      this.children[bit] = node2 = new HuffmanTreeNode(null);
                    }
                    node2.buildTree(line2, shift2 - 1);
                  }
                }
                decodeNode(reader) {
                  if (this.isLeaf) {
                    if (this.isOOB) {
                      return null;
                    }
                    const htOffset = reader.readBits(this.rangeLength);
                    return this.rangeLow + (this.isLowerRange ? -htOffset : htOffset);
                  }
                  const node2 = this.children[reader.readBit()];
                  if (!node2) {
                    throw new Jbig2Error("invalid Huffman data");
                  }
                  return node2.decodeNode(reader);
                }
              }
              class HuffmanTable {
                constructor(lines, prefixCodesDone) {
                  if (!prefixCodesDone) {
                    this.assignPrefixCodes(lines);
                  }
                  this.rootNode = new HuffmanTreeNode(null);
                  for (let i = 0, ii = lines.length; i < ii; i++) {
                    const line2 = lines[i];
                    if (line2.prefixLength > 0) {
                      this.rootNode.buildTree(line2, line2.prefixLength - 1);
                    }
                  }
                }
                decode(reader) {
                  return this.rootNode.decodeNode(reader);
                }
                assignPrefixCodes(lines) {
                  const linesLength = lines.length;
                  let prefixLengthMax = 0;
                  for (let i = 0; i < linesLength; i++) {
                    prefixLengthMax = Math.max(prefixLengthMax, lines[i].prefixLength);
                  }
                  const histogram = new Uint32Array(prefixLengthMax + 1);
                  for (let i = 0; i < linesLength; i++) {
                    histogram[lines[i].prefixLength]++;
                  }
                  let currentLength = 1, firstCode = 0, currentCode, currentTemp, line2;
                  histogram[0] = 0;
                  while (currentLength <= prefixLengthMax) {
                    firstCode = firstCode + histogram[currentLength - 1] << 1;
                    currentCode = firstCode;
                    currentTemp = 0;
                    while (currentTemp < linesLength) {
                      line2 = lines[currentTemp];
                      if (line2.prefixLength === currentLength) {
                        line2.prefixCode = currentCode;
                        currentCode++;
                      }
                      currentTemp++;
                    }
                    currentLength++;
                  }
                }
              }
              function decodeTablesSegment(data2, start, end) {
                const flags = data2[start];
                const lowestValue = (0, _core_utils.readUint32)(data2, start + 1) & 4294967295;
                const highestValue = (0, _core_utils.readUint32)(data2, start + 5) & 4294967295;
                const reader = new Reader(data2, start + 9, end);
                const prefixSizeBits = (flags >> 1 & 7) + 1;
                const rangeSizeBits = (flags >> 4 & 7) + 1;
                const lines = [];
                let prefixLength, rangeLength, currentRangeLow = lowestValue;
                do {
                  prefixLength = reader.readBits(prefixSizeBits);
                  rangeLength = reader.readBits(rangeSizeBits);
                  lines.push(new HuffmanLine([currentRangeLow, prefixLength, rangeLength, 0]));
                  currentRangeLow += 1 << rangeLength;
                } while (currentRangeLow < highestValue);
                prefixLength = reader.readBits(prefixSizeBits);
                lines.push(new HuffmanLine([lowestValue - 1, prefixLength, 32, 0, "lower"]));
                prefixLength = reader.readBits(prefixSizeBits);
                lines.push(new HuffmanLine([highestValue, prefixLength, 32, 0]));
                if (flags & 1) {
                  prefixLength = reader.readBits(prefixSizeBits);
                  lines.push(new HuffmanLine([prefixLength, 0]));
                }
                return new HuffmanTable(lines, false);
              }
              const standardTablesCache = {};
              function getStandardTable(number4) {
                let table = standardTablesCache[number4];
                if (table) {
                  return table;
                }
                let lines;
                switch (number4) {
                  case 1:
                    lines = [[0, 1, 4, 0], [16, 2, 8, 2], [272, 3, 16, 6], [65808, 3, 32, 7]];
                    break;
                  case 2:
                    lines = [[0, 1, 0, 0], [1, 2, 0, 2], [2, 3, 0, 6], [3, 4, 3, 14], [11, 5, 6, 30], [75, 6, 32, 62], [6, 63]];
                    break;
                  case 3:
                    lines = [[-256, 8, 8, 254], [0, 1, 0, 0], [1, 2, 0, 2], [2, 3, 0, 6], [3, 4, 3, 14], [11, 5, 6, 30], [-257, 8, 32, 255, "lower"], [75, 7, 32, 126], [6, 62]];
                    break;
                  case 4:
                    lines = [[1, 1, 0, 0], [2, 2, 0, 2], [3, 3, 0, 6], [4, 4, 3, 14], [12, 5, 6, 30], [76, 5, 32, 31]];
                    break;
                  case 5:
                    lines = [[-255, 7, 8, 126], [1, 1, 0, 0], [2, 2, 0, 2], [3, 3, 0, 6], [4, 4, 3, 14], [12, 5, 6, 30], [-256, 7, 32, 127, "lower"], [76, 6, 32, 62]];
                    break;
                  case 6:
                    lines = [[-2048, 5, 10, 28], [-1024, 4, 9, 8], [-512, 4, 8, 9], [-256, 4, 7, 10], [-128, 5, 6, 29], [-64, 5, 5, 30], [-32, 4, 5, 11], [0, 2, 7, 0], [128, 3, 7, 2], [256, 3, 8, 3], [512, 4, 9, 12], [1024, 4, 10, 13], [-2049, 6, 32, 62, "lower"], [2048, 6, 32, 63]];
                    break;
                  case 7:
                    lines = [[-1024, 4, 9, 8], [-512, 3, 8, 0], [-256, 4, 7, 9], [-128, 5, 6, 26], [-64, 5, 5, 27], [-32, 4, 5, 10], [0, 4, 5, 11], [32, 5, 5, 28], [64, 5, 6, 29], [128, 4, 7, 12], [256, 3, 8, 1], [512, 3, 9, 2], [1024, 3, 10, 3], [-1025, 5, 32, 30, "lower"], [2048, 5, 32, 31]];
                    break;
                  case 8:
                    lines = [[-15, 8, 3, 252], [-7, 9, 1, 508], [-5, 8, 1, 253], [-3, 9, 0, 509], [-2, 7, 0, 124], [-1, 4, 0, 10], [0, 2, 1, 0], [2, 5, 0, 26], [3, 6, 0, 58], [4, 3, 4, 4], [20, 6, 1, 59], [22, 4, 4, 11], [38, 4, 5, 12], [70, 5, 6, 27], [134, 5, 7, 28], [262, 6, 7, 60], [390, 7, 8, 125], [646, 6, 10, 61], [-16, 9, 32, 510, "lower"], [1670, 9, 32, 511], [2, 1]];
                    break;
                  case 9:
                    lines = [[-31, 8, 4, 252], [-15, 9, 2, 508], [-11, 8, 2, 253], [-7, 9, 1, 509], [-5, 7, 1, 124], [-3, 4, 1, 10], [-1, 3, 1, 2], [1, 3, 1, 3], [3, 5, 1, 26], [5, 6, 1, 58], [7, 3, 5, 4], [39, 6, 2, 59], [43, 4, 5, 11], [75, 4, 6, 12], [139, 5, 7, 27], [267, 5, 8, 28], [523, 6, 8, 60], [779, 7, 9, 125], [1291, 6, 11, 61], [-32, 9, 32, 510, "lower"], [3339, 9, 32, 511], [2, 0]];
                    break;
                  case 10:
                    lines = [[-21, 7, 4, 122], [-5, 8, 0, 252], [-4, 7, 0, 123], [-3, 5, 0, 24], [-2, 2, 2, 0], [2, 5, 0, 25], [3, 6, 0, 54], [4, 7, 0, 124], [5, 8, 0, 253], [6, 2, 6, 1], [70, 5, 5, 26], [102, 6, 5, 55], [134, 6, 6, 56], [198, 6, 7, 57], [326, 6, 8, 58], [582, 6, 9, 59], [1094, 6, 10, 60], [2118, 7, 11, 125], [-22, 8, 32, 254, "lower"], [4166, 8, 32, 255], [2, 2]];
                    break;
                  case 11:
                    lines = [[1, 1, 0, 0], [2, 2, 1, 2], [4, 4, 0, 12], [5, 4, 1, 13], [7, 5, 1, 28], [9, 5, 2, 29], [13, 6, 2, 60], [17, 7, 2, 122], [21, 7, 3, 123], [29, 7, 4, 124], [45, 7, 5, 125], [77, 7, 6, 126], [141, 7, 32, 127]];
                    break;
                  case 12:
                    lines = [[1, 1, 0, 0], [2, 2, 0, 2], [3, 3, 1, 6], [5, 5, 0, 28], [6, 5, 1, 29], [8, 6, 1, 60], [10, 7, 0, 122], [11, 7, 1, 123], [13, 7, 2, 124], [17, 7, 3, 125], [25, 7, 4, 126], [41, 8, 5, 254], [73, 8, 32, 255]];
                    break;
                  case 13:
                    lines = [[1, 1, 0, 0], [2, 3, 0, 4], [3, 4, 0, 12], [4, 5, 0, 28], [5, 4, 1, 13], [7, 3, 3, 5], [15, 6, 1, 58], [17, 6, 2, 59], [21, 6, 3, 60], [29, 6, 4, 61], [45, 6, 5, 62], [77, 7, 6, 126], [141, 7, 32, 127]];
                    break;
                  case 14:
                    lines = [[-2, 3, 0, 4], [-1, 3, 0, 5], [0, 1, 0, 0], [1, 3, 0, 6], [2, 3, 0, 7]];
                    break;
                  case 15:
                    lines = [[-24, 7, 4, 124], [-8, 6, 2, 60], [-4, 5, 1, 28], [-2, 4, 0, 12], [-1, 3, 0, 4], [0, 1, 0, 0], [1, 3, 0, 5], [2, 4, 0, 13], [3, 5, 1, 29], [5, 6, 2, 61], [9, 7, 4, 125], [-25, 7, 32, 126, "lower"], [25, 7, 32, 127]];
                    break;
                  default:
                    throw new Jbig2Error(`standard table B.${number4} does not exist`);
                }
                for (let i = 0, ii = lines.length; i < ii; i++) {
                  lines[i] = new HuffmanLine(lines[i]);
                }
                table = new HuffmanTable(lines, true);
                standardTablesCache[number4] = table;
                return table;
              }
              class Reader {
                constructor(data2, start, end) {
                  this.data = data2;
                  this.start = start;
                  this.end = end;
                  this.position = start;
                  this.shift = -1;
                  this.currentByte = 0;
                }
                readBit() {
                  if (this.shift < 0) {
                    if (this.position >= this.end) {
                      throw new Jbig2Error("end of data while reading bit");
                    }
                    this.currentByte = this.data[this.position++];
                    this.shift = 7;
                  }
                  const bit = this.currentByte >> this.shift & 1;
                  this.shift--;
                  return bit;
                }
                readBits(numBits) {
                  let result = 0, i;
                  for (i = numBits - 1; i >= 0; i--) {
                    result |= this.readBit() << i;
                  }
                  return result;
                }
                byteAlign() {
                  this.shift = -1;
                }
                next() {
                  if (this.position >= this.end) {
                    return -1;
                  }
                  return this.data[this.position++];
                }
              }
              function getCustomHuffmanTable(index3, referredTo, customTables) {
                let currentIndex = 0;
                for (let i = 0, ii = referredTo.length; i < ii; i++) {
                  const table = customTables[referredTo[i]];
                  if (table) {
                    if (index3 === currentIndex) {
                      return table;
                    }
                    currentIndex++;
                  }
                }
                throw new Jbig2Error("can't find custom Huffman table");
              }
              function getTextRegionHuffmanTables(textRegion, referredTo, customTables, numberOfSymbols, reader) {
                const codes = [];
                for (let i = 0; i <= 34; i++) {
                  const codeLength = reader.readBits(4);
                  codes.push(new HuffmanLine([i, codeLength, 0, 0]));
                }
                const runCodesTable = new HuffmanTable(codes, false);
                codes.length = 0;
                for (let i = 0; i < numberOfSymbols; ) {
                  const codeLength = runCodesTable.decode(reader);
                  if (codeLength >= 32) {
                    let repeatedLength, numberOfRepeats, j;
                    switch (codeLength) {
                      case 32:
                        if (i === 0) {
                          throw new Jbig2Error("no previous value in symbol ID table");
                        }
                        numberOfRepeats = reader.readBits(2) + 3;
                        repeatedLength = codes[i - 1].prefixLength;
                        break;
                      case 33:
                        numberOfRepeats = reader.readBits(3) + 3;
                        repeatedLength = 0;
                        break;
                      case 34:
                        numberOfRepeats = reader.readBits(7) + 11;
                        repeatedLength = 0;
                        break;
                      default:
                        throw new Jbig2Error("invalid code length in symbol ID table");
                    }
                    for (j = 0; j < numberOfRepeats; j++) {
                      codes.push(new HuffmanLine([i, repeatedLength, 0, 0]));
                      i++;
                    }
                  } else {
                    codes.push(new HuffmanLine([i, codeLength, 0, 0]));
                    i++;
                  }
                }
                reader.byteAlign();
                const symbolIDTable = new HuffmanTable(codes, false);
                let customIndex = 0, tableFirstS, tableDeltaS, tableDeltaT;
                switch (textRegion.huffmanFS) {
                  case 0:
                  case 1:
                    tableFirstS = getStandardTable(textRegion.huffmanFS + 6);
                    break;
                  case 3:
                    tableFirstS = getCustomHuffmanTable(customIndex, referredTo, customTables);
                    customIndex++;
                    break;
                  default:
                    throw new Jbig2Error("invalid Huffman FS selector");
                }
                switch (textRegion.huffmanDS) {
                  case 0:
                  case 1:
                  case 2:
                    tableDeltaS = getStandardTable(textRegion.huffmanDS + 8);
                    break;
                  case 3:
                    tableDeltaS = getCustomHuffmanTable(customIndex, referredTo, customTables);
                    customIndex++;
                    break;
                  default:
                    throw new Jbig2Error("invalid Huffman DS selector");
                }
                switch (textRegion.huffmanDT) {
                  case 0:
                  case 1:
                  case 2:
                    tableDeltaT = getStandardTable(textRegion.huffmanDT + 11);
                    break;
                  case 3:
                    tableDeltaT = getCustomHuffmanTable(customIndex, referredTo, customTables);
                    customIndex++;
                    break;
                  default:
                    throw new Jbig2Error("invalid Huffman DT selector");
                }
                if (textRegion.refinement) {
                  throw new Jbig2Error("refinement with Huffman is not supported");
                }
                return {
                  symbolIDTable,
                  tableFirstS,
                  tableDeltaS,
                  tableDeltaT
                };
              }
              function getSymbolDictionaryHuffmanTables(dictionary, referredTo, customTables) {
                let customIndex = 0, tableDeltaHeight, tableDeltaWidth;
                switch (dictionary.huffmanDHSelector) {
                  case 0:
                  case 1:
                    tableDeltaHeight = getStandardTable(dictionary.huffmanDHSelector + 4);
                    break;
                  case 3:
                    tableDeltaHeight = getCustomHuffmanTable(customIndex, referredTo, customTables);
                    customIndex++;
                    break;
                  default:
                    throw new Jbig2Error("invalid Huffman DH selector");
                }
                switch (dictionary.huffmanDWSelector) {
                  case 0:
                  case 1:
                    tableDeltaWidth = getStandardTable(dictionary.huffmanDWSelector + 2);
                    break;
                  case 3:
                    tableDeltaWidth = getCustomHuffmanTable(customIndex, referredTo, customTables);
                    customIndex++;
                    break;
                  default:
                    throw new Jbig2Error("invalid Huffman DW selector");
                }
                let tableBitmapSize, tableAggregateInstances;
                if (dictionary.bitmapSizeSelector) {
                  tableBitmapSize = getCustomHuffmanTable(customIndex, referredTo, customTables);
                  customIndex++;
                } else {
                  tableBitmapSize = getStandardTable(1);
                }
                if (dictionary.aggregationInstancesSelector) {
                  tableAggregateInstances = getCustomHuffmanTable(customIndex, referredTo, customTables);
                } else {
                  tableAggregateInstances = getStandardTable(1);
                }
                return {
                  tableDeltaHeight,
                  tableDeltaWidth,
                  tableBitmapSize,
                  tableAggregateInstances
                };
              }
              function readUncompressedBitmap(reader, width, height) {
                const bitmap = [];
                for (let y = 0; y < height; y++) {
                  const row = new Uint8Array(width);
                  bitmap.push(row);
                  for (let x = 0; x < width; x++) {
                    row[x] = reader.readBit();
                  }
                  reader.byteAlign();
                }
                return bitmap;
              }
              function decodeMMRBitmap(input, width, height, endOfBlock) {
                const params = {
                  K: -1,
                  Columns: width,
                  Rows: height,
                  BlackIs1: true,
                  EndOfBlock: endOfBlock
                };
                const decoder = new _ccitt.CCITTFaxDecoder(input, params);
                const bitmap = [];
                let currentByte, eof = false;
                for (let y = 0; y < height; y++) {
                  const row = new Uint8Array(width);
                  bitmap.push(row);
                  let shift2 = -1;
                  for (let x = 0; x < width; x++) {
                    if (shift2 < 0) {
                      currentByte = decoder.readNextChar();
                      if (currentByte === -1) {
                        currentByte = 0;
                        eof = true;
                      }
                      shift2 = 7;
                    }
                    row[x] = currentByte >> shift2 & 1;
                    shift2--;
                  }
                }
                if (endOfBlock && !eof) {
                  const lookForEOFLimit = 5;
                  for (let i = 0; i < lookForEOFLimit; i++) {
                    if (decoder.readNextChar() === -1) {
                      break;
                    }
                  }
                }
                return bitmap;
              }
              class Jbig2Image {
                parseChunks(chunks) {
                  return parseJbig2Chunks(chunks);
                }
                parse(data2) {
                  throw new Error("Not implemented: Jbig2Image.parse");
                }
              }
              exports3.Jbig2Image = Jbig2Image;
            }),
            /* 25 */
            /***/
            ((__unused_webpack_module2, exports3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.ArithmeticDecoder = void 0;
              const QeTable = [{
                qe: 22017,
                nmps: 1,
                nlps: 1,
                switchFlag: 1
              }, {
                qe: 13313,
                nmps: 2,
                nlps: 6,
                switchFlag: 0
              }, {
                qe: 6145,
                nmps: 3,
                nlps: 9,
                switchFlag: 0
              }, {
                qe: 2753,
                nmps: 4,
                nlps: 12,
                switchFlag: 0
              }, {
                qe: 1313,
                nmps: 5,
                nlps: 29,
                switchFlag: 0
              }, {
                qe: 545,
                nmps: 38,
                nlps: 33,
                switchFlag: 0
              }, {
                qe: 22017,
                nmps: 7,
                nlps: 6,
                switchFlag: 1
              }, {
                qe: 21505,
                nmps: 8,
                nlps: 14,
                switchFlag: 0
              }, {
                qe: 18433,
                nmps: 9,
                nlps: 14,
                switchFlag: 0
              }, {
                qe: 14337,
                nmps: 10,
                nlps: 14,
                switchFlag: 0
              }, {
                qe: 12289,
                nmps: 11,
                nlps: 17,
                switchFlag: 0
              }, {
                qe: 9217,
                nmps: 12,
                nlps: 18,
                switchFlag: 0
              }, {
                qe: 7169,
                nmps: 13,
                nlps: 20,
                switchFlag: 0
              }, {
                qe: 5633,
                nmps: 29,
                nlps: 21,
                switchFlag: 0
              }, {
                qe: 22017,
                nmps: 15,
                nlps: 14,
                switchFlag: 1
              }, {
                qe: 21505,
                nmps: 16,
                nlps: 14,
                switchFlag: 0
              }, {
                qe: 20737,
                nmps: 17,
                nlps: 15,
                switchFlag: 0
              }, {
                qe: 18433,
                nmps: 18,
                nlps: 16,
                switchFlag: 0
              }, {
                qe: 14337,
                nmps: 19,
                nlps: 17,
                switchFlag: 0
              }, {
                qe: 13313,
                nmps: 20,
                nlps: 18,
                switchFlag: 0
              }, {
                qe: 12289,
                nmps: 21,
                nlps: 19,
                switchFlag: 0
              }, {
                qe: 10241,
                nmps: 22,
                nlps: 19,
                switchFlag: 0
              }, {
                qe: 9217,
                nmps: 23,
                nlps: 20,
                switchFlag: 0
              }, {
                qe: 8705,
                nmps: 24,
                nlps: 21,
                switchFlag: 0
              }, {
                qe: 7169,
                nmps: 25,
                nlps: 22,
                switchFlag: 0
              }, {
                qe: 6145,
                nmps: 26,
                nlps: 23,
                switchFlag: 0
              }, {
                qe: 5633,
                nmps: 27,
                nlps: 24,
                switchFlag: 0
              }, {
                qe: 5121,
                nmps: 28,
                nlps: 25,
                switchFlag: 0
              }, {
                qe: 4609,
                nmps: 29,
                nlps: 26,
                switchFlag: 0
              }, {
                qe: 4353,
                nmps: 30,
                nlps: 27,
                switchFlag: 0
              }, {
                qe: 2753,
                nmps: 31,
                nlps: 28,
                switchFlag: 0
              }, {
                qe: 2497,
                nmps: 32,
                nlps: 29,
                switchFlag: 0
              }, {
                qe: 2209,
                nmps: 33,
                nlps: 30,
                switchFlag: 0
              }, {
                qe: 1313,
                nmps: 34,
                nlps: 31,
                switchFlag: 0
              }, {
                qe: 1089,
                nmps: 35,
                nlps: 32,
                switchFlag: 0
              }, {
                qe: 673,
                nmps: 36,
                nlps: 33,
                switchFlag: 0
              }, {
                qe: 545,
                nmps: 37,
                nlps: 34,
                switchFlag: 0
              }, {
                qe: 321,
                nmps: 38,
                nlps: 35,
                switchFlag: 0
              }, {
                qe: 273,
                nmps: 39,
                nlps: 36,
                switchFlag: 0
              }, {
                qe: 133,
                nmps: 40,
                nlps: 37,
                switchFlag: 0
              }, {
                qe: 73,
                nmps: 41,
                nlps: 38,
                switchFlag: 0
              }, {
                qe: 37,
                nmps: 42,
                nlps: 39,
                switchFlag: 0
              }, {
                qe: 21,
                nmps: 43,
                nlps: 40,
                switchFlag: 0
              }, {
                qe: 9,
                nmps: 44,
                nlps: 41,
                switchFlag: 0
              }, {
                qe: 5,
                nmps: 45,
                nlps: 42,
                switchFlag: 0
              }, {
                qe: 1,
                nmps: 45,
                nlps: 43,
                switchFlag: 0
              }, {
                qe: 22017,
                nmps: 46,
                nlps: 46,
                switchFlag: 0
              }];
              class ArithmeticDecoder {
                constructor(data2, start, end) {
                  this.data = data2;
                  this.bp = start;
                  this.dataEnd = end;
                  this.chigh = data2[start];
                  this.clow = 0;
                  this.byteIn();
                  this.chigh = this.chigh << 7 & 65535 | this.clow >> 9 & 127;
                  this.clow = this.clow << 7 & 65535;
                  this.ct -= 7;
                  this.a = 32768;
                }
                byteIn() {
                  const data2 = this.data;
                  let bp = this.bp;
                  if (data2[bp] === 255) {
                    if (data2[bp + 1] > 143) {
                      this.clow += 65280;
                      this.ct = 8;
                    } else {
                      bp++;
                      this.clow += data2[bp] << 9;
                      this.ct = 7;
                      this.bp = bp;
                    }
                  } else {
                    bp++;
                    this.clow += bp < this.dataEnd ? data2[bp] << 8 : 65280;
                    this.ct = 8;
                    this.bp = bp;
                  }
                  if (this.clow > 65535) {
                    this.chigh += this.clow >> 16;
                    this.clow &= 65535;
                  }
                }
                readBit(contexts, pos) {
                  let cx_index = contexts[pos] >> 1, cx_mps = contexts[pos] & 1;
                  const qeTableIcx = QeTable[cx_index];
                  const qeIcx = qeTableIcx.qe;
                  let d;
                  let a = this.a - qeIcx;
                  if (this.chigh < qeIcx) {
                    if (a < qeIcx) {
                      a = qeIcx;
                      d = cx_mps;
                      cx_index = qeTableIcx.nmps;
                    } else {
                      a = qeIcx;
                      d = 1 ^ cx_mps;
                      if (qeTableIcx.switchFlag === 1) {
                        cx_mps = d;
                      }
                      cx_index = qeTableIcx.nlps;
                    }
                  } else {
                    this.chigh -= qeIcx;
                    if ((a & 32768) !== 0) {
                      this.a = a;
                      return cx_mps;
                    }
                    if (a < qeIcx) {
                      d = 1 ^ cx_mps;
                      if (qeTableIcx.switchFlag === 1) {
                        cx_mps = d;
                      }
                      cx_index = qeTableIcx.nlps;
                    } else {
                      d = cx_mps;
                      cx_index = qeTableIcx.nmps;
                    }
                  }
                  do {
                    if (this.ct === 0) {
                      this.byteIn();
                    }
                    a <<= 1;
                    this.chigh = this.chigh << 1 & 65535 | this.clow >> 15 & 1;
                    this.clow = this.clow << 1 & 65535;
                    this.ct--;
                  } while ((a & 32768) === 0);
                  this.a = a;
                  contexts[pos] = cx_index << 1 | cx_mps;
                  return d;
                }
              }
              exports3.ArithmeticDecoder = ArithmeticDecoder;
            }),
            /* 26 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.JpegStream = void 0;
              var _decode_stream = __w_pdfjs_require__3(18);
              var _primitives = __w_pdfjs_require__3(4);
              var _jpg = __w_pdfjs_require__3(27);
              var _util2 = __w_pdfjs_require__3(2);
              class JpegStream extends _decode_stream.DecodeStream {
                constructor(stream, maybeLength, params) {
                  let ch;
                  while ((ch = stream.getByte()) !== -1) {
                    if (ch === 255) {
                      stream.skip(-1);
                      break;
                    }
                  }
                  super(maybeLength);
                  this.stream = stream;
                  this.dict = stream.dict;
                  this.maybeLength = maybeLength;
                  this.params = params;
                }
                get bytes() {
                  return (0, _util2.shadow)(this, "bytes", this.stream.getBytes(this.maybeLength));
                }
                ensureBuffer(requested) {
                }
                readBlock() {
                  if (this.eof) {
                    return;
                  }
                  const jpegOptions = {
                    decodeTransform: void 0,
                    colorTransform: void 0
                  };
                  const decodeArr = this.dict.getArray("D", "Decode");
                  if ((this.forceRGBA || this.forceRGB) && Array.isArray(decodeArr)) {
                    const bitsPerComponent = this.dict.get("BPC", "BitsPerComponent") || 8;
                    const decodeArrLength = decodeArr.length;
                    const transform = new Int32Array(decodeArrLength);
                    let transformNeeded = false;
                    const maxValue = (1 << bitsPerComponent) - 1;
                    for (let i = 0; i < decodeArrLength; i += 2) {
                      transform[i] = (decodeArr[i + 1] - decodeArr[i]) * 256 | 0;
                      transform[i + 1] = decodeArr[i] * maxValue | 0;
                      if (transform[i] !== 256 || transform[i + 1] !== 0) {
                        transformNeeded = true;
                      }
                    }
                    if (transformNeeded) {
                      jpegOptions.decodeTransform = transform;
                    }
                  }
                  if (this.params instanceof _primitives.Dict) {
                    const colorTransform = this.params.get("ColorTransform");
                    if (Number.isInteger(colorTransform)) {
                      jpegOptions.colorTransform = colorTransform;
                    }
                  }
                  const jpegImage = new _jpg.JpegImage(jpegOptions);
                  jpegImage.parse(this.bytes);
                  const data2 = jpegImage.getData({
                    width: this.drawWidth,
                    height: this.drawHeight,
                    forceRGBA: this.forceRGBA,
                    forceRGB: this.forceRGB,
                    isSourcePDF: true
                  });
                  this.buffer = data2;
                  this.bufferLength = data2.length;
                  this.eof = true;
                }
              }
              exports3.JpegStream = JpegStream;
            }),
            /* 27 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.JpegImage = void 0;
              var _util2 = __w_pdfjs_require__3(2);
              var _image_utils = __w_pdfjs_require__3(28);
              var _core_utils = __w_pdfjs_require__3(3);
              class JpegError extends _util2.BaseException {
                constructor(msg) {
                  super(`JPEG error: ${msg}`, "JpegError");
                }
              }
              class DNLMarkerError extends _util2.BaseException {
                constructor(message2, scanLines) {
                  super(message2, "DNLMarkerError");
                  this.scanLines = scanLines;
                }
              }
              class EOIMarkerError extends _util2.BaseException {
                constructor(msg) {
                  super(msg, "EOIMarkerError");
                }
              }
              const dctZigZag = new Uint8Array([0, 1, 8, 16, 9, 2, 3, 10, 17, 24, 32, 25, 18, 11, 4, 5, 12, 19, 26, 33, 40, 48, 41, 34, 27, 20, 13, 6, 7, 14, 21, 28, 35, 42, 49, 56, 57, 50, 43, 36, 29, 22, 15, 23, 30, 37, 44, 51, 58, 59, 52, 45, 38, 31, 39, 46, 53, 60, 61, 54, 47, 55, 62, 63]);
              const dctCos1 = 4017;
              const dctSin1 = 799;
              const dctCos3 = 3406;
              const dctSin3 = 2276;
              const dctCos6 = 1567;
              const dctSin6 = 3784;
              const dctSqrt2 = 5793;
              const dctSqrt1d2 = 2896;
              function buildHuffmanTable(codeLengths, values) {
                let k = 0, i, j, length2 = 16;
                while (length2 > 0 && !codeLengths[length2 - 1]) {
                  length2--;
                }
                const code2 = [{
                  children: [],
                  index: 0
                }];
                let p = code2[0], q;
                for (i = 0; i < length2; i++) {
                  for (j = 0; j < codeLengths[i]; j++) {
                    p = code2.pop();
                    p.children[p.index] = values[k];
                    while (p.index > 0) {
                      p = code2.pop();
                    }
                    p.index++;
                    code2.push(p);
                    while (code2.length <= i) {
                      code2.push(q = {
                        children: [],
                        index: 0
                      });
                      p.children[p.index] = q.children;
                      p = q;
                    }
                    k++;
                  }
                  if (i + 1 < length2) {
                    code2.push(q = {
                      children: [],
                      index: 0
                    });
                    p.children[p.index] = q.children;
                    p = q;
                  }
                }
                return code2[0].children;
              }
              function getBlockBufferOffset(component, row, col) {
                return 64 * ((component.blocksPerLine + 1) * row + col);
              }
              function decodeScan(data2, offset4, frame, components, resetInterval, spectralStart, spectralEnd, successivePrev, successive, parseDNLMarker = false) {
                const mcusPerLine = frame.mcusPerLine;
                const progressive = frame.progressive;
                const startOffset = offset4;
                let bitsData = 0, bitsCount = 0;
                function readBit() {
                  if (bitsCount > 0) {
                    bitsCount--;
                    return bitsData >> bitsCount & 1;
                  }
                  bitsData = data2[offset4++];
                  if (bitsData === 255) {
                    const nextByte = data2[offset4++];
                    if (nextByte) {
                      if (nextByte === 220 && parseDNLMarker) {
                        offset4 += 2;
                        const scanLines = (0, _core_utils.readUint16)(data2, offset4);
                        offset4 += 2;
                        if (scanLines > 0 && scanLines !== frame.scanLines) {
                          throw new DNLMarkerError("Found DNL marker (0xFFDC) while parsing scan data", scanLines);
                        }
                      } else if (nextByte === 217) {
                        if (parseDNLMarker) {
                          const maybeScanLines = blockRow * (frame.precision === 8 ? 8 : 0);
                          if (maybeScanLines > 0 && Math.round(frame.scanLines / maybeScanLines) >= 5) {
                            throw new DNLMarkerError("Found EOI marker (0xFFD9) while parsing scan data, possibly caused by incorrect `scanLines` parameter", maybeScanLines);
                          }
                        }
                        throw new EOIMarkerError("Found EOI marker (0xFFD9) while parsing scan data");
                      }
                      throw new JpegError(`unexpected marker ${(bitsData << 8 | nextByte).toString(16)}`);
                    }
                  }
                  bitsCount = 7;
                  return bitsData >>> 7;
                }
                function decodeHuffman(tree) {
                  let node2 = tree;
                  while (true) {
                    node2 = node2[readBit()];
                    switch (typeof node2) {
                      case "number":
                        return node2;
                      case "object":
                        continue;
                    }
                    throw new JpegError("invalid huffman sequence");
                  }
                }
                function receive(length2) {
                  let n3 = 0;
                  while (length2 > 0) {
                    n3 = n3 << 1 | readBit();
                    length2--;
                  }
                  return n3;
                }
                function receiveAndExtend(length2) {
                  if (length2 === 1) {
                    return readBit() === 1 ? 1 : -1;
                  }
                  const n3 = receive(length2);
                  if (n3 >= 1 << length2 - 1) {
                    return n3;
                  }
                  return n3 + (-1 << length2) + 1;
                }
                function decodeBaseline(component2, blockOffset) {
                  const t2 = decodeHuffman(component2.huffmanTableDC);
                  const diff3 = t2 === 0 ? 0 : receiveAndExtend(t2);
                  component2.blockData[blockOffset] = component2.pred += diff3;
                  let k2 = 1;
                  while (k2 < 64) {
                    const rs = decodeHuffman(component2.huffmanTableAC);
                    const s = rs & 15, r2 = rs >> 4;
                    if (s === 0) {
                      if (r2 < 15) {
                        break;
                      }
                      k2 += 16;
                      continue;
                    }
                    k2 += r2;
                    const z = dctZigZag[k2];
                    component2.blockData[blockOffset + z] = receiveAndExtend(s);
                    k2++;
                  }
                }
                function decodeDCFirst(component2, blockOffset) {
                  const t2 = decodeHuffman(component2.huffmanTableDC);
                  const diff3 = t2 === 0 ? 0 : receiveAndExtend(t2) << successive;
                  component2.blockData[blockOffset] = component2.pred += diff3;
                }
                function decodeDCSuccessive(component2, blockOffset) {
                  component2.blockData[blockOffset] |= readBit() << successive;
                }
                let eobrun = 0;
                function decodeACFirst(component2, blockOffset) {
                  if (eobrun > 0) {
                    eobrun--;
                    return;
                  }
                  let k2 = spectralStart;
                  const e3 = spectralEnd;
                  while (k2 <= e3) {
                    const rs = decodeHuffman(component2.huffmanTableAC);
                    const s = rs & 15, r2 = rs >> 4;
                    if (s === 0) {
                      if (r2 < 15) {
                        eobrun = receive(r2) + (1 << r2) - 1;
                        break;
                      }
                      k2 += 16;
                      continue;
                    }
                    k2 += r2;
                    const z = dctZigZag[k2];
                    component2.blockData[blockOffset + z] = receiveAndExtend(s) * (1 << successive);
                    k2++;
                  }
                }
                let successiveACState = 0, successiveACNextValue;
                function decodeACSuccessive(component2, blockOffset) {
                  let k2 = spectralStart;
                  const e3 = spectralEnd;
                  let r2 = 0;
                  let s;
                  let rs;
                  while (k2 <= e3) {
                    const offsetZ = blockOffset + dctZigZag[k2];
                    const sign2 = component2.blockData[offsetZ] < 0 ? -1 : 1;
                    switch (successiveACState) {
                      case 0:
                        rs = decodeHuffman(component2.huffmanTableAC);
                        s = rs & 15;
                        r2 = rs >> 4;
                        if (s === 0) {
                          if (r2 < 15) {
                            eobrun = receive(r2) + (1 << r2);
                            successiveACState = 4;
                          } else {
                            r2 = 16;
                            successiveACState = 1;
                          }
                        } else {
                          if (s !== 1) {
                            throw new JpegError("invalid ACn encoding");
                          }
                          successiveACNextValue = receiveAndExtend(s);
                          successiveACState = r2 ? 2 : 3;
                        }
                        continue;
                      case 1:
                      case 2:
                        if (component2.blockData[offsetZ]) {
                          component2.blockData[offsetZ] += sign2 * (readBit() << successive);
                        } else {
                          r2--;
                          if (r2 === 0) {
                            successiveACState = successiveACState === 2 ? 3 : 0;
                          }
                        }
                        break;
                      case 3:
                        if (component2.blockData[offsetZ]) {
                          component2.blockData[offsetZ] += sign2 * (readBit() << successive);
                        } else {
                          component2.blockData[offsetZ] = successiveACNextValue << successive;
                          successiveACState = 0;
                        }
                        break;
                      case 4:
                        if (component2.blockData[offsetZ]) {
                          component2.blockData[offsetZ] += sign2 * (readBit() << successive);
                        }
                        break;
                    }
                    k2++;
                  }
                  if (successiveACState === 4) {
                    eobrun--;
                    if (eobrun === 0) {
                      successiveACState = 0;
                    }
                  }
                }
                let blockRow = 0;
                function decodeMcu(component2, decode, mcu2, row, col) {
                  const mcuRow = mcu2 / mcusPerLine | 0;
                  const mcuCol = mcu2 % mcusPerLine;
                  blockRow = mcuRow * component2.v + row;
                  const blockCol = mcuCol * component2.h + col;
                  const blockOffset = getBlockBufferOffset(component2, blockRow, blockCol);
                  decode(component2, blockOffset);
                }
                function decodeBlock(component2, decode, mcu2) {
                  blockRow = mcu2 / component2.blocksPerLine | 0;
                  const blockCol = mcu2 % component2.blocksPerLine;
                  const blockOffset = getBlockBufferOffset(component2, blockRow, blockCol);
                  decode(component2, blockOffset);
                }
                const componentsLength = components.length;
                let component, i, j, k, n2;
                let decodeFn;
                if (progressive) {
                  if (spectralStart === 0) {
                    decodeFn = successivePrev === 0 ? decodeDCFirst : decodeDCSuccessive;
                  } else {
                    decodeFn = successivePrev === 0 ? decodeACFirst : decodeACSuccessive;
                  }
                } else {
                  decodeFn = decodeBaseline;
                }
                let mcu = 0, fileMarker;
                const mcuExpected = componentsLength === 1 ? components[0].blocksPerLine * components[0].blocksPerColumn : mcusPerLine * frame.mcusPerColumn;
                let h2, v;
                while (mcu <= mcuExpected) {
                  const mcuToRead = resetInterval ? Math.min(mcuExpected - mcu, resetInterval) : mcuExpected;
                  if (mcuToRead > 0) {
                    for (i = 0; i < componentsLength; i++) {
                      components[i].pred = 0;
                    }
                    eobrun = 0;
                    if (componentsLength === 1) {
                      component = components[0];
                      for (n2 = 0; n2 < mcuToRead; n2++) {
                        decodeBlock(component, decodeFn, mcu);
                        mcu++;
                      }
                    } else {
                      for (n2 = 0; n2 < mcuToRead; n2++) {
                        for (i = 0; i < componentsLength; i++) {
                          component = components[i];
                          h2 = component.h;
                          v = component.v;
                          for (j = 0; j < v; j++) {
                            for (k = 0; k < h2; k++) {
                              decodeMcu(component, decodeFn, mcu, j, k);
                            }
                          }
                        }
                        mcu++;
                      }
                    }
                  }
                  bitsCount = 0;
                  fileMarker = findNextFileMarker(data2, offset4);
                  if (!fileMarker) {
                    break;
                  }
                  if (fileMarker.invalid) {
                    const partialMsg = mcuToRead > 0 ? "unexpected" : "excessive";
                    (0, _util2.warn)(`decodeScan - ${partialMsg} MCU data, current marker is: ${fileMarker.invalid}`);
                    offset4 = fileMarker.offset;
                  }
                  if (fileMarker.marker >= 65488 && fileMarker.marker <= 65495) {
                    offset4 += 2;
                  } else {
                    break;
                  }
                }
                return offset4 - startOffset;
              }
              function quantizeAndInverse(component, blockBufferOffset, p) {
                const qt = component.quantizationTable, blockData = component.blockData;
                let v0, v1, v2, v3, v4, v5, v6, v7;
                let p0, p1, p2, p3, p4, p5, p6, p7;
                let t2;
                if (!qt) {
                  throw new JpegError("missing required Quantization Table.");
                }
                for (let row = 0; row < 64; row += 8) {
                  p0 = blockData[blockBufferOffset + row];
                  p1 = blockData[blockBufferOffset + row + 1];
                  p2 = blockData[blockBufferOffset + row + 2];
                  p3 = blockData[blockBufferOffset + row + 3];
                  p4 = blockData[blockBufferOffset + row + 4];
                  p5 = blockData[blockBufferOffset + row + 5];
                  p6 = blockData[blockBufferOffset + row + 6];
                  p7 = blockData[blockBufferOffset + row + 7];
                  p0 *= qt[row];
                  if ((p1 | p2 | p3 | p4 | p5 | p6 | p7) === 0) {
                    t2 = dctSqrt2 * p0 + 512 >> 10;
                    p[row] = t2;
                    p[row + 1] = t2;
                    p[row + 2] = t2;
                    p[row + 3] = t2;
                    p[row + 4] = t2;
                    p[row + 5] = t2;
                    p[row + 6] = t2;
                    p[row + 7] = t2;
                    continue;
                  }
                  p1 *= qt[row + 1];
                  p2 *= qt[row + 2];
                  p3 *= qt[row + 3];
                  p4 *= qt[row + 4];
                  p5 *= qt[row + 5];
                  p6 *= qt[row + 6];
                  p7 *= qt[row + 7];
                  v0 = dctSqrt2 * p0 + 128 >> 8;
                  v1 = dctSqrt2 * p4 + 128 >> 8;
                  v2 = p2;
                  v3 = p6;
                  v4 = dctSqrt1d2 * (p1 - p7) + 128 >> 8;
                  v7 = dctSqrt1d2 * (p1 + p7) + 128 >> 8;
                  v5 = p3 << 4;
                  v6 = p5 << 4;
                  v0 = v0 + v1 + 1 >> 1;
                  v1 = v0 - v1;
                  t2 = v2 * dctSin6 + v3 * dctCos6 + 128 >> 8;
                  v2 = v2 * dctCos6 - v3 * dctSin6 + 128 >> 8;
                  v3 = t2;
                  v4 = v4 + v6 + 1 >> 1;
                  v6 = v4 - v6;
                  v7 = v7 + v5 + 1 >> 1;
                  v5 = v7 - v5;
                  v0 = v0 + v3 + 1 >> 1;
                  v3 = v0 - v3;
                  v1 = v1 + v2 + 1 >> 1;
                  v2 = v1 - v2;
                  t2 = v4 * dctSin3 + v7 * dctCos3 + 2048 >> 12;
                  v4 = v4 * dctCos3 - v7 * dctSin3 + 2048 >> 12;
                  v7 = t2;
                  t2 = v5 * dctSin1 + v6 * dctCos1 + 2048 >> 12;
                  v5 = v5 * dctCos1 - v6 * dctSin1 + 2048 >> 12;
                  v6 = t2;
                  p[row] = v0 + v7;
                  p[row + 7] = v0 - v7;
                  p[row + 1] = v1 + v6;
                  p[row + 6] = v1 - v6;
                  p[row + 2] = v2 + v5;
                  p[row + 5] = v2 - v5;
                  p[row + 3] = v3 + v4;
                  p[row + 4] = v3 - v4;
                }
                for (let col = 0; col < 8; ++col) {
                  p0 = p[col];
                  p1 = p[col + 8];
                  p2 = p[col + 16];
                  p3 = p[col + 24];
                  p4 = p[col + 32];
                  p5 = p[col + 40];
                  p6 = p[col + 48];
                  p7 = p[col + 56];
                  if ((p1 | p2 | p3 | p4 | p5 | p6 | p7) === 0) {
                    t2 = dctSqrt2 * p0 + 8192 >> 14;
                    if (t2 < -2040) {
                      t2 = 0;
                    } else if (t2 >= 2024) {
                      t2 = 255;
                    } else {
                      t2 = t2 + 2056 >> 4;
                    }
                    blockData[blockBufferOffset + col] = t2;
                    blockData[blockBufferOffset + col + 8] = t2;
                    blockData[blockBufferOffset + col + 16] = t2;
                    blockData[blockBufferOffset + col + 24] = t2;
                    blockData[blockBufferOffset + col + 32] = t2;
                    blockData[blockBufferOffset + col + 40] = t2;
                    blockData[blockBufferOffset + col + 48] = t2;
                    blockData[blockBufferOffset + col + 56] = t2;
                    continue;
                  }
                  v0 = dctSqrt2 * p0 + 2048 >> 12;
                  v1 = dctSqrt2 * p4 + 2048 >> 12;
                  v2 = p2;
                  v3 = p6;
                  v4 = dctSqrt1d2 * (p1 - p7) + 2048 >> 12;
                  v7 = dctSqrt1d2 * (p1 + p7) + 2048 >> 12;
                  v5 = p3;
                  v6 = p5;
                  v0 = (v0 + v1 + 1 >> 1) + 4112;
                  v1 = v0 - v1;
                  t2 = v2 * dctSin6 + v3 * dctCos6 + 2048 >> 12;
                  v2 = v2 * dctCos6 - v3 * dctSin6 + 2048 >> 12;
                  v3 = t2;
                  v4 = v4 + v6 + 1 >> 1;
                  v6 = v4 - v6;
                  v7 = v7 + v5 + 1 >> 1;
                  v5 = v7 - v5;
                  v0 = v0 + v3 + 1 >> 1;
                  v3 = v0 - v3;
                  v1 = v1 + v2 + 1 >> 1;
                  v2 = v1 - v2;
                  t2 = v4 * dctSin3 + v7 * dctCos3 + 2048 >> 12;
                  v4 = v4 * dctCos3 - v7 * dctSin3 + 2048 >> 12;
                  v7 = t2;
                  t2 = v5 * dctSin1 + v6 * dctCos1 + 2048 >> 12;
                  v5 = v5 * dctCos1 - v6 * dctSin1 + 2048 >> 12;
                  v6 = t2;
                  p0 = v0 + v7;
                  p7 = v0 - v7;
                  p1 = v1 + v6;
                  p6 = v1 - v6;
                  p2 = v2 + v5;
                  p5 = v2 - v5;
                  p3 = v3 + v4;
                  p4 = v3 - v4;
                  if (p0 < 16) {
                    p0 = 0;
                  } else if (p0 >= 4080) {
                    p0 = 255;
                  } else {
                    p0 >>= 4;
                  }
                  if (p1 < 16) {
                    p1 = 0;
                  } else if (p1 >= 4080) {
                    p1 = 255;
                  } else {
                    p1 >>= 4;
                  }
                  if (p2 < 16) {
                    p2 = 0;
                  } else if (p2 >= 4080) {
                    p2 = 255;
                  } else {
                    p2 >>= 4;
                  }
                  if (p3 < 16) {
                    p3 = 0;
                  } else if (p3 >= 4080) {
                    p3 = 255;
                  } else {
                    p3 >>= 4;
                  }
                  if (p4 < 16) {
                    p4 = 0;
                  } else if (p4 >= 4080) {
                    p4 = 255;
                  } else {
                    p4 >>= 4;
                  }
                  if (p5 < 16) {
                    p5 = 0;
                  } else if (p5 >= 4080) {
                    p5 = 255;
                  } else {
                    p5 >>= 4;
                  }
                  if (p6 < 16) {
                    p6 = 0;
                  } else if (p6 >= 4080) {
                    p6 = 255;
                  } else {
                    p6 >>= 4;
                  }
                  if (p7 < 16) {
                    p7 = 0;
                  } else if (p7 >= 4080) {
                    p7 = 255;
                  } else {
                    p7 >>= 4;
                  }
                  blockData[blockBufferOffset + col] = p0;
                  blockData[blockBufferOffset + col + 8] = p1;
                  blockData[blockBufferOffset + col + 16] = p2;
                  blockData[blockBufferOffset + col + 24] = p3;
                  blockData[blockBufferOffset + col + 32] = p4;
                  blockData[blockBufferOffset + col + 40] = p5;
                  blockData[blockBufferOffset + col + 48] = p6;
                  blockData[blockBufferOffset + col + 56] = p7;
                }
              }
              function buildComponentData(frame, component) {
                const blocksPerLine = component.blocksPerLine;
                const blocksPerColumn = component.blocksPerColumn;
                const computationBuffer = new Int16Array(64);
                for (let blockRow = 0; blockRow < blocksPerColumn; blockRow++) {
                  for (let blockCol = 0; blockCol < blocksPerLine; blockCol++) {
                    const offset4 = getBlockBufferOffset(component, blockRow, blockCol);
                    quantizeAndInverse(component, offset4, computationBuffer);
                  }
                }
                return component.blockData;
              }
              function findNextFileMarker(data2, currentPos, startPos = currentPos) {
                const maxPos = data2.length - 1;
                let newPos = startPos < currentPos ? startPos : currentPos;
                if (currentPos >= maxPos) {
                  return null;
                }
                const currentMarker = (0, _core_utils.readUint16)(data2, currentPos);
                if (currentMarker >= 65472 && currentMarker <= 65534) {
                  return {
                    invalid: null,
                    marker: currentMarker,
                    offset: currentPos
                  };
                }
                let newMarker = (0, _core_utils.readUint16)(data2, newPos);
                while (!(newMarker >= 65472 && newMarker <= 65534)) {
                  if (++newPos >= maxPos) {
                    return null;
                  }
                  newMarker = (0, _core_utils.readUint16)(data2, newPos);
                }
                return {
                  invalid: currentMarker.toString(16),
                  marker: newMarker,
                  offset: newPos
                };
              }
              class JpegImage {
                constructor({
                  decodeTransform = null,
                  colorTransform = -1
                } = {}) {
                  this._decodeTransform = decodeTransform;
                  this._colorTransform = colorTransform;
                }
                parse(data2, {
                  dnlScanLines = null
                } = {}) {
                  function readDataBlock() {
                    const length2 = (0, _core_utils.readUint16)(data2, offset4);
                    offset4 += 2;
                    let endOffset = offset4 + length2 - 2;
                    const fileMarker2 = findNextFileMarker(data2, endOffset, offset4);
                    if (fileMarker2?.invalid) {
                      (0, _util2.warn)("readDataBlock - incorrect length, current marker is: " + fileMarker2.invalid);
                      endOffset = fileMarker2.offset;
                    }
                    const array4 = data2.subarray(offset4, endOffset);
                    offset4 += array4.length;
                    return array4;
                  }
                  function prepareComponents(frame2) {
                    const mcusPerLine = Math.ceil(frame2.samplesPerLine / 8 / frame2.maxH);
                    const mcusPerColumn = Math.ceil(frame2.scanLines / 8 / frame2.maxV);
                    for (const component of frame2.components) {
                      const blocksPerLine = Math.ceil(Math.ceil(frame2.samplesPerLine / 8) * component.h / frame2.maxH);
                      const blocksPerColumn = Math.ceil(Math.ceil(frame2.scanLines / 8) * component.v / frame2.maxV);
                      const blocksPerLineForMcu = mcusPerLine * component.h;
                      const blocksPerColumnForMcu = mcusPerColumn * component.v;
                      const blocksBufferSize = 64 * blocksPerColumnForMcu * (blocksPerLineForMcu + 1);
                      component.blockData = new Int16Array(blocksBufferSize);
                      component.blocksPerLine = blocksPerLine;
                      component.blocksPerColumn = blocksPerColumn;
                    }
                    frame2.mcusPerLine = mcusPerLine;
                    frame2.mcusPerColumn = mcusPerColumn;
                  }
                  let offset4 = 0;
                  let jfif = null;
                  let adobe = null;
                  let frame, resetInterval;
                  let numSOSMarkers = 0;
                  const quantizationTables = [];
                  const huffmanTablesAC = [], huffmanTablesDC = [];
                  let fileMarker = (0, _core_utils.readUint16)(data2, offset4);
                  offset4 += 2;
                  if (fileMarker !== 65496) {
                    throw new JpegError("SOI not found");
                  }
                  fileMarker = (0, _core_utils.readUint16)(data2, offset4);
                  offset4 += 2;
                  markerLoop: while (fileMarker !== 65497) {
                    let i, j, l2;
                    switch (fileMarker) {
                      case 65504:
                      case 65505:
                      case 65506:
                      case 65507:
                      case 65508:
                      case 65509:
                      case 65510:
                      case 65511:
                      case 65512:
                      case 65513:
                      case 65514:
                      case 65515:
                      case 65516:
                      case 65517:
                      case 65518:
                      case 65519:
                      case 65534:
                        const appData = readDataBlock();
                        if (fileMarker === 65504) {
                          if (appData[0] === 74 && appData[1] === 70 && appData[2] === 73 && appData[3] === 70 && appData[4] === 0) {
                            jfif = {
                              version: {
                                major: appData[5],
                                minor: appData[6]
                              },
                              densityUnits: appData[7],
                              xDensity: appData[8] << 8 | appData[9],
                              yDensity: appData[10] << 8 | appData[11],
                              thumbWidth: appData[12],
                              thumbHeight: appData[13],
                              thumbData: appData.subarray(14, 14 + 3 * appData[12] * appData[13])
                            };
                          }
                        }
                        if (fileMarker === 65518) {
                          if (appData[0] === 65 && appData[1] === 100 && appData[2] === 111 && appData[3] === 98 && appData[4] === 101) {
                            adobe = {
                              version: appData[5] << 8 | appData[6],
                              flags0: appData[7] << 8 | appData[8],
                              flags1: appData[9] << 8 | appData[10],
                              transformCode: appData[11]
                            };
                          }
                        }
                        break;
                      case 65499:
                        const quantizationTablesLength = (0, _core_utils.readUint16)(data2, offset4);
                        offset4 += 2;
                        const quantizationTablesEnd = quantizationTablesLength + offset4 - 2;
                        let z;
                        while (offset4 < quantizationTablesEnd) {
                          const quantizationTableSpec = data2[offset4++];
                          const tableData = new Uint16Array(64);
                          if (quantizationTableSpec >> 4 === 0) {
                            for (j = 0; j < 64; j++) {
                              z = dctZigZag[j];
                              tableData[z] = data2[offset4++];
                            }
                          } else if (quantizationTableSpec >> 4 === 1) {
                            for (j = 0; j < 64; j++) {
                              z = dctZigZag[j];
                              tableData[z] = (0, _core_utils.readUint16)(data2, offset4);
                              offset4 += 2;
                            }
                          } else {
                            throw new JpegError("DQT - invalid table spec");
                          }
                          quantizationTables[quantizationTableSpec & 15] = tableData;
                        }
                        break;
                      case 65472:
                      case 65473:
                      case 65474:
                        if (frame) {
                          throw new JpegError("Only single frame JPEGs supported");
                        }
                        offset4 += 2;
                        frame = {};
                        frame.extended = fileMarker === 65473;
                        frame.progressive = fileMarker === 65474;
                        frame.precision = data2[offset4++];
                        const sofScanLines = (0, _core_utils.readUint16)(data2, offset4);
                        offset4 += 2;
                        frame.scanLines = dnlScanLines || sofScanLines;
                        frame.samplesPerLine = (0, _core_utils.readUint16)(data2, offset4);
                        offset4 += 2;
                        frame.components = [];
                        frame.componentIds = {};
                        const componentsCount = data2[offset4++];
                        let maxH = 0, maxV = 0;
                        for (i = 0; i < componentsCount; i++) {
                          const componentId = data2[offset4];
                          const h2 = data2[offset4 + 1] >> 4;
                          const v = data2[offset4 + 1] & 15;
                          if (maxH < h2) {
                            maxH = h2;
                          }
                          if (maxV < v) {
                            maxV = v;
                          }
                          const qId = data2[offset4 + 2];
                          l2 = frame.components.push({
                            h: h2,
                            v,
                            quantizationId: qId,
                            quantizationTable: null
                          });
                          frame.componentIds[componentId] = l2 - 1;
                          offset4 += 3;
                        }
                        frame.maxH = maxH;
                        frame.maxV = maxV;
                        prepareComponents(frame);
                        break;
                      case 65476:
                        const huffmanLength = (0, _core_utils.readUint16)(data2, offset4);
                        offset4 += 2;
                        for (i = 2; i < huffmanLength; ) {
                          const huffmanTableSpec = data2[offset4++];
                          const codeLengths = new Uint8Array(16);
                          let codeLengthSum = 0;
                          for (j = 0; j < 16; j++, offset4++) {
                            codeLengthSum += codeLengths[j] = data2[offset4];
                          }
                          const huffmanValues = new Uint8Array(codeLengthSum);
                          for (j = 0; j < codeLengthSum; j++, offset4++) {
                            huffmanValues[j] = data2[offset4];
                          }
                          i += 17 + codeLengthSum;
                          (huffmanTableSpec >> 4 === 0 ? huffmanTablesDC : huffmanTablesAC)[huffmanTableSpec & 15] = buildHuffmanTable(codeLengths, huffmanValues);
                        }
                        break;
                      case 65501:
                        offset4 += 2;
                        resetInterval = (0, _core_utils.readUint16)(data2, offset4);
                        offset4 += 2;
                        break;
                      case 65498:
                        const parseDNLMarker = ++numSOSMarkers === 1 && !dnlScanLines;
                        offset4 += 2;
                        const selectorsCount = data2[offset4++], components = [];
                        for (i = 0; i < selectorsCount; i++) {
                          const index3 = data2[offset4++];
                          const componentIndex = frame.componentIds[index3];
                          const component = frame.components[componentIndex];
                          component.index = index3;
                          const tableSpec = data2[offset4++];
                          component.huffmanTableDC = huffmanTablesDC[tableSpec >> 4];
                          component.huffmanTableAC = huffmanTablesAC[tableSpec & 15];
                          components.push(component);
                        }
                        const spectralStart = data2[offset4++], spectralEnd = data2[offset4++], successiveApproximation = data2[offset4++];
                        try {
                          const processed = decodeScan(data2, offset4, frame, components, resetInterval, spectralStart, spectralEnd, successiveApproximation >> 4, successiveApproximation & 15, parseDNLMarker);
                          offset4 += processed;
                        } catch (ex) {
                          if (ex instanceof DNLMarkerError) {
                            (0, _util2.warn)(`${ex.message} -- attempting to re-parse the JPEG image.`);
                            return this.parse(data2, {
                              dnlScanLines: ex.scanLines
                            });
                          } else if (ex instanceof EOIMarkerError) {
                            (0, _util2.warn)(`${ex.message} -- ignoring the rest of the image data.`);
                            break markerLoop;
                          }
                          throw ex;
                        }
                        break;
                      case 65500:
                        offset4 += 4;
                        break;
                      case 65535:
                        if (data2[offset4] !== 255) {
                          offset4--;
                        }
                        break;
                      default:
                        const nextFileMarker = findNextFileMarker(data2, offset4 - 2, offset4 - 3);
                        if (nextFileMarker?.invalid) {
                          (0, _util2.warn)("JpegImage.parse - unexpected data, current marker is: " + nextFileMarker.invalid);
                          offset4 = nextFileMarker.offset;
                          break;
                        }
                        if (!nextFileMarker || offset4 >= data2.length - 1) {
                          (0, _util2.warn)("JpegImage.parse - reached the end of the image data without finding an EOI marker (0xFFD9).");
                          break markerLoop;
                        }
                        throw new JpegError("JpegImage.parse - unknown marker: " + fileMarker.toString(16));
                    }
                    fileMarker = (0, _core_utils.readUint16)(data2, offset4);
                    offset4 += 2;
                  }
                  this.width = frame.samplesPerLine;
                  this.height = frame.scanLines;
                  this.jfif = jfif;
                  this.adobe = adobe;
                  this.components = [];
                  for (const component of frame.components) {
                    const quantizationTable = quantizationTables[component.quantizationId];
                    if (quantizationTable) {
                      component.quantizationTable = quantizationTable;
                    }
                    this.components.push({
                      index: component.index,
                      output: buildComponentData(frame, component),
                      scaleX: component.h / frame.maxH,
                      scaleY: component.v / frame.maxV,
                      blocksPerLine: component.blocksPerLine,
                      blocksPerColumn: component.blocksPerColumn
                    });
                  }
                  this.numComponents = this.components.length;
                  return void 0;
                }
                _getLinearizedBlockData(width, height, isSourcePDF = false) {
                  const scaleX = this.width / width, scaleY = this.height / height;
                  let component, componentScaleX, componentScaleY, blocksPerScanline;
                  let x, y, i, j, k;
                  let index3;
                  let offset4 = 0;
                  let output;
                  const numComponents = this.components.length;
                  const dataLength = width * height * numComponents;
                  const data2 = new Uint8ClampedArray(dataLength);
                  const xScaleBlockOffset = new Uint32Array(width);
                  const mask3LSB = 4294967288;
                  let lastComponentScaleX;
                  for (i = 0; i < numComponents; i++) {
                    component = this.components[i];
                    componentScaleX = component.scaleX * scaleX;
                    componentScaleY = component.scaleY * scaleY;
                    offset4 = i;
                    output = component.output;
                    blocksPerScanline = component.blocksPerLine + 1 << 3;
                    if (componentScaleX !== lastComponentScaleX) {
                      for (x = 0; x < width; x++) {
                        j = 0 | x * componentScaleX;
                        xScaleBlockOffset[x] = (j & mask3LSB) << 3 | j & 7;
                      }
                      lastComponentScaleX = componentScaleX;
                    }
                    for (y = 0; y < height; y++) {
                      j = 0 | y * componentScaleY;
                      index3 = blocksPerScanline * (j & mask3LSB) | (j & 7) << 3;
                      for (x = 0; x < width; x++) {
                        data2[offset4] = output[index3 + xScaleBlockOffset[x]];
                        offset4 += numComponents;
                      }
                    }
                  }
                  let transform = this._decodeTransform;
                  if (!isSourcePDF && numComponents === 4 && !transform) {
                    transform = new Int32Array([-256, 255, -256, 255, -256, 255, -256, 255]);
                  }
                  if (transform) {
                    for (i = 0; i < dataLength; ) {
                      for (j = 0, k = 0; j < numComponents; j++, i++, k += 2) {
                        data2[i] = (data2[i] * transform[k] >> 8) + transform[k + 1];
                      }
                    }
                  }
                  return data2;
                }
                get _isColorConversionNeeded() {
                  if (this.adobe) {
                    return !!this.adobe.transformCode;
                  }
                  if (this.numComponents === 3) {
                    if (this._colorTransform === 0) {
                      return false;
                    } else if (this.components[0].index === 82 && this.components[1].index === 71 && this.components[2].index === 66) {
                      return false;
                    }
                    return true;
                  }
                  if (this._colorTransform === 1) {
                    return true;
                  }
                  return false;
                }
                _convertYccToRgb(data2) {
                  let Y, Cb, Cr;
                  for (let i = 0, length2 = data2.length; i < length2; i += 3) {
                    Y = data2[i];
                    Cb = data2[i + 1];
                    Cr = data2[i + 2];
                    data2[i] = Y - 179.456 + 1.402 * Cr;
                    data2[i + 1] = Y + 135.459 - 0.344 * Cb - 0.714 * Cr;
                    data2[i + 2] = Y - 226.816 + 1.772 * Cb;
                  }
                  return data2;
                }
                _convertYccToRgba(data2, out) {
                  for (let i = 0, j = 0, length2 = data2.length; i < length2; i += 3, j += 4) {
                    const Y = data2[i];
                    const Cb = data2[i + 1];
                    const Cr = data2[i + 2];
                    out[j] = Y - 179.456 + 1.402 * Cr;
                    out[j + 1] = Y + 135.459 - 0.344 * Cb - 0.714 * Cr;
                    out[j + 2] = Y - 226.816 + 1.772 * Cb;
                    out[j + 3] = 255;
                  }
                  return out;
                }
                _convertYcckToRgb(data2) {
                  let Y, Cb, Cr, k;
                  let offset4 = 0;
                  for (let i = 0, length2 = data2.length; i < length2; i += 4) {
                    Y = data2[i];
                    Cb = data2[i + 1];
                    Cr = data2[i + 2];
                    k = data2[i + 3];
                    data2[offset4++] = -122.67195406894 + Cb * (-660635669420364e-19 * Cb + 437130475926232e-18 * Cr - 54080610064599e-18 * Y + 48449797120281e-17 * k - 0.154362151871126) + Cr * (-957964378445773e-18 * Cr + 817076911346625e-18 * Y - 0.00477271405408747 * k + 1.53380253221734) + Y * (961250184130688e-18 * Y - 0.00266257332283933 * k + 0.48357088451265) + k * (-336197177618394e-18 * k + 0.484791561490776);
                    data2[offset4++] = 107.268039397724 + Cb * (219927104525741e-19 * Cb - 640992018297945e-18 * Cr + 659397001245577e-18 * Y + 426105652938837e-18 * k - 0.176491792462875) + Cr * (-778269941513683e-18 * Cr + 0.00130872261408275 * Y + 770482631801132e-18 * k - 0.151051492775562) + Y * (0.00126935368114843 * Y - 0.00265090189010898 * k + 0.25802910206845) + k * (-318913117588328e-18 * k - 0.213742400323665);
                    data2[offset4++] = -20.810012546947 + Cb * (-570115196973677e-18 * Cb - 263409051004589e-19 * Cr + 0.0020741088115012 * Y - 0.00288260236853442 * k + 0.814272968359295) + Cr * (-153496057440975e-19 * Cr - 132689043961446e-18 * Y + 560833691242812e-18 * k - 0.195152027534049) + Y * (0.00174418132927582 * Y - 0.00255243321439347 * k + 0.116935020465145) + k * (-343531996510555e-18 * k + 0.24165260232407);
                  }
                  return data2.subarray(0, offset4);
                }
                _convertYcckToRgba(data2) {
                  for (let i = 0, length2 = data2.length; i < length2; i += 4) {
                    const Y = data2[i];
                    const Cb = data2[i + 1];
                    const Cr = data2[i + 2];
                    const k = data2[i + 3];
                    data2[i] = -122.67195406894 + Cb * (-660635669420364e-19 * Cb + 437130475926232e-18 * Cr - 54080610064599e-18 * Y + 48449797120281e-17 * k - 0.154362151871126) + Cr * (-957964378445773e-18 * Cr + 817076911346625e-18 * Y - 0.00477271405408747 * k + 1.53380253221734) + Y * (961250184130688e-18 * Y - 0.00266257332283933 * k + 0.48357088451265) + k * (-336197177618394e-18 * k + 0.484791561490776);
                    data2[i + 1] = 107.268039397724 + Cb * (219927104525741e-19 * Cb - 640992018297945e-18 * Cr + 659397001245577e-18 * Y + 426105652938837e-18 * k - 0.176491792462875) + Cr * (-778269941513683e-18 * Cr + 0.00130872261408275 * Y + 770482631801132e-18 * k - 0.151051492775562) + Y * (0.00126935368114843 * Y - 0.00265090189010898 * k + 0.25802910206845) + k * (-318913117588328e-18 * k - 0.213742400323665);
                    data2[i + 2] = -20.810012546947 + Cb * (-570115196973677e-18 * Cb - 263409051004589e-19 * Cr + 0.0020741088115012 * Y - 0.00288260236853442 * k + 0.814272968359295) + Cr * (-153496057440975e-19 * Cr - 132689043961446e-18 * Y + 560833691242812e-18 * k - 0.195152027534049) + Y * (0.00174418132927582 * Y - 0.00255243321439347 * k + 0.116935020465145) + k * (-343531996510555e-18 * k + 0.24165260232407);
                    data2[i + 3] = 255;
                  }
                  return data2;
                }
                _convertYcckToCmyk(data2) {
                  let Y, Cb, Cr;
                  for (let i = 0, length2 = data2.length; i < length2; i += 4) {
                    Y = data2[i];
                    Cb = data2[i + 1];
                    Cr = data2[i + 2];
                    data2[i] = 434.456 - Y - 1.402 * Cr;
                    data2[i + 1] = 119.541 - Y + 0.344 * Cb + 0.714 * Cr;
                    data2[i + 2] = 481.816 - Y - 1.772 * Cb;
                  }
                  return data2;
                }
                _convertCmykToRgb(data2) {
                  let c, m, y, k;
                  let offset4 = 0;
                  for (let i = 0, length2 = data2.length; i < length2; i += 4) {
                    c = data2[i];
                    m = data2[i + 1];
                    y = data2[i + 2];
                    k = data2[i + 3];
                    data2[offset4++] = 255 + c * (-6747147073602441e-20 * c + 8379262121013727e-19 * m + 2894718188643294e-19 * y + 0.003264231057537806 * k - 1.1185611867203937) + m * (26374107616089405e-21 * m - 8626949158638572e-20 * y - 2748769067499491e-19 * k - 0.02155688794978967) + y * (-3878099212869363e-20 * y - 3267808279485286e-19 * k + 0.0686742238595345) - k * (3361971776183937e-19 * k + 0.7430659151342254);
                    data2[offset4++] = 255 + c * (13596372813588848e-20 * c + 924537132573585e-18 * m + 10567359618683593e-20 * y + 4791864687436512e-19 * k - 0.3109689587515875) + m * (-23545346108370344e-20 * m + 2702845253534714e-19 * y + 0.0020200308977307156 * k - 0.7488052167015494) + y * (6834815998235662e-20 * y + 15168452363460973e-20 * k - 0.09751927774728933) - k * (3189131175883281e-19 * k + 0.7364883807733168);
                    data2[offset4++] = 255 + c * (13598650411385307e-21 * c + 12423956175490851e-20 * m + 4751985097583589e-19 * y - 36729317476630422e-22 * k - 0.05562186980264034) + m * (16141380598724676e-20 * m + 9692239130725186e-19 * y + 7782692450036253e-19 * k - 0.44015232367526463) + y * (5068882914068769e-22 * y + 0.0017778369011375071 * k - 0.7591454649749609) - k * (3435319965105553e-19 * k + 0.7063770186160144);
                  }
                  return data2.subarray(0, offset4);
                }
                _convertCmykToRgba(data2) {
                  for (let i = 0, length2 = data2.length; i < length2; i += 4) {
                    const c = data2[i];
                    const m = data2[i + 1];
                    const y = data2[i + 2];
                    const k = data2[i + 3];
                    data2[i] = 255 + c * (-6747147073602441e-20 * c + 8379262121013727e-19 * m + 2894718188643294e-19 * y + 0.003264231057537806 * k - 1.1185611867203937) + m * (26374107616089405e-21 * m - 8626949158638572e-20 * y - 2748769067499491e-19 * k - 0.02155688794978967) + y * (-3878099212869363e-20 * y - 3267808279485286e-19 * k + 0.0686742238595345) - k * (3361971776183937e-19 * k + 0.7430659151342254);
                    data2[i + 1] = 255 + c * (13596372813588848e-20 * c + 924537132573585e-18 * m + 10567359618683593e-20 * y + 4791864687436512e-19 * k - 0.3109689587515875) + m * (-23545346108370344e-20 * m + 2702845253534714e-19 * y + 0.0020200308977307156 * k - 0.7488052167015494) + y * (6834815998235662e-20 * y + 15168452363460973e-20 * k - 0.09751927774728933) - k * (3189131175883281e-19 * k + 0.7364883807733168);
                    data2[i + 2] = 255 + c * (13598650411385307e-21 * c + 12423956175490851e-20 * m + 4751985097583589e-19 * y - 36729317476630422e-22 * k - 0.05562186980264034) + m * (16141380598724676e-20 * m + 9692239130725186e-19 * y + 7782692450036253e-19 * k - 0.44015232367526463) + y * (5068882914068769e-22 * y + 0.0017778369011375071 * k - 0.7591454649749609) - k * (3435319965105553e-19 * k + 0.7063770186160144);
                    data2[i + 3] = 255;
                  }
                  return data2;
                }
                getData({
                  width,
                  height,
                  forceRGBA = false,
                  forceRGB = false,
                  isSourcePDF = false
                }) {
                  if (this.numComponents > 4) {
                    throw new JpegError("Unsupported color mode");
                  }
                  const data2 = this._getLinearizedBlockData(width, height, isSourcePDF);
                  if (this.numComponents === 1 && (forceRGBA || forceRGB)) {
                    const len = data2.length * (forceRGBA ? 4 : 3);
                    const rgbaData = new Uint8ClampedArray(len);
                    let offset4 = 0;
                    if (forceRGBA) {
                      (0, _image_utils.grayToRGBA)(data2, new Uint32Array(rgbaData.buffer));
                    } else {
                      for (const grayColor of data2) {
                        rgbaData[offset4++] = grayColor;
                        rgbaData[offset4++] = grayColor;
                        rgbaData[offset4++] = grayColor;
                      }
                    }
                    return rgbaData;
                  } else if (this.numComponents === 3 && this._isColorConversionNeeded) {
                    if (forceRGBA) {
                      const rgbaData = new Uint8ClampedArray(data2.length / 3 * 4);
                      return this._convertYccToRgba(data2, rgbaData);
                    }
                    return this._convertYccToRgb(data2);
                  } else if (this.numComponents === 4) {
                    if (this._isColorConversionNeeded) {
                      if (forceRGBA) {
                        return this._convertYcckToRgba(data2);
                      }
                      if (forceRGB) {
                        return this._convertYcckToRgb(data2);
                      }
                      return this._convertYcckToCmyk(data2);
                    } else if (forceRGBA) {
                      return this._convertCmykToRgba(data2);
                    } else if (forceRGB) {
                      return this._convertCmykToRgb(data2);
                    }
                  }
                  return data2;
                }
              }
              exports3.JpegImage = JpegImage;
            }),
            /* 28 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.convertBlackAndWhiteToRGBA = convertBlackAndWhiteToRGBA;
              exports3.convertToRGBA = convertToRGBA;
              exports3.grayToRGBA = grayToRGBA;
              var _util2 = __w_pdfjs_require__3(2);
              function convertToRGBA(params) {
                switch (params.kind) {
                  case _util2.ImageKind.GRAYSCALE_1BPP:
                    return convertBlackAndWhiteToRGBA(params);
                  case _util2.ImageKind.RGB_24BPP:
                    return convertRGBToRGBA(params);
                }
                return null;
              }
              function convertBlackAndWhiteToRGBA({
                src,
                srcPos = 0,
                dest,
                width,
                height,
                nonBlackColor = 4294967295,
                inverseDecode = false
              }) {
                const black = _util2.FeatureTest.isLittleEndian ? 4278190080 : 255;
                const [zeroMapping, oneMapping] = inverseDecode ? [nonBlackColor, black] : [black, nonBlackColor];
                const widthInSource = width >> 3;
                const widthRemainder = width & 7;
                const srcLength = src.length;
                dest = new Uint32Array(dest.buffer);
                let destPos = 0;
                for (let i = 0; i < height; i++) {
                  for (const max = srcPos + widthInSource; srcPos < max; srcPos++) {
                    const elem2 = srcPos < srcLength ? src[srcPos] : 255;
                    dest[destPos++] = elem2 & 128 ? oneMapping : zeroMapping;
                    dest[destPos++] = elem2 & 64 ? oneMapping : zeroMapping;
                    dest[destPos++] = elem2 & 32 ? oneMapping : zeroMapping;
                    dest[destPos++] = elem2 & 16 ? oneMapping : zeroMapping;
                    dest[destPos++] = elem2 & 8 ? oneMapping : zeroMapping;
                    dest[destPos++] = elem2 & 4 ? oneMapping : zeroMapping;
                    dest[destPos++] = elem2 & 2 ? oneMapping : zeroMapping;
                    dest[destPos++] = elem2 & 1 ? oneMapping : zeroMapping;
                  }
                  if (widthRemainder === 0) {
                    continue;
                  }
                  const elem = srcPos < srcLength ? src[srcPos++] : 255;
                  for (let j = 0; j < widthRemainder; j++) {
                    dest[destPos++] = elem & 1 << 7 - j ? oneMapping : zeroMapping;
                  }
                }
                return {
                  srcPos,
                  destPos
                };
              }
              function convertRGBToRGBA({
                src,
                srcPos = 0,
                dest,
                destPos = 0,
                width,
                height
              }) {
                let i = 0;
                const len32 = src.length >> 2;
                const src32 = new Uint32Array(src.buffer, srcPos, len32);
                if (_util2.FeatureTest.isLittleEndian) {
                  for (; i < len32 - 2; i += 3, destPos += 4) {
                    const s1 = src32[i];
                    const s2 = src32[i + 1];
                    const s3 = src32[i + 2];
                    dest[destPos] = s1 | 4278190080;
                    dest[destPos + 1] = s1 >>> 24 | s2 << 8 | 4278190080;
                    dest[destPos + 2] = s2 >>> 16 | s3 << 16 | 4278190080;
                    dest[destPos + 3] = s3 >>> 8 | 4278190080;
                  }
                  for (let j = i * 4, jj = src.length; j < jj; j += 3) {
                    dest[destPos++] = src[j] | src[j + 1] << 8 | src[j + 2] << 16 | 4278190080;
                  }
                } else {
                  for (; i < len32 - 2; i += 3, destPos += 4) {
                    const s1 = src32[i];
                    const s2 = src32[i + 1];
                    const s3 = src32[i + 2];
                    dest[destPos] = s1 | 255;
                    dest[destPos + 1] = s1 << 24 | s2 >>> 8 | 255;
                    dest[destPos + 2] = s2 << 16 | s3 >>> 16 | 255;
                    dest[destPos + 3] = s3 << 8 | 255;
                  }
                  for (let j = i * 4, jj = src.length; j < jj; j += 3) {
                    dest[destPos++] = src[j] << 24 | src[j + 1] << 16 | src[j + 2] << 8 | 255;
                  }
                }
                return {
                  srcPos,
                  destPos
                };
              }
              function grayToRGBA(src, dest) {
                if (_util2.FeatureTest.isLittleEndian) {
                  for (let i = 0, ii = src.length; i < ii; i++) {
                    dest[i] = src[i] * 65793 | 4278190080;
                  }
                } else {
                  for (let i = 0, ii = src.length; i < ii; i++) {
                    dest[i] = src[i] * 16843008 | 255;
                  }
                }
              }
            }),
            /* 29 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.JpxStream = void 0;
              var _decode_stream = __w_pdfjs_require__3(18);
              var _jpx = __w_pdfjs_require__3(30);
              var _util2 = __w_pdfjs_require__3(2);
              class JpxStream extends _decode_stream.DecodeStream {
                constructor(stream, maybeLength, params) {
                  super(maybeLength);
                  this.stream = stream;
                  this.dict = stream.dict;
                  this.maybeLength = maybeLength;
                  this.params = params;
                }
                get bytes() {
                  return (0, _util2.shadow)(this, "bytes", this.stream.getBytes(this.maybeLength));
                }
                ensureBuffer(requested) {
                }
                readBlock() {
                  if (this.eof) {
                    return;
                  }
                  const jpxImage = new _jpx.JpxImage();
                  jpxImage.parse(this.bytes);
                  const width = jpxImage.width;
                  const height = jpxImage.height;
                  const componentsCount = jpxImage.componentsCount;
                  const tileCount = jpxImage.tiles.length;
                  if (tileCount === 1) {
                    this.buffer = jpxImage.tiles[0].items;
                  } else {
                    const data2 = new Uint8ClampedArray(width * height * componentsCount);
                    for (let k = 0; k < tileCount; k++) {
                      const tileComponents = jpxImage.tiles[k];
                      const tileWidth = tileComponents.width;
                      const tileHeight = tileComponents.height;
                      const tileLeft = tileComponents.left;
                      const tileTop = tileComponents.top;
                      const src = tileComponents.items;
                      let srcPosition = 0;
                      let dataPosition = (width * tileTop + tileLeft) * componentsCount;
                      const imgRowSize = width * componentsCount;
                      const tileRowSize = tileWidth * componentsCount;
                      for (let j = 0; j < tileHeight; j++) {
                        const rowBytes = src.subarray(srcPosition, srcPosition + tileRowSize);
                        data2.set(rowBytes, dataPosition);
                        srcPosition += tileRowSize;
                        dataPosition += imgRowSize;
                      }
                    }
                    this.buffer = data2;
                  }
                  this.bufferLength = this.buffer.length;
                  this.eof = true;
                }
              }
              exports3.JpxStream = JpxStream;
            }),
            /* 30 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.JpxImage = void 0;
              var _util2 = __w_pdfjs_require__3(2);
              var _core_utils = __w_pdfjs_require__3(3);
              var _arithmetic_decoder = __w_pdfjs_require__3(25);
              class JpxError extends _util2.BaseException {
                constructor(msg) {
                  super(`JPX error: ${msg}`, "JpxError");
                }
              }
              const SubbandsGainLog2 = {
                LL: 0,
                LH: 1,
                HL: 1,
                HH: 2
              };
              class JpxImage {
                constructor() {
                  this.failOnCorruptedImage = false;
                }
                parse(data2) {
                  const head = (0, _core_utils.readUint16)(data2, 0);
                  if (head === 65359) {
                    this.parseCodestream(data2, 0, data2.length);
                    return;
                  }
                  const length2 = data2.length;
                  let position3 = 0;
                  while (position3 < length2) {
                    let headerSize = 8;
                    let lbox = (0, _core_utils.readUint32)(data2, position3);
                    const tbox = (0, _core_utils.readUint32)(data2, position3 + 4);
                    position3 += headerSize;
                    if (lbox === 1) {
                      lbox = (0, _core_utils.readUint32)(data2, position3) * 4294967296 + (0, _core_utils.readUint32)(data2, position3 + 4);
                      position3 += 8;
                      headerSize += 8;
                    }
                    if (lbox === 0) {
                      lbox = length2 - position3 + headerSize;
                    }
                    if (lbox < headerSize) {
                      throw new JpxError("Invalid box field size");
                    }
                    const dataLength = lbox - headerSize;
                    let jumpDataLength = true;
                    switch (tbox) {
                      case 1785737832:
                        jumpDataLength = false;
                        break;
                      case 1668246642:
                        const method4 = data2[position3];
                        if (method4 === 1) {
                          const colorspace = (0, _core_utils.readUint32)(data2, position3 + 3);
                          switch (colorspace) {
                            case 16:
                            case 17:
                            case 18:
                              break;
                            default:
                              (0, _util2.warn)("Unknown colorspace " + colorspace);
                              break;
                          }
                        } else if (method4 === 2) {
                          (0, _util2.info)("ICC profile not supported");
                        }
                        break;
                      case 1785737827:
                        this.parseCodestream(data2, position3, position3 + dataLength);
                        break;
                      case 1783636e3:
                        if ((0, _core_utils.readUint32)(data2, position3) !== 218793738) {
                          (0, _util2.warn)("Invalid JP2 signature");
                        }
                        break;
                      case 1783634458:
                      case 1718909296:
                      case 1920099697:
                      case 1919251232:
                      case 1768449138:
                        break;
                      default:
                        const headerType = String.fromCharCode(tbox >> 24 & 255, tbox >> 16 & 255, tbox >> 8 & 255, tbox & 255);
                        (0, _util2.warn)(`Unsupported header type ${tbox} (${headerType}).`);
                        break;
                    }
                    if (jumpDataLength) {
                      position3 += dataLength;
                    }
                  }
                }
                parseImageProperties(stream) {
                  let newByte = stream.getByte();
                  while (newByte >= 0) {
                    const oldByte = newByte;
                    newByte = stream.getByte();
                    const code2 = oldByte << 8 | newByte;
                    if (code2 === 65361) {
                      stream.skip(4);
                      const Xsiz = stream.getInt32() >>> 0;
                      const Ysiz = stream.getInt32() >>> 0;
                      const XOsiz = stream.getInt32() >>> 0;
                      const YOsiz = stream.getInt32() >>> 0;
                      stream.skip(16);
                      const Csiz = stream.getUint16();
                      this.width = Xsiz - XOsiz;
                      this.height = Ysiz - YOsiz;
                      this.componentsCount = Csiz;
                      this.bitsPerComponent = 8;
                      return;
                    }
                  }
                  throw new JpxError("No size marker found in JPX stream");
                }
                parseCodestream(data2, start, end) {
                  const context = {};
                  let doNotRecover = false;
                  try {
                    let position3 = start;
                    while (position3 + 1 < end) {
                      const code2 = (0, _core_utils.readUint16)(data2, position3);
                      position3 += 2;
                      let length2 = 0, j, sqcd, spqcds, spqcdSize, scalarExpounded, tile;
                      switch (code2) {
                        case 65359:
                          context.mainHeader = true;
                          break;
                        case 65497:
                          break;
                        case 65361:
                          length2 = (0, _core_utils.readUint16)(data2, position3);
                          const siz = {};
                          siz.Xsiz = (0, _core_utils.readUint32)(data2, position3 + 4);
                          siz.Ysiz = (0, _core_utils.readUint32)(data2, position3 + 8);
                          siz.XOsiz = (0, _core_utils.readUint32)(data2, position3 + 12);
                          siz.YOsiz = (0, _core_utils.readUint32)(data2, position3 + 16);
                          siz.XTsiz = (0, _core_utils.readUint32)(data2, position3 + 20);
                          siz.YTsiz = (0, _core_utils.readUint32)(data2, position3 + 24);
                          siz.XTOsiz = (0, _core_utils.readUint32)(data2, position3 + 28);
                          siz.YTOsiz = (0, _core_utils.readUint32)(data2, position3 + 32);
                          const componentsCount = (0, _core_utils.readUint16)(data2, position3 + 36);
                          siz.Csiz = componentsCount;
                          const components = [];
                          j = position3 + 38;
                          for (let i = 0; i < componentsCount; i++) {
                            const component = {
                              precision: (data2[j] & 127) + 1,
                              isSigned: !!(data2[j] & 128),
                              XRsiz: data2[j + 1],
                              YRsiz: data2[j + 2]
                            };
                            j += 3;
                            calculateComponentDimensions(component, siz);
                            components.push(component);
                          }
                          context.SIZ = siz;
                          context.components = components;
                          calculateTileGrids(context, components);
                          context.QCC = [];
                          context.COC = [];
                          break;
                        case 65372:
                          length2 = (0, _core_utils.readUint16)(data2, position3);
                          const qcd = {};
                          j = position3 + 2;
                          sqcd = data2[j++];
                          switch (sqcd & 31) {
                            case 0:
                              spqcdSize = 8;
                              scalarExpounded = true;
                              break;
                            case 1:
                              spqcdSize = 16;
                              scalarExpounded = false;
                              break;
                            case 2:
                              spqcdSize = 16;
                              scalarExpounded = true;
                              break;
                            default:
                              throw new Error("Invalid SQcd value " + sqcd);
                          }
                          qcd.noQuantization = spqcdSize === 8;
                          qcd.scalarExpounded = scalarExpounded;
                          qcd.guardBits = sqcd >> 5;
                          spqcds = [];
                          while (j < length2 + position3) {
                            const spqcd = {};
                            if (spqcdSize === 8) {
                              spqcd.epsilon = data2[j++] >> 3;
                              spqcd.mu = 0;
                            } else {
                              spqcd.epsilon = data2[j] >> 3;
                              spqcd.mu = (data2[j] & 7) << 8 | data2[j + 1];
                              j += 2;
                            }
                            spqcds.push(spqcd);
                          }
                          qcd.SPqcds = spqcds;
                          if (context.mainHeader) {
                            context.QCD = qcd;
                          } else {
                            context.currentTile.QCD = qcd;
                            context.currentTile.QCC = [];
                          }
                          break;
                        case 65373:
                          length2 = (0, _core_utils.readUint16)(data2, position3);
                          const qcc = {};
                          j = position3 + 2;
                          let cqcc;
                          if (context.SIZ.Csiz < 257) {
                            cqcc = data2[j++];
                          } else {
                            cqcc = (0, _core_utils.readUint16)(data2, j);
                            j += 2;
                          }
                          sqcd = data2[j++];
                          switch (sqcd & 31) {
                            case 0:
                              spqcdSize = 8;
                              scalarExpounded = true;
                              break;
                            case 1:
                              spqcdSize = 16;
                              scalarExpounded = false;
                              break;
                            case 2:
                              spqcdSize = 16;
                              scalarExpounded = true;
                              break;
                            default:
                              throw new Error("Invalid SQcd value " + sqcd);
                          }
                          qcc.noQuantization = spqcdSize === 8;
                          qcc.scalarExpounded = scalarExpounded;
                          qcc.guardBits = sqcd >> 5;
                          spqcds = [];
                          while (j < length2 + position3) {
                            const spqcd = {};
                            if (spqcdSize === 8) {
                              spqcd.epsilon = data2[j++] >> 3;
                              spqcd.mu = 0;
                            } else {
                              spqcd.epsilon = data2[j] >> 3;
                              spqcd.mu = (data2[j] & 7) << 8 | data2[j + 1];
                              j += 2;
                            }
                            spqcds.push(spqcd);
                          }
                          qcc.SPqcds = spqcds;
                          if (context.mainHeader) {
                            context.QCC[cqcc] = qcc;
                          } else {
                            context.currentTile.QCC[cqcc] = qcc;
                          }
                          break;
                        case 65362:
                          length2 = (0, _core_utils.readUint16)(data2, position3);
                          const cod = {};
                          j = position3 + 2;
                          const scod = data2[j++];
                          cod.entropyCoderWithCustomPrecincts = !!(scod & 1);
                          cod.sopMarkerUsed = !!(scod & 2);
                          cod.ephMarkerUsed = !!(scod & 4);
                          cod.progressionOrder = data2[j++];
                          cod.layersCount = (0, _core_utils.readUint16)(data2, j);
                          j += 2;
                          cod.multipleComponentTransform = data2[j++];
                          cod.decompositionLevelsCount = data2[j++];
                          cod.xcb = (data2[j++] & 15) + 2;
                          cod.ycb = (data2[j++] & 15) + 2;
                          const blockStyle = data2[j++];
                          cod.selectiveArithmeticCodingBypass = !!(blockStyle & 1);
                          cod.resetContextProbabilities = !!(blockStyle & 2);
                          cod.terminationOnEachCodingPass = !!(blockStyle & 4);
                          cod.verticallyStripe = !!(blockStyle & 8);
                          cod.predictableTermination = !!(blockStyle & 16);
                          cod.segmentationSymbolUsed = !!(blockStyle & 32);
                          cod.reversibleTransformation = data2[j++];
                          if (cod.entropyCoderWithCustomPrecincts) {
                            const precinctsSizes = [];
                            while (j < length2 + position3) {
                              const precinctsSize = data2[j++];
                              precinctsSizes.push({
                                PPx: precinctsSize & 15,
                                PPy: precinctsSize >> 4
                              });
                            }
                            cod.precinctsSizes = precinctsSizes;
                          }
                          const unsupported = [];
                          if (cod.selectiveArithmeticCodingBypass) {
                            unsupported.push("selectiveArithmeticCodingBypass");
                          }
                          if (cod.terminationOnEachCodingPass) {
                            unsupported.push("terminationOnEachCodingPass");
                          }
                          if (cod.verticallyStripe) {
                            unsupported.push("verticallyStripe");
                          }
                          if (cod.predictableTermination) {
                            unsupported.push("predictableTermination");
                          }
                          if (unsupported.length > 0) {
                            doNotRecover = true;
                            (0, _util2.warn)(`JPX: Unsupported COD options (${unsupported.join(", ")}).`);
                          }
                          if (context.mainHeader) {
                            context.COD = cod;
                          } else {
                            context.currentTile.COD = cod;
                            context.currentTile.COC = [];
                          }
                          break;
                        case 65424:
                          length2 = (0, _core_utils.readUint16)(data2, position3);
                          tile = {};
                          tile.index = (0, _core_utils.readUint16)(data2, position3 + 2);
                          tile.length = (0, _core_utils.readUint32)(data2, position3 + 4);
                          tile.dataEnd = tile.length + position3 - 2;
                          tile.partIndex = data2[position3 + 8];
                          tile.partsCount = data2[position3 + 9];
                          context.mainHeader = false;
                          if (tile.partIndex === 0) {
                            tile.COD = context.COD;
                            tile.COC = context.COC.slice(0);
                            tile.QCD = context.QCD;
                            tile.QCC = context.QCC.slice(0);
                          }
                          context.currentTile = tile;
                          break;
                        case 65427:
                          tile = context.currentTile;
                          if (tile.partIndex === 0) {
                            initializeTile(context, tile.index);
                            buildPackets(context);
                          }
                          length2 = tile.dataEnd - position3;
                          parseTilePackets(context, data2, position3, length2);
                          break;
                        case 65363:
                          (0, _util2.warn)("JPX: Codestream code 0xFF53 (COC) is not implemented.");
                        case 65365:
                        case 65367:
                        case 65368:
                        case 65380:
                          length2 = (0, _core_utils.readUint16)(data2, position3);
                          break;
                        default:
                          throw new Error("Unknown codestream code: " + code2.toString(16));
                      }
                      position3 += length2;
                    }
                  } catch (e3) {
                    if (doNotRecover || this.failOnCorruptedImage) {
                      throw new JpxError(e3.message);
                    } else {
                      (0, _util2.warn)(`JPX: Trying to recover from: "${e3.message}".`);
                    }
                  }
                  this.tiles = transformComponents(context);
                  this.width = context.SIZ.Xsiz - context.SIZ.XOsiz;
                  this.height = context.SIZ.Ysiz - context.SIZ.YOsiz;
                  this.componentsCount = context.SIZ.Csiz;
                }
              }
              exports3.JpxImage = JpxImage;
              function calculateComponentDimensions(component, siz) {
                component.x0 = Math.ceil(siz.XOsiz / component.XRsiz);
                component.x1 = Math.ceil(siz.Xsiz / component.XRsiz);
                component.y0 = Math.ceil(siz.YOsiz / component.YRsiz);
                component.y1 = Math.ceil(siz.Ysiz / component.YRsiz);
                component.width = component.x1 - component.x0;
                component.height = component.y1 - component.y0;
              }
              function calculateTileGrids(context, components) {
                const siz = context.SIZ;
                const tiles = [];
                let tile;
                const numXtiles = Math.ceil((siz.Xsiz - siz.XTOsiz) / siz.XTsiz);
                const numYtiles = Math.ceil((siz.Ysiz - siz.YTOsiz) / siz.YTsiz);
                for (let q = 0; q < numYtiles; q++) {
                  for (let p = 0; p < numXtiles; p++) {
                    tile = {};
                    tile.tx0 = Math.max(siz.XTOsiz + p * siz.XTsiz, siz.XOsiz);
                    tile.ty0 = Math.max(siz.YTOsiz + q * siz.YTsiz, siz.YOsiz);
                    tile.tx1 = Math.min(siz.XTOsiz + (p + 1) * siz.XTsiz, siz.Xsiz);
                    tile.ty1 = Math.min(siz.YTOsiz + (q + 1) * siz.YTsiz, siz.Ysiz);
                    tile.width = tile.tx1 - tile.tx0;
                    tile.height = tile.ty1 - tile.ty0;
                    tile.components = [];
                    tiles.push(tile);
                  }
                }
                context.tiles = tiles;
                const componentsCount = siz.Csiz;
                for (let i = 0, ii = componentsCount; i < ii; i++) {
                  const component = components[i];
                  for (let j = 0, jj = tiles.length; j < jj; j++) {
                    const tileComponent = {};
                    tile = tiles[j];
                    tileComponent.tcx0 = Math.ceil(tile.tx0 / component.XRsiz);
                    tileComponent.tcy0 = Math.ceil(tile.ty0 / component.YRsiz);
                    tileComponent.tcx1 = Math.ceil(tile.tx1 / component.XRsiz);
                    tileComponent.tcy1 = Math.ceil(tile.ty1 / component.YRsiz);
                    tileComponent.width = tileComponent.tcx1 - tileComponent.tcx0;
                    tileComponent.height = tileComponent.tcy1 - tileComponent.tcy0;
                    tile.components[i] = tileComponent;
                  }
                }
              }
              function getBlocksDimensions(context, component, r2) {
                const codOrCoc = component.codingStyleParameters;
                const result = {};
                if (!codOrCoc.entropyCoderWithCustomPrecincts) {
                  result.PPx = 15;
                  result.PPy = 15;
                } else {
                  result.PPx = codOrCoc.precinctsSizes[r2].PPx;
                  result.PPy = codOrCoc.precinctsSizes[r2].PPy;
                }
                result.xcb_ = r2 > 0 ? Math.min(codOrCoc.xcb, result.PPx - 1) : Math.min(codOrCoc.xcb, result.PPx);
                result.ycb_ = r2 > 0 ? Math.min(codOrCoc.ycb, result.PPy - 1) : Math.min(codOrCoc.ycb, result.PPy);
                return result;
              }
              function buildPrecincts(context, resolution, dimensions) {
                const precinctWidth = 1 << dimensions.PPx;
                const precinctHeight = 1 << dimensions.PPy;
                const isZeroRes = resolution.resLevel === 0;
                const precinctWidthInSubband = 1 << dimensions.PPx + (isZeroRes ? 0 : -1);
                const precinctHeightInSubband = 1 << dimensions.PPy + (isZeroRes ? 0 : -1);
                const numprecinctswide = resolution.trx1 > resolution.trx0 ? Math.ceil(resolution.trx1 / precinctWidth) - Math.floor(resolution.trx0 / precinctWidth) : 0;
                const numprecinctshigh = resolution.try1 > resolution.try0 ? Math.ceil(resolution.try1 / precinctHeight) - Math.floor(resolution.try0 / precinctHeight) : 0;
                const numprecincts = numprecinctswide * numprecinctshigh;
                resolution.precinctParameters = {
                  precinctWidth,
                  precinctHeight,
                  numprecinctswide,
                  numprecinctshigh,
                  numprecincts,
                  precinctWidthInSubband,
                  precinctHeightInSubband
                };
              }
              function buildCodeblocks(context, subband, dimensions) {
                const xcb_ = dimensions.xcb_;
                const ycb_ = dimensions.ycb_;
                const codeblockWidth = 1 << xcb_;
                const codeblockHeight = 1 << ycb_;
                const cbx0 = subband.tbx0 >> xcb_;
                const cby0 = subband.tby0 >> ycb_;
                const cbx1 = subband.tbx1 + codeblockWidth - 1 >> xcb_;
                const cby1 = subband.tby1 + codeblockHeight - 1 >> ycb_;
                const precinctParameters = subband.resolution.precinctParameters;
                const codeblocks = [];
                const precincts = [];
                let i, j, codeblock, precinctNumber;
                for (j = cby0; j < cby1; j++) {
                  for (i = cbx0; i < cbx1; i++) {
                    codeblock = {
                      cbx: i,
                      cby: j,
                      tbx0: codeblockWidth * i,
                      tby0: codeblockHeight * j,
                      tbx1: codeblockWidth * (i + 1),
                      tby1: codeblockHeight * (j + 1)
                    };
                    codeblock.tbx0_ = Math.max(subband.tbx0, codeblock.tbx0);
                    codeblock.tby0_ = Math.max(subband.tby0, codeblock.tby0);
                    codeblock.tbx1_ = Math.min(subband.tbx1, codeblock.tbx1);
                    codeblock.tby1_ = Math.min(subband.tby1, codeblock.tby1);
                    const pi = Math.floor((codeblock.tbx0_ - subband.tbx0) / precinctParameters.precinctWidthInSubband);
                    const pj = Math.floor((codeblock.tby0_ - subband.tby0) / precinctParameters.precinctHeightInSubband);
                    precinctNumber = pi + pj * precinctParameters.numprecinctswide;
                    codeblock.precinctNumber = precinctNumber;
                    codeblock.subbandType = subband.type;
                    codeblock.Lblock = 3;
                    if (codeblock.tbx1_ <= codeblock.tbx0_ || codeblock.tby1_ <= codeblock.tby0_) {
                      continue;
                    }
                    codeblocks.push(codeblock);
                    let precinct = precincts[precinctNumber];
                    if (precinct !== void 0) {
                      if (i < precinct.cbxMin) {
                        precinct.cbxMin = i;
                      } else if (i > precinct.cbxMax) {
                        precinct.cbxMax = i;
                      }
                      if (j < precinct.cbyMin) {
                        precinct.cbxMin = j;
                      } else if (j > precinct.cbyMax) {
                        precinct.cbyMax = j;
                      }
                    } else {
                      precincts[precinctNumber] = precinct = {
                        cbxMin: i,
                        cbyMin: j,
                        cbxMax: i,
                        cbyMax: j
                      };
                    }
                    codeblock.precinct = precinct;
                  }
                }
                subband.codeblockParameters = {
                  codeblockWidth: xcb_,
                  codeblockHeight: ycb_,
                  numcodeblockwide: cbx1 - cbx0 + 1,
                  numcodeblockhigh: cby1 - cby0 + 1
                };
                subband.codeblocks = codeblocks;
                subband.precincts = precincts;
              }
              function createPacket(resolution, precinctNumber, layerNumber) {
                const precinctCodeblocks = [];
                const subbands = resolution.subbands;
                for (let i = 0, ii = subbands.length; i < ii; i++) {
                  const subband = subbands[i];
                  const codeblocks = subband.codeblocks;
                  for (let j = 0, jj = codeblocks.length; j < jj; j++) {
                    const codeblock = codeblocks[j];
                    if (codeblock.precinctNumber !== precinctNumber) {
                      continue;
                    }
                    precinctCodeblocks.push(codeblock);
                  }
                }
                return {
                  layerNumber,
                  codeblocks: precinctCodeblocks
                };
              }
              function LayerResolutionComponentPositionIterator(context) {
                const siz = context.SIZ;
                const tileIndex = context.currentTile.index;
                const tile = context.tiles[tileIndex];
                const layersCount = tile.codingStyleDefaultParameters.layersCount;
                const componentsCount = siz.Csiz;
                let maxDecompositionLevelsCount = 0;
                for (let q = 0; q < componentsCount; q++) {
                  maxDecompositionLevelsCount = Math.max(maxDecompositionLevelsCount, tile.components[q].codingStyleParameters.decompositionLevelsCount);
                }
                let l2 = 0, r2 = 0, i = 0, k = 0;
                this.nextPacket = function JpxImage_nextPacket() {
                  for (; l2 < layersCount; l2++) {
                    for (; r2 <= maxDecompositionLevelsCount; r2++) {
                      for (; i < componentsCount; i++) {
                        const component = tile.components[i];
                        if (r2 > component.codingStyleParameters.decompositionLevelsCount) {
                          continue;
                        }
                        const resolution = component.resolutions[r2];
                        const numprecincts = resolution.precinctParameters.numprecincts;
                        for (; k < numprecincts; ) {
                          const packet = createPacket(resolution, k, l2);
                          k++;
                          return packet;
                        }
                        k = 0;
                      }
                      i = 0;
                    }
                    r2 = 0;
                  }
                  throw new JpxError("Out of packets");
                };
              }
              function ResolutionLayerComponentPositionIterator(context) {
                const siz = context.SIZ;
                const tileIndex = context.currentTile.index;
                const tile = context.tiles[tileIndex];
                const layersCount = tile.codingStyleDefaultParameters.layersCount;
                const componentsCount = siz.Csiz;
                let maxDecompositionLevelsCount = 0;
                for (let q = 0; q < componentsCount; q++) {
                  maxDecompositionLevelsCount = Math.max(maxDecompositionLevelsCount, tile.components[q].codingStyleParameters.decompositionLevelsCount);
                }
                let r2 = 0, l2 = 0, i = 0, k = 0;
                this.nextPacket = function JpxImage_nextPacket() {
                  for (; r2 <= maxDecompositionLevelsCount; r2++) {
                    for (; l2 < layersCount; l2++) {
                      for (; i < componentsCount; i++) {
                        const component = tile.components[i];
                        if (r2 > component.codingStyleParameters.decompositionLevelsCount) {
                          continue;
                        }
                        const resolution = component.resolutions[r2];
                        const numprecincts = resolution.precinctParameters.numprecincts;
                        for (; k < numprecincts; ) {
                          const packet = createPacket(resolution, k, l2);
                          k++;
                          return packet;
                        }
                        k = 0;
                      }
                      i = 0;
                    }
                    l2 = 0;
                  }
                  throw new JpxError("Out of packets");
                };
              }
              function ResolutionPositionComponentLayerIterator(context) {
                const siz = context.SIZ;
                const tileIndex = context.currentTile.index;
                const tile = context.tiles[tileIndex];
                const layersCount = tile.codingStyleDefaultParameters.layersCount;
                const componentsCount = siz.Csiz;
                let l2, r2, c, p;
                let maxDecompositionLevelsCount = 0;
                for (c = 0; c < componentsCount; c++) {
                  const component = tile.components[c];
                  maxDecompositionLevelsCount = Math.max(maxDecompositionLevelsCount, component.codingStyleParameters.decompositionLevelsCount);
                }
                const maxNumPrecinctsInLevel = new Int32Array(maxDecompositionLevelsCount + 1);
                for (r2 = 0; r2 <= maxDecompositionLevelsCount; ++r2) {
                  let maxNumPrecincts = 0;
                  for (c = 0; c < componentsCount; ++c) {
                    const resolutions = tile.components[c].resolutions;
                    if (r2 < resolutions.length) {
                      maxNumPrecincts = Math.max(maxNumPrecincts, resolutions[r2].precinctParameters.numprecincts);
                    }
                  }
                  maxNumPrecinctsInLevel[r2] = maxNumPrecincts;
                }
                l2 = 0;
                r2 = 0;
                c = 0;
                p = 0;
                this.nextPacket = function JpxImage_nextPacket() {
                  for (; r2 <= maxDecompositionLevelsCount; r2++) {
                    for (; p < maxNumPrecinctsInLevel[r2]; p++) {
                      for (; c < componentsCount; c++) {
                        const component = tile.components[c];
                        if (r2 > component.codingStyleParameters.decompositionLevelsCount) {
                          continue;
                        }
                        const resolution = component.resolutions[r2];
                        const numprecincts = resolution.precinctParameters.numprecincts;
                        if (p >= numprecincts) {
                          continue;
                        }
                        for (; l2 < layersCount; ) {
                          const packet = createPacket(resolution, p, l2);
                          l2++;
                          return packet;
                        }
                        l2 = 0;
                      }
                      c = 0;
                    }
                    p = 0;
                  }
                  throw new JpxError("Out of packets");
                };
              }
              function PositionComponentResolutionLayerIterator(context) {
                const siz = context.SIZ;
                const tileIndex = context.currentTile.index;
                const tile = context.tiles[tileIndex];
                const layersCount = tile.codingStyleDefaultParameters.layersCount;
                const componentsCount = siz.Csiz;
                const precinctsSizes = getPrecinctSizesInImageScale(tile);
                const precinctsIterationSizes = precinctsSizes;
                let l2 = 0, r2 = 0, c = 0, px = 0, py = 0;
                this.nextPacket = function JpxImage_nextPacket() {
                  for (; py < precinctsIterationSizes.maxNumHigh; py++) {
                    for (; px < precinctsIterationSizes.maxNumWide; px++) {
                      for (; c < componentsCount; c++) {
                        const component = tile.components[c];
                        const decompositionLevelsCount = component.codingStyleParameters.decompositionLevelsCount;
                        for (; r2 <= decompositionLevelsCount; r2++) {
                          const resolution = component.resolutions[r2];
                          const sizeInImageScale = precinctsSizes.components[c].resolutions[r2];
                          const k = getPrecinctIndexIfExist(px, py, sizeInImageScale, precinctsIterationSizes, resolution);
                          if (k === null) {
                            continue;
                          }
                          for (; l2 < layersCount; ) {
                            const packet = createPacket(resolution, k, l2);
                            l2++;
                            return packet;
                          }
                          l2 = 0;
                        }
                        r2 = 0;
                      }
                      c = 0;
                    }
                    px = 0;
                  }
                  throw new JpxError("Out of packets");
                };
              }
              function ComponentPositionResolutionLayerIterator(context) {
                const siz = context.SIZ;
                const tileIndex = context.currentTile.index;
                const tile = context.tiles[tileIndex];
                const layersCount = tile.codingStyleDefaultParameters.layersCount;
                const componentsCount = siz.Csiz;
                const precinctsSizes = getPrecinctSizesInImageScale(tile);
                let l2 = 0, r2 = 0, c = 0, px = 0, py = 0;
                this.nextPacket = function JpxImage_nextPacket() {
                  for (; c < componentsCount; ++c) {
                    const component = tile.components[c];
                    const precinctsIterationSizes = precinctsSizes.components[c];
                    const decompositionLevelsCount = component.codingStyleParameters.decompositionLevelsCount;
                    for (; py < precinctsIterationSizes.maxNumHigh; py++) {
                      for (; px < precinctsIterationSizes.maxNumWide; px++) {
                        for (; r2 <= decompositionLevelsCount; r2++) {
                          const resolution = component.resolutions[r2];
                          const sizeInImageScale = precinctsIterationSizes.resolutions[r2];
                          const k = getPrecinctIndexIfExist(px, py, sizeInImageScale, precinctsIterationSizes, resolution);
                          if (k === null) {
                            continue;
                          }
                          for (; l2 < layersCount; ) {
                            const packet = createPacket(resolution, k, l2);
                            l2++;
                            return packet;
                          }
                          l2 = 0;
                        }
                        r2 = 0;
                      }
                      px = 0;
                    }
                    py = 0;
                  }
                  throw new JpxError("Out of packets");
                };
              }
              function getPrecinctIndexIfExist(pxIndex, pyIndex, sizeInImageScale, precinctIterationSizes, resolution) {
                const posX = pxIndex * precinctIterationSizes.minWidth;
                const posY = pyIndex * precinctIterationSizes.minHeight;
                if (posX % sizeInImageScale.width !== 0 || posY % sizeInImageScale.height !== 0) {
                  return null;
                }
                const startPrecinctRowIndex = posY / sizeInImageScale.width * resolution.precinctParameters.numprecinctswide;
                return posX / sizeInImageScale.height + startPrecinctRowIndex;
              }
              function getPrecinctSizesInImageScale(tile) {
                const componentsCount = tile.components.length;
                let minWidth = Number.MAX_VALUE;
                let minHeight = Number.MAX_VALUE;
                let maxNumWide = 0;
                let maxNumHigh = 0;
                const sizePerComponent = new Array(componentsCount);
                for (let c = 0; c < componentsCount; c++) {
                  const component = tile.components[c];
                  const decompositionLevelsCount = component.codingStyleParameters.decompositionLevelsCount;
                  const sizePerResolution = new Array(decompositionLevelsCount + 1);
                  let minWidthCurrentComponent = Number.MAX_VALUE;
                  let minHeightCurrentComponent = Number.MAX_VALUE;
                  let maxNumWideCurrentComponent = 0;
                  let maxNumHighCurrentComponent = 0;
                  let scale = 1;
                  for (let r2 = decompositionLevelsCount; r2 >= 0; --r2) {
                    const resolution = component.resolutions[r2];
                    const widthCurrentResolution = scale * resolution.precinctParameters.precinctWidth;
                    const heightCurrentResolution = scale * resolution.precinctParameters.precinctHeight;
                    minWidthCurrentComponent = Math.min(minWidthCurrentComponent, widthCurrentResolution);
                    minHeightCurrentComponent = Math.min(minHeightCurrentComponent, heightCurrentResolution);
                    maxNumWideCurrentComponent = Math.max(maxNumWideCurrentComponent, resolution.precinctParameters.numprecinctswide);
                    maxNumHighCurrentComponent = Math.max(maxNumHighCurrentComponent, resolution.precinctParameters.numprecinctshigh);
                    sizePerResolution[r2] = {
                      width: widthCurrentResolution,
                      height: heightCurrentResolution
                    };
                    scale <<= 1;
                  }
                  minWidth = Math.min(minWidth, minWidthCurrentComponent);
                  minHeight = Math.min(minHeight, minHeightCurrentComponent);
                  maxNumWide = Math.max(maxNumWide, maxNumWideCurrentComponent);
                  maxNumHigh = Math.max(maxNumHigh, maxNumHighCurrentComponent);
                  sizePerComponent[c] = {
                    resolutions: sizePerResolution,
                    minWidth: minWidthCurrentComponent,
                    minHeight: minHeightCurrentComponent,
                    maxNumWide: maxNumWideCurrentComponent,
                    maxNumHigh: maxNumHighCurrentComponent
                  };
                }
                return {
                  components: sizePerComponent,
                  minWidth,
                  minHeight,
                  maxNumWide,
                  maxNumHigh
                };
              }
              function buildPackets(context) {
                const siz = context.SIZ;
                const tileIndex = context.currentTile.index;
                const tile = context.tiles[tileIndex];
                const componentsCount = siz.Csiz;
                for (let c = 0; c < componentsCount; c++) {
                  const component = tile.components[c];
                  const decompositionLevelsCount = component.codingStyleParameters.decompositionLevelsCount;
                  const resolutions = [];
                  const subbands = [];
                  for (let r2 = 0; r2 <= decompositionLevelsCount; r2++) {
                    const blocksDimensions = getBlocksDimensions(context, component, r2);
                    const resolution = {};
                    const scale = 1 << decompositionLevelsCount - r2;
                    resolution.trx0 = Math.ceil(component.tcx0 / scale);
                    resolution.try0 = Math.ceil(component.tcy0 / scale);
                    resolution.trx1 = Math.ceil(component.tcx1 / scale);
                    resolution.try1 = Math.ceil(component.tcy1 / scale);
                    resolution.resLevel = r2;
                    buildPrecincts(context, resolution, blocksDimensions);
                    resolutions.push(resolution);
                    let subband;
                    if (r2 === 0) {
                      subband = {};
                      subband.type = "LL";
                      subband.tbx0 = Math.ceil(component.tcx0 / scale);
                      subband.tby0 = Math.ceil(component.tcy0 / scale);
                      subband.tbx1 = Math.ceil(component.tcx1 / scale);
                      subband.tby1 = Math.ceil(component.tcy1 / scale);
                      subband.resolution = resolution;
                      buildCodeblocks(context, subband, blocksDimensions);
                      subbands.push(subband);
                      resolution.subbands = [subband];
                    } else {
                      const bscale = 1 << decompositionLevelsCount - r2 + 1;
                      const resolutionSubbands = [];
                      subband = {};
                      subband.type = "HL";
                      subband.tbx0 = Math.ceil(component.tcx0 / bscale - 0.5);
                      subband.tby0 = Math.ceil(component.tcy0 / bscale);
                      subband.tbx1 = Math.ceil(component.tcx1 / bscale - 0.5);
                      subband.tby1 = Math.ceil(component.tcy1 / bscale);
                      subband.resolution = resolution;
                      buildCodeblocks(context, subband, blocksDimensions);
                      subbands.push(subband);
                      resolutionSubbands.push(subband);
                      subband = {};
                      subband.type = "LH";
                      subband.tbx0 = Math.ceil(component.tcx0 / bscale);
                      subband.tby0 = Math.ceil(component.tcy0 / bscale - 0.5);
                      subband.tbx1 = Math.ceil(component.tcx1 / bscale);
                      subband.tby1 = Math.ceil(component.tcy1 / bscale - 0.5);
                      subband.resolution = resolution;
                      buildCodeblocks(context, subband, blocksDimensions);
                      subbands.push(subband);
                      resolutionSubbands.push(subband);
                      subband = {};
                      subband.type = "HH";
                      subband.tbx0 = Math.ceil(component.tcx0 / bscale - 0.5);
                      subband.tby0 = Math.ceil(component.tcy0 / bscale - 0.5);
                      subband.tbx1 = Math.ceil(component.tcx1 / bscale - 0.5);
                      subband.tby1 = Math.ceil(component.tcy1 / bscale - 0.5);
                      subband.resolution = resolution;
                      buildCodeblocks(context, subband, blocksDimensions);
                      subbands.push(subband);
                      resolutionSubbands.push(subband);
                      resolution.subbands = resolutionSubbands;
                    }
                  }
                  component.resolutions = resolutions;
                  component.subbands = subbands;
                }
                const progressionOrder = tile.codingStyleDefaultParameters.progressionOrder;
                switch (progressionOrder) {
                  case 0:
                    tile.packetsIterator = new LayerResolutionComponentPositionIterator(context);
                    break;
                  case 1:
                    tile.packetsIterator = new ResolutionLayerComponentPositionIterator(context);
                    break;
                  case 2:
                    tile.packetsIterator = new ResolutionPositionComponentLayerIterator(context);
                    break;
                  case 3:
                    tile.packetsIterator = new PositionComponentResolutionLayerIterator(context);
                    break;
                  case 4:
                    tile.packetsIterator = new ComponentPositionResolutionLayerIterator(context);
                    break;
                  default:
                    throw new JpxError(`Unsupported progression order ${progressionOrder}`);
                }
              }
              function parseTilePackets(context, data2, offset4, dataLength) {
                let position3 = 0;
                let buffer, bufferSize = 0, skipNextBit = false;
                function readBits(count) {
                  while (bufferSize < count) {
                    const b = data2[offset4 + position3];
                    position3++;
                    if (skipNextBit) {
                      buffer = buffer << 7 | b;
                      bufferSize += 7;
                      skipNextBit = false;
                    } else {
                      buffer = buffer << 8 | b;
                      bufferSize += 8;
                    }
                    if (b === 255) {
                      skipNextBit = true;
                    }
                  }
                  bufferSize -= count;
                  return buffer >>> bufferSize & (1 << count) - 1;
                }
                function skipMarkerIfEqual(value) {
                  if (data2[offset4 + position3 - 1] === 255 && data2[offset4 + position3] === value) {
                    skipBytes(1);
                    return true;
                  } else if (data2[offset4 + position3] === 255 && data2[offset4 + position3 + 1] === value) {
                    skipBytes(2);
                    return true;
                  }
                  return false;
                }
                function skipBytes(count) {
                  position3 += count;
                }
                function alignToByte() {
                  bufferSize = 0;
                  if (skipNextBit) {
                    position3++;
                    skipNextBit = false;
                  }
                }
                function readCodingpasses() {
                  if (readBits(1) === 0) {
                    return 1;
                  }
                  if (readBits(1) === 0) {
                    return 2;
                  }
                  let value = readBits(2);
                  if (value < 3) {
                    return value + 3;
                  }
                  value = readBits(5);
                  if (value < 31) {
                    return value + 6;
                  }
                  value = readBits(7);
                  return value + 37;
                }
                const tileIndex = context.currentTile.index;
                const tile = context.tiles[tileIndex];
                const sopMarkerUsed = context.COD.sopMarkerUsed;
                const ephMarkerUsed = context.COD.ephMarkerUsed;
                const packetsIterator = tile.packetsIterator;
                while (position3 < dataLength) {
                  alignToByte();
                  if (sopMarkerUsed && skipMarkerIfEqual(145)) {
                    skipBytes(4);
                  }
                  const packet = packetsIterator.nextPacket();
                  if (!readBits(1)) {
                    continue;
                  }
                  const layerNumber = packet.layerNumber, queue = [];
                  let codeblock;
                  for (let i = 0, ii = packet.codeblocks.length; i < ii; i++) {
                    codeblock = packet.codeblocks[i];
                    let precinct = codeblock.precinct;
                    const codeblockColumn = codeblock.cbx - precinct.cbxMin;
                    const codeblockRow = codeblock.cby - precinct.cbyMin;
                    let codeblockIncluded = false;
                    let firstTimeInclusion = false;
                    let valueReady, zeroBitPlanesTree;
                    if (codeblock.included !== void 0) {
                      codeblockIncluded = !!readBits(1);
                    } else {
                      precinct = codeblock.precinct;
                      let inclusionTree;
                      if (precinct.inclusionTree !== void 0) {
                        inclusionTree = precinct.inclusionTree;
                      } else {
                        const width = precinct.cbxMax - precinct.cbxMin + 1;
                        const height = precinct.cbyMax - precinct.cbyMin + 1;
                        inclusionTree = new InclusionTree(width, height, layerNumber);
                        zeroBitPlanesTree = new TagTree(width, height);
                        precinct.inclusionTree = inclusionTree;
                        precinct.zeroBitPlanesTree = zeroBitPlanesTree;
                        for (let l2 = 0; l2 < layerNumber; l2++) {
                          if (readBits(1) !== 0) {
                            throw new JpxError("Invalid tag tree");
                          }
                        }
                      }
                      if (inclusionTree.reset(codeblockColumn, codeblockRow, layerNumber)) {
                        while (true) {
                          if (readBits(1)) {
                            valueReady = !inclusionTree.nextLevel();
                            if (valueReady) {
                              codeblock.included = true;
                              codeblockIncluded = firstTimeInclusion = true;
                              break;
                            }
                          } else {
                            inclusionTree.incrementValue(layerNumber);
                            break;
                          }
                        }
                      }
                    }
                    if (!codeblockIncluded) {
                      continue;
                    }
                    if (firstTimeInclusion) {
                      zeroBitPlanesTree = precinct.zeroBitPlanesTree;
                      zeroBitPlanesTree.reset(codeblockColumn, codeblockRow);
                      while (true) {
                        if (readBits(1)) {
                          valueReady = !zeroBitPlanesTree.nextLevel();
                          if (valueReady) {
                            break;
                          }
                        } else {
                          zeroBitPlanesTree.incrementValue();
                        }
                      }
                      codeblock.zeroBitPlanes = zeroBitPlanesTree.value;
                    }
                    const codingpasses = readCodingpasses();
                    while (readBits(1)) {
                      codeblock.Lblock++;
                    }
                    const codingpassesLog2 = (0, _core_utils.log2)(codingpasses);
                    const bits = (codingpasses < 1 << codingpassesLog2 ? codingpassesLog2 - 1 : codingpassesLog2) + codeblock.Lblock;
                    const codedDataLength = readBits(bits);
                    queue.push({
                      codeblock,
                      codingpasses,
                      dataLength: codedDataLength
                    });
                  }
                  alignToByte();
                  if (ephMarkerUsed) {
                    skipMarkerIfEqual(146);
                  }
                  while (queue.length > 0) {
                    const packetItem = queue.shift();
                    codeblock = packetItem.codeblock;
                    if (codeblock.data === void 0) {
                      codeblock.data = [];
                    }
                    codeblock.data.push({
                      data: data2,
                      start: offset4 + position3,
                      end: offset4 + position3 + packetItem.dataLength,
                      codingpasses: packetItem.codingpasses
                    });
                    position3 += packetItem.dataLength;
                  }
                }
                return position3;
              }
              function copyCoefficients(coefficients, levelWidth, levelHeight, subband, delta, mb, reversible, segmentationSymbolUsed, resetContextProbabilities) {
                const x0 = subband.tbx0;
                const y0 = subband.tby0;
                const width = subband.tbx1 - subband.tbx0;
                const codeblocks = subband.codeblocks;
                const right2 = subband.type.charAt(0) === "H" ? 1 : 0;
                const bottom = subband.type.charAt(1) === "H" ? levelWidth : 0;
                for (let i = 0, ii = codeblocks.length; i < ii; ++i) {
                  const codeblock = codeblocks[i];
                  const blockWidth = codeblock.tbx1_ - codeblock.tbx0_;
                  const blockHeight = codeblock.tby1_ - codeblock.tby0_;
                  if (blockWidth === 0 || blockHeight === 0) {
                    continue;
                  }
                  if (codeblock.data === void 0) {
                    continue;
                  }
                  const bitModel = new BitModel(blockWidth, blockHeight, codeblock.subbandType, codeblock.zeroBitPlanes, mb);
                  let currentCodingpassType = 2;
                  const data2 = codeblock.data;
                  let totalLength = 0, codingpasses = 0;
                  let j, jj, dataItem;
                  for (j = 0, jj = data2.length; j < jj; j++) {
                    dataItem = data2[j];
                    totalLength += dataItem.end - dataItem.start;
                    codingpasses += dataItem.codingpasses;
                  }
                  const encodedData = new Uint8Array(totalLength);
                  let position3 = 0;
                  for (j = 0, jj = data2.length; j < jj; j++) {
                    dataItem = data2[j];
                    const chunk = dataItem.data.subarray(dataItem.start, dataItem.end);
                    encodedData.set(chunk, position3);
                    position3 += chunk.length;
                  }
                  const decoder = new _arithmetic_decoder.ArithmeticDecoder(encodedData, 0, totalLength);
                  bitModel.setDecoder(decoder);
                  for (j = 0; j < codingpasses; j++) {
                    switch (currentCodingpassType) {
                      case 0:
                        bitModel.runSignificancePropagationPass();
                        break;
                      case 1:
                        bitModel.runMagnitudeRefinementPass();
                        break;
                      case 2:
                        bitModel.runCleanupPass();
                        if (segmentationSymbolUsed) {
                          bitModel.checkSegmentationSymbol();
                        }
                        break;
                    }
                    if (resetContextProbabilities) {
                      bitModel.reset();
                    }
                    currentCodingpassType = (currentCodingpassType + 1) % 3;
                  }
                  let offset4 = codeblock.tbx0_ - x0 + (codeblock.tby0_ - y0) * width;
                  const sign2 = bitModel.coefficentsSign;
                  const magnitude = bitModel.coefficentsMagnitude;
                  const bitsDecoded = bitModel.bitsDecoded;
                  const magnitudeCorrection = reversible ? 0 : 0.5;
                  let k, n2, nb;
                  position3 = 0;
                  const interleave = subband.type !== "LL";
                  for (j = 0; j < blockHeight; j++) {
                    const row = offset4 / width | 0;
                    const levelOffset = 2 * row * (levelWidth - width) + right2 + bottom;
                    for (k = 0; k < blockWidth; k++) {
                      n2 = magnitude[position3];
                      if (n2 !== 0) {
                        n2 = (n2 + magnitudeCorrection) * delta;
                        if (sign2[position3] !== 0) {
                          n2 = -n2;
                        }
                        nb = bitsDecoded[position3];
                        const pos = interleave ? levelOffset + (offset4 << 1) : offset4;
                        coefficients[pos] = reversible && nb >= mb ? n2 : n2 * (1 << mb - nb);
                      }
                      offset4++;
                      position3++;
                    }
                    offset4 += width - blockWidth;
                  }
                }
              }
              function transformTile(context, tile, c) {
                const component = tile.components[c];
                const codingStyleParameters = component.codingStyleParameters;
                const quantizationParameters = component.quantizationParameters;
                const decompositionLevelsCount = codingStyleParameters.decompositionLevelsCount;
                const spqcds = quantizationParameters.SPqcds;
                const scalarExpounded = quantizationParameters.scalarExpounded;
                const guardBits = quantizationParameters.guardBits;
                const segmentationSymbolUsed = codingStyleParameters.segmentationSymbolUsed;
                const resetContextProbabilities = codingStyleParameters.resetContextProbabilities;
                const precision = context.components[c].precision;
                const reversible = codingStyleParameters.reversibleTransformation;
                const transform = reversible ? new ReversibleTransform() : new IrreversibleTransform();
                const subbandCoefficients = [];
                let b = 0;
                for (let i = 0; i <= decompositionLevelsCount; i++) {
                  const resolution = component.resolutions[i];
                  const width = resolution.trx1 - resolution.trx0;
                  const height = resolution.try1 - resolution.try0;
                  const coefficients = new Float32Array(width * height);
                  for (let j = 0, jj = resolution.subbands.length; j < jj; j++) {
                    let mu, epsilon;
                    if (!scalarExpounded) {
                      mu = spqcds[0].mu;
                      epsilon = spqcds[0].epsilon + (i > 0 ? 1 - i : 0);
                    } else {
                      mu = spqcds[b].mu;
                      epsilon = spqcds[b].epsilon;
                      b++;
                    }
                    const subband = resolution.subbands[j];
                    const gainLog2 = SubbandsGainLog2[subband.type];
                    const delta = reversible ? 1 : 2 ** (precision + gainLog2 - epsilon) * (1 + mu / 2048);
                    const mb = guardBits + epsilon - 1;
                    copyCoefficients(coefficients, width, height, subband, delta, mb, reversible, segmentationSymbolUsed, resetContextProbabilities);
                  }
                  subbandCoefficients.push({
                    width,
                    height,
                    items: coefficients
                  });
                }
                const result = transform.calculate(subbandCoefficients, component.tcx0, component.tcy0);
                return {
                  left: component.tcx0,
                  top: component.tcy0,
                  width: result.width,
                  height: result.height,
                  items: result.items
                };
              }
              function transformComponents(context) {
                const siz = context.SIZ;
                const components = context.components;
                const componentsCount = siz.Csiz;
                const resultImages = [];
                for (let i = 0, ii = context.tiles.length; i < ii; i++) {
                  const tile = context.tiles[i];
                  const transformedTiles = [];
                  for (let c = 0; c < componentsCount; c++) {
                    transformedTiles[c] = transformTile(context, tile, c);
                  }
                  const tile0 = transformedTiles[0];
                  const out = new Uint8ClampedArray(tile0.items.length * componentsCount);
                  const result = {
                    left: tile0.left,
                    top: tile0.top,
                    width: tile0.width,
                    height: tile0.height,
                    items: out
                  };
                  let shift2, offset4;
                  let pos = 0, j, jj, y0, y1, y2;
                  if (tile.codingStyleDefaultParameters.multipleComponentTransform) {
                    const fourComponents = componentsCount === 4;
                    const y0items = transformedTiles[0].items;
                    const y1items = transformedTiles[1].items;
                    const y2items = transformedTiles[2].items;
                    const y3items = fourComponents ? transformedTiles[3].items : null;
                    shift2 = components[0].precision - 8;
                    offset4 = (128 << shift2) + 0.5;
                    const component0 = tile.components[0];
                    const alpha01 = componentsCount - 3;
                    jj = y0items.length;
                    if (!component0.codingStyleParameters.reversibleTransformation) {
                      for (j = 0; j < jj; j++, pos += alpha01) {
                        y0 = y0items[j] + offset4;
                        y1 = y1items[j];
                        y2 = y2items[j];
                        out[pos++] = y0 + 1.402 * y2 >> shift2;
                        out[pos++] = y0 - 0.34413 * y1 - 0.71414 * y2 >> shift2;
                        out[pos++] = y0 + 1.772 * y1 >> shift2;
                      }
                    } else {
                      for (j = 0; j < jj; j++, pos += alpha01) {
                        y0 = y0items[j] + offset4;
                        y1 = y1items[j];
                        y2 = y2items[j];
                        const g = y0 - (y2 + y1 >> 2);
                        out[pos++] = g + y2 >> shift2;
                        out[pos++] = g >> shift2;
                        out[pos++] = g + y1 >> shift2;
                      }
                    }
                    if (fourComponents) {
                      for (j = 0, pos = 3; j < jj; j++, pos += 4) {
                        out[pos] = y3items[j] + offset4 >> shift2;
                      }
                    }
                  } else {
                    for (let c = 0; c < componentsCount; c++) {
                      const items = transformedTiles[c].items;
                      shift2 = components[c].precision - 8;
                      offset4 = (128 << shift2) + 0.5;
                      for (pos = c, j = 0, jj = items.length; j < jj; j++) {
                        out[pos] = items[j] + offset4 >> shift2;
                        pos += componentsCount;
                      }
                    }
                  }
                  resultImages.push(result);
                }
                return resultImages;
              }
              function initializeTile(context, tileIndex) {
                const siz = context.SIZ;
                const componentsCount = siz.Csiz;
                const tile = context.tiles[tileIndex];
                for (let c = 0; c < componentsCount; c++) {
                  const component = tile.components[c];
                  const qcdOrQcc = context.currentTile.QCC[c] !== void 0 ? context.currentTile.QCC[c] : context.currentTile.QCD;
                  component.quantizationParameters = qcdOrQcc;
                  const codOrCoc = context.currentTile.COC[c] !== void 0 ? context.currentTile.COC[c] : context.currentTile.COD;
                  component.codingStyleParameters = codOrCoc;
                }
                tile.codingStyleDefaultParameters = context.currentTile.COD;
              }
              class TagTree {
                constructor(width, height) {
                  const levelsLength = (0, _core_utils.log2)(Math.max(width, height)) + 1;
                  this.levels = [];
                  for (let i = 0; i < levelsLength; i++) {
                    const level = {
                      width,
                      height,
                      items: []
                    };
                    this.levels.push(level);
                    width = Math.ceil(width / 2);
                    height = Math.ceil(height / 2);
                  }
                }
                reset(i, j) {
                  let currentLevel = 0, value = 0, level;
                  while (currentLevel < this.levels.length) {
                    level = this.levels[currentLevel];
                    const index3 = i + j * level.width;
                    if (level.items[index3] !== void 0) {
                      value = level.items[index3];
                      break;
                    }
                    level.index = index3;
                    i >>= 1;
                    j >>= 1;
                    currentLevel++;
                  }
                  currentLevel--;
                  level = this.levels[currentLevel];
                  level.items[level.index] = value;
                  this.currentLevel = currentLevel;
                  delete this.value;
                }
                incrementValue() {
                  const level = this.levels[this.currentLevel];
                  level.items[level.index]++;
                }
                nextLevel() {
                  let currentLevel = this.currentLevel;
                  let level = this.levels[currentLevel];
                  const value = level.items[level.index];
                  currentLevel--;
                  if (currentLevel < 0) {
                    this.value = value;
                    return false;
                  }
                  this.currentLevel = currentLevel;
                  level = this.levels[currentLevel];
                  level.items[level.index] = value;
                  return true;
                }
              }
              class InclusionTree {
                constructor(width, height, defaultValue2) {
                  const levelsLength = (0, _core_utils.log2)(Math.max(width, height)) + 1;
                  this.levels = [];
                  for (let i = 0; i < levelsLength; i++) {
                    const items = new Uint8Array(width * height);
                    for (let j = 0, jj = items.length; j < jj; j++) {
                      items[j] = defaultValue2;
                    }
                    const level = {
                      width,
                      height,
                      items
                    };
                    this.levels.push(level);
                    width = Math.ceil(width / 2);
                    height = Math.ceil(height / 2);
                  }
                }
                reset(i, j, stopValue) {
                  let currentLevel = 0;
                  while (currentLevel < this.levels.length) {
                    const level = this.levels[currentLevel];
                    const index3 = i + j * level.width;
                    level.index = index3;
                    const value = level.items[index3];
                    if (value === 255) {
                      break;
                    }
                    if (value > stopValue) {
                      this.currentLevel = currentLevel;
                      this.propagateValues();
                      return false;
                    }
                    i >>= 1;
                    j >>= 1;
                    currentLevel++;
                  }
                  this.currentLevel = currentLevel - 1;
                  return true;
                }
                incrementValue(stopValue) {
                  const level = this.levels[this.currentLevel];
                  level.items[level.index] = stopValue + 1;
                  this.propagateValues();
                }
                propagateValues() {
                  let levelIndex = this.currentLevel;
                  let level = this.levels[levelIndex];
                  const currentValue = level.items[level.index];
                  while (--levelIndex >= 0) {
                    level = this.levels[levelIndex];
                    level.items[level.index] = currentValue;
                  }
                }
                nextLevel() {
                  let currentLevel = this.currentLevel;
                  let level = this.levels[currentLevel];
                  const value = level.items[level.index];
                  level.items[level.index] = 255;
                  currentLevel--;
                  if (currentLevel < 0) {
                    return false;
                  }
                  this.currentLevel = currentLevel;
                  level = this.levels[currentLevel];
                  level.items[level.index] = value;
                  return true;
                }
              }
              class BitModel {
                static UNIFORM_CONTEXT = 17;
                static RUNLENGTH_CONTEXT = 18;
                static LLAndLHContextsLabel = new Uint8Array([0, 5, 8, 0, 3, 7, 8, 0, 4, 7, 8, 0, 0, 0, 0, 0, 1, 6, 8, 0, 3, 7, 8, 0, 4, 7, 8, 0, 0, 0, 0, 0, 2, 6, 8, 0, 3, 7, 8, 0, 4, 7, 8, 0, 0, 0, 0, 0, 2, 6, 8, 0, 3, 7, 8, 0, 4, 7, 8, 0, 0, 0, 0, 0, 2, 6, 8, 0, 3, 7, 8, 0, 4, 7, 8]);
                static HLContextLabel = new Uint8Array([0, 3, 4, 0, 5, 7, 7, 0, 8, 8, 8, 0, 0, 0, 0, 0, 1, 3, 4, 0, 6, 7, 7, 0, 8, 8, 8, 0, 0, 0, 0, 0, 2, 3, 4, 0, 6, 7, 7, 0, 8, 8, 8, 0, 0, 0, 0, 0, 2, 3, 4, 0, 6, 7, 7, 0, 8, 8, 8, 0, 0, 0, 0, 0, 2, 3, 4, 0, 6, 7, 7, 0, 8, 8, 8]);
                static HHContextLabel = new Uint8Array([0, 1, 2, 0, 1, 2, 2, 0, 2, 2, 2, 0, 0, 0, 0, 0, 3, 4, 5, 0, 4, 5, 5, 0, 5, 5, 5, 0, 0, 0, 0, 0, 6, 7, 7, 0, 7, 7, 7, 0, 7, 7, 7, 0, 0, 0, 0, 0, 8, 8, 8, 0, 8, 8, 8, 0, 8, 8, 8, 0, 0, 0, 0, 0, 8, 8, 8, 0, 8, 8, 8, 0, 8, 8, 8]);
                constructor(width, height, subband, zeroBitPlanes, mb) {
                  this.width = width;
                  this.height = height;
                  let contextLabelTable;
                  if (subband === "HH") {
                    contextLabelTable = BitModel.HHContextLabel;
                  } else if (subband === "HL") {
                    contextLabelTable = BitModel.HLContextLabel;
                  } else {
                    contextLabelTable = BitModel.LLAndLHContextsLabel;
                  }
                  this.contextLabelTable = contextLabelTable;
                  const coefficientCount = width * height;
                  this.neighborsSignificance = new Uint8Array(coefficientCount);
                  this.coefficentsSign = new Uint8Array(coefficientCount);
                  let coefficentsMagnitude;
                  if (mb > 14) {
                    coefficentsMagnitude = new Uint32Array(coefficientCount);
                  } else if (mb > 6) {
                    coefficentsMagnitude = new Uint16Array(coefficientCount);
                  } else {
                    coefficentsMagnitude = new Uint8Array(coefficientCount);
                  }
                  this.coefficentsMagnitude = coefficentsMagnitude;
                  this.processingFlags = new Uint8Array(coefficientCount);
                  const bitsDecoded = new Uint8Array(coefficientCount);
                  if (zeroBitPlanes !== 0) {
                    for (let i = 0; i < coefficientCount; i++) {
                      bitsDecoded[i] = zeroBitPlanes;
                    }
                  }
                  this.bitsDecoded = bitsDecoded;
                  this.reset();
                }
                setDecoder(decoder) {
                  this.decoder = decoder;
                }
                reset() {
                  this.contexts = new Int8Array(19);
                  this.contexts[0] = 4 << 1 | 0;
                  this.contexts[BitModel.UNIFORM_CONTEXT] = 46 << 1 | 0;
                  this.contexts[BitModel.RUNLENGTH_CONTEXT] = 3 << 1 | 0;
                }
                setNeighborsSignificance(row, column2, index3) {
                  const neighborsSignificance = this.neighborsSignificance;
                  const width = this.width, height = this.height;
                  const left2 = column2 > 0;
                  const right2 = column2 + 1 < width;
                  let i;
                  if (row > 0) {
                    i = index3 - width;
                    if (left2) {
                      neighborsSignificance[i - 1] += 16;
                    }
                    if (right2) {
                      neighborsSignificance[i + 1] += 16;
                    }
                    neighborsSignificance[i] += 4;
                  }
                  if (row + 1 < height) {
                    i = index3 + width;
                    if (left2) {
                      neighborsSignificance[i - 1] += 16;
                    }
                    if (right2) {
                      neighborsSignificance[i + 1] += 16;
                    }
                    neighborsSignificance[i] += 4;
                  }
                  if (left2) {
                    neighborsSignificance[index3 - 1] += 1;
                  }
                  if (right2) {
                    neighborsSignificance[index3 + 1] += 1;
                  }
                  neighborsSignificance[index3] |= 128;
                }
                runSignificancePropagationPass() {
                  const decoder = this.decoder;
                  const width = this.width, height = this.height;
                  const coefficentsMagnitude = this.coefficentsMagnitude;
                  const coefficentsSign = this.coefficentsSign;
                  const neighborsSignificance = this.neighborsSignificance;
                  const processingFlags = this.processingFlags;
                  const contexts = this.contexts;
                  const labels = this.contextLabelTable;
                  const bitsDecoded = this.bitsDecoded;
                  const processedInverseMask = ~1;
                  const processedMask = 1;
                  const firstMagnitudeBitMask = 2;
                  for (let i0 = 0; i0 < height; i0 += 4) {
                    for (let j = 0; j < width; j++) {
                      let index3 = i0 * width + j;
                      for (let i1 = 0; i1 < 4; i1++, index3 += width) {
                        const i = i0 + i1;
                        if (i >= height) {
                          break;
                        }
                        processingFlags[index3] &= processedInverseMask;
                        if (coefficentsMagnitude[index3] || !neighborsSignificance[index3]) {
                          continue;
                        }
                        const contextLabel = labels[neighborsSignificance[index3]];
                        const decision = decoder.readBit(contexts, contextLabel);
                        if (decision) {
                          const sign2 = this.decodeSignBit(i, j, index3);
                          coefficentsSign[index3] = sign2;
                          coefficentsMagnitude[index3] = 1;
                          this.setNeighborsSignificance(i, j, index3);
                          processingFlags[index3] |= firstMagnitudeBitMask;
                        }
                        bitsDecoded[index3]++;
                        processingFlags[index3] |= processedMask;
                      }
                    }
                  }
                }
                decodeSignBit(row, column2, index3) {
                  const width = this.width, height = this.height;
                  const coefficentsMagnitude = this.coefficentsMagnitude;
                  const coefficentsSign = this.coefficentsSign;
                  let contribution, sign0, sign1, significance1;
                  let contextLabel, decoded;
                  significance1 = column2 > 0 && coefficentsMagnitude[index3 - 1] !== 0;
                  if (column2 + 1 < width && coefficentsMagnitude[index3 + 1] !== 0) {
                    sign1 = coefficentsSign[index3 + 1];
                    if (significance1) {
                      sign0 = coefficentsSign[index3 - 1];
                      contribution = 1 - sign1 - sign0;
                    } else {
                      contribution = 1 - sign1 - sign1;
                    }
                  } else if (significance1) {
                    sign0 = coefficentsSign[index3 - 1];
                    contribution = 1 - sign0 - sign0;
                  } else {
                    contribution = 0;
                  }
                  const horizontalContribution = 3 * contribution;
                  significance1 = row > 0 && coefficentsMagnitude[index3 - width] !== 0;
                  if (row + 1 < height && coefficentsMagnitude[index3 + width] !== 0) {
                    sign1 = coefficentsSign[index3 + width];
                    if (significance1) {
                      sign0 = coefficentsSign[index3 - width];
                      contribution = 1 - sign1 - sign0 + horizontalContribution;
                    } else {
                      contribution = 1 - sign1 - sign1 + horizontalContribution;
                    }
                  } else if (significance1) {
                    sign0 = coefficentsSign[index3 - width];
                    contribution = 1 - sign0 - sign0 + horizontalContribution;
                  } else {
                    contribution = horizontalContribution;
                  }
                  if (contribution >= 0) {
                    contextLabel = 9 + contribution;
                    decoded = this.decoder.readBit(this.contexts, contextLabel);
                  } else {
                    contextLabel = 9 - contribution;
                    decoded = this.decoder.readBit(this.contexts, contextLabel) ^ 1;
                  }
                  return decoded;
                }
                runMagnitudeRefinementPass() {
                  const decoder = this.decoder;
                  const width = this.width, height = this.height;
                  const coefficentsMagnitude = this.coefficentsMagnitude;
                  const neighborsSignificance = this.neighborsSignificance;
                  const contexts = this.contexts;
                  const bitsDecoded = this.bitsDecoded;
                  const processingFlags = this.processingFlags;
                  const processedMask = 1;
                  const firstMagnitudeBitMask = 2;
                  const length2 = width * height;
                  const width4 = width * 4;
                  for (let index0 = 0, indexNext; index0 < length2; index0 = indexNext) {
                    indexNext = Math.min(length2, index0 + width4);
                    for (let j = 0; j < width; j++) {
                      for (let index3 = index0 + j; index3 < indexNext; index3 += width) {
                        if (!coefficentsMagnitude[index3] || (processingFlags[index3] & processedMask) !== 0) {
                          continue;
                        }
                        let contextLabel = 16;
                        if ((processingFlags[index3] & firstMagnitudeBitMask) !== 0) {
                          processingFlags[index3] ^= firstMagnitudeBitMask;
                          const significance = neighborsSignificance[index3] & 127;
                          contextLabel = significance === 0 ? 15 : 14;
                        }
                        const bit = decoder.readBit(contexts, contextLabel);
                        coefficentsMagnitude[index3] = coefficentsMagnitude[index3] << 1 | bit;
                        bitsDecoded[index3]++;
                        processingFlags[index3] |= processedMask;
                      }
                    }
                  }
                }
                runCleanupPass() {
                  const decoder = this.decoder;
                  const width = this.width, height = this.height;
                  const neighborsSignificance = this.neighborsSignificance;
                  const coefficentsMagnitude = this.coefficentsMagnitude;
                  const coefficentsSign = this.coefficentsSign;
                  const contexts = this.contexts;
                  const labels = this.contextLabelTable;
                  const bitsDecoded = this.bitsDecoded;
                  const processingFlags = this.processingFlags;
                  const processedMask = 1;
                  const firstMagnitudeBitMask = 2;
                  const oneRowDown = width;
                  const twoRowsDown = width * 2;
                  const threeRowsDown = width * 3;
                  let iNext;
                  for (let i0 = 0; i0 < height; i0 = iNext) {
                    iNext = Math.min(i0 + 4, height);
                    const indexBase = i0 * width;
                    const checkAllEmpty = i0 + 3 < height;
                    for (let j = 0; j < width; j++) {
                      const index0 = indexBase + j;
                      const allEmpty = checkAllEmpty && processingFlags[index0] === 0 && processingFlags[index0 + oneRowDown] === 0 && processingFlags[index0 + twoRowsDown] === 0 && processingFlags[index0 + threeRowsDown] === 0 && neighborsSignificance[index0] === 0 && neighborsSignificance[index0 + oneRowDown] === 0 && neighborsSignificance[index0 + twoRowsDown] === 0 && neighborsSignificance[index0 + threeRowsDown] === 0;
                      let i1 = 0, index3 = index0;
                      let i = i0, sign2;
                      if (allEmpty) {
                        const hasSignificantCoefficent = decoder.readBit(contexts, BitModel.RUNLENGTH_CONTEXT);
                        if (!hasSignificantCoefficent) {
                          bitsDecoded[index0]++;
                          bitsDecoded[index0 + oneRowDown]++;
                          bitsDecoded[index0 + twoRowsDown]++;
                          bitsDecoded[index0 + threeRowsDown]++;
                          continue;
                        }
                        i1 = decoder.readBit(contexts, BitModel.UNIFORM_CONTEXT) << 1 | decoder.readBit(contexts, BitModel.UNIFORM_CONTEXT);
                        if (i1 !== 0) {
                          i = i0 + i1;
                          index3 += i1 * width;
                        }
                        sign2 = this.decodeSignBit(i, j, index3);
                        coefficentsSign[index3] = sign2;
                        coefficentsMagnitude[index3] = 1;
                        this.setNeighborsSignificance(i, j, index3);
                        processingFlags[index3] |= firstMagnitudeBitMask;
                        index3 = index0;
                        for (let i2 = i0; i2 <= i; i2++, index3 += width) {
                          bitsDecoded[index3]++;
                        }
                        i1++;
                      }
                      for (i = i0 + i1; i < iNext; i++, index3 += width) {
                        if (coefficentsMagnitude[index3] || (processingFlags[index3] & processedMask) !== 0) {
                          continue;
                        }
                        const contextLabel = labels[neighborsSignificance[index3]];
                        const decision = decoder.readBit(contexts, contextLabel);
                        if (decision === 1) {
                          sign2 = this.decodeSignBit(i, j, index3);
                          coefficentsSign[index3] = sign2;
                          coefficentsMagnitude[index3] = 1;
                          this.setNeighborsSignificance(i, j, index3);
                          processingFlags[index3] |= firstMagnitudeBitMask;
                        }
                        bitsDecoded[index3]++;
                      }
                    }
                  }
                }
                checkSegmentationSymbol() {
                  const decoder = this.decoder;
                  const contexts = this.contexts;
                  const symbol = decoder.readBit(contexts, BitModel.UNIFORM_CONTEXT) << 3 | decoder.readBit(contexts, BitModel.UNIFORM_CONTEXT) << 2 | decoder.readBit(contexts, BitModel.UNIFORM_CONTEXT) << 1 | decoder.readBit(contexts, BitModel.UNIFORM_CONTEXT);
                  if (symbol !== 10) {
                    throw new JpxError("Invalid segmentation symbol");
                  }
                }
              }
              class Transform2 {
                constructor() {
                  if (this.constructor === Transform2) {
                    (0, _util2.unreachable)("Cannot initialize Transform.");
                  }
                }
                calculate(subbands, u0, v0) {
                  let ll = subbands[0];
                  for (let i = 1, ii = subbands.length; i < ii; i++) {
                    ll = this.iterate(ll, subbands[i], u0, v0);
                  }
                  return ll;
                }
                extend(buffer, offset4, size) {
                  let i1 = offset4 - 1, j1 = offset4 + 1;
                  let i2 = offset4 + size - 2, j2 = offset4 + size;
                  buffer[i1--] = buffer[j1++];
                  buffer[j2++] = buffer[i2--];
                  buffer[i1--] = buffer[j1++];
                  buffer[j2++] = buffer[i2--];
                  buffer[i1--] = buffer[j1++];
                  buffer[j2++] = buffer[i2--];
                  buffer[i1] = buffer[j1];
                  buffer[j2] = buffer[i2];
                }
                filter(x, offset4, length2) {
                  (0, _util2.unreachable)("Abstract method `filter` called");
                }
                iterate(ll, hl_lh_hh, u0, v0) {
                  const llWidth = ll.width, llHeight = ll.height;
                  let llItems = ll.items;
                  const width = hl_lh_hh.width;
                  const height = hl_lh_hh.height;
                  const items = hl_lh_hh.items;
                  let i, j, k, l2, u, v;
                  for (k = 0, i = 0; i < llHeight; i++) {
                    l2 = i * 2 * width;
                    for (j = 0; j < llWidth; j++, k++, l2 += 2) {
                      items[l2] = llItems[k];
                    }
                  }
                  llItems = ll.items = null;
                  const bufferPadding = 4;
                  const rowBuffer = new Float32Array(width + 2 * bufferPadding);
                  if (width === 1) {
                    if ((u0 & 1) !== 0) {
                      for (v = 0, k = 0; v < height; v++, k += width) {
                        items[k] *= 0.5;
                      }
                    }
                  } else {
                    for (v = 0, k = 0; v < height; v++, k += width) {
                      rowBuffer.set(items.subarray(k, k + width), bufferPadding);
                      this.extend(rowBuffer, bufferPadding, width);
                      this.filter(rowBuffer, bufferPadding, width);
                      items.set(rowBuffer.subarray(bufferPadding, bufferPadding + width), k);
                    }
                  }
                  let numBuffers = 16;
                  const colBuffers = [];
                  for (i = 0; i < numBuffers; i++) {
                    colBuffers.push(new Float32Array(height + 2 * bufferPadding));
                  }
                  let b, currentBuffer = 0;
                  ll = bufferPadding + height;
                  if (height === 1) {
                    if ((v0 & 1) !== 0) {
                      for (u = 0; u < width; u++) {
                        items[u] *= 0.5;
                      }
                    }
                  } else {
                    for (u = 0; u < width; u++) {
                      if (currentBuffer === 0) {
                        numBuffers = Math.min(width - u, numBuffers);
                        for (k = u, l2 = bufferPadding; l2 < ll; k += width, l2++) {
                          for (b = 0; b < numBuffers; b++) {
                            colBuffers[b][l2] = items[k + b];
                          }
                        }
                        currentBuffer = numBuffers;
                      }
                      currentBuffer--;
                      const buffer = colBuffers[currentBuffer];
                      this.extend(buffer, bufferPadding, height);
                      this.filter(buffer, bufferPadding, height);
                      if (currentBuffer === 0) {
                        k = u - numBuffers + 1;
                        for (l2 = bufferPadding; l2 < ll; k += width, l2++) {
                          for (b = 0; b < numBuffers; b++) {
                            items[k + b] = colBuffers[b][l2];
                          }
                        }
                      }
                    }
                  }
                  return {
                    width,
                    height,
                    items
                  };
                }
              }
              class IrreversibleTransform extends Transform2 {
                filter(x, offset4, length2) {
                  const len = length2 >> 1;
                  offset4 |= 0;
                  let j, n2, current2, next2;
                  const alpha = -1.586134342059924;
                  const beta = -0.052980118572961;
                  const gamma = 0.882911075530934;
                  const delta = 0.443506852043971;
                  const K = 1.230174104914001;
                  const K_ = 1 / K;
                  j = offset4 - 3;
                  for (n2 = len + 4; n2--; j += 2) {
                    x[j] *= K_;
                  }
                  j = offset4 - 2;
                  current2 = delta * x[j - 1];
                  for (n2 = len + 3; n2--; j += 2) {
                    next2 = delta * x[j + 1];
                    x[j] = K * x[j] - current2 - next2;
                    if (n2--) {
                      j += 2;
                      current2 = delta * x[j + 1];
                      x[j] = K * x[j] - current2 - next2;
                    } else {
                      break;
                    }
                  }
                  j = offset4 - 1;
                  current2 = gamma * x[j - 1];
                  for (n2 = len + 2; n2--; j += 2) {
                    next2 = gamma * x[j + 1];
                    x[j] -= current2 + next2;
                    if (n2--) {
                      j += 2;
                      current2 = gamma * x[j + 1];
                      x[j] -= current2 + next2;
                    } else {
                      break;
                    }
                  }
                  j = offset4;
                  current2 = beta * x[j - 1];
                  for (n2 = len + 1; n2--; j += 2) {
                    next2 = beta * x[j + 1];
                    x[j] -= current2 + next2;
                    if (n2--) {
                      j += 2;
                      current2 = beta * x[j + 1];
                      x[j] -= current2 + next2;
                    } else {
                      break;
                    }
                  }
                  if (len !== 0) {
                    j = offset4 + 1;
                    current2 = alpha * x[j - 1];
                    for (n2 = len; n2--; j += 2) {
                      next2 = alpha * x[j + 1];
                      x[j] -= current2 + next2;
                      if (n2--) {
                        j += 2;
                        current2 = alpha * x[j + 1];
                        x[j] -= current2 + next2;
                      } else {
                        break;
                      }
                    }
                  }
                }
              }
              class ReversibleTransform extends Transform2 {
                filter(x, offset4, length2) {
                  const len = length2 >> 1;
                  offset4 |= 0;
                  let j, n2;
                  for (j = offset4, n2 = len + 1; n2--; j += 2) {
                    x[j] -= x[j - 1] + x[j + 1] + 2 >> 2;
                  }
                  for (j = offset4 + 1, n2 = len; n2--; j += 2) {
                    x[j] += x[j - 1] + x[j + 1] >> 1;
                  }
                }
              }
            }),
            /* 31 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.LZWStream = void 0;
              var _decode_stream = __w_pdfjs_require__3(18);
              class LZWStream extends _decode_stream.DecodeStream {
                constructor(str, maybeLength, earlyChange) {
                  super(maybeLength);
                  this.str = str;
                  this.dict = str.dict;
                  this.cachedData = 0;
                  this.bitsCached = 0;
                  const maxLzwDictionarySize = 4096;
                  const lzwState = {
                    earlyChange,
                    codeLength: 9,
                    nextCode: 258,
                    dictionaryValues: new Uint8Array(maxLzwDictionarySize),
                    dictionaryLengths: new Uint16Array(maxLzwDictionarySize),
                    dictionaryPrevCodes: new Uint16Array(maxLzwDictionarySize),
                    currentSequence: new Uint8Array(maxLzwDictionarySize),
                    currentSequenceLength: 0
                  };
                  for (let i = 0; i < 256; ++i) {
                    lzwState.dictionaryValues[i] = i;
                    lzwState.dictionaryLengths[i] = 1;
                  }
                  this.lzwState = lzwState;
                }
                readBits(n2) {
                  let bitsCached = this.bitsCached;
                  let cachedData = this.cachedData;
                  while (bitsCached < n2) {
                    const c = this.str.getByte();
                    if (c === -1) {
                      this.eof = true;
                      return null;
                    }
                    cachedData = cachedData << 8 | c;
                    bitsCached += 8;
                  }
                  this.bitsCached = bitsCached -= n2;
                  this.cachedData = cachedData;
                  this.lastCode = null;
                  return cachedData >>> bitsCached & (1 << n2) - 1;
                }
                readBlock() {
                  const blockSize = 512, decodedSizeDelta = blockSize;
                  let estimatedDecodedSize = blockSize * 2;
                  let i, j, q;
                  const lzwState = this.lzwState;
                  if (!lzwState) {
                    return;
                  }
                  const earlyChange = lzwState.earlyChange;
                  let nextCode = lzwState.nextCode;
                  const dictionaryValues = lzwState.dictionaryValues;
                  const dictionaryLengths = lzwState.dictionaryLengths;
                  const dictionaryPrevCodes = lzwState.dictionaryPrevCodes;
                  let codeLength = lzwState.codeLength;
                  let prevCode = lzwState.prevCode;
                  const currentSequence = lzwState.currentSequence;
                  let currentSequenceLength = lzwState.currentSequenceLength;
                  let decodedLength = 0;
                  let currentBufferLength = this.bufferLength;
                  let buffer = this.ensureBuffer(this.bufferLength + estimatedDecodedSize);
                  for (i = 0; i < blockSize; i++) {
                    const code2 = this.readBits(codeLength);
                    const hasPrev = currentSequenceLength > 0;
                    if (code2 < 256) {
                      currentSequence[0] = code2;
                      currentSequenceLength = 1;
                    } else if (code2 >= 258) {
                      if (code2 < nextCode) {
                        currentSequenceLength = dictionaryLengths[code2];
                        for (j = currentSequenceLength - 1, q = code2; j >= 0; j--) {
                          currentSequence[j] = dictionaryValues[q];
                          q = dictionaryPrevCodes[q];
                        }
                      } else {
                        currentSequence[currentSequenceLength++] = currentSequence[0];
                      }
                    } else if (code2 === 256) {
                      codeLength = 9;
                      nextCode = 258;
                      currentSequenceLength = 0;
                      continue;
                    } else {
                      this.eof = true;
                      delete this.lzwState;
                      break;
                    }
                    if (hasPrev) {
                      dictionaryPrevCodes[nextCode] = prevCode;
                      dictionaryLengths[nextCode] = dictionaryLengths[prevCode] + 1;
                      dictionaryValues[nextCode] = currentSequence[0];
                      nextCode++;
                      codeLength = nextCode + earlyChange & nextCode + earlyChange - 1 ? codeLength : Math.min(Math.log(nextCode + earlyChange) / 0.6931471805599453 + 1, 12) | 0;
                    }
                    prevCode = code2;
                    decodedLength += currentSequenceLength;
                    if (estimatedDecodedSize < decodedLength) {
                      do {
                        estimatedDecodedSize += decodedSizeDelta;
                      } while (estimatedDecodedSize < decodedLength);
                      buffer = this.ensureBuffer(this.bufferLength + estimatedDecodedSize);
                    }
                    for (j = 0; j < currentSequenceLength; j++) {
                      buffer[currentBufferLength++] = currentSequence[j];
                    }
                  }
                  lzwState.nextCode = nextCode;
                  lzwState.codeLength = codeLength;
                  lzwState.prevCode = prevCode;
                  lzwState.currentSequenceLength = currentSequenceLength;
                  this.bufferLength = currentBufferLength;
                }
              }
              exports3.LZWStream = LZWStream;
            }),
            /* 32 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.PredictorStream = void 0;
              var _decode_stream = __w_pdfjs_require__3(18);
              var _primitives = __w_pdfjs_require__3(4);
              var _util2 = __w_pdfjs_require__3(2);
              class PredictorStream extends _decode_stream.DecodeStream {
                constructor(str, maybeLength, params) {
                  super(maybeLength);
                  if (!(params instanceof _primitives.Dict)) {
                    return str;
                  }
                  const predictor = this.predictor = params.get("Predictor") || 1;
                  if (predictor <= 1) {
                    return str;
                  }
                  if (predictor !== 2 && (predictor < 10 || predictor > 15)) {
                    throw new _util2.FormatError(`Unsupported predictor: ${predictor}`);
                  }
                  this.readBlock = predictor === 2 ? this.readBlockTiff : this.readBlockPng;
                  this.str = str;
                  this.dict = str.dict;
                  const colors = this.colors = params.get("Colors") || 1;
                  const bits = this.bits = params.get("BPC", "BitsPerComponent") || 8;
                  const columns = this.columns = params.get("Columns") || 1;
                  this.pixBytes = colors * bits + 7 >> 3;
                  this.rowBytes = columns * colors * bits + 7 >> 3;
                  return this;
                }
                readBlockTiff() {
                  const rowBytes = this.rowBytes;
                  const bufferLength = this.bufferLength;
                  const buffer = this.ensureBuffer(bufferLength + rowBytes);
                  const bits = this.bits;
                  const colors = this.colors;
                  const rawBytes = this.str.getBytes(rowBytes);
                  this.eof = !rawBytes.length;
                  if (this.eof) {
                    return;
                  }
                  let inbuf = 0, outbuf = 0;
                  let inbits = 0, outbits = 0;
                  let pos = bufferLength;
                  let i;
                  if (bits === 1 && colors === 1) {
                    for (i = 0; i < rowBytes; ++i) {
                      let c = rawBytes[i] ^ inbuf;
                      c ^= c >> 1;
                      c ^= c >> 2;
                      c ^= c >> 4;
                      inbuf = (c & 1) << 7;
                      buffer[pos++] = c;
                    }
                  } else if (bits === 8) {
                    for (i = 0; i < colors; ++i) {
                      buffer[pos++] = rawBytes[i];
                    }
                    for (; i < rowBytes; ++i) {
                      buffer[pos] = buffer[pos - colors] + rawBytes[i];
                      pos++;
                    }
                  } else if (bits === 16) {
                    const bytesPerPixel = colors * 2;
                    for (i = 0; i < bytesPerPixel; ++i) {
                      buffer[pos++] = rawBytes[i];
                    }
                    for (; i < rowBytes; i += 2) {
                      const sum2 = ((rawBytes[i] & 255) << 8) + (rawBytes[i + 1] & 255) + ((buffer[pos - bytesPerPixel] & 255) << 8) + (buffer[pos - bytesPerPixel + 1] & 255);
                      buffer[pos++] = sum2 >> 8 & 255;
                      buffer[pos++] = sum2 & 255;
                    }
                  } else {
                    const compArray = new Uint8Array(colors + 1);
                    const bitMask = (1 << bits) - 1;
                    let j = 0, k = bufferLength;
                    const columns = this.columns;
                    for (i = 0; i < columns; ++i) {
                      for (let kk = 0; kk < colors; ++kk) {
                        if (inbits < bits) {
                          inbuf = inbuf << 8 | rawBytes[j++] & 255;
                          inbits += 8;
                        }
                        compArray[kk] = compArray[kk] + (inbuf >> inbits - bits) & bitMask;
                        inbits -= bits;
                        outbuf = outbuf << bits | compArray[kk];
                        outbits += bits;
                        if (outbits >= 8) {
                          buffer[k++] = outbuf >> outbits - 8 & 255;
                          outbits -= 8;
                        }
                      }
                    }
                    if (outbits > 0) {
                      buffer[k++] = (outbuf << 8 - outbits) + (inbuf & (1 << 8 - outbits) - 1);
                    }
                  }
                  this.bufferLength += rowBytes;
                }
                readBlockPng() {
                  const rowBytes = this.rowBytes;
                  const pixBytes = this.pixBytes;
                  const predictor = this.str.getByte();
                  const rawBytes = this.str.getBytes(rowBytes);
                  this.eof = !rawBytes.length;
                  if (this.eof) {
                    return;
                  }
                  const bufferLength = this.bufferLength;
                  const buffer = this.ensureBuffer(bufferLength + rowBytes);
                  let prevRow = buffer.subarray(bufferLength - rowBytes, bufferLength);
                  if (prevRow.length === 0) {
                    prevRow = new Uint8Array(rowBytes);
                  }
                  let i, j = bufferLength, up2, c;
                  switch (predictor) {
                    case 0:
                      for (i = 0; i < rowBytes; ++i) {
                        buffer[j++] = rawBytes[i];
                      }
                      break;
                    case 1:
                      for (i = 0; i < pixBytes; ++i) {
                        buffer[j++] = rawBytes[i];
                      }
                      for (; i < rowBytes; ++i) {
                        buffer[j] = buffer[j - pixBytes] + rawBytes[i] & 255;
                        j++;
                      }
                      break;
                    case 2:
                      for (i = 0; i < rowBytes; ++i) {
                        buffer[j++] = prevRow[i] + rawBytes[i] & 255;
                      }
                      break;
                    case 3:
                      for (i = 0; i < pixBytes; ++i) {
                        buffer[j++] = (prevRow[i] >> 1) + rawBytes[i];
                      }
                      for (; i < rowBytes; ++i) {
                        buffer[j] = (prevRow[i] + buffer[j - pixBytes] >> 1) + rawBytes[i] & 255;
                        j++;
                      }
                      break;
                    case 4:
                      for (i = 0; i < pixBytes; ++i) {
                        up2 = prevRow[i];
                        c = rawBytes[i];
                        buffer[j++] = up2 + c;
                      }
                      for (; i < rowBytes; ++i) {
                        up2 = prevRow[i];
                        const upLeft = prevRow[i - pixBytes];
                        const left2 = buffer[j - pixBytes];
                        const p = left2 + up2 - upLeft;
                        let pa = p - left2;
                        if (pa < 0) {
                          pa = -pa;
                        }
                        let pb = p - up2;
                        if (pb < 0) {
                          pb = -pb;
                        }
                        let pc = p - upLeft;
                        if (pc < 0) {
                          pc = -pc;
                        }
                        c = rawBytes[i];
                        if (pa <= pb && pa <= pc) {
                          buffer[j++] = left2 + c;
                        } else if (pb <= pc) {
                          buffer[j++] = up2 + c;
                        } else {
                          buffer[j++] = upLeft + c;
                        }
                      }
                      break;
                    default:
                      throw new _util2.FormatError(`Unsupported predictor: ${predictor}`);
                  }
                  this.bufferLength += rowBytes;
                }
              }
              exports3.PredictorStream = PredictorStream;
            }),
            /* 33 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.RunLengthStream = void 0;
              var _decode_stream = __w_pdfjs_require__3(18);
              class RunLengthStream extends _decode_stream.DecodeStream {
                constructor(str, maybeLength) {
                  super(maybeLength);
                  this.str = str;
                  this.dict = str.dict;
                }
                readBlock() {
                  const repeatHeader = this.str.getBytes(2);
                  if (!repeatHeader || repeatHeader.length < 2 || repeatHeader[0] === 128) {
                    this.eof = true;
                    return;
                  }
                  let buffer;
                  let bufferLength = this.bufferLength;
                  let n2 = repeatHeader[0];
                  if (n2 < 128) {
                    buffer = this.ensureBuffer(bufferLength + n2 + 1);
                    buffer[bufferLength++] = repeatHeader[1];
                    if (n2 > 0) {
                      const source = this.str.getBytes(n2);
                      buffer.set(source, bufferLength);
                      bufferLength += n2;
                    }
                  } else {
                    n2 = 257 - n2;
                    const b = repeatHeader[1];
                    buffer = this.ensureBuffer(bufferLength + n2 + 1);
                    for (let i = 0; i < n2; i++) {
                      buffer[bufferLength++] = b;
                    }
                  }
                  this.bufferLength = bufferLength;
                }
              }
              exports3.RunLengthStream = RunLengthStream;
            }),
            /* 34 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.Font = exports3.ErrorFont = void 0;
              var _util2 = __w_pdfjs_require__3(2);
              var _cff_parser = __w_pdfjs_require__3(35);
              var _fonts_utils = __w_pdfjs_require__3(38);
              var _unicode = __w_pdfjs_require__3(40);
              var _glyphlist = __w_pdfjs_require__3(39);
              var _encodings = __w_pdfjs_require__3(37);
              var _standard_fonts = __w_pdfjs_require__3(41);
              var _to_unicode_map = __w_pdfjs_require__3(42);
              var _cff_font = __w_pdfjs_require__3(43);
              var _font_renderer = __w_pdfjs_require__3(44);
              var _metrics = __w_pdfjs_require__3(45);
              var _glyf = __w_pdfjs_require__3(46);
              var _cmap = __w_pdfjs_require__3(14);
              var _opentype_file_builder = __w_pdfjs_require__3(47);
              var _core_utils = __w_pdfjs_require__3(3);
              var _stream = __w_pdfjs_require__3(8);
              var _type1_font = __w_pdfjs_require__3(48);
              const PRIVATE_USE_AREAS = [[57344, 63743], [1048576, 1114109]];
              const PDF_GLYPH_SPACE_UNITS = 1e3;
              const EXPORT_DATA_PROPERTIES = ["ascent", "bbox", "black", "bold", "charProcOperatorList", "composite", "cssFontInfo", "data", "defaultVMetrics", "defaultWidth", "descent", "fallbackName", "fontMatrix", "isInvalidPDFjsFont", "isType3Font", "italic", "loadedName", "mimetype", "missingFile", "name", "remeasure", "subtype", "systemFontInfo", "type", "vertical"];
              const EXPORT_DATA_EXTRA_PROPERTIES = ["cMap", "defaultEncoding", "differences", "isMonospace", "isSerifFont", "isSymbolicFont", "seacMap", "toFontChar", "toUnicode", "vmetrics", "widths"];
              function adjustWidths(properties2) {
                if (!properties2.fontMatrix) {
                  return;
                }
                if (properties2.fontMatrix[0] === _util2.FONT_IDENTITY_MATRIX[0]) {
                  return;
                }
                const scale = 1e-3 / properties2.fontMatrix[0];
                const glyphsWidths = properties2.widths;
                for (const glyph in glyphsWidths) {
                  glyphsWidths[glyph] *= scale;
                }
                properties2.defaultWidth *= scale;
              }
              function adjustTrueTypeToUnicode(properties2, isSymbolicFont, nameRecords) {
                if (properties2.isInternalFont) {
                  return;
                }
                if (properties2.hasIncludedToUnicodeMap) {
                  return;
                }
                if (properties2.hasEncoding) {
                  return;
                }
                if (properties2.toUnicode instanceof _to_unicode_map.IdentityToUnicodeMap) {
                  return;
                }
                if (!isSymbolicFont) {
                  return;
                }
                if (nameRecords.length === 0) {
                  return;
                }
                if (properties2.defaultEncoding === _encodings.WinAnsiEncoding) {
                  return;
                }
                for (const r2 of nameRecords) {
                  if (!isWinNameRecord(r2)) {
                    return;
                  }
                }
                const encoding = _encodings.WinAnsiEncoding;
                const toUnicode = [], glyphsUnicodeMap = (0, _glyphlist.getGlyphsUnicode)();
                for (const charCode in encoding) {
                  const glyphName = encoding[charCode];
                  if (glyphName === "") {
                    continue;
                  }
                  const unicode = glyphsUnicodeMap[glyphName];
                  if (unicode === void 0) {
                    continue;
                  }
                  toUnicode[charCode] = String.fromCharCode(unicode);
                }
                if (toUnicode.length > 0) {
                  properties2.toUnicode.amend(toUnicode);
                }
              }
              function adjustType1ToUnicode(properties2, builtInEncoding) {
                if (properties2.isInternalFont) {
                  return;
                }
                if (properties2.hasIncludedToUnicodeMap) {
                  return;
                }
                if (builtInEncoding === properties2.defaultEncoding) {
                  return;
                }
                if (properties2.toUnicode instanceof _to_unicode_map.IdentityToUnicodeMap) {
                  return;
                }
                const toUnicode = [], glyphsUnicodeMap = (0, _glyphlist.getGlyphsUnicode)();
                for (const charCode in builtInEncoding) {
                  if (properties2.hasEncoding) {
                    if (properties2.baseEncodingName || properties2.differences[charCode] !== void 0) {
                      continue;
                    }
                  }
                  const glyphName = builtInEncoding[charCode];
                  const unicode = (0, _unicode.getUnicodeForGlyph)(glyphName, glyphsUnicodeMap);
                  if (unicode !== -1) {
                    toUnicode[charCode] = String.fromCharCode(unicode);
                  }
                }
                if (toUnicode.length > 0) {
                  properties2.toUnicode.amend(toUnicode);
                }
              }
              function amendFallbackToUnicode(properties2) {
                if (!properties2.fallbackToUnicode) {
                  return;
                }
                if (properties2.toUnicode instanceof _to_unicode_map.IdentityToUnicodeMap) {
                  return;
                }
                const toUnicode = [];
                for (const charCode in properties2.fallbackToUnicode) {
                  if (properties2.toUnicode.has(charCode)) {
                    continue;
                  }
                  toUnicode[charCode] = properties2.fallbackToUnicode[charCode];
                }
                if (toUnicode.length > 0) {
                  properties2.toUnicode.amend(toUnicode);
                }
              }
              class Glyph {
                constructor(originalCharCode, fontChar, unicode, accent, width, vmetric, operatorListId, isSpace, isInFont) {
                  this.originalCharCode = originalCharCode;
                  this.fontChar = fontChar;
                  this.unicode = unicode;
                  this.accent = accent;
                  this.width = width;
                  this.vmetric = vmetric;
                  this.operatorListId = operatorListId;
                  this.isSpace = isSpace;
                  this.isInFont = isInFont;
                }
                get category() {
                  return (0, _util2.shadow)(this, "category", (0, _unicode.getCharUnicodeCategory)(this.unicode), true);
                }
              }
              function int162(b0, b1) {
                return (b0 << 8) + b1;
              }
              function writeSignedInt16(bytes, index3, value) {
                bytes[index3 + 1] = value;
                bytes[index3] = value >>> 8;
              }
              function signedInt16(b0, b1) {
                const value = (b0 << 8) + b1;
                return value & 1 << 15 ? value - 65536 : value;
              }
              function int322(b0, b1, b2, b3) {
                return (b0 << 24) + (b1 << 16) + (b2 << 8) + b3;
              }
              function string16(value) {
                return String.fromCharCode(value >> 8 & 255, value & 255);
              }
              function safeString16(value) {
                if (value > 32767) {
                  value = 32767;
                } else if (value < -32768) {
                  value = -32768;
                }
                return String.fromCharCode(value >> 8 & 255, value & 255);
              }
              function isTrueTypeFile(file) {
                const header = file.peekBytes(4);
                return (0, _core_utils.readUint32)(header, 0) === 65536 || (0, _util2.bytesToString)(header) === "true";
              }
              function isTrueTypeCollectionFile(file) {
                const header = file.peekBytes(4);
                return (0, _util2.bytesToString)(header) === "ttcf";
              }
              function isOpenTypeFile(file) {
                const header = file.peekBytes(4);
                return (0, _util2.bytesToString)(header) === "OTTO";
              }
              function isType1File(file) {
                const header = file.peekBytes(2);
                if (header[0] === 37 && header[1] === 33) {
                  return true;
                }
                if (header[0] === 128 && header[1] === 1) {
                  return true;
                }
                return false;
              }
              function isCFFFile(file) {
                const header = file.peekBytes(4);
                if (header[0] >= 1 && header[3] >= 1 && header[3] <= 4) {
                  return true;
                }
                return false;
              }
              function getFontFileType(file, {
                type: type5,
                subtype,
                composite
              }) {
                let fileType, fileSubtype;
                if (isTrueTypeFile(file) || isTrueTypeCollectionFile(file)) {
                  fileType = composite ? "CIDFontType2" : "TrueType";
                } else if (isOpenTypeFile(file)) {
                  fileType = composite ? "CIDFontType2" : "OpenType";
                } else if (isType1File(file)) {
                  if (composite) {
                    fileType = "CIDFontType0";
                  } else {
                    fileType = type5 === "MMType1" ? "MMType1" : "Type1";
                  }
                } else if (isCFFFile(file)) {
                  if (composite) {
                    fileType = "CIDFontType0";
                    fileSubtype = "CIDFontType0C";
                  } else {
                    fileType = type5 === "MMType1" ? "MMType1" : "Type1";
                    fileSubtype = "Type1C";
                  }
                } else {
                  (0, _util2.warn)("getFontFileType: Unable to detect correct font file Type/Subtype.");
                  fileType = type5;
                  fileSubtype = subtype;
                }
                return [fileType, fileSubtype];
              }
              function applyStandardFontGlyphMap(map, glyphMap) {
                for (const charCode in glyphMap) {
                  map[+charCode] = glyphMap[charCode];
                }
              }
              function buildToFontChar(encoding, glyphsUnicodeMap, differences) {
                const toFontChar = [];
                let unicode;
                for (let i = 0, ii = encoding.length; i < ii; i++) {
                  unicode = (0, _unicode.getUnicodeForGlyph)(encoding[i], glyphsUnicodeMap);
                  if (unicode !== -1) {
                    toFontChar[i] = unicode;
                  }
                }
                for (const charCode in differences) {
                  unicode = (0, _unicode.getUnicodeForGlyph)(differences[charCode], glyphsUnicodeMap);
                  if (unicode !== -1) {
                    toFontChar[+charCode] = unicode;
                  }
                }
                return toFontChar;
              }
              function isMacNameRecord(r2) {
                return r2.platform === 1 && r2.encoding === 0 && r2.language === 0;
              }
              function isWinNameRecord(r2) {
                return r2.platform === 3 && r2.encoding === 1 && r2.language === 1033;
              }
              function convertCidString(charCode, cid, shouldThrow = false) {
                switch (cid.length) {
                  case 1:
                    return cid.charCodeAt(0);
                  case 2:
                    return cid.charCodeAt(0) << 8 | cid.charCodeAt(1);
                }
                const msg = `Unsupported CID string (charCode ${charCode}): "${cid}".`;
                if (shouldThrow) {
                  throw new _util2.FormatError(msg);
                }
                (0, _util2.warn)(msg);
                return cid;
              }
              function adjustMapping(charCodeToGlyphId, hasGlyph, newGlyphZeroId, toUnicode) {
                const newMap = /* @__PURE__ */ Object.create(null);
                const toUnicodeExtraMap = /* @__PURE__ */ new Map();
                const toFontChar = [];
                const usedGlyphIds = /* @__PURE__ */ new Set();
                let privateUseAreaIndex = 0;
                const privateUseOffetStart = PRIVATE_USE_AREAS[privateUseAreaIndex][0];
                let nextAvailableFontCharCode = privateUseOffetStart;
                let privateUseOffetEnd = PRIVATE_USE_AREAS[privateUseAreaIndex][1];
                const isInPrivateArea = (code2) => PRIVATE_USE_AREAS[0][0] <= code2 && code2 <= PRIVATE_USE_AREAS[0][1] || PRIVATE_USE_AREAS[1][0] <= code2 && code2 <= PRIVATE_USE_AREAS[1][1];
                for (let originalCharCode in charCodeToGlyphId) {
                  originalCharCode |= 0;
                  let glyphId = charCodeToGlyphId[originalCharCode];
                  if (!hasGlyph(glyphId)) {
                    continue;
                  }
                  if (nextAvailableFontCharCode > privateUseOffetEnd) {
                    privateUseAreaIndex++;
                    if (privateUseAreaIndex >= PRIVATE_USE_AREAS.length) {
                      (0, _util2.warn)("Ran out of space in font private use area.");
                      break;
                    }
                    nextAvailableFontCharCode = PRIVATE_USE_AREAS[privateUseAreaIndex][0];
                    privateUseOffetEnd = PRIVATE_USE_AREAS[privateUseAreaIndex][1];
                  }
                  const fontCharCode = nextAvailableFontCharCode++;
                  if (glyphId === 0) {
                    glyphId = newGlyphZeroId;
                  }
                  let unicode = toUnicode.get(originalCharCode);
                  if (typeof unicode === "string") {
                    unicode = unicode.codePointAt(0);
                  }
                  if (unicode && !isInPrivateArea(unicode) && !usedGlyphIds.has(glyphId)) {
                    toUnicodeExtraMap.set(unicode, glyphId);
                    usedGlyphIds.add(glyphId);
                  }
                  newMap[fontCharCode] = glyphId;
                  toFontChar[originalCharCode] = fontCharCode;
                }
                return {
                  toFontChar,
                  charCodeToGlyphId: newMap,
                  toUnicodeExtraMap,
                  nextAvailableFontCharCode
                };
              }
              function getRanges(glyphs, toUnicodeExtraMap, numGlyphs) {
                const codes = [];
                for (const charCode in glyphs) {
                  if (glyphs[charCode] >= numGlyphs) {
                    continue;
                  }
                  codes.push({
                    fontCharCode: charCode | 0,
                    glyphId: glyphs[charCode]
                  });
                }
                if (toUnicodeExtraMap) {
                  for (const [unicode, glyphId] of toUnicodeExtraMap) {
                    if (glyphId >= numGlyphs) {
                      continue;
                    }
                    codes.push({
                      fontCharCode: unicode,
                      glyphId
                    });
                  }
                }
                if (codes.length === 0) {
                  codes.push({
                    fontCharCode: 0,
                    glyphId: 0
                  });
                }
                codes.sort(function fontGetRangesSort(a, b) {
                  return a.fontCharCode - b.fontCharCode;
                });
                const ranges = [];
                const length2 = codes.length;
                for (let n2 = 0; n2 < length2; ) {
                  const start = codes[n2].fontCharCode;
                  const codeIndices = [codes[n2].glyphId];
                  ++n2;
                  let end = start;
                  while (n2 < length2 && end + 1 === codes[n2].fontCharCode) {
                    codeIndices.push(codes[n2].glyphId);
                    ++end;
                    ++n2;
                    if (end === 65535) {
                      break;
                    }
                  }
                  ranges.push([start, end, codeIndices]);
                }
                return ranges;
              }
              function createCmapTable(glyphs, toUnicodeExtraMap, numGlyphs) {
                const ranges = getRanges(glyphs, toUnicodeExtraMap, numGlyphs);
                const numTables = ranges.at(-1)[1] > 65535 ? 2 : 1;
                let cmap = "\0\0" + string16(numTables) + "\0\0" + (0, _util2.string32)(4 + numTables * 8);
                let i, ii, j, jj;
                for (i = ranges.length - 1; i >= 0; --i) {
                  if (ranges[i][0] <= 65535) {
                    break;
                  }
                }
                const bmpLength = i + 1;
                if (ranges[i][0] < 65535 && ranges[i][1] === 65535) {
                  ranges[i][1] = 65534;
                }
                const trailingRangesCount = ranges[i][1] < 65535 ? 1 : 0;
                const segCount = bmpLength + trailingRangesCount;
                const searchParams = _opentype_file_builder.OpenTypeFileBuilder.getSearchParams(segCount, 2);
                let startCount = "";
                let endCount = "";
                let idDeltas = "";
                let idRangeOffsets = "";
                let glyphsIds = "";
                let bias = 0;
                let range3, start, end, codes;
                for (i = 0, ii = bmpLength; i < ii; i++) {
                  range3 = ranges[i];
                  start = range3[0];
                  end = range3[1];
                  startCount += string16(start);
                  endCount += string16(end);
                  codes = range3[2];
                  let contiguous = true;
                  for (j = 1, jj = codes.length; j < jj; ++j) {
                    if (codes[j] !== codes[j - 1] + 1) {
                      contiguous = false;
                      break;
                    }
                  }
                  if (!contiguous) {
                    const offset4 = (segCount - i) * 2 + bias * 2;
                    bias += end - start + 1;
                    idDeltas += string16(0);
                    idRangeOffsets += string16(offset4);
                    for (j = 0, jj = codes.length; j < jj; ++j) {
                      glyphsIds += string16(codes[j]);
                    }
                  } else {
                    const startCode = codes[0];
                    idDeltas += string16(startCode - start & 65535);
                    idRangeOffsets += string16(0);
                  }
                }
                if (trailingRangesCount > 0) {
                  endCount += "\xFF\xFF";
                  startCount += "\xFF\xFF";
                  idDeltas += "\0";
                  idRangeOffsets += "\0\0";
                }
                const format314 = "\0\0" + string16(2 * segCount) + string16(searchParams.range) + string16(searchParams.entry) + string16(searchParams.rangeShift) + endCount + "\0\0" + startCount + idDeltas + idRangeOffsets + glyphsIds;
                let format31012 = "";
                let header31012 = "";
                if (numTables > 1) {
                  cmap += "\0\0\n" + (0, _util2.string32)(4 + numTables * 8 + 4 + format314.length);
                  format31012 = "";
                  for (i = 0, ii = ranges.length; i < ii; i++) {
                    range3 = ranges[i];
                    start = range3[0];
                    codes = range3[2];
                    let code2 = codes[0];
                    for (j = 1, jj = codes.length; j < jj; ++j) {
                      if (codes[j] !== codes[j - 1] + 1) {
                        end = range3[0] + j - 1;
                        format31012 += (0, _util2.string32)(start) + (0, _util2.string32)(end) + (0, _util2.string32)(code2);
                        start = end + 1;
                        code2 = codes[j];
                      }
                    }
                    format31012 += (0, _util2.string32)(start) + (0, _util2.string32)(range3[1]) + (0, _util2.string32)(code2);
                  }
                  header31012 = "\0\f\0\0" + (0, _util2.string32)(format31012.length + 16) + "\0\0\0\0" + (0, _util2.string32)(format31012.length / 12);
                }
                return cmap + "\0" + string16(format314.length + 4) + format314 + header31012 + format31012;
              }
              function validateOS2Table(os2, file) {
                file.pos = (file.start || 0) + os2.offset;
                const version7 = file.getUint16();
                file.skip(60);
                const selection = file.getUint16();
                if (version7 < 4 && selection & 768) {
                  return false;
                }
                const firstChar = file.getUint16();
                const lastChar = file.getUint16();
                if (firstChar > lastChar) {
                  return false;
                }
                file.skip(6);
                const usWinAscent = file.getUint16();
                if (usWinAscent === 0) {
                  return false;
                }
                os2.data[8] = os2.data[9] = 0;
                return true;
              }
              function createOS2Table(properties2, charstrings, override) {
                override ||= {
                  unitsPerEm: 0,
                  yMax: 0,
                  yMin: 0,
                  ascent: 0,
                  descent: 0
                };
                let ulUnicodeRange1 = 0;
                let ulUnicodeRange2 = 0;
                let ulUnicodeRange3 = 0;
                let ulUnicodeRange4 = 0;
                let firstCharIndex = null;
                let lastCharIndex = 0;
                let position3 = -1;
                if (charstrings) {
                  for (let code2 in charstrings) {
                    code2 |= 0;
                    if (firstCharIndex > code2 || !firstCharIndex) {
                      firstCharIndex = code2;
                    }
                    if (lastCharIndex < code2) {
                      lastCharIndex = code2;
                    }
                    position3 = (0, _unicode.getUnicodeRangeFor)(code2, position3);
                    if (position3 < 32) {
                      ulUnicodeRange1 |= 1 << position3;
                    } else if (position3 < 64) {
                      ulUnicodeRange2 |= 1 << position3 - 32;
                    } else if (position3 < 96) {
                      ulUnicodeRange3 |= 1 << position3 - 64;
                    } else if (position3 < 123) {
                      ulUnicodeRange4 |= 1 << position3 - 96;
                    } else {
                      throw new _util2.FormatError("Unicode ranges Bits > 123 are reserved for internal usage");
                    }
                  }
                  if (lastCharIndex > 65535) {
                    lastCharIndex = 65535;
                  }
                } else {
                  firstCharIndex = 0;
                  lastCharIndex = 255;
                }
                const bbox = properties2.bbox || [0, 0, 0, 0];
                const unitsPerEm = override.unitsPerEm || 1 / (properties2.fontMatrix || _util2.FONT_IDENTITY_MATRIX)[0];
                const scale = properties2.ascentScaled ? 1 : unitsPerEm / PDF_GLYPH_SPACE_UNITS;
                const typoAscent = override.ascent || Math.round(scale * (properties2.ascent || bbox[3]));
                let typoDescent = override.descent || Math.round(scale * (properties2.descent || bbox[1]));
                if (typoDescent > 0 && properties2.descent > 0 && bbox[1] < 0) {
                  typoDescent = -typoDescent;
                }
                const winAscent = override.yMax || typoAscent;
                const winDescent = -override.yMin || -typoDescent;
                return "\0$\xF4\0\0\0\x8A\xBB\0\0\0\x8C\x8A\xBB\0\0\xDF\x001\0\0\0\0" + String.fromCharCode(properties2.fixedPitch ? 9 : 0) + "\0\0\0\0\0\0" + (0, _util2.string32)(ulUnicodeRange1) + (0, _util2.string32)(ulUnicodeRange2) + (0, _util2.string32)(ulUnicodeRange3) + (0, _util2.string32)(ulUnicodeRange4) + "*21*" + string16(properties2.italicAngle ? 1 : 0) + string16(firstCharIndex || properties2.firstChar) + string16(lastCharIndex || properties2.lastChar) + string16(typoAscent) + string16(typoDescent) + "\0d" + string16(winAscent) + string16(winDescent) + "\0\0\0\0\0\0\0\0" + string16(properties2.xHeight) + string16(properties2.capHeight) + string16(0) + string16(firstCharIndex || properties2.firstChar) + "\0";
              }
              function createPostTable(properties2) {
                const angle = Math.floor(properties2.italicAngle * 2 ** 16);
                return "\0\0\0" + (0, _util2.string32)(angle) + "\0\0\0\0" + (0, _util2.string32)(properties2.fixedPitch ? 1 : 0) + "\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0";
              }
              function createPostscriptName(name) {
                return name.replaceAll(/[^\x21-\x7E]|[[\](){}<>/%]/g, "").slice(0, 63);
              }
              function createNameTable(name, proto) {
                if (!proto) {
                  proto = [[], []];
                }
                const strings = [proto[0][0] || "Original licence", proto[0][1] || name, proto[0][2] || "Unknown", proto[0][3] || "uniqueID", proto[0][4] || name, proto[0][5] || "Version 0.11", proto[0][6] || createPostscriptName(name), proto[0][7] || "Unknown", proto[0][8] || "Unknown", proto[0][9] || "Unknown"];
                const stringsUnicode = [];
                let i, ii, j, jj, str;
                for (i = 0, ii = strings.length; i < ii; i++) {
                  str = proto[1][i] || strings[i];
                  const strBufUnicode = [];
                  for (j = 0, jj = str.length; j < jj; j++) {
                    strBufUnicode.push(string16(str.charCodeAt(j)));
                  }
                  stringsUnicode.push(strBufUnicode.join(""));
                }
                const names2 = [strings, stringsUnicode];
                const platforms = ["\0", "\0"];
                const encodings = ["\0\0", "\0"];
                const languages = ["\0\0", "	"];
                const namesRecordCount = strings.length * platforms.length;
                let nameTable = "\0\0" + string16(namesRecordCount) + string16(namesRecordCount * 12 + 6);
                let strOffset = 0;
                for (i = 0, ii = platforms.length; i < ii; i++) {
                  const strs = names2[i];
                  for (j = 0, jj = strs.length; j < jj; j++) {
                    str = strs[j];
                    const nameRecord = platforms[i] + encodings[i] + languages[i] + string16(j) + string16(str.length) + string16(strOffset);
                    nameTable += nameRecord;
                    strOffset += str.length;
                  }
                }
                nameTable += strings.join("") + stringsUnicode.join("");
                return nameTable;
              }
              class Font3 {
                constructor(name, file, properties2) {
                  this.name = name;
                  this.psName = null;
                  this.mimetype = null;
                  this.disableFontFace = false;
                  this.loadedName = properties2.loadedName;
                  this.isType3Font = properties2.isType3Font;
                  this.missingFile = false;
                  this.cssFontInfo = properties2.cssFontInfo;
                  this._charsCache = /* @__PURE__ */ Object.create(null);
                  this._glyphCache = /* @__PURE__ */ Object.create(null);
                  let isSerifFont = !!(properties2.flags & _fonts_utils.FontFlags.Serif);
                  if (!isSerifFont && !properties2.isSimulatedFlags) {
                    const baseName = name.replaceAll(/[,_]/g, "-").split("-")[0], serifFonts = (0, _standard_fonts.getSerifFonts)();
                    for (const namePart of baseName.split("+")) {
                      if (serifFonts[namePart]) {
                        isSerifFont = true;
                        break;
                      }
                    }
                  }
                  this.isSerifFont = isSerifFont;
                  this.isSymbolicFont = !!(properties2.flags & _fonts_utils.FontFlags.Symbolic);
                  this.isMonospace = !!(properties2.flags & _fonts_utils.FontFlags.FixedPitch);
                  let {
                    type: type5,
                    subtype
                  } = properties2;
                  this.type = type5;
                  this.subtype = subtype;
                  this.systemFontInfo = properties2.systemFontInfo;
                  const matches = name.match(/^InvalidPDFjsFont_(.*)_\d+$/);
                  this.isInvalidPDFjsFont = !!matches;
                  if (this.isInvalidPDFjsFont) {
                    this.fallbackName = matches[1];
                  } else if (this.isMonospace) {
                    this.fallbackName = "monospace";
                  } else if (this.isSerifFont) {
                    this.fallbackName = "serif";
                  } else {
                    this.fallbackName = "sans-serif";
                  }
                  if (this.systemFontInfo?.guessFallback) {
                    this.systemFontInfo.guessFallback = false;
                    this.systemFontInfo.css += `,${this.fallbackName}`;
                  }
                  this.differences = properties2.differences;
                  this.widths = properties2.widths;
                  this.defaultWidth = properties2.defaultWidth;
                  this.composite = properties2.composite;
                  this.cMap = properties2.cMap;
                  this.capHeight = properties2.capHeight / PDF_GLYPH_SPACE_UNITS;
                  this.ascent = properties2.ascent / PDF_GLYPH_SPACE_UNITS;
                  this.descent = properties2.descent / PDF_GLYPH_SPACE_UNITS;
                  this.lineHeight = this.ascent - this.descent;
                  this.fontMatrix = properties2.fontMatrix;
                  this.bbox = properties2.bbox;
                  this.defaultEncoding = properties2.defaultEncoding;
                  this.toUnicode = properties2.toUnicode;
                  this.toFontChar = [];
                  if (properties2.type === "Type3") {
                    for (let charCode = 0; charCode < 256; charCode++) {
                      this.toFontChar[charCode] = this.differences[charCode] || properties2.defaultEncoding[charCode];
                    }
                    return;
                  }
                  this.cidEncoding = properties2.cidEncoding || "";
                  this.vertical = !!properties2.vertical;
                  if (this.vertical) {
                    this.vmetrics = properties2.vmetrics;
                    this.defaultVMetrics = properties2.defaultVMetrics;
                  }
                  if (!file || file.isEmpty) {
                    if (file) {
                      (0, _util2.warn)('Font file is empty in "' + name + '" (' + this.loadedName + ")");
                    }
                    this.fallbackToSystemFont(properties2);
                    return;
                  }
                  [type5, subtype] = getFontFileType(file, properties2);
                  if (type5 !== this.type || subtype !== this.subtype) {
                    (0, _util2.info)(`Inconsistent font file Type/SubType, expected: ${this.type}/${this.subtype} but found: ${type5}/${subtype}.`);
                  }
                  let data2;
                  try {
                    switch (type5) {
                      case "MMType1":
                        (0, _util2.info)("MMType1 font (" + name + "), falling back to Type1.");
                      case "Type1":
                      case "CIDFontType0":
                        this.mimetype = "font/opentype";
                        const cff = subtype === "Type1C" || subtype === "CIDFontType0C" ? new _cff_font.CFFFont(file, properties2) : new _type1_font.Type1Font(name, file, properties2);
                        adjustWidths(properties2);
                        data2 = this.convert(name, cff, properties2);
                        break;
                      case "OpenType":
                      case "TrueType":
                      case "CIDFontType2":
                        this.mimetype = "font/opentype";
                        data2 = this.checkAndRepair(name, file, properties2);
                        if (this.isOpenType) {
                          adjustWidths(properties2);
                          type5 = "OpenType";
                        }
                        break;
                      default:
                        throw new _util2.FormatError(`Font ${type5} is not supported`);
                    }
                  } catch (e3) {
                    (0, _util2.warn)(e3);
                    this.fallbackToSystemFont(properties2);
                    return;
                  }
                  amendFallbackToUnicode(properties2);
                  this.data = data2;
                  this.type = type5;
                  this.subtype = subtype;
                  this.fontMatrix = properties2.fontMatrix;
                  this.widths = properties2.widths;
                  this.defaultWidth = properties2.defaultWidth;
                  this.toUnicode = properties2.toUnicode;
                  this.seacMap = properties2.seacMap;
                }
                get renderer() {
                  const renderer = _font_renderer.FontRendererFactory.create(this, _fonts_utils.SEAC_ANALYSIS_ENABLED);
                  return (0, _util2.shadow)(this, "renderer", renderer);
                }
                exportData(extraProperties = false) {
                  const exportDataProperties = extraProperties ? [...EXPORT_DATA_PROPERTIES, ...EXPORT_DATA_EXTRA_PROPERTIES] : EXPORT_DATA_PROPERTIES;
                  const data2 = /* @__PURE__ */ Object.create(null);
                  let property2, value;
                  for (property2 of exportDataProperties) {
                    value = this[property2];
                    if (value !== void 0) {
                      data2[property2] = value;
                    }
                  }
                  return data2;
                }
                fallbackToSystemFont(properties2) {
                  this.missingFile = true;
                  const {
                    name,
                    type: type5
                  } = this;
                  let fontName = (0, _fonts_utils.normalizeFontName)(name);
                  const stdFontMap = (0, _standard_fonts.getStdFontMap)(), nonStdFontMap = (0, _standard_fonts.getNonStdFontMap)();
                  const isStandardFont = !!stdFontMap[fontName];
                  const isMappedToStandardFont = !!(nonStdFontMap[fontName] && stdFontMap[nonStdFontMap[fontName]]);
                  fontName = stdFontMap[fontName] || nonStdFontMap[fontName] || fontName;
                  const fontBasicMetricsMap = (0, _metrics.getFontBasicMetrics)();
                  const metrics = fontBasicMetricsMap[fontName];
                  if (metrics) {
                    if (isNaN(this.ascent)) {
                      this.ascent = metrics.ascent / PDF_GLYPH_SPACE_UNITS;
                    }
                    if (isNaN(this.descent)) {
                      this.descent = metrics.descent / PDF_GLYPH_SPACE_UNITS;
                    }
                    if (isNaN(this.capHeight)) {
                      this.capHeight = metrics.capHeight / PDF_GLYPH_SPACE_UNITS;
                    }
                  }
                  this.bold = /bold/gi.test(fontName);
                  this.italic = /oblique|italic/gi.test(fontName);
                  this.black = /Black/g.test(name);
                  const isNarrow = /Narrow/g.test(name);
                  this.remeasure = (!isStandardFont || isNarrow) && Object.keys(this.widths).length > 0;
                  if ((isStandardFont || isMappedToStandardFont) && type5 === "CIDFontType2" && this.cidEncoding.startsWith("Identity-")) {
                    const cidToGidMap = properties2.cidToGidMap;
                    const map = [];
                    applyStandardFontGlyphMap(map, (0, _standard_fonts.getGlyphMapForStandardFonts)());
                    if (/Arial-?Black/i.test(name)) {
                      applyStandardFontGlyphMap(map, (0, _standard_fonts.getSupplementalGlyphMapForArialBlack)());
                    } else if (/Calibri/i.test(name)) {
                      applyStandardFontGlyphMap(map, (0, _standard_fonts.getSupplementalGlyphMapForCalibri)());
                    }
                    if (cidToGidMap) {
                      for (const charCode in map) {
                        const cid = map[charCode];
                        if (cidToGidMap[cid] !== void 0) {
                          map[+charCode] = cidToGidMap[cid];
                        }
                      }
                      if (cidToGidMap.length !== this.toUnicode.length && properties2.hasIncludedToUnicodeMap && this.toUnicode instanceof _to_unicode_map.IdentityToUnicodeMap) {
                        this.toUnicode.forEach(function(charCode, unicodeCharCode) {
                          const cid = map[charCode];
                          if (cidToGidMap[cid] === void 0) {
                            map[+charCode] = unicodeCharCode;
                          }
                        });
                      }
                    }
                    if (!(this.toUnicode instanceof _to_unicode_map.IdentityToUnicodeMap)) {
                      this.toUnicode.forEach(function(charCode, unicodeCharCode) {
                        map[+charCode] = unicodeCharCode;
                      });
                    }
                    this.toFontChar = map;
                    this.toUnicode = new _to_unicode_map.ToUnicodeMap(map);
                  } else if (/Symbol/i.test(fontName)) {
                    this.toFontChar = buildToFontChar(_encodings.SymbolSetEncoding, (0, _glyphlist.getGlyphsUnicode)(), this.differences);
                  } else if (/Dingbats/i.test(fontName)) {
                    this.toFontChar = buildToFontChar(_encodings.ZapfDingbatsEncoding, (0, _glyphlist.getDingbatsGlyphsUnicode)(), this.differences);
                  } else if (isStandardFont) {
                    const map = buildToFontChar(this.defaultEncoding, (0, _glyphlist.getGlyphsUnicode)(), this.differences);
                    if (type5 === "CIDFontType2" && !this.cidEncoding.startsWith("Identity-") && !(this.toUnicode instanceof _to_unicode_map.IdentityToUnicodeMap)) {
                      this.toUnicode.forEach(function(charCode, unicodeCharCode) {
                        map[+charCode] = unicodeCharCode;
                      });
                    }
                    this.toFontChar = map;
                  } else {
                    const glyphsUnicodeMap = (0, _glyphlist.getGlyphsUnicode)();
                    const map = [];
                    this.toUnicode.forEach((charCode, unicodeCharCode) => {
                      if (!this.composite) {
                        const glyphName = this.differences[charCode] || this.defaultEncoding[charCode];
                        const unicode = (0, _unicode.getUnicodeForGlyph)(glyphName, glyphsUnicodeMap);
                        if (unicode !== -1) {
                          unicodeCharCode = unicode;
                        }
                      }
                      map[+charCode] = unicodeCharCode;
                    });
                    if (this.composite && this.toUnicode instanceof _to_unicode_map.IdentityToUnicodeMap) {
                      if (/Tahoma|Verdana/i.test(name)) {
                        applyStandardFontGlyphMap(map, (0, _standard_fonts.getGlyphMapForStandardFonts)());
                      }
                    }
                    this.toFontChar = map;
                  }
                  amendFallbackToUnicode(properties2);
                  this.loadedName = fontName.split("-")[0];
                }
                checkAndRepair(name, font, properties2) {
                  const VALID_TABLES = ["OS/2", "cmap", "head", "hhea", "hmtx", "maxp", "name", "post", "loca", "glyf", "fpgm", "prep", "cvt ", "CFF "];
                  function readTables(file, numTables) {
                    const tables2 = /* @__PURE__ */ Object.create(null);
                    tables2["OS/2"] = null;
                    tables2.cmap = null;
                    tables2.head = null;
                    tables2.hhea = null;
                    tables2.hmtx = null;
                    tables2.maxp = null;
                    tables2.name = null;
                    tables2.post = null;
                    for (let i = 0; i < numTables; i++) {
                      const table = readTableEntry(file);
                      if (!VALID_TABLES.includes(table.tag)) {
                        continue;
                      }
                      if (table.length === 0) {
                        continue;
                      }
                      tables2[table.tag] = table;
                    }
                    return tables2;
                  }
                  function readTableEntry(file) {
                    const tag = file.getString(4);
                    const checksum = file.getInt32() >>> 0;
                    const offset4 = file.getInt32() >>> 0;
                    const length2 = file.getInt32() >>> 0;
                    const previousPosition = file.pos;
                    file.pos = file.start || 0;
                    file.skip(offset4);
                    const data2 = file.getBytes(length2);
                    file.pos = previousPosition;
                    if (tag === "head") {
                      data2[8] = data2[9] = data2[10] = data2[11] = 0;
                      data2[17] |= 32;
                    }
                    return {
                      tag,
                      checksum,
                      length: length2,
                      offset: offset4,
                      data: data2
                    };
                  }
                  function readOpenTypeHeader(ttf) {
                    return {
                      version: ttf.getString(4),
                      numTables: ttf.getUint16(),
                      searchRange: ttf.getUint16(),
                      entrySelector: ttf.getUint16(),
                      rangeShift: ttf.getUint16()
                    };
                  }
                  function readTrueTypeCollectionHeader(ttc) {
                    const ttcTag = ttc.getString(4);
                    (0, _util2.assert)(ttcTag === "ttcf", "Must be a TrueType Collection font.");
                    const majorVersion = ttc.getUint16();
                    const minorVersion = ttc.getUint16();
                    const numFonts = ttc.getInt32() >>> 0;
                    const offsetTable = [];
                    for (let i = 0; i < numFonts; i++) {
                      offsetTable.push(ttc.getInt32() >>> 0);
                    }
                    const header2 = {
                      ttcTag,
                      majorVersion,
                      minorVersion,
                      numFonts,
                      offsetTable
                    };
                    switch (majorVersion) {
                      case 1:
                        return header2;
                      case 2:
                        header2.dsigTag = ttc.getInt32() >>> 0;
                        header2.dsigLength = ttc.getInt32() >>> 0;
                        header2.dsigOffset = ttc.getInt32() >>> 0;
                        return header2;
                    }
                    throw new _util2.FormatError(`Invalid TrueType Collection majorVersion: ${majorVersion}.`);
                  }
                  function readTrueTypeCollectionData(ttc, fontName) {
                    const {
                      numFonts,
                      offsetTable
                    } = readTrueTypeCollectionHeader(ttc);
                    const fontNameParts = fontName.split("+");
                    let fallbackData;
                    for (let i = 0; i < numFonts; i++) {
                      ttc.pos = (ttc.start || 0) + offsetTable[i];
                      const potentialHeader = readOpenTypeHeader(ttc);
                      const potentialTables = readTables(ttc, potentialHeader.numTables);
                      if (!potentialTables.name) {
                        throw new _util2.FormatError('TrueType Collection font must contain a "name" table.');
                      }
                      const [nameTable] = readNameTable(potentialTables.name);
                      for (let j = 0, jj = nameTable.length; j < jj; j++) {
                        for (let k = 0, kk = nameTable[j].length; k < kk; k++) {
                          const nameEntry = nameTable[j][k]?.replaceAll(/\s/g, "");
                          if (!nameEntry) {
                            continue;
                          }
                          if (nameEntry === fontName) {
                            return {
                              header: potentialHeader,
                              tables: potentialTables
                            };
                          }
                          if (fontNameParts.length < 2) {
                            continue;
                          }
                          for (const part of fontNameParts) {
                            if (nameEntry === part) {
                              fallbackData = {
                                name: part,
                                header: potentialHeader,
                                tables: potentialTables
                              };
                            }
                          }
                        }
                      }
                    }
                    if (fallbackData) {
                      (0, _util2.warn)(`TrueType Collection does not contain "${fontName}" font, falling back to "${fallbackData.name}" font instead.`);
                      return {
                        header: fallbackData.header,
                        tables: fallbackData.tables
                      };
                    }
                    throw new _util2.FormatError(`TrueType Collection does not contain "${fontName}" font.`);
                  }
                  function readCmapTable(cmap, file, isSymbolicFont, hasEncoding) {
                    if (!cmap) {
                      (0, _util2.warn)("No cmap table available.");
                      return {
                        platformId: -1,
                        encodingId: -1,
                        mappings: [],
                        hasShortCmap: false
                      };
                    }
                    let segment;
                    let start = (file.start || 0) + cmap.offset;
                    file.pos = start;
                    file.skip(2);
                    const numTables = file.getUint16();
                    let potentialTable;
                    let canBreak = false;
                    for (let i = 0; i < numTables; i++) {
                      const platformId = file.getUint16();
                      const encodingId = file.getUint16();
                      const offset4 = file.getInt32() >>> 0;
                      let useTable = false;
                      if (potentialTable?.platformId === platformId && potentialTable?.encodingId === encodingId) {
                        continue;
                      }
                      if (platformId === 0 && (encodingId === 0 || encodingId === 1 || encodingId === 3)) {
                        useTable = true;
                      } else if (platformId === 1 && encodingId === 0) {
                        useTable = true;
                      } else if (platformId === 3 && encodingId === 1 && (hasEncoding || !potentialTable)) {
                        useTable = true;
                        if (!isSymbolicFont) {
                          canBreak = true;
                        }
                      } else if (isSymbolicFont && platformId === 3 && encodingId === 0) {
                        useTable = true;
                        let correctlySorted = true;
                        if (i < numTables - 1) {
                          const nextBytes = file.peekBytes(2), nextPlatformId = int162(nextBytes[0], nextBytes[1]);
                          if (nextPlatformId < platformId) {
                            correctlySorted = false;
                          }
                        }
                        if (correctlySorted) {
                          canBreak = true;
                        }
                      }
                      if (useTable) {
                        potentialTable = {
                          platformId,
                          encodingId,
                          offset: offset4
                        };
                      }
                      if (canBreak) {
                        break;
                      }
                    }
                    if (potentialTable) {
                      file.pos = start + potentialTable.offset;
                    }
                    if (!potentialTable || file.peekByte() === -1) {
                      (0, _util2.warn)("Could not find a preferred cmap table.");
                      return {
                        platformId: -1,
                        encodingId: -1,
                        mappings: [],
                        hasShortCmap: false
                      };
                    }
                    const format3 = file.getUint16();
                    let hasShortCmap = false;
                    const mappings = [];
                    let j, glyphId;
                    if (format3 === 0) {
                      file.skip(2 + 2);
                      for (j = 0; j < 256; j++) {
                        const index3 = file.getByte();
                        if (!index3) {
                          continue;
                        }
                        mappings.push({
                          charCode: j,
                          glyphId: index3
                        });
                      }
                      hasShortCmap = true;
                    } else if (format3 === 2) {
                      file.skip(2 + 2);
                      const subHeaderKeys = [];
                      let maxSubHeaderKey = 0;
                      for (let i = 0; i < 256; i++) {
                        const subHeaderKey = file.getUint16() >> 3;
                        subHeaderKeys.push(subHeaderKey);
                        maxSubHeaderKey = Math.max(subHeaderKey, maxSubHeaderKey);
                      }
                      const subHeaders = [];
                      for (let i = 0; i <= maxSubHeaderKey; i++) {
                        subHeaders.push({
                          firstCode: file.getUint16(),
                          entryCount: file.getUint16(),
                          idDelta: signedInt16(file.getByte(), file.getByte()),
                          idRangePos: file.pos + file.getUint16()
                        });
                      }
                      for (let i = 0; i < 256; i++) {
                        if (subHeaderKeys[i] === 0) {
                          file.pos = subHeaders[0].idRangePos + 2 * i;
                          glyphId = file.getUint16();
                          mappings.push({
                            charCode: i,
                            glyphId
                          });
                        } else {
                          const s = subHeaders[subHeaderKeys[i]];
                          for (j = 0; j < s.entryCount; j++) {
                            const charCode = (i << 8) + j + s.firstCode;
                            file.pos = s.idRangePos + 2 * j;
                            glyphId = file.getUint16();
                            if (glyphId !== 0) {
                              glyphId = (glyphId + s.idDelta) % 65536;
                            }
                            mappings.push({
                              charCode,
                              glyphId
                            });
                          }
                        }
                      }
                    } else if (format3 === 4) {
                      file.skip(2 + 2);
                      const segCount = file.getUint16() >> 1;
                      file.skip(6);
                      const segments = [];
                      let segIndex;
                      for (segIndex = 0; segIndex < segCount; segIndex++) {
                        segments.push({
                          end: file.getUint16()
                        });
                      }
                      file.skip(2);
                      for (segIndex = 0; segIndex < segCount; segIndex++) {
                        segments[segIndex].start = file.getUint16();
                      }
                      for (segIndex = 0; segIndex < segCount; segIndex++) {
                        segments[segIndex].delta = file.getUint16();
                      }
                      let offsetsCount = 0, offsetIndex;
                      for (segIndex = 0; segIndex < segCount; segIndex++) {
                        segment = segments[segIndex];
                        const rangeOffset = file.getUint16();
                        if (!rangeOffset) {
                          segment.offsetIndex = -1;
                          continue;
                        }
                        offsetIndex = (rangeOffset >> 1) - (segCount - segIndex);
                        segment.offsetIndex = offsetIndex;
                        offsetsCount = Math.max(offsetsCount, offsetIndex + segment.end - segment.start + 1);
                      }
                      const offsets = [];
                      for (j = 0; j < offsetsCount; j++) {
                        offsets.push(file.getUint16());
                      }
                      for (segIndex = 0; segIndex < segCount; segIndex++) {
                        segment = segments[segIndex];
                        start = segment.start;
                        const end = segment.end;
                        const delta = segment.delta;
                        offsetIndex = segment.offsetIndex;
                        for (j = start; j <= end; j++) {
                          if (j === 65535) {
                            continue;
                          }
                          glyphId = offsetIndex < 0 ? j : offsets[offsetIndex + j - start];
                          glyphId = glyphId + delta & 65535;
                          mappings.push({
                            charCode: j,
                            glyphId
                          });
                        }
                      }
                    } else if (format3 === 6) {
                      file.skip(2 + 2);
                      const firstCode = file.getUint16();
                      const entryCount = file.getUint16();
                      for (j = 0; j < entryCount; j++) {
                        glyphId = file.getUint16();
                        const charCode = firstCode + j;
                        mappings.push({
                          charCode,
                          glyphId
                        });
                      }
                    } else if (format3 === 12) {
                      file.skip(2 + 4 + 4);
                      const nGroups = file.getInt32() >>> 0;
                      for (j = 0; j < nGroups; j++) {
                        const startCharCode = file.getInt32() >>> 0;
                        const endCharCode = file.getInt32() >>> 0;
                        let glyphCode = file.getInt32() >>> 0;
                        for (let charCode = startCharCode; charCode <= endCharCode; charCode++) {
                          mappings.push({
                            charCode,
                            glyphId: glyphCode++
                          });
                        }
                      }
                    } else {
                      (0, _util2.warn)("cmap table has unsupported format: " + format3);
                      return {
                        platformId: -1,
                        encodingId: -1,
                        mappings: [],
                        hasShortCmap: false
                      };
                    }
                    mappings.sort(function(a, b) {
                      return a.charCode - b.charCode;
                    });
                    for (let i = 1; i < mappings.length; i++) {
                      if (mappings[i - 1].charCode === mappings[i].charCode) {
                        mappings.splice(i, 1);
                        i--;
                      }
                    }
                    return {
                      platformId: potentialTable.platformId,
                      encodingId: potentialTable.encodingId,
                      mappings,
                      hasShortCmap
                    };
                  }
                  function sanitizeMetrics(file, header2, metrics, headTable, numGlyphs2, dupFirstEntry2) {
                    if (!header2) {
                      if (metrics) {
                        metrics.data = null;
                      }
                      return;
                    }
                    file.pos = (file.start || 0) + header2.offset;
                    file.pos += 4;
                    file.pos += 2;
                    file.pos += 2;
                    file.pos += 2;
                    file.pos += 2;
                    file.pos += 2;
                    file.pos += 2;
                    file.pos += 2;
                    file.pos += 2;
                    file.pos += 2;
                    const caretOffset = file.getUint16();
                    file.pos += 8;
                    file.pos += 2;
                    let numOfMetrics = file.getUint16();
                    if (caretOffset !== 0) {
                      const macStyle = int162(headTable.data[44], headTable.data[45]);
                      if (!(macStyle & 2)) {
                        header2.data[22] = 0;
                        header2.data[23] = 0;
                      }
                    }
                    if (numOfMetrics > numGlyphs2) {
                      (0, _util2.info)(`The numOfMetrics (${numOfMetrics}) should not be greater than the numGlyphs (${numGlyphs2}).`);
                      numOfMetrics = numGlyphs2;
                      header2.data[34] = (numOfMetrics & 65280) >> 8;
                      header2.data[35] = numOfMetrics & 255;
                    }
                    const numOfSidebearings = numGlyphs2 - numOfMetrics;
                    const numMissing = numOfSidebearings - (metrics.length - numOfMetrics * 4 >> 1);
                    if (numMissing > 0) {
                      const entries = new Uint8Array(metrics.length + numMissing * 2);
                      entries.set(metrics.data);
                      if (dupFirstEntry2) {
                        entries[metrics.length] = metrics.data[2];
                        entries[metrics.length + 1] = metrics.data[3];
                      }
                      metrics.data = entries;
                    }
                  }
                  function sanitizeGlyph(source, sourceStart, sourceEnd, dest, destStart, hintsValid2) {
                    const glyphProfile = {
                      length: 0,
                      sizeOfInstructions: 0
                    };
                    if (sourceStart < 0 || sourceStart >= source.length || sourceEnd > source.length || sourceEnd - sourceStart <= 12) {
                      return glyphProfile;
                    }
                    const glyf = source.subarray(sourceStart, sourceEnd);
                    const xMin = signedInt16(glyf[2], glyf[3]);
                    const yMin = signedInt16(glyf[4], glyf[5]);
                    const xMax = signedInt16(glyf[6], glyf[7]);
                    const yMax = signedInt16(glyf[8], glyf[9]);
                    if (xMin > xMax) {
                      writeSignedInt16(glyf, 2, xMax);
                      writeSignedInt16(glyf, 6, xMin);
                    }
                    if (yMin > yMax) {
                      writeSignedInt16(glyf, 4, yMax);
                      writeSignedInt16(glyf, 8, yMin);
                    }
                    const contoursCount = signedInt16(glyf[0], glyf[1]);
                    if (contoursCount < 0) {
                      if (contoursCount < -1) {
                        return glyphProfile;
                      }
                      dest.set(glyf, destStart);
                      glyphProfile.length = glyf.length;
                      return glyphProfile;
                    }
                    let i, j = 10, flagsCount = 0;
                    for (i = 0; i < contoursCount; i++) {
                      const endPoint = glyf[j] << 8 | glyf[j + 1];
                      flagsCount = endPoint + 1;
                      j += 2;
                    }
                    const instructionsStart = j;
                    const instructionsLength = glyf[j] << 8 | glyf[j + 1];
                    glyphProfile.sizeOfInstructions = instructionsLength;
                    j += 2 + instructionsLength;
                    const instructionsEnd = j;
                    let coordinatesLength = 0;
                    for (i = 0; i < flagsCount; i++) {
                      const flag = glyf[j++];
                      if (flag & 192) {
                        glyf[j - 1] = flag & 63;
                      }
                      let xLength = 2;
                      if (flag & 2) {
                        xLength = 1;
                      } else if (flag & 16) {
                        xLength = 0;
                      }
                      let yLength = 2;
                      if (flag & 4) {
                        yLength = 1;
                      } else if (flag & 32) {
                        yLength = 0;
                      }
                      const xyLength = xLength + yLength;
                      coordinatesLength += xyLength;
                      if (flag & 8) {
                        const repeat = glyf[j++];
                        if (repeat === 0) {
                          glyf[j - 1] ^= 8;
                        }
                        i += repeat;
                        coordinatesLength += repeat * xyLength;
                      }
                    }
                    if (coordinatesLength === 0) {
                      return glyphProfile;
                    }
                    let glyphDataLength = j + coordinatesLength;
                    if (glyphDataLength > glyf.length) {
                      return glyphProfile;
                    }
                    if (!hintsValid2 && instructionsLength > 0) {
                      dest.set(glyf.subarray(0, instructionsStart), destStart);
                      dest.set([0, 0], destStart + instructionsStart);
                      dest.set(glyf.subarray(instructionsEnd, glyphDataLength), destStart + instructionsStart + 2);
                      glyphDataLength -= instructionsLength;
                      if (glyf.length - glyphDataLength > 3) {
                        glyphDataLength = glyphDataLength + 3 & ~3;
                      }
                      glyphProfile.length = glyphDataLength;
                      return glyphProfile;
                    }
                    if (glyf.length - glyphDataLength > 3) {
                      glyphDataLength = glyphDataLength + 3 & ~3;
                      dest.set(glyf.subarray(0, glyphDataLength), destStart);
                      glyphProfile.length = glyphDataLength;
                      return glyphProfile;
                    }
                    dest.set(glyf, destStart);
                    glyphProfile.length = glyf.length;
                    return glyphProfile;
                  }
                  function sanitizeHead(head, numGlyphs2, locaLength) {
                    const data2 = head.data;
                    const version8 = int322(data2[0], data2[1], data2[2], data2[3]);
                    if (version8 >> 16 !== 1) {
                      (0, _util2.info)("Attempting to fix invalid version in head table: " + version8);
                      data2[0] = 0;
                      data2[1] = 1;
                      data2[2] = 0;
                      data2[3] = 0;
                    }
                    const indexToLocFormat = int162(data2[50], data2[51]);
                    if (indexToLocFormat < 0 || indexToLocFormat > 1) {
                      (0, _util2.info)("Attempting to fix invalid indexToLocFormat in head table: " + indexToLocFormat);
                      const numGlyphsPlusOne = numGlyphs2 + 1;
                      if (locaLength === numGlyphsPlusOne << 1) {
                        data2[50] = 0;
                        data2[51] = 0;
                      } else if (locaLength === numGlyphsPlusOne << 2) {
                        data2[50] = 0;
                        data2[51] = 1;
                      } else {
                        throw new _util2.FormatError("Could not fix indexToLocFormat: " + indexToLocFormat);
                      }
                    }
                  }
                  function sanitizeGlyphLocations(loca, glyf, numGlyphs2, isGlyphLocationsLong, hintsValid2, dupFirstEntry2, maxSizeOfInstructions2) {
                    let itemSize, itemDecode, itemEncode;
                    if (isGlyphLocationsLong) {
                      itemSize = 4;
                      itemDecode = function fontItemDecodeLong(data2, offset4) {
                        return data2[offset4] << 24 | data2[offset4 + 1] << 16 | data2[offset4 + 2] << 8 | data2[offset4 + 3];
                      };
                      itemEncode = function fontItemEncodeLong(data2, offset4, value) {
                        data2[offset4] = value >>> 24 & 255;
                        data2[offset4 + 1] = value >> 16 & 255;
                        data2[offset4 + 2] = value >> 8 & 255;
                        data2[offset4 + 3] = value & 255;
                      };
                    } else {
                      itemSize = 2;
                      itemDecode = function fontItemDecode(data2, offset4) {
                        return data2[offset4] << 9 | data2[offset4 + 1] << 1;
                      };
                      itemEncode = function fontItemEncode(data2, offset4, value) {
                        data2[offset4] = value >> 9 & 255;
                        data2[offset4 + 1] = value >> 1 & 255;
                      };
                    }
                    const numGlyphsOut2 = dupFirstEntry2 ? numGlyphs2 + 1 : numGlyphs2;
                    const locaDataSize = itemSize * (1 + numGlyphsOut2);
                    const locaData = new Uint8Array(locaDataSize);
                    locaData.set(loca.data.subarray(0, locaDataSize));
                    loca.data = locaData;
                    const oldGlyfData = glyf.data;
                    const oldGlyfDataLength = oldGlyfData.length;
                    const newGlyfData = new Uint8Array(oldGlyfDataLength);
                    let i, j;
                    const locaEntries = [];
                    for (i = 0, j = 0; i < numGlyphs2 + 1; i++, j += itemSize) {
                      let offset4 = itemDecode(locaData, j);
                      if (offset4 > oldGlyfDataLength) {
                        offset4 = oldGlyfDataLength;
                      }
                      locaEntries.push({
                        index: i,
                        offset: offset4,
                        endOffset: 0
                      });
                    }
                    locaEntries.sort((a, b) => {
                      return a.offset - b.offset;
                    });
                    for (i = 0; i < numGlyphs2; i++) {
                      locaEntries[i].endOffset = locaEntries[i + 1].offset;
                    }
                    locaEntries.sort((a, b) => {
                      return a.index - b.index;
                    });
                    for (i = 0; i < numGlyphs2; i++) {
                      const {
                        offset: offset4,
                        endOffset
                      } = locaEntries[i];
                      if (offset4 !== 0 || endOffset !== 0) {
                        break;
                      }
                      const nextOffset = locaEntries[i + 1].offset;
                      if (nextOffset === 0) {
                        continue;
                      }
                      locaEntries[i].endOffset = nextOffset;
                      break;
                    }
                    const missingGlyphs2 = /* @__PURE__ */ Object.create(null);
                    let writeOffset = 0;
                    itemEncode(locaData, 0, writeOffset);
                    for (i = 0, j = itemSize; i < numGlyphs2; i++, j += itemSize) {
                      const glyphProfile = sanitizeGlyph(oldGlyfData, locaEntries[i].offset, locaEntries[i].endOffset, newGlyfData, writeOffset, hintsValid2);
                      const newLength = glyphProfile.length;
                      if (newLength === 0) {
                        missingGlyphs2[i] = true;
                      }
                      if (glyphProfile.sizeOfInstructions > maxSizeOfInstructions2) {
                        maxSizeOfInstructions2 = glyphProfile.sizeOfInstructions;
                      }
                      writeOffset += newLength;
                      itemEncode(locaData, j, writeOffset);
                    }
                    if (writeOffset === 0) {
                      const simpleGlyph = new Uint8Array([0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 49, 0]);
                      for (i = 0, j = itemSize; i < numGlyphsOut2; i++, j += itemSize) {
                        itemEncode(locaData, j, simpleGlyph.length);
                      }
                      glyf.data = simpleGlyph;
                    } else if (dupFirstEntry2) {
                      const firstEntryLength = itemDecode(locaData, itemSize);
                      if (newGlyfData.length > firstEntryLength + writeOffset) {
                        glyf.data = newGlyfData.subarray(0, firstEntryLength + writeOffset);
                      } else {
                        glyf.data = new Uint8Array(firstEntryLength + writeOffset);
                        glyf.data.set(newGlyfData.subarray(0, writeOffset));
                      }
                      glyf.data.set(newGlyfData.subarray(0, firstEntryLength), writeOffset);
                      itemEncode(loca.data, locaData.length - itemSize, writeOffset + firstEntryLength);
                    } else {
                      glyf.data = newGlyfData.subarray(0, writeOffset);
                    }
                    return {
                      missingGlyphs: missingGlyphs2,
                      maxSizeOfInstructions: maxSizeOfInstructions2
                    };
                  }
                  function readPostScriptTable(post, propertiesObj, maxpNumGlyphs) {
                    const start = (font.start || 0) + post.offset;
                    font.pos = start;
                    const length2 = post.length, end = start + length2;
                    const version8 = font.getInt32();
                    font.skip(28);
                    let glyphNames;
                    let valid = true;
                    let i;
                    switch (version8) {
                      case 65536:
                        glyphNames = _fonts_utils.MacStandardGlyphOrdering;
                        break;
                      case 131072:
                        const numGlyphs2 = font.getUint16();
                        if (numGlyphs2 !== maxpNumGlyphs) {
                          valid = false;
                          break;
                        }
                        const glyphNameIndexes = [];
                        for (i = 0; i < numGlyphs2; ++i) {
                          const index3 = font.getUint16();
                          if (index3 >= 32768) {
                            valid = false;
                            break;
                          }
                          glyphNameIndexes.push(index3);
                        }
                        if (!valid) {
                          break;
                        }
                        const customNames = [], strBuf = [];
                        while (font.pos < end) {
                          const stringLength = font.getByte();
                          strBuf.length = stringLength;
                          for (i = 0; i < stringLength; ++i) {
                            strBuf[i] = String.fromCharCode(font.getByte());
                          }
                          customNames.push(strBuf.join(""));
                        }
                        glyphNames = [];
                        for (i = 0; i < numGlyphs2; ++i) {
                          const j = glyphNameIndexes[i];
                          if (j < 258) {
                            glyphNames.push(_fonts_utils.MacStandardGlyphOrdering[j]);
                            continue;
                          }
                          glyphNames.push(customNames[j - 258]);
                        }
                        break;
                      case 196608:
                        break;
                      default:
                        (0, _util2.warn)("Unknown/unsupported post table version " + version8);
                        valid = false;
                        if (propertiesObj.defaultEncoding) {
                          glyphNames = propertiesObj.defaultEncoding;
                        }
                        break;
                    }
                    propertiesObj.glyphNames = glyphNames;
                    return valid;
                  }
                  function readNameTable(nameTable) {
                    const start = (font.start || 0) + nameTable.offset;
                    font.pos = start;
                    const names2 = [[], []], records = [];
                    const length2 = nameTable.length, end = start + length2;
                    const format3 = font.getUint16();
                    const FORMAT_0_HEADER_LENGTH = 6;
                    if (format3 !== 0 || length2 < FORMAT_0_HEADER_LENGTH) {
                      return [names2, records];
                    }
                    const numRecords = font.getUint16();
                    const stringsStart = font.getUint16();
                    const NAME_RECORD_LENGTH = 12;
                    let i, ii;
                    for (i = 0; i < numRecords && font.pos + NAME_RECORD_LENGTH <= end; i++) {
                      const r2 = {
                        platform: font.getUint16(),
                        encoding: font.getUint16(),
                        language: font.getUint16(),
                        name: font.getUint16(),
                        length: font.getUint16(),
                        offset: font.getUint16()
                      };
                      if (isMacNameRecord(r2) || isWinNameRecord(r2)) {
                        records.push(r2);
                      }
                    }
                    for (i = 0, ii = records.length; i < ii; i++) {
                      const record = records[i];
                      if (record.length <= 0) {
                        continue;
                      }
                      const pos = start + stringsStart + record.offset;
                      if (pos + record.length > end) {
                        continue;
                      }
                      font.pos = pos;
                      const nameIndex = record.name;
                      if (record.encoding) {
                        let str = "";
                        for (let j = 0, jj = record.length; j < jj; j += 2) {
                          str += String.fromCharCode(font.getUint16());
                        }
                        names2[1][nameIndex] = str;
                      } else {
                        names2[0][nameIndex] = font.getString(record.length);
                      }
                    }
                    return [names2, records];
                  }
                  const TTOpsStackDeltas = [0, 0, 0, 0, 0, 0, 0, 0, -2, -2, -2, -2, 0, 0, -2, -5, -1, -1, -1, -1, -1, -1, -1, -1, 0, 0, -1, 0, -1, -1, -1, -1, 1, -1, -999, 0, 1, 0, -1, -2, 0, -1, -2, -1, -1, 0, -1, -1, 0, 0, -999, -999, -1, -1, -1, -1, -2, -999, -2, -2, -999, 0, -2, -2, 0, 0, -2, 0, -2, 0, 0, 0, -2, -1, -1, 1, 1, 0, 0, -1, -1, -1, -1, -1, -1, -1, 0, 0, -1, 0, -1, -1, 0, -999, -1, -1, -1, -1, -1, -1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, -2, -999, -999, -999, -999, -999, -1, -1, -2, -2, 0, 0, 0, 0, -1, -1, -999, -2, -2, 0, 0, -1, -2, -2, 0, 0, 0, -1, -1, -1, -2];
                  function sanitizeTTProgram(table, ttContext) {
                    let data2 = table.data;
                    let i = 0, j, n2, b, funcId, pc, lastEndf = 0, lastDeff = 0;
                    const stack = [];
                    const callstack = [];
                    const functionsCalled = [];
                    let tooComplexToFollowFunctions = ttContext.tooComplexToFollowFunctions;
                    let inFDEF = false, ifLevel = 0, inELSE = 0;
                    for (let ii = data2.length; i < ii; ) {
                      const op = data2[i++];
                      if (op === 64) {
                        n2 = data2[i++];
                        if (inFDEF || inELSE) {
                          i += n2;
                        } else {
                          for (j = 0; j < n2; j++) {
                            stack.push(data2[i++]);
                          }
                        }
                      } else if (op === 65) {
                        n2 = data2[i++];
                        if (inFDEF || inELSE) {
                          i += n2 * 2;
                        } else {
                          for (j = 0; j < n2; j++) {
                            b = data2[i++];
                            stack.push(b << 8 | data2[i++]);
                          }
                        }
                      } else if ((op & 248) === 176) {
                        n2 = op - 176 + 1;
                        if (inFDEF || inELSE) {
                          i += n2;
                        } else {
                          for (j = 0; j < n2; j++) {
                            stack.push(data2[i++]);
                          }
                        }
                      } else if ((op & 248) === 184) {
                        n2 = op - 184 + 1;
                        if (inFDEF || inELSE) {
                          i += n2 * 2;
                        } else {
                          for (j = 0; j < n2; j++) {
                            b = data2[i++];
                            stack.push(b << 8 | data2[i++]);
                          }
                        }
                      } else if (op === 43 && !tooComplexToFollowFunctions) {
                        if (!inFDEF && !inELSE) {
                          funcId = stack.at(-1);
                          if (isNaN(funcId)) {
                            (0, _util2.info)("TT: CALL empty stack (or invalid entry).");
                          } else {
                            ttContext.functionsUsed[funcId] = true;
                            if (funcId in ttContext.functionsStackDeltas) {
                              const newStackLength = stack.length + ttContext.functionsStackDeltas[funcId];
                              if (newStackLength < 0) {
                                (0, _util2.warn)("TT: CALL invalid functions stack delta.");
                                ttContext.hintsValid = false;
                                return;
                              }
                              stack.length = newStackLength;
                            } else if (funcId in ttContext.functionsDefined && !functionsCalled.includes(funcId)) {
                              callstack.push({
                                data: data2,
                                i,
                                stackTop: stack.length - 1
                              });
                              functionsCalled.push(funcId);
                              pc = ttContext.functionsDefined[funcId];
                              if (!pc) {
                                (0, _util2.warn)("TT: CALL non-existent function");
                                ttContext.hintsValid = false;
                                return;
                              }
                              data2 = pc.data;
                              i = pc.i;
                            }
                          }
                        }
                      } else if (op === 44 && !tooComplexToFollowFunctions) {
                        if (inFDEF || inELSE) {
                          (0, _util2.warn)("TT: nested FDEFs not allowed");
                          tooComplexToFollowFunctions = true;
                        }
                        inFDEF = true;
                        lastDeff = i;
                        funcId = stack.pop();
                        ttContext.functionsDefined[funcId] = {
                          data: data2,
                          i
                        };
                      } else if (op === 45) {
                        if (inFDEF) {
                          inFDEF = false;
                          lastEndf = i;
                        } else {
                          pc = callstack.pop();
                          if (!pc) {
                            (0, _util2.warn)("TT: ENDF bad stack");
                            ttContext.hintsValid = false;
                            return;
                          }
                          funcId = functionsCalled.pop();
                          data2 = pc.data;
                          i = pc.i;
                          ttContext.functionsStackDeltas[funcId] = stack.length - pc.stackTop;
                        }
                      } else if (op === 137) {
                        if (inFDEF || inELSE) {
                          (0, _util2.warn)("TT: nested IDEFs not allowed");
                          tooComplexToFollowFunctions = true;
                        }
                        inFDEF = true;
                        lastDeff = i;
                      } else if (op === 88) {
                        ++ifLevel;
                      } else if (op === 27) {
                        inELSE = ifLevel;
                      } else if (op === 89) {
                        if (inELSE === ifLevel) {
                          inELSE = 0;
                        }
                        --ifLevel;
                      } else if (op === 28) {
                        if (!inFDEF && !inELSE) {
                          const offset4 = stack.at(-1);
                          if (offset4 > 0) {
                            i += offset4 - 1;
                          }
                        }
                      }
                      if (!inFDEF && !inELSE) {
                        let stackDelta = 0;
                        if (op <= 142) {
                          stackDelta = TTOpsStackDeltas[op];
                        } else if (op >= 192 && op <= 223) {
                          stackDelta = -1;
                        } else if (op >= 224) {
                          stackDelta = -2;
                        }
                        if (op >= 113 && op <= 117) {
                          n2 = stack.pop();
                          if (!isNaN(n2)) {
                            stackDelta = -n2 * 2;
                          }
                        }
                        while (stackDelta < 0 && stack.length > 0) {
                          stack.pop();
                          stackDelta++;
                        }
                        while (stackDelta > 0) {
                          stack.push(NaN);
                          stackDelta--;
                        }
                      }
                    }
                    ttContext.tooComplexToFollowFunctions = tooComplexToFollowFunctions;
                    const content = [data2];
                    if (i > data2.length) {
                      content.push(new Uint8Array(i - data2.length));
                    }
                    if (lastDeff > lastEndf) {
                      (0, _util2.warn)("TT: complementing a missing function tail");
                      content.push(new Uint8Array([34, 45]));
                    }
                    foldTTTable(table, content);
                  }
                  function checkInvalidFunctions(ttContext, maxFunctionDefs2) {
                    if (ttContext.tooComplexToFollowFunctions) {
                      return;
                    }
                    if (ttContext.functionsDefined.length > maxFunctionDefs2) {
                      (0, _util2.warn)("TT: more functions defined than expected");
                      ttContext.hintsValid = false;
                      return;
                    }
                    for (let j = 0, jj = ttContext.functionsUsed.length; j < jj; j++) {
                      if (j > maxFunctionDefs2) {
                        (0, _util2.warn)("TT: invalid function id: " + j);
                        ttContext.hintsValid = false;
                        return;
                      }
                      if (ttContext.functionsUsed[j] && !ttContext.functionsDefined[j]) {
                        (0, _util2.warn)("TT: undefined function: " + j);
                        ttContext.hintsValid = false;
                        return;
                      }
                    }
                  }
                  function foldTTTable(table, content) {
                    if (content.length > 1) {
                      let newLength = 0;
                      let j, jj;
                      for (j = 0, jj = content.length; j < jj; j++) {
                        newLength += content[j].length;
                      }
                      newLength = newLength + 3 & ~3;
                      const result = new Uint8Array(newLength);
                      let pos = 0;
                      for (j = 0, jj = content.length; j < jj; j++) {
                        result.set(content[j], pos);
                        pos += content[j].length;
                      }
                      table.data = result;
                      table.length = newLength;
                    }
                  }
                  function sanitizeTTPrograms(fpgm, prep, cvt, maxFunctionDefs2) {
                    const ttContext = {
                      functionsDefined: [],
                      functionsUsed: [],
                      functionsStackDeltas: [],
                      tooComplexToFollowFunctions: false,
                      hintsValid: true
                    };
                    if (fpgm) {
                      sanitizeTTProgram(fpgm, ttContext);
                    }
                    if (prep) {
                      sanitizeTTProgram(prep, ttContext);
                    }
                    if (fpgm) {
                      checkInvalidFunctions(ttContext, maxFunctionDefs2);
                    }
                    if (cvt && cvt.length & 1) {
                      const cvtData = new Uint8Array(cvt.length + 1);
                      cvtData.set(cvt.data);
                      cvt.data = cvtData;
                    }
                    return ttContext.hintsValid;
                  }
                  font = new _stream.Stream(new Uint8Array(font.getBytes()));
                  let header, tables;
                  if (isTrueTypeCollectionFile(font)) {
                    const ttcData = readTrueTypeCollectionData(font, this.name);
                    header = ttcData.header;
                    tables = ttcData.tables;
                  } else {
                    header = readOpenTypeHeader(font);
                    tables = readTables(font, header.numTables);
                  }
                  let cff, cffFile;
                  const isTrueType = !tables["CFF "];
                  if (!isTrueType) {
                    const isComposite = properties2.composite && (properties2.cidToGidMap?.length > 0 || !(properties2.cMap instanceof _cmap.IdentityCMap));
                    if (header.version === "OTTO" && !isComposite || !tables.head || !tables.hhea || !tables.maxp || !tables.post) {
                      cffFile = new _stream.Stream(tables["CFF "].data);
                      cff = new _cff_font.CFFFont(cffFile, properties2);
                      adjustWidths(properties2);
                      return this.convert(name, cff, properties2);
                    }
                    delete tables.glyf;
                    delete tables.loca;
                    delete tables.fpgm;
                    delete tables.prep;
                    delete tables["cvt "];
                    this.isOpenType = true;
                  } else {
                    if (!tables.loca) {
                      throw new _util2.FormatError('Required "loca" table is not found');
                    }
                    if (!tables.glyf) {
                      (0, _util2.warn)('Required "glyf" table is not found -- trying to recover.');
                      tables.glyf = {
                        tag: "glyf",
                        data: new Uint8Array(0)
                      };
                    }
                    this.isOpenType = false;
                  }
                  if (!tables.maxp) {
                    throw new _util2.FormatError('Required "maxp" table is not found');
                  }
                  font.pos = (font.start || 0) + tables.maxp.offset;
                  const version7 = font.getInt32();
                  const numGlyphs = font.getUint16();
                  if (properties2.scaleFactors?.length === numGlyphs && isTrueType) {
                    const {
                      scaleFactors
                    } = properties2;
                    const isGlyphLocationsLong = int162(tables.head.data[50], tables.head.data[51]);
                    const glyphs = new _glyf.GlyfTable({
                      glyfTable: tables.glyf.data,
                      isGlyphLocationsLong,
                      locaTable: tables.loca.data,
                      numGlyphs
                    });
                    glyphs.scale(scaleFactors);
                    const {
                      glyf,
                      loca,
                      isLocationLong
                    } = glyphs.write();
                    tables.glyf.data = glyf;
                    tables.loca.data = loca;
                    if (isLocationLong !== !!isGlyphLocationsLong) {
                      tables.head.data[50] = 0;
                      tables.head.data[51] = isLocationLong ? 1 : 0;
                    }
                    const metrics = tables.hmtx.data;
                    for (let i = 0; i < numGlyphs; i++) {
                      const j = 4 * i;
                      const advanceWidth = Math.round(scaleFactors[i] * int162(metrics[j], metrics[j + 1]));
                      metrics[j] = advanceWidth >> 8 & 255;
                      metrics[j + 1] = advanceWidth & 255;
                      const lsb = Math.round(scaleFactors[i] * signedInt16(metrics[j + 2], metrics[j + 3]));
                      writeSignedInt16(metrics, j + 2, lsb);
                    }
                  }
                  let numGlyphsOut = numGlyphs + 1;
                  let dupFirstEntry = true;
                  if (numGlyphsOut > 65535) {
                    dupFirstEntry = false;
                    numGlyphsOut = numGlyphs;
                    (0, _util2.warn)("Not enough space in glyfs to duplicate first glyph.");
                  }
                  let maxFunctionDefs = 0;
                  let maxSizeOfInstructions = 0;
                  if (version7 >= 65536 && tables.maxp.length >= 22) {
                    font.pos += 8;
                    const maxZones = font.getUint16();
                    if (maxZones > 2) {
                      tables.maxp.data[14] = 0;
                      tables.maxp.data[15] = 2;
                    }
                    font.pos += 4;
                    maxFunctionDefs = font.getUint16();
                    font.pos += 4;
                    maxSizeOfInstructions = font.getUint16();
                  }
                  tables.maxp.data[4] = numGlyphsOut >> 8;
                  tables.maxp.data[5] = numGlyphsOut & 255;
                  const hintsValid = sanitizeTTPrograms(tables.fpgm, tables.prep, tables["cvt "], maxFunctionDefs);
                  if (!hintsValid) {
                    delete tables.fpgm;
                    delete tables.prep;
                    delete tables["cvt "];
                  }
                  sanitizeMetrics(font, tables.hhea, tables.hmtx, tables.head, numGlyphsOut, dupFirstEntry);
                  if (!tables.head) {
                    throw new _util2.FormatError('Required "head" table is not found');
                  }
                  sanitizeHead(tables.head, numGlyphs, isTrueType ? tables.loca.length : 0);
                  let missingGlyphs = /* @__PURE__ */ Object.create(null);
                  if (isTrueType) {
                    const isGlyphLocationsLong = int162(tables.head.data[50], tables.head.data[51]);
                    const glyphsInfo = sanitizeGlyphLocations(tables.loca, tables.glyf, numGlyphs, isGlyphLocationsLong, hintsValid, dupFirstEntry, maxSizeOfInstructions);
                    missingGlyphs = glyphsInfo.missingGlyphs;
                    if (version7 >= 65536 && tables.maxp.length >= 22) {
                      tables.maxp.data[26] = glyphsInfo.maxSizeOfInstructions >> 8;
                      tables.maxp.data[27] = glyphsInfo.maxSizeOfInstructions & 255;
                    }
                  }
                  if (!tables.hhea) {
                    throw new _util2.FormatError('Required "hhea" table is not found');
                  }
                  if (tables.hhea.data[10] === 0 && tables.hhea.data[11] === 0) {
                    tables.hhea.data[10] = 255;
                    tables.hhea.data[11] = 255;
                  }
                  const metricsOverride = {
                    unitsPerEm: int162(tables.head.data[18], tables.head.data[19]),
                    yMax: signedInt16(tables.head.data[42], tables.head.data[43]),
                    yMin: signedInt16(tables.head.data[38], tables.head.data[39]),
                    ascent: signedInt16(tables.hhea.data[4], tables.hhea.data[5]),
                    descent: signedInt16(tables.hhea.data[6], tables.hhea.data[7]),
                    lineGap: signedInt16(tables.hhea.data[8], tables.hhea.data[9])
                  };
                  this.ascent = metricsOverride.ascent / metricsOverride.unitsPerEm;
                  this.descent = metricsOverride.descent / metricsOverride.unitsPerEm;
                  this.lineGap = metricsOverride.lineGap / metricsOverride.unitsPerEm;
                  if (this.cssFontInfo?.lineHeight) {
                    this.lineHeight = this.cssFontInfo.metrics.lineHeight;
                    this.lineGap = this.cssFontInfo.metrics.lineGap;
                  } else {
                    this.lineHeight = this.ascent - this.descent + this.lineGap;
                  }
                  if (tables.post) {
                    readPostScriptTable(tables.post, properties2, numGlyphs);
                  }
                  tables.post = {
                    tag: "post",
                    data: createPostTable(properties2)
                  };
                  const charCodeToGlyphId = [];
                  function hasGlyph(glyphId) {
                    return !missingGlyphs[glyphId];
                  }
                  if (properties2.composite) {
                    const cidToGidMap = properties2.cidToGidMap || [];
                    const isCidToGidMapEmpty = cidToGidMap.length === 0;
                    properties2.cMap.forEach(function(charCode, cid) {
                      if (typeof cid === "string") {
                        cid = convertCidString(charCode, cid, true);
                      }
                      if (cid > 65535) {
                        throw new _util2.FormatError("Max size of CID is 65,535");
                      }
                      let glyphId = -1;
                      if (isCidToGidMapEmpty) {
                        glyphId = cid;
                      } else if (cidToGidMap[cid] !== void 0) {
                        glyphId = cidToGidMap[cid];
                      }
                      if (glyphId >= 0 && glyphId < numGlyphs && hasGlyph(glyphId)) {
                        charCodeToGlyphId[charCode] = glyphId;
                      }
                    });
                  } else {
                    const cmapTable = readCmapTable(tables.cmap, font, this.isSymbolicFont, properties2.hasEncoding);
                    const cmapPlatformId = cmapTable.platformId;
                    const cmapEncodingId = cmapTable.encodingId;
                    const cmapMappings = cmapTable.mappings;
                    let baseEncoding = [], forcePostTable = false;
                    if (properties2.hasEncoding && (properties2.baseEncodingName === "MacRomanEncoding" || properties2.baseEncodingName === "WinAnsiEncoding")) {
                      baseEncoding = (0, _encodings.getEncoding)(properties2.baseEncodingName);
                    }
                    if (properties2.hasEncoding && !this.isSymbolicFont && (cmapPlatformId === 3 && cmapEncodingId === 1 || cmapPlatformId === 1 && cmapEncodingId === 0)) {
                      const glyphsUnicodeMap = (0, _glyphlist.getGlyphsUnicode)();
                      for (let charCode = 0; charCode < 256; charCode++) {
                        let glyphName;
                        if (this.differences[charCode] !== void 0) {
                          glyphName = this.differences[charCode];
                        } else if (baseEncoding.length && baseEncoding[charCode] !== "") {
                          glyphName = baseEncoding[charCode];
                        } else {
                          glyphName = _encodings.StandardEncoding[charCode];
                        }
                        if (!glyphName) {
                          continue;
                        }
                        const standardGlyphName = (0, _fonts_utils.recoverGlyphName)(glyphName, glyphsUnicodeMap);
                        let unicodeOrCharCode;
                        if (cmapPlatformId === 3 && cmapEncodingId === 1) {
                          unicodeOrCharCode = glyphsUnicodeMap[standardGlyphName];
                        } else if (cmapPlatformId === 1 && cmapEncodingId === 0) {
                          unicodeOrCharCode = _encodings.MacRomanEncoding.indexOf(standardGlyphName);
                        }
                        if (unicodeOrCharCode === void 0) {
                          if (!properties2.glyphNames && properties2.hasIncludedToUnicodeMap && !(this.toUnicode instanceof _to_unicode_map.IdentityToUnicodeMap)) {
                            const unicode = this.toUnicode.get(charCode);
                            if (unicode) {
                              unicodeOrCharCode = unicode.codePointAt(0);
                            }
                          }
                          if (unicodeOrCharCode === void 0) {
                            continue;
                          }
                        }
                        for (const mapping2 of cmapMappings) {
                          if (mapping2.charCode !== unicodeOrCharCode) {
                            continue;
                          }
                          charCodeToGlyphId[charCode] = mapping2.glyphId;
                          break;
                        }
                      }
                    } else if (cmapPlatformId === 0) {
                      for (const mapping2 of cmapMappings) {
                        charCodeToGlyphId[mapping2.charCode] = mapping2.glyphId;
                      }
                      forcePostTable = true;
                    } else {
                      for (const mapping2 of cmapMappings) {
                        let charCode = mapping2.charCode;
                        if (cmapPlatformId === 3 && charCode >= 61440 && charCode <= 61695) {
                          charCode &= 255;
                        }
                        charCodeToGlyphId[charCode] = mapping2.glyphId;
                      }
                    }
                    if (properties2.glyphNames && (baseEncoding.length || this.differences.length)) {
                      for (let i = 0; i < 256; ++i) {
                        if (!forcePostTable && charCodeToGlyphId[i] !== void 0) {
                          continue;
                        }
                        const glyphName = this.differences[i] || baseEncoding[i];
                        if (!glyphName) {
                          continue;
                        }
                        const glyphId = properties2.glyphNames.indexOf(glyphName);
                        if (glyphId > 0 && hasGlyph(glyphId)) {
                          charCodeToGlyphId[i] = glyphId;
                        }
                      }
                    }
                  }
                  if (charCodeToGlyphId.length === 0) {
                    charCodeToGlyphId[0] = 0;
                  }
                  let glyphZeroId = numGlyphsOut - 1;
                  if (!dupFirstEntry) {
                    glyphZeroId = 0;
                  }
                  if (!properties2.cssFontInfo) {
                    const newMapping = adjustMapping(charCodeToGlyphId, hasGlyph, glyphZeroId, this.toUnicode);
                    this.toFontChar = newMapping.toFontChar;
                    tables.cmap = {
                      tag: "cmap",
                      data: createCmapTable(newMapping.charCodeToGlyphId, newMapping.toUnicodeExtraMap, numGlyphsOut)
                    };
                    if (!tables["OS/2"] || !validateOS2Table(tables["OS/2"], font)) {
                      tables["OS/2"] = {
                        tag: "OS/2",
                        data: createOS2Table(properties2, newMapping.charCodeToGlyphId, metricsOverride)
                      };
                    }
                  }
                  if (!isTrueType) {
                    try {
                      cffFile = new _stream.Stream(tables["CFF "].data);
                      const parser = new _cff_parser.CFFParser(cffFile, properties2, _fonts_utils.SEAC_ANALYSIS_ENABLED);
                      cff = parser.parse();
                      cff.duplicateFirstGlyph();
                      const compiler = new _cff_parser.CFFCompiler(cff);
                      tables["CFF "].data = compiler.compile();
                    } catch {
                      (0, _util2.warn)("Failed to compile font " + properties2.loadedName);
                    }
                  }
                  if (!tables.name) {
                    tables.name = {
                      tag: "name",
                      data: createNameTable(this.name)
                    };
                  } else {
                    const [namePrototype, nameRecords] = readNameTable(tables.name);
                    tables.name.data = createNameTable(name, namePrototype);
                    this.psName = namePrototype[0][6] || null;
                    if (!properties2.composite) {
                      adjustTrueTypeToUnicode(properties2, this.isSymbolicFont, nameRecords);
                    }
                  }
                  const builder = new _opentype_file_builder.OpenTypeFileBuilder(header.version);
                  for (const tableTag in tables) {
                    builder.addTable(tableTag, tables[tableTag].data);
                  }
                  return builder.toArray();
                }
                convert(fontName, font, properties2) {
                  properties2.fixedPitch = false;
                  if (properties2.builtInEncoding) {
                    adjustType1ToUnicode(properties2, properties2.builtInEncoding);
                  }
                  let glyphZeroId = 1;
                  if (font instanceof _cff_font.CFFFont) {
                    glyphZeroId = font.numGlyphs - 1;
                  }
                  const mapping2 = font.getGlyphMapping(properties2);
                  let newMapping = null;
                  let newCharCodeToGlyphId = mapping2;
                  let toUnicodeExtraMap = null;
                  if (!properties2.cssFontInfo) {
                    newMapping = adjustMapping(mapping2, font.hasGlyphId.bind(font), glyphZeroId, this.toUnicode);
                    this.toFontChar = newMapping.toFontChar;
                    newCharCodeToGlyphId = newMapping.charCodeToGlyphId;
                    toUnicodeExtraMap = newMapping.toUnicodeExtraMap;
                  }
                  const numGlyphs = font.numGlyphs;
                  function getCharCodes(charCodeToGlyphId, glyphId) {
                    let charCodes = null;
                    for (const charCode in charCodeToGlyphId) {
                      if (glyphId === charCodeToGlyphId[charCode]) {
                        (charCodes ||= []).push(charCode | 0);
                      }
                    }
                    return charCodes;
                  }
                  function createCharCode(charCodeToGlyphId, glyphId) {
                    for (const charCode in charCodeToGlyphId) {
                      if (glyphId === charCodeToGlyphId[charCode]) {
                        return charCode | 0;
                      }
                    }
                    newMapping.charCodeToGlyphId[newMapping.nextAvailableFontCharCode] = glyphId;
                    return newMapping.nextAvailableFontCharCode++;
                  }
                  const seacs = font.seacs;
                  if (newMapping && _fonts_utils.SEAC_ANALYSIS_ENABLED && seacs?.length) {
                    const matrix = properties2.fontMatrix || _util2.FONT_IDENTITY_MATRIX;
                    const charset = font.getCharset();
                    const seacMap = /* @__PURE__ */ Object.create(null);
                    for (let glyphId in seacs) {
                      glyphId |= 0;
                      const seac = seacs[glyphId];
                      const baseGlyphName = _encodings.StandardEncoding[seac[2]];
                      const accentGlyphName = _encodings.StandardEncoding[seac[3]];
                      const baseGlyphId = charset.indexOf(baseGlyphName);
                      const accentGlyphId = charset.indexOf(accentGlyphName);
                      if (baseGlyphId < 0 || accentGlyphId < 0) {
                        continue;
                      }
                      const accentOffset = {
                        x: seac[0] * matrix[0] + seac[1] * matrix[2] + matrix[4],
                        y: seac[0] * matrix[1] + seac[1] * matrix[3] + matrix[5]
                      };
                      const charCodes = getCharCodes(mapping2, glyphId);
                      if (!charCodes) {
                        continue;
                      }
                      for (const charCode of charCodes) {
                        const charCodeToGlyphId = newMapping.charCodeToGlyphId;
                        const baseFontCharCode = createCharCode(charCodeToGlyphId, baseGlyphId);
                        const accentFontCharCode = createCharCode(charCodeToGlyphId, accentGlyphId);
                        seacMap[charCode] = {
                          baseFontCharCode,
                          accentFontCharCode,
                          accentOffset
                        };
                      }
                    }
                    properties2.seacMap = seacMap;
                  }
                  const unitsPerEm = 1 / (properties2.fontMatrix || _util2.FONT_IDENTITY_MATRIX)[0];
                  const builder = new _opentype_file_builder.OpenTypeFileBuilder("OTTO");
                  builder.addTable("CFF ", font.data);
                  builder.addTable("OS/2", createOS2Table(properties2, newCharCodeToGlyphId));
                  builder.addTable("cmap", createCmapTable(newCharCodeToGlyphId, toUnicodeExtraMap, numGlyphs));
                  builder.addTable("head", "\0\0\0\0\0\0\0\0\0\0_<\xF5\0\0" + safeString16(unitsPerEm) + "\0\0\0\0\x9E\v~'\0\0\0\0\x9E\v~'\0\0" + safeString16(properties2.descent) + "\xFF" + safeString16(properties2.ascent) + string16(properties2.italicAngle ? 2 : 0) + "\0\0\0\0\0\0\0");
                  builder.addTable("hhea", "\0\0\0" + safeString16(properties2.ascent) + safeString16(properties2.descent) + "\0\0\xFF\xFF\0\0\0\0\0\0" + safeString16(properties2.capHeight) + safeString16(Math.tan(properties2.italicAngle) * properties2.xHeight) + "\0\0\0\0\0\0\0\0\0\0\0\0" + string16(numGlyphs));
                  builder.addTable("hmtx", (function fontFieldsHmtx() {
                    const charstrings = font.charstrings;
                    const cffWidths = font.cff ? font.cff.widths : null;
                    let hmtx = "\0\0\0\0";
                    for (let i = 1, ii = numGlyphs; i < ii; i++) {
                      let width = 0;
                      if (charstrings) {
                        const charstring = charstrings[i - 1];
                        width = "width" in charstring ? charstring.width : 0;
                      } else if (cffWidths) {
                        width = Math.ceil(cffWidths[i] || 0);
                      }
                      hmtx += string16(width) + string16(0);
                    }
                    return hmtx;
                  })());
                  builder.addTable("maxp", "\0\0P\0" + string16(numGlyphs));
                  builder.addTable("name", createNameTable(fontName));
                  builder.addTable("post", createPostTable(properties2));
                  return builder.toArray();
                }
                get spaceWidth() {
                  const possibleSpaceReplacements = ["space", "minus", "one", "i", "I"];
                  let width;
                  for (const glyphName of possibleSpaceReplacements) {
                    if (glyphName in this.widths) {
                      width = this.widths[glyphName];
                      break;
                    }
                    const glyphsUnicodeMap = (0, _glyphlist.getGlyphsUnicode)();
                    const glyphUnicode = glyphsUnicodeMap[glyphName];
                    let charcode = 0;
                    if (this.composite && this.cMap.contains(glyphUnicode)) {
                      charcode = this.cMap.lookup(glyphUnicode);
                      if (typeof charcode === "string") {
                        charcode = convertCidString(glyphUnicode, charcode);
                      }
                    }
                    if (!charcode && this.toUnicode) {
                      charcode = this.toUnicode.charCodeOf(glyphUnicode);
                    }
                    if (charcode <= 0) {
                      charcode = glyphUnicode;
                    }
                    width = this.widths[charcode];
                    if (width) {
                      break;
                    }
                  }
                  return (0, _util2.shadow)(this, "spaceWidth", width || this.defaultWidth);
                }
                _charToGlyph(charcode, isSpace = false) {
                  let glyph = this._glyphCache[charcode];
                  if (glyph?.isSpace === isSpace) {
                    return glyph;
                  }
                  let fontCharCode, width, operatorListId;
                  let widthCode = charcode;
                  if (this.cMap?.contains(charcode)) {
                    widthCode = this.cMap.lookup(charcode);
                    if (typeof widthCode === "string") {
                      widthCode = convertCidString(charcode, widthCode);
                    }
                  }
                  width = this.widths[widthCode];
                  if (typeof width !== "number") {
                    width = this.defaultWidth;
                  }
                  const vmetric = this.vmetrics?.[widthCode];
                  let unicode = this.toUnicode.get(charcode) || charcode;
                  if (typeof unicode === "number") {
                    unicode = String.fromCharCode(unicode);
                  }
                  let isInFont = this.toFontChar[charcode] !== void 0;
                  fontCharCode = this.toFontChar[charcode] || charcode;
                  if (this.missingFile) {
                    const glyphName = this.differences[charcode] || this.defaultEncoding[charcode];
                    if ((glyphName === ".notdef" || glyphName === "") && this.type === "Type1") {
                      fontCharCode = 32;
                    }
                    fontCharCode = (0, _unicode.mapSpecialUnicodeValues)(fontCharCode);
                  }
                  if (this.isType3Font) {
                    operatorListId = fontCharCode;
                  }
                  let accent = null;
                  if (this.seacMap?.[charcode]) {
                    isInFont = true;
                    const seac = this.seacMap[charcode];
                    fontCharCode = seac.baseFontCharCode;
                    accent = {
                      fontChar: String.fromCodePoint(seac.accentFontCharCode),
                      offset: seac.accentOffset
                    };
                  }
                  let fontChar = "";
                  if (typeof fontCharCode === "number") {
                    if (fontCharCode <= 1114111) {
                      fontChar = String.fromCodePoint(fontCharCode);
                    } else {
                      (0, _util2.warn)(`charToGlyph - invalid fontCharCode: ${fontCharCode}`);
                    }
                  }
                  glyph = new Glyph(charcode, fontChar, unicode, accent, width, vmetric, operatorListId, isSpace, isInFont);
                  return this._glyphCache[charcode] = glyph;
                }
                charsToGlyphs(chars) {
                  let glyphs = this._charsCache[chars];
                  if (glyphs) {
                    return glyphs;
                  }
                  glyphs = [];
                  if (this.cMap) {
                    const c = /* @__PURE__ */ Object.create(null), ii = chars.length;
                    let i = 0;
                    while (i < ii) {
                      this.cMap.readCharCode(chars, i, c);
                      const {
                        charcode,
                        length: length2
                      } = c;
                      i += length2;
                      const glyph = this._charToGlyph(charcode, length2 === 1 && chars.charCodeAt(i - 1) === 32);
                      glyphs.push(glyph);
                    }
                  } else {
                    for (let i = 0, ii = chars.length; i < ii; ++i) {
                      const charcode = chars.charCodeAt(i);
                      const glyph = this._charToGlyph(charcode, charcode === 32);
                      glyphs.push(glyph);
                    }
                  }
                  return this._charsCache[chars] = glyphs;
                }
                getCharPositions(chars) {
                  const positions = [];
                  if (this.cMap) {
                    const c = /* @__PURE__ */ Object.create(null);
                    let i = 0;
                    while (i < chars.length) {
                      this.cMap.readCharCode(chars, i, c);
                      const length2 = c.length;
                      positions.push([i, i + length2]);
                      i += length2;
                    }
                  } else {
                    for (let i = 0, ii = chars.length; i < ii; ++i) {
                      positions.push([i, i + 1]);
                    }
                  }
                  return positions;
                }
                get glyphCacheValues() {
                  return Object.values(this._glyphCache);
                }
                encodeString(str) {
                  const buffers = [];
                  const currentBuf = [];
                  const hasCurrentBufErrors = () => buffers.length % 2 === 1;
                  const getCharCode = this.toUnicode instanceof _to_unicode_map.IdentityToUnicodeMap ? (unicode) => this.toUnicode.charCodeOf(unicode) : (unicode) => this.toUnicode.charCodeOf(String.fromCodePoint(unicode));
                  for (let i = 0, ii = str.length; i < ii; i++) {
                    const unicode = str.codePointAt(i);
                    if (unicode > 55295 && (unicode < 57344 || unicode > 65533)) {
                      i++;
                    }
                    if (this.toUnicode) {
                      const charCode = getCharCode(unicode);
                      if (charCode !== -1) {
                        if (hasCurrentBufErrors()) {
                          buffers.push(currentBuf.join(""));
                          currentBuf.length = 0;
                        }
                        const charCodeLength = this.cMap ? this.cMap.getCharCodeLength(charCode) : 1;
                        for (let j = charCodeLength - 1; j >= 0; j--) {
                          currentBuf.push(String.fromCharCode(charCode >> 8 * j & 255));
                        }
                        continue;
                      }
                    }
                    if (!hasCurrentBufErrors()) {
                      buffers.push(currentBuf.join(""));
                      currentBuf.length = 0;
                    }
                    currentBuf.push(String.fromCodePoint(unicode));
                  }
                  buffers.push(currentBuf.join(""));
                  return buffers;
                }
              }
              exports3.Font = Font3;
              class ErrorFont {
                constructor(error2) {
                  this.error = error2;
                  this.loadedName = "g_font_error";
                  this.missingFile = true;
                }
                charsToGlyphs() {
                  return [];
                }
                encodeString(chars) {
                  return [chars];
                }
                exportData(extraProperties = false) {
                  return {
                    error: this.error
                  };
                }
              }
              exports3.ErrorFont = ErrorFont;
            }),
            /* 35 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.CFFTopDict = exports3.CFFStrings = exports3.CFFStandardStrings = exports3.CFFPrivateDict = exports3.CFFParser = exports3.CFFIndex = exports3.CFFHeader = exports3.CFFFDSelect = exports3.CFFCompiler = exports3.CFFCharset = exports3.CFF = void 0;
              var _util2 = __w_pdfjs_require__3(2);
              var _charsets = __w_pdfjs_require__3(36);
              var _encodings = __w_pdfjs_require__3(37);
              const MAX_SUBR_NESTING = 10;
              const CFFStandardStrings = [".notdef", "space", "exclam", "quotedbl", "numbersign", "dollar", "percent", "ampersand", "quoteright", "parenleft", "parenright", "asterisk", "plus", "comma", "hyphen", "period", "slash", "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "colon", "semicolon", "less", "equal", "greater", "question", "at", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "bracketleft", "backslash", "bracketright", "asciicircum", "underscore", "quoteleft", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "braceleft", "bar", "braceright", "asciitilde", "exclamdown", "cent", "sterling", "fraction", "yen", "florin", "section", "currency", "quotesingle", "quotedblleft", "guillemotleft", "guilsinglleft", "guilsinglright", "fi", "fl", "endash", "dagger", "daggerdbl", "periodcentered", "paragraph", "bullet", "quotesinglbase", "quotedblbase", "quotedblright", "guillemotright", "ellipsis", "perthousand", "questiondown", "grave", "acute", "circumflex", "tilde", "macron", "breve", "dotaccent", "dieresis", "ring", "cedilla", "hungarumlaut", "ogonek", "caron", "emdash", "AE", "ordfeminine", "Lslash", "Oslash", "OE", "ordmasculine", "ae", "dotlessi", "lslash", "oslash", "oe", "germandbls", "onesuperior", "logicalnot", "mu", "trademark", "Eth", "onehalf", "plusminus", "Thorn", "onequarter", "divide", "brokenbar", "degree", "thorn", "threequarters", "twosuperior", "registered", "minus", "eth", "multiply", "threesuperior", "copyright", "Aacute", "Acircumflex", "Adieresis", "Agrave", "Aring", "Atilde", "Ccedilla", "Eacute", "Ecircumflex", "Edieresis", "Egrave", "Iacute", "Icircumflex", "Idieresis", "Igrave", "Ntilde", "Oacute", "Ocircumflex", "Odieresis", "Ograve", "Otilde", "Scaron", "Uacute", "Ucircumflex", "Udieresis", "Ugrave", "Yacute", "Ydieresis", "Zcaron", "aacute", "acircumflex", "adieresis", "agrave", "aring", "atilde", "ccedilla", "eacute", "ecircumflex", "edieresis", "egrave", "iacute", "icircumflex", "idieresis", "igrave", "ntilde", "oacute", "ocircumflex", "odieresis", "ograve", "otilde", "scaron", "uacute", "ucircumflex", "udieresis", "ugrave", "yacute", "ydieresis", "zcaron", "exclamsmall", "Hungarumlautsmall", "dollaroldstyle", "dollarsuperior", "ampersandsmall", "Acutesmall", "parenleftsuperior", "parenrightsuperior", "twodotenleader", "onedotenleader", "zerooldstyle", "oneoldstyle", "twooldstyle", "threeoldstyle", "fouroldstyle", "fiveoldstyle", "sixoldstyle", "sevenoldstyle", "eightoldstyle", "nineoldstyle", "commasuperior", "threequartersemdash", "periodsuperior", "questionsmall", "asuperior", "bsuperior", "centsuperior", "dsuperior", "esuperior", "isuperior", "lsuperior", "msuperior", "nsuperior", "osuperior", "rsuperior", "ssuperior", "tsuperior", "ff", "ffi", "ffl", "parenleftinferior", "parenrightinferior", "Circumflexsmall", "hyphensuperior", "Gravesmall", "Asmall", "Bsmall", "Csmall", "Dsmall", "Esmall", "Fsmall", "Gsmall", "Hsmall", "Ismall", "Jsmall", "Ksmall", "Lsmall", "Msmall", "Nsmall", "Osmall", "Psmall", "Qsmall", "Rsmall", "Ssmall", "Tsmall", "Usmall", "Vsmall", "Wsmall", "Xsmall", "Ysmall", "Zsmall", "colonmonetary", "onefitted", "rupiah", "Tildesmall", "exclamdownsmall", "centoldstyle", "Lslashsmall", "Scaronsmall", "Zcaronsmall", "Dieresissmall", "Brevesmall", "Caronsmall", "Dotaccentsmall", "Macronsmall", "figuredash", "hypheninferior", "Ogoneksmall", "Ringsmall", "Cedillasmall", "questiondownsmall", "oneeighth", "threeeighths", "fiveeighths", "seveneighths", "onethird", "twothirds", "zerosuperior", "foursuperior", "fivesuperior", "sixsuperior", "sevensuperior", "eightsuperior", "ninesuperior", "zeroinferior", "oneinferior", "twoinferior", "threeinferior", "fourinferior", "fiveinferior", "sixinferior", "seveninferior", "eightinferior", "nineinferior", "centinferior", "dollarinferior", "periodinferior", "commainferior", "Agravesmall", "Aacutesmall", "Acircumflexsmall", "Atildesmall", "Adieresissmall", "Aringsmall", "AEsmall", "Ccedillasmall", "Egravesmall", "Eacutesmall", "Ecircumflexsmall", "Edieresissmall", "Igravesmall", "Iacutesmall", "Icircumflexsmall", "Idieresissmall", "Ethsmall", "Ntildesmall", "Ogravesmall", "Oacutesmall", "Ocircumflexsmall", "Otildesmall", "Odieresissmall", "OEsmall", "Oslashsmall", "Ugravesmall", "Uacutesmall", "Ucircumflexsmall", "Udieresissmall", "Yacutesmall", "Thornsmall", "Ydieresissmall", "001.000", "001.001", "001.002", "001.003", "Black", "Bold", "Book", "Light", "Medium", "Regular", "Roman", "Semibold"];
              exports3.CFFStandardStrings = CFFStandardStrings;
              const NUM_STANDARD_CFF_STRINGS = 391;
              const CharstringValidationData = [null, {
                id: "hstem",
                min: 2,
                stackClearing: true,
                stem: true
              }, null, {
                id: "vstem",
                min: 2,
                stackClearing: true,
                stem: true
              }, {
                id: "vmoveto",
                min: 1,
                stackClearing: true
              }, {
                id: "rlineto",
                min: 2,
                resetStack: true
              }, {
                id: "hlineto",
                min: 1,
                resetStack: true
              }, {
                id: "vlineto",
                min: 1,
                resetStack: true
              }, {
                id: "rrcurveto",
                min: 6,
                resetStack: true
              }, null, {
                id: "callsubr",
                min: 1,
                undefStack: true
              }, {
                id: "return",
                min: 0,
                undefStack: true
              }, null, null, {
                id: "endchar",
                min: 0,
                stackClearing: true
              }, null, null, null, {
                id: "hstemhm",
                min: 2,
                stackClearing: true,
                stem: true
              }, {
                id: "hintmask",
                min: 0,
                stackClearing: true
              }, {
                id: "cntrmask",
                min: 0,
                stackClearing: true
              }, {
                id: "rmoveto",
                min: 2,
                stackClearing: true
              }, {
                id: "hmoveto",
                min: 1,
                stackClearing: true
              }, {
                id: "vstemhm",
                min: 2,
                stackClearing: true,
                stem: true
              }, {
                id: "rcurveline",
                min: 8,
                resetStack: true
              }, {
                id: "rlinecurve",
                min: 8,
                resetStack: true
              }, {
                id: "vvcurveto",
                min: 4,
                resetStack: true
              }, {
                id: "hhcurveto",
                min: 4,
                resetStack: true
              }, null, {
                id: "callgsubr",
                min: 1,
                undefStack: true
              }, {
                id: "vhcurveto",
                min: 4,
                resetStack: true
              }, {
                id: "hvcurveto",
                min: 4,
                resetStack: true
              }];
              const CharstringValidationData12 = [null, null, null, {
                id: "and",
                min: 2,
                stackDelta: -1
              }, {
                id: "or",
                min: 2,
                stackDelta: -1
              }, {
                id: "not",
                min: 1,
                stackDelta: 0
              }, null, null, null, {
                id: "abs",
                min: 1,
                stackDelta: 0
              }, {
                id: "add",
                min: 2,
                stackDelta: -1,
                stackFn(stack, index3) {
                  stack[index3 - 2] = stack[index3 - 2] + stack[index3 - 1];
                }
              }, {
                id: "sub",
                min: 2,
                stackDelta: -1,
                stackFn(stack, index3) {
                  stack[index3 - 2] = stack[index3 - 2] - stack[index3 - 1];
                }
              }, {
                id: "div",
                min: 2,
                stackDelta: -1,
                stackFn(stack, index3) {
                  stack[index3 - 2] = stack[index3 - 2] / stack[index3 - 1];
                }
              }, null, {
                id: "neg",
                min: 1,
                stackDelta: 0,
                stackFn(stack, index3) {
                  stack[index3 - 1] = -stack[index3 - 1];
                }
              }, {
                id: "eq",
                min: 2,
                stackDelta: -1
              }, null, null, {
                id: "drop",
                min: 1,
                stackDelta: -1
              }, null, {
                id: "put",
                min: 2,
                stackDelta: -2
              }, {
                id: "get",
                min: 1,
                stackDelta: 0
              }, {
                id: "ifelse",
                min: 4,
                stackDelta: -3
              }, {
                id: "random",
                min: 0,
                stackDelta: 1
              }, {
                id: "mul",
                min: 2,
                stackDelta: -1,
                stackFn(stack, index3) {
                  stack[index3 - 2] = stack[index3 - 2] * stack[index3 - 1];
                }
              }, null, {
                id: "sqrt",
                min: 1,
                stackDelta: 0
              }, {
                id: "dup",
                min: 1,
                stackDelta: 1
              }, {
                id: "exch",
                min: 2,
                stackDelta: 0
              }, {
                id: "index",
                min: 2,
                stackDelta: 0
              }, {
                id: "roll",
                min: 3,
                stackDelta: -2
              }, null, null, null, {
                id: "hflex",
                min: 7,
                resetStack: true
              }, {
                id: "flex",
                min: 13,
                resetStack: true
              }, {
                id: "hflex1",
                min: 9,
                resetStack: true
              }, {
                id: "flex1",
                min: 11,
                resetStack: true
              }];
              class CFFParser {
                constructor(file, properties2, seacAnalysisEnabled) {
                  this.bytes = file.getBytes();
                  this.properties = properties2;
                  this.seacAnalysisEnabled = !!seacAnalysisEnabled;
                }
                parse() {
                  const properties2 = this.properties;
                  const cff = new CFF();
                  this.cff = cff;
                  const header = this.parseHeader();
                  const nameIndex = this.parseIndex(header.endPos);
                  const topDictIndex = this.parseIndex(nameIndex.endPos);
                  const stringIndex = this.parseIndex(topDictIndex.endPos);
                  const globalSubrIndex = this.parseIndex(stringIndex.endPos);
                  const topDictParsed = this.parseDict(topDictIndex.obj.get(0));
                  const topDict = this.createDict(CFFTopDict, topDictParsed, cff.strings);
                  cff.header = header.obj;
                  cff.names = this.parseNameIndex(nameIndex.obj);
                  cff.strings = this.parseStringIndex(stringIndex.obj);
                  cff.topDict = topDict;
                  cff.globalSubrIndex = globalSubrIndex.obj;
                  this.parsePrivateDict(cff.topDict);
                  cff.isCIDFont = topDict.hasName("ROS");
                  const charStringOffset = topDict.getByName("CharStrings");
                  const charStringIndex = this.parseIndex(charStringOffset).obj;
                  const fontMatrix = topDict.getByName("FontMatrix");
                  if (fontMatrix) {
                    properties2.fontMatrix = fontMatrix;
                  }
                  const fontBBox = topDict.getByName("FontBBox");
                  if (fontBBox) {
                    properties2.ascent = Math.max(fontBBox[3], fontBBox[1]);
                    properties2.descent = Math.min(fontBBox[1], fontBBox[3]);
                    properties2.ascentScaled = true;
                  }
                  let charset, encoding;
                  if (cff.isCIDFont) {
                    const fdArrayIndex = this.parseIndex(topDict.getByName("FDArray")).obj;
                    for (let i = 0, ii = fdArrayIndex.count; i < ii; ++i) {
                      const dictRaw = fdArrayIndex.get(i);
                      const fontDict = this.createDict(CFFTopDict, this.parseDict(dictRaw), cff.strings);
                      this.parsePrivateDict(fontDict);
                      cff.fdArray.push(fontDict);
                    }
                    encoding = null;
                    charset = this.parseCharsets(topDict.getByName("charset"), charStringIndex.count, cff.strings, true);
                    cff.fdSelect = this.parseFDSelect(topDict.getByName("FDSelect"), charStringIndex.count);
                  } else {
                    charset = this.parseCharsets(topDict.getByName("charset"), charStringIndex.count, cff.strings, false);
                    encoding = this.parseEncoding(topDict.getByName("Encoding"), properties2, cff.strings, charset.charset);
                  }
                  cff.charset = charset;
                  cff.encoding = encoding;
                  const charStringsAndSeacs = this.parseCharStrings({
                    charStrings: charStringIndex,
                    localSubrIndex: topDict.privateDict.subrsIndex,
                    globalSubrIndex: globalSubrIndex.obj,
                    fdSelect: cff.fdSelect,
                    fdArray: cff.fdArray,
                    privateDict: topDict.privateDict
                  });
                  cff.charStrings = charStringsAndSeacs.charStrings;
                  cff.seacs = charStringsAndSeacs.seacs;
                  cff.widths = charStringsAndSeacs.widths;
                  return cff;
                }
                parseHeader() {
                  let bytes = this.bytes;
                  const bytesLength = bytes.length;
                  let offset4 = 0;
                  while (offset4 < bytesLength && bytes[offset4] !== 1) {
                    ++offset4;
                  }
                  if (offset4 >= bytesLength) {
                    throw new _util2.FormatError("Invalid CFF header");
                  }
                  if (offset4 !== 0) {
                    (0, _util2.info)("cff data is shifted");
                    bytes = bytes.subarray(offset4);
                    this.bytes = bytes;
                  }
                  const major = bytes[0];
                  const minor = bytes[1];
                  const hdrSize = bytes[2];
                  const offSize = bytes[3];
                  const header = new CFFHeader(major, minor, hdrSize, offSize);
                  return {
                    obj: header,
                    endPos: hdrSize
                  };
                }
                parseDict(dict) {
                  let pos = 0;
                  function parseOperand() {
                    let value = dict[pos++];
                    if (value === 30) {
                      return parseFloatOperand();
                    } else if (value === 28) {
                      value = dict[pos++];
                      value = (value << 24 | dict[pos++] << 16) >> 16;
                      return value;
                    } else if (value === 29) {
                      value = dict[pos++];
                      value = value << 8 | dict[pos++];
                      value = value << 8 | dict[pos++];
                      value = value << 8 | dict[pos++];
                      return value;
                    } else if (value >= 32 && value <= 246) {
                      return value - 139;
                    } else if (value >= 247 && value <= 250) {
                      return (value - 247) * 256 + dict[pos++] + 108;
                    } else if (value >= 251 && value <= 254) {
                      return -((value - 251) * 256) - dict[pos++] - 108;
                    }
                    (0, _util2.warn)('CFFParser_parseDict: "' + value + '" is a reserved command.');
                    return NaN;
                  }
                  function parseFloatOperand() {
                    let str = "";
                    const eof = 15;
                    const lookup = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", ".", "E", "E-", null, "-"];
                    const length2 = dict.length;
                    while (pos < length2) {
                      const b = dict[pos++];
                      const b1 = b >> 4;
                      const b2 = b & 15;
                      if (b1 === eof) {
                        break;
                      }
                      str += lookup[b1];
                      if (b2 === eof) {
                        break;
                      }
                      str += lookup[b2];
                    }
                    return parseFloat(str);
                  }
                  let operands = [];
                  const entries = [];
                  pos = 0;
                  const end = dict.length;
                  while (pos < end) {
                    let b = dict[pos];
                    if (b <= 21) {
                      if (b === 12) {
                        b = b << 8 | dict[++pos];
                      }
                      entries.push([b, operands]);
                      operands = [];
                      ++pos;
                    } else {
                      operands.push(parseOperand());
                    }
                  }
                  return entries;
                }
                parseIndex(pos) {
                  const cffIndex = new CFFIndex();
                  const bytes = this.bytes;
                  const count = bytes[pos++] << 8 | bytes[pos++];
                  const offsets = [];
                  let end = pos;
                  let i, ii;
                  if (count !== 0) {
                    const offsetSize = bytes[pos++];
                    const startPos = pos + (count + 1) * offsetSize - 1;
                    for (i = 0, ii = count + 1; i < ii; ++i) {
                      let offset4 = 0;
                      for (let j = 0; j < offsetSize; ++j) {
                        offset4 <<= 8;
                        offset4 += bytes[pos++];
                      }
                      offsets.push(startPos + offset4);
                    }
                    end = offsets[count];
                  }
                  for (i = 0, ii = offsets.length - 1; i < ii; ++i) {
                    const offsetStart = offsets[i];
                    const offsetEnd = offsets[i + 1];
                    cffIndex.add(bytes.subarray(offsetStart, offsetEnd));
                  }
                  return {
                    obj: cffIndex,
                    endPos: end
                  };
                }
                parseNameIndex(index3) {
                  const names2 = [];
                  for (let i = 0, ii = index3.count; i < ii; ++i) {
                    const name = index3.get(i);
                    names2.push((0, _util2.bytesToString)(name));
                  }
                  return names2;
                }
                parseStringIndex(index3) {
                  const strings = new CFFStrings();
                  for (let i = 0, ii = index3.count; i < ii; ++i) {
                    const data2 = index3.get(i);
                    strings.add((0, _util2.bytesToString)(data2));
                  }
                  return strings;
                }
                createDict(Type, dict, strings) {
                  const cffDict = new Type(strings);
                  for (const [key2, value] of dict) {
                    cffDict.setByKey(key2, value);
                  }
                  return cffDict;
                }
                parseCharString(state, data2, localSubrIndex, globalSubrIndex) {
                  if (!data2 || state.callDepth > MAX_SUBR_NESTING) {
                    return false;
                  }
                  let stackSize = state.stackSize;
                  const stack = state.stack;
                  let length2 = data2.length;
                  for (let j = 0; j < length2; ) {
                    const value = data2[j++];
                    let validationCommand = null;
                    if (value === 12) {
                      const q = data2[j++];
                      if (q === 0) {
                        data2[j - 2] = 139;
                        data2[j - 1] = 22;
                        stackSize = 0;
                      } else {
                        validationCommand = CharstringValidationData12[q];
                      }
                    } else if (value === 28) {
                      stack[stackSize] = (data2[j] << 24 | data2[j + 1] << 16) >> 16;
                      j += 2;
                      stackSize++;
                    } else if (value === 14) {
                      if (stackSize >= 4) {
                        stackSize -= 4;
                        if (this.seacAnalysisEnabled) {
                          state.seac = stack.slice(stackSize, stackSize + 4);
                          return false;
                        }
                      }
                      validationCommand = CharstringValidationData[value];
                    } else if (value >= 32 && value <= 246) {
                      stack[stackSize] = value - 139;
                      stackSize++;
                    } else if (value >= 247 && value <= 254) {
                      stack[stackSize] = value < 251 ? (value - 247 << 8) + data2[j] + 108 : -(value - 251 << 8) - data2[j] - 108;
                      j++;
                      stackSize++;
                    } else if (value === 255) {
                      stack[stackSize] = (data2[j] << 24 | data2[j + 1] << 16 | data2[j + 2] << 8 | data2[j + 3]) / 65536;
                      j += 4;
                      stackSize++;
                    } else if (value === 19 || value === 20) {
                      state.hints += stackSize >> 1;
                      if (state.hints === 0) {
                        data2.copyWithin(j - 1, j, -1);
                        j -= 1;
                        length2 -= 1;
                        continue;
                      }
                      j += state.hints + 7 >> 3;
                      stackSize %= 2;
                      validationCommand = CharstringValidationData[value];
                    } else if (value === 10 || value === 29) {
                      const subrsIndex = value === 10 ? localSubrIndex : globalSubrIndex;
                      if (!subrsIndex) {
                        validationCommand = CharstringValidationData[value];
                        (0, _util2.warn)("Missing subrsIndex for " + validationCommand.id);
                        return false;
                      }
                      let bias = 32768;
                      if (subrsIndex.count < 1240) {
                        bias = 107;
                      } else if (subrsIndex.count < 33900) {
                        bias = 1131;
                      }
                      const subrNumber = stack[--stackSize] + bias;
                      if (subrNumber < 0 || subrNumber >= subrsIndex.count || isNaN(subrNumber)) {
                        validationCommand = CharstringValidationData[value];
                        (0, _util2.warn)("Out of bounds subrIndex for " + validationCommand.id);
                        return false;
                      }
                      state.stackSize = stackSize;
                      state.callDepth++;
                      const valid = this.parseCharString(state, subrsIndex.get(subrNumber), localSubrIndex, globalSubrIndex);
                      if (!valid) {
                        return false;
                      }
                      state.callDepth--;
                      stackSize = state.stackSize;
                      continue;
                    } else if (value === 11) {
                      state.stackSize = stackSize;
                      return true;
                    } else if (value === 0 && j === data2.length) {
                      data2[j - 1] = 14;
                      validationCommand = CharstringValidationData[14];
                    } else if (value === 9) {
                      data2.copyWithin(j - 1, j, -1);
                      j -= 1;
                      length2 -= 1;
                      continue;
                    } else {
                      validationCommand = CharstringValidationData[value];
                    }
                    if (validationCommand) {
                      if (validationCommand.stem) {
                        state.hints += stackSize >> 1;
                        if (value === 3 || value === 23) {
                          state.hasVStems = true;
                        } else if (state.hasVStems && (value === 1 || value === 18)) {
                          (0, _util2.warn)("CFF stem hints are in wrong order");
                          data2[j - 1] = value === 1 ? 3 : 23;
                        }
                      }
                      if ("min" in validationCommand) {
                        if (!state.undefStack && stackSize < validationCommand.min) {
                          (0, _util2.warn)("Not enough parameters for " + validationCommand.id + "; actual: " + stackSize + ", expected: " + validationCommand.min);
                          if (stackSize === 0) {
                            data2[j - 1] = 14;
                            return true;
                          }
                          return false;
                        }
                      }
                      if (state.firstStackClearing && validationCommand.stackClearing) {
                        state.firstStackClearing = false;
                        stackSize -= validationCommand.min;
                        if (stackSize >= 2 && validationCommand.stem) {
                          stackSize %= 2;
                        } else if (stackSize > 1) {
                          (0, _util2.warn)("Found too many parameters for stack-clearing command");
                        }
                        if (stackSize > 0) {
                          state.width = stack[stackSize - 1];
                        }
                      }
                      if ("stackDelta" in validationCommand) {
                        if ("stackFn" in validationCommand) {
                          validationCommand.stackFn(stack, stackSize);
                        }
                        stackSize += validationCommand.stackDelta;
                      } else if (validationCommand.stackClearing) {
                        stackSize = 0;
                      } else if (validationCommand.resetStack) {
                        stackSize = 0;
                        state.undefStack = false;
                      } else if (validationCommand.undefStack) {
                        stackSize = 0;
                        state.undefStack = true;
                        state.firstStackClearing = false;
                      }
                    }
                  }
                  if (length2 < data2.length) {
                    data2.fill(14, length2);
                  }
                  state.stackSize = stackSize;
                  return true;
                }
                parseCharStrings({
                  charStrings,
                  localSubrIndex,
                  globalSubrIndex,
                  fdSelect,
                  fdArray,
                  privateDict
                }) {
                  const seacs = [];
                  const widths = [];
                  const count = charStrings.count;
                  for (let i = 0; i < count; i++) {
                    const charstring = charStrings.get(i);
                    const state = {
                      callDepth: 0,
                      stackSize: 0,
                      stack: [],
                      undefStack: true,
                      hints: 0,
                      firstStackClearing: true,
                      seac: null,
                      width: null,
                      hasVStems: false
                    };
                    let valid = true;
                    let localSubrToUse = null;
                    let privateDictToUse = privateDict;
                    if (fdSelect && fdArray.length) {
                      const fdIndex = fdSelect.getFDIndex(i);
                      if (fdIndex === -1) {
                        (0, _util2.warn)("Glyph index is not in fd select.");
                        valid = false;
                      }
                      if (fdIndex >= fdArray.length) {
                        (0, _util2.warn)("Invalid fd index for glyph index.");
                        valid = false;
                      }
                      if (valid) {
                        privateDictToUse = fdArray[fdIndex].privateDict;
                        localSubrToUse = privateDictToUse.subrsIndex;
                      }
                    } else if (localSubrIndex) {
                      localSubrToUse = localSubrIndex;
                    }
                    if (valid) {
                      valid = this.parseCharString(state, charstring, localSubrToUse, globalSubrIndex);
                    }
                    if (state.width !== null) {
                      const nominalWidth = privateDictToUse.getByName("nominalWidthX");
                      widths[i] = nominalWidth + state.width;
                    } else {
                      const defaultWidth = privateDictToUse.getByName("defaultWidthX");
                      widths[i] = defaultWidth;
                    }
                    if (state.seac !== null) {
                      seacs[i] = state.seac;
                    }
                    if (!valid) {
                      charStrings.set(i, new Uint8Array([14]));
                    }
                  }
                  return {
                    charStrings,
                    seacs,
                    widths
                  };
                }
                emptyPrivateDictionary(parentDict) {
                  const privateDict = this.createDict(CFFPrivateDict, [], parentDict.strings);
                  parentDict.setByKey(18, [0, 0]);
                  parentDict.privateDict = privateDict;
                }
                parsePrivateDict(parentDict) {
                  if (!parentDict.hasName("Private")) {
                    this.emptyPrivateDictionary(parentDict);
                    return;
                  }
                  const privateOffset = parentDict.getByName("Private");
                  if (!Array.isArray(privateOffset) || privateOffset.length !== 2) {
                    parentDict.removeByName("Private");
                    return;
                  }
                  const size = privateOffset[0];
                  const offset4 = privateOffset[1];
                  if (size === 0 || offset4 >= this.bytes.length) {
                    this.emptyPrivateDictionary(parentDict);
                    return;
                  }
                  const privateDictEnd = offset4 + size;
                  const dictData = this.bytes.subarray(offset4, privateDictEnd);
                  const dict = this.parseDict(dictData);
                  const privateDict = this.createDict(CFFPrivateDict, dict, parentDict.strings);
                  parentDict.privateDict = privateDict;
                  if (privateDict.getByName("ExpansionFactor") === 0) {
                    privateDict.setByName("ExpansionFactor", 0.06);
                  }
                  if (!privateDict.getByName("Subrs")) {
                    return;
                  }
                  const subrsOffset = privateDict.getByName("Subrs");
                  const relativeOffset = offset4 + subrsOffset;
                  if (subrsOffset === 0 || relativeOffset >= this.bytes.length) {
                    this.emptyPrivateDictionary(parentDict);
                    return;
                  }
                  const subrsIndex = this.parseIndex(relativeOffset);
                  privateDict.subrsIndex = subrsIndex.obj;
                }
                parseCharsets(pos, length2, strings, cid) {
                  if (pos === 0) {
                    return new CFFCharset(true, CFFCharsetPredefinedTypes.ISO_ADOBE, _charsets.ISOAdobeCharset);
                  } else if (pos === 1) {
                    return new CFFCharset(true, CFFCharsetPredefinedTypes.EXPERT, _charsets.ExpertCharset);
                  } else if (pos === 2) {
                    return new CFFCharset(true, CFFCharsetPredefinedTypes.EXPERT_SUBSET, _charsets.ExpertSubsetCharset);
                  }
                  const bytes = this.bytes;
                  const start = pos;
                  const format3 = bytes[pos++];
                  const charset = [cid ? 0 : ".notdef"];
                  let id, count, i;
                  length2 -= 1;
                  switch (format3) {
                    case 0:
                      for (i = 0; i < length2; i++) {
                        id = bytes[pos++] << 8 | bytes[pos++];
                        charset.push(cid ? id : strings.get(id));
                      }
                      break;
                    case 1:
                      while (charset.length <= length2) {
                        id = bytes[pos++] << 8 | bytes[pos++];
                        count = bytes[pos++];
                        for (i = 0; i <= count; i++) {
                          charset.push(cid ? id++ : strings.get(id++));
                        }
                      }
                      break;
                    case 2:
                      while (charset.length <= length2) {
                        id = bytes[pos++] << 8 | bytes[pos++];
                        count = bytes[pos++] << 8 | bytes[pos++];
                        for (i = 0; i <= count; i++) {
                          charset.push(cid ? id++ : strings.get(id++));
                        }
                      }
                      break;
                    default:
                      throw new _util2.FormatError("Unknown charset format");
                  }
                  const end = pos;
                  const raw = bytes.subarray(start, end);
                  return new CFFCharset(false, format3, charset, raw);
                }
                parseEncoding(pos, properties2, strings, charset) {
                  const encoding = /* @__PURE__ */ Object.create(null);
                  const bytes = this.bytes;
                  let predefined = false;
                  let format3, i, ii;
                  let raw = null;
                  function readSupplement() {
                    const supplementsCount = bytes[pos++];
                    for (i = 0; i < supplementsCount; i++) {
                      const code2 = bytes[pos++];
                      const sid = (bytes[pos++] << 8) + (bytes[pos++] & 255);
                      encoding[code2] = charset.indexOf(strings.get(sid));
                    }
                  }
                  if (pos === 0 || pos === 1) {
                    predefined = true;
                    format3 = pos;
                    const baseEncoding = pos ? _encodings.ExpertEncoding : _encodings.StandardEncoding;
                    for (i = 0, ii = charset.length; i < ii; i++) {
                      const index3 = baseEncoding.indexOf(charset[i]);
                      if (index3 !== -1) {
                        encoding[index3] = i;
                      }
                    }
                  } else {
                    const dataStart = pos;
                    format3 = bytes[pos++];
                    switch (format3 & 127) {
                      case 0:
                        const glyphsCount = bytes[pos++];
                        for (i = 1; i <= glyphsCount; i++) {
                          encoding[bytes[pos++]] = i;
                        }
                        break;
                      case 1:
                        const rangesCount = bytes[pos++];
                        let gid = 1;
                        for (i = 0; i < rangesCount; i++) {
                          const start = bytes[pos++];
                          const left2 = bytes[pos++];
                          for (let j = start; j <= start + left2; j++) {
                            encoding[j] = gid++;
                          }
                        }
                        break;
                      default:
                        throw new _util2.FormatError(`Unknown encoding format: ${format3} in CFF`);
                    }
                    const dataEnd = pos;
                    if (format3 & 128) {
                      bytes[dataStart] &= 127;
                      readSupplement();
                    }
                    raw = bytes.subarray(dataStart, dataEnd);
                  }
                  format3 &= 127;
                  return new CFFEncoding(predefined, format3, encoding, raw);
                }
                parseFDSelect(pos, length2) {
                  const bytes = this.bytes;
                  const format3 = bytes[pos++];
                  const fdSelect = [];
                  let i;
                  switch (format3) {
                    case 0:
                      for (i = 0; i < length2; ++i) {
                        const id = bytes[pos++];
                        fdSelect.push(id);
                      }
                      break;
                    case 3:
                      const rangesCount = bytes[pos++] << 8 | bytes[pos++];
                      for (i = 0; i < rangesCount; ++i) {
                        let first = bytes[pos++] << 8 | bytes[pos++];
                        if (i === 0 && first !== 0) {
                          (0, _util2.warn)("parseFDSelect: The first range must have a first GID of 0 -- trying to recover.");
                          first = 0;
                        }
                        const fdIndex = bytes[pos++];
                        const next2 = bytes[pos] << 8 | bytes[pos + 1];
                        for (let j = first; j < next2; ++j) {
                          fdSelect.push(fdIndex);
                        }
                      }
                      pos += 2;
                      break;
                    default:
                      throw new _util2.FormatError(`parseFDSelect: Unknown format "${format3}".`);
                  }
                  if (fdSelect.length !== length2) {
                    throw new _util2.FormatError("parseFDSelect: Invalid font data.");
                  }
                  return new CFFFDSelect(format3, fdSelect);
                }
              }
              exports3.CFFParser = CFFParser;
              class CFF {
                constructor() {
                  this.header = null;
                  this.names = [];
                  this.topDict = null;
                  this.strings = new CFFStrings();
                  this.globalSubrIndex = null;
                  this.encoding = null;
                  this.charset = null;
                  this.charStrings = null;
                  this.fdArray = [];
                  this.fdSelect = null;
                  this.isCIDFont = false;
                }
                duplicateFirstGlyph() {
                  if (this.charStrings.count >= 65535) {
                    (0, _util2.warn)("Not enough space in charstrings to duplicate first glyph.");
                    return;
                  }
                  const glyphZero = this.charStrings.get(0);
                  this.charStrings.add(glyphZero);
                  if (this.isCIDFont) {
                    this.fdSelect.fdSelect.push(this.fdSelect.fdSelect[0]);
                  }
                }
                hasGlyphId(id) {
                  if (id < 0 || id >= this.charStrings.count) {
                    return false;
                  }
                  const glyph = this.charStrings.get(id);
                  return glyph.length > 0;
                }
              }
              exports3.CFF = CFF;
              class CFFHeader {
                constructor(major, minor, hdrSize, offSize) {
                  this.major = major;
                  this.minor = minor;
                  this.hdrSize = hdrSize;
                  this.offSize = offSize;
                }
              }
              exports3.CFFHeader = CFFHeader;
              class CFFStrings {
                constructor() {
                  this.strings = [];
                }
                get(index3) {
                  if (index3 >= 0 && index3 <= NUM_STANDARD_CFF_STRINGS - 1) {
                    return CFFStandardStrings[index3];
                  }
                  if (index3 - NUM_STANDARD_CFF_STRINGS <= this.strings.length) {
                    return this.strings[index3 - NUM_STANDARD_CFF_STRINGS];
                  }
                  return CFFStandardStrings[0];
                }
                getSID(str) {
                  let index3 = CFFStandardStrings.indexOf(str);
                  if (index3 !== -1) {
                    return index3;
                  }
                  index3 = this.strings.indexOf(str);
                  if (index3 !== -1) {
                    return index3 + NUM_STANDARD_CFF_STRINGS;
                  }
                  return -1;
                }
                add(value) {
                  this.strings.push(value);
                }
                get count() {
                  return this.strings.length;
                }
              }
              exports3.CFFStrings = CFFStrings;
              class CFFIndex {
                constructor() {
                  this.objects = [];
                  this.length = 0;
                }
                add(data2) {
                  this.length += data2.length;
                  this.objects.push(data2);
                }
                set(index3, data2) {
                  this.length += data2.length - this.objects[index3].length;
                  this.objects[index3] = data2;
                }
                get(index3) {
                  return this.objects[index3];
                }
                get count() {
                  return this.objects.length;
                }
              }
              exports3.CFFIndex = CFFIndex;
              class CFFDict {
                constructor(tables, strings) {
                  this.keyToNameMap = tables.keyToNameMap;
                  this.nameToKeyMap = tables.nameToKeyMap;
                  this.defaults = tables.defaults;
                  this.types = tables.types;
                  this.opcodes = tables.opcodes;
                  this.order = tables.order;
                  this.strings = strings;
                  this.values = /* @__PURE__ */ Object.create(null);
                }
                setByKey(key2, value) {
                  if (!(key2 in this.keyToNameMap)) {
                    return false;
                  }
                  if (value.length === 0) {
                    return true;
                  }
                  for (const val of value) {
                    if (isNaN(val)) {
                      (0, _util2.warn)(`Invalid CFFDict value: "${value}" for key "${key2}".`);
                      return true;
                    }
                  }
                  const type5 = this.types[key2];
                  if (type5 === "num" || type5 === "sid" || type5 === "offset") {
                    value = value[0];
                  }
                  this.values[key2] = value;
                  return true;
                }
                setByName(name, value) {
                  if (!(name in this.nameToKeyMap)) {
                    throw new _util2.FormatError(`Invalid dictionary name "${name}"`);
                  }
                  this.values[this.nameToKeyMap[name]] = value;
                }
                hasName(name) {
                  return this.nameToKeyMap[name] in this.values;
                }
                getByName(name) {
                  if (!(name in this.nameToKeyMap)) {
                    throw new _util2.FormatError(`Invalid dictionary name ${name}"`);
                  }
                  const key2 = this.nameToKeyMap[name];
                  if (!(key2 in this.values)) {
                    return this.defaults[key2];
                  }
                  return this.values[key2];
                }
                removeByName(name) {
                  delete this.values[this.nameToKeyMap[name]];
                }
                static createTables(layout) {
                  const tables = {
                    keyToNameMap: {},
                    nameToKeyMap: {},
                    defaults: {},
                    types: {},
                    opcodes: {},
                    order: []
                  };
                  for (const entry of layout) {
                    const key2 = Array.isArray(entry[0]) ? (entry[0][0] << 8) + entry[0][1] : entry[0];
                    tables.keyToNameMap[key2] = entry[1];
                    tables.nameToKeyMap[entry[1]] = key2;
                    tables.types[key2] = entry[2];
                    tables.defaults[key2] = entry[3];
                    tables.opcodes[key2] = Array.isArray(entry[0]) ? entry[0] : [entry[0]];
                    tables.order.push(key2);
                  }
                  return tables;
                }
              }
              const CFFTopDictLayout = [[[12, 30], "ROS", ["sid", "sid", "num"], null], [[12, 20], "SyntheticBase", "num", null], [0, "version", "sid", null], [1, "Notice", "sid", null], [[12, 0], "Copyright", "sid", null], [2, "FullName", "sid", null], [3, "FamilyName", "sid", null], [4, "Weight", "sid", null], [[12, 1], "isFixedPitch", "num", 0], [[12, 2], "ItalicAngle", "num", 0], [[12, 3], "UnderlinePosition", "num", -100], [[12, 4], "UnderlineThickness", "num", 50], [[12, 5], "PaintType", "num", 0], [[12, 6], "CharstringType", "num", 2], [[12, 7], "FontMatrix", ["num", "num", "num", "num", "num", "num"], [1e-3, 0, 0, 1e-3, 0, 0]], [13, "UniqueID", "num", null], [5, "FontBBox", ["num", "num", "num", "num"], [0, 0, 0, 0]], [[12, 8], "StrokeWidth", "num", 0], [14, "XUID", "array", null], [15, "charset", "offset", 0], [16, "Encoding", "offset", 0], [17, "CharStrings", "offset", 0], [18, "Private", ["offset", "offset"], null], [[12, 21], "PostScript", "sid", null], [[12, 22], "BaseFontName", "sid", null], [[12, 23], "BaseFontBlend", "delta", null], [[12, 31], "CIDFontVersion", "num", 0], [[12, 32], "CIDFontRevision", "num", 0], [[12, 33], "CIDFontType", "num", 0], [[12, 34], "CIDCount", "num", 8720], [[12, 35], "UIDBase", "num", null], [[12, 37], "FDSelect", "offset", null], [[12, 36], "FDArray", "offset", null], [[12, 38], "FontName", "sid", null]];
              class CFFTopDict extends CFFDict {
                static get tables() {
                  return (0, _util2.shadow)(this, "tables", this.createTables(CFFTopDictLayout));
                }
                constructor(strings) {
                  super(CFFTopDict.tables, strings);
                  this.privateDict = null;
                }
              }
              exports3.CFFTopDict = CFFTopDict;
              const CFFPrivateDictLayout = [[6, "BlueValues", "delta", null], [7, "OtherBlues", "delta", null], [8, "FamilyBlues", "delta", null], [9, "FamilyOtherBlues", "delta", null], [[12, 9], "BlueScale", "num", 0.039625], [[12, 10], "BlueShift", "num", 7], [[12, 11], "BlueFuzz", "num", 1], [10, "StdHW", "num", null], [11, "StdVW", "num", null], [[12, 12], "StemSnapH", "delta", null], [[12, 13], "StemSnapV", "delta", null], [[12, 14], "ForceBold", "num", 0], [[12, 17], "LanguageGroup", "num", 0], [[12, 18], "ExpansionFactor", "num", 0.06], [[12, 19], "initialRandomSeed", "num", 0], [20, "defaultWidthX", "num", 0], [21, "nominalWidthX", "num", 0], [19, "Subrs", "offset", null]];
              class CFFPrivateDict extends CFFDict {
                static get tables() {
                  return (0, _util2.shadow)(this, "tables", this.createTables(CFFPrivateDictLayout));
                }
                constructor(strings) {
                  super(CFFPrivateDict.tables, strings);
                  this.subrsIndex = null;
                }
              }
              exports3.CFFPrivateDict = CFFPrivateDict;
              const CFFCharsetPredefinedTypes = {
                ISO_ADOBE: 0,
                EXPERT: 1,
                EXPERT_SUBSET: 2
              };
              class CFFCharset {
                constructor(predefined, format3, charset, raw) {
                  this.predefined = predefined;
                  this.format = format3;
                  this.charset = charset;
                  this.raw = raw;
                }
              }
              exports3.CFFCharset = CFFCharset;
              class CFFEncoding {
                constructor(predefined, format3, encoding, raw) {
                  this.predefined = predefined;
                  this.format = format3;
                  this.encoding = encoding;
                  this.raw = raw;
                }
              }
              class CFFFDSelect {
                constructor(format3, fdSelect) {
                  this.format = format3;
                  this.fdSelect = fdSelect;
                }
                getFDIndex(glyphIndex) {
                  if (glyphIndex < 0 || glyphIndex >= this.fdSelect.length) {
                    return -1;
                  }
                  return this.fdSelect[glyphIndex];
                }
              }
              exports3.CFFFDSelect = CFFFDSelect;
              class CFFOffsetTracker {
                constructor() {
                  this.offsets = /* @__PURE__ */ Object.create(null);
                }
                isTracking(key2) {
                  return key2 in this.offsets;
                }
                track(key2, location2) {
                  if (key2 in this.offsets) {
                    throw new _util2.FormatError(`Already tracking location of ${key2}`);
                  }
                  this.offsets[key2] = location2;
                }
                offset(value) {
                  for (const key2 in this.offsets) {
                    this.offsets[key2] += value;
                  }
                }
                setEntryLocation(key2, values, output) {
                  if (!(key2 in this.offsets)) {
                    throw new _util2.FormatError(`Not tracking location of ${key2}`);
                  }
                  const data2 = output.data;
                  const dataOffset = this.offsets[key2];
                  const size = 5;
                  for (let i = 0, ii = values.length; i < ii; ++i) {
                    const offset0 = i * size + dataOffset;
                    const offset1 = offset0 + 1;
                    const offset22 = offset0 + 2;
                    const offset32 = offset0 + 3;
                    const offset4 = offset0 + 4;
                    if (data2[offset0] !== 29 || data2[offset1] !== 0 || data2[offset22] !== 0 || data2[offset32] !== 0 || data2[offset4] !== 0) {
                      throw new _util2.FormatError("writing to an offset that is not empty");
                    }
                    const value = values[i];
                    data2[offset0] = 29;
                    data2[offset1] = value >> 24 & 255;
                    data2[offset22] = value >> 16 & 255;
                    data2[offset32] = value >> 8 & 255;
                    data2[offset4] = value & 255;
                  }
                }
              }
              class CFFCompiler {
                constructor(cff) {
                  this.cff = cff;
                }
                compile() {
                  const cff = this.cff;
                  const output = {
                    data: [],
                    length: 0,
                    add(data2) {
                      try {
                        this.data.push(...data2);
                      } catch {
                        this.data = this.data.concat(data2);
                      }
                      this.length = this.data.length;
                    }
                  };
                  const header = this.compileHeader(cff.header);
                  output.add(header);
                  const nameIndex = this.compileNameIndex(cff.names);
                  output.add(nameIndex);
                  if (cff.isCIDFont) {
                    if (cff.topDict.hasName("FontMatrix")) {
                      const base = cff.topDict.getByName("FontMatrix");
                      cff.topDict.removeByName("FontMatrix");
                      for (const subDict of cff.fdArray) {
                        let matrix = base.slice(0);
                        if (subDict.hasName("FontMatrix")) {
                          matrix = _util2.Util.transform(matrix, subDict.getByName("FontMatrix"));
                        }
                        subDict.setByName("FontMatrix", matrix);
                      }
                    }
                  }
                  const xuid = cff.topDict.getByName("XUID");
                  if (xuid?.length > 16) {
                    cff.topDict.removeByName("XUID");
                  }
                  cff.topDict.setByName("charset", 0);
                  let compiled = this.compileTopDicts([cff.topDict], output.length, cff.isCIDFont);
                  output.add(compiled.output);
                  const topDictTracker = compiled.trackers[0];
                  const stringIndex = this.compileStringIndex(cff.strings.strings);
                  output.add(stringIndex);
                  const globalSubrIndex = this.compileIndex(cff.globalSubrIndex);
                  output.add(globalSubrIndex);
                  if (cff.encoding && cff.topDict.hasName("Encoding")) {
                    if (cff.encoding.predefined) {
                      topDictTracker.setEntryLocation("Encoding", [cff.encoding.format], output);
                    } else {
                      const encoding = this.compileEncoding(cff.encoding);
                      topDictTracker.setEntryLocation("Encoding", [output.length], output);
                      output.add(encoding);
                    }
                  }
                  const charset = this.compileCharset(cff.charset, cff.charStrings.count, cff.strings, cff.isCIDFont);
                  topDictTracker.setEntryLocation("charset", [output.length], output);
                  output.add(charset);
                  const charStrings = this.compileCharStrings(cff.charStrings);
                  topDictTracker.setEntryLocation("CharStrings", [output.length], output);
                  output.add(charStrings);
                  if (cff.isCIDFont) {
                    topDictTracker.setEntryLocation("FDSelect", [output.length], output);
                    const fdSelect = this.compileFDSelect(cff.fdSelect);
                    output.add(fdSelect);
                    compiled = this.compileTopDicts(cff.fdArray, output.length, true);
                    topDictTracker.setEntryLocation("FDArray", [output.length], output);
                    output.add(compiled.output);
                    const fontDictTrackers = compiled.trackers;
                    this.compilePrivateDicts(cff.fdArray, fontDictTrackers, output);
                  }
                  this.compilePrivateDicts([cff.topDict], [topDictTracker], output);
                  output.add([0]);
                  return output.data;
                }
                encodeNumber(value) {
                  if (Number.isInteger(value)) {
                    return this.encodeInteger(value);
                  }
                  return this.encodeFloat(value);
                }
                static get EncodeFloatRegExp() {
                  return (0, _util2.shadow)(this, "EncodeFloatRegExp", /\.(\d*?)(?:9{5,20}|0{5,20})\d{0,2}(?:e(.+)|$)/);
                }
                encodeFloat(num) {
                  let value = num.toString();
                  const m = CFFCompiler.EncodeFloatRegExp.exec(value);
                  if (m) {
                    const epsilon = parseFloat("1e" + ((m[2] ? +m[2] : 0) + m[1].length));
                    value = (Math.round(num * epsilon) / epsilon).toString();
                  }
                  let nibbles = "";
                  let i, ii;
                  for (i = 0, ii = value.length; i < ii; ++i) {
                    const a = value[i];
                    if (a === "e") {
                      nibbles += value[++i] === "-" ? "c" : "b";
                    } else if (a === ".") {
                      nibbles += "a";
                    } else if (a === "-") {
                      nibbles += "e";
                    } else {
                      nibbles += a;
                    }
                  }
                  nibbles += nibbles.length & 1 ? "f" : "ff";
                  const out = [30];
                  for (i = 0, ii = nibbles.length; i < ii; i += 2) {
                    out.push(parseInt(nibbles.substring(i, i + 2), 16));
                  }
                  return out;
                }
                encodeInteger(value) {
                  let code2;
                  if (value >= -107 && value <= 107) {
                    code2 = [value + 139];
                  } else if (value >= 108 && value <= 1131) {
                    value -= 108;
                    code2 = [(value >> 8) + 247, value & 255];
                  } else if (value >= -1131 && value <= -108) {
                    value = -value - 108;
                    code2 = [(value >> 8) + 251, value & 255];
                  } else if (value >= -32768 && value <= 32767) {
                    code2 = [28, value >> 8 & 255, value & 255];
                  } else {
                    code2 = [29, value >> 24 & 255, value >> 16 & 255, value >> 8 & 255, value & 255];
                  }
                  return code2;
                }
                compileHeader(header) {
                  return [header.major, header.minor, 4, header.offSize];
                }
                compileNameIndex(names2) {
                  const nameIndex = new CFFIndex();
                  for (const name of names2) {
                    const length2 = Math.min(name.length, 127);
                    let sanitizedName = new Array(length2);
                    for (let j = 0; j < length2; j++) {
                      let char2 = name[j];
                      if (char2 < "!" || char2 > "~" || char2 === "[" || char2 === "]" || char2 === "(" || char2 === ")" || char2 === "{" || char2 === "}" || char2 === "<" || char2 === ">" || char2 === "/" || char2 === "%") {
                        char2 = "_";
                      }
                      sanitizedName[j] = char2;
                    }
                    sanitizedName = sanitizedName.join("");
                    if (sanitizedName === "") {
                      sanitizedName = "Bad_Font_Name";
                    }
                    nameIndex.add((0, _util2.stringToBytes)(sanitizedName));
                  }
                  return this.compileIndex(nameIndex);
                }
                compileTopDicts(dicts, length2, removeCidKeys) {
                  const fontDictTrackers = [];
                  let fdArrayIndex = new CFFIndex();
                  for (const fontDict of dicts) {
                    if (removeCidKeys) {
                      fontDict.removeByName("CIDFontVersion");
                      fontDict.removeByName("CIDFontRevision");
                      fontDict.removeByName("CIDFontType");
                      fontDict.removeByName("CIDCount");
                      fontDict.removeByName("UIDBase");
                    }
                    const fontDictTracker = new CFFOffsetTracker();
                    const fontDictData = this.compileDict(fontDict, fontDictTracker);
                    fontDictTrackers.push(fontDictTracker);
                    fdArrayIndex.add(fontDictData);
                    fontDictTracker.offset(length2);
                  }
                  fdArrayIndex = this.compileIndex(fdArrayIndex, fontDictTrackers);
                  return {
                    trackers: fontDictTrackers,
                    output: fdArrayIndex
                  };
                }
                compilePrivateDicts(dicts, trackers, output) {
                  for (let i = 0, ii = dicts.length; i < ii; ++i) {
                    const fontDict = dicts[i];
                    const privateDict = fontDict.privateDict;
                    if (!privateDict || !fontDict.hasName("Private")) {
                      throw new _util2.FormatError("There must be a private dictionary.");
                    }
                    const privateDictTracker = new CFFOffsetTracker();
                    const privateDictData = this.compileDict(privateDict, privateDictTracker);
                    let outputLength = output.length;
                    privateDictTracker.offset(outputLength);
                    if (!privateDictData.length) {
                      outputLength = 0;
                    }
                    trackers[i].setEntryLocation("Private", [privateDictData.length, outputLength], output);
                    output.add(privateDictData);
                    if (privateDict.subrsIndex && privateDict.hasName("Subrs")) {
                      const subrs = this.compileIndex(privateDict.subrsIndex);
                      privateDictTracker.setEntryLocation("Subrs", [privateDictData.length], output);
                      output.add(subrs);
                    }
                  }
                }
                compileDict(dict, offsetTracker) {
                  const out = [];
                  for (const key2 of dict.order) {
                    if (!(key2 in dict.values)) {
                      continue;
                    }
                    let values = dict.values[key2];
                    let types3 = dict.types[key2];
                    if (!Array.isArray(types3)) {
                      types3 = [types3];
                    }
                    if (!Array.isArray(values)) {
                      values = [values];
                    }
                    if (values.length === 0) {
                      continue;
                    }
                    for (let j = 0, jj = types3.length; j < jj; ++j) {
                      const type5 = types3[j];
                      const value = values[j];
                      switch (type5) {
                        case "num":
                        case "sid":
                          out.push(...this.encodeNumber(value));
                          break;
                        case "offset":
                          const name = dict.keyToNameMap[key2];
                          if (!offsetTracker.isTracking(name)) {
                            offsetTracker.track(name, out.length);
                          }
                          out.push(29, 0, 0, 0, 0);
                          break;
                        case "array":
                        case "delta":
                          out.push(...this.encodeNumber(value));
                          for (let k = 1, kk = values.length; k < kk; ++k) {
                            out.push(...this.encodeNumber(values[k]));
                          }
                          break;
                        default:
                          throw new _util2.FormatError(`Unknown data type of ${type5}`);
                      }
                    }
                    out.push(...dict.opcodes[key2]);
                  }
                  return out;
                }
                compileStringIndex(strings) {
                  const stringIndex = new CFFIndex();
                  for (const string3 of strings) {
                    stringIndex.add((0, _util2.stringToBytes)(string3));
                  }
                  return this.compileIndex(stringIndex);
                }
                compileCharStrings(charStrings) {
                  const charStringsIndex = new CFFIndex();
                  for (let i = 0; i < charStrings.count; i++) {
                    const glyph = charStrings.get(i);
                    if (glyph.length === 0) {
                      charStringsIndex.add(new Uint8Array([139, 14]));
                      continue;
                    }
                    charStringsIndex.add(glyph);
                  }
                  return this.compileIndex(charStringsIndex);
                }
                compileCharset(charset, numGlyphs, strings, isCIDFont) {
                  let out;
                  const numGlyphsLessNotDef = numGlyphs - 1;
                  if (isCIDFont) {
                    out = new Uint8Array([2, 0, 0, numGlyphsLessNotDef >> 8 & 255, numGlyphsLessNotDef & 255]);
                  } else {
                    const length2 = 1 + numGlyphsLessNotDef * 2;
                    out = new Uint8Array(length2);
                    out[0] = 0;
                    let charsetIndex = 0;
                    const numCharsets = charset.charset.length;
                    let warned2 = false;
                    for (let i = 1; i < out.length; i += 2) {
                      let sid = 0;
                      if (charsetIndex < numCharsets) {
                        const name = charset.charset[charsetIndex++];
                        sid = strings.getSID(name);
                        if (sid === -1) {
                          sid = 0;
                          if (!warned2) {
                            warned2 = true;
                            (0, _util2.warn)(`Couldn't find ${name} in CFF strings`);
                          }
                        }
                      }
                      out[i] = sid >> 8 & 255;
                      out[i + 1] = sid & 255;
                    }
                  }
                  return this.compileTypedArray(out);
                }
                compileEncoding(encoding) {
                  return this.compileTypedArray(encoding.raw);
                }
                compileFDSelect(fdSelect) {
                  const format3 = fdSelect.format;
                  let out, i;
                  switch (format3) {
                    case 0:
                      out = new Uint8Array(1 + fdSelect.fdSelect.length);
                      out[0] = format3;
                      for (i = 0; i < fdSelect.fdSelect.length; i++) {
                        out[i + 1] = fdSelect.fdSelect[i];
                      }
                      break;
                    case 3:
                      const start = 0;
                      let lastFD = fdSelect.fdSelect[0];
                      const ranges = [format3, 0, 0, start >> 8 & 255, start & 255, lastFD];
                      for (i = 1; i < fdSelect.fdSelect.length; i++) {
                        const currentFD = fdSelect.fdSelect[i];
                        if (currentFD !== lastFD) {
                          ranges.push(i >> 8 & 255, i & 255, currentFD);
                          lastFD = currentFD;
                        }
                      }
                      const numRanges = (ranges.length - 3) / 3;
                      ranges[1] = numRanges >> 8 & 255;
                      ranges[2] = numRanges & 255;
                      ranges.push(i >> 8 & 255, i & 255);
                      out = new Uint8Array(ranges);
                      break;
                  }
                  return this.compileTypedArray(out);
                }
                compileTypedArray(data2) {
                  return Array.from(data2);
                }
                compileIndex(index3, trackers = []) {
                  const objects = index3.objects;
                  const count = objects.length;
                  if (count === 0) {
                    return [0, 0];
                  }
                  const data2 = [count >> 8 & 255, count & 255];
                  let lastOffset = 1, i;
                  for (i = 0; i < count; ++i) {
                    lastOffset += objects[i].length;
                  }
                  let offsetSize;
                  if (lastOffset < 256) {
                    offsetSize = 1;
                  } else if (lastOffset < 65536) {
                    offsetSize = 2;
                  } else if (lastOffset < 16777216) {
                    offsetSize = 3;
                  } else {
                    offsetSize = 4;
                  }
                  data2.push(offsetSize);
                  let relativeOffset = 1;
                  for (i = 0; i < count + 1; i++) {
                    if (offsetSize === 1) {
                      data2.push(relativeOffset & 255);
                    } else if (offsetSize === 2) {
                      data2.push(relativeOffset >> 8 & 255, relativeOffset & 255);
                    } else if (offsetSize === 3) {
                      data2.push(relativeOffset >> 16 & 255, relativeOffset >> 8 & 255, relativeOffset & 255);
                    } else {
                      data2.push(relativeOffset >>> 24 & 255, relativeOffset >> 16 & 255, relativeOffset >> 8 & 255, relativeOffset & 255);
                    }
                    if (objects[i]) {
                      relativeOffset += objects[i].length;
                    }
                  }
                  for (i = 0; i < count; i++) {
                    if (trackers[i]) {
                      trackers[i].offset(data2.length);
                    }
                    data2.push(...objects[i]);
                  }
                  return data2;
                }
              }
              exports3.CFFCompiler = CFFCompiler;
            }),
            /* 36 */
            /***/
            ((__unused_webpack_module2, exports3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.ISOAdobeCharset = exports3.ExpertSubsetCharset = exports3.ExpertCharset = void 0;
              const ISOAdobeCharset = [".notdef", "space", "exclam", "quotedbl", "numbersign", "dollar", "percent", "ampersand", "quoteright", "parenleft", "parenright", "asterisk", "plus", "comma", "hyphen", "period", "slash", "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "colon", "semicolon", "less", "equal", "greater", "question", "at", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "bracketleft", "backslash", "bracketright", "asciicircum", "underscore", "quoteleft", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "braceleft", "bar", "braceright", "asciitilde", "exclamdown", "cent", "sterling", "fraction", "yen", "florin", "section", "currency", "quotesingle", "quotedblleft", "guillemotleft", "guilsinglleft", "guilsinglright", "fi", "fl", "endash", "dagger", "daggerdbl", "periodcentered", "paragraph", "bullet", "quotesinglbase", "quotedblbase", "quotedblright", "guillemotright", "ellipsis", "perthousand", "questiondown", "grave", "acute", "circumflex", "tilde", "macron", "breve", "dotaccent", "dieresis", "ring", "cedilla", "hungarumlaut", "ogonek", "caron", "emdash", "AE", "ordfeminine", "Lslash", "Oslash", "OE", "ordmasculine", "ae", "dotlessi", "lslash", "oslash", "oe", "germandbls", "onesuperior", "logicalnot", "mu", "trademark", "Eth", "onehalf", "plusminus", "Thorn", "onequarter", "divide", "brokenbar", "degree", "thorn", "threequarters", "twosuperior", "registered", "minus", "eth", "multiply", "threesuperior", "copyright", "Aacute", "Acircumflex", "Adieresis", "Agrave", "Aring", "Atilde", "Ccedilla", "Eacute", "Ecircumflex", "Edieresis", "Egrave", "Iacute", "Icircumflex", "Idieresis", "Igrave", "Ntilde", "Oacute", "Ocircumflex", "Odieresis", "Ograve", "Otilde", "Scaron", "Uacute", "Ucircumflex", "Udieresis", "Ugrave", "Yacute", "Ydieresis", "Zcaron", "aacute", "acircumflex", "adieresis", "agrave", "aring", "atilde", "ccedilla", "eacute", "ecircumflex", "edieresis", "egrave", "iacute", "icircumflex", "idieresis", "igrave", "ntilde", "oacute", "ocircumflex", "odieresis", "ograve", "otilde", "scaron", "uacute", "ucircumflex", "udieresis", "ugrave", "yacute", "ydieresis", "zcaron"];
              exports3.ISOAdobeCharset = ISOAdobeCharset;
              const ExpertCharset = [".notdef", "space", "exclamsmall", "Hungarumlautsmall", "dollaroldstyle", "dollarsuperior", "ampersandsmall", "Acutesmall", "parenleftsuperior", "parenrightsuperior", "twodotenleader", "onedotenleader", "comma", "hyphen", "period", "fraction", "zerooldstyle", "oneoldstyle", "twooldstyle", "threeoldstyle", "fouroldstyle", "fiveoldstyle", "sixoldstyle", "sevenoldstyle", "eightoldstyle", "nineoldstyle", "colon", "semicolon", "commasuperior", "threequartersemdash", "periodsuperior", "questionsmall", "asuperior", "bsuperior", "centsuperior", "dsuperior", "esuperior", "isuperior", "lsuperior", "msuperior", "nsuperior", "osuperior", "rsuperior", "ssuperior", "tsuperior", "ff", "fi", "fl", "ffi", "ffl", "parenleftinferior", "parenrightinferior", "Circumflexsmall", "hyphensuperior", "Gravesmall", "Asmall", "Bsmall", "Csmall", "Dsmall", "Esmall", "Fsmall", "Gsmall", "Hsmall", "Ismall", "Jsmall", "Ksmall", "Lsmall", "Msmall", "Nsmall", "Osmall", "Psmall", "Qsmall", "Rsmall", "Ssmall", "Tsmall", "Usmall", "Vsmall", "Wsmall", "Xsmall", "Ysmall", "Zsmall", "colonmonetary", "onefitted", "rupiah", "Tildesmall", "exclamdownsmall", "centoldstyle", "Lslashsmall", "Scaronsmall", "Zcaronsmall", "Dieresissmall", "Brevesmall", "Caronsmall", "Dotaccentsmall", "Macronsmall", "figuredash", "hypheninferior", "Ogoneksmall", "Ringsmall", "Cedillasmall", "onequarter", "onehalf", "threequarters", "questiondownsmall", "oneeighth", "threeeighths", "fiveeighths", "seveneighths", "onethird", "twothirds", "zerosuperior", "onesuperior", "twosuperior", "threesuperior", "foursuperior", "fivesuperior", "sixsuperior", "sevensuperior", "eightsuperior", "ninesuperior", "zeroinferior", "oneinferior", "twoinferior", "threeinferior", "fourinferior", "fiveinferior", "sixinferior", "seveninferior", "eightinferior", "nineinferior", "centinferior", "dollarinferior", "periodinferior", "commainferior", "Agravesmall", "Aacutesmall", "Acircumflexsmall", "Atildesmall", "Adieresissmall", "Aringsmall", "AEsmall", "Ccedillasmall", "Egravesmall", "Eacutesmall", "Ecircumflexsmall", "Edieresissmall", "Igravesmall", "Iacutesmall", "Icircumflexsmall", "Idieresissmall", "Ethsmall", "Ntildesmall", "Ogravesmall", "Oacutesmall", "Ocircumflexsmall", "Otildesmall", "Odieresissmall", "OEsmall", "Oslashsmall", "Ugravesmall", "Uacutesmall", "Ucircumflexsmall", "Udieresissmall", "Yacutesmall", "Thornsmall", "Ydieresissmall"];
              exports3.ExpertCharset = ExpertCharset;
              const ExpertSubsetCharset = [".notdef", "space", "dollaroldstyle", "dollarsuperior", "parenleftsuperior", "parenrightsuperior", "twodotenleader", "onedotenleader", "comma", "hyphen", "period", "fraction", "zerooldstyle", "oneoldstyle", "twooldstyle", "threeoldstyle", "fouroldstyle", "fiveoldstyle", "sixoldstyle", "sevenoldstyle", "eightoldstyle", "nineoldstyle", "colon", "semicolon", "commasuperior", "threequartersemdash", "periodsuperior", "asuperior", "bsuperior", "centsuperior", "dsuperior", "esuperior", "isuperior", "lsuperior", "msuperior", "nsuperior", "osuperior", "rsuperior", "ssuperior", "tsuperior", "ff", "fi", "fl", "ffi", "ffl", "parenleftinferior", "parenrightinferior", "hyphensuperior", "colonmonetary", "onefitted", "rupiah", "centoldstyle", "figuredash", "hypheninferior", "onequarter", "onehalf", "threequarters", "oneeighth", "threeeighths", "fiveeighths", "seveneighths", "onethird", "twothirds", "zerosuperior", "onesuperior", "twosuperior", "threesuperior", "foursuperior", "fivesuperior", "sixsuperior", "sevensuperior", "eightsuperior", "ninesuperior", "zeroinferior", "oneinferior", "twoinferior", "threeinferior", "fourinferior", "fiveinferior", "sixinferior", "seveninferior", "eightinferior", "nineinferior", "centinferior", "dollarinferior", "periodinferior", "commainferior"];
              exports3.ExpertSubsetCharset = ExpertSubsetCharset;
            }),
            /* 37 */
            /***/
            ((__unused_webpack_module2, exports3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.ZapfDingbatsEncoding = exports3.WinAnsiEncoding = exports3.SymbolSetEncoding = exports3.StandardEncoding = exports3.MacRomanEncoding = exports3.ExpertEncoding = void 0;
              exports3.getEncoding = getEncoding;
              const ExpertEncoding = ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "space", "exclamsmall", "Hungarumlautsmall", "", "dollaroldstyle", "dollarsuperior", "ampersandsmall", "Acutesmall", "parenleftsuperior", "parenrightsuperior", "twodotenleader", "onedotenleader", "comma", "hyphen", "period", "fraction", "zerooldstyle", "oneoldstyle", "twooldstyle", "threeoldstyle", "fouroldstyle", "fiveoldstyle", "sixoldstyle", "sevenoldstyle", "eightoldstyle", "nineoldstyle", "colon", "semicolon", "commasuperior", "threequartersemdash", "periodsuperior", "questionsmall", "", "asuperior", "bsuperior", "centsuperior", "dsuperior", "esuperior", "", "", "", "isuperior", "", "", "lsuperior", "msuperior", "nsuperior", "osuperior", "", "", "rsuperior", "ssuperior", "tsuperior", "", "ff", "fi", "fl", "ffi", "ffl", "parenleftinferior", "", "parenrightinferior", "Circumflexsmall", "hyphensuperior", "Gravesmall", "Asmall", "Bsmall", "Csmall", "Dsmall", "Esmall", "Fsmall", "Gsmall", "Hsmall", "Ismall", "Jsmall", "Ksmall", "Lsmall", "Msmall", "Nsmall", "Osmall", "Psmall", "Qsmall", "Rsmall", "Ssmall", "Tsmall", "Usmall", "Vsmall", "Wsmall", "Xsmall", "Ysmall", "Zsmall", "colonmonetary", "onefitted", "rupiah", "Tildesmall", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "exclamdownsmall", "centoldstyle", "Lslashsmall", "", "", "Scaronsmall", "Zcaronsmall", "Dieresissmall", "Brevesmall", "Caronsmall", "", "Dotaccentsmall", "", "", "Macronsmall", "", "", "figuredash", "hypheninferior", "", "", "Ogoneksmall", "Ringsmall", "Cedillasmall", "", "", "", "onequarter", "onehalf", "threequarters", "questiondownsmall", "oneeighth", "threeeighths", "fiveeighths", "seveneighths", "onethird", "twothirds", "", "", "zerosuperior", "onesuperior", "twosuperior", "threesuperior", "foursuperior", "fivesuperior", "sixsuperior", "sevensuperior", "eightsuperior", "ninesuperior", "zeroinferior", "oneinferior", "twoinferior", "threeinferior", "fourinferior", "fiveinferior", "sixinferior", "seveninferior", "eightinferior", "nineinferior", "centinferior", "dollarinferior", "periodinferior", "commainferior", "Agravesmall", "Aacutesmall", "Acircumflexsmall", "Atildesmall", "Adieresissmall", "Aringsmall", "AEsmall", "Ccedillasmall", "Egravesmall", "Eacutesmall", "Ecircumflexsmall", "Edieresissmall", "Igravesmall", "Iacutesmall", "Icircumflexsmall", "Idieresissmall", "Ethsmall", "Ntildesmall", "Ogravesmall", "Oacutesmall", "Ocircumflexsmall", "Otildesmall", "Odieresissmall", "OEsmall", "Oslashsmall", "Ugravesmall", "Uacutesmall", "Ucircumflexsmall", "Udieresissmall", "Yacutesmall", "Thornsmall", "Ydieresissmall"];
              exports3.ExpertEncoding = ExpertEncoding;
              const MacExpertEncoding = ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "space", "exclamsmall", "Hungarumlautsmall", "centoldstyle", "dollaroldstyle", "dollarsuperior", "ampersandsmall", "Acutesmall", "parenleftsuperior", "parenrightsuperior", "twodotenleader", "onedotenleader", "comma", "hyphen", "period", "fraction", "zerooldstyle", "oneoldstyle", "twooldstyle", "threeoldstyle", "fouroldstyle", "fiveoldstyle", "sixoldstyle", "sevenoldstyle", "eightoldstyle", "nineoldstyle", "colon", "semicolon", "", "threequartersemdash", "", "questionsmall", "", "", "", "", "Ethsmall", "", "", "onequarter", "onehalf", "threequarters", "oneeighth", "threeeighths", "fiveeighths", "seveneighths", "onethird", "twothirds", "", "", "", "", "", "", "ff", "fi", "fl", "ffi", "ffl", "parenleftinferior", "", "parenrightinferior", "Circumflexsmall", "hypheninferior", "Gravesmall", "Asmall", "Bsmall", "Csmall", "Dsmall", "Esmall", "Fsmall", "Gsmall", "Hsmall", "Ismall", "Jsmall", "Ksmall", "Lsmall", "Msmall", "Nsmall", "Osmall", "Psmall", "Qsmall", "Rsmall", "Ssmall", "Tsmall", "Usmall", "Vsmall", "Wsmall", "Xsmall", "Ysmall", "Zsmall", "colonmonetary", "onefitted", "rupiah", "Tildesmall", "", "", "asuperior", "centsuperior", "", "", "", "", "Aacutesmall", "Agravesmall", "Acircumflexsmall", "Adieresissmall", "Atildesmall", "Aringsmall", "Ccedillasmall", "Eacutesmall", "Egravesmall", "Ecircumflexsmall", "Edieresissmall", "Iacutesmall", "Igravesmall", "Icircumflexsmall", "Idieresissmall", "Ntildesmall", "Oacutesmall", "Ogravesmall", "Ocircumflexsmall", "Odieresissmall", "Otildesmall", "Uacutesmall", "Ugravesmall", "Ucircumflexsmall", "Udieresissmall", "", "eightsuperior", "fourinferior", "threeinferior", "sixinferior", "eightinferior", "seveninferior", "Scaronsmall", "", "centinferior", "twoinferior", "", "Dieresissmall", "", "Caronsmall", "osuperior", "fiveinferior", "", "commainferior", "periodinferior", "Yacutesmall", "", "dollarinferior", "", "", "Thornsmall", "", "nineinferior", "zeroinferior", "Zcaronsmall", "AEsmall", "Oslashsmall", "questiondownsmall", "oneinferior", "Lslashsmall", "", "", "", "", "", "", "Cedillasmall", "", "", "", "", "", "OEsmall", "figuredash", "hyphensuperior", "", "", "", "", "exclamdownsmall", "", "Ydieresissmall", "", "onesuperior", "twosuperior", "threesuperior", "foursuperior", "fivesuperior", "sixsuperior", "sevensuperior", "ninesuperior", "zerosuperior", "", "esuperior", "rsuperior", "tsuperior", "", "", "isuperior", "ssuperior", "dsuperior", "", "", "", "", "", "lsuperior", "Ogoneksmall", "Brevesmall", "Macronsmall", "bsuperior", "nsuperior", "msuperior", "commasuperior", "periodsuperior", "Dotaccentsmall", "Ringsmall", "", "", "", ""];
              const MacRomanEncoding = ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "space", "exclam", "quotedbl", "numbersign", "dollar", "percent", "ampersand", "quotesingle", "parenleft", "parenright", "asterisk", "plus", "comma", "hyphen", "period", "slash", "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "colon", "semicolon", "less", "equal", "greater", "question", "at", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "bracketleft", "backslash", "bracketright", "asciicircum", "underscore", "grave", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "braceleft", "bar", "braceright", "asciitilde", "", "Adieresis", "Aring", "Ccedilla", "Eacute", "Ntilde", "Odieresis", "Udieresis", "aacute", "agrave", "acircumflex", "adieresis", "atilde", "aring", "ccedilla", "eacute", "egrave", "ecircumflex", "edieresis", "iacute", "igrave", "icircumflex", "idieresis", "ntilde", "oacute", "ograve", "ocircumflex", "odieresis", "otilde", "uacute", "ugrave", "ucircumflex", "udieresis", "dagger", "degree", "cent", "sterling", "section", "bullet", "paragraph", "germandbls", "registered", "copyright", "trademark", "acute", "dieresis", "notequal", "AE", "Oslash", "infinity", "plusminus", "lessequal", "greaterequal", "yen", "mu", "partialdiff", "summation", "product", "pi", "integral", "ordfeminine", "ordmasculine", "Omega", "ae", "oslash", "questiondown", "exclamdown", "logicalnot", "radical", "florin", "approxequal", "Delta", "guillemotleft", "guillemotright", "ellipsis", "space", "Agrave", "Atilde", "Otilde", "OE", "oe", "endash", "emdash", "quotedblleft", "quotedblright", "quoteleft", "quoteright", "divide", "lozenge", "ydieresis", "Ydieresis", "fraction", "currency", "guilsinglleft", "guilsinglright", "fi", "fl", "daggerdbl", "periodcentered", "quotesinglbase", "quotedblbase", "perthousand", "Acircumflex", "Ecircumflex", "Aacute", "Edieresis", "Egrave", "Iacute", "Icircumflex", "Idieresis", "Igrave", "Oacute", "Ocircumflex", "apple", "Ograve", "Uacute", "Ucircumflex", "Ugrave", "dotlessi", "circumflex", "tilde", "macron", "breve", "dotaccent", "ring", "cedilla", "hungarumlaut", "ogonek", "caron"];
              exports3.MacRomanEncoding = MacRomanEncoding;
              const StandardEncoding = ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "space", "exclam", "quotedbl", "numbersign", "dollar", "percent", "ampersand", "quoteright", "parenleft", "parenright", "asterisk", "plus", "comma", "hyphen", "period", "slash", "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "colon", "semicolon", "less", "equal", "greater", "question", "at", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "bracketleft", "backslash", "bracketright", "asciicircum", "underscore", "quoteleft", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "braceleft", "bar", "braceright", "asciitilde", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "exclamdown", "cent", "sterling", "fraction", "yen", "florin", "section", "currency", "quotesingle", "quotedblleft", "guillemotleft", "guilsinglleft", "guilsinglright", "fi", "fl", "", "endash", "dagger", "daggerdbl", "periodcentered", "", "paragraph", "bullet", "quotesinglbase", "quotedblbase", "quotedblright", "guillemotright", "ellipsis", "perthousand", "", "questiondown", "", "grave", "acute", "circumflex", "tilde", "macron", "breve", "dotaccent", "dieresis", "", "ring", "cedilla", "", "hungarumlaut", "ogonek", "caron", "emdash", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "AE", "", "ordfeminine", "", "", "", "", "Lslash", "Oslash", "OE", "ordmasculine", "", "", "", "", "", "ae", "", "", "", "dotlessi", "", "", "lslash", "oslash", "oe", "germandbls", "", "", "", ""];
              exports3.StandardEncoding = StandardEncoding;
              const WinAnsiEncoding = ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "space", "exclam", "quotedbl", "numbersign", "dollar", "percent", "ampersand", "quotesingle", "parenleft", "parenright", "asterisk", "plus", "comma", "hyphen", "period", "slash", "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "colon", "semicolon", "less", "equal", "greater", "question", "at", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "bracketleft", "backslash", "bracketright", "asciicircum", "underscore", "grave", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "braceleft", "bar", "braceright", "asciitilde", "bullet", "Euro", "bullet", "quotesinglbase", "florin", "quotedblbase", "ellipsis", "dagger", "daggerdbl", "circumflex", "perthousand", "Scaron", "guilsinglleft", "OE", "bullet", "Zcaron", "bullet", "bullet", "quoteleft", "quoteright", "quotedblleft", "quotedblright", "bullet", "endash", "emdash", "tilde", "trademark", "scaron", "guilsinglright", "oe", "bullet", "zcaron", "Ydieresis", "space", "exclamdown", "cent", "sterling", "currency", "yen", "brokenbar", "section", "dieresis", "copyright", "ordfeminine", "guillemotleft", "logicalnot", "hyphen", "registered", "macron", "degree", "plusminus", "twosuperior", "threesuperior", "acute", "mu", "paragraph", "periodcentered", "cedilla", "onesuperior", "ordmasculine", "guillemotright", "onequarter", "onehalf", "threequarters", "questiondown", "Agrave", "Aacute", "Acircumflex", "Atilde", "Adieresis", "Aring", "AE", "Ccedilla", "Egrave", "Eacute", "Ecircumflex", "Edieresis", "Igrave", "Iacute", "Icircumflex", "Idieresis", "Eth", "Ntilde", "Ograve", "Oacute", "Ocircumflex", "Otilde", "Odieresis", "multiply", "Oslash", "Ugrave", "Uacute", "Ucircumflex", "Udieresis", "Yacute", "Thorn", "germandbls", "agrave", "aacute", "acircumflex", "atilde", "adieresis", "aring", "ae", "ccedilla", "egrave", "eacute", "ecircumflex", "edieresis", "igrave", "iacute", "icircumflex", "idieresis", "eth", "ntilde", "ograve", "oacute", "ocircumflex", "otilde", "odieresis", "divide", "oslash", "ugrave", "uacute", "ucircumflex", "udieresis", "yacute", "thorn", "ydieresis"];
              exports3.WinAnsiEncoding = WinAnsiEncoding;
              const SymbolSetEncoding = ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "space", "exclam", "universal", "numbersign", "existential", "percent", "ampersand", "suchthat", "parenleft", "parenright", "asteriskmath", "plus", "comma", "minus", "period", "slash", "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "colon", "semicolon", "less", "equal", "greater", "question", "congruent", "Alpha", "Beta", "Chi", "Delta", "Epsilon", "Phi", "Gamma", "Eta", "Iota", "theta1", "Kappa", "Lambda", "Mu", "Nu", "Omicron", "Pi", "Theta", "Rho", "Sigma", "Tau", "Upsilon", "sigma1", "Omega", "Xi", "Psi", "Zeta", "bracketleft", "therefore", "bracketright", "perpendicular", "underscore", "radicalex", "alpha", "beta", "chi", "delta", "epsilon", "phi", "gamma", "eta", "iota", "phi1", "kappa", "lambda", "mu", "nu", "omicron", "pi", "theta", "rho", "sigma", "tau", "upsilon", "omega1", "omega", "xi", "psi", "zeta", "braceleft", "bar", "braceright", "similar", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "Euro", "Upsilon1", "minute", "lessequal", "fraction", "infinity", "florin", "club", "diamond", "heart", "spade", "arrowboth", "arrowleft", "arrowup", "arrowright", "arrowdown", "degree", "plusminus", "second", "greaterequal", "multiply", "proportional", "partialdiff", "bullet", "divide", "notequal", "equivalence", "approxequal", "ellipsis", "arrowvertex", "arrowhorizex", "carriagereturn", "aleph", "Ifraktur", "Rfraktur", "weierstrass", "circlemultiply", "circleplus", "emptyset", "intersection", "union", "propersuperset", "reflexsuperset", "notsubset", "propersubset", "reflexsubset", "element", "notelement", "angle", "gradient", "registerserif", "copyrightserif", "trademarkserif", "product", "radical", "dotmath", "logicalnot", "logicaland", "logicalor", "arrowdblboth", "arrowdblleft", "arrowdblup", "arrowdblright", "arrowdbldown", "lozenge", "angleleft", "registersans", "copyrightsans", "trademarksans", "summation", "parenlefttp", "parenleftex", "parenleftbt", "bracketlefttp", "bracketleftex", "bracketleftbt", "bracelefttp", "braceleftmid", "braceleftbt", "braceex", "", "angleright", "integral", "integraltp", "integralex", "integralbt", "parenrighttp", "parenrightex", "parenrightbt", "bracketrighttp", "bracketrightex", "bracketrightbt", "bracerighttp", "bracerightmid", "bracerightbt", ""];
              exports3.SymbolSetEncoding = SymbolSetEncoding;
              const ZapfDingbatsEncoding = ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "space", "a1", "a2", "a202", "a3", "a4", "a5", "a119", "a118", "a117", "a11", "a12", "a13", "a14", "a15", "a16", "a105", "a17", "a18", "a19", "a20", "a21", "a22", "a23", "a24", "a25", "a26", "a27", "a28", "a6", "a7", "a8", "a9", "a10", "a29", "a30", "a31", "a32", "a33", "a34", "a35", "a36", "a37", "a38", "a39", "a40", "a41", "a42", "a43", "a44", "a45", "a46", "a47", "a48", "a49", "a50", "a51", "a52", "a53", "a54", "a55", "a56", "a57", "a58", "a59", "a60", "a61", "a62", "a63", "a64", "a65", "a66", "a67", "a68", "a69", "a70", "a71", "a72", "a73", "a74", "a203", "a75", "a204", "a76", "a77", "a78", "a79", "a81", "a82", "a83", "a84", "a97", "a98", "a99", "a100", "", "a89", "a90", "a93", "a94", "a91", "a92", "a205", "a85", "a206", "a86", "a87", "a88", "a95", "a96", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "a101", "a102", "a103", "a104", "a106", "a107", "a108", "a112", "a111", "a110", "a109", "a120", "a121", "a122", "a123", "a124", "a125", "a126", "a127", "a128", "a129", "a130", "a131", "a132", "a133", "a134", "a135", "a136", "a137", "a138", "a139", "a140", "a141", "a142", "a143", "a144", "a145", "a146", "a147", "a148", "a149", "a150", "a151", "a152", "a153", "a154", "a155", "a156", "a157", "a158", "a159", "a160", "a161", "a163", "a164", "a196", "a165", "a192", "a166", "a167", "a168", "a169", "a170", "a171", "a172", "a173", "a162", "a174", "a175", "a176", "a177", "a178", "a179", "a193", "a180", "a199", "a181", "a200", "a182", "", "a201", "a183", "a184", "a197", "a185", "a194", "a198", "a186", "a195", "a187", "a188", "a189", "a190", "a191", ""];
              exports3.ZapfDingbatsEncoding = ZapfDingbatsEncoding;
              function getEncoding(encodingName) {
                switch (encodingName) {
                  case "WinAnsiEncoding":
                    return WinAnsiEncoding;
                  case "StandardEncoding":
                    return StandardEncoding;
                  case "MacRomanEncoding":
                    return MacRomanEncoding;
                  case "SymbolSetEncoding":
                    return SymbolSetEncoding;
                  case "ZapfDingbatsEncoding":
                    return ZapfDingbatsEncoding;
                  case "ExpertEncoding":
                    return ExpertEncoding;
                  case "MacExpertEncoding":
                    return MacExpertEncoding;
                  default:
                    return null;
                }
              }
            }),
            /* 38 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.SEAC_ANALYSIS_ENABLED = exports3.MacStandardGlyphOrdering = exports3.FontFlags = void 0;
              exports3.normalizeFontName = normalizeFontName;
              exports3.recoverGlyphName = recoverGlyphName;
              exports3.type1FontGlyphMapping = type1FontGlyphMapping;
              var _encodings = __w_pdfjs_require__3(37);
              var _glyphlist = __w_pdfjs_require__3(39);
              var _unicode = __w_pdfjs_require__3(40);
              var _util2 = __w_pdfjs_require__3(2);
              const SEAC_ANALYSIS_ENABLED = true;
              exports3.SEAC_ANALYSIS_ENABLED = SEAC_ANALYSIS_ENABLED;
              const FontFlags = {
                FixedPitch: 1,
                Serif: 2,
                Symbolic: 4,
                Script: 8,
                Nonsymbolic: 32,
                Italic: 64,
                AllCap: 65536,
                SmallCap: 131072,
                ForceBold: 262144
              };
              exports3.FontFlags = FontFlags;
              const MacStandardGlyphOrdering = [".notdef", ".null", "nonmarkingreturn", "space", "exclam", "quotedbl", "numbersign", "dollar", "percent", "ampersand", "quotesingle", "parenleft", "parenright", "asterisk", "plus", "comma", "hyphen", "period", "slash", "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "colon", "semicolon", "less", "equal", "greater", "question", "at", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "bracketleft", "backslash", "bracketright", "asciicircum", "underscore", "grave", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "braceleft", "bar", "braceright", "asciitilde", "Adieresis", "Aring", "Ccedilla", "Eacute", "Ntilde", "Odieresis", "Udieresis", "aacute", "agrave", "acircumflex", "adieresis", "atilde", "aring", "ccedilla", "eacute", "egrave", "ecircumflex", "edieresis", "iacute", "igrave", "icircumflex", "idieresis", "ntilde", "oacute", "ograve", "ocircumflex", "odieresis", "otilde", "uacute", "ugrave", "ucircumflex", "udieresis", "dagger", "degree", "cent", "sterling", "section", "bullet", "paragraph", "germandbls", "registered", "copyright", "trademark", "acute", "dieresis", "notequal", "AE", "Oslash", "infinity", "plusminus", "lessequal", "greaterequal", "yen", "mu", "partialdiff", "summation", "product", "pi", "integral", "ordfeminine", "ordmasculine", "Omega", "ae", "oslash", "questiondown", "exclamdown", "logicalnot", "radical", "florin", "approxequal", "Delta", "guillemotleft", "guillemotright", "ellipsis", "nonbreakingspace", "Agrave", "Atilde", "Otilde", "OE", "oe", "endash", "emdash", "quotedblleft", "quotedblright", "quoteleft", "quoteright", "divide", "lozenge", "ydieresis", "Ydieresis", "fraction", "currency", "guilsinglleft", "guilsinglright", "fi", "fl", "daggerdbl", "periodcentered", "quotesinglbase", "quotedblbase", "perthousand", "Acircumflex", "Ecircumflex", "Aacute", "Edieresis", "Egrave", "Iacute", "Icircumflex", "Idieresis", "Igrave", "Oacute", "Ocircumflex", "apple", "Ograve", "Uacute", "Ucircumflex", "Ugrave", "dotlessi", "circumflex", "tilde", "macron", "breve", "dotaccent", "ring", "cedilla", "hungarumlaut", "ogonek", "caron", "Lslash", "lslash", "Scaron", "scaron", "Zcaron", "zcaron", "brokenbar", "Eth", "eth", "Yacute", "yacute", "Thorn", "thorn", "minus", "multiply", "onesuperior", "twosuperior", "threesuperior", "onehalf", "onequarter", "threequarters", "franc", "Gbreve", "gbreve", "Idotaccent", "Scedilla", "scedilla", "Cacute", "cacute", "Ccaron", "ccaron", "dcroat"];
              exports3.MacStandardGlyphOrdering = MacStandardGlyphOrdering;
              function recoverGlyphName(name, glyphsUnicodeMap) {
                if (glyphsUnicodeMap[name] !== void 0) {
                  return name;
                }
                const unicode = (0, _unicode.getUnicodeForGlyph)(name, glyphsUnicodeMap);
                if (unicode !== -1) {
                  for (const key2 in glyphsUnicodeMap) {
                    if (glyphsUnicodeMap[key2] === unicode) {
                      return key2;
                    }
                  }
                }
                (0, _util2.info)("Unable to recover a standard glyph name for: " + name);
                return name;
              }
              function type1FontGlyphMapping(properties2, builtInEncoding, glyphNames) {
                const charCodeToGlyphId = /* @__PURE__ */ Object.create(null);
                let glyphId, charCode, baseEncoding;
                const isSymbolicFont = !!(properties2.flags & FontFlags.Symbolic);
                if (properties2.isInternalFont) {
                  baseEncoding = builtInEncoding;
                  for (charCode = 0; charCode < baseEncoding.length; charCode++) {
                    glyphId = glyphNames.indexOf(baseEncoding[charCode]);
                    charCodeToGlyphId[charCode] = glyphId >= 0 ? glyphId : 0;
                  }
                } else if (properties2.baseEncodingName) {
                  baseEncoding = (0, _encodings.getEncoding)(properties2.baseEncodingName);
                  for (charCode = 0; charCode < baseEncoding.length; charCode++) {
                    glyphId = glyphNames.indexOf(baseEncoding[charCode]);
                    charCodeToGlyphId[charCode] = glyphId >= 0 ? glyphId : 0;
                  }
                } else if (isSymbolicFont) {
                  for (charCode in builtInEncoding) {
                    charCodeToGlyphId[charCode] = builtInEncoding[charCode];
                  }
                } else {
                  baseEncoding = _encodings.StandardEncoding;
                  for (charCode = 0; charCode < baseEncoding.length; charCode++) {
                    glyphId = glyphNames.indexOf(baseEncoding[charCode]);
                    charCodeToGlyphId[charCode] = glyphId >= 0 ? glyphId : 0;
                  }
                }
                const differences = properties2.differences;
                let glyphsUnicodeMap;
                if (differences) {
                  for (charCode in differences) {
                    const glyphName = differences[charCode];
                    glyphId = glyphNames.indexOf(glyphName);
                    if (glyphId === -1) {
                      if (!glyphsUnicodeMap) {
                        glyphsUnicodeMap = (0, _glyphlist.getGlyphsUnicode)();
                      }
                      const standardGlyphName = recoverGlyphName(glyphName, glyphsUnicodeMap);
                      if (standardGlyphName !== glyphName) {
                        glyphId = glyphNames.indexOf(standardGlyphName);
                      }
                    }
                    charCodeToGlyphId[charCode] = glyphId >= 0 ? glyphId : 0;
                  }
                }
                return charCodeToGlyphId;
              }
              function normalizeFontName(name) {
                return name.replaceAll(/[,_]/g, "-").replaceAll(/\s/g, "");
              }
            }),
            /* 39 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.getGlyphsUnicode = exports3.getDingbatsGlyphsUnicode = void 0;
              var _core_utils = __w_pdfjs_require__3(3);
              const getGlyphsUnicode = (0, _core_utils.getLookupTableFactory)(function(t2) {
                t2.A = 65;
                t2.AE = 198;
                t2.AEacute = 508;
                t2.AEmacron = 482;
                t2.AEsmall = 63462;
                t2.Aacute = 193;
                t2.Aacutesmall = 63457;
                t2.Abreve = 258;
                t2.Abreveacute = 7854;
                t2.Abrevecyrillic = 1232;
                t2.Abrevedotbelow = 7862;
                t2.Abrevegrave = 7856;
                t2.Abrevehookabove = 7858;
                t2.Abrevetilde = 7860;
                t2.Acaron = 461;
                t2.Acircle = 9398;
                t2.Acircumflex = 194;
                t2.Acircumflexacute = 7844;
                t2.Acircumflexdotbelow = 7852;
                t2.Acircumflexgrave = 7846;
                t2.Acircumflexhookabove = 7848;
                t2.Acircumflexsmall = 63458;
                t2.Acircumflextilde = 7850;
                t2.Acute = 63177;
                t2.Acutesmall = 63412;
                t2.Acyrillic = 1040;
                t2.Adblgrave = 512;
                t2.Adieresis = 196;
                t2.Adieresiscyrillic = 1234;
                t2.Adieresismacron = 478;
                t2.Adieresissmall = 63460;
                t2.Adotbelow = 7840;
                t2.Adotmacron = 480;
                t2.Agrave = 192;
                t2.Agravesmall = 63456;
                t2.Ahookabove = 7842;
                t2.Aiecyrillic = 1236;
                t2.Ainvertedbreve = 514;
                t2.Alpha = 913;
                t2.Alphatonos = 902;
                t2.Amacron = 256;
                t2.Amonospace = 65313;
                t2.Aogonek = 260;
                t2.Aring = 197;
                t2.Aringacute = 506;
                t2.Aringbelow = 7680;
                t2.Aringsmall = 63461;
                t2.Asmall = 63329;
                t2.Atilde = 195;
                t2.Atildesmall = 63459;
                t2.Aybarmenian = 1329;
                t2.B = 66;
                t2.Bcircle = 9399;
                t2.Bdotaccent = 7682;
                t2.Bdotbelow = 7684;
                t2.Becyrillic = 1041;
                t2.Benarmenian = 1330;
                t2.Beta = 914;
                t2.Bhook = 385;
                t2.Blinebelow = 7686;
                t2.Bmonospace = 65314;
                t2.Brevesmall = 63220;
                t2.Bsmall = 63330;
                t2.Btopbar = 386;
                t2.C = 67;
                t2.Caarmenian = 1342;
                t2.Cacute = 262;
                t2.Caron = 63178;
                t2.Caronsmall = 63221;
                t2.Ccaron = 268;
                t2.Ccedilla = 199;
                t2.Ccedillaacute = 7688;
                t2.Ccedillasmall = 63463;
                t2.Ccircle = 9400;
                t2.Ccircumflex = 264;
                t2.Cdot = 266;
                t2.Cdotaccent = 266;
                t2.Cedillasmall = 63416;
                t2.Chaarmenian = 1353;
                t2.Cheabkhasiancyrillic = 1212;
                t2.Checyrillic = 1063;
                t2.Chedescenderabkhasiancyrillic = 1214;
                t2.Chedescendercyrillic = 1206;
                t2.Chedieresiscyrillic = 1268;
                t2.Cheharmenian = 1347;
                t2.Chekhakassiancyrillic = 1227;
                t2.Cheverticalstrokecyrillic = 1208;
                t2.Chi = 935;
                t2.Chook = 391;
                t2.Circumflexsmall = 63222;
                t2.Cmonospace = 65315;
                t2.Coarmenian = 1361;
                t2.Csmall = 63331;
                t2.D = 68;
                t2.DZ = 497;
                t2.DZcaron = 452;
                t2.Daarmenian = 1332;
                t2.Dafrican = 393;
                t2.Dcaron = 270;
                t2.Dcedilla = 7696;
                t2.Dcircle = 9401;
                t2.Dcircumflexbelow = 7698;
                t2.Dcroat = 272;
                t2.Ddotaccent = 7690;
                t2.Ddotbelow = 7692;
                t2.Decyrillic = 1044;
                t2.Deicoptic = 1006;
                t2.Delta = 8710;
                t2.Deltagreek = 916;
                t2.Dhook = 394;
                t2.Dieresis = 63179;
                t2.DieresisAcute = 63180;
                t2.DieresisGrave = 63181;
                t2.Dieresissmall = 63400;
                t2.Digammagreek = 988;
                t2.Djecyrillic = 1026;
                t2.Dlinebelow = 7694;
                t2.Dmonospace = 65316;
                t2.Dotaccentsmall = 63223;
                t2.Dslash = 272;
                t2.Dsmall = 63332;
                t2.Dtopbar = 395;
                t2.Dz = 498;
                t2.Dzcaron = 453;
                t2.Dzeabkhasiancyrillic = 1248;
                t2.Dzecyrillic = 1029;
                t2.Dzhecyrillic = 1039;
                t2.E = 69;
                t2.Eacute = 201;
                t2.Eacutesmall = 63465;
                t2.Ebreve = 276;
                t2.Ecaron = 282;
                t2.Ecedillabreve = 7708;
                t2.Echarmenian = 1333;
                t2.Ecircle = 9402;
                t2.Ecircumflex = 202;
                t2.Ecircumflexacute = 7870;
                t2.Ecircumflexbelow = 7704;
                t2.Ecircumflexdotbelow = 7878;
                t2.Ecircumflexgrave = 7872;
                t2.Ecircumflexhookabove = 7874;
                t2.Ecircumflexsmall = 63466;
                t2.Ecircumflextilde = 7876;
                t2.Ecyrillic = 1028;
                t2.Edblgrave = 516;
                t2.Edieresis = 203;
                t2.Edieresissmall = 63467;
                t2.Edot = 278;
                t2.Edotaccent = 278;
                t2.Edotbelow = 7864;
                t2.Efcyrillic = 1060;
                t2.Egrave = 200;
                t2.Egravesmall = 63464;
                t2.Eharmenian = 1335;
                t2.Ehookabove = 7866;
                t2.Eightroman = 8551;
                t2.Einvertedbreve = 518;
                t2.Eiotifiedcyrillic = 1124;
                t2.Elcyrillic = 1051;
                t2.Elevenroman = 8554;
                t2.Emacron = 274;
                t2.Emacronacute = 7702;
                t2.Emacrongrave = 7700;
                t2.Emcyrillic = 1052;
                t2.Emonospace = 65317;
                t2.Encyrillic = 1053;
                t2.Endescendercyrillic = 1186;
                t2.Eng = 330;
                t2.Enghecyrillic = 1188;
                t2.Enhookcyrillic = 1223;
                t2.Eogonek = 280;
                t2.Eopen = 400;
                t2.Epsilon = 917;
                t2.Epsilontonos = 904;
                t2.Ercyrillic = 1056;
                t2.Ereversed = 398;
                t2.Ereversedcyrillic = 1069;
                t2.Escyrillic = 1057;
                t2.Esdescendercyrillic = 1194;
                t2.Esh = 425;
                t2.Esmall = 63333;
                t2.Eta = 919;
                t2.Etarmenian = 1336;
                t2.Etatonos = 905;
                t2.Eth = 208;
                t2.Ethsmall = 63472;
                t2.Etilde = 7868;
                t2.Etildebelow = 7706;
                t2.Euro = 8364;
                t2.Ezh = 439;
                t2.Ezhcaron = 494;
                t2.Ezhreversed = 440;
                t2.F = 70;
                t2.Fcircle = 9403;
                t2.Fdotaccent = 7710;
                t2.Feharmenian = 1366;
                t2.Feicoptic = 996;
                t2.Fhook = 401;
                t2.Fitacyrillic = 1138;
                t2.Fiveroman = 8548;
                t2.Fmonospace = 65318;
                t2.Fourroman = 8547;
                t2.Fsmall = 63334;
                t2.G = 71;
                t2.GBsquare = 13191;
                t2.Gacute = 500;
                t2.Gamma = 915;
                t2.Gammaafrican = 404;
                t2.Gangiacoptic = 1002;
                t2.Gbreve = 286;
                t2.Gcaron = 486;
                t2.Gcedilla = 290;
                t2.Gcircle = 9404;
                t2.Gcircumflex = 284;
                t2.Gcommaaccent = 290;
                t2.Gdot = 288;
                t2.Gdotaccent = 288;
                t2.Gecyrillic = 1043;
                t2.Ghadarmenian = 1346;
                t2.Ghemiddlehookcyrillic = 1172;
                t2.Ghestrokecyrillic = 1170;
                t2.Gheupturncyrillic = 1168;
                t2.Ghook = 403;
                t2.Gimarmenian = 1331;
                t2.Gjecyrillic = 1027;
                t2.Gmacron = 7712;
                t2.Gmonospace = 65319;
                t2.Grave = 63182;
                t2.Gravesmall = 63328;
                t2.Gsmall = 63335;
                t2.Gsmallhook = 667;
                t2.Gstroke = 484;
                t2.H = 72;
                t2.H18533 = 9679;
                t2.H18543 = 9642;
                t2.H18551 = 9643;
                t2.H22073 = 9633;
                t2.HPsquare = 13259;
                t2.Haabkhasiancyrillic = 1192;
                t2.Hadescendercyrillic = 1202;
                t2.Hardsigncyrillic = 1066;
                t2.Hbar = 294;
                t2.Hbrevebelow = 7722;
                t2.Hcedilla = 7720;
                t2.Hcircle = 9405;
                t2.Hcircumflex = 292;
                t2.Hdieresis = 7718;
                t2.Hdotaccent = 7714;
                t2.Hdotbelow = 7716;
                t2.Hmonospace = 65320;
                t2.Hoarmenian = 1344;
                t2.Horicoptic = 1e3;
                t2.Hsmall = 63336;
                t2.Hungarumlaut = 63183;
                t2.Hungarumlautsmall = 63224;
                t2.Hzsquare = 13200;
                t2.I = 73;
                t2.IAcyrillic = 1071;
                t2.IJ = 306;
                t2.IUcyrillic = 1070;
                t2.Iacute = 205;
                t2.Iacutesmall = 63469;
                t2.Ibreve = 300;
                t2.Icaron = 463;
                t2.Icircle = 9406;
                t2.Icircumflex = 206;
                t2.Icircumflexsmall = 63470;
                t2.Icyrillic = 1030;
                t2.Idblgrave = 520;
                t2.Idieresis = 207;
                t2.Idieresisacute = 7726;
                t2.Idieresiscyrillic = 1252;
                t2.Idieresissmall = 63471;
                t2.Idot = 304;
                t2.Idotaccent = 304;
                t2.Idotbelow = 7882;
                t2.Iebrevecyrillic = 1238;
                t2.Iecyrillic = 1045;
                t2.Ifraktur = 8465;
                t2.Igrave = 204;
                t2.Igravesmall = 63468;
                t2.Ihookabove = 7880;
                t2.Iicyrillic = 1048;
                t2.Iinvertedbreve = 522;
                t2.Iishortcyrillic = 1049;
                t2.Imacron = 298;
                t2.Imacroncyrillic = 1250;
                t2.Imonospace = 65321;
                t2.Iniarmenian = 1339;
                t2.Iocyrillic = 1025;
                t2.Iogonek = 302;
                t2.Iota = 921;
                t2.Iotaafrican = 406;
                t2.Iotadieresis = 938;
                t2.Iotatonos = 906;
                t2.Ismall = 63337;
                t2.Istroke = 407;
                t2.Itilde = 296;
                t2.Itildebelow = 7724;
                t2.Izhitsacyrillic = 1140;
                t2.Izhitsadblgravecyrillic = 1142;
                t2.J = 74;
                t2.Jaarmenian = 1345;
                t2.Jcircle = 9407;
                t2.Jcircumflex = 308;
                t2.Jecyrillic = 1032;
                t2.Jheharmenian = 1355;
                t2.Jmonospace = 65322;
                t2.Jsmall = 63338;
                t2.K = 75;
                t2.KBsquare = 13189;
                t2.KKsquare = 13261;
                t2.Kabashkircyrillic = 1184;
                t2.Kacute = 7728;
                t2.Kacyrillic = 1050;
                t2.Kadescendercyrillic = 1178;
                t2.Kahookcyrillic = 1219;
                t2.Kappa = 922;
                t2.Kastrokecyrillic = 1182;
                t2.Kaverticalstrokecyrillic = 1180;
                t2.Kcaron = 488;
                t2.Kcedilla = 310;
                t2.Kcircle = 9408;
                t2.Kcommaaccent = 310;
                t2.Kdotbelow = 7730;
                t2.Keharmenian = 1364;
                t2.Kenarmenian = 1343;
                t2.Khacyrillic = 1061;
                t2.Kheicoptic = 998;
                t2.Khook = 408;
                t2.Kjecyrillic = 1036;
                t2.Klinebelow = 7732;
                t2.Kmonospace = 65323;
                t2.Koppacyrillic = 1152;
                t2.Koppagreek = 990;
                t2.Ksicyrillic = 1134;
                t2.Ksmall = 63339;
                t2.L = 76;
                t2.LJ = 455;
                t2.LL = 63167;
                t2.Lacute = 313;
                t2.Lambda = 923;
                t2.Lcaron = 317;
                t2.Lcedilla = 315;
                t2.Lcircle = 9409;
                t2.Lcircumflexbelow = 7740;
                t2.Lcommaaccent = 315;
                t2.Ldot = 319;
                t2.Ldotaccent = 319;
                t2.Ldotbelow = 7734;
                t2.Ldotbelowmacron = 7736;
                t2.Liwnarmenian = 1340;
                t2.Lj = 456;
                t2.Ljecyrillic = 1033;
                t2.Llinebelow = 7738;
                t2.Lmonospace = 65324;
                t2.Lslash = 321;
                t2.Lslashsmall = 63225;
                t2.Lsmall = 63340;
                t2.M = 77;
                t2.MBsquare = 13190;
                t2.Macron = 63184;
                t2.Macronsmall = 63407;
                t2.Macute = 7742;
                t2.Mcircle = 9410;
                t2.Mdotaccent = 7744;
                t2.Mdotbelow = 7746;
                t2.Menarmenian = 1348;
                t2.Mmonospace = 65325;
                t2.Msmall = 63341;
                t2.Mturned = 412;
                t2.Mu = 924;
                t2.N = 78;
                t2.NJ = 458;
                t2.Nacute = 323;
                t2.Ncaron = 327;
                t2.Ncedilla = 325;
                t2.Ncircle = 9411;
                t2.Ncircumflexbelow = 7754;
                t2.Ncommaaccent = 325;
                t2.Ndotaccent = 7748;
                t2.Ndotbelow = 7750;
                t2.Nhookleft = 413;
                t2.Nineroman = 8552;
                t2.Nj = 459;
                t2.Njecyrillic = 1034;
                t2.Nlinebelow = 7752;
                t2.Nmonospace = 65326;
                t2.Nowarmenian = 1350;
                t2.Nsmall = 63342;
                t2.Ntilde = 209;
                t2.Ntildesmall = 63473;
                t2.Nu = 925;
                t2.O = 79;
                t2.OE = 338;
                t2.OEsmall = 63226;
                t2.Oacute = 211;
                t2.Oacutesmall = 63475;
                t2.Obarredcyrillic = 1256;
                t2.Obarreddieresiscyrillic = 1258;
                t2.Obreve = 334;
                t2.Ocaron = 465;
                t2.Ocenteredtilde = 415;
                t2.Ocircle = 9412;
                t2.Ocircumflex = 212;
                t2.Ocircumflexacute = 7888;
                t2.Ocircumflexdotbelow = 7896;
                t2.Ocircumflexgrave = 7890;
                t2.Ocircumflexhookabove = 7892;
                t2.Ocircumflexsmall = 63476;
                t2.Ocircumflextilde = 7894;
                t2.Ocyrillic = 1054;
                t2.Odblacute = 336;
                t2.Odblgrave = 524;
                t2.Odieresis = 214;
                t2.Odieresiscyrillic = 1254;
                t2.Odieresissmall = 63478;
                t2.Odotbelow = 7884;
                t2.Ogoneksmall = 63227;
                t2.Ograve = 210;
                t2.Ogravesmall = 63474;
                t2.Oharmenian = 1365;
                t2.Ohm = 8486;
                t2.Ohookabove = 7886;
                t2.Ohorn = 416;
                t2.Ohornacute = 7898;
                t2.Ohorndotbelow = 7906;
                t2.Ohorngrave = 7900;
                t2.Ohornhookabove = 7902;
                t2.Ohorntilde = 7904;
                t2.Ohungarumlaut = 336;
                t2.Oi = 418;
                t2.Oinvertedbreve = 526;
                t2.Omacron = 332;
                t2.Omacronacute = 7762;
                t2.Omacrongrave = 7760;
                t2.Omega = 8486;
                t2.Omegacyrillic = 1120;
                t2.Omegagreek = 937;
                t2.Omegaroundcyrillic = 1146;
                t2.Omegatitlocyrillic = 1148;
                t2.Omegatonos = 911;
                t2.Omicron = 927;
                t2.Omicrontonos = 908;
                t2.Omonospace = 65327;
                t2.Oneroman = 8544;
                t2.Oogonek = 490;
                t2.Oogonekmacron = 492;
                t2.Oopen = 390;
                t2.Oslash = 216;
                t2.Oslashacute = 510;
                t2.Oslashsmall = 63480;
                t2.Osmall = 63343;
                t2.Ostrokeacute = 510;
                t2.Otcyrillic = 1150;
                t2.Otilde = 213;
                t2.Otildeacute = 7756;
                t2.Otildedieresis = 7758;
                t2.Otildesmall = 63477;
                t2.P = 80;
                t2.Pacute = 7764;
                t2.Pcircle = 9413;
                t2.Pdotaccent = 7766;
                t2.Pecyrillic = 1055;
                t2.Peharmenian = 1354;
                t2.Pemiddlehookcyrillic = 1190;
                t2.Phi = 934;
                t2.Phook = 420;
                t2.Pi = 928;
                t2.Piwrarmenian = 1363;
                t2.Pmonospace = 65328;
                t2.Psi = 936;
                t2.Psicyrillic = 1136;
                t2.Psmall = 63344;
                t2.Q = 81;
                t2.Qcircle = 9414;
                t2.Qmonospace = 65329;
                t2.Qsmall = 63345;
                t2.R = 82;
                t2.Raarmenian = 1356;
                t2.Racute = 340;
                t2.Rcaron = 344;
                t2.Rcedilla = 342;
                t2.Rcircle = 9415;
                t2.Rcommaaccent = 342;
                t2.Rdblgrave = 528;
                t2.Rdotaccent = 7768;
                t2.Rdotbelow = 7770;
                t2.Rdotbelowmacron = 7772;
                t2.Reharmenian = 1360;
                t2.Rfraktur = 8476;
                t2.Rho = 929;
                t2.Ringsmall = 63228;
                t2.Rinvertedbreve = 530;
                t2.Rlinebelow = 7774;
                t2.Rmonospace = 65330;
                t2.Rsmall = 63346;
                t2.Rsmallinverted = 641;
                t2.Rsmallinvertedsuperior = 694;
                t2.S = 83;
                t2.SF010000 = 9484;
                t2.SF020000 = 9492;
                t2.SF030000 = 9488;
                t2.SF040000 = 9496;
                t2.SF050000 = 9532;
                t2.SF060000 = 9516;
                t2.SF070000 = 9524;
                t2.SF080000 = 9500;
                t2.SF090000 = 9508;
                t2.SF100000 = 9472;
                t2.SF110000 = 9474;
                t2.SF190000 = 9569;
                t2.SF200000 = 9570;
                t2.SF210000 = 9558;
                t2.SF220000 = 9557;
                t2.SF230000 = 9571;
                t2.SF240000 = 9553;
                t2.SF250000 = 9559;
                t2.SF260000 = 9565;
                t2.SF270000 = 9564;
                t2.SF280000 = 9563;
                t2.SF360000 = 9566;
                t2.SF370000 = 9567;
                t2.SF380000 = 9562;
                t2.SF390000 = 9556;
                t2.SF400000 = 9577;
                t2.SF410000 = 9574;
                t2.SF420000 = 9568;
                t2.SF430000 = 9552;
                t2.SF440000 = 9580;
                t2.SF450000 = 9575;
                t2.SF460000 = 9576;
                t2.SF470000 = 9572;
                t2.SF480000 = 9573;
                t2.SF490000 = 9561;
                t2.SF500000 = 9560;
                t2.SF510000 = 9554;
                t2.SF520000 = 9555;
                t2.SF530000 = 9579;
                t2.SF540000 = 9578;
                t2.Sacute = 346;
                t2.Sacutedotaccent = 7780;
                t2.Sampigreek = 992;
                t2.Scaron = 352;
                t2.Scarondotaccent = 7782;
                t2.Scaronsmall = 63229;
                t2.Scedilla = 350;
                t2.Schwa = 399;
                t2.Schwacyrillic = 1240;
                t2.Schwadieresiscyrillic = 1242;
                t2.Scircle = 9416;
                t2.Scircumflex = 348;
                t2.Scommaaccent = 536;
                t2.Sdotaccent = 7776;
                t2.Sdotbelow = 7778;
                t2.Sdotbelowdotaccent = 7784;
                t2.Seharmenian = 1357;
                t2.Sevenroman = 8550;
                t2.Shaarmenian = 1351;
                t2.Shacyrillic = 1064;
                t2.Shchacyrillic = 1065;
                t2.Sheicoptic = 994;
                t2.Shhacyrillic = 1210;
                t2.Shimacoptic = 1004;
                t2.Sigma = 931;
                t2.Sixroman = 8549;
                t2.Smonospace = 65331;
                t2.Softsigncyrillic = 1068;
                t2.Ssmall = 63347;
                t2.Stigmagreek = 986;
                t2.T = 84;
                t2.Tau = 932;
                t2.Tbar = 358;
                t2.Tcaron = 356;
                t2.Tcedilla = 354;
                t2.Tcircle = 9417;
                t2.Tcircumflexbelow = 7792;
                t2.Tcommaaccent = 354;
                t2.Tdotaccent = 7786;
                t2.Tdotbelow = 7788;
                t2.Tecyrillic = 1058;
                t2.Tedescendercyrillic = 1196;
                t2.Tenroman = 8553;
                t2.Tetsecyrillic = 1204;
                t2.Theta = 920;
                t2.Thook = 428;
                t2.Thorn = 222;
                t2.Thornsmall = 63486;
                t2.Threeroman = 8546;
                t2.Tildesmall = 63230;
                t2.Tiwnarmenian = 1359;
                t2.Tlinebelow = 7790;
                t2.Tmonospace = 65332;
                t2.Toarmenian = 1337;
                t2.Tonefive = 444;
                t2.Tonesix = 388;
                t2.Tonetwo = 423;
                t2.Tretroflexhook = 430;
                t2.Tsecyrillic = 1062;
                t2.Tshecyrillic = 1035;
                t2.Tsmall = 63348;
                t2.Twelveroman = 8555;
                t2.Tworoman = 8545;
                t2.U = 85;
                t2.Uacute = 218;
                t2.Uacutesmall = 63482;
                t2.Ubreve = 364;
                t2.Ucaron = 467;
                t2.Ucircle = 9418;
                t2.Ucircumflex = 219;
                t2.Ucircumflexbelow = 7798;
                t2.Ucircumflexsmall = 63483;
                t2.Ucyrillic = 1059;
                t2.Udblacute = 368;
                t2.Udblgrave = 532;
                t2.Udieresis = 220;
                t2.Udieresisacute = 471;
                t2.Udieresisbelow = 7794;
                t2.Udieresiscaron = 473;
                t2.Udieresiscyrillic = 1264;
                t2.Udieresisgrave = 475;
                t2.Udieresismacron = 469;
                t2.Udieresissmall = 63484;
                t2.Udotbelow = 7908;
                t2.Ugrave = 217;
                t2.Ugravesmall = 63481;
                t2.Uhookabove = 7910;
                t2.Uhorn = 431;
                t2.Uhornacute = 7912;
                t2.Uhorndotbelow = 7920;
                t2.Uhorngrave = 7914;
                t2.Uhornhookabove = 7916;
                t2.Uhorntilde = 7918;
                t2.Uhungarumlaut = 368;
                t2.Uhungarumlautcyrillic = 1266;
                t2.Uinvertedbreve = 534;
                t2.Ukcyrillic = 1144;
                t2.Umacron = 362;
                t2.Umacroncyrillic = 1262;
                t2.Umacrondieresis = 7802;
                t2.Umonospace = 65333;
                t2.Uogonek = 370;
                t2.Upsilon = 933;
                t2.Upsilon1 = 978;
                t2.Upsilonacutehooksymbolgreek = 979;
                t2.Upsilonafrican = 433;
                t2.Upsilondieresis = 939;
                t2.Upsilondieresishooksymbolgreek = 980;
                t2.Upsilonhooksymbol = 978;
                t2.Upsilontonos = 910;
                t2.Uring = 366;
                t2.Ushortcyrillic = 1038;
                t2.Usmall = 63349;
                t2.Ustraightcyrillic = 1198;
                t2.Ustraightstrokecyrillic = 1200;
                t2.Utilde = 360;
                t2.Utildeacute = 7800;
                t2.Utildebelow = 7796;
                t2.V = 86;
                t2.Vcircle = 9419;
                t2.Vdotbelow = 7806;
                t2.Vecyrillic = 1042;
                t2.Vewarmenian = 1358;
                t2.Vhook = 434;
                t2.Vmonospace = 65334;
                t2.Voarmenian = 1352;
                t2.Vsmall = 63350;
                t2.Vtilde = 7804;
                t2.W = 87;
                t2.Wacute = 7810;
                t2.Wcircle = 9420;
                t2.Wcircumflex = 372;
                t2.Wdieresis = 7812;
                t2.Wdotaccent = 7814;
                t2.Wdotbelow = 7816;
                t2.Wgrave = 7808;
                t2.Wmonospace = 65335;
                t2.Wsmall = 63351;
                t2.X = 88;
                t2.Xcircle = 9421;
                t2.Xdieresis = 7820;
                t2.Xdotaccent = 7818;
                t2.Xeharmenian = 1341;
                t2.Xi = 926;
                t2.Xmonospace = 65336;
                t2.Xsmall = 63352;
                t2.Y = 89;
                t2.Yacute = 221;
                t2.Yacutesmall = 63485;
                t2.Yatcyrillic = 1122;
                t2.Ycircle = 9422;
                t2.Ycircumflex = 374;
                t2.Ydieresis = 376;
                t2.Ydieresissmall = 63487;
                t2.Ydotaccent = 7822;
                t2.Ydotbelow = 7924;
                t2.Yericyrillic = 1067;
                t2.Yerudieresiscyrillic = 1272;
                t2.Ygrave = 7922;
                t2.Yhook = 435;
                t2.Yhookabove = 7926;
                t2.Yiarmenian = 1349;
                t2.Yicyrillic = 1031;
                t2.Yiwnarmenian = 1362;
                t2.Ymonospace = 65337;
                t2.Ysmall = 63353;
                t2.Ytilde = 7928;
                t2.Yusbigcyrillic = 1130;
                t2.Yusbigiotifiedcyrillic = 1132;
                t2.Yuslittlecyrillic = 1126;
                t2.Yuslittleiotifiedcyrillic = 1128;
                t2.Z = 90;
                t2.Zaarmenian = 1334;
                t2.Zacute = 377;
                t2.Zcaron = 381;
                t2.Zcaronsmall = 63231;
                t2.Zcircle = 9423;
                t2.Zcircumflex = 7824;
                t2.Zdot = 379;
                t2.Zdotaccent = 379;
                t2.Zdotbelow = 7826;
                t2.Zecyrillic = 1047;
                t2.Zedescendercyrillic = 1176;
                t2.Zedieresiscyrillic = 1246;
                t2.Zeta = 918;
                t2.Zhearmenian = 1338;
                t2.Zhebrevecyrillic = 1217;
                t2.Zhecyrillic = 1046;
                t2.Zhedescendercyrillic = 1174;
                t2.Zhedieresiscyrillic = 1244;
                t2.Zlinebelow = 7828;
                t2.Zmonospace = 65338;
                t2.Zsmall = 63354;
                t2.Zstroke = 437;
                t2.a = 97;
                t2.aabengali = 2438;
                t2.aacute = 225;
                t2.aadeva = 2310;
                t2.aagujarati = 2694;
                t2.aagurmukhi = 2566;
                t2.aamatragurmukhi = 2622;
                t2.aarusquare = 13059;
                t2.aavowelsignbengali = 2494;
                t2.aavowelsigndeva = 2366;
                t2.aavowelsigngujarati = 2750;
                t2.abbreviationmarkarmenian = 1375;
                t2.abbreviationsigndeva = 2416;
                t2.abengali = 2437;
                t2.abopomofo = 12570;
                t2.abreve = 259;
                t2.abreveacute = 7855;
                t2.abrevecyrillic = 1233;
                t2.abrevedotbelow = 7863;
                t2.abrevegrave = 7857;
                t2.abrevehookabove = 7859;
                t2.abrevetilde = 7861;
                t2.acaron = 462;
                t2.acircle = 9424;
                t2.acircumflex = 226;
                t2.acircumflexacute = 7845;
                t2.acircumflexdotbelow = 7853;
                t2.acircumflexgrave = 7847;
                t2.acircumflexhookabove = 7849;
                t2.acircumflextilde = 7851;
                t2.acute = 180;
                t2.acutebelowcmb = 791;
                t2.acutecmb = 769;
                t2.acutecomb = 769;
                t2.acutedeva = 2388;
                t2.acutelowmod = 719;
                t2.acutetonecmb = 833;
                t2.acyrillic = 1072;
                t2.adblgrave = 513;
                t2.addakgurmukhi = 2673;
                t2.adeva = 2309;
                t2.adieresis = 228;
                t2.adieresiscyrillic = 1235;
                t2.adieresismacron = 479;
                t2.adotbelow = 7841;
                t2.adotmacron = 481;
                t2.ae = 230;
                t2.aeacute = 509;
                t2.aekorean = 12624;
                t2.aemacron = 483;
                t2.afii00208 = 8213;
                t2.afii08941 = 8356;
                t2.afii10017 = 1040;
                t2.afii10018 = 1041;
                t2.afii10019 = 1042;
                t2.afii10020 = 1043;
                t2.afii10021 = 1044;
                t2.afii10022 = 1045;
                t2.afii10023 = 1025;
                t2.afii10024 = 1046;
                t2.afii10025 = 1047;
                t2.afii10026 = 1048;
                t2.afii10027 = 1049;
                t2.afii10028 = 1050;
                t2.afii10029 = 1051;
                t2.afii10030 = 1052;
                t2.afii10031 = 1053;
                t2.afii10032 = 1054;
                t2.afii10033 = 1055;
                t2.afii10034 = 1056;
                t2.afii10035 = 1057;
                t2.afii10036 = 1058;
                t2.afii10037 = 1059;
                t2.afii10038 = 1060;
                t2.afii10039 = 1061;
                t2.afii10040 = 1062;
                t2.afii10041 = 1063;
                t2.afii10042 = 1064;
                t2.afii10043 = 1065;
                t2.afii10044 = 1066;
                t2.afii10045 = 1067;
                t2.afii10046 = 1068;
                t2.afii10047 = 1069;
                t2.afii10048 = 1070;
                t2.afii10049 = 1071;
                t2.afii10050 = 1168;
                t2.afii10051 = 1026;
                t2.afii10052 = 1027;
                t2.afii10053 = 1028;
                t2.afii10054 = 1029;
                t2.afii10055 = 1030;
                t2.afii10056 = 1031;
                t2.afii10057 = 1032;
                t2.afii10058 = 1033;
                t2.afii10059 = 1034;
                t2.afii10060 = 1035;
                t2.afii10061 = 1036;
                t2.afii10062 = 1038;
                t2.afii10063 = 63172;
                t2.afii10064 = 63173;
                t2.afii10065 = 1072;
                t2.afii10066 = 1073;
                t2.afii10067 = 1074;
                t2.afii10068 = 1075;
                t2.afii10069 = 1076;
                t2.afii10070 = 1077;
                t2.afii10071 = 1105;
                t2.afii10072 = 1078;
                t2.afii10073 = 1079;
                t2.afii10074 = 1080;
                t2.afii10075 = 1081;
                t2.afii10076 = 1082;
                t2.afii10077 = 1083;
                t2.afii10078 = 1084;
                t2.afii10079 = 1085;
                t2.afii10080 = 1086;
                t2.afii10081 = 1087;
                t2.afii10082 = 1088;
                t2.afii10083 = 1089;
                t2.afii10084 = 1090;
                t2.afii10085 = 1091;
                t2.afii10086 = 1092;
                t2.afii10087 = 1093;
                t2.afii10088 = 1094;
                t2.afii10089 = 1095;
                t2.afii10090 = 1096;
                t2.afii10091 = 1097;
                t2.afii10092 = 1098;
                t2.afii10093 = 1099;
                t2.afii10094 = 1100;
                t2.afii10095 = 1101;
                t2.afii10096 = 1102;
                t2.afii10097 = 1103;
                t2.afii10098 = 1169;
                t2.afii10099 = 1106;
                t2.afii10100 = 1107;
                t2.afii10101 = 1108;
                t2.afii10102 = 1109;
                t2.afii10103 = 1110;
                t2.afii10104 = 1111;
                t2.afii10105 = 1112;
                t2.afii10106 = 1113;
                t2.afii10107 = 1114;
                t2.afii10108 = 1115;
                t2.afii10109 = 1116;
                t2.afii10110 = 1118;
                t2.afii10145 = 1039;
                t2.afii10146 = 1122;
                t2.afii10147 = 1138;
                t2.afii10148 = 1140;
                t2.afii10192 = 63174;
                t2.afii10193 = 1119;
                t2.afii10194 = 1123;
                t2.afii10195 = 1139;
                t2.afii10196 = 1141;
                t2.afii10831 = 63175;
                t2.afii10832 = 63176;
                t2.afii10846 = 1241;
                t2.afii299 = 8206;
                t2.afii300 = 8207;
                t2.afii301 = 8205;
                t2.afii57381 = 1642;
                t2.afii57388 = 1548;
                t2.afii57392 = 1632;
                t2.afii57393 = 1633;
                t2.afii57394 = 1634;
                t2.afii57395 = 1635;
                t2.afii57396 = 1636;
                t2.afii57397 = 1637;
                t2.afii57398 = 1638;
                t2.afii57399 = 1639;
                t2.afii57400 = 1640;
                t2.afii57401 = 1641;
                t2.afii57403 = 1563;
                t2.afii57407 = 1567;
                t2.afii57409 = 1569;
                t2.afii57410 = 1570;
                t2.afii57411 = 1571;
                t2.afii57412 = 1572;
                t2.afii57413 = 1573;
                t2.afii57414 = 1574;
                t2.afii57415 = 1575;
                t2.afii57416 = 1576;
                t2.afii57417 = 1577;
                t2.afii57418 = 1578;
                t2.afii57419 = 1579;
                t2.afii57420 = 1580;
                t2.afii57421 = 1581;
                t2.afii57422 = 1582;
                t2.afii57423 = 1583;
                t2.afii57424 = 1584;
                t2.afii57425 = 1585;
                t2.afii57426 = 1586;
                t2.afii57427 = 1587;
                t2.afii57428 = 1588;
                t2.afii57429 = 1589;
                t2.afii57430 = 1590;
                t2.afii57431 = 1591;
                t2.afii57432 = 1592;
                t2.afii57433 = 1593;
                t2.afii57434 = 1594;
                t2.afii57440 = 1600;
                t2.afii57441 = 1601;
                t2.afii57442 = 1602;
                t2.afii57443 = 1603;
                t2.afii57444 = 1604;
                t2.afii57445 = 1605;
                t2.afii57446 = 1606;
                t2.afii57448 = 1608;
                t2.afii57449 = 1609;
                t2.afii57450 = 1610;
                t2.afii57451 = 1611;
                t2.afii57452 = 1612;
                t2.afii57453 = 1613;
                t2.afii57454 = 1614;
                t2.afii57455 = 1615;
                t2.afii57456 = 1616;
                t2.afii57457 = 1617;
                t2.afii57458 = 1618;
                t2.afii57470 = 1607;
                t2.afii57505 = 1700;
                t2.afii57506 = 1662;
                t2.afii57507 = 1670;
                t2.afii57508 = 1688;
                t2.afii57509 = 1711;
                t2.afii57511 = 1657;
                t2.afii57512 = 1672;
                t2.afii57513 = 1681;
                t2.afii57514 = 1722;
                t2.afii57519 = 1746;
                t2.afii57534 = 1749;
                t2.afii57636 = 8362;
                t2.afii57645 = 1470;
                t2.afii57658 = 1475;
                t2.afii57664 = 1488;
                t2.afii57665 = 1489;
                t2.afii57666 = 1490;
                t2.afii57667 = 1491;
                t2.afii57668 = 1492;
                t2.afii57669 = 1493;
                t2.afii57670 = 1494;
                t2.afii57671 = 1495;
                t2.afii57672 = 1496;
                t2.afii57673 = 1497;
                t2.afii57674 = 1498;
                t2.afii57675 = 1499;
                t2.afii57676 = 1500;
                t2.afii57677 = 1501;
                t2.afii57678 = 1502;
                t2.afii57679 = 1503;
                t2.afii57680 = 1504;
                t2.afii57681 = 1505;
                t2.afii57682 = 1506;
                t2.afii57683 = 1507;
                t2.afii57684 = 1508;
                t2.afii57685 = 1509;
                t2.afii57686 = 1510;
                t2.afii57687 = 1511;
                t2.afii57688 = 1512;
                t2.afii57689 = 1513;
                t2.afii57690 = 1514;
                t2.afii57694 = 64298;
                t2.afii57695 = 64299;
                t2.afii57700 = 64331;
                t2.afii57705 = 64287;
                t2.afii57716 = 1520;
                t2.afii57717 = 1521;
                t2.afii57718 = 1522;
                t2.afii57723 = 64309;
                t2.afii57793 = 1460;
                t2.afii57794 = 1461;
                t2.afii57795 = 1462;
                t2.afii57796 = 1467;
                t2.afii57797 = 1464;
                t2.afii57798 = 1463;
                t2.afii57799 = 1456;
                t2.afii57800 = 1458;
                t2.afii57801 = 1457;
                t2.afii57802 = 1459;
                t2.afii57803 = 1474;
                t2.afii57804 = 1473;
                t2.afii57806 = 1465;
                t2.afii57807 = 1468;
                t2.afii57839 = 1469;
                t2.afii57841 = 1471;
                t2.afii57842 = 1472;
                t2.afii57929 = 700;
                t2.afii61248 = 8453;
                t2.afii61289 = 8467;
                t2.afii61352 = 8470;
                t2.afii61573 = 8236;
                t2.afii61574 = 8237;
                t2.afii61575 = 8238;
                t2.afii61664 = 8204;
                t2.afii63167 = 1645;
                t2.afii64937 = 701;
                t2.agrave = 224;
                t2.agujarati = 2693;
                t2.agurmukhi = 2565;
                t2.ahiragana = 12354;
                t2.ahookabove = 7843;
                t2.aibengali = 2448;
                t2.aibopomofo = 12574;
                t2.aideva = 2320;
                t2.aiecyrillic = 1237;
                t2.aigujarati = 2704;
                t2.aigurmukhi = 2576;
                t2.aimatragurmukhi = 2632;
                t2.ainarabic = 1593;
                t2.ainfinalarabic = 65226;
                t2.aininitialarabic = 65227;
                t2.ainmedialarabic = 65228;
                t2.ainvertedbreve = 515;
                t2.aivowelsignbengali = 2504;
                t2.aivowelsigndeva = 2376;
                t2.aivowelsigngujarati = 2760;
                t2.akatakana = 12450;
                t2.akatakanahalfwidth = 65393;
                t2.akorean = 12623;
                t2.alef = 1488;
                t2.alefarabic = 1575;
                t2.alefdageshhebrew = 64304;
                t2.aleffinalarabic = 65166;
                t2.alefhamzaabovearabic = 1571;
                t2.alefhamzaabovefinalarabic = 65156;
                t2.alefhamzabelowarabic = 1573;
                t2.alefhamzabelowfinalarabic = 65160;
                t2.alefhebrew = 1488;
                t2.aleflamedhebrew = 64335;
                t2.alefmaddaabovearabic = 1570;
                t2.alefmaddaabovefinalarabic = 65154;
                t2.alefmaksuraarabic = 1609;
                t2.alefmaksurafinalarabic = 65264;
                t2.alefmaksurainitialarabic = 65267;
                t2.alefmaksuramedialarabic = 65268;
                t2.alefpatahhebrew = 64302;
                t2.alefqamatshebrew = 64303;
                t2.aleph = 8501;
                t2.allequal = 8780;
                t2.alpha = 945;
                t2.alphatonos = 940;
                t2.amacron = 257;
                t2.amonospace = 65345;
                t2.ampersand = 38;
                t2.ampersandmonospace = 65286;
                t2.ampersandsmall = 63270;
                t2.amsquare = 13250;
                t2.anbopomofo = 12578;
                t2.angbopomofo = 12580;
                t2.angbracketleft = 12296;
                t2.angbracketright = 12297;
                t2.angkhankhuthai = 3674;
                t2.angle = 8736;
                t2.anglebracketleft = 12296;
                t2.anglebracketleftvertical = 65087;
                t2.anglebracketright = 12297;
                t2.anglebracketrightvertical = 65088;
                t2.angleleft = 9001;
                t2.angleright = 9002;
                t2.angstrom = 8491;
                t2.anoteleia = 903;
                t2.anudattadeva = 2386;
                t2.anusvarabengali = 2434;
                t2.anusvaradeva = 2306;
                t2.anusvaragujarati = 2690;
                t2.aogonek = 261;
                t2.apaatosquare = 13056;
                t2.aparen = 9372;
                t2.apostrophearmenian = 1370;
                t2.apostrophemod = 700;
                t2.apple = 63743;
                t2.approaches = 8784;
                t2.approxequal = 8776;
                t2.approxequalorimage = 8786;
                t2.approximatelyequal = 8773;
                t2.araeaekorean = 12686;
                t2.araeakorean = 12685;
                t2.arc = 8978;
                t2.arighthalfring = 7834;
                t2.aring = 229;
                t2.aringacute = 507;
                t2.aringbelow = 7681;
                t2.arrowboth = 8596;
                t2.arrowdashdown = 8675;
                t2.arrowdashleft = 8672;
                t2.arrowdashright = 8674;
                t2.arrowdashup = 8673;
                t2.arrowdblboth = 8660;
                t2.arrowdbldown = 8659;
                t2.arrowdblleft = 8656;
                t2.arrowdblright = 8658;
                t2.arrowdblup = 8657;
                t2.arrowdown = 8595;
                t2.arrowdownleft = 8601;
                t2.arrowdownright = 8600;
                t2.arrowdownwhite = 8681;
                t2.arrowheaddownmod = 709;
                t2.arrowheadleftmod = 706;
                t2.arrowheadrightmod = 707;
                t2.arrowheadupmod = 708;
                t2.arrowhorizex = 63719;
                t2.arrowleft = 8592;
                t2.arrowleftdbl = 8656;
                t2.arrowleftdblstroke = 8653;
                t2.arrowleftoverright = 8646;
                t2.arrowleftwhite = 8678;
                t2.arrowright = 8594;
                t2.arrowrightdblstroke = 8655;
                t2.arrowrightheavy = 10142;
                t2.arrowrightoverleft = 8644;
                t2.arrowrightwhite = 8680;
                t2.arrowtableft = 8676;
                t2.arrowtabright = 8677;
                t2.arrowup = 8593;
                t2.arrowupdn = 8597;
                t2.arrowupdnbse = 8616;
                t2.arrowupdownbase = 8616;
                t2.arrowupleft = 8598;
                t2.arrowupleftofdown = 8645;
                t2.arrowupright = 8599;
                t2.arrowupwhite = 8679;
                t2.arrowvertex = 63718;
                t2.asciicircum = 94;
                t2.asciicircummonospace = 65342;
                t2.asciitilde = 126;
                t2.asciitildemonospace = 65374;
                t2.ascript = 593;
                t2.ascriptturned = 594;
                t2.asmallhiragana = 12353;
                t2.asmallkatakana = 12449;
                t2.asmallkatakanahalfwidth = 65383;
                t2.asterisk = 42;
                t2.asteriskaltonearabic = 1645;
                t2.asteriskarabic = 1645;
                t2.asteriskmath = 8727;
                t2.asteriskmonospace = 65290;
                t2.asterisksmall = 65121;
                t2.asterism = 8258;
                t2.asuperior = 63209;
                t2.asymptoticallyequal = 8771;
                t2.at = 64;
                t2.atilde = 227;
                t2.atmonospace = 65312;
                t2.atsmall = 65131;
                t2.aturned = 592;
                t2.aubengali = 2452;
                t2.aubopomofo = 12576;
                t2.audeva = 2324;
                t2.augujarati = 2708;
                t2.augurmukhi = 2580;
                t2.aulengthmarkbengali = 2519;
                t2.aumatragurmukhi = 2636;
                t2.auvowelsignbengali = 2508;
                t2.auvowelsigndeva = 2380;
                t2.auvowelsigngujarati = 2764;
                t2.avagrahadeva = 2365;
                t2.aybarmenian = 1377;
                t2.ayin = 1506;
                t2.ayinaltonehebrew = 64288;
                t2.ayinhebrew = 1506;
                t2.b = 98;
                t2.babengali = 2476;
                t2.backslash = 92;
                t2.backslashmonospace = 65340;
                t2.badeva = 2348;
                t2.bagujarati = 2732;
                t2.bagurmukhi = 2604;
                t2.bahiragana = 12400;
                t2.bahtthai = 3647;
                t2.bakatakana = 12496;
                t2.bar = 124;
                t2.barmonospace = 65372;
                t2.bbopomofo = 12549;
                t2.bcircle = 9425;
                t2.bdotaccent = 7683;
                t2.bdotbelow = 7685;
                t2.beamedsixteenthnotes = 9836;
                t2.because = 8757;
                t2.becyrillic = 1073;
                t2.beharabic = 1576;
                t2.behfinalarabic = 65168;
                t2.behinitialarabic = 65169;
                t2.behiragana = 12409;
                t2.behmedialarabic = 65170;
                t2.behmeeminitialarabic = 64671;
                t2.behmeemisolatedarabic = 64520;
                t2.behnoonfinalarabic = 64621;
                t2.bekatakana = 12505;
                t2.benarmenian = 1378;
                t2.bet = 1489;
                t2.beta = 946;
                t2.betasymbolgreek = 976;
                t2.betdagesh = 64305;
                t2.betdageshhebrew = 64305;
                t2.bethebrew = 1489;
                t2.betrafehebrew = 64332;
                t2.bhabengali = 2477;
                t2.bhadeva = 2349;
                t2.bhagujarati = 2733;
                t2.bhagurmukhi = 2605;
                t2.bhook = 595;
                t2.bihiragana = 12403;
                t2.bikatakana = 12499;
                t2.bilabialclick = 664;
                t2.bindigurmukhi = 2562;
                t2.birusquare = 13105;
                t2.blackcircle = 9679;
                t2.blackdiamond = 9670;
                t2.blackdownpointingtriangle = 9660;
                t2.blackleftpointingpointer = 9668;
                t2.blackleftpointingtriangle = 9664;
                t2.blacklenticularbracketleft = 12304;
                t2.blacklenticularbracketleftvertical = 65083;
                t2.blacklenticularbracketright = 12305;
                t2.blacklenticularbracketrightvertical = 65084;
                t2.blacklowerlefttriangle = 9699;
                t2.blacklowerrighttriangle = 9698;
                t2.blackrectangle = 9644;
                t2.blackrightpointingpointer = 9658;
                t2.blackrightpointingtriangle = 9654;
                t2.blacksmallsquare = 9642;
                t2.blacksmilingface = 9787;
                t2.blacksquare = 9632;
                t2.blackstar = 9733;
                t2.blackupperlefttriangle = 9700;
                t2.blackupperrighttriangle = 9701;
                t2.blackuppointingsmalltriangle = 9652;
                t2.blackuppointingtriangle = 9650;
                t2.blank = 9251;
                t2.blinebelow = 7687;
                t2.block = 9608;
                t2.bmonospace = 65346;
                t2.bobaimaithai = 3610;
                t2.bohiragana = 12412;
                t2.bokatakana = 12508;
                t2.bparen = 9373;
                t2.bqsquare = 13251;
                t2.braceex = 63732;
                t2.braceleft = 123;
                t2.braceleftbt = 63731;
                t2.braceleftmid = 63730;
                t2.braceleftmonospace = 65371;
                t2.braceleftsmall = 65115;
                t2.bracelefttp = 63729;
                t2.braceleftvertical = 65079;
                t2.braceright = 125;
                t2.bracerightbt = 63742;
                t2.bracerightmid = 63741;
                t2.bracerightmonospace = 65373;
                t2.bracerightsmall = 65116;
                t2.bracerighttp = 63740;
                t2.bracerightvertical = 65080;
                t2.bracketleft = 91;
                t2.bracketleftbt = 63728;
                t2.bracketleftex = 63727;
                t2.bracketleftmonospace = 65339;
                t2.bracketlefttp = 63726;
                t2.bracketright = 93;
                t2.bracketrightbt = 63739;
                t2.bracketrightex = 63738;
                t2.bracketrightmonospace = 65341;
                t2.bracketrighttp = 63737;
                t2.breve = 728;
                t2.brevebelowcmb = 814;
                t2.brevecmb = 774;
                t2.breveinvertedbelowcmb = 815;
                t2.breveinvertedcmb = 785;
                t2.breveinverteddoublecmb = 865;
                t2.bridgebelowcmb = 810;
                t2.bridgeinvertedbelowcmb = 826;
                t2.brokenbar = 166;
                t2.bstroke = 384;
                t2.bsuperior = 63210;
                t2.btopbar = 387;
                t2.buhiragana = 12406;
                t2.bukatakana = 12502;
                t2.bullet = 8226;
                t2.bulletinverse = 9688;
                t2.bulletoperator = 8729;
                t2.bullseye = 9678;
                t2.c = 99;
                t2.caarmenian = 1390;
                t2.cabengali = 2458;
                t2.cacute = 263;
                t2.cadeva = 2330;
                t2.cagujarati = 2714;
                t2.cagurmukhi = 2586;
                t2.calsquare = 13192;
                t2.candrabindubengali = 2433;
                t2.candrabinducmb = 784;
                t2.candrabindudeva = 2305;
                t2.candrabindugujarati = 2689;
                t2.capslock = 8682;
                t2.careof = 8453;
                t2.caron = 711;
                t2.caronbelowcmb = 812;
                t2.caroncmb = 780;
                t2.carriagereturn = 8629;
                t2.cbopomofo = 12568;
                t2.ccaron = 269;
                t2.ccedilla = 231;
                t2.ccedillaacute = 7689;
                t2.ccircle = 9426;
                t2.ccircumflex = 265;
                t2.ccurl = 597;
                t2.cdot = 267;
                t2.cdotaccent = 267;
                t2.cdsquare = 13253;
                t2.cedilla = 184;
                t2.cedillacmb = 807;
                t2.cent = 162;
                t2.centigrade = 8451;
                t2.centinferior = 63199;
                t2.centmonospace = 65504;
                t2.centoldstyle = 63394;
                t2.centsuperior = 63200;
                t2.chaarmenian = 1401;
                t2.chabengali = 2459;
                t2.chadeva = 2331;
                t2.chagujarati = 2715;
                t2.chagurmukhi = 2587;
                t2.chbopomofo = 12564;
                t2.cheabkhasiancyrillic = 1213;
                t2.checkmark = 10003;
                t2.checyrillic = 1095;
                t2.chedescenderabkhasiancyrillic = 1215;
                t2.chedescendercyrillic = 1207;
                t2.chedieresiscyrillic = 1269;
                t2.cheharmenian = 1395;
                t2.chekhakassiancyrillic = 1228;
                t2.cheverticalstrokecyrillic = 1209;
                t2.chi = 967;
                t2.chieuchacirclekorean = 12919;
                t2.chieuchaparenkorean = 12823;
                t2.chieuchcirclekorean = 12905;
                t2.chieuchkorean = 12618;
                t2.chieuchparenkorean = 12809;
                t2.chochangthai = 3594;
                t2.chochanthai = 3592;
                t2.chochingthai = 3593;
                t2.chochoethai = 3596;
                t2.chook = 392;
                t2.cieucacirclekorean = 12918;
                t2.cieucaparenkorean = 12822;
                t2.cieuccirclekorean = 12904;
                t2.cieuckorean = 12616;
                t2.cieucparenkorean = 12808;
                t2.cieucuparenkorean = 12828;
                t2.circle = 9675;
                t2.circlecopyrt = 169;
                t2.circlemultiply = 8855;
                t2.circleot = 8857;
                t2.circleplus = 8853;
                t2.circlepostalmark = 12342;
                t2.circlewithlefthalfblack = 9680;
                t2.circlewithrighthalfblack = 9681;
                t2.circumflex = 710;
                t2.circumflexbelowcmb = 813;
                t2.circumflexcmb = 770;
                t2.clear = 8999;
                t2.clickalveolar = 450;
                t2.clickdental = 448;
                t2.clicklateral = 449;
                t2.clickretroflex = 451;
                t2.club = 9827;
                t2.clubsuitblack = 9827;
                t2.clubsuitwhite = 9831;
                t2.cmcubedsquare = 13220;
                t2.cmonospace = 65347;
                t2.cmsquaredsquare = 13216;
                t2.coarmenian = 1409;
                t2.colon = 58;
                t2.colonmonetary = 8353;
                t2.colonmonospace = 65306;
                t2.colonsign = 8353;
                t2.colonsmall = 65109;
                t2.colontriangularhalfmod = 721;
                t2.colontriangularmod = 720;
                t2.comma = 44;
                t2.commaabovecmb = 787;
                t2.commaaboverightcmb = 789;
                t2.commaaccent = 63171;
                t2.commaarabic = 1548;
                t2.commaarmenian = 1373;
                t2.commainferior = 63201;
                t2.commamonospace = 65292;
                t2.commareversedabovecmb = 788;
                t2.commareversedmod = 701;
                t2.commasmall = 65104;
                t2.commasuperior = 63202;
                t2.commaturnedabovecmb = 786;
                t2.commaturnedmod = 699;
                t2.compass = 9788;
                t2.congruent = 8773;
                t2.contourintegral = 8750;
                t2.control = 8963;
                t2.controlACK = 6;
                t2.controlBEL = 7;
                t2.controlBS = 8;
                t2.controlCAN = 24;
                t2.controlCR = 13;
                t2.controlDC1 = 17;
                t2.controlDC2 = 18;
                t2.controlDC3 = 19;
                t2.controlDC4 = 20;
                t2.controlDEL = 127;
                t2.controlDLE = 16;
                t2.controlEM = 25;
                t2.controlENQ = 5;
                t2.controlEOT = 4;
                t2.controlESC = 27;
                t2.controlETB = 23;
                t2.controlETX = 3;
                t2.controlFF = 12;
                t2.controlFS = 28;
                t2.controlGS = 29;
                t2.controlHT = 9;
                t2.controlLF = 10;
                t2.controlNAK = 21;
                t2.controlNULL = 0;
                t2.controlRS = 30;
                t2.controlSI = 15;
                t2.controlSO = 14;
                t2.controlSOT = 2;
                t2.controlSTX = 1;
                t2.controlSUB = 26;
                t2.controlSYN = 22;
                t2.controlUS = 31;
                t2.controlVT = 11;
                t2.copyright = 169;
                t2.copyrightsans = 63721;
                t2.copyrightserif = 63193;
                t2.cornerbracketleft = 12300;
                t2.cornerbracketlefthalfwidth = 65378;
                t2.cornerbracketleftvertical = 65089;
                t2.cornerbracketright = 12301;
                t2.cornerbracketrighthalfwidth = 65379;
                t2.cornerbracketrightvertical = 65090;
                t2.corporationsquare = 13183;
                t2.cosquare = 13255;
                t2.coverkgsquare = 13254;
                t2.cparen = 9374;
                t2.cruzeiro = 8354;
                t2.cstretched = 663;
                t2.curlyand = 8911;
                t2.curlyor = 8910;
                t2.currency = 164;
                t2.cyrBreve = 63185;
                t2.cyrFlex = 63186;
                t2.cyrbreve = 63188;
                t2.cyrflex = 63189;
                t2.d = 100;
                t2.daarmenian = 1380;
                t2.dabengali = 2470;
                t2.dadarabic = 1590;
                t2.dadeva = 2342;
                t2.dadfinalarabic = 65214;
                t2.dadinitialarabic = 65215;
                t2.dadmedialarabic = 65216;
                t2.dagesh = 1468;
                t2.dageshhebrew = 1468;
                t2.dagger = 8224;
                t2.daggerdbl = 8225;
                t2.dagujarati = 2726;
                t2.dagurmukhi = 2598;
                t2.dahiragana = 12384;
                t2.dakatakana = 12480;
                t2.dalarabic = 1583;
                t2.dalet = 1491;
                t2.daletdagesh = 64307;
                t2.daletdageshhebrew = 64307;
                t2.dalethebrew = 1491;
                t2.dalfinalarabic = 65194;
                t2.dammaarabic = 1615;
                t2.dammalowarabic = 1615;
                t2.dammatanaltonearabic = 1612;
                t2.dammatanarabic = 1612;
                t2.danda = 2404;
                t2.dargahebrew = 1447;
                t2.dargalefthebrew = 1447;
                t2.dasiapneumatacyrilliccmb = 1157;
                t2.dblGrave = 63187;
                t2.dblanglebracketleft = 12298;
                t2.dblanglebracketleftvertical = 65085;
                t2.dblanglebracketright = 12299;
                t2.dblanglebracketrightvertical = 65086;
                t2.dblarchinvertedbelowcmb = 811;
                t2.dblarrowleft = 8660;
                t2.dblarrowright = 8658;
                t2.dbldanda = 2405;
                t2.dblgrave = 63190;
                t2.dblgravecmb = 783;
                t2.dblintegral = 8748;
                t2.dbllowline = 8215;
                t2.dbllowlinecmb = 819;
                t2.dbloverlinecmb = 831;
                t2.dblprimemod = 698;
                t2.dblverticalbar = 8214;
                t2.dblverticallineabovecmb = 782;
                t2.dbopomofo = 12553;
                t2.dbsquare = 13256;
                t2.dcaron = 271;
                t2.dcedilla = 7697;
                t2.dcircle = 9427;
                t2.dcircumflexbelow = 7699;
                t2.dcroat = 273;
                t2.ddabengali = 2465;
                t2.ddadeva = 2337;
                t2.ddagujarati = 2721;
                t2.ddagurmukhi = 2593;
                t2.ddalarabic = 1672;
                t2.ddalfinalarabic = 64393;
                t2.dddhadeva = 2396;
                t2.ddhabengali = 2466;
                t2.ddhadeva = 2338;
                t2.ddhagujarati = 2722;
                t2.ddhagurmukhi = 2594;
                t2.ddotaccent = 7691;
                t2.ddotbelow = 7693;
                t2.decimalseparatorarabic = 1643;
                t2.decimalseparatorpersian = 1643;
                t2.decyrillic = 1076;
                t2.degree = 176;
                t2.dehihebrew = 1453;
                t2.dehiragana = 12391;
                t2.deicoptic = 1007;
                t2.dekatakana = 12487;
                t2.deleteleft = 9003;
                t2.deleteright = 8998;
                t2.delta = 948;
                t2.deltaturned = 397;
                t2.denominatorminusonenumeratorbengali = 2552;
                t2.dezh = 676;
                t2.dhabengali = 2471;
                t2.dhadeva = 2343;
                t2.dhagujarati = 2727;
                t2.dhagurmukhi = 2599;
                t2.dhook = 599;
                t2.dialytikatonos = 901;
                t2.dialytikatonoscmb = 836;
                t2.diamond = 9830;
                t2.diamondsuitwhite = 9826;
                t2.dieresis = 168;
                t2.dieresisacute = 63191;
                t2.dieresisbelowcmb = 804;
                t2.dieresiscmb = 776;
                t2.dieresisgrave = 63192;
                t2.dieresistonos = 901;
                t2.dihiragana = 12386;
                t2.dikatakana = 12482;
                t2.dittomark = 12291;
                t2.divide = 247;
                t2.divides = 8739;
                t2.divisionslash = 8725;
                t2.djecyrillic = 1106;
                t2.dkshade = 9619;
                t2.dlinebelow = 7695;
                t2.dlsquare = 13207;
                t2.dmacron = 273;
                t2.dmonospace = 65348;
                t2.dnblock = 9604;
                t2.dochadathai = 3598;
                t2.dodekthai = 3604;
                t2.dohiragana = 12393;
                t2.dokatakana = 12489;
                t2.dollar = 36;
                t2.dollarinferior = 63203;
                t2.dollarmonospace = 65284;
                t2.dollaroldstyle = 63268;
                t2.dollarsmall = 65129;
                t2.dollarsuperior = 63204;
                t2.dong = 8363;
                t2.dorusquare = 13094;
                t2.dotaccent = 729;
                t2.dotaccentcmb = 775;
                t2.dotbelowcmb = 803;
                t2.dotbelowcomb = 803;
                t2.dotkatakana = 12539;
                t2.dotlessi = 305;
                t2.dotlessj = 63166;
                t2.dotlessjstrokehook = 644;
                t2.dotmath = 8901;
                t2.dottedcircle = 9676;
                t2.doubleyodpatah = 64287;
                t2.doubleyodpatahhebrew = 64287;
                t2.downtackbelowcmb = 798;
                t2.downtackmod = 725;
                t2.dparen = 9375;
                t2.dsuperior = 63211;
                t2.dtail = 598;
                t2.dtopbar = 396;
                t2.duhiragana = 12389;
                t2.dukatakana = 12485;
                t2.dz = 499;
                t2.dzaltone = 675;
                t2.dzcaron = 454;
                t2.dzcurl = 677;
                t2.dzeabkhasiancyrillic = 1249;
                t2.dzecyrillic = 1109;
                t2.dzhecyrillic = 1119;
                t2.e = 101;
                t2.eacute = 233;
                t2.earth = 9793;
                t2.ebengali = 2447;
                t2.ebopomofo = 12572;
                t2.ebreve = 277;
                t2.ecandradeva = 2317;
                t2.ecandragujarati = 2701;
                t2.ecandravowelsigndeva = 2373;
                t2.ecandravowelsigngujarati = 2757;
                t2.ecaron = 283;
                t2.ecedillabreve = 7709;
                t2.echarmenian = 1381;
                t2.echyiwnarmenian = 1415;
                t2.ecircle = 9428;
                t2.ecircumflex = 234;
                t2.ecircumflexacute = 7871;
                t2.ecircumflexbelow = 7705;
                t2.ecircumflexdotbelow = 7879;
                t2.ecircumflexgrave = 7873;
                t2.ecircumflexhookabove = 7875;
                t2.ecircumflextilde = 7877;
                t2.ecyrillic = 1108;
                t2.edblgrave = 517;
                t2.edeva = 2319;
                t2.edieresis = 235;
                t2.edot = 279;
                t2.edotaccent = 279;
                t2.edotbelow = 7865;
                t2.eegurmukhi = 2575;
                t2.eematragurmukhi = 2631;
                t2.efcyrillic = 1092;
                t2.egrave = 232;
                t2.egujarati = 2703;
                t2.eharmenian = 1383;
                t2.ehbopomofo = 12573;
                t2.ehiragana = 12360;
                t2.ehookabove = 7867;
                t2.eibopomofo = 12575;
                t2.eight = 56;
                t2.eightarabic = 1640;
                t2.eightbengali = 2542;
                t2.eightcircle = 9319;
                t2.eightcircleinversesansserif = 10129;
                t2.eightdeva = 2414;
                t2.eighteencircle = 9329;
                t2.eighteenparen = 9349;
                t2.eighteenperiod = 9369;
                t2.eightgujarati = 2798;
                t2.eightgurmukhi = 2670;
                t2.eighthackarabic = 1640;
                t2.eighthangzhou = 12328;
                t2.eighthnotebeamed = 9835;
                t2.eightideographicparen = 12839;
                t2.eightinferior = 8328;
                t2.eightmonospace = 65304;
                t2.eightoldstyle = 63288;
                t2.eightparen = 9339;
                t2.eightperiod = 9359;
                t2.eightpersian = 1784;
                t2.eightroman = 8567;
                t2.eightsuperior = 8312;
                t2.eightthai = 3672;
                t2.einvertedbreve = 519;
                t2.eiotifiedcyrillic = 1125;
                t2.ekatakana = 12456;
                t2.ekatakanahalfwidth = 65396;
                t2.ekonkargurmukhi = 2676;
                t2.ekorean = 12628;
                t2.elcyrillic = 1083;
                t2.element = 8712;
                t2.elevencircle = 9322;
                t2.elevenparen = 9342;
                t2.elevenperiod = 9362;
                t2.elevenroman = 8570;
                t2.ellipsis = 8230;
                t2.ellipsisvertical = 8942;
                t2.emacron = 275;
                t2.emacronacute = 7703;
                t2.emacrongrave = 7701;
                t2.emcyrillic = 1084;
                t2.emdash = 8212;
                t2.emdashvertical = 65073;
                t2.emonospace = 65349;
                t2.emphasismarkarmenian = 1371;
                t2.emptyset = 8709;
                t2.enbopomofo = 12579;
                t2.encyrillic = 1085;
                t2.endash = 8211;
                t2.endashvertical = 65074;
                t2.endescendercyrillic = 1187;
                t2.eng = 331;
                t2.engbopomofo = 12581;
                t2.enghecyrillic = 1189;
                t2.enhookcyrillic = 1224;
                t2.enspace = 8194;
                t2.eogonek = 281;
                t2.eokorean = 12627;
                t2.eopen = 603;
                t2.eopenclosed = 666;
                t2.eopenreversed = 604;
                t2.eopenreversedclosed = 606;
                t2.eopenreversedhook = 605;
                t2.eparen = 9376;
                t2.epsilon = 949;
                t2.epsilontonos = 941;
                t2.equal = 61;
                t2.equalmonospace = 65309;
                t2.equalsmall = 65126;
                t2.equalsuperior = 8316;
                t2.equivalence = 8801;
                t2.erbopomofo = 12582;
                t2.ercyrillic = 1088;
                t2.ereversed = 600;
                t2.ereversedcyrillic = 1101;
                t2.escyrillic = 1089;
                t2.esdescendercyrillic = 1195;
                t2.esh = 643;
                t2.eshcurl = 646;
                t2.eshortdeva = 2318;
                t2.eshortvowelsigndeva = 2374;
                t2.eshreversedloop = 426;
                t2.eshsquatreversed = 645;
                t2.esmallhiragana = 12359;
                t2.esmallkatakana = 12455;
                t2.esmallkatakanahalfwidth = 65386;
                t2.estimated = 8494;
                t2.esuperior = 63212;
                t2.eta = 951;
                t2.etarmenian = 1384;
                t2.etatonos = 942;
                t2.eth = 240;
                t2.etilde = 7869;
                t2.etildebelow = 7707;
                t2.etnahtafoukhhebrew = 1425;
                t2.etnahtafoukhlefthebrew = 1425;
                t2.etnahtahebrew = 1425;
                t2.etnahtalefthebrew = 1425;
                t2.eturned = 477;
                t2.eukorean = 12641;
                t2.euro = 8364;
                t2.evowelsignbengali = 2503;
                t2.evowelsigndeva = 2375;
                t2.evowelsigngujarati = 2759;
                t2.exclam = 33;
                t2.exclamarmenian = 1372;
                t2.exclamdbl = 8252;
                t2.exclamdown = 161;
                t2.exclamdownsmall = 63393;
                t2.exclammonospace = 65281;
                t2.exclamsmall = 63265;
                t2.existential = 8707;
                t2.ezh = 658;
                t2.ezhcaron = 495;
                t2.ezhcurl = 659;
                t2.ezhreversed = 441;
                t2.ezhtail = 442;
                t2.f = 102;
                t2.fadeva = 2398;
                t2.fagurmukhi = 2654;
                t2.fahrenheit = 8457;
                t2.fathaarabic = 1614;
                t2.fathalowarabic = 1614;
                t2.fathatanarabic = 1611;
                t2.fbopomofo = 12552;
                t2.fcircle = 9429;
                t2.fdotaccent = 7711;
                t2.feharabic = 1601;
                t2.feharmenian = 1414;
                t2.fehfinalarabic = 65234;
                t2.fehinitialarabic = 65235;
                t2.fehmedialarabic = 65236;
                t2.feicoptic = 997;
                t2.female = 9792;
                t2.ff = 64256;
                t2.f_f = 64256;
                t2.ffi = 64259;
                t2.f_f_i = 64259;
                t2.ffl = 64260;
                t2.f_f_l = 64260;
                t2.fi = 64257;
                t2.f_i = 64257;
                t2.fifteencircle = 9326;
                t2.fifteenparen = 9346;
                t2.fifteenperiod = 9366;
                t2.figuredash = 8210;
                t2.filledbox = 9632;
                t2.filledrect = 9644;
                t2.finalkaf = 1498;
                t2.finalkafdagesh = 64314;
                t2.finalkafdageshhebrew = 64314;
                t2.finalkafhebrew = 1498;
                t2.finalmem = 1501;
                t2.finalmemhebrew = 1501;
                t2.finalnun = 1503;
                t2.finalnunhebrew = 1503;
                t2.finalpe = 1507;
                t2.finalpehebrew = 1507;
                t2.finaltsadi = 1509;
                t2.finaltsadihebrew = 1509;
                t2.firsttonechinese = 713;
                t2.fisheye = 9673;
                t2.fitacyrillic = 1139;
                t2.five = 53;
                t2.fivearabic = 1637;
                t2.fivebengali = 2539;
                t2.fivecircle = 9316;
                t2.fivecircleinversesansserif = 10126;
                t2.fivedeva = 2411;
                t2.fiveeighths = 8541;
                t2.fivegujarati = 2795;
                t2.fivegurmukhi = 2667;
                t2.fivehackarabic = 1637;
                t2.fivehangzhou = 12325;
                t2.fiveideographicparen = 12836;
                t2.fiveinferior = 8325;
                t2.fivemonospace = 65301;
                t2.fiveoldstyle = 63285;
                t2.fiveparen = 9336;
                t2.fiveperiod = 9356;
                t2.fivepersian = 1781;
                t2.fiveroman = 8564;
                t2.fivesuperior = 8309;
                t2.fivethai = 3669;
                t2.fl = 64258;
                t2.f_l = 64258;
                t2.florin = 402;
                t2.fmonospace = 65350;
                t2.fmsquare = 13209;
                t2.fofanthai = 3615;
                t2.fofathai = 3613;
                t2.fongmanthai = 3663;
                t2.forall = 8704;
                t2.four = 52;
                t2.fourarabic = 1636;
                t2.fourbengali = 2538;
                t2.fourcircle = 9315;
                t2.fourcircleinversesansserif = 10125;
                t2.fourdeva = 2410;
                t2.fourgujarati = 2794;
                t2.fourgurmukhi = 2666;
                t2.fourhackarabic = 1636;
                t2.fourhangzhou = 12324;
                t2.fourideographicparen = 12835;
                t2.fourinferior = 8324;
                t2.fourmonospace = 65300;
                t2.fournumeratorbengali = 2551;
                t2.fouroldstyle = 63284;
                t2.fourparen = 9335;
                t2.fourperiod = 9355;
                t2.fourpersian = 1780;
                t2.fourroman = 8563;
                t2.foursuperior = 8308;
                t2.fourteencircle = 9325;
                t2.fourteenparen = 9345;
                t2.fourteenperiod = 9365;
                t2.fourthai = 3668;
                t2.fourthtonechinese = 715;
                t2.fparen = 9377;
                t2.fraction = 8260;
                t2.franc = 8355;
                t2.g = 103;
                t2.gabengali = 2455;
                t2.gacute = 501;
                t2.gadeva = 2327;
                t2.gafarabic = 1711;
                t2.gaffinalarabic = 64403;
                t2.gafinitialarabic = 64404;
                t2.gafmedialarabic = 64405;
                t2.gagujarati = 2711;
                t2.gagurmukhi = 2583;
                t2.gahiragana = 12364;
                t2.gakatakana = 12460;
                t2.gamma = 947;
                t2.gammalatinsmall = 611;
                t2.gammasuperior = 736;
                t2.gangiacoptic = 1003;
                t2.gbopomofo = 12557;
                t2.gbreve = 287;
                t2.gcaron = 487;
                t2.gcedilla = 291;
                t2.gcircle = 9430;
                t2.gcircumflex = 285;
                t2.gcommaaccent = 291;
                t2.gdot = 289;
                t2.gdotaccent = 289;
                t2.gecyrillic = 1075;
                t2.gehiragana = 12370;
                t2.gekatakana = 12466;
                t2.geometricallyequal = 8785;
                t2.gereshaccenthebrew = 1436;
                t2.gereshhebrew = 1523;
                t2.gereshmuqdamhebrew = 1437;
                t2.germandbls = 223;
                t2.gershayimaccenthebrew = 1438;
                t2.gershayimhebrew = 1524;
                t2.getamark = 12307;
                t2.ghabengali = 2456;
                t2.ghadarmenian = 1394;
                t2.ghadeva = 2328;
                t2.ghagujarati = 2712;
                t2.ghagurmukhi = 2584;
                t2.ghainarabic = 1594;
                t2.ghainfinalarabic = 65230;
                t2.ghaininitialarabic = 65231;
                t2.ghainmedialarabic = 65232;
                t2.ghemiddlehookcyrillic = 1173;
                t2.ghestrokecyrillic = 1171;
                t2.gheupturncyrillic = 1169;
                t2.ghhadeva = 2394;
                t2.ghhagurmukhi = 2650;
                t2.ghook = 608;
                t2.ghzsquare = 13203;
                t2.gihiragana = 12366;
                t2.gikatakana = 12462;
                t2.gimarmenian = 1379;
                t2.gimel = 1490;
                t2.gimeldagesh = 64306;
                t2.gimeldageshhebrew = 64306;
                t2.gimelhebrew = 1490;
                t2.gjecyrillic = 1107;
                t2.glottalinvertedstroke = 446;
                t2.glottalstop = 660;
                t2.glottalstopinverted = 662;
                t2.glottalstopmod = 704;
                t2.glottalstopreversed = 661;
                t2.glottalstopreversedmod = 705;
                t2.glottalstopreversedsuperior = 740;
                t2.glottalstopstroke = 673;
                t2.glottalstopstrokereversed = 674;
                t2.gmacron = 7713;
                t2.gmonospace = 65351;
                t2.gohiragana = 12372;
                t2.gokatakana = 12468;
                t2.gparen = 9378;
                t2.gpasquare = 13228;
                t2.gradient = 8711;
                t2.grave = 96;
                t2.gravebelowcmb = 790;
                t2.gravecmb = 768;
                t2.gravecomb = 768;
                t2.gravedeva = 2387;
                t2.gravelowmod = 718;
                t2.gravemonospace = 65344;
                t2.gravetonecmb = 832;
                t2.greater = 62;
                t2.greaterequal = 8805;
                t2.greaterequalorless = 8923;
                t2.greatermonospace = 65310;
                t2.greaterorequivalent = 8819;
                t2.greaterorless = 8823;
                t2.greateroverequal = 8807;
                t2.greatersmall = 65125;
                t2.gscript = 609;
                t2.gstroke = 485;
                t2.guhiragana = 12368;
                t2.guillemotleft = 171;
                t2.guillemotright = 187;
                t2.guilsinglleft = 8249;
                t2.guilsinglright = 8250;
                t2.gukatakana = 12464;
                t2.guramusquare = 13080;
                t2.gysquare = 13257;
                t2.h = 104;
                t2.haabkhasiancyrillic = 1193;
                t2.haaltonearabic = 1729;
                t2.habengali = 2489;
                t2.hadescendercyrillic = 1203;
                t2.hadeva = 2361;
                t2.hagujarati = 2745;
                t2.hagurmukhi = 2617;
                t2.haharabic = 1581;
                t2.hahfinalarabic = 65186;
                t2.hahinitialarabic = 65187;
                t2.hahiragana = 12399;
                t2.hahmedialarabic = 65188;
                t2.haitusquare = 13098;
                t2.hakatakana = 12495;
                t2.hakatakanahalfwidth = 65418;
                t2.halantgurmukhi = 2637;
                t2.hamzaarabic = 1569;
                t2.hamzalowarabic = 1569;
                t2.hangulfiller = 12644;
                t2.hardsigncyrillic = 1098;
                t2.harpoonleftbarbup = 8636;
                t2.harpoonrightbarbup = 8640;
                t2.hasquare = 13258;
                t2.hatafpatah = 1458;
                t2.hatafpatah16 = 1458;
                t2.hatafpatah23 = 1458;
                t2.hatafpatah2f = 1458;
                t2.hatafpatahhebrew = 1458;
                t2.hatafpatahnarrowhebrew = 1458;
                t2.hatafpatahquarterhebrew = 1458;
                t2.hatafpatahwidehebrew = 1458;
                t2.hatafqamats = 1459;
                t2.hatafqamats1b = 1459;
                t2.hatafqamats28 = 1459;
                t2.hatafqamats34 = 1459;
                t2.hatafqamatshebrew = 1459;
                t2.hatafqamatsnarrowhebrew = 1459;
                t2.hatafqamatsquarterhebrew = 1459;
                t2.hatafqamatswidehebrew = 1459;
                t2.hatafsegol = 1457;
                t2.hatafsegol17 = 1457;
                t2.hatafsegol24 = 1457;
                t2.hatafsegol30 = 1457;
                t2.hatafsegolhebrew = 1457;
                t2.hatafsegolnarrowhebrew = 1457;
                t2.hatafsegolquarterhebrew = 1457;
                t2.hatafsegolwidehebrew = 1457;
                t2.hbar = 295;
                t2.hbopomofo = 12559;
                t2.hbrevebelow = 7723;
                t2.hcedilla = 7721;
                t2.hcircle = 9431;
                t2.hcircumflex = 293;
                t2.hdieresis = 7719;
                t2.hdotaccent = 7715;
                t2.hdotbelow = 7717;
                t2.he = 1492;
                t2.heart = 9829;
                t2.heartsuitblack = 9829;
                t2.heartsuitwhite = 9825;
                t2.hedagesh = 64308;
                t2.hedageshhebrew = 64308;
                t2.hehaltonearabic = 1729;
                t2.heharabic = 1607;
                t2.hehebrew = 1492;
                t2.hehfinalaltonearabic = 64423;
                t2.hehfinalalttwoarabic = 65258;
                t2.hehfinalarabic = 65258;
                t2.hehhamzaabovefinalarabic = 64421;
                t2.hehhamzaaboveisolatedarabic = 64420;
                t2.hehinitialaltonearabic = 64424;
                t2.hehinitialarabic = 65259;
                t2.hehiragana = 12408;
                t2.hehmedialaltonearabic = 64425;
                t2.hehmedialarabic = 65260;
                t2.heiseierasquare = 13179;
                t2.hekatakana = 12504;
                t2.hekatakanahalfwidth = 65421;
                t2.hekutaarusquare = 13110;
                t2.henghook = 615;
                t2.herutusquare = 13113;
                t2.het = 1495;
                t2.hethebrew = 1495;
                t2.hhook = 614;
                t2.hhooksuperior = 689;
                t2.hieuhacirclekorean = 12923;
                t2.hieuhaparenkorean = 12827;
                t2.hieuhcirclekorean = 12909;
                t2.hieuhkorean = 12622;
                t2.hieuhparenkorean = 12813;
                t2.hihiragana = 12402;
                t2.hikatakana = 12498;
                t2.hikatakanahalfwidth = 65419;
                t2.hiriq = 1460;
                t2.hiriq14 = 1460;
                t2.hiriq21 = 1460;
                t2.hiriq2d = 1460;
                t2.hiriqhebrew = 1460;
                t2.hiriqnarrowhebrew = 1460;
                t2.hiriqquarterhebrew = 1460;
                t2.hiriqwidehebrew = 1460;
                t2.hlinebelow = 7830;
                t2.hmonospace = 65352;
                t2.hoarmenian = 1392;
                t2.hohipthai = 3627;
                t2.hohiragana = 12411;
                t2.hokatakana = 12507;
                t2.hokatakanahalfwidth = 65422;
                t2.holam = 1465;
                t2.holam19 = 1465;
                t2.holam26 = 1465;
                t2.holam32 = 1465;
                t2.holamhebrew = 1465;
                t2.holamnarrowhebrew = 1465;
                t2.holamquarterhebrew = 1465;
                t2.holamwidehebrew = 1465;
                t2.honokhukthai = 3630;
                t2.hookabovecomb = 777;
                t2.hookcmb = 777;
                t2.hookpalatalizedbelowcmb = 801;
                t2.hookretroflexbelowcmb = 802;
                t2.hoonsquare = 13122;
                t2.horicoptic = 1001;
                t2.horizontalbar = 8213;
                t2.horncmb = 795;
                t2.hotsprings = 9832;
                t2.house = 8962;
                t2.hparen = 9379;
                t2.hsuperior = 688;
                t2.hturned = 613;
                t2.huhiragana = 12405;
                t2.huiitosquare = 13107;
                t2.hukatakana = 12501;
                t2.hukatakanahalfwidth = 65420;
                t2.hungarumlaut = 733;
                t2.hungarumlautcmb = 779;
                t2.hv = 405;
                t2.hyphen = 45;
                t2.hypheninferior = 63205;
                t2.hyphenmonospace = 65293;
                t2.hyphensmall = 65123;
                t2.hyphensuperior = 63206;
                t2.hyphentwo = 8208;
                t2.i = 105;
                t2.iacute = 237;
                t2.iacyrillic = 1103;
                t2.ibengali = 2439;
                t2.ibopomofo = 12583;
                t2.ibreve = 301;
                t2.icaron = 464;
                t2.icircle = 9432;
                t2.icircumflex = 238;
                t2.icyrillic = 1110;
                t2.idblgrave = 521;
                t2.ideographearthcircle = 12943;
                t2.ideographfirecircle = 12939;
                t2.ideographicallianceparen = 12863;
                t2.ideographiccallparen = 12858;
                t2.ideographiccentrecircle = 12965;
                t2.ideographicclose = 12294;
                t2.ideographiccomma = 12289;
                t2.ideographiccommaleft = 65380;
                t2.ideographiccongratulationparen = 12855;
                t2.ideographiccorrectcircle = 12963;
                t2.ideographicearthparen = 12847;
                t2.ideographicenterpriseparen = 12861;
                t2.ideographicexcellentcircle = 12957;
                t2.ideographicfestivalparen = 12864;
                t2.ideographicfinancialcircle = 12950;
                t2.ideographicfinancialparen = 12854;
                t2.ideographicfireparen = 12843;
                t2.ideographichaveparen = 12850;
                t2.ideographichighcircle = 12964;
                t2.ideographiciterationmark = 12293;
                t2.ideographiclaborcircle = 12952;
                t2.ideographiclaborparen = 12856;
                t2.ideographicleftcircle = 12967;
                t2.ideographiclowcircle = 12966;
                t2.ideographicmedicinecircle = 12969;
                t2.ideographicmetalparen = 12846;
                t2.ideographicmoonparen = 12842;
                t2.ideographicnameparen = 12852;
                t2.ideographicperiod = 12290;
                t2.ideographicprintcircle = 12958;
                t2.ideographicreachparen = 12867;
                t2.ideographicrepresentparen = 12857;
                t2.ideographicresourceparen = 12862;
                t2.ideographicrightcircle = 12968;
                t2.ideographicsecretcircle = 12953;
                t2.ideographicselfparen = 12866;
                t2.ideographicsocietyparen = 12851;
                t2.ideographicspace = 12288;
                t2.ideographicspecialparen = 12853;
                t2.ideographicstockparen = 12849;
                t2.ideographicstudyparen = 12859;
                t2.ideographicsunparen = 12848;
                t2.ideographicsuperviseparen = 12860;
                t2.ideographicwaterparen = 12844;
                t2.ideographicwoodparen = 12845;
                t2.ideographiczero = 12295;
                t2.ideographmetalcircle = 12942;
                t2.ideographmooncircle = 12938;
                t2.ideographnamecircle = 12948;
                t2.ideographsuncircle = 12944;
                t2.ideographwatercircle = 12940;
                t2.ideographwoodcircle = 12941;
                t2.ideva = 2311;
                t2.idieresis = 239;
                t2.idieresisacute = 7727;
                t2.idieresiscyrillic = 1253;
                t2.idotbelow = 7883;
                t2.iebrevecyrillic = 1239;
                t2.iecyrillic = 1077;
                t2.ieungacirclekorean = 12917;
                t2.ieungaparenkorean = 12821;
                t2.ieungcirclekorean = 12903;
                t2.ieungkorean = 12615;
                t2.ieungparenkorean = 12807;
                t2.igrave = 236;
                t2.igujarati = 2695;
                t2.igurmukhi = 2567;
                t2.ihiragana = 12356;
                t2.ihookabove = 7881;
                t2.iibengali = 2440;
                t2.iicyrillic = 1080;
                t2.iideva = 2312;
                t2.iigujarati = 2696;
                t2.iigurmukhi = 2568;
                t2.iimatragurmukhi = 2624;
                t2.iinvertedbreve = 523;
                t2.iishortcyrillic = 1081;
                t2.iivowelsignbengali = 2496;
                t2.iivowelsigndeva = 2368;
                t2.iivowelsigngujarati = 2752;
                t2.ij = 307;
                t2.ikatakana = 12452;
                t2.ikatakanahalfwidth = 65394;
                t2.ikorean = 12643;
                t2.ilde = 732;
                t2.iluyhebrew = 1452;
                t2.imacron = 299;
                t2.imacroncyrillic = 1251;
                t2.imageorapproximatelyequal = 8787;
                t2.imatragurmukhi = 2623;
                t2.imonospace = 65353;
                t2.increment = 8710;
                t2.infinity = 8734;
                t2.iniarmenian = 1387;
                t2.integral = 8747;
                t2.integralbottom = 8993;
                t2.integralbt = 8993;
                t2.integralex = 63733;
                t2.integraltop = 8992;
                t2.integraltp = 8992;
                t2.intersection = 8745;
                t2.intisquare = 13061;
                t2.invbullet = 9688;
                t2.invcircle = 9689;
                t2.invsmileface = 9787;
                t2.iocyrillic = 1105;
                t2.iogonek = 303;
                t2.iota = 953;
                t2.iotadieresis = 970;
                t2.iotadieresistonos = 912;
                t2.iotalatin = 617;
                t2.iotatonos = 943;
                t2.iparen = 9380;
                t2.irigurmukhi = 2674;
                t2.ismallhiragana = 12355;
                t2.ismallkatakana = 12451;
                t2.ismallkatakanahalfwidth = 65384;
                t2.issharbengali = 2554;
                t2.istroke = 616;
                t2.isuperior = 63213;
                t2.iterationhiragana = 12445;
                t2.iterationkatakana = 12541;
                t2.itilde = 297;
                t2.itildebelow = 7725;
                t2.iubopomofo = 12585;
                t2.iucyrillic = 1102;
                t2.ivowelsignbengali = 2495;
                t2.ivowelsigndeva = 2367;
                t2.ivowelsigngujarati = 2751;
                t2.izhitsacyrillic = 1141;
                t2.izhitsadblgravecyrillic = 1143;
                t2.j = 106;
                t2.jaarmenian = 1393;
                t2.jabengali = 2460;
                t2.jadeva = 2332;
                t2.jagujarati = 2716;
                t2.jagurmukhi = 2588;
                t2.jbopomofo = 12560;
                t2.jcaron = 496;
                t2.jcircle = 9433;
                t2.jcircumflex = 309;
                t2.jcrossedtail = 669;
                t2.jdotlessstroke = 607;
                t2.jecyrillic = 1112;
                t2.jeemarabic = 1580;
                t2.jeemfinalarabic = 65182;
                t2.jeeminitialarabic = 65183;
                t2.jeemmedialarabic = 65184;
                t2.jeharabic = 1688;
                t2.jehfinalarabic = 64395;
                t2.jhabengali = 2461;
                t2.jhadeva = 2333;
                t2.jhagujarati = 2717;
                t2.jhagurmukhi = 2589;
                t2.jheharmenian = 1403;
                t2.jis = 12292;
                t2.jmonospace = 65354;
                t2.jparen = 9381;
                t2.jsuperior = 690;
                t2.k = 107;
                t2.kabashkircyrillic = 1185;
                t2.kabengali = 2453;
                t2.kacute = 7729;
                t2.kacyrillic = 1082;
                t2.kadescendercyrillic = 1179;
                t2.kadeva = 2325;
                t2.kaf = 1499;
                t2.kafarabic = 1603;
                t2.kafdagesh = 64315;
                t2.kafdageshhebrew = 64315;
                t2.kaffinalarabic = 65242;
                t2.kafhebrew = 1499;
                t2.kafinitialarabic = 65243;
                t2.kafmedialarabic = 65244;
                t2.kafrafehebrew = 64333;
                t2.kagujarati = 2709;
                t2.kagurmukhi = 2581;
                t2.kahiragana = 12363;
                t2.kahookcyrillic = 1220;
                t2.kakatakana = 12459;
                t2.kakatakanahalfwidth = 65398;
                t2.kappa = 954;
                t2.kappasymbolgreek = 1008;
                t2.kapyeounmieumkorean = 12657;
                t2.kapyeounphieuphkorean = 12676;
                t2.kapyeounpieupkorean = 12664;
                t2.kapyeounssangpieupkorean = 12665;
                t2.karoriisquare = 13069;
                t2.kashidaautoarabic = 1600;
                t2.kashidaautonosidebearingarabic = 1600;
                t2.kasmallkatakana = 12533;
                t2.kasquare = 13188;
                t2.kasraarabic = 1616;
                t2.kasratanarabic = 1613;
                t2.kastrokecyrillic = 1183;
                t2.katahiraprolongmarkhalfwidth = 65392;
                t2.kaverticalstrokecyrillic = 1181;
                t2.kbopomofo = 12558;
                t2.kcalsquare = 13193;
                t2.kcaron = 489;
                t2.kcedilla = 311;
                t2.kcircle = 9434;
                t2.kcommaaccent = 311;
                t2.kdotbelow = 7731;
                t2.keharmenian = 1412;
                t2.kehiragana = 12369;
                t2.kekatakana = 12465;
                t2.kekatakanahalfwidth = 65401;
                t2.kenarmenian = 1391;
                t2.kesmallkatakana = 12534;
                t2.kgreenlandic = 312;
                t2.khabengali = 2454;
                t2.khacyrillic = 1093;
                t2.khadeva = 2326;
                t2.khagujarati = 2710;
                t2.khagurmukhi = 2582;
                t2.khaharabic = 1582;
                t2.khahfinalarabic = 65190;
                t2.khahinitialarabic = 65191;
                t2.khahmedialarabic = 65192;
                t2.kheicoptic = 999;
                t2.khhadeva = 2393;
                t2.khhagurmukhi = 2649;
                t2.khieukhacirclekorean = 12920;
                t2.khieukhaparenkorean = 12824;
                t2.khieukhcirclekorean = 12906;
                t2.khieukhkorean = 12619;
                t2.khieukhparenkorean = 12810;
                t2.khokhaithai = 3586;
                t2.khokhonthai = 3589;
                t2.khokhuatthai = 3587;
                t2.khokhwaithai = 3588;
                t2.khomutthai = 3675;
                t2.khook = 409;
                t2.khorakhangthai = 3590;
                t2.khzsquare = 13201;
                t2.kihiragana = 12365;
                t2.kikatakana = 12461;
                t2.kikatakanahalfwidth = 65399;
                t2.kiroguramusquare = 13077;
                t2.kiromeetorusquare = 13078;
                t2.kirosquare = 13076;
                t2.kiyeokacirclekorean = 12910;
                t2.kiyeokaparenkorean = 12814;
                t2.kiyeokcirclekorean = 12896;
                t2.kiyeokkorean = 12593;
                t2.kiyeokparenkorean = 12800;
                t2.kiyeoksioskorean = 12595;
                t2.kjecyrillic = 1116;
                t2.klinebelow = 7733;
                t2.klsquare = 13208;
                t2.kmcubedsquare = 13222;
                t2.kmonospace = 65355;
                t2.kmsquaredsquare = 13218;
                t2.kohiragana = 12371;
                t2.kohmsquare = 13248;
                t2.kokaithai = 3585;
                t2.kokatakana = 12467;
                t2.kokatakanahalfwidth = 65402;
                t2.kooposquare = 13086;
                t2.koppacyrillic = 1153;
                t2.koreanstandardsymbol = 12927;
                t2.koroniscmb = 835;
                t2.kparen = 9382;
                t2.kpasquare = 13226;
                t2.ksicyrillic = 1135;
                t2.ktsquare = 13263;
                t2.kturned = 670;
                t2.kuhiragana = 12367;
                t2.kukatakana = 12463;
                t2.kukatakanahalfwidth = 65400;
                t2.kvsquare = 13240;
                t2.kwsquare = 13246;
                t2.l = 108;
                t2.labengali = 2482;
                t2.lacute = 314;
                t2.ladeva = 2354;
                t2.lagujarati = 2738;
                t2.lagurmukhi = 2610;
                t2.lakkhangyaothai = 3653;
                t2.lamaleffinalarabic = 65276;
                t2.lamalefhamzaabovefinalarabic = 65272;
                t2.lamalefhamzaaboveisolatedarabic = 65271;
                t2.lamalefhamzabelowfinalarabic = 65274;
                t2.lamalefhamzabelowisolatedarabic = 65273;
                t2.lamalefisolatedarabic = 65275;
                t2.lamalefmaddaabovefinalarabic = 65270;
                t2.lamalefmaddaaboveisolatedarabic = 65269;
                t2.lamarabic = 1604;
                t2.lambda = 955;
                t2.lambdastroke = 411;
                t2.lamed = 1500;
                t2.lameddagesh = 64316;
                t2.lameddageshhebrew = 64316;
                t2.lamedhebrew = 1500;
                t2.lamfinalarabic = 65246;
                t2.lamhahinitialarabic = 64714;
                t2.laminitialarabic = 65247;
                t2.lamjeeminitialarabic = 64713;
                t2.lamkhahinitialarabic = 64715;
                t2.lamlamhehisolatedarabic = 65010;
                t2.lammedialarabic = 65248;
                t2.lammeemhahinitialarabic = 64904;
                t2.lammeeminitialarabic = 64716;
                t2.largecircle = 9711;
                t2.lbar = 410;
                t2.lbelt = 620;
                t2.lbopomofo = 12556;
                t2.lcaron = 318;
                t2.lcedilla = 316;
                t2.lcircle = 9435;
                t2.lcircumflexbelow = 7741;
                t2.lcommaaccent = 316;
                t2.ldot = 320;
                t2.ldotaccent = 320;
                t2.ldotbelow = 7735;
                t2.ldotbelowmacron = 7737;
                t2.leftangleabovecmb = 794;
                t2.lefttackbelowcmb = 792;
                t2.less = 60;
                t2.lessequal = 8804;
                t2.lessequalorgreater = 8922;
                t2.lessmonospace = 65308;
                t2.lessorequivalent = 8818;
                t2.lessorgreater = 8822;
                t2.lessoverequal = 8806;
                t2.lesssmall = 65124;
                t2.lezh = 622;
                t2.lfblock = 9612;
                t2.lhookretroflex = 621;
                t2.lira = 8356;
                t2.liwnarmenian = 1388;
                t2.lj = 457;
                t2.ljecyrillic = 1113;
                t2.ll = 63168;
                t2.lladeva = 2355;
                t2.llagujarati = 2739;
                t2.llinebelow = 7739;
                t2.llladeva = 2356;
                t2.llvocalicbengali = 2529;
                t2.llvocalicdeva = 2401;
                t2.llvocalicvowelsignbengali = 2531;
                t2.llvocalicvowelsigndeva = 2403;
                t2.lmiddletilde = 619;
                t2.lmonospace = 65356;
                t2.lmsquare = 13264;
                t2.lochulathai = 3628;
                t2.logicaland = 8743;
                t2.logicalnot = 172;
                t2.logicalnotreversed = 8976;
                t2.logicalor = 8744;
                t2.lolingthai = 3621;
                t2.longs = 383;
                t2.lowlinecenterline = 65102;
                t2.lowlinecmb = 818;
                t2.lowlinedashed = 65101;
                t2.lozenge = 9674;
                t2.lparen = 9383;
                t2.lslash = 322;
                t2.lsquare = 8467;
                t2.lsuperior = 63214;
                t2.ltshade = 9617;
                t2.luthai = 3622;
                t2.lvocalicbengali = 2444;
                t2.lvocalicdeva = 2316;
                t2.lvocalicvowelsignbengali = 2530;
                t2.lvocalicvowelsigndeva = 2402;
                t2.lxsquare = 13267;
                t2.m = 109;
                t2.mabengali = 2478;
                t2.macron = 175;
                t2.macronbelowcmb = 817;
                t2.macroncmb = 772;
                t2.macronlowmod = 717;
                t2.macronmonospace = 65507;
                t2.macute = 7743;
                t2.madeva = 2350;
                t2.magujarati = 2734;
                t2.magurmukhi = 2606;
                t2.mahapakhhebrew = 1444;
                t2.mahapakhlefthebrew = 1444;
                t2.mahiragana = 12414;
                t2.maichattawalowleftthai = 63637;
                t2.maichattawalowrightthai = 63636;
                t2.maichattawathai = 3659;
                t2.maichattawaupperleftthai = 63635;
                t2.maieklowleftthai = 63628;
                t2.maieklowrightthai = 63627;
                t2.maiekthai = 3656;
                t2.maiekupperleftthai = 63626;
                t2.maihanakatleftthai = 63620;
                t2.maihanakatthai = 3633;
                t2.maitaikhuleftthai = 63625;
                t2.maitaikhuthai = 3655;
                t2.maitholowleftthai = 63631;
                t2.maitholowrightthai = 63630;
                t2.maithothai = 3657;
                t2.maithoupperleftthai = 63629;
                t2.maitrilowleftthai = 63634;
                t2.maitrilowrightthai = 63633;
                t2.maitrithai = 3658;
                t2.maitriupperleftthai = 63632;
                t2.maiyamokthai = 3654;
                t2.makatakana = 12510;
                t2.makatakanahalfwidth = 65423;
                t2.male = 9794;
                t2.mansyonsquare = 13127;
                t2.maqafhebrew = 1470;
                t2.mars = 9794;
                t2.masoracirclehebrew = 1455;
                t2.masquare = 13187;
                t2.mbopomofo = 12551;
                t2.mbsquare = 13268;
                t2.mcircle = 9436;
                t2.mcubedsquare = 13221;
                t2.mdotaccent = 7745;
                t2.mdotbelow = 7747;
                t2.meemarabic = 1605;
                t2.meemfinalarabic = 65250;
                t2.meeminitialarabic = 65251;
                t2.meemmedialarabic = 65252;
                t2.meemmeeminitialarabic = 64721;
                t2.meemmeemisolatedarabic = 64584;
                t2.meetorusquare = 13133;
                t2.mehiragana = 12417;
                t2.meizierasquare = 13182;
                t2.mekatakana = 12513;
                t2.mekatakanahalfwidth = 65426;
                t2.mem = 1502;
                t2.memdagesh = 64318;
                t2.memdageshhebrew = 64318;
                t2.memhebrew = 1502;
                t2.menarmenian = 1396;
                t2.merkhahebrew = 1445;
                t2.merkhakefulahebrew = 1446;
                t2.merkhakefulalefthebrew = 1446;
                t2.merkhalefthebrew = 1445;
                t2.mhook = 625;
                t2.mhzsquare = 13202;
                t2.middledotkatakanahalfwidth = 65381;
                t2.middot = 183;
                t2.mieumacirclekorean = 12914;
                t2.mieumaparenkorean = 12818;
                t2.mieumcirclekorean = 12900;
                t2.mieumkorean = 12609;
                t2.mieumpansioskorean = 12656;
                t2.mieumparenkorean = 12804;
                t2.mieumpieupkorean = 12654;
                t2.mieumsioskorean = 12655;
                t2.mihiragana = 12415;
                t2.mikatakana = 12511;
                t2.mikatakanahalfwidth = 65424;
                t2.minus = 8722;
                t2.minusbelowcmb = 800;
                t2.minuscircle = 8854;
                t2.minusmod = 727;
                t2.minusplus = 8723;
                t2.minute = 8242;
                t2.miribaarusquare = 13130;
                t2.mirisquare = 13129;
                t2.mlonglegturned = 624;
                t2.mlsquare = 13206;
                t2.mmcubedsquare = 13219;
                t2.mmonospace = 65357;
                t2.mmsquaredsquare = 13215;
                t2.mohiragana = 12418;
                t2.mohmsquare = 13249;
                t2.mokatakana = 12514;
                t2.mokatakanahalfwidth = 65427;
                t2.molsquare = 13270;
                t2.momathai = 3617;
                t2.moverssquare = 13223;
                t2.moverssquaredsquare = 13224;
                t2.mparen = 9384;
                t2.mpasquare = 13227;
                t2.mssquare = 13235;
                t2.msuperior = 63215;
                t2.mturned = 623;
                t2.mu = 181;
                t2.mu1 = 181;
                t2.muasquare = 13186;
                t2.muchgreater = 8811;
                t2.muchless = 8810;
                t2.mufsquare = 13196;
                t2.mugreek = 956;
                t2.mugsquare = 13197;
                t2.muhiragana = 12416;
                t2.mukatakana = 12512;
                t2.mukatakanahalfwidth = 65425;
                t2.mulsquare = 13205;
                t2.multiply = 215;
                t2.mumsquare = 13211;
                t2.munahhebrew = 1443;
                t2.munahlefthebrew = 1443;
                t2.musicalnote = 9834;
                t2.musicalnotedbl = 9835;
                t2.musicflatsign = 9837;
                t2.musicsharpsign = 9839;
                t2.mussquare = 13234;
                t2.muvsquare = 13238;
                t2.muwsquare = 13244;
                t2.mvmegasquare = 13241;
                t2.mvsquare = 13239;
                t2.mwmegasquare = 13247;
                t2.mwsquare = 13245;
                t2.n = 110;
                t2.nabengali = 2472;
                t2.nabla = 8711;
                t2.nacute = 324;
                t2.nadeva = 2344;
                t2.nagujarati = 2728;
                t2.nagurmukhi = 2600;
                t2.nahiragana = 12394;
                t2.nakatakana = 12490;
                t2.nakatakanahalfwidth = 65413;
                t2.napostrophe = 329;
                t2.nasquare = 13185;
                t2.nbopomofo = 12555;
                t2.nbspace = 160;
                t2.ncaron = 328;
                t2.ncedilla = 326;
                t2.ncircle = 9437;
                t2.ncircumflexbelow = 7755;
                t2.ncommaaccent = 326;
                t2.ndotaccent = 7749;
                t2.ndotbelow = 7751;
                t2.nehiragana = 12397;
                t2.nekatakana = 12493;
                t2.nekatakanahalfwidth = 65416;
                t2.newsheqelsign = 8362;
                t2.nfsquare = 13195;
                t2.ngabengali = 2457;
                t2.ngadeva = 2329;
                t2.ngagujarati = 2713;
                t2.ngagurmukhi = 2585;
                t2.ngonguthai = 3591;
                t2.nhiragana = 12435;
                t2.nhookleft = 626;
                t2.nhookretroflex = 627;
                t2.nieunacirclekorean = 12911;
                t2.nieunaparenkorean = 12815;
                t2.nieuncieuckorean = 12597;
                t2.nieuncirclekorean = 12897;
                t2.nieunhieuhkorean = 12598;
                t2.nieunkorean = 12596;
                t2.nieunpansioskorean = 12648;
                t2.nieunparenkorean = 12801;
                t2.nieunsioskorean = 12647;
                t2.nieuntikeutkorean = 12646;
                t2.nihiragana = 12395;
                t2.nikatakana = 12491;
                t2.nikatakanahalfwidth = 65414;
                t2.nikhahitleftthai = 63641;
                t2.nikhahitthai = 3661;
                t2.nine = 57;
                t2.ninearabic = 1641;
                t2.ninebengali = 2543;
                t2.ninecircle = 9320;
                t2.ninecircleinversesansserif = 10130;
                t2.ninedeva = 2415;
                t2.ninegujarati = 2799;
                t2.ninegurmukhi = 2671;
                t2.ninehackarabic = 1641;
                t2.ninehangzhou = 12329;
                t2.nineideographicparen = 12840;
                t2.nineinferior = 8329;
                t2.ninemonospace = 65305;
                t2.nineoldstyle = 63289;
                t2.nineparen = 9340;
                t2.nineperiod = 9360;
                t2.ninepersian = 1785;
                t2.nineroman = 8568;
                t2.ninesuperior = 8313;
                t2.nineteencircle = 9330;
                t2.nineteenparen = 9350;
                t2.nineteenperiod = 9370;
                t2.ninethai = 3673;
                t2.nj = 460;
                t2.njecyrillic = 1114;
                t2.nkatakana = 12531;
                t2.nkatakanahalfwidth = 65437;
                t2.nlegrightlong = 414;
                t2.nlinebelow = 7753;
                t2.nmonospace = 65358;
                t2.nmsquare = 13210;
                t2.nnabengali = 2467;
                t2.nnadeva = 2339;
                t2.nnagujarati = 2723;
                t2.nnagurmukhi = 2595;
                t2.nnnadeva = 2345;
                t2.nohiragana = 12398;
                t2.nokatakana = 12494;
                t2.nokatakanahalfwidth = 65417;
                t2.nonbreakingspace = 160;
                t2.nonenthai = 3603;
                t2.nonuthai = 3609;
                t2.noonarabic = 1606;
                t2.noonfinalarabic = 65254;
                t2.noonghunnaarabic = 1722;
                t2.noonghunnafinalarabic = 64415;
                t2.nooninitialarabic = 65255;
                t2.noonjeeminitialarabic = 64722;
                t2.noonjeemisolatedarabic = 64587;
                t2.noonmedialarabic = 65256;
                t2.noonmeeminitialarabic = 64725;
                t2.noonmeemisolatedarabic = 64590;
                t2.noonnoonfinalarabic = 64653;
                t2.notcontains = 8716;
                t2.notelement = 8713;
                t2.notelementof = 8713;
                t2.notequal = 8800;
                t2.notgreater = 8815;
                t2.notgreaternorequal = 8817;
                t2.notgreaternorless = 8825;
                t2.notidentical = 8802;
                t2.notless = 8814;
                t2.notlessnorequal = 8816;
                t2.notparallel = 8742;
                t2.notprecedes = 8832;
                t2.notsubset = 8836;
                t2.notsucceeds = 8833;
                t2.notsuperset = 8837;
                t2.nowarmenian = 1398;
                t2.nparen = 9385;
                t2.nssquare = 13233;
                t2.nsuperior = 8319;
                t2.ntilde = 241;
                t2.nu = 957;
                t2.nuhiragana = 12396;
                t2.nukatakana = 12492;
                t2.nukatakanahalfwidth = 65415;
                t2.nuktabengali = 2492;
                t2.nuktadeva = 2364;
                t2.nuktagujarati = 2748;
                t2.nuktagurmukhi = 2620;
                t2.numbersign = 35;
                t2.numbersignmonospace = 65283;
                t2.numbersignsmall = 65119;
                t2.numeralsigngreek = 884;
                t2.numeralsignlowergreek = 885;
                t2.numero = 8470;
                t2.nun = 1504;
                t2.nundagesh = 64320;
                t2.nundageshhebrew = 64320;
                t2.nunhebrew = 1504;
                t2.nvsquare = 13237;
                t2.nwsquare = 13243;
                t2.nyabengali = 2462;
                t2.nyadeva = 2334;
                t2.nyagujarati = 2718;
                t2.nyagurmukhi = 2590;
                t2.o = 111;
                t2.oacute = 243;
                t2.oangthai = 3629;
                t2.obarred = 629;
                t2.obarredcyrillic = 1257;
                t2.obarreddieresiscyrillic = 1259;
                t2.obengali = 2451;
                t2.obopomofo = 12571;
                t2.obreve = 335;
                t2.ocandradeva = 2321;
                t2.ocandragujarati = 2705;
                t2.ocandravowelsigndeva = 2377;
                t2.ocandravowelsigngujarati = 2761;
                t2.ocaron = 466;
                t2.ocircle = 9438;
                t2.ocircumflex = 244;
                t2.ocircumflexacute = 7889;
                t2.ocircumflexdotbelow = 7897;
                t2.ocircumflexgrave = 7891;
                t2.ocircumflexhookabove = 7893;
                t2.ocircumflextilde = 7895;
                t2.ocyrillic = 1086;
                t2.odblacute = 337;
                t2.odblgrave = 525;
                t2.odeva = 2323;
                t2.odieresis = 246;
                t2.odieresiscyrillic = 1255;
                t2.odotbelow = 7885;
                t2.oe = 339;
                t2.oekorean = 12634;
                t2.ogonek = 731;
                t2.ogonekcmb = 808;
                t2.ograve = 242;
                t2.ogujarati = 2707;
                t2.oharmenian = 1413;
                t2.ohiragana = 12362;
                t2.ohookabove = 7887;
                t2.ohorn = 417;
                t2.ohornacute = 7899;
                t2.ohorndotbelow = 7907;
                t2.ohorngrave = 7901;
                t2.ohornhookabove = 7903;
                t2.ohorntilde = 7905;
                t2.ohungarumlaut = 337;
                t2.oi = 419;
                t2.oinvertedbreve = 527;
                t2.okatakana = 12458;
                t2.okatakanahalfwidth = 65397;
                t2.okorean = 12631;
                t2.olehebrew = 1451;
                t2.omacron = 333;
                t2.omacronacute = 7763;
                t2.omacrongrave = 7761;
                t2.omdeva = 2384;
                t2.omega = 969;
                t2.omega1 = 982;
                t2.omegacyrillic = 1121;
                t2.omegalatinclosed = 631;
                t2.omegaroundcyrillic = 1147;
                t2.omegatitlocyrillic = 1149;
                t2.omegatonos = 974;
                t2.omgujarati = 2768;
                t2.omicron = 959;
                t2.omicrontonos = 972;
                t2.omonospace = 65359;
                t2.one = 49;
                t2.onearabic = 1633;
                t2.onebengali = 2535;
                t2.onecircle = 9312;
                t2.onecircleinversesansserif = 10122;
                t2.onedeva = 2407;
                t2.onedotenleader = 8228;
                t2.oneeighth = 8539;
                t2.onefitted = 63196;
                t2.onegujarati = 2791;
                t2.onegurmukhi = 2663;
                t2.onehackarabic = 1633;
                t2.onehalf = 189;
                t2.onehangzhou = 12321;
                t2.oneideographicparen = 12832;
                t2.oneinferior = 8321;
                t2.onemonospace = 65297;
                t2.onenumeratorbengali = 2548;
                t2.oneoldstyle = 63281;
                t2.oneparen = 9332;
                t2.oneperiod = 9352;
                t2.onepersian = 1777;
                t2.onequarter = 188;
                t2.oneroman = 8560;
                t2.onesuperior = 185;
                t2.onethai = 3665;
                t2.onethird = 8531;
                t2.oogonek = 491;
                t2.oogonekmacron = 493;
                t2.oogurmukhi = 2579;
                t2.oomatragurmukhi = 2635;
                t2.oopen = 596;
                t2.oparen = 9386;
                t2.openbullet = 9702;
                t2.option = 8997;
                t2.ordfeminine = 170;
                t2.ordmasculine = 186;
                t2.orthogonal = 8735;
                t2.oshortdeva = 2322;
                t2.oshortvowelsigndeva = 2378;
                t2.oslash = 248;
                t2.oslashacute = 511;
                t2.osmallhiragana = 12361;
                t2.osmallkatakana = 12457;
                t2.osmallkatakanahalfwidth = 65387;
                t2.ostrokeacute = 511;
                t2.osuperior = 63216;
                t2.otcyrillic = 1151;
                t2.otilde = 245;
                t2.otildeacute = 7757;
                t2.otildedieresis = 7759;
                t2.oubopomofo = 12577;
                t2.overline = 8254;
                t2.overlinecenterline = 65098;
                t2.overlinecmb = 773;
                t2.overlinedashed = 65097;
                t2.overlinedblwavy = 65100;
                t2.overlinewavy = 65099;
                t2.overscore = 175;
                t2.ovowelsignbengali = 2507;
                t2.ovowelsigndeva = 2379;
                t2.ovowelsigngujarati = 2763;
                t2.p = 112;
                t2.paampssquare = 13184;
                t2.paasentosquare = 13099;
                t2.pabengali = 2474;
                t2.pacute = 7765;
                t2.padeva = 2346;
                t2.pagedown = 8671;
                t2.pageup = 8670;
                t2.pagujarati = 2730;
                t2.pagurmukhi = 2602;
                t2.pahiragana = 12401;
                t2.paiyannoithai = 3631;
                t2.pakatakana = 12497;
                t2.palatalizationcyrilliccmb = 1156;
                t2.palochkacyrillic = 1216;
                t2.pansioskorean = 12671;
                t2.paragraph = 182;
                t2.parallel = 8741;
                t2.parenleft = 40;
                t2.parenleftaltonearabic = 64830;
                t2.parenleftbt = 63725;
                t2.parenleftex = 63724;
                t2.parenleftinferior = 8333;
                t2.parenleftmonospace = 65288;
                t2.parenleftsmall = 65113;
                t2.parenleftsuperior = 8317;
                t2.parenlefttp = 63723;
                t2.parenleftvertical = 65077;
                t2.parenright = 41;
                t2.parenrightaltonearabic = 64831;
                t2.parenrightbt = 63736;
                t2.parenrightex = 63735;
                t2.parenrightinferior = 8334;
                t2.parenrightmonospace = 65289;
                t2.parenrightsmall = 65114;
                t2.parenrightsuperior = 8318;
                t2.parenrighttp = 63734;
                t2.parenrightvertical = 65078;
                t2.partialdiff = 8706;
                t2.paseqhebrew = 1472;
                t2.pashtahebrew = 1433;
                t2.pasquare = 13225;
                t2.patah = 1463;
                t2.patah11 = 1463;
                t2.patah1d = 1463;
                t2.patah2a = 1463;
                t2.patahhebrew = 1463;
                t2.patahnarrowhebrew = 1463;
                t2.patahquarterhebrew = 1463;
                t2.patahwidehebrew = 1463;
                t2.pazerhebrew = 1441;
                t2.pbopomofo = 12550;
                t2.pcircle = 9439;
                t2.pdotaccent = 7767;
                t2.pe = 1508;
                t2.pecyrillic = 1087;
                t2.pedagesh = 64324;
                t2.pedageshhebrew = 64324;
                t2.peezisquare = 13115;
                t2.pefinaldageshhebrew = 64323;
                t2.peharabic = 1662;
                t2.peharmenian = 1402;
                t2.pehebrew = 1508;
                t2.pehfinalarabic = 64343;
                t2.pehinitialarabic = 64344;
                t2.pehiragana = 12410;
                t2.pehmedialarabic = 64345;
                t2.pekatakana = 12506;
                t2.pemiddlehookcyrillic = 1191;
                t2.perafehebrew = 64334;
                t2.percent = 37;
                t2.percentarabic = 1642;
                t2.percentmonospace = 65285;
                t2.percentsmall = 65130;
                t2.period = 46;
                t2.periodarmenian = 1417;
                t2.periodcentered = 183;
                t2.periodhalfwidth = 65377;
                t2.periodinferior = 63207;
                t2.periodmonospace = 65294;
                t2.periodsmall = 65106;
                t2.periodsuperior = 63208;
                t2.perispomenigreekcmb = 834;
                t2.perpendicular = 8869;
                t2.perthousand = 8240;
                t2.peseta = 8359;
                t2.pfsquare = 13194;
                t2.phabengali = 2475;
                t2.phadeva = 2347;
                t2.phagujarati = 2731;
                t2.phagurmukhi = 2603;
                t2.phi = 966;
                t2.phi1 = 981;
                t2.phieuphacirclekorean = 12922;
                t2.phieuphaparenkorean = 12826;
                t2.phieuphcirclekorean = 12908;
                t2.phieuphkorean = 12621;
                t2.phieuphparenkorean = 12812;
                t2.philatin = 632;
                t2.phinthuthai = 3642;
                t2.phisymbolgreek = 981;
                t2.phook = 421;
                t2.phophanthai = 3614;
                t2.phophungthai = 3612;
                t2.phosamphaothai = 3616;
                t2.pi = 960;
                t2.pieupacirclekorean = 12915;
                t2.pieupaparenkorean = 12819;
                t2.pieupcieuckorean = 12662;
                t2.pieupcirclekorean = 12901;
                t2.pieupkiyeokkorean = 12658;
                t2.pieupkorean = 12610;
                t2.pieupparenkorean = 12805;
                t2.pieupsioskiyeokkorean = 12660;
                t2.pieupsioskorean = 12612;
                t2.pieupsiostikeutkorean = 12661;
                t2.pieupthieuthkorean = 12663;
                t2.pieuptikeutkorean = 12659;
                t2.pihiragana = 12404;
                t2.pikatakana = 12500;
                t2.pisymbolgreek = 982;
                t2.piwrarmenian = 1411;
                t2.planckover2pi = 8463;
                t2.planckover2pi1 = 8463;
                t2.plus = 43;
                t2.plusbelowcmb = 799;
                t2.pluscircle = 8853;
                t2.plusminus = 177;
                t2.plusmod = 726;
                t2.plusmonospace = 65291;
                t2.plussmall = 65122;
                t2.plussuperior = 8314;
                t2.pmonospace = 65360;
                t2.pmsquare = 13272;
                t2.pohiragana = 12413;
                t2.pointingindexdownwhite = 9759;
                t2.pointingindexleftwhite = 9756;
                t2.pointingindexrightwhite = 9758;
                t2.pointingindexupwhite = 9757;
                t2.pokatakana = 12509;
                t2.poplathai = 3611;
                t2.postalmark = 12306;
                t2.postalmarkface = 12320;
                t2.pparen = 9387;
                t2.precedes = 8826;
                t2.prescription = 8478;
                t2.primemod = 697;
                t2.primereversed = 8245;
                t2.product = 8719;
                t2.projective = 8965;
                t2.prolongedkana = 12540;
                t2.propellor = 8984;
                t2.propersubset = 8834;
                t2.propersuperset = 8835;
                t2.proportion = 8759;
                t2.proportional = 8733;
                t2.psi = 968;
                t2.psicyrillic = 1137;
                t2.psilipneumatacyrilliccmb = 1158;
                t2.pssquare = 13232;
                t2.puhiragana = 12407;
                t2.pukatakana = 12503;
                t2.pvsquare = 13236;
                t2.pwsquare = 13242;
                t2.q = 113;
                t2.qadeva = 2392;
                t2.qadmahebrew = 1448;
                t2.qafarabic = 1602;
                t2.qaffinalarabic = 65238;
                t2.qafinitialarabic = 65239;
                t2.qafmedialarabic = 65240;
                t2.qamats = 1464;
                t2.qamats10 = 1464;
                t2.qamats1a = 1464;
                t2.qamats1c = 1464;
                t2.qamats27 = 1464;
                t2.qamats29 = 1464;
                t2.qamats33 = 1464;
                t2.qamatsde = 1464;
                t2.qamatshebrew = 1464;
                t2.qamatsnarrowhebrew = 1464;
                t2.qamatsqatanhebrew = 1464;
                t2.qamatsqatannarrowhebrew = 1464;
                t2.qamatsqatanquarterhebrew = 1464;
                t2.qamatsqatanwidehebrew = 1464;
                t2.qamatsquarterhebrew = 1464;
                t2.qamatswidehebrew = 1464;
                t2.qarneyparahebrew = 1439;
                t2.qbopomofo = 12561;
                t2.qcircle = 9440;
                t2.qhook = 672;
                t2.qmonospace = 65361;
                t2.qof = 1511;
                t2.qofdagesh = 64327;
                t2.qofdageshhebrew = 64327;
                t2.qofhebrew = 1511;
                t2.qparen = 9388;
                t2.quarternote = 9833;
                t2.qubuts = 1467;
                t2.qubuts18 = 1467;
                t2.qubuts25 = 1467;
                t2.qubuts31 = 1467;
                t2.qubutshebrew = 1467;
                t2.qubutsnarrowhebrew = 1467;
                t2.qubutsquarterhebrew = 1467;
                t2.qubutswidehebrew = 1467;
                t2.question = 63;
                t2.questionarabic = 1567;
                t2.questionarmenian = 1374;
                t2.questiondown = 191;
                t2.questiondownsmall = 63423;
                t2.questiongreek = 894;
                t2.questionmonospace = 65311;
                t2.questionsmall = 63295;
                t2.quotedbl = 34;
                t2.quotedblbase = 8222;
                t2.quotedblleft = 8220;
                t2.quotedblmonospace = 65282;
                t2.quotedblprime = 12318;
                t2.quotedblprimereversed = 12317;
                t2.quotedblright = 8221;
                t2.quoteleft = 8216;
                t2.quoteleftreversed = 8219;
                t2.quotereversed = 8219;
                t2.quoteright = 8217;
                t2.quoterightn = 329;
                t2.quotesinglbase = 8218;
                t2.quotesingle = 39;
                t2.quotesinglemonospace = 65287;
                t2.r = 114;
                t2.raarmenian = 1404;
                t2.rabengali = 2480;
                t2.racute = 341;
                t2.radeva = 2352;
                t2.radical = 8730;
                t2.radicalex = 63717;
                t2.radoverssquare = 13230;
                t2.radoverssquaredsquare = 13231;
                t2.radsquare = 13229;
                t2.rafe = 1471;
                t2.rafehebrew = 1471;
                t2.ragujarati = 2736;
                t2.ragurmukhi = 2608;
                t2.rahiragana = 12425;
                t2.rakatakana = 12521;
                t2.rakatakanahalfwidth = 65431;
                t2.ralowerdiagonalbengali = 2545;
                t2.ramiddlediagonalbengali = 2544;
                t2.ramshorn = 612;
                t2.ratio = 8758;
                t2.rbopomofo = 12566;
                t2.rcaron = 345;
                t2.rcedilla = 343;
                t2.rcircle = 9441;
                t2.rcommaaccent = 343;
                t2.rdblgrave = 529;
                t2.rdotaccent = 7769;
                t2.rdotbelow = 7771;
                t2.rdotbelowmacron = 7773;
                t2.referencemark = 8251;
                t2.reflexsubset = 8838;
                t2.reflexsuperset = 8839;
                t2.registered = 174;
                t2.registersans = 63720;
                t2.registerserif = 63194;
                t2.reharabic = 1585;
                t2.reharmenian = 1408;
                t2.rehfinalarabic = 65198;
                t2.rehiragana = 12428;
                t2.rekatakana = 12524;
                t2.rekatakanahalfwidth = 65434;
                t2.resh = 1512;
                t2.reshdageshhebrew = 64328;
                t2.reshhebrew = 1512;
                t2.reversedtilde = 8765;
                t2.reviahebrew = 1431;
                t2.reviamugrashhebrew = 1431;
                t2.revlogicalnot = 8976;
                t2.rfishhook = 638;
                t2.rfishhookreversed = 639;
                t2.rhabengali = 2525;
                t2.rhadeva = 2397;
                t2.rho = 961;
                t2.rhook = 637;
                t2.rhookturned = 635;
                t2.rhookturnedsuperior = 693;
                t2.rhosymbolgreek = 1009;
                t2.rhotichookmod = 734;
                t2.rieulacirclekorean = 12913;
                t2.rieulaparenkorean = 12817;
                t2.rieulcirclekorean = 12899;
                t2.rieulhieuhkorean = 12608;
                t2.rieulkiyeokkorean = 12602;
                t2.rieulkiyeoksioskorean = 12649;
                t2.rieulkorean = 12601;
                t2.rieulmieumkorean = 12603;
                t2.rieulpansioskorean = 12652;
                t2.rieulparenkorean = 12803;
                t2.rieulphieuphkorean = 12607;
                t2.rieulpieupkorean = 12604;
                t2.rieulpieupsioskorean = 12651;
                t2.rieulsioskorean = 12605;
                t2.rieulthieuthkorean = 12606;
                t2.rieultikeutkorean = 12650;
                t2.rieulyeorinhieuhkorean = 12653;
                t2.rightangle = 8735;
                t2.righttackbelowcmb = 793;
                t2.righttriangle = 8895;
                t2.rihiragana = 12426;
                t2.rikatakana = 12522;
                t2.rikatakanahalfwidth = 65432;
                t2.ring = 730;
                t2.ringbelowcmb = 805;
                t2.ringcmb = 778;
                t2.ringhalfleft = 703;
                t2.ringhalfleftarmenian = 1369;
                t2.ringhalfleftbelowcmb = 796;
                t2.ringhalfleftcentered = 723;
                t2.ringhalfright = 702;
                t2.ringhalfrightbelowcmb = 825;
                t2.ringhalfrightcentered = 722;
                t2.rinvertedbreve = 531;
                t2.rittorusquare = 13137;
                t2.rlinebelow = 7775;
                t2.rlongleg = 636;
                t2.rlonglegturned = 634;
                t2.rmonospace = 65362;
                t2.rohiragana = 12429;
                t2.rokatakana = 12525;
                t2.rokatakanahalfwidth = 65435;
                t2.roruathai = 3619;
                t2.rparen = 9389;
                t2.rrabengali = 2524;
                t2.rradeva = 2353;
                t2.rragurmukhi = 2652;
                t2.rreharabic = 1681;
                t2.rrehfinalarabic = 64397;
                t2.rrvocalicbengali = 2528;
                t2.rrvocalicdeva = 2400;
                t2.rrvocalicgujarati = 2784;
                t2.rrvocalicvowelsignbengali = 2500;
                t2.rrvocalicvowelsigndeva = 2372;
                t2.rrvocalicvowelsigngujarati = 2756;
                t2.rsuperior = 63217;
                t2.rtblock = 9616;
                t2.rturned = 633;
                t2.rturnedsuperior = 692;
                t2.ruhiragana = 12427;
                t2.rukatakana = 12523;
                t2.rukatakanahalfwidth = 65433;
                t2.rupeemarkbengali = 2546;
                t2.rupeesignbengali = 2547;
                t2.rupiah = 63197;
                t2.ruthai = 3620;
                t2.rvocalicbengali = 2443;
                t2.rvocalicdeva = 2315;
                t2.rvocalicgujarati = 2699;
                t2.rvocalicvowelsignbengali = 2499;
                t2.rvocalicvowelsigndeva = 2371;
                t2.rvocalicvowelsigngujarati = 2755;
                t2.s = 115;
                t2.sabengali = 2488;
                t2.sacute = 347;
                t2.sacutedotaccent = 7781;
                t2.sadarabic = 1589;
                t2.sadeva = 2360;
                t2.sadfinalarabic = 65210;
                t2.sadinitialarabic = 65211;
                t2.sadmedialarabic = 65212;
                t2.sagujarati = 2744;
                t2.sagurmukhi = 2616;
                t2.sahiragana = 12373;
                t2.sakatakana = 12469;
                t2.sakatakanahalfwidth = 65403;
                t2.sallallahoualayhewasallamarabic = 65018;
                t2.samekh = 1505;
                t2.samekhdagesh = 64321;
                t2.samekhdageshhebrew = 64321;
                t2.samekhhebrew = 1505;
                t2.saraaathai = 3634;
                t2.saraaethai = 3649;
                t2.saraaimaimalaithai = 3652;
                t2.saraaimaimuanthai = 3651;
                t2.saraamthai = 3635;
                t2.saraathai = 3632;
                t2.saraethai = 3648;
                t2.saraiileftthai = 63622;
                t2.saraiithai = 3637;
                t2.saraileftthai = 63621;
                t2.saraithai = 3636;
                t2.saraothai = 3650;
                t2.saraueeleftthai = 63624;
                t2.saraueethai = 3639;
                t2.saraueleftthai = 63623;
                t2.sarauethai = 3638;
                t2.sarauthai = 3640;
                t2.sarauuthai = 3641;
                t2.sbopomofo = 12569;
                t2.scaron = 353;
                t2.scarondotaccent = 7783;
                t2.scedilla = 351;
                t2.schwa = 601;
                t2.schwacyrillic = 1241;
                t2.schwadieresiscyrillic = 1243;
                t2.schwahook = 602;
                t2.scircle = 9442;
                t2.scircumflex = 349;
                t2.scommaaccent = 537;
                t2.sdotaccent = 7777;
                t2.sdotbelow = 7779;
                t2.sdotbelowdotaccent = 7785;
                t2.seagullbelowcmb = 828;
                t2.second = 8243;
                t2.secondtonechinese = 714;
                t2.section = 167;
                t2.seenarabic = 1587;
                t2.seenfinalarabic = 65202;
                t2.seeninitialarabic = 65203;
                t2.seenmedialarabic = 65204;
                t2.segol = 1462;
                t2.segol13 = 1462;
                t2.segol1f = 1462;
                t2.segol2c = 1462;
                t2.segolhebrew = 1462;
                t2.segolnarrowhebrew = 1462;
                t2.segolquarterhebrew = 1462;
                t2.segoltahebrew = 1426;
                t2.segolwidehebrew = 1462;
                t2.seharmenian = 1405;
                t2.sehiragana = 12379;
                t2.sekatakana = 12475;
                t2.sekatakanahalfwidth = 65406;
                t2.semicolon = 59;
                t2.semicolonarabic = 1563;
                t2.semicolonmonospace = 65307;
                t2.semicolonsmall = 65108;
                t2.semivoicedmarkkana = 12444;
                t2.semivoicedmarkkanahalfwidth = 65439;
                t2.sentisquare = 13090;
                t2.sentosquare = 13091;
                t2.seven = 55;
                t2.sevenarabic = 1639;
                t2.sevenbengali = 2541;
                t2.sevencircle = 9318;
                t2.sevencircleinversesansserif = 10128;
                t2.sevendeva = 2413;
                t2.seveneighths = 8542;
                t2.sevengujarati = 2797;
                t2.sevengurmukhi = 2669;
                t2.sevenhackarabic = 1639;
                t2.sevenhangzhou = 12327;
                t2.sevenideographicparen = 12838;
                t2.seveninferior = 8327;
                t2.sevenmonospace = 65303;
                t2.sevenoldstyle = 63287;
                t2.sevenparen = 9338;
                t2.sevenperiod = 9358;
                t2.sevenpersian = 1783;
                t2.sevenroman = 8566;
                t2.sevensuperior = 8311;
                t2.seventeencircle = 9328;
                t2.seventeenparen = 9348;
                t2.seventeenperiod = 9368;
                t2.seventhai = 3671;
                t2.sfthyphen = 173;
                t2.shaarmenian = 1399;
                t2.shabengali = 2486;
                t2.shacyrillic = 1096;
                t2.shaddaarabic = 1617;
                t2.shaddadammaarabic = 64609;
                t2.shaddadammatanarabic = 64606;
                t2.shaddafathaarabic = 64608;
                t2.shaddakasraarabic = 64610;
                t2.shaddakasratanarabic = 64607;
                t2.shade = 9618;
                t2.shadedark = 9619;
                t2.shadelight = 9617;
                t2.shademedium = 9618;
                t2.shadeva = 2358;
                t2.shagujarati = 2742;
                t2.shagurmukhi = 2614;
                t2.shalshelethebrew = 1427;
                t2.shbopomofo = 12565;
                t2.shchacyrillic = 1097;
                t2.sheenarabic = 1588;
                t2.sheenfinalarabic = 65206;
                t2.sheeninitialarabic = 65207;
                t2.sheenmedialarabic = 65208;
                t2.sheicoptic = 995;
                t2.sheqel = 8362;
                t2.sheqelhebrew = 8362;
                t2.sheva = 1456;
                t2.sheva115 = 1456;
                t2.sheva15 = 1456;
                t2.sheva22 = 1456;
                t2.sheva2e = 1456;
                t2.shevahebrew = 1456;
                t2.shevanarrowhebrew = 1456;
                t2.shevaquarterhebrew = 1456;
                t2.shevawidehebrew = 1456;
                t2.shhacyrillic = 1211;
                t2.shimacoptic = 1005;
                t2.shin = 1513;
                t2.shindagesh = 64329;
                t2.shindageshhebrew = 64329;
                t2.shindageshshindot = 64300;
                t2.shindageshshindothebrew = 64300;
                t2.shindageshsindot = 64301;
                t2.shindageshsindothebrew = 64301;
                t2.shindothebrew = 1473;
                t2.shinhebrew = 1513;
                t2.shinshindot = 64298;
                t2.shinshindothebrew = 64298;
                t2.shinsindot = 64299;
                t2.shinsindothebrew = 64299;
                t2.shook = 642;
                t2.sigma = 963;
                t2.sigma1 = 962;
                t2.sigmafinal = 962;
                t2.sigmalunatesymbolgreek = 1010;
                t2.sihiragana = 12375;
                t2.sikatakana = 12471;
                t2.sikatakanahalfwidth = 65404;
                t2.siluqhebrew = 1469;
                t2.siluqlefthebrew = 1469;
                t2.similar = 8764;
                t2.sindothebrew = 1474;
                t2.siosacirclekorean = 12916;
                t2.siosaparenkorean = 12820;
                t2.sioscieuckorean = 12670;
                t2.sioscirclekorean = 12902;
                t2.sioskiyeokkorean = 12666;
                t2.sioskorean = 12613;
                t2.siosnieunkorean = 12667;
                t2.siosparenkorean = 12806;
                t2.siospieupkorean = 12669;
                t2.siostikeutkorean = 12668;
                t2.six = 54;
                t2.sixarabic = 1638;
                t2.sixbengali = 2540;
                t2.sixcircle = 9317;
                t2.sixcircleinversesansserif = 10127;
                t2.sixdeva = 2412;
                t2.sixgujarati = 2796;
                t2.sixgurmukhi = 2668;
                t2.sixhackarabic = 1638;
                t2.sixhangzhou = 12326;
                t2.sixideographicparen = 12837;
                t2.sixinferior = 8326;
                t2.sixmonospace = 65302;
                t2.sixoldstyle = 63286;
                t2.sixparen = 9337;
                t2.sixperiod = 9357;
                t2.sixpersian = 1782;
                t2.sixroman = 8565;
                t2.sixsuperior = 8310;
                t2.sixteencircle = 9327;
                t2.sixteencurrencydenominatorbengali = 2553;
                t2.sixteenparen = 9347;
                t2.sixteenperiod = 9367;
                t2.sixthai = 3670;
                t2.slash = 47;
                t2.slashmonospace = 65295;
                t2.slong = 383;
                t2.slongdotaccent = 7835;
                t2.smileface = 9786;
                t2.smonospace = 65363;
                t2.sofpasuqhebrew = 1475;
                t2.softhyphen = 173;
                t2.softsigncyrillic = 1100;
                t2.sohiragana = 12381;
                t2.sokatakana = 12477;
                t2.sokatakanahalfwidth = 65407;
                t2.soliduslongoverlaycmb = 824;
                t2.solidusshortoverlaycmb = 823;
                t2.sorusithai = 3625;
                t2.sosalathai = 3624;
                t2.sosothai = 3595;
                t2.sosuathai = 3626;
                t2.space = 32;
                t2.spacehackarabic = 32;
                t2.spade = 9824;
                t2.spadesuitblack = 9824;
                t2.spadesuitwhite = 9828;
                t2.sparen = 9390;
                t2.squarebelowcmb = 827;
                t2.squarecc = 13252;
                t2.squarecm = 13213;
                t2.squarediagonalcrosshatchfill = 9641;
                t2.squarehorizontalfill = 9636;
                t2.squarekg = 13199;
                t2.squarekm = 13214;
                t2.squarekmcapital = 13262;
                t2.squareln = 13265;
                t2.squarelog = 13266;
                t2.squaremg = 13198;
                t2.squaremil = 13269;
                t2.squaremm = 13212;
                t2.squaremsquared = 13217;
                t2.squareorthogonalcrosshatchfill = 9638;
                t2.squareupperlefttolowerrightfill = 9639;
                t2.squareupperrighttolowerleftfill = 9640;
                t2.squareverticalfill = 9637;
                t2.squarewhitewithsmallblack = 9635;
                t2.srsquare = 13275;
                t2.ssabengali = 2487;
                t2.ssadeva = 2359;
                t2.ssagujarati = 2743;
                t2.ssangcieuckorean = 12617;
                t2.ssanghieuhkorean = 12677;
                t2.ssangieungkorean = 12672;
                t2.ssangkiyeokkorean = 12594;
                t2.ssangnieunkorean = 12645;
                t2.ssangpieupkorean = 12611;
                t2.ssangsioskorean = 12614;
                t2.ssangtikeutkorean = 12600;
                t2.ssuperior = 63218;
                t2.sterling = 163;
                t2.sterlingmonospace = 65505;
                t2.strokelongoverlaycmb = 822;
                t2.strokeshortoverlaycmb = 821;
                t2.subset = 8834;
                t2.subsetnotequal = 8842;
                t2.subsetorequal = 8838;
                t2.succeeds = 8827;
                t2.suchthat = 8715;
                t2.suhiragana = 12377;
                t2.sukatakana = 12473;
                t2.sukatakanahalfwidth = 65405;
                t2.sukunarabic = 1618;
                t2.summation = 8721;
                t2.sun = 9788;
                t2.superset = 8835;
                t2.supersetnotequal = 8843;
                t2.supersetorequal = 8839;
                t2.svsquare = 13276;
                t2.syouwaerasquare = 13180;
                t2.t = 116;
                t2.tabengali = 2468;
                t2.tackdown = 8868;
                t2.tackleft = 8867;
                t2.tadeva = 2340;
                t2.tagujarati = 2724;
                t2.tagurmukhi = 2596;
                t2.taharabic = 1591;
                t2.tahfinalarabic = 65218;
                t2.tahinitialarabic = 65219;
                t2.tahiragana = 12383;
                t2.tahmedialarabic = 65220;
                t2.taisyouerasquare = 13181;
                t2.takatakana = 12479;
                t2.takatakanahalfwidth = 65408;
                t2.tatweelarabic = 1600;
                t2.tau = 964;
                t2.tav = 1514;
                t2.tavdages = 64330;
                t2.tavdagesh = 64330;
                t2.tavdageshhebrew = 64330;
                t2.tavhebrew = 1514;
                t2.tbar = 359;
                t2.tbopomofo = 12554;
                t2.tcaron = 357;
                t2.tccurl = 680;
                t2.tcedilla = 355;
                t2.tcheharabic = 1670;
                t2.tchehfinalarabic = 64379;
                t2.tchehinitialarabic = 64380;
                t2.tchehmedialarabic = 64381;
                t2.tcircle = 9443;
                t2.tcircumflexbelow = 7793;
                t2.tcommaaccent = 355;
                t2.tdieresis = 7831;
                t2.tdotaccent = 7787;
                t2.tdotbelow = 7789;
                t2.tecyrillic = 1090;
                t2.tedescendercyrillic = 1197;
                t2.teharabic = 1578;
                t2.tehfinalarabic = 65174;
                t2.tehhahinitialarabic = 64674;
                t2.tehhahisolatedarabic = 64524;
                t2.tehinitialarabic = 65175;
                t2.tehiragana = 12390;
                t2.tehjeeminitialarabic = 64673;
                t2.tehjeemisolatedarabic = 64523;
                t2.tehmarbutaarabic = 1577;
                t2.tehmarbutafinalarabic = 65172;
                t2.tehmedialarabic = 65176;
                t2.tehmeeminitialarabic = 64676;
                t2.tehmeemisolatedarabic = 64526;
                t2.tehnoonfinalarabic = 64627;
                t2.tekatakana = 12486;
                t2.tekatakanahalfwidth = 65411;
                t2.telephone = 8481;
                t2.telephoneblack = 9742;
                t2.telishagedolahebrew = 1440;
                t2.telishaqetanahebrew = 1449;
                t2.tencircle = 9321;
                t2.tenideographicparen = 12841;
                t2.tenparen = 9341;
                t2.tenperiod = 9361;
                t2.tenroman = 8569;
                t2.tesh = 679;
                t2.tet = 1496;
                t2.tetdagesh = 64312;
                t2.tetdageshhebrew = 64312;
                t2.tethebrew = 1496;
                t2.tetsecyrillic = 1205;
                t2.tevirhebrew = 1435;
                t2.tevirlefthebrew = 1435;
                t2.thabengali = 2469;
                t2.thadeva = 2341;
                t2.thagujarati = 2725;
                t2.thagurmukhi = 2597;
                t2.thalarabic = 1584;
                t2.thalfinalarabic = 65196;
                t2.thanthakhatlowleftthai = 63640;
                t2.thanthakhatlowrightthai = 63639;
                t2.thanthakhatthai = 3660;
                t2.thanthakhatupperleftthai = 63638;
                t2.theharabic = 1579;
                t2.thehfinalarabic = 65178;
                t2.thehinitialarabic = 65179;
                t2.thehmedialarabic = 65180;
                t2.thereexists = 8707;
                t2.therefore = 8756;
                t2.theta = 952;
                t2.theta1 = 977;
                t2.thetasymbolgreek = 977;
                t2.thieuthacirclekorean = 12921;
                t2.thieuthaparenkorean = 12825;
                t2.thieuthcirclekorean = 12907;
                t2.thieuthkorean = 12620;
                t2.thieuthparenkorean = 12811;
                t2.thirteencircle = 9324;
                t2.thirteenparen = 9344;
                t2.thirteenperiod = 9364;
                t2.thonangmonthothai = 3601;
                t2.thook = 429;
                t2.thophuthaothai = 3602;
                t2.thorn = 254;
                t2.thothahanthai = 3607;
                t2.thothanthai = 3600;
                t2.thothongthai = 3608;
                t2.thothungthai = 3606;
                t2.thousandcyrillic = 1154;
                t2.thousandsseparatorarabic = 1644;
                t2.thousandsseparatorpersian = 1644;
                t2.three = 51;
                t2.threearabic = 1635;
                t2.threebengali = 2537;
                t2.threecircle = 9314;
                t2.threecircleinversesansserif = 10124;
                t2.threedeva = 2409;
                t2.threeeighths = 8540;
                t2.threegujarati = 2793;
                t2.threegurmukhi = 2665;
                t2.threehackarabic = 1635;
                t2.threehangzhou = 12323;
                t2.threeideographicparen = 12834;
                t2.threeinferior = 8323;
                t2.threemonospace = 65299;
                t2.threenumeratorbengali = 2550;
                t2.threeoldstyle = 63283;
                t2.threeparen = 9334;
                t2.threeperiod = 9354;
                t2.threepersian = 1779;
                t2.threequarters = 190;
                t2.threequartersemdash = 63198;
                t2.threeroman = 8562;
                t2.threesuperior = 179;
                t2.threethai = 3667;
                t2.thzsquare = 13204;
                t2.tihiragana = 12385;
                t2.tikatakana = 12481;
                t2.tikatakanahalfwidth = 65409;
                t2.tikeutacirclekorean = 12912;
                t2.tikeutaparenkorean = 12816;
                t2.tikeutcirclekorean = 12898;
                t2.tikeutkorean = 12599;
                t2.tikeutparenkorean = 12802;
                t2.tilde = 732;
                t2.tildebelowcmb = 816;
                t2.tildecmb = 771;
                t2.tildecomb = 771;
                t2.tildedoublecmb = 864;
                t2.tildeoperator = 8764;
                t2.tildeoverlaycmb = 820;
                t2.tildeverticalcmb = 830;
                t2.timescircle = 8855;
                t2.tipehahebrew = 1430;
                t2.tipehalefthebrew = 1430;
                t2.tippigurmukhi = 2672;
                t2.titlocyrilliccmb = 1155;
                t2.tiwnarmenian = 1407;
                t2.tlinebelow = 7791;
                t2.tmonospace = 65364;
                t2.toarmenian = 1385;
                t2.tohiragana = 12392;
                t2.tokatakana = 12488;
                t2.tokatakanahalfwidth = 65412;
                t2.tonebarextrahighmod = 741;
                t2.tonebarextralowmod = 745;
                t2.tonebarhighmod = 742;
                t2.tonebarlowmod = 744;
                t2.tonebarmidmod = 743;
                t2.tonefive = 445;
                t2.tonesix = 389;
                t2.tonetwo = 424;
                t2.tonos = 900;
                t2.tonsquare = 13095;
                t2.topatakthai = 3599;
                t2.tortoiseshellbracketleft = 12308;
                t2.tortoiseshellbracketleftsmall = 65117;
                t2.tortoiseshellbracketleftvertical = 65081;
                t2.tortoiseshellbracketright = 12309;
                t2.tortoiseshellbracketrightsmall = 65118;
                t2.tortoiseshellbracketrightvertical = 65082;
                t2.totaothai = 3605;
                t2.tpalatalhook = 427;
                t2.tparen = 9391;
                t2.trademark = 8482;
                t2.trademarksans = 63722;
                t2.trademarkserif = 63195;
                t2.tretroflexhook = 648;
                t2.triagdn = 9660;
                t2.triaglf = 9668;
                t2.triagrt = 9658;
                t2.triagup = 9650;
                t2.ts = 678;
                t2.tsadi = 1510;
                t2.tsadidagesh = 64326;
                t2.tsadidageshhebrew = 64326;
                t2.tsadihebrew = 1510;
                t2.tsecyrillic = 1094;
                t2.tsere = 1461;
                t2.tsere12 = 1461;
                t2.tsere1e = 1461;
                t2.tsere2b = 1461;
                t2.tserehebrew = 1461;
                t2.tserenarrowhebrew = 1461;
                t2.tserequarterhebrew = 1461;
                t2.tserewidehebrew = 1461;
                t2.tshecyrillic = 1115;
                t2.tsuperior = 63219;
                t2.ttabengali = 2463;
                t2.ttadeva = 2335;
                t2.ttagujarati = 2719;
                t2.ttagurmukhi = 2591;
                t2.tteharabic = 1657;
                t2.ttehfinalarabic = 64359;
                t2.ttehinitialarabic = 64360;
                t2.ttehmedialarabic = 64361;
                t2.tthabengali = 2464;
                t2.tthadeva = 2336;
                t2.tthagujarati = 2720;
                t2.tthagurmukhi = 2592;
                t2.tturned = 647;
                t2.tuhiragana = 12388;
                t2.tukatakana = 12484;
                t2.tukatakanahalfwidth = 65410;
                t2.tusmallhiragana = 12387;
                t2.tusmallkatakana = 12483;
                t2.tusmallkatakanahalfwidth = 65391;
                t2.twelvecircle = 9323;
                t2.twelveparen = 9343;
                t2.twelveperiod = 9363;
                t2.twelveroman = 8571;
                t2.twentycircle = 9331;
                t2.twentyhangzhou = 21316;
                t2.twentyparen = 9351;
                t2.twentyperiod = 9371;
                t2.two = 50;
                t2.twoarabic = 1634;
                t2.twobengali = 2536;
                t2.twocircle = 9313;
                t2.twocircleinversesansserif = 10123;
                t2.twodeva = 2408;
                t2.twodotenleader = 8229;
                t2.twodotleader = 8229;
                t2.twodotleadervertical = 65072;
                t2.twogujarati = 2792;
                t2.twogurmukhi = 2664;
                t2.twohackarabic = 1634;
                t2.twohangzhou = 12322;
                t2.twoideographicparen = 12833;
                t2.twoinferior = 8322;
                t2.twomonospace = 65298;
                t2.twonumeratorbengali = 2549;
                t2.twooldstyle = 63282;
                t2.twoparen = 9333;
                t2.twoperiod = 9353;
                t2.twopersian = 1778;
                t2.tworoman = 8561;
                t2.twostroke = 443;
                t2.twosuperior = 178;
                t2.twothai = 3666;
                t2.twothirds = 8532;
                t2.u = 117;
                t2.uacute = 250;
                t2.ubar = 649;
                t2.ubengali = 2441;
                t2.ubopomofo = 12584;
                t2.ubreve = 365;
                t2.ucaron = 468;
                t2.ucircle = 9444;
                t2.ucircumflex = 251;
                t2.ucircumflexbelow = 7799;
                t2.ucyrillic = 1091;
                t2.udattadeva = 2385;
                t2.udblacute = 369;
                t2.udblgrave = 533;
                t2.udeva = 2313;
                t2.udieresis = 252;
                t2.udieresisacute = 472;
                t2.udieresisbelow = 7795;
                t2.udieresiscaron = 474;
                t2.udieresiscyrillic = 1265;
                t2.udieresisgrave = 476;
                t2.udieresismacron = 470;
                t2.udotbelow = 7909;
                t2.ugrave = 249;
                t2.ugujarati = 2697;
                t2.ugurmukhi = 2569;
                t2.uhiragana = 12358;
                t2.uhookabove = 7911;
                t2.uhorn = 432;
                t2.uhornacute = 7913;
                t2.uhorndotbelow = 7921;
                t2.uhorngrave = 7915;
                t2.uhornhookabove = 7917;
                t2.uhorntilde = 7919;
                t2.uhungarumlaut = 369;
                t2.uhungarumlautcyrillic = 1267;
                t2.uinvertedbreve = 535;
                t2.ukatakana = 12454;
                t2.ukatakanahalfwidth = 65395;
                t2.ukcyrillic = 1145;
                t2.ukorean = 12636;
                t2.umacron = 363;
                t2.umacroncyrillic = 1263;
                t2.umacrondieresis = 7803;
                t2.umatragurmukhi = 2625;
                t2.umonospace = 65365;
                t2.underscore = 95;
                t2.underscoredbl = 8215;
                t2.underscoremonospace = 65343;
                t2.underscorevertical = 65075;
                t2.underscorewavy = 65103;
                t2.union = 8746;
                t2.universal = 8704;
                t2.uogonek = 371;
                t2.uparen = 9392;
                t2.upblock = 9600;
                t2.upperdothebrew = 1476;
                t2.upsilon = 965;
                t2.upsilondieresis = 971;
                t2.upsilondieresistonos = 944;
                t2.upsilonlatin = 650;
                t2.upsilontonos = 973;
                t2.uptackbelowcmb = 797;
                t2.uptackmod = 724;
                t2.uragurmukhi = 2675;
                t2.uring = 367;
                t2.ushortcyrillic = 1118;
                t2.usmallhiragana = 12357;
                t2.usmallkatakana = 12453;
                t2.usmallkatakanahalfwidth = 65385;
                t2.ustraightcyrillic = 1199;
                t2.ustraightstrokecyrillic = 1201;
                t2.utilde = 361;
                t2.utildeacute = 7801;
                t2.utildebelow = 7797;
                t2.uubengali = 2442;
                t2.uudeva = 2314;
                t2.uugujarati = 2698;
                t2.uugurmukhi = 2570;
                t2.uumatragurmukhi = 2626;
                t2.uuvowelsignbengali = 2498;
                t2.uuvowelsigndeva = 2370;
                t2.uuvowelsigngujarati = 2754;
                t2.uvowelsignbengali = 2497;
                t2.uvowelsigndeva = 2369;
                t2.uvowelsigngujarati = 2753;
                t2.v = 118;
                t2.vadeva = 2357;
                t2.vagujarati = 2741;
                t2.vagurmukhi = 2613;
                t2.vakatakana = 12535;
                t2.vav = 1493;
                t2.vavdagesh = 64309;
                t2.vavdagesh65 = 64309;
                t2.vavdageshhebrew = 64309;
                t2.vavhebrew = 1493;
                t2.vavholam = 64331;
                t2.vavholamhebrew = 64331;
                t2.vavvavhebrew = 1520;
                t2.vavyodhebrew = 1521;
                t2.vcircle = 9445;
                t2.vdotbelow = 7807;
                t2.vecyrillic = 1074;
                t2.veharabic = 1700;
                t2.vehfinalarabic = 64363;
                t2.vehinitialarabic = 64364;
                t2.vehmedialarabic = 64365;
                t2.vekatakana = 12537;
                t2.venus = 9792;
                t2.verticalbar = 124;
                t2.verticallineabovecmb = 781;
                t2.verticallinebelowcmb = 809;
                t2.verticallinelowmod = 716;
                t2.verticallinemod = 712;
                t2.vewarmenian = 1406;
                t2.vhook = 651;
                t2.vikatakana = 12536;
                t2.viramabengali = 2509;
                t2.viramadeva = 2381;
                t2.viramagujarati = 2765;
                t2.visargabengali = 2435;
                t2.visargadeva = 2307;
                t2.visargagujarati = 2691;
                t2.vmonospace = 65366;
                t2.voarmenian = 1400;
                t2.voicediterationhiragana = 12446;
                t2.voicediterationkatakana = 12542;
                t2.voicedmarkkana = 12443;
                t2.voicedmarkkanahalfwidth = 65438;
                t2.vokatakana = 12538;
                t2.vparen = 9393;
                t2.vtilde = 7805;
                t2.vturned = 652;
                t2.vuhiragana = 12436;
                t2.vukatakana = 12532;
                t2.w = 119;
                t2.wacute = 7811;
                t2.waekorean = 12633;
                t2.wahiragana = 12431;
                t2.wakatakana = 12527;
                t2.wakatakanahalfwidth = 65436;
                t2.wakorean = 12632;
                t2.wasmallhiragana = 12430;
                t2.wasmallkatakana = 12526;
                t2.wattosquare = 13143;
                t2.wavedash = 12316;
                t2.wavyunderscorevertical = 65076;
                t2.wawarabic = 1608;
                t2.wawfinalarabic = 65262;
                t2.wawhamzaabovearabic = 1572;
                t2.wawhamzaabovefinalarabic = 65158;
                t2.wbsquare = 13277;
                t2.wcircle = 9446;
                t2.wcircumflex = 373;
                t2.wdieresis = 7813;
                t2.wdotaccent = 7815;
                t2.wdotbelow = 7817;
                t2.wehiragana = 12433;
                t2.weierstrass = 8472;
                t2.wekatakana = 12529;
                t2.wekorean = 12638;
                t2.weokorean = 12637;
                t2.wgrave = 7809;
                t2.whitebullet = 9702;
                t2.whitecircle = 9675;
                t2.whitecircleinverse = 9689;
                t2.whitecornerbracketleft = 12302;
                t2.whitecornerbracketleftvertical = 65091;
                t2.whitecornerbracketright = 12303;
                t2.whitecornerbracketrightvertical = 65092;
                t2.whitediamond = 9671;
                t2.whitediamondcontainingblacksmalldiamond = 9672;
                t2.whitedownpointingsmalltriangle = 9663;
                t2.whitedownpointingtriangle = 9661;
                t2.whiteleftpointingsmalltriangle = 9667;
                t2.whiteleftpointingtriangle = 9665;
                t2.whitelenticularbracketleft = 12310;
                t2.whitelenticularbracketright = 12311;
                t2.whiterightpointingsmalltriangle = 9657;
                t2.whiterightpointingtriangle = 9655;
                t2.whitesmallsquare = 9643;
                t2.whitesmilingface = 9786;
                t2.whitesquare = 9633;
                t2.whitestar = 9734;
                t2.whitetelephone = 9743;
                t2.whitetortoiseshellbracketleft = 12312;
                t2.whitetortoiseshellbracketright = 12313;
                t2.whiteuppointingsmalltriangle = 9653;
                t2.whiteuppointingtriangle = 9651;
                t2.wihiragana = 12432;
                t2.wikatakana = 12528;
                t2.wikorean = 12639;
                t2.wmonospace = 65367;
                t2.wohiragana = 12434;
                t2.wokatakana = 12530;
                t2.wokatakanahalfwidth = 65382;
                t2.won = 8361;
                t2.wonmonospace = 65510;
                t2.wowaenthai = 3623;
                t2.wparen = 9394;
                t2.wring = 7832;
                t2.wsuperior = 695;
                t2.wturned = 653;
                t2.wynn = 447;
                t2.x = 120;
                t2.xabovecmb = 829;
                t2.xbopomofo = 12562;
                t2.xcircle = 9447;
                t2.xdieresis = 7821;
                t2.xdotaccent = 7819;
                t2.xeharmenian = 1389;
                t2.xi = 958;
                t2.xmonospace = 65368;
                t2.xparen = 9395;
                t2.xsuperior = 739;
                t2.y = 121;
                t2.yaadosquare = 13134;
                t2.yabengali = 2479;
                t2.yacute = 253;
                t2.yadeva = 2351;
                t2.yaekorean = 12626;
                t2.yagujarati = 2735;
                t2.yagurmukhi = 2607;
                t2.yahiragana = 12420;
                t2.yakatakana = 12516;
                t2.yakatakanahalfwidth = 65428;
                t2.yakorean = 12625;
                t2.yamakkanthai = 3662;
                t2.yasmallhiragana = 12419;
                t2.yasmallkatakana = 12515;
                t2.yasmallkatakanahalfwidth = 65388;
                t2.yatcyrillic = 1123;
                t2.ycircle = 9448;
                t2.ycircumflex = 375;
                t2.ydieresis = 255;
                t2.ydotaccent = 7823;
                t2.ydotbelow = 7925;
                t2.yeharabic = 1610;
                t2.yehbarreearabic = 1746;
                t2.yehbarreefinalarabic = 64431;
                t2.yehfinalarabic = 65266;
                t2.yehhamzaabovearabic = 1574;
                t2.yehhamzaabovefinalarabic = 65162;
                t2.yehhamzaaboveinitialarabic = 65163;
                t2.yehhamzaabovemedialarabic = 65164;
                t2.yehinitialarabic = 65267;
                t2.yehmedialarabic = 65268;
                t2.yehmeeminitialarabic = 64733;
                t2.yehmeemisolatedarabic = 64600;
                t2.yehnoonfinalarabic = 64660;
                t2.yehthreedotsbelowarabic = 1745;
                t2.yekorean = 12630;
                t2.yen = 165;
                t2.yenmonospace = 65509;
                t2.yeokorean = 12629;
                t2.yeorinhieuhkorean = 12678;
                t2.yerahbenyomohebrew = 1450;
                t2.yerahbenyomolefthebrew = 1450;
                t2.yericyrillic = 1099;
                t2.yerudieresiscyrillic = 1273;
                t2.yesieungkorean = 12673;
                t2.yesieungpansioskorean = 12675;
                t2.yesieungsioskorean = 12674;
                t2.yetivhebrew = 1434;
                t2.ygrave = 7923;
                t2.yhook = 436;
                t2.yhookabove = 7927;
                t2.yiarmenian = 1397;
                t2.yicyrillic = 1111;
                t2.yikorean = 12642;
                t2.yinyang = 9775;
                t2.yiwnarmenian = 1410;
                t2.ymonospace = 65369;
                t2.yod = 1497;
                t2.yoddagesh = 64313;
                t2.yoddageshhebrew = 64313;
                t2.yodhebrew = 1497;
                t2.yodyodhebrew = 1522;
                t2.yodyodpatahhebrew = 64287;
                t2.yohiragana = 12424;
                t2.yoikorean = 12681;
                t2.yokatakana = 12520;
                t2.yokatakanahalfwidth = 65430;
                t2.yokorean = 12635;
                t2.yosmallhiragana = 12423;
                t2.yosmallkatakana = 12519;
                t2.yosmallkatakanahalfwidth = 65390;
                t2.yotgreek = 1011;
                t2.yoyaekorean = 12680;
                t2.yoyakorean = 12679;
                t2.yoyakthai = 3618;
                t2.yoyingthai = 3597;
                t2.yparen = 9396;
                t2.ypogegrammeni = 890;
                t2.ypogegrammenigreekcmb = 837;
                t2.yr = 422;
                t2.yring = 7833;
                t2.ysuperior = 696;
                t2.ytilde = 7929;
                t2.yturned = 654;
                t2.yuhiragana = 12422;
                t2.yuikorean = 12684;
                t2.yukatakana = 12518;
                t2.yukatakanahalfwidth = 65429;
                t2.yukorean = 12640;
                t2.yusbigcyrillic = 1131;
                t2.yusbigiotifiedcyrillic = 1133;
                t2.yuslittlecyrillic = 1127;
                t2.yuslittleiotifiedcyrillic = 1129;
                t2.yusmallhiragana = 12421;
                t2.yusmallkatakana = 12517;
                t2.yusmallkatakanahalfwidth = 65389;
                t2.yuyekorean = 12683;
                t2.yuyeokorean = 12682;
                t2.yyabengali = 2527;
                t2.yyadeva = 2399;
                t2.z = 122;
                t2.zaarmenian = 1382;
                t2.zacute = 378;
                t2.zadeva = 2395;
                t2.zagurmukhi = 2651;
                t2.zaharabic = 1592;
                t2.zahfinalarabic = 65222;
                t2.zahinitialarabic = 65223;
                t2.zahiragana = 12374;
                t2.zahmedialarabic = 65224;
                t2.zainarabic = 1586;
                t2.zainfinalarabic = 65200;
                t2.zakatakana = 12470;
                t2.zaqefgadolhebrew = 1429;
                t2.zaqefqatanhebrew = 1428;
                t2.zarqahebrew = 1432;
                t2.zayin = 1494;
                t2.zayindagesh = 64310;
                t2.zayindageshhebrew = 64310;
                t2.zayinhebrew = 1494;
                t2.zbopomofo = 12567;
                t2.zcaron = 382;
                t2.zcircle = 9449;
                t2.zcircumflex = 7825;
                t2.zcurl = 657;
                t2.zdot = 380;
                t2.zdotaccent = 380;
                t2.zdotbelow = 7827;
                t2.zecyrillic = 1079;
                t2.zedescendercyrillic = 1177;
                t2.zedieresiscyrillic = 1247;
                t2.zehiragana = 12380;
                t2.zekatakana = 12476;
                t2.zero = 48;
                t2.zeroarabic = 1632;
                t2.zerobengali = 2534;
                t2.zerodeva = 2406;
                t2.zerogujarati = 2790;
                t2.zerogurmukhi = 2662;
                t2.zerohackarabic = 1632;
                t2.zeroinferior = 8320;
                t2.zeromonospace = 65296;
                t2.zerooldstyle = 63280;
                t2.zeropersian = 1776;
                t2.zerosuperior = 8304;
                t2.zerothai = 3664;
                t2.zerowidthjoiner = 65279;
                t2.zerowidthnonjoiner = 8204;
                t2.zerowidthspace = 8203;
                t2.zeta = 950;
                t2.zhbopomofo = 12563;
                t2.zhearmenian = 1386;
                t2.zhebrevecyrillic = 1218;
                t2.zhecyrillic = 1078;
                t2.zhedescendercyrillic = 1175;
                t2.zhedieresiscyrillic = 1245;
                t2.zihiragana = 12376;
                t2.zikatakana = 12472;
                t2.zinorhebrew = 1454;
                t2.zlinebelow = 7829;
                t2.zmonospace = 65370;
                t2.zohiragana = 12382;
                t2.zokatakana = 12478;
                t2.zparen = 9397;
                t2.zretroflexhook = 656;
                t2.zstroke = 438;
                t2.zuhiragana = 12378;
                t2.zukatakana = 12474;
                t2[".notdef"] = 0;
                t2.angbracketleftbig = 9001;
                t2.angbracketleftBig = 9001;
                t2.angbracketleftbigg = 9001;
                t2.angbracketleftBigg = 9001;
                t2.angbracketrightBig = 9002;
                t2.angbracketrightbig = 9002;
                t2.angbracketrightBigg = 9002;
                t2.angbracketrightbigg = 9002;
                t2.arrowhookleft = 8618;
                t2.arrowhookright = 8617;
                t2.arrowlefttophalf = 8636;
                t2.arrowleftbothalf = 8637;
                t2.arrownortheast = 8599;
                t2.arrownorthwest = 8598;
                t2.arrowrighttophalf = 8640;
                t2.arrowrightbothalf = 8641;
                t2.arrowsoutheast = 8600;
                t2.arrowsouthwest = 8601;
                t2.backslashbig = 8726;
                t2.backslashBig = 8726;
                t2.backslashBigg = 8726;
                t2.backslashbigg = 8726;
                t2.bardbl = 8214;
                t2.bracehtipdownleft = 65079;
                t2.bracehtipdownright = 65079;
                t2.bracehtipupleft = 65080;
                t2.bracehtipupright = 65080;
                t2.braceleftBig = 123;
                t2.braceleftbig = 123;
                t2.braceleftbigg = 123;
                t2.braceleftBigg = 123;
                t2.bracerightBig = 125;
                t2.bracerightbig = 125;
                t2.bracerightbigg = 125;
                t2.bracerightBigg = 125;
                t2.bracketleftbig = 91;
                t2.bracketleftBig = 91;
                t2.bracketleftbigg = 91;
                t2.bracketleftBigg = 91;
                t2.bracketrightBig = 93;
                t2.bracketrightbig = 93;
                t2.bracketrightbigg = 93;
                t2.bracketrightBigg = 93;
                t2.ceilingleftbig = 8968;
                t2.ceilingleftBig = 8968;
                t2.ceilingleftBigg = 8968;
                t2.ceilingleftbigg = 8968;
                t2.ceilingrightbig = 8969;
                t2.ceilingrightBig = 8969;
                t2.ceilingrightbigg = 8969;
                t2.ceilingrightBigg = 8969;
                t2.circledotdisplay = 8857;
                t2.circledottext = 8857;
                t2.circlemultiplydisplay = 8855;
                t2.circlemultiplytext = 8855;
                t2.circleplusdisplay = 8853;
                t2.circleplustext = 8853;
                t2.contintegraldisplay = 8750;
                t2.contintegraltext = 8750;
                t2.coproductdisplay = 8720;
                t2.coproducttext = 8720;
                t2.floorleftBig = 8970;
                t2.floorleftbig = 8970;
                t2.floorleftbigg = 8970;
                t2.floorleftBigg = 8970;
                t2.floorrightbig = 8971;
                t2.floorrightBig = 8971;
                t2.floorrightBigg = 8971;
                t2.floorrightbigg = 8971;
                t2.hatwide = 770;
                t2.hatwider = 770;
                t2.hatwidest = 770;
                t2.intercal = 7488;
                t2.integraldisplay = 8747;
                t2.integraltext = 8747;
                t2.intersectiondisplay = 8898;
                t2.intersectiontext = 8898;
                t2.logicalanddisplay = 8743;
                t2.logicalandtext = 8743;
                t2.logicalordisplay = 8744;
                t2.logicalortext = 8744;
                t2.parenleftBig = 40;
                t2.parenleftbig = 40;
                t2.parenleftBigg = 40;
                t2.parenleftbigg = 40;
                t2.parenrightBig = 41;
                t2.parenrightbig = 41;
                t2.parenrightBigg = 41;
                t2.parenrightbigg = 41;
                t2.prime = 8242;
                t2.productdisplay = 8719;
                t2.producttext = 8719;
                t2.radicalbig = 8730;
                t2.radicalBig = 8730;
                t2.radicalBigg = 8730;
                t2.radicalbigg = 8730;
                t2.radicalbt = 8730;
                t2.radicaltp = 8730;
                t2.radicalvertex = 8730;
                t2.slashbig = 47;
                t2.slashBig = 47;
                t2.slashBigg = 47;
                t2.slashbigg = 47;
                t2.summationdisplay = 8721;
                t2.summationtext = 8721;
                t2.tildewide = 732;
                t2.tildewider = 732;
                t2.tildewidest = 732;
                t2.uniondisplay = 8899;
                t2.unionmultidisplay = 8846;
                t2.unionmultitext = 8846;
                t2.unionsqdisplay = 8852;
                t2.unionsqtext = 8852;
                t2.uniontext = 8899;
                t2.vextenddouble = 8741;
                t2.vextendsingle = 8739;
              });
              exports3.getGlyphsUnicode = getGlyphsUnicode;
              const getDingbatsGlyphsUnicode = (0, _core_utils.getLookupTableFactory)(function(t2) {
                t2.space = 32;
                t2.a1 = 9985;
                t2.a2 = 9986;
                t2.a202 = 9987;
                t2.a3 = 9988;
                t2.a4 = 9742;
                t2.a5 = 9990;
                t2.a119 = 9991;
                t2.a118 = 9992;
                t2.a117 = 9993;
                t2.a11 = 9755;
                t2.a12 = 9758;
                t2.a13 = 9996;
                t2.a14 = 9997;
                t2.a15 = 9998;
                t2.a16 = 9999;
                t2.a105 = 1e4;
                t2.a17 = 10001;
                t2.a18 = 10002;
                t2.a19 = 10003;
                t2.a20 = 10004;
                t2.a21 = 10005;
                t2.a22 = 10006;
                t2.a23 = 10007;
                t2.a24 = 10008;
                t2.a25 = 10009;
                t2.a26 = 10010;
                t2.a27 = 10011;
                t2.a28 = 10012;
                t2.a6 = 10013;
                t2.a7 = 10014;
                t2.a8 = 10015;
                t2.a9 = 10016;
                t2.a10 = 10017;
                t2.a29 = 10018;
                t2.a30 = 10019;
                t2.a31 = 10020;
                t2.a32 = 10021;
                t2.a33 = 10022;
                t2.a34 = 10023;
                t2.a35 = 9733;
                t2.a36 = 10025;
                t2.a37 = 10026;
                t2.a38 = 10027;
                t2.a39 = 10028;
                t2.a40 = 10029;
                t2.a41 = 10030;
                t2.a42 = 10031;
                t2.a43 = 10032;
                t2.a44 = 10033;
                t2.a45 = 10034;
                t2.a46 = 10035;
                t2.a47 = 10036;
                t2.a48 = 10037;
                t2.a49 = 10038;
                t2.a50 = 10039;
                t2.a51 = 10040;
                t2.a52 = 10041;
                t2.a53 = 10042;
                t2.a54 = 10043;
                t2.a55 = 10044;
                t2.a56 = 10045;
                t2.a57 = 10046;
                t2.a58 = 10047;
                t2.a59 = 10048;
                t2.a60 = 10049;
                t2.a61 = 10050;
                t2.a62 = 10051;
                t2.a63 = 10052;
                t2.a64 = 10053;
                t2.a65 = 10054;
                t2.a66 = 10055;
                t2.a67 = 10056;
                t2.a68 = 10057;
                t2.a69 = 10058;
                t2.a70 = 10059;
                t2.a71 = 9679;
                t2.a72 = 10061;
                t2.a73 = 9632;
                t2.a74 = 10063;
                t2.a203 = 10064;
                t2.a75 = 10065;
                t2.a204 = 10066;
                t2.a76 = 9650;
                t2.a77 = 9660;
                t2.a78 = 9670;
                t2.a79 = 10070;
                t2.a81 = 9687;
                t2.a82 = 10072;
                t2.a83 = 10073;
                t2.a84 = 10074;
                t2.a97 = 10075;
                t2.a98 = 10076;
                t2.a99 = 10077;
                t2.a100 = 10078;
                t2.a101 = 10081;
                t2.a102 = 10082;
                t2.a103 = 10083;
                t2.a104 = 10084;
                t2.a106 = 10085;
                t2.a107 = 10086;
                t2.a108 = 10087;
                t2.a112 = 9827;
                t2.a111 = 9830;
                t2.a110 = 9829;
                t2.a109 = 9824;
                t2.a120 = 9312;
                t2.a121 = 9313;
                t2.a122 = 9314;
                t2.a123 = 9315;
                t2.a124 = 9316;
                t2.a125 = 9317;
                t2.a126 = 9318;
                t2.a127 = 9319;
                t2.a128 = 9320;
                t2.a129 = 9321;
                t2.a130 = 10102;
                t2.a131 = 10103;
                t2.a132 = 10104;
                t2.a133 = 10105;
                t2.a134 = 10106;
                t2.a135 = 10107;
                t2.a136 = 10108;
                t2.a137 = 10109;
                t2.a138 = 10110;
                t2.a139 = 10111;
                t2.a140 = 10112;
                t2.a141 = 10113;
                t2.a142 = 10114;
                t2.a143 = 10115;
                t2.a144 = 10116;
                t2.a145 = 10117;
                t2.a146 = 10118;
                t2.a147 = 10119;
                t2.a148 = 10120;
                t2.a149 = 10121;
                t2.a150 = 10122;
                t2.a151 = 10123;
                t2.a152 = 10124;
                t2.a153 = 10125;
                t2.a154 = 10126;
                t2.a155 = 10127;
                t2.a156 = 10128;
                t2.a157 = 10129;
                t2.a158 = 10130;
                t2.a159 = 10131;
                t2.a160 = 10132;
                t2.a161 = 8594;
                t2.a163 = 8596;
                t2.a164 = 8597;
                t2.a196 = 10136;
                t2.a165 = 10137;
                t2.a192 = 10138;
                t2.a166 = 10139;
                t2.a167 = 10140;
                t2.a168 = 10141;
                t2.a169 = 10142;
                t2.a170 = 10143;
                t2.a171 = 10144;
                t2.a172 = 10145;
                t2.a173 = 10146;
                t2.a162 = 10147;
                t2.a174 = 10148;
                t2.a175 = 10149;
                t2.a176 = 10150;
                t2.a177 = 10151;
                t2.a178 = 10152;
                t2.a179 = 10153;
                t2.a193 = 10154;
                t2.a180 = 10155;
                t2.a199 = 10156;
                t2.a181 = 10157;
                t2.a200 = 10158;
                t2.a182 = 10159;
                t2.a201 = 10161;
                t2.a183 = 10162;
                t2.a184 = 10163;
                t2.a197 = 10164;
                t2.a185 = 10165;
                t2.a194 = 10166;
                t2.a198 = 10167;
                t2.a186 = 10168;
                t2.a195 = 10169;
                t2.a187 = 10170;
                t2.a188 = 10171;
                t2.a189 = 10172;
                t2.a190 = 10173;
                t2.a191 = 10174;
                t2.a89 = 10088;
                t2.a90 = 10089;
                t2.a93 = 10090;
                t2.a94 = 10091;
                t2.a91 = 10092;
                t2.a92 = 10093;
                t2.a205 = 10094;
                t2.a85 = 10095;
                t2.a206 = 10096;
                t2.a86 = 10097;
                t2.a87 = 10098;
                t2.a88 = 10099;
                t2.a95 = 10100;
                t2.a96 = 10101;
                t2[".notdef"] = 0;
              });
              exports3.getDingbatsGlyphsUnicode = getDingbatsGlyphsUnicode;
            }),
            /* 40 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.clearUnicodeCaches = clearUnicodeCaches;
              exports3.getCharUnicodeCategory = getCharUnicodeCategory;
              exports3.getUnicodeForGlyph = getUnicodeForGlyph;
              exports3.getUnicodeRangeFor = getUnicodeRangeFor;
              exports3.mapSpecialUnicodeValues = mapSpecialUnicodeValues;
              var _core_utils = __w_pdfjs_require__3(3);
              const getSpecialPUASymbols = (0, _core_utils.getLookupTableFactory)(function(t2) {
                t2[63721] = 169;
                t2[63193] = 169;
                t2[63720] = 174;
                t2[63194] = 174;
                t2[63722] = 8482;
                t2[63195] = 8482;
                t2[63729] = 9127;
                t2[63730] = 9128;
                t2[63731] = 9129;
                t2[63740] = 9131;
                t2[63741] = 9132;
                t2[63742] = 9133;
                t2[63726] = 9121;
                t2[63727] = 9122;
                t2[63728] = 9123;
                t2[63737] = 9124;
                t2[63738] = 9125;
                t2[63739] = 9126;
                t2[63723] = 9115;
                t2[63724] = 9116;
                t2[63725] = 9117;
                t2[63734] = 9118;
                t2[63735] = 9119;
                t2[63736] = 9120;
              });
              function mapSpecialUnicodeValues(code2) {
                if (code2 >= 65520 && code2 <= 65535) {
                  return 0;
                } else if (code2 >= 62976 && code2 <= 63743) {
                  return getSpecialPUASymbols()[code2] || code2;
                } else if (code2 === 173) {
                  return 45;
                }
                return code2;
              }
              function getUnicodeForGlyph(name, glyphsUnicodeMap) {
                let unicode = glyphsUnicodeMap[name];
                if (unicode !== void 0) {
                  return unicode;
                }
                if (!name) {
                  return -1;
                }
                if (name[0] === "u") {
                  const nameLen = name.length;
                  let hexStr;
                  if (nameLen === 7 && name[1] === "n" && name[2] === "i") {
                    hexStr = name.substring(3);
                  } else if (nameLen >= 5 && nameLen <= 7) {
                    hexStr = name.substring(1);
                  } else {
                    return -1;
                  }
                  if (hexStr === hexStr.toUpperCase()) {
                    unicode = parseInt(hexStr, 16);
                    if (unicode >= 0) {
                      return unicode;
                    }
                  }
                }
                return -1;
              }
              const UnicodeRanges = [[0, 127], [128, 255], [256, 383], [384, 591], [592, 687, 7424, 7551, 7552, 7615], [688, 767, 42752, 42783], [768, 879, 7616, 7679], [880, 1023], [11392, 11519], [1024, 1279, 1280, 1327, 11744, 11775, 42560, 42655], [1328, 1423], [1424, 1535], [42240, 42559], [1536, 1791, 1872, 1919], [1984, 2047], [2304, 2431], [2432, 2559], [2560, 2687], [2688, 2815], [2816, 2943], [2944, 3071], [3072, 3199], [3200, 3327], [3328, 3455], [3584, 3711], [3712, 3839], [4256, 4351, 11520, 11567], [6912, 7039], [4352, 4607], [7680, 7935, 11360, 11391, 42784, 43007], [7936, 8191], [8192, 8303, 11776, 11903], [8304, 8351], [8352, 8399], [8400, 8447], [8448, 8527], [8528, 8591], [8592, 8703, 10224, 10239, 10496, 10623, 11008, 11263], [8704, 8959, 10752, 11007, 10176, 10223, 10624, 10751], [8960, 9215], [9216, 9279], [9280, 9311], [9312, 9471], [9472, 9599], [9600, 9631], [9632, 9727], [9728, 9983], [9984, 10175], [12288, 12351], [12352, 12447], [12448, 12543, 12784, 12799], [12544, 12591, 12704, 12735], [12592, 12687], [43072, 43135], [12800, 13055], [13056, 13311], [44032, 55215], [55296, 57343], [67840, 67871], [19968, 40959, 11904, 12031, 12032, 12255, 12272, 12287, 13312, 19903, 131072, 173791, 12688, 12703], [57344, 63743], [12736, 12783, 63744, 64255, 194560, 195103], [64256, 64335], [64336, 65023], [65056, 65071], [65040, 65055], [65104, 65135], [65136, 65279], [65280, 65519], [65520, 65535], [3840, 4095], [1792, 1871], [1920, 1983], [3456, 3583], [4096, 4255], [4608, 4991, 4992, 5023, 11648, 11743], [5024, 5119], [5120, 5759], [5760, 5791], [5792, 5887], [6016, 6143], [6144, 6319], [10240, 10495], [40960, 42127], [5888, 5919, 5920, 5951, 5952, 5983, 5984, 6015], [66304, 66351], [66352, 66383], [66560, 66639], [118784, 119039, 119040, 119295, 119296, 119375], [119808, 120831], [1044480, 1048573], [65024, 65039, 917760, 917999], [917504, 917631], [6400, 6479], [6480, 6527], [6528, 6623], [6656, 6687], [11264, 11359], [11568, 11647], [19904, 19967], [43008, 43055], [65536, 65663, 65664, 65791, 65792, 65855], [65856, 65935], [66432, 66463], [66464, 66527], [66640, 66687], [66688, 66735], [67584, 67647], [68096, 68191], [119552, 119647], [73728, 74751, 74752, 74879], [119648, 119679], [7040, 7103], [7168, 7247], [7248, 7295], [43136, 43231], [43264, 43311], [43312, 43359], [43520, 43615], [65936, 65999], [66e3, 66047], [66208, 66271, 66176, 66207, 67872, 67903], [127024, 127135, 126976, 127023]];
              function getUnicodeRangeFor(value, lastPosition = -1) {
                if (lastPosition !== -1) {
                  const range3 = UnicodeRanges[lastPosition];
                  for (let i = 0, ii = range3.length; i < ii; i += 2) {
                    if (value >= range3[i] && value <= range3[i + 1]) {
                      return lastPosition;
                    }
                  }
                }
                for (let i = 0, ii = UnicodeRanges.length; i < ii; i++) {
                  const range3 = UnicodeRanges[i];
                  for (let j = 0, jj = range3.length; j < jj; j += 2) {
                    if (value >= range3[j] && value <= range3[j + 1]) {
                      return i;
                    }
                  }
                }
                return -1;
              }
              const SpecialCharRegExp = new RegExp("^(\\s)|(\\p{Mn})|(\\p{Cf})$", "u");
              const CategoryCache = /* @__PURE__ */ new Map();
              function getCharUnicodeCategory(char2) {
                const cachedCategory = CategoryCache.get(char2);
                if (cachedCategory) {
                  return cachedCategory;
                }
                const groups = char2.match(SpecialCharRegExp);
                const category = {
                  isWhitespace: !!groups?.[1],
                  isZeroWidthDiacritic: !!groups?.[2],
                  isInvisibleFormatMark: !!groups?.[3]
                };
                CategoryCache.set(char2, category);
                return category;
              }
              function clearUnicodeCaches() {
                CategoryCache.clear();
              }
            }),
            /* 41 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.getSerifFonts = exports3.getNonStdFontMap = exports3.getGlyphMapForStandardFonts = exports3.getFontNameToFileMap = void 0;
              exports3.getStandardFontName = getStandardFontName;
              exports3.getSymbolsFonts = exports3.getSupplementalGlyphMapForCalibri = exports3.getSupplementalGlyphMapForArialBlack = exports3.getStdFontMap = void 0;
              exports3.isKnownFontName = isKnownFontName;
              var _core_utils = __w_pdfjs_require__3(3);
              var _fonts_utils = __w_pdfjs_require__3(38);
              const getStdFontMap = (0, _core_utils.getLookupTableFactory)(function(t2) {
                t2["Times-Roman"] = "Times-Roman";
                t2.Helvetica = "Helvetica";
                t2.Courier = "Courier";
                t2.Symbol = "Symbol";
                t2["Times-Bold"] = "Times-Bold";
                t2["Helvetica-Bold"] = "Helvetica-Bold";
                t2["Courier-Bold"] = "Courier-Bold";
                t2.ZapfDingbats = "ZapfDingbats";
                t2["Times-Italic"] = "Times-Italic";
                t2["Helvetica-Oblique"] = "Helvetica-Oblique";
                t2["Courier-Oblique"] = "Courier-Oblique";
                t2["Times-BoldItalic"] = "Times-BoldItalic";
                t2["Helvetica-BoldOblique"] = "Helvetica-BoldOblique";
                t2["Courier-BoldOblique"] = "Courier-BoldOblique";
                t2.ArialNarrow = "Helvetica";
                t2["ArialNarrow-Bold"] = "Helvetica-Bold";
                t2["ArialNarrow-BoldItalic"] = "Helvetica-BoldOblique";
                t2["ArialNarrow-Italic"] = "Helvetica-Oblique";
                t2.ArialBlack = "Helvetica";
                t2["ArialBlack-Bold"] = "Helvetica-Bold";
                t2["ArialBlack-BoldItalic"] = "Helvetica-BoldOblique";
                t2["ArialBlack-Italic"] = "Helvetica-Oblique";
                t2["Arial-Black"] = "Helvetica";
                t2["Arial-Black-Bold"] = "Helvetica-Bold";
                t2["Arial-Black-BoldItalic"] = "Helvetica-BoldOblique";
                t2["Arial-Black-Italic"] = "Helvetica-Oblique";
                t2.Arial = "Helvetica";
                t2["Arial-Bold"] = "Helvetica-Bold";
                t2["Arial-BoldItalic"] = "Helvetica-BoldOblique";
                t2["Arial-Italic"] = "Helvetica-Oblique";
                t2.ArialMT = "Helvetica";
                t2["Arial-BoldItalicMT"] = "Helvetica-BoldOblique";
                t2["Arial-BoldMT"] = "Helvetica-Bold";
                t2["Arial-ItalicMT"] = "Helvetica-Oblique";
                t2["Arial-BoldItalicMT-BoldItalic"] = "Helvetica-BoldOblique";
                t2["Arial-BoldMT-Bold"] = "Helvetica-Bold";
                t2["Arial-ItalicMT-Italic"] = "Helvetica-Oblique";
                t2.ArialUnicodeMS = "Helvetica";
                t2["ArialUnicodeMS-Bold"] = "Helvetica-Bold";
                t2["ArialUnicodeMS-BoldItalic"] = "Helvetica-BoldOblique";
                t2["ArialUnicodeMS-Italic"] = "Helvetica-Oblique";
                t2["Courier-BoldItalic"] = "Courier-BoldOblique";
                t2["Courier-Italic"] = "Courier-Oblique";
                t2.CourierNew = "Courier";
                t2["CourierNew-Bold"] = "Courier-Bold";
                t2["CourierNew-BoldItalic"] = "Courier-BoldOblique";
                t2["CourierNew-Italic"] = "Courier-Oblique";
                t2["CourierNewPS-BoldItalicMT"] = "Courier-BoldOblique";
                t2["CourierNewPS-BoldMT"] = "Courier-Bold";
                t2["CourierNewPS-ItalicMT"] = "Courier-Oblique";
                t2.CourierNewPSMT = "Courier";
                t2["Helvetica-BoldItalic"] = "Helvetica-BoldOblique";
                t2["Helvetica-Italic"] = "Helvetica-Oblique";
                t2["Symbol-Bold"] = "Symbol";
                t2["Symbol-BoldItalic"] = "Symbol";
                t2["Symbol-Italic"] = "Symbol";
                t2.TimesNewRoman = "Times-Roman";
                t2["TimesNewRoman-Bold"] = "Times-Bold";
                t2["TimesNewRoman-BoldItalic"] = "Times-BoldItalic";
                t2["TimesNewRoman-Italic"] = "Times-Italic";
                t2.TimesNewRomanPS = "Times-Roman";
                t2["TimesNewRomanPS-Bold"] = "Times-Bold";
                t2["TimesNewRomanPS-BoldItalic"] = "Times-BoldItalic";
                t2["TimesNewRomanPS-BoldItalicMT"] = "Times-BoldItalic";
                t2["TimesNewRomanPS-BoldMT"] = "Times-Bold";
                t2["TimesNewRomanPS-Italic"] = "Times-Italic";
                t2["TimesNewRomanPS-ItalicMT"] = "Times-Italic";
                t2.TimesNewRomanPSMT = "Times-Roman";
                t2["TimesNewRomanPSMT-Bold"] = "Times-Bold";
                t2["TimesNewRomanPSMT-BoldItalic"] = "Times-BoldItalic";
                t2["TimesNewRomanPSMT-Italic"] = "Times-Italic";
              });
              exports3.getStdFontMap = getStdFontMap;
              const getFontNameToFileMap = (0, _core_utils.getLookupTableFactory)(function(t2) {
                t2.Courier = "FoxitFixed.pfb";
                t2["Courier-Bold"] = "FoxitFixedBold.pfb";
                t2["Courier-BoldOblique"] = "FoxitFixedBoldItalic.pfb";
                t2["Courier-Oblique"] = "FoxitFixedItalic.pfb";
                t2.Helvetica = "LiberationSans-Regular.ttf";
                t2["Helvetica-Bold"] = "LiberationSans-Bold.ttf";
                t2["Helvetica-BoldOblique"] = "LiberationSans-BoldItalic.ttf";
                t2["Helvetica-Oblique"] = "LiberationSans-Italic.ttf";
                t2["Times-Roman"] = "FoxitSerif.pfb";
                t2["Times-Bold"] = "FoxitSerifBold.pfb";
                t2["Times-BoldItalic"] = "FoxitSerifBoldItalic.pfb";
                t2["Times-Italic"] = "FoxitSerifItalic.pfb";
                t2.Symbol = "FoxitSymbol.pfb";
                t2.ZapfDingbats = "FoxitDingbats.pfb";
                t2["LiberationSans-Regular"] = "LiberationSans-Regular.ttf";
                t2["LiberationSans-Bold"] = "LiberationSans-Bold.ttf";
                t2["LiberationSans-Italic"] = "LiberationSans-Italic.ttf";
                t2["LiberationSans-BoldItalic"] = "LiberationSans-BoldItalic.ttf";
              });
              exports3.getFontNameToFileMap = getFontNameToFileMap;
              const getNonStdFontMap = (0, _core_utils.getLookupTableFactory)(function(t2) {
                t2.Calibri = "Helvetica";
                t2["Calibri-Bold"] = "Helvetica-Bold";
                t2["Calibri-BoldItalic"] = "Helvetica-BoldOblique";
                t2["Calibri-Italic"] = "Helvetica-Oblique";
                t2.CenturyGothic = "Helvetica";
                t2["CenturyGothic-Bold"] = "Helvetica-Bold";
                t2["CenturyGothic-BoldItalic"] = "Helvetica-BoldOblique";
                t2["CenturyGothic-Italic"] = "Helvetica-Oblique";
                t2.ComicSansMS = "Comic Sans MS";
                t2["ComicSansMS-Bold"] = "Comic Sans MS-Bold";
                t2["ComicSansMS-BoldItalic"] = "Comic Sans MS-BoldItalic";
                t2["ComicSansMS-Italic"] = "Comic Sans MS-Italic";
                t2.Impact = "Helvetica";
                t2["ItcSymbol-Bold"] = "Helvetica-Bold";
                t2["ItcSymbol-BoldItalic"] = "Helvetica-BoldOblique";
                t2["ItcSymbol-Book"] = "Helvetica";
                t2["ItcSymbol-BookItalic"] = "Helvetica-Oblique";
                t2["ItcSymbol-Medium"] = "Helvetica";
                t2["ItcSymbol-MediumItalic"] = "Helvetica-Oblique";
                t2.LucidaConsole = "Courier";
                t2["LucidaConsole-Bold"] = "Courier-Bold";
                t2["LucidaConsole-BoldItalic"] = "Courier-BoldOblique";
                t2["LucidaConsole-Italic"] = "Courier-Oblique";
                t2["LucidaSans-Demi"] = "Helvetica-Bold";
                t2["MS-Gothic"] = "MS Gothic";
                t2["MS-Gothic-Bold"] = "MS Gothic-Bold";
                t2["MS-Gothic-BoldItalic"] = "MS Gothic-BoldItalic";
                t2["MS-Gothic-Italic"] = "MS Gothic-Italic";
                t2["MS-Mincho"] = "MS Mincho";
                t2["MS-Mincho-Bold"] = "MS Mincho-Bold";
                t2["MS-Mincho-BoldItalic"] = "MS Mincho-BoldItalic";
                t2["MS-Mincho-Italic"] = "MS Mincho-Italic";
                t2["MS-PGothic"] = "MS PGothic";
                t2["MS-PGothic-Bold"] = "MS PGothic-Bold";
                t2["MS-PGothic-BoldItalic"] = "MS PGothic-BoldItalic";
                t2["MS-PGothic-Italic"] = "MS PGothic-Italic";
                t2["MS-PMincho"] = "MS PMincho";
                t2["MS-PMincho-Bold"] = "MS PMincho-Bold";
                t2["MS-PMincho-BoldItalic"] = "MS PMincho-BoldItalic";
                t2["MS-PMincho-Italic"] = "MS PMincho-Italic";
                t2.NuptialScript = "Times-Italic";
                t2.SegoeUISymbol = "Helvetica";
              });
              exports3.getNonStdFontMap = getNonStdFontMap;
              const getSerifFonts = (0, _core_utils.getLookupTableFactory)(function(t2) {
                t2["Adobe Jenson"] = true;
                t2["Adobe Text"] = true;
                t2.Albertus = true;
                t2.Aldus = true;
                t2.Alexandria = true;
                t2.Algerian = true;
                t2["American Typewriter"] = true;
                t2.Antiqua = true;
                t2.Apex = true;
                t2.Arno = true;
                t2.Aster = true;
                t2.Aurora = true;
                t2.Baskerville = true;
                t2.Bell = true;
                t2.Bembo = true;
                t2["Bembo Schoolbook"] = true;
                t2.Benguiat = true;
                t2["Berkeley Old Style"] = true;
                t2["Bernhard Modern"] = true;
                t2["Berthold City"] = true;
                t2.Bodoni = true;
                t2["Bauer Bodoni"] = true;
                t2["Book Antiqua"] = true;
                t2.Bookman = true;
                t2["Bordeaux Roman"] = true;
                t2["Californian FB"] = true;
                t2.Calisto = true;
                t2.Calvert = true;
                t2.Capitals = true;
                t2.Cambria = true;
                t2.Cartier = true;
                t2.Caslon = true;
                t2.Catull = true;
                t2.Centaur = true;
                t2["Century Old Style"] = true;
                t2["Century Schoolbook"] = true;
                t2.Chaparral = true;
                t2["Charis SIL"] = true;
                t2.Cheltenham = true;
                t2["Cholla Slab"] = true;
                t2.Clarendon = true;
                t2.Clearface = true;
                t2.Cochin = true;
                t2.Colonna = true;
                t2["Computer Modern"] = true;
                t2["Concrete Roman"] = true;
                t2.Constantia = true;
                t2["Cooper Black"] = true;
                t2.Corona = true;
                t2.Ecotype = true;
                t2.Egyptienne = true;
                t2.Elephant = true;
                t2.Excelsior = true;
                t2.Fairfield = true;
                t2["FF Scala"] = true;
                t2.Folkard = true;
                t2.Footlight = true;
                t2.FreeSerif = true;
                t2["Friz Quadrata"] = true;
                t2.Garamond = true;
                t2.Gentium = true;
                t2.Georgia = true;
                t2.Gloucester = true;
                t2["Goudy Old Style"] = true;
                t2["Goudy Schoolbook"] = true;
                t2["Goudy Pro Font"] = true;
                t2.Granjon = true;
                t2["Guardian Egyptian"] = true;
                t2.Heather = true;
                t2.Hercules = true;
                t2["High Tower Text"] = true;
                t2.Hiroshige = true;
                t2["Hoefler Text"] = true;
                t2["Humana Serif"] = true;
                t2.Imprint = true;
                t2["Ionic No. 5"] = true;
                t2.Janson = true;
                t2.Joanna = true;
                t2.Korinna = true;
                t2.Lexicon = true;
                t2.LiberationSerif = true;
                t2["Liberation Serif"] = true;
                t2["Linux Libertine"] = true;
                t2.Literaturnaya = true;
                t2.Lucida = true;
                t2["Lucida Bright"] = true;
                t2.Melior = true;
                t2.Memphis = true;
                t2.Miller = true;
                t2.Minion = true;
                t2.Modern = true;
                t2["Mona Lisa"] = true;
                t2["Mrs Eaves"] = true;
                t2["MS Serif"] = true;
                t2["Museo Slab"] = true;
                t2["New York"] = true;
                t2["Nimbus Roman"] = true;
                t2["NPS Rawlinson Roadway"] = true;
                t2.NuptialScript = true;
                t2.Palatino = true;
                t2.Perpetua = true;
                t2.Plantin = true;
                t2["Plantin Schoolbook"] = true;
                t2.Playbill = true;
                t2["Poor Richard"] = true;
                t2["Rawlinson Roadway"] = true;
                t2.Renault = true;
                t2.Requiem = true;
                t2.Rockwell = true;
                t2.Roman = true;
                t2["Rotis Serif"] = true;
                t2.Sabon = true;
                t2.Scala = true;
                t2.Seagull = true;
                t2.Sistina = true;
                t2.Souvenir = true;
                t2.STIX = true;
                t2["Stone Informal"] = true;
                t2["Stone Serif"] = true;
                t2.Sylfaen = true;
                t2.Times = true;
                t2.Trajan = true;
                t2["Trinit\xE9"] = true;
                t2["Trump Mediaeval"] = true;
                t2.Utopia = true;
                t2["Vale Type"] = true;
                t2["Bitstream Vera"] = true;
                t2["Vera Serif"] = true;
                t2.Versailles = true;
                t2.Wanted = true;
                t2.Weiss = true;
                t2["Wide Latin"] = true;
                t2.Windsor = true;
                t2.XITS = true;
              });
              exports3.getSerifFonts = getSerifFonts;
              const getSymbolsFonts = (0, _core_utils.getLookupTableFactory)(function(t2) {
                t2.Dingbats = true;
                t2.Symbol = true;
                t2.ZapfDingbats = true;
                t2.Wingdings = true;
                t2["Wingdings-Bold"] = true;
                t2["Wingdings-Regular"] = true;
              });
              exports3.getSymbolsFonts = getSymbolsFonts;
              const getGlyphMapForStandardFonts = (0, _core_utils.getLookupTableFactory)(function(t2) {
                t2[2] = 10;
                t2[3] = 32;
                t2[4] = 33;
                t2[5] = 34;
                t2[6] = 35;
                t2[7] = 36;
                t2[8] = 37;
                t2[9] = 38;
                t2[10] = 39;
                t2[11] = 40;
                t2[12] = 41;
                t2[13] = 42;
                t2[14] = 43;
                t2[15] = 44;
                t2[16] = 45;
                t2[17] = 46;
                t2[18] = 47;
                t2[19] = 48;
                t2[20] = 49;
                t2[21] = 50;
                t2[22] = 51;
                t2[23] = 52;
                t2[24] = 53;
                t2[25] = 54;
                t2[26] = 55;
                t2[27] = 56;
                t2[28] = 57;
                t2[29] = 58;
                t2[30] = 894;
                t2[31] = 60;
                t2[32] = 61;
                t2[33] = 62;
                t2[34] = 63;
                t2[35] = 64;
                t2[36] = 65;
                t2[37] = 66;
                t2[38] = 67;
                t2[39] = 68;
                t2[40] = 69;
                t2[41] = 70;
                t2[42] = 71;
                t2[43] = 72;
                t2[44] = 73;
                t2[45] = 74;
                t2[46] = 75;
                t2[47] = 76;
                t2[48] = 77;
                t2[49] = 78;
                t2[50] = 79;
                t2[51] = 80;
                t2[52] = 81;
                t2[53] = 82;
                t2[54] = 83;
                t2[55] = 84;
                t2[56] = 85;
                t2[57] = 86;
                t2[58] = 87;
                t2[59] = 88;
                t2[60] = 89;
                t2[61] = 90;
                t2[62] = 91;
                t2[63] = 92;
                t2[64] = 93;
                t2[65] = 94;
                t2[66] = 95;
                t2[67] = 96;
                t2[68] = 97;
                t2[69] = 98;
                t2[70] = 99;
                t2[71] = 100;
                t2[72] = 101;
                t2[73] = 102;
                t2[74] = 103;
                t2[75] = 104;
                t2[76] = 105;
                t2[77] = 106;
                t2[78] = 107;
                t2[79] = 108;
                t2[80] = 109;
                t2[81] = 110;
                t2[82] = 111;
                t2[83] = 112;
                t2[84] = 113;
                t2[85] = 114;
                t2[86] = 115;
                t2[87] = 116;
                t2[88] = 117;
                t2[89] = 118;
                t2[90] = 119;
                t2[91] = 120;
                t2[92] = 121;
                t2[93] = 122;
                t2[94] = 123;
                t2[95] = 124;
                t2[96] = 125;
                t2[97] = 126;
                t2[98] = 196;
                t2[99] = 197;
                t2[100] = 199;
                t2[101] = 201;
                t2[102] = 209;
                t2[103] = 214;
                t2[104] = 220;
                t2[105] = 225;
                t2[106] = 224;
                t2[107] = 226;
                t2[108] = 228;
                t2[109] = 227;
                t2[110] = 229;
                t2[111] = 231;
                t2[112] = 233;
                t2[113] = 232;
                t2[114] = 234;
                t2[115] = 235;
                t2[116] = 237;
                t2[117] = 236;
                t2[118] = 238;
                t2[119] = 239;
                t2[120] = 241;
                t2[121] = 243;
                t2[122] = 242;
                t2[123] = 244;
                t2[124] = 246;
                t2[125] = 245;
                t2[126] = 250;
                t2[127] = 249;
                t2[128] = 251;
                t2[129] = 252;
                t2[130] = 8224;
                t2[131] = 176;
                t2[132] = 162;
                t2[133] = 163;
                t2[134] = 167;
                t2[135] = 8226;
                t2[136] = 182;
                t2[137] = 223;
                t2[138] = 174;
                t2[139] = 169;
                t2[140] = 8482;
                t2[141] = 180;
                t2[142] = 168;
                t2[143] = 8800;
                t2[144] = 198;
                t2[145] = 216;
                t2[146] = 8734;
                t2[147] = 177;
                t2[148] = 8804;
                t2[149] = 8805;
                t2[150] = 165;
                t2[151] = 181;
                t2[152] = 8706;
                t2[153] = 8721;
                t2[154] = 8719;
                t2[156] = 8747;
                t2[157] = 170;
                t2[158] = 186;
                t2[159] = 8486;
                t2[160] = 230;
                t2[161] = 248;
                t2[162] = 191;
                t2[163] = 161;
                t2[164] = 172;
                t2[165] = 8730;
                t2[166] = 402;
                t2[167] = 8776;
                t2[168] = 8710;
                t2[169] = 171;
                t2[170] = 187;
                t2[171] = 8230;
                t2[179] = 8220;
                t2[180] = 8221;
                t2[181] = 8216;
                t2[182] = 8217;
                t2[200] = 193;
                t2[203] = 205;
                t2[207] = 211;
                t2[210] = 218;
                t2[223] = 711;
                t2[224] = 321;
                t2[225] = 322;
                t2[226] = 352;
                t2[227] = 353;
                t2[228] = 381;
                t2[229] = 382;
                t2[233] = 221;
                t2[234] = 253;
                t2[252] = 263;
                t2[253] = 268;
                t2[254] = 269;
                t2[258] = 258;
                t2[260] = 260;
                t2[261] = 261;
                t2[265] = 280;
                t2[266] = 281;
                t2[267] = 282;
                t2[268] = 283;
                t2[269] = 313;
                t2[275] = 323;
                t2[276] = 324;
                t2[278] = 328;
                t2[283] = 344;
                t2[284] = 345;
                t2[285] = 346;
                t2[286] = 347;
                t2[292] = 367;
                t2[295] = 377;
                t2[296] = 378;
                t2[298] = 380;
                t2[305] = 963;
                t2[306] = 964;
                t2[307] = 966;
                t2[308] = 8215;
                t2[309] = 8252;
                t2[310] = 8319;
                t2[311] = 8359;
                t2[312] = 8592;
                t2[313] = 8593;
                t2[337] = 9552;
                t2[493] = 1039;
                t2[494] = 1040;
                t2[672] = 1488;
                t2[673] = 1489;
                t2[674] = 1490;
                t2[675] = 1491;
                t2[676] = 1492;
                t2[677] = 1493;
                t2[678] = 1494;
                t2[679] = 1495;
                t2[680] = 1496;
                t2[681] = 1497;
                t2[682] = 1498;
                t2[683] = 1499;
                t2[684] = 1500;
                t2[685] = 1501;
                t2[686] = 1502;
                t2[687] = 1503;
                t2[688] = 1504;
                t2[689] = 1505;
                t2[690] = 1506;
                t2[691] = 1507;
                t2[692] = 1508;
                t2[693] = 1509;
                t2[694] = 1510;
                t2[695] = 1511;
                t2[696] = 1512;
                t2[697] = 1513;
                t2[698] = 1514;
                t2[705] = 1524;
                t2[706] = 8362;
                t2[710] = 64288;
                t2[711] = 64298;
                t2[759] = 1617;
                t2[761] = 1776;
                t2[763] = 1778;
                t2[775] = 1652;
                t2[777] = 1764;
                t2[778] = 1780;
                t2[779] = 1781;
                t2[780] = 1782;
                t2[782] = 771;
                t2[783] = 64726;
                t2[786] = 8363;
                t2[788] = 8532;
                t2[790] = 768;
                t2[791] = 769;
                t2[792] = 768;
                t2[795] = 803;
                t2[797] = 64336;
                t2[798] = 64337;
                t2[799] = 64342;
                t2[800] = 64343;
                t2[801] = 64344;
                t2[802] = 64345;
                t2[803] = 64362;
                t2[804] = 64363;
                t2[805] = 64364;
                t2[2424] = 7821;
                t2[2425] = 7822;
                t2[2426] = 7823;
                t2[2427] = 7824;
                t2[2428] = 7825;
                t2[2429] = 7826;
                t2[2430] = 7827;
                t2[2433] = 7682;
                t2[2678] = 8045;
                t2[2679] = 8046;
                t2[2830] = 1552;
                t2[2838] = 686;
                t2[2840] = 751;
                t2[2842] = 753;
                t2[2843] = 754;
                t2[2844] = 755;
                t2[2846] = 757;
                t2[2856] = 767;
                t2[2857] = 848;
                t2[2858] = 849;
                t2[2862] = 853;
                t2[2863] = 854;
                t2[2864] = 855;
                t2[2865] = 861;
                t2[2866] = 862;
                t2[2906] = 7460;
                t2[2908] = 7462;
                t2[2909] = 7463;
                t2[2910] = 7464;
                t2[2912] = 7466;
                t2[2913] = 7467;
                t2[2914] = 7468;
                t2[2916] = 7470;
                t2[2917] = 7471;
                t2[2918] = 7472;
                t2[2920] = 7474;
                t2[2921] = 7475;
                t2[2922] = 7476;
                t2[2924] = 7478;
                t2[2925] = 7479;
                t2[2926] = 7480;
                t2[2928] = 7482;
                t2[2929] = 7483;
                t2[2930] = 7484;
                t2[2932] = 7486;
                t2[2933] = 7487;
                t2[2934] = 7488;
                t2[2936] = 7490;
                t2[2937] = 7491;
                t2[2938] = 7492;
                t2[2940] = 7494;
                t2[2941] = 7495;
                t2[2942] = 7496;
                t2[2944] = 7498;
                t2[2946] = 7500;
                t2[2948] = 7502;
                t2[2950] = 7504;
                t2[2951] = 7505;
                t2[2952] = 7506;
                t2[2954] = 7508;
                t2[2955] = 7509;
                t2[2956] = 7510;
                t2[2958] = 7512;
                t2[2959] = 7513;
                t2[2960] = 7514;
                t2[2962] = 7516;
                t2[2963] = 7517;
                t2[2964] = 7518;
                t2[2966] = 7520;
                t2[2967] = 7521;
                t2[2968] = 7522;
                t2[2970] = 7524;
                t2[2971] = 7525;
                t2[2972] = 7526;
                t2[2974] = 7528;
                t2[2975] = 7529;
                t2[2976] = 7530;
                t2[2978] = 1537;
                t2[2979] = 1538;
                t2[2980] = 1539;
                t2[2982] = 1549;
                t2[2983] = 1551;
                t2[2984] = 1552;
                t2[2986] = 1554;
                t2[2987] = 1555;
                t2[2988] = 1556;
                t2[2990] = 1623;
                t2[2991] = 1624;
                t2[2995] = 1775;
                t2[2999] = 1791;
                t2[3002] = 64290;
                t2[3003] = 64291;
                t2[3004] = 64292;
                t2[3006] = 64294;
                t2[3007] = 64295;
                t2[3008] = 64296;
                t2[3011] = 1900;
                t2[3014] = 8223;
                t2[3015] = 8244;
                t2[3017] = 7532;
                t2[3018] = 7533;
                t2[3019] = 7534;
                t2[3075] = 7590;
                t2[3076] = 7591;
                t2[3079] = 7594;
                t2[3080] = 7595;
                t2[3083] = 7598;
                t2[3084] = 7599;
                t2[3087] = 7602;
                t2[3088] = 7603;
                t2[3091] = 7606;
                t2[3092] = 7607;
                t2[3095] = 7610;
                t2[3096] = 7611;
                t2[3099] = 7614;
                t2[3100] = 7615;
                t2[3103] = 7618;
                t2[3104] = 7619;
                t2[3107] = 8337;
                t2[3108] = 8338;
                t2[3116] = 1884;
                t2[3119] = 1885;
                t2[3120] = 1885;
                t2[3123] = 1886;
                t2[3124] = 1886;
                t2[3127] = 1887;
                t2[3128] = 1887;
                t2[3131] = 1888;
                t2[3132] = 1888;
                t2[3135] = 1889;
                t2[3136] = 1889;
                t2[3139] = 1890;
                t2[3140] = 1890;
                t2[3143] = 1891;
                t2[3144] = 1891;
                t2[3147] = 1892;
                t2[3148] = 1892;
                t2[3153] = 580;
                t2[3154] = 581;
                t2[3157] = 584;
                t2[3158] = 585;
                t2[3161] = 588;
                t2[3162] = 589;
                t2[3165] = 891;
                t2[3166] = 892;
                t2[3169] = 1274;
                t2[3170] = 1275;
                t2[3173] = 1278;
                t2[3174] = 1279;
                t2[3181] = 7622;
                t2[3182] = 7623;
                t2[3282] = 11799;
                t2[3316] = 578;
                t2[3379] = 42785;
                t2[3393] = 1159;
                t2[3416] = 8377;
              });
              exports3.getGlyphMapForStandardFonts = getGlyphMapForStandardFonts;
              const getSupplementalGlyphMapForArialBlack = (0, _core_utils.getLookupTableFactory)(function(t2) {
                t2[227] = 322;
                t2[264] = 261;
                t2[291] = 346;
              });
              exports3.getSupplementalGlyphMapForArialBlack = getSupplementalGlyphMapForArialBlack;
              const getSupplementalGlyphMapForCalibri = (0, _core_utils.getLookupTableFactory)(function(t2) {
                t2[1] = 32;
                t2[4] = 65;
                t2[5] = 192;
                t2[6] = 193;
                t2[9] = 196;
                t2[17] = 66;
                t2[18] = 67;
                t2[21] = 268;
                t2[24] = 68;
                t2[28] = 69;
                t2[29] = 200;
                t2[30] = 201;
                t2[32] = 282;
                t2[38] = 70;
                t2[39] = 71;
                t2[44] = 72;
                t2[47] = 73;
                t2[48] = 204;
                t2[49] = 205;
                t2[58] = 74;
                t2[60] = 75;
                t2[62] = 76;
                t2[68] = 77;
                t2[69] = 78;
                t2[75] = 79;
                t2[76] = 210;
                t2[80] = 214;
                t2[87] = 80;
                t2[89] = 81;
                t2[90] = 82;
                t2[92] = 344;
                t2[94] = 83;
                t2[97] = 352;
                t2[100] = 84;
                t2[104] = 85;
                t2[109] = 220;
                t2[115] = 86;
                t2[116] = 87;
                t2[121] = 88;
                t2[122] = 89;
                t2[124] = 221;
                t2[127] = 90;
                t2[129] = 381;
                t2[258] = 97;
                t2[259] = 224;
                t2[260] = 225;
                t2[263] = 228;
                t2[268] = 261;
                t2[271] = 98;
                t2[272] = 99;
                t2[273] = 263;
                t2[275] = 269;
                t2[282] = 100;
                t2[286] = 101;
                t2[287] = 232;
                t2[288] = 233;
                t2[290] = 283;
                t2[295] = 281;
                t2[296] = 102;
                t2[336] = 103;
                t2[346] = 104;
                t2[349] = 105;
                t2[350] = 236;
                t2[351] = 237;
                t2[361] = 106;
                t2[364] = 107;
                t2[367] = 108;
                t2[371] = 322;
                t2[373] = 109;
                t2[374] = 110;
                t2[381] = 111;
                t2[382] = 242;
                t2[383] = 243;
                t2[386] = 246;
                t2[393] = 112;
                t2[395] = 113;
                t2[396] = 114;
                t2[398] = 345;
                t2[400] = 115;
                t2[401] = 347;
                t2[403] = 353;
                t2[410] = 116;
                t2[437] = 117;
                t2[442] = 252;
                t2[448] = 118;
                t2[449] = 119;
                t2[454] = 120;
                t2[455] = 121;
                t2[457] = 253;
                t2[460] = 122;
                t2[462] = 382;
                t2[463] = 380;
                t2[853] = 44;
                t2[855] = 58;
                t2[856] = 46;
                t2[876] = 47;
                t2[878] = 45;
                t2[882] = 45;
                t2[894] = 40;
                t2[895] = 41;
                t2[896] = 91;
                t2[897] = 93;
                t2[923] = 64;
                t2[1004] = 48;
                t2[1005] = 49;
                t2[1006] = 50;
                t2[1007] = 51;
                t2[1008] = 52;
                t2[1009] = 53;
                t2[1010] = 54;
                t2[1011] = 55;
                t2[1012] = 56;
                t2[1013] = 57;
                t2[1081] = 37;
                t2[1085] = 43;
                t2[1086] = 45;
              });
              exports3.getSupplementalGlyphMapForCalibri = getSupplementalGlyphMapForCalibri;
              function getStandardFontName(name) {
                const fontName = (0, _fonts_utils.normalizeFontName)(name);
                const stdFontMap = getStdFontMap();
                return stdFontMap[fontName];
              }
              function isKnownFontName(name) {
                const fontName = (0, _fonts_utils.normalizeFontName)(name);
                return !!(getStdFontMap()[fontName] || getNonStdFontMap()[fontName] || getSerifFonts()[fontName] || getSymbolsFonts()[fontName]);
              }
            }),
            /* 42 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.ToUnicodeMap = exports3.IdentityToUnicodeMap = void 0;
              var _util2 = __w_pdfjs_require__3(2);
              class ToUnicodeMap {
                constructor(cmap = []) {
                  this._map = cmap;
                }
                get length() {
                  return this._map.length;
                }
                forEach(callback) {
                  for (const charCode in this._map) {
                    callback(charCode, this._map[charCode].charCodeAt(0));
                  }
                }
                has(i) {
                  return this._map[i] !== void 0;
                }
                get(i) {
                  return this._map[i];
                }
                charCodeOf(value) {
                  const map = this._map;
                  if (map.length <= 65536) {
                    return map.indexOf(value);
                  }
                  for (const charCode in map) {
                    if (map[charCode] === value) {
                      return charCode | 0;
                    }
                  }
                  return -1;
                }
                amend(map) {
                  for (const charCode in map) {
                    this._map[charCode] = map[charCode];
                  }
                }
              }
              exports3.ToUnicodeMap = ToUnicodeMap;
              class IdentityToUnicodeMap {
                constructor(firstChar, lastChar) {
                  this.firstChar = firstChar;
                  this.lastChar = lastChar;
                }
                get length() {
                  return this.lastChar + 1 - this.firstChar;
                }
                forEach(callback) {
                  for (let i = this.firstChar, ii = this.lastChar; i <= ii; i++) {
                    callback(i, i);
                  }
                }
                has(i) {
                  return this.firstChar <= i && i <= this.lastChar;
                }
                get(i) {
                  if (this.firstChar <= i && i <= this.lastChar) {
                    return String.fromCharCode(i);
                  }
                  return void 0;
                }
                charCodeOf(v) {
                  return Number.isInteger(v) && v >= this.firstChar && v <= this.lastChar ? v : -1;
                }
                amend(map) {
                  (0, _util2.unreachable)("Should not call amend()");
                }
              }
              exports3.IdentityToUnicodeMap = IdentityToUnicodeMap;
            }),
            /* 43 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.CFFFont = void 0;
              var _cff_parser = __w_pdfjs_require__3(35);
              var _fonts_utils = __w_pdfjs_require__3(38);
              var _util2 = __w_pdfjs_require__3(2);
              class CFFFont {
                constructor(file, properties2) {
                  this.properties = properties2;
                  const parser = new _cff_parser.CFFParser(file, properties2, _fonts_utils.SEAC_ANALYSIS_ENABLED);
                  this.cff = parser.parse();
                  this.cff.duplicateFirstGlyph();
                  const compiler = new _cff_parser.CFFCompiler(this.cff);
                  this.seacs = this.cff.seacs;
                  try {
                    this.data = compiler.compile();
                  } catch {
                    (0, _util2.warn)("Failed to compile font " + properties2.loadedName);
                    this.data = file;
                  }
                  this._createBuiltInEncoding();
                }
                get numGlyphs() {
                  return this.cff.charStrings.count;
                }
                getCharset() {
                  return this.cff.charset.charset;
                }
                getGlyphMapping() {
                  const cff = this.cff;
                  const properties2 = this.properties;
                  const {
                    cidToGidMap,
                    cMap
                  } = properties2;
                  const charsets = cff.charset.charset;
                  let charCodeToGlyphId;
                  let glyphId;
                  if (properties2.composite) {
                    let invCidToGidMap;
                    if (cidToGidMap?.length > 0) {
                      invCidToGidMap = /* @__PURE__ */ Object.create(null);
                      for (let i = 0, ii = cidToGidMap.length; i < ii; i++) {
                        const gid = cidToGidMap[i];
                        if (gid !== void 0) {
                          invCidToGidMap[gid] = i;
                        }
                      }
                    }
                    charCodeToGlyphId = /* @__PURE__ */ Object.create(null);
                    let charCode;
                    if (cff.isCIDFont) {
                      for (glyphId = 0; glyphId < charsets.length; glyphId++) {
                        const cid = charsets[glyphId];
                        charCode = cMap.charCodeOf(cid);
                        if (invCidToGidMap?.[charCode] !== void 0) {
                          charCode = invCidToGidMap[charCode];
                        }
                        charCodeToGlyphId[charCode] = glyphId;
                      }
                    } else {
                      for (glyphId = 0; glyphId < cff.charStrings.count; glyphId++) {
                        charCode = cMap.charCodeOf(glyphId);
                        charCodeToGlyphId[charCode] = glyphId;
                      }
                    }
                    return charCodeToGlyphId;
                  }
                  let encoding = cff.encoding ? cff.encoding.encoding : null;
                  if (properties2.isInternalFont) {
                    encoding = properties2.defaultEncoding;
                  }
                  charCodeToGlyphId = (0, _fonts_utils.type1FontGlyphMapping)(properties2, encoding, charsets);
                  return charCodeToGlyphId;
                }
                hasGlyphId(id) {
                  return this.cff.hasGlyphId(id);
                }
                _createBuiltInEncoding() {
                  const {
                    charset,
                    encoding
                  } = this.cff;
                  if (!charset || !encoding) {
                    return;
                  }
                  const charsets = charset.charset, encodings = encoding.encoding;
                  const map = [];
                  for (const charCode in encodings) {
                    const glyphId = encodings[charCode];
                    if (glyphId >= 0) {
                      const glyphName = charsets[glyphId];
                      if (glyphName) {
                        map[charCode] = glyphName;
                      }
                    }
                  }
                  if (map.length > 0) {
                    this.properties.builtInEncoding = map;
                  }
                }
              }
              exports3.CFFFont = CFFFont;
            }),
            /* 44 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.FontRendererFactory = void 0;
              var _util2 = __w_pdfjs_require__3(2);
              var _cff_parser = __w_pdfjs_require__3(35);
              var _glyphlist = __w_pdfjs_require__3(39);
              var _encodings = __w_pdfjs_require__3(37);
              var _stream = __w_pdfjs_require__3(8);
              function getUint32(data2, offset4) {
                return (data2[offset4] << 24 | data2[offset4 + 1] << 16 | data2[offset4 + 2] << 8 | data2[offset4 + 3]) >>> 0;
              }
              function getUint16(data2, offset4) {
                return data2[offset4] << 8 | data2[offset4 + 1];
              }
              function getInt16(data2, offset4) {
                return (data2[offset4] << 24 | data2[offset4 + 1] << 16) >> 16;
              }
              function getInt8(data2, offset4) {
                return data2[offset4] << 24 >> 24;
              }
              function getFloat214(data2, offset4) {
                return getInt16(data2, offset4) / 16384;
              }
              function getSubroutineBias(subrs) {
                const numSubrs = subrs.length;
                let bias = 32768;
                if (numSubrs < 1240) {
                  bias = 107;
                } else if (numSubrs < 33900) {
                  bias = 1131;
                }
                return bias;
              }
              function parseCmap(data2, start, end) {
                const offset4 = getUint16(data2, start + 2) === 1 ? getUint32(data2, start + 8) : getUint32(data2, start + 16);
                const format3 = getUint16(data2, start + offset4);
                let ranges, p, i;
                if (format3 === 4) {
                  getUint16(data2, start + offset4 + 2);
                  const segCount = getUint16(data2, start + offset4 + 6) >> 1;
                  p = start + offset4 + 14;
                  ranges = [];
                  for (i = 0; i < segCount; i++, p += 2) {
                    ranges[i] = {
                      end: getUint16(data2, p)
                    };
                  }
                  p += 2;
                  for (i = 0; i < segCount; i++, p += 2) {
                    ranges[i].start = getUint16(data2, p);
                  }
                  for (i = 0; i < segCount; i++, p += 2) {
                    ranges[i].idDelta = getUint16(data2, p);
                  }
                  for (i = 0; i < segCount; i++, p += 2) {
                    let idOffset = getUint16(data2, p);
                    if (idOffset === 0) {
                      continue;
                    }
                    ranges[i].ids = [];
                    for (let j = 0, jj = ranges[i].end - ranges[i].start + 1; j < jj; j++) {
                      ranges[i].ids[j] = getUint16(data2, p + idOffset);
                      idOffset += 2;
                    }
                  }
                  return ranges;
                } else if (format3 === 12) {
                  const groups = getUint32(data2, start + offset4 + 12);
                  p = start + offset4 + 16;
                  ranges = [];
                  for (i = 0; i < groups; i++) {
                    start = getUint32(data2, p);
                    ranges.push({
                      start,
                      end: getUint32(data2, p + 4),
                      idDelta: getUint32(data2, p + 8) - start
                    });
                    p += 12;
                  }
                  return ranges;
                }
                throw new _util2.FormatError(`unsupported cmap: ${format3}`);
              }
              function parseCff(data2, start, end, seacAnalysisEnabled) {
                const properties2 = {};
                const parser = new _cff_parser.CFFParser(new _stream.Stream(data2, start, end - start), properties2, seacAnalysisEnabled);
                const cff = parser.parse();
                return {
                  glyphs: cff.charStrings.objects,
                  subrs: cff.topDict.privateDict?.subrsIndex?.objects,
                  gsubrs: cff.globalSubrIndex?.objects,
                  isCFFCIDFont: cff.isCIDFont,
                  fdSelect: cff.fdSelect,
                  fdArray: cff.fdArray
                };
              }
              function parseGlyfTable(glyf, loca, isGlyphLocationsLong) {
                let itemSize, itemDecode;
                if (isGlyphLocationsLong) {
                  itemSize = 4;
                  itemDecode = getUint32;
                } else {
                  itemSize = 2;
                  itemDecode = (data2, offset4) => 2 * getUint16(data2, offset4);
                }
                const glyphs = [];
                let startOffset = itemDecode(loca, 0);
                for (let j = itemSize; j < loca.length; j += itemSize) {
                  const endOffset = itemDecode(loca, j);
                  glyphs.push(glyf.subarray(startOffset, endOffset));
                  startOffset = endOffset;
                }
                return glyphs;
              }
              function lookupCmap(ranges, unicode) {
                const code2 = unicode.codePointAt(0);
                let gid = 0, l2 = 0, r2 = ranges.length - 1;
                while (l2 < r2) {
                  const c = l2 + r2 + 1 >> 1;
                  if (code2 < ranges[c].start) {
                    r2 = c - 1;
                  } else {
                    l2 = c;
                  }
                }
                if (ranges[l2].start <= code2 && code2 <= ranges[l2].end) {
                  gid = ranges[l2].idDelta + (ranges[l2].ids ? ranges[l2].ids[code2 - ranges[l2].start] : code2) & 65535;
                }
                return {
                  charCode: code2,
                  glyphId: gid
                };
              }
              function compileGlyf(code2, cmds, font) {
                function moveTo(x2, y2) {
                  cmds.push({
                    cmd: "moveTo",
                    args: [x2, y2]
                  });
                }
                function lineTo(x2, y2) {
                  cmds.push({
                    cmd: "lineTo",
                    args: [x2, y2]
                  });
                }
                function quadraticCurveTo(xa, ya, x2, y2) {
                  cmds.push({
                    cmd: "quadraticCurveTo",
                    args: [xa, ya, x2, y2]
                  });
                }
                let i = 0;
                const numberOfContours = getInt16(code2, i);
                let flags;
                let x = 0, y = 0;
                i += 10;
                if (numberOfContours < 0) {
                  do {
                    flags = getUint16(code2, i);
                    const glyphIndex = getUint16(code2, i + 2);
                    i += 4;
                    let arg1, arg2;
                    if (flags & 1) {
                      if (flags & 2) {
                        arg1 = getInt16(code2, i);
                        arg2 = getInt16(code2, i + 2);
                      } else {
                        arg1 = getUint16(code2, i);
                        arg2 = getUint16(code2, i + 2);
                      }
                      i += 4;
                    } else if (flags & 2) {
                      arg1 = getInt8(code2, i++);
                      arg2 = getInt8(code2, i++);
                    } else {
                      arg1 = code2[i++];
                      arg2 = code2[i++];
                    }
                    if (flags & 2) {
                      x = arg1;
                      y = arg2;
                    } else {
                      x = 0;
                      y = 0;
                    }
                    let scaleX = 1, scaleY = 1, scale01 = 0, scale10 = 0;
                    if (flags & 8) {
                      scaleX = scaleY = getFloat214(code2, i);
                      i += 2;
                    } else if (flags & 64) {
                      scaleX = getFloat214(code2, i);
                      scaleY = getFloat214(code2, i + 2);
                      i += 4;
                    } else if (flags & 128) {
                      scaleX = getFloat214(code2, i);
                      scale01 = getFloat214(code2, i + 2);
                      scale10 = getFloat214(code2, i + 4);
                      scaleY = getFloat214(code2, i + 6);
                      i += 8;
                    }
                    const subglyph = font.glyphs[glyphIndex];
                    if (subglyph) {
                      cmds.push({
                        cmd: "save"
                      }, {
                        cmd: "transform",
                        args: [scaleX, scale01, scale10, scaleY, x, y]
                      });
                      if (!(flags & 2)) {
                      }
                      compileGlyf(subglyph, cmds, font);
                      cmds.push({
                        cmd: "restore"
                      });
                    }
                  } while (flags & 32);
                } else {
                  const endPtsOfContours = [];
                  let j, jj;
                  for (j = 0; j < numberOfContours; j++) {
                    endPtsOfContours.push(getUint16(code2, i));
                    i += 2;
                  }
                  const instructionLength = getUint16(code2, i);
                  i += 2 + instructionLength;
                  const numberOfPoints = endPtsOfContours.at(-1) + 1;
                  const points = [];
                  while (points.length < numberOfPoints) {
                    flags = code2[i++];
                    let repeat = 1;
                    if (flags & 8) {
                      repeat += code2[i++];
                    }
                    while (repeat-- > 0) {
                      points.push({
                        flags
                      });
                    }
                  }
                  for (j = 0; j < numberOfPoints; j++) {
                    switch (points[j].flags & 18) {
                      case 0:
                        x += getInt16(code2, i);
                        i += 2;
                        break;
                      case 2:
                        x -= code2[i++];
                        break;
                      case 18:
                        x += code2[i++];
                        break;
                    }
                    points[j].x = x;
                  }
                  for (j = 0; j < numberOfPoints; j++) {
                    switch (points[j].flags & 36) {
                      case 0:
                        y += getInt16(code2, i);
                        i += 2;
                        break;
                      case 4:
                        y -= code2[i++];
                        break;
                      case 36:
                        y += code2[i++];
                        break;
                    }
                    points[j].y = y;
                  }
                  let startPoint = 0;
                  for (i = 0; i < numberOfContours; i++) {
                    const endPoint = endPtsOfContours[i];
                    const contour = points.slice(startPoint, endPoint + 1);
                    if (contour[0].flags & 1) {
                      contour.push(contour[0]);
                    } else if (contour.at(-1).flags & 1) {
                      contour.unshift(contour.at(-1));
                    } else {
                      const p = {
                        flags: 1,
                        x: (contour[0].x + contour.at(-1).x) / 2,
                        y: (contour[0].y + contour.at(-1).y) / 2
                      };
                      contour.unshift(p);
                      contour.push(p);
                    }
                    moveTo(contour[0].x, contour[0].y);
                    for (j = 1, jj = contour.length; j < jj; j++) {
                      if (contour[j].flags & 1) {
                        lineTo(contour[j].x, contour[j].y);
                      } else if (contour[j + 1].flags & 1) {
                        quadraticCurveTo(contour[j].x, contour[j].y, contour[j + 1].x, contour[j + 1].y);
                        j++;
                      } else {
                        quadraticCurveTo(contour[j].x, contour[j].y, (contour[j].x + contour[j + 1].x) / 2, (contour[j].y + contour[j + 1].y) / 2);
                      }
                    }
                    startPoint = endPoint + 1;
                  }
                }
              }
              function compileCharString(charStringCode, cmds, font, glyphId) {
                function moveTo(x2, y2) {
                  cmds.push({
                    cmd: "moveTo",
                    args: [x2, y2]
                  });
                }
                function lineTo(x2, y2) {
                  cmds.push({
                    cmd: "lineTo",
                    args: [x2, y2]
                  });
                }
                function bezierCurveTo(x1, y1, x2, y2, x3, y3) {
                  cmds.push({
                    cmd: "bezierCurveTo",
                    args: [x1, y1, x2, y2, x3, y3]
                  });
                }
                const stack = [];
                let x = 0, y = 0;
                let stems = 0;
                function parse6(code2) {
                  let i = 0;
                  while (i < code2.length) {
                    let stackClean = false;
                    let v = code2[i++];
                    let xa, xb, ya, yb, y1, y2, y3, n2, subrCode;
                    switch (v) {
                      case 1:
                        stems += stack.length >> 1;
                        stackClean = true;
                        break;
                      case 3:
                        stems += stack.length >> 1;
                        stackClean = true;
                        break;
                      case 4:
                        y += stack.pop();
                        moveTo(x, y);
                        stackClean = true;
                        break;
                      case 5:
                        while (stack.length > 0) {
                          x += stack.shift();
                          y += stack.shift();
                          lineTo(x, y);
                        }
                        break;
                      case 6:
                        while (stack.length > 0) {
                          x += stack.shift();
                          lineTo(x, y);
                          if (stack.length === 0) {
                            break;
                          }
                          y += stack.shift();
                          lineTo(x, y);
                        }
                        break;
                      case 7:
                        while (stack.length > 0) {
                          y += stack.shift();
                          lineTo(x, y);
                          if (stack.length === 0) {
                            break;
                          }
                          x += stack.shift();
                          lineTo(x, y);
                        }
                        break;
                      case 8:
                        while (stack.length > 0) {
                          xa = x + stack.shift();
                          ya = y + stack.shift();
                          xb = xa + stack.shift();
                          yb = ya + stack.shift();
                          x = xb + stack.shift();
                          y = yb + stack.shift();
                          bezierCurveTo(xa, ya, xb, yb, x, y);
                        }
                        break;
                      case 10:
                        n2 = stack.pop();
                        subrCode = null;
                        if (font.isCFFCIDFont) {
                          const fdIndex = font.fdSelect.getFDIndex(glyphId);
                          if (fdIndex >= 0 && fdIndex < font.fdArray.length) {
                            const fontDict = font.fdArray[fdIndex];
                            let subrs;
                            if (fontDict.privateDict?.subrsIndex) {
                              subrs = fontDict.privateDict.subrsIndex.objects;
                            }
                            if (subrs) {
                              n2 += getSubroutineBias(subrs);
                              subrCode = subrs[n2];
                            }
                          } else {
                            (0, _util2.warn)("Invalid fd index for glyph index.");
                          }
                        } else {
                          subrCode = font.subrs[n2 + font.subrsBias];
                        }
                        if (subrCode) {
                          parse6(subrCode);
                        }
                        break;
                      case 11:
                        return;
                      case 12:
                        v = code2[i++];
                        switch (v) {
                          case 34:
                            xa = x + stack.shift();
                            xb = xa + stack.shift();
                            y1 = y + stack.shift();
                            x = xb + stack.shift();
                            bezierCurveTo(xa, y, xb, y1, x, y1);
                            xa = x + stack.shift();
                            xb = xa + stack.shift();
                            x = xb + stack.shift();
                            bezierCurveTo(xa, y1, xb, y, x, y);
                            break;
                          case 35:
                            xa = x + stack.shift();
                            ya = y + stack.shift();
                            xb = xa + stack.shift();
                            yb = ya + stack.shift();
                            x = xb + stack.shift();
                            y = yb + stack.shift();
                            bezierCurveTo(xa, ya, xb, yb, x, y);
                            xa = x + stack.shift();
                            ya = y + stack.shift();
                            xb = xa + stack.shift();
                            yb = ya + stack.shift();
                            x = xb + stack.shift();
                            y = yb + stack.shift();
                            bezierCurveTo(xa, ya, xb, yb, x, y);
                            stack.pop();
                            break;
                          case 36:
                            xa = x + stack.shift();
                            y1 = y + stack.shift();
                            xb = xa + stack.shift();
                            y2 = y1 + stack.shift();
                            x = xb + stack.shift();
                            bezierCurveTo(xa, y1, xb, y2, x, y2);
                            xa = x + stack.shift();
                            xb = xa + stack.shift();
                            y3 = y2 + stack.shift();
                            x = xb + stack.shift();
                            bezierCurveTo(xa, y2, xb, y3, x, y);
                            break;
                          case 37:
                            const x0 = x, y0 = y;
                            xa = x + stack.shift();
                            ya = y + stack.shift();
                            xb = xa + stack.shift();
                            yb = ya + stack.shift();
                            x = xb + stack.shift();
                            y = yb + stack.shift();
                            bezierCurveTo(xa, ya, xb, yb, x, y);
                            xa = x + stack.shift();
                            ya = y + stack.shift();
                            xb = xa + stack.shift();
                            yb = ya + stack.shift();
                            x = xb;
                            y = yb;
                            if (Math.abs(x - x0) > Math.abs(y - y0)) {
                              x += stack.shift();
                            } else {
                              y += stack.shift();
                            }
                            bezierCurveTo(xa, ya, xb, yb, x, y);
                            break;
                          default:
                            throw new _util2.FormatError(`unknown operator: 12 ${v}`);
                        }
                        break;
                      case 14:
                        if (stack.length >= 4) {
                          const achar = stack.pop();
                          const bchar = stack.pop();
                          y = stack.pop();
                          x = stack.pop();
                          cmds.push({
                            cmd: "save"
                          }, {
                            cmd: "translate",
                            args: [x, y]
                          });
                          let cmap = lookupCmap(font.cmap, String.fromCharCode(font.glyphNameMap[_encodings.StandardEncoding[achar]]));
                          compileCharString(font.glyphs[cmap.glyphId], cmds, font, cmap.glyphId);
                          cmds.push({
                            cmd: "restore"
                          });
                          cmap = lookupCmap(font.cmap, String.fromCharCode(font.glyphNameMap[_encodings.StandardEncoding[bchar]]));
                          compileCharString(font.glyphs[cmap.glyphId], cmds, font, cmap.glyphId);
                        }
                        return;
                      case 18:
                        stems += stack.length >> 1;
                        stackClean = true;
                        break;
                      case 19:
                        stems += stack.length >> 1;
                        i += stems + 7 >> 3;
                        stackClean = true;
                        break;
                      case 20:
                        stems += stack.length >> 1;
                        i += stems + 7 >> 3;
                        stackClean = true;
                        break;
                      case 21:
                        y += stack.pop();
                        x += stack.pop();
                        moveTo(x, y);
                        stackClean = true;
                        break;
                      case 22:
                        x += stack.pop();
                        moveTo(x, y);
                        stackClean = true;
                        break;
                      case 23:
                        stems += stack.length >> 1;
                        stackClean = true;
                        break;
                      case 24:
                        while (stack.length > 2) {
                          xa = x + stack.shift();
                          ya = y + stack.shift();
                          xb = xa + stack.shift();
                          yb = ya + stack.shift();
                          x = xb + stack.shift();
                          y = yb + stack.shift();
                          bezierCurveTo(xa, ya, xb, yb, x, y);
                        }
                        x += stack.shift();
                        y += stack.shift();
                        lineTo(x, y);
                        break;
                      case 25:
                        while (stack.length > 6) {
                          x += stack.shift();
                          y += stack.shift();
                          lineTo(x, y);
                        }
                        xa = x + stack.shift();
                        ya = y + stack.shift();
                        xb = xa + stack.shift();
                        yb = ya + stack.shift();
                        x = xb + stack.shift();
                        y = yb + stack.shift();
                        bezierCurveTo(xa, ya, xb, yb, x, y);
                        break;
                      case 26:
                        if (stack.length % 2) {
                          x += stack.shift();
                        }
                        while (stack.length > 0) {
                          xa = x;
                          ya = y + stack.shift();
                          xb = xa + stack.shift();
                          yb = ya + stack.shift();
                          x = xb;
                          y = yb + stack.shift();
                          bezierCurveTo(xa, ya, xb, yb, x, y);
                        }
                        break;
                      case 27:
                        if (stack.length % 2) {
                          y += stack.shift();
                        }
                        while (stack.length > 0) {
                          xa = x + stack.shift();
                          ya = y;
                          xb = xa + stack.shift();
                          yb = ya + stack.shift();
                          x = xb + stack.shift();
                          y = yb;
                          bezierCurveTo(xa, ya, xb, yb, x, y);
                        }
                        break;
                      case 28:
                        stack.push((code2[i] << 24 | code2[i + 1] << 16) >> 16);
                        i += 2;
                        break;
                      case 29:
                        n2 = stack.pop() + font.gsubrsBias;
                        subrCode = font.gsubrs[n2];
                        if (subrCode) {
                          parse6(subrCode);
                        }
                        break;
                      case 30:
                        while (stack.length > 0) {
                          xa = x;
                          ya = y + stack.shift();
                          xb = xa + stack.shift();
                          yb = ya + stack.shift();
                          x = xb + stack.shift();
                          y = yb + (stack.length === 1 ? stack.shift() : 0);
                          bezierCurveTo(xa, ya, xb, yb, x, y);
                          if (stack.length === 0) {
                            break;
                          }
                          xa = x + stack.shift();
                          ya = y;
                          xb = xa + stack.shift();
                          yb = ya + stack.shift();
                          y = yb + stack.shift();
                          x = xb + (stack.length === 1 ? stack.shift() : 0);
                          bezierCurveTo(xa, ya, xb, yb, x, y);
                        }
                        break;
                      case 31:
                        while (stack.length > 0) {
                          xa = x + stack.shift();
                          ya = y;
                          xb = xa + stack.shift();
                          yb = ya + stack.shift();
                          y = yb + stack.shift();
                          x = xb + (stack.length === 1 ? stack.shift() : 0);
                          bezierCurveTo(xa, ya, xb, yb, x, y);
                          if (stack.length === 0) {
                            break;
                          }
                          xa = x;
                          ya = y + stack.shift();
                          xb = xa + stack.shift();
                          yb = ya + stack.shift();
                          x = xb + stack.shift();
                          y = yb + (stack.length === 1 ? stack.shift() : 0);
                          bezierCurveTo(xa, ya, xb, yb, x, y);
                        }
                        break;
                      default:
                        if (v < 32) {
                          throw new _util2.FormatError(`unknown operator: ${v}`);
                        }
                        if (v < 247) {
                          stack.push(v - 139);
                        } else if (v < 251) {
                          stack.push((v - 247) * 256 + code2[i++] + 108);
                        } else if (v < 255) {
                          stack.push(-(v - 251) * 256 - code2[i++] - 108);
                        } else {
                          stack.push((code2[i] << 24 | code2[i + 1] << 16 | code2[i + 2] << 8 | code2[i + 3]) / 65536);
                          i += 4;
                        }
                        break;
                    }
                    if (stackClean) {
                      stack.length = 0;
                    }
                  }
                }
                parse6(charStringCode);
              }
              const NOOP = [];
              class CompiledFont {
                constructor(fontMatrix) {
                  if (this.constructor === CompiledFont) {
                    (0, _util2.unreachable)("Cannot initialize CompiledFont.");
                  }
                  this.fontMatrix = fontMatrix;
                  this.compiledGlyphs = /* @__PURE__ */ Object.create(null);
                  this.compiledCharCodeToGlyphId = /* @__PURE__ */ Object.create(null);
                }
                getPathJs(unicode) {
                  const {
                    charCode,
                    glyphId
                  } = lookupCmap(this.cmap, unicode);
                  let fn = this.compiledGlyphs[glyphId];
                  if (!fn) {
                    try {
                      fn = this.compileGlyph(this.glyphs[glyphId], glyphId);
                      this.compiledGlyphs[glyphId] = fn;
                    } catch (ex) {
                      this.compiledGlyphs[glyphId] = NOOP;
                      if (this.compiledCharCodeToGlyphId[charCode] === void 0) {
                        this.compiledCharCodeToGlyphId[charCode] = glyphId;
                      }
                      throw ex;
                    }
                  }
                  if (this.compiledCharCodeToGlyphId[charCode] === void 0) {
                    this.compiledCharCodeToGlyphId[charCode] = glyphId;
                  }
                  return fn;
                }
                compileGlyph(code2, glyphId) {
                  if (!code2 || code2.length === 0 || code2[0] === 14) {
                    return NOOP;
                  }
                  let fontMatrix = this.fontMatrix;
                  if (this.isCFFCIDFont) {
                    const fdIndex = this.fdSelect.getFDIndex(glyphId);
                    if (fdIndex >= 0 && fdIndex < this.fdArray.length) {
                      const fontDict = this.fdArray[fdIndex];
                      fontMatrix = fontDict.getByName("FontMatrix") || _util2.FONT_IDENTITY_MATRIX;
                    } else {
                      (0, _util2.warn)("Invalid fd index for glyph index.");
                    }
                  }
                  const cmds = [{
                    cmd: "save"
                  }, {
                    cmd: "transform",
                    args: fontMatrix.slice()
                  }, {
                    cmd: "scale",
                    args: ["size", "-size"]
                  }];
                  this.compileGlyphImpl(code2, cmds, glyphId);
                  cmds.push({
                    cmd: "restore"
                  });
                  return cmds;
                }
                compileGlyphImpl() {
                  (0, _util2.unreachable)("Children classes should implement this.");
                }
                hasBuiltPath(unicode) {
                  const {
                    charCode,
                    glyphId
                  } = lookupCmap(this.cmap, unicode);
                  return this.compiledGlyphs[glyphId] !== void 0 && this.compiledCharCodeToGlyphId[charCode] !== void 0;
                }
              }
              class TrueTypeCompiled extends CompiledFont {
                constructor(glyphs, cmap, fontMatrix) {
                  super(fontMatrix || [488e-6, 0, 0, 488e-6, 0, 0]);
                  this.glyphs = glyphs;
                  this.cmap = cmap;
                }
                compileGlyphImpl(code2, cmds) {
                  compileGlyf(code2, cmds, this);
                }
              }
              class Type2Compiled extends CompiledFont {
                constructor(cffInfo, cmap, fontMatrix, glyphNameMap) {
                  super(fontMatrix || [1e-3, 0, 0, 1e-3, 0, 0]);
                  this.glyphs = cffInfo.glyphs;
                  this.gsubrs = cffInfo.gsubrs || [];
                  this.subrs = cffInfo.subrs || [];
                  this.cmap = cmap;
                  this.glyphNameMap = glyphNameMap || (0, _glyphlist.getGlyphsUnicode)();
                  this.gsubrsBias = getSubroutineBias(this.gsubrs);
                  this.subrsBias = getSubroutineBias(this.subrs);
                  this.isCFFCIDFont = cffInfo.isCFFCIDFont;
                  this.fdSelect = cffInfo.fdSelect;
                  this.fdArray = cffInfo.fdArray;
                }
                compileGlyphImpl(code2, cmds, glyphId) {
                  compileCharString(code2, cmds, this, glyphId);
                }
              }
              class FontRendererFactory {
                static create(font, seacAnalysisEnabled) {
                  const data2 = new Uint8Array(font.data);
                  let cmap, glyf, loca, cff, indexToLocFormat, unitsPerEm;
                  const numTables = getUint16(data2, 4);
                  for (let i = 0, p = 12; i < numTables; i++, p += 16) {
                    const tag = (0, _util2.bytesToString)(data2.subarray(p, p + 4));
                    const offset4 = getUint32(data2, p + 8);
                    const length2 = getUint32(data2, p + 12);
                    switch (tag) {
                      case "cmap":
                        cmap = parseCmap(data2, offset4, offset4 + length2);
                        break;
                      case "glyf":
                        glyf = data2.subarray(offset4, offset4 + length2);
                        break;
                      case "loca":
                        loca = data2.subarray(offset4, offset4 + length2);
                        break;
                      case "head":
                        unitsPerEm = getUint16(data2, offset4 + 18);
                        indexToLocFormat = getUint16(data2, offset4 + 50);
                        break;
                      case "CFF ":
                        cff = parseCff(data2, offset4, offset4 + length2, seacAnalysisEnabled);
                        break;
                    }
                  }
                  if (glyf) {
                    const fontMatrix = !unitsPerEm ? font.fontMatrix : [1 / unitsPerEm, 0, 0, 1 / unitsPerEm, 0, 0];
                    return new TrueTypeCompiled(parseGlyfTable(glyf, loca, indexToLocFormat), cmap, fontMatrix);
                  }
                  return new Type2Compiled(cff, cmap, font.fontMatrix, font.glyphNameMap);
                }
              }
              exports3.FontRendererFactory = FontRendererFactory;
            }),
            /* 45 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.getMetrics = exports3.getFontBasicMetrics = void 0;
              var _core_utils = __w_pdfjs_require__3(3);
              const getMetrics = (0, _core_utils.getLookupTableFactory)(function(t2) {
                t2.Courier = 600;
                t2["Courier-Bold"] = 600;
                t2["Courier-BoldOblique"] = 600;
                t2["Courier-Oblique"] = 600;
                t2.Helvetica = (0, _core_utils.getLookupTableFactory)(function(t3) {
                  t3.space = 278;
                  t3.exclam = 278;
                  t3.quotedbl = 355;
                  t3.numbersign = 556;
                  t3.dollar = 556;
                  t3.percent = 889;
                  t3.ampersand = 667;
                  t3.quoteright = 222;
                  t3.parenleft = 333;
                  t3.parenright = 333;
                  t3.asterisk = 389;
                  t3.plus = 584;
                  t3.comma = 278;
                  t3.hyphen = 333;
                  t3.period = 278;
                  t3.slash = 278;
                  t3.zero = 556;
                  t3.one = 556;
                  t3.two = 556;
                  t3.three = 556;
                  t3.four = 556;
                  t3.five = 556;
                  t3.six = 556;
                  t3.seven = 556;
                  t3.eight = 556;
                  t3.nine = 556;
                  t3.colon = 278;
                  t3.semicolon = 278;
                  t3.less = 584;
                  t3.equal = 584;
                  t3.greater = 584;
                  t3.question = 556;
                  t3.at = 1015;
                  t3.A = 667;
                  t3.B = 667;
                  t3.C = 722;
                  t3.D = 722;
                  t3.E = 667;
                  t3.F = 611;
                  t3.G = 778;
                  t3.H = 722;
                  t3.I = 278;
                  t3.J = 500;
                  t3.K = 667;
                  t3.L = 556;
                  t3.M = 833;
                  t3.N = 722;
                  t3.O = 778;
                  t3.P = 667;
                  t3.Q = 778;
                  t3.R = 722;
                  t3.S = 667;
                  t3.T = 611;
                  t3.U = 722;
                  t3.V = 667;
                  t3.W = 944;
                  t3.X = 667;
                  t3.Y = 667;
                  t3.Z = 611;
                  t3.bracketleft = 278;
                  t3.backslash = 278;
                  t3.bracketright = 278;
                  t3.asciicircum = 469;
                  t3.underscore = 556;
                  t3.quoteleft = 222;
                  t3.a = 556;
                  t3.b = 556;
                  t3.c = 500;
                  t3.d = 556;
                  t3.e = 556;
                  t3.f = 278;
                  t3.g = 556;
                  t3.h = 556;
                  t3.i = 222;
                  t3.j = 222;
                  t3.k = 500;
                  t3.l = 222;
                  t3.m = 833;
                  t3.n = 556;
                  t3.o = 556;
                  t3.p = 556;
                  t3.q = 556;
                  t3.r = 333;
                  t3.s = 500;
                  t3.t = 278;
                  t3.u = 556;
                  t3.v = 500;
                  t3.w = 722;
                  t3.x = 500;
                  t3.y = 500;
                  t3.z = 500;
                  t3.braceleft = 334;
                  t3.bar = 260;
                  t3.braceright = 334;
                  t3.asciitilde = 584;
                  t3.exclamdown = 333;
                  t3.cent = 556;
                  t3.sterling = 556;
                  t3.fraction = 167;
                  t3.yen = 556;
                  t3.florin = 556;
                  t3.section = 556;
                  t3.currency = 556;
                  t3.quotesingle = 191;
                  t3.quotedblleft = 333;
                  t3.guillemotleft = 556;
                  t3.guilsinglleft = 333;
                  t3.guilsinglright = 333;
                  t3.fi = 500;
                  t3.fl = 500;
                  t3.endash = 556;
                  t3.dagger = 556;
                  t3.daggerdbl = 556;
                  t3.periodcentered = 278;
                  t3.paragraph = 537;
                  t3.bullet = 350;
                  t3.quotesinglbase = 222;
                  t3.quotedblbase = 333;
                  t3.quotedblright = 333;
                  t3.guillemotright = 556;
                  t3.ellipsis = 1e3;
                  t3.perthousand = 1e3;
                  t3.questiondown = 611;
                  t3.grave = 333;
                  t3.acute = 333;
                  t3.circumflex = 333;
                  t3.tilde = 333;
                  t3.macron = 333;
                  t3.breve = 333;
                  t3.dotaccent = 333;
                  t3.dieresis = 333;
                  t3.ring = 333;
                  t3.cedilla = 333;
                  t3.hungarumlaut = 333;
                  t3.ogonek = 333;
                  t3.caron = 333;
                  t3.emdash = 1e3;
                  t3.AE = 1e3;
                  t3.ordfeminine = 370;
                  t3.Lslash = 556;
                  t3.Oslash = 778;
                  t3.OE = 1e3;
                  t3.ordmasculine = 365;
                  t3.ae = 889;
                  t3.dotlessi = 278;
                  t3.lslash = 222;
                  t3.oslash = 611;
                  t3.oe = 944;
                  t3.germandbls = 611;
                  t3.Idieresis = 278;
                  t3.eacute = 556;
                  t3.abreve = 556;
                  t3.uhungarumlaut = 556;
                  t3.ecaron = 556;
                  t3.Ydieresis = 667;
                  t3.divide = 584;
                  t3.Yacute = 667;
                  t3.Acircumflex = 667;
                  t3.aacute = 556;
                  t3.Ucircumflex = 722;
                  t3.yacute = 500;
                  t3.scommaaccent = 500;
                  t3.ecircumflex = 556;
                  t3.Uring = 722;
                  t3.Udieresis = 722;
                  t3.aogonek = 556;
                  t3.Uacute = 722;
                  t3.uogonek = 556;
                  t3.Edieresis = 667;
                  t3.Dcroat = 722;
                  t3.commaaccent = 250;
                  t3.copyright = 737;
                  t3.Emacron = 667;
                  t3.ccaron = 500;
                  t3.aring = 556;
                  t3.Ncommaaccent = 722;
                  t3.lacute = 222;
                  t3.agrave = 556;
                  t3.Tcommaaccent = 611;
                  t3.Cacute = 722;
                  t3.atilde = 556;
                  t3.Edotaccent = 667;
                  t3.scaron = 500;
                  t3.scedilla = 500;
                  t3.iacute = 278;
                  t3.lozenge = 471;
                  t3.Rcaron = 722;
                  t3.Gcommaaccent = 778;
                  t3.ucircumflex = 556;
                  t3.acircumflex = 556;
                  t3.Amacron = 667;
                  t3.rcaron = 333;
                  t3.ccedilla = 500;
                  t3.Zdotaccent = 611;
                  t3.Thorn = 667;
                  t3.Omacron = 778;
                  t3.Racute = 722;
                  t3.Sacute = 667;
                  t3.dcaron = 643;
                  t3.Umacron = 722;
                  t3.uring = 556;
                  t3.threesuperior = 333;
                  t3.Ograve = 778;
                  t3.Agrave = 667;
                  t3.Abreve = 667;
                  t3.multiply = 584;
                  t3.uacute = 556;
                  t3.Tcaron = 611;
                  t3.partialdiff = 476;
                  t3.ydieresis = 500;
                  t3.Nacute = 722;
                  t3.icircumflex = 278;
                  t3.Ecircumflex = 667;
                  t3.adieresis = 556;
                  t3.edieresis = 556;
                  t3.cacute = 500;
                  t3.nacute = 556;
                  t3.umacron = 556;
                  t3.Ncaron = 722;
                  t3.Iacute = 278;
                  t3.plusminus = 584;
                  t3.brokenbar = 260;
                  t3.registered = 737;
                  t3.Gbreve = 778;
                  t3.Idotaccent = 278;
                  t3.summation = 600;
                  t3.Egrave = 667;
                  t3.racute = 333;
                  t3.omacron = 556;
                  t3.Zacute = 611;
                  t3.Zcaron = 611;
                  t3.greaterequal = 549;
                  t3.Eth = 722;
                  t3.Ccedilla = 722;
                  t3.lcommaaccent = 222;
                  t3.tcaron = 317;
                  t3.eogonek = 556;
                  t3.Uogonek = 722;
                  t3.Aacute = 667;
                  t3.Adieresis = 667;
                  t3.egrave = 556;
                  t3.zacute = 500;
                  t3.iogonek = 222;
                  t3.Oacute = 778;
                  t3.oacute = 556;
                  t3.amacron = 556;
                  t3.sacute = 500;
                  t3.idieresis = 278;
                  t3.Ocircumflex = 778;
                  t3.Ugrave = 722;
                  t3.Delta = 612;
                  t3.thorn = 556;
                  t3.twosuperior = 333;
                  t3.Odieresis = 778;
                  t3.mu = 556;
                  t3.igrave = 278;
                  t3.ohungarumlaut = 556;
                  t3.Eogonek = 667;
                  t3.dcroat = 556;
                  t3.threequarters = 834;
                  t3.Scedilla = 667;
                  t3.lcaron = 299;
                  t3.Kcommaaccent = 667;
                  t3.Lacute = 556;
                  t3.trademark = 1e3;
                  t3.edotaccent = 556;
                  t3.Igrave = 278;
                  t3.Imacron = 278;
                  t3.Lcaron = 556;
                  t3.onehalf = 834;
                  t3.lessequal = 549;
                  t3.ocircumflex = 556;
                  t3.ntilde = 556;
                  t3.Uhungarumlaut = 722;
                  t3.Eacute = 667;
                  t3.emacron = 556;
                  t3.gbreve = 556;
                  t3.onequarter = 834;
                  t3.Scaron = 667;
                  t3.Scommaaccent = 667;
                  t3.Ohungarumlaut = 778;
                  t3.degree = 400;
                  t3.ograve = 556;
                  t3.Ccaron = 722;
                  t3.ugrave = 556;
                  t3.radical = 453;
                  t3.Dcaron = 722;
                  t3.rcommaaccent = 333;
                  t3.Ntilde = 722;
                  t3.otilde = 556;
                  t3.Rcommaaccent = 722;
                  t3.Lcommaaccent = 556;
                  t3.Atilde = 667;
                  t3.Aogonek = 667;
                  t3.Aring = 667;
                  t3.Otilde = 778;
                  t3.zdotaccent = 500;
                  t3.Ecaron = 667;
                  t3.Iogonek = 278;
                  t3.kcommaaccent = 500;
                  t3.minus = 584;
                  t3.Icircumflex = 278;
                  t3.ncaron = 556;
                  t3.tcommaaccent = 278;
                  t3.logicalnot = 584;
                  t3.odieresis = 556;
                  t3.udieresis = 556;
                  t3.notequal = 549;
                  t3.gcommaaccent = 556;
                  t3.eth = 556;
                  t3.zcaron = 500;
                  t3.ncommaaccent = 556;
                  t3.onesuperior = 333;
                  t3.imacron = 278;
                  t3.Euro = 556;
                });
                t2["Helvetica-Bold"] = (0, _core_utils.getLookupTableFactory)(function(t3) {
                  t3.space = 278;
                  t3.exclam = 333;
                  t3.quotedbl = 474;
                  t3.numbersign = 556;
                  t3.dollar = 556;
                  t3.percent = 889;
                  t3.ampersand = 722;
                  t3.quoteright = 278;
                  t3.parenleft = 333;
                  t3.parenright = 333;
                  t3.asterisk = 389;
                  t3.plus = 584;
                  t3.comma = 278;
                  t3.hyphen = 333;
                  t3.period = 278;
                  t3.slash = 278;
                  t3.zero = 556;
                  t3.one = 556;
                  t3.two = 556;
                  t3.three = 556;
                  t3.four = 556;
                  t3.five = 556;
                  t3.six = 556;
                  t3.seven = 556;
                  t3.eight = 556;
                  t3.nine = 556;
                  t3.colon = 333;
                  t3.semicolon = 333;
                  t3.less = 584;
                  t3.equal = 584;
                  t3.greater = 584;
                  t3.question = 611;
                  t3.at = 975;
                  t3.A = 722;
                  t3.B = 722;
                  t3.C = 722;
                  t3.D = 722;
                  t3.E = 667;
                  t3.F = 611;
                  t3.G = 778;
                  t3.H = 722;
                  t3.I = 278;
                  t3.J = 556;
                  t3.K = 722;
                  t3.L = 611;
                  t3.M = 833;
                  t3.N = 722;
                  t3.O = 778;
                  t3.P = 667;
                  t3.Q = 778;
                  t3.R = 722;
                  t3.S = 667;
                  t3.T = 611;
                  t3.U = 722;
                  t3.V = 667;
                  t3.W = 944;
                  t3.X = 667;
                  t3.Y = 667;
                  t3.Z = 611;
                  t3.bracketleft = 333;
                  t3.backslash = 278;
                  t3.bracketright = 333;
                  t3.asciicircum = 584;
                  t3.underscore = 556;
                  t3.quoteleft = 278;
                  t3.a = 556;
                  t3.b = 611;
                  t3.c = 556;
                  t3.d = 611;
                  t3.e = 556;
                  t3.f = 333;
                  t3.g = 611;
                  t3.h = 611;
                  t3.i = 278;
                  t3.j = 278;
                  t3.k = 556;
                  t3.l = 278;
                  t3.m = 889;
                  t3.n = 611;
                  t3.o = 611;
                  t3.p = 611;
                  t3.q = 611;
                  t3.r = 389;
                  t3.s = 556;
                  t3.t = 333;
                  t3.u = 611;
                  t3.v = 556;
                  t3.w = 778;
                  t3.x = 556;
                  t3.y = 556;
                  t3.z = 500;
                  t3.braceleft = 389;
                  t3.bar = 280;
                  t3.braceright = 389;
                  t3.asciitilde = 584;
                  t3.exclamdown = 333;
                  t3.cent = 556;
                  t3.sterling = 556;
                  t3.fraction = 167;
                  t3.yen = 556;
                  t3.florin = 556;
                  t3.section = 556;
                  t3.currency = 556;
                  t3.quotesingle = 238;
                  t3.quotedblleft = 500;
                  t3.guillemotleft = 556;
                  t3.guilsinglleft = 333;
                  t3.guilsinglright = 333;
                  t3.fi = 611;
                  t3.fl = 611;
                  t3.endash = 556;
                  t3.dagger = 556;
                  t3.daggerdbl = 556;
                  t3.periodcentered = 278;
                  t3.paragraph = 556;
                  t3.bullet = 350;
                  t3.quotesinglbase = 278;
                  t3.quotedblbase = 500;
                  t3.quotedblright = 500;
                  t3.guillemotright = 556;
                  t3.ellipsis = 1e3;
                  t3.perthousand = 1e3;
                  t3.questiondown = 611;
                  t3.grave = 333;
                  t3.acute = 333;
                  t3.circumflex = 333;
                  t3.tilde = 333;
                  t3.macron = 333;
                  t3.breve = 333;
                  t3.dotaccent = 333;
                  t3.dieresis = 333;
                  t3.ring = 333;
                  t3.cedilla = 333;
                  t3.hungarumlaut = 333;
                  t3.ogonek = 333;
                  t3.caron = 333;
                  t3.emdash = 1e3;
                  t3.AE = 1e3;
                  t3.ordfeminine = 370;
                  t3.Lslash = 611;
                  t3.Oslash = 778;
                  t3.OE = 1e3;
                  t3.ordmasculine = 365;
                  t3.ae = 889;
                  t3.dotlessi = 278;
                  t3.lslash = 278;
                  t3.oslash = 611;
                  t3.oe = 944;
                  t3.germandbls = 611;
                  t3.Idieresis = 278;
                  t3.eacute = 556;
                  t3.abreve = 556;
                  t3.uhungarumlaut = 611;
                  t3.ecaron = 556;
                  t3.Ydieresis = 667;
                  t3.divide = 584;
                  t3.Yacute = 667;
                  t3.Acircumflex = 722;
                  t3.aacute = 556;
                  t3.Ucircumflex = 722;
                  t3.yacute = 556;
                  t3.scommaaccent = 556;
                  t3.ecircumflex = 556;
                  t3.Uring = 722;
                  t3.Udieresis = 722;
                  t3.aogonek = 556;
                  t3.Uacute = 722;
                  t3.uogonek = 611;
                  t3.Edieresis = 667;
                  t3.Dcroat = 722;
                  t3.commaaccent = 250;
                  t3.copyright = 737;
                  t3.Emacron = 667;
                  t3.ccaron = 556;
                  t3.aring = 556;
                  t3.Ncommaaccent = 722;
                  t3.lacute = 278;
                  t3.agrave = 556;
                  t3.Tcommaaccent = 611;
                  t3.Cacute = 722;
                  t3.atilde = 556;
                  t3.Edotaccent = 667;
                  t3.scaron = 556;
                  t3.scedilla = 556;
                  t3.iacute = 278;
                  t3.lozenge = 494;
                  t3.Rcaron = 722;
                  t3.Gcommaaccent = 778;
                  t3.ucircumflex = 611;
                  t3.acircumflex = 556;
                  t3.Amacron = 722;
                  t3.rcaron = 389;
                  t3.ccedilla = 556;
                  t3.Zdotaccent = 611;
                  t3.Thorn = 667;
                  t3.Omacron = 778;
                  t3.Racute = 722;
                  t3.Sacute = 667;
                  t3.dcaron = 743;
                  t3.Umacron = 722;
                  t3.uring = 611;
                  t3.threesuperior = 333;
                  t3.Ograve = 778;
                  t3.Agrave = 722;
                  t3.Abreve = 722;
                  t3.multiply = 584;
                  t3.uacute = 611;
                  t3.Tcaron = 611;
                  t3.partialdiff = 494;
                  t3.ydieresis = 556;
                  t3.Nacute = 722;
                  t3.icircumflex = 278;
                  t3.Ecircumflex = 667;
                  t3.adieresis = 556;
                  t3.edieresis = 556;
                  t3.cacute = 556;
                  t3.nacute = 611;
                  t3.umacron = 611;
                  t3.Ncaron = 722;
                  t3.Iacute = 278;
                  t3.plusminus = 584;
                  t3.brokenbar = 280;
                  t3.registered = 737;
                  t3.Gbreve = 778;
                  t3.Idotaccent = 278;
                  t3.summation = 600;
                  t3.Egrave = 667;
                  t3.racute = 389;
                  t3.omacron = 611;
                  t3.Zacute = 611;
                  t3.Zcaron = 611;
                  t3.greaterequal = 549;
                  t3.Eth = 722;
                  t3.Ccedilla = 722;
                  t3.lcommaaccent = 278;
                  t3.tcaron = 389;
                  t3.eogonek = 556;
                  t3.Uogonek = 722;
                  t3.Aacute = 722;
                  t3.Adieresis = 722;
                  t3.egrave = 556;
                  t3.zacute = 500;
                  t3.iogonek = 278;
                  t3.Oacute = 778;
                  t3.oacute = 611;
                  t3.amacron = 556;
                  t3.sacute = 556;
                  t3.idieresis = 278;
                  t3.Ocircumflex = 778;
                  t3.Ugrave = 722;
                  t3.Delta = 612;
                  t3.thorn = 611;
                  t3.twosuperior = 333;
                  t3.Odieresis = 778;
                  t3.mu = 611;
                  t3.igrave = 278;
                  t3.ohungarumlaut = 611;
                  t3.Eogonek = 667;
                  t3.dcroat = 611;
                  t3.threequarters = 834;
                  t3.Scedilla = 667;
                  t3.lcaron = 400;
                  t3.Kcommaaccent = 722;
                  t3.Lacute = 611;
                  t3.trademark = 1e3;
                  t3.edotaccent = 556;
                  t3.Igrave = 278;
                  t3.Imacron = 278;
                  t3.Lcaron = 611;
                  t3.onehalf = 834;
                  t3.lessequal = 549;
                  t3.ocircumflex = 611;
                  t3.ntilde = 611;
                  t3.Uhungarumlaut = 722;
                  t3.Eacute = 667;
                  t3.emacron = 556;
                  t3.gbreve = 611;
                  t3.onequarter = 834;
                  t3.Scaron = 667;
                  t3.Scommaaccent = 667;
                  t3.Ohungarumlaut = 778;
                  t3.degree = 400;
                  t3.ograve = 611;
                  t3.Ccaron = 722;
                  t3.ugrave = 611;
                  t3.radical = 549;
                  t3.Dcaron = 722;
                  t3.rcommaaccent = 389;
                  t3.Ntilde = 722;
                  t3.otilde = 611;
                  t3.Rcommaaccent = 722;
                  t3.Lcommaaccent = 611;
                  t3.Atilde = 722;
                  t3.Aogonek = 722;
                  t3.Aring = 722;
                  t3.Otilde = 778;
                  t3.zdotaccent = 500;
                  t3.Ecaron = 667;
                  t3.Iogonek = 278;
                  t3.kcommaaccent = 556;
                  t3.minus = 584;
                  t3.Icircumflex = 278;
                  t3.ncaron = 611;
                  t3.tcommaaccent = 333;
                  t3.logicalnot = 584;
                  t3.odieresis = 611;
                  t3.udieresis = 611;
                  t3.notequal = 549;
                  t3.gcommaaccent = 611;
                  t3.eth = 611;
                  t3.zcaron = 500;
                  t3.ncommaaccent = 611;
                  t3.onesuperior = 333;
                  t3.imacron = 278;
                  t3.Euro = 556;
                });
                t2["Helvetica-BoldOblique"] = (0, _core_utils.getLookupTableFactory)(function(t3) {
                  t3.space = 278;
                  t3.exclam = 333;
                  t3.quotedbl = 474;
                  t3.numbersign = 556;
                  t3.dollar = 556;
                  t3.percent = 889;
                  t3.ampersand = 722;
                  t3.quoteright = 278;
                  t3.parenleft = 333;
                  t3.parenright = 333;
                  t3.asterisk = 389;
                  t3.plus = 584;
                  t3.comma = 278;
                  t3.hyphen = 333;
                  t3.period = 278;
                  t3.slash = 278;
                  t3.zero = 556;
                  t3.one = 556;
                  t3.two = 556;
                  t3.three = 556;
                  t3.four = 556;
                  t3.five = 556;
                  t3.six = 556;
                  t3.seven = 556;
                  t3.eight = 556;
                  t3.nine = 556;
                  t3.colon = 333;
                  t3.semicolon = 333;
                  t3.less = 584;
                  t3.equal = 584;
                  t3.greater = 584;
                  t3.question = 611;
                  t3.at = 975;
                  t3.A = 722;
                  t3.B = 722;
                  t3.C = 722;
                  t3.D = 722;
                  t3.E = 667;
                  t3.F = 611;
                  t3.G = 778;
                  t3.H = 722;
                  t3.I = 278;
                  t3.J = 556;
                  t3.K = 722;
                  t3.L = 611;
                  t3.M = 833;
                  t3.N = 722;
                  t3.O = 778;
                  t3.P = 667;
                  t3.Q = 778;
                  t3.R = 722;
                  t3.S = 667;
                  t3.T = 611;
                  t3.U = 722;
                  t3.V = 667;
                  t3.W = 944;
                  t3.X = 667;
                  t3.Y = 667;
                  t3.Z = 611;
                  t3.bracketleft = 333;
                  t3.backslash = 278;
                  t3.bracketright = 333;
                  t3.asciicircum = 584;
                  t3.underscore = 556;
                  t3.quoteleft = 278;
                  t3.a = 556;
                  t3.b = 611;
                  t3.c = 556;
                  t3.d = 611;
                  t3.e = 556;
                  t3.f = 333;
                  t3.g = 611;
                  t3.h = 611;
                  t3.i = 278;
                  t3.j = 278;
                  t3.k = 556;
                  t3.l = 278;
                  t3.m = 889;
                  t3.n = 611;
                  t3.o = 611;
                  t3.p = 611;
                  t3.q = 611;
                  t3.r = 389;
                  t3.s = 556;
                  t3.t = 333;
                  t3.u = 611;
                  t3.v = 556;
                  t3.w = 778;
                  t3.x = 556;
                  t3.y = 556;
                  t3.z = 500;
                  t3.braceleft = 389;
                  t3.bar = 280;
                  t3.braceright = 389;
                  t3.asciitilde = 584;
                  t3.exclamdown = 333;
                  t3.cent = 556;
                  t3.sterling = 556;
                  t3.fraction = 167;
                  t3.yen = 556;
                  t3.florin = 556;
                  t3.section = 556;
                  t3.currency = 556;
                  t3.quotesingle = 238;
                  t3.quotedblleft = 500;
                  t3.guillemotleft = 556;
                  t3.guilsinglleft = 333;
                  t3.guilsinglright = 333;
                  t3.fi = 611;
                  t3.fl = 611;
                  t3.endash = 556;
                  t3.dagger = 556;
                  t3.daggerdbl = 556;
                  t3.periodcentered = 278;
                  t3.paragraph = 556;
                  t3.bullet = 350;
                  t3.quotesinglbase = 278;
                  t3.quotedblbase = 500;
                  t3.quotedblright = 500;
                  t3.guillemotright = 556;
                  t3.ellipsis = 1e3;
                  t3.perthousand = 1e3;
                  t3.questiondown = 611;
                  t3.grave = 333;
                  t3.acute = 333;
                  t3.circumflex = 333;
                  t3.tilde = 333;
                  t3.macron = 333;
                  t3.breve = 333;
                  t3.dotaccent = 333;
                  t3.dieresis = 333;
                  t3.ring = 333;
                  t3.cedilla = 333;
                  t3.hungarumlaut = 333;
                  t3.ogonek = 333;
                  t3.caron = 333;
                  t3.emdash = 1e3;
                  t3.AE = 1e3;
                  t3.ordfeminine = 370;
                  t3.Lslash = 611;
                  t3.Oslash = 778;
                  t3.OE = 1e3;
                  t3.ordmasculine = 365;
                  t3.ae = 889;
                  t3.dotlessi = 278;
                  t3.lslash = 278;
                  t3.oslash = 611;
                  t3.oe = 944;
                  t3.germandbls = 611;
                  t3.Idieresis = 278;
                  t3.eacute = 556;
                  t3.abreve = 556;
                  t3.uhungarumlaut = 611;
                  t3.ecaron = 556;
                  t3.Ydieresis = 667;
                  t3.divide = 584;
                  t3.Yacute = 667;
                  t3.Acircumflex = 722;
                  t3.aacute = 556;
                  t3.Ucircumflex = 722;
                  t3.yacute = 556;
                  t3.scommaaccent = 556;
                  t3.ecircumflex = 556;
                  t3.Uring = 722;
                  t3.Udieresis = 722;
                  t3.aogonek = 556;
                  t3.Uacute = 722;
                  t3.uogonek = 611;
                  t3.Edieresis = 667;
                  t3.Dcroat = 722;
                  t3.commaaccent = 250;
                  t3.copyright = 737;
                  t3.Emacron = 667;
                  t3.ccaron = 556;
                  t3.aring = 556;
                  t3.Ncommaaccent = 722;
                  t3.lacute = 278;
                  t3.agrave = 556;
                  t3.Tcommaaccent = 611;
                  t3.Cacute = 722;
                  t3.atilde = 556;
                  t3.Edotaccent = 667;
                  t3.scaron = 556;
                  t3.scedilla = 556;
                  t3.iacute = 278;
                  t3.lozenge = 494;
                  t3.Rcaron = 722;
                  t3.Gcommaaccent = 778;
                  t3.ucircumflex = 611;
                  t3.acircumflex = 556;
                  t3.Amacron = 722;
                  t3.rcaron = 389;
                  t3.ccedilla = 556;
                  t3.Zdotaccent = 611;
                  t3.Thorn = 667;
                  t3.Omacron = 778;
                  t3.Racute = 722;
                  t3.Sacute = 667;
                  t3.dcaron = 743;
                  t3.Umacron = 722;
                  t3.uring = 611;
                  t3.threesuperior = 333;
                  t3.Ograve = 778;
                  t3.Agrave = 722;
                  t3.Abreve = 722;
                  t3.multiply = 584;
                  t3.uacute = 611;
                  t3.Tcaron = 611;
                  t3.partialdiff = 494;
                  t3.ydieresis = 556;
                  t3.Nacute = 722;
                  t3.icircumflex = 278;
                  t3.Ecircumflex = 667;
                  t3.adieresis = 556;
                  t3.edieresis = 556;
                  t3.cacute = 556;
                  t3.nacute = 611;
                  t3.umacron = 611;
                  t3.Ncaron = 722;
                  t3.Iacute = 278;
                  t3.plusminus = 584;
                  t3.brokenbar = 280;
                  t3.registered = 737;
                  t3.Gbreve = 778;
                  t3.Idotaccent = 278;
                  t3.summation = 600;
                  t3.Egrave = 667;
                  t3.racute = 389;
                  t3.omacron = 611;
                  t3.Zacute = 611;
                  t3.Zcaron = 611;
                  t3.greaterequal = 549;
                  t3.Eth = 722;
                  t3.Ccedilla = 722;
                  t3.lcommaaccent = 278;
                  t3.tcaron = 389;
                  t3.eogonek = 556;
                  t3.Uogonek = 722;
                  t3.Aacute = 722;
                  t3.Adieresis = 722;
                  t3.egrave = 556;
                  t3.zacute = 500;
                  t3.iogonek = 278;
                  t3.Oacute = 778;
                  t3.oacute = 611;
                  t3.amacron = 556;
                  t3.sacute = 556;
                  t3.idieresis = 278;
                  t3.Ocircumflex = 778;
                  t3.Ugrave = 722;
                  t3.Delta = 612;
                  t3.thorn = 611;
                  t3.twosuperior = 333;
                  t3.Odieresis = 778;
                  t3.mu = 611;
                  t3.igrave = 278;
                  t3.ohungarumlaut = 611;
                  t3.Eogonek = 667;
                  t3.dcroat = 611;
                  t3.threequarters = 834;
                  t3.Scedilla = 667;
                  t3.lcaron = 400;
                  t3.Kcommaaccent = 722;
                  t3.Lacute = 611;
                  t3.trademark = 1e3;
                  t3.edotaccent = 556;
                  t3.Igrave = 278;
                  t3.Imacron = 278;
                  t3.Lcaron = 611;
                  t3.onehalf = 834;
                  t3.lessequal = 549;
                  t3.ocircumflex = 611;
                  t3.ntilde = 611;
                  t3.Uhungarumlaut = 722;
                  t3.Eacute = 667;
                  t3.emacron = 556;
                  t3.gbreve = 611;
                  t3.onequarter = 834;
                  t3.Scaron = 667;
                  t3.Scommaaccent = 667;
                  t3.Ohungarumlaut = 778;
                  t3.degree = 400;
                  t3.ograve = 611;
                  t3.Ccaron = 722;
                  t3.ugrave = 611;
                  t3.radical = 549;
                  t3.Dcaron = 722;
                  t3.rcommaaccent = 389;
                  t3.Ntilde = 722;
                  t3.otilde = 611;
                  t3.Rcommaaccent = 722;
                  t3.Lcommaaccent = 611;
                  t3.Atilde = 722;
                  t3.Aogonek = 722;
                  t3.Aring = 722;
                  t3.Otilde = 778;
                  t3.zdotaccent = 500;
                  t3.Ecaron = 667;
                  t3.Iogonek = 278;
                  t3.kcommaaccent = 556;
                  t3.minus = 584;
                  t3.Icircumflex = 278;
                  t3.ncaron = 611;
                  t3.tcommaaccent = 333;
                  t3.logicalnot = 584;
                  t3.odieresis = 611;
                  t3.udieresis = 611;
                  t3.notequal = 549;
                  t3.gcommaaccent = 611;
                  t3.eth = 611;
                  t3.zcaron = 500;
                  t3.ncommaaccent = 611;
                  t3.onesuperior = 333;
                  t3.imacron = 278;
                  t3.Euro = 556;
                });
                t2["Helvetica-Oblique"] = (0, _core_utils.getLookupTableFactory)(function(t3) {
                  t3.space = 278;
                  t3.exclam = 278;
                  t3.quotedbl = 355;
                  t3.numbersign = 556;
                  t3.dollar = 556;
                  t3.percent = 889;
                  t3.ampersand = 667;
                  t3.quoteright = 222;
                  t3.parenleft = 333;
                  t3.parenright = 333;
                  t3.asterisk = 389;
                  t3.plus = 584;
                  t3.comma = 278;
                  t3.hyphen = 333;
                  t3.period = 278;
                  t3.slash = 278;
                  t3.zero = 556;
                  t3.one = 556;
                  t3.two = 556;
                  t3.three = 556;
                  t3.four = 556;
                  t3.five = 556;
                  t3.six = 556;
                  t3.seven = 556;
                  t3.eight = 556;
                  t3.nine = 556;
                  t3.colon = 278;
                  t3.semicolon = 278;
                  t3.less = 584;
                  t3.equal = 584;
                  t3.greater = 584;
                  t3.question = 556;
                  t3.at = 1015;
                  t3.A = 667;
                  t3.B = 667;
                  t3.C = 722;
                  t3.D = 722;
                  t3.E = 667;
                  t3.F = 611;
                  t3.G = 778;
                  t3.H = 722;
                  t3.I = 278;
                  t3.J = 500;
                  t3.K = 667;
                  t3.L = 556;
                  t3.M = 833;
                  t3.N = 722;
                  t3.O = 778;
                  t3.P = 667;
                  t3.Q = 778;
                  t3.R = 722;
                  t3.S = 667;
                  t3.T = 611;
                  t3.U = 722;
                  t3.V = 667;
                  t3.W = 944;
                  t3.X = 667;
                  t3.Y = 667;
                  t3.Z = 611;
                  t3.bracketleft = 278;
                  t3.backslash = 278;
                  t3.bracketright = 278;
                  t3.asciicircum = 469;
                  t3.underscore = 556;
                  t3.quoteleft = 222;
                  t3.a = 556;
                  t3.b = 556;
                  t3.c = 500;
                  t3.d = 556;
                  t3.e = 556;
                  t3.f = 278;
                  t3.g = 556;
                  t3.h = 556;
                  t3.i = 222;
                  t3.j = 222;
                  t3.k = 500;
                  t3.l = 222;
                  t3.m = 833;
                  t3.n = 556;
                  t3.o = 556;
                  t3.p = 556;
                  t3.q = 556;
                  t3.r = 333;
                  t3.s = 500;
                  t3.t = 278;
                  t3.u = 556;
                  t3.v = 500;
                  t3.w = 722;
                  t3.x = 500;
                  t3.y = 500;
                  t3.z = 500;
                  t3.braceleft = 334;
                  t3.bar = 260;
                  t3.braceright = 334;
                  t3.asciitilde = 584;
                  t3.exclamdown = 333;
                  t3.cent = 556;
                  t3.sterling = 556;
                  t3.fraction = 167;
                  t3.yen = 556;
                  t3.florin = 556;
                  t3.section = 556;
                  t3.currency = 556;
                  t3.quotesingle = 191;
                  t3.quotedblleft = 333;
                  t3.guillemotleft = 556;
                  t3.guilsinglleft = 333;
                  t3.guilsinglright = 333;
                  t3.fi = 500;
                  t3.fl = 500;
                  t3.endash = 556;
                  t3.dagger = 556;
                  t3.daggerdbl = 556;
                  t3.periodcentered = 278;
                  t3.paragraph = 537;
                  t3.bullet = 350;
                  t3.quotesinglbase = 222;
                  t3.quotedblbase = 333;
                  t3.quotedblright = 333;
                  t3.guillemotright = 556;
                  t3.ellipsis = 1e3;
                  t3.perthousand = 1e3;
                  t3.questiondown = 611;
                  t3.grave = 333;
                  t3.acute = 333;
                  t3.circumflex = 333;
                  t3.tilde = 333;
                  t3.macron = 333;
                  t3.breve = 333;
                  t3.dotaccent = 333;
                  t3.dieresis = 333;
                  t3.ring = 333;
                  t3.cedilla = 333;
                  t3.hungarumlaut = 333;
                  t3.ogonek = 333;
                  t3.caron = 333;
                  t3.emdash = 1e3;
                  t3.AE = 1e3;
                  t3.ordfeminine = 370;
                  t3.Lslash = 556;
                  t3.Oslash = 778;
                  t3.OE = 1e3;
                  t3.ordmasculine = 365;
                  t3.ae = 889;
                  t3.dotlessi = 278;
                  t3.lslash = 222;
                  t3.oslash = 611;
                  t3.oe = 944;
                  t3.germandbls = 611;
                  t3.Idieresis = 278;
                  t3.eacute = 556;
                  t3.abreve = 556;
                  t3.uhungarumlaut = 556;
                  t3.ecaron = 556;
                  t3.Ydieresis = 667;
                  t3.divide = 584;
                  t3.Yacute = 667;
                  t3.Acircumflex = 667;
                  t3.aacute = 556;
                  t3.Ucircumflex = 722;
                  t3.yacute = 500;
                  t3.scommaaccent = 500;
                  t3.ecircumflex = 556;
                  t3.Uring = 722;
                  t3.Udieresis = 722;
                  t3.aogonek = 556;
                  t3.Uacute = 722;
                  t3.uogonek = 556;
                  t3.Edieresis = 667;
                  t3.Dcroat = 722;
                  t3.commaaccent = 250;
                  t3.copyright = 737;
                  t3.Emacron = 667;
                  t3.ccaron = 500;
                  t3.aring = 556;
                  t3.Ncommaaccent = 722;
                  t3.lacute = 222;
                  t3.agrave = 556;
                  t3.Tcommaaccent = 611;
                  t3.Cacute = 722;
                  t3.atilde = 556;
                  t3.Edotaccent = 667;
                  t3.scaron = 500;
                  t3.scedilla = 500;
                  t3.iacute = 278;
                  t3.lozenge = 471;
                  t3.Rcaron = 722;
                  t3.Gcommaaccent = 778;
                  t3.ucircumflex = 556;
                  t3.acircumflex = 556;
                  t3.Amacron = 667;
                  t3.rcaron = 333;
                  t3.ccedilla = 500;
                  t3.Zdotaccent = 611;
                  t3.Thorn = 667;
                  t3.Omacron = 778;
                  t3.Racute = 722;
                  t3.Sacute = 667;
                  t3.dcaron = 643;
                  t3.Umacron = 722;
                  t3.uring = 556;
                  t3.threesuperior = 333;
                  t3.Ograve = 778;
                  t3.Agrave = 667;
                  t3.Abreve = 667;
                  t3.multiply = 584;
                  t3.uacute = 556;
                  t3.Tcaron = 611;
                  t3.partialdiff = 476;
                  t3.ydieresis = 500;
                  t3.Nacute = 722;
                  t3.icircumflex = 278;
                  t3.Ecircumflex = 667;
                  t3.adieresis = 556;
                  t3.edieresis = 556;
                  t3.cacute = 500;
                  t3.nacute = 556;
                  t3.umacron = 556;
                  t3.Ncaron = 722;
                  t3.Iacute = 278;
                  t3.plusminus = 584;
                  t3.brokenbar = 260;
                  t3.registered = 737;
                  t3.Gbreve = 778;
                  t3.Idotaccent = 278;
                  t3.summation = 600;
                  t3.Egrave = 667;
                  t3.racute = 333;
                  t3.omacron = 556;
                  t3.Zacute = 611;
                  t3.Zcaron = 611;
                  t3.greaterequal = 549;
                  t3.Eth = 722;
                  t3.Ccedilla = 722;
                  t3.lcommaaccent = 222;
                  t3.tcaron = 317;
                  t3.eogonek = 556;
                  t3.Uogonek = 722;
                  t3.Aacute = 667;
                  t3.Adieresis = 667;
                  t3.egrave = 556;
                  t3.zacute = 500;
                  t3.iogonek = 222;
                  t3.Oacute = 778;
                  t3.oacute = 556;
                  t3.amacron = 556;
                  t3.sacute = 500;
                  t3.idieresis = 278;
                  t3.Ocircumflex = 778;
                  t3.Ugrave = 722;
                  t3.Delta = 612;
                  t3.thorn = 556;
                  t3.twosuperior = 333;
                  t3.Odieresis = 778;
                  t3.mu = 556;
                  t3.igrave = 278;
                  t3.ohungarumlaut = 556;
                  t3.Eogonek = 667;
                  t3.dcroat = 556;
                  t3.threequarters = 834;
                  t3.Scedilla = 667;
                  t3.lcaron = 299;
                  t3.Kcommaaccent = 667;
                  t3.Lacute = 556;
                  t3.trademark = 1e3;
                  t3.edotaccent = 556;
                  t3.Igrave = 278;
                  t3.Imacron = 278;
                  t3.Lcaron = 556;
                  t3.onehalf = 834;
                  t3.lessequal = 549;
                  t3.ocircumflex = 556;
                  t3.ntilde = 556;
                  t3.Uhungarumlaut = 722;
                  t3.Eacute = 667;
                  t3.emacron = 556;
                  t3.gbreve = 556;
                  t3.onequarter = 834;
                  t3.Scaron = 667;
                  t3.Scommaaccent = 667;
                  t3.Ohungarumlaut = 778;
                  t3.degree = 400;
                  t3.ograve = 556;
                  t3.Ccaron = 722;
                  t3.ugrave = 556;
                  t3.radical = 453;
                  t3.Dcaron = 722;
                  t3.rcommaaccent = 333;
                  t3.Ntilde = 722;
                  t3.otilde = 556;
                  t3.Rcommaaccent = 722;
                  t3.Lcommaaccent = 556;
                  t3.Atilde = 667;
                  t3.Aogonek = 667;
                  t3.Aring = 667;
                  t3.Otilde = 778;
                  t3.zdotaccent = 500;
                  t3.Ecaron = 667;
                  t3.Iogonek = 278;
                  t3.kcommaaccent = 500;
                  t3.minus = 584;
                  t3.Icircumflex = 278;
                  t3.ncaron = 556;
                  t3.tcommaaccent = 278;
                  t3.logicalnot = 584;
                  t3.odieresis = 556;
                  t3.udieresis = 556;
                  t3.notequal = 549;
                  t3.gcommaaccent = 556;
                  t3.eth = 556;
                  t3.zcaron = 500;
                  t3.ncommaaccent = 556;
                  t3.onesuperior = 333;
                  t3.imacron = 278;
                  t3.Euro = 556;
                });
                t2.Symbol = (0, _core_utils.getLookupTableFactory)(function(t3) {
                  t3.space = 250;
                  t3.exclam = 333;
                  t3.universal = 713;
                  t3.numbersign = 500;
                  t3.existential = 549;
                  t3.percent = 833;
                  t3.ampersand = 778;
                  t3.suchthat = 439;
                  t3.parenleft = 333;
                  t3.parenright = 333;
                  t3.asteriskmath = 500;
                  t3.plus = 549;
                  t3.comma = 250;
                  t3.minus = 549;
                  t3.period = 250;
                  t3.slash = 278;
                  t3.zero = 500;
                  t3.one = 500;
                  t3.two = 500;
                  t3.three = 500;
                  t3.four = 500;
                  t3.five = 500;
                  t3.six = 500;
                  t3.seven = 500;
                  t3.eight = 500;
                  t3.nine = 500;
                  t3.colon = 278;
                  t3.semicolon = 278;
                  t3.less = 549;
                  t3.equal = 549;
                  t3.greater = 549;
                  t3.question = 444;
                  t3.congruent = 549;
                  t3.Alpha = 722;
                  t3.Beta = 667;
                  t3.Chi = 722;
                  t3.Delta = 612;
                  t3.Epsilon = 611;
                  t3.Phi = 763;
                  t3.Gamma = 603;
                  t3.Eta = 722;
                  t3.Iota = 333;
                  t3.theta1 = 631;
                  t3.Kappa = 722;
                  t3.Lambda = 686;
                  t3.Mu = 889;
                  t3.Nu = 722;
                  t3.Omicron = 722;
                  t3.Pi = 768;
                  t3.Theta = 741;
                  t3.Rho = 556;
                  t3.Sigma = 592;
                  t3.Tau = 611;
                  t3.Upsilon = 690;
                  t3.sigma1 = 439;
                  t3.Omega = 768;
                  t3.Xi = 645;
                  t3.Psi = 795;
                  t3.Zeta = 611;
                  t3.bracketleft = 333;
                  t3.therefore = 863;
                  t3.bracketright = 333;
                  t3.perpendicular = 658;
                  t3.underscore = 500;
                  t3.radicalex = 500;
                  t3.alpha = 631;
                  t3.beta = 549;
                  t3.chi = 549;
                  t3.delta = 494;
                  t3.epsilon = 439;
                  t3.phi = 521;
                  t3.gamma = 411;
                  t3.eta = 603;
                  t3.iota = 329;
                  t3.phi1 = 603;
                  t3.kappa = 549;
                  t3.lambda = 549;
                  t3.mu = 576;
                  t3.nu = 521;
                  t3.omicron = 549;
                  t3.pi = 549;
                  t3.theta = 521;
                  t3.rho = 549;
                  t3.sigma = 603;
                  t3.tau = 439;
                  t3.upsilon = 576;
                  t3.omega1 = 713;
                  t3.omega = 686;
                  t3.xi = 493;
                  t3.psi = 686;
                  t3.zeta = 494;
                  t3.braceleft = 480;
                  t3.bar = 200;
                  t3.braceright = 480;
                  t3.similar = 549;
                  t3.Euro = 750;
                  t3.Upsilon1 = 620;
                  t3.minute = 247;
                  t3.lessequal = 549;
                  t3.fraction = 167;
                  t3.infinity = 713;
                  t3.florin = 500;
                  t3.club = 753;
                  t3.diamond = 753;
                  t3.heart = 753;
                  t3.spade = 753;
                  t3.arrowboth = 1042;
                  t3.arrowleft = 987;
                  t3.arrowup = 603;
                  t3.arrowright = 987;
                  t3.arrowdown = 603;
                  t3.degree = 400;
                  t3.plusminus = 549;
                  t3.second = 411;
                  t3.greaterequal = 549;
                  t3.multiply = 549;
                  t3.proportional = 713;
                  t3.partialdiff = 494;
                  t3.bullet = 460;
                  t3.divide = 549;
                  t3.notequal = 549;
                  t3.equivalence = 549;
                  t3.approxequal = 549;
                  t3.ellipsis = 1e3;
                  t3.arrowvertex = 603;
                  t3.arrowhorizex = 1e3;
                  t3.carriagereturn = 658;
                  t3.aleph = 823;
                  t3.Ifraktur = 686;
                  t3.Rfraktur = 795;
                  t3.weierstrass = 987;
                  t3.circlemultiply = 768;
                  t3.circleplus = 768;
                  t3.emptyset = 823;
                  t3.intersection = 768;
                  t3.union = 768;
                  t3.propersuperset = 713;
                  t3.reflexsuperset = 713;
                  t3.notsubset = 713;
                  t3.propersubset = 713;
                  t3.reflexsubset = 713;
                  t3.element = 713;
                  t3.notelement = 713;
                  t3.angle = 768;
                  t3.gradient = 713;
                  t3.registerserif = 790;
                  t3.copyrightserif = 790;
                  t3.trademarkserif = 890;
                  t3.product = 823;
                  t3.radical = 549;
                  t3.dotmath = 250;
                  t3.logicalnot = 713;
                  t3.logicaland = 603;
                  t3.logicalor = 603;
                  t3.arrowdblboth = 1042;
                  t3.arrowdblleft = 987;
                  t3.arrowdblup = 603;
                  t3.arrowdblright = 987;
                  t3.arrowdbldown = 603;
                  t3.lozenge = 494;
                  t3.angleleft = 329;
                  t3.registersans = 790;
                  t3.copyrightsans = 790;
                  t3.trademarksans = 786;
                  t3.summation = 713;
                  t3.parenlefttp = 384;
                  t3.parenleftex = 384;
                  t3.parenleftbt = 384;
                  t3.bracketlefttp = 384;
                  t3.bracketleftex = 384;
                  t3.bracketleftbt = 384;
                  t3.bracelefttp = 494;
                  t3.braceleftmid = 494;
                  t3.braceleftbt = 494;
                  t3.braceex = 494;
                  t3.angleright = 329;
                  t3.integral = 274;
                  t3.integraltp = 686;
                  t3.integralex = 686;
                  t3.integralbt = 686;
                  t3.parenrighttp = 384;
                  t3.parenrightex = 384;
                  t3.parenrightbt = 384;
                  t3.bracketrighttp = 384;
                  t3.bracketrightex = 384;
                  t3.bracketrightbt = 384;
                  t3.bracerighttp = 494;
                  t3.bracerightmid = 494;
                  t3.bracerightbt = 494;
                  t3.apple = 790;
                });
                t2["Times-Roman"] = (0, _core_utils.getLookupTableFactory)(function(t3) {
                  t3.space = 250;
                  t3.exclam = 333;
                  t3.quotedbl = 408;
                  t3.numbersign = 500;
                  t3.dollar = 500;
                  t3.percent = 833;
                  t3.ampersand = 778;
                  t3.quoteright = 333;
                  t3.parenleft = 333;
                  t3.parenright = 333;
                  t3.asterisk = 500;
                  t3.plus = 564;
                  t3.comma = 250;
                  t3.hyphen = 333;
                  t3.period = 250;
                  t3.slash = 278;
                  t3.zero = 500;
                  t3.one = 500;
                  t3.two = 500;
                  t3.three = 500;
                  t3.four = 500;
                  t3.five = 500;
                  t3.six = 500;
                  t3.seven = 500;
                  t3.eight = 500;
                  t3.nine = 500;
                  t3.colon = 278;
                  t3.semicolon = 278;
                  t3.less = 564;
                  t3.equal = 564;
                  t3.greater = 564;
                  t3.question = 444;
                  t3.at = 921;
                  t3.A = 722;
                  t3.B = 667;
                  t3.C = 667;
                  t3.D = 722;
                  t3.E = 611;
                  t3.F = 556;
                  t3.G = 722;
                  t3.H = 722;
                  t3.I = 333;
                  t3.J = 389;
                  t3.K = 722;
                  t3.L = 611;
                  t3.M = 889;
                  t3.N = 722;
                  t3.O = 722;
                  t3.P = 556;
                  t3.Q = 722;
                  t3.R = 667;
                  t3.S = 556;
                  t3.T = 611;
                  t3.U = 722;
                  t3.V = 722;
                  t3.W = 944;
                  t3.X = 722;
                  t3.Y = 722;
                  t3.Z = 611;
                  t3.bracketleft = 333;
                  t3.backslash = 278;
                  t3.bracketright = 333;
                  t3.asciicircum = 469;
                  t3.underscore = 500;
                  t3.quoteleft = 333;
                  t3.a = 444;
                  t3.b = 500;
                  t3.c = 444;
                  t3.d = 500;
                  t3.e = 444;
                  t3.f = 333;
                  t3.g = 500;
                  t3.h = 500;
                  t3.i = 278;
                  t3.j = 278;
                  t3.k = 500;
                  t3.l = 278;
                  t3.m = 778;
                  t3.n = 500;
                  t3.o = 500;
                  t3.p = 500;
                  t3.q = 500;
                  t3.r = 333;
                  t3.s = 389;
                  t3.t = 278;
                  t3.u = 500;
                  t3.v = 500;
                  t3.w = 722;
                  t3.x = 500;
                  t3.y = 500;
                  t3.z = 444;
                  t3.braceleft = 480;
                  t3.bar = 200;
                  t3.braceright = 480;
                  t3.asciitilde = 541;
                  t3.exclamdown = 333;
                  t3.cent = 500;
                  t3.sterling = 500;
                  t3.fraction = 167;
                  t3.yen = 500;
                  t3.florin = 500;
                  t3.section = 500;
                  t3.currency = 500;
                  t3.quotesingle = 180;
                  t3.quotedblleft = 444;
                  t3.guillemotleft = 500;
                  t3.guilsinglleft = 333;
                  t3.guilsinglright = 333;
                  t3.fi = 556;
                  t3.fl = 556;
                  t3.endash = 500;
                  t3.dagger = 500;
                  t3.daggerdbl = 500;
                  t3.periodcentered = 250;
                  t3.paragraph = 453;
                  t3.bullet = 350;
                  t3.quotesinglbase = 333;
                  t3.quotedblbase = 444;
                  t3.quotedblright = 444;
                  t3.guillemotright = 500;
                  t3.ellipsis = 1e3;
                  t3.perthousand = 1e3;
                  t3.questiondown = 444;
                  t3.grave = 333;
                  t3.acute = 333;
                  t3.circumflex = 333;
                  t3.tilde = 333;
                  t3.macron = 333;
                  t3.breve = 333;
                  t3.dotaccent = 333;
                  t3.dieresis = 333;
                  t3.ring = 333;
                  t3.cedilla = 333;
                  t3.hungarumlaut = 333;
                  t3.ogonek = 333;
                  t3.caron = 333;
                  t3.emdash = 1e3;
                  t3.AE = 889;
                  t3.ordfeminine = 276;
                  t3.Lslash = 611;
                  t3.Oslash = 722;
                  t3.OE = 889;
                  t3.ordmasculine = 310;
                  t3.ae = 667;
                  t3.dotlessi = 278;
                  t3.lslash = 278;
                  t3.oslash = 500;
                  t3.oe = 722;
                  t3.germandbls = 500;
                  t3.Idieresis = 333;
                  t3.eacute = 444;
                  t3.abreve = 444;
                  t3.uhungarumlaut = 500;
                  t3.ecaron = 444;
                  t3.Ydieresis = 722;
                  t3.divide = 564;
                  t3.Yacute = 722;
                  t3.Acircumflex = 722;
                  t3.aacute = 444;
                  t3.Ucircumflex = 722;
                  t3.yacute = 500;
                  t3.scommaaccent = 389;
                  t3.ecircumflex = 444;
                  t3.Uring = 722;
                  t3.Udieresis = 722;
                  t3.aogonek = 444;
                  t3.Uacute = 722;
                  t3.uogonek = 500;
                  t3.Edieresis = 611;
                  t3.Dcroat = 722;
                  t3.commaaccent = 250;
                  t3.copyright = 760;
                  t3.Emacron = 611;
                  t3.ccaron = 444;
                  t3.aring = 444;
                  t3.Ncommaaccent = 722;
                  t3.lacute = 278;
                  t3.agrave = 444;
                  t3.Tcommaaccent = 611;
                  t3.Cacute = 667;
                  t3.atilde = 444;
                  t3.Edotaccent = 611;
                  t3.scaron = 389;
                  t3.scedilla = 389;
                  t3.iacute = 278;
                  t3.lozenge = 471;
                  t3.Rcaron = 667;
                  t3.Gcommaaccent = 722;
                  t3.ucircumflex = 500;
                  t3.acircumflex = 444;
                  t3.Amacron = 722;
                  t3.rcaron = 333;
                  t3.ccedilla = 444;
                  t3.Zdotaccent = 611;
                  t3.Thorn = 556;
                  t3.Omacron = 722;
                  t3.Racute = 667;
                  t3.Sacute = 556;
                  t3.dcaron = 588;
                  t3.Umacron = 722;
                  t3.uring = 500;
                  t3.threesuperior = 300;
                  t3.Ograve = 722;
                  t3.Agrave = 722;
                  t3.Abreve = 722;
                  t3.multiply = 564;
                  t3.uacute = 500;
                  t3.Tcaron = 611;
                  t3.partialdiff = 476;
                  t3.ydieresis = 500;
                  t3.Nacute = 722;
                  t3.icircumflex = 278;
                  t3.Ecircumflex = 611;
                  t3.adieresis = 444;
                  t3.edieresis = 444;
                  t3.cacute = 444;
                  t3.nacute = 500;
                  t3.umacron = 500;
                  t3.Ncaron = 722;
                  t3.Iacute = 333;
                  t3.plusminus = 564;
                  t3.brokenbar = 200;
                  t3.registered = 760;
                  t3.Gbreve = 722;
                  t3.Idotaccent = 333;
                  t3.summation = 600;
                  t3.Egrave = 611;
                  t3.racute = 333;
                  t3.omacron = 500;
                  t3.Zacute = 611;
                  t3.Zcaron = 611;
                  t3.greaterequal = 549;
                  t3.Eth = 722;
                  t3.Ccedilla = 667;
                  t3.lcommaaccent = 278;
                  t3.tcaron = 326;
                  t3.eogonek = 444;
                  t3.Uogonek = 722;
                  t3.Aacute = 722;
                  t3.Adieresis = 722;
                  t3.egrave = 444;
                  t3.zacute = 444;
                  t3.iogonek = 278;
                  t3.Oacute = 722;
                  t3.oacute = 500;
                  t3.amacron = 444;
                  t3.sacute = 389;
                  t3.idieresis = 278;
                  t3.Ocircumflex = 722;
                  t3.Ugrave = 722;
                  t3.Delta = 612;
                  t3.thorn = 500;
                  t3.twosuperior = 300;
                  t3.Odieresis = 722;
                  t3.mu = 500;
                  t3.igrave = 278;
                  t3.ohungarumlaut = 500;
                  t3.Eogonek = 611;
                  t3.dcroat = 500;
                  t3.threequarters = 750;
                  t3.Scedilla = 556;
                  t3.lcaron = 344;
                  t3.Kcommaaccent = 722;
                  t3.Lacute = 611;
                  t3.trademark = 980;
                  t3.edotaccent = 444;
                  t3.Igrave = 333;
                  t3.Imacron = 333;
                  t3.Lcaron = 611;
                  t3.onehalf = 750;
                  t3.lessequal = 549;
                  t3.ocircumflex = 500;
                  t3.ntilde = 500;
                  t3.Uhungarumlaut = 722;
                  t3.Eacute = 611;
                  t3.emacron = 444;
                  t3.gbreve = 500;
                  t3.onequarter = 750;
                  t3.Scaron = 556;
                  t3.Scommaaccent = 556;
                  t3.Ohungarumlaut = 722;
                  t3.degree = 400;
                  t3.ograve = 500;
                  t3.Ccaron = 667;
                  t3.ugrave = 500;
                  t3.radical = 453;
                  t3.Dcaron = 722;
                  t3.rcommaaccent = 333;
                  t3.Ntilde = 722;
                  t3.otilde = 500;
                  t3.Rcommaaccent = 667;
                  t3.Lcommaaccent = 611;
                  t3.Atilde = 722;
                  t3.Aogonek = 722;
                  t3.Aring = 722;
                  t3.Otilde = 722;
                  t3.zdotaccent = 444;
                  t3.Ecaron = 611;
                  t3.Iogonek = 333;
                  t3.kcommaaccent = 500;
                  t3.minus = 564;
                  t3.Icircumflex = 333;
                  t3.ncaron = 500;
                  t3.tcommaaccent = 278;
                  t3.logicalnot = 564;
                  t3.odieresis = 500;
                  t3.udieresis = 500;
                  t3.notequal = 549;
                  t3.gcommaaccent = 500;
                  t3.eth = 500;
                  t3.zcaron = 444;
                  t3.ncommaaccent = 500;
                  t3.onesuperior = 300;
                  t3.imacron = 278;
                  t3.Euro = 500;
                });
                t2["Times-Bold"] = (0, _core_utils.getLookupTableFactory)(function(t3) {
                  t3.space = 250;
                  t3.exclam = 333;
                  t3.quotedbl = 555;
                  t3.numbersign = 500;
                  t3.dollar = 500;
                  t3.percent = 1e3;
                  t3.ampersand = 833;
                  t3.quoteright = 333;
                  t3.parenleft = 333;
                  t3.parenright = 333;
                  t3.asterisk = 500;
                  t3.plus = 570;
                  t3.comma = 250;
                  t3.hyphen = 333;
                  t3.period = 250;
                  t3.slash = 278;
                  t3.zero = 500;
                  t3.one = 500;
                  t3.two = 500;
                  t3.three = 500;
                  t3.four = 500;
                  t3.five = 500;
                  t3.six = 500;
                  t3.seven = 500;
                  t3.eight = 500;
                  t3.nine = 500;
                  t3.colon = 333;
                  t3.semicolon = 333;
                  t3.less = 570;
                  t3.equal = 570;
                  t3.greater = 570;
                  t3.question = 500;
                  t3.at = 930;
                  t3.A = 722;
                  t3.B = 667;
                  t3.C = 722;
                  t3.D = 722;
                  t3.E = 667;
                  t3.F = 611;
                  t3.G = 778;
                  t3.H = 778;
                  t3.I = 389;
                  t3.J = 500;
                  t3.K = 778;
                  t3.L = 667;
                  t3.M = 944;
                  t3.N = 722;
                  t3.O = 778;
                  t3.P = 611;
                  t3.Q = 778;
                  t3.R = 722;
                  t3.S = 556;
                  t3.T = 667;
                  t3.U = 722;
                  t3.V = 722;
                  t3.W = 1e3;
                  t3.X = 722;
                  t3.Y = 722;
                  t3.Z = 667;
                  t3.bracketleft = 333;
                  t3.backslash = 278;
                  t3.bracketright = 333;
                  t3.asciicircum = 581;
                  t3.underscore = 500;
                  t3.quoteleft = 333;
                  t3.a = 500;
                  t3.b = 556;
                  t3.c = 444;
                  t3.d = 556;
                  t3.e = 444;
                  t3.f = 333;
                  t3.g = 500;
                  t3.h = 556;
                  t3.i = 278;
                  t3.j = 333;
                  t3.k = 556;
                  t3.l = 278;
                  t3.m = 833;
                  t3.n = 556;
                  t3.o = 500;
                  t3.p = 556;
                  t3.q = 556;
                  t3.r = 444;
                  t3.s = 389;
                  t3.t = 333;
                  t3.u = 556;
                  t3.v = 500;
                  t3.w = 722;
                  t3.x = 500;
                  t3.y = 500;
                  t3.z = 444;
                  t3.braceleft = 394;
                  t3.bar = 220;
                  t3.braceright = 394;
                  t3.asciitilde = 520;
                  t3.exclamdown = 333;
                  t3.cent = 500;
                  t3.sterling = 500;
                  t3.fraction = 167;
                  t3.yen = 500;
                  t3.florin = 500;
                  t3.section = 500;
                  t3.currency = 500;
                  t3.quotesingle = 278;
                  t3.quotedblleft = 500;
                  t3.guillemotleft = 500;
                  t3.guilsinglleft = 333;
                  t3.guilsinglright = 333;
                  t3.fi = 556;
                  t3.fl = 556;
                  t3.endash = 500;
                  t3.dagger = 500;
                  t3.daggerdbl = 500;
                  t3.periodcentered = 250;
                  t3.paragraph = 540;
                  t3.bullet = 350;
                  t3.quotesinglbase = 333;
                  t3.quotedblbase = 500;
                  t3.quotedblright = 500;
                  t3.guillemotright = 500;
                  t3.ellipsis = 1e3;
                  t3.perthousand = 1e3;
                  t3.questiondown = 500;
                  t3.grave = 333;
                  t3.acute = 333;
                  t3.circumflex = 333;
                  t3.tilde = 333;
                  t3.macron = 333;
                  t3.breve = 333;
                  t3.dotaccent = 333;
                  t3.dieresis = 333;
                  t3.ring = 333;
                  t3.cedilla = 333;
                  t3.hungarumlaut = 333;
                  t3.ogonek = 333;
                  t3.caron = 333;
                  t3.emdash = 1e3;
                  t3.AE = 1e3;
                  t3.ordfeminine = 300;
                  t3.Lslash = 667;
                  t3.Oslash = 778;
                  t3.OE = 1e3;
                  t3.ordmasculine = 330;
                  t3.ae = 722;
                  t3.dotlessi = 278;
                  t3.lslash = 278;
                  t3.oslash = 500;
                  t3.oe = 722;
                  t3.germandbls = 556;
                  t3.Idieresis = 389;
                  t3.eacute = 444;
                  t3.abreve = 500;
                  t3.uhungarumlaut = 556;
                  t3.ecaron = 444;
                  t3.Ydieresis = 722;
                  t3.divide = 570;
                  t3.Yacute = 722;
                  t3.Acircumflex = 722;
                  t3.aacute = 500;
                  t3.Ucircumflex = 722;
                  t3.yacute = 500;
                  t3.scommaaccent = 389;
                  t3.ecircumflex = 444;
                  t3.Uring = 722;
                  t3.Udieresis = 722;
                  t3.aogonek = 500;
                  t3.Uacute = 722;
                  t3.uogonek = 556;
                  t3.Edieresis = 667;
                  t3.Dcroat = 722;
                  t3.commaaccent = 250;
                  t3.copyright = 747;
                  t3.Emacron = 667;
                  t3.ccaron = 444;
                  t3.aring = 500;
                  t3.Ncommaaccent = 722;
                  t3.lacute = 278;
                  t3.agrave = 500;
                  t3.Tcommaaccent = 667;
                  t3.Cacute = 722;
                  t3.atilde = 500;
                  t3.Edotaccent = 667;
                  t3.scaron = 389;
                  t3.scedilla = 389;
                  t3.iacute = 278;
                  t3.lozenge = 494;
                  t3.Rcaron = 722;
                  t3.Gcommaaccent = 778;
                  t3.ucircumflex = 556;
                  t3.acircumflex = 500;
                  t3.Amacron = 722;
                  t3.rcaron = 444;
                  t3.ccedilla = 444;
                  t3.Zdotaccent = 667;
                  t3.Thorn = 611;
                  t3.Omacron = 778;
                  t3.Racute = 722;
                  t3.Sacute = 556;
                  t3.dcaron = 672;
                  t3.Umacron = 722;
                  t3.uring = 556;
                  t3.threesuperior = 300;
                  t3.Ograve = 778;
                  t3.Agrave = 722;
                  t3.Abreve = 722;
                  t3.multiply = 570;
                  t3.uacute = 556;
                  t3.Tcaron = 667;
                  t3.partialdiff = 494;
                  t3.ydieresis = 500;
                  t3.Nacute = 722;
                  t3.icircumflex = 278;
                  t3.Ecircumflex = 667;
                  t3.adieresis = 500;
                  t3.edieresis = 444;
                  t3.cacute = 444;
                  t3.nacute = 556;
                  t3.umacron = 556;
                  t3.Ncaron = 722;
                  t3.Iacute = 389;
                  t3.plusminus = 570;
                  t3.brokenbar = 220;
                  t3.registered = 747;
                  t3.Gbreve = 778;
                  t3.Idotaccent = 389;
                  t3.summation = 600;
                  t3.Egrave = 667;
                  t3.racute = 444;
                  t3.omacron = 500;
                  t3.Zacute = 667;
                  t3.Zcaron = 667;
                  t3.greaterequal = 549;
                  t3.Eth = 722;
                  t3.Ccedilla = 722;
                  t3.lcommaaccent = 278;
                  t3.tcaron = 416;
                  t3.eogonek = 444;
                  t3.Uogonek = 722;
                  t3.Aacute = 722;
                  t3.Adieresis = 722;
                  t3.egrave = 444;
                  t3.zacute = 444;
                  t3.iogonek = 278;
                  t3.Oacute = 778;
                  t3.oacute = 500;
                  t3.amacron = 500;
                  t3.sacute = 389;
                  t3.idieresis = 278;
                  t3.Ocircumflex = 778;
                  t3.Ugrave = 722;
                  t3.Delta = 612;
                  t3.thorn = 556;
                  t3.twosuperior = 300;
                  t3.Odieresis = 778;
                  t3.mu = 556;
                  t3.igrave = 278;
                  t3.ohungarumlaut = 500;
                  t3.Eogonek = 667;
                  t3.dcroat = 556;
                  t3.threequarters = 750;
                  t3.Scedilla = 556;
                  t3.lcaron = 394;
                  t3.Kcommaaccent = 778;
                  t3.Lacute = 667;
                  t3.trademark = 1e3;
                  t3.edotaccent = 444;
                  t3.Igrave = 389;
                  t3.Imacron = 389;
                  t3.Lcaron = 667;
                  t3.onehalf = 750;
                  t3.lessequal = 549;
                  t3.ocircumflex = 500;
                  t3.ntilde = 556;
                  t3.Uhungarumlaut = 722;
                  t3.Eacute = 667;
                  t3.emacron = 444;
                  t3.gbreve = 500;
                  t3.onequarter = 750;
                  t3.Scaron = 556;
                  t3.Scommaaccent = 556;
                  t3.Ohungarumlaut = 778;
                  t3.degree = 400;
                  t3.ograve = 500;
                  t3.Ccaron = 722;
                  t3.ugrave = 556;
                  t3.radical = 549;
                  t3.Dcaron = 722;
                  t3.rcommaaccent = 444;
                  t3.Ntilde = 722;
                  t3.otilde = 500;
                  t3.Rcommaaccent = 722;
                  t3.Lcommaaccent = 667;
                  t3.Atilde = 722;
                  t3.Aogonek = 722;
                  t3.Aring = 722;
                  t3.Otilde = 778;
                  t3.zdotaccent = 444;
                  t3.Ecaron = 667;
                  t3.Iogonek = 389;
                  t3.kcommaaccent = 556;
                  t3.minus = 570;
                  t3.Icircumflex = 389;
                  t3.ncaron = 556;
                  t3.tcommaaccent = 333;
                  t3.logicalnot = 570;
                  t3.odieresis = 500;
                  t3.udieresis = 556;
                  t3.notequal = 549;
                  t3.gcommaaccent = 500;
                  t3.eth = 500;
                  t3.zcaron = 444;
                  t3.ncommaaccent = 556;
                  t3.onesuperior = 300;
                  t3.imacron = 278;
                  t3.Euro = 500;
                });
                t2["Times-BoldItalic"] = (0, _core_utils.getLookupTableFactory)(function(t3) {
                  t3.space = 250;
                  t3.exclam = 389;
                  t3.quotedbl = 555;
                  t3.numbersign = 500;
                  t3.dollar = 500;
                  t3.percent = 833;
                  t3.ampersand = 778;
                  t3.quoteright = 333;
                  t3.parenleft = 333;
                  t3.parenright = 333;
                  t3.asterisk = 500;
                  t3.plus = 570;
                  t3.comma = 250;
                  t3.hyphen = 333;
                  t3.period = 250;
                  t3.slash = 278;
                  t3.zero = 500;
                  t3.one = 500;
                  t3.two = 500;
                  t3.three = 500;
                  t3.four = 500;
                  t3.five = 500;
                  t3.six = 500;
                  t3.seven = 500;
                  t3.eight = 500;
                  t3.nine = 500;
                  t3.colon = 333;
                  t3.semicolon = 333;
                  t3.less = 570;
                  t3.equal = 570;
                  t3.greater = 570;
                  t3.question = 500;
                  t3.at = 832;
                  t3.A = 667;
                  t3.B = 667;
                  t3.C = 667;
                  t3.D = 722;
                  t3.E = 667;
                  t3.F = 667;
                  t3.G = 722;
                  t3.H = 778;
                  t3.I = 389;
                  t3.J = 500;
                  t3.K = 667;
                  t3.L = 611;
                  t3.M = 889;
                  t3.N = 722;
                  t3.O = 722;
                  t3.P = 611;
                  t3.Q = 722;
                  t3.R = 667;
                  t3.S = 556;
                  t3.T = 611;
                  t3.U = 722;
                  t3.V = 667;
                  t3.W = 889;
                  t3.X = 667;
                  t3.Y = 611;
                  t3.Z = 611;
                  t3.bracketleft = 333;
                  t3.backslash = 278;
                  t3.bracketright = 333;
                  t3.asciicircum = 570;
                  t3.underscore = 500;
                  t3.quoteleft = 333;
                  t3.a = 500;
                  t3.b = 500;
                  t3.c = 444;
                  t3.d = 500;
                  t3.e = 444;
                  t3.f = 333;
                  t3.g = 500;
                  t3.h = 556;
                  t3.i = 278;
                  t3.j = 278;
                  t3.k = 500;
                  t3.l = 278;
                  t3.m = 778;
                  t3.n = 556;
                  t3.o = 500;
                  t3.p = 500;
                  t3.q = 500;
                  t3.r = 389;
                  t3.s = 389;
                  t3.t = 278;
                  t3.u = 556;
                  t3.v = 444;
                  t3.w = 667;
                  t3.x = 500;
                  t3.y = 444;
                  t3.z = 389;
                  t3.braceleft = 348;
                  t3.bar = 220;
                  t3.braceright = 348;
                  t3.asciitilde = 570;
                  t3.exclamdown = 389;
                  t3.cent = 500;
                  t3.sterling = 500;
                  t3.fraction = 167;
                  t3.yen = 500;
                  t3.florin = 500;
                  t3.section = 500;
                  t3.currency = 500;
                  t3.quotesingle = 278;
                  t3.quotedblleft = 500;
                  t3.guillemotleft = 500;
                  t3.guilsinglleft = 333;
                  t3.guilsinglright = 333;
                  t3.fi = 556;
                  t3.fl = 556;
                  t3.endash = 500;
                  t3.dagger = 500;
                  t3.daggerdbl = 500;
                  t3.periodcentered = 250;
                  t3.paragraph = 500;
                  t3.bullet = 350;
                  t3.quotesinglbase = 333;
                  t3.quotedblbase = 500;
                  t3.quotedblright = 500;
                  t3.guillemotright = 500;
                  t3.ellipsis = 1e3;
                  t3.perthousand = 1e3;
                  t3.questiondown = 500;
                  t3.grave = 333;
                  t3.acute = 333;
                  t3.circumflex = 333;
                  t3.tilde = 333;
                  t3.macron = 333;
                  t3.breve = 333;
                  t3.dotaccent = 333;
                  t3.dieresis = 333;
                  t3.ring = 333;
                  t3.cedilla = 333;
                  t3.hungarumlaut = 333;
                  t3.ogonek = 333;
                  t3.caron = 333;
                  t3.emdash = 1e3;
                  t3.AE = 944;
                  t3.ordfeminine = 266;
                  t3.Lslash = 611;
                  t3.Oslash = 722;
                  t3.OE = 944;
                  t3.ordmasculine = 300;
                  t3.ae = 722;
                  t3.dotlessi = 278;
                  t3.lslash = 278;
                  t3.oslash = 500;
                  t3.oe = 722;
                  t3.germandbls = 500;
                  t3.Idieresis = 389;
                  t3.eacute = 444;
                  t3.abreve = 500;
                  t3.uhungarumlaut = 556;
                  t3.ecaron = 444;
                  t3.Ydieresis = 611;
                  t3.divide = 570;
                  t3.Yacute = 611;
                  t3.Acircumflex = 667;
                  t3.aacute = 500;
                  t3.Ucircumflex = 722;
                  t3.yacute = 444;
                  t3.scommaaccent = 389;
                  t3.ecircumflex = 444;
                  t3.Uring = 722;
                  t3.Udieresis = 722;
                  t3.aogonek = 500;
                  t3.Uacute = 722;
                  t3.uogonek = 556;
                  t3.Edieresis = 667;
                  t3.Dcroat = 722;
                  t3.commaaccent = 250;
                  t3.copyright = 747;
                  t3.Emacron = 667;
                  t3.ccaron = 444;
                  t3.aring = 500;
                  t3.Ncommaaccent = 722;
                  t3.lacute = 278;
                  t3.agrave = 500;
                  t3.Tcommaaccent = 611;
                  t3.Cacute = 667;
                  t3.atilde = 500;
                  t3.Edotaccent = 667;
                  t3.scaron = 389;
                  t3.scedilla = 389;
                  t3.iacute = 278;
                  t3.lozenge = 494;
                  t3.Rcaron = 667;
                  t3.Gcommaaccent = 722;
                  t3.ucircumflex = 556;
                  t3.acircumflex = 500;
                  t3.Amacron = 667;
                  t3.rcaron = 389;
                  t3.ccedilla = 444;
                  t3.Zdotaccent = 611;
                  t3.Thorn = 611;
                  t3.Omacron = 722;
                  t3.Racute = 667;
                  t3.Sacute = 556;
                  t3.dcaron = 608;
                  t3.Umacron = 722;
                  t3.uring = 556;
                  t3.threesuperior = 300;
                  t3.Ograve = 722;
                  t3.Agrave = 667;
                  t3.Abreve = 667;
                  t3.multiply = 570;
                  t3.uacute = 556;
                  t3.Tcaron = 611;
                  t3.partialdiff = 494;
                  t3.ydieresis = 444;
                  t3.Nacute = 722;
                  t3.icircumflex = 278;
                  t3.Ecircumflex = 667;
                  t3.adieresis = 500;
                  t3.edieresis = 444;
                  t3.cacute = 444;
                  t3.nacute = 556;
                  t3.umacron = 556;
                  t3.Ncaron = 722;
                  t3.Iacute = 389;
                  t3.plusminus = 570;
                  t3.brokenbar = 220;
                  t3.registered = 747;
                  t3.Gbreve = 722;
                  t3.Idotaccent = 389;
                  t3.summation = 600;
                  t3.Egrave = 667;
                  t3.racute = 389;
                  t3.omacron = 500;
                  t3.Zacute = 611;
                  t3.Zcaron = 611;
                  t3.greaterequal = 549;
                  t3.Eth = 722;
                  t3.Ccedilla = 667;
                  t3.lcommaaccent = 278;
                  t3.tcaron = 366;
                  t3.eogonek = 444;
                  t3.Uogonek = 722;
                  t3.Aacute = 667;
                  t3.Adieresis = 667;
                  t3.egrave = 444;
                  t3.zacute = 389;
                  t3.iogonek = 278;
                  t3.Oacute = 722;
                  t3.oacute = 500;
                  t3.amacron = 500;
                  t3.sacute = 389;
                  t3.idieresis = 278;
                  t3.Ocircumflex = 722;
                  t3.Ugrave = 722;
                  t3.Delta = 612;
                  t3.thorn = 500;
                  t3.twosuperior = 300;
                  t3.Odieresis = 722;
                  t3.mu = 576;
                  t3.igrave = 278;
                  t3.ohungarumlaut = 500;
                  t3.Eogonek = 667;
                  t3.dcroat = 500;
                  t3.threequarters = 750;
                  t3.Scedilla = 556;
                  t3.lcaron = 382;
                  t3.Kcommaaccent = 667;
                  t3.Lacute = 611;
                  t3.trademark = 1e3;
                  t3.edotaccent = 444;
                  t3.Igrave = 389;
                  t3.Imacron = 389;
                  t3.Lcaron = 611;
                  t3.onehalf = 750;
                  t3.lessequal = 549;
                  t3.ocircumflex = 500;
                  t3.ntilde = 556;
                  t3.Uhungarumlaut = 722;
                  t3.Eacute = 667;
                  t3.emacron = 444;
                  t3.gbreve = 500;
                  t3.onequarter = 750;
                  t3.Scaron = 556;
                  t3.Scommaaccent = 556;
                  t3.Ohungarumlaut = 722;
                  t3.degree = 400;
                  t3.ograve = 500;
                  t3.Ccaron = 667;
                  t3.ugrave = 556;
                  t3.radical = 549;
                  t3.Dcaron = 722;
                  t3.rcommaaccent = 389;
                  t3.Ntilde = 722;
                  t3.otilde = 500;
                  t3.Rcommaaccent = 667;
                  t3.Lcommaaccent = 611;
                  t3.Atilde = 667;
                  t3.Aogonek = 667;
                  t3.Aring = 667;
                  t3.Otilde = 722;
                  t3.zdotaccent = 389;
                  t3.Ecaron = 667;
                  t3.Iogonek = 389;
                  t3.kcommaaccent = 500;
                  t3.minus = 606;
                  t3.Icircumflex = 389;
                  t3.ncaron = 556;
                  t3.tcommaaccent = 278;
                  t3.logicalnot = 606;
                  t3.odieresis = 500;
                  t3.udieresis = 556;
                  t3.notequal = 549;
                  t3.gcommaaccent = 500;
                  t3.eth = 500;
                  t3.zcaron = 389;
                  t3.ncommaaccent = 556;
                  t3.onesuperior = 300;
                  t3.imacron = 278;
                  t3.Euro = 500;
                });
                t2["Times-Italic"] = (0, _core_utils.getLookupTableFactory)(function(t3) {
                  t3.space = 250;
                  t3.exclam = 333;
                  t3.quotedbl = 420;
                  t3.numbersign = 500;
                  t3.dollar = 500;
                  t3.percent = 833;
                  t3.ampersand = 778;
                  t3.quoteright = 333;
                  t3.parenleft = 333;
                  t3.parenright = 333;
                  t3.asterisk = 500;
                  t3.plus = 675;
                  t3.comma = 250;
                  t3.hyphen = 333;
                  t3.period = 250;
                  t3.slash = 278;
                  t3.zero = 500;
                  t3.one = 500;
                  t3.two = 500;
                  t3.three = 500;
                  t3.four = 500;
                  t3.five = 500;
                  t3.six = 500;
                  t3.seven = 500;
                  t3.eight = 500;
                  t3.nine = 500;
                  t3.colon = 333;
                  t3.semicolon = 333;
                  t3.less = 675;
                  t3.equal = 675;
                  t3.greater = 675;
                  t3.question = 500;
                  t3.at = 920;
                  t3.A = 611;
                  t3.B = 611;
                  t3.C = 667;
                  t3.D = 722;
                  t3.E = 611;
                  t3.F = 611;
                  t3.G = 722;
                  t3.H = 722;
                  t3.I = 333;
                  t3.J = 444;
                  t3.K = 667;
                  t3.L = 556;
                  t3.M = 833;
                  t3.N = 667;
                  t3.O = 722;
                  t3.P = 611;
                  t3.Q = 722;
                  t3.R = 611;
                  t3.S = 500;
                  t3.T = 556;
                  t3.U = 722;
                  t3.V = 611;
                  t3.W = 833;
                  t3.X = 611;
                  t3.Y = 556;
                  t3.Z = 556;
                  t3.bracketleft = 389;
                  t3.backslash = 278;
                  t3.bracketright = 389;
                  t3.asciicircum = 422;
                  t3.underscore = 500;
                  t3.quoteleft = 333;
                  t3.a = 500;
                  t3.b = 500;
                  t3.c = 444;
                  t3.d = 500;
                  t3.e = 444;
                  t3.f = 278;
                  t3.g = 500;
                  t3.h = 500;
                  t3.i = 278;
                  t3.j = 278;
                  t3.k = 444;
                  t3.l = 278;
                  t3.m = 722;
                  t3.n = 500;
                  t3.o = 500;
                  t3.p = 500;
                  t3.q = 500;
                  t3.r = 389;
                  t3.s = 389;
                  t3.t = 278;
                  t3.u = 500;
                  t3.v = 444;
                  t3.w = 667;
                  t3.x = 444;
                  t3.y = 444;
                  t3.z = 389;
                  t3.braceleft = 400;
                  t3.bar = 275;
                  t3.braceright = 400;
                  t3.asciitilde = 541;
                  t3.exclamdown = 389;
                  t3.cent = 500;
                  t3.sterling = 500;
                  t3.fraction = 167;
                  t3.yen = 500;
                  t3.florin = 500;
                  t3.section = 500;
                  t3.currency = 500;
                  t3.quotesingle = 214;
                  t3.quotedblleft = 556;
                  t3.guillemotleft = 500;
                  t3.guilsinglleft = 333;
                  t3.guilsinglright = 333;
                  t3.fi = 500;
                  t3.fl = 500;
                  t3.endash = 500;
                  t3.dagger = 500;
                  t3.daggerdbl = 500;
                  t3.periodcentered = 250;
                  t3.paragraph = 523;
                  t3.bullet = 350;
                  t3.quotesinglbase = 333;
                  t3.quotedblbase = 556;
                  t3.quotedblright = 556;
                  t3.guillemotright = 500;
                  t3.ellipsis = 889;
                  t3.perthousand = 1e3;
                  t3.questiondown = 500;
                  t3.grave = 333;
                  t3.acute = 333;
                  t3.circumflex = 333;
                  t3.tilde = 333;
                  t3.macron = 333;
                  t3.breve = 333;
                  t3.dotaccent = 333;
                  t3.dieresis = 333;
                  t3.ring = 333;
                  t3.cedilla = 333;
                  t3.hungarumlaut = 333;
                  t3.ogonek = 333;
                  t3.caron = 333;
                  t3.emdash = 889;
                  t3.AE = 889;
                  t3.ordfeminine = 276;
                  t3.Lslash = 556;
                  t3.Oslash = 722;
                  t3.OE = 944;
                  t3.ordmasculine = 310;
                  t3.ae = 667;
                  t3.dotlessi = 278;
                  t3.lslash = 278;
                  t3.oslash = 500;
                  t3.oe = 667;
                  t3.germandbls = 500;
                  t3.Idieresis = 333;
                  t3.eacute = 444;
                  t3.abreve = 500;
                  t3.uhungarumlaut = 500;
                  t3.ecaron = 444;
                  t3.Ydieresis = 556;
                  t3.divide = 675;
                  t3.Yacute = 556;
                  t3.Acircumflex = 611;
                  t3.aacute = 500;
                  t3.Ucircumflex = 722;
                  t3.yacute = 444;
                  t3.scommaaccent = 389;
                  t3.ecircumflex = 444;
                  t3.Uring = 722;
                  t3.Udieresis = 722;
                  t3.aogonek = 500;
                  t3.Uacute = 722;
                  t3.uogonek = 500;
                  t3.Edieresis = 611;
                  t3.Dcroat = 722;
                  t3.commaaccent = 250;
                  t3.copyright = 760;
                  t3.Emacron = 611;
                  t3.ccaron = 444;
                  t3.aring = 500;
                  t3.Ncommaaccent = 667;
                  t3.lacute = 278;
                  t3.agrave = 500;
                  t3.Tcommaaccent = 556;
                  t3.Cacute = 667;
                  t3.atilde = 500;
                  t3.Edotaccent = 611;
                  t3.scaron = 389;
                  t3.scedilla = 389;
                  t3.iacute = 278;
                  t3.lozenge = 471;
                  t3.Rcaron = 611;
                  t3.Gcommaaccent = 722;
                  t3.ucircumflex = 500;
                  t3.acircumflex = 500;
                  t3.Amacron = 611;
                  t3.rcaron = 389;
                  t3.ccedilla = 444;
                  t3.Zdotaccent = 556;
                  t3.Thorn = 611;
                  t3.Omacron = 722;
                  t3.Racute = 611;
                  t3.Sacute = 500;
                  t3.dcaron = 544;
                  t3.Umacron = 722;
                  t3.uring = 500;
                  t3.threesuperior = 300;
                  t3.Ograve = 722;
                  t3.Agrave = 611;
                  t3.Abreve = 611;
                  t3.multiply = 675;
                  t3.uacute = 500;
                  t3.Tcaron = 556;
                  t3.partialdiff = 476;
                  t3.ydieresis = 444;
                  t3.Nacute = 667;
                  t3.icircumflex = 278;
                  t3.Ecircumflex = 611;
                  t3.adieresis = 500;
                  t3.edieresis = 444;
                  t3.cacute = 444;
                  t3.nacute = 500;
                  t3.umacron = 500;
                  t3.Ncaron = 667;
                  t3.Iacute = 333;
                  t3.plusminus = 675;
                  t3.brokenbar = 275;
                  t3.registered = 760;
                  t3.Gbreve = 722;
                  t3.Idotaccent = 333;
                  t3.summation = 600;
                  t3.Egrave = 611;
                  t3.racute = 389;
                  t3.omacron = 500;
                  t3.Zacute = 556;
                  t3.Zcaron = 556;
                  t3.greaterequal = 549;
                  t3.Eth = 722;
                  t3.Ccedilla = 667;
                  t3.lcommaaccent = 278;
                  t3.tcaron = 300;
                  t3.eogonek = 444;
                  t3.Uogonek = 722;
                  t3.Aacute = 611;
                  t3.Adieresis = 611;
                  t3.egrave = 444;
                  t3.zacute = 389;
                  t3.iogonek = 278;
                  t3.Oacute = 722;
                  t3.oacute = 500;
                  t3.amacron = 500;
                  t3.sacute = 389;
                  t3.idieresis = 278;
                  t3.Ocircumflex = 722;
                  t3.Ugrave = 722;
                  t3.Delta = 612;
                  t3.thorn = 500;
                  t3.twosuperior = 300;
                  t3.Odieresis = 722;
                  t3.mu = 500;
                  t3.igrave = 278;
                  t3.ohungarumlaut = 500;
                  t3.Eogonek = 611;
                  t3.dcroat = 500;
                  t3.threequarters = 750;
                  t3.Scedilla = 500;
                  t3.lcaron = 300;
                  t3.Kcommaaccent = 667;
                  t3.Lacute = 556;
                  t3.trademark = 980;
                  t3.edotaccent = 444;
                  t3.Igrave = 333;
                  t3.Imacron = 333;
                  t3.Lcaron = 611;
                  t3.onehalf = 750;
                  t3.lessequal = 549;
                  t3.ocircumflex = 500;
                  t3.ntilde = 500;
                  t3.Uhungarumlaut = 722;
                  t3.Eacute = 611;
                  t3.emacron = 444;
                  t3.gbreve = 500;
                  t3.onequarter = 750;
                  t3.Scaron = 500;
                  t3.Scommaaccent = 500;
                  t3.Ohungarumlaut = 722;
                  t3.degree = 400;
                  t3.ograve = 500;
                  t3.Ccaron = 667;
                  t3.ugrave = 500;
                  t3.radical = 453;
                  t3.Dcaron = 722;
                  t3.rcommaaccent = 389;
                  t3.Ntilde = 667;
                  t3.otilde = 500;
                  t3.Rcommaaccent = 611;
                  t3.Lcommaaccent = 556;
                  t3.Atilde = 611;
                  t3.Aogonek = 611;
                  t3.Aring = 611;
                  t3.Otilde = 722;
                  t3.zdotaccent = 389;
                  t3.Ecaron = 611;
                  t3.Iogonek = 333;
                  t3.kcommaaccent = 444;
                  t3.minus = 675;
                  t3.Icircumflex = 333;
                  t3.ncaron = 500;
                  t3.tcommaaccent = 278;
                  t3.logicalnot = 675;
                  t3.odieresis = 500;
                  t3.udieresis = 500;
                  t3.notequal = 549;
                  t3.gcommaaccent = 500;
                  t3.eth = 500;
                  t3.zcaron = 389;
                  t3.ncommaaccent = 500;
                  t3.onesuperior = 300;
                  t3.imacron = 278;
                  t3.Euro = 500;
                });
                t2.ZapfDingbats = (0, _core_utils.getLookupTableFactory)(function(t3) {
                  t3.space = 278;
                  t3.a1 = 974;
                  t3.a2 = 961;
                  t3.a202 = 974;
                  t3.a3 = 980;
                  t3.a4 = 719;
                  t3.a5 = 789;
                  t3.a119 = 790;
                  t3.a118 = 791;
                  t3.a117 = 690;
                  t3.a11 = 960;
                  t3.a12 = 939;
                  t3.a13 = 549;
                  t3.a14 = 855;
                  t3.a15 = 911;
                  t3.a16 = 933;
                  t3.a105 = 911;
                  t3.a17 = 945;
                  t3.a18 = 974;
                  t3.a19 = 755;
                  t3.a20 = 846;
                  t3.a21 = 762;
                  t3.a22 = 761;
                  t3.a23 = 571;
                  t3.a24 = 677;
                  t3.a25 = 763;
                  t3.a26 = 760;
                  t3.a27 = 759;
                  t3.a28 = 754;
                  t3.a6 = 494;
                  t3.a7 = 552;
                  t3.a8 = 537;
                  t3.a9 = 577;
                  t3.a10 = 692;
                  t3.a29 = 786;
                  t3.a30 = 788;
                  t3.a31 = 788;
                  t3.a32 = 790;
                  t3.a33 = 793;
                  t3.a34 = 794;
                  t3.a35 = 816;
                  t3.a36 = 823;
                  t3.a37 = 789;
                  t3.a38 = 841;
                  t3.a39 = 823;
                  t3.a40 = 833;
                  t3.a41 = 816;
                  t3.a42 = 831;
                  t3.a43 = 923;
                  t3.a44 = 744;
                  t3.a45 = 723;
                  t3.a46 = 749;
                  t3.a47 = 790;
                  t3.a48 = 792;
                  t3.a49 = 695;
                  t3.a50 = 776;
                  t3.a51 = 768;
                  t3.a52 = 792;
                  t3.a53 = 759;
                  t3.a54 = 707;
                  t3.a55 = 708;
                  t3.a56 = 682;
                  t3.a57 = 701;
                  t3.a58 = 826;
                  t3.a59 = 815;
                  t3.a60 = 789;
                  t3.a61 = 789;
                  t3.a62 = 707;
                  t3.a63 = 687;
                  t3.a64 = 696;
                  t3.a65 = 689;
                  t3.a66 = 786;
                  t3.a67 = 787;
                  t3.a68 = 713;
                  t3.a69 = 791;
                  t3.a70 = 785;
                  t3.a71 = 791;
                  t3.a72 = 873;
                  t3.a73 = 761;
                  t3.a74 = 762;
                  t3.a203 = 762;
                  t3.a75 = 759;
                  t3.a204 = 759;
                  t3.a76 = 892;
                  t3.a77 = 892;
                  t3.a78 = 788;
                  t3.a79 = 784;
                  t3.a81 = 438;
                  t3.a82 = 138;
                  t3.a83 = 277;
                  t3.a84 = 415;
                  t3.a97 = 392;
                  t3.a98 = 392;
                  t3.a99 = 668;
                  t3.a100 = 668;
                  t3.a89 = 390;
                  t3.a90 = 390;
                  t3.a93 = 317;
                  t3.a94 = 317;
                  t3.a91 = 276;
                  t3.a92 = 276;
                  t3.a205 = 509;
                  t3.a85 = 509;
                  t3.a206 = 410;
                  t3.a86 = 410;
                  t3.a87 = 234;
                  t3.a88 = 234;
                  t3.a95 = 334;
                  t3.a96 = 334;
                  t3.a101 = 732;
                  t3.a102 = 544;
                  t3.a103 = 544;
                  t3.a104 = 910;
                  t3.a106 = 667;
                  t3.a107 = 760;
                  t3.a108 = 760;
                  t3.a112 = 776;
                  t3.a111 = 595;
                  t3.a110 = 694;
                  t3.a109 = 626;
                  t3.a120 = 788;
                  t3.a121 = 788;
                  t3.a122 = 788;
                  t3.a123 = 788;
                  t3.a124 = 788;
                  t3.a125 = 788;
                  t3.a126 = 788;
                  t3.a127 = 788;
                  t3.a128 = 788;
                  t3.a129 = 788;
                  t3.a130 = 788;
                  t3.a131 = 788;
                  t3.a132 = 788;
                  t3.a133 = 788;
                  t3.a134 = 788;
                  t3.a135 = 788;
                  t3.a136 = 788;
                  t3.a137 = 788;
                  t3.a138 = 788;
                  t3.a139 = 788;
                  t3.a140 = 788;
                  t3.a141 = 788;
                  t3.a142 = 788;
                  t3.a143 = 788;
                  t3.a144 = 788;
                  t3.a145 = 788;
                  t3.a146 = 788;
                  t3.a147 = 788;
                  t3.a148 = 788;
                  t3.a149 = 788;
                  t3.a150 = 788;
                  t3.a151 = 788;
                  t3.a152 = 788;
                  t3.a153 = 788;
                  t3.a154 = 788;
                  t3.a155 = 788;
                  t3.a156 = 788;
                  t3.a157 = 788;
                  t3.a158 = 788;
                  t3.a159 = 788;
                  t3.a160 = 894;
                  t3.a161 = 838;
                  t3.a163 = 1016;
                  t3.a164 = 458;
                  t3.a196 = 748;
                  t3.a165 = 924;
                  t3.a192 = 748;
                  t3.a166 = 918;
                  t3.a167 = 927;
                  t3.a168 = 928;
                  t3.a169 = 928;
                  t3.a170 = 834;
                  t3.a171 = 873;
                  t3.a172 = 828;
                  t3.a173 = 924;
                  t3.a162 = 924;
                  t3.a174 = 917;
                  t3.a175 = 930;
                  t3.a176 = 931;
                  t3.a177 = 463;
                  t3.a178 = 883;
                  t3.a179 = 836;
                  t3.a193 = 836;
                  t3.a180 = 867;
                  t3.a199 = 867;
                  t3.a181 = 696;
                  t3.a200 = 696;
                  t3.a182 = 874;
                  t3.a201 = 874;
                  t3.a183 = 760;
                  t3.a184 = 946;
                  t3.a197 = 771;
                  t3.a185 = 865;
                  t3.a194 = 771;
                  t3.a198 = 888;
                  t3.a186 = 967;
                  t3.a195 = 888;
                  t3.a187 = 831;
                  t3.a188 = 873;
                  t3.a189 = 927;
                  t3.a190 = 970;
                  t3.a191 = 918;
                });
              });
              exports3.getMetrics = getMetrics;
              const getFontBasicMetrics = (0, _core_utils.getLookupTableFactory)(function(t2) {
                t2.Courier = {
                  ascent: 629,
                  descent: -157,
                  capHeight: 562,
                  xHeight: -426
                };
                t2["Courier-Bold"] = {
                  ascent: 629,
                  descent: -157,
                  capHeight: 562,
                  xHeight: 439
                };
                t2["Courier-Oblique"] = {
                  ascent: 629,
                  descent: -157,
                  capHeight: 562,
                  xHeight: 426
                };
                t2["Courier-BoldOblique"] = {
                  ascent: 629,
                  descent: -157,
                  capHeight: 562,
                  xHeight: 426
                };
                t2.Helvetica = {
                  ascent: 718,
                  descent: -207,
                  capHeight: 718,
                  xHeight: 523
                };
                t2["Helvetica-Bold"] = {
                  ascent: 718,
                  descent: -207,
                  capHeight: 718,
                  xHeight: 532
                };
                t2["Helvetica-Oblique"] = {
                  ascent: 718,
                  descent: -207,
                  capHeight: 718,
                  xHeight: 523
                };
                t2["Helvetica-BoldOblique"] = {
                  ascent: 718,
                  descent: -207,
                  capHeight: 718,
                  xHeight: 532
                };
                t2["Times-Roman"] = {
                  ascent: 683,
                  descent: -217,
                  capHeight: 662,
                  xHeight: 450
                };
                t2["Times-Bold"] = {
                  ascent: 683,
                  descent: -217,
                  capHeight: 676,
                  xHeight: 461
                };
                t2["Times-Italic"] = {
                  ascent: 683,
                  descent: -217,
                  capHeight: 653,
                  xHeight: 441
                };
                t2["Times-BoldItalic"] = {
                  ascent: 683,
                  descent: -217,
                  capHeight: 669,
                  xHeight: 462
                };
                t2.Symbol = {
                  ascent: Math.NaN,
                  descent: Math.NaN,
                  capHeight: Math.NaN,
                  xHeight: Math.NaN
                };
                t2.ZapfDingbats = {
                  ascent: Math.NaN,
                  descent: Math.NaN,
                  capHeight: Math.NaN,
                  xHeight: Math.NaN
                };
              });
              exports3.getFontBasicMetrics = getFontBasicMetrics;
            }),
            /* 46 */
            /***/
            ((__unused_webpack_module2, exports3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.GlyfTable = void 0;
              const ON_CURVE_POINT = 1 << 0;
              const X_SHORT_VECTOR = 1 << 1;
              const Y_SHORT_VECTOR = 1 << 2;
              const REPEAT_FLAG = 1 << 3;
              const X_IS_SAME_OR_POSITIVE_X_SHORT_VECTOR = 1 << 4;
              const Y_IS_SAME_OR_POSITIVE_Y_SHORT_VECTOR = 1 << 5;
              const OVERLAP_SIMPLE = 1 << 6;
              const ARG_1_AND_2_ARE_WORDS = 1 << 0;
              const ARGS_ARE_XY_VALUES = 1 << 1;
              const WE_HAVE_A_SCALE = 1 << 3;
              const MORE_COMPONENTS = 1 << 5;
              const WE_HAVE_AN_X_AND_Y_SCALE = 1 << 6;
              const WE_HAVE_A_TWO_BY_TWO = 1 << 7;
              const WE_HAVE_INSTRUCTIONS = 1 << 8;
              class GlyfTable {
                constructor({
                  glyfTable,
                  isGlyphLocationsLong,
                  locaTable,
                  numGlyphs
                }) {
                  this.glyphs = [];
                  const loca = new DataView(locaTable.buffer, locaTable.byteOffset, locaTable.byteLength);
                  const glyf = new DataView(glyfTable.buffer, glyfTable.byteOffset, glyfTable.byteLength);
                  const offsetSize = isGlyphLocationsLong ? 4 : 2;
                  let prev2 = isGlyphLocationsLong ? loca.getUint32(0) : 2 * loca.getUint16(0);
                  let pos = 0;
                  for (let i = 0; i < numGlyphs; i++) {
                    pos += offsetSize;
                    const next2 = isGlyphLocationsLong ? loca.getUint32(pos) : 2 * loca.getUint16(pos);
                    if (next2 === prev2) {
                      this.glyphs.push(new Glyph({}));
                      continue;
                    }
                    const glyph = Glyph.parse(prev2, glyf);
                    this.glyphs.push(glyph);
                    prev2 = next2;
                  }
                }
                getSize() {
                  return this.glyphs.reduce((a, g) => {
                    const size = g.getSize();
                    return a + (size + 3 & ~3);
                  }, 0);
                }
                write() {
                  const totalSize = this.getSize();
                  const glyfTable = new DataView(new ArrayBuffer(totalSize));
                  const isLocationLong = totalSize > 131070;
                  const offsetSize = isLocationLong ? 4 : 2;
                  const locaTable = new DataView(new ArrayBuffer((this.glyphs.length + 1) * offsetSize));
                  if (isLocationLong) {
                    locaTable.setUint32(0, 0);
                  } else {
                    locaTable.setUint16(0, 0);
                  }
                  let pos = 0;
                  let locaIndex = 0;
                  for (const glyph of this.glyphs) {
                    pos += glyph.write(pos, glyfTable);
                    pos = pos + 3 & ~3;
                    locaIndex += offsetSize;
                    if (isLocationLong) {
                      locaTable.setUint32(locaIndex, pos);
                    } else {
                      locaTable.setUint16(locaIndex, pos >> 1);
                    }
                  }
                  return {
                    isLocationLong,
                    loca: new Uint8Array(locaTable.buffer),
                    glyf: new Uint8Array(glyfTable.buffer)
                  };
                }
                scale(factors) {
                  for (let i = 0, ii = this.glyphs.length; i < ii; i++) {
                    this.glyphs[i].scale(factors[i]);
                  }
                }
              }
              exports3.GlyfTable = GlyfTable;
              class Glyph {
                constructor({
                  header = null,
                  simple = null,
                  composites = null
                }) {
                  this.header = header;
                  this.simple = simple;
                  this.composites = composites;
                }
                static parse(pos, glyf) {
                  const [read, header] = GlyphHeader.parse(pos, glyf);
                  pos += read;
                  if (header.numberOfContours < 0) {
                    const composites = [];
                    while (true) {
                      const [n2, composite] = CompositeGlyph.parse(pos, glyf);
                      pos += n2;
                      composites.push(composite);
                      if (!(composite.flags & MORE_COMPONENTS)) {
                        break;
                      }
                    }
                    return new Glyph({
                      header,
                      composites
                    });
                  }
                  const simple = SimpleGlyph.parse(pos, glyf, header.numberOfContours);
                  return new Glyph({
                    header,
                    simple
                  });
                }
                getSize() {
                  if (!this.header) {
                    return 0;
                  }
                  const size = this.simple ? this.simple.getSize() : this.composites.reduce((a, c) => a + c.getSize(), 0);
                  return this.header.getSize() + size;
                }
                write(pos, buf) {
                  if (!this.header) {
                    return 0;
                  }
                  const spos = pos;
                  pos += this.header.write(pos, buf);
                  if (this.simple) {
                    pos += this.simple.write(pos, buf);
                  } else {
                    for (const composite of this.composites) {
                      pos += composite.write(pos, buf);
                    }
                  }
                  return pos - spos;
                }
                scale(factor) {
                  if (!this.header) {
                    return;
                  }
                  const xMiddle = (this.header.xMin + this.header.xMax) / 2;
                  this.header.scale(xMiddle, factor);
                  if (this.simple) {
                    this.simple.scale(xMiddle, factor);
                  } else {
                    for (const composite of this.composites) {
                      composite.scale(xMiddle, factor);
                    }
                  }
                }
              }
              class GlyphHeader {
                constructor({
                  numberOfContours,
                  xMin,
                  yMin,
                  xMax,
                  yMax
                }) {
                  this.numberOfContours = numberOfContours;
                  this.xMin = xMin;
                  this.yMin = yMin;
                  this.xMax = xMax;
                  this.yMax = yMax;
                }
                static parse(pos, glyf) {
                  return [10, new GlyphHeader({
                    numberOfContours: glyf.getInt16(pos),
                    xMin: glyf.getInt16(pos + 2),
                    yMin: glyf.getInt16(pos + 4),
                    xMax: glyf.getInt16(pos + 6),
                    yMax: glyf.getInt16(pos + 8)
                  })];
                }
                getSize() {
                  return 10;
                }
                write(pos, buf) {
                  buf.setInt16(pos, this.numberOfContours);
                  buf.setInt16(pos + 2, this.xMin);
                  buf.setInt16(pos + 4, this.yMin);
                  buf.setInt16(pos + 6, this.xMax);
                  buf.setInt16(pos + 8, this.yMax);
                  return 10;
                }
                scale(x, factor) {
                  this.xMin = Math.round(x + (this.xMin - x) * factor);
                  this.xMax = Math.round(x + (this.xMax - x) * factor);
                }
              }
              class Contour {
                constructor({
                  flags,
                  xCoordinates,
                  yCoordinates
                }) {
                  this.xCoordinates = xCoordinates;
                  this.yCoordinates = yCoordinates;
                  this.flags = flags;
                }
              }
              class SimpleGlyph {
                constructor({
                  contours,
                  instructions
                }) {
                  this.contours = contours;
                  this.instructions = instructions;
                }
                static parse(pos, glyf, numberOfContours) {
                  const endPtsOfContours = [];
                  for (let i = 0; i < numberOfContours; i++) {
                    const endPt = glyf.getUint16(pos);
                    pos += 2;
                    endPtsOfContours.push(endPt);
                  }
                  const numberOfPt = endPtsOfContours[numberOfContours - 1] + 1;
                  const instructionLength = glyf.getUint16(pos);
                  pos += 2;
                  const instructions = new Uint8Array(glyf).slice(pos, pos + instructionLength);
                  pos += instructionLength;
                  const flags = [];
                  for (let i = 0; i < numberOfPt; pos++, i++) {
                    let flag = glyf.getUint8(pos);
                    flags.push(flag);
                    if (flag & REPEAT_FLAG) {
                      const count = glyf.getUint8(++pos);
                      flag ^= REPEAT_FLAG;
                      for (let m = 0; m < count; m++) {
                        flags.push(flag);
                      }
                      i += count;
                    }
                  }
                  const allXCoordinates = [];
                  let xCoordinates = [];
                  let yCoordinates = [];
                  let pointFlags = [];
                  const contours = [];
                  let endPtsOfContoursIndex = 0;
                  let lastCoordinate = 0;
                  for (let i = 0; i < numberOfPt; i++) {
                    const flag = flags[i];
                    if (flag & X_SHORT_VECTOR) {
                      const x = glyf.getUint8(pos++);
                      lastCoordinate += flag & X_IS_SAME_OR_POSITIVE_X_SHORT_VECTOR ? x : -x;
                      xCoordinates.push(lastCoordinate);
                    } else if (flag & X_IS_SAME_OR_POSITIVE_X_SHORT_VECTOR) {
                      xCoordinates.push(lastCoordinate);
                    } else {
                      lastCoordinate += glyf.getInt16(pos);
                      pos += 2;
                      xCoordinates.push(lastCoordinate);
                    }
                    if (endPtsOfContours[endPtsOfContoursIndex] === i) {
                      endPtsOfContoursIndex++;
                      allXCoordinates.push(xCoordinates);
                      xCoordinates = [];
                    }
                  }
                  lastCoordinate = 0;
                  endPtsOfContoursIndex = 0;
                  for (let i = 0; i < numberOfPt; i++) {
                    const flag = flags[i];
                    if (flag & Y_SHORT_VECTOR) {
                      const y = glyf.getUint8(pos++);
                      lastCoordinate += flag & Y_IS_SAME_OR_POSITIVE_Y_SHORT_VECTOR ? y : -y;
                      yCoordinates.push(lastCoordinate);
                    } else if (flag & Y_IS_SAME_OR_POSITIVE_Y_SHORT_VECTOR) {
                      yCoordinates.push(lastCoordinate);
                    } else {
                      lastCoordinate += glyf.getInt16(pos);
                      pos += 2;
                      yCoordinates.push(lastCoordinate);
                    }
                    pointFlags.push(flag & ON_CURVE_POINT | flag & OVERLAP_SIMPLE);
                    if (endPtsOfContours[endPtsOfContoursIndex] === i) {
                      xCoordinates = allXCoordinates[endPtsOfContoursIndex];
                      endPtsOfContoursIndex++;
                      contours.push(new Contour({
                        flags: pointFlags,
                        xCoordinates,
                        yCoordinates
                      }));
                      yCoordinates = [];
                      pointFlags = [];
                    }
                  }
                  return new SimpleGlyph({
                    contours,
                    instructions
                  });
                }
                getSize() {
                  let size = this.contours.length * 2 + 2 + this.instructions.length;
                  let lastX = 0;
                  let lastY = 0;
                  for (const contour of this.contours) {
                    size += contour.flags.length;
                    for (let i = 0, ii = contour.xCoordinates.length; i < ii; i++) {
                      const x = contour.xCoordinates[i];
                      const y = contour.yCoordinates[i];
                      let abs3 = Math.abs(x - lastX);
                      if (abs3 > 255) {
                        size += 2;
                      } else if (abs3 > 0) {
                        size += 1;
                      }
                      lastX = x;
                      abs3 = Math.abs(y - lastY);
                      if (abs3 > 255) {
                        size += 2;
                      } else if (abs3 > 0) {
                        size += 1;
                      }
                      lastY = y;
                    }
                  }
                  return size;
                }
                write(pos, buf) {
                  const spos = pos;
                  const xCoordinates = [];
                  const yCoordinates = [];
                  const flags = [];
                  let lastX = 0;
                  let lastY = 0;
                  for (const contour of this.contours) {
                    for (let i = 0, ii = contour.xCoordinates.length; i < ii; i++) {
                      let flag = contour.flags[i];
                      const x = contour.xCoordinates[i];
                      let delta = x - lastX;
                      if (delta === 0) {
                        flag |= X_IS_SAME_OR_POSITIVE_X_SHORT_VECTOR;
                        xCoordinates.push(0);
                      } else {
                        const abs3 = Math.abs(delta);
                        if (abs3 <= 255) {
                          flag |= delta >= 0 ? X_SHORT_VECTOR | X_IS_SAME_OR_POSITIVE_X_SHORT_VECTOR : X_SHORT_VECTOR;
                          xCoordinates.push(abs3);
                        } else {
                          xCoordinates.push(delta);
                        }
                      }
                      lastX = x;
                      const y = contour.yCoordinates[i];
                      delta = y - lastY;
                      if (delta === 0) {
                        flag |= Y_IS_SAME_OR_POSITIVE_Y_SHORT_VECTOR;
                        yCoordinates.push(0);
                      } else {
                        const abs3 = Math.abs(delta);
                        if (abs3 <= 255) {
                          flag |= delta >= 0 ? Y_SHORT_VECTOR | Y_IS_SAME_OR_POSITIVE_Y_SHORT_VECTOR : Y_SHORT_VECTOR;
                          yCoordinates.push(abs3);
                        } else {
                          yCoordinates.push(delta);
                        }
                      }
                      lastY = y;
                      flags.push(flag);
                    }
                    buf.setUint16(pos, xCoordinates.length - 1);
                    pos += 2;
                  }
                  buf.setUint16(pos, this.instructions.length);
                  pos += 2;
                  if (this.instructions.length) {
                    new Uint8Array(buf.buffer, 0, buf.buffer.byteLength).set(this.instructions, pos);
                    pos += this.instructions.length;
                  }
                  for (const flag of flags) {
                    buf.setUint8(pos++, flag);
                  }
                  for (let i = 0, ii = xCoordinates.length; i < ii; i++) {
                    const x = xCoordinates[i];
                    const flag = flags[i];
                    if (flag & X_SHORT_VECTOR) {
                      buf.setUint8(pos++, x);
                    } else if (!(flag & X_IS_SAME_OR_POSITIVE_X_SHORT_VECTOR)) {
                      buf.setInt16(pos, x);
                      pos += 2;
                    }
                  }
                  for (let i = 0, ii = yCoordinates.length; i < ii; i++) {
                    const y = yCoordinates[i];
                    const flag = flags[i];
                    if (flag & Y_SHORT_VECTOR) {
                      buf.setUint8(pos++, y);
                    } else if (!(flag & Y_IS_SAME_OR_POSITIVE_Y_SHORT_VECTOR)) {
                      buf.setInt16(pos, y);
                      pos += 2;
                    }
                  }
                  return pos - spos;
                }
                scale(x, factor) {
                  for (const contour of this.contours) {
                    if (contour.xCoordinates.length === 0) {
                      continue;
                    }
                    for (let i = 0, ii = contour.xCoordinates.length; i < ii; i++) {
                      contour.xCoordinates[i] = Math.round(x + (contour.xCoordinates[i] - x) * factor);
                    }
                  }
                }
              }
              class CompositeGlyph {
                constructor({
                  flags,
                  glyphIndex,
                  argument1,
                  argument2,
                  transf,
                  instructions
                }) {
                  this.flags = flags;
                  this.glyphIndex = glyphIndex;
                  this.argument1 = argument1;
                  this.argument2 = argument2;
                  this.transf = transf;
                  this.instructions = instructions;
                }
                static parse(pos, glyf) {
                  const spos = pos;
                  const transf = [];
                  let flags = glyf.getUint16(pos);
                  const glyphIndex = glyf.getUint16(pos + 2);
                  pos += 4;
                  let argument1, argument2;
                  if (flags & ARG_1_AND_2_ARE_WORDS) {
                    if (flags & ARGS_ARE_XY_VALUES) {
                      argument1 = glyf.getInt16(pos);
                      argument2 = glyf.getInt16(pos + 2);
                    } else {
                      argument1 = glyf.getUint16(pos);
                      argument2 = glyf.getUint16(pos + 2);
                    }
                    pos += 4;
                    flags ^= ARG_1_AND_2_ARE_WORDS;
                  } else {
                    if (flags & ARGS_ARE_XY_VALUES) {
                      argument1 = glyf.getInt8(pos);
                      argument2 = glyf.getInt8(pos + 1);
                    } else {
                      argument1 = glyf.getUint8(pos);
                      argument2 = glyf.getUint8(pos + 1);
                    }
                    pos += 2;
                  }
                  if (flags & WE_HAVE_A_SCALE) {
                    transf.push(glyf.getUint16(pos));
                    pos += 2;
                  } else if (flags & WE_HAVE_AN_X_AND_Y_SCALE) {
                    transf.push(glyf.getUint16(pos), glyf.getUint16(pos + 2));
                    pos += 4;
                  } else if (flags & WE_HAVE_A_TWO_BY_TWO) {
                    transf.push(glyf.getUint16(pos), glyf.getUint16(pos + 2), glyf.getUint16(pos + 4), glyf.getUint16(pos + 6));
                    pos += 8;
                  }
                  let instructions = null;
                  if (flags & WE_HAVE_INSTRUCTIONS) {
                    const instructionLength = glyf.getUint16(pos);
                    pos += 2;
                    instructions = new Uint8Array(glyf).slice(pos, pos + instructionLength);
                    pos += instructionLength;
                  }
                  return [pos - spos, new CompositeGlyph({
                    flags,
                    glyphIndex,
                    argument1,
                    argument2,
                    transf,
                    instructions
                  })];
                }
                getSize() {
                  let size = 2 + 2 + this.transf.length * 2;
                  if (this.flags & WE_HAVE_INSTRUCTIONS) {
                    size += 2 + this.instructions.length;
                  }
                  size += 2;
                  if (this.flags & 2) {
                    if (!(this.argument1 >= -128 && this.argument1 <= 127 && this.argument2 >= -128 && this.argument2 <= 127)) {
                      size += 2;
                    }
                  } else if (!(this.argument1 >= 0 && this.argument1 <= 255 && this.argument2 >= 0 && this.argument2 <= 255)) {
                    size += 2;
                  }
                  return size;
                }
                write(pos, buf) {
                  const spos = pos;
                  if (this.flags & ARGS_ARE_XY_VALUES) {
                    if (!(this.argument1 >= -128 && this.argument1 <= 127 && this.argument2 >= -128 && this.argument2 <= 127)) {
                      this.flags |= ARG_1_AND_2_ARE_WORDS;
                    }
                  } else if (!(this.argument1 >= 0 && this.argument1 <= 255 && this.argument2 >= 0 && this.argument2 <= 255)) {
                    this.flags |= ARG_1_AND_2_ARE_WORDS;
                  }
                  buf.setUint16(pos, this.flags);
                  buf.setUint16(pos + 2, this.glyphIndex);
                  pos += 4;
                  if (this.flags & ARG_1_AND_2_ARE_WORDS) {
                    if (this.flags & ARGS_ARE_XY_VALUES) {
                      buf.setInt16(pos, this.argument1);
                      buf.setInt16(pos + 2, this.argument2);
                    } else {
                      buf.setUint16(pos, this.argument1);
                      buf.setUint16(pos + 2, this.argument2);
                    }
                    pos += 4;
                  } else {
                    buf.setUint8(pos, this.argument1);
                    buf.setUint8(pos + 1, this.argument2);
                    pos += 2;
                  }
                  if (this.flags & WE_HAVE_INSTRUCTIONS) {
                    buf.setUint16(pos, this.instructions.length);
                    pos += 2;
                    if (this.instructions.length) {
                      new Uint8Array(buf.buffer, 0, buf.buffer.byteLength).set(this.instructions, pos);
                      pos += this.instructions.length;
                    }
                  }
                  return pos - spos;
                }
                scale(x, factor) {
                }
              }
            }),
            /* 47 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.OpenTypeFileBuilder = void 0;
              var _core_utils = __w_pdfjs_require__3(3);
              var _util2 = __w_pdfjs_require__3(2);
              function writeInt16(dest, offset4, num) {
                dest[offset4] = num >> 8 & 255;
                dest[offset4 + 1] = num & 255;
              }
              function writeInt32(dest, offset4, num) {
                dest[offset4] = num >> 24 & 255;
                dest[offset4 + 1] = num >> 16 & 255;
                dest[offset4 + 2] = num >> 8 & 255;
                dest[offset4 + 3] = num & 255;
              }
              function writeData(dest, offset4, data2) {
                if (data2 instanceof Uint8Array) {
                  dest.set(data2, offset4);
                } else if (typeof data2 === "string") {
                  for (let i = 0, ii = data2.length; i < ii; i++) {
                    dest[offset4++] = data2.charCodeAt(i) & 255;
                  }
                } else {
                  for (const num of data2) {
                    dest[offset4++] = num & 255;
                  }
                }
              }
              const OTF_HEADER_SIZE = 12;
              const OTF_TABLE_ENTRY_SIZE = 16;
              class OpenTypeFileBuilder {
                constructor(sfnt) {
                  this.sfnt = sfnt;
                  this.tables = /* @__PURE__ */ Object.create(null);
                }
                static getSearchParams(entriesCount, entrySize) {
                  let maxPower2 = 1, log2 = 0;
                  while ((maxPower2 ^ entriesCount) > maxPower2) {
                    maxPower2 <<= 1;
                    log2++;
                  }
                  const searchRange = maxPower2 * entrySize;
                  return {
                    range: searchRange,
                    entry: log2,
                    rangeShift: entrySize * entriesCount - searchRange
                  };
                }
                toArray() {
                  let sfnt = this.sfnt;
                  const tables = this.tables;
                  const tablesNames = Object.keys(tables);
                  tablesNames.sort();
                  const numTables = tablesNames.length;
                  let i, j, jj, table, tableName;
                  let offset4 = OTF_HEADER_SIZE + numTables * OTF_TABLE_ENTRY_SIZE;
                  const tableOffsets = [offset4];
                  for (i = 0; i < numTables; i++) {
                    table = tables[tablesNames[i]];
                    const paddedLength = (table.length + 3 & ~3) >>> 0;
                    offset4 += paddedLength;
                    tableOffsets.push(offset4);
                  }
                  const file = new Uint8Array(offset4);
                  for (i = 0; i < numTables; i++) {
                    table = tables[tablesNames[i]];
                    writeData(file, tableOffsets[i], table);
                  }
                  if (sfnt === "true") {
                    sfnt = (0, _util2.string32)(65536);
                  }
                  file[0] = sfnt.charCodeAt(0) & 255;
                  file[1] = sfnt.charCodeAt(1) & 255;
                  file[2] = sfnt.charCodeAt(2) & 255;
                  file[3] = sfnt.charCodeAt(3) & 255;
                  writeInt16(file, 4, numTables);
                  const searchParams = OpenTypeFileBuilder.getSearchParams(numTables, 16);
                  writeInt16(file, 6, searchParams.range);
                  writeInt16(file, 8, searchParams.entry);
                  writeInt16(file, 10, searchParams.rangeShift);
                  offset4 = OTF_HEADER_SIZE;
                  for (i = 0; i < numTables; i++) {
                    tableName = tablesNames[i];
                    file[offset4] = tableName.charCodeAt(0) & 255;
                    file[offset4 + 1] = tableName.charCodeAt(1) & 255;
                    file[offset4 + 2] = tableName.charCodeAt(2) & 255;
                    file[offset4 + 3] = tableName.charCodeAt(3) & 255;
                    let checksum = 0;
                    for (j = tableOffsets[i], jj = tableOffsets[i + 1]; j < jj; j += 4) {
                      const quad = (0, _core_utils.readUint32)(file, j);
                      checksum = checksum + quad >>> 0;
                    }
                    writeInt32(file, offset4 + 4, checksum);
                    writeInt32(file, offset4 + 8, tableOffsets[i]);
                    writeInt32(file, offset4 + 12, tables[tableName].length);
                    offset4 += OTF_TABLE_ENTRY_SIZE;
                  }
                  return file;
                }
                addTable(tag, data2) {
                  if (tag in this.tables) {
                    throw new Error("Table " + tag + " already exists");
                  }
                  this.tables[tag] = data2;
                }
              }
              exports3.OpenTypeFileBuilder = OpenTypeFileBuilder;
            }),
            /* 48 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.Type1Font = void 0;
              var _cff_parser = __w_pdfjs_require__3(35);
              var _util2 = __w_pdfjs_require__3(2);
              var _fonts_utils = __w_pdfjs_require__3(38);
              var _core_utils = __w_pdfjs_require__3(3);
              var _stream = __w_pdfjs_require__3(8);
              var _type1_parser = __w_pdfjs_require__3(49);
              function findBlock(streamBytes, signature, startIndex) {
                const streamBytesLength = streamBytes.length;
                const signatureLength = signature.length;
                const scanLength = streamBytesLength - signatureLength;
                let i = startIndex, found = false;
                while (i < scanLength) {
                  let j = 0;
                  while (j < signatureLength && streamBytes[i + j] === signature[j]) {
                    j++;
                  }
                  if (j >= signatureLength) {
                    i += j;
                    while (i < streamBytesLength && (0, _core_utils.isWhiteSpace)(streamBytes[i])) {
                      i++;
                    }
                    found = true;
                    break;
                  }
                  i++;
                }
                return {
                  found,
                  length: i
                };
              }
              function getHeaderBlock(stream, suggestedLength) {
                const EEXEC_SIGNATURE = [101, 101, 120, 101, 99];
                const streamStartPos = stream.pos;
                let headerBytes, headerBytesLength, block;
                try {
                  headerBytes = stream.getBytes(suggestedLength);
                  headerBytesLength = headerBytes.length;
                } catch {
                }
                if (headerBytesLength === suggestedLength) {
                  block = findBlock(headerBytes, EEXEC_SIGNATURE, suggestedLength - 2 * EEXEC_SIGNATURE.length);
                  if (block.found && block.length === suggestedLength) {
                    return {
                      stream: new _stream.Stream(headerBytes),
                      length: suggestedLength
                    };
                  }
                }
                (0, _util2.warn)('Invalid "Length1" property in Type1 font -- trying to recover.');
                stream.pos = streamStartPos;
                const SCAN_BLOCK_LENGTH = 2048;
                let actualLength;
                while (true) {
                  const scanBytes = stream.peekBytes(SCAN_BLOCK_LENGTH);
                  block = findBlock(scanBytes, EEXEC_SIGNATURE, 0);
                  if (block.length === 0) {
                    break;
                  }
                  stream.pos += block.length;
                  if (block.found) {
                    actualLength = stream.pos - streamStartPos;
                    break;
                  }
                }
                stream.pos = streamStartPos;
                if (actualLength) {
                  return {
                    stream: new _stream.Stream(stream.getBytes(actualLength)),
                    length: actualLength
                  };
                }
                (0, _util2.warn)('Unable to recover "Length1" property in Type1 font -- using as is.');
                return {
                  stream: new _stream.Stream(stream.getBytes(suggestedLength)),
                  length: suggestedLength
                };
              }
              function getEexecBlock(stream, suggestedLength) {
                const eexecBytes = stream.getBytes();
                if (eexecBytes.length === 0) {
                  throw new _util2.FormatError("getEexecBlock - no font program found.");
                }
                return {
                  stream: new _stream.Stream(eexecBytes),
                  length: eexecBytes.length
                };
              }
              class Type1Font {
                constructor(name, file, properties2) {
                  const PFB_HEADER_SIZE = 6;
                  let headerBlockLength = properties2.length1;
                  let eexecBlockLength = properties2.length2;
                  let pfbHeader = file.peekBytes(PFB_HEADER_SIZE);
                  const pfbHeaderPresent = pfbHeader[0] === 128 && pfbHeader[1] === 1;
                  if (pfbHeaderPresent) {
                    file.skip(PFB_HEADER_SIZE);
                    headerBlockLength = pfbHeader[5] << 24 | pfbHeader[4] << 16 | pfbHeader[3] << 8 | pfbHeader[2];
                  }
                  const headerBlock = getHeaderBlock(file, headerBlockLength);
                  const headerBlockParser = new _type1_parser.Type1Parser(headerBlock.stream, false, _fonts_utils.SEAC_ANALYSIS_ENABLED);
                  headerBlockParser.extractFontHeader(properties2);
                  if (pfbHeaderPresent) {
                    pfbHeader = file.getBytes(PFB_HEADER_SIZE);
                    eexecBlockLength = pfbHeader[5] << 24 | pfbHeader[4] << 16 | pfbHeader[3] << 8 | pfbHeader[2];
                  }
                  const eexecBlock = getEexecBlock(file, eexecBlockLength);
                  const eexecBlockParser = new _type1_parser.Type1Parser(eexecBlock.stream, true, _fonts_utils.SEAC_ANALYSIS_ENABLED);
                  const data2 = eexecBlockParser.extractFontProgram(properties2);
                  for (const key2 in data2.properties) {
                    properties2[key2] = data2.properties[key2];
                  }
                  const charstrings = data2.charstrings;
                  const type2Charstrings = this.getType2Charstrings(charstrings);
                  const subrs = this.getType2Subrs(data2.subrs);
                  this.charstrings = charstrings;
                  this.data = this.wrap(name, type2Charstrings, this.charstrings, subrs, properties2);
                  this.seacs = this.getSeacs(data2.charstrings);
                }
                get numGlyphs() {
                  return this.charstrings.length + 1;
                }
                getCharset() {
                  const charset = [".notdef"];
                  for (const {
                    glyphName
                  } of this.charstrings) {
                    charset.push(glyphName);
                  }
                  return charset;
                }
                getGlyphMapping(properties2) {
                  const charstrings = this.charstrings;
                  if (properties2.composite) {
                    const charCodeToGlyphId = /* @__PURE__ */ Object.create(null);
                    for (let glyphId2 = 0, charstringsLen = charstrings.length; glyphId2 < charstringsLen; glyphId2++) {
                      const charCode = properties2.cMap.charCodeOf(glyphId2);
                      charCodeToGlyphId[charCode] = glyphId2 + 1;
                    }
                    return charCodeToGlyphId;
                  }
                  const glyphNames = [".notdef"];
                  let builtInEncoding, glyphId;
                  for (glyphId = 0; glyphId < charstrings.length; glyphId++) {
                    glyphNames.push(charstrings[glyphId].glyphName);
                  }
                  const encoding = properties2.builtInEncoding;
                  if (encoding) {
                    builtInEncoding = /* @__PURE__ */ Object.create(null);
                    for (const charCode in encoding) {
                      glyphId = glyphNames.indexOf(encoding[charCode]);
                      if (glyphId >= 0) {
                        builtInEncoding[charCode] = glyphId;
                      }
                    }
                  }
                  return (0, _fonts_utils.type1FontGlyphMapping)(properties2, builtInEncoding, glyphNames);
                }
                hasGlyphId(id) {
                  if (id < 0 || id >= this.numGlyphs) {
                    return false;
                  }
                  if (id === 0) {
                    return true;
                  }
                  const glyph = this.charstrings[id - 1];
                  return glyph.charstring.length > 0;
                }
                getSeacs(charstrings) {
                  const seacMap = [];
                  for (let i = 0, ii = charstrings.length; i < ii; i++) {
                    const charstring = charstrings[i];
                    if (charstring.seac) {
                      seacMap[i + 1] = charstring.seac;
                    }
                  }
                  return seacMap;
                }
                getType2Charstrings(type1Charstrings) {
                  const type2Charstrings = [];
                  for (const type1Charstring of type1Charstrings) {
                    type2Charstrings.push(type1Charstring.charstring);
                  }
                  return type2Charstrings;
                }
                getType2Subrs(type1Subrs) {
                  let bias = 0;
                  const count = type1Subrs.length;
                  if (count < 1133) {
                    bias = 107;
                  } else if (count < 33769) {
                    bias = 1131;
                  } else {
                    bias = 32768;
                  }
                  const type2Subrs = [];
                  let i;
                  for (i = 0; i < bias; i++) {
                    type2Subrs.push([11]);
                  }
                  for (i = 0; i < count; i++) {
                    type2Subrs.push(type1Subrs[i]);
                  }
                  return type2Subrs;
                }
                wrap(name, glyphs, charstrings, subrs, properties2) {
                  const cff = new _cff_parser.CFF();
                  cff.header = new _cff_parser.CFFHeader(1, 0, 4, 4);
                  cff.names = [name];
                  const topDict = new _cff_parser.CFFTopDict();
                  topDict.setByName("version", 391);
                  topDict.setByName("Notice", 392);
                  topDict.setByName("FullName", 393);
                  topDict.setByName("FamilyName", 394);
                  topDict.setByName("Weight", 395);
                  topDict.setByName("Encoding", null);
                  topDict.setByName("FontMatrix", properties2.fontMatrix);
                  topDict.setByName("FontBBox", properties2.bbox);
                  topDict.setByName("charset", null);
                  topDict.setByName("CharStrings", null);
                  topDict.setByName("Private", null);
                  cff.topDict = topDict;
                  const strings = new _cff_parser.CFFStrings();
                  strings.add("Version 0.11");
                  strings.add("See original notice");
                  strings.add(name);
                  strings.add(name);
                  strings.add("Medium");
                  cff.strings = strings;
                  cff.globalSubrIndex = new _cff_parser.CFFIndex();
                  const count = glyphs.length;
                  const charsetArray = [".notdef"];
                  let i, ii;
                  for (i = 0; i < count; i++) {
                    const glyphName = charstrings[i].glyphName;
                    const index3 = _cff_parser.CFFStandardStrings.indexOf(glyphName);
                    if (index3 === -1) {
                      strings.add(glyphName);
                    }
                    charsetArray.push(glyphName);
                  }
                  cff.charset = new _cff_parser.CFFCharset(false, 0, charsetArray);
                  const charStringsIndex = new _cff_parser.CFFIndex();
                  charStringsIndex.add([139, 14]);
                  for (i = 0; i < count; i++) {
                    charStringsIndex.add(glyphs[i]);
                  }
                  cff.charStrings = charStringsIndex;
                  const privateDict = new _cff_parser.CFFPrivateDict();
                  privateDict.setByName("Subrs", null);
                  const fields = ["BlueValues", "OtherBlues", "FamilyBlues", "FamilyOtherBlues", "StemSnapH", "StemSnapV", "BlueShift", "BlueFuzz", "BlueScale", "LanguageGroup", "ExpansionFactor", "ForceBold", "StdHW", "StdVW"];
                  for (i = 0, ii = fields.length; i < ii; i++) {
                    const field = fields[i];
                    if (!(field in properties2.privateData)) {
                      continue;
                    }
                    const value = properties2.privateData[field];
                    if (Array.isArray(value)) {
                      for (let j = value.length - 1; j > 0; j--) {
                        value[j] -= value[j - 1];
                      }
                    }
                    privateDict.setByName(field, value);
                  }
                  cff.topDict.privateDict = privateDict;
                  const subrIndex = new _cff_parser.CFFIndex();
                  for (i = 0, ii = subrs.length; i < ii; i++) {
                    subrIndex.add(subrs[i]);
                  }
                  privateDict.subrsIndex = subrIndex;
                  const compiler = new _cff_parser.CFFCompiler(cff);
                  return compiler.compile();
                }
              }
              exports3.Type1Font = Type1Font;
            }),
            /* 49 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.Type1Parser = void 0;
              var _encodings = __w_pdfjs_require__3(37);
              var _core_utils = __w_pdfjs_require__3(3);
              var _stream = __w_pdfjs_require__3(8);
              var _util2 = __w_pdfjs_require__3(2);
              const HINTING_ENABLED = false;
              const COMMAND_MAP = {
                hstem: [1],
                vstem: [3],
                vmoveto: [4],
                rlineto: [5],
                hlineto: [6],
                vlineto: [7],
                rrcurveto: [8],
                callsubr: [10],
                flex: [12, 35],
                drop: [12, 18],
                endchar: [14],
                rmoveto: [21],
                hmoveto: [22],
                vhcurveto: [30],
                hvcurveto: [31]
              };
              class Type1CharString {
                constructor() {
                  this.width = 0;
                  this.lsb = 0;
                  this.flexing = false;
                  this.output = [];
                  this.stack = [];
                }
                convert(encoded, subrs, seacAnalysisEnabled) {
                  const count = encoded.length;
                  let error2 = false;
                  let wx, sbx, subrNumber;
                  for (let i = 0; i < count; i++) {
                    let value = encoded[i];
                    if (value < 32) {
                      if (value === 12) {
                        value = (value << 8) + encoded[++i];
                      }
                      switch (value) {
                        case 1:
                          if (!HINTING_ENABLED) {
                            this.stack = [];
                            break;
                          }
                          error2 = this.executeCommand(2, COMMAND_MAP.hstem);
                          break;
                        case 3:
                          if (!HINTING_ENABLED) {
                            this.stack = [];
                            break;
                          }
                          error2 = this.executeCommand(2, COMMAND_MAP.vstem);
                          break;
                        case 4:
                          if (this.flexing) {
                            if (this.stack.length < 1) {
                              error2 = true;
                              break;
                            }
                            const dy = this.stack.pop();
                            this.stack.push(0, dy);
                            break;
                          }
                          error2 = this.executeCommand(1, COMMAND_MAP.vmoveto);
                          break;
                        case 5:
                          error2 = this.executeCommand(2, COMMAND_MAP.rlineto);
                          break;
                        case 6:
                          error2 = this.executeCommand(1, COMMAND_MAP.hlineto);
                          break;
                        case 7:
                          error2 = this.executeCommand(1, COMMAND_MAP.vlineto);
                          break;
                        case 8:
                          error2 = this.executeCommand(6, COMMAND_MAP.rrcurveto);
                          break;
                        case 9:
                          this.stack = [];
                          break;
                        case 10:
                          if (this.stack.length < 1) {
                            error2 = true;
                            break;
                          }
                          subrNumber = this.stack.pop();
                          if (!subrs[subrNumber]) {
                            error2 = true;
                            break;
                          }
                          error2 = this.convert(subrs[subrNumber], subrs, seacAnalysisEnabled);
                          break;
                        case 11:
                          return error2;
                        case 13:
                          if (this.stack.length < 2) {
                            error2 = true;
                            break;
                          }
                          wx = this.stack.pop();
                          sbx = this.stack.pop();
                          this.lsb = sbx;
                          this.width = wx;
                          this.stack.push(wx, sbx);
                          error2 = this.executeCommand(2, COMMAND_MAP.hmoveto);
                          break;
                        case 14:
                          this.output.push(COMMAND_MAP.endchar[0]);
                          break;
                        case 21:
                          if (this.flexing) {
                            break;
                          }
                          error2 = this.executeCommand(2, COMMAND_MAP.rmoveto);
                          break;
                        case 22:
                          if (this.flexing) {
                            this.stack.push(0);
                            break;
                          }
                          error2 = this.executeCommand(1, COMMAND_MAP.hmoveto);
                          break;
                        case 30:
                          error2 = this.executeCommand(4, COMMAND_MAP.vhcurveto);
                          break;
                        case 31:
                          error2 = this.executeCommand(4, COMMAND_MAP.hvcurveto);
                          break;
                        case (12 << 8) + 0:
                          this.stack = [];
                          break;
                        case (12 << 8) + 1:
                          if (!HINTING_ENABLED) {
                            this.stack = [];
                            break;
                          }
                          error2 = this.executeCommand(2, COMMAND_MAP.vstem);
                          break;
                        case (12 << 8) + 2:
                          if (!HINTING_ENABLED) {
                            this.stack = [];
                            break;
                          }
                          error2 = this.executeCommand(2, COMMAND_MAP.hstem);
                          break;
                        case (12 << 8) + 6:
                          if (seacAnalysisEnabled) {
                            const asb = this.stack.at(-5);
                            this.seac = this.stack.splice(-4, 4);
                            this.seac[0] += this.lsb - asb;
                            error2 = this.executeCommand(0, COMMAND_MAP.endchar);
                          } else {
                            error2 = this.executeCommand(4, COMMAND_MAP.endchar);
                          }
                          break;
                        case (12 << 8) + 7:
                          if (this.stack.length < 4) {
                            error2 = true;
                            break;
                          }
                          this.stack.pop();
                          wx = this.stack.pop();
                          const sby = this.stack.pop();
                          sbx = this.stack.pop();
                          this.lsb = sbx;
                          this.width = wx;
                          this.stack.push(wx, sbx, sby);
                          error2 = this.executeCommand(3, COMMAND_MAP.rmoveto);
                          break;
                        case (12 << 8) + 12:
                          if (this.stack.length < 2) {
                            error2 = true;
                            break;
                          }
                          const num2 = this.stack.pop();
                          const num1 = this.stack.pop();
                          this.stack.push(num1 / num2);
                          break;
                        case (12 << 8) + 16:
                          if (this.stack.length < 2) {
                            error2 = true;
                            break;
                          }
                          subrNumber = this.stack.pop();
                          const numArgs = this.stack.pop();
                          if (subrNumber === 0 && numArgs === 3) {
                            const flexArgs = this.stack.splice(-17, 17);
                            this.stack.push(flexArgs[2] + flexArgs[0], flexArgs[3] + flexArgs[1], flexArgs[4], flexArgs[5], flexArgs[6], flexArgs[7], flexArgs[8], flexArgs[9], flexArgs[10], flexArgs[11], flexArgs[12], flexArgs[13], flexArgs[14]);
                            error2 = this.executeCommand(13, COMMAND_MAP.flex, true);
                            this.flexing = false;
                            this.stack.push(flexArgs[15], flexArgs[16]);
                          } else if (subrNumber === 1 && numArgs === 0) {
                            this.flexing = true;
                          }
                          break;
                        case (12 << 8) + 17:
                          break;
                        case (12 << 8) + 33:
                          this.stack = [];
                          break;
                        default:
                          (0, _util2.warn)('Unknown type 1 charstring command of "' + value + '"');
                          break;
                      }
                      if (error2) {
                        break;
                      }
                      continue;
                    } else if (value <= 246) {
                      value -= 139;
                    } else if (value <= 250) {
                      value = (value - 247) * 256 + encoded[++i] + 108;
                    } else if (value <= 254) {
                      value = -((value - 251) * 256) - encoded[++i] - 108;
                    } else {
                      value = (encoded[++i] & 255) << 24 | (encoded[++i] & 255) << 16 | (encoded[++i] & 255) << 8 | (encoded[++i] & 255) << 0;
                    }
                    this.stack.push(value);
                  }
                  return error2;
                }
                executeCommand(howManyArgs, command, keepStack) {
                  const stackLength = this.stack.length;
                  if (howManyArgs > stackLength) {
                    return true;
                  }
                  const start = stackLength - howManyArgs;
                  for (let i = start; i < stackLength; i++) {
                    let value = this.stack[i];
                    if (Number.isInteger(value)) {
                      this.output.push(28, value >> 8 & 255, value & 255);
                    } else {
                      value = 65536 * value | 0;
                      this.output.push(255, value >> 24 & 255, value >> 16 & 255, value >> 8 & 255, value & 255);
                    }
                  }
                  this.output.push(...command);
                  if (keepStack) {
                    this.stack.splice(start, howManyArgs);
                  } else {
                    this.stack.length = 0;
                  }
                  return false;
                }
              }
              const EEXEC_ENCRYPT_KEY = 55665;
              const CHAR_STRS_ENCRYPT_KEY = 4330;
              function isHexDigit2(code2) {
                return code2 >= 48 && code2 <= 57 || code2 >= 65 && code2 <= 70 || code2 >= 97 && code2 <= 102;
              }
              function decrypt(data2, key2, discardNumber) {
                if (discardNumber >= data2.length) {
                  return new Uint8Array(0);
                }
                const c1 = 52845, c2 = 22719;
                let r2 = key2 | 0, i, j;
                for (i = 0; i < discardNumber; i++) {
                  r2 = (data2[i] + r2) * c1 + c2 & (1 << 16) - 1;
                }
                const count = data2.length - discardNumber;
                const decrypted = new Uint8Array(count);
                for (i = discardNumber, j = 0; j < count; i++, j++) {
                  const value = data2[i];
                  decrypted[j] = value ^ r2 >> 8;
                  r2 = (value + r2) * c1 + c2 & (1 << 16) - 1;
                }
                return decrypted;
              }
              function decryptAscii(data2, key2, discardNumber) {
                const c1 = 52845, c2 = 22719;
                let r2 = key2 | 0;
                const count = data2.length, maybeLength = count >>> 1;
                const decrypted = new Uint8Array(maybeLength);
                let i, j;
                for (i = 0, j = 0; i < count; i++) {
                  const digit1 = data2[i];
                  if (!isHexDigit2(digit1)) {
                    continue;
                  }
                  i++;
                  let digit2;
                  while (i < count && !isHexDigit2(digit2 = data2[i])) {
                    i++;
                  }
                  if (i < count) {
                    const value = parseInt(String.fromCharCode(digit1, digit2), 16);
                    decrypted[j++] = value ^ r2 >> 8;
                    r2 = (value + r2) * c1 + c2 & (1 << 16) - 1;
                  }
                }
                return decrypted.slice(discardNumber, j);
              }
              function isSpecial(c) {
                return c === 47 || c === 91 || c === 93 || c === 123 || c === 125 || c === 40 || c === 41;
              }
              class Type1Parser {
                constructor(stream, encrypted, seacAnalysisEnabled) {
                  if (encrypted) {
                    const data2 = stream.getBytes();
                    const isBinary = !((isHexDigit2(data2[0]) || (0, _core_utils.isWhiteSpace)(data2[0])) && isHexDigit2(data2[1]) && isHexDigit2(data2[2]) && isHexDigit2(data2[3]) && isHexDigit2(data2[4]) && isHexDigit2(data2[5]) && isHexDigit2(data2[6]) && isHexDigit2(data2[7]));
                    stream = new _stream.Stream(isBinary ? decrypt(data2, EEXEC_ENCRYPT_KEY, 4) : decryptAscii(data2, EEXEC_ENCRYPT_KEY, 4));
                  }
                  this.seacAnalysisEnabled = !!seacAnalysisEnabled;
                  this.stream = stream;
                  this.nextChar();
                }
                readNumberArray() {
                  this.getToken();
                  const array4 = [];
                  while (true) {
                    const token2 = this.getToken();
                    if (token2 === null || token2 === "]" || token2 === "}") {
                      break;
                    }
                    array4.push(parseFloat(token2 || 0));
                  }
                  return array4;
                }
                readNumber() {
                  const token2 = this.getToken();
                  return parseFloat(token2 || 0);
                }
                readInt() {
                  const token2 = this.getToken();
                  return parseInt(token2 || 0, 10) | 0;
                }
                readBoolean() {
                  const token2 = this.getToken();
                  return token2 === "true" ? 1 : 0;
                }
                nextChar() {
                  return this.currentChar = this.stream.getByte();
                }
                prevChar() {
                  this.stream.skip(-2);
                  return this.currentChar = this.stream.getByte();
                }
                getToken() {
                  let comment2 = false;
                  let ch = this.currentChar;
                  while (true) {
                    if (ch === -1) {
                      return null;
                    }
                    if (comment2) {
                      if (ch === 10 || ch === 13) {
                        comment2 = false;
                      }
                    } else if (ch === 37) {
                      comment2 = true;
                    } else if (!(0, _core_utils.isWhiteSpace)(ch)) {
                      break;
                    }
                    ch = this.nextChar();
                  }
                  if (isSpecial(ch)) {
                    this.nextChar();
                    return String.fromCharCode(ch);
                  }
                  let token2 = "";
                  do {
                    token2 += String.fromCharCode(ch);
                    ch = this.nextChar();
                  } while (ch >= 0 && !(0, _core_utils.isWhiteSpace)(ch) && !isSpecial(ch));
                  return token2;
                }
                readCharStrings(bytes, lenIV) {
                  if (lenIV === -1) {
                    return bytes;
                  }
                  return decrypt(bytes, CHAR_STRS_ENCRYPT_KEY, lenIV);
                }
                extractFontProgram(properties2) {
                  const stream = this.stream;
                  const subrs = [], charstrings = [];
                  const privateData = /* @__PURE__ */ Object.create(null);
                  privateData.lenIV = 4;
                  const program = {
                    subrs: [],
                    charstrings: [],
                    properties: {
                      privateData
                    }
                  };
                  let token2, length2, data2, lenIV;
                  while ((token2 = this.getToken()) !== null) {
                    if (token2 !== "/") {
                      continue;
                    }
                    token2 = this.getToken();
                    switch (token2) {
                      case "CharStrings":
                        this.getToken();
                        this.getToken();
                        this.getToken();
                        this.getToken();
                        while (true) {
                          token2 = this.getToken();
                          if (token2 === null || token2 === "end") {
                            break;
                          }
                          if (token2 !== "/") {
                            continue;
                          }
                          const glyph = this.getToken();
                          length2 = this.readInt();
                          this.getToken();
                          data2 = length2 > 0 ? stream.getBytes(length2) : new Uint8Array(0);
                          lenIV = program.properties.privateData.lenIV;
                          const encoded = this.readCharStrings(data2, lenIV);
                          this.nextChar();
                          token2 = this.getToken();
                          if (token2 === "noaccess") {
                            this.getToken();
                          } else if (token2 === "/") {
                            this.prevChar();
                          }
                          charstrings.push({
                            glyph,
                            encoded
                          });
                        }
                        break;
                      case "Subrs":
                        this.readInt();
                        this.getToken();
                        while (this.getToken() === "dup") {
                          const index3 = this.readInt();
                          length2 = this.readInt();
                          this.getToken();
                          data2 = length2 > 0 ? stream.getBytes(length2) : new Uint8Array(0);
                          lenIV = program.properties.privateData.lenIV;
                          const encoded = this.readCharStrings(data2, lenIV);
                          this.nextChar();
                          token2 = this.getToken();
                          if (token2 === "noaccess") {
                            this.getToken();
                          }
                          subrs[index3] = encoded;
                        }
                        break;
                      case "BlueValues":
                      case "OtherBlues":
                      case "FamilyBlues":
                      case "FamilyOtherBlues":
                        const blueArray = this.readNumberArray();
                        if (blueArray.length > 0 && blueArray.length % 2 === 0 && HINTING_ENABLED) {
                          program.properties.privateData[token2] = blueArray;
                        }
                        break;
                      case "StemSnapH":
                      case "StemSnapV":
                        program.properties.privateData[token2] = this.readNumberArray();
                        break;
                      case "StdHW":
                      case "StdVW":
                        program.properties.privateData[token2] = this.readNumberArray()[0];
                        break;
                      case "BlueShift":
                      case "lenIV":
                      case "BlueFuzz":
                      case "BlueScale":
                      case "LanguageGroup":
                        program.properties.privateData[token2] = this.readNumber();
                        break;
                      case "ExpansionFactor":
                        program.properties.privateData[token2] = this.readNumber() || 0.06;
                        break;
                      case "ForceBold":
                        program.properties.privateData[token2] = this.readBoolean();
                        break;
                    }
                  }
                  for (const {
                    encoded,
                    glyph
                  } of charstrings) {
                    const charString = new Type1CharString();
                    const error2 = charString.convert(encoded, subrs, this.seacAnalysisEnabled);
                    let output = charString.output;
                    if (error2) {
                      output = [14];
                    }
                    const charStringObject = {
                      glyphName: glyph,
                      charstring: output,
                      width: charString.width,
                      lsb: charString.lsb,
                      seac: charString.seac
                    };
                    if (glyph === ".notdef") {
                      program.charstrings.unshift(charStringObject);
                    } else {
                      program.charstrings.push(charStringObject);
                    }
                    if (properties2.builtInEncoding) {
                      const index3 = properties2.builtInEncoding.indexOf(glyph);
                      if (index3 > -1 && properties2.widths[index3] === void 0 && index3 >= properties2.firstChar && index3 <= properties2.lastChar) {
                        properties2.widths[index3] = charString.width;
                      }
                    }
                  }
                  return program;
                }
                extractFontHeader(properties2) {
                  let token2;
                  while ((token2 = this.getToken()) !== null) {
                    if (token2 !== "/") {
                      continue;
                    }
                    token2 = this.getToken();
                    switch (token2) {
                      case "FontMatrix":
                        const matrix = this.readNumberArray();
                        properties2.fontMatrix = matrix;
                        break;
                      case "Encoding":
                        const encodingArg = this.getToken();
                        let encoding;
                        if (!/^\d+$/.test(encodingArg)) {
                          encoding = (0, _encodings.getEncoding)(encodingArg);
                        } else {
                          encoding = [];
                          const size = parseInt(encodingArg, 10) | 0;
                          this.getToken();
                          for (let j = 0; j < size; j++) {
                            token2 = this.getToken();
                            while (token2 !== "dup" && token2 !== "def") {
                              token2 = this.getToken();
                              if (token2 === null) {
                                return;
                              }
                            }
                            if (token2 === "def") {
                              break;
                            }
                            const index3 = this.readInt();
                            this.getToken();
                            const glyph = this.getToken();
                            encoding[index3] = glyph;
                            this.getToken();
                          }
                        }
                        properties2.builtInEncoding = encoding;
                        break;
                      case "FontBBox":
                        const fontBBox = this.readNumberArray();
                        properties2.ascent = Math.max(fontBBox[3], fontBBox[1]);
                        properties2.descent = Math.min(fontBBox[1], fontBBox[3]);
                        properties2.ascentScaled = true;
                        break;
                    }
                  }
                }
              }
              exports3.Type1Parser = Type1Parser;
            }),
            /* 50 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.Pattern = void 0;
              exports3.clearPatternCaches = clearPatternCaches;
              exports3.getTilingPatternIR = getTilingPatternIR;
              var _util2 = __w_pdfjs_require__3(2);
              var _base_stream = __w_pdfjs_require__3(5);
              var _colorspace = __w_pdfjs_require__3(12);
              var _core_utils = __w_pdfjs_require__3(3);
              const ShadingType = {
                FUNCTION_BASED: 1,
                AXIAL: 2,
                RADIAL: 3,
                FREE_FORM_MESH: 4,
                LATTICE_FORM_MESH: 5,
                COONS_PATCH_MESH: 6,
                TENSOR_PATCH_MESH: 7
              };
              class Pattern {
                constructor() {
                  (0, _util2.unreachable)("Cannot initialize Pattern.");
                }
                static parseShading(shading, xref, res, pdfFunctionFactory, localColorSpaceCache) {
                  const dict = shading instanceof _base_stream.BaseStream ? shading.dict : shading;
                  const type5 = dict.get("ShadingType");
                  try {
                    switch (type5) {
                      case ShadingType.AXIAL:
                      case ShadingType.RADIAL:
                        return new RadialAxialShading(dict, xref, res, pdfFunctionFactory, localColorSpaceCache);
                      case ShadingType.FREE_FORM_MESH:
                      case ShadingType.LATTICE_FORM_MESH:
                      case ShadingType.COONS_PATCH_MESH:
                      case ShadingType.TENSOR_PATCH_MESH:
                        return new MeshShading(shading, xref, res, pdfFunctionFactory, localColorSpaceCache);
                      default:
                        throw new _util2.FormatError("Unsupported ShadingType: " + type5);
                    }
                  } catch (ex) {
                    if (ex instanceof _core_utils.MissingDataException) {
                      throw ex;
                    }
                    (0, _util2.warn)(ex);
                    return new DummyShading();
                  }
                }
              }
              exports3.Pattern = Pattern;
              class BaseShading {
                static SMALL_NUMBER = 1e-6;
                constructor() {
                  if (this.constructor === BaseShading) {
                    (0, _util2.unreachable)("Cannot initialize BaseShading.");
                  }
                }
                getIR() {
                  (0, _util2.unreachable)("Abstract method `getIR` called.");
                }
              }
              class RadialAxialShading extends BaseShading {
                constructor(dict, xref, resources, pdfFunctionFactory, localColorSpaceCache) {
                  super();
                  this.coordsArr = dict.getArray("Coords");
                  this.shadingType = dict.get("ShadingType");
                  const cs = _colorspace.ColorSpace.parse({
                    cs: dict.getRaw("CS") || dict.getRaw("ColorSpace"),
                    xref,
                    resources,
                    pdfFunctionFactory,
                    localColorSpaceCache
                  });
                  const bbox = dict.getArray("BBox");
                  this.bbox = Array.isArray(bbox) && bbox.length === 4 ? _util2.Util.normalizeRect(bbox) : null;
                  let t0 = 0, t1 = 1;
                  if (dict.has("Domain")) {
                    const domainArr = dict.getArray("Domain");
                    t0 = domainArr[0];
                    t1 = domainArr[1];
                  }
                  let extendStart = false, extendEnd = false;
                  if (dict.has("Extend")) {
                    const extendArr = dict.getArray("Extend");
                    extendStart = extendArr[0];
                    extendEnd = extendArr[1];
                  }
                  if (this.shadingType === ShadingType.RADIAL && (!extendStart || !extendEnd)) {
                    const [x1, y1, r1, x2, y2, r2] = this.coordsArr;
                    const distance = Math.hypot(x1 - x2, y1 - y2);
                    if (r1 <= r2 + distance && r2 <= r1 + distance) {
                      (0, _util2.warn)("Unsupported radial gradient.");
                    }
                  }
                  this.extendStart = extendStart;
                  this.extendEnd = extendEnd;
                  const fnObj = dict.getRaw("Function");
                  const fn = pdfFunctionFactory.createFromArray(fnObj);
                  const NUMBER_OF_SAMPLES = 840;
                  const step = (t1 - t0) / NUMBER_OF_SAMPLES;
                  const colorStops = this.colorStops = [];
                  if (t0 >= t1 || step <= 0) {
                    (0, _util2.info)("Bad shading domain.");
                    return;
                  }
                  const color = new Float32Array(cs.numComps), ratio = new Float32Array(1);
                  let rgbColor;
                  let iBase = 0;
                  ratio[0] = t0;
                  fn(ratio, 0, color, 0);
                  let rgbBase = cs.getRgb(color, 0);
                  const cssColorBase = _util2.Util.makeHexColor(rgbBase[0], rgbBase[1], rgbBase[2]);
                  colorStops.push([0, cssColorBase]);
                  let iPrev = 1;
                  ratio[0] = t0 + step;
                  fn(ratio, 0, color, 0);
                  let rgbPrev = cs.getRgb(color, 0);
                  let maxSlopeR = rgbPrev[0] - rgbBase[0] + 1;
                  let maxSlopeG = rgbPrev[1] - rgbBase[1] + 1;
                  let maxSlopeB = rgbPrev[2] - rgbBase[2] + 1;
                  let minSlopeR = rgbPrev[0] - rgbBase[0] - 1;
                  let minSlopeG = rgbPrev[1] - rgbBase[1] - 1;
                  let minSlopeB = rgbPrev[2] - rgbBase[2] - 1;
                  for (let i = 2; i < NUMBER_OF_SAMPLES; i++) {
                    ratio[0] = t0 + i * step;
                    fn(ratio, 0, color, 0);
                    rgbColor = cs.getRgb(color, 0);
                    const run = i - iBase;
                    maxSlopeR = Math.min(maxSlopeR, (rgbColor[0] - rgbBase[0] + 1) / run);
                    maxSlopeG = Math.min(maxSlopeG, (rgbColor[1] - rgbBase[1] + 1) / run);
                    maxSlopeB = Math.min(maxSlopeB, (rgbColor[2] - rgbBase[2] + 1) / run);
                    minSlopeR = Math.max(minSlopeR, (rgbColor[0] - rgbBase[0] - 1) / run);
                    minSlopeG = Math.max(minSlopeG, (rgbColor[1] - rgbBase[1] - 1) / run);
                    minSlopeB = Math.max(minSlopeB, (rgbColor[2] - rgbBase[2] - 1) / run);
                    const slopesExist = minSlopeR <= maxSlopeR && minSlopeG <= maxSlopeG && minSlopeB <= maxSlopeB;
                    if (!slopesExist) {
                      const cssColor2 = _util2.Util.makeHexColor(rgbPrev[0], rgbPrev[1], rgbPrev[2]);
                      colorStops.push([iPrev / NUMBER_OF_SAMPLES, cssColor2]);
                      maxSlopeR = rgbColor[0] - rgbPrev[0] + 1;
                      maxSlopeG = rgbColor[1] - rgbPrev[1] + 1;
                      maxSlopeB = rgbColor[2] - rgbPrev[2] + 1;
                      minSlopeR = rgbColor[0] - rgbPrev[0] - 1;
                      minSlopeG = rgbColor[1] - rgbPrev[1] - 1;
                      minSlopeB = rgbColor[2] - rgbPrev[2] - 1;
                      iBase = iPrev;
                      rgbBase = rgbPrev;
                    }
                    iPrev = i;
                    rgbPrev = rgbColor;
                  }
                  const cssColor = _util2.Util.makeHexColor(rgbPrev[0], rgbPrev[1], rgbPrev[2]);
                  colorStops.push([1, cssColor]);
                  let background = "transparent";
                  if (dict.has("Background")) {
                    rgbColor = cs.getRgb(dict.get("Background"), 0);
                    background = _util2.Util.makeHexColor(rgbColor[0], rgbColor[1], rgbColor[2]);
                  }
                  if (!extendStart) {
                    colorStops.unshift([0, background]);
                    colorStops[1][0] += BaseShading.SMALL_NUMBER;
                  }
                  if (!extendEnd) {
                    colorStops.at(-1)[0] -= BaseShading.SMALL_NUMBER;
                    colorStops.push([1, background]);
                  }
                  this.colorStops = colorStops;
                }
                getIR() {
                  const coordsArr = this.coordsArr;
                  const shadingType = this.shadingType;
                  let type5, p0, p1, r0, r1;
                  if (shadingType === ShadingType.AXIAL) {
                    p0 = [coordsArr[0], coordsArr[1]];
                    p1 = [coordsArr[2], coordsArr[3]];
                    r0 = null;
                    r1 = null;
                    type5 = "axial";
                  } else if (shadingType === ShadingType.RADIAL) {
                    p0 = [coordsArr[0], coordsArr[1]];
                    p1 = [coordsArr[3], coordsArr[4]];
                    r0 = coordsArr[2];
                    r1 = coordsArr[5];
                    type5 = "radial";
                  } else {
                    (0, _util2.unreachable)(`getPattern type unknown: ${shadingType}`);
                  }
                  return ["RadialAxial", type5, this.bbox, this.colorStops, p0, p1, r0, r1];
                }
              }
              class MeshStreamReader {
                constructor(stream, context) {
                  this.stream = stream;
                  this.context = context;
                  this.buffer = 0;
                  this.bufferLength = 0;
                  const numComps = context.numComps;
                  this.tmpCompsBuf = new Float32Array(numComps);
                  const csNumComps = context.colorSpace.numComps;
                  this.tmpCsCompsBuf = context.colorFn ? new Float32Array(csNumComps) : this.tmpCompsBuf;
                }
                get hasData() {
                  if (this.stream.end) {
                    return this.stream.pos < this.stream.end;
                  }
                  if (this.bufferLength > 0) {
                    return true;
                  }
                  const nextByte = this.stream.getByte();
                  if (nextByte < 0) {
                    return false;
                  }
                  this.buffer = nextByte;
                  this.bufferLength = 8;
                  return true;
                }
                readBits(n2) {
                  let buffer = this.buffer;
                  let bufferLength = this.bufferLength;
                  if (n2 === 32) {
                    if (bufferLength === 0) {
                      return (this.stream.getByte() << 24 | this.stream.getByte() << 16 | this.stream.getByte() << 8 | this.stream.getByte()) >>> 0;
                    }
                    buffer = buffer << 24 | this.stream.getByte() << 16 | this.stream.getByte() << 8 | this.stream.getByte();
                    const nextByte = this.stream.getByte();
                    this.buffer = nextByte & (1 << bufferLength) - 1;
                    return (buffer << 8 - bufferLength | (nextByte & 255) >> bufferLength) >>> 0;
                  }
                  if (n2 === 8 && bufferLength === 0) {
                    return this.stream.getByte();
                  }
                  while (bufferLength < n2) {
                    buffer = buffer << 8 | this.stream.getByte();
                    bufferLength += 8;
                  }
                  bufferLength -= n2;
                  this.bufferLength = bufferLength;
                  this.buffer = buffer & (1 << bufferLength) - 1;
                  return buffer >> bufferLength;
                }
                align() {
                  this.buffer = 0;
                  this.bufferLength = 0;
                }
                readFlag() {
                  return this.readBits(this.context.bitsPerFlag);
                }
                readCoordinate() {
                  const bitsPerCoordinate = this.context.bitsPerCoordinate;
                  const xi = this.readBits(bitsPerCoordinate);
                  const yi = this.readBits(bitsPerCoordinate);
                  const decode = this.context.decode;
                  const scale = bitsPerCoordinate < 32 ? 1 / ((1 << bitsPerCoordinate) - 1) : 23283064365386963e-26;
                  return [xi * scale * (decode[1] - decode[0]) + decode[0], yi * scale * (decode[3] - decode[2]) + decode[2]];
                }
                readComponents() {
                  const numComps = this.context.numComps;
                  const bitsPerComponent = this.context.bitsPerComponent;
                  const scale = bitsPerComponent < 32 ? 1 / ((1 << bitsPerComponent) - 1) : 23283064365386963e-26;
                  const decode = this.context.decode;
                  const components = this.tmpCompsBuf;
                  for (let i = 0, j = 4; i < numComps; i++, j += 2) {
                    const ci = this.readBits(bitsPerComponent);
                    components[i] = ci * scale * (decode[j + 1] - decode[j]) + decode[j];
                  }
                  const color = this.tmpCsCompsBuf;
                  if (this.context.colorFn) {
                    this.context.colorFn(components, 0, color, 0);
                  }
                  return this.context.colorSpace.getRgb(color, 0);
                }
              }
              let bCache = /* @__PURE__ */ Object.create(null);
              function buildB(count) {
                const lut = [];
                for (let i = 0; i <= count; i++) {
                  const t2 = i / count, t_ = 1 - t2;
                  lut.push(new Float32Array([t_ ** 3, 3 * t2 * t_ ** 2, 3 * t2 ** 2 * t_, t2 ** 3]));
                }
                return lut;
              }
              function getB(count) {
                return bCache[count] ||= buildB(count);
              }
              function clearPatternCaches() {
                bCache = /* @__PURE__ */ Object.create(null);
              }
              class MeshShading extends BaseShading {
                static MIN_SPLIT_PATCH_CHUNKS_AMOUNT = 3;
                static MAX_SPLIT_PATCH_CHUNKS_AMOUNT = 20;
                static TRIANGLE_DENSITY = 20;
                constructor(stream, xref, resources, pdfFunctionFactory, localColorSpaceCache) {
                  super();
                  if (!(stream instanceof _base_stream.BaseStream)) {
                    throw new _util2.FormatError("Mesh data is not a stream");
                  }
                  const dict = stream.dict;
                  this.shadingType = dict.get("ShadingType");
                  const bbox = dict.getArray("BBox");
                  this.bbox = Array.isArray(bbox) && bbox.length === 4 ? _util2.Util.normalizeRect(bbox) : null;
                  const cs = _colorspace.ColorSpace.parse({
                    cs: dict.getRaw("CS") || dict.getRaw("ColorSpace"),
                    xref,
                    resources,
                    pdfFunctionFactory,
                    localColorSpaceCache
                  });
                  this.background = dict.has("Background") ? cs.getRgb(dict.get("Background"), 0) : null;
                  const fnObj = dict.getRaw("Function");
                  const fn = fnObj ? pdfFunctionFactory.createFromArray(fnObj) : null;
                  this.coords = [];
                  this.colors = [];
                  this.figures = [];
                  const decodeContext = {
                    bitsPerCoordinate: dict.get("BitsPerCoordinate"),
                    bitsPerComponent: dict.get("BitsPerComponent"),
                    bitsPerFlag: dict.get("BitsPerFlag"),
                    decode: dict.getArray("Decode"),
                    colorFn: fn,
                    colorSpace: cs,
                    numComps: fn ? 1 : cs.numComps
                  };
                  const reader = new MeshStreamReader(stream, decodeContext);
                  let patchMesh = false;
                  switch (this.shadingType) {
                    case ShadingType.FREE_FORM_MESH:
                      this._decodeType4Shading(reader);
                      break;
                    case ShadingType.LATTICE_FORM_MESH:
                      const verticesPerRow = dict.get("VerticesPerRow") | 0;
                      if (verticesPerRow < 2) {
                        throw new _util2.FormatError("Invalid VerticesPerRow");
                      }
                      this._decodeType5Shading(reader, verticesPerRow);
                      break;
                    case ShadingType.COONS_PATCH_MESH:
                      this._decodeType6Shading(reader);
                      patchMesh = true;
                      break;
                    case ShadingType.TENSOR_PATCH_MESH:
                      this._decodeType7Shading(reader);
                      patchMesh = true;
                      break;
                    default:
                      (0, _util2.unreachable)("Unsupported mesh type.");
                      break;
                  }
                  if (patchMesh) {
                    this._updateBounds();
                    for (let i = 0, ii = this.figures.length; i < ii; i++) {
                      this._buildFigureFromPatch(i);
                    }
                  }
                  this._updateBounds();
                  this._packData();
                }
                _decodeType4Shading(reader) {
                  const coords = this.coords;
                  const colors = this.colors;
                  const operators = [];
                  const ps = [];
                  let verticesLeft = 0;
                  while (reader.hasData) {
                    const f = reader.readFlag();
                    const coord = reader.readCoordinate();
                    const color = reader.readComponents();
                    if (verticesLeft === 0) {
                      if (!(0 <= f && f <= 2)) {
                        throw new _util2.FormatError("Unknown type4 flag");
                      }
                      switch (f) {
                        case 0:
                          verticesLeft = 3;
                          break;
                        case 1:
                          ps.push(ps.at(-2), ps.at(-1));
                          verticesLeft = 1;
                          break;
                        case 2:
                          ps.push(ps.at(-3), ps.at(-1));
                          verticesLeft = 1;
                          break;
                      }
                      operators.push(f);
                    }
                    ps.push(coords.length);
                    coords.push(coord);
                    colors.push(color);
                    verticesLeft--;
                    reader.align();
                  }
                  this.figures.push({
                    type: "triangles",
                    coords: new Int32Array(ps),
                    colors: new Int32Array(ps)
                  });
                }
                _decodeType5Shading(reader, verticesPerRow) {
                  const coords = this.coords;
                  const colors = this.colors;
                  const ps = [];
                  while (reader.hasData) {
                    const coord = reader.readCoordinate();
                    const color = reader.readComponents();
                    ps.push(coords.length);
                    coords.push(coord);
                    colors.push(color);
                  }
                  this.figures.push({
                    type: "lattice",
                    coords: new Int32Array(ps),
                    colors: new Int32Array(ps),
                    verticesPerRow
                  });
                }
                _decodeType6Shading(reader) {
                  const coords = this.coords;
                  const colors = this.colors;
                  const ps = new Int32Array(16);
                  const cs = new Int32Array(4);
                  while (reader.hasData) {
                    const f = reader.readFlag();
                    if (!(0 <= f && f <= 3)) {
                      throw new _util2.FormatError("Unknown type6 flag");
                    }
                    const pi = coords.length;
                    for (let i = 0, ii = f !== 0 ? 8 : 12; i < ii; i++) {
                      coords.push(reader.readCoordinate());
                    }
                    const ci = colors.length;
                    for (let i = 0, ii = f !== 0 ? 2 : 4; i < ii; i++) {
                      colors.push(reader.readComponents());
                    }
                    let tmp1, tmp2, tmp3, tmp4;
                    switch (f) {
                      case 0:
                        ps[12] = pi + 3;
                        ps[13] = pi + 4;
                        ps[14] = pi + 5;
                        ps[15] = pi + 6;
                        ps[8] = pi + 2;
                        ps[11] = pi + 7;
                        ps[4] = pi + 1;
                        ps[7] = pi + 8;
                        ps[0] = pi;
                        ps[1] = pi + 11;
                        ps[2] = pi + 10;
                        ps[3] = pi + 9;
                        cs[2] = ci + 1;
                        cs[3] = ci + 2;
                        cs[0] = ci;
                        cs[1] = ci + 3;
                        break;
                      case 1:
                        tmp1 = ps[12];
                        tmp2 = ps[13];
                        tmp3 = ps[14];
                        tmp4 = ps[15];
                        ps[12] = tmp4;
                        ps[13] = pi + 0;
                        ps[14] = pi + 1;
                        ps[15] = pi + 2;
                        ps[8] = tmp3;
                        ps[11] = pi + 3;
                        ps[4] = tmp2;
                        ps[7] = pi + 4;
                        ps[0] = tmp1;
                        ps[1] = pi + 7;
                        ps[2] = pi + 6;
                        ps[3] = pi + 5;
                        tmp1 = cs[2];
                        tmp2 = cs[3];
                        cs[2] = tmp2;
                        cs[3] = ci;
                        cs[0] = tmp1;
                        cs[1] = ci + 1;
                        break;
                      case 2:
                        tmp1 = ps[15];
                        tmp2 = ps[11];
                        ps[12] = ps[3];
                        ps[13] = pi + 0;
                        ps[14] = pi + 1;
                        ps[15] = pi + 2;
                        ps[8] = ps[7];
                        ps[11] = pi + 3;
                        ps[4] = tmp2;
                        ps[7] = pi + 4;
                        ps[0] = tmp1;
                        ps[1] = pi + 7;
                        ps[2] = pi + 6;
                        ps[3] = pi + 5;
                        tmp1 = cs[3];
                        cs[2] = cs[1];
                        cs[3] = ci;
                        cs[0] = tmp1;
                        cs[1] = ci + 1;
                        break;
                      case 3:
                        ps[12] = ps[0];
                        ps[13] = pi + 0;
                        ps[14] = pi + 1;
                        ps[15] = pi + 2;
                        ps[8] = ps[1];
                        ps[11] = pi + 3;
                        ps[4] = ps[2];
                        ps[7] = pi + 4;
                        ps[0] = ps[3];
                        ps[1] = pi + 7;
                        ps[2] = pi + 6;
                        ps[3] = pi + 5;
                        cs[2] = cs[0];
                        cs[3] = ci;
                        cs[0] = cs[1];
                        cs[1] = ci + 1;
                        break;
                    }
                    ps[5] = coords.length;
                    coords.push([(-4 * coords[ps[0]][0] - coords[ps[15]][0] + 6 * (coords[ps[4]][0] + coords[ps[1]][0]) - 2 * (coords[ps[12]][0] + coords[ps[3]][0]) + 3 * (coords[ps[13]][0] + coords[ps[7]][0])) / 9, (-4 * coords[ps[0]][1] - coords[ps[15]][1] + 6 * (coords[ps[4]][1] + coords[ps[1]][1]) - 2 * (coords[ps[12]][1] + coords[ps[3]][1]) + 3 * (coords[ps[13]][1] + coords[ps[7]][1])) / 9]);
                    ps[6] = coords.length;
                    coords.push([(-4 * coords[ps[3]][0] - coords[ps[12]][0] + 6 * (coords[ps[2]][0] + coords[ps[7]][0]) - 2 * (coords[ps[0]][0] + coords[ps[15]][0]) + 3 * (coords[ps[4]][0] + coords[ps[14]][0])) / 9, (-4 * coords[ps[3]][1] - coords[ps[12]][1] + 6 * (coords[ps[2]][1] + coords[ps[7]][1]) - 2 * (coords[ps[0]][1] + coords[ps[15]][1]) + 3 * (coords[ps[4]][1] + coords[ps[14]][1])) / 9]);
                    ps[9] = coords.length;
                    coords.push([(-4 * coords[ps[12]][0] - coords[ps[3]][0] + 6 * (coords[ps[8]][0] + coords[ps[13]][0]) - 2 * (coords[ps[0]][0] + coords[ps[15]][0]) + 3 * (coords[ps[11]][0] + coords[ps[1]][0])) / 9, (-4 * coords[ps[12]][1] - coords[ps[3]][1] + 6 * (coords[ps[8]][1] + coords[ps[13]][1]) - 2 * (coords[ps[0]][1] + coords[ps[15]][1]) + 3 * (coords[ps[11]][1] + coords[ps[1]][1])) / 9]);
                    ps[10] = coords.length;
                    coords.push([(-4 * coords[ps[15]][0] - coords[ps[0]][0] + 6 * (coords[ps[11]][0] + coords[ps[14]][0]) - 2 * (coords[ps[12]][0] + coords[ps[3]][0]) + 3 * (coords[ps[2]][0] + coords[ps[8]][0])) / 9, (-4 * coords[ps[15]][1] - coords[ps[0]][1] + 6 * (coords[ps[11]][1] + coords[ps[14]][1]) - 2 * (coords[ps[12]][1] + coords[ps[3]][1]) + 3 * (coords[ps[2]][1] + coords[ps[8]][1])) / 9]);
                    this.figures.push({
                      type: "patch",
                      coords: new Int32Array(ps),
                      colors: new Int32Array(cs)
                    });
                  }
                }
                _decodeType7Shading(reader) {
                  const coords = this.coords;
                  const colors = this.colors;
                  const ps = new Int32Array(16);
                  const cs = new Int32Array(4);
                  while (reader.hasData) {
                    const f = reader.readFlag();
                    if (!(0 <= f && f <= 3)) {
                      throw new _util2.FormatError("Unknown type7 flag");
                    }
                    const pi = coords.length;
                    for (let i = 0, ii = f !== 0 ? 12 : 16; i < ii; i++) {
                      coords.push(reader.readCoordinate());
                    }
                    const ci = colors.length;
                    for (let i = 0, ii = f !== 0 ? 2 : 4; i < ii; i++) {
                      colors.push(reader.readComponents());
                    }
                    let tmp1, tmp2, tmp3, tmp4;
                    switch (f) {
                      case 0:
                        ps[12] = pi + 3;
                        ps[13] = pi + 4;
                        ps[14] = pi + 5;
                        ps[15] = pi + 6;
                        ps[8] = pi + 2;
                        ps[9] = pi + 13;
                        ps[10] = pi + 14;
                        ps[11] = pi + 7;
                        ps[4] = pi + 1;
                        ps[5] = pi + 12;
                        ps[6] = pi + 15;
                        ps[7] = pi + 8;
                        ps[0] = pi;
                        ps[1] = pi + 11;
                        ps[2] = pi + 10;
                        ps[3] = pi + 9;
                        cs[2] = ci + 1;
                        cs[3] = ci + 2;
                        cs[0] = ci;
                        cs[1] = ci + 3;
                        break;
                      case 1:
                        tmp1 = ps[12];
                        tmp2 = ps[13];
                        tmp3 = ps[14];
                        tmp4 = ps[15];
                        ps[12] = tmp4;
                        ps[13] = pi + 0;
                        ps[14] = pi + 1;
                        ps[15] = pi + 2;
                        ps[8] = tmp3;
                        ps[9] = pi + 9;
                        ps[10] = pi + 10;
                        ps[11] = pi + 3;
                        ps[4] = tmp2;
                        ps[5] = pi + 8;
                        ps[6] = pi + 11;
                        ps[7] = pi + 4;
                        ps[0] = tmp1;
                        ps[1] = pi + 7;
                        ps[2] = pi + 6;
                        ps[3] = pi + 5;
                        tmp1 = cs[2];
                        tmp2 = cs[3];
                        cs[2] = tmp2;
                        cs[3] = ci;
                        cs[0] = tmp1;
                        cs[1] = ci + 1;
                        break;
                      case 2:
                        tmp1 = ps[15];
                        tmp2 = ps[11];
                        ps[12] = ps[3];
                        ps[13] = pi + 0;
                        ps[14] = pi + 1;
                        ps[15] = pi + 2;
                        ps[8] = ps[7];
                        ps[9] = pi + 9;
                        ps[10] = pi + 10;
                        ps[11] = pi + 3;
                        ps[4] = tmp2;
                        ps[5] = pi + 8;
                        ps[6] = pi + 11;
                        ps[7] = pi + 4;
                        ps[0] = tmp1;
                        ps[1] = pi + 7;
                        ps[2] = pi + 6;
                        ps[3] = pi + 5;
                        tmp1 = cs[3];
                        cs[2] = cs[1];
                        cs[3] = ci;
                        cs[0] = tmp1;
                        cs[1] = ci + 1;
                        break;
                      case 3:
                        ps[12] = ps[0];
                        ps[13] = pi + 0;
                        ps[14] = pi + 1;
                        ps[15] = pi + 2;
                        ps[8] = ps[1];
                        ps[9] = pi + 9;
                        ps[10] = pi + 10;
                        ps[11] = pi + 3;
                        ps[4] = ps[2];
                        ps[5] = pi + 8;
                        ps[6] = pi + 11;
                        ps[7] = pi + 4;
                        ps[0] = ps[3];
                        ps[1] = pi + 7;
                        ps[2] = pi + 6;
                        ps[3] = pi + 5;
                        cs[2] = cs[0];
                        cs[3] = ci;
                        cs[0] = cs[1];
                        cs[1] = ci + 1;
                        break;
                    }
                    this.figures.push({
                      type: "patch",
                      coords: new Int32Array(ps),
                      colors: new Int32Array(cs)
                    });
                  }
                }
                _buildFigureFromPatch(index3) {
                  const figure = this.figures[index3];
                  (0, _util2.assert)(figure.type === "patch", "Unexpected patch mesh figure");
                  const coords = this.coords, colors = this.colors;
                  const pi = figure.coords;
                  const ci = figure.colors;
                  const figureMinX = Math.min(coords[pi[0]][0], coords[pi[3]][0], coords[pi[12]][0], coords[pi[15]][0]);
                  const figureMinY = Math.min(coords[pi[0]][1], coords[pi[3]][1], coords[pi[12]][1], coords[pi[15]][1]);
                  const figureMaxX = Math.max(coords[pi[0]][0], coords[pi[3]][0], coords[pi[12]][0], coords[pi[15]][0]);
                  const figureMaxY = Math.max(coords[pi[0]][1], coords[pi[3]][1], coords[pi[12]][1], coords[pi[15]][1]);
                  let splitXBy = Math.ceil((figureMaxX - figureMinX) * MeshShading.TRIANGLE_DENSITY / (this.bounds[2] - this.bounds[0]));
                  splitXBy = Math.max(MeshShading.MIN_SPLIT_PATCH_CHUNKS_AMOUNT, Math.min(MeshShading.MAX_SPLIT_PATCH_CHUNKS_AMOUNT, splitXBy));
                  let splitYBy = Math.ceil((figureMaxY - figureMinY) * MeshShading.TRIANGLE_DENSITY / (this.bounds[3] - this.bounds[1]));
                  splitYBy = Math.max(MeshShading.MIN_SPLIT_PATCH_CHUNKS_AMOUNT, Math.min(MeshShading.MAX_SPLIT_PATCH_CHUNKS_AMOUNT, splitYBy));
                  const verticesPerRow = splitXBy + 1;
                  const figureCoords = new Int32Array((splitYBy + 1) * verticesPerRow);
                  const figureColors = new Int32Array((splitYBy + 1) * verticesPerRow);
                  let k = 0;
                  const cl = new Uint8Array(3), cr = new Uint8Array(3);
                  const c0 = colors[ci[0]], c1 = colors[ci[1]], c2 = colors[ci[2]], c3 = colors[ci[3]];
                  const bRow = getB(splitYBy), bCol = getB(splitXBy);
                  for (let row = 0; row <= splitYBy; row++) {
                    cl[0] = (c0[0] * (splitYBy - row) + c2[0] * row) / splitYBy | 0;
                    cl[1] = (c0[1] * (splitYBy - row) + c2[1] * row) / splitYBy | 0;
                    cl[2] = (c0[2] * (splitYBy - row) + c2[2] * row) / splitYBy | 0;
                    cr[0] = (c1[0] * (splitYBy - row) + c3[0] * row) / splitYBy | 0;
                    cr[1] = (c1[1] * (splitYBy - row) + c3[1] * row) / splitYBy | 0;
                    cr[2] = (c1[2] * (splitYBy - row) + c3[2] * row) / splitYBy | 0;
                    for (let col = 0; col <= splitXBy; col++, k++) {
                      if ((row === 0 || row === splitYBy) && (col === 0 || col === splitXBy)) {
                        continue;
                      }
                      let x = 0, y = 0;
                      let q = 0;
                      for (let i = 0; i <= 3; i++) {
                        for (let j = 0; j <= 3; j++, q++) {
                          const m = bRow[row][i] * bCol[col][j];
                          x += coords[pi[q]][0] * m;
                          y += coords[pi[q]][1] * m;
                        }
                      }
                      figureCoords[k] = coords.length;
                      coords.push([x, y]);
                      figureColors[k] = colors.length;
                      const newColor = new Uint8Array(3);
                      newColor[0] = (cl[0] * (splitXBy - col) + cr[0] * col) / splitXBy | 0;
                      newColor[1] = (cl[1] * (splitXBy - col) + cr[1] * col) / splitXBy | 0;
                      newColor[2] = (cl[2] * (splitXBy - col) + cr[2] * col) / splitXBy | 0;
                      colors.push(newColor);
                    }
                  }
                  figureCoords[0] = pi[0];
                  figureColors[0] = ci[0];
                  figureCoords[splitXBy] = pi[3];
                  figureColors[splitXBy] = ci[1];
                  figureCoords[verticesPerRow * splitYBy] = pi[12];
                  figureColors[verticesPerRow * splitYBy] = ci[2];
                  figureCoords[verticesPerRow * splitYBy + splitXBy] = pi[15];
                  figureColors[verticesPerRow * splitYBy + splitXBy] = ci[3];
                  this.figures[index3] = {
                    type: "lattice",
                    coords: figureCoords,
                    colors: figureColors,
                    verticesPerRow
                  };
                }
                _updateBounds() {
                  let minX = this.coords[0][0], minY = this.coords[0][1], maxX = minX, maxY = minY;
                  for (let i = 1, ii = this.coords.length; i < ii; i++) {
                    const x = this.coords[i][0], y = this.coords[i][1];
                    minX = minX > x ? x : minX;
                    minY = minY > y ? y : minY;
                    maxX = maxX < x ? x : maxX;
                    maxY = maxY < y ? y : maxY;
                  }
                  this.bounds = [minX, minY, maxX, maxY];
                }
                _packData() {
                  let i, ii, j, jj;
                  const coords = this.coords;
                  const coordsPacked = new Float32Array(coords.length * 2);
                  for (i = 0, j = 0, ii = coords.length; i < ii; i++) {
                    const xy = coords[i];
                    coordsPacked[j++] = xy[0];
                    coordsPacked[j++] = xy[1];
                  }
                  this.coords = coordsPacked;
                  const colors = this.colors;
                  const colorsPacked = new Uint8Array(colors.length * 3);
                  for (i = 0, j = 0, ii = colors.length; i < ii; i++) {
                    const c = colors[i];
                    colorsPacked[j++] = c[0];
                    colorsPacked[j++] = c[1];
                    colorsPacked[j++] = c[2];
                  }
                  this.colors = colorsPacked;
                  const figures = this.figures;
                  for (i = 0, ii = figures.length; i < ii; i++) {
                    const figure = figures[i], ps = figure.coords, cs = figure.colors;
                    for (j = 0, jj = ps.length; j < jj; j++) {
                      ps[j] *= 2;
                      cs[j] *= 3;
                    }
                  }
                }
                getIR() {
                  return ["Mesh", this.shadingType, this.coords, this.colors, this.figures, this.bounds, this.bbox, this.background];
                }
              }
              class DummyShading extends BaseShading {
                getIR() {
                  return ["Dummy"];
                }
              }
              function getTilingPatternIR(operatorList, dict, color) {
                const matrix = dict.getArray("Matrix");
                const bbox = _util2.Util.normalizeRect(dict.getArray("BBox"));
                const xstep = dict.get("XStep");
                const ystep = dict.get("YStep");
                const paintType = dict.get("PaintType");
                const tilingType = dict.get("TilingType");
                if (bbox[2] - bbox[0] === 0 || bbox[3] - bbox[1] === 0) {
                  throw new _util2.FormatError(`Invalid getTilingPatternIR /BBox array: [${bbox}].`);
                }
                return ["TilingPattern", color, operatorList, matrix, bbox, xstep, ystep, paintType, tilingType];
              }
            }),
            /* 51 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.getXfaFontDict = getXfaFontDict;
              exports3.getXfaFontName = getXfaFontName;
              var _calibri_factors = __w_pdfjs_require__3(52);
              var _primitives = __w_pdfjs_require__3(4);
              var _helvetica_factors = __w_pdfjs_require__3(53);
              var _liberationsans_widths = __w_pdfjs_require__3(54);
              var _myriadpro_factors = __w_pdfjs_require__3(55);
              var _segoeui_factors = __w_pdfjs_require__3(56);
              var _core_utils = __w_pdfjs_require__3(3);
              var _fonts_utils = __w_pdfjs_require__3(38);
              const getXFAFontMap = (0, _core_utils.getLookupTableFactory)(function(t2) {
                t2["MyriadPro-Regular"] = t2["PdfJS-Fallback-Regular"] = {
                  name: "LiberationSans-Regular",
                  factors: _myriadpro_factors.MyriadProRegularFactors,
                  baseWidths: _liberationsans_widths.LiberationSansRegularWidths,
                  baseMapping: _liberationsans_widths.LiberationSansRegularMapping,
                  metrics: _myriadpro_factors.MyriadProRegularMetrics
                };
                t2["MyriadPro-Bold"] = t2["PdfJS-Fallback-Bold"] = {
                  name: "LiberationSans-Bold",
                  factors: _myriadpro_factors.MyriadProBoldFactors,
                  baseWidths: _liberationsans_widths.LiberationSansBoldWidths,
                  baseMapping: _liberationsans_widths.LiberationSansBoldMapping,
                  metrics: _myriadpro_factors.MyriadProBoldMetrics
                };
                t2["MyriadPro-It"] = t2["MyriadPro-Italic"] = t2["PdfJS-Fallback-Italic"] = {
                  name: "LiberationSans-Italic",
                  factors: _myriadpro_factors.MyriadProItalicFactors,
                  baseWidths: _liberationsans_widths.LiberationSansItalicWidths,
                  baseMapping: _liberationsans_widths.LiberationSansItalicMapping,
                  metrics: _myriadpro_factors.MyriadProItalicMetrics
                };
                t2["MyriadPro-BoldIt"] = t2["MyriadPro-BoldItalic"] = t2["PdfJS-Fallback-BoldItalic"] = {
                  name: "LiberationSans-BoldItalic",
                  factors: _myriadpro_factors.MyriadProBoldItalicFactors,
                  baseWidths: _liberationsans_widths.LiberationSansBoldItalicWidths,
                  baseMapping: _liberationsans_widths.LiberationSansBoldItalicMapping,
                  metrics: _myriadpro_factors.MyriadProBoldItalicMetrics
                };
                t2.ArialMT = t2.Arial = t2["Arial-Regular"] = {
                  name: "LiberationSans-Regular",
                  baseWidths: _liberationsans_widths.LiberationSansRegularWidths,
                  baseMapping: _liberationsans_widths.LiberationSansRegularMapping
                };
                t2["Arial-BoldMT"] = t2["Arial-Bold"] = {
                  name: "LiberationSans-Bold",
                  baseWidths: _liberationsans_widths.LiberationSansBoldWidths,
                  baseMapping: _liberationsans_widths.LiberationSansBoldMapping
                };
                t2["Arial-ItalicMT"] = t2["Arial-Italic"] = {
                  name: "LiberationSans-Italic",
                  baseWidths: _liberationsans_widths.LiberationSansItalicWidths,
                  baseMapping: _liberationsans_widths.LiberationSansItalicMapping
                };
                t2["Arial-BoldItalicMT"] = t2["Arial-BoldItalic"] = {
                  name: "LiberationSans-BoldItalic",
                  baseWidths: _liberationsans_widths.LiberationSansBoldItalicWidths,
                  baseMapping: _liberationsans_widths.LiberationSansBoldItalicMapping
                };
                t2["Calibri-Regular"] = {
                  name: "LiberationSans-Regular",
                  factors: _calibri_factors.CalibriRegularFactors,
                  baseWidths: _liberationsans_widths.LiberationSansRegularWidths,
                  baseMapping: _liberationsans_widths.LiberationSansRegularMapping,
                  metrics: _calibri_factors.CalibriRegularMetrics
                };
                t2["Calibri-Bold"] = {
                  name: "LiberationSans-Bold",
                  factors: _calibri_factors.CalibriBoldFactors,
                  baseWidths: _liberationsans_widths.LiberationSansBoldWidths,
                  baseMapping: _liberationsans_widths.LiberationSansBoldMapping,
                  metrics: _calibri_factors.CalibriBoldMetrics
                };
                t2["Calibri-Italic"] = {
                  name: "LiberationSans-Italic",
                  factors: _calibri_factors.CalibriItalicFactors,
                  baseWidths: _liberationsans_widths.LiberationSansItalicWidths,
                  baseMapping: _liberationsans_widths.LiberationSansItalicMapping,
                  metrics: _calibri_factors.CalibriItalicMetrics
                };
                t2["Calibri-BoldItalic"] = {
                  name: "LiberationSans-BoldItalic",
                  factors: _calibri_factors.CalibriBoldItalicFactors,
                  baseWidths: _liberationsans_widths.LiberationSansBoldItalicWidths,
                  baseMapping: _liberationsans_widths.LiberationSansBoldItalicMapping,
                  metrics: _calibri_factors.CalibriBoldItalicMetrics
                };
                t2["Segoeui-Regular"] = {
                  name: "LiberationSans-Regular",
                  factors: _segoeui_factors.SegoeuiRegularFactors,
                  baseWidths: _liberationsans_widths.LiberationSansRegularWidths,
                  baseMapping: _liberationsans_widths.LiberationSansRegularMapping,
                  metrics: _segoeui_factors.SegoeuiRegularMetrics
                };
                t2["Segoeui-Bold"] = {
                  name: "LiberationSans-Bold",
                  factors: _segoeui_factors.SegoeuiBoldFactors,
                  baseWidths: _liberationsans_widths.LiberationSansBoldWidths,
                  baseMapping: _liberationsans_widths.LiberationSansBoldMapping,
                  metrics: _segoeui_factors.SegoeuiBoldMetrics
                };
                t2["Segoeui-Italic"] = {
                  name: "LiberationSans-Italic",
                  factors: _segoeui_factors.SegoeuiItalicFactors,
                  baseWidths: _liberationsans_widths.LiberationSansItalicWidths,
                  baseMapping: _liberationsans_widths.LiberationSansItalicMapping,
                  metrics: _segoeui_factors.SegoeuiItalicMetrics
                };
                t2["Segoeui-BoldItalic"] = {
                  name: "LiberationSans-BoldItalic",
                  factors: _segoeui_factors.SegoeuiBoldItalicFactors,
                  baseWidths: _liberationsans_widths.LiberationSansBoldItalicWidths,
                  baseMapping: _liberationsans_widths.LiberationSansBoldItalicMapping,
                  metrics: _segoeui_factors.SegoeuiBoldItalicMetrics
                };
                t2["Helvetica-Regular"] = t2.Helvetica = {
                  name: "LiberationSans-Regular",
                  factors: _helvetica_factors.HelveticaRegularFactors,
                  baseWidths: _liberationsans_widths.LiberationSansRegularWidths,
                  baseMapping: _liberationsans_widths.LiberationSansRegularMapping,
                  metrics: _helvetica_factors.HelveticaRegularMetrics
                };
                t2["Helvetica-Bold"] = {
                  name: "LiberationSans-Bold",
                  factors: _helvetica_factors.HelveticaBoldFactors,
                  baseWidths: _liberationsans_widths.LiberationSansBoldWidths,
                  baseMapping: _liberationsans_widths.LiberationSansBoldMapping,
                  metrics: _helvetica_factors.HelveticaBoldMetrics
                };
                t2["Helvetica-Italic"] = {
                  name: "LiberationSans-Italic",
                  factors: _helvetica_factors.HelveticaItalicFactors,
                  baseWidths: _liberationsans_widths.LiberationSansItalicWidths,
                  baseMapping: _liberationsans_widths.LiberationSansItalicMapping,
                  metrics: _helvetica_factors.HelveticaItalicMetrics
                };
                t2["Helvetica-BoldItalic"] = {
                  name: "LiberationSans-BoldItalic",
                  factors: _helvetica_factors.HelveticaBoldItalicFactors,
                  baseWidths: _liberationsans_widths.LiberationSansBoldItalicWidths,
                  baseMapping: _liberationsans_widths.LiberationSansBoldItalicMapping,
                  metrics: _helvetica_factors.HelveticaBoldItalicMetrics
                };
              });
              function getXfaFontName(name) {
                const fontName = (0, _fonts_utils.normalizeFontName)(name);
                const fontMap = getXFAFontMap();
                return fontMap[fontName];
              }
              function getXfaFontWidths(name) {
                const info = getXfaFontName(name);
                if (!info) {
                  return null;
                }
                const {
                  baseWidths,
                  baseMapping,
                  factors
                } = info;
                const rescaledBaseWidths = !factors ? baseWidths : baseWidths.map((w, i) => w * factors[i]);
                let currentCode = -2;
                let currentArray;
                const newWidths = [];
                for (const [unicode, glyphIndex] of baseMapping.map((charUnicode, index3) => [charUnicode, index3]).sort(([unicode1], [unicode2]) => unicode1 - unicode2)) {
                  if (unicode === -1) {
                    continue;
                  }
                  if (unicode === currentCode + 1) {
                    currentArray.push(rescaledBaseWidths[glyphIndex]);
                    currentCode += 1;
                  } else {
                    currentCode = unicode;
                    currentArray = [rescaledBaseWidths[glyphIndex]];
                    newWidths.push(unicode, currentArray);
                  }
                }
                return newWidths;
              }
              function getXfaFontDict(name) {
                const widths = getXfaFontWidths(name);
                const dict = new _primitives.Dict(null);
                dict.set("BaseFont", _primitives.Name.get(name));
                dict.set("Type", _primitives.Name.get("Font"));
                dict.set("Subtype", _primitives.Name.get("CIDFontType2"));
                dict.set("Encoding", _primitives.Name.get("Identity-H"));
                dict.set("CIDToGIDMap", _primitives.Name.get("Identity"));
                dict.set("W", widths);
                dict.set("FirstChar", widths[0]);
                dict.set("LastChar", widths.at(-2) + widths.at(-1).length - 1);
                const descriptor = new _primitives.Dict(null);
                dict.set("FontDescriptor", descriptor);
                const systemInfo = new _primitives.Dict(null);
                systemInfo.set("Ordering", "Identity");
                systemInfo.set("Registry", "Adobe");
                systemInfo.set("Supplement", 0);
                dict.set("CIDSystemInfo", systemInfo);
                return dict;
              }
            }),
            /* 52 */
            /***/
            ((__unused_webpack_module2, exports3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.CalibriRegularMetrics = exports3.CalibriRegularFactors = exports3.CalibriItalicMetrics = exports3.CalibriItalicFactors = exports3.CalibriBoldMetrics = exports3.CalibriBoldItalicMetrics = exports3.CalibriBoldItalicFactors = exports3.CalibriBoldFactors = void 0;
              const CalibriBoldFactors = [1.3877, 1, 1, 1, 0.97801, 0.92482, 0.89552, 0.91133, 0.81988, 0.97566, 0.98152, 0.93548, 0.93548, 1.2798, 0.85284, 0.92794, 1, 0.96134, 1.54657, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.82845, 0.82845, 0.85284, 0.85284, 0.85284, 0.75859, 0.92138, 0.83908, 0.7762, 0.73293, 0.87289, 0.73133, 0.7514, 0.81921, 0.87356, 0.95958, 0.59526, 0.75727, 0.69225, 1.04924, 0.9121, 0.86943, 0.79795, 0.88198, 0.77958, 0.70864, 0.81055, 0.90399, 0.88653, 0.96017, 0.82577, 0.77892, 0.78257, 0.97507, 1.54657, 0.97507, 0.85284, 0.89552, 0.90176, 0.88762, 0.8785, 0.75241, 0.8785, 0.90518, 0.95015, 0.77618, 0.8785, 0.88401, 0.91916, 0.86304, 0.88401, 0.91488, 0.8785, 0.8801, 0.8785, 0.8785, 0.91343, 0.7173, 1.04106, 0.8785, 0.85075, 0.95794, 0.82616, 0.85162, 0.79492, 0.88331, 1.69808, 0.88331, 0.85284, 0.97801, 0.89552, 0.91133, 0.89552, 0.91133, 1.7801, 0.89552, 1.24487, 1.13254, 1.12401, 0.96839, 0.85284, 0.68787, 0.70645, 0.85592, 0.90747, 1.01466, 1.0088, 0.90323, 1, 1.07463, 1, 0.91056, 0.75806, 1.19118, 0.96839, 0.78864, 0.82845, 0.84133, 0.75859, 0.83908, 0.83908, 0.83908, 0.83908, 0.83908, 0.83908, 0.77539, 0.73293, 0.73133, 0.73133, 0.73133, 0.73133, 0.95958, 0.95958, 0.95958, 0.95958, 0.88506, 0.9121, 0.86943, 0.86943, 0.86943, 0.86943, 0.86943, 0.85284, 0.87508, 0.90399, 0.90399, 0.90399, 0.90399, 0.77892, 0.79795, 0.90807, 0.88762, 0.88762, 0.88762, 0.88762, 0.88762, 0.88762, 0.8715, 0.75241, 0.90518, 0.90518, 0.90518, 0.90518, 0.88401, 0.88401, 0.88401, 0.88401, 0.8785, 0.8785, 0.8801, 0.8801, 0.8801, 0.8801, 0.8801, 0.90747, 0.89049, 0.8785, 0.8785, 0.8785, 0.8785, 0.85162, 0.8785, 0.85162, 0.83908, 0.88762, 0.83908, 0.88762, 0.83908, 0.88762, 0.73293, 0.75241, 0.73293, 0.75241, 0.73293, 0.75241, 0.73293, 0.75241, 0.87289, 0.83016, 0.88506, 0.93125, 0.73133, 0.90518, 0.73133, 0.90518, 0.73133, 0.90518, 0.73133, 0.90518, 0.73133, 0.90518, 0.81921, 0.77618, 0.81921, 0.77618, 0.81921, 0.77618, 1, 1, 0.87356, 0.8785, 0.91075, 0.89608, 0.95958, 0.88401, 0.95958, 0.88401, 0.95958, 0.88401, 0.95958, 0.88401, 0.95958, 0.88401, 0.76229, 0.90167, 0.59526, 0.91916, 1, 1, 0.86304, 0.69225, 0.88401, 1, 1, 0.70424, 0.79468, 0.91926, 0.88175, 0.70823, 0.94903, 0.9121, 0.8785, 1, 1, 0.9121, 0.8785, 0.87802, 0.88656, 0.8785, 0.86943, 0.8801, 0.86943, 0.8801, 0.86943, 0.8801, 0.87402, 0.89291, 0.77958, 0.91343, 1, 1, 0.77958, 0.91343, 0.70864, 0.7173, 0.70864, 0.7173, 0.70864, 0.7173, 0.70864, 0.7173, 1, 1, 0.81055, 0.75841, 0.81055, 1.06452, 0.90399, 0.8785, 0.90399, 0.8785, 0.90399, 0.8785, 0.90399, 0.8785, 0.90399, 0.8785, 0.90399, 0.8785, 0.96017, 0.95794, 0.77892, 0.85162, 0.77892, 0.78257, 0.79492, 0.78257, 0.79492, 0.78257, 0.79492, 0.9297, 0.56892, 0.83908, 0.88762, 0.77539, 0.8715, 0.87508, 0.89049, 1, 1, 0.81055, 1.04106, 1.20528, 1.20528, 1, 1.15543, 0.70674, 0.98387, 0.94721, 1.33431, 1.45894, 0.95161, 1.06303, 0.83908, 0.80352, 0.57184, 0.6965, 0.56289, 0.82001, 0.56029, 0.81235, 1.02988, 0.83908, 0.7762, 0.68156, 0.80367, 0.73133, 0.78257, 0.87356, 0.86943, 0.95958, 0.75727, 0.89019, 1.04924, 0.9121, 0.7648, 0.86943, 0.87356, 0.79795, 0.78275, 0.81055, 0.77892, 0.9762, 0.82577, 0.99819, 0.84896, 0.95958, 0.77892, 0.96108, 1.01407, 0.89049, 1.02988, 0.94211, 0.96108, 0.8936, 0.84021, 0.87842, 0.96399, 0.79109, 0.89049, 1.00813, 1.02988, 0.86077, 0.87445, 0.92099, 0.84723, 0.86513, 0.8801, 0.75638, 0.85714, 0.78216, 0.79586, 0.87965, 0.94211, 0.97747, 0.78287, 0.97926, 0.84971, 1.02988, 0.94211, 0.8801, 0.94211, 0.84971, 0.73133, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.90264, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.90518, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.90548, 1, 1, 1, 1, 1, 1, 0.96017, 0.95794, 0.96017, 0.95794, 0.96017, 0.95794, 0.77892, 0.85162, 1, 1, 0.89552, 0.90527, 1, 0.90363, 0.92794, 0.92794, 0.92794, 0.92794, 0.87012, 0.87012, 0.87012, 0.89552, 0.89552, 1.42259, 0.71143, 1.06152, 1, 1, 1.03372, 1.03372, 0.97171, 1.4956, 2.2807, 0.93835, 0.83406, 0.91133, 0.84107, 0.91133, 1, 1, 1, 0.72021, 1, 1.23108, 0.83489, 0.88525, 0.88525, 0.81499, 0.90527, 1.81055, 0.90527, 1.81055, 1.31006, 1.53711, 0.94434, 1.08696, 1, 0.95018, 0.77192, 0.85284, 0.90747, 1.17534, 0.69825, 0.9716, 1.37077, 0.90747, 0.90747, 0.85356, 0.90747, 0.90747, 1.44947, 0.85284, 0.8941, 0.8941, 0.70572, 0.8, 0.70572, 0.70572, 0.70572, 0.70572, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.99862, 0.99862, 1, 1, 1, 1, 1, 1.08004, 0.91027, 1, 1, 1, 0.99862, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.90727, 0.90727, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
              exports3.CalibriBoldFactors = CalibriBoldFactors;
              const CalibriBoldMetrics = {
                lineHeight: 1.2207,
                lineGap: 0.2207
              };
              exports3.CalibriBoldMetrics = CalibriBoldMetrics;
              const CalibriBoldItalicFactors = [1.3877, 1, 1, 1, 0.97801, 0.92482, 0.89552, 0.91133, 0.81988, 0.97566, 0.98152, 0.93548, 0.93548, 1.2798, 0.85284, 0.92794, 1, 0.96134, 1.56239, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.82845, 0.82845, 0.85284, 0.85284, 0.85284, 0.75859, 0.92138, 0.83908, 0.7762, 0.71805, 0.87289, 0.73133, 0.7514, 0.81921, 0.87356, 0.95958, 0.59526, 0.75727, 0.69225, 1.04924, 0.90872, 0.85938, 0.79795, 0.87068, 0.77958, 0.69766, 0.81055, 0.90399, 0.88653, 0.96068, 0.82577, 0.77892, 0.78257, 0.97507, 1.529, 0.97507, 0.85284, 0.89552, 0.90176, 0.94908, 0.86411, 0.74012, 0.86411, 0.88323, 0.95015, 0.86411, 0.86331, 0.88401, 0.91916, 0.86304, 0.88401, 0.9039, 0.86331, 0.86331, 0.86411, 0.86411, 0.90464, 0.70852, 1.04106, 0.86331, 0.84372, 0.95794, 0.82616, 0.84548, 0.79492, 0.88331, 1.69808, 0.88331, 0.85284, 0.97801, 0.89552, 0.91133, 0.89552, 0.91133, 1.7801, 0.89552, 1.24487, 1.13254, 1.19129, 0.96839, 0.85284, 0.68787, 0.70645, 0.85592, 0.90747, 1.01466, 1.0088, 0.90323, 1, 1.07463, 1, 0.91056, 0.75806, 1.19118, 0.96839, 0.78864, 0.82845, 0.84133, 0.75859, 0.83908, 0.83908, 0.83908, 0.83908, 0.83908, 0.83908, 0.77539, 0.71805, 0.73133, 0.73133, 0.73133, 0.73133, 0.95958, 0.95958, 0.95958, 0.95958, 0.88506, 0.90872, 0.85938, 0.85938, 0.85938, 0.85938, 0.85938, 0.85284, 0.87068, 0.90399, 0.90399, 0.90399, 0.90399, 0.77892, 0.79795, 0.90807, 0.94908, 0.94908, 0.94908, 0.94908, 0.94908, 0.94908, 0.85887, 0.74012, 0.88323, 0.88323, 0.88323, 0.88323, 0.88401, 0.88401, 0.88401, 0.88401, 0.8785, 0.86331, 0.86331, 0.86331, 0.86331, 0.86331, 0.86331, 0.90747, 0.89049, 0.86331, 0.86331, 0.86331, 0.86331, 0.84548, 0.86411, 0.84548, 0.83908, 0.94908, 0.83908, 0.94908, 0.83908, 0.94908, 0.71805, 0.74012, 0.71805, 0.74012, 0.71805, 0.74012, 0.71805, 0.74012, 0.87289, 0.79538, 0.88506, 0.92726, 0.73133, 0.88323, 0.73133, 0.88323, 0.73133, 0.88323, 0.73133, 0.88323, 0.73133, 0.88323, 0.81921, 0.86411, 0.81921, 0.86411, 0.81921, 0.86411, 1, 1, 0.87356, 0.86331, 0.91075, 0.8777, 0.95958, 0.88401, 0.95958, 0.88401, 0.95958, 0.88401, 0.95958, 0.88401, 0.95958, 0.88401, 0.76467, 0.90167, 0.59526, 0.91916, 1, 1, 0.86304, 0.69225, 0.88401, 1, 1, 0.70424, 0.77312, 0.91926, 0.88175, 0.70823, 0.94903, 0.90872, 0.86331, 1, 1, 0.90872, 0.86331, 0.86906, 0.88116, 0.86331, 0.85938, 0.86331, 0.85938, 0.86331, 0.85938, 0.86331, 0.87402, 0.86549, 0.77958, 0.90464, 1, 1, 0.77958, 0.90464, 0.69766, 0.70852, 0.69766, 0.70852, 0.69766, 0.70852, 0.69766, 0.70852, 1, 1, 0.81055, 0.75841, 0.81055, 1.06452, 0.90399, 0.86331, 0.90399, 0.86331, 0.90399, 0.86331, 0.90399, 0.86331, 0.90399, 0.86331, 0.90399, 0.86331, 0.96068, 0.95794, 0.77892, 0.84548, 0.77892, 0.78257, 0.79492, 0.78257, 0.79492, 0.78257, 0.79492, 0.9297, 0.56892, 0.83908, 0.94908, 0.77539, 0.85887, 0.87068, 0.89049, 1, 1, 0.81055, 1.04106, 1.20528, 1.20528, 1, 1.15543, 0.70088, 0.98387, 0.94721, 1.33431, 1.45894, 0.95161, 1.48387, 0.83908, 0.80352, 0.57118, 0.6965, 0.56347, 0.79179, 0.55853, 0.80346, 1.02988, 0.83908, 0.7762, 0.67174, 0.86036, 0.73133, 0.78257, 0.87356, 0.86441, 0.95958, 0.75727, 0.89019, 1.04924, 0.90872, 0.74889, 0.85938, 0.87891, 0.79795, 0.7957, 0.81055, 0.77892, 0.97447, 0.82577, 0.97466, 0.87179, 0.95958, 0.77892, 0.94252, 0.95612, 0.8753, 1.02988, 0.92733, 0.94252, 0.87411, 0.84021, 0.8728, 0.95612, 0.74081, 0.8753, 1.02189, 1.02988, 0.84814, 0.87445, 0.91822, 0.84723, 0.85668, 0.86331, 0.81344, 0.87581, 0.76422, 0.82046, 0.96057, 0.92733, 0.99375, 0.78022, 0.95452, 0.86015, 1.02988, 0.92733, 0.86331, 0.92733, 0.86015, 0.73133, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.90631, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.88323, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.85174, 1, 1, 1, 1, 1, 1, 0.96068, 0.95794, 0.96068, 0.95794, 0.96068, 0.95794, 0.77892, 0.84548, 1, 1, 0.89552, 0.90527, 1, 0.90363, 0.92794, 0.92794, 0.92794, 0.89807, 0.87012, 0.87012, 0.87012, 0.89552, 0.89552, 1.42259, 0.71094, 1.06152, 1, 1, 1.03372, 1.03372, 0.97171, 1.4956, 2.2807, 0.92972, 0.83406, 0.91133, 0.83326, 0.91133, 1, 1, 1, 0.72021, 1, 1.23108, 0.83489, 0.88525, 0.88525, 0.81499, 0.90616, 1.81055, 0.90527, 1.81055, 1.3107, 1.53711, 0.94434, 1.08696, 1, 0.95018, 0.77192, 0.85284, 0.90747, 1.17534, 0.69825, 0.9716, 1.37077, 0.90747, 0.90747, 0.85356, 0.90747, 0.90747, 1.44947, 0.85284, 0.8941, 0.8941, 0.70572, 0.8, 0.70572, 0.70572, 0.70572, 0.70572, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.99862, 0.99862, 1, 1, 1, 1, 1, 1.08004, 0.91027, 1, 1, 1, 0.99862, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.90727, 0.90727, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
              exports3.CalibriBoldItalicFactors = CalibriBoldItalicFactors;
              const CalibriBoldItalicMetrics = {
                lineHeight: 1.2207,
                lineGap: 0.2207
              };
              exports3.CalibriBoldItalicMetrics = CalibriBoldItalicMetrics;
              const CalibriItalicFactors = [1.3877, 1, 1, 1, 1.17223, 1.1293, 0.89552, 0.91133, 0.80395, 1.02269, 1.15601, 0.91056, 0.91056, 1.2798, 0.85284, 0.89807, 1, 0.90861, 1.39543, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.96309, 0.96309, 0.85284, 0.85284, 0.85284, 0.83319, 0.88071, 0.8675, 0.81552, 0.72346, 0.85193, 0.73206, 0.7522, 0.81105, 0.86275, 0.90685, 0.6377, 0.77892, 0.75593, 1.02638, 0.89249, 0.84118, 0.77452, 0.85374, 0.75186, 0.67789, 0.79776, 0.88844, 0.85066, 0.94309, 0.77818, 0.7306, 0.76659, 1.10369, 1.38313, 1.10369, 1.06139, 0.89552, 0.8739, 0.9245, 0.9245, 0.83203, 0.9245, 0.85865, 1.09842, 0.9245, 0.9245, 1.03297, 1.07692, 0.90918, 1.03297, 0.94959, 0.9245, 0.92274, 0.9245, 0.9245, 1.02933, 0.77832, 1.20562, 0.9245, 0.8916, 0.98986, 0.86621, 0.89453, 0.79004, 0.94152, 1.77256, 0.94152, 0.85284, 0.97801, 0.89552, 0.91133, 0.89552, 0.91133, 1.91729, 0.89552, 1.17889, 1.13254, 1.16359, 0.92098, 0.85284, 0.68787, 0.71353, 0.84737, 0.90747, 1.0088, 1.0044, 0.87683, 1, 1.09091, 1, 0.92229, 0.739, 1.15642, 0.92098, 0.76288, 0.80504, 0.80972, 0.75859, 0.8675, 0.8675, 0.8675, 0.8675, 0.8675, 0.8675, 0.76318, 0.72346, 0.73206, 0.73206, 0.73206, 0.73206, 0.90685, 0.90685, 0.90685, 0.90685, 0.86477, 0.89249, 0.84118, 0.84118, 0.84118, 0.84118, 0.84118, 0.85284, 0.84557, 0.88844, 0.88844, 0.88844, 0.88844, 0.7306, 0.77452, 0.86331, 0.9245, 0.9245, 0.9245, 0.9245, 0.9245, 0.9245, 0.84843, 0.83203, 0.85865, 0.85865, 0.85865, 0.85865, 0.82601, 0.82601, 0.82601, 0.82601, 0.94469, 0.9245, 0.92274, 0.92274, 0.92274, 0.92274, 0.92274, 0.90747, 0.86651, 0.9245, 0.9245, 0.9245, 0.9245, 0.89453, 0.9245, 0.89453, 0.8675, 0.9245, 0.8675, 0.9245, 0.8675, 0.9245, 0.72346, 0.83203, 0.72346, 0.83203, 0.72346, 0.83203, 0.72346, 0.83203, 0.85193, 0.8875, 0.86477, 0.99034, 0.73206, 0.85865, 0.73206, 0.85865, 0.73206, 0.85865, 0.73206, 0.85865, 0.73206, 0.85865, 0.81105, 0.9245, 0.81105, 0.9245, 0.81105, 0.9245, 1, 1, 0.86275, 0.9245, 0.90872, 0.93591, 0.90685, 0.82601, 0.90685, 0.82601, 0.90685, 0.82601, 0.90685, 1.03297, 0.90685, 0.82601, 0.77896, 1.05611, 0.6377, 1.07692, 1, 1, 0.90918, 0.75593, 1.03297, 1, 1, 0.76032, 0.9375, 0.98156, 0.93407, 0.77261, 1.11429, 0.89249, 0.9245, 1, 1, 0.89249, 0.9245, 0.92534, 0.86698, 0.9245, 0.84118, 0.92274, 0.84118, 0.92274, 0.84118, 0.92274, 0.8667, 0.86291, 0.75186, 1.02933, 1, 1, 0.75186, 1.02933, 0.67789, 0.77832, 0.67789, 0.77832, 0.67789, 0.77832, 0.67789, 0.77832, 1, 1, 0.79776, 0.97655, 0.79776, 1.23023, 0.88844, 0.9245, 0.88844, 0.9245, 0.88844, 0.9245, 0.88844, 0.9245, 0.88844, 0.9245, 0.88844, 0.9245, 0.94309, 0.98986, 0.7306, 0.89453, 0.7306, 0.76659, 0.79004, 0.76659, 0.79004, 0.76659, 0.79004, 1.09231, 0.54873, 0.8675, 0.9245, 0.76318, 0.84843, 0.84557, 0.86651, 1, 1, 0.79776, 1.20562, 1.18622, 1.18622, 1, 1.1437, 0.67009, 0.96334, 0.93695, 1.35191, 1.40909, 0.95161, 1.48387, 0.8675, 0.90861, 0.6192, 0.7363, 0.64824, 0.82411, 0.56321, 0.85696, 1.23516, 0.8675, 0.81552, 0.7286, 0.84134, 0.73206, 0.76659, 0.86275, 0.84369, 0.90685, 0.77892, 0.85871, 1.02638, 0.89249, 0.75828, 0.84118, 0.85984, 0.77452, 0.76466, 0.79776, 0.7306, 0.90782, 0.77818, 0.903, 0.87291, 0.90685, 0.7306, 0.99058, 1.03667, 0.94635, 1.23516, 0.9849, 0.99058, 0.92393, 0.8916, 0.942, 1.03667, 0.75026, 0.94635, 1.0297, 1.23516, 0.90918, 0.94048, 0.98217, 0.89746, 0.84153, 0.92274, 0.82507, 0.88832, 0.84438, 0.88178, 1.03525, 0.9849, 1.00225, 0.78086, 0.97248, 0.89404, 1.23516, 0.9849, 0.92274, 0.9849, 0.89404, 0.73206, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.89693, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.85865, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.90933, 1, 1, 1, 1, 1, 1, 0.94309, 0.98986, 0.94309, 0.98986, 0.94309, 0.98986, 0.7306, 0.89453, 1, 1, 0.89552, 0.90527, 1, 0.90186, 1.12308, 1.12308, 1.12308, 1.12308, 1.2566, 1.2566, 1.2566, 0.89552, 0.89552, 1.42259, 0.68994, 1.03809, 1, 1, 1.0176, 1.0176, 1.11523, 1.4956, 2.01462, 0.97858, 0.82616, 0.91133, 0.83437, 0.91133, 1, 1, 1, 0.70508, 1, 1.23108, 0.79801, 0.84426, 0.84426, 0.774, 0.90572, 1.81055, 0.90749, 1.81055, 1.28809, 1.55469, 0.94434, 1.07806, 1, 0.97094, 0.7589, 0.85284, 0.90747, 1.19658, 0.69825, 0.97622, 1.33512, 0.90747, 0.90747, 0.85284, 0.90747, 0.90747, 1.44947, 0.85284, 0.8941, 0.8941, 0.70572, 0.8, 0.70572, 0.70572, 0.70572, 0.70572, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.99862, 0.99862, 1, 1, 1, 1, 1, 1.0336, 0.91027, 1, 1, 1, 0.99862, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.05859, 1.05859, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
              exports3.CalibriItalicFactors = CalibriItalicFactors;
              const CalibriItalicMetrics = {
                lineHeight: 1.2207,
                lineGap: 0.2207
              };
              exports3.CalibriItalicMetrics = CalibriItalicMetrics;
              const CalibriRegularFactors = [1.3877, 1, 1, 1, 1.17223, 1.1293, 0.89552, 0.91133, 0.80395, 1.02269, 1.15601, 0.91056, 0.91056, 1.2798, 0.85284, 0.89807, 1, 0.90861, 1.39016, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.96309, 0.96309, 0.85284, 0.85284, 0.85284, 0.83319, 0.88071, 0.8675, 0.81552, 0.73834, 0.85193, 0.73206, 0.7522, 0.81105, 0.86275, 0.90685, 0.6377, 0.77892, 0.75593, 1.02638, 0.89385, 0.85122, 0.77452, 0.86503, 0.75186, 0.68887, 0.79776, 0.88844, 0.85066, 0.94258, 0.77818, 0.7306, 0.76659, 1.10369, 1.39016, 1.10369, 1.06139, 0.89552, 0.8739, 0.86128, 0.94469, 0.8457, 0.94469, 0.89464, 1.09842, 0.84636, 0.94469, 1.03297, 1.07692, 0.90918, 1.03297, 0.95897, 0.94469, 0.9482, 0.94469, 0.94469, 1.04692, 0.78223, 1.20562, 0.94469, 0.90332, 0.98986, 0.86621, 0.90527, 0.79004, 0.94152, 1.77256, 0.94152, 0.85284, 0.97801, 0.89552, 0.91133, 0.89552, 0.91133, 1.91729, 0.89552, 1.17889, 1.13254, 1.08707, 0.92098, 0.85284, 0.68787, 0.71353, 0.84737, 0.90747, 1.0088, 1.0044, 0.87683, 1, 1.09091, 1, 0.92229, 0.739, 1.15642, 0.92098, 0.76288, 0.80504, 0.80972, 0.75859, 0.8675, 0.8675, 0.8675, 0.8675, 0.8675, 0.8675, 0.76318, 0.73834, 0.73206, 0.73206, 0.73206, 0.73206, 0.90685, 0.90685, 0.90685, 0.90685, 0.86477, 0.89385, 0.85122, 0.85122, 0.85122, 0.85122, 0.85122, 0.85284, 0.85311, 0.88844, 0.88844, 0.88844, 0.88844, 0.7306, 0.77452, 0.86331, 0.86128, 0.86128, 0.86128, 0.86128, 0.86128, 0.86128, 0.8693, 0.8457, 0.89464, 0.89464, 0.89464, 0.89464, 0.82601, 0.82601, 0.82601, 0.82601, 0.94469, 0.94469, 0.9482, 0.9482, 0.9482, 0.9482, 0.9482, 0.90747, 0.86651, 0.94469, 0.94469, 0.94469, 0.94469, 0.90527, 0.94469, 0.90527, 0.8675, 0.86128, 0.8675, 0.86128, 0.8675, 0.86128, 0.73834, 0.8457, 0.73834, 0.8457, 0.73834, 0.8457, 0.73834, 0.8457, 0.85193, 0.92454, 0.86477, 0.9921, 0.73206, 0.89464, 0.73206, 0.89464, 0.73206, 0.89464, 0.73206, 0.89464, 0.73206, 0.89464, 0.81105, 0.84636, 0.81105, 0.84636, 0.81105, 0.84636, 1, 1, 0.86275, 0.94469, 0.90872, 0.95786, 0.90685, 0.82601, 0.90685, 0.82601, 0.90685, 0.82601, 0.90685, 1.03297, 0.90685, 0.82601, 0.77741, 1.05611, 0.6377, 1.07692, 1, 1, 0.90918, 0.75593, 1.03297, 1, 1, 0.76032, 0.90452, 0.98156, 1.11842, 0.77261, 1.11429, 0.89385, 0.94469, 1, 1, 0.89385, 0.94469, 0.95877, 0.86901, 0.94469, 0.85122, 0.9482, 0.85122, 0.9482, 0.85122, 0.9482, 0.8667, 0.90016, 0.75186, 1.04692, 1, 1, 0.75186, 1.04692, 0.68887, 0.78223, 0.68887, 0.78223, 0.68887, 0.78223, 0.68887, 0.78223, 1, 1, 0.79776, 0.92188, 0.79776, 1.23023, 0.88844, 0.94469, 0.88844, 0.94469, 0.88844, 0.94469, 0.88844, 0.94469, 0.88844, 0.94469, 0.88844, 0.94469, 0.94258, 0.98986, 0.7306, 0.90527, 0.7306, 0.76659, 0.79004, 0.76659, 0.79004, 0.76659, 0.79004, 1.09231, 0.54873, 0.8675, 0.86128, 0.76318, 0.8693, 0.85311, 0.86651, 1, 1, 0.79776, 1.20562, 1.18622, 1.18622, 1, 1.1437, 0.67742, 0.96334, 0.93695, 1.35191, 1.40909, 0.95161, 1.48387, 0.86686, 0.90861, 0.62267, 0.74359, 0.65649, 0.85498, 0.56963, 0.88254, 1.23516, 0.8675, 0.81552, 0.75443, 0.84503, 0.73206, 0.76659, 0.86275, 0.85122, 0.90685, 0.77892, 0.85746, 1.02638, 0.89385, 0.75657, 0.85122, 0.86275, 0.77452, 0.74171, 0.79776, 0.7306, 0.95165, 0.77818, 0.89772, 0.88831, 0.90685, 0.7306, 0.98142, 1.02191, 0.96576, 1.23516, 0.99018, 0.98142, 0.9236, 0.89258, 0.94035, 1.02191, 0.78848, 0.96576, 0.9561, 1.23516, 0.90918, 0.92578, 0.95424, 0.89746, 0.83969, 0.9482, 0.80113, 0.89442, 0.85208, 0.86155, 0.98022, 0.99018, 1.00452, 0.81209, 0.99247, 0.89181, 1.23516, 0.99018, 0.9482, 0.99018, 0.89181, 0.73206, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.88844, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.89464, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.96766, 1, 1, 1, 1, 1, 1, 0.94258, 0.98986, 0.94258, 0.98986, 0.94258, 0.98986, 0.7306, 0.90527, 1, 1, 0.89552, 0.90527, 1, 0.90186, 1.12308, 1.12308, 1.12308, 1.12308, 1.2566, 1.2566, 1.2566, 0.89552, 0.89552, 1.42259, 0.69043, 1.03809, 1, 1, 1.0176, 1.0176, 1.11523, 1.4956, 2.01462, 0.99331, 0.82616, 0.91133, 0.84286, 0.91133, 1, 1, 1, 0.70508, 1, 1.23108, 0.79801, 0.84426, 0.84426, 0.774, 0.90527, 1.81055, 0.90527, 1.81055, 1.28809, 1.55469, 0.94434, 1.07806, 1, 0.97094, 0.7589, 0.85284, 0.90747, 1.19658, 0.69825, 0.97622, 1.33512, 0.90747, 0.90747, 0.85356, 0.90747, 0.90747, 1.44947, 0.85284, 0.8941, 0.8941, 0.70572, 0.8, 0.70572, 0.70572, 0.70572, 0.70572, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.99862, 0.99862, 1, 1, 1, 1, 1, 1.0336, 0.91027, 1, 1, 1, 0.99862, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.05859, 1.05859, 1, 1, 1, 1.07185, 0.99413, 0.96334, 1.08065, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
              exports3.CalibriRegularFactors = CalibriRegularFactors;
              const CalibriRegularMetrics = {
                lineHeight: 1.2207,
                lineGap: 0.2207
              };
              exports3.CalibriRegularMetrics = CalibriRegularMetrics;
            }),
            /* 53 */
            /***/
            ((__unused_webpack_module2, exports3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.HelveticaRegularMetrics = exports3.HelveticaRegularFactors = exports3.HelveticaItalicMetrics = exports3.HelveticaItalicFactors = exports3.HelveticaBoldMetrics = exports3.HelveticaBoldItalicMetrics = exports3.HelveticaBoldItalicFactors = exports3.HelveticaBoldFactors = void 0;
              const HelveticaBoldFactors = [0.76116, 1, 1, 1.0006, 0.99998, 0.99974, 0.99973, 0.99973, 0.99982, 0.99977, 1.00087, 0.99998, 0.99998, 0.99959, 1.00003, 1.0006, 0.99998, 1.0006, 1.0006, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99998, 1, 1.00003, 1.00003, 1.00003, 1.00026, 0.9999, 0.99977, 0.99977, 0.99977, 0.99977, 1.00001, 1.00026, 1.00022, 0.99977, 1.0006, 0.99973, 0.99977, 1.00026, 0.99999, 0.99977, 1.00022, 1.00001, 1.00022, 0.99977, 1.00001, 1.00026, 0.99977, 1.00001, 1.00016, 1.00001, 1.00001, 1.00026, 0.99998, 1.0006, 0.99998, 1.00003, 0.99973, 0.99998, 0.99973, 1.00026, 0.99973, 1.00026, 0.99973, 0.99998, 1.00026, 1.00026, 1.0006, 1.0006, 0.99973, 1.0006, 0.99982, 1.00026, 1.00026, 1.00026, 1.00026, 0.99959, 0.99973, 0.99998, 1.00026, 0.99973, 1.00022, 0.99973, 0.99973, 1, 0.99959, 1.00077, 0.99959, 1.00003, 0.99998, 0.99973, 0.99973, 0.99973, 0.99973, 1.00077, 0.99973, 0.99998, 1.00025, 0.99968, 0.99973, 1.00003, 1.00025, 0.60299, 1.00024, 1.06409, 1, 1, 0.99998, 1, 0.99973, 1.0006, 0.99998, 1, 0.99936, 0.99973, 1.00002, 1.00002, 1.00002, 1.00026, 0.99977, 0.99977, 0.99977, 0.99977, 0.99977, 0.99977, 1, 0.99977, 1.00001, 1.00001, 1.00001, 1.00001, 1.0006, 1.0006, 1.0006, 1.0006, 0.99977, 0.99977, 1.00022, 1.00022, 1.00022, 1.00022, 1.00022, 1.00003, 1.00022, 0.99977, 0.99977, 0.99977, 0.99977, 1.00001, 1.00001, 1.00026, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99982, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 1.0006, 1.0006, 1.0006, 1.0006, 1.00026, 1.00026, 1.00026, 1.00026, 1.00026, 1.00026, 1.00026, 1.06409, 1.00026, 1.00026, 1.00026, 1.00026, 1.00026, 0.99973, 1.00026, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 1.03374, 0.99977, 1.00026, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00022, 1.00026, 1.00022, 1.00026, 1.00022, 1.00026, 1.00022, 1.00026, 0.99977, 1.00026, 0.99977, 1.00026, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.00042, 0.99973, 0.99973, 1.0006, 0.99977, 0.99973, 0.99973, 1.00026, 1.0006, 1.00026, 1.0006, 1.00026, 1.03828, 1.00026, 0.99999, 1.00026, 1.0006, 0.99977, 1.00026, 0.99977, 1.00026, 0.99977, 1.00026, 0.9993, 0.9998, 1.00026, 1.00022, 1.00026, 1.00022, 1.00026, 1.00022, 1.00026, 1, 1.00016, 0.99977, 0.99959, 0.99977, 0.99959, 0.99977, 0.99959, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00026, 0.99998, 1.00026, 0.8121, 1.00026, 0.99998, 0.99977, 1.00026, 0.99977, 1.00026, 0.99977, 1.00026, 0.99977, 1.00026, 0.99977, 1.00026, 0.99977, 1.00026, 1.00016, 1.00022, 1.00001, 0.99973, 1.00001, 1.00026, 1, 1.00026, 1, 1.00026, 1, 1.0006, 0.99973, 0.99977, 0.99973, 1, 0.99982, 1.00022, 1.00026, 1.00001, 0.99973, 1.00026, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 1.00034, 0.99977, 1, 0.99997, 1.00026, 1.00078, 1.00036, 0.99973, 1.00013, 1.0006, 0.99977, 0.99977, 0.99988, 0.85148, 1.00001, 1.00026, 0.99977, 1.00022, 1.0006, 0.99977, 1.00001, 0.99999, 0.99977, 1.00069, 1.00022, 0.99977, 1.00001, 0.99984, 1.00026, 1.00001, 1.00024, 1.00001, 0.9999, 1, 1.0006, 1.00001, 1.00041, 0.99962, 1.00026, 1.0006, 0.99995, 1.00041, 0.99942, 0.99973, 0.99927, 1.00082, 0.99902, 1.00026, 1.00087, 1.0006, 1.00069, 0.99973, 0.99867, 0.99973, 0.9993, 1.00026, 1.00049, 1.00056, 1, 0.99988, 0.99935, 0.99995, 0.99954, 1.00055, 0.99945, 1.00032, 1.0006, 0.99995, 1.00026, 0.99995, 1.00032, 1.00001, 1.00008, 0.99971, 1.00019, 0.9994, 1.00001, 1.0006, 1.00044, 0.99973, 1.00023, 1.00047, 1, 0.99942, 0.99561, 0.99989, 1.00035, 0.99977, 1.00035, 0.99977, 1.00019, 0.99944, 1.00001, 1.00021, 0.99926, 1.00035, 1.00035, 0.99942, 1.00048, 0.99999, 0.99977, 1.00022, 1.00035, 1.00001, 0.99977, 1.00026, 0.99989, 1.00057, 1.00001, 0.99936, 1.00052, 1.00012, 0.99996, 1.00043, 1, 1.00035, 0.9994, 0.99976, 1.00035, 0.99973, 1.00052, 1.00041, 1.00119, 1.00037, 0.99973, 1.00002, 0.99986, 1.00041, 1.00041, 0.99902, 0.9996, 1.00034, 0.99999, 1.00026, 0.99999, 1.00026, 0.99973, 1.00052, 0.99973, 1, 0.99973, 1.00041, 1.00075, 0.9994, 1.0003, 0.99999, 1, 1.00041, 0.99955, 1, 0.99915, 0.99973, 0.99973, 1.00026, 1.00119, 0.99955, 0.99973, 1.0006, 0.99911, 1.0006, 1.00026, 0.99972, 1.00026, 0.99902, 1.00041, 0.99973, 0.99999, 1, 1, 1.00038, 1.0005, 1.00016, 1.00022, 1.00016, 1.00022, 1.00016, 1.00022, 1.00001, 0.99973, 1, 1, 0.99973, 1, 1, 0.99955, 1.0006, 1.0006, 1.0006, 1.0006, 1, 1, 1, 0.99973, 0.99973, 0.99972, 1, 1, 1.00106, 0.99999, 0.99998, 0.99998, 0.99999, 0.99998, 1.66475, 1, 0.99973, 0.99973, 1.00023, 0.99973, 0.99971, 1.00047, 1.00023, 1, 0.99991, 0.99984, 1.00002, 1.00002, 1.00002, 1.00002, 1, 1, 1, 1, 1, 1, 1, 0.99972, 1, 1.20985, 1.39713, 1.00003, 1.00031, 1.00015, 1, 0.99561, 1.00027, 1.00031, 1.00031, 0.99915, 1.00031, 1.00031, 0.99999, 1.00003, 0.99999, 0.99999, 1.41144, 1.6, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.40579, 1.40579, 1.36625, 0.99999, 1, 0.99861, 0.99861, 1, 1.00026, 1.00026, 1.00026, 1.00026, 0.99972, 0.99999, 0.99999, 0.99999, 0.99999, 1.40483, 1, 0.99977, 1.00054, 1, 1, 0.99953, 0.99962, 1.00042, 0.9995, 1, 1, 1, 1, 1, 1, 1, 1, 0.99998, 0.99998, 0.99998, 0.99998, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
              exports3.HelveticaBoldFactors = HelveticaBoldFactors;
              const HelveticaBoldMetrics = {
                lineHeight: 1.2,
                lineGap: 0.2
              };
              exports3.HelveticaBoldMetrics = HelveticaBoldMetrics;
              const HelveticaBoldItalicFactors = [0.76116, 1, 1, 1.0006, 0.99998, 0.99974, 0.99973, 0.99973, 0.99982, 0.99977, 1.00087, 0.99998, 0.99998, 0.99959, 1.00003, 1.0006, 0.99998, 1.0006, 1.0006, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99998, 1, 1.00003, 1.00003, 1.00003, 1.00026, 0.9999, 0.99977, 0.99977, 0.99977, 0.99977, 1.00001, 1.00026, 1.00022, 0.99977, 1.0006, 0.99973, 0.99977, 1.00026, 0.99999, 0.99977, 1.00022, 1.00001, 1.00022, 0.99977, 1.00001, 1.00026, 0.99977, 1.00001, 1.00016, 1.00001, 1.00001, 1.00026, 0.99998, 1.0006, 0.99998, 1.00003, 0.99973, 0.99998, 0.99973, 1.00026, 0.99973, 1.00026, 0.99973, 0.99998, 1.00026, 1.00026, 1.0006, 1.0006, 0.99973, 1.0006, 0.99982, 1.00026, 1.00026, 1.00026, 1.00026, 0.99959, 0.99973, 0.99998, 1.00026, 0.99973, 1.00022, 0.99973, 0.99973, 1, 0.99959, 1.00077, 0.99959, 1.00003, 0.99998, 0.99973, 0.99973, 0.99973, 0.99973, 1.00077, 0.99973, 0.99998, 1.00025, 0.99968, 0.99973, 1.00003, 1.00025, 0.60299, 1.00024, 1.06409, 1, 1, 0.99998, 1, 0.99973, 1.0006, 0.99998, 1, 0.99936, 0.99973, 1.00002, 1.00002, 1.00002, 1.00026, 0.99977, 0.99977, 0.99977, 0.99977, 0.99977, 0.99977, 1, 0.99977, 1.00001, 1.00001, 1.00001, 1.00001, 1.0006, 1.0006, 1.0006, 1.0006, 0.99977, 0.99977, 1.00022, 1.00022, 1.00022, 1.00022, 1.00022, 1.00003, 1.00022, 0.99977, 0.99977, 0.99977, 0.99977, 1.00001, 1.00001, 1.00026, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99982, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 1.0006, 1.0006, 1.0006, 1.0006, 1.00026, 1.00026, 1.00026, 1.00026, 1.00026, 1.00026, 1.00026, 1.06409, 1.00026, 1.00026, 1.00026, 1.00026, 1.00026, 0.99973, 1.00026, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 1.0044, 0.99977, 1.00026, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00022, 1.00026, 1.00022, 1.00026, 1.00022, 1.00026, 1.00022, 1.00026, 0.99977, 1.00026, 0.99977, 1.00026, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 0.99971, 0.99973, 0.99973, 1.0006, 0.99977, 0.99973, 0.99973, 1.00026, 1.0006, 1.00026, 1.0006, 1.00026, 1.01011, 1.00026, 0.99999, 1.00026, 1.0006, 0.99977, 1.00026, 0.99977, 1.00026, 0.99977, 1.00026, 0.9993, 0.9998, 1.00026, 1.00022, 1.00026, 1.00022, 1.00026, 1.00022, 1.00026, 1, 1.00016, 0.99977, 0.99959, 0.99977, 0.99959, 0.99977, 0.99959, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00026, 0.99998, 1.00026, 0.8121, 1.00026, 0.99998, 0.99977, 1.00026, 0.99977, 1.00026, 0.99977, 1.00026, 0.99977, 1.00026, 0.99977, 1.00026, 0.99977, 1.00026, 1.00016, 1.00022, 1.00001, 0.99973, 1.00001, 1.00026, 1, 1.00026, 1, 1.00026, 1, 1.0006, 0.99973, 0.99977, 0.99973, 1, 0.99982, 1.00022, 1.00026, 1.00001, 0.99973, 1.00026, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99977, 1, 1, 1.00026, 0.99969, 0.99972, 0.99981, 0.9998, 1.0006, 0.99977, 0.99977, 1.00022, 0.91155, 1.00001, 1.00026, 0.99977, 1.00022, 1.0006, 0.99977, 1.00001, 0.99999, 0.99977, 0.99966, 1.00022, 1.00032, 1.00001, 0.99944, 1.00026, 1.00001, 0.99968, 1.00001, 1.00047, 1, 1.0006, 1.00001, 0.99981, 1.00101, 1.00026, 1.0006, 0.99948, 0.99981, 1.00064, 0.99973, 0.99942, 1.00101, 1.00061, 1.00026, 1.00069, 1.0006, 1.00014, 0.99973, 1.01322, 0.99973, 1.00065, 1.00026, 1.00012, 0.99923, 1, 1.00064, 1.00076, 0.99948, 1.00055, 1.00063, 1.00007, 0.99943, 1.0006, 0.99948, 1.00026, 0.99948, 0.99943, 1.00001, 1.00001, 1.00029, 1.00038, 1.00035, 1.00001, 1.0006, 1.0006, 0.99973, 0.99978, 1.00001, 1.00057, 0.99989, 0.99967, 0.99964, 0.99967, 0.99977, 0.99999, 0.99977, 1.00038, 0.99977, 1.00001, 0.99973, 1.00066, 0.99967, 0.99967, 1.00041, 0.99998, 0.99999, 0.99977, 1.00022, 0.99967, 1.00001, 0.99977, 1.00026, 0.99964, 1.00031, 1.00001, 0.99999, 0.99999, 1, 1.00023, 1, 1, 0.99999, 1.00035, 1.00001, 0.99999, 0.99973, 0.99977, 0.99999, 1.00058, 0.99973, 0.99973, 0.99955, 0.9995, 1.00026, 1.00026, 1.00032, 0.99989, 1.00034, 0.99999, 1.00026, 1.00026, 1.00026, 0.99973, 0.45998, 0.99973, 1.00026, 0.99973, 1.00001, 0.99999, 0.99982, 0.99994, 0.99996, 1, 1.00042, 1.00044, 1.00029, 1.00023, 0.99973, 0.99973, 1.00026, 0.99949, 1.00002, 0.99973, 1.0006, 1.0006, 1.0006, 0.99975, 1.00026, 1.00026, 1.00032, 0.98685, 0.99973, 1.00026, 1, 1, 0.99966, 1.00044, 1.00016, 1.00022, 1.00016, 1.00022, 1.00016, 1.00022, 1.00001, 0.99973, 1, 1, 0.99973, 1, 1, 0.99955, 1.0006, 1.0006, 1.0006, 1.0006, 1, 1, 1, 0.99973, 0.99973, 0.99972, 1, 1, 1.00106, 0.99999, 0.99998, 0.99998, 0.99999, 0.99998, 1.66475, 1, 0.99973, 0.99973, 1, 0.99973, 0.99971, 0.99978, 1, 1, 0.99991, 0.99984, 1.00002, 1.00002, 1.00002, 1.00002, 1.00098, 1, 1, 1, 1.00049, 1, 1, 0.99972, 1, 1.20985, 1.39713, 1.00003, 1.00031, 1.00015, 1, 0.99561, 1.00027, 1.00031, 1.00031, 0.99915, 1.00031, 1.00031, 0.99999, 1.00003, 0.99999, 0.99999, 1.41144, 1.6, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.40579, 1.40579, 1.36625, 0.99999, 1, 0.99861, 0.99861, 1, 1.00026, 1.00026, 1.00026, 1.00026, 0.99972, 0.99999, 0.99999, 0.99999, 0.99999, 1.40483, 1, 0.99977, 1.00054, 1, 1, 0.99953, 0.99962, 1.00042, 0.9995, 1, 1, 1, 1, 1, 1, 1, 1, 0.99998, 0.99998, 0.99998, 0.99998, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
              exports3.HelveticaBoldItalicFactors = HelveticaBoldItalicFactors;
              const HelveticaBoldItalicMetrics = {
                lineHeight: 1.35,
                lineGap: 0.2
              };
              exports3.HelveticaBoldItalicMetrics = HelveticaBoldItalicMetrics;
              const HelveticaItalicFactors = [0.76116, 1, 1, 1.0006, 1.0006, 1.00006, 0.99973, 0.99973, 0.99982, 1.00001, 1.00043, 0.99998, 0.99998, 0.99959, 1.00003, 1.0006, 0.99998, 1.0006, 1.0006, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 1.0006, 1, 1.00003, 1.00003, 1.00003, 0.99973, 0.99987, 1.00001, 1.00001, 0.99977, 0.99977, 1.00001, 1.00026, 1.00022, 0.99977, 1.0006, 1, 1.00001, 0.99973, 0.99999, 0.99977, 1.00022, 1.00001, 1.00022, 0.99977, 1.00001, 1.00026, 0.99977, 1.00001, 1.00016, 1.00001, 1.00001, 1.00026, 1.0006, 1.0006, 1.0006, 0.99949, 0.99973, 0.99998, 0.99973, 0.99973, 1, 0.99973, 0.99973, 1.0006, 0.99973, 0.99973, 0.99924, 0.99924, 1, 0.99924, 0.99999, 0.99973, 0.99973, 0.99973, 0.99973, 0.99998, 1, 1.0006, 0.99973, 1, 0.99977, 1, 1, 1, 1.00005, 1.0009, 1.00005, 1.00003, 0.99998, 0.99973, 0.99973, 0.99973, 0.99973, 1.0009, 0.99973, 0.99998, 1.00025, 0.99968, 0.99973, 1.00003, 1.00025, 0.60299, 1.00024, 1.06409, 1, 1, 0.99998, 1, 0.9998, 1.0006, 0.99998, 1, 0.99936, 0.99973, 1.00002, 1.00002, 1.00002, 1.00026, 1.00001, 1.00001, 1.00001, 1.00001, 1.00001, 1.00001, 1, 0.99977, 1.00001, 1.00001, 1.00001, 1.00001, 1.0006, 1.0006, 1.0006, 1.0006, 0.99977, 0.99977, 1.00022, 1.00022, 1.00022, 1.00022, 1.00022, 1.00003, 1.00022, 0.99977, 0.99977, 0.99977, 0.99977, 1.00001, 1.00001, 1.00026, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99982, 1, 0.99973, 0.99973, 0.99973, 0.99973, 1.0006, 1.0006, 1.0006, 1.0006, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 1.06409, 1.00026, 0.99973, 0.99973, 0.99973, 0.99973, 1, 0.99973, 1, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 0.99977, 1, 0.99977, 1, 0.99977, 1, 0.99977, 1, 0.99977, 1.0288, 0.99977, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00022, 0.99973, 1.00022, 0.99973, 1.00022, 0.99973, 1.00022, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 0.99924, 1.0006, 1.0006, 0.99946, 1.00034, 1, 0.99924, 1.00001, 1, 1, 0.99973, 0.99924, 0.99973, 0.99924, 0.99973, 1.06311, 0.99973, 1.00024, 0.99973, 0.99924, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 1.00041, 0.9998, 0.99973, 1.00022, 0.99973, 1.00022, 0.99973, 1.00022, 0.99973, 1, 1.00016, 0.99977, 0.99998, 0.99977, 0.99998, 0.99977, 0.99998, 1.00001, 1, 1.00001, 1, 1.00001, 1, 1.00001, 1, 1.00026, 1.0006, 1.00026, 0.89547, 1.00026, 1.0006, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 1.00016, 0.99977, 1.00001, 1, 1.00001, 1.00026, 1, 1.00026, 1, 1.00026, 1, 0.99924, 0.99973, 1.00001, 0.99973, 1, 0.99982, 1.00022, 1.00026, 1.00001, 1, 1.00026, 1.0006, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 1.00001, 1, 1.00054, 0.99977, 1.00084, 1.00007, 0.99973, 1.00013, 0.99924, 1.00001, 1.00001, 0.99945, 0.91221, 1.00001, 1.00026, 0.99977, 1.00022, 1.0006, 1.00001, 1.00001, 0.99999, 0.99977, 0.99933, 1.00022, 1.00054, 1.00001, 1.00065, 1.00026, 1.00001, 1.0001, 1.00001, 1.00052, 1, 1.0006, 1.00001, 0.99945, 0.99897, 0.99968, 0.99924, 1.00036, 0.99945, 0.99949, 1, 1.0006, 0.99897, 0.99918, 0.99968, 0.99911, 0.99924, 1, 0.99962, 1.01487, 1, 1.0005, 0.99973, 1.00012, 1.00043, 1, 0.99995, 0.99994, 1.00036, 0.99947, 1.00019, 1.00063, 1.00025, 0.99924, 1.00036, 0.99973, 1.00036, 1.00025, 1.00001, 1.00001, 1.00027, 1.0001, 1.00068, 1.00001, 1.0006, 1.0006, 1, 1.00008, 0.99957, 0.99972, 0.9994, 0.99954, 0.99975, 1.00051, 1.00001, 1.00019, 1.00001, 1.0001, 0.99986, 1.00001, 1.00001, 1.00038, 0.99954, 0.99954, 0.9994, 1.00066, 0.99999, 0.99977, 1.00022, 1.00054, 1.00001, 0.99977, 1.00026, 0.99975, 1.0001, 1.00001, 0.99993, 0.9995, 0.99955, 1.00016, 0.99978, 0.99974, 1.00019, 1.00022, 0.99955, 1.00053, 0.99973, 1.00089, 1.00005, 0.99967, 1.00048, 0.99973, 1.00002, 1.00034, 0.99973, 0.99973, 0.99964, 1.00006, 1.00066, 0.99947, 0.99973, 0.98894, 0.99973, 1, 0.44898, 1, 0.99946, 1, 1.00039, 1.00082, 0.99991, 0.99991, 0.99985, 1.00022, 1.00023, 1.00061, 1.00006, 0.99966, 0.99973, 0.99973, 0.99973, 1.00019, 1.0008, 1, 0.99924, 0.99924, 0.99924, 0.99983, 1.00044, 0.99973, 0.99964, 0.98332, 1, 0.99973, 1, 1, 0.99962, 0.99895, 1.00016, 0.99977, 1.00016, 0.99977, 1.00016, 0.99977, 1.00001, 1, 1, 1, 0.99973, 1, 1, 0.99955, 0.99924, 0.99924, 0.99924, 0.99924, 0.99998, 0.99998, 0.99998, 0.99973, 0.99973, 0.99972, 1, 1, 1.00267, 0.99999, 0.99998, 0.99998, 1, 0.99998, 1.66475, 1, 0.99973, 0.99973, 1.00023, 0.99973, 1.00423, 0.99925, 0.99999, 1, 0.99991, 0.99984, 1.00002, 1.00002, 1.00002, 1.00002, 1.00049, 1, 1.00245, 1, 1, 1, 1, 0.96329, 1, 1.20985, 1.39713, 1.00003, 0.8254, 1.00015, 1, 1.00035, 1.00027, 1.00031, 1.00031, 1.00003, 1.00031, 1.00031, 0.99999, 1.00003, 0.99999, 0.99999, 1.41144, 1.6, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.40579, 1.40579, 1.36625, 0.99999, 1, 0.99861, 0.99861, 1, 1.00026, 1.00026, 1.00026, 1.00026, 0.95317, 0.99999, 0.99999, 0.99999, 0.99999, 1.40483, 1, 0.99977, 1.00054, 1, 1, 0.99953, 0.99962, 1.00042, 0.9995, 1, 1, 1, 1, 1, 1, 1, 1, 0.99998, 0.99998, 0.99998, 0.99998, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
              exports3.HelveticaItalicFactors = HelveticaItalicFactors;
              const HelveticaItalicMetrics = {
                lineHeight: 1.35,
                lineGap: 0.2
              };
              exports3.HelveticaItalicMetrics = HelveticaItalicMetrics;
              const HelveticaRegularFactors = [0.76116, 1, 1, 1.0006, 1.0006, 1.00006, 0.99973, 0.99973, 0.99982, 1.00001, 1.00043, 0.99998, 0.99998, 0.99959, 1.00003, 1.0006, 0.99998, 1.0006, 1.0006, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 1.0006, 1, 1.00003, 1.00003, 1.00003, 0.99973, 0.99987, 1.00001, 1.00001, 0.99977, 0.99977, 1.00001, 1.00026, 1.00022, 0.99977, 1.0006, 1, 1.00001, 0.99973, 0.99999, 0.99977, 1.00022, 1.00001, 1.00022, 0.99977, 1.00001, 1.00026, 0.99977, 1.00001, 1.00016, 1.00001, 1.00001, 1.00026, 1.0006, 1.0006, 1.0006, 0.99949, 0.99973, 0.99998, 0.99973, 0.99973, 1, 0.99973, 0.99973, 1.0006, 0.99973, 0.99973, 0.99924, 0.99924, 1, 0.99924, 0.99999, 0.99973, 0.99973, 0.99973, 0.99973, 0.99998, 1, 1.0006, 0.99973, 1, 0.99977, 1, 1, 1, 1.00005, 1.0009, 1.00005, 1.00003, 0.99998, 0.99973, 0.99973, 0.99973, 0.99973, 1.0009, 0.99973, 0.99998, 1.00025, 0.99968, 0.99973, 1.00003, 1.00025, 0.60299, 1.00024, 1.06409, 1, 1, 0.99998, 1, 0.9998, 1.0006, 0.99998, 1, 0.99936, 0.99973, 1.00002, 1.00002, 1.00002, 1.00026, 1.00001, 1.00001, 1.00001, 1.00001, 1.00001, 1.00001, 1, 0.99977, 1.00001, 1.00001, 1.00001, 1.00001, 1.0006, 1.0006, 1.0006, 1.0006, 0.99977, 0.99977, 1.00022, 1.00022, 1.00022, 1.00022, 1.00022, 1.00003, 1.00022, 0.99977, 0.99977, 0.99977, 0.99977, 1.00001, 1.00001, 1.00026, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99982, 1, 0.99973, 0.99973, 0.99973, 0.99973, 1.0006, 1.0006, 1.0006, 1.0006, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 1.06409, 1.00026, 0.99973, 0.99973, 0.99973, 0.99973, 1, 0.99973, 1, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 0.99977, 1, 0.99977, 1, 0.99977, 1, 0.99977, 1, 0.99977, 1.04596, 0.99977, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00022, 0.99973, 1.00022, 0.99973, 1.00022, 0.99973, 1.00022, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 0.99924, 1.0006, 1.0006, 1.00019, 1.00034, 1, 0.99924, 1.00001, 1, 1, 0.99973, 0.99924, 0.99973, 0.99924, 0.99973, 1.02572, 0.99973, 1.00005, 0.99973, 0.99924, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99999, 0.9998, 0.99973, 1.00022, 0.99973, 1.00022, 0.99973, 1.00022, 0.99973, 1, 1.00016, 0.99977, 0.99998, 0.99977, 0.99998, 0.99977, 0.99998, 1.00001, 1, 1.00001, 1, 1.00001, 1, 1.00001, 1, 1.00026, 1.0006, 1.00026, 0.84533, 1.00026, 1.0006, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 1.00016, 0.99977, 1.00001, 1, 1.00001, 1.00026, 1, 1.00026, 1, 1.00026, 1, 0.99924, 0.99973, 1.00001, 0.99973, 1, 0.99982, 1.00022, 1.00026, 1.00001, 1, 1.00026, 1.0006, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99928, 1, 0.99977, 1.00013, 1.00055, 0.99947, 0.99945, 0.99941, 0.99924, 1.00001, 1.00001, 1.0004, 0.91621, 1.00001, 1.00026, 0.99977, 1.00022, 1.0006, 1.00001, 1.00005, 0.99999, 0.99977, 1.00015, 1.00022, 0.99977, 1.00001, 0.99973, 1.00026, 1.00001, 1.00019, 1.00001, 0.99946, 1, 1.0006, 1.00001, 0.99978, 1.00045, 0.99973, 0.99924, 1.00023, 0.99978, 0.99966, 1, 1.00065, 1.00045, 1.00019, 0.99973, 0.99973, 0.99924, 1, 1, 0.96499, 1, 1.00055, 0.99973, 1.00008, 1.00027, 1, 0.9997, 0.99995, 1.00023, 0.99933, 1.00019, 1.00015, 1.00031, 0.99924, 1.00023, 0.99973, 1.00023, 1.00031, 1.00001, 0.99928, 1.00029, 1.00092, 1.00035, 1.00001, 1.0006, 1.0006, 1, 0.99988, 0.99975, 1, 1.00082, 0.99561, 0.9996, 1.00035, 1.00001, 0.99962, 1.00001, 1.00092, 0.99964, 1.00001, 0.99963, 0.99999, 1.00035, 1.00035, 1.00082, 0.99962, 0.99999, 0.99977, 1.00022, 1.00035, 1.00001, 0.99977, 1.00026, 0.9996, 0.99967, 1.00001, 1.00034, 1.00074, 1.00054, 1.00053, 1.00063, 0.99971, 0.99962, 1.00035, 0.99975, 0.99977, 0.99973, 1.00043, 0.99953, 1.0007, 0.99915, 0.99973, 1.00008, 0.99892, 1.00073, 1.00073, 1.00114, 0.99915, 1.00073, 0.99955, 0.99973, 1.00092, 0.99973, 1, 0.99998, 1, 1.0003, 1, 1.00043, 1.00001, 0.99969, 1.0003, 1, 1.00035, 1.00001, 0.9995, 1, 1.00092, 0.99973, 0.99973, 0.99973, 1.0007, 0.9995, 1, 0.99924, 1.0006, 0.99924, 0.99972, 1.00062, 0.99973, 1.00114, 1.00073, 1, 0.99955, 1, 1, 1.00047, 0.99968, 1.00016, 0.99977, 1.00016, 0.99977, 1.00016, 0.99977, 1.00001, 1, 1, 1, 0.99973, 1, 1, 0.99955, 0.99924, 0.99924, 0.99924, 0.99924, 0.99998, 0.99998, 0.99998, 0.99973, 0.99973, 0.99972, 1, 1, 1.00267, 0.99999, 0.99998, 0.99998, 1, 0.99998, 1.66475, 1, 0.99973, 0.99973, 1.00023, 0.99973, 0.99971, 0.99925, 1.00023, 1, 0.99991, 0.99984, 1.00002, 1.00002, 1.00002, 1.00002, 1, 1, 1, 1, 1, 1, 1, 0.96329, 1, 1.20985, 1.39713, 1.00003, 0.8254, 1.00015, 1, 1.00035, 1.00027, 1.00031, 1.00031, 0.99915, 1.00031, 1.00031, 0.99999, 1.00003, 0.99999, 0.99999, 1.41144, 1.6, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.40579, 1.40579, 1.36625, 0.99999, 1, 0.99861, 0.99861, 1, 1.00026, 1.00026, 1.00026, 1.00026, 0.95317, 0.99999, 0.99999, 0.99999, 0.99999, 1.40483, 1, 0.99977, 1.00054, 1, 1, 0.99953, 0.99962, 1.00042, 0.9995, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
              exports3.HelveticaRegularFactors = HelveticaRegularFactors;
              const HelveticaRegularMetrics = {
                lineHeight: 1.2,
                lineGap: 0.2
              };
              exports3.HelveticaRegularMetrics = HelveticaRegularMetrics;
            }),
            /* 54 */
            /***/
            ((__unused_webpack_module2, exports3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.LiberationSansRegularWidths = exports3.LiberationSansRegularMapping = exports3.LiberationSansItalicWidths = exports3.LiberationSansItalicMapping = exports3.LiberationSansBoldWidths = exports3.LiberationSansBoldMapping = exports3.LiberationSansBoldItalicWidths = exports3.LiberationSansBoldItalicMapping = void 0;
              const LiberationSansBoldWidths = [365, 0, 333, 278, 333, 474, 556, 556, 889, 722, 238, 333, 333, 389, 584, 278, 333, 278, 278, 556, 556, 556, 556, 556, 556, 556, 556, 556, 556, 333, 333, 584, 584, 584, 611, 975, 722, 722, 722, 722, 667, 611, 778, 722, 278, 556, 722, 611, 833, 722, 778, 667, 778, 722, 667, 611, 722, 667, 944, 667, 667, 611, 333, 278, 333, 584, 556, 333, 556, 611, 556, 611, 556, 333, 611, 611, 278, 278, 556, 278, 889, 611, 611, 611, 611, 389, 556, 333, 611, 556, 778, 556, 556, 500, 389, 280, 389, 584, 333, 556, 556, 556, 556, 280, 556, 333, 737, 370, 556, 584, 737, 552, 400, 549, 333, 333, 333, 576, 556, 278, 333, 333, 365, 556, 834, 834, 834, 611, 722, 722, 722, 722, 722, 722, 1e3, 722, 667, 667, 667, 667, 278, 278, 278, 278, 722, 722, 778, 778, 778, 778, 778, 584, 778, 722, 722, 722, 722, 667, 667, 611, 556, 556, 556, 556, 556, 556, 889, 556, 556, 556, 556, 556, 278, 278, 278, 278, 611, 611, 611, 611, 611, 611, 611, 549, 611, 611, 611, 611, 611, 556, 611, 556, 722, 556, 722, 556, 722, 556, 722, 556, 722, 556, 722, 556, 722, 556, 722, 719, 722, 611, 667, 556, 667, 556, 667, 556, 667, 556, 667, 556, 778, 611, 778, 611, 778, 611, 778, 611, 722, 611, 722, 611, 278, 278, 278, 278, 278, 278, 278, 278, 278, 278, 785, 556, 556, 278, 722, 556, 556, 611, 278, 611, 278, 611, 385, 611, 479, 611, 278, 722, 611, 722, 611, 722, 611, 708, 723, 611, 778, 611, 778, 611, 778, 611, 1e3, 944, 722, 389, 722, 389, 722, 389, 667, 556, 667, 556, 667, 556, 667, 556, 611, 333, 611, 479, 611, 333, 722, 611, 722, 611, 722, 611, 722, 611, 722, 611, 722, 611, 944, 778, 667, 556, 667, 611, 500, 611, 500, 611, 500, 278, 556, 722, 556, 1e3, 889, 778, 611, 667, 556, 611, 333, 333, 333, 333, 333, 333, 333, 333, 333, 333, 333, 465, 722, 333, 853, 906, 474, 825, 927, 838, 278, 722, 722, 601, 719, 667, 611, 722, 778, 278, 722, 667, 833, 722, 644, 778, 722, 667, 600, 611, 667, 821, 667, 809, 802, 278, 667, 615, 451, 611, 278, 582, 615, 610, 556, 606, 475, 460, 611, 541, 278, 558, 556, 612, 556, 445, 611, 766, 619, 520, 684, 446, 582, 715, 576, 753, 845, 278, 582, 611, 582, 845, 667, 669, 885, 567, 711, 667, 278, 276, 556, 1094, 1062, 875, 610, 722, 622, 719, 722, 719, 722, 567, 712, 667, 904, 626, 719, 719, 610, 702, 833, 722, 778, 719, 667, 722, 611, 622, 854, 667, 730, 703, 1005, 1019, 870, 979, 719, 711, 1031, 719, 556, 618, 615, 417, 635, 556, 709, 497, 615, 615, 500, 635, 740, 604, 611, 604, 611, 556, 490, 556, 875, 556, 615, 581, 833, 844, 729, 854, 615, 552, 854, 583, 556, 556, 611, 417, 552, 556, 278, 281, 278, 969, 906, 611, 500, 615, 556, 604, 778, 611, 487, 447, 944, 778, 944, 778, 944, 778, 667, 556, 333, 333, 556, 1e3, 1e3, 552, 278, 278, 278, 278, 500, 500, 500, 556, 556, 350, 1e3, 1e3, 240, 479, 333, 333, 604, 333, 167, 396, 556, 556, 1094, 556, 885, 489, 1115, 1e3, 768, 600, 834, 834, 834, 834, 1e3, 500, 1e3, 500, 1e3, 500, 500, 494, 612, 823, 713, 584, 549, 713, 979, 722, 274, 549, 549, 583, 549, 549, 604, 584, 604, 604, 708, 625, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 729, 604, 604, 354, 354, 1e3, 990, 990, 990, 990, 494, 604, 604, 604, 604, 354, 1021, 1052, 917, 750, 750, 531, 656, 594, 510, 500, 750, 750, 611, 611, 333, 333, 333, 333, 333, 333, 333, 333, 222, 222, 333, 333, 333, 333, 333, 333, 333, 333];
              exports3.LiberationSansBoldWidths = LiberationSansBoldWidths;
              const LiberationSansBoldMapping = [-1, -1, -1, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250, 251, 252, 253, 254, 255, 256, 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284, 285, 286, 287, 288, 289, 290, 291, 292, 293, 294, 295, 296, 297, 298, 299, 300, 301, 302, 303, 304, 305, 306, 307, 308, 309, 310, 311, 312, 313, 314, 315, 316, 317, 318, 319, 320, 321, 322, 323, 324, 325, 326, 327, 328, 329, 330, 331, 332, 333, 334, 335, 336, 337, 338, 339, 340, 341, 342, 343, 344, 345, 346, 347, 348, 349, 350, 351, 352, 353, 354, 355, 356, 357, 358, 359, 360, 361, 362, 363, 364, 365, 366, 367, 368, 369, 370, 371, 372, 373, 374, 375, 376, 377, 378, 379, 380, 381, 382, 383, 402, 506, 507, 508, 509, 510, 511, 536, 537, 538, 539, 710, 711, 713, 728, 729, 730, 731, 732, 733, 900, 901, 902, 903, 904, 905, 906, 908, 910, 911, 912, 913, 914, 915, 916, 917, 918, 919, 920, 921, 922, 923, 924, 925, 926, 927, 928, 929, 931, 932, 933, 934, 935, 936, 937, 938, 939, 940, 941, 942, 943, 944, 945, 946, 947, 948, 949, 950, 951, 952, 953, 954, 955, 956, 957, 958, 959, 960, 961, 962, 963, 964, 965, 966, 967, 968, 969, 970, 971, 972, 973, 974, 1024, 1025, 1026, 1027, 1028, 1029, 1030, 1031, 1032, 1033, 1034, 1035, 1036, 1037, 1038, 1039, 1040, 1041, 1042, 1043, 1044, 1045, 1046, 1047, 1048, 1049, 1050, 1051, 1052, 1053, 1054, 1055, 1056, 1057, 1058, 1059, 1060, 1061, 1062, 1063, 1064, 1065, 1066, 1067, 1068, 1069, 1070, 1071, 1072, 1073, 1074, 1075, 1076, 1077, 1078, 1079, 1080, 1081, 1082, 1083, 1084, 1085, 1086, 1087, 1088, 1089, 1090, 1091, 1092, 1093, 1094, 1095, 1096, 1097, 1098, 1099, 1100, 1101, 1102, 1103, 1104, 1105, 1106, 1107, 1108, 1109, 1110, 1111, 1112, 1113, 1114, 1115, 1116, 1117, 1118, 1119, 1138, 1139, 1168, 1169, 7808, 7809, 7810, 7811, 7812, 7813, 7922, 7923, 8208, 8209, 8211, 8212, 8213, 8215, 8216, 8217, 8218, 8219, 8220, 8221, 8222, 8224, 8225, 8226, 8230, 8240, 8242, 8243, 8249, 8250, 8252, 8254, 8260, 8319, 8355, 8356, 8359, 8364, 8453, 8467, 8470, 8482, 8486, 8494, 8539, 8540, 8541, 8542, 8592, 8593, 8594, 8595, 8596, 8597, 8616, 8706, 8710, 8719, 8721, 8722, 8730, 8734, 8735, 8745, 8747, 8776, 8800, 8801, 8804, 8805, 8962, 8976, 8992, 8993, 9472, 9474, 9484, 9488, 9492, 9496, 9500, 9508, 9516, 9524, 9532, 9552, 9553, 9554, 9555, 9556, 9557, 9558, 9559, 9560, 9561, 9562, 9563, 9564, 9565, 9566, 9567, 9568, 9569, 9570, 9571, 9572, 9573, 9574, 9575, 9576, 9577, 9578, 9579, 9580, 9600, 9604, 9608, 9612, 9616, 9617, 9618, 9619, 9632, 9633, 9642, 9643, 9644, 9650, 9658, 9660, 9668, 9674, 9675, 9679, 9688, 9689, 9702, 9786, 9787, 9788, 9792, 9794, 9824, 9827, 9829, 9830, 9834, 9835, 9836, 61441, 61442, 61445, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1];
              exports3.LiberationSansBoldMapping = LiberationSansBoldMapping;
              const LiberationSansBoldItalicWidths = [365, 0, 333, 278, 333, 474, 556, 556, 889, 722, 238, 333, 333, 389, 584, 278, 333, 278, 278, 556, 556, 556, 556, 556, 556, 556, 556, 556, 556, 333, 333, 584, 584, 584, 611, 975, 722, 722, 722, 722, 667, 611, 778, 722, 278, 556, 722, 611, 833, 722, 778, 667, 778, 722, 667, 611, 722, 667, 944, 667, 667, 611, 333, 278, 333, 584, 556, 333, 556, 611, 556, 611, 556, 333, 611, 611, 278, 278, 556, 278, 889, 611, 611, 611, 611, 389, 556, 333, 611, 556, 778, 556, 556, 500, 389, 280, 389, 584, 333, 556, 556, 556, 556, 280, 556, 333, 737, 370, 556, 584, 737, 552, 400, 549, 333, 333, 333, 576, 556, 278, 333, 333, 365, 556, 834, 834, 834, 611, 722, 722, 722, 722, 722, 722, 1e3, 722, 667, 667, 667, 667, 278, 278, 278, 278, 722, 722, 778, 778, 778, 778, 778, 584, 778, 722, 722, 722, 722, 667, 667, 611, 556, 556, 556, 556, 556, 556, 889, 556, 556, 556, 556, 556, 278, 278, 278, 278, 611, 611, 611, 611, 611, 611, 611, 549, 611, 611, 611, 611, 611, 556, 611, 556, 722, 556, 722, 556, 722, 556, 722, 556, 722, 556, 722, 556, 722, 556, 722, 740, 722, 611, 667, 556, 667, 556, 667, 556, 667, 556, 667, 556, 778, 611, 778, 611, 778, 611, 778, 611, 722, 611, 722, 611, 278, 278, 278, 278, 278, 278, 278, 278, 278, 278, 782, 556, 556, 278, 722, 556, 556, 611, 278, 611, 278, 611, 396, 611, 479, 611, 278, 722, 611, 722, 611, 722, 611, 708, 723, 611, 778, 611, 778, 611, 778, 611, 1e3, 944, 722, 389, 722, 389, 722, 389, 667, 556, 667, 556, 667, 556, 667, 556, 611, 333, 611, 479, 611, 333, 722, 611, 722, 611, 722, 611, 722, 611, 722, 611, 722, 611, 944, 778, 667, 556, 667, 611, 500, 611, 500, 611, 500, 278, 556, 722, 556, 1e3, 889, 778, 611, 667, 556, 611, 333, 333, 333, 333, 333, 333, 333, 333, 333, 333, 333, 333, 722, 333, 854, 906, 473, 844, 930, 847, 278, 722, 722, 610, 671, 667, 611, 722, 778, 278, 722, 667, 833, 722, 657, 778, 718, 667, 590, 611, 667, 822, 667, 829, 781, 278, 667, 620, 479, 611, 278, 591, 620, 621, 556, 610, 479, 492, 611, 558, 278, 566, 556, 603, 556, 450, 611, 712, 605, 532, 664, 409, 591, 704, 578, 773, 834, 278, 591, 611, 591, 834, 667, 667, 886, 614, 719, 667, 278, 278, 556, 1094, 1042, 854, 622, 719, 677, 719, 722, 708, 722, 614, 722, 667, 927, 643, 719, 719, 615, 687, 833, 722, 778, 719, 667, 722, 611, 677, 781, 667, 729, 708, 979, 989, 854, 1e3, 708, 719, 1042, 729, 556, 619, 604, 534, 618, 556, 736, 510, 611, 611, 507, 622, 740, 604, 611, 611, 611, 556, 889, 556, 885, 556, 646, 583, 889, 935, 707, 854, 594, 552, 865, 589, 556, 556, 611, 469, 563, 556, 278, 278, 278, 969, 906, 611, 507, 619, 556, 611, 778, 611, 575, 467, 944, 778, 944, 778, 944, 778, 667, 556, 333, 333, 556, 1e3, 1e3, 552, 278, 278, 278, 278, 500, 500, 500, 556, 556, 350, 1e3, 1e3, 240, 479, 333, 333, 604, 333, 167, 396, 556, 556, 1104, 556, 885, 516, 1146, 1e3, 768, 600, 834, 834, 834, 834, 999, 500, 1e3, 500, 1e3, 500, 500, 494, 612, 823, 713, 584, 549, 713, 979, 722, 274, 549, 549, 583, 549, 549, 604, 584, 604, 604, 708, 625, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 729, 604, 604, 354, 354, 1e3, 990, 990, 990, 990, 494, 604, 604, 604, 604, 354, 1021, 1052, 917, 750, 750, 531, 656, 594, 510, 500, 750, 750, 611, 611, 333, 333, 333, 333, 333, 333, 333, 333, 222, 222, 333, 333, 333, 333, 333, 333, 333, 333];
              exports3.LiberationSansBoldItalicWidths = LiberationSansBoldItalicWidths;
              const LiberationSansBoldItalicMapping = [-1, -1, -1, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250, 251, 252, 253, 254, 255, 256, 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284, 285, 286, 287, 288, 289, 290, 291, 292, 293, 294, 295, 296, 297, 298, 299, 300, 301, 302, 303, 304, 305, 306, 307, 308, 309, 310, 311, 312, 313, 314, 315, 316, 317, 318, 319, 320, 321, 322, 323, 324, 325, 326, 327, 328, 329, 330, 331, 332, 333, 334, 335, 336, 337, 338, 339, 340, 341, 342, 343, 344, 345, 346, 347, 348, 349, 350, 351, 352, 353, 354, 355, 356, 357, 358, 359, 360, 361, 362, 363, 364, 365, 366, 367, 368, 369, 370, 371, 372, 373, 374, 375, 376, 377, 378, 379, 380, 381, 382, 383, 402, 506, 507, 508, 509, 510, 511, 536, 537, 538, 539, 710, 711, 713, 728, 729, 730, 731, 732, 733, 900, 901, 902, 903, 904, 905, 906, 908, 910, 911, 912, 913, 914, 915, 916, 917, 918, 919, 920, 921, 922, 923, 924, 925, 926, 927, 928, 929, 931, 932, 933, 934, 935, 936, 937, 938, 939, 940, 941, 942, 943, 944, 945, 946, 947, 948, 949, 950, 951, 952, 953, 954, 955, 956, 957, 958, 959, 960, 961, 962, 963, 964, 965, 966, 967, 968, 969, 970, 971, 972, 973, 974, 1024, 1025, 1026, 1027, 1028, 1029, 1030, 1031, 1032, 1033, 1034, 1035, 1036, 1037, 1038, 1039, 1040, 1041, 1042, 1043, 1044, 1045, 1046, 1047, 1048, 1049, 1050, 1051, 1052, 1053, 1054, 1055, 1056, 1057, 1058, 1059, 1060, 1061, 1062, 1063, 1064, 1065, 1066, 1067, 1068, 1069, 1070, 1071, 1072, 1073, 1074, 1075, 1076, 1077, 1078, 1079, 1080, 1081, 1082, 1083, 1084, 1085, 1086, 1087, 1088, 1089, 1090, 1091, 1092, 1093, 1094, 1095, 1096, 1097, 1098, 1099, 1100, 1101, 1102, 1103, 1104, 1105, 1106, 1107, 1108, 1109, 1110, 1111, 1112, 1113, 1114, 1115, 1116, 1117, 1118, 1119, 1138, 1139, 1168, 1169, 7808, 7809, 7810, 7811, 7812, 7813, 7922, 7923, 8208, 8209, 8211, 8212, 8213, 8215, 8216, 8217, 8218, 8219, 8220, 8221, 8222, 8224, 8225, 8226, 8230, 8240, 8242, 8243, 8249, 8250, 8252, 8254, 8260, 8319, 8355, 8356, 8359, 8364, 8453, 8467, 8470, 8482, 8486, 8494, 8539, 8540, 8541, 8542, 8592, 8593, 8594, 8595, 8596, 8597, 8616, 8706, 8710, 8719, 8721, 8722, 8730, 8734, 8735, 8745, 8747, 8776, 8800, 8801, 8804, 8805, 8962, 8976, 8992, 8993, 9472, 9474, 9484, 9488, 9492, 9496, 9500, 9508, 9516, 9524, 9532, 9552, 9553, 9554, 9555, 9556, 9557, 9558, 9559, 9560, 9561, 9562, 9563, 9564, 9565, 9566, 9567, 9568, 9569, 9570, 9571, 9572, 9573, 9574, 9575, 9576, 9577, 9578, 9579, 9580, 9600, 9604, 9608, 9612, 9616, 9617, 9618, 9619, 9632, 9633, 9642, 9643, 9644, 9650, 9658, 9660, 9668, 9674, 9675, 9679, 9688, 9689, 9702, 9786, 9787, 9788, 9792, 9794, 9824, 9827, 9829, 9830, 9834, 9835, 9836, 61441, 61442, 61445, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1];
              exports3.LiberationSansBoldItalicMapping = LiberationSansBoldItalicMapping;
              const LiberationSansItalicWidths = [365, 0, 333, 278, 278, 355, 556, 556, 889, 667, 191, 333, 333, 389, 584, 278, 333, 278, 278, 556, 556, 556, 556, 556, 556, 556, 556, 556, 556, 278, 278, 584, 584, 584, 556, 1015, 667, 667, 722, 722, 667, 611, 778, 722, 278, 500, 667, 556, 833, 722, 778, 667, 778, 722, 667, 611, 722, 667, 944, 667, 667, 611, 278, 278, 278, 469, 556, 333, 556, 556, 500, 556, 556, 278, 556, 556, 222, 222, 500, 222, 833, 556, 556, 556, 556, 333, 500, 278, 556, 500, 722, 500, 500, 500, 334, 260, 334, 584, 333, 556, 556, 556, 556, 260, 556, 333, 737, 370, 556, 584, 737, 552, 400, 549, 333, 333, 333, 576, 537, 278, 333, 333, 365, 556, 834, 834, 834, 611, 667, 667, 667, 667, 667, 667, 1e3, 722, 667, 667, 667, 667, 278, 278, 278, 278, 722, 722, 778, 778, 778, 778, 778, 584, 778, 722, 722, 722, 722, 667, 667, 611, 556, 556, 556, 556, 556, 556, 889, 500, 556, 556, 556, 556, 278, 278, 278, 278, 556, 556, 556, 556, 556, 556, 556, 549, 611, 556, 556, 556, 556, 500, 556, 500, 667, 556, 667, 556, 667, 556, 722, 500, 722, 500, 722, 500, 722, 500, 722, 625, 722, 556, 667, 556, 667, 556, 667, 556, 667, 556, 667, 556, 778, 556, 778, 556, 778, 556, 778, 556, 722, 556, 722, 556, 278, 278, 278, 278, 278, 278, 278, 222, 278, 278, 733, 444, 500, 222, 667, 500, 500, 556, 222, 556, 222, 556, 281, 556, 400, 556, 222, 722, 556, 722, 556, 722, 556, 615, 723, 556, 778, 556, 778, 556, 778, 556, 1e3, 944, 722, 333, 722, 333, 722, 333, 667, 500, 667, 500, 667, 500, 667, 500, 611, 278, 611, 354, 611, 278, 722, 556, 722, 556, 722, 556, 722, 556, 722, 556, 722, 556, 944, 722, 667, 500, 667, 611, 500, 611, 500, 611, 500, 222, 556, 667, 556, 1e3, 889, 778, 611, 667, 500, 611, 278, 333, 333, 333, 333, 333, 333, 333, 333, 333, 333, 333, 667, 278, 789, 846, 389, 794, 865, 775, 222, 667, 667, 570, 671, 667, 611, 722, 778, 278, 667, 667, 833, 722, 648, 778, 725, 667, 600, 611, 667, 837, 667, 831, 761, 278, 667, 570, 439, 555, 222, 550, 570, 571, 500, 556, 439, 463, 555, 542, 222, 500, 492, 548, 500, 447, 556, 670, 573, 486, 603, 374, 550, 652, 546, 728, 779, 222, 550, 556, 550, 779, 667, 667, 843, 544, 708, 667, 278, 278, 500, 1066, 982, 844, 589, 715, 639, 724, 667, 651, 667, 544, 704, 667, 917, 614, 715, 715, 589, 686, 833, 722, 778, 725, 667, 722, 611, 639, 795, 667, 727, 673, 920, 923, 805, 886, 651, 694, 1022, 682, 556, 562, 522, 493, 553, 556, 688, 465, 556, 556, 472, 564, 686, 550, 556, 556, 556, 500, 833, 500, 835, 500, 572, 518, 830, 851, 621, 736, 526, 492, 752, 534, 556, 556, 556, 378, 496, 500, 222, 222, 222, 910, 828, 556, 472, 565, 500, 556, 778, 556, 492, 339, 944, 722, 944, 722, 944, 722, 667, 500, 333, 333, 556, 1e3, 1e3, 552, 222, 222, 222, 222, 333, 333, 333, 556, 556, 350, 1e3, 1e3, 188, 354, 333, 333, 500, 333, 167, 365, 556, 556, 1094, 556, 885, 323, 1083, 1e3, 768, 600, 834, 834, 834, 834, 1e3, 500, 998, 500, 1e3, 500, 500, 494, 612, 823, 713, 584, 549, 713, 979, 719, 274, 549, 549, 584, 549, 549, 604, 584, 604, 604, 708, 625, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 729, 604, 604, 354, 354, 1e3, 990, 990, 990, 990, 494, 604, 604, 604, 604, 354, 1021, 1052, 917, 750, 750, 531, 656, 594, 510, 500, 750, 750, 500, 500, 333, 333, 333, 333, 333, 333, 333, 333, 222, 222, 294, 294, 324, 324, 316, 328, 398, 285];
              exports3.LiberationSansItalicWidths = LiberationSansItalicWidths;
              const LiberationSansItalicMapping = [-1, -1, -1, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250, 251, 252, 253, 254, 255, 256, 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284, 285, 286, 287, 288, 289, 290, 291, 292, 293, 294, 295, 296, 297, 298, 299, 300, 301, 302, 303, 304, 305, 306, 307, 308, 309, 310, 311, 312, 313, 314, 315, 316, 317, 318, 319, 320, 321, 322, 323, 324, 325, 326, 327, 328, 329, 330, 331, 332, 333, 334, 335, 336, 337, 338, 339, 340, 341, 342, 343, 344, 345, 346, 347, 348, 349, 350, 351, 352, 353, 354, 355, 356, 357, 358, 359, 360, 361, 362, 363, 364, 365, 366, 367, 368, 369, 370, 371, 372, 373, 374, 375, 376, 377, 378, 379, 380, 381, 382, 383, 402, 506, 507, 508, 509, 510, 511, 536, 537, 538, 539, 710, 711, 713, 728, 729, 730, 731, 732, 733, 900, 901, 902, 903, 904, 905, 906, 908, 910, 911, 912, 913, 914, 915, 916, 917, 918, 919, 920, 921, 922, 923, 924, 925, 926, 927, 928, 929, 931, 932, 933, 934, 935, 936, 937, 938, 939, 940, 941, 942, 943, 944, 945, 946, 947, 948, 949, 950, 951, 952, 953, 954, 955, 956, 957, 958, 959, 960, 961, 962, 963, 964, 965, 966, 967, 968, 969, 970, 971, 972, 973, 974, 1024, 1025, 1026, 1027, 1028, 1029, 1030, 1031, 1032, 1033, 1034, 1035, 1036, 1037, 1038, 1039, 1040, 1041, 1042, 1043, 1044, 1045, 1046, 1047, 1048, 1049, 1050, 1051, 1052, 1053, 1054, 1055, 1056, 1057, 1058, 1059, 1060, 1061, 1062, 1063, 1064, 1065, 1066, 1067, 1068, 1069, 1070, 1071, 1072, 1073, 1074, 1075, 1076, 1077, 1078, 1079, 1080, 1081, 1082, 1083, 1084, 1085, 1086, 1087, 1088, 1089, 1090, 1091, 1092, 1093, 1094, 1095, 1096, 1097, 1098, 1099, 1100, 1101, 1102, 1103, 1104, 1105, 1106, 1107, 1108, 1109, 1110, 1111, 1112, 1113, 1114, 1115, 1116, 1117, 1118, 1119, 1138, 1139, 1168, 1169, 7808, 7809, 7810, 7811, 7812, 7813, 7922, 7923, 8208, 8209, 8211, 8212, 8213, 8215, 8216, 8217, 8218, 8219, 8220, 8221, 8222, 8224, 8225, 8226, 8230, 8240, 8242, 8243, 8249, 8250, 8252, 8254, 8260, 8319, 8355, 8356, 8359, 8364, 8453, 8467, 8470, 8482, 8486, 8494, 8539, 8540, 8541, 8542, 8592, 8593, 8594, 8595, 8596, 8597, 8616, 8706, 8710, 8719, 8721, 8722, 8730, 8734, 8735, 8745, 8747, 8776, 8800, 8801, 8804, 8805, 8962, 8976, 8992, 8993, 9472, 9474, 9484, 9488, 9492, 9496, 9500, 9508, 9516, 9524, 9532, 9552, 9553, 9554, 9555, 9556, 9557, 9558, 9559, 9560, 9561, 9562, 9563, 9564, 9565, 9566, 9567, 9568, 9569, 9570, 9571, 9572, 9573, 9574, 9575, 9576, 9577, 9578, 9579, 9580, 9600, 9604, 9608, 9612, 9616, 9617, 9618, 9619, 9632, 9633, 9642, 9643, 9644, 9650, 9658, 9660, 9668, 9674, 9675, 9679, 9688, 9689, 9702, 9786, 9787, 9788, 9792, 9794, 9824, 9827, 9829, 9830, 9834, 9835, 9836, 61441, 61442, 61445, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1];
              exports3.LiberationSansItalicMapping = LiberationSansItalicMapping;
              const LiberationSansRegularWidths = [365, 0, 333, 278, 278, 355, 556, 556, 889, 667, 191, 333, 333, 389, 584, 278, 333, 278, 278, 556, 556, 556, 556, 556, 556, 556, 556, 556, 556, 278, 278, 584, 584, 584, 556, 1015, 667, 667, 722, 722, 667, 611, 778, 722, 278, 500, 667, 556, 833, 722, 778, 667, 778, 722, 667, 611, 722, 667, 944, 667, 667, 611, 278, 278, 278, 469, 556, 333, 556, 556, 500, 556, 556, 278, 556, 556, 222, 222, 500, 222, 833, 556, 556, 556, 556, 333, 500, 278, 556, 500, 722, 500, 500, 500, 334, 260, 334, 584, 333, 556, 556, 556, 556, 260, 556, 333, 737, 370, 556, 584, 737, 552, 400, 549, 333, 333, 333, 576, 537, 278, 333, 333, 365, 556, 834, 834, 834, 611, 667, 667, 667, 667, 667, 667, 1e3, 722, 667, 667, 667, 667, 278, 278, 278, 278, 722, 722, 778, 778, 778, 778, 778, 584, 778, 722, 722, 722, 722, 667, 667, 611, 556, 556, 556, 556, 556, 556, 889, 500, 556, 556, 556, 556, 278, 278, 278, 278, 556, 556, 556, 556, 556, 556, 556, 549, 611, 556, 556, 556, 556, 500, 556, 500, 667, 556, 667, 556, 667, 556, 722, 500, 722, 500, 722, 500, 722, 500, 722, 615, 722, 556, 667, 556, 667, 556, 667, 556, 667, 556, 667, 556, 778, 556, 778, 556, 778, 556, 778, 556, 722, 556, 722, 556, 278, 278, 278, 278, 278, 278, 278, 222, 278, 278, 735, 444, 500, 222, 667, 500, 500, 556, 222, 556, 222, 556, 292, 556, 334, 556, 222, 722, 556, 722, 556, 722, 556, 604, 723, 556, 778, 556, 778, 556, 778, 556, 1e3, 944, 722, 333, 722, 333, 722, 333, 667, 500, 667, 500, 667, 500, 667, 500, 611, 278, 611, 375, 611, 278, 722, 556, 722, 556, 722, 556, 722, 556, 722, 556, 722, 556, 944, 722, 667, 500, 667, 611, 500, 611, 500, 611, 500, 222, 556, 667, 556, 1e3, 889, 778, 611, 667, 500, 611, 278, 333, 333, 333, 333, 333, 333, 333, 333, 333, 333, 333, 667, 278, 784, 838, 384, 774, 855, 752, 222, 667, 667, 551, 668, 667, 611, 722, 778, 278, 667, 668, 833, 722, 650, 778, 722, 667, 618, 611, 667, 798, 667, 835, 748, 278, 667, 578, 446, 556, 222, 547, 578, 575, 500, 557, 446, 441, 556, 556, 222, 500, 500, 576, 500, 448, 556, 690, 569, 482, 617, 395, 547, 648, 525, 713, 781, 222, 547, 556, 547, 781, 667, 667, 865, 542, 719, 667, 278, 278, 500, 1057, 1010, 854, 583, 722, 635, 719, 667, 656, 667, 542, 677, 667, 923, 604, 719, 719, 583, 656, 833, 722, 778, 719, 667, 722, 611, 635, 760, 667, 740, 667, 917, 938, 792, 885, 656, 719, 1010, 722, 556, 573, 531, 365, 583, 556, 669, 458, 559, 559, 438, 583, 688, 552, 556, 542, 556, 500, 458, 500, 823, 500, 573, 521, 802, 823, 625, 719, 521, 510, 750, 542, 556, 556, 556, 365, 510, 500, 222, 278, 222, 906, 812, 556, 438, 559, 500, 552, 778, 556, 489, 411, 944, 722, 944, 722, 944, 722, 667, 500, 333, 333, 556, 1e3, 1e3, 552, 222, 222, 222, 222, 333, 333, 333, 556, 556, 350, 1e3, 1e3, 188, 354, 333, 333, 500, 333, 167, 365, 556, 556, 1094, 556, 885, 323, 1073, 1e3, 768, 600, 834, 834, 834, 834, 1e3, 500, 1e3, 500, 1e3, 500, 500, 494, 612, 823, 713, 584, 549, 713, 979, 719, 274, 549, 549, 583, 549, 549, 604, 584, 604, 604, 708, 625, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 729, 604, 604, 354, 354, 1e3, 990, 990, 990, 990, 494, 604, 604, 604, 604, 354, 1021, 1052, 917, 750, 750, 531, 656, 594, 510, 500, 750, 750, 500, 500, 333, 333, 333, 333, 333, 333, 333, 333, 222, 222, 294, 294, 324, 324, 316, 328, 398, 285];
              exports3.LiberationSansRegularWidths = LiberationSansRegularWidths;
              const LiberationSansRegularMapping = [-1, -1, -1, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250, 251, 252, 253, 254, 255, 256, 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284, 285, 286, 287, 288, 289, 290, 291, 292, 293, 294, 295, 296, 297, 298, 299, 300, 301, 302, 303, 304, 305, 306, 307, 308, 309, 310, 311, 312, 313, 314, 315, 316, 317, 318, 319, 320, 321, 322, 323, 324, 325, 326, 327, 328, 329, 330, 331, 332, 333, 334, 335, 336, 337, 338, 339, 340, 341, 342, 343, 344, 345, 346, 347, 348, 349, 350, 351, 352, 353, 354, 355, 356, 357, 358, 359, 360, 361, 362, 363, 364, 365, 366, 367, 368, 369, 370, 371, 372, 373, 374, 375, 376, 377, 378, 379, 380, 381, 382, 383, 402, 506, 507, 508, 509, 510, 511, 536, 537, 538, 539, 710, 711, 713, 728, 729, 730, 731, 732, 733, 900, 901, 902, 903, 904, 905, 906, 908, 910, 911, 912, 913, 914, 915, 916, 917, 918, 919, 920, 921, 922, 923, 924, 925, 926, 927, 928, 929, 931, 932, 933, 934, 935, 936, 937, 938, 939, 940, 941, 942, 943, 944, 945, 946, 947, 948, 949, 950, 951, 952, 953, 954, 955, 956, 957, 958, 959, 960, 961, 962, 963, 964, 965, 966, 967, 968, 969, 970, 971, 972, 973, 974, 1024, 1025, 1026, 1027, 1028, 1029, 1030, 1031, 1032, 1033, 1034, 1035, 1036, 1037, 1038, 1039, 1040, 1041, 1042, 1043, 1044, 1045, 1046, 1047, 1048, 1049, 1050, 1051, 1052, 1053, 1054, 1055, 1056, 1057, 1058, 1059, 1060, 1061, 1062, 1063, 1064, 1065, 1066, 1067, 1068, 1069, 1070, 1071, 1072, 1073, 1074, 1075, 1076, 1077, 1078, 1079, 1080, 1081, 1082, 1083, 1084, 1085, 1086, 1087, 1088, 1089, 1090, 1091, 1092, 1093, 1094, 1095, 1096, 1097, 1098, 1099, 1100, 1101, 1102, 1103, 1104, 1105, 1106, 1107, 1108, 1109, 1110, 1111, 1112, 1113, 1114, 1115, 1116, 1117, 1118, 1119, 1138, 1139, 1168, 1169, 7808, 7809, 7810, 7811, 7812, 7813, 7922, 7923, 8208, 8209, 8211, 8212, 8213, 8215, 8216, 8217, 8218, 8219, 8220, 8221, 8222, 8224, 8225, 8226, 8230, 8240, 8242, 8243, 8249, 8250, 8252, 8254, 8260, 8319, 8355, 8356, 8359, 8364, 8453, 8467, 8470, 8482, 8486, 8494, 8539, 8540, 8541, 8542, 8592, 8593, 8594, 8595, 8596, 8597, 8616, 8706, 8710, 8719, 8721, 8722, 8730, 8734, 8735, 8745, 8747, 8776, 8800, 8801, 8804, 8805, 8962, 8976, 8992, 8993, 9472, 9474, 9484, 9488, 9492, 9496, 9500, 9508, 9516, 9524, 9532, 9552, 9553, 9554, 9555, 9556, 9557, 9558, 9559, 9560, 9561, 9562, 9563, 9564, 9565, 9566, 9567, 9568, 9569, 9570, 9571, 9572, 9573, 9574, 9575, 9576, 9577, 9578, 9579, 9580, 9600, 9604, 9608, 9612, 9616, 9617, 9618, 9619, 9632, 9633, 9642, 9643, 9644, 9650, 9658, 9660, 9668, 9674, 9675, 9679, 9688, 9689, 9702, 9786, 9787, 9788, 9792, 9794, 9824, 9827, 9829, 9830, 9834, 9835, 9836, 61441, 61442, 61445, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1];
              exports3.LiberationSansRegularMapping = LiberationSansRegularMapping;
            }),
            /* 55 */
            /***/
            ((__unused_webpack_module2, exports3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.MyriadProRegularMetrics = exports3.MyriadProRegularFactors = exports3.MyriadProItalicMetrics = exports3.MyriadProItalicFactors = exports3.MyriadProBoldMetrics = exports3.MyriadProBoldItalicMetrics = exports3.MyriadProBoldItalicFactors = exports3.MyriadProBoldFactors = void 0;
              const MyriadProBoldFactors = [1.36898, 1, 1, 0.72706, 0.80479, 0.83734, 0.98894, 0.99793, 0.9897, 0.93884, 0.86209, 0.94292, 0.94292, 1.16661, 1.02058, 0.93582, 0.96694, 0.93582, 1.19137, 0.99793, 0.99793, 0.99793, 0.99793, 0.99793, 0.99793, 0.99793, 0.99793, 0.99793, 0.99793, 0.78076, 0.78076, 1.02058, 1.02058, 1.02058, 0.72851, 0.78966, 0.90838, 0.83637, 0.82391, 0.96376, 0.80061, 0.86275, 0.8768, 0.95407, 1.0258, 0.73901, 0.85022, 0.83655, 1.0156, 0.95546, 0.92179, 0.87107, 0.92179, 0.82114, 0.8096, 0.89713, 0.94438, 0.95353, 0.94083, 0.91905, 0.90406, 0.9446, 0.94292, 1.18777, 0.94292, 1.02058, 0.89903, 0.90088, 0.94938, 0.97898, 0.81093, 0.97571, 0.94938, 1.024, 0.9577, 0.95933, 0.98621, 1.0474, 0.97455, 0.98981, 0.9672, 0.95933, 0.9446, 0.97898, 0.97407, 0.97646, 0.78036, 1.10208, 0.95442, 0.95298, 0.97579, 0.9332, 0.94039, 0.938, 0.80687, 1.01149, 0.80687, 1.02058, 0.80479, 0.99793, 0.99793, 0.99793, 0.99793, 1.01149, 1.00872, 0.90088, 0.91882, 1.0213, 0.8361, 1.02058, 0.62295, 0.54324, 0.89022, 1.08595, 1, 1, 0.90088, 1, 0.97455, 0.93582, 0.90088, 1, 1.05686, 0.8361, 0.99642, 0.99642, 0.99642, 0.72851, 0.90838, 0.90838, 0.90838, 0.90838, 0.90838, 0.90838, 0.868, 0.82391, 0.80061, 0.80061, 0.80061, 0.80061, 1.0258, 1.0258, 1.0258, 1.0258, 0.97484, 0.95546, 0.92179, 0.92179, 0.92179, 0.92179, 0.92179, 1.02058, 0.92179, 0.94438, 0.94438, 0.94438, 0.94438, 0.90406, 0.86958, 0.98225, 0.94938, 0.94938, 0.94938, 0.94938, 0.94938, 0.94938, 0.9031, 0.81093, 0.94938, 0.94938, 0.94938, 0.94938, 0.98621, 0.98621, 0.98621, 0.98621, 0.93969, 0.95933, 0.9446, 0.9446, 0.9446, 0.9446, 0.9446, 1.08595, 0.9446, 0.95442, 0.95442, 0.95442, 0.95442, 0.94039, 0.97898, 0.94039, 0.90838, 0.94938, 0.90838, 0.94938, 0.90838, 0.94938, 0.82391, 0.81093, 0.82391, 0.81093, 0.82391, 0.81093, 0.82391, 0.81093, 0.96376, 0.84313, 0.97484, 0.97571, 0.80061, 0.94938, 0.80061, 0.94938, 0.80061, 0.94938, 0.80061, 0.94938, 0.80061, 0.94938, 0.8768, 0.9577, 0.8768, 0.9577, 0.8768, 0.9577, 1, 1, 0.95407, 0.95933, 0.97069, 0.95933, 1.0258, 0.98621, 1.0258, 0.98621, 1.0258, 0.98621, 1.0258, 0.98621, 1.0258, 0.98621, 0.887, 1.01591, 0.73901, 1.0474, 1, 1, 0.97455, 0.83655, 0.98981, 1, 1, 0.83655, 0.73977, 0.83655, 0.73903, 0.84638, 1.033, 0.95546, 0.95933, 1, 1, 0.95546, 0.95933, 0.8271, 0.95417, 0.95933, 0.92179, 0.9446, 0.92179, 0.9446, 0.92179, 0.9446, 0.936, 0.91964, 0.82114, 0.97646, 1, 1, 0.82114, 0.97646, 0.8096, 0.78036, 0.8096, 0.78036, 1, 1, 0.8096, 0.78036, 1, 1, 0.89713, 0.77452, 0.89713, 1.10208, 0.94438, 0.95442, 0.94438, 0.95442, 0.94438, 0.95442, 0.94438, 0.95442, 0.94438, 0.95442, 0.94438, 0.95442, 0.94083, 0.97579, 0.90406, 0.94039, 0.90406, 0.9446, 0.938, 0.9446, 0.938, 0.9446, 0.938, 1, 0.99793, 0.90838, 0.94938, 0.868, 0.9031, 0.92179, 0.9446, 1, 1, 0.89713, 1.10208, 0.90088, 0.90088, 0.90088, 0.90088, 0.90088, 0.90088, 0.90088, 0.90088, 0.90088, 0.90989, 0.9358, 0.91945, 0.83181, 0.75261, 0.87992, 0.82976, 0.96034, 0.83689, 0.97268, 1.0078, 0.90838, 0.83637, 0.8019, 0.90157, 0.80061, 0.9446, 0.95407, 0.92436, 1.0258, 0.85022, 0.97153, 1.0156, 0.95546, 0.89192, 0.92179, 0.92361, 0.87107, 0.96318, 0.89713, 0.93704, 0.95638, 0.91905, 0.91709, 0.92796, 1.0258, 0.93704, 0.94836, 1.0373, 0.95933, 1.0078, 0.95871, 0.94836, 0.96174, 0.92601, 0.9498, 0.98607, 0.95776, 0.95933, 1.05453, 1.0078, 0.98275, 0.9314, 0.95617, 0.91701, 1.05993, 0.9446, 0.78367, 0.9553, 1, 0.86832, 1.0128, 0.95871, 0.99394, 0.87548, 0.96361, 0.86774, 1.0078, 0.95871, 0.9446, 0.95871, 0.86774, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.94083, 0.97579, 0.94083, 0.97579, 0.94083, 0.97579, 0.90406, 0.94039, 0.96694, 1, 0.89903, 1, 1, 1, 0.93582, 0.93582, 0.93582, 1, 0.908, 0.908, 0.918, 0.94219, 0.94219, 0.96544, 1, 1.285, 1, 1, 0.81079, 0.81079, 1, 1, 0.74854, 1, 1, 1, 1, 0.99793, 1, 1, 1, 0.65, 1, 1.36145, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.17173, 1, 0.80535, 0.76169, 1.02058, 1.0732, 1.05486, 1, 1, 1.30692, 1.08595, 1.08595, 1, 1.08595, 1.08595, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.16161, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
              exports3.MyriadProBoldFactors = MyriadProBoldFactors;
              const MyriadProBoldMetrics = {
                lineHeight: 1.2,
                lineGap: 0.2
              };
              exports3.MyriadProBoldMetrics = MyriadProBoldMetrics;
              const MyriadProBoldItalicFactors = [1.36898, 1, 1, 0.66227, 0.80779, 0.81625, 0.97276, 0.97276, 0.97733, 0.92222, 0.83266, 0.94292, 0.94292, 1.16148, 1.02058, 0.93582, 0.96694, 0.93582, 1.17337, 0.97276, 0.97276, 0.97276, 0.97276, 0.97276, 0.97276, 0.97276, 0.97276, 0.97276, 0.97276, 0.78076, 0.78076, 1.02058, 1.02058, 1.02058, 0.71541, 0.76813, 0.85576, 0.80591, 0.80729, 0.94299, 0.77512, 0.83655, 0.86523, 0.92222, 0.98621, 0.71743, 0.81698, 0.79726, 0.98558, 0.92222, 0.90637, 0.83809, 0.90637, 0.80729, 0.76463, 0.86275, 0.90699, 0.91605, 0.9154, 0.85308, 0.85458, 0.90531, 0.94292, 1.21296, 0.94292, 1.02058, 0.89903, 1.18616, 0.99613, 0.91677, 0.78216, 0.91677, 0.90083, 0.98796, 0.9135, 0.92168, 0.95381, 0.98981, 0.95298, 0.95381, 0.93459, 0.92168, 0.91513, 0.92004, 0.91677, 0.95077, 0.748, 1.04502, 0.91677, 0.92061, 0.94236, 0.89544, 0.89364, 0.9, 0.80687, 0.8578, 0.80687, 1.02058, 0.80779, 0.97276, 0.97276, 0.97276, 0.97276, 0.8578, 0.99973, 1.18616, 0.91339, 1.08074, 0.82891, 1.02058, 0.55509, 0.71526, 0.89022, 1.08595, 1, 1, 1.18616, 1, 0.96736, 0.93582, 1.18616, 1, 1.04864, 0.82711, 0.99043, 0.99043, 0.99043, 0.71541, 0.85576, 0.85576, 0.85576, 0.85576, 0.85576, 0.85576, 0.845, 0.80729, 0.77512, 0.77512, 0.77512, 0.77512, 0.98621, 0.98621, 0.98621, 0.98621, 0.95961, 0.92222, 0.90637, 0.90637, 0.90637, 0.90637, 0.90637, 1.02058, 0.90251, 0.90699, 0.90699, 0.90699, 0.90699, 0.85458, 0.83659, 0.94951, 0.99613, 0.99613, 0.99613, 0.99613, 0.99613, 0.99613, 0.85811, 0.78216, 0.90083, 0.90083, 0.90083, 0.90083, 0.95381, 0.95381, 0.95381, 0.95381, 0.9135, 0.92168, 0.91513, 0.91513, 0.91513, 0.91513, 0.91513, 1.08595, 0.91677, 0.91677, 0.91677, 0.91677, 0.91677, 0.89364, 0.92332, 0.89364, 0.85576, 0.99613, 0.85576, 0.99613, 0.85576, 0.99613, 0.80729, 0.78216, 0.80729, 0.78216, 0.80729, 0.78216, 0.80729, 0.78216, 0.94299, 0.76783, 0.95961, 0.91677, 0.77512, 0.90083, 0.77512, 0.90083, 0.77512, 0.90083, 0.77512, 0.90083, 0.77512, 0.90083, 0.86523, 0.9135, 0.86523, 0.9135, 0.86523, 0.9135, 1, 1, 0.92222, 0.92168, 0.92222, 0.92168, 0.98621, 0.95381, 0.98621, 0.95381, 0.98621, 0.95381, 0.98621, 0.95381, 0.98621, 0.95381, 0.86036, 0.97096, 0.71743, 0.98981, 1, 1, 0.95298, 0.79726, 0.95381, 1, 1, 0.79726, 0.6894, 0.79726, 0.74321, 0.81691, 1.0006, 0.92222, 0.92168, 1, 1, 0.92222, 0.92168, 0.79464, 0.92098, 0.92168, 0.90637, 0.91513, 0.90637, 0.91513, 0.90637, 0.91513, 0.909, 0.87514, 0.80729, 0.95077, 1, 1, 0.80729, 0.95077, 0.76463, 0.748, 0.76463, 0.748, 1, 1, 0.76463, 0.748, 1, 1, 0.86275, 0.72651, 0.86275, 1.04502, 0.90699, 0.91677, 0.90699, 0.91677, 0.90699, 0.91677, 0.90699, 0.91677, 0.90699, 0.91677, 0.90699, 0.91677, 0.9154, 0.94236, 0.85458, 0.89364, 0.85458, 0.90531, 0.9, 0.90531, 0.9, 0.90531, 0.9, 1, 0.97276, 0.85576, 0.99613, 0.845, 0.85811, 0.90251, 0.91677, 1, 1, 0.86275, 1.04502, 1.18616, 1.18616, 1.18616, 1.18616, 1.18616, 1.18616, 1.18616, 1.18616, 1.18616, 1.00899, 1.30628, 0.85576, 0.80178, 0.66862, 0.7927, 0.69323, 0.88127, 0.72459, 0.89711, 0.95381, 0.85576, 0.80591, 0.7805, 0.94729, 0.77512, 0.90531, 0.92222, 0.90637, 0.98621, 0.81698, 0.92655, 0.98558, 0.92222, 0.85359, 0.90637, 0.90976, 0.83809, 0.94523, 0.86275, 0.83509, 0.93157, 0.85308, 0.83392, 0.92346, 0.98621, 0.83509, 0.92886, 0.91324, 0.92168, 0.95381, 0.90646, 0.92886, 0.90557, 0.86847, 0.90276, 0.91324, 0.86842, 0.92168, 0.99531, 0.95381, 0.9224, 0.85408, 0.92699, 0.86847, 1.0051, 0.91513, 0.80487, 0.93481, 1, 0.88159, 1.05214, 0.90646, 0.97355, 0.81539, 0.89398, 0.85923, 0.95381, 0.90646, 0.91513, 0.90646, 0.85923, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.9154, 0.94236, 0.9154, 0.94236, 0.9154, 0.94236, 0.85458, 0.89364, 0.96694, 1, 0.89903, 1, 1, 1, 0.91782, 0.91782, 0.91782, 1, 0.896, 0.896, 0.896, 0.9332, 0.9332, 0.95973, 1, 1.26, 1, 1, 0.80479, 0.80178, 1, 1, 0.85633, 1, 1, 1, 1, 0.97276, 1, 1, 1, 0.698, 1, 1.36145, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.14542, 1, 0.79199, 0.78694, 1.02058, 1.03493, 1.05486, 1, 1, 1.23026, 1.08595, 1.08595, 1, 1.08595, 1.08595, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.20006, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
              exports3.MyriadProBoldItalicFactors = MyriadProBoldItalicFactors;
              const MyriadProBoldItalicMetrics = {
                lineHeight: 1.2,
                lineGap: 0.2
              };
              exports3.MyriadProBoldItalicMetrics = MyriadProBoldItalicMetrics;
              const MyriadProItalicFactors = [1.36898, 1, 1, 0.65507, 0.84943, 0.85639, 0.88465, 0.88465, 0.86936, 0.88307, 0.86948, 0.85283, 0.85283, 1.06383, 1.02058, 0.75945, 0.9219, 0.75945, 1.17337, 0.88465, 0.88465, 0.88465, 0.88465, 0.88465, 0.88465, 0.88465, 0.88465, 0.88465, 0.88465, 0.75945, 0.75945, 1.02058, 1.02058, 1.02058, 0.69046, 0.70926, 0.85158, 0.77812, 0.76852, 0.89591, 0.70466, 0.76125, 0.80094, 0.86822, 0.83864, 0.728, 0.77212, 0.79475, 0.93637, 0.87514, 0.8588, 0.76013, 0.8588, 0.72421, 0.69866, 0.77598, 0.85991, 0.80811, 0.87832, 0.78112, 0.77512, 0.8562, 1.0222, 1.18417, 1.0222, 1.27014, 0.89903, 1.15012, 0.93859, 0.94399, 0.846, 0.94399, 0.81453, 1.0186, 0.94219, 0.96017, 1.03075, 1.02175, 0.912, 1.03075, 0.96998, 0.96017, 0.93859, 0.94399, 0.94399, 0.95493, 0.746, 1.12658, 0.94578, 0.91, 0.979, 0.882, 0.882, 0.83, 0.85034, 0.83537, 0.85034, 1.02058, 0.70869, 0.88465, 0.88465, 0.88465, 0.88465, 0.83537, 0.90083, 1.15012, 0.9161, 0.94565, 0.73541, 1.02058, 0.53609, 0.69353, 0.79519, 1.08595, 1, 1, 1.15012, 1, 0.91974, 0.75945, 1.15012, 1, 0.9446, 0.73361, 0.9005, 0.9005, 0.9005, 0.62864, 0.85158, 0.85158, 0.85158, 0.85158, 0.85158, 0.85158, 0.773, 0.76852, 0.70466, 0.70466, 0.70466, 0.70466, 0.83864, 0.83864, 0.83864, 0.83864, 0.90561, 0.87514, 0.8588, 0.8588, 0.8588, 0.8588, 0.8588, 1.02058, 0.85751, 0.85991, 0.85991, 0.85991, 0.85991, 0.77512, 0.76013, 0.88075, 0.93859, 0.93859, 0.93859, 0.93859, 0.93859, 0.93859, 0.8075, 0.846, 0.81453, 0.81453, 0.81453, 0.81453, 0.82424, 0.82424, 0.82424, 0.82424, 0.9278, 0.96017, 0.93859, 0.93859, 0.93859, 0.93859, 0.93859, 1.08595, 0.8562, 0.94578, 0.94578, 0.94578, 0.94578, 0.882, 0.94578, 0.882, 0.85158, 0.93859, 0.85158, 0.93859, 0.85158, 0.93859, 0.76852, 0.846, 0.76852, 0.846, 0.76852, 0.846, 0.76852, 0.846, 0.89591, 0.8544, 0.90561, 0.94399, 0.70466, 0.81453, 0.70466, 0.81453, 0.70466, 0.81453, 0.70466, 0.81453, 0.70466, 0.81453, 0.80094, 0.94219, 0.80094, 0.94219, 0.80094, 0.94219, 1, 1, 0.86822, 0.96017, 0.86822, 0.96017, 0.83864, 0.82424, 0.83864, 0.82424, 0.83864, 0.82424, 0.83864, 1.03075, 0.83864, 0.82424, 0.81402, 1.02738, 0.728, 1.02175, 1, 1, 0.912, 0.79475, 1.03075, 1, 1, 0.79475, 0.83911, 0.79475, 0.66266, 0.80553, 1.06676, 0.87514, 0.96017, 1, 1, 0.87514, 0.96017, 0.86865, 0.87396, 0.96017, 0.8588, 0.93859, 0.8588, 0.93859, 0.8588, 0.93859, 0.867, 0.84759, 0.72421, 0.95493, 1, 1, 0.72421, 0.95493, 0.69866, 0.746, 0.69866, 0.746, 1, 1, 0.69866, 0.746, 1, 1, 0.77598, 0.88417, 0.77598, 1.12658, 0.85991, 0.94578, 0.85991, 0.94578, 0.85991, 0.94578, 0.85991, 0.94578, 0.85991, 0.94578, 0.85991, 0.94578, 0.87832, 0.979, 0.77512, 0.882, 0.77512, 0.8562, 0.83, 0.8562, 0.83, 0.8562, 0.83, 1, 0.88465, 0.85158, 0.93859, 0.773, 0.8075, 0.85751, 0.8562, 1, 1, 0.77598, 1.12658, 1.15012, 1.15012, 1.15012, 1.15012, 1.15012, 1.15313, 1.15012, 1.15012, 1.15012, 1.08106, 1.03901, 0.85158, 0.77025, 0.62264, 0.7646, 0.65351, 0.86026, 0.69461, 0.89947, 1.03075, 0.85158, 0.77812, 0.76449, 0.88836, 0.70466, 0.8562, 0.86822, 0.8588, 0.83864, 0.77212, 0.85308, 0.93637, 0.87514, 0.82352, 0.8588, 0.85701, 0.76013, 0.89058, 0.77598, 0.8156, 0.82565, 0.78112, 0.77899, 0.89386, 0.83864, 0.8156, 0.9486, 0.92388, 0.96186, 1.03075, 0.91123, 0.9486, 0.93298, 0.878, 0.93942, 0.92388, 0.84596, 0.96186, 0.95119, 1.03075, 0.922, 0.88787, 0.95829, 0.88, 0.93559, 0.93859, 0.78815, 0.93758, 1, 0.89217, 1.03737, 0.91123, 0.93969, 0.77487, 0.85769, 0.86799, 1.03075, 0.91123, 0.93859, 0.91123, 0.86799, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.87832, 0.979, 0.87832, 0.979, 0.87832, 0.979, 0.77512, 0.882, 0.9219, 1, 0.89903, 1, 1, 1, 0.87321, 0.87321, 0.87321, 1, 1.027, 1.027, 1.027, 0.86847, 0.86847, 0.79121, 1, 1.124, 1, 1, 0.73572, 0.73572, 1, 1, 0.85034, 1, 1, 1, 1, 0.88465, 1, 1, 1, 0.669, 1, 1.36145, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.04828, 1, 0.74948, 0.75187, 1.02058, 0.98391, 1.02119, 1, 1, 1.06233, 1.08595, 1.08595, 1, 1.08595, 1.08595, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.05233, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
              exports3.MyriadProItalicFactors = MyriadProItalicFactors;
              const MyriadProItalicMetrics = {
                lineHeight: 1.2,
                lineGap: 0.2
              };
              exports3.MyriadProItalicMetrics = MyriadProItalicMetrics;
              const MyriadProRegularFactors = [1.36898, 1, 1, 0.76305, 0.82784, 0.94935, 0.89364, 0.92241, 0.89073, 0.90706, 0.98472, 0.85283, 0.85283, 1.0664, 1.02058, 0.74505, 0.9219, 0.74505, 1.23456, 0.92241, 0.92241, 0.92241, 0.92241, 0.92241, 0.92241, 0.92241, 0.92241, 0.92241, 0.92241, 0.74505, 0.74505, 1.02058, 1.02058, 1.02058, 0.73002, 0.72601, 0.91755, 0.8126, 0.80314, 0.92222, 0.73764, 0.79726, 0.83051, 0.90284, 0.86023, 0.74, 0.8126, 0.84869, 0.96518, 0.91115, 0.8858, 0.79761, 0.8858, 0.74498, 0.73914, 0.81363, 0.89591, 0.83659, 0.89633, 0.85608, 0.8111, 0.90531, 1.0222, 1.22736, 1.0222, 1.27014, 0.89903, 0.90088, 0.86667, 1.0231, 0.896, 1.01411, 0.90083, 1.05099, 1.00512, 0.99793, 1.05326, 1.09377, 0.938, 1.06226, 1.00119, 0.99793, 0.98714, 1.0231, 1.01231, 0.98196, 0.792, 1.19137, 0.99074, 0.962, 1.01915, 0.926, 0.942, 0.856, 0.85034, 0.92006, 0.85034, 1.02058, 0.69067, 0.92241, 0.92241, 0.92241, 0.92241, 0.92006, 0.9332, 0.90088, 0.91882, 0.93484, 0.75339, 1.02058, 0.56866, 0.54324, 0.79519, 1.08595, 1, 1, 0.90088, 1, 0.95325, 0.74505, 0.90088, 1, 0.97198, 0.75339, 0.91009, 0.91009, 0.91009, 0.66466, 0.91755, 0.91755, 0.91755, 0.91755, 0.91755, 0.91755, 0.788, 0.80314, 0.73764, 0.73764, 0.73764, 0.73764, 0.86023, 0.86023, 0.86023, 0.86023, 0.92915, 0.91115, 0.8858, 0.8858, 0.8858, 0.8858, 0.8858, 1.02058, 0.8858, 0.89591, 0.89591, 0.89591, 0.89591, 0.8111, 0.79611, 0.89713, 0.86667, 0.86667, 0.86667, 0.86667, 0.86667, 0.86667, 0.86936, 0.896, 0.90083, 0.90083, 0.90083, 0.90083, 0.84224, 0.84224, 0.84224, 0.84224, 0.97276, 0.99793, 0.98714, 0.98714, 0.98714, 0.98714, 0.98714, 1.08595, 0.89876, 0.99074, 0.99074, 0.99074, 0.99074, 0.942, 1.0231, 0.942, 0.91755, 0.86667, 0.91755, 0.86667, 0.91755, 0.86667, 0.80314, 0.896, 0.80314, 0.896, 0.80314, 0.896, 0.80314, 0.896, 0.92222, 0.93372, 0.92915, 1.01411, 0.73764, 0.90083, 0.73764, 0.90083, 0.73764, 0.90083, 0.73764, 0.90083, 0.73764, 0.90083, 0.83051, 1.00512, 0.83051, 1.00512, 0.83051, 1.00512, 1, 1, 0.90284, 0.99793, 0.90976, 0.99793, 0.86023, 0.84224, 0.86023, 0.84224, 0.86023, 0.84224, 0.86023, 1.05326, 0.86023, 0.84224, 0.82873, 1.07469, 0.74, 1.09377, 1, 1, 0.938, 0.84869, 1.06226, 1, 1, 0.84869, 0.83704, 0.84869, 0.81441, 0.85588, 1.08927, 0.91115, 0.99793, 1, 1, 0.91115, 0.99793, 0.91887, 0.90991, 0.99793, 0.8858, 0.98714, 0.8858, 0.98714, 0.8858, 0.98714, 0.894, 0.91434, 0.74498, 0.98196, 1, 1, 0.74498, 0.98196, 0.73914, 0.792, 0.73914, 0.792, 1, 1, 0.73914, 0.792, 1, 1, 0.81363, 0.904, 0.81363, 1.19137, 0.89591, 0.99074, 0.89591, 0.99074, 0.89591, 0.99074, 0.89591, 0.99074, 0.89591, 0.99074, 0.89591, 0.99074, 0.89633, 1.01915, 0.8111, 0.942, 0.8111, 0.90531, 0.856, 0.90531, 0.856, 0.90531, 0.856, 1, 0.92241, 0.91755, 0.86667, 0.788, 0.86936, 0.8858, 0.89876, 1, 1, 0.81363, 1.19137, 0.90088, 0.90088, 0.90088, 0.90088, 0.90088, 0.90088, 0.90088, 0.90088, 0.90088, 0.90388, 1.03901, 0.92138, 0.78105, 0.7154, 0.86169, 0.80513, 0.94007, 0.82528, 0.98612, 1.06226, 0.91755, 0.8126, 0.81884, 0.92819, 0.73764, 0.90531, 0.90284, 0.8858, 0.86023, 0.8126, 0.91172, 0.96518, 0.91115, 0.83089, 0.8858, 0.87791, 0.79761, 0.89297, 0.81363, 0.88157, 0.89992, 0.85608, 0.81992, 0.94307, 0.86023, 0.88157, 0.95308, 0.98699, 0.99793, 1.06226, 0.95817, 0.95308, 0.97358, 0.928, 0.98088, 0.98699, 0.92761, 0.99793, 0.96017, 1.06226, 0.986, 0.944, 0.95978, 0.938, 0.96705, 0.98714, 0.80442, 0.98972, 1, 0.89762, 1.04552, 0.95817, 0.99007, 0.87064, 0.91879, 0.88888, 1.06226, 0.95817, 0.98714, 0.95817, 0.88888, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.89633, 1.01915, 0.89633, 1.01915, 0.89633, 1.01915, 0.8111, 0.942, 0.9219, 1, 0.89903, 1, 1, 1, 0.93173, 0.93173, 0.93173, 1, 1.06304, 1.06304, 1.06904, 0.89903, 0.89903, 0.80549, 1, 1.156, 1, 1, 0.76575, 0.76575, 1, 1, 0.72458, 1, 1, 1, 1, 0.92241, 1, 1, 1, 0.619, 1, 1.36145, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.07257, 1, 0.74705, 0.71119, 1.02058, 1.024, 1.02119, 1, 1, 1.1536, 1.08595, 1.08595, 1, 1.08595, 1.08595, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.05638, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
              exports3.MyriadProRegularFactors = MyriadProRegularFactors;
              const MyriadProRegularMetrics = {
                lineHeight: 1.2,
                lineGap: 0.2
              };
              exports3.MyriadProRegularMetrics = MyriadProRegularMetrics;
            }),
            /* 56 */
            /***/
            ((__unused_webpack_module2, exports3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.SegoeuiRegularMetrics = exports3.SegoeuiRegularFactors = exports3.SegoeuiItalicMetrics = exports3.SegoeuiItalicFactors = exports3.SegoeuiBoldMetrics = exports3.SegoeuiBoldItalicMetrics = exports3.SegoeuiBoldItalicFactors = exports3.SegoeuiBoldFactors = void 0;
              const SegoeuiBoldFactors = [1.76738, 1, 1, 0.99297, 0.9824, 1.04016, 1.06497, 1.03424, 0.97529, 1.17647, 1.23203, 1.1085, 1.1085, 1.16939, 1.2107, 0.9754, 1.21408, 0.9754, 1.59578, 1.03424, 1.03424, 1.03424, 1.03424, 1.03424, 1.03424, 1.03424, 1.03424, 1.03424, 1.03424, 0.81378, 0.81378, 1.2107, 1.2107, 1.2107, 0.71703, 0.97847, 0.97363, 0.88776, 0.8641, 1.02096, 0.79795, 0.85132, 0.914, 1.06085, 1.1406, 0.8007, 0.89858, 0.83693, 1.14889, 1.09398, 0.97489, 0.92094, 0.97489, 0.90399, 0.84041, 0.95923, 1.00135, 1, 1.06467, 0.98243, 0.90996, 0.99361, 1.1085, 1.56942, 1.1085, 1.2107, 0.74627, 0.94282, 0.96752, 1.01519, 0.86304, 1.01359, 0.97278, 1.15103, 1.01359, 0.98561, 1.02285, 1.02285, 1.00527, 1.02285, 1.0302, 0.99041, 1.0008, 1.01519, 1.01359, 1.02258, 0.79104, 1.16862, 0.99041, 0.97454, 1.02511, 0.99298, 0.96752, 0.95801, 0.94856, 1.16579, 0.94856, 1.2107, 0.9824, 1.03424, 1.03424, 1, 1.03424, 1.16579, 0.8727, 1.3871, 1.18622, 1.10818, 1.04478, 1.2107, 1.18622, 0.75155, 0.94994, 1.28826, 1.21408, 1.21408, 0.91056, 1, 0.91572, 0.9754, 0.64663, 1.18328, 1.24866, 1.04478, 1.14169, 1.15749, 1.17389, 0.71703, 0.97363, 0.97363, 0.97363, 0.97363, 0.97363, 0.97363, 0.93506, 0.8641, 0.79795, 0.79795, 0.79795, 0.79795, 1.1406, 1.1406, 1.1406, 1.1406, 1.02096, 1.09398, 0.97426, 0.97426, 0.97426, 0.97426, 0.97426, 1.2107, 0.97489, 1.00135, 1.00135, 1.00135, 1.00135, 0.90996, 0.92094, 1.02798, 0.96752, 0.96752, 0.96752, 0.96752, 0.96752, 0.96752, 0.93136, 0.86304, 0.97278, 0.97278, 0.97278, 0.97278, 1.02285, 1.02285, 1.02285, 1.02285, 0.97122, 0.99041, 1, 1, 1, 1, 1, 1.28826, 1.0008, 0.99041, 0.99041, 0.99041, 0.99041, 0.96752, 1.01519, 0.96752, 0.97363, 0.96752, 0.97363, 0.96752, 0.97363, 0.96752, 0.8641, 0.86304, 0.8641, 0.86304, 0.8641, 0.86304, 0.8641, 0.86304, 1.02096, 1.03057, 1.02096, 1.03517, 0.79795, 0.97278, 0.79795, 0.97278, 0.79795, 0.97278, 0.79795, 0.97278, 0.79795, 0.97278, 0.914, 1.01359, 0.914, 1.01359, 0.914, 1.01359, 1, 1, 1.06085, 0.98561, 1.06085, 1.00879, 1.1406, 1.02285, 1.1406, 1.02285, 1.1406, 1.02285, 1.1406, 1.02285, 1.1406, 1.02285, 0.97138, 1.08692, 0.8007, 1.02285, 1, 1, 1.00527, 0.83693, 1.02285, 1, 1, 0.83693, 0.9455, 0.83693, 0.90418, 0.83693, 1.13005, 1.09398, 0.99041, 1, 1, 1.09398, 0.99041, 0.96692, 1.09251, 0.99041, 0.97489, 1.0008, 0.97489, 1.0008, 0.97489, 1.0008, 0.93994, 0.97931, 0.90399, 1.02258, 1, 1, 0.90399, 1.02258, 0.84041, 0.79104, 0.84041, 0.79104, 0.84041, 0.79104, 0.84041, 0.79104, 1, 1, 0.95923, 1.07034, 0.95923, 1.16862, 1.00135, 0.99041, 1.00135, 0.99041, 1.00135, 0.99041, 1.00135, 0.99041, 1.00135, 0.99041, 1.00135, 0.99041, 1.06467, 1.02511, 0.90996, 0.96752, 0.90996, 0.99361, 0.95801, 0.99361, 0.95801, 0.99361, 0.95801, 1.07733, 1.03424, 0.97363, 0.96752, 0.93506, 0.93136, 0.97489, 1.0008, 1, 1, 0.95923, 1.16862, 1.15103, 1.15103, 1.01173, 1.03959, 0.75953, 0.81378, 0.79912, 1.15103, 1.21994, 0.95161, 0.87815, 1.01149, 0.81525, 0.7676, 0.98167, 1.01134, 1.02546, 0.84097, 1.03089, 1.18102, 0.97363, 0.88776, 0.85134, 0.97826, 0.79795, 0.99361, 1.06085, 0.97489, 1.1406, 0.89858, 1.0388, 1.14889, 1.09398, 0.86039, 0.97489, 1.0595, 0.92094, 0.94793, 0.95923, 0.90996, 0.99346, 0.98243, 1.02112, 0.95493, 1.1406, 0.90996, 1.03574, 1.02597, 1.0008, 1.18102, 1.06628, 1.03574, 1.0192, 1.01932, 1.00886, 0.97531, 1.0106, 1.0008, 1.13189, 1.18102, 1.02277, 0.98683, 1.0016, 0.99561, 1.07237, 1.0008, 0.90434, 0.99921, 0.93803, 0.8965, 1.23085, 1.06628, 1.04983, 0.96268, 1.0499, 0.98439, 1.18102, 1.06628, 1.0008, 1.06628, 0.98439, 0.79795, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.09466, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.97278, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.02065, 1, 1, 1, 1, 1, 1, 1.06467, 1.02511, 1.06467, 1.02511, 1.06467, 1.02511, 0.90996, 0.96752, 1, 1.21408, 0.89903, 1, 1, 0.75155, 1.04394, 1.04394, 1.04394, 1.04394, 0.98633, 0.98633, 0.98633, 0.73047, 0.73047, 1.20642, 0.91211, 1.25635, 1.222, 1.02956, 1.03372, 1.03372, 0.96039, 1.24633, 1, 1.12454, 0.93503, 1.03424, 1.19687, 1.03424, 1, 1, 1, 0.771, 1, 1, 1.15749, 1.15749, 1.15749, 1.10948, 0.86279, 0.94434, 0.86279, 0.94434, 0.86182, 1, 1, 1.16897, 1, 0.96085, 0.90137, 1.2107, 1.18416, 1.13973, 0.69825, 0.9716, 2.10339, 1.29004, 1.29004, 1.21172, 1.29004, 1.29004, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.42603, 1, 0.99862, 0.99862, 1, 0.87025, 0.87025, 0.87025, 0.87025, 1.18874, 1.42603, 1, 1.42603, 1.42603, 0.99862, 1, 1, 1, 1, 1, 1.2886, 1.04315, 1.15296, 1.34163, 1, 1, 1, 1.09193, 1.09193, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
              exports3.SegoeuiBoldFactors = SegoeuiBoldFactors;
              const SegoeuiBoldMetrics = {
                lineHeight: 1.33008,
                lineGap: 0
              };
              exports3.SegoeuiBoldMetrics = SegoeuiBoldMetrics;
              const SegoeuiBoldItalicFactors = [1.76738, 1, 1, 0.98946, 1.03959, 1.04016, 1.02809, 1.036, 0.97639, 1.10953, 1.23203, 1.11144, 1.11144, 1.16939, 1.21237, 0.9754, 1.21261, 0.9754, 1.59754, 1.036, 1.036, 1.036, 1.036, 1.036, 1.036, 1.036, 1.036, 1.036, 1.036, 0.81378, 0.81378, 1.21237, 1.21237, 1.21237, 0.73541, 0.97847, 0.97363, 0.89723, 0.87897, 1.0426, 0.79429, 0.85292, 0.91149, 1.05815, 1.1406, 0.79631, 0.90128, 0.83853, 1.04396, 1.10615, 0.97552, 0.94436, 0.97552, 0.88641, 0.80527, 0.96083, 1.00135, 1, 1.06777, 0.9817, 0.91142, 0.99361, 1.11144, 1.57293, 1.11144, 1.21237, 0.74627, 1.31818, 1.06585, 0.97042, 0.83055, 0.97042, 0.93503, 1.1261, 0.97042, 0.97922, 1.14236, 0.94552, 1.01054, 1.14236, 1.02471, 0.97922, 0.94165, 0.97042, 0.97042, 1.0276, 0.78929, 1.1261, 0.97922, 0.95874, 1.02197, 0.98507, 0.96752, 0.97168, 0.95107, 1.16579, 0.95107, 1.21237, 1.03959, 1.036, 1.036, 1, 1.036, 1.16579, 0.87357, 1.31818, 1.18754, 1.26781, 1.05356, 1.21237, 1.18622, 0.79487, 0.94994, 1.29004, 1.24047, 1.24047, 1.31818, 1, 0.91484, 0.9754, 1.31818, 1.1349, 1.24866, 1.05356, 1.13934, 1.15574, 1.17389, 0.73541, 0.97363, 0.97363, 0.97363, 0.97363, 0.97363, 0.97363, 0.94385, 0.87897, 0.79429, 0.79429, 0.79429, 0.79429, 1.1406, 1.1406, 1.1406, 1.1406, 1.0426, 1.10615, 0.97552, 0.97552, 0.97552, 0.97552, 0.97552, 1.21237, 0.97552, 1.00135, 1.00135, 1.00135, 1.00135, 0.91142, 0.94436, 0.98721, 1.06585, 1.06585, 1.06585, 1.06585, 1.06585, 1.06585, 0.96705, 0.83055, 0.93503, 0.93503, 0.93503, 0.93503, 1.14236, 1.14236, 1.14236, 1.14236, 0.93125, 0.97922, 0.94165, 0.94165, 0.94165, 0.94165, 0.94165, 1.29004, 0.94165, 0.97922, 0.97922, 0.97922, 0.97922, 0.96752, 0.97042, 0.96752, 0.97363, 1.06585, 0.97363, 1.06585, 0.97363, 1.06585, 0.87897, 0.83055, 0.87897, 0.83055, 0.87897, 0.83055, 0.87897, 0.83055, 1.0426, 1.0033, 1.0426, 0.97042, 0.79429, 0.93503, 0.79429, 0.93503, 0.79429, 0.93503, 0.79429, 0.93503, 0.79429, 0.93503, 0.91149, 0.97042, 0.91149, 0.97042, 0.91149, 0.97042, 1, 1, 1.05815, 0.97922, 1.05815, 0.97922, 1.1406, 1.14236, 1.1406, 1.14236, 1.1406, 1.14236, 1.1406, 1.14236, 1.1406, 1.14236, 0.97441, 1.04302, 0.79631, 1.01582, 1, 1, 1.01054, 0.83853, 1.14236, 1, 1, 0.83853, 1.09125, 0.83853, 0.90418, 0.83853, 1.19508, 1.10615, 0.97922, 1, 1, 1.10615, 0.97922, 1.01034, 1.10466, 0.97922, 0.97552, 0.94165, 0.97552, 0.94165, 0.97552, 0.94165, 0.91602, 0.91981, 0.88641, 1.0276, 1, 1, 0.88641, 1.0276, 0.80527, 0.78929, 0.80527, 0.78929, 0.80527, 0.78929, 0.80527, 0.78929, 1, 1, 0.96083, 1.05403, 0.95923, 1.16862, 1.00135, 0.97922, 1.00135, 0.97922, 1.00135, 0.97922, 1.00135, 0.97922, 1.00135, 0.97922, 1.00135, 0.97922, 1.06777, 1.02197, 0.91142, 0.96752, 0.91142, 0.99361, 0.97168, 0.99361, 0.97168, 0.99361, 0.97168, 1.23199, 1.036, 0.97363, 1.06585, 0.94385, 0.96705, 0.97552, 0.94165, 1, 1, 0.96083, 1.1261, 1.31818, 1.31818, 1.31818, 1.31818, 1.31818, 1.31818, 1.31818, 1.31818, 1.31818, 0.95161, 1.27126, 1.00811, 0.83284, 0.77702, 0.99137, 0.95253, 1.0347, 0.86142, 1.07205, 1.14236, 0.97363, 0.89723, 0.86869, 1.09818, 0.79429, 0.99361, 1.05815, 0.97552, 1.1406, 0.90128, 1.06662, 1.04396, 1.10615, 0.84918, 0.97552, 1.04694, 0.94436, 0.98015, 0.96083, 0.91142, 1.00356, 0.9817, 1.01945, 0.98999, 1.1406, 0.91142, 1.04961, 0.9898, 1.00639, 1.14236, 1.07514, 1.04961, 0.99607, 1.02897, 1.008, 0.9898, 0.95134, 1.00639, 1.11121, 1.14236, 1.00518, 0.97981, 1.02186, 1, 1.08578, 0.94165, 0.99314, 0.98387, 0.93028, 0.93377, 1.35125, 1.07514, 1.10687, 0.93491, 1.04232, 1.00351, 1.14236, 1.07514, 0.94165, 1.07514, 1.00351, 0.79429, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.09097, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.93503, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.96609, 1, 1, 1, 1, 1, 1, 1.06777, 1.02197, 1.06777, 1.02197, 1.06777, 1.02197, 0.91142, 0.96752, 1, 1.21261, 0.89903, 1, 1, 0.75155, 1.04745, 1.04745, 1.04745, 1.04394, 0.98633, 0.98633, 0.98633, 0.72959, 0.72959, 1.20502, 0.91406, 1.26514, 1.222, 1.02956, 1.03372, 1.03372, 0.96039, 1.24633, 1, 1.09125, 0.93327, 1.03336, 1.16541, 1.036, 1, 1, 1, 0.771, 1, 1, 1.15574, 1.15574, 1.15574, 1.15574, 0.86364, 0.94434, 0.86279, 0.94434, 0.86224, 1, 1, 1.16798, 1, 0.96085, 0.90068, 1.21237, 1.18416, 1.13904, 0.69825, 0.9716, 2.10339, 1.29004, 1.29004, 1.21339, 1.29004, 1.29004, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.42603, 1, 0.99862, 0.99862, 1, 0.87025, 0.87025, 0.87025, 0.87025, 1.18775, 1.42603, 1, 1.42603, 1.42603, 0.99862, 1, 1, 1, 1, 1, 1.2886, 1.04315, 1.15296, 1.34163, 1, 1, 1, 1.13269, 1.13269, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
              exports3.SegoeuiBoldItalicFactors = SegoeuiBoldItalicFactors;
              const SegoeuiBoldItalicMetrics = {
                lineHeight: 1.33008,
                lineGap: 0
              };
              exports3.SegoeuiBoldItalicMetrics = SegoeuiBoldItalicMetrics;
              const SegoeuiItalicFactors = [1.76738, 1, 1, 0.98946, 1.14763, 1.05365, 1.06234, 0.96927, 0.92586, 1.15373, 1.18414, 0.91349, 0.91349, 1.07403, 1.17308, 0.78383, 1.20088, 0.78383, 1.42531, 0.96927, 0.96927, 0.96927, 0.96927, 0.96927, 0.96927, 0.96927, 0.96927, 0.96927, 0.96927, 0.78383, 0.78383, 1.17308, 1.17308, 1.17308, 0.77349, 0.94565, 0.94729, 0.85944, 0.88506, 0.9858, 0.74817, 0.80016, 0.88449, 0.98039, 0.95782, 0.69238, 0.89898, 0.83231, 0.98183, 1.03989, 0.96924, 0.86237, 0.96924, 0.80595, 0.74524, 0.86091, 0.95402, 0.94143, 0.98448, 0.8858, 0.83089, 0.93285, 1.0949, 1.39016, 1.0949, 1.45994, 0.74627, 1.04839, 0.97454, 0.97454, 0.87207, 0.97454, 0.87533, 1.06151, 0.97454, 1.00176, 1.16484, 1.08132, 0.98047, 1.16484, 1.02989, 1.01054, 0.96225, 0.97454, 0.97454, 1.06598, 0.79004, 1.16344, 1.00351, 0.94629, 0.9973, 0.91016, 0.96777, 0.9043, 0.91082, 0.92481, 0.91082, 1.17308, 0.95748, 0.96927, 0.96927, 1, 0.96927, 0.92481, 0.80597, 1.04839, 1.23393, 1.1781, 0.9245, 1.17308, 1.20808, 0.63218, 0.94261, 1.24822, 1.09971, 1.09971, 1.04839, 1, 0.85273, 0.78032, 1.04839, 1.09971, 1.22326, 0.9245, 1.09836, 1.13525, 1.15222, 0.70424, 0.94729, 0.94729, 0.94729, 0.94729, 0.94729, 0.94729, 0.85498, 0.88506, 0.74817, 0.74817, 0.74817, 0.74817, 0.95782, 0.95782, 0.95782, 0.95782, 0.9858, 1.03989, 0.96924, 0.96924, 0.96924, 0.96924, 0.96924, 1.17308, 0.96924, 0.95402, 0.95402, 0.95402, 0.95402, 0.83089, 0.86237, 0.88409, 0.97454, 0.97454, 0.97454, 0.97454, 0.97454, 0.97454, 0.92916, 0.87207, 0.87533, 0.87533, 0.87533, 0.87533, 0.93146, 0.93146, 0.93146, 0.93146, 0.93854, 1.01054, 0.96225, 0.96225, 0.96225, 0.96225, 0.96225, 1.24822, 0.8761, 1.00351, 1.00351, 1.00351, 1.00351, 0.96777, 0.97454, 0.96777, 0.94729, 0.97454, 0.94729, 0.97454, 0.94729, 0.97454, 0.88506, 0.87207, 0.88506, 0.87207, 0.88506, 0.87207, 0.88506, 0.87207, 0.9858, 0.95391, 0.9858, 0.97454, 0.74817, 0.87533, 0.74817, 0.87533, 0.74817, 0.87533, 0.74817, 0.87533, 0.74817, 0.87533, 0.88449, 0.97454, 0.88449, 0.97454, 0.88449, 0.97454, 1, 1, 0.98039, 1.00176, 0.98039, 1.00176, 0.95782, 0.93146, 0.95782, 0.93146, 0.95782, 0.93146, 0.95782, 1.16484, 0.95782, 0.93146, 0.84421, 1.12761, 0.69238, 1.08132, 1, 1, 0.98047, 0.83231, 1.16484, 1, 1, 0.84723, 1.04861, 0.84723, 0.78755, 0.83231, 1.23736, 1.03989, 1.01054, 1, 1, 1.03989, 1.01054, 0.9857, 1.03849, 1.01054, 0.96924, 0.96225, 0.96924, 0.96225, 0.96924, 0.96225, 0.92383, 0.90171, 0.80595, 1.06598, 1, 1, 0.80595, 1.06598, 0.74524, 0.79004, 0.74524, 0.79004, 0.74524, 0.79004, 0.74524, 0.79004, 1, 1, 0.86091, 1.02759, 0.85771, 1.16344, 0.95402, 1.00351, 0.95402, 1.00351, 0.95402, 1.00351, 0.95402, 1.00351, 0.95402, 1.00351, 0.95402, 1.00351, 0.98448, 0.9973, 0.83089, 0.96777, 0.83089, 0.93285, 0.9043, 0.93285, 0.9043, 0.93285, 0.9043, 1.31868, 0.96927, 0.94729, 0.97454, 0.85498, 0.92916, 0.96924, 0.8761, 1, 1, 0.86091, 1.16344, 1.04839, 1.04839, 1.04839, 1.04839, 1.04839, 1.04839, 1.04839, 1.04839, 1.04839, 0.81965, 0.81965, 0.94729, 0.78032, 0.71022, 0.90883, 0.84171, 0.99877, 0.77596, 1.05734, 1.2, 0.94729, 0.85944, 0.82791, 0.9607, 0.74817, 0.93285, 0.98039, 0.96924, 0.95782, 0.89898, 0.98316, 0.98183, 1.03989, 0.78614, 0.96924, 0.97642, 0.86237, 0.86075, 0.86091, 0.83089, 0.90082, 0.8858, 0.97296, 1.01284, 0.95782, 0.83089, 1.0976, 1.04, 1.03342, 1.2, 1.0675, 1.0976, 0.98205, 1.03809, 1.05097, 1.04, 0.95364, 1.03342, 1.05401, 1.2, 1.02148, 1.0119, 1.04724, 1.0127, 1.02732, 0.96225, 0.8965, 0.97783, 0.93574, 0.94818, 1.30679, 1.0675, 1.11826, 0.99821, 1.0557, 1.0326, 1.2, 1.0675, 0.96225, 1.0675, 1.0326, 0.74817, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.03754, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.87533, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.98705, 1, 1, 1, 1, 1, 1, 0.98448, 0.9973, 0.98448, 0.9973, 0.98448, 0.9973, 0.83089, 0.96777, 1, 1.20088, 0.89903, 1, 1, 0.75155, 0.94945, 0.94945, 0.94945, 0.94945, 1.12317, 1.12317, 1.12317, 0.67603, 0.67603, 1.15621, 0.73584, 1.21191, 1.22135, 1.06483, 0.94868, 0.94868, 0.95996, 1.24633, 1, 1.07497, 0.87709, 0.96927, 1.01473, 0.96927, 1, 1, 1, 0.77295, 1, 1, 1.09836, 1.09836, 1.09836, 1.01522, 0.86321, 0.94434, 0.8649, 0.94434, 0.86182, 1, 1, 1.083, 1, 0.91578, 0.86438, 1.17308, 1.18416, 1.14589, 0.69825, 0.97622, 1.96791, 1.24822, 1.24822, 1.17308, 1.24822, 1.24822, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.42603, 1, 0.99862, 0.99862, 1, 0.87025, 0.87025, 0.87025, 0.87025, 1.17984, 1.42603, 1, 1.42603, 1.42603, 0.99862, 1, 1, 1, 1, 1, 1.2886, 1.04315, 1.15296, 1.34163, 1, 1, 1, 1.10742, 1.10742, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
              exports3.SegoeuiItalicFactors = SegoeuiItalicFactors;
              const SegoeuiItalicMetrics = {
                lineHeight: 1.33008,
                lineGap: 0
              };
              exports3.SegoeuiItalicMetrics = SegoeuiItalicMetrics;
              const SegoeuiRegularFactors = [1.76738, 1, 1, 0.98594, 1.02285, 1.10454, 1.06234, 0.96927, 0.92037, 1.19985, 1.2046, 0.90616, 0.90616, 1.07152, 1.1714, 0.78032, 1.20088, 0.78032, 1.40246, 0.96927, 0.96927, 0.96927, 0.96927, 0.96927, 0.96927, 0.96927, 0.96927, 0.96927, 0.96927, 0.78032, 0.78032, 1.1714, 1.1714, 1.1714, 0.80597, 0.94084, 0.96706, 0.85944, 0.85734, 0.97093, 0.75842, 0.79936, 0.88198, 0.9831, 0.95782, 0.71387, 0.86969, 0.84636, 1.07796, 1.03584, 0.96924, 0.83968, 0.96924, 0.82826, 0.79649, 0.85771, 0.95132, 0.93119, 0.98965, 0.88433, 0.8287, 0.93365, 1.08612, 1.3638, 1.08612, 1.45786, 0.74627, 0.80499, 0.91484, 1.05707, 0.92383, 1.05882, 0.9403, 1.12654, 1.05882, 1.01756, 1.09011, 1.09011, 0.99414, 1.09011, 1.034, 1.01756, 1.05356, 1.05707, 1.05882, 1.04399, 0.84863, 1.21968, 1.01756, 0.95801, 1.00068, 0.91797, 0.96777, 0.9043, 0.90351, 0.92105, 0.90351, 1.1714, 0.85337, 0.96927, 0.96927, 0.99912, 0.96927, 0.92105, 0.80597, 1.2434, 1.20808, 1.05937, 0.90957, 1.1714, 1.20808, 0.75155, 0.94261, 1.24644, 1.09971, 1.09971, 0.84751, 1, 0.85273, 0.78032, 0.61584, 1.05425, 1.17914, 0.90957, 1.08665, 1.11593, 1.14169, 0.73381, 0.96706, 0.96706, 0.96706, 0.96706, 0.96706, 0.96706, 0.86035, 0.85734, 0.75842, 0.75842, 0.75842, 0.75842, 0.95782, 0.95782, 0.95782, 0.95782, 0.97093, 1.03584, 0.96924, 0.96924, 0.96924, 0.96924, 0.96924, 1.1714, 0.96924, 0.95132, 0.95132, 0.95132, 0.95132, 0.8287, 0.83968, 0.89049, 0.91484, 0.91484, 0.91484, 0.91484, 0.91484, 0.91484, 0.93575, 0.92383, 0.9403, 0.9403, 0.9403, 0.9403, 0.8717, 0.8717, 0.8717, 0.8717, 1.00527, 1.01756, 1.05356, 1.05356, 1.05356, 1.05356, 1.05356, 1.24644, 0.95923, 1.01756, 1.01756, 1.01756, 1.01756, 0.96777, 1.05707, 0.96777, 0.96706, 0.91484, 0.96706, 0.91484, 0.96706, 0.91484, 0.85734, 0.92383, 0.85734, 0.92383, 0.85734, 0.92383, 0.85734, 0.92383, 0.97093, 1.0969, 0.97093, 1.05882, 0.75842, 0.9403, 0.75842, 0.9403, 0.75842, 0.9403, 0.75842, 0.9403, 0.75842, 0.9403, 0.88198, 1.05882, 0.88198, 1.05882, 0.88198, 1.05882, 1, 1, 0.9831, 1.01756, 0.9831, 1.01756, 0.95782, 0.8717, 0.95782, 0.8717, 0.95782, 0.8717, 0.95782, 1.09011, 0.95782, 0.8717, 0.84784, 1.11551, 0.71387, 1.09011, 1, 1, 0.99414, 0.84636, 1.09011, 1, 1, 0.84636, 1.0536, 0.84636, 0.94298, 0.84636, 1.23297, 1.03584, 1.01756, 1, 1, 1.03584, 1.01756, 1.00323, 1.03444, 1.01756, 0.96924, 1.05356, 0.96924, 1.05356, 0.96924, 1.05356, 0.93066, 0.98293, 0.82826, 1.04399, 1, 1, 0.82826, 1.04399, 0.79649, 0.84863, 0.79649, 0.84863, 0.79649, 0.84863, 0.79649, 0.84863, 1, 1, 0.85771, 1.17318, 0.85771, 1.21968, 0.95132, 1.01756, 0.95132, 1.01756, 0.95132, 1.01756, 0.95132, 1.01756, 0.95132, 1.01756, 0.95132, 1.01756, 0.98965, 1.00068, 0.8287, 0.96777, 0.8287, 0.93365, 0.9043, 0.93365, 0.9043, 0.93365, 0.9043, 1.08571, 0.96927, 0.96706, 0.91484, 0.86035, 0.93575, 0.96924, 0.95923, 1, 1, 0.85771, 1.21968, 1.11437, 1.11437, 0.93109, 0.91202, 0.60411, 0.84164, 0.55572, 1.01173, 0.97361, 0.81818, 0.81818, 0.96635, 0.78032, 0.72727, 0.92366, 0.98601, 1.03405, 0.77968, 1.09799, 1.2, 0.96706, 0.85944, 0.85638, 0.96491, 0.75842, 0.93365, 0.9831, 0.96924, 0.95782, 0.86969, 0.94152, 1.07796, 1.03584, 0.78437, 0.96924, 0.98715, 0.83968, 0.83491, 0.85771, 0.8287, 0.94492, 0.88433, 0.9287, 1.0098, 0.95782, 0.8287, 1.0625, 0.98248, 1.03424, 1.2, 1.01071, 1.0625, 0.95246, 1.03809, 1.04912, 0.98248, 1.00221, 1.03424, 1.05443, 1.2, 1.04785, 0.99609, 1.00169, 1.05176, 0.99346, 1.05356, 0.9087, 1.03004, 0.95542, 0.93117, 1.23362, 1.01071, 1.07831, 1.02512, 1.05205, 1.03502, 1.2, 1.01071, 1.05356, 1.01071, 1.03502, 0.75842, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.03719, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.9403, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.04021, 1, 1, 1, 1, 1, 1, 0.98965, 1.00068, 0.98965, 1.00068, 0.98965, 1.00068, 0.8287, 0.96777, 1, 1.20088, 0.89903, 1, 1, 0.75155, 1.03077, 1.03077, 1.03077, 1.03077, 1.13196, 1.13196, 1.13196, 0.67428, 0.67428, 1.16039, 0.73291, 1.20996, 1.22135, 1.06483, 0.94868, 0.94868, 0.95996, 1.24633, 1, 1.07497, 0.87796, 0.96927, 1.01518, 0.96927, 1, 1, 1, 0.77295, 1, 1, 1.10539, 1.10539, 1.11358, 1.06967, 0.86279, 0.94434, 0.86279, 0.94434, 0.86182, 1, 1, 1.083, 1, 0.91578, 0.86507, 1.1714, 1.18416, 1.14589, 0.69825, 0.97622, 1.9697, 1.24822, 1.24822, 1.17238, 1.24822, 1.24822, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.42603, 1, 0.99862, 0.99862, 1, 0.87025, 0.87025, 0.87025, 0.87025, 1.18083, 1.42603, 1, 1.42603, 1.42603, 0.99862, 1, 1, 1, 1, 1, 1.2886, 1.04315, 1.15296, 1.34163, 1, 1, 1, 1.10938, 1.10938, 1, 1, 1, 1.05425, 1.09971, 1.09971, 1.09971, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
              exports3.SegoeuiRegularFactors = SegoeuiRegularFactors;
              const SegoeuiRegularMetrics = {
                lineHeight: 1.33008,
                lineGap: 0
              };
              exports3.SegoeuiRegularMetrics = SegoeuiRegularMetrics;
            }),
            /* 57 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.PostScriptEvaluator = exports3.PostScriptCompiler = exports3.PDFFunctionFactory = void 0;
              exports3.isPDFFunction = isPDFFunction;
              var _primitives = __w_pdfjs_require__3(4);
              var _util2 = __w_pdfjs_require__3(2);
              var _ps_parser = __w_pdfjs_require__3(58);
              var _base_stream = __w_pdfjs_require__3(5);
              var _image_utils = __w_pdfjs_require__3(59);
              class PDFFunctionFactory {
                constructor({
                  xref,
                  isEvalSupported = true
                }) {
                  this.xref = xref;
                  this.isEvalSupported = isEvalSupported !== false;
                }
                create(fn) {
                  const cachedFunction = this.getCached(fn);
                  if (cachedFunction) {
                    return cachedFunction;
                  }
                  const parsedFunction = PDFFunction.parse({
                    xref: this.xref,
                    isEvalSupported: this.isEvalSupported,
                    fn: fn instanceof _primitives.Ref ? this.xref.fetch(fn) : fn
                  });
                  this._cache(fn, parsedFunction);
                  return parsedFunction;
                }
                createFromArray(fnObj) {
                  const cachedFunction = this.getCached(fnObj);
                  if (cachedFunction) {
                    return cachedFunction;
                  }
                  const parsedFunction = PDFFunction.parseArray({
                    xref: this.xref,
                    isEvalSupported: this.isEvalSupported,
                    fnObj: fnObj instanceof _primitives.Ref ? this.xref.fetch(fnObj) : fnObj
                  });
                  this._cache(fnObj, parsedFunction);
                  return parsedFunction;
                }
                getCached(cacheKey) {
                  let fnRef;
                  if (cacheKey instanceof _primitives.Ref) {
                    fnRef = cacheKey;
                  } else if (cacheKey instanceof _primitives.Dict) {
                    fnRef = cacheKey.objId;
                  } else if (cacheKey instanceof _base_stream.BaseStream) {
                    fnRef = cacheKey.dict?.objId;
                  }
                  if (fnRef) {
                    const localFunction = this._localFunctionCache.getByRef(fnRef);
                    if (localFunction) {
                      return localFunction;
                    }
                  }
                  return null;
                }
                _cache(cacheKey, parsedFunction) {
                  if (!parsedFunction) {
                    throw new Error('PDFFunctionFactory._cache - expected "parsedFunction" argument.');
                  }
                  let fnRef;
                  if (cacheKey instanceof _primitives.Ref) {
                    fnRef = cacheKey;
                  } else if (cacheKey instanceof _primitives.Dict) {
                    fnRef = cacheKey.objId;
                  } else if (cacheKey instanceof _base_stream.BaseStream) {
                    fnRef = cacheKey.dict?.objId;
                  }
                  if (fnRef) {
                    this._localFunctionCache.set(null, fnRef, parsedFunction);
                  }
                }
                get _localFunctionCache() {
                  return (0, _util2.shadow)(this, "_localFunctionCache", new _image_utils.LocalFunctionCache());
                }
              }
              exports3.PDFFunctionFactory = PDFFunctionFactory;
              function toNumberArray(arr) {
                if (!Array.isArray(arr)) {
                  return null;
                }
                const length2 = arr.length;
                for (let i = 0; i < length2; i++) {
                  if (typeof arr[i] !== "number") {
                    const result = new Array(length2);
                    for (let j = 0; j < length2; j++) {
                      result[j] = +arr[j];
                    }
                    return result;
                  }
                }
                return arr;
              }
              class PDFFunction {
                static getSampleArray(size, outputSize, bps, stream) {
                  let i, ii;
                  let length2 = 1;
                  for (i = 0, ii = size.length; i < ii; i++) {
                    length2 *= size[i];
                  }
                  length2 *= outputSize;
                  const array4 = new Array(length2);
                  let codeSize = 0;
                  let codeBuf = 0;
                  const sampleMul = 1 / (2 ** bps - 1);
                  const strBytes = stream.getBytes((length2 * bps + 7) / 8);
                  let strIdx = 0;
                  for (i = 0; i < length2; i++) {
                    while (codeSize < bps) {
                      codeBuf <<= 8;
                      codeBuf |= strBytes[strIdx++];
                      codeSize += 8;
                    }
                    codeSize -= bps;
                    array4[i] = (codeBuf >> codeSize) * sampleMul;
                    codeBuf &= (1 << codeSize) - 1;
                  }
                  return array4;
                }
                static parse({
                  xref,
                  isEvalSupported,
                  fn
                }) {
                  const dict = fn.dict || fn;
                  const typeNum = dict.get("FunctionType");
                  switch (typeNum) {
                    case 0:
                      return this.constructSampled({
                        xref,
                        isEvalSupported,
                        fn,
                        dict
                      });
                    case 1:
                      break;
                    case 2:
                      return this.constructInterpolated({
                        xref,
                        isEvalSupported,
                        dict
                      });
                    case 3:
                      return this.constructStiched({
                        xref,
                        isEvalSupported,
                        dict
                      });
                    case 4:
                      return this.constructPostScript({
                        xref,
                        isEvalSupported,
                        fn,
                        dict
                      });
                  }
                  throw new _util2.FormatError("Unknown type of function");
                }
                static parseArray({
                  xref,
                  isEvalSupported,
                  fnObj
                }) {
                  if (!Array.isArray(fnObj)) {
                    return this.parse({
                      xref,
                      isEvalSupported,
                      fn: fnObj
                    });
                  }
                  const fnArray = [];
                  for (const fn of fnObj) {
                    fnArray.push(this.parse({
                      xref,
                      isEvalSupported,
                      fn: xref.fetchIfRef(fn)
                    }));
                  }
                  return function(src, srcOffset, dest, destOffset) {
                    for (let i = 0, ii = fnArray.length; i < ii; i++) {
                      fnArray[i](src, srcOffset, dest, destOffset + i);
                    }
                  };
                }
                static constructSampled({
                  xref,
                  isEvalSupported,
                  fn,
                  dict
                }) {
                  function toMultiArray(arr) {
                    const inputLength = arr.length;
                    const out = [];
                    let index3 = 0;
                    for (let i = 0; i < inputLength; i += 2) {
                      out[index3++] = [arr[i], arr[i + 1]];
                    }
                    return out;
                  }
                  function interpolate(x, xmin, xmax, ymin, ymax) {
                    return ymin + (x - xmin) * ((ymax - ymin) / (xmax - xmin));
                  }
                  let domain = toNumberArray(dict.getArray("Domain"));
                  let range3 = toNumberArray(dict.getArray("Range"));
                  if (!domain || !range3) {
                    throw new _util2.FormatError("No domain or range");
                  }
                  const inputSize = domain.length / 2;
                  const outputSize = range3.length / 2;
                  domain = toMultiArray(domain);
                  range3 = toMultiArray(range3);
                  const size = toNumberArray(dict.getArray("Size"));
                  const bps = dict.get("BitsPerSample");
                  const order = dict.get("Order") || 1;
                  if (order !== 1) {
                    (0, _util2.info)("No support for cubic spline interpolation: " + order);
                  }
                  let encode = toNumberArray(dict.getArray("Encode"));
                  if (!encode) {
                    encode = [];
                    for (let i = 0; i < inputSize; ++i) {
                      encode.push([0, size[i] - 1]);
                    }
                  } else {
                    encode = toMultiArray(encode);
                  }
                  let decode = toNumberArray(dict.getArray("Decode"));
                  decode = !decode ? range3 : toMultiArray(decode);
                  const samples = this.getSampleArray(size, outputSize, bps, fn);
                  return function constructSampledFn(src, srcOffset, dest, destOffset) {
                    const cubeVertices = 1 << inputSize;
                    const cubeN = new Float64Array(cubeVertices);
                    const cubeVertex = new Uint32Array(cubeVertices);
                    let i, j;
                    for (j = 0; j < cubeVertices; j++) {
                      cubeN[j] = 1;
                    }
                    let k = outputSize, pos = 1;
                    for (i = 0; i < inputSize; ++i) {
                      const domain_2i = domain[i][0];
                      const domain_2i_1 = domain[i][1];
                      const xi = Math.min(Math.max(src[srcOffset + i], domain_2i), domain_2i_1);
                      let e3 = interpolate(xi, domain_2i, domain_2i_1, encode[i][0], encode[i][1]);
                      const size_i = size[i];
                      e3 = Math.min(Math.max(e3, 0), size_i - 1);
                      const e0 = e3 < size_i - 1 ? Math.floor(e3) : e3 - 1;
                      const n0 = e0 + 1 - e3;
                      const n1 = e3 - e0;
                      const offset0 = e0 * k;
                      const offset1 = offset0 + k;
                      for (j = 0; j < cubeVertices; j++) {
                        if (j & pos) {
                          cubeN[j] *= n1;
                          cubeVertex[j] += offset1;
                        } else {
                          cubeN[j] *= n0;
                          cubeVertex[j] += offset0;
                        }
                      }
                      k *= size_i;
                      pos <<= 1;
                    }
                    for (j = 0; j < outputSize; ++j) {
                      let rj = 0;
                      for (i = 0; i < cubeVertices; i++) {
                        rj += samples[cubeVertex[i] + j] * cubeN[i];
                      }
                      rj = interpolate(rj, 0, 1, decode[j][0], decode[j][1]);
                      dest[destOffset + j] = Math.min(Math.max(rj, range3[j][0]), range3[j][1]);
                    }
                  };
                }
                static constructInterpolated({
                  xref,
                  isEvalSupported,
                  dict
                }) {
                  const c0 = toNumberArray(dict.getArray("C0")) || [0];
                  const c1 = toNumberArray(dict.getArray("C1")) || [1];
                  const n2 = dict.get("N");
                  const diff3 = [];
                  for (let i = 0, ii = c0.length; i < ii; ++i) {
                    diff3.push(c1[i] - c0[i]);
                  }
                  const length2 = diff3.length;
                  return function constructInterpolatedFn(src, srcOffset, dest, destOffset) {
                    const x = n2 === 1 ? src[srcOffset] : src[srcOffset] ** n2;
                    for (let j = 0; j < length2; ++j) {
                      dest[destOffset + j] = c0[j] + x * diff3[j];
                    }
                  };
                }
                static constructStiched({
                  xref,
                  isEvalSupported,
                  dict
                }) {
                  const domain = toNumberArray(dict.getArray("Domain"));
                  if (!domain) {
                    throw new _util2.FormatError("No domain");
                  }
                  const inputSize = domain.length / 2;
                  if (inputSize !== 1) {
                    throw new _util2.FormatError("Bad domain for stiched function");
                  }
                  const fns = [];
                  for (const fn of dict.get("Functions")) {
                    fns.push(this.parse({
                      xref,
                      isEvalSupported,
                      fn: xref.fetchIfRef(fn)
                    }));
                  }
                  const bounds = toNumberArray(dict.getArray("Bounds"));
                  const encode = toNumberArray(dict.getArray("Encode"));
                  const tmpBuf = new Float32Array(1);
                  return function constructStichedFn(src, srcOffset, dest, destOffset) {
                    const clip = function constructStichedFromIRClip(v2, min, max) {
                      if (v2 > max) {
                        v2 = max;
                      } else if (v2 < min) {
                        v2 = min;
                      }
                      return v2;
                    };
                    const v = clip(src[srcOffset], domain[0], domain[1]);
                    const length2 = bounds.length;
                    let i;
                    for (i = 0; i < length2; ++i) {
                      if (v < bounds[i]) {
                        break;
                      }
                    }
                    let dmin = domain[0];
                    if (i > 0) {
                      dmin = bounds[i - 1];
                    }
                    let dmax = domain[1];
                    if (i < bounds.length) {
                      dmax = bounds[i];
                    }
                    const rmin = encode[2 * i];
                    const rmax = encode[2 * i + 1];
                    tmpBuf[0] = dmin === dmax ? rmin : rmin + (v - dmin) * (rmax - rmin) / (dmax - dmin);
                    fns[i](tmpBuf, 0, dest, destOffset);
                  };
                }
                static constructPostScript({
                  xref,
                  isEvalSupported,
                  fn,
                  dict
                }) {
                  const domain = toNumberArray(dict.getArray("Domain"));
                  const range3 = toNumberArray(dict.getArray("Range"));
                  if (!domain) {
                    throw new _util2.FormatError("No domain.");
                  }
                  if (!range3) {
                    throw new _util2.FormatError("No range.");
                  }
                  const lexer = new _ps_parser.PostScriptLexer(fn);
                  const parser = new _ps_parser.PostScriptParser(lexer);
                  const code2 = parser.parse();
                  if (isEvalSupported && _util2.FeatureTest.isEvalSupported) {
                    const compiled = new PostScriptCompiler().compile(code2, domain, range3);
                    if (compiled) {
                      return new Function("src", "srcOffset", "dest", "destOffset", compiled);
                    }
                  }
                  (0, _util2.info)("Unable to compile PS function");
                  const numOutputs = range3.length >> 1;
                  const numInputs = domain.length >> 1;
                  const evaluator = new PostScriptEvaluator(code2);
                  const cache = /* @__PURE__ */ Object.create(null);
                  const MAX_CACHE_SIZE = 2048 * 4;
                  let cache_available = MAX_CACHE_SIZE;
                  const tmpBuf = new Float32Array(numInputs);
                  return function constructPostScriptFn(src, srcOffset, dest, destOffset) {
                    let i, value;
                    let key2 = "";
                    const input = tmpBuf;
                    for (i = 0; i < numInputs; i++) {
                      value = src[srcOffset + i];
                      input[i] = value;
                      key2 += value + "_";
                    }
                    const cachedValue = cache[key2];
                    if (cachedValue !== void 0) {
                      dest.set(cachedValue, destOffset);
                      return;
                    }
                    const output = new Float32Array(numOutputs);
                    const stack = evaluator.execute(input);
                    const stackIndex = stack.length - numOutputs;
                    for (i = 0; i < numOutputs; i++) {
                      value = stack[stackIndex + i];
                      let bound = range3[i * 2];
                      if (value < bound) {
                        value = bound;
                      } else {
                        bound = range3[i * 2 + 1];
                        if (value > bound) {
                          value = bound;
                        }
                      }
                      output[i] = value;
                    }
                    if (cache_available > 0) {
                      cache_available--;
                      cache[key2] = output;
                    }
                    dest.set(output, destOffset);
                  };
                }
              }
              function isPDFFunction(v) {
                let fnDict;
                if (v instanceof _primitives.Dict) {
                  fnDict = v;
                } else if (v instanceof _base_stream.BaseStream) {
                  fnDict = v.dict;
                } else {
                  return false;
                }
                return fnDict.has("FunctionType");
              }
              class PostScriptStack {
                static MAX_STACK_SIZE = 100;
                constructor(initialStack) {
                  this.stack = initialStack ? Array.from(initialStack) : [];
                }
                push(value) {
                  if (this.stack.length >= PostScriptStack.MAX_STACK_SIZE) {
                    throw new Error("PostScript function stack overflow.");
                  }
                  this.stack.push(value);
                }
                pop() {
                  if (this.stack.length <= 0) {
                    throw new Error("PostScript function stack underflow.");
                  }
                  return this.stack.pop();
                }
                copy(n2) {
                  if (this.stack.length + n2 >= PostScriptStack.MAX_STACK_SIZE) {
                    throw new Error("PostScript function stack overflow.");
                  }
                  const stack = this.stack;
                  for (let i = stack.length - n2, j = n2 - 1; j >= 0; j--, i++) {
                    stack.push(stack[i]);
                  }
                }
                index(n2) {
                  this.push(this.stack[this.stack.length - n2 - 1]);
                }
                roll(n2, p) {
                  const stack = this.stack;
                  const l2 = stack.length - n2;
                  const r2 = stack.length - 1;
                  const c = l2 + (p - Math.floor(p / n2) * n2);
                  for (let i = l2, j = r2; i < j; i++, j--) {
                    const t2 = stack[i];
                    stack[i] = stack[j];
                    stack[j] = t2;
                  }
                  for (let i = l2, j = c - 1; i < j; i++, j--) {
                    const t2 = stack[i];
                    stack[i] = stack[j];
                    stack[j] = t2;
                  }
                  for (let i = c, j = r2; i < j; i++, j--) {
                    const t2 = stack[i];
                    stack[i] = stack[j];
                    stack[j] = t2;
                  }
                }
              }
              class PostScriptEvaluator {
                constructor(operators) {
                  this.operators = operators;
                }
                execute(initialStack) {
                  const stack = new PostScriptStack(initialStack);
                  let counter2 = 0;
                  const operators = this.operators;
                  const length2 = operators.length;
                  let operator, a, b;
                  while (counter2 < length2) {
                    operator = operators[counter2++];
                    if (typeof operator === "number") {
                      stack.push(operator);
                      continue;
                    }
                    switch (operator) {
                      case "jz":
                        b = stack.pop();
                        a = stack.pop();
                        if (!a) {
                          counter2 = b;
                        }
                        break;
                      case "j":
                        a = stack.pop();
                        counter2 = a;
                        break;
                      case "abs":
                        a = stack.pop();
                        stack.push(Math.abs(a));
                        break;
                      case "add":
                        b = stack.pop();
                        a = stack.pop();
                        stack.push(a + b);
                        break;
                      case "and":
                        b = stack.pop();
                        a = stack.pop();
                        if (typeof a === "boolean" && typeof b === "boolean") {
                          stack.push(a && b);
                        } else {
                          stack.push(a & b);
                        }
                        break;
                      case "atan":
                        b = stack.pop();
                        a = stack.pop();
                        a = Math.atan2(a, b) / Math.PI * 180;
                        if (a < 0) {
                          a += 360;
                        }
                        stack.push(a);
                        break;
                      case "bitshift":
                        b = stack.pop();
                        a = stack.pop();
                        if (a > 0) {
                          stack.push(a << b);
                        } else {
                          stack.push(a >> b);
                        }
                        break;
                      case "ceiling":
                        a = stack.pop();
                        stack.push(Math.ceil(a));
                        break;
                      case "copy":
                        a = stack.pop();
                        stack.copy(a);
                        break;
                      case "cos":
                        a = stack.pop();
                        stack.push(Math.cos(a % 360 / 180 * Math.PI));
                        break;
                      case "cvi":
                        a = stack.pop() | 0;
                        stack.push(a);
                        break;
                      case "cvr":
                        break;
                      case "div":
                        b = stack.pop();
                        a = stack.pop();
                        stack.push(a / b);
                        break;
                      case "dup":
                        stack.copy(1);
                        break;
                      case "eq":
                        b = stack.pop();
                        a = stack.pop();
                        stack.push(a === b);
                        break;
                      case "exch":
                        stack.roll(2, 1);
                        break;
                      case "exp":
                        b = stack.pop();
                        a = stack.pop();
                        stack.push(a ** b);
                        break;
                      case "false":
                        stack.push(false);
                        break;
                      case "floor":
                        a = stack.pop();
                        stack.push(Math.floor(a));
                        break;
                      case "ge":
                        b = stack.pop();
                        a = stack.pop();
                        stack.push(a >= b);
                        break;
                      case "gt":
                        b = stack.pop();
                        a = stack.pop();
                        stack.push(a > b);
                        break;
                      case "idiv":
                        b = stack.pop();
                        a = stack.pop();
                        stack.push(a / b | 0);
                        break;
                      case "index":
                        a = stack.pop();
                        stack.index(a);
                        break;
                      case "le":
                        b = stack.pop();
                        a = stack.pop();
                        stack.push(a <= b);
                        break;
                      case "ln":
                        a = stack.pop();
                        stack.push(Math.log(a));
                        break;
                      case "log":
                        a = stack.pop();
                        stack.push(Math.log10(a));
                        break;
                      case "lt":
                        b = stack.pop();
                        a = stack.pop();
                        stack.push(a < b);
                        break;
                      case "mod":
                        b = stack.pop();
                        a = stack.pop();
                        stack.push(a % b);
                        break;
                      case "mul":
                        b = stack.pop();
                        a = stack.pop();
                        stack.push(a * b);
                        break;
                      case "ne":
                        b = stack.pop();
                        a = stack.pop();
                        stack.push(a !== b);
                        break;
                      case "neg":
                        a = stack.pop();
                        stack.push(-a);
                        break;
                      case "not":
                        a = stack.pop();
                        if (typeof a === "boolean") {
                          stack.push(!a);
                        } else {
                          stack.push(~a);
                        }
                        break;
                      case "or":
                        b = stack.pop();
                        a = stack.pop();
                        if (typeof a === "boolean" && typeof b === "boolean") {
                          stack.push(a || b);
                        } else {
                          stack.push(a | b);
                        }
                        break;
                      case "pop":
                        stack.pop();
                        break;
                      case "roll":
                        b = stack.pop();
                        a = stack.pop();
                        stack.roll(a, b);
                        break;
                      case "round":
                        a = stack.pop();
                        stack.push(Math.round(a));
                        break;
                      case "sin":
                        a = stack.pop();
                        stack.push(Math.sin(a % 360 / 180 * Math.PI));
                        break;
                      case "sqrt":
                        a = stack.pop();
                        stack.push(Math.sqrt(a));
                        break;
                      case "sub":
                        b = stack.pop();
                        a = stack.pop();
                        stack.push(a - b);
                        break;
                      case "true":
                        stack.push(true);
                        break;
                      case "truncate":
                        a = stack.pop();
                        a = a < 0 ? Math.ceil(a) : Math.floor(a);
                        stack.push(a);
                        break;
                      case "xor":
                        b = stack.pop();
                        a = stack.pop();
                        if (typeof a === "boolean" && typeof b === "boolean") {
                          stack.push(a !== b);
                        } else {
                          stack.push(a ^ b);
                        }
                        break;
                      default:
                        throw new _util2.FormatError(`Unknown operator ${operator}`);
                    }
                  }
                  return stack.stack;
                }
              }
              exports3.PostScriptEvaluator = PostScriptEvaluator;
              class AstNode {
                constructor(type5) {
                  this.type = type5;
                }
                visit(visitor) {
                  (0, _util2.unreachable)("abstract method");
                }
              }
              class AstArgument extends AstNode {
                constructor(index3, min, max) {
                  super("args");
                  this.index = index3;
                  this.min = min;
                  this.max = max;
                }
                visit(visitor) {
                  visitor.visitArgument(this);
                }
              }
              class AstLiteral extends AstNode {
                constructor(number4) {
                  super("literal");
                  this.number = number4;
                  this.min = number4;
                  this.max = number4;
                }
                visit(visitor) {
                  visitor.visitLiteral(this);
                }
              }
              class AstBinaryOperation extends AstNode {
                constructor(op, arg1, arg2, min, max) {
                  super("binary");
                  this.op = op;
                  this.arg1 = arg1;
                  this.arg2 = arg2;
                  this.min = min;
                  this.max = max;
                }
                visit(visitor) {
                  visitor.visitBinaryOperation(this);
                }
              }
              class AstMin extends AstNode {
                constructor(arg, max) {
                  super("max");
                  this.arg = arg;
                  this.min = arg.min;
                  this.max = max;
                }
                visit(visitor) {
                  visitor.visitMin(this);
                }
              }
              class AstVariable extends AstNode {
                constructor(index3, min, max) {
                  super("var");
                  this.index = index3;
                  this.min = min;
                  this.max = max;
                }
                visit(visitor) {
                  visitor.visitVariable(this);
                }
              }
              class AstVariableDefinition extends AstNode {
                constructor(variable, arg) {
                  super("definition");
                  this.variable = variable;
                  this.arg = arg;
                }
                visit(visitor) {
                  visitor.visitVariableDefinition(this);
                }
              }
              class ExpressionBuilderVisitor {
                constructor() {
                  this.parts = [];
                }
                visitArgument(arg) {
                  this.parts.push("Math.max(", arg.min, ", Math.min(", arg.max, ", src[srcOffset + ", arg.index, "]))");
                }
                visitVariable(variable) {
                  this.parts.push("v", variable.index);
                }
                visitLiteral(literal2) {
                  this.parts.push(literal2.number);
                }
                visitBinaryOperation(operation) {
                  this.parts.push("(");
                  operation.arg1.visit(this);
                  this.parts.push(" ", operation.op, " ");
                  operation.arg2.visit(this);
                  this.parts.push(")");
                }
                visitVariableDefinition(definition) {
                  this.parts.push("var ");
                  definition.variable.visit(this);
                  this.parts.push(" = ");
                  definition.arg.visit(this);
                  this.parts.push(";");
                }
                visitMin(max) {
                  this.parts.push("Math.min(");
                  max.arg.visit(this);
                  this.parts.push(", ", max.max, ")");
                }
                toString() {
                  return this.parts.join("");
                }
              }
              function buildAddOperation(num1, num2) {
                if (num2.type === "literal" && num2.number === 0) {
                  return num1;
                }
                if (num1.type === "literal" && num1.number === 0) {
                  return num2;
                }
                if (num2.type === "literal" && num1.type === "literal") {
                  return new AstLiteral(num1.number + num2.number);
                }
                return new AstBinaryOperation("+", num1, num2, num1.min + num2.min, num1.max + num2.max);
              }
              function buildMulOperation(num1, num2) {
                if (num2.type === "literal") {
                  if (num2.number === 0) {
                    return new AstLiteral(0);
                  } else if (num2.number === 1) {
                    return num1;
                  } else if (num1.type === "literal") {
                    return new AstLiteral(num1.number * num2.number);
                  }
                }
                if (num1.type === "literal") {
                  if (num1.number === 0) {
                    return new AstLiteral(0);
                  } else if (num1.number === 1) {
                    return num2;
                  }
                }
                const min = Math.min(num1.min * num2.min, num1.min * num2.max, num1.max * num2.min, num1.max * num2.max);
                const max = Math.max(num1.min * num2.min, num1.min * num2.max, num1.max * num2.min, num1.max * num2.max);
                return new AstBinaryOperation("*", num1, num2, min, max);
              }
              function buildSubOperation(num1, num2) {
                if (num2.type === "literal") {
                  if (num2.number === 0) {
                    return num1;
                  } else if (num1.type === "literal") {
                    return new AstLiteral(num1.number - num2.number);
                  }
                }
                if (num2.type === "binary" && num2.op === "-" && num1.type === "literal" && num1.number === 1 && num2.arg1.type === "literal" && num2.arg1.number === 1) {
                  return num2.arg2;
                }
                return new AstBinaryOperation("-", num1, num2, num1.min - num2.max, num1.max - num2.min);
              }
              function buildMinOperation(num1, max) {
                if (num1.min >= max) {
                  return new AstLiteral(max);
                } else if (num1.max <= max) {
                  return num1;
                }
                return new AstMin(num1, max);
              }
              class PostScriptCompiler {
                compile(code2, domain, range3) {
                  const stack = [];
                  const instructions = [];
                  const inputSize = domain.length >> 1, outputSize = range3.length >> 1;
                  let lastRegister = 0;
                  let n2, j;
                  let num1, num2, ast1, ast2, tmpVar, item;
                  for (let i = 0; i < inputSize; i++) {
                    stack.push(new AstArgument(i, domain[i * 2], domain[i * 2 + 1]));
                  }
                  for (let i = 0, ii = code2.length; i < ii; i++) {
                    item = code2[i];
                    if (typeof item === "number") {
                      stack.push(new AstLiteral(item));
                      continue;
                    }
                    switch (item) {
                      case "add":
                        if (stack.length < 2) {
                          return null;
                        }
                        num2 = stack.pop();
                        num1 = stack.pop();
                        stack.push(buildAddOperation(num1, num2));
                        break;
                      case "cvr":
                        if (stack.length < 1) {
                          return null;
                        }
                        break;
                      case "mul":
                        if (stack.length < 2) {
                          return null;
                        }
                        num2 = stack.pop();
                        num1 = stack.pop();
                        stack.push(buildMulOperation(num1, num2));
                        break;
                      case "sub":
                        if (stack.length < 2) {
                          return null;
                        }
                        num2 = stack.pop();
                        num1 = stack.pop();
                        stack.push(buildSubOperation(num1, num2));
                        break;
                      case "exch":
                        if (stack.length < 2) {
                          return null;
                        }
                        ast1 = stack.pop();
                        ast2 = stack.pop();
                        stack.push(ast1, ast2);
                        break;
                      case "pop":
                        if (stack.length < 1) {
                          return null;
                        }
                        stack.pop();
                        break;
                      case "index":
                        if (stack.length < 1) {
                          return null;
                        }
                        num1 = stack.pop();
                        if (num1.type !== "literal") {
                          return null;
                        }
                        n2 = num1.number;
                        if (n2 < 0 || !Number.isInteger(n2) || stack.length < n2) {
                          return null;
                        }
                        ast1 = stack[stack.length - n2 - 1];
                        if (ast1.type === "literal" || ast1.type === "var") {
                          stack.push(ast1);
                          break;
                        }
                        tmpVar = new AstVariable(lastRegister++, ast1.min, ast1.max);
                        stack[stack.length - n2 - 1] = tmpVar;
                        stack.push(tmpVar);
                        instructions.push(new AstVariableDefinition(tmpVar, ast1));
                        break;
                      case "dup":
                        if (stack.length < 1) {
                          return null;
                        }
                        if (typeof code2[i + 1] === "number" && code2[i + 2] === "gt" && code2[i + 3] === i + 7 && code2[i + 4] === "jz" && code2[i + 5] === "pop" && code2[i + 6] === code2[i + 1]) {
                          num1 = stack.pop();
                          stack.push(buildMinOperation(num1, code2[i + 1]));
                          i += 6;
                          break;
                        }
                        ast1 = stack.at(-1);
                        if (ast1.type === "literal" || ast1.type === "var") {
                          stack.push(ast1);
                          break;
                        }
                        tmpVar = new AstVariable(lastRegister++, ast1.min, ast1.max);
                        stack[stack.length - 1] = tmpVar;
                        stack.push(tmpVar);
                        instructions.push(new AstVariableDefinition(tmpVar, ast1));
                        break;
                      case "roll":
                        if (stack.length < 2) {
                          return null;
                        }
                        num2 = stack.pop();
                        num1 = stack.pop();
                        if (num2.type !== "literal" || num1.type !== "literal") {
                          return null;
                        }
                        j = num2.number;
                        n2 = num1.number;
                        if (n2 <= 0 || !Number.isInteger(n2) || !Number.isInteger(j) || stack.length < n2) {
                          return null;
                        }
                        j = (j % n2 + n2) % n2;
                        if (j === 0) {
                          break;
                        }
                        stack.push(...stack.splice(stack.length - n2, n2 - j));
                        break;
                      default:
                        return null;
                    }
                  }
                  if (stack.length !== outputSize) {
                    return null;
                  }
                  const result = [];
                  for (const instruction of instructions) {
                    const statementBuilder = new ExpressionBuilderVisitor();
                    instruction.visit(statementBuilder);
                    result.push(statementBuilder.toString());
                  }
                  for (let i = 0, ii = stack.length; i < ii; i++) {
                    const expr = stack[i], statementBuilder = new ExpressionBuilderVisitor();
                    expr.visit(statementBuilder);
                    const min = range3[i * 2], max = range3[i * 2 + 1];
                    const out = [statementBuilder.toString()];
                    if (min > expr.min) {
                      out.unshift("Math.max(", min, ", ");
                      out.push(")");
                    }
                    if (max < expr.max) {
                      out.unshift("Math.min(", max, ", ");
                      out.push(")");
                    }
                    out.unshift("dest[destOffset + ", i, "] = ");
                    out.push(";");
                    result.push(out.join(""));
                  }
                  return result.join("\n");
                }
              }
              exports3.PostScriptCompiler = PostScriptCompiler;
            }),
            /* 58 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.PostScriptParser = exports3.PostScriptLexer = void 0;
              var _util2 = __w_pdfjs_require__3(2);
              var _primitives = __w_pdfjs_require__3(4);
              var _core_utils = __w_pdfjs_require__3(3);
              class PostScriptParser {
                constructor(lexer) {
                  this.lexer = lexer;
                  this.operators = [];
                  this.token = null;
                  this.prev = null;
                }
                nextToken() {
                  this.prev = this.token;
                  this.token = this.lexer.getToken();
                }
                accept(type5) {
                  if (this.token.type === type5) {
                    this.nextToken();
                    return true;
                  }
                  return false;
                }
                expect(type5) {
                  if (this.accept(type5)) {
                    return true;
                  }
                  throw new _util2.FormatError(`Unexpected symbol: found ${this.token.type} expected ${type5}.`);
                }
                parse() {
                  this.nextToken();
                  this.expect(PostScriptTokenTypes.LBRACE);
                  this.parseBlock();
                  this.expect(PostScriptTokenTypes.RBRACE);
                  return this.operators;
                }
                parseBlock() {
                  while (true) {
                    if (this.accept(PostScriptTokenTypes.NUMBER)) {
                      this.operators.push(this.prev.value);
                    } else if (this.accept(PostScriptTokenTypes.OPERATOR)) {
                      this.operators.push(this.prev.value);
                    } else if (this.accept(PostScriptTokenTypes.LBRACE)) {
                      this.parseCondition();
                    } else {
                      return;
                    }
                  }
                }
                parseCondition() {
                  const conditionLocation = this.operators.length;
                  this.operators.push(null, null);
                  this.parseBlock();
                  this.expect(PostScriptTokenTypes.RBRACE);
                  if (this.accept(PostScriptTokenTypes.IF)) {
                    this.operators[conditionLocation] = this.operators.length;
                    this.operators[conditionLocation + 1] = "jz";
                  } else if (this.accept(PostScriptTokenTypes.LBRACE)) {
                    const jumpLocation = this.operators.length;
                    this.operators.push(null, null);
                    const endOfTrue = this.operators.length;
                    this.parseBlock();
                    this.expect(PostScriptTokenTypes.RBRACE);
                    this.expect(PostScriptTokenTypes.IFELSE);
                    this.operators[jumpLocation] = this.operators.length;
                    this.operators[jumpLocation + 1] = "j";
                    this.operators[conditionLocation] = endOfTrue;
                    this.operators[conditionLocation + 1] = "jz";
                  } else {
                    throw new _util2.FormatError("PS Function: error parsing conditional.");
                  }
                }
              }
              exports3.PostScriptParser = PostScriptParser;
              const PostScriptTokenTypes = {
                LBRACE: 0,
                RBRACE: 1,
                NUMBER: 2,
                OPERATOR: 3,
                IF: 4,
                IFELSE: 5
              };
              class PostScriptToken {
                static get opCache() {
                  return (0, _util2.shadow)(this, "opCache", /* @__PURE__ */ Object.create(null));
                }
                constructor(type5, value) {
                  this.type = type5;
                  this.value = value;
                }
                static getOperator(op) {
                  return PostScriptToken.opCache[op] ||= new PostScriptToken(PostScriptTokenTypes.OPERATOR, op);
                }
                static get LBRACE() {
                  return (0, _util2.shadow)(this, "LBRACE", new PostScriptToken(PostScriptTokenTypes.LBRACE, "{"));
                }
                static get RBRACE() {
                  return (0, _util2.shadow)(this, "RBRACE", new PostScriptToken(PostScriptTokenTypes.RBRACE, "}"));
                }
                static get IF() {
                  return (0, _util2.shadow)(this, "IF", new PostScriptToken(PostScriptTokenTypes.IF, "IF"));
                }
                static get IFELSE() {
                  return (0, _util2.shadow)(this, "IFELSE", new PostScriptToken(PostScriptTokenTypes.IFELSE, "IFELSE"));
                }
              }
              class PostScriptLexer {
                constructor(stream) {
                  this.stream = stream;
                  this.nextChar();
                  this.strBuf = [];
                }
                nextChar() {
                  return this.currentChar = this.stream.getByte();
                }
                getToken() {
                  let comment2 = false;
                  let ch = this.currentChar;
                  while (true) {
                    if (ch < 0) {
                      return _primitives.EOF;
                    }
                    if (comment2) {
                      if (ch === 10 || ch === 13) {
                        comment2 = false;
                      }
                    } else if (ch === 37) {
                      comment2 = true;
                    } else if (!(0, _core_utils.isWhiteSpace)(ch)) {
                      break;
                    }
                    ch = this.nextChar();
                  }
                  switch (ch | 0) {
                    case 48:
                    case 49:
                    case 50:
                    case 51:
                    case 52:
                    case 53:
                    case 54:
                    case 55:
                    case 56:
                    case 57:
                    case 43:
                    case 45:
                    case 46:
                      return new PostScriptToken(PostScriptTokenTypes.NUMBER, this.getNumber());
                    case 123:
                      this.nextChar();
                      return PostScriptToken.LBRACE;
                    case 125:
                      this.nextChar();
                      return PostScriptToken.RBRACE;
                  }
                  const strBuf = this.strBuf;
                  strBuf.length = 0;
                  strBuf[0] = String.fromCharCode(ch);
                  while ((ch = this.nextChar()) >= 0 && (ch >= 65 && ch <= 90 || ch >= 97 && ch <= 122)) {
                    strBuf.push(String.fromCharCode(ch));
                  }
                  const str = strBuf.join("");
                  switch (str.toLowerCase()) {
                    case "if":
                      return PostScriptToken.IF;
                    case "ifelse":
                      return PostScriptToken.IFELSE;
                    default:
                      return PostScriptToken.getOperator(str);
                  }
                }
                getNumber() {
                  let ch = this.currentChar;
                  const strBuf = this.strBuf;
                  strBuf.length = 0;
                  strBuf[0] = String.fromCharCode(ch);
                  while ((ch = this.nextChar()) >= 0) {
                    if (ch >= 48 && ch <= 57 || ch === 45 || ch === 46) {
                      strBuf.push(String.fromCharCode(ch));
                    } else {
                      break;
                    }
                  }
                  const value = parseFloat(strBuf.join(""));
                  if (isNaN(value)) {
                    throw new _util2.FormatError(`Invalid floating point number: ${value}`);
                  }
                  return value;
                }
              }
              exports3.PostScriptLexer = PostScriptLexer;
            }),
            /* 59 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.RegionalImageCache = exports3.LocalTilingPatternCache = exports3.LocalImageCache = exports3.LocalGStateCache = exports3.LocalFunctionCache = exports3.LocalColorSpaceCache = exports3.GlobalImageCache = void 0;
              var _util2 = __w_pdfjs_require__3(2);
              var _primitives = __w_pdfjs_require__3(4);
              class BaseLocalCache {
                constructor(options) {
                  if (this.constructor === BaseLocalCache) {
                    (0, _util2.unreachable)("Cannot initialize BaseLocalCache.");
                  }
                  this._onlyRefs = options?.onlyRefs === true;
                  if (!this._onlyRefs) {
                    this._nameRefMap = /* @__PURE__ */ new Map();
                    this._imageMap = /* @__PURE__ */ new Map();
                  }
                  this._imageCache = new _primitives.RefSetCache();
                }
                getByName(name) {
                  if (this._onlyRefs) {
                    (0, _util2.unreachable)("Should not call `getByName` method.");
                  }
                  const ref3 = this._nameRefMap.get(name);
                  if (ref3) {
                    return this.getByRef(ref3);
                  }
                  return this._imageMap.get(name) || null;
                }
                getByRef(ref3) {
                  return this._imageCache.get(ref3) || null;
                }
                set(name, ref3, data2) {
                  (0, _util2.unreachable)("Abstract method `set` called.");
                }
              }
              class LocalImageCache extends BaseLocalCache {
                set(name, ref3 = null, data2) {
                  if (typeof name !== "string") {
                    throw new Error('LocalImageCache.set - expected "name" argument.');
                  }
                  if (ref3) {
                    if (this._imageCache.has(ref3)) {
                      return;
                    }
                    this._nameRefMap.set(name, ref3);
                    this._imageCache.put(ref3, data2);
                    return;
                  }
                  if (this._imageMap.has(name)) {
                    return;
                  }
                  this._imageMap.set(name, data2);
                }
              }
              exports3.LocalImageCache = LocalImageCache;
              class LocalColorSpaceCache extends BaseLocalCache {
                set(name = null, ref3 = null, data2) {
                  if (typeof name !== "string" && !ref3) {
                    throw new Error('LocalColorSpaceCache.set - expected "name" and/or "ref" argument.');
                  }
                  if (ref3) {
                    if (this._imageCache.has(ref3)) {
                      return;
                    }
                    if (name !== null) {
                      this._nameRefMap.set(name, ref3);
                    }
                    this._imageCache.put(ref3, data2);
                    return;
                  }
                  if (this._imageMap.has(name)) {
                    return;
                  }
                  this._imageMap.set(name, data2);
                }
              }
              exports3.LocalColorSpaceCache = LocalColorSpaceCache;
              class LocalFunctionCache extends BaseLocalCache {
                constructor(options) {
                  super({
                    onlyRefs: true
                  });
                }
                set(name = null, ref3, data2) {
                  if (!ref3) {
                    throw new Error('LocalFunctionCache.set - expected "ref" argument.');
                  }
                  if (this._imageCache.has(ref3)) {
                    return;
                  }
                  this._imageCache.put(ref3, data2);
                }
              }
              exports3.LocalFunctionCache = LocalFunctionCache;
              class LocalGStateCache extends BaseLocalCache {
                set(name, ref3 = null, data2) {
                  if (typeof name !== "string") {
                    throw new Error('LocalGStateCache.set - expected "name" argument.');
                  }
                  if (ref3) {
                    if (this._imageCache.has(ref3)) {
                      return;
                    }
                    this._nameRefMap.set(name, ref3);
                    this._imageCache.put(ref3, data2);
                    return;
                  }
                  if (this._imageMap.has(name)) {
                    return;
                  }
                  this._imageMap.set(name, data2);
                }
              }
              exports3.LocalGStateCache = LocalGStateCache;
              class LocalTilingPatternCache extends BaseLocalCache {
                constructor(options) {
                  super({
                    onlyRefs: true
                  });
                }
                set(name = null, ref3, data2) {
                  if (!ref3) {
                    throw new Error('LocalTilingPatternCache.set - expected "ref" argument.');
                  }
                  if (this._imageCache.has(ref3)) {
                    return;
                  }
                  this._imageCache.put(ref3, data2);
                }
              }
              exports3.LocalTilingPatternCache = LocalTilingPatternCache;
              class RegionalImageCache extends BaseLocalCache {
                constructor(options) {
                  super({
                    onlyRefs: true
                  });
                }
                set(name = null, ref3, data2) {
                  if (!ref3) {
                    throw new Error('RegionalImageCache.set - expected "ref" argument.');
                  }
                  if (this._imageCache.has(ref3)) {
                    return;
                  }
                  this._imageCache.put(ref3, data2);
                }
              }
              exports3.RegionalImageCache = RegionalImageCache;
              class GlobalImageCache {
                static NUM_PAGES_THRESHOLD = 2;
                static MIN_IMAGES_TO_CACHE = 10;
                static MAX_BYTE_SIZE = 5 * _util2.MAX_IMAGE_SIZE_TO_CACHE;
                constructor() {
                  this._refCache = new _primitives.RefSetCache();
                  this._imageCache = new _primitives.RefSetCache();
                }
                get _byteSize() {
                  let byteSize = 0;
                  for (const imageData of this._imageCache) {
                    byteSize += imageData.byteSize;
                  }
                  return byteSize;
                }
                get _cacheLimitReached() {
                  if (this._imageCache.size < GlobalImageCache.MIN_IMAGES_TO_CACHE) {
                    return false;
                  }
                  if (this._byteSize < GlobalImageCache.MAX_BYTE_SIZE) {
                    return false;
                  }
                  return true;
                }
                shouldCache(ref3, pageIndex) {
                  let pageIndexSet = this._refCache.get(ref3);
                  if (!pageIndexSet) {
                    pageIndexSet = /* @__PURE__ */ new Set();
                    this._refCache.put(ref3, pageIndexSet);
                  }
                  pageIndexSet.add(pageIndex);
                  if (pageIndexSet.size < GlobalImageCache.NUM_PAGES_THRESHOLD) {
                    return false;
                  }
                  if (!this._imageCache.has(ref3) && this._cacheLimitReached) {
                    return false;
                  }
                  return true;
                }
                addByteSize(ref3, byteSize) {
                  const imageData = this._imageCache.get(ref3);
                  if (!imageData) {
                    return;
                  }
                  if (imageData.byteSize) {
                    return;
                  }
                  imageData.byteSize = byteSize;
                }
                getData(ref3, pageIndex) {
                  const pageIndexSet = this._refCache.get(ref3);
                  if (!pageIndexSet) {
                    return null;
                  }
                  if (pageIndexSet.size < GlobalImageCache.NUM_PAGES_THRESHOLD) {
                    return null;
                  }
                  const imageData = this._imageCache.get(ref3);
                  if (!imageData) {
                    return null;
                  }
                  pageIndexSet.add(pageIndex);
                  return imageData;
                }
                setData(ref3, data2) {
                  if (!this._refCache.has(ref3)) {
                    throw new Error('GlobalImageCache.setData - expected "shouldCache" to have been called.');
                  }
                  if (this._imageCache.has(ref3)) {
                    return;
                  }
                  if (this._cacheLimitReached) {
                    (0, _util2.warn)("GlobalImageCache.setData - cache limit reached.");
                    return;
                  }
                  this._imageCache.put(ref3, data2);
                }
                clear(onlyData = false) {
                  if (!onlyData) {
                    this._refCache.clear();
                  }
                  this._imageCache.clear();
                }
              }
              exports3.GlobalImageCache = GlobalImageCache;
            }),
            /* 60 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.bidi = bidi;
              var _util2 = __w_pdfjs_require__3(2);
              const baseTypes = ["BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "S", "B", "S", "WS", "B", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "B", "B", "B", "S", "WS", "ON", "ON", "ET", "ET", "ET", "ON", "ON", "ON", "ON", "ON", "ES", "CS", "ES", "CS", "CS", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "CS", "ON", "ON", "ON", "ON", "ON", "ON", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "ON", "ON", "ON", "ON", "ON", "ON", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "ON", "ON", "ON", "ON", "BN", "BN", "BN", "BN", "BN", "BN", "B", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "CS", "ON", "ET", "ET", "ET", "ET", "ON", "ON", "ON", "ON", "L", "ON", "ON", "BN", "ON", "ON", "ET", "ET", "EN", "EN", "ON", "L", "ON", "ON", "ON", "EN", "L", "ON", "ON", "ON", "ON", "ON", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "ON", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "ON", "L", "L", "L", "L", "L", "L", "L", "L"];
              const arabicTypes = ["AN", "AN", "AN", "AN", "AN", "AN", "ON", "ON", "AL", "ET", "ET", "AL", "CS", "AL", "ON", "ON", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AL", "AL", "", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "ET", "AN", "AN", "AL", "AL", "AL", "NSM", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AN", "ON", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AL", "AL", "NSM", "NSM", "ON", "NSM", "NSM", "NSM", "NSM", "AL", "AL", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "AL", "AL", "AL", "AL", "AL", "AL"];
              function isOdd(i) {
                return (i & 1) !== 0;
              }
              function isEven(i) {
                return (i & 1) === 0;
              }
              function findUnequal(arr, start, value) {
                let j, jj;
                for (j = start, jj = arr.length; j < jj; ++j) {
                  if (arr[j] !== value) {
                    return j;
                  }
                }
                return j;
              }
              function setValues(arr, start, end, value) {
                for (let j = start; j < end; ++j) {
                  arr[j] = value;
                }
              }
              function reverseValues(arr, start, end) {
                for (let i = start, j = end - 1; i < j; ++i, --j) {
                  const temp = arr[i];
                  arr[i] = arr[j];
                  arr[j] = temp;
                }
              }
              function createBidiText(str, isLTR, vertical = false) {
                let dir = "ltr";
                if (vertical) {
                  dir = "ttb";
                } else if (!isLTR) {
                  dir = "rtl";
                }
                return {
                  str,
                  dir
                };
              }
              const chars = [];
              const types3 = [];
              function bidi(str, startLevel = -1, vertical = false) {
                let isLTR = true;
                const strLength = str.length;
                if (strLength === 0 || vertical) {
                  return createBidiText(str, isLTR, vertical);
                }
                chars.length = strLength;
                types3.length = strLength;
                let numBidi = 0;
                let i, ii;
                for (i = 0; i < strLength; ++i) {
                  chars[i] = str.charAt(i);
                  const charCode = str.charCodeAt(i);
                  let charType = "L";
                  if (charCode <= 255) {
                    charType = baseTypes[charCode];
                  } else if (1424 <= charCode && charCode <= 1524) {
                    charType = "R";
                  } else if (1536 <= charCode && charCode <= 1791) {
                    charType = arabicTypes[charCode & 255];
                    if (!charType) {
                      (0, _util2.warn)("Bidi: invalid Unicode character " + charCode.toString(16));
                    }
                  } else if (1792 <= charCode && charCode <= 2220 || 64336 <= charCode && charCode <= 65023 || 65136 <= charCode && charCode <= 65279) {
                    charType = "AL";
                  }
                  if (charType === "R" || charType === "AL" || charType === "AN") {
                    numBidi++;
                  }
                  types3[i] = charType;
                }
                if (numBidi === 0) {
                  isLTR = true;
                  return createBidiText(str, isLTR);
                }
                if (startLevel === -1) {
                  if (numBidi / strLength < 0.3 && strLength > 4) {
                    isLTR = true;
                    startLevel = 0;
                  } else {
                    isLTR = false;
                    startLevel = 1;
                  }
                }
                const levels = [];
                for (i = 0; i < strLength; ++i) {
                  levels[i] = startLevel;
                }
                const e3 = isOdd(startLevel) ? "R" : "L";
                const sor = e3;
                const eor = sor;
                let lastType = sor;
                for (i = 0; i < strLength; ++i) {
                  if (types3[i] === "NSM") {
                    types3[i] = lastType;
                  } else {
                    lastType = types3[i];
                  }
                }
                lastType = sor;
                let t2;
                for (i = 0; i < strLength; ++i) {
                  t2 = types3[i];
                  if (t2 === "EN") {
                    types3[i] = lastType === "AL" ? "AN" : "EN";
                  } else if (t2 === "R" || t2 === "L" || t2 === "AL") {
                    lastType = t2;
                  }
                }
                for (i = 0; i < strLength; ++i) {
                  t2 = types3[i];
                  if (t2 === "AL") {
                    types3[i] = "R";
                  }
                }
                for (i = 1; i < strLength - 1; ++i) {
                  if (types3[i] === "ES" && types3[i - 1] === "EN" && types3[i + 1] === "EN") {
                    types3[i] = "EN";
                  }
                  if (types3[i] === "CS" && (types3[i - 1] === "EN" || types3[i - 1] === "AN") && types3[i + 1] === types3[i - 1]) {
                    types3[i] = types3[i - 1];
                  }
                }
                for (i = 0; i < strLength; ++i) {
                  if (types3[i] === "EN") {
                    for (let j = i - 1; j >= 0; --j) {
                      if (types3[j] !== "ET") {
                        break;
                      }
                      types3[j] = "EN";
                    }
                    for (let j = i + 1; j < strLength; ++j) {
                      if (types3[j] !== "ET") {
                        break;
                      }
                      types3[j] = "EN";
                    }
                  }
                }
                for (i = 0; i < strLength; ++i) {
                  t2 = types3[i];
                  if (t2 === "WS" || t2 === "ES" || t2 === "ET" || t2 === "CS") {
                    types3[i] = "ON";
                  }
                }
                lastType = sor;
                for (i = 0; i < strLength; ++i) {
                  t2 = types3[i];
                  if (t2 === "EN") {
                    types3[i] = lastType === "L" ? "L" : "EN";
                  } else if (t2 === "R" || t2 === "L") {
                    lastType = t2;
                  }
                }
                for (i = 0; i < strLength; ++i) {
                  if (types3[i] === "ON") {
                    const end = findUnequal(types3, i + 1, "ON");
                    let before = sor;
                    if (i > 0) {
                      before = types3[i - 1];
                    }
                    let after = eor;
                    if (end + 1 < strLength) {
                      after = types3[end + 1];
                    }
                    if (before !== "L") {
                      before = "R";
                    }
                    if (after !== "L") {
                      after = "R";
                    }
                    if (before === after) {
                      setValues(types3, i, end, before);
                    }
                    i = end - 1;
                  }
                }
                for (i = 0; i < strLength; ++i) {
                  if (types3[i] === "ON") {
                    types3[i] = e3;
                  }
                }
                for (i = 0; i < strLength; ++i) {
                  t2 = types3[i];
                  if (isEven(levels[i])) {
                    if (t2 === "R") {
                      levels[i] += 1;
                    } else if (t2 === "AN" || t2 === "EN") {
                      levels[i] += 2;
                    }
                  } else if (t2 === "L" || t2 === "AN" || t2 === "EN") {
                    levels[i] += 1;
                  }
                }
                let highestLevel = -1;
                let lowestOddLevel = 99;
                let level;
                for (i = 0, ii = levels.length; i < ii; ++i) {
                  level = levels[i];
                  if (highestLevel < level) {
                    highestLevel = level;
                  }
                  if (lowestOddLevel > level && isOdd(level)) {
                    lowestOddLevel = level;
                  }
                }
                for (level = highestLevel; level >= lowestOddLevel; --level) {
                  let start = -1;
                  for (i = 0, ii = levels.length; i < ii; ++i) {
                    if (levels[i] < level) {
                      if (start >= 0) {
                        reverseValues(chars, start, i);
                        start = -1;
                      }
                    } else if (start < 0) {
                      start = i;
                    }
                  }
                  if (start >= 0) {
                    reverseValues(chars, start, levels.length);
                  }
                }
                for (i = 0, ii = chars.length; i < ii; ++i) {
                  const ch = chars[i];
                  if (ch === "<" || ch === ">") {
                    chars[i] = "";
                  }
                }
                return createBidiText(chars.join(""), isLTR);
              }
            }),
            /* 61 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.getFontSubstitution = getFontSubstitution;
              var _fonts_utils = __w_pdfjs_require__3(38);
              var _core_utils = __w_pdfjs_require__3(3);
              const NORMAL = {
                style: "normal",
                weight: "normal"
              };
              const BOLD = {
                style: "normal",
                weight: "bold"
              };
              const ITALIC = {
                style: "italic",
                weight: "normal"
              };
              const BOLDITALIC = {
                style: "italic",
                weight: "bold"
              };
              const substitutionMap = /* @__PURE__ */ new Map([["Times-Roman", {
                local: ["Times New Roman", "Times-Roman", "Times", "Liberation Serif", "Nimbus Roman", "Nimbus Roman L", "Tinos", "Thorndale", "TeX Gyre Termes", "FreeSerif", "DejaVu Serif", "Bitstream Vera Serif", "Ubuntu"],
                style: NORMAL,
                ultimate: "serif"
              }], ["Times-Bold", {
                alias: "Times-Roman",
                style: BOLD,
                ultimate: "serif"
              }], ["Times-Italic", {
                alias: "Times-Roman",
                style: ITALIC,
                ultimate: "serif"
              }], ["Times-BoldItalic", {
                alias: "Times-Roman",
                style: BOLDITALIC,
                ultimate: "serif"
              }], ["Helvetica", {
                local: ["Helvetica", "Helvetica Neue", "Arial", "Arial Nova", "Liberation Sans", "Arimo", "Nimbus Sans", "Nimbus Sans L", "A030", "TeX Gyre Heros", "FreeSans", "DejaVu Sans", "Albany", "Bitstream Vera Sans", "Arial Unicode MS", "Microsoft Sans Serif", "Apple Symbols", "Cantarell"],
                path: "LiberationSans-Regular.ttf",
                style: NORMAL,
                ultimate: "sans-serif"
              }], ["Helvetica-Bold", {
                alias: "Helvetica",
                path: "LiberationSans-Bold.ttf",
                style: BOLD,
                ultimate: "sans-serif"
              }], ["Helvetica-Oblique", {
                alias: "Helvetica",
                path: "LiberationSans-Italic.ttf",
                style: ITALIC,
                ultimate: "sans-serif"
              }], ["Helvetica-BoldOblique", {
                alias: "Helvetica",
                path: "LiberationSans-BoldItalic.ttf",
                style: BOLDITALIC,
                ultimate: "sans-serif"
              }], ["Courier", {
                local: ["Courier", "Courier New", "Liberation Mono", "Nimbus Mono", "Nimbus Mono L", "Cousine", "Cumberland", "TeX Gyre Cursor", "FreeMono"],
                style: NORMAL,
                ultimate: "monospace"
              }], ["Courier-Bold", {
                alias: "Courier",
                style: BOLD,
                ultimate: "monospace"
              }], ["Courier-Oblique", {
                alias: "Courier",
                style: ITALIC,
                ultimate: "monospace"
              }], ["Courier-BoldOblique", {
                alias: "Courier",
                style: BOLDITALIC,
                ultimate: "monospace"
              }], ["ArialBlack", {
                local: ["Arial Black"],
                style: {
                  style: "normal",
                  weight: "900"
                },
                fallback: "Helvetica-Bold"
              }], ["ArialBlack-Bold", {
                alias: "ArialBlack"
              }], ["ArialBlack-Italic", {
                alias: "ArialBlack",
                style: {
                  style: "italic",
                  weight: "900"
                },
                fallback: "Helvetica-BoldOblique"
              }], ["ArialBlack-BoldItalic", {
                alias: "ArialBlack-Italic"
              }], ["ArialNarrow", {
                local: ["Arial Narrow", "Liberation Sans Narrow", "Helvetica Condensed", "Nimbus Sans Narrow", "TeX Gyre Heros Cn"],
                style: NORMAL,
                fallback: "Helvetica"
              }], ["ArialNarrow-Bold", {
                alias: "ArialNarrow",
                style: BOLD,
                fallback: "Helvetica-Bold"
              }], ["ArialNarrow-Italic", {
                alias: "ArialNarrow",
                style: ITALIC,
                fallback: "Helvetica-Oblique"
              }], ["ArialNarrow-BoldItalic", {
                alias: "ArialNarrow",
                style: BOLDITALIC,
                fallback: "Helvetica-BoldOblique"
              }], ["Calibri", {
                local: ["Calibri", "Carlito"],
                style: NORMAL,
                fallback: "Helvetica"
              }], ["Calibri-Bold", {
                alias: "Calibri",
                style: BOLD,
                fallback: "Helvetica-Bold"
              }], ["Calibri-Italic", {
                alias: "Calibri",
                style: ITALIC,
                fallback: "Helvetica-Oblique"
              }], ["Calibri-BoldItalic", {
                alias: "Calibri",
                style: BOLDITALIC,
                fallback: "Helvetica-BoldOblique"
              }], ["Wingdings", {
                local: ["Wingdings", "URW Dingbats"],
                style: NORMAL
              }], ["Wingdings-Regular", {
                alias: "Wingdings"
              }], ["Wingdings-Bold", {
                alias: "Wingdings"
              }]]);
              const fontAliases = /* @__PURE__ */ new Map([["Arial-Black", "ArialBlack"]]);
              function getStyleToAppend(style2) {
                switch (style2) {
                  case BOLD:
                    return "Bold";
                  case ITALIC:
                    return "Italic";
                  case BOLDITALIC:
                    return "Bold Italic";
                  default:
                    if (style2?.weight === "bold") {
                      return "Bold";
                    }
                    if (style2?.style === "italic") {
                      return "Italic";
                    }
                }
                return "";
              }
              function generateFont({
                alias,
                local,
                path: path2,
                fallback,
                style: style2,
                ultimate
              }, src, localFontPath, useFallback = true, usePath = true, append2 = "") {
                const result = {
                  style: null,
                  ultimate: null
                };
                if (local) {
                  const extra = append2 ? ` ${append2}` : "";
                  for (const name of local) {
                    src.push(`local(${name}${extra})`);
                  }
                }
                if (alias) {
                  const substitution = substitutionMap.get(alias);
                  const aliasAppend = append2 || getStyleToAppend(style2);
                  Object.assign(result, generateFont(substitution, src, localFontPath, useFallback && !fallback, usePath && !path2, aliasAppend));
                }
                if (style2) {
                  result.style = style2;
                }
                if (ultimate) {
                  result.ultimate = ultimate;
                }
                if (useFallback && fallback) {
                  const fallbackInfo = substitutionMap.get(fallback);
                  const {
                    ultimate: fallbackUltimate
                  } = generateFont(fallbackInfo, src, localFontPath, useFallback, usePath && !path2, append2);
                  result.ultimate ||= fallbackUltimate;
                }
                if (usePath && path2 && localFontPath) {
                  src.push(`url(${localFontPath}${path2})`);
                }
                return result;
              }
              function getFontSubstitution(systemFontCache, idFactory, localFontPath, baseFontName, standardFontName) {
                baseFontName = (0, _fonts_utils.normalizeFontName)(baseFontName);
                const key2 = baseFontName;
                let substitutionInfo = systemFontCache.get(key2);
                if (substitutionInfo) {
                  return substitutionInfo;
                }
                let substitution = substitutionMap.get(baseFontName);
                if (!substitution) {
                  for (const [alias, subst] of fontAliases) {
                    if (baseFontName.startsWith(alias)) {
                      baseFontName = `${subst}${baseFontName.substring(alias.length)}`;
                      substitution = substitutionMap.get(baseFontName);
                      break;
                    }
                  }
                }
                let mustAddBaseFont = false;
                if (!substitution) {
                  substitution = substitutionMap.get(standardFontName);
                  mustAddBaseFont = true;
                }
                const loadedName = `${idFactory.getDocId()}_s${idFactory.createFontId()}`;
                if (!substitution) {
                  if (!(0, _core_utils.validateFontName)(baseFontName)) {
                    systemFontCache.set(key2, null);
                    return null;
                  }
                  const bold = /bold/gi.test(baseFontName);
                  const italic = /oblique|italic/gi.test(baseFontName);
                  const style3 = bold && italic && BOLDITALIC || bold && BOLD || italic && ITALIC || NORMAL;
                  substitutionInfo = {
                    css: loadedName,
                    guessFallback: true,
                    loadedName,
                    baseFontName,
                    src: `local(${baseFontName})`,
                    style: style3
                  };
                  systemFontCache.set(key2, substitutionInfo);
                  return substitutionInfo;
                }
                const src = [];
                if (mustAddBaseFont && (0, _core_utils.validateFontName)(baseFontName)) {
                  src.push(`local(${baseFontName})`);
                }
                const {
                  style: style2,
                  ultimate
                } = generateFont(substitution, src, localFontPath);
                const guessFallback = ultimate === null;
                const fallback = guessFallback ? "" : `,${ultimate}`;
                substitutionInfo = {
                  css: `${loadedName}${fallback}`,
                  guessFallback,
                  loadedName,
                  baseFontName,
                  src: src.join(","),
                  style: style2
                };
                systemFontCache.set(key2, substitutionInfo);
                return substitutionInfo;
              }
            }),
            /* 62 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.ImageResizer = void 0;
              var _util2 = __w_pdfjs_require__3(2);
              const MIN_IMAGE_DIM = 2048;
              const MAX_IMAGE_DIM = 65537;
              const MAX_ERROR = 128;
              class ImageResizer {
                constructor(imgData, isMask) {
                  this._imgData = imgData;
                  this._isMask = isMask;
                }
                static needsToBeResized(width, height) {
                  if (width <= this._goodSquareLength && height <= this._goodSquareLength) {
                    return false;
                  }
                  const {
                    MAX_DIM
                  } = this;
                  if (width > MAX_DIM || height > MAX_DIM) {
                    return true;
                  }
                  const area = width * height;
                  if (this._hasMaxArea) {
                    return area > this.MAX_AREA;
                  }
                  if (area < this._goodSquareLength ** 2) {
                    return false;
                  }
                  if (this._areGoodDims(width, height)) {
                    this._goodSquareLength = Math.max(this._goodSquareLength, Math.floor(Math.sqrt(width * height)));
                    return false;
                  }
                  this._goodSquareLength = this._guessMax(this._goodSquareLength, MAX_DIM, MAX_ERROR, 0);
                  const maxArea = this.MAX_AREA = this._goodSquareLength ** 2;
                  return area > maxArea;
                }
                static get MAX_DIM() {
                  return (0, _util2.shadow)(this, "MAX_DIM", this._guessMax(MIN_IMAGE_DIM, MAX_IMAGE_DIM, 0, 1));
                }
                static get MAX_AREA() {
                  this._hasMaxArea = true;
                  return (0, _util2.shadow)(this, "MAX_AREA", this._guessMax(ImageResizer._goodSquareLength, this.MAX_DIM, MAX_ERROR, 0) ** 2);
                }
                static set MAX_AREA(area) {
                  if (area >= 0) {
                    this._hasMaxArea = true;
                    (0, _util2.shadow)(this, "MAX_AREA", area);
                  }
                }
                static setMaxArea(area) {
                  if (!this._hasMaxArea) {
                    this.MAX_AREA = area >> 2;
                  }
                }
                static _areGoodDims(width, height) {
                  try {
                    const canvas = new OffscreenCanvas(width, height);
                    const ctx = canvas.getContext("2d");
                    ctx.fillRect(0, 0, 1, 1);
                    const opacity = ctx.getImageData(0, 0, 1, 1).data[3];
                    canvas.width = canvas.height = 1;
                    return opacity !== 0;
                  } catch {
                    return false;
                  }
                }
                static _guessMax(start, end, tolerance, defaultHeight) {
                  while (start + tolerance + 1 < end) {
                    const middle = Math.floor((start + end) / 2);
                    const height = defaultHeight || middle;
                    if (this._areGoodDims(middle, height)) {
                      start = middle;
                    } else {
                      end = middle;
                    }
                  }
                  return start;
                }
                static async createImage(imgData, isMask = false) {
                  return new ImageResizer(imgData, isMask)._createImage();
                }
                async _createImage() {
                  const data2 = this._encodeBMP();
                  const blob = new Blob([data2.buffer], {
                    type: "image/bmp"
                  });
                  const bitmapPromise = createImageBitmap(blob);
                  const {
                    MAX_AREA,
                    MAX_DIM
                  } = ImageResizer;
                  const {
                    _imgData: imgData
                  } = this;
                  const {
                    width,
                    height
                  } = imgData;
                  const minFactor = Math.max(width / MAX_DIM, height / MAX_DIM, Math.sqrt(width * height / MAX_AREA));
                  const firstFactor = Math.max(minFactor, 2);
                  const factor = Math.round(10 * (minFactor + 1.25)) / 10 / firstFactor;
                  const N = Math.floor(Math.log2(factor));
                  const steps = new Array(N + 2).fill(2);
                  steps[0] = firstFactor;
                  steps.splice(-1, 1, factor / (1 << N));
                  let newWidth = width;
                  let newHeight = height;
                  let bitmap = await bitmapPromise;
                  for (const step of steps) {
                    const prevWidth = newWidth;
                    const prevHeight = newHeight;
                    newWidth = Math.floor(newWidth / step) - 1;
                    newHeight = Math.floor(newHeight / step) - 1;
                    const canvas = new OffscreenCanvas(newWidth, newHeight);
                    const ctx = canvas.getContext("2d");
                    ctx.drawImage(bitmap, 0, 0, prevWidth, prevHeight, 0, 0, newWidth, newHeight);
                    bitmap = canvas.transferToImageBitmap();
                  }
                  imgData.data = null;
                  imgData.bitmap = bitmap;
                  imgData.width = newWidth;
                  imgData.height = newHeight;
                  return imgData;
                }
                _encodeBMP() {
                  const {
                    width,
                    height,
                    kind
                  } = this._imgData;
                  let data2 = this._imgData.data;
                  let bitPerPixel;
                  let colorTable = new Uint8Array(0);
                  let maskTable = colorTable;
                  let compression = 0;
                  switch (kind) {
                    case _util2.ImageKind.GRAYSCALE_1BPP: {
                      bitPerPixel = 1;
                      colorTable = new Uint8Array(this._isMask ? [255, 255, 255, 255, 0, 0, 0, 0] : [0, 0, 0, 0, 255, 255, 255, 255]);
                      const rowLen = width + 7 >> 3;
                      const rowSize = rowLen + 3 & -4;
                      if (rowLen !== rowSize) {
                        const newData = new Uint8Array(rowSize * height);
                        let k = 0;
                        for (let i2 = 0, ii = height * rowLen; i2 < ii; i2 += rowLen, k += rowSize) {
                          newData.set(data2.subarray(i2, i2 + rowLen), k);
                        }
                        data2 = newData;
                      }
                      break;
                    }
                    case _util2.ImageKind.RGB_24BPP: {
                      bitPerPixel = 24;
                      if (width & 3) {
                        const rowLen = 3 * width;
                        const rowSize = rowLen + 3 & -4;
                        const extraLen = rowSize - rowLen;
                        const newData = new Uint8Array(rowSize * height);
                        let k = 0;
                        for (let i2 = 0, ii = height * rowLen; i2 < ii; i2 += rowLen) {
                          const row = data2.subarray(i2, i2 + rowLen);
                          for (let j = 0; j < rowLen; j += 3) {
                            newData[k++] = row[j + 2];
                            newData[k++] = row[j + 1];
                            newData[k++] = row[j];
                          }
                          k += extraLen;
                        }
                        data2 = newData;
                      } else {
                        for (let i2 = 0, ii = data2.length; i2 < ii; i2 += 3) {
                          const tmp = data2[i2];
                          data2[i2] = data2[i2 + 2];
                          data2[i2 + 2] = tmp;
                        }
                      }
                      break;
                    }
                    case _util2.ImageKind.RGBA_32BPP:
                      bitPerPixel = 32;
                      compression = 3;
                      maskTable = new Uint8Array(4 + 4 + 4 + 4 + 52);
                      const view2 = new DataView(maskTable.buffer);
                      if (_util2.FeatureTest.isLittleEndian) {
                        view2.setUint32(0, 255, true);
                        view2.setUint32(4, 65280, true);
                        view2.setUint32(8, 16711680, true);
                        view2.setUint32(12, 4278190080, true);
                      } else {
                        view2.setUint32(0, 4278190080, true);
                        view2.setUint32(4, 16711680, true);
                        view2.setUint32(8, 65280, true);
                        view2.setUint32(12, 255, true);
                      }
                      break;
                    default:
                      throw new Error("invalid format");
                  }
                  let i = 0;
                  const headerLength = 40 + maskTable.length;
                  const fileLength = 14 + headerLength + colorTable.length + data2.length;
                  const bmpData = new Uint8Array(fileLength);
                  const view = new DataView(bmpData.buffer);
                  view.setUint16(i, 19778, true);
                  i += 2;
                  view.setUint32(i, fileLength, true);
                  i += 4;
                  view.setUint32(i, 0, true);
                  i += 4;
                  view.setUint32(i, 14 + headerLength + colorTable.length, true);
                  i += 4;
                  view.setUint32(i, headerLength, true);
                  i += 4;
                  view.setInt32(i, width, true);
                  i += 4;
                  view.setInt32(i, -height, true);
                  i += 4;
                  view.setUint16(i, 1, true);
                  i += 2;
                  view.setUint16(i, bitPerPixel, true);
                  i += 2;
                  view.setUint32(i, compression, true);
                  i += 4;
                  view.setUint32(i, 0, true);
                  i += 4;
                  view.setInt32(i, 0, true);
                  i += 4;
                  view.setInt32(i, 0, true);
                  i += 4;
                  view.setUint32(i, colorTable.length / 4, true);
                  i += 4;
                  view.setUint32(i, 0, true);
                  i += 4;
                  bmpData.set(maskTable, i);
                  i += maskTable.length;
                  bmpData.set(colorTable, i);
                  i += colorTable.length;
                  bmpData.set(data2, i);
                  return bmpData;
                }
              }
              exports3.ImageResizer = ImageResizer;
              ImageResizer._goodSquareLength = MIN_IMAGE_DIM;
            }),
            /* 63 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.MurmurHash3_64 = void 0;
              var _util2 = __w_pdfjs_require__3(2);
              const SEED = 3285377520;
              const MASK_HIGH = 4294901760;
              const MASK_LOW = 65535;
              class MurmurHash3_64 {
                constructor(seed) {
                  this.h1 = seed ? seed & 4294967295 : SEED;
                  this.h2 = seed ? seed & 4294967295 : SEED;
                }
                update(input) {
                  let data2, length2;
                  if (typeof input === "string") {
                    data2 = new Uint8Array(input.length * 2);
                    length2 = 0;
                    for (let i = 0, ii = input.length; i < ii; i++) {
                      const code2 = input.charCodeAt(i);
                      if (code2 <= 255) {
                        data2[length2++] = code2;
                      } else {
                        data2[length2++] = code2 >>> 8;
                        data2[length2++] = code2 & 255;
                      }
                    }
                  } else if ((0, _util2.isArrayBuffer)(input)) {
                    data2 = input.slice();
                    length2 = data2.byteLength;
                  } else {
                    throw new Error("Wrong data format in MurmurHash3_64_update. Input must be a string or array.");
                  }
                  const blockCounts = length2 >> 2;
                  const tailLength = length2 - blockCounts * 4;
                  const dataUint32 = new Uint32Array(data2.buffer, 0, blockCounts);
                  let k1 = 0, k2 = 0;
                  let h1 = this.h1, h2 = this.h2;
                  const C1 = 3432918353, C2 = 461845907;
                  const C1_LOW = C1 & MASK_LOW, C2_LOW = C2 & MASK_LOW;
                  for (let i = 0; i < blockCounts; i++) {
                    if (i & 1) {
                      k1 = dataUint32[i];
                      k1 = k1 * C1 & MASK_HIGH | k1 * C1_LOW & MASK_LOW;
                      k1 = k1 << 15 | k1 >>> 17;
                      k1 = k1 * C2 & MASK_HIGH | k1 * C2_LOW & MASK_LOW;
                      h1 ^= k1;
                      h1 = h1 << 13 | h1 >>> 19;
                      h1 = h1 * 5 + 3864292196;
                    } else {
                      k2 = dataUint32[i];
                      k2 = k2 * C1 & MASK_HIGH | k2 * C1_LOW & MASK_LOW;
                      k2 = k2 << 15 | k2 >>> 17;
                      k2 = k2 * C2 & MASK_HIGH | k2 * C2_LOW & MASK_LOW;
                      h2 ^= k2;
                      h2 = h2 << 13 | h2 >>> 19;
                      h2 = h2 * 5 + 3864292196;
                    }
                  }
                  k1 = 0;
                  switch (tailLength) {
                    case 3:
                      k1 ^= data2[blockCounts * 4 + 2] << 16;
                    case 2:
                      k1 ^= data2[blockCounts * 4 + 1] << 8;
                    case 1:
                      k1 ^= data2[blockCounts * 4];
                      k1 = k1 * C1 & MASK_HIGH | k1 * C1_LOW & MASK_LOW;
                      k1 = k1 << 15 | k1 >>> 17;
                      k1 = k1 * C2 & MASK_HIGH | k1 * C2_LOW & MASK_LOW;
                      if (blockCounts & 1) {
                        h1 ^= k1;
                      } else {
                        h2 ^= k1;
                      }
                  }
                  this.h1 = h1;
                  this.h2 = h2;
                }
                hexdigest() {
                  let h1 = this.h1, h2 = this.h2;
                  h1 ^= h2 >>> 1;
                  h1 = h1 * 3981806797 & MASK_HIGH | h1 * 36045 & MASK_LOW;
                  h2 = h2 * 4283543511 & MASK_HIGH | ((h2 << 16 | h1 >>> 16) * 2950163797 & MASK_HIGH) >>> 16;
                  h1 ^= h2 >>> 1;
                  h1 = h1 * 444984403 & MASK_HIGH | h1 * 60499 & MASK_LOW;
                  h2 = h2 * 3301882366 & MASK_HIGH | ((h2 << 16 | h1 >>> 16) * 3120437893 & MASK_HIGH) >>> 16;
                  h1 ^= h2 >>> 1;
                  return (h1 >>> 0).toString(16).padStart(8, "0") + (h2 >>> 0).toString(16).padStart(8, "0");
                }
              }
              exports3.MurmurHash3_64 = MurmurHash3_64;
            }),
            /* 64 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.OperatorList = void 0;
              var _util2 = __w_pdfjs_require__3(2);
              function addState(parentState, pattern6, checkFn, iterateFn, processFn) {
                let state = parentState;
                for (let i = 0, ii = pattern6.length - 1; i < ii; i++) {
                  const item = pattern6[i];
                  state = state[item] ||= [];
                }
                state[pattern6.at(-1)] = {
                  checkFn,
                  iterateFn,
                  processFn
                };
              }
              const InitialState = [];
              addState(InitialState, [_util2.OPS.save, _util2.OPS.transform, _util2.OPS.paintInlineImageXObject, _util2.OPS.restore], null, function iterateInlineImageGroup(context, i) {
                const fnArray = context.fnArray;
                const iFirstSave = context.iCurr - 3;
                const pos = (i - iFirstSave) % 4;
                switch (pos) {
                  case 0:
                    return fnArray[i] === _util2.OPS.save;
                  case 1:
                    return fnArray[i] === _util2.OPS.transform;
                  case 2:
                    return fnArray[i] === _util2.OPS.paintInlineImageXObject;
                  case 3:
                    return fnArray[i] === _util2.OPS.restore;
                }
                throw new Error(`iterateInlineImageGroup - invalid pos: ${pos}`);
              }, function foundInlineImageGroup(context, i) {
                const MIN_IMAGES_IN_INLINE_IMAGES_BLOCK = 10;
                const MAX_IMAGES_IN_INLINE_IMAGES_BLOCK = 200;
                const MAX_WIDTH = 1e3;
                const IMAGE_PADDING = 1;
                const fnArray = context.fnArray, argsArray = context.argsArray;
                const curr = context.iCurr;
                const iFirstSave = curr - 3;
                const iFirstTransform = curr - 2;
                const iFirstPIIXO = curr - 1;
                const count = Math.min(Math.floor((i - iFirstSave) / 4), MAX_IMAGES_IN_INLINE_IMAGES_BLOCK);
                if (count < MIN_IMAGES_IN_INLINE_IMAGES_BLOCK) {
                  return i - (i - iFirstSave) % 4;
                }
                let maxX = 0;
                const map = [];
                let maxLineHeight = 0;
                let currentX = IMAGE_PADDING, currentY = IMAGE_PADDING;
                for (let q = 0; q < count; q++) {
                  const transform = argsArray[iFirstTransform + (q << 2)];
                  const img2 = argsArray[iFirstPIIXO + (q << 2)][0];
                  if (currentX + img2.width > MAX_WIDTH) {
                    maxX = Math.max(maxX, currentX);
                    currentY += maxLineHeight + 2 * IMAGE_PADDING;
                    currentX = 0;
                    maxLineHeight = 0;
                  }
                  map.push({
                    transform,
                    x: currentX,
                    y: currentY,
                    w: img2.width,
                    h: img2.height
                  });
                  currentX += img2.width + 2 * IMAGE_PADDING;
                  maxLineHeight = Math.max(maxLineHeight, img2.height);
                }
                const imgWidth = Math.max(maxX, currentX) + IMAGE_PADDING;
                const imgHeight = currentY + maxLineHeight + IMAGE_PADDING;
                const imgData = new Uint8Array(imgWidth * imgHeight * 4);
                const imgRowSize = imgWidth << 2;
                for (let q = 0; q < count; q++) {
                  const data2 = argsArray[iFirstPIIXO + (q << 2)][0].data;
                  const rowSize = map[q].w << 2;
                  let dataOffset = 0;
                  let offset4 = map[q].x + map[q].y * imgWidth << 2;
                  imgData.set(data2.subarray(0, rowSize), offset4 - imgRowSize);
                  for (let k = 0, kk = map[q].h; k < kk; k++) {
                    imgData.set(data2.subarray(dataOffset, dataOffset + rowSize), offset4);
                    dataOffset += rowSize;
                    offset4 += imgRowSize;
                  }
                  imgData.set(data2.subarray(dataOffset - rowSize, dataOffset), offset4);
                  while (offset4 >= 0) {
                    data2[offset4 - 4] = data2[offset4];
                    data2[offset4 - 3] = data2[offset4 + 1];
                    data2[offset4 - 2] = data2[offset4 + 2];
                    data2[offset4 - 1] = data2[offset4 + 3];
                    data2[offset4 + rowSize] = data2[offset4 + rowSize - 4];
                    data2[offset4 + rowSize + 1] = data2[offset4 + rowSize - 3];
                    data2[offset4 + rowSize + 2] = data2[offset4 + rowSize - 2];
                    data2[offset4 + rowSize + 3] = data2[offset4 + rowSize - 1];
                    offset4 -= imgRowSize;
                  }
                }
                const img = {
                  width: imgWidth,
                  height: imgHeight
                };
                if (context.isOffscreenCanvasSupported) {
                  const canvas = new OffscreenCanvas(imgWidth, imgHeight);
                  const ctx = canvas.getContext("2d");
                  ctx.putImageData(new ImageData(new Uint8ClampedArray(imgData.buffer), imgWidth, imgHeight), 0, 0);
                  img.bitmap = canvas.transferToImageBitmap();
                  img.data = null;
                } else {
                  img.kind = _util2.ImageKind.RGBA_32BPP;
                  img.data = imgData;
                }
                fnArray.splice(iFirstSave, count * 4, _util2.OPS.paintInlineImageXObjectGroup);
                argsArray.splice(iFirstSave, count * 4, [img, map]);
                return iFirstSave + 1;
              });
              addState(InitialState, [_util2.OPS.save, _util2.OPS.transform, _util2.OPS.paintImageMaskXObject, _util2.OPS.restore], null, function iterateImageMaskGroup(context, i) {
                const fnArray = context.fnArray;
                const iFirstSave = context.iCurr - 3;
                const pos = (i - iFirstSave) % 4;
                switch (pos) {
                  case 0:
                    return fnArray[i] === _util2.OPS.save;
                  case 1:
                    return fnArray[i] === _util2.OPS.transform;
                  case 2:
                    return fnArray[i] === _util2.OPS.paintImageMaskXObject;
                  case 3:
                    return fnArray[i] === _util2.OPS.restore;
                }
                throw new Error(`iterateImageMaskGroup - invalid pos: ${pos}`);
              }, function foundImageMaskGroup(context, i) {
                const MIN_IMAGES_IN_MASKS_BLOCK = 10;
                const MAX_IMAGES_IN_MASKS_BLOCK = 100;
                const MAX_SAME_IMAGES_IN_MASKS_BLOCK = 1e3;
                const fnArray = context.fnArray, argsArray = context.argsArray;
                const curr = context.iCurr;
                const iFirstSave = curr - 3;
                const iFirstTransform = curr - 2;
                const iFirstPIMXO = curr - 1;
                let count = Math.floor((i - iFirstSave) / 4);
                if (count < MIN_IMAGES_IN_MASKS_BLOCK) {
                  return i - (i - iFirstSave) % 4;
                }
                let isSameImage = false;
                let iTransform, transformArgs;
                const firstPIMXOArg0 = argsArray[iFirstPIMXO][0];
                const firstTransformArg0 = argsArray[iFirstTransform][0], firstTransformArg1 = argsArray[iFirstTransform][1], firstTransformArg2 = argsArray[iFirstTransform][2], firstTransformArg3 = argsArray[iFirstTransform][3];
                if (firstTransformArg1 === firstTransformArg2) {
                  isSameImage = true;
                  iTransform = iFirstTransform + 4;
                  let iPIMXO = iFirstPIMXO + 4;
                  for (let q = 1; q < count; q++, iTransform += 4, iPIMXO += 4) {
                    transformArgs = argsArray[iTransform];
                    if (argsArray[iPIMXO][0] !== firstPIMXOArg0 || transformArgs[0] !== firstTransformArg0 || transformArgs[1] !== firstTransformArg1 || transformArgs[2] !== firstTransformArg2 || transformArgs[3] !== firstTransformArg3) {
                      if (q < MIN_IMAGES_IN_MASKS_BLOCK) {
                        isSameImage = false;
                      } else {
                        count = q;
                      }
                      break;
                    }
                  }
                }
                if (isSameImage) {
                  count = Math.min(count, MAX_SAME_IMAGES_IN_MASKS_BLOCK);
                  const positions = new Float32Array(count * 2);
                  iTransform = iFirstTransform;
                  for (let q = 0; q < count; q++, iTransform += 4) {
                    transformArgs = argsArray[iTransform];
                    positions[q << 1] = transformArgs[4];
                    positions[(q << 1) + 1] = transformArgs[5];
                  }
                  fnArray.splice(iFirstSave, count * 4, _util2.OPS.paintImageMaskXObjectRepeat);
                  argsArray.splice(iFirstSave, count * 4, [firstPIMXOArg0, firstTransformArg0, firstTransformArg1, firstTransformArg2, firstTransformArg3, positions]);
                } else {
                  count = Math.min(count, MAX_IMAGES_IN_MASKS_BLOCK);
                  const images = [];
                  for (let q = 0; q < count; q++) {
                    transformArgs = argsArray[iFirstTransform + (q << 2)];
                    const maskParams = argsArray[iFirstPIMXO + (q << 2)][0];
                    images.push({
                      data: maskParams.data,
                      width: maskParams.width,
                      height: maskParams.height,
                      interpolate: maskParams.interpolate,
                      count: maskParams.count,
                      transform: transformArgs
                    });
                  }
                  fnArray.splice(iFirstSave, count * 4, _util2.OPS.paintImageMaskXObjectGroup);
                  argsArray.splice(iFirstSave, count * 4, [images]);
                }
                return iFirstSave + 1;
              });
              addState(InitialState, [_util2.OPS.save, _util2.OPS.transform, _util2.OPS.paintImageXObject, _util2.OPS.restore], function(context) {
                const argsArray = context.argsArray;
                const iFirstTransform = context.iCurr - 2;
                return argsArray[iFirstTransform][1] === 0 && argsArray[iFirstTransform][2] === 0;
              }, function iterateImageGroup(context, i) {
                const fnArray = context.fnArray, argsArray = context.argsArray;
                const iFirstSave = context.iCurr - 3;
                const pos = (i - iFirstSave) % 4;
                switch (pos) {
                  case 0:
                    return fnArray[i] === _util2.OPS.save;
                  case 1:
                    if (fnArray[i] !== _util2.OPS.transform) {
                      return false;
                    }
                    const iFirstTransform = context.iCurr - 2;
                    const firstTransformArg0 = argsArray[iFirstTransform][0];
                    const firstTransformArg3 = argsArray[iFirstTransform][3];
                    if (argsArray[i][0] !== firstTransformArg0 || argsArray[i][1] !== 0 || argsArray[i][2] !== 0 || argsArray[i][3] !== firstTransformArg3) {
                      return false;
                    }
                    return true;
                  case 2:
                    if (fnArray[i] !== _util2.OPS.paintImageXObject) {
                      return false;
                    }
                    const iFirstPIXO = context.iCurr - 1;
                    const firstPIXOArg0 = argsArray[iFirstPIXO][0];
                    if (argsArray[i][0] !== firstPIXOArg0) {
                      return false;
                    }
                    return true;
                  case 3:
                    return fnArray[i] === _util2.OPS.restore;
                }
                throw new Error(`iterateImageGroup - invalid pos: ${pos}`);
              }, function(context, i) {
                const MIN_IMAGES_IN_BLOCK = 3;
                const MAX_IMAGES_IN_BLOCK = 1e3;
                const fnArray = context.fnArray, argsArray = context.argsArray;
                const curr = context.iCurr;
                const iFirstSave = curr - 3;
                const iFirstTransform = curr - 2;
                const iFirstPIXO = curr - 1;
                const firstPIXOArg0 = argsArray[iFirstPIXO][0];
                const firstTransformArg0 = argsArray[iFirstTransform][0];
                const firstTransformArg3 = argsArray[iFirstTransform][3];
                const count = Math.min(Math.floor((i - iFirstSave) / 4), MAX_IMAGES_IN_BLOCK);
                if (count < MIN_IMAGES_IN_BLOCK) {
                  return i - (i - iFirstSave) % 4;
                }
                const positions = new Float32Array(count * 2);
                let iTransform = iFirstTransform;
                for (let q = 0; q < count; q++, iTransform += 4) {
                  const transformArgs = argsArray[iTransform];
                  positions[q << 1] = transformArgs[4];
                  positions[(q << 1) + 1] = transformArgs[5];
                }
                const args = [firstPIXOArg0, firstTransformArg0, firstTransformArg3, positions];
                fnArray.splice(iFirstSave, count * 4, _util2.OPS.paintImageXObjectRepeat);
                argsArray.splice(iFirstSave, count * 4, args);
                return iFirstSave + 1;
              });
              addState(InitialState, [_util2.OPS.beginText, _util2.OPS.setFont, _util2.OPS.setTextMatrix, _util2.OPS.showText, _util2.OPS.endText], null, function iterateShowTextGroup(context, i) {
                const fnArray = context.fnArray, argsArray = context.argsArray;
                const iFirstSave = context.iCurr - 4;
                const pos = (i - iFirstSave) % 5;
                switch (pos) {
                  case 0:
                    return fnArray[i] === _util2.OPS.beginText;
                  case 1:
                    return fnArray[i] === _util2.OPS.setFont;
                  case 2:
                    return fnArray[i] === _util2.OPS.setTextMatrix;
                  case 3:
                    if (fnArray[i] !== _util2.OPS.showText) {
                      return false;
                    }
                    const iFirstSetFont = context.iCurr - 3;
                    const firstSetFontArg0 = argsArray[iFirstSetFont][0];
                    const firstSetFontArg1 = argsArray[iFirstSetFont][1];
                    if (argsArray[i][0] !== firstSetFontArg0 || argsArray[i][1] !== firstSetFontArg1) {
                      return false;
                    }
                    return true;
                  case 4:
                    return fnArray[i] === _util2.OPS.endText;
                }
                throw new Error(`iterateShowTextGroup - invalid pos: ${pos}`);
              }, function(context, i) {
                const MIN_CHARS_IN_BLOCK = 3;
                const MAX_CHARS_IN_BLOCK = 1e3;
                const fnArray = context.fnArray, argsArray = context.argsArray;
                const curr = context.iCurr;
                const iFirstBeginText = curr - 4;
                const iFirstSetFont = curr - 3;
                const iFirstSetTextMatrix = curr - 2;
                const iFirstShowText = curr - 1;
                const iFirstEndText = curr;
                const firstSetFontArg0 = argsArray[iFirstSetFont][0];
                const firstSetFontArg1 = argsArray[iFirstSetFont][1];
                let count = Math.min(Math.floor((i - iFirstBeginText) / 5), MAX_CHARS_IN_BLOCK);
                if (count < MIN_CHARS_IN_BLOCK) {
                  return i - (i - iFirstBeginText) % 5;
                }
                let iFirst = iFirstBeginText;
                if (iFirstBeginText >= 4 && fnArray[iFirstBeginText - 4] === fnArray[iFirstSetFont] && fnArray[iFirstBeginText - 3] === fnArray[iFirstSetTextMatrix] && fnArray[iFirstBeginText - 2] === fnArray[iFirstShowText] && fnArray[iFirstBeginText - 1] === fnArray[iFirstEndText] && argsArray[iFirstBeginText - 4][0] === firstSetFontArg0 && argsArray[iFirstBeginText - 4][1] === firstSetFontArg1) {
                  count++;
                  iFirst -= 5;
                }
                let iEndText = iFirst + 4;
                for (let q = 1; q < count; q++) {
                  fnArray.splice(iEndText, 3);
                  argsArray.splice(iEndText, 3);
                  iEndText += 2;
                }
                return iEndText + 1;
              });
              class NullOptimizer {
                constructor(queue) {
                  this.queue = queue;
                }
                _optimize() {
                }
                push(fn, args) {
                  this.queue.fnArray.push(fn);
                  this.queue.argsArray.push(args);
                  this._optimize();
                }
                flush() {
                }
                reset() {
                }
              }
              class QueueOptimizer extends NullOptimizer {
                constructor(queue) {
                  super(queue);
                  this.state = null;
                  this.context = {
                    iCurr: 0,
                    fnArray: queue.fnArray,
                    argsArray: queue.argsArray,
                    isOffscreenCanvasSupported: false
                  };
                  this.match = null;
                  this.lastProcessed = 0;
                }
                set isOffscreenCanvasSupported(value) {
                  this.context.isOffscreenCanvasSupported = value;
                }
                _optimize() {
                  const fnArray = this.queue.fnArray;
                  let i = this.lastProcessed, ii = fnArray.length;
                  let state = this.state;
                  let match2 = this.match;
                  if (!state && !match2 && i + 1 === ii && !InitialState[fnArray[i]]) {
                    this.lastProcessed = ii;
                    return;
                  }
                  const context = this.context;
                  while (i < ii) {
                    if (match2) {
                      const iterate = (0, match2.iterateFn)(context, i);
                      if (iterate) {
                        i++;
                        continue;
                      }
                      i = (0, match2.processFn)(context, i + 1);
                      ii = fnArray.length;
                      match2 = null;
                      state = null;
                      if (i >= ii) {
                        break;
                      }
                    }
                    state = (state || InitialState)[fnArray[i]];
                    if (!state || Array.isArray(state)) {
                      i++;
                      continue;
                    }
                    context.iCurr = i;
                    i++;
                    if (state.checkFn && !(0, state.checkFn)(context)) {
                      state = null;
                      continue;
                    }
                    match2 = state;
                    state = null;
                  }
                  this.state = state;
                  this.match = match2;
                  this.lastProcessed = i;
                }
                flush() {
                  while (this.match) {
                    const length2 = this.queue.fnArray.length;
                    this.lastProcessed = (0, this.match.processFn)(this.context, length2);
                    this.match = null;
                    this.state = null;
                    this._optimize();
                  }
                }
                reset() {
                  this.state = null;
                  this.match = null;
                  this.lastProcessed = 0;
                }
              }
              class OperatorList {
                static CHUNK_SIZE = 1e3;
                static CHUNK_SIZE_ABOUT = this.CHUNK_SIZE - 5;
                constructor(intent = 0, streamSink) {
                  this._streamSink = streamSink;
                  this.fnArray = [];
                  this.argsArray = [];
                  this.optimizer = streamSink && !(intent & _util2.RenderingIntentFlag.OPLIST) ? new QueueOptimizer(this) : new NullOptimizer(this);
                  this.dependencies = /* @__PURE__ */ new Set();
                  this._totalLength = 0;
                  this.weight = 0;
                  this._resolved = streamSink ? null : Promise.resolve();
                }
                set isOffscreenCanvasSupported(value) {
                  this.optimizer.isOffscreenCanvasSupported = value;
                }
                get length() {
                  return this.argsArray.length;
                }
                get ready() {
                  return this._resolved || this._streamSink.ready;
                }
                get totalLength() {
                  return this._totalLength + this.length;
                }
                addOp(fn, args) {
                  this.optimizer.push(fn, args);
                  this.weight++;
                  if (this._streamSink) {
                    if (this.weight >= OperatorList.CHUNK_SIZE) {
                      this.flush();
                    } else if (this.weight >= OperatorList.CHUNK_SIZE_ABOUT && (fn === _util2.OPS.restore || fn === _util2.OPS.endText)) {
                      this.flush();
                    }
                  }
                }
                addImageOps(fn, args, optionalContent) {
                  if (optionalContent !== void 0) {
                    this.addOp(_util2.OPS.beginMarkedContentProps, ["OC", optionalContent]);
                  }
                  this.addOp(fn, args);
                  if (optionalContent !== void 0) {
                    this.addOp(_util2.OPS.endMarkedContent, []);
                  }
                }
                addDependency(dependency) {
                  if (this.dependencies.has(dependency)) {
                    return;
                  }
                  this.dependencies.add(dependency);
                  this.addOp(_util2.OPS.dependency, [dependency]);
                }
                addDependencies(dependencies) {
                  for (const dependency of dependencies) {
                    this.addDependency(dependency);
                  }
                }
                addOpList(opList) {
                  if (!(opList instanceof OperatorList)) {
                    (0, _util2.warn)('addOpList - ignoring invalid "opList" parameter.');
                    return;
                  }
                  for (const dependency of opList.dependencies) {
                    this.dependencies.add(dependency);
                  }
                  for (let i = 0, ii = opList.length; i < ii; i++) {
                    this.addOp(opList.fnArray[i], opList.argsArray[i]);
                  }
                }
                getIR() {
                  return {
                    fnArray: this.fnArray,
                    argsArray: this.argsArray,
                    length: this.length
                  };
                }
                get _transfers() {
                  const transfers = [];
                  const {
                    fnArray,
                    argsArray,
                    length: length2
                  } = this;
                  for (let i = 0; i < length2; i++) {
                    switch (fnArray[i]) {
                      case _util2.OPS.paintInlineImageXObject:
                      case _util2.OPS.paintInlineImageXObjectGroup:
                      case _util2.OPS.paintImageMaskXObject:
                        const arg = argsArray[i][0];
                        if (!arg.cached && arg.data?.buffer instanceof ArrayBuffer) {
                          transfers.push(arg.data.buffer);
                        }
                        break;
                    }
                  }
                  return transfers;
                }
                flush(lastChunk = false, separateAnnots = null) {
                  this.optimizer.flush();
                  const length2 = this.length;
                  this._totalLength += length2;
                  this._streamSink.enqueue({
                    fnArray: this.fnArray,
                    argsArray: this.argsArray,
                    lastChunk,
                    separateAnnots,
                    length: length2
                  }, 1, this._transfers);
                  this.dependencies.clear();
                  this.fnArray.length = 0;
                  this.argsArray.length = 0;
                  this.weight = 0;
                  this.optimizer.reset();
                }
              }
              exports3.OperatorList = OperatorList;
            }),
            /* 65 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.PDFImage = void 0;
              var _util2 = __w_pdfjs_require__3(2);
              var _image_utils = __w_pdfjs_require__3(28);
              var _base_stream = __w_pdfjs_require__3(5);
              var _colorspace = __w_pdfjs_require__3(12);
              var _decode_stream = __w_pdfjs_require__3(18);
              var _image_resizer = __w_pdfjs_require__3(62);
              var _jpeg_stream = __w_pdfjs_require__3(26);
              var _jpx = __w_pdfjs_require__3(30);
              var _primitives = __w_pdfjs_require__3(4);
              function decodeAndClamp(value, addend, coefficient, max) {
                value = addend + value * coefficient;
                if (value < 0) {
                  value = 0;
                } else if (value > max) {
                  value = max;
                }
                return value;
              }
              function resizeImageMask(src, bpc, w1, h1, w2, h2) {
                const length2 = w2 * h2;
                let dest;
                if (bpc <= 8) {
                  dest = new Uint8Array(length2);
                } else if (bpc <= 16) {
                  dest = new Uint16Array(length2);
                } else {
                  dest = new Uint32Array(length2);
                }
                const xRatio = w1 / w2;
                const yRatio = h1 / h2;
                let i, j, py, newIndex = 0, oldIndex;
                const xScaled = new Uint16Array(w2);
                const w1Scanline = w1;
                for (i = 0; i < w2; i++) {
                  xScaled[i] = Math.floor(i * xRatio);
                }
                for (i = 0; i < h2; i++) {
                  py = Math.floor(i * yRatio) * w1Scanline;
                  for (j = 0; j < w2; j++) {
                    oldIndex = py + xScaled[j];
                    dest[newIndex++] = src[oldIndex];
                  }
                }
                return dest;
              }
              class PDFImage {
                constructor({
                  xref,
                  res,
                  image,
                  isInline = false,
                  smask = null,
                  mask = null,
                  isMask = false,
                  pdfFunctionFactory,
                  localColorSpaceCache
                }) {
                  this.image = image;
                  const dict = image.dict;
                  const filter3 = dict.get("F", "Filter");
                  let filterName;
                  if (filter3 instanceof _primitives.Name) {
                    filterName = filter3.name;
                  } else if (Array.isArray(filter3)) {
                    const filterZero = xref.fetchIfRef(filter3[0]);
                    if (filterZero instanceof _primitives.Name) {
                      filterName = filterZero.name;
                    }
                  }
                  switch (filterName) {
                    case "JPXDecode":
                      const jpxImage = new _jpx.JpxImage();
                      jpxImage.parseImageProperties(image.stream);
                      image.stream.reset();
                      image.width = jpxImage.width;
                      image.height = jpxImage.height;
                      image.bitsPerComponent = jpxImage.bitsPerComponent;
                      image.numComps = jpxImage.componentsCount;
                      break;
                    case "JBIG2Decode":
                      image.bitsPerComponent = 1;
                      image.numComps = 1;
                      break;
                  }
                  let width = dict.get("W", "Width");
                  let height = dict.get("H", "Height");
                  if (Number.isInteger(image.width) && image.width > 0 && Number.isInteger(image.height) && image.height > 0 && (image.width !== width || image.height !== height)) {
                    (0, _util2.warn)("PDFImage - using the Width/Height of the image data, rather than the image dictionary.");
                    width = image.width;
                    height = image.height;
                  }
                  if (width < 1 || height < 1) {
                    throw new _util2.FormatError(`Invalid image width: ${width} or height: ${height}`);
                  }
                  this.width = width;
                  this.height = height;
                  this.interpolate = dict.get("I", "Interpolate");
                  this.imageMask = dict.get("IM", "ImageMask") || false;
                  this.matte = dict.get("Matte") || false;
                  let bitsPerComponent = image.bitsPerComponent;
                  if (!bitsPerComponent) {
                    bitsPerComponent = dict.get("BPC", "BitsPerComponent");
                    if (!bitsPerComponent) {
                      if (this.imageMask) {
                        bitsPerComponent = 1;
                      } else {
                        throw new _util2.FormatError(`Bits per component missing in image: ${this.imageMask}`);
                      }
                    }
                  }
                  this.bpc = bitsPerComponent;
                  if (!this.imageMask) {
                    let colorSpace = dict.getRaw("CS") || dict.getRaw("ColorSpace");
                    if (!colorSpace) {
                      (0, _util2.info)("JPX images (which do not require color spaces)");
                      switch (image.numComps) {
                        case 1:
                          colorSpace = _primitives.Name.get("DeviceGray");
                          break;
                        case 3:
                          colorSpace = _primitives.Name.get("DeviceRGB");
                          break;
                        case 4:
                          colorSpace = _primitives.Name.get("DeviceCMYK");
                          break;
                        default:
                          throw new Error(`JPX images with ${image.numComps} color components not supported.`);
                      }
                    }
                    this.colorSpace = _colorspace.ColorSpace.parse({
                      cs: colorSpace,
                      xref,
                      resources: isInline ? res : null,
                      pdfFunctionFactory,
                      localColorSpaceCache
                    });
                    this.numComps = this.colorSpace.numComps;
                  }
                  this.decode = dict.getArray("D", "Decode");
                  this.needsDecode = false;
                  if (this.decode && (this.colorSpace && !this.colorSpace.isDefaultDecode(this.decode, bitsPerComponent) || isMask && !_colorspace.ColorSpace.isDefaultDecode(this.decode, 1))) {
                    this.needsDecode = true;
                    const max = (1 << bitsPerComponent) - 1;
                    this.decodeCoefficients = [];
                    this.decodeAddends = [];
                    const isIndexed = this.colorSpace?.name === "Indexed";
                    for (let i = 0, j = 0; i < this.decode.length; i += 2, ++j) {
                      const dmin = this.decode[i];
                      const dmax = this.decode[i + 1];
                      this.decodeCoefficients[j] = isIndexed ? (dmax - dmin) / max : dmax - dmin;
                      this.decodeAddends[j] = isIndexed ? dmin : max * dmin;
                    }
                  }
                  if (smask) {
                    this.smask = new PDFImage({
                      xref,
                      res,
                      image: smask,
                      isInline,
                      pdfFunctionFactory,
                      localColorSpaceCache
                    });
                  } else if (mask) {
                    if (mask instanceof _base_stream.BaseStream) {
                      const maskDict = mask.dict, imageMask = maskDict.get("IM", "ImageMask");
                      if (!imageMask) {
                        (0, _util2.warn)("Ignoring /Mask in image without /ImageMask.");
                      } else {
                        this.mask = new PDFImage({
                          xref,
                          res,
                          image: mask,
                          isInline,
                          isMask: true,
                          pdfFunctionFactory,
                          localColorSpaceCache
                        });
                      }
                    } else {
                      this.mask = mask;
                    }
                  }
                }
                static async buildImage({
                  xref,
                  res,
                  image,
                  isInline = false,
                  pdfFunctionFactory,
                  localColorSpaceCache
                }) {
                  const imageData = image;
                  let smaskData = null;
                  let maskData = null;
                  const smask = image.dict.get("SMask");
                  const mask = image.dict.get("Mask");
                  if (smask) {
                    if (smask instanceof _base_stream.BaseStream) {
                      smaskData = smask;
                    } else {
                      (0, _util2.warn)("Unsupported /SMask format.");
                    }
                  } else if (mask) {
                    if (mask instanceof _base_stream.BaseStream || Array.isArray(mask)) {
                      maskData = mask;
                    } else {
                      (0, _util2.warn)("Unsupported /Mask format.");
                    }
                  }
                  return new PDFImage({
                    xref,
                    res,
                    image: imageData,
                    isInline,
                    smask: smaskData,
                    mask: maskData,
                    pdfFunctionFactory,
                    localColorSpaceCache
                  });
                }
                static createRawMask({
                  imgArray,
                  width,
                  height,
                  imageIsFromDecodeStream,
                  inverseDecode,
                  interpolate
                }) {
                  const computedLength = (width + 7 >> 3) * height;
                  const actualLength = imgArray.byteLength;
                  const haveFullData = computedLength === actualLength;
                  let data2, i;
                  if (imageIsFromDecodeStream && (!inverseDecode || haveFullData)) {
                    data2 = imgArray;
                  } else if (!inverseDecode) {
                    data2 = new Uint8Array(imgArray);
                  } else {
                    data2 = new Uint8Array(computedLength);
                    data2.set(imgArray);
                    data2.fill(255, actualLength);
                  }
                  if (inverseDecode) {
                    for (i = 0; i < actualLength; i++) {
                      data2[i] ^= 255;
                    }
                  }
                  return {
                    data: data2,
                    width,
                    height,
                    interpolate
                  };
                }
                static async createMask({
                  imgArray,
                  width,
                  height,
                  imageIsFromDecodeStream,
                  inverseDecode,
                  interpolate,
                  isOffscreenCanvasSupported = false
                }) {
                  const isSingleOpaquePixel = width === 1 && height === 1 && inverseDecode === (imgArray.length === 0 || !!(imgArray[0] & 128));
                  if (isSingleOpaquePixel) {
                    return {
                      isSingleOpaquePixel
                    };
                  }
                  if (isOffscreenCanvasSupported) {
                    if (_image_resizer.ImageResizer.needsToBeResized(width, height)) {
                      const data2 = new Uint8ClampedArray(width * height * 4);
                      (0, _image_utils.convertBlackAndWhiteToRGBA)({
                        src: imgArray,
                        dest: data2,
                        width,
                        height,
                        nonBlackColor: 0,
                        inverseDecode
                      });
                      return _image_resizer.ImageResizer.createImage({
                        kind: _util2.ImageKind.RGBA_32BPP,
                        data: data2,
                        width,
                        height,
                        interpolate
                      });
                    }
                    const canvas = new OffscreenCanvas(width, height);
                    const ctx = canvas.getContext("2d");
                    const imgData = ctx.createImageData(width, height);
                    (0, _image_utils.convertBlackAndWhiteToRGBA)({
                      src: imgArray,
                      dest: imgData.data,
                      width,
                      height,
                      nonBlackColor: 0,
                      inverseDecode
                    });
                    ctx.putImageData(imgData, 0, 0);
                    const bitmap = canvas.transferToImageBitmap();
                    return {
                      data: null,
                      width,
                      height,
                      interpolate,
                      bitmap
                    };
                  }
                  return this.createRawMask({
                    imgArray,
                    width,
                    height,
                    inverseDecode,
                    imageIsFromDecodeStream,
                    interpolate
                  });
                }
                get drawWidth() {
                  return Math.max(this.width, this.smask?.width || 0, this.mask?.width || 0);
                }
                get drawHeight() {
                  return Math.max(this.height, this.smask?.height || 0, this.mask?.height || 0);
                }
                decodeBuffer(buffer) {
                  const bpc = this.bpc;
                  const numComps = this.numComps;
                  const decodeAddends = this.decodeAddends;
                  const decodeCoefficients = this.decodeCoefficients;
                  const max = (1 << bpc) - 1;
                  let i, ii;
                  if (bpc === 1) {
                    for (i = 0, ii = buffer.length; i < ii; i++) {
                      buffer[i] = +!buffer[i];
                    }
                    return;
                  }
                  let index3 = 0;
                  for (i = 0, ii = this.width * this.height; i < ii; i++) {
                    for (let j = 0; j < numComps; j++) {
                      buffer[index3] = decodeAndClamp(buffer[index3], decodeAddends[j], decodeCoefficients[j], max);
                      index3++;
                    }
                  }
                }
                getComponents(buffer) {
                  const bpc = this.bpc;
                  if (bpc === 8) {
                    return buffer;
                  }
                  const width = this.width;
                  const height = this.height;
                  const numComps = this.numComps;
                  const length2 = width * height * numComps;
                  let bufferPos = 0;
                  let output;
                  if (bpc <= 8) {
                    output = new Uint8Array(length2);
                  } else if (bpc <= 16) {
                    output = new Uint16Array(length2);
                  } else {
                    output = new Uint32Array(length2);
                  }
                  const rowComps = width * numComps;
                  const max = (1 << bpc) - 1;
                  let i = 0, ii, buf;
                  if (bpc === 1) {
                    let mask, loop1End, loop2End;
                    for (let j = 0; j < height; j++) {
                      loop1End = i + (rowComps & ~7);
                      loop2End = i + rowComps;
                      while (i < loop1End) {
                        buf = buffer[bufferPos++];
                        output[i] = buf >> 7 & 1;
                        output[i + 1] = buf >> 6 & 1;
                        output[i + 2] = buf >> 5 & 1;
                        output[i + 3] = buf >> 4 & 1;
                        output[i + 4] = buf >> 3 & 1;
                        output[i + 5] = buf >> 2 & 1;
                        output[i + 6] = buf >> 1 & 1;
                        output[i + 7] = buf & 1;
                        i += 8;
                      }
                      if (i < loop2End) {
                        buf = buffer[bufferPos++];
                        mask = 128;
                        while (i < loop2End) {
                          output[i++] = +!!(buf & mask);
                          mask >>= 1;
                        }
                      }
                    }
                  } else {
                    let bits = 0;
                    buf = 0;
                    for (i = 0, ii = length2; i < ii; ++i) {
                      if (i % rowComps === 0) {
                        buf = 0;
                        bits = 0;
                      }
                      while (bits < bpc) {
                        buf = buf << 8 | buffer[bufferPos++];
                        bits += 8;
                      }
                      const remainingBits = bits - bpc;
                      let value = buf >> remainingBits;
                      if (value < 0) {
                        value = 0;
                      } else if (value > max) {
                        value = max;
                      }
                      output[i] = value;
                      buf &= (1 << remainingBits) - 1;
                      bits = remainingBits;
                    }
                  }
                  return output;
                }
                fillOpacity(rgbaBuf, width, height, actualHeight, image) {
                  const smask = this.smask;
                  const mask = this.mask;
                  let alphaBuf, sw, sh, i, ii, j;
                  if (smask) {
                    sw = smask.width;
                    sh = smask.height;
                    alphaBuf = new Uint8ClampedArray(sw * sh);
                    smask.fillGrayBuffer(alphaBuf);
                    if (sw !== width || sh !== height) {
                      alphaBuf = resizeImageMask(alphaBuf, smask.bpc, sw, sh, width, height);
                    }
                  } else if (mask) {
                    if (mask instanceof PDFImage) {
                      sw = mask.width;
                      sh = mask.height;
                      alphaBuf = new Uint8ClampedArray(sw * sh);
                      mask.numComps = 1;
                      mask.fillGrayBuffer(alphaBuf);
                      for (i = 0, ii = sw * sh; i < ii; ++i) {
                        alphaBuf[i] = 255 - alphaBuf[i];
                      }
                      if (sw !== width || sh !== height) {
                        alphaBuf = resizeImageMask(alphaBuf, mask.bpc, sw, sh, width, height);
                      }
                    } else if (Array.isArray(mask)) {
                      alphaBuf = new Uint8ClampedArray(width * height);
                      const numComps = this.numComps;
                      for (i = 0, ii = width * height; i < ii; ++i) {
                        let opacity = 0;
                        const imageOffset = i * numComps;
                        for (j = 0; j < numComps; ++j) {
                          const color = image[imageOffset + j];
                          const maskOffset = j * 2;
                          if (color < mask[maskOffset] || color > mask[maskOffset + 1]) {
                            opacity = 255;
                            break;
                          }
                        }
                        alphaBuf[i] = opacity;
                      }
                    } else {
                      throw new _util2.FormatError("Unknown mask format.");
                    }
                  }
                  if (alphaBuf) {
                    for (i = 0, j = 3, ii = width * actualHeight; i < ii; ++i, j += 4) {
                      rgbaBuf[j] = alphaBuf[i];
                    }
                  } else {
                    for (i = 0, j = 3, ii = width * actualHeight; i < ii; ++i, j += 4) {
                      rgbaBuf[j] = 255;
                    }
                  }
                }
                undoPreblend(buffer, width, height) {
                  const matte = this.smask?.matte;
                  if (!matte) {
                    return;
                  }
                  const matteRgb = this.colorSpace.getRgb(matte, 0);
                  const matteR = matteRgb[0];
                  const matteG = matteRgb[1];
                  const matteB = matteRgb[2];
                  const length2 = width * height * 4;
                  for (let i = 0; i < length2; i += 4) {
                    const alpha = buffer[i + 3];
                    if (alpha === 0) {
                      buffer[i] = 255;
                      buffer[i + 1] = 255;
                      buffer[i + 2] = 255;
                      continue;
                    }
                    const k = 255 / alpha;
                    buffer[i] = (buffer[i] - matteR) * k + matteR;
                    buffer[i + 1] = (buffer[i + 1] - matteG) * k + matteG;
                    buffer[i + 2] = (buffer[i + 2] - matteB) * k + matteB;
                  }
                }
                async createImageData(forceRGBA = false, isOffscreenCanvasSupported = false) {
                  const drawWidth = this.drawWidth;
                  const drawHeight = this.drawHeight;
                  const imgData = {
                    width: drawWidth,
                    height: drawHeight,
                    interpolate: this.interpolate,
                    kind: 0,
                    data: null
                  };
                  const numComps = this.numComps;
                  const originalWidth = this.width;
                  const originalHeight = this.height;
                  const bpc = this.bpc;
                  const rowBytes = originalWidth * numComps * bpc + 7 >> 3;
                  const mustBeResized = isOffscreenCanvasSupported && _image_resizer.ImageResizer.needsToBeResized(drawWidth, drawHeight);
                  if (!forceRGBA) {
                    let kind;
                    if (this.colorSpace.name === "DeviceGray" && bpc === 1) {
                      kind = _util2.ImageKind.GRAYSCALE_1BPP;
                    } else if (this.colorSpace.name === "DeviceRGB" && bpc === 8 && !this.needsDecode) {
                      kind = _util2.ImageKind.RGB_24BPP;
                    }
                    if (kind && !this.smask && !this.mask && drawWidth === originalWidth && drawHeight === originalHeight) {
                      const data3 = this.getImageBytes(originalHeight * rowBytes, {});
                      if (isOffscreenCanvasSupported) {
                        if (mustBeResized) {
                          return _image_resizer.ImageResizer.createImage({
                            data: data3,
                            kind,
                            width: drawWidth,
                            height: drawHeight,
                            interpolate: this.interpolate
                          }, this.needsDecode);
                        }
                        return this.createBitmap(kind, originalWidth, originalHeight, data3);
                      }
                      imgData.kind = kind;
                      imgData.data = data3;
                      if (this.needsDecode) {
                        (0, _util2.assert)(kind === _util2.ImageKind.GRAYSCALE_1BPP, "PDFImage.createImageData: The image must be grayscale.");
                        const buffer = imgData.data;
                        for (let i = 0, ii = buffer.length; i < ii; i++) {
                          buffer[i] ^= 255;
                        }
                      }
                      return imgData;
                    }
                    if (this.image instanceof _jpeg_stream.JpegStream && !this.smask && !this.mask && !this.needsDecode) {
                      let imageLength = originalHeight * rowBytes;
                      if (isOffscreenCanvasSupported && !mustBeResized) {
                        let isHandled = false;
                        switch (this.colorSpace.name) {
                          case "DeviceGray":
                            imageLength *= 4;
                            isHandled = true;
                            break;
                          case "DeviceRGB":
                            imageLength = imageLength / 3 * 4;
                            isHandled = true;
                            break;
                          case "DeviceCMYK":
                            isHandled = true;
                            break;
                        }
                        if (isHandled) {
                          const rgba = this.getImageBytes(imageLength, {
                            drawWidth,
                            drawHeight,
                            forceRGBA: true
                          });
                          return this.createBitmap(_util2.ImageKind.RGBA_32BPP, drawWidth, drawHeight, rgba);
                        }
                      } else {
                        switch (this.colorSpace.name) {
                          case "DeviceGray":
                            imageLength *= 3;
                          case "DeviceRGB":
                          case "DeviceCMYK":
                            imgData.kind = _util2.ImageKind.RGB_24BPP;
                            imgData.data = this.getImageBytes(imageLength, {
                              drawWidth,
                              drawHeight,
                              forceRGB: true
                            });
                            if (mustBeResized) {
                              return _image_resizer.ImageResizer.createImage(imgData);
                            }
                            return imgData;
                        }
                      }
                    }
                  }
                  const imgArray = this.getImageBytes(originalHeight * rowBytes, {
                    internal: true
                  });
                  const actualHeight = 0 | imgArray.length / rowBytes * drawHeight / originalHeight;
                  const comps = this.getComponents(imgArray);
                  let alpha01, maybeUndoPreblend;
                  let canvas, ctx, canvasImgData, data2;
                  if (isOffscreenCanvasSupported && !mustBeResized) {
                    canvas = new OffscreenCanvas(drawWidth, drawHeight);
                    ctx = canvas.getContext("2d");
                    canvasImgData = ctx.createImageData(drawWidth, drawHeight);
                    data2 = canvasImgData.data;
                  }
                  imgData.kind = _util2.ImageKind.RGBA_32BPP;
                  if (!forceRGBA && !this.smask && !this.mask) {
                    if (!isOffscreenCanvasSupported || mustBeResized) {
                      imgData.kind = _util2.ImageKind.RGB_24BPP;
                      data2 = new Uint8ClampedArray(drawWidth * drawHeight * 3);
                      alpha01 = 0;
                    } else {
                      const arr = new Uint32Array(data2.buffer);
                      arr.fill(_util2.FeatureTest.isLittleEndian ? 4278190080 : 255);
                      alpha01 = 1;
                    }
                    maybeUndoPreblend = false;
                  } else {
                    if (!isOffscreenCanvasSupported || mustBeResized) {
                      data2 = new Uint8ClampedArray(drawWidth * drawHeight * 4);
                    }
                    alpha01 = 1;
                    maybeUndoPreblend = true;
                    this.fillOpacity(data2, drawWidth, drawHeight, actualHeight, comps);
                  }
                  if (this.needsDecode) {
                    this.decodeBuffer(comps);
                  }
                  this.colorSpace.fillRgb(data2, originalWidth, originalHeight, drawWidth, drawHeight, actualHeight, bpc, comps, alpha01);
                  if (maybeUndoPreblend) {
                    this.undoPreblend(data2, drawWidth, actualHeight);
                  }
                  if (isOffscreenCanvasSupported && !mustBeResized) {
                    ctx.putImageData(canvasImgData, 0, 0);
                    const bitmap = canvas.transferToImageBitmap();
                    return {
                      data: null,
                      width: drawWidth,
                      height: drawHeight,
                      bitmap,
                      interpolate: this.interpolate
                    };
                  }
                  imgData.data = data2;
                  if (mustBeResized) {
                    return _image_resizer.ImageResizer.createImage(imgData);
                  }
                  return imgData;
                }
                fillGrayBuffer(buffer) {
                  const numComps = this.numComps;
                  if (numComps !== 1) {
                    throw new _util2.FormatError(`Reading gray scale from a color image: ${numComps}`);
                  }
                  const width = this.width;
                  const height = this.height;
                  const bpc = this.bpc;
                  const rowBytes = width * numComps * bpc + 7 >> 3;
                  const imgArray = this.getImageBytes(height * rowBytes, {
                    internal: true
                  });
                  const comps = this.getComponents(imgArray);
                  let i, length2;
                  if (bpc === 1) {
                    length2 = width * height;
                    if (this.needsDecode) {
                      for (i = 0; i < length2; ++i) {
                        buffer[i] = comps[i] - 1 & 255;
                      }
                    } else {
                      for (i = 0; i < length2; ++i) {
                        buffer[i] = -comps[i] & 255;
                      }
                    }
                    return;
                  }
                  if (this.needsDecode) {
                    this.decodeBuffer(comps);
                  }
                  length2 = width * height;
                  const scale = 255 / ((1 << bpc) - 1);
                  for (i = 0; i < length2; ++i) {
                    buffer[i] = scale * comps[i];
                  }
                }
                createBitmap(kind, width, height, src) {
                  const canvas = new OffscreenCanvas(width, height);
                  const ctx = canvas.getContext("2d");
                  let imgData;
                  if (kind === _util2.ImageKind.RGBA_32BPP) {
                    imgData = new ImageData(src, width, height);
                  } else {
                    imgData = ctx.createImageData(width, height);
                    (0, _image_utils.convertToRGBA)({
                      kind,
                      src,
                      dest: new Uint32Array(imgData.data.buffer),
                      width,
                      height,
                      inverseDecode: this.needsDecode
                    });
                  }
                  ctx.putImageData(imgData, 0, 0);
                  const bitmap = canvas.transferToImageBitmap();
                  return {
                    data: null,
                    width,
                    height,
                    bitmap,
                    interpolate: this.interpolate
                  };
                }
                getImageBytes(length2, {
                  drawWidth,
                  drawHeight,
                  forceRGBA = false,
                  forceRGB = false,
                  internal = false
                }) {
                  this.image.reset();
                  this.image.drawWidth = drawWidth || this.width;
                  this.image.drawHeight = drawHeight || this.height;
                  this.image.forceRGBA = !!forceRGBA;
                  this.image.forceRGB = !!forceRGB;
                  const imageBytes = this.image.getBytes(length2);
                  if (internal || this.image instanceof _decode_stream.DecodeStream) {
                    return imageBytes;
                  }
                  (0, _util2.assert)(imageBytes instanceof Uint8Array, 'PDFImage.getImageBytes: Unsupported "imageBytes" type.');
                  return new Uint8Array(imageBytes);
                }
              }
              exports3.PDFImage = PDFImage;
            }),
            /* 66 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.Catalog = void 0;
              var _core_utils = __w_pdfjs_require__3(3);
              var _util2 = __w_pdfjs_require__3(2);
              var _primitives = __w_pdfjs_require__3(4);
              var _name_number_tree = __w_pdfjs_require__3(67);
              var _base_stream = __w_pdfjs_require__3(5);
              var _cleanup_helper = __w_pdfjs_require__3(68);
              var _colorspace = __w_pdfjs_require__3(12);
              var _file_spec = __w_pdfjs_require__3(69);
              var _image_utils = __w_pdfjs_require__3(59);
              var _metadata_parser = __w_pdfjs_require__3(70);
              var _struct_tree = __w_pdfjs_require__3(72);
              function fetchDestination(dest) {
                if (dest instanceof _primitives.Dict) {
                  dest = dest.get("D");
                }
                return Array.isArray(dest) ? dest : null;
              }
              class Catalog {
                constructor(pdfManager, xref) {
                  this.pdfManager = pdfManager;
                  this.xref = xref;
                  this._catDict = xref.getCatalogObj();
                  if (!(this._catDict instanceof _primitives.Dict)) {
                    throw new _util2.FormatError("Catalog object is not a dictionary.");
                  }
                  this.toplevelPagesDict;
                  this._actualNumPages = null;
                  this.fontCache = new _primitives.RefSetCache();
                  this.builtInCMapCache = /* @__PURE__ */ new Map();
                  this.standardFontDataCache = /* @__PURE__ */ new Map();
                  this.globalImageCache = new _image_utils.GlobalImageCache();
                  this.pageKidsCountCache = new _primitives.RefSetCache();
                  this.pageIndexCache = new _primitives.RefSetCache();
                  this.nonBlendModesSet = new _primitives.RefSet();
                  this.systemFontCache = /* @__PURE__ */ new Map();
                }
                cloneDict() {
                  return this._catDict.clone();
                }
                get version() {
                  const version7 = this._catDict.get("Version");
                  if (version7 instanceof _primitives.Name) {
                    if (_core_utils.PDF_VERSION_REGEXP.test(version7.name)) {
                      return (0, _util2.shadow)(this, "version", version7.name);
                    }
                    (0, _util2.warn)(`Invalid PDF catalog version: ${version7.name}`);
                  }
                  return (0, _util2.shadow)(this, "version", null);
                }
                get lang() {
                  const lang = this._catDict.get("Lang");
                  return (0, _util2.shadow)(this, "lang", typeof lang === "string" ? (0, _util2.stringToPDFString)(lang) : null);
                }
                get needsRendering() {
                  const needsRendering = this._catDict.get("NeedsRendering");
                  return (0, _util2.shadow)(this, "needsRendering", typeof needsRendering === "boolean" ? needsRendering : false);
                }
                get collection() {
                  let collection = null;
                  try {
                    const obj = this._catDict.get("Collection");
                    if (obj instanceof _primitives.Dict && obj.size > 0) {
                      collection = obj;
                    }
                  } catch (ex) {
                    if (ex instanceof _core_utils.MissingDataException) {
                      throw ex;
                    }
                    (0, _util2.info)("Cannot fetch Collection entry; assuming no collection is present.");
                  }
                  return (0, _util2.shadow)(this, "collection", collection);
                }
                get acroForm() {
                  let acroForm = null;
                  try {
                    const obj = this._catDict.get("AcroForm");
                    if (obj instanceof _primitives.Dict && obj.size > 0) {
                      acroForm = obj;
                    }
                  } catch (ex) {
                    if (ex instanceof _core_utils.MissingDataException) {
                      throw ex;
                    }
                    (0, _util2.info)("Cannot fetch AcroForm entry; assuming no forms are present.");
                  }
                  return (0, _util2.shadow)(this, "acroForm", acroForm);
                }
                get acroFormRef() {
                  const value = this._catDict.getRaw("AcroForm");
                  return (0, _util2.shadow)(this, "acroFormRef", value instanceof _primitives.Ref ? value : null);
                }
                get metadata() {
                  const streamRef = this._catDict.getRaw("Metadata");
                  if (!(streamRef instanceof _primitives.Ref)) {
                    return (0, _util2.shadow)(this, "metadata", null);
                  }
                  let metadata = null;
                  try {
                    const stream = this.xref.fetch(streamRef, !this.xref.encrypt?.encryptMetadata);
                    if (stream instanceof _base_stream.BaseStream && stream.dict instanceof _primitives.Dict) {
                      const type5 = stream.dict.get("Type");
                      const subtype = stream.dict.get("Subtype");
                      if ((0, _primitives.isName)(type5, "Metadata") && (0, _primitives.isName)(subtype, "XML")) {
                        const data2 = (0, _util2.stringToUTF8String)(stream.getString());
                        if (data2) {
                          metadata = new _metadata_parser.MetadataParser(data2).serializable;
                        }
                      }
                    }
                  } catch (ex) {
                    if (ex instanceof _core_utils.MissingDataException) {
                      throw ex;
                    }
                    (0, _util2.info)(`Skipping invalid Metadata: "${ex}".`);
                  }
                  return (0, _util2.shadow)(this, "metadata", metadata);
                }
                get markInfo() {
                  let markInfo = null;
                  try {
                    markInfo = this._readMarkInfo();
                  } catch (ex) {
                    if (ex instanceof _core_utils.MissingDataException) {
                      throw ex;
                    }
                    (0, _util2.warn)("Unable to read mark info.");
                  }
                  return (0, _util2.shadow)(this, "markInfo", markInfo);
                }
                _readMarkInfo() {
                  const obj = this._catDict.get("MarkInfo");
                  if (!(obj instanceof _primitives.Dict)) {
                    return null;
                  }
                  const markInfo = {
                    Marked: false,
                    UserProperties: false,
                    Suspects: false
                  };
                  for (const key2 in markInfo) {
                    const value = obj.get(key2);
                    if (typeof value === "boolean") {
                      markInfo[key2] = value;
                    }
                  }
                  return markInfo;
                }
                get structTreeRoot() {
                  let structTree = null;
                  try {
                    structTree = this._readStructTreeRoot();
                  } catch (ex) {
                    if (ex instanceof _core_utils.MissingDataException) {
                      throw ex;
                    }
                    (0, _util2.warn)("Unable read to structTreeRoot info.");
                  }
                  return (0, _util2.shadow)(this, "structTreeRoot", structTree);
                }
                _readStructTreeRoot() {
                  const rawObj = this._catDict.getRaw("StructTreeRoot");
                  const obj = this.xref.fetchIfRef(rawObj);
                  if (!(obj instanceof _primitives.Dict)) {
                    return null;
                  }
                  const root2 = new _struct_tree.StructTreeRoot(obj, rawObj);
                  root2.init();
                  return root2;
                }
                get toplevelPagesDict() {
                  const pagesObj = this._catDict.get("Pages");
                  if (!(pagesObj instanceof _primitives.Dict)) {
                    throw new _util2.FormatError("Invalid top-level pages dictionary.");
                  }
                  return (0, _util2.shadow)(this, "toplevelPagesDict", pagesObj);
                }
                get documentOutline() {
                  let obj = null;
                  try {
                    obj = this._readDocumentOutline();
                  } catch (ex) {
                    if (ex instanceof _core_utils.MissingDataException) {
                      throw ex;
                    }
                    (0, _util2.warn)("Unable to read document outline.");
                  }
                  return (0, _util2.shadow)(this, "documentOutline", obj);
                }
                _readDocumentOutline() {
                  let obj = this._catDict.get("Outlines");
                  if (!(obj instanceof _primitives.Dict)) {
                    return null;
                  }
                  obj = obj.getRaw("First");
                  if (!(obj instanceof _primitives.Ref)) {
                    return null;
                  }
                  const root2 = {
                    items: []
                  };
                  const queue = [{
                    obj,
                    parent: root2
                  }];
                  const processed = new _primitives.RefSet();
                  processed.put(obj);
                  const xref = this.xref, blackColor = new Uint8ClampedArray(3);
                  while (queue.length > 0) {
                    const i = queue.shift();
                    const outlineDict = xref.fetchIfRef(i.obj);
                    if (outlineDict === null) {
                      continue;
                    }
                    if (!outlineDict.has("Title")) {
                      throw new _util2.FormatError("Invalid outline item encountered.");
                    }
                    const data2 = {
                      url: null,
                      dest: null,
                      action: null
                    };
                    Catalog.parseDestDictionary({
                      destDict: outlineDict,
                      resultObj: data2,
                      docBaseUrl: this.baseUrl,
                      docAttachments: this.attachments
                    });
                    const title = outlineDict.get("Title");
                    const flags = outlineDict.get("F") || 0;
                    const color = outlineDict.getArray("C");
                    const count = outlineDict.get("Count");
                    let rgbColor = blackColor;
                    if (Array.isArray(color) && color.length === 3 && (color[0] !== 0 || color[1] !== 0 || color[2] !== 0)) {
                      rgbColor = _colorspace.ColorSpace.singletons.rgb.getRgb(color, 0);
                    }
                    const outlineItem = {
                      action: data2.action,
                      attachment: data2.attachment,
                      dest: data2.dest,
                      url: data2.url,
                      unsafeUrl: data2.unsafeUrl,
                      newWindow: data2.newWindow,
                      setOCGState: data2.setOCGState,
                      title: (0, _util2.stringToPDFString)(title),
                      color: rgbColor,
                      count: Number.isInteger(count) ? count : void 0,
                      bold: !!(flags & 2),
                      italic: !!(flags & 1),
                      items: []
                    };
                    i.parent.items.push(outlineItem);
                    obj = outlineDict.getRaw("First");
                    if (obj instanceof _primitives.Ref && !processed.has(obj)) {
                      queue.push({
                        obj,
                        parent: outlineItem
                      });
                      processed.put(obj);
                    }
                    obj = outlineDict.getRaw("Next");
                    if (obj instanceof _primitives.Ref && !processed.has(obj)) {
                      queue.push({
                        obj,
                        parent: i.parent
                      });
                      processed.put(obj);
                    }
                  }
                  return root2.items.length > 0 ? root2.items : null;
                }
                get permissions() {
                  let permissions = null;
                  try {
                    permissions = this._readPermissions();
                  } catch (ex) {
                    if (ex instanceof _core_utils.MissingDataException) {
                      throw ex;
                    }
                    (0, _util2.warn)("Unable to read permissions.");
                  }
                  return (0, _util2.shadow)(this, "permissions", permissions);
                }
                _readPermissions() {
                  const encrypt = this.xref.trailer.get("Encrypt");
                  if (!(encrypt instanceof _primitives.Dict)) {
                    return null;
                  }
                  let flags = encrypt.get("P");
                  if (typeof flags !== "number") {
                    return null;
                  }
                  flags += 2 ** 32;
                  const permissions = [];
                  for (const key2 in _util2.PermissionFlag) {
                    const value = _util2.PermissionFlag[key2];
                    if (flags & value) {
                      permissions.push(value);
                    }
                  }
                  return permissions;
                }
                get optionalContentConfig() {
                  let config = null;
                  try {
                    const properties2 = this._catDict.get("OCProperties");
                    if (!properties2) {
                      return (0, _util2.shadow)(this, "optionalContentConfig", null);
                    }
                    const defaultConfig2 = properties2.get("D");
                    if (!defaultConfig2) {
                      return (0, _util2.shadow)(this, "optionalContentConfig", null);
                    }
                    const groupsData = properties2.get("OCGs");
                    if (!Array.isArray(groupsData)) {
                      return (0, _util2.shadow)(this, "optionalContentConfig", null);
                    }
                    const groups = [];
                    const groupRefs = [];
                    for (const groupRef of groupsData) {
                      if (!(groupRef instanceof _primitives.Ref)) {
                        continue;
                      }
                      groupRefs.push(groupRef);
                      const group = this.xref.fetchIfRef(groupRef);
                      groups.push({
                        id: groupRef.toString(),
                        name: typeof group.get("Name") === "string" ? (0, _util2.stringToPDFString)(group.get("Name")) : null,
                        intent: typeof group.get("Intent") === "string" ? (0, _util2.stringToPDFString)(group.get("Intent")) : null
                      });
                    }
                    config = this._readOptionalContentConfig(defaultConfig2, groupRefs);
                    config.groups = groups;
                  } catch (ex) {
                    if (ex instanceof _core_utils.MissingDataException) {
                      throw ex;
                    }
                    (0, _util2.warn)(`Unable to read optional content config: ${ex}`);
                  }
                  return (0, _util2.shadow)(this, "optionalContentConfig", config);
                }
                _readOptionalContentConfig(config, contentGroupRefs) {
                  function parseOnOff(refs2) {
                    const onParsed = [];
                    if (Array.isArray(refs2)) {
                      for (const value of refs2) {
                        if (!(value instanceof _primitives.Ref)) {
                          continue;
                        }
                        if (contentGroupRefs.includes(value)) {
                          onParsed.push(value.toString());
                        }
                      }
                    }
                    return onParsed;
                  }
                  function parseOrder(refs2, nestedLevels = 0) {
                    if (!Array.isArray(refs2)) {
                      return null;
                    }
                    const order = [];
                    for (const value of refs2) {
                      if (value instanceof _primitives.Ref && contentGroupRefs.includes(value)) {
                        parsedOrderRefs.put(value);
                        order.push(value.toString());
                        continue;
                      }
                      const nestedOrder = parseNestedOrder(value, nestedLevels);
                      if (nestedOrder) {
                        order.push(nestedOrder);
                      }
                    }
                    if (nestedLevels > 0) {
                      return order;
                    }
                    const hiddenGroups = [];
                    for (const groupRef of contentGroupRefs) {
                      if (parsedOrderRefs.has(groupRef)) {
                        continue;
                      }
                      hiddenGroups.push(groupRef.toString());
                    }
                    if (hiddenGroups.length) {
                      order.push({
                        name: null,
                        order: hiddenGroups
                      });
                    }
                    return order;
                  }
                  function parseNestedOrder(ref3, nestedLevels) {
                    if (++nestedLevels > MAX_NESTED_LEVELS) {
                      (0, _util2.warn)("parseNestedOrder - reached MAX_NESTED_LEVELS.");
                      return null;
                    }
                    const value = xref.fetchIfRef(ref3);
                    if (!Array.isArray(value)) {
                      return null;
                    }
                    const nestedName = xref.fetchIfRef(value[0]);
                    if (typeof nestedName !== "string") {
                      return null;
                    }
                    const nestedOrder = parseOrder(value.slice(1), nestedLevels);
                    if (!nestedOrder || !nestedOrder.length) {
                      return null;
                    }
                    return {
                      name: (0, _util2.stringToPDFString)(nestedName),
                      order: nestedOrder
                    };
                  }
                  const xref = this.xref, parsedOrderRefs = new _primitives.RefSet(), MAX_NESTED_LEVELS = 10;
                  return {
                    name: typeof config.get("Name") === "string" ? (0, _util2.stringToPDFString)(config.get("Name")) : null,
                    creator: typeof config.get("Creator") === "string" ? (0, _util2.stringToPDFString)(config.get("Creator")) : null,
                    baseState: config.get("BaseState") instanceof _primitives.Name ? config.get("BaseState").name : null,
                    on: parseOnOff(config.get("ON")),
                    off: parseOnOff(config.get("OFF")),
                    order: parseOrder(config.get("Order")),
                    groups: null
                  };
                }
                setActualNumPages(num = null) {
                  this._actualNumPages = num;
                }
                get hasActualNumPages() {
                  return this._actualNumPages !== null;
                }
                get _pagesCount() {
                  const obj = this.toplevelPagesDict.get("Count");
                  if (!Number.isInteger(obj)) {
                    throw new _util2.FormatError("Page count in top-level pages dictionary is not an integer.");
                  }
                  return (0, _util2.shadow)(this, "_pagesCount", obj);
                }
                get numPages() {
                  return this.hasActualNumPages ? this._actualNumPages : this._pagesCount;
                }
                get destinations() {
                  const obj = this._readDests(), dests = /* @__PURE__ */ Object.create(null);
                  if (obj instanceof _name_number_tree.NameTree) {
                    for (const [key2, value] of obj.getAll()) {
                      const dest = fetchDestination(value);
                      if (dest) {
                        dests[(0, _util2.stringToPDFString)(key2)] = dest;
                      }
                    }
                  } else if (obj instanceof _primitives.Dict) {
                    obj.forEach(function(key2, value) {
                      const dest = fetchDestination(value);
                      if (dest) {
                        dests[key2] = dest;
                      }
                    });
                  }
                  return (0, _util2.shadow)(this, "destinations", dests);
                }
                getDestination(id) {
                  const obj = this._readDests();
                  if (obj instanceof _name_number_tree.NameTree) {
                    const dest = fetchDestination(obj.get(id));
                    if (dest) {
                      return dest;
                    }
                    const allDest = this.destinations[id];
                    if (allDest) {
                      (0, _util2.warn)(`Found "${id}" at an incorrect position in the NameTree.`);
                      return allDest;
                    }
                  } else if (obj instanceof _primitives.Dict) {
                    const dest = fetchDestination(obj.get(id));
                    if (dest) {
                      return dest;
                    }
                  }
                  return null;
                }
                _readDests() {
                  const obj = this._catDict.get("Names");
                  if (obj?.has("Dests")) {
                    return new _name_number_tree.NameTree(obj.getRaw("Dests"), this.xref);
                  } else if (this._catDict.has("Dests")) {
                    return this._catDict.get("Dests");
                  }
                  return void 0;
                }
                get pageLabels() {
                  let obj = null;
                  try {
                    obj = this._readPageLabels();
                  } catch (ex) {
                    if (ex instanceof _core_utils.MissingDataException) {
                      throw ex;
                    }
                    (0, _util2.warn)("Unable to read page labels.");
                  }
                  return (0, _util2.shadow)(this, "pageLabels", obj);
                }
                _readPageLabels() {
                  const obj = this._catDict.getRaw("PageLabels");
                  if (!obj) {
                    return null;
                  }
                  const pageLabels = new Array(this.numPages);
                  let style2 = null, prefix3 = "";
                  const numberTree = new _name_number_tree.NumberTree(obj, this.xref);
                  const nums = numberTree.getAll();
                  let currentLabel = "", currentIndex = 1;
                  for (let i = 0, ii = this.numPages; i < ii; i++) {
                    const labelDict = nums.get(i);
                    if (labelDict !== void 0) {
                      if (!(labelDict instanceof _primitives.Dict)) {
                        throw new _util2.FormatError("PageLabel is not a dictionary.");
                      }
                      if (labelDict.has("Type") && !(0, _primitives.isName)(labelDict.get("Type"), "PageLabel")) {
                        throw new _util2.FormatError("Invalid type in PageLabel dictionary.");
                      }
                      if (labelDict.has("S")) {
                        const s = labelDict.get("S");
                        if (!(s instanceof _primitives.Name)) {
                          throw new _util2.FormatError("Invalid style in PageLabel dictionary.");
                        }
                        style2 = s.name;
                      } else {
                        style2 = null;
                      }
                      if (labelDict.has("P")) {
                        const p = labelDict.get("P");
                        if (typeof p !== "string") {
                          throw new _util2.FormatError("Invalid prefix in PageLabel dictionary.");
                        }
                        prefix3 = (0, _util2.stringToPDFString)(p);
                      } else {
                        prefix3 = "";
                      }
                      if (labelDict.has("St")) {
                        const st = labelDict.get("St");
                        if (!(Number.isInteger(st) && st >= 1)) {
                          throw new _util2.FormatError("Invalid start in PageLabel dictionary.");
                        }
                        currentIndex = st;
                      } else {
                        currentIndex = 1;
                      }
                    }
                    switch (style2) {
                      case "D":
                        currentLabel = currentIndex;
                        break;
                      case "R":
                      case "r":
                        currentLabel = (0, _core_utils.toRomanNumerals)(currentIndex, style2 === "r");
                        break;
                      case "A":
                      case "a":
                        const LIMIT = 26;
                        const A_UPPER_CASE = 65, A_LOWER_CASE = 97;
                        const baseCharCode = style2 === "a" ? A_LOWER_CASE : A_UPPER_CASE;
                        const letterIndex = currentIndex - 1;
                        const character2 = String.fromCharCode(baseCharCode + letterIndex % LIMIT);
                        currentLabel = character2.repeat(Math.floor(letterIndex / LIMIT) + 1);
                        break;
                      default:
                        if (style2) {
                          throw new _util2.FormatError(`Invalid style "${style2}" in PageLabel dictionary.`);
                        }
                        currentLabel = "";
                    }
                    pageLabels[i] = prefix3 + currentLabel;
                    currentIndex++;
                  }
                  return pageLabels;
                }
                get pageLayout() {
                  const obj = this._catDict.get("PageLayout");
                  let pageLayout = "";
                  if (obj instanceof _primitives.Name) {
                    switch (obj.name) {
                      case "SinglePage":
                      case "OneColumn":
                      case "TwoColumnLeft":
                      case "TwoColumnRight":
                      case "TwoPageLeft":
                      case "TwoPageRight":
                        pageLayout = obj.name;
                    }
                  }
                  return (0, _util2.shadow)(this, "pageLayout", pageLayout);
                }
                get pageMode() {
                  const obj = this._catDict.get("PageMode");
                  let pageMode = "UseNone";
                  if (obj instanceof _primitives.Name) {
                    switch (obj.name) {
                      case "UseNone":
                      case "UseOutlines":
                      case "UseThumbs":
                      case "FullScreen":
                      case "UseOC":
                      case "UseAttachments":
                        pageMode = obj.name;
                    }
                  }
                  return (0, _util2.shadow)(this, "pageMode", pageMode);
                }
                get viewerPreferences() {
                  const obj = this._catDict.get("ViewerPreferences");
                  if (!(obj instanceof _primitives.Dict)) {
                    return (0, _util2.shadow)(this, "viewerPreferences", null);
                  }
                  let prefs = null;
                  for (const key2 of obj.getKeys()) {
                    const value = obj.get(key2);
                    let prefValue;
                    switch (key2) {
                      case "HideToolbar":
                      case "HideMenubar":
                      case "HideWindowUI":
                      case "FitWindow":
                      case "CenterWindow":
                      case "DisplayDocTitle":
                      case "PickTrayByPDFSize":
                        if (typeof value === "boolean") {
                          prefValue = value;
                        }
                        break;
                      case "NonFullScreenPageMode":
                        if (value instanceof _primitives.Name) {
                          switch (value.name) {
                            case "UseNone":
                            case "UseOutlines":
                            case "UseThumbs":
                            case "UseOC":
                              prefValue = value.name;
                              break;
                            default:
                              prefValue = "UseNone";
                          }
                        }
                        break;
                      case "Direction":
                        if (value instanceof _primitives.Name) {
                          switch (value.name) {
                            case "L2R":
                            case "R2L":
                              prefValue = value.name;
                              break;
                            default:
                              prefValue = "L2R";
                          }
                        }
                        break;
                      case "ViewArea":
                      case "ViewClip":
                      case "PrintArea":
                      case "PrintClip":
                        if (value instanceof _primitives.Name) {
                          switch (value.name) {
                            case "MediaBox":
                            case "CropBox":
                            case "BleedBox":
                            case "TrimBox":
                            case "ArtBox":
                              prefValue = value.name;
                              break;
                            default:
                              prefValue = "CropBox";
                          }
                        }
                        break;
                      case "PrintScaling":
                        if (value instanceof _primitives.Name) {
                          switch (value.name) {
                            case "None":
                            case "AppDefault":
                              prefValue = value.name;
                              break;
                            default:
                              prefValue = "AppDefault";
                          }
                        }
                        break;
                      case "Duplex":
                        if (value instanceof _primitives.Name) {
                          switch (value.name) {
                            case "Simplex":
                            case "DuplexFlipShortEdge":
                            case "DuplexFlipLongEdge":
                              prefValue = value.name;
                              break;
                            default:
                              prefValue = "None";
                          }
                        }
                        break;
                      case "PrintPageRange":
                        if (Array.isArray(value) && value.length % 2 === 0) {
                          const isValid2 = value.every((page, i, arr) => {
                            return Number.isInteger(page) && page > 0 && (i === 0 || page >= arr[i - 1]) && page <= this.numPages;
                          });
                          if (isValid2) {
                            prefValue = value;
                          }
                        }
                        break;
                      case "NumCopies":
                        if (Number.isInteger(value) && value > 0) {
                          prefValue = value;
                        }
                        break;
                      default:
                        (0, _util2.warn)(`Ignoring non-standard key in ViewerPreferences: ${key2}.`);
                        continue;
                    }
                    if (prefValue === void 0) {
                      (0, _util2.warn)(`Bad value, for key "${key2}", in ViewerPreferences: ${value}.`);
                      continue;
                    }
                    if (!prefs) {
                      prefs = /* @__PURE__ */ Object.create(null);
                    }
                    prefs[key2] = prefValue;
                  }
                  return (0, _util2.shadow)(this, "viewerPreferences", prefs);
                }
                get openAction() {
                  const obj = this._catDict.get("OpenAction");
                  const openAction = /* @__PURE__ */ Object.create(null);
                  if (obj instanceof _primitives.Dict) {
                    const destDict = new _primitives.Dict(this.xref);
                    destDict.set("A", obj);
                    const resultObj = {
                      url: null,
                      dest: null,
                      action: null
                    };
                    Catalog.parseDestDictionary({
                      destDict,
                      resultObj
                    });
                    if (Array.isArray(resultObj.dest)) {
                      openAction.dest = resultObj.dest;
                    } else if (resultObj.action) {
                      openAction.action = resultObj.action;
                    }
                  } else if (Array.isArray(obj)) {
                    openAction.dest = obj;
                  }
                  return (0, _util2.shadow)(this, "openAction", (0, _util2.objectSize)(openAction) > 0 ? openAction : null);
                }
                get attachments() {
                  const obj = this._catDict.get("Names");
                  let attachments = null;
                  if (obj instanceof _primitives.Dict && obj.has("EmbeddedFiles")) {
                    const nameTree = new _name_number_tree.NameTree(obj.getRaw("EmbeddedFiles"), this.xref);
                    for (const [key2, value] of nameTree.getAll()) {
                      const fs = new _file_spec.FileSpec(value, this.xref);
                      if (!attachments) {
                        attachments = /* @__PURE__ */ Object.create(null);
                      }
                      attachments[(0, _util2.stringToPDFString)(key2)] = fs.serializable;
                    }
                  }
                  return (0, _util2.shadow)(this, "attachments", attachments);
                }
                get xfaImages() {
                  const obj = this._catDict.get("Names");
                  let xfaImages = null;
                  if (obj instanceof _primitives.Dict && obj.has("XFAImages")) {
                    const nameTree = new _name_number_tree.NameTree(obj.getRaw("XFAImages"), this.xref);
                    for (const [key2, value] of nameTree.getAll()) {
                      if (!xfaImages) {
                        xfaImages = new _primitives.Dict(this.xref);
                      }
                      xfaImages.set((0, _util2.stringToPDFString)(key2), value);
                    }
                  }
                  return (0, _util2.shadow)(this, "xfaImages", xfaImages);
                }
                _collectJavaScript() {
                  const obj = this._catDict.get("Names");
                  let javaScript = null;
                  function appendIfJavaScriptDict(name, jsDict) {
                    if (!(jsDict instanceof _primitives.Dict)) {
                      return;
                    }
                    if (!(0, _primitives.isName)(jsDict.get("S"), "JavaScript")) {
                      return;
                    }
                    let js = jsDict.get("JS");
                    if (js instanceof _base_stream.BaseStream) {
                      js = js.getString();
                    } else if (typeof js !== "string") {
                      return;
                    }
                    js = (0, _util2.stringToPDFString)(js).replaceAll("\0", "");
                    if (js) {
                      (javaScript ||= /* @__PURE__ */ new Map()).set(name, js);
                    }
                  }
                  if (obj instanceof _primitives.Dict && obj.has("JavaScript")) {
                    const nameTree = new _name_number_tree.NameTree(obj.getRaw("JavaScript"), this.xref);
                    for (const [key2, value] of nameTree.getAll()) {
                      appendIfJavaScriptDict((0, _util2.stringToPDFString)(key2), value);
                    }
                  }
                  const openAction = this._catDict.get("OpenAction");
                  if (openAction) {
                    appendIfJavaScriptDict("OpenAction", openAction);
                  }
                  return javaScript;
                }
                get jsActions() {
                  const javaScript = this._collectJavaScript();
                  let actions = (0, _core_utils.collectActions)(this.xref, this._catDict, _util2.DocumentActionEventType);
                  if (javaScript) {
                    actions ||= /* @__PURE__ */ Object.create(null);
                    for (const [key2, val] of javaScript) {
                      if (key2 in actions) {
                        actions[key2].push(val);
                      } else {
                        actions[key2] = [val];
                      }
                    }
                  }
                  return (0, _util2.shadow)(this, "jsActions", actions);
                }
                async fontFallback(id, handler) {
                  const translatedFonts = await Promise.all(this.fontCache);
                  for (const translatedFont of translatedFonts) {
                    if (translatedFont.loadedName === id) {
                      translatedFont.fallback(handler);
                      return;
                    }
                  }
                }
                async cleanup(manuallyTriggered = false) {
                  (0, _cleanup_helper.clearGlobalCaches)();
                  this.globalImageCache.clear(manuallyTriggered);
                  this.pageKidsCountCache.clear();
                  this.pageIndexCache.clear();
                  this.nonBlendModesSet.clear();
                  const translatedFonts = await Promise.all(this.fontCache);
                  for (const {
                    dict
                  } of translatedFonts) {
                    delete dict.cacheKey;
                  }
                  this.fontCache.clear();
                  this.builtInCMapCache.clear();
                  this.standardFontDataCache.clear();
                  this.systemFontCache.clear();
                }
                async getPageDict(pageIndex) {
                  const nodesToVisit = [this.toplevelPagesDict];
                  const visitedNodes = new _primitives.RefSet();
                  const pagesRef = this._catDict.getRaw("Pages");
                  if (pagesRef instanceof _primitives.Ref) {
                    visitedNodes.put(pagesRef);
                  }
                  const xref = this.xref, pageKidsCountCache = this.pageKidsCountCache, pageIndexCache = this.pageIndexCache;
                  let currentPageIndex = 0;
                  while (nodesToVisit.length) {
                    const currentNode = nodesToVisit.pop();
                    if (currentNode instanceof _primitives.Ref) {
                      const count2 = pageKidsCountCache.get(currentNode);
                      if (count2 >= 0 && currentPageIndex + count2 <= pageIndex) {
                        currentPageIndex += count2;
                        continue;
                      }
                      if (visitedNodes.has(currentNode)) {
                        throw new _util2.FormatError("Pages tree contains circular reference.");
                      }
                      visitedNodes.put(currentNode);
                      const obj = await xref.fetchAsync(currentNode);
                      if (obj instanceof _primitives.Dict) {
                        let type5 = obj.getRaw("Type");
                        if (type5 instanceof _primitives.Ref) {
                          type5 = await xref.fetchAsync(type5);
                        }
                        if ((0, _primitives.isName)(type5, "Page") || !obj.has("Kids")) {
                          if (!pageKidsCountCache.has(currentNode)) {
                            pageKidsCountCache.put(currentNode, 1);
                          }
                          if (!pageIndexCache.has(currentNode)) {
                            pageIndexCache.put(currentNode, currentPageIndex);
                          }
                          if (currentPageIndex === pageIndex) {
                            return [obj, currentNode];
                          }
                          currentPageIndex++;
                          continue;
                        }
                      }
                      nodesToVisit.push(obj);
                      continue;
                    }
                    if (!(currentNode instanceof _primitives.Dict)) {
                      throw new _util2.FormatError("Page dictionary kid reference points to wrong type of object.");
                    }
                    const {
                      objId
                    } = currentNode;
                    let count = currentNode.getRaw("Count");
                    if (count instanceof _primitives.Ref) {
                      count = await xref.fetchAsync(count);
                    }
                    if (Number.isInteger(count) && count >= 0) {
                      if (objId && !pageKidsCountCache.has(objId)) {
                        pageKidsCountCache.put(objId, count);
                      }
                      if (currentPageIndex + count <= pageIndex) {
                        currentPageIndex += count;
                        continue;
                      }
                    }
                    let kids = currentNode.getRaw("Kids");
                    if (kids instanceof _primitives.Ref) {
                      kids = await xref.fetchAsync(kids);
                    }
                    if (!Array.isArray(kids)) {
                      let type5 = currentNode.getRaw("Type");
                      if (type5 instanceof _primitives.Ref) {
                        type5 = await xref.fetchAsync(type5);
                      }
                      if ((0, _primitives.isName)(type5, "Page") || !currentNode.has("Kids")) {
                        if (currentPageIndex === pageIndex) {
                          return [currentNode, null];
                        }
                        currentPageIndex++;
                        continue;
                      }
                      throw new _util2.FormatError("Page dictionary kids object is not an array.");
                    }
                    for (let last2 = kids.length - 1; last2 >= 0; last2--) {
                      nodesToVisit.push(kids[last2]);
                    }
                  }
                  throw new Error(`Page index ${pageIndex} not found.`);
                }
                async getAllPageDicts(recoveryMode = false) {
                  const {
                    ignoreErrors
                  } = this.pdfManager.evaluatorOptions;
                  const queue = [{
                    currentNode: this.toplevelPagesDict,
                    posInKids: 0
                  }];
                  const visitedNodes = new _primitives.RefSet();
                  const pagesRef = this._catDict.getRaw("Pages");
                  if (pagesRef instanceof _primitives.Ref) {
                    visitedNodes.put(pagesRef);
                  }
                  const map = /* @__PURE__ */ new Map(), xref = this.xref, pageIndexCache = this.pageIndexCache;
                  let pageIndex = 0;
                  function addPageDict(pageDict, pageRef) {
                    if (pageRef && !pageIndexCache.has(pageRef)) {
                      pageIndexCache.put(pageRef, pageIndex);
                    }
                    map.set(pageIndex++, [pageDict, pageRef]);
                  }
                  function addPageError(error2) {
                    if (error2 instanceof _core_utils.XRefEntryException && !recoveryMode) {
                      throw error2;
                    }
                    if (recoveryMode && ignoreErrors && pageIndex === 0) {
                      (0, _util2.warn)(`getAllPageDicts - Skipping invalid first page: "${error2}".`);
                      error2 = _primitives.Dict.empty;
                    }
                    map.set(pageIndex++, [error2, null]);
                  }
                  while (queue.length > 0) {
                    const queueItem = queue.at(-1);
                    const {
                      currentNode,
                      posInKids
                    } = queueItem;
                    let kids = currentNode.getRaw("Kids");
                    if (kids instanceof _primitives.Ref) {
                      try {
                        kids = await xref.fetchAsync(kids);
                      } catch (ex) {
                        addPageError(ex);
                        break;
                      }
                    }
                    if (!Array.isArray(kids)) {
                      addPageError(new _util2.FormatError("Page dictionary kids object is not an array."));
                      break;
                    }
                    if (posInKids >= kids.length) {
                      queue.pop();
                      continue;
                    }
                    const kidObj = kids[posInKids];
                    let obj;
                    if (kidObj instanceof _primitives.Ref) {
                      if (visitedNodes.has(kidObj)) {
                        addPageError(new _util2.FormatError("Pages tree contains circular reference."));
                        break;
                      }
                      visitedNodes.put(kidObj);
                      try {
                        obj = await xref.fetchAsync(kidObj);
                      } catch (ex) {
                        addPageError(ex);
                        break;
                      }
                    } else {
                      obj = kidObj;
                    }
                    if (!(obj instanceof _primitives.Dict)) {
                      addPageError(new _util2.FormatError("Page dictionary kid reference points to wrong type of object."));
                      break;
                    }
                    let type5 = obj.getRaw("Type");
                    if (type5 instanceof _primitives.Ref) {
                      try {
                        type5 = await xref.fetchAsync(type5);
                      } catch (ex) {
                        addPageError(ex);
                        break;
                      }
                    }
                    if ((0, _primitives.isName)(type5, "Page") || !obj.has("Kids")) {
                      addPageDict(obj, kidObj instanceof _primitives.Ref ? kidObj : null);
                    } else {
                      queue.push({
                        currentNode: obj,
                        posInKids: 0
                      });
                    }
                    queueItem.posInKids++;
                  }
                  return map;
                }
                getPageIndex(pageRef) {
                  const cachedPageIndex = this.pageIndexCache.get(pageRef);
                  if (cachedPageIndex !== void 0) {
                    return Promise.resolve(cachedPageIndex);
                  }
                  const xref = this.xref;
                  function pagesBeforeRef(kidRef) {
                    let total2 = 0, parentRef;
                    return xref.fetchAsync(kidRef).then(function(node2) {
                      if ((0, _primitives.isRefsEqual)(kidRef, pageRef) && !(0, _primitives.isDict)(node2, "Page") && !(node2 instanceof _primitives.Dict && !node2.has("Type") && node2.has("Contents"))) {
                        throw new _util2.FormatError("The reference does not point to a /Page dictionary.");
                      }
                      if (!node2) {
                        return null;
                      }
                      if (!(node2 instanceof _primitives.Dict)) {
                        throw new _util2.FormatError("Node must be a dictionary.");
                      }
                      parentRef = node2.getRaw("Parent");
                      return node2.getAsync("Parent");
                    }).then(function(parent2) {
                      if (!parent2) {
                        return null;
                      }
                      if (!(parent2 instanceof _primitives.Dict)) {
                        throw new _util2.FormatError("Parent must be a dictionary.");
                      }
                      return parent2.getAsync("Kids");
                    }).then(function(kids) {
                      if (!kids) {
                        return null;
                      }
                      const kidPromises = [];
                      let found = false;
                      for (const kid of kids) {
                        if (!(kid instanceof _primitives.Ref)) {
                          throw new _util2.FormatError("Kid must be a reference.");
                        }
                        if ((0, _primitives.isRefsEqual)(kid, kidRef)) {
                          found = true;
                          break;
                        }
                        kidPromises.push(xref.fetchAsync(kid).then(function(obj) {
                          if (!(obj instanceof _primitives.Dict)) {
                            throw new _util2.FormatError("Kid node must be a dictionary.");
                          }
                          if (obj.has("Count")) {
                            total2 += obj.get("Count");
                          } else {
                            total2++;
                          }
                        }));
                      }
                      if (!found) {
                        throw new _util2.FormatError("Kid reference not found in parent's kids.");
                      }
                      return Promise.all(kidPromises).then(function() {
                        return [total2, parentRef];
                      });
                    });
                  }
                  let total = 0;
                  const next2 = (ref3) => pagesBeforeRef(ref3).then((args) => {
                    if (!args) {
                      this.pageIndexCache.put(pageRef, total);
                      return total;
                    }
                    const [count, parentRef] = args;
                    total += count;
                    return next2(parentRef);
                  });
                  return next2(pageRef);
                }
                get baseUrl() {
                  const uri = this._catDict.get("URI");
                  if (uri instanceof _primitives.Dict) {
                    const base = uri.get("Base");
                    if (typeof base === "string") {
                      const absoluteUrl = (0, _util2.createValidAbsoluteUrl)(base, null, {
                        tryConvertEncoding: true
                      });
                      if (absoluteUrl) {
                        return (0, _util2.shadow)(this, "baseUrl", absoluteUrl.href);
                      }
                    }
                  }
                  return (0, _util2.shadow)(this, "baseUrl", this.pdfManager.docBaseUrl);
                }
                static parseDestDictionary({
                  destDict,
                  resultObj,
                  docBaseUrl = null,
                  docAttachments = null
                }) {
                  if (!(destDict instanceof _primitives.Dict)) {
                    (0, _util2.warn)("parseDestDictionary: `destDict` must be a dictionary.");
                    return;
                  }
                  let action = destDict.get("A"), url2, dest;
                  if (!(action instanceof _primitives.Dict)) {
                    if (destDict.has("Dest")) {
                      action = destDict.get("Dest");
                    } else {
                      action = destDict.get("AA");
                      if (action instanceof _primitives.Dict) {
                        if (action.has("D")) {
                          action = action.get("D");
                        } else if (action.has("U")) {
                          action = action.get("U");
                        }
                      }
                    }
                  }
                  if (action instanceof _primitives.Dict) {
                    const actionType = action.get("S");
                    if (!(actionType instanceof _primitives.Name)) {
                      (0, _util2.warn)("parseDestDictionary: Invalid type in Action dictionary.");
                      return;
                    }
                    const actionName = actionType.name;
                    switch (actionName) {
                      case "ResetForm":
                        const flags = action.get("Flags");
                        const include = ((typeof flags === "number" ? flags : 0) & 1) === 0;
                        const fields = [];
                        const refs2 = [];
                        for (const obj of action.get("Fields") || []) {
                          if (obj instanceof _primitives.Ref) {
                            refs2.push(obj.toString());
                          } else if (typeof obj === "string") {
                            fields.push((0, _util2.stringToPDFString)(obj));
                          }
                        }
                        resultObj.resetForm = {
                          fields,
                          refs: refs2,
                          include
                        };
                        break;
                      case "URI":
                        url2 = action.get("URI");
                        if (url2 instanceof _primitives.Name) {
                          url2 = "/" + url2.name;
                        }
                        break;
                      case "GoTo":
                        dest = action.get("D");
                        break;
                      case "Launch":
                      case "GoToR":
                        const urlDict = action.get("F");
                        if (urlDict instanceof _primitives.Dict) {
                          url2 = urlDict.get("F") || null;
                        } else if (typeof urlDict === "string") {
                          url2 = urlDict;
                        }
                        let remoteDest = action.get("D");
                        if (remoteDest) {
                          if (remoteDest instanceof _primitives.Name) {
                            remoteDest = remoteDest.name;
                          }
                          if (typeof url2 === "string") {
                            const baseUrl = url2.split("#")[0];
                            if (typeof remoteDest === "string") {
                              url2 = baseUrl + "#" + remoteDest;
                            } else if (Array.isArray(remoteDest)) {
                              url2 = baseUrl + "#" + JSON.stringify(remoteDest);
                            }
                          }
                        }
                        const newWindow = action.get("NewWindow");
                        if (typeof newWindow === "boolean") {
                          resultObj.newWindow = newWindow;
                        }
                        break;
                      case "GoToE":
                        const target = action.get("T");
                        let attachment;
                        if (docAttachments && target instanceof _primitives.Dict) {
                          const relationship = target.get("R");
                          const name = target.get("N");
                          if ((0, _primitives.isName)(relationship, "C") && typeof name === "string") {
                            attachment = docAttachments[(0, _util2.stringToPDFString)(name)];
                          }
                        }
                        if (attachment) {
                          resultObj.attachment = attachment;
                        } else {
                          (0, _util2.warn)(`parseDestDictionary - unimplemented "GoToE" action.`);
                        }
                        break;
                      case "Named":
                        const namedAction = action.get("N");
                        if (namedAction instanceof _primitives.Name) {
                          resultObj.action = namedAction.name;
                        }
                        break;
                      case "SetOCGState":
                        const state = action.get("State");
                        const preserveRB = action.get("PreserveRB");
                        if (!Array.isArray(state) || state.length === 0) {
                          break;
                        }
                        const stateArr = [];
                        for (const elem of state) {
                          if (elem instanceof _primitives.Name) {
                            switch (elem.name) {
                              case "ON":
                              case "OFF":
                              case "Toggle":
                                stateArr.push(elem.name);
                                break;
                            }
                          } else if (elem instanceof _primitives.Ref) {
                            stateArr.push(elem.toString());
                          }
                        }
                        if (stateArr.length !== state.length) {
                          break;
                        }
                        resultObj.setOCGState = {
                          state: stateArr,
                          preserveRB: typeof preserveRB === "boolean" ? preserveRB : true
                        };
                        break;
                      case "JavaScript":
                        const jsAction = action.get("JS");
                        let js;
                        if (jsAction instanceof _base_stream.BaseStream) {
                          js = jsAction.getString();
                        } else if (typeof jsAction === "string") {
                          js = jsAction;
                        }
                        const jsURL = js && (0, _core_utils.recoverJsURL)((0, _util2.stringToPDFString)(js));
                        if (jsURL) {
                          url2 = jsURL.url;
                          resultObj.newWindow = jsURL.newWindow;
                          break;
                        }
                      default:
                        if (actionName === "JavaScript" || actionName === "SubmitForm") {
                          break;
                        }
                        (0, _util2.warn)(`parseDestDictionary - unsupported action: "${actionName}".`);
                        break;
                    }
                  } else if (destDict.has("Dest")) {
                    dest = destDict.get("Dest");
                  }
                  if (typeof url2 === "string") {
                    const absoluteUrl = (0, _util2.createValidAbsoluteUrl)(url2, docBaseUrl, {
                      addDefaultProtocol: true,
                      tryConvertEncoding: true
                    });
                    if (absoluteUrl) {
                      resultObj.url = absoluteUrl.href;
                    }
                    resultObj.unsafeUrl = url2;
                  }
                  if (dest) {
                    if (dest instanceof _primitives.Name) {
                      dest = dest.name;
                    }
                    if (typeof dest === "string") {
                      resultObj.dest = (0, _util2.stringToPDFString)(dest);
                    } else if (Array.isArray(dest)) {
                      resultObj.dest = dest;
                    }
                  }
                }
              }
              exports3.Catalog = Catalog;
            }),
            /* 67 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.NumberTree = exports3.NameTree = void 0;
              var _primitives = __w_pdfjs_require__3(4);
              var _util2 = __w_pdfjs_require__3(2);
              class NameOrNumberTree {
                constructor(root2, xref, type5) {
                  if (this.constructor === NameOrNumberTree) {
                    (0, _util2.unreachable)("Cannot initialize NameOrNumberTree.");
                  }
                  this.root = root2;
                  this.xref = xref;
                  this._type = type5;
                }
                getAll() {
                  const map = /* @__PURE__ */ new Map();
                  if (!this.root) {
                    return map;
                  }
                  const xref = this.xref;
                  const processed = new _primitives.RefSet();
                  processed.put(this.root);
                  const queue = [this.root];
                  while (queue.length > 0) {
                    const obj = xref.fetchIfRef(queue.shift());
                    if (!(obj instanceof _primitives.Dict)) {
                      continue;
                    }
                    if (obj.has("Kids")) {
                      const kids = obj.get("Kids");
                      if (!Array.isArray(kids)) {
                        continue;
                      }
                      for (const kid of kids) {
                        if (processed.has(kid)) {
                          throw new _util2.FormatError(`Duplicate entry in "${this._type}" tree.`);
                        }
                        queue.push(kid);
                        processed.put(kid);
                      }
                      continue;
                    }
                    const entries = obj.get(this._type);
                    if (!Array.isArray(entries)) {
                      continue;
                    }
                    for (let i = 0, ii = entries.length; i < ii; i += 2) {
                      map.set(xref.fetchIfRef(entries[i]), xref.fetchIfRef(entries[i + 1]));
                    }
                  }
                  return map;
                }
                get(key2) {
                  if (!this.root) {
                    return null;
                  }
                  const xref = this.xref;
                  let kidsOrEntries = xref.fetchIfRef(this.root);
                  let loopCount = 0;
                  const MAX_LEVELS = 10;
                  while (kidsOrEntries.has("Kids")) {
                    if (++loopCount > MAX_LEVELS) {
                      (0, _util2.warn)(`Search depth limit reached for "${this._type}" tree.`);
                      return null;
                    }
                    const kids = kidsOrEntries.get("Kids");
                    if (!Array.isArray(kids)) {
                      return null;
                    }
                    let l2 = 0, r2 = kids.length - 1;
                    while (l2 <= r2) {
                      const m = l2 + r2 >> 1;
                      const kid = xref.fetchIfRef(kids[m]);
                      const limits = kid.get("Limits");
                      if (key2 < xref.fetchIfRef(limits[0])) {
                        r2 = m - 1;
                      } else if (key2 > xref.fetchIfRef(limits[1])) {
                        l2 = m + 1;
                      } else {
                        kidsOrEntries = kid;
                        break;
                      }
                    }
                    if (l2 > r2) {
                      return null;
                    }
                  }
                  const entries = kidsOrEntries.get(this._type);
                  if (Array.isArray(entries)) {
                    let l2 = 0, r2 = entries.length - 2;
                    while (l2 <= r2) {
                      const tmp = l2 + r2 >> 1, m = tmp + (tmp & 1);
                      const currentKey = xref.fetchIfRef(entries[m]);
                      if (key2 < currentKey) {
                        r2 = m - 2;
                      } else if (key2 > currentKey) {
                        l2 = m + 2;
                      } else {
                        return xref.fetchIfRef(entries[m + 1]);
                      }
                    }
                  }
                  return null;
                }
              }
              class NameTree extends NameOrNumberTree {
                constructor(root2, xref) {
                  super(root2, xref, "Names");
                }
              }
              exports3.NameTree = NameTree;
              class NumberTree extends NameOrNumberTree {
                constructor(root2, xref) {
                  super(root2, xref, "Nums");
                }
              }
              exports3.NumberTree = NumberTree;
            }),
            /* 68 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.clearGlobalCaches = clearGlobalCaches;
              var _pattern = __w_pdfjs_require__3(50);
              var _primitives = __w_pdfjs_require__3(4);
              var _unicode = __w_pdfjs_require__3(40);
              function clearGlobalCaches() {
                (0, _pattern.clearPatternCaches)();
                (0, _primitives.clearPrimitiveCaches)();
                (0, _unicode.clearUnicodeCaches)();
              }
            }),
            /* 69 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.FileSpec = void 0;
              var _util2 = __w_pdfjs_require__3(2);
              var _base_stream = __w_pdfjs_require__3(5);
              var _primitives = __w_pdfjs_require__3(4);
              function pickPlatformItem(dict) {
                if (dict.has("UF")) {
                  return dict.get("UF");
                } else if (dict.has("F")) {
                  return dict.get("F");
                } else if (dict.has("Unix")) {
                  return dict.get("Unix");
                } else if (dict.has("Mac")) {
                  return dict.get("Mac");
                } else if (dict.has("DOS")) {
                  return dict.get("DOS");
                }
                return null;
              }
              class FileSpec {
                constructor(root2, xref) {
                  if (!(root2 instanceof _primitives.Dict)) {
                    return;
                  }
                  this.xref = xref;
                  this.root = root2;
                  if (root2.has("FS")) {
                    this.fs = root2.get("FS");
                  }
                  this.description = root2.has("Desc") ? (0, _util2.stringToPDFString)(root2.get("Desc")) : "";
                  if (root2.has("RF")) {
                    (0, _util2.warn)("Related file specifications are not supported");
                  }
                  this.contentAvailable = true;
                  if (!root2.has("EF")) {
                    this.contentAvailable = false;
                    (0, _util2.warn)("Non-embedded file specifications are not supported");
                  }
                }
                get filename() {
                  if (!this._filename && this.root) {
                    const filename = pickPlatformItem(this.root) || "unnamed";
                    this._filename = (0, _util2.stringToPDFString)(filename).replaceAll("\\\\", "\\").replaceAll("\\/", "/").replaceAll("\\", "/");
                  }
                  return this._filename;
                }
                get content() {
                  if (!this.contentAvailable) {
                    return null;
                  }
                  if (!this.contentRef && this.root) {
                    this.contentRef = pickPlatformItem(this.root.get("EF"));
                  }
                  let content = null;
                  if (this.contentRef) {
                    const fileObj = this.xref.fetchIfRef(this.contentRef);
                    if (fileObj instanceof _base_stream.BaseStream) {
                      content = fileObj.getBytes();
                    } else {
                      (0, _util2.warn)("Embedded file specification points to non-existing/invalid content");
                    }
                  } else {
                    (0, _util2.warn)("Embedded file specification does not have a content");
                  }
                  return content;
                }
                get serializable() {
                  return {
                    filename: this.filename,
                    content: this.content
                  };
                }
              }
              exports3.FileSpec = FileSpec;
            }),
            /* 70 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.MetadataParser = void 0;
              var _xml_parser = __w_pdfjs_require__3(71);
              class MetadataParser {
                constructor(data2) {
                  data2 = this._repair(data2);
                  const parser = new _xml_parser.SimpleXMLParser({
                    lowerCaseName: true
                  });
                  const xmlDocument = parser.parseFromString(data2);
                  this._metadataMap = /* @__PURE__ */ new Map();
                  this._data = data2;
                  if (xmlDocument) {
                    this._parse(xmlDocument);
                  }
                }
                _repair(data2) {
                  return data2.replace(/^[^<]+/, "").replaceAll(/>\\376\\377([^<]+)/g, function(all, codes) {
                    const bytes = codes.replaceAll(/\\([0-3])([0-7])([0-7])/g, function(code2, d1, d2, d3) {
                      return String.fromCharCode(d1 * 64 + d2 * 8 + d3 * 1);
                    }).replaceAll(/&(amp|apos|gt|lt|quot);/g, function(str, name) {
                      switch (name) {
                        case "amp":
                          return "&";
                        case "apos":
                          return "'";
                        case "gt":
                          return ">";
                        case "lt":
                          return "<";
                        case "quot":
                          return '"';
                      }
                      throw new Error(`_repair: ${name} isn't defined.`);
                    });
                    const charBuf = [">"];
                    for (let i = 0, ii = bytes.length; i < ii; i += 2) {
                      const code2 = bytes.charCodeAt(i) * 256 + bytes.charCodeAt(i + 1);
                      if (code2 >= 32 && code2 < 127 && code2 !== 60 && code2 !== 62 && code2 !== 38) {
                        charBuf.push(String.fromCharCode(code2));
                      } else {
                        charBuf.push("&#x" + (65536 + code2).toString(16).substring(1) + ";");
                      }
                    }
                    return charBuf.join("");
                  });
                }
                _getSequence(entry) {
                  const name = entry.nodeName;
                  if (name !== "rdf:bag" && name !== "rdf:seq" && name !== "rdf:alt") {
                    return null;
                  }
                  return entry.childNodes.filter((node2) => node2.nodeName === "rdf:li");
                }
                _parseArray(entry) {
                  if (!entry.hasChildNodes()) {
                    return;
                  }
                  const [seqNode] = entry.childNodes;
                  const sequence = this._getSequence(seqNode) || [];
                  this._metadataMap.set(entry.nodeName, sequence.map((node2) => node2.textContent.trim()));
                }
                _parse(xmlDocument) {
                  let rdf = xmlDocument.documentElement;
                  if (rdf.nodeName !== "rdf:rdf") {
                    rdf = rdf.firstChild;
                    while (rdf && rdf.nodeName !== "rdf:rdf") {
                      rdf = rdf.nextSibling;
                    }
                  }
                  if (!rdf || rdf.nodeName !== "rdf:rdf" || !rdf.hasChildNodes()) {
                    return;
                  }
                  for (const desc of rdf.childNodes) {
                    if (desc.nodeName !== "rdf:description") {
                      continue;
                    }
                    for (const entry of desc.childNodes) {
                      const name = entry.nodeName;
                      switch (name) {
                        case "#text":
                          continue;
                        case "dc:creator":
                        case "dc:subject":
                          this._parseArray(entry);
                          continue;
                      }
                      this._metadataMap.set(name, entry.textContent.trim());
                    }
                  }
                }
                get serializable() {
                  return {
                    parsedData: this._metadataMap,
                    rawData: this._data
                  };
                }
              }
              exports3.MetadataParser = MetadataParser;
            }),
            /* 71 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.XMLParserErrorCode = exports3.XMLParserBase = exports3.SimpleXMLParser = exports3.SimpleDOMNode = void 0;
              var _core_utils = __w_pdfjs_require__3(3);
              const XMLParserErrorCode = {
                NoError: 0,
                EndOfDocument: -1,
                UnterminatedCdat: -2,
                UnterminatedXmlDeclaration: -3,
                UnterminatedDoctypeDeclaration: -4,
                UnterminatedComment: -5,
                MalformedElement: -6,
                OutOfMemory: -7,
                UnterminatedAttributeValue: -8,
                UnterminatedElement: -9,
                ElementNeverBegun: -10
              };
              exports3.XMLParserErrorCode = XMLParserErrorCode;
              function isWhitespace(s, index3) {
                const ch = s[index3];
                return ch === " " || ch === "\n" || ch === "\r" || ch === "	";
              }
              function isWhitespaceString(s) {
                for (let i = 0, ii = s.length; i < ii; i++) {
                  if (!isWhitespace(s, i)) {
                    return false;
                  }
                }
                return true;
              }
              class XMLParserBase {
                _resolveEntities(s) {
                  return s.replaceAll(/&([^;]+);/g, (all, entity) => {
                    if (entity.substring(0, 2) === "#x") {
                      return String.fromCodePoint(parseInt(entity.substring(2), 16));
                    } else if (entity.substring(0, 1) === "#") {
                      return String.fromCodePoint(parseInt(entity.substring(1), 10));
                    }
                    switch (entity) {
                      case "lt":
                        return "<";
                      case "gt":
                        return ">";
                      case "amp":
                        return "&";
                      case "quot":
                        return '"';
                      case "apos":
                        return "'";
                    }
                    return this.onResolveEntity(entity);
                  });
                }
                _parseContent(s, start) {
                  const attributes2 = [];
                  let pos = start;
                  function skipWs() {
                    while (pos < s.length && isWhitespace(s, pos)) {
                      ++pos;
                    }
                  }
                  while (pos < s.length && !isWhitespace(s, pos) && s[pos] !== ">" && s[pos] !== "/") {
                    ++pos;
                  }
                  const name = s.substring(start, pos);
                  skipWs();
                  while (pos < s.length && s[pos] !== ">" && s[pos] !== "/" && s[pos] !== "?") {
                    skipWs();
                    let attrName = "", attrValue = "";
                    while (pos < s.length && !isWhitespace(s, pos) && s[pos] !== "=") {
                      attrName += s[pos];
                      ++pos;
                    }
                    skipWs();
                    if (s[pos] !== "=") {
                      return null;
                    }
                    ++pos;
                    skipWs();
                    const attrEndChar = s[pos];
                    if (attrEndChar !== '"' && attrEndChar !== "'") {
                      return null;
                    }
                    const attrEndIndex = s.indexOf(attrEndChar, ++pos);
                    if (attrEndIndex < 0) {
                      return null;
                    }
                    attrValue = s.substring(pos, attrEndIndex);
                    attributes2.push({
                      name: attrName,
                      value: this._resolveEntities(attrValue)
                    });
                    pos = attrEndIndex + 1;
                    skipWs();
                  }
                  return {
                    name,
                    attributes: attributes2,
                    parsed: pos - start
                  };
                }
                _parseProcessingInstruction(s, start) {
                  let pos = start;
                  function skipWs() {
                    while (pos < s.length && isWhitespace(s, pos)) {
                      ++pos;
                    }
                  }
                  while (pos < s.length && !isWhitespace(s, pos) && s[pos] !== ">" && s[pos] !== "?" && s[pos] !== "/") {
                    ++pos;
                  }
                  const name = s.substring(start, pos);
                  skipWs();
                  const attrStart = pos;
                  while (pos < s.length && (s[pos] !== "?" || s[pos + 1] !== ">")) {
                    ++pos;
                  }
                  const value = s.substring(attrStart, pos);
                  return {
                    name,
                    value,
                    parsed: pos - start
                  };
                }
                parseXml(s) {
                  let i = 0;
                  while (i < s.length) {
                    const ch = s[i];
                    let j = i;
                    if (ch === "<") {
                      ++j;
                      const ch2 = s[j];
                      let q;
                      switch (ch2) {
                        case "/":
                          ++j;
                          q = s.indexOf(">", j);
                          if (q < 0) {
                            this.onError(XMLParserErrorCode.UnterminatedElement);
                            return;
                          }
                          this.onEndElement(s.substring(j, q));
                          j = q + 1;
                          break;
                        case "?":
                          ++j;
                          const pi = this._parseProcessingInstruction(s, j);
                          if (s.substring(j + pi.parsed, j + pi.parsed + 2) !== "?>") {
                            this.onError(XMLParserErrorCode.UnterminatedXmlDeclaration);
                            return;
                          }
                          this.onPi(pi.name, pi.value);
                          j += pi.parsed + 2;
                          break;
                        case "!":
                          if (s.substring(j + 1, j + 3) === "--") {
                            q = s.indexOf("-->", j + 3);
                            if (q < 0) {
                              this.onError(XMLParserErrorCode.UnterminatedComment);
                              return;
                            }
                            this.onComment(s.substring(j + 3, q));
                            j = q + 3;
                          } else if (s.substring(j + 1, j + 8) === "[CDATA[") {
                            q = s.indexOf("]]>", j + 8);
                            if (q < 0) {
                              this.onError(XMLParserErrorCode.UnterminatedCdat);
                              return;
                            }
                            this.onCdata(s.substring(j + 8, q));
                            j = q + 3;
                          } else if (s.substring(j + 1, j + 8) === "DOCTYPE") {
                            const q2 = s.indexOf("[", j + 8);
                            let complexDoctype = false;
                            q = s.indexOf(">", j + 8);
                            if (q < 0) {
                              this.onError(XMLParserErrorCode.UnterminatedDoctypeDeclaration);
                              return;
                            }
                            if (q2 > 0 && q > q2) {
                              q = s.indexOf("]>", j + 8);
                              if (q < 0) {
                                this.onError(XMLParserErrorCode.UnterminatedDoctypeDeclaration);
                                return;
                              }
                              complexDoctype = true;
                            }
                            const doctypeContent = s.substring(j + 8, q + (complexDoctype ? 1 : 0));
                            this.onDoctype(doctypeContent);
                            j = q + (complexDoctype ? 2 : 1);
                          } else {
                            this.onError(XMLParserErrorCode.MalformedElement);
                            return;
                          }
                          break;
                        default:
                          const content = this._parseContent(s, j);
                          if (content === null) {
                            this.onError(XMLParserErrorCode.MalformedElement);
                            return;
                          }
                          let isClosed = false;
                          if (s.substring(j + content.parsed, j + content.parsed + 2) === "/>") {
                            isClosed = true;
                          } else if (s.substring(j + content.parsed, j + content.parsed + 1) !== ">") {
                            this.onError(XMLParserErrorCode.UnterminatedElement);
                            return;
                          }
                          this.onBeginElement(content.name, content.attributes, isClosed);
                          j += content.parsed + (isClosed ? 2 : 1);
                          break;
                      }
                    } else {
                      while (j < s.length && s[j] !== "<") {
                        j++;
                      }
                      const text = s.substring(i, j);
                      this.onText(this._resolveEntities(text));
                    }
                    i = j;
                  }
                }
                onResolveEntity(name) {
                  return `&${name};`;
                }
                onPi(name, value) {
                }
                onComment(text) {
                }
                onCdata(text) {
                }
                onDoctype(doctypeContent) {
                }
                onText(text) {
                }
                onBeginElement(name, attributes2, isEmpty2) {
                }
                onEndElement(name) {
                }
                onError(code2) {
                }
              }
              exports3.XMLParserBase = XMLParserBase;
              class SimpleDOMNode {
                constructor(nodeName, nodeValue) {
                  this.nodeName = nodeName;
                  this.nodeValue = nodeValue;
                  Object.defineProperty(this, "parentNode", {
                    value: null,
                    writable: true
                  });
                }
                get firstChild() {
                  return this.childNodes?.[0];
                }
                get nextSibling() {
                  const childNodes = this.parentNode.childNodes;
                  if (!childNodes) {
                    return void 0;
                  }
                  const index3 = childNodes.indexOf(this);
                  if (index3 === -1) {
                    return void 0;
                  }
                  return childNodes[index3 + 1];
                }
                get textContent() {
                  if (!this.childNodes) {
                    return this.nodeValue || "";
                  }
                  return this.childNodes.map(function(child) {
                    return child.textContent;
                  }).join("");
                }
                get children() {
                  return this.childNodes || [];
                }
                hasChildNodes() {
                  return this.childNodes?.length > 0;
                }
                searchNode(paths, pos) {
                  if (pos >= paths.length) {
                    return this;
                  }
                  const component = paths[pos];
                  if (component.name.startsWith("#") && pos < paths.length - 1) {
                    return this.searchNode(paths, pos + 1);
                  }
                  const stack = [];
                  let node2 = this;
                  while (true) {
                    if (component.name === node2.nodeName) {
                      if (component.pos === 0) {
                        const res = node2.searchNode(paths, pos + 1);
                        if (res !== null) {
                          return res;
                        }
                      } else if (stack.length === 0) {
                        return null;
                      } else {
                        const [parent2] = stack.pop();
                        let siblingPos = 0;
                        for (const child of parent2.childNodes) {
                          if (component.name === child.nodeName) {
                            if (siblingPos === component.pos) {
                              return child.searchNode(paths, pos + 1);
                            }
                            siblingPos++;
                          }
                        }
                        return node2.searchNode(paths, pos + 1);
                      }
                    }
                    if (node2.childNodes?.length > 0) {
                      stack.push([node2, 0]);
                      node2 = node2.childNodes[0];
                    } else if (stack.length === 0) {
                      return null;
                    } else {
                      while (stack.length !== 0) {
                        const [parent2, currentPos] = stack.pop();
                        const newPos = currentPos + 1;
                        if (newPos < parent2.childNodes.length) {
                          stack.push([parent2, newPos]);
                          node2 = parent2.childNodes[newPos];
                          break;
                        }
                      }
                      if (stack.length === 0) {
                        return null;
                      }
                    }
                  }
                }
                dump(buffer) {
                  if (this.nodeName === "#text") {
                    buffer.push((0, _core_utils.encodeToXmlString)(this.nodeValue));
                    return;
                  }
                  buffer.push(`<${this.nodeName}`);
                  if (this.attributes) {
                    for (const attribute of this.attributes) {
                      buffer.push(` ${attribute.name}="${(0, _core_utils.encodeToXmlString)(attribute.value)}"`);
                    }
                  }
                  if (this.hasChildNodes()) {
                    buffer.push(">");
                    for (const child of this.childNodes) {
                      child.dump(buffer);
                    }
                    buffer.push(`</${this.nodeName}>`);
                  } else if (this.nodeValue) {
                    buffer.push(`>${(0, _core_utils.encodeToXmlString)(this.nodeValue)}</${this.nodeName}>`);
                  } else {
                    buffer.push("/>");
                  }
                }
              }
              exports3.SimpleDOMNode = SimpleDOMNode;
              class SimpleXMLParser extends XMLParserBase {
                constructor({
                  hasAttributes = false,
                  lowerCaseName = false
                }) {
                  super();
                  this._currentFragment = null;
                  this._stack = null;
                  this._errorCode = XMLParserErrorCode.NoError;
                  this._hasAttributes = hasAttributes;
                  this._lowerCaseName = lowerCaseName;
                }
                parseFromString(data2) {
                  this._currentFragment = [];
                  this._stack = [];
                  this._errorCode = XMLParserErrorCode.NoError;
                  this.parseXml(data2);
                  if (this._errorCode !== XMLParserErrorCode.NoError) {
                    return void 0;
                  }
                  const [documentElement] = this._currentFragment;
                  if (!documentElement) {
                    return void 0;
                  }
                  return {
                    documentElement
                  };
                }
                onText(text) {
                  if (isWhitespaceString(text)) {
                    return;
                  }
                  const node2 = new SimpleDOMNode("#text", text);
                  this._currentFragment.push(node2);
                }
                onCdata(text) {
                  const node2 = new SimpleDOMNode("#text", text);
                  this._currentFragment.push(node2);
                }
                onBeginElement(name, attributes2, isEmpty2) {
                  if (this._lowerCaseName) {
                    name = name.toLowerCase();
                  }
                  const node2 = new SimpleDOMNode(name);
                  node2.childNodes = [];
                  if (this._hasAttributes) {
                    node2.attributes = attributes2;
                  }
                  this._currentFragment.push(node2);
                  if (isEmpty2) {
                    return;
                  }
                  this._stack.push(this._currentFragment);
                  this._currentFragment = node2.childNodes;
                }
                onEndElement(name) {
                  this._currentFragment = this._stack.pop() || [];
                  const lastElement = this._currentFragment.at(-1);
                  if (!lastElement) {
                    return null;
                  }
                  for (const childNode of lastElement.childNodes) {
                    childNode.parentNode = lastElement;
                  }
                  return lastElement;
                }
                onError(code2) {
                  this._errorCode = code2;
                }
              }
              exports3.SimpleXMLParser = SimpleXMLParser;
            }),
            /* 72 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.StructTreeRoot = exports3.StructTreePage = void 0;
              var _util2 = __w_pdfjs_require__3(2);
              var _primitives = __w_pdfjs_require__3(4);
              var _name_number_tree = __w_pdfjs_require__3(67);
              var _writer = __w_pdfjs_require__3(73);
              const MAX_DEPTH = 40;
              const StructElementType = {
                PAGE_CONTENT: 1,
                STREAM_CONTENT: 2,
                OBJECT: 3,
                ANNOTATION: 4,
                ELEMENT: 5
              };
              class StructTreeRoot {
                constructor(rootDict, rootRef) {
                  this.dict = rootDict;
                  this.ref = rootRef instanceof _primitives.Ref ? rootRef : null;
                  this.roleMap = /* @__PURE__ */ new Map();
                  this.structParentIds = null;
                }
                init() {
                  this.readRoleMap();
                }
                #addIdToPage(pageRef, id, type5) {
                  if (!(pageRef instanceof _primitives.Ref) || id < 0) {
                    return;
                  }
                  this.structParentIds ||= new _primitives.RefSetCache();
                  let ids2 = this.structParentIds.get(pageRef);
                  if (!ids2) {
                    ids2 = [];
                    this.structParentIds.put(pageRef, ids2);
                  }
                  ids2.push([id, type5]);
                }
                addAnnotationIdToPage(pageRef, id) {
                  this.#addIdToPage(pageRef, id, StructElementType.ANNOTATION);
                }
                readRoleMap() {
                  const roleMapDict = this.dict.get("RoleMap");
                  if (!(roleMapDict instanceof _primitives.Dict)) {
                    return;
                  }
                  roleMapDict.forEach((key2, value) => {
                    if (!(value instanceof _primitives.Name)) {
                      return;
                    }
                    this.roleMap.set(key2, value.name);
                  });
                }
                static async canCreateStructureTree({
                  catalogRef,
                  pdfManager,
                  newAnnotationsByPage
                }) {
                  if (!(catalogRef instanceof _primitives.Ref)) {
                    (0, _util2.warn)("Cannot save the struct tree: no catalog reference.");
                    return false;
                  }
                  let nextKey = 0;
                  let hasNothingToUpdate = true;
                  for (const [pageIndex, elements] of newAnnotationsByPage) {
                    const {
                      ref: pageRef
                    } = await pdfManager.getPage(pageIndex);
                    if (!(pageRef instanceof _primitives.Ref)) {
                      (0, _util2.warn)(`Cannot save the struct tree: page ${pageIndex} has no ref.`);
                      hasNothingToUpdate = true;
                      break;
                    }
                    for (const element of elements) {
                      if (element.accessibilityData?.type) {
                        element.parentTreeId = nextKey++;
                        hasNothingToUpdate = false;
                      }
                    }
                  }
                  if (hasNothingToUpdate) {
                    for (const elements of newAnnotationsByPage.values()) {
                      for (const element of elements) {
                        delete element.parentTreeId;
                      }
                    }
                    return false;
                  }
                  return true;
                }
                static async createStructureTree({
                  newAnnotationsByPage,
                  xref,
                  catalogRef,
                  pdfManager,
                  newRefs
                }) {
                  const root2 = pdfManager.catalog.cloneDict();
                  const structTreeRootRef = xref.getNewTemporaryRef();
                  root2.set("StructTreeRoot", structTreeRootRef);
                  const buffer = [];
                  await (0, _writer.writeObject)(catalogRef, root2, buffer, xref);
                  newRefs.push({
                    ref: catalogRef,
                    data: buffer.join("")
                  });
                  const structTreeRoot = new _primitives.Dict(xref);
                  structTreeRoot.set("Type", _primitives.Name.get("StructTreeRoot"));
                  const parentTreeRef = xref.getNewTemporaryRef();
                  structTreeRoot.set("ParentTree", parentTreeRef);
                  const kids = [];
                  structTreeRoot.set("K", kids);
                  const parentTree = new _primitives.Dict(xref);
                  const nums = [];
                  parentTree.set("Nums", nums);
                  const nextKey = await this.#writeKids({
                    newAnnotationsByPage,
                    structTreeRootRef,
                    kids,
                    nums,
                    xref,
                    pdfManager,
                    newRefs,
                    buffer
                  });
                  structTreeRoot.set("ParentTreeNextKey", nextKey);
                  buffer.length = 0;
                  await (0, _writer.writeObject)(parentTreeRef, parentTree, buffer, xref);
                  newRefs.push({
                    ref: parentTreeRef,
                    data: buffer.join("")
                  });
                  buffer.length = 0;
                  await (0, _writer.writeObject)(structTreeRootRef, structTreeRoot, buffer, xref);
                  newRefs.push({
                    ref: structTreeRootRef,
                    data: buffer.join("")
                  });
                }
                async canUpdateStructTree({
                  pdfManager,
                  newAnnotationsByPage
                }) {
                  if (!this.ref) {
                    (0, _util2.warn)("Cannot update the struct tree: no root reference.");
                    return false;
                  }
                  let nextKey = this.dict.get("ParentTreeNextKey");
                  if (!Number.isInteger(nextKey) || nextKey < 0) {
                    (0, _util2.warn)("Cannot update the struct tree: invalid next key.");
                    return false;
                  }
                  const parentTree = this.dict.get("ParentTree");
                  if (!(parentTree instanceof _primitives.Dict)) {
                    (0, _util2.warn)("Cannot update the struct tree: ParentTree isn't a dict.");
                    return false;
                  }
                  const nums = parentTree.get("Nums");
                  if (!Array.isArray(nums)) {
                    (0, _util2.warn)("Cannot update the struct tree: nums isn't an array.");
                    return false;
                  }
                  const {
                    numPages
                  } = pdfManager.catalog;
                  for (const pageIndex of newAnnotationsByPage.keys()) {
                    const {
                      pageDict,
                      ref: pageRef
                    } = await pdfManager.getPage(pageIndex);
                    if (!(pageRef instanceof _primitives.Ref)) {
                      (0, _util2.warn)(`Cannot save the struct tree: page ${pageIndex} has no ref.`);
                      return false;
                    }
                    const id = pageDict.get("StructParents");
                    if (!Number.isInteger(id) || id < 0 || id >= numPages) {
                      (0, _util2.warn)(`Cannot save the struct tree: page ${pageIndex} has no id.`);
                      return false;
                    }
                  }
                  let hasNothingToUpdate = true;
                  for (const [pageIndex, elements] of newAnnotationsByPage) {
                    const {
                      pageDict
                    } = await pdfManager.getPage(pageIndex);
                    StructTreeRoot.#collectParents({
                      elements,
                      xref: this.dict.xref,
                      pageDict,
                      parentTree
                    });
                    for (const element of elements) {
                      if (element.accessibilityData?.type) {
                        element.parentTreeId = nextKey++;
                        hasNothingToUpdate = false;
                      }
                    }
                  }
                  if (hasNothingToUpdate) {
                    for (const elements of newAnnotationsByPage.values()) {
                      for (const element of elements) {
                        delete element.parentTreeId;
                        delete element.structTreeParent;
                      }
                    }
                    return false;
                  }
                  return true;
                }
                async updateStructureTree({
                  newAnnotationsByPage,
                  pdfManager,
                  newRefs
                }) {
                  const xref = this.dict.xref;
                  const structTreeRoot = this.dict.clone();
                  const structTreeRootRef = this.ref;
                  let parentTreeRef = structTreeRoot.getRaw("ParentTree");
                  let parentTree;
                  if (parentTreeRef instanceof _primitives.Ref) {
                    parentTree = xref.fetch(parentTreeRef);
                  } else {
                    parentTree = parentTreeRef;
                    parentTreeRef = xref.getNewTemporaryRef();
                    structTreeRoot.set("ParentTree", parentTreeRef);
                  }
                  parentTree = parentTree.clone();
                  let nums = parentTree.getRaw("Nums");
                  let numsRef = null;
                  if (nums instanceof _primitives.Ref) {
                    numsRef = nums;
                    nums = xref.fetch(numsRef);
                  }
                  nums = nums.slice();
                  if (!numsRef) {
                    parentTree.set("Nums", nums);
                  }
                  let kids = structTreeRoot.getRaw("K");
                  let kidsRef = null;
                  if (kids instanceof _primitives.Ref) {
                    kidsRef = kids;
                    kids = xref.fetch(kidsRef);
                  } else {
                    kidsRef = xref.getNewTemporaryRef();
                    structTreeRoot.set("K", kidsRef);
                  }
                  kids = Array.isArray(kids) ? kids.slice() : [kids];
                  const buffer = [];
                  const newNextkey = await StructTreeRoot.#writeKids({
                    newAnnotationsByPage,
                    structTreeRootRef,
                    kids,
                    nums,
                    xref,
                    pdfManager,
                    newRefs,
                    buffer
                  });
                  structTreeRoot.set("ParentTreeNextKey", newNextkey);
                  buffer.length = 0;
                  await (0, _writer.writeObject)(kidsRef, kids, buffer, xref);
                  newRefs.push({
                    ref: kidsRef,
                    data: buffer.join("")
                  });
                  if (numsRef) {
                    buffer.length = 0;
                    await (0, _writer.writeObject)(numsRef, nums, buffer, xref);
                    newRefs.push({
                      ref: numsRef,
                      data: buffer.join("")
                    });
                  }
                  buffer.length = 0;
                  await (0, _writer.writeObject)(parentTreeRef, parentTree, buffer, xref);
                  newRefs.push({
                    ref: parentTreeRef,
                    data: buffer.join("")
                  });
                  buffer.length = 0;
                  await (0, _writer.writeObject)(structTreeRootRef, structTreeRoot, buffer, xref);
                  newRefs.push({
                    ref: structTreeRootRef,
                    data: buffer.join("")
                  });
                }
                static async #writeKids({
                  newAnnotationsByPage,
                  structTreeRootRef,
                  kids,
                  nums,
                  xref,
                  pdfManager,
                  newRefs,
                  buffer
                }) {
                  const objr = _primitives.Name.get("OBJR");
                  let nextKey = -Infinity;
                  for (const [pageIndex, elements] of newAnnotationsByPage) {
                    const {
                      ref: pageRef
                    } = await pdfManager.getPage(pageIndex);
                    for (const {
                      accessibilityData: {
                        type: type5,
                        title,
                        lang,
                        alt,
                        expanded,
                        actualText
                      },
                      ref: ref3,
                      parentTreeId,
                      structTreeParent
                    } of elements) {
                      nextKey = Math.max(nextKey, parentTreeId);
                      const tagRef = xref.getNewTemporaryRef();
                      const tagDict = new _primitives.Dict(xref);
                      tagDict.set("S", _primitives.Name.get(type5));
                      if (title) {
                        tagDict.set("T", title);
                      }
                      if (lang) {
                        tagDict.set("Lang", lang);
                      }
                      if (alt) {
                        tagDict.set("Alt", alt);
                      }
                      if (expanded) {
                        tagDict.set("E", expanded);
                      }
                      if (actualText) {
                        tagDict.set("ActualText", actualText);
                      }
                      if (structTreeParent) {
                        await this.#updateParentTag({
                          structTreeParent,
                          tagDict,
                          newTagRef: tagRef,
                          fallbackRef: structTreeRootRef,
                          xref,
                          newRefs,
                          buffer
                        });
                      } else {
                        tagDict.set("P", structTreeRootRef);
                      }
                      const objDict = new _primitives.Dict(xref);
                      tagDict.set("K", objDict);
                      objDict.set("Type", objr);
                      objDict.set("Pg", pageRef);
                      objDict.set("Obj", ref3);
                      buffer.length = 0;
                      await (0, _writer.writeObject)(tagRef, tagDict, buffer, xref);
                      newRefs.push({
                        ref: tagRef,
                        data: buffer.join("")
                      });
                      nums.push(parentTreeId, tagRef);
                      kids.push(tagRef);
                    }
                  }
                  return nextKey + 1;
                }
                static #collectParents({
                  elements,
                  xref,
                  pageDict,
                  parentTree
                }) {
                  const idToElement = /* @__PURE__ */ new Map();
                  for (const element of elements) {
                    if (element.structTreeParentId) {
                      const id2 = parseInt(element.structTreeParentId.split("_mc")[1], 10);
                      idToElement.set(id2, element);
                    }
                  }
                  const id = pageDict.get("StructParents");
                  const numberTree = new _name_number_tree.NumberTree(parentTree, xref);
                  const parentArray = numberTree.get(id);
                  if (!Array.isArray(parentArray)) {
                    return;
                  }
                  const updateElement = (kid, pageKid, kidRef) => {
                    const element = idToElement.get(kid);
                    if (element) {
                      const parentRef = pageKid.getRaw("P");
                      const parentDict = xref.fetchIfRef(parentRef);
                      if (parentRef instanceof _primitives.Ref && parentDict instanceof _primitives.Dict) {
                        element.structTreeParent = {
                          ref: kidRef,
                          dict: pageKid
                        };
                      }
                      return true;
                    }
                    return false;
                  };
                  for (const kidRef of parentArray) {
                    if (!(kidRef instanceof _primitives.Ref)) {
                      continue;
                    }
                    const pageKid = xref.fetch(kidRef);
                    const k = pageKid.get("K");
                    if (Number.isInteger(k)) {
                      updateElement(k, pageKid, kidRef);
                      continue;
                    }
                    if (!Array.isArray(k)) {
                      continue;
                    }
                    for (let kid of k) {
                      kid = xref.fetchIfRef(kid);
                      if (Number.isInteger(kid) && updateElement(kid, pageKid, kidRef)) {
                        break;
                      }
                    }
                  }
                }
                static async #updateParentTag({
                  structTreeParent: {
                    ref: ref3,
                    dict
                  },
                  tagDict,
                  newTagRef,
                  fallbackRef,
                  xref,
                  newRefs,
                  buffer
                }) {
                  const parentRef = dict.getRaw("P");
                  let parentDict = xref.fetchIfRef(parentRef);
                  tagDict.set("P", parentRef);
                  let saveParentDict = false;
                  let parentKids;
                  let parentKidsRef = parentDict.getRaw("K");
                  if (!(parentKidsRef instanceof _primitives.Ref)) {
                    parentKids = parentKidsRef;
                    parentKidsRef = xref.getNewTemporaryRef();
                    parentDict = parentDict.clone();
                    parentDict.set("K", parentKidsRef);
                    saveParentDict = true;
                  } else {
                    parentKids = xref.fetch(parentKidsRef);
                  }
                  if (Array.isArray(parentKids)) {
                    const index3 = parentKids.indexOf(ref3);
                    if (index3 >= 0) {
                      parentKids = parentKids.slice();
                      parentKids.splice(index3 + 1, 0, newTagRef);
                    } else {
                      (0, _util2.warn)("Cannot update the struct tree: parent kid not found.");
                      tagDict.set("P", fallbackRef);
                      return;
                    }
                  } else if (parentKids instanceof _primitives.Dict) {
                    parentKids = [parentKidsRef, newTagRef];
                    parentKidsRef = xref.getNewTemporaryRef();
                    parentDict.set("K", parentKidsRef);
                    saveParentDict = true;
                  }
                  buffer.length = 0;
                  await (0, _writer.writeObject)(parentKidsRef, parentKids, buffer, xref);
                  newRefs.push({
                    ref: parentKidsRef,
                    data: buffer.join("")
                  });
                  if (!saveParentDict) {
                    return;
                  }
                  buffer.length = 0;
                  await (0, _writer.writeObject)(parentRef, parentDict, buffer, xref);
                  newRefs.push({
                    ref: parentRef,
                    data: buffer.join("")
                  });
                }
              }
              exports3.StructTreeRoot = StructTreeRoot;
              class StructElementNode {
                constructor(tree, dict) {
                  this.tree = tree;
                  this.dict = dict;
                  this.kids = [];
                  this.parseKids();
                }
                get role() {
                  const nameObj = this.dict.get("S");
                  const name = nameObj instanceof _primitives.Name ? nameObj.name : "";
                  const {
                    root: root2
                  } = this.tree;
                  if (root2.roleMap.has(name)) {
                    return root2.roleMap.get(name);
                  }
                  return name;
                }
                parseKids() {
                  let pageObjId = null;
                  const objRef = this.dict.getRaw("Pg");
                  if (objRef instanceof _primitives.Ref) {
                    pageObjId = objRef.toString();
                  }
                  const kids = this.dict.get("K");
                  if (Array.isArray(kids)) {
                    for (const kid of kids) {
                      const element = this.parseKid(pageObjId, kid);
                      if (element) {
                        this.kids.push(element);
                      }
                    }
                  } else {
                    const element = this.parseKid(pageObjId, kids);
                    if (element) {
                      this.kids.push(element);
                    }
                  }
                }
                parseKid(pageObjId, kid) {
                  if (Number.isInteger(kid)) {
                    if (this.tree.pageDict.objId !== pageObjId) {
                      return null;
                    }
                    return new StructElement({
                      type: StructElementType.PAGE_CONTENT,
                      mcid: kid,
                      pageObjId
                    });
                  }
                  let kidDict = null;
                  if (kid instanceof _primitives.Ref) {
                    kidDict = this.dict.xref.fetch(kid);
                  } else if (kid instanceof _primitives.Dict) {
                    kidDict = kid;
                  }
                  if (!kidDict) {
                    return null;
                  }
                  const pageRef = kidDict.getRaw("Pg");
                  if (pageRef instanceof _primitives.Ref) {
                    pageObjId = pageRef.toString();
                  }
                  const type5 = kidDict.get("Type") instanceof _primitives.Name ? kidDict.get("Type").name : null;
                  if (type5 === "MCR") {
                    if (this.tree.pageDict.objId !== pageObjId) {
                      return null;
                    }
                    const kidRef = kidDict.getRaw("Stm");
                    return new StructElement({
                      type: StructElementType.STREAM_CONTENT,
                      refObjId: kidRef instanceof _primitives.Ref ? kidRef.toString() : null,
                      pageObjId,
                      mcid: kidDict.get("MCID")
                    });
                  }
                  if (type5 === "OBJR") {
                    if (this.tree.pageDict.objId !== pageObjId) {
                      return null;
                    }
                    const kidRef = kidDict.getRaw("Obj");
                    return new StructElement({
                      type: StructElementType.OBJECT,
                      refObjId: kidRef instanceof _primitives.Ref ? kidRef.toString() : null,
                      pageObjId
                    });
                  }
                  return new StructElement({
                    type: StructElementType.ELEMENT,
                    dict: kidDict
                  });
                }
              }
              class StructElement {
                constructor({
                  type: type5,
                  dict = null,
                  mcid = null,
                  pageObjId = null,
                  refObjId = null
                }) {
                  this.type = type5;
                  this.dict = dict;
                  this.mcid = mcid;
                  this.pageObjId = pageObjId;
                  this.refObjId = refObjId;
                  this.parentNode = null;
                }
              }
              class StructTreePage {
                constructor(structTreeRoot, pageDict) {
                  this.root = structTreeRoot;
                  this.rootDict = structTreeRoot ? structTreeRoot.dict : null;
                  this.pageDict = pageDict;
                  this.nodes = [];
                }
                parse(pageRef) {
                  if (!this.root || !this.rootDict) {
                    return;
                  }
                  const parentTree = this.rootDict.get("ParentTree");
                  if (!parentTree) {
                    return;
                  }
                  const id = this.pageDict.get("StructParents");
                  const ids2 = pageRef instanceof _primitives.Ref && this.root.structParentIds?.get(pageRef);
                  if (!Number.isInteger(id) && !ids2) {
                    return;
                  }
                  const map = /* @__PURE__ */ new Map();
                  const numberTree = new _name_number_tree.NumberTree(parentTree, this.rootDict.xref);
                  if (Number.isInteger(id)) {
                    const parentArray = numberTree.get(id);
                    if (Array.isArray(parentArray)) {
                      for (const ref3 of parentArray) {
                        if (ref3 instanceof _primitives.Ref) {
                          this.addNode(this.rootDict.xref.fetch(ref3), map);
                        }
                      }
                    }
                  }
                  if (!ids2) {
                    return;
                  }
                  for (const [elemId, type5] of ids2) {
                    const obj = numberTree.get(elemId);
                    if (obj) {
                      const elem = this.addNode(this.rootDict.xref.fetchIfRef(obj), map);
                      if (elem?.kids?.length === 1 && elem.kids[0].type === StructElementType.OBJECT) {
                        elem.kids[0].type = type5;
                      }
                    }
                  }
                }
                addNode(dict, map, level = 0) {
                  if (level > MAX_DEPTH) {
                    (0, _util2.warn)("StructTree MAX_DEPTH reached.");
                    return null;
                  }
                  if (map.has(dict)) {
                    return map.get(dict);
                  }
                  const element = new StructElementNode(this, dict);
                  map.set(dict, element);
                  const parent2 = dict.get("P");
                  if (!parent2 || (0, _primitives.isName)(parent2.get("Type"), "StructTreeRoot")) {
                    if (!this.addTopLevelNode(dict, element)) {
                      map.delete(dict);
                    }
                    return element;
                  }
                  const parentNode = this.addNode(parent2, map, level + 1);
                  if (!parentNode) {
                    return element;
                  }
                  let save = false;
                  for (const kid of parentNode.kids) {
                    if (kid.type === StructElementType.ELEMENT && kid.dict === dict) {
                      kid.parentNode = element;
                      save = true;
                    }
                  }
                  if (!save) {
                    map.delete(dict);
                  }
                  return element;
                }
                addTopLevelNode(dict, element) {
                  const obj = this.rootDict.get("K");
                  if (!obj) {
                    return false;
                  }
                  if (obj instanceof _primitives.Dict) {
                    if (obj.objId !== dict.objId) {
                      return false;
                    }
                    this.nodes[0] = element;
                    return true;
                  }
                  if (!Array.isArray(obj)) {
                    return true;
                  }
                  let save = false;
                  for (let i = 0; i < obj.length; i++) {
                    const kidRef = obj[i];
                    if (kidRef?.toString() === dict.objId) {
                      this.nodes[i] = element;
                      save = true;
                    }
                  }
                  return save;
                }
                get serializable() {
                  function nodeToSerializable(node2, parent2, level = 0) {
                    if (level > MAX_DEPTH) {
                      (0, _util2.warn)("StructTree too deep to be fully serialized.");
                      return;
                    }
                    const obj = /* @__PURE__ */ Object.create(null);
                    obj.role = node2.role;
                    obj.children = [];
                    parent2.children.push(obj);
                    const alt = node2.dict.get("Alt");
                    if (typeof alt === "string") {
                      obj.alt = (0, _util2.stringToPDFString)(alt);
                    }
                    const lang = node2.dict.get("Lang");
                    if (typeof lang === "string") {
                      obj.lang = (0, _util2.stringToPDFString)(lang);
                    }
                    for (const kid of node2.kids) {
                      const kidElement = kid.type === StructElementType.ELEMENT ? kid.parentNode : null;
                      if (kidElement) {
                        nodeToSerializable(kidElement, obj, level + 1);
                        continue;
                      } else if (kid.type === StructElementType.PAGE_CONTENT || kid.type === StructElementType.STREAM_CONTENT) {
                        obj.children.push({
                          type: "content",
                          id: `p${kid.pageObjId}_mc${kid.mcid}`
                        });
                      } else if (kid.type === StructElementType.OBJECT) {
                        obj.children.push({
                          type: "object",
                          id: kid.refObjId
                        });
                      } else if (kid.type === StructElementType.ANNOTATION) {
                        obj.children.push({
                          type: "annotation",
                          id: `${_util2.AnnotationPrefix}${kid.refObjId}`
                        });
                      }
                    }
                  }
                  const root2 = /* @__PURE__ */ Object.create(null);
                  root2.children = [];
                  root2.role = "Root";
                  for (const child of this.nodes) {
                    if (!child) {
                      continue;
                    }
                    nodeToSerializable(child, root2);
                  }
                  return root2;
                }
              }
              exports3.StructTreePage = StructTreePage;
            }),
            /* 73 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.incrementalUpdate = incrementalUpdate;
              exports3.writeDict = writeDict;
              exports3.writeObject = writeObject;
              var _util2 = __w_pdfjs_require__3(2);
              var _primitives = __w_pdfjs_require__3(4);
              var _core_utils = __w_pdfjs_require__3(3);
              var _xml_parser = __w_pdfjs_require__3(71);
              var _base_stream = __w_pdfjs_require__3(5);
              var _crypto = __w_pdfjs_require__3(74);
              async function writeObject(ref3, obj, buffer, {
                encrypt = null
              }) {
                const transform = encrypt?.createCipherTransform(ref3.num, ref3.gen);
                buffer.push(`${ref3.num} ${ref3.gen} obj
`);
                if (obj instanceof _primitives.Dict) {
                  await writeDict(obj, buffer, transform);
                } else if (obj instanceof _base_stream.BaseStream) {
                  await writeStream(obj, buffer, transform);
                } else if (Array.isArray(obj)) {
                  await writeArray(obj, buffer, transform);
                }
                buffer.push("\nendobj\n");
              }
              async function writeDict(dict, buffer, transform) {
                buffer.push("<<");
                for (const key2 of dict.getKeys()) {
                  buffer.push(` /${(0, _core_utils.escapePDFName)(key2)} `);
                  await writeValue(dict.getRaw(key2), buffer, transform);
                }
                buffer.push(">>");
              }
              async function writeStream(stream, buffer, transform) {
                let string3 = stream.getString();
                const {
                  dict
                } = stream;
                const [filter3, params] = await Promise.all([dict.getAsync("Filter"), dict.getAsync("DecodeParms")]);
                const filterZero = Array.isArray(filter3) ? await dict.xref.fetchIfRefAsync(filter3[0]) : filter3;
                const isFilterZeroFlateDecode = (0, _primitives.isName)(filterZero, "FlateDecode");
                const MIN_LENGTH_FOR_COMPRESSING = 256;
                if (typeof CompressionStream !== "undefined" && (string3.length >= MIN_LENGTH_FOR_COMPRESSING || isFilterZeroFlateDecode)) {
                  try {
                    const byteArray = (0, _util2.stringToBytes)(string3);
                    const cs = new CompressionStream("deflate");
                    const writer = cs.writable.getWriter();
                    writer.write(byteArray);
                    writer.close();
                    const buf = await new Response(cs.readable).arrayBuffer();
                    string3 = (0, _util2.bytesToString)(new Uint8Array(buf));
                    let newFilter, newParams;
                    if (!filter3) {
                      newFilter = _primitives.Name.get("FlateDecode");
                    } else if (!isFilterZeroFlateDecode) {
                      newFilter = Array.isArray(filter3) ? [_primitives.Name.get("FlateDecode"), ...filter3] : [_primitives.Name.get("FlateDecode"), filter3];
                      if (params) {
                        newParams = Array.isArray(params) ? [null, ...params] : [null, params];
                      }
                    }
                    if (newFilter) {
                      dict.set("Filter", newFilter);
                    }
                    if (newParams) {
                      dict.set("DecodeParms", newParams);
                    }
                  } catch (ex) {
                    (0, _util2.info)(`writeStream - cannot compress data: "${ex}".`);
                  }
                }
                if (transform) {
                  string3 = transform.encryptString(string3);
                }
                dict.set("Length", string3.length);
                await writeDict(dict, buffer, transform);
                buffer.push(" stream\n", string3, "\nendstream");
              }
              async function writeArray(array4, buffer, transform) {
                buffer.push("[");
                let first = true;
                for (const val of array4) {
                  if (!first) {
                    buffer.push(" ");
                  } else {
                    first = false;
                  }
                  await writeValue(val, buffer, transform);
                }
                buffer.push("]");
              }
              async function writeValue(value, buffer, transform) {
                if (value instanceof _primitives.Name) {
                  buffer.push(`/${(0, _core_utils.escapePDFName)(value.name)}`);
                } else if (value instanceof _primitives.Ref) {
                  buffer.push(`${value.num} ${value.gen} R`);
                } else if (Array.isArray(value)) {
                  await writeArray(value, buffer, transform);
                } else if (typeof value === "string") {
                  if (transform) {
                    value = transform.encryptString(value);
                  }
                  buffer.push(`(${(0, _core_utils.escapeString)(value)})`);
                } else if (typeof value === "number") {
                  buffer.push((0, _core_utils.numberToString)(value));
                } else if (typeof value === "boolean") {
                  buffer.push(value.toString());
                } else if (value instanceof _primitives.Dict) {
                  await writeDict(value, buffer, transform);
                } else if (value instanceof _base_stream.BaseStream) {
                  await writeStream(value, buffer, transform);
                } else if (value === null) {
                  buffer.push("null");
                } else {
                  (0, _util2.warn)(`Unhandled value in writer: ${typeof value}, please file a bug.`);
                }
              }
              function writeInt(number4, size, offset4, buffer) {
                for (let i = size + offset4 - 1; i > offset4 - 1; i--) {
                  buffer[i] = number4 & 255;
                  number4 >>= 8;
                }
                return offset4 + size;
              }
              function writeString(string3, offset4, buffer) {
                for (let i = 0, len = string3.length; i < len; i++) {
                  buffer[offset4 + i] = string3.charCodeAt(i) & 255;
                }
              }
              function computeMD5(filesize, xrefInfo) {
                const time = Math.floor(Date.now() / 1e3);
                const filename = xrefInfo.filename || "";
                const md5Buffer = [time.toString(), filename, filesize.toString()];
                let md5BufferLen = md5Buffer.reduce((a, str) => a + str.length, 0);
                for (const value of Object.values(xrefInfo.info)) {
                  md5Buffer.push(value);
                  md5BufferLen += value.length;
                }
                const array4 = new Uint8Array(md5BufferLen);
                let offset4 = 0;
                for (const str of md5Buffer) {
                  writeString(str, offset4, array4);
                  offset4 += str.length;
                }
                return (0, _util2.bytesToString)((0, _crypto.calculateMD5)(array4));
              }
              function writeXFADataForAcroform(str, newRefs) {
                const xml = new _xml_parser.SimpleXMLParser({
                  hasAttributes: true
                }).parseFromString(str);
                for (const {
                  xfa
                } of newRefs) {
                  if (!xfa) {
                    continue;
                  }
                  const {
                    path: path2,
                    value
                  } = xfa;
                  if (!path2) {
                    continue;
                  }
                  const nodePath = (0, _core_utils.parseXFAPath)(path2);
                  let node2 = xml.documentElement.searchNode(nodePath, 0);
                  if (!node2 && nodePath.length > 1) {
                    node2 = xml.documentElement.searchNode([nodePath.at(-1)], 0);
                  }
                  if (node2) {
                    node2.childNodes = Array.isArray(value) ? value.map((val) => new _xml_parser.SimpleDOMNode("value", val)) : [new _xml_parser.SimpleDOMNode("#text", value)];
                  } else {
                    (0, _util2.warn)(`Node not found for path: ${path2}`);
                  }
                }
                const buffer = [];
                xml.documentElement.dump(buffer);
                return buffer.join("");
              }
              async function updateAcroform({
                xref,
                acroForm,
                acroFormRef,
                hasXfa,
                hasXfaDatasetsEntry,
                xfaDatasetsRef,
                needAppearances,
                newRefs
              }) {
                if (hasXfa && !hasXfaDatasetsEntry && !xfaDatasetsRef) {
                  (0, _util2.warn)("XFA - Cannot save it");
                }
                if (!needAppearances && (!hasXfa || !xfaDatasetsRef || hasXfaDatasetsEntry)) {
                  return;
                }
                const dict = acroForm.clone();
                if (hasXfa && !hasXfaDatasetsEntry) {
                  const newXfa = acroForm.get("XFA").slice();
                  newXfa.splice(2, 0, "datasets");
                  newXfa.splice(3, 0, xfaDatasetsRef);
                  dict.set("XFA", newXfa);
                }
                if (needAppearances) {
                  dict.set("NeedAppearances", true);
                }
                const buffer = [];
                await writeObject(acroFormRef, dict, buffer, xref);
                newRefs.push({
                  ref: acroFormRef,
                  data: buffer.join("")
                });
              }
              function updateXFA({
                xfaData,
                xfaDatasetsRef,
                newRefs,
                xref
              }) {
                if (xfaData === null) {
                  const datasets = xref.fetchIfRef(xfaDatasetsRef);
                  xfaData = writeXFADataForAcroform(datasets.getString(), newRefs);
                }
                const encrypt = xref.encrypt;
                if (encrypt) {
                  const transform = encrypt.createCipherTransform(xfaDatasetsRef.num, xfaDatasetsRef.gen);
                  xfaData = transform.encryptString(xfaData);
                }
                const data2 = `${xfaDatasetsRef.num} ${xfaDatasetsRef.gen} obj
<< /Type /EmbeddedFile /Length ${xfaData.length}>>
stream
` + xfaData + "\nendstream\nendobj\n";
                newRefs.push({
                  ref: xfaDatasetsRef,
                  data: data2
                });
              }
              async function incrementalUpdate({
                originalData,
                xrefInfo,
                newRefs,
                xref = null,
                hasXfa = false,
                xfaDatasetsRef = null,
                hasXfaDatasetsEntry = false,
                needAppearances,
                acroFormRef = null,
                acroForm = null,
                xfaData = null
              }) {
                await updateAcroform({
                  xref,
                  acroForm,
                  acroFormRef,
                  hasXfa,
                  hasXfaDatasetsEntry,
                  xfaDatasetsRef,
                  needAppearances,
                  newRefs
                });
                if (hasXfa) {
                  updateXFA({
                    xfaData,
                    xfaDatasetsRef,
                    newRefs,
                    xref
                  });
                }
                const newXref = new _primitives.Dict(null);
                const refForXrefTable = xrefInfo.newRef;
                let buffer, baseOffset;
                const lastByte = originalData.at(-1);
                if (lastByte === 10 || lastByte === 13) {
                  buffer = [];
                  baseOffset = originalData.length;
                } else {
                  buffer = ["\n"];
                  baseOffset = originalData.length + 1;
                }
                newXref.set("Size", refForXrefTable.num + 1);
                newXref.set("Prev", xrefInfo.startXRef);
                newXref.set("Type", _primitives.Name.get("XRef"));
                if (xrefInfo.rootRef !== null) {
                  newXref.set("Root", xrefInfo.rootRef);
                }
                if (xrefInfo.infoRef !== null) {
                  newXref.set("Info", xrefInfo.infoRef);
                }
                if (xrefInfo.encryptRef !== null) {
                  newXref.set("Encrypt", xrefInfo.encryptRef);
                }
                newRefs.push({
                  ref: refForXrefTable,
                  data: ""
                });
                newRefs = newRefs.sort((a, b) => {
                  return a.ref.num - b.ref.num;
                });
                const xrefTableData = [[0, 1, 65535]];
                const indexes = [0, 1];
                let maxOffset2 = 0;
                for (const {
                  ref: ref3,
                  data: data2
                } of newRefs) {
                  maxOffset2 = Math.max(maxOffset2, baseOffset);
                  xrefTableData.push([1, baseOffset, Math.min(ref3.gen, 65535)]);
                  baseOffset += data2.length;
                  indexes.push(ref3.num, 1);
                  buffer.push(data2);
                }
                newXref.set("Index", indexes);
                if (Array.isArray(xrefInfo.fileIds) && xrefInfo.fileIds.length > 0) {
                  const md5 = computeMD5(baseOffset, xrefInfo);
                  newXref.set("ID", [xrefInfo.fileIds[0], md5]);
                }
                const offsetSize = Math.ceil(Math.log2(maxOffset2) / 8);
                const sizes2 = [1, offsetSize, 2];
                const structSize = sizes2[0] + sizes2[1] + sizes2[2];
                const tableLength = structSize * xrefTableData.length;
                newXref.set("W", sizes2);
                newXref.set("Length", tableLength);
                buffer.push(`${refForXrefTable.num} ${refForXrefTable.gen} obj
`);
                await writeDict(newXref, buffer, null);
                buffer.push(" stream\n");
                const bufferLen = buffer.reduce((a, str) => a + str.length, 0);
                const footer = `
endstream
endobj
startxref
${baseOffset}
%%EOF
`;
                const array4 = new Uint8Array(originalData.length + bufferLen + tableLength + footer.length);
                array4.set(originalData);
                let offset4 = originalData.length;
                for (const str of buffer) {
                  writeString(str, offset4, array4);
                  offset4 += str.length;
                }
                for (const [type5, objOffset, gen] of xrefTableData) {
                  offset4 = writeInt(type5, sizes2[0], offset4, array4);
                  offset4 = writeInt(objOffset, sizes2[1], offset4, array4);
                  offset4 = writeInt(gen, sizes2[2], offset4, array4);
                }
                writeString(footer, offset4, array4);
                return array4;
              }
            }),
            /* 74 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.calculateSHA256 = exports3.calculateMD5 = exports3.PDF20 = exports3.PDF17 = exports3.CipherTransformFactory = exports3.ARCFourCipher = exports3.AES256Cipher = exports3.AES128Cipher = void 0;
              exports3.calculateSHA384 = calculateSHA384;
              exports3.calculateSHA512 = void 0;
              var _util2 = __w_pdfjs_require__3(2);
              var _primitives = __w_pdfjs_require__3(4);
              var _decrypt_stream = __w_pdfjs_require__3(75);
              class ARCFourCipher {
                constructor(key2) {
                  this.a = 0;
                  this.b = 0;
                  const s = new Uint8Array(256);
                  const keyLength = key2.length;
                  for (let i = 0; i < 256; ++i) {
                    s[i] = i;
                  }
                  for (let i = 0, j = 0; i < 256; ++i) {
                    const tmp = s[i];
                    j = j + tmp + key2[i % keyLength] & 255;
                    s[i] = s[j];
                    s[j] = tmp;
                  }
                  this.s = s;
                }
                encryptBlock(data2) {
                  let a = this.a, b = this.b;
                  const s = this.s;
                  const n2 = data2.length;
                  const output = new Uint8Array(n2);
                  for (let i = 0; i < n2; ++i) {
                    a = a + 1 & 255;
                    const tmp = s[a];
                    b = b + tmp & 255;
                    const tmp2 = s[b];
                    s[a] = tmp2;
                    s[b] = tmp;
                    output[i] = data2[i] ^ s[tmp + tmp2 & 255];
                  }
                  this.a = a;
                  this.b = b;
                  return output;
                }
                decryptBlock(data2) {
                  return this.encryptBlock(data2);
                }
                encrypt(data2) {
                  return this.encryptBlock(data2);
                }
              }
              exports3.ARCFourCipher = ARCFourCipher;
              const calculateMD5 = (function calculateMD5Closure() {
                const r2 = new Uint8Array([7, 12, 17, 22, 7, 12, 17, 22, 7, 12, 17, 22, 7, 12, 17, 22, 5, 9, 14, 20, 5, 9, 14, 20, 5, 9, 14, 20, 5, 9, 14, 20, 4, 11, 16, 23, 4, 11, 16, 23, 4, 11, 16, 23, 4, 11, 16, 23, 6, 10, 15, 21, 6, 10, 15, 21, 6, 10, 15, 21, 6, 10, 15, 21]);
                const k = new Int32Array([-680876936, -389564586, 606105819, -1044525330, -176418897, 1200080426, -1473231341, -45705983, 1770035416, -1958414417, -42063, -1990404162, 1804603682, -40341101, -1502002290, 1236535329, -165796510, -1069501632, 643717713, -373897302, -701558691, 38016083, -660478335, -405537848, 568446438, -1019803690, -187363961, 1163531501, -1444681467, -51403784, 1735328473, -1926607734, -378558, -2022574463, 1839030562, -35309556, -1530992060, 1272893353, -155497632, -1094730640, 681279174, -358537222, -722521979, 76029189, -640364487, -421815835, 530742520, -995338651, -198630844, 1126891415, -1416354905, -57434055, 1700485571, -1894986606, -1051523, -2054922799, 1873313359, -30611744, -1560198380, 1309151649, -145523070, -1120210379, 718787259, -343485551]);
                function hash2(data2, offset4, length2) {
                  let h0 = 1732584193, h1 = -271733879, h2 = -1732584194, h3 = 271733878;
                  const paddedLength = length2 + 72 & ~63;
                  const padded = new Uint8Array(paddedLength);
                  let i, j;
                  for (i = 0; i < length2; ++i) {
                    padded[i] = data2[offset4++];
                  }
                  padded[i++] = 128;
                  const n2 = paddedLength - 8;
                  while (i < n2) {
                    padded[i++] = 0;
                  }
                  padded[i++] = length2 << 3 & 255;
                  padded[i++] = length2 >> 5 & 255;
                  padded[i++] = length2 >> 13 & 255;
                  padded[i++] = length2 >> 21 & 255;
                  padded[i++] = length2 >>> 29 & 255;
                  padded[i++] = 0;
                  padded[i++] = 0;
                  padded[i++] = 0;
                  const w = new Int32Array(16);
                  for (i = 0; i < paddedLength; ) {
                    for (j = 0; j < 16; ++j, i += 4) {
                      w[j] = padded[i] | padded[i + 1] << 8 | padded[i + 2] << 16 | padded[i + 3] << 24;
                    }
                    let a = h0, b = h1, c = h2, d = h3, f, g;
                    for (j = 0; j < 64; ++j) {
                      if (j < 16) {
                        f = b & c | ~b & d;
                        g = j;
                      } else if (j < 32) {
                        f = d & b | ~d & c;
                        g = 5 * j + 1 & 15;
                      } else if (j < 48) {
                        f = b ^ c ^ d;
                        g = 3 * j + 5 & 15;
                      } else {
                        f = c ^ (b | ~d);
                        g = 7 * j & 15;
                      }
                      const tmp = d, rotateArg = a + f + k[j] + w[g] | 0, rotate2 = r2[j];
                      d = c;
                      c = b;
                      b = b + (rotateArg << rotate2 | rotateArg >>> 32 - rotate2) | 0;
                      a = tmp;
                    }
                    h0 = h0 + a | 0;
                    h1 = h1 + b | 0;
                    h2 = h2 + c | 0;
                    h3 = h3 + d | 0;
                  }
                  return new Uint8Array([h0 & 255, h0 >> 8 & 255, h0 >> 16 & 255, h0 >>> 24 & 255, h1 & 255, h1 >> 8 & 255, h1 >> 16 & 255, h1 >>> 24 & 255, h2 & 255, h2 >> 8 & 255, h2 >> 16 & 255, h2 >>> 24 & 255, h3 & 255, h3 >> 8 & 255, h3 >> 16 & 255, h3 >>> 24 & 255]);
                }
                return hash2;
              })();
              exports3.calculateMD5 = calculateMD5;
              class Word64 {
                constructor(highInteger, lowInteger) {
                  this.high = highInteger | 0;
                  this.low = lowInteger | 0;
                }
                and(word) {
                  this.high &= word.high;
                  this.low &= word.low;
                }
                xor(word) {
                  this.high ^= word.high;
                  this.low ^= word.low;
                }
                or(word) {
                  this.high |= word.high;
                  this.low |= word.low;
                }
                shiftRight(places) {
                  if (places >= 32) {
                    this.low = this.high >>> places - 32 | 0;
                    this.high = 0;
                  } else {
                    this.low = this.low >>> places | this.high << 32 - places;
                    this.high = this.high >>> places | 0;
                  }
                }
                shiftLeft(places) {
                  if (places >= 32) {
                    this.high = this.low << places - 32;
                    this.low = 0;
                  } else {
                    this.high = this.high << places | this.low >>> 32 - places;
                    this.low <<= places;
                  }
                }
                rotateRight(places) {
                  let low, high;
                  if (places & 32) {
                    high = this.low;
                    low = this.high;
                  } else {
                    low = this.low;
                    high = this.high;
                  }
                  places &= 31;
                  this.low = low >>> places | high << 32 - places;
                  this.high = high >>> places | low << 32 - places;
                }
                not() {
                  this.high = ~this.high;
                  this.low = ~this.low;
                }
                add(word) {
                  const lowAdd = (this.low >>> 0) + (word.low >>> 0);
                  let highAdd = (this.high >>> 0) + (word.high >>> 0);
                  if (lowAdd > 4294967295) {
                    highAdd += 1;
                  }
                  this.low = lowAdd | 0;
                  this.high = highAdd | 0;
                }
                copyTo(bytes, offset4) {
                  bytes[offset4] = this.high >>> 24 & 255;
                  bytes[offset4 + 1] = this.high >> 16 & 255;
                  bytes[offset4 + 2] = this.high >> 8 & 255;
                  bytes[offset4 + 3] = this.high & 255;
                  bytes[offset4 + 4] = this.low >>> 24 & 255;
                  bytes[offset4 + 5] = this.low >> 16 & 255;
                  bytes[offset4 + 6] = this.low >> 8 & 255;
                  bytes[offset4 + 7] = this.low & 255;
                }
                assign(word) {
                  this.high = word.high;
                  this.low = word.low;
                }
              }
              const calculateSHA256 = /* @__PURE__ */ (function calculateSHA256Closure() {
                function rotr(x, n2) {
                  return x >>> n2 | x << 32 - n2;
                }
                function ch(x, y, z) {
                  return x & y ^ ~x & z;
                }
                function maj(x, y, z) {
                  return x & y ^ x & z ^ y & z;
                }
                function sigma(x) {
                  return rotr(x, 2) ^ rotr(x, 13) ^ rotr(x, 22);
                }
                function sigmaPrime(x) {
                  return rotr(x, 6) ^ rotr(x, 11) ^ rotr(x, 25);
                }
                function littleSigma(x) {
                  return rotr(x, 7) ^ rotr(x, 18) ^ x >>> 3;
                }
                function littleSigmaPrime(x) {
                  return rotr(x, 17) ^ rotr(x, 19) ^ x >>> 10;
                }
                const k = [1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298];
                function hash2(data2, offset4, length2) {
                  let h0 = 1779033703, h1 = 3144134277, h2 = 1013904242, h3 = 2773480762, h4 = 1359893119, h5 = 2600822924, h6 = 528734635, h7 = 1541459225;
                  const paddedLength = Math.ceil((length2 + 9) / 64) * 64;
                  const padded = new Uint8Array(paddedLength);
                  let i, j;
                  for (i = 0; i < length2; ++i) {
                    padded[i] = data2[offset4++];
                  }
                  padded[i++] = 128;
                  const n2 = paddedLength - 8;
                  while (i < n2) {
                    padded[i++] = 0;
                  }
                  padded[i++] = 0;
                  padded[i++] = 0;
                  padded[i++] = 0;
                  padded[i++] = length2 >>> 29 & 255;
                  padded[i++] = length2 >> 21 & 255;
                  padded[i++] = length2 >> 13 & 255;
                  padded[i++] = length2 >> 5 & 255;
                  padded[i++] = length2 << 3 & 255;
                  const w = new Uint32Array(64);
                  for (i = 0; i < paddedLength; ) {
                    for (j = 0; j < 16; ++j) {
                      w[j] = padded[i] << 24 | padded[i + 1] << 16 | padded[i + 2] << 8 | padded[i + 3];
                      i += 4;
                    }
                    for (j = 16; j < 64; ++j) {
                      w[j] = littleSigmaPrime(w[j - 2]) + w[j - 7] + littleSigma(w[j - 15]) + w[j - 16] | 0;
                    }
                    let a = h0, b = h1, c = h2, d = h3, e3 = h4, f = h5, g = h6, h8 = h7, t1, t2;
                    for (j = 0; j < 64; ++j) {
                      t1 = h8 + sigmaPrime(e3) + ch(e3, f, g) + k[j] + w[j];
                      t2 = sigma(a) + maj(a, b, c);
                      h8 = g;
                      g = f;
                      f = e3;
                      e3 = d + t1 | 0;
                      d = c;
                      c = b;
                      b = a;
                      a = t1 + t2 | 0;
                    }
                    h0 = h0 + a | 0;
                    h1 = h1 + b | 0;
                    h2 = h2 + c | 0;
                    h3 = h3 + d | 0;
                    h4 = h4 + e3 | 0;
                    h5 = h5 + f | 0;
                    h6 = h6 + g | 0;
                    h7 = h7 + h8 | 0;
                  }
                  return new Uint8Array([h0 >> 24 & 255, h0 >> 16 & 255, h0 >> 8 & 255, h0 & 255, h1 >> 24 & 255, h1 >> 16 & 255, h1 >> 8 & 255, h1 & 255, h2 >> 24 & 255, h2 >> 16 & 255, h2 >> 8 & 255, h2 & 255, h3 >> 24 & 255, h3 >> 16 & 255, h3 >> 8 & 255, h3 & 255, h4 >> 24 & 255, h4 >> 16 & 255, h4 >> 8 & 255, h4 & 255, h5 >> 24 & 255, h5 >> 16 & 255, h5 >> 8 & 255, h5 & 255, h6 >> 24 & 255, h6 >> 16 & 255, h6 >> 8 & 255, h6 & 255, h7 >> 24 & 255, h7 >> 16 & 255, h7 >> 8 & 255, h7 & 255]);
                }
                return hash2;
              })();
              exports3.calculateSHA256 = calculateSHA256;
              const calculateSHA512 = (function calculateSHA512Closure() {
                function ch(result, x, y, z, tmp) {
                  result.assign(x);
                  result.and(y);
                  tmp.assign(x);
                  tmp.not();
                  tmp.and(z);
                  result.xor(tmp);
                }
                function maj(result, x, y, z, tmp) {
                  result.assign(x);
                  result.and(y);
                  tmp.assign(x);
                  tmp.and(z);
                  result.xor(tmp);
                  tmp.assign(y);
                  tmp.and(z);
                  result.xor(tmp);
                }
                function sigma(result, x, tmp) {
                  result.assign(x);
                  result.rotateRight(28);
                  tmp.assign(x);
                  tmp.rotateRight(34);
                  result.xor(tmp);
                  tmp.assign(x);
                  tmp.rotateRight(39);
                  result.xor(tmp);
                }
                function sigmaPrime(result, x, tmp) {
                  result.assign(x);
                  result.rotateRight(14);
                  tmp.assign(x);
                  tmp.rotateRight(18);
                  result.xor(tmp);
                  tmp.assign(x);
                  tmp.rotateRight(41);
                  result.xor(tmp);
                }
                function littleSigma(result, x, tmp) {
                  result.assign(x);
                  result.rotateRight(1);
                  tmp.assign(x);
                  tmp.rotateRight(8);
                  result.xor(tmp);
                  tmp.assign(x);
                  tmp.shiftRight(7);
                  result.xor(tmp);
                }
                function littleSigmaPrime(result, x, tmp) {
                  result.assign(x);
                  result.rotateRight(19);
                  tmp.assign(x);
                  tmp.rotateRight(61);
                  result.xor(tmp);
                  tmp.assign(x);
                  tmp.shiftRight(6);
                  result.xor(tmp);
                }
                const k = [new Word64(1116352408, 3609767458), new Word64(1899447441, 602891725), new Word64(3049323471, 3964484399), new Word64(3921009573, 2173295548), new Word64(961987163, 4081628472), new Word64(1508970993, 3053834265), new Word64(2453635748, 2937671579), new Word64(2870763221, 3664609560), new Word64(3624381080, 2734883394), new Word64(310598401, 1164996542), new Word64(607225278, 1323610764), new Word64(1426881987, 3590304994), new Word64(1925078388, 4068182383), new Word64(2162078206, 991336113), new Word64(2614888103, 633803317), new Word64(3248222580, 3479774868), new Word64(3835390401, 2666613458), new Word64(4022224774, 944711139), new Word64(264347078, 2341262773), new Word64(604807628, 2007800933), new Word64(770255983, 1495990901), new Word64(1249150122, 1856431235), new Word64(1555081692, 3175218132), new Word64(1996064986, 2198950837), new Word64(2554220882, 3999719339), new Word64(2821834349, 766784016), new Word64(2952996808, 2566594879), new Word64(3210313671, 3203337956), new Word64(3336571891, 1034457026), new Word64(3584528711, 2466948901), new Word64(113926993, 3758326383), new Word64(338241895, 168717936), new Word64(666307205, 1188179964), new Word64(773529912, 1546045734), new Word64(1294757372, 1522805485), new Word64(1396182291, 2643833823), new Word64(1695183700, 2343527390), new Word64(1986661051, 1014477480), new Word64(2177026350, 1206759142), new Word64(2456956037, 344077627), new Word64(2730485921, 1290863460), new Word64(2820302411, 3158454273), new Word64(3259730800, 3505952657), new Word64(3345764771, 106217008), new Word64(3516065817, 3606008344), new Word64(3600352804, 1432725776), new Word64(4094571909, 1467031594), new Word64(275423344, 851169720), new Word64(430227734, 3100823752), new Word64(506948616, 1363258195), new Word64(659060556, 3750685593), new Word64(883997877, 3785050280), new Word64(958139571, 3318307427), new Word64(1322822218, 3812723403), new Word64(1537002063, 2003034995), new Word64(1747873779, 3602036899), new Word64(1955562222, 1575990012), new Word64(2024104815, 1125592928), new Word64(2227730452, 2716904306), new Word64(2361852424, 442776044), new Word64(2428436474, 593698344), new Word64(2756734187, 3733110249), new Word64(3204031479, 2999351573), new Word64(3329325298, 3815920427), new Word64(3391569614, 3928383900), new Word64(3515267271, 566280711), new Word64(3940187606, 3454069534), new Word64(4118630271, 4000239992), new Word64(116418474, 1914138554), new Word64(174292421, 2731055270), new Word64(289380356, 3203993006), new Word64(460393269, 320620315), new Word64(685471733, 587496836), new Word64(852142971, 1086792851), new Word64(1017036298, 365543100), new Word64(1126000580, 2618297676), new Word64(1288033470, 3409855158), new Word64(1501505948, 4234509866), new Word64(1607167915, 987167468), new Word64(1816402316, 1246189591)];
                function hash2(data2, offset4, length2, mode384 = false) {
                  let h0, h1, h2, h3, h4, h5, h6, h7;
                  if (!mode384) {
                    h0 = new Word64(1779033703, 4089235720);
                    h1 = new Word64(3144134277, 2227873595);
                    h2 = new Word64(1013904242, 4271175723);
                    h3 = new Word64(2773480762, 1595750129);
                    h4 = new Word64(1359893119, 2917565137);
                    h5 = new Word64(2600822924, 725511199);
                    h6 = new Word64(528734635, 4215389547);
                    h7 = new Word64(1541459225, 327033209);
                  } else {
                    h0 = new Word64(3418070365, 3238371032);
                    h1 = new Word64(1654270250, 914150663);
                    h2 = new Word64(2438529370, 812702999);
                    h3 = new Word64(355462360, 4144912697);
                    h4 = new Word64(1731405415, 4290775857);
                    h5 = new Word64(2394180231, 1750603025);
                    h6 = new Word64(3675008525, 1694076839);
                    h7 = new Word64(1203062813, 3204075428);
                  }
                  const paddedLength = Math.ceil((length2 + 17) / 128) * 128;
                  const padded = new Uint8Array(paddedLength);
                  let i, j;
                  for (i = 0; i < length2; ++i) {
                    padded[i] = data2[offset4++];
                  }
                  padded[i++] = 128;
                  const n2 = paddedLength - 16;
                  while (i < n2) {
                    padded[i++] = 0;
                  }
                  padded[i++] = 0;
                  padded[i++] = 0;
                  padded[i++] = 0;
                  padded[i++] = 0;
                  padded[i++] = 0;
                  padded[i++] = 0;
                  padded[i++] = 0;
                  padded[i++] = 0;
                  padded[i++] = 0;
                  padded[i++] = 0;
                  padded[i++] = 0;
                  padded[i++] = length2 >>> 29 & 255;
                  padded[i++] = length2 >> 21 & 255;
                  padded[i++] = length2 >> 13 & 255;
                  padded[i++] = length2 >> 5 & 255;
                  padded[i++] = length2 << 3 & 255;
                  const w = new Array(80);
                  for (i = 0; i < 80; i++) {
                    w[i] = new Word64(0, 0);
                  }
                  let a = new Word64(0, 0), b = new Word64(0, 0), c = new Word64(0, 0);
                  let d = new Word64(0, 0), e3 = new Word64(0, 0), f = new Word64(0, 0);
                  let g = new Word64(0, 0), h8 = new Word64(0, 0);
                  const t1 = new Word64(0, 0), t2 = new Word64(0, 0);
                  const tmp1 = new Word64(0, 0), tmp2 = new Word64(0, 0);
                  let tmp3;
                  for (i = 0; i < paddedLength; ) {
                    for (j = 0; j < 16; ++j) {
                      w[j].high = padded[i] << 24 | padded[i + 1] << 16 | padded[i + 2] << 8 | padded[i + 3];
                      w[j].low = padded[i + 4] << 24 | padded[i + 5] << 16 | padded[i + 6] << 8 | padded[i + 7];
                      i += 8;
                    }
                    for (j = 16; j < 80; ++j) {
                      tmp3 = w[j];
                      littleSigmaPrime(tmp3, w[j - 2], tmp2);
                      tmp3.add(w[j - 7]);
                      littleSigma(tmp1, w[j - 15], tmp2);
                      tmp3.add(tmp1);
                      tmp3.add(w[j - 16]);
                    }
                    a.assign(h0);
                    b.assign(h1);
                    c.assign(h2);
                    d.assign(h3);
                    e3.assign(h4);
                    f.assign(h5);
                    g.assign(h6);
                    h8.assign(h7);
                    for (j = 0; j < 80; ++j) {
                      t1.assign(h8);
                      sigmaPrime(tmp1, e3, tmp2);
                      t1.add(tmp1);
                      ch(tmp1, e3, f, g, tmp2);
                      t1.add(tmp1);
                      t1.add(k[j]);
                      t1.add(w[j]);
                      sigma(t2, a, tmp2);
                      maj(tmp1, a, b, c, tmp2);
                      t2.add(tmp1);
                      tmp3 = h8;
                      h8 = g;
                      g = f;
                      f = e3;
                      d.add(t1);
                      e3 = d;
                      d = c;
                      c = b;
                      b = a;
                      tmp3.assign(t1);
                      tmp3.add(t2);
                      a = tmp3;
                    }
                    h0.add(a);
                    h1.add(b);
                    h2.add(c);
                    h3.add(d);
                    h4.add(e3);
                    h5.add(f);
                    h6.add(g);
                    h7.add(h8);
                  }
                  let result;
                  if (!mode384) {
                    result = new Uint8Array(64);
                    h0.copyTo(result, 0);
                    h1.copyTo(result, 8);
                    h2.copyTo(result, 16);
                    h3.copyTo(result, 24);
                    h4.copyTo(result, 32);
                    h5.copyTo(result, 40);
                    h6.copyTo(result, 48);
                    h7.copyTo(result, 56);
                  } else {
                    result = new Uint8Array(48);
                    h0.copyTo(result, 0);
                    h1.copyTo(result, 8);
                    h2.copyTo(result, 16);
                    h3.copyTo(result, 24);
                    h4.copyTo(result, 32);
                    h5.copyTo(result, 40);
                  }
                  return result;
                }
                return hash2;
              })();
              exports3.calculateSHA512 = calculateSHA512;
              function calculateSHA384(data2, offset4, length2) {
                return calculateSHA512(data2, offset4, length2, true);
              }
              class NullCipher {
                decryptBlock(data2) {
                  return data2;
                }
                encrypt(data2) {
                  return data2;
                }
              }
              class AESBaseCipher {
                constructor() {
                  if (this.constructor === AESBaseCipher) {
                    (0, _util2.unreachable)("Cannot initialize AESBaseCipher.");
                  }
                  this._s = new Uint8Array([99, 124, 119, 123, 242, 107, 111, 197, 48, 1, 103, 43, 254, 215, 171, 118, 202, 130, 201, 125, 250, 89, 71, 240, 173, 212, 162, 175, 156, 164, 114, 192, 183, 253, 147, 38, 54, 63, 247, 204, 52, 165, 229, 241, 113, 216, 49, 21, 4, 199, 35, 195, 24, 150, 5, 154, 7, 18, 128, 226, 235, 39, 178, 117, 9, 131, 44, 26, 27, 110, 90, 160, 82, 59, 214, 179, 41, 227, 47, 132, 83, 209, 0, 237, 32, 252, 177, 91, 106, 203, 190, 57, 74, 76, 88, 207, 208, 239, 170, 251, 67, 77, 51, 133, 69, 249, 2, 127, 80, 60, 159, 168, 81, 163, 64, 143, 146, 157, 56, 245, 188, 182, 218, 33, 16, 255, 243, 210, 205, 12, 19, 236, 95, 151, 68, 23, 196, 167, 126, 61, 100, 93, 25, 115, 96, 129, 79, 220, 34, 42, 144, 136, 70, 238, 184, 20, 222, 94, 11, 219, 224, 50, 58, 10, 73, 6, 36, 92, 194, 211, 172, 98, 145, 149, 228, 121, 231, 200, 55, 109, 141, 213, 78, 169, 108, 86, 244, 234, 101, 122, 174, 8, 186, 120, 37, 46, 28, 166, 180, 198, 232, 221, 116, 31, 75, 189, 139, 138, 112, 62, 181, 102, 72, 3, 246, 14, 97, 53, 87, 185, 134, 193, 29, 158, 225, 248, 152, 17, 105, 217, 142, 148, 155, 30, 135, 233, 206, 85, 40, 223, 140, 161, 137, 13, 191, 230, 66, 104, 65, 153, 45, 15, 176, 84, 187, 22]);
                  this._inv_s = new Uint8Array([82, 9, 106, 213, 48, 54, 165, 56, 191, 64, 163, 158, 129, 243, 215, 251, 124, 227, 57, 130, 155, 47, 255, 135, 52, 142, 67, 68, 196, 222, 233, 203, 84, 123, 148, 50, 166, 194, 35, 61, 238, 76, 149, 11, 66, 250, 195, 78, 8, 46, 161, 102, 40, 217, 36, 178, 118, 91, 162, 73, 109, 139, 209, 37, 114, 248, 246, 100, 134, 104, 152, 22, 212, 164, 92, 204, 93, 101, 182, 146, 108, 112, 72, 80, 253, 237, 185, 218, 94, 21, 70, 87, 167, 141, 157, 132, 144, 216, 171, 0, 140, 188, 211, 10, 247, 228, 88, 5, 184, 179, 69, 6, 208, 44, 30, 143, 202, 63, 15, 2, 193, 175, 189, 3, 1, 19, 138, 107, 58, 145, 17, 65, 79, 103, 220, 234, 151, 242, 207, 206, 240, 180, 230, 115, 150, 172, 116, 34, 231, 173, 53, 133, 226, 249, 55, 232, 28, 117, 223, 110, 71, 241, 26, 113, 29, 41, 197, 137, 111, 183, 98, 14, 170, 24, 190, 27, 252, 86, 62, 75, 198, 210, 121, 32, 154, 219, 192, 254, 120, 205, 90, 244, 31, 221, 168, 51, 136, 7, 199, 49, 177, 18, 16, 89, 39, 128, 236, 95, 96, 81, 127, 169, 25, 181, 74, 13, 45, 229, 122, 159, 147, 201, 156, 239, 160, 224, 59, 77, 174, 42, 245, 176, 200, 235, 187, 60, 131, 83, 153, 97, 23, 43, 4, 126, 186, 119, 214, 38, 225, 105, 20, 99, 85, 33, 12, 125]);
                  this._mix = new Uint32Array([0, 235474187, 470948374, 303765277, 941896748, 908933415, 607530554, 708780849, 1883793496, 2118214995, 1817866830, 1649639237, 1215061108, 1181045119, 1417561698, 1517767529, 3767586992, 4003061179, 4236429990, 4069246893, 3635733660, 3602770327, 3299278474, 3400528769, 2430122216, 2664543715, 2362090238, 2193862645, 2835123396, 2801107407, 3035535058, 3135740889, 3678124923, 3576870512, 3341394285, 3374361702, 3810496343, 3977675356, 4279080257, 4043610186, 2876494627, 2776292904, 3076639029, 3110650942, 2472011535, 2640243204, 2403728665, 2169303058, 1001089995, 899835584, 666464733, 699432150, 59727847, 226906860, 530400753, 294930682, 1273168787, 1172967064, 1475418501, 1509430414, 1942435775, 2110667444, 1876241833, 1641816226, 2910219766, 2743034109, 2976151520, 3211623147, 2505202138, 2606453969, 2302690252, 2269728455, 3711829422, 3543599269, 3240894392, 3475313331, 3843699074, 3943906441, 4178062228, 4144047775, 1306967366, 1139781709, 1374988112, 1610459739, 1975683434, 2076935265, 1775276924, 1742315127, 1034867998, 866637845, 566021896, 800440835, 92987698, 193195065, 429456164, 395441711, 1984812685, 2017778566, 1784663195, 1683407248, 1315562145, 1080094634, 1383856311, 1551037884, 101039829, 135050206, 437757123, 337553864, 1042385657, 807962610, 573804783, 742039012, 2531067453, 2564033334, 2328828971, 2227573024, 2935566865, 2700099354, 3001755655, 3168937228, 3868552805, 3902563182, 4203181171, 4102977912, 3736164937, 3501741890, 3265478751, 3433712980, 1106041591, 1340463100, 1576976609, 1408749034, 2043211483, 2009195472, 1708848333, 1809054150, 832877231, 1068351396, 766945465, 599762354, 159417987, 126454664, 361929877, 463180190, 2709260871, 2943682380, 3178106961, 3009879386, 2572697195, 2538681184, 2236228733, 2336434550, 3509871135, 3745345300, 3441850377, 3274667266, 3910161971, 3877198648, 4110568485, 4211818798, 2597806476, 2497604743, 2261089178, 2295101073, 2733856160, 2902087851, 3202437046, 2968011453, 3936291284, 3835036895, 4136440770, 4169408201, 3535486456, 3702665459, 3467192302, 3231722213, 2051518780, 1951317047, 1716890410, 1750902305, 1113818384, 1282050075, 1584504582, 1350078989, 168810852, 67556463, 371049330, 404016761, 841739592, 1008918595, 775550814, 540080725, 3969562369, 3801332234, 4035489047, 4269907996, 3569255213, 3669462566, 3366754619, 3332740144, 2631065433, 2463879762, 2160117071, 2395588676, 2767645557, 2868897406, 3102011747, 3069049960, 202008497, 33778362, 270040487, 504459436, 875451293, 975658646, 675039627, 641025152, 2084704233, 1917518562, 1615861247, 1851332852, 1147550661, 1248802510, 1484005843, 1451044056, 933301370, 967311729, 733156972, 632953703, 260388950, 25965917, 328671808, 496906059, 1206477858, 1239443753, 1543208500, 1441952575, 2144161806, 1908694277, 1675577880, 1842759443, 3610369226, 3644379585, 3408119516, 3307916247, 4011190502, 3776767469, 4077384432, 4245618683, 2809771154, 2842737049, 3144396420, 3043140495, 2673705150, 2438237621, 2203032232, 2370213795]);
                  this._mixCol = new Uint8Array(256);
                  for (let i = 0; i < 256; i++) {
                    this._mixCol[i] = i < 128 ? i << 1 : i << 1 ^ 27;
                  }
                  this.buffer = new Uint8Array(16);
                  this.bufferPosition = 0;
                }
                _expandKey(cipherKey) {
                  (0, _util2.unreachable)("Cannot call `_expandKey` on the base class");
                }
                _decrypt(input, key2) {
                  let t2, u, v;
                  const state = new Uint8Array(16);
                  state.set(input);
                  for (let j = 0, k = this._keySize; j < 16; ++j, ++k) {
                    state[j] ^= key2[k];
                  }
                  for (let i = this._cyclesOfRepetition - 1; i >= 1; --i) {
                    t2 = state[13];
                    state[13] = state[9];
                    state[9] = state[5];
                    state[5] = state[1];
                    state[1] = t2;
                    t2 = state[14];
                    u = state[10];
                    state[14] = state[6];
                    state[10] = state[2];
                    state[6] = t2;
                    state[2] = u;
                    t2 = state[15];
                    u = state[11];
                    v = state[7];
                    state[15] = state[3];
                    state[11] = t2;
                    state[7] = u;
                    state[3] = v;
                    for (let j = 0; j < 16; ++j) {
                      state[j] = this._inv_s[state[j]];
                    }
                    for (let j = 0, k = i * 16; j < 16; ++j, ++k) {
                      state[j] ^= key2[k];
                    }
                    for (let j = 0; j < 16; j += 4) {
                      const s0 = this._mix[state[j]];
                      const s1 = this._mix[state[j + 1]];
                      const s2 = this._mix[state[j + 2]];
                      const s3 = this._mix[state[j + 3]];
                      t2 = s0 ^ s1 >>> 8 ^ s1 << 24 ^ s2 >>> 16 ^ s2 << 16 ^ s3 >>> 24 ^ s3 << 8;
                      state[j] = t2 >>> 24 & 255;
                      state[j + 1] = t2 >> 16 & 255;
                      state[j + 2] = t2 >> 8 & 255;
                      state[j + 3] = t2 & 255;
                    }
                  }
                  t2 = state[13];
                  state[13] = state[9];
                  state[9] = state[5];
                  state[5] = state[1];
                  state[1] = t2;
                  t2 = state[14];
                  u = state[10];
                  state[14] = state[6];
                  state[10] = state[2];
                  state[6] = t2;
                  state[2] = u;
                  t2 = state[15];
                  u = state[11];
                  v = state[7];
                  state[15] = state[3];
                  state[11] = t2;
                  state[7] = u;
                  state[3] = v;
                  for (let j = 0; j < 16; ++j) {
                    state[j] = this._inv_s[state[j]];
                    state[j] ^= key2[j];
                  }
                  return state;
                }
                _encrypt(input, key2) {
                  const s = this._s;
                  let t2, u, v;
                  const state = new Uint8Array(16);
                  state.set(input);
                  for (let j = 0; j < 16; ++j) {
                    state[j] ^= key2[j];
                  }
                  for (let i = 1; i < this._cyclesOfRepetition; i++) {
                    for (let j = 0; j < 16; ++j) {
                      state[j] = s[state[j]];
                    }
                    v = state[1];
                    state[1] = state[5];
                    state[5] = state[9];
                    state[9] = state[13];
                    state[13] = v;
                    v = state[2];
                    u = state[6];
                    state[2] = state[10];
                    state[6] = state[14];
                    state[10] = v;
                    state[14] = u;
                    v = state[3];
                    u = state[7];
                    t2 = state[11];
                    state[3] = state[15];
                    state[7] = v;
                    state[11] = u;
                    state[15] = t2;
                    for (let j = 0; j < 16; j += 4) {
                      const s0 = state[j + 0];
                      const s1 = state[j + 1];
                      const s2 = state[j + 2];
                      const s3 = state[j + 3];
                      t2 = s0 ^ s1 ^ s2 ^ s3;
                      state[j + 0] ^= t2 ^ this._mixCol[s0 ^ s1];
                      state[j + 1] ^= t2 ^ this._mixCol[s1 ^ s2];
                      state[j + 2] ^= t2 ^ this._mixCol[s2 ^ s3];
                      state[j + 3] ^= t2 ^ this._mixCol[s3 ^ s0];
                    }
                    for (let j = 0, k = i * 16; j < 16; ++j, ++k) {
                      state[j] ^= key2[k];
                    }
                  }
                  for (let j = 0; j < 16; ++j) {
                    state[j] = s[state[j]];
                  }
                  v = state[1];
                  state[1] = state[5];
                  state[5] = state[9];
                  state[9] = state[13];
                  state[13] = v;
                  v = state[2];
                  u = state[6];
                  state[2] = state[10];
                  state[6] = state[14];
                  state[10] = v;
                  state[14] = u;
                  v = state[3];
                  u = state[7];
                  t2 = state[11];
                  state[3] = state[15];
                  state[7] = v;
                  state[11] = u;
                  state[15] = t2;
                  for (let j = 0, k = this._keySize; j < 16; ++j, ++k) {
                    state[j] ^= key2[k];
                  }
                  return state;
                }
                _decryptBlock2(data2, finalize) {
                  const sourceLength = data2.length;
                  let buffer = this.buffer, bufferLength = this.bufferPosition;
                  const result = [];
                  let iv = this.iv;
                  for (let i = 0; i < sourceLength; ++i) {
                    buffer[bufferLength] = data2[i];
                    ++bufferLength;
                    if (bufferLength < 16) {
                      continue;
                    }
                    const plain = this._decrypt(buffer, this._key);
                    for (let j = 0; j < 16; ++j) {
                      plain[j] ^= iv[j];
                    }
                    iv = buffer;
                    result.push(plain);
                    buffer = new Uint8Array(16);
                    bufferLength = 0;
                  }
                  this.buffer = buffer;
                  this.bufferLength = bufferLength;
                  this.iv = iv;
                  if (result.length === 0) {
                    return new Uint8Array(0);
                  }
                  let outputLength = 16 * result.length;
                  if (finalize) {
                    const lastBlock = result.at(-1);
                    let psLen = lastBlock[15];
                    if (psLen <= 16) {
                      for (let i = 15, ii = 16 - psLen; i >= ii; --i) {
                        if (lastBlock[i] !== psLen) {
                          psLen = 0;
                          break;
                        }
                      }
                      outputLength -= psLen;
                      result[result.length - 1] = lastBlock.subarray(0, 16 - psLen);
                    }
                  }
                  const output = new Uint8Array(outputLength);
                  for (let i = 0, j = 0, ii = result.length; i < ii; ++i, j += 16) {
                    output.set(result[i], j);
                  }
                  return output;
                }
                decryptBlock(data2, finalize, iv = null) {
                  const sourceLength = data2.length;
                  const buffer = this.buffer;
                  let bufferLength = this.bufferPosition;
                  if (iv) {
                    this.iv = iv;
                  } else {
                    for (let i = 0; bufferLength < 16 && i < sourceLength; ++i, ++bufferLength) {
                      buffer[bufferLength] = data2[i];
                    }
                    if (bufferLength < 16) {
                      this.bufferLength = bufferLength;
                      return new Uint8Array(0);
                    }
                    this.iv = buffer;
                    data2 = data2.subarray(16);
                  }
                  this.buffer = new Uint8Array(16);
                  this.bufferLength = 0;
                  this.decryptBlock = this._decryptBlock2;
                  return this.decryptBlock(data2, finalize);
                }
                encrypt(data2, iv) {
                  const sourceLength = data2.length;
                  let buffer = this.buffer, bufferLength = this.bufferPosition;
                  const result = [];
                  if (!iv) {
                    iv = new Uint8Array(16);
                  }
                  for (let i = 0; i < sourceLength; ++i) {
                    buffer[bufferLength] = data2[i];
                    ++bufferLength;
                    if (bufferLength < 16) {
                      continue;
                    }
                    for (let j = 0; j < 16; ++j) {
                      buffer[j] ^= iv[j];
                    }
                    const cipher = this._encrypt(buffer, this._key);
                    iv = cipher;
                    result.push(cipher);
                    buffer = new Uint8Array(16);
                    bufferLength = 0;
                  }
                  this.buffer = buffer;
                  this.bufferLength = bufferLength;
                  this.iv = iv;
                  if (result.length === 0) {
                    return new Uint8Array(0);
                  }
                  const outputLength = 16 * result.length;
                  const output = new Uint8Array(outputLength);
                  for (let i = 0, j = 0, ii = result.length; i < ii; ++i, j += 16) {
                    output.set(result[i], j);
                  }
                  return output;
                }
              }
              class AES128Cipher extends AESBaseCipher {
                constructor(key2) {
                  super();
                  this._cyclesOfRepetition = 10;
                  this._keySize = 160;
                  this._rcon = new Uint8Array([141, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54, 108, 216, 171, 77, 154, 47, 94, 188, 99, 198, 151, 53, 106, 212, 179, 125, 250, 239, 197, 145, 57, 114, 228, 211, 189, 97, 194, 159, 37, 74, 148, 51, 102, 204, 131, 29, 58, 116, 232, 203, 141, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54, 108, 216, 171, 77, 154, 47, 94, 188, 99, 198, 151, 53, 106, 212, 179, 125, 250, 239, 197, 145, 57, 114, 228, 211, 189, 97, 194, 159, 37, 74, 148, 51, 102, 204, 131, 29, 58, 116, 232, 203, 141, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54, 108, 216, 171, 77, 154, 47, 94, 188, 99, 198, 151, 53, 106, 212, 179, 125, 250, 239, 197, 145, 57, 114, 228, 211, 189, 97, 194, 159, 37, 74, 148, 51, 102, 204, 131, 29, 58, 116, 232, 203, 141, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54, 108, 216, 171, 77, 154, 47, 94, 188, 99, 198, 151, 53, 106, 212, 179, 125, 250, 239, 197, 145, 57, 114, 228, 211, 189, 97, 194, 159, 37, 74, 148, 51, 102, 204, 131, 29, 58, 116, 232, 203, 141, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54, 108, 216, 171, 77, 154, 47, 94, 188, 99, 198, 151, 53, 106, 212, 179, 125, 250, 239, 197, 145, 57, 114, 228, 211, 189, 97, 194, 159, 37, 74, 148, 51, 102, 204, 131, 29, 58, 116, 232, 203, 141]);
                  this._key = this._expandKey(key2);
                }
                _expandKey(cipherKey) {
                  const b = 176;
                  const s = this._s;
                  const rcon = this._rcon;
                  const result = new Uint8Array(b);
                  result.set(cipherKey);
                  for (let j = 16, i = 1; j < b; ++i) {
                    let t1 = result[j - 3];
                    let t2 = result[j - 2];
                    let t3 = result[j - 1];
                    let t4 = result[j - 4];
                    t1 = s[t1];
                    t2 = s[t2];
                    t3 = s[t3];
                    t4 = s[t4];
                    t1 ^= rcon[i];
                    for (let n2 = 0; n2 < 4; ++n2) {
                      result[j] = t1 ^= result[j - 16];
                      j++;
                      result[j] = t2 ^= result[j - 16];
                      j++;
                      result[j] = t3 ^= result[j - 16];
                      j++;
                      result[j] = t4 ^= result[j - 16];
                      j++;
                    }
                  }
                  return result;
                }
              }
              exports3.AES128Cipher = AES128Cipher;
              class AES256Cipher extends AESBaseCipher {
                constructor(key2) {
                  super();
                  this._cyclesOfRepetition = 14;
                  this._keySize = 224;
                  this._key = this._expandKey(key2);
                }
                _expandKey(cipherKey) {
                  const b = 240;
                  const s = this._s;
                  const result = new Uint8Array(b);
                  result.set(cipherKey);
                  let r2 = 1;
                  let t1, t2, t3, t4;
                  for (let j = 32, i = 1; j < b; ++i) {
                    if (j % 32 === 16) {
                      t1 = s[t1];
                      t2 = s[t2];
                      t3 = s[t3];
                      t4 = s[t4];
                    } else if (j % 32 === 0) {
                      t1 = result[j - 3];
                      t2 = result[j - 2];
                      t3 = result[j - 1];
                      t4 = result[j - 4];
                      t1 = s[t1];
                      t2 = s[t2];
                      t3 = s[t3];
                      t4 = s[t4];
                      t1 ^= r2;
                      if ((r2 <<= 1) >= 256) {
                        r2 = (r2 ^ 27) & 255;
                      }
                    }
                    for (let n2 = 0; n2 < 4; ++n2) {
                      result[j] = t1 ^= result[j - 32];
                      j++;
                      result[j] = t2 ^= result[j - 32];
                      j++;
                      result[j] = t3 ^= result[j - 32];
                      j++;
                      result[j] = t4 ^= result[j - 32];
                      j++;
                    }
                  }
                  return result;
                }
              }
              exports3.AES256Cipher = AES256Cipher;
              class PDF17 {
                checkOwnerPassword(password, ownerValidationSalt, userBytes, ownerPassword) {
                  const hashData = new Uint8Array(password.length + 56);
                  hashData.set(password, 0);
                  hashData.set(ownerValidationSalt, password.length);
                  hashData.set(userBytes, password.length + ownerValidationSalt.length);
                  const result = calculateSHA256(hashData, 0, hashData.length);
                  return (0, _util2.isArrayEqual)(result, ownerPassword);
                }
                checkUserPassword(password, userValidationSalt, userPassword) {
                  const hashData = new Uint8Array(password.length + 8);
                  hashData.set(password, 0);
                  hashData.set(userValidationSalt, password.length);
                  const result = calculateSHA256(hashData, 0, hashData.length);
                  return (0, _util2.isArrayEqual)(result, userPassword);
                }
                getOwnerKey(password, ownerKeySalt, userBytes, ownerEncryption) {
                  const hashData = new Uint8Array(password.length + 56);
                  hashData.set(password, 0);
                  hashData.set(ownerKeySalt, password.length);
                  hashData.set(userBytes, password.length + ownerKeySalt.length);
                  const key2 = calculateSHA256(hashData, 0, hashData.length);
                  const cipher = new AES256Cipher(key2);
                  return cipher.decryptBlock(ownerEncryption, false, new Uint8Array(16));
                }
                getUserKey(password, userKeySalt, userEncryption) {
                  const hashData = new Uint8Array(password.length + 8);
                  hashData.set(password, 0);
                  hashData.set(userKeySalt, password.length);
                  const key2 = calculateSHA256(hashData, 0, hashData.length);
                  const cipher = new AES256Cipher(key2);
                  return cipher.decryptBlock(userEncryption, false, new Uint8Array(16));
                }
              }
              exports3.PDF17 = PDF17;
              class PDF20 {
                _hash(password, input, userBytes) {
                  let k = calculateSHA256(input, 0, input.length).subarray(0, 32);
                  let e3 = [0];
                  let i = 0;
                  while (i < 64 || e3.at(-1) > i - 32) {
                    const combinedLength = password.length + k.length + userBytes.length, combinedArray = new Uint8Array(combinedLength);
                    let writeOffset = 0;
                    combinedArray.set(password, writeOffset);
                    writeOffset += password.length;
                    combinedArray.set(k, writeOffset);
                    writeOffset += k.length;
                    combinedArray.set(userBytes, writeOffset);
                    const k1 = new Uint8Array(combinedLength * 64);
                    for (let j = 0, pos = 0; j < 64; j++, pos += combinedLength) {
                      k1.set(combinedArray, pos);
                    }
                    const cipher = new AES128Cipher(k.subarray(0, 16));
                    e3 = cipher.encrypt(k1, k.subarray(16, 32));
                    const remainder = e3.slice(0, 16).reduce((a, b) => a + b, 0) % 3;
                    if (remainder === 0) {
                      k = calculateSHA256(e3, 0, e3.length);
                    } else if (remainder === 1) {
                      k = calculateSHA384(e3, 0, e3.length);
                    } else if (remainder === 2) {
                      k = calculateSHA512(e3, 0, e3.length);
                    }
                    i++;
                  }
                  return k.subarray(0, 32);
                }
                checkOwnerPassword(password, ownerValidationSalt, userBytes, ownerPassword) {
                  const hashData = new Uint8Array(password.length + 56);
                  hashData.set(password, 0);
                  hashData.set(ownerValidationSalt, password.length);
                  hashData.set(userBytes, password.length + ownerValidationSalt.length);
                  const result = this._hash(password, hashData, userBytes);
                  return (0, _util2.isArrayEqual)(result, ownerPassword);
                }
                checkUserPassword(password, userValidationSalt, userPassword) {
                  const hashData = new Uint8Array(password.length + 8);
                  hashData.set(password, 0);
                  hashData.set(userValidationSalt, password.length);
                  const result = this._hash(password, hashData, []);
                  return (0, _util2.isArrayEqual)(result, userPassword);
                }
                getOwnerKey(password, ownerKeySalt, userBytes, ownerEncryption) {
                  const hashData = new Uint8Array(password.length + 56);
                  hashData.set(password, 0);
                  hashData.set(ownerKeySalt, password.length);
                  hashData.set(userBytes, password.length + ownerKeySalt.length);
                  const key2 = this._hash(password, hashData, userBytes);
                  const cipher = new AES256Cipher(key2);
                  return cipher.decryptBlock(ownerEncryption, false, new Uint8Array(16));
                }
                getUserKey(password, userKeySalt, userEncryption) {
                  const hashData = new Uint8Array(password.length + 8);
                  hashData.set(password, 0);
                  hashData.set(userKeySalt, password.length);
                  const key2 = this._hash(password, hashData, []);
                  const cipher = new AES256Cipher(key2);
                  return cipher.decryptBlock(userEncryption, false, new Uint8Array(16));
                }
              }
              exports3.PDF20 = PDF20;
              class CipherTransform {
                constructor(stringCipherConstructor, streamCipherConstructor) {
                  this.StringCipherConstructor = stringCipherConstructor;
                  this.StreamCipherConstructor = streamCipherConstructor;
                }
                createStream(stream, length2) {
                  const cipher = new this.StreamCipherConstructor();
                  return new _decrypt_stream.DecryptStream(stream, length2, function cipherTransformDecryptStream(data2, finalize) {
                    return cipher.decryptBlock(data2, finalize);
                  });
                }
                decryptString(s) {
                  const cipher = new this.StringCipherConstructor();
                  let data2 = (0, _util2.stringToBytes)(s);
                  data2 = cipher.decryptBlock(data2, true);
                  return (0, _util2.bytesToString)(data2);
                }
                encryptString(s) {
                  const cipher = new this.StringCipherConstructor();
                  if (cipher instanceof AESBaseCipher) {
                    const strLen = s.length;
                    const pad = 16 - strLen % 16;
                    s += String.fromCharCode(pad).repeat(pad);
                    const iv = new Uint8Array(16);
                    if (typeof crypto !== "undefined") {
                      crypto.getRandomValues(iv);
                    } else {
                      for (let i = 0; i < 16; i++) {
                        iv[i] = Math.floor(256 * Math.random());
                      }
                    }
                    let data3 = (0, _util2.stringToBytes)(s);
                    data3 = cipher.encrypt(data3, iv);
                    const buf = new Uint8Array(16 + data3.length);
                    buf.set(iv);
                    buf.set(data3, 16);
                    return (0, _util2.bytesToString)(buf);
                  }
                  let data2 = (0, _util2.stringToBytes)(s);
                  data2 = cipher.encrypt(data2);
                  return (0, _util2.bytesToString)(data2);
                }
              }
              class CipherTransformFactory {
                static #defaultPasswordBytes = new Uint8Array([40, 191, 78, 94, 78, 117, 138, 65, 100, 0, 78, 86, 255, 250, 1, 8, 46, 46, 0, 182, 208, 104, 62, 128, 47, 12, 169, 254, 100, 83, 105, 122]);
                #createEncryptionKey20(revision, password, ownerPassword, ownerValidationSalt, ownerKeySalt, uBytes, userPassword, userValidationSalt, userKeySalt, ownerEncryption, userEncryption, perms) {
                  if (password) {
                    const passwordLength = Math.min(127, password.length);
                    password = password.subarray(0, passwordLength);
                  } else {
                    password = [];
                  }
                  const pdfAlgorithm = revision === 6 ? new PDF20() : new PDF17();
                  if (pdfAlgorithm.checkUserPassword(password, userValidationSalt, userPassword)) {
                    return pdfAlgorithm.getUserKey(password, userKeySalt, userEncryption);
                  } else if (password.length && pdfAlgorithm.checkOwnerPassword(password, ownerValidationSalt, uBytes, ownerPassword)) {
                    return pdfAlgorithm.getOwnerKey(password, ownerKeySalt, uBytes, ownerEncryption);
                  }
                  return null;
                }
                #prepareKeyData(fileId, password, ownerPassword, userPassword, flags, revision, keyLength, encryptMetadata) {
                  const hashDataSize = 40 + ownerPassword.length + fileId.length;
                  const hashData = new Uint8Array(hashDataSize);
                  let i = 0, j, n2;
                  if (password) {
                    n2 = Math.min(32, password.length);
                    for (; i < n2; ++i) {
                      hashData[i] = password[i];
                    }
                  }
                  j = 0;
                  while (i < 32) {
                    hashData[i++] = CipherTransformFactory.#defaultPasswordBytes[j++];
                  }
                  for (j = 0, n2 = ownerPassword.length; j < n2; ++j) {
                    hashData[i++] = ownerPassword[j];
                  }
                  hashData[i++] = flags & 255;
                  hashData[i++] = flags >> 8 & 255;
                  hashData[i++] = flags >> 16 & 255;
                  hashData[i++] = flags >>> 24 & 255;
                  for (j = 0, n2 = fileId.length; j < n2; ++j) {
                    hashData[i++] = fileId[j];
                  }
                  if (revision >= 4 && !encryptMetadata) {
                    hashData[i++] = 255;
                    hashData[i++] = 255;
                    hashData[i++] = 255;
                    hashData[i++] = 255;
                  }
                  let hash2 = calculateMD5(hashData, 0, i);
                  const keyLengthInBytes = keyLength >> 3;
                  if (revision >= 3) {
                    for (j = 0; j < 50; ++j) {
                      hash2 = calculateMD5(hash2, 0, keyLengthInBytes);
                    }
                  }
                  const encryptionKey = hash2.subarray(0, keyLengthInBytes);
                  let cipher, checkData;
                  if (revision >= 3) {
                    for (i = 0; i < 32; ++i) {
                      hashData[i] = CipherTransformFactory.#defaultPasswordBytes[i];
                    }
                    for (j = 0, n2 = fileId.length; j < n2; ++j) {
                      hashData[i++] = fileId[j];
                    }
                    cipher = new ARCFourCipher(encryptionKey);
                    checkData = cipher.encryptBlock(calculateMD5(hashData, 0, i));
                    n2 = encryptionKey.length;
                    const derivedKey = new Uint8Array(n2);
                    for (j = 1; j <= 19; ++j) {
                      for (let k = 0; k < n2; ++k) {
                        derivedKey[k] = encryptionKey[k] ^ j;
                      }
                      cipher = new ARCFourCipher(derivedKey);
                      checkData = cipher.encryptBlock(checkData);
                    }
                    for (j = 0, n2 = checkData.length; j < n2; ++j) {
                      if (userPassword[j] !== checkData[j]) {
                        return null;
                      }
                    }
                  } else {
                    cipher = new ARCFourCipher(encryptionKey);
                    checkData = cipher.encryptBlock(CipherTransformFactory.#defaultPasswordBytes);
                    for (j = 0, n2 = checkData.length; j < n2; ++j) {
                      if (userPassword[j] !== checkData[j]) {
                        return null;
                      }
                    }
                  }
                  return encryptionKey;
                }
                #decodeUserPassword(password, ownerPassword, revision, keyLength) {
                  const hashData = new Uint8Array(32);
                  let i = 0;
                  const n2 = Math.min(32, password.length);
                  for (; i < n2; ++i) {
                    hashData[i] = password[i];
                  }
                  let j = 0;
                  while (i < 32) {
                    hashData[i++] = CipherTransformFactory.#defaultPasswordBytes[j++];
                  }
                  let hash2 = calculateMD5(hashData, 0, i);
                  const keyLengthInBytes = keyLength >> 3;
                  if (revision >= 3) {
                    for (j = 0; j < 50; ++j) {
                      hash2 = calculateMD5(hash2, 0, hash2.length);
                    }
                  }
                  let cipher, userPassword;
                  if (revision >= 3) {
                    userPassword = ownerPassword;
                    const derivedKey = new Uint8Array(keyLengthInBytes);
                    for (j = 19; j >= 0; j--) {
                      for (let k = 0; k < keyLengthInBytes; ++k) {
                        derivedKey[k] = hash2[k] ^ j;
                      }
                      cipher = new ARCFourCipher(derivedKey);
                      userPassword = cipher.encryptBlock(userPassword);
                    }
                  } else {
                    cipher = new ARCFourCipher(hash2.subarray(0, keyLengthInBytes));
                    userPassword = cipher.encryptBlock(ownerPassword);
                  }
                  return userPassword;
                }
                #buildObjectKey(num, gen, encryptionKey, isAes = false) {
                  const key2 = new Uint8Array(encryptionKey.length + 9);
                  const n2 = encryptionKey.length;
                  let i;
                  for (i = 0; i < n2; ++i) {
                    key2[i] = encryptionKey[i];
                  }
                  key2[i++] = num & 255;
                  key2[i++] = num >> 8 & 255;
                  key2[i++] = num >> 16 & 255;
                  key2[i++] = gen & 255;
                  key2[i++] = gen >> 8 & 255;
                  if (isAes) {
                    key2[i++] = 115;
                    key2[i++] = 65;
                    key2[i++] = 108;
                    key2[i++] = 84;
                  }
                  const hash2 = calculateMD5(key2, 0, i);
                  return hash2.subarray(0, Math.min(encryptionKey.length + 5, 16));
                }
                #buildCipherConstructor(cf, name, num, gen, key2) {
                  if (!(name instanceof _primitives.Name)) {
                    throw new _util2.FormatError("Invalid crypt filter name.");
                  }
                  const self2 = this;
                  const cryptFilter = cf.get(name.name);
                  const cfm = cryptFilter?.get("CFM");
                  if (!cfm || cfm.name === "None") {
                    return function() {
                      return new NullCipher();
                    };
                  }
                  if (cfm.name === "V2") {
                    return function() {
                      return new ARCFourCipher(self2.#buildObjectKey(num, gen, key2, false));
                    };
                  }
                  if (cfm.name === "AESV2") {
                    return function() {
                      return new AES128Cipher(self2.#buildObjectKey(num, gen, key2, true));
                    };
                  }
                  if (cfm.name === "AESV3") {
                    return function() {
                      return new AES256Cipher(key2);
                    };
                  }
                  throw new _util2.FormatError("Unknown crypto method");
                }
                constructor(dict, fileId, password) {
                  const filter3 = dict.get("Filter");
                  if (!(0, _primitives.isName)(filter3, "Standard")) {
                    throw new _util2.FormatError("unknown encryption method");
                  }
                  this.filterName = filter3.name;
                  this.dict = dict;
                  const algorithm = dict.get("V");
                  if (!Number.isInteger(algorithm) || algorithm !== 1 && algorithm !== 2 && algorithm !== 4 && algorithm !== 5) {
                    throw new _util2.FormatError("unsupported encryption algorithm");
                  }
                  this.algorithm = algorithm;
                  let keyLength = dict.get("Length");
                  if (!keyLength) {
                    if (algorithm <= 3) {
                      keyLength = 40;
                    } else {
                      const cfDict = dict.get("CF");
                      const streamCryptoName = dict.get("StmF");
                      if (cfDict instanceof _primitives.Dict && streamCryptoName instanceof _primitives.Name) {
                        cfDict.suppressEncryption = true;
                        const handlerDict = cfDict.get(streamCryptoName.name);
                        keyLength = handlerDict?.get("Length") || 128;
                        if (keyLength < 40) {
                          keyLength <<= 3;
                        }
                      }
                    }
                  }
                  if (!Number.isInteger(keyLength) || keyLength < 40 || keyLength % 8 !== 0) {
                    throw new _util2.FormatError("invalid key length");
                  }
                  const ownerBytes = (0, _util2.stringToBytes)(dict.get("O")), userBytes = (0, _util2.stringToBytes)(dict.get("U"));
                  const ownerPassword = ownerBytes.subarray(0, 32);
                  const userPassword = userBytes.subarray(0, 32);
                  const flags = dict.get("P");
                  const revision = dict.get("R");
                  const encryptMetadata = (algorithm === 4 || algorithm === 5) && dict.get("EncryptMetadata") !== false;
                  this.encryptMetadata = encryptMetadata;
                  const fileIdBytes = (0, _util2.stringToBytes)(fileId);
                  let passwordBytes;
                  if (password) {
                    if (revision === 6) {
                      try {
                        password = (0, _util2.utf8StringToString)(password);
                      } catch {
                        (0, _util2.warn)("CipherTransformFactory: Unable to convert UTF8 encoded password.");
                      }
                    }
                    passwordBytes = (0, _util2.stringToBytes)(password);
                  }
                  let encryptionKey;
                  if (algorithm !== 5) {
                    encryptionKey = this.#prepareKeyData(fileIdBytes, passwordBytes, ownerPassword, userPassword, flags, revision, keyLength, encryptMetadata);
                  } else {
                    const ownerValidationSalt = ownerBytes.subarray(32, 40);
                    const ownerKeySalt = ownerBytes.subarray(40, 48);
                    const uBytes = userBytes.subarray(0, 48);
                    const userValidationSalt = userBytes.subarray(32, 40);
                    const userKeySalt = userBytes.subarray(40, 48);
                    const ownerEncryption = (0, _util2.stringToBytes)(dict.get("OE"));
                    const userEncryption = (0, _util2.stringToBytes)(dict.get("UE"));
                    const perms = (0, _util2.stringToBytes)(dict.get("Perms"));
                    encryptionKey = this.#createEncryptionKey20(revision, passwordBytes, ownerPassword, ownerValidationSalt, ownerKeySalt, uBytes, userPassword, userValidationSalt, userKeySalt, ownerEncryption, userEncryption, perms);
                  }
                  if (!encryptionKey && !password) {
                    throw new _util2.PasswordException("No password given", _util2.PasswordResponses.NEED_PASSWORD);
                  } else if (!encryptionKey && password) {
                    const decodedPassword = this.#decodeUserPassword(passwordBytes, ownerPassword, revision, keyLength);
                    encryptionKey = this.#prepareKeyData(fileIdBytes, decodedPassword, ownerPassword, userPassword, flags, revision, keyLength, encryptMetadata);
                  }
                  if (!encryptionKey) {
                    throw new _util2.PasswordException("Incorrect Password", _util2.PasswordResponses.INCORRECT_PASSWORD);
                  }
                  this.encryptionKey = encryptionKey;
                  if (algorithm >= 4) {
                    const cf = dict.get("CF");
                    if (cf instanceof _primitives.Dict) {
                      cf.suppressEncryption = true;
                    }
                    this.cf = cf;
                    this.stmf = dict.get("StmF") || _primitives.Name.get("Identity");
                    this.strf = dict.get("StrF") || _primitives.Name.get("Identity");
                    this.eff = dict.get("EFF") || this.stmf;
                  }
                }
                createCipherTransform(num, gen) {
                  if (this.algorithm === 4 || this.algorithm === 5) {
                    return new CipherTransform(this.#buildCipherConstructor(this.cf, this.strf, num, gen, this.encryptionKey), this.#buildCipherConstructor(this.cf, this.stmf, num, gen, this.encryptionKey));
                  }
                  const key2 = this.#buildObjectKey(num, gen, this.encryptionKey, false);
                  const cipherConstructor = function() {
                    return new ARCFourCipher(key2);
                  };
                  return new CipherTransform(cipherConstructor, cipherConstructor);
                }
              }
              exports3.CipherTransformFactory = CipherTransformFactory;
            }),
            /* 75 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.DecryptStream = void 0;
              var _decode_stream = __w_pdfjs_require__3(18);
              const chunkSize = 512;
              class DecryptStream extends _decode_stream.DecodeStream {
                constructor(str, maybeLength, decrypt) {
                  super(maybeLength);
                  this.str = str;
                  this.dict = str.dict;
                  this.decrypt = decrypt;
                  this.nextChunk = null;
                  this.initialized = false;
                }
                readBlock() {
                  let chunk;
                  if (this.initialized) {
                    chunk = this.nextChunk;
                  } else {
                    chunk = this.str.getBytes(chunkSize);
                    this.initialized = true;
                  }
                  if (!chunk || chunk.length === 0) {
                    this.eof = true;
                    return;
                  }
                  this.nextChunk = this.str.getBytes(chunkSize);
                  const hasMoreData = this.nextChunk?.length > 0;
                  const decrypt = this.decrypt;
                  chunk = decrypt(chunk, !hasMoreData);
                  const bufferLength = this.bufferLength, newLength = bufferLength + chunk.length, buffer = this.ensureBuffer(newLength);
                  buffer.set(chunk, bufferLength);
                  this.bufferLength = newLength;
                }
              }
              exports3.DecryptStream = DecryptStream;
            }),
            /* 76 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.ObjectLoader = void 0;
              var _primitives = __w_pdfjs_require__3(4);
              var _base_stream = __w_pdfjs_require__3(5);
              var _core_utils = __w_pdfjs_require__3(3);
              var _util2 = __w_pdfjs_require__3(2);
              function mayHaveChildren(value) {
                return value instanceof _primitives.Ref || value instanceof _primitives.Dict || value instanceof _base_stream.BaseStream || Array.isArray(value);
              }
              function addChildren(node2, nodesToVisit) {
                if (node2 instanceof _primitives.Dict) {
                  node2 = node2.getRawValues();
                } else if (node2 instanceof _base_stream.BaseStream) {
                  node2 = node2.dict.getRawValues();
                } else if (!Array.isArray(node2)) {
                  return;
                }
                for (const rawValue of node2) {
                  if (mayHaveChildren(rawValue)) {
                    nodesToVisit.push(rawValue);
                  }
                }
              }
              class ObjectLoader {
                constructor(dict, keys4, xref) {
                  this.dict = dict;
                  this.keys = keys4;
                  this.xref = xref;
                  this.refSet = null;
                }
                async load() {
                  if (this.xref.stream.isDataLoaded) {
                    return void 0;
                  }
                  const {
                    keys: keys4,
                    dict
                  } = this;
                  this.refSet = new _primitives.RefSet();
                  const nodesToVisit = [];
                  for (const key2 of keys4) {
                    const rawValue = dict.getRaw(key2);
                    if (rawValue !== void 0) {
                      nodesToVisit.push(rawValue);
                    }
                  }
                  return this._walk(nodesToVisit);
                }
                async _walk(nodesToVisit) {
                  const nodesToRevisit = [];
                  const pendingRequests = [];
                  while (nodesToVisit.length) {
                    let currentNode = nodesToVisit.pop();
                    if (currentNode instanceof _primitives.Ref) {
                      if (this.refSet.has(currentNode)) {
                        continue;
                      }
                      try {
                        this.refSet.put(currentNode);
                        currentNode = this.xref.fetch(currentNode);
                      } catch (ex) {
                        if (!(ex instanceof _core_utils.MissingDataException)) {
                          (0, _util2.warn)(`ObjectLoader._walk - requesting all data: "${ex}".`);
                          this.refSet = null;
                          const {
                            manager
                          } = this.xref.stream;
                          return manager.requestAllChunks();
                        }
                        nodesToRevisit.push(currentNode);
                        pendingRequests.push({
                          begin: ex.begin,
                          end: ex.end
                        });
                      }
                    }
                    if (currentNode instanceof _base_stream.BaseStream) {
                      const baseStreams = currentNode.getBaseStreams();
                      if (baseStreams) {
                        let foundMissingData = false;
                        for (const stream of baseStreams) {
                          if (stream.isDataLoaded) {
                            continue;
                          }
                          foundMissingData = true;
                          pendingRequests.push({
                            begin: stream.start,
                            end: stream.end
                          });
                        }
                        if (foundMissingData) {
                          nodesToRevisit.push(currentNode);
                        }
                      }
                    }
                    addChildren(currentNode, nodesToVisit);
                  }
                  if (pendingRequests.length) {
                    await this.xref.stream.manager.requestRanges(pendingRequests);
                    for (const node2 of nodesToRevisit) {
                      if (node2 instanceof _primitives.Ref) {
                        this.refSet.remove(node2);
                      }
                    }
                    return this._walk(nodesToRevisit);
                  }
                  this.refSet = null;
                  return void 0;
                }
              }
              exports3.ObjectLoader = ObjectLoader;
            }),
            /* 77 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.XFAFactory = void 0;
              var _symbol_utils = __w_pdfjs_require__3(78);
              var _bind = __w_pdfjs_require__3(79);
              var _data = __w_pdfjs_require__3(89);
              var _fonts = __w_pdfjs_require__3(85);
              var _utils = __w_pdfjs_require__3(84);
              var _util2 = __w_pdfjs_require__3(2);
              var _parser = __w_pdfjs_require__3(90);
              var _xhtml = __w_pdfjs_require__3(100);
              class XFAFactory {
                constructor(data2) {
                  try {
                    this.root = new _parser.XFAParser().parse(XFAFactory._createDocument(data2));
                    const binder = new _bind.Binder(this.root);
                    this.form = binder.bind();
                    this.dataHandler = new _data.DataHandler(this.root, binder.getData());
                    this.form[_symbol_utils.$globalData].template = this.form;
                  } catch (e3) {
                    (0, _util2.warn)(`XFA - an error occurred during parsing and binding: ${e3}`);
                  }
                }
                isValid() {
                  return this.root && this.form;
                }
                _createPagesHelper() {
                  const iterator = this.form[_symbol_utils.$toPages]();
                  return new Promise((resolve, reject) => {
                    const nextIteration = () => {
                      try {
                        const value = iterator.next();
                        if (value.done) {
                          resolve(value.value);
                        } else {
                          setTimeout(nextIteration, 0);
                        }
                      } catch (e3) {
                        reject(e3);
                      }
                    };
                    setTimeout(nextIteration, 0);
                  });
                }
                async _createPages() {
                  try {
                    this.pages = await this._createPagesHelper();
                    this.dims = this.pages.children.map((c) => {
                      const {
                        width,
                        height
                      } = c.attributes.style;
                      return [0, 0, parseInt(width), parseInt(height)];
                    });
                  } catch (e3) {
                    (0, _util2.warn)(`XFA - an error occurred during layout: ${e3}`);
                  }
                }
                getBoundingBox(pageIndex) {
                  return this.dims[pageIndex];
                }
                async getNumPages() {
                  if (!this.pages) {
                    await this._createPages();
                  }
                  return this.dims.length;
                }
                setImages(images) {
                  this.form[_symbol_utils.$globalData].images = images;
                }
                setFonts(fonts) {
                  this.form[_symbol_utils.$globalData].fontFinder = new _fonts.FontFinder(fonts);
                  const missingFonts = [];
                  for (let typeface of this.form[_symbol_utils.$globalData].usedTypefaces) {
                    typeface = (0, _utils.stripQuotes)(typeface);
                    const font = this.form[_symbol_utils.$globalData].fontFinder.find(typeface);
                    if (!font) {
                      missingFonts.push(typeface);
                    }
                  }
                  if (missingFonts.length > 0) {
                    return missingFonts;
                  }
                  return null;
                }
                appendFonts(fonts, reallyMissingFonts) {
                  this.form[_symbol_utils.$globalData].fontFinder.add(fonts, reallyMissingFonts);
                }
                async getPages() {
                  if (!this.pages) {
                    await this._createPages();
                  }
                  const pages = this.pages;
                  this.pages = null;
                  return pages;
                }
                serializeData(storage) {
                  return this.dataHandler.serialize(storage);
                }
                static _createDocument(data2) {
                  if (!data2["/xdp:xdp"]) {
                    return data2["xdp:xdp"];
                  }
                  return Object.values(data2).join("");
                }
                static getRichTextAsHtml(rc) {
                  if (!rc || typeof rc !== "string") {
                    return null;
                  }
                  try {
                    let root2 = new _parser.XFAParser(_xhtml.XhtmlNamespace, true).parse(rc);
                    if (!["body", "xhtml"].includes(root2[_symbol_utils.$nodeName])) {
                      const newRoot = _xhtml.XhtmlNamespace.body({});
                      newRoot[_symbol_utils.$appendChild](root2);
                      root2 = newRoot;
                    }
                    const result = root2[_symbol_utils.$toHTML]();
                    if (!result.success) {
                      return null;
                    }
                    const {
                      html: html2
                    } = result;
                    const {
                      attributes: attributes2
                    } = html2;
                    if (attributes2) {
                      if (attributes2.class) {
                        attributes2.class = attributes2.class.filter((attr) => !attr.startsWith("xfa"));
                      }
                      attributes2.dir = "auto";
                    }
                    return {
                      html: html2,
                      str: root2[_symbol_utils.$text]()
                    };
                  } catch (e3) {
                    (0, _util2.warn)(`XFA - an error occurred during parsing of rich text: ${e3}`);
                  }
                  return null;
                }
              }
              exports3.XFAFactory = XFAFactory;
            }),
            /* 78 */
            /***/
            ((__unused_webpack_module2, exports3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.$uid = exports3.$toStyle = exports3.$toString = exports3.$toPages = exports3.$toHTML = exports3.$text = exports3.$tabIndex = exports3.$setValue = exports3.$setSetAttributes = exports3.$setId = exports3.$searchNode = exports3.$root = exports3.$resolvePrototypes = exports3.$removeChild = exports3.$pushPara = exports3.$pushGlyphs = exports3.$popPara = exports3.$onText = exports3.$onChildCheck = exports3.$onChild = exports3.$nsAttributes = exports3.$nodeName = exports3.$namespaceId = exports3.$lastAttribute = exports3.$isUsable = exports3.$isTransparent = exports3.$isThereMoreWidth = exports3.$isSplittable = exports3.$isNsAgnostic = exports3.$isDescendent = exports3.$isDataValue = exports3.$isCDATAXml = exports3.$isBindable = exports3.$insertAt = exports3.$indexOf = exports3.$ids = exports3.$hasSettableValue = exports3.$globalData = exports3.$getTemplateRoot = exports3.$getSubformParent = exports3.$getRealChildrenByNameIt = exports3.$getParent = exports3.$getNextPage = exports3.$getExtra = exports3.$getDataValue = exports3.$getContainedChildren = exports3.$getChildrenByNameIt = exports3.$getChildrenByName = exports3.$getChildrenByClass = exports3.$getChildren = exports3.$getAvailableSpace = exports3.$getAttributes = exports3.$getAttributeIt = exports3.$flushHTML = exports3.$finalize = exports3.$extra = exports3.$dump = exports3.$data = exports3.$content = exports3.$consumed = exports3.$clone = exports3.$cleanup = exports3.$cleanPage = exports3.$clean = exports3.$childrenToHTML = exports3.$appendChild = exports3.$addHTML = exports3.$acceptWhitespace = void 0;
              const $acceptWhitespace = Symbol();
              exports3.$acceptWhitespace = $acceptWhitespace;
              const $addHTML = Symbol();
              exports3.$addHTML = $addHTML;
              const $appendChild = Symbol();
              exports3.$appendChild = $appendChild;
              const $childrenToHTML = Symbol();
              exports3.$childrenToHTML = $childrenToHTML;
              const $clean = Symbol();
              exports3.$clean = $clean;
              const $cleanPage = Symbol();
              exports3.$cleanPage = $cleanPage;
              const $cleanup = Symbol();
              exports3.$cleanup = $cleanup;
              const $clone = Symbol();
              exports3.$clone = $clone;
              const $consumed = Symbol();
              exports3.$consumed = $consumed;
              const $content = Symbol("content");
              exports3.$content = $content;
              const $data = Symbol("data");
              exports3.$data = $data;
              const $dump = Symbol();
              exports3.$dump = $dump;
              const $extra = Symbol("extra");
              exports3.$extra = $extra;
              const $finalize = Symbol();
              exports3.$finalize = $finalize;
              const $flushHTML = Symbol();
              exports3.$flushHTML = $flushHTML;
              const $getAttributeIt = Symbol();
              exports3.$getAttributeIt = $getAttributeIt;
              const $getAttributes = Symbol();
              exports3.$getAttributes = $getAttributes;
              const $getAvailableSpace = Symbol();
              exports3.$getAvailableSpace = $getAvailableSpace;
              const $getChildrenByClass = Symbol();
              exports3.$getChildrenByClass = $getChildrenByClass;
              const $getChildrenByName = Symbol();
              exports3.$getChildrenByName = $getChildrenByName;
              const $getChildrenByNameIt = Symbol();
              exports3.$getChildrenByNameIt = $getChildrenByNameIt;
              const $getDataValue = Symbol();
              exports3.$getDataValue = $getDataValue;
              const $getExtra = Symbol();
              exports3.$getExtra = $getExtra;
              const $getRealChildrenByNameIt = Symbol();
              exports3.$getRealChildrenByNameIt = $getRealChildrenByNameIt;
              const $getChildren = Symbol();
              exports3.$getChildren = $getChildren;
              const $getContainedChildren = Symbol();
              exports3.$getContainedChildren = $getContainedChildren;
              const $getNextPage = Symbol();
              exports3.$getNextPage = $getNextPage;
              const $getSubformParent = Symbol();
              exports3.$getSubformParent = $getSubformParent;
              const $getParent = Symbol();
              exports3.$getParent = $getParent;
              const $getTemplateRoot = Symbol();
              exports3.$getTemplateRoot = $getTemplateRoot;
              const $globalData = Symbol();
              exports3.$globalData = $globalData;
              const $hasSettableValue = Symbol();
              exports3.$hasSettableValue = $hasSettableValue;
              const $ids = Symbol();
              exports3.$ids = $ids;
              const $indexOf = Symbol();
              exports3.$indexOf = $indexOf;
              const $insertAt = Symbol();
              exports3.$insertAt = $insertAt;
              const $isCDATAXml = Symbol();
              exports3.$isCDATAXml = $isCDATAXml;
              const $isBindable = Symbol();
              exports3.$isBindable = $isBindable;
              const $isDataValue = Symbol();
              exports3.$isDataValue = $isDataValue;
              const $isDescendent = Symbol();
              exports3.$isDescendent = $isDescendent;
              const $isNsAgnostic = Symbol();
              exports3.$isNsAgnostic = $isNsAgnostic;
              const $isSplittable = Symbol();
              exports3.$isSplittable = $isSplittable;
              const $isThereMoreWidth = Symbol();
              exports3.$isThereMoreWidth = $isThereMoreWidth;
              const $isTransparent = Symbol();
              exports3.$isTransparent = $isTransparent;
              const $isUsable = Symbol();
              exports3.$isUsable = $isUsable;
              const $lastAttribute = Symbol();
              exports3.$lastAttribute = $lastAttribute;
              const $namespaceId = Symbol("namespaceId");
              exports3.$namespaceId = $namespaceId;
              const $nodeName = Symbol("nodeName");
              exports3.$nodeName = $nodeName;
              const $nsAttributes = Symbol();
              exports3.$nsAttributes = $nsAttributes;
              const $onChild = Symbol();
              exports3.$onChild = $onChild;
              const $onChildCheck = Symbol();
              exports3.$onChildCheck = $onChildCheck;
              const $onText = Symbol();
              exports3.$onText = $onText;
              const $pushGlyphs = Symbol();
              exports3.$pushGlyphs = $pushGlyphs;
              const $popPara = Symbol();
              exports3.$popPara = $popPara;
              const $pushPara = Symbol();
              exports3.$pushPara = $pushPara;
              const $removeChild = Symbol();
              exports3.$removeChild = $removeChild;
              const $root = Symbol("root");
              exports3.$root = $root;
              const $resolvePrototypes = Symbol();
              exports3.$resolvePrototypes = $resolvePrototypes;
              const $searchNode = Symbol();
              exports3.$searchNode = $searchNode;
              const $setId = Symbol();
              exports3.$setId = $setId;
              const $setSetAttributes = Symbol();
              exports3.$setSetAttributes = $setSetAttributes;
              const $setValue = Symbol();
              exports3.$setValue = $setValue;
              const $tabIndex = Symbol();
              exports3.$tabIndex = $tabIndex;
              const $text = Symbol();
              exports3.$text = $text;
              const $toPages = Symbol();
              exports3.$toPages = $toPages;
              const $toHTML = Symbol();
              exports3.$toHTML = $toHTML;
              const $toString = Symbol();
              exports3.$toString = $toString;
              const $toStyle = Symbol();
              exports3.$toStyle = $toStyle;
              const $uid = Symbol("uid");
              exports3.$uid = $uid;
            }),
            /* 79 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.Binder = void 0;
              var _symbol_utils = __w_pdfjs_require__3(78);
              var _template = __w_pdfjs_require__3(80);
              var _som = __w_pdfjs_require__3(88);
              var _xfa_object = __w_pdfjs_require__3(87);
              var _namespaces = __w_pdfjs_require__3(81);
              var _util2 = __w_pdfjs_require__3(2);
              const NS_DATASETS = _namespaces.NamespaceIds.datasets.id;
              function createText(content) {
                const node2 = new _template.Text({});
                node2[_symbol_utils.$content] = content;
                return node2;
              }
              class Binder {
                constructor(root2) {
                  this.root = root2;
                  this.datasets = root2.datasets;
                  this.data = root2.datasets?.data || new _xfa_object.XmlObject(_namespaces.NamespaceIds.datasets.id, "data");
                  this.emptyMerge = this.data[_symbol_utils.$getChildren]().length === 0;
                  this.root.form = this.form = root2.template[_symbol_utils.$clone]();
                }
                _isConsumeData() {
                  return !this.emptyMerge && this._mergeMode;
                }
                _isMatchTemplate() {
                  return !this._isConsumeData();
                }
                bind() {
                  this._bindElement(this.form, this.data);
                  return this.form;
                }
                getData() {
                  return this.data;
                }
                _bindValue(formNode, data2, picture) {
                  formNode[_symbol_utils.$data] = data2;
                  if (formNode[_symbol_utils.$hasSettableValue]()) {
                    if (data2[_symbol_utils.$isDataValue]()) {
                      const value = data2[_symbol_utils.$getDataValue]();
                      formNode[_symbol_utils.$setValue](createText(value));
                    } else if (formNode instanceof _template.Field && formNode.ui?.choiceList?.open === "multiSelect") {
                      const value = data2[_symbol_utils.$getChildren]().map((child) => child[_symbol_utils.$content].trim()).join("\n");
                      formNode[_symbol_utils.$setValue](createText(value));
                    } else if (this._isConsumeData()) {
                      (0, _util2.warn)(`XFA - Nodes haven't the same type.`);
                    }
                  } else if (!data2[_symbol_utils.$isDataValue]() || this._isMatchTemplate()) {
                    this._bindElement(formNode, data2);
                  } else {
                    (0, _util2.warn)(`XFA - Nodes haven't the same type.`);
                  }
                }
                _findDataByNameToConsume(name, isValue, dataNode, global2) {
                  if (!name) {
                    return null;
                  }
                  let generator, match2;
                  for (let i = 0; i < 3; i++) {
                    generator = dataNode[_symbol_utils.$getRealChildrenByNameIt](name, false, true);
                    while (true) {
                      match2 = generator.next().value;
                      if (!match2) {
                        break;
                      }
                      if (isValue === match2[_symbol_utils.$isDataValue]()) {
                        return match2;
                      }
                    }
                    if (dataNode[_symbol_utils.$namespaceId] === _namespaces.NamespaceIds.datasets.id && dataNode[_symbol_utils.$nodeName] === "data") {
                      break;
                    }
                    dataNode = dataNode[_symbol_utils.$getParent]();
                  }
                  if (!global2) {
                    return null;
                  }
                  generator = this.data[_symbol_utils.$getRealChildrenByNameIt](name, true, false);
                  match2 = generator.next().value;
                  if (match2) {
                    return match2;
                  }
                  generator = this.data[_symbol_utils.$getAttributeIt](name, true);
                  match2 = generator.next().value;
                  if (match2?.[_symbol_utils.$isDataValue]()) {
                    return match2;
                  }
                  return null;
                }
                _setProperties(formNode, dataNode) {
                  if (!formNode.hasOwnProperty("setProperty")) {
                    return;
                  }
                  for (const {
                    ref: ref3,
                    target,
                    connection
                  } of formNode.setProperty.children) {
                    if (connection) {
                      continue;
                    }
                    if (!ref3) {
                      continue;
                    }
                    const nodes = (0, _som.searchNode)(this.root, dataNode, ref3, false, false);
                    if (!nodes) {
                      (0, _util2.warn)(`XFA - Invalid reference: ${ref3}.`);
                      continue;
                    }
                    const [node2] = nodes;
                    if (!node2[_symbol_utils.$isDescendent](this.data)) {
                      (0, _util2.warn)(`XFA - Invalid node: must be a data node.`);
                      continue;
                    }
                    const targetNodes = (0, _som.searchNode)(this.root, formNode, target, false, false);
                    if (!targetNodes) {
                      (0, _util2.warn)(`XFA - Invalid target: ${target}.`);
                      continue;
                    }
                    const [targetNode] = targetNodes;
                    if (!targetNode[_symbol_utils.$isDescendent](formNode)) {
                      (0, _util2.warn)(`XFA - Invalid target: must be a property or subproperty.`);
                      continue;
                    }
                    const targetParent = targetNode[_symbol_utils.$getParent]();
                    if (targetNode instanceof _template.SetProperty || targetParent instanceof _template.SetProperty) {
                      (0, _util2.warn)(`XFA - Invalid target: cannot be a setProperty or one of its properties.`);
                      continue;
                    }
                    if (targetNode instanceof _template.BindItems || targetParent instanceof _template.BindItems) {
                      (0, _util2.warn)(`XFA - Invalid target: cannot be a bindItems or one of its properties.`);
                      continue;
                    }
                    const content = node2[_symbol_utils.$text]();
                    const name = targetNode[_symbol_utils.$nodeName];
                    if (targetNode instanceof _xfa_object.XFAAttribute) {
                      const attrs = /* @__PURE__ */ Object.create(null);
                      attrs[name] = content;
                      const obj = Reflect.construct(Object.getPrototypeOf(targetParent).constructor, [attrs]);
                      targetParent[name] = obj[name];
                      continue;
                    }
                    if (!targetNode.hasOwnProperty(_symbol_utils.$content)) {
                      (0, _util2.warn)(`XFA - Invalid node to use in setProperty`);
                      continue;
                    }
                    targetNode[_symbol_utils.$data] = node2;
                    targetNode[_symbol_utils.$content] = content;
                    targetNode[_symbol_utils.$finalize]();
                  }
                }
                _bindItems(formNode, dataNode) {
                  if (!formNode.hasOwnProperty("items") || !formNode.hasOwnProperty("bindItems") || formNode.bindItems.isEmpty()) {
                    return;
                  }
                  for (const item of formNode.items.children) {
                    formNode[_symbol_utils.$removeChild](item);
                  }
                  formNode.items.clear();
                  const labels = new _template.Items({});
                  const values = new _template.Items({});
                  formNode[_symbol_utils.$appendChild](labels);
                  formNode.items.push(labels);
                  formNode[_symbol_utils.$appendChild](values);
                  formNode.items.push(values);
                  for (const {
                    ref: ref3,
                    labelRef,
                    valueRef,
                    connection
                  } of formNode.bindItems.children) {
                    if (connection) {
                      continue;
                    }
                    if (!ref3) {
                      continue;
                    }
                    const nodes = (0, _som.searchNode)(this.root, dataNode, ref3, false, false);
                    if (!nodes) {
                      (0, _util2.warn)(`XFA - Invalid reference: ${ref3}.`);
                      continue;
                    }
                    for (const node2 of nodes) {
                      if (!node2[_symbol_utils.$isDescendent](this.datasets)) {
                        (0, _util2.warn)(`XFA - Invalid ref (${ref3}): must be a datasets child.`);
                        continue;
                      }
                      const labelNodes = (0, _som.searchNode)(this.root, node2, labelRef, true, false);
                      if (!labelNodes) {
                        (0, _util2.warn)(`XFA - Invalid label: ${labelRef}.`);
                        continue;
                      }
                      const [labelNode] = labelNodes;
                      if (!labelNode[_symbol_utils.$isDescendent](this.datasets)) {
                        (0, _util2.warn)(`XFA - Invalid label: must be a datasets child.`);
                        continue;
                      }
                      const valueNodes = (0, _som.searchNode)(this.root, node2, valueRef, true, false);
                      if (!valueNodes) {
                        (0, _util2.warn)(`XFA - Invalid value: ${valueRef}.`);
                        continue;
                      }
                      const [valueNode] = valueNodes;
                      if (!valueNode[_symbol_utils.$isDescendent](this.datasets)) {
                        (0, _util2.warn)(`XFA - Invalid value: must be a datasets child.`);
                        continue;
                      }
                      const label = createText(labelNode[_symbol_utils.$text]());
                      const value = createText(valueNode[_symbol_utils.$text]());
                      labels[_symbol_utils.$appendChild](label);
                      labels.text.push(label);
                      values[_symbol_utils.$appendChild](value);
                      values.text.push(value);
                    }
                  }
                }
                _bindOccurrences(formNode, matches, picture) {
                  let baseClone2;
                  if (matches.length > 1) {
                    baseClone2 = formNode[_symbol_utils.$clone]();
                    baseClone2[_symbol_utils.$removeChild](baseClone2.occur);
                    baseClone2.occur = null;
                  }
                  this._bindValue(formNode, matches[0], picture);
                  this._setProperties(formNode, matches[0]);
                  this._bindItems(formNode, matches[0]);
                  if (matches.length === 1) {
                    return;
                  }
                  const parent2 = formNode[_symbol_utils.$getParent]();
                  const name = formNode[_symbol_utils.$nodeName];
                  const pos = parent2[_symbol_utils.$indexOf](formNode);
                  for (let i = 1, ii = matches.length; i < ii; i++) {
                    const match2 = matches[i];
                    const clone = baseClone2[_symbol_utils.$clone]();
                    parent2[name].push(clone);
                    parent2[_symbol_utils.$insertAt](pos + i, clone);
                    this._bindValue(clone, match2, picture);
                    this._setProperties(clone, match2);
                    this._bindItems(clone, match2);
                  }
                }
                _createOccurrences(formNode) {
                  if (!this.emptyMerge) {
                    return;
                  }
                  const {
                    occur
                  } = formNode;
                  if (!occur || occur.initial <= 1) {
                    return;
                  }
                  const parent2 = formNode[_symbol_utils.$getParent]();
                  const name = formNode[_symbol_utils.$nodeName];
                  if (!(parent2[name] instanceof _xfa_object.XFAObjectArray)) {
                    return;
                  }
                  let currentNumber;
                  if (formNode.name) {
                    currentNumber = parent2[name].children.filter((e3) => e3.name === formNode.name).length;
                  } else {
                    currentNumber = parent2[name].children.length;
                  }
                  const pos = parent2[_symbol_utils.$indexOf](formNode) + 1;
                  const ii = occur.initial - currentNumber;
                  if (ii) {
                    const nodeClone = formNode[_symbol_utils.$clone]();
                    nodeClone[_symbol_utils.$removeChild](nodeClone.occur);
                    nodeClone.occur = null;
                    parent2[name].push(nodeClone);
                    parent2[_symbol_utils.$insertAt](pos, nodeClone);
                    for (let i = 1; i < ii; i++) {
                      const clone = nodeClone[_symbol_utils.$clone]();
                      parent2[name].push(clone);
                      parent2[_symbol_utils.$insertAt](pos + i, clone);
                    }
                  }
                }
                _getOccurInfo(formNode) {
                  const {
                    name,
                    occur
                  } = formNode;
                  if (!occur || !name) {
                    return [1, 1];
                  }
                  const max = occur.max === -1 ? Infinity : occur.max;
                  return [occur.min, max];
                }
                _setAndBind(formNode, dataNode) {
                  this._setProperties(formNode, dataNode);
                  this._bindItems(formNode, dataNode);
                  this._bindElement(formNode, dataNode);
                }
                _bindElement(formNode, dataNode) {
                  const uselessNodes = [];
                  this._createOccurrences(formNode);
                  for (const child of formNode[_symbol_utils.$getChildren]()) {
                    if (child[_symbol_utils.$data]) {
                      continue;
                    }
                    if (this._mergeMode === void 0 && child[_symbol_utils.$nodeName] === "subform") {
                      this._mergeMode = child.mergeMode === "consumeData";
                      const dataChildren = dataNode[_symbol_utils.$getChildren]();
                      if (dataChildren.length > 0) {
                        this._bindOccurrences(child, [dataChildren[0]], null);
                      } else if (this.emptyMerge) {
                        const nsId = dataNode[_symbol_utils.$namespaceId] === NS_DATASETS ? -1 : dataNode[_symbol_utils.$namespaceId];
                        const dataChild = child[_symbol_utils.$data] = new _xfa_object.XmlObject(nsId, child.name || "root");
                        dataNode[_symbol_utils.$appendChild](dataChild);
                        this._bindElement(child, dataChild);
                      }
                      continue;
                    }
                    if (!child[_symbol_utils.$isBindable]()) {
                      continue;
                    }
                    let global2 = false;
                    let picture = null;
                    let ref3 = null;
                    let match2 = null;
                    if (child.bind) {
                      switch (child.bind.match) {
                        case "none":
                          this._setAndBind(child, dataNode);
                          continue;
                        case "global":
                          global2 = true;
                          break;
                        case "dataRef":
                          if (!child.bind.ref) {
                            (0, _util2.warn)(`XFA - ref is empty in node ${child[_symbol_utils.$nodeName]}.`);
                            this._setAndBind(child, dataNode);
                            continue;
                          }
                          ref3 = child.bind.ref;
                          break;
                        default:
                          break;
                      }
                      if (child.bind.picture) {
                        picture = child.bind.picture[_symbol_utils.$content];
                      }
                    }
                    const [min, max] = this._getOccurInfo(child);
                    if (ref3) {
                      match2 = (0, _som.searchNode)(this.root, dataNode, ref3, true, false);
                      if (match2 === null) {
                        match2 = (0, _som.createDataNode)(this.data, dataNode, ref3);
                        if (!match2) {
                          continue;
                        }
                        if (this._isConsumeData()) {
                          match2[_symbol_utils.$consumed] = true;
                        }
                        this._setAndBind(child, match2);
                        continue;
                      } else {
                        if (this._isConsumeData()) {
                          match2 = match2.filter((node2) => !node2[_symbol_utils.$consumed]);
                        }
                        if (match2.length > max) {
                          match2 = match2.slice(0, max);
                        } else if (match2.length === 0) {
                          match2 = null;
                        }
                        if (match2 && this._isConsumeData()) {
                          match2.forEach((node2) => {
                            node2[_symbol_utils.$consumed] = true;
                          });
                        }
                      }
                    } else {
                      if (!child.name) {
                        this._setAndBind(child, dataNode);
                        continue;
                      }
                      if (this._isConsumeData()) {
                        const matches = [];
                        while (matches.length < max) {
                          const found = this._findDataByNameToConsume(child.name, child[_symbol_utils.$hasSettableValue](), dataNode, global2);
                          if (!found) {
                            break;
                          }
                          found[_symbol_utils.$consumed] = true;
                          matches.push(found);
                        }
                        match2 = matches.length > 0 ? matches : null;
                      } else {
                        match2 = dataNode[_symbol_utils.$getRealChildrenByNameIt](child.name, false, this.emptyMerge).next().value;
                        if (!match2) {
                          if (min === 0) {
                            uselessNodes.push(child);
                            continue;
                          }
                          const nsId = dataNode[_symbol_utils.$namespaceId] === NS_DATASETS ? -1 : dataNode[_symbol_utils.$namespaceId];
                          match2 = child[_symbol_utils.$data] = new _xfa_object.XmlObject(nsId, child.name);
                          if (this.emptyMerge) {
                            match2[_symbol_utils.$consumed] = true;
                          }
                          dataNode[_symbol_utils.$appendChild](match2);
                          this._setAndBind(child, match2);
                          continue;
                        }
                        if (this.emptyMerge) {
                          match2[_symbol_utils.$consumed] = true;
                        }
                        match2 = [match2];
                      }
                    }
                    if (match2) {
                      this._bindOccurrences(child, match2, picture);
                    } else if (min > 0) {
                      this._setAndBind(child, dataNode);
                    } else {
                      uselessNodes.push(child);
                    }
                  }
                  uselessNodes.forEach((node2) => node2[_symbol_utils.$getParent]()[_symbol_utils.$removeChild](node2));
                }
              }
              exports3.Binder = Binder;
            }),
            /* 80 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.Value = exports3.Text = exports3.TemplateNamespace = exports3.Template = exports3.SetProperty = exports3.Items = exports3.Field = exports3.BindItems = void 0;
              var _symbol_utils = __w_pdfjs_require__3(78);
              var _namespaces = __w_pdfjs_require__3(81);
              var _layout = __w_pdfjs_require__3(82);
              var _html_utils = __w_pdfjs_require__3(83);
              var _xfa_object = __w_pdfjs_require__3(87);
              var _utils = __w_pdfjs_require__3(84);
              var _util2 = __w_pdfjs_require__3(2);
              var _fonts = __w_pdfjs_require__3(85);
              var _core_utils = __w_pdfjs_require__3(3);
              var _som = __w_pdfjs_require__3(88);
              const TEMPLATE_NS_ID = _namespaces.NamespaceIds.template.id;
              const SVG_NS = "http://www.w3.org/2000/svg";
              const MAX_ATTEMPTS_FOR_LRTB_LAYOUT = 2;
              const MAX_EMPTY_PAGES = 3;
              const DEFAULT_TAB_INDEX = 5e3;
              const HEADING_PATTERN = /^H(\d+)$/;
              const MIMES = /* @__PURE__ */ new Set(["image/gif", "image/jpeg", "image/jpg", "image/pjpeg", "image/png", "image/apng", "image/x-png", "image/bmp", "image/x-ms-bmp", "image/tiff", "image/tif", "application/octet-stream"]);
              const IMAGES_HEADERS = [[[66, 77], "image/bmp"], [[255, 216, 255], "image/jpeg"], [[73, 73, 42, 0], "image/tiff"], [[77, 77, 0, 42], "image/tiff"], [[71, 73, 70, 56, 57, 97], "image/gif"], [[137, 80, 78, 71, 13, 10, 26, 10], "image/png"]];
              function getBorderDims(node2) {
                if (!node2 || !node2.border) {
                  return {
                    w: 0,
                    h: 0
                  };
                }
                const borderExtra = node2.border[_symbol_utils.$getExtra]();
                if (!borderExtra) {
                  return {
                    w: 0,
                    h: 0
                  };
                }
                return {
                  w: borderExtra.widths[0] + borderExtra.widths[2] + borderExtra.insets[0] + borderExtra.insets[2],
                  h: borderExtra.widths[1] + borderExtra.widths[3] + borderExtra.insets[1] + borderExtra.insets[3]
                };
              }
              function hasMargin(node2) {
                return node2.margin && (node2.margin.topInset || node2.margin.rightInset || node2.margin.bottomInset || node2.margin.leftInset);
              }
              function _setValue(templateNode, value) {
                if (!templateNode.value) {
                  const nodeValue = new Value({});
                  templateNode[_symbol_utils.$appendChild](nodeValue);
                  templateNode.value = nodeValue;
                }
                templateNode.value[_symbol_utils.$setValue](value);
              }
              function* getContainedChildren(node2) {
                for (const child of node2[_symbol_utils.$getChildren]()) {
                  if (child instanceof SubformSet) {
                    yield* child[_symbol_utils.$getContainedChildren]();
                    continue;
                  }
                  yield child;
                }
              }
              function isRequired(node2) {
                return node2.validate?.nullTest === "error";
              }
              function setTabIndex(node2) {
                while (node2) {
                  if (!node2.traversal) {
                    node2[_symbol_utils.$tabIndex] = node2[_symbol_utils.$getParent]()[_symbol_utils.$tabIndex];
                    return;
                  }
                  if (node2[_symbol_utils.$tabIndex]) {
                    return;
                  }
                  let next2 = null;
                  for (const child of node2.traversal[_symbol_utils.$getChildren]()) {
                    if (child.operation === "next") {
                      next2 = child;
                      break;
                    }
                  }
                  if (!next2 || !next2.ref) {
                    node2[_symbol_utils.$tabIndex] = node2[_symbol_utils.$getParent]()[_symbol_utils.$tabIndex];
                    return;
                  }
                  const root2 = node2[_symbol_utils.$getTemplateRoot]();
                  node2[_symbol_utils.$tabIndex] = ++root2[_symbol_utils.$tabIndex];
                  const ref3 = root2[_symbol_utils.$searchNode](next2.ref, node2);
                  if (!ref3) {
                    return;
                  }
                  node2 = ref3[0];
                }
              }
              function applyAssist(obj, attributes2) {
                const assist = obj.assist;
                if (assist) {
                  const assistTitle = assist[_symbol_utils.$toHTML]();
                  if (assistTitle) {
                    attributes2.title = assistTitle;
                  }
                  const role = assist.role;
                  const match2 = role.match(HEADING_PATTERN);
                  if (match2) {
                    const ariaRole = "heading";
                    const ariaLevel = match2[1];
                    attributes2.role = ariaRole;
                    attributes2["aria-level"] = ariaLevel;
                  }
                }
                if (obj.layout === "table") {
                  attributes2.role = "table";
                } else if (obj.layout === "row") {
                  attributes2.role = "row";
                } else {
                  const parent2 = obj[_symbol_utils.$getParent]();
                  if (parent2.layout === "row") {
                    attributes2.role = parent2.assist?.role === "TH" ? "columnheader" : "cell";
                  }
                }
              }
              function ariaLabel(obj) {
                if (!obj.assist) {
                  return null;
                }
                const assist = obj.assist;
                if (assist.speak && assist.speak[_symbol_utils.$content] !== "") {
                  return assist.speak[_symbol_utils.$content];
                }
                if (assist.toolTip) {
                  return assist.toolTip[_symbol_utils.$content];
                }
                return null;
              }
              function valueToHtml(value) {
                return _utils.HTMLResult.success({
                  name: "div",
                  attributes: {
                    class: ["xfaRich"],
                    style: /* @__PURE__ */ Object.create(null)
                  },
                  children: [{
                    name: "span",
                    attributes: {
                      style: /* @__PURE__ */ Object.create(null)
                    },
                    value
                  }]
                });
              }
              function setFirstUnsplittable(node2) {
                const root2 = node2[_symbol_utils.$getTemplateRoot]();
                if (root2[_symbol_utils.$extra].firstUnsplittable === null) {
                  root2[_symbol_utils.$extra].firstUnsplittable = node2;
                  root2[_symbol_utils.$extra].noLayoutFailure = true;
                }
              }
              function unsetFirstUnsplittable(node2) {
                const root2 = node2[_symbol_utils.$getTemplateRoot]();
                if (root2[_symbol_utils.$extra].firstUnsplittable === node2) {
                  root2[_symbol_utils.$extra].noLayoutFailure = false;
                }
              }
              function handleBreak(node2) {
                if (node2[_symbol_utils.$extra]) {
                  return false;
                }
                node2[_symbol_utils.$extra] = /* @__PURE__ */ Object.create(null);
                if (node2.targetType === "auto") {
                  return false;
                }
                const root2 = node2[_symbol_utils.$getTemplateRoot]();
                let target = null;
                if (node2.target) {
                  target = root2[_symbol_utils.$searchNode](node2.target, node2[_symbol_utils.$getParent]());
                  if (!target) {
                    return false;
                  }
                  target = target[0];
                }
                const {
                  currentPageArea,
                  currentContentArea
                } = root2[_symbol_utils.$extra];
                if (node2.targetType === "pageArea") {
                  if (!(target instanceof PageArea)) {
                    target = null;
                  }
                  if (node2.startNew) {
                    node2[_symbol_utils.$extra].target = target || currentPageArea;
                    return true;
                  } else if (target && target !== currentPageArea) {
                    node2[_symbol_utils.$extra].target = target;
                    return true;
                  }
                  return false;
                }
                if (!(target instanceof ContentArea)) {
                  target = null;
                }
                const pageArea = target && target[_symbol_utils.$getParent]();
                let index3;
                let nextPageArea = pageArea;
                if (node2.startNew) {
                  if (target) {
                    const contentAreas = pageArea.contentArea.children;
                    const indexForCurrent = contentAreas.indexOf(currentContentArea);
                    const indexForTarget = contentAreas.indexOf(target);
                    if (indexForCurrent !== -1 && indexForCurrent < indexForTarget) {
                      nextPageArea = null;
                    }
                    index3 = indexForTarget - 1;
                  } else {
                    index3 = currentPageArea.contentArea.children.indexOf(currentContentArea);
                  }
                } else if (target && target !== currentContentArea) {
                  const contentAreas = pageArea.contentArea.children;
                  index3 = contentAreas.indexOf(target) - 1;
                  nextPageArea = pageArea === currentPageArea ? null : pageArea;
                } else {
                  return false;
                }
                node2[_symbol_utils.$extra].target = nextPageArea;
                node2[_symbol_utils.$extra].index = index3;
                return true;
              }
              function handleOverflow(node2, extraNode, space) {
                const root2 = node2[_symbol_utils.$getTemplateRoot]();
                const saved = root2[_symbol_utils.$extra].noLayoutFailure;
                const savedMethod = extraNode[_symbol_utils.$getSubformParent];
                extraNode[_symbol_utils.$getSubformParent] = () => node2;
                root2[_symbol_utils.$extra].noLayoutFailure = true;
                const res = extraNode[_symbol_utils.$toHTML](space);
                node2[_symbol_utils.$addHTML](res.html, res.bbox);
                root2[_symbol_utils.$extra].noLayoutFailure = saved;
                extraNode[_symbol_utils.$getSubformParent] = savedMethod;
              }
              class AppearanceFilter extends _xfa_object.StringObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "appearanceFilter");
                  this.id = attributes2.id || "";
                  this.type = (0, _utils.getStringOption)(attributes2.type, ["optional", "required"]);
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                }
              }
              class Arc extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "arc", true);
                  this.circular = (0, _utils.getInteger)({
                    data: attributes2.circular,
                    defaultValue: 0,
                    validate: (x) => x === 1
                  });
                  this.hand = (0, _utils.getStringOption)(attributes2.hand, ["even", "left", "right"]);
                  this.id = attributes2.id || "";
                  this.startAngle = (0, _utils.getFloat)({
                    data: attributes2.startAngle,
                    defaultValue: 0,
                    validate: (x) => true
                  });
                  this.sweepAngle = (0, _utils.getFloat)({
                    data: attributes2.sweepAngle,
                    defaultValue: 360,
                    validate: (x) => true
                  });
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                  this.edge = null;
                  this.fill = null;
                }
                [_symbol_utils.$toHTML]() {
                  const edge = this.edge || new Edge({});
                  const edgeStyle = edge[_symbol_utils.$toStyle]();
                  const style2 = /* @__PURE__ */ Object.create(null);
                  if (this.fill?.presence === "visible") {
                    Object.assign(style2, this.fill[_symbol_utils.$toStyle]());
                  } else {
                    style2.fill = "transparent";
                  }
                  style2.strokeWidth = (0, _html_utils.measureToString)(edge.presence === "visible" ? edge.thickness : 0);
                  style2.stroke = edgeStyle.color;
                  let arc;
                  const attributes2 = {
                    xmlns: SVG_NS,
                    style: {
                      width: "100%",
                      height: "100%",
                      overflow: "visible"
                    }
                  };
                  if (this.sweepAngle === 360) {
                    arc = {
                      name: "ellipse",
                      attributes: {
                        xmlns: SVG_NS,
                        cx: "50%",
                        cy: "50%",
                        rx: "50%",
                        ry: "50%",
                        style: style2
                      }
                    };
                  } else {
                    const startAngle = this.startAngle * Math.PI / 180;
                    const sweepAngle = this.sweepAngle * Math.PI / 180;
                    const largeArc = this.sweepAngle > 180 ? 1 : 0;
                    const [x1, y1, x2, y2] = [50 * (1 + Math.cos(startAngle)), 50 * (1 - Math.sin(startAngle)), 50 * (1 + Math.cos(startAngle + sweepAngle)), 50 * (1 - Math.sin(startAngle + sweepAngle))];
                    arc = {
                      name: "path",
                      attributes: {
                        xmlns: SVG_NS,
                        d: `M ${x1} ${y1} A 50 50 0 ${largeArc} 0 ${x2} ${y2}`,
                        vectorEffect: "non-scaling-stroke",
                        style: style2
                      }
                    };
                    Object.assign(attributes2, {
                      viewBox: "0 0 100 100",
                      preserveAspectRatio: "none"
                    });
                  }
                  const svg = {
                    name: "svg",
                    children: [arc],
                    attributes: attributes2
                  };
                  const parent2 = this[_symbol_utils.$getParent]()[_symbol_utils.$getParent]();
                  if (hasMargin(parent2)) {
                    return _utils.HTMLResult.success({
                      name: "div",
                      attributes: {
                        style: {
                          display: "inline",
                          width: "100%",
                          height: "100%"
                        }
                      },
                      children: [svg]
                    });
                  }
                  svg.attributes.style.position = "absolute";
                  return _utils.HTMLResult.success(svg);
                }
              }
              class Area extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "area", true);
                  this.colSpan = (0, _utils.getInteger)({
                    data: attributes2.colSpan,
                    defaultValue: 1,
                    validate: (n2) => n2 >= 1 || n2 === -1
                  });
                  this.id = attributes2.id || "";
                  this.name = attributes2.name || "";
                  this.relevant = (0, _utils.getRelevant)(attributes2.relevant);
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                  this.x = (0, _utils.getMeasurement)(attributes2.x, "0pt");
                  this.y = (0, _utils.getMeasurement)(attributes2.y, "0pt");
                  this.desc = null;
                  this.extras = null;
                  this.area = new _xfa_object.XFAObjectArray();
                  this.draw = new _xfa_object.XFAObjectArray();
                  this.exObject = new _xfa_object.XFAObjectArray();
                  this.exclGroup = new _xfa_object.XFAObjectArray();
                  this.field = new _xfa_object.XFAObjectArray();
                  this.subform = new _xfa_object.XFAObjectArray();
                  this.subformSet = new _xfa_object.XFAObjectArray();
                }
                *[_symbol_utils.$getContainedChildren]() {
                  yield* getContainedChildren(this);
                }
                [_symbol_utils.$isTransparent]() {
                  return true;
                }
                [_symbol_utils.$isBindable]() {
                  return true;
                }
                [_symbol_utils.$addHTML](html2, bbox) {
                  const [x, y, w, h2] = bbox;
                  this[_symbol_utils.$extra].width = Math.max(this[_symbol_utils.$extra].width, x + w);
                  this[_symbol_utils.$extra].height = Math.max(this[_symbol_utils.$extra].height, y + h2);
                  this[_symbol_utils.$extra].children.push(html2);
                }
                [_symbol_utils.$getAvailableSpace]() {
                  return this[_symbol_utils.$extra].availableSpace;
                }
                [_symbol_utils.$toHTML](availableSpace) {
                  const style2 = (0, _html_utils.toStyle)(this, "position");
                  const attributes2 = {
                    style: style2,
                    id: this[_symbol_utils.$uid],
                    class: ["xfaArea"]
                  };
                  if ((0, _html_utils.isPrintOnly)(this)) {
                    attributes2.class.push("xfaPrintOnly");
                  }
                  if (this.name) {
                    attributes2.xfaName = this.name;
                  }
                  const children = [];
                  this[_symbol_utils.$extra] = {
                    children,
                    width: 0,
                    height: 0,
                    availableSpace
                  };
                  const result = this[_symbol_utils.$childrenToHTML]({
                    filter: /* @__PURE__ */ new Set(["area", "draw", "field", "exclGroup", "subform", "subformSet"]),
                    include: true
                  });
                  if (!result.success) {
                    if (result.isBreak()) {
                      return result;
                    }
                    delete this[_symbol_utils.$extra];
                    return _utils.HTMLResult.FAILURE;
                  }
                  style2.width = (0, _html_utils.measureToString)(this[_symbol_utils.$extra].width);
                  style2.height = (0, _html_utils.measureToString)(this[_symbol_utils.$extra].height);
                  const html2 = {
                    name: "div",
                    attributes: attributes2,
                    children
                  };
                  const bbox = [this.x, this.y, this[_symbol_utils.$extra].width, this[_symbol_utils.$extra].height];
                  delete this[_symbol_utils.$extra];
                  return _utils.HTMLResult.success(html2, bbox);
                }
              }
              class Assist extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "assist", true);
                  this.id = attributes2.id || "";
                  this.role = attributes2.role || "";
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                  this.speak = null;
                  this.toolTip = null;
                }
                [_symbol_utils.$toHTML]() {
                  return this.toolTip?.[_symbol_utils.$content] || null;
                }
              }
              class Barcode extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "barcode", true);
                  this.charEncoding = (0, _utils.getKeyword)({
                    data: attributes2.charEncoding ? attributes2.charEncoding.toLowerCase() : "",
                    defaultValue: "",
                    validate: (k) => ["utf-8", "big-five", "fontspecific", "gbk", "gb-18030", "gb-2312", "ksc-5601", "none", "shift-jis", "ucs-2", "utf-16"].includes(k) || k.match(/iso-8859-\d{2}/)
                  });
                  this.checksum = (0, _utils.getStringOption)(attributes2.checksum, ["none", "1mod10", "1mod10_1mod11", "2mod10", "auto"]);
                  this.dataColumnCount = (0, _utils.getInteger)({
                    data: attributes2.dataColumnCount,
                    defaultValue: -1,
                    validate: (x) => x >= 0
                  });
                  this.dataLength = (0, _utils.getInteger)({
                    data: attributes2.dataLength,
                    defaultValue: -1,
                    validate: (x) => x >= 0
                  });
                  this.dataPrep = (0, _utils.getStringOption)(attributes2.dataPrep, ["none", "flateCompress"]);
                  this.dataRowCount = (0, _utils.getInteger)({
                    data: attributes2.dataRowCount,
                    defaultValue: -1,
                    validate: (x) => x >= 0
                  });
                  this.endChar = attributes2.endChar || "";
                  this.errorCorrectionLevel = (0, _utils.getInteger)({
                    data: attributes2.errorCorrectionLevel,
                    defaultValue: -1,
                    validate: (x) => x >= 0 && x <= 8
                  });
                  this.id = attributes2.id || "";
                  this.moduleHeight = (0, _utils.getMeasurement)(attributes2.moduleHeight, "5mm");
                  this.moduleWidth = (0, _utils.getMeasurement)(attributes2.moduleWidth, "0.25mm");
                  this.printCheckDigit = (0, _utils.getInteger)({
                    data: attributes2.printCheckDigit,
                    defaultValue: 0,
                    validate: (x) => x === 1
                  });
                  this.rowColumnRatio = (0, _utils.getRatio)(attributes2.rowColumnRatio);
                  this.startChar = attributes2.startChar || "";
                  this.textLocation = (0, _utils.getStringOption)(attributes2.textLocation, ["below", "above", "aboveEmbedded", "belowEmbedded", "none"]);
                  this.truncate = (0, _utils.getInteger)({
                    data: attributes2.truncate,
                    defaultValue: 0,
                    validate: (x) => x === 1
                  });
                  this.type = (0, _utils.getStringOption)(attributes2.type ? attributes2.type.toLowerCase() : "", ["aztec", "codabar", "code2of5industrial", "code2of5interleaved", "code2of5matrix", "code2of5standard", "code3of9", "code3of9extended", "code11", "code49", "code93", "code128", "code128a", "code128b", "code128c", "code128sscc", "datamatrix", "ean8", "ean8add2", "ean8add5", "ean13", "ean13add2", "ean13add5", "ean13pwcd", "fim", "logmars", "maxicode", "msi", "pdf417", "pdf417macro", "plessey", "postauscust2", "postauscust3", "postausreplypaid", "postausstandard", "postukrm4scc", "postusdpbc", "postusimb", "postusstandard", "postus5zip", "qrcode", "rfid", "rss14", "rss14expanded", "rss14limited", "rss14stacked", "rss14stackedomni", "rss14truncated", "telepen", "ucc128", "ucc128random", "ucc128sscc", "upca", "upcaadd2", "upcaadd5", "upcapwcd", "upce", "upceadd2", "upceadd5", "upcean2", "upcean5", "upsmaxicode"]);
                  this.upsMode = (0, _utils.getStringOption)(attributes2.upsMode, ["usCarrier", "internationalCarrier", "secureSymbol", "standardSymbol"]);
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                  this.wideNarrowRatio = (0, _utils.getRatio)(attributes2.wideNarrowRatio);
                  this.encrypt = null;
                  this.extras = null;
                }
              }
              class Bind extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "bind", true);
                  this.match = (0, _utils.getStringOption)(attributes2.match, ["once", "dataRef", "global", "none"]);
                  this.ref = attributes2.ref || "";
                  this.picture = null;
                }
              }
              class BindItems extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "bindItems");
                  this.connection = attributes2.connection || "";
                  this.labelRef = attributes2.labelRef || "";
                  this.ref = attributes2.ref || "";
                  this.valueRef = attributes2.valueRef || "";
                }
              }
              exports3.BindItems = BindItems;
              class Bookend extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "bookend");
                  this.id = attributes2.id || "";
                  this.leader = attributes2.leader || "";
                  this.trailer = attributes2.trailer || "";
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                }
              }
              class BooleanElement extends _xfa_object.Option01 {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "boolean");
                  this.id = attributes2.id || "";
                  this.name = attributes2.name || "";
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                }
                [_symbol_utils.$toHTML](availableSpace) {
                  return valueToHtml(this[_symbol_utils.$content] === 1 ? "1" : "0");
                }
              }
              class Border extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "border", true);
                  this.break = (0, _utils.getStringOption)(attributes2.break, ["close", "open"]);
                  this.hand = (0, _utils.getStringOption)(attributes2.hand, ["even", "left", "right"]);
                  this.id = attributes2.id || "";
                  this.presence = (0, _utils.getStringOption)(attributes2.presence, ["visible", "hidden", "inactive", "invisible"]);
                  this.relevant = (0, _utils.getRelevant)(attributes2.relevant);
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                  this.corner = new _xfa_object.XFAObjectArray(4);
                  this.edge = new _xfa_object.XFAObjectArray(4);
                  this.extras = null;
                  this.fill = null;
                  this.margin = null;
                }
                [_symbol_utils.$getExtra]() {
                  if (!this[_symbol_utils.$extra]) {
                    const edges = this.edge.children.slice();
                    if (edges.length < 4) {
                      const defaultEdge = edges.at(-1) || new Edge({});
                      for (let i = edges.length; i < 4; i++) {
                        edges.push(defaultEdge);
                      }
                    }
                    const widths = edges.map((edge) => edge.thickness);
                    const insets = [0, 0, 0, 0];
                    if (this.margin) {
                      insets[0] = this.margin.topInset;
                      insets[1] = this.margin.rightInset;
                      insets[2] = this.margin.bottomInset;
                      insets[3] = this.margin.leftInset;
                    }
                    this[_symbol_utils.$extra] = {
                      widths,
                      insets,
                      edges
                    };
                  }
                  return this[_symbol_utils.$extra];
                }
                [_symbol_utils.$toStyle]() {
                  const {
                    edges
                  } = this[_symbol_utils.$getExtra]();
                  const edgeStyles = edges.map((node2) => {
                    const style3 = node2[_symbol_utils.$toStyle]();
                    style3.color ||= "#000000";
                    return style3;
                  });
                  const style2 = /* @__PURE__ */ Object.create(null);
                  if (this.margin) {
                    Object.assign(style2, this.margin[_symbol_utils.$toStyle]());
                  }
                  if (this.fill?.presence === "visible") {
                    Object.assign(style2, this.fill[_symbol_utils.$toStyle]());
                  }
                  if (this.corner.children.some((node2) => node2.radius !== 0)) {
                    const cornerStyles = this.corner.children.map((node2) => node2[_symbol_utils.$toStyle]());
                    if (cornerStyles.length === 2 || cornerStyles.length === 3) {
                      const last2 = cornerStyles.at(-1);
                      for (let i = cornerStyles.length; i < 4; i++) {
                        cornerStyles.push(last2);
                      }
                    }
                    style2.borderRadius = cornerStyles.map((s) => s.radius).join(" ");
                  }
                  switch (this.presence) {
                    case "invisible":
                    case "hidden":
                      style2.borderStyle = "";
                      break;
                    case "inactive":
                      style2.borderStyle = "none";
                      break;
                    default:
                      style2.borderStyle = edgeStyles.map((s) => s.style).join(" ");
                      break;
                  }
                  style2.borderWidth = edgeStyles.map((s) => s.width).join(" ");
                  style2.borderColor = edgeStyles.map((s) => s.color).join(" ");
                  return style2;
                }
              }
              class Break extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "break", true);
                  this.after = (0, _utils.getStringOption)(attributes2.after, ["auto", "contentArea", "pageArea", "pageEven", "pageOdd"]);
                  this.afterTarget = attributes2.afterTarget || "";
                  this.before = (0, _utils.getStringOption)(attributes2.before, ["auto", "contentArea", "pageArea", "pageEven", "pageOdd"]);
                  this.beforeTarget = attributes2.beforeTarget || "";
                  this.bookendLeader = attributes2.bookendLeader || "";
                  this.bookendTrailer = attributes2.bookendTrailer || "";
                  this.id = attributes2.id || "";
                  this.overflowLeader = attributes2.overflowLeader || "";
                  this.overflowTarget = attributes2.overflowTarget || "";
                  this.overflowTrailer = attributes2.overflowTrailer || "";
                  this.startNew = (0, _utils.getInteger)({
                    data: attributes2.startNew,
                    defaultValue: 0,
                    validate: (x) => x === 1
                  });
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                  this.extras = null;
                }
              }
              class BreakAfter extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "breakAfter", true);
                  this.id = attributes2.id || "";
                  this.leader = attributes2.leader || "";
                  this.startNew = (0, _utils.getInteger)({
                    data: attributes2.startNew,
                    defaultValue: 0,
                    validate: (x) => x === 1
                  });
                  this.target = attributes2.target || "";
                  this.targetType = (0, _utils.getStringOption)(attributes2.targetType, ["auto", "contentArea", "pageArea"]);
                  this.trailer = attributes2.trailer || "";
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                  this.script = null;
                }
              }
              class BreakBefore extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "breakBefore", true);
                  this.id = attributes2.id || "";
                  this.leader = attributes2.leader || "";
                  this.startNew = (0, _utils.getInteger)({
                    data: attributes2.startNew,
                    defaultValue: 0,
                    validate: (x) => x === 1
                  });
                  this.target = attributes2.target || "";
                  this.targetType = (0, _utils.getStringOption)(attributes2.targetType, ["auto", "contentArea", "pageArea"]);
                  this.trailer = attributes2.trailer || "";
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                  this.script = null;
                }
                [_symbol_utils.$toHTML](availableSpace) {
                  this[_symbol_utils.$extra] = {};
                  return _utils.HTMLResult.FAILURE;
                }
              }
              class Button2 extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "button", true);
                  this.highlight = (0, _utils.getStringOption)(attributes2.highlight, ["inverted", "none", "outline", "push"]);
                  this.id = attributes2.id || "";
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                  this.extras = null;
                }
                [_symbol_utils.$toHTML](availableSpace) {
                  const parent2 = this[_symbol_utils.$getParent]();
                  const grandpa = parent2[_symbol_utils.$getParent]();
                  const htmlButton = {
                    name: "button",
                    attributes: {
                      id: this[_symbol_utils.$uid],
                      class: ["xfaButton"],
                      style: {}
                    },
                    children: []
                  };
                  for (const event of grandpa.event.children) {
                    if (event.activity !== "click" || !event.script) {
                      continue;
                    }
                    const jsURL = (0, _core_utils.recoverJsURL)(event.script[_symbol_utils.$content]);
                    if (!jsURL) {
                      continue;
                    }
                    const href = (0, _html_utils.fixURL)(jsURL.url);
                    if (!href) {
                      continue;
                    }
                    htmlButton.children.push({
                      name: "a",
                      attributes: {
                        id: "link" + this[_symbol_utils.$uid],
                        href,
                        newWindow: jsURL.newWindow,
                        class: ["xfaLink"],
                        style: {}
                      },
                      children: []
                    });
                  }
                  return _utils.HTMLResult.success(htmlButton);
                }
              }
              class Calculate extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "calculate", true);
                  this.id = attributes2.id || "";
                  this.override = (0, _utils.getStringOption)(attributes2.override, ["disabled", "error", "ignore", "warning"]);
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                  this.extras = null;
                  this.message = null;
                  this.script = null;
                }
              }
              class Caption extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "caption", true);
                  this.id = attributes2.id || "";
                  this.placement = (0, _utils.getStringOption)(attributes2.placement, ["left", "bottom", "inline", "right", "top"]);
                  this.presence = (0, _utils.getStringOption)(attributes2.presence, ["visible", "hidden", "inactive", "invisible"]);
                  this.reserve = Math.ceil((0, _utils.getMeasurement)(attributes2.reserve));
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                  this.extras = null;
                  this.font = null;
                  this.margin = null;
                  this.para = null;
                  this.value = null;
                }
                [_symbol_utils.$setValue](value) {
                  _setValue(this, value);
                }
                [_symbol_utils.$getExtra](availableSpace) {
                  if (!this[_symbol_utils.$extra]) {
                    let {
                      width,
                      height
                    } = availableSpace;
                    switch (this.placement) {
                      case "left":
                      case "right":
                      case "inline":
                        width = this.reserve <= 0 ? width : this.reserve;
                        break;
                      case "top":
                      case "bottom":
                        height = this.reserve <= 0 ? height : this.reserve;
                        break;
                    }
                    this[_symbol_utils.$extra] = (0, _html_utils.layoutNode)(this, {
                      width,
                      height
                    });
                  }
                  return this[_symbol_utils.$extra];
                }
                [_symbol_utils.$toHTML](availableSpace) {
                  if (!this.value) {
                    return _utils.HTMLResult.EMPTY;
                  }
                  this[_symbol_utils.$pushPara]();
                  const value = this.value[_symbol_utils.$toHTML](availableSpace).html;
                  if (!value) {
                    this[_symbol_utils.$popPara]();
                    return _utils.HTMLResult.EMPTY;
                  }
                  const savedReserve = this.reserve;
                  if (this.reserve <= 0) {
                    const {
                      w,
                      h: h2
                    } = this[_symbol_utils.$getExtra](availableSpace);
                    switch (this.placement) {
                      case "left":
                      case "right":
                      case "inline":
                        this.reserve = w;
                        break;
                      case "top":
                      case "bottom":
                        this.reserve = h2;
                        break;
                    }
                  }
                  const children = [];
                  if (typeof value === "string") {
                    children.push({
                      name: "#text",
                      value
                    });
                  } else {
                    children.push(value);
                  }
                  const style2 = (0, _html_utils.toStyle)(this, "font", "margin", "visibility");
                  switch (this.placement) {
                    case "left":
                    case "right":
                      if (this.reserve > 0) {
                        style2.width = (0, _html_utils.measureToString)(this.reserve);
                      }
                      break;
                    case "top":
                    case "bottom":
                      if (this.reserve > 0) {
                        style2.height = (0, _html_utils.measureToString)(this.reserve);
                      }
                      break;
                  }
                  (0, _html_utils.setPara)(this, null, value);
                  this[_symbol_utils.$popPara]();
                  this.reserve = savedReserve;
                  return _utils.HTMLResult.success({
                    name: "div",
                    attributes: {
                      style: style2,
                      class: ["xfaCaption"]
                    },
                    children
                  });
                }
              }
              class Certificate extends _xfa_object.StringObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "certificate");
                  this.id = attributes2.id || "";
                  this.name = attributes2.name || "";
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                }
              }
              class Certificates extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "certificates", true);
                  this.credentialServerPolicy = (0, _utils.getStringOption)(attributes2.credentialServerPolicy, ["optional", "required"]);
                  this.id = attributes2.id || "";
                  this.url = attributes2.url || "";
                  this.urlPolicy = attributes2.urlPolicy || "";
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                  this.encryption = null;
                  this.issuers = null;
                  this.keyUsage = null;
                  this.oids = null;
                  this.signing = null;
                  this.subjectDNs = null;
                }
              }
              class CheckButton extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "checkButton", true);
                  this.id = attributes2.id || "";
                  this.mark = (0, _utils.getStringOption)(attributes2.mark, ["default", "check", "circle", "cross", "diamond", "square", "star"]);
                  this.shape = (0, _utils.getStringOption)(attributes2.shape, ["square", "round"]);
                  this.size = (0, _utils.getMeasurement)(attributes2.size, "10pt");
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                  this.border = null;
                  this.extras = null;
                  this.margin = null;
                }
                [_symbol_utils.$toHTML](availableSpace) {
                  const style2 = (0, _html_utils.toStyle)("margin");
                  const size = (0, _html_utils.measureToString)(this.size);
                  style2.width = style2.height = size;
                  let type5;
                  let className2;
                  let groupId;
                  const field = this[_symbol_utils.$getParent]()[_symbol_utils.$getParent]();
                  const items = field.items.children.length && field.items.children[0][_symbol_utils.$toHTML]().html || [];
                  const exportedValue = {
                    on: (items[0] !== void 0 ? items[0] : "on").toString(),
                    off: (items[1] !== void 0 ? items[1] : "off").toString()
                  };
                  const value = field.value?.[_symbol_utils.$text]() || "off";
                  const checked = value === exportedValue.on || void 0;
                  const container = field[_symbol_utils.$getSubformParent]();
                  const fieldId = field[_symbol_utils.$uid];
                  let dataId;
                  if (container instanceof ExclGroup) {
                    groupId = container[_symbol_utils.$uid];
                    type5 = "radio";
                    className2 = "xfaRadio";
                    dataId = container[_symbol_utils.$data]?.[_symbol_utils.$uid] || container[_symbol_utils.$uid];
                  } else {
                    type5 = "checkbox";
                    className2 = "xfaCheckbox";
                    dataId = field[_symbol_utils.$data]?.[_symbol_utils.$uid] || field[_symbol_utils.$uid];
                  }
                  const input = {
                    name: "input",
                    attributes: {
                      class: [className2],
                      style: style2,
                      fieldId,
                      dataId,
                      type: type5,
                      checked,
                      xfaOn: exportedValue.on,
                      xfaOff: exportedValue.off,
                      "aria-label": ariaLabel(field),
                      "aria-required": false
                    }
                  };
                  if (groupId) {
                    input.attributes.name = groupId;
                  }
                  if (isRequired(field)) {
                    input.attributes["aria-required"] = true;
                    input.attributes.required = true;
                  }
                  return _utils.HTMLResult.success({
                    name: "label",
                    attributes: {
                      class: ["xfaLabel"]
                    },
                    children: [input]
                  });
                }
              }
              class ChoiceList extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "choiceList", true);
                  this.commitOn = (0, _utils.getStringOption)(attributes2.commitOn, ["select", "exit"]);
                  this.id = attributes2.id || "";
                  this.open = (0, _utils.getStringOption)(attributes2.open, ["userControl", "always", "multiSelect", "onEntry"]);
                  this.textEntry = (0, _utils.getInteger)({
                    data: attributes2.textEntry,
                    defaultValue: 0,
                    validate: (x) => x === 1
                  });
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                  this.border = null;
                  this.extras = null;
                  this.margin = null;
                }
                [_symbol_utils.$toHTML](availableSpace) {
                  const style2 = (0, _html_utils.toStyle)(this, "border", "margin");
                  const ui = this[_symbol_utils.$getParent]();
                  const field = ui[_symbol_utils.$getParent]();
                  const fontSize = field.font?.size || 10;
                  const optionStyle = {
                    fontSize: `calc(${fontSize}px * var(--scale-factor))`
                  };
                  const children = [];
                  if (field.items.children.length > 0) {
                    const items = field.items;
                    let displayedIndex = 0;
                    let saveIndex = 0;
                    if (items.children.length === 2) {
                      displayedIndex = items.children[0].save;
                      saveIndex = 1 - displayedIndex;
                    }
                    const displayed = items.children[displayedIndex][_symbol_utils.$toHTML]().html;
                    const values = items.children[saveIndex][_symbol_utils.$toHTML]().html;
                    let selected = false;
                    const value = field.value?.[_symbol_utils.$text]() || "";
                    for (let i = 0, ii = displayed.length; i < ii; i++) {
                      const option = {
                        name: "option",
                        attributes: {
                          value: values[i] || displayed[i],
                          style: optionStyle
                        },
                        value: displayed[i]
                      };
                      if (values[i] === value) {
                        option.attributes.selected = selected = true;
                      }
                      children.push(option);
                    }
                    if (!selected) {
                      children.splice(0, 0, {
                        name: "option",
                        attributes: {
                          hidden: true,
                          selected: true
                        },
                        value: " "
                      });
                    }
                  }
                  const selectAttributes = {
                    class: ["xfaSelect"],
                    fieldId: field[_symbol_utils.$uid],
                    dataId: field[_symbol_utils.$data]?.[_symbol_utils.$uid] || field[_symbol_utils.$uid],
                    style: style2,
                    "aria-label": ariaLabel(field),
                    "aria-required": false
                  };
                  if (isRequired(field)) {
                    selectAttributes["aria-required"] = true;
                    selectAttributes.required = true;
                  }
                  if (this.open === "multiSelect") {
                    selectAttributes.multiple = true;
                  }
                  return _utils.HTMLResult.success({
                    name: "label",
                    attributes: {
                      class: ["xfaLabel"]
                    },
                    children: [{
                      name: "select",
                      children,
                      attributes: selectAttributes
                    }]
                  });
                }
              }
              class Color5 extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "color", true);
                  this.cSpace = (0, _utils.getStringOption)(attributes2.cSpace, ["SRGB"]);
                  this.id = attributes2.id || "";
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                  this.value = attributes2.value ? (0, _utils.getColor)(attributes2.value) : "";
                  this.extras = null;
                }
                [_symbol_utils.$hasSettableValue]() {
                  return false;
                }
                [_symbol_utils.$toStyle]() {
                  return this.value ? _util2.Util.makeHexColor(this.value.r, this.value.g, this.value.b) : null;
                }
              }
              class Comb extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "comb");
                  this.id = attributes2.id || "";
                  this.numberOfCells = (0, _utils.getInteger)({
                    data: attributes2.numberOfCells,
                    defaultValue: 0,
                    validate: (x) => x >= 0
                  });
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                }
              }
              class Connect extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "connect", true);
                  this.connection = attributes2.connection || "";
                  this.id = attributes2.id || "";
                  this.ref = attributes2.ref || "";
                  this.usage = (0, _utils.getStringOption)(attributes2.usage, ["exportAndImport", "exportOnly", "importOnly"]);
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                  this.picture = null;
                }
              }
              class ContentArea extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "contentArea", true);
                  this.h = (0, _utils.getMeasurement)(attributes2.h);
                  this.id = attributes2.id || "";
                  this.name = attributes2.name || "";
                  this.relevant = (0, _utils.getRelevant)(attributes2.relevant);
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                  this.w = (0, _utils.getMeasurement)(attributes2.w);
                  this.x = (0, _utils.getMeasurement)(attributes2.x, "0pt");
                  this.y = (0, _utils.getMeasurement)(attributes2.y, "0pt");
                  this.desc = null;
                  this.extras = null;
                }
                [_symbol_utils.$toHTML](availableSpace) {
                  const left2 = (0, _html_utils.measureToString)(this.x);
                  const top = (0, _html_utils.measureToString)(this.y);
                  const style2 = {
                    left: left2,
                    top,
                    width: (0, _html_utils.measureToString)(this.w),
                    height: (0, _html_utils.measureToString)(this.h)
                  };
                  const classNames186 = ["xfaContentarea"];
                  if ((0, _html_utils.isPrintOnly)(this)) {
                    classNames186.push("xfaPrintOnly");
                  }
                  return _utils.HTMLResult.success({
                    name: "div",
                    children: [],
                    attributes: {
                      style: style2,
                      class: classNames186,
                      id: this[_symbol_utils.$uid]
                    }
                  });
                }
              }
              class Corner extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "corner", true);
                  this.id = attributes2.id || "";
                  this.inverted = (0, _utils.getInteger)({
                    data: attributes2.inverted,
                    defaultValue: 0,
                    validate: (x) => x === 1
                  });
                  this.join = (0, _utils.getStringOption)(attributes2.join, ["square", "round"]);
                  this.presence = (0, _utils.getStringOption)(attributes2.presence, ["visible", "hidden", "inactive", "invisible"]);
                  this.radius = (0, _utils.getMeasurement)(attributes2.radius);
                  this.stroke = (0, _utils.getStringOption)(attributes2.stroke, ["solid", "dashDot", "dashDotDot", "dashed", "dotted", "embossed", "etched", "lowered", "raised"]);
                  this.thickness = (0, _utils.getMeasurement)(attributes2.thickness, "0.5pt");
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                  this.color = null;
                  this.extras = null;
                }
                [_symbol_utils.$toStyle]() {
                  const style2 = (0, _html_utils.toStyle)(this, "visibility");
                  style2.radius = (0, _html_utils.measureToString)(this.join === "square" ? 0 : this.radius);
                  return style2;
                }
              }
              class DateElement extends _xfa_object.ContentObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "date");
                  this.id = attributes2.id || "";
                  this.name = attributes2.name || "";
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                }
                [_symbol_utils.$finalize]() {
                  const date4 = this[_symbol_utils.$content].trim();
                  this[_symbol_utils.$content] = date4 ? new Date(date4) : null;
                }
                [_symbol_utils.$toHTML](availableSpace) {
                  return valueToHtml(this[_symbol_utils.$content] ? this[_symbol_utils.$content].toString() : "");
                }
              }
              class DateTime extends _xfa_object.ContentObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "dateTime");
                  this.id = attributes2.id || "";
                  this.name = attributes2.name || "";
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                }
                [_symbol_utils.$finalize]() {
                  const date4 = this[_symbol_utils.$content].trim();
                  this[_symbol_utils.$content] = date4 ? new Date(date4) : null;
                }
                [_symbol_utils.$toHTML](availableSpace) {
                  return valueToHtml(this[_symbol_utils.$content] ? this[_symbol_utils.$content].toString() : "");
                }
              }
              class DateTimeEdit extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "dateTimeEdit", true);
                  this.hScrollPolicy = (0, _utils.getStringOption)(attributes2.hScrollPolicy, ["auto", "off", "on"]);
                  this.id = attributes2.id || "";
                  this.picker = (0, _utils.getStringOption)(attributes2.picker, ["host", "none"]);
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                  this.border = null;
                  this.comb = null;
                  this.extras = null;
                  this.margin = null;
                }
                [_symbol_utils.$toHTML](availableSpace) {
                  const style2 = (0, _html_utils.toStyle)(this, "border", "font", "margin");
                  const field = this[_symbol_utils.$getParent]()[_symbol_utils.$getParent]();
                  const html2 = {
                    name: "input",
                    attributes: {
                      type: "text",
                      fieldId: field[_symbol_utils.$uid],
                      dataId: field[_symbol_utils.$data]?.[_symbol_utils.$uid] || field[_symbol_utils.$uid],
                      class: ["xfaTextfield"],
                      style: style2,
                      "aria-label": ariaLabel(field),
                      "aria-required": false
                    }
                  };
                  if (isRequired(field)) {
                    html2.attributes["aria-required"] = true;
                    html2.attributes.required = true;
                  }
                  return _utils.HTMLResult.success({
                    name: "label",
                    attributes: {
                      class: ["xfaLabel"]
                    },
                    children: [html2]
                  });
                }
              }
              class Decimal extends _xfa_object.ContentObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "decimal");
                  this.fracDigits = (0, _utils.getInteger)({
                    data: attributes2.fracDigits,
                    defaultValue: 2,
                    validate: (x) => true
                  });
                  this.id = attributes2.id || "";
                  this.leadDigits = (0, _utils.getInteger)({
                    data: attributes2.leadDigits,
                    defaultValue: -1,
                    validate: (x) => true
                  });
                  this.name = attributes2.name || "";
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                }
                [_symbol_utils.$finalize]() {
                  const number4 = parseFloat(this[_symbol_utils.$content].trim());
                  this[_symbol_utils.$content] = isNaN(number4) ? null : number4;
                }
                [_symbol_utils.$toHTML](availableSpace) {
                  return valueToHtml(this[_symbol_utils.$content] !== null ? this[_symbol_utils.$content].toString() : "");
                }
              }
              class DefaultUi extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "defaultUi", true);
                  this.id = attributes2.id || "";
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                  this.extras = null;
                }
              }
              class Desc extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "desc", true);
                  this.id = attributes2.id || "";
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                  this.boolean = new _xfa_object.XFAObjectArray();
                  this.date = new _xfa_object.XFAObjectArray();
                  this.dateTime = new _xfa_object.XFAObjectArray();
                  this.decimal = new _xfa_object.XFAObjectArray();
                  this.exData = new _xfa_object.XFAObjectArray();
                  this.float = new _xfa_object.XFAObjectArray();
                  this.image = new _xfa_object.XFAObjectArray();
                  this.integer = new _xfa_object.XFAObjectArray();
                  this.text = new _xfa_object.XFAObjectArray();
                  this.time = new _xfa_object.XFAObjectArray();
                }
              }
              class DigestMethod extends _xfa_object.OptionObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "digestMethod", ["", "SHA1", "SHA256", "SHA512", "RIPEMD160"]);
                  this.id = attributes2.id || "";
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                }
              }
              class DigestMethods extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "digestMethods", true);
                  this.id = attributes2.id || "";
                  this.type = (0, _utils.getStringOption)(attributes2.type, ["optional", "required"]);
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                  this.digestMethod = new _xfa_object.XFAObjectArray();
                }
              }
              class Draw extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "draw", true);
                  this.anchorType = (0, _utils.getStringOption)(attributes2.anchorType, ["topLeft", "bottomCenter", "bottomLeft", "bottomRight", "middleCenter", "middleLeft", "middleRight", "topCenter", "topRight"]);
                  this.colSpan = (0, _utils.getInteger)({
                    data: attributes2.colSpan,
                    defaultValue: 1,
                    validate: (n2) => n2 >= 1 || n2 === -1
                  });
                  this.h = attributes2.h ? (0, _utils.getMeasurement)(attributes2.h) : "";
                  this.hAlign = (0, _utils.getStringOption)(attributes2.hAlign, ["left", "center", "justify", "justifyAll", "radix", "right"]);
                  this.id = attributes2.id || "";
                  this.locale = attributes2.locale || "";
                  this.maxH = (0, _utils.getMeasurement)(attributes2.maxH, "0pt");
                  this.maxW = (0, _utils.getMeasurement)(attributes2.maxW, "0pt");
                  this.minH = (0, _utils.getMeasurement)(attributes2.minH, "0pt");
                  this.minW = (0, _utils.getMeasurement)(attributes2.minW, "0pt");
                  this.name = attributes2.name || "";
                  this.presence = (0, _utils.getStringOption)(attributes2.presence, ["visible", "hidden", "inactive", "invisible"]);
                  this.relevant = (0, _utils.getRelevant)(attributes2.relevant);
                  this.rotate = (0, _utils.getInteger)({
                    data: attributes2.rotate,
                    defaultValue: 0,
                    validate: (x) => x % 90 === 0
                  });
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                  this.w = attributes2.w ? (0, _utils.getMeasurement)(attributes2.w) : "";
                  this.x = (0, _utils.getMeasurement)(attributes2.x, "0pt");
                  this.y = (0, _utils.getMeasurement)(attributes2.y, "0pt");
                  this.assist = null;
                  this.border = null;
                  this.caption = null;
                  this.desc = null;
                  this.extras = null;
                  this.font = null;
                  this.keep = null;
                  this.margin = null;
                  this.para = null;
                  this.traversal = null;
                  this.ui = null;
                  this.value = null;
                  this.setProperty = new _xfa_object.XFAObjectArray();
                }
                [_symbol_utils.$setValue](value) {
                  _setValue(this, value);
                }
                [_symbol_utils.$toHTML](availableSpace) {
                  setTabIndex(this);
                  if (this.presence === "hidden" || this.presence === "inactive") {
                    return _utils.HTMLResult.EMPTY;
                  }
                  (0, _html_utils.fixDimensions)(this);
                  this[_symbol_utils.$pushPara]();
                  const savedW = this.w;
                  const savedH = this.h;
                  const {
                    w,
                    h: h2,
                    isBroken
                  } = (0, _html_utils.layoutNode)(this, availableSpace);
                  if (w && this.w === "") {
                    if (isBroken && this[_symbol_utils.$getSubformParent]()[_symbol_utils.$isThereMoreWidth]()) {
                      this[_symbol_utils.$popPara]();
                      return _utils.HTMLResult.FAILURE;
                    }
                    this.w = w;
                  }
                  if (h2 && this.h === "") {
                    this.h = h2;
                  }
                  setFirstUnsplittable(this);
                  if (!(0, _layout.checkDimensions)(this, availableSpace)) {
                    this.w = savedW;
                    this.h = savedH;
                    this[_symbol_utils.$popPara]();
                    return _utils.HTMLResult.FAILURE;
                  }
                  unsetFirstUnsplittable(this);
                  const style2 = (0, _html_utils.toStyle)(this, "font", "hAlign", "dimensions", "position", "presence", "rotate", "anchorType", "border", "margin");
                  (0, _html_utils.setMinMaxDimensions)(this, style2);
                  if (style2.margin) {
                    style2.padding = style2.margin;
                    delete style2.margin;
                  }
                  const classNames186 = ["xfaDraw"];
                  if (this.font) {
                    classNames186.push("xfaFont");
                  }
                  if ((0, _html_utils.isPrintOnly)(this)) {
                    classNames186.push("xfaPrintOnly");
                  }
                  const attributes2 = {
                    style: style2,
                    id: this[_symbol_utils.$uid],
                    class: classNames186
                  };
                  if (this.name) {
                    attributes2.xfaName = this.name;
                  }
                  const html2 = {
                    name: "div",
                    attributes: attributes2,
                    children: []
                  };
                  applyAssist(this, attributes2);
                  const bbox = (0, _html_utils.computeBbox)(this, html2, availableSpace);
                  const value = this.value ? this.value[_symbol_utils.$toHTML](availableSpace).html : null;
                  if (value === null) {
                    this.w = savedW;
                    this.h = savedH;
                    this[_symbol_utils.$popPara]();
                    return _utils.HTMLResult.success((0, _html_utils.createWrapper)(this, html2), bbox);
                  }
                  html2.children.push(value);
                  (0, _html_utils.setPara)(this, style2, value);
                  this.w = savedW;
                  this.h = savedH;
                  this[_symbol_utils.$popPara]();
                  return _utils.HTMLResult.success((0, _html_utils.createWrapper)(this, html2), bbox);
                }
              }
              class Edge extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "edge", true);
                  this.cap = (0, _utils.getStringOption)(attributes2.cap, ["square", "butt", "round"]);
                  this.id = attributes2.id || "";
                  this.presence = (0, _utils.getStringOption)(attributes2.presence, ["visible", "hidden", "inactive", "invisible"]);
                  this.stroke = (0, _utils.getStringOption)(attributes2.stroke, ["solid", "dashDot", "dashDotDot", "dashed", "dotted", "embossed", "etched", "lowered", "raised"]);
                  this.thickness = (0, _utils.getMeasurement)(attributes2.thickness, "0.5pt");
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                  this.color = null;
                  this.extras = null;
                }
                [_symbol_utils.$toStyle]() {
                  const style2 = (0, _html_utils.toStyle)(this, "visibility");
                  Object.assign(style2, {
                    linecap: this.cap,
                    width: (0, _html_utils.measureToString)(this.thickness),
                    color: this.color ? this.color[_symbol_utils.$toStyle]() : "#000000",
                    style: ""
                  });
                  if (this.presence !== "visible") {
                    style2.style = "none";
                  } else {
                    switch (this.stroke) {
                      case "solid":
                        style2.style = "solid";
                        break;
                      case "dashDot":
                        style2.style = "dashed";
                        break;
                      case "dashDotDot":
                        style2.style = "dashed";
                        break;
                      case "dashed":
                        style2.style = "dashed";
                        break;
                      case "dotted":
                        style2.style = "dotted";
                        break;
                      case "embossed":
                        style2.style = "ridge";
                        break;
                      case "etched":
                        style2.style = "groove";
                        break;
                      case "lowered":
                        style2.style = "inset";
                        break;
                      case "raised":
                        style2.style = "outset";
                        break;
                    }
                  }
                  return style2;
                }
              }
              class Encoding extends _xfa_object.OptionObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "encoding", ["adbe.x509.rsa_sha1", "adbe.pkcs7.detached", "adbe.pkcs7.sha1"]);
                  this.id = attributes2.id || "";
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                }
              }
              class Encodings extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "encodings", true);
                  this.id = attributes2.id || "";
                  this.type = (0, _utils.getStringOption)(attributes2.type, ["optional", "required"]);
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                  this.encoding = new _xfa_object.XFAObjectArray();
                }
              }
              class Encrypt extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "encrypt", true);
                  this.id = attributes2.id || "";
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                  this.certificate = null;
                }
              }
              class EncryptData extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "encryptData", true);
                  this.id = attributes2.id || "";
                  this.operation = (0, _utils.getStringOption)(attributes2.operation, ["encrypt", "decrypt"]);
                  this.target = attributes2.target || "";
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                  this.filter = null;
                  this.manifest = null;
                }
              }
              class Encryption extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "encryption", true);
                  this.id = attributes2.id || "";
                  this.type = (0, _utils.getStringOption)(attributes2.type, ["optional", "required"]);
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                  this.certificate = new _xfa_object.XFAObjectArray();
                }
              }
              class EncryptionMethod extends _xfa_object.OptionObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "encryptionMethod", ["", "AES256-CBC", "TRIPLEDES-CBC", "AES128-CBC", "AES192-CBC"]);
                  this.id = attributes2.id || "";
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                }
              }
              class EncryptionMethods extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "encryptionMethods", true);
                  this.id = attributes2.id || "";
                  this.type = (0, _utils.getStringOption)(attributes2.type, ["optional", "required"]);
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                  this.encryptionMethod = new _xfa_object.XFAObjectArray();
                }
              }
              class Event2 extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "event", true);
                  this.activity = (0, _utils.getStringOption)(attributes2.activity, ["click", "change", "docClose", "docReady", "enter", "exit", "full", "indexChange", "initialize", "mouseDown", "mouseEnter", "mouseExit", "mouseUp", "postExecute", "postOpen", "postPrint", "postSave", "postSign", "postSubmit", "preExecute", "preOpen", "prePrint", "preSave", "preSign", "preSubmit", "ready", "validationState"]);
                  this.id = attributes2.id || "";
                  this.listen = (0, _utils.getStringOption)(attributes2.listen, ["refOnly", "refAndDescendents"]);
                  this.name = attributes2.name || "";
                  this.ref = attributes2.ref || "";
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                  this.extras = null;
                  this.encryptData = null;
                  this.execute = null;
                  this.script = null;
                  this.signData = null;
                  this.submit = null;
                }
              }
              class ExData extends _xfa_object.ContentObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "exData");
                  this.contentType = attributes2.contentType || "";
                  this.href = attributes2.href || "";
                  this.id = attributes2.id || "";
                  this.maxLength = (0, _utils.getInteger)({
                    data: attributes2.maxLength,
                    defaultValue: -1,
                    validate: (x) => x >= -1
                  });
                  this.name = attributes2.name || "";
                  this.rid = attributes2.rid || "";
                  this.transferEncoding = (0, _utils.getStringOption)(attributes2.transferEncoding, ["none", "base64", "package"]);
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                }
                [_symbol_utils.$isCDATAXml]() {
                  return this.contentType === "text/html";
                }
                [_symbol_utils.$onChild](child) {
                  if (this.contentType === "text/html" && child[_symbol_utils.$namespaceId] === _namespaces.NamespaceIds.xhtml.id) {
                    this[_symbol_utils.$content] = child;
                    return true;
                  }
                  if (this.contentType === "text/xml") {
                    this[_symbol_utils.$content] = child;
                    return true;
                  }
                  return false;
                }
                [_symbol_utils.$toHTML](availableSpace) {
                  if (this.contentType !== "text/html" || !this[_symbol_utils.$content]) {
                    return _utils.HTMLResult.EMPTY;
                  }
                  return this[_symbol_utils.$content][_symbol_utils.$toHTML](availableSpace);
                }
              }
              class ExObject extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "exObject", true);
                  this.archive = attributes2.archive || "";
                  this.classId = attributes2.classId || "";
                  this.codeBase = attributes2.codeBase || "";
                  this.codeType = attributes2.codeType || "";
                  this.id = attributes2.id || "";
                  this.name = attributes2.name || "";
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                  this.extras = null;
                  this.boolean = new _xfa_object.XFAObjectArray();
                  this.date = new _xfa_object.XFAObjectArray();
                  this.dateTime = new _xfa_object.XFAObjectArray();
                  this.decimal = new _xfa_object.XFAObjectArray();
                  this.exData = new _xfa_object.XFAObjectArray();
                  this.exObject = new _xfa_object.XFAObjectArray();
                  this.float = new _xfa_object.XFAObjectArray();
                  this.image = new _xfa_object.XFAObjectArray();
                  this.integer = new _xfa_object.XFAObjectArray();
                  this.text = new _xfa_object.XFAObjectArray();
                  this.time = new _xfa_object.XFAObjectArray();
                }
              }
              class ExclGroup extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "exclGroup", true);
                  this.access = (0, _utils.getStringOption)(attributes2.access, ["open", "nonInteractive", "protected", "readOnly"]);
                  this.accessKey = attributes2.accessKey || "";
                  this.anchorType = (0, _utils.getStringOption)(attributes2.anchorType, ["topLeft", "bottomCenter", "bottomLeft", "bottomRight", "middleCenter", "middleLeft", "middleRight", "topCenter", "topRight"]);
                  this.colSpan = (0, _utils.getInteger)({
                    data: attributes2.colSpan,
                    defaultValue: 1,
                    validate: (n2) => n2 >= 1 || n2 === -1
                  });
                  this.h = attributes2.h ? (0, _utils.getMeasurement)(attributes2.h) : "";
                  this.hAlign = (0, _utils.getStringOption)(attributes2.hAlign, ["left", "center", "justify", "justifyAll", "radix", "right"]);
                  this.id = attributes2.id || "";
                  this.layout = (0, _utils.getStringOption)(attributes2.layout, ["position", "lr-tb", "rl-row", "rl-tb", "row", "table", "tb"]);
                  this.maxH = (0, _utils.getMeasurement)(attributes2.maxH, "0pt");
                  this.maxW = (0, _utils.getMeasurement)(attributes2.maxW, "0pt");
                  this.minH = (0, _utils.getMeasurement)(attributes2.minH, "0pt");
                  this.minW = (0, _utils.getMeasurement)(attributes2.minW, "0pt");
                  this.name = attributes2.name || "";
                  this.presence = (0, _utils.getStringOption)(attributes2.presence, ["visible", "hidden", "inactive", "invisible"]);
                  this.relevant = (0, _utils.getRelevant)(attributes2.relevant);
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                  this.w = attributes2.w ? (0, _utils.getMeasurement)(attributes2.w) : "";
                  this.x = (0, _utils.getMeasurement)(attributes2.x, "0pt");
                  this.y = (0, _utils.getMeasurement)(attributes2.y, "0pt");
                  this.assist = null;
                  this.bind = null;
                  this.border = null;
                  this.calculate = null;
                  this.caption = null;
                  this.desc = null;
                  this.extras = null;
                  this.margin = null;
                  this.para = null;
                  this.traversal = null;
                  this.validate = null;
                  this.connect = new _xfa_object.XFAObjectArray();
                  this.event = new _xfa_object.XFAObjectArray();
                  this.field = new _xfa_object.XFAObjectArray();
                  this.setProperty = new _xfa_object.XFAObjectArray();
                }
                [_symbol_utils.$isBindable]() {
                  return true;
                }
                [_symbol_utils.$hasSettableValue]() {
                  return true;
                }
                [_symbol_utils.$setValue](value) {
                  for (const field of this.field.children) {
                    if (!field.value) {
                      const nodeValue = new Value({});
                      field[_symbol_utils.$appendChild](nodeValue);
                      field.value = nodeValue;
                    }
                    field.value[_symbol_utils.$setValue](value);
                  }
                }
                [_symbol_utils.$isThereMoreWidth]() {
                  return this.layout.endsWith("-tb") && this[_symbol_utils.$extra].attempt === 0 && this[_symbol_utils.$extra].numberInLine > 0 || this[_symbol_utils.$getParent]()[_symbol_utils.$isThereMoreWidth]();
                }
                [_symbol_utils.$isSplittable]() {
                  const parent2 = this[_symbol_utils.$getSubformParent]();
                  if (!parent2[_symbol_utils.$isSplittable]()) {
                    return false;
                  }
                  if (this[_symbol_utils.$extra]._isSplittable !== void 0) {
                    return this[_symbol_utils.$extra]._isSplittable;
                  }
                  if (this.layout === "position" || this.layout.includes("row")) {
                    this[_symbol_utils.$extra]._isSplittable = false;
                    return false;
                  }
                  if (parent2.layout?.endsWith("-tb") && parent2[_symbol_utils.$extra].numberInLine !== 0) {
                    return false;
                  }
                  this[_symbol_utils.$extra]._isSplittable = true;
                  return true;
                }
                [_symbol_utils.$flushHTML]() {
                  return (0, _layout.flushHTML)(this);
                }
                [_symbol_utils.$addHTML](html2, bbox) {
                  (0, _layout.addHTML)(this, html2, bbox);
                }
                [_symbol_utils.$getAvailableSpace]() {
                  return (0, _layout.getAvailableSpace)(this);
                }
                [_symbol_utils.$toHTML](availableSpace) {
                  setTabIndex(this);
                  if (this.presence === "hidden" || this.presence === "inactive" || this.h === 0 || this.w === 0) {
                    return _utils.HTMLResult.EMPTY;
                  }
                  (0, _html_utils.fixDimensions)(this);
                  const children = [];
                  const attributes2 = {
                    id: this[_symbol_utils.$uid],
                    class: []
                  };
                  (0, _html_utils.setAccess)(this, attributes2.class);
                  if (!this[_symbol_utils.$extra]) {
                    this[_symbol_utils.$extra] = /* @__PURE__ */ Object.create(null);
                  }
                  Object.assign(this[_symbol_utils.$extra], {
                    children,
                    attributes: attributes2,
                    attempt: 0,
                    line: null,
                    numberInLine: 0,
                    availableSpace: {
                      width: Math.min(this.w || Infinity, availableSpace.width),
                      height: Math.min(this.h || Infinity, availableSpace.height)
                    },
                    width: 0,
                    height: 0,
                    prevHeight: 0,
                    currentWidth: 0
                  });
                  const isSplittable = this[_symbol_utils.$isSplittable]();
                  if (!isSplittable) {
                    setFirstUnsplittable(this);
                  }
                  if (!(0, _layout.checkDimensions)(this, availableSpace)) {
                    return _utils.HTMLResult.FAILURE;
                  }
                  const filter3 = /* @__PURE__ */ new Set(["field"]);
                  if (this.layout.includes("row")) {
                    const columnWidths = this[_symbol_utils.$getSubformParent]().columnWidths;
                    if (Array.isArray(columnWidths) && columnWidths.length > 0) {
                      this[_symbol_utils.$extra].columnWidths = columnWidths;
                      this[_symbol_utils.$extra].currentColumn = 0;
                    }
                  }
                  const style2 = (0, _html_utils.toStyle)(this, "anchorType", "dimensions", "position", "presence", "border", "margin", "hAlign");
                  const classNames186 = ["xfaExclgroup"];
                  const cl = (0, _html_utils.layoutClass)(this);
                  if (cl) {
                    classNames186.push(cl);
                  }
                  if ((0, _html_utils.isPrintOnly)(this)) {
                    classNames186.push("xfaPrintOnly");
                  }
                  attributes2.style = style2;
                  attributes2.class = classNames186;
                  if (this.name) {
                    attributes2.xfaName = this.name;
                  }
                  this[_symbol_utils.$pushPara]();
                  const isLrTb = this.layout === "lr-tb" || this.layout === "rl-tb";
                  const maxRun = isLrTb ? MAX_ATTEMPTS_FOR_LRTB_LAYOUT : 1;
                  for (; this[_symbol_utils.$extra].attempt < maxRun; this[_symbol_utils.$extra].attempt++) {
                    if (isLrTb && this[_symbol_utils.$extra].attempt === MAX_ATTEMPTS_FOR_LRTB_LAYOUT - 1) {
                      this[_symbol_utils.$extra].numberInLine = 0;
                    }
                    const result = this[_symbol_utils.$childrenToHTML]({
                      filter: filter3,
                      include: true
                    });
                    if (result.success) {
                      break;
                    }
                    if (result.isBreak()) {
                      this[_symbol_utils.$popPara]();
                      return result;
                    }
                    if (isLrTb && this[_symbol_utils.$extra].attempt === 0 && this[_symbol_utils.$extra].numberInLine === 0 && !this[_symbol_utils.$getTemplateRoot]()[_symbol_utils.$extra].noLayoutFailure) {
                      this[_symbol_utils.$extra].attempt = maxRun;
                      break;
                    }
                  }
                  this[_symbol_utils.$popPara]();
                  if (!isSplittable) {
                    unsetFirstUnsplittable(this);
                  }
                  if (this[_symbol_utils.$extra].attempt === maxRun) {
                    if (!isSplittable) {
                      delete this[_symbol_utils.$extra];
                    }
                    return _utils.HTMLResult.FAILURE;
                  }
                  let marginH = 0;
                  let marginV = 0;
                  if (this.margin) {
                    marginH = this.margin.leftInset + this.margin.rightInset;
                    marginV = this.margin.topInset + this.margin.bottomInset;
                  }
                  const width = Math.max(this[_symbol_utils.$extra].width + marginH, this.w || 0);
                  const height = Math.max(this[_symbol_utils.$extra].height + marginV, this.h || 0);
                  const bbox = [this.x, this.y, width, height];
                  if (this.w === "") {
                    style2.width = (0, _html_utils.measureToString)(width);
                  }
                  if (this.h === "") {
                    style2.height = (0, _html_utils.measureToString)(height);
                  }
                  const html2 = {
                    name: "div",
                    attributes: attributes2,
                    children
                  };
                  applyAssist(this, attributes2);
                  delete this[_symbol_utils.$extra];
                  return _utils.HTMLResult.success((0, _html_utils.createWrapper)(this, html2), bbox);
                }
              }
              class Execute extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "execute");
                  this.connection = attributes2.connection || "";
                  this.executeType = (0, _utils.getStringOption)(attributes2.executeType, ["import", "remerge"]);
                  this.id = attributes2.id || "";
                  this.runAt = (0, _utils.getStringOption)(attributes2.runAt, ["client", "both", "server"]);
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                }
              }
              class Extras extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "extras", true);
                  this.id = attributes2.id || "";
                  this.name = attributes2.name || "";
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                  this.boolean = new _xfa_object.XFAObjectArray();
                  this.date = new _xfa_object.XFAObjectArray();
                  this.dateTime = new _xfa_object.XFAObjectArray();
                  this.decimal = new _xfa_object.XFAObjectArray();
                  this.exData = new _xfa_object.XFAObjectArray();
                  this.extras = new _xfa_object.XFAObjectArray();
                  this.float = new _xfa_object.XFAObjectArray();
                  this.image = new _xfa_object.XFAObjectArray();
                  this.integer = new _xfa_object.XFAObjectArray();
                  this.text = new _xfa_object.XFAObjectArray();
                  this.time = new _xfa_object.XFAObjectArray();
                }
              }
              class Field2 extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "field", true);
                  this.access = (0, _utils.getStringOption)(attributes2.access, ["open", "nonInteractive", "protected", "readOnly"]);
                  this.accessKey = attributes2.accessKey || "";
                  this.anchorType = (0, _utils.getStringOption)(attributes2.anchorType, ["topLeft", "bottomCenter", "bottomLeft", "bottomRight", "middleCenter", "middleLeft", "middleRight", "topCenter", "topRight"]);
                  this.colSpan = (0, _utils.getInteger)({
                    data: attributes2.colSpan,
                    defaultValue: 1,
                    validate: (n2) => n2 >= 1 || n2 === -1
                  });
                  this.h = attributes2.h ? (0, _utils.getMeasurement)(attributes2.h) : "";
                  this.hAlign = (0, _utils.getStringOption)(attributes2.hAlign, ["left", "center", "justify", "justifyAll", "radix", "right"]);
                  this.id = attributes2.id || "";
                  this.locale = attributes2.locale || "";
                  this.maxH = (0, _utils.getMeasurement)(attributes2.maxH, "0pt");
                  this.maxW = (0, _utils.getMeasurement)(attributes2.maxW, "0pt");
                  this.minH = (0, _utils.getMeasurement)(attributes2.minH, "0pt");
                  this.minW = (0, _utils.getMeasurement)(attributes2.minW, "0pt");
                  this.name = attributes2.name || "";
                  this.presence = (0, _utils.getStringOption)(attributes2.presence, ["visible", "hidden", "inactive", "invisible"]);
                  this.relevant = (0, _utils.getRelevant)(attributes2.relevant);
                  this.rotate = (0, _utils.getInteger)({
                    data: attributes2.rotate,
                    defaultValue: 0,
                    validate: (x) => x % 90 === 0
                  });
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                  this.w = attributes2.w ? (0, _utils.getMeasurement)(attributes2.w) : "";
                  this.x = (0, _utils.getMeasurement)(attributes2.x, "0pt");
                  this.y = (0, _utils.getMeasurement)(attributes2.y, "0pt");
                  this.assist = null;
                  this.bind = null;
                  this.border = null;
                  this.calculate = null;
                  this.caption = null;
                  this.desc = null;
                  this.extras = null;
                  this.font = null;
                  this.format = null;
                  this.items = new _xfa_object.XFAObjectArray(2);
                  this.keep = null;
                  this.margin = null;
                  this.para = null;
                  this.traversal = null;
                  this.ui = null;
                  this.validate = null;
                  this.value = null;
                  this.bindItems = new _xfa_object.XFAObjectArray();
                  this.connect = new _xfa_object.XFAObjectArray();
                  this.event = new _xfa_object.XFAObjectArray();
                  this.setProperty = new _xfa_object.XFAObjectArray();
                }
                [_symbol_utils.$isBindable]() {
                  return true;
                }
                [_symbol_utils.$setValue](value) {
                  _setValue(this, value);
                }
                [_symbol_utils.$toHTML](availableSpace) {
                  setTabIndex(this);
                  if (!this.ui) {
                    this.ui = new Ui({});
                    this.ui[_symbol_utils.$globalData] = this[_symbol_utils.$globalData];
                    this[_symbol_utils.$appendChild](this.ui);
                    let node2;
                    switch (this.items.children.length) {
                      case 0:
                        node2 = new TextEdit({});
                        this.ui.textEdit = node2;
                        break;
                      case 1:
                        node2 = new CheckButton({});
                        this.ui.checkButton = node2;
                        break;
                      case 2:
                        node2 = new ChoiceList({});
                        this.ui.choiceList = node2;
                        break;
                    }
                    this.ui[_symbol_utils.$appendChild](node2);
                  }
                  if (!this.ui || this.presence === "hidden" || this.presence === "inactive" || this.h === 0 || this.w === 0) {
                    return _utils.HTMLResult.EMPTY;
                  }
                  if (this.caption) {
                    delete this.caption[_symbol_utils.$extra];
                  }
                  this[_symbol_utils.$pushPara]();
                  const caption = this.caption ? this.caption[_symbol_utils.$toHTML](availableSpace).html : null;
                  const savedW = this.w;
                  const savedH = this.h;
                  let marginH = 0;
                  let marginV = 0;
                  if (this.margin) {
                    marginH = this.margin.leftInset + this.margin.rightInset;
                    marginV = this.margin.topInset + this.margin.bottomInset;
                  }
                  let borderDims = null;
                  if (this.w === "" || this.h === "") {
                    let width = null;
                    let height = null;
                    let uiW = 0;
                    let uiH = 0;
                    if (this.ui.checkButton) {
                      uiW = uiH = this.ui.checkButton.size;
                    } else {
                      const {
                        w,
                        h: h2
                      } = (0, _html_utils.layoutNode)(this, availableSpace);
                      if (w !== null) {
                        uiW = w;
                        uiH = h2;
                      } else {
                        uiH = (0, _fonts.getMetrics)(this.font, true).lineNoGap;
                      }
                    }
                    borderDims = getBorderDims(this.ui[_symbol_utils.$getExtra]());
                    uiW += borderDims.w;
                    uiH += borderDims.h;
                    if (this.caption) {
                      const {
                        w,
                        h: h2,
                        isBroken
                      } = this.caption[_symbol_utils.$getExtra](availableSpace);
                      if (isBroken && this[_symbol_utils.$getSubformParent]()[_symbol_utils.$isThereMoreWidth]()) {
                        this[_symbol_utils.$popPara]();
                        return _utils.HTMLResult.FAILURE;
                      }
                      width = w;
                      height = h2;
                      switch (this.caption.placement) {
                        case "left":
                        case "right":
                        case "inline":
                          width += uiW;
                          break;
                        case "top":
                        case "bottom":
                          height += uiH;
                          break;
                      }
                    } else {
                      width = uiW;
                      height = uiH;
                    }
                    if (width && this.w === "") {
                      width += marginH;
                      this.w = Math.min(this.maxW <= 0 ? Infinity : this.maxW, this.minW + 1 < width ? width : this.minW);
                    }
                    if (height && this.h === "") {
                      height += marginV;
                      this.h = Math.min(this.maxH <= 0 ? Infinity : this.maxH, this.minH + 1 < height ? height : this.minH);
                    }
                  }
                  this[_symbol_utils.$popPara]();
                  (0, _html_utils.fixDimensions)(this);
                  setFirstUnsplittable(this);
                  if (!(0, _layout.checkDimensions)(this, availableSpace)) {
                    this.w = savedW;
                    this.h = savedH;
                    this[_symbol_utils.$popPara]();
                    return _utils.HTMLResult.FAILURE;
                  }
                  unsetFirstUnsplittable(this);
                  const style2 = (0, _html_utils.toStyle)(this, "font", "dimensions", "position", "rotate", "anchorType", "presence", "margin", "hAlign");
                  (0, _html_utils.setMinMaxDimensions)(this, style2);
                  const classNames186 = ["xfaField"];
                  if (this.font) {
                    classNames186.push("xfaFont");
                  }
                  if ((0, _html_utils.isPrintOnly)(this)) {
                    classNames186.push("xfaPrintOnly");
                  }
                  const attributes2 = {
                    style: style2,
                    id: this[_symbol_utils.$uid],
                    class: classNames186
                  };
                  if (style2.margin) {
                    style2.padding = style2.margin;
                    delete style2.margin;
                  }
                  (0, _html_utils.setAccess)(this, classNames186);
                  if (this.name) {
                    attributes2.xfaName = this.name;
                  }
                  const children = [];
                  const html2 = {
                    name: "div",
                    attributes: attributes2,
                    children
                  };
                  applyAssist(this, attributes2);
                  const borderStyle = this.border ? this.border[_symbol_utils.$toStyle]() : null;
                  const bbox = (0, _html_utils.computeBbox)(this, html2, availableSpace);
                  const ui = this.ui[_symbol_utils.$toHTML]().html;
                  if (!ui) {
                    Object.assign(style2, borderStyle);
                    return _utils.HTMLResult.success((0, _html_utils.createWrapper)(this, html2), bbox);
                  }
                  if (this[_symbol_utils.$tabIndex]) {
                    if (ui.children?.[0]) {
                      ui.children[0].attributes.tabindex = this[_symbol_utils.$tabIndex];
                    } else {
                      ui.attributes.tabindex = this[_symbol_utils.$tabIndex];
                    }
                  }
                  if (!ui.attributes.style) {
                    ui.attributes.style = /* @__PURE__ */ Object.create(null);
                  }
                  let aElement = null;
                  if (this.ui.button) {
                    if (ui.children.length === 1) {
                      [aElement] = ui.children.splice(0, 1);
                    }
                    Object.assign(ui.attributes.style, borderStyle);
                  } else {
                    Object.assign(style2, borderStyle);
                  }
                  children.push(ui);
                  if (this.value) {
                    if (this.ui.imageEdit) {
                      ui.children.push(this.value[_symbol_utils.$toHTML]().html);
                    } else if (!this.ui.button) {
                      let value = "";
                      if (this.value.exData) {
                        value = this.value.exData[_symbol_utils.$text]();
                      } else if (this.value.text) {
                        value = this.value.text[_symbol_utils.$getExtra]();
                      } else {
                        const htmlValue = this.value[_symbol_utils.$toHTML]().html;
                        if (htmlValue !== null) {
                          value = htmlValue.children[0].value;
                        }
                      }
                      if (this.ui.textEdit && this.value.text?.maxChars) {
                        ui.children[0].attributes.maxLength = this.value.text.maxChars;
                      }
                      if (value) {
                        if (this.ui.numericEdit) {
                          value = parseFloat(value);
                          value = isNaN(value) ? "" : value.toString();
                        }
                        if (ui.children[0].name === "textarea") {
                          ui.children[0].attributes.textContent = value;
                        } else {
                          ui.children[0].attributes.value = value;
                        }
                      }
                    }
                  }
                  if (!this.ui.imageEdit && ui.children?.[0] && this.h) {
                    borderDims = borderDims || getBorderDims(this.ui[_symbol_utils.$getExtra]());
                    let captionHeight = 0;
                    if (this.caption && ["top", "bottom"].includes(this.caption.placement)) {
                      captionHeight = this.caption.reserve;
                      if (captionHeight <= 0) {
                        captionHeight = this.caption[_symbol_utils.$getExtra](availableSpace).h;
                      }
                      const inputHeight = this.h - captionHeight - marginV - borderDims.h;
                      ui.children[0].attributes.style.height = (0, _html_utils.measureToString)(inputHeight);
                    } else {
                      ui.children[0].attributes.style.height = "100%";
                    }
                  }
                  if (aElement) {
                    ui.children.push(aElement);
                  }
                  if (!caption) {
                    if (ui.attributes.class) {
                      ui.attributes.class.push("xfaLeft");
                    }
                    this.w = savedW;
                    this.h = savedH;
                    return _utils.HTMLResult.success((0, _html_utils.createWrapper)(this, html2), bbox);
                  }
                  if (this.ui.button) {
                    if (style2.padding) {
                      delete style2.padding;
                    }
                    if (caption.name === "div") {
                      caption.name = "span";
                    }
                    ui.children.push(caption);
                    return _utils.HTMLResult.success(html2, bbox);
                  } else if (this.ui.checkButton) {
                    caption.attributes.class[0] = "xfaCaptionForCheckButton";
                  }
                  if (!ui.attributes.class) {
                    ui.attributes.class = [];
                  }
                  ui.children.splice(0, 0, caption);
                  switch (this.caption.placement) {
                    case "left":
                      ui.attributes.class.push("xfaLeft");
                      break;
                    case "right":
                      ui.attributes.class.push("xfaRight");
                      break;
                    case "top":
                      ui.attributes.class.push("xfaTop");
                      break;
                    case "bottom":
                      ui.attributes.class.push("xfaBottom");
                      break;
                    case "inline":
                      ui.attributes.class.push("xfaLeft");
                      break;
                  }
                  this.w = savedW;
                  this.h = savedH;
                  return _utils.HTMLResult.success((0, _html_utils.createWrapper)(this, html2), bbox);
                }
              }
              exports3.Field = Field2;
              class Fill extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "fill", true);
                  this.id = attributes2.id || "";
                  this.presence = (0, _utils.getStringOption)(attributes2.presence, ["visible", "hidden", "inactive", "invisible"]);
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                  this.color = null;
                  this.extras = null;
                  this.linear = null;
                  this.pattern = null;
                  this.radial = null;
                  this.solid = null;
                  this.stipple = null;
                }
                [_symbol_utils.$toStyle]() {
                  const parent2 = this[_symbol_utils.$getParent]();
                  const grandpa = parent2[_symbol_utils.$getParent]();
                  const ggrandpa = grandpa[_symbol_utils.$getParent]();
                  const style2 = /* @__PURE__ */ Object.create(null);
                  let propName = "color";
                  let altPropName = propName;
                  if (parent2 instanceof Border) {
                    propName = "background-color";
                    altPropName = "background";
                    if (ggrandpa instanceof Ui) {
                      style2.backgroundColor = "white";
                    }
                  }
                  if (parent2 instanceof Rectangle || parent2 instanceof Arc) {
                    propName = altPropName = "fill";
                    style2.fill = "white";
                  }
                  for (const name of Object.getOwnPropertyNames(this)) {
                    if (name === "extras" || name === "color") {
                      continue;
                    }
                    const obj = this[name];
                    if (!(obj instanceof _xfa_object.XFAObject)) {
                      continue;
                    }
                    const color = obj[_symbol_utils.$toStyle](this.color);
                    if (color) {
                      style2[color.startsWith("#") ? propName : altPropName] = color;
                    }
                    return style2;
                  }
                  if (this.color?.value) {
                    const color = this.color[_symbol_utils.$toStyle]();
                    style2[color.startsWith("#") ? propName : altPropName] = color;
                  }
                  return style2;
                }
              }
              class Filter extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "filter", true);
                  this.addRevocationInfo = (0, _utils.getStringOption)(attributes2.addRevocationInfo, ["", "required", "optional", "none"]);
                  this.id = attributes2.id || "";
                  this.name = attributes2.name || "";
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                  this.version = (0, _utils.getInteger)({
                    data: this.version,
                    defaultValue: 5,
                    validate: (x) => x >= 1 && x <= 5
                  });
                  this.appearanceFilter = null;
                  this.certificates = null;
                  this.digestMethods = null;
                  this.encodings = null;
                  this.encryptionMethods = null;
                  this.handler = null;
                  this.lockDocument = null;
                  this.mdp = null;
                  this.reasons = null;
                  this.timeStamp = null;
                }
              }
              class Float extends _xfa_object.ContentObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "float");
                  this.id = attributes2.id || "";
                  this.name = attributes2.name || "";
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                }
                [_symbol_utils.$finalize]() {
                  const number4 = parseFloat(this[_symbol_utils.$content].trim());
                  this[_symbol_utils.$content] = isNaN(number4) ? null : number4;
                }
                [_symbol_utils.$toHTML](availableSpace) {
                  return valueToHtml(this[_symbol_utils.$content] !== null ? this[_symbol_utils.$content].toString() : "");
                }
              }
              class Font3 extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "font", true);
                  this.baselineShift = (0, _utils.getMeasurement)(attributes2.baselineShift);
                  this.fontHorizontalScale = (0, _utils.getFloat)({
                    data: attributes2.fontHorizontalScale,
                    defaultValue: 100,
                    validate: (x) => x >= 0
                  });
                  this.fontVerticalScale = (0, _utils.getFloat)({
                    data: attributes2.fontVerticalScale,
                    defaultValue: 100,
                    validate: (x) => x >= 0
                  });
                  this.id = attributes2.id || "";
                  this.kerningMode = (0, _utils.getStringOption)(attributes2.kerningMode, ["none", "pair"]);
                  this.letterSpacing = (0, _utils.getMeasurement)(attributes2.letterSpacing, "0");
                  this.lineThrough = (0, _utils.getInteger)({
                    data: attributes2.lineThrough,
                    defaultValue: 0,
                    validate: (x) => x === 1 || x === 2
                  });
                  this.lineThroughPeriod = (0, _utils.getStringOption)(attributes2.lineThroughPeriod, ["all", "word"]);
                  this.overline = (0, _utils.getInteger)({
                    data: attributes2.overline,
                    defaultValue: 0,
                    validate: (x) => x === 1 || x === 2
                  });
                  this.overlinePeriod = (0, _utils.getStringOption)(attributes2.overlinePeriod, ["all", "word"]);
                  this.posture = (0, _utils.getStringOption)(attributes2.posture, ["normal", "italic"]);
                  this.size = (0, _utils.getMeasurement)(attributes2.size, "10pt");
                  this.typeface = attributes2.typeface || "Courier";
                  this.underline = (0, _utils.getInteger)({
                    data: attributes2.underline,
                    defaultValue: 0,
                    validate: (x) => x === 1 || x === 2
                  });
                  this.underlinePeriod = (0, _utils.getStringOption)(attributes2.underlinePeriod, ["all", "word"]);
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                  this.weight = (0, _utils.getStringOption)(attributes2.weight, ["normal", "bold"]);
                  this.extras = null;
                  this.fill = null;
                }
                [_symbol_utils.$clean](builder) {
                  super[_symbol_utils.$clean](builder);
                  this[_symbol_utils.$globalData].usedTypefaces.add(this.typeface);
                }
                [_symbol_utils.$toStyle]() {
                  const style2 = (0, _html_utils.toStyle)(this, "fill");
                  const color = style2.color;
                  if (color) {
                    if (color === "#000000") {
                      delete style2.color;
                    } else if (!color.startsWith("#")) {
                      style2.background = color;
                      style2.backgroundClip = "text";
                      style2.color = "transparent";
                    }
                  }
                  if (this.baselineShift) {
                    style2.verticalAlign = (0, _html_utils.measureToString)(this.baselineShift);
                  }
                  style2.fontKerning = this.kerningMode === "none" ? "none" : "normal";
                  style2.letterSpacing = (0, _html_utils.measureToString)(this.letterSpacing);
                  if (this.lineThrough !== 0) {
                    style2.textDecoration = "line-through";
                    if (this.lineThrough === 2) {
                      style2.textDecorationStyle = "double";
                    }
                  }
                  if (this.overline !== 0) {
                    style2.textDecoration = "overline";
                    if (this.overline === 2) {
                      style2.textDecorationStyle = "double";
                    }
                  }
                  style2.fontStyle = this.posture;
                  style2.fontSize = (0, _html_utils.measureToString)(0.99 * this.size);
                  (0, _html_utils.setFontFamily)(this, this, this[_symbol_utils.$globalData].fontFinder, style2);
                  if (this.underline !== 0) {
                    style2.textDecoration = "underline";
                    if (this.underline === 2) {
                      style2.textDecorationStyle = "double";
                    }
                  }
                  style2.fontWeight = this.weight;
                  return style2;
                }
              }
              class Format extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "format", true);
                  this.id = attributes2.id || "";
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                  this.extras = null;
                  this.picture = null;
                }
              }
              class Handler3 extends _xfa_object.StringObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "handler");
                  this.id = attributes2.id || "";
                  this.type = (0, _utils.getStringOption)(attributes2.type, ["optional", "required"]);
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                }
              }
              class Hyphenation extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "hyphenation");
                  this.excludeAllCaps = (0, _utils.getInteger)({
                    data: attributes2.excludeAllCaps,
                    defaultValue: 0,
                    validate: (x) => x === 1
                  });
                  this.excludeInitialCap = (0, _utils.getInteger)({
                    data: attributes2.excludeInitialCap,
                    defaultValue: 0,
                    validate: (x) => x === 1
                  });
                  this.hyphenate = (0, _utils.getInteger)({
                    data: attributes2.hyphenate,
                    defaultValue: 0,
                    validate: (x) => x === 1
                  });
                  this.id = attributes2.id || "";
                  this.pushCharacterCount = (0, _utils.getInteger)({
                    data: attributes2.pushCharacterCount,
                    defaultValue: 3,
                    validate: (x) => x >= 0
                  });
                  this.remainCharacterCount = (0, _utils.getInteger)({
                    data: attributes2.remainCharacterCount,
                    defaultValue: 3,
                    validate: (x) => x >= 0
                  });
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                  this.wordCharacterCount = (0, _utils.getInteger)({
                    data: attributes2.wordCharacterCount,
                    defaultValue: 7,
                    validate: (x) => x >= 0
                  });
                }
              }
              class Image3 extends _xfa_object.StringObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "image");
                  this.aspect = (0, _utils.getStringOption)(attributes2.aspect, ["fit", "actual", "height", "none", "width"]);
                  this.contentType = attributes2.contentType || "";
                  this.href = attributes2.href || "";
                  this.id = attributes2.id || "";
                  this.name = attributes2.name || "";
                  this.transferEncoding = (0, _utils.getStringOption)(attributes2.transferEncoding, ["base64", "none", "package"]);
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                }
                [_symbol_utils.$toHTML]() {
                  if (this.contentType && !MIMES.has(this.contentType.toLowerCase())) {
                    return _utils.HTMLResult.EMPTY;
                  }
                  let buffer = this[_symbol_utils.$globalData].images && this[_symbol_utils.$globalData].images.get(this.href);
                  if (!buffer && (this.href || !this[_symbol_utils.$content])) {
                    return _utils.HTMLResult.EMPTY;
                  }
                  if (!buffer && this.transferEncoding === "base64") {
                    buffer = (0, _util2.stringToBytes)(atob(this[_symbol_utils.$content]));
                  }
                  if (!buffer) {
                    return _utils.HTMLResult.EMPTY;
                  }
                  if (!this.contentType) {
                    for (const [header, type5] of IMAGES_HEADERS) {
                      if (buffer.length > header.length && header.every((x, i) => x === buffer[i])) {
                        this.contentType = type5;
                        break;
                      }
                    }
                    if (!this.contentType) {
                      return _utils.HTMLResult.EMPTY;
                    }
                  }
                  const blob = new Blob([buffer], {
                    type: this.contentType
                  });
                  let style2;
                  switch (this.aspect) {
                    case "fit":
                    case "actual":
                      break;
                    case "height":
                      style2 = {
                        height: "100%",
                        objectFit: "fill"
                      };
                      break;
                    case "none":
                      style2 = {
                        width: "100%",
                        height: "100%",
                        objectFit: "fill"
                      };
                      break;
                    case "width":
                      style2 = {
                        width: "100%",
                        objectFit: "fill"
                      };
                      break;
                  }
                  const parent2 = this[_symbol_utils.$getParent]();
                  return _utils.HTMLResult.success({
                    name: "img",
                    attributes: {
                      class: ["xfaImage"],
                      style: style2,
                      src: URL.createObjectURL(blob),
                      alt: parent2 ? ariaLabel(parent2[_symbol_utils.$getParent]()) : null
                    }
                  });
                }
              }
              class ImageEdit extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "imageEdit", true);
                  this.data = (0, _utils.getStringOption)(attributes2.data, ["link", "embed"]);
                  this.id = attributes2.id || "";
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                  this.border = null;
                  this.extras = null;
                  this.margin = null;
                }
                [_symbol_utils.$toHTML](availableSpace) {
                  if (this.data === "embed") {
                    return _utils.HTMLResult.success({
                      name: "div",
                      children: [],
                      attributes: {}
                    });
                  }
                  return _utils.HTMLResult.EMPTY;
                }
              }
              class Integer extends _xfa_object.ContentObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "integer");
                  this.id = attributes2.id || "";
                  this.name = attributes2.name || "";
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                }
                [_symbol_utils.$finalize]() {
                  const number4 = parseInt(this[_symbol_utils.$content].trim(), 10);
                  this[_symbol_utils.$content] = isNaN(number4) ? null : number4;
                }
                [_symbol_utils.$toHTML](availableSpace) {
                  return valueToHtml(this[_symbol_utils.$content] !== null ? this[_symbol_utils.$content].toString() : "");
                }
              }
              class Issuers extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "issuers", true);
                  this.id = attributes2.id || "";
                  this.type = (0, _utils.getStringOption)(attributes2.type, ["optional", "required"]);
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                  this.certificate = new _xfa_object.XFAObjectArray();
                }
              }
              class Items extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "items", true);
                  this.id = attributes2.id || "";
                  this.name = attributes2.name || "";
                  this.presence = (0, _utils.getStringOption)(attributes2.presence, ["visible", "hidden", "inactive", "invisible"]);
                  this.ref = attributes2.ref || "";
                  this.save = (0, _utils.getInteger)({
                    data: attributes2.save,
                    defaultValue: 0,
                    validate: (x) => x === 1
                  });
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                  this.boolean = new _xfa_object.XFAObjectArray();
                  this.date = new _xfa_object.XFAObjectArray();
                  this.dateTime = new _xfa_object.XFAObjectArray();
                  this.decimal = new _xfa_object.XFAObjectArray();
                  this.exData = new _xfa_object.XFAObjectArray();
                  this.float = new _xfa_object.XFAObjectArray();
                  this.image = new _xfa_object.XFAObjectArray();
                  this.integer = new _xfa_object.XFAObjectArray();
                  this.text = new _xfa_object.XFAObjectArray();
                  this.time = new _xfa_object.XFAObjectArray();
                }
                [_symbol_utils.$toHTML]() {
                  const output = [];
                  for (const child of this[_symbol_utils.$getChildren]()) {
                    output.push(child[_symbol_utils.$text]());
                  }
                  return _utils.HTMLResult.success(output);
                }
              }
              exports3.Items = Items;
              class Keep extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "keep", true);
                  this.id = attributes2.id || "";
                  const options = ["none", "contentArea", "pageArea"];
                  this.intact = (0, _utils.getStringOption)(attributes2.intact, options);
                  this.next = (0, _utils.getStringOption)(attributes2.next, options);
                  this.previous = (0, _utils.getStringOption)(attributes2.previous, options);
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                  this.extras = null;
                }
              }
              class KeyUsage extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "keyUsage");
                  const options = ["", "yes", "no"];
                  this.crlSign = (0, _utils.getStringOption)(attributes2.crlSign, options);
                  this.dataEncipherment = (0, _utils.getStringOption)(attributes2.dataEncipherment, options);
                  this.decipherOnly = (0, _utils.getStringOption)(attributes2.decipherOnly, options);
                  this.digitalSignature = (0, _utils.getStringOption)(attributes2.digitalSignature, options);
                  this.encipherOnly = (0, _utils.getStringOption)(attributes2.encipherOnly, options);
                  this.id = attributes2.id || "";
                  this.keyAgreement = (0, _utils.getStringOption)(attributes2.keyAgreement, options);
                  this.keyCertSign = (0, _utils.getStringOption)(attributes2.keyCertSign, options);
                  this.keyEncipherment = (0, _utils.getStringOption)(attributes2.keyEncipherment, options);
                  this.nonRepudiation = (0, _utils.getStringOption)(attributes2.nonRepudiation, options);
                  this.type = (0, _utils.getStringOption)(attributes2.type, ["optional", "required"]);
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                }
              }
              class Line4 extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "line", true);
                  this.hand = (0, _utils.getStringOption)(attributes2.hand, ["even", "left", "right"]);
                  this.id = attributes2.id || "";
                  this.slope = (0, _utils.getStringOption)(attributes2.slope, ["\\", "/"]);
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                  this.edge = null;
                }
                [_symbol_utils.$toHTML]() {
                  const parent2 = this[_symbol_utils.$getParent]()[_symbol_utils.$getParent]();
                  const edge = this.edge || new Edge({});
                  const edgeStyle = edge[_symbol_utils.$toStyle]();
                  const style2 = /* @__PURE__ */ Object.create(null);
                  const thickness = edge.presence === "visible" ? edge.thickness : 0;
                  style2.strokeWidth = (0, _html_utils.measureToString)(thickness);
                  style2.stroke = edgeStyle.color;
                  let x1, y1, x2, y2;
                  let width = "100%";
                  let height = "100%";
                  if (parent2.w <= thickness) {
                    [x1, y1, x2, y2] = ["50%", 0, "50%", "100%"];
                    width = style2.strokeWidth;
                  } else if (parent2.h <= thickness) {
                    [x1, y1, x2, y2] = [0, "50%", "100%", "50%"];
                    height = style2.strokeWidth;
                  } else if (this.slope === "\\") {
                    [x1, y1, x2, y2] = [0, 0, "100%", "100%"];
                  } else {
                    [x1, y1, x2, y2] = [0, "100%", "100%", 0];
                  }
                  const line2 = {
                    name: "line",
                    attributes: {
                      xmlns: SVG_NS,
                      x1,
                      y1,
                      x2,
                      y2,
                      style: style2
                    }
                  };
                  const svg = {
                    name: "svg",
                    children: [line2],
                    attributes: {
                      xmlns: SVG_NS,
                      width,
                      height,
                      style: {
                        overflow: "visible"
                      }
                    }
                  };
                  if (hasMargin(parent2)) {
                    return _utils.HTMLResult.success({
                      name: "div",
                      attributes: {
                        style: {
                          display: "inline",
                          width: "100%",
                          height: "100%"
                        }
                      },
                      children: [svg]
                    });
                  }
                  svg.attributes.style.position = "absolute";
                  return _utils.HTMLResult.success(svg);
                }
              }
              class Linear extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "linear", true);
                  this.id = attributes2.id || "";
                  this.type = (0, _utils.getStringOption)(attributes2.type, ["toRight", "toBottom", "toLeft", "toTop"]);
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                  this.color = null;
                  this.extras = null;
                }
                [_symbol_utils.$toStyle](startColor) {
                  startColor = startColor ? startColor[_symbol_utils.$toStyle]() : "#FFFFFF";
                  const transf = this.type.replace(/([RBLT])/, " $1").toLowerCase();
                  const endColor = this.color ? this.color[_symbol_utils.$toStyle]() : "#000000";
                  return `linear-gradient(${transf}, ${startColor}, ${endColor})`;
                }
              }
              class LockDocument extends _xfa_object.ContentObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "lockDocument");
                  this.id = attributes2.id || "";
                  this.type = (0, _utils.getStringOption)(attributes2.type, ["optional", "required"]);
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                }
                [_symbol_utils.$finalize]() {
                  this[_symbol_utils.$content] = (0, _utils.getStringOption)(this[_symbol_utils.$content], ["auto", "0", "1"]);
                }
              }
              class Manifest extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "manifest", true);
                  this.action = (0, _utils.getStringOption)(attributes2.action, ["include", "all", "exclude"]);
                  this.id = attributes2.id || "";
                  this.name = attributes2.name || "";
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                  this.extras = null;
                  this.ref = new _xfa_object.XFAObjectArray();
                }
              }
              class Margin extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "margin", true);
                  this.bottomInset = (0, _utils.getMeasurement)(attributes2.bottomInset, "0");
                  this.id = attributes2.id || "";
                  this.leftInset = (0, _utils.getMeasurement)(attributes2.leftInset, "0");
                  this.rightInset = (0, _utils.getMeasurement)(attributes2.rightInset, "0");
                  this.topInset = (0, _utils.getMeasurement)(attributes2.topInset, "0");
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                  this.extras = null;
                }
                [_symbol_utils.$toStyle]() {
                  return {
                    margin: (0, _html_utils.measureToString)(this.topInset) + " " + (0, _html_utils.measureToString)(this.rightInset) + " " + (0, _html_utils.measureToString)(this.bottomInset) + " " + (0, _html_utils.measureToString)(this.leftInset)
                  };
                }
              }
              class Mdp extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "mdp");
                  this.id = attributes2.id || "";
                  this.permissions = (0, _utils.getInteger)({
                    data: attributes2.permissions,
                    defaultValue: 2,
                    validate: (x) => x === 1 || x === 3
                  });
                  this.signatureType = (0, _utils.getStringOption)(attributes2.signatureType, ["filler", "author"]);
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                }
              }
              class Medium extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "medium");
                  this.id = attributes2.id || "";
                  this.imagingBBox = (0, _utils.getBBox)(attributes2.imagingBBox);
                  this.long = (0, _utils.getMeasurement)(attributes2.long);
                  this.orientation = (0, _utils.getStringOption)(attributes2.orientation, ["portrait", "landscape"]);
                  this.short = (0, _utils.getMeasurement)(attributes2.short);
                  this.stock = attributes2.stock || "";
                  this.trayIn = (0, _utils.getStringOption)(attributes2.trayIn, ["auto", "delegate", "pageFront"]);
                  this.trayOut = (0, _utils.getStringOption)(attributes2.trayOut, ["auto", "delegate"]);
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                }
              }
              class Message extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "message", true);
                  this.id = attributes2.id || "";
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                  this.text = new _xfa_object.XFAObjectArray();
                }
              }
              class NumericEdit extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "numericEdit", true);
                  this.hScrollPolicy = (0, _utils.getStringOption)(attributes2.hScrollPolicy, ["auto", "off", "on"]);
                  this.id = attributes2.id || "";
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                  this.border = null;
                  this.comb = null;
                  this.extras = null;
                  this.margin = null;
                }
                [_symbol_utils.$toHTML](availableSpace) {
                  const style2 = (0, _html_utils.toStyle)(this, "border", "font", "margin");
                  const field = this[_symbol_utils.$getParent]()[_symbol_utils.$getParent]();
                  const html2 = {
                    name: "input",
                    attributes: {
                      type: "text",
                      fieldId: field[_symbol_utils.$uid],
                      dataId: field[_symbol_utils.$data]?.[_symbol_utils.$uid] || field[_symbol_utils.$uid],
                      class: ["xfaTextfield"],
                      style: style2,
                      "aria-label": ariaLabel(field),
                      "aria-required": false
                    }
                  };
                  if (isRequired(field)) {
                    html2.attributes["aria-required"] = true;
                    html2.attributes.required = true;
                  }
                  return _utils.HTMLResult.success({
                    name: "label",
                    attributes: {
                      class: ["xfaLabel"]
                    },
                    children: [html2]
                  });
                }
              }
              class Occur extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "occur", true);
                  this.id = attributes2.id || "";
                  this.initial = attributes2.initial !== "" ? (0, _utils.getInteger)({
                    data: attributes2.initial,
                    defaultValue: "",
                    validate: (x) => true
                  }) : "";
                  this.max = attributes2.max !== "" ? (0, _utils.getInteger)({
                    data: attributes2.max,
                    defaultValue: 1,
                    validate: (x) => true
                  }) : "";
                  this.min = attributes2.min !== "" ? (0, _utils.getInteger)({
                    data: attributes2.min,
                    defaultValue: 1,
                    validate: (x) => true
                  }) : "";
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                  this.extras = null;
                }
                [_symbol_utils.$clean]() {
                  const parent2 = this[_symbol_utils.$getParent]();
                  const originalMin = this.min;
                  if (this.min === "") {
                    this.min = parent2 instanceof PageArea || parent2 instanceof PageSet ? 0 : 1;
                  }
                  if (this.max === "") {
                    if (originalMin === "") {
                      this.max = parent2 instanceof PageArea || parent2 instanceof PageSet ? -1 : 1;
                    } else {
                      this.max = this.min;
                    }
                  }
                  if (this.max !== -1 && this.max < this.min) {
                    this.max = this.min;
                  }
                  if (this.initial === "") {
                    this.initial = parent2 instanceof Template9 ? 1 : this.min;
                  }
                }
              }
              class Oid extends _xfa_object.StringObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "oid");
                  this.id = attributes2.id || "";
                  this.name = attributes2.name || "";
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                }
              }
              class Oids extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "oids", true);
                  this.id = attributes2.id || "";
                  this.type = (0, _utils.getStringOption)(attributes2.type, ["optional", "required"]);
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                  this.oid = new _xfa_object.XFAObjectArray();
                }
              }
              class Overflow2 extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "overflow");
                  this.id = attributes2.id || "";
                  this.leader = attributes2.leader || "";
                  this.target = attributes2.target || "";
                  this.trailer = attributes2.trailer || "";
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                }
                [_symbol_utils.$getExtra]() {
                  if (!this[_symbol_utils.$extra]) {
                    const parent2 = this[_symbol_utils.$getParent]();
                    const root2 = this[_symbol_utils.$getTemplateRoot]();
                    const target = root2[_symbol_utils.$searchNode](this.target, parent2);
                    const leader = root2[_symbol_utils.$searchNode](this.leader, parent2);
                    const trailer = root2[_symbol_utils.$searchNode](this.trailer, parent2);
                    this[_symbol_utils.$extra] = {
                      target: target?.[0] || null,
                      leader: leader?.[0] || null,
                      trailer: trailer?.[0] || null,
                      addLeader: false,
                      addTrailer: false
                    };
                  }
                  return this[_symbol_utils.$extra];
                }
              }
              class PageArea extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "pageArea", true);
                  this.blankOrNotBlank = (0, _utils.getStringOption)(attributes2.blankOrNotBlank, ["any", "blank", "notBlank"]);
                  this.id = attributes2.id || "";
                  this.initialNumber = (0, _utils.getInteger)({
                    data: attributes2.initialNumber,
                    defaultValue: 1,
                    validate: (x) => true
                  });
                  this.name = attributes2.name || "";
                  this.numbered = (0, _utils.getInteger)({
                    data: attributes2.numbered,
                    defaultValue: 1,
                    validate: (x) => true
                  });
                  this.oddOrEven = (0, _utils.getStringOption)(attributes2.oddOrEven, ["any", "even", "odd"]);
                  this.pagePosition = (0, _utils.getStringOption)(attributes2.pagePosition, ["any", "first", "last", "only", "rest"]);
                  this.relevant = (0, _utils.getRelevant)(attributes2.relevant);
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                  this.desc = null;
                  this.extras = null;
                  this.medium = null;
                  this.occur = null;
                  this.area = new _xfa_object.XFAObjectArray();
                  this.contentArea = new _xfa_object.XFAObjectArray();
                  this.draw = new _xfa_object.XFAObjectArray();
                  this.exclGroup = new _xfa_object.XFAObjectArray();
                  this.field = new _xfa_object.XFAObjectArray();
                  this.subform = new _xfa_object.XFAObjectArray();
                }
                [_symbol_utils.$isUsable]() {
                  if (!this[_symbol_utils.$extra]) {
                    this[_symbol_utils.$extra] = {
                      numberOfUse: 0
                    };
                    return true;
                  }
                  return !this.occur || this.occur.max === -1 || this[_symbol_utils.$extra].numberOfUse < this.occur.max;
                }
                [_symbol_utils.$cleanPage]() {
                  delete this[_symbol_utils.$extra];
                }
                [_symbol_utils.$getNextPage]() {
                  if (!this[_symbol_utils.$extra]) {
                    this[_symbol_utils.$extra] = {
                      numberOfUse: 0
                    };
                  }
                  const parent2 = this[_symbol_utils.$getParent]();
                  if (parent2.relation === "orderedOccurrence") {
                    if (this[_symbol_utils.$isUsable]()) {
                      this[_symbol_utils.$extra].numberOfUse += 1;
                      return this;
                    }
                  }
                  return parent2[_symbol_utils.$getNextPage]();
                }
                [_symbol_utils.$getAvailableSpace]() {
                  return this[_symbol_utils.$extra].space || {
                    width: 0,
                    height: 0
                  };
                }
                [_symbol_utils.$toHTML]() {
                  if (!this[_symbol_utils.$extra]) {
                    this[_symbol_utils.$extra] = {
                      numberOfUse: 1
                    };
                  }
                  const children = [];
                  this[_symbol_utils.$extra].children = children;
                  const style2 = /* @__PURE__ */ Object.create(null);
                  if (this.medium && this.medium.short && this.medium.long) {
                    style2.width = (0, _html_utils.measureToString)(this.medium.short);
                    style2.height = (0, _html_utils.measureToString)(this.medium.long);
                    this[_symbol_utils.$extra].space = {
                      width: this.medium.short,
                      height: this.medium.long
                    };
                    if (this.medium.orientation === "landscape") {
                      const x = style2.width;
                      style2.width = style2.height;
                      style2.height = x;
                      this[_symbol_utils.$extra].space = {
                        width: this.medium.long,
                        height: this.medium.short
                      };
                    }
                  } else {
                    (0, _util2.warn)("XFA - No medium specified in pageArea: please file a bug.");
                  }
                  this[_symbol_utils.$childrenToHTML]({
                    filter: /* @__PURE__ */ new Set(["area", "draw", "field", "subform"]),
                    include: true
                  });
                  this[_symbol_utils.$childrenToHTML]({
                    filter: /* @__PURE__ */ new Set(["contentArea"]),
                    include: true
                  });
                  return _utils.HTMLResult.success({
                    name: "div",
                    children,
                    attributes: {
                      class: ["xfaPage"],
                      id: this[_symbol_utils.$uid],
                      style: style2,
                      xfaName: this.name
                    }
                  });
                }
              }
              class PageSet extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "pageSet", true);
                  this.duplexImposition = (0, _utils.getStringOption)(attributes2.duplexImposition, ["longEdge", "shortEdge"]);
                  this.id = attributes2.id || "";
                  this.name = attributes2.name || "";
                  this.relation = (0, _utils.getStringOption)(attributes2.relation, ["orderedOccurrence", "duplexPaginated", "simplexPaginated"]);
                  this.relevant = (0, _utils.getRelevant)(attributes2.relevant);
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                  this.extras = null;
                  this.occur = null;
                  this.pageArea = new _xfa_object.XFAObjectArray();
                  this.pageSet = new _xfa_object.XFAObjectArray();
                }
                [_symbol_utils.$cleanPage]() {
                  for (const page of this.pageArea.children) {
                    page[_symbol_utils.$cleanPage]();
                  }
                  for (const page of this.pageSet.children) {
                    page[_symbol_utils.$cleanPage]();
                  }
                }
                [_symbol_utils.$isUsable]() {
                  return !this.occur || this.occur.max === -1 || this[_symbol_utils.$extra].numberOfUse < this.occur.max;
                }
                [_symbol_utils.$getNextPage]() {
                  if (!this[_symbol_utils.$extra]) {
                    this[_symbol_utils.$extra] = {
                      numberOfUse: 1,
                      pageIndex: -1,
                      pageSetIndex: -1
                    };
                  }
                  if (this.relation === "orderedOccurrence") {
                    if (this[_symbol_utils.$extra].pageIndex + 1 < this.pageArea.children.length) {
                      this[_symbol_utils.$extra].pageIndex += 1;
                      const pageArea = this.pageArea.children[this[_symbol_utils.$extra].pageIndex];
                      return pageArea[_symbol_utils.$getNextPage]();
                    }
                    if (this[_symbol_utils.$extra].pageSetIndex + 1 < this.pageSet.children.length) {
                      this[_symbol_utils.$extra].pageSetIndex += 1;
                      return this.pageSet.children[this[_symbol_utils.$extra].pageSetIndex][_symbol_utils.$getNextPage]();
                    }
                    if (this[_symbol_utils.$isUsable]()) {
                      this[_symbol_utils.$extra].numberOfUse += 1;
                      this[_symbol_utils.$extra].pageIndex = -1;
                      this[_symbol_utils.$extra].pageSetIndex = -1;
                      return this[_symbol_utils.$getNextPage]();
                    }
                    const parent2 = this[_symbol_utils.$getParent]();
                    if (parent2 instanceof PageSet) {
                      return parent2[_symbol_utils.$getNextPage]();
                    }
                    this[_symbol_utils.$cleanPage]();
                    return this[_symbol_utils.$getNextPage]();
                  }
                  const pageNumber = this[_symbol_utils.$getTemplateRoot]()[_symbol_utils.$extra].pageNumber;
                  const parity = pageNumber % 2 === 0 ? "even" : "odd";
                  const position3 = pageNumber === 0 ? "first" : "rest";
                  let page = this.pageArea.children.find((p) => p.oddOrEven === parity && p.pagePosition === position3);
                  if (page) {
                    return page;
                  }
                  page = this.pageArea.children.find((p) => p.oddOrEven === "any" && p.pagePosition === position3);
                  if (page) {
                    return page;
                  }
                  page = this.pageArea.children.find((p) => p.oddOrEven === "any" && p.pagePosition === "any");
                  if (page) {
                    return page;
                  }
                  return this.pageArea.children[0];
                }
              }
              class Para extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "para", true);
                  this.hAlign = (0, _utils.getStringOption)(attributes2.hAlign, ["left", "center", "justify", "justifyAll", "radix", "right"]);
                  this.id = attributes2.id || "";
                  this.lineHeight = attributes2.lineHeight ? (0, _utils.getMeasurement)(attributes2.lineHeight, "0pt") : "";
                  this.marginLeft = attributes2.marginLeft ? (0, _utils.getMeasurement)(attributes2.marginLeft, "0pt") : "";
                  this.marginRight = attributes2.marginRight ? (0, _utils.getMeasurement)(attributes2.marginRight, "0pt") : "";
                  this.orphans = (0, _utils.getInteger)({
                    data: attributes2.orphans,
                    defaultValue: 0,
                    validate: (x) => x >= 0
                  });
                  this.preserve = attributes2.preserve || "";
                  this.radixOffset = attributes2.radixOffset ? (0, _utils.getMeasurement)(attributes2.radixOffset, "0pt") : "";
                  this.spaceAbove = attributes2.spaceAbove ? (0, _utils.getMeasurement)(attributes2.spaceAbove, "0pt") : "";
                  this.spaceBelow = attributes2.spaceBelow ? (0, _utils.getMeasurement)(attributes2.spaceBelow, "0pt") : "";
                  this.tabDefault = attributes2.tabDefault ? (0, _utils.getMeasurement)(this.tabDefault) : "";
                  this.tabStops = (attributes2.tabStops || "").trim().split(/\s+/).map((x, i) => i % 2 === 1 ? (0, _utils.getMeasurement)(x) : x);
                  this.textIndent = attributes2.textIndent ? (0, _utils.getMeasurement)(attributes2.textIndent, "0pt") : "";
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                  this.vAlign = (0, _utils.getStringOption)(attributes2.vAlign, ["top", "bottom", "middle"]);
                  this.widows = (0, _utils.getInteger)({
                    data: attributes2.widows,
                    defaultValue: 0,
                    validate: (x) => x >= 0
                  });
                  this.hyphenation = null;
                }
                [_symbol_utils.$toStyle]() {
                  const style2 = (0, _html_utils.toStyle)(this, "hAlign");
                  if (this.marginLeft !== "") {
                    style2.paddingLeft = (0, _html_utils.measureToString)(this.marginLeft);
                  }
                  if (this.marginRight !== "") {
                    style2.paddingight = (0, _html_utils.measureToString)(this.marginRight);
                  }
                  if (this.spaceAbove !== "") {
                    style2.paddingTop = (0, _html_utils.measureToString)(this.spaceAbove);
                  }
                  if (this.spaceBelow !== "") {
                    style2.paddingBottom = (0, _html_utils.measureToString)(this.spaceBelow);
                  }
                  if (this.textIndent !== "") {
                    style2.textIndent = (0, _html_utils.measureToString)(this.textIndent);
                    (0, _html_utils.fixTextIndent)(style2);
                  }
                  if (this.lineHeight > 0) {
                    style2.lineHeight = (0, _html_utils.measureToString)(this.lineHeight);
                  }
                  if (this.tabDefault !== "") {
                    style2.tabSize = (0, _html_utils.measureToString)(this.tabDefault);
                  }
                  if (this.tabStops.length > 0) {
                  }
                  if (this.hyphenatation) {
                    Object.assign(style2, this.hyphenatation[_symbol_utils.$toStyle]());
                  }
                  return style2;
                }
              }
              class PasswordEdit extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "passwordEdit", true);
                  this.hScrollPolicy = (0, _utils.getStringOption)(attributes2.hScrollPolicy, ["auto", "off", "on"]);
                  this.id = attributes2.id || "";
                  this.passwordChar = attributes2.passwordChar || "*";
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                  this.border = null;
                  this.extras = null;
                  this.margin = null;
                }
              }
              class Pattern extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "pattern", true);
                  this.id = attributes2.id || "";
                  this.type = (0, _utils.getStringOption)(attributes2.type, ["crossHatch", "crossDiagonal", "diagonalLeft", "diagonalRight", "horizontal", "vertical"]);
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                  this.color = null;
                  this.extras = null;
                }
                [_symbol_utils.$toStyle](startColor) {
                  startColor = startColor ? startColor[_symbol_utils.$toStyle]() : "#FFFFFF";
                  const endColor = this.color ? this.color[_symbol_utils.$toStyle]() : "#000000";
                  const width = 5;
                  const cmd = "repeating-linear-gradient";
                  const colors = `${startColor},${startColor} ${width}px,${endColor} ${width}px,${endColor} ${2 * width}px`;
                  switch (this.type) {
                    case "crossHatch":
                      return `${cmd}(to top,${colors}) ${cmd}(to right,${colors})`;
                    case "crossDiagonal":
                      return `${cmd}(45deg,${colors}) ${cmd}(-45deg,${colors})`;
                    case "diagonalLeft":
                      return `${cmd}(45deg,${colors})`;
                    case "diagonalRight":
                      return `${cmd}(-45deg,${colors})`;
                    case "horizontal":
                      return `${cmd}(to top,${colors})`;
                    case "vertical":
                      return `${cmd}(to right,${colors})`;
                  }
                  return "";
                }
              }
              class Picture extends _xfa_object.StringObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "picture");
                  this.id = attributes2.id || "";
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                }
              }
              class Proto extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "proto", true);
                  this.appearanceFilter = new _xfa_object.XFAObjectArray();
                  this.arc = new _xfa_object.XFAObjectArray();
                  this.area = new _xfa_object.XFAObjectArray();
                  this.assist = new _xfa_object.XFAObjectArray();
                  this.barcode = new _xfa_object.XFAObjectArray();
                  this.bindItems = new _xfa_object.XFAObjectArray();
                  this.bookend = new _xfa_object.XFAObjectArray();
                  this.boolean = new _xfa_object.XFAObjectArray();
                  this.border = new _xfa_object.XFAObjectArray();
                  this.break = new _xfa_object.XFAObjectArray();
                  this.breakAfter = new _xfa_object.XFAObjectArray();
                  this.breakBefore = new _xfa_object.XFAObjectArray();
                  this.button = new _xfa_object.XFAObjectArray();
                  this.calculate = new _xfa_object.XFAObjectArray();
                  this.caption = new _xfa_object.XFAObjectArray();
                  this.certificate = new _xfa_object.XFAObjectArray();
                  this.certificates = new _xfa_object.XFAObjectArray();
                  this.checkButton = new _xfa_object.XFAObjectArray();
                  this.choiceList = new _xfa_object.XFAObjectArray();
                  this.color = new _xfa_object.XFAObjectArray();
                  this.comb = new _xfa_object.XFAObjectArray();
                  this.connect = new _xfa_object.XFAObjectArray();
                  this.contentArea = new _xfa_object.XFAObjectArray();
                  this.corner = new _xfa_object.XFAObjectArray();
                  this.date = new _xfa_object.XFAObjectArray();
                  this.dateTime = new _xfa_object.XFAObjectArray();
                  this.dateTimeEdit = new _xfa_object.XFAObjectArray();
                  this.decimal = new _xfa_object.XFAObjectArray();
                  this.defaultUi = new _xfa_object.XFAObjectArray();
                  this.desc = new _xfa_object.XFAObjectArray();
                  this.digestMethod = new _xfa_object.XFAObjectArray();
                  this.digestMethods = new _xfa_object.XFAObjectArray();
                  this.draw = new _xfa_object.XFAObjectArray();
                  this.edge = new _xfa_object.XFAObjectArray();
                  this.encoding = new _xfa_object.XFAObjectArray();
                  this.encodings = new _xfa_object.XFAObjectArray();
                  this.encrypt = new _xfa_object.XFAObjectArray();
                  this.encryptData = new _xfa_object.XFAObjectArray();
                  this.encryption = new _xfa_object.XFAObjectArray();
                  this.encryptionMethod = new _xfa_object.XFAObjectArray();
                  this.encryptionMethods = new _xfa_object.XFAObjectArray();
                  this.event = new _xfa_object.XFAObjectArray();
                  this.exData = new _xfa_object.XFAObjectArray();
                  this.exObject = new _xfa_object.XFAObjectArray();
                  this.exclGroup = new _xfa_object.XFAObjectArray();
                  this.execute = new _xfa_object.XFAObjectArray();
                  this.extras = new _xfa_object.XFAObjectArray();
                  this.field = new _xfa_object.XFAObjectArray();
                  this.fill = new _xfa_object.XFAObjectArray();
                  this.filter = new _xfa_object.XFAObjectArray();
                  this.float = new _xfa_object.XFAObjectArray();
                  this.font = new _xfa_object.XFAObjectArray();
                  this.format = new _xfa_object.XFAObjectArray();
                  this.handler = new _xfa_object.XFAObjectArray();
                  this.hyphenation = new _xfa_object.XFAObjectArray();
                  this.image = new _xfa_object.XFAObjectArray();
                  this.imageEdit = new _xfa_object.XFAObjectArray();
                  this.integer = new _xfa_object.XFAObjectArray();
                  this.issuers = new _xfa_object.XFAObjectArray();
                  this.items = new _xfa_object.XFAObjectArray();
                  this.keep = new _xfa_object.XFAObjectArray();
                  this.keyUsage = new _xfa_object.XFAObjectArray();
                  this.line = new _xfa_object.XFAObjectArray();
                  this.linear = new _xfa_object.XFAObjectArray();
                  this.lockDocument = new _xfa_object.XFAObjectArray();
                  this.manifest = new _xfa_object.XFAObjectArray();
                  this.margin = new _xfa_object.XFAObjectArray();
                  this.mdp = new _xfa_object.XFAObjectArray();
                  this.medium = new _xfa_object.XFAObjectArray();
                  this.message = new _xfa_object.XFAObjectArray();
                  this.numericEdit = new _xfa_object.XFAObjectArray();
                  this.occur = new _xfa_object.XFAObjectArray();
                  this.oid = new _xfa_object.XFAObjectArray();
                  this.oids = new _xfa_object.XFAObjectArray();
                  this.overflow = new _xfa_object.XFAObjectArray();
                  this.pageArea = new _xfa_object.XFAObjectArray();
                  this.pageSet = new _xfa_object.XFAObjectArray();
                  this.para = new _xfa_object.XFAObjectArray();
                  this.passwordEdit = new _xfa_object.XFAObjectArray();
                  this.pattern = new _xfa_object.XFAObjectArray();
                  this.picture = new _xfa_object.XFAObjectArray();
                  this.radial = new _xfa_object.XFAObjectArray();
                  this.reason = new _xfa_object.XFAObjectArray();
                  this.reasons = new _xfa_object.XFAObjectArray();
                  this.rectangle = new _xfa_object.XFAObjectArray();
                  this.ref = new _xfa_object.XFAObjectArray();
                  this.script = new _xfa_object.XFAObjectArray();
                  this.setProperty = new _xfa_object.XFAObjectArray();
                  this.signData = new _xfa_object.XFAObjectArray();
                  this.signature = new _xfa_object.XFAObjectArray();
                  this.signing = new _xfa_object.XFAObjectArray();
                  this.solid = new _xfa_object.XFAObjectArray();
                  this.speak = new _xfa_object.XFAObjectArray();
                  this.stipple = new _xfa_object.XFAObjectArray();
                  this.subform = new _xfa_object.XFAObjectArray();
                  this.subformSet = new _xfa_object.XFAObjectArray();
                  this.subjectDN = new _xfa_object.XFAObjectArray();
                  this.subjectDNs = new _xfa_object.XFAObjectArray();
                  this.submit = new _xfa_object.XFAObjectArray();
                  this.text = new _xfa_object.XFAObjectArray();
                  this.textEdit = new _xfa_object.XFAObjectArray();
                  this.time = new _xfa_object.XFAObjectArray();
                  this.timeStamp = new _xfa_object.XFAObjectArray();
                  this.toolTip = new _xfa_object.XFAObjectArray();
                  this.traversal = new _xfa_object.XFAObjectArray();
                  this.traverse = new _xfa_object.XFAObjectArray();
                  this.ui = new _xfa_object.XFAObjectArray();
                  this.validate = new _xfa_object.XFAObjectArray();
                  this.value = new _xfa_object.XFAObjectArray();
                  this.variables = new _xfa_object.XFAObjectArray();
                }
              }
              class Radial extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "radial", true);
                  this.id = attributes2.id || "";
                  this.type = (0, _utils.getStringOption)(attributes2.type, ["toEdge", "toCenter"]);
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                  this.color = null;
                  this.extras = null;
                }
                [_symbol_utils.$toStyle](startColor) {
                  startColor = startColor ? startColor[_symbol_utils.$toStyle]() : "#FFFFFF";
                  const endColor = this.color ? this.color[_symbol_utils.$toStyle]() : "#000000";
                  const colors = this.type === "toEdge" ? `${startColor},${endColor}` : `${endColor},${startColor}`;
                  return `radial-gradient(circle at center, ${colors})`;
                }
              }
              class Reason extends _xfa_object.StringObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "reason");
                  this.id = attributes2.id || "";
                  this.name = attributes2.name || "";
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                }
              }
              class Reasons extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "reasons", true);
                  this.id = attributes2.id || "";
                  this.type = (0, _utils.getStringOption)(attributes2.type, ["optional", "required"]);
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                  this.reason = new _xfa_object.XFAObjectArray();
                }
              }
              class Rectangle extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "rectangle", true);
                  this.hand = (0, _utils.getStringOption)(attributes2.hand, ["even", "left", "right"]);
                  this.id = attributes2.id || "";
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                  this.corner = new _xfa_object.XFAObjectArray(4);
                  this.edge = new _xfa_object.XFAObjectArray(4);
                  this.fill = null;
                }
                [_symbol_utils.$toHTML]() {
                  const edge = this.edge.children.length ? this.edge.children[0] : new Edge({});
                  const edgeStyle = edge[_symbol_utils.$toStyle]();
                  const style2 = /* @__PURE__ */ Object.create(null);
                  if (this.fill?.presence === "visible") {
                    Object.assign(style2, this.fill[_symbol_utils.$toStyle]());
                  } else {
                    style2.fill = "transparent";
                  }
                  style2.strokeWidth = (0, _html_utils.measureToString)(edge.presence === "visible" ? edge.thickness : 0);
                  style2.stroke = edgeStyle.color;
                  const corner = this.corner.children.length ? this.corner.children[0] : new Corner({});
                  const cornerStyle = corner[_symbol_utils.$toStyle]();
                  const rect = {
                    name: "rect",
                    attributes: {
                      xmlns: SVG_NS,
                      width: "100%",
                      height: "100%",
                      x: 0,
                      y: 0,
                      rx: cornerStyle.radius,
                      ry: cornerStyle.radius,
                      style: style2
                    }
                  };
                  const svg = {
                    name: "svg",
                    children: [rect],
                    attributes: {
                      xmlns: SVG_NS,
                      style: {
                        overflow: "visible"
                      },
                      width: "100%",
                      height: "100%"
                    }
                  };
                  const parent2 = this[_symbol_utils.$getParent]()[_symbol_utils.$getParent]();
                  if (hasMargin(parent2)) {
                    return _utils.HTMLResult.success({
                      name: "div",
                      attributes: {
                        style: {
                          display: "inline",
                          width: "100%",
                          height: "100%"
                        }
                      },
                      children: [svg]
                    });
                  }
                  svg.attributes.style.position = "absolute";
                  return _utils.HTMLResult.success(svg);
                }
              }
              class RefElement extends _xfa_object.StringObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "ref");
                  this.id = attributes2.id || "";
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                }
              }
              class Script extends _xfa_object.StringObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "script");
                  this.binding = attributes2.binding || "";
                  this.contentType = attributes2.contentType || "";
                  this.id = attributes2.id || "";
                  this.name = attributes2.name || "";
                  this.runAt = (0, _utils.getStringOption)(attributes2.runAt, ["client", "both", "server"]);
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                }
              }
              class SetProperty extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "setProperty");
                  this.connection = attributes2.connection || "";
                  this.ref = attributes2.ref || "";
                  this.target = attributes2.target || "";
                }
              }
              exports3.SetProperty = SetProperty;
              class SignData extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "signData", true);
                  this.id = attributes2.id || "";
                  this.operation = (0, _utils.getStringOption)(attributes2.operation, ["sign", "clear", "verify"]);
                  this.ref = attributes2.ref || "";
                  this.target = attributes2.target || "";
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                  this.filter = null;
                  this.manifest = null;
                }
              }
              class Signature extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "signature", true);
                  this.id = attributes2.id || "";
                  this.type = (0, _utils.getStringOption)(attributes2.type, ["PDF1.3", "PDF1.6"]);
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                  this.border = null;
                  this.extras = null;
                  this.filter = null;
                  this.manifest = null;
                  this.margin = null;
                }
              }
              class Signing extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "signing", true);
                  this.id = attributes2.id || "";
                  this.type = (0, _utils.getStringOption)(attributes2.type, ["optional", "required"]);
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                  this.certificate = new _xfa_object.XFAObjectArray();
                }
              }
              class Solid extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "solid", true);
                  this.id = attributes2.id || "";
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                  this.extras = null;
                }
                [_symbol_utils.$toStyle](startColor) {
                  return startColor ? startColor[_symbol_utils.$toStyle]() : "#FFFFFF";
                }
              }
              class Speak extends _xfa_object.StringObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "speak");
                  this.disable = (0, _utils.getInteger)({
                    data: attributes2.disable,
                    defaultValue: 0,
                    validate: (x) => x === 1
                  });
                  this.id = attributes2.id || "";
                  this.priority = (0, _utils.getStringOption)(attributes2.priority, ["custom", "caption", "name", "toolTip"]);
                  this.rid = attributes2.rid || "";
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                }
              }
              class Stipple extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "stipple", true);
                  this.id = attributes2.id || "";
                  this.rate = (0, _utils.getInteger)({
                    data: attributes2.rate,
                    defaultValue: 50,
                    validate: (x) => x >= 0 && x <= 100
                  });
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                  this.color = null;
                  this.extras = null;
                }
                [_symbol_utils.$toStyle](bgColor) {
                  const alpha = this.rate / 100;
                  return _util2.Util.makeHexColor(Math.round(bgColor.value.r * (1 - alpha) + this.value.r * alpha), Math.round(bgColor.value.g * (1 - alpha) + this.value.g * alpha), Math.round(bgColor.value.b * (1 - alpha) + this.value.b * alpha));
                }
              }
              class Subform extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "subform", true);
                  this.access = (0, _utils.getStringOption)(attributes2.access, ["open", "nonInteractive", "protected", "readOnly"]);
                  this.allowMacro = (0, _utils.getInteger)({
                    data: attributes2.allowMacro,
                    defaultValue: 0,
                    validate: (x) => x === 1
                  });
                  this.anchorType = (0, _utils.getStringOption)(attributes2.anchorType, ["topLeft", "bottomCenter", "bottomLeft", "bottomRight", "middleCenter", "middleLeft", "middleRight", "topCenter", "topRight"]);
                  this.colSpan = (0, _utils.getInteger)({
                    data: attributes2.colSpan,
                    defaultValue: 1,
                    validate: (n2) => n2 >= 1 || n2 === -1
                  });
                  this.columnWidths = (attributes2.columnWidths || "").trim().split(/\s+/).map((x) => x === "-1" ? -1 : (0, _utils.getMeasurement)(x));
                  this.h = attributes2.h ? (0, _utils.getMeasurement)(attributes2.h) : "";
                  this.hAlign = (0, _utils.getStringOption)(attributes2.hAlign, ["left", "center", "justify", "justifyAll", "radix", "right"]);
                  this.id = attributes2.id || "";
                  this.layout = (0, _utils.getStringOption)(attributes2.layout, ["position", "lr-tb", "rl-row", "rl-tb", "row", "table", "tb"]);
                  this.locale = attributes2.locale || "";
                  this.maxH = (0, _utils.getMeasurement)(attributes2.maxH, "0pt");
                  this.maxW = (0, _utils.getMeasurement)(attributes2.maxW, "0pt");
                  this.mergeMode = (0, _utils.getStringOption)(attributes2.mergeMode, ["consumeData", "matchTemplate"]);
                  this.minH = (0, _utils.getMeasurement)(attributes2.minH, "0pt");
                  this.minW = (0, _utils.getMeasurement)(attributes2.minW, "0pt");
                  this.name = attributes2.name || "";
                  this.presence = (0, _utils.getStringOption)(attributes2.presence, ["visible", "hidden", "inactive", "invisible"]);
                  this.relevant = (0, _utils.getRelevant)(attributes2.relevant);
                  this.restoreState = (0, _utils.getStringOption)(attributes2.restoreState, ["manual", "auto"]);
                  this.scope = (0, _utils.getStringOption)(attributes2.scope, ["name", "none"]);
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                  this.w = attributes2.w ? (0, _utils.getMeasurement)(attributes2.w) : "";
                  this.x = (0, _utils.getMeasurement)(attributes2.x, "0pt");
                  this.y = (0, _utils.getMeasurement)(attributes2.y, "0pt");
                  this.assist = null;
                  this.bind = null;
                  this.bookend = null;
                  this.border = null;
                  this.break = null;
                  this.calculate = null;
                  this.desc = null;
                  this.extras = null;
                  this.keep = null;
                  this.margin = null;
                  this.occur = null;
                  this.overflow = null;
                  this.pageSet = null;
                  this.para = null;
                  this.traversal = null;
                  this.validate = null;
                  this.variables = null;
                  this.area = new _xfa_object.XFAObjectArray();
                  this.breakAfter = new _xfa_object.XFAObjectArray();
                  this.breakBefore = new _xfa_object.XFAObjectArray();
                  this.connect = new _xfa_object.XFAObjectArray();
                  this.draw = new _xfa_object.XFAObjectArray();
                  this.event = new _xfa_object.XFAObjectArray();
                  this.exObject = new _xfa_object.XFAObjectArray();
                  this.exclGroup = new _xfa_object.XFAObjectArray();
                  this.field = new _xfa_object.XFAObjectArray();
                  this.proto = new _xfa_object.XFAObjectArray();
                  this.setProperty = new _xfa_object.XFAObjectArray();
                  this.subform = new _xfa_object.XFAObjectArray();
                  this.subformSet = new _xfa_object.XFAObjectArray();
                }
                [_symbol_utils.$getSubformParent]() {
                  const parent2 = this[_symbol_utils.$getParent]();
                  if (parent2 instanceof SubformSet) {
                    return parent2[_symbol_utils.$getSubformParent]();
                  }
                  return parent2;
                }
                [_symbol_utils.$isBindable]() {
                  return true;
                }
                [_symbol_utils.$isThereMoreWidth]() {
                  return this.layout.endsWith("-tb") && this[_symbol_utils.$extra].attempt === 0 && this[_symbol_utils.$extra].numberInLine > 0 || this[_symbol_utils.$getParent]()[_symbol_utils.$isThereMoreWidth]();
                }
                *[_symbol_utils.$getContainedChildren]() {
                  yield* getContainedChildren(this);
                }
                [_symbol_utils.$flushHTML]() {
                  return (0, _layout.flushHTML)(this);
                }
                [_symbol_utils.$addHTML](html2, bbox) {
                  (0, _layout.addHTML)(this, html2, bbox);
                }
                [_symbol_utils.$getAvailableSpace]() {
                  return (0, _layout.getAvailableSpace)(this);
                }
                [_symbol_utils.$isSplittable]() {
                  const parent2 = this[_symbol_utils.$getSubformParent]();
                  if (!parent2[_symbol_utils.$isSplittable]()) {
                    return false;
                  }
                  if (this[_symbol_utils.$extra]._isSplittable !== void 0) {
                    return this[_symbol_utils.$extra]._isSplittable;
                  }
                  if (this.layout === "position" || this.layout.includes("row")) {
                    this[_symbol_utils.$extra]._isSplittable = false;
                    return false;
                  }
                  if (this.keep && this.keep.intact !== "none") {
                    this[_symbol_utils.$extra]._isSplittable = false;
                    return false;
                  }
                  if (parent2.layout?.endsWith("-tb") && parent2[_symbol_utils.$extra].numberInLine !== 0) {
                    return false;
                  }
                  this[_symbol_utils.$extra]._isSplittable = true;
                  return true;
                }
                [_symbol_utils.$toHTML](availableSpace) {
                  setTabIndex(this);
                  if (this.break) {
                    if (this.break.after !== "auto" || this.break.afterTarget !== "") {
                      const node2 = new BreakAfter({
                        targetType: this.break.after,
                        target: this.break.afterTarget,
                        startNew: this.break.startNew.toString()
                      });
                      node2[_symbol_utils.$globalData] = this[_symbol_utils.$globalData];
                      this[_symbol_utils.$appendChild](node2);
                      this.breakAfter.push(node2);
                    }
                    if (this.break.before !== "auto" || this.break.beforeTarget !== "") {
                      const node2 = new BreakBefore({
                        targetType: this.break.before,
                        target: this.break.beforeTarget,
                        startNew: this.break.startNew.toString()
                      });
                      node2[_symbol_utils.$globalData] = this[_symbol_utils.$globalData];
                      this[_symbol_utils.$appendChild](node2);
                      this.breakBefore.push(node2);
                    }
                    if (this.break.overflowTarget !== "") {
                      const node2 = new Overflow2({
                        target: this.break.overflowTarget,
                        leader: this.break.overflowLeader,
                        trailer: this.break.overflowTrailer
                      });
                      node2[_symbol_utils.$globalData] = this[_symbol_utils.$globalData];
                      this[_symbol_utils.$appendChild](node2);
                      this.overflow.push(node2);
                    }
                    this[_symbol_utils.$removeChild](this.break);
                    this.break = null;
                  }
                  if (this.presence === "hidden" || this.presence === "inactive") {
                    return _utils.HTMLResult.EMPTY;
                  }
                  if (this.breakBefore.children.length > 1 || this.breakAfter.children.length > 1) {
                    (0, _util2.warn)("XFA - Several breakBefore or breakAfter in subforms: please file a bug.");
                  }
                  if (this.breakBefore.children.length >= 1) {
                    const breakBefore = this.breakBefore.children[0];
                    if (handleBreak(breakBefore)) {
                      return _utils.HTMLResult.breakNode(breakBefore);
                    }
                  }
                  if (this[_symbol_utils.$extra]?.afterBreakAfter) {
                    return _utils.HTMLResult.EMPTY;
                  }
                  (0, _html_utils.fixDimensions)(this);
                  const children = [];
                  const attributes2 = {
                    id: this[_symbol_utils.$uid],
                    class: []
                  };
                  (0, _html_utils.setAccess)(this, attributes2.class);
                  if (!this[_symbol_utils.$extra]) {
                    this[_symbol_utils.$extra] = /* @__PURE__ */ Object.create(null);
                  }
                  Object.assign(this[_symbol_utils.$extra], {
                    children,
                    line: null,
                    attributes: attributes2,
                    attempt: 0,
                    numberInLine: 0,
                    availableSpace: {
                      width: Math.min(this.w || Infinity, availableSpace.width),
                      height: Math.min(this.h || Infinity, availableSpace.height)
                    },
                    width: 0,
                    height: 0,
                    prevHeight: 0,
                    currentWidth: 0
                  });
                  const root2 = this[_symbol_utils.$getTemplateRoot]();
                  const savedNoLayoutFailure = root2[_symbol_utils.$extra].noLayoutFailure;
                  const isSplittable = this[_symbol_utils.$isSplittable]();
                  if (!isSplittable) {
                    setFirstUnsplittable(this);
                  }
                  if (!(0, _layout.checkDimensions)(this, availableSpace)) {
                    return _utils.HTMLResult.FAILURE;
                  }
                  const filter3 = /* @__PURE__ */ new Set(["area", "draw", "exclGroup", "field", "subform", "subformSet"]);
                  if (this.layout.includes("row")) {
                    const columnWidths = this[_symbol_utils.$getSubformParent]().columnWidths;
                    if (Array.isArray(columnWidths) && columnWidths.length > 0) {
                      this[_symbol_utils.$extra].columnWidths = columnWidths;
                      this[_symbol_utils.$extra].currentColumn = 0;
                    }
                  }
                  const style2 = (0, _html_utils.toStyle)(this, "anchorType", "dimensions", "position", "presence", "border", "margin", "hAlign");
                  const classNames186 = ["xfaSubform"];
                  const cl = (0, _html_utils.layoutClass)(this);
                  if (cl) {
                    classNames186.push(cl);
                  }
                  attributes2.style = style2;
                  attributes2.class = classNames186;
                  if (this.name) {
                    attributes2.xfaName = this.name;
                  }
                  if (this.overflow) {
                    const overflowExtra = this.overflow[_symbol_utils.$getExtra]();
                    if (overflowExtra.addLeader) {
                      overflowExtra.addLeader = false;
                      handleOverflow(this, overflowExtra.leader, availableSpace);
                    }
                  }
                  this[_symbol_utils.$pushPara]();
                  const isLrTb = this.layout === "lr-tb" || this.layout === "rl-tb";
                  const maxRun = isLrTb ? MAX_ATTEMPTS_FOR_LRTB_LAYOUT : 1;
                  for (; this[_symbol_utils.$extra].attempt < maxRun; this[_symbol_utils.$extra].attempt++) {
                    if (isLrTb && this[_symbol_utils.$extra].attempt === MAX_ATTEMPTS_FOR_LRTB_LAYOUT - 1) {
                      this[_symbol_utils.$extra].numberInLine = 0;
                    }
                    const result2 = this[_symbol_utils.$childrenToHTML]({
                      filter: filter3,
                      include: true
                    });
                    if (result2.success) {
                      break;
                    }
                    if (result2.isBreak()) {
                      this[_symbol_utils.$popPara]();
                      return result2;
                    }
                    if (isLrTb && this[_symbol_utils.$extra].attempt === 0 && this[_symbol_utils.$extra].numberInLine === 0 && !root2[_symbol_utils.$extra].noLayoutFailure) {
                      this[_symbol_utils.$extra].attempt = maxRun;
                      break;
                    }
                  }
                  this[_symbol_utils.$popPara]();
                  if (!isSplittable) {
                    unsetFirstUnsplittable(this);
                  }
                  root2[_symbol_utils.$extra].noLayoutFailure = savedNoLayoutFailure;
                  if (this[_symbol_utils.$extra].attempt === maxRun) {
                    if (this.overflow) {
                      this[_symbol_utils.$getTemplateRoot]()[_symbol_utils.$extra].overflowNode = this.overflow;
                    }
                    if (!isSplittable) {
                      delete this[_symbol_utils.$extra];
                    }
                    return _utils.HTMLResult.FAILURE;
                  }
                  if (this.overflow) {
                    const overflowExtra = this.overflow[_symbol_utils.$getExtra]();
                    if (overflowExtra.addTrailer) {
                      overflowExtra.addTrailer = false;
                      handleOverflow(this, overflowExtra.trailer, availableSpace);
                    }
                  }
                  let marginH = 0;
                  let marginV = 0;
                  if (this.margin) {
                    marginH = this.margin.leftInset + this.margin.rightInset;
                    marginV = this.margin.topInset + this.margin.bottomInset;
                  }
                  const width = Math.max(this[_symbol_utils.$extra].width + marginH, this.w || 0);
                  const height = Math.max(this[_symbol_utils.$extra].height + marginV, this.h || 0);
                  const bbox = [this.x, this.y, width, height];
                  if (this.w === "") {
                    style2.width = (0, _html_utils.measureToString)(width);
                  }
                  if (this.h === "") {
                    style2.height = (0, _html_utils.measureToString)(height);
                  }
                  if ((style2.width === "0px" || style2.height === "0px") && children.length === 0) {
                    return _utils.HTMLResult.EMPTY;
                  }
                  const html2 = {
                    name: "div",
                    attributes: attributes2,
                    children
                  };
                  applyAssist(this, attributes2);
                  const result = _utils.HTMLResult.success((0, _html_utils.createWrapper)(this, html2), bbox);
                  if (this.breakAfter.children.length >= 1) {
                    const breakAfter = this.breakAfter.children[0];
                    if (handleBreak(breakAfter)) {
                      this[_symbol_utils.$extra].afterBreakAfter = result;
                      return _utils.HTMLResult.breakNode(breakAfter);
                    }
                  }
                  delete this[_symbol_utils.$extra];
                  return result;
                }
              }
              class SubformSet extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "subformSet", true);
                  this.id = attributes2.id || "";
                  this.name = attributes2.name || "";
                  this.relation = (0, _utils.getStringOption)(attributes2.relation, ["ordered", "choice", "unordered"]);
                  this.relevant = (0, _utils.getRelevant)(attributes2.relevant);
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                  this.bookend = null;
                  this.break = null;
                  this.desc = null;
                  this.extras = null;
                  this.occur = null;
                  this.overflow = null;
                  this.breakAfter = new _xfa_object.XFAObjectArray();
                  this.breakBefore = new _xfa_object.XFAObjectArray();
                  this.subform = new _xfa_object.XFAObjectArray();
                  this.subformSet = new _xfa_object.XFAObjectArray();
                }
                *[_symbol_utils.$getContainedChildren]() {
                  yield* getContainedChildren(this);
                }
                [_symbol_utils.$getSubformParent]() {
                  let parent2 = this[_symbol_utils.$getParent]();
                  while (!(parent2 instanceof Subform)) {
                    parent2 = parent2[_symbol_utils.$getParent]();
                  }
                  return parent2;
                }
                [_symbol_utils.$isBindable]() {
                  return true;
                }
              }
              class SubjectDN extends _xfa_object.ContentObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "subjectDN");
                  this.delimiter = attributes2.delimiter || ",";
                  this.id = attributes2.id || "";
                  this.name = attributes2.name || "";
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                }
                [_symbol_utils.$finalize]() {
                  this[_symbol_utils.$content] = new Map(this[_symbol_utils.$content].split(this.delimiter).map((kv) => {
                    kv = kv.split("=", 2);
                    kv[0] = kv[0].trim();
                    return kv;
                  }));
                }
              }
              class SubjectDNs extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "subjectDNs", true);
                  this.id = attributes2.id || "";
                  this.type = (0, _utils.getStringOption)(attributes2.type, ["optional", "required"]);
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                  this.subjectDN = new _xfa_object.XFAObjectArray();
                }
              }
              class Submit extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "submit", true);
                  this.embedPDF = (0, _utils.getInteger)({
                    data: attributes2.embedPDF,
                    defaultValue: 0,
                    validate: (x) => x === 1
                  });
                  this.format = (0, _utils.getStringOption)(attributes2.format, ["xdp", "formdata", "pdf", "urlencoded", "xfd", "xml"]);
                  this.id = attributes2.id || "";
                  this.target = attributes2.target || "";
                  this.textEncoding = (0, _utils.getKeyword)({
                    data: attributes2.textEncoding ? attributes2.textEncoding.toLowerCase() : "",
                    defaultValue: "",
                    validate: (k) => ["utf-8", "big-five", "fontspecific", "gbk", "gb-18030", "gb-2312", "ksc-5601", "none", "shift-jis", "ucs-2", "utf-16"].includes(k) || k.match(/iso-8859-\d{2}/)
                  });
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                  this.xdpContent = attributes2.xdpContent || "";
                  this.encrypt = null;
                  this.encryptData = new _xfa_object.XFAObjectArray();
                  this.signData = new _xfa_object.XFAObjectArray();
                }
              }
              class Template9 extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "template", true);
                  this.baseProfile = (0, _utils.getStringOption)(attributes2.baseProfile, ["full", "interactiveForms"]);
                  this.extras = null;
                  this.subform = new _xfa_object.XFAObjectArray();
                }
                [_symbol_utils.$finalize]() {
                  if (this.subform.children.length === 0) {
                    (0, _util2.warn)("XFA - No subforms in template node.");
                  }
                  if (this.subform.children.length >= 2) {
                    (0, _util2.warn)("XFA - Several subforms in template node: please file a bug.");
                  }
                  this[_symbol_utils.$tabIndex] = DEFAULT_TAB_INDEX;
                }
                [_symbol_utils.$isSplittable]() {
                  return true;
                }
                [_symbol_utils.$searchNode](expr, container) {
                  if (expr.startsWith("#")) {
                    return [this[_symbol_utils.$ids].get(expr.slice(1))];
                  }
                  return (0, _som.searchNode)(this, container, expr, true, true);
                }
                *[_symbol_utils.$toPages]() {
                  if (!this.subform.children.length) {
                    return _utils.HTMLResult.success({
                      name: "div",
                      children: []
                    });
                  }
                  this[_symbol_utils.$extra] = {
                    overflowNode: null,
                    firstUnsplittable: null,
                    currentContentArea: null,
                    currentPageArea: null,
                    noLayoutFailure: false,
                    pageNumber: 1,
                    pagePosition: "first",
                    oddOrEven: "odd",
                    blankOrNotBlank: "nonBlank",
                    paraStack: []
                  };
                  const root2 = this.subform.children[0];
                  root2.pageSet[_symbol_utils.$cleanPage]();
                  const pageAreas = root2.pageSet.pageArea.children;
                  const mainHtml = {
                    name: "div",
                    children: []
                  };
                  let pageArea = null;
                  let breakBefore = null;
                  let breakBeforeTarget = null;
                  if (root2.breakBefore.children.length >= 1) {
                    breakBefore = root2.breakBefore.children[0];
                    breakBeforeTarget = breakBefore.target;
                  } else if (root2.subform.children.length >= 1 && root2.subform.children[0].breakBefore.children.length >= 1) {
                    breakBefore = root2.subform.children[0].breakBefore.children[0];
                    breakBeforeTarget = breakBefore.target;
                  } else if (root2.break?.beforeTarget) {
                    breakBefore = root2.break;
                    breakBeforeTarget = breakBefore.beforeTarget;
                  } else if (root2.subform.children.length >= 1 && root2.subform.children[0].break?.beforeTarget) {
                    breakBefore = root2.subform.children[0].break;
                    breakBeforeTarget = breakBefore.beforeTarget;
                  }
                  if (breakBefore) {
                    const target = this[_symbol_utils.$searchNode](breakBeforeTarget, breakBefore[_symbol_utils.$getParent]());
                    if (target instanceof PageArea) {
                      pageArea = target;
                      breakBefore[_symbol_utils.$extra] = {};
                    }
                  }
                  if (!pageArea) {
                    pageArea = pageAreas[0];
                  }
                  pageArea[_symbol_utils.$extra] = {
                    numberOfUse: 1
                  };
                  const pageAreaParent = pageArea[_symbol_utils.$getParent]();
                  pageAreaParent[_symbol_utils.$extra] = {
                    numberOfUse: 1,
                    pageIndex: pageAreaParent.pageArea.children.indexOf(pageArea),
                    pageSetIndex: 0
                  };
                  let targetPageArea;
                  let leader = null;
                  let trailer = null;
                  let hasSomething = true;
                  let hasSomethingCounter = 0;
                  let startIndex = 0;
                  while (true) {
                    if (!hasSomething) {
                      mainHtml.children.pop();
                      if (++hasSomethingCounter === MAX_EMPTY_PAGES) {
                        (0, _util2.warn)("XFA - Something goes wrong: please file a bug.");
                        return mainHtml;
                      }
                    } else {
                      hasSomethingCounter = 0;
                    }
                    targetPageArea = null;
                    this[_symbol_utils.$extra].currentPageArea = pageArea;
                    const page = pageArea[_symbol_utils.$toHTML]().html;
                    mainHtml.children.push(page);
                    if (leader) {
                      this[_symbol_utils.$extra].noLayoutFailure = true;
                      page.children.push(leader[_symbol_utils.$toHTML](pageArea[_symbol_utils.$extra].space).html);
                      leader = null;
                    }
                    if (trailer) {
                      this[_symbol_utils.$extra].noLayoutFailure = true;
                      page.children.push(trailer[_symbol_utils.$toHTML](pageArea[_symbol_utils.$extra].space).html);
                      trailer = null;
                    }
                    const contentAreas = pageArea.contentArea.children;
                    const htmlContentAreas = page.children.filter((node2) => node2.attributes.class.includes("xfaContentarea"));
                    hasSomething = false;
                    this[_symbol_utils.$extra].firstUnsplittable = null;
                    this[_symbol_utils.$extra].noLayoutFailure = false;
                    const flush = (index3) => {
                      const html2 = root2[_symbol_utils.$flushHTML]();
                      if (html2) {
                        hasSomething ||= html2.children?.length > 0;
                        htmlContentAreas[index3].children.push(html2);
                      }
                    };
                    for (let i = startIndex, ii = contentAreas.length; i < ii; i++) {
                      const contentArea = this[_symbol_utils.$extra].currentContentArea = contentAreas[i];
                      const space = {
                        width: contentArea.w,
                        height: contentArea.h
                      };
                      startIndex = 0;
                      if (leader) {
                        htmlContentAreas[i].children.push(leader[_symbol_utils.$toHTML](space).html);
                        leader = null;
                      }
                      if (trailer) {
                        htmlContentAreas[i].children.push(trailer[_symbol_utils.$toHTML](space).html);
                        trailer = null;
                      }
                      const html2 = root2[_symbol_utils.$toHTML](space);
                      if (html2.success) {
                        if (html2.html) {
                          hasSomething ||= html2.html.children?.length > 0;
                          htmlContentAreas[i].children.push(html2.html);
                        } else if (!hasSomething && mainHtml.children.length > 1) {
                          mainHtml.children.pop();
                        }
                        return mainHtml;
                      }
                      if (html2.isBreak()) {
                        const node2 = html2.breakNode;
                        flush(i);
                        if (node2.targetType === "auto") {
                          continue;
                        }
                        if (node2.leader) {
                          leader = this[_symbol_utils.$searchNode](node2.leader, node2[_symbol_utils.$getParent]());
                          leader = leader ? leader[0] : null;
                        }
                        if (node2.trailer) {
                          trailer = this[_symbol_utils.$searchNode](node2.trailer, node2[_symbol_utils.$getParent]());
                          trailer = trailer ? trailer[0] : null;
                        }
                        if (node2.targetType === "pageArea") {
                          targetPageArea = node2[_symbol_utils.$extra].target;
                          i = Infinity;
                        } else if (!node2[_symbol_utils.$extra].target) {
                          i = node2[_symbol_utils.$extra].index;
                        } else {
                          targetPageArea = node2[_symbol_utils.$extra].target;
                          startIndex = node2[_symbol_utils.$extra].index + 1;
                          i = Infinity;
                        }
                        continue;
                      }
                      if (this[_symbol_utils.$extra].overflowNode) {
                        const node2 = this[_symbol_utils.$extra].overflowNode;
                        this[_symbol_utils.$extra].overflowNode = null;
                        const overflowExtra = node2[_symbol_utils.$getExtra]();
                        const target = overflowExtra.target;
                        overflowExtra.addLeader = overflowExtra.leader !== null;
                        overflowExtra.addTrailer = overflowExtra.trailer !== null;
                        flush(i);
                        const currentIndex = i;
                        i = Infinity;
                        if (target instanceof PageArea) {
                          targetPageArea = target;
                        } else if (target instanceof ContentArea) {
                          const index3 = contentAreas.indexOf(target);
                          if (index3 !== -1) {
                            if (index3 > currentIndex) {
                              i = index3 - 1;
                            } else {
                              startIndex = index3;
                            }
                          } else {
                            targetPageArea = target[_symbol_utils.$getParent]();
                            startIndex = targetPageArea.contentArea.children.indexOf(target);
                          }
                        }
                        continue;
                      }
                      flush(i);
                    }
                    this[_symbol_utils.$extra].pageNumber += 1;
                    if (targetPageArea) {
                      if (targetPageArea[_symbol_utils.$isUsable]()) {
                        targetPageArea[_symbol_utils.$extra].numberOfUse += 1;
                      } else {
                        targetPageArea = null;
                      }
                    }
                    pageArea = targetPageArea || pageArea[_symbol_utils.$getNextPage]();
                    yield null;
                  }
                }
              }
              exports3.Template = Template9;
              class Text7 extends _xfa_object.ContentObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "text");
                  this.id = attributes2.id || "";
                  this.maxChars = (0, _utils.getInteger)({
                    data: attributes2.maxChars,
                    defaultValue: 0,
                    validate: (x) => x >= 0
                  });
                  this.name = attributes2.name || "";
                  this.rid = attributes2.rid || "";
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                }
                [_symbol_utils.$acceptWhitespace]() {
                  return true;
                }
                [_symbol_utils.$onChild](child) {
                  if (child[_symbol_utils.$namespaceId] === _namespaces.NamespaceIds.xhtml.id) {
                    this[_symbol_utils.$content] = child;
                    return true;
                  }
                  (0, _util2.warn)(`XFA - Invalid content in Text: ${child[_symbol_utils.$nodeName]}.`);
                  return false;
                }
                [_symbol_utils.$onText](str) {
                  if (this[_symbol_utils.$content] instanceof _xfa_object.XFAObject) {
                    return;
                  }
                  super[_symbol_utils.$onText](str);
                }
                [_symbol_utils.$finalize]() {
                  if (typeof this[_symbol_utils.$content] === "string") {
                    this[_symbol_utils.$content] = this[_symbol_utils.$content].replaceAll("\r\n", "\n");
                  }
                }
                [_symbol_utils.$getExtra]() {
                  if (typeof this[_symbol_utils.$content] === "string") {
                    return this[_symbol_utils.$content].split(/[\u2029\u2028\n]/).reduce((acc, line2) => {
                      if (line2) {
                        acc.push(line2);
                      }
                      return acc;
                    }, []).join("\n");
                  }
                  return this[_symbol_utils.$content][_symbol_utils.$text]();
                }
                [_symbol_utils.$toHTML](availableSpace) {
                  if (typeof this[_symbol_utils.$content] === "string") {
                    const html2 = valueToHtml(this[_symbol_utils.$content]).html;
                    if (this[_symbol_utils.$content].includes("\u2029")) {
                      html2.name = "div";
                      html2.children = [];
                      this[_symbol_utils.$content].split("\u2029").map((para) => para.split(/[\u2028\n]/).reduce((acc, line2) => {
                        acc.push({
                          name: "span",
                          value: line2
                        }, {
                          name: "br"
                        });
                        return acc;
                      }, [])).forEach((lines) => {
                        html2.children.push({
                          name: "p",
                          children: lines
                        });
                      });
                    } else if (/[\u2028\n]/.test(this[_symbol_utils.$content])) {
                      html2.name = "div";
                      html2.children = [];
                      this[_symbol_utils.$content].split(/[\u2028\n]/).forEach((line2) => {
                        html2.children.push({
                          name: "span",
                          value: line2
                        }, {
                          name: "br"
                        });
                      });
                    }
                    return _utils.HTMLResult.success(html2);
                  }
                  return this[_symbol_utils.$content][_symbol_utils.$toHTML](availableSpace);
                }
              }
              exports3.Text = Text7;
              class TextEdit extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "textEdit", true);
                  this.allowRichText = (0, _utils.getInteger)({
                    data: attributes2.allowRichText,
                    defaultValue: 0,
                    validate: (x) => x === 1
                  });
                  this.hScrollPolicy = (0, _utils.getStringOption)(attributes2.hScrollPolicy, ["auto", "off", "on"]);
                  this.id = attributes2.id || "";
                  this.multiLine = (0, _utils.getInteger)({
                    data: attributes2.multiLine,
                    defaultValue: "",
                    validate: (x) => x === 0 || x === 1
                  });
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                  this.vScrollPolicy = (0, _utils.getStringOption)(attributes2.vScrollPolicy, ["auto", "off", "on"]);
                  this.border = null;
                  this.comb = null;
                  this.extras = null;
                  this.margin = null;
                }
                [_symbol_utils.$toHTML](availableSpace) {
                  const style2 = (0, _html_utils.toStyle)(this, "border", "font", "margin");
                  let html2;
                  const field = this[_symbol_utils.$getParent]()[_symbol_utils.$getParent]();
                  if (this.multiLine === "") {
                    this.multiLine = field instanceof Draw ? 1 : 0;
                  }
                  if (this.multiLine === 1) {
                    html2 = {
                      name: "textarea",
                      attributes: {
                        dataId: field[_symbol_utils.$data]?.[_symbol_utils.$uid] || field[_symbol_utils.$uid],
                        fieldId: field[_symbol_utils.$uid],
                        class: ["xfaTextfield"],
                        style: style2,
                        "aria-label": ariaLabel(field),
                        "aria-required": false
                      }
                    };
                  } else {
                    html2 = {
                      name: "input",
                      attributes: {
                        type: "text",
                        dataId: field[_symbol_utils.$data]?.[_symbol_utils.$uid] || field[_symbol_utils.$uid],
                        fieldId: field[_symbol_utils.$uid],
                        class: ["xfaTextfield"],
                        style: style2,
                        "aria-label": ariaLabel(field),
                        "aria-required": false
                      }
                    };
                  }
                  if (isRequired(field)) {
                    html2.attributes["aria-required"] = true;
                    html2.attributes.required = true;
                  }
                  return _utils.HTMLResult.success({
                    name: "label",
                    attributes: {
                      class: ["xfaLabel"]
                    },
                    children: [html2]
                  });
                }
              }
              class Time3 extends _xfa_object.StringObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "time");
                  this.id = attributes2.id || "";
                  this.name = attributes2.name || "";
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                }
                [_symbol_utils.$finalize]() {
                  const date4 = this[_symbol_utils.$content].trim();
                  this[_symbol_utils.$content] = date4 ? new Date(date4) : null;
                }
                [_symbol_utils.$toHTML](availableSpace) {
                  return valueToHtml(this[_symbol_utils.$content] ? this[_symbol_utils.$content].toString() : "");
                }
              }
              class TimeStamp extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "timeStamp");
                  this.id = attributes2.id || "";
                  this.server = attributes2.server || "";
                  this.type = (0, _utils.getStringOption)(attributes2.type, ["optional", "required"]);
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                }
              }
              class ToolTip extends _xfa_object.StringObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "toolTip");
                  this.id = attributes2.id || "";
                  this.rid = attributes2.rid || "";
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                }
              }
              class Traversal extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "traversal", true);
                  this.id = attributes2.id || "";
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                  this.extras = null;
                  this.traverse = new _xfa_object.XFAObjectArray();
                }
              }
              class Traverse extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "traverse", true);
                  this.id = attributes2.id || "";
                  this.operation = (0, _utils.getStringOption)(attributes2.operation, ["next", "back", "down", "first", "left", "right", "up"]);
                  this.ref = attributes2.ref || "";
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                  this.extras = null;
                  this.script = null;
                }
                get name() {
                  return this.operation;
                }
                [_symbol_utils.$isTransparent]() {
                  return false;
                }
              }
              class Ui extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "ui", true);
                  this.id = attributes2.id || "";
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                  this.extras = null;
                  this.picture = null;
                  this.barcode = null;
                  this.button = null;
                  this.checkButton = null;
                  this.choiceList = null;
                  this.dateTimeEdit = null;
                  this.defaultUi = null;
                  this.imageEdit = null;
                  this.numericEdit = null;
                  this.passwordEdit = null;
                  this.signature = null;
                  this.textEdit = null;
                }
                [_symbol_utils.$getExtra]() {
                  if (this[_symbol_utils.$extra] === void 0) {
                    for (const name of Object.getOwnPropertyNames(this)) {
                      if (name === "extras" || name === "picture") {
                        continue;
                      }
                      const obj = this[name];
                      if (!(obj instanceof _xfa_object.XFAObject)) {
                        continue;
                      }
                      this[_symbol_utils.$extra] = obj;
                      return obj;
                    }
                    this[_symbol_utils.$extra] = null;
                  }
                  return this[_symbol_utils.$extra];
                }
                [_symbol_utils.$toHTML](availableSpace) {
                  const obj = this[_symbol_utils.$getExtra]();
                  if (obj) {
                    return obj[_symbol_utils.$toHTML](availableSpace);
                  }
                  return _utils.HTMLResult.EMPTY;
                }
              }
              class Validate extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "validate", true);
                  this.formatTest = (0, _utils.getStringOption)(attributes2.formatTest, ["warning", "disabled", "error"]);
                  this.id = attributes2.id || "";
                  this.nullTest = (0, _utils.getStringOption)(attributes2.nullTest, ["disabled", "error", "warning"]);
                  this.scriptTest = (0, _utils.getStringOption)(attributes2.scriptTest, ["error", "disabled", "warning"]);
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                  this.extras = null;
                  this.message = null;
                  this.picture = null;
                  this.script = null;
                }
              }
              class Value extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "value", true);
                  this.id = attributes2.id || "";
                  this.override = (0, _utils.getInteger)({
                    data: attributes2.override,
                    defaultValue: 0,
                    validate: (x) => x === 1
                  });
                  this.relevant = (0, _utils.getRelevant)(attributes2.relevant);
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                  this.arc = null;
                  this.boolean = null;
                  this.date = null;
                  this.dateTime = null;
                  this.decimal = null;
                  this.exData = null;
                  this.float = null;
                  this.image = null;
                  this.integer = null;
                  this.line = null;
                  this.rectangle = null;
                  this.text = null;
                  this.time = null;
                }
                [_symbol_utils.$setValue](value) {
                  const parent2 = this[_symbol_utils.$getParent]();
                  if (parent2 instanceof Field2) {
                    if (parent2.ui?.imageEdit) {
                      if (!this.image) {
                        this.image = new Image3({});
                        this[_symbol_utils.$appendChild](this.image);
                      }
                      this.image[_symbol_utils.$content] = value[_symbol_utils.$content];
                      return;
                    }
                  }
                  const valueName = value[_symbol_utils.$nodeName];
                  if (this[valueName] !== null) {
                    this[valueName][_symbol_utils.$content] = value[_symbol_utils.$content];
                    return;
                  }
                  for (const name of Object.getOwnPropertyNames(this)) {
                    const obj = this[name];
                    if (obj instanceof _xfa_object.XFAObject) {
                      this[name] = null;
                      this[_symbol_utils.$removeChild](obj);
                    }
                  }
                  this[value[_symbol_utils.$nodeName]] = value;
                  this[_symbol_utils.$appendChild](value);
                }
                [_symbol_utils.$text]() {
                  if (this.exData) {
                    if (typeof this.exData[_symbol_utils.$content] === "string") {
                      return this.exData[_symbol_utils.$content].trim();
                    }
                    return this.exData[_symbol_utils.$content][_symbol_utils.$text]().trim();
                  }
                  for (const name of Object.getOwnPropertyNames(this)) {
                    if (name === "image") {
                      continue;
                    }
                    const obj = this[name];
                    if (obj instanceof _xfa_object.XFAObject) {
                      return (obj[_symbol_utils.$content] || "").toString().trim();
                    }
                  }
                  return null;
                }
                [_symbol_utils.$toHTML](availableSpace) {
                  for (const name of Object.getOwnPropertyNames(this)) {
                    const obj = this[name];
                    if (!(obj instanceof _xfa_object.XFAObject)) {
                      continue;
                    }
                    return obj[_symbol_utils.$toHTML](availableSpace);
                  }
                  return _utils.HTMLResult.EMPTY;
                }
              }
              exports3.Value = Value;
              class Variables extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(TEMPLATE_NS_ID, "variables", true);
                  this.id = attributes2.id || "";
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                  this.boolean = new _xfa_object.XFAObjectArray();
                  this.date = new _xfa_object.XFAObjectArray();
                  this.dateTime = new _xfa_object.XFAObjectArray();
                  this.decimal = new _xfa_object.XFAObjectArray();
                  this.exData = new _xfa_object.XFAObjectArray();
                  this.float = new _xfa_object.XFAObjectArray();
                  this.image = new _xfa_object.XFAObjectArray();
                  this.integer = new _xfa_object.XFAObjectArray();
                  this.manifest = new _xfa_object.XFAObjectArray();
                  this.script = new _xfa_object.XFAObjectArray();
                  this.text = new _xfa_object.XFAObjectArray();
                  this.time = new _xfa_object.XFAObjectArray();
                }
                [_symbol_utils.$isTransparent]() {
                  return true;
                }
              }
              class TemplateNamespace {
                static [_namespaces.$buildXFAObject](name, attributes2) {
                  if (TemplateNamespace.hasOwnProperty(name)) {
                    const node2 = TemplateNamespace[name](attributes2);
                    node2[_symbol_utils.$setSetAttributes](attributes2);
                    return node2;
                  }
                  return void 0;
                }
                static appearanceFilter(attrs) {
                  return new AppearanceFilter(attrs);
                }
                static arc(attrs) {
                  return new Arc(attrs);
                }
                static area(attrs) {
                  return new Area(attrs);
                }
                static assist(attrs) {
                  return new Assist(attrs);
                }
                static barcode(attrs) {
                  return new Barcode(attrs);
                }
                static bind(attrs) {
                  return new Bind(attrs);
                }
                static bindItems(attrs) {
                  return new BindItems(attrs);
                }
                static bookend(attrs) {
                  return new Bookend(attrs);
                }
                static boolean(attrs) {
                  return new BooleanElement(attrs);
                }
                static border(attrs) {
                  return new Border(attrs);
                }
                static break(attrs) {
                  return new Break(attrs);
                }
                static breakAfter(attrs) {
                  return new BreakAfter(attrs);
                }
                static breakBefore(attrs) {
                  return new BreakBefore(attrs);
                }
                static button(attrs) {
                  return new Button2(attrs);
                }
                static calculate(attrs) {
                  return new Calculate(attrs);
                }
                static caption(attrs) {
                  return new Caption(attrs);
                }
                static certificate(attrs) {
                  return new Certificate(attrs);
                }
                static certificates(attrs) {
                  return new Certificates(attrs);
                }
                static checkButton(attrs) {
                  return new CheckButton(attrs);
                }
                static choiceList(attrs) {
                  return new ChoiceList(attrs);
                }
                static color(attrs) {
                  return new Color5(attrs);
                }
                static comb(attrs) {
                  return new Comb(attrs);
                }
                static connect(attrs) {
                  return new Connect(attrs);
                }
                static contentArea(attrs) {
                  return new ContentArea(attrs);
                }
                static corner(attrs) {
                  return new Corner(attrs);
                }
                static date(attrs) {
                  return new DateElement(attrs);
                }
                static dateTime(attrs) {
                  return new DateTime(attrs);
                }
                static dateTimeEdit(attrs) {
                  return new DateTimeEdit(attrs);
                }
                static decimal(attrs) {
                  return new Decimal(attrs);
                }
                static defaultUi(attrs) {
                  return new DefaultUi(attrs);
                }
                static desc(attrs) {
                  return new Desc(attrs);
                }
                static digestMethod(attrs) {
                  return new DigestMethod(attrs);
                }
                static digestMethods(attrs) {
                  return new DigestMethods(attrs);
                }
                static draw(attrs) {
                  return new Draw(attrs);
                }
                static edge(attrs) {
                  return new Edge(attrs);
                }
                static encoding(attrs) {
                  return new Encoding(attrs);
                }
                static encodings(attrs) {
                  return new Encodings(attrs);
                }
                static encrypt(attrs) {
                  return new Encrypt(attrs);
                }
                static encryptData(attrs) {
                  return new EncryptData(attrs);
                }
                static encryption(attrs) {
                  return new Encryption(attrs);
                }
                static encryptionMethod(attrs) {
                  return new EncryptionMethod(attrs);
                }
                static encryptionMethods(attrs) {
                  return new EncryptionMethods(attrs);
                }
                static event(attrs) {
                  return new Event2(attrs);
                }
                static exData(attrs) {
                  return new ExData(attrs);
                }
                static exObject(attrs) {
                  return new ExObject(attrs);
                }
                static exclGroup(attrs) {
                  return new ExclGroup(attrs);
                }
                static execute(attrs) {
                  return new Execute(attrs);
                }
                static extras(attrs) {
                  return new Extras(attrs);
                }
                static field(attrs) {
                  return new Field2(attrs);
                }
                static fill(attrs) {
                  return new Fill(attrs);
                }
                static filter(attrs) {
                  return new Filter(attrs);
                }
                static float(attrs) {
                  return new Float(attrs);
                }
                static font(attrs) {
                  return new Font3(attrs);
                }
                static format(attrs) {
                  return new Format(attrs);
                }
                static handler(attrs) {
                  return new Handler3(attrs);
                }
                static hyphenation(attrs) {
                  return new Hyphenation(attrs);
                }
                static image(attrs) {
                  return new Image3(attrs);
                }
                static imageEdit(attrs) {
                  return new ImageEdit(attrs);
                }
                static integer(attrs) {
                  return new Integer(attrs);
                }
                static issuers(attrs) {
                  return new Issuers(attrs);
                }
                static items(attrs) {
                  return new Items(attrs);
                }
                static keep(attrs) {
                  return new Keep(attrs);
                }
                static keyUsage(attrs) {
                  return new KeyUsage(attrs);
                }
                static line(attrs) {
                  return new Line4(attrs);
                }
                static linear(attrs) {
                  return new Linear(attrs);
                }
                static lockDocument(attrs) {
                  return new LockDocument(attrs);
                }
                static manifest(attrs) {
                  return new Manifest(attrs);
                }
                static margin(attrs) {
                  return new Margin(attrs);
                }
                static mdp(attrs) {
                  return new Mdp(attrs);
                }
                static medium(attrs) {
                  return new Medium(attrs);
                }
                static message(attrs) {
                  return new Message(attrs);
                }
                static numericEdit(attrs) {
                  return new NumericEdit(attrs);
                }
                static occur(attrs) {
                  return new Occur(attrs);
                }
                static oid(attrs) {
                  return new Oid(attrs);
                }
                static oids(attrs) {
                  return new Oids(attrs);
                }
                static overflow(attrs) {
                  return new Overflow2(attrs);
                }
                static pageArea(attrs) {
                  return new PageArea(attrs);
                }
                static pageSet(attrs) {
                  return new PageSet(attrs);
                }
                static para(attrs) {
                  return new Para(attrs);
                }
                static passwordEdit(attrs) {
                  return new PasswordEdit(attrs);
                }
                static pattern(attrs) {
                  return new Pattern(attrs);
                }
                static picture(attrs) {
                  return new Picture(attrs);
                }
                static proto(attrs) {
                  return new Proto(attrs);
                }
                static radial(attrs) {
                  return new Radial(attrs);
                }
                static reason(attrs) {
                  return new Reason(attrs);
                }
                static reasons(attrs) {
                  return new Reasons(attrs);
                }
                static rectangle(attrs) {
                  return new Rectangle(attrs);
                }
                static ref(attrs) {
                  return new RefElement(attrs);
                }
                static script(attrs) {
                  return new Script(attrs);
                }
                static setProperty(attrs) {
                  return new SetProperty(attrs);
                }
                static signData(attrs) {
                  return new SignData(attrs);
                }
                static signature(attrs) {
                  return new Signature(attrs);
                }
                static signing(attrs) {
                  return new Signing(attrs);
                }
                static solid(attrs) {
                  return new Solid(attrs);
                }
                static speak(attrs) {
                  return new Speak(attrs);
                }
                static stipple(attrs) {
                  return new Stipple(attrs);
                }
                static subform(attrs) {
                  return new Subform(attrs);
                }
                static subformSet(attrs) {
                  return new SubformSet(attrs);
                }
                static subjectDN(attrs) {
                  return new SubjectDN(attrs);
                }
                static subjectDNs(attrs) {
                  return new SubjectDNs(attrs);
                }
                static submit(attrs) {
                  return new Submit(attrs);
                }
                static template(attrs) {
                  return new Template9(attrs);
                }
                static text(attrs) {
                  return new Text7(attrs);
                }
                static textEdit(attrs) {
                  return new TextEdit(attrs);
                }
                static time(attrs) {
                  return new Time3(attrs);
                }
                static timeStamp(attrs) {
                  return new TimeStamp(attrs);
                }
                static toolTip(attrs) {
                  return new ToolTip(attrs);
                }
                static traversal(attrs) {
                  return new Traversal(attrs);
                }
                static traverse(attrs) {
                  return new Traverse(attrs);
                }
                static ui(attrs) {
                  return new Ui(attrs);
                }
                static validate(attrs) {
                  return new Validate(attrs);
                }
                static value(attrs) {
                  return new Value(attrs);
                }
                static variables(attrs) {
                  return new Variables(attrs);
                }
              }
              exports3.TemplateNamespace = TemplateNamespace;
            }),
            /* 81 */
            /***/
            ((__unused_webpack_module2, exports3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.NamespaceIds = exports3.$buildXFAObject = void 0;
              const $buildXFAObject = Symbol();
              exports3.$buildXFAObject = $buildXFAObject;
              const NamespaceIds = {
                config: {
                  id: 0,
                  check: (ns) => ns.startsWith("http://www.xfa.org/schema/xci/")
                },
                connectionSet: {
                  id: 1,
                  check: (ns) => ns.startsWith("http://www.xfa.org/schema/xfa-connection-set/")
                },
                datasets: {
                  id: 2,
                  check: (ns) => ns.startsWith("http://www.xfa.org/schema/xfa-data/")
                },
                form: {
                  id: 3,
                  check: (ns) => ns.startsWith("http://www.xfa.org/schema/xfa-form/")
                },
                localeSet: {
                  id: 4,
                  check: (ns) => ns.startsWith("http://www.xfa.org/schema/xfa-locale-set/")
                },
                pdf: {
                  id: 5,
                  check: (ns) => ns === "http://ns.adobe.com/xdp/pdf/"
                },
                signature: {
                  id: 6,
                  check: (ns) => ns === "http://www.w3.org/2000/09/xmldsig#"
                },
                sourceSet: {
                  id: 7,
                  check: (ns) => ns.startsWith("http://www.xfa.org/schema/xfa-source-set/")
                },
                stylesheet: {
                  id: 8,
                  check: (ns) => ns === "http://www.w3.org/1999/XSL/Transform"
                },
                template: {
                  id: 9,
                  check: (ns) => ns.startsWith("http://www.xfa.org/schema/xfa-template/")
                },
                xdc: {
                  id: 10,
                  check: (ns) => ns.startsWith("http://www.xfa.org/schema/xdc/")
                },
                xdp: {
                  id: 11,
                  check: (ns) => ns === "http://ns.adobe.com/xdp/"
                },
                xfdf: {
                  id: 12,
                  check: (ns) => ns === "http://ns.adobe.com/xfdf/"
                },
                xhtml: {
                  id: 13,
                  check: (ns) => ns === "http://www.w3.org/1999/xhtml"
                },
                xmpmeta: {
                  id: 14,
                  check: (ns) => ns === "http://ns.adobe.com/xmpmeta/"
                }
              };
              exports3.NamespaceIds = NamespaceIds;
            }),
            /* 82 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.addHTML = addHTML;
              exports3.checkDimensions = checkDimensions;
              exports3.flushHTML = flushHTML;
              exports3.getAvailableSpace = getAvailableSpace;
              var _symbol_utils = __w_pdfjs_require__3(78);
              var _html_utils = __w_pdfjs_require__3(83);
              function createLine(node2, children) {
                return {
                  name: "div",
                  attributes: {
                    class: [node2.layout === "lr-tb" ? "xfaLr" : "xfaRl"]
                  },
                  children
                };
              }
              function flushHTML(node2) {
                if (!node2[_symbol_utils.$extra]) {
                  return null;
                }
                const attributes2 = node2[_symbol_utils.$extra].attributes;
                const html2 = {
                  name: "div",
                  attributes: attributes2,
                  children: node2[_symbol_utils.$extra].children
                };
                if (node2[_symbol_utils.$extra].failingNode) {
                  const htmlFromFailing = node2[_symbol_utils.$extra].failingNode[_symbol_utils.$flushHTML]();
                  if (htmlFromFailing) {
                    if (node2.layout.endsWith("-tb")) {
                      html2.children.push(createLine(node2, [htmlFromFailing]));
                    } else {
                      html2.children.push(htmlFromFailing);
                    }
                  }
                }
                if (html2.children.length === 0) {
                  return null;
                }
                return html2;
              }
              function addHTML(node2, html2, bbox) {
                const extra = node2[_symbol_utils.$extra];
                const availableSpace = extra.availableSpace;
                const [x, y, w, h2] = bbox;
                switch (node2.layout) {
                  case "position": {
                    extra.width = Math.max(extra.width, x + w);
                    extra.height = Math.max(extra.height, y + h2);
                    extra.children.push(html2);
                    break;
                  }
                  case "lr-tb":
                  case "rl-tb":
                    if (!extra.line || extra.attempt === 1) {
                      extra.line = createLine(node2, []);
                      extra.children.push(extra.line);
                      extra.numberInLine = 0;
                    }
                    extra.numberInLine += 1;
                    extra.line.children.push(html2);
                    if (extra.attempt === 0) {
                      extra.currentWidth += w;
                      extra.height = Math.max(extra.height, extra.prevHeight + h2);
                    } else {
                      extra.currentWidth = w;
                      extra.prevHeight = extra.height;
                      extra.height += h2;
                      extra.attempt = 0;
                    }
                    extra.width = Math.max(extra.width, extra.currentWidth);
                    break;
                  case "rl-row":
                  case "row": {
                    extra.children.push(html2);
                    extra.width += w;
                    extra.height = Math.max(extra.height, h2);
                    const height = (0, _html_utils.measureToString)(extra.height);
                    for (const child of extra.children) {
                      child.attributes.style.height = height;
                    }
                    break;
                  }
                  case "table": {
                    extra.width = Math.min(availableSpace.width, Math.max(extra.width, w));
                    extra.height += h2;
                    extra.children.push(html2);
                    break;
                  }
                  case "tb": {
                    extra.width = Math.min(availableSpace.width, Math.max(extra.width, w));
                    extra.height += h2;
                    extra.children.push(html2);
                    break;
                  }
                }
              }
              function getAvailableSpace(node2) {
                const availableSpace = node2[_symbol_utils.$extra].availableSpace;
                const marginV = node2.margin ? node2.margin.topInset + node2.margin.bottomInset : 0;
                const marginH = node2.margin ? node2.margin.leftInset + node2.margin.rightInset : 0;
                switch (node2.layout) {
                  case "lr-tb":
                  case "rl-tb":
                    if (node2[_symbol_utils.$extra].attempt === 0) {
                      return {
                        width: availableSpace.width - marginH - node2[_symbol_utils.$extra].currentWidth,
                        height: availableSpace.height - marginV - node2[_symbol_utils.$extra].prevHeight
                      };
                    }
                    return {
                      width: availableSpace.width - marginH,
                      height: availableSpace.height - marginV - node2[_symbol_utils.$extra].height
                    };
                  case "rl-row":
                  case "row":
                    const width = node2[_symbol_utils.$extra].columnWidths.slice(node2[_symbol_utils.$extra].currentColumn).reduce((a, x) => a + x);
                    return {
                      width,
                      height: availableSpace.height - marginH
                    };
                  case "table":
                  case "tb":
                    return {
                      width: availableSpace.width - marginH,
                      height: availableSpace.height - marginV - node2[_symbol_utils.$extra].height
                    };
                  case "position":
                  default:
                    return availableSpace;
                }
              }
              function getTransformedBBox(node2) {
                let w = node2.w === "" ? NaN : node2.w;
                let h2 = node2.h === "" ? NaN : node2.h;
                let [centerX, centerY] = [0, 0];
                switch (node2.anchorType || "") {
                  case "bottomCenter":
                    [centerX, centerY] = [w / 2, h2];
                    break;
                  case "bottomLeft":
                    [centerX, centerY] = [0, h2];
                    break;
                  case "bottomRight":
                    [centerX, centerY] = [w, h2];
                    break;
                  case "middleCenter":
                    [centerX, centerY] = [w / 2, h2 / 2];
                    break;
                  case "middleLeft":
                    [centerX, centerY] = [0, h2 / 2];
                    break;
                  case "middleRight":
                    [centerX, centerY] = [w, h2 / 2];
                    break;
                  case "topCenter":
                    [centerX, centerY] = [w / 2, 0];
                    break;
                  case "topRight":
                    [centerX, centerY] = [w, 0];
                    break;
                }
                let x, y;
                switch (node2.rotate || 0) {
                  case 0:
                    [x, y] = [-centerX, -centerY];
                    break;
                  case 90:
                    [x, y] = [-centerY, centerX];
                    [w, h2] = [h2, -w];
                    break;
                  case 180:
                    [x, y] = [centerX, centerY];
                    [w, h2] = [-w, -h2];
                    break;
                  case 270:
                    [x, y] = [centerY, -centerX];
                    [w, h2] = [-h2, w];
                    break;
                }
                return [node2.x + x + Math.min(0, w), node2.y + y + Math.min(0, h2), Math.abs(w), Math.abs(h2)];
              }
              function checkDimensions(node2, space) {
                if (node2[_symbol_utils.$getTemplateRoot]()[_symbol_utils.$extra].firstUnsplittable === null) {
                  return true;
                }
                if (node2.w === 0 || node2.h === 0) {
                  return true;
                }
                const ERROR = 2;
                const parent2 = node2[_symbol_utils.$getSubformParent]();
                const attempt = parent2[_symbol_utils.$extra]?.attempt || 0;
                const [, y, w, h2] = getTransformedBBox(node2);
                switch (parent2.layout) {
                  case "lr-tb":
                  case "rl-tb":
                    if (attempt === 0) {
                      if (!node2[_symbol_utils.$getTemplateRoot]()[_symbol_utils.$extra].noLayoutFailure) {
                        if (node2.h !== "" && Math.round(h2 - space.height) > ERROR) {
                          return false;
                        }
                        if (node2.w !== "") {
                          if (Math.round(w - space.width) <= ERROR) {
                            return true;
                          }
                          if (parent2[_symbol_utils.$extra].numberInLine === 0) {
                            return space.height > ERROR;
                          }
                          return false;
                        }
                        return space.width > ERROR;
                      }
                      if (node2.w !== "") {
                        return Math.round(w - space.width) <= ERROR;
                      }
                      return space.width > ERROR;
                    }
                    if (node2[_symbol_utils.$getTemplateRoot]()[_symbol_utils.$extra].noLayoutFailure) {
                      return true;
                    }
                    if (node2.h !== "" && Math.round(h2 - space.height) > ERROR) {
                      return false;
                    }
                    if (node2.w === "" || Math.round(w - space.width) <= ERROR) {
                      return space.height > ERROR;
                    }
                    if (parent2[_symbol_utils.$isThereMoreWidth]()) {
                      return false;
                    }
                    return space.height > ERROR;
                  case "table":
                  case "tb":
                    if (node2[_symbol_utils.$getTemplateRoot]()[_symbol_utils.$extra].noLayoutFailure) {
                      return true;
                    }
                    if (node2.h !== "" && !node2[_symbol_utils.$isSplittable]()) {
                      return Math.round(h2 - space.height) <= ERROR;
                    }
                    if (node2.w === "" || Math.round(w - space.width) <= ERROR) {
                      return space.height > ERROR;
                    }
                    if (parent2[_symbol_utils.$isThereMoreWidth]()) {
                      return false;
                    }
                    return space.height > ERROR;
                  case "position":
                    if (node2[_symbol_utils.$getTemplateRoot]()[_symbol_utils.$extra].noLayoutFailure) {
                      return true;
                    }
                    if (node2.h === "" || Math.round(h2 + y - space.height) <= ERROR) {
                      return true;
                    }
                    const area = node2[_symbol_utils.$getTemplateRoot]()[_symbol_utils.$extra].currentContentArea;
                    return h2 + y > area.h;
                  case "rl-row":
                  case "row":
                    if (node2[_symbol_utils.$getTemplateRoot]()[_symbol_utils.$extra].noLayoutFailure) {
                      return true;
                    }
                    if (node2.h !== "") {
                      return Math.round(h2 - space.height) <= ERROR;
                    }
                    return true;
                  default:
                    return true;
                }
              }
            }),
            /* 83 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.computeBbox = computeBbox;
              exports3.createWrapper = createWrapper;
              exports3.fixDimensions = fixDimensions;
              exports3.fixTextIndent = fixTextIndent;
              exports3.fixURL = fixURL;
              exports3.isPrintOnly = isPrintOnly;
              exports3.layoutClass = layoutClass;
              exports3.layoutNode = layoutNode;
              exports3.measureToString = measureToString;
              exports3.setAccess = setAccess;
              exports3.setFontFamily = setFontFamily;
              exports3.setMinMaxDimensions = setMinMaxDimensions;
              exports3.setPara = setPara;
              exports3.toStyle = toStyle;
              var _symbol_utils = __w_pdfjs_require__3(78);
              var _util2 = __w_pdfjs_require__3(2);
              var _utils = __w_pdfjs_require__3(84);
              var _fonts = __w_pdfjs_require__3(85);
              var _text = __w_pdfjs_require__3(86);
              var _xfa_object = __w_pdfjs_require__3(87);
              function measureToString(m) {
                if (typeof m === "string") {
                  return "0px";
                }
                return Number.isInteger(m) ? `${m}px` : `${m.toFixed(2)}px`;
              }
              const converters = {
                anchorType(node2, style2) {
                  const parent2 = node2[_symbol_utils.$getSubformParent]();
                  if (!parent2 || parent2.layout && parent2.layout !== "position") {
                    return;
                  }
                  if (!("transform" in style2)) {
                    style2.transform = "";
                  }
                  switch (node2.anchorType) {
                    case "bottomCenter":
                      style2.transform += "translate(-50%, -100%)";
                      break;
                    case "bottomLeft":
                      style2.transform += "translate(0,-100%)";
                      break;
                    case "bottomRight":
                      style2.transform += "translate(-100%,-100%)";
                      break;
                    case "middleCenter":
                      style2.transform += "translate(-50%,-50%)";
                      break;
                    case "middleLeft":
                      style2.transform += "translate(0,-50%)";
                      break;
                    case "middleRight":
                      style2.transform += "translate(-100%,-50%)";
                      break;
                    case "topCenter":
                      style2.transform += "translate(-50%,0)";
                      break;
                    case "topRight":
                      style2.transform += "translate(-100%,0)";
                      break;
                  }
                },
                dimensions(node2, style2) {
                  const parent2 = node2[_symbol_utils.$getSubformParent]();
                  let width = node2.w;
                  const height = node2.h;
                  if (parent2.layout?.includes("row")) {
                    const extra = parent2[_symbol_utils.$extra];
                    const colSpan = node2.colSpan;
                    let w;
                    if (colSpan === -1) {
                      w = extra.columnWidths.slice(extra.currentColumn).reduce((a, x) => a + x, 0);
                      extra.currentColumn = 0;
                    } else {
                      w = extra.columnWidths.slice(extra.currentColumn, extra.currentColumn + colSpan).reduce((a, x) => a + x, 0);
                      extra.currentColumn = (extra.currentColumn + node2.colSpan) % extra.columnWidths.length;
                    }
                    if (!isNaN(w)) {
                      width = node2.w = w;
                    }
                  }
                  style2.width = width !== "" ? measureToString(width) : "auto";
                  style2.height = height !== "" ? measureToString(height) : "auto";
                },
                position(node2, style2) {
                  const parent2 = node2[_symbol_utils.$getSubformParent]();
                  if (parent2?.layout && parent2.layout !== "position") {
                    return;
                  }
                  style2.position = "absolute";
                  style2.left = measureToString(node2.x);
                  style2.top = measureToString(node2.y);
                },
                rotate(node2, style2) {
                  if (node2.rotate) {
                    if (!("transform" in style2)) {
                      style2.transform = "";
                    }
                    style2.transform += `rotate(-${node2.rotate}deg)`;
                    style2.transformOrigin = "top left";
                  }
                },
                presence(node2, style2) {
                  switch (node2.presence) {
                    case "invisible":
                      style2.visibility = "hidden";
                      break;
                    case "hidden":
                    case "inactive":
                      style2.display = "none";
                      break;
                  }
                },
                hAlign(node2, style2) {
                  if (node2[_symbol_utils.$nodeName] === "para") {
                    switch (node2.hAlign) {
                      case "justifyAll":
                        style2.textAlign = "justify-all";
                        break;
                      case "radix":
                        style2.textAlign = "left";
                        break;
                      default:
                        style2.textAlign = node2.hAlign;
                    }
                  } else {
                    switch (node2.hAlign) {
                      case "left":
                        style2.alignSelf = "start";
                        break;
                      case "center":
                        style2.alignSelf = "center";
                        break;
                      case "right":
                        style2.alignSelf = "end";
                        break;
                    }
                  }
                },
                margin(node2, style2) {
                  if (node2.margin) {
                    style2.margin = node2.margin[_symbol_utils.$toStyle]().margin;
                  }
                }
              };
              function setMinMaxDimensions(node2, style2) {
                const parent2 = node2[_symbol_utils.$getSubformParent]();
                if (parent2.layout === "position") {
                  if (node2.minW > 0) {
                    style2.minWidth = measureToString(node2.minW);
                  }
                  if (node2.maxW > 0) {
                    style2.maxWidth = measureToString(node2.maxW);
                  }
                  if (node2.minH > 0) {
                    style2.minHeight = measureToString(node2.minH);
                  }
                  if (node2.maxH > 0) {
                    style2.maxHeight = measureToString(node2.maxH);
                  }
                }
              }
              function layoutText(text, xfaFont, margin, lineHeight, fontFinder, width) {
                const measure = new _text.TextMeasure(xfaFont, margin, lineHeight, fontFinder);
                if (typeof text === "string") {
                  measure.addString(text);
                } else {
                  text[_symbol_utils.$pushGlyphs](measure);
                }
                return measure.compute(width);
              }
              function layoutNode(node2, availableSpace) {
                let height = null;
                let width = null;
                let isBroken = false;
                if ((!node2.w || !node2.h) && node2.value) {
                  let marginH = 0;
                  let marginV = 0;
                  if (node2.margin) {
                    marginH = node2.margin.leftInset + node2.margin.rightInset;
                    marginV = node2.margin.topInset + node2.margin.bottomInset;
                  }
                  let lineHeight = null;
                  let margin = null;
                  if (node2.para) {
                    margin = /* @__PURE__ */ Object.create(null);
                    lineHeight = node2.para.lineHeight === "" ? null : node2.para.lineHeight;
                    margin.top = node2.para.spaceAbove === "" ? 0 : node2.para.spaceAbove;
                    margin.bottom = node2.para.spaceBelow === "" ? 0 : node2.para.spaceBelow;
                    margin.left = node2.para.marginLeft === "" ? 0 : node2.para.marginLeft;
                    margin.right = node2.para.marginRight === "" ? 0 : node2.para.marginRight;
                  }
                  let font = node2.font;
                  if (!font) {
                    const root2 = node2[_symbol_utils.$getTemplateRoot]();
                    let parent2 = node2[_symbol_utils.$getParent]();
                    while (parent2 && parent2 !== root2) {
                      if (parent2.font) {
                        font = parent2.font;
                        break;
                      }
                      parent2 = parent2[_symbol_utils.$getParent]();
                    }
                  }
                  const maxWidth = (node2.w || availableSpace.width) - marginH;
                  const fontFinder = node2[_symbol_utils.$globalData].fontFinder;
                  if (node2.value.exData && node2.value.exData[_symbol_utils.$content] && node2.value.exData.contentType === "text/html") {
                    const res = layoutText(node2.value.exData[_symbol_utils.$content], font, margin, lineHeight, fontFinder, maxWidth);
                    width = res.width;
                    height = res.height;
                    isBroken = res.isBroken;
                  } else {
                    const text = node2.value[_symbol_utils.$text]();
                    if (text) {
                      const res = layoutText(text, font, margin, lineHeight, fontFinder, maxWidth);
                      width = res.width;
                      height = res.height;
                      isBroken = res.isBroken;
                    }
                  }
                  if (width !== null && !node2.w) {
                    width += marginH;
                  }
                  if (height !== null && !node2.h) {
                    height += marginV;
                  }
                }
                return {
                  w: width,
                  h: height,
                  isBroken
                };
              }
              function computeBbox(node2, html2, availableSpace) {
                let bbox;
                if (node2.w !== "" && node2.h !== "") {
                  bbox = [node2.x, node2.y, node2.w, node2.h];
                } else {
                  if (!availableSpace) {
                    return null;
                  }
                  let width = node2.w;
                  if (width === "") {
                    if (node2.maxW === 0) {
                      const parent2 = node2[_symbol_utils.$getSubformParent]();
                      width = parent2.layout === "position" && parent2.w !== "" ? 0 : node2.minW;
                    } else {
                      width = Math.min(node2.maxW, availableSpace.width);
                    }
                    html2.attributes.style.width = measureToString(width);
                  }
                  let height = node2.h;
                  if (height === "") {
                    if (node2.maxH === 0) {
                      const parent2 = node2[_symbol_utils.$getSubformParent]();
                      height = parent2.layout === "position" && parent2.h !== "" ? 0 : node2.minH;
                    } else {
                      height = Math.min(node2.maxH, availableSpace.height);
                    }
                    html2.attributes.style.height = measureToString(height);
                  }
                  bbox = [node2.x, node2.y, width, height];
                }
                return bbox;
              }
              function fixDimensions(node2) {
                const parent2 = node2[_symbol_utils.$getSubformParent]();
                if (parent2.layout?.includes("row")) {
                  const extra = parent2[_symbol_utils.$extra];
                  const colSpan = node2.colSpan;
                  let width;
                  if (colSpan === -1) {
                    width = extra.columnWidths.slice(extra.currentColumn).reduce((a, w) => a + w, 0);
                  } else {
                    width = extra.columnWidths.slice(extra.currentColumn, extra.currentColumn + colSpan).reduce((a, w) => a + w, 0);
                  }
                  if (!isNaN(width)) {
                    node2.w = width;
                  }
                }
                if (parent2.layout && parent2.layout !== "position") {
                  node2.x = node2.y = 0;
                }
                if (node2.layout === "table") {
                  if (node2.w === "" && Array.isArray(node2.columnWidths)) {
                    node2.w = node2.columnWidths.reduce((a, x) => a + x, 0);
                  }
                }
              }
              function layoutClass(node2) {
                switch (node2.layout) {
                  case "position":
                    return "xfaPosition";
                  case "lr-tb":
                    return "xfaLrTb";
                  case "rl-row":
                    return "xfaRlRow";
                  case "rl-tb":
                    return "xfaRlTb";
                  case "row":
                    return "xfaRow";
                  case "table":
                    return "xfaTable";
                  case "tb":
                    return "xfaTb";
                  default:
                    return "xfaPosition";
                }
              }
              function toStyle(node2, ...names2) {
                const style2 = /* @__PURE__ */ Object.create(null);
                for (const name of names2) {
                  const value = node2[name];
                  if (value === null) {
                    continue;
                  }
                  if (converters.hasOwnProperty(name)) {
                    converters[name](node2, style2);
                    continue;
                  }
                  if (value instanceof _xfa_object.XFAObject) {
                    const newStyle = value[_symbol_utils.$toStyle]();
                    if (newStyle) {
                      Object.assign(style2, newStyle);
                    } else {
                      (0, _util2.warn)(`(DEBUG) - XFA - style for ${name} not implemented yet`);
                    }
                  }
                }
                return style2;
              }
              function createWrapper(node2, html2) {
                const {
                  attributes: attributes2
                } = html2;
                const {
                  style: style2
                } = attributes2;
                const wrapper = {
                  name: "div",
                  attributes: {
                    class: ["xfaWrapper"],
                    style: /* @__PURE__ */ Object.create(null)
                  },
                  children: []
                };
                attributes2.class.push("xfaWrapped");
                if (node2.border) {
                  const {
                    widths,
                    insets
                  } = node2.border[_symbol_utils.$extra];
                  let width, height;
                  let top = insets[0];
                  let left2 = insets[3];
                  const insetsH = insets[0] + insets[2];
                  const insetsW = insets[1] + insets[3];
                  switch (node2.border.hand) {
                    case "even":
                      top -= widths[0] / 2;
                      left2 -= widths[3] / 2;
                      width = `calc(100% + ${(widths[1] + widths[3]) / 2 - insetsW}px)`;
                      height = `calc(100% + ${(widths[0] + widths[2]) / 2 - insetsH}px)`;
                      break;
                    case "left":
                      top -= widths[0];
                      left2 -= widths[3];
                      width = `calc(100% + ${widths[1] + widths[3] - insetsW}px)`;
                      height = `calc(100% + ${widths[0] + widths[2] - insetsH}px)`;
                      break;
                    case "right":
                      width = insetsW ? `calc(100% - ${insetsW}px)` : "100%";
                      height = insetsH ? `calc(100% - ${insetsH}px)` : "100%";
                      break;
                  }
                  const classNames186 = ["xfaBorder"];
                  if (isPrintOnly(node2.border)) {
                    classNames186.push("xfaPrintOnly");
                  }
                  const border = {
                    name: "div",
                    attributes: {
                      class: classNames186,
                      style: {
                        top: `${top}px`,
                        left: `${left2}px`,
                        width,
                        height
                      }
                    },
                    children: []
                  };
                  for (const key2 of ["border", "borderWidth", "borderColor", "borderRadius", "borderStyle"]) {
                    if (style2[key2] !== void 0) {
                      border.attributes.style[key2] = style2[key2];
                      delete style2[key2];
                    }
                  }
                  wrapper.children.push(border, html2);
                } else {
                  wrapper.children.push(html2);
                }
                for (const key2 of ["background", "backgroundClip", "top", "left", "width", "height", "minWidth", "minHeight", "maxWidth", "maxHeight", "transform", "transformOrigin", "visibility"]) {
                  if (style2[key2] !== void 0) {
                    wrapper.attributes.style[key2] = style2[key2];
                    delete style2[key2];
                  }
                }
                wrapper.attributes.style.position = style2.position === "absolute" ? "absolute" : "relative";
                delete style2.position;
                if (style2.alignSelf) {
                  wrapper.attributes.style.alignSelf = style2.alignSelf;
                  delete style2.alignSelf;
                }
                return wrapper;
              }
              function fixTextIndent(styles) {
                const indent = (0, _utils.getMeasurement)(styles.textIndent, "0px");
                if (indent >= 0) {
                  return;
                }
                const align = styles.textAlign === "right" ? "right" : "left";
                const name = "padding" + (align === "left" ? "Left" : "Right");
                const padding = (0, _utils.getMeasurement)(styles[name], "0px");
                styles[name] = `${padding - indent}px`;
              }
              function setAccess(node2, classNames186) {
                switch (node2.access) {
                  case "nonInteractive":
                    classNames186.push("xfaNonInteractive");
                    break;
                  case "readOnly":
                    classNames186.push("xfaReadOnly");
                    break;
                  case "protected":
                    classNames186.push("xfaDisabled");
                    break;
                }
              }
              function isPrintOnly(node2) {
                return node2.relevant.length > 0 && !node2.relevant[0].excluded && node2.relevant[0].viewname === "print";
              }
              function getCurrentPara(node2) {
                const stack = node2[_symbol_utils.$getTemplateRoot]()[_symbol_utils.$extra].paraStack;
                return stack.length ? stack.at(-1) : null;
              }
              function setPara(node2, nodeStyle, value) {
                if (value.attributes.class?.includes("xfaRich")) {
                  if (nodeStyle) {
                    if (node2.h === "") {
                      nodeStyle.height = "auto";
                    }
                    if (node2.w === "") {
                      nodeStyle.width = "auto";
                    }
                  }
                  const para = getCurrentPara(node2);
                  if (para) {
                    const valueStyle = value.attributes.style;
                    valueStyle.display = "flex";
                    valueStyle.flexDirection = "column";
                    switch (para.vAlign) {
                      case "top":
                        valueStyle.justifyContent = "start";
                        break;
                      case "bottom":
                        valueStyle.justifyContent = "end";
                        break;
                      case "middle":
                        valueStyle.justifyContent = "center";
                        break;
                    }
                    const paraStyle = para[_symbol_utils.$toStyle]();
                    for (const [key2, val] of Object.entries(paraStyle)) {
                      if (!(key2 in valueStyle)) {
                        valueStyle[key2] = val;
                      }
                    }
                  }
                }
              }
              function setFontFamily(xfaFont, node2, fontFinder, style2) {
                if (!fontFinder) {
                  delete style2.fontFamily;
                  return;
                }
                const name = (0, _utils.stripQuotes)(xfaFont.typeface);
                style2.fontFamily = `"${name}"`;
                const typeface = fontFinder.find(name);
                if (typeface) {
                  const {
                    fontFamily
                  } = typeface.regular.cssFontInfo;
                  if (fontFamily !== name) {
                    style2.fontFamily = `"${fontFamily}"`;
                  }
                  const para = getCurrentPara(node2);
                  if (para && para.lineHeight !== "") {
                    return;
                  }
                  if (style2.lineHeight) {
                    return;
                  }
                  const pdfFont = (0, _fonts.selectFont)(xfaFont, typeface);
                  if (pdfFont) {
                    style2.lineHeight = Math.max(1.2, pdfFont.lineHeight);
                  }
                }
              }
              function fixURL(str) {
                const absoluteUrl = (0, _util2.createValidAbsoluteUrl)(str, null, {
                  addDefaultProtocol: true,
                  tryConvertEncoding: true
                });
                return absoluteUrl ? absoluteUrl.href : null;
              }
            }),
            /* 84 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.HTMLResult = void 0;
              exports3.getBBox = getBBox;
              exports3.getColor = getColor;
              exports3.getFloat = getFloat;
              exports3.getInteger = getInteger;
              exports3.getKeyword = getKeyword;
              exports3.getMeasurement = getMeasurement;
              exports3.getRatio = getRatio;
              exports3.getRelevant = getRelevant;
              exports3.getStringOption = getStringOption;
              exports3.stripQuotes = stripQuotes;
              var _util2 = __w_pdfjs_require__3(2);
              const dimConverters = {
                pt: (x) => x,
                cm: (x) => x / 2.54 * 72,
                mm: (x) => x / (10 * 2.54) * 72,
                in: (x) => x * 72,
                px: (x) => x
              };
              const measurementPattern = /([+-]?\d+\.?\d*)(.*)/;
              function stripQuotes(str) {
                if (str.startsWith("'") || str.startsWith('"')) {
                  return str.slice(1, -1);
                }
                return str;
              }
              function getInteger({
                data: data2,
                defaultValue: defaultValue2,
                validate
              }) {
                if (!data2) {
                  return defaultValue2;
                }
                data2 = data2.trim();
                const n2 = parseInt(data2, 10);
                if (!isNaN(n2) && validate(n2)) {
                  return n2;
                }
                return defaultValue2;
              }
              function getFloat({
                data: data2,
                defaultValue: defaultValue2,
                validate
              }) {
                if (!data2) {
                  return defaultValue2;
                }
                data2 = data2.trim();
                const n2 = parseFloat(data2);
                if (!isNaN(n2) && validate(n2)) {
                  return n2;
                }
                return defaultValue2;
              }
              function getKeyword({
                data: data2,
                defaultValue: defaultValue2,
                validate
              }) {
                if (!data2) {
                  return defaultValue2;
                }
                data2 = data2.trim();
                if (validate(data2)) {
                  return data2;
                }
                return defaultValue2;
              }
              function getStringOption(data2, options) {
                return getKeyword({
                  data: data2,
                  defaultValue: options[0],
                  validate: (k) => options.includes(k)
                });
              }
              function getMeasurement(str, def = "0") {
                def ||= "0";
                if (!str) {
                  return getMeasurement(def);
                }
                const match2 = str.trim().match(measurementPattern);
                if (!match2) {
                  return getMeasurement(def);
                }
                const [, valueStr, unit3] = match2;
                const value = parseFloat(valueStr);
                if (isNaN(value)) {
                  return getMeasurement(def);
                }
                if (value === 0) {
                  return 0;
                }
                const conv = dimConverters[unit3];
                if (conv) {
                  return conv(value);
                }
                return value;
              }
              function getRatio(data2) {
                if (!data2) {
                  return {
                    num: 1,
                    den: 1
                  };
                }
                const ratio = data2.trim().split(/\s*:\s*/).map((x) => parseFloat(x)).filter((x) => !isNaN(x));
                if (ratio.length === 1) {
                  ratio.push(1);
                }
                if (ratio.length === 0) {
                  return {
                    num: 1,
                    den: 1
                  };
                }
                const [num, den] = ratio;
                return {
                  num,
                  den
                };
              }
              function getRelevant(data2) {
                if (!data2) {
                  return [];
                }
                return data2.trim().split(/\s+/).map((e3) => {
                  return {
                    excluded: e3[0] === "-",
                    viewname: e3.substring(1)
                  };
                });
              }
              function getColor(data2, def = [0, 0, 0]) {
                let [r2, g, b] = def;
                if (!data2) {
                  return {
                    r: r2,
                    g,
                    b
                  };
                }
                const color = data2.trim().split(/\s*,\s*/).map((c) => Math.min(Math.max(0, parseInt(c.trim(), 10)), 255)).map((c) => isNaN(c) ? 0 : c);
                if (color.length < 3) {
                  return {
                    r: r2,
                    g,
                    b
                  };
                }
                [r2, g, b] = color;
                return {
                  r: r2,
                  g,
                  b
                };
              }
              function getBBox(data2) {
                const def = -1;
                if (!data2) {
                  return {
                    x: def,
                    y: def,
                    width: def,
                    height: def
                  };
                }
                const bbox = data2.trim().split(/\s*,\s*/).map((m) => getMeasurement(m, "-1"));
                if (bbox.length < 4 || bbox[2] < 0 || bbox[3] < 0) {
                  return {
                    x: def,
                    y: def,
                    width: def,
                    height: def
                  };
                }
                const [x, y, width, height] = bbox;
                return {
                  x,
                  y,
                  width,
                  height
                };
              }
              class HTMLResult {
                static get FAILURE() {
                  return (0, _util2.shadow)(this, "FAILURE", new HTMLResult(false, null, null, null));
                }
                static get EMPTY() {
                  return (0, _util2.shadow)(this, "EMPTY", new HTMLResult(true, null, null, null));
                }
                constructor(success, html2, bbox, breakNode) {
                  this.success = success;
                  this.html = html2;
                  this.bbox = bbox;
                  this.breakNode = breakNode;
                }
                isBreak() {
                  return !!this.breakNode;
                }
                static breakNode(node2) {
                  return new HTMLResult(false, null, null, node2);
                }
                static success(html2, bbox = null) {
                  return new HTMLResult(true, html2, bbox, null);
                }
              }
              exports3.HTMLResult = HTMLResult;
            }),
            /* 85 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.FontFinder = void 0;
              exports3.getMetrics = getMetrics;
              exports3.selectFont = selectFont;
              var _symbol_utils = __w_pdfjs_require__3(78);
              var _utils = __w_pdfjs_require__3(84);
              var _util2 = __w_pdfjs_require__3(2);
              class FontFinder {
                constructor(pdfFonts) {
                  this.fonts = /* @__PURE__ */ new Map();
                  this.cache = /* @__PURE__ */ new Map();
                  this.warned = /* @__PURE__ */ new Set();
                  this.defaultFont = null;
                  this.add(pdfFonts);
                }
                add(pdfFonts, reallyMissingFonts = null) {
                  for (const pdfFont of pdfFonts) {
                    this.addPdfFont(pdfFont);
                  }
                  for (const pdfFont of this.fonts.values()) {
                    if (!pdfFont.regular) {
                      pdfFont.regular = pdfFont.italic || pdfFont.bold || pdfFont.bolditalic;
                    }
                  }
                  if (!reallyMissingFonts || reallyMissingFonts.size === 0) {
                    return;
                  }
                  const myriad = this.fonts.get("PdfJS-Fallback-PdfJS-XFA");
                  for (const missing of reallyMissingFonts) {
                    this.fonts.set(missing, myriad);
                  }
                }
                addPdfFont(pdfFont) {
                  const cssFontInfo = pdfFont.cssFontInfo;
                  const name = cssFontInfo.fontFamily;
                  let font = this.fonts.get(name);
                  if (!font) {
                    font = /* @__PURE__ */ Object.create(null);
                    this.fonts.set(name, font);
                    if (!this.defaultFont) {
                      this.defaultFont = font;
                    }
                  }
                  let property2 = "";
                  const fontWeight = parseFloat(cssFontInfo.fontWeight);
                  if (parseFloat(cssFontInfo.italicAngle) !== 0) {
                    property2 = fontWeight >= 700 ? "bolditalic" : "italic";
                  } else if (fontWeight >= 700) {
                    property2 = "bold";
                  }
                  if (!property2) {
                    if (pdfFont.name.includes("Bold") || pdfFont.psName?.includes("Bold")) {
                      property2 = "bold";
                    }
                    if (pdfFont.name.includes("Italic") || pdfFont.name.endsWith("It") || pdfFont.psName?.includes("Italic") || pdfFont.psName?.endsWith("It")) {
                      property2 += "italic";
                    }
                  }
                  if (!property2) {
                    property2 = "regular";
                  }
                  font[property2] = pdfFont;
                }
                getDefault() {
                  return this.defaultFont;
                }
                find(fontName, mustWarn = true) {
                  let font = this.fonts.get(fontName) || this.cache.get(fontName);
                  if (font) {
                    return font;
                  }
                  const pattern6 = /,|-|_| |bolditalic|bold|italic|regular|it/gi;
                  let name = fontName.replaceAll(pattern6, "");
                  font = this.fonts.get(name);
                  if (font) {
                    this.cache.set(fontName, font);
                    return font;
                  }
                  name = name.toLowerCase();
                  const maybe = [];
                  for (const [family, pdfFont] of this.fonts.entries()) {
                    if (family.replaceAll(pattern6, "").toLowerCase().startsWith(name)) {
                      maybe.push(pdfFont);
                    }
                  }
                  if (maybe.length === 0) {
                    for (const [, pdfFont] of this.fonts.entries()) {
                      if (pdfFont.regular.name?.replaceAll(pattern6, "").toLowerCase().startsWith(name)) {
                        maybe.push(pdfFont);
                      }
                    }
                  }
                  if (maybe.length === 0) {
                    name = name.replaceAll(/psmt|mt/gi, "");
                    for (const [family, pdfFont] of this.fonts.entries()) {
                      if (family.replaceAll(pattern6, "").toLowerCase().startsWith(name)) {
                        maybe.push(pdfFont);
                      }
                    }
                  }
                  if (maybe.length === 0) {
                    for (const pdfFont of this.fonts.values()) {
                      if (pdfFont.regular.name?.replaceAll(pattern6, "").toLowerCase().startsWith(name)) {
                        maybe.push(pdfFont);
                      }
                    }
                  }
                  if (maybe.length >= 1) {
                    if (maybe.length !== 1 && mustWarn) {
                      (0, _util2.warn)(`XFA - Too many choices to guess the correct font: ${fontName}`);
                    }
                    this.cache.set(fontName, maybe[0]);
                    return maybe[0];
                  }
                  if (mustWarn && !this.warned.has(fontName)) {
                    this.warned.add(fontName);
                    (0, _util2.warn)(`XFA - Cannot find the font: ${fontName}`);
                  }
                  return null;
                }
              }
              exports3.FontFinder = FontFinder;
              function selectFont(xfaFont, typeface) {
                if (xfaFont.posture === "italic") {
                  if (xfaFont.weight === "bold") {
                    return typeface.bolditalic;
                  }
                  return typeface.italic;
                } else if (xfaFont.weight === "bold") {
                  return typeface.bold;
                }
                return typeface.regular;
              }
              function getMetrics(xfaFont, real = false) {
                let pdfFont = null;
                if (xfaFont) {
                  const name = (0, _utils.stripQuotes)(xfaFont.typeface);
                  const typeface = xfaFont[_symbol_utils.$globalData].fontFinder.find(name);
                  pdfFont = selectFont(xfaFont, typeface);
                }
                if (!pdfFont) {
                  return {
                    lineHeight: 12,
                    lineGap: 2,
                    lineNoGap: 10
                  };
                }
                const size = xfaFont.size || 10;
                const lineHeight = pdfFont.lineHeight ? Math.max(real ? 0 : 1.2, pdfFont.lineHeight) : 1.2;
                const lineGap = pdfFont.lineGap === void 0 ? 0.2 : pdfFont.lineGap;
                return {
                  lineHeight: lineHeight * size,
                  lineGap: lineGap * size,
                  lineNoGap: Math.max(1, lineHeight - lineGap) * size
                };
              }
            }),
            /* 86 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.TextMeasure = void 0;
              var _fonts = __w_pdfjs_require__3(85);
              const WIDTH_FACTOR = 1.02;
              class FontInfo {
                constructor(xfaFont, margin, lineHeight, fontFinder) {
                  this.lineHeight = lineHeight;
                  this.paraMargin = margin || {
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right: 0
                  };
                  if (!xfaFont) {
                    [this.pdfFont, this.xfaFont] = this.defaultFont(fontFinder);
                    return;
                  }
                  this.xfaFont = {
                    typeface: xfaFont.typeface,
                    posture: xfaFont.posture,
                    weight: xfaFont.weight,
                    size: xfaFont.size,
                    letterSpacing: xfaFont.letterSpacing
                  };
                  const typeface = fontFinder.find(xfaFont.typeface);
                  if (!typeface) {
                    [this.pdfFont, this.xfaFont] = this.defaultFont(fontFinder);
                    return;
                  }
                  this.pdfFont = (0, _fonts.selectFont)(xfaFont, typeface);
                  if (!this.pdfFont) {
                    [this.pdfFont, this.xfaFont] = this.defaultFont(fontFinder);
                  }
                }
                defaultFont(fontFinder) {
                  const font = fontFinder.find("Helvetica", false) || fontFinder.find("Myriad Pro", false) || fontFinder.find("Arial", false) || fontFinder.getDefault();
                  if (font?.regular) {
                    const pdfFont = font.regular;
                    const info = pdfFont.cssFontInfo;
                    const xfaFont2 = {
                      typeface: info.fontFamily,
                      posture: "normal",
                      weight: "normal",
                      size: 10,
                      letterSpacing: 0
                    };
                    return [pdfFont, xfaFont2];
                  }
                  const xfaFont = {
                    typeface: "Courier",
                    posture: "normal",
                    weight: "normal",
                    size: 10,
                    letterSpacing: 0
                  };
                  return [null, xfaFont];
                }
              }
              class FontSelector {
                constructor(defaultXfaFont, defaultParaMargin, defaultLineHeight, fontFinder) {
                  this.fontFinder = fontFinder;
                  this.stack = [new FontInfo(defaultXfaFont, defaultParaMargin, defaultLineHeight, fontFinder)];
                }
                pushData(xfaFont, margin, lineHeight) {
                  const lastFont = this.stack.at(-1);
                  for (const name of ["typeface", "posture", "weight", "size", "letterSpacing"]) {
                    if (!xfaFont[name]) {
                      xfaFont[name] = lastFont.xfaFont[name];
                    }
                  }
                  for (const name of ["top", "bottom", "left", "right"]) {
                    if (isNaN(margin[name])) {
                      margin[name] = lastFont.paraMargin[name];
                    }
                  }
                  const fontInfo = new FontInfo(xfaFont, margin, lineHeight || lastFont.lineHeight, this.fontFinder);
                  if (!fontInfo.pdfFont) {
                    fontInfo.pdfFont = lastFont.pdfFont;
                  }
                  this.stack.push(fontInfo);
                }
                popFont() {
                  this.stack.pop();
                }
                topFont() {
                  return this.stack.at(-1);
                }
              }
              class TextMeasure {
                constructor(defaultXfaFont, defaultParaMargin, defaultLineHeight, fonts) {
                  this.glyphs = [];
                  this.fontSelector = new FontSelector(defaultXfaFont, defaultParaMargin, defaultLineHeight, fonts);
                  this.extraHeight = 0;
                }
                pushData(xfaFont, margin, lineHeight) {
                  this.fontSelector.pushData(xfaFont, margin, lineHeight);
                }
                popFont(xfaFont) {
                  return this.fontSelector.popFont();
                }
                addPara() {
                  const lastFont = this.fontSelector.topFont();
                  this.extraHeight += lastFont.paraMargin.top + lastFont.paraMargin.bottom;
                }
                addString(str) {
                  if (!str) {
                    return;
                  }
                  const lastFont = this.fontSelector.topFont();
                  const fontSize = lastFont.xfaFont.size;
                  if (lastFont.pdfFont) {
                    const letterSpacing = lastFont.xfaFont.letterSpacing;
                    const pdfFont = lastFont.pdfFont;
                    const fontLineHeight = pdfFont.lineHeight || 1.2;
                    const lineHeight = lastFont.lineHeight || Math.max(1.2, fontLineHeight) * fontSize;
                    const lineGap = pdfFont.lineGap === void 0 ? 0.2 : pdfFont.lineGap;
                    const noGap = fontLineHeight - lineGap;
                    const firstLineHeight = Math.max(1, noGap) * fontSize;
                    const scale = fontSize / 1e3;
                    const fallbackWidth = pdfFont.defaultWidth || pdfFont.charsToGlyphs(" ")[0].width;
                    for (const line2 of str.split(/[\u2029\n]/)) {
                      const encodedLine = pdfFont.encodeString(line2).join("");
                      const glyphs = pdfFont.charsToGlyphs(encodedLine);
                      for (const glyph of glyphs) {
                        const width = glyph.width || fallbackWidth;
                        this.glyphs.push([width * scale + letterSpacing, lineHeight, firstLineHeight, glyph.unicode, false]);
                      }
                      this.glyphs.push([0, 0, 0, "\n", true]);
                    }
                    this.glyphs.pop();
                    return;
                  }
                  for (const line2 of str.split(/[\u2029\n]/)) {
                    for (const char2 of line2.split("")) {
                      this.glyphs.push([fontSize, 1.2 * fontSize, fontSize, char2, false]);
                    }
                    this.glyphs.push([0, 0, 0, "\n", true]);
                  }
                  this.glyphs.pop();
                }
                compute(maxWidth) {
                  let lastSpacePos = -1, lastSpaceWidth = 0, width = 0, height = 0, currentLineWidth = 0, currentLineHeight = 0;
                  let isBroken = false;
                  let isFirstLine = true;
                  for (let i = 0, ii = this.glyphs.length; i < ii; i++) {
                    const [glyphWidth, lineHeight, firstLineHeight, char2, isEOL] = this.glyphs[i];
                    const isSpace = char2 === " ";
                    const glyphHeight = isFirstLine ? firstLineHeight : lineHeight;
                    if (isEOL) {
                      width = Math.max(width, currentLineWidth);
                      currentLineWidth = 0;
                      height += currentLineHeight;
                      currentLineHeight = glyphHeight;
                      lastSpacePos = -1;
                      lastSpaceWidth = 0;
                      isFirstLine = false;
                      continue;
                    }
                    if (isSpace) {
                      if (currentLineWidth + glyphWidth > maxWidth) {
                        width = Math.max(width, currentLineWidth);
                        currentLineWidth = 0;
                        height += currentLineHeight;
                        currentLineHeight = glyphHeight;
                        lastSpacePos = -1;
                        lastSpaceWidth = 0;
                        isBroken = true;
                        isFirstLine = false;
                      } else {
                        currentLineHeight = Math.max(glyphHeight, currentLineHeight);
                        lastSpaceWidth = currentLineWidth;
                        currentLineWidth += glyphWidth;
                        lastSpacePos = i;
                      }
                      continue;
                    }
                    if (currentLineWidth + glyphWidth > maxWidth) {
                      height += currentLineHeight;
                      currentLineHeight = glyphHeight;
                      if (lastSpacePos !== -1) {
                        i = lastSpacePos;
                        width = Math.max(width, lastSpaceWidth);
                        currentLineWidth = 0;
                        lastSpacePos = -1;
                        lastSpaceWidth = 0;
                      } else {
                        width = Math.max(width, currentLineWidth);
                        currentLineWidth = glyphWidth;
                      }
                      isBroken = true;
                      isFirstLine = false;
                      continue;
                    }
                    currentLineWidth += glyphWidth;
                    currentLineHeight = Math.max(glyphHeight, currentLineHeight);
                  }
                  width = Math.max(width, currentLineWidth);
                  height += currentLineHeight + this.extraHeight;
                  return {
                    width: WIDTH_FACTOR * width,
                    height,
                    isBroken
                  };
                }
              }
              exports3.TextMeasure = TextMeasure;
            }),
            /* 87 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.XmlObject = exports3.XFAObjectArray = exports3.XFAObject = exports3.XFAAttribute = exports3.StringObject = exports3.OptionObject = exports3.Option10 = exports3.Option01 = exports3.IntegerObject = exports3.ContentObject = void 0;
              var _symbol_utils = __w_pdfjs_require__3(78);
              var _utils = __w_pdfjs_require__3(84);
              var _util2 = __w_pdfjs_require__3(2);
              var _core_utils = __w_pdfjs_require__3(3);
              var _namespaces = __w_pdfjs_require__3(81);
              var _som = __w_pdfjs_require__3(88);
              const _applyPrototype = Symbol();
              const _attributes = Symbol();
              const _attributeNames = Symbol();
              const _children = Symbol("_children");
              const _cloneAttribute = Symbol();
              const _dataValue = Symbol();
              const _defaultValue = Symbol();
              const _filteredChildrenGenerator = Symbol();
              const _getPrototype = Symbol();
              const _getUnsetAttributes = Symbol();
              const _hasChildren = Symbol();
              const _max = Symbol();
              const _options = Symbol();
              const _parent = Symbol("parent");
              const _resolvePrototypesHelper = Symbol();
              const _setAttributes = Symbol();
              const _validator = Symbol();
              let uid3 = 0;
              const NS_DATASETS = _namespaces.NamespaceIds.datasets.id;
              class XFAObject {
                constructor(nsId, name, hasChildren = false) {
                  this[_symbol_utils.$namespaceId] = nsId;
                  this[_symbol_utils.$nodeName] = name;
                  this[_hasChildren] = hasChildren;
                  this[_parent] = null;
                  this[_children] = [];
                  this[_symbol_utils.$uid] = `${name}${uid3++}`;
                  this[_symbol_utils.$globalData] = null;
                }
                get isXFAObject() {
                  return true;
                }
                get isXFAObjectArray() {
                  return false;
                }
                createNodes(path2) {
                  let root2 = this, node2 = null;
                  for (const {
                    name,
                    index: index3
                  } of path2) {
                    for (let i = 0, ii = isFinite(index3) ? index3 : 0; i <= ii; i++) {
                      const nsId = root2[_symbol_utils.$namespaceId] === NS_DATASETS ? -1 : root2[_symbol_utils.$namespaceId];
                      node2 = new XmlObject(nsId, name);
                      root2[_symbol_utils.$appendChild](node2);
                    }
                    root2 = node2;
                  }
                  return node2;
                }
                [_symbol_utils.$onChild](child) {
                  if (!this[_hasChildren] || !this[_symbol_utils.$onChildCheck](child)) {
                    return false;
                  }
                  const name = child[_symbol_utils.$nodeName];
                  const node2 = this[name];
                  if (node2 instanceof XFAObjectArray) {
                    if (node2.push(child)) {
                      this[_symbol_utils.$appendChild](child);
                      return true;
                    }
                  } else {
                    if (node2 !== null) {
                      this[_symbol_utils.$removeChild](node2);
                    }
                    this[name] = child;
                    this[_symbol_utils.$appendChild](child);
                    return true;
                  }
                  let id = "";
                  if (this.id) {
                    id = ` (id: ${this.id})`;
                  } else if (this.name) {
                    id = ` (name: ${this.name} ${this.h.value})`;
                  }
                  (0, _util2.warn)(`XFA - node "${this[_symbol_utils.$nodeName]}"${id} has already enough "${name}"!`);
                  return false;
                }
                [_symbol_utils.$onChildCheck](child) {
                  return this.hasOwnProperty(child[_symbol_utils.$nodeName]) && child[_symbol_utils.$namespaceId] === this[_symbol_utils.$namespaceId];
                }
                [_symbol_utils.$isNsAgnostic]() {
                  return false;
                }
                [_symbol_utils.$acceptWhitespace]() {
                  return false;
                }
                [_symbol_utils.$isCDATAXml]() {
                  return false;
                }
                [_symbol_utils.$isBindable]() {
                  return false;
                }
                [_symbol_utils.$popPara]() {
                  if (this.para) {
                    this[_symbol_utils.$getTemplateRoot]()[_symbol_utils.$extra].paraStack.pop();
                  }
                }
                [_symbol_utils.$pushPara]() {
                  this[_symbol_utils.$getTemplateRoot]()[_symbol_utils.$extra].paraStack.push(this.para);
                }
                [_symbol_utils.$setId](ids2) {
                  if (this.id && this[_symbol_utils.$namespaceId] === _namespaces.NamespaceIds.template.id) {
                    ids2.set(this.id, this);
                  }
                }
                [_symbol_utils.$getTemplateRoot]() {
                  return this[_symbol_utils.$globalData].template;
                }
                [_symbol_utils.$isSplittable]() {
                  return false;
                }
                [_symbol_utils.$isThereMoreWidth]() {
                  return false;
                }
                [_symbol_utils.$appendChild](child) {
                  child[_parent] = this;
                  this[_children].push(child);
                  if (!child[_symbol_utils.$globalData] && this[_symbol_utils.$globalData]) {
                    child[_symbol_utils.$globalData] = this[_symbol_utils.$globalData];
                  }
                }
                [_symbol_utils.$removeChild](child) {
                  const i = this[_children].indexOf(child);
                  this[_children].splice(i, 1);
                }
                [_symbol_utils.$hasSettableValue]() {
                  return this.hasOwnProperty("value");
                }
                [_symbol_utils.$setValue](_) {
                }
                [_symbol_utils.$onText](_) {
                }
                [_symbol_utils.$finalize]() {
                }
                [_symbol_utils.$clean](builder) {
                  delete this[_hasChildren];
                  if (this[_symbol_utils.$cleanup]) {
                    builder.clean(this[_symbol_utils.$cleanup]);
                    delete this[_symbol_utils.$cleanup];
                  }
                }
                [_symbol_utils.$indexOf](child) {
                  return this[_children].indexOf(child);
                }
                [_symbol_utils.$insertAt](i, child) {
                  child[_parent] = this;
                  this[_children].splice(i, 0, child);
                  if (!child[_symbol_utils.$globalData] && this[_symbol_utils.$globalData]) {
                    child[_symbol_utils.$globalData] = this[_symbol_utils.$globalData];
                  }
                }
                [_symbol_utils.$isTransparent]() {
                  return !this.name;
                }
                [_symbol_utils.$lastAttribute]() {
                  return "";
                }
                [_symbol_utils.$text]() {
                  if (this[_children].length === 0) {
                    return this[_symbol_utils.$content];
                  }
                  return this[_children].map((c) => c[_symbol_utils.$text]()).join("");
                }
                get [_attributeNames]() {
                  const proto = Object.getPrototypeOf(this);
                  if (!proto._attributes) {
                    const attributes2 = proto._attributes = /* @__PURE__ */ new Set();
                    for (const name of Object.getOwnPropertyNames(this)) {
                      if (this[name] === null || this[name] instanceof XFAObject || this[name] instanceof XFAObjectArray) {
                        break;
                      }
                      attributes2.add(name);
                    }
                  }
                  return (0, _util2.shadow)(this, _attributeNames, proto._attributes);
                }
                [_symbol_utils.$isDescendent](parent2) {
                  let node2 = this;
                  while (node2) {
                    if (node2 === parent2) {
                      return true;
                    }
                    node2 = node2[_symbol_utils.$getParent]();
                  }
                  return false;
                }
                [_symbol_utils.$getParent]() {
                  return this[_parent];
                }
                [_symbol_utils.$getSubformParent]() {
                  return this[_symbol_utils.$getParent]();
                }
                [_symbol_utils.$getChildren](name = null) {
                  if (!name) {
                    return this[_children];
                  }
                  return this[name];
                }
                [_symbol_utils.$dump]() {
                  const dumped = /* @__PURE__ */ Object.create(null);
                  if (this[_symbol_utils.$content]) {
                    dumped.$content = this[_symbol_utils.$content];
                  }
                  for (const name of Object.getOwnPropertyNames(this)) {
                    const value = this[name];
                    if (value === null) {
                      continue;
                    }
                    if (value instanceof XFAObject) {
                      dumped[name] = value[_symbol_utils.$dump]();
                    } else if (value instanceof XFAObjectArray) {
                      if (!value.isEmpty()) {
                        dumped[name] = value.dump();
                      }
                    } else {
                      dumped[name] = value;
                    }
                  }
                  return dumped;
                }
                [_symbol_utils.$toStyle]() {
                  return null;
                }
                [_symbol_utils.$toHTML]() {
                  return _utils.HTMLResult.EMPTY;
                }
                *[_symbol_utils.$getContainedChildren]() {
                  for (const node2 of this[_symbol_utils.$getChildren]()) {
                    yield node2;
                  }
                }
                *[_filteredChildrenGenerator](filter3, include) {
                  for (const node2 of this[_symbol_utils.$getContainedChildren]()) {
                    if (!filter3 || include === filter3.has(node2[_symbol_utils.$nodeName])) {
                      const availableSpace = this[_symbol_utils.$getAvailableSpace]();
                      const res = node2[_symbol_utils.$toHTML](availableSpace);
                      if (!res.success) {
                        this[_symbol_utils.$extra].failingNode = node2;
                      }
                      yield res;
                    }
                  }
                }
                [_symbol_utils.$flushHTML]() {
                  return null;
                }
                [_symbol_utils.$addHTML](html2, bbox) {
                  this[_symbol_utils.$extra].children.push(html2);
                }
                [_symbol_utils.$getAvailableSpace]() {
                }
                [_symbol_utils.$childrenToHTML]({
                  filter: filter3 = null,
                  include = true
                }) {
                  if (!this[_symbol_utils.$extra].generator) {
                    this[_symbol_utils.$extra].generator = this[_filteredChildrenGenerator](filter3, include);
                  } else {
                    const availableSpace = this[_symbol_utils.$getAvailableSpace]();
                    const res = this[_symbol_utils.$extra].failingNode[_symbol_utils.$toHTML](availableSpace);
                    if (!res.success) {
                      return res;
                    }
                    if (res.html) {
                      this[_symbol_utils.$addHTML](res.html, res.bbox);
                    }
                    delete this[_symbol_utils.$extra].failingNode;
                  }
                  while (true) {
                    const gen = this[_symbol_utils.$extra].generator.next();
                    if (gen.done) {
                      break;
                    }
                    const res = gen.value;
                    if (!res.success) {
                      return res;
                    }
                    if (res.html) {
                      this[_symbol_utils.$addHTML](res.html, res.bbox);
                    }
                  }
                  this[_symbol_utils.$extra].generator = null;
                  return _utils.HTMLResult.EMPTY;
                }
                [_symbol_utils.$setSetAttributes](attributes2) {
                  this[_setAttributes] = new Set(Object.keys(attributes2));
                }
                [_getUnsetAttributes](protoAttributes) {
                  const allAttr = this[_attributeNames];
                  const setAttr = this[_setAttributes];
                  return [...protoAttributes].filter((x) => allAttr.has(x) && !setAttr.has(x));
                }
                [_symbol_utils.$resolvePrototypes](ids2, ancestors = /* @__PURE__ */ new Set()) {
                  for (const child of this[_children]) {
                    child[_resolvePrototypesHelper](ids2, ancestors);
                  }
                }
                [_resolvePrototypesHelper](ids2, ancestors) {
                  const proto = this[_getPrototype](ids2, ancestors);
                  if (proto) {
                    this[_applyPrototype](proto, ids2, ancestors);
                  } else {
                    this[_symbol_utils.$resolvePrototypes](ids2, ancestors);
                  }
                }
                [_getPrototype](ids2, ancestors) {
                  const {
                    use,
                    usehref
                  } = this;
                  if (!use && !usehref) {
                    return null;
                  }
                  let proto = null;
                  let somExpression = null;
                  let id = null;
                  let ref3 = use;
                  if (usehref) {
                    ref3 = usehref;
                    if (usehref.startsWith("#som(") && usehref.endsWith(")")) {
                      somExpression = usehref.slice("#som(".length, -1);
                    } else if (usehref.startsWith(".#som(") && usehref.endsWith(")")) {
                      somExpression = usehref.slice(".#som(".length, -1);
                    } else if (usehref.startsWith("#")) {
                      id = usehref.slice(1);
                    } else if (usehref.startsWith(".#")) {
                      id = usehref.slice(2);
                    }
                  } else if (use.startsWith("#")) {
                    id = use.slice(1);
                  } else {
                    somExpression = use;
                  }
                  this.use = this.usehref = "";
                  if (id) {
                    proto = ids2.get(id);
                  } else {
                    proto = (0, _som.searchNode)(ids2.get(_symbol_utils.$root), this, somExpression, true, false);
                    if (proto) {
                      proto = proto[0];
                    }
                  }
                  if (!proto) {
                    (0, _util2.warn)(`XFA - Invalid prototype reference: ${ref3}.`);
                    return null;
                  }
                  if (proto[_symbol_utils.$nodeName] !== this[_symbol_utils.$nodeName]) {
                    (0, _util2.warn)(`XFA - Incompatible prototype: ${proto[_symbol_utils.$nodeName]} !== ${this[_symbol_utils.$nodeName]}.`);
                    return null;
                  }
                  if (ancestors.has(proto)) {
                    (0, _util2.warn)(`XFA - Cycle detected in prototypes use.`);
                    return null;
                  }
                  ancestors.add(proto);
                  const protoProto = proto[_getPrototype](ids2, ancestors);
                  if (protoProto) {
                    proto[_applyPrototype](protoProto, ids2, ancestors);
                  }
                  proto[_symbol_utils.$resolvePrototypes](ids2, ancestors);
                  ancestors.delete(proto);
                  return proto;
                }
                [_applyPrototype](proto, ids2, ancestors) {
                  if (ancestors.has(proto)) {
                    (0, _util2.warn)(`XFA - Cycle detected in prototypes use.`);
                    return;
                  }
                  if (!this[_symbol_utils.$content] && proto[_symbol_utils.$content]) {
                    this[_symbol_utils.$content] = proto[_symbol_utils.$content];
                  }
                  const newAncestors = new Set(ancestors);
                  newAncestors.add(proto);
                  for (const unsetAttrName of this[_getUnsetAttributes](proto[_setAttributes])) {
                    this[unsetAttrName] = proto[unsetAttrName];
                    if (this[_setAttributes]) {
                      this[_setAttributes].add(unsetAttrName);
                    }
                  }
                  for (const name of Object.getOwnPropertyNames(this)) {
                    if (this[_attributeNames].has(name)) {
                      continue;
                    }
                    const value = this[name];
                    const protoValue = proto[name];
                    if (value instanceof XFAObjectArray) {
                      for (const child of value[_children]) {
                        child[_resolvePrototypesHelper](ids2, ancestors);
                      }
                      for (let i = value[_children].length, ii = protoValue[_children].length; i < ii; i++) {
                        const child = proto[_children][i][_symbol_utils.$clone]();
                        if (value.push(child)) {
                          child[_parent] = this;
                          this[_children].push(child);
                          child[_resolvePrototypesHelper](ids2, ancestors);
                        } else {
                          break;
                        }
                      }
                      continue;
                    }
                    if (value !== null) {
                      value[_symbol_utils.$resolvePrototypes](ids2, ancestors);
                      if (protoValue) {
                        value[_applyPrototype](protoValue, ids2, ancestors);
                      }
                      continue;
                    }
                    if (protoValue !== null) {
                      const child = protoValue[_symbol_utils.$clone]();
                      child[_parent] = this;
                      this[name] = child;
                      this[_children].push(child);
                      child[_resolvePrototypesHelper](ids2, ancestors);
                    }
                  }
                }
                static [_cloneAttribute](obj) {
                  if (Array.isArray(obj)) {
                    return obj.map((x) => XFAObject[_cloneAttribute](x));
                  }
                  if (typeof obj === "object" && obj !== null) {
                    return Object.assign({}, obj);
                  }
                  return obj;
                }
                [_symbol_utils.$clone]() {
                  const clone = Object.create(Object.getPrototypeOf(this));
                  for (const $symbol of Object.getOwnPropertySymbols(this)) {
                    try {
                      clone[$symbol] = this[$symbol];
                    } catch {
                      (0, _util2.shadow)(clone, $symbol, this[$symbol]);
                    }
                  }
                  clone[_symbol_utils.$uid] = `${clone[_symbol_utils.$nodeName]}${uid3++}`;
                  clone[_children] = [];
                  for (const name of Object.getOwnPropertyNames(this)) {
                    if (this[_attributeNames].has(name)) {
                      clone[name] = XFAObject[_cloneAttribute](this[name]);
                      continue;
                    }
                    const value = this[name];
                    clone[name] = value instanceof XFAObjectArray ? new XFAObjectArray(value[_max]) : null;
                  }
                  for (const child of this[_children]) {
                    const name = child[_symbol_utils.$nodeName];
                    const clonedChild = child[_symbol_utils.$clone]();
                    clone[_children].push(clonedChild);
                    clonedChild[_parent] = clone;
                    if (clone[name] === null) {
                      clone[name] = clonedChild;
                    } else {
                      clone[name][_children].push(clonedChild);
                    }
                  }
                  return clone;
                }
                [_symbol_utils.$getChildren](name = null) {
                  if (!name) {
                    return this[_children];
                  }
                  return this[_children].filter((c) => c[_symbol_utils.$nodeName] === name);
                }
                [_symbol_utils.$getChildrenByClass](name) {
                  return this[name];
                }
                [_symbol_utils.$getChildrenByName](name, allTransparent, first = true) {
                  return Array.from(this[_symbol_utils.$getChildrenByNameIt](name, allTransparent, first));
                }
                *[_symbol_utils.$getChildrenByNameIt](name, allTransparent, first = true) {
                  if (name === "parent") {
                    yield this[_parent];
                    return;
                  }
                  for (const child of this[_children]) {
                    if (child[_symbol_utils.$nodeName] === name) {
                      yield child;
                    }
                    if (child.name === name) {
                      yield child;
                    }
                    if (allTransparent || child[_symbol_utils.$isTransparent]()) {
                      yield* child[_symbol_utils.$getChildrenByNameIt](name, allTransparent, false);
                    }
                  }
                  if (first && this[_attributeNames].has(name)) {
                    yield new XFAAttribute(this, name, this[name]);
                  }
                }
              }
              exports3.XFAObject = XFAObject;
              class XFAObjectArray {
                constructor(max = Infinity) {
                  this[_max] = max;
                  this[_children] = [];
                }
                get isXFAObject() {
                  return false;
                }
                get isXFAObjectArray() {
                  return true;
                }
                push(child) {
                  const len = this[_children].length;
                  if (len <= this[_max]) {
                    this[_children].push(child);
                    return true;
                  }
                  (0, _util2.warn)(`XFA - node "${child[_symbol_utils.$nodeName]}" accepts no more than ${this[_max]} children`);
                  return false;
                }
                isEmpty() {
                  return this[_children].length === 0;
                }
                dump() {
                  return this[_children].length === 1 ? this[_children][0][_symbol_utils.$dump]() : this[_children].map((x) => x[_symbol_utils.$dump]());
                }
                [_symbol_utils.$clone]() {
                  const clone = new XFAObjectArray(this[_max]);
                  clone[_children] = this[_children].map((c) => c[_symbol_utils.$clone]());
                  return clone;
                }
                get children() {
                  return this[_children];
                }
                clear() {
                  this[_children].length = 0;
                }
              }
              exports3.XFAObjectArray = XFAObjectArray;
              class XFAAttribute {
                constructor(node2, name, value) {
                  this[_parent] = node2;
                  this[_symbol_utils.$nodeName] = name;
                  this[_symbol_utils.$content] = value;
                  this[_symbol_utils.$consumed] = false;
                  this[_symbol_utils.$uid] = `attribute${uid3++}`;
                }
                [_symbol_utils.$getParent]() {
                  return this[_parent];
                }
                [_symbol_utils.$isDataValue]() {
                  return true;
                }
                [_symbol_utils.$getDataValue]() {
                  return this[_symbol_utils.$content].trim();
                }
                [_symbol_utils.$setValue](value) {
                  value = value.value || "";
                  this[_symbol_utils.$content] = value.toString();
                }
                [_symbol_utils.$text]() {
                  return this[_symbol_utils.$content];
                }
                [_symbol_utils.$isDescendent](parent2) {
                  return this[_parent] === parent2 || this[_parent][_symbol_utils.$isDescendent](parent2);
                }
              }
              exports3.XFAAttribute = XFAAttribute;
              class XmlObject extends XFAObject {
                constructor(nsId, name, attributes2 = {}) {
                  super(nsId, name);
                  this[_symbol_utils.$content] = "";
                  this[_dataValue] = null;
                  if (name !== "#text") {
                    const map = /* @__PURE__ */ new Map();
                    this[_attributes] = map;
                    for (const [attrName, value] of Object.entries(attributes2)) {
                      map.set(attrName, new XFAAttribute(this, attrName, value));
                    }
                    if (attributes2.hasOwnProperty(_symbol_utils.$nsAttributes)) {
                      const dataNode = attributes2[_symbol_utils.$nsAttributes].xfa.dataNode;
                      if (dataNode !== void 0) {
                        if (dataNode === "dataGroup") {
                          this[_dataValue] = false;
                        } else if (dataNode === "dataValue") {
                          this[_dataValue] = true;
                        }
                      }
                    }
                  }
                  this[_symbol_utils.$consumed] = false;
                }
                [_symbol_utils.$toString](buf) {
                  const tagName = this[_symbol_utils.$nodeName];
                  if (tagName === "#text") {
                    buf.push((0, _core_utils.encodeToXmlString)(this[_symbol_utils.$content]));
                    return;
                  }
                  const utf8TagName = (0, _util2.utf8StringToString)(tagName);
                  const prefix3 = this[_symbol_utils.$namespaceId] === NS_DATASETS ? "xfa:" : "";
                  buf.push(`<${prefix3}${utf8TagName}`);
                  for (const [name, value] of this[_attributes].entries()) {
                    const utf8Name = (0, _util2.utf8StringToString)(name);
                    buf.push(` ${utf8Name}="${(0, _core_utils.encodeToXmlString)(value[_symbol_utils.$content])}"`);
                  }
                  if (this[_dataValue] !== null) {
                    if (this[_dataValue]) {
                      buf.push(` xfa:dataNode="dataValue"`);
                    } else {
                      buf.push(` xfa:dataNode="dataGroup"`);
                    }
                  }
                  if (!this[_symbol_utils.$content] && this[_children].length === 0) {
                    buf.push("/>");
                    return;
                  }
                  buf.push(">");
                  if (this[_symbol_utils.$content]) {
                    if (typeof this[_symbol_utils.$content] === "string") {
                      buf.push((0, _core_utils.encodeToXmlString)(this[_symbol_utils.$content]));
                    } else {
                      this[_symbol_utils.$content][_symbol_utils.$toString](buf);
                    }
                  } else {
                    for (const child of this[_children]) {
                      child[_symbol_utils.$toString](buf);
                    }
                  }
                  buf.push(`</${prefix3}${utf8TagName}>`);
                }
                [_symbol_utils.$onChild](child) {
                  if (this[_symbol_utils.$content]) {
                    const node2 = new XmlObject(this[_symbol_utils.$namespaceId], "#text");
                    this[_symbol_utils.$appendChild](node2);
                    node2[_symbol_utils.$content] = this[_symbol_utils.$content];
                    this[_symbol_utils.$content] = "";
                  }
                  this[_symbol_utils.$appendChild](child);
                  return true;
                }
                [_symbol_utils.$onText](str) {
                  this[_symbol_utils.$content] += str;
                }
                [_symbol_utils.$finalize]() {
                  if (this[_symbol_utils.$content] && this[_children].length > 0) {
                    const node2 = new XmlObject(this[_symbol_utils.$namespaceId], "#text");
                    this[_symbol_utils.$appendChild](node2);
                    node2[_symbol_utils.$content] = this[_symbol_utils.$content];
                    delete this[_symbol_utils.$content];
                  }
                }
                [_symbol_utils.$toHTML]() {
                  if (this[_symbol_utils.$nodeName] === "#text") {
                    return _utils.HTMLResult.success({
                      name: "#text",
                      value: this[_symbol_utils.$content]
                    });
                  }
                  return _utils.HTMLResult.EMPTY;
                }
                [_symbol_utils.$getChildren](name = null) {
                  if (!name) {
                    return this[_children];
                  }
                  return this[_children].filter((c) => c[_symbol_utils.$nodeName] === name);
                }
                [_symbol_utils.$getAttributes]() {
                  return this[_attributes];
                }
                [_symbol_utils.$getChildrenByClass](name) {
                  const value = this[_attributes].get(name);
                  if (value !== void 0) {
                    return value;
                  }
                  return this[_symbol_utils.$getChildren](name);
                }
                *[_symbol_utils.$getChildrenByNameIt](name, allTransparent) {
                  const value = this[_attributes].get(name);
                  if (value) {
                    yield value;
                  }
                  for (const child of this[_children]) {
                    if (child[_symbol_utils.$nodeName] === name) {
                      yield child;
                    }
                    if (allTransparent) {
                      yield* child[_symbol_utils.$getChildrenByNameIt](name, allTransparent);
                    }
                  }
                }
                *[_symbol_utils.$getAttributeIt](name, skipConsumed) {
                  const value = this[_attributes].get(name);
                  if (value && (!skipConsumed || !value[_symbol_utils.$consumed])) {
                    yield value;
                  }
                  for (const child of this[_children]) {
                    yield* child[_symbol_utils.$getAttributeIt](name, skipConsumed);
                  }
                }
                *[_symbol_utils.$getRealChildrenByNameIt](name, allTransparent, skipConsumed) {
                  for (const child of this[_children]) {
                    if (child[_symbol_utils.$nodeName] === name && (!skipConsumed || !child[_symbol_utils.$consumed])) {
                      yield child;
                    }
                    if (allTransparent) {
                      yield* child[_symbol_utils.$getRealChildrenByNameIt](name, allTransparent, skipConsumed);
                    }
                  }
                }
                [_symbol_utils.$isDataValue]() {
                  if (this[_dataValue] === null) {
                    return this[_children].length === 0 || this[_children][0][_symbol_utils.$namespaceId] === _namespaces.NamespaceIds.xhtml.id;
                  }
                  return this[_dataValue];
                }
                [_symbol_utils.$getDataValue]() {
                  if (this[_dataValue] === null) {
                    if (this[_children].length === 0) {
                      return this[_symbol_utils.$content].trim();
                    }
                    if (this[_children][0][_symbol_utils.$namespaceId] === _namespaces.NamespaceIds.xhtml.id) {
                      return this[_children][0][_symbol_utils.$text]().trim();
                    }
                    return null;
                  }
                  return this[_symbol_utils.$content].trim();
                }
                [_symbol_utils.$setValue](value) {
                  value = value.value || "";
                  this[_symbol_utils.$content] = value.toString();
                }
                [_symbol_utils.$dump](hasNS = false) {
                  const dumped = /* @__PURE__ */ Object.create(null);
                  if (hasNS) {
                    dumped.$ns = this[_symbol_utils.$namespaceId];
                  }
                  if (this[_symbol_utils.$content]) {
                    dumped.$content = this[_symbol_utils.$content];
                  }
                  dumped.$name = this[_symbol_utils.$nodeName];
                  dumped.children = [];
                  for (const child of this[_children]) {
                    dumped.children.push(child[_symbol_utils.$dump](hasNS));
                  }
                  dumped.attributes = /* @__PURE__ */ Object.create(null);
                  for (const [name, value] of this[_attributes]) {
                    dumped.attributes[name] = value[_symbol_utils.$content];
                  }
                  return dumped;
                }
              }
              exports3.XmlObject = XmlObject;
              class ContentObject extends XFAObject {
                constructor(nsId, name) {
                  super(nsId, name);
                  this[_symbol_utils.$content] = "";
                }
                [_symbol_utils.$onText](text) {
                  this[_symbol_utils.$content] += text;
                }
                [_symbol_utils.$finalize]() {
                }
              }
              exports3.ContentObject = ContentObject;
              class OptionObject extends ContentObject {
                constructor(nsId, name, options) {
                  super(nsId, name);
                  this[_options] = options;
                }
                [_symbol_utils.$finalize]() {
                  this[_symbol_utils.$content] = (0, _utils.getKeyword)({
                    data: this[_symbol_utils.$content],
                    defaultValue: this[_options][0],
                    validate: (k) => this[_options].includes(k)
                  });
                }
                [_symbol_utils.$clean](builder) {
                  super[_symbol_utils.$clean](builder);
                  delete this[_options];
                }
              }
              exports3.OptionObject = OptionObject;
              class StringObject extends ContentObject {
                [_symbol_utils.$finalize]() {
                  this[_symbol_utils.$content] = this[_symbol_utils.$content].trim();
                }
              }
              exports3.StringObject = StringObject;
              class IntegerObject extends ContentObject {
                constructor(nsId, name, defaultValue2, validator) {
                  super(nsId, name);
                  this[_defaultValue] = defaultValue2;
                  this[_validator] = validator;
                }
                [_symbol_utils.$finalize]() {
                  this[_symbol_utils.$content] = (0, _utils.getInteger)({
                    data: this[_symbol_utils.$content],
                    defaultValue: this[_defaultValue],
                    validate: this[_validator]
                  });
                }
                [_symbol_utils.$clean](builder) {
                  super[_symbol_utils.$clean](builder);
                  delete this[_defaultValue];
                  delete this[_validator];
                }
              }
              exports3.IntegerObject = IntegerObject;
              class Option01 extends IntegerObject {
                constructor(nsId, name) {
                  super(nsId, name, 0, (n2) => n2 === 1);
                }
              }
              exports3.Option01 = Option01;
              class Option10 extends IntegerObject {
                constructor(nsId, name) {
                  super(nsId, name, 1, (n2) => n2 === 0);
                }
              }
              exports3.Option10 = Option10;
            }),
            /* 88 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.createDataNode = createDataNode;
              exports3.searchNode = searchNode;
              var _symbol_utils = __w_pdfjs_require__3(78);
              var _util2 = __w_pdfjs_require__3(2);
              const namePattern = /^[^.[]+/;
              const indexPattern = /^[^\]]+/;
              const operators = {
                dot: 0,
                dotDot: 1,
                dotHash: 2,
                dotBracket: 3,
                dotParen: 4
              };
              const shortcuts = /* @__PURE__ */ new Map([["$data", (root2, current2) => root2.datasets ? root2.datasets.data : root2], ["$record", (root2, current2) => (root2.datasets ? root2.datasets.data : root2)[_symbol_utils.$getChildren]()[0]], ["$template", (root2, current2) => root2.template], ["$connectionSet", (root2, current2) => root2.connectionSet], ["$form", (root2, current2) => root2.form], ["$layout", (root2, current2) => root2.layout], ["$host", (root2, current2) => root2.host], ["$dataWindow", (root2, current2) => root2.dataWindow], ["$event", (root2, current2) => root2.event], ["!", (root2, current2) => root2.datasets], ["$xfa", (root2, current2) => root2], ["xfa", (root2, current2) => root2], ["$", (root2, current2) => current2]]);
              const somCache = /* @__PURE__ */ new WeakMap();
              function parseIndex(index3) {
                index3 = index3.trim();
                if (index3 === "*") {
                  return Infinity;
                }
                return parseInt(index3, 10) || 0;
              }
              function parseExpression3(expr, dotDotAllowed, noExpr = true) {
                let match2 = expr.match(namePattern);
                if (!match2) {
                  return null;
                }
                let [name] = match2;
                const parsed = [{
                  name,
                  cacheName: "." + name,
                  index: 0,
                  js: null,
                  formCalc: null,
                  operator: operators.dot
                }];
                let pos = name.length;
                while (pos < expr.length) {
                  const spos = pos;
                  const char2 = expr.charAt(pos++);
                  if (char2 === "[") {
                    match2 = expr.slice(pos).match(indexPattern);
                    if (!match2) {
                      (0, _util2.warn)("XFA - Invalid index in SOM expression");
                      return null;
                    }
                    parsed.at(-1).index = parseIndex(match2[0]);
                    pos += match2[0].length + 1;
                    continue;
                  }
                  let operator;
                  switch (expr.charAt(pos)) {
                    case ".":
                      if (!dotDotAllowed) {
                        return null;
                      }
                      pos++;
                      operator = operators.dotDot;
                      break;
                    case "#":
                      pos++;
                      operator = operators.dotHash;
                      break;
                    case "[":
                      if (noExpr) {
                        (0, _util2.warn)("XFA - SOM expression contains a FormCalc subexpression which is not supported for now.");
                        return null;
                      }
                      operator = operators.dotBracket;
                      break;
                    case "(":
                      if (noExpr) {
                        (0, _util2.warn)("XFA - SOM expression contains a JavaScript subexpression which is not supported for now.");
                        return null;
                      }
                      operator = operators.dotParen;
                      break;
                    default:
                      operator = operators.dot;
                      break;
                  }
                  match2 = expr.slice(pos).match(namePattern);
                  if (!match2) {
                    break;
                  }
                  [name] = match2;
                  pos += name.length;
                  parsed.push({
                    name,
                    cacheName: expr.slice(spos, pos),
                    operator,
                    index: 0,
                    js: null,
                    formCalc: null
                  });
                }
                return parsed;
              }
              function searchNode(root2, container, expr, dotDotAllowed = true, useCache = true) {
                const parsed = parseExpression3(expr, dotDotAllowed);
                if (!parsed) {
                  return null;
                }
                const fn = shortcuts.get(parsed[0].name);
                let i = 0;
                let isQualified;
                if (fn) {
                  isQualified = true;
                  root2 = [fn(root2, container)];
                  i = 1;
                } else {
                  isQualified = container === null;
                  root2 = [container || root2];
                }
                for (let ii = parsed.length; i < ii; i++) {
                  const {
                    name,
                    cacheName,
                    operator,
                    index: index3
                  } = parsed[i];
                  const nodes = [];
                  for (const node2 of root2) {
                    if (!node2.isXFAObject) {
                      continue;
                    }
                    let children, cached2;
                    if (useCache) {
                      cached2 = somCache.get(node2);
                      if (!cached2) {
                        cached2 = /* @__PURE__ */ new Map();
                        somCache.set(node2, cached2);
                      }
                      children = cached2.get(cacheName);
                    }
                    if (!children) {
                      switch (operator) {
                        case operators.dot:
                          children = node2[_symbol_utils.$getChildrenByName](name, false);
                          break;
                        case operators.dotDot:
                          children = node2[_symbol_utils.$getChildrenByName](name, true);
                          break;
                        case operators.dotHash:
                          children = node2[_symbol_utils.$getChildrenByClass](name);
                          children = children.isXFAObjectArray ? children.children : [children];
                          break;
                        default:
                          break;
                      }
                      if (useCache) {
                        cached2.set(cacheName, children);
                      }
                    }
                    if (children.length > 0) {
                      nodes.push(children);
                    }
                  }
                  if (nodes.length === 0 && !isQualified && i === 0) {
                    const parent2 = container[_symbol_utils.$getParent]();
                    container = parent2;
                    if (!container) {
                      return null;
                    }
                    i = -1;
                    root2 = [container];
                    continue;
                  }
                  root2 = isFinite(index3) ? nodes.filter((node2) => index3 < node2.length).map((node2) => node2[index3]) : nodes.flat();
                }
                if (root2.length === 0) {
                  return null;
                }
                return root2;
              }
              function createDataNode(root2, container, expr) {
                const parsed = parseExpression3(expr);
                if (!parsed) {
                  return null;
                }
                if (parsed.some((x) => x.operator === operators.dotDot)) {
                  return null;
                }
                const fn = shortcuts.get(parsed[0].name);
                let i = 0;
                if (fn) {
                  root2 = fn(root2, container);
                  i = 1;
                } else {
                  root2 = container || root2;
                }
                for (let ii = parsed.length; i < ii; i++) {
                  const {
                    name,
                    operator,
                    index: index3
                  } = parsed[i];
                  if (!isFinite(index3)) {
                    parsed[i].index = 0;
                    return root2.createNodes(parsed.slice(i));
                  }
                  let children;
                  switch (operator) {
                    case operators.dot:
                      children = root2[_symbol_utils.$getChildrenByName](name, false);
                      break;
                    case operators.dotDot:
                      children = root2[_symbol_utils.$getChildrenByName](name, true);
                      break;
                    case operators.dotHash:
                      children = root2[_symbol_utils.$getChildrenByClass](name);
                      children = children.isXFAObjectArray ? children.children : [children];
                      break;
                    default:
                      break;
                  }
                  if (children.length === 0) {
                    return root2.createNodes(parsed.slice(i));
                  }
                  if (index3 < children.length) {
                    const child = children[index3];
                    if (!child.isXFAObject) {
                      (0, _util2.warn)(`XFA - Cannot create a node.`);
                      return null;
                    }
                    root2 = child;
                  } else {
                    parsed[i].index = index3 - children.length;
                    return root2.createNodes(parsed.slice(i));
                  }
                }
                return null;
              }
            }),
            /* 89 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.DataHandler = void 0;
              var _symbol_utils = __w_pdfjs_require__3(78);
              class DataHandler {
                constructor(root2, data2) {
                  this.data = data2;
                  this.dataset = root2.datasets || null;
                }
                serialize(storage) {
                  const stack = [[-1, this.data[_symbol_utils.$getChildren]()]];
                  while (stack.length > 0) {
                    const last2 = stack.at(-1);
                    const [i, children] = last2;
                    if (i + 1 === children.length) {
                      stack.pop();
                      continue;
                    }
                    const child = children[++last2[0]];
                    const storageEntry = storage.get(child[_symbol_utils.$uid]);
                    if (storageEntry) {
                      child[_symbol_utils.$setValue](storageEntry);
                    } else {
                      const attributes2 = child[_symbol_utils.$getAttributes]();
                      for (const value of attributes2.values()) {
                        const entry = storage.get(value[_symbol_utils.$uid]);
                        if (entry) {
                          value[_symbol_utils.$setValue](entry);
                          break;
                        }
                      }
                    }
                    const nodes = child[_symbol_utils.$getChildren]();
                    if (nodes.length > 0) {
                      stack.push([-1, nodes]);
                    }
                  }
                  const buf = [`<xfa:datasets xmlns:xfa="http://www.xfa.org/schema/xfa-data/1.0/">`];
                  if (this.dataset) {
                    for (const child of this.dataset[_symbol_utils.$getChildren]()) {
                      if (child[_symbol_utils.$nodeName] !== "data") {
                        child[_symbol_utils.$toString](buf);
                      }
                    }
                  }
                  this.data[_symbol_utils.$toString](buf);
                  buf.push("</xfa:datasets>");
                  return buf.join("");
                }
              }
              exports3.DataHandler = DataHandler;
            }),
            /* 90 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.XFAParser = void 0;
              var _symbol_utils = __w_pdfjs_require__3(78);
              var _xml_parser = __w_pdfjs_require__3(71);
              var _builder = __w_pdfjs_require__3(91);
              var _util2 = __w_pdfjs_require__3(2);
              class XFAParser extends _xml_parser.XMLParserBase {
                constructor(rootNameSpace = null, richText = false) {
                  super();
                  this._builder = new _builder.Builder(rootNameSpace);
                  this._stack = [];
                  this._globalData = {
                    usedTypefaces: /* @__PURE__ */ new Set()
                  };
                  this._ids = /* @__PURE__ */ new Map();
                  this._current = this._builder.buildRoot(this._ids);
                  this._errorCode = _xml_parser.XMLParserErrorCode.NoError;
                  this._whiteRegex = /^\s+$/;
                  this._nbsps = /\xa0+/g;
                  this._richText = richText;
                }
                parse(data2) {
                  this.parseXml(data2);
                  if (this._errorCode !== _xml_parser.XMLParserErrorCode.NoError) {
                    return void 0;
                  }
                  this._current[_symbol_utils.$finalize]();
                  return this._current.element;
                }
                onText(text) {
                  text = text.replace(this._nbsps, (match2) => match2.slice(1) + " ");
                  if (this._richText || this._current[_symbol_utils.$acceptWhitespace]()) {
                    this._current[_symbol_utils.$onText](text, this._richText);
                    return;
                  }
                  if (this._whiteRegex.test(text)) {
                    return;
                  }
                  this._current[_symbol_utils.$onText](text.trim());
                }
                onCdata(text) {
                  this._current[_symbol_utils.$onText](text);
                }
                _mkAttributes(attributes2, tagName) {
                  let namespace = null;
                  let prefixes = null;
                  const attributeObj = /* @__PURE__ */ Object.create({});
                  for (const {
                    name,
                    value
                  } of attributes2) {
                    if (name === "xmlns") {
                      if (!namespace) {
                        namespace = value;
                      } else {
                        (0, _util2.warn)(`XFA - multiple namespace definition in <${tagName}>`);
                      }
                    } else if (name.startsWith("xmlns:")) {
                      const prefix3 = name.substring("xmlns:".length);
                      if (!prefixes) {
                        prefixes = [];
                      }
                      prefixes.push({
                        prefix: prefix3,
                        value
                      });
                    } else {
                      const i = name.indexOf(":");
                      if (i === -1) {
                        attributeObj[name] = value;
                      } else {
                        let nsAttrs = attributeObj[_symbol_utils.$nsAttributes];
                        if (!nsAttrs) {
                          nsAttrs = attributeObj[_symbol_utils.$nsAttributes] = /* @__PURE__ */ Object.create(null);
                        }
                        const [ns, attrName] = [name.slice(0, i), name.slice(i + 1)];
                        const attrs = nsAttrs[ns] ||= /* @__PURE__ */ Object.create(null);
                        attrs[attrName] = value;
                      }
                    }
                  }
                  return [namespace, prefixes, attributeObj];
                }
                _getNameAndPrefix(name, nsAgnostic) {
                  const i = name.indexOf(":");
                  if (i === -1) {
                    return [name, null];
                  }
                  return [name.substring(i + 1), nsAgnostic ? "" : name.substring(0, i)];
                }
                onBeginElement(tagName, attributes2, isEmpty2) {
                  const [namespace, prefixes, attributesObj] = this._mkAttributes(attributes2, tagName);
                  const [name, nsPrefix] = this._getNameAndPrefix(tagName, this._builder.isNsAgnostic());
                  const node2 = this._builder.build({
                    nsPrefix,
                    name,
                    attributes: attributesObj,
                    namespace,
                    prefixes
                  });
                  node2[_symbol_utils.$globalData] = this._globalData;
                  if (isEmpty2) {
                    node2[_symbol_utils.$finalize]();
                    if (this._current[_symbol_utils.$onChild](node2)) {
                      node2[_symbol_utils.$setId](this._ids);
                    }
                    node2[_symbol_utils.$clean](this._builder);
                    return;
                  }
                  this._stack.push(this._current);
                  this._current = node2;
                }
                onEndElement(name) {
                  const node2 = this._current;
                  if (node2[_symbol_utils.$isCDATAXml]() && typeof node2[_symbol_utils.$content] === "string") {
                    const parser = new XFAParser();
                    parser._globalData = this._globalData;
                    const root2 = parser.parse(node2[_symbol_utils.$content]);
                    node2[_symbol_utils.$content] = null;
                    node2[_symbol_utils.$onChild](root2);
                  }
                  node2[_symbol_utils.$finalize]();
                  this._current = this._stack.pop();
                  if (this._current[_symbol_utils.$onChild](node2)) {
                    node2[_symbol_utils.$setId](this._ids);
                  }
                  node2[_symbol_utils.$clean](this._builder);
                }
                onError(code2) {
                  this._errorCode = code2;
                }
              }
              exports3.XFAParser = XFAParser;
            }),
            /* 91 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.Builder = void 0;
              var _namespaces = __w_pdfjs_require__3(81);
              var _symbol_utils = __w_pdfjs_require__3(78);
              var _setup = __w_pdfjs_require__3(92);
              var _template = __w_pdfjs_require__3(80);
              var _unknown = __w_pdfjs_require__3(101);
              var _util2 = __w_pdfjs_require__3(2);
              var _xfa_object = __w_pdfjs_require__3(87);
              class Root2 extends _xfa_object.XFAObject {
                constructor(ids2) {
                  super(-1, "root", /* @__PURE__ */ Object.create(null));
                  this.element = null;
                  this[_symbol_utils.$ids] = ids2;
                }
                [_symbol_utils.$onChild](child) {
                  this.element = child;
                  return true;
                }
                [_symbol_utils.$finalize]() {
                  super[_symbol_utils.$finalize]();
                  if (this.element.template instanceof _template.Template) {
                    this[_symbol_utils.$ids].set(_symbol_utils.$root, this.element);
                    this.element.template[_symbol_utils.$resolvePrototypes](this[_symbol_utils.$ids]);
                    this.element.template[_symbol_utils.$ids] = this[_symbol_utils.$ids];
                  }
                }
              }
              class Empty4 extends _xfa_object.XFAObject {
                constructor() {
                  super(-1, "", /* @__PURE__ */ Object.create(null));
                }
                [_symbol_utils.$onChild](_) {
                  return false;
                }
              }
              class Builder {
                constructor(rootNameSpace = null) {
                  this._namespaceStack = [];
                  this._nsAgnosticLevel = 0;
                  this._namespacePrefixes = /* @__PURE__ */ new Map();
                  this._namespaces = /* @__PURE__ */ new Map();
                  this._nextNsId = Math.max(...Object.values(_namespaces.NamespaceIds).map(({
                    id
                  }) => id));
                  this._currentNamespace = rootNameSpace || new _unknown.UnknownNamespace(++this._nextNsId);
                }
                buildRoot(ids2) {
                  return new Root2(ids2);
                }
                build({
                  nsPrefix,
                  name,
                  attributes: attributes2,
                  namespace,
                  prefixes
                }) {
                  const hasNamespaceDef = namespace !== null;
                  if (hasNamespaceDef) {
                    this._namespaceStack.push(this._currentNamespace);
                    this._currentNamespace = this._searchNamespace(namespace);
                  }
                  if (prefixes) {
                    this._addNamespacePrefix(prefixes);
                  }
                  if (attributes2.hasOwnProperty(_symbol_utils.$nsAttributes)) {
                    const dataTemplate = _setup.NamespaceSetUp.datasets;
                    const nsAttrs = attributes2[_symbol_utils.$nsAttributes];
                    let xfaAttrs = null;
                    for (const [ns, attrs] of Object.entries(nsAttrs)) {
                      const nsToUse = this._getNamespaceToUse(ns);
                      if (nsToUse === dataTemplate) {
                        xfaAttrs = {
                          xfa: attrs
                        };
                        break;
                      }
                    }
                    if (xfaAttrs) {
                      attributes2[_symbol_utils.$nsAttributes] = xfaAttrs;
                    } else {
                      delete attributes2[_symbol_utils.$nsAttributes];
                    }
                  }
                  const namespaceToUse = this._getNamespaceToUse(nsPrefix);
                  const node2 = namespaceToUse?.[_namespaces.$buildXFAObject](name, attributes2) || new Empty4();
                  if (node2[_symbol_utils.$isNsAgnostic]()) {
                    this._nsAgnosticLevel++;
                  }
                  if (hasNamespaceDef || prefixes || node2[_symbol_utils.$isNsAgnostic]()) {
                    node2[_symbol_utils.$cleanup] = {
                      hasNamespace: hasNamespaceDef,
                      prefixes,
                      nsAgnostic: node2[_symbol_utils.$isNsAgnostic]()
                    };
                  }
                  return node2;
                }
                isNsAgnostic() {
                  return this._nsAgnosticLevel > 0;
                }
                _searchNamespace(nsName) {
                  let ns = this._namespaces.get(nsName);
                  if (ns) {
                    return ns;
                  }
                  for (const [name, {
                    check
                  }] of Object.entries(_namespaces.NamespaceIds)) {
                    if (check(nsName)) {
                      ns = _setup.NamespaceSetUp[name];
                      if (ns) {
                        this._namespaces.set(nsName, ns);
                        return ns;
                      }
                      break;
                    }
                  }
                  ns = new _unknown.UnknownNamespace(++this._nextNsId);
                  this._namespaces.set(nsName, ns);
                  return ns;
                }
                _addNamespacePrefix(prefixes) {
                  for (const {
                    prefix: prefix3,
                    value
                  } of prefixes) {
                    const namespace = this._searchNamespace(value);
                    let prefixStack = this._namespacePrefixes.get(prefix3);
                    if (!prefixStack) {
                      prefixStack = [];
                      this._namespacePrefixes.set(prefix3, prefixStack);
                    }
                    prefixStack.push(namespace);
                  }
                }
                _getNamespaceToUse(prefix3) {
                  if (!prefix3) {
                    return this._currentNamespace;
                  }
                  const prefixStack = this._namespacePrefixes.get(prefix3);
                  if (prefixStack?.length > 0) {
                    return prefixStack.at(-1);
                  }
                  (0, _util2.warn)(`Unknown namespace prefix: ${prefix3}.`);
                  return null;
                }
                clean(data2) {
                  const {
                    hasNamespace,
                    prefixes,
                    nsAgnostic
                  } = data2;
                  if (hasNamespace) {
                    this._currentNamespace = this._namespaceStack.pop();
                  }
                  if (prefixes) {
                    prefixes.forEach(({
                      prefix: prefix3
                    }) => {
                      this._namespacePrefixes.get(prefix3).pop();
                    });
                  }
                  if (nsAgnostic) {
                    this._nsAgnosticLevel--;
                  }
                }
              }
              exports3.Builder = Builder;
            }),
            /* 92 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.NamespaceSetUp = void 0;
              var _config = __w_pdfjs_require__3(93);
              var _connection_set = __w_pdfjs_require__3(94);
              var _datasets = __w_pdfjs_require__3(95);
              var _locale_set = __w_pdfjs_require__3(96);
              var _signature = __w_pdfjs_require__3(97);
              var _stylesheet = __w_pdfjs_require__3(98);
              var _template = __w_pdfjs_require__3(80);
              var _xdp = __w_pdfjs_require__3(99);
              var _xhtml = __w_pdfjs_require__3(100);
              const NamespaceSetUp = {
                config: _config.ConfigNamespace,
                connection: _connection_set.ConnectionSetNamespace,
                datasets: _datasets.DatasetsNamespace,
                localeSet: _locale_set.LocaleSetNamespace,
                signature: _signature.SignatureNamespace,
                stylesheet: _stylesheet.StylesheetNamespace,
                template: _template.TemplateNamespace,
                xdp: _xdp.XdpNamespace,
                xhtml: _xhtml.XhtmlNamespace
              };
              exports3.NamespaceSetUp = NamespaceSetUp;
            }),
            /* 93 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.ConfigNamespace = void 0;
              var _namespaces = __w_pdfjs_require__3(81);
              var _symbol_utils = __w_pdfjs_require__3(78);
              var _xfa_object = __w_pdfjs_require__3(87);
              var _utils = __w_pdfjs_require__3(84);
              var _util2 = __w_pdfjs_require__3(2);
              const CONFIG_NS_ID = _namespaces.NamespaceIds.config.id;
              class Acrobat extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "acrobat", true);
                  this.acrobat7 = null;
                  this.autoSave = null;
                  this.common = null;
                  this.validate = null;
                  this.validateApprovalSignatures = null;
                  this.submitUrl = new _xfa_object.XFAObjectArray();
                }
              }
              class Acrobat7 extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "acrobat7", true);
                  this.dynamicRender = null;
                }
              }
              class ADBE_JSConsole extends _xfa_object.OptionObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "ADBE_JSConsole", ["delegate", "Enable", "Disable"]);
                }
              }
              class ADBE_JSDebugger extends _xfa_object.OptionObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "ADBE_JSDebugger", ["delegate", "Enable", "Disable"]);
                }
              }
              class AddSilentPrint extends _xfa_object.Option01 {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "addSilentPrint");
                }
              }
              class AddViewerPreferences extends _xfa_object.Option01 {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "addViewerPreferences");
                }
              }
              class AdjustData extends _xfa_object.Option10 {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "adjustData");
                }
              }
              class AdobeExtensionLevel extends _xfa_object.IntegerObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "adobeExtensionLevel", 0, (n2) => n2 >= 1 && n2 <= 8);
                }
              }
              class Agent extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "agent", true);
                  this.name = attributes2.name ? attributes2.name.trim() : "";
                  this.common = new _xfa_object.XFAObjectArray();
                }
              }
              class AlwaysEmbed extends _xfa_object.ContentObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "alwaysEmbed");
                }
              }
              class Amd extends _xfa_object.StringObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "amd");
                }
              }
              class Area extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "area");
                  this.level = (0, _utils.getInteger)({
                    data: attributes2.level,
                    defaultValue: 0,
                    validate: (n2) => n2 >= 1 && n2 <= 3
                  });
                  this.name = (0, _utils.getStringOption)(attributes2.name, ["", "barcode", "coreinit", "deviceDriver", "font", "general", "layout", "merge", "script", "signature", "sourceSet", "templateCache"]);
                }
              }
              class Attributes extends _xfa_object.OptionObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "attributes", ["preserve", "delegate", "ignore"]);
                }
              }
              class AutoSave extends _xfa_object.OptionObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "autoSave", ["disabled", "enabled"]);
                }
              }
              class Base3 extends _xfa_object.StringObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "base");
                }
              }
              class BatchOutput extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "batchOutput");
                  this.format = (0, _utils.getStringOption)(attributes2.format, ["none", "concat", "zip", "zipCompress"]);
                }
              }
              class BehaviorOverride extends _xfa_object.ContentObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "behaviorOverride");
                }
                [_symbol_utils.$finalize]() {
                  this[_symbol_utils.$content] = new Map(this[_symbol_utils.$content].trim().split(/\s+/).filter((x) => x.includes(":")).map((x) => x.split(":", 2)));
                }
              }
              class Cache extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "cache", true);
                  this.templateCache = null;
                }
              }
              class Change extends _xfa_object.Option01 {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "change");
                }
              }
              class Common extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "common", true);
                  this.data = null;
                  this.locale = null;
                  this.localeSet = null;
                  this.messaging = null;
                  this.suppressBanner = null;
                  this.template = null;
                  this.validationMessaging = null;
                  this.versionControl = null;
                  this.log = new _xfa_object.XFAObjectArray();
                }
              }
              class Compress extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "compress");
                  this.scope = (0, _utils.getStringOption)(attributes2.scope, ["imageOnly", "document"]);
                }
              }
              class CompressLogicalStructure extends _xfa_object.Option01 {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "compressLogicalStructure");
                }
              }
              class CompressObjectStream extends _xfa_object.Option10 {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "compressObjectStream");
                }
              }
              class Compression extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "compression", true);
                  this.compressLogicalStructure = null;
                  this.compressObjectStream = null;
                  this.level = null;
                  this.type = null;
                }
              }
              class Config extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "config", true);
                  this.acrobat = null;
                  this.present = null;
                  this.trace = null;
                  this.agent = new _xfa_object.XFAObjectArray();
                }
              }
              class Conformance extends _xfa_object.OptionObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "conformance", ["A", "B"]);
                }
              }
              class ContentCopy extends _xfa_object.Option01 {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "contentCopy");
                }
              }
              class Copies extends _xfa_object.IntegerObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "copies", 1, (n2) => n2 >= 1);
                }
              }
              class Creator extends _xfa_object.StringObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "creator");
                }
              }
              class CurrentPage extends _xfa_object.IntegerObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "currentPage", 0, (n2) => n2 >= 0);
                }
              }
              class Data extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "data", true);
                  this.adjustData = null;
                  this.attributes = null;
                  this.incrementalLoad = null;
                  this.outputXSL = null;
                  this.range = null;
                  this.record = null;
                  this.startNode = null;
                  this.uri = null;
                  this.window = null;
                  this.xsl = null;
                  this.excludeNS = new _xfa_object.XFAObjectArray();
                  this.transform = new _xfa_object.XFAObjectArray();
                }
              }
              class Debug extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "debug", true);
                  this.uri = null;
                }
              }
              class DefaultTypeface extends _xfa_object.ContentObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "defaultTypeface");
                  this.writingScript = (0, _utils.getStringOption)(attributes2.writingScript, ["*", "Arabic", "Cyrillic", "EastEuropeanRoman", "Greek", "Hebrew", "Japanese", "Korean", "Roman", "SimplifiedChinese", "Thai", "TraditionalChinese", "Vietnamese"]);
                }
              }
              class Destination extends _xfa_object.OptionObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "destination", ["pdf", "pcl", "ps", "webClient", "zpl"]);
                }
              }
              class DocumentAssembly extends _xfa_object.Option01 {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "documentAssembly");
                }
              }
              class Driver extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "driver", true);
                  this.name = attributes2.name ? attributes2.name.trim() : "";
                  this.fontInfo = null;
                  this.xdc = null;
                }
              }
              class DuplexOption extends _xfa_object.OptionObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "duplexOption", ["simplex", "duplexFlipLongEdge", "duplexFlipShortEdge"]);
                }
              }
              class DynamicRender extends _xfa_object.OptionObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "dynamicRender", ["forbidden", "required"]);
                }
              }
              class Embed extends _xfa_object.Option01 {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "embed");
                }
              }
              class Encrypt extends _xfa_object.Option01 {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "encrypt");
                }
              }
              class Encryption extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "encryption", true);
                  this.encrypt = null;
                  this.encryptionLevel = null;
                  this.permissions = null;
                }
              }
              class EncryptionLevel extends _xfa_object.OptionObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "encryptionLevel", ["40bit", "128bit"]);
                }
              }
              class Enforce extends _xfa_object.StringObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "enforce");
                }
              }
              class Equate extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "equate");
                  this.force = (0, _utils.getInteger)({
                    data: attributes2.force,
                    defaultValue: 1,
                    validate: (n2) => n2 === 0
                  });
                  this.from = attributes2.from || "";
                  this.to = attributes2.to || "";
                }
              }
              class EquateRange extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "equateRange");
                  this.from = attributes2.from || "";
                  this.to = attributes2.to || "";
                  this._unicodeRange = attributes2.unicodeRange || "";
                }
                get unicodeRange() {
                  const ranges = [];
                  const unicodeRegex = /U\+([0-9a-fA-F]+)/;
                  const unicodeRange = this._unicodeRange;
                  for (let range3 of unicodeRange.split(",").map((x) => x.trim()).filter((x) => !!x)) {
                    range3 = range3.split("-", 2).map((x) => {
                      const found = x.match(unicodeRegex);
                      if (!found) {
                        return 0;
                      }
                      return parseInt(found[1], 16);
                    });
                    if (range3.length === 1) {
                      range3.push(range3[0]);
                    }
                    ranges.push(range3);
                  }
                  return (0, _util2.shadow)(this, "unicodeRange", ranges);
                }
              }
              class Exclude extends _xfa_object.ContentObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "exclude");
                }
                [_symbol_utils.$finalize]() {
                  this[_symbol_utils.$content] = this[_symbol_utils.$content].trim().split(/\s+/).filter((x) => x && ["calculate", "close", "enter", "exit", "initialize", "ready", "validate"].includes(x));
                }
              }
              class ExcludeNS extends _xfa_object.StringObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "excludeNS");
                }
              }
              class FlipLabel extends _xfa_object.OptionObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "flipLabel", ["usePrinterSetting", "on", "off"]);
                }
              }
              class FontInfo extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "fontInfo", true);
                  this.embed = null;
                  this.map = null;
                  this.subsetBelow = null;
                  this.alwaysEmbed = new _xfa_object.XFAObjectArray();
                  this.defaultTypeface = new _xfa_object.XFAObjectArray();
                  this.neverEmbed = new _xfa_object.XFAObjectArray();
                }
              }
              class FormFieldFilling extends _xfa_object.Option01 {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "formFieldFilling");
                }
              }
              class GroupParent extends _xfa_object.StringObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "groupParent");
                }
              }
              class IfEmpty extends _xfa_object.OptionObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "ifEmpty", ["dataValue", "dataGroup", "ignore", "remove"]);
                }
              }
              class IncludeXDPContent extends _xfa_object.StringObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "includeXDPContent");
                }
              }
              class IncrementalLoad extends _xfa_object.OptionObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "incrementalLoad", ["none", "forwardOnly"]);
                }
              }
              class IncrementalMerge extends _xfa_object.Option01 {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "incrementalMerge");
                }
              }
              class Interactive extends _xfa_object.Option01 {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "interactive");
                }
              }
              class Jog extends _xfa_object.OptionObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "jog", ["usePrinterSetting", "none", "pageSet"]);
                }
              }
              class LabelPrinter extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "labelPrinter", true);
                  this.name = (0, _utils.getStringOption)(attributes2.name, ["zpl", "dpl", "ipl", "tcpl"]);
                  this.batchOutput = null;
                  this.flipLabel = null;
                  this.fontInfo = null;
                  this.xdc = null;
                }
              }
              class Layout extends _xfa_object.OptionObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "layout", ["paginate", "panel"]);
                }
              }
              class Level extends _xfa_object.IntegerObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "level", 0, (n2) => n2 > 0);
                }
              }
              class Linearized extends _xfa_object.Option01 {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "linearized");
                }
              }
              class Locale extends _xfa_object.StringObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "locale");
                }
              }
              class LocaleSet extends _xfa_object.StringObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "localeSet");
                }
              }
              class Log extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "log", true);
                  this.mode = null;
                  this.threshold = null;
                  this.to = null;
                  this.uri = null;
                }
              }
              class MapElement extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "map", true);
                  this.equate = new _xfa_object.XFAObjectArray();
                  this.equateRange = new _xfa_object.XFAObjectArray();
                }
              }
              class MediumInfo extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "mediumInfo", true);
                  this.map = null;
                }
              }
              class Message extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "message", true);
                  this.msgId = null;
                  this.severity = null;
                }
              }
              class Messaging extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "messaging", true);
                  this.message = new _xfa_object.XFAObjectArray();
                }
              }
              class Mode3 extends _xfa_object.OptionObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "mode", ["append", "overwrite"]);
                }
              }
              class ModifyAnnots extends _xfa_object.Option01 {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "modifyAnnots");
                }
              }
              class MsgId extends _xfa_object.IntegerObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "msgId", 1, (n2) => n2 >= 1);
                }
              }
              class NameAttr extends _xfa_object.StringObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "nameAttr");
                }
              }
              class NeverEmbed extends _xfa_object.ContentObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "neverEmbed");
                }
              }
              class NumberOfCopies extends _xfa_object.IntegerObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "numberOfCopies", null, (n2) => n2 >= 2 && n2 <= 5);
                }
              }
              class OpenAction extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "openAction", true);
                  this.destination = null;
                }
              }
              class Output extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "output", true);
                  this.to = null;
                  this.type = null;
                  this.uri = null;
                }
              }
              class OutputBin extends _xfa_object.StringObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "outputBin");
                }
              }
              class OutputXSL extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "outputXSL", true);
                  this.uri = null;
                }
              }
              class Overprint extends _xfa_object.OptionObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "overprint", ["none", "both", "draw", "field"]);
                }
              }
              class Packets extends _xfa_object.StringObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "packets");
                }
                [_symbol_utils.$finalize]() {
                  if (this[_symbol_utils.$content] === "*") {
                    return;
                  }
                  this[_symbol_utils.$content] = this[_symbol_utils.$content].trim().split(/\s+/).filter((x) => ["config", "datasets", "template", "xfdf", "xslt"].includes(x));
                }
              }
              class PageOffset extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "pageOffset");
                  this.x = (0, _utils.getInteger)({
                    data: attributes2.x,
                    defaultValue: "useXDCSetting",
                    validate: (n2) => true
                  });
                  this.y = (0, _utils.getInteger)({
                    data: attributes2.y,
                    defaultValue: "useXDCSetting",
                    validate: (n2) => true
                  });
                }
              }
              class PageRange extends _xfa_object.StringObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "pageRange");
                }
                [_symbol_utils.$finalize]() {
                  const numbers = this[_symbol_utils.$content].trim().split(/\s+/).map((x) => parseInt(x, 10));
                  const ranges = [];
                  for (let i = 0, ii = numbers.length; i < ii; i += 2) {
                    ranges.push(numbers.slice(i, i + 2));
                  }
                  this[_symbol_utils.$content] = ranges;
                }
              }
              class Pagination4 extends _xfa_object.OptionObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "pagination", ["simplex", "duplexShortEdge", "duplexLongEdge"]);
                }
              }
              class PaginationOverride extends _xfa_object.OptionObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "paginationOverride", ["none", "forceDuplex", "forceDuplexLongEdge", "forceDuplexShortEdge", "forceSimplex"]);
                }
              }
              class Part extends _xfa_object.IntegerObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "part", 1, (n2) => false);
                }
              }
              class Pcl extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "pcl", true);
                  this.name = attributes2.name || "";
                  this.batchOutput = null;
                  this.fontInfo = null;
                  this.jog = null;
                  this.mediumInfo = null;
                  this.outputBin = null;
                  this.pageOffset = null;
                  this.staple = null;
                  this.xdc = null;
                }
              }
              class Pdf extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "pdf", true);
                  this.name = attributes2.name || "";
                  this.adobeExtensionLevel = null;
                  this.batchOutput = null;
                  this.compression = null;
                  this.creator = null;
                  this.encryption = null;
                  this.fontInfo = null;
                  this.interactive = null;
                  this.linearized = null;
                  this.openAction = null;
                  this.pdfa = null;
                  this.producer = null;
                  this.renderPolicy = null;
                  this.scriptModel = null;
                  this.silentPrint = null;
                  this.submitFormat = null;
                  this.tagged = null;
                  this.version = null;
                  this.viewerPreferences = null;
                  this.xdc = null;
                }
              }
              class Pdfa extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "pdfa", true);
                  this.amd = null;
                  this.conformance = null;
                  this.includeXDPContent = null;
                  this.part = null;
                }
              }
              class Permissions extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "permissions", true);
                  this.accessibleContent = null;
                  this.change = null;
                  this.contentCopy = null;
                  this.documentAssembly = null;
                  this.formFieldFilling = null;
                  this.modifyAnnots = null;
                  this.plaintextMetadata = null;
                  this.print = null;
                  this.printHighQuality = null;
                }
              }
              class PickTrayByPDFSize extends _xfa_object.Option01 {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "pickTrayByPDFSize");
                }
              }
              class Picture extends _xfa_object.StringObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "picture");
                }
              }
              class PlaintextMetadata extends _xfa_object.Option01 {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "plaintextMetadata");
                }
              }
              class Presence extends _xfa_object.OptionObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "presence", ["preserve", "dissolve", "dissolveStructure", "ignore", "remove"]);
                }
              }
              class Present extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "present", true);
                  this.behaviorOverride = null;
                  this.cache = null;
                  this.common = null;
                  this.copies = null;
                  this.destination = null;
                  this.incrementalMerge = null;
                  this.layout = null;
                  this.output = null;
                  this.overprint = null;
                  this.pagination = null;
                  this.paginationOverride = null;
                  this.script = null;
                  this.validate = null;
                  this.xdp = null;
                  this.driver = new _xfa_object.XFAObjectArray();
                  this.labelPrinter = new _xfa_object.XFAObjectArray();
                  this.pcl = new _xfa_object.XFAObjectArray();
                  this.pdf = new _xfa_object.XFAObjectArray();
                  this.ps = new _xfa_object.XFAObjectArray();
                  this.submitUrl = new _xfa_object.XFAObjectArray();
                  this.webClient = new _xfa_object.XFAObjectArray();
                  this.zpl = new _xfa_object.XFAObjectArray();
                }
              }
              class Print extends _xfa_object.Option01 {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "print");
                }
              }
              class PrintHighQuality extends _xfa_object.Option01 {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "printHighQuality");
                }
              }
              class PrintScaling extends _xfa_object.OptionObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "printScaling", ["appdefault", "noScaling"]);
                }
              }
              class PrinterName extends _xfa_object.StringObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "printerName");
                }
              }
              class Producer extends _xfa_object.StringObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "producer");
                }
              }
              class Ps extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "ps", true);
                  this.name = attributes2.name || "";
                  this.batchOutput = null;
                  this.fontInfo = null;
                  this.jog = null;
                  this.mediumInfo = null;
                  this.outputBin = null;
                  this.staple = null;
                  this.xdc = null;
                }
              }
              class Range extends _xfa_object.ContentObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "range");
                }
                [_symbol_utils.$finalize]() {
                  this[_symbol_utils.$content] = this[_symbol_utils.$content].trim().split(/\s*,\s*/, 2).map((range3) => range3.split("-").map((x) => parseInt(x.trim(), 10))).filter((range3) => range3.every((x) => !isNaN(x))).map((range3) => {
                    if (range3.length === 1) {
                      range3.push(range3[0]);
                    }
                    return range3;
                  });
                }
              }
              class Record extends _xfa_object.ContentObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "record");
                }
                [_symbol_utils.$finalize]() {
                  this[_symbol_utils.$content] = this[_symbol_utils.$content].trim();
                  const n2 = parseInt(this[_symbol_utils.$content], 10);
                  if (!isNaN(n2) && n2 >= 0) {
                    this[_symbol_utils.$content] = n2;
                  }
                }
              }
              class Relevant extends _xfa_object.ContentObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "relevant");
                }
                [_symbol_utils.$finalize]() {
                  this[_symbol_utils.$content] = this[_symbol_utils.$content].trim().split(/\s+/);
                }
              }
              class Rename extends _xfa_object.ContentObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "rename");
                }
                [_symbol_utils.$finalize]() {
                  this[_symbol_utils.$content] = this[_symbol_utils.$content].trim();
                  if (this[_symbol_utils.$content].toLowerCase().startsWith("xml") || new RegExp("[\\p{L}_][\\p{L}\\d._\\p{M}-]*", "u").test(this[_symbol_utils.$content])) {
                    (0, _util2.warn)("XFA - Rename: invalid XFA name");
                  }
                }
              }
              class RenderPolicy extends _xfa_object.OptionObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "renderPolicy", ["server", "client"]);
                }
              }
              class RunScripts extends _xfa_object.OptionObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "runScripts", ["both", "client", "none", "server"]);
                }
              }
              class Script extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "script", true);
                  this.currentPage = null;
                  this.exclude = null;
                  this.runScripts = null;
                }
              }
              class ScriptModel extends _xfa_object.OptionObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "scriptModel", ["XFA", "none"]);
                }
              }
              class Severity extends _xfa_object.OptionObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "severity", ["ignore", "error", "information", "trace", "warning"]);
                }
              }
              class SilentPrint extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "silentPrint", true);
                  this.addSilentPrint = null;
                  this.printerName = null;
                }
              }
              class Staple extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "staple");
                  this.mode = (0, _utils.getStringOption)(attributes2.mode, ["usePrinterSetting", "on", "off"]);
                }
              }
              class StartNode extends _xfa_object.StringObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "startNode");
                }
              }
              class StartPage extends _xfa_object.IntegerObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "startPage", 0, (n2) => true);
                }
              }
              class SubmitFormat extends _xfa_object.OptionObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "submitFormat", ["html", "delegate", "fdf", "xml", "pdf"]);
                }
              }
              class SubmitUrl extends _xfa_object.StringObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "submitUrl");
                }
              }
              class SubsetBelow extends _xfa_object.IntegerObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "subsetBelow", 100, (n2) => n2 >= 0 && n2 <= 100);
                }
              }
              class SuppressBanner extends _xfa_object.Option01 {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "suppressBanner");
                }
              }
              class Tagged extends _xfa_object.Option01 {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "tagged");
                }
              }
              class Template9 extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "template", true);
                  this.base = null;
                  this.relevant = null;
                  this.startPage = null;
                  this.uri = null;
                  this.xsl = null;
                }
              }
              class Threshold extends _xfa_object.OptionObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "threshold", ["trace", "error", "information", "warning"]);
                }
              }
              class To extends _xfa_object.OptionObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "to", ["null", "memory", "stderr", "stdout", "system", "uri"]);
                }
              }
              class TemplateCache extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "templateCache");
                  this.maxEntries = (0, _utils.getInteger)({
                    data: attributes2.maxEntries,
                    defaultValue: 5,
                    validate: (n2) => n2 >= 0
                  });
                }
              }
              class Trace extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "trace", true);
                  this.area = new _xfa_object.XFAObjectArray();
                }
              }
              class Transform2 extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "transform", true);
                  this.groupParent = null;
                  this.ifEmpty = null;
                  this.nameAttr = null;
                  this.picture = null;
                  this.presence = null;
                  this.rename = null;
                  this.whitespace = null;
                }
              }
              class Type extends _xfa_object.OptionObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "type", ["none", "ascii85", "asciiHex", "ccittfax", "flate", "lzw", "runLength", "native", "xdp", "mergedXDP"]);
                }
              }
              class Uri extends _xfa_object.StringObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "uri");
                }
              }
              class Validate extends _xfa_object.OptionObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "validate", ["preSubmit", "prePrint", "preExecute", "preSave"]);
                }
              }
              class ValidateApprovalSignatures extends _xfa_object.ContentObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "validateApprovalSignatures");
                }
                [_symbol_utils.$finalize]() {
                  this[_symbol_utils.$content] = this[_symbol_utils.$content].trim().split(/\s+/).filter((x) => ["docReady", "postSign"].includes(x));
                }
              }
              class ValidationMessaging extends _xfa_object.OptionObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "validationMessaging", ["allMessagesIndividually", "allMessagesTogether", "firstMessageOnly", "noMessages"]);
                }
              }
              class Version extends _xfa_object.OptionObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "version", ["1.7", "1.6", "1.5", "1.4", "1.3", "1.2"]);
                }
              }
              class VersionControl extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "VersionControl");
                  this.outputBelow = (0, _utils.getStringOption)(attributes2.outputBelow, ["warn", "error", "update"]);
                  this.sourceAbove = (0, _utils.getStringOption)(attributes2.sourceAbove, ["warn", "error"]);
                  this.sourceBelow = (0, _utils.getStringOption)(attributes2.sourceBelow, ["update", "maintain"]);
                }
              }
              class ViewerPreferences extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "viewerPreferences", true);
                  this.ADBE_JSConsole = null;
                  this.ADBE_JSDebugger = null;
                  this.addViewerPreferences = null;
                  this.duplexOption = null;
                  this.enforce = null;
                  this.numberOfCopies = null;
                  this.pageRange = null;
                  this.pickTrayByPDFSize = null;
                  this.printScaling = null;
                }
              }
              class WebClient extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "webClient", true);
                  this.name = attributes2.name ? attributes2.name.trim() : "";
                  this.fontInfo = null;
                  this.xdc = null;
                }
              }
              class Whitespace extends _xfa_object.OptionObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "whitespace", ["preserve", "ltrim", "normalize", "rtrim", "trim"]);
                }
              }
              class Window2 extends _xfa_object.ContentObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "window");
                }
                [_symbol_utils.$finalize]() {
                  const pair = this[_symbol_utils.$content].trim().split(/\s*,\s*/, 2).map((x) => parseInt(x, 10));
                  if (pair.some((x) => isNaN(x))) {
                    this[_symbol_utils.$content] = [0, 0];
                    return;
                  }
                  if (pair.length === 1) {
                    pair.push(pair[0]);
                  }
                  this[_symbol_utils.$content] = pair;
                }
              }
              class Xdc extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "xdc", true);
                  this.uri = new _xfa_object.XFAObjectArray();
                  this.xsl = new _xfa_object.XFAObjectArray();
                }
              }
              class Xdp extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "xdp", true);
                  this.packets = null;
                }
              }
              class Xsl extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "xsl", true);
                  this.debug = null;
                  this.uri = null;
                }
              }
              class Zpl extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(CONFIG_NS_ID, "zpl", true);
                  this.name = attributes2.name ? attributes2.name.trim() : "";
                  this.batchOutput = null;
                  this.flipLabel = null;
                  this.fontInfo = null;
                  this.xdc = null;
                }
              }
              class ConfigNamespace {
                static [_namespaces.$buildXFAObject](name, attributes2) {
                  if (ConfigNamespace.hasOwnProperty(name)) {
                    return ConfigNamespace[name](attributes2);
                  }
                  return void 0;
                }
                static acrobat(attrs) {
                  return new Acrobat(attrs);
                }
                static acrobat7(attrs) {
                  return new Acrobat7(attrs);
                }
                static ADBE_JSConsole(attrs) {
                  return new ADBE_JSConsole(attrs);
                }
                static ADBE_JSDebugger(attrs) {
                  return new ADBE_JSDebugger(attrs);
                }
                static addSilentPrint(attrs) {
                  return new AddSilentPrint(attrs);
                }
                static addViewerPreferences(attrs) {
                  return new AddViewerPreferences(attrs);
                }
                static adjustData(attrs) {
                  return new AdjustData(attrs);
                }
                static adobeExtensionLevel(attrs) {
                  return new AdobeExtensionLevel(attrs);
                }
                static agent(attrs) {
                  return new Agent(attrs);
                }
                static alwaysEmbed(attrs) {
                  return new AlwaysEmbed(attrs);
                }
                static amd(attrs) {
                  return new Amd(attrs);
                }
                static area(attrs) {
                  return new Area(attrs);
                }
                static attributes(attrs) {
                  return new Attributes(attrs);
                }
                static autoSave(attrs) {
                  return new AutoSave(attrs);
                }
                static base(attrs) {
                  return new Base3(attrs);
                }
                static batchOutput(attrs) {
                  return new BatchOutput(attrs);
                }
                static behaviorOverride(attrs) {
                  return new BehaviorOverride(attrs);
                }
                static cache(attrs) {
                  return new Cache(attrs);
                }
                static change(attrs) {
                  return new Change(attrs);
                }
                static common(attrs) {
                  return new Common(attrs);
                }
                static compress(attrs) {
                  return new Compress(attrs);
                }
                static compressLogicalStructure(attrs) {
                  return new CompressLogicalStructure(attrs);
                }
                static compressObjectStream(attrs) {
                  return new CompressObjectStream(attrs);
                }
                static compression(attrs) {
                  return new Compression(attrs);
                }
                static config(attrs) {
                  return new Config(attrs);
                }
                static conformance(attrs) {
                  return new Conformance(attrs);
                }
                static contentCopy(attrs) {
                  return new ContentCopy(attrs);
                }
                static copies(attrs) {
                  return new Copies(attrs);
                }
                static creator(attrs) {
                  return new Creator(attrs);
                }
                static currentPage(attrs) {
                  return new CurrentPage(attrs);
                }
                static data(attrs) {
                  return new Data(attrs);
                }
                static debug(attrs) {
                  return new Debug(attrs);
                }
                static defaultTypeface(attrs) {
                  return new DefaultTypeface(attrs);
                }
                static destination(attrs) {
                  return new Destination(attrs);
                }
                static documentAssembly(attrs) {
                  return new DocumentAssembly(attrs);
                }
                static driver(attrs) {
                  return new Driver(attrs);
                }
                static duplexOption(attrs) {
                  return new DuplexOption(attrs);
                }
                static dynamicRender(attrs) {
                  return new DynamicRender(attrs);
                }
                static embed(attrs) {
                  return new Embed(attrs);
                }
                static encrypt(attrs) {
                  return new Encrypt(attrs);
                }
                static encryption(attrs) {
                  return new Encryption(attrs);
                }
                static encryptionLevel(attrs) {
                  return new EncryptionLevel(attrs);
                }
                static enforce(attrs) {
                  return new Enforce(attrs);
                }
                static equate(attrs) {
                  return new Equate(attrs);
                }
                static equateRange(attrs) {
                  return new EquateRange(attrs);
                }
                static exclude(attrs) {
                  return new Exclude(attrs);
                }
                static excludeNS(attrs) {
                  return new ExcludeNS(attrs);
                }
                static flipLabel(attrs) {
                  return new FlipLabel(attrs);
                }
                static fontInfo(attrs) {
                  return new FontInfo(attrs);
                }
                static formFieldFilling(attrs) {
                  return new FormFieldFilling(attrs);
                }
                static groupParent(attrs) {
                  return new GroupParent(attrs);
                }
                static ifEmpty(attrs) {
                  return new IfEmpty(attrs);
                }
                static includeXDPContent(attrs) {
                  return new IncludeXDPContent(attrs);
                }
                static incrementalLoad(attrs) {
                  return new IncrementalLoad(attrs);
                }
                static incrementalMerge(attrs) {
                  return new IncrementalMerge(attrs);
                }
                static interactive(attrs) {
                  return new Interactive(attrs);
                }
                static jog(attrs) {
                  return new Jog(attrs);
                }
                static labelPrinter(attrs) {
                  return new LabelPrinter(attrs);
                }
                static layout(attrs) {
                  return new Layout(attrs);
                }
                static level(attrs) {
                  return new Level(attrs);
                }
                static linearized(attrs) {
                  return new Linearized(attrs);
                }
                static locale(attrs) {
                  return new Locale(attrs);
                }
                static localeSet(attrs) {
                  return new LocaleSet(attrs);
                }
                static log(attrs) {
                  return new Log(attrs);
                }
                static map(attrs) {
                  return new MapElement(attrs);
                }
                static mediumInfo(attrs) {
                  return new MediumInfo(attrs);
                }
                static message(attrs) {
                  return new Message(attrs);
                }
                static messaging(attrs) {
                  return new Messaging(attrs);
                }
                static mode(attrs) {
                  return new Mode3(attrs);
                }
                static modifyAnnots(attrs) {
                  return new ModifyAnnots(attrs);
                }
                static msgId(attrs) {
                  return new MsgId(attrs);
                }
                static nameAttr(attrs) {
                  return new NameAttr(attrs);
                }
                static neverEmbed(attrs) {
                  return new NeverEmbed(attrs);
                }
                static numberOfCopies(attrs) {
                  return new NumberOfCopies(attrs);
                }
                static openAction(attrs) {
                  return new OpenAction(attrs);
                }
                static output(attrs) {
                  return new Output(attrs);
                }
                static outputBin(attrs) {
                  return new OutputBin(attrs);
                }
                static outputXSL(attrs) {
                  return new OutputXSL(attrs);
                }
                static overprint(attrs) {
                  return new Overprint(attrs);
                }
                static packets(attrs) {
                  return new Packets(attrs);
                }
                static pageOffset(attrs) {
                  return new PageOffset(attrs);
                }
                static pageRange(attrs) {
                  return new PageRange(attrs);
                }
                static pagination(attrs) {
                  return new Pagination4(attrs);
                }
                static paginationOverride(attrs) {
                  return new PaginationOverride(attrs);
                }
                static part(attrs) {
                  return new Part(attrs);
                }
                static pcl(attrs) {
                  return new Pcl(attrs);
                }
                static pdf(attrs) {
                  return new Pdf(attrs);
                }
                static pdfa(attrs) {
                  return new Pdfa(attrs);
                }
                static permissions(attrs) {
                  return new Permissions(attrs);
                }
                static pickTrayByPDFSize(attrs) {
                  return new PickTrayByPDFSize(attrs);
                }
                static picture(attrs) {
                  return new Picture(attrs);
                }
                static plaintextMetadata(attrs) {
                  return new PlaintextMetadata(attrs);
                }
                static presence(attrs) {
                  return new Presence(attrs);
                }
                static present(attrs) {
                  return new Present(attrs);
                }
                static print(attrs) {
                  return new Print(attrs);
                }
                static printHighQuality(attrs) {
                  return new PrintHighQuality(attrs);
                }
                static printScaling(attrs) {
                  return new PrintScaling(attrs);
                }
                static printerName(attrs) {
                  return new PrinterName(attrs);
                }
                static producer(attrs) {
                  return new Producer(attrs);
                }
                static ps(attrs) {
                  return new Ps(attrs);
                }
                static range(attrs) {
                  return new Range(attrs);
                }
                static record(attrs) {
                  return new Record(attrs);
                }
                static relevant(attrs) {
                  return new Relevant(attrs);
                }
                static rename(attrs) {
                  return new Rename(attrs);
                }
                static renderPolicy(attrs) {
                  return new RenderPolicy(attrs);
                }
                static runScripts(attrs) {
                  return new RunScripts(attrs);
                }
                static script(attrs) {
                  return new Script(attrs);
                }
                static scriptModel(attrs) {
                  return new ScriptModel(attrs);
                }
                static severity(attrs) {
                  return new Severity(attrs);
                }
                static silentPrint(attrs) {
                  return new SilentPrint(attrs);
                }
                static staple(attrs) {
                  return new Staple(attrs);
                }
                static startNode(attrs) {
                  return new StartNode(attrs);
                }
                static startPage(attrs) {
                  return new StartPage(attrs);
                }
                static submitFormat(attrs) {
                  return new SubmitFormat(attrs);
                }
                static submitUrl(attrs) {
                  return new SubmitUrl(attrs);
                }
                static subsetBelow(attrs) {
                  return new SubsetBelow(attrs);
                }
                static suppressBanner(attrs) {
                  return new SuppressBanner(attrs);
                }
                static tagged(attrs) {
                  return new Tagged(attrs);
                }
                static template(attrs) {
                  return new Template9(attrs);
                }
                static templateCache(attrs) {
                  return new TemplateCache(attrs);
                }
                static threshold(attrs) {
                  return new Threshold(attrs);
                }
                static to(attrs) {
                  return new To(attrs);
                }
                static trace(attrs) {
                  return new Trace(attrs);
                }
                static transform(attrs) {
                  return new Transform2(attrs);
                }
                static type(attrs) {
                  return new Type(attrs);
                }
                static uri(attrs) {
                  return new Uri(attrs);
                }
                static validate(attrs) {
                  return new Validate(attrs);
                }
                static validateApprovalSignatures(attrs) {
                  return new ValidateApprovalSignatures(attrs);
                }
                static validationMessaging(attrs) {
                  return new ValidationMessaging(attrs);
                }
                static version(attrs) {
                  return new Version(attrs);
                }
                static versionControl(attrs) {
                  return new VersionControl(attrs);
                }
                static viewerPreferences(attrs) {
                  return new ViewerPreferences(attrs);
                }
                static webClient(attrs) {
                  return new WebClient(attrs);
                }
                static whitespace(attrs) {
                  return new Whitespace(attrs);
                }
                static window(attrs) {
                  return new Window2(attrs);
                }
                static xdc(attrs) {
                  return new Xdc(attrs);
                }
                static xdp(attrs) {
                  return new Xdp(attrs);
                }
                static xsl(attrs) {
                  return new Xsl(attrs);
                }
                static zpl(attrs) {
                  return new Zpl(attrs);
                }
              }
              exports3.ConfigNamespace = ConfigNamespace;
            }),
            /* 94 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.ConnectionSetNamespace = void 0;
              var _namespaces = __w_pdfjs_require__3(81);
              var _xfa_object = __w_pdfjs_require__3(87);
              const CONNECTION_SET_NS_ID = _namespaces.NamespaceIds.connectionSet.id;
              class ConnectionSet extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(CONNECTION_SET_NS_ID, "connectionSet", true);
                  this.wsdlConnection = new _xfa_object.XFAObjectArray();
                  this.xmlConnection = new _xfa_object.XFAObjectArray();
                  this.xsdConnection = new _xfa_object.XFAObjectArray();
                }
              }
              class EffectiveInputPolicy extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(CONNECTION_SET_NS_ID, "effectiveInputPolicy");
                  this.id = attributes2.id || "";
                  this.name = attributes2.name || "";
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                }
              }
              class EffectiveOutputPolicy extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(CONNECTION_SET_NS_ID, "effectiveOutputPolicy");
                  this.id = attributes2.id || "";
                  this.name = attributes2.name || "";
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                }
              }
              class Operation extends _xfa_object.StringObject {
                constructor(attributes2) {
                  super(CONNECTION_SET_NS_ID, "operation");
                  this.id = attributes2.id || "";
                  this.input = attributes2.input || "";
                  this.name = attributes2.name || "";
                  this.output = attributes2.output || "";
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                }
              }
              class RootElement extends _xfa_object.StringObject {
                constructor(attributes2) {
                  super(CONNECTION_SET_NS_ID, "rootElement");
                  this.id = attributes2.id || "";
                  this.name = attributes2.name || "";
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                }
              }
              class SoapAction extends _xfa_object.StringObject {
                constructor(attributes2) {
                  super(CONNECTION_SET_NS_ID, "soapAction");
                  this.id = attributes2.id || "";
                  this.name = attributes2.name || "";
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                }
              }
              class SoapAddress extends _xfa_object.StringObject {
                constructor(attributes2) {
                  super(CONNECTION_SET_NS_ID, "soapAddress");
                  this.id = attributes2.id || "";
                  this.name = attributes2.name || "";
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                }
              }
              class Uri extends _xfa_object.StringObject {
                constructor(attributes2) {
                  super(CONNECTION_SET_NS_ID, "uri");
                  this.id = attributes2.id || "";
                  this.name = attributes2.name || "";
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                }
              }
              class WsdlAddress extends _xfa_object.StringObject {
                constructor(attributes2) {
                  super(CONNECTION_SET_NS_ID, "wsdlAddress");
                  this.id = attributes2.id || "";
                  this.name = attributes2.name || "";
                  this.use = attributes2.use || "";
                  this.usehref = attributes2.usehref || "";
                }
              }
              class WsdlConnection extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(CONNECTION_SET_NS_ID, "wsdlConnection", true);
                  this.dataDescription = attributes2.dataDescription || "";
                  this.name = attributes2.name || "";
                  this.effectiveInputPolicy = null;
                  this.effectiveOutputPolicy = null;
                  this.operation = null;
                  this.soapAction = null;
                  this.soapAddress = null;
                  this.wsdlAddress = null;
                }
              }
              class XmlConnection extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(CONNECTION_SET_NS_ID, "xmlConnection", true);
                  this.dataDescription = attributes2.dataDescription || "";
                  this.name = attributes2.name || "";
                  this.uri = null;
                }
              }
              class XsdConnection extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(CONNECTION_SET_NS_ID, "xsdConnection", true);
                  this.dataDescription = attributes2.dataDescription || "";
                  this.name = attributes2.name || "";
                  this.rootElement = null;
                  this.uri = null;
                }
              }
              class ConnectionSetNamespace {
                static [_namespaces.$buildXFAObject](name, attributes2) {
                  if (ConnectionSetNamespace.hasOwnProperty(name)) {
                    return ConnectionSetNamespace[name](attributes2);
                  }
                  return void 0;
                }
                static connectionSet(attrs) {
                  return new ConnectionSet(attrs);
                }
                static effectiveInputPolicy(attrs) {
                  return new EffectiveInputPolicy(attrs);
                }
                static effectiveOutputPolicy(attrs) {
                  return new EffectiveOutputPolicy(attrs);
                }
                static operation(attrs) {
                  return new Operation(attrs);
                }
                static rootElement(attrs) {
                  return new RootElement(attrs);
                }
                static soapAction(attrs) {
                  return new SoapAction(attrs);
                }
                static soapAddress(attrs) {
                  return new SoapAddress(attrs);
                }
                static uri(attrs) {
                  return new Uri(attrs);
                }
                static wsdlAddress(attrs) {
                  return new WsdlAddress(attrs);
                }
                static wsdlConnection(attrs) {
                  return new WsdlConnection(attrs);
                }
                static xmlConnection(attrs) {
                  return new XmlConnection(attrs);
                }
                static xsdConnection(attrs) {
                  return new XsdConnection(attrs);
                }
              }
              exports3.ConnectionSetNamespace = ConnectionSetNamespace;
            }),
            /* 95 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.DatasetsNamespace = void 0;
              var _symbol_utils = __w_pdfjs_require__3(78);
              var _namespaces = __w_pdfjs_require__3(81);
              var _xfa_object = __w_pdfjs_require__3(87);
              const DATASETS_NS_ID = _namespaces.NamespaceIds.datasets.id;
              class Data extends _xfa_object.XmlObject {
                constructor(attributes2) {
                  super(DATASETS_NS_ID, "data", attributes2);
                }
                [_symbol_utils.$isNsAgnostic]() {
                  return true;
                }
              }
              class Datasets extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(DATASETS_NS_ID, "datasets", true);
                  this.data = null;
                  this.Signature = null;
                }
                [_symbol_utils.$onChild](child) {
                  const name = child[_symbol_utils.$nodeName];
                  if (name === "data" && child[_symbol_utils.$namespaceId] === DATASETS_NS_ID || name === "Signature" && child[_symbol_utils.$namespaceId] === _namespaces.NamespaceIds.signature.id) {
                    this[name] = child;
                  }
                  this[_symbol_utils.$appendChild](child);
                }
              }
              class DatasetsNamespace {
                static [_namespaces.$buildXFAObject](name, attributes2) {
                  if (DatasetsNamespace.hasOwnProperty(name)) {
                    return DatasetsNamespace[name](attributes2);
                  }
                  return void 0;
                }
                static datasets(attributes2) {
                  return new Datasets(attributes2);
                }
                static data(attributes2) {
                  return new Data(attributes2);
                }
              }
              exports3.DatasetsNamespace = DatasetsNamespace;
            }),
            /* 96 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.LocaleSetNamespace = void 0;
              var _namespaces = __w_pdfjs_require__3(81);
              var _xfa_object = __w_pdfjs_require__3(87);
              var _utils = __w_pdfjs_require__3(84);
              const LOCALE_SET_NS_ID = _namespaces.NamespaceIds.localeSet.id;
              class CalendarSymbols extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(LOCALE_SET_NS_ID, "calendarSymbols", true);
                  this.name = "gregorian";
                  this.dayNames = new _xfa_object.XFAObjectArray(2);
                  this.eraNames = null;
                  this.meridiemNames = null;
                  this.monthNames = new _xfa_object.XFAObjectArray(2);
                }
              }
              class CurrencySymbol extends _xfa_object.StringObject {
                constructor(attributes2) {
                  super(LOCALE_SET_NS_ID, "currencySymbol");
                  this.name = (0, _utils.getStringOption)(attributes2.name, ["symbol", "isoname", "decimal"]);
                }
              }
              class CurrencySymbols extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(LOCALE_SET_NS_ID, "currencySymbols", true);
                  this.currencySymbol = new _xfa_object.XFAObjectArray(3);
                }
              }
              class DatePattern extends _xfa_object.StringObject {
                constructor(attributes2) {
                  super(LOCALE_SET_NS_ID, "datePattern");
                  this.name = (0, _utils.getStringOption)(attributes2.name, ["full", "long", "med", "short"]);
                }
              }
              class DatePatterns extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(LOCALE_SET_NS_ID, "datePatterns", true);
                  this.datePattern = new _xfa_object.XFAObjectArray(4);
                }
              }
              class DateTimeSymbols extends _xfa_object.ContentObject {
                constructor(attributes2) {
                  super(LOCALE_SET_NS_ID, "dateTimeSymbols");
                }
              }
              class Day extends _xfa_object.StringObject {
                constructor(attributes2) {
                  super(LOCALE_SET_NS_ID, "day");
                }
              }
              class DayNames extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(LOCALE_SET_NS_ID, "dayNames", true);
                  this.abbr = (0, _utils.getInteger)({
                    data: attributes2.abbr,
                    defaultValue: 0,
                    validate: (x) => x === 1
                  });
                  this.day = new _xfa_object.XFAObjectArray(7);
                }
              }
              class Era extends _xfa_object.StringObject {
                constructor(attributes2) {
                  super(LOCALE_SET_NS_ID, "era");
                }
              }
              class EraNames extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(LOCALE_SET_NS_ID, "eraNames", true);
                  this.era = new _xfa_object.XFAObjectArray(2);
                }
              }
              class Locale extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(LOCALE_SET_NS_ID, "locale", true);
                  this.desc = attributes2.desc || "";
                  this.name = "isoname";
                  this.calendarSymbols = null;
                  this.currencySymbols = null;
                  this.datePatterns = null;
                  this.dateTimeSymbols = null;
                  this.numberPatterns = null;
                  this.numberSymbols = null;
                  this.timePatterns = null;
                  this.typeFaces = null;
                }
              }
              class LocaleSet extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(LOCALE_SET_NS_ID, "localeSet", true);
                  this.locale = new _xfa_object.XFAObjectArray();
                }
              }
              class Meridiem extends _xfa_object.StringObject {
                constructor(attributes2) {
                  super(LOCALE_SET_NS_ID, "meridiem");
                }
              }
              class MeridiemNames extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(LOCALE_SET_NS_ID, "meridiemNames", true);
                  this.meridiem = new _xfa_object.XFAObjectArray(2);
                }
              }
              class Month extends _xfa_object.StringObject {
                constructor(attributes2) {
                  super(LOCALE_SET_NS_ID, "month");
                }
              }
              class MonthNames extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(LOCALE_SET_NS_ID, "monthNames", true);
                  this.abbr = (0, _utils.getInteger)({
                    data: attributes2.abbr,
                    defaultValue: 0,
                    validate: (x) => x === 1
                  });
                  this.month = new _xfa_object.XFAObjectArray(12);
                }
              }
              class NumberPattern extends _xfa_object.StringObject {
                constructor(attributes2) {
                  super(LOCALE_SET_NS_ID, "numberPattern");
                  this.name = (0, _utils.getStringOption)(attributes2.name, ["full", "long", "med", "short"]);
                }
              }
              class NumberPatterns extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(LOCALE_SET_NS_ID, "numberPatterns", true);
                  this.numberPattern = new _xfa_object.XFAObjectArray(4);
                }
              }
              class NumberSymbol extends _xfa_object.StringObject {
                constructor(attributes2) {
                  super(LOCALE_SET_NS_ID, "numberSymbol");
                  this.name = (0, _utils.getStringOption)(attributes2.name, ["decimal", "grouping", "percent", "minus", "zero"]);
                }
              }
              class NumberSymbols extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(LOCALE_SET_NS_ID, "numberSymbols", true);
                  this.numberSymbol = new _xfa_object.XFAObjectArray(5);
                }
              }
              class TimePattern extends _xfa_object.StringObject {
                constructor(attributes2) {
                  super(LOCALE_SET_NS_ID, "timePattern");
                  this.name = (0, _utils.getStringOption)(attributes2.name, ["full", "long", "med", "short"]);
                }
              }
              class TimePatterns extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(LOCALE_SET_NS_ID, "timePatterns", true);
                  this.timePattern = new _xfa_object.XFAObjectArray(4);
                }
              }
              class TypeFace extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(LOCALE_SET_NS_ID, "typeFace", true);
                  this.name = attributes2.name | "";
                }
              }
              class TypeFaces extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(LOCALE_SET_NS_ID, "typeFaces", true);
                  this.typeFace = new _xfa_object.XFAObjectArray();
                }
              }
              class LocaleSetNamespace {
                static [_namespaces.$buildXFAObject](name, attributes2) {
                  if (LocaleSetNamespace.hasOwnProperty(name)) {
                    return LocaleSetNamespace[name](attributes2);
                  }
                  return void 0;
                }
                static calendarSymbols(attrs) {
                  return new CalendarSymbols(attrs);
                }
                static currencySymbol(attrs) {
                  return new CurrencySymbol(attrs);
                }
                static currencySymbols(attrs) {
                  return new CurrencySymbols(attrs);
                }
                static datePattern(attrs) {
                  return new DatePattern(attrs);
                }
                static datePatterns(attrs) {
                  return new DatePatterns(attrs);
                }
                static dateTimeSymbols(attrs) {
                  return new DateTimeSymbols(attrs);
                }
                static day(attrs) {
                  return new Day(attrs);
                }
                static dayNames(attrs) {
                  return new DayNames(attrs);
                }
                static era(attrs) {
                  return new Era(attrs);
                }
                static eraNames(attrs) {
                  return new EraNames(attrs);
                }
                static locale(attrs) {
                  return new Locale(attrs);
                }
                static localeSet(attrs) {
                  return new LocaleSet(attrs);
                }
                static meridiem(attrs) {
                  return new Meridiem(attrs);
                }
                static meridiemNames(attrs) {
                  return new MeridiemNames(attrs);
                }
                static month(attrs) {
                  return new Month(attrs);
                }
                static monthNames(attrs) {
                  return new MonthNames(attrs);
                }
                static numberPattern(attrs) {
                  return new NumberPattern(attrs);
                }
                static numberPatterns(attrs) {
                  return new NumberPatterns(attrs);
                }
                static numberSymbol(attrs) {
                  return new NumberSymbol(attrs);
                }
                static numberSymbols(attrs) {
                  return new NumberSymbols(attrs);
                }
                static timePattern(attrs) {
                  return new TimePattern(attrs);
                }
                static timePatterns(attrs) {
                  return new TimePatterns(attrs);
                }
                static typeFace(attrs) {
                  return new TypeFace(attrs);
                }
                static typeFaces(attrs) {
                  return new TypeFaces(attrs);
                }
              }
              exports3.LocaleSetNamespace = LocaleSetNamespace;
            }),
            /* 97 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.SignatureNamespace = void 0;
              var _namespaces = __w_pdfjs_require__3(81);
              var _xfa_object = __w_pdfjs_require__3(87);
              const SIGNATURE_NS_ID = _namespaces.NamespaceIds.signature.id;
              class Signature extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(SIGNATURE_NS_ID, "signature", true);
                }
              }
              class SignatureNamespace {
                static [_namespaces.$buildXFAObject](name, attributes2) {
                  if (SignatureNamespace.hasOwnProperty(name)) {
                    return SignatureNamespace[name](attributes2);
                  }
                  return void 0;
                }
                static signature(attributes2) {
                  return new Signature(attributes2);
                }
              }
              exports3.SignatureNamespace = SignatureNamespace;
            }),
            /* 98 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.StylesheetNamespace = void 0;
              var _namespaces = __w_pdfjs_require__3(81);
              var _xfa_object = __w_pdfjs_require__3(87);
              const STYLESHEET_NS_ID = _namespaces.NamespaceIds.stylesheet.id;
              class Stylesheet extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(STYLESHEET_NS_ID, "stylesheet", true);
                }
              }
              class StylesheetNamespace {
                static [_namespaces.$buildXFAObject](name, attributes2) {
                  if (StylesheetNamespace.hasOwnProperty(name)) {
                    return StylesheetNamespace[name](attributes2);
                  }
                  return void 0;
                }
                static stylesheet(attributes2) {
                  return new Stylesheet(attributes2);
                }
              }
              exports3.StylesheetNamespace = StylesheetNamespace;
            }),
            /* 99 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.XdpNamespace = void 0;
              var _namespaces = __w_pdfjs_require__3(81);
              var _symbol_utils = __w_pdfjs_require__3(78);
              var _xfa_object = __w_pdfjs_require__3(87);
              const XDP_NS_ID = _namespaces.NamespaceIds.xdp.id;
              class Xdp extends _xfa_object.XFAObject {
                constructor(attributes2) {
                  super(XDP_NS_ID, "xdp", true);
                  this.uuid = attributes2.uuid || "";
                  this.timeStamp = attributes2.timeStamp || "";
                  this.config = null;
                  this.connectionSet = null;
                  this.datasets = null;
                  this.localeSet = null;
                  this.stylesheet = new _xfa_object.XFAObjectArray();
                  this.template = null;
                }
                [_symbol_utils.$onChildCheck](child) {
                  const ns = _namespaces.NamespaceIds[child[_symbol_utils.$nodeName]];
                  return ns && child[_symbol_utils.$namespaceId] === ns.id;
                }
              }
              class XdpNamespace {
                static [_namespaces.$buildXFAObject](name, attributes2) {
                  if (XdpNamespace.hasOwnProperty(name)) {
                    return XdpNamespace[name](attributes2);
                  }
                  return void 0;
                }
                static xdp(attributes2) {
                  return new Xdp(attributes2);
                }
              }
              exports3.XdpNamespace = XdpNamespace;
            }),
            /* 100 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.XhtmlNamespace = void 0;
              var _symbol_utils = __w_pdfjs_require__3(78);
              var _namespaces = __w_pdfjs_require__3(81);
              var _html_utils = __w_pdfjs_require__3(83);
              var _utils = __w_pdfjs_require__3(84);
              var _xfa_object = __w_pdfjs_require__3(87);
              const XHTML_NS_ID = _namespaces.NamespaceIds.xhtml.id;
              const $richText = Symbol();
              const VALID_STYLES = /* @__PURE__ */ new Set(["color", "font", "font-family", "font-size", "font-stretch", "font-style", "font-weight", "margin", "margin-bottom", "margin-left", "margin-right", "margin-top", "letter-spacing", "line-height", "orphans", "page-break-after", "page-break-before", "page-break-inside", "tab-interval", "tab-stop", "text-align", "text-decoration", "text-indent", "vertical-align", "widows", "kerning-mode", "xfa-font-horizontal-scale", "xfa-font-vertical-scale", "xfa-spacerun", "xfa-tab-stops"]);
              const StyleMapping = /* @__PURE__ */ new Map([["page-break-after", "breakAfter"], ["page-break-before", "breakBefore"], ["page-break-inside", "breakInside"], ["kerning-mode", (value) => value === "none" ? "none" : "normal"], ["xfa-font-horizontal-scale", (value) => `scaleX(${Math.max(0, Math.min(parseInt(value) / 100)).toFixed(2)})`], ["xfa-font-vertical-scale", (value) => `scaleY(${Math.max(0, Math.min(parseInt(value) / 100)).toFixed(2)})`], ["xfa-spacerun", ""], ["xfa-tab-stops", ""], ["font-size", (value, original) => {
                value = original.fontSize = (0, _utils.getMeasurement)(value);
                return (0, _html_utils.measureToString)(0.99 * value);
              }], ["letter-spacing", (value) => (0, _html_utils.measureToString)((0, _utils.getMeasurement)(value))], ["line-height", (value) => (0, _html_utils.measureToString)((0, _utils.getMeasurement)(value))], ["margin", (value) => (0, _html_utils.measureToString)((0, _utils.getMeasurement)(value))], ["margin-bottom", (value) => (0, _html_utils.measureToString)((0, _utils.getMeasurement)(value))], ["margin-left", (value) => (0, _html_utils.measureToString)((0, _utils.getMeasurement)(value))], ["margin-right", (value) => (0, _html_utils.measureToString)((0, _utils.getMeasurement)(value))], ["margin-top", (value) => (0, _html_utils.measureToString)((0, _utils.getMeasurement)(value))], ["text-indent", (value) => (0, _html_utils.measureToString)((0, _utils.getMeasurement)(value))], ["font-family", (value) => value], ["vertical-align", (value) => (0, _html_utils.measureToString)((0, _utils.getMeasurement)(value))]]);
              const spacesRegExp = /\s+/g;
              const crlfRegExp = /[\r\n]+/g;
              const crlfForRichTextRegExp = /\r\n?/g;
              function mapStyle(styleStr, node2, richText) {
                const style2 = /* @__PURE__ */ Object.create(null);
                if (!styleStr) {
                  return style2;
                }
                const original = /* @__PURE__ */ Object.create(null);
                for (const [key2, value] of styleStr.split(";").map((s) => s.split(":", 2))) {
                  const mapping2 = StyleMapping.get(key2);
                  if (mapping2 === "") {
                    continue;
                  }
                  let newValue = value;
                  if (mapping2) {
                    newValue = typeof mapping2 === "string" ? mapping2 : mapping2(value, original);
                  }
                  if (key2.endsWith("scale")) {
                    style2.transform = style2.transform ? `${style2[key2]} ${newValue}` : newValue;
                  } else {
                    style2[key2.replaceAll(/-([a-zA-Z])/g, (_, x) => x.toUpperCase())] = newValue;
                  }
                }
                if (style2.fontFamily) {
                  (0, _html_utils.setFontFamily)({
                    typeface: style2.fontFamily,
                    weight: style2.fontWeight || "normal",
                    posture: style2.fontStyle || "normal",
                    size: original.fontSize || 0
                  }, node2, node2[_symbol_utils.$globalData].fontFinder, style2);
                }
                if (richText && style2.verticalAlign && style2.verticalAlign !== "0px" && style2.fontSize) {
                  const SUB_SUPER_SCRIPT_FACTOR = 0.583;
                  const VERTICAL_FACTOR = 0.333;
                  const fontSize = (0, _utils.getMeasurement)(style2.fontSize);
                  style2.fontSize = (0, _html_utils.measureToString)(fontSize * SUB_SUPER_SCRIPT_FACTOR);
                  style2.verticalAlign = (0, _html_utils.measureToString)(Math.sign((0, _utils.getMeasurement)(style2.verticalAlign)) * fontSize * VERTICAL_FACTOR);
                }
                if (richText && style2.fontSize) {
                  style2.fontSize = `calc(${style2.fontSize} * var(--scale-factor))`;
                }
                (0, _html_utils.fixTextIndent)(style2);
                return style2;
              }
              function checkStyle(node2) {
                if (!node2.style) {
                  return "";
                }
                return node2.style.trim().split(/\s*;\s*/).filter((s) => !!s).map((s) => s.split(/\s*:\s*/, 2)).filter(([key2, value]) => {
                  if (key2 === "font-family") {
                    node2[_symbol_utils.$globalData].usedTypefaces.add(value);
                  }
                  return VALID_STYLES.has(key2);
                }).map((kv) => kv.join(":")).join(";");
              }
              const NoWhites = /* @__PURE__ */ new Set(["body", "html"]);
              class XhtmlObject extends _xfa_object.XmlObject {
                constructor(attributes2, name) {
                  super(XHTML_NS_ID, name);
                  this[$richText] = false;
                  this.style = attributes2.style || "";
                }
                [_symbol_utils.$clean](builder) {
                  super[_symbol_utils.$clean](builder);
                  this.style = checkStyle(this);
                }
                [_symbol_utils.$acceptWhitespace]() {
                  return !NoWhites.has(this[_symbol_utils.$nodeName]);
                }
                [_symbol_utils.$onText](str, richText = false) {
                  if (!richText) {
                    str = str.replaceAll(crlfRegExp, "");
                    if (!this.style.includes("xfa-spacerun:yes")) {
                      str = str.replaceAll(spacesRegExp, " ");
                    }
                  } else {
                    this[$richText] = true;
                  }
                  if (str) {
                    this[_symbol_utils.$content] += str;
                  }
                }
                [_symbol_utils.$pushGlyphs](measure, mustPop = true) {
                  const xfaFont = /* @__PURE__ */ Object.create(null);
                  const margin = {
                    top: NaN,
                    bottom: NaN,
                    left: NaN,
                    right: NaN
                  };
                  let lineHeight = null;
                  for (const [key2, value] of this.style.split(";").map((s) => s.split(":", 2))) {
                    switch (key2) {
                      case "font-family":
                        xfaFont.typeface = (0, _utils.stripQuotes)(value);
                        break;
                      case "font-size":
                        xfaFont.size = (0, _utils.getMeasurement)(value);
                        break;
                      case "font-weight":
                        xfaFont.weight = value;
                        break;
                      case "font-style":
                        xfaFont.posture = value;
                        break;
                      case "letter-spacing":
                        xfaFont.letterSpacing = (0, _utils.getMeasurement)(value);
                        break;
                      case "margin":
                        const values = value.split(/ \t/).map((x) => (0, _utils.getMeasurement)(x));
                        switch (values.length) {
                          case 1:
                            margin.top = margin.bottom = margin.left = margin.right = values[0];
                            break;
                          case 2:
                            margin.top = margin.bottom = values[0];
                            margin.left = margin.right = values[1];
                            break;
                          case 3:
                            margin.top = values[0];
                            margin.bottom = values[2];
                            margin.left = margin.right = values[1];
                            break;
                          case 4:
                            margin.top = values[0];
                            margin.left = values[1];
                            margin.bottom = values[2];
                            margin.right = values[3];
                            break;
                        }
                        break;
                      case "margin-top":
                        margin.top = (0, _utils.getMeasurement)(value);
                        break;
                      case "margin-bottom":
                        margin.bottom = (0, _utils.getMeasurement)(value);
                        break;
                      case "margin-left":
                        margin.left = (0, _utils.getMeasurement)(value);
                        break;
                      case "margin-right":
                        margin.right = (0, _utils.getMeasurement)(value);
                        break;
                      case "line-height":
                        lineHeight = (0, _utils.getMeasurement)(value);
                        break;
                    }
                  }
                  measure.pushData(xfaFont, margin, lineHeight);
                  if (this[_symbol_utils.$content]) {
                    measure.addString(this[_symbol_utils.$content]);
                  } else {
                    for (const child of this[_symbol_utils.$getChildren]()) {
                      if (child[_symbol_utils.$nodeName] === "#text") {
                        measure.addString(child[_symbol_utils.$content]);
                        continue;
                      }
                      child[_symbol_utils.$pushGlyphs](measure);
                    }
                  }
                  if (mustPop) {
                    measure.popFont();
                  }
                }
                [_symbol_utils.$toHTML](availableSpace) {
                  const children = [];
                  this[_symbol_utils.$extra] = {
                    children
                  };
                  this[_symbol_utils.$childrenToHTML]({});
                  if (children.length === 0 && !this[_symbol_utils.$content]) {
                    return _utils.HTMLResult.EMPTY;
                  }
                  let value;
                  if (this[$richText]) {
                    value = this[_symbol_utils.$content] ? this[_symbol_utils.$content].replaceAll(crlfForRichTextRegExp, "\n") : void 0;
                  } else {
                    value = this[_symbol_utils.$content] || void 0;
                  }
                  return _utils.HTMLResult.success({
                    name: this[_symbol_utils.$nodeName],
                    attributes: {
                      href: this.href,
                      style: mapStyle(this.style, this, this[$richText])
                    },
                    children,
                    value
                  });
                }
              }
              class A extends XhtmlObject {
                constructor(attributes2) {
                  super(attributes2, "a");
                  this.href = (0, _html_utils.fixURL)(attributes2.href) || "";
                }
              }
              class B extends XhtmlObject {
                constructor(attributes2) {
                  super(attributes2, "b");
                }
                [_symbol_utils.$pushGlyphs](measure) {
                  measure.pushFont({
                    weight: "bold"
                  });
                  super[_symbol_utils.$pushGlyphs](measure);
                  measure.popFont();
                }
              }
              class Body2 extends XhtmlObject {
                constructor(attributes2) {
                  super(attributes2, "body");
                }
                [_symbol_utils.$toHTML](availableSpace) {
                  const res = super[_symbol_utils.$toHTML](availableSpace);
                  const {
                    html: html2
                  } = res;
                  if (!html2) {
                    return _utils.HTMLResult.EMPTY;
                  }
                  html2.name = "div";
                  html2.attributes.class = ["xfaRich"];
                  return res;
                }
              }
              class Br extends XhtmlObject {
                constructor(attributes2) {
                  super(attributes2, "br");
                }
                [_symbol_utils.$text]() {
                  return "\n";
                }
                [_symbol_utils.$pushGlyphs](measure) {
                  measure.addString("\n");
                }
                [_symbol_utils.$toHTML](availableSpace) {
                  return _utils.HTMLResult.success({
                    name: "br"
                  });
                }
              }
              class Html extends XhtmlObject {
                constructor(attributes2) {
                  super(attributes2, "html");
                }
                [_symbol_utils.$toHTML](availableSpace) {
                  const children = [];
                  this[_symbol_utils.$extra] = {
                    children
                  };
                  this[_symbol_utils.$childrenToHTML]({});
                  if (children.length === 0) {
                    return _utils.HTMLResult.success({
                      name: "div",
                      attributes: {
                        class: ["xfaRich"],
                        style: {}
                      },
                      value: this[_symbol_utils.$content] || ""
                    });
                  }
                  if (children.length === 1) {
                    const child = children[0];
                    if (child.attributes?.class.includes("xfaRich")) {
                      return _utils.HTMLResult.success(child);
                    }
                  }
                  return _utils.HTMLResult.success({
                    name: "div",
                    attributes: {
                      class: ["xfaRich"],
                      style: {}
                    },
                    children
                  });
                }
              }
              class I extends XhtmlObject {
                constructor(attributes2) {
                  super(attributes2, "i");
                }
                [_symbol_utils.$pushGlyphs](measure) {
                  measure.pushFont({
                    posture: "italic"
                  });
                  super[_symbol_utils.$pushGlyphs](measure);
                  measure.popFont();
                }
              }
              class Li extends XhtmlObject {
                constructor(attributes2) {
                  super(attributes2, "li");
                }
              }
              class Ol extends XhtmlObject {
                constructor(attributes2) {
                  super(attributes2, "ol");
                }
              }
              class P extends XhtmlObject {
                constructor(attributes2) {
                  super(attributes2, "p");
                }
                [_symbol_utils.$pushGlyphs](measure) {
                  super[_symbol_utils.$pushGlyphs](measure, false);
                  measure.addString("\n");
                  measure.addPara();
                  measure.popFont();
                }
                [_symbol_utils.$text]() {
                  const siblings = this[_symbol_utils.$getParent]()[_symbol_utils.$getChildren]();
                  if (siblings.at(-1) === this) {
                    return super[_symbol_utils.$text]();
                  }
                  return super[_symbol_utils.$text]() + "\n";
                }
              }
              class Span extends XhtmlObject {
                constructor(attributes2) {
                  super(attributes2, "span");
                }
              }
              class Sub extends XhtmlObject {
                constructor(attributes2) {
                  super(attributes2, "sub");
                }
              }
              class Sup extends XhtmlObject {
                constructor(attributes2) {
                  super(attributes2, "sup");
                }
              }
              class Ul extends XhtmlObject {
                constructor(attributes2) {
                  super(attributes2, "ul");
                }
              }
              class XhtmlNamespace {
                static [_namespaces.$buildXFAObject](name, attributes2) {
                  if (XhtmlNamespace.hasOwnProperty(name)) {
                    return XhtmlNamespace[name](attributes2);
                  }
                  return void 0;
                }
                static a(attributes2) {
                  return new A(attributes2);
                }
                static b(attributes2) {
                  return new B(attributes2);
                }
                static body(attributes2) {
                  return new Body2(attributes2);
                }
                static br(attributes2) {
                  return new Br(attributes2);
                }
                static html(attributes2) {
                  return new Html(attributes2);
                }
                static i(attributes2) {
                  return new I(attributes2);
                }
                static li(attributes2) {
                  return new Li(attributes2);
                }
                static ol(attributes2) {
                  return new Ol(attributes2);
                }
                static p(attributes2) {
                  return new P(attributes2);
                }
                static span(attributes2) {
                  return new Span(attributes2);
                }
                static sub(attributes2) {
                  return new Sub(attributes2);
                }
                static sup(attributes2) {
                  return new Sup(attributes2);
                }
                static ul(attributes2) {
                  return new Ul(attributes2);
                }
              }
              exports3.XhtmlNamespace = XhtmlNamespace;
            }),
            /* 101 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.UnknownNamespace = void 0;
              var _namespaces = __w_pdfjs_require__3(81);
              var _xfa_object = __w_pdfjs_require__3(87);
              class UnknownNamespace {
                constructor(nsId) {
                  this.namespaceId = nsId;
                }
                [_namespaces.$buildXFAObject](name, attributes2) {
                  return new _xfa_object.XmlObject(this.namespaceId, name, attributes2);
                }
              }
              exports3.UnknownNamespace = UnknownNamespace;
            }),
            /* 102 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.DatasetReader = void 0;
              var _util2 = __w_pdfjs_require__3(2);
              var _core_utils = __w_pdfjs_require__3(3);
              var _xml_parser = __w_pdfjs_require__3(71);
              function decodeString(str) {
                try {
                  return (0, _util2.stringToUTF8String)(str);
                } catch (ex) {
                  (0, _util2.warn)(`UTF-8 decoding failed: "${ex}".`);
                  return str;
                }
              }
              class DatasetXMLParser extends _xml_parser.SimpleXMLParser {
                constructor(options) {
                  super(options);
                  this.node = null;
                }
                onEndElement(name) {
                  const node2 = super.onEndElement(name);
                  if (node2 && name === "xfa:datasets") {
                    this.node = node2;
                    throw new Error("Aborting DatasetXMLParser.");
                  }
                }
              }
              class DatasetReader {
                constructor(data2) {
                  if (data2.datasets) {
                    this.node = new _xml_parser.SimpleXMLParser({
                      hasAttributes: true
                    }).parseFromString(data2.datasets).documentElement;
                  } else {
                    const parser = new DatasetXMLParser({
                      hasAttributes: true
                    });
                    try {
                      parser.parseFromString(data2["xdp:xdp"]);
                    } catch {
                    }
                    this.node = parser.node;
                  }
                }
                getValue(path2) {
                  if (!this.node || !path2) {
                    return "";
                  }
                  const node2 = this.node.searchNode((0, _core_utils.parseXFAPath)(path2), 0);
                  if (!node2) {
                    return "";
                  }
                  const first = node2.firstChild;
                  if (first?.nodeName === "value") {
                    return node2.children.map((child) => decodeString(child.textContent));
                  }
                  return decodeString(node2.textContent);
                }
              }
              exports3.DatasetReader = DatasetReader;
            }),
            /* 103 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.XRef = void 0;
              var _util2 = __w_pdfjs_require__3(2);
              var _primitives = __w_pdfjs_require__3(4);
              var _parser = __w_pdfjs_require__3(16);
              var _core_utils = __w_pdfjs_require__3(3);
              var _base_stream = __w_pdfjs_require__3(5);
              var _crypto = __w_pdfjs_require__3(74);
              class XRef {
                #firstXRefStmPos = null;
                constructor(stream, pdfManager) {
                  this.stream = stream;
                  this.pdfManager = pdfManager;
                  this.entries = [];
                  this._xrefStms = /* @__PURE__ */ new Set();
                  this._cacheMap = /* @__PURE__ */ new Map();
                  this._pendingRefs = new _primitives.RefSet();
                  this._newPersistentRefNum = null;
                  this._newTemporaryRefNum = null;
                }
                getNewPersistentRef(obj) {
                  if (this._newPersistentRefNum === null) {
                    this._newPersistentRefNum = this.entries.length || 1;
                  }
                  const num = this._newPersistentRefNum++;
                  this._cacheMap.set(num, obj);
                  return _primitives.Ref.get(num, 0);
                }
                getNewTemporaryRef() {
                  if (this._newTemporaryRefNum === null) {
                    this._newTemporaryRefNum = this.entries.length || 1;
                  }
                  return _primitives.Ref.get(this._newTemporaryRefNum++, 0);
                }
                resetNewTemporaryRef() {
                  this._newTemporaryRefNum = null;
                }
                setStartXRef(startXRef) {
                  this.startXRefQueue = [startXRef];
                }
                parse(recoveryMode = false) {
                  let trailerDict;
                  if (!recoveryMode) {
                    trailerDict = this.readXRef();
                  } else {
                    (0, _util2.warn)("Indexing all PDF objects");
                    trailerDict = this.indexObjects();
                  }
                  trailerDict.assignXref(this);
                  this.trailer = trailerDict;
                  let encrypt;
                  try {
                    encrypt = trailerDict.get("Encrypt");
                  } catch (ex) {
                    if (ex instanceof _core_utils.MissingDataException) {
                      throw ex;
                    }
                    (0, _util2.warn)(`XRef.parse - Invalid "Encrypt" reference: "${ex}".`);
                  }
                  if (encrypt instanceof _primitives.Dict) {
                    const ids2 = trailerDict.get("ID");
                    const fileId = ids2?.length ? ids2[0] : "";
                    encrypt.suppressEncryption = true;
                    this.encrypt = new _crypto.CipherTransformFactory(encrypt, fileId, this.pdfManager.password);
                  }
                  let root2;
                  try {
                    root2 = trailerDict.get("Root");
                  } catch (ex) {
                    if (ex instanceof _core_utils.MissingDataException) {
                      throw ex;
                    }
                    (0, _util2.warn)(`XRef.parse - Invalid "Root" reference: "${ex}".`);
                  }
                  if (root2 instanceof _primitives.Dict) {
                    try {
                      const pages = root2.get("Pages");
                      if (pages instanceof _primitives.Dict) {
                        this.root = root2;
                        return;
                      }
                    } catch (ex) {
                      if (ex instanceof _core_utils.MissingDataException) {
                        throw ex;
                      }
                      (0, _util2.warn)(`XRef.parse - Invalid "Pages" reference: "${ex}".`);
                    }
                  }
                  if (!recoveryMode) {
                    throw new _core_utils.XRefParseException();
                  }
                  throw new _util2.InvalidPDFException("Invalid Root reference.");
                }
                processXRefTable(parser) {
                  if (!("tableState" in this)) {
                    this.tableState = {
                      entryNum: 0,
                      streamPos: parser.lexer.stream.pos,
                      parserBuf1: parser.buf1,
                      parserBuf2: parser.buf2
                    };
                  }
                  const obj = this.readXRefTable(parser);
                  if (!(0, _primitives.isCmd)(obj, "trailer")) {
                    throw new _util2.FormatError("Invalid XRef table: could not find trailer dictionary");
                  }
                  let dict = parser.getObj();
                  if (!(dict instanceof _primitives.Dict) && dict.dict) {
                    dict = dict.dict;
                  }
                  if (!(dict instanceof _primitives.Dict)) {
                    throw new _util2.FormatError("Invalid XRef table: could not parse trailer dictionary");
                  }
                  delete this.tableState;
                  return dict;
                }
                readXRefTable(parser) {
                  const stream = parser.lexer.stream;
                  const tableState = this.tableState;
                  stream.pos = tableState.streamPos;
                  parser.buf1 = tableState.parserBuf1;
                  parser.buf2 = tableState.parserBuf2;
                  let obj;
                  while (true) {
                    if (!("firstEntryNum" in tableState) || !("entryCount" in tableState)) {
                      if ((0, _primitives.isCmd)(obj = parser.getObj(), "trailer")) {
                        break;
                      }
                      tableState.firstEntryNum = obj;
                      tableState.entryCount = parser.getObj();
                    }
                    let first = tableState.firstEntryNum;
                    const count = tableState.entryCount;
                    if (!Number.isInteger(first) || !Number.isInteger(count)) {
                      throw new _util2.FormatError("Invalid XRef table: wrong types in subsection header");
                    }
                    for (let i = tableState.entryNum; i < count; i++) {
                      tableState.streamPos = stream.pos;
                      tableState.entryNum = i;
                      tableState.parserBuf1 = parser.buf1;
                      tableState.parserBuf2 = parser.buf2;
                      const entry = {};
                      entry.offset = parser.getObj();
                      entry.gen = parser.getObj();
                      const type5 = parser.getObj();
                      if (type5 instanceof _primitives.Cmd) {
                        switch (type5.cmd) {
                          case "f":
                            entry.free = true;
                            break;
                          case "n":
                            entry.uncompressed = true;
                            break;
                        }
                      }
                      if (!Number.isInteger(entry.offset) || !Number.isInteger(entry.gen) || !(entry.free || entry.uncompressed)) {
                        throw new _util2.FormatError(`Invalid entry in XRef subsection: ${first}, ${count}`);
                      }
                      if (i === 0 && entry.free && first === 1) {
                        first = 0;
                      }
                      if (!this.entries[i + first]) {
                        this.entries[i + first] = entry;
                      }
                    }
                    tableState.entryNum = 0;
                    tableState.streamPos = stream.pos;
                    tableState.parserBuf1 = parser.buf1;
                    tableState.parserBuf2 = parser.buf2;
                    delete tableState.firstEntryNum;
                    delete tableState.entryCount;
                  }
                  if (this.entries[0] && !this.entries[0].free) {
                    throw new _util2.FormatError("Invalid XRef table: unexpected first object");
                  }
                  return obj;
                }
                processXRefStream(stream) {
                  if (!("streamState" in this)) {
                    const streamParameters = stream.dict;
                    const byteWidths = streamParameters.get("W");
                    let range3 = streamParameters.get("Index");
                    if (!range3) {
                      range3 = [0, streamParameters.get("Size")];
                    }
                    this.streamState = {
                      entryRanges: range3,
                      byteWidths,
                      entryNum: 0,
                      streamPos: stream.pos
                    };
                  }
                  this.readXRefStream(stream);
                  delete this.streamState;
                  return stream.dict;
                }
                readXRefStream(stream) {
                  const streamState = this.streamState;
                  stream.pos = streamState.streamPos;
                  const [typeFieldWidth, offsetFieldWidth, generationFieldWidth] = streamState.byteWidths;
                  const entryRanges = streamState.entryRanges;
                  while (entryRanges.length > 0) {
                    const [first, n2] = entryRanges;
                    if (!Number.isInteger(first) || !Number.isInteger(n2)) {
                      throw new _util2.FormatError(`Invalid XRef range fields: ${first}, ${n2}`);
                    }
                    if (!Number.isInteger(typeFieldWidth) || !Number.isInteger(offsetFieldWidth) || !Number.isInteger(generationFieldWidth)) {
                      throw new _util2.FormatError(`Invalid XRef entry fields length: ${first}, ${n2}`);
                    }
                    for (let i = streamState.entryNum; i < n2; ++i) {
                      streamState.entryNum = i;
                      streamState.streamPos = stream.pos;
                      let type5 = 0, offset4 = 0, generation = 0;
                      for (let j = 0; j < typeFieldWidth; ++j) {
                        const typeByte = stream.getByte();
                        if (typeByte === -1) {
                          throw new _util2.FormatError("Invalid XRef byteWidths 'type'.");
                        }
                        type5 = type5 << 8 | typeByte;
                      }
                      if (typeFieldWidth === 0) {
                        type5 = 1;
                      }
                      for (let j = 0; j < offsetFieldWidth; ++j) {
                        const offsetByte = stream.getByte();
                        if (offsetByte === -1) {
                          throw new _util2.FormatError("Invalid XRef byteWidths 'offset'.");
                        }
                        offset4 = offset4 << 8 | offsetByte;
                      }
                      for (let j = 0; j < generationFieldWidth; ++j) {
                        const generationByte = stream.getByte();
                        if (generationByte === -1) {
                          throw new _util2.FormatError("Invalid XRef byteWidths 'generation'.");
                        }
                        generation = generation << 8 | generationByte;
                      }
                      const entry = {};
                      entry.offset = offset4;
                      entry.gen = generation;
                      switch (type5) {
                        case 0:
                          entry.free = true;
                          break;
                        case 1:
                          entry.uncompressed = true;
                          break;
                        case 2:
                          break;
                        default:
                          throw new _util2.FormatError(`Invalid XRef entry type: ${type5}`);
                      }
                      if (!this.entries[first + i]) {
                        this.entries[first + i] = entry;
                      }
                    }
                    streamState.entryNum = 0;
                    streamState.streamPos = stream.pos;
                    entryRanges.splice(0, 2);
                  }
                }
                indexObjects() {
                  const TAB2 = 9, LF = 10, CR = 13, SPACE = 32;
                  const PERCENT = 37, LT = 60;
                  function readToken(data2, offset4) {
                    let token2 = "", ch = data2[offset4];
                    while (ch !== LF && ch !== CR && ch !== LT) {
                      if (++offset4 >= data2.length) {
                        break;
                      }
                      token2 += String.fromCharCode(ch);
                      ch = data2[offset4];
                    }
                    return token2;
                  }
                  function skipUntil(data2, offset4, what) {
                    const length3 = what.length, dataLength = data2.length;
                    let skipped = 0;
                    while (offset4 < dataLength) {
                      let i = 0;
                      while (i < length3 && data2[offset4 + i] === what[i]) {
                        ++i;
                      }
                      if (i >= length3) {
                        break;
                      }
                      offset4++;
                      skipped++;
                    }
                    return skipped;
                  }
                  const gEndobjRegExp = /\b(endobj|\d+\s+\d+\s+obj|xref|trailer\s*<<)\b/g;
                  const gStartxrefRegExp = /\b(startxref|\d+\s+\d+\s+obj)\b/g;
                  const objRegExp = /^(\d+)\s+(\d+)\s+obj\b/;
                  const trailerBytes = new Uint8Array([116, 114, 97, 105, 108, 101, 114]);
                  const startxrefBytes = new Uint8Array([115, 116, 97, 114, 116, 120, 114, 101, 102]);
                  const xrefBytes = new Uint8Array([47, 88, 82, 101, 102]);
                  this.entries.length = 0;
                  this._cacheMap.clear();
                  const stream = this.stream;
                  stream.pos = 0;
                  const buffer = stream.getBytes(), bufferStr = (0, _util2.bytesToString)(buffer), length2 = buffer.length;
                  let position3 = stream.start;
                  const trailers = [], xrefStms = [];
                  while (position3 < length2) {
                    let ch = buffer[position3];
                    if (ch === TAB2 || ch === LF || ch === CR || ch === SPACE) {
                      ++position3;
                      continue;
                    }
                    if (ch === PERCENT) {
                      do {
                        ++position3;
                        if (position3 >= length2) {
                          break;
                        }
                        ch = buffer[position3];
                      } while (ch !== LF && ch !== CR);
                      continue;
                    }
                    const token2 = readToken(buffer, position3);
                    let m;
                    if (token2.startsWith("xref") && (token2.length === 4 || /\s/.test(token2[4]))) {
                      position3 += skipUntil(buffer, position3, trailerBytes);
                      trailers.push(position3);
                      position3 += skipUntil(buffer, position3, startxrefBytes);
                    } else if (m = objRegExp.exec(token2)) {
                      const num = m[1] | 0, gen = m[2] | 0;
                      const startPos = position3 + token2.length;
                      let contentLength, updateEntries = false;
                      if (!this.entries[num]) {
                        updateEntries = true;
                      } else if (this.entries[num].gen === gen) {
                        try {
                          const parser = new _parser.Parser({
                            lexer: new _parser.Lexer(stream.makeSubStream(startPos))
                          });
                          parser.getObj();
                          updateEntries = true;
                        } catch (ex) {
                          if (ex instanceof _core_utils.ParserEOFException) {
                            (0, _util2.warn)(`indexObjects -- checking object (${token2}): "${ex}".`);
                          } else {
                            updateEntries = true;
                          }
                        }
                      }
                      if (updateEntries) {
                        this.entries[num] = {
                          offset: position3 - stream.start,
                          gen,
                          uncompressed: true
                        };
                      }
                      gEndobjRegExp.lastIndex = startPos;
                      const match2 = gEndobjRegExp.exec(bufferStr);
                      if (match2) {
                        const endPos = gEndobjRegExp.lastIndex + 1;
                        contentLength = endPos - position3;
                        if (match2[1] !== "endobj") {
                          (0, _util2.warn)(`indexObjects: Found "${match2[1]}" inside of another "obj", caused by missing "endobj" -- trying to recover.`);
                          contentLength -= match2[1].length + 1;
                        }
                      } else {
                        contentLength = length2 - position3;
                      }
                      const content = buffer.subarray(position3, position3 + contentLength);
                      const xrefTagOffset = skipUntil(content, 0, xrefBytes);
                      if (xrefTagOffset < contentLength && content[xrefTagOffset + 5] < 64) {
                        xrefStms.push(position3 - stream.start);
                        this._xrefStms.add(position3 - stream.start);
                      }
                      position3 += contentLength;
                    } else if (token2.startsWith("trailer") && (token2.length === 7 || /\s/.test(token2[7]))) {
                      trailers.push(position3);
                      const startPos = position3 + token2.length;
                      let contentLength;
                      gStartxrefRegExp.lastIndex = startPos;
                      const match2 = gStartxrefRegExp.exec(bufferStr);
                      if (match2) {
                        const endPos = gStartxrefRegExp.lastIndex + 1;
                        contentLength = endPos - position3;
                        if (match2[1] !== "startxref") {
                          (0, _util2.warn)(`indexObjects: Found "${match2[1]}" after "trailer", caused by missing "startxref" -- trying to recover.`);
                          contentLength -= match2[1].length + 1;
                        }
                      } else {
                        contentLength = length2 - position3;
                      }
                      position3 += contentLength;
                    } else {
                      position3 += token2.length + 1;
                    }
                  }
                  for (const xrefStm of xrefStms) {
                    this.startXRefQueue.push(xrefStm);
                    this.readXRef(true);
                  }
                  const trailerDicts = [];
                  let isEncrypted = false;
                  for (const trailer of trailers) {
                    stream.pos = trailer;
                    const parser = new _parser.Parser({
                      lexer: new _parser.Lexer(stream),
                      xref: this,
                      allowStreams: true,
                      recoveryMode: true
                    });
                    const obj = parser.getObj();
                    if (!(0, _primitives.isCmd)(obj, "trailer")) {
                      continue;
                    }
                    const dict = parser.getObj();
                    if (!(dict instanceof _primitives.Dict)) {
                      continue;
                    }
                    trailerDicts.push(dict);
                    if (dict.has("Encrypt")) {
                      isEncrypted = true;
                    }
                  }
                  let trailerDict, trailerError;
                  for (const dict of [...trailerDicts, "genFallback", ...trailerDicts]) {
                    if (dict === "genFallback") {
                      if (!trailerError) {
                        break;
                      }
                      this._generationFallback = true;
                      continue;
                    }
                    let validPagesDict = false;
                    try {
                      const rootDict = dict.get("Root");
                      if (!(rootDict instanceof _primitives.Dict)) {
                        continue;
                      }
                      const pagesDict = rootDict.get("Pages");
                      if (!(pagesDict instanceof _primitives.Dict)) {
                        continue;
                      }
                      const pagesCount = pagesDict.get("Count");
                      if (Number.isInteger(pagesCount)) {
                        validPagesDict = true;
                      }
                    } catch (ex) {
                      trailerError = ex;
                      continue;
                    }
                    if (validPagesDict && (!isEncrypted || dict.has("Encrypt")) && dict.has("ID")) {
                      return dict;
                    }
                    trailerDict = dict;
                  }
                  if (trailerDict) {
                    return trailerDict;
                  }
                  if (this.topDict) {
                    return this.topDict;
                  }
                  throw new _util2.InvalidPDFException("Invalid PDF structure.");
                }
                readXRef(recoveryMode = false) {
                  const stream = this.stream;
                  const startXRefParsedCache = /* @__PURE__ */ new Set();
                  while (this.startXRefQueue.length) {
                    try {
                      const startXRef = this.startXRefQueue[0];
                      if (startXRefParsedCache.has(startXRef)) {
                        (0, _util2.warn)("readXRef - skipping XRef table since it was already parsed.");
                        this.startXRefQueue.shift();
                        continue;
                      }
                      startXRefParsedCache.add(startXRef);
                      stream.pos = startXRef + stream.start;
                      const parser = new _parser.Parser({
                        lexer: new _parser.Lexer(stream),
                        xref: this,
                        allowStreams: true
                      });
                      let obj = parser.getObj();
                      let dict;
                      if ((0, _primitives.isCmd)(obj, "xref")) {
                        dict = this.processXRefTable(parser);
                        if (!this.topDict) {
                          this.topDict = dict;
                        }
                        obj = dict.get("XRefStm");
                        if (Number.isInteger(obj) && !this._xrefStms.has(obj)) {
                          this._xrefStms.add(obj);
                          this.startXRefQueue.push(obj);
                          this.#firstXRefStmPos ??= obj;
                        }
                      } else if (Number.isInteger(obj)) {
                        if (!Number.isInteger(parser.getObj()) || !(0, _primitives.isCmd)(parser.getObj(), "obj") || !((obj = parser.getObj()) instanceof _base_stream.BaseStream)) {
                          throw new _util2.FormatError("Invalid XRef stream");
                        }
                        dict = this.processXRefStream(obj);
                        if (!this.topDict) {
                          this.topDict = dict;
                        }
                        if (!dict) {
                          throw new _util2.FormatError("Failed to read XRef stream");
                        }
                      } else {
                        throw new _util2.FormatError("Invalid XRef stream header");
                      }
                      obj = dict.get("Prev");
                      if (Number.isInteger(obj)) {
                        this.startXRefQueue.push(obj);
                      } else if (obj instanceof _primitives.Ref) {
                        this.startXRefQueue.push(obj.num);
                      }
                    } catch (e3) {
                      if (e3 instanceof _core_utils.MissingDataException) {
                        throw e3;
                      }
                      (0, _util2.info)("(while reading XRef): " + e3);
                    }
                    this.startXRefQueue.shift();
                  }
                  if (this.topDict) {
                    return this.topDict;
                  }
                  if (recoveryMode) {
                    return void 0;
                  }
                  throw new _core_utils.XRefParseException();
                }
                get lastXRefStreamPos() {
                  return this.#firstXRefStmPos ?? (this._xrefStms.size > 0 ? Math.max(...this._xrefStms) : null);
                }
                getEntry(i) {
                  const xrefEntry = this.entries[i];
                  if (xrefEntry && !xrefEntry.free && xrefEntry.offset) {
                    return xrefEntry;
                  }
                  return null;
                }
                fetchIfRef(obj, suppressEncryption = false) {
                  if (obj instanceof _primitives.Ref) {
                    return this.fetch(obj, suppressEncryption);
                  }
                  return obj;
                }
                fetch(ref3, suppressEncryption = false) {
                  if (!(ref3 instanceof _primitives.Ref)) {
                    throw new Error("ref object is not a reference");
                  }
                  const num = ref3.num;
                  const cacheEntry = this._cacheMap.get(num);
                  if (cacheEntry !== void 0) {
                    if (cacheEntry instanceof _primitives.Dict && !cacheEntry.objId) {
                      cacheEntry.objId = ref3.toString();
                    }
                    return cacheEntry;
                  }
                  let xrefEntry = this.getEntry(num);
                  if (xrefEntry === null) {
                    this._cacheMap.set(num, xrefEntry);
                    return xrefEntry;
                  }
                  if (this._pendingRefs.has(ref3)) {
                    this._pendingRefs.remove(ref3);
                    (0, _util2.warn)(`Ignoring circular reference: ${ref3}.`);
                    return _primitives.CIRCULAR_REF;
                  }
                  this._pendingRefs.put(ref3);
                  try {
                    xrefEntry = xrefEntry.uncompressed ? this.fetchUncompressed(ref3, xrefEntry, suppressEncryption) : this.fetchCompressed(ref3, xrefEntry, suppressEncryption);
                    this._pendingRefs.remove(ref3);
                  } catch (ex) {
                    this._pendingRefs.remove(ref3);
                    throw ex;
                  }
                  if (xrefEntry instanceof _primitives.Dict) {
                    xrefEntry.objId = ref3.toString();
                  } else if (xrefEntry instanceof _base_stream.BaseStream) {
                    xrefEntry.dict.objId = ref3.toString();
                  }
                  return xrefEntry;
                }
                fetchUncompressed(ref3, xrefEntry, suppressEncryption = false) {
                  const gen = ref3.gen;
                  let num = ref3.num;
                  if (xrefEntry.gen !== gen) {
                    const msg = `Inconsistent generation in XRef: ${ref3}`;
                    if (this._generationFallback && xrefEntry.gen < gen) {
                      (0, _util2.warn)(msg);
                      return this.fetchUncompressed(_primitives.Ref.get(num, xrefEntry.gen), xrefEntry, suppressEncryption);
                    }
                    throw new _core_utils.XRefEntryException(msg);
                  }
                  const stream = this.stream.makeSubStream(xrefEntry.offset + this.stream.start);
                  const parser = new _parser.Parser({
                    lexer: new _parser.Lexer(stream),
                    xref: this,
                    allowStreams: true
                  });
                  const obj1 = parser.getObj();
                  const obj2 = parser.getObj();
                  const obj3 = parser.getObj();
                  if (obj1 !== num || obj2 !== gen || !(obj3 instanceof _primitives.Cmd)) {
                    throw new _core_utils.XRefEntryException(`Bad (uncompressed) XRef entry: ${ref3}`);
                  }
                  if (obj3.cmd !== "obj") {
                    if (obj3.cmd.startsWith("obj")) {
                      num = parseInt(obj3.cmd.substring(3), 10);
                      if (!Number.isNaN(num)) {
                        return num;
                      }
                    }
                    throw new _core_utils.XRefEntryException(`Bad (uncompressed) XRef entry: ${ref3}`);
                  }
                  xrefEntry = this.encrypt && !suppressEncryption ? parser.getObj(this.encrypt.createCipherTransform(num, gen)) : parser.getObj();
                  if (!(xrefEntry instanceof _base_stream.BaseStream)) {
                    this._cacheMap.set(num, xrefEntry);
                  }
                  return xrefEntry;
                }
                fetchCompressed(ref3, xrefEntry, suppressEncryption = false) {
                  const tableOffset = xrefEntry.offset;
                  const stream = this.fetch(_primitives.Ref.get(tableOffset, 0));
                  if (!(stream instanceof _base_stream.BaseStream)) {
                    throw new _util2.FormatError("bad ObjStm stream");
                  }
                  const first = stream.dict.get("First");
                  const n2 = stream.dict.get("N");
                  if (!Number.isInteger(first) || !Number.isInteger(n2)) {
                    throw new _util2.FormatError("invalid first and n parameters for ObjStm stream");
                  }
                  let parser = new _parser.Parser({
                    lexer: new _parser.Lexer(stream),
                    xref: this,
                    allowStreams: true
                  });
                  const nums = new Array(n2);
                  const offsets = new Array(n2);
                  for (let i = 0; i < n2; ++i) {
                    const num = parser.getObj();
                    if (!Number.isInteger(num)) {
                      throw new _util2.FormatError(`invalid object number in the ObjStm stream: ${num}`);
                    }
                    const offset4 = parser.getObj();
                    if (!Number.isInteger(offset4)) {
                      throw new _util2.FormatError(`invalid object offset in the ObjStm stream: ${offset4}`);
                    }
                    nums[i] = num;
                    offsets[i] = offset4;
                  }
                  const start = (stream.start || 0) + first;
                  const entries = new Array(n2);
                  for (let i = 0; i < n2; ++i) {
                    const length2 = i < n2 - 1 ? offsets[i + 1] - offsets[i] : void 0;
                    if (length2 < 0) {
                      throw new _util2.FormatError("Invalid offset in the ObjStm stream.");
                    }
                    parser = new _parser.Parser({
                      lexer: new _parser.Lexer(stream.makeSubStream(start + offsets[i], length2, stream.dict)),
                      xref: this,
                      allowStreams: true
                    });
                    const obj = parser.getObj();
                    entries[i] = obj;
                    if (obj instanceof _base_stream.BaseStream) {
                      continue;
                    }
                    const num = nums[i], entry = this.entries[num];
                    if (entry && entry.offset === tableOffset && entry.gen === i) {
                      this._cacheMap.set(num, obj);
                    }
                  }
                  xrefEntry = entries[xrefEntry.gen];
                  if (xrefEntry === void 0) {
                    throw new _core_utils.XRefEntryException(`Bad (compressed) XRef entry: ${ref3}`);
                  }
                  return xrefEntry;
                }
                async fetchIfRefAsync(obj, suppressEncryption) {
                  if (obj instanceof _primitives.Ref) {
                    return this.fetchAsync(obj, suppressEncryption);
                  }
                  return obj;
                }
                async fetchAsync(ref3, suppressEncryption) {
                  try {
                    return this.fetch(ref3, suppressEncryption);
                  } catch (ex) {
                    if (!(ex instanceof _core_utils.MissingDataException)) {
                      throw ex;
                    }
                    await this.pdfManager.requestRange(ex.begin, ex.end);
                    return this.fetchAsync(ref3, suppressEncryption);
                  }
                }
                getCatalogObj() {
                  return this.root;
                }
              }
              exports3.XRef = XRef;
            }),
            /* 104 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.MessageHandler = void 0;
              var _util2 = __w_pdfjs_require__3(2);
              const CallbackKind = {
                UNKNOWN: 0,
                DATA: 1,
                ERROR: 2
              };
              const StreamKind = {
                UNKNOWN: 0,
                CANCEL: 1,
                CANCEL_COMPLETE: 2,
                CLOSE: 3,
                ENQUEUE: 4,
                ERROR: 5,
                PULL: 6,
                PULL_COMPLETE: 7,
                START_COMPLETE: 8
              };
              function wrapReason(reason) {
                if (!(reason instanceof Error || typeof reason === "object" && reason !== null)) {
                  (0, _util2.unreachable)('wrapReason: Expected "reason" to be a (possibly cloned) Error.');
                }
                switch (reason.name) {
                  case "AbortException":
                    return new _util2.AbortException(reason.message);
                  case "MissingPDFException":
                    return new _util2.MissingPDFException(reason.message);
                  case "PasswordException":
                    return new _util2.PasswordException(reason.message, reason.code);
                  case "UnexpectedResponseException":
                    return new _util2.UnexpectedResponseException(reason.message, reason.status);
                  case "UnknownErrorException":
                    return new _util2.UnknownErrorException(reason.message, reason.details);
                  default:
                    return new _util2.UnknownErrorException(reason.message, reason.toString());
                }
              }
              class MessageHandler {
                constructor(sourceName, targetName, comObj) {
                  this.sourceName = sourceName;
                  this.targetName = targetName;
                  this.comObj = comObj;
                  this.callbackId = 1;
                  this.streamId = 1;
                  this.streamSinks = /* @__PURE__ */ Object.create(null);
                  this.streamControllers = /* @__PURE__ */ Object.create(null);
                  this.callbackCapabilities = /* @__PURE__ */ Object.create(null);
                  this.actionHandler = /* @__PURE__ */ Object.create(null);
                  this._onComObjOnMessage = (event) => {
                    const data2 = event.data;
                    if (data2.targetName !== this.sourceName) {
                      return;
                    }
                    if (data2.stream) {
                      this.#processStreamMessage(data2);
                      return;
                    }
                    if (data2.callback) {
                      const callbackId = data2.callbackId;
                      const capability = this.callbackCapabilities[callbackId];
                      if (!capability) {
                        throw new Error(`Cannot resolve callback ${callbackId}`);
                      }
                      delete this.callbackCapabilities[callbackId];
                      if (data2.callback === CallbackKind.DATA) {
                        capability.resolve(data2.data);
                      } else if (data2.callback === CallbackKind.ERROR) {
                        capability.reject(wrapReason(data2.reason));
                      } else {
                        throw new Error("Unexpected callback case");
                      }
                      return;
                    }
                    const action = this.actionHandler[data2.action];
                    if (!action) {
                      throw new Error(`Unknown action from worker: ${data2.action}`);
                    }
                    if (data2.callbackId) {
                      const cbSourceName = this.sourceName;
                      const cbTargetName = data2.sourceName;
                      new Promise(function(resolve) {
                        resolve(action(data2.data));
                      }).then(function(result) {
                        comObj.postMessage({
                          sourceName: cbSourceName,
                          targetName: cbTargetName,
                          callback: CallbackKind.DATA,
                          callbackId: data2.callbackId,
                          data: result
                        });
                      }, function(reason) {
                        comObj.postMessage({
                          sourceName: cbSourceName,
                          targetName: cbTargetName,
                          callback: CallbackKind.ERROR,
                          callbackId: data2.callbackId,
                          reason: wrapReason(reason)
                        });
                      });
                      return;
                    }
                    if (data2.streamId) {
                      this.#createStreamSink(data2);
                      return;
                    }
                    action(data2.data);
                  };
                  comObj.addEventListener("message", this._onComObjOnMessage);
                }
                on(actionName, handler) {
                  const ah = this.actionHandler;
                  if (ah[actionName]) {
                    throw new Error(`There is already an actionName called "${actionName}"`);
                  }
                  ah[actionName] = handler;
                }
                send(actionName, data2, transfers) {
                  this.comObj.postMessage({
                    sourceName: this.sourceName,
                    targetName: this.targetName,
                    action: actionName,
                    data: data2
                  }, transfers);
                }
                sendWithPromise(actionName, data2, transfers) {
                  const callbackId = this.callbackId++;
                  const capability = new _util2.PromiseCapability();
                  this.callbackCapabilities[callbackId] = capability;
                  try {
                    this.comObj.postMessage({
                      sourceName: this.sourceName,
                      targetName: this.targetName,
                      action: actionName,
                      callbackId,
                      data: data2
                    }, transfers);
                  } catch (ex) {
                    capability.reject(ex);
                  }
                  return capability.promise;
                }
                sendWithStream(actionName, data2, queueingStrategy, transfers) {
                  const streamId = this.streamId++, sourceName = this.sourceName, targetName = this.targetName, comObj = this.comObj;
                  return new ReadableStream({
                    start: (controller) => {
                      const startCapability = new _util2.PromiseCapability();
                      this.streamControllers[streamId] = {
                        controller,
                        startCall: startCapability,
                        pullCall: null,
                        cancelCall: null,
                        isClosed: false
                      };
                      comObj.postMessage({
                        sourceName,
                        targetName,
                        action: actionName,
                        streamId,
                        data: data2,
                        desiredSize: controller.desiredSize
                      }, transfers);
                      return startCapability.promise;
                    },
                    pull: (controller) => {
                      const pullCapability = new _util2.PromiseCapability();
                      this.streamControllers[streamId].pullCall = pullCapability;
                      comObj.postMessage({
                        sourceName,
                        targetName,
                        stream: StreamKind.PULL,
                        streamId,
                        desiredSize: controller.desiredSize
                      });
                      return pullCapability.promise;
                    },
                    cancel: (reason) => {
                      (0, _util2.assert)(reason instanceof Error, "cancel must have a valid reason");
                      const cancelCapability = new _util2.PromiseCapability();
                      this.streamControllers[streamId].cancelCall = cancelCapability;
                      this.streamControllers[streamId].isClosed = true;
                      comObj.postMessage({
                        sourceName,
                        targetName,
                        stream: StreamKind.CANCEL,
                        streamId,
                        reason: wrapReason(reason)
                      });
                      return cancelCapability.promise;
                    }
                  }, queueingStrategy);
                }
                #createStreamSink(data2) {
                  const streamId = data2.streamId, sourceName = this.sourceName, targetName = data2.sourceName, comObj = this.comObj;
                  const self2 = this, action = this.actionHandler[data2.action];
                  const streamSink = {
                    enqueue(chunk, size = 1, transfers) {
                      if (this.isCancelled) {
                        return;
                      }
                      const lastDesiredSize = this.desiredSize;
                      this.desiredSize -= size;
                      if (lastDesiredSize > 0 && this.desiredSize <= 0) {
                        this.sinkCapability = new _util2.PromiseCapability();
                        this.ready = this.sinkCapability.promise;
                      }
                      comObj.postMessage({
                        sourceName,
                        targetName,
                        stream: StreamKind.ENQUEUE,
                        streamId,
                        chunk
                      }, transfers);
                    },
                    close() {
                      if (this.isCancelled) {
                        return;
                      }
                      this.isCancelled = true;
                      comObj.postMessage({
                        sourceName,
                        targetName,
                        stream: StreamKind.CLOSE,
                        streamId
                      });
                      delete self2.streamSinks[streamId];
                    },
                    error(reason) {
                      (0, _util2.assert)(reason instanceof Error, "error must have a valid reason");
                      if (this.isCancelled) {
                        return;
                      }
                      this.isCancelled = true;
                      comObj.postMessage({
                        sourceName,
                        targetName,
                        stream: StreamKind.ERROR,
                        streamId,
                        reason: wrapReason(reason)
                      });
                    },
                    sinkCapability: new _util2.PromiseCapability(),
                    onPull: null,
                    onCancel: null,
                    isCancelled: false,
                    desiredSize: data2.desiredSize,
                    ready: null
                  };
                  streamSink.sinkCapability.resolve();
                  streamSink.ready = streamSink.sinkCapability.promise;
                  this.streamSinks[streamId] = streamSink;
                  new Promise(function(resolve) {
                    resolve(action(data2.data, streamSink));
                  }).then(function() {
                    comObj.postMessage({
                      sourceName,
                      targetName,
                      stream: StreamKind.START_COMPLETE,
                      streamId,
                      success: true
                    });
                  }, function(reason) {
                    comObj.postMessage({
                      sourceName,
                      targetName,
                      stream: StreamKind.START_COMPLETE,
                      streamId,
                      reason: wrapReason(reason)
                    });
                  });
                }
                #processStreamMessage(data2) {
                  const streamId = data2.streamId, sourceName = this.sourceName, targetName = data2.sourceName, comObj = this.comObj;
                  const streamController = this.streamControllers[streamId], streamSink = this.streamSinks[streamId];
                  switch (data2.stream) {
                    case StreamKind.START_COMPLETE:
                      if (data2.success) {
                        streamController.startCall.resolve();
                      } else {
                        streamController.startCall.reject(wrapReason(data2.reason));
                      }
                      break;
                    case StreamKind.PULL_COMPLETE:
                      if (data2.success) {
                        streamController.pullCall.resolve();
                      } else {
                        streamController.pullCall.reject(wrapReason(data2.reason));
                      }
                      break;
                    case StreamKind.PULL:
                      if (!streamSink) {
                        comObj.postMessage({
                          sourceName,
                          targetName,
                          stream: StreamKind.PULL_COMPLETE,
                          streamId,
                          success: true
                        });
                        break;
                      }
                      if (streamSink.desiredSize <= 0 && data2.desiredSize > 0) {
                        streamSink.sinkCapability.resolve();
                      }
                      streamSink.desiredSize = data2.desiredSize;
                      new Promise(function(resolve) {
                        resolve(streamSink.onPull?.());
                      }).then(function() {
                        comObj.postMessage({
                          sourceName,
                          targetName,
                          stream: StreamKind.PULL_COMPLETE,
                          streamId,
                          success: true
                        });
                      }, function(reason) {
                        comObj.postMessage({
                          sourceName,
                          targetName,
                          stream: StreamKind.PULL_COMPLETE,
                          streamId,
                          reason: wrapReason(reason)
                        });
                      });
                      break;
                    case StreamKind.ENQUEUE:
                      (0, _util2.assert)(streamController, "enqueue should have stream controller");
                      if (streamController.isClosed) {
                        break;
                      }
                      streamController.controller.enqueue(data2.chunk);
                      break;
                    case StreamKind.CLOSE:
                      (0, _util2.assert)(streamController, "close should have stream controller");
                      if (streamController.isClosed) {
                        break;
                      }
                      streamController.isClosed = true;
                      streamController.controller.close();
                      this.#deleteStreamController(streamController, streamId);
                      break;
                    case StreamKind.ERROR:
                      (0, _util2.assert)(streamController, "error should have stream controller");
                      streamController.controller.error(wrapReason(data2.reason));
                      this.#deleteStreamController(streamController, streamId);
                      break;
                    case StreamKind.CANCEL_COMPLETE:
                      if (data2.success) {
                        streamController.cancelCall.resolve();
                      } else {
                        streamController.cancelCall.reject(wrapReason(data2.reason));
                      }
                      this.#deleteStreamController(streamController, streamId);
                      break;
                    case StreamKind.CANCEL:
                      if (!streamSink) {
                        break;
                      }
                      new Promise(function(resolve) {
                        resolve(streamSink.onCancel?.(wrapReason(data2.reason)));
                      }).then(function() {
                        comObj.postMessage({
                          sourceName,
                          targetName,
                          stream: StreamKind.CANCEL_COMPLETE,
                          streamId,
                          success: true
                        });
                      }, function(reason) {
                        comObj.postMessage({
                          sourceName,
                          targetName,
                          stream: StreamKind.CANCEL_COMPLETE,
                          streamId,
                          reason: wrapReason(reason)
                        });
                      });
                      streamSink.sinkCapability.reject(wrapReason(data2.reason));
                      streamSink.isCancelled = true;
                      delete this.streamSinks[streamId];
                      break;
                    default:
                      throw new Error("Unexpected stream case");
                  }
                }
                async #deleteStreamController(streamController, streamId) {
                  await Promise.allSettled([streamController.startCall?.promise, streamController.pullCall?.promise, streamController.cancelCall?.promise]);
                  delete this.streamControllers[streamId];
                }
                destroy() {
                  this.comObj.removeEventListener("message", this._onComObjOnMessage);
                }
              }
              exports3.MessageHandler = MessageHandler;
            }),
            /* 105 */
            /***/
            ((__unused_webpack_module2, exports3, __w_pdfjs_require__3) => {
              Object.defineProperty(exports3, "__esModule", {
                value: true
              });
              exports3.PDFWorkerStream = void 0;
              var _util2 = __w_pdfjs_require__3(2);
              class PDFWorkerStream {
                constructor(msgHandler) {
                  this._msgHandler = msgHandler;
                  this._contentLength = null;
                  this._fullRequestReader = null;
                  this._rangeRequestReaders = [];
                }
                getFullReader() {
                  (0, _util2.assert)(!this._fullRequestReader, "PDFWorkerStream.getFullReader can only be called once.");
                  this._fullRequestReader = new PDFWorkerStreamReader(this._msgHandler);
                  return this._fullRequestReader;
                }
                getRangeReader(begin, end) {
                  const reader = new PDFWorkerStreamRangeReader(begin, end, this._msgHandler);
                  this._rangeRequestReaders.push(reader);
                  return reader;
                }
                cancelAllRequests(reason) {
                  this._fullRequestReader?.cancel(reason);
                  for (const reader of this._rangeRequestReaders.slice(0)) {
                    reader.cancel(reason);
                  }
                }
              }
              exports3.PDFWorkerStream = PDFWorkerStream;
              class PDFWorkerStreamReader {
                constructor(msgHandler) {
                  this._msgHandler = msgHandler;
                  this.onProgress = null;
                  this._contentLength = null;
                  this._isRangeSupported = false;
                  this._isStreamingSupported = false;
                  const readableStream = this._msgHandler.sendWithStream("GetReader");
                  this._reader = readableStream.getReader();
                  this._headersReady = this._msgHandler.sendWithPromise("ReaderHeadersReady").then((data2) => {
                    this._isStreamingSupported = data2.isStreamingSupported;
                    this._isRangeSupported = data2.isRangeSupported;
                    this._contentLength = data2.contentLength;
                  });
                }
                get headersReady() {
                  return this._headersReady;
                }
                get contentLength() {
                  return this._contentLength;
                }
                get isStreamingSupported() {
                  return this._isStreamingSupported;
                }
                get isRangeSupported() {
                  return this._isRangeSupported;
                }
                async read() {
                  const {
                    value,
                    done
                  } = await this._reader.read();
                  if (done) {
                    return {
                      value: void 0,
                      done: true
                    };
                  }
                  return {
                    value: value.buffer,
                    done: false
                  };
                }
                cancel(reason) {
                  this._reader.cancel(reason);
                }
              }
              class PDFWorkerStreamRangeReader {
                constructor(begin, end, msgHandler) {
                  this._msgHandler = msgHandler;
                  this.onProgress = null;
                  const readableStream = this._msgHandler.sendWithStream("GetRangeReader", {
                    begin,
                    end
                  });
                  this._reader = readableStream.getReader();
                }
                get isStreamingSupported() {
                  return false;
                }
                async read() {
                  const {
                    value,
                    done
                  } = await this._reader.read();
                  if (done) {
                    return {
                      value: void 0,
                      done: true
                    };
                  }
                  return {
                    value: value.buffer,
                    done: false
                  };
                }
                cancel(reason) {
                  this._reader.cancel(reason);
                }
              }
            })
            /******/
          ];
          var __webpack_module_cache__2 = {};
          function __w_pdfjs_require__2(moduleId) {
            var cachedModule = __webpack_module_cache__2[moduleId];
            if (cachedModule !== void 0) {
              return cachedModule.exports;
            }
            var module3 = __webpack_module_cache__2[moduleId] = {
              /******/
              // no module.id needed
              /******/
              // no module.loaded needed
              /******/
              exports: {}
              /******/
            };
            __webpack_modules__2[moduleId](module3, module3.exports, __w_pdfjs_require__2);
            return module3.exports;
          }
          var __webpack_exports__2 = {};
          (() => {
            var exports3 = __webpack_exports__2;
            Object.defineProperty(exports3, "__esModule", {
              value: true
            });
            Object.defineProperty(exports3, "WorkerMessageHandler", {
              enumerable: true,
              get: function() {
                return _worker.WorkerMessageHandler;
              }
            });
            var _worker = __w_pdfjs_require__2(1);
            const pdfjsVersion = "3.11.174";
            const pdfjsBuild = "ce8716743";
          })();
          return __webpack_exports__2;
        })()
      );
    });
  }
});

// ../../node_modules/pdfjs-dist/build/pdf.worker.entry.js
var require_pdf_worker_entry = __commonJS({
  "../../node_modules/pdfjs-dist/build/pdf.worker.entry.js"() {
    (typeof window !== "undefined" ? window : {}).pdfjsWorker = require_pdf_worker();
  }
});

// ../../node_modules/fast-deep-equal/index.js
var require_fast_deep_equal = __commonJS({
  "../../node_modules/fast-deep-equal/index.js"(exports2, module2) {
    "use strict";
    module2.exports = function equal(a, b) {
      if (a === b) return true;
      if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length2, i, keys4;
        if (Array.isArray(a)) {
          length2 = a.length;
          if (length2 != b.length) return false;
          for (i = length2; i-- !== 0; )
            if (!equal(a[i], b[i])) return false;
          return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys4 = Object.keys(a);
        length2 = keys4.length;
        if (length2 !== Object.keys(b).length) return false;
        for (i = length2; i-- !== 0; )
          if (!Object.prototype.hasOwnProperty.call(b, keys4[i])) return false;
        for (i = length2; i-- !== 0; ) {
          var key2 = keys4[i];
          if (!equal(a[key2], b[key2])) return false;
        }
        return true;
      }
      return a !== a && b !== b;
    };
  }
});

// ../../node_modules/tiny-inflate/index.js
var require_tiny_inflate = __commonJS({
  "../../node_modules/tiny-inflate/index.js"(exports2, module2) {
    var TINF_OK = 0;
    var TINF_DATA_ERROR = -3;
    function Tree4() {
      this.table = new Uint16Array(16);
      this.trans = new Uint16Array(288);
    }
    function Data(source, dest) {
      this.source = source;
      this.sourceIndex = 0;
      this.tag = 0;
      this.bitcount = 0;
      this.dest = dest;
      this.destLen = 0;
      this.ltree = new Tree4();
      this.dtree = new Tree4();
    }
    var sltree = new Tree4();
    var sdtree = new Tree4();
    var length_bits = new Uint8Array(30);
    var length_base = new Uint16Array(30);
    var dist_bits = new Uint8Array(30);
    var dist_base = new Uint16Array(30);
    var clcidx = new Uint8Array([
      16,
      17,
      18,
      0,
      8,
      7,
      9,
      6,
      10,
      5,
      11,
      4,
      12,
      3,
      13,
      2,
      14,
      1,
      15
    ]);
    var code_tree = new Tree4();
    var lengths = new Uint8Array(288 + 32);
    function tinf_build_bits_base(bits, base, delta, first) {
      var i, sum2;
      for (i = 0; i < delta; ++i) bits[i] = 0;
      for (i = 0; i < 30 - delta; ++i) bits[i + delta] = i / delta | 0;
      for (sum2 = first, i = 0; i < 30; ++i) {
        base[i] = sum2;
        sum2 += 1 << bits[i];
      }
    }
    function tinf_build_fixed_trees(lt, dt) {
      var i;
      for (i = 0; i < 7; ++i) lt.table[i] = 0;
      lt.table[7] = 24;
      lt.table[8] = 152;
      lt.table[9] = 112;
      for (i = 0; i < 24; ++i) lt.trans[i] = 256 + i;
      for (i = 0; i < 144; ++i) lt.trans[24 + i] = i;
      for (i = 0; i < 8; ++i) lt.trans[24 + 144 + i] = 280 + i;
      for (i = 0; i < 112; ++i) lt.trans[24 + 144 + 8 + i] = 144 + i;
      for (i = 0; i < 5; ++i) dt.table[i] = 0;
      dt.table[5] = 32;
      for (i = 0; i < 32; ++i) dt.trans[i] = i;
    }
    var offs = new Uint16Array(16);
    function tinf_build_tree(t2, lengths2, off, num) {
      var i, sum2;
      for (i = 0; i < 16; ++i) t2.table[i] = 0;
      for (i = 0; i < num; ++i) t2.table[lengths2[off + i]]++;
      t2.table[0] = 0;
      for (sum2 = 0, i = 0; i < 16; ++i) {
        offs[i] = sum2;
        sum2 += t2.table[i];
      }
      for (i = 0; i < num; ++i) {
        if (lengths2[off + i]) t2.trans[offs[lengths2[off + i]]++] = i;
      }
    }
    function tinf_getbit(d) {
      if (!d.bitcount--) {
        d.tag = d.source[d.sourceIndex++];
        d.bitcount = 7;
      }
      var bit = d.tag & 1;
      d.tag >>>= 1;
      return bit;
    }
    function tinf_read_bits(d, num, base) {
      if (!num)
        return base;
      while (d.bitcount < 24) {
        d.tag |= d.source[d.sourceIndex++] << d.bitcount;
        d.bitcount += 8;
      }
      var val = d.tag & 65535 >>> 16 - num;
      d.tag >>>= num;
      d.bitcount -= num;
      return val + base;
    }
    function tinf_decode_symbol(d, t2) {
      while (d.bitcount < 24) {
        d.tag |= d.source[d.sourceIndex++] << d.bitcount;
        d.bitcount += 8;
      }
      var sum2 = 0, cur = 0, len = 0;
      var tag = d.tag;
      do {
        cur = 2 * cur + (tag & 1);
        tag >>>= 1;
        ++len;
        sum2 += t2.table[len];
        cur -= t2.table[len];
      } while (cur >= 0);
      d.tag = tag;
      d.bitcount -= len;
      return t2.trans[sum2 + cur];
    }
    function tinf_decode_trees(d, lt, dt) {
      var hlit, hdist, hclen;
      var i, num, length2;
      hlit = tinf_read_bits(d, 5, 257);
      hdist = tinf_read_bits(d, 5, 1);
      hclen = tinf_read_bits(d, 4, 4);
      for (i = 0; i < 19; ++i) lengths[i] = 0;
      for (i = 0; i < hclen; ++i) {
        var clen = tinf_read_bits(d, 3, 0);
        lengths[clcidx[i]] = clen;
      }
      tinf_build_tree(code_tree, lengths, 0, 19);
      for (num = 0; num < hlit + hdist; ) {
        var sym = tinf_decode_symbol(d, code_tree);
        switch (sym) {
          case 16:
            var prev2 = lengths[num - 1];
            for (length2 = tinf_read_bits(d, 2, 3); length2; --length2) {
              lengths[num++] = prev2;
            }
            break;
          case 17:
            for (length2 = tinf_read_bits(d, 3, 3); length2; --length2) {
              lengths[num++] = 0;
            }
            break;
          case 18:
            for (length2 = tinf_read_bits(d, 7, 11); length2; --length2) {
              lengths[num++] = 0;
            }
            break;
          default:
            lengths[num++] = sym;
            break;
        }
      }
      tinf_build_tree(lt, lengths, 0, hlit);
      tinf_build_tree(dt, lengths, hlit, hdist);
    }
    function tinf_inflate_block_data(d, lt, dt) {
      while (1) {
        var sym = tinf_decode_symbol(d, lt);
        if (sym === 256) {
          return TINF_OK;
        }
        if (sym < 256) {
          d.dest[d.destLen++] = sym;
        } else {
          var length2, dist, offs2;
          var i;
          sym -= 257;
          length2 = tinf_read_bits(d, length_bits[sym], length_base[sym]);
          dist = tinf_decode_symbol(d, dt);
          offs2 = d.destLen - tinf_read_bits(d, dist_bits[dist], dist_base[dist]);
          for (i = offs2; i < offs2 + length2; ++i) {
            d.dest[d.destLen++] = d.dest[i];
          }
        }
      }
    }
    function tinf_inflate_uncompressed_block(d) {
      var length2, invlength;
      var i;
      while (d.bitcount > 8) {
        d.sourceIndex--;
        d.bitcount -= 8;
      }
      length2 = d.source[d.sourceIndex + 1];
      length2 = 256 * length2 + d.source[d.sourceIndex];
      invlength = d.source[d.sourceIndex + 3];
      invlength = 256 * invlength + d.source[d.sourceIndex + 2];
      if (length2 !== (~invlength & 65535))
        return TINF_DATA_ERROR;
      d.sourceIndex += 4;
      for (i = length2; i; --i)
        d.dest[d.destLen++] = d.source[d.sourceIndex++];
      d.bitcount = 0;
      return TINF_OK;
    }
    function tinf_uncompress(source, dest) {
      var d = new Data(source, dest);
      var bfinal, btype, res;
      do {
        bfinal = tinf_getbit(d);
        btype = tinf_read_bits(d, 2, 0);
        switch (btype) {
          case 0:
            res = tinf_inflate_uncompressed_block(d);
            break;
          case 1:
            res = tinf_inflate_block_data(d, sltree, sdtree);
            break;
          case 2:
            tinf_decode_trees(d, d.ltree, d.dtree);
            res = tinf_inflate_block_data(d, d.ltree, d.dtree);
            break;
          default:
            res = TINF_DATA_ERROR;
        }
        if (res !== TINF_OK)
          throw new Error("Data error");
      } while (!bfinal);
      if (d.destLen < d.dest.length) {
        if (typeof d.dest.slice === "function")
          return d.dest.slice(0, d.destLen);
        else
          return d.dest.subarray(0, d.destLen);
      }
      return d.dest;
    }
    tinf_build_fixed_trees(sltree, sdtree);
    tinf_build_bits_base(length_bits, length_base, 4, 3);
    tinf_build_bits_base(dist_bits, dist_base, 2, 1);
    length_bits[28] = 0;
    length_base[28] = 258;
    module2.exports = tinf_uncompress;
  }
});

// ../../node_modules/unicode-trie/swap.js
var require_swap = __commonJS({
  "../../node_modules/unicode-trie/swap.js"(exports2, module2) {
    var isBigEndian2 = new Uint8Array(new Uint32Array([305419896]).buffer)[0] === 18;
    var swap2 = (b, n2, m) => {
      let i = b[n2];
      b[n2] = b[m];
      b[m] = i;
    };
    var swap32 = (array4) => {
      const len = array4.length;
      for (let i = 0; i < len; i += 4) {
        swap2(array4, i, i + 3);
        swap2(array4, i + 1, i + 2);
      }
    };
    var swap32LE = (array4) => {
      if (isBigEndian2) {
        swap32(array4);
      }
    };
    module2.exports = {
      swap32LE
    };
  }
});

// ../../node_modules/unicode-trie/index.js
var require_unicode_trie = __commonJS({
  "../../node_modules/unicode-trie/index.js"(exports2, module2) {
    var inflate = require_tiny_inflate();
    var { swap32LE } = require_swap();
    var SHIFT_1 = 6 + 5;
    var SHIFT_2 = 5;
    var SHIFT_1_2 = SHIFT_1 - SHIFT_2;
    var OMITTED_BMP_INDEX_1_LENGTH = 65536 >> SHIFT_1;
    var INDEX_2_BLOCK_LENGTH = 1 << SHIFT_1_2;
    var INDEX_2_MASK = INDEX_2_BLOCK_LENGTH - 1;
    var INDEX_SHIFT = 2;
    var DATA_BLOCK_LENGTH = 1 << SHIFT_2;
    var DATA_MASK = DATA_BLOCK_LENGTH - 1;
    var LSCP_INDEX_2_OFFSET = 65536 >> SHIFT_2;
    var LSCP_INDEX_2_LENGTH = 1024 >> SHIFT_2;
    var INDEX_2_BMP_LENGTH = LSCP_INDEX_2_OFFSET + LSCP_INDEX_2_LENGTH;
    var UTF8_2B_INDEX_2_OFFSET = INDEX_2_BMP_LENGTH;
    var UTF8_2B_INDEX_2_LENGTH = 2048 >> 6;
    var INDEX_1_OFFSET = UTF8_2B_INDEX_2_OFFSET + UTF8_2B_INDEX_2_LENGTH;
    var DATA_GRANULARITY = 1 << INDEX_SHIFT;
    var UnicodeTrie = class {
      constructor(data2) {
        const isBuffer2 = typeof data2.readUInt32BE === "function" && typeof data2.slice === "function";
        if (isBuffer2 || data2 instanceof Uint8Array) {
          let uncompressedLength;
          if (isBuffer2) {
            this.highStart = data2.readUInt32LE(0);
            this.errorValue = data2.readUInt32LE(4);
            uncompressedLength = data2.readUInt32LE(8);
            data2 = data2.slice(12);
          } else {
            const view = new DataView(data2.buffer);
            this.highStart = view.getUint32(0, true);
            this.errorValue = view.getUint32(4, true);
            uncompressedLength = view.getUint32(8, true);
            data2 = data2.subarray(12);
          }
          data2 = inflate(data2, new Uint8Array(uncompressedLength));
          data2 = inflate(data2, new Uint8Array(uncompressedLength));
          swap32LE(data2);
          this.data = new Uint32Array(data2.buffer);
        } else {
          ({ data: this.data, highStart: this.highStart, errorValue: this.errorValue } = data2);
        }
      }
      get(codePoint) {
        let index3;
        if (codePoint < 0 || codePoint > 1114111) {
          return this.errorValue;
        }
        if (codePoint < 55296 || codePoint > 56319 && codePoint <= 65535) {
          index3 = (this.data[codePoint >> SHIFT_2] << INDEX_SHIFT) + (codePoint & DATA_MASK);
          return this.data[index3];
        }
        if (codePoint <= 65535) {
          index3 = (this.data[LSCP_INDEX_2_OFFSET + (codePoint - 55296 >> SHIFT_2)] << INDEX_SHIFT) + (codePoint & DATA_MASK);
          return this.data[index3];
        }
        if (codePoint < this.highStart) {
          index3 = this.data[INDEX_1_OFFSET - OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> SHIFT_1)];
          index3 = this.data[index3 + (codePoint >> SHIFT_2 & INDEX_2_MASK)];
          index3 = (index3 << INDEX_SHIFT) + (codePoint & DATA_MASK);
          return this.data[index3];
        }
        return this.data[this.data.length - DATA_GRANULARITY];
      }
    };
    module2.exports = UnicodeTrie;
  }
});

// ../../node_modules/dfa/index.js
var require_dfa = __commonJS({
  "../../node_modules/dfa/index.js"(exports2, module2) {
    "use strict";
    var INITIAL_STATE = 1;
    var FAIL_STATE = 0;
    var StateMachine = class {
      constructor(dfa) {
        this.stateTable = dfa.stateTable;
        this.accepting = dfa.accepting;
        this.tags = dfa.tags;
      }
      /**
       * Returns an iterable object that yields pattern matches over the input sequence.
       * Matches are of the form [startIndex, endIndex, tags].
       */
      match(str) {
        var self2 = this;
        return {
          *[Symbol.iterator]() {
            var state = INITIAL_STATE;
            var startRun = null;
            var lastAccepting = null;
            var lastState = null;
            for (var p = 0; p < str.length; p++) {
              var c = str[p];
              lastState = state;
              state = self2.stateTable[state][c];
              if (state === FAIL_STATE) {
                if (startRun != null && lastAccepting != null && lastAccepting >= startRun) {
                  yield [startRun, lastAccepting, self2.tags[lastState]];
                }
                state = self2.stateTable[INITIAL_STATE][c];
                startRun = null;
              }
              if (state !== FAIL_STATE && startRun == null) {
                startRun = p;
              }
              if (self2.accepting[state]) {
                lastAccepting = p;
              }
              if (state === FAIL_STATE) {
                state = INITIAL_STATE;
              }
            }
            if (startRun != null && lastAccepting != null && lastAccepting >= startRun) {
              yield [startRun, lastAccepting, self2.tags[state]];
            }
          }
        };
      }
      /**
       * For each match over the input sequence, action functions matching
       * the tag definitions in the input pattern are called with the startIndex,
       * endIndex, and sub-match sequence.
       */
      apply(str, actions) {
        for (var [start, end, tags] of this.match(str)) {
          for (var tag of tags) {
            if (typeof actions[tag] === "function") {
              actions[tag](start, end, str.slice(start, end + 1));
            }
          }
        }
      }
    };
    module2.exports = StateMachine;
  }
});

// ../../node_modules/clone/clone.js
var require_clone = __commonJS({
  "../../node_modules/clone/clone.js"(exports2, module2) {
    var clone = (function() {
      "use strict";
      function _instanceof(obj, type5) {
        return type5 != null && obj instanceof type5;
      }
      var nativeMap;
      try {
        nativeMap = Map;
      } catch (_) {
        nativeMap = function() {
        };
      }
      var nativeSet;
      try {
        nativeSet = Set;
      } catch (_) {
        nativeSet = function() {
        };
      }
      var nativePromise;
      try {
        nativePromise = Promise;
      } catch (_) {
        nativePromise = function() {
        };
      }
      function clone2(parent2, circular, depth, prototype, includeNonEnumerable) {
        if (typeof circular === "object") {
          depth = circular.depth;
          prototype = circular.prototype;
          includeNonEnumerable = circular.includeNonEnumerable;
          circular = circular.circular;
        }
        var allParents = [];
        var allChildren = [];
        var useBuffer = typeof Buffer != "undefined";
        if (typeof circular == "undefined")
          circular = true;
        if (typeof depth == "undefined")
          depth = Infinity;
        function _clone(parent3, depth2) {
          if (parent3 === null)
            return null;
          if (depth2 === 0)
            return parent3;
          var child;
          var proto;
          if (typeof parent3 != "object") {
            return parent3;
          }
          if (_instanceof(parent3, nativeMap)) {
            child = new nativeMap();
          } else if (_instanceof(parent3, nativeSet)) {
            child = new nativeSet();
          } else if (_instanceof(parent3, nativePromise)) {
            child = new nativePromise(function(resolve, reject) {
              parent3.then(function(value) {
                resolve(_clone(value, depth2 - 1));
              }, function(err) {
                reject(_clone(err, depth2 - 1));
              });
            });
          } else if (clone2.__isArray(parent3)) {
            child = [];
          } else if (clone2.__isRegExp(parent3)) {
            child = new RegExp(parent3.source, __getRegExpFlags(parent3));
            if (parent3.lastIndex) child.lastIndex = parent3.lastIndex;
          } else if (clone2.__isDate(parent3)) {
            child = new Date(parent3.getTime());
          } else if (useBuffer && Buffer.isBuffer(parent3)) {
            if (Buffer.allocUnsafe) {
              child = Buffer.allocUnsafe(parent3.length);
            } else {
              child = new Buffer(parent3.length);
            }
            parent3.copy(child);
            return child;
          } else if (_instanceof(parent3, Error)) {
            child = Object.create(parent3);
          } else {
            if (typeof prototype == "undefined") {
              proto = Object.getPrototypeOf(parent3);
              child = Object.create(proto);
            } else {
              child = Object.create(prototype);
              proto = prototype;
            }
          }
          if (circular) {
            var index3 = allParents.indexOf(parent3);
            if (index3 != -1) {
              return allChildren[index3];
            }
            allParents.push(parent3);
            allChildren.push(child);
          }
          if (_instanceof(parent3, nativeMap)) {
            parent3.forEach(function(value, key2) {
              var keyChild = _clone(key2, depth2 - 1);
              var valueChild = _clone(value, depth2 - 1);
              child.set(keyChild, valueChild);
            });
          }
          if (_instanceof(parent3, nativeSet)) {
            parent3.forEach(function(value) {
              var entryChild = _clone(value, depth2 - 1);
              child.add(entryChild);
            });
          }
          for (var i in parent3) {
            var attrs;
            if (proto) {
              attrs = Object.getOwnPropertyDescriptor(proto, i);
            }
            if (attrs && attrs.set == null) {
              continue;
            }
            child[i] = _clone(parent3[i], depth2 - 1);
          }
          if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(parent3);
            for (var i = 0; i < symbols.length; i++) {
              var symbol = symbols[i];
              var descriptor = Object.getOwnPropertyDescriptor(parent3, symbol);
              if (descriptor && !descriptor.enumerable && !includeNonEnumerable) {
                continue;
              }
              child[symbol] = _clone(parent3[symbol], depth2 - 1);
              if (!descriptor.enumerable) {
                Object.defineProperty(child, symbol, {
                  enumerable: false
                });
              }
            }
          }
          if (includeNonEnumerable) {
            var allPropertyNames = Object.getOwnPropertyNames(parent3);
            for (var i = 0; i < allPropertyNames.length; i++) {
              var propertyName = allPropertyNames[i];
              var descriptor = Object.getOwnPropertyDescriptor(parent3, propertyName);
              if (descriptor && descriptor.enumerable) {
                continue;
              }
              child[propertyName] = _clone(parent3[propertyName], depth2 - 1);
              Object.defineProperty(child, propertyName, {
                enumerable: false
              });
            }
          }
          return child;
        }
        return _clone(parent2, depth);
      }
      clone2.clonePrototype = function clonePrototype(parent2) {
        if (parent2 === null)
          return null;
        var c = function() {
        };
        c.prototype = parent2;
        return new c();
      };
      function __objToStr(o3) {
        return Object.prototype.toString.call(o3);
      }
      clone2.__objToStr = __objToStr;
      function __isDate(o3) {
        return typeof o3 === "object" && __objToStr(o3) === "[object Date]";
      }
      clone2.__isDate = __isDate;
      function __isArray(o3) {
        return typeof o3 === "object" && __objToStr(o3) === "[object Array]";
      }
      clone2.__isArray = __isArray;
      function __isRegExp(o3) {
        return typeof o3 === "object" && __objToStr(o3) === "[object RegExp]";
      }
      clone2.__isRegExp = __isRegExp;
      function __getRegExpFlags(re) {
        var flags = "";
        if (re.global) flags += "g";
        if (re.ignoreCase) flags += "i";
        if (re.multiline) flags += "m";
        return flags;
      }
      clone2.__getRegExpFlags = __getRegExpFlags;
      return clone2;
    })();
    if (typeof module2 === "object" && module2.exports) {
      module2.exports = clone;
    }
  }
});

// ../../node_modules/brotli/dec/streams.js
var require_streams = __commonJS({
  "../../node_modules/brotli/dec/streams.js"(exports2) {
    function BrotliInput(buffer) {
      this.buffer = buffer;
      this.pos = 0;
    }
    BrotliInput.prototype.read = function(buf, i, count) {
      if (this.pos + count > this.buffer.length) {
        count = this.buffer.length - this.pos;
      }
      for (var p = 0; p < count; p++)
        buf[i + p] = this.buffer[this.pos + p];
      this.pos += count;
      return count;
    };
    exports2.BrotliInput = BrotliInput;
    function BrotliOutput(buf) {
      this.buffer = buf;
      this.pos = 0;
    }
    BrotliOutput.prototype.write = function(buf, count) {
      if (this.pos + count > this.buffer.length)
        throw new Error("Output buffer is not large enough");
      this.buffer.set(buf.subarray(0, count), this.pos);
      this.pos += count;
      return count;
    };
    exports2.BrotliOutput = BrotliOutput;
  }
});

// ../../node_modules/brotli/dec/bit_reader.js
var require_bit_reader = __commonJS({
  "../../node_modules/brotli/dec/bit_reader.js"(exports2, module2) {
    var BROTLI_READ_SIZE = 4096;
    var BROTLI_IBUF_SIZE = 2 * BROTLI_READ_SIZE + 32;
    var BROTLI_IBUF_MASK = 2 * BROTLI_READ_SIZE - 1;
    var kBitMask = new Uint32Array([
      0,
      1,
      3,
      7,
      15,
      31,
      63,
      127,
      255,
      511,
      1023,
      2047,
      4095,
      8191,
      16383,
      32767,
      65535,
      131071,
      262143,
      524287,
      1048575,
      2097151,
      4194303,
      8388607,
      16777215
    ]);
    function BrotliBitReader(input) {
      this.buf_ = new Uint8Array(BROTLI_IBUF_SIZE);
      this.input_ = input;
      this.reset();
    }
    BrotliBitReader.READ_SIZE = BROTLI_READ_SIZE;
    BrotliBitReader.IBUF_MASK = BROTLI_IBUF_MASK;
    BrotliBitReader.prototype.reset = function() {
      this.buf_ptr_ = 0;
      this.val_ = 0;
      this.pos_ = 0;
      this.bit_pos_ = 0;
      this.bit_end_pos_ = 0;
      this.eos_ = 0;
      this.readMoreInput();
      for (var i = 0; i < 4; i++) {
        this.val_ |= this.buf_[this.pos_] << 8 * i;
        ++this.pos_;
      }
      return this.bit_end_pos_ > 0;
    };
    BrotliBitReader.prototype.readMoreInput = function() {
      if (this.bit_end_pos_ > 256) {
        return;
      } else if (this.eos_) {
        if (this.bit_pos_ > this.bit_end_pos_)
          throw new Error("Unexpected end of input " + this.bit_pos_ + " " + this.bit_end_pos_);
      } else {
        var dst = this.buf_ptr_;
        var bytes_read = this.input_.read(this.buf_, dst, BROTLI_READ_SIZE);
        if (bytes_read < 0) {
          throw new Error("Unexpected end of input");
        }
        if (bytes_read < BROTLI_READ_SIZE) {
          this.eos_ = 1;
          for (var p = 0; p < 32; p++)
            this.buf_[dst + bytes_read + p] = 0;
        }
        if (dst === 0) {
          for (var p = 0; p < 32; p++)
            this.buf_[(BROTLI_READ_SIZE << 1) + p] = this.buf_[p];
          this.buf_ptr_ = BROTLI_READ_SIZE;
        } else {
          this.buf_ptr_ = 0;
        }
        this.bit_end_pos_ += bytes_read << 3;
      }
    };
    BrotliBitReader.prototype.fillBitWindow = function() {
      while (this.bit_pos_ >= 8) {
        this.val_ >>>= 8;
        this.val_ |= this.buf_[this.pos_ & BROTLI_IBUF_MASK] << 24;
        ++this.pos_;
        this.bit_pos_ = this.bit_pos_ - 8 >>> 0;
        this.bit_end_pos_ = this.bit_end_pos_ - 8 >>> 0;
      }
    };
    BrotliBitReader.prototype.readBits = function(n_bits) {
      if (32 - this.bit_pos_ < n_bits) {
        this.fillBitWindow();
      }
      var val = this.val_ >>> this.bit_pos_ & kBitMask[n_bits];
      this.bit_pos_ += n_bits;
      return val;
    };
    module2.exports = BrotliBitReader;
  }
});

// ../../node_modules/brotli/dec/dictionary.bin.js
var require_dictionary_bin = __commonJS({
  "../../node_modules/brotli/dec/dictionary.bin.js"(exports2, module2) {
    module2.exports = "W5/fcQLn5gKf2XUbAiQ1XULX+TZz6ADToDsgqk6qVfeC0e4m6OO2wcQ1J76ZBVRV1fRkEsdu//62zQsFEZWSTCnMhcsQKlS2qOhuVYYMGCkV0fXWEoMFbESXrKEZ9wdUEsyw9g4bJlEt1Y6oVMxMRTEVbCIwZzJzboK5j8m4YH02qgXYhv1V+PM435sLVxyHJihaJREEhZGqL03txGFQLm76caGO/ovxKvzCby/3vMTtX/459f0igi7WutnKiMQ6wODSoRh/8Lx1V3Q99MvKtwB6bHdERYRY0hStJoMjNeTsNX7bn+Y7e4EQ3bf8xBc7L0BsyfFPK43dGSXpL6clYC/I328h54/VYrQ5i0648FgbGtl837svJ35L3Mot/+nPlNpWgKx1gGXQYqX6n+bbZ7wuyCHKcUok12Xjqub7NXZGzqBx0SD+uziNf87t7ve42jxSKQoW3nyxVrWIGlFShhCKxjpZZ5MeGna0+lBkk+kaN8F9qFBAFgEogyMBdcX/T1W/WnMOi/7ycWUQloEBKGeC48MkiwqJkJO+12eQiOFHMmck6q/IjWW3RZlany23TBm+cNr/84/oi5GGmGBZWrZ6j+zykVozz5fT/QH/Da6WTbZYYPynVNO7kxzuNN2kxKKWche5WveitPKAecB8YcAHz/+zXLjcLzkdDSktNIDwZE9J9X+tto43oJy65wApM3mDzYtCwX9lM+N5VR3kXYo0Z3t0TtXfgBFg7gU8oN0Dgl7fZlUbhNll+0uuohRVKjrEd8egrSndy5/Tgd2gqjA4CAVuC7ESUmL3DZoGnfhQV8uwnpi8EGvAVVsowNRxPudck7+oqAUDkwZopWqFnW1riss0t1z6iCISVKreYGNvQcXv+1L9+jbP8cd/dPUiqBso2q+7ZyFBvENCkkVr44iyPbtOoOoCecWsiuqMSML5lv+vN5MzUr+Dnh73G7Q1YnRYJVYXHRJaNAOByiaK6CusgFdBPE40r0rvqXV7tksKO2DrHYXBTv8P5ysqxEx8VDXUDDqkPH6NNOV/a2WH8zlkXRELSa8P+heNyJBBP7PgsG1EtWtNef6/i+lcayzQwQCsduidpbKfhWUDgAEmyhGu/zVTacI6RS0zTABrOYueemnVa19u9fT23N/Ta6RvTpof5DWygqreCqrDAgM4LID1+1T/taU6yTFVLqXOv+/MuQOFnaF8vLMKD7tKWDoBdALgxF33zQccCcdHx8fKIVdW69O7qHtXpeGr9jbbpFA+qRMWr5hp0s67FPc7HAiLV0g0/peZlW7hJPYEhZyhpSwahnf93/tZgfqZWXFdmdXBzqxGHLrQKxoAY6fRoBhgCRPmmGueYZ5JexTVDKUIXzkG/fqp/0U3hAgQdJ9zumutK6nqWbaqvm1pgu03IYR+G+8s0jDBBz8cApZFSBeuWasyqo2OMDKAZCozS+GWSvL/HsE9rHxooe17U3s/lTE+VZAk4j3dp6uIGaC0JMiqR5CUsabPyM0dOYDR7Ea7ip4USZlya38YfPtvrX/tBlhHilj55nZ1nfN24AOAi9BVtz/Mbn8AEDJCqJgsVUa6nQnSxv2Fs7l/NlCzpfYEjmPrNyib/+t0ei2eEMjvNhLkHCZlci4WhBe7ePZTmzYqlY9+1pxtS4GB+5lM1BHT9tS270EWUDYFq1I0yY/fNiAk4bk9yBgmef/f2k6AlYQZHsNFnW8wBQxCd68iWv7/35bXfz3JZmfGligWAKRjIs3IpzxQ27vAglHSiOzCYzJ9L9A1CdiyFvyR66ucA4jKifu5ehwER26yV7HjKqn5Mfozo7Coxxt8LWWPT47BeMxX8p0Pjb7hZn+6bw7z3Lw+7653j5sI8CLu5kThpMlj1m4c2ch3jGcP1FsT13vuK3qjecKTZk2kHcOZY40UX+qdaxstZqsqQqgXz+QGF99ZJLqr3VYu4aecl1Ab5GmqS8k/GV5b95zxQ5d4EfXUJ6kTS/CXF/aiqKDOT1T7Jz5z0PwDUcwr9clLN1OJGCiKfqvah+h3XzrBOiLOW8wvn8gW6qE8vPxi+Efv+UH55T7PQFVMh6cZ1pZQlzJpKZ7P7uWvwPGJ6DTlR6wbyj3Iv2HyefnRo/dv7dNx+qaa0N38iBsR++Uil7Wd4afwDNsrzDAK4fXZwvEY/jdKuIKXlfrQd2C39dW7ntnRbIp9OtGy9pPBn/V2ASoi/2UJZfS+xuGLH8bnLuPlzdTNS6zdyk8Dt/h6sfOW5myxh1f+zf3zZ3MX/mO9cQPp5pOx967ZA6/pqHvclNfnUFF+rq+Vd7alKr6KWPcIDhpn6v2K6NlUu6LrKo8b/pYpU/Gazfvtwhn7tEOUuXht5rUJdSf6sLjYf0VTYDgwJ81yaqKTUYej/tbHckSRb/HZicwGJqh1mAHB/IuNs9dc9yuvF3D5Xocm3elWFdq5oEy70dYFit79yaLiNjPj5UUcVmZUVhQEhW5V2Z6Cm4HVH/R8qlamRYwBileuh07CbEce3TXa2JmXWBf+ozt319psboobeZhVnwhMZzOeQJzhpTDbP71Tv8HuZxxUI/+ma3XW6DFDDs4+qmpERwHGBd2edxwUKlODRdUWZ/g0GOezrbzOZauFMai4QU6GVHV6aPNBiBndHSsV4IzpvUiiYyg6OyyrL4Dj5q/Lw3N5kAwftEVl9rNd7Jk5PDij2hTH6wIXnsyXkKePxbmHYgC8A6an5Fob/KH5GtC0l4eFso+VpxedtJHdHpNm+Bvy4C79yVOkrZsLrQ3OHCeB0Ra+kBIRldUGlDCEmq2RwXnfyh6Dz+alk6eftI2n6sastRrGwbwszBeDRS/Fa/KwRJkCzTsLr/JCs5hOPE/MPLYdZ1F1fv7D+VmysX6NpOC8aU9F4Qs6HvDyUy9PvFGDKZ/P5101TYHFl8pjj6wm/qyS75etZhhfg0UEL4OYmHk6m6dO192AzoIyPSV9QedDA4Ml23rRbqxMPMxf7FJnDc5FTElVS/PyqgePzmwVZ26NWhRDQ+oaT7ly7ell4s3DypS1s0g+tOr7XHrrkZj9+x/mJBttrLx98lFIaRZzHz4aC7r52/JQ4VjHahY2/YVXZn/QC2ztQb/sY3uRlyc5vQS8nLPGT/n27495i8HPA152z7Fh5aFpyn1GPJKHuPL8Iw94DuW3KjkURAWZXn4EQy89xiKEHN1mk/tkM4gYDBxwNoYvRfE6LFqsxWJtPrDGbsnLMap3Ka3MUoytW0cvieozOmdERmhcqzG+3HmZv2yZeiIeQTKGdRT4HHNxekm1tY+/n06rGmFleqLscSERzctTKM6G9P0Pc1RmVvrascIxaO1CQCiYPE15bD7c3xSeW7gXxYjgxcrUlcbIvO0r+Yplhx0kTt3qafDOmFyMjgGxXu73rddMHpV1wMubyAGcf/v5dLr5P72Ta9lBF+fzMJrMycwv+9vnU3ANIl1cH9tfW7af8u0/HG0vV47jNFXzFTtaha1xvze/s8KMtCYucXc1nzfd/MQydUXn/b72RBt5wO/3jRcMH9BdhC/yctKBIveRYPrNpDWqBsO8VMmP+WvRaOcA4zRMR1PvSoO92rS7pYEv+fZfEfTMzEdM+6X5tLlyxExhqLRkms5EuLovLfx66de5fL2/yX02H52FPVwahrPqmN/E0oVXnsCKhbi/yRxX83nRbUKWhzYceXOntfuXn51NszJ6MO73pQf5Pl4in3ec4JU8hF7ppV34+mm9r1LY0ee/i1O1wpd8+zfLztE0cqBxggiBi5Bu95v9l3r9r/U5hweLn+TbfxowrWDqdJauKd8+q/dH8sbPkc9ttuyO94f7/XK/nHX46MPFLEb5qQlNPvhJ50/59t9ft3LXu7uVaWaO2bDrDCnRSzZyWvFKxO1+vT8MwwunR3bX0CkfPjqb4K9O19tn5X50PvmYpEwHtiW9WtzuV/s76B1zvLLNkViNd8ySxIl/3orfqP90TyTGaf7/rx8jQzeHJXdmh/N6YDvbvmTBwCdxfEQ1NcL6wNMdSIXNq7b1EUzRy1/Axsyk5p22GMG1b+GxFgbHErZh92wuvco0AuOLXct9hvw2nw/LqIcDRRmJmmZzcgUa7JpM/WV/S9IUfbF56TL2orzqwebdRD8nIYNJ41D/hz37Fo11p2Y21wzPcn713qVGhqtevStYfGH4n69OEJtPvbbLYWvscDqc3Hgnu166+tAyLnxrX0Y5zoYjV++1sI7t5kMr02KT/+uwtkc+rZLOf/qn/s3nYCf13Dg8/sB2diJgjGqjQ+TLhxbzyue2Ob7X6/9lUwW7a+lbznHzOYy8LKW1C/uRPbQY3KW/0gO9LXunHLvPL97afba9bFtc9hmz7GAttjVYlCvQAiOwAk/gC5+hkLEs6tr3AZKxLJtOEwk2dLxTYWsIB/j/ToWtIWzo906FrSG8iaqqqqqqiIiIiAgzMzMzNz+AyK+01/zi8n8S+Y1MjoRaQ80WU/G8MBlO+53VPXANrWm4wzGUVZUjjBJZVdhpcfkjsmcWaO+UEldXi1e+zq+HOsCpknYshuh8pOLISJun7TN0EIGW2xTnlOImeecnoGW4raxe2G1T3HEvfYUYMhG+gAFOAwh5nK8mZhwJMmN7r224QVsNFvZ87Z0qatvknklyPDK3Hy45PgVKXji52Wen4d4PlFVVYGnNap+fSpFbK90rYnhUc6n91Q3AY9E0tJOFrcfZtm/491XbcG/jsViUPPX76qmeuiz+qY1Hk7/1VPM405zWVuoheLUimpWYdVzCmUdKHebMdzgrYrb8mL2eeLSnRWHdonfZa8RsOU9F37w+591l5FLYHiOqWeHtE/lWrBHcRKp3uhtr8yXm8LU/5ms+NM6ZKsqu90cFZ4o58+k4rdrtB97NADFbwmEG7lXqvirhOTOqU14xuUF2myIjURcPHrPOQ4lmM3PeMg7bUuk0nnZi67bXsU6H8lhqIo8TaOrEafCO1ARK9PjC0QOoq2BxmMdgYB9G/lIb9++fqNJ2s7BHGFyBNmZAR8J3KCo012ikaSP8BCrf6VI0X5xdnbhHIO+B5rbOyB54zXkzfObyJ4ecwxfqBJMLFc7m59rNcw7hoHnFZ0b00zee+gTqvjm61Pb4xn0kcDX4jvHM0rBXZypG3DCKnD/Waa/ZtHmtFPgO5eETx+k7RrVg3aSwm2YoNXnCs3XPQDhNn+Fia6IlOOuIG6VJH7TP6ava26ehKHQa2T4N0tcZ9dPCGo3ZdnNltsHQbeYt5vPnJezV/cAeNypdml1vCHI8M81nSRP5Qi2+mI8v/sxiZru9187nRtp3f/42NemcONa+4eVC3PCZzc88aZh851CqSsshe70uPxeN/dmYwlwb3trwMrN1Gq8jbnApcVDx/yDPeYs5/7r62tsQ6lLg+DiFXTEhzR9dHqv0iT4tgj825W+H3XiRUNUZT2kR9Ri0+lp+UM3iQtS8uOE23Ly4KYtvqH13jghUntJRAewuzNLDXp8RxdcaA3cMY6TO2IeSFRXezeWIjCqyhsUdMYuCgYTZSKpBype1zRfq8FshvfBPc6BAQWl7/QxIDp3VGo1J3vn42OEs3qznws+YLRXbymyB19a9XBx6n/owcyxlEYyFWCi+kG9F+EyD/4yn80+agaZ9P7ay2Dny99aK2o91FkfEOY8hBwyfi5uwx2y5SaHmG+oq/zl1FX/8irOf8Y3vAcX/6uLP6A6nvMO24edSGPjQc827Rw2atX+z2bKq0CmW9mOtYnr5/AfDa1ZfPaXnKtlWborup7QYx+Or2uWb+N3N//2+yDcXMqIJdf55xl7/vsj4WoPPlxLxtVrkJ4w/tTe3mLdATOOYwxcq52w5Wxz5MbPdVs5O8/lhfE7dPj0bIiPQ3QV0iqm4m3YX8hRfc6jQ3fWepevMqUDJd86Z4vwM40CWHnn+WphsGHfieF02D3tmZvpWD+kBpNCFcLnZhcmmrhpGzzbdA+sQ1ar18OJD87IOKOFoRNznaHPNHUfUNhvY1iU+uhvEvpKHaUn3qK3exVVyX4joipp3um7FmYJWmA+WbIDshRpbVRx5/nqstCgy87FGbfVB8yDGCqS+2qCsnRwnSAN6zgzxfdB2nBT/vZ4/6uxb6oH8b4VBRxiIB93wLa47hG3w2SL/2Z27yOXJFwZpSJaBYyvajA7vRRYNKqljXKpt/CFD/tSMr18DKKbwB0xggBePatl1nki0yvqW5zchlyZmJ0OTxJ3D+fsYJs/mxYN5+Le5oagtcl+YsVvy8kSjI2YGvGjvmpkRS9W2dtXqWnVuxUhURm1lKtou/hdEq19VBp9OjGvHEQSmrpuf2R24mXGheil8KeiANY8fW1VERUfBImb64j12caBZmRViZHbeVMjCrPDg9A90IXrtnsYCuZtRQ0PyrKDjBNOsPfKsg1pA02gHlVr0OXiFhtp6nJqXVzcbfM0KnzC3ggOENPE9VBdmHKN6LYaijb4wXxJn5A0FSDF5j+h1ooZx885Jt3ZKzO5n7Z5WfNEOtyyPqQEnn7WLv5Fis3PdgMshjF1FRydbNyeBbyKI1oN1TRVrVK7kgsb/zjX4NDPIRMctVeaxVB38Vh1x5KbeJbU138AM5KzmZu3uny0ErygxiJF7GVXUrPzFxrlx1uFdAaZFDN9cvIb74qD9tzBMo7L7WIEYK+sla1DVMHpF0F7b3+Y6S+zjvLeDMCpapmJo1weBWuxKF3rOocih1gun4BoJh1kWnV/Jmiq6uOhK3VfKxEHEkafjLgK3oujaPzY6SXg8phhL4TNR1xvJd1Wa0aYFfPUMLrNBDCh4AuGRTbtKMc6Z1Udj8evY/ZpCuMAUefdo69DZUngoqE1P9A3PJfOf7WixCEj+Y6t7fYeHbbxUAoFV3M89cCKfma3fc1+jKRe7MFWEbQqEfyzO2x/wrO2VYH7iYdQ9BkPyI8/3kXBpLaCpU7eC0Yv/am/tEDu7HZpqg0EvHo0nf/R/gRzUWy33/HXMJQeu1GylKmOkXzlCfGFruAcPPhaGqZOtu19zsJ1SO2Jz4Ztth5cBX6mRQwWmDwryG9FUMlZzNckMdK+IoMJv1rOWnBamS2w2KHiaPMPLC15hCZm4KTpoZyj4E2TqC/P6r7/EhnDMhKicZZ1ZwxuC7DPzDGs53q8gXaI9kFTK+2LTq7bhwsTbrMV8Rsfua5lMS0FwbTitUVnVa1yTb5IX51mmYnUcP9wPr8Ji1tiYJeJV9GZTrQhF7vvdU2OTU42ogJ9FDwhmycI2LIg++03C6scYhUyUuMV5tkw6kGUoL+mjNC38+wMdWNljn6tGPpRES7veqrSn5TRuv+dh6JVL/iDHU1db4c9WK3++OrH3PqziF916UMUKn8G67nN60GfWiHrXYhUG3yVWmyYak59NHj8t1smG4UDiWz2rPHNrKnN4Zo1LBbr2/eF9YZ0n0blx2nG4X+EKFxvS3W28JESD+FWk61VCD3z/URGHiJl++7TdBwkCj6tGOH3qDb0QqcOF9Kzpj0HUb/KyFW3Yhj2VMKJqGZleFBH7vqvf7WqLC3XMuHV8q8a4sTFuxUtkD/6JIBvKaVjv96ndgruKZ1k/BHzqf2K9fLk7HGXANyLDd1vxkK/i055pnzl+zw6zLnwXlVYVtfmacJgEpRP1hbGgrYPVN6v2lG+idQNGmwcKXu/8xEj/P6qe/sB2WmwNp6pp8jaISMkwdleFXYK55NHWLTTbutSUqjBfDGWo/Yg918qQ+8BRZSAHZbfuNZz2O0sov1Ue4CWlVg3rFhM3Kljj9ksGd/NUhk4nH+a5UN2+1i8+NM3vRNp7uQ6sqexSCukEVlVZriHNqFi5rLm9TMWa4qm3idJqppQACol2l4VSuvWLfta4JcXy3bROPNbXOgdOhG47LC0CwW/dMlSx4Jf17aEU3yA1x9p+Yc0jupXgcMuYNku64iYOkGToVDuJvlbEKlJqsmiHbvNrIVZEH+yFdF8DbleZ6iNiWwMqvtMp/mSpwx5KxRrT9p3MAPTHGtMbfvdFhyj9vhaKcn3At8Lc16Ai+vBcSp1ztXi7rCJZx/ql7TXcclq6Q76UeKWDy9boS0WHIjUuWhPG8LBmW5y2rhuTpM5vsLt+HOLh1Yf0DqXa9tsfC+kaKt2htA0ai/L2i7RKoNjEwztkmRU0GfgW1TxUvPFhg0V7DdfWJk5gfrccpYv+MA9M0dkGTLECeYwUixRzjRFdmjG7zdZIl3XKB9YliNKI31lfa7i2JG5C8Ss+rHe0D7Z696/V3DEAOWHnQ9yNahMUl5kENWS6pHKKp2D1BaSrrHdE1w2qNxIztpXgUIrF0bm15YML4b6V1k+GpNysTahKMVrrS85lTVo9OGJ96I47eAy5rYWpRf/mIzeoYU1DKaQCTUVwrhHeyNoDqHel+lLxr9WKzhSYw7vrR6+V5q0pfi2k3L1zqkubY6rrd9ZLvSuWNf0uqnkY+FpTvFzSW9Fp0b9l8JA7THV9eCi/PY/SCZIUYx3BU2alj7Cm3VV6eYpios4b6WuNOJdYXUK3zTqj5CVG2FqYM4Z7CuIU0qO05XR0d71FHM0YhZmJmTRfLlXEumN82BGtzdX0S19t1e+bUieK8zRmqpa4Qc5TSjifmaQsY2ETLjhI36gMR1+7qpjdXXHiceUekfBaucHShAOiFXmv3sNmGQyU5iVgnoocuonQXEPTFwslHtS8R+A47StI9wj0iSrtbi5rMysczFiImsQ+bdFClnFjjpXXwMy6O7qfjOr8Fb0a7ODItisjnn3EQO16+ypd1cwyaAW5Yzxz5QknfMO7643fXW/I9y3U2xH27Oapqr56Z/tEzglj6IbT6HEHjopiXqeRbe5mQQvxtcbDOVverN0ZgMdzqRYRjaXtMRd56Q4cZSmdPvZJdSrhJ1D9zNXPqAEqPIavPdfubt5oke2kmv0dztIszSv2VYuoyf1UuopbsYb+uX9h6WpwjpgtZ6fNNawNJ4q8O3CFoSbioAaOSZMx2GYaPYB+rEb6qjQiNRFQ76TvwNFVKD+BhH9VhcKGsXzmMI7BptU/CNWolM7YzROvpFAntsiWJp6eR2d3GarcYShVYSUqhmYOWj5E96NK2WvmYNTeY7Zs4RUEdv9h9QT4EseKt6LzLrqEOs3hxAY1MaNWpSa6zZx8F3YOVeCYMS88W+CYHDuWe4yoc6YK+djDuEOrBR5lvh0r+Q9uM88lrjx9x9AtgpQVNE8r+3O6Gvw59D+kBF/UMXyhliYUtPjmvXGY6Dk3x+kEOW+GtdMVC4EZTqoS/jmR0P0LS75DOc/w2vnri97M4SdbZ8qeU7gg8DVbERkU5geaMQO3mYrSYyAngeUQqrN0C0/vsFmcgWNXNeidsTAj7/4MncJR0caaBUpbLK1yBCBNRjEv6KvuVSdpPnEMJdsRRtqJ+U8tN1gXA4ePHc6ZT0eviI73UOJF0fEZ8YaneAQqQdGphNvwM4nIqPnXxV0xA0fnCT+oAhJuyw/q8jO0y8CjSteZExwBpIN6SvNp6A5G/abi6egeND/1GTguhuNjaUbbnSbGd4L8937Ezm34Eyi6n1maeOBxh3PI0jzJDf5mh/BsLD7F2GOKvlA/5gtvxI3/eV4sLfKW5Wy+oio+es/u6T8UU+nsofy57Icb/JlZHPFtCgd/x+bwt3ZT+xXTtTtTrGAb4QehC6X9G+8YT+ozcLxDsdCjsuOqwPFnrdLYaFc92Ui0m4fr39lYmlCaqTit7G6O/3kWDkgtXjNH4BiEm/+jegQnihOtfffn33WxsFjhfMd48HT+f6o6X65j7XR8WLSHMFkxbvOYsrRsF1bowDuSQ18Mkxk4qz2zoGPL5fu9h2Hqmt1asl3Q3Yu3szOc+spiCmX4AETBM3pLoTYSp3sVxahyhL8eC4mPN9k2x3o0xkiixIzM3CZFzf5oR4mecQ5+ax2wCah3/crmnHoqR0+KMaOPxRif1oEFRFOO/kTPPmtww+NfMXxEK6gn6iU32U6fFruIz8Q4WgljtnaCVTBgWx7diUdshC9ZEa5yKpRBBeW12r/iNc/+EgNqmhswNB8SBoihHXeDF7rrWDLcmt3V8GYYN7pXRy4DZjj4DJuUBL5iC3DQAaoo4vkftqVTYRGLS3mHZ7gdmdTTqbgNN/PTdTCOTgXolc88MhXAEUMdX0iy1JMuk5wLsgeu0QUYlz2S4skTWwJz6pOm/8ihrmgGfFgri+ZWUK2gAPHgbWa8jaocdSuM4FJYoKicYX/ZSENkg9Q1ZzJfwScfVnR2DegOGwCvmogaWJCLQepv9WNlU6QgsmOwICquU28Mlk3d9W5E81lU/5Ez0LcX6lwKMWDNluNKfBDUy/phJgBcMnfkh9iRxrdOzgs08JdPB85Lwo+GUSb4t3nC+0byqMZtO2fQJ4U2zGIr49t/28qmmGv2RanDD7a3FEcdtutkW8twwwlUSpb8QalodddbBfNHKDQ828BdE7OBgFdiKYohLawFYqpybQoxATZrheLhdI7+0Zlu9Q1myRcd15r9UIm8K2LGJxqTegntqNVMKnf1a8zQiyUR1rxoqjiFxeHxqFcYUTHfDu7rhbWng6qOxOsI+5A1p9mRyEPdVkTlE24vY54W7bWc6jMgZvNXdfC9/9q7408KDsbdL7Utz7QFSDetz2picArzrdpL8OaCHC9V26RroemtDZ5yNM/KGkWMyTmfnInEvwtSD23UcFcjhaE3VKzkoaEMKGBft4XbIO6forTY1lmGQwVmKicBCiArDzE+1oIxE08fWeviIOD5TznqH+OoHadvoOP20drMPe5Irg3XBQziW2XDuHYzjqQQ4wySssjXUs5H+t3FWYMHppUnBHMx/nYIT5d7OmjDbgD9F6na3m4l7KdkeSO3kTEPXafiWinogag7b52taiZhL1TSvBFmEZafFq2H8khQaZXuitCewT5FBgVtPK0j4xUHPfUz3Q28eac1Z139DAP23dgki94EC8vbDPTQC97HPPSWjUNG5tWKMsaxAEMKC0665Xvo1Ntd07wCLNf8Q56mrEPVpCxlIMVlQlWRxM3oAfpgIc+8KC3rEXUog5g06vt7zgXY8grH7hhwVSaeuvC06YYRAwpbyk/Unzj9hLEZNs2oxPQB9yc+GnL6zTgq7rI++KDJwX2SP8Sd6YzTuw5lV/kU6eQxRD12omfQAW6caTR4LikYkBB1CMOrvgRr/VY75+NSB40Cni6bADAtaK+vyxVWpf9NeKJxN2KYQ8Q2xPB3K1s7fuhvWbr2XpgW044VD6DRs0qXoqKf1NFsaGvKJc47leUV3pppP/5VTKFhaGuol4Esfjf5zyCyUHmHthChcYh4hYLQF+AFWsuq4t0wJyWgdwQVOZiV0efRHPoK5+E1vjz9wTJmVkITC9oEstAsyZSgE/dbicwKr89YUxKZI+owD205Tm5lnnmDRuP/JnzxX3gMtlrcX0UesZdxyQqYQuEW4R51vmQ5xOZteUd8SJruMlTUzhtVw/Nq7eUBcqN2/HVotgfngif60yKEtoUx3WYOZlVJuJOh8u59fzSDPFYtQgqDUAGyGhQOAvKroXMcOYY0qjnStJR/G3aP+Jt1sLVlGV8POwr/6OGsqetnyF3TmTqZjENfnXh51oxe9qVUw2M78EzAJ+IM8lZ1MBPQ9ZWSVc4J3mWSrLKrMHReA5qdGoz0ODRsaA+vwxXA2cAM4qlfzBJA6581m4hzxItQw5dxrrBL3Y6kCbUcFxo1S8jyV44q//+7ASNNudZ6xeaNOSIUffqMn4A9lIjFctYn2gpEPAb3f7p3iIBN8H14FUGQ9ct2hPsL+cEsTgUrR47uJVN4n4wt/wgfwwHuOnLd4yobkofy8JvxSQTA7rMpDIc608SlZFJfZYcmbT0tAHpPE8MrtQ42siTUNWxqvWZOmvu9f0JPoQmg+6l7sZWwyfi6PXkxJnwBraUG0MYG4zYHQz3igy/XsFkx5tNQxw43qvI9dU3f0DdhOUlHKjmi1VAr2Kiy0HZwD8VeEbhh0OiDdMYspolQsYdSwjCcjeowIXNZVUPmL2wwIkYhmXKhGozdCJ4lRKbsf4NBh/XnQoS92NJEWOVOFs2YhN8c5QZFeK0pRdAG40hqvLbmoSA8xQmzOOEc7wLcme9JOsjPCEgpCwUs9E2DohMHRhUeyGIN6TFvrbny8nDuilsDpzrH5mS76APoIEJmItS67sQJ+nfwddzmjPxcBEBBCw0kWDwd0EZCkNeOD7NNQhtBm7KHL9mRxj6U1yWU2puzlIDtpYxdH4ZPeXBJkTGAJfUr/oTCz/iypY6uXaR2V1doPxJYlrw2ghH0D5gbrhFcIxzYwi4a/4hqVdf2DdxBp6vGYDjavxMAAoy+1+3aiO6S3W/QAKNVXagDtvsNtx7Ks+HKgo6U21B+QSZgIogV5Bt+BnXisdVfy9VyXV+2P5fMuvdpAjM1o/K9Z+XnE4EOCrue+kcdYHqAQ0/Y/OmNlQ6OI33jH/uD1RalPaHpJAm2av0/xtpqdXVKNDrc9F2izo23Wu7firgbURFDNX9eGGeYBhiypyXZft2j3hTvzE6PMWKsod//rEILDkzBXfi7xh0eFkfb3/1zzPK/PI5Nk3FbZyTl4mq5BfBoVoqiPHO4Q4QKZAlrQ3MdNfi3oxIjvsM3kAFv3fdufurqYR3PSwX/mpGy/GFI/B2MNPiNdOppWVbs/gjF3YH+QA9jMhlAbhvasAHstB0IJew09iAkmXHl1/TEj+jvHOpOGrPRQXbPADM+Ig2/OEcUcpgPTItMtW4DdqgfYVI/+4hAFWYjUGpOP/UwNuB7+BbKOcALbjobdgzeBQfjgNSp2GOpxzGLj70Vvq5cw2AoYENwKLUtJUX8sGRox4dVa/TN4xKwaKcl9XawQR/uNus700Hf17pyNnezrUgaY9e4MADhEDBpsJT6y1gDJs1q6wlwGhuUzGR7C8kgpjPyHWwsvrf3yn1zJEIRa5eSxoLAZOCR9xbuztxFRJW9ZmMYfCFJ0evm9F2fVnuje92Rc4Pl6A8bluN8MZyyJGZ0+sNSb//DvAFxC2BqlEsFwccWeAl6CyBcQV1bx4mQMBP1Jxqk1EUADNLeieS2dUFbQ/c/kvwItbZ7tx0st16viqd53WsRmPTKv2AD8CUnhtPWg5aUegNpsYgasaw2+EVooeNKmrW3MFtj76bYHJm5K9gpAXZXsE5U8DM8XmVOSJ1F1WnLy6nQup+jx52bAb+rCq6y9WXl2B2oZDhfDkW7H3oYfT/4xx5VncBuxMXP2lNfhUVQjSSzSRbuZFE4vFawlzveXxaYKVs8LpvAb8IRYF3ZHiRnm0ADeNPWocwxSzNseG7NrSEVZoHdKWqaGEBz1N8Pt7kFbqh3LYmAbm9i1IChIpLpM5AS6mr6OAPHMwwznVy61YpBYX8xZDN/a+lt7n+x5j4bNOVteZ8lj3hpAHSx1VR8vZHec4AHO9XFCdjZ9eRkSV65ljMmZVzaej2qFn/qt1lvWzNZEfHxK3qOJrHL6crr0CRzMox5f2e8ALBB4UGFZKA3tN6F6IXd32GTJXGQ7DTi9j/dNcLF9jCbDcWGKxoKTYblIwbLDReL00LRcDPMcQuXLMh5YzgtfjkFK1DP1iDzzYYVZz5M/kWYRlRpig1htVRjVCknm+h1M5LiEDXOyHREhvzCGpFZjHS0RsK27o2avgdilrJkalWqPW3D9gmwV37HKmfM3F8YZj2ar+vHFvf3B8CRoH4kDHIK9mrAg+owiEwNjjd9V+FsQKYR8czJrUkf7Qoi2YaW6EVDZp5zYlqiYtuXOTHk4fAcZ7qBbdLDiJq0WNV1l2+Hntk1mMWvxrYmc8kIx8G3rW36J6Ra4lLrTOCgiOihmow+YnzUT19jbV2B3RWqSHyxkhmgsBqMYWvOcUom1jDQ436+fcbu3xf2bbeqU/ca+C4DOKE+e3qvmeMqW3AxejfzBRFVcwVYPq4L0APSWWoJu+5UYX4qg5U6YTioqQGPG9XrnuZ/BkxuYpe6Li87+18EskyQW/uA+uk2rpHpr6hut2TlVbKgWkFpx+AZffweiw2+VittkEyf/ifinS/0ItRL2Jq3tQOcxPaWO2xrG68GdFoUpZgFXaP2wYVtRc6xYCfI1CaBqyWpg4bx8OHBQwsV4XWMibZZ0LYjWEy2IxQ1mZrf1/UNbYCJplWu3nZ4WpodIGVA05d+RWSS+ET9tH3RfGGmNI1cIY7evZZq7o+a0bjjygpmR3mVfalkT/SZGT27Q8QGalwGlDOS9VHCyFAIL0a1Q7JiW3saz9gqY8lqKynFrPCzxkU4SIfLc9VfCI5edgRhDXs0edO992nhTKHriREP1NJC6SROMgQ0xO5kNNZOhMOIT99AUElbxqeZF8A3xrfDJsWtDnUenAHdYWSwAbYjFqQZ+D5gi3hNK8CSxU9i6f6ClL9IGlj1OPMQAsr84YG6ijsJpCaGWj75c3yOZKBB9mNpQNPUKkK0D6wgLH8MGoyRxTX6Y05Q4AnYNXMZwXM4eij/9WpsM/9CoRnFQXGR6MEaY+FXvXEO3RO0JaStk6OXuHVATHJE+1W+TU3bSZ2ksMtqjO0zfSJCdBv7y2d8DMx6TfVme3q0ZpTKMMu4YL/t7ciTNtdDkwPogh3Cnjx7qk08SHwf+dksZ7M2vCOlfsF0hQ6J4ehPCaHTNrM/zBSOqD83dBEBCW/F/LEmeh0nOHd7oVl3/Qo/9GUDkkbj7yz+9cvvu+dDAtx8NzCDTP4iKdZvk9MWiizvtILLepysflSvTLFBZ37RLwiriqyRxYv/zrgFd/9XVHh/OmzBvDX4mitMR/lUavs2Vx6cR94lzAkplm3IRNy4TFfu47tuYs9EQPIPVta4P64tV+sZ7n3ued3cgEx2YK+QL5+xms6osk8qQbTyuKVGdaX9FQqk6qfDnT5ykxk0VK7KZ62b6DNDUfQlqGHxSMKv1P0XN5BqMeKG1P4Wp5QfZDUCEldppoX0U6ss2jIko2XpURKCIhfaOqLPfShdtS37ZrT+jFRSH2xYVV1rmT/MBtRQhxiO4MQ3iAGlaZi+9PWBEIXOVnu9jN1f921lWLZky9bqbM3J2MAAI9jmuAx3gyoEUa6P2ivs0EeNv/OR+AX6q5SW6l5HaoFuS6jr6yg9limu+P0KYKzfMXWcQSfTXzpOzKEKpwI3YGXZpSSy2LTlMgfmFA3CF6R5c9xWEtRuCg2ZPUQ2Nb6dRFTNd4TfGHrnEWSKHPuRyiJSDAZ+KX0VxmSHjGPbQTLVpqixia2uyhQ394gBMt7C3ZAmxn/DJS+l1fBsAo2Eir/C0jG9csd4+/tp12pPc/BVJGaK9mfvr7M/CeztrmCO5qY06Edi4xAGtiEhnWAbzLy2VEyazE1J5nPmgU4RpW4Sa0TnOT6w5lgt3/tMpROigHHmexBGAMY0mdcDbDxWIz41NgdD6oxgHsJRgr5RnT6wZAkTOcStU4NMOQNemSO7gxGahdEsC+NRVGxMUhQmmM0llWRbbmFGHzEqLM4Iw0H7577Kyo+Zf+2cUFIOw93gEY171vQaM0HLwpjpdRR6Jz7V0ckE7XzYJ0TmY9znLdzkva0vNrAGGT5SUZ5uaHDkcGvI0ySpwkasEgZPMseYcu85w8HPdSNi+4T6A83iAwDbxgeFcB1ZM2iGXzFcEOUlYVrEckaOyodfvaYSQ7GuB4ISE0nYJc15X/1ciDTPbPCgYJK55VkEor4LvzL9S2WDy4xj+6FOqVyTAC2ZNowheeeSI5hA/02l8UYkv4nk9iaVn+kCVEUstgk5Hyq+gJm6R9vG3rhuM904he/hFmNQaUIATB1y3vw+OmxP4X5Yi6A5I5jJufHCjF9+AGNwnEllZjUco6XhsO5T5+R3yxz5yLVOnAn0zuS+6zdj0nTJbEZCbXJdtpfYZfCeCOqJHoE2vPPFS6eRLjIJlG69X93nfR0mxSFXzp1Zc0lt/VafDaImhUMtbnqWVb9M4nGNQLN68BHP7AR8Il9dkcxzmBv8PCZlw9guY0lurbBsmNYlwJZsA/B15/HfkbjbwPddaVecls/elmDHNW2r4crAx43feNkfRwsaNq/yyJ0d/p5hZ6AZajz7DBfUok0ZU62gCzz7x8eVfJTKA8IWn45vINLSM1q+HF9CV9qF3zP6Ml21kPPL3CXzkuYUlnSqT+Ij4tI/od5KwIs+tDajDs64owN7tOAd6eucGz+KfO26iNcBFpbWA5732bBNWO4kHNpr9D955L61bvHCF/mwSrz6eQaDjfDEANqGMkFc+NGxpKZzCD2sj/JrHd+zlPQ8Iz7Q+2JVIiVCuCKoK/hlAEHzvk/Piq3mRL1rT/fEh9hoT5GJmeYswg1otiKydizJ/fS2SeKHVu6Z3JEHjiW8NaTQgP5xdBli8nC57XiN9hrquBu99hn9zqwo92+PM2JXtpeVZS0PdqR5mDyDreMMtEws+CpwaRyyzoYtfcvt9PJIW0fJVNNi/FFyRsea7peLvJrL+5b4GOXJ8tAr+ATk9f8KmiIsRhqRy0vFzwRV3Z5dZ3QqIU8JQ/uQpkJbjMUMFj2F9sCFeaBjI4+fL/oN3+LQgjI4zuAfQ+3IPIPFQBccf0clJpsfpnBxD84atwtupkGqKvrH7cGNl/QcWcSi6wcVDML6ljOgYbo+2BOAWNNjlUBPiyitUAwbnhFvLbnqw42kR3Yp2kv2dMeDdcGOX5kT4S6M44KHEB/SpCfl7xgsUvs+JNY9G3O2X/6FEt9FyAn57lrbiu+tl83sCymSvq9eZbe9mchL7MTf/Ta78e80zSf0hYY5eUU7+ff14jv7Xy8qjzfzzzvaJnrIdvFb5BLWKcWGy5/w7+vV2cvIfwHqdTB+RuJK5oj9mbt0Hy94AmjMjjwYNZlNS6uiyxNnwNyt3gdreLb64p/3+08nXkb92LTkkRgFOwk1oGEVllcOj5lv1hfAZywDows0944U8vUFw+A/nuVq/UCygsrmWIBnHyU01d0XJPwriEOvx/ISK6Pk4y2w0gmojZs7lU8TtakBAdne4v/aNxmMpK4VcGMp7si0yqsiolXRuOi1Z1P7SqD3Zmp0CWcyK4Ubmp2SXiXuI5nGLCieFHKHNRIlcY3Pys2dwMTYCaqlyWSITwr2oGXvyU3h1Pf8eQ3w1bnD7ilocVjYDkcXR3Oo1BXgMLTUjNw2xMVwjtp99NhSVc5aIWrDQT5DHPKtCtheBP4zHcw4dz2eRdTMamhlHhtfgqJJHI7NGDUw1XL8vsSeSHyKqDtqoAmrQqsYwvwi7HW3ojWyhIa5oz5xJTaq14NAzFLjVLR12rRNUQ6xohDnrWFb5bG9yf8aCD8d5phoackcNJp+Dw3Due3RM+5Rid7EuIgsnwgpX0rUWh/nqPtByMhMZZ69NpgvRTKZ62ViZ+Q7Dp5r4K0d7EfJuiy06KuIYauRh5Ecrhdt2QpTS1k1AscEHvapNbU3HL1F2TFyR33Wxb5MvH5iZsrn3SDcsxlnnshO8PLwmdGN+paWnQuORtZGX37uhFT64SeuPsx8UOokY6ON85WdQ1dki5zErsJGazcBOddWJEKqNPiJpsMD1GrVLrVY+AOdPWQneTyyP1hRX/lMM4ZogGGOhYuAdr7F/DOiAoc++cn5vlf0zkMUJ40Z1rlgv9BelPqVOpxKeOpzKdF8maK+1Vv23MO9k/8+qpLoxrIGH2EDQlnGmH8CD31G8QqlyQIcpmR5bwmSVw9/Ns6IHgulCRehvZ/+VrM60Cu/r3AontFfrljew74skYe2uyn7JKQtFQBQRJ9ryGic/zQOsbS4scUBctA8cPToQ3x6ZBQu6DPu5m1bnCtP8TllLYA0UTQNVqza5nfew3Mopy1GPUwG5jsl0OVXniPmAcmLqO5HG8Hv3nSLecE9oOjPDXcsTxoCBxYyzBdj4wmnyEV4kvFDunipS8SSkvdaMnTBN9brHUR8xdmmEAp/Pdqk9uextp1t+JrtXwpN/MG2w/qhRMpSNxQ1uhg/kKO30eQ/FyHUDkWHT8V6gGRU4DhDMxZu7xXij9Ui6jlpWmQCqJg3FkOTq3WKneCRYZxBXMNAVLQgHXSCGSqNdjebY94oyIpVjMYehAiFx/tqzBXFHZaL5PeeD74rW5OysFoUXY8sebUZleFTUa/+zBKVTFDopTReXNuZq47QjkWnxjirCommO4L/GrFtVV21EpMyw8wyThL5Y59d88xtlx1g1ttSICDwnof6lt/6zliPzgVUL8jWBjC0o2D6Kg+jNuThkAlaDJsq/AG2aKA//A76avw2KNqtv223P+Wq3StRDDNKFFgtsFukYt1GFDWooFVXitaNhb3RCyJi4cMeNjROiPEDb4k+G3+hD8tsg+5hhmSc/8t2JTSwYoCzAI75doq8QTHe+E/Tw0RQSUDlU+6uBeNN3h6jJGX/mH8oj0i3caCNsjvTnoh73BtyZpsflHLq6AfwJNCDX4S98h4+pCOhGKDhV3rtkKHMa3EG4J9y8zFWI4UsfNzC/Rl5midNn7gwoN9j23HGCQQ+OAZpTTPMdiVow740gIyuEtd0qVxMyNXhHcnuXRKdw5wDUSL358ktjMXmAkvIB73BLa1vfF9BAUZInPYJiwxqFWQQBVk7gQH4ojfUQ/KEjn+A/WR6EEe4CtbpoLe1mzHkajgTIoE0SLDHVauKhrq12zrAXBGbPPWKCt4DGedq3JyGRbmPFW32bE7T20+73BatV/qQhhBWfWBFHfhYWXjALts38FemnoT+9bn1jDBMcUMmYgSc0e7GQjv2MUBwLU8ionCpgV+Qrhg7iUIfUY6JFxR0Y+ZTCPM+rVuq0GNLyJXX6nrUTt8HzFBRY1E/FIm2EeVA9NcXrj7S6YYIChVQCWr/m2fYUjC4j0XLkzZ8GCSLfmkW3PB/xq+nlXsKVBOj7vTvqKCOMq7Ztqr3cQ+N8gBnPaAps+oGwWOkbuxnRYj/x/WjiDclVrs22xMK4qArE1Ztk1456kiJriw6abkNeRHogaPRBgbgF9Z8i/tbzWELN4CvbqtrqV9TtGSnmPS2F9kqOIBaazHYaJ9bi3AoDBvlZasMluxt0BDXfhp02Jn411aVt6S4TUB8ZgFDkI6TP6gwPY85w+oUQSsjIeXVminrwIdK2ZAawb8Se6XOJbOaliQxHSrnAeONDLuCnFejIbp4YDtBcQCwMsYiRZfHefuEJqJcwKTTJ8sx5hjHmJI1sPFHOr6W9AhZ2NAod38mnLQk1gOz2LCAohoQbgMbUK9RMEA3LkiF7Sr9tLZp6lkciIGhE2V546w3Mam53VtVkGbB9w0Yk2XiRnCmbpxmHr2k4eSC0RuNbjNsUfDIfc8DZvRvgUDe1IlKdZTzcT4ZGEb53dp8VtsoZlyXzLHOdAbsp1LPTVaHvLA0GYDFMbAW/WUBfUAdHwqLFAV+3uHvYWrCfhUOR2i89qvCBoOb48usAGdcF2M4aKn79k/43WzBZ+xR1L0uZfia70XP9soQReeuhZiUnXFDG1T8/OXNmssTSnYO+3kVLAgeiY719uDwL9FQycgLPessNihMZbAKG7qwPZyG11G1+ZA3jAX2yddpYfmaKBlmfcK/V0mwIRUDC0nJSOPUl2KB8h13F4dlVZiRhdGY5farwN+f9hEb1cRi41ZcGDn6Xe9MMSTOY81ULJyXIHSWFIQHstVYLiJEiUjktlHiGjntN5/btB8Fu+vp28zl2fZXN+dJDyN6EXhS+0yzqpl/LSJNEUVxmu7BsNdjAY0jVsAhkNuuY0E1G48ej25mSt+00yPbQ4SRCVkIwb6ISvYtmJRPz9Zt5dk76blf+lJwAPH5KDF+vHAmACLoCdG2Adii6dOHnNJnTmZtoOGO8Q1jy1veMw6gbLFToQmfJa7nT7Al89mRbRkZZQxJTKgK5Kc9INzmTJFp0tpAPzNmyL/F08bX3nhCumM/cR/2RPn9emZ3VljokttZD1zVWXlUIqEU7SLk5I0lFRU0AcENXBYazNaVzsVHA/sD3o9hm42wbHIRb/BBQTKzAi8s3+bMtpOOZgLdQzCYPfX3UUxKd1WYVkGH7lh/RBBgMZZwXzU9+GYxdBqlGs0LP+DZ5g2BWNh6FAcR944B+K/JTWI3t9YyVyRhlP4CCoUk/mmF7+r2pilVBjxXBHFaBfBtr9hbVn2zDuI0kEOG3kBx8CGdPOjX1ph1POOZJUO1JEGG0jzUy2tK4X0CgVNYhmkqqQysRNtKuPdCJqK3WW57kaV17vXgiyPrl4KEEWgiGF1euI4QkSFHFf0TDroQiLNKJiLbdhH0YBhriRNCHPxSqJmNNoketaioohqMglh6wLtEGWSM1EZbQg72h0UJAIPVFCAJOThpQGGdKfFovcwEeiBuZHN2Ob4uVM7+gwZLz1D9E7ta4RmMZ24OBBAg7Eh6dLXGofZ4U2TFOCQMKjwhVckjrydRS+YaqCw1kYt6UexuzbNEDyYLTZnrY1PzsHZJT4U+awO2xlqTSYu6n/U29O2wPXgGOEKDMSq+zTUtyc8+6iLp0ivav4FKx+xxVy4FxhIF/pucVDqpsVe2jFOfdZhTzLz2QjtzvsTCvDPU7bzDH2eXVKUV9TZ+qFtaSSxnYgYdXKwVreIgvWhT9eGDB2OvnWyPLfIIIfNnfIxU8nW7MbcH05nhlsYtaW9EZRsxWcKdEqInq1DiZPKCz7iGmAU9/ccnnQud2pNgIGFYOTAWjhIrd63aPDgfj8/sdlD4l+UTlcxTI9jbaMqqN0gQxSHs60IAcW3cH4p3V1aSciTKB29L1tz2eUQhRiTgTvmqc+sGtBNh4ky0mQJGsdycBREP+fAaSs1EREDVo5gvgi5+aCN7NECw30owbCc1mSpjiahyNVwJd1jiGgzSwfTpzf2c5XJvG/g1n0fH88KHNnf+u7ZiRMlXueSIsloJBUtW9ezvsx9grfsX/FNxnbxU1Lvg0hLxixypHKGFAaPu0xCD8oDTeFSyfRT6s8109GMUZL8m2xXp8X2dpPCWWdX84iga4BrTlOfqox4shqEgh/Ht4qRst52cA1xOIUuOxgfUivp6v5f8IVyaryEdpVk72ERAwdT4aoY1usBgmP+0m06Q216H/nubtNYxHaOIYjcach3A8Ez/zc0KcShhel0HCYjFsA0FjYqyJ5ZUH1aZw3+zWC0hLpM6GDfcAdn9fq2orPmZbW6XXrf+Krc9RtvII5jeD3dFoT1KwZJwxfUMvc5KLfn8rROW23Jw89sJ2a5dpB3qWDUBWF2iX8OCuKprHosJ2mflBR+Wqs86VvgI/XMnsqb97+VlKdPVysczPj8Jhzf+WCvGBHijAqYlavbF60soMWlHbvKT+ScvhprgeTln51xX0sF+Eadc/l2s2a5BgkVbHYyz0E85p0LstqH+gEGiR84nBRRFIn8hLSZrGwqjZ3E29cuGi+5Z5bp7EM8MWFa9ssS/vy4VrDfECSv7DSU84DaP0sXI3Ap4lWznQ65nQoTKRWU30gd7Nn8ZowUvGIx4aqyXGwmA/PB4qN8msJUODezUHEl0VP9uo+cZ8vPFodSIB4C7lQYjEFj8yu49C2KIV3qxMFYTevG8KqAr0TPlkbzHHnTpDpvpzziAiNFh8xiT7C/TiyH0EguUw4vxAgpnE27WIypV+uFN2zW7xniF/n75trs9IJ5amB1zXXZ1LFkJ6GbS/dFokzl4cc2mamVwhL4XU0Av5gDWAl+aEWhAP7t2VIwU+EpvfOPDcLASX7H7lZpXA2XQfbSlD4qU18NffNPoAKMNSccBfO9YVVgmlW4RydBqfHAV7+hrZ84WJGho6bNT0YMhxxLdOx/dwGj0oyak9aAkNJ8lRJzUuA8sR+fPyiyTgUHio5+Pp+YaKlHrhR41jY5NESPS3x+zTMe0S2HnLOKCOQPpdxKyviBvdHrCDRqO+l96HhhNBLXWv4yEMuEUYo8kXnYJM8oIgVM4XJ+xXOev4YbWeqsvgq0lmw4/PiYr9sYLt+W5EAuYSFnJEan8CwJwbtASBfLBBpJZiRPor/aCJBZsM+MhvS7ZepyHvU8m5WSmaZnxuLts8ojl6KkS8oSAHkq5GWlCB/NgJ5W3rO2Cj1MK7ahxsCrbTT3a0V/QQH+sErxV4XUWDHx0kkFy25bPmBMBQ6BU3HoHhhYcJB9JhP6NXUWKxnE0raXHB6U9KHpWdQCQI72qevp5fMzcm+AvC85rsynVQhruDA9fp9COe7N56cg1UKGSas89vrN+WlGLYTwi5W+0xYdKEGtGCeNJwXKDU0XqU5uQYnWsMwTENLGtbQMvoGjIFIEMzCRal4rnBAg7D/CSn8MsCvS+FDJJAzoiioJEhZJgAp9n2+1Yznr7H+6eT4YkJ9Mpj60ImcW4i4iHDLn9RydB8dx3QYm3rsX6n4VRrZDsYK6DCGwkwd5n3/INFEpk16fYpP6JtMQpqEMzcOfQGAHXBTEGzuLJ03GYQL9bmV2/7ExDlRf+Uvf1sM2frRtCWmal12pMgtonvSCtR4n1CLUZRdTHDHP1Otwqd+rcdlavnKjUB/OYXQHUJzpNyFoKpQK+2OgrEKpGyIgIBgn2y9QHnTJihZOpEvOKIoHAMGAXHmj21Lym39Mbiow4IF+77xNuewziNVBxr6KD5e+9HzZSBIlUa/AmsDFJFXeyrQakR3FwowTGcADJHcEfhGkXYNGSYo4dh4bxwLM+28xjiqkdn0/3R4UEkvcBrBfn/SzBc1XhKM2VPlJgKSorjDac96V2UnQYXl1/yZPT4DVelgO+soMjexXwYO58VLl5xInQUZI8jc3H2CPnCNb9X05nOxIy4MlecasTqGK6s2az4RjpF2cQP2G28R+7wDPsZDZC/kWtjdoHC7SpdPmqQrUAhMwKVuxCmYTiD9q/O7GHtZvPSN0CAUQN/rymXZNniYLlJDE70bsk6Xxsh4kDOdxe7A2wo7P9F5YvqqRDI6brf79yPCSp4I0jVoO4YnLYtX5nzspR5WB4AKOYtR1ujXbOQpPyYDvfRE3FN5zw0i7reehdi7yV0YDRKRllGCGRk5Yz+Uv1fYl2ZwrnGsqsjgAVo0xEUba8ohjaNMJNwTwZA/wBDWFSCpg1eUH8MYL2zdioxRTqgGQrDZxQyNzyBJPXZF0+oxITJAbj7oNC5JwgDMUJaM5GqlGCWc//KCIrI+aclEe4IA0uzv7cuj6GCdaJONpi13O544vbtIHBF+A+JeDFUQNy61Gki3rtyQ4aUywn6ru314/dkGiP8Iwjo0J/2Txs49ZkwEl4mx+iYUUO55I6pJzU4P+7RRs+DXZkyKUYZqVWrPF4I94m4Wx1tXeE74o9GuX977yvJ/jkdak8+AmoHVjI15V+WwBdARFV2IPirJgVMdsg1Pez2VNHqa7EHWdTkl3XTcyjG9BiueWFvQfXI8aWSkuuRmqi/HUuzqyvLJfNfs0txMqldYYflWB1BS31WkuPJGGwXUCpjiQSktkuBMWwHjSkQxeehqw1Kgz0Trzm7QbtgxiEPDVmWCNCAeCfROTphd1ZNOhzLy6XfJyG6Xgd5MCAZw4xie0Sj5AnY1/akDgNS9YFl3Y06vd6FAsg2gVQJtzG7LVq1OH2frbXNHWH/NY89NNZ4QUSJqL2yEcGADbT38X0bGdukqYlSoliKOcsSTuqhcaemUeYLLoI8+MZor2RxXTRThF1LrHfqf/5LcLAjdl4EERgUysYS2geE+yFdasU91UgUDsc2cSQ1ZoT9+uLOwdgAmifwQqF028INc2IQEDfTmUw3eZxvz7Ud1z3xc1PQfeCvfKsB9jOhRj7rFyb9XcDWLcYj0bByosychMezMLVkFiYcdBBQtvI6K0KRuOZQH2kBsYHJaXTkup8F0eIhO1/GcIwWKpr2mouB7g5TUDJNvORXPXa/mU8bh27TAZYBe2sKx4NSv5OjnHIWD2RuysCzBlUfeNXhDd2jxnHoUlheJ3jBApzURy0fwm2FwwsSU0caQGl0Kv8hopRQE211NnvtLRsmCNrhhpEDoNiZEzD2QdJWKbRRWnaFedXHAELSN0t0bfsCsMf0ktfBoXBoNA+nZN9+pSlmuzspFevmsqqcMllzzvkyXrzoA+Ryo1ePXpdGOoJvhyru+EBRsmOp7MXZ0vNUMUqHLUoKglg1p73sWeZmPc+KAw0pE2zIsFFE5H4192KwDvDxdxEYoDBDNZjbg2bmADTeUKK57IPD4fTYF4c6EnXx/teYMORBDtIhPJneiZny7Nv/zG+YmekIKCoxr6kauE2bZtBLufetNG0BtBY7f+/ImUypMBvdWu/Q7vTMRzw5aQGZWuc1V0HEsItFYMIBnoKGZ0xcarba/TYZq50kCaflFysYjA4EDKHqGdpYWdKYmm+a7TADmW35yfnOYpZYrkpVEtiqF0EujI00aeplNs2k+qyFZNeE3CDPL9P6b4PQ/kataHkVpLSEVGK7EX6rAa7IVNrvZtFvOA6okKvBgMtFDAGZOx88MeBcJ8AR3AgUUeIznAN6tjCUipGDZONm1FjWJp4A3QIzSaIOmZ7DvF/ysYYbM/fFDOV0jntAjRdapxJxL0eThpEhKOjCDDq2ks+3GrwxqIFKLe1WdOzII8XIOPGnwy6LKXVfpSDOTEfaRsGujhpS4hBIsMOqHbl16PJxc4EkaVu9wpEYlF/84NSv5Zum4drMfp9yXbzzAOJqqS4YkI4cBrFrC7bMPiCfgI3nNZAqkk3QOZqR+yyqx+nDQKBBBZ7QKrfGMCL+XpqFaBJU0wpkBdAhbR4hJsmT5aynlvkouoxm/NjD5oe6BzVIO9uktM+/5dEC5P7vZvarmuO/lKXz4sBabVPIATuKTrwbJP8XUkdM6uEctHKXICUJGjaZIWRbZp8czquQYfY6ynBUCfIU+gG6wqSIBmYIm9pZpXdaL121V7q0VjDjmQnXvMe7ysoEZnZL15B0SpxS1jjd83uNIOKZwu5MPzg2NhOx3xMOPYwEn2CUzbSrwAs5OAtrz3GAaUkJOU74XwjaYUmGJdZBS1NJVkGYrToINLKDjxcuIlyfVsKQSG/G4DyiO2SlQvJ0d0Ot1uOG5IFSAkq+PRVMgVMDvOIJMdqjeCFKUGRWBW9wigYvcbU7CQL/7meF2KZAaWl+4y9uhowAX7elogAvItAAxo2+SFxGRsHGEW9BnhlTuWigYxRcnVUBRQHV41LV+Fr5CJYV7sHfeywswx4XMtUx6EkBhR+q8AXXUA8uPJ73Pb49i9KG9fOljvXeyFj9ixgbo6CcbAJ7WHWqKHy/h+YjBwp6VcN7M89FGzQ04qbrQtgrOFybg3gQRTYG5xn73ArkfQWjCJROwy3J38Dx/D7jOa6BBNsitEw1wGq780EEioOeD+ZGp2J66ADiVGMayiHYucMk8nTK2zzT9CnEraAk95kQjy4k0GRElLL5YAKLQErJ5rp1eay9O4Fb6yJGm9U4FaMwPGxtKD6odIIHKoWnhKo1U8KIpFC+MVn59ZXmc7ZTBZfsg6FQ8W10YfTr4u0nYrpHZbZ1jXiLmooF0cOm0+mPnJBXQtepc7n0BqOipNCqI6yyloTeRShNKH04FIo0gcMk0H/xThyN4pPAWjDDkEp3lNNPRNVfpMI44CWRlRgViP64eK0JSRp0WUvCWYumlW/c58Vcz/yMwVcW5oYb9+26TEhwvbxiNg48hl1VI1UXTU//Eta+BMKnGUivctfL5wINDD0giQL1ipt6U7C9cd4+lgqY2lMUZ02Uv6Prs+ZEZer7ZfWBXVghlfOOrClwsoOFKzWEfz6RZu1eCs+K8fLvkts5+BX0gyrFYve0C3qHrn5U/Oh6D/CihmWIrY7HUZRhJaxde+tldu6adYJ+LeXupQw0XExC36RETdNFxcq9glMu4cNQSX9cqR/GQYp+IxUkIcNGWVU7ZtGa6P3XAyodRt0XeS3Tp01AnCh0ZbUh4VrSZeV9RWfSoWyxnY3hzcZ30G/InDq4wxRrEejreBxnhIQbkxenxkaxl+k7eLUQkUR6vKJ2iDFNGX3WmVA1yaOH+mvhBd+sE6vacQzFobwY5BqEAFmejwW5ne7HtVNolOUgJc8CsUxmc/LBi8N5mu9VsIA5HyErnS6zeCz7VLI9+n/hbT6hTokMXTVyXJRKSG2hd2labXTbtmK4fNH3IZBPreSA4FMeVouVN3zG5x9CiGpLw/3pceo4qGqp+rVp+z+7yQ98oEf+nyH4F3+J9IheDBa94Wi63zJbLBCIZm7P0asHGpIJt3PzE3m0S4YIWyXBCVXGikj8MudDPB/6Nm2v4IxJ5gU0ii0guy5SUHqGUYzTP0jIJU5E82RHUXtX4lDdrihBLdP1YaG1AGUC12rQKuIaGvCpMjZC9bWSCYnjDlvpWbkdXMTNeBHLKiuoozMGIvkczmP0aRJSJ8PYnLCVNhKHXBNckH79e8Z8Kc2wUej4sQZoH8qDRGkg86maW/ZQWGNnLcXmq3FlXM6ssR/3P6E/bHMvm6HLrv1yRixit25JsH3/IOr2UV4BWJhxXW5BJ6Xdr07n9kF3ZNAk6/Xpc5MSFmYJ2R7bdL8Kk7q1OU9Elg/tCxJ8giT27wSTySF0GOxg4PbYJdi/Nyia9Nn89CGDulfJemm1aiEr/eleGSN+5MRrVJ4K6lgyTTIW3i9cQ0dAi6FHt0YMbH3wDSAtGLSAccezzxHitt1QdhW36CQgPcA8vIIBh3/JNjf/Obmc2yzpk8edSlS4lVdwgW5vzbYEyFoF4GCBBby1keVNueHAH+evi+H7oOVfS3XuPQSNTXOONAbzJeSb5stwdQHl1ZjrGoE49I8+A9j3t+ahhQj74FCSWpZrj7wRSFJJnnwi1T9HL5qrCFW/JZq6P62XkMWTb+u4lGpKfmmwiJWx178GOG7KbrZGqyWwmuyKWPkNswkZ1q8uptUlviIi+AXh2bOOTOLsrtNkfqbQJeh24reebkINLkjut5r4d9GR/r8CBa9SU0UQhsnZp5cP+RqWCixRm7i4YRFbtZ4EAkhtNa6jHb6gPYQv7MKqkPLRmX3dFsK8XsRLVZ6IEVrCbmNDc8o5mqsogjAQfoC9Bc7R6gfw03m+lQpv6kTfhxscDIX6s0w+fBxtkhjXAXr10UouWCx3C/p/FYwJRS/AXRKkjOb5CLmK4XRe0+xeDDwVkJPZau52bzLEDHCqV0f44pPgKOkYKgTZJ33fmk3Tu8SdxJ02SHM8Fem5SMsWqRyi2F1ynfRJszcFKykdWlNqgDA/L9lKYBmc7Zu/q9ii1FPF47VJkqhirUob53zoiJtVVRVwMR34gV9iqcBaHbRu9kkvqk3yMpfRFG49pKKjIiq7h/VpRwPGTHoY4cg05X5028iHsLvUW/uz+kjPyIEhhcKUwCkJAwbR9pIEGOn8z6svAO8i89sJ3dL5qDWFYbS+HGPRMxYwJItFQN86YESeJQhn2urGiLRffQeLptDl8dAgb+Tp47UQPxWOw17OeChLN1WnzlkPL1T5O+O3Menpn4C3IY5LEepHpnPeZHbvuWfeVtPlkH4LZjPbBrkJT3NoRJzBt86CO0Xq59oQ+8dsm0ymRcmQyn8w71mhmcuEI5byuF+C88VPYly2sEzjlzAQ3vdn/1+Hzguw6qFNNbqenhZGbdiG6RwZaTG7jTA2X9RdXjDN9yj1uQpyO4Lx8KRAcZcbZMafp4wPOd5MdXoFY52V1A8M9hi3sso93+uprE0qYNMjkE22CvK4HuUxqN7oIz5pWuETq1lQAjqlSlqdD2Rnr/ggp/TVkQYjn9lMfYelk2sH5HPdopYo7MHwlV1or9Bxf+QCyLzm92vzG2wjiIjC/ZHEJzeroJl6bdFPTpZho5MV2U86fLQqxNlGIMqCGy+9WYhJ8ob1r0+Whxde9L2PdysETv97O+xVw+VNN1TZSQN5I6l9m5Ip6pLIqLm4a1B1ffH6gHyqT9p82NOjntRWGIofO3bJz5GhkvSWbsXueTAMaJDou99kGLqDlhwBZNEQ4mKPuDvVwSK4WmLluHyhA97pZiVe8g+JxmnJF8IkV/tCs4Jq/HgOoAEGR9tCDsDbDmi3OviUQpG5D8XmKcSAUaFLRXb2lmJTNYdhtYyfjBYZQmN5qT5CNuaD3BVnlkCk7bsMW3AtXkNMMTuW4HjUERSJnVQ0vsBGa1wo3Qh7115XGeTF3NTz8w0440AgU7c3bSXO/KMINaIWXd0oLpoq/0/QJxCQSJ9XnYy1W7TYLBJpHsVWD1ahsA7FjNvRd6mxCiHsm8g6Z0pnzqIpF1dHUtP2ITU5Z1hZHbu+L3BEEStBbL9XYvGfEakv1bmf+bOZGnoiuHEdlBnaChxYKNzB23b8sw8YyT7Ajxfk49eJIAvdbVkdFCe2J0gMefhQ0bIZxhx3fzMIysQNiN8PgOUKxOMur10LduigREDRMZyP4oGWrP1GFY4t6groASsZ421os48wAdnrbovNhLt7ScNULkwZ5AIZJTrbaKYTLjA1oJ3sIuN/aYocm/9uoQHEIlacF1s/TM1fLcPTL38O9fOsjMEIwoPKfvt7opuI9G2Hf/PR4aCLDQ7wNmIdEuXJ/QNL72k5q4NejAldPfe3UVVqzkys8YZ/jYOGOp6c+YzRCrCuq0M11y7TiN6qk7YXRMn/gukxrEimbMQjr3jwRM6dKVZ4RUfWQr8noPXLJq6yh5R3EH1IVOHESst/LItbG2D2vRsZRkAObzvQAAD3mb3/G4NzopI0FAiHfbpq0X72adg6SRj+8OHMShtFxxLZlf/nLgRLbClwl5WmaYSs+yEjkq48tY7Z2bE0N91mJwt+ua0NlRJIDh0HikF4UvSVorFj2YVu9YeS5tfvlVjPSoNu/Zu6dEUfBOT555hahBdN3Sa5Xuj2Rvau1lQNIaC944y0RWj9UiNDskAK1WoL+EfXcC6IbBXFRyVfX/WKXxPAwUyIAGW8ggZ08hcijKTt1YKnUO6QPvcrmDVAb0FCLIXn5id4fD/Jx4tw/gbXs7WF9b2RgXtPhLBG9vF5FEkdHAKrQHZAJC/HWvk7nvzzDzIXZlfFTJoC3JpGgLPBY7SQTjGlUvG577yNutZ1hTfs9/1nkSXK9zzKLRZ3VODeKUovJe0WCq1zVMYxCJMenmNzPIU2S8TA4E7wWmbNkxq9rI2dd6v0VpcAPVMxnDsvWTWFayyqvKZO7Z08a62i/oH2/jxf8rpmfO64in3FLiL1GX8IGtVE9M23yGsIqJbxDTy+LtaMWDaPqkymb5VrQdzOvqldeU0SUi6IirG8UZ3jcpRbwHa1C0Dww9G/SFX3gPvTJQE+kyz+g1BeMILKKO+olcHzctOWgzxYHnOD7dpCRtuZEXACjgqesZMasoPgnuDC4nUviAAxDc5pngjoAITIkvhKwg5d608pdrZcA+qn5TMT6Uo/QzBaOxBCLTJX3Mgk85rMfsnWx86oLxf7p2PX5ONqieTa/qM3tPw4ZXvlAp83NSD8F7+ZgctK1TpoYwtiU2h02HCGioH5tkVCqNVTMH5p00sRy2JU1qyDBP2CII/Dg4WDsIl+zgeX7589srx6YORRQMBfKbodbB743Tl4WLKOEnwWUVBsm94SOlCracU72MSyj068wdpYjyz1FwC2bjQnxnB6Mp/pZ+yyZXtguEaYB+kqhjQ6UUmwSFazOb+rhYjLaoiM+aN9/8KKn0zaCTFpN9eKwWy7/u4EHzO46TdFSNjMfn2iPSJwDPCFHc0I1+vjdAZw5ZjqR/uzi9Zn20oAa5JnLEk/EA3VRWE7J/XrupfFJPtCUuqHPpnlL7ISJtRpSVcB8qsZCm2QEkWoROtCKKxUh3yEcMbWYJwk6DlEBG0bZP6eg06FL3v6RPb7odGuwm7FN8fG4woqtB8e7M5klPpo97GoObNwt+ludTAmxyC5hmcFx+dIvEZKI6igFKHqLH01iY1o7903VzG9QGetyVx5RNmBYUU+zIuSva/yIcECUi4pRmE3VkF2avqulQEUY4yZ/wmNboBzPmAPey3+dSYtBZUjeWWT0pPwCz4Vozxp9xeClIU60qvEFMQCaPvPaA70WlOP9f/ey39macvpGCVa+zfa8gO44wbxpJUlC8GN/pRMTQtzY8Z8/hiNrU+Zq64ZfFGIkdj7m7abcK1EBtws1X4J/hnqvasPvvDSDYWN+QcQVGMqXalkDtTad5rYY0TIR1Eqox3czwPMjKPvF5sFv17Thujr1IZ1Ytl4VX1J0vjXKmLY4lmXipRAro0qVGEcXxEVMMEl54jQMd4J7RjgomU0j1ptjyxY+cLiSyXPfiEcIS2lWDK3ISAy6UZ3Hb5vnPncA94411jcy75ay6B6DSTzK6UTCZR9uDANtPBrvIDgjsfarMiwoax2OlLxaSoYn4iRgkpEGqEkwox5tyI8aKkLlfZ12lO11TxsqRMY89j5JaO55XfPJPDL1LGSnC88Re9Ai+Nu5bZjtwRrvFITUFHPR4ZmxGslQMecgbZO7nHk32qHxYkdvWpup07ojcMCaVrpFAyFZJJbNvBpZfdf39Hdo2kPtT7v0/f8R/B5Nz4f1t9/3zNM/7n6SUHfcWk5dfQFJvcJMgPolGCpOFb/WC0FGWU2asuQyT+rm88ZKZ78Cei/CAh939CH0JYbpZIPtxc2ufXqjS3pHH9lnWK4iJ7OjR/EESpCo2R3MYKyE7rHfhTvWho4cL1QdN4jFTyR6syMwFm124TVDDRXMNveI1Dp/ntwdz8k8kxw7iFSx6+Yx6O+1LzMVrN0BBzziZi9kneZSzgollBnVwBh6oSOPHXrglrOj+QmR/AESrhDpKrWT+8/AiMDxS/5wwRNuGQPLlJ9ovomhJWn8sMLVItQ8N/7IXvtD8kdOoHaw+vBSbFImQsv/OCAIui99E+YSIOMlMvBXkAt+NAZK8wB9Jf8CPtB+TOUOR+z71d/AFXpPBT6+A5FLjxMjLIEoJzrQfquvxEIi+WoUzGR1IzQFNvbYOnxb2PyQ0kGdyXKzW2axQL8lNAXPk6NEjqrRD1oZtKLlFoofrXw0dCNWASHzy+7PSzOUJ3XtaPZsxLDjr+o41fKuKWNmjiZtfkOzItvlV2MDGSheGF0ma04qE3TUEfqJMrXFm7DpK+27DSvCUVf7rbNoljPhha5W7KBqVq0ShUSTbRmuqPtQreVWH4JET5yMhuqMoSd4r/N8sDmeQiQQvi1tcZv7Moc7dT5X5AtCD6kNEGZOzVcNYlpX4AbTsLgSYYliiPyVoniuYYySxsBy5cgb3pD+EK0Gpb0wJg031dPgaL8JZt6sIvzNPEHfVPOjXmaXj4bd4voXzpZ5GApMhILgMbCEWZ2zwgdeQgjNHLbPIt+KqxRwWPLTN6HwZ0Ouijj4UF+Sg0Au8XuIKW0WxlexdrFrDcZJ8Shauat3X0XmHygqgL1nAu2hrJFb4wZXkcS+i36KMyU1yFvYv23bQUJi/3yQpqr/naUOoiEWOxckyq/gq43dFou1DVDaYMZK9tho7+IXXokBCs5GRfOcBK7g3A+jXQ39K4YA8PBRW4m5+yR0ZAxWJncjRVbITvIAPHYRt1EJ3YLiUbqIvoKHtzHKtUy1ddRUQ0AUO41vonZDUOW+mrszw+SW/6Q/IUgNpcXFjkM7F4CSSQ2ExZg85otsMs7kqsQD4OxYeBNDcSpifjMoLb7GEbGWTwasVObmB/bfPcUlq0wYhXCYEDWRW02TP5bBrYsKTGWjnWDDJ1F7zWai0zW/2XsCuvBQjPFcTYaQX3tSXRSm8hsAoDdjArK/OFp6vcWYOE7lizP0Yc+8p16i7/NiXIiiQTp7c7Xus925VEtlKAjUdFhyaiLT7VxDagprMFwix4wZ05u0qj7cDWFd0W9OYHIu3JbJKMXRJ1aYNovugg+QqRN7fNHSi26VSgBpn+JfMuPo3aeqPWik/wI5Rz3BWarPQX4i5+dM0npwVOsX+KsOhC7vDg+OJsz4Q5zlnIeflUWL6QYMbf9WDfLmosLF4Qev3mJiOuHjoor/dMeBpA9iKDkMjYBNbRo414HCxjsHrB4EXNbHzNMDHCLuNBG6Sf+J4MZ/ElVsDSLxjIiGsTPhw8BPjxbfQtskj+dyNMKOOcUYIRBEIqbazz3lmjlRQhplxq673VklMMY6597vu+d89ec/zq7Mi4gQvh87ehYbpOuZEXj5g/Q7S7BFDAAB9DzG35SC853xtWVcnZQoH54jeOqYLR9NDuwxsVthTV7V99n/B7HSbAytbEyVTz/5NhJ8gGIjG0E5j3griULUd5Rg7tQR+90hJgNQKQH2btbSfPcaTOfIexc1db1BxUOhM1vWCpLaYuKr3FdNTt/T3PWCpEUWDKEtzYrjpzlL/wri3MITKsFvtF8QVV/NhVo97aKIBgdliNc10dWdXVDpVtsNn+2UIolrgqdWA4EY8so0YvB4a+aLzMXiMAuOHQrXY0tr+CL10JbvZzgjJJuB1cRkdT7DUqTvnswVUp5kkUSFVtIIFYK05+tQxT6992HHNWVhWxUsD1PkceIrlXuUVRogwmfdhyrf6zzaL8+c0L7GXMZOteAhAVQVwdJh+7nrX7x4LaIIfz2F2v7Dg/uDfz2Fa+4gFm2zHAor8UqimJG3VTJtZEoFXhnDYXvxMJFc6ku2bhbCxzij2z5UNuK0jmp1mnvkVNUfR+SEmj1Lr94Lym75PO7Fs0MIr3GdsWXRXSfgLTVY0FLqba97u1In8NAcY7IC6TjWLigwKEIm43NxTdaVTv9mcKkzuzBkKd8x/xt1p/9BbP7Wyb4bpo1K1gnOpbLvKz58pWl3B55RJ/Z5mRDLPtNQg14jdOEs9+h/V5UVpwrAI8kGbX8KPVPDIMfIqKDjJD9UyDOPhjZ3vFAyecwyq4akUE9mDOtJEK1hpDyi6Ae87sWAClXGTiwPwN7PXWwjxaR79ArHRIPeYKTunVW24sPr/3HPz2IwH8oKH4OlWEmt4BLM6W5g4kMcYbLwj2usodD1088stZA7VOsUSpEVl4w7NMb1EUHMRxAxLF0CIV+0L3iZb+ekB1vSDSFjAZ3hfLJf7gFaXrOKn+mhR+rWw/eTXIcAgl4HvFuBg1LOmOAwJH3eoVEjjwheKA4icbrQCmvAtpQ0mXG0agYp5mj4Rb6mdQ+RV4QBPbxMqh9C7o8nP0Wko2ocnCHeRGhN1XVyT2b9ACsL+6ylUy+yC3QEnaKRIJK91YtaoSrcWZMMwxuM0E9J68Z+YyjA0g8p1PfHAAIROy6Sa04VXOuT6A351FOWhKfTGsFJ3RTJGWYPoLk5FVK4OaYR9hkJvezwF9vQN1126r6isMGXWTqFW+3HL3I/jurlIdDWIVvYY+s6yq7lrFSPAGRdnU7PVwY/SvWbZGpXzy3BQ2LmAJlrONUsZs4oGkly0V267xbD5KMY8woNNsmWG1VVgLCra8aQBBcI4DP2BlNwxhiCtHlaz6OWFoCW0vMR3ErrG7JyMjTSCnvRcsEHgmPnwA6iNpJ2DrFb4gLlhKJyZGaWkA97H6FFdwEcLT6DRQQL++fOkVC4cYGW1TG/3iK5dShRSuiBulmihqgjR45Vi03o2RbQbP3sxt90VxQ6vzdlGfkXmmKmjOi080JSHkLntjvsBJnv7gKscOaTOkEaRQqAnCA4HWtB4XnMtOhpRmH2FH8tTXrIjAGNWEmudQLCkcVlGTQ965Kh0H6ixXbgImQP6b42B49sO5C8pc7iRlgyvSYvcnH9FgQ3azLbQG2cUW96SDojTQStxkOJyOuDGTHAnnWkz29aEwN9FT8EJ4yhXOg+jLTrCPKeEoJ9a7lDXOjEr8AgX4BmnMQ668oW0zYPyQiVMPxKRHtpfnEEyaKhdzNVThlxxDQNdrHeZiUFb6NoY2KwvSb7BnRcpJy+/g/zAYx3fYSN5QEaVD2Y1VsNWxB0BSO12MRsRY8JLfAezRMz5lURuLUnG1ToKk6Q30FughqWN6gBNcFxP/nY/iv+iaUQOa+2Nuym46wtI/DvSfzSp1jEi4SdYBE7YhTiVV5cX9gwboVDMVgZp5YBQlHOQvaDNfcCoCJuYhf5kz5kwiIKPjzgpcRJHPbOhJajeoeRL53cuMahhV8Z7IRr6M4hW0JzT7mzaMUzQpm866zwM7Cs07fJYXuWvjAMkbe5O6V4bu71sOG6JQ4oL8zIeXHheFVavzxmlIyBkgc9IZlEDplMPr8xlcyss4pVUdwK1e7CK2kTsSdq7g5SHRAl3pYUB9Ko4fsh4qleOyJv1z3KFSTSvwEcRO/Ew8ozEDYZSqpfoVW9uhJfYrNAXR0Z3VmeoAD+rVWtwP/13sE/3ICX3HhDG3CMc476dEEC0K3umSAD4j+ZQLVdFOsWL2C1TH5+4KiSWH+lMibo+B55hR3Gq40G1n25sGcN0mEcoU2wN9FCVyQLBhYOu9aHVLWjEKx2JIUZi5ySoHUAI9b8hGzaLMxCZDMLhv8MkcpTqEwz9KFDpCpqQhVmsGQN8m24wyB82FAKNmjgfKRsXRmsSESovAwXjBIoMKSG51p6Um8b3i7GISs7kjTq/PZoioCfJzfKdJTN0Q45kQEQuh9H88M3yEs3DbtRTKALraM0YC8laiMiOOe6ADmTcCiREeAWZelBaEXRaSuj2lx0xHaRYqF65O0Lo5OCFU18A8cMDE4MLYm9w2QSr9NgQAIcRxZsNpA7UJR0e71JL+VU+ISWFk5I97lra8uGg7GlQYhGd4Gc6rxsLFRiIeGO4abP4S4ekQ1fiqDCy87GZHd52fn5aaDGuvOmIofrzpVwMvtbreZ/855OaXTRcNiNE0wzGZSxbjg26v8ko8L537v/XCCWP2MFaArJpvnkep0pA+O86MWjRAZPQRfznZiSIaTppy6m3p6HrNSsY7fDtz7Cl4V/DJAjQDoyiL2uwf1UHVd2AIrzBUSlJaTj4k6NL97a/GqhWKU9RUmjnYKpm2r+JYUcrkCuZKvcYvrg8pDoUKQywY9GDWg03DUFSirlUXBS5SWn/KAntnf0IdHGL/7mwXqDG+LZYjbEdQmqUqq4y54TNmWUP7IgcAw5816YBzwiNIJiE9M4lPCzeI/FGBeYy3p6IAmH4AjXXmvQ4Iy0Y82NTobcAggT2Cdqz6Mx4TdGoq9fn2etrWKUNFyatAHydQTVUQ2S5OWVUlugcNvoUrlA8cJJz9MqOa/W3iVno4zDHfE7zhoY5f5lRTVZDhrQbR8LS4eRLz8iPMyBL6o4PiLlp89FjdokQLaSBmKHUwWp0na5fE3v9zny2YcDXG/jfI9sctulHRbdkI5a4GOPJx4oAJQzVZ/yYAado8KNZUdEFs9ZPiBsausotXMNebEgr0dyopuqfScFJ3ODNPHgclACPdccwv0YJGQdsN2lhoV4HVGBxcEUeUX/alr4nqpcc1CCR3vR7g40zteQg/JvWmFlUE4mAiTpHlYGrB7w+U2KdSwQz2QJKBe/5eiixWipmfP15AFWrK8Sh1GBBYLgzki1wTMhGQmagXqJ2+FuqJ8f0XzXCVJFHQdMAw8xco11HhM347alrAu+wmX3pDFABOvkC+WPX0Uhg1Z5MVHKNROxaR84YV3s12UcM+70cJ460SzEaKLyh472vOMD3XnaK7zxZcXlWqenEvcjmgGNR2OKbI1s8U+iwiW+HotHalp3e1MGDy6BMVIvajnAzkFHbeVsgjmJUkrP9OAwnEHYXVBqYx3q7LvXjoVR0mY8h+ZaOnh053pdsGkmbqhyryN01eVHySr+CkDYkSMeZ1xjPNVM+gVLTDKu2VGsMUJqWO4TwPDP0VOg2/8ITbAUaMGb4LjL7L+Pi11lEVMXTYIlAZ/QHmTENjyx3kDkBdfcvvQt6tKk6jYFM4EG5UXDTaF5+1ZjRz6W7MdJPC+wTkbDUim4p5QQH3b9kGk2Bkilyeur8Bc20wm5uJSBO95GfYDI1EZipoRaH7uVveneqz43tlTZGRQ4a7CNmMHgXyOQQOL6WQkgMUTQDT8vh21aSdz7ERiZT1jK9F+v6wgFvuEmGngSvIUR2CJkc5tx1QygfZnAruONobB1idCLB1FCfO7N1ZdRocT8/Wye+EnDiO9pzqIpnLDl4bkaRKW+ekBVwHn46Shw1X0tclt/0ROijuUB4kIInrVJU4buWf4YITJtjOJ6iKdr1u+flgQeFH70GxKjhdgt/MrwfB4K/sXczQ+9zYcrD4dhY6qZhZ010rrxggWA8JaZyg2pYij8ieYEg1aZJkZK9O1Re7sB0iouf60rK0Gd+AYlp7soqCBCDGwfKeUQhCBn0E0o0GS6PdmjLi0TtCYZeqazqwN+yNINIA8Lk3iPDnWUiIPLGNcHmZDxfeK0iAdxm/T7LnN+gemRL61hHIc0NCAZaiYJR+OHnLWSe8sLrK905B5eEJHNlWq4RmEXIaFTmo49f8w61+NwfEUyuJAwVqZCLFcyHBKAcIVj3sNzfEOXzVKIndxHw+AR93owhbCxUZf6Gs8cz6/1VdrFEPrv330+9s6BtMVPJ3zl/Uf9rUi0Z/opexfdL3ykF76e999GPfVv8fJv/Y/+/5hEMon1tqNFyVRevV9y9/uIvsG3dbB8GRRrgaEXfhx+2xeOFt+cEn3RZanNxdEe2+B6MHpNbrRE53PlDifPvFcp4kO78ILR0T4xyW/WGPyBsqGdoA7zJJCu1TKbGfhnqgnRbxbB2B3UZoeQ2bz2sTVnUwokTcTU21RxN1PYPS3Sar7T0eRIsyCNowr9amwoMU/od9s2APtiKNL6ENOlyKADstAEWKA+sdKDhrJ6BOhRJmZ+QJbAaZ3/5Fq0/lumCgEzGEbu3yi0Y4I4EgVAjqxh4HbuQn0GrRhOWyAfsglQJAVL1y/6yezS2k8RE2MstJLh92NOB3GCYgFXznF4d25qiP4ZCyI4RYGesut6FXK6GwPpKK8WHEkhYui0AyEmr5Ml3uBFtPFdnioI8RiCooa7Z1G1WuyIi3nSNglutc+xY8BkeW3JJXPK6jd2VIMpaSxpVtFq+R+ySK9J6WG5Qvt+C+QH1hyYUOVK7857nFmyDBYgZ/o+AnibzNVqyYCJQvyDXDTK+iXdkA71bY7TL3bvuLxLBQ8kbTvTEY9aqkQ3+MiLWbEgjLzOH+lXgco1ERgzd80rDCymlpaRQbOYnKG/ODoFl46lzT0cjM5FYVvv0qLUbD5lyJtMUaC1pFlTkNONx6lliaX9o0i/1vws5bNKn5OuENQEKmLlcP4o2ZmJjD4zzd3Fk32uQ4uRWkPSUqb4LBe3EXHdORNB2BWsws5daRnMfNVX7isPSb1hMQdAJi1/qmDMfRUlCU74pmnzjbXfL8PVG8NsW6IQM2Ne23iCPIpryJjYbVnm5hCvKpMa7HLViNiNc+xTfDIaKm3jctViD8A1M9YPJNk003VVr4Zo2MuGW8vil8SLaGpPXqG7I4DLdtl8a4Rbx1Lt4w5Huqaa1XzZBtj208EJVGcmKYEuaeN27zT9EE6a09JerXdEbpaNgNqYJdhP1NdqiPKsbDRUi86XvvNC7rME5mrSQtrzAZVndtSjCMqd8BmaeGR4l4YFULGRBeXIV9Y4yxLFdyoUNpiy2IhePSWzBofYPP0eIa2q5JP4j9G8at/AqoSsLAUuRXtvgsqX/zYwsE+of6oSDbUOo4RMJw+DOUTJq+hnqwKim9Yy/napyZNTc2rCq6V9jHtJbxGPDwlzWj/Sk3zF/BHOlT/fSjSq7FqlPI1q6J+ru8Aku008SFINXZfOfnZNOvGPMtEmn2gLPt+H4QLA+/SYe4j398auzhKIp2Pok3mPC5q1IN1HgR+mnEfc4NeeHYwd2/kpszR3cBn7ni9NbIqhtSWFW8xbUJuUPVOeeXu3j0IGZmFNiwaNZ6rH4/zQ2ODz6tFxRLsUYZu1bfd1uIvfQDt4YD/efKYv8VF8bHGDgK22w2Wqwpi43vNCOXFJZCGMqWiPbL8mil6tsmOTXAWCyMCw73e2rADZj2IK6rqksM3EXF2cbLb4vjB14wa/yXK5vwU+05MzERJ5nXsXsW21o7M+gO0js2OyKciP5uF2iXyb2DiptwQeHeqygkrNsqVCSlldxBMpwHi1vfc8RKpP/4L3Lmpq6DZcvhDDfxTCE3splacTcOtXdK2g303dIWBVe2wD/Gvja1cClFQ67gw0t1ZUttsUgQ1Veky8oOpS6ksYEc4bqseCbZy766SvL3FodmnahlWJRgVCNjPxhL/fk2wyvlKhITH/VQCipOI0dNcRa5B1M5HmOBjTLeZQJy237e2mobwmDyJNHePhdDmiknvLKaDbShL+Is1XTCJuLQd2wmdJL7+mKvs294whXQD+vtd88KKk0DXP8B1Xu9J+xo69VOuFgexgTrcvI6SyltuLix9OPuE6/iRJYoBMEXxU4shQMf4Fjqwf1PtnJ/wWSZd29rhZjRmTGgiGTAUQqRz+nCdjeMfYhsBD5Lv60KILWEvNEHfmsDs2L0A252351eUoYxAysVaCJVLdH9QFWAmqJDCODUcdoo12+gd6bW2boY0pBVHWL6LQDK5bYWh1V8vFvi0cRpfwv7cJiMX3AZNJuTddHehTIdU0YQ/sQ1dLoF2xQPcCuHKiuCWOY30DHe1OwcClLAhqAKyqlnIbH/8u9ScJpcS4kgp6HKDUdiOgRaRGSiUCRBjzI5gSksMZKqy7Sd51aeg0tgJ+x0TH9YH2Mgsap9N7ENZdEB0bey2DMTrBA1hn56SErNHf3tKtqyL9b6yXEP97/rc+jgD2N1LNUH6RM9AzP3kSipr06RkKOolR7HO768jjWiH1X92jA7dkg7gcNcjqsZCgfqWw0tPXdLg20cF6vnQypg7gLtkazrHAodyYfENPQZsdfnjMZiNu4nJO97D1/sQE+3vNFzrSDOKw+keLECYf7RJwVHeP/j79833oZ0egonYB2FlFE5qj02B/LVOMJQlsB8uNg3Leg4qtZwntsOSNidR0abbZmAK4sCzvt8Yiuz2yrNCJoH5O8XvX/vLeR/BBYTWj0sOPYM/jyxRd5+/JziKAABaPcw/34UA3aj/gLZxZgRCWN6m4m3demanNgsx0P237/Q+Ew5VYnJPkyCY0cIVHoFn2Ay/e7U4P19APbPFXEHX94N6KhEMPG7iwB3+I+O1jd5n6VSgHegxgaSawO6iQCYFgDsPSMsNOcUj4q3sF6KzGaH/0u5PQoAj/8zq6Uc9MoNrGqhYeb2jQo0WlGlXjxtanZLS24/OIN5Gx/2g684BPDQpwlqnkFcxpmP/osnOXrFuu4PqifouQH0eF5qCkvITQbJw/Zvy5mAHWC9oU+cTiYhJmSfKsCyt1cGVxisKu+NymEQIAyaCgud/V09qT3nk/9s/SWsYtha7yNpzBIMM40rCSGaJ9u6lEkl00vXBiEt7p9P5IBCiavynEOv7FgLqPdeqxRiCwuFVMolSIUBcoyfUC2e2FJSAUgYdVGFf0b0Kn2EZlK97yyxrT2MVgvtRikfdaAW8RwEEfN+B7/eK8bBdp7URpbqn1xcrC6d2UjdsKbzCjBFqkKkoZt7Mrhg6YagE7spkqj0jOrWM+UGQ0MUlG2evP1uE1p2xSv4dMK0dna6ENcNUF+xkaJ7B764NdxLCpuvhblltVRAf7vK5qPttJ/9RYFUUSGcLdibnz6mf7WkPO3MkUUhR2mAOuGv8IWw5XG1ZvoVMnjSAZe6T7WYA99GENxoHkMiKxHlCuK5Gd0INrISImHQrQmv6F4mqU/TTQ8nHMDzCRivKySQ8dqkpQgnUMnwIkaAuc6/FGq1hw3b2Sba398BhUwUZSAIO8XZvnuLdY2n6hOXws+gq9BHUKcKFA6kz6FDnpxLPICa3qGhnc97bo1FT/XJk48LrkHJ2CAtBv0RtN97N21plfpXHvZ8gMJb7Zc4cfI6MbPwsW7AilCSXMFIEUEmir8XLEklA0ztYbGpTTGqttp5hpFTTIqUyaAIqvMT9A/x+Ji5ejA4Bhxb/cl1pUdOD6epd3yilIdO6j297xInoiBPuEDW2/UfslDyhGkQs7Wy253bVnlT+SWg89zYIK/9KXFl5fe+jow2rd5FXv8zDPrmfMXiUPt9QBO/iK4QGbX5j/7Rx1c1vzsY8ONbP3lVIaPrhL4+1QrECTN3nyKavGG0gBBtHvTKhGoBHgMXHStFowN+HKrPriYu+OZ05Frn8okQrPaaxoKP1ULCS/cmKFN3gcH7HQlVjraCeQmtjg1pSQxeuqXiSKgLpxc/1OiZsU4+n4lz4hpahGyWBURLi4642n1gn9qz9bIsaCeEPJ0uJmenMWp2tJmIwLQ6VSgDYErOeBCfSj9P4G/vI7oIF+l/n5fp956QgxGvur77ynawAu3G9MdFbJbu49NZnWnnFcQHjxRuhUYvg1U/e84N4JTecciDAKb/KYIFXzloyuE1eYXf54MmhjTq7B/yBToDzzpx3tJCTo3HCmVPYfmtBRe3mPYEE/6RlTIxbf4fSOcaKFGk4gbaUWe44hVk9SZzhW80yfW5QWBHxmtUzvMhfVQli4gZTktIOZd9mjJ5hsbmzttaHQB29Am3dZkmx3g/qvYocyhZ2PXAWsNQiIaf+Q8W/MWPIK7/TjvCx5q2XRp4lVWydMc2wIQkhadDB0xsnw/kSEyGjLKjI4coVIwtubTF3E7MJ6LS6UOsJKj82XVAVPJJcepfewbzE91ivXZvOvYfsmMevwtPpfMzGmC7WJlyW2j0jh7AF1JLmwEJSKYwIvu6DHc3YnyLH9ZdIBnQ+nOVDRiP+REpqv++typYHIvoJyICGA40d8bR7HR2k7do6UQTHF4oriYeIQbxKe4Th6+/l1BjUtS9hqORh3MbgvYrStXTfSwaBOmAVQZzpYNqsAmQyjY56MUqty3c/xH6GuhNvNaG9vGbG6cPtBM8UA3e8r51D0AR9kozKuGGSMgLz3nAHxDNnc7GTwpLj7/6HeWp1iksDeTjwCLpxejuMtpMnGJgsiku1sOACwQ9ukzESiDRN77YNESxR5LphOlcASXA5uIts1LnBIcn1J7BLWs49DMALSnuz95gdOrTZr0u1SeYHinno/pE58xYoXbVO/S+FEMMs5qyWkMnp8Q3ClyTlZP52Y9nq7b8fITPuVXUk9ohG5EFHw4gAEcjFxfKb3xuAsEjx2z1wxNbSZMcgS9GKyW3R6KwJONgtA64LTyxWm8Bvudp0M1FdJPEGopM4Fvg7G/hsptkhCfHFegv4ENwxPeXmYhxwZy7js+BeM27t9ODBMynVCLJ7RWcBMteZJtvjOYHb5lOnCLYWNEMKC59BA7covu1cANa2PXL05iGdufOzkgFqqHBOrgQVUmLEc+Mkz4Rq8O6WkNr7atNkH4M8d+SD1t/tSzt3oFql+neVs+AwEI5JaBJaxARtY2Z4mKoUqxds4UpZ0sv3zIbNoo0J4fihldQTX3XNcuNcZmcrB5LTWMdzeRuAtBk3cZHYQF6gTi3PNuDJ0nmR+4LPLoHvxQIxRgJ9iNNXqf2SYJhcvCtJiVWo85TsyFOuq7EyBPJrAdhEgE0cTq16FQXhYPJFqSfiVn0IQnPOy0LbU4BeG94QjdYNB0CiQ3QaxQqD2ebSMiNjaVaw8WaM4Z5WnzcVDsr4eGweSLa2DE3BWViaxhZFIcSTjgxNCAfelg+hznVOYoe5VqTYs1g7WtfTm3e4/WduC6p+qqAM8H4ZyrJCGpewThTDPe6H7CzX/zQ8Tm+r65HeZn+MsmxUciEWPlAVaK/VBaQBWfoG/aRL/jSZIQfep/89GjasWmbaWzeEZ2R1FOjvyJT37O9B8046SRSKVEnXWlBqbkb5XCS3qFeuE9xb9+frEknxWB5h1D/hruz2iVDEAS7+qkEz5Ot5agHJc7WCdY94Ws61sURcX5nG8UELGBAHZ3i+3VulAyT0nKNNz4K2LBHBWJcTBX1wzf+//u/j/9+//v87+9/l9Lbh/L/uyNYiTsWV2LwsjaA6MxTuzFMqmxW8Jw/+IppdX8t/Clgi1rI1SN0UC/r6tX/4lUc2VV1OQReSeCsjUpKZchw4XUcjHfw6ryCV3R8s6VXm67vp4n+lcPV9gJwmbKQEsmrJi9c2vkwrm8HFbVYNTaRGq8D91t9n5+U+aD/hNtN3HjC/nC/vUoGFSCkXP+NlRcmLUqLbiUBl4LYf1U/CCvwtd3ryCH8gUmGITAxiH1O5rnGTz7y1LuFjmnFGQ1UWuM7HwfXtWl2fPFKklYwNUpF2IL/TmaRETjQiM5SJacI+3Gv5MBU8lP5Io6gWkawpyzNEVGqOdx4YlO1dCvjbWFZWbCmeiFKPSlMKtKcMFLs/KQxtgAHi7NZNCQ32bBAW2mbHflVZ8wXKi1JKVHkW20bnYnl3dKWJeWJOiX3oKPBD6Zbi0ZvSIuWktUHB8qDR8DMMh1ZfkBL9FS9x5r0hBGLJ8pUCJv3NYH+Ae8p40mZWd5m5fhobFjQeQvqTT4VKWIYfRL0tfaXKiVl75hHReuTJEcqVlug+eOIIc4bdIydtn2K0iNZPsYWQvQio2qbO3OqAlPHDDOB7DfjGEfVF51FqqNacd6QmgFKJpMfLp5DHTv4wXlONKVXF9zTJpDV4m1sYZqJPhotcsliZM8yksKkCkzpiXt+EcRQvSQqmBS9WdWkxMTJXPSw94jqI3varCjQxTazjlMH8jTS8ilaW8014/vwA/LNa+YiFoyyx3s/KswP3O8QW1jtq45yTM/DX9a8M4voTVaO2ebvw1EooDw/yg6Y1faY+WwrdVs5Yt0hQ5EwRfYXSFxray1YvSM+kYmlpLG2/9mm1MfmbKHXr44Ih8nVKb1M537ZANUkCtdsPZ80JVKVKabVHCadaLXg+IV8i5GSwpZti0h6diTaKs9sdpUKEpd7jDUpYmHtiX33SKiO3tuydkaxA7pEc9XIQEOfWJlszj5YpL5bKeQyT7aZSBOamvSHl8xsWvgo26IP/bqk+0EJUz+gkkcvlUlyPp2kdKFtt7y5aCdks9ZJJcFp5ZWeaWKgtnXMN3ORwGLBE0PtkEIek5FY2aVssUZHtsWIvnljMVJtuVIjpZup/5VL1yPOHWWHkOMc6YySWMckczD5jUj2mlLVquFaMU8leGVaqeXis+aRRL8zm4WuBk6cyWfGMxgtr8useQEx7k/PvRoZyd9nde1GUCV84gMX8Ogu/BWezYPSR27llzQnA97oo0pYyxobYUJfsj+ysTm9zJ+S4pk0TGo9VTG0KjqYhTmALfoDZVKla2b5yhv241PxFaLJs3i05K0AAIdcGxCJZmT3ZdT7CliR7q+kur7WdQjygYtOWRL9B8E4s4LI8KpAj7bE0dg7DLOaX+MGeAi0hMMSSWZEz+RudXbZCsGYS0QqiXjH9XQbd8sCB+nIVTq7/T/FDS+zWY9q7Z2fdq1tdLb6v3hKKVDAw5gjj6o9r1wHFROdHc18MJp4SJ2Ucvu+iQ9EgkekW8VCM+psM6y+/2SBy8tNN4a3L1MzP+OLsyvESo5gS7IQOnIqMmviJBVc6zbVG1n8eXiA3j46kmvvtJlewwNDrxk4SbJOtP/TV/lIVK9ueShNbbMHfwnLTLLhbZuO79ec5XvfgRwLFK+w1r5ZWW15rVFZrE+wKqNRv5KqsLNfpGgnoUU6Y71NxEmN7MyqwqAQqoIULOw/LbuUB2+uE75gJt+kq1qY4LoxV+qR/zalupea3D5+WMeaRIn0sAI6DDWDh158fqUb4YhAxhREbUN0qyyJYkBU4V2KARXDT65gW3gRsiv7xSPYEKLwzgriWcWgPr0sbZnv7m1XHNFW6xPdGNZUdxFiUYlmXNjDVWuu7LCkX/nVkrXaJhiYktBISC2xgBXQnNEP+cptWl1eG62a7CPXrnrkTQ5BQASbEqUZWMDiZUisKyHDeLFOaJILUo5f6iDt4ZO8MlqaKLto0AmTHVVbkGuyPa1R/ywZsWRoRDoRdNMMHwYTsklMVnlAd2S0282bgMI8fiJpDh69OSL6K3qbo20KfpNMurnYGQSr/stFqZ7hYsxKlLnKAKhsmB8AIpEQ4bd/NrTLTXefsE6ChRmKWjXKVgpGoPs8GAicgKVw4K0qgDgy1A6hFq1WRat3fHF+FkU+b6H4NWpOU3KXTxrIb2qSHAb+qhm8hiSROi/9ofapjxhyKxxntPpge6KL5Z4+WBMYkAcE6+0Hd3Yh2zBsK2MV3iW0Y6cvOCroXlRb2MMJtdWx+3dkFzGh2Pe3DZ9QpSqpaR/rE1ImOrHqYYyccpiLC22amJIjRWVAherTfpQLmo6/K2pna85GrDuQPlH1Tsar8isAJbXLafSwOof4gg9RkAGm/oYpBQQiPUoyDk2BCQ1k+KILq48ErFo4WSRhHLq/y7mgw3+L85PpP6xWr6cgp9sOjYjKagOrxF148uhuaWtjet953fh1IQiEzgC+d2IgBCcUZqgTAICm2bR8oCjDLBsmg+ThyhfD+zBalsKBY1Ce54Y/t9cwfbLu9SFwEgphfopNA3yNxgyDafUM3mYTovZNgPGdd4ZFFOj1vtfFW3u7N+iHEN1HkeesDMXKPyoCDCGVMo4GCCD6PBhQ3dRZIHy0Y/3MaE5zU9mTCrwwnZojtE+qNpMSkJSpmGe0EzLyFelMJqhfFQ7a50uXxZ8pCc2wxtAKWgHoeamR2O7R+bq7IbPYItO0esdRgoTaY38hZLJ5y02oIVwoPokGIzxAMDuanQ1vn2WDQ00Rh6o5QOaCRu99fwDbQcN0XAuqkFpxT/cfz3slGRVokrNU0iqiMAJFEbKScZdmSkTUznC0U+MfwFOGdLgsewRyPKwBZYSmy6U325iUhBQNxbAC3FLKDV9VSOuQpOOukJ/GAmu/tyEbX9DgEp6dv1zoU0IqzpG6gssSjIYRVPGgU1QAQYRgIT8gEV0EXr1sqeh2I6rXjtmoCYyEDCe/PkFEi/Q48FuT29p557iN+LCwk5CK/CZ2WdAdfQZh2Z9QGrzPLSNRj5igUWzl9Vi0rCqH8G1Kp4QMLkuwMCAypdviDXyOIk0AHTM8HBYKh3b0/F+DxoNj4ZdoZfCpQVdnZarqoMaHWnMLNVcyevytGsrXQEoIbubqWYNo7NRHzdc0zvT21fWVirj7g36iy6pxogfvgHp1xH1Turbz8QyyHnXeBJicpYUctbzApwzZ1HT+FPEXMAgUZetgeGMwt4G+DHiDT2Lu+PT21fjJCAfV16a/Wu1PqOkUHSTKYhWW6PhhHUlNtWzFnA7MbY+r64vkwdpfNB2JfWgWXAvkzd42K4lN9x7Wrg4kIKgXCb4mcW595MCPJ/cTfPAMQMFWwnqwde4w8HZYJFpQwcSMhjVz4B8p6ncSCN1X4klxoIH4BN2J6taBMj6lHkAOs8JJAmXq5xsQtrPIPIIp/HG6i21xMGcFgqDXSRF0xQg14d2uy6HgKE13LSvQe52oShF5Jx1R6avyL4thhXQZHfC94oZzuPUBKFYf1VvDaxIrtV6dNGSx7DO0i1p6CzBkuAmEqyWceQY7F9+U0ObYDzoa1iKao/cOD/v6Q9gHrrr1uCeOk8fST9MG23Ul0KmM3r+Wn6Hi6WAcL7gEeaykicvgjzkjSwFsAXIR81Zx4QJ6oosVyJkCcT+4xAldCcihqvTf94HHUPXYp3REIaR4dhpQF6+FK1H0i9i7Pvh8owu3lO4PT1iuqu+DkL2Bj9+kdfGAg2TXw03iNHyobxofLE2ibjsYDPgeEQlRMR7afXbSGQcnPjI2D+sdtmuQ771dbASUsDndU7t58jrrNGRzISvwioAlHs5FA+cBE5Ccznkd8NMV6BR6ksnKLPZnMUawRDU1MZ/ib3xCdkTblHKu4blNiylH5n213yM0zubEie0o4JhzcfAy3H5qh2l17uLooBNLaO+gzonTH2uF8PQu9EyH+pjGsACTMy4cHzsPdymUSXYJOMP3yTkXqvO/lpvt0cX5ekDEu9PUfBeZODkFuAjXCaGdi6ew4qxJ8PmFfwmPpkgQjQlWqomFY6UkjmcnAtJG75EVR+NpzGpP1Ef5qUUbfowrC3zcSLX3BxgWEgEx/v9cP8H8u1Mvt9/rMDYf6sjwU1xSOPBgzFEeJLMRVFtKo5QHsUYT8ZRLCah27599EuqoC9PYjYO6aoAMHB8X1OHwEAYouHfHB3nyb2B+SnZxM/vw/bCtORjLMSy5aZoEpvgdGvlJfNPFUu/p7Z4VVK1hiI0/UTuB3ZPq4ohEbm7Mntgc1evEtknaosgZSwnDC2BdMmibpeg48X8Ixl+/8+xXdbshQXUPPvx8jT3fkELivHSmqbhblfNFShWAyQnJ3WBU6SMYSIpTDmHjdLVAdlADdz9gCplZw6mTiHqDwIsxbm9ErGusiVpg2w8Q3khKV/R9Oj8PFeF43hmW/nSd99nZzhyjCX3QOZkkB6BsH4H866WGyv9E0hVAzPYah2tkRfQZMmP2rinfOeQalge0ovhduBjJs9a1GBwReerceify49ctOh5/65ATYuMsAkVltmvTLBk4oHpdl6i+p8DoNj4Fb2vhdFYer2JSEilEwPd5n5zNoGBXEjreg/wh2NFnNRaIUHSOXa4eJRwygZoX6vnWnqVdCRT1ARxeFrNBJ+tsdooMwqnYhE7zIxnD8pZH+P0Nu1wWxCPTADfNWmqx626IBJJq6NeapcGeOmbtXvl0TeWG0Y7OGGV4+EHTtNBIT5Wd0Bujl7inXgZgfXTM5efD3qDTJ54O9v3Bkv+tdIRlq1kXcVD0BEMirmFxglNPt5pedb1AnxuCYMChUykwsTIWqT23XDpvTiKEru1cTcEMeniB+HQDehxPXNmkotFdwUPnilB/u4Nx5Xc6l8J9jH1EgKZUUt8t8cyoZleDBEt8oibDmJRAoMKJ5Oe9CSWS5ZMEJvacsGVdXDWjp/Ype5x0p9PXB2PAwt2LRD3d+ftNgpuyvxlP8pB84oB1i73vAVpwyrmXW72hfW6Dzn9Jkj4++0VQ4d0KSx1AsDA4OtXXDo63/w+GD+zC7w5SJaxsmnlYRQ4dgdjA7tTl2KNLnpJ+mvkoDxtt1a4oPaX3EVqj96o9sRKBQqU7ZOiupeAIyLMD+Y3YwHx30XWHB5CQiw7q3mj1EDlP2eBsZbz79ayUMbyHQ7s8gu4Lgip1LiGJj7NQj905/+rgUYKAA5qdrlHKIknWmqfuR+PB8RdBkDg/NgnlT89G72h2NvySnj7UyBwD+mi/IWs1xWbxuVwUIVXun5cMqBtFbrccI+DILjsVQg6eeq0itiRfedn89CvyFtpkxaauEvSANuZmB1p8FGPbU94J9medwsZ9HkUYjmI7OH5HuxendLbxTaYrPuIfE2ffXFKhoNBUp33HsFAXmCV/Vxpq5AYgFoRr5Ay93ZLRlgaIPjhZjXZZChT+aE5iWAXMX0oSFQEtwjiuhQQItTQX5IYrKfKB+queTNplR1Hoflo5/I6aPPmACwQCE2jTOYo5Dz1cs7Sod0KTG/3kEDGk3kUaUCON19xSJCab3kNpWZhSWkO8l+SpW70Wn3g0ciOIJO5JXma6dbos6jyisuxXwUUhj2+1uGhcvuliKtWwsUTw4gi1c/diEEpZHoKoxTBeMDmhPhKTx7TXWRakV8imJR355DcIHkR9IREHxohP4TbyR5LtFU24umRPRmEYHbpe1LghyxPx7YgUHjNbbQFRQhh4KeU1EabXx8FS3JAxp2rwRDoeWkJgWRUSKw6gGP5U2PuO9V4ZuiKXGGzFQuRuf+tkSSsbBtRJKhCi3ENuLlXhPbjTKD4djXVnfXFds6Zb+1XiUrRfyayGxJq1+SYBEfbKlgjiSmk0orgTqzSS+DZ5rTqsJbttiNtp+KMqGE2AHGFw6jQqM5vD6vMptmXV9OAjq49Uf/Lx9Opam+Hn5O9p8qoBBAQixzQZ4eNVkO9sPzJAMyR1y4/RCQQ1s0pV5KAU5sKLw3tkcFbI/JqrjCsK4Mw+W8aod4lioYuawUiCyVWBE/qPaFi5bnkgpfu/ae47174rI1fqQoTbW0HrU6FAejq7ByM0V4zkZTg02/YJK2N7hUQRCeZ4BIgSEqgD8XsjzG6LIsSbuHoIdz/LhFzbNn1clci1NHWJ0/6/O8HJMdIpEZbqi1RrrFfoo/rI/7ufm2MPG5lUI0IYJ4MAiHRTSOFJ2oTverFHYXThkYFIoyFx6rMYFgaOKM4xNWdlOnIcKb/suptptgTOTdVIf4YgdaAjJnIAm4qNNHNQqqAzvi53GkyRCEoseUBrHohZsjUbkR8gfKtc/+Oa72lwxJ8Mq6HDfDATbfbJhzeIuFQJSiw1uZprHlzUf90WgqG76zO0eCB1WdPv1IT6sNxxh91GEL2YpgC97ikFHyoaH92ndwduqZ6IYjkg20DX33MWdoZk7QkcKUCgisIYslOaaLyvIIqRKWQj16jE1DlQWJJaPopWTJjXfixEjRJJo8g4++wuQjbq+WVYjsqCuNIQW3YjnxKe2M5ZKEqq+cX7ZVgnkbsU3RWIyXA1rxv4kGersYJjD//auldXGmcEbcfTeF16Y1708FB1HIfmWv6dSFi6oD4E+RIjCsEZ+kY7dKnwReJJw3xCjKvi3kGN42rvyhUlIz0Bp+fNSV5xwFiuBzG296e5s/oHoFtUyUplmPulIPl+e1CQIQVtjlzLzzzbV+D/OVQtYzo5ixtMi5BmHuG4N/uKfJk5UIREp7+12oZlKtPBomXSzAY0KgtbPzzZoHQxujnREUgBU+O/jKKhgxVhRPtbqyHiUaRwRpHv7pgRPyUrnE7fYkVblGmfTY28tFCvlILC04Tz3ivkNWVazA+OsYrxvRM/hiNn8Fc4bQBeUZABGx5S/xFf9Lbbmk298X7iFg2yeimvsQqqJ+hYbt6uq+Zf9jC+Jcwiccd61NKQtFvGWrgJiHB5lwi6fR8KzYS7EaEHf/ka9EC7H8D+WEa3TEACHBkNSj/cXxFeq4RllC+fUFm2xtstYLL2nos1DfzsC9vqDDdRVcPA3Ho95aEQHvExVThXPqym65llkKlfRXbPTRiDepdylHjmV9YTWAEjlD9DdQnCem7Aj/ml58On366392214B5zrmQz/9ySG2mFqEwjq5sFl5tYJPw5hNz8lyZPUTsr5E0F2C9VMPnZckWP7+mbwp/BiN7f4kf7vtGnZF2JGvjK/sDX1RtcFY5oPQnE4lIAYV49U3C9SP0LCY/9i/WIFK9ORjzM9kG/KGrAuwFmgdEpdLaiqQNpCTGZVuAO65afkY1h33hrqyLjZy92JK3/twdj9pafFcwfXONmPQWldPlMe7jlP24Js0v9m8bIJ9TgS2IuRvE9ZVRaCwSJYOtAfL5H/YS4FfzKWKbek+GFulheyKtDNlBtrdmr+KU+ibHTdalzFUmMfxw3f36x+3cQbJLItSilW9cuvZEMjKw987jykZRlsH/UI+HlKfo2tLwemBEeBFtmxF2xmItA/dAIfQ+rXnm88dqvXa+GapOYVt/2waFimXFx3TC2MUiOi5/Ml+3rj/YU6Ihx2hXgiDXFsUeQkRAD6wF3SCPi2flk7XwKAA4zboqynuELD312EJ88lmDEVOMa1W/K/a8tGylZRMrMoILyoMQzzbDJHNZrhH77L9qSC42HVmKiZ5S0016UTp83gOhCwz9XItK9fgXfK3F5d7nZCBUekoLxrutQaPHa16Rjsa0gTrzyjqTnmcIcrxg6X6dkKiucudc0DD5W4pJPf0vuDW8r5/uw24YfMuxFRpD2ovT2mFX79xH6Jf+MVdv2TYqR6/955QgVPe3JCD/WjAYcLA9tpXgFiEjge2J5ljeI/iUzg91KQuHkII4mmHZxC3XQORLAC6G7uFn5LOmlnXkjFdoO976moNTxElS8HdxWoPAkjjocDR136m2l+f5t6xaaNgdodOvTu0rievnhNAB79WNrVs6EsPgkgfahF9gSFzzAd+rJSraw5Mllit7vUP5YxA843lUpu6/5jAR0RvH4rRXkSg3nE+O5GFyfe+L0s5r3k05FyghSFnKo4TTgs07qj4nTLqOYj6qaW9knJTDkF5OFMYbmCP+8H16Ty482OjvERV6OFyw043L9w3hoJi408sR+SGo1WviXUu8d7qS+ehKjpKwxeCthsm2LBFSFeetx0x4AaKPxtp3CxdWqCsLrB1s/j5TAhc1jNZsXWl6tjo/WDoewxzg8T8NnhZ1niUwL/nhfygLanCnRwaFGDyLw+sfZhyZ1UtYTp8TYB6dE7R3VsKKH95CUxJ8u8N+9u2/9HUNKHW3x3w5GQrfOPafk2w5qZq8MaHT0ebeY3wIsp3rN9lrpIsW9c1ws3VNV+JwNz0Lo9+V7zZr6GD56We6gWVIvtmam5GPPkVAbr74r6SwhuL+TRXtW/0pgyX16VNl4/EAD50TnUPuwrW6OcUO2VlWXS0inq872kk7GUlW6o/ozFKq+Sip6LcTtSDfDrPTcCHhx75H8BeRon+KG2wRwzfDgWhALmiWOMO6h3pm1UCZEPEjScyk7tdLx6WrdA2N1QTPENvNnhCQjW6kl057/qv7IwRryHrZBCwVSbLLnFRiHdTwk8mlYixFt1slEcPD7FVht13HyqVeyD55HOXrh2ElAxJyinGeoFzwKA91zfrdLvDxJSjzmImfvTisreI25EDcVfGsmxLVbfU8PGe/7NmWWKjXcdTJ11jAlVIY/Bv/mcxg/Q10vCHwKG1GW/XbJq5nxDhyLqiorn7Wd7VEVL8UgVzpHMjQ+Z8DUgSukiVwWAKkeTlVVeZ7t1DGnCgJVIdBPZAEK5f8CDyDNo7tK4/5DBjdD5MPV86TaEhGsLVFPQSI68KlBYy84FievdU9gWh6XZrugvtCZmi9vfd6db6V7FmoEcRHnG36VZH8N4aZaldq9zZawt1uBFgxYYx+Gs/qW1jwANeFy+LCoymyM6zgG7j8bGzUyLhvrbJkTYAEdICEb4kMKusKT9V3eIwMLsjdUdgijMc+7iKrr+TxrVWG0U+W95SGrxnxGrE4eaJFfgvAjUM4SAy8UaRwE9j6ZQH5qYAWGtXByvDiLSDfOD0yFA3UCMKSyQ30fyy1mIRg4ZcgZHLNHWl+c9SeijOvbOJxoQy7lTN2r3Y8p6ovxvUY74aOYbuVezryqXA6U+fcp6wSV9X5/OZKP18tB56Ua0gMyxJI7XyNT7IrqN8GsB9rL/kP5KMrjXxgqKLDa+V5OCH6a5hmOWemMUsea9vQl9t5Oce76PrTyTv50ExOqngE3PHPfSL//AItPdB7kGnyTRhVUUFNdJJ2z7RtktZwgmQzhBG/G7QsjZmJfCE7k75EmdIKH7xlnmDrNM/XbTT6FzldcH/rcRGxlPrv4qDScqE7JSmQABJWqRT/TUcJSwoQM+1jvDigvrjjH8oeK2in1S+/yO1j8xAws/T5u0VnIvAPqaE1atNuN0cuRliLcH2j0nTL4JpcR7w9Qya0JoaHgsOiALLCCzRkl1UUESz+ze/gIXHGtDwgYrK6pCFKJ1webSDog4zTlPkgXZqxlQDiYMjhDpwTtBW2WxthWbov9dt2X9XFLFmcF+eEc1UaQ74gqZiZsdj63pH1qcv3Vy8JYciogIVKsJ8Yy3J9w/GhjWVSQAmrS0BPOWK+RKV+0lWqXgYMnIFwpcZVD7zPSp547i9HlflB8gVnSTGmmq1ClO081OW/UH11pEQMfkEdDFzjLC1Cdo/BdL3s7cXb8J++Hzz1rhOUVZFIPehRiZ8VYu6+7Er7j5PSZu9g/GBdmNzJmyCD9wiswj9BZw+T3iBrg81re36ihMLjoVLoWc+62a1U/7qVX5CpvTVF7rocSAKwv4cBVqZm7lLDS/qoXs4fMs/VQi6BtVbNA3uSzKpQfjH1o3x4LrvkOn40zhm6hjduDglzJUwA0POabgdXIndp9fzhOo23Pe+Rk9GSLX0d71Poqry8NQDTzNlsa+JTNG9+UrEf+ngxCjGEsDCc0bz+udVRyHQI1jmEO3S+IOQycEq7XwB6z3wfMfa73m8PVRp+iOgtZfeSBl01xn03vMaQJkyj7vnhGCklsCWVRUl4y+5oNUzQ63B2dbjDF3vikd/3RUMifPYnX5Glfuk2FsV/7RqjI9yKTbE8wJY+74p7qXO8+dIYgjtLD/N8TJtRh04N9tXJA4H59IkMmLElgvr0Q5OCeVfdAt+5hkh4pQgfRMHpL74XatLQpPiOyHRs/OdmHtBf8nOZcxVKzdGclIN16lE7kJ+pVMjspOI+5+TqLRO6m0ZpNXJoZRv9MPDRcAfJUtNZHyig/s2wwReakFgPPJwCQmu1I30/tcBbji+Na53i1W1N+BqoY7Zxo+U/M9XyJ4Ok2SSkBtoOrwuhAY3a03Eu6l8wFdIG1cN+e8hopTkiKF093KuH/BcB39rMiGDLn6XVhGKEaaT/vqb/lufuAdpGExevF1+J9itkFhCfymWr9vGb3BTK4j598zRH7+e+MU9maruZqb0pkGxRDRE1CD4Z8LV4vhgPidk5w2Bq816g3nHw1//j3JStz7NR9HIWELO8TMn3QrP/zZp//+Dv9p429/ogv+GATR+n/UdF+ns9xNkXZQJXY4t9jMkJNUFygAtzndXwjss+yWH9HAnLQQfhAskdZS2l01HLWv7L7us5uTH409pqitvfSOQg/c+Zt7k879P3K9+WV68n7+3cZfuRd/dDPP/03rn+d+/nBvWfgDlt8+LzjqJ/vx3CnNOwiXhho778C96iD+1TBvRZYeP+EH81LE0vVwOOrmCLB3iKzI1x+vJEsrPH4uF0UB4TJ4X3uDfOCo3PYpYe0MF4bouh0DQ/l43fxUF7Y+dpWuvTSffB0yO2UQUETI/LwCZE3BvnevJ7c9zUlY3H58xzke6DNFDQG8n0WtDN4LAYN4nogKav1ezOfK/z+t6tsCTp+dhx4ymjWuCJk1dEUifDP+HyS4iP/Vg9B2jTo9L4NbiBuDS4nuuHW6H+JDQn2JtqRKGkEQPEYE7uzazXIkcxIAqUq1esasZBETlEZY7y7Jo+RoV/IsjY9eIMkUvr42Hc0xqtsavZvhz1OLwSxMOTuqzlhb0WbdOwBH9EYiyBjatz40bUxTHbiWxqJ0uma19qhPruvcWJlbiSSH48OLDDpaHPszvyct41ZfTu10+vjox6kOqK6v0K/gEPphEvMl/vwSv+A4Hhm36JSP9IXTyCZDm4kKsqD5ay8b1Sad/vaiyO5N/sDfEV6Z4q95E+yfjxpqBoBETW2C7xl4pIO2bDODDFurUPwE7EWC2Uplq+AHmBHvir2PSgkR12/Ry65O0aZtQPeXi9mTlF/Wj5GQ+vFkYyhXsLTjrBSP9hwk4GPqDP5rBn5/l8b0mLRAvRSzXHc293bs3s8EsdE3m2exxidWVB4joHR+S+dz5/W+v00K3TqN14CDBth8eWcsTbiwXPsygHdGid0PEdy6HHm2v/IUuV5RVapYmzGsX90mpnIdNGcOOq64Dbc5GUbYpD9M7S+6cLY//QmjxFLP5cuTFRm3vA5rkFZroFnO3bjHF35uU3s8mvL7Tp9nyTc4mymTJ5sLIp7umSnGkO23faehtz3mmTS7fbVx5rP7x3HXIjRNeq/A3xCs9JNB08c9S9BF2O3bOur0ItslFxXgRPdaapBIi4dRpKGxVz7ir69t/bc9qTxjvtOyGOfiLGDhR4fYywHv1WdOplxIV87TpLBy3Wc0QP0P9s4G7FBNOdITS/tep3o3h1TEa5XDDii7fWtqRzUEReP2fbxz7bHWWJdbIOxOUJZtItNZpTFRfj6vm9sYjRxQVO+WTdiOhdPeTJ+8YirPvoeL88l5iLYOHd3b/Imkq+1ZN1El3UikhftuteEYxf1Wujof8Pr4ICTu5ezZyZ4tHQMxlzUHLYO2VMOoNMGL/20S5i2o2obfk+8qqdR7xzbRDbgU0lnuIgz4LelQ5XS7xbLuSQtNS95v3ZUOdaUx/Qd8qxCt6xf2E62yb/HukLO6RyorV8KgYl5YNc75y+KvefrxY+lc/64y9kvWP0a0bDz/rojq+RWjO06WeruWqNFU7r3HPIcLWRql8ICZsz2Ls/qOm/CLn6++X+Qf7mGspYCrZod/lpl6Rw4xN/yuq8gqV4B6aHk1hVE1SfILxWu5gvXqbfARYQpspcxKp1F/c8XOPzkZvmoSw+vEqBLdrq1fr3wAPv5NnM9i8F+jdAuxkP5Z71c6uhK3enlnGymr7UsWZKC12qgUiG8XXGQ9mxnqz4GSIlybF9eXmbqj2sHX+a1jf0gRoONHRdRSrIq03Ty89eQ1GbV/Bk+du4+V15zls+vvERvZ4E7ZbnxWTVjDjb4o/k8jlw44pTIrUGxxuJvBeO+heuhOjpFsO6lVJ/aXnJDa/bM0Ql1cLbXE/Pbv3EZ3vj3iVrB5irjupZTzlnv677NrI9UNYNqbPgp/HZXS+lJmk87wec+7YOxTDo2aw2l3NfDr34VNlvqWJBknuK7oSlZ6/T10zuOoPZOeoIk81N+sL843WJ2Q4Z0fZ3scsqC/JV2fuhWi1jGURSKZV637lf53Xnnx16/vKEXY89aVJ0fv91jGdfG+G4+sniwHes4hS+udOr4RfhFhG/F5gUG35QaU+McuLmclb5ZWmR+sG5V6nf+PxYzlrnFGxpZaK8eqqVo0NfmAWoGfXDiT/FnUbWvzGDOTr8aktOZWg4BYvz5YH12ZbfCcGtNk+dDAZNGWvHov+PIOnY9Prjg8h/wLRrT69suaMVZ5bNuK00lSVpnqSX1NON/81FoP92rYndionwgOiA8WMf4vc8l15KqEEG4yAm2+WAN5Brfu1sq9suWYqgoajgOYt/JCk1gC8wPkK+XKCtRX6TAtgvrnuBgNRmn6I8lVDipOVB9kX6Oxkp4ZKyd1M6Gj8/v2U7k+YQBL95Kb9PQENucJb0JlW3b5tObN7m/Z1j1ev388d7o15zgXsI9CikAGAViR6lkJv7nb4Ak40M2G8TJ447kN+pvfHiOFjSUSP6PM+QfbAywKJCBaxSVxpizHseZUyUBhq59vFwrkyGoRiHbo0apweEZeSLuNiQ+HAekOnarFg00dZNXaPeoHPTRR0FmEyqYExOVaaaO8c0uFUh7U4e/UxdBmthlBDgg257Q33j1hA7HTxSeTTSuVnPZbgW1nodwmG16aKBDKxEetv7D9OjO0JhrbJTnoe+kcGoDJazFSO8/fUN9Jy/g4XK5PUkw2dgPDGpJqBfhe7GA+cjzfE/EGsMM+FV9nj9IAhrSfT/J3QE5TEIYyk5UjsI6ZZcCPr6A8FZUF4g9nnpVmjX90MLSQysIPD0nFzqwCcSJmIb5mYv2Cmk+C1MDFkZQyCBq4c/Yai9LJ6xYkGS/x2s5/frIW2vmG2Wrv0APpCdgCA9snFvfpe8uc0OwdRs4G9973PGEBnQB5qKrCQ6m6X/H7NInZ7y/1674/ZXOVp7OeuCRk8JFS516VHrnH1HkIUIlTIljjHaQtEtkJtosYul77cVwjk3gW1Ajaa6zWeyHGLlpk3VHE2VFzT2yI/EvlGUSz2H9zYE1s4nsKMtMqNyKNtL/59CpFJki5Fou6VXGm8vWATEPwrUVOLvoA8jLuwOzVBCgHB2Cr5V6OwEWtJEKokJkfc87h+sNHTvMb0KVTp5284QTPupoWvQVUwUeogZR3kBMESYo0mfukewRVPKh5+rzLQb7HKjFFIgWhj1w3yN/qCNoPI8XFiUgBNT1hCHBsAz8L7Oyt8wQWUFj92ONn/APyJFg8hzueqoJdNj57ROrFbffuS/XxrSXLTRgj5uxZjpgQYceeMc2wJrahReSKpm3QjHfqExTLAB2ipVumE8pqcZv8LYXQiPHHsgb5BMW8zM5pvQit+mQx8XGaVDcfVbLyMTlY8xcfmm/RSAT/H09UQol5gIz7rESDmnrQ4bURIB4iRXMDQwxgex1GgtDxKp2HayIkR+E/aDmCttNm2C6lytWdfOVzD6X2SpDWjQDlMRvAp1symWv4my1bPCD+E1EmGnMGWhNwmycJnDV2WrQNxO45ukEb08AAffizYKVULp15I4vbNK5DzWwCSUADfmKhfGSUqii1L2UsE8rB7mLuHuUJZOx4+WiizHBJ/hwboaBzhpNOVvgFTf5cJsHef7L1HCI9dOUUbb+YxUJWn6dYOLz+THi91kzY5dtO5c+grX7v0jEbsuoOGnoIreDIg/sFMyG+TyCLIcAWd1IZ1UNFxE8Uie13ucm40U2fcxC0u3WLvLOxwu+F7MWUsHsdtFQZ7W+nlfCASiAKyh8rnP3EyDByvtJb6Kax6/HkLzT9SyEyTMVM1zPtM0MJY14DmsWh4MgD15Ea9Hd00AdkTZ0EiG5NAGuIBzQJJ0JR0na+OB7lQA6UKxMfihIQ7GCCnVz694QvykWXTxpS2soDu+smru1UdIxSvAszBFD1c8c6ZOobA8bJiJIvuycgIXBQIXWwhyTgZDQxJTRXgEwRNAawGSXO0a1DKjdihLVNp/taE/xYhsgwe+VpKEEB4LlraQyE84gEihxCnbfoyOuJIEXy2FIYw+JjRusybKlU2g/vhTSGTydvCvXhYBdtAXtS2v7LkHtmXh/8fly1do8FI/D0f8UbzVb5h+KRhMGSAmR2mhi0YG/uj7wgxcfzCrMvdjitUIpXDX8ae2JcF/36qUWIMwN6JsjaRGNj+jEteGDcFyTUb8X/NHSucKMJp7pduxtD6KuxVlyxxwaeiC1FbGBESO84lbyrAugYxdl+2N8/6AgWpo/IeoAOcsG35IA/b3AuSyoa55L7llBLlaWlEWvuCFd8f8NfcTUgzJv6CbB+6ohWwodlk9nGWFpBAOaz5uEW5xBvmjnHFeDsb0mXwayj3mdYq5gxxNf3H3/tnCgHwjSrpSgVxLmiTtuszdRUFIsn6LiMPjL808vL1uQhDbM7aA43mISXReqjSskynIRcHCJ9qeFopJfx9tqyUoGbSwJex/0aDE3plBPGtNBYgWbdLom3+Q/bjdizR2/AS/c/dH/d3G7pyl1qDXgtOFtEqidwLqxPYtrNEveasWq3vPUUtqTeu8gpov4bdOQRI2kneFvRNMrShyVeEupK1PoLDPMSfWMIJcs267mGB8X9CehQCF0gIyhpP10mbyM7lwW1e6TGvHBV1sg/UyTghHPGRqMyaebC6pbB1WKNCQtlai1GGvmq9zUKaUzLaXsXEBYtHxmFbEZ2kJhR164LhWW2Tlp1dhsGE7ZgIWRBOx3Zcu2DxgH+G83WTPceKG0TgQKKiiNNOlWgvqNEbnrk6fVD+AqRam2OguZb0YWSTX88N+i/ELSxbaUUpPx4vJUzYg/WonSeA8xUK6u7DPHgpqWpEe6D4cXg5uK9FIYVba47V/nb+wyOtk+zG8RrS4EA0ouwa04iByRLSvoJA2FzaobbZtXnq8GdbfqEp5I2dpfpj59TCVif6+E75p665faiX8gS213RqBxTZqfHP46nF6NSenOneuT+vgbLUbdTH2/t0REFXZJOEB6DHvx6N6g9956CYrY/AYcm9gELJXYkrSi+0F0geKDZgOCIYkLU/+GOW5aGj8mvLFgtFH5+XC8hvAE3CvHRfl4ofM/Qwk4x2A+R+nyc9gNu/9Tem7XW4XRnyRymf52z09cTOdr+PG6+P/Vb4QiXlwauc5WB1z3o+IJjlbxI8MyWtSzT+k4sKVbhF3xa+vDts3NxXa87iiu+xRH9cAprnOL2h6vV54iQRXuOAj1s8nLFK8gZ70ThIQcWdF19/2xaJmT0efrkNDkWbpAQPdo92Z8+Hn/aLjbOzB9AI/k12fPs9HhUNDJ1u6ax2VxD3R6PywN7BrLJ26z6s3QoMp76qzzwetrDABKSGkfW5PwS1GvYNUbK6uRqxfyVGNyFB0E+OugMM8kKwmJmupuRWO8XkXXXQECyRVw9UyIrtCtcc4oNqXqr7AURBmKn6Khz3eBN96LwIJrAGP9mr/59uTOSx631suyT+QujDd4beUFpZ0kJEEnjlP+X/Kr2kCKhnENTg4BsMTOmMqlj2WMFLRUlVG0fzdCBgUta9odrJfpVdFomTi6ak0tFjXTcdqqvWBAzjY6hVrH9sbt3Z9gn+AVDpTcQImefbB4edirjzrsNievve4ZT4EUZWV3TxEsIW+9MT/RJoKfZZYSRGfC1CwPG/9rdMOM8qR/LUYvw5f/emUSoD7YSFuOoqchdUg2UePd1eCtFSKgxLSZ764oy4lvRCIH6bowPxZWwxNFctksLeil47pfevcBipkkBIc4ngZG+kxGZ71a72KQ7VaZ6MZOZkQJZXM6kb/Ac0/XkJx8dvyfJcWbI3zONEaEPIW8GbkYjsZcwy+eMoKrYjDmvEEixHzkCSCRPRzhOfJZuLdcbx19EL23MA8rnjTZZ787FGMnkqnpuzB5/90w1gtUSRaWcb0eta8198VEeZMUSfIhyuc4/nywFQ9uqn7jdqXh+5wwv+RK9XouNPbYdoEelNGo34KyySwigsrfCe0v/PlWPvQvQg8R0KgHO18mTVThhQrlbEQ0Kp/JxPdjHyR7E1QPw/ut0r+HDDG7BwZFm9IqEUZRpv2WpzlMkOemeLcAt5CsrzskLGaVOAxyySzZV/D2EY7ydNZMf8e8VhHcKGHAWNszf1EOq8fNstijMY4JXyATwTdncFFqcNDfDo+mWFvxJJpc4sEZtjXyBdoFcxbUmniCoKq5jydUHNjYJxMqN1KzYV62MugcELVhS3Bnd+TLLOh7dws/zSXWzxEb4Nj4aFun5x4kDWLK5TUF/yCXB/cZYvI9kPgVsG2jShtXkxfgT+xzjJofXqPEnIXIQ1lnIdmVzBOM90EXvJUW6a0nZ/7XjJGl8ToO3H/fdxnxmTNKBZxnkpXLVgLXCZywGT3YyS75w/PAH5I/jMuRspej8xZObU9kREbRA+kqjmKRFaKGWAmFQspC+QLbKPf0RaK3OXvBSWqo46p70ws/eZpu6jCtZUgQy6r4tHMPUdAgWGGUYNbuv/1a6K+MVFsd3T183+T8capSo6m0+Sh57fEeG/95dykGJBQMj09DSW2bY0mUonDy9a8trLnnL5B5LW3Nl8rJZNysO8Zb+80zXxqUGFpud3Qzwb7bf+8mq6x0TAnJU9pDQR9YQmZhlna2xuxJt0aCO/f1SU8gblOrbIyMsxTlVUW69VJPzYU2HlRXcqE2lLLxnObZuz2tT9CivfTAUYfmzJlt/lOPgsR6VN64/xQd4Jlk/RV7UKVv2Gx/AWsmTAuCWKhdwC+4HmKEKYZh2Xis4KsUR1BeObs1c13wqFRnocdmuheaTV30gvVXZcouzHKK5zwrN52jXJEuX6dGx3BCpV/++4f3hyaW/cQJLFKqasjsMuO3B3WlMq2gyYfdK1e7L2pO/tRye2mwzwZPfdUMrl5wdLqdd2Kv/wVtnpyWYhd49L6rsOV+8HXPrWH2Kup89l2tz6bf80iYSd+V4LROSOHeamvexR524q4r43rTmtFzQvArpvWfLYFZrbFspBsXNUqqenjxNNsFXatZvlIhk7teUPfK+YL32F8McTnjv0BZNppb+vshoCrtLXjIWq3EJXpVXIlG6ZNL0dh6qEm2WMwDjD3LfOfkGh1/czYc/0qhiD2ozNnH4882MVVt3JbVFkbwowNCO3KL5IoYW5wlVeGCViOuv1svZx7FbzxKzA4zGqBlRRaRWCobXaVq4yYCWbZf8eiJwt3OY+MFiSJengcFP2t0JMfzOiJ7cECvpx7neg1Rc5x+7myPJOXt2FohVRyXtD+/rDoTOyGYInJelZMjolecVHUhUNqvdZWg2J2t0jPmiLFeRD/8fOT4o+NGILb+TufCo9ceBBm3JLVn+MO2675n7qiEX/6W+188cYg3Zn5NSTjgOKfWFSAANa6raCxSoVU851oJLY11WIoYK0du0ec5E4tCnAPoKh71riTsjVIp3gKvBbEYQiNYrmH22oLQWA2AdwMnID6PX9b58dR2QKo4qag1D1Z+L/FwEKTR7osOZPWECPJIHQqPUsM5i/CH5YupVPfFA5pHUBcsesh8eO5YhyWnaVRPZn/BmdXVumZWPxMP5e28zm2uqHgFoT9CymHYNNrzrrjlXZM06HnzDxYNlI5b/QosxLmmrqDFqmogQdqk0WLkUceoAvQxHgkIyvWU69BPFr24VB6+lx75Rna6dGtrmOxDnvBojvi1/4dHjVeg8owofPe1cOnxU1ioh016s/Vudv9mhV9f35At+Sh28h1bpp8xhr09+vf47Elx3Ms6hyp6QvB3t0vnLbOhwo660cp7K0vvepabK7YJfxEWWfrC2YzJfYOjygPwfwd/1amTqa0hZ5ueebhWYVMubRTwIjj+0Oq0ohU3zfRfuL8gt59XsHdwKtxTQQ4Y2qz6gisxnm2UdlmpEkgOsZz7iEk6QOt8BuPwr+NR01LTqXmJo1C76o1N274twJvl+I069TiLpenK/miRxhyY8jvYV6W1WuSwhH9q7kuwnJMtm7IWcqs7HsnyHSqWXLSpYtZGaR1V3t0gauninFPZGtWskF65rtti48UV9uV9KM8kfDYs0pgB00S+TlzTXV6P8mxq15b9En8sz3jWSszcifZa/NuufPNnNTb031pptt0+sRSH/7UG8pzbsgtt3OG3ut7B9JzDMt2mTZuyRNIV8D54TuTrpNcHtgmMlYJeiY9XS83NYJicjRjtJSf9BZLsQv629QdDsKQhTK5CnXhpk7vMNkHzPhm0ExW/VCGApHfPyBagtZQTQmPHx7g5IXXsrQDPzIVhv2LB6Ih138iSDww1JNHrDvzUxvp73MsQBVhW8EbrReaVUcLB1R3PUXyaYG4HpJUcLVxMgDxcPkVRQpL7VTAGabDzbKcvg12t5P8TSGQkrj/gOrpnbiDHwluA73xbXts/L7u468cRWSWRtgTwlQnA47EKg0OiZDgFxAKQQUcsbGomITgeXUAAyKe03eA7Mp4gnyKQmm0LXJtEk6ddksMJCuxDmmHzmVhO+XaN2A54MIh3niw5CF7PwiXFZrnA8wOdeHLvvhdoqIDG9PDI7UnWWHq526T8y6ixJPhkuVKZnoUruOpUgOOp3iIKBjk+yi1vHo5cItHXb1PIKzGaZlRS0g5d3MV2pD8FQdGYLZ73aae/eEIUePMc4NFz8pIUfLCrrF4jVWH5gQneN3S8vANBmUXrEcKGn6hIUN95y1vpsvLwbGpzV9L0ZKTan6TDXM05236uLJcIEMKVAxKNT0K8WljuwNny3BNQRfzovA85beI9zr1AGNYnYCVkR1aGngWURUrgqR+gRrQhxW81l3CHevjvGEPzPMTxdsIfB9dfGRbZU0cg/1mcubtECX4tvaedmNAvTxCJtc2QaoUalGfENCGK7IS/O8CRpdOVca8EWCRwv2sSWE8CJPW5PCugjCXPd3h6U60cPD+bdhtXZuYB6stcoveE7Sm5MM2yvfUHXFSW7KzLmi7/EeEWL0wqcOH9MOSKjhCHHmw+JGLcYE/7SBZQCRggox0ZZTAxrlzNNXYXL5fNIjkdT4YMqVUz6p8YDt049v4OXGdg3qTrtLBUXOZf7ahPlZAY/O+7Sp0bvGSHdyQ8B1LOsplqMb9Se8VAE7gIdSZvxbRSrfl+Lk5Qaqi5QJceqjitdErcHXg/3MryljPSIAMaaloFm1cVwBJ8DNmkDqoGROSHFetrgjQ5CahuKkdH5pRPigMrgTtlFI8ufJPJSUlGgTjbBSvpRc0zypiUn6U5KZqcRoyrtzhmJ7/caeZkmVRwJQeLOG8LY6vP5ChpKhc8Js0El+n6FXqbx9ItdtLtYP92kKfaTLtCi8StLZdENJa9Ex1nOoz1kQ7qxoiZFKRyLf4O4CHRT0T/0W9F8epNKVoeyxUXhy3sQMMsJjQJEyMOjmOhMFgOmmlscV4eFi1CldU92yjwleirEKPW3bPAuEhRZV7JsKV3Lr5cETAiFuX5Nw5UlF7d2HZ96Bh0sgFIL5KGaKSoVYVlvdKpZJVP5+NZ7xDEkQhmDgsDKciazJCXJ6ZN2B3FY2f6VZyGl/t4aunGIAk/BHaS+i+SpdRfnB/OktOvyjinWNfM9Ksr6WwtCa1hCmeRI6icpFM4o8quCLsikU0tMoZI/9EqXRMpKGaWzofl4nQuVQm17d5fU5qXCQeCDqVaL9XJ9qJ08n3G3EFZS28SHEb3cdRBdtO0YcTzil3QknNKEe/smQ1fTb0XbpyNB5xAeuIlf+5KWlEY0DqJbsnzJlQxJPOVyHiKMx5Xu9FcEv1Fbg6Fhm4t+Jyy5JC1W3YO8dYLsO0PXPbxodBgttTbH3rt9Cp1lJIk2r3O1Zqu94eRbnIz2f50lWolYzuKsj4PMok4abHLO8NAC884hiXx5Fy5pWKO0bWL7uEGXaJCtznhP67SlQ4xjWIfgq6EpZ28QMtuZK7JC0RGbl9nA4XtFLug/NLMoH1pGt9IonAJqcEDLyH6TDROcbsmGPaGIxMo41IUAnQVPMPGByp4mOmh9ZQMkBAcksUK55LsZj7E5z5XuZoyWCKu6nHmDq22xI/9Z8YdxJy4kWpD16jLVrpwGLWfyOD0Wd+cBzFBxVaGv7S5k9qwh/5t/LQEXsRqI3Q9Rm3QIoaZW9GlsDaKOUyykyWuhNOprSEi0s1G4rgoiX1V743EELti+pJu5og6X0g6oTynUqlhH9k6ezyRi05NGZHz0nvp3HOJr7ebrAUFrDjbkFBObEvdQWkkUbL0pEvMU46X58vF9j9F3j6kpyetNUBItrEubW9ZvMPM4qNqLlsSBJqOH3XbNwv/cXDXNxN8iFLzUhteisYY+RlHYOuP29/Cb+L+xv+35Rv7xudnZ6ohK4cMPfCG8KI7dNmjNk/H4e84pOxn/sZHK9psfvj8ncA8qJz7O8xqbxESDivGJOZzF7o5PJLQ7g34qAWoyuA+x3btU98LT6ZyGyceIXjrqob2CAVql4VOTQPUQYvHV/g4zAuCZGvYQBtf0wmd5lilrvuEn1BXLny01B4h4SMDlYsnNpm9d7m9h578ufpef9Z4WplqWQvqo52fyUA7J24eZD5av6SyGIV9kpmHNqyvdfzcpEMw97BvknV2fq+MFHun9BT3Lsf8pbzvisWiIQvYkng+8Vxk1V+dli1u56kY50LRjaPdotvT5BwqtwyF+emo/z9J3yVUVGfKrxQtJMOAQWoQii/4dp9wgybSa5mkucmRLtEQZ/pz0tL/NVcgWAd95nEQ3Tg6tNbuyn3Iepz65L3huMUUBntllWuu4DbtOFSMSbpILV4fy6wlM0SOvi6CpLh81c1LreIvKd61uEWBcDw1lUBUW1I0Z+m/PaRlX+PQ/oxg0Ye6KUiIiTF4ADNk59Ydpt5/rkxmq9tV5Kcp/eQLUVVmBzQNVuytQCP6Ezd0G8eLxWyHpmZWJ3bAzkWTtg4lZlw42SQezEmiUPaJUuR/qklVA/87S4ArFCpALdY3QRdUw3G3XbWUp6aq9z0zUizcPa7351p9JXOZyfdZBFnqt90VzQndXB/mwf8LC9STj5kenVpNuqOQQP3mIRJj7eV21FxG8VAxKrEn3c+XfmZ800EPb9/5lIlijscUbB6da0RQaMook0zug1G0tKi/JBC4rw7/D3m4ARzAkzMcVrDcT2SyFtUdWAsFlsPDFqV3N+EjyXaoEePwroaZCiLqEzb8MW+PNE9TmTC01EzWli51PzZvUqkmyuROU+V6ik+Le/9qT6nwzUzf9tP68tYei0YaDGx6kAd7jn1cKqOCuYbiELH9zYqcc4MnRJjkeGiqaGwLImhyeKs+xKJMBlOJ05ow9gGCKZ1VpnMKoSCTbMS+X+23y042zOb5MtcY/6oBeAo1Vy89OTyhpavFP78jXCcFH0t7Gx24hMEOm2gsEfGabVpQgvFqbQKMsknFRRmuPHcZu0Su/WMFphZvB2r/EGbG72rpGGho3h+Msz0uGzJ7hNK2uqQiE1qmn0zgacKYYZBCqsxV+sjbpoVdSilW/b94n2xNb648VmNIoizqEWhBnsen+d0kbCPmRItfWqSBeOd9Wne3c6bcd6uvXOJ6WdiSsuXq0ndhqrQ4QoWUjCjYtZ0EAhnSOP1m44xkf0O7jXghrzSJWxP4a/t72jU29Vu2rvu4n7HfHkkmQOMGSS+NPeLGO5I73mC2B7+lMiBQQZRM9/9liLIfowupUFAbPBbR+lxDM6M8Ptgh1paJq5Rvs7yEuLQv/7d1oU2woFSb3FMPWQOKMuCuJ7pDDjpIclus5TeEoMBy2YdVB4fxmesaCeMNsEgTHKS5WDSGyNUOoEpcC2OFWtIRf0w27ck34/DjxRTVIcc9+kqZE6iMSiVDsiKdP/Xz5XfEhm/sBhO50p1rvJDlkyyxuJ9SPgs7YeUJBjXdeAkE+P9OQJm6SZnn1svcduI78dYmbkE2mtziPrcjVisXG78spLvbZaSFx/Rks9zP4LKn0Cdz/3JsetkT06A8f/yCgMO6Mb1Hme0JJ7b2wZz1qleqTuKBGokhPVUZ0dVu+tnQYNEY1fmkZSz6+EGZ5EzL7657mreZGR3jUfaEk458PDniBzsSmBKhDRzfXameryJv9/D5m6HIqZ0R+ouCE54Dzp4IJuuD1e4Dc5i+PpSORJfG23uVgqixAMDvchMR0nZdH5brclYwRoJRWv/rlxGRI5ffD5NPGmIDt7vDE1434pYdVZIFh89Bs94HGGJbTwrN8T6lh1HZFTOB4lWzWj6EVqxSMvC0/ljWBQ3F2kc/mO2b6tWonT2JEqEwFts8rz2h+oWNds9ceR2cb7zZvJTDppHaEhK5avWqsseWa2Dt5BBhabdWSktS80oMQrL4TvAM9b5HMmyDnO+OkkbMXfUJG7eXqTIG6lqSOEbqVR+qYdP7uWb57WEJqzyh411GAVsDinPs7KvUeXItlcMdOUWzXBH6zscymV1LLVCtc8IePojzXHF9m5b5zGwBRdzcyUJkiu938ApmAayRdJrX1PmVguWUvt2ThQ62czItTyWJMW2An/hdDfMK7SiFQlGIdAbltHz3ycoh7j9V7GxNWBpbtcSdqm4XxRwTawc3cbZ+xfSv9qQfEkDKfZTwCkqWGI/ur250ItXlMlh6vUNWEYIg9A3GzbgmbqvTN8js2YMo87CU5y6nZ4dbJLDQJj9fc7yM7tZzJDZFtqOcU8+mZjYlq4VmifI23iHb1ZoT9E+kT2dolnP1AfiOkt7PQCSykBiXy5mv637IegWSKj9IKrYZf4Lu9+I7ub+mkRdlvYzehh/jaJ9n7HUH5b2IbgeNdkY7wx1yVzxS7pbvky6+nmVUtRllEFfweUQ0/nG017WoUYSxs+j2B4FV/F62EtHlMWZXYrjGHpthnNb1x66LKZ0Qe92INWHdfR/vqp02wMS8r1G4dJqHok8KmQ7947G13a4YXbsGgHcBvRuVu1eAi4/A5+ZixmdSXM73LupB/LH7O9yxLTVXJTyBbI1S49TIROrfVCOb/czZ9pM4JsZx8kUz8dQGv7gUWKxXvTH7QM/3J2OuXXgciUhqY+cgtaOliQQVOYthBLV3xpESZT3rmfEYNZxmpBbb24CRao86prn+i9TNOh8VxRJGXJfXHATJHs1T5txgc/opYrY8XjlGQQbRcoxIBcnVsMjmU1ymmIUL4dviJXndMAJ0Yet+c7O52/p98ytlmAsGBaTAmMhimAnvp1TWNGM9BpuitGj+t810CU2UhorrjPKGtThVC8WaXw04WFnT5fTjqmPyrQ0tN3CkLsctVy2xr0ZWgiWVZ1OrlFjjxJYsOiZv2cAoOvE+7sY0I/TwWcZqMoyIKNOftwP7w++Rfg67ljfovKYa50if3fzE/8aPYVey/Nq35+nH2sLPh/fP5TsylSKGOZ4k69d2PnH43+kq++sRXHQqGArWdwhx+hpwQC6JgT2uxehYU4Zbw7oNb6/HLikPyJROGK2ouyr+vzseESp9G50T4AyFrSqOQ0rroCYP4sMDFBrHn342EyZTMlSyk47rHSq89Y9/nI3zG5lX16Z5lxphguLOcZUndL8wNcrkyjH82jqg8Bo8OYkynrxZvbFno5lUS3OPr8Ko3mX9NoRPdYOKKjD07bvgFgpZ/RF+YzkWvJ/Hs/tUbfeGzGWLxNAjfDzHHMVSDwB5SabQLsIZHiBp43FjGkaienYoDd18hu2BGwOK7U3o70K/WY/kuuKdmdrykIBUdG2mvE91L1JtTbh20mOLbk1vCAamu7utlXeGU2ooVikbU/actcgmsC1FKk2qmj3GWeIWbj4tGIxE7BLcBWUvvcnd/lYxsMV4F917fWeFB/XbINN3qGvIyTpCalz1lVewdIGqeAS/gB8Mi+sA+BqDiX3VGD2eUunTRbSY+AuDy4E3Qx3hAhwnSXX+B0zuj3eQ1miS8Vux2z/l6/BkWtjKGU72aJkOCWhGcSf3+kFkkB15vGOsQrSdFr6qTj0gBYiOlnBO41170gOWHSUoBVRU2JjwppYdhIFDfu7tIRHccSNM5KZOFDPz0TGMAjzzEpeLwTWp+kn201kU6NjbiMQJx83+LX1e1tZ10kuChJZ/XBUQ1dwaBHjTDJDqOympEk8X2M3VtVw21JksChA8w1tTefO3RJ1FMbqZ01bHHkudDB/OhLfe7P5GOHaI28ZXKTMuqo0hLWQ4HabBsGG7NbP1RiXtETz074er6w/OerJWEqjmkq2y51q1BVI+JUudnVa3ogBpzdhFE7fC7kybrAt2Z6RqDjATAUEYeYK45WMupBKQRtQlU+uNsjnzj6ZmGrezA+ASrWxQ6LMkHRXqXwNq7ftv28dUx/ZSJciDXP2SWJsWaN0FjPX9Yko6LobZ7aYW/IdUktI9apTLyHS8DyWPyuoZyxN1TK/vtfxk3HwWh6JczZC8Ftn0bIJay2g+n5wd7lm9rEsKO+svqVmi+c1j88hSCxbzrg4+HEP0Nt1/B6YW1XVm09T1CpAKjc9n18hjqsaFGdfyva1ZG0Xu3ip6N6JGpyTSqY5h4BOlpLPaOnyw45PdXTN+DtAKg7DLrLFTnWusoSBHk3s0d7YouJHq85/R09Tfc37ENXZF48eAYLnq9GLioNcwDZrC6FW6godB8JnqYUPvn0pWLfQz0lM0Yy8Mybgn84Ds3Q9bDP10bLyOV+qzxa4Rd9Dhu7cju8mMaONXK3UqmBQ9qIg7etIwEqM/kECk/Dzja4Bs1xR+Q/tCbc8IKrSGsTdJJ0vge7IG20W687uVmK6icWQ6cD3lwFzgNMGtFvO5qyJeKflGLAAcQZOrkxVwy3cWvqlGpvjmf9Qe6Ap20MPbV92DPV0OhFM4kz8Yr0ffC2zLWSQ1kqY6QdQrttR3kh1YLtQd1kCEv5hVoPIRWl5ERcUTttBIrWp6Xs5Ehh5OUUwI5aEBvuiDmUoENmnVw1FohCrbRp1A1E+XSlWVOTi7ADW+5Ohb9z1vK4qx5R5lPdGCPBJZ00mC+Ssp8VUbgpGAvXWMuWQQRbCqI6Rr2jtxZxtfP7W/8onz+yz0Gs76LaT5HX9ecyiZCB/ZR/gFtMxPsDwohoeCRtiuLxE1GM1vUEUgBv86+eehL58/P56QFGQ/MqOe/vC76L63jzmeax4exd/OKTUvkXg+fOJUHych9xt/9goJMrapSgvXrj8+8vk/N80f22Sewj6cyGqt1B6mztoeklVHHraouhvHJaG/OuBz6DHKMpFmQULU1bRWlyYE0RPXYYkUycIemN7TLtgNCJX6BqdyxDKkegO7nJK5xQ7OVYDZTMf9bVHidtk6DQX9Et+V9M7esgbsYBdEeUpsB0Xvw2kd9+rI7V+m47u+O/tq7mw7262HU1WlS9uFzsV6JxIHNmUCy0QS9e077JGRFbG65z3/dOKB/Zk+yDdKpUmdXjn/aS3N5nv4fK7bMHHmPlHd4E2+iTbV5rpzScRnxk6KARuDTJ8Q1LpK2mP8gj1EbuJ9RIyY+EWK4hCiIDBAS1Tm2IEXAFfgKPgdL9O6mAa06wjCcUAL6EsxPQWO9VNegBPm/0GgkZbDxCynxujX/92vmGcjZRMAY45puak2sFLCLSwXpEsyy5fnF0jGJBhm+fNSHKKUUfy+276A7/feLOFxxUuHRNJI2Osenxyvf8DAGObT60pfTTlhEg9u/KKkhJqm5U1/+BEcSkpFDA5XeCqxwXmPac1jcuZ3JWQ+p0NdWzb/5v1ZvF8GtMTFFEdQjpLO0bwPb0BHNWnip3liDXI2fXf05jjvfJ0NpjLCUgfTh9CMFYVFKEd4Z/OG/2C+N435mnK+9t1gvCiVcaaH7rK4+PjCvpVNiz+t2QyqH1O8x3JKZVl6Q+Lp/XK8wMjVMslOq9FdSw5FtUs/CptXH9PW+wbWHgrV17R5jTVOtGtKFu3nb80T+E0tv9QkzW3J2dbaw/8ddAKZ0pxIaEqLjlPrji3VgJ3GvdFvlqD8075woxh4fVt0JZE0KVFsAvqhe0dqN9b35jtSpnYMXkU+vZq+IAHad3IHc2s/LYrnD1anfG46IFiMIr9oNbZDWvwthqYNqOigaKd/XlLU4XHfk/PXIjPsLy/9/kAtQ+/wKH+hI/IROWj5FPvTZAT9f7j4ZXQyG4M0TujMAFXYkKvEHv1xhySekgXGGqNxWeWKlf8dDAlLuB1cb/qOD+rk7cmwt+1yKpk9cudqBanTi6zTbXRtV8qylNtjyOVKy1HTz0GW9rjt6sSjAZcT5R+KdtyYb0zyqG9pSLuCw5WBwAn7fjBjKLLoxLXMI+52L9cLwIR2B6OllJZLHJ8vDxmWdtF+QJnmt1rsHPIWY20lftk8fYePkAIg6Hgn532QoIpegMxiWgAOfe5/U44APR8Ac0NeZrVh3gEhs12W+tVSiWiUQekf/YBECUy5fdYbA08dd7VzPAP9aiVcIB9k6tY7WdJ1wNV+bHeydNtmC6G5ICtFC1ZwmJU/j8hf0I8TRVKSiz5oYIa93EpUI78X8GYIAZabx47/n8LDAAJ0nNtP1rpROprqKMBRecShca6qXuTSI3jZBLOB3Vp381B5rCGhjSvh/NSVkYp2qIdP/Bg=";
  }
});

// ../../node_modules/brotli/dec/dictionary-browser.js
var require_dictionary_browser = __commonJS({
  "../../node_modules/brotli/dec/dictionary-browser.js"(exports2) {
    var base64 = require_base64_js();
    exports2.init = function() {
      var BrotliDecompressBuffer = require_decode().BrotliDecompressBuffer;
      var compressed = base64.toByteArray(require_dictionary_bin());
      return BrotliDecompressBuffer(compressed);
    };
  }
});

// ../../node_modules/brotli/dec/dictionary.js
var require_dictionary = __commonJS({
  "../../node_modules/brotli/dec/dictionary.js"(exports2) {
    var data2 = require_dictionary_browser();
    exports2.init = function() {
      exports2.dictionary = data2.init();
    };
    exports2.offsetsByLength = new Uint32Array([
      0,
      0,
      0,
      0,
      0,
      4096,
      9216,
      21504,
      35840,
      44032,
      53248,
      63488,
      74752,
      87040,
      93696,
      100864,
      104704,
      106752,
      108928,
      113536,
      115968,
      118528,
      119872,
      121280,
      122016
    ]);
    exports2.sizeBitsByLength = new Uint8Array([
      0,
      0,
      0,
      0,
      10,
      10,
      11,
      11,
      10,
      10,
      10,
      10,
      10,
      9,
      9,
      8,
      7,
      7,
      8,
      7,
      7,
      6,
      6,
      5,
      5
    ]);
    exports2.minDictionaryWordLength = 4;
    exports2.maxDictionaryWordLength = 24;
  }
});

// ../../node_modules/brotli/dec/huffman.js
var require_huffman = __commonJS({
  "../../node_modules/brotli/dec/huffman.js"(exports2) {
    function HuffmanCode(bits, value) {
      this.bits = bits;
      this.value = value;
    }
    exports2.HuffmanCode = HuffmanCode;
    var MAX_LENGTH = 15;
    function GetNextKey(key2, len) {
      var step = 1 << len - 1;
      while (key2 & step) {
        step >>= 1;
      }
      return (key2 & step - 1) + step;
    }
    function ReplicateValue(table, i, step, end, code2) {
      do {
        end -= step;
        table[i + end] = new HuffmanCode(code2.bits, code2.value);
      } while (end > 0);
    }
    function NextTableBitSize(count, len, root_bits) {
      var left2 = 1 << len - root_bits;
      while (len < MAX_LENGTH) {
        left2 -= count[len];
        if (left2 <= 0) break;
        ++len;
        left2 <<= 1;
      }
      return len - root_bits;
    }
    exports2.BrotliBuildHuffmanTable = function(root_table, table, root_bits, code_lengths, code_lengths_size) {
      var start_table = table;
      var code2;
      var len;
      var symbol;
      var key2;
      var step;
      var low;
      var mask;
      var table_bits;
      var table_size;
      var total_size;
      var sorted;
      var count = new Int32Array(MAX_LENGTH + 1);
      var offset4 = new Int32Array(MAX_LENGTH + 1);
      sorted = new Int32Array(code_lengths_size);
      for (symbol = 0; symbol < code_lengths_size; symbol++) {
        count[code_lengths[symbol]]++;
      }
      offset4[1] = 0;
      for (len = 1; len < MAX_LENGTH; len++) {
        offset4[len + 1] = offset4[len] + count[len];
      }
      for (symbol = 0; symbol < code_lengths_size; symbol++) {
        if (code_lengths[symbol] !== 0) {
          sorted[offset4[code_lengths[symbol]]++] = symbol;
        }
      }
      table_bits = root_bits;
      table_size = 1 << table_bits;
      total_size = table_size;
      if (offset4[MAX_LENGTH] === 1) {
        for (key2 = 0; key2 < total_size; ++key2) {
          root_table[table + key2] = new HuffmanCode(0, sorted[0] & 65535);
        }
        return total_size;
      }
      key2 = 0;
      symbol = 0;
      for (len = 1, step = 2; len <= root_bits; ++len, step <<= 1) {
        for (; count[len] > 0; --count[len]) {
          code2 = new HuffmanCode(len & 255, sorted[symbol++] & 65535);
          ReplicateValue(root_table, table + key2, step, table_size, code2);
          key2 = GetNextKey(key2, len);
        }
      }
      mask = total_size - 1;
      low = -1;
      for (len = root_bits + 1, step = 2; len <= MAX_LENGTH; ++len, step <<= 1) {
        for (; count[len] > 0; --count[len]) {
          if ((key2 & mask) !== low) {
            table += table_size;
            table_bits = NextTableBitSize(count, len, root_bits);
            table_size = 1 << table_bits;
            total_size += table_size;
            low = key2 & mask;
            root_table[start_table + low] = new HuffmanCode(table_bits + root_bits & 255, table - start_table - low & 65535);
          }
          code2 = new HuffmanCode(len - root_bits & 255, sorted[symbol++] & 65535);
          ReplicateValue(root_table, table + (key2 >> root_bits), step, table_size, code2);
          key2 = GetNextKey(key2, len);
        }
      }
      return total_size;
    };
  }
});

// ../../node_modules/brotli/dec/context.js
var require_context = __commonJS({
  "../../node_modules/brotli/dec/context.js"(exports2) {
    exports2.lookup = new Uint8Array([
      /* CONTEXT_UTF8, last byte. */
      /* ASCII range. */
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      4,
      4,
      0,
      0,
      4,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      8,
      12,
      16,
      12,
      12,
      20,
      12,
      16,
      24,
      28,
      12,
      12,
      32,
      12,
      36,
      12,
      44,
      44,
      44,
      44,
      44,
      44,
      44,
      44,
      44,
      44,
      32,
      32,
      24,
      40,
      28,
      12,
      12,
      48,
      52,
      52,
      52,
      48,
      52,
      52,
      52,
      48,
      52,
      52,
      52,
      52,
      52,
      48,
      52,
      52,
      52,
      52,
      52,
      48,
      52,
      52,
      52,
      52,
      52,
      24,
      12,
      28,
      12,
      12,
      12,
      56,
      60,
      60,
      60,
      56,
      60,
      60,
      60,
      56,
      60,
      60,
      60,
      60,
      60,
      56,
      60,
      60,
      60,
      60,
      60,
      56,
      60,
      60,
      60,
      60,
      60,
      24,
      12,
      28,
      12,
      0,
      /* UTF8 continuation byte range. */
      0,
      1,
      0,
      1,
      0,
      1,
      0,
      1,
      0,
      1,
      0,
      1,
      0,
      1,
      0,
      1,
      0,
      1,
      0,
      1,
      0,
      1,
      0,
      1,
      0,
      1,
      0,
      1,
      0,
      1,
      0,
      1,
      0,
      1,
      0,
      1,
      0,
      1,
      0,
      1,
      0,
      1,
      0,
      1,
      0,
      1,
      0,
      1,
      0,
      1,
      0,
      1,
      0,
      1,
      0,
      1,
      0,
      1,
      0,
      1,
      0,
      1,
      0,
      1,
      /* UTF8 lead byte range. */
      2,
      3,
      2,
      3,
      2,
      3,
      2,
      3,
      2,
      3,
      2,
      3,
      2,
      3,
      2,
      3,
      2,
      3,
      2,
      3,
      2,
      3,
      2,
      3,
      2,
      3,
      2,
      3,
      2,
      3,
      2,
      3,
      2,
      3,
      2,
      3,
      2,
      3,
      2,
      3,
      2,
      3,
      2,
      3,
      2,
      3,
      2,
      3,
      2,
      3,
      2,
      3,
      2,
      3,
      2,
      3,
      2,
      3,
      2,
      3,
      2,
      3,
      2,
      3,
      /* CONTEXT_UTF8 second last byte. */
      /* ASCII range. */
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      1,
      1,
      1,
      1,
      1,
      1,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      1,
      1,
      1,
      1,
      0,
      /* UTF8 continuation byte range. */
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      /* UTF8 lead byte range. */
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      /* CONTEXT_SIGNED, second last byte. */
      0,
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      2,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      3,
      4,
      4,
      4,
      4,
      4,
      4,
      4,
      4,
      4,
      4,
      4,
      4,
      4,
      4,
      4,
      4,
      4,
      4,
      4,
      4,
      4,
      4,
      4,
      4,
      4,
      4,
      4,
      4,
      4,
      4,
      4,
      4,
      4,
      4,
      4,
      4,
      4,
      4,
      4,
      4,
      4,
      4,
      4,
      4,
      4,
      4,
      4,
      4,
      4,
      4,
      4,
      4,
      4,
      4,
      4,
      4,
      4,
      4,
      4,
      4,
      4,
      4,
      4,
      4,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      6,
      6,
      6,
      6,
      6,
      6,
      6,
      6,
      6,
      6,
      6,
      6,
      6,
      6,
      6,
      7,
      /* CONTEXT_SIGNED, last byte, same as the above values shifted by 3 bits. */
      0,
      8,
      8,
      8,
      8,
      8,
      8,
      8,
      8,
      8,
      8,
      8,
      8,
      8,
      8,
      8,
      16,
      16,
      16,
      16,
      16,
      16,
      16,
      16,
      16,
      16,
      16,
      16,
      16,
      16,
      16,
      16,
      16,
      16,
      16,
      16,
      16,
      16,
      16,
      16,
      16,
      16,
      16,
      16,
      16,
      16,
      16,
      16,
      16,
      16,
      16,
      16,
      16,
      16,
      16,
      16,
      16,
      16,
      16,
      16,
      16,
      16,
      16,
      16,
      24,
      24,
      24,
      24,
      24,
      24,
      24,
      24,
      24,
      24,
      24,
      24,
      24,
      24,
      24,
      24,
      24,
      24,
      24,
      24,
      24,
      24,
      24,
      24,
      24,
      24,
      24,
      24,
      24,
      24,
      24,
      24,
      24,
      24,
      24,
      24,
      24,
      24,
      24,
      24,
      24,
      24,
      24,
      24,
      24,
      24,
      24,
      24,
      24,
      24,
      24,
      24,
      24,
      24,
      24,
      24,
      24,
      24,
      24,
      24,
      24,
      24,
      24,
      24,
      32,
      32,
      32,
      32,
      32,
      32,
      32,
      32,
      32,
      32,
      32,
      32,
      32,
      32,
      32,
      32,
      32,
      32,
      32,
      32,
      32,
      32,
      32,
      32,
      32,
      32,
      32,
      32,
      32,
      32,
      32,
      32,
      32,
      32,
      32,
      32,
      32,
      32,
      32,
      32,
      32,
      32,
      32,
      32,
      32,
      32,
      32,
      32,
      32,
      32,
      32,
      32,
      32,
      32,
      32,
      32,
      32,
      32,
      32,
      32,
      32,
      32,
      32,
      32,
      40,
      40,
      40,
      40,
      40,
      40,
      40,
      40,
      40,
      40,
      40,
      40,
      40,
      40,
      40,
      40,
      40,
      40,
      40,
      40,
      40,
      40,
      40,
      40,
      40,
      40,
      40,
      40,
      40,
      40,
      40,
      40,
      40,
      40,
      40,
      40,
      40,
      40,
      40,
      40,
      40,
      40,
      40,
      40,
      40,
      40,
      40,
      40,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      48,
      56,
      /* CONTEXT_LSB6, last byte. */
      0,
      1,
      2,
      3,
      4,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      12,
      13,
      14,
      15,
      16,
      17,
      18,
      19,
      20,
      21,
      22,
      23,
      24,
      25,
      26,
      27,
      28,
      29,
      30,
      31,
      32,
      33,
      34,
      35,
      36,
      37,
      38,
      39,
      40,
      41,
      42,
      43,
      44,
      45,
      46,
      47,
      48,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      58,
      59,
      60,
      61,
      62,
      63,
      0,
      1,
      2,
      3,
      4,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      12,
      13,
      14,
      15,
      16,
      17,
      18,
      19,
      20,
      21,
      22,
      23,
      24,
      25,
      26,
      27,
      28,
      29,
      30,
      31,
      32,
      33,
      34,
      35,
      36,
      37,
      38,
      39,
      40,
      41,
      42,
      43,
      44,
      45,
      46,
      47,
      48,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      58,
      59,
      60,
      61,
      62,
      63,
      0,
      1,
      2,
      3,
      4,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      12,
      13,
      14,
      15,
      16,
      17,
      18,
      19,
      20,
      21,
      22,
      23,
      24,
      25,
      26,
      27,
      28,
      29,
      30,
      31,
      32,
      33,
      34,
      35,
      36,
      37,
      38,
      39,
      40,
      41,
      42,
      43,
      44,
      45,
      46,
      47,
      48,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      58,
      59,
      60,
      61,
      62,
      63,
      0,
      1,
      2,
      3,
      4,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      12,
      13,
      14,
      15,
      16,
      17,
      18,
      19,
      20,
      21,
      22,
      23,
      24,
      25,
      26,
      27,
      28,
      29,
      30,
      31,
      32,
      33,
      34,
      35,
      36,
      37,
      38,
      39,
      40,
      41,
      42,
      43,
      44,
      45,
      46,
      47,
      48,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      58,
      59,
      60,
      61,
      62,
      63,
      /* CONTEXT_MSB6, last byte. */
      0,
      0,
      0,
      0,
      1,
      1,
      1,
      1,
      2,
      2,
      2,
      2,
      3,
      3,
      3,
      3,
      4,
      4,
      4,
      4,
      5,
      5,
      5,
      5,
      6,
      6,
      6,
      6,
      7,
      7,
      7,
      7,
      8,
      8,
      8,
      8,
      9,
      9,
      9,
      9,
      10,
      10,
      10,
      10,
      11,
      11,
      11,
      11,
      12,
      12,
      12,
      12,
      13,
      13,
      13,
      13,
      14,
      14,
      14,
      14,
      15,
      15,
      15,
      15,
      16,
      16,
      16,
      16,
      17,
      17,
      17,
      17,
      18,
      18,
      18,
      18,
      19,
      19,
      19,
      19,
      20,
      20,
      20,
      20,
      21,
      21,
      21,
      21,
      22,
      22,
      22,
      22,
      23,
      23,
      23,
      23,
      24,
      24,
      24,
      24,
      25,
      25,
      25,
      25,
      26,
      26,
      26,
      26,
      27,
      27,
      27,
      27,
      28,
      28,
      28,
      28,
      29,
      29,
      29,
      29,
      30,
      30,
      30,
      30,
      31,
      31,
      31,
      31,
      32,
      32,
      32,
      32,
      33,
      33,
      33,
      33,
      34,
      34,
      34,
      34,
      35,
      35,
      35,
      35,
      36,
      36,
      36,
      36,
      37,
      37,
      37,
      37,
      38,
      38,
      38,
      38,
      39,
      39,
      39,
      39,
      40,
      40,
      40,
      40,
      41,
      41,
      41,
      41,
      42,
      42,
      42,
      42,
      43,
      43,
      43,
      43,
      44,
      44,
      44,
      44,
      45,
      45,
      45,
      45,
      46,
      46,
      46,
      46,
      47,
      47,
      47,
      47,
      48,
      48,
      48,
      48,
      49,
      49,
      49,
      49,
      50,
      50,
      50,
      50,
      51,
      51,
      51,
      51,
      52,
      52,
      52,
      52,
      53,
      53,
      53,
      53,
      54,
      54,
      54,
      54,
      55,
      55,
      55,
      55,
      56,
      56,
      56,
      56,
      57,
      57,
      57,
      57,
      58,
      58,
      58,
      58,
      59,
      59,
      59,
      59,
      60,
      60,
      60,
      60,
      61,
      61,
      61,
      61,
      62,
      62,
      62,
      62,
      63,
      63,
      63,
      63,
      /* CONTEXT_{M,L}SB6, second last byte, */
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]);
    exports2.lookupOffsets = new Uint16Array([
      /* CONTEXT_LSB6 */
      1024,
      1536,
      /* CONTEXT_MSB6 */
      1280,
      1536,
      /* CONTEXT_UTF8 */
      0,
      256,
      /* CONTEXT_SIGNED */
      768,
      512
    ]);
  }
});

// ../../node_modules/brotli/dec/prefix.js
var require_prefix = __commonJS({
  "../../node_modules/brotli/dec/prefix.js"(exports2) {
    function PrefixCodeRange(offset4, nbits) {
      this.offset = offset4;
      this.nbits = nbits;
    }
    exports2.kBlockLengthPrefixCode = [
      new PrefixCodeRange(1, 2),
      new PrefixCodeRange(5, 2),
      new PrefixCodeRange(9, 2),
      new PrefixCodeRange(13, 2),
      new PrefixCodeRange(17, 3),
      new PrefixCodeRange(25, 3),
      new PrefixCodeRange(33, 3),
      new PrefixCodeRange(41, 3),
      new PrefixCodeRange(49, 4),
      new PrefixCodeRange(65, 4),
      new PrefixCodeRange(81, 4),
      new PrefixCodeRange(97, 4),
      new PrefixCodeRange(113, 5),
      new PrefixCodeRange(145, 5),
      new PrefixCodeRange(177, 5),
      new PrefixCodeRange(209, 5),
      new PrefixCodeRange(241, 6),
      new PrefixCodeRange(305, 6),
      new PrefixCodeRange(369, 7),
      new PrefixCodeRange(497, 8),
      new PrefixCodeRange(753, 9),
      new PrefixCodeRange(1265, 10),
      new PrefixCodeRange(2289, 11),
      new PrefixCodeRange(4337, 12),
      new PrefixCodeRange(8433, 13),
      new PrefixCodeRange(16625, 24)
    ];
    exports2.kInsertLengthPrefixCode = [
      new PrefixCodeRange(0, 0),
      new PrefixCodeRange(1, 0),
      new PrefixCodeRange(2, 0),
      new PrefixCodeRange(3, 0),
      new PrefixCodeRange(4, 0),
      new PrefixCodeRange(5, 0),
      new PrefixCodeRange(6, 1),
      new PrefixCodeRange(8, 1),
      new PrefixCodeRange(10, 2),
      new PrefixCodeRange(14, 2),
      new PrefixCodeRange(18, 3),
      new PrefixCodeRange(26, 3),
      new PrefixCodeRange(34, 4),
      new PrefixCodeRange(50, 4),
      new PrefixCodeRange(66, 5),
      new PrefixCodeRange(98, 5),
      new PrefixCodeRange(130, 6),
      new PrefixCodeRange(194, 7),
      new PrefixCodeRange(322, 8),
      new PrefixCodeRange(578, 9),
      new PrefixCodeRange(1090, 10),
      new PrefixCodeRange(2114, 12),
      new PrefixCodeRange(6210, 14),
      new PrefixCodeRange(22594, 24)
    ];
    exports2.kCopyLengthPrefixCode = [
      new PrefixCodeRange(2, 0),
      new PrefixCodeRange(3, 0),
      new PrefixCodeRange(4, 0),
      new PrefixCodeRange(5, 0),
      new PrefixCodeRange(6, 0),
      new PrefixCodeRange(7, 0),
      new PrefixCodeRange(8, 0),
      new PrefixCodeRange(9, 0),
      new PrefixCodeRange(10, 1),
      new PrefixCodeRange(12, 1),
      new PrefixCodeRange(14, 2),
      new PrefixCodeRange(18, 2),
      new PrefixCodeRange(22, 3),
      new PrefixCodeRange(30, 3),
      new PrefixCodeRange(38, 4),
      new PrefixCodeRange(54, 4),
      new PrefixCodeRange(70, 5),
      new PrefixCodeRange(102, 5),
      new PrefixCodeRange(134, 6),
      new PrefixCodeRange(198, 7),
      new PrefixCodeRange(326, 8),
      new PrefixCodeRange(582, 9),
      new PrefixCodeRange(1094, 10),
      new PrefixCodeRange(2118, 24)
    ];
    exports2.kInsertRangeLut = [
      0,
      0,
      8,
      8,
      0,
      16,
      8,
      16,
      16
    ];
    exports2.kCopyRangeLut = [
      0,
      8,
      0,
      8,
      16,
      0,
      16,
      8,
      16
    ];
  }
});

// ../../node_modules/brotli/dec/transform.js
var require_transform = __commonJS({
  "../../node_modules/brotli/dec/transform.js"(exports2) {
    var BrotliDictionary = require_dictionary();
    var kIdentity = 0;
    var kOmitLast1 = 1;
    var kOmitLast2 = 2;
    var kOmitLast3 = 3;
    var kOmitLast4 = 4;
    var kOmitLast5 = 5;
    var kOmitLast6 = 6;
    var kOmitLast7 = 7;
    var kOmitLast8 = 8;
    var kOmitLast9 = 9;
    var kUppercaseFirst = 10;
    var kUppercaseAll = 11;
    var kOmitFirst1 = 12;
    var kOmitFirst2 = 13;
    var kOmitFirst3 = 14;
    var kOmitFirst4 = 15;
    var kOmitFirst5 = 16;
    var kOmitFirst6 = 17;
    var kOmitFirst7 = 18;
    var kOmitFirst9 = 20;
    function Transform2(prefix3, transform, suffix) {
      this.prefix = new Uint8Array(prefix3.length);
      this.transform = transform;
      this.suffix = new Uint8Array(suffix.length);
      for (var i = 0; i < prefix3.length; i++)
        this.prefix[i] = prefix3.charCodeAt(i);
      for (var i = 0; i < suffix.length; i++)
        this.suffix[i] = suffix.charCodeAt(i);
    }
    var kTransforms = [
      new Transform2("", kIdentity, ""),
      new Transform2("", kIdentity, " "),
      new Transform2(" ", kIdentity, " "),
      new Transform2("", kOmitFirst1, ""),
      new Transform2("", kUppercaseFirst, " "),
      new Transform2("", kIdentity, " the "),
      new Transform2(" ", kIdentity, ""),
      new Transform2("s ", kIdentity, " "),
      new Transform2("", kIdentity, " of "),
      new Transform2("", kUppercaseFirst, ""),
      new Transform2("", kIdentity, " and "),
      new Transform2("", kOmitFirst2, ""),
      new Transform2("", kOmitLast1, ""),
      new Transform2(", ", kIdentity, " "),
      new Transform2("", kIdentity, ", "),
      new Transform2(" ", kUppercaseFirst, " "),
      new Transform2("", kIdentity, " in "),
      new Transform2("", kIdentity, " to "),
      new Transform2("e ", kIdentity, " "),
      new Transform2("", kIdentity, '"'),
      new Transform2("", kIdentity, "."),
      new Transform2("", kIdentity, '">'),
      new Transform2("", kIdentity, "\n"),
      new Transform2("", kOmitLast3, ""),
      new Transform2("", kIdentity, "]"),
      new Transform2("", kIdentity, " for "),
      new Transform2("", kOmitFirst3, ""),
      new Transform2("", kOmitLast2, ""),
      new Transform2("", kIdentity, " a "),
      new Transform2("", kIdentity, " that "),
      new Transform2(" ", kUppercaseFirst, ""),
      new Transform2("", kIdentity, ". "),
      new Transform2(".", kIdentity, ""),
      new Transform2(" ", kIdentity, ", "),
      new Transform2("", kOmitFirst4, ""),
      new Transform2("", kIdentity, " with "),
      new Transform2("", kIdentity, "'"),
      new Transform2("", kIdentity, " from "),
      new Transform2("", kIdentity, " by "),
      new Transform2("", kOmitFirst5, ""),
      new Transform2("", kOmitFirst6, ""),
      new Transform2(" the ", kIdentity, ""),
      new Transform2("", kOmitLast4, ""),
      new Transform2("", kIdentity, ". The "),
      new Transform2("", kUppercaseAll, ""),
      new Transform2("", kIdentity, " on "),
      new Transform2("", kIdentity, " as "),
      new Transform2("", kIdentity, " is "),
      new Transform2("", kOmitLast7, ""),
      new Transform2("", kOmitLast1, "ing "),
      new Transform2("", kIdentity, "\n	"),
      new Transform2("", kIdentity, ":"),
      new Transform2(" ", kIdentity, ". "),
      new Transform2("", kIdentity, "ed "),
      new Transform2("", kOmitFirst9, ""),
      new Transform2("", kOmitFirst7, ""),
      new Transform2("", kOmitLast6, ""),
      new Transform2("", kIdentity, "("),
      new Transform2("", kUppercaseFirst, ", "),
      new Transform2("", kOmitLast8, ""),
      new Transform2("", kIdentity, " at "),
      new Transform2("", kIdentity, "ly "),
      new Transform2(" the ", kIdentity, " of "),
      new Transform2("", kOmitLast5, ""),
      new Transform2("", kOmitLast9, ""),
      new Transform2(" ", kUppercaseFirst, ", "),
      new Transform2("", kUppercaseFirst, '"'),
      new Transform2(".", kIdentity, "("),
      new Transform2("", kUppercaseAll, " "),
      new Transform2("", kUppercaseFirst, '">'),
      new Transform2("", kIdentity, '="'),
      new Transform2(" ", kIdentity, "."),
      new Transform2(".com/", kIdentity, ""),
      new Transform2(" the ", kIdentity, " of the "),
      new Transform2("", kUppercaseFirst, "'"),
      new Transform2("", kIdentity, ". This "),
      new Transform2("", kIdentity, ","),
      new Transform2(".", kIdentity, " "),
      new Transform2("", kUppercaseFirst, "("),
      new Transform2("", kUppercaseFirst, "."),
      new Transform2("", kIdentity, " not "),
      new Transform2(" ", kIdentity, '="'),
      new Transform2("", kIdentity, "er "),
      new Transform2(" ", kUppercaseAll, " "),
      new Transform2("", kIdentity, "al "),
      new Transform2(" ", kUppercaseAll, ""),
      new Transform2("", kIdentity, "='"),
      new Transform2("", kUppercaseAll, '"'),
      new Transform2("", kUppercaseFirst, ". "),
      new Transform2(" ", kIdentity, "("),
      new Transform2("", kIdentity, "ful "),
      new Transform2(" ", kUppercaseFirst, ". "),
      new Transform2("", kIdentity, "ive "),
      new Transform2("", kIdentity, "less "),
      new Transform2("", kUppercaseAll, "'"),
      new Transform2("", kIdentity, "est "),
      new Transform2(" ", kUppercaseFirst, "."),
      new Transform2("", kUppercaseAll, '">'),
      new Transform2(" ", kIdentity, "='"),
      new Transform2("", kUppercaseFirst, ","),
      new Transform2("", kIdentity, "ize "),
      new Transform2("", kUppercaseAll, "."),
      new Transform2("\xC2\xA0", kIdentity, ""),
      new Transform2(" ", kIdentity, ","),
      new Transform2("", kUppercaseFirst, '="'),
      new Transform2("", kUppercaseAll, '="'),
      new Transform2("", kIdentity, "ous "),
      new Transform2("", kUppercaseAll, ", "),
      new Transform2("", kUppercaseFirst, "='"),
      new Transform2(" ", kUppercaseFirst, ","),
      new Transform2(" ", kUppercaseAll, '="'),
      new Transform2(" ", kUppercaseAll, ", "),
      new Transform2("", kUppercaseAll, ","),
      new Transform2("", kUppercaseAll, "("),
      new Transform2("", kUppercaseAll, ". "),
      new Transform2(" ", kUppercaseAll, "."),
      new Transform2("", kUppercaseAll, "='"),
      new Transform2(" ", kUppercaseAll, ". "),
      new Transform2(" ", kUppercaseFirst, '="'),
      new Transform2(" ", kUppercaseAll, "='"),
      new Transform2(" ", kUppercaseFirst, "='")
    ];
    exports2.kTransforms = kTransforms;
    exports2.kNumTransforms = kTransforms.length;
    function ToUpperCase(p, i) {
      if (p[i] < 192) {
        if (p[i] >= 97 && p[i] <= 122) {
          p[i] ^= 32;
        }
        return 1;
      }
      if (p[i] < 224) {
        p[i + 1] ^= 32;
        return 2;
      }
      p[i + 2] ^= 5;
      return 3;
    }
    exports2.transformDictionaryWord = function(dst, idx, word, len, transform) {
      var prefix3 = kTransforms[transform].prefix;
      var suffix = kTransforms[transform].suffix;
      var t2 = kTransforms[transform].transform;
      var skip = t2 < kOmitFirst1 ? 0 : t2 - (kOmitFirst1 - 1);
      var i = 0;
      var start_idx = idx;
      var uppercase;
      if (skip > len) {
        skip = len;
      }
      var prefix_pos = 0;
      while (prefix_pos < prefix3.length) {
        dst[idx++] = prefix3[prefix_pos++];
      }
      word += skip;
      len -= skip;
      if (t2 <= kOmitLast9) {
        len -= t2;
      }
      for (i = 0; i < len; i++) {
        dst[idx++] = BrotliDictionary.dictionary[word + i];
      }
      uppercase = idx - len;
      if (t2 === kUppercaseFirst) {
        ToUpperCase(dst, uppercase);
      } else if (t2 === kUppercaseAll) {
        while (len > 0) {
          var step = ToUpperCase(dst, uppercase);
          uppercase += step;
          len -= step;
        }
      }
      var suffix_pos = 0;
      while (suffix_pos < suffix.length) {
        dst[idx++] = suffix[suffix_pos++];
      }
      return idx - start_idx;
    };
  }
});

// ../../node_modules/brotli/dec/decode.js
var require_decode = __commonJS({
  "../../node_modules/brotli/dec/decode.js"(exports2) {
    var BrotliInput = require_streams().BrotliInput;
    var BrotliOutput = require_streams().BrotliOutput;
    var BrotliBitReader = require_bit_reader();
    var BrotliDictionary = require_dictionary();
    var HuffmanCode = require_huffman().HuffmanCode;
    var BrotliBuildHuffmanTable = require_huffman().BrotliBuildHuffmanTable;
    var Context4 = require_context();
    var Prefix = require_prefix();
    var Transform2 = require_transform();
    var kDefaultCodeLength = 8;
    var kCodeLengthRepeatCode = 16;
    var kNumLiteralCodes = 256;
    var kNumInsertAndCopyCodes = 704;
    var kNumBlockLengthCodes = 26;
    var kLiteralContextBits = 6;
    var kDistanceContextBits = 2;
    var HUFFMAN_TABLE_BITS = 8;
    var HUFFMAN_TABLE_MASK = 255;
    var HUFFMAN_MAX_TABLE_SIZE = 1080;
    var CODE_LENGTH_CODES = 18;
    var kCodeLengthCodeOrder = new Uint8Array([
      1,
      2,
      3,
      4,
      0,
      5,
      17,
      6,
      16,
      7,
      8,
      9,
      10,
      11,
      12,
      13,
      14,
      15
    ]);
    var NUM_DISTANCE_SHORT_CODES = 16;
    var kDistanceShortCodeIndexOffset = new Uint8Array([
      3,
      2,
      1,
      0,
      3,
      3,
      3,
      3,
      3,
      3,
      2,
      2,
      2,
      2,
      2,
      2
    ]);
    var kDistanceShortCodeValueOffset = new Int8Array([
      0,
      0,
      0,
      0,
      -1,
      1,
      -2,
      2,
      -3,
      3,
      -1,
      1,
      -2,
      2,
      -3,
      3
    ]);
    var kMaxHuffmanTableSize = new Uint16Array([
      256,
      402,
      436,
      468,
      500,
      534,
      566,
      598,
      630,
      662,
      694,
      726,
      758,
      790,
      822,
      854,
      886,
      920,
      952,
      984,
      1016,
      1048,
      1080
    ]);
    function DecodeWindowBits(br) {
      var n2;
      if (br.readBits(1) === 0) {
        return 16;
      }
      n2 = br.readBits(3);
      if (n2 > 0) {
        return 17 + n2;
      }
      n2 = br.readBits(3);
      if (n2 > 0) {
        return 8 + n2;
      }
      return 17;
    }
    function DecodeVarLenUint8(br) {
      if (br.readBits(1)) {
        var nbits = br.readBits(3);
        if (nbits === 0) {
          return 1;
        } else {
          return br.readBits(nbits) + (1 << nbits);
        }
      }
      return 0;
    }
    function MetaBlockLength() {
      this.meta_block_length = 0;
      this.input_end = 0;
      this.is_uncompressed = 0;
      this.is_metadata = false;
    }
    function DecodeMetaBlockLength(br) {
      var out = new MetaBlockLength();
      var size_nibbles;
      var size_bytes;
      var i;
      out.input_end = br.readBits(1);
      if (out.input_end && br.readBits(1)) {
        return out;
      }
      size_nibbles = br.readBits(2) + 4;
      if (size_nibbles === 7) {
        out.is_metadata = true;
        if (br.readBits(1) !== 0)
          throw new Error("Invalid reserved bit");
        size_bytes = br.readBits(2);
        if (size_bytes === 0)
          return out;
        for (i = 0; i < size_bytes; i++) {
          var next_byte = br.readBits(8);
          if (i + 1 === size_bytes && size_bytes > 1 && next_byte === 0)
            throw new Error("Invalid size byte");
          out.meta_block_length |= next_byte << i * 8;
        }
      } else {
        for (i = 0; i < size_nibbles; ++i) {
          var next_nibble = br.readBits(4);
          if (i + 1 === size_nibbles && size_nibbles > 4 && next_nibble === 0)
            throw new Error("Invalid size nibble");
          out.meta_block_length |= next_nibble << i * 4;
        }
      }
      ++out.meta_block_length;
      if (!out.input_end && !out.is_metadata) {
        out.is_uncompressed = br.readBits(1);
      }
      return out;
    }
    function ReadSymbol(table, index3, br) {
      var start_index = index3;
      var nbits;
      br.fillBitWindow();
      index3 += br.val_ >>> br.bit_pos_ & HUFFMAN_TABLE_MASK;
      nbits = table[index3].bits - HUFFMAN_TABLE_BITS;
      if (nbits > 0) {
        br.bit_pos_ += HUFFMAN_TABLE_BITS;
        index3 += table[index3].value;
        index3 += br.val_ >>> br.bit_pos_ & (1 << nbits) - 1;
      }
      br.bit_pos_ += table[index3].bits;
      return table[index3].value;
    }
    function ReadHuffmanCodeLengths(code_length_code_lengths, num_symbols, code_lengths, br) {
      var symbol = 0;
      var prev_code_len = kDefaultCodeLength;
      var repeat = 0;
      var repeat_code_len = 0;
      var space = 32768;
      var table = [];
      for (var i = 0; i < 32; i++)
        table.push(new HuffmanCode(0, 0));
      BrotliBuildHuffmanTable(table, 0, 5, code_length_code_lengths, CODE_LENGTH_CODES);
      while (symbol < num_symbols && space > 0) {
        var p = 0;
        var code_len;
        br.readMoreInput();
        br.fillBitWindow();
        p += br.val_ >>> br.bit_pos_ & 31;
        br.bit_pos_ += table[p].bits;
        code_len = table[p].value & 255;
        if (code_len < kCodeLengthRepeatCode) {
          repeat = 0;
          code_lengths[symbol++] = code_len;
          if (code_len !== 0) {
            prev_code_len = code_len;
            space -= 32768 >> code_len;
          }
        } else {
          var extra_bits = code_len - 14;
          var old_repeat;
          var repeat_delta;
          var new_len = 0;
          if (code_len === kCodeLengthRepeatCode) {
            new_len = prev_code_len;
          }
          if (repeat_code_len !== new_len) {
            repeat = 0;
            repeat_code_len = new_len;
          }
          old_repeat = repeat;
          if (repeat > 0) {
            repeat -= 2;
            repeat <<= extra_bits;
          }
          repeat += br.readBits(extra_bits) + 3;
          repeat_delta = repeat - old_repeat;
          if (symbol + repeat_delta > num_symbols) {
            throw new Error("[ReadHuffmanCodeLengths] symbol + repeat_delta > num_symbols");
          }
          for (var x = 0; x < repeat_delta; x++)
            code_lengths[symbol + x] = repeat_code_len;
          symbol += repeat_delta;
          if (repeat_code_len !== 0) {
            space -= repeat_delta << 15 - repeat_code_len;
          }
        }
      }
      if (space !== 0) {
        throw new Error("[ReadHuffmanCodeLengths] space = " + space);
      }
      for (; symbol < num_symbols; symbol++)
        code_lengths[symbol] = 0;
    }
    function ReadHuffmanCode(alphabet_size, tables, table, br) {
      var table_size = 0;
      var simple_code_or_skip;
      var code_lengths = new Uint8Array(alphabet_size);
      br.readMoreInput();
      simple_code_or_skip = br.readBits(2);
      if (simple_code_or_skip === 1) {
        var i;
        var max_bits_counter = alphabet_size - 1;
        var max_bits = 0;
        var symbols = new Int32Array(4);
        var num_symbols = br.readBits(2) + 1;
        while (max_bits_counter) {
          max_bits_counter >>= 1;
          ++max_bits;
        }
        for (i = 0; i < num_symbols; ++i) {
          symbols[i] = br.readBits(max_bits) % alphabet_size;
          code_lengths[symbols[i]] = 2;
        }
        code_lengths[symbols[0]] = 1;
        switch (num_symbols) {
          case 1:
            break;
          case 3:
            if (symbols[0] === symbols[1] || symbols[0] === symbols[2] || symbols[1] === symbols[2]) {
              throw new Error("[ReadHuffmanCode] invalid symbols");
            }
            break;
          case 2:
            if (symbols[0] === symbols[1]) {
              throw new Error("[ReadHuffmanCode] invalid symbols");
            }
            code_lengths[symbols[1]] = 1;
            break;
          case 4:
            if (symbols[0] === symbols[1] || symbols[0] === symbols[2] || symbols[0] === symbols[3] || symbols[1] === symbols[2] || symbols[1] === symbols[3] || symbols[2] === symbols[3]) {
              throw new Error("[ReadHuffmanCode] invalid symbols");
            }
            if (br.readBits(1)) {
              code_lengths[symbols[2]] = 3;
              code_lengths[symbols[3]] = 3;
            } else {
              code_lengths[symbols[0]] = 2;
            }
            break;
        }
      } else {
        var i;
        var code_length_code_lengths = new Uint8Array(CODE_LENGTH_CODES);
        var space = 32;
        var num_codes = 0;
        var huff = [
          new HuffmanCode(2, 0),
          new HuffmanCode(2, 4),
          new HuffmanCode(2, 3),
          new HuffmanCode(3, 2),
          new HuffmanCode(2, 0),
          new HuffmanCode(2, 4),
          new HuffmanCode(2, 3),
          new HuffmanCode(4, 1),
          new HuffmanCode(2, 0),
          new HuffmanCode(2, 4),
          new HuffmanCode(2, 3),
          new HuffmanCode(3, 2),
          new HuffmanCode(2, 0),
          new HuffmanCode(2, 4),
          new HuffmanCode(2, 3),
          new HuffmanCode(4, 5)
        ];
        for (i = simple_code_or_skip; i < CODE_LENGTH_CODES && space > 0; ++i) {
          var code_len_idx = kCodeLengthCodeOrder[i];
          var p = 0;
          var v;
          br.fillBitWindow();
          p += br.val_ >>> br.bit_pos_ & 15;
          br.bit_pos_ += huff[p].bits;
          v = huff[p].value;
          code_length_code_lengths[code_len_idx] = v;
          if (v !== 0) {
            space -= 32 >> v;
            ++num_codes;
          }
        }
        if (!(num_codes === 1 || space === 0))
          throw new Error("[ReadHuffmanCode] invalid num_codes or space");
        ReadHuffmanCodeLengths(code_length_code_lengths, alphabet_size, code_lengths, br);
      }
      table_size = BrotliBuildHuffmanTable(tables, table, HUFFMAN_TABLE_BITS, code_lengths, alphabet_size);
      if (table_size === 0) {
        throw new Error("[ReadHuffmanCode] BuildHuffmanTable failed: ");
      }
      return table_size;
    }
    function ReadBlockLength(table, index3, br) {
      var code2;
      var nbits;
      code2 = ReadSymbol(table, index3, br);
      nbits = Prefix.kBlockLengthPrefixCode[code2].nbits;
      return Prefix.kBlockLengthPrefixCode[code2].offset + br.readBits(nbits);
    }
    function TranslateShortCodes(code2, ringbuffer, index3) {
      var val;
      if (code2 < NUM_DISTANCE_SHORT_CODES) {
        index3 += kDistanceShortCodeIndexOffset[code2];
        index3 &= 3;
        val = ringbuffer[index3] + kDistanceShortCodeValueOffset[code2];
      } else {
        val = code2 - NUM_DISTANCE_SHORT_CODES + 1;
      }
      return val;
    }
    function MoveToFront(v, index3) {
      var value = v[index3];
      var i = index3;
      for (; i; --i) v[i] = v[i - 1];
      v[0] = value;
    }
    function InverseMoveToFrontTransform(v, v_len) {
      var mtf = new Uint8Array(256);
      var i;
      for (i = 0; i < 256; ++i) {
        mtf[i] = i;
      }
      for (i = 0; i < v_len; ++i) {
        var index3 = v[i];
        v[i] = mtf[index3];
        if (index3) MoveToFront(mtf, index3);
      }
    }
    function HuffmanTreeGroup(alphabet_size, num_htrees) {
      this.alphabet_size = alphabet_size;
      this.num_htrees = num_htrees;
      this.codes = new Array(num_htrees + num_htrees * kMaxHuffmanTableSize[alphabet_size + 31 >>> 5]);
      this.htrees = new Uint32Array(num_htrees);
    }
    HuffmanTreeGroup.prototype.decode = function(br) {
      var i;
      var table_size;
      var next2 = 0;
      for (i = 0; i < this.num_htrees; ++i) {
        this.htrees[i] = next2;
        table_size = ReadHuffmanCode(this.alphabet_size, this.codes, next2, br);
        next2 += table_size;
      }
    };
    function DecodeContextMap(context_map_size, br) {
      var out = { num_htrees: null, context_map: null };
      var use_rle_for_zeros;
      var max_run_length_prefix = 0;
      var table;
      var i;
      br.readMoreInput();
      var num_htrees = out.num_htrees = DecodeVarLenUint8(br) + 1;
      var context_map = out.context_map = new Uint8Array(context_map_size);
      if (num_htrees <= 1) {
        return out;
      }
      use_rle_for_zeros = br.readBits(1);
      if (use_rle_for_zeros) {
        max_run_length_prefix = br.readBits(4) + 1;
      }
      table = [];
      for (i = 0; i < HUFFMAN_MAX_TABLE_SIZE; i++) {
        table[i] = new HuffmanCode(0, 0);
      }
      ReadHuffmanCode(num_htrees + max_run_length_prefix, table, 0, br);
      for (i = 0; i < context_map_size; ) {
        var code2;
        br.readMoreInput();
        code2 = ReadSymbol(table, 0, br);
        if (code2 === 0) {
          context_map[i] = 0;
          ++i;
        } else if (code2 <= max_run_length_prefix) {
          var reps = 1 + (1 << code2) + br.readBits(code2);
          while (--reps) {
            if (i >= context_map_size) {
              throw new Error("[DecodeContextMap] i >= context_map_size");
            }
            context_map[i] = 0;
            ++i;
          }
        } else {
          context_map[i] = code2 - max_run_length_prefix;
          ++i;
        }
      }
      if (br.readBits(1)) {
        InverseMoveToFrontTransform(context_map, context_map_size);
      }
      return out;
    }
    function DecodeBlockType(max_block_type, trees, tree_type, block_types, ringbuffers, indexes, br) {
      var ringbuffer = tree_type * 2;
      var index3 = tree_type;
      var type_code = ReadSymbol(trees, tree_type * HUFFMAN_MAX_TABLE_SIZE, br);
      var block_type;
      if (type_code === 0) {
        block_type = ringbuffers[ringbuffer + (indexes[index3] & 1)];
      } else if (type_code === 1) {
        block_type = ringbuffers[ringbuffer + (indexes[index3] - 1 & 1)] + 1;
      } else {
        block_type = type_code - 2;
      }
      if (block_type >= max_block_type) {
        block_type -= max_block_type;
      }
      block_types[tree_type] = block_type;
      ringbuffers[ringbuffer + (indexes[index3] & 1)] = block_type;
      ++indexes[index3];
    }
    function CopyUncompressedBlockToOutput(output, len, pos, ringbuffer, ringbuffer_mask, br) {
      var rb_size = ringbuffer_mask + 1;
      var rb_pos = pos & ringbuffer_mask;
      var br_pos = br.pos_ & BrotliBitReader.IBUF_MASK;
      var nbytes;
      if (len < 8 || br.bit_pos_ + (len << 3) < br.bit_end_pos_) {
        while (len-- > 0) {
          br.readMoreInput();
          ringbuffer[rb_pos++] = br.readBits(8);
          if (rb_pos === rb_size) {
            output.write(ringbuffer, rb_size);
            rb_pos = 0;
          }
        }
        return;
      }
      if (br.bit_end_pos_ < 32) {
        throw new Error("[CopyUncompressedBlockToOutput] br.bit_end_pos_ < 32");
      }
      while (br.bit_pos_ < 32) {
        ringbuffer[rb_pos] = br.val_ >>> br.bit_pos_;
        br.bit_pos_ += 8;
        ++rb_pos;
        --len;
      }
      nbytes = br.bit_end_pos_ - br.bit_pos_ >> 3;
      if (br_pos + nbytes > BrotliBitReader.IBUF_MASK) {
        var tail = BrotliBitReader.IBUF_MASK + 1 - br_pos;
        for (var x = 0; x < tail; x++)
          ringbuffer[rb_pos + x] = br.buf_[br_pos + x];
        nbytes -= tail;
        rb_pos += tail;
        len -= tail;
        br_pos = 0;
      }
      for (var x = 0; x < nbytes; x++)
        ringbuffer[rb_pos + x] = br.buf_[br_pos + x];
      rb_pos += nbytes;
      len -= nbytes;
      if (rb_pos >= rb_size) {
        output.write(ringbuffer, rb_size);
        rb_pos -= rb_size;
        for (var x = 0; x < rb_pos; x++)
          ringbuffer[x] = ringbuffer[rb_size + x];
      }
      while (rb_pos + len >= rb_size) {
        nbytes = rb_size - rb_pos;
        if (br.input_.read(ringbuffer, rb_pos, nbytes) < nbytes) {
          throw new Error("[CopyUncompressedBlockToOutput] not enough bytes");
        }
        output.write(ringbuffer, rb_size);
        len -= nbytes;
        rb_pos = 0;
      }
      if (br.input_.read(ringbuffer, rb_pos, len) < len) {
        throw new Error("[CopyUncompressedBlockToOutput] not enough bytes");
      }
      br.reset();
    }
    function JumpToByteBoundary(br) {
      var new_bit_pos = br.bit_pos_ + 7 & ~7;
      var pad_bits = br.readBits(new_bit_pos - br.bit_pos_);
      return pad_bits == 0;
    }
    function BrotliDecompressedSize(buffer) {
      var input = new BrotliInput(buffer);
      var br = new BrotliBitReader(input);
      DecodeWindowBits(br);
      var out = DecodeMetaBlockLength(br);
      return out.meta_block_length;
    }
    exports2.BrotliDecompressedSize = BrotliDecompressedSize;
    function BrotliDecompressBuffer(buffer, output_size) {
      var input = new BrotliInput(buffer);
      if (output_size == null) {
        output_size = BrotliDecompressedSize(buffer);
      }
      var output_buffer = new Uint8Array(output_size);
      var output = new BrotliOutput(output_buffer);
      BrotliDecompress(input, output);
      if (output.pos < output.buffer.length) {
        output.buffer = output.buffer.subarray(0, output.pos);
      }
      return output.buffer;
    }
    exports2.BrotliDecompressBuffer = BrotliDecompressBuffer;
    function BrotliDecompress(input, output) {
      var i;
      var pos = 0;
      var input_end = 0;
      var window_bits = 0;
      var max_backward_distance;
      var max_distance = 0;
      var ringbuffer_size;
      var ringbuffer_mask;
      var ringbuffer;
      var ringbuffer_end;
      var dist_rb = [16, 15, 11, 4];
      var dist_rb_idx = 0;
      var prev_byte1 = 0;
      var prev_byte2 = 0;
      var hgroup = [new HuffmanTreeGroup(0, 0), new HuffmanTreeGroup(0, 0), new HuffmanTreeGroup(0, 0)];
      var block_type_trees;
      var block_len_trees;
      var br;
      var kRingBufferWriteAheadSlack = 128 + BrotliBitReader.READ_SIZE;
      br = new BrotliBitReader(input);
      window_bits = DecodeWindowBits(br);
      max_backward_distance = (1 << window_bits) - 16;
      ringbuffer_size = 1 << window_bits;
      ringbuffer_mask = ringbuffer_size - 1;
      ringbuffer = new Uint8Array(ringbuffer_size + kRingBufferWriteAheadSlack + BrotliDictionary.maxDictionaryWordLength);
      ringbuffer_end = ringbuffer_size;
      block_type_trees = [];
      block_len_trees = [];
      for (var x = 0; x < 3 * HUFFMAN_MAX_TABLE_SIZE; x++) {
        block_type_trees[x] = new HuffmanCode(0, 0);
        block_len_trees[x] = new HuffmanCode(0, 0);
      }
      while (!input_end) {
        var meta_block_remaining_len = 0;
        var is_uncompressed;
        var block_length = [1 << 28, 1 << 28, 1 << 28];
        var block_type = [0];
        var num_block_types = [1, 1, 1];
        var block_type_rb = [0, 1, 0, 1, 0, 1];
        var block_type_rb_index = [0];
        var distance_postfix_bits;
        var num_direct_distance_codes;
        var distance_postfix_mask;
        var num_distance_codes;
        var context_map = null;
        var context_modes = null;
        var num_literal_htrees;
        var dist_context_map = null;
        var num_dist_htrees;
        var context_offset = 0;
        var context_map_slice = null;
        var literal_htree_index = 0;
        var dist_context_offset = 0;
        var dist_context_map_slice = null;
        var dist_htree_index = 0;
        var context_lookup_offset1 = 0;
        var context_lookup_offset2 = 0;
        var context_mode;
        var htree_command;
        for (i = 0; i < 3; ++i) {
          hgroup[i].codes = null;
          hgroup[i].htrees = null;
        }
        br.readMoreInput();
        var _out = DecodeMetaBlockLength(br);
        meta_block_remaining_len = _out.meta_block_length;
        if (pos + meta_block_remaining_len > output.buffer.length) {
          var tmp = new Uint8Array(pos + meta_block_remaining_len);
          tmp.set(output.buffer);
          output.buffer = tmp;
        }
        input_end = _out.input_end;
        is_uncompressed = _out.is_uncompressed;
        if (_out.is_metadata) {
          JumpToByteBoundary(br);
          for (; meta_block_remaining_len > 0; --meta_block_remaining_len) {
            br.readMoreInput();
            br.readBits(8);
          }
          continue;
        }
        if (meta_block_remaining_len === 0) {
          continue;
        }
        if (is_uncompressed) {
          br.bit_pos_ = br.bit_pos_ + 7 & ~7;
          CopyUncompressedBlockToOutput(
            output,
            meta_block_remaining_len,
            pos,
            ringbuffer,
            ringbuffer_mask,
            br
          );
          pos += meta_block_remaining_len;
          continue;
        }
        for (i = 0; i < 3; ++i) {
          num_block_types[i] = DecodeVarLenUint8(br) + 1;
          if (num_block_types[i] >= 2) {
            ReadHuffmanCode(num_block_types[i] + 2, block_type_trees, i * HUFFMAN_MAX_TABLE_SIZE, br);
            ReadHuffmanCode(kNumBlockLengthCodes, block_len_trees, i * HUFFMAN_MAX_TABLE_SIZE, br);
            block_length[i] = ReadBlockLength(block_len_trees, i * HUFFMAN_MAX_TABLE_SIZE, br);
            block_type_rb_index[i] = 1;
          }
        }
        br.readMoreInput();
        distance_postfix_bits = br.readBits(2);
        num_direct_distance_codes = NUM_DISTANCE_SHORT_CODES + (br.readBits(4) << distance_postfix_bits);
        distance_postfix_mask = (1 << distance_postfix_bits) - 1;
        num_distance_codes = num_direct_distance_codes + (48 << distance_postfix_bits);
        context_modes = new Uint8Array(num_block_types[0]);
        for (i = 0; i < num_block_types[0]; ++i) {
          br.readMoreInput();
          context_modes[i] = br.readBits(2) << 1;
        }
        var _o1 = DecodeContextMap(num_block_types[0] << kLiteralContextBits, br);
        num_literal_htrees = _o1.num_htrees;
        context_map = _o1.context_map;
        var _o2 = DecodeContextMap(num_block_types[2] << kDistanceContextBits, br);
        num_dist_htrees = _o2.num_htrees;
        dist_context_map = _o2.context_map;
        hgroup[0] = new HuffmanTreeGroup(kNumLiteralCodes, num_literal_htrees);
        hgroup[1] = new HuffmanTreeGroup(kNumInsertAndCopyCodes, num_block_types[1]);
        hgroup[2] = new HuffmanTreeGroup(num_distance_codes, num_dist_htrees);
        for (i = 0; i < 3; ++i) {
          hgroup[i].decode(br);
        }
        context_map_slice = 0;
        dist_context_map_slice = 0;
        context_mode = context_modes[block_type[0]];
        context_lookup_offset1 = Context4.lookupOffsets[context_mode];
        context_lookup_offset2 = Context4.lookupOffsets[context_mode + 1];
        htree_command = hgroup[1].htrees[0];
        while (meta_block_remaining_len > 0) {
          var cmd_code;
          var range_idx;
          var insert_code;
          var copy_code;
          var insert_length;
          var copy_length;
          var distance_code;
          var distance;
          var context;
          var j;
          var copy_dst;
          br.readMoreInput();
          if (block_length[1] === 0) {
            DecodeBlockType(
              num_block_types[1],
              block_type_trees,
              1,
              block_type,
              block_type_rb,
              block_type_rb_index,
              br
            );
            block_length[1] = ReadBlockLength(block_len_trees, HUFFMAN_MAX_TABLE_SIZE, br);
            htree_command = hgroup[1].htrees[block_type[1]];
          }
          --block_length[1];
          cmd_code = ReadSymbol(hgroup[1].codes, htree_command, br);
          range_idx = cmd_code >> 6;
          if (range_idx >= 2) {
            range_idx -= 2;
            distance_code = -1;
          } else {
            distance_code = 0;
          }
          insert_code = Prefix.kInsertRangeLut[range_idx] + (cmd_code >> 3 & 7);
          copy_code = Prefix.kCopyRangeLut[range_idx] + (cmd_code & 7);
          insert_length = Prefix.kInsertLengthPrefixCode[insert_code].offset + br.readBits(Prefix.kInsertLengthPrefixCode[insert_code].nbits);
          copy_length = Prefix.kCopyLengthPrefixCode[copy_code].offset + br.readBits(Prefix.kCopyLengthPrefixCode[copy_code].nbits);
          prev_byte1 = ringbuffer[pos - 1 & ringbuffer_mask];
          prev_byte2 = ringbuffer[pos - 2 & ringbuffer_mask];
          for (j = 0; j < insert_length; ++j) {
            br.readMoreInput();
            if (block_length[0] === 0) {
              DecodeBlockType(
                num_block_types[0],
                block_type_trees,
                0,
                block_type,
                block_type_rb,
                block_type_rb_index,
                br
              );
              block_length[0] = ReadBlockLength(block_len_trees, 0, br);
              context_offset = block_type[0] << kLiteralContextBits;
              context_map_slice = context_offset;
              context_mode = context_modes[block_type[0]];
              context_lookup_offset1 = Context4.lookupOffsets[context_mode];
              context_lookup_offset2 = Context4.lookupOffsets[context_mode + 1];
            }
            context = Context4.lookup[context_lookup_offset1 + prev_byte1] | Context4.lookup[context_lookup_offset2 + prev_byte2];
            literal_htree_index = context_map[context_map_slice + context];
            --block_length[0];
            prev_byte2 = prev_byte1;
            prev_byte1 = ReadSymbol(hgroup[0].codes, hgroup[0].htrees[literal_htree_index], br);
            ringbuffer[pos & ringbuffer_mask] = prev_byte1;
            if ((pos & ringbuffer_mask) === ringbuffer_mask) {
              output.write(ringbuffer, ringbuffer_size);
            }
            ++pos;
          }
          meta_block_remaining_len -= insert_length;
          if (meta_block_remaining_len <= 0) break;
          if (distance_code < 0) {
            var context;
            br.readMoreInput();
            if (block_length[2] === 0) {
              DecodeBlockType(
                num_block_types[2],
                block_type_trees,
                2,
                block_type,
                block_type_rb,
                block_type_rb_index,
                br
              );
              block_length[2] = ReadBlockLength(block_len_trees, 2 * HUFFMAN_MAX_TABLE_SIZE, br);
              dist_context_offset = block_type[2] << kDistanceContextBits;
              dist_context_map_slice = dist_context_offset;
            }
            --block_length[2];
            context = (copy_length > 4 ? 3 : copy_length - 2) & 255;
            dist_htree_index = dist_context_map[dist_context_map_slice + context];
            distance_code = ReadSymbol(hgroup[2].codes, hgroup[2].htrees[dist_htree_index], br);
            if (distance_code >= num_direct_distance_codes) {
              var nbits;
              var postfix;
              var offset4;
              distance_code -= num_direct_distance_codes;
              postfix = distance_code & distance_postfix_mask;
              distance_code >>= distance_postfix_bits;
              nbits = (distance_code >> 1) + 1;
              offset4 = (2 + (distance_code & 1) << nbits) - 4;
              distance_code = num_direct_distance_codes + (offset4 + br.readBits(nbits) << distance_postfix_bits) + postfix;
            }
          }
          distance = TranslateShortCodes(distance_code, dist_rb, dist_rb_idx);
          if (distance < 0) {
            throw new Error("[BrotliDecompress] invalid distance");
          }
          if (pos < max_backward_distance && max_distance !== max_backward_distance) {
            max_distance = pos;
          } else {
            max_distance = max_backward_distance;
          }
          copy_dst = pos & ringbuffer_mask;
          if (distance > max_distance) {
            if (copy_length >= BrotliDictionary.minDictionaryWordLength && copy_length <= BrotliDictionary.maxDictionaryWordLength) {
              var offset4 = BrotliDictionary.offsetsByLength[copy_length];
              var word_id = distance - max_distance - 1;
              var shift2 = BrotliDictionary.sizeBitsByLength[copy_length];
              var mask = (1 << shift2) - 1;
              var word_idx = word_id & mask;
              var transform_idx = word_id >> shift2;
              offset4 += word_idx * copy_length;
              if (transform_idx < Transform2.kNumTransforms) {
                var len = Transform2.transformDictionaryWord(ringbuffer, copy_dst, offset4, copy_length, transform_idx);
                copy_dst += len;
                pos += len;
                meta_block_remaining_len -= len;
                if (copy_dst >= ringbuffer_end) {
                  output.write(ringbuffer, ringbuffer_size);
                  for (var _x = 0; _x < copy_dst - ringbuffer_end; _x++)
                    ringbuffer[_x] = ringbuffer[ringbuffer_end + _x];
                }
              } else {
                throw new Error("Invalid backward reference. pos: " + pos + " distance: " + distance + " len: " + copy_length + " bytes left: " + meta_block_remaining_len);
              }
            } else {
              throw new Error("Invalid backward reference. pos: " + pos + " distance: " + distance + " len: " + copy_length + " bytes left: " + meta_block_remaining_len);
            }
          } else {
            if (distance_code > 0) {
              dist_rb[dist_rb_idx & 3] = distance;
              ++dist_rb_idx;
            }
            if (copy_length > meta_block_remaining_len) {
              throw new Error("Invalid backward reference. pos: " + pos + " distance: " + distance + " len: " + copy_length + " bytes left: " + meta_block_remaining_len);
            }
            for (j = 0; j < copy_length; ++j) {
              ringbuffer[pos & ringbuffer_mask] = ringbuffer[pos - distance & ringbuffer_mask];
              if ((pos & ringbuffer_mask) === ringbuffer_mask) {
                output.write(ringbuffer, ringbuffer_size);
              }
              ++pos;
              --meta_block_remaining_len;
            }
          }
          prev_byte1 = ringbuffer[pos - 1 & ringbuffer_mask];
          prev_byte2 = ringbuffer[pos - 2 & ringbuffer_mask];
        }
        pos &= 1073741823;
      }
      output.write(ringbuffer, pos & ringbuffer_mask);
    }
    exports2.BrotliDecompress = BrotliDecompress;
    BrotliDictionary.init();
  }
});

// ../../node_modules/brotli/decompress.js
var require_decompress = __commonJS({
  "../../node_modules/brotli/decompress.js"(exports2, module2) {
    module2.exports = require_decode().BrotliDecompressBuffer;
  }
});

// ../../node_modules/classnames/index.js
var require_classnames = __commonJS({
  "../../node_modules/classnames/index.js"(exports2, module2) {
    (function() {
      "use strict";
      var hasOwn2 = {}.hasOwnProperty;
      function classNames186() {
        var classes = "";
        for (var i = 0; i < arguments.length; i++) {
          var arg = arguments[i];
          if (arg) {
            classes = appendClass(classes, parseValue(arg));
          }
        }
        return classes;
      }
      function parseValue(arg) {
        if (typeof arg === "string" || typeof arg === "number") {
          return arg;
        }
        if (typeof arg !== "object") {
          return "";
        }
        if (Array.isArray(arg)) {
          return classNames186.apply(null, arg);
        }
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) {
          return arg.toString();
        }
        var classes = "";
        for (var key2 in arg) {
          if (hasOwn2.call(arg, key2) && arg[key2]) {
            classes = appendClass(classes, key2);
          }
        }
        return classes;
      }
      function appendClass(value, newClass) {
        if (!newClass) {
          return value;
        }
        if (value) {
          return value + " " + newClass;
        }
        return value + newClass;
      }
      if (typeof module2 !== "undefined" && module2.exports) {
        classNames186.default = classNames186;
        module2.exports = classNames186;
      } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) {
        define("classnames", [], function() {
          return classNames186;
        });
      } else {
        window.classNames = classNames186;
      }
    })();
  }
});

// ../../node_modules/react-is/cjs/react-is.development.js
var require_react_is_development = __commonJS({
  "../../node_modules/react-is/cjs/react-is.development.js"(exports2) {
    "use strict";
    if (true) {
      (function() {
        "use strict";
        var REACT_ELEMENT_TYPE = Symbol.for("react.element");
        var REACT_PORTAL_TYPE = Symbol.for("react.portal");
        var REACT_FRAGMENT_TYPE2 = Symbol.for("react.fragment");
        var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
        var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
        var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
        var REACT_CONTEXT_TYPE = Symbol.for("react.context");
        var REACT_SERVER_CONTEXT_TYPE = Symbol.for("react.server_context");
        var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
        var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
        var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
        var REACT_MEMO_TYPE = Symbol.for("react.memo");
        var REACT_LAZY_TYPE = Symbol.for("react.lazy");
        var REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
        var enableScopeAPI = false;
        var enableCacheElement = false;
        var enableTransitionTracing = false;
        var enableLegacyHidden = false;
        var enableDebugTracing = false;
        var REACT_MODULE_REFERENCE;
        {
          REACT_MODULE_REFERENCE = Symbol.for("react.module.reference");
        }
        function isValidElementType(type5) {
          if (typeof type5 === "string" || typeof type5 === "function") {
            return true;
          }
          if (type5 === REACT_FRAGMENT_TYPE2 || type5 === REACT_PROFILER_TYPE || enableDebugTracing || type5 === REACT_STRICT_MODE_TYPE || type5 === REACT_SUSPENSE_TYPE || type5 === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type5 === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) {
            return true;
          }
          if (typeof type5 === "object" && type5 !== null) {
            if (type5.$$typeof === REACT_LAZY_TYPE || type5.$$typeof === REACT_MEMO_TYPE || type5.$$typeof === REACT_PROVIDER_TYPE || type5.$$typeof === REACT_CONTEXT_TYPE || type5.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
            // types supported by any Flight configuration anywhere since
            // we don't know which Flight build this will end up being used
            // with.
            type5.$$typeof === REACT_MODULE_REFERENCE || type5.getModuleId !== void 0) {
              return true;
            }
          }
          return false;
        }
        function typeOf(object4) {
          if (typeof object4 === "object" && object4 !== null) {
            var $$typeof = object4.$$typeof;
            switch ($$typeof) {
              case REACT_ELEMENT_TYPE:
                var type5 = object4.type;
                switch (type5) {
                  case REACT_FRAGMENT_TYPE2:
                  case REACT_PROFILER_TYPE:
                  case REACT_STRICT_MODE_TYPE:
                  case REACT_SUSPENSE_TYPE:
                  case REACT_SUSPENSE_LIST_TYPE:
                    return type5;
                  default:
                    var $$typeofType = type5 && type5.$$typeof;
                    switch ($$typeofType) {
                      case REACT_SERVER_CONTEXT_TYPE:
                      case REACT_CONTEXT_TYPE:
                      case REACT_FORWARD_REF_TYPE:
                      case REACT_LAZY_TYPE:
                      case REACT_MEMO_TYPE:
                      case REACT_PROVIDER_TYPE:
                        return $$typeofType;
                      default:
                        return $$typeof;
                    }
                }
              case REACT_PORTAL_TYPE:
                return $$typeof;
            }
          }
          return void 0;
        }
        var ContextConsumer = REACT_CONTEXT_TYPE;
        var ContextProvider = REACT_PROVIDER_TYPE;
        var Element3 = REACT_ELEMENT_TYPE;
        var ForwardRef2 = REACT_FORWARD_REF_TYPE;
        var Fragment35 = REACT_FRAGMENT_TYPE2;
        var Lazy = REACT_LAZY_TYPE;
        var Memo = REACT_MEMO_TYPE;
        var Portal2 = REACT_PORTAL_TYPE;
        var Profiler = REACT_PROFILER_TYPE;
        var StrictMode = REACT_STRICT_MODE_TYPE;
        var Suspense = REACT_SUSPENSE_TYPE;
        var SuspenseList = REACT_SUSPENSE_LIST_TYPE;
        var hasWarnedAboutDeprecatedIsAsyncMode = false;
        var hasWarnedAboutDeprecatedIsConcurrentMode = false;
        function isAsyncMode(object4) {
          {
            if (!hasWarnedAboutDeprecatedIsAsyncMode) {
              hasWarnedAboutDeprecatedIsAsyncMode = true;
              console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.");
            }
          }
          return false;
        }
        function isConcurrentMode(object4) {
          {
            if (!hasWarnedAboutDeprecatedIsConcurrentMode) {
              hasWarnedAboutDeprecatedIsConcurrentMode = true;
              console["warn"]("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.");
            }
          }
          return false;
        }
        function isContextConsumer(object4) {
          return typeOf(object4) === REACT_CONTEXT_TYPE;
        }
        function isContextProvider(object4) {
          return typeOf(object4) === REACT_PROVIDER_TYPE;
        }
        function isElement(object4) {
          return typeof object4 === "object" && object4 !== null && object4.$$typeof === REACT_ELEMENT_TYPE;
        }
        function isForwardRef(object4) {
          return typeOf(object4) === REACT_FORWARD_REF_TYPE;
        }
        function isFragment3(object4) {
          return typeOf(object4) === REACT_FRAGMENT_TYPE2;
        }
        function isLazy(object4) {
          return typeOf(object4) === REACT_LAZY_TYPE;
        }
        function isMemo2(object4) {
          return typeOf(object4) === REACT_MEMO_TYPE;
        }
        function isPortal(object4) {
          return typeOf(object4) === REACT_PORTAL_TYPE;
        }
        function isProfiler(object4) {
          return typeOf(object4) === REACT_PROFILER_TYPE;
        }
        function isStrictMode(object4) {
          return typeOf(object4) === REACT_STRICT_MODE_TYPE;
        }
        function isSuspense(object4) {
          return typeOf(object4) === REACT_SUSPENSE_TYPE;
        }
        function isSuspenseList(object4) {
          return typeOf(object4) === REACT_SUSPENSE_LIST_TYPE;
        }
        exports2.ContextConsumer = ContextConsumer;
        exports2.ContextProvider = ContextProvider;
        exports2.Element = Element3;
        exports2.ForwardRef = ForwardRef2;
        exports2.Fragment = Fragment35;
        exports2.Lazy = Lazy;
        exports2.Memo = Memo;
        exports2.Portal = Portal2;
        exports2.Profiler = Profiler;
        exports2.StrictMode = StrictMode;
        exports2.Suspense = Suspense;
        exports2.SuspenseList = SuspenseList;
        exports2.isAsyncMode = isAsyncMode;
        exports2.isConcurrentMode = isConcurrentMode;
        exports2.isContextConsumer = isContextConsumer;
        exports2.isContextProvider = isContextProvider;
        exports2.isElement = isElement;
        exports2.isForwardRef = isForwardRef;
        exports2.isFragment = isFragment3;
        exports2.isLazy = isLazy;
        exports2.isMemo = isMemo2;
        exports2.isPortal = isPortal;
        exports2.isProfiler = isProfiler;
        exports2.isStrictMode = isStrictMode;
        exports2.isSuspense = isSuspense;
        exports2.isSuspenseList = isSuspenseList;
        exports2.isValidElementType = isValidElementType;
        exports2.typeOf = typeOf;
      })();
    }
  }
});

// ../../node_modules/react-is/index.js
var require_react_is = __commonJS({
  "../../node_modules/react-is/index.js"(exports2, module2) {
    "use strict";
    if (false) {
      module2.exports = null;
    } else {
      module2.exports = require_react_is_development();
    }
  }
});

// ../../node_modules/dayjs/dayjs.min.js
var require_dayjs_min = __commonJS({
  "../../node_modules/dayjs/dayjs.min.js"(exports2, module2) {
    !(function(t2, e3) {
      "object" == typeof exports2 && "undefined" != typeof module2 ? module2.exports = e3() : "function" == typeof define && define.amd ? define(e3) : (t2 = "undefined" != typeof globalThis ? globalThis : t2 || self).dayjs = e3();
    })(exports2, (function() {
      "use strict";
      var t2 = 1e3, e3 = 6e4, n2 = 36e5, r2 = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o3 = "week", c = "month", f = "quarter", h2 = "year", d = "date", l2 = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(t3) {
        var e4 = ["th", "st", "nd", "rd"], n3 = t3 % 100;
        return "[" + t3 + (e4[(n3 - 20) % 10] || e4[n3] || e4[0]) + "]";
      } }, m = function(t3, e4, n3) {
        var r3 = String(t3);
        return !r3 || r3.length >= e4 ? t3 : "" + Array(e4 + 1 - r3.length).join(n3) + t3;
      }, v = { s: m, z: function(t3) {
        var e4 = -t3.utcOffset(), n3 = Math.abs(e4), r3 = Math.floor(n3 / 60), i2 = n3 % 60;
        return (e4 <= 0 ? "+" : "-") + m(r3, 2, "0") + ":" + m(i2, 2, "0");
      }, m: function t3(e4, n3) {
        if (e4.date() < n3.date()) return -t3(n3, e4);
        var r3 = 12 * (n3.year() - e4.year()) + (n3.month() - e4.month()), i2 = e4.clone().add(r3, c), s2 = n3 - i2 < 0, u2 = e4.clone().add(r3 + (s2 ? -1 : 1), c);
        return +(-(r3 + (n3 - i2) / (s2 ? i2 - u2 : u2 - i2)) || 0);
      }, a: function(t3) {
        return t3 < 0 ? Math.ceil(t3) || 0 : Math.floor(t3);
      }, p: function(t3) {
        return { M: c, y: h2, w: o3, d: a, D: d, h: u, m: s, s: i, ms: r2, Q: f }[t3] || String(t3 || "").toLowerCase().replace(/s$/, "");
      }, u: function(t3) {
        return void 0 === t3;
      } }, g = "en", D = {};
      D[g] = M;
      var p = "$isDayjsObject", S = function(t3) {
        return t3 instanceof _ || !(!t3 || !t3[p]);
      }, w = function t3(e4, n3, r3) {
        var i2;
        if (!e4) return g;
        if ("string" == typeof e4) {
          var s2 = e4.toLowerCase();
          D[s2] && (i2 = s2), n3 && (D[s2] = n3, i2 = s2);
          var u2 = e4.split("-");
          if (!i2 && u2.length > 1) return t3(u2[0]);
        } else {
          var a2 = e4.name;
          D[a2] = e4, i2 = a2;
        }
        return !r3 && i2 && (g = i2), i2 || !r3 && g;
      }, O = function(t3, e4) {
        if (S(t3)) return t3.clone();
        var n3 = "object" == typeof e4 ? e4 : {};
        return n3.date = t3, n3.args = arguments, new _(n3);
      }, b = v;
      b.l = w, b.i = S, b.w = function(t3, e4) {
        return O(t3, { locale: e4.$L, utc: e4.$u, x: e4.$x, $offset: e4.$offset });
      };
      var _ = (function() {
        function M2(t3) {
          this.$L = w(t3.locale, null, true), this.parse(t3), this.$x = this.$x || t3.x || {}, this[p] = true;
        }
        var m2 = M2.prototype;
        return m2.parse = function(t3) {
          this.$d = (function(t4) {
            var e4 = t4.date, n3 = t4.utc;
            if (null === e4) return /* @__PURE__ */ new Date(NaN);
            if (b.u(e4)) return /* @__PURE__ */ new Date();
            if (e4 instanceof Date) return new Date(e4);
            if ("string" == typeof e4 && !/Z$/i.test(e4)) {
              var r3 = e4.match($);
              if (r3) {
                var i2 = r3[2] - 1 || 0, s2 = (r3[7] || "0").substring(0, 3);
                return n3 ? new Date(Date.UTC(r3[1], i2, r3[3] || 1, r3[4] || 0, r3[5] || 0, r3[6] || 0, s2)) : new Date(r3[1], i2, r3[3] || 1, r3[4] || 0, r3[5] || 0, r3[6] || 0, s2);
              }
            }
            return new Date(e4);
          })(t3), this.init();
        }, m2.init = function() {
          var t3 = this.$d;
          this.$y = t3.getFullYear(), this.$M = t3.getMonth(), this.$D = t3.getDate(), this.$W = t3.getDay(), this.$H = t3.getHours(), this.$m = t3.getMinutes(), this.$s = t3.getSeconds(), this.$ms = t3.getMilliseconds();
        }, m2.$utils = function() {
          return b;
        }, m2.isValid = function() {
          return !(this.$d.toString() === l2);
        }, m2.isSame = function(t3, e4) {
          var n3 = O(t3);
          return this.startOf(e4) <= n3 && n3 <= this.endOf(e4);
        }, m2.isAfter = function(t3, e4) {
          return O(t3) < this.startOf(e4);
        }, m2.isBefore = function(t3, e4) {
          return this.endOf(e4) < O(t3);
        }, m2.$g = function(t3, e4, n3) {
          return b.u(t3) ? this[e4] : this.set(n3, t3);
        }, m2.unix = function() {
          return Math.floor(this.valueOf() / 1e3);
        }, m2.valueOf = function() {
          return this.$d.getTime();
        }, m2.startOf = function(t3, e4) {
          var n3 = this, r3 = !!b.u(e4) || e4, f2 = b.p(t3), l3 = function(t4, e5) {
            var i2 = b.w(n3.$u ? Date.UTC(n3.$y, e5, t4) : new Date(n3.$y, e5, t4), n3);
            return r3 ? i2 : i2.endOf(a);
          }, $2 = function(t4, e5) {
            return b.w(n3.toDate()[t4].apply(n3.toDate("s"), (r3 ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(e5)), n3);
          }, y2 = this.$W, M3 = this.$M, m3 = this.$D, v2 = "set" + (this.$u ? "UTC" : "");
          switch (f2) {
            case h2:
              return r3 ? l3(1, 0) : l3(31, 11);
            case c:
              return r3 ? l3(1, M3) : l3(0, M3 + 1);
            case o3:
              var g2 = this.$locale().weekStart || 0, D2 = (y2 < g2 ? y2 + 7 : y2) - g2;
              return l3(r3 ? m3 - D2 : m3 + (6 - D2), M3);
            case a:
            case d:
              return $2(v2 + "Hours", 0);
            case u:
              return $2(v2 + "Minutes", 1);
            case s:
              return $2(v2 + "Seconds", 2);
            case i:
              return $2(v2 + "Milliseconds", 3);
            default:
              return this.clone();
          }
        }, m2.endOf = function(t3) {
          return this.startOf(t3, false);
        }, m2.$set = function(t3, e4) {
          var n3, o4 = b.p(t3), f2 = "set" + (this.$u ? "UTC" : ""), l3 = (n3 = {}, n3[a] = f2 + "Date", n3[d] = f2 + "Date", n3[c] = f2 + "Month", n3[h2] = f2 + "FullYear", n3[u] = f2 + "Hours", n3[s] = f2 + "Minutes", n3[i] = f2 + "Seconds", n3[r2] = f2 + "Milliseconds", n3)[o4], $2 = o4 === a ? this.$D + (e4 - this.$W) : e4;
          if (o4 === c || o4 === h2) {
            var y2 = this.clone().set(d, 1);
            y2.$d[l3]($2), y2.init(), this.$d = y2.set(d, Math.min(this.$D, y2.daysInMonth())).$d;
          } else l3 && this.$d[l3]($2);
          return this.init(), this;
        }, m2.set = function(t3, e4) {
          return this.clone().$set(t3, e4);
        }, m2.get = function(t3) {
          return this[b.p(t3)]();
        }, m2.add = function(r3, f2) {
          var d2, l3 = this;
          r3 = Number(r3);
          var $2 = b.p(f2), y2 = function(t3) {
            var e4 = O(l3);
            return b.w(e4.date(e4.date() + Math.round(t3 * r3)), l3);
          };
          if ($2 === c) return this.set(c, this.$M + r3);
          if ($2 === h2) return this.set(h2, this.$y + r3);
          if ($2 === a) return y2(1);
          if ($2 === o3) return y2(7);
          var M3 = (d2 = {}, d2[s] = e3, d2[u] = n2, d2[i] = t2, d2)[$2] || 1, m3 = this.$d.getTime() + r3 * M3;
          return b.w(m3, this);
        }, m2.subtract = function(t3, e4) {
          return this.add(-1 * t3, e4);
        }, m2.format = function(t3) {
          var e4 = this, n3 = this.$locale();
          if (!this.isValid()) return n3.invalidDate || l2;
          var r3 = t3 || "YYYY-MM-DDTHH:mm:ssZ", i2 = b.z(this), s2 = this.$H, u2 = this.$m, a2 = this.$M, o4 = n3.weekdays, c2 = n3.months, f2 = n3.meridiem, h3 = function(t4, n4, i3, s3) {
            return t4 && (t4[n4] || t4(e4, r3)) || i3[n4].slice(0, s3);
          }, d2 = function(t4) {
            return b.s(s2 % 12 || 12, t4, "0");
          }, $2 = f2 || function(t4, e5, n4) {
            var r4 = t4 < 12 ? "AM" : "PM";
            return n4 ? r4.toLowerCase() : r4;
          };
          return r3.replace(y, (function(t4, r4) {
            return r4 || (function(t5) {
              switch (t5) {
                case "YY":
                  return String(e4.$y).slice(-2);
                case "YYYY":
                  return b.s(e4.$y, 4, "0");
                case "M":
                  return a2 + 1;
                case "MM":
                  return b.s(a2 + 1, 2, "0");
                case "MMM":
                  return h3(n3.monthsShort, a2, c2, 3);
                case "MMMM":
                  return h3(c2, a2);
                case "D":
                  return e4.$D;
                case "DD":
                  return b.s(e4.$D, 2, "0");
                case "d":
                  return String(e4.$W);
                case "dd":
                  return h3(n3.weekdaysMin, e4.$W, o4, 2);
                case "ddd":
                  return h3(n3.weekdaysShort, e4.$W, o4, 3);
                case "dddd":
                  return o4[e4.$W];
                case "H":
                  return String(s2);
                case "HH":
                  return b.s(s2, 2, "0");
                case "h":
                  return d2(1);
                case "hh":
                  return d2(2);
                case "a":
                  return $2(s2, u2, true);
                case "A":
                  return $2(s2, u2, false);
                case "m":
                  return String(u2);
                case "mm":
                  return b.s(u2, 2, "0");
                case "s":
                  return String(e4.$s);
                case "ss":
                  return b.s(e4.$s, 2, "0");
                case "SSS":
                  return b.s(e4.$ms, 3, "0");
                case "Z":
                  return i2;
              }
              return null;
            })(t4) || i2.replace(":", "");
          }));
        }, m2.utcOffset = function() {
          return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m2.diff = function(r3, d2, l3) {
          var $2, y2 = this, M3 = b.p(d2), m3 = O(r3), v2 = (m3.utcOffset() - this.utcOffset()) * e3, g2 = this - m3, D2 = function() {
            return b.m(y2, m3);
          };
          switch (M3) {
            case h2:
              $2 = D2() / 12;
              break;
            case c:
              $2 = D2();
              break;
            case f:
              $2 = D2() / 3;
              break;
            case o3:
              $2 = (g2 - v2) / 6048e5;
              break;
            case a:
              $2 = (g2 - v2) / 864e5;
              break;
            case u:
              $2 = g2 / n2;
              break;
            case s:
              $2 = g2 / e3;
              break;
            case i:
              $2 = g2 / t2;
              break;
            default:
              $2 = g2;
          }
          return l3 ? $2 : b.a($2);
        }, m2.daysInMonth = function() {
          return this.endOf(c).$D;
        }, m2.$locale = function() {
          return D[this.$L];
        }, m2.locale = function(t3, e4) {
          if (!t3) return this.$L;
          var n3 = this.clone(), r3 = w(t3, e4, true);
          return r3 && (n3.$L = r3), n3;
        }, m2.clone = function() {
          return b.w(this.$d, this);
        }, m2.toDate = function() {
          return new Date(this.valueOf());
        }, m2.toJSON = function() {
          return this.isValid() ? this.toISOString() : null;
        }, m2.toISOString = function() {
          return this.$d.toISOString();
        }, m2.toString = function() {
          return this.$d.toUTCString();
        }, M2;
      })(), k = _.prototype;
      return O.prototype = k, [["$ms", r2], ["$s", i], ["$m", s], ["$H", u], ["$W", a], ["$M", c], ["$y", h2], ["$D", d]].forEach((function(t3) {
        k[t3[1]] = function(e4) {
          return this.$g(e4, t3[0], t3[1]);
        };
      })), O.extend = function(t3, e4) {
        return t3.$i || (t3(e4, _, O), t3.$i = true), O;
      }, O.locale = w, O.isDayjs = S, O.unix = function(t3) {
        return O(1e3 * t3);
      }, O.en = D[g], O.Ls = D, O.p = {}, O;
    }));
  }
});

// ../../node_modules/dayjs/plugin/weekday.js
var require_weekday = __commonJS({
  "../../node_modules/dayjs/plugin/weekday.js"(exports2, module2) {
    !(function(e3, t2) {
      "object" == typeof exports2 && "undefined" != typeof module2 ? module2.exports = t2() : "function" == typeof define && define.amd ? define(t2) : (e3 = "undefined" != typeof globalThis ? globalThis : e3 || self).dayjs_plugin_weekday = t2();
    })(exports2, (function() {
      "use strict";
      return function(e3, t2) {
        t2.prototype.weekday = function(e4) {
          var t3 = this.$locale().weekStart || 0, i = this.$W, n2 = (i < t3 ? i + 7 : i) - t3;
          return this.$utils().u(e4) ? n2 : this.subtract(n2, "day").add(e4, "day");
        };
      };
    }));
  }
});

// ../../node_modules/dayjs/plugin/localeData.js
var require_localeData = __commonJS({
  "../../node_modules/dayjs/plugin/localeData.js"(exports2, module2) {
    !(function(n2, e3) {
      "object" == typeof exports2 && "undefined" != typeof module2 ? module2.exports = e3() : "function" == typeof define && define.amd ? define(e3) : (n2 = "undefined" != typeof globalThis ? globalThis : n2 || self).dayjs_plugin_localeData = e3();
    })(exports2, (function() {
      "use strict";
      return function(n2, e3, t2) {
        var r2 = e3.prototype, o3 = function(n3) {
          return n3 && (n3.indexOf ? n3 : n3.s);
        }, u = function(n3, e4, t3, r3, u2) {
          var i2 = n3.name ? n3 : n3.$locale(), a2 = o3(i2[e4]), s2 = o3(i2[t3]), f = a2 || s2.map((function(n4) {
            return n4.slice(0, r3);
          }));
          if (!u2) return f;
          var d = i2.weekStart;
          return f.map((function(n4, e5) {
            return f[(e5 + (d || 0)) % 7];
          }));
        }, i = function() {
          return t2.Ls[t2.locale()];
        }, a = function(n3, e4) {
          return n3.formats[e4] || (function(n4) {
            return n4.replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, (function(n5, e5, t3) {
              return e5 || t3.slice(1);
            }));
          })(n3.formats[e4.toUpperCase()]);
        }, s = function() {
          var n3 = this;
          return { months: function(e4) {
            return e4 ? e4.format("MMMM") : u(n3, "months");
          }, monthsShort: function(e4) {
            return e4 ? e4.format("MMM") : u(n3, "monthsShort", "months", 3);
          }, firstDayOfWeek: function() {
            return n3.$locale().weekStart || 0;
          }, weekdays: function(e4) {
            return e4 ? e4.format("dddd") : u(n3, "weekdays");
          }, weekdaysMin: function(e4) {
            return e4 ? e4.format("dd") : u(n3, "weekdaysMin", "weekdays", 2);
          }, weekdaysShort: function(e4) {
            return e4 ? e4.format("ddd") : u(n3, "weekdaysShort", "weekdays", 3);
          }, longDateFormat: function(e4) {
            return a(n3.$locale(), e4);
          }, meridiem: this.$locale().meridiem, ordinal: this.$locale().ordinal };
        };
        r2.localeData = function() {
          return s.bind(this)();
        }, t2.localeData = function() {
          var n3 = i();
          return { firstDayOfWeek: function() {
            return n3.weekStart || 0;
          }, weekdays: function() {
            return t2.weekdays();
          }, weekdaysShort: function() {
            return t2.weekdaysShort();
          }, weekdaysMin: function() {
            return t2.weekdaysMin();
          }, months: function() {
            return t2.months();
          }, monthsShort: function() {
            return t2.monthsShort();
          }, longDateFormat: function(e4) {
            return a(n3, e4);
          }, meridiem: n3.meridiem, ordinal: n3.ordinal };
        }, t2.months = function() {
          return u(i(), "months");
        }, t2.monthsShort = function() {
          return u(i(), "monthsShort", "months", 3);
        }, t2.weekdays = function(n3) {
          return u(i(), "weekdays", null, null, n3);
        }, t2.weekdaysShort = function(n3) {
          return u(i(), "weekdaysShort", "weekdays", 3, n3);
        }, t2.weekdaysMin = function(n3) {
          return u(i(), "weekdaysMin", "weekdays", 2, n3);
        };
      };
    }));
  }
});

// ../../node_modules/dayjs/plugin/weekOfYear.js
var require_weekOfYear = __commonJS({
  "../../node_modules/dayjs/plugin/weekOfYear.js"(exports2, module2) {
    !(function(e3, t2) {
      "object" == typeof exports2 && "undefined" != typeof module2 ? module2.exports = t2() : "function" == typeof define && define.amd ? define(t2) : (e3 = "undefined" != typeof globalThis ? globalThis : e3 || self).dayjs_plugin_weekOfYear = t2();
    })(exports2, (function() {
      "use strict";
      var e3 = "week", t2 = "year";
      return function(i, n2, r2) {
        var f = n2.prototype;
        f.week = function(i2) {
          if (void 0 === i2 && (i2 = null), null !== i2) return this.add(7 * (i2 - this.week()), "day");
          var n3 = this.$locale().yearStart || 1;
          if (11 === this.month() && this.date() > 25) {
            var f2 = r2(this).startOf(t2).add(1, t2).date(n3), s = r2(this).endOf(e3);
            if (f2.isBefore(s)) return 1;
          }
          var a = r2(this).startOf(t2).date(n3).startOf(e3).subtract(1, "millisecond"), o3 = this.diff(a, e3, true);
          return o3 < 0 ? r2(this).startOf("week").week() : Math.ceil(o3);
        }, f.weeks = function(e4) {
          return void 0 === e4 && (e4 = null), this.week(e4);
        };
      };
    }));
  }
});

// ../../node_modules/dayjs/plugin/weekYear.js
var require_weekYear = __commonJS({
  "../../node_modules/dayjs/plugin/weekYear.js"(exports2, module2) {
    !(function(e3, t2) {
      "object" == typeof exports2 && "undefined" != typeof module2 ? module2.exports = t2() : "function" == typeof define && define.amd ? define(t2) : (e3 = "undefined" != typeof globalThis ? globalThis : e3 || self).dayjs_plugin_weekYear = t2();
    })(exports2, (function() {
      "use strict";
      return function(e3, t2) {
        t2.prototype.weekYear = function() {
          var e4 = this.month(), t3 = this.week(), n2 = this.year();
          return 1 === t3 && 11 === e4 ? n2 + 1 : 0 === e4 && t3 >= 52 ? n2 - 1 : n2;
        };
      };
    }));
  }
});

// ../../node_modules/dayjs/plugin/advancedFormat.js
var require_advancedFormat = __commonJS({
  "../../node_modules/dayjs/plugin/advancedFormat.js"(exports2, module2) {
    !(function(e3, t2) {
      "object" == typeof exports2 && "undefined" != typeof module2 ? module2.exports = t2() : "function" == typeof define && define.amd ? define(t2) : (e3 = "undefined" != typeof globalThis ? globalThis : e3 || self).dayjs_plugin_advancedFormat = t2();
    })(exports2, (function() {
      "use strict";
      return function(e3, t2) {
        var r2 = t2.prototype, n2 = r2.format;
        r2.format = function(e4) {
          var t3 = this, r3 = this.$locale();
          if (!this.isValid()) return n2.bind(this)(e4);
          var s = this.$utils(), a = (e4 || "YYYY-MM-DDTHH:mm:ssZ").replace(/\[([^\]]+)]|Q|wo|ww|w|WW|W|zzz|z|gggg|GGGG|Do|X|x|k{1,2}|S/g, (function(e5) {
            switch (e5) {
              case "Q":
                return Math.ceil((t3.$M + 1) / 3);
              case "Do":
                return r3.ordinal(t3.$D);
              case "gggg":
                return t3.weekYear();
              case "GGGG":
                return t3.isoWeekYear();
              case "wo":
                return r3.ordinal(t3.week(), "W");
              case "w":
              case "ww":
                return s.s(t3.week(), "w" === e5 ? 1 : 2, "0");
              case "W":
              case "WW":
                return s.s(t3.isoWeek(), "W" === e5 ? 1 : 2, "0");
              case "k":
              case "kk":
                return s.s(String(0 === t3.$H ? 24 : t3.$H), "k" === e5 ? 1 : 2, "0");
              case "X":
                return Math.floor(t3.$d.getTime() / 1e3);
              case "x":
                return t3.$d.getTime();
              case "z":
                return "[" + t3.offsetName() + "]";
              case "zzz":
                return "[" + t3.offsetName("long") + "]";
              default:
                return e5;
            }
          }));
          return n2.bind(this)(a);
        };
      };
    }));
  }
});

// ../../node_modules/dayjs/plugin/customParseFormat.js
var require_customParseFormat = __commonJS({
  "../../node_modules/dayjs/plugin/customParseFormat.js"(exports2, module2) {
    !(function(e3, t2) {
      "object" == typeof exports2 && "undefined" != typeof module2 ? module2.exports = t2() : "function" == typeof define && define.amd ? define(t2) : (e3 = "undefined" != typeof globalThis ? globalThis : e3 || self).dayjs_plugin_customParseFormat = t2();
    })(exports2, (function() {
      "use strict";
      var e3 = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" }, t2 = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|Q|YYYY|YY?|ww?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, n2 = /\d/, r2 = /\d\d/, i = /\d\d?/, o3 = /\d*[^-_:/,()\s\d]+/, s = {}, a = function(e4) {
        return (e4 = +e4) + (e4 > 68 ? 1900 : 2e3);
      };
      var f = function(e4) {
        return function(t3) {
          this[e4] = +t3;
        };
      }, h2 = [/[+-]\d\d:?(\d\d)?|Z/, function(e4) {
        (this.zone || (this.zone = {})).offset = (function(e5) {
          if (!e5) return 0;
          if ("Z" === e5) return 0;
          var t3 = e5.match(/([+-]|\d\d)/g), n3 = 60 * t3[1] + (+t3[2] || 0);
          return 0 === n3 ? 0 : "+" === t3[0] ? -n3 : n3;
        })(e4);
      }], u = function(e4) {
        var t3 = s[e4];
        return t3 && (t3.indexOf ? t3 : t3.s.concat(t3.f));
      }, d = function(e4, t3) {
        var n3, r3 = s.meridiem;
        if (r3) {
          for (var i2 = 1; i2 <= 24; i2 += 1) if (e4.indexOf(r3(i2, 0, t3)) > -1) {
            n3 = i2 > 12;
            break;
          }
        } else n3 = e4 === (t3 ? "pm" : "PM");
        return n3;
      }, c = { A: [o3, function(e4) {
        this.afternoon = d(e4, false);
      }], a: [o3, function(e4) {
        this.afternoon = d(e4, true);
      }], Q: [n2, function(e4) {
        this.month = 3 * (e4 - 1) + 1;
      }], S: [n2, function(e4) {
        this.milliseconds = 100 * +e4;
      }], SS: [r2, function(e4) {
        this.milliseconds = 10 * +e4;
      }], SSS: [/\d{3}/, function(e4) {
        this.milliseconds = +e4;
      }], s: [i, f("seconds")], ss: [i, f("seconds")], m: [i, f("minutes")], mm: [i, f("minutes")], H: [i, f("hours")], h: [i, f("hours")], HH: [i, f("hours")], hh: [i, f("hours")], D: [i, f("day")], DD: [r2, f("day")], Do: [o3, function(e4) {
        var t3 = s.ordinal, n3 = e4.match(/\d+/);
        if (this.day = n3[0], t3) for (var r3 = 1; r3 <= 31; r3 += 1) t3(r3).replace(/\[|\]/g, "") === e4 && (this.day = r3);
      }], w: [i, f("week")], ww: [r2, f("week")], M: [i, f("month")], MM: [r2, f("month")], MMM: [o3, function(e4) {
        var t3 = u("months"), n3 = (u("monthsShort") || t3.map((function(e5) {
          return e5.slice(0, 3);
        }))).indexOf(e4) + 1;
        if (n3 < 1) throw new Error();
        this.month = n3 % 12 || n3;
      }], MMMM: [o3, function(e4) {
        var t3 = u("months").indexOf(e4) + 1;
        if (t3 < 1) throw new Error();
        this.month = t3 % 12 || t3;
      }], Y: [/[+-]?\d+/, f("year")], YY: [r2, function(e4) {
        this.year = a(e4);
      }], YYYY: [/\d{4}/, f("year")], Z: h2, ZZ: h2 };
      function l2(n3) {
        var r3, i2;
        r3 = n3, i2 = s && s.formats;
        for (var o4 = (n3 = r3.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, (function(t3, n4, r4) {
          var o5 = r4 && r4.toUpperCase();
          return n4 || i2[r4] || e3[r4] || i2[o5].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, (function(e4, t4, n5) {
            return t4 || n5.slice(1);
          }));
        }))).match(t2), a2 = o4.length, f2 = 0; f2 < a2; f2 += 1) {
          var h3 = o4[f2], u2 = c[h3], d2 = u2 && u2[0], l3 = u2 && u2[1];
          o4[f2] = l3 ? { regex: d2, parser: l3 } : h3.replace(/^\[|\]$/g, "");
        }
        return function(e4) {
          for (var t3 = {}, n4 = 0, r4 = 0; n4 < a2; n4 += 1) {
            var i3 = o4[n4];
            if ("string" == typeof i3) r4 += i3.length;
            else {
              var s2 = i3.regex, f3 = i3.parser, h4 = e4.slice(r4), u3 = s2.exec(h4)[0];
              f3.call(t3, u3), e4 = e4.replace(u3, "");
            }
          }
          return (function(e5) {
            var t4 = e5.afternoon;
            if (void 0 !== t4) {
              var n5 = e5.hours;
              t4 ? n5 < 12 && (e5.hours += 12) : 12 === n5 && (e5.hours = 0), delete e5.afternoon;
            }
          })(t3), t3;
        };
      }
      return function(e4, t3, n3) {
        n3.p.customParseFormat = true, e4 && e4.parseTwoDigitYear && (a = e4.parseTwoDigitYear);
        var r3 = t3.prototype, i2 = r3.parse;
        r3.parse = function(e5) {
          var t4 = e5.date, r4 = e5.utc, o4 = e5.args;
          this.$u = r4;
          var a2 = o4[1];
          if ("string" == typeof a2) {
            var f2 = true === o4[2], h3 = true === o4[3], u2 = f2 || h3, d2 = o4[2];
            h3 && (d2 = o4[2]), s = this.$locale(), !f2 && d2 && (s = n3.Ls[d2]), this.$d = (function(e6, t5, n4, r5) {
              try {
                if (["x", "X"].indexOf(t5) > -1) return new Date(("X" === t5 ? 1e3 : 1) * e6);
                var i3 = l2(t5)(e6), o5 = i3.year, s2 = i3.month, a3 = i3.day, f3 = i3.hours, h4 = i3.minutes, u3 = i3.seconds, d3 = i3.milliseconds, c3 = i3.zone, m2 = i3.week, M2 = /* @__PURE__ */ new Date(), Y = a3 || (o5 || s2 ? 1 : M2.getDate()), p = o5 || M2.getFullYear(), v = 0;
                o5 && !s2 || (v = s2 > 0 ? s2 - 1 : M2.getMonth());
                var D, w = f3 || 0, g = h4 || 0, y = u3 || 0, L = d3 || 0;
                return c3 ? new Date(Date.UTC(p, v, Y, w, g, y, L + 60 * c3.offset * 1e3)) : n4 ? new Date(Date.UTC(p, v, Y, w, g, y, L)) : (D = new Date(p, v, Y, w, g, y, L), m2 && (D = r5(D).week(m2).toDate()), D);
              } catch (e7) {
                return /* @__PURE__ */ new Date("");
              }
            })(t4, a2, r4, n3), this.init(), d2 && true !== d2 && (this.$L = this.locale(d2).$L), u2 && t4 != this.format(a2) && (this.$d = /* @__PURE__ */ new Date("")), s = {};
          } else if (a2 instanceof Array) for (var c2 = a2.length, m = 1; m <= c2; m += 1) {
            o4[1] = a2[m - 1];
            var M = n3.apply(this, o4);
            if (M.isValid()) {
              this.$d = M.$d, this.$L = M.$L, this.init();
              break;
            }
            m === c2 && (this.$d = /* @__PURE__ */ new Date(""));
          }
          else i2.call(this, e5);
        };
      };
    }));
  }
});

// ../../node_modules/toggle-selection/index.js
var require_toggle_selection = __commonJS({
  "../../node_modules/toggle-selection/index.js"(exports2, module2) {
    module2.exports = function() {
      var selection = document.getSelection();
      if (!selection.rangeCount) {
        return function() {
        };
      }
      var active = document.activeElement;
      var ranges = [];
      for (var i = 0; i < selection.rangeCount; i++) {
        ranges.push(selection.getRangeAt(i));
      }
      switch (active.tagName.toUpperCase()) {
        // .toUpperCase handles XHTML
        case "INPUT":
        case "TEXTAREA":
          active.blur();
          break;
        default:
          active = null;
          break;
      }
      selection.removeAllRanges();
      return function() {
        selection.type === "Caret" && selection.removeAllRanges();
        if (!selection.rangeCount) {
          ranges.forEach(function(range3) {
            selection.addRange(range3);
          });
        }
        active && active.focus();
      };
    };
  }
});

// ../../node_modules/copy-to-clipboard/index.js
var require_copy_to_clipboard = __commonJS({
  "../../node_modules/copy-to-clipboard/index.js"(exports2, module2) {
    "use strict";
    var deselectCurrent = require_toggle_selection();
    var clipboardToIE11Formatting = {
      "text/plain": "Text",
      "text/html": "Url",
      "default": "Text"
    };
    var defaultMessage = "Copy to clipboard: #{key}, Enter";
    function format3(message2) {
      var copyKey = (/mac os x/i.test(navigator.userAgent) ? "\u2318" : "Ctrl") + "+C";
      return message2.replace(/#{\s*key\s*}/g, copyKey);
    }
    function copy2(text, options) {
      var debug, message2, reselectPrevious, range3, selection, mark, success = false;
      if (!options) {
        options = {};
      }
      debug = options.debug || false;
      try {
        reselectPrevious = deselectCurrent();
        range3 = document.createRange();
        selection = document.getSelection();
        mark = document.createElement("span");
        mark.textContent = text;
        mark.ariaHidden = "true";
        mark.style.all = "unset";
        mark.style.position = "fixed";
        mark.style.top = 0;
        mark.style.clip = "rect(0, 0, 0, 0)";
        mark.style.whiteSpace = "pre";
        mark.style.webkitUserSelect = "text";
        mark.style.MozUserSelect = "text";
        mark.style.msUserSelect = "text";
        mark.style.userSelect = "text";
        mark.addEventListener("copy", function(e3) {
          e3.stopPropagation();
          if (options.format) {
            e3.preventDefault();
            if (typeof e3.clipboardData === "undefined") {
              debug && console.warn("unable to use e.clipboardData");
              debug && console.warn("trying IE specific stuff");
              window.clipboardData.clearData();
              var format4 = clipboardToIE11Formatting[options.format] || clipboardToIE11Formatting["default"];
              window.clipboardData.setData(format4, text);
            } else {
              e3.clipboardData.clearData();
              e3.clipboardData.setData(options.format, text);
            }
          }
          if (options.onCopy) {
            e3.preventDefault();
            options.onCopy(e3.clipboardData);
          }
        });
        document.body.appendChild(mark);
        range3.selectNodeContents(mark);
        selection.addRange(range3);
        var successful = document.execCommand("copy");
        if (!successful) {
          throw new Error("copy command was unsuccessful");
        }
        success = true;
      } catch (err) {
        debug && console.error("unable to copy using execCommand: ", err);
        debug && console.warn("trying IE specific stuff");
        try {
          window.clipboardData.setData(options.format || "text", text);
          options.onCopy && options.onCopy(window.clipboardData);
          success = true;
        } catch (err2) {
          debug && console.error("unable to copy using clipboardData: ", err2);
          debug && console.error("falling back to prompt");
          message2 = format3("message" in options ? options.message : defaultMessage);
          window.prompt(message2, text);
        }
      } finally {
        if (selection) {
          if (typeof selection.removeRange == "function") {
            selection.removeRange(range3);
          } else {
            selection.removeAllRanges();
          }
        }
        if (mark) {
          document.body.removeChild(mark);
        }
        reselectPrevious();
      }
      return success;
    }
    module2.exports = copy2;
  }
});

// ../../node_modules/use-sync-external-store/cjs/use-sync-external-store-shim.development.js
var require_use_sync_external_store_shim_development = __commonJS({
  "../../node_modules/use-sync-external-store/cjs/use-sync-external-store-shim.development.js"(exports2) {
    "use strict";
    (function() {
      function is(x, y) {
        return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
      }
      function useSyncExternalStore$2(subscribe, getSnapshot) {
        didWarnOld18Alpha || void 0 === React615.startTransition || (didWarnOld18Alpha = true, console.error(
          "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
        ));
        var value = getSnapshot();
        if (!didWarnUncachedGetSnapshot) {
          var cachedValue = getSnapshot();
          objectIs(value, cachedValue) || (console.error(
            "The result of getSnapshot should be cached to avoid an infinite loop"
          ), didWarnUncachedGetSnapshot = true);
        }
        cachedValue = useState135({
          inst: { value, getSnapshot }
        });
        var inst = cachedValue[0].inst, forceUpdate = cachedValue[1];
        useLayoutEffect10(
          function() {
            inst.value = value;
            inst.getSnapshot = getSnapshot;
            checkIfSnapshotChanged(inst) && forceUpdate({ inst });
          },
          [subscribe, value, getSnapshot]
        );
        useEffect142(
          function() {
            checkIfSnapshotChanged(inst) && forceUpdate({ inst });
            return subscribe(function() {
              checkIfSnapshotChanged(inst) && forceUpdate({ inst });
            });
          },
          [subscribe]
        );
        useDebugValue3(value);
        return value;
      }
      function checkIfSnapshotChanged(inst) {
        var latestGetSnapshot = inst.getSnapshot;
        inst = inst.value;
        try {
          var nextValue = latestGetSnapshot();
          return !objectIs(inst, nextValue);
        } catch (error2) {
          return true;
        }
      }
      function useSyncExternalStore$1(subscribe, getSnapshot) {
        return getSnapshot();
      }
      "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
      var React615 = require_react(), objectIs = "function" === typeof Object.is ? Object.is : is, useState135 = React615.useState, useEffect142 = React615.useEffect, useLayoutEffect10 = React615.useLayoutEffect, useDebugValue3 = React615.useDebugValue, didWarnOld18Alpha = false, didWarnUncachedGetSnapshot = false, shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? useSyncExternalStore$1 : useSyncExternalStore$2;
      exports2.useSyncExternalStore = void 0 !== React615.useSyncExternalStore ? React615.useSyncExternalStore : shim;
      "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
    })();
  }
});

// ../../node_modules/use-sync-external-store/shim/index.js
var require_shim = __commonJS({
  "../../node_modules/use-sync-external-store/shim/index.js"(exports2, module2) {
    "use strict";
    if (false) {
      module2.exports = null;
    } else {
      module2.exports = require_use_sync_external_store_shim_development();
    }
  }
});

// ../../node_modules/use-sync-external-store/cjs/use-sync-external-store-shim/with-selector.development.js
var require_with_selector_development = __commonJS({
  "../../node_modules/use-sync-external-store/cjs/use-sync-external-store-shim/with-selector.development.js"(exports2) {
    "use strict";
    (function() {
      function is(x, y) {
        return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
      }
      "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
      var React615 = require_react(), shim = require_shim(), objectIs = "function" === typeof Object.is ? Object.is : is, useSyncExternalStore = shim.useSyncExternalStore, useRef189 = React615.useRef, useEffect142 = React615.useEffect, useMemo166 = React615.useMemo, useDebugValue3 = React615.useDebugValue;
      exports2.useSyncExternalStoreWithSelector = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual2) {
        var instRef = useRef189(null);
        if (null === instRef.current) {
          var inst = { hasValue: false, value: null };
          instRef.current = inst;
        } else inst = instRef.current;
        instRef = useMemo166(
          function() {
            function memoizedSelector(nextSnapshot) {
              if (!hasMemo) {
                hasMemo = true;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual2 && inst.hasValue) {
                  var currentSelection = inst.value;
                  if (isEqual2(currentSelection, nextSnapshot))
                    return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
              }
              currentSelection = memoizedSelection;
              if (objectIs(memoizedSnapshot, nextSnapshot))
                return currentSelection;
              var nextSelection = selector(nextSnapshot);
              if (void 0 !== isEqual2 && isEqual2(currentSelection, nextSelection))
                return memoizedSnapshot = nextSnapshot, currentSelection;
              memoizedSnapshot = nextSnapshot;
              return memoizedSelection = nextSelection;
            }
            var hasMemo = false, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
            return [
              function() {
                return memoizedSelector(getSnapshot());
              },
              null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
              }
            ];
          },
          [getSnapshot, getServerSnapshot, selector, isEqual2]
        );
        var value = useSyncExternalStore(subscribe, instRef[0], instRef[1]);
        useEffect142(
          function() {
            inst.hasValue = true;
            inst.value = value;
          },
          [value]
        );
        useDebugValue3(value);
        return value;
      };
      "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
    })();
  }
});

// ../../node_modules/use-sync-external-store/shim/with-selector.js
var require_with_selector = __commonJS({
  "../../node_modules/use-sync-external-store/shim/with-selector.js"(exports2, module2) {
    "use strict";
    if (false) {
      module2.exports = null;
    } else {
      module2.exports = require_with_selector_development();
    }
  }
});

// ../../node_modules/color-name/index.js
var require_color_name = __commonJS({
  "../../node_modules/color-name/index.js"(exports2, module2) {
    "use strict";
    module2.exports = {
      "aliceblue": [240, 248, 255],
      "antiquewhite": [250, 235, 215],
      "aqua": [0, 255, 255],
      "aquamarine": [127, 255, 212],
      "azure": [240, 255, 255],
      "beige": [245, 245, 220],
      "bisque": [255, 228, 196],
      "black": [0, 0, 0],
      "blanchedalmond": [255, 235, 205],
      "blue": [0, 0, 255],
      "blueviolet": [138, 43, 226],
      "brown": [165, 42, 42],
      "burlywood": [222, 184, 135],
      "cadetblue": [95, 158, 160],
      "chartreuse": [127, 255, 0],
      "chocolate": [210, 105, 30],
      "coral": [255, 127, 80],
      "cornflowerblue": [100, 149, 237],
      "cornsilk": [255, 248, 220],
      "crimson": [220, 20, 60],
      "cyan": [0, 255, 255],
      "darkblue": [0, 0, 139],
      "darkcyan": [0, 139, 139],
      "darkgoldenrod": [184, 134, 11],
      "darkgray": [169, 169, 169],
      "darkgreen": [0, 100, 0],
      "darkgrey": [169, 169, 169],
      "darkkhaki": [189, 183, 107],
      "darkmagenta": [139, 0, 139],
      "darkolivegreen": [85, 107, 47],
      "darkorange": [255, 140, 0],
      "darkorchid": [153, 50, 204],
      "darkred": [139, 0, 0],
      "darksalmon": [233, 150, 122],
      "darkseagreen": [143, 188, 143],
      "darkslateblue": [72, 61, 139],
      "darkslategray": [47, 79, 79],
      "darkslategrey": [47, 79, 79],
      "darkturquoise": [0, 206, 209],
      "darkviolet": [148, 0, 211],
      "deeppink": [255, 20, 147],
      "deepskyblue": [0, 191, 255],
      "dimgray": [105, 105, 105],
      "dimgrey": [105, 105, 105],
      "dodgerblue": [30, 144, 255],
      "firebrick": [178, 34, 34],
      "floralwhite": [255, 250, 240],
      "forestgreen": [34, 139, 34],
      "fuchsia": [255, 0, 255],
      "gainsboro": [220, 220, 220],
      "ghostwhite": [248, 248, 255],
      "gold": [255, 215, 0],
      "goldenrod": [218, 165, 32],
      "gray": [128, 128, 128],
      "green": [0, 128, 0],
      "greenyellow": [173, 255, 47],
      "grey": [128, 128, 128],
      "honeydew": [240, 255, 240],
      "hotpink": [255, 105, 180],
      "indianred": [205, 92, 92],
      "indigo": [75, 0, 130],
      "ivory": [255, 255, 240],
      "khaki": [240, 230, 140],
      "lavender": [230, 230, 250],
      "lavenderblush": [255, 240, 245],
      "lawngreen": [124, 252, 0],
      "lemonchiffon": [255, 250, 205],
      "lightblue": [173, 216, 230],
      "lightcoral": [240, 128, 128],
      "lightcyan": [224, 255, 255],
      "lightgoldenrodyellow": [250, 250, 210],
      "lightgray": [211, 211, 211],
      "lightgreen": [144, 238, 144],
      "lightgrey": [211, 211, 211],
      "lightpink": [255, 182, 193],
      "lightsalmon": [255, 160, 122],
      "lightseagreen": [32, 178, 170],
      "lightskyblue": [135, 206, 250],
      "lightslategray": [119, 136, 153],
      "lightslategrey": [119, 136, 153],
      "lightsteelblue": [176, 196, 222],
      "lightyellow": [255, 255, 224],
      "lime": [0, 255, 0],
      "limegreen": [50, 205, 50],
      "linen": [250, 240, 230],
      "magenta": [255, 0, 255],
      "maroon": [128, 0, 0],
      "mediumaquamarine": [102, 205, 170],
      "mediumblue": [0, 0, 205],
      "mediumorchid": [186, 85, 211],
      "mediumpurple": [147, 112, 219],
      "mediumseagreen": [60, 179, 113],
      "mediumslateblue": [123, 104, 238],
      "mediumspringgreen": [0, 250, 154],
      "mediumturquoise": [72, 209, 204],
      "mediumvioletred": [199, 21, 133],
      "midnightblue": [25, 25, 112],
      "mintcream": [245, 255, 250],
      "mistyrose": [255, 228, 225],
      "moccasin": [255, 228, 181],
      "navajowhite": [255, 222, 173],
      "navy": [0, 0, 128],
      "oldlace": [253, 245, 230],
      "olive": [128, 128, 0],
      "olivedrab": [107, 142, 35],
      "orange": [255, 165, 0],
      "orangered": [255, 69, 0],
      "orchid": [218, 112, 214],
      "palegoldenrod": [238, 232, 170],
      "palegreen": [152, 251, 152],
      "paleturquoise": [175, 238, 238],
      "palevioletred": [219, 112, 147],
      "papayawhip": [255, 239, 213],
      "peachpuff": [255, 218, 185],
      "peru": [205, 133, 63],
      "pink": [255, 192, 203],
      "plum": [221, 160, 221],
      "powderblue": [176, 224, 230],
      "purple": [128, 0, 128],
      "rebeccapurple": [102, 51, 153],
      "red": [255, 0, 0],
      "rosybrown": [188, 143, 143],
      "royalblue": [65, 105, 225],
      "saddlebrown": [139, 69, 19],
      "salmon": [250, 128, 114],
      "sandybrown": [244, 164, 96],
      "seagreen": [46, 139, 87],
      "seashell": [255, 245, 238],
      "sienna": [160, 82, 45],
      "silver": [192, 192, 192],
      "skyblue": [135, 206, 235],
      "slateblue": [106, 90, 205],
      "slategray": [112, 128, 144],
      "slategrey": [112, 128, 144],
      "snow": [255, 250, 250],
      "springgreen": [0, 255, 127],
      "steelblue": [70, 130, 180],
      "tan": [210, 180, 140],
      "teal": [0, 128, 128],
      "thistle": [216, 191, 216],
      "tomato": [255, 99, 71],
      "turquoise": [64, 224, 208],
      "violet": [238, 130, 238],
      "wheat": [245, 222, 179],
      "white": [255, 255, 255],
      "whitesmoke": [245, 245, 245],
      "yellow": [255, 255, 0],
      "yellowgreen": [154, 205, 50]
    };
  }
});

// ../../node_modules/simple-swizzle/node_modules/is-arrayish/index.js
var require_is_arrayish = __commonJS({
  "../../node_modules/simple-swizzle/node_modules/is-arrayish/index.js"(exports2, module2) {
    module2.exports = function isArrayish(obj) {
      if (!obj || typeof obj === "string") {
        return false;
      }
      return obj instanceof Array || Array.isArray(obj) || obj.length >= 0 && (obj.splice instanceof Function || Object.getOwnPropertyDescriptor(obj, obj.length - 1) && obj.constructor.name !== "String");
    };
  }
});

// ../../node_modules/simple-swizzle/index.js
var require_simple_swizzle = __commonJS({
  "../../node_modules/simple-swizzle/index.js"(exports2, module2) {
    "use strict";
    var isArrayish = require_is_arrayish();
    var concat = Array.prototype.concat;
    var slice2 = Array.prototype.slice;
    var swizzle = module2.exports = function swizzle2(args) {
      var results = [];
      for (var i = 0, len = args.length; i < len; i++) {
        var arg = args[i];
        if (isArrayish(arg)) {
          results = concat.call(results, slice2.call(arg));
        } else {
          results.push(arg);
        }
      }
      return results;
    };
    swizzle.wrap = function(fn) {
      return function() {
        return fn(swizzle(arguments));
      };
    };
  }
});

// ../../node_modules/color-string/index.js
var require_color_string = __commonJS({
  "../../node_modules/color-string/index.js"(exports2, module2) {
    var colorNames = require_color_name();
    var swizzle = require_simple_swizzle();
    var hasOwnProperty15 = Object.hasOwnProperty;
    var reverseNames = /* @__PURE__ */ Object.create(null);
    for (name in colorNames) {
      if (hasOwnProperty15.call(colorNames, name)) {
        reverseNames[colorNames[name]] = name;
      }
    }
    var name;
    var cs = module2.exports = {
      to: {},
      get: {}
    };
    cs.get = function(string3) {
      var prefix3 = string3.substring(0, 3).toLowerCase();
      var val;
      var model;
      switch (prefix3) {
        case "hsl":
          val = cs.get.hsl(string3);
          model = "hsl";
          break;
        case "hwb":
          val = cs.get.hwb(string3);
          model = "hwb";
          break;
        default:
          val = cs.get.rgb(string3);
          model = "rgb";
          break;
      }
      if (!val) {
        return null;
      }
      return { model, value: val };
    };
    cs.get.rgb = function(string3) {
      if (!string3) {
        return null;
      }
      var abbr = /^#([a-f0-9]{3,4})$/i;
      var hex2 = /^#([a-f0-9]{6})([a-f0-9]{2})?$/i;
      var rgba = /^rgba?\(\s*([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/;
      var per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/;
      var keyword = /^(\w+)$/;
      var rgb2 = [0, 0, 0, 1];
      var match2;
      var i;
      var hexAlpha;
      if (match2 = string3.match(hex2)) {
        hexAlpha = match2[2];
        match2 = match2[1];
        for (i = 0; i < 3; i++) {
          var i2 = i * 2;
          rgb2[i] = parseInt(match2.slice(i2, i2 + 2), 16);
        }
        if (hexAlpha) {
          rgb2[3] = parseInt(hexAlpha, 16) / 255;
        }
      } else if (match2 = string3.match(abbr)) {
        match2 = match2[1];
        hexAlpha = match2[3];
        for (i = 0; i < 3; i++) {
          rgb2[i] = parseInt(match2[i] + match2[i], 16);
        }
        if (hexAlpha) {
          rgb2[3] = parseInt(hexAlpha + hexAlpha, 16) / 255;
        }
      } else if (match2 = string3.match(rgba)) {
        for (i = 0; i < 3; i++) {
          rgb2[i] = parseInt(match2[i + 1], 0);
        }
        if (match2[4]) {
          if (match2[5]) {
            rgb2[3] = parseFloat(match2[4]) * 0.01;
          } else {
            rgb2[3] = parseFloat(match2[4]);
          }
        }
      } else if (match2 = string3.match(per)) {
        for (i = 0; i < 3; i++) {
          rgb2[i] = Math.round(parseFloat(match2[i + 1]) * 2.55);
        }
        if (match2[4]) {
          if (match2[5]) {
            rgb2[3] = parseFloat(match2[4]) * 0.01;
          } else {
            rgb2[3] = parseFloat(match2[4]);
          }
        }
      } else if (match2 = string3.match(keyword)) {
        if (match2[1] === "transparent") {
          return [0, 0, 0, 0];
        }
        if (!hasOwnProperty15.call(colorNames, match2[1])) {
          return null;
        }
        rgb2 = colorNames[match2[1]];
        rgb2[3] = 1;
        return rgb2;
      } else {
        return null;
      }
      for (i = 0; i < 3; i++) {
        rgb2[i] = clamp(rgb2[i], 0, 255);
      }
      rgb2[3] = clamp(rgb2[3], 0, 1);
      return rgb2;
    };
    cs.get.hsl = function(string3) {
      if (!string3) {
        return null;
      }
      var hsl = /^hsla?\(\s*([+-]?(?:\d{0,3}\.)?\d+)(?:deg)?\s*,?\s*([+-]?[\d\.]+)%\s*,?\s*([+-]?[\d\.]+)%\s*(?:[,|\/]\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/;
      var match2 = string3.match(hsl);
      if (match2) {
        var alpha = parseFloat(match2[4]);
        var h2 = (parseFloat(match2[1]) % 360 + 360) % 360;
        var s = clamp(parseFloat(match2[2]), 0, 100);
        var l2 = clamp(parseFloat(match2[3]), 0, 100);
        var a = clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
        return [h2, s, l2, a];
      }
      return null;
    };
    cs.get.hwb = function(string3) {
      if (!string3) {
        return null;
      }
      var hwb = /^hwb\(\s*([+-]?\d{0,3}(?:\.\d+)?)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/;
      var match2 = string3.match(hwb);
      if (match2) {
        var alpha = parseFloat(match2[4]);
        var h2 = (parseFloat(match2[1]) % 360 + 360) % 360;
        var w = clamp(parseFloat(match2[2]), 0, 100);
        var b = clamp(parseFloat(match2[3]), 0, 100);
        var a = clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
        return [h2, w, b, a];
      }
      return null;
    };
    cs.to.hex = function() {
      var rgba = swizzle(arguments);
      return "#" + hexDouble(rgba[0]) + hexDouble(rgba[1]) + hexDouble(rgba[2]) + (rgba[3] < 1 ? hexDouble(Math.round(rgba[3] * 255)) : "");
    };
    cs.to.rgb = function() {
      var rgba = swizzle(arguments);
      return rgba.length < 4 || rgba[3] === 1 ? "rgb(" + Math.round(rgba[0]) + ", " + Math.round(rgba[1]) + ", " + Math.round(rgba[2]) + ")" : "rgba(" + Math.round(rgba[0]) + ", " + Math.round(rgba[1]) + ", " + Math.round(rgba[2]) + ", " + rgba[3] + ")";
    };
    cs.to.rgb.percent = function() {
      var rgba = swizzle(arguments);
      var r2 = Math.round(rgba[0] / 255 * 100);
      var g = Math.round(rgba[1] / 255 * 100);
      var b = Math.round(rgba[2] / 255 * 100);
      return rgba.length < 4 || rgba[3] === 1 ? "rgb(" + r2 + "%, " + g + "%, " + b + "%)" : "rgba(" + r2 + "%, " + g + "%, " + b + "%, " + rgba[3] + ")";
    };
    cs.to.hsl = function() {
      var hsla = swizzle(arguments);
      return hsla.length < 4 || hsla[3] === 1 ? "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)" : "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, " + hsla[3] + ")";
    };
    cs.to.hwb = function() {
      var hwba = swizzle(arguments);
      var a = "";
      if (hwba.length >= 4 && hwba[3] !== 1) {
        a = ", " + hwba[3];
      }
      return "hwb(" + hwba[0] + ", " + hwba[1] + "%, " + hwba[2] + "%" + a + ")";
    };
    cs.to.keyword = function(rgb2) {
      return reverseNames[rgb2.slice(0, 3)];
    };
    function clamp(num, min, max) {
      return Math.min(Math.max(min, num), max);
    }
    function hexDouble(num) {
      var str = Math.round(num).toString(16).toUpperCase();
      return str.length < 2 ? "0" + str : str;
    }
  }
});

// ../../node_modules/form-render/node_modules/color-name/index.js
var require_color_name2 = __commonJS({
  "../../node_modules/form-render/node_modules/color-name/index.js"(exports2, module2) {
    "use strict";
    module2.exports = {
      "aliceblue": [240, 248, 255],
      "antiquewhite": [250, 235, 215],
      "aqua": [0, 255, 255],
      "aquamarine": [127, 255, 212],
      "azure": [240, 255, 255],
      "beige": [245, 245, 220],
      "bisque": [255, 228, 196],
      "black": [0, 0, 0],
      "blanchedalmond": [255, 235, 205],
      "blue": [0, 0, 255],
      "blueviolet": [138, 43, 226],
      "brown": [165, 42, 42],
      "burlywood": [222, 184, 135],
      "cadetblue": [95, 158, 160],
      "chartreuse": [127, 255, 0],
      "chocolate": [210, 105, 30],
      "coral": [255, 127, 80],
      "cornflowerblue": [100, 149, 237],
      "cornsilk": [255, 248, 220],
      "crimson": [220, 20, 60],
      "cyan": [0, 255, 255],
      "darkblue": [0, 0, 139],
      "darkcyan": [0, 139, 139],
      "darkgoldenrod": [184, 134, 11],
      "darkgray": [169, 169, 169],
      "darkgreen": [0, 100, 0],
      "darkgrey": [169, 169, 169],
      "darkkhaki": [189, 183, 107],
      "darkmagenta": [139, 0, 139],
      "darkolivegreen": [85, 107, 47],
      "darkorange": [255, 140, 0],
      "darkorchid": [153, 50, 204],
      "darkred": [139, 0, 0],
      "darksalmon": [233, 150, 122],
      "darkseagreen": [143, 188, 143],
      "darkslateblue": [72, 61, 139],
      "darkslategray": [47, 79, 79],
      "darkslategrey": [47, 79, 79],
      "darkturquoise": [0, 206, 209],
      "darkviolet": [148, 0, 211],
      "deeppink": [255, 20, 147],
      "deepskyblue": [0, 191, 255],
      "dimgray": [105, 105, 105],
      "dimgrey": [105, 105, 105],
      "dodgerblue": [30, 144, 255],
      "firebrick": [178, 34, 34],
      "floralwhite": [255, 250, 240],
      "forestgreen": [34, 139, 34],
      "fuchsia": [255, 0, 255],
      "gainsboro": [220, 220, 220],
      "ghostwhite": [248, 248, 255],
      "gold": [255, 215, 0],
      "goldenrod": [218, 165, 32],
      "gray": [128, 128, 128],
      "green": [0, 128, 0],
      "greenyellow": [173, 255, 47],
      "grey": [128, 128, 128],
      "honeydew": [240, 255, 240],
      "hotpink": [255, 105, 180],
      "indianred": [205, 92, 92],
      "indigo": [75, 0, 130],
      "ivory": [255, 255, 240],
      "khaki": [240, 230, 140],
      "lavender": [230, 230, 250],
      "lavenderblush": [255, 240, 245],
      "lawngreen": [124, 252, 0],
      "lemonchiffon": [255, 250, 205],
      "lightblue": [173, 216, 230],
      "lightcoral": [240, 128, 128],
      "lightcyan": [224, 255, 255],
      "lightgoldenrodyellow": [250, 250, 210],
      "lightgray": [211, 211, 211],
      "lightgreen": [144, 238, 144],
      "lightgrey": [211, 211, 211],
      "lightpink": [255, 182, 193],
      "lightsalmon": [255, 160, 122],
      "lightseagreen": [32, 178, 170],
      "lightskyblue": [135, 206, 250],
      "lightslategray": [119, 136, 153],
      "lightslategrey": [119, 136, 153],
      "lightsteelblue": [176, 196, 222],
      "lightyellow": [255, 255, 224],
      "lime": [0, 255, 0],
      "limegreen": [50, 205, 50],
      "linen": [250, 240, 230],
      "magenta": [255, 0, 255],
      "maroon": [128, 0, 0],
      "mediumaquamarine": [102, 205, 170],
      "mediumblue": [0, 0, 205],
      "mediumorchid": [186, 85, 211],
      "mediumpurple": [147, 112, 219],
      "mediumseagreen": [60, 179, 113],
      "mediumslateblue": [123, 104, 238],
      "mediumspringgreen": [0, 250, 154],
      "mediumturquoise": [72, 209, 204],
      "mediumvioletred": [199, 21, 133],
      "midnightblue": [25, 25, 112],
      "mintcream": [245, 255, 250],
      "mistyrose": [255, 228, 225],
      "moccasin": [255, 228, 181],
      "navajowhite": [255, 222, 173],
      "navy": [0, 0, 128],
      "oldlace": [253, 245, 230],
      "olive": [128, 128, 0],
      "olivedrab": [107, 142, 35],
      "orange": [255, 165, 0],
      "orangered": [255, 69, 0],
      "orchid": [218, 112, 214],
      "palegoldenrod": [238, 232, 170],
      "palegreen": [152, 251, 152],
      "paleturquoise": [175, 238, 238],
      "palevioletred": [219, 112, 147],
      "papayawhip": [255, 239, 213],
      "peachpuff": [255, 218, 185],
      "peru": [205, 133, 63],
      "pink": [255, 192, 203],
      "plum": [221, 160, 221],
      "powderblue": [176, 224, 230],
      "purple": [128, 0, 128],
      "rebeccapurple": [102, 51, 153],
      "red": [255, 0, 0],
      "rosybrown": [188, 143, 143],
      "royalblue": [65, 105, 225],
      "saddlebrown": [139, 69, 19],
      "salmon": [250, 128, 114],
      "sandybrown": [244, 164, 96],
      "seagreen": [46, 139, 87],
      "seashell": [255, 245, 238],
      "sienna": [160, 82, 45],
      "silver": [192, 192, 192],
      "skyblue": [135, 206, 235],
      "slateblue": [106, 90, 205],
      "slategray": [112, 128, 144],
      "slategrey": [112, 128, 144],
      "snow": [255, 250, 250],
      "springgreen": [0, 255, 127],
      "steelblue": [70, 130, 180],
      "tan": [210, 180, 140],
      "teal": [0, 128, 128],
      "thistle": [216, 191, 216],
      "tomato": [255, 99, 71],
      "turquoise": [64, 224, 208],
      "violet": [238, 130, 238],
      "wheat": [245, 222, 179],
      "white": [255, 255, 255],
      "whitesmoke": [245, 245, 245],
      "yellow": [255, 255, 0],
      "yellowgreen": [154, 205, 50]
    };
  }
});

// ../../node_modules/form-render/node_modules/color-convert/conversions.js
var require_conversions = __commonJS({
  "../../node_modules/form-render/node_modules/color-convert/conversions.js"(exports2, module2) {
    var cssKeywords = require_color_name2();
    var reverseKeywords = {};
    for (key2 in cssKeywords) {
      if (cssKeywords.hasOwnProperty(key2)) {
        reverseKeywords[cssKeywords[key2]] = key2;
      }
    }
    var key2;
    var convert = module2.exports = {
      rgb: { channels: 3, labels: "rgb" },
      hsl: { channels: 3, labels: "hsl" },
      hsv: { channels: 3, labels: "hsv" },
      hwb: { channels: 3, labels: "hwb" },
      cmyk: { channels: 4, labels: "cmyk" },
      xyz: { channels: 3, labels: "xyz" },
      lab: { channels: 3, labels: "lab" },
      lch: { channels: 3, labels: "lch" },
      hex: { channels: 1, labels: ["hex"] },
      keyword: { channels: 1, labels: ["keyword"] },
      ansi16: { channels: 1, labels: ["ansi16"] },
      ansi256: { channels: 1, labels: ["ansi256"] },
      hcg: { channels: 3, labels: ["h", "c", "g"] },
      apple: { channels: 3, labels: ["r16", "g16", "b16"] },
      gray: { channels: 1, labels: ["gray"] }
    };
    for (model in convert) {
      if (convert.hasOwnProperty(model)) {
        if (!("channels" in convert[model])) {
          throw new Error("missing channels property: " + model);
        }
        if (!("labels" in convert[model])) {
          throw new Error("missing channel labels property: " + model);
        }
        if (convert[model].labels.length !== convert[model].channels) {
          throw new Error("channel and label counts mismatch: " + model);
        }
        channels = convert[model].channels;
        labels = convert[model].labels;
        delete convert[model].channels;
        delete convert[model].labels;
        Object.defineProperty(convert[model], "channels", { value: channels });
        Object.defineProperty(convert[model], "labels", { value: labels });
      }
    }
    var channels;
    var labels;
    var model;
    convert.rgb.hsl = function(rgb2) {
      var r2 = rgb2[0] / 255;
      var g = rgb2[1] / 255;
      var b = rgb2[2] / 255;
      var min = Math.min(r2, g, b);
      var max = Math.max(r2, g, b);
      var delta = max - min;
      var h2;
      var s;
      var l2;
      if (max === min) {
        h2 = 0;
      } else if (r2 === max) {
        h2 = (g - b) / delta;
      } else if (g === max) {
        h2 = 2 + (b - r2) / delta;
      } else if (b === max) {
        h2 = 4 + (r2 - g) / delta;
      }
      h2 = Math.min(h2 * 60, 360);
      if (h2 < 0) {
        h2 += 360;
      }
      l2 = (min + max) / 2;
      if (max === min) {
        s = 0;
      } else if (l2 <= 0.5) {
        s = delta / (max + min);
      } else {
        s = delta / (2 - max - min);
      }
      return [h2, s * 100, l2 * 100];
    };
    convert.rgb.hsv = function(rgb2) {
      var rdif;
      var gdif;
      var bdif;
      var h2;
      var s;
      var r2 = rgb2[0] / 255;
      var g = rgb2[1] / 255;
      var b = rgb2[2] / 255;
      var v = Math.max(r2, g, b);
      var diff3 = v - Math.min(r2, g, b);
      var diffc = function(c) {
        return (v - c) / 6 / diff3 + 1 / 2;
      };
      if (diff3 === 0) {
        h2 = s = 0;
      } else {
        s = diff3 / v;
        rdif = diffc(r2);
        gdif = diffc(g);
        bdif = diffc(b);
        if (r2 === v) {
          h2 = bdif - gdif;
        } else if (g === v) {
          h2 = 1 / 3 + rdif - bdif;
        } else if (b === v) {
          h2 = 2 / 3 + gdif - rdif;
        }
        if (h2 < 0) {
          h2 += 1;
        } else if (h2 > 1) {
          h2 -= 1;
        }
      }
      return [
        h2 * 360,
        s * 100,
        v * 100
      ];
    };
    convert.rgb.hwb = function(rgb2) {
      var r2 = rgb2[0];
      var g = rgb2[1];
      var b = rgb2[2];
      var h2 = convert.rgb.hsl(rgb2)[0];
      var w = 1 / 255 * Math.min(r2, Math.min(g, b));
      b = 1 - 1 / 255 * Math.max(r2, Math.max(g, b));
      return [h2, w * 100, b * 100];
    };
    convert.rgb.cmyk = function(rgb2) {
      var r2 = rgb2[0] / 255;
      var g = rgb2[1] / 255;
      var b = rgb2[2] / 255;
      var c;
      var m;
      var y;
      var k;
      k = Math.min(1 - r2, 1 - g, 1 - b);
      c = (1 - r2 - k) / (1 - k) || 0;
      m = (1 - g - k) / (1 - k) || 0;
      y = (1 - b - k) / (1 - k) || 0;
      return [c * 100, m * 100, y * 100, k * 100];
    };
    function comparativeDistance(x, y) {
      return Math.pow(x[0] - y[0], 2) + Math.pow(x[1] - y[1], 2) + Math.pow(x[2] - y[2], 2);
    }
    convert.rgb.keyword = function(rgb2) {
      var reversed = reverseKeywords[rgb2];
      if (reversed) {
        return reversed;
      }
      var currentClosestDistance = Infinity;
      var currentClosestKeyword;
      for (var keyword in cssKeywords) {
        if (cssKeywords.hasOwnProperty(keyword)) {
          var value = cssKeywords[keyword];
          var distance = comparativeDistance(rgb2, value);
          if (distance < currentClosestDistance) {
            currentClosestDistance = distance;
            currentClosestKeyword = keyword;
          }
        }
      }
      return currentClosestKeyword;
    };
    convert.keyword.rgb = function(keyword) {
      return cssKeywords[keyword];
    };
    convert.rgb.xyz = function(rgb2) {
      var r2 = rgb2[0] / 255;
      var g = rgb2[1] / 255;
      var b = rgb2[2] / 255;
      r2 = r2 > 0.04045 ? Math.pow((r2 + 0.055) / 1.055, 2.4) : r2 / 12.92;
      g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
      b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
      var x = r2 * 0.4124 + g * 0.3576 + b * 0.1805;
      var y = r2 * 0.2126 + g * 0.7152 + b * 0.0722;
      var z = r2 * 0.0193 + g * 0.1192 + b * 0.9505;
      return [x * 100, y * 100, z * 100];
    };
    convert.rgb.lab = function(rgb2) {
      var xyz = convert.rgb.xyz(rgb2);
      var x = xyz[0];
      var y = xyz[1];
      var z = xyz[2];
      var l2;
      var a;
      var b;
      x /= 95.047;
      y /= 100;
      z /= 108.883;
      x = x > 8856e-6 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
      y = y > 8856e-6 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
      z = z > 8856e-6 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
      l2 = 116 * y - 16;
      a = 500 * (x - y);
      b = 200 * (y - z);
      return [l2, a, b];
    };
    convert.hsl.rgb = function(hsl) {
      var h2 = hsl[0] / 360;
      var s = hsl[1] / 100;
      var l2 = hsl[2] / 100;
      var t1;
      var t2;
      var t3;
      var rgb2;
      var val;
      if (s === 0) {
        val = l2 * 255;
        return [val, val, val];
      }
      if (l2 < 0.5) {
        t2 = l2 * (1 + s);
      } else {
        t2 = l2 + s - l2 * s;
      }
      t1 = 2 * l2 - t2;
      rgb2 = [0, 0, 0];
      for (var i = 0; i < 3; i++) {
        t3 = h2 + 1 / 3 * -(i - 1);
        if (t3 < 0) {
          t3++;
        }
        if (t3 > 1) {
          t3--;
        }
        if (6 * t3 < 1) {
          val = t1 + (t2 - t1) * 6 * t3;
        } else if (2 * t3 < 1) {
          val = t2;
        } else if (3 * t3 < 2) {
          val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
        } else {
          val = t1;
        }
        rgb2[i] = val * 255;
      }
      return rgb2;
    };
    convert.hsl.hsv = function(hsl) {
      var h2 = hsl[0];
      var s = hsl[1] / 100;
      var l2 = hsl[2] / 100;
      var smin = s;
      var lmin = Math.max(l2, 0.01);
      var sv;
      var v;
      l2 *= 2;
      s *= l2 <= 1 ? l2 : 2 - l2;
      smin *= lmin <= 1 ? lmin : 2 - lmin;
      v = (l2 + s) / 2;
      sv = l2 === 0 ? 2 * smin / (lmin + smin) : 2 * s / (l2 + s);
      return [h2, sv * 100, v * 100];
    };
    convert.hsv.rgb = function(hsv) {
      var h2 = hsv[0] / 60;
      var s = hsv[1] / 100;
      var v = hsv[2] / 100;
      var hi = Math.floor(h2) % 6;
      var f = h2 - Math.floor(h2);
      var p = 255 * v * (1 - s);
      var q = 255 * v * (1 - s * f);
      var t2 = 255 * v * (1 - s * (1 - f));
      v *= 255;
      switch (hi) {
        case 0:
          return [v, t2, p];
        case 1:
          return [q, v, p];
        case 2:
          return [p, v, t2];
        case 3:
          return [p, q, v];
        case 4:
          return [t2, p, v];
        case 5:
          return [v, p, q];
      }
    };
    convert.hsv.hsl = function(hsv) {
      var h2 = hsv[0];
      var s = hsv[1] / 100;
      var v = hsv[2] / 100;
      var vmin = Math.max(v, 0.01);
      var lmin;
      var sl;
      var l2;
      l2 = (2 - s) * v;
      lmin = (2 - s) * vmin;
      sl = s * vmin;
      sl /= lmin <= 1 ? lmin : 2 - lmin;
      sl = sl || 0;
      l2 /= 2;
      return [h2, sl * 100, l2 * 100];
    };
    convert.hwb.rgb = function(hwb) {
      var h2 = hwb[0] / 360;
      var wh = hwb[1] / 100;
      var bl = hwb[2] / 100;
      var ratio = wh + bl;
      var i;
      var v;
      var f;
      var n2;
      if (ratio > 1) {
        wh /= ratio;
        bl /= ratio;
      }
      i = Math.floor(6 * h2);
      v = 1 - bl;
      f = 6 * h2 - i;
      if ((i & 1) !== 0) {
        f = 1 - f;
      }
      n2 = wh + f * (v - wh);
      var r2;
      var g;
      var b;
      switch (i) {
        default:
        case 6:
        case 0:
          r2 = v;
          g = n2;
          b = wh;
          break;
        case 1:
          r2 = n2;
          g = v;
          b = wh;
          break;
        case 2:
          r2 = wh;
          g = v;
          b = n2;
          break;
        case 3:
          r2 = wh;
          g = n2;
          b = v;
          break;
        case 4:
          r2 = n2;
          g = wh;
          b = v;
          break;
        case 5:
          r2 = v;
          g = wh;
          b = n2;
          break;
      }
      return [r2 * 255, g * 255, b * 255];
    };
    convert.cmyk.rgb = function(cmyk2) {
      var c = cmyk2[0] / 100;
      var m = cmyk2[1] / 100;
      var y = cmyk2[2] / 100;
      var k = cmyk2[3] / 100;
      var r2;
      var g;
      var b;
      r2 = 1 - Math.min(1, c * (1 - k) + k);
      g = 1 - Math.min(1, m * (1 - k) + k);
      b = 1 - Math.min(1, y * (1 - k) + k);
      return [r2 * 255, g * 255, b * 255];
    };
    convert.xyz.rgb = function(xyz) {
      var x = xyz[0] / 100;
      var y = xyz[1] / 100;
      var z = xyz[2] / 100;
      var r2;
      var g;
      var b;
      r2 = x * 3.2406 + y * -1.5372 + z * -0.4986;
      g = x * -0.9689 + y * 1.8758 + z * 0.0415;
      b = x * 0.0557 + y * -0.204 + z * 1.057;
      r2 = r2 > 31308e-7 ? 1.055 * Math.pow(r2, 1 / 2.4) - 0.055 : r2 * 12.92;
      g = g > 31308e-7 ? 1.055 * Math.pow(g, 1 / 2.4) - 0.055 : g * 12.92;
      b = b > 31308e-7 ? 1.055 * Math.pow(b, 1 / 2.4) - 0.055 : b * 12.92;
      r2 = Math.min(Math.max(0, r2), 1);
      g = Math.min(Math.max(0, g), 1);
      b = Math.min(Math.max(0, b), 1);
      return [r2 * 255, g * 255, b * 255];
    };
    convert.xyz.lab = function(xyz) {
      var x = xyz[0];
      var y = xyz[1];
      var z = xyz[2];
      var l2;
      var a;
      var b;
      x /= 95.047;
      y /= 100;
      z /= 108.883;
      x = x > 8856e-6 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
      y = y > 8856e-6 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
      z = z > 8856e-6 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
      l2 = 116 * y - 16;
      a = 500 * (x - y);
      b = 200 * (y - z);
      return [l2, a, b];
    };
    convert.lab.xyz = function(lab) {
      var l2 = lab[0];
      var a = lab[1];
      var b = lab[2];
      var x;
      var y;
      var z;
      y = (l2 + 16) / 116;
      x = a / 500 + y;
      z = y - b / 200;
      var y2 = Math.pow(y, 3);
      var x2 = Math.pow(x, 3);
      var z2 = Math.pow(z, 3);
      y = y2 > 8856e-6 ? y2 : (y - 16 / 116) / 7.787;
      x = x2 > 8856e-6 ? x2 : (x - 16 / 116) / 7.787;
      z = z2 > 8856e-6 ? z2 : (z - 16 / 116) / 7.787;
      x *= 95.047;
      y *= 100;
      z *= 108.883;
      return [x, y, z];
    };
    convert.lab.lch = function(lab) {
      var l2 = lab[0];
      var a = lab[1];
      var b = lab[2];
      var hr;
      var h2;
      var c;
      hr = Math.atan2(b, a);
      h2 = hr * 360 / 2 / Math.PI;
      if (h2 < 0) {
        h2 += 360;
      }
      c = Math.sqrt(a * a + b * b);
      return [l2, c, h2];
    };
    convert.lch.lab = function(lch) {
      var l2 = lch[0];
      var c = lch[1];
      var h2 = lch[2];
      var a;
      var b;
      var hr;
      hr = h2 / 360 * 2 * Math.PI;
      a = c * Math.cos(hr);
      b = c * Math.sin(hr);
      return [l2, a, b];
    };
    convert.rgb.ansi16 = function(args) {
      var r2 = args[0];
      var g = args[1];
      var b = args[2];
      var value = 1 in arguments ? arguments[1] : convert.rgb.hsv(args)[2];
      value = Math.round(value / 50);
      if (value === 0) {
        return 30;
      }
      var ansi = 30 + (Math.round(b / 255) << 2 | Math.round(g / 255) << 1 | Math.round(r2 / 255));
      if (value === 2) {
        ansi += 60;
      }
      return ansi;
    };
    convert.hsv.ansi16 = function(args) {
      return convert.rgb.ansi16(convert.hsv.rgb(args), args[2]);
    };
    convert.rgb.ansi256 = function(args) {
      var r2 = args[0];
      var g = args[1];
      var b = args[2];
      if (r2 === g && g === b) {
        if (r2 < 8) {
          return 16;
        }
        if (r2 > 248) {
          return 231;
        }
        return Math.round((r2 - 8) / 247 * 24) + 232;
      }
      var ansi = 16 + 36 * Math.round(r2 / 255 * 5) + 6 * Math.round(g / 255 * 5) + Math.round(b / 255 * 5);
      return ansi;
    };
    convert.ansi16.rgb = function(args) {
      var color = args % 10;
      if (color === 0 || color === 7) {
        if (args > 50) {
          color += 3.5;
        }
        color = color / 10.5 * 255;
        return [color, color, color];
      }
      var mult = (~~(args > 50) + 1) * 0.5;
      var r2 = (color & 1) * mult * 255;
      var g = (color >> 1 & 1) * mult * 255;
      var b = (color >> 2 & 1) * mult * 255;
      return [r2, g, b];
    };
    convert.ansi256.rgb = function(args) {
      if (args >= 232) {
        var c = (args - 232) * 10 + 8;
        return [c, c, c];
      }
      args -= 16;
      var rem;
      var r2 = Math.floor(args / 36) / 5 * 255;
      var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
      var b = rem % 6 / 5 * 255;
      return [r2, g, b];
    };
    convert.rgb.hex = function(args) {
      var integer4 = ((Math.round(args[0]) & 255) << 16) + ((Math.round(args[1]) & 255) << 8) + (Math.round(args[2]) & 255);
      var string3 = integer4.toString(16).toUpperCase();
      return "000000".substring(string3.length) + string3;
    };
    convert.hex.rgb = function(args) {
      var match2 = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
      if (!match2) {
        return [0, 0, 0];
      }
      var colorString = match2[0];
      if (match2[0].length === 3) {
        colorString = colorString.split("").map(function(char2) {
          return char2 + char2;
        }).join("");
      }
      var integer4 = parseInt(colorString, 16);
      var r2 = integer4 >> 16 & 255;
      var g = integer4 >> 8 & 255;
      var b = integer4 & 255;
      return [r2, g, b];
    };
    convert.rgb.hcg = function(rgb2) {
      var r2 = rgb2[0] / 255;
      var g = rgb2[1] / 255;
      var b = rgb2[2] / 255;
      var max = Math.max(Math.max(r2, g), b);
      var min = Math.min(Math.min(r2, g), b);
      var chroma = max - min;
      var grayscale;
      var hue;
      if (chroma < 1) {
        grayscale = min / (1 - chroma);
      } else {
        grayscale = 0;
      }
      if (chroma <= 0) {
        hue = 0;
      } else if (max === r2) {
        hue = (g - b) / chroma % 6;
      } else if (max === g) {
        hue = 2 + (b - r2) / chroma;
      } else {
        hue = 4 + (r2 - g) / chroma + 4;
      }
      hue /= 6;
      hue %= 1;
      return [hue * 360, chroma * 100, grayscale * 100];
    };
    convert.hsl.hcg = function(hsl) {
      var s = hsl[1] / 100;
      var l2 = hsl[2] / 100;
      var c = 1;
      var f = 0;
      if (l2 < 0.5) {
        c = 2 * s * l2;
      } else {
        c = 2 * s * (1 - l2);
      }
      if (c < 1) {
        f = (l2 - 0.5 * c) / (1 - c);
      }
      return [hsl[0], c * 100, f * 100];
    };
    convert.hsv.hcg = function(hsv) {
      var s = hsv[1] / 100;
      var v = hsv[2] / 100;
      var c = s * v;
      var f = 0;
      if (c < 1) {
        f = (v - c) / (1 - c);
      }
      return [hsv[0], c * 100, f * 100];
    };
    convert.hcg.rgb = function(hcg) {
      var h2 = hcg[0] / 360;
      var c = hcg[1] / 100;
      var g = hcg[2] / 100;
      if (c === 0) {
        return [g * 255, g * 255, g * 255];
      }
      var pure = [0, 0, 0];
      var hi = h2 % 1 * 6;
      var v = hi % 1;
      var w = 1 - v;
      var mg = 0;
      switch (Math.floor(hi)) {
        case 0:
          pure[0] = 1;
          pure[1] = v;
          pure[2] = 0;
          break;
        case 1:
          pure[0] = w;
          pure[1] = 1;
          pure[2] = 0;
          break;
        case 2:
          pure[0] = 0;
          pure[1] = 1;
          pure[2] = v;
          break;
        case 3:
          pure[0] = 0;
          pure[1] = w;
          pure[2] = 1;
          break;
        case 4:
          pure[0] = v;
          pure[1] = 0;
          pure[2] = 1;
          break;
        default:
          pure[0] = 1;
          pure[1] = 0;
          pure[2] = w;
      }
      mg = (1 - c) * g;
      return [
        (c * pure[0] + mg) * 255,
        (c * pure[1] + mg) * 255,
        (c * pure[2] + mg) * 255
      ];
    };
    convert.hcg.hsv = function(hcg) {
      var c = hcg[1] / 100;
      var g = hcg[2] / 100;
      var v = c + g * (1 - c);
      var f = 0;
      if (v > 0) {
        f = c / v;
      }
      return [hcg[0], f * 100, v * 100];
    };
    convert.hcg.hsl = function(hcg) {
      var c = hcg[1] / 100;
      var g = hcg[2] / 100;
      var l2 = g * (1 - c) + 0.5 * c;
      var s = 0;
      if (l2 > 0 && l2 < 0.5) {
        s = c / (2 * l2);
      } else if (l2 >= 0.5 && l2 < 1) {
        s = c / (2 * (1 - l2));
      }
      return [hcg[0], s * 100, l2 * 100];
    };
    convert.hcg.hwb = function(hcg) {
      var c = hcg[1] / 100;
      var g = hcg[2] / 100;
      var v = c + g * (1 - c);
      return [hcg[0], (v - c) * 100, (1 - v) * 100];
    };
    convert.hwb.hcg = function(hwb) {
      var w = hwb[1] / 100;
      var b = hwb[2] / 100;
      var v = 1 - b;
      var c = v - w;
      var g = 0;
      if (c < 1) {
        g = (v - c) / (1 - c);
      }
      return [hwb[0], c * 100, g * 100];
    };
    convert.apple.rgb = function(apple) {
      return [apple[0] / 65535 * 255, apple[1] / 65535 * 255, apple[2] / 65535 * 255];
    };
    convert.rgb.apple = function(rgb2) {
      return [rgb2[0] / 255 * 65535, rgb2[1] / 255 * 65535, rgb2[2] / 255 * 65535];
    };
    convert.gray.rgb = function(args) {
      return [args[0] / 100 * 255, args[0] / 100 * 255, args[0] / 100 * 255];
    };
    convert.gray.hsl = convert.gray.hsv = function(args) {
      return [0, 0, args[0]];
    };
    convert.gray.hwb = function(gray) {
      return [0, 100, gray[0]];
    };
    convert.gray.cmyk = function(gray) {
      return [0, 0, 0, gray[0]];
    };
    convert.gray.lab = function(gray) {
      return [gray[0], 0, 0];
    };
    convert.gray.hex = function(gray) {
      var val = Math.round(gray[0] / 100 * 255) & 255;
      var integer4 = (val << 16) + (val << 8) + val;
      var string3 = integer4.toString(16).toUpperCase();
      return "000000".substring(string3.length) + string3;
    };
    convert.rgb.gray = function(rgb2) {
      var val = (rgb2[0] + rgb2[1] + rgb2[2]) / 3;
      return [val / 255 * 100];
    };
  }
});

// ../../node_modules/form-render/node_modules/color-convert/route.js
var require_route = __commonJS({
  "../../node_modules/form-render/node_modules/color-convert/route.js"(exports2, module2) {
    var conversions = require_conversions();
    function buildGraph() {
      var graph = {};
      var models = Object.keys(conversions);
      for (var len = models.length, i = 0; i < len; i++) {
        graph[models[i]] = {
          // http://jsperf.com/1-vs-infinity
          // micro-opt, but this is simple.
          distance: -1,
          parent: null
        };
      }
      return graph;
    }
    function deriveBFS(fromModel) {
      var graph = buildGraph();
      var queue = [fromModel];
      graph[fromModel].distance = 0;
      while (queue.length) {
        var current2 = queue.pop();
        var adjacents = Object.keys(conversions[current2]);
        for (var len = adjacents.length, i = 0; i < len; i++) {
          var adjacent = adjacents[i];
          var node2 = graph[adjacent];
          if (node2.distance === -1) {
            node2.distance = graph[current2].distance + 1;
            node2.parent = current2;
            queue.unshift(adjacent);
          }
        }
      }
      return graph;
    }
    function link(from2, to) {
      return function(args) {
        return to(from2(args));
      };
    }
    function wrapConversion(toModel, graph) {
      var path2 = [graph[toModel].parent, toModel];
      var fn = conversions[graph[toModel].parent][toModel];
      var cur = graph[toModel].parent;
      while (graph[cur].parent) {
        path2.unshift(graph[cur].parent);
        fn = link(conversions[graph[cur].parent][cur], fn);
        cur = graph[cur].parent;
      }
      fn.conversion = path2;
      return fn;
    }
    module2.exports = function(fromModel) {
      var graph = deriveBFS(fromModel);
      var conversion = {};
      var models = Object.keys(graph);
      for (var len = models.length, i = 0; i < len; i++) {
        var toModel = models[i];
        var node2 = graph[toModel];
        if (node2.parent === null) {
          continue;
        }
        conversion[toModel] = wrapConversion(toModel, graph);
      }
      return conversion;
    };
  }
});

// ../../node_modules/form-render/node_modules/color-convert/index.js
var require_color_convert = __commonJS({
  "../../node_modules/form-render/node_modules/color-convert/index.js"(exports2, module2) {
    var conversions = require_conversions();
    var route = require_route();
    var convert = {};
    var models = Object.keys(conversions);
    function wrapRaw(fn) {
      var wrappedFn = function(args) {
        if (args === void 0 || args === null) {
          return args;
        }
        if (arguments.length > 1) {
          args = Array.prototype.slice.call(arguments);
        }
        return fn(args);
      };
      if ("conversion" in fn) {
        wrappedFn.conversion = fn.conversion;
      }
      return wrappedFn;
    }
    function wrapRounded(fn) {
      var wrappedFn = function(args) {
        if (args === void 0 || args === null) {
          return args;
        }
        if (arguments.length > 1) {
          args = Array.prototype.slice.call(arguments);
        }
        var result = fn(args);
        if (typeof result === "object") {
          for (var len = result.length, i = 0; i < len; i++) {
            result[i] = Math.round(result[i]);
          }
        }
        return result;
      };
      if ("conversion" in fn) {
        wrappedFn.conversion = fn.conversion;
      }
      return wrappedFn;
    }
    models.forEach(function(fromModel) {
      convert[fromModel] = {};
      Object.defineProperty(convert[fromModel], "channels", { value: conversions[fromModel].channels });
      Object.defineProperty(convert[fromModel], "labels", { value: conversions[fromModel].labels });
      var routes = route(fromModel);
      var routeModels = Object.keys(routes);
      routeModels.forEach(function(toModel) {
        var fn = routes[toModel];
        convert[fromModel][toModel] = wrapRounded(fn);
        convert[fromModel][toModel].raw = wrapRaw(fn);
      });
    });
    module2.exports = convert;
  }
});

// ../../node_modules/form-render/node_modules/color/index.js
var require_color = __commonJS({
  "../../node_modules/form-render/node_modules/color/index.js"(exports2, module2) {
    "use strict";
    var colorString = require_color_string();
    var convert = require_color_convert();
    var _slice = [].slice;
    var skippedModels = [
      // to be honest, I don't really feel like keyword belongs in color convert, but eh.
      "keyword",
      // gray conflicts with some method names, and has its own method defined.
      "gray",
      // shouldn't really be in color-convert either...
      "hex"
    ];
    var hashedModelKeys = {};
    Object.keys(convert).forEach(function(model) {
      hashedModelKeys[_slice.call(convert[model].labels).sort().join("")] = model;
    });
    var limiters = {};
    function Color5(obj, model) {
      if (!(this instanceof Color5)) {
        return new Color5(obj, model);
      }
      if (model && model in skippedModels) {
        model = null;
      }
      if (model && !(model in convert)) {
        throw new Error("Unknown model: " + model);
      }
      var i;
      var channels;
      if (obj == null) {
        this.model = "rgb";
        this.color = [0, 0, 0];
        this.valpha = 1;
      } else if (obj instanceof Color5) {
        this.model = obj.model;
        this.color = obj.color.slice();
        this.valpha = obj.valpha;
      } else if (typeof obj === "string") {
        var result = colorString.get(obj);
        if (result === null) {
          throw new Error("Unable to parse color from string: " + obj);
        }
        this.model = result.model;
        channels = convert[this.model].channels;
        this.color = result.value.slice(0, channels);
        this.valpha = typeof result.value[channels] === "number" ? result.value[channels] : 1;
      } else if (obj.length) {
        this.model = model || "rgb";
        channels = convert[this.model].channels;
        var newArr = _slice.call(obj, 0, channels);
        this.color = zeroArray(newArr, channels);
        this.valpha = typeof obj[channels] === "number" ? obj[channels] : 1;
      } else if (typeof obj === "number") {
        obj &= 16777215;
        this.model = "rgb";
        this.color = [
          obj >> 16 & 255,
          obj >> 8 & 255,
          obj & 255
        ];
        this.valpha = 1;
      } else {
        this.valpha = 1;
        var keys4 = Object.keys(obj);
        if ("alpha" in obj) {
          keys4.splice(keys4.indexOf("alpha"), 1);
          this.valpha = typeof obj.alpha === "number" ? obj.alpha : 0;
        }
        var hashedKeys = keys4.sort().join("");
        if (!(hashedKeys in hashedModelKeys)) {
          throw new Error("Unable to parse color from object: " + JSON.stringify(obj));
        }
        this.model = hashedModelKeys[hashedKeys];
        var labels = convert[this.model].labels;
        var color = [];
        for (i = 0; i < labels.length; i++) {
          color.push(obj[labels[i]]);
        }
        this.color = zeroArray(color);
      }
      if (limiters[this.model]) {
        channels = convert[this.model].channels;
        for (i = 0; i < channels; i++) {
          var limit = limiters[this.model][i];
          if (limit) {
            this.color[i] = limit(this.color[i]);
          }
        }
      }
      this.valpha = Math.max(0, Math.min(1, this.valpha));
      if (Object.freeze) {
        Object.freeze(this);
      }
    }
    Color5.prototype = {
      toString: function() {
        return this.string();
      },
      toJSON: function() {
        return this[this.model]();
      },
      string: function(places) {
        var self2 = this.model in colorString.to ? this : this.rgb();
        self2 = self2.round(typeof places === "number" ? places : 1);
        var args = self2.valpha === 1 ? self2.color : self2.color.concat(this.valpha);
        return colorString.to[self2.model](args);
      },
      percentString: function(places) {
        var self2 = this.rgb().round(typeof places === "number" ? places : 1);
        var args = self2.valpha === 1 ? self2.color : self2.color.concat(this.valpha);
        return colorString.to.rgb.percent(args);
      },
      array: function() {
        return this.valpha === 1 ? this.color.slice() : this.color.concat(this.valpha);
      },
      object: function() {
        var result = {};
        var channels = convert[this.model].channels;
        var labels = convert[this.model].labels;
        for (var i = 0; i < channels; i++) {
          result[labels[i]] = this.color[i];
        }
        if (this.valpha !== 1) {
          result.alpha = this.valpha;
        }
        return result;
      },
      unitArray: function() {
        var rgb2 = this.rgb().color;
        rgb2[0] /= 255;
        rgb2[1] /= 255;
        rgb2[2] /= 255;
        if (this.valpha !== 1) {
          rgb2.push(this.valpha);
        }
        return rgb2;
      },
      unitObject: function() {
        var rgb2 = this.rgb().object();
        rgb2.r /= 255;
        rgb2.g /= 255;
        rgb2.b /= 255;
        if (this.valpha !== 1) {
          rgb2.alpha = this.valpha;
        }
        return rgb2;
      },
      round: function(places) {
        places = Math.max(places || 0, 0);
        return new Color5(this.color.map(roundToPlace(places)).concat(this.valpha), this.model);
      },
      alpha: function(val) {
        if (arguments.length) {
          return new Color5(this.color.concat(Math.max(0, Math.min(1, val))), this.model);
        }
        return this.valpha;
      },
      // rgb
      red: getset("rgb", 0, maxfn(255)),
      green: getset("rgb", 1, maxfn(255)),
      blue: getset("rgb", 2, maxfn(255)),
      hue: getset(["hsl", "hsv", "hsl", "hwb", "hcg"], 0, function(val) {
        return (val % 360 + 360) % 360;
      }),
      // eslint-disable-line brace-style
      saturationl: getset("hsl", 1, maxfn(100)),
      lightness: getset("hsl", 2, maxfn(100)),
      saturationv: getset("hsv", 1, maxfn(100)),
      value: getset("hsv", 2, maxfn(100)),
      chroma: getset("hcg", 1, maxfn(100)),
      gray: getset("hcg", 2, maxfn(100)),
      white: getset("hwb", 1, maxfn(100)),
      wblack: getset("hwb", 2, maxfn(100)),
      cyan: getset("cmyk", 0, maxfn(100)),
      magenta: getset("cmyk", 1, maxfn(100)),
      yellow: getset("cmyk", 2, maxfn(100)),
      black: getset("cmyk", 3, maxfn(100)),
      x: getset("xyz", 0, maxfn(100)),
      y: getset("xyz", 1, maxfn(100)),
      z: getset("xyz", 2, maxfn(100)),
      l: getset("lab", 0, maxfn(100)),
      a: getset("lab", 1),
      b: getset("lab", 2),
      keyword: function(val) {
        if (arguments.length) {
          return new Color5(val);
        }
        return convert[this.model].keyword(this.color);
      },
      hex: function(val) {
        if (arguments.length) {
          return new Color5(val);
        }
        return colorString.to.hex(this.rgb().round().color);
      },
      rgbNumber: function() {
        var rgb2 = this.rgb().color;
        return (rgb2[0] & 255) << 16 | (rgb2[1] & 255) << 8 | rgb2[2] & 255;
      },
      luminosity: function() {
        var rgb2 = this.rgb().color;
        var lum = [];
        for (var i = 0; i < rgb2.length; i++) {
          var chan = rgb2[i] / 255;
          lum[i] = chan <= 0.03928 ? chan / 12.92 : Math.pow((chan + 0.055) / 1.055, 2.4);
        }
        return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
      },
      contrast: function(color2) {
        var lum1 = this.luminosity();
        var lum2 = color2.luminosity();
        if (lum1 > lum2) {
          return (lum1 + 0.05) / (lum2 + 0.05);
        }
        return (lum2 + 0.05) / (lum1 + 0.05);
      },
      level: function(color2) {
        var contrastRatio = this.contrast(color2);
        if (contrastRatio >= 7.1) {
          return "AAA";
        }
        return contrastRatio >= 4.5 ? "AA" : "";
      },
      isDark: function() {
        var rgb2 = this.rgb().color;
        var yiq = (rgb2[0] * 299 + rgb2[1] * 587 + rgb2[2] * 114) / 1e3;
        return yiq < 128;
      },
      isLight: function() {
        return !this.isDark();
      },
      negate: function() {
        var rgb2 = this.rgb();
        for (var i = 0; i < 3; i++) {
          rgb2.color[i] = 255 - rgb2.color[i];
        }
        return rgb2;
      },
      lighten: function(ratio) {
        var hsl = this.hsl();
        hsl.color[2] += hsl.color[2] * ratio;
        return hsl;
      },
      darken: function(ratio) {
        var hsl = this.hsl();
        hsl.color[2] -= hsl.color[2] * ratio;
        return hsl;
      },
      saturate: function(ratio) {
        var hsl = this.hsl();
        hsl.color[1] += hsl.color[1] * ratio;
        return hsl;
      },
      desaturate: function(ratio) {
        var hsl = this.hsl();
        hsl.color[1] -= hsl.color[1] * ratio;
        return hsl;
      },
      whiten: function(ratio) {
        var hwb = this.hwb();
        hwb.color[1] += hwb.color[1] * ratio;
        return hwb;
      },
      blacken: function(ratio) {
        var hwb = this.hwb();
        hwb.color[2] += hwb.color[2] * ratio;
        return hwb;
      },
      grayscale: function() {
        var rgb2 = this.rgb().color;
        var val = rgb2[0] * 0.3 + rgb2[1] * 0.59 + rgb2[2] * 0.11;
        return Color5.rgb(val, val, val);
      },
      fade: function(ratio) {
        return this.alpha(this.valpha - this.valpha * ratio);
      },
      opaquer: function(ratio) {
        return this.alpha(this.valpha + this.valpha * ratio);
      },
      rotate: function(degrees2) {
        var hsl = this.hsl();
        var hue = hsl.color[0];
        hue = (hue + degrees2) % 360;
        hue = hue < 0 ? 360 + hue : hue;
        hsl.color[0] = hue;
        return hsl;
      },
      mix: function(mixinColor, weight) {
        if (!mixinColor || !mixinColor.rgb) {
          throw new Error('Argument to "mix" was not a Color instance, but rather an instance of ' + typeof mixinColor);
        }
        var color1 = mixinColor.rgb();
        var color2 = this.rgb();
        var p = weight === void 0 ? 0.5 : weight;
        var w = 2 * p - 1;
        var a = color1.alpha() - color2.alpha();
        var w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2;
        var w2 = 1 - w1;
        return Color5.rgb(
          w1 * color1.red() + w2 * color2.red(),
          w1 * color1.green() + w2 * color2.green(),
          w1 * color1.blue() + w2 * color2.blue(),
          color1.alpha() * p + color2.alpha() * (1 - p)
        );
      }
    };
    Object.keys(convert).forEach(function(model) {
      if (skippedModels.indexOf(model) !== -1) {
        return;
      }
      var channels = convert[model].channels;
      Color5.prototype[model] = function() {
        if (this.model === model) {
          return new Color5(this);
        }
        if (arguments.length) {
          return new Color5(arguments, model);
        }
        var newAlpha = typeof arguments[channels] === "number" ? channels : this.valpha;
        return new Color5(assertArray(convert[this.model][model].raw(this.color)).concat(newAlpha), model);
      };
      Color5[model] = function(color) {
        if (typeof color === "number") {
          color = zeroArray(_slice.call(arguments), channels);
        }
        return new Color5(color, model);
      };
    });
    function roundTo(num, places) {
      return Number(num.toFixed(places));
    }
    function roundToPlace(places) {
      return function(num) {
        return roundTo(num, places);
      };
    }
    function getset(model, channel, modifier) {
      model = Array.isArray(model) ? model : [model];
      model.forEach(function(m) {
        (limiters[m] || (limiters[m] = []))[channel] = modifier;
      });
      model = model[0];
      return function(val) {
        var result;
        if (arguments.length) {
          if (modifier) {
            val = modifier(val);
          }
          result = this[model]();
          result.color[channel] = val;
          return result;
        }
        result = this[model]().color[channel];
        if (modifier) {
          result = modifier(result);
        }
        return result;
      };
    }
    function maxfn(max) {
      return function(v) {
        return Math.max(0, Math.min(max, v));
      };
    }
    function assertArray(val) {
      return Array.isArray(val) ? val : [val];
    }
    function zeroArray(arr, length2) {
      for (var i = 0; i < length2; i++) {
        if (typeof arr[i] !== "number") {
          arr[i] = 0;
        }
      }
      return arr;
    }
    module2.exports = Color5;
  }
});

// ../../node_modules/@babel/runtime/helpers/interopRequireDefault.js
var require_interopRequireDefault = __commonJS({
  "../../node_modules/@babel/runtime/helpers/interopRequireDefault.js"(exports2, module2) {
    function _interopRequireDefault(e3) {
      return e3 && e3.__esModule ? e3 : {
        "default": e3
      };
    }
    module2.exports = _interopRequireDefault, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
  }
});

// ../../node_modules/rc-pagination/lib/locale/zh_CN.js
var require_zh_CN = __commonJS({
  "../../node_modules/rc-pagination/lib/locale/zh_CN.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = void 0;
    var locale6 = {
      // Options
      items_per_page: "\u6761/\u9875",
      jump_to: "\u8DF3\u81F3",
      jump_to_confirm: "\u786E\u5B9A",
      page: "\u9875",
      // Pagination
      prev_page: "\u4E0A\u4E00\u9875",
      next_page: "\u4E0B\u4E00\u9875",
      prev_5: "\u5411\u524D 5 \u9875",
      next_5: "\u5411\u540E 5 \u9875",
      prev_3: "\u5411\u524D 3 \u9875",
      next_3: "\u5411\u540E 3 \u9875",
      page_size: "\u9875\u7801"
    };
    var _default = exports2.default = locale6;
  }
});

// ../../node_modules/@babel/runtime/helpers/typeof.js
var require_typeof = __commonJS({
  "../../node_modules/@babel/runtime/helpers/typeof.js"(exports2, module2) {
    function _typeof16(o3) {
      "@babel/helpers - typeof";
      return module2.exports = _typeof16 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o4) {
        return typeof o4;
      } : function(o4) {
        return o4 && "function" == typeof Symbol && o4.constructor === Symbol && o4 !== Symbol.prototype ? "symbol" : typeof o4;
      }, module2.exports.__esModule = true, module2.exports["default"] = module2.exports, _typeof16(o3);
    }
    module2.exports = _typeof16, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
  }
});

// ../../node_modules/@babel/runtime/helpers/toPrimitive.js
var require_toPrimitive = __commonJS({
  "../../node_modules/@babel/runtime/helpers/toPrimitive.js"(exports2, module2) {
    var _typeof16 = require_typeof()["default"];
    function toPrimitive2(t2, r2) {
      if ("object" != _typeof16(t2) || !t2) return t2;
      var e3 = t2[Symbol.toPrimitive];
      if (void 0 !== e3) {
        var i = e3.call(t2, r2 || "default");
        if ("object" != _typeof16(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === r2 ? String : Number)(t2);
    }
    module2.exports = toPrimitive2, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
  }
});

// ../../node_modules/@babel/runtime/helpers/toPropertyKey.js
var require_toPropertyKey = __commonJS({
  "../../node_modules/@babel/runtime/helpers/toPropertyKey.js"(exports2, module2) {
    var _typeof16 = require_typeof()["default"];
    var toPrimitive2 = require_toPrimitive();
    function toPropertyKey2(t2) {
      var i = toPrimitive2(t2, "string");
      return "symbol" == _typeof16(i) ? i : i + "";
    }
    module2.exports = toPropertyKey2, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
  }
});

// ../../node_modules/@babel/runtime/helpers/defineProperty.js
var require_defineProperty = __commonJS({
  "../../node_modules/@babel/runtime/helpers/defineProperty.js"(exports2, module2) {
    var toPropertyKey2 = require_toPropertyKey();
    function _defineProperty11(e3, r2, t2) {
      return (r2 = toPropertyKey2(r2)) in e3 ? Object.defineProperty(e3, r2, {
        value: t2,
        enumerable: true,
        configurable: true,
        writable: true
      }) : e3[r2] = t2, e3;
    }
    module2.exports = _defineProperty11, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
  }
});

// ../../node_modules/@babel/runtime/helpers/objectSpread2.js
var require_objectSpread2 = __commonJS({
  "../../node_modules/@babel/runtime/helpers/objectSpread2.js"(exports2, module2) {
    var defineProperty2 = require_defineProperty();
    function ownKeys3(e3, r2) {
      var t2 = Object.keys(e3);
      if (Object.getOwnPropertySymbols) {
        var o3 = Object.getOwnPropertySymbols(e3);
        r2 && (o3 = o3.filter(function(r3) {
          return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
        })), t2.push.apply(t2, o3);
      }
      return t2;
    }
    function _objectSpread22(e3) {
      for (var r2 = 1; r2 < arguments.length; r2++) {
        var t2 = null != arguments[r2] ? arguments[r2] : {};
        r2 % 2 ? ownKeys3(Object(t2), true).forEach(function(r3) {
          defineProperty2(e3, r3, t2[r3]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t2)) : ownKeys3(Object(t2)).forEach(function(r3) {
          Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t2, r3));
        });
      }
      return e3;
    }
    module2.exports = _objectSpread22, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
  }
});

// ../../node_modules/rc-picker/lib/locale/common.js
var require_common = __commonJS({
  "../../node_modules/rc-picker/lib/locale/common.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.commonLocale = void 0;
    var commonLocale2 = exports2.commonLocale = {
      yearFormat: "YYYY",
      dayFormat: "D",
      cellMeridiemFormat: "A",
      monthBeforeYear: true
    };
  }
});

// ../../node_modules/rc-picker/lib/locale/zh_CN.js
var require_zh_CN2 = __commonJS({
  "../../node_modules/rc-picker/lib/locale/zh_CN.js"(exports2) {
    "use strict";
    var _interopRequireDefault = require_interopRequireDefault().default;
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = void 0;
    var _objectSpread22 = _interopRequireDefault(require_objectSpread2());
    var _common = require_common();
    var locale6 = (0, _objectSpread22.default)((0, _objectSpread22.default)({}, _common.commonLocale), {}, {
      locale: "zh_CN",
      today: "\u4ECA\u5929",
      now: "\u6B64\u523B",
      backToToday: "\u8FD4\u56DE\u4ECA\u5929",
      ok: "\u786E\u5B9A",
      timeSelect: "\u9009\u62E9\u65F6\u95F4",
      dateSelect: "\u9009\u62E9\u65E5\u671F",
      weekSelect: "\u9009\u62E9\u5468",
      clear: "\u6E05\u9664",
      week: "\u5468",
      month: "\u6708",
      year: "\u5E74",
      previousMonth: "\u4E0A\u4E2A\u6708 (\u7FFB\u9875\u4E0A\u952E)",
      nextMonth: "\u4E0B\u4E2A\u6708 (\u7FFB\u9875\u4E0B\u952E)",
      monthSelect: "\u9009\u62E9\u6708\u4EFD",
      yearSelect: "\u9009\u62E9\u5E74\u4EFD",
      decadeSelect: "\u9009\u62E9\u5E74\u4EE3",
      previousYear: "\u4E0A\u4E00\u5E74 (Control\u952E\u52A0\u5DE6\u65B9\u5411\u952E)",
      nextYear: "\u4E0B\u4E00\u5E74 (Control\u952E\u52A0\u53F3\u65B9\u5411\u952E)",
      previousDecade: "\u4E0A\u4E00\u5E74\u4EE3",
      nextDecade: "\u4E0B\u4E00\u5E74\u4EE3",
      previousCentury: "\u4E0A\u4E00\u4E16\u7EAA",
      nextCentury: "\u4E0B\u4E00\u4E16\u7EAA",
      yearFormat: "YYYY\u5E74",
      cellDateFormat: "D",
      monthBeforeYear: false
    });
    var _default = exports2.default = locale6;
  }
});

// ../../node_modules/antd/lib/time-picker/locale/zh_CN.js
var require_zh_CN3 = __commonJS({
  "../../node_modules/antd/lib/time-picker/locale/zh_CN.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = void 0;
    var locale6 = {
      placeholder: "\u8BF7\u9009\u62E9\u65F6\u95F4",
      rangePlaceholder: ["\u5F00\u59CB\u65F6\u95F4", "\u7ED3\u675F\u65F6\u95F4"]
    };
    var _default = exports2.default = locale6;
  }
});

// ../../node_modules/antd/lib/date-picker/locale/zh_CN.js
var require_zh_CN4 = __commonJS({
  "../../node_modules/antd/lib/date-picker/locale/zh_CN.js"(exports2) {
    "use strict";
    var _interopRequireDefault = require_interopRequireDefault().default;
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = void 0;
    var _zh_CN = _interopRequireDefault(require_zh_CN2());
    var _zh_CN2 = _interopRequireDefault(require_zh_CN3());
    var locale6 = {
      lang: Object.assign({
        placeholder: "\u8BF7\u9009\u62E9\u65E5\u671F",
        yearPlaceholder: "\u8BF7\u9009\u62E9\u5E74\u4EFD",
        quarterPlaceholder: "\u8BF7\u9009\u62E9\u5B63\u5EA6",
        monthPlaceholder: "\u8BF7\u9009\u62E9\u6708\u4EFD",
        weekPlaceholder: "\u8BF7\u9009\u62E9\u5468",
        rangePlaceholder: ["\u5F00\u59CB\u65E5\u671F", "\u7ED3\u675F\u65E5\u671F"],
        rangeYearPlaceholder: ["\u5F00\u59CB\u5E74\u4EFD", "\u7ED3\u675F\u5E74\u4EFD"],
        rangeMonthPlaceholder: ["\u5F00\u59CB\u6708\u4EFD", "\u7ED3\u675F\u6708\u4EFD"],
        rangeQuarterPlaceholder: ["\u5F00\u59CB\u5B63\u5EA6", "\u7ED3\u675F\u5B63\u5EA6"],
        rangeWeekPlaceholder: ["\u5F00\u59CB\u5468", "\u7ED3\u675F\u5468"]
      }, _zh_CN.default),
      timePickerLocale: Object.assign({}, _zh_CN2.default)
    };
    locale6.lang.ok = "\u786E\u5B9A";
    var _default = exports2.default = locale6;
  }
});

// ../../node_modules/antd/lib/calendar/locale/zh_CN.js
var require_zh_CN5 = __commonJS({
  "../../node_modules/antd/lib/calendar/locale/zh_CN.js"(exports2) {
    "use strict";
    var _interopRequireDefault = require_interopRequireDefault().default;
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = void 0;
    var _zh_CN = _interopRequireDefault(require_zh_CN4());
    var _default = exports2.default = _zh_CN.default;
  }
});

// ../../node_modules/antd/lib/locale/zh_CN.js
var require_zh_CN6 = __commonJS({
  "../../node_modules/antd/lib/locale/zh_CN.js"(exports2) {
    "use strict";
    var _interopRequireDefault = require_interopRequireDefault().default;
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = void 0;
    var _zh_CN = _interopRequireDefault(require_zh_CN());
    var _zh_CN2 = _interopRequireDefault(require_zh_CN5());
    var _zh_CN3 = _interopRequireDefault(require_zh_CN4());
    var _zh_CN4 = _interopRequireDefault(require_zh_CN3());
    var typeTemplate4 = "${label}\u4E0D\u662F\u4E00\u4E2A\u6709\u6548\u7684${type}";
    var localeValues2 = {
      locale: "zh-cn",
      Pagination: _zh_CN.default,
      DatePicker: _zh_CN3.default,
      TimePicker: _zh_CN4.default,
      Calendar: _zh_CN2.default,
      // locales for all components
      global: {
        placeholder: "\u8BF7\u9009\u62E9",
        close: "\u5173\u95ED"
      },
      Table: {
        filterTitle: "\u7B5B\u9009",
        filterConfirm: "\u786E\u5B9A",
        filterReset: "\u91CD\u7F6E",
        filterEmptyText: "\u65E0\u7B5B\u9009\u9879",
        filterCheckAll: "\u5168\u9009",
        filterSearchPlaceholder: "\u5728\u7B5B\u9009\u9879\u4E2D\u641C\u7D22",
        emptyText: "\u6682\u65E0\u6570\u636E",
        selectAll: "\u5168\u9009\u5F53\u9875",
        selectInvert: "\u53CD\u9009\u5F53\u9875",
        selectNone: "\u6E05\u7A7A\u6240\u6709",
        selectionAll: "\u5168\u9009\u6240\u6709",
        sortTitle: "\u6392\u5E8F",
        expand: "\u5C55\u5F00\u884C",
        collapse: "\u5173\u95ED\u884C",
        triggerDesc: "\u70B9\u51FB\u964D\u5E8F",
        triggerAsc: "\u70B9\u51FB\u5347\u5E8F",
        cancelSort: "\u53D6\u6D88\u6392\u5E8F"
      },
      Modal: {
        okText: "\u786E\u5B9A",
        cancelText: "\u53D6\u6D88",
        justOkText: "\u77E5\u9053\u4E86"
      },
      Tour: {
        Next: "\u4E0B\u4E00\u6B65",
        Previous: "\u4E0A\u4E00\u6B65",
        Finish: "\u7ED3\u675F\u5BFC\u89C8"
      },
      Popconfirm: {
        cancelText: "\u53D6\u6D88",
        okText: "\u786E\u5B9A"
      },
      Transfer: {
        titles: ["", ""],
        searchPlaceholder: "\u8BF7\u8F93\u5165\u641C\u7D22\u5185\u5BB9",
        itemUnit: "\u9879",
        itemsUnit: "\u9879",
        remove: "\u5220\u9664",
        selectCurrent: "\u5168\u9009\u5F53\u9875",
        removeCurrent: "\u5220\u9664\u5F53\u9875",
        selectAll: "\u5168\u9009\u6240\u6709",
        deselectAll: "\u53D6\u6D88\u5168\u9009",
        removeAll: "\u5220\u9664\u5168\u90E8",
        selectInvert: "\u53CD\u9009\u5F53\u9875"
      },
      Upload: {
        uploading: "\u6587\u4EF6\u4E0A\u4F20\u4E2D",
        removeFile: "\u5220\u9664\u6587\u4EF6",
        uploadError: "\u4E0A\u4F20\u9519\u8BEF",
        previewFile: "\u9884\u89C8\u6587\u4EF6",
        downloadFile: "\u4E0B\u8F7D\u6587\u4EF6"
      },
      Empty: {
        description: "\u6682\u65E0\u6570\u636E"
      },
      Icon: {
        icon: "\u56FE\u6807"
      },
      Text: {
        edit: "\u7F16\u8F91",
        copy: "\u590D\u5236",
        copied: "\u590D\u5236\u6210\u529F",
        expand: "\u5C55\u5F00",
        collapse: "\u6536\u8D77"
      },
      Form: {
        optional: "\uFF08\u53EF\u9009\uFF09",
        defaultValidateMessages: {
          default: "\u5B57\u6BB5\u9A8C\u8BC1\u9519\u8BEF${label}",
          required: "\u8BF7\u8F93\u5165${label}",
          enum: "${label}\u5FC5\u987B\u662F\u5176\u4E2D\u4E00\u4E2A[${enum}]",
          whitespace: "${label}\u4E0D\u80FD\u4E3A\u7A7A\u5B57\u7B26",
          date: {
            format: "${label}\u65E5\u671F\u683C\u5F0F\u65E0\u6548",
            parse: "${label}\u4E0D\u80FD\u8F6C\u6362\u4E3A\u65E5\u671F",
            invalid: "${label}\u662F\u4E00\u4E2A\u65E0\u6548\u65E5\u671F"
          },
          types: {
            string: typeTemplate4,
            method: typeTemplate4,
            array: typeTemplate4,
            object: typeTemplate4,
            number: typeTemplate4,
            date: typeTemplate4,
            boolean: typeTemplate4,
            integer: typeTemplate4,
            float: typeTemplate4,
            regexp: typeTemplate4,
            email: typeTemplate4,
            url: typeTemplate4,
            hex: typeTemplate4
          },
          string: {
            len: "${label}\u987B\u4E3A${len}\u4E2A\u5B57\u7B26",
            min: "${label}\u6700\u5C11${min}\u4E2A\u5B57\u7B26",
            max: "${label}\u6700\u591A${max}\u4E2A\u5B57\u7B26",
            range: "${label}\u987B\u5728${min}-${max}\u5B57\u7B26\u4E4B\u95F4"
          },
          number: {
            len: "${label}\u5FC5\u987B\u7B49\u4E8E${len}",
            min: "${label}\u6700\u5C0F\u503C\u4E3A${min}",
            max: "${label}\u6700\u5927\u503C\u4E3A${max}",
            range: "${label}\u987B\u5728${min}-${max}\u4E4B\u95F4"
          },
          array: {
            len: "\u987B\u4E3A${len}\u4E2A${label}",
            min: "\u6700\u5C11${min}\u4E2A${label}",
            max: "\u6700\u591A${max}\u4E2A${label}",
            range: "${label}\u6570\u91CF\u987B\u5728${min}-${max}\u4E4B\u95F4"
          },
          pattern: {
            mismatch: "${label}\u4E0E\u6A21\u5F0F\u4E0D\u5339\u914D${pattern}"
          }
        }
      },
      Image: {
        preview: "\u9884\u89C8"
      },
      QRCode: {
        expired: "\u4E8C\u7EF4\u7801\u8FC7\u671F",
        refresh: "\u70B9\u51FB\u5237\u65B0",
        scanned: "\u5DF2\u626B\u63CF"
      },
      ColorPicker: {
        presetEmpty: "\u6682\u65E0",
        transparent: "\u65E0\u8272",
        singleColor: "\u5355\u8272",
        gradientColor: "\u6E10\u53D8\u8272"
      }
    };
    var _default = exports2.default = localeValues2;
  }
});

// ../../node_modules/rc-pagination/lib/locale/en_US.js
var require_en_US = __commonJS({
  "../../node_modules/rc-pagination/lib/locale/en_US.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = void 0;
    var locale6 = {
      // Options
      items_per_page: "/ page",
      jump_to: "Go to",
      jump_to_confirm: "confirm",
      page: "Page",
      // Pagination
      prev_page: "Previous Page",
      next_page: "Next Page",
      prev_5: "Previous 5 Pages",
      next_5: "Next 5 Pages",
      prev_3: "Previous 3 Pages",
      next_3: "Next 3 Pages",
      page_size: "Page Size"
    };
    var _default = exports2.default = locale6;
  }
});

// ../../node_modules/rc-picker/lib/locale/en_US.js
var require_en_US2 = __commonJS({
  "../../node_modules/rc-picker/lib/locale/en_US.js"(exports2) {
    "use strict";
    var _interopRequireDefault = require_interopRequireDefault().default;
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = void 0;
    var _objectSpread22 = _interopRequireDefault(require_objectSpread2());
    var _common = require_common();
    var locale6 = (0, _objectSpread22.default)((0, _objectSpread22.default)({}, _common.commonLocale), {}, {
      locale: "en_US",
      today: "Today",
      now: "Now",
      backToToday: "Back to today",
      ok: "OK",
      clear: "Clear",
      week: "Week",
      month: "Month",
      year: "Year",
      timeSelect: "select time",
      dateSelect: "select date",
      weekSelect: "Choose a week",
      monthSelect: "Choose a month",
      yearSelect: "Choose a year",
      decadeSelect: "Choose a decade",
      dateFormat: "M/D/YYYY",
      dateTimeFormat: "M/D/YYYY HH:mm:ss",
      previousMonth: "Previous month (PageUp)",
      nextMonth: "Next month (PageDown)",
      previousYear: "Last year (Control + left)",
      nextYear: "Next year (Control + right)",
      previousDecade: "Last decade",
      nextDecade: "Next decade",
      previousCentury: "Last century",
      nextCentury: "Next century"
    });
    var _default = exports2.default = locale6;
  }
});

// ../../node_modules/antd/lib/time-picker/locale/en_US.js
var require_en_US3 = __commonJS({
  "../../node_modules/antd/lib/time-picker/locale/en_US.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = void 0;
    var locale6 = {
      placeholder: "Select time",
      rangePlaceholder: ["Start time", "End time"]
    };
    var _default = exports2.default = locale6;
  }
});

// ../../node_modules/antd/lib/date-picker/locale/en_US.js
var require_en_US4 = __commonJS({
  "../../node_modules/antd/lib/date-picker/locale/en_US.js"(exports2) {
    "use strict";
    var _interopRequireDefault = require_interopRequireDefault().default;
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = void 0;
    var _en_US = _interopRequireDefault(require_en_US2());
    var _en_US2 = _interopRequireDefault(require_en_US3());
    var locale6 = {
      lang: Object.assign({
        placeholder: "Select date",
        yearPlaceholder: "Select year",
        quarterPlaceholder: "Select quarter",
        monthPlaceholder: "Select month",
        weekPlaceholder: "Select week",
        rangePlaceholder: ["Start date", "End date"],
        rangeYearPlaceholder: ["Start year", "End year"],
        rangeQuarterPlaceholder: ["Start quarter", "End quarter"],
        rangeMonthPlaceholder: ["Start month", "End month"],
        rangeWeekPlaceholder: ["Start week", "End week"]
      }, _en_US.default),
      timePickerLocale: Object.assign({}, _en_US2.default)
    };
    var _default = exports2.default = locale6;
  }
});

// ../../node_modules/antd/lib/calendar/locale/en_US.js
var require_en_US5 = __commonJS({
  "../../node_modules/antd/lib/calendar/locale/en_US.js"(exports2) {
    "use strict";
    var _interopRequireDefault = require_interopRequireDefault().default;
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = void 0;
    var _en_US = _interopRequireDefault(require_en_US4());
    var _default = exports2.default = _en_US.default;
  }
});

// ../../node_modules/antd/lib/locale/en_US.js
var require_en_US6 = __commonJS({
  "../../node_modules/antd/lib/locale/en_US.js"(exports2) {
    "use strict";
    var _interopRequireDefault = require_interopRequireDefault().default;
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = void 0;
    var _en_US = _interopRequireDefault(require_en_US());
    var _en_US2 = _interopRequireDefault(require_en_US5());
    var _en_US3 = _interopRequireDefault(require_en_US4());
    var _en_US4 = _interopRequireDefault(require_en_US3());
    var typeTemplate4 = "${label} is not a valid ${type}";
    var localeValues2 = {
      locale: "en",
      Pagination: _en_US.default,
      DatePicker: _en_US3.default,
      TimePicker: _en_US4.default,
      Calendar: _en_US2.default,
      global: {
        placeholder: "Please select",
        close: "Close"
      },
      Table: {
        filterTitle: "Filter menu",
        filterConfirm: "OK",
        filterReset: "Reset",
        filterEmptyText: "No filters",
        filterCheckAll: "Select all items",
        filterSearchPlaceholder: "Search in filters",
        emptyText: "No data",
        selectAll: "Select current page",
        selectInvert: "Invert current page",
        selectNone: "Clear all data",
        selectionAll: "Select all data",
        sortTitle: "Sort",
        expand: "Expand row",
        collapse: "Collapse row",
        triggerDesc: "Click to sort descending",
        triggerAsc: "Click to sort ascending",
        cancelSort: "Click to cancel sorting"
      },
      Tour: {
        Next: "Next",
        Previous: "Previous",
        Finish: "Finish"
      },
      Modal: {
        okText: "OK",
        cancelText: "Cancel",
        justOkText: "OK"
      },
      Popconfirm: {
        okText: "OK",
        cancelText: "Cancel"
      },
      Transfer: {
        titles: ["", ""],
        searchPlaceholder: "Search here",
        itemUnit: "item",
        itemsUnit: "items",
        remove: "Remove",
        selectCurrent: "Select current page",
        removeCurrent: "Remove current page",
        selectAll: "Select all data",
        deselectAll: "Deselect all data",
        removeAll: "Remove all data",
        selectInvert: "Invert current page"
      },
      Upload: {
        uploading: "Uploading...",
        removeFile: "Remove file",
        uploadError: "Upload error",
        previewFile: "Preview file",
        downloadFile: "Download file"
      },
      Empty: {
        description: "No data"
      },
      Icon: {
        icon: "icon"
      },
      Text: {
        edit: "Edit",
        copy: "Copy",
        copied: "Copied",
        expand: "Expand",
        collapse: "Collapse"
      },
      Form: {
        optional: "(optional)",
        defaultValidateMessages: {
          default: "Field validation error for ${label}",
          required: "Please enter ${label}",
          enum: "${label} must be one of [${enum}]",
          whitespace: "${label} cannot be a blank character",
          date: {
            format: "${label} date format is invalid",
            parse: "${label} cannot be converted to a date",
            invalid: "${label} is an invalid date"
          },
          types: {
            string: typeTemplate4,
            method: typeTemplate4,
            array: typeTemplate4,
            object: typeTemplate4,
            number: typeTemplate4,
            date: typeTemplate4,
            boolean: typeTemplate4,
            integer: typeTemplate4,
            float: typeTemplate4,
            regexp: typeTemplate4,
            email: typeTemplate4,
            url: typeTemplate4,
            hex: typeTemplate4
          },
          string: {
            len: "${label} must be ${len} characters",
            min: "${label} must be at least ${min} characters",
            max: "${label} must be up to ${max} characters",
            range: "${label} must be between ${min}-${max} characters"
          },
          number: {
            len: "${label} must be equal to ${len}",
            min: "${label} must be minimum ${min}",
            max: "${label} must be maximum ${max}",
            range: "${label} must be between ${min}-${max}"
          },
          array: {
            len: "Must be ${len} ${label}",
            min: "At least ${min} ${label}",
            max: "At most ${max} ${label}",
            range: "The amount of ${label} must be between ${min}-${max}"
          },
          pattern: {
            mismatch: "${label} does not match the pattern ${pattern}"
          }
        }
      },
      Image: {
        preview: "Preview"
      },
      QRCode: {
        expired: "QR code expired",
        refresh: "Refresh",
        scanned: "Scanned"
      },
      ColorPicker: {
        presetEmpty: "Empty",
        transparent: "Transparent",
        singleColor: "Single",
        gradientColor: "Gradient"
      }
    };
    var _default = exports2.default = localeValues2;
  }
});

// ../../node_modules/dayjs/locale/zh-cn.js
var require_zh_cn = __commonJS({
  "../../node_modules/dayjs/locale/zh-cn.js"(exports2, module2) {
    !(function(e3, _) {
      "object" == typeof exports2 && "undefined" != typeof module2 ? module2.exports = _(require_dayjs_min()) : "function" == typeof define && define.amd ? define(["dayjs"], _) : (e3 = "undefined" != typeof globalThis ? globalThis : e3 || self).dayjs_locale_zh_cn = _(e3.dayjs);
    })(exports2, (function(e3) {
      "use strict";
      function _(e4) {
        return e4 && "object" == typeof e4 && "default" in e4 ? e4 : { default: e4 };
      }
      var t2 = _(e3), d = { name: "zh-cn", weekdays: "\u661F\u671F\u65E5_\u661F\u671F\u4E00_\u661F\u671F\u4E8C_\u661F\u671F\u4E09_\u661F\u671F\u56DB_\u661F\u671F\u4E94_\u661F\u671F\u516D".split("_"), weekdaysShort: "\u5468\u65E5_\u5468\u4E00_\u5468\u4E8C_\u5468\u4E09_\u5468\u56DB_\u5468\u4E94_\u5468\u516D".split("_"), weekdaysMin: "\u65E5_\u4E00_\u4E8C_\u4E09_\u56DB_\u4E94_\u516D".split("_"), months: "\u4E00\u6708_\u4E8C\u6708_\u4E09\u6708_\u56DB\u6708_\u4E94\u6708_\u516D\u6708_\u4E03\u6708_\u516B\u6708_\u4E5D\u6708_\u5341\u6708_\u5341\u4E00\u6708_\u5341\u4E8C\u6708".split("_"), monthsShort: "1\u6708_2\u6708_3\u6708_4\u6708_5\u6708_6\u6708_7\u6708_8\u6708_9\u6708_10\u6708_11\u6708_12\u6708".split("_"), ordinal: function(e4, _2) {
        return "W" === _2 ? e4 + "\u5468" : e4 + "\u65E5";
      }, weekStart: 1, yearStart: 4, formats: { LT: "HH:mm", LTS: "HH:mm:ss", L: "YYYY/MM/DD", LL: "YYYY\u5E74M\u6708D\u65E5", LLL: "YYYY\u5E74M\u6708D\u65E5Ah\u70B9mm\u5206", LLLL: "YYYY\u5E74M\u6708D\u65E5ddddAh\u70B9mm\u5206", l: "YYYY/M/D", ll: "YYYY\u5E74M\u6708D\u65E5", lll: "YYYY\u5E74M\u6708D\u65E5 HH:mm", llll: "YYYY\u5E74M\u6708D\u65E5dddd HH:mm" }, relativeTime: { future: "%s\u5185", past: "%s\u524D", s: "\u51E0\u79D2", m: "1 \u5206\u949F", mm: "%d \u5206\u949F", h: "1 \u5C0F\u65F6", hh: "%d \u5C0F\u65F6", d: "1 \u5929", dd: "%d \u5929", M: "1 \u4E2A\u6708", MM: "%d \u4E2A\u6708", y: "1 \u5E74", yy: "%d \u5E74" }, meridiem: function(e4, _2) {
        var t3 = 100 * e4 + _2;
        return t3 < 600 ? "\u51CC\u6668" : t3 < 900 ? "\u65E9\u4E0A" : t3 < 1100 ? "\u4E0A\u5348" : t3 < 1300 ? "\u4E2D\u5348" : t3 < 1800 ? "\u4E0B\u5348" : "\u665A\u4E0A";
      } };
      return t2.default.locale(d, null, true), d;
    }));
  }
});

// ../../node_modules/prop-types/node_modules/react-is/cjs/react-is.development.js
var require_react_is_development2 = __commonJS({
  "../../node_modules/prop-types/node_modules/react-is/cjs/react-is.development.js"(exports2) {
    "use strict";
    if (true) {
      (function() {
        "use strict";
        var hasSymbol = typeof Symbol === "function" && Symbol.for;
        var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 60103;
        var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 60106;
        var REACT_FRAGMENT_TYPE2 = hasSymbol ? Symbol.for("react.fragment") : 60107;
        var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 60108;
        var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 60114;
        var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 60109;
        var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 60110;
        var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 60111;
        var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 60111;
        var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 60112;
        var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 60113;
        var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 60120;
        var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 60115;
        var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 60116;
        var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 60121;
        var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 60117;
        var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 60118;
        var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 60119;
        function isValidElementType(type5) {
          return typeof type5 === "string" || typeof type5 === "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
          type5 === REACT_FRAGMENT_TYPE2 || type5 === REACT_CONCURRENT_MODE_TYPE || type5 === REACT_PROFILER_TYPE || type5 === REACT_STRICT_MODE_TYPE || type5 === REACT_SUSPENSE_TYPE || type5 === REACT_SUSPENSE_LIST_TYPE || typeof type5 === "object" && type5 !== null && (type5.$$typeof === REACT_LAZY_TYPE || type5.$$typeof === REACT_MEMO_TYPE || type5.$$typeof === REACT_PROVIDER_TYPE || type5.$$typeof === REACT_CONTEXT_TYPE || type5.$$typeof === REACT_FORWARD_REF_TYPE || type5.$$typeof === REACT_FUNDAMENTAL_TYPE || type5.$$typeof === REACT_RESPONDER_TYPE || type5.$$typeof === REACT_SCOPE_TYPE || type5.$$typeof === REACT_BLOCK_TYPE);
        }
        function typeOf(object4) {
          if (typeof object4 === "object" && object4 !== null) {
            var $$typeof = object4.$$typeof;
            switch ($$typeof) {
              case REACT_ELEMENT_TYPE:
                var type5 = object4.type;
                switch (type5) {
                  case REACT_ASYNC_MODE_TYPE:
                  case REACT_CONCURRENT_MODE_TYPE:
                  case REACT_FRAGMENT_TYPE2:
                  case REACT_PROFILER_TYPE:
                  case REACT_STRICT_MODE_TYPE:
                  case REACT_SUSPENSE_TYPE:
                    return type5;
                  default:
                    var $$typeofType = type5 && type5.$$typeof;
                    switch ($$typeofType) {
                      case REACT_CONTEXT_TYPE:
                      case REACT_FORWARD_REF_TYPE:
                      case REACT_LAZY_TYPE:
                      case REACT_MEMO_TYPE:
                      case REACT_PROVIDER_TYPE:
                        return $$typeofType;
                      default:
                        return $$typeof;
                    }
                }
              case REACT_PORTAL_TYPE:
                return $$typeof;
            }
          }
          return void 0;
        }
        var AsyncMode = REACT_ASYNC_MODE_TYPE;
        var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
        var ContextConsumer = REACT_CONTEXT_TYPE;
        var ContextProvider = REACT_PROVIDER_TYPE;
        var Element3 = REACT_ELEMENT_TYPE;
        var ForwardRef2 = REACT_FORWARD_REF_TYPE;
        var Fragment35 = REACT_FRAGMENT_TYPE2;
        var Lazy = REACT_LAZY_TYPE;
        var Memo = REACT_MEMO_TYPE;
        var Portal2 = REACT_PORTAL_TYPE;
        var Profiler = REACT_PROFILER_TYPE;
        var StrictMode = REACT_STRICT_MODE_TYPE;
        var Suspense = REACT_SUSPENSE_TYPE;
        var hasWarnedAboutDeprecatedIsAsyncMode = false;
        function isAsyncMode(object4) {
          {
            if (!hasWarnedAboutDeprecatedIsAsyncMode) {
              hasWarnedAboutDeprecatedIsAsyncMode = true;
              console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
            }
          }
          return isConcurrentMode(object4) || typeOf(object4) === REACT_ASYNC_MODE_TYPE;
        }
        function isConcurrentMode(object4) {
          return typeOf(object4) === REACT_CONCURRENT_MODE_TYPE;
        }
        function isContextConsumer(object4) {
          return typeOf(object4) === REACT_CONTEXT_TYPE;
        }
        function isContextProvider(object4) {
          return typeOf(object4) === REACT_PROVIDER_TYPE;
        }
        function isElement(object4) {
          return typeof object4 === "object" && object4 !== null && object4.$$typeof === REACT_ELEMENT_TYPE;
        }
        function isForwardRef(object4) {
          return typeOf(object4) === REACT_FORWARD_REF_TYPE;
        }
        function isFragment3(object4) {
          return typeOf(object4) === REACT_FRAGMENT_TYPE2;
        }
        function isLazy(object4) {
          return typeOf(object4) === REACT_LAZY_TYPE;
        }
        function isMemo2(object4) {
          return typeOf(object4) === REACT_MEMO_TYPE;
        }
        function isPortal(object4) {
          return typeOf(object4) === REACT_PORTAL_TYPE;
        }
        function isProfiler(object4) {
          return typeOf(object4) === REACT_PROFILER_TYPE;
        }
        function isStrictMode(object4) {
          return typeOf(object4) === REACT_STRICT_MODE_TYPE;
        }
        function isSuspense(object4) {
          return typeOf(object4) === REACT_SUSPENSE_TYPE;
        }
        exports2.AsyncMode = AsyncMode;
        exports2.ConcurrentMode = ConcurrentMode;
        exports2.ContextConsumer = ContextConsumer;
        exports2.ContextProvider = ContextProvider;
        exports2.Element = Element3;
        exports2.ForwardRef = ForwardRef2;
        exports2.Fragment = Fragment35;
        exports2.Lazy = Lazy;
        exports2.Memo = Memo;
        exports2.Portal = Portal2;
        exports2.Profiler = Profiler;
        exports2.StrictMode = StrictMode;
        exports2.Suspense = Suspense;
        exports2.isAsyncMode = isAsyncMode;
        exports2.isConcurrentMode = isConcurrentMode;
        exports2.isContextConsumer = isContextConsumer;
        exports2.isContextProvider = isContextProvider;
        exports2.isElement = isElement;
        exports2.isForwardRef = isForwardRef;
        exports2.isFragment = isFragment3;
        exports2.isLazy = isLazy;
        exports2.isMemo = isMemo2;
        exports2.isPortal = isPortal;
        exports2.isProfiler = isProfiler;
        exports2.isStrictMode = isStrictMode;
        exports2.isSuspense = isSuspense;
        exports2.isValidElementType = isValidElementType;
        exports2.typeOf = typeOf;
      })();
    }
  }
});

// ../../node_modules/prop-types/node_modules/react-is/index.js
var require_react_is2 = __commonJS({
  "../../node_modules/prop-types/node_modules/react-is/index.js"(exports2, module2) {
    "use strict";
    if (false) {
      module2.exports = null;
    } else {
      module2.exports = require_react_is_development2();
    }
  }
});

// ../../node_modules/prop-types/factoryWithTypeCheckers.js
var require_factoryWithTypeCheckers = __commonJS({
  "../../node_modules/prop-types/factoryWithTypeCheckers.js"(exports2, module2) {
    "use strict";
    var ReactIs = require_react_is2();
    var assign2 = require_object_assign();
    var ReactPropTypesSecret = require_ReactPropTypesSecret();
    var has2 = require_has();
    var checkPropTypes = require_checkPropTypes();
    var printWarning = function() {
    };
    if (true) {
      printWarning = function(text) {
        var message2 = "Warning: " + text;
        if (typeof console !== "undefined") {
          console.error(message2);
        }
        try {
          throw new Error(message2);
        } catch (x) {
        }
      };
    }
    function emptyFunctionThatReturnsNull() {
      return null;
    }
    module2.exports = function(isValidElement31, throwOnDirectAccess) {
      var ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
      var FAUX_ITERATOR_SYMBOL = "@@iterator";
      function getIteratorFn(maybeIterable) {
        var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
        if (typeof iteratorFn === "function") {
          return iteratorFn;
        }
      }
      var ANONYMOUS = "<<anonymous>>";
      var ReactPropTypes = {
        array: createPrimitiveTypeChecker("array"),
        bigint: createPrimitiveTypeChecker("bigint"),
        bool: createPrimitiveTypeChecker("boolean"),
        func: createPrimitiveTypeChecker("function"),
        number: createPrimitiveTypeChecker("number"),
        object: createPrimitiveTypeChecker("object"),
        string: createPrimitiveTypeChecker("string"),
        symbol: createPrimitiveTypeChecker("symbol"),
        any: createAnyTypeChecker(),
        arrayOf: createArrayOfTypeChecker,
        element: createElementTypeChecker(),
        elementType: createElementTypeTypeChecker(),
        instanceOf: createInstanceTypeChecker,
        node: createNodeChecker(),
        objectOf: createObjectOfTypeChecker,
        oneOf: createEnumTypeChecker,
        oneOfType: createUnionTypeChecker,
        shape: createShapeTypeChecker,
        exact: createStrictShapeTypeChecker
      };
      function is(x, y) {
        if (x === y) {
          return x !== 0 || 1 / x === 1 / y;
        } else {
          return x !== x && y !== y;
        }
      }
      function PropTypeError(message2, data2) {
        this.message = message2;
        this.data = data2 && typeof data2 === "object" ? data2 : {};
        this.stack = "";
      }
      PropTypeError.prototype = Error.prototype;
      function createChainableTypeChecker(validate) {
        if (true) {
          var manualPropTypeCallCache = {};
          var manualPropTypeWarningCount = 0;
        }
        function checkType(isRequired, props, propName, componentName, location2, propFullName, secret) {
          componentName = componentName || ANONYMOUS;
          propFullName = propFullName || propName;
          if (secret !== ReactPropTypesSecret) {
            if (throwOnDirectAccess) {
              var err = new Error(
                "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
              );
              err.name = "Invariant Violation";
              throw err;
            } else if (typeof console !== "undefined") {
              var cacheKey = componentName + ":" + propName;
              if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
              manualPropTypeWarningCount < 3) {
                printWarning(
                  "You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
                );
                manualPropTypeCallCache[cacheKey] = true;
                manualPropTypeWarningCount++;
              }
            }
          }
          if (props[propName] == null) {
            if (isRequired) {
              if (props[propName] === null) {
                return new PropTypeError("The " + location2 + " `" + propFullName + "` is marked as required " + ("in `" + componentName + "`, but its value is `null`."));
              }
              return new PropTypeError("The " + location2 + " `" + propFullName + "` is marked as required in " + ("`" + componentName + "`, but its value is `undefined`."));
            }
            return null;
          } else {
            return validate(props, propName, componentName, location2, propFullName);
          }
        }
        var chainedCheckType = checkType.bind(null, false);
        chainedCheckType.isRequired = checkType.bind(null, true);
        return chainedCheckType;
      }
      function createPrimitiveTypeChecker(expectedType) {
        function validate(props, propName, componentName, location2, propFullName, secret) {
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== expectedType) {
            var preciseType = getPreciseType(propValue);
            return new PropTypeError(
              "Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + preciseType + "` supplied to `" + componentName + "`, expected ") + ("`" + expectedType + "`."),
              { expectedType }
            );
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createAnyTypeChecker() {
        return createChainableTypeChecker(emptyFunctionThatReturnsNull);
      }
      function createArrayOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location2, propFullName) {
          if (typeof typeChecker !== "function") {
            return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
          }
          var propValue = props[propName];
          if (!Array.isArray(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an array."));
          }
          for (var i = 0; i < propValue.length; i++) {
            var error2 = typeChecker(propValue, i, componentName, location2, propFullName + "[" + i + "]", ReactPropTypesSecret);
            if (error2 instanceof Error) {
              return error2;
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createElementTypeChecker() {
        function validate(props, propName, componentName, location2, propFullName) {
          var propValue = props[propName];
          if (!isValidElement31(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement."));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createElementTypeTypeChecker() {
        function validate(props, propName, componentName, location2, propFullName) {
          var propValue = props[propName];
          if (!ReactIs.isValidElementType(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement type."));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createInstanceTypeChecker(expectedClass) {
        function validate(props, propName, componentName, location2, propFullName) {
          if (!(props[propName] instanceof expectedClass)) {
            var expectedClassName = expectedClass.name || ANONYMOUS;
            var actualClassName = getClassName(props[propName]);
            return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + actualClassName + "` supplied to `" + componentName + "`, expected ") + ("instance of `" + expectedClassName + "`."));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createEnumTypeChecker(expectedValues) {
        if (!Array.isArray(expectedValues)) {
          if (true) {
            if (arguments.length > 1) {
              printWarning(
                "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
              );
            } else {
              printWarning("Invalid argument supplied to oneOf, expected an array.");
            }
          }
          return emptyFunctionThatReturnsNull;
        }
        function validate(props, propName, componentName, location2, propFullName) {
          var propValue = props[propName];
          for (var i = 0; i < expectedValues.length; i++) {
            if (is(propValue, expectedValues[i])) {
              return null;
            }
          }
          var valuesString = JSON.stringify(expectedValues, function replacer(key2, value) {
            var type5 = getPreciseType(value);
            if (type5 === "symbol") {
              return String(value);
            }
            return value;
          });
          return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of value `" + String(propValue) + "` " + ("supplied to `" + componentName + "`, expected one of " + valuesString + "."));
        }
        return createChainableTypeChecker(validate);
      }
      function createObjectOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location2, propFullName) {
          if (typeof typeChecker !== "function") {
            return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
          }
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== "object") {
            return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an object."));
          }
          for (var key2 in propValue) {
            if (has2(propValue, key2)) {
              var error2 = typeChecker(propValue, key2, componentName, location2, propFullName + "." + key2, ReactPropTypesSecret);
              if (error2 instanceof Error) {
                return error2;
              }
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createUnionTypeChecker(arrayOfTypeCheckers) {
        if (!Array.isArray(arrayOfTypeCheckers)) {
          true ? printWarning("Invalid argument supplied to oneOfType, expected an instance of array.") : void 0;
          return emptyFunctionThatReturnsNull;
        }
        for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
          var checker = arrayOfTypeCheckers[i];
          if (typeof checker !== "function") {
            printWarning(
              "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i + "."
            );
            return emptyFunctionThatReturnsNull;
          }
        }
        function validate(props, propName, componentName, location2, propFullName) {
          var expectedTypes = [];
          for (var i2 = 0; i2 < arrayOfTypeCheckers.length; i2++) {
            var checker2 = arrayOfTypeCheckers[i2];
            var checkerResult = checker2(props, propName, componentName, location2, propFullName, ReactPropTypesSecret);
            if (checkerResult == null) {
              return null;
            }
            if (checkerResult.data && has2(checkerResult.data, "expectedType")) {
              expectedTypes.push(checkerResult.data.expectedType);
            }
          }
          var expectedTypesMessage = expectedTypes.length > 0 ? ", expected one of type [" + expectedTypes.join(", ") + "]" : "";
          return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` supplied to " + ("`" + componentName + "`" + expectedTypesMessage + "."));
        }
        return createChainableTypeChecker(validate);
      }
      function createNodeChecker() {
        function validate(props, propName, componentName, location2, propFullName) {
          if (!isNode3(props[propName])) {
            return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` supplied to " + ("`" + componentName + "`, expected a ReactNode."));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function invalidValidatorError(componentName, location2, propFullName, key2, type5) {
        return new PropTypeError(
          (componentName || "React class") + ": " + location2 + " type `" + propFullName + "." + key2 + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + type5 + "`."
        );
      }
      function createShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location2, propFullName) {
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== "object") {
            return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
          }
          for (var key2 in shapeTypes) {
            var checker = shapeTypes[key2];
            if (typeof checker !== "function") {
              return invalidValidatorError(componentName, location2, propFullName, key2, getPreciseType(checker));
            }
            var error2 = checker(propValue, key2, componentName, location2, propFullName + "." + key2, ReactPropTypesSecret);
            if (error2) {
              return error2;
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createStrictShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location2, propFullName) {
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== "object") {
            return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
          }
          var allKeys = assign2({}, props[propName], shapeTypes);
          for (var key2 in allKeys) {
            var checker = shapeTypes[key2];
            if (has2(shapeTypes, key2) && typeof checker !== "function") {
              return invalidValidatorError(componentName, location2, propFullName, key2, getPreciseType(checker));
            }
            if (!checker) {
              return new PropTypeError(
                "Invalid " + location2 + " `" + propFullName + "` key `" + key2 + "` supplied to `" + componentName + "`.\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  ")
              );
            }
            var error2 = checker(propValue, key2, componentName, location2, propFullName + "." + key2, ReactPropTypesSecret);
            if (error2) {
              return error2;
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function isNode3(propValue) {
        switch (typeof propValue) {
          case "number":
          case "string":
          case "undefined":
            return true;
          case "boolean":
            return !propValue;
          case "object":
            if (Array.isArray(propValue)) {
              return propValue.every(isNode3);
            }
            if (propValue === null || isValidElement31(propValue)) {
              return true;
            }
            var iteratorFn = getIteratorFn(propValue);
            if (iteratorFn) {
              var iterator = iteratorFn.call(propValue);
              var step;
              if (iteratorFn !== propValue.entries) {
                while (!(step = iterator.next()).done) {
                  if (!isNode3(step.value)) {
                    return false;
                  }
                }
              } else {
                while (!(step = iterator.next()).done) {
                  var entry = step.value;
                  if (entry) {
                    if (!isNode3(entry[1])) {
                      return false;
                    }
                  }
                }
              }
            } else {
              return false;
            }
            return true;
          default:
            return false;
        }
      }
      function isSymbol2(propType, propValue) {
        if (propType === "symbol") {
          return true;
        }
        if (!propValue) {
          return false;
        }
        if (propValue["@@toStringTag"] === "Symbol") {
          return true;
        }
        if (typeof Symbol === "function" && propValue instanceof Symbol) {
          return true;
        }
        return false;
      }
      function getPropType(propValue) {
        var propType = typeof propValue;
        if (Array.isArray(propValue)) {
          return "array";
        }
        if (propValue instanceof RegExp) {
          return "object";
        }
        if (isSymbol2(propType, propValue)) {
          return "symbol";
        }
        return propType;
      }
      function getPreciseType(propValue) {
        if (typeof propValue === "undefined" || propValue === null) {
          return "" + propValue;
        }
        var propType = getPropType(propValue);
        if (propType === "object") {
          if (propValue instanceof Date) {
            return "date";
          } else if (propValue instanceof RegExp) {
            return "regexp";
          }
        }
        return propType;
      }
      function getPostfixForTypeWarning(value) {
        var type5 = getPreciseType(value);
        switch (type5) {
          case "array":
          case "object":
            return "an " + type5;
          case "boolean":
          case "date":
          case "regexp":
            return "a " + type5;
          default:
            return type5;
        }
      }
      function getClassName(propValue) {
        if (!propValue.constructor || !propValue.constructor.name) {
          return ANONYMOUS;
        }
        return propValue.constructor.name;
      }
      ReactPropTypes.checkPropTypes = checkPropTypes;
      ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
      ReactPropTypes.PropTypes = ReactPropTypes;
      return ReactPropTypes;
    };
  }
});

// ../../node_modules/prop-types/index.js
var require_prop_types = __commonJS({
  "../../node_modules/prop-types/index.js"(exports2, module2) {
    if (true) {
      ReactIs = require_react_is2();
      throwOnDirectAccess = true;
      module2.exports = require_factoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
    } else {
      module2.exports = null();
    }
    var ReactIs;
    var throwOnDirectAccess;
  }
});

// ../../node_modules/core-js/library/modules/_global.js
var require_global = __commonJS({
  "../../node_modules/core-js/library/modules/_global.js"(exports2, module2) {
    var global2 = module2.exports = typeof window != "undefined" && window.Math == Math ? window : typeof self != "undefined" && self.Math == Math ? self : Function("return this")();
    if (typeof __g == "number") __g = global2;
  }
});

// ../../node_modules/core-js/library/modules/_core.js
var require_core = __commonJS({
  "../../node_modules/core-js/library/modules/_core.js"(exports2, module2) {
    var core = module2.exports = { version: "2.6.12" };
    if (typeof __e == "number") __e = core;
  }
});

// ../../node_modules/core-js/library/modules/_a-function.js
var require_a_function = __commonJS({
  "../../node_modules/core-js/library/modules/_a-function.js"(exports2, module2) {
    module2.exports = function(it) {
      if (typeof it != "function") throw TypeError(it + " is not a function!");
      return it;
    };
  }
});

// ../../node_modules/core-js/library/modules/_ctx.js
var require_ctx = __commonJS({
  "../../node_modules/core-js/library/modules/_ctx.js"(exports2, module2) {
    var aFunction = require_a_function();
    module2.exports = function(fn, that, length2) {
      aFunction(fn);
      if (that === void 0) return fn;
      switch (length2) {
        case 1:
          return function(a) {
            return fn.call(that, a);
          };
        case 2:
          return function(a, b) {
            return fn.call(that, a, b);
          };
        case 3:
          return function(a, b, c) {
            return fn.call(that, a, b, c);
          };
      }
      return function() {
        return fn.apply(that, arguments);
      };
    };
  }
});

// ../../node_modules/core-js/library/modules/_is-object.js
var require_is_object = __commonJS({
  "../../node_modules/core-js/library/modules/_is-object.js"(exports2, module2) {
    module2.exports = function(it) {
      return typeof it === "object" ? it !== null : typeof it === "function";
    };
  }
});

// ../../node_modules/core-js/library/modules/_an-object.js
var require_an_object = __commonJS({
  "../../node_modules/core-js/library/modules/_an-object.js"(exports2, module2) {
    var isObject7 = require_is_object();
    module2.exports = function(it) {
      if (!isObject7(it)) throw TypeError(it + " is not an object!");
      return it;
    };
  }
});

// ../../node_modules/core-js/library/modules/_fails.js
var require_fails = __commonJS({
  "../../node_modules/core-js/library/modules/_fails.js"(exports2, module2) {
    module2.exports = function(exec) {
      try {
        return !!exec();
      } catch (e3) {
        return true;
      }
    };
  }
});

// ../../node_modules/core-js/library/modules/_descriptors.js
var require_descriptors = __commonJS({
  "../../node_modules/core-js/library/modules/_descriptors.js"(exports2, module2) {
    module2.exports = !require_fails()(function() {
      return Object.defineProperty({}, "a", { get: function() {
        return 7;
      } }).a != 7;
    });
  }
});

// ../../node_modules/core-js/library/modules/_dom-create.js
var require_dom_create = __commonJS({
  "../../node_modules/core-js/library/modules/_dom-create.js"(exports2, module2) {
    var isObject7 = require_is_object();
    var document2 = require_global().document;
    var is = isObject7(document2) && isObject7(document2.createElement);
    module2.exports = function(it) {
      return is ? document2.createElement(it) : {};
    };
  }
});

// ../../node_modules/core-js/library/modules/_ie8-dom-define.js
var require_ie8_dom_define = __commonJS({
  "../../node_modules/core-js/library/modules/_ie8-dom-define.js"(exports2, module2) {
    module2.exports = !require_descriptors() && !require_fails()(function() {
      return Object.defineProperty(require_dom_create()("div"), "a", { get: function() {
        return 7;
      } }).a != 7;
    });
  }
});

// ../../node_modules/core-js/library/modules/_to-primitive.js
var require_to_primitive = __commonJS({
  "../../node_modules/core-js/library/modules/_to-primitive.js"(exports2, module2) {
    var isObject7 = require_is_object();
    module2.exports = function(it, S) {
      if (!isObject7(it)) return it;
      var fn, val;
      if (S && typeof (fn = it.toString) == "function" && !isObject7(val = fn.call(it))) return val;
      if (typeof (fn = it.valueOf) == "function" && !isObject7(val = fn.call(it))) return val;
      if (!S && typeof (fn = it.toString) == "function" && !isObject7(val = fn.call(it))) return val;
      throw TypeError("Can't convert object to primitive value");
    };
  }
});

// ../../node_modules/core-js/library/modules/_object-dp.js
var require_object_dp = __commonJS({
  "../../node_modules/core-js/library/modules/_object-dp.js"(exports2) {
    var anObject = require_an_object();
    var IE8_DOM_DEFINE = require_ie8_dom_define();
    var toPrimitive2 = require_to_primitive();
    var dP = Object.defineProperty;
    exports2.f = require_descriptors() ? Object.defineProperty : function defineProperty2(O, P, Attributes) {
      anObject(O);
      P = toPrimitive2(P, true);
      anObject(Attributes);
      if (IE8_DOM_DEFINE) try {
        return dP(O, P, Attributes);
      } catch (e3) {
      }
      if ("get" in Attributes || "set" in Attributes) throw TypeError("Accessors not supported!");
      if ("value" in Attributes) O[P] = Attributes.value;
      return O;
    };
  }
});

// ../../node_modules/core-js/library/modules/_property-desc.js
var require_property_desc = __commonJS({
  "../../node_modules/core-js/library/modules/_property-desc.js"(exports2, module2) {
    module2.exports = function(bitmap, value) {
      return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value
      };
    };
  }
});

// ../../node_modules/core-js/library/modules/_hide.js
var require_hide = __commonJS({
  "../../node_modules/core-js/library/modules/_hide.js"(exports2, module2) {
    var dP = require_object_dp();
    var createDesc = require_property_desc();
    module2.exports = require_descriptors() ? function(object4, key2, value) {
      return dP.f(object4, key2, createDesc(1, value));
    } : function(object4, key2, value) {
      object4[key2] = value;
      return object4;
    };
  }
});

// ../../node_modules/core-js/library/modules/_has.js
var require_has2 = __commonJS({
  "../../node_modules/core-js/library/modules/_has.js"(exports2, module2) {
    var hasOwnProperty15 = {}.hasOwnProperty;
    module2.exports = function(it, key2) {
      return hasOwnProperty15.call(it, key2);
    };
  }
});

// ../../node_modules/core-js/library/modules/_export.js
var require_export = __commonJS({
  "../../node_modules/core-js/library/modules/_export.js"(exports2, module2) {
    var global2 = require_global();
    var core = require_core();
    var ctx = require_ctx();
    var hide = require_hide();
    var has2 = require_has2();
    var PROTOTYPE = "prototype";
    var $export = function(type5, name, source) {
      var IS_FORCED = type5 & $export.F;
      var IS_GLOBAL = type5 & $export.G;
      var IS_STATIC = type5 & $export.S;
      var IS_PROTO = type5 & $export.P;
      var IS_BIND = type5 & $export.B;
      var IS_WRAP = type5 & $export.W;
      var exports3 = IS_GLOBAL ? core : core[name] || (core[name] = {});
      var expProto = exports3[PROTOTYPE];
      var target = IS_GLOBAL ? global2 : IS_STATIC ? global2[name] : (global2[name] || {})[PROTOTYPE];
      var key2, own, out;
      if (IS_GLOBAL) source = name;
      for (key2 in source) {
        own = !IS_FORCED && target && target[key2] !== void 0;
        if (own && has2(exports3, key2)) continue;
        out = own ? target[key2] : source[key2];
        exports3[key2] = IS_GLOBAL && typeof target[key2] != "function" ? source[key2] : IS_BIND && own ? ctx(out, global2) : IS_WRAP && target[key2] == out ? (function(C) {
          var F = function(a, b, c) {
            if (this instanceof C) {
              switch (arguments.length) {
                case 0:
                  return new C();
                case 1:
                  return new C(a);
                case 2:
                  return new C(a, b);
              }
              return new C(a, b, c);
            }
            return C.apply(this, arguments);
          };
          F[PROTOTYPE] = C[PROTOTYPE];
          return F;
        })(out) : IS_PROTO && typeof out == "function" ? ctx(Function.call, out) : out;
        if (IS_PROTO) {
          (exports3.virtual || (exports3.virtual = {}))[key2] = out;
          if (type5 & $export.R && expProto && !expProto[key2]) hide(expProto, key2, out);
        }
      }
    };
    $export.F = 1;
    $export.G = 2;
    $export.S = 4;
    $export.P = 8;
    $export.B = 16;
    $export.W = 32;
    $export.U = 64;
    $export.R = 128;
    module2.exports = $export;
  }
});

// ../../node_modules/core-js/library/modules/_cof.js
var require_cof = __commonJS({
  "../../node_modules/core-js/library/modules/_cof.js"(exports2, module2) {
    var toString3 = {}.toString;
    module2.exports = function(it) {
      return toString3.call(it).slice(8, -1);
    };
  }
});

// ../../node_modules/core-js/library/modules/_iobject.js
var require_iobject = __commonJS({
  "../../node_modules/core-js/library/modules/_iobject.js"(exports2, module2) {
    var cof = require_cof();
    module2.exports = Object("z").propertyIsEnumerable(0) ? Object : function(it) {
      return cof(it) == "String" ? it.split("") : Object(it);
    };
  }
});

// ../../node_modules/core-js/library/modules/_defined.js
var require_defined = __commonJS({
  "../../node_modules/core-js/library/modules/_defined.js"(exports2, module2) {
    module2.exports = function(it) {
      if (it == void 0) throw TypeError("Can't call method on  " + it);
      return it;
    };
  }
});

// ../../node_modules/core-js/library/modules/_to-iobject.js
var require_to_iobject = __commonJS({
  "../../node_modules/core-js/library/modules/_to-iobject.js"(exports2, module2) {
    var IObject = require_iobject();
    var defined = require_defined();
    module2.exports = function(it) {
      return IObject(defined(it));
    };
  }
});

// ../../node_modules/core-js/library/modules/_to-integer.js
var require_to_integer = __commonJS({
  "../../node_modules/core-js/library/modules/_to-integer.js"(exports2, module2) {
    var ceil = Math.ceil;
    var floor = Math.floor;
    module2.exports = function(it) {
      return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
    };
  }
});

// ../../node_modules/core-js/library/modules/_to-length.js
var require_to_length = __commonJS({
  "../../node_modules/core-js/library/modules/_to-length.js"(exports2, module2) {
    var toInteger = require_to_integer();
    var min = Math.min;
    module2.exports = function(it) {
      return it > 0 ? min(toInteger(it), 9007199254740991) : 0;
    };
  }
});

// ../../node_modules/core-js/library/modules/_to-absolute-index.js
var require_to_absolute_index = __commonJS({
  "../../node_modules/core-js/library/modules/_to-absolute-index.js"(exports2, module2) {
    var toInteger = require_to_integer();
    var max = Math.max;
    var min = Math.min;
    module2.exports = function(index3, length2) {
      index3 = toInteger(index3);
      return index3 < 0 ? max(index3 + length2, 0) : min(index3, length2);
    };
  }
});

// ../../node_modules/core-js/library/modules/_array-includes.js
var require_array_includes = __commonJS({
  "../../node_modules/core-js/library/modules/_array-includes.js"(exports2, module2) {
    var toIObject = require_to_iobject();
    var toLength = require_to_length();
    var toAbsoluteIndex = require_to_absolute_index();
    module2.exports = function(IS_INCLUDES) {
      return function($this, el, fromIndex) {
        var O = toIObject($this);
        var length2 = toLength(O.length);
        var index3 = toAbsoluteIndex(fromIndex, length2);
        var value;
        if (IS_INCLUDES && el != el) while (length2 > index3) {
          value = O[index3++];
          if (value != value) return true;
        }
        else for (; length2 > index3; index3++) if (IS_INCLUDES || index3 in O) {
          if (O[index3] === el) return IS_INCLUDES || index3 || 0;
        }
        return !IS_INCLUDES && -1;
      };
    };
  }
});

// ../../node_modules/core-js/library/modules/_library.js
var require_library = __commonJS({
  "../../node_modules/core-js/library/modules/_library.js"(exports2, module2) {
    module2.exports = true;
  }
});

// ../../node_modules/core-js/library/modules/_shared.js
var require_shared = __commonJS({
  "../../node_modules/core-js/library/modules/_shared.js"(exports2, module2) {
    var core = require_core();
    var global2 = require_global();
    var SHARED = "__core-js_shared__";
    var store = global2[SHARED] || (global2[SHARED] = {});
    (module2.exports = function(key2, value) {
      return store[key2] || (store[key2] = value !== void 0 ? value : {});
    })("versions", []).push({
      version: core.version,
      mode: require_library() ? "pure" : "global",
      copyright: "\xA9 2020 Denis Pushkarev (zloirock.ru)"
    });
  }
});

// ../../node_modules/core-js/library/modules/_uid.js
var require_uid = __commonJS({
  "../../node_modules/core-js/library/modules/_uid.js"(exports2, module2) {
    var id = 0;
    var px = Math.random();
    module2.exports = function(key2) {
      return "Symbol(".concat(key2 === void 0 ? "" : key2, ")_", (++id + px).toString(36));
    };
  }
});

// ../../node_modules/core-js/library/modules/_shared-key.js
var require_shared_key = __commonJS({
  "../../node_modules/core-js/library/modules/_shared-key.js"(exports2, module2) {
    var shared = require_shared()("keys");
    var uid3 = require_uid();
    module2.exports = function(key2) {
      return shared[key2] || (shared[key2] = uid3(key2));
    };
  }
});

// ../../node_modules/core-js/library/modules/_object-keys-internal.js
var require_object_keys_internal = __commonJS({
  "../../node_modules/core-js/library/modules/_object-keys-internal.js"(exports2, module2) {
    var has2 = require_has2();
    var toIObject = require_to_iobject();
    var arrayIndexOf = require_array_includes()(false);
    var IE_PROTO = require_shared_key()("IE_PROTO");
    module2.exports = function(object4, names2) {
      var O = toIObject(object4);
      var i = 0;
      var result = [];
      var key2;
      for (key2 in O) if (key2 != IE_PROTO) has2(O, key2) && result.push(key2);
      while (names2.length > i) if (has2(O, key2 = names2[i++])) {
        ~arrayIndexOf(result, key2) || result.push(key2);
      }
      return result;
    };
  }
});

// ../../node_modules/core-js/library/modules/_enum-bug-keys.js
var require_enum_bug_keys = __commonJS({
  "../../node_modules/core-js/library/modules/_enum-bug-keys.js"(exports2, module2) {
    module2.exports = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");
  }
});

// ../../node_modules/core-js/library/modules/_object-keys.js
var require_object_keys = __commonJS({
  "../../node_modules/core-js/library/modules/_object-keys.js"(exports2, module2) {
    var $keys = require_object_keys_internal();
    var enumBugKeys = require_enum_bug_keys();
    module2.exports = Object.keys || function keys4(O) {
      return $keys(O, enumBugKeys);
    };
  }
});

// ../../node_modules/core-js/library/modules/_object-gops.js
var require_object_gops = __commonJS({
  "../../node_modules/core-js/library/modules/_object-gops.js"(exports2) {
    exports2.f = Object.getOwnPropertySymbols;
  }
});

// ../../node_modules/core-js/library/modules/_object-pie.js
var require_object_pie = __commonJS({
  "../../node_modules/core-js/library/modules/_object-pie.js"(exports2) {
    exports2.f = {}.propertyIsEnumerable;
  }
});

// ../../node_modules/core-js/library/modules/_to-object.js
var require_to_object = __commonJS({
  "../../node_modules/core-js/library/modules/_to-object.js"(exports2, module2) {
    var defined = require_defined();
    module2.exports = function(it) {
      return Object(defined(it));
    };
  }
});

// ../../node_modules/core-js/library/modules/_object-assign.js
var require_object_assign2 = __commonJS({
  "../../node_modules/core-js/library/modules/_object-assign.js"(exports2, module2) {
    "use strict";
    var DESCRIPTORS = require_descriptors();
    var getKeys3 = require_object_keys();
    var gOPS = require_object_gops();
    var pIE = require_object_pie();
    var toObject = require_to_object();
    var IObject = require_iobject();
    var $assign = Object.assign;
    module2.exports = !$assign || require_fails()(function() {
      var A = {};
      var B = {};
      var S = Symbol();
      var K = "abcdefghijklmnopqrst";
      A[S] = 7;
      K.split("").forEach(function(k) {
        B[k] = k;
      });
      return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join("") != K;
    }) ? function assign2(target, source) {
      var T = toObject(target);
      var aLen = arguments.length;
      var index3 = 1;
      var getSymbols2 = gOPS.f;
      var isEnum = pIE.f;
      while (aLen > index3) {
        var S = IObject(arguments[index3++]);
        var keys4 = getSymbols2 ? getKeys3(S).concat(getSymbols2(S)) : getKeys3(S);
        var length2 = keys4.length;
        var j = 0;
        var key2;
        while (length2 > j) {
          key2 = keys4[j++];
          if (!DESCRIPTORS || isEnum.call(S, key2)) T[key2] = S[key2];
        }
      }
      return T;
    } : $assign;
  }
});

// ../../node_modules/core-js/library/modules/es6.object.assign.js
var require_es6_object_assign = __commonJS({
  "../../node_modules/core-js/library/modules/es6.object.assign.js"() {
    var $export = require_export();
    $export($export.S + $export.F, "Object", { assign: require_object_assign2() });
  }
});

// ../../node_modules/core-js/library/fn/object/assign.js
var require_assign = __commonJS({
  "../../node_modules/core-js/library/fn/object/assign.js"(exports2, module2) {
    require_es6_object_assign();
    module2.exports = require_core().Object.assign;
  }
});

// ../../node_modules/babel-runtime/core-js/object/assign.js
var require_assign2 = __commonJS({
  "../../node_modules/babel-runtime/core-js/object/assign.js"(exports2, module2) {
    module2.exports = { "default": require_assign(), __esModule: true };
  }
});

// ../../node_modules/babel-runtime/helpers/extends.js
var require_extends = __commonJS({
  "../../node_modules/babel-runtime/helpers/extends.js"(exports2) {
    "use strict";
    exports2.__esModule = true;
    var _assign = require_assign2();
    var _assign2 = _interopRequireDefault(_assign);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { default: obj };
    }
    exports2.default = _assign2.default || function(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key2 in source) {
          if (Object.prototype.hasOwnProperty.call(source, key2)) {
            target[key2] = source[key2];
          }
        }
      }
      return target;
    };
  }
});

// ../../node_modules/create-react-class/factory.js
var require_factory = __commonJS({
  "../../node_modules/create-react-class/factory.js"(exports2, module2) {
    "use strict";
    var _assign = require_object_assign();
    var emptyObject = {};
    if (true) {
      Object.freeze(emptyObject);
    }
    var validateFormat = function validateFormat2(format3) {
    };
    if (true) {
      validateFormat = function validateFormat2(format3) {
        if (format3 === void 0) {
          throw new Error("invariant requires an error message argument");
        }
      };
    }
    function _invariant(condition, format3, a, b, c, d, e3, f) {
      validateFormat(format3);
      if (!condition) {
        var error2;
        if (format3 === void 0) {
          error2 = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        } else {
          var args = [a, b, c, d, e3, f];
          var argIndex = 0;
          error2 = new Error(format3.replace(/%s/g, function() {
            return args[argIndex++];
          }));
          error2.name = "Invariant Violation";
        }
        error2.framesToPop = 1;
        throw error2;
      }
    }
    var warning6 = function() {
    };
    if (true) {
      printWarning = function printWarning2(format3) {
        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }
        var argIndex = 0;
        var message2 = "Warning: " + format3.replace(/%s/g, function() {
          return args[argIndex++];
        });
        if (typeof console !== "undefined") {
          console.error(message2);
        }
        try {
          throw new Error(message2);
        } catch (x) {
        }
      };
      warning6 = function warning7(condition, format3) {
        if (format3 === void 0) {
          throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        }
        if (format3.indexOf("Failed Composite propType: ") === 0) {
          return;
        }
        if (!condition) {
          for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
            args[_key2 - 2] = arguments[_key2];
          }
          printWarning.apply(void 0, [format3].concat(args));
        }
      };
    }
    var printWarning;
    var MIXINS_KEY = "mixins";
    function identity3(fn) {
      return fn;
    }
    var ReactPropTypeLocationNames;
    if (true) {
      ReactPropTypeLocationNames = {
        prop: "prop",
        context: "context",
        childContext: "child context"
      };
    } else {
      ReactPropTypeLocationNames = {};
    }
    function factory(ReactComponent, isValidElement31, ReactNoopUpdateQueue) {
      var injectedMixins = [];
      var ReactClassInterface = {
        /**
         * An array of Mixin objects to include when defining your component.
         *
         * @type {array}
         * @optional
         */
        mixins: "DEFINE_MANY",
        /**
         * An object containing properties and methods that should be defined on
         * the component's constructor instead of its prototype (static methods).
         *
         * @type {object}
         * @optional
         */
        statics: "DEFINE_MANY",
        /**
         * Definition of prop types for this component.
         *
         * @type {object}
         * @optional
         */
        propTypes: "DEFINE_MANY",
        /**
         * Definition of context types for this component.
         *
         * @type {object}
         * @optional
         */
        contextTypes: "DEFINE_MANY",
        /**
         * Definition of context types this component sets for its children.
         *
         * @type {object}
         * @optional
         */
        childContextTypes: "DEFINE_MANY",
        // ==== Definition methods ====
        /**
         * Invoked when the component is mounted. Values in the mapping will be set on
         * `this.props` if that prop is not specified (i.e. using an `in` check).
         *
         * This method is invoked before `getInitialState` and therefore cannot rely
         * on `this.state` or use `this.setState`.
         *
         * @return {object}
         * @optional
         */
        getDefaultProps: "DEFINE_MANY_MERGED",
        /**
         * Invoked once before the component is mounted. The return value will be used
         * as the initial value of `this.state`.
         *
         *   getInitialState: function() {
         *     return {
         *       isOn: false,
         *       fooBaz: new BazFoo()
         *     }
         *   }
         *
         * @return {object}
         * @optional
         */
        getInitialState: "DEFINE_MANY_MERGED",
        /**
         * @return {object}
         * @optional
         */
        getChildContext: "DEFINE_MANY_MERGED",
        /**
         * Uses props from `this.props` and state from `this.state` to render the
         * structure of the component.
         *
         * No guarantees are made about when or how often this method is invoked, so
         * it must not have side effects.
         *
         *   render: function() {
         *     var name = this.props.name;
         *     return <div>Hello, {name}!</div>;
         *   }
         *
         * @return {ReactComponent}
         * @required
         */
        render: "DEFINE_ONCE",
        // ==== Delegate methods ====
        /**
         * Invoked when the component is initially created and about to be mounted.
         * This may have side effects, but any external subscriptions or data created
         * by this method must be cleaned up in `componentWillUnmount`.
         *
         * @optional
         */
        componentWillMount: "DEFINE_MANY",
        /**
         * Invoked when the component has been mounted and has a DOM representation.
         * However, there is no guarantee that the DOM node is in the document.
         *
         * Use this as an opportunity to operate on the DOM when the component has
         * been mounted (initialized and rendered) for the first time.
         *
         * @param {DOMElement} rootNode DOM element representing the component.
         * @optional
         */
        componentDidMount: "DEFINE_MANY",
        /**
         * Invoked before the component receives new props.
         *
         * Use this as an opportunity to react to a prop transition by updating the
         * state using `this.setState`. Current props are accessed via `this.props`.
         *
         *   componentWillReceiveProps: function(nextProps, nextContext) {
         *     this.setState({
         *       likesIncreasing: nextProps.likeCount > this.props.likeCount
         *     });
         *   }
         *
         * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
         * transition may cause a state change, but the opposite is not true. If you
         * need it, you are probably looking for `componentWillUpdate`.
         *
         * @param {object} nextProps
         * @optional
         */
        componentWillReceiveProps: "DEFINE_MANY",
        /**
         * Invoked while deciding if the component should be updated as a result of
         * receiving new props, state and/or context.
         *
         * Use this as an opportunity to `return false` when you're certain that the
         * transition to the new props/state/context will not require a component
         * update.
         *
         *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
         *     return !equal(nextProps, this.props) ||
         *       !equal(nextState, this.state) ||
         *       !equal(nextContext, this.context);
         *   }
         *
         * @param {object} nextProps
         * @param {?object} nextState
         * @param {?object} nextContext
         * @return {boolean} True if the component should update.
         * @optional
         */
        shouldComponentUpdate: "DEFINE_ONCE",
        /**
         * Invoked when the component is about to update due to a transition from
         * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
         * and `nextContext`.
         *
         * Use this as an opportunity to perform preparation before an update occurs.
         *
         * NOTE: You **cannot** use `this.setState()` in this method.
         *
         * @param {object} nextProps
         * @param {?object} nextState
         * @param {?object} nextContext
         * @param {ReactReconcileTransaction} transaction
         * @optional
         */
        componentWillUpdate: "DEFINE_MANY",
        /**
         * Invoked when the component's DOM representation has been updated.
         *
         * Use this as an opportunity to operate on the DOM when the component has
         * been updated.
         *
         * @param {object} prevProps
         * @param {?object} prevState
         * @param {?object} prevContext
         * @param {DOMElement} rootNode DOM element representing the component.
         * @optional
         */
        componentDidUpdate: "DEFINE_MANY",
        /**
         * Invoked when the component is about to be removed from its parent and have
         * its DOM representation destroyed.
         *
         * Use this as an opportunity to deallocate any external resources.
         *
         * NOTE: There is no `componentDidUnmount` since your component will have been
         * destroyed by that point.
         *
         * @optional
         */
        componentWillUnmount: "DEFINE_MANY",
        /**
         * Replacement for (deprecated) `componentWillMount`.
         *
         * @optional
         */
        UNSAFE_componentWillMount: "DEFINE_MANY",
        /**
         * Replacement for (deprecated) `componentWillReceiveProps`.
         *
         * @optional
         */
        UNSAFE_componentWillReceiveProps: "DEFINE_MANY",
        /**
         * Replacement for (deprecated) `componentWillUpdate`.
         *
         * @optional
         */
        UNSAFE_componentWillUpdate: "DEFINE_MANY",
        // ==== Advanced methods ====
        /**
         * Updates the component's currently mounted DOM representation.
         *
         * By default, this implements React's rendering and reconciliation algorithm.
         * Sophisticated clients may wish to override this.
         *
         * @param {ReactReconcileTransaction} transaction
         * @internal
         * @overridable
         */
        updateComponent: "OVERRIDE_BASE"
      };
      var ReactClassStaticInterface = {
        /**
         * This method is invoked after a component is instantiated and when it
         * receives new props. Return an object to update state in response to
         * prop changes. Return null to indicate no change to state.
         *
         * If an object is returned, its keys will be merged into the existing state.
         *
         * @return {object || null}
         * @optional
         */
        getDerivedStateFromProps: "DEFINE_MANY_MERGED"
      };
      var RESERVED_SPEC_KEYS = {
        displayName: function(Constructor, displayName) {
          Constructor.displayName = displayName;
        },
        mixins: function(Constructor, mixins) {
          if (mixins) {
            for (var i = 0; i < mixins.length; i++) {
              mixSpecIntoComponent(Constructor, mixins[i]);
            }
          }
        },
        childContextTypes: function(Constructor, childContextTypes) {
          if (true) {
            validateTypeDef(Constructor, childContextTypes, "childContext");
          }
          Constructor.childContextTypes = _assign(
            {},
            Constructor.childContextTypes,
            childContextTypes
          );
        },
        contextTypes: function(Constructor, contextTypes) {
          if (true) {
            validateTypeDef(Constructor, contextTypes, "context");
          }
          Constructor.contextTypes = _assign(
            {},
            Constructor.contextTypes,
            contextTypes
          );
        },
        /**
         * Special case getDefaultProps which should move into statics but requires
         * automatic merging.
         */
        getDefaultProps: function(Constructor, getDefaultProps) {
          if (Constructor.getDefaultProps) {
            Constructor.getDefaultProps = createMergedResultFunction(
              Constructor.getDefaultProps,
              getDefaultProps
            );
          } else {
            Constructor.getDefaultProps = getDefaultProps;
          }
        },
        propTypes: function(Constructor, propTypes) {
          if (true) {
            validateTypeDef(Constructor, propTypes, "prop");
          }
          Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
        },
        statics: function(Constructor, statics) {
          mixStaticSpecIntoComponent(Constructor, statics);
        },
        autobind: function() {
        }
      };
      function validateTypeDef(Constructor, typeDef, location2) {
        for (var propName in typeDef) {
          if (typeDef.hasOwnProperty(propName)) {
            if (true) {
              warning6(
                typeof typeDef[propName] === "function",
                "%s: %s type `%s` is invalid; it must be a function, usually from React.PropTypes.",
                Constructor.displayName || "ReactClass",
                ReactPropTypeLocationNames[location2],
                propName
              );
            }
          }
        }
      }
      function validateMethodOverride(isAlreadyDefined, name) {
        var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;
        if (ReactClassMixin.hasOwnProperty(name)) {
          _invariant(
            specPolicy === "OVERRIDE_BASE",
            "ReactClassInterface: You are attempting to override `%s` from your class specification. Ensure that your method names do not overlap with React methods.",
            name
          );
        }
        if (isAlreadyDefined) {
          _invariant(
            specPolicy === "DEFINE_MANY" || specPolicy === "DEFINE_MANY_MERGED",
            "ReactClassInterface: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.",
            name
          );
        }
      }
      function mixSpecIntoComponent(Constructor, spec) {
        if (!spec) {
          if (true) {
            var typeofSpec = typeof spec;
            var isMixinValid = typeofSpec === "object" && spec !== null;
            if (true) {
              warning6(
                isMixinValid,
                "%s: You're attempting to include a mixin that is either null or not an object. Check the mixins included by the component, as well as any mixins they include themselves. Expected object but got %s.",
                Constructor.displayName || "ReactClass",
                spec === null ? null : typeofSpec
              );
            }
          }
          return;
        }
        _invariant(
          typeof spec !== "function",
          "ReactClass: You're attempting to use a component class or function as a mixin. Instead, just use a regular object."
        );
        _invariant(
          !isValidElement31(spec),
          "ReactClass: You're attempting to use a component as a mixin. Instead, just use a regular object."
        );
        var proto = Constructor.prototype;
        var autoBindPairs = proto.__reactAutoBindPairs;
        if (spec.hasOwnProperty(MIXINS_KEY)) {
          RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
        }
        for (var name in spec) {
          if (!spec.hasOwnProperty(name)) {
            continue;
          }
          if (name === MIXINS_KEY) {
            continue;
          }
          var property2 = spec[name];
          var isAlreadyDefined = proto.hasOwnProperty(name);
          validateMethodOverride(isAlreadyDefined, name);
          if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
            RESERVED_SPEC_KEYS[name](Constructor, property2);
          } else {
            var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
            var isFunction6 = typeof property2 === "function";
            var shouldAutoBind = isFunction6 && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;
            if (shouldAutoBind) {
              autoBindPairs.push(name, property2);
              proto[name] = property2;
            } else {
              if (isAlreadyDefined) {
                var specPolicy = ReactClassInterface[name];
                _invariant(
                  isReactClassMethod && (specPolicy === "DEFINE_MANY_MERGED" || specPolicy === "DEFINE_MANY"),
                  "ReactClass: Unexpected spec policy %s for key %s when mixing in component specs.",
                  specPolicy,
                  name
                );
                if (specPolicy === "DEFINE_MANY_MERGED") {
                  proto[name] = createMergedResultFunction(proto[name], property2);
                } else if (specPolicy === "DEFINE_MANY") {
                  proto[name] = createChainedFunction(proto[name], property2);
                }
              } else {
                proto[name] = property2;
                if (true) {
                  if (typeof property2 === "function" && spec.displayName) {
                    proto[name].displayName = spec.displayName + "_" + name;
                  }
                }
              }
            }
          }
        }
      }
      function mixStaticSpecIntoComponent(Constructor, statics) {
        if (!statics) {
          return;
        }
        for (var name in statics) {
          var property2 = statics[name];
          if (!statics.hasOwnProperty(name)) {
            continue;
          }
          var isReserved = name in RESERVED_SPEC_KEYS;
          _invariant(
            !isReserved,
            'ReactClass: You are attempting to define a reserved property, `%s`, that shouldn\'t be on the "statics" key. Define it as an instance property instead; it will still be accessible on the constructor.',
            name
          );
          var isAlreadyDefined = name in Constructor;
          if (isAlreadyDefined) {
            var specPolicy = ReactClassStaticInterface.hasOwnProperty(name) ? ReactClassStaticInterface[name] : null;
            _invariant(
              specPolicy === "DEFINE_MANY_MERGED",
              "ReactClass: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.",
              name
            );
            Constructor[name] = createMergedResultFunction(Constructor[name], property2);
            return;
          }
          Constructor[name] = property2;
        }
      }
      function mergeIntoWithNoDuplicateKeys(one, two) {
        _invariant(
          one && two && typeof one === "object" && typeof two === "object",
          "mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects."
        );
        for (var key2 in two) {
          if (two.hasOwnProperty(key2)) {
            _invariant(
              one[key2] === void 0,
              "mergeIntoWithNoDuplicateKeys(): Tried to merge two objects with the same key: `%s`. This conflict may be due to a mixin; in particular, this may be caused by two getInitialState() or getDefaultProps() methods returning objects with clashing keys.",
              key2
            );
            one[key2] = two[key2];
          }
        }
        return one;
      }
      function createMergedResultFunction(one, two) {
        return function mergedResult() {
          var a = one.apply(this, arguments);
          var b = two.apply(this, arguments);
          if (a == null) {
            return b;
          } else if (b == null) {
            return a;
          }
          var c = {};
          mergeIntoWithNoDuplicateKeys(c, a);
          mergeIntoWithNoDuplicateKeys(c, b);
          return c;
        };
      }
      function createChainedFunction(one, two) {
        return function chainedFunction() {
          one.apply(this, arguments);
          two.apply(this, arguments);
        };
      }
      function bindAutoBindMethod(component, method4) {
        var boundMethod = method4.bind(component);
        if (true) {
          boundMethod.__reactBoundContext = component;
          boundMethod.__reactBoundMethod = method4;
          boundMethod.__reactBoundArguments = null;
          var componentName = component.constructor.displayName;
          var _bind = boundMethod.bind;
          boundMethod.bind = function(newThis) {
            for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
              args[_key - 1] = arguments[_key];
            }
            if (newThis !== component && newThis !== null) {
              if (true) {
                warning6(
                  false,
                  "bind(): React component methods may only be bound to the component instance. See %s",
                  componentName
                );
              }
            } else if (!args.length) {
              if (true) {
                warning6(
                  false,
                  "bind(): You are binding a component method to the component. React does this for you automatically in a high-performance way, so you can safely remove this call. See %s",
                  componentName
                );
              }
              return boundMethod;
            }
            var reboundMethod = _bind.apply(boundMethod, arguments);
            reboundMethod.__reactBoundContext = component;
            reboundMethod.__reactBoundMethod = method4;
            reboundMethod.__reactBoundArguments = args;
            return reboundMethod;
          };
        }
        return boundMethod;
      }
      function bindAutoBindMethods(component) {
        var pairs = component.__reactAutoBindPairs;
        for (var i = 0; i < pairs.length; i += 2) {
          var autoBindKey = pairs[i];
          var method4 = pairs[i + 1];
          component[autoBindKey] = bindAutoBindMethod(component, method4);
        }
      }
      var IsMountedPreMixin = {
        componentDidMount: function() {
          this.__isMounted = true;
        }
      };
      var IsMountedPostMixin = {
        componentWillUnmount: function() {
          this.__isMounted = false;
        }
      };
      var ReactClassMixin = {
        /**
         * TODO: This will be deprecated because state should always keep a consistent
         * type signature and the only use case for this, is to avoid that.
         */
        replaceState: function(newState, callback) {
          this.updater.enqueueReplaceState(this, newState, callback);
        },
        /**
         * Checks whether or not this composite component is mounted.
         * @return {boolean} True if mounted, false otherwise.
         * @protected
         * @final
         */
        isMounted: function() {
          if (true) {
            warning6(
              this.__didWarnIsMounted,
              "%s: isMounted is deprecated. Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks.",
              this.constructor && this.constructor.displayName || this.name || "Component"
            );
            this.__didWarnIsMounted = true;
          }
          return !!this.__isMounted;
        }
      };
      var ReactClassComponent = function() {
      };
      _assign(
        ReactClassComponent.prototype,
        ReactComponent.prototype,
        ReactClassMixin
      );
      function createClass(spec) {
        var Constructor = identity3(function(props, context, updater) {
          if (true) {
            warning6(
              this instanceof Constructor,
              "Something is calling a React component directly. Use a factory or JSX instead. See: https://fb.me/react-legacyfactory"
            );
          }
          if (this.__reactAutoBindPairs.length) {
            bindAutoBindMethods(this);
          }
          this.props = props;
          this.context = context;
          this.refs = emptyObject;
          this.updater = updater || ReactNoopUpdateQueue;
          this.state = null;
          var initialState = this.getInitialState ? this.getInitialState() : null;
          if (true) {
            if (initialState === void 0 && this.getInitialState._isMockFunction) {
              initialState = null;
            }
          }
          _invariant(
            typeof initialState === "object" && !Array.isArray(initialState),
            "%s.getInitialState(): must return an object or null",
            Constructor.displayName || "ReactCompositeComponent"
          );
          this.state = initialState;
        });
        Constructor.prototype = new ReactClassComponent();
        Constructor.prototype.constructor = Constructor;
        Constructor.prototype.__reactAutoBindPairs = [];
        injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
        mixSpecIntoComponent(Constructor, IsMountedPreMixin);
        mixSpecIntoComponent(Constructor, spec);
        mixSpecIntoComponent(Constructor, IsMountedPostMixin);
        if (Constructor.getDefaultProps) {
          Constructor.defaultProps = Constructor.getDefaultProps();
        }
        if (true) {
          if (Constructor.getDefaultProps) {
            Constructor.getDefaultProps.isReactClassApproved = {};
          }
          if (Constructor.prototype.getInitialState) {
            Constructor.prototype.getInitialState.isReactClassApproved = {};
          }
        }
        _invariant(
          Constructor.prototype.render,
          "createClass(...): Class specification must implement a `render` method."
        );
        if (true) {
          warning6(
            !Constructor.prototype.componentShouldUpdate,
            "%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.",
            spec.displayName || "A component"
          );
          warning6(
            !Constructor.prototype.componentWillRecieveProps,
            "%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?",
            spec.displayName || "A component"
          );
          warning6(
            !Constructor.prototype.UNSAFE_componentWillRecieveProps,
            "%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?",
            spec.displayName || "A component"
          );
        }
        for (var methodName in ReactClassInterface) {
          if (!Constructor.prototype[methodName]) {
            Constructor.prototype[methodName] = null;
          }
        }
        return Constructor;
      }
      return createClass;
    }
    module2.exports = factory;
  }
});

// ../../node_modules/create-react-class/index.js
var require_create_react_class = __commonJS({
  "../../node_modules/create-react-class/index.js"(exports2, module2) {
    "use strict";
    var React615 = require_react();
    var factory = require_factory();
    if (typeof React615 === "undefined") {
      throw Error(
        "create-react-class could not find the React object. If you are using script tags, make sure that React is being loaded before create-react-class."
      );
    }
    var ReactNoopUpdateQueue = new React615.Component().updater;
    module2.exports = factory(
      React615.Component,
      React615.isValidElement,
      ReactNoopUpdateQueue
    );
  }
});

// ../../node_modules/rc-trigger/node_modules/rc-util/lib/Dom/contains.js
var require_contains = __commonJS({
  "../../node_modules/rc-trigger/node_modules/rc-util/lib/Dom/contains.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = contains2;
    function contains2(root2, n2) {
      var node2 = n2;
      while (node2) {
        if (node2 === root2) {
          return true;
        }
        node2 = node2.parentNode;
      }
      return false;
    }
  }
});

// ../../node_modules/add-dom-event-listener/lib/EventBaseObject.js
var require_EventBaseObject = __commonJS({
  "../../node_modules/add-dom-event-listener/lib/EventBaseObject.js"(exports2, module2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    function returnFalse() {
      return false;
    }
    function returnTrue() {
      return true;
    }
    function EventBaseObject() {
      this.timeStamp = Date.now();
      this.target = void 0;
      this.currentTarget = void 0;
    }
    EventBaseObject.prototype = {
      isEventObject: 1,
      constructor: EventBaseObject,
      isDefaultPrevented: returnFalse,
      isPropagationStopped: returnFalse,
      isImmediatePropagationStopped: returnFalse,
      preventDefault: function preventDefault2() {
        this.isDefaultPrevented = returnTrue;
      },
      stopPropagation: function stopPropagation2() {
        this.isPropagationStopped = returnTrue;
      },
      stopImmediatePropagation: function stopImmediatePropagation() {
        this.isImmediatePropagationStopped = returnTrue;
        this.stopPropagation();
      },
      halt: function halt(immediate) {
        if (immediate) {
          this.stopImmediatePropagation();
        } else {
          this.stopPropagation();
        }
        this.preventDefault();
      }
    };
    exports2["default"] = EventBaseObject;
    module2.exports = exports2["default"];
  }
});

// ../../node_modules/add-dom-event-listener/lib/EventObject.js
var require_EventObject = __commonJS({
  "../../node_modules/add-dom-event-listener/lib/EventObject.js"(exports2, module2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    var _EventBaseObject = require_EventBaseObject();
    var _EventBaseObject2 = _interopRequireDefault(_EventBaseObject);
    var _objectAssign = require_object_assign();
    var _objectAssign2 = _interopRequireDefault(_objectAssign);
    var TRUE = true;
    var FALSE = false;
    var commonProps = ["altKey", "bubbles", "cancelable", "ctrlKey", "currentTarget", "eventPhase", "metaKey", "shiftKey", "target", "timeStamp", "view", "type"];
    function isNullOrUndefined(w) {
      return w === null || w === void 0;
    }
    var eventNormalizers = [{
      reg: /^key/,
      props: ["char", "charCode", "key", "keyCode", "which"],
      fix: function fix(event, nativeEvent) {
        if (isNullOrUndefined(event.which)) {
          event.which = !isNullOrUndefined(nativeEvent.charCode) ? nativeEvent.charCode : nativeEvent.keyCode;
        }
        if (event.metaKey === void 0) {
          event.metaKey = event.ctrlKey;
        }
      }
    }, {
      reg: /^touch/,
      props: ["touches", "changedTouches", "targetTouches"]
    }, {
      reg: /^hashchange$/,
      props: ["newURL", "oldURL"]
    }, {
      reg: /^gesturechange$/i,
      props: ["rotation", "scale"]
    }, {
      reg: /^(mousewheel|DOMMouseScroll)$/,
      props: [],
      fix: function fix(event, nativeEvent) {
        var deltaX = void 0;
        var deltaY = void 0;
        var delta = void 0;
        var wheelDelta = nativeEvent.wheelDelta;
        var axis = nativeEvent.axis;
        var wheelDeltaY = nativeEvent.wheelDeltaY;
        var wheelDeltaX = nativeEvent.wheelDeltaX;
        var detail = nativeEvent.detail;
        if (wheelDelta) {
          delta = wheelDelta / 120;
        }
        if (detail) {
          delta = 0 - (detail % 3 === 0 ? detail / 3 : detail);
        }
        if (axis !== void 0) {
          if (axis === event.HORIZONTAL_AXIS) {
            deltaY = 0;
            deltaX = 0 - delta;
          } else if (axis === event.VERTICAL_AXIS) {
            deltaX = 0;
            deltaY = delta;
          }
        }
        if (wheelDeltaY !== void 0) {
          deltaY = wheelDeltaY / 120;
        }
        if (wheelDeltaX !== void 0) {
          deltaX = -1 * wheelDeltaX / 120;
        }
        if (!deltaX && !deltaY) {
          deltaY = delta;
        }
        if (deltaX !== void 0) {
          event.deltaX = deltaX;
        }
        if (deltaY !== void 0) {
          event.deltaY = deltaY;
        }
        if (delta !== void 0) {
          event.delta = delta;
        }
      }
    }, {
      reg: /^mouse|contextmenu|click|mspointer|(^DOMMouseScroll$)/i,
      props: ["buttons", "clientX", "clientY", "button", "offsetX", "relatedTarget", "which", "fromElement", "toElement", "offsetY", "pageX", "pageY", "screenX", "screenY"],
      fix: function fix(event, nativeEvent) {
        var eventDoc = void 0;
        var doc2 = void 0;
        var body = void 0;
        var target = event.target;
        var button = nativeEvent.button;
        if (target && isNullOrUndefined(event.pageX) && !isNullOrUndefined(nativeEvent.clientX)) {
          eventDoc = target.ownerDocument || document;
          doc2 = eventDoc.documentElement;
          body = eventDoc.body;
          event.pageX = nativeEvent.clientX + (doc2 && doc2.scrollLeft || body && body.scrollLeft || 0) - (doc2 && doc2.clientLeft || body && body.clientLeft || 0);
          event.pageY = nativeEvent.clientY + (doc2 && doc2.scrollTop || body && body.scrollTop || 0) - (doc2 && doc2.clientTop || body && body.clientTop || 0);
        }
        if (!event.which && button !== void 0) {
          if (button & 1) {
            event.which = 1;
          } else if (button & 2) {
            event.which = 3;
          } else if (button & 4) {
            event.which = 2;
          } else {
            event.which = 0;
          }
        }
        if (!event.relatedTarget && event.fromElement) {
          event.relatedTarget = event.fromElement === target ? event.toElement : event.fromElement;
        }
        return event;
      }
    }];
    function retTrue() {
      return TRUE;
    }
    function retFalse() {
      return FALSE;
    }
    function DomEventObject(nativeEvent) {
      var type5 = nativeEvent.type;
      var isNative = typeof nativeEvent.stopPropagation === "function" || typeof nativeEvent.cancelBubble === "boolean";
      _EventBaseObject2["default"].call(this);
      this.nativeEvent = nativeEvent;
      var isDefaultPrevented = retFalse;
      if ("defaultPrevented" in nativeEvent) {
        isDefaultPrevented = nativeEvent.defaultPrevented ? retTrue : retFalse;
      } else if ("getPreventDefault" in nativeEvent) {
        isDefaultPrevented = nativeEvent.getPreventDefault() ? retTrue : retFalse;
      } else if ("returnValue" in nativeEvent) {
        isDefaultPrevented = nativeEvent.returnValue === FALSE ? retTrue : retFalse;
      }
      this.isDefaultPrevented = isDefaultPrevented;
      var fixFns = [];
      var fixFn = void 0;
      var l2 = void 0;
      var prop = void 0;
      var props = commonProps.concat();
      eventNormalizers.forEach(function(normalizer) {
        if (type5.match(normalizer.reg)) {
          props = props.concat(normalizer.props);
          if (normalizer.fix) {
            fixFns.push(normalizer.fix);
          }
        }
      });
      l2 = props.length;
      while (l2) {
        prop = props[--l2];
        this[prop] = nativeEvent[prop];
      }
      if (!this.target && isNative) {
        this.target = nativeEvent.srcElement || document;
      }
      if (this.target && this.target.nodeType === 3) {
        this.target = this.target.parentNode;
      }
      l2 = fixFns.length;
      while (l2) {
        fixFn = fixFns[--l2];
        fixFn(this, nativeEvent);
      }
      this.timeStamp = nativeEvent.timeStamp || Date.now();
    }
    var EventBaseObjectProto = _EventBaseObject2["default"].prototype;
    (0, _objectAssign2["default"])(DomEventObject.prototype, EventBaseObjectProto, {
      constructor: DomEventObject,
      preventDefault: function preventDefault2() {
        var e3 = this.nativeEvent;
        if (e3.preventDefault) {
          e3.preventDefault();
        } else {
          e3.returnValue = FALSE;
        }
        EventBaseObjectProto.preventDefault.call(this);
      },
      stopPropagation: function stopPropagation2() {
        var e3 = this.nativeEvent;
        if (e3.stopPropagation) {
          e3.stopPropagation();
        } else {
          e3.cancelBubble = TRUE;
        }
        EventBaseObjectProto.stopPropagation.call(this);
      }
    });
    exports2["default"] = DomEventObject;
    module2.exports = exports2["default"];
  }
});

// ../../node_modules/add-dom-event-listener/lib/index.js
var require_lib = __commonJS({
  "../../node_modules/add-dom-event-listener/lib/index.js"(exports2, module2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2["default"] = addEventListener;
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    var _EventObject = require_EventObject();
    var _EventObject2 = _interopRequireDefault(_EventObject);
    function addEventListener(target, eventType, callback, option) {
      function wrapCallback(e3) {
        var ne = new _EventObject2["default"](e3);
        callback.call(target, ne);
      }
      if (target.addEventListener) {
        var _ret = (function() {
          var useCapture = false;
          if (typeof option === "object") {
            useCapture = option.capture || false;
          } else if (typeof option === "boolean") {
            useCapture = option;
          }
          target.addEventListener(eventType, wrapCallback, option || false);
          return {
            v: {
              remove: function remove() {
                target.removeEventListener(eventType, wrapCallback, useCapture);
              }
            }
          };
        })();
        if (typeof _ret === "object") return _ret.v;
      } else if (target.attachEvent) {
        target.attachEvent("on" + eventType, wrapCallback);
        return {
          remove: function remove() {
            target.detachEvent("on" + eventType, wrapCallback);
          }
        };
      }
    }
    module2.exports = exports2["default"];
  }
});

// ../../node_modules/rc-trigger/node_modules/rc-util/lib/Dom/addEventListener.js
var require_addEventListener = __commonJS({
  "../../node_modules/rc-trigger/node_modules/rc-util/lib/Dom/addEventListener.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = addEventListenerWrap2;
    var _addDomEventListener = _interopRequireDefault(require_lib());
    var _reactDom = _interopRequireDefault(require_react_dom());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { default: obj };
    }
    function addEventListenerWrap2(target, eventType, cb, option) {
      var callback = _reactDom.default.unstable_batchedUpdates ? function run(e3) {
        _reactDom.default.unstable_batchedUpdates(cb, e3);
      } : cb;
      return (0, _addDomEventListener.default)(target, eventType, callback, option);
    }
  }
});

// ../../node_modules/babel-runtime/helpers/classCallCheck.js
var require_classCallCheck = __commonJS({
  "../../node_modules/babel-runtime/helpers/classCallCheck.js"(exports2) {
    "use strict";
    exports2.__esModule = true;
    exports2.default = function(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    };
  }
});

// ../../node_modules/core-js/library/modules/es6.object.define-property.js
var require_es6_object_define_property = __commonJS({
  "../../node_modules/core-js/library/modules/es6.object.define-property.js"() {
    var $export = require_export();
    $export($export.S + $export.F * !require_descriptors(), "Object", { defineProperty: require_object_dp().f });
  }
});

// ../../node_modules/core-js/library/fn/object/define-property.js
var require_define_property = __commonJS({
  "../../node_modules/core-js/library/fn/object/define-property.js"(exports2, module2) {
    require_es6_object_define_property();
    var $Object = require_core().Object;
    module2.exports = function defineProperty2(it, key2, desc) {
      return $Object.defineProperty(it, key2, desc);
    };
  }
});

// ../../node_modules/babel-runtime/core-js/object/define-property.js
var require_define_property2 = __commonJS({
  "../../node_modules/babel-runtime/core-js/object/define-property.js"(exports2, module2) {
    module2.exports = { "default": require_define_property(), __esModule: true };
  }
});

// ../../node_modules/babel-runtime/helpers/createClass.js
var require_createClass = __commonJS({
  "../../node_modules/babel-runtime/helpers/createClass.js"(exports2) {
    "use strict";
    exports2.__esModule = true;
    var _defineProperty11 = require_define_property2();
    var _defineProperty22 = _interopRequireDefault(_defineProperty11);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { default: obj };
    }
    exports2.default = /* @__PURE__ */ (function() {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          (0, _defineProperty22.default)(target, descriptor.key, descriptor);
        }
      }
      return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    })();
  }
});

// ../../node_modules/core-js/library/modules/_string-at.js
var require_string_at = __commonJS({
  "../../node_modules/core-js/library/modules/_string-at.js"(exports2, module2) {
    var toInteger = require_to_integer();
    var defined = require_defined();
    module2.exports = function(TO_STRING) {
      return function(that, pos) {
        var s = String(defined(that));
        var i = toInteger(pos);
        var l2 = s.length;
        var a, b;
        if (i < 0 || i >= l2) return TO_STRING ? "" : void 0;
        a = s.charCodeAt(i);
        return a < 55296 || a > 56319 || i + 1 === l2 || (b = s.charCodeAt(i + 1)) < 56320 || b > 57343 ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 55296 << 10) + (b - 56320) + 65536;
      };
    };
  }
});

// ../../node_modules/core-js/library/modules/_redefine.js
var require_redefine = __commonJS({
  "../../node_modules/core-js/library/modules/_redefine.js"(exports2, module2) {
    module2.exports = require_hide();
  }
});

// ../../node_modules/core-js/library/modules/_iterators.js
var require_iterators = __commonJS({
  "../../node_modules/core-js/library/modules/_iterators.js"(exports2, module2) {
    module2.exports = {};
  }
});

// ../../node_modules/core-js/library/modules/_object-dps.js
var require_object_dps = __commonJS({
  "../../node_modules/core-js/library/modules/_object-dps.js"(exports2, module2) {
    var dP = require_object_dp();
    var anObject = require_an_object();
    var getKeys3 = require_object_keys();
    module2.exports = require_descriptors() ? Object.defineProperties : function defineProperties(O, Properties2) {
      anObject(O);
      var keys4 = getKeys3(Properties2);
      var length2 = keys4.length;
      var i = 0;
      var P;
      while (length2 > i) dP.f(O, P = keys4[i++], Properties2[P]);
      return O;
    };
  }
});

// ../../node_modules/core-js/library/modules/_html.js
var require_html = __commonJS({
  "../../node_modules/core-js/library/modules/_html.js"(exports2, module2) {
    var document2 = require_global().document;
    module2.exports = document2 && document2.documentElement;
  }
});

// ../../node_modules/core-js/library/modules/_object-create.js
var require_object_create = __commonJS({
  "../../node_modules/core-js/library/modules/_object-create.js"(exports2, module2) {
    var anObject = require_an_object();
    var dPs = require_object_dps();
    var enumBugKeys = require_enum_bug_keys();
    var IE_PROTO = require_shared_key()("IE_PROTO");
    var Empty4 = function() {
    };
    var PROTOTYPE = "prototype";
    var createDict = function() {
      var iframe = require_dom_create()("iframe");
      var i = enumBugKeys.length;
      var lt = "<";
      var gt = ">";
      var iframeDocument;
      iframe.style.display = "none";
      require_html().appendChild(iframe);
      iframe.src = "javascript:";
      iframeDocument = iframe.contentWindow.document;
      iframeDocument.open();
      iframeDocument.write(lt + "script" + gt + "document.F=Object" + lt + "/script" + gt);
      iframeDocument.close();
      createDict = iframeDocument.F;
      while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
      return createDict();
    };
    module2.exports = Object.create || function create(O, Properties2) {
      var result;
      if (O !== null) {
        Empty4[PROTOTYPE] = anObject(O);
        result = new Empty4();
        Empty4[PROTOTYPE] = null;
        result[IE_PROTO] = O;
      } else result = createDict();
      return Properties2 === void 0 ? result : dPs(result, Properties2);
    };
  }
});

// ../../node_modules/core-js/library/modules/_wks.js
var require_wks = __commonJS({
  "../../node_modules/core-js/library/modules/_wks.js"(exports2, module2) {
    var store = require_shared()("wks");
    var uid3 = require_uid();
    var Symbol3 = require_global().Symbol;
    var USE_SYMBOL = typeof Symbol3 == "function";
    var $exports = module2.exports = function(name) {
      return store[name] || (store[name] = USE_SYMBOL && Symbol3[name] || (USE_SYMBOL ? Symbol3 : uid3)("Symbol." + name));
    };
    $exports.store = store;
  }
});

// ../../node_modules/core-js/library/modules/_set-to-string-tag.js
var require_set_to_string_tag = __commonJS({
  "../../node_modules/core-js/library/modules/_set-to-string-tag.js"(exports2, module2) {
    var def = require_object_dp().f;
    var has2 = require_has2();
    var TAG = require_wks()("toStringTag");
    module2.exports = function(it, tag, stat) {
      if (it && !has2(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
    };
  }
});

// ../../node_modules/core-js/library/modules/_iter-create.js
var require_iter_create = __commonJS({
  "../../node_modules/core-js/library/modules/_iter-create.js"(exports2, module2) {
    "use strict";
    var create = require_object_create();
    var descriptor = require_property_desc();
    var setToStringTag = require_set_to_string_tag();
    var IteratorPrototype = {};
    require_hide()(IteratorPrototype, require_wks()("iterator"), function() {
      return this;
    });
    module2.exports = function(Constructor, NAME, next2) {
      Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next2) });
      setToStringTag(Constructor, NAME + " Iterator");
    };
  }
});

// ../../node_modules/core-js/library/modules/_object-gpo.js
var require_object_gpo = __commonJS({
  "../../node_modules/core-js/library/modules/_object-gpo.js"(exports2, module2) {
    var has2 = require_has2();
    var toObject = require_to_object();
    var IE_PROTO = require_shared_key()("IE_PROTO");
    var ObjectProto = Object.prototype;
    module2.exports = Object.getPrototypeOf || function(O) {
      O = toObject(O);
      if (has2(O, IE_PROTO)) return O[IE_PROTO];
      if (typeof O.constructor == "function" && O instanceof O.constructor) {
        return O.constructor.prototype;
      }
      return O instanceof Object ? ObjectProto : null;
    };
  }
});

// ../../node_modules/core-js/library/modules/_iter-define.js
var require_iter_define = __commonJS({
  "../../node_modules/core-js/library/modules/_iter-define.js"(exports2, module2) {
    "use strict";
    var LIBRARY = require_library();
    var $export = require_export();
    var redefine = require_redefine();
    var hide = require_hide();
    var Iterators = require_iterators();
    var $iterCreate = require_iter_create();
    var setToStringTag = require_set_to_string_tag();
    var getPrototypeOf = require_object_gpo();
    var ITERATOR = require_wks()("iterator");
    var BUGGY = !([].keys && "next" in [].keys());
    var FF_ITERATOR = "@@iterator";
    var KEYS = "keys";
    var VALUES = "values";
    var returnThis = function() {
      return this;
    };
    module2.exports = function(Base3, NAME, Constructor, next2, DEFAULT, IS_SET, FORCED) {
      $iterCreate(Constructor, NAME, next2);
      var getMethod = function(kind) {
        if (!BUGGY && kind in proto) return proto[kind];
        switch (kind) {
          case KEYS:
            return function keys4() {
              return new Constructor(this, kind);
            };
          case VALUES:
            return function values() {
              return new Constructor(this, kind);
            };
        }
        return function entries() {
          return new Constructor(this, kind);
        };
      };
      var TAG = NAME + " Iterator";
      var DEF_VALUES = DEFAULT == VALUES;
      var VALUES_BUG = false;
      var proto = Base3.prototype;
      var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
      var $default = $native || getMethod(DEFAULT);
      var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod("entries") : void 0;
      var $anyNative = NAME == "Array" ? proto.entries || $native : $native;
      var methods2, key2, IteratorPrototype;
      if ($anyNative) {
        IteratorPrototype = getPrototypeOf($anyNative.call(new Base3()));
        if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
          setToStringTag(IteratorPrototype, TAG, true);
          if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != "function") hide(IteratorPrototype, ITERATOR, returnThis);
        }
      }
      if (DEF_VALUES && $native && $native.name !== VALUES) {
        VALUES_BUG = true;
        $default = function values() {
          return $native.call(this);
        };
      }
      if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
        hide(proto, ITERATOR, $default);
      }
      Iterators[NAME] = $default;
      Iterators[TAG] = returnThis;
      if (DEFAULT) {
        methods2 = {
          values: DEF_VALUES ? $default : getMethod(VALUES),
          keys: IS_SET ? $default : getMethod(KEYS),
          entries: $entries
        };
        if (FORCED) for (key2 in methods2) {
          if (!(key2 in proto)) redefine(proto, key2, methods2[key2]);
        }
        else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods2);
      }
      return methods2;
    };
  }
});

// ../../node_modules/core-js/library/modules/es6.string.iterator.js
var require_es6_string_iterator = __commonJS({
  "../../node_modules/core-js/library/modules/es6.string.iterator.js"() {
    "use strict";
    var $at = require_string_at()(true);
    require_iter_define()(String, "String", function(iterated) {
      this._t = String(iterated);
      this._i = 0;
    }, function() {
      var O = this._t;
      var index3 = this._i;
      var point;
      if (index3 >= O.length) return { value: void 0, done: true };
      point = $at(O, index3);
      this._i += point.length;
      return { value: point, done: false };
    });
  }
});

// ../../node_modules/core-js/library/modules/_add-to-unscopables.js
var require_add_to_unscopables = __commonJS({
  "../../node_modules/core-js/library/modules/_add-to-unscopables.js"(exports2, module2) {
    module2.exports = function() {
    };
  }
});

// ../../node_modules/core-js/library/modules/_iter-step.js
var require_iter_step = __commonJS({
  "../../node_modules/core-js/library/modules/_iter-step.js"(exports2, module2) {
    module2.exports = function(done, value) {
      return { value, done: !!done };
    };
  }
});

// ../../node_modules/core-js/library/modules/es6.array.iterator.js
var require_es6_array_iterator = __commonJS({
  "../../node_modules/core-js/library/modules/es6.array.iterator.js"(exports2, module2) {
    "use strict";
    var addToUnscopables = require_add_to_unscopables();
    var step = require_iter_step();
    var Iterators = require_iterators();
    var toIObject = require_to_iobject();
    module2.exports = require_iter_define()(Array, "Array", function(iterated, kind) {
      this._t = toIObject(iterated);
      this._i = 0;
      this._k = kind;
    }, function() {
      var O = this._t;
      var kind = this._k;
      var index3 = this._i++;
      if (!O || index3 >= O.length) {
        this._t = void 0;
        return step(1);
      }
      if (kind == "keys") return step(0, index3);
      if (kind == "values") return step(0, O[index3]);
      return step(0, [index3, O[index3]]);
    }, "values");
    Iterators.Arguments = Iterators.Array;
    addToUnscopables("keys");
    addToUnscopables("values");
    addToUnscopables("entries");
  }
});

// ../../node_modules/core-js/library/modules/web.dom.iterable.js
var require_web_dom_iterable = __commonJS({
  "../../node_modules/core-js/library/modules/web.dom.iterable.js"() {
    require_es6_array_iterator();
    var global2 = require_global();
    var hide = require_hide();
    var Iterators = require_iterators();
    var TO_STRING_TAG = require_wks()("toStringTag");
    var DOMIterables = "CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(",");
    for (i = 0; i < DOMIterables.length; i++) {
      NAME = DOMIterables[i];
      Collection2 = global2[NAME];
      proto = Collection2 && Collection2.prototype;
      if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
      Iterators[NAME] = Iterators.Array;
    }
    var NAME;
    var Collection2;
    var proto;
    var i;
  }
});

// ../../node_modules/core-js/library/modules/_wks-ext.js
var require_wks_ext = __commonJS({
  "../../node_modules/core-js/library/modules/_wks-ext.js"(exports2) {
    exports2.f = require_wks();
  }
});

// ../../node_modules/core-js/library/fn/symbol/iterator.js
var require_iterator = __commonJS({
  "../../node_modules/core-js/library/fn/symbol/iterator.js"(exports2, module2) {
    require_es6_string_iterator();
    require_web_dom_iterable();
    module2.exports = require_wks_ext().f("iterator");
  }
});

// ../../node_modules/babel-runtime/core-js/symbol/iterator.js
var require_iterator2 = __commonJS({
  "../../node_modules/babel-runtime/core-js/symbol/iterator.js"(exports2, module2) {
    module2.exports = { "default": require_iterator(), __esModule: true };
  }
});

// ../../node_modules/core-js/library/modules/_meta.js
var require_meta = __commonJS({
  "../../node_modules/core-js/library/modules/_meta.js"(exports2, module2) {
    var META = require_uid()("meta");
    var isObject7 = require_is_object();
    var has2 = require_has2();
    var setDesc = require_object_dp().f;
    var id = 0;
    var isExtensible = Object.isExtensible || function() {
      return true;
    };
    var FREEZE = !require_fails()(function() {
      return isExtensible(Object.preventExtensions({}));
    });
    var setMeta = function(it) {
      setDesc(it, META, { value: {
        i: "O" + ++id,
        // object ID
        w: {}
        // weak collections IDs
      } });
    };
    var fastKey = function(it, create) {
      if (!isObject7(it)) return typeof it == "symbol" ? it : (typeof it == "string" ? "S" : "P") + it;
      if (!has2(it, META)) {
        if (!isExtensible(it)) return "F";
        if (!create) return "E";
        setMeta(it);
      }
      return it[META].i;
    };
    var getWeak = function(it, create) {
      if (!has2(it, META)) {
        if (!isExtensible(it)) return true;
        if (!create) return false;
        setMeta(it);
      }
      return it[META].w;
    };
    var onFreeze = function(it) {
      if (FREEZE && meta.NEED && isExtensible(it) && !has2(it, META)) setMeta(it);
      return it;
    };
    var meta = module2.exports = {
      KEY: META,
      NEED: false,
      fastKey,
      getWeak,
      onFreeze
    };
  }
});

// ../../node_modules/core-js/library/modules/_wks-define.js
var require_wks_define = __commonJS({
  "../../node_modules/core-js/library/modules/_wks-define.js"(exports2, module2) {
    var global2 = require_global();
    var core = require_core();
    var LIBRARY = require_library();
    var wksExt = require_wks_ext();
    var defineProperty2 = require_object_dp().f;
    module2.exports = function(name) {
      var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global2.Symbol || {});
      if (name.charAt(0) != "_" && !(name in $Symbol)) defineProperty2($Symbol, name, { value: wksExt.f(name) });
    };
  }
});

// ../../node_modules/core-js/library/modules/_enum-keys.js
var require_enum_keys = __commonJS({
  "../../node_modules/core-js/library/modules/_enum-keys.js"(exports2, module2) {
    var getKeys3 = require_object_keys();
    var gOPS = require_object_gops();
    var pIE = require_object_pie();
    module2.exports = function(it) {
      var result = getKeys3(it);
      var getSymbols2 = gOPS.f;
      if (getSymbols2) {
        var symbols = getSymbols2(it);
        var isEnum = pIE.f;
        var i = 0;
        var key2;
        while (symbols.length > i) if (isEnum.call(it, key2 = symbols[i++])) result.push(key2);
      }
      return result;
    };
  }
});

// ../../node_modules/core-js/library/modules/_is-array.js
var require_is_array = __commonJS({
  "../../node_modules/core-js/library/modules/_is-array.js"(exports2, module2) {
    var cof = require_cof();
    module2.exports = Array.isArray || function isArray6(arg) {
      return cof(arg) == "Array";
    };
  }
});

// ../../node_modules/core-js/library/modules/_object-gopn.js
var require_object_gopn = __commonJS({
  "../../node_modules/core-js/library/modules/_object-gopn.js"(exports2) {
    var $keys = require_object_keys_internal();
    var hiddenKeys = require_enum_bug_keys().concat("length", "prototype");
    exports2.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
      return $keys(O, hiddenKeys);
    };
  }
});

// ../../node_modules/core-js/library/modules/_object-gopn-ext.js
var require_object_gopn_ext = __commonJS({
  "../../node_modules/core-js/library/modules/_object-gopn-ext.js"(exports2, module2) {
    var toIObject = require_to_iobject();
    var gOPN = require_object_gopn().f;
    var toString3 = {}.toString;
    var windowNames = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
    var getWindowNames = function(it) {
      try {
        return gOPN(it);
      } catch (e3) {
        return windowNames.slice();
      }
    };
    module2.exports.f = function getOwnPropertyNames(it) {
      return windowNames && toString3.call(it) == "[object Window]" ? getWindowNames(it) : gOPN(toIObject(it));
    };
  }
});

// ../../node_modules/core-js/library/modules/_object-gopd.js
var require_object_gopd = __commonJS({
  "../../node_modules/core-js/library/modules/_object-gopd.js"(exports2) {
    var pIE = require_object_pie();
    var createDesc = require_property_desc();
    var toIObject = require_to_iobject();
    var toPrimitive2 = require_to_primitive();
    var has2 = require_has2();
    var IE8_DOM_DEFINE = require_ie8_dom_define();
    var gOPD = Object.getOwnPropertyDescriptor;
    exports2.f = require_descriptors() ? gOPD : function getOwnPropertyDescriptor(O, P) {
      O = toIObject(O);
      P = toPrimitive2(P, true);
      if (IE8_DOM_DEFINE) try {
        return gOPD(O, P);
      } catch (e3) {
      }
      if (has2(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
    };
  }
});

// ../../node_modules/core-js/library/modules/es6.symbol.js
var require_es6_symbol = __commonJS({
  "../../node_modules/core-js/library/modules/es6.symbol.js"() {
    "use strict";
    var global2 = require_global();
    var has2 = require_has2();
    var DESCRIPTORS = require_descriptors();
    var $export = require_export();
    var redefine = require_redefine();
    var META = require_meta().KEY;
    var $fails = require_fails();
    var shared = require_shared();
    var setToStringTag = require_set_to_string_tag();
    var uid3 = require_uid();
    var wks = require_wks();
    var wksExt = require_wks_ext();
    var wksDefine = require_wks_define();
    var enumKeys = require_enum_keys();
    var isArray6 = require_is_array();
    var anObject = require_an_object();
    var isObject7 = require_is_object();
    var toObject = require_to_object();
    var toIObject = require_to_iobject();
    var toPrimitive2 = require_to_primitive();
    var createDesc = require_property_desc();
    var _create = require_object_create();
    var gOPNExt = require_object_gopn_ext();
    var $GOPD = require_object_gopd();
    var $GOPS = require_object_gops();
    var $DP = require_object_dp();
    var $keys = require_object_keys();
    var gOPD = $GOPD.f;
    var dP = $DP.f;
    var gOPN = gOPNExt.f;
    var $Symbol = global2.Symbol;
    var $JSON = global2.JSON;
    var _stringify = $JSON && $JSON.stringify;
    var PROTOTYPE = "prototype";
    var HIDDEN = wks("_hidden");
    var TO_PRIMITIVE = wks("toPrimitive");
    var isEnum = {}.propertyIsEnumerable;
    var SymbolRegistry = shared("symbol-registry");
    var AllSymbols = shared("symbols");
    var OPSymbols = shared("op-symbols");
    var ObjectProto = Object[PROTOTYPE];
    var USE_NATIVE = typeof $Symbol == "function" && !!$GOPS.f;
    var QObject = global2.QObject;
    var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
    var setSymbolDesc = DESCRIPTORS && $fails(function() {
      return _create(dP({}, "a", {
        get: function() {
          return dP(this, "a", { value: 7 }).a;
        }
      })).a != 7;
    }) ? function(it, key2, D) {
      var protoDesc = gOPD(ObjectProto, key2);
      if (protoDesc) delete ObjectProto[key2];
      dP(it, key2, D);
      if (protoDesc && it !== ObjectProto) dP(ObjectProto, key2, protoDesc);
    } : dP;
    var wrap = function(tag) {
      var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
      sym._k = tag;
      return sym;
    };
    var isSymbol2 = USE_NATIVE && typeof $Symbol.iterator == "symbol" ? function(it) {
      return typeof it == "symbol";
    } : function(it) {
      return it instanceof $Symbol;
    };
    var $defineProperty = function defineProperty2(it, key2, D) {
      if (it === ObjectProto) $defineProperty(OPSymbols, key2, D);
      anObject(it);
      key2 = toPrimitive2(key2, true);
      anObject(D);
      if (has2(AllSymbols, key2)) {
        if (!D.enumerable) {
          if (!has2(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
          it[HIDDEN][key2] = true;
        } else {
          if (has2(it, HIDDEN) && it[HIDDEN][key2]) it[HIDDEN][key2] = false;
          D = _create(D, { enumerable: createDesc(0, false) });
        }
        return setSymbolDesc(it, key2, D);
      }
      return dP(it, key2, D);
    };
    var $defineProperties = function defineProperties(it, P) {
      anObject(it);
      var keys4 = enumKeys(P = toIObject(P));
      var i = 0;
      var l2 = keys4.length;
      var key2;
      while (l2 > i) $defineProperty(it, key2 = keys4[i++], P[key2]);
      return it;
    };
    var $create = function create(it, P) {
      return P === void 0 ? _create(it) : $defineProperties(_create(it), P);
    };
    var $propertyIsEnumerable = function propertyIsEnumerable3(key2) {
      var E = isEnum.call(this, key2 = toPrimitive2(key2, true));
      if (this === ObjectProto && has2(AllSymbols, key2) && !has2(OPSymbols, key2)) return false;
      return E || !has2(this, key2) || !has2(AllSymbols, key2) || has2(this, HIDDEN) && this[HIDDEN][key2] ? E : true;
    };
    var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key2) {
      it = toIObject(it);
      key2 = toPrimitive2(key2, true);
      if (it === ObjectProto && has2(AllSymbols, key2) && !has2(OPSymbols, key2)) return;
      var D = gOPD(it, key2);
      if (D && has2(AllSymbols, key2) && !(has2(it, HIDDEN) && it[HIDDEN][key2])) D.enumerable = true;
      return D;
    };
    var $getOwnPropertyNames = function getOwnPropertyNames(it) {
      var names2 = gOPN(toIObject(it));
      var result = [];
      var i = 0;
      var key2;
      while (names2.length > i) {
        if (!has2(AllSymbols, key2 = names2[i++]) && key2 != HIDDEN && key2 != META) result.push(key2);
      }
      return result;
    };
    var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
      var IS_OP = it === ObjectProto;
      var names2 = gOPN(IS_OP ? OPSymbols : toIObject(it));
      var result = [];
      var i = 0;
      var key2;
      while (names2.length > i) {
        if (has2(AllSymbols, key2 = names2[i++]) && (IS_OP ? has2(ObjectProto, key2) : true)) result.push(AllSymbols[key2]);
      }
      return result;
    };
    if (!USE_NATIVE) {
      $Symbol = function Symbol3() {
        if (this instanceof $Symbol) throw TypeError("Symbol is not a constructor!");
        var tag = uid3(arguments.length > 0 ? arguments[0] : void 0);
        var $set = function(value) {
          if (this === ObjectProto) $set.call(OPSymbols, value);
          if (has2(this, HIDDEN) && has2(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
          setSymbolDesc(this, tag, createDesc(1, value));
        };
        if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
        return wrap(tag);
      };
      redefine($Symbol[PROTOTYPE], "toString", function toString3() {
        return this._k;
      });
      $GOPD.f = $getOwnPropertyDescriptor;
      $DP.f = $defineProperty;
      require_object_gopn().f = gOPNExt.f = $getOwnPropertyNames;
      require_object_pie().f = $propertyIsEnumerable;
      $GOPS.f = $getOwnPropertySymbols;
      if (DESCRIPTORS && !require_library()) {
        redefine(ObjectProto, "propertyIsEnumerable", $propertyIsEnumerable, true);
      }
      wksExt.f = function(name) {
        return wrap(wks(name));
      };
    }
    $export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
    for (es6Symbols = // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
    "hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","), j = 0; es6Symbols.length > j; ) wks(es6Symbols[j++]);
    var es6Symbols;
    var j;
    for (wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k; ) wksDefine(wellKnownSymbols[k++]);
    var wellKnownSymbols;
    var k;
    $export($export.S + $export.F * !USE_NATIVE, "Symbol", {
      // 19.4.2.1 Symbol.for(key)
      "for": function(key2) {
        return has2(SymbolRegistry, key2 += "") ? SymbolRegistry[key2] : SymbolRegistry[key2] = $Symbol(key2);
      },
      // 19.4.2.5 Symbol.keyFor(sym)
      keyFor: function keyFor(sym) {
        if (!isSymbol2(sym)) throw TypeError(sym + " is not a symbol!");
        for (var key2 in SymbolRegistry) if (SymbolRegistry[key2] === sym) return key2;
      },
      useSetter: function() {
        setter = true;
      },
      useSimple: function() {
        setter = false;
      }
    });
    $export($export.S + $export.F * !USE_NATIVE, "Object", {
      // 19.1.2.2 Object.create(O [, Properties])
      create: $create,
      // 19.1.2.4 Object.defineProperty(O, P, Attributes)
      defineProperty: $defineProperty,
      // 19.1.2.3 Object.defineProperties(O, Properties)
      defineProperties: $defineProperties,
      // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
      getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
      // 19.1.2.7 Object.getOwnPropertyNames(O)
      getOwnPropertyNames: $getOwnPropertyNames,
      // 19.1.2.8 Object.getOwnPropertySymbols(O)
      getOwnPropertySymbols: $getOwnPropertySymbols
    });
    var FAILS_ON_PRIMITIVES = $fails(function() {
      $GOPS.f(1);
    });
    $export($export.S + $export.F * FAILS_ON_PRIMITIVES, "Object", {
      getOwnPropertySymbols: function getOwnPropertySymbols(it) {
        return $GOPS.f(toObject(it));
      }
    });
    $JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function() {
      var S = $Symbol();
      return _stringify([S]) != "[null]" || _stringify({ a: S }) != "{}" || _stringify(Object(S)) != "{}";
    })), "JSON", {
      stringify: function stringify4(it) {
        var args = [it];
        var i = 1;
        var replacer, $replacer;
        while (arguments.length > i) args.push(arguments[i++]);
        $replacer = replacer = args[1];
        if (!isObject7(replacer) && it === void 0 || isSymbol2(it)) return;
        if (!isArray6(replacer)) replacer = function(key2, value) {
          if (typeof $replacer == "function") value = $replacer.call(this, key2, value);
          if (!isSymbol2(value)) return value;
        };
        args[1] = replacer;
        return _stringify.apply($JSON, args);
      }
    });
    $Symbol[PROTOTYPE][TO_PRIMITIVE] || require_hide()($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
    setToStringTag($Symbol, "Symbol");
    setToStringTag(Math, "Math", true);
    setToStringTag(global2.JSON, "JSON", true);
  }
});

// ../../node_modules/core-js/library/modules/es6.object.to-string.js
var require_es6_object_to_string = __commonJS({
  "../../node_modules/core-js/library/modules/es6.object.to-string.js"() {
  }
});

// ../../node_modules/core-js/library/modules/es7.symbol.async-iterator.js
var require_es7_symbol_async_iterator = __commonJS({
  "../../node_modules/core-js/library/modules/es7.symbol.async-iterator.js"() {
    require_wks_define()("asyncIterator");
  }
});

// ../../node_modules/core-js/library/modules/es7.symbol.observable.js
var require_es7_symbol_observable = __commonJS({
  "../../node_modules/core-js/library/modules/es7.symbol.observable.js"() {
    require_wks_define()("observable");
  }
});

// ../../node_modules/core-js/library/fn/symbol/index.js
var require_symbol = __commonJS({
  "../../node_modules/core-js/library/fn/symbol/index.js"(exports2, module2) {
    require_es6_symbol();
    require_es6_object_to_string();
    require_es7_symbol_async_iterator();
    require_es7_symbol_observable();
    module2.exports = require_core().Symbol;
  }
});

// ../../node_modules/babel-runtime/core-js/symbol.js
var require_symbol2 = __commonJS({
  "../../node_modules/babel-runtime/core-js/symbol.js"(exports2, module2) {
    module2.exports = { "default": require_symbol(), __esModule: true };
  }
});

// ../../node_modules/babel-runtime/helpers/typeof.js
var require_typeof2 = __commonJS({
  "../../node_modules/babel-runtime/helpers/typeof.js"(exports2) {
    "use strict";
    exports2.__esModule = true;
    var _iterator = require_iterator2();
    var _iterator2 = _interopRequireDefault(_iterator);
    var _symbol = require_symbol2();
    var _symbol2 = _interopRequireDefault(_symbol);
    var _typeof16 = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function(obj) {
      return typeof obj;
    } : function(obj) {
      return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj;
    };
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { default: obj };
    }
    exports2.default = typeof _symbol2.default === "function" && _typeof16(_iterator2.default) === "symbol" ? function(obj) {
      return typeof obj === "undefined" ? "undefined" : _typeof16(obj);
    } : function(obj) {
      return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof16(obj);
    };
  }
});

// ../../node_modules/babel-runtime/helpers/possibleConstructorReturn.js
var require_possibleConstructorReturn = __commonJS({
  "../../node_modules/babel-runtime/helpers/possibleConstructorReturn.js"(exports2) {
    "use strict";
    exports2.__esModule = true;
    var _typeof22 = require_typeof2();
    var _typeof32 = _interopRequireDefault(_typeof22);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { default: obj };
    }
    exports2.default = function(self2, call2) {
      if (!self2) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }
      return call2 && ((typeof call2 === "undefined" ? "undefined" : (0, _typeof32.default)(call2)) === "object" || typeof call2 === "function") ? call2 : self2;
    };
  }
});

// ../../node_modules/core-js/library/modules/_set-proto.js
var require_set_proto = __commonJS({
  "../../node_modules/core-js/library/modules/_set-proto.js"(exports2, module2) {
    var isObject7 = require_is_object();
    var anObject = require_an_object();
    var check = function(O, proto) {
      anObject(O);
      if (!isObject7(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
    };
    module2.exports = {
      set: Object.setPrototypeOf || ("__proto__" in {} ? (
        // eslint-disable-line
        (function(test, buggy, set4) {
          try {
            set4 = require_ctx()(Function.call, require_object_gopd().f(Object.prototype, "__proto__").set, 2);
            set4(test, []);
            buggy = !(test instanceof Array);
          } catch (e3) {
            buggy = true;
          }
          return function setPrototypeOf(O, proto) {
            check(O, proto);
            if (buggy) O.__proto__ = proto;
            else set4(O, proto);
            return O;
          };
        })({}, false)
      ) : void 0),
      check
    };
  }
});

// ../../node_modules/core-js/library/modules/es6.object.set-prototype-of.js
var require_es6_object_set_prototype_of = __commonJS({
  "../../node_modules/core-js/library/modules/es6.object.set-prototype-of.js"() {
    var $export = require_export();
    $export($export.S, "Object", { setPrototypeOf: require_set_proto().set });
  }
});

// ../../node_modules/core-js/library/fn/object/set-prototype-of.js
var require_set_prototype_of = __commonJS({
  "../../node_modules/core-js/library/fn/object/set-prototype-of.js"(exports2, module2) {
    require_es6_object_set_prototype_of();
    module2.exports = require_core().Object.setPrototypeOf;
  }
});

// ../../node_modules/babel-runtime/core-js/object/set-prototype-of.js
var require_set_prototype_of2 = __commonJS({
  "../../node_modules/babel-runtime/core-js/object/set-prototype-of.js"(exports2, module2) {
    module2.exports = { "default": require_set_prototype_of(), __esModule: true };
  }
});

// ../../node_modules/core-js/library/modules/es6.object.create.js
var require_es6_object_create = __commonJS({
  "../../node_modules/core-js/library/modules/es6.object.create.js"() {
    var $export = require_export();
    $export($export.S, "Object", { create: require_object_create() });
  }
});

// ../../node_modules/core-js/library/fn/object/create.js
var require_create = __commonJS({
  "../../node_modules/core-js/library/fn/object/create.js"(exports2, module2) {
    require_es6_object_create();
    var $Object = require_core().Object;
    module2.exports = function create(P, D) {
      return $Object.create(P, D);
    };
  }
});

// ../../node_modules/babel-runtime/core-js/object/create.js
var require_create2 = __commonJS({
  "../../node_modules/babel-runtime/core-js/object/create.js"(exports2, module2) {
    module2.exports = { "default": require_create(), __esModule: true };
  }
});

// ../../node_modules/babel-runtime/helpers/inherits.js
var require_inherits = __commonJS({
  "../../node_modules/babel-runtime/helpers/inherits.js"(exports2) {
    "use strict";
    exports2.__esModule = true;
    var _setPrototypeOf2 = require_set_prototype_of2();
    var _setPrototypeOf22 = _interopRequireDefault(_setPrototypeOf2);
    var _create = require_create2();
    var _create2 = _interopRequireDefault(_create);
    var _typeof22 = require_typeof2();
    var _typeof32 = _interopRequireDefault(_typeof22);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { default: obj };
    }
    exports2.default = function(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof32.default)(superClass)));
      }
      subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      if (superClass) _setPrototypeOf22.default ? (0, _setPrototypeOf22.default)(subClass, superClass) : subClass.__proto__ = superClass;
    };
  }
});

// ../../node_modules/dom-align/dist-node/index.js
var require_dist_node = __commonJS({
  "../../node_modules/dom-align/dist-node/index.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    var vendorPrefix;
    var jsCssMap = {
      Webkit: "-webkit-",
      Moz: "-moz-",
      // IE did it wrong again ...
      ms: "-ms-",
      O: "-o-"
    };
    function getVendorPrefix() {
      if (vendorPrefix !== void 0) {
        return vendorPrefix;
      }
      vendorPrefix = "";
      var style2 = document.createElement("p").style;
      var testProp = "Transform";
      for (var key2 in jsCssMap) {
        if (key2 + testProp in style2) {
          vendorPrefix = key2;
        }
      }
      return vendorPrefix;
    }
    function getTransitionName3() {
      return getVendorPrefix() ? "".concat(getVendorPrefix(), "TransitionProperty") : "transitionProperty";
    }
    function getTransformName() {
      return getVendorPrefix() ? "".concat(getVendorPrefix(), "Transform") : "transform";
    }
    function setTransitionProperty(node2, value) {
      var name = getTransitionName3();
      if (name) {
        node2.style[name] = value;
        if (name !== "transitionProperty") {
          node2.style.transitionProperty = value;
        }
      }
    }
    function setTransform(node2, value) {
      var name = getTransformName();
      if (name) {
        node2.style[name] = value;
        if (name !== "transform") {
          node2.style.transform = value;
        }
      }
    }
    function getTransitionProperty(node2) {
      return node2.style.transitionProperty || node2.style[getTransitionName3()];
    }
    function getTransformXY(node2) {
      var style2 = window.getComputedStyle(node2, null);
      var transform = style2.getPropertyValue("transform") || style2.getPropertyValue(getTransformName());
      if (transform && transform !== "none") {
        var matrix = transform.replace(/[^0-9\-.,]/g, "").split(",");
        return {
          x: parseFloat(matrix[12] || matrix[4], 0),
          y: parseFloat(matrix[13] || matrix[5], 0)
        };
      }
      return {
        x: 0,
        y: 0
      };
    }
    var matrix2d = /matrix\((.*)\)/;
    var matrix3d2 = /matrix3d\((.*)\)/;
    function setTransformXY(node2, xy) {
      var style2 = window.getComputedStyle(node2, null);
      var transform = style2.getPropertyValue("transform") || style2.getPropertyValue(getTransformName());
      if (transform && transform !== "none") {
        var arr;
        var match2d = transform.match(matrix2d);
        if (match2d) {
          match2d = match2d[1];
          arr = match2d.split(",").map(function(item) {
            return parseFloat(item, 10);
          });
          arr[4] = xy.x;
          arr[5] = xy.y;
          setTransform(node2, "matrix(".concat(arr.join(","), ")"));
        } else {
          var match3d = transform.match(matrix3d2)[1];
          arr = match3d.split(",").map(function(item) {
            return parseFloat(item, 10);
          });
          arr[12] = xy.x;
          arr[13] = xy.y;
          setTransform(node2, "matrix3d(".concat(arr.join(","), ")"));
        }
      } else {
        setTransform(node2, "translateX(".concat(xy.x, "px) translateY(").concat(xy.y, "px) translateZ(0)"));
      }
    }
    function _typeof16(obj) {
      "@babel/helpers - typeof";
      return _typeof16 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj2) {
        return typeof obj2;
      } : function(obj2) {
        return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
      }, _typeof16(obj);
    }
    var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;
    var getComputedStyleX;
    function forceRelayout(elem) {
      var originalStyle = elem.style.display;
      elem.style.display = "none";
      elem.offsetHeight;
      elem.style.display = originalStyle;
    }
    function css2(el, name, v) {
      var value = v;
      if (_typeof16(name) === "object") {
        for (var i in name) {
          if (name.hasOwnProperty(i)) {
            css2(el, i, name[i]);
          }
        }
        return void 0;
      }
      if (typeof value !== "undefined") {
        if (typeof value === "number") {
          value = "".concat(value, "px");
        }
        el.style[name] = value;
        return void 0;
      }
      return getComputedStyleX(el, name);
    }
    function getClientPosition2(elem) {
      var box2;
      var x;
      var y;
      var doc2 = elem.ownerDocument;
      var body = doc2.body;
      var docElem = doc2 && doc2.documentElement;
      box2 = elem.getBoundingClientRect();
      x = Math.floor(box2.left);
      y = Math.floor(box2.top);
      x -= docElem.clientLeft || body.clientLeft || 0;
      y -= docElem.clientTop || body.clientTop || 0;
      return {
        left: x,
        top: y
      };
    }
    function getScroll4(w, top) {
      var ret = w["page".concat(top ? "Y" : "X", "Offset")];
      var method4 = "scroll".concat(top ? "Top" : "Left");
      if (typeof ret !== "number") {
        var d = w.document;
        ret = d.documentElement[method4];
        if (typeof ret !== "number") {
          ret = d.body[method4];
        }
      }
      return ret;
    }
    function getScrollLeft(w) {
      return getScroll4(w);
    }
    function getScrollTop(w) {
      return getScroll4(w, true);
    }
    function getOffset5(el) {
      var pos = getClientPosition2(el);
      var doc2 = el.ownerDocument;
      var w = doc2.defaultView || doc2.parentWindow;
      pos.left += getScrollLeft(w);
      pos.top += getScrollTop(w);
      return pos;
    }
    function isWindow4(obj) {
      return obj !== null && obj !== void 0 && obj == obj.window;
    }
    function getDocument4(node2) {
      if (isWindow4(node2)) {
        return node2.document;
      }
      if (node2.nodeType === 9) {
        return node2;
      }
      return node2.ownerDocument;
    }
    function _getComputedStyle(elem, name, cs) {
      var computedStyle = cs;
      var val = "";
      var d = getDocument4(elem);
      computedStyle = computedStyle || d.defaultView.getComputedStyle(elem, null);
      if (computedStyle) {
        val = computedStyle.getPropertyValue(name) || computedStyle[name];
      }
      return val;
    }
    var _RE_NUM_NO_PX = new RegExp("^(".concat(RE_NUM, ")(?!px)[a-z%]+$"), "i");
    var RE_POS = /^(top|right|bottom|left)$/;
    var CURRENT_STYLE = "currentStyle";
    var RUNTIME_STYLE = "runtimeStyle";
    var LEFT2 = "left";
    var PX = "px";
    function _getComputedStyleIE(elem, name) {
      var ret = elem[CURRENT_STYLE] && elem[CURRENT_STYLE][name];
      if (_RE_NUM_NO_PX.test(ret) && !RE_POS.test(name)) {
        var style2 = elem.style;
        var left2 = style2[LEFT2];
        var rsLeft = elem[RUNTIME_STYLE][LEFT2];
        elem[RUNTIME_STYLE][LEFT2] = elem[CURRENT_STYLE][LEFT2];
        style2[LEFT2] = name === "fontSize" ? "1em" : ret || 0;
        ret = style2.pixelLeft + PX;
        style2[LEFT2] = left2;
        elem[RUNTIME_STYLE][LEFT2] = rsLeft;
      }
      return ret === "" ? "auto" : ret;
    }
    if (typeof window !== "undefined") {
      getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE;
    }
    function getOffsetDirection(dir, option) {
      if (dir === "left") {
        return option.useCssRight ? "right" : dir;
      }
      return option.useCssBottom ? "bottom" : dir;
    }
    function oppositeOffsetDirection(dir) {
      if (dir === "left") {
        return "right";
      } else if (dir === "right") {
        return "left";
      } else if (dir === "top") {
        return "bottom";
      } else if (dir === "bottom") {
        return "top";
      }
    }
    function setLeftTop(elem, offset4, option) {
      if (css2(elem, "position") === "static") {
        elem.style.position = "relative";
      }
      var presetH = -999;
      var presetV = -999;
      var horizontalProperty = getOffsetDirection("left", option);
      var verticalProperty = getOffsetDirection("top", option);
      var oppositeHorizontalProperty = oppositeOffsetDirection(horizontalProperty);
      var oppositeVerticalProperty = oppositeOffsetDirection(verticalProperty);
      if (horizontalProperty !== "left") {
        presetH = 999;
      }
      if (verticalProperty !== "top") {
        presetV = 999;
      }
      var originalTransition = "";
      var originalOffset = getOffset5(elem);
      if ("left" in offset4 || "top" in offset4) {
        originalTransition = getTransitionProperty(elem) || "";
        setTransitionProperty(elem, "none");
      }
      if ("left" in offset4) {
        elem.style[oppositeHorizontalProperty] = "";
        elem.style[horizontalProperty] = "".concat(presetH, "px");
      }
      if ("top" in offset4) {
        elem.style[oppositeVerticalProperty] = "";
        elem.style[verticalProperty] = "".concat(presetV, "px");
      }
      forceRelayout(elem);
      var old = getOffset5(elem);
      var originalStyle = {};
      for (var key2 in offset4) {
        if (offset4.hasOwnProperty(key2)) {
          var dir = getOffsetDirection(key2, option);
          var preset = key2 === "left" ? presetH : presetV;
          var off = originalOffset[key2] - old[key2];
          if (dir === key2) {
            originalStyle[dir] = preset + off;
          } else {
            originalStyle[dir] = preset - off;
          }
        }
      }
      css2(elem, originalStyle);
      forceRelayout(elem);
      if ("left" in offset4 || "top" in offset4) {
        setTransitionProperty(elem, originalTransition);
      }
      var ret = {};
      for (var _key in offset4) {
        if (offset4.hasOwnProperty(_key)) {
          var _dir = getOffsetDirection(_key, option);
          var _off = offset4[_key] - originalOffset[_key];
          if (_key === _dir) {
            ret[_dir] = originalStyle[_dir] + _off;
          } else {
            ret[_dir] = originalStyle[_dir] - _off;
          }
        }
      }
      css2(elem, ret);
    }
    function setTransform$1(elem, offset4) {
      var originalOffset = getOffset5(elem);
      var originalXY = getTransformXY(elem);
      var resultXY = {
        x: originalXY.x,
        y: originalXY.y
      };
      if ("left" in offset4) {
        resultXY.x = originalXY.x + offset4.left - originalOffset.left;
      }
      if ("top" in offset4) {
        resultXY.y = originalXY.y + offset4.top - originalOffset.top;
      }
      setTransformXY(elem, resultXY);
    }
    function setOffset(elem, offset4, option) {
      if (option.ignoreShake) {
        var oriOffset = getOffset5(elem);
        var oLeft = oriOffset.left.toFixed(0);
        var oTop = oriOffset.top.toFixed(0);
        var tLeft = offset4.left.toFixed(0);
        var tTop = offset4.top.toFixed(0);
        if (oLeft === tLeft && oTop === tTop) {
          return;
        }
      }
      if (option.useCssRight || option.useCssBottom) {
        setLeftTop(elem, offset4, option);
      } else if (option.useCssTransform && getTransformName() in document.body.style) {
        setTransform$1(elem, offset4);
      } else {
        setLeftTop(elem, offset4, option);
      }
    }
    function each(arr, fn) {
      for (var i = 0; i < arr.length; i++) {
        fn(arr[i]);
      }
    }
    function isBorderBoxFn(elem) {
      return getComputedStyleX(elem, "boxSizing") === "border-box";
    }
    var BOX_MODELS = ["margin", "border", "padding"];
    var CONTENT_INDEX = -1;
    var PADDING_INDEX = 2;
    var BORDER_INDEX = 1;
    var MARGIN_INDEX = 0;
    function swap2(elem, options, callback) {
      var old = {};
      var style2 = elem.style;
      var name;
      for (name in options) {
        if (options.hasOwnProperty(name)) {
          old[name] = style2[name];
          style2[name] = options[name];
        }
      }
      callback.call(elem);
      for (name in options) {
        if (options.hasOwnProperty(name)) {
          style2[name] = old[name];
        }
      }
    }
    function getPBMWidth(elem, props, which) {
      var value = 0;
      var prop;
      var j;
      var i;
      for (j = 0; j < props.length; j++) {
        prop = props[j];
        if (prop) {
          for (i = 0; i < which.length; i++) {
            var cssProp = void 0;
            if (prop === "border") {
              cssProp = "".concat(prop).concat(which[i], "Width");
            } else {
              cssProp = prop + which[i];
            }
            value += parseFloat(getComputedStyleX(elem, cssProp)) || 0;
          }
        }
      }
      return value;
    }
    var domUtils = {
      getParent: function getParent2(element) {
        var parent2 = element;
        do {
          if (parent2.nodeType === 11 && parent2.host) {
            parent2 = parent2.host;
          } else {
            parent2 = parent2.parentNode;
          }
        } while (parent2 && parent2.nodeType !== 1 && parent2.nodeType !== 9);
        return parent2;
      }
    };
    each(["Width", "Height"], function(name) {
      domUtils["doc".concat(name)] = function(refWin) {
        var d = refWin.document;
        return Math.max(
          // firefox chrome documentElement.scrollHeight< body.scrollHeight
          // ie standard mode : documentElement.scrollHeight> body.scrollHeight
          d.documentElement["scroll".concat(name)],
          // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
          d.body["scroll".concat(name)],
          domUtils["viewport".concat(name)](d)
        );
      };
      domUtils["viewport".concat(name)] = function(win) {
        var prop = "client".concat(name);
        var doc2 = win.document;
        var body = doc2.body;
        var documentElement = doc2.documentElement;
        var documentElementProp = documentElement[prop];
        return doc2.compatMode === "CSS1Compat" && documentElementProp || body && body[prop] || documentElementProp;
      };
    });
    function getWH(elem, name, ex) {
      var extra = ex;
      if (isWindow4(elem)) {
        return name === "width" ? domUtils.viewportWidth(elem) : domUtils.viewportHeight(elem);
      } else if (elem.nodeType === 9) {
        return name === "width" ? domUtils.docWidth(elem) : domUtils.docHeight(elem);
      }
      var which = name === "width" ? ["Left", "Right"] : ["Top", "Bottom"];
      var borderBoxValue = name === "width" ? Math.floor(elem.getBoundingClientRect().width) : Math.floor(elem.getBoundingClientRect().height);
      var isBorderBox = isBorderBoxFn(elem);
      var cssBoxValue = 0;
      if (borderBoxValue === null || borderBoxValue === void 0 || borderBoxValue <= 0) {
        borderBoxValue = void 0;
        cssBoxValue = getComputedStyleX(elem, name);
        if (cssBoxValue === null || cssBoxValue === void 0 || Number(cssBoxValue) < 0) {
          cssBoxValue = elem.style[name] || 0;
        }
        cssBoxValue = Math.floor(parseFloat(cssBoxValue)) || 0;
      }
      if (extra === void 0) {
        extra = isBorderBox ? BORDER_INDEX : CONTENT_INDEX;
      }
      var borderBoxValueOrIsBorderBox = borderBoxValue !== void 0 || isBorderBox;
      var val = borderBoxValue || cssBoxValue;
      if (extra === CONTENT_INDEX) {
        if (borderBoxValueOrIsBorderBox) {
          return val - getPBMWidth(elem, ["border", "padding"], which);
        }
        return cssBoxValue;
      } else if (borderBoxValueOrIsBorderBox) {
        if (extra === BORDER_INDEX) {
          return val;
        }
        return val + (extra === PADDING_INDEX ? -getPBMWidth(elem, ["border"], which) : getPBMWidth(elem, ["margin"], which));
      }
      return cssBoxValue + getPBMWidth(elem, BOX_MODELS.slice(extra), which);
    }
    var cssShow = {
      position: "absolute",
      visibility: "hidden",
      display: "block"
    };
    function getWHIgnoreDisplay() {
      for (var _len = arguments.length, args = new Array(_len), _key2 = 0; _key2 < _len; _key2++) {
        args[_key2] = arguments[_key2];
      }
      var val;
      var elem = args[0];
      if (elem.offsetWidth !== 0) {
        val = getWH.apply(void 0, args);
      } else {
        swap2(elem, cssShow, function() {
          val = getWH.apply(void 0, args);
        });
      }
      return val;
    }
    each(["width", "height"], function(name) {
      var first = name.charAt(0).toUpperCase() + name.slice(1);
      domUtils["outer".concat(first)] = function(el, includeMargin) {
        return el && getWHIgnoreDisplay(el, name, includeMargin ? MARGIN_INDEX : BORDER_INDEX);
      };
      var which = name === "width" ? ["Left", "Right"] : ["Top", "Bottom"];
      domUtils[name] = function(elem, v) {
        var val = v;
        if (val !== void 0) {
          if (elem) {
            var isBorderBox = isBorderBoxFn(elem);
            if (isBorderBox) {
              val += getPBMWidth(elem, ["padding", "border"], which);
            }
            return css2(elem, name, val);
          }
          return void 0;
        }
        return elem && getWHIgnoreDisplay(elem, name, CONTENT_INDEX);
      };
    });
    function mix(to, from2) {
      for (var i in from2) {
        if (from2.hasOwnProperty(i)) {
          to[i] = from2[i];
        }
      }
      return to;
    }
    var utils = {
      getWindow: function getWindow3(node2) {
        if (node2 && node2.document && node2.setTimeout) {
          return node2;
        }
        var doc2 = node2.ownerDocument || node2;
        return doc2.defaultView || doc2.parentWindow;
      },
      getDocument: getDocument4,
      offset: function offset4(el, value, option) {
        if (typeof value !== "undefined") {
          setOffset(el, value, option || {});
        } else {
          return getOffset5(el);
        }
      },
      isWindow: isWindow4,
      each,
      css: css2,
      clone: function clone(obj) {
        var i;
        var ret = {};
        for (i in obj) {
          if (obj.hasOwnProperty(i)) {
            ret[i] = obj[i];
          }
        }
        var overflow = obj.overflow;
        if (overflow) {
          for (i in obj) {
            if (obj.hasOwnProperty(i)) {
              ret.overflow[i] = obj.overflow[i];
            }
          }
        }
        return ret;
      },
      mix,
      getWindowScrollLeft: function getWindowScrollLeft(w) {
        return getScrollLeft(w);
      },
      getWindowScrollTop: function getWindowScrollTop(w) {
        return getScrollTop(w);
      },
      merge: function merge3() {
        var ret = {};
        for (var i = 0; i < arguments.length; i++) {
          utils.mix(ret, i < 0 || arguments.length <= i ? void 0 : arguments[i]);
        }
        return ret;
      },
      viewportWidth: 0,
      viewportHeight: 0
    };
    mix(utils, domUtils);
    var getParent = utils.getParent;
    function getOffsetParent(element) {
      if (utils.isWindow(element) || element.nodeType === 9) {
        return null;
      }
      var doc2 = utils.getDocument(element);
      var body = doc2.body;
      var parent2;
      var positionStyle = utils.css(element, "position");
      var skipStatic = positionStyle === "fixed" || positionStyle === "absolute";
      if (!skipStatic) {
        return element.nodeName.toLowerCase() === "html" ? null : getParent(element);
      }
      for (parent2 = getParent(element); parent2 && parent2 !== body && parent2.nodeType !== 9; parent2 = getParent(parent2)) {
        positionStyle = utils.css(parent2, "position");
        if (positionStyle !== "static") {
          return parent2;
        }
      }
      return null;
    }
    var getParent$1 = utils.getParent;
    function isAncestorFixed(element) {
      if (utils.isWindow(element) || element.nodeType === 9) {
        return false;
      }
      var doc2 = utils.getDocument(element);
      var body = doc2.body;
      var parent2 = null;
      for (
        parent2 = getParent$1(element);
        // 修复元素位于 document.documentElement 下导致崩溃问题
        parent2 && parent2 !== body && parent2 !== doc2;
        parent2 = getParent$1(parent2)
      ) {
        var positionStyle = utils.css(parent2, "position");
        if (positionStyle === "fixed") {
          return true;
        }
      }
      return false;
    }
    function getVisibleRectForElement(element, alwaysByViewport) {
      var visibleRect = {
        left: 0,
        right: Infinity,
        top: 0,
        bottom: Infinity
      };
      var el = getOffsetParent(element);
      var doc2 = utils.getDocument(element);
      var win = doc2.defaultView || doc2.parentWindow;
      var body = doc2.body;
      var documentElement = doc2.documentElement;
      while (el) {
        if ((navigator.userAgent.indexOf("MSIE") === -1 || el.clientWidth !== 0) && // body may have overflow set on it, yet we still get the entire
        // viewport. In some browsers, el.offsetParent may be
        // document.documentElement, so check for that too.
        el !== body && el !== documentElement && utils.css(el, "overflow") !== "visible") {
          var pos = utils.offset(el);
          pos.left += el.clientLeft;
          pos.top += el.clientTop;
          visibleRect.top = Math.max(visibleRect.top, pos.top);
          visibleRect.right = Math.min(
            visibleRect.right,
            // consider area without scrollBar
            pos.left + el.clientWidth
          );
          visibleRect.bottom = Math.min(visibleRect.bottom, pos.top + el.clientHeight);
          visibleRect.left = Math.max(visibleRect.left, pos.left);
        } else if (el === body || el === documentElement) {
          break;
        }
        el = getOffsetParent(el);
      }
      var originalPosition = null;
      if (!utils.isWindow(element) && element.nodeType !== 9) {
        originalPosition = element.style.position;
        var position3 = utils.css(element, "position");
        if (position3 === "absolute") {
          element.style.position = "fixed";
        }
      }
      var scrollX = utils.getWindowScrollLeft(win);
      var scrollY = utils.getWindowScrollTop(win);
      var viewportWidth = utils.viewportWidth(win);
      var viewportHeight = utils.viewportHeight(win);
      var documentWidth = documentElement.scrollWidth;
      var documentHeight = documentElement.scrollHeight;
      var bodyStyle = window.getComputedStyle(body);
      if (bodyStyle.overflowX === "hidden") {
        documentWidth = win.innerWidth;
      }
      if (bodyStyle.overflowY === "hidden") {
        documentHeight = win.innerHeight;
      }
      if (element.style) {
        element.style.position = originalPosition;
      }
      if (alwaysByViewport || isAncestorFixed(element)) {
        visibleRect.left = Math.max(visibleRect.left, scrollX);
        visibleRect.top = Math.max(visibleRect.top, scrollY);
        visibleRect.right = Math.min(visibleRect.right, scrollX + viewportWidth);
        visibleRect.bottom = Math.min(visibleRect.bottom, scrollY + viewportHeight);
      } else {
        var maxVisibleWidth = Math.max(documentWidth, scrollX + viewportWidth);
        visibleRect.right = Math.min(visibleRect.right, maxVisibleWidth);
        var maxVisibleHeight = Math.max(documentHeight, scrollY + viewportHeight);
        visibleRect.bottom = Math.min(visibleRect.bottom, maxVisibleHeight);
      }
      return visibleRect.top >= 0 && visibleRect.left >= 0 && visibleRect.bottom > visibleRect.top && visibleRect.right > visibleRect.left ? visibleRect : null;
    }
    function adjustForViewport(elFuturePos, elRegion, visibleRect, overflow) {
      var pos = utils.clone(elFuturePos);
      var size = {
        width: elRegion.width,
        height: elRegion.height
      };
      if (overflow.adjustX && pos.left < visibleRect.left) {
        pos.left = visibleRect.left;
      }
      if (overflow.resizeWidth && pos.left >= visibleRect.left && pos.left + size.width > visibleRect.right) {
        size.width -= pos.left + size.width - visibleRect.right;
      }
      if (overflow.adjustX && pos.left + size.width > visibleRect.right) {
        pos.left = Math.max(visibleRect.right - size.width, visibleRect.left);
      }
      if (overflow.adjustY && pos.top < visibleRect.top) {
        pos.top = visibleRect.top;
      }
      if (overflow.resizeHeight && pos.top >= visibleRect.top && pos.top + size.height > visibleRect.bottom) {
        size.height -= pos.top + size.height - visibleRect.bottom;
      }
      if (overflow.adjustY && pos.top + size.height > visibleRect.bottom) {
        pos.top = Math.max(visibleRect.bottom - size.height, visibleRect.top);
      }
      return utils.mix(pos, size);
    }
    function getRegion(node2) {
      var offset4;
      var w;
      var h2;
      if (!utils.isWindow(node2) && node2.nodeType !== 9) {
        offset4 = utils.offset(node2);
        w = utils.outerWidth(node2);
        h2 = utils.outerHeight(node2);
      } else {
        var win = utils.getWindow(node2);
        offset4 = {
          left: utils.getWindowScrollLeft(win),
          top: utils.getWindowScrollTop(win)
        };
        w = utils.viewportWidth(win);
        h2 = utils.viewportHeight(win);
      }
      offset4.width = w;
      offset4.height = h2;
      return offset4;
    }
    function getAlignOffset(region, align) {
      var V = align.charAt(0);
      var H = align.charAt(1);
      var w = region.width;
      var h2 = region.height;
      var x = region.left;
      var y = region.top;
      if (V === "c") {
        y += h2 / 2;
      } else if (V === "b") {
        y += h2;
      }
      if (H === "c") {
        x += w / 2;
      } else if (H === "r") {
        x += w;
      }
      return {
        left: x,
        top: y
      };
    }
    function getElFuturePos(elRegion, refNodeRegion, points, offset4, targetOffset3) {
      var p1 = getAlignOffset(refNodeRegion, points[1]);
      var p2 = getAlignOffset(elRegion, points[0]);
      var diff3 = [p2.left - p1.left, p2.top - p1.top];
      return {
        left: Math.round(elRegion.left - diff3[0] + offset4[0] - targetOffset3[0]),
        top: Math.round(elRegion.top - diff3[1] + offset4[1] - targetOffset3[1])
      };
    }
    function isFailX(elFuturePos, elRegion, visibleRect) {
      return elFuturePos.left < visibleRect.left || elFuturePos.left + elRegion.width > visibleRect.right;
    }
    function isFailY(elFuturePos, elRegion, visibleRect) {
      return elFuturePos.top < visibleRect.top || elFuturePos.top + elRegion.height > visibleRect.bottom;
    }
    function isCompleteFailX(elFuturePos, elRegion, visibleRect) {
      return elFuturePos.left > visibleRect.right || elFuturePos.left + elRegion.width < visibleRect.left;
    }
    function isCompleteFailY(elFuturePos, elRegion, visibleRect) {
      return elFuturePos.top > visibleRect.bottom || elFuturePos.top + elRegion.height < visibleRect.top;
    }
    function flip(points, reg, map) {
      var ret = [];
      utils.each(points, function(p) {
        ret.push(p.replace(reg, function(m) {
          return map[m];
        }));
      });
      return ret;
    }
    function flipOffset(offset4, index3) {
      offset4[index3] = -offset4[index3];
      return offset4;
    }
    function convertOffset(str, offsetLen) {
      var n2;
      if (/%$/.test(str)) {
        n2 = parseInt(str.substring(0, str.length - 1), 10) / 100 * offsetLen;
      } else {
        n2 = parseInt(str, 10);
      }
      return n2 || 0;
    }
    function normalizeOffset(offset4, el) {
      offset4[0] = convertOffset(offset4[0], el.width);
      offset4[1] = convertOffset(offset4[1], el.height);
    }
    function doAlign(el, tgtRegion, align, isTgtRegionVisible) {
      var points = align.points;
      var offset4 = align.offset || [0, 0];
      var targetOffset3 = align.targetOffset || [0, 0];
      var overflow = align.overflow;
      var source = align.source || el;
      offset4 = [].concat(offset4);
      targetOffset3 = [].concat(targetOffset3);
      overflow = overflow || {};
      var newOverflowCfg = {};
      var fail = 0;
      var alwaysByViewport = !!(overflow && overflow.alwaysByViewport);
      var visibleRect = getVisibleRectForElement(source, alwaysByViewport);
      var elRegion = getRegion(source);
      normalizeOffset(offset4, elRegion);
      normalizeOffset(targetOffset3, tgtRegion);
      var elFuturePos = getElFuturePos(elRegion, tgtRegion, points, offset4, targetOffset3);
      var newElRegion = utils.merge(elRegion, elFuturePos);
      if (visibleRect && (overflow.adjustX || overflow.adjustY) && isTgtRegionVisible) {
        if (overflow.adjustX) {
          if (isFailX(elFuturePos, elRegion, visibleRect)) {
            var newPoints = flip(points, /[lr]/gi, {
              l: "r",
              r: "l"
            });
            var newOffset = flipOffset(offset4, 0);
            var newTargetOffset = flipOffset(targetOffset3, 0);
            var newElFuturePos = getElFuturePos(elRegion, tgtRegion, newPoints, newOffset, newTargetOffset);
            if (!isCompleteFailX(newElFuturePos, elRegion, visibleRect)) {
              fail = 1;
              points = newPoints;
              offset4 = newOffset;
              targetOffset3 = newTargetOffset;
            }
          }
        }
        if (overflow.adjustY) {
          if (isFailY(elFuturePos, elRegion, visibleRect)) {
            var _newPoints = flip(points, /[tb]/gi, {
              t: "b",
              b: "t"
            });
            var _newOffset = flipOffset(offset4, 1);
            var _newTargetOffset = flipOffset(targetOffset3, 1);
            var _newElFuturePos = getElFuturePos(elRegion, tgtRegion, _newPoints, _newOffset, _newTargetOffset);
            if (!isCompleteFailY(_newElFuturePos, elRegion, visibleRect)) {
              fail = 1;
              points = _newPoints;
              offset4 = _newOffset;
              targetOffset3 = _newTargetOffset;
            }
          }
        }
        if (fail) {
          elFuturePos = getElFuturePos(elRegion, tgtRegion, points, offset4, targetOffset3);
          utils.mix(newElRegion, elFuturePos);
        }
        var isStillFailX = isFailX(elFuturePos, elRegion, visibleRect);
        var isStillFailY = isFailY(elFuturePos, elRegion, visibleRect);
        if (isStillFailX || isStillFailY) {
          var _newPoints2 = points;
          if (isStillFailX) {
            _newPoints2 = flip(points, /[lr]/gi, {
              l: "r",
              r: "l"
            });
          }
          if (isStillFailY) {
            _newPoints2 = flip(points, /[tb]/gi, {
              t: "b",
              b: "t"
            });
          }
          points = _newPoints2;
          offset4 = align.offset || [0, 0];
          targetOffset3 = align.targetOffset || [0, 0];
        }
        newOverflowCfg.adjustX = overflow.adjustX && isStillFailX;
        newOverflowCfg.adjustY = overflow.adjustY && isStillFailY;
        if (newOverflowCfg.adjustX || newOverflowCfg.adjustY) {
          newElRegion = adjustForViewport(elFuturePos, elRegion, visibleRect, newOverflowCfg);
        }
      }
      if (newElRegion.width !== elRegion.width) {
        utils.css(source, "width", utils.width(source) + newElRegion.width - elRegion.width);
      }
      if (newElRegion.height !== elRegion.height) {
        utils.css(source, "height", utils.height(source) + newElRegion.height - elRegion.height);
      }
      utils.offset(source, {
        left: newElRegion.left,
        top: newElRegion.top
      }, {
        useCssRight: align.useCssRight,
        useCssBottom: align.useCssBottom,
        useCssTransform: align.useCssTransform,
        ignoreShake: align.ignoreShake
      });
      return {
        points,
        offset: offset4,
        targetOffset: targetOffset3,
        overflow: newOverflowCfg
      };
    }
    function isOutOfVisibleRect(target, alwaysByViewport) {
      var visibleRect = getVisibleRectForElement(target, alwaysByViewport);
      var targetRegion = getRegion(target);
      return !visibleRect || targetRegion.left + targetRegion.width <= visibleRect.left || targetRegion.top + targetRegion.height <= visibleRect.top || targetRegion.left >= visibleRect.right || targetRegion.top >= visibleRect.bottom;
    }
    function alignElement(el, refNode, align) {
      var target = align.target || refNode;
      var refNodeRegion = getRegion(target);
      var isTargetNotOutOfVisible = !isOutOfVisibleRect(target, align.overflow && align.overflow.alwaysByViewport);
      return doAlign(el, refNodeRegion, align, isTargetNotOutOfVisible);
    }
    alignElement.__getOffsetParent = getOffsetParent;
    alignElement.__getVisibleRectForElement = getVisibleRectForElement;
    function ownKeys3(object4, enumerableOnly) {
      var keys4 = Object.keys(object4);
      if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object4);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
          return Object.getOwnPropertyDescriptor(object4, sym).enumerable;
        })), keys4.push.apply(keys4, symbols);
      }
      return keys4;
    }
    function _objectSpread3(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys3(Object(source), true).forEach(function(key2) {
          _defineProperty11(target, key2, source[key2]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys3(Object(source)).forEach(function(key2) {
          Object.defineProperty(target, key2, Object.getOwnPropertyDescriptor(source, key2));
        });
      }
      return target;
    }
    function _defineProperty11(obj, key2, value) {
      if (key2 in obj) {
        Object.defineProperty(obj, key2, {
          value,
          enumerable: true,
          configurable: true,
          writable: true
        });
      } else {
        obj[key2] = value;
      }
      return obj;
    }
    function alignPoint(el, tgtPoint, align) {
      var pageX;
      var pageY;
      var doc2 = utils.getDocument(el);
      var win = doc2.defaultView || doc2.parentWindow;
      var scrollX = utils.getWindowScrollLeft(win);
      var scrollY = utils.getWindowScrollTop(win);
      var viewportWidth = utils.viewportWidth(win);
      var viewportHeight = utils.viewportHeight(win);
      if ("pageX" in tgtPoint) {
        pageX = tgtPoint.pageX;
      } else {
        pageX = scrollX + tgtPoint.clientX;
      }
      if ("pageY" in tgtPoint) {
        pageY = tgtPoint.pageY;
      } else {
        pageY = scrollY + tgtPoint.clientY;
      }
      var tgtRegion = {
        left: pageX,
        top: pageY,
        width: 0,
        height: 0
      };
      var pointInView = pageX >= 0 && pageX <= scrollX + viewportWidth && pageY >= 0 && pageY <= scrollY + viewportHeight;
      var points = [align.points[0], "cc"];
      return doAlign(el, tgtRegion, _objectSpread3(_objectSpread3({}, align), {}, {
        points
      }), pointInView);
    }
    exports2.alignElement = alignElement;
    exports2.alignPoint = alignPoint;
    exports2.default = alignElement;
  }
});

// ../../node_modules/rc-align/node_modules/rc-util/lib/Dom/addEventListener.js
var require_addEventListener2 = __commonJS({
  "../../node_modules/rc-align/node_modules/rc-util/lib/Dom/addEventListener.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = addEventListenerWrap2;
    var _addDomEventListener = _interopRequireDefault(require_lib());
    var _reactDom = _interopRequireDefault(require_react_dom());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { default: obj };
    }
    function addEventListenerWrap2(target, eventType, cb, option) {
      var callback = _reactDom.default.unstable_batchedUpdates ? function run(e3) {
        _reactDom.default.unstable_batchedUpdates(cb, e3);
      } : cb;
      return (0, _addDomEventListener.default)(target, eventType, callback, option);
    }
  }
});

// ../../node_modules/rc-align/node_modules/rc-util/lib/Dom/contains.js
var require_contains2 = __commonJS({
  "../../node_modules/rc-align/node_modules/rc-util/lib/Dom/contains.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = contains2;
    function contains2(root2, n2) {
      var node2 = n2;
      while (node2) {
        if (node2 === root2) {
          return true;
        }
        node2 = node2.parentNode;
      }
      return false;
    }
  }
});

// ../../node_modules/rc-align/lib/util.js
var require_util = __commonJS({
  "../../node_modules/rc-align/lib/util.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.buffer = buffer;
    exports2.isSamePoint = isSamePoint2;
    exports2.isWindow = isWindow4;
    exports2.isSimilarValue = isSimilarValue;
    exports2.restoreFocus = restoreFocus;
    var _contains = require_contains2();
    var _contains2 = _interopRequireDefault(_contains);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    function buffer(fn, ms) {
      var timer = void 0;
      function clear() {
        if (timer) {
          clearTimeout(timer);
          timer = null;
        }
      }
      function bufferFn() {
        clear();
        timer = setTimeout(fn, ms);
      }
      bufferFn.clear = clear;
      return bufferFn;
    }
    function isSamePoint2(prev2, next2) {
      if (prev2 === next2) return true;
      if (!prev2 || !next2) return false;
      if ("pageX" in next2 && "pageY" in next2) {
        return prev2.pageX === next2.pageX && prev2.pageY === next2.pageY;
      }
      if ("clientX" in next2 && "clientY" in next2) {
        return prev2.clientX === next2.clientX && prev2.clientY === next2.clientY;
      }
      return false;
    }
    function isWindow4(obj) {
      return obj && typeof obj === "object" && obj.window === obj;
    }
    function isSimilarValue(val1, val2) {
      var int1 = Math.floor(val1);
      var int2 = Math.floor(val2);
      return Math.abs(int1 - int2) <= 1;
    }
    function restoreFocus(activeElement, container) {
      if (activeElement !== document.activeElement && (0, _contains2["default"])(container, activeElement)) {
        activeElement.focus();
      }
    }
  }
});

// ../../node_modules/rc-align/lib/Align.js
var require_Align = __commonJS({
  "../../node_modules/rc-align/lib/Align.js"(exports2, module2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    var _classCallCheck2 = require_classCallCheck();
    var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
    var _createClass2 = require_createClass();
    var _createClass3 = _interopRequireDefault(_createClass2);
    var _possibleConstructorReturn2 = require_possibleConstructorReturn();
    var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
    var _inherits2 = require_inherits();
    var _inherits3 = _interopRequireDefault(_inherits2);
    var _react = require_react();
    var _react2 = _interopRequireDefault(_react);
    var _propTypes = require_prop_types();
    var _propTypes2 = _interopRequireDefault(_propTypes);
    var _reactDom = require_react_dom();
    var _reactDom2 = _interopRequireDefault(_reactDom);
    var _domAlign = require_dist_node();
    var _addEventListener = require_addEventListener2();
    var _addEventListener2 = _interopRequireDefault(_addEventListener);
    var _util2 = require_util();
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    function getElement(func) {
      if (typeof func !== "function" || !func) return null;
      return func();
    }
    function getPoint(point) {
      if (typeof point !== "object" || !point) return null;
      return point;
    }
    var Align = (function(_Component) {
      (0, _inherits3["default"])(Align2, _Component);
      function Align2() {
        var _ref;
        var _temp, _this, _ret;
        (0, _classCallCheck3["default"])(this, Align2);
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3["default"])(this, (_ref = Align2.__proto__ || Object.getPrototypeOf(Align2)).call.apply(_ref, [this].concat(args))), _this), _this.forceAlign = function() {
          var _this$props = _this.props, disabled = _this$props.disabled, target = _this$props.target, align = _this$props.align, onAlign = _this$props.onAlign;
          if (!disabled && target) {
            var source = _reactDom2["default"].findDOMNode(_this);
            var result = void 0;
            var element = getElement(target);
            var point = getPoint(target);
            var activeElement = document.activeElement;
            if (element) {
              result = (0, _domAlign.alignElement)(source, element, align);
            } else if (point) {
              result = (0, _domAlign.alignPoint)(source, point, align);
            }
            (0, _util2.restoreFocus)(activeElement, source);
            if (onAlign) {
              onAlign(source, result);
            }
          }
        }, _temp), (0, _possibleConstructorReturn3["default"])(_this, _ret);
      }
      (0, _createClass3["default"])(Align2, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          var props = this.props;
          this.forceAlign();
          if (!props.disabled && props.monitorWindowResize) {
            this.startMonitorWindowResize();
          }
        }
      }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps) {
          var reAlign = false;
          var props = this.props;
          if (!props.disabled) {
            var source = _reactDom2["default"].findDOMNode(this);
            var sourceRect = source ? source.getBoundingClientRect() : null;
            if (prevProps.disabled) {
              reAlign = true;
            } else {
              var lastElement = getElement(prevProps.target);
              var currentElement = getElement(props.target);
              var lastPoint = getPoint(prevProps.target);
              var currentPoint = getPoint(props.target);
              if ((0, _util2.isWindow)(lastElement) && (0, _util2.isWindow)(currentElement)) {
                reAlign = false;
              } else if (lastElement !== currentElement || // Element change
              lastElement && !currentElement && currentPoint || // Change from element to point
              lastPoint && currentPoint && currentElement || // Change from point to element
              currentPoint && !(0, _util2.isSamePoint)(lastPoint, currentPoint)) {
                reAlign = true;
              }
              var preRect = this.sourceRect || {};
              if (!reAlign && source && (!(0, _util2.isSimilarValue)(preRect.width, sourceRect.width) || !(0, _util2.isSimilarValue)(preRect.height, sourceRect.height))) {
                reAlign = true;
              }
            }
            this.sourceRect = sourceRect;
          }
          if (reAlign) {
            this.forceAlign();
          }
          if (props.monitorWindowResize && !props.disabled) {
            this.startMonitorWindowResize();
          } else {
            this.stopMonitorWindowResize();
          }
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this.stopMonitorWindowResize();
        }
      }, {
        key: "startMonitorWindowResize",
        value: function startMonitorWindowResize() {
          if (!this.resizeHandler) {
            this.bufferMonitor = (0, _util2.buffer)(this.forceAlign, this.props.monitorBufferTime);
            this.resizeHandler = (0, _addEventListener2["default"])(window, "resize", this.bufferMonitor);
          }
        }
      }, {
        key: "stopMonitorWindowResize",
        value: function stopMonitorWindowResize() {
          if (this.resizeHandler) {
            this.bufferMonitor.clear();
            this.resizeHandler.remove();
            this.resizeHandler = null;
          }
        }
      }, {
        key: "render",
        value: function render4() {
          var _this2 = this;
          var _props = this.props, childrenProps = _props.childrenProps, children = _props.children;
          var child = _react2["default"].Children.only(children);
          if (childrenProps) {
            var newProps = {};
            var propList2 = Object.keys(childrenProps);
            propList2.forEach(function(prop) {
              newProps[prop] = _this2.props[childrenProps[prop]];
            });
            return _react2["default"].cloneElement(child, newProps);
          }
          return child;
        }
      }]);
      return Align2;
    })(_react.Component);
    Align.propTypes = {
      childrenProps: _propTypes2["default"].object,
      align: _propTypes2["default"].object.isRequired,
      target: _propTypes2["default"].oneOfType([_propTypes2["default"].func, _propTypes2["default"].shape({
        clientX: _propTypes2["default"].number,
        clientY: _propTypes2["default"].number,
        pageX: _propTypes2["default"].number,
        pageY: _propTypes2["default"].number
      })]),
      onAlign: _propTypes2["default"].func,
      monitorBufferTime: _propTypes2["default"].number,
      monitorWindowResize: _propTypes2["default"].bool,
      disabled: _propTypes2["default"].bool,
      children: _propTypes2["default"].any
    };
    Align.defaultProps = {
      target: function target() {
        return window;
      },
      monitorBufferTime: 50,
      monitorWindowResize: false,
      disabled: false
    };
    exports2["default"] = Align;
    module2.exports = exports2["default"];
  }
});

// ../../node_modules/rc-align/lib/index.js
var require_lib2 = __commonJS({
  "../../node_modules/rc-align/lib/index.js"(exports2, module2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    var _Align = require_Align();
    var _Align2 = _interopRequireDefault(_Align);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    exports2["default"] = _Align2["default"];
    module2.exports = exports2["default"];
  }
});

// ../../node_modules/babel-runtime/helpers/defineProperty.js
var require_defineProperty2 = __commonJS({
  "../../node_modules/babel-runtime/helpers/defineProperty.js"(exports2) {
    "use strict";
    exports2.__esModule = true;
    var _defineProperty11 = require_define_property2();
    var _defineProperty22 = _interopRequireDefault(_defineProperty11);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { default: obj };
    }
    exports2.default = function(obj, key2, value) {
      if (key2 in obj) {
        (0, _defineProperty22.default)(obj, key2, {
          value,
          enumerable: true,
          configurable: true,
          writable: true
        });
      } else {
        obj[key2] = value;
      }
      return obj;
    };
  }
});

// ../../node_modules/rc-animate/node_modules/rc-util/lib/unsafeLifecyclesPolyfill.js
var require_unsafeLifecyclesPolyfill = __commonJS({
  "../../node_modules/rc-animate/node_modules/rc-util/lib/unsafeLifecyclesPolyfill.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = void 0;
    var _react = _interopRequireDefault(require_react());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { default: obj };
    }
    var unsafeLifecyclesPolyfill = function unsafeLifecyclesPolyfill2(Component10) {
      var prototype = Component10.prototype;
      if (!prototype || !prototype.isReactComponent) {
        throw new Error("Can only polyfill class components");
      }
      if (typeof prototype.componentWillReceiveProps !== "function") {
        return Component10;
      }
      if (!_react.default.Profiler) {
        return Component10;
      }
      prototype.UNSAFE_componentWillReceiveProps = prototype.componentWillReceiveProps;
      delete prototype.componentWillReceiveProps;
      return Component10;
    };
    var _default = unsafeLifecyclesPolyfill;
    exports2.default = _default;
  }
});

// ../../node_modules/rc-animate/lib/ChildrenUtils.js
var require_ChildrenUtils = __commonJS({
  "../../node_modules/rc-animate/lib/ChildrenUtils.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.toArrayChildren = toArrayChildren;
    exports2.findChildInChildrenByKey = findChildInChildrenByKey;
    exports2.findShownChildInChildrenByKey = findShownChildInChildrenByKey;
    exports2.findHiddenChildInChildrenByKey = findHiddenChildInChildrenByKey;
    exports2.isSameChildren = isSameChildren;
    exports2.mergeChildren = mergeChildren;
    var _react = require_react();
    var _react2 = _interopRequireDefault(_react);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    function toArrayChildren(children) {
      var ret = [];
      _react2["default"].Children.forEach(children, function(child) {
        ret.push(child);
      });
      return ret;
    }
    function findChildInChildrenByKey(children, key2) {
      var ret = null;
      if (children) {
        children.forEach(function(child) {
          if (ret) {
            return;
          }
          if (child && child.key === key2) {
            ret = child;
          }
        });
      }
      return ret;
    }
    function findShownChildInChildrenByKey(children, key2, showProp) {
      var ret = null;
      if (children) {
        children.forEach(function(child) {
          if (child && child.key === key2 && child.props[showProp]) {
            if (ret) {
              throw new Error("two child with same key for <rc-animate> children");
            }
            ret = child;
          }
        });
      }
      return ret;
    }
    function findHiddenChildInChildrenByKey(children, key2, showProp) {
      var found = 0;
      if (children) {
        children.forEach(function(child) {
          if (found) {
            return;
          }
          found = child && child.key === key2 && !child.props[showProp];
        });
      }
      return found;
    }
    function isSameChildren(c1, c2, showProp) {
      var same = c1.length === c2.length;
      if (same) {
        c1.forEach(function(child, index3) {
          var child2 = c2[index3];
          if (child && child2) {
            if (child && !child2 || !child && child2) {
              same = false;
            } else if (child.key !== child2.key) {
              same = false;
            } else if (showProp && child.props[showProp] !== child2.props[showProp]) {
              same = false;
            }
          }
        });
      }
      return same;
    }
    function mergeChildren(prev2, next2) {
      var ret = [];
      var nextChildrenPending = {};
      var pendingChildren = [];
      prev2.forEach(function(child) {
        if (child && findChildInChildrenByKey(next2, child.key)) {
          if (pendingChildren.length) {
            nextChildrenPending[child.key] = pendingChildren;
            pendingChildren = [];
          }
        } else {
          pendingChildren.push(child);
        }
      });
      next2.forEach(function(child) {
        if (child && Object.prototype.hasOwnProperty.call(nextChildrenPending, child.key)) {
          ret = ret.concat(nextChildrenPending[child.key]);
        }
        ret.push(child);
      });
      ret = ret.concat(pendingChildren);
      return ret;
    }
  }
});

// ../../node_modules/css-animation/lib/Event.js
var require_Event = __commonJS({
  "../../node_modules/css-animation/lib/Event.js"(exports2, module2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    var START_EVENT_NAME_MAP = {
      transitionstart: {
        transition: "transitionstart",
        WebkitTransition: "webkitTransitionStart",
        MozTransition: "mozTransitionStart",
        OTransition: "oTransitionStart",
        msTransition: "MSTransitionStart"
      },
      animationstart: {
        animation: "animationstart",
        WebkitAnimation: "webkitAnimationStart",
        MozAnimation: "mozAnimationStart",
        OAnimation: "oAnimationStart",
        msAnimation: "MSAnimationStart"
      }
    };
    var END_EVENT_NAME_MAP = {
      transitionend: {
        transition: "transitionend",
        WebkitTransition: "webkitTransitionEnd",
        MozTransition: "mozTransitionEnd",
        OTransition: "oTransitionEnd",
        msTransition: "MSTransitionEnd"
      },
      animationend: {
        animation: "animationend",
        WebkitAnimation: "webkitAnimationEnd",
        MozAnimation: "mozAnimationEnd",
        OAnimation: "oAnimationEnd",
        msAnimation: "MSAnimationEnd"
      }
    };
    var startEvents = [];
    var endEvents = [];
    function detectEvents() {
      var testEl = document.createElement("div");
      var style2 = testEl.style;
      if (!("AnimationEvent" in window)) {
        delete START_EVENT_NAME_MAP.animationstart.animation;
        delete END_EVENT_NAME_MAP.animationend.animation;
      }
      if (!("TransitionEvent" in window)) {
        delete START_EVENT_NAME_MAP.transitionstart.transition;
        delete END_EVENT_NAME_MAP.transitionend.transition;
      }
      function process2(EVENT_NAME_MAP, events2) {
        for (var baseEventName in EVENT_NAME_MAP) {
          if (EVENT_NAME_MAP.hasOwnProperty(baseEventName)) {
            var baseEvents = EVENT_NAME_MAP[baseEventName];
            for (var styleName in baseEvents) {
              if (styleName in style2) {
                events2.push(baseEvents[styleName]);
                break;
              }
            }
          }
        }
      }
      process2(START_EVENT_NAME_MAP, startEvents);
      process2(END_EVENT_NAME_MAP, endEvents);
    }
    if (typeof window !== "undefined" && typeof document !== "undefined") {
      detectEvents();
    }
    function addEventListener(node2, eventName, eventListener) {
      node2.addEventListener(eventName, eventListener, false);
    }
    function removeEventListener(node2, eventName, eventListener) {
      node2.removeEventListener(eventName, eventListener, false);
    }
    var TransitionEvents = {
      // Start events
      startEvents,
      addStartEventListener: function addStartEventListener(node2, eventListener) {
        if (startEvents.length === 0) {
          window.setTimeout(eventListener, 0);
          return;
        }
        startEvents.forEach(function(startEvent) {
          addEventListener(node2, startEvent, eventListener);
        });
      },
      removeStartEventListener: function removeStartEventListener(node2, eventListener) {
        if (startEvents.length === 0) {
          return;
        }
        startEvents.forEach(function(startEvent) {
          removeEventListener(node2, startEvent, eventListener);
        });
      },
      // End events
      endEvents,
      addEndEventListener: function addEndEventListener(node2, eventListener) {
        if (endEvents.length === 0) {
          window.setTimeout(eventListener, 0);
          return;
        }
        endEvents.forEach(function(endEvent) {
          addEventListener(node2, endEvent, eventListener);
        });
      },
      removeEndEventListener: function removeEndEventListener(node2, eventListener) {
        if (endEvents.length === 0) {
          return;
        }
        endEvents.forEach(function(endEvent) {
          removeEventListener(node2, endEvent, eventListener);
        });
      }
    };
    exports2["default"] = TransitionEvents;
    module2.exports = exports2["default"];
  }
});

// ../../node_modules/component-indexof/index.js
var require_component_indexof = __commonJS({
  "../../node_modules/component-indexof/index.js"(exports2, module2) {
    module2.exports = function(arr, obj) {
      if (arr.indexOf) return arr.indexOf(obj);
      for (var i = 0; i < arr.length; ++i) {
        if (arr[i] === obj) return i;
      }
      return -1;
    };
  }
});

// ../../node_modules/component-classes/index.js
var require_component_classes = __commonJS({
  "../../node_modules/component-classes/index.js"(exports2, module2) {
    try {
      index3 = require_component_indexof();
    } catch (err) {
      index3 = require_component_indexof();
    }
    var index3;
    var re = /\s+/;
    var toString3 = Object.prototype.toString;
    module2.exports = function(el) {
      return new ClassList(el);
    };
    function ClassList(el) {
      if (!el || !el.nodeType) {
        throw new Error("A DOM element reference is required");
      }
      this.el = el;
      this.list = el.classList;
    }
    ClassList.prototype.add = function(name) {
      if (this.list) {
        this.list.add(name);
        return this;
      }
      var arr = this.array();
      var i = index3(arr, name);
      if (!~i) arr.push(name);
      this.el.className = arr.join(" ");
      return this;
    };
    ClassList.prototype.remove = function(name) {
      if ("[object RegExp]" == toString3.call(name)) {
        return this.removeMatching(name);
      }
      if (this.list) {
        this.list.remove(name);
        return this;
      }
      var arr = this.array();
      var i = index3(arr, name);
      if (~i) arr.splice(i, 1);
      this.el.className = arr.join(" ");
      return this;
    };
    ClassList.prototype.removeMatching = function(re2) {
      var arr = this.array();
      for (var i = 0; i < arr.length; i++) {
        if (re2.test(arr[i])) {
          this.remove(arr[i]);
        }
      }
      return this;
    };
    ClassList.prototype.toggle = function(name, force) {
      if (this.list) {
        if ("undefined" !== typeof force) {
          if (force !== this.list.toggle(name, force)) {
            this.list.toggle(name);
          }
        } else {
          this.list.toggle(name);
        }
        return this;
      }
      if ("undefined" !== typeof force) {
        if (!force) {
          this.remove(name);
        } else {
          this.add(name);
        }
      } else {
        if (this.has(name)) {
          this.remove(name);
        } else {
          this.add(name);
        }
      }
      return this;
    };
    ClassList.prototype.array = function() {
      var className2 = this.el.getAttribute("class") || "";
      var str = className2.replace(/^\s+|\s+$/g, "");
      var arr = str.split(re);
      if ("" === arr[0]) arr.shift();
      return arr;
    };
    ClassList.prototype.has = ClassList.prototype.contains = function(name) {
      return this.list ? this.list.contains(name) : !!~index3(this.array(), name);
    };
  }
});

// ../../node_modules/css-animation/lib/index.js
var require_lib3 = __commonJS({
  "../../node_modules/css-animation/lib/index.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.isCssAnimationSupported = void 0;
    var _typeof22 = require_typeof2();
    var _typeof32 = _interopRequireDefault(_typeof22);
    var _Event = require_Event();
    var _Event2 = _interopRequireDefault(_Event);
    var _componentClasses = require_component_classes();
    var _componentClasses2 = _interopRequireDefault(_componentClasses);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    var isCssAnimationSupported = _Event2["default"].endEvents.length !== 0;
    var capitalPrefixes = [
      "Webkit",
      "Moz",
      "O",
      // ms is special .... !
      "ms"
    ];
    var prefixes = ["-webkit-", "-moz-", "-o-", "ms-", ""];
    function getStyleProperty(node2, name) {
      var style2 = window.getComputedStyle(node2, null);
      var ret = "";
      for (var i = 0; i < prefixes.length; i++) {
        ret = style2.getPropertyValue(prefixes[i] + name);
        if (ret) {
          break;
        }
      }
      return ret;
    }
    function fixBrowserByTimeout(node2) {
      if (isCssAnimationSupported) {
        var transitionDelay = parseFloat(getStyleProperty(node2, "transition-delay")) || 0;
        var transitionDuration = parseFloat(getStyleProperty(node2, "transition-duration")) || 0;
        var animationDelay = parseFloat(getStyleProperty(node2, "animation-delay")) || 0;
        var animationDuration = parseFloat(getStyleProperty(node2, "animation-duration")) || 0;
        var time = Math.max(transitionDuration + transitionDelay, animationDuration + animationDelay);
        node2.rcEndAnimTimeout = setTimeout(function() {
          node2.rcEndAnimTimeout = null;
          if (node2.rcEndListener) {
            node2.rcEndListener();
          }
        }, time * 1e3 + 200);
      }
    }
    function clearBrowserBugTimeout(node2) {
      if (node2.rcEndAnimTimeout) {
        clearTimeout(node2.rcEndAnimTimeout);
        node2.rcEndAnimTimeout = null;
      }
    }
    var cssAnimation = function cssAnimation2(node2, transitionName, endCallback) {
      var nameIsObj = (typeof transitionName === "undefined" ? "undefined" : (0, _typeof32["default"])(transitionName)) === "object";
      var className2 = nameIsObj ? transitionName.name : transitionName;
      var activeClassName = nameIsObj ? transitionName.active : transitionName + "-active";
      var end = endCallback;
      var start = void 0;
      var active = void 0;
      var nodeClasses = (0, _componentClasses2["default"])(node2);
      if (endCallback && Object.prototype.toString.call(endCallback) === "[object Object]") {
        end = endCallback.end;
        start = endCallback.start;
        active = endCallback.active;
      }
      if (node2.rcEndListener) {
        node2.rcEndListener();
      }
      node2.rcEndListener = function(e3) {
        if (e3 && e3.target !== node2) {
          return;
        }
        if (node2.rcAnimTimeout) {
          clearTimeout(node2.rcAnimTimeout);
          node2.rcAnimTimeout = null;
        }
        clearBrowserBugTimeout(node2);
        nodeClasses.remove(className2);
        nodeClasses.remove(activeClassName);
        _Event2["default"].removeEndEventListener(node2, node2.rcEndListener);
        node2.rcEndListener = null;
        if (end) {
          end();
        }
      };
      _Event2["default"].addEndEventListener(node2, node2.rcEndListener);
      if (start) {
        start();
      }
      nodeClasses.add(className2);
      node2.rcAnimTimeout = setTimeout(function() {
        node2.rcAnimTimeout = null;
        nodeClasses.add(activeClassName);
        if (active) {
          setTimeout(active, 0);
        }
        fixBrowserByTimeout(node2);
      }, 30);
      return {
        stop: function stop() {
          if (node2.rcEndListener) {
            node2.rcEndListener();
          }
        }
      };
    };
    cssAnimation.style = function(node2, style2, callback) {
      if (node2.rcEndListener) {
        node2.rcEndListener();
      }
      node2.rcEndListener = function(e3) {
        if (e3 && e3.target !== node2) {
          return;
        }
        if (node2.rcAnimTimeout) {
          clearTimeout(node2.rcAnimTimeout);
          node2.rcAnimTimeout = null;
        }
        clearBrowserBugTimeout(node2);
        _Event2["default"].removeEndEventListener(node2, node2.rcEndListener);
        node2.rcEndListener = null;
        if (callback) {
          callback();
        }
      };
      _Event2["default"].addEndEventListener(node2, node2.rcEndListener);
      node2.rcAnimTimeout = setTimeout(function() {
        for (var s in style2) {
          if (style2.hasOwnProperty(s)) {
            node2.style[s] = style2[s];
          }
        }
        node2.rcAnimTimeout = null;
        fixBrowserByTimeout(node2);
      }, 0);
    };
    cssAnimation.setTransition = function(node2, p, value) {
      var property2 = p;
      var v = value;
      if (value === void 0) {
        v = property2;
        property2 = "";
      }
      property2 = property2 || "";
      capitalPrefixes.forEach(function(prefix3) {
        node2.style[prefix3 + "Transition" + property2] = v;
      });
    };
    cssAnimation.isCssAnimationSupported = isCssAnimationSupported;
    exports2.isCssAnimationSupported = isCssAnimationSupported;
    exports2["default"] = cssAnimation;
  }
});

// ../../node_modules/rc-animate/lib/util/animate.js
var require_animate = __commonJS({
  "../../node_modules/rc-animate/lib/util/animate.js"(exports2, module2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    var util2 = {
      isAppearSupported: function isAppearSupported(props) {
        return props.transitionName && props.transitionAppear || props.animation.appear;
      },
      isEnterSupported: function isEnterSupported(props) {
        return props.transitionName && props.transitionEnter || props.animation.enter;
      },
      isLeaveSupported: function isLeaveSupported(props) {
        return props.transitionName && props.transitionLeave || props.animation.leave;
      },
      allowAppearCallback: function allowAppearCallback(props) {
        return props.transitionAppear || props.animation.appear;
      },
      allowEnterCallback: function allowEnterCallback(props) {
        return props.transitionEnter || props.animation.enter;
      },
      allowLeaveCallback: function allowLeaveCallback(props) {
        return props.transitionLeave || props.animation.leave;
      }
    };
    exports2["default"] = util2;
    module2.exports = exports2["default"];
  }
});

// ../../node_modules/rc-animate/lib/AnimateChild.js
var require_AnimateChild = __commonJS({
  "../../node_modules/rc-animate/lib/AnimateChild.js"(exports2, module2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    var _classCallCheck2 = require_classCallCheck();
    var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
    var _createClass2 = require_createClass();
    var _createClass3 = _interopRequireDefault(_createClass2);
    var _possibleConstructorReturn2 = require_possibleConstructorReturn();
    var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
    var _inherits2 = require_inherits();
    var _inherits3 = _interopRequireDefault(_inherits2);
    var _react = require_react();
    var _react2 = _interopRequireDefault(_react);
    var _reactDom = require_react_dom();
    var _reactDom2 = _interopRequireDefault(_reactDom);
    var _propTypes = require_prop_types();
    var _propTypes2 = _interopRequireDefault(_propTypes);
    var _cssAnimation = require_lib3();
    var _cssAnimation2 = _interopRequireDefault(_cssAnimation);
    var _animate = require_animate();
    var _animate2 = _interopRequireDefault(_animate);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    var transitionMap = {
      enter: "transitionEnter",
      appear: "transitionAppear",
      leave: "transitionLeave"
    };
    var AnimateChild = (function(_React$Component) {
      (0, _inherits3["default"])(AnimateChild2, _React$Component);
      function AnimateChild2() {
        (0, _classCallCheck3["default"])(this, AnimateChild2);
        return (0, _possibleConstructorReturn3["default"])(this, (AnimateChild2.__proto__ || Object.getPrototypeOf(AnimateChild2)).apply(this, arguments));
      }
      (0, _createClass3["default"])(AnimateChild2, [{
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this.stop();
        }
      }, {
        key: "componentWillEnter",
        value: function componentWillEnter(done) {
          if (_animate2["default"].isEnterSupported(this.props)) {
            this.transition("enter", done);
          } else {
            done();
          }
        }
      }, {
        key: "componentWillAppear",
        value: function componentWillAppear(done) {
          if (_animate2["default"].isAppearSupported(this.props)) {
            this.transition("appear", done);
          } else {
            done();
          }
        }
      }, {
        key: "componentWillLeave",
        value: function componentWillLeave(done) {
          if (_animate2["default"].isLeaveSupported(this.props)) {
            this.transition("leave", done);
          } else {
            done();
          }
        }
      }, {
        key: "transition",
        value: function transition(animationType, finishCallback) {
          var _this2 = this;
          var node2 = _reactDom2["default"].findDOMNode(this);
          var props = this.props;
          var transitionName = props.transitionName;
          var nameIsObj = typeof transitionName === "object";
          this.stop();
          var end = function end2() {
            _this2.stopper = null;
            finishCallback();
          };
          if ((_cssAnimation.isCssAnimationSupported || !props.animation[animationType]) && transitionName && props[transitionMap[animationType]]) {
            var name = nameIsObj ? transitionName[animationType] : transitionName + "-" + animationType;
            var activeName = name + "-active";
            if (nameIsObj && transitionName[animationType + "Active"]) {
              activeName = transitionName[animationType + "Active"];
            }
            this.stopper = (0, _cssAnimation2["default"])(node2, {
              name,
              active: activeName
            }, end);
          } else {
            this.stopper = props.animation[animationType](node2, end);
          }
        }
      }, {
        key: "stop",
        value: function stop() {
          var stopper = this.stopper;
          if (stopper) {
            this.stopper = null;
            stopper.stop();
          }
        }
      }, {
        key: "render",
        value: function render4() {
          return this.props.children;
        }
      }]);
      return AnimateChild2;
    })(_react2["default"].Component);
    AnimateChild.propTypes = {
      children: _propTypes2["default"].any,
      animation: _propTypes2["default"].any,
      transitionName: _propTypes2["default"].any
    };
    exports2["default"] = AnimateChild;
    module2.exports = exports2["default"];
  }
});

// ../../node_modules/rc-animate/lib/Animate.js
var require_Animate = __commonJS({
  "../../node_modules/rc-animate/lib/Animate.js"(exports2, module2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    var _extends22 = require_extends();
    var _extends3 = _interopRequireDefault(_extends22);
    var _defineProperty22 = require_defineProperty2();
    var _defineProperty32 = _interopRequireDefault(_defineProperty22);
    var _classCallCheck2 = require_classCallCheck();
    var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
    var _createClass2 = require_createClass();
    var _createClass3 = _interopRequireDefault(_createClass2);
    var _possibleConstructorReturn2 = require_possibleConstructorReturn();
    var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
    var _inherits2 = require_inherits();
    var _inherits3 = _interopRequireDefault(_inherits2);
    var _react = require_react();
    var _react2 = _interopRequireDefault(_react);
    var _propTypes = require_prop_types();
    var _propTypes2 = _interopRequireDefault(_propTypes);
    var _unsafeLifecyclesPolyfill = require_unsafeLifecyclesPolyfill();
    var _unsafeLifecyclesPolyfill2 = _interopRequireDefault(_unsafeLifecyclesPolyfill);
    var _ChildrenUtils = require_ChildrenUtils();
    var _AnimateChild = require_AnimateChild();
    var _AnimateChild2 = _interopRequireDefault(_AnimateChild);
    var _animate = require_animate();
    var _animate2 = _interopRequireDefault(_animate);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    var defaultKey = "rc_animate_" + Date.now();
    function getChildrenFromProps(props) {
      var children = props.children;
      if (_react2["default"].isValidElement(children)) {
        if (!children.key) {
          return _react2["default"].cloneElement(children, {
            key: defaultKey
          });
        }
      }
      return children;
    }
    function noop7() {
    }
    var Animate = (function(_React$Component) {
      (0, _inherits3["default"])(Animate2, _React$Component);
      function Animate2(props) {
        (0, _classCallCheck3["default"])(this, Animate2);
        var _this = (0, _possibleConstructorReturn3["default"])(this, (Animate2.__proto__ || Object.getPrototypeOf(Animate2)).call(this, props));
        _initialiseProps.call(_this);
        _this.currentlyAnimatingKeys = {};
        _this.keysToEnter = [];
        _this.keysToLeave = [];
        _this.state = {
          children: (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(props))
        };
        _this.childrenRefs = {};
        return _this;
      }
      (0, _createClass3["default"])(Animate2, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          var _this2 = this;
          var showProp = this.props.showProp;
          var children = this.state.children;
          if (showProp) {
            children = children.filter(function(child) {
              return !!child.props[showProp];
            });
          }
          children.forEach(function(child) {
            if (child) {
              _this2.performAppear(child.key);
            }
          });
        }
      }, {
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps) {
          var _this3 = this;
          this.nextProps = nextProps;
          var nextChildren = (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(nextProps));
          var props = this.props;
          if (props.exclusive) {
            Object.keys(this.currentlyAnimatingKeys).forEach(function(key2) {
              _this3.stop(key2);
            });
          }
          var showProp = props.showProp;
          var currentlyAnimatingKeys = this.currentlyAnimatingKeys;
          var currentChildren = props.exclusive ? (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(props)) : this.state.children;
          var newChildren = [];
          if (showProp) {
            currentChildren.forEach(function(currentChild) {
              var nextChild = currentChild && (0, _ChildrenUtils.findChildInChildrenByKey)(nextChildren, currentChild.key);
              var newChild = void 0;
              if ((!nextChild || !nextChild.props[showProp]) && currentChild.props[showProp]) {
                newChild = _react2["default"].cloneElement(nextChild || currentChild, (0, _defineProperty32["default"])({}, showProp, true));
              } else {
                newChild = nextChild;
              }
              if (newChild) {
                newChildren.push(newChild);
              }
            });
            nextChildren.forEach(function(nextChild) {
              if (!nextChild || !(0, _ChildrenUtils.findChildInChildrenByKey)(currentChildren, nextChild.key)) {
                newChildren.push(nextChild);
              }
            });
          } else {
            newChildren = (0, _ChildrenUtils.mergeChildren)(currentChildren, nextChildren);
          }
          this.setState({
            children: newChildren
          });
          nextChildren.forEach(function(child) {
            var key2 = child && child.key;
            if (child && currentlyAnimatingKeys[key2]) {
              return;
            }
            var hasPrev = child && (0, _ChildrenUtils.findChildInChildrenByKey)(currentChildren, key2);
            if (showProp) {
              var showInNext = child.props[showProp];
              if (hasPrev) {
                var showInNow = (0, _ChildrenUtils.findShownChildInChildrenByKey)(currentChildren, key2, showProp);
                if (!showInNow && showInNext) {
                  _this3.keysToEnter.push(key2);
                }
              } else if (showInNext) {
                _this3.keysToEnter.push(key2);
              }
            } else if (!hasPrev) {
              _this3.keysToEnter.push(key2);
            }
          });
          currentChildren.forEach(function(child) {
            var key2 = child && child.key;
            if (child && currentlyAnimatingKeys[key2]) {
              return;
            }
            var hasNext = child && (0, _ChildrenUtils.findChildInChildrenByKey)(nextChildren, key2);
            if (showProp) {
              var showInNow = child.props[showProp];
              if (hasNext) {
                var showInNext = (0, _ChildrenUtils.findShownChildInChildrenByKey)(nextChildren, key2, showProp);
                if (!showInNext && showInNow) {
                  _this3.keysToLeave.push(key2);
                }
              } else if (showInNow) {
                _this3.keysToLeave.push(key2);
              }
            } else if (!hasNext) {
              _this3.keysToLeave.push(key2);
            }
          });
        }
      }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate() {
          var keysToEnter = this.keysToEnter;
          this.keysToEnter = [];
          keysToEnter.forEach(this.performEnter);
          var keysToLeave = this.keysToLeave;
          this.keysToLeave = [];
          keysToLeave.forEach(this.performLeave);
        }
      }, {
        key: "isValidChildByKey",
        value: function isValidChildByKey(currentChildren, key2) {
          var showProp = this.props.showProp;
          if (showProp) {
            return (0, _ChildrenUtils.findShownChildInChildrenByKey)(currentChildren, key2, showProp);
          }
          return (0, _ChildrenUtils.findChildInChildrenByKey)(currentChildren, key2);
        }
      }, {
        key: "stop",
        value: function stop(key2) {
          delete this.currentlyAnimatingKeys[key2];
          var component = this.childrenRefs[key2];
          if (component) {
            component.stop();
          }
        }
      }, {
        key: "render",
        value: function render4() {
          var _this4 = this;
          var props = this.props;
          this.nextProps = props;
          var stateChildren = this.state.children;
          var children = null;
          if (stateChildren) {
            children = stateChildren.map(function(child) {
              if (child === null || child === void 0) {
                return child;
              }
              if (!child.key) {
                throw new Error("must set key for <rc-animate> children");
              }
              return _react2["default"].createElement(
                _AnimateChild2["default"],
                {
                  key: child.key,
                  ref: function ref3(node2) {
                    _this4.childrenRefs[child.key] = node2;
                  },
                  animation: props.animation,
                  transitionName: props.transitionName,
                  transitionEnter: props.transitionEnter,
                  transitionAppear: props.transitionAppear,
                  transitionLeave: props.transitionLeave
                },
                child
              );
            });
          }
          var Component10 = props.component;
          if (Component10) {
            var passedProps = props;
            if (typeof Component10 === "string") {
              passedProps = (0, _extends3["default"])({
                className: props.className,
                style: props.style
              }, props.componentProps);
            }
            return _react2["default"].createElement(
              Component10,
              passedProps,
              children
            );
          }
          return children[0] || null;
        }
      }]);
      return Animate2;
    })(_react2["default"].Component);
    Animate.isAnimate = true;
    Animate.propTypes = {
      className: _propTypes2["default"].string,
      style: _propTypes2["default"].object,
      component: _propTypes2["default"].any,
      componentProps: _propTypes2["default"].object,
      animation: _propTypes2["default"].object,
      transitionName: _propTypes2["default"].oneOfType([_propTypes2["default"].string, _propTypes2["default"].object]),
      transitionEnter: _propTypes2["default"].bool,
      transitionAppear: _propTypes2["default"].bool,
      exclusive: _propTypes2["default"].bool,
      transitionLeave: _propTypes2["default"].bool,
      onEnd: _propTypes2["default"].func,
      onEnter: _propTypes2["default"].func,
      onLeave: _propTypes2["default"].func,
      onAppear: _propTypes2["default"].func,
      showProp: _propTypes2["default"].string,
      children: _propTypes2["default"].node
    };
    Animate.defaultProps = {
      animation: {},
      component: "span",
      componentProps: {},
      transitionEnter: true,
      transitionLeave: true,
      transitionAppear: false,
      onEnd: noop7,
      onEnter: noop7,
      onLeave: noop7,
      onAppear: noop7
    };
    var _initialiseProps = function _initialiseProps2() {
      var _this5 = this;
      this.performEnter = function(key2) {
        if (_this5.childrenRefs[key2]) {
          _this5.currentlyAnimatingKeys[key2] = true;
          _this5.childrenRefs[key2].componentWillEnter(_this5.handleDoneAdding.bind(_this5, key2, "enter"));
        }
      };
      this.performAppear = function(key2) {
        if (_this5.childrenRefs[key2]) {
          _this5.currentlyAnimatingKeys[key2] = true;
          _this5.childrenRefs[key2].componentWillAppear(_this5.handleDoneAdding.bind(_this5, key2, "appear"));
        }
      };
      this.handleDoneAdding = function(key2, type5) {
        var props = _this5.props;
        delete _this5.currentlyAnimatingKeys[key2];
        if (props.exclusive && props !== _this5.nextProps) {
          return;
        }
        var currentChildren = (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(props));
        if (!_this5.isValidChildByKey(currentChildren, key2)) {
          _this5.performLeave(key2);
        } else if (type5 === "appear") {
          if (_animate2["default"].allowAppearCallback(props)) {
            props.onAppear(key2);
            props.onEnd(key2, true);
          }
        } else if (_animate2["default"].allowEnterCallback(props)) {
          props.onEnter(key2);
          props.onEnd(key2, true);
        }
      };
      this.performLeave = function(key2) {
        if (_this5.childrenRefs[key2]) {
          _this5.currentlyAnimatingKeys[key2] = true;
          _this5.childrenRefs[key2].componentWillLeave(_this5.handleDoneLeaving.bind(_this5, key2));
        }
      };
      this.handleDoneLeaving = function(key2) {
        var props = _this5.props;
        delete _this5.currentlyAnimatingKeys[key2];
        if (props.exclusive && props !== _this5.nextProps) {
          return;
        }
        var currentChildren = (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(props));
        if (_this5.isValidChildByKey(currentChildren, key2)) {
          _this5.performEnter(key2);
        } else {
          var end = function end2() {
            if (_animate2["default"].allowLeaveCallback(props)) {
              props.onLeave(key2);
              props.onEnd(key2, false);
            }
          };
          if (!(0, _ChildrenUtils.isSameChildren)(_this5.state.children, currentChildren, props.showProp)) {
            _this5.setState({
              children: currentChildren
            }, end);
          } else {
            end();
          }
        }
      };
    };
    exports2["default"] = (0, _unsafeLifecyclesPolyfill2["default"])(Animate);
    module2.exports = exports2["default"];
  }
});

// ../../node_modules/babel-runtime/helpers/objectWithoutProperties.js
var require_objectWithoutProperties = __commonJS({
  "../../node_modules/babel-runtime/helpers/objectWithoutProperties.js"(exports2) {
    "use strict";
    exports2.__esModule = true;
    exports2.default = function(obj, keys4) {
      var target = {};
      for (var i in obj) {
        if (keys4.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
      }
      return target;
    };
  }
});

// ../../node_modules/rc-trigger/lib/LazyRenderBox.js
var require_LazyRenderBox = __commonJS({
  "../../node_modules/rc-trigger/lib/LazyRenderBox.js"(exports2, module2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    var _objectWithoutProperties22 = require_objectWithoutProperties();
    var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties22);
    var _classCallCheck2 = require_classCallCheck();
    var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
    var _createClass2 = require_createClass();
    var _createClass3 = _interopRequireDefault(_createClass2);
    var _possibleConstructorReturn2 = require_possibleConstructorReturn();
    var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
    var _inherits2 = require_inherits();
    var _inherits3 = _interopRequireDefault(_inherits2);
    var _react = require_react();
    var _react2 = _interopRequireDefault(_react);
    var _propTypes = require_prop_types();
    var _propTypes2 = _interopRequireDefault(_propTypes);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    var LazyRenderBox = (function(_Component) {
      (0, _inherits3["default"])(LazyRenderBox2, _Component);
      function LazyRenderBox2() {
        (0, _classCallCheck3["default"])(this, LazyRenderBox2);
        return (0, _possibleConstructorReturn3["default"])(this, (LazyRenderBox2.__proto__ || Object.getPrototypeOf(LazyRenderBox2)).apply(this, arguments));
      }
      (0, _createClass3["default"])(LazyRenderBox2, [{
        key: "shouldComponentUpdate",
        value: function shouldComponentUpdate(nextProps) {
          return nextProps.hiddenClassName || nextProps.visible;
        }
      }, {
        key: "render",
        value: function render4() {
          var _props = this.props, hiddenClassName = _props.hiddenClassName, visible = _props.visible, props = (0, _objectWithoutProperties3["default"])(_props, ["hiddenClassName", "visible"]);
          if (hiddenClassName || _react2["default"].Children.count(props.children) > 1) {
            if (!visible && hiddenClassName) {
              props.className += " " + hiddenClassName;
            }
            return _react2["default"].createElement("div", props);
          }
          return _react2["default"].Children.only(props.children);
        }
      }]);
      return LazyRenderBox2;
    })(_react.Component);
    LazyRenderBox.propTypes = {
      children: _propTypes2["default"].any,
      className: _propTypes2["default"].string,
      visible: _propTypes2["default"].bool,
      hiddenClassName: _propTypes2["default"].string
    };
    exports2["default"] = LazyRenderBox;
    module2.exports = exports2["default"];
  }
});

// ../../node_modules/rc-trigger/lib/PopupInner.js
var require_PopupInner = __commonJS({
  "../../node_modules/rc-trigger/lib/PopupInner.js"(exports2, module2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    var _classCallCheck2 = require_classCallCheck();
    var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
    var _createClass2 = require_createClass();
    var _createClass3 = _interopRequireDefault(_createClass2);
    var _possibleConstructorReturn2 = require_possibleConstructorReturn();
    var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
    var _inherits2 = require_inherits();
    var _inherits3 = _interopRequireDefault(_inherits2);
    var _react = require_react();
    var _react2 = _interopRequireDefault(_react);
    var _propTypes = require_prop_types();
    var _propTypes2 = _interopRequireDefault(_propTypes);
    var _LazyRenderBox = require_LazyRenderBox();
    var _LazyRenderBox2 = _interopRequireDefault(_LazyRenderBox);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    var PopupInner = (function(_Component) {
      (0, _inherits3["default"])(PopupInner2, _Component);
      function PopupInner2() {
        (0, _classCallCheck3["default"])(this, PopupInner2);
        return (0, _possibleConstructorReturn3["default"])(this, (PopupInner2.__proto__ || Object.getPrototypeOf(PopupInner2)).apply(this, arguments));
      }
      (0, _createClass3["default"])(PopupInner2, [{
        key: "render",
        value: function render4() {
          var props = this.props;
          var className2 = props.className;
          if (!props.visible) {
            className2 += " " + props.hiddenClassName;
          }
          return _react2["default"].createElement(
            "div",
            {
              className: className2,
              onMouseEnter: props.onMouseEnter,
              onMouseLeave: props.onMouseLeave,
              style: props.style
            },
            _react2["default"].createElement(
              _LazyRenderBox2["default"],
              { className: props.prefixCls + "-content", visible: props.visible },
              props.children
            )
          );
        }
      }]);
      return PopupInner2;
    })(_react.Component);
    PopupInner.propTypes = {
      hiddenClassName: _propTypes2["default"].string,
      className: _propTypes2["default"].string,
      prefixCls: _propTypes2["default"].string,
      onMouseEnter: _propTypes2["default"].func,
      onMouseLeave: _propTypes2["default"].func,
      children: _propTypes2["default"].any
    };
    exports2["default"] = PopupInner;
    module2.exports = exports2["default"];
  }
});

// ../../node_modules/rc-trigger/lib/utils.js
var require_utils = __commonJS({
  "../../node_modules/rc-trigger/lib/utils.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    var _extends22 = require_extends();
    var _extends3 = _interopRequireDefault(_extends22);
    exports2.getAlignFromPlacement = getAlignFromPlacement;
    exports2.getPopupClassNameFromAlign = getPopupClassNameFromAlign;
    exports2.saveRef = saveRef;
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    function isPointsEq2(a1, a2) {
      return a1[0] === a2[0] && a1[1] === a2[1];
    }
    function getAlignFromPlacement(builtinPlacements, placementStr, align) {
      var baseAlign = builtinPlacements[placementStr] || {};
      return (0, _extends3["default"])({}, baseAlign, align);
    }
    function getPopupClassNameFromAlign(builtinPlacements, prefixCls, align) {
      var points = align.points;
      for (var placement in builtinPlacements) {
        if (builtinPlacements.hasOwnProperty(placement)) {
          if (isPointsEq2(builtinPlacements[placement].points, points)) {
            return prefixCls + "-placement-" + placement;
          }
        }
      }
      return "";
    }
    function saveRef(name, component) {
      this[name] = component;
    }
  }
});

// ../../node_modules/rc-trigger/lib/Popup.js
var require_Popup = __commonJS({
  "../../node_modules/rc-trigger/lib/Popup.js"(exports2, module2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    var _extends22 = require_extends();
    var _extends3 = _interopRequireDefault(_extends22);
    var _classCallCheck2 = require_classCallCheck();
    var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
    var _createClass2 = require_createClass();
    var _createClass3 = _interopRequireDefault(_createClass2);
    var _possibleConstructorReturn2 = require_possibleConstructorReturn();
    var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
    var _inherits2 = require_inherits();
    var _inherits3 = _interopRequireDefault(_inherits2);
    var _react = require_react();
    var _react2 = _interopRequireDefault(_react);
    var _propTypes = require_prop_types();
    var _propTypes2 = _interopRequireDefault(_propTypes);
    var _reactDom = require_react_dom();
    var _reactDom2 = _interopRequireDefault(_reactDom);
    var _rcAlign = require_lib2();
    var _rcAlign2 = _interopRequireDefault(_rcAlign);
    var _rcAnimate = require_Animate();
    var _rcAnimate2 = _interopRequireDefault(_rcAnimate);
    var _PopupInner = require_PopupInner();
    var _PopupInner2 = _interopRequireDefault(_PopupInner);
    var _LazyRenderBox = require_LazyRenderBox();
    var _LazyRenderBox2 = _interopRequireDefault(_LazyRenderBox);
    var _utils = require_utils();
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    var Popup4 = (function(_Component) {
      (0, _inherits3["default"])(Popup5, _Component);
      function Popup5(props) {
        (0, _classCallCheck3["default"])(this, Popup5);
        var _this = (0, _possibleConstructorReturn3["default"])(this, (Popup5.__proto__ || Object.getPrototypeOf(Popup5)).call(this, props));
        _initialiseProps.call(_this);
        _this.savePopupRef = _utils.saveRef.bind(_this, "popupInstance");
        _this.saveAlignRef = _utils.saveRef.bind(_this, "alignInstance");
        return _this;
      }
      (0, _createClass3["default"])(Popup5, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          this.rootNode = this.getPopupDomNode();
        }
      }, {
        key: "getPopupDomNode",
        value: function getPopupDomNode() {
          return _reactDom2["default"].findDOMNode(this.popupInstance);
        }
      }, {
        key: "getMaskTransitionName",
        value: function getMaskTransitionName() {
          var props = this.props;
          var transitionName = props.maskTransitionName;
          var animation = props.maskAnimation;
          if (!transitionName && animation) {
            transitionName = props.prefixCls + "-" + animation;
          }
          return transitionName;
        }
      }, {
        key: "getTransitionName",
        value: function getTransitionName3() {
          var props = this.props;
          var transitionName = props.transitionName;
          if (!transitionName && props.animation) {
            transitionName = props.prefixCls + "-" + props.animation;
          }
          return transitionName;
        }
      }, {
        key: "getClassName",
        value: function getClassName(currentAlignClassName) {
          return this.props.prefixCls + " " + this.props.className + " " + currentAlignClassName;
        }
      }, {
        key: "getPopupElement",
        value: function getPopupElement() {
          var savePopupRef = this.savePopupRef, props = this.props;
          var align = props.align, style2 = props.style, visible = props.visible, prefixCls = props.prefixCls, destroyPopupOnHide = props.destroyPopupOnHide;
          var className2 = this.getClassName(this.currentAlignClassName || props.getClassNameFromAlign(align));
          var hiddenClassName = prefixCls + "-hidden";
          if (!visible) {
            this.currentAlignClassName = null;
          }
          var newStyle = (0, _extends3["default"])({}, style2, this.getZIndexStyle());
          var popupInnerProps = {
            className: className2,
            prefixCls,
            ref: savePopupRef,
            onMouseEnter: props.onMouseEnter,
            onMouseLeave: props.onMouseLeave,
            style: newStyle
          };
          if (destroyPopupOnHide) {
            return _react2["default"].createElement(
              _rcAnimate2["default"],
              {
                component: "",
                exclusive: true,
                transitionAppear: true,
                transitionName: this.getTransitionName()
              },
              visible ? _react2["default"].createElement(
                _rcAlign2["default"],
                {
                  target: this.getTarget,
                  key: "popup",
                  ref: this.saveAlignRef,
                  monitorWindowResize: true,
                  align,
                  onAlign: this.onAlign
                },
                _react2["default"].createElement(
                  _PopupInner2["default"],
                  (0, _extends3["default"])({
                    visible: true
                  }, popupInnerProps),
                  props.children
                )
              ) : null
            );
          }
          return _react2["default"].createElement(
            _rcAnimate2["default"],
            {
              component: "",
              exclusive: true,
              transitionAppear: true,
              transitionName: this.getTransitionName(),
              showProp: "xVisible"
            },
            _react2["default"].createElement(
              _rcAlign2["default"],
              {
                target: this.getTarget,
                key: "popup",
                ref: this.saveAlignRef,
                monitorWindowResize: true,
                xVisible: visible,
                childrenProps: { visible: "xVisible" },
                disabled: !visible,
                align,
                onAlign: this.onAlign
              },
              _react2["default"].createElement(
                _PopupInner2["default"],
                (0, _extends3["default"])({
                  hiddenClassName
                }, popupInnerProps),
                props.children
              )
            )
          );
        }
      }, {
        key: "getZIndexStyle",
        value: function getZIndexStyle() {
          var style2 = {};
          var props = this.props;
          if (props.zIndex !== void 0) {
            style2.zIndex = props.zIndex;
          }
          return style2;
        }
      }, {
        key: "getMaskElement",
        value: function getMaskElement() {
          var props = this.props;
          var maskElement = void 0;
          if (props.mask) {
            var maskTransition = this.getMaskTransitionName();
            maskElement = _react2["default"].createElement(_LazyRenderBox2["default"], {
              style: this.getZIndexStyle(),
              key: "mask",
              className: props.prefixCls + "-mask",
              hiddenClassName: props.prefixCls + "-mask-hidden",
              visible: props.visible
            });
            if (maskTransition) {
              maskElement = _react2["default"].createElement(
                _rcAnimate2["default"],
                {
                  key: "mask",
                  showProp: "visible",
                  transitionAppear: true,
                  component: "",
                  transitionName: maskTransition
                },
                maskElement
              );
            }
          }
          return maskElement;
        }
      }, {
        key: "render",
        value: function render4() {
          return _react2["default"].createElement(
            "div",
            null,
            this.getMaskElement(),
            this.getPopupElement()
          );
        }
      }]);
      return Popup5;
    })(_react.Component);
    Popup4.propTypes = {
      visible: _propTypes2["default"].bool,
      style: _propTypes2["default"].object,
      getClassNameFromAlign: _propTypes2["default"].func,
      onAlign: _propTypes2["default"].func,
      getRootDomNode: _propTypes2["default"].func,
      onMouseEnter: _propTypes2["default"].func,
      align: _propTypes2["default"].any,
      destroyPopupOnHide: _propTypes2["default"].bool,
      className: _propTypes2["default"].string,
      prefixCls: _propTypes2["default"].string,
      onMouseLeave: _propTypes2["default"].func
    };
    var _initialiseProps = function _initialiseProps2() {
      var _this2 = this;
      this.onAlign = function(popupDomNode, align) {
        var props = _this2.props;
        var currentAlignClassName = props.getClassNameFromAlign(align);
        if (_this2.currentAlignClassName !== currentAlignClassName) {
          _this2.currentAlignClassName = currentAlignClassName;
          popupDomNode.className = _this2.getClassName(currentAlignClassName);
        }
        props.onAlign(popupDomNode, align);
      };
      this.getTarget = function() {
        return _this2.props.getRootDomNode();
      };
    };
    exports2["default"] = Popup4;
    module2.exports = exports2["default"];
  }
});

// ../../node_modules/rc-trigger/node_modules/rc-util/lib/getContainerRenderMixin.js
var require_getContainerRenderMixin = __commonJS({
  "../../node_modules/rc-trigger/node_modules/rc-util/lib/getContainerRenderMixin.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = getContainerRenderMixin;
    var _reactDom = _interopRequireDefault(require_react_dom());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { default: obj };
    }
    function ownKeys3(object4, enumerableOnly) {
      var keys4 = Object.keys(object4);
      if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object4);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
          return Object.getOwnPropertyDescriptor(object4, sym).enumerable;
        });
        keys4.push.apply(keys4, symbols);
      }
      return keys4;
    }
    function _objectSpread3(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) {
          ownKeys3(Object(source), true).forEach(function(key2) {
            _defineProperty11(target, key2, source[key2]);
          });
        } else if (Object.getOwnPropertyDescriptors) {
          Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        } else {
          ownKeys3(Object(source)).forEach(function(key2) {
            Object.defineProperty(target, key2, Object.getOwnPropertyDescriptor(source, key2));
          });
        }
      }
      return target;
    }
    function _defineProperty11(obj, key2, value) {
      if (key2 in obj) {
        Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
      } else {
        obj[key2] = value;
      }
      return obj;
    }
    function defaultGetContainer3() {
      var container = document.createElement("div");
      document.body.appendChild(container);
      return container;
    }
    function getContainerRenderMixin(config) {
      var _config$autoMount = config.autoMount, autoMount = _config$autoMount === void 0 ? true : _config$autoMount, _config$autoDestroy = config.autoDestroy, autoDestroy = _config$autoDestroy === void 0 ? true : _config$autoDestroy, isVisible = config.isVisible, isForceRender = config.isForceRender, getComponent = config.getComponent, _config$getContainer = config.getContainer, getContainer2 = _config$getContainer === void 0 ? defaultGetContainer3 : _config$getContainer;
      var mixin;
      function _renderComponent(instance, componentArg, ready) {
        if (!isVisible || instance._component || isVisible(instance) || isForceRender && isForceRender(instance)) {
          if (!instance._container) {
            instance._container = getContainer2(instance);
          }
          var component;
          if (instance.getComponent) {
            component = instance.getComponent(componentArg);
          } else {
            component = getComponent(instance, componentArg);
          }
          _reactDom.default.unstable_renderSubtreeIntoContainer(instance, component, instance._container, function callback() {
            instance._component = this;
            if (ready) {
              ready.call(this);
            }
          });
        }
      }
      if (autoMount) {
        mixin = _objectSpread3(_objectSpread3({}, mixin), {}, {
          componentDidMount: function componentDidMount() {
            _renderComponent(this);
          },
          componentDidUpdate: function componentDidUpdate() {
            _renderComponent(this);
          }
        });
      }
      if (!autoMount || !autoDestroy) {
        mixin = _objectSpread3(_objectSpread3({}, mixin), {}, {
          renderComponent: function renderComponent(componentArg, ready) {
            _renderComponent(this, componentArg, ready);
          }
        });
      }
      function _removeContainer(instance) {
        if (instance._container) {
          var container = instance._container;
          _reactDom.default.unmountComponentAtNode(container);
          container.parentNode.removeChild(container);
          instance._container = null;
        }
      }
      if (autoDestroy) {
        mixin = _objectSpread3(_objectSpread3({}, mixin), {}, {
          componentWillUnmount: function componentWillUnmount() {
            _removeContainer(this);
          }
        });
      } else {
        mixin = _objectSpread3(_objectSpread3({}, mixin), {}, {
          removeContainer: function removeContainer() {
            _removeContainer(this);
          }
        });
      }
      return mixin;
    }
  }
});

// ../../node_modules/rc-trigger/lib/index.js
var require_lib4 = __commonJS({
  "../../node_modules/rc-trigger/lib/index.js"(exports2, module2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    var _extends22 = require_extends();
    var _extends3 = _interopRequireDefault(_extends22);
    var _react = require_react();
    var _react2 = _interopRequireDefault(_react);
    var _propTypes = require_prop_types();
    var _propTypes2 = _interopRequireDefault(_propTypes);
    var _reactDom = require_react_dom();
    var _createReactClass = require_create_react_class();
    var _createReactClass2 = _interopRequireDefault(_createReactClass);
    var _contains = require_contains();
    var _contains2 = _interopRequireDefault(_contains);
    var _addEventListener = require_addEventListener();
    var _addEventListener2 = _interopRequireDefault(_addEventListener);
    var _Popup = require_Popup();
    var _Popup2 = _interopRequireDefault(_Popup);
    var _utils = require_utils();
    var _getContainerRenderMixin = require_getContainerRenderMixin();
    var _getContainerRenderMixin2 = _interopRequireDefault(_getContainerRenderMixin);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    function noop7() {
    }
    function returnEmptyString() {
      return "";
    }
    function returnDocument() {
      return window.document;
    }
    var isMobile = typeof navigator !== "undefined" && !!navigator.userAgent.match(/(Android|iPhone|iPad|iPod|iOS|UCWEB)/i);
    var ALL_HANDLERS = ["onClick", "onMouseDown", "onTouchStart", "onMouseEnter", "onMouseLeave", "onFocus", "onBlur"];
    var Trigger = (0, _createReactClass2["default"])({
      displayName: "Trigger",
      propTypes: {
        children: _propTypes2["default"].any,
        action: _propTypes2["default"].oneOfType([_propTypes2["default"].string, _propTypes2["default"].arrayOf(_propTypes2["default"].string)]),
        showAction: _propTypes2["default"].any,
        hideAction: _propTypes2["default"].any,
        getPopupClassNameFromAlign: _propTypes2["default"].any,
        onPopupVisibleChange: _propTypes2["default"].func,
        afterPopupVisibleChange: _propTypes2["default"].func,
        popup: _propTypes2["default"].oneOfType([_propTypes2["default"].node, _propTypes2["default"].func]).isRequired,
        popupStyle: _propTypes2["default"].object,
        prefixCls: _propTypes2["default"].string,
        popupClassName: _propTypes2["default"].string,
        popupPlacement: _propTypes2["default"].string,
        builtinPlacements: _propTypes2["default"].object,
        popupTransitionName: _propTypes2["default"].oneOfType([_propTypes2["default"].string, _propTypes2["default"].object]),
        popupAnimation: _propTypes2["default"].any,
        mouseEnterDelay: _propTypes2["default"].number,
        mouseLeaveDelay: _propTypes2["default"].number,
        zIndex: _propTypes2["default"].number,
        focusDelay: _propTypes2["default"].number,
        blurDelay: _propTypes2["default"].number,
        getPopupContainer: _propTypes2["default"].func,
        getDocument: _propTypes2["default"].func,
        destroyPopupOnHide: _propTypes2["default"].bool,
        mask: _propTypes2["default"].bool,
        maskClosable: _propTypes2["default"].bool,
        onPopupAlign: _propTypes2["default"].func,
        popupAlign: _propTypes2["default"].object,
        popupVisible: _propTypes2["default"].bool,
        maskTransitionName: _propTypes2["default"].oneOfType([_propTypes2["default"].string, _propTypes2["default"].object]),
        maskAnimation: _propTypes2["default"].string
      },
      mixins: [(0, _getContainerRenderMixin2["default"])({
        autoMount: false,
        isVisible: function isVisible(instance) {
          return instance.state.popupVisible;
        },
        getContainer: function getContainer2(instance) {
          var props = instance.props;
          var popupContainer = document.createElement("div");
          popupContainer.style.position = "absolute";
          popupContainer.style.top = "0";
          popupContainer.style.left = "0";
          popupContainer.style.width = "100%";
          var mountNode = props.getPopupContainer ? props.getPopupContainer((0, _reactDom.findDOMNode)(instance)) : props.getDocument().body;
          mountNode.appendChild(popupContainer);
          return popupContainer;
        }
      })],
      getDefaultProps: function getDefaultProps() {
        return {
          prefixCls: "rc-trigger-popup",
          getPopupClassNameFromAlign: returnEmptyString,
          getDocument: returnDocument,
          onPopupVisibleChange: noop7,
          afterPopupVisibleChange: noop7,
          onPopupAlign: noop7,
          popupClassName: "",
          mouseEnterDelay: 0,
          mouseLeaveDelay: 0.1,
          focusDelay: 0,
          blurDelay: 0.15,
          popupStyle: {},
          destroyPopupOnHide: false,
          popupAlign: {},
          defaultPopupVisible: false,
          mask: false,
          maskClosable: true,
          action: [],
          showAction: [],
          hideAction: []
        };
      },
      getInitialState: function getInitialState2() {
        var props = this.props;
        var popupVisible = void 0;
        if ("popupVisible" in props) {
          popupVisible = !!props.popupVisible;
        } else {
          popupVisible = !!props.defaultPopupVisible;
        }
        return {
          popupVisible
        };
      },
      componentWillMount: function componentWillMount() {
        var _this = this;
        ALL_HANDLERS.forEach(function(h2) {
          _this["fire" + h2] = function(e3) {
            _this.fireEvents(h2, e3);
          };
        });
      },
      componentDidMount: function componentDidMount() {
        this.componentDidUpdate({}, {
          popupVisible: this.state.popupVisible
        });
      },
      componentWillReceiveProps: function componentWillReceiveProps(_ref) {
        var popupVisible = _ref.popupVisible;
        if (popupVisible !== void 0) {
          this.setState({
            popupVisible
          });
        }
      },
      componentDidUpdate: function componentDidUpdate(_, prevState) {
        var props = this.props;
        var state = this.state;
        this.renderComponent(null, function() {
          if (prevState.popupVisible !== state.popupVisible) {
            props.afterPopupVisibleChange(state.popupVisible);
          }
        });
        if (state.popupVisible) {
          var currentDocument = void 0;
          if (!this.clickOutsideHandler && this.isClickToHide()) {
            currentDocument = props.getDocument();
            this.clickOutsideHandler = (0, _addEventListener2["default"])(currentDocument, "mousedown", this.onDocumentClick);
          }
          if (!this.touchOutsideHandler && isMobile) {
            currentDocument = currentDocument || props.getDocument();
            this.touchOutsideHandler = (0, _addEventListener2["default"])(currentDocument, "click", this.onDocumentClick);
          }
          return;
        }
        this.clearOutsideHandler();
      },
      componentWillUnmount: function componentWillUnmount() {
        this.clearDelayTimer();
        this.clearOutsideHandler();
      },
      onMouseEnter: function onMouseEnter(e3) {
        this.fireEvents("onMouseEnter", e3);
        this.delaySetPopupVisible(true, this.props.mouseEnterDelay);
      },
      onMouseLeave: function onMouseLeave(e3) {
        this.fireEvents("onMouseLeave", e3);
        this.delaySetPopupVisible(false, this.props.mouseLeaveDelay);
      },
      onPopupMouseEnter: function onPopupMouseEnter() {
        this.clearDelayTimer();
      },
      onPopupMouseLeave: function onPopupMouseLeave(e3) {
        if (e3.relatedTarget && !e3.relatedTarget.setTimeout && this._component && this._component.getPopupDomNode && (0, _contains2["default"])(this._component.getPopupDomNode(), e3.relatedTarget)) {
          return;
        }
        this.delaySetPopupVisible(false, this.props.mouseLeaveDelay);
      },
      onFocus: function onFocus(e3) {
        this.fireEvents("onFocus", e3);
        this.clearDelayTimer();
        if (this.isFocusToShow()) {
          this.focusTime = Date.now();
          this.delaySetPopupVisible(true, this.props.focusDelay);
        }
      },
      onMouseDown: function onMouseDown(e3) {
        this.fireEvents("onMouseDown", e3);
        this.preClickTime = Date.now();
      },
      onTouchStart: function onTouchStart(e3) {
        this.fireEvents("onTouchStart", e3);
        this.preTouchTime = Date.now();
      },
      onBlur: function onBlur(e3) {
        this.fireEvents("onBlur", e3);
        this.clearDelayTimer();
        if (this.isBlurToHide()) {
          this.delaySetPopupVisible(false, this.props.blurDelay);
        }
      },
      onClick: function onClick(event) {
        this.fireEvents("onClick", event);
        if (this.focusTime) {
          var preTime = void 0;
          if (this.preClickTime && this.preTouchTime) {
            preTime = Math.min(this.preClickTime, this.preTouchTime);
          } else if (this.preClickTime) {
            preTime = this.preClickTime;
          } else if (this.preTouchTime) {
            preTime = this.preTouchTime;
          }
          if (Math.abs(preTime - this.focusTime) < 20) {
            return;
          }
          this.focusTime = 0;
        }
        this.preClickTime = 0;
        this.preTouchTime = 0;
        event.preventDefault();
        var nextVisible = !this.state.popupVisible;
        if (this.isClickToHide() && !nextVisible || nextVisible && this.isClickToShow()) {
          this.setPopupVisible(!this.state.popupVisible);
        }
      },
      onDocumentClick: function onDocumentClick(event) {
        if (this.props.mask && !this.props.maskClosable) {
          return;
        }
        var target = event.target;
        var root2 = (0, _reactDom.findDOMNode)(this);
        var popupNode = this.getPopupDomNode();
        if (!(0, _contains2["default"])(root2, target) && !(0, _contains2["default"])(popupNode, target)) {
          this.close();
        }
      },
      getPopupDomNode: function getPopupDomNode() {
        if (this._component && this._component.getPopupDomNode) {
          return this._component.getPopupDomNode();
        }
        return null;
      },
      getRootDomNode: function getRootDomNode() {
        return (0, _reactDom.findDOMNode)(this);
      },
      getPopupClassNameFromAlign: function getPopupClassNameFromAlign(align) {
        var className2 = [];
        var props = this.props;
        var popupPlacement = props.popupPlacement, builtinPlacements = props.builtinPlacements, prefixCls = props.prefixCls;
        if (popupPlacement && builtinPlacements) {
          className2.push((0, _utils.getPopupClassNameFromAlign)(builtinPlacements, prefixCls, align));
        }
        if (props.getPopupClassNameFromAlign) {
          className2.push(props.getPopupClassNameFromAlign(align));
        }
        return className2.join(" ");
      },
      getPopupAlign: function getPopupAlign() {
        var props = this.props;
        var popupPlacement = props.popupPlacement, popupAlign = props.popupAlign, builtinPlacements = props.builtinPlacements;
        if (popupPlacement && builtinPlacements) {
          return (0, _utils.getAlignFromPlacement)(builtinPlacements, popupPlacement, popupAlign);
        }
        return popupAlign;
      },
      getComponent: function getComponent() {
        var props = this.props, state = this.state;
        var mouseProps = {};
        if (this.isMouseEnterToShow()) {
          mouseProps.onMouseEnter = this.onPopupMouseEnter;
        }
        if (this.isMouseLeaveToHide()) {
          mouseProps.onMouseLeave = this.onPopupMouseLeave;
        }
        return _react2["default"].createElement(
          _Popup2["default"],
          (0, _extends3["default"])({
            prefixCls: props.prefixCls,
            destroyPopupOnHide: props.destroyPopupOnHide,
            visible: state.popupVisible,
            className: props.popupClassName,
            action: props.action,
            align: this.getPopupAlign(),
            onAlign: props.onPopupAlign,
            animation: props.popupAnimation,
            getClassNameFromAlign: this.getPopupClassNameFromAlign
          }, mouseProps, {
            getRootDomNode: this.getRootDomNode,
            style: props.popupStyle,
            mask: props.mask,
            zIndex: props.zIndex,
            transitionName: props.popupTransitionName,
            maskAnimation: props.maskAnimation,
            maskTransitionName: props.maskTransitionName
          }),
          typeof props.popup === "function" ? props.popup() : props.popup
        );
      },
      setPopupVisible: function setPopupVisible(popupVisible) {
        this.clearDelayTimer();
        if (this.state.popupVisible !== popupVisible) {
          if (!("popupVisible" in this.props)) {
            this.setState({
              popupVisible
            });
          }
          this.props.onPopupVisibleChange(popupVisible);
        }
      },
      delaySetPopupVisible: function delaySetPopupVisible(visible, delayS) {
        var _this2 = this;
        var delay = delayS * 1e3;
        this.clearDelayTimer();
        if (delay) {
          this.delayTimer = setTimeout(function() {
            _this2.setPopupVisible(visible);
            _this2.clearDelayTimer();
          }, delay);
        } else {
          this.setPopupVisible(visible);
        }
      },
      clearDelayTimer: function clearDelayTimer() {
        if (this.delayTimer) {
          clearTimeout(this.delayTimer);
          this.delayTimer = null;
        }
      },
      clearOutsideHandler: function clearOutsideHandler() {
        if (this.clickOutsideHandler) {
          this.clickOutsideHandler.remove();
          this.clickOutsideHandler = null;
        }
        if (this.touchOutsideHandler) {
          this.touchOutsideHandler.remove();
          this.touchOutsideHandler = null;
        }
      },
      createTwoChains: function createTwoChains(event) {
        var childPros = this.props.children.props;
        var props = this.props;
        if (childPros[event] && props[event]) {
          return this["fire" + event];
        }
        return childPros[event] || props[event];
      },
      isClickToShow: function isClickToShow() {
        var _props = this.props, action = _props.action, showAction = _props.showAction;
        return action.indexOf("click") !== -1 || showAction.indexOf("click") !== -1;
      },
      isClickToHide: function isClickToHide() {
        var _props2 = this.props, action = _props2.action, hideAction = _props2.hideAction;
        return action.indexOf("click") !== -1 || hideAction.indexOf("click") !== -1;
      },
      isMouseEnterToShow: function isMouseEnterToShow() {
        var _props3 = this.props, action = _props3.action, showAction = _props3.showAction;
        return action.indexOf("hover") !== -1 || showAction.indexOf("mouseEnter") !== -1;
      },
      isMouseLeaveToHide: function isMouseLeaveToHide() {
        var _props4 = this.props, action = _props4.action, hideAction = _props4.hideAction;
        return action.indexOf("hover") !== -1 || hideAction.indexOf("mouseLeave") !== -1;
      },
      isFocusToShow: function isFocusToShow() {
        var _props5 = this.props, action = _props5.action, showAction = _props5.showAction;
        return action.indexOf("focus") !== -1 || showAction.indexOf("focus") !== -1;
      },
      isBlurToHide: function isBlurToHide() {
        var _props6 = this.props, action = _props6.action, hideAction = _props6.hideAction;
        return action.indexOf("focus") !== -1 || hideAction.indexOf("blur") !== -1;
      },
      forcePopupAlign: function forcePopupAlign() {
        if (this.state.popupVisible && this._component && this._component.alignInstance) {
          this._component.alignInstance.forceAlign();
        }
      },
      fireEvents: function fireEvents(type5, e3) {
        var childCallback = this.props.children.props[type5];
        if (childCallback) {
          childCallback(e3);
        }
        var callback = this.props[type5];
        if (callback) {
          callback(e3);
        }
      },
      close: function close() {
        this.setPopupVisible(false);
      },
      render: function render4() {
        var props = this.props;
        var children = props.children;
        var child = _react2["default"].Children.only(children);
        var newChildProps = {};
        if (this.isClickToHide() || this.isClickToShow()) {
          newChildProps.onClick = this.onClick;
          newChildProps.onMouseDown = this.onMouseDown;
          newChildProps.onTouchStart = this.onTouchStart;
        } else {
          newChildProps.onClick = this.createTwoChains("onClick");
          newChildProps.onMouseDown = this.createTwoChains("onMouseDown");
          newChildProps.onTouchStart = this.createTwoChains("onTouchStart");
        }
        if (this.isMouseEnterToShow()) {
          newChildProps.onMouseEnter = this.onMouseEnter;
        } else {
          newChildProps.onMouseEnter = this.createTwoChains("onMouseEnter");
        }
        if (this.isMouseLeaveToHide()) {
          newChildProps.onMouseLeave = this.onMouseLeave;
        } else {
          newChildProps.onMouseLeave = this.createTwoChains("onMouseLeave");
        }
        if (this.isFocusToShow() || this.isBlurToHide()) {
          newChildProps.onFocus = this.onFocus;
          newChildProps.onBlur = this.onBlur;
        } else {
          newChildProps.onFocus = this.createTwoChains("onFocus");
          newChildProps.onBlur = this.createTwoChains("onBlur");
        }
        return _react2["default"].cloneElement(child, newChildProps);
      }
    });
    exports2["default"] = Trigger;
    module2.exports = exports2["default"];
  }
});

// ../../node_modules/tinycolor2/cjs/tinycolor.js
var require_tinycolor = __commonJS({
  "../../node_modules/tinycolor2/cjs/tinycolor.js"(exports2, module2) {
    (function(global2, factory) {
      typeof exports2 === "object" && typeof module2 !== "undefined" ? module2.exports = factory() : typeof define === "function" && define.amd ? define(factory) : (global2 = typeof globalThis !== "undefined" ? globalThis : global2 || self, global2.tinycolor = factory());
    })(exports2, (function() {
      "use strict";
      function _typeof16(obj) {
        "@babel/helpers - typeof";
        return _typeof16 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj2) {
          return typeof obj2;
        } : function(obj2) {
          return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
        }, _typeof16(obj);
      }
      var trimLeft = /^\s+/;
      var trimRight = /\s+$/;
      function tinycolor(color, opts) {
        color = color ? color : "";
        opts = opts || {};
        if (color instanceof tinycolor) {
          return color;
        }
        if (!(this instanceof tinycolor)) {
          return new tinycolor(color, opts);
        }
        var rgb2 = inputToRGB(color);
        this._originalInput = color, this._r = rgb2.r, this._g = rgb2.g, this._b = rgb2.b, this._a = rgb2.a, this._roundA = Math.round(100 * this._a) / 100, this._format = opts.format || rgb2.format;
        this._gradientType = opts.gradientType;
        if (this._r < 1) this._r = Math.round(this._r);
        if (this._g < 1) this._g = Math.round(this._g);
        if (this._b < 1) this._b = Math.round(this._b);
        this._ok = rgb2.ok;
      }
      tinycolor.prototype = {
        isDark: function isDark() {
          return this.getBrightness() < 128;
        },
        isLight: function isLight() {
          return !this.isDark();
        },
        isValid: function isValid2() {
          return this._ok;
        },
        getOriginalInput: function getOriginalInput() {
          return this._originalInput;
        },
        getFormat: function getFormat2() {
          return this._format;
        },
        getAlpha: function getAlpha() {
          return this._a;
        },
        getBrightness: function getBrightness() {
          var rgb2 = this.toRgb();
          return (rgb2.r * 299 + rgb2.g * 587 + rgb2.b * 114) / 1e3;
        },
        getLuminance: function getLuminance() {
          var rgb2 = this.toRgb();
          var RsRGB, GsRGB, BsRGB, R, G, B;
          RsRGB = rgb2.r / 255;
          GsRGB = rgb2.g / 255;
          BsRGB = rgb2.b / 255;
          if (RsRGB <= 0.03928) R = RsRGB / 12.92;
          else R = Math.pow((RsRGB + 0.055) / 1.055, 2.4);
          if (GsRGB <= 0.03928) G = GsRGB / 12.92;
          else G = Math.pow((GsRGB + 0.055) / 1.055, 2.4);
          if (BsRGB <= 0.03928) B = BsRGB / 12.92;
          else B = Math.pow((BsRGB + 0.055) / 1.055, 2.4);
          return 0.2126 * R + 0.7152 * G + 0.0722 * B;
        },
        setAlpha: function setAlpha(value) {
          this._a = boundAlpha(value);
          this._roundA = Math.round(100 * this._a) / 100;
          return this;
        },
        toHsv: function toHsv() {
          var hsv = rgbToHsv(this._r, this._g, this._b);
          return {
            h: hsv.h * 360,
            s: hsv.s,
            v: hsv.v,
            a: this._a
          };
        },
        toHsvString: function toHsvString() {
          var hsv = rgbToHsv(this._r, this._g, this._b);
          var h2 = Math.round(hsv.h * 360), s = Math.round(hsv.s * 100), v = Math.round(hsv.v * 100);
          return this._a == 1 ? "hsv(" + h2 + ", " + s + "%, " + v + "%)" : "hsva(" + h2 + ", " + s + "%, " + v + "%, " + this._roundA + ")";
        },
        toHsl: function toHsl() {
          var hsl = rgbToHsl(this._r, this._g, this._b);
          return {
            h: hsl.h * 360,
            s: hsl.s,
            l: hsl.l,
            a: this._a
          };
        },
        toHslString: function toHslString() {
          var hsl = rgbToHsl(this._r, this._g, this._b);
          var h2 = Math.round(hsl.h * 360), s = Math.round(hsl.s * 100), l2 = Math.round(hsl.l * 100);
          return this._a == 1 ? "hsl(" + h2 + ", " + s + "%, " + l2 + "%)" : "hsla(" + h2 + ", " + s + "%, " + l2 + "%, " + this._roundA + ")";
        },
        toHex: function toHex(allow3Char) {
          return rgbToHex(this._r, this._g, this._b, allow3Char);
        },
        toHexString: function toHexString(allow3Char) {
          return "#" + this.toHex(allow3Char);
        },
        toHex8: function toHex8(allow4Char) {
          return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
        },
        toHex8String: function toHex8String(allow4Char) {
          return "#" + this.toHex8(allow4Char);
        },
        toRgb: function toRgb() {
          return {
            r: Math.round(this._r),
            g: Math.round(this._g),
            b: Math.round(this._b),
            a: this._a
          };
        },
        toRgbString: function toRgbString() {
          return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
        },
        toPercentageRgb: function toPercentageRgb() {
          return {
            r: Math.round(bound01(this._r, 255) * 100) + "%",
            g: Math.round(bound01(this._g, 255) * 100) + "%",
            b: Math.round(bound01(this._b, 255) * 100) + "%",
            a: this._a
          };
        },
        toPercentageRgbString: function toPercentageRgbString() {
          return this._a == 1 ? "rgb(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%)" : "rgba(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
        },
        toName: function toName() {
          if (this._a === 0) {
            return "transparent";
          }
          if (this._a < 1) {
            return false;
          }
          return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
        },
        toFilter: function toFilter(secondColor) {
          var hex8String = "#" + rgbaToArgbHex(this._r, this._g, this._b, this._a);
          var secondHex8String = hex8String;
          var gradientType = this._gradientType ? "GradientType = 1, " : "";
          if (secondColor) {
            var s = tinycolor(secondColor);
            secondHex8String = "#" + rgbaToArgbHex(s._r, s._g, s._b, s._a);
          }
          return "progid:DXImageTransform.Microsoft.gradient(" + gradientType + "startColorstr=" + hex8String + ",endColorstr=" + secondHex8String + ")";
        },
        toString: function toString3(format3) {
          var formatSet = !!format3;
          format3 = format3 || this._format;
          var formattedString = false;
          var hasAlpha = this._a < 1 && this._a >= 0;
          var needsAlphaFormat = !formatSet && hasAlpha && (format3 === "hex" || format3 === "hex6" || format3 === "hex3" || format3 === "hex4" || format3 === "hex8" || format3 === "name");
          if (needsAlphaFormat) {
            if (format3 === "name" && this._a === 0) {
              return this.toName();
            }
            return this.toRgbString();
          }
          if (format3 === "rgb") {
            formattedString = this.toRgbString();
          }
          if (format3 === "prgb") {
            formattedString = this.toPercentageRgbString();
          }
          if (format3 === "hex" || format3 === "hex6") {
            formattedString = this.toHexString();
          }
          if (format3 === "hex3") {
            formattedString = this.toHexString(true);
          }
          if (format3 === "hex4") {
            formattedString = this.toHex8String(true);
          }
          if (format3 === "hex8") {
            formattedString = this.toHex8String();
          }
          if (format3 === "name") {
            formattedString = this.toName();
          }
          if (format3 === "hsl") {
            formattedString = this.toHslString();
          }
          if (format3 === "hsv") {
            formattedString = this.toHsvString();
          }
          return formattedString || this.toHexString();
        },
        clone: function clone() {
          return tinycolor(this.toString());
        },
        _applyModification: function _applyModification(fn, args) {
          var color = fn.apply(null, [this].concat([].slice.call(args)));
          this._r = color._r;
          this._g = color._g;
          this._b = color._b;
          this.setAlpha(color._a);
          return this;
        },
        lighten: function lighten() {
          return this._applyModification(_lighten, arguments);
        },
        brighten: function brighten() {
          return this._applyModification(_brighten, arguments);
        },
        darken: function darken() {
          return this._applyModification(_darken, arguments);
        },
        desaturate: function desaturate() {
          return this._applyModification(_desaturate, arguments);
        },
        saturate: function saturate() {
          return this._applyModification(_saturate, arguments);
        },
        greyscale: function greyscale() {
          return this._applyModification(_greyscale, arguments);
        },
        spin: function spin() {
          return this._applyModification(_spin, arguments);
        },
        _applyCombination: function _applyCombination(fn, args) {
          return fn.apply(null, [this].concat([].slice.call(args)));
        },
        analogous: function analogous() {
          return this._applyCombination(_analogous, arguments);
        },
        complement: function complement() {
          return this._applyCombination(_complement, arguments);
        },
        monochromatic: function monochromatic() {
          return this._applyCombination(_monochromatic, arguments);
        },
        splitcomplement: function splitcomplement() {
          return this._applyCombination(_splitcomplement, arguments);
        },
        // Disabled until https://github.com/bgrins/TinyColor/issues/254
        // polyad: function (number) {
        //   return this._applyCombination(polyad, [number]);
        // },
        triad: function triad() {
          return this._applyCombination(polyad, [3]);
        },
        tetrad: function tetrad() {
          return this._applyCombination(polyad, [4]);
        }
      };
      tinycolor.fromRatio = function(color, opts) {
        if (_typeof16(color) == "object") {
          var newColor = {};
          for (var i in color) {
            if (color.hasOwnProperty(i)) {
              if (i === "a") {
                newColor[i] = color[i];
              } else {
                newColor[i] = convertToPercentage(color[i]);
              }
            }
          }
          color = newColor;
        }
        return tinycolor(color, opts);
      };
      function inputToRGB(color) {
        var rgb2 = {
          r: 0,
          g: 0,
          b: 0
        };
        var a = 1;
        var s = null;
        var v = null;
        var l2 = null;
        var ok = false;
        var format3 = false;
        if (typeof color == "string") {
          color = stringInputToObject(color);
        }
        if (_typeof16(color) == "object") {
          if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
            rgb2 = rgbToRgb(color.r, color.g, color.b);
            ok = true;
            format3 = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
          } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
            s = convertToPercentage(color.s);
            v = convertToPercentage(color.v);
            rgb2 = hsvToRgb(color.h, s, v);
            ok = true;
            format3 = "hsv";
          } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
            s = convertToPercentage(color.s);
            l2 = convertToPercentage(color.l);
            rgb2 = hslToRgb(color.h, s, l2);
            ok = true;
            format3 = "hsl";
          }
          if (color.hasOwnProperty("a")) {
            a = color.a;
          }
        }
        a = boundAlpha(a);
        return {
          ok,
          format: color.format || format3,
          r: Math.min(255, Math.max(rgb2.r, 0)),
          g: Math.min(255, Math.max(rgb2.g, 0)),
          b: Math.min(255, Math.max(rgb2.b, 0)),
          a
        };
      }
      function rgbToRgb(r2, g, b) {
        return {
          r: bound01(r2, 255) * 255,
          g: bound01(g, 255) * 255,
          b: bound01(b, 255) * 255
        };
      }
      function rgbToHsl(r2, g, b) {
        r2 = bound01(r2, 255);
        g = bound01(g, 255);
        b = bound01(b, 255);
        var max = Math.max(r2, g, b), min = Math.min(r2, g, b);
        var h2, s, l2 = (max + min) / 2;
        if (max == min) {
          h2 = s = 0;
        } else {
          var d = max - min;
          s = l2 > 0.5 ? d / (2 - max - min) : d / (max + min);
          switch (max) {
            case r2:
              h2 = (g - b) / d + (g < b ? 6 : 0);
              break;
            case g:
              h2 = (b - r2) / d + 2;
              break;
            case b:
              h2 = (r2 - g) / d + 4;
              break;
          }
          h2 /= 6;
        }
        return {
          h: h2,
          s,
          l: l2
        };
      }
      function hslToRgb(h2, s, l2) {
        var r2, g, b;
        h2 = bound01(h2, 360);
        s = bound01(s, 100);
        l2 = bound01(l2, 100);
        function hue2rgb(p2, q2, t2) {
          if (t2 < 0) t2 += 1;
          if (t2 > 1) t2 -= 1;
          if (t2 < 1 / 6) return p2 + (q2 - p2) * 6 * t2;
          if (t2 < 1 / 2) return q2;
          if (t2 < 2 / 3) return p2 + (q2 - p2) * (2 / 3 - t2) * 6;
          return p2;
        }
        if (s === 0) {
          r2 = g = b = l2;
        } else {
          var q = l2 < 0.5 ? l2 * (1 + s) : l2 + s - l2 * s;
          var p = 2 * l2 - q;
          r2 = hue2rgb(p, q, h2 + 1 / 3);
          g = hue2rgb(p, q, h2);
          b = hue2rgb(p, q, h2 - 1 / 3);
        }
        return {
          r: r2 * 255,
          g: g * 255,
          b: b * 255
        };
      }
      function rgbToHsv(r2, g, b) {
        r2 = bound01(r2, 255);
        g = bound01(g, 255);
        b = bound01(b, 255);
        var max = Math.max(r2, g, b), min = Math.min(r2, g, b);
        var h2, s, v = max;
        var d = max - min;
        s = max === 0 ? 0 : d / max;
        if (max == min) {
          h2 = 0;
        } else {
          switch (max) {
            case r2:
              h2 = (g - b) / d + (g < b ? 6 : 0);
              break;
            case g:
              h2 = (b - r2) / d + 2;
              break;
            case b:
              h2 = (r2 - g) / d + 4;
              break;
          }
          h2 /= 6;
        }
        return {
          h: h2,
          s,
          v
        };
      }
      function hsvToRgb(h2, s, v) {
        h2 = bound01(h2, 360) * 6;
        s = bound01(s, 100);
        v = bound01(v, 100);
        var i = Math.floor(h2), f = h2 - i, p = v * (1 - s), q = v * (1 - f * s), t2 = v * (1 - (1 - f) * s), mod = i % 6, r2 = [v, q, p, p, t2, v][mod], g = [t2, v, v, q, p, p][mod], b = [p, p, t2, v, v, q][mod];
        return {
          r: r2 * 255,
          g: g * 255,
          b: b * 255
        };
      }
      function rgbToHex(r2, g, b, allow3Char) {
        var hex2 = [pad2(Math.round(r2).toString(16)), pad2(Math.round(g).toString(16)), pad2(Math.round(b).toString(16))];
        if (allow3Char && hex2[0].charAt(0) == hex2[0].charAt(1) && hex2[1].charAt(0) == hex2[1].charAt(1) && hex2[2].charAt(0) == hex2[2].charAt(1)) {
          return hex2[0].charAt(0) + hex2[1].charAt(0) + hex2[2].charAt(0);
        }
        return hex2.join("");
      }
      function rgbaToHex(r2, g, b, a, allow4Char) {
        var hex2 = [pad2(Math.round(r2).toString(16)), pad2(Math.round(g).toString(16)), pad2(Math.round(b).toString(16)), pad2(convertDecimalToHex(a))];
        if (allow4Char && hex2[0].charAt(0) == hex2[0].charAt(1) && hex2[1].charAt(0) == hex2[1].charAt(1) && hex2[2].charAt(0) == hex2[2].charAt(1) && hex2[3].charAt(0) == hex2[3].charAt(1)) {
          return hex2[0].charAt(0) + hex2[1].charAt(0) + hex2[2].charAt(0) + hex2[3].charAt(0);
        }
        return hex2.join("");
      }
      function rgbaToArgbHex(r2, g, b, a) {
        var hex2 = [pad2(convertDecimalToHex(a)), pad2(Math.round(r2).toString(16)), pad2(Math.round(g).toString(16)), pad2(Math.round(b).toString(16))];
        return hex2.join("");
      }
      tinycolor.equals = function(color1, color2) {
        if (!color1 || !color2) return false;
        return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
      };
      tinycolor.random = function() {
        return tinycolor.fromRatio({
          r: Math.random(),
          g: Math.random(),
          b: Math.random()
        });
      };
      function _desaturate(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.s -= amount / 100;
        hsl.s = clamp01(hsl.s);
        return tinycolor(hsl);
      }
      function _saturate(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.s += amount / 100;
        hsl.s = clamp01(hsl.s);
        return tinycolor(hsl);
      }
      function _greyscale(color) {
        return tinycolor(color).desaturate(100);
      }
      function _lighten(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.l += amount / 100;
        hsl.l = clamp01(hsl.l);
        return tinycolor(hsl);
      }
      function _brighten(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var rgb2 = tinycolor(color).toRgb();
        rgb2.r = Math.max(0, Math.min(255, rgb2.r - Math.round(255 * -(amount / 100))));
        rgb2.g = Math.max(0, Math.min(255, rgb2.g - Math.round(255 * -(amount / 100))));
        rgb2.b = Math.max(0, Math.min(255, rgb2.b - Math.round(255 * -(amount / 100))));
        return tinycolor(rgb2);
      }
      function _darken(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.l -= amount / 100;
        hsl.l = clamp01(hsl.l);
        return tinycolor(hsl);
      }
      function _spin(color, amount) {
        var hsl = tinycolor(color).toHsl();
        var hue = (hsl.h + amount) % 360;
        hsl.h = hue < 0 ? 360 + hue : hue;
        return tinycolor(hsl);
      }
      function _complement(color) {
        var hsl = tinycolor(color).toHsl();
        hsl.h = (hsl.h + 180) % 360;
        return tinycolor(hsl);
      }
      function polyad(color, number4) {
        if (isNaN(number4) || number4 <= 0) {
          throw new Error("Argument to polyad must be a positive number");
        }
        var hsl = tinycolor(color).toHsl();
        var result = [tinycolor(color)];
        var step = 360 / number4;
        for (var i = 1; i < number4; i++) {
          result.push(tinycolor({
            h: (hsl.h + i * step) % 360,
            s: hsl.s,
            l: hsl.l
          }));
        }
        return result;
      }
      function _splitcomplement(color) {
        var hsl = tinycolor(color).toHsl();
        var h2 = hsl.h;
        return [tinycolor(color), tinycolor({
          h: (h2 + 72) % 360,
          s: hsl.s,
          l: hsl.l
        }), tinycolor({
          h: (h2 + 216) % 360,
          s: hsl.s,
          l: hsl.l
        })];
      }
      function _analogous(color, results, slices) {
        results = results || 6;
        slices = slices || 30;
        var hsl = tinycolor(color).toHsl();
        var part = 360 / slices;
        var ret = [tinycolor(color)];
        for (hsl.h = (hsl.h - (part * results >> 1) + 720) % 360; --results; ) {
          hsl.h = (hsl.h + part) % 360;
          ret.push(tinycolor(hsl));
        }
        return ret;
      }
      function _monochromatic(color, results) {
        results = results || 6;
        var hsv = tinycolor(color).toHsv();
        var h2 = hsv.h, s = hsv.s, v = hsv.v;
        var ret = [];
        var modification = 1 / results;
        while (results--) {
          ret.push(tinycolor({
            h: h2,
            s,
            v
          }));
          v = (v + modification) % 1;
        }
        return ret;
      }
      tinycolor.mix = function(color1, color2, amount) {
        amount = amount === 0 ? 0 : amount || 50;
        var rgb1 = tinycolor(color1).toRgb();
        var rgb2 = tinycolor(color2).toRgb();
        var p = amount / 100;
        var rgba = {
          r: (rgb2.r - rgb1.r) * p + rgb1.r,
          g: (rgb2.g - rgb1.g) * p + rgb1.g,
          b: (rgb2.b - rgb1.b) * p + rgb1.b,
          a: (rgb2.a - rgb1.a) * p + rgb1.a
        };
        return tinycolor(rgba);
      };
      tinycolor.readability = function(color1, color2) {
        var c1 = tinycolor(color1);
        var c2 = tinycolor(color2);
        return (Math.max(c1.getLuminance(), c2.getLuminance()) + 0.05) / (Math.min(c1.getLuminance(), c2.getLuminance()) + 0.05);
      };
      tinycolor.isReadable = function(color1, color2, wcag2) {
        var readability = tinycolor.readability(color1, color2);
        var wcag2Parms, out;
        out = false;
        wcag2Parms = validateWCAG2Parms(wcag2);
        switch (wcag2Parms.level + wcag2Parms.size) {
          case "AAsmall":
          case "AAAlarge":
            out = readability >= 4.5;
            break;
          case "AAlarge":
            out = readability >= 3;
            break;
          case "AAAsmall":
            out = readability >= 7;
            break;
        }
        return out;
      };
      tinycolor.mostReadable = function(baseColor, colorList, args) {
        var bestColor = null;
        var bestScore = 0;
        var readability;
        var includeFallbackColors, level, size;
        args = args || {};
        includeFallbackColors = args.includeFallbackColors;
        level = args.level;
        size = args.size;
        for (var i = 0; i < colorList.length; i++) {
          readability = tinycolor.readability(baseColor, colorList[i]);
          if (readability > bestScore) {
            bestScore = readability;
            bestColor = tinycolor(colorList[i]);
          }
        }
        if (tinycolor.isReadable(baseColor, bestColor, {
          level,
          size
        }) || !includeFallbackColors) {
          return bestColor;
        } else {
          args.includeFallbackColors = false;
          return tinycolor.mostReadable(baseColor, ["#fff", "#000"], args);
        }
      };
      var names2 = tinycolor.names = {
        aliceblue: "f0f8ff",
        antiquewhite: "faebd7",
        aqua: "0ff",
        aquamarine: "7fffd4",
        azure: "f0ffff",
        beige: "f5f5dc",
        bisque: "ffe4c4",
        black: "000",
        blanchedalmond: "ffebcd",
        blue: "00f",
        blueviolet: "8a2be2",
        brown: "a52a2a",
        burlywood: "deb887",
        burntsienna: "ea7e5d",
        cadetblue: "5f9ea0",
        chartreuse: "7fff00",
        chocolate: "d2691e",
        coral: "ff7f50",
        cornflowerblue: "6495ed",
        cornsilk: "fff8dc",
        crimson: "dc143c",
        cyan: "0ff",
        darkblue: "00008b",
        darkcyan: "008b8b",
        darkgoldenrod: "b8860b",
        darkgray: "a9a9a9",
        darkgreen: "006400",
        darkgrey: "a9a9a9",
        darkkhaki: "bdb76b",
        darkmagenta: "8b008b",
        darkolivegreen: "556b2f",
        darkorange: "ff8c00",
        darkorchid: "9932cc",
        darkred: "8b0000",
        darksalmon: "e9967a",
        darkseagreen: "8fbc8f",
        darkslateblue: "483d8b",
        darkslategray: "2f4f4f",
        darkslategrey: "2f4f4f",
        darkturquoise: "00ced1",
        darkviolet: "9400d3",
        deeppink: "ff1493",
        deepskyblue: "00bfff",
        dimgray: "696969",
        dimgrey: "696969",
        dodgerblue: "1e90ff",
        firebrick: "b22222",
        floralwhite: "fffaf0",
        forestgreen: "228b22",
        fuchsia: "f0f",
        gainsboro: "dcdcdc",
        ghostwhite: "f8f8ff",
        gold: "ffd700",
        goldenrod: "daa520",
        gray: "808080",
        green: "008000",
        greenyellow: "adff2f",
        grey: "808080",
        honeydew: "f0fff0",
        hotpink: "ff69b4",
        indianred: "cd5c5c",
        indigo: "4b0082",
        ivory: "fffff0",
        khaki: "f0e68c",
        lavender: "e6e6fa",
        lavenderblush: "fff0f5",
        lawngreen: "7cfc00",
        lemonchiffon: "fffacd",
        lightblue: "add8e6",
        lightcoral: "f08080",
        lightcyan: "e0ffff",
        lightgoldenrodyellow: "fafad2",
        lightgray: "d3d3d3",
        lightgreen: "90ee90",
        lightgrey: "d3d3d3",
        lightpink: "ffb6c1",
        lightsalmon: "ffa07a",
        lightseagreen: "20b2aa",
        lightskyblue: "87cefa",
        lightslategray: "789",
        lightslategrey: "789",
        lightsteelblue: "b0c4de",
        lightyellow: "ffffe0",
        lime: "0f0",
        limegreen: "32cd32",
        linen: "faf0e6",
        magenta: "f0f",
        maroon: "800000",
        mediumaquamarine: "66cdaa",
        mediumblue: "0000cd",
        mediumorchid: "ba55d3",
        mediumpurple: "9370db",
        mediumseagreen: "3cb371",
        mediumslateblue: "7b68ee",
        mediumspringgreen: "00fa9a",
        mediumturquoise: "48d1cc",
        mediumvioletred: "c71585",
        midnightblue: "191970",
        mintcream: "f5fffa",
        mistyrose: "ffe4e1",
        moccasin: "ffe4b5",
        navajowhite: "ffdead",
        navy: "000080",
        oldlace: "fdf5e6",
        olive: "808000",
        olivedrab: "6b8e23",
        orange: "ffa500",
        orangered: "ff4500",
        orchid: "da70d6",
        palegoldenrod: "eee8aa",
        palegreen: "98fb98",
        paleturquoise: "afeeee",
        palevioletred: "db7093",
        papayawhip: "ffefd5",
        peachpuff: "ffdab9",
        peru: "cd853f",
        pink: "ffc0cb",
        plum: "dda0dd",
        powderblue: "b0e0e6",
        purple: "800080",
        rebeccapurple: "663399",
        red: "f00",
        rosybrown: "bc8f8f",
        royalblue: "4169e1",
        saddlebrown: "8b4513",
        salmon: "fa8072",
        sandybrown: "f4a460",
        seagreen: "2e8b57",
        seashell: "fff5ee",
        sienna: "a0522d",
        silver: "c0c0c0",
        skyblue: "87ceeb",
        slateblue: "6a5acd",
        slategray: "708090",
        slategrey: "708090",
        snow: "fffafa",
        springgreen: "00ff7f",
        steelblue: "4682b4",
        tan: "d2b48c",
        teal: "008080",
        thistle: "d8bfd8",
        tomato: "ff6347",
        turquoise: "40e0d0",
        violet: "ee82ee",
        wheat: "f5deb3",
        white: "fff",
        whitesmoke: "f5f5f5",
        yellow: "ff0",
        yellowgreen: "9acd32"
      };
      var hexNames = tinycolor.hexNames = flip(names2);
      function flip(o3) {
        var flipped = {};
        for (var i in o3) {
          if (o3.hasOwnProperty(i)) {
            flipped[o3[i]] = i;
          }
        }
        return flipped;
      }
      function boundAlpha(a) {
        a = parseFloat(a);
        if (isNaN(a) || a < 0 || a > 1) {
          a = 1;
        }
        return a;
      }
      function bound01(n2, max) {
        if (isOnePointZero(n2)) n2 = "100%";
        var processPercent = isPercentage(n2);
        n2 = Math.min(max, Math.max(0, parseFloat(n2)));
        if (processPercent) {
          n2 = parseInt(n2 * max, 10) / 100;
        }
        if (Math.abs(n2 - max) < 1e-6) {
          return 1;
        }
        return n2 % max / parseFloat(max);
      }
      function clamp01(val) {
        return Math.min(1, Math.max(0, val));
      }
      function parseIntFromHex(val) {
        return parseInt(val, 16);
      }
      function isOnePointZero(n2) {
        return typeof n2 == "string" && n2.indexOf(".") != -1 && parseFloat(n2) === 1;
      }
      function isPercentage(n2) {
        return typeof n2 === "string" && n2.indexOf("%") != -1;
      }
      function pad2(c) {
        return c.length == 1 ? "0" + c : "" + c;
      }
      function convertToPercentage(n2) {
        if (n2 <= 1) {
          n2 = n2 * 100 + "%";
        }
        return n2;
      }
      function convertDecimalToHex(d) {
        return Math.round(parseFloat(d) * 255).toString(16);
      }
      function convertHexToDecimal(h2) {
        return parseIntFromHex(h2) / 255;
      }
      var matchers = (function() {
        var CSS_INTEGER = "[-\\+]?\\d+%?";
        var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";
        var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";
        var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
        var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
        return {
          CSS_UNIT: new RegExp(CSS_UNIT),
          rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
          rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
          hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
          hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
          hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
          hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
          hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
          hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
          hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
          hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
        };
      })();
      function isValidCSSUnit(color) {
        return !!matchers.CSS_UNIT.exec(color);
      }
      function stringInputToObject(color) {
        color = color.replace(trimLeft, "").replace(trimRight, "").toLowerCase();
        var named = false;
        if (names2[color]) {
          color = names2[color];
          named = true;
        } else if (color == "transparent") {
          return {
            r: 0,
            g: 0,
            b: 0,
            a: 0,
            format: "name"
          };
        }
        var match2;
        if (match2 = matchers.rgb.exec(color)) {
          return {
            r: match2[1],
            g: match2[2],
            b: match2[3]
          };
        }
        if (match2 = matchers.rgba.exec(color)) {
          return {
            r: match2[1],
            g: match2[2],
            b: match2[3],
            a: match2[4]
          };
        }
        if (match2 = matchers.hsl.exec(color)) {
          return {
            h: match2[1],
            s: match2[2],
            l: match2[3]
          };
        }
        if (match2 = matchers.hsla.exec(color)) {
          return {
            h: match2[1],
            s: match2[2],
            l: match2[3],
            a: match2[4]
          };
        }
        if (match2 = matchers.hsv.exec(color)) {
          return {
            h: match2[1],
            s: match2[2],
            v: match2[3]
          };
        }
        if (match2 = matchers.hsva.exec(color)) {
          return {
            h: match2[1],
            s: match2[2],
            v: match2[3],
            a: match2[4]
          };
        }
        if (match2 = matchers.hex8.exec(color)) {
          return {
            r: parseIntFromHex(match2[1]),
            g: parseIntFromHex(match2[2]),
            b: parseIntFromHex(match2[3]),
            a: convertHexToDecimal(match2[4]),
            format: named ? "name" : "hex8"
          };
        }
        if (match2 = matchers.hex6.exec(color)) {
          return {
            r: parseIntFromHex(match2[1]),
            g: parseIntFromHex(match2[2]),
            b: parseIntFromHex(match2[3]),
            format: named ? "name" : "hex"
          };
        }
        if (match2 = matchers.hex4.exec(color)) {
          return {
            r: parseIntFromHex(match2[1] + "" + match2[1]),
            g: parseIntFromHex(match2[2] + "" + match2[2]),
            b: parseIntFromHex(match2[3] + "" + match2[3]),
            a: convertHexToDecimal(match2[4] + "" + match2[4]),
            format: named ? "name" : "hex8"
          };
        }
        if (match2 = matchers.hex3.exec(color)) {
          return {
            r: parseIntFromHex(match2[1] + "" + match2[1]),
            g: parseIntFromHex(match2[2] + "" + match2[2]),
            b: parseIntFromHex(match2[3] + "" + match2[3]),
            format: named ? "name" : "hex"
          };
        }
        return false;
      }
      function validateWCAG2Parms(parms) {
        var level, size;
        parms = parms || {
          level: "AA",
          size: "small"
        };
        level = (parms.level || "AA").toUpperCase();
        size = (parms.size || "small").toLowerCase();
        if (level !== "AA" && level !== "AAA") {
          level = "AA";
        }
        if (size !== "small" && size !== "large") {
          size = "small";
        }
        return {
          level,
          size
        };
      }
      return tinycolor;
    }));
  }
});

// ../../node_modules/rc-color-picker/lib/helpers/color.js
var require_color2 = __commonJS({
  "../../node_modules/rc-color-picker/lib/helpers/color.js"(exports2, module2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    var _extends3 = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key2 in source) {
          if (Object.prototype.hasOwnProperty.call(source, key2)) {
            target[key2] = source[key2];
          }
        }
      }
      return target;
    };
    var _createClass2 = /* @__PURE__ */ (function() {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    })();
    var _tinycolor = require_tinycolor();
    var _tinycolor2 = _interopRequireDefault(_tinycolor);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    function _classCallCheck2(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
    var Color5 = (function() {
      function Color6(input) {
        var _this = this;
        _classCallCheck2(this, Color6);
        this.initRgb = function() {
          var _color$toRgb = _this.color.toRgb(), r2 = _color$toRgb.r, g = _color$toRgb.g, b = _color$toRgb.b;
          _this.redValue = r2;
          _this.greenValue = g;
          _this.blueValue = b;
        };
        this.initHsb = function() {
          var _color$toHsv = _this.color.toHsv(), h2 = _color$toHsv.h, s = _color$toHsv.s, v = _color$toHsv.v;
          _this.hueValue = h2;
          _this.saturationValue = s;
          _this.brightnessValue = v;
        };
        this.toHexString = function() {
          return _this.color.toHexString();
        };
        this.toRgbString = function() {
          return _this.color.toRgbString();
        };
        this.color = (0, _tinycolor2["default"])(input);
        this.initRgb();
        this.initHsb();
        var initAlpha = input && input.alpha || this.color.toRgb().a;
        this.alphaValue = Math.min(1, initAlpha) * 100;
      }
      Color6.isValidHex = function isValidHex(hex2) {
        return (0, _tinycolor2["default"])(hex2).isValid();
      };
      _createClass2(Color6, [{
        key: "hex",
        get: function get3() {
          return this.color.toHex();
        }
        // 色调
      }, {
        key: "hue",
        set: function set4(value) {
          this.color = (0, _tinycolor2["default"])({
            h: value,
            s: this.saturation,
            v: this.brightness
          });
          this.initRgb();
          this.hueValue = value;
        },
        get: function get3() {
          return this.hueValue;
        }
        // 饱和度
      }, {
        key: "saturation",
        set: function set4(value) {
          this.color = (0, _tinycolor2["default"])({
            h: this.hue,
            s: value,
            v: this.brightness
          });
          this.initRgb();
          this.saturationValue = value;
        },
        get: function get3() {
          return this.saturationValue;
        }
        // 亮度
      }, {
        key: "lightness",
        set: function set4(value) {
          this.color = (0, _tinycolor2["default"])({
            h: this.hue,
            s: this.saturation,
            l: value
          });
          this.initRgb();
          this.lightnessValue = value;
        },
        get: function get3() {
          return this.lightnessValue;
        }
      }, {
        key: "brightness",
        set: function set4(value) {
          this.color = (0, _tinycolor2["default"])({
            h: this.hue,
            s: this.saturation,
            v: value
          });
          this.initRgb();
          this.brightnessValue = value;
        },
        get: function get3() {
          return this.brightnessValue;
        }
        // red
      }, {
        key: "red",
        set: function set4(value) {
          var rgb2 = this.color.toRgb();
          this.color = (0, _tinycolor2["default"])(_extends3({}, rgb2, {
            r: value
          }));
          this.initHsb();
          this.redValue = value;
        },
        get: function get3() {
          return this.redValue;
        }
        // green
      }, {
        key: "green",
        set: function set4(value) {
          var rgb2 = this.color.toRgb();
          this.color = (0, _tinycolor2["default"])(_extends3({}, rgb2, {
            g: value
          }));
          this.initHsb();
          this.greenValue = value;
        },
        get: function get3() {
          return this.greenValue;
        }
        // blue
      }, {
        key: "blue",
        set: function set4(value) {
          var rgb2 = this.color.toRgb();
          this.color = (0, _tinycolor2["default"])(_extends3({}, rgb2, {
            b: value
          }));
          this.initHsb();
          this.blueValue = value;
        },
        get: function get3() {
          return this.blueValue;
        }
        // alpha
      }, {
        key: "alpha",
        set: function set4(value) {
          this.color.setAlpha(value / 100);
        },
        get: function get3() {
          return this.color.getAlpha() * 100;
        }
      }, {
        key: "RGB",
        get: function get3() {
          return [this.red, this.green, this.blue];
        }
      }, {
        key: "HSB",
        get: function get3() {
          return [this.hue, this.saturation, this.brightness];
        }
      }]);
      return Color6;
    })();
    exports2["default"] = Color5;
    module2.exports = exports2["default"];
  }
});

// ../../node_modules/rc-color-picker/node_modules/rc-util/lib/Dom/addEventListener.js
var require_addEventListener3 = __commonJS({
  "../../node_modules/rc-color-picker/node_modules/rc-util/lib/Dom/addEventListener.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = addEventListenerWrap2;
    var _addDomEventListener = _interopRequireDefault(require_lib());
    var _reactDom = _interopRequireDefault(require_react_dom());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { default: obj };
    }
    function addEventListenerWrap2(target, eventType, cb, option) {
      var callback = _reactDom.default.unstable_batchedUpdates ? function run(e3) {
        _reactDom.default.unstable_batchedUpdates(cb, e3);
      } : cb;
      return (0, _addDomEventListener.default)(target, eventType, callback, option);
    }
  }
});

// ../../node_modules/rc-color-picker/lib/Board.js
var require_Board = __commonJS({
  "../../node_modules/rc-color-picker/lib/Board.js"(exports2, module2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    var _react = require_react();
    var _react2 = _interopRequireDefault(_react);
    var _reactDom = require_react_dom();
    var _reactDom2 = _interopRequireDefault(_reactDom);
    var _propTypes = require_prop_types();
    var _propTypes2 = _interopRequireDefault(_propTypes);
    var _addEventListener = require_addEventListener3();
    var _addEventListener2 = _interopRequireDefault(_addEventListener);
    var _color = require_color2();
    var _color2 = _interopRequireDefault(_color);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    function _defaults(obj, defaults) {
      var keys4 = Object.getOwnPropertyNames(defaults);
      for (var i = 0; i < keys4.length; i++) {
        var key2 = keys4[i];
        var value = Object.getOwnPropertyDescriptor(defaults, key2);
        if (value && value.configurable && obj[key2] === void 0) {
          Object.defineProperty(obj, key2, value);
        }
      }
      return obj;
    }
    function _classCallCheck2(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
    function _possibleConstructorReturn2(self2, call2) {
      if (!self2) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }
      return call2 && (typeof call2 === "object" || typeof call2 === "function") ? call2 : self2;
    }
    function _inherits2(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
      }
      subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass);
    }
    var WIDTH = 200;
    var HEIGHT = 150;
    var Board = (function(_React$Component) {
      _inherits2(Board2, _React$Component);
      function Board2(props) {
        _classCallCheck2(this, Board2);
        var _this = _possibleConstructorReturn2(this, _React$Component.call(this, props));
        _this.onBoardMouseDown = function(e3) {
          var buttons = e3.buttons;
          if (buttons !== 1) return;
          var x = e3.clientX;
          var y = e3.clientY;
          _this.pointMoveTo({
            x,
            y
          });
          _this.removeListeners();
          _this.dragListener = (0, _addEventListener2["default"])(window, "mousemove", _this.onBoardDrag);
          _this.dragUpListener = (0, _addEventListener2["default"])(window, "mouseup", _this.onBoardDragEnd);
        };
        _this.onBoardTouchStart = function(e3) {
          if (e3.touches.length !== 1) {
            return;
          }
          _this.removeTouchListeners();
          var x = e3.targetTouches[0].clientX;
          var y = e3.targetTouches[0].clientY;
          _this.pointMoveTo({
            x,
            y
          });
          _this.touchMoveListener = (0, _addEventListener2["default"])(window, "touchmove", _this.onBoardTouchMove);
          _this.touchEndListener = (0, _addEventListener2["default"])(window, "touchend", _this.onBoardTouchEnd);
        };
        _this.onBoardTouchMove = function(e3) {
          if (e3.preventDefault) {
            e3.preventDefault();
          }
          var x = e3.targetTouches[0].clientX;
          var y = e3.targetTouches[0].clientY;
          _this.pointMoveTo({
            x,
            y
          });
        };
        _this.onBoardTouchEnd = function() {
          _this.removeTouchListeners();
        };
        _this.onBoardDrag = function(e3) {
          var x = e3.clientX;
          var y = e3.clientY;
          _this.pointMoveTo({
            x,
            y
          });
        };
        _this.onBoardDragEnd = function(e3) {
          var x = e3.clientX;
          var y = e3.clientY;
          _this.pointMoveTo({
            x,
            y
          });
          _this.removeListeners();
        };
        _this.getPrefixCls = function() {
          return _this.props.rootPrefixCls + "-board";
        };
        _this.removeTouchListeners = function() {
          if (_this.touchMoveListener) {
            _this.touchMoveListener.remove();
            _this.touchMoveListener = null;
          }
          if (_this.touchEndListener) {
            _this.touchEndListener.remove();
            _this.touchEndListener = null;
          }
        };
        _this.removeListeners = function() {
          if (_this.dragListener) {
            _this.dragListener.remove();
            _this.dragListener = null;
          }
          if (_this.dragUpListener) {
            _this.dragUpListener.remove();
            _this.dragUpListener = null;
          }
        };
        _this.pointMoveTo = function(pos) {
          var rect = _reactDom2["default"].findDOMNode(_this).getBoundingClientRect();
          var left2 = pos.x - rect.left;
          var top = pos.y - rect.top;
          var rWidth = rect.width || WIDTH;
          var rHeight = rect.height || HEIGHT;
          left2 = Math.max(0, left2);
          left2 = Math.min(left2, rWidth);
          top = Math.max(0, top);
          top = Math.min(top, rHeight);
          var color = _this.props.color;
          color.saturation = left2 / rWidth;
          color.brightness = 1 - top / rHeight;
          _this.props.onChange(color);
        };
        return _this;
      }
      Board2.prototype.componentWillUnmount = function componentWillUnmount() {
        this.removeListeners();
        this.removeTouchListeners();
      };
      Board2.prototype.render = function render4() {
        var prefixCls = this.getPrefixCls();
        var color = this.props.color;
        var hueHsv = {
          h: color.hue,
          s: 1,
          v: 1
        };
        var hueColor = new _color2["default"](hueHsv).toHexString();
        var xRel = color.saturation * 100;
        var yRel = (1 - color.brightness) * 100;
        return _react2["default"].createElement(
          "div",
          { className: prefixCls },
          _react2["default"].createElement(
            "div",
            { className: prefixCls + "-hsv", style: { backgroundColor: hueColor } },
            _react2["default"].createElement("div", { className: prefixCls + "-value" }),
            _react2["default"].createElement("div", { className: prefixCls + "-saturation" })
          ),
          _react2["default"].createElement("span", { style: { left: xRel + "%", top: yRel + "%" } }),
          _react2["default"].createElement("div", {
            className: prefixCls + "-handler",
            onMouseDown: this.onBoardMouseDown,
            onTouchStart: this.onBoardTouchStart
          })
        );
      };
      return Board2;
    })(_react2["default"].Component);
    exports2["default"] = Board;
    Board.propTypes = {
      color: _propTypes2["default"].object,
      onChange: _propTypes2["default"].func,
      rootPrefixCls: _propTypes2["default"].string
    };
    module2.exports = exports2["default"];
  }
});

// ../../node_modules/rc-color-picker/lib/Preview.js
var require_Preview = __commonJS({
  "../../node_modules/rc-color-picker/lib/Preview.js"(exports2, module2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    var _react = require_react();
    var _react2 = _interopRequireDefault(_react);
    var _propTypes = require_prop_types();
    var _propTypes2 = _interopRequireDefault(_propTypes);
    var _color = require_color2();
    var _color2 = _interopRequireDefault(_color);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    function _defaults(obj, defaults) {
      var keys4 = Object.getOwnPropertyNames(defaults);
      for (var i = 0; i < keys4.length; i++) {
        var key2 = keys4[i];
        var value = Object.getOwnPropertyDescriptor(defaults, key2);
        if (value && value.configurable && obj[key2] === void 0) {
          Object.defineProperty(obj, key2, value);
        }
      }
      return obj;
    }
    function _classCallCheck2(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
    function _possibleConstructorReturn2(self2, call2) {
      if (!self2) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }
      return call2 && (typeof call2 === "object" || typeof call2 === "function") ? call2 : self2;
    }
    function _inherits2(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
      }
      subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass);
    }
    var Preview4 = (function(_React$Component) {
      _inherits2(Preview5, _React$Component);
      function Preview5() {
        var _temp, _this, _ret;
        _classCallCheck2(this, Preview5);
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        return _ret = (_temp = (_this = _possibleConstructorReturn2(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.onChange = function(e3) {
          var value = e3.target.value;
          var color = new _color2["default"](value);
          _this.props.onChange(color);
          e3.stopPropagation();
        }, _this.getPrefixCls = function() {
          return _this.props.rootPrefixCls + "-preview";
        }, _temp), _possibleConstructorReturn2(_this, _ret);
      }
      Preview5.prototype.render = function render4() {
        var prefixCls = this.getPrefixCls();
        var hex2 = this.props.color.toHexString();
        return _react2["default"].createElement(
          "div",
          { className: prefixCls },
          _react2["default"].createElement("span", {
            style: {
              backgroundColor: hex2,
              opacity: this.props.alpha / 100
            }
          }),
          _react2["default"].createElement("input", {
            type: "color",
            value: hex2,
            onChange: this.onChange,
            onClick: this.props.onInputClick
          })
        );
      };
      return Preview5;
    })(_react2["default"].Component);
    exports2["default"] = Preview4;
    Preview4.propTypes = {
      rootPrefixCls: _propTypes2["default"].string,
      color: _propTypes2["default"].object,
      alpha: _propTypes2["default"].number,
      onChange: _propTypes2["default"].func,
      onInputClick: _propTypes2["default"].func
    };
    module2.exports = exports2["default"];
  }
});

// ../../node_modules/rc-color-picker/lib/Ribbon.js
var require_Ribbon = __commonJS({
  "../../node_modules/rc-color-picker/lib/Ribbon.js"(exports2, module2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    var _react = require_react();
    var _react2 = _interopRequireDefault(_react);
    var _reactDom = require_react_dom();
    var _reactDom2 = _interopRequireDefault(_reactDom);
    var _propTypes = require_prop_types();
    var _propTypes2 = _interopRequireDefault(_propTypes);
    var _addEventListener = require_addEventListener3();
    var _addEventListener2 = _interopRequireDefault(_addEventListener);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    function _defaults(obj, defaults) {
      var keys4 = Object.getOwnPropertyNames(defaults);
      for (var i = 0; i < keys4.length; i++) {
        var key2 = keys4[i];
        var value = Object.getOwnPropertyDescriptor(defaults, key2);
        if (value && value.configurable && obj[key2] === void 0) {
          Object.defineProperty(obj, key2, value);
        }
      }
      return obj;
    }
    function _classCallCheck2(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
    function _possibleConstructorReturn2(self2, call2) {
      if (!self2) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }
      return call2 && (typeof call2 === "object" || typeof call2 === "function") ? call2 : self2;
    }
    function _inherits2(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
      }
      subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass);
    }
    var Ribbon = (function(_React$Component) {
      _inherits2(Ribbon2, _React$Component);
      function Ribbon2(props) {
        _classCallCheck2(this, Ribbon2);
        var _this = _possibleConstructorReturn2(this, _React$Component.call(this, props));
        _this.onMouseDown = function(e3) {
          var x = e3.clientX;
          var y = e3.clientY;
          _this.pointMoveTo({
            x,
            y
          });
          _this.dragListener = (0, _addEventListener2["default"])(window, "mousemove", _this.onDrag);
          _this.dragUpListener = (0, _addEventListener2["default"])(window, "mouseup", _this.onDragEnd);
        };
        _this.onDrag = function(e3) {
          var x = e3.clientX;
          var y = e3.clientY;
          _this.pointMoveTo({
            x,
            y
          });
        };
        _this.onDragEnd = function(e3) {
          var x = e3.clientX;
          var y = e3.clientY;
          _this.pointMoveTo({
            x,
            y
          });
          _this.removeListeners();
        };
        _this.getPrefixCls = function() {
          return _this.props.rootPrefixCls + "-ribbon";
        };
        _this.pointMoveTo = function(coords) {
          var rect = _reactDom2["default"].findDOMNode(_this).getBoundingClientRect();
          var width = rect.width;
          var left2 = coords.x - rect.left;
          left2 = Math.max(0, left2);
          left2 = Math.min(left2, width);
          var huePercent = left2 / width;
          var hue = huePercent * 360;
          var color = _this.props.color;
          color.hue = hue;
          _this.props.onChange(color);
        };
        _this.removeListeners = function() {
          if (_this.dragListener) {
            _this.dragListener.remove();
            _this.dragListener = null;
          }
          if (_this.dragUpListener) {
            _this.dragUpListener.remove();
            _this.dragUpListener = null;
          }
        };
        return _this;
      }
      Ribbon2.prototype.componentWillUnmount = function componentWillUnmount() {
        this.removeListeners();
      };
      Ribbon2.prototype.render = function render4() {
        var prefixCls = this.getPrefixCls();
        var hue = this.props.color.hue;
        var per = hue / 360 * 100;
        return _react2["default"].createElement(
          "div",
          { className: prefixCls },
          _react2["default"].createElement("span", { ref: "point", style: { left: per + "%" } }),
          _react2["default"].createElement("div", { className: prefixCls + "-handler", onMouseDown: this.onMouseDown })
        );
      };
      return Ribbon2;
    })(_react2["default"].Component);
    exports2["default"] = Ribbon;
    Ribbon.propTypes = {
      rootPrefixCls: _propTypes2["default"].string,
      color: _propTypes2["default"].object,
      onChange: _propTypes2["default"].func
    };
    module2.exports = exports2["default"];
  }
});

// ../../node_modules/rc-color-picker/lib/Alpha.js
var require_Alpha = __commonJS({
  "../../node_modules/rc-color-picker/lib/Alpha.js"(exports2, module2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    var _react = require_react();
    var _react2 = _interopRequireDefault(_react);
    var _reactDom = require_react_dom();
    var _propTypes = require_prop_types();
    var _propTypes2 = _interopRequireDefault(_propTypes);
    var _addEventListener = require_addEventListener3();
    var _addEventListener2 = _interopRequireDefault(_addEventListener);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    function _defaults(obj, defaults) {
      var keys4 = Object.getOwnPropertyNames(defaults);
      for (var i = 0; i < keys4.length; i++) {
        var key2 = keys4[i];
        var value = Object.getOwnPropertyDescriptor(defaults, key2);
        if (value && value.configurable && obj[key2] === void 0) {
          Object.defineProperty(obj, key2, value);
        }
      }
      return obj;
    }
    function _classCallCheck2(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
    function _possibleConstructorReturn2(self2, call2) {
      if (!self2) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }
      return call2 && (typeof call2 === "object" || typeof call2 === "function") ? call2 : self2;
    }
    function _inherits2(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
      }
      subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass);
    }
    function rgbaColor(r2, g, b, a) {
      return "rgba(" + [r2, g, b, a / 100].join(",") + ")";
    }
    var Alpha = (function(_React$Component) {
      _inherits2(Alpha2, _React$Component);
      function Alpha2(props) {
        _classCallCheck2(this, Alpha2);
        var _this = _possibleConstructorReturn2(this, _React$Component.call(this, props));
        _this.onMouseDown = function(e3) {
          var x = e3.clientX;
          var y = e3.clientY;
          _this.pointMoveTo({
            x,
            y
          });
          _this.dragListener = (0, _addEventListener2["default"])(window, "mousemove", _this.onDrag);
          _this.dragUpListener = (0, _addEventListener2["default"])(window, "mouseup", _this.onDragEnd);
        };
        _this.onDrag = function(e3) {
          var x = e3.clientX;
          var y = e3.clientY;
          _this.pointMoveTo({
            x,
            y
          });
        };
        _this.onDragEnd = function(e3) {
          var x = e3.clientX;
          var y = e3.clientY;
          _this.pointMoveTo({
            x,
            y
          });
          _this.removeListeners();
        };
        _this.getBackground = function() {
          var _this$props$color = _this.props.color, red2 = _this$props$color.red, green2 = _this$props$color.green, blue2 = _this$props$color.blue;
          var opacityGradient = "linear-gradient(to right, " + rgbaColor(red2, green2, blue2, 0) + " , " + rgbaColor(red2, green2, blue2, 100) + ")";
          return opacityGradient;
        };
        _this.getPrefixCls = function() {
          return _this.props.rootPrefixCls + "-alpha";
        };
        _this.pointMoveTo = function(coords) {
          var rect = (0, _reactDom.findDOMNode)(_this).getBoundingClientRect();
          var width = rect.width;
          var left2 = coords.x - rect.left;
          left2 = Math.max(0, left2);
          left2 = Math.min(left2, width);
          var alpha = Math.round(left2 / width * 100);
          _this.props.onChange(alpha);
        };
        _this.removeListeners = function() {
          if (_this.dragListener) {
            _this.dragListener.remove();
            _this.dragListener = null;
          }
          if (_this.dragUpListener) {
            _this.dragUpListener.remove();
            _this.dragUpListener = null;
          }
        };
        return _this;
      }
      Alpha2.prototype.componentWillUnmount = function componentWillUnmount() {
        this.removeListeners();
      };
      Alpha2.prototype.render = function render4() {
        var prefixCls = this.getPrefixCls();
        return _react2["default"].createElement(
          "div",
          { className: prefixCls },
          _react2["default"].createElement("div", { ref: "bg", className: prefixCls + "-bg", style: { background: this.getBackground() } }),
          _react2["default"].createElement("span", { style: { left: this.props.alpha + "%" } }),
          _react2["default"].createElement("div", { className: prefixCls + "-handler", onMouseDown: this.onMouseDown })
        );
      };
      return Alpha2;
    })(_react2["default"].Component);
    exports2["default"] = Alpha;
    Alpha.propTypes = {
      color: _propTypes2["default"].object,
      onChange: _propTypes2["default"].func,
      rootPrefixCls: _propTypes2["default"].string,
      alpha: _propTypes2["default"].number
    };
    module2.exports = exports2["default"];
  }
});

// ../../node_modules/rc-color-picker/lib/helpers/percentage.js
var require_percentage = __commonJS({
  "../../node_modules/rc-color-picker/lib/helpers/percentage.js"(exports2, module2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2["default"] = percentage;
    function percentage(input) {
      return Math.round(input * 100);
    }
    module2.exports = exports2["default"];
  }
});

// ../../node_modules/rc-color-picker/lib/Params.js
var require_Params = __commonJS({
  "../../node_modules/rc-color-picker/lib/Params.js"(exports2, module2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    var _react = require_react();
    var _react2 = _interopRequireDefault(_react);
    var _propTypes = require_prop_types();
    var _propTypes2 = _interopRequireDefault(_propTypes);
    var _classnames = require_classnames();
    var _classnames2 = _interopRequireDefault(_classnames);
    var _color = require_color2();
    var _color2 = _interopRequireDefault(_color);
    var _percentage = require_percentage();
    var _percentage2 = _interopRequireDefault(_percentage);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    function _defaults(obj, defaults) {
      var keys4 = Object.getOwnPropertyNames(defaults);
      for (var i = 0; i < keys4.length; i++) {
        var key2 = keys4[i];
        var value = Object.getOwnPropertyDescriptor(defaults, key2);
        if (value && value.configurable && obj[key2] === void 0) {
          Object.defineProperty(obj, key2, value);
        }
      }
      return obj;
    }
    function _defineProperty11(obj, key2, value) {
      if (key2 in obj) {
        Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
      } else {
        obj[key2] = value;
      }
      return obj;
    }
    function _classCallCheck2(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
    function _possibleConstructorReturn2(self2, call2) {
      if (!self2) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }
      return call2 && (typeof call2 === "object" || typeof call2 === "function") ? call2 : self2;
    }
    function _inherits2(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
      }
      subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass);
    }
    var modesMap = ["RGB", "HSB"];
    var Params = (function(_React$Component) {
      _inherits2(Params2, _React$Component);
      function Params2(props) {
        _classCallCheck2(this, Params2);
        var _this = _possibleConstructorReturn2(this, _React$Component.call(this, props));
        _this.getChannelInRange = function(value, index3) {
          var channelMap = {
            RGB: [[0, 255], [0, 255], [0, 255]],
            HSB: [[0, 359], [0, 100], [0, 100]]
          };
          var mode = _this.state.mode;
          var range3 = channelMap[mode][index3];
          var result = parseInt(value, 10);
          if (isNaN(result)) {
            result = 0;
          }
          result = Math.max(range3[0], result);
          result = Math.min(result, range3[1]);
          return result;
        };
        _this.getPrefixCls = function() {
          return _this.props.rootPrefixCls + "-params";
        };
        _this.handleHexBlur = function() {
          var hex2 = _this.state.hex;
          var color = null;
          if (_color2["default"].isValidHex(hex2)) {
            color = new _color2["default"](hex2);
          }
          if (color !== null) {
            _this.setState({
              color,
              hex: hex2
            });
            _this.props.onChange(color, false);
          }
        };
        _this.handleHexPress = function(event) {
          var hex2 = _this.state.hex;
          if (event.nativeEvent.which === 13) {
            var color = null;
            if (_color2["default"].isValidHex(hex2)) {
              color = new _color2["default"](hex2);
            }
            if (color !== null) {
              _this.setState({
                color,
                hex: hex2
              });
              _this.props.onChange(color, false);
            }
          }
        };
        _this.handleHexChange = function(event) {
          var hex2 = event.target.value;
          _this.setState({
            hex: hex2
          });
        };
        _this.handleModeChange = function() {
          var mode = _this.state.mode;
          var modeIndex = (modesMap.indexOf(mode) + 1) % modesMap.length;
          mode = modesMap[modeIndex];
          _this.setState({
            mode
          });
        };
        _this.handleAlphaHandler = function(event) {
          var alpha = parseInt(event.target.value, 10);
          if (isNaN(alpha)) {
            alpha = 0;
          }
          alpha = Math.max(0, alpha);
          alpha = Math.min(alpha, 100);
          _this.props.onAlphaChange(alpha);
        };
        _this.updateColorByChanel = function(channel, value) {
          var color = _this.props.color;
          var mode = _this.state.mode;
          if (mode === "HSB") {
            if (channel === "H") {
              color.hue = parseInt(value, 10);
            } else if (channel === "S") {
              color.saturation = parseInt(value, 10) / 100;
            } else if (channel === "B") {
              color.brightness = parseInt(value, 10) / 100;
            }
          } else {
            if (channel === "R") {
              color.red = parseInt(value, 10);
            } else if (channel === "G") {
              color.green = parseInt(value, 10);
            } else if (channel === "B") {
              color.blue = parseInt(value, 10);
            }
          }
          return color;
        };
        _this.handleColorChannelChange = function(index3, event) {
          var value = _this.getChannelInRange(event.target.value, index3);
          var mode = _this.state.mode;
          var channel = mode[index3];
          var color = _this.updateColorByChanel(channel, value);
          _this.setState({
            hex: color.hex,
            color
          }, function() {
            _this.props.onChange(color, false);
          });
        };
        _this.state = {
          mode: props.mode,
          hex: props.color.hex,
          color: props.color
          // instanceof tinycolor
        };
        return _this;
      }
      Params2.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        var nextColor = nextProps.color;
        this.setState({
          color: nextColor,
          hex: nextColor.hex
        });
      };
      Params2.prototype.render = function render4() {
        var _cx;
        var prefixCls = this.getPrefixCls();
        var enableAlpha = this.props.enableAlpha;
        var _state = this.state, mode = _state.mode, color = _state.color;
        var colorChannel = color[mode];
        if (mode === "HSB") {
          colorChannel[0] = parseInt(colorChannel[0], 10);
          colorChannel[1] = (0, _percentage2["default"])(colorChannel[1]);
          colorChannel[2] = (0, _percentage2["default"])(colorChannel[2]);
        }
        var paramsClasses = (0, _classnames2["default"])((_cx = {}, _defineProperty11(_cx, prefixCls, true), _defineProperty11(_cx, prefixCls + "-has-alpha", enableAlpha), _cx));
        return _react2["default"].createElement(
          "div",
          { className: paramsClasses },
          _react2["default"].createElement(
            "div",
            { className: prefixCls + "-input" },
            _react2["default"].createElement("input", {
              className: prefixCls + "-hex",
              type: "text",
              maxLength: "6",
              onKeyPress: this.handleHexPress,
              onBlur: this.handleHexBlur,
              onChange: this.handleHexChange,
              value: this.state.hex.toLowerCase()
            }),
            _react2["default"].createElement("input", {
              type: "number",
              ref: "channel_0",
              value: colorChannel[0],
              onChange: this.handleColorChannelChange.bind(null, 0)
            }),
            _react2["default"].createElement("input", {
              type: "number",
              ref: "channel_1",
              value: colorChannel[1],
              onChange: this.handleColorChannelChange.bind(null, 1)
            }),
            _react2["default"].createElement("input", {
              type: "number",
              ref: "channel_2",
              value: colorChannel[2],
              onChange: this.handleColorChannelChange.bind(null, 2)
            }),
            enableAlpha && _react2["default"].createElement("input", {
              type: "number",
              value: Math.round(this.props.alpha),
              onChange: this.handleAlphaHandler
            })
          ),
          _react2["default"].createElement(
            "div",
            { className: prefixCls + "-lable" },
            _react2["default"].createElement(
              "label",
              { className: prefixCls + "-lable-hex" },
              "Hex"
            ),
            _react2["default"].createElement(
              "label",
              { className: prefixCls + "-lable-number", onClick: this.handleModeChange },
              mode[0]
            ),
            _react2["default"].createElement(
              "label",
              { className: prefixCls + "-lable-number", onClick: this.handleModeChange },
              mode[1]
            ),
            _react2["default"].createElement(
              "label",
              { className: prefixCls + "-lable-number", onClick: this.handleModeChange },
              mode[2]
            ),
            enableAlpha && _react2["default"].createElement(
              "label",
              { className: prefixCls + "-lable-alpha" },
              "A"
            )
          )
        );
      };
      return Params2;
    })(_react2["default"].Component);
    exports2["default"] = Params;
    Params.propTypes = {
      alpha: _propTypes2["default"].number,
      enableAlpha: _propTypes2["default"].bool,
      color: _propTypes2["default"].object.isRequired,
      mode: _propTypes2["default"].oneOf(modesMap),
      onAlphaChange: _propTypes2["default"].func,
      onChange: _propTypes2["default"].func,
      rootPrefixCls: _propTypes2["default"].string
    };
    Params.defaultProps = {
      mode: modesMap[0],
      enableAlpha: true
    };
    module2.exports = exports2["default"];
  }
});

// ../../node_modules/rc-color-picker/lib/utils/validationColor.js
var require_validationColor = __commonJS({
  "../../node_modules/rc-color-picker/lib/utils/validationColor.js"(exports2, module2) {
    "use strict";
    module2.exports = function validationColor(props, propName, componentName) {
      if (props[propName] && !/^#[0-9a-fA-F]{3,6}$/.test(props[propName])) {
        return new Error(componentName + ".props." + propName + " Validation failed!");
      }
    };
  }
});

// ../../node_modules/rc-color-picker/lib/Panel.js
var require_Panel = __commonJS({
  "../../node_modules/rc-color-picker/lib/Panel.js"(exports2, module2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    var _react = require_react();
    var _react2 = _interopRequireDefault(_react);
    var _propTypes = require_prop_types();
    var _propTypes2 = _interopRequireDefault(_propTypes);
    var _color = require_color2();
    var _color2 = _interopRequireDefault(_color);
    var _Board = require_Board();
    var _Board2 = _interopRequireDefault(_Board);
    var _Preview = require_Preview();
    var _Preview2 = _interopRequireDefault(_Preview);
    var _Ribbon = require_Ribbon();
    var _Ribbon2 = _interopRequireDefault(_Ribbon);
    var _Alpha = require_Alpha();
    var _Alpha2 = _interopRequireDefault(_Alpha);
    var _Params = require_Params();
    var _Params2 = _interopRequireDefault(_Params);
    var _classnames = require_classnames();
    var _classnames2 = _interopRequireDefault(_classnames);
    var _validationColor = require_validationColor();
    var _validationColor2 = _interopRequireDefault(_validationColor);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    function _defaults(obj, defaults) {
      var keys4 = Object.getOwnPropertyNames(defaults);
      for (var i = 0; i < keys4.length; i++) {
        var key2 = keys4[i];
        var value = Object.getOwnPropertyDescriptor(defaults, key2);
        if (value && value.configurable && obj[key2] === void 0) {
          Object.defineProperty(obj, key2, value);
        }
      }
      return obj;
    }
    function _defineProperty11(obj, key2, value) {
      if (key2 in obj) {
        Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
      } else {
        obj[key2] = value;
      }
      return obj;
    }
    function _classCallCheck2(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
    function _possibleConstructorReturn2(self2, call2) {
      if (!self2) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }
      return call2 && (typeof call2 === "object" || typeof call2 === "function") ? call2 : self2;
    }
    function _inherits2(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
      }
      subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass);
    }
    function noop7() {
    }
    var Panel5 = (function(_React$Component) {
      _inherits2(Panel6, _React$Component);
      function Panel6(props) {
        _classCallCheck2(this, Panel6);
        var _this = _possibleConstructorReturn2(this, _React$Component.call(this, props));
        _initialiseProps.call(_this);
        var alpha = typeof props.alpha === "undefined" ? props.defaultAlpha : Math.min(props.alpha, props.defaultAlpha);
        var color = new _color2["default"](props.color || props.defaultColor);
        _this.state = {
          color,
          alpha
        };
        return _this;
      }
      Panel6.prototype.componentDidMount = function componentDidMount() {
        this.props.onMount(this.ref);
      };
      Panel6.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if (nextProps.color) {
          var color = new _color2["default"](nextProps.color);
          this.setState({
            color
          });
        }
        if (nextProps.alpha !== void 0) {
          this.setState({
            alpha: nextProps.alpha
          });
        }
      };
      Panel6.prototype.render = function render4() {
        var _cx, _this2 = this;
        var _props = this.props, prefixCls = _props.prefixCls, enableAlpha = _props.enableAlpha;
        var _state = this.state, color = _state.color, alpha = _state.alpha;
        var wrapClasses = (0, _classnames2["default"])((_cx = {}, _defineProperty11(_cx, prefixCls + "-wrap", true), _defineProperty11(_cx, prefixCls + "-wrap-has-alpha", enableAlpha), _cx));
        return _react2["default"].createElement(
          "div",
          {
            ref: function ref3(_ref) {
              return _this2.ref = _ref;
            },
            className: [prefixCls, this.props.className].join(" "),
            style: this.props.style,
            onFocus: this.onFocus,
            onBlur: this.onBlur,
            tabIndex: "0"
          },
          _react2["default"].createElement(
            "div",
            { className: prefixCls + "-inner" },
            _react2["default"].createElement(_Board2["default"], { rootPrefixCls: prefixCls, color, onChange: this.handleChange }),
            _react2["default"].createElement(
              "div",
              { className: wrapClasses },
              _react2["default"].createElement(
                "div",
                { className: prefixCls + "-wrap-ribbon" },
                _react2["default"].createElement(_Ribbon2["default"], { rootPrefixCls: prefixCls, color, onChange: this.handleChange })
              ),
              enableAlpha && _react2["default"].createElement(
                "div",
                { className: prefixCls + "-wrap-alpha" },
                _react2["default"].createElement(_Alpha2["default"], {
                  rootPrefixCls: prefixCls,
                  alpha,
                  color,
                  onChange: this.handleAlphaChange
                })
              ),
              _react2["default"].createElement(
                "div",
                { className: prefixCls + "-wrap-preview" },
                _react2["default"].createElement(_Preview2["default"], {
                  rootPrefixCls: prefixCls,
                  alpha,
                  onChange: this.handleChange,
                  onInputClick: this.onSystemColorPickerOpen,
                  color
                })
              )
            ),
            _react2["default"].createElement(
              "div",
              { className: prefixCls + "-wrap", style: { height: 40, marginTop: 6 } },
              _react2["default"].createElement(_Params2["default"], {
                rootPrefixCls: prefixCls,
                color,
                alpha,
                onAlphaChange: this.handleAlphaChange,
                onChange: this.handleChange,
                mode: this.props.mode,
                enableAlpha: this.props.enableAlpha
              })
            )
          )
        );
      };
      return Panel6;
    })(_react2["default"].Component);
    var _initialiseProps = function _initialiseProps2() {
      var _this3 = this;
      this.onSystemColorPickerOpen = function(e3) {
        if (e3.target.type === "color") {
          _this3.systemColorPickerOpen = true;
        }
      };
      this.onFocus = function() {
        if (_this3._blurTimer) {
          clearTimeout(_this3._blurTimer);
          _this3._blurTimer = null;
        } else {
          _this3.props.onFocus();
        }
      };
      this.onBlur = function() {
        if (_this3._blurTimer) {
          clearTimeout(_this3._blurTimer);
        }
        _this3._blurTimer = setTimeout(function() {
          if (_this3.systemColorPickerOpen) {
            _this3.systemColorPickerOpen = false;
            return;
          }
          _this3.props.onBlur();
        }, 100);
      };
      this.handleAlphaChange = function(alpha) {
        var color = _this3.state.color;
        color.alpha = alpha;
        _this3.setState({
          alpha,
          color
        });
        _this3.props.onChange({
          color: color.toHexString(),
          alpha
        });
      };
      this.handleChange = function(color) {
        var alpha = _this3.state.alpha;
        color.alpha = alpha;
        _this3.setState({ color });
        _this3.props.onChange({
          color: color.toHexString(),
          alpha: color.alpha
        });
      };
    };
    exports2["default"] = Panel5;
    Panel5.propTypes = {
      alpha: _propTypes2["default"].number,
      className: _propTypes2["default"].string,
      color: _validationColor2["default"],
      // Hex string
      defaultAlpha: _propTypes2["default"].number,
      defaultColor: _validationColor2["default"],
      // Hex string
      enableAlpha: _propTypes2["default"].bool,
      mode: _propTypes2["default"].oneOf(["RGB", "HSL", "HSB"]),
      onBlur: _propTypes2["default"].func,
      onChange: _propTypes2["default"].func,
      onFocus: _propTypes2["default"].func,
      onMount: _propTypes2["default"].func,
      prefixCls: _propTypes2["default"].string,
      style: _propTypes2["default"].object
    };
    Panel5.defaultProps = {
      className: "",
      defaultAlpha: 100,
      defaultColor: "#ff0000",
      enableAlpha: true,
      mode: "RGB",
      onBlur: noop7,
      onChange: noop7,
      onFocus: noop7,
      onMount: noop7,
      prefixCls: "rc-color-picker-panel",
      style: {}
    };
    module2.exports = exports2["default"];
  }
});

// ../../node_modules/rc-color-picker/lib/placements.js
var require_placements = __commonJS({
  "../../node_modules/rc-color-picker/lib/placements.js"(exports2, module2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    var autoAdjustOverflow3 = {
      adjustX: 1,
      adjustY: 1
    };
    var targetOffset3 = [0, 0];
    var placements4 = {
      topLeft: {
        points: ["bl", "tl"],
        overflow: autoAdjustOverflow3,
        offset: [0, -5],
        targetOffset: targetOffset3
      },
      topRight: {
        points: ["br", "tr"],
        overflow: autoAdjustOverflow3,
        offset: [0, -5],
        targetOffset: targetOffset3
      },
      bottomLeft: {
        points: ["tl", "bl"],
        overflow: autoAdjustOverflow3,
        offset: [0, 5],
        targetOffset: targetOffset3
      },
      bottomRight: {
        points: ["tr", "br"],
        overflow: autoAdjustOverflow3,
        offset: [0, 5],
        targetOffset: targetOffset3
      }
    };
    exports2["default"] = placements4;
    module2.exports = exports2["default"];
  }
});

// ../../node_modules/rc-color-picker/lib/ColorPicker.js
var require_ColorPicker = __commonJS({
  "../../node_modules/rc-color-picker/lib/ColorPicker.js"(exports2, module2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    var _slicedToArray17 = /* @__PURE__ */ (function() {
      function sliceIterator(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = void 0;
        try {
          for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
          }
        } catch (err) {
          _d = true;
          _e = err;
        } finally {
          try {
            if (!_n && _i["return"]) _i["return"]();
          } finally {
            if (_d) throw _e;
          }
        }
        return _arr;
      }
      return function(arr, i) {
        if (Array.isArray(arr)) {
          return arr;
        } else if (Symbol.iterator in Object(arr)) {
          return sliceIterator(arr, i);
        } else {
          throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
      };
    })();
    var _extends3 = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key2 in source) {
          if (Object.prototype.hasOwnProperty.call(source, key2)) {
            target[key2] = source[key2];
          }
        }
      }
      return target;
    };
    var _react = require_react();
    var _react2 = _interopRequireDefault(_react);
    var _reactDom = require_react_dom();
    var _propTypes = require_prop_types();
    var _propTypes2 = _interopRequireDefault(_propTypes);
    var _rcTrigger = require_lib4();
    var _rcTrigger2 = _interopRequireDefault(_rcTrigger);
    var _Panel = require_Panel();
    var _Panel2 = _interopRequireDefault(_Panel);
    var _placements = require_placements();
    var _placements2 = _interopRequireDefault(_placements);
    var _color = require_color2();
    var _color2 = _interopRequireDefault(_color);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    function _defaults(obj, defaults) {
      var keys4 = Object.getOwnPropertyNames(defaults);
      for (var i = 0; i < keys4.length; i++) {
        var key2 = keys4[i];
        var value = Object.getOwnPropertyDescriptor(defaults, key2);
        if (value && value.configurable && obj[key2] === void 0) {
          Object.defineProperty(obj, key2, value);
        }
      }
      return obj;
    }
    function _classCallCheck2(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
    function _possibleConstructorReturn2(self2, call2) {
      if (!self2) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }
      return call2 && (typeof call2 === "object" || typeof call2 === "function") ? call2 : self2;
    }
    function _inherits2(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
      }
      subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass);
    }
    function refFn(field, component) {
      this[field] = component;
    }
    function prevent(e3) {
      e3.preventDefault();
    }
    var ColorPicker3 = (function(_React$Component) {
      _inherits2(ColorPicker4, _React$Component);
      function ColorPicker4(props) {
        _classCallCheck2(this, ColorPicker4);
        var _this = _possibleConstructorReturn2(this, _React$Component.call(this, props));
        var alpha = typeof props.alpha === "undefined" ? props.defaultAlpha : Math.min(props.alpha, props.defaultAlpha);
        _this.state = {
          color: props.color || props.defaultColor,
          alpha,
          open: false
        };
        var events2 = ["onTriggerClick", "onChange", "onBlur", "getPickerElement", "getRootDOMNode", "getTriggerDOMNode", "onVisibleChange", "onPanelMount", "setOpen", "open", "close", "focus"];
        events2.forEach(function(e3) {
          _this[e3] = _this[e3].bind(_this);
        });
        _this.saveTriggerRef = refFn.bind(_this, "triggerInstance");
        return _this;
      }
      ColorPicker4.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if (nextProps.color) {
          this.setState({
            color: nextProps.color
          });
        }
        if (nextProps.alpha !== null && nextProps.alpha !== void 0) {
          this.setState({
            alpha: nextProps.alpha
          });
        }
      };
      ColorPicker4.prototype.onTriggerClick = function onTriggerClick() {
        this.setState({
          open: !this.state.open
        });
      };
      ColorPicker4.prototype.onChange = function onChange(colors) {
        var _this2 = this;
        this.setState(_extends3({}, colors), function() {
          _this2.props.onChange(_this2.state);
        });
      };
      ColorPicker4.prototype.onBlur = function onBlur() {
        this.setOpen(false);
      };
      ColorPicker4.prototype.onVisibleChange = function onVisibleChange(open2) {
        this.setOpen(open2);
      };
      ColorPicker4.prototype.onPanelMount = function onPanelMount(panelDOMRef) {
        if (this.state.open) {
          setTimeout(function() {
            panelDOMRef.focus();
          }, 1);
        }
      };
      ColorPicker4.prototype.setOpen = function setOpen(open2, callback) {
        var _this3 = this;
        if (this.state.open !== open2) {
          this.setState({
            open: open2
          }, function() {
            if (typeof callback === "function") callback();
            var _props = _this3.props, onOpen = _props.onOpen, onClose = _props.onClose;
            if (_this3.state.open) {
              onOpen(_this3.state);
            } else {
              onClose(_this3.state);
            }
          });
        }
      };
      ColorPicker4.prototype.getRootDOMNode = function getRootDOMNode() {
        return (0, _reactDom.findDOMNode)(this);
      };
      ColorPicker4.prototype.getTriggerDOMNode = function getTriggerDOMNode() {
        return (0, _reactDom.findDOMNode)(this.triggerInstance);
      };
      ColorPicker4.prototype.getPickerElement = function getPickerElement() {
        return _react2["default"].createElement(_Panel2["default"], {
          onMount: this.onPanelMount,
          defaultColor: this.state.color,
          alpha: this.state.alpha,
          enableAlpha: this.props.enableAlpha,
          prefixCls: this.props.prefixCls + "-panel",
          onChange: this.onChange,
          onBlur: this.onBlur,
          mode: this.props.mode,
          className: this.props.className
        });
      };
      ColorPicker4.prototype.open = function open2(callback) {
        this.setOpen(true, callback);
      };
      ColorPicker4.prototype.close = function close(callback) {
        this.setOpen(false, callback);
      };
      ColorPicker4.prototype.focus = function focus() {
        if (!this.state.open) {
          (0, _reactDom.findDOMNode)(this).focus();
        }
      };
      ColorPicker4.prototype.render = function render4() {
        var props = this.props;
        var state = this.state;
        var classes = [props.prefixCls + "-wrap", props.className];
        if (state.open) {
          classes.push(props.prefixCls + "-open");
        }
        var children = props.children;
        var _RGB = _slicedToArray17(new _color2["default"](this.state.color).RGB, 3), r2 = _RGB[0], g = _RGB[1], b = _RGB[2];
        var RGBA = [r2, g, b];
        RGBA.push(this.state.alpha / 100);
        if (children) {
          children = _react2["default"].cloneElement(children, {
            ref: this.saveTriggerRef,
            unselectable: "unselectable",
            style: {
              backgroundColor: "rgba(" + RGBA.join(",") + ")"
            },
            onClick: this.onTriggerClick,
            onMouseDown: prevent
          });
        }
        var prefixCls = props.prefixCls, placement = props.placement, style2 = props.style, getCalendarContainer = props.getCalendarContainer, align = props.align, animation = props.animation, disabled = props.disabled, transitionName = props.transitionName;
        return _react2["default"].createElement(
          "div",
          { className: classes.join(" ") },
          _react2["default"].createElement(
            _rcTrigger2["default"],
            {
              popup: this.getPickerElement(),
              popupAlign: align,
              builtinPlacements: _placements2["default"],
              popupPlacement: placement,
              action: disabled ? [] : ["click"],
              destroyPopupOnHide: true,
              getPopupContainer: getCalendarContainer,
              popupStyle: style2,
              popupAnimation: animation,
              popupTransitionName: transitionName,
              popupVisible: state.open,
              onPopupVisibleChange: this.onVisibleChange,
              prefixCls
            },
            children
          )
        );
      };
      return ColorPicker4;
    })(_react2["default"].Component);
    exports2["default"] = ColorPicker3;
    ColorPicker3.propTypes = {
      defaultColor: _propTypes2["default"].string,
      defaultAlpha: _propTypes2["default"].number,
      // can custom
      alpha: _propTypes2["default"].number,
      children: _propTypes2["default"].node.isRequired,
      className: _propTypes2["default"].string,
      color: _propTypes2["default"].string,
      enableAlpha: _propTypes2["default"].bool,
      mode: _propTypes2["default"].oneOf(["RGB", "HSL", "HSB"]),
      onChange: _propTypes2["default"].func,
      onClose: _propTypes2["default"].func,
      onOpen: _propTypes2["default"].func,
      placement: _propTypes2["default"].oneOf(["topLeft", "topRight", "bottomLeft", "bottomRight"]),
      prefixCls: _propTypes2["default"].string.isRequired,
      style: _propTypes2["default"].object
    };
    ColorPicker3.defaultProps = {
      defaultColor: "#F00",
      defaultAlpha: 100,
      onChange: function onChange() {
      },
      onOpen: function onOpen() {
      },
      onClose: function onClose() {
      },
      children: _react2["default"].createElement("span", { className: "rc-color-picker-trigger" }),
      className: "",
      enableAlpha: true,
      placement: "topLeft",
      prefixCls: "rc-color-picker",
      style: {}
    };
    module2.exports = exports2["default"];
  }
});

// ../../node_modules/rc-color-picker/lib/index.js
var require_lib5 = __commonJS({
  "../../node_modules/rc-color-picker/lib/index.js"(exports2, module2) {
    "use strict";
    module2.exports = require_ColorPicker();
    module2.exports.Panel = require_Panel();
  }
});

// ../../node_modules/dayjs/plugin/quarterOfYear.js
var require_quarterOfYear = __commonJS({
  "../../node_modules/dayjs/plugin/quarterOfYear.js"(exports2, module2) {
    !(function(t2, n2) {
      "object" == typeof exports2 && "undefined" != typeof module2 ? module2.exports = n2() : "function" == typeof define && define.amd ? define(n2) : (t2 = "undefined" != typeof globalThis ? globalThis : t2 || self).dayjs_plugin_quarterOfYear = n2();
    })(exports2, (function() {
      "use strict";
      var t2 = "month", n2 = "quarter";
      return function(e3, i) {
        var r2 = i.prototype;
        r2.quarter = function(t3) {
          return this.$utils().u(t3) ? Math.ceil((this.month() + 1) / 3) : this.month(this.month() % 3 + 3 * (t3 - 1));
        };
        var s = r2.add;
        r2.add = function(e4, i2) {
          return e4 = Number(e4), this.$utils().p(i2) === n2 ? this.add(3 * e4, t2) : s.bind(this)(e4, i2);
        };
        var u = r2.startOf;
        r2.startOf = function(e4, i2) {
          var r3 = this.$utils(), s2 = !!r3.u(i2) || i2;
          if (r3.p(e4) === n2) {
            var o3 = this.quarter() - 1;
            return s2 ? this.month(3 * o3).startOf(t2).startOf("day") : this.month(3 * o3 + 2).endOf(t2).endOf("day");
          }
          return u.bind(this)(e4, i2);
        };
      };
    }));
  }
});

// ../../node_modules/@ant-design/icons-svg/lib/asn/PictureOutlined.js
var require_PictureOutlined = __commonJS({
  "../../node_modules/@ant-design/icons-svg/lib/asn/PictureOutlined.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    var PictureOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136v-39.9l138.5-164.3 150.1 178L658.1 489 888 761.6V792zm0-129.8L664.2 396.8c-3.2-3.8-9-3.8-12.2 0L424.6 666.4l-144-170.7c-3.2-3.8-9-3.8-12.2 0L136 652.7V232h752v430.2zM304 456a88 88 0 100-176 88 88 0 000 176zm0-116c15.5 0 28 12.5 28 28s-12.5 28-28 28-28-12.5-28-28 12.5-28 28-28z" } }] }, "name": "picture", "theme": "outlined" };
    exports2.default = PictureOutlined;
  }
});

// ../../node_modules/@babel/runtime/helpers/arrayWithHoles.js
var require_arrayWithHoles = __commonJS({
  "../../node_modules/@babel/runtime/helpers/arrayWithHoles.js"(exports2, module2) {
    function _arrayWithHoles18(r2) {
      if (Array.isArray(r2)) return r2;
    }
    module2.exports = _arrayWithHoles18, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
  }
});

// ../../node_modules/@babel/runtime/helpers/iterableToArrayLimit.js
var require_iterableToArrayLimit = __commonJS({
  "../../node_modules/@babel/runtime/helpers/iterableToArrayLimit.js"(exports2, module2) {
    function _iterableToArrayLimit17(r2, l2) {
      var t2 = null == r2 ? null : "undefined" != typeof Symbol && r2[Symbol.iterator] || r2["@@iterator"];
      if (null != t2) {
        var e3, n2, i, u, a = [], f = true, o3 = false;
        try {
          if (i = (t2 = t2.call(r2)).next, 0 === l2) {
            if (Object(t2) !== t2) return;
            f = false;
          } else for (; !(f = (e3 = i.call(t2)).done) && (a.push(e3.value), a.length !== l2); f = true) ;
        } catch (r3) {
          o3 = true, n2 = r3;
        } finally {
          try {
            if (!f && null != t2["return"] && (u = t2["return"](), Object(u) !== u)) return;
          } finally {
            if (o3) throw n2;
          }
        }
        return a;
      }
    }
    module2.exports = _iterableToArrayLimit17, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
  }
});

// ../../node_modules/@babel/runtime/helpers/arrayLikeToArray.js
var require_arrayLikeToArray = __commonJS({
  "../../node_modules/@babel/runtime/helpers/arrayLikeToArray.js"(exports2, module2) {
    function _arrayLikeToArray25(r2, a) {
      (null == a || a > r2.length) && (a = r2.length);
      for (var e3 = 0, n2 = Array(a); e3 < a; e3++) n2[e3] = r2[e3];
      return n2;
    }
    module2.exports = _arrayLikeToArray25, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
  }
});

// ../../node_modules/@babel/runtime/helpers/unsupportedIterableToArray.js
var require_unsupportedIterableToArray = __commonJS({
  "../../node_modules/@babel/runtime/helpers/unsupportedIterableToArray.js"(exports2, module2) {
    var arrayLikeToArray = require_arrayLikeToArray();
    function _unsupportedIterableToArray25(r2, a) {
      if (r2) {
        if ("string" == typeof r2) return arrayLikeToArray(r2, a);
        var t2 = {}.toString.call(r2).slice(8, -1);
        return "Object" === t2 && r2.constructor && (t2 = r2.constructor.name), "Map" === t2 || "Set" === t2 ? Array.from(r2) : "Arguments" === t2 || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t2) ? arrayLikeToArray(r2, a) : void 0;
      }
    }
    module2.exports = _unsupportedIterableToArray25, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
  }
});

// ../../node_modules/@babel/runtime/helpers/nonIterableRest.js
var require_nonIterableRest = __commonJS({
  "../../node_modules/@babel/runtime/helpers/nonIterableRest.js"(exports2, module2) {
    function _nonIterableRest18() {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    module2.exports = _nonIterableRest18, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
  }
});

// ../../node_modules/@babel/runtime/helpers/slicedToArray.js
var require_slicedToArray = __commonJS({
  "../../node_modules/@babel/runtime/helpers/slicedToArray.js"(exports2, module2) {
    var arrayWithHoles = require_arrayWithHoles();
    var iterableToArrayLimit = require_iterableToArrayLimit();
    var unsupportedIterableToArray = require_unsupportedIterableToArray();
    var nonIterableRest = require_nonIterableRest();
    function _slicedToArray17(r2, e3) {
      return arrayWithHoles(r2) || iterableToArrayLimit(r2, e3) || unsupportedIterableToArray(r2, e3) || nonIterableRest();
    }
    module2.exports = _slicedToArray17, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
  }
});

// ../../node_modules/@babel/runtime/helpers/objectWithoutPropertiesLoose.js
var require_objectWithoutPropertiesLoose = __commonJS({
  "../../node_modules/@babel/runtime/helpers/objectWithoutPropertiesLoose.js"(exports2, module2) {
    function _objectWithoutPropertiesLoose3(r2, e3) {
      if (null == r2) return {};
      var t2 = {};
      for (var n2 in r2) if ({}.hasOwnProperty.call(r2, n2)) {
        if (-1 !== e3.indexOf(n2)) continue;
        t2[n2] = r2[n2];
      }
      return t2;
    }
    module2.exports = _objectWithoutPropertiesLoose3, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
  }
});

// ../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js
var require_objectWithoutProperties2 = __commonJS({
  "../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js"(exports2, module2) {
    var objectWithoutPropertiesLoose = require_objectWithoutPropertiesLoose();
    function _objectWithoutProperties3(e3, t2) {
      if (null == e3) return {};
      var o3, r2, i = objectWithoutPropertiesLoose(e3, t2);
      if (Object.getOwnPropertySymbols) {
        var n2 = Object.getOwnPropertySymbols(e3);
        for (r2 = 0; r2 < n2.length; r2++) o3 = n2[r2], -1 === t2.indexOf(o3) && {}.propertyIsEnumerable.call(e3, o3) && (i[o3] = e3[o3]);
      }
      return i;
    }
    module2.exports = _objectWithoutProperties3, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
  }
});

// ../../node_modules/form-render/node_modules/@ant-design/icons/lib/components/Context.js
var require_Context = __commonJS({
  "../../node_modules/form-render/node_modules/@ant-design/icons/lib/components/Context.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = void 0;
    var _react = require_react();
    var IconContext2 = /* @__PURE__ */ (0, _react.createContext)({});
    var _default = exports2.default = IconContext2;
  }
});

// ../../node_modules/@ctrl/tinycolor/dist/util.js
var require_util2 = __commonJS({
  "../../node_modules/@ctrl/tinycolor/dist/util.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.pad2 = exports2.convertToPercentage = exports2.boundAlpha = exports2.isPercentage = exports2.isOnePointZero = exports2.clamp01 = exports2.bound01 = void 0;
    function bound01(n2, max) {
      if (isOnePointZero(n2)) {
        n2 = "100%";
      }
      var isPercent = isPercentage(n2);
      n2 = max === 360 ? n2 : Math.min(max, Math.max(0, parseFloat(n2)));
      if (isPercent) {
        n2 = parseInt(String(n2 * max), 10) / 100;
      }
      if (Math.abs(n2 - max) < 1e-6) {
        return 1;
      }
      if (max === 360) {
        n2 = (n2 < 0 ? n2 % max + max : n2 % max) / parseFloat(String(max));
      } else {
        n2 = n2 % max / parseFloat(String(max));
      }
      return n2;
    }
    exports2.bound01 = bound01;
    function clamp01(val) {
      return Math.min(1, Math.max(0, val));
    }
    exports2.clamp01 = clamp01;
    function isOnePointZero(n2) {
      return typeof n2 === "string" && n2.indexOf(".") !== -1 && parseFloat(n2) === 1;
    }
    exports2.isOnePointZero = isOnePointZero;
    function isPercentage(n2) {
      return typeof n2 === "string" && n2.indexOf("%") !== -1;
    }
    exports2.isPercentage = isPercentage;
    function boundAlpha(a) {
      a = parseFloat(a);
      if (isNaN(a) || a < 0 || a > 1) {
        a = 1;
      }
      return a;
    }
    exports2.boundAlpha = boundAlpha;
    function convertToPercentage(n2) {
      if (n2 <= 1) {
        return "".concat(Number(n2) * 100, "%");
      }
      return n2;
    }
    exports2.convertToPercentage = convertToPercentage;
    function pad2(c) {
      return c.length === 1 ? "0" + c : String(c);
    }
    exports2.pad2 = pad2;
  }
});

// ../../node_modules/@ctrl/tinycolor/dist/conversion.js
var require_conversion = __commonJS({
  "../../node_modules/@ctrl/tinycolor/dist/conversion.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.numberInputToObject = exports2.parseIntFromHex = exports2.convertHexToDecimal = exports2.convertDecimalToHex = exports2.rgbaToArgbHex = exports2.rgbaToHex = exports2.rgbToHex = exports2.hsvToRgb = exports2.rgbToHsv = exports2.hslToRgb = exports2.rgbToHsl = exports2.rgbToRgb = void 0;
    var util_js_1 = require_util2();
    function rgbToRgb(r2, g, b) {
      return {
        r: (0, util_js_1.bound01)(r2, 255) * 255,
        g: (0, util_js_1.bound01)(g, 255) * 255,
        b: (0, util_js_1.bound01)(b, 255) * 255
      };
    }
    exports2.rgbToRgb = rgbToRgb;
    function rgbToHsl(r2, g, b) {
      r2 = (0, util_js_1.bound01)(r2, 255);
      g = (0, util_js_1.bound01)(g, 255);
      b = (0, util_js_1.bound01)(b, 255);
      var max = Math.max(r2, g, b);
      var min = Math.min(r2, g, b);
      var h2 = 0;
      var s = 0;
      var l2 = (max + min) / 2;
      if (max === min) {
        s = 0;
        h2 = 0;
      } else {
        var d = max - min;
        s = l2 > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch (max) {
          case r2:
            h2 = (g - b) / d + (g < b ? 6 : 0);
            break;
          case g:
            h2 = (b - r2) / d + 2;
            break;
          case b:
            h2 = (r2 - g) / d + 4;
            break;
          default:
            break;
        }
        h2 /= 6;
      }
      return { h: h2, s, l: l2 };
    }
    exports2.rgbToHsl = rgbToHsl;
    function hue2rgb(p, q, t2) {
      if (t2 < 0) {
        t2 += 1;
      }
      if (t2 > 1) {
        t2 -= 1;
      }
      if (t2 < 1 / 6) {
        return p + (q - p) * (6 * t2);
      }
      if (t2 < 1 / 2) {
        return q;
      }
      if (t2 < 2 / 3) {
        return p + (q - p) * (2 / 3 - t2) * 6;
      }
      return p;
    }
    function hslToRgb(h2, s, l2) {
      var r2;
      var g;
      var b;
      h2 = (0, util_js_1.bound01)(h2, 360);
      s = (0, util_js_1.bound01)(s, 100);
      l2 = (0, util_js_1.bound01)(l2, 100);
      if (s === 0) {
        g = l2;
        b = l2;
        r2 = l2;
      } else {
        var q = l2 < 0.5 ? l2 * (1 + s) : l2 + s - l2 * s;
        var p = 2 * l2 - q;
        r2 = hue2rgb(p, q, h2 + 1 / 3);
        g = hue2rgb(p, q, h2);
        b = hue2rgb(p, q, h2 - 1 / 3);
      }
      return { r: r2 * 255, g: g * 255, b: b * 255 };
    }
    exports2.hslToRgb = hslToRgb;
    function rgbToHsv(r2, g, b) {
      r2 = (0, util_js_1.bound01)(r2, 255);
      g = (0, util_js_1.bound01)(g, 255);
      b = (0, util_js_1.bound01)(b, 255);
      var max = Math.max(r2, g, b);
      var min = Math.min(r2, g, b);
      var h2 = 0;
      var v = max;
      var d = max - min;
      var s = max === 0 ? 0 : d / max;
      if (max === min) {
        h2 = 0;
      } else {
        switch (max) {
          case r2:
            h2 = (g - b) / d + (g < b ? 6 : 0);
            break;
          case g:
            h2 = (b - r2) / d + 2;
            break;
          case b:
            h2 = (r2 - g) / d + 4;
            break;
          default:
            break;
        }
        h2 /= 6;
      }
      return { h: h2, s, v };
    }
    exports2.rgbToHsv = rgbToHsv;
    function hsvToRgb(h2, s, v) {
      h2 = (0, util_js_1.bound01)(h2, 360) * 6;
      s = (0, util_js_1.bound01)(s, 100);
      v = (0, util_js_1.bound01)(v, 100);
      var i = Math.floor(h2);
      var f = h2 - i;
      var p = v * (1 - s);
      var q = v * (1 - f * s);
      var t2 = v * (1 - (1 - f) * s);
      var mod = i % 6;
      var r2 = [v, q, p, p, t2, v][mod];
      var g = [t2, v, v, q, p, p][mod];
      var b = [p, p, t2, v, v, q][mod];
      return { r: r2 * 255, g: g * 255, b: b * 255 };
    }
    exports2.hsvToRgb = hsvToRgb;
    function rgbToHex(r2, g, b, allow3Char) {
      var hex2 = [
        (0, util_js_1.pad2)(Math.round(r2).toString(16)),
        (0, util_js_1.pad2)(Math.round(g).toString(16)),
        (0, util_js_1.pad2)(Math.round(b).toString(16))
      ];
      if (allow3Char && hex2[0].startsWith(hex2[0].charAt(1)) && hex2[1].startsWith(hex2[1].charAt(1)) && hex2[2].startsWith(hex2[2].charAt(1))) {
        return hex2[0].charAt(0) + hex2[1].charAt(0) + hex2[2].charAt(0);
      }
      return hex2.join("");
    }
    exports2.rgbToHex = rgbToHex;
    function rgbaToHex(r2, g, b, a, allow4Char) {
      var hex2 = [
        (0, util_js_1.pad2)(Math.round(r2).toString(16)),
        (0, util_js_1.pad2)(Math.round(g).toString(16)),
        (0, util_js_1.pad2)(Math.round(b).toString(16)),
        (0, util_js_1.pad2)(convertDecimalToHex(a))
      ];
      if (allow4Char && hex2[0].startsWith(hex2[0].charAt(1)) && hex2[1].startsWith(hex2[1].charAt(1)) && hex2[2].startsWith(hex2[2].charAt(1)) && hex2[3].startsWith(hex2[3].charAt(1))) {
        return hex2[0].charAt(0) + hex2[1].charAt(0) + hex2[2].charAt(0) + hex2[3].charAt(0);
      }
      return hex2.join("");
    }
    exports2.rgbaToHex = rgbaToHex;
    function rgbaToArgbHex(r2, g, b, a) {
      var hex2 = [
        (0, util_js_1.pad2)(convertDecimalToHex(a)),
        (0, util_js_1.pad2)(Math.round(r2).toString(16)),
        (0, util_js_1.pad2)(Math.round(g).toString(16)),
        (0, util_js_1.pad2)(Math.round(b).toString(16))
      ];
      return hex2.join("");
    }
    exports2.rgbaToArgbHex = rgbaToArgbHex;
    function convertDecimalToHex(d) {
      return Math.round(parseFloat(d) * 255).toString(16);
    }
    exports2.convertDecimalToHex = convertDecimalToHex;
    function convertHexToDecimal(h2) {
      return parseIntFromHex(h2) / 255;
    }
    exports2.convertHexToDecimal = convertHexToDecimal;
    function parseIntFromHex(val) {
      return parseInt(val, 16);
    }
    exports2.parseIntFromHex = parseIntFromHex;
    function numberInputToObject(color) {
      return {
        r: color >> 16,
        g: (color & 65280) >> 8,
        b: color & 255
      };
    }
    exports2.numberInputToObject = numberInputToObject;
  }
});

// ../../node_modules/@ctrl/tinycolor/dist/css-color-names.js
var require_css_color_names = __commonJS({
  "../../node_modules/@ctrl/tinycolor/dist/css-color-names.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.names = void 0;
    exports2.names = {
      aliceblue: "#f0f8ff",
      antiquewhite: "#faebd7",
      aqua: "#00ffff",
      aquamarine: "#7fffd4",
      azure: "#f0ffff",
      beige: "#f5f5dc",
      bisque: "#ffe4c4",
      black: "#000000",
      blanchedalmond: "#ffebcd",
      blue: "#0000ff",
      blueviolet: "#8a2be2",
      brown: "#a52a2a",
      burlywood: "#deb887",
      cadetblue: "#5f9ea0",
      chartreuse: "#7fff00",
      chocolate: "#d2691e",
      coral: "#ff7f50",
      cornflowerblue: "#6495ed",
      cornsilk: "#fff8dc",
      crimson: "#dc143c",
      cyan: "#00ffff",
      darkblue: "#00008b",
      darkcyan: "#008b8b",
      darkgoldenrod: "#b8860b",
      darkgray: "#a9a9a9",
      darkgreen: "#006400",
      darkgrey: "#a9a9a9",
      darkkhaki: "#bdb76b",
      darkmagenta: "#8b008b",
      darkolivegreen: "#556b2f",
      darkorange: "#ff8c00",
      darkorchid: "#9932cc",
      darkred: "#8b0000",
      darksalmon: "#e9967a",
      darkseagreen: "#8fbc8f",
      darkslateblue: "#483d8b",
      darkslategray: "#2f4f4f",
      darkslategrey: "#2f4f4f",
      darkturquoise: "#00ced1",
      darkviolet: "#9400d3",
      deeppink: "#ff1493",
      deepskyblue: "#00bfff",
      dimgray: "#696969",
      dimgrey: "#696969",
      dodgerblue: "#1e90ff",
      firebrick: "#b22222",
      floralwhite: "#fffaf0",
      forestgreen: "#228b22",
      fuchsia: "#ff00ff",
      gainsboro: "#dcdcdc",
      ghostwhite: "#f8f8ff",
      goldenrod: "#daa520",
      gold: "#ffd700",
      gray: "#808080",
      green: "#008000",
      greenyellow: "#adff2f",
      grey: "#808080",
      honeydew: "#f0fff0",
      hotpink: "#ff69b4",
      indianred: "#cd5c5c",
      indigo: "#4b0082",
      ivory: "#fffff0",
      khaki: "#f0e68c",
      lavenderblush: "#fff0f5",
      lavender: "#e6e6fa",
      lawngreen: "#7cfc00",
      lemonchiffon: "#fffacd",
      lightblue: "#add8e6",
      lightcoral: "#f08080",
      lightcyan: "#e0ffff",
      lightgoldenrodyellow: "#fafad2",
      lightgray: "#d3d3d3",
      lightgreen: "#90ee90",
      lightgrey: "#d3d3d3",
      lightpink: "#ffb6c1",
      lightsalmon: "#ffa07a",
      lightseagreen: "#20b2aa",
      lightskyblue: "#87cefa",
      lightslategray: "#778899",
      lightslategrey: "#778899",
      lightsteelblue: "#b0c4de",
      lightyellow: "#ffffe0",
      lime: "#00ff00",
      limegreen: "#32cd32",
      linen: "#faf0e6",
      magenta: "#ff00ff",
      maroon: "#800000",
      mediumaquamarine: "#66cdaa",
      mediumblue: "#0000cd",
      mediumorchid: "#ba55d3",
      mediumpurple: "#9370db",
      mediumseagreen: "#3cb371",
      mediumslateblue: "#7b68ee",
      mediumspringgreen: "#00fa9a",
      mediumturquoise: "#48d1cc",
      mediumvioletred: "#c71585",
      midnightblue: "#191970",
      mintcream: "#f5fffa",
      mistyrose: "#ffe4e1",
      moccasin: "#ffe4b5",
      navajowhite: "#ffdead",
      navy: "#000080",
      oldlace: "#fdf5e6",
      olive: "#808000",
      olivedrab: "#6b8e23",
      orange: "#ffa500",
      orangered: "#ff4500",
      orchid: "#da70d6",
      palegoldenrod: "#eee8aa",
      palegreen: "#98fb98",
      paleturquoise: "#afeeee",
      palevioletred: "#db7093",
      papayawhip: "#ffefd5",
      peachpuff: "#ffdab9",
      peru: "#cd853f",
      pink: "#ffc0cb",
      plum: "#dda0dd",
      powderblue: "#b0e0e6",
      purple: "#800080",
      rebeccapurple: "#663399",
      red: "#ff0000",
      rosybrown: "#bc8f8f",
      royalblue: "#4169e1",
      saddlebrown: "#8b4513",
      salmon: "#fa8072",
      sandybrown: "#f4a460",
      seagreen: "#2e8b57",
      seashell: "#fff5ee",
      sienna: "#a0522d",
      silver: "#c0c0c0",
      skyblue: "#87ceeb",
      slateblue: "#6a5acd",
      slategray: "#708090",
      slategrey: "#708090",
      snow: "#fffafa",
      springgreen: "#00ff7f",
      steelblue: "#4682b4",
      tan: "#d2b48c",
      teal: "#008080",
      thistle: "#d8bfd8",
      tomato: "#ff6347",
      turquoise: "#40e0d0",
      violet: "#ee82ee",
      wheat: "#f5deb3",
      white: "#ffffff",
      whitesmoke: "#f5f5f5",
      yellow: "#ffff00",
      yellowgreen: "#9acd32"
    };
  }
});

// ../../node_modules/@ctrl/tinycolor/dist/format-input.js
var require_format_input = __commonJS({
  "../../node_modules/@ctrl/tinycolor/dist/format-input.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.isValidCSSUnit = exports2.stringInputToObject = exports2.inputToRGB = void 0;
    var conversion_js_1 = require_conversion();
    var css_color_names_js_1 = require_css_color_names();
    var util_js_1 = require_util2();
    function inputToRGB(color) {
      var rgb2 = { r: 0, g: 0, b: 0 };
      var a = 1;
      var s = null;
      var v = null;
      var l2 = null;
      var ok = false;
      var format3 = false;
      if (typeof color === "string") {
        color = stringInputToObject(color);
      }
      if (typeof color === "object") {
        if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
          rgb2 = (0, conversion_js_1.rgbToRgb)(color.r, color.g, color.b);
          ok = true;
          format3 = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
        } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
          s = (0, util_js_1.convertToPercentage)(color.s);
          v = (0, util_js_1.convertToPercentage)(color.v);
          rgb2 = (0, conversion_js_1.hsvToRgb)(color.h, s, v);
          ok = true;
          format3 = "hsv";
        } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
          s = (0, util_js_1.convertToPercentage)(color.s);
          l2 = (0, util_js_1.convertToPercentage)(color.l);
          rgb2 = (0, conversion_js_1.hslToRgb)(color.h, s, l2);
          ok = true;
          format3 = "hsl";
        }
        if (Object.prototype.hasOwnProperty.call(color, "a")) {
          a = color.a;
        }
      }
      a = (0, util_js_1.boundAlpha)(a);
      return {
        ok,
        format: color.format || format3,
        r: Math.min(255, Math.max(rgb2.r, 0)),
        g: Math.min(255, Math.max(rgb2.g, 0)),
        b: Math.min(255, Math.max(rgb2.b, 0)),
        a
      };
    }
    exports2.inputToRGB = inputToRGB;
    var CSS_INTEGER = "[-\\+]?\\d+%?";
    var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";
    var CSS_UNIT = "(?:".concat(CSS_NUMBER, ")|(?:").concat(CSS_INTEGER, ")");
    var PERMISSIVE_MATCH3 = "[\\s|\\(]+(".concat(CSS_UNIT, ")[,|\\s]+(").concat(CSS_UNIT, ")[,|\\s]+(").concat(CSS_UNIT, ")\\s*\\)?");
    var PERMISSIVE_MATCH4 = "[\\s|\\(]+(".concat(CSS_UNIT, ")[,|\\s]+(").concat(CSS_UNIT, ")[,|\\s]+(").concat(CSS_UNIT, ")[,|\\s]+(").concat(CSS_UNIT, ")\\s*\\)?");
    var matchers = {
      CSS_UNIT: new RegExp(CSS_UNIT),
      rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
      rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
      hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
      hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
      hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
      hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
      hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
      hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
      hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
      hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
    };
    function stringInputToObject(color) {
      color = color.trim().toLowerCase();
      if (color.length === 0) {
        return false;
      }
      var named = false;
      if (css_color_names_js_1.names[color]) {
        color = css_color_names_js_1.names[color];
        named = true;
      } else if (color === "transparent") {
        return { r: 0, g: 0, b: 0, a: 0, format: "name" };
      }
      var match2 = matchers.rgb.exec(color);
      if (match2) {
        return { r: match2[1], g: match2[2], b: match2[3] };
      }
      match2 = matchers.rgba.exec(color);
      if (match2) {
        return { r: match2[1], g: match2[2], b: match2[3], a: match2[4] };
      }
      match2 = matchers.hsl.exec(color);
      if (match2) {
        return { h: match2[1], s: match2[2], l: match2[3] };
      }
      match2 = matchers.hsla.exec(color);
      if (match2) {
        return { h: match2[1], s: match2[2], l: match2[3], a: match2[4] };
      }
      match2 = matchers.hsv.exec(color);
      if (match2) {
        return { h: match2[1], s: match2[2], v: match2[3] };
      }
      match2 = matchers.hsva.exec(color);
      if (match2) {
        return { h: match2[1], s: match2[2], v: match2[3], a: match2[4] };
      }
      match2 = matchers.hex8.exec(color);
      if (match2) {
        return {
          r: (0, conversion_js_1.parseIntFromHex)(match2[1]),
          g: (0, conversion_js_1.parseIntFromHex)(match2[2]),
          b: (0, conversion_js_1.parseIntFromHex)(match2[3]),
          a: (0, conversion_js_1.convertHexToDecimal)(match2[4]),
          format: named ? "name" : "hex8"
        };
      }
      match2 = matchers.hex6.exec(color);
      if (match2) {
        return {
          r: (0, conversion_js_1.parseIntFromHex)(match2[1]),
          g: (0, conversion_js_1.parseIntFromHex)(match2[2]),
          b: (0, conversion_js_1.parseIntFromHex)(match2[3]),
          format: named ? "name" : "hex"
        };
      }
      match2 = matchers.hex4.exec(color);
      if (match2) {
        return {
          r: (0, conversion_js_1.parseIntFromHex)(match2[1] + match2[1]),
          g: (0, conversion_js_1.parseIntFromHex)(match2[2] + match2[2]),
          b: (0, conversion_js_1.parseIntFromHex)(match2[3] + match2[3]),
          a: (0, conversion_js_1.convertHexToDecimal)(match2[4] + match2[4]),
          format: named ? "name" : "hex8"
        };
      }
      match2 = matchers.hex3.exec(color);
      if (match2) {
        return {
          r: (0, conversion_js_1.parseIntFromHex)(match2[1] + match2[1]),
          g: (0, conversion_js_1.parseIntFromHex)(match2[2] + match2[2]),
          b: (0, conversion_js_1.parseIntFromHex)(match2[3] + match2[3]),
          format: named ? "name" : "hex"
        };
      }
      return false;
    }
    exports2.stringInputToObject = stringInputToObject;
    function isValidCSSUnit(color) {
      return Boolean(matchers.CSS_UNIT.exec(String(color)));
    }
    exports2.isValidCSSUnit = isValidCSSUnit;
  }
});

// ../../node_modules/@ctrl/tinycolor/dist/index.js
var require_dist = __commonJS({
  "../../node_modules/@ctrl/tinycolor/dist/index.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.tinycolor = exports2.TinyColor = void 0;
    var conversion_js_1 = require_conversion();
    var css_color_names_js_1 = require_css_color_names();
    var format_input_1 = require_format_input();
    var util_js_1 = require_util2();
    var TinyColor = (
      /** @class */
      (function() {
        function TinyColor2(color, opts) {
          if (color === void 0) {
            color = "";
          }
          if (opts === void 0) {
            opts = {};
          }
          var _a;
          if (color instanceof TinyColor2) {
            return color;
          }
          if (typeof color === "number") {
            color = (0, conversion_js_1.numberInputToObject)(color);
          }
          this.originalInput = color;
          var rgb2 = (0, format_input_1.inputToRGB)(color);
          this.originalInput = color;
          this.r = rgb2.r;
          this.g = rgb2.g;
          this.b = rgb2.b;
          this.a = rgb2.a;
          this.roundA = Math.round(100 * this.a) / 100;
          this.format = (_a = opts.format) !== null && _a !== void 0 ? _a : rgb2.format;
          this.gradientType = opts.gradientType;
          if (this.r < 1) {
            this.r = Math.round(this.r);
          }
          if (this.g < 1) {
            this.g = Math.round(this.g);
          }
          if (this.b < 1) {
            this.b = Math.round(this.b);
          }
          this.isValid = rgb2.ok;
        }
        TinyColor2.prototype.isDark = function() {
          return this.getBrightness() < 128;
        };
        TinyColor2.prototype.isLight = function() {
          return !this.isDark();
        };
        TinyColor2.prototype.getBrightness = function() {
          var rgb2 = this.toRgb();
          return (rgb2.r * 299 + rgb2.g * 587 + rgb2.b * 114) / 1e3;
        };
        TinyColor2.prototype.getLuminance = function() {
          var rgb2 = this.toRgb();
          var R;
          var G;
          var B;
          var RsRGB = rgb2.r / 255;
          var GsRGB = rgb2.g / 255;
          var BsRGB = rgb2.b / 255;
          if (RsRGB <= 0.03928) {
            R = RsRGB / 12.92;
          } else {
            R = Math.pow((RsRGB + 0.055) / 1.055, 2.4);
          }
          if (GsRGB <= 0.03928) {
            G = GsRGB / 12.92;
          } else {
            G = Math.pow((GsRGB + 0.055) / 1.055, 2.4);
          }
          if (BsRGB <= 0.03928) {
            B = BsRGB / 12.92;
          } else {
            B = Math.pow((BsRGB + 0.055) / 1.055, 2.4);
          }
          return 0.2126 * R + 0.7152 * G + 0.0722 * B;
        };
        TinyColor2.prototype.getAlpha = function() {
          return this.a;
        };
        TinyColor2.prototype.setAlpha = function(alpha) {
          this.a = (0, util_js_1.boundAlpha)(alpha);
          this.roundA = Math.round(100 * this.a) / 100;
          return this;
        };
        TinyColor2.prototype.isMonochrome = function() {
          var s = this.toHsl().s;
          return s === 0;
        };
        TinyColor2.prototype.toHsv = function() {
          var hsv = (0, conversion_js_1.rgbToHsv)(this.r, this.g, this.b);
          return { h: hsv.h * 360, s: hsv.s, v: hsv.v, a: this.a };
        };
        TinyColor2.prototype.toHsvString = function() {
          var hsv = (0, conversion_js_1.rgbToHsv)(this.r, this.g, this.b);
          var h2 = Math.round(hsv.h * 360);
          var s = Math.round(hsv.s * 100);
          var v = Math.round(hsv.v * 100);
          return this.a === 1 ? "hsv(".concat(h2, ", ").concat(s, "%, ").concat(v, "%)") : "hsva(".concat(h2, ", ").concat(s, "%, ").concat(v, "%, ").concat(this.roundA, ")");
        };
        TinyColor2.prototype.toHsl = function() {
          var hsl = (0, conversion_js_1.rgbToHsl)(this.r, this.g, this.b);
          return { h: hsl.h * 360, s: hsl.s, l: hsl.l, a: this.a };
        };
        TinyColor2.prototype.toHslString = function() {
          var hsl = (0, conversion_js_1.rgbToHsl)(this.r, this.g, this.b);
          var h2 = Math.round(hsl.h * 360);
          var s = Math.round(hsl.s * 100);
          var l2 = Math.round(hsl.l * 100);
          return this.a === 1 ? "hsl(".concat(h2, ", ").concat(s, "%, ").concat(l2, "%)") : "hsla(".concat(h2, ", ").concat(s, "%, ").concat(l2, "%, ").concat(this.roundA, ")");
        };
        TinyColor2.prototype.toHex = function(allow3Char) {
          if (allow3Char === void 0) {
            allow3Char = false;
          }
          return (0, conversion_js_1.rgbToHex)(this.r, this.g, this.b, allow3Char);
        };
        TinyColor2.prototype.toHexString = function(allow3Char) {
          if (allow3Char === void 0) {
            allow3Char = false;
          }
          return "#" + this.toHex(allow3Char);
        };
        TinyColor2.prototype.toHex8 = function(allow4Char) {
          if (allow4Char === void 0) {
            allow4Char = false;
          }
          return (0, conversion_js_1.rgbaToHex)(this.r, this.g, this.b, this.a, allow4Char);
        };
        TinyColor2.prototype.toHex8String = function(allow4Char) {
          if (allow4Char === void 0) {
            allow4Char = false;
          }
          return "#" + this.toHex8(allow4Char);
        };
        TinyColor2.prototype.toHexShortString = function(allowShortChar) {
          if (allowShortChar === void 0) {
            allowShortChar = false;
          }
          return this.a === 1 ? this.toHexString(allowShortChar) : this.toHex8String(allowShortChar);
        };
        TinyColor2.prototype.toRgb = function() {
          return {
            r: Math.round(this.r),
            g: Math.round(this.g),
            b: Math.round(this.b),
            a: this.a
          };
        };
        TinyColor2.prototype.toRgbString = function() {
          var r2 = Math.round(this.r);
          var g = Math.round(this.g);
          var b = Math.round(this.b);
          return this.a === 1 ? "rgb(".concat(r2, ", ").concat(g, ", ").concat(b, ")") : "rgba(".concat(r2, ", ").concat(g, ", ").concat(b, ", ").concat(this.roundA, ")");
        };
        TinyColor2.prototype.toPercentageRgb = function() {
          var fmt2 = function(x) {
            return "".concat(Math.round((0, util_js_1.bound01)(x, 255) * 100), "%");
          };
          return {
            r: fmt2(this.r),
            g: fmt2(this.g),
            b: fmt2(this.b),
            a: this.a
          };
        };
        TinyColor2.prototype.toPercentageRgbString = function() {
          var rnd = function(x) {
            return Math.round((0, util_js_1.bound01)(x, 255) * 100);
          };
          return this.a === 1 ? "rgb(".concat(rnd(this.r), "%, ").concat(rnd(this.g), "%, ").concat(rnd(this.b), "%)") : "rgba(".concat(rnd(this.r), "%, ").concat(rnd(this.g), "%, ").concat(rnd(this.b), "%, ").concat(this.roundA, ")");
        };
        TinyColor2.prototype.toName = function() {
          if (this.a === 0) {
            return "transparent";
          }
          if (this.a < 1) {
            return false;
          }
          var hex2 = "#" + (0, conversion_js_1.rgbToHex)(this.r, this.g, this.b, false);
          for (var _i = 0, _a = Object.entries(css_color_names_js_1.names); _i < _a.length; _i++) {
            var _b = _a[_i], key2 = _b[0], value = _b[1];
            if (hex2 === value) {
              return key2;
            }
          }
          return false;
        };
        TinyColor2.prototype.toString = function(format3) {
          var formatSet = Boolean(format3);
          format3 = format3 !== null && format3 !== void 0 ? format3 : this.format;
          var formattedString = false;
          var hasAlpha = this.a < 1 && this.a >= 0;
          var needsAlphaFormat = !formatSet && hasAlpha && (format3.startsWith("hex") || format3 === "name");
          if (needsAlphaFormat) {
            if (format3 === "name" && this.a === 0) {
              return this.toName();
            }
            return this.toRgbString();
          }
          if (format3 === "rgb") {
            formattedString = this.toRgbString();
          }
          if (format3 === "prgb") {
            formattedString = this.toPercentageRgbString();
          }
          if (format3 === "hex" || format3 === "hex6") {
            formattedString = this.toHexString();
          }
          if (format3 === "hex3") {
            formattedString = this.toHexString(true);
          }
          if (format3 === "hex4") {
            formattedString = this.toHex8String(true);
          }
          if (format3 === "hex8") {
            formattedString = this.toHex8String();
          }
          if (format3 === "name") {
            formattedString = this.toName();
          }
          if (format3 === "hsl") {
            formattedString = this.toHslString();
          }
          if (format3 === "hsv") {
            formattedString = this.toHsvString();
          }
          return formattedString || this.toHexString();
        };
        TinyColor2.prototype.toNumber = function() {
          return (Math.round(this.r) << 16) + (Math.round(this.g) << 8) + Math.round(this.b);
        };
        TinyColor2.prototype.clone = function() {
          return new TinyColor2(this.toString());
        };
        TinyColor2.prototype.lighten = function(amount) {
          if (amount === void 0) {
            amount = 10;
          }
          var hsl = this.toHsl();
          hsl.l += amount / 100;
          hsl.l = (0, util_js_1.clamp01)(hsl.l);
          return new TinyColor2(hsl);
        };
        TinyColor2.prototype.brighten = function(amount) {
          if (amount === void 0) {
            amount = 10;
          }
          var rgb2 = this.toRgb();
          rgb2.r = Math.max(0, Math.min(255, rgb2.r - Math.round(255 * -(amount / 100))));
          rgb2.g = Math.max(0, Math.min(255, rgb2.g - Math.round(255 * -(amount / 100))));
          rgb2.b = Math.max(0, Math.min(255, rgb2.b - Math.round(255 * -(amount / 100))));
          return new TinyColor2(rgb2);
        };
        TinyColor2.prototype.darken = function(amount) {
          if (amount === void 0) {
            amount = 10;
          }
          var hsl = this.toHsl();
          hsl.l -= amount / 100;
          hsl.l = (0, util_js_1.clamp01)(hsl.l);
          return new TinyColor2(hsl);
        };
        TinyColor2.prototype.tint = function(amount) {
          if (amount === void 0) {
            amount = 10;
          }
          return this.mix("white", amount);
        };
        TinyColor2.prototype.shade = function(amount) {
          if (amount === void 0) {
            amount = 10;
          }
          return this.mix("black", amount);
        };
        TinyColor2.prototype.desaturate = function(amount) {
          if (amount === void 0) {
            amount = 10;
          }
          var hsl = this.toHsl();
          hsl.s -= amount / 100;
          hsl.s = (0, util_js_1.clamp01)(hsl.s);
          return new TinyColor2(hsl);
        };
        TinyColor2.prototype.saturate = function(amount) {
          if (amount === void 0) {
            amount = 10;
          }
          var hsl = this.toHsl();
          hsl.s += amount / 100;
          hsl.s = (0, util_js_1.clamp01)(hsl.s);
          return new TinyColor2(hsl);
        };
        TinyColor2.prototype.greyscale = function() {
          return this.desaturate(100);
        };
        TinyColor2.prototype.spin = function(amount) {
          var hsl = this.toHsl();
          var hue = (hsl.h + amount) % 360;
          hsl.h = hue < 0 ? 360 + hue : hue;
          return new TinyColor2(hsl);
        };
        TinyColor2.prototype.mix = function(color, amount) {
          if (amount === void 0) {
            amount = 50;
          }
          var rgb1 = this.toRgb();
          var rgb2 = new TinyColor2(color).toRgb();
          var p = amount / 100;
          var rgba = {
            r: (rgb2.r - rgb1.r) * p + rgb1.r,
            g: (rgb2.g - rgb1.g) * p + rgb1.g,
            b: (rgb2.b - rgb1.b) * p + rgb1.b,
            a: (rgb2.a - rgb1.a) * p + rgb1.a
          };
          return new TinyColor2(rgba);
        };
        TinyColor2.prototype.analogous = function(results, slices) {
          if (results === void 0) {
            results = 6;
          }
          if (slices === void 0) {
            slices = 30;
          }
          var hsl = this.toHsl();
          var part = 360 / slices;
          var ret = [this];
          for (hsl.h = (hsl.h - (part * results >> 1) + 720) % 360; --results; ) {
            hsl.h = (hsl.h + part) % 360;
            ret.push(new TinyColor2(hsl));
          }
          return ret;
        };
        TinyColor2.prototype.complement = function() {
          var hsl = this.toHsl();
          hsl.h = (hsl.h + 180) % 360;
          return new TinyColor2(hsl);
        };
        TinyColor2.prototype.monochromatic = function(results) {
          if (results === void 0) {
            results = 6;
          }
          var hsv = this.toHsv();
          var h2 = hsv.h;
          var s = hsv.s;
          var v = hsv.v;
          var res = [];
          var modification = 1 / results;
          while (results--) {
            res.push(new TinyColor2({ h: h2, s, v }));
            v = (v + modification) % 1;
          }
          return res;
        };
        TinyColor2.prototype.splitcomplement = function() {
          var hsl = this.toHsl();
          var h2 = hsl.h;
          return [
            this,
            new TinyColor2({ h: (h2 + 72) % 360, s: hsl.s, l: hsl.l }),
            new TinyColor2({ h: (h2 + 216) % 360, s: hsl.s, l: hsl.l })
          ];
        };
        TinyColor2.prototype.onBackground = function(background) {
          var fg = this.toRgb();
          var bg = new TinyColor2(background).toRgb();
          var alpha = fg.a + bg.a * (1 - fg.a);
          return new TinyColor2({
            r: (fg.r * fg.a + bg.r * bg.a * (1 - fg.a)) / alpha,
            g: (fg.g * fg.a + bg.g * bg.a * (1 - fg.a)) / alpha,
            b: (fg.b * fg.a + bg.b * bg.a * (1 - fg.a)) / alpha,
            a: alpha
          });
        };
        TinyColor2.prototype.triad = function() {
          return this.polyad(3);
        };
        TinyColor2.prototype.tetrad = function() {
          return this.polyad(4);
        };
        TinyColor2.prototype.polyad = function(n2) {
          var hsl = this.toHsl();
          var h2 = hsl.h;
          var result = [this];
          var increment = 360 / n2;
          for (var i = 1; i < n2; i++) {
            result.push(new TinyColor2({ h: (h2 + i * increment) % 360, s: hsl.s, l: hsl.l }));
          }
          return result;
        };
        TinyColor2.prototype.equals = function(color) {
          return this.toRgbString() === new TinyColor2(color).toRgbString();
        };
        return TinyColor2;
      })()
    );
    exports2.TinyColor = TinyColor;
    function tinycolor(color, opts) {
      if (color === void 0) {
        color = "";
      }
      if (opts === void 0) {
        opts = {};
      }
      return new TinyColor(color, opts);
    }
    exports2.tinycolor = tinycolor;
  }
});

// ../../node_modules/@ctrl/tinycolor/dist/readability.js
var require_readability = __commonJS({
  "../../node_modules/@ctrl/tinycolor/dist/readability.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.mostReadable = exports2.isReadable = exports2.readability = void 0;
    var index_js_1 = require_dist();
    function readability(color1, color2) {
      var c1 = new index_js_1.TinyColor(color1);
      var c2 = new index_js_1.TinyColor(color2);
      return (Math.max(c1.getLuminance(), c2.getLuminance()) + 0.05) / (Math.min(c1.getLuminance(), c2.getLuminance()) + 0.05);
    }
    exports2.readability = readability;
    function isReadable(color1, color2, wcag2) {
      var _a, _b;
      if (wcag2 === void 0) {
        wcag2 = { level: "AA", size: "small" };
      }
      var readabilityLevel = readability(color1, color2);
      switch (((_a = wcag2.level) !== null && _a !== void 0 ? _a : "AA") + ((_b = wcag2.size) !== null && _b !== void 0 ? _b : "small")) {
        case "AAsmall":
        case "AAAlarge":
          return readabilityLevel >= 4.5;
        case "AAlarge":
          return readabilityLevel >= 3;
        case "AAAsmall":
          return readabilityLevel >= 7;
        default:
          return false;
      }
    }
    exports2.isReadable = isReadable;
    function mostReadable(baseColor, colorList, args) {
      if (args === void 0) {
        args = { includeFallbackColors: false, level: "AA", size: "small" };
      }
      var bestColor = null;
      var bestScore = 0;
      var includeFallbackColors = args.includeFallbackColors, level = args.level, size = args.size;
      for (var _i = 0, colorList_1 = colorList; _i < colorList_1.length; _i++) {
        var color = colorList_1[_i];
        var score = readability(baseColor, color);
        if (score > bestScore) {
          bestScore = score;
          bestColor = new index_js_1.TinyColor(color);
        }
      }
      if (isReadable(baseColor, bestColor, { level, size }) || !includeFallbackColors) {
        return bestColor;
      }
      args.includeFallbackColors = false;
      return mostReadable(baseColor, ["#fff", "#000"], args);
    }
    exports2.mostReadable = mostReadable;
  }
});

// ../../node_modules/@ctrl/tinycolor/dist/to-ms-filter.js
var require_to_ms_filter = __commonJS({
  "../../node_modules/@ctrl/tinycolor/dist/to-ms-filter.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.toMsFilter = void 0;
    var conversion_js_1 = require_conversion();
    var index_js_1 = require_dist();
    function toMsFilter(firstColor, secondColor) {
      var color = new index_js_1.TinyColor(firstColor);
      var hex8String = "#" + (0, conversion_js_1.rgbaToArgbHex)(color.r, color.g, color.b, color.a);
      var secondHex8String = hex8String;
      var gradientType = color.gradientType ? "GradientType = 1, " : "";
      if (secondColor) {
        var s = new index_js_1.TinyColor(secondColor);
        secondHex8String = "#" + (0, conversion_js_1.rgbaToArgbHex)(s.r, s.g, s.b, s.a);
      }
      return "progid:DXImageTransform.Microsoft.gradient(".concat(gradientType, "startColorstr=").concat(hex8String, ",endColorstr=").concat(secondHex8String, ")");
    }
    exports2.toMsFilter = toMsFilter;
  }
});

// ../../node_modules/@ctrl/tinycolor/dist/from-ratio.js
var require_from_ratio = __commonJS({
  "../../node_modules/@ctrl/tinycolor/dist/from-ratio.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.legacyRandom = exports2.fromRatio = void 0;
    var index_js_1 = require_dist();
    var util_js_1 = require_util2();
    function fromRatio(ratio, opts) {
      var newColor = {
        r: (0, util_js_1.convertToPercentage)(ratio.r),
        g: (0, util_js_1.convertToPercentage)(ratio.g),
        b: (0, util_js_1.convertToPercentage)(ratio.b)
      };
      if (ratio.a !== void 0) {
        newColor.a = Number(ratio.a);
      }
      return new index_js_1.TinyColor(newColor, opts);
    }
    exports2.fromRatio = fromRatio;
    function legacyRandom() {
      return new index_js_1.TinyColor({
        r: Math.random(),
        g: Math.random(),
        b: Math.random()
      });
    }
    exports2.legacyRandom = legacyRandom;
  }
});

// ../../node_modules/@ctrl/tinycolor/dist/random.js
var require_random = __commonJS({
  "../../node_modules/@ctrl/tinycolor/dist/random.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.bounds = exports2.random = void 0;
    var index_js_1 = require_dist();
    function random(options) {
      if (options === void 0) {
        options = {};
      }
      if (options.count !== void 0 && options.count !== null) {
        var totalColors = options.count;
        var colors = [];
        options.count = void 0;
        while (totalColors > colors.length) {
          options.count = null;
          if (options.seed) {
            options.seed += 1;
          }
          colors.push(random(options));
        }
        options.count = totalColors;
        return colors;
      }
      var h2 = pickHue(options.hue, options.seed);
      var s = pickSaturation(h2, options);
      var v = pickBrightness(h2, s, options);
      var res = { h: h2, s, v };
      if (options.alpha !== void 0) {
        res.a = options.alpha;
      }
      return new index_js_1.TinyColor(res);
    }
    exports2.random = random;
    function pickHue(hue, seed) {
      var hueRange = getHueRange(hue);
      var res = randomWithin(hueRange, seed);
      if (res < 0) {
        res = 360 + res;
      }
      return res;
    }
    function pickSaturation(hue, options) {
      if (options.hue === "monochrome") {
        return 0;
      }
      if (options.luminosity === "random") {
        return randomWithin([0, 100], options.seed);
      }
      var saturationRange = getColorInfo(hue).saturationRange;
      var sMin = saturationRange[0];
      var sMax = saturationRange[1];
      switch (options.luminosity) {
        case "bright":
          sMin = 55;
          break;
        case "dark":
          sMin = sMax - 10;
          break;
        case "light":
          sMax = 55;
          break;
        default:
          break;
      }
      return randomWithin([sMin, sMax], options.seed);
    }
    function pickBrightness(H, S, options) {
      var bMin = getMinimumBrightness(H, S);
      var bMax = 100;
      switch (options.luminosity) {
        case "dark":
          bMax = bMin + 20;
          break;
        case "light":
          bMin = (bMax + bMin) / 2;
          break;
        case "random":
          bMin = 0;
          bMax = 100;
          break;
        default:
          break;
      }
      return randomWithin([bMin, bMax], options.seed);
    }
    function getMinimumBrightness(H, S) {
      var lowerBounds = getColorInfo(H).lowerBounds;
      for (var i = 0; i < lowerBounds.length - 1; i++) {
        var s1 = lowerBounds[i][0];
        var v1 = lowerBounds[i][1];
        var s2 = lowerBounds[i + 1][0];
        var v2 = lowerBounds[i + 1][1];
        if (S >= s1 && S <= s2) {
          var m = (v2 - v1) / (s2 - s1);
          var b = v1 - m * s1;
          return m * S + b;
        }
      }
      return 0;
    }
    function getHueRange(colorInput) {
      var num = parseInt(colorInput, 10);
      if (!Number.isNaN(num) && num < 360 && num > 0) {
        return [num, num];
      }
      if (typeof colorInput === "string") {
        var namedColor = exports2.bounds.find(function(n2) {
          return n2.name === colorInput;
        });
        if (namedColor) {
          var color = defineColor(namedColor);
          if (color.hueRange) {
            return color.hueRange;
          }
        }
        var parsed = new index_js_1.TinyColor(colorInput);
        if (parsed.isValid) {
          var hue = parsed.toHsv().h;
          return [hue, hue];
        }
      }
      return [0, 360];
    }
    function getColorInfo(hue) {
      if (hue >= 334 && hue <= 360) {
        hue -= 360;
      }
      for (var _i = 0, bounds_1 = exports2.bounds; _i < bounds_1.length; _i++) {
        var bound = bounds_1[_i];
        var color = defineColor(bound);
        if (color.hueRange && hue >= color.hueRange[0] && hue <= color.hueRange[1]) {
          return color;
        }
      }
      throw Error("Color not found");
    }
    function randomWithin(range3, seed) {
      if (seed === void 0) {
        return Math.floor(range3[0] + Math.random() * (range3[1] + 1 - range3[0]));
      }
      var max = range3[1] || 1;
      var min = range3[0] || 0;
      seed = (seed * 9301 + 49297) % 233280;
      var rnd = seed / 233280;
      return Math.floor(min + rnd * (max - min));
    }
    function defineColor(bound) {
      var sMin = bound.lowerBounds[0][0];
      var sMax = bound.lowerBounds[bound.lowerBounds.length - 1][0];
      var bMin = bound.lowerBounds[bound.lowerBounds.length - 1][1];
      var bMax = bound.lowerBounds[0][1];
      return {
        name: bound.name,
        hueRange: bound.hueRange,
        lowerBounds: bound.lowerBounds,
        saturationRange: [sMin, sMax],
        brightnessRange: [bMin, bMax]
      };
    }
    exports2.bounds = [
      {
        name: "monochrome",
        hueRange: null,
        lowerBounds: [
          [0, 0],
          [100, 0]
        ]
      },
      {
        name: "red",
        hueRange: [-26, 18],
        lowerBounds: [
          [20, 100],
          [30, 92],
          [40, 89],
          [50, 85],
          [60, 78],
          [70, 70],
          [80, 60],
          [90, 55],
          [100, 50]
        ]
      },
      {
        name: "orange",
        hueRange: [19, 46],
        lowerBounds: [
          [20, 100],
          [30, 93],
          [40, 88],
          [50, 86],
          [60, 85],
          [70, 70],
          [100, 70]
        ]
      },
      {
        name: "yellow",
        hueRange: [47, 62],
        lowerBounds: [
          [25, 100],
          [40, 94],
          [50, 89],
          [60, 86],
          [70, 84],
          [80, 82],
          [90, 80],
          [100, 75]
        ]
      },
      {
        name: "green",
        hueRange: [63, 178],
        lowerBounds: [
          [30, 100],
          [40, 90],
          [50, 85],
          [60, 81],
          [70, 74],
          [80, 64],
          [90, 50],
          [100, 40]
        ]
      },
      {
        name: "blue",
        hueRange: [179, 257],
        lowerBounds: [
          [20, 100],
          [30, 86],
          [40, 80],
          [50, 74],
          [60, 60],
          [70, 52],
          [80, 44],
          [90, 39],
          [100, 35]
        ]
      },
      {
        name: "purple",
        hueRange: [258, 282],
        lowerBounds: [
          [20, 100],
          [30, 87],
          [40, 79],
          [50, 70],
          [60, 65],
          [70, 59],
          [80, 52],
          [90, 45],
          [100, 42]
        ]
      },
      {
        name: "pink",
        hueRange: [283, 334],
        lowerBounds: [
          [20, 100],
          [30, 90],
          [40, 86],
          [60, 84],
          [80, 80],
          [90, 75],
          [100, 73]
        ]
      }
    ];
  }
});

// ../../node_modules/@ctrl/tinycolor/dist/interfaces.js
var require_interfaces = __commonJS({
  "../../node_modules/@ctrl/tinycolor/dist/interfaces.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
  }
});

// ../../node_modules/@ctrl/tinycolor/dist/public_api.js
var require_public_api = __commonJS({
  "../../node_modules/@ctrl/tinycolor/dist/public_api.js"(exports2) {
    "use strict";
    var __createBinding = exports2 && exports2.__createBinding || (Object.create ? (function(o3, m, k, k2) {
      if (k2 === void 0) k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o3, k2, desc);
    }) : (function(o3, m, k, k2) {
      if (k2 === void 0) k2 = k;
      o3[k2] = m[k];
    }));
    var __exportStar = exports2 && exports2.__exportStar || function(m, exports3) {
      for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports3, p)) __createBinding(exports3, m, p);
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var index_js_1 = require_dist();
    __exportStar(require_dist(), exports2);
    __exportStar(require_css_color_names(), exports2);
    __exportStar(require_readability(), exports2);
    __exportStar(require_to_ms_filter(), exports2);
    __exportStar(require_from_ratio(), exports2);
    __exportStar(require_format_input(), exports2);
    __exportStar(require_random(), exports2);
    __exportStar(require_interfaces(), exports2);
    __exportStar(require_conversion(), exports2);
    exports2.default = index_js_1.tinycolor;
  }
});

// ../../node_modules/form-render/node_modules/@ant-design/colors/dist/index.js
var require_dist2 = __commonJS({
  "../../node_modules/form-render/node_modules/@ant-design/colors/dist/index.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    var tinycolor = require_public_api();
    var hueStep2 = 2;
    var saturationStep3 = 0.16;
    var saturationStep22 = 0.05;
    var brightnessStep12 = 0.05;
    var brightnessStep22 = 0.15;
    var lightColorCount2 = 5;
    var darkColorCount2 = 4;
    var darkColorMap2 = [{
      index: 7,
      opacity: 0.15
    }, {
      index: 6,
      opacity: 0.25
    }, {
      index: 5,
      opacity: 0.3
    }, {
      index: 5,
      opacity: 0.45
    }, {
      index: 5,
      opacity: 0.65
    }, {
      index: 5,
      opacity: 0.85
    }, {
      index: 4,
      opacity: 0.9
    }, {
      index: 3,
      opacity: 0.95
    }, {
      index: 2,
      opacity: 0.97
    }, {
      index: 1,
      opacity: 0.98
    }];
    function toHsv(_ref) {
      var r2 = _ref.r, g = _ref.g, b = _ref.b;
      var hsv = tinycolor.rgbToHsv(r2, g, b);
      return {
        h: hsv.h * 360,
        s: hsv.s,
        v: hsv.v
      };
    }
    function toHex(_ref2) {
      var r2 = _ref2.r, g = _ref2.g, b = _ref2.b;
      return "#".concat(tinycolor.rgbToHex(r2, g, b, false));
    }
    function mix(rgb1, rgb2, amount) {
      var p = amount / 100;
      var rgb3 = {
        r: (rgb2.r - rgb1.r) * p + rgb1.r,
        g: (rgb2.g - rgb1.g) * p + rgb1.g,
        b: (rgb2.b - rgb1.b) * p + rgb1.b
      };
      return rgb3;
    }
    function getHue2(hsv, i, light) {
      var hue;
      if (Math.round(hsv.h) >= 60 && Math.round(hsv.h) <= 240) {
        hue = light ? Math.round(hsv.h) - hueStep2 * i : Math.round(hsv.h) + hueStep2 * i;
      } else {
        hue = light ? Math.round(hsv.h) + hueStep2 * i : Math.round(hsv.h) - hueStep2 * i;
      }
      if (hue < 0) {
        hue += 360;
      } else if (hue >= 360) {
        hue -= 360;
      }
      return hue;
    }
    function getSaturation2(hsv, i, light) {
      if (hsv.h === 0 && hsv.s === 0) {
        return hsv.s;
      }
      var saturation;
      if (light) {
        saturation = hsv.s - saturationStep3 * i;
      } else if (i === darkColorCount2) {
        saturation = hsv.s + saturationStep3;
      } else {
        saturation = hsv.s + saturationStep22 * i;
      }
      if (saturation > 1) {
        saturation = 1;
      }
      if (light && i === lightColorCount2 && saturation > 0.1) {
        saturation = 0.1;
      }
      if (saturation < 0.06) {
        saturation = 0.06;
      }
      return Number(saturation.toFixed(2));
    }
    function getValue4(hsv, i, light) {
      var value;
      if (light) {
        value = hsv.v + brightnessStep12 * i;
      } else {
        value = hsv.v - brightnessStep22 * i;
      }
      if (value > 1) {
        value = 1;
      }
      return Number(value.toFixed(2));
    }
    function generate3(color) {
      var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      var patterns = [];
      var pColor = tinycolor.inputToRGB(color);
      for (var i = lightColorCount2; i > 0; i -= 1) {
        var hsv = toHsv(pColor);
        var colorString = toHex(tinycolor.inputToRGB({
          h: getHue2(hsv, i, true),
          s: getSaturation2(hsv, i, true),
          v: getValue4(hsv, i, true)
        }));
        patterns.push(colorString);
      }
      patterns.push(toHex(pColor));
      for (var _i = 1; _i <= darkColorCount2; _i += 1) {
        var _hsv = toHsv(pColor);
        var _colorString = toHex(tinycolor.inputToRGB({
          h: getHue2(_hsv, _i),
          s: getSaturation2(_hsv, _i),
          v: getValue4(_hsv, _i)
        }));
        patterns.push(_colorString);
      }
      if (opts.theme === "dark") {
        return darkColorMap2.map(function(_ref3) {
          var index3 = _ref3.index, opacity = _ref3.opacity;
          var darkColorString = toHex(mix(tinycolor.inputToRGB(opts.backgroundColor || "#141414"), tinycolor.inputToRGB(patterns[index3]), opacity * 100));
          return darkColorString;
        });
      }
      return patterns;
    }
    var presetPrimaryColors2 = {
      red: "#F5222D",
      volcano: "#FA541C",
      orange: "#FA8C16",
      gold: "#FAAD14",
      yellow: "#FADB14",
      lime: "#A0D911",
      green: "#52C41A",
      cyan: "#13C2C2",
      blue: "#1890FF",
      geekblue: "#2F54EB",
      purple: "#722ED1",
      magenta: "#EB2F96",
      grey: "#666666"
    };
    var presetPalettes2 = {};
    var presetDarkPalettes = {};
    Object.keys(presetPrimaryColors2).forEach(function(key2) {
      presetPalettes2[key2] = generate3(presetPrimaryColors2[key2]);
      presetPalettes2[key2].primary = presetPalettes2[key2][5];
      presetDarkPalettes[key2] = generate3(presetPrimaryColors2[key2], {
        theme: "dark",
        backgroundColor: "#141414"
      });
      presetDarkPalettes[key2].primary = presetDarkPalettes[key2][5];
    });
    var red2 = presetPalettes2.red;
    var volcano2 = presetPalettes2.volcano;
    var gold2 = presetPalettes2.gold;
    var orange2 = presetPalettes2.orange;
    var yellow2 = presetPalettes2.yellow;
    var lime2 = presetPalettes2.lime;
    var green2 = presetPalettes2.green;
    var cyan2 = presetPalettes2.cyan;
    var blue2 = presetPalettes2.blue;
    var geekblue2 = presetPalettes2.geekblue;
    var purple2 = presetPalettes2.purple;
    var magenta2 = presetPalettes2.magenta;
    var grey2 = presetPalettes2.grey;
    exports2.blue = blue2;
    exports2.cyan = cyan2;
    exports2.geekblue = geekblue2;
    exports2.generate = generate3;
    exports2.gold = gold2;
    exports2.green = green2;
    exports2.grey = grey2;
    exports2.lime = lime2;
    exports2.magenta = magenta2;
    exports2.orange = orange2;
    exports2.presetDarkPalettes = presetDarkPalettes;
    exports2.presetPalettes = presetPalettes2;
    exports2.presetPrimaryColors = presetPrimaryColors2;
    exports2.purple = purple2;
    exports2.red = red2;
    exports2.volcano = volcano2;
    exports2.yellow = yellow2;
  }
});

// ../../node_modules/rc-util/lib/warning.js
var require_warning = __commonJS({
  "../../node_modules/rc-util/lib/warning.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.call = call2;
    exports2.default = void 0;
    exports2.note = note2;
    exports2.noteOnce = noteOnce2;
    exports2.preMessage = void 0;
    exports2.resetWarned = resetWarned2;
    exports2.warning = warning6;
    exports2.warningOnce = warningOnce2;
    var warned2 = {};
    var preWarningFns2 = [];
    var preMessage3 = exports2.preMessage = function preMessage4(fn) {
      preWarningFns2.push(fn);
    };
    function warning6(valid, message2) {
      if (!valid && console !== void 0) {
        var finalMessage = preWarningFns2.reduce(function(msg, preMessageFn) {
          return preMessageFn(msg !== null && msg !== void 0 ? msg : "", "warning");
        }, message2);
        if (finalMessage) {
          console.error("Warning: ".concat(finalMessage));
        }
      }
    }
    function note2(valid, message2) {
      if (!valid && console !== void 0) {
        var finalMessage = preWarningFns2.reduce(function(msg, preMessageFn) {
          return preMessageFn(msg !== null && msg !== void 0 ? msg : "", "note");
        }, message2);
        if (finalMessage) {
          console.warn("Note: ".concat(finalMessage));
        }
      }
    }
    function resetWarned2() {
      warned2 = {};
    }
    function call2(method4, valid, message2) {
      if (!valid && !warned2[message2]) {
        method4(false, message2);
        warned2[message2] = true;
      }
    }
    function warningOnce2(valid, message2) {
      call2(warning6, valid, message2);
    }
    function noteOnce2(valid, message2) {
      call2(note2, valid, message2);
    }
    warningOnce2.preMessage = preMessage3;
    warningOnce2.resetWarned = resetWarned2;
    warningOnce2.noteOnce = noteOnce2;
    var _default = exports2.default = warningOnce2;
  }
});

// ../../node_modules/rc-util/lib/Dom/canUseDom.js
var require_canUseDom = __commonJS({
  "../../node_modules/rc-util/lib/Dom/canUseDom.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = canUseDom2;
    function canUseDom2() {
      return !!(typeof window !== "undefined" && window.document && window.document.createElement);
    }
  }
});

// ../../node_modules/rc-util/lib/Dom/contains.js
var require_contains3 = __commonJS({
  "../../node_modules/rc-util/lib/Dom/contains.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = contains2;
    function contains2(root2, n2) {
      if (!root2) {
        return false;
      }
      if (root2.contains) {
        return root2.contains(n2);
      }
      var node2 = n2;
      while (node2) {
        if (node2 === root2) {
          return true;
        }
        node2 = node2.parentNode;
      }
      return false;
    }
  }
});

// ../../node_modules/rc-util/lib/Dom/dynamicCSS.js
var require_dynamicCSS = __commonJS({
  "../../node_modules/rc-util/lib/Dom/dynamicCSS.js"(exports2) {
    "use strict";
    var _interopRequireDefault = require_interopRequireDefault().default;
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.clearContainerCache = clearContainerCache;
    exports2.injectCSS = injectCSS2;
    exports2.removeCSS = removeCSS2;
    exports2.updateCSS = updateCSS2;
    var _objectSpread22 = _interopRequireDefault(require_objectSpread2());
    var _canUseDom = _interopRequireDefault(require_canUseDom());
    var _contains = _interopRequireDefault(require_contains3());
    var APPEND_ORDER2 = "data-rc-order";
    var APPEND_PRIORITY2 = "data-rc-priority";
    var MARK_KEY2 = "rc-util-key";
    var containerCache2 = /* @__PURE__ */ new Map();
    function getMark2() {
      var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, mark = _ref.mark;
      if (mark) {
        return mark.startsWith("data-") ? mark : "data-".concat(mark);
      }
      return MARK_KEY2;
    }
    function getContainer2(option) {
      if (option.attachTo) {
        return option.attachTo;
      }
      var head = document.querySelector("head");
      return head || document.body;
    }
    function getOrder2(prepend) {
      if (prepend === "queue") {
        return "prependQueue";
      }
      return prepend ? "prepend" : "append";
    }
    function findStyles2(container) {
      return Array.from((containerCache2.get(container) || container).children).filter(function(node2) {
        return node2.tagName === "STYLE";
      });
    }
    function injectCSS2(css2) {
      var option = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      if (!(0, _canUseDom.default)()) {
        return null;
      }
      var csp = option.csp, prepend = option.prepend, _option$priority = option.priority, priority = _option$priority === void 0 ? 0 : _option$priority;
      var mergedOrder = getOrder2(prepend);
      var isPrependQueue = mergedOrder === "prependQueue";
      var styleNode = document.createElement("style");
      styleNode.setAttribute(APPEND_ORDER2, mergedOrder);
      if (isPrependQueue && priority) {
        styleNode.setAttribute(APPEND_PRIORITY2, "".concat(priority));
      }
      if (csp !== null && csp !== void 0 && csp.nonce) {
        styleNode.nonce = csp === null || csp === void 0 ? void 0 : csp.nonce;
      }
      styleNode.innerHTML = css2;
      var container = getContainer2(option);
      var firstChild = container.firstChild;
      if (prepend) {
        if (isPrependQueue) {
          var existStyle = (option.styles || findStyles2(container)).filter(function(node2) {
            if (!["prepend", "prependQueue"].includes(node2.getAttribute(APPEND_ORDER2))) {
              return false;
            }
            var nodePriority = Number(node2.getAttribute(APPEND_PRIORITY2) || 0);
            return priority >= nodePriority;
          });
          if (existStyle.length) {
            container.insertBefore(styleNode, existStyle[existStyle.length - 1].nextSibling);
            return styleNode;
          }
        }
        container.insertBefore(styleNode, firstChild);
      } else {
        container.appendChild(styleNode);
      }
      return styleNode;
    }
    function findExistNode2(key2) {
      var option = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      var container = getContainer2(option);
      return (option.styles || findStyles2(container)).find(function(node2) {
        return node2.getAttribute(getMark2(option)) === key2;
      });
    }
    function removeCSS2(key2) {
      var option = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      var existNode = findExistNode2(key2, option);
      if (existNode) {
        var container = getContainer2(option);
        container.removeChild(existNode);
      }
    }
    function syncRealContainer2(container, option) {
      var cachedRealContainer = containerCache2.get(container);
      if (!cachedRealContainer || !(0, _contains.default)(document, cachedRealContainer)) {
        var placeholderStyle = injectCSS2("", option);
        var parentNode = placeholderStyle.parentNode;
        containerCache2.set(container, parentNode);
        container.removeChild(placeholderStyle);
      }
    }
    function clearContainerCache() {
      containerCache2.clear();
    }
    function updateCSS2(css2, key2) {
      var originOption = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      var container = getContainer2(originOption);
      var styles = findStyles2(container);
      var option = (0, _objectSpread22.default)((0, _objectSpread22.default)({}, originOption), {}, {
        styles
      });
      syncRealContainer2(container, option);
      var existNode = findExistNode2(key2, option);
      if (existNode) {
        var _option$csp, _option$csp2;
        if ((_option$csp = option.csp) !== null && _option$csp !== void 0 && _option$csp.nonce && existNode.nonce !== ((_option$csp2 = option.csp) === null || _option$csp2 === void 0 ? void 0 : _option$csp2.nonce)) {
          var _option$csp3;
          existNode.nonce = (_option$csp3 = option.csp) === null || _option$csp3 === void 0 ? void 0 : _option$csp3.nonce;
        }
        if (existNode.innerHTML !== css2) {
          existNode.innerHTML = css2;
        }
        return existNode;
      }
      var newNode = injectCSS2(css2, option);
      newNode.setAttribute(getMark2(option), key2);
      return newNode;
    }
  }
});

// ../../node_modules/lodash/_freeGlobal.js
var require_freeGlobal = __commonJS({
  "../../node_modules/lodash/_freeGlobal.js"(exports2, module2) {
    var freeGlobal2 = typeof global == "object" && global && global.Object === Object && global;
    module2.exports = freeGlobal2;
  }
});

// ../../node_modules/lodash/_root.js
var require_root = __commonJS({
  "../../node_modules/lodash/_root.js"(exports2, module2) {
    var freeGlobal2 = require_freeGlobal();
    var freeSelf2 = typeof self == "object" && self && self.Object === Object && self;
    var root2 = freeGlobal2 || freeSelf2 || Function("return this")();
    module2.exports = root2;
  }
});

// ../../node_modules/lodash/_Symbol.js
var require_Symbol = __commonJS({
  "../../node_modules/lodash/_Symbol.js"(exports2, module2) {
    var root2 = require_root();
    var Symbol3 = root2.Symbol;
    module2.exports = Symbol3;
  }
});

// ../../node_modules/lodash/_arrayMap.js
var require_arrayMap = __commonJS({
  "../../node_modules/lodash/_arrayMap.js"(exports2, module2) {
    function arrayMap2(array4, iteratee) {
      var index3 = -1, length2 = array4 == null ? 0 : array4.length, result = Array(length2);
      while (++index3 < length2) {
        result[index3] = iteratee(array4[index3], index3, array4);
      }
      return result;
    }
    module2.exports = arrayMap2;
  }
});

// ../../node_modules/lodash/isArray.js
var require_isArray = __commonJS({
  "../../node_modules/lodash/isArray.js"(exports2, module2) {
    var isArray6 = Array.isArray;
    module2.exports = isArray6;
  }
});

// ../../node_modules/lodash/_getRawTag.js
var require_getRawTag = __commonJS({
  "../../node_modules/lodash/_getRawTag.js"(exports2, module2) {
    var Symbol3 = require_Symbol();
    var objectProto17 = Object.prototype;
    var hasOwnProperty15 = objectProto17.hasOwnProperty;
    var nativeObjectToString3 = objectProto17.toString;
    var symToStringTag3 = Symbol3 ? Symbol3.toStringTag : void 0;
    function getRawTag2(value) {
      var isOwn = hasOwnProperty15.call(value, symToStringTag3), tag = value[symToStringTag3];
      try {
        value[symToStringTag3] = void 0;
        var unmasked = true;
      } catch (e3) {
      }
      var result = nativeObjectToString3.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag3] = tag;
        } else {
          delete value[symToStringTag3];
        }
      }
      return result;
    }
    module2.exports = getRawTag2;
  }
});

// ../../node_modules/lodash/_objectToString.js
var require_objectToString = __commonJS({
  "../../node_modules/lodash/_objectToString.js"(exports2, module2) {
    var objectProto17 = Object.prototype;
    var nativeObjectToString3 = objectProto17.toString;
    function objectToString2(value) {
      return nativeObjectToString3.call(value);
    }
    module2.exports = objectToString2;
  }
});

// ../../node_modules/lodash/_baseGetTag.js
var require_baseGetTag = __commonJS({
  "../../node_modules/lodash/_baseGetTag.js"(exports2, module2) {
    var Symbol3 = require_Symbol();
    var getRawTag2 = require_getRawTag();
    var objectToString2 = require_objectToString();
    var nullTag2 = "[object Null]";
    var undefinedTag2 = "[object Undefined]";
    var symToStringTag3 = Symbol3 ? Symbol3.toStringTag : void 0;
    function baseGetTag2(value) {
      if (value == null) {
        return value === void 0 ? undefinedTag2 : nullTag2;
      }
      return symToStringTag3 && symToStringTag3 in Object(value) ? getRawTag2(value) : objectToString2(value);
    }
    module2.exports = baseGetTag2;
  }
});

// ../../node_modules/lodash/isObjectLike.js
var require_isObjectLike = __commonJS({
  "../../node_modules/lodash/isObjectLike.js"(exports2, module2) {
    function isObjectLike2(value) {
      return value != null && typeof value == "object";
    }
    module2.exports = isObjectLike2;
  }
});

// ../../node_modules/lodash/isSymbol.js
var require_isSymbol = __commonJS({
  "../../node_modules/lodash/isSymbol.js"(exports2, module2) {
    var baseGetTag2 = require_baseGetTag();
    var isObjectLike2 = require_isObjectLike();
    var symbolTag5 = "[object Symbol]";
    function isSymbol2(value) {
      return typeof value == "symbol" || isObjectLike2(value) && baseGetTag2(value) == symbolTag5;
    }
    module2.exports = isSymbol2;
  }
});

// ../../node_modules/lodash/_baseToString.js
var require_baseToString = __commonJS({
  "../../node_modules/lodash/_baseToString.js"(exports2, module2) {
    var Symbol3 = require_Symbol();
    var arrayMap2 = require_arrayMap();
    var isArray6 = require_isArray();
    var isSymbol2 = require_isSymbol();
    var INFINITY3 = 1 / 0;
    var symbolProto4 = Symbol3 ? Symbol3.prototype : void 0;
    var symbolToString2 = symbolProto4 ? symbolProto4.toString : void 0;
    function baseToString2(value) {
      if (typeof value == "string") {
        return value;
      }
      if (isArray6(value)) {
        return arrayMap2(value, baseToString2) + "";
      }
      if (isSymbol2(value)) {
        return symbolToString2 ? symbolToString2.call(value) : "";
      }
      var result = value + "";
      return result == "0" && 1 / value == -INFINITY3 ? "-0" : result;
    }
    module2.exports = baseToString2;
  }
});

// ../../node_modules/lodash/toString.js
var require_toString = __commonJS({
  "../../node_modules/lodash/toString.js"(exports2, module2) {
    var baseToString2 = require_baseToString();
    function toString3(value) {
      return value == null ? "" : baseToString2(value);
    }
    module2.exports = toString3;
  }
});

// ../../node_modules/lodash/_baseSlice.js
var require_baseSlice = __commonJS({
  "../../node_modules/lodash/_baseSlice.js"(exports2, module2) {
    function baseSlice2(array4, start, end) {
      var index3 = -1, length2 = array4.length;
      if (start < 0) {
        start = -start > length2 ? 0 : length2 + start;
      }
      end = end > length2 ? length2 : end;
      if (end < 0) {
        end += length2;
      }
      length2 = start > end ? 0 : end - start >>> 0;
      start >>>= 0;
      var result = Array(length2);
      while (++index3 < length2) {
        result[index3] = array4[index3 + start];
      }
      return result;
    }
    module2.exports = baseSlice2;
  }
});

// ../../node_modules/lodash/_castSlice.js
var require_castSlice = __commonJS({
  "../../node_modules/lodash/_castSlice.js"(exports2, module2) {
    var baseSlice2 = require_baseSlice();
    function castSlice(array4, start, end) {
      var length2 = array4.length;
      end = end === void 0 ? length2 : end;
      return !start && end >= length2 ? array4 : baseSlice2(array4, start, end);
    }
    module2.exports = castSlice;
  }
});

// ../../node_modules/lodash/_hasUnicode.js
var require_hasUnicode = __commonJS({
  "../../node_modules/lodash/_hasUnicode.js"(exports2, module2) {
    var rsAstralRange = "\\ud800-\\udfff";
    var rsComboMarksRange = "\\u0300-\\u036f";
    var reComboHalfMarksRange = "\\ufe20-\\ufe2f";
    var rsComboSymbolsRange = "\\u20d0-\\u20ff";
    var rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;
    var rsVarRange = "\\ufe0e\\ufe0f";
    var rsZWJ = "\\u200d";
    var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    function hasUnicode(string3) {
      return reHasUnicode.test(string3);
    }
    module2.exports = hasUnicode;
  }
});

// ../../node_modules/lodash/_asciiToArray.js
var require_asciiToArray = __commonJS({
  "../../node_modules/lodash/_asciiToArray.js"(exports2, module2) {
    function asciiToArray(string3) {
      return string3.split("");
    }
    module2.exports = asciiToArray;
  }
});

// ../../node_modules/lodash/_unicodeToArray.js
var require_unicodeToArray = __commonJS({
  "../../node_modules/lodash/_unicodeToArray.js"(exports2, module2) {
    var rsAstralRange = "\\ud800-\\udfff";
    var rsComboMarksRange = "\\u0300-\\u036f";
    var reComboHalfMarksRange = "\\ufe20-\\ufe2f";
    var rsComboSymbolsRange = "\\u20d0-\\u20ff";
    var rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;
    var rsVarRange = "\\ufe0e\\ufe0f";
    var rsAstral = "[" + rsAstralRange + "]";
    var rsCombo = "[" + rsComboRange + "]";
    var rsFitz = "\\ud83c[\\udffb-\\udfff]";
    var rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")";
    var rsNonAstral = "[^" + rsAstralRange + "]";
    var rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}";
    var rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]";
    var rsZWJ = "\\u200d";
    var reOptMod = rsModifier + "?";
    var rsOptVar = "[" + rsVarRange + "]?";
    var rsOptJoin = "(?:" + rsZWJ + "(?:" + [rsNonAstral, rsRegional, rsSurrPair].join("|") + ")" + rsOptVar + reOptMod + ")*";
    var rsSeq = rsOptVar + reOptMod + rsOptJoin;
    var rsSymbol = "(?:" + [rsNonAstral + rsCombo + "?", rsCombo, rsRegional, rsSurrPair, rsAstral].join("|") + ")";
    var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    function unicodeToArray(string3) {
      return string3.match(reUnicode) || [];
    }
    module2.exports = unicodeToArray;
  }
});

// ../../node_modules/lodash/_stringToArray.js
var require_stringToArray = __commonJS({
  "../../node_modules/lodash/_stringToArray.js"(exports2, module2) {
    var asciiToArray = require_asciiToArray();
    var hasUnicode = require_hasUnicode();
    var unicodeToArray = require_unicodeToArray();
    function stringToArray(string3) {
      return hasUnicode(string3) ? unicodeToArray(string3) : asciiToArray(string3);
    }
    module2.exports = stringToArray;
  }
});

// ../../node_modules/lodash/_createCaseFirst.js
var require_createCaseFirst = __commonJS({
  "../../node_modules/lodash/_createCaseFirst.js"(exports2, module2) {
    var castSlice = require_castSlice();
    var hasUnicode = require_hasUnicode();
    var stringToArray = require_stringToArray();
    var toString3 = require_toString();
    function createCaseFirst(methodName) {
      return function(string3) {
        string3 = toString3(string3);
        var strSymbols = hasUnicode(string3) ? stringToArray(string3) : void 0;
        var chr = strSymbols ? strSymbols[0] : string3.charAt(0);
        var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string3.slice(1);
        return chr[methodName]() + trailing;
      };
    }
    module2.exports = createCaseFirst;
  }
});

// ../../node_modules/lodash/upperFirst.js
var require_upperFirst = __commonJS({
  "../../node_modules/lodash/upperFirst.js"(exports2, module2) {
    var createCaseFirst = require_createCaseFirst();
    var upperFirst = createCaseFirst("toUpperCase");
    module2.exports = upperFirst;
  }
});

// ../../node_modules/lodash/capitalize.js
var require_capitalize = __commonJS({
  "../../node_modules/lodash/capitalize.js"(exports2, module2) {
    var toString3 = require_toString();
    var upperFirst = require_upperFirst();
    function capitalize(string3) {
      return upperFirst(toString3(string3).toLowerCase());
    }
    module2.exports = capitalize;
  }
});

// ../../node_modules/lodash/_arrayReduce.js
var require_arrayReduce = __commonJS({
  "../../node_modules/lodash/_arrayReduce.js"(exports2, module2) {
    function arrayReduce(array4, iteratee, accumulator, initAccum) {
      var index3 = -1, length2 = array4 == null ? 0 : array4.length;
      if (initAccum && length2) {
        accumulator = array4[++index3];
      }
      while (++index3 < length2) {
        accumulator = iteratee(accumulator, array4[index3], index3, array4);
      }
      return accumulator;
    }
    module2.exports = arrayReduce;
  }
});

// ../../node_modules/lodash/_basePropertyOf.js
var require_basePropertyOf = __commonJS({
  "../../node_modules/lodash/_basePropertyOf.js"(exports2, module2) {
    function basePropertyOf(object4) {
      return function(key2) {
        return object4 == null ? void 0 : object4[key2];
      };
    }
    module2.exports = basePropertyOf;
  }
});

// ../../node_modules/lodash/_deburrLetter.js
var require_deburrLetter = __commonJS({
  "../../node_modules/lodash/_deburrLetter.js"(exports2, module2) {
    var basePropertyOf = require_basePropertyOf();
    var deburredLetters = {
      // Latin-1 Supplement block.
      "\xC0": "A",
      "\xC1": "A",
      "\xC2": "A",
      "\xC3": "A",
      "\xC4": "A",
      "\xC5": "A",
      "\xE0": "a",
      "\xE1": "a",
      "\xE2": "a",
      "\xE3": "a",
      "\xE4": "a",
      "\xE5": "a",
      "\xC7": "C",
      "\xE7": "c",
      "\xD0": "D",
      "\xF0": "d",
      "\xC8": "E",
      "\xC9": "E",
      "\xCA": "E",
      "\xCB": "E",
      "\xE8": "e",
      "\xE9": "e",
      "\xEA": "e",
      "\xEB": "e",
      "\xCC": "I",
      "\xCD": "I",
      "\xCE": "I",
      "\xCF": "I",
      "\xEC": "i",
      "\xED": "i",
      "\xEE": "i",
      "\xEF": "i",
      "\xD1": "N",
      "\xF1": "n",
      "\xD2": "O",
      "\xD3": "O",
      "\xD4": "O",
      "\xD5": "O",
      "\xD6": "O",
      "\xD8": "O",
      "\xF2": "o",
      "\xF3": "o",
      "\xF4": "o",
      "\xF5": "o",
      "\xF6": "o",
      "\xF8": "o",
      "\xD9": "U",
      "\xDA": "U",
      "\xDB": "U",
      "\xDC": "U",
      "\xF9": "u",
      "\xFA": "u",
      "\xFB": "u",
      "\xFC": "u",
      "\xDD": "Y",
      "\xFD": "y",
      "\xFF": "y",
      "\xC6": "Ae",
      "\xE6": "ae",
      "\xDE": "Th",
      "\xFE": "th",
      "\xDF": "ss",
      // Latin Extended-A block.
      "\u0100": "A",
      "\u0102": "A",
      "\u0104": "A",
      "\u0101": "a",
      "\u0103": "a",
      "\u0105": "a",
      "\u0106": "C",
      "\u0108": "C",
      "\u010A": "C",
      "\u010C": "C",
      "\u0107": "c",
      "\u0109": "c",
      "\u010B": "c",
      "\u010D": "c",
      "\u010E": "D",
      "\u0110": "D",
      "\u010F": "d",
      "\u0111": "d",
      "\u0112": "E",
      "\u0114": "E",
      "\u0116": "E",
      "\u0118": "E",
      "\u011A": "E",
      "\u0113": "e",
      "\u0115": "e",
      "\u0117": "e",
      "\u0119": "e",
      "\u011B": "e",
      "\u011C": "G",
      "\u011E": "G",
      "\u0120": "G",
      "\u0122": "G",
      "\u011D": "g",
      "\u011F": "g",
      "\u0121": "g",
      "\u0123": "g",
      "\u0124": "H",
      "\u0126": "H",
      "\u0125": "h",
      "\u0127": "h",
      "\u0128": "I",
      "\u012A": "I",
      "\u012C": "I",
      "\u012E": "I",
      "\u0130": "I",
      "\u0129": "i",
      "\u012B": "i",
      "\u012D": "i",
      "\u012F": "i",
      "\u0131": "i",
      "\u0134": "J",
      "\u0135": "j",
      "\u0136": "K",
      "\u0137": "k",
      "\u0138": "k",
      "\u0139": "L",
      "\u013B": "L",
      "\u013D": "L",
      "\u013F": "L",
      "\u0141": "L",
      "\u013A": "l",
      "\u013C": "l",
      "\u013E": "l",
      "\u0140": "l",
      "\u0142": "l",
      "\u0143": "N",
      "\u0145": "N",
      "\u0147": "N",
      "\u014A": "N",
      "\u0144": "n",
      "\u0146": "n",
      "\u0148": "n",
      "\u014B": "n",
      "\u014C": "O",
      "\u014E": "O",
      "\u0150": "O",
      "\u014D": "o",
      "\u014F": "o",
      "\u0151": "o",
      "\u0154": "R",
      "\u0156": "R",
      "\u0158": "R",
      "\u0155": "r",
      "\u0157": "r",
      "\u0159": "r",
      "\u015A": "S",
      "\u015C": "S",
      "\u015E": "S",
      "\u0160": "S",
      "\u015B": "s",
      "\u015D": "s",
      "\u015F": "s",
      "\u0161": "s",
      "\u0162": "T",
      "\u0164": "T",
      "\u0166": "T",
      "\u0163": "t",
      "\u0165": "t",
      "\u0167": "t",
      "\u0168": "U",
      "\u016A": "U",
      "\u016C": "U",
      "\u016E": "U",
      "\u0170": "U",
      "\u0172": "U",
      "\u0169": "u",
      "\u016B": "u",
      "\u016D": "u",
      "\u016F": "u",
      "\u0171": "u",
      "\u0173": "u",
      "\u0174": "W",
      "\u0175": "w",
      "\u0176": "Y",
      "\u0177": "y",
      "\u0178": "Y",
      "\u0179": "Z",
      "\u017B": "Z",
      "\u017D": "Z",
      "\u017A": "z",
      "\u017C": "z",
      "\u017E": "z",
      "\u0132": "IJ",
      "\u0133": "ij",
      "\u0152": "Oe",
      "\u0153": "oe",
      "\u0149": "'n",
      "\u017F": "s"
    };
    var deburrLetter = basePropertyOf(deburredLetters);
    module2.exports = deburrLetter;
  }
});

// ../../node_modules/lodash/deburr.js
var require_deburr = __commonJS({
  "../../node_modules/lodash/deburr.js"(exports2, module2) {
    var deburrLetter = require_deburrLetter();
    var toString3 = require_toString();
    var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    var rsComboMarksRange = "\\u0300-\\u036f";
    var reComboHalfMarksRange = "\\ufe20-\\ufe2f";
    var rsComboSymbolsRange = "\\u20d0-\\u20ff";
    var rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;
    var rsCombo = "[" + rsComboRange + "]";
    var reComboMark = RegExp(rsCombo, "g");
    function deburr(string3) {
      string3 = toString3(string3);
      return string3 && string3.replace(reLatin, deburrLetter).replace(reComboMark, "");
    }
    module2.exports = deburr;
  }
});

// ../../node_modules/lodash/_asciiWords.js
var require_asciiWords = __commonJS({
  "../../node_modules/lodash/_asciiWords.js"(exports2, module2) {
    var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    function asciiWords(string3) {
      return string3.match(reAsciiWord) || [];
    }
    module2.exports = asciiWords;
  }
});

// ../../node_modules/lodash/_hasUnicodeWord.js
var require_hasUnicodeWord = __commonJS({
  "../../node_modules/lodash/_hasUnicodeWord.js"(exports2, module2) {
    var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    function hasUnicodeWord(string3) {
      return reHasUnicodeWord.test(string3);
    }
    module2.exports = hasUnicodeWord;
  }
});

// ../../node_modules/lodash/_unicodeWords.js
var require_unicodeWords = __commonJS({
  "../../node_modules/lodash/_unicodeWords.js"(exports2, module2) {
    var rsAstralRange = "\\ud800-\\udfff";
    var rsComboMarksRange = "\\u0300-\\u036f";
    var reComboHalfMarksRange = "\\ufe20-\\ufe2f";
    var rsComboSymbolsRange = "\\u20d0-\\u20ff";
    var rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;
    var rsDingbatRange = "\\u2700-\\u27bf";
    var rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff";
    var rsMathOpRange = "\\xac\\xb1\\xd7\\xf7";
    var rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf";
    var rsPunctuationRange = "\\u2000-\\u206f";
    var rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000";
    var rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde";
    var rsVarRange = "\\ufe0e\\ufe0f";
    var rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    var rsApos = "['\u2019]";
    var rsBreak = "[" + rsBreakRange + "]";
    var rsCombo = "[" + rsComboRange + "]";
    var rsDigits = "\\d+";
    var rsDingbat = "[" + rsDingbatRange + "]";
    var rsLower = "[" + rsLowerRange + "]";
    var rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]";
    var rsFitz = "\\ud83c[\\udffb-\\udfff]";
    var rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")";
    var rsNonAstral = "[^" + rsAstralRange + "]";
    var rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}";
    var rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]";
    var rsUpper = "[" + rsUpperRange + "]";
    var rsZWJ = "\\u200d";
    var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")";
    var rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")";
    var rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?";
    var rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?";
    var reOptMod = rsModifier + "?";
    var rsOptVar = "[" + rsVarRange + "]?";
    var rsOptJoin = "(?:" + rsZWJ + "(?:" + [rsNonAstral, rsRegional, rsSurrPair].join("|") + ")" + rsOptVar + reOptMod + ")*";
    var rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])";
    var rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])";
    var rsSeq = rsOptVar + reOptMod + rsOptJoin;
    var rsEmoji = "(?:" + [rsDingbat, rsRegional, rsSurrPair].join("|") + ")" + rsSeq;
    var reUnicodeWord = RegExp([
      rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [rsBreak, rsUpper, "$"].join("|") + ")",
      rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [rsBreak, rsUpper + rsMiscLower, "$"].join("|") + ")",
      rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
      rsUpper + "+" + rsOptContrUpper,
      rsOrdUpper,
      rsOrdLower,
      rsDigits,
      rsEmoji
    ].join("|"), "g");
    function unicodeWords(string3) {
      return string3.match(reUnicodeWord) || [];
    }
    module2.exports = unicodeWords;
  }
});

// ../../node_modules/lodash/words.js
var require_words = __commonJS({
  "../../node_modules/lodash/words.js"(exports2, module2) {
    var asciiWords = require_asciiWords();
    var hasUnicodeWord = require_hasUnicodeWord();
    var toString3 = require_toString();
    var unicodeWords = require_unicodeWords();
    function words(string3, pattern6, guard) {
      string3 = toString3(string3);
      pattern6 = guard ? void 0 : pattern6;
      if (pattern6 === void 0) {
        return hasUnicodeWord(string3) ? unicodeWords(string3) : asciiWords(string3);
      }
      return string3.match(pattern6) || [];
    }
    module2.exports = words;
  }
});

// ../../node_modules/lodash/_createCompounder.js
var require_createCompounder = __commonJS({
  "../../node_modules/lodash/_createCompounder.js"(exports2, module2) {
    var arrayReduce = require_arrayReduce();
    var deburr = require_deburr();
    var words = require_words();
    var rsApos = "['\u2019]";
    var reApos = RegExp(rsApos, "g");
    function createCompounder(callback) {
      return function(string3) {
        return arrayReduce(words(deburr(string3).replace(reApos, "")), callback, "");
      };
    }
    module2.exports = createCompounder;
  }
});

// ../../node_modules/lodash/camelCase.js
var require_camelCase = __commonJS({
  "../../node_modules/lodash/camelCase.js"(exports2, module2) {
    var capitalize = require_capitalize();
    var createCompounder = require_createCompounder();
    var camelCase2 = createCompounder(function(result, word, index3) {
      word = word.toLowerCase();
      return result + (index3 ? capitalize(word) : word);
    });
    module2.exports = camelCase2;
  }
});

// ../../node_modules/form-render/node_modules/@ant-design/icons/lib/utils.js
var require_utils2 = __commonJS({
  "../../node_modules/form-render/node_modules/@ant-design/icons/lib/utils.js"(exports2) {
    "use strict";
    var _interopRequireDefault = require_interopRequireDefault();
    var _typeof32 = require_typeof();
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.generate = generate3;
    exports2.getSecondaryColor = getSecondaryColor2;
    exports2.iconStyles = void 0;
    exports2.isIconDefinition = isIconDefinition2;
    exports2.normalizeAttrs = normalizeAttrs2;
    exports2.normalizeTwoToneColors = normalizeTwoToneColors2;
    exports2.useInsertStyles = exports2.svgBaseProps = void 0;
    exports2.warning = warning6;
    var _objectSpread22 = _interopRequireDefault(require_objectSpread2());
    var _typeof22 = _interopRequireDefault(require_typeof());
    var _colors = require_dist2();
    var _react = _interopRequireWildcard(require_react());
    var _warning2 = _interopRequireDefault(require_warning());
    var _dynamicCSS = require_dynamicCSS();
    var _Context = _interopRequireDefault(require_Context());
    var _camelCase = _interopRequireDefault(require_camelCase());
    function _getRequireWildcardCache(e3) {
      if ("function" != typeof WeakMap) return null;
      var r2 = /* @__PURE__ */ new WeakMap(), t2 = /* @__PURE__ */ new WeakMap();
      return (_getRequireWildcardCache = function _getRequireWildcardCache2(e4) {
        return e4 ? t2 : r2;
      })(e3);
    }
    function _interopRequireWildcard(e3, r2) {
      if (!r2 && e3 && e3.__esModule) return e3;
      if (null === e3 || "object" != _typeof32(e3) && "function" != typeof e3) return { default: e3 };
      var t2 = _getRequireWildcardCache(r2);
      if (t2 && t2.has(e3)) return t2.get(e3);
      var n2 = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var u in e3) if ("default" !== u && {}.hasOwnProperty.call(e3, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e3, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n2, u, i) : n2[u] = e3[u];
      }
      return n2.default = e3, t2 && t2.set(e3, n2), n2;
    }
    function warning6(valid, message2) {
      (0, _warning2.default)(valid, "[@ant-design/icons] ".concat(message2));
    }
    function isIconDefinition2(target) {
      return (0, _typeof22.default)(target) === "object" && typeof target.name === "string" && typeof target.theme === "string" && ((0, _typeof22.default)(target.icon) === "object" || typeof target.icon === "function");
    }
    function normalizeAttrs2() {
      var attrs = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      return Object.keys(attrs).reduce(function(acc, key2) {
        var val = attrs[key2];
        switch (key2) {
          case "class":
            acc.className = val;
            delete acc.class;
            break;
          default:
            delete acc[key2];
            acc[(0, _camelCase.default)(key2)] = val;
        }
        return acc;
      }, {});
    }
    function generate3(node2, key2, rootProps) {
      if (!rootProps) {
        return /* @__PURE__ */ _react.default.createElement(node2.tag, (0, _objectSpread22.default)({
          key: key2
        }, normalizeAttrs2(node2.attrs)), (node2.children || []).map(function(child, index3) {
          return generate3(child, "".concat(key2, "-").concat(node2.tag, "-").concat(index3));
        }));
      }
      return /* @__PURE__ */ _react.default.createElement(node2.tag, (0, _objectSpread22.default)((0, _objectSpread22.default)({
        key: key2
      }, normalizeAttrs2(node2.attrs)), rootProps), (node2.children || []).map(function(child, index3) {
        return generate3(child, "".concat(key2, "-").concat(node2.tag, "-").concat(index3));
      }));
    }
    function getSecondaryColor2(primaryColor) {
      return (0, _colors.generate)(primaryColor)[0];
    }
    function normalizeTwoToneColors2(twoToneColor) {
      if (!twoToneColor) {
        return [];
      }
      return Array.isArray(twoToneColor) ? twoToneColor : [twoToneColor];
    }
    var svgBaseProps = exports2.svgBaseProps = {
      width: "1em",
      height: "1em",
      fill: "currentColor",
      "aria-hidden": "true",
      focusable: "false"
    };
    var iconStyles2 = exports2.iconStyles = "\n.anticon {\n  display: inline-flex;\n  alignItems: center;\n  color: inherit;\n  font-style: normal;\n  line-height: 0;\n  text-align: center;\n  text-transform: none;\n  vertical-align: -0.125em;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.anticon > * {\n  line-height: 1;\n}\n\n.anticon svg {\n  display: inline-block;\n}\n\n.anticon::before {\n  display: none;\n}\n\n.anticon .anticon-icon {\n  display: block;\n}\n\n.anticon[tabindex] {\n  cursor: pointer;\n}\n\n.anticon-spin::before,\n.anticon-spin {\n  display: inline-block;\n  -webkit-animation: loadingCircle 1s infinite linear;\n  animation: loadingCircle 1s infinite linear;\n}\n\n@-webkit-keyframes loadingCircle {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes loadingCircle {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n";
    var useInsertStyles3 = exports2.useInsertStyles = function useInsertStyles4() {
      var styleStr = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : iconStyles2;
      var _useContext = (0, _react.useContext)(_Context.default), csp = _useContext.csp;
      (0, _react.useEffect)(function() {
        (0, _dynamicCSS.updateCSS)(styleStr, "@ant-design-icons", {
          prepend: true,
          csp
        });
      }, []);
    };
  }
});

// ../../node_modules/form-render/node_modules/@ant-design/icons/lib/components/IconBase.js
var require_IconBase = __commonJS({
  "../../node_modules/form-render/node_modules/@ant-design/icons/lib/components/IconBase.js"(exports2) {
    "use strict";
    var _interopRequireDefault = require_interopRequireDefault();
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = void 0;
    var _objectWithoutProperties22 = _interopRequireDefault(require_objectWithoutProperties2());
    var _objectSpread22 = _interopRequireDefault(require_objectSpread2());
    var _utils = require_utils2();
    var _excluded77 = ["icon", "className", "onClick", "style", "primaryColor", "secondaryColor"];
    var twoToneColorPalette2 = {
      primaryColor: "#333",
      secondaryColor: "#E6E6E6",
      calculated: false
    };
    function setTwoToneColors2(_ref) {
      var primaryColor = _ref.primaryColor, secondaryColor = _ref.secondaryColor;
      twoToneColorPalette2.primaryColor = primaryColor;
      twoToneColorPalette2.secondaryColor = secondaryColor || (0, _utils.getSecondaryColor)(primaryColor);
      twoToneColorPalette2.calculated = !!secondaryColor;
    }
    function getTwoToneColors2() {
      return (0, _objectSpread22.default)({}, twoToneColorPalette2);
    }
    var IconBase3 = function IconBase4(props) {
      var icon = props.icon, className2 = props.className, onClick = props.onClick, style2 = props.style, primaryColor = props.primaryColor, secondaryColor = props.secondaryColor, restProps = (0, _objectWithoutProperties22.default)(props, _excluded77);
      var colors = twoToneColorPalette2;
      if (primaryColor) {
        colors = {
          primaryColor,
          secondaryColor: secondaryColor || (0, _utils.getSecondaryColor)(primaryColor)
        };
      }
      (0, _utils.useInsertStyles)();
      (0, _utils.warning)((0, _utils.isIconDefinition)(icon), "icon should be icon definiton, but got ".concat(icon));
      if (!(0, _utils.isIconDefinition)(icon)) {
        return null;
      }
      var target = icon;
      if (target && typeof target.icon === "function") {
        target = (0, _objectSpread22.default)((0, _objectSpread22.default)({}, target), {}, {
          icon: target.icon(colors.primaryColor, colors.secondaryColor)
        });
      }
      return (0, _utils.generate)(target.icon, "svg-".concat(target.name), (0, _objectSpread22.default)({
        className: className2,
        onClick,
        style: style2,
        "data-icon": target.name,
        width: "1em",
        height: "1em",
        fill: "currentColor",
        "aria-hidden": "true"
      }, restProps));
    };
    IconBase3.displayName = "IconReact";
    IconBase3.getTwoToneColors = getTwoToneColors2;
    IconBase3.setTwoToneColors = setTwoToneColors2;
    var _default = exports2.default = IconBase3;
  }
});

// ../../node_modules/form-render/node_modules/@ant-design/icons/lib/components/twoTonePrimaryColor.js
var require_twoTonePrimaryColor = __commonJS({
  "../../node_modules/form-render/node_modules/@ant-design/icons/lib/components/twoTonePrimaryColor.js"(exports2) {
    "use strict";
    var _interopRequireDefault = require_interopRequireDefault();
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.getTwoToneColor = getTwoToneColor2;
    exports2.setTwoToneColor = setTwoToneColor2;
    var _slicedToArray22 = _interopRequireDefault(require_slicedToArray());
    var _IconBase = _interopRequireDefault(require_IconBase());
    var _utils = require_utils2();
    function setTwoToneColor2(twoToneColor) {
      var _normalizeTwoToneColo = (0, _utils.normalizeTwoToneColors)(twoToneColor), _normalizeTwoToneColo2 = (0, _slicedToArray22.default)(_normalizeTwoToneColo, 2), primaryColor = _normalizeTwoToneColo2[0], secondaryColor = _normalizeTwoToneColo2[1];
      return _IconBase.default.setTwoToneColors({
        primaryColor,
        secondaryColor
      });
    }
    function getTwoToneColor2() {
      var colors = _IconBase.default.getTwoToneColors();
      if (!colors.calculated) {
        return colors.primaryColor;
      }
      return [colors.primaryColor, colors.secondaryColor];
    }
  }
});

// ../../node_modules/form-render/node_modules/@ant-design/icons/lib/components/AntdIcon.js
var require_AntdIcon = __commonJS({
  "../../node_modules/form-render/node_modules/@ant-design/icons/lib/components/AntdIcon.js"(exports2) {
    "use strict";
    var _interopRequireDefault = require_interopRequireDefault();
    var _typeof16 = require_typeof();
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = void 0;
    var _objectSpread22 = _interopRequireDefault(require_objectSpread2());
    var _slicedToArray22 = _interopRequireDefault(require_slicedToArray());
    var _defineProperty22 = _interopRequireDefault(require_defineProperty());
    var _objectWithoutProperties22 = _interopRequireDefault(require_objectWithoutProperties2());
    var React615 = _interopRequireWildcard(require_react());
    var _classnames = _interopRequireDefault(require_classnames());
    var _Context = _interopRequireDefault(require_Context());
    var _IconBase = _interopRequireDefault(require_IconBase());
    var _twoTonePrimaryColor = require_twoTonePrimaryColor();
    var _utils = require_utils2();
    var _excluded77 = ["className", "icon", "spin", "rotate", "tabIndex", "onClick", "twoToneColor"];
    function _getRequireWildcardCache(e3) {
      if ("function" != typeof WeakMap) return null;
      var r2 = /* @__PURE__ */ new WeakMap(), t2 = /* @__PURE__ */ new WeakMap();
      return (_getRequireWildcardCache = function _getRequireWildcardCache2(e4) {
        return e4 ? t2 : r2;
      })(e3);
    }
    function _interopRequireWildcard(e3, r2) {
      if (!r2 && e3 && e3.__esModule) return e3;
      if (null === e3 || "object" != _typeof16(e3) && "function" != typeof e3) return { default: e3 };
      var t2 = _getRequireWildcardCache(r2);
      if (t2 && t2.has(e3)) return t2.get(e3);
      var n2 = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var u in e3) if ("default" !== u && {}.hasOwnProperty.call(e3, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e3, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n2, u, i) : n2[u] = e3[u];
      }
      return n2.default = e3, t2 && t2.set(e3, n2), n2;
    }
    (0, _twoTonePrimaryColor.setTwoToneColor)("#1890ff");
    var Icon6 = /* @__PURE__ */ React615.forwardRef(function(props, ref3) {
      var className2 = props.className, icon = props.icon, spin = props.spin, rotate2 = props.rotate, tabIndex = props.tabIndex, onClick = props.onClick, twoToneColor = props.twoToneColor, restProps = (0, _objectWithoutProperties22.default)(props, _excluded77);
      var _React$useContext = React615.useContext(_Context.default), _React$useContext$pre = _React$useContext.prefixCls, prefixCls = _React$useContext$pre === void 0 ? "anticon" : _React$useContext$pre, rootClassName = _React$useContext.rootClassName;
      var classString = (0, _classnames.default)(rootClassName, prefixCls, (0, _defineProperty22.default)((0, _defineProperty22.default)({}, "".concat(prefixCls, "-").concat(icon.name), !!icon.name), "".concat(prefixCls, "-spin"), !!spin || icon.name === "loading"), className2);
      var iconTabIndex = tabIndex;
      if (iconTabIndex === void 0 && onClick) {
        iconTabIndex = -1;
      }
      var svgStyle = rotate2 ? {
        msTransform: "rotate(".concat(rotate2, "deg)"),
        transform: "rotate(".concat(rotate2, "deg)")
      } : void 0;
      var _normalizeTwoToneColo = (0, _utils.normalizeTwoToneColors)(twoToneColor), _normalizeTwoToneColo2 = (0, _slicedToArray22.default)(_normalizeTwoToneColo, 2), primaryColor = _normalizeTwoToneColo2[0], secondaryColor = _normalizeTwoToneColo2[1];
      return /* @__PURE__ */ React615.createElement("span", (0, _objectSpread22.default)((0, _objectSpread22.default)({
        role: "img",
        "aria-label": icon.name
      }, restProps), {}, {
        ref: ref3,
        tabIndex: iconTabIndex,
        onClick,
        className: classString
      }), /* @__PURE__ */ React615.createElement(_IconBase.default, {
        icon,
        primaryColor,
        secondaryColor,
        style: svgStyle
      }));
    });
    Icon6.displayName = "AntdIcon";
    Icon6.getTwoToneColor = _twoTonePrimaryColor.getTwoToneColor;
    Icon6.setTwoToneColor = _twoTonePrimaryColor.setTwoToneColor;
    var _default = exports2.default = Icon6;
  }
});

// ../../node_modules/form-render/node_modules/@ant-design/icons/lib/icons/PictureOutlined.js
var require_PictureOutlined2 = __commonJS({
  "../../node_modules/form-render/node_modules/@ant-design/icons/lib/icons/PictureOutlined.js"(exports2) {
    "use strict";
    var _interopRequireDefault = require_interopRequireDefault();
    var _typeof16 = require_typeof();
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = void 0;
    var _objectSpread22 = _interopRequireDefault(require_objectSpread2());
    var React615 = _interopRequireWildcard(require_react());
    var _PictureOutlined2 = _interopRequireDefault(require_PictureOutlined());
    var _AntdIcon = _interopRequireDefault(require_AntdIcon());
    function _getRequireWildcardCache(e3) {
      if ("function" != typeof WeakMap) return null;
      var r2 = /* @__PURE__ */ new WeakMap(), t2 = /* @__PURE__ */ new WeakMap();
      return (_getRequireWildcardCache = function _getRequireWildcardCache2(e4) {
        return e4 ? t2 : r2;
      })(e3);
    }
    function _interopRequireWildcard(e3, r2) {
      if (!r2 && e3 && e3.__esModule) return e3;
      if (null === e3 || "object" != _typeof16(e3) && "function" != typeof e3) return { default: e3 };
      var t2 = _getRequireWildcardCache(r2);
      if (t2 && t2.has(e3)) return t2.get(e3);
      var n2 = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var u in e3) if ("default" !== u && {}.hasOwnProperty.call(e3, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e3, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n2, u, i) : n2[u] = e3[u];
      }
      return n2.default = e3, t2 && t2.set(e3, n2), n2;
    }
    var PictureOutlined = function PictureOutlined2(props, ref3) {
      return /* @__PURE__ */ React615.createElement(_AntdIcon.default, (0, _objectSpread22.default)((0, _objectSpread22.default)({}, props), {}, {
        ref: ref3,
        icon: _PictureOutlined2.default
      }));
    };
    var RefIcon50 = /* @__PURE__ */ React615.forwardRef(PictureOutlined);
    if (true) {
      RefIcon50.displayName = "PictureOutlined";
    }
    var _default = exports2.default = RefIcon50;
  }
});

// ../../node_modules/@ant-design/icons-svg/lib/asn/UploadOutlined.js
var require_UploadOutlined = __commonJS({
  "../../node_modules/@ant-design/icons-svg/lib/asn/UploadOutlined.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    var UploadOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M400 317.7h73.9V656c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V317.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 163a8 8 0 00-12.6 0l-112 141.7c-4.1 5.3-.4 13 6.3 13zM878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z" } }] }, "name": "upload", "theme": "outlined" };
    exports2.default = UploadOutlined;
  }
});

// ../../node_modules/form-render/node_modules/@ant-design/icons/lib/icons/UploadOutlined.js
var require_UploadOutlined2 = __commonJS({
  "../../node_modules/form-render/node_modules/@ant-design/icons/lib/icons/UploadOutlined.js"(exports2) {
    "use strict";
    var _interopRequireDefault = require_interopRequireDefault();
    var _typeof16 = require_typeof();
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = void 0;
    var _objectSpread22 = _interopRequireDefault(require_objectSpread2());
    var React615 = _interopRequireWildcard(require_react());
    var _UploadOutlined2 = _interopRequireDefault(require_UploadOutlined());
    var _AntdIcon = _interopRequireDefault(require_AntdIcon());
    function _getRequireWildcardCache(e3) {
      if ("function" != typeof WeakMap) return null;
      var r2 = /* @__PURE__ */ new WeakMap(), t2 = /* @__PURE__ */ new WeakMap();
      return (_getRequireWildcardCache = function _getRequireWildcardCache2(e4) {
        return e4 ? t2 : r2;
      })(e3);
    }
    function _interopRequireWildcard(e3, r2) {
      if (!r2 && e3 && e3.__esModule) return e3;
      if (null === e3 || "object" != _typeof16(e3) && "function" != typeof e3) return { default: e3 };
      var t2 = _getRequireWildcardCache(r2);
      if (t2 && t2.has(e3)) return t2.get(e3);
      var n2 = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var u in e3) if ("default" !== u && {}.hasOwnProperty.call(e3, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e3, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n2, u, i) : n2[u] = e3[u];
      }
      return n2.default = e3, t2 && t2.set(e3, n2), n2;
    }
    var UploadOutlined = function UploadOutlined2(props, ref3) {
      return /* @__PURE__ */ React615.createElement(_AntdIcon.default, (0, _objectSpread22.default)((0, _objectSpread22.default)({}, props), {}, {
        ref: ref3,
        icon: _UploadOutlined2.default
      }));
    };
    var RefIcon50 = /* @__PURE__ */ React615.forwardRef(UploadOutlined);
    if (true) {
      RefIcon50.displayName = "UploadOutlined";
    }
    var _default = exports2.default = RefIcon50;
  }
});

// ../../node_modules/@ant-design/icons-svg/lib/asn/DownOutlined.js
var require_DownOutlined = __commonJS({
  "../../node_modules/@ant-design/icons-svg/lib/asn/DownOutlined.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    var DownOutlined4 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z" } }] }, "name": "down", "theme": "outlined" };
    exports2.default = DownOutlined4;
  }
});

// ../../node_modules/form-render/node_modules/@ant-design/icons/lib/icons/DownOutlined.js
var require_DownOutlined2 = __commonJS({
  "../../node_modules/form-render/node_modules/@ant-design/icons/lib/icons/DownOutlined.js"(exports2) {
    "use strict";
    var _interopRequireDefault = require_interopRequireDefault();
    var _typeof16 = require_typeof();
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = void 0;
    var _objectSpread22 = _interopRequireDefault(require_objectSpread2());
    var React615 = _interopRequireWildcard(require_react());
    var _DownOutlined3 = _interopRequireDefault(require_DownOutlined());
    var _AntdIcon = _interopRequireDefault(require_AntdIcon());
    function _getRequireWildcardCache(e3) {
      if ("function" != typeof WeakMap) return null;
      var r2 = /* @__PURE__ */ new WeakMap(), t2 = /* @__PURE__ */ new WeakMap();
      return (_getRequireWildcardCache = function _getRequireWildcardCache2(e4) {
        return e4 ? t2 : r2;
      })(e3);
    }
    function _interopRequireWildcard(e3, r2) {
      if (!r2 && e3 && e3.__esModule) return e3;
      if (null === e3 || "object" != _typeof16(e3) && "function" != typeof e3) return { default: e3 };
      var t2 = _getRequireWildcardCache(r2);
      if (t2 && t2.has(e3)) return t2.get(e3);
      var n2 = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var u in e3) if ("default" !== u && {}.hasOwnProperty.call(e3, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e3, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n2, u, i) : n2[u] = e3[u];
      }
      return n2.default = e3, t2 && t2.set(e3, n2), n2;
    }
    var DownOutlined4 = function DownOutlined5(props, ref3) {
      return /* @__PURE__ */ React615.createElement(_AntdIcon.default, (0, _objectSpread22.default)((0, _objectSpread22.default)({}, props), {}, {
        ref: ref3,
        icon: _DownOutlined3.default
      }));
    };
    var RefIcon50 = /* @__PURE__ */ React615.forwardRef(DownOutlined4);
    if (true) {
      RefIcon50.displayName = "DownOutlined";
    }
    var _default = exports2.default = RefIcon50;
  }
});

// ../../node_modules/@ant-design/icons-svg/lib/asn/PlusOutlined.js
var require_PlusOutlined = __commonJS({
  "../../node_modules/@ant-design/icons-svg/lib/asn/PlusOutlined.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    var PlusOutlined4 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8z" } }, { "tag": "path", "attrs": { "d": "M192 474h672q8 0 8 8v60q0 8-8 8H160q-8 0-8-8v-60q0-8 8-8z" } }] }, "name": "plus", "theme": "outlined" };
    exports2.default = PlusOutlined4;
  }
});

// ../../node_modules/form-render/node_modules/@ant-design/icons/lib/icons/PlusOutlined.js
var require_PlusOutlined2 = __commonJS({
  "../../node_modules/form-render/node_modules/@ant-design/icons/lib/icons/PlusOutlined.js"(exports2) {
    "use strict";
    var _interopRequireDefault = require_interopRequireDefault();
    var _typeof16 = require_typeof();
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = void 0;
    var _objectSpread22 = _interopRequireDefault(require_objectSpread2());
    var React615 = _interopRequireWildcard(require_react());
    var _PlusOutlined6 = _interopRequireDefault(require_PlusOutlined());
    var _AntdIcon = _interopRequireDefault(require_AntdIcon());
    function _getRequireWildcardCache(e3) {
      if ("function" != typeof WeakMap) return null;
      var r2 = /* @__PURE__ */ new WeakMap(), t2 = /* @__PURE__ */ new WeakMap();
      return (_getRequireWildcardCache = function _getRequireWildcardCache2(e4) {
        return e4 ? t2 : r2;
      })(e3);
    }
    function _interopRequireWildcard(e3, r2) {
      if (!r2 && e3 && e3.__esModule) return e3;
      if (null === e3 || "object" != _typeof16(e3) && "function" != typeof e3) return { default: e3 };
      var t2 = _getRequireWildcardCache(r2);
      if (t2 && t2.has(e3)) return t2.get(e3);
      var n2 = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var u in e3) if ("default" !== u && {}.hasOwnProperty.call(e3, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e3, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n2, u, i) : n2[u] = e3[u];
      }
      return n2.default = e3, t2 && t2.set(e3, n2), n2;
    }
    var PlusOutlined4 = function PlusOutlined5(props, ref3) {
      return /* @__PURE__ */ React615.createElement(_AntdIcon.default, (0, _objectSpread22.default)((0, _objectSpread22.default)({}, props), {}, {
        ref: ref3,
        icon: _PlusOutlined6.default
      }));
    };
    var RefIcon50 = /* @__PURE__ */ React615.forwardRef(PlusOutlined4);
    if (true) {
      RefIcon50.displayName = "PlusOutlined";
    }
    var _default = exports2.default = RefIcon50;
  }
});

// ../../node_modules/@ant-design/icons-svg/lib/asn/CopyOutlined.js
var require_CopyOutlined = __commonJS({
  "../../node_modules/@ant-design/icons-svg/lib/asn/CopyOutlined.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    var CopyOutlined4 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32zM704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM350 856.2L263.9 770H350v86.2zM664 888H414V746c0-22.1-17.9-40-40-40H232V264h432v624z" } }] }, "name": "copy", "theme": "outlined" };
    exports2.default = CopyOutlined4;
  }
});

// ../../node_modules/form-render/node_modules/@ant-design/icons/lib/icons/CopyOutlined.js
var require_CopyOutlined2 = __commonJS({
  "../../node_modules/form-render/node_modules/@ant-design/icons/lib/icons/CopyOutlined.js"(exports2) {
    "use strict";
    var _interopRequireDefault = require_interopRequireDefault();
    var _typeof16 = require_typeof();
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = void 0;
    var _objectSpread22 = _interopRequireDefault(require_objectSpread2());
    var React615 = _interopRequireWildcard(require_react());
    var _CopyOutlined6 = _interopRequireDefault(require_CopyOutlined());
    var _AntdIcon = _interopRequireDefault(require_AntdIcon());
    function _getRequireWildcardCache(e3) {
      if ("function" != typeof WeakMap) return null;
      var r2 = /* @__PURE__ */ new WeakMap(), t2 = /* @__PURE__ */ new WeakMap();
      return (_getRequireWildcardCache = function _getRequireWildcardCache2(e4) {
        return e4 ? t2 : r2;
      })(e3);
    }
    function _interopRequireWildcard(e3, r2) {
      if (!r2 && e3 && e3.__esModule) return e3;
      if (null === e3 || "object" != _typeof16(e3) && "function" != typeof e3) return { default: e3 };
      var t2 = _getRequireWildcardCache(r2);
      if (t2 && t2.has(e3)) return t2.get(e3);
      var n2 = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var u in e3) if ("default" !== u && {}.hasOwnProperty.call(e3, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e3, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n2, u, i) : n2[u] = e3[u];
      }
      return n2.default = e3, t2 && t2.set(e3, n2), n2;
    }
    var CopyOutlined4 = function CopyOutlined5(props, ref3) {
      return /* @__PURE__ */ React615.createElement(_AntdIcon.default, (0, _objectSpread22.default)((0, _objectSpread22.default)({}, props), {}, {
        ref: ref3,
        icon: _CopyOutlined6.default
      }));
    };
    var RefIcon50 = /* @__PURE__ */ React615.forwardRef(CopyOutlined4);
    if (true) {
      RefIcon50.displayName = "CopyOutlined";
    }
    var _default = exports2.default = RefIcon50;
  }
});

// ../../node_modules/@ant-design/icons-svg/lib/asn/CloseOutlined.js
var require_CloseOutlined = __commonJS({
  "../../node_modules/@ant-design/icons-svg/lib/asn/CloseOutlined.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    var CloseOutlined4 = { "icon": { "tag": "svg", "attrs": { "fill-rule": "evenodd", "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M799.86 166.31c.02 0 .04.02.08.06l57.69 57.7c.04.03.05.05.06.08a.12.12 0 010 .06c0 .03-.02.05-.06.09L569.93 512l287.7 287.7c.04.04.05.06.06.09a.12.12 0 010 .07c0 .02-.02.04-.06.08l-57.7 57.69c-.03.04-.05.05-.07.06a.12.12 0 01-.07 0c-.03 0-.05-.02-.09-.06L512 569.93l-287.7 287.7c-.04.04-.06.05-.09.06a.12.12 0 01-.07 0c-.02 0-.04-.02-.08-.06l-57.69-57.7c-.04-.03-.05-.05-.06-.07a.12.12 0 010-.07c0-.03.02-.05.06-.09L454.07 512l-287.7-287.7c-.04-.04-.05-.06-.06-.09a.12.12 0 010-.07c0-.02.02-.04.06-.08l57.7-57.69c.03-.04.05-.05.07-.06a.12.12 0 01.07 0c.03 0 .05.02.09.06L512 454.07l287.7-287.7c.04-.04.06-.05.09-.06a.12.12 0 01.07 0z" } }] }, "name": "close", "theme": "outlined" };
    exports2.default = CloseOutlined4;
  }
});

// ../../node_modules/form-render/node_modules/@ant-design/icons/lib/icons/CloseOutlined.js
var require_CloseOutlined2 = __commonJS({
  "../../node_modules/form-render/node_modules/@ant-design/icons/lib/icons/CloseOutlined.js"(exports2) {
    "use strict";
    var _interopRequireDefault = require_interopRequireDefault();
    var _typeof16 = require_typeof();
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = void 0;
    var _objectSpread22 = _interopRequireDefault(require_objectSpread2());
    var React615 = _interopRequireWildcard(require_react());
    var _CloseOutlined7 = _interopRequireDefault(require_CloseOutlined());
    var _AntdIcon = _interopRequireDefault(require_AntdIcon());
    function _getRequireWildcardCache(e3) {
      if ("function" != typeof WeakMap) return null;
      var r2 = /* @__PURE__ */ new WeakMap(), t2 = /* @__PURE__ */ new WeakMap();
      return (_getRequireWildcardCache = function _getRequireWildcardCache2(e4) {
        return e4 ? t2 : r2;
      })(e3);
    }
    function _interopRequireWildcard(e3, r2) {
      if (!r2 && e3 && e3.__esModule) return e3;
      if (null === e3 || "object" != _typeof16(e3) && "function" != typeof e3) return { default: e3 };
      var t2 = _getRequireWildcardCache(r2);
      if (t2 && t2.has(e3)) return t2.get(e3);
      var n2 = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var u in e3) if ("default" !== u && {}.hasOwnProperty.call(e3, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e3, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n2, u, i) : n2[u] = e3[u];
      }
      return n2.default = e3, t2 && t2.set(e3, n2), n2;
    }
    var CloseOutlined4 = function CloseOutlined5(props, ref3) {
      return /* @__PURE__ */ React615.createElement(_AntdIcon.default, (0, _objectSpread22.default)((0, _objectSpread22.default)({}, props), {}, {
        ref: ref3,
        icon: _CloseOutlined7.default
      }));
    };
    var RefIcon50 = /* @__PURE__ */ React615.forwardRef(CloseOutlined4);
    if (true) {
      RefIcon50.displayName = "CloseOutlined";
    }
    var _default = exports2.default = RefIcon50;
  }
});

// ../../node_modules/@ant-design/icons-svg/lib/asn/ArrowDownOutlined.js
var require_ArrowDownOutlined = __commonJS({
  "../../node_modules/@ant-design/icons-svg/lib/asn/ArrowDownOutlined.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    var ArrowDownOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M862 465.3h-81c-4.6 0-9 2-12.1 5.5L550 723.1V160c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v563.1L255.1 470.8c-3-3.5-7.4-5.5-12.1-5.5h-81c-6.8 0-10.5 8.1-6 13.2L487.9 861a31.96 31.96 0 0048.3 0L868 478.5c4.5-5.2.8-13.2-6-13.2z" } }] }, "name": "arrow-down", "theme": "outlined" };
    exports2.default = ArrowDownOutlined;
  }
});

// ../../node_modules/form-render/node_modules/@ant-design/icons/lib/icons/ArrowDownOutlined.js
var require_ArrowDownOutlined2 = __commonJS({
  "../../node_modules/form-render/node_modules/@ant-design/icons/lib/icons/ArrowDownOutlined.js"(exports2) {
    "use strict";
    var _interopRequireDefault = require_interopRequireDefault();
    var _typeof16 = require_typeof();
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = void 0;
    var _objectSpread22 = _interopRequireDefault(require_objectSpread2());
    var React615 = _interopRequireWildcard(require_react());
    var _ArrowDownOutlined6 = _interopRequireDefault(require_ArrowDownOutlined());
    var _AntdIcon = _interopRequireDefault(require_AntdIcon());
    function _getRequireWildcardCache(e3) {
      if ("function" != typeof WeakMap) return null;
      var r2 = /* @__PURE__ */ new WeakMap(), t2 = /* @__PURE__ */ new WeakMap();
      return (_getRequireWildcardCache = function _getRequireWildcardCache2(e4) {
        return e4 ? t2 : r2;
      })(e3);
    }
    function _interopRequireWildcard(e3, r2) {
      if (!r2 && e3 && e3.__esModule) return e3;
      if (null === e3 || "object" != _typeof16(e3) && "function" != typeof e3) return { default: e3 };
      var t2 = _getRequireWildcardCache(r2);
      if (t2 && t2.has(e3)) return t2.get(e3);
      var n2 = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var u in e3) if ("default" !== u && {}.hasOwnProperty.call(e3, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e3, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n2, u, i) : n2[u] = e3[u];
      }
      return n2.default = e3, t2 && t2.set(e3, n2), n2;
    }
    var ArrowDownOutlined = function ArrowDownOutlined2(props, ref3) {
      return /* @__PURE__ */ React615.createElement(_AntdIcon.default, (0, _objectSpread22.default)((0, _objectSpread22.default)({}, props), {}, {
        ref: ref3,
        icon: _ArrowDownOutlined6.default
      }));
    };
    var RefIcon50 = /* @__PURE__ */ React615.forwardRef(ArrowDownOutlined);
    if (true) {
      RefIcon50.displayName = "ArrowDownOutlined";
    }
    var _default = exports2.default = RefIcon50;
  }
});

// ../../node_modules/@ant-design/icons-svg/lib/asn/ArrowUpOutlined.js
var require_ArrowUpOutlined = __commonJS({
  "../../node_modules/@ant-design/icons-svg/lib/asn/ArrowUpOutlined.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    var ArrowUpOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M868 545.5L536.1 163a31.96 31.96 0 00-48.3 0L156 545.5a7.97 7.97 0 006 13.2h81c4.6 0 9-2 12.1-5.5L474 300.9V864c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V300.9l218.9 252.3c3 3.5 7.4 5.5 12.1 5.5h81c6.8 0 10.5-8 6-13.2z" } }] }, "name": "arrow-up", "theme": "outlined" };
    exports2.default = ArrowUpOutlined;
  }
});

// ../../node_modules/form-render/node_modules/@ant-design/icons/lib/icons/ArrowUpOutlined.js
var require_ArrowUpOutlined2 = __commonJS({
  "../../node_modules/form-render/node_modules/@ant-design/icons/lib/icons/ArrowUpOutlined.js"(exports2) {
    "use strict";
    var _interopRequireDefault = require_interopRequireDefault();
    var _typeof16 = require_typeof();
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = void 0;
    var _objectSpread22 = _interopRequireDefault(require_objectSpread2());
    var React615 = _interopRequireWildcard(require_react());
    var _ArrowUpOutlined6 = _interopRequireDefault(require_ArrowUpOutlined());
    var _AntdIcon = _interopRequireDefault(require_AntdIcon());
    function _getRequireWildcardCache(e3) {
      if ("function" != typeof WeakMap) return null;
      var r2 = /* @__PURE__ */ new WeakMap(), t2 = /* @__PURE__ */ new WeakMap();
      return (_getRequireWildcardCache = function _getRequireWildcardCache2(e4) {
        return e4 ? t2 : r2;
      })(e3);
    }
    function _interopRequireWildcard(e3, r2) {
      if (!r2 && e3 && e3.__esModule) return e3;
      if (null === e3 || "object" != _typeof16(e3) && "function" != typeof e3) return { default: e3 };
      var t2 = _getRequireWildcardCache(r2);
      if (t2 && t2.has(e3)) return t2.get(e3);
      var n2 = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var u in e3) if ("default" !== u && {}.hasOwnProperty.call(e3, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e3, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n2, u, i) : n2[u] = e3[u];
      }
      return n2.default = e3, t2 && t2.set(e3, n2), n2;
    }
    var ArrowUpOutlined = function ArrowUpOutlined2(props, ref3) {
      return /* @__PURE__ */ React615.createElement(_AntdIcon.default, (0, _objectSpread22.default)((0, _objectSpread22.default)({}, props), {}, {
        ref: ref3,
        icon: _ArrowUpOutlined6.default
      }));
    };
    var RefIcon50 = /* @__PURE__ */ React615.forwardRef(ArrowUpOutlined);
    if (true) {
      RefIcon50.displayName = "ArrowUpOutlined";
    }
    var _default = exports2.default = RefIcon50;
  }
});

// ../../node_modules/@ant-design/icons-svg/lib/asn/InfoCircleOutlined.js
var require_InfoCircleOutlined = __commonJS({
  "../../node_modules/@ant-design/icons-svg/lib/asn/InfoCircleOutlined.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    var InfoCircleOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }, { "tag": "path", "attrs": { "d": "M464 336a48 48 0 1096 0 48 48 0 10-96 0zm72 112h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8z" } }] }, "name": "info-circle", "theme": "outlined" };
    exports2.default = InfoCircleOutlined;
  }
});

// ../../node_modules/form-render/node_modules/@ant-design/icons/lib/icons/InfoCircleOutlined.js
var require_InfoCircleOutlined2 = __commonJS({
  "../../node_modules/form-render/node_modules/@ant-design/icons/lib/icons/InfoCircleOutlined.js"(exports2) {
    "use strict";
    var _interopRequireDefault = require_interopRequireDefault();
    var _typeof16 = require_typeof();
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = void 0;
    var _objectSpread22 = _interopRequireDefault(require_objectSpread2());
    var React615 = _interopRequireWildcard(require_react());
    var _InfoCircleOutlined4 = _interopRequireDefault(require_InfoCircleOutlined());
    var _AntdIcon = _interopRequireDefault(require_AntdIcon());
    function _getRequireWildcardCache(e3) {
      if ("function" != typeof WeakMap) return null;
      var r2 = /* @__PURE__ */ new WeakMap(), t2 = /* @__PURE__ */ new WeakMap();
      return (_getRequireWildcardCache = function _getRequireWildcardCache2(e4) {
        return e4 ? t2 : r2;
      })(e3);
    }
    function _interopRequireWildcard(e3, r2) {
      if (!r2 && e3 && e3.__esModule) return e3;
      if (null === e3 || "object" != _typeof16(e3) && "function" != typeof e3) return { default: e3 };
      var t2 = _getRequireWildcardCache(r2);
      if (t2 && t2.has(e3)) return t2.get(e3);
      var n2 = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var u in e3) if ("default" !== u && {}.hasOwnProperty.call(e3, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e3, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n2, u, i) : n2[u] = e3[u];
      }
      return n2.default = e3, t2 && t2.set(e3, n2), n2;
    }
    var InfoCircleOutlined = function InfoCircleOutlined2(props, ref3) {
      return /* @__PURE__ */ React615.createElement(_AntdIcon.default, (0, _objectSpread22.default)((0, _objectSpread22.default)({}, props), {}, {
        ref: ref3,
        icon: _InfoCircleOutlined4.default
      }));
    };
    var RefIcon50 = /* @__PURE__ */ React615.forwardRef(InfoCircleOutlined);
    if (true) {
      RefIcon50.displayName = "InfoCircleOutlined";
    }
    var _default = exports2.default = RefIcon50;
  }
});

// ../../node_modules/@ant-design/icons-svg/lib/asn/UpOutlined.js
var require_UpOutlined = __commonJS({
  "../../node_modules/@ant-design/icons-svg/lib/asn/UpOutlined.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    var UpOutlined4 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M890.5 755.3L537.9 269.2c-12.8-17.6-39-17.6-51.7 0L133.5 755.3A8 8 0 00140 768h75c5.1 0 9.9-2.5 12.9-6.6L512 369.8l284.1 391.6c3 4.1 7.8 6.6 12.9 6.6h75c6.5 0 10.3-7.4 6.5-12.7z" } }] }, "name": "up", "theme": "outlined" };
    exports2.default = UpOutlined4;
  }
});

// ../../node_modules/form-render/node_modules/@ant-design/icons/lib/icons/UpOutlined.js
var require_UpOutlined2 = __commonJS({
  "../../node_modules/form-render/node_modules/@ant-design/icons/lib/icons/UpOutlined.js"(exports2) {
    "use strict";
    var _interopRequireDefault = require_interopRequireDefault();
    var _typeof16 = require_typeof();
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = void 0;
    var _objectSpread22 = _interopRequireDefault(require_objectSpread2());
    var React615 = _interopRequireWildcard(require_react());
    var _UpOutlined2 = _interopRequireDefault(require_UpOutlined());
    var _AntdIcon = _interopRequireDefault(require_AntdIcon());
    function _getRequireWildcardCache(e3) {
      if ("function" != typeof WeakMap) return null;
      var r2 = /* @__PURE__ */ new WeakMap(), t2 = /* @__PURE__ */ new WeakMap();
      return (_getRequireWildcardCache = function _getRequireWildcardCache2(e4) {
        return e4 ? t2 : r2;
      })(e3);
    }
    function _interopRequireWildcard(e3, r2) {
      if (!r2 && e3 && e3.__esModule) return e3;
      if (null === e3 || "object" != _typeof16(e3) && "function" != typeof e3) return { default: e3 };
      var t2 = _getRequireWildcardCache(r2);
      if (t2 && t2.has(e3)) return t2.get(e3);
      var n2 = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var u in e3) if ("default" !== u && {}.hasOwnProperty.call(e3, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e3, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n2, u, i) : n2[u] = e3[u];
      }
      return n2.default = e3, t2 && t2.set(e3, n2), n2;
    }
    var UpOutlined4 = function UpOutlined5(props, ref3) {
      return /* @__PURE__ */ React615.createElement(_AntdIcon.default, (0, _objectSpread22.default)((0, _objectSpread22.default)({}, props), {}, {
        ref: ref3,
        icon: _UpOutlined2.default
      }));
    };
    var RefIcon50 = /* @__PURE__ */ React615.forwardRef(UpOutlined4);
    if (true) {
      RefIcon50.displayName = "UpOutlined";
    }
    var _default = exports2.default = RefIcon50;
  }
});

// src/Designer.tsx
var import_react248 = __toESM(require_react());
var import_react_dom14 = __toESM(require_react_dom());

// ../common/dist/esm/src/version.js
var PDFME_VERSION = "x.x.x";

// ../common/dist/esm/src/constants.js
var PT_TO_PX_RATIO = 1.333;
var PT_TO_MM_RATIO = 0.3528;
var MM_TO_PT_RATIO = 2.8346;
var ZOOM = 3.7795275591;
var DEFAULT_FONT_NAME = "Roboto";
var DEFAULT_FONT_VALUE = "data:font/ttf;base64,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";

// ../../node_modules/zod/v3/external.js
var external_exports = {};
__export(external_exports, {
  BRAND: () => BRAND,
  DIRTY: () => DIRTY,
  EMPTY_PATH: () => EMPTY_PATH,
  INVALID: () => INVALID,
  NEVER: () => NEVER,
  OK: () => OK,
  ParseStatus: () => ParseStatus,
  Schema: () => ZodType,
  ZodAny: () => ZodAny,
  ZodArray: () => ZodArray,
  ZodBigInt: () => ZodBigInt,
  ZodBoolean: () => ZodBoolean,
  ZodBranded: () => ZodBranded,
  ZodCatch: () => ZodCatch,
  ZodDate: () => ZodDate,
  ZodDefault: () => ZodDefault,
  ZodDiscriminatedUnion: () => ZodDiscriminatedUnion,
  ZodEffects: () => ZodEffects,
  ZodEnum: () => ZodEnum,
  ZodError: () => ZodError,
  ZodFirstPartyTypeKind: () => ZodFirstPartyTypeKind,
  ZodFunction: () => ZodFunction,
  ZodIntersection: () => ZodIntersection,
  ZodIssueCode: () => ZodIssueCode,
  ZodLazy: () => ZodLazy,
  ZodLiteral: () => ZodLiteral,
  ZodMap: () => ZodMap,
  ZodNaN: () => ZodNaN,
  ZodNativeEnum: () => ZodNativeEnum,
  ZodNever: () => ZodNever,
  ZodNull: () => ZodNull,
  ZodNullable: () => ZodNullable,
  ZodNumber: () => ZodNumber,
  ZodObject: () => ZodObject,
  ZodOptional: () => ZodOptional,
  ZodParsedType: () => ZodParsedType,
  ZodPipeline: () => ZodPipeline,
  ZodPromise: () => ZodPromise,
  ZodReadonly: () => ZodReadonly,
  ZodRecord: () => ZodRecord,
  ZodSchema: () => ZodType,
  ZodSet: () => ZodSet,
  ZodString: () => ZodString,
  ZodSymbol: () => ZodSymbol,
  ZodTransformer: () => ZodEffects,
  ZodTuple: () => ZodTuple,
  ZodType: () => ZodType,
  ZodUndefined: () => ZodUndefined,
  ZodUnion: () => ZodUnion,
  ZodUnknown: () => ZodUnknown,
  ZodVoid: () => ZodVoid,
  addIssueToContext: () => addIssueToContext,
  any: () => anyType,
  array: () => arrayType,
  bigint: () => bigIntType,
  boolean: () => booleanType,
  coerce: () => coerce,
  custom: () => custom,
  date: () => dateType,
  datetimeRegex: () => datetimeRegex,
  defaultErrorMap: () => en_default,
  discriminatedUnion: () => discriminatedUnionType,
  effect: () => effectsType,
  enum: () => enumType,
  function: () => functionType,
  getErrorMap: () => getErrorMap,
  getParsedType: () => getParsedType,
  instanceof: () => instanceOfType,
  intersection: () => intersectionType,
  isAborted: () => isAborted,
  isAsync: () => isAsync,
  isDirty: () => isDirty,
  isValid: () => isValid,
  late: () => late,
  lazy: () => lazyType,
  literal: () => literalType,
  makeIssue: () => makeIssue,
  map: () => mapType,
  nan: () => nanType,
  nativeEnum: () => nativeEnumType,
  never: () => neverType,
  null: () => nullType,
  nullable: () => nullableType,
  number: () => numberType,
  object: () => objectType,
  objectUtil: () => objectUtil,
  oboolean: () => oboolean,
  onumber: () => onumber,
  optional: () => optionalType,
  ostring: () => ostring,
  pipeline: () => pipelineType,
  preprocess: () => preprocessType,
  promise: () => promiseType,
  quotelessJson: () => quotelessJson,
  record: () => recordType,
  set: () => setType,
  setErrorMap: () => setErrorMap,
  strictObject: () => strictObjectType,
  string: () => stringType,
  symbol: () => symbolType,
  transformer: () => effectsType,
  tuple: () => tupleType,
  undefined: () => undefinedType,
  union: () => unionType,
  unknown: () => unknownType,
  util: () => util,
  void: () => voidType
});

// ../../node_modules/zod/v3/helpers/util.js
var util;
(function(util2) {
  util2.assertEqual = (_) => {
  };
  function assertIs2(_arg) {
  }
  util2.assertIs = assertIs2;
  function assertNever(_x) {
    throw new Error();
  }
  util2.assertNever = assertNever;
  util2.arrayToEnum = (items) => {
    const obj = {};
    for (const item of items) {
      obj[item] = item;
    }
    return obj;
  };
  util2.getValidEnumValues = (obj) => {
    const validKeys = util2.objectKeys(obj).filter((k) => typeof obj[obj[k]] !== "number");
    const filtered = {};
    for (const k of validKeys) {
      filtered[k] = obj[k];
    }
    return util2.objectValues(filtered);
  };
  util2.objectValues = (obj) => {
    return util2.objectKeys(obj).map(function(e3) {
      return obj[e3];
    });
  };
  util2.objectKeys = typeof Object.keys === "function" ? (obj) => Object.keys(obj) : (object4) => {
    const keys4 = [];
    for (const key2 in object4) {
      if (Object.prototype.hasOwnProperty.call(object4, key2)) {
        keys4.push(key2);
      }
    }
    return keys4;
  };
  util2.find = (arr, checker) => {
    for (const item of arr) {
      if (checker(item))
        return item;
    }
    return void 0;
  };
  util2.isInteger = typeof Number.isInteger === "function" ? (val) => Number.isInteger(val) : (val) => typeof val === "number" && Number.isFinite(val) && Math.floor(val) === val;
  function joinValues(array4, separator = " | ") {
    return array4.map((val) => typeof val === "string" ? `'${val}'` : val).join(separator);
  }
  util2.joinValues = joinValues;
  util2.jsonStringifyReplacer = (_, value) => {
    if (typeof value === "bigint") {
      return value.toString();
    }
    return value;
  };
})(util || (util = {}));
var objectUtil;
(function(objectUtil2) {
  objectUtil2.mergeShapes = (first, second) => {
    return {
      ...first,
      ...second
      // second overwrites first
    };
  };
})(objectUtil || (objectUtil = {}));
var ZodParsedType = util.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]);
var getParsedType = (data2) => {
  const t2 = typeof data2;
  switch (t2) {
    case "undefined":
      return ZodParsedType.undefined;
    case "string":
      return ZodParsedType.string;
    case "number":
      return Number.isNaN(data2) ? ZodParsedType.nan : ZodParsedType.number;
    case "boolean":
      return ZodParsedType.boolean;
    case "function":
      return ZodParsedType.function;
    case "bigint":
      return ZodParsedType.bigint;
    case "symbol":
      return ZodParsedType.symbol;
    case "object":
      if (Array.isArray(data2)) {
        return ZodParsedType.array;
      }
      if (data2 === null) {
        return ZodParsedType.null;
      }
      if (data2.then && typeof data2.then === "function" && data2.catch && typeof data2.catch === "function") {
        return ZodParsedType.promise;
      }
      if (typeof Map !== "undefined" && data2 instanceof Map) {
        return ZodParsedType.map;
      }
      if (typeof Set !== "undefined" && data2 instanceof Set) {
        return ZodParsedType.set;
      }
      if (typeof Date !== "undefined" && data2 instanceof Date) {
        return ZodParsedType.date;
      }
      return ZodParsedType.object;
    default:
      return ZodParsedType.unknown;
  }
};

// ../../node_modules/zod/v3/ZodError.js
var ZodIssueCode = util.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]);
var quotelessJson = (obj) => {
  const json = JSON.stringify(obj, null, 2);
  return json.replace(/"([^"]+)":/g, "$1:");
};
var ZodError = class _ZodError extends Error {
  get errors() {
    return this.issues;
  }
  constructor(issues) {
    super();
    this.issues = [];
    this.addIssue = (sub) => {
      this.issues = [...this.issues, sub];
    };
    this.addIssues = (subs = []) => {
      this.issues = [...this.issues, ...subs];
    };
    const actualProto = new.target.prototype;
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(this, actualProto);
    } else {
      this.__proto__ = actualProto;
    }
    this.name = "ZodError";
    this.issues = issues;
  }
  format(_mapper) {
    const mapper = _mapper || function(issue) {
      return issue.message;
    };
    const fieldErrors = { _errors: [] };
    const processError = (error2) => {
      for (const issue of error2.issues) {
        if (issue.code === "invalid_union") {
          issue.unionErrors.map(processError);
        } else if (issue.code === "invalid_return_type") {
          processError(issue.returnTypeError);
        } else if (issue.code === "invalid_arguments") {
          processError(issue.argumentsError);
        } else if (issue.path.length === 0) {
          fieldErrors._errors.push(mapper(issue));
        } else {
          let curr = fieldErrors;
          let i = 0;
          while (i < issue.path.length) {
            const el = issue.path[i];
            const terminal = i === issue.path.length - 1;
            if (!terminal) {
              curr[el] = curr[el] || { _errors: [] };
            } else {
              curr[el] = curr[el] || { _errors: [] };
              curr[el]._errors.push(mapper(issue));
            }
            curr = curr[el];
            i++;
          }
        }
      }
    };
    processError(this);
    return fieldErrors;
  }
  static assert(value) {
    if (!(value instanceof _ZodError)) {
      throw new Error(`Not a ZodError: ${value}`);
    }
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, util.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(mapper = (issue) => issue.message) {
    const fieldErrors = {};
    const formErrors = [];
    for (const sub of this.issues) {
      if (sub.path.length > 0) {
        const firstEl = sub.path[0];
        fieldErrors[firstEl] = fieldErrors[firstEl] || [];
        fieldErrors[firstEl].push(mapper(sub));
      } else {
        formErrors.push(mapper(sub));
      }
    }
    return { formErrors, fieldErrors };
  }
  get formErrors() {
    return this.flatten();
  }
};
ZodError.create = (issues) => {
  const error2 = new ZodError(issues);
  return error2;
};

// ../../node_modules/zod/v3/locales/en.js
var errorMap = (issue, _ctx) => {
  let message2;
  switch (issue.code) {
    case ZodIssueCode.invalid_type:
      if (issue.received === ZodParsedType.undefined) {
        message2 = "Required";
      } else {
        message2 = `Expected ${issue.expected}, received ${issue.received}`;
      }
      break;
    case ZodIssueCode.invalid_literal:
      message2 = `Invalid literal value, expected ${JSON.stringify(issue.expected, util.jsonStringifyReplacer)}`;
      break;
    case ZodIssueCode.unrecognized_keys:
      message2 = `Unrecognized key(s) in object: ${util.joinValues(issue.keys, ", ")}`;
      break;
    case ZodIssueCode.invalid_union:
      message2 = `Invalid input`;
      break;
    case ZodIssueCode.invalid_union_discriminator:
      message2 = `Invalid discriminator value. Expected ${util.joinValues(issue.options)}`;
      break;
    case ZodIssueCode.invalid_enum_value:
      message2 = `Invalid enum value. Expected ${util.joinValues(issue.options)}, received '${issue.received}'`;
      break;
    case ZodIssueCode.invalid_arguments:
      message2 = `Invalid function arguments`;
      break;
    case ZodIssueCode.invalid_return_type:
      message2 = `Invalid function return type`;
      break;
    case ZodIssueCode.invalid_date:
      message2 = `Invalid date`;
      break;
    case ZodIssueCode.invalid_string:
      if (typeof issue.validation === "object") {
        if ("includes" in issue.validation) {
          message2 = `Invalid input: must include "${issue.validation.includes}"`;
          if (typeof issue.validation.position === "number") {
            message2 = `${message2} at one or more positions greater than or equal to ${issue.validation.position}`;
          }
        } else if ("startsWith" in issue.validation) {
          message2 = `Invalid input: must start with "${issue.validation.startsWith}"`;
        } else if ("endsWith" in issue.validation) {
          message2 = `Invalid input: must end with "${issue.validation.endsWith}"`;
        } else {
          util.assertNever(issue.validation);
        }
      } else if (issue.validation !== "regex") {
        message2 = `Invalid ${issue.validation}`;
      } else {
        message2 = "Invalid";
      }
      break;
    case ZodIssueCode.too_small:
      if (issue.type === "array")
        message2 = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
      else if (issue.type === "string")
        message2 = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
      else if (issue.type === "number")
        message2 = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
      else if (issue.type === "bigint")
        message2 = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
      else if (issue.type === "date")
        message2 = `Date must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${new Date(Number(issue.minimum))}`;
      else
        message2 = "Invalid input";
      break;
    case ZodIssueCode.too_big:
      if (issue.type === "array")
        message2 = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
      else if (issue.type === "string")
        message2 = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
      else if (issue.type === "number")
        message2 = `Number must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
      else if (issue.type === "bigint")
        message2 = `BigInt must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
      else if (issue.type === "date")
        message2 = `Date must be ${issue.exact ? `exactly` : issue.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(Number(issue.maximum))}`;
      else
        message2 = "Invalid input";
      break;
    case ZodIssueCode.custom:
      message2 = `Invalid input`;
      break;
    case ZodIssueCode.invalid_intersection_types:
      message2 = `Intersection results could not be merged`;
      break;
    case ZodIssueCode.not_multiple_of:
      message2 = `Number must be a multiple of ${issue.multipleOf}`;
      break;
    case ZodIssueCode.not_finite:
      message2 = "Number must be finite";
      break;
    default:
      message2 = _ctx.defaultError;
      util.assertNever(issue);
  }
  return { message: message2 };
};
var en_default = errorMap;

// ../../node_modules/zod/v3/errors.js
var overrideErrorMap = en_default;
function setErrorMap(map) {
  overrideErrorMap = map;
}
function getErrorMap() {
  return overrideErrorMap;
}

// ../../node_modules/zod/v3/helpers/parseUtil.js
var makeIssue = (params) => {
  const { data: data2, path: path2, errorMaps, issueData } = params;
  const fullPath = [...path2, ...issueData.path || []];
  const fullIssue = {
    ...issueData,
    path: fullPath
  };
  if (issueData.message !== void 0) {
    return {
      ...issueData,
      path: fullPath,
      message: issueData.message
    };
  }
  let errorMessage = "";
  const maps = errorMaps.filter((m) => !!m).slice().reverse();
  for (const map of maps) {
    errorMessage = map(fullIssue, { data: data2, defaultError: errorMessage }).message;
  }
  return {
    ...issueData,
    path: fullPath,
    message: errorMessage
  };
};
var EMPTY_PATH = [];
function addIssueToContext(ctx, issueData) {
  const overrideMap = getErrorMap();
  const issue = makeIssue({
    issueData,
    data: ctx.data,
    path: ctx.path,
    errorMaps: [
      ctx.common.contextualErrorMap,
      // contextual error map is first priority
      ctx.schemaErrorMap,
      // then schema-bound map if available
      overrideMap,
      // then global override map
      overrideMap === en_default ? void 0 : en_default
      // then global default map
    ].filter((x) => !!x)
  });
  ctx.common.issues.push(issue);
}
var ParseStatus = class _ParseStatus {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    if (this.value === "valid")
      this.value = "dirty";
  }
  abort() {
    if (this.value !== "aborted")
      this.value = "aborted";
  }
  static mergeArray(status, results) {
    const arrayValue = [];
    for (const s of results) {
      if (s.status === "aborted")
        return INVALID;
      if (s.status === "dirty")
        status.dirty();
      arrayValue.push(s.value);
    }
    return { status: status.value, value: arrayValue };
  }
  static async mergeObjectAsync(status, pairs) {
    const syncPairs = [];
    for (const pair of pairs) {
      const key2 = await pair.key;
      const value = await pair.value;
      syncPairs.push({
        key: key2,
        value
      });
    }
    return _ParseStatus.mergeObjectSync(status, syncPairs);
  }
  static mergeObjectSync(status, pairs) {
    const finalObject = {};
    for (const pair of pairs) {
      const { key: key2, value } = pair;
      if (key2.status === "aborted")
        return INVALID;
      if (value.status === "aborted")
        return INVALID;
      if (key2.status === "dirty")
        status.dirty();
      if (value.status === "dirty")
        status.dirty();
      if (key2.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) {
        finalObject[key2.value] = value.value;
      }
    }
    return { status: status.value, value: finalObject };
  }
};
var INVALID = Object.freeze({
  status: "aborted"
});
var DIRTY = (value) => ({ status: "dirty", value });
var OK = (value) => ({ status: "valid", value });
var isAborted = (x) => x.status === "aborted";
var isDirty = (x) => x.status === "dirty";
var isValid = (x) => x.status === "valid";
var isAsync = (x) => typeof Promise !== "undefined" && x instanceof Promise;

// ../../node_modules/zod/v3/helpers/errorUtil.js
var errorUtil;
(function(errorUtil2) {
  errorUtil2.errToObj = (message2) => typeof message2 === "string" ? { message: message2 } : message2 || {};
  errorUtil2.toString = (message2) => typeof message2 === "string" ? message2 : message2?.message;
})(errorUtil || (errorUtil = {}));

// ../../node_modules/zod/v3/types.js
var ParseInputLazyPath = class {
  constructor(parent2, value, path2, key2) {
    this._cachedPath = [];
    this.parent = parent2;
    this.data = value;
    this._path = path2;
    this._key = key2;
  }
  get path() {
    if (!this._cachedPath.length) {
      if (Array.isArray(this._key)) {
        this._cachedPath.push(...this._path, ...this._key);
      } else {
        this._cachedPath.push(...this._path, this._key);
      }
    }
    return this._cachedPath;
  }
};
var handleResult = (ctx, result) => {
  if (isValid(result)) {
    return { success: true, data: result.value };
  } else {
    if (!ctx.common.issues.length) {
      throw new Error("Validation failed but no issues detected.");
    }
    return {
      success: false,
      get error() {
        if (this._error)
          return this._error;
        const error2 = new ZodError(ctx.common.issues);
        this._error = error2;
        return this._error;
      }
    };
  }
};
function processCreateParams(params) {
  if (!params)
    return {};
  const { errorMap: errorMap2, invalid_type_error, required_error, description } = params;
  if (errorMap2 && (invalid_type_error || required_error)) {
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  }
  if (errorMap2)
    return { errorMap: errorMap2, description };
  const customMap = (iss, ctx) => {
    const { message: message2 } = params;
    if (iss.code === "invalid_enum_value") {
      return { message: message2 ?? ctx.defaultError };
    }
    if (typeof ctx.data === "undefined") {
      return { message: message2 ?? required_error ?? ctx.defaultError };
    }
    if (iss.code !== "invalid_type")
      return { message: ctx.defaultError };
    return { message: message2 ?? invalid_type_error ?? ctx.defaultError };
  };
  return { errorMap: customMap, description };
}
var ZodType = class {
  get description() {
    return this._def.description;
  }
  _getType(input) {
    return getParsedType(input.data);
  }
  _getOrReturnCtx(input, ctx) {
    return ctx || {
      common: input.parent.common,
      data: input.data,
      parsedType: getParsedType(input.data),
      schemaErrorMap: this._def.errorMap,
      path: input.path,
      parent: input.parent
    };
  }
  _processInputParams(input) {
    return {
      status: new ParseStatus(),
      ctx: {
        common: input.parent.common,
        data: input.data,
        parsedType: getParsedType(input.data),
        schemaErrorMap: this._def.errorMap,
        path: input.path,
        parent: input.parent
      }
    };
  }
  _parseSync(input) {
    const result = this._parse(input);
    if (isAsync(result)) {
      throw new Error("Synchronous parse encountered promise.");
    }
    return result;
  }
  _parseAsync(input) {
    const result = this._parse(input);
    return Promise.resolve(result);
  }
  parse(data2, params) {
    const result = this.safeParse(data2, params);
    if (result.success)
      return result.data;
    throw result.error;
  }
  safeParse(data2, params) {
    const ctx = {
      common: {
        issues: [],
        async: params?.async ?? false,
        contextualErrorMap: params?.errorMap
      },
      path: params?.path || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: data2,
      parsedType: getParsedType(data2)
    };
    const result = this._parseSync({ data: data2, path: ctx.path, parent: ctx });
    return handleResult(ctx, result);
  }
  "~validate"(data2) {
    const ctx = {
      common: {
        issues: [],
        async: !!this["~standard"].async
      },
      path: [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: data2,
      parsedType: getParsedType(data2)
    };
    if (!this["~standard"].async) {
      try {
        const result = this._parseSync({ data: data2, path: [], parent: ctx });
        return isValid(result) ? {
          value: result.value
        } : {
          issues: ctx.common.issues
        };
      } catch (err) {
        if (err?.message?.toLowerCase()?.includes("encountered")) {
          this["~standard"].async = true;
        }
        ctx.common = {
          issues: [],
          async: true
        };
      }
    }
    return this._parseAsync({ data: data2, path: [], parent: ctx }).then((result) => isValid(result) ? {
      value: result.value
    } : {
      issues: ctx.common.issues
    });
  }
  async parseAsync(data2, params) {
    const result = await this.safeParseAsync(data2, params);
    if (result.success)
      return result.data;
    throw result.error;
  }
  async safeParseAsync(data2, params) {
    const ctx = {
      common: {
        issues: [],
        contextualErrorMap: params?.errorMap,
        async: true
      },
      path: params?.path || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: data2,
      parsedType: getParsedType(data2)
    };
    const maybeAsyncResult = this._parse({ data: data2, path: ctx.path, parent: ctx });
    const result = await (isAsync(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult));
    return handleResult(ctx, result);
  }
  refine(check, message2) {
    const getIssueProperties = (val) => {
      if (typeof message2 === "string" || typeof message2 === "undefined") {
        return { message: message2 };
      } else if (typeof message2 === "function") {
        return message2(val);
      } else {
        return message2;
      }
    };
    return this._refinement((val, ctx) => {
      const result = check(val);
      const setError = () => ctx.addIssue({
        code: ZodIssueCode.custom,
        ...getIssueProperties(val)
      });
      if (typeof Promise !== "undefined" && result instanceof Promise) {
        return result.then((data2) => {
          if (!data2) {
            setError();
            return false;
          } else {
            return true;
          }
        });
      }
      if (!result) {
        setError();
        return false;
      } else {
        return true;
      }
    });
  }
  refinement(check, refinementData) {
    return this._refinement((val, ctx) => {
      if (!check(val)) {
        ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
        return false;
      } else {
        return true;
      }
    });
  }
  _refinement(refinement) {
    return new ZodEffects({
      schema: this,
      typeName: ZodFirstPartyTypeKind.ZodEffects,
      effect: { type: "refinement", refinement }
    });
  }
  superRefine(refinement) {
    return this._refinement(refinement);
  }
  constructor(def) {
    this.spa = this.safeParseAsync;
    this._def = def;
    this.parse = this.parse.bind(this);
    this.safeParse = this.safeParse.bind(this);
    this.parseAsync = this.parseAsync.bind(this);
    this.safeParseAsync = this.safeParseAsync.bind(this);
    this.spa = this.spa.bind(this);
    this.refine = this.refine.bind(this);
    this.refinement = this.refinement.bind(this);
    this.superRefine = this.superRefine.bind(this);
    this.optional = this.optional.bind(this);
    this.nullable = this.nullable.bind(this);
    this.nullish = this.nullish.bind(this);
    this.array = this.array.bind(this);
    this.promise = this.promise.bind(this);
    this.or = this.or.bind(this);
    this.and = this.and.bind(this);
    this.transform = this.transform.bind(this);
    this.brand = this.brand.bind(this);
    this.default = this.default.bind(this);
    this.catch = this.catch.bind(this);
    this.describe = this.describe.bind(this);
    this.pipe = this.pipe.bind(this);
    this.readonly = this.readonly.bind(this);
    this.isNullable = this.isNullable.bind(this);
    this.isOptional = this.isOptional.bind(this);
    this["~standard"] = {
      version: 1,
      vendor: "zod",
      validate: (data2) => this["~validate"](data2)
    };
  }
  optional() {
    return ZodOptional.create(this, this._def);
  }
  nullable() {
    return ZodNullable.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return ZodArray.create(this);
  }
  promise() {
    return ZodPromise.create(this, this._def);
  }
  or(option) {
    return ZodUnion.create([this, option], this._def);
  }
  and(incoming) {
    return ZodIntersection.create(this, incoming, this._def);
  }
  transform(transform) {
    return new ZodEffects({
      ...processCreateParams(this._def),
      schema: this,
      typeName: ZodFirstPartyTypeKind.ZodEffects,
      effect: { type: "transform", transform }
    });
  }
  default(def) {
    const defaultValueFunc = typeof def === "function" ? def : () => def;
    return new ZodDefault({
      ...processCreateParams(this._def),
      innerType: this,
      defaultValue: defaultValueFunc,
      typeName: ZodFirstPartyTypeKind.ZodDefault
    });
  }
  brand() {
    return new ZodBranded({
      typeName: ZodFirstPartyTypeKind.ZodBranded,
      type: this,
      ...processCreateParams(this._def)
    });
  }
  catch(def) {
    const catchValueFunc = typeof def === "function" ? def : () => def;
    return new ZodCatch({
      ...processCreateParams(this._def),
      innerType: this,
      catchValue: catchValueFunc,
      typeName: ZodFirstPartyTypeKind.ZodCatch
    });
  }
  describe(description) {
    const This = this.constructor;
    return new This({
      ...this._def,
      description
    });
  }
  pipe(target) {
    return ZodPipeline.create(this, target);
  }
  readonly() {
    return ZodReadonly.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
};
var cuidRegex = /^c[^\s-]{8,}$/i;
var cuid2Regex = /^[0-9a-z]+$/;
var ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/i;
var uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
var nanoidRegex = /^[a-z0-9_-]{21}$/i;
var jwtRegex = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/;
var durationRegex = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/;
var emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
var _emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
var emojiRegex;
var ipv4Regex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/;
var ipv4CidrRegex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/;
var ipv6Regex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/;
var ipv6CidrRegex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/;
var base64Regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
var base64urlRegex = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/;
var dateRegexSource = `((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))`;
var dateRegex = new RegExp(`^${dateRegexSource}$`);
function timeRegexSource(args) {
  let secondsRegexSource = `[0-5]\\d`;
  if (args.precision) {
    secondsRegexSource = `${secondsRegexSource}\\.\\d{${args.precision}}`;
  } else if (args.precision == null) {
    secondsRegexSource = `${secondsRegexSource}(\\.\\d+)?`;
  }
  const secondsQuantifier = args.precision ? "+" : "?";
  return `([01]\\d|2[0-3]):[0-5]\\d(:${secondsRegexSource})${secondsQuantifier}`;
}
function timeRegex(args) {
  return new RegExp(`^${timeRegexSource(args)}$`);
}
function datetimeRegex(args) {
  let regex = `${dateRegexSource}T${timeRegexSource(args)}`;
  const opts = [];
  opts.push(args.local ? `Z?` : `Z`);
  if (args.offset)
    opts.push(`([+-]\\d{2}:?\\d{2})`);
  regex = `${regex}(${opts.join("|")})`;
  return new RegExp(`^${regex}$`);
}
function isValidIP(ip, version7) {
  if ((version7 === "v4" || !version7) && ipv4Regex.test(ip)) {
    return true;
  }
  if ((version7 === "v6" || !version7) && ipv6Regex.test(ip)) {
    return true;
  }
  return false;
}
function isValidJWT(jwt, alg) {
  if (!jwtRegex.test(jwt))
    return false;
  try {
    const [header] = jwt.split(".");
    if (!header)
      return false;
    const base64 = header.replace(/-/g, "+").replace(/_/g, "/").padEnd(header.length + (4 - header.length % 4) % 4, "=");
    const decoded = JSON.parse(atob(base64));
    if (typeof decoded !== "object" || decoded === null)
      return false;
    if ("typ" in decoded && decoded?.typ !== "JWT")
      return false;
    if (!decoded.alg)
      return false;
    if (alg && decoded.alg !== alg)
      return false;
    return true;
  } catch {
    return false;
  }
}
function isValidCidr(ip, version7) {
  if ((version7 === "v4" || !version7) && ipv4CidrRegex.test(ip)) {
    return true;
  }
  if ((version7 === "v6" || !version7) && ipv6CidrRegex.test(ip)) {
    return true;
  }
  return false;
}
var ZodString = class _ZodString extends ZodType {
  _parse(input) {
    if (this._def.coerce) {
      input.data = String(input.data);
    }
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.string) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.string,
        received: ctx2.parsedType
      });
      return INVALID;
    }
    const status = new ParseStatus();
    let ctx = void 0;
    for (const check of this._def.checks) {
      if (check.kind === "min") {
        if (input.data.length < check.value) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_small,
            minimum: check.value,
            type: "string",
            inclusive: true,
            exact: false,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "max") {
        if (input.data.length > check.value) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_big,
            maximum: check.value,
            type: "string",
            inclusive: true,
            exact: false,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "length") {
        const tooBig = input.data.length > check.value;
        const tooSmall = input.data.length < check.value;
        if (tooBig || tooSmall) {
          ctx = this._getOrReturnCtx(input, ctx);
          if (tooBig) {
            addIssueToContext(ctx, {
              code: ZodIssueCode.too_big,
              maximum: check.value,
              type: "string",
              inclusive: true,
              exact: true,
              message: check.message
            });
          } else if (tooSmall) {
            addIssueToContext(ctx, {
              code: ZodIssueCode.too_small,
              minimum: check.value,
              type: "string",
              inclusive: true,
              exact: true,
              message: check.message
            });
          }
          status.dirty();
        }
      } else if (check.kind === "email") {
        if (!emailRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "email",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "emoji") {
        if (!emojiRegex) {
          emojiRegex = new RegExp(_emojiRegex, "u");
        }
        if (!emojiRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "emoji",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "uuid") {
        if (!uuidRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "uuid",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "nanoid") {
        if (!nanoidRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "nanoid",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "cuid") {
        if (!cuidRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "cuid",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "cuid2") {
        if (!cuid2Regex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "cuid2",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "ulid") {
        if (!ulidRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "ulid",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "url") {
        try {
          new URL(input.data);
        } catch {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "url",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "regex") {
        check.regex.lastIndex = 0;
        const testResult = check.regex.test(input.data);
        if (!testResult) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "regex",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "trim") {
        input.data = input.data.trim();
      } else if (check.kind === "includes") {
        if (!input.data.includes(check.value, check.position)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_string,
            validation: { includes: check.value, position: check.position },
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "toLowerCase") {
        input.data = input.data.toLowerCase();
      } else if (check.kind === "toUpperCase") {
        input.data = input.data.toUpperCase();
      } else if (check.kind === "startsWith") {
        if (!input.data.startsWith(check.value)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_string,
            validation: { startsWith: check.value },
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "endsWith") {
        if (!input.data.endsWith(check.value)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_string,
            validation: { endsWith: check.value },
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "datetime") {
        const regex = datetimeRegex(check);
        if (!regex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_string,
            validation: "datetime",
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "date") {
        const regex = dateRegex;
        if (!regex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_string,
            validation: "date",
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "time") {
        const regex = timeRegex(check);
        if (!regex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_string,
            validation: "time",
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "duration") {
        if (!durationRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "duration",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "ip") {
        if (!isValidIP(input.data, check.version)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "ip",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "jwt") {
        if (!isValidJWT(input.data, check.alg)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "jwt",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "cidr") {
        if (!isValidCidr(input.data, check.version)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "cidr",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "base64") {
        if (!base64Regex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "base64",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "base64url") {
        if (!base64urlRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "base64url",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else {
        util.assertNever(check);
      }
    }
    return { status: status.value, value: input.data };
  }
  _regex(regex, validation, message2) {
    return this.refinement((data2) => regex.test(data2), {
      validation,
      code: ZodIssueCode.invalid_string,
      ...errorUtil.errToObj(message2)
    });
  }
  _addCheck(check) {
    return new _ZodString({
      ...this._def,
      checks: [...this._def.checks, check]
    });
  }
  email(message2) {
    return this._addCheck({ kind: "email", ...errorUtil.errToObj(message2) });
  }
  url(message2) {
    return this._addCheck({ kind: "url", ...errorUtil.errToObj(message2) });
  }
  emoji(message2) {
    return this._addCheck({ kind: "emoji", ...errorUtil.errToObj(message2) });
  }
  uuid(message2) {
    return this._addCheck({ kind: "uuid", ...errorUtil.errToObj(message2) });
  }
  nanoid(message2) {
    return this._addCheck({ kind: "nanoid", ...errorUtil.errToObj(message2) });
  }
  cuid(message2) {
    return this._addCheck({ kind: "cuid", ...errorUtil.errToObj(message2) });
  }
  cuid2(message2) {
    return this._addCheck({ kind: "cuid2", ...errorUtil.errToObj(message2) });
  }
  ulid(message2) {
    return this._addCheck({ kind: "ulid", ...errorUtil.errToObj(message2) });
  }
  base64(message2) {
    return this._addCheck({ kind: "base64", ...errorUtil.errToObj(message2) });
  }
  base64url(message2) {
    return this._addCheck({
      kind: "base64url",
      ...errorUtil.errToObj(message2)
    });
  }
  jwt(options) {
    return this._addCheck({ kind: "jwt", ...errorUtil.errToObj(options) });
  }
  ip(options) {
    return this._addCheck({ kind: "ip", ...errorUtil.errToObj(options) });
  }
  cidr(options) {
    return this._addCheck({ kind: "cidr", ...errorUtil.errToObj(options) });
  }
  datetime(options) {
    if (typeof options === "string") {
      return this._addCheck({
        kind: "datetime",
        precision: null,
        offset: false,
        local: false,
        message: options
      });
    }
    return this._addCheck({
      kind: "datetime",
      precision: typeof options?.precision === "undefined" ? null : options?.precision,
      offset: options?.offset ?? false,
      local: options?.local ?? false,
      ...errorUtil.errToObj(options?.message)
    });
  }
  date(message2) {
    return this._addCheck({ kind: "date", message: message2 });
  }
  time(options) {
    if (typeof options === "string") {
      return this._addCheck({
        kind: "time",
        precision: null,
        message: options
      });
    }
    return this._addCheck({
      kind: "time",
      precision: typeof options?.precision === "undefined" ? null : options?.precision,
      ...errorUtil.errToObj(options?.message)
    });
  }
  duration(message2) {
    return this._addCheck({ kind: "duration", ...errorUtil.errToObj(message2) });
  }
  regex(regex, message2) {
    return this._addCheck({
      kind: "regex",
      regex,
      ...errorUtil.errToObj(message2)
    });
  }
  includes(value, options) {
    return this._addCheck({
      kind: "includes",
      value,
      position: options?.position,
      ...errorUtil.errToObj(options?.message)
    });
  }
  startsWith(value, message2) {
    return this._addCheck({
      kind: "startsWith",
      value,
      ...errorUtil.errToObj(message2)
    });
  }
  endsWith(value, message2) {
    return this._addCheck({
      kind: "endsWith",
      value,
      ...errorUtil.errToObj(message2)
    });
  }
  min(minLength, message2) {
    return this._addCheck({
      kind: "min",
      value: minLength,
      ...errorUtil.errToObj(message2)
    });
  }
  max(maxLength, message2) {
    return this._addCheck({
      kind: "max",
      value: maxLength,
      ...errorUtil.errToObj(message2)
    });
  }
  length(len, message2) {
    return this._addCheck({
      kind: "length",
      value: len,
      ...errorUtil.errToObj(message2)
    });
  }
  /**
   * Equivalent to `.min(1)`
   */
  nonempty(message2) {
    return this.min(1, errorUtil.errToObj(message2));
  }
  trim() {
    return new _ZodString({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new _ZodString({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new _ZodString({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((ch) => ch.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((ch) => ch.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((ch) => ch.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((ch) => ch.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((ch) => ch.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((ch) => ch.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((ch) => ch.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((ch) => ch.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((ch) => ch.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((ch) => ch.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((ch) => ch.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((ch) => ch.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((ch) => ch.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((ch) => ch.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((ch) => ch.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((ch) => ch.kind === "base64url");
  }
  get minLength() {
    let min = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "min") {
        if (min === null || ch.value > min)
          min = ch.value;
      }
    }
    return min;
  }
  get maxLength() {
    let max = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "max") {
        if (max === null || ch.value < max)
          max = ch.value;
      }
    }
    return max;
  }
};
ZodString.create = (params) => {
  return new ZodString({
    checks: [],
    typeName: ZodFirstPartyTypeKind.ZodString,
    coerce: params?.coerce ?? false,
    ...processCreateParams(params)
  });
};
function floatSafeRemainder(val, step) {
  const valDecCount = (val.toString().split(".")[1] || "").length;
  const stepDecCount = (step.toString().split(".")[1] || "").length;
  const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
  const valInt = Number.parseInt(val.toFixed(decCount).replace(".", ""));
  const stepInt = Number.parseInt(step.toFixed(decCount).replace(".", ""));
  return valInt % stepInt / 10 ** decCount;
}
var ZodNumber = class _ZodNumber extends ZodType {
  constructor() {
    super(...arguments);
    this.min = this.gte;
    this.max = this.lte;
    this.step = this.multipleOf;
  }
  _parse(input) {
    if (this._def.coerce) {
      input.data = Number(input.data);
    }
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.number) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.number,
        received: ctx2.parsedType
      });
      return INVALID;
    }
    let ctx = void 0;
    const status = new ParseStatus();
    for (const check of this._def.checks) {
      if (check.kind === "int") {
        if (!util.isInteger(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_type,
            expected: "integer",
            received: "float",
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "min") {
        const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
        if (tooSmall) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_small,
            minimum: check.value,
            type: "number",
            inclusive: check.inclusive,
            exact: false,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "max") {
        const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
        if (tooBig) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_big,
            maximum: check.value,
            type: "number",
            inclusive: check.inclusive,
            exact: false,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "multipleOf") {
        if (floatSafeRemainder(input.data, check.value) !== 0) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.not_multiple_of,
            multipleOf: check.value,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "finite") {
        if (!Number.isFinite(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.not_finite,
            message: check.message
          });
          status.dirty();
        }
      } else {
        util.assertNever(check);
      }
    }
    return { status: status.value, value: input.data };
  }
  gte(value, message2) {
    return this.setLimit("min", value, true, errorUtil.toString(message2));
  }
  gt(value, message2) {
    return this.setLimit("min", value, false, errorUtil.toString(message2));
  }
  lte(value, message2) {
    return this.setLimit("max", value, true, errorUtil.toString(message2));
  }
  lt(value, message2) {
    return this.setLimit("max", value, false, errorUtil.toString(message2));
  }
  setLimit(kind, value, inclusive, message2) {
    return new _ZodNumber({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind,
          value,
          inclusive,
          message: errorUtil.toString(message2)
        }
      ]
    });
  }
  _addCheck(check) {
    return new _ZodNumber({
      ...this._def,
      checks: [...this._def.checks, check]
    });
  }
  int(message2) {
    return this._addCheck({
      kind: "int",
      message: errorUtil.toString(message2)
    });
  }
  positive(message2) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: false,
      message: errorUtil.toString(message2)
    });
  }
  negative(message2) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: false,
      message: errorUtil.toString(message2)
    });
  }
  nonpositive(message2) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: true,
      message: errorUtil.toString(message2)
    });
  }
  nonnegative(message2) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: true,
      message: errorUtil.toString(message2)
    });
  }
  multipleOf(value, message2) {
    return this._addCheck({
      kind: "multipleOf",
      value,
      message: errorUtil.toString(message2)
    });
  }
  finite(message2) {
    return this._addCheck({
      kind: "finite",
      message: errorUtil.toString(message2)
    });
  }
  safe(message2) {
    return this._addCheck({
      kind: "min",
      inclusive: true,
      value: Number.MIN_SAFE_INTEGER,
      message: errorUtil.toString(message2)
    })._addCheck({
      kind: "max",
      inclusive: true,
      value: Number.MAX_SAFE_INTEGER,
      message: errorUtil.toString(message2)
    });
  }
  get minValue() {
    let min = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "min") {
        if (min === null || ch.value > min)
          min = ch.value;
      }
    }
    return min;
  }
  get maxValue() {
    let max = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "max") {
        if (max === null || ch.value < max)
          max = ch.value;
      }
    }
    return max;
  }
  get isInt() {
    return !!this._def.checks.find((ch) => ch.kind === "int" || ch.kind === "multipleOf" && util.isInteger(ch.value));
  }
  get isFinite() {
    let max = null;
    let min = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") {
        return true;
      } else if (ch.kind === "min") {
        if (min === null || ch.value > min)
          min = ch.value;
      } else if (ch.kind === "max") {
        if (max === null || ch.value < max)
          max = ch.value;
      }
    }
    return Number.isFinite(min) && Number.isFinite(max);
  }
};
ZodNumber.create = (params) => {
  return new ZodNumber({
    checks: [],
    typeName: ZodFirstPartyTypeKind.ZodNumber,
    coerce: params?.coerce || false,
    ...processCreateParams(params)
  });
};
var ZodBigInt = class _ZodBigInt extends ZodType {
  constructor() {
    super(...arguments);
    this.min = this.gte;
    this.max = this.lte;
  }
  _parse(input) {
    if (this._def.coerce) {
      try {
        input.data = BigInt(input.data);
      } catch {
        return this._getInvalidInput(input);
      }
    }
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.bigint) {
      return this._getInvalidInput(input);
    }
    let ctx = void 0;
    const status = new ParseStatus();
    for (const check of this._def.checks) {
      if (check.kind === "min") {
        const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
        if (tooSmall) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_small,
            type: "bigint",
            minimum: check.value,
            inclusive: check.inclusive,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "max") {
        const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
        if (tooBig) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_big,
            type: "bigint",
            maximum: check.value,
            inclusive: check.inclusive,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "multipleOf") {
        if (input.data % check.value !== BigInt(0)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.not_multiple_of,
            multipleOf: check.value,
            message: check.message
          });
          status.dirty();
        }
      } else {
        util.assertNever(check);
      }
    }
    return { status: status.value, value: input.data };
  }
  _getInvalidInput(input) {
    const ctx = this._getOrReturnCtx(input);
    addIssueToContext(ctx, {
      code: ZodIssueCode.invalid_type,
      expected: ZodParsedType.bigint,
      received: ctx.parsedType
    });
    return INVALID;
  }
  gte(value, message2) {
    return this.setLimit("min", value, true, errorUtil.toString(message2));
  }
  gt(value, message2) {
    return this.setLimit("min", value, false, errorUtil.toString(message2));
  }
  lte(value, message2) {
    return this.setLimit("max", value, true, errorUtil.toString(message2));
  }
  lt(value, message2) {
    return this.setLimit("max", value, false, errorUtil.toString(message2));
  }
  setLimit(kind, value, inclusive, message2) {
    return new _ZodBigInt({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind,
          value,
          inclusive,
          message: errorUtil.toString(message2)
        }
      ]
    });
  }
  _addCheck(check) {
    return new _ZodBigInt({
      ...this._def,
      checks: [...this._def.checks, check]
    });
  }
  positive(message2) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: false,
      message: errorUtil.toString(message2)
    });
  }
  negative(message2) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: false,
      message: errorUtil.toString(message2)
    });
  }
  nonpositive(message2) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: true,
      message: errorUtil.toString(message2)
    });
  }
  nonnegative(message2) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: true,
      message: errorUtil.toString(message2)
    });
  }
  multipleOf(value, message2) {
    return this._addCheck({
      kind: "multipleOf",
      value,
      message: errorUtil.toString(message2)
    });
  }
  get minValue() {
    let min = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "min") {
        if (min === null || ch.value > min)
          min = ch.value;
      }
    }
    return min;
  }
  get maxValue() {
    let max = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "max") {
        if (max === null || ch.value < max)
          max = ch.value;
      }
    }
    return max;
  }
};
ZodBigInt.create = (params) => {
  return new ZodBigInt({
    checks: [],
    typeName: ZodFirstPartyTypeKind.ZodBigInt,
    coerce: params?.coerce ?? false,
    ...processCreateParams(params)
  });
};
var ZodBoolean = class extends ZodType {
  _parse(input) {
    if (this._def.coerce) {
      input.data = Boolean(input.data);
    }
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.boolean) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.boolean,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return OK(input.data);
  }
};
ZodBoolean.create = (params) => {
  return new ZodBoolean({
    typeName: ZodFirstPartyTypeKind.ZodBoolean,
    coerce: params?.coerce || false,
    ...processCreateParams(params)
  });
};
var ZodDate = class _ZodDate extends ZodType {
  _parse(input) {
    if (this._def.coerce) {
      input.data = new Date(input.data);
    }
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.date) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.date,
        received: ctx2.parsedType
      });
      return INVALID;
    }
    if (Number.isNaN(input.data.getTime())) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode.invalid_date
      });
      return INVALID;
    }
    const status = new ParseStatus();
    let ctx = void 0;
    for (const check of this._def.checks) {
      if (check.kind === "min") {
        if (input.data.getTime() < check.value) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_small,
            message: check.message,
            inclusive: true,
            exact: false,
            minimum: check.value,
            type: "date"
          });
          status.dirty();
        }
      } else if (check.kind === "max") {
        if (input.data.getTime() > check.value) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_big,
            message: check.message,
            inclusive: true,
            exact: false,
            maximum: check.value,
            type: "date"
          });
          status.dirty();
        }
      } else {
        util.assertNever(check);
      }
    }
    return {
      status: status.value,
      value: new Date(input.data.getTime())
    };
  }
  _addCheck(check) {
    return new _ZodDate({
      ...this._def,
      checks: [...this._def.checks, check]
    });
  }
  min(minDate, message2) {
    return this._addCheck({
      kind: "min",
      value: minDate.getTime(),
      message: errorUtil.toString(message2)
    });
  }
  max(maxDate, message2) {
    return this._addCheck({
      kind: "max",
      value: maxDate.getTime(),
      message: errorUtil.toString(message2)
    });
  }
  get minDate() {
    let min = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "min") {
        if (min === null || ch.value > min)
          min = ch.value;
      }
    }
    return min != null ? new Date(min) : null;
  }
  get maxDate() {
    let max = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "max") {
        if (max === null || ch.value < max)
          max = ch.value;
      }
    }
    return max != null ? new Date(max) : null;
  }
};
ZodDate.create = (params) => {
  return new ZodDate({
    checks: [],
    coerce: params?.coerce || false,
    typeName: ZodFirstPartyTypeKind.ZodDate,
    ...processCreateParams(params)
  });
};
var ZodSymbol = class extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.symbol) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.symbol,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return OK(input.data);
  }
};
ZodSymbol.create = (params) => {
  return new ZodSymbol({
    typeName: ZodFirstPartyTypeKind.ZodSymbol,
    ...processCreateParams(params)
  });
};
var ZodUndefined = class extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.undefined) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.undefined,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return OK(input.data);
  }
};
ZodUndefined.create = (params) => {
  return new ZodUndefined({
    typeName: ZodFirstPartyTypeKind.ZodUndefined,
    ...processCreateParams(params)
  });
};
var ZodNull = class extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.null) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.null,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return OK(input.data);
  }
};
ZodNull.create = (params) => {
  return new ZodNull({
    typeName: ZodFirstPartyTypeKind.ZodNull,
    ...processCreateParams(params)
  });
};
var ZodAny = class extends ZodType {
  constructor() {
    super(...arguments);
    this._any = true;
  }
  _parse(input) {
    return OK(input.data);
  }
};
ZodAny.create = (params) => {
  return new ZodAny({
    typeName: ZodFirstPartyTypeKind.ZodAny,
    ...processCreateParams(params)
  });
};
var ZodUnknown = class extends ZodType {
  constructor() {
    super(...arguments);
    this._unknown = true;
  }
  _parse(input) {
    return OK(input.data);
  }
};
ZodUnknown.create = (params) => {
  return new ZodUnknown({
    typeName: ZodFirstPartyTypeKind.ZodUnknown,
    ...processCreateParams(params)
  });
};
var ZodNever = class extends ZodType {
  _parse(input) {
    const ctx = this._getOrReturnCtx(input);
    addIssueToContext(ctx, {
      code: ZodIssueCode.invalid_type,
      expected: ZodParsedType.never,
      received: ctx.parsedType
    });
    return INVALID;
  }
};
ZodNever.create = (params) => {
  return new ZodNever({
    typeName: ZodFirstPartyTypeKind.ZodNever,
    ...processCreateParams(params)
  });
};
var ZodVoid = class extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.undefined) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.void,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return OK(input.data);
  }
};
ZodVoid.create = (params) => {
  return new ZodVoid({
    typeName: ZodFirstPartyTypeKind.ZodVoid,
    ...processCreateParams(params)
  });
};
var ZodArray = class _ZodArray extends ZodType {
  _parse(input) {
    const { ctx, status } = this._processInputParams(input);
    const def = this._def;
    if (ctx.parsedType !== ZodParsedType.array) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.array,
        received: ctx.parsedType
      });
      return INVALID;
    }
    if (def.exactLength !== null) {
      const tooBig = ctx.data.length > def.exactLength.value;
      const tooSmall = ctx.data.length < def.exactLength.value;
      if (tooBig || tooSmall) {
        addIssueToContext(ctx, {
          code: tooBig ? ZodIssueCode.too_big : ZodIssueCode.too_small,
          minimum: tooSmall ? def.exactLength.value : void 0,
          maximum: tooBig ? def.exactLength.value : void 0,
          type: "array",
          inclusive: true,
          exact: true,
          message: def.exactLength.message
        });
        status.dirty();
      }
    }
    if (def.minLength !== null) {
      if (ctx.data.length < def.minLength.value) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.too_small,
          minimum: def.minLength.value,
          type: "array",
          inclusive: true,
          exact: false,
          message: def.minLength.message
        });
        status.dirty();
      }
    }
    if (def.maxLength !== null) {
      if (ctx.data.length > def.maxLength.value) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.too_big,
          maximum: def.maxLength.value,
          type: "array",
          inclusive: true,
          exact: false,
          message: def.maxLength.message
        });
        status.dirty();
      }
    }
    if (ctx.common.async) {
      return Promise.all([...ctx.data].map((item, i) => {
        return def.type._parseAsync(new ParseInputLazyPath(ctx, item, ctx.path, i));
      })).then((result2) => {
        return ParseStatus.mergeArray(status, result2);
      });
    }
    const result = [...ctx.data].map((item, i) => {
      return def.type._parseSync(new ParseInputLazyPath(ctx, item, ctx.path, i));
    });
    return ParseStatus.mergeArray(status, result);
  }
  get element() {
    return this._def.type;
  }
  min(minLength, message2) {
    return new _ZodArray({
      ...this._def,
      minLength: { value: minLength, message: errorUtil.toString(message2) }
    });
  }
  max(maxLength, message2) {
    return new _ZodArray({
      ...this._def,
      maxLength: { value: maxLength, message: errorUtil.toString(message2) }
    });
  }
  length(len, message2) {
    return new _ZodArray({
      ...this._def,
      exactLength: { value: len, message: errorUtil.toString(message2) }
    });
  }
  nonempty(message2) {
    return this.min(1, message2);
  }
};
ZodArray.create = (schema, params) => {
  return new ZodArray({
    type: schema,
    minLength: null,
    maxLength: null,
    exactLength: null,
    typeName: ZodFirstPartyTypeKind.ZodArray,
    ...processCreateParams(params)
  });
};
function deepPartialify(schema) {
  if (schema instanceof ZodObject) {
    const newShape = {};
    for (const key2 in schema.shape) {
      const fieldSchema = schema.shape[key2];
      newShape[key2] = ZodOptional.create(deepPartialify(fieldSchema));
    }
    return new ZodObject({
      ...schema._def,
      shape: () => newShape
    });
  } else if (schema instanceof ZodArray) {
    return new ZodArray({
      ...schema._def,
      type: deepPartialify(schema.element)
    });
  } else if (schema instanceof ZodOptional) {
    return ZodOptional.create(deepPartialify(schema.unwrap()));
  } else if (schema instanceof ZodNullable) {
    return ZodNullable.create(deepPartialify(schema.unwrap()));
  } else if (schema instanceof ZodTuple) {
    return ZodTuple.create(schema.items.map((item) => deepPartialify(item)));
  } else {
    return schema;
  }
}
var ZodObject = class _ZodObject extends ZodType {
  constructor() {
    super(...arguments);
    this._cached = null;
    this.nonstrict = this.passthrough;
    this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const shape = this._def.shape();
    const keys4 = util.objectKeys(shape);
    this._cached = { shape, keys: keys4 };
    return this._cached;
  }
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.object) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.object,
        received: ctx2.parsedType
      });
      return INVALID;
    }
    const { status, ctx } = this._processInputParams(input);
    const { shape, keys: shapeKeys } = this._getCached();
    const extraKeys = [];
    if (!(this._def.catchall instanceof ZodNever && this._def.unknownKeys === "strip")) {
      for (const key2 in ctx.data) {
        if (!shapeKeys.includes(key2)) {
          extraKeys.push(key2);
        }
      }
    }
    const pairs = [];
    for (const key2 of shapeKeys) {
      const keyValidator = shape[key2];
      const value = ctx.data[key2];
      pairs.push({
        key: { status: "valid", value: key2 },
        value: keyValidator._parse(new ParseInputLazyPath(ctx, value, ctx.path, key2)),
        alwaysSet: key2 in ctx.data
      });
    }
    if (this._def.catchall instanceof ZodNever) {
      const unknownKeys = this._def.unknownKeys;
      if (unknownKeys === "passthrough") {
        for (const key2 of extraKeys) {
          pairs.push({
            key: { status: "valid", value: key2 },
            value: { status: "valid", value: ctx.data[key2] }
          });
        }
      } else if (unknownKeys === "strict") {
        if (extraKeys.length > 0) {
          addIssueToContext(ctx, {
            code: ZodIssueCode.unrecognized_keys,
            keys: extraKeys
          });
          status.dirty();
        }
      } else if (unknownKeys === "strip") {
      } else {
        throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
      }
    } else {
      const catchall = this._def.catchall;
      for (const key2 of extraKeys) {
        const value = ctx.data[key2];
        pairs.push({
          key: { status: "valid", value: key2 },
          value: catchall._parse(
            new ParseInputLazyPath(ctx, value, ctx.path, key2)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: key2 in ctx.data
        });
      }
    }
    if (ctx.common.async) {
      return Promise.resolve().then(async () => {
        const syncPairs = [];
        for (const pair of pairs) {
          const key2 = await pair.key;
          const value = await pair.value;
          syncPairs.push({
            key: key2,
            value,
            alwaysSet: pair.alwaysSet
          });
        }
        return syncPairs;
      }).then((syncPairs) => {
        return ParseStatus.mergeObjectSync(status, syncPairs);
      });
    } else {
      return ParseStatus.mergeObjectSync(status, pairs);
    }
  }
  get shape() {
    return this._def.shape();
  }
  strict(message2) {
    errorUtil.errToObj;
    return new _ZodObject({
      ...this._def,
      unknownKeys: "strict",
      ...message2 !== void 0 ? {
        errorMap: (issue, ctx) => {
          const defaultError = this._def.errorMap?.(issue, ctx).message ?? ctx.defaultError;
          if (issue.code === "unrecognized_keys")
            return {
              message: errorUtil.errToObj(message2).message ?? defaultError
            };
          return {
            message: defaultError
          };
        }
      } : {}
    });
  }
  strip() {
    return new _ZodObject({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new _ZodObject({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(augmentation) {
    return new _ZodObject({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...augmentation
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(merging) {
    const merged = new _ZodObject({
      unknownKeys: merging._def.unknownKeys,
      catchall: merging._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...merging._def.shape()
      }),
      typeName: ZodFirstPartyTypeKind.ZodObject
    });
    return merged;
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(key2, schema) {
    return this.augment({ [key2]: schema });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(index3) {
    return new _ZodObject({
      ...this._def,
      catchall: index3
    });
  }
  pick(mask) {
    const shape = {};
    for (const key2 of util.objectKeys(mask)) {
      if (mask[key2] && this.shape[key2]) {
        shape[key2] = this.shape[key2];
      }
    }
    return new _ZodObject({
      ...this._def,
      shape: () => shape
    });
  }
  omit(mask) {
    const shape = {};
    for (const key2 of util.objectKeys(this.shape)) {
      if (!mask[key2]) {
        shape[key2] = this.shape[key2];
      }
    }
    return new _ZodObject({
      ...this._def,
      shape: () => shape
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return deepPartialify(this);
  }
  partial(mask) {
    const newShape = {};
    for (const key2 of util.objectKeys(this.shape)) {
      const fieldSchema = this.shape[key2];
      if (mask && !mask[key2]) {
        newShape[key2] = fieldSchema;
      } else {
        newShape[key2] = fieldSchema.optional();
      }
    }
    return new _ZodObject({
      ...this._def,
      shape: () => newShape
    });
  }
  required(mask) {
    const newShape = {};
    for (const key2 of util.objectKeys(this.shape)) {
      if (mask && !mask[key2]) {
        newShape[key2] = this.shape[key2];
      } else {
        const fieldSchema = this.shape[key2];
        let newField = fieldSchema;
        while (newField instanceof ZodOptional) {
          newField = newField._def.innerType;
        }
        newShape[key2] = newField;
      }
    }
    return new _ZodObject({
      ...this._def,
      shape: () => newShape
    });
  }
  keyof() {
    return createZodEnum(util.objectKeys(this.shape));
  }
};
ZodObject.create = (shape, params) => {
  return new ZodObject({
    shape: () => shape,
    unknownKeys: "strip",
    catchall: ZodNever.create(),
    typeName: ZodFirstPartyTypeKind.ZodObject,
    ...processCreateParams(params)
  });
};
ZodObject.strictCreate = (shape, params) => {
  return new ZodObject({
    shape: () => shape,
    unknownKeys: "strict",
    catchall: ZodNever.create(),
    typeName: ZodFirstPartyTypeKind.ZodObject,
    ...processCreateParams(params)
  });
};
ZodObject.lazycreate = (shape, params) => {
  return new ZodObject({
    shape,
    unknownKeys: "strip",
    catchall: ZodNever.create(),
    typeName: ZodFirstPartyTypeKind.ZodObject,
    ...processCreateParams(params)
  });
};
var ZodUnion = class extends ZodType {
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    const options = this._def.options;
    function handleResults(results) {
      for (const result of results) {
        if (result.result.status === "valid") {
          return result.result;
        }
      }
      for (const result of results) {
        if (result.result.status === "dirty") {
          ctx.common.issues.push(...result.ctx.common.issues);
          return result.result;
        }
      }
      const unionErrors = results.map((result) => new ZodError(result.ctx.common.issues));
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_union,
        unionErrors
      });
      return INVALID;
    }
    if (ctx.common.async) {
      return Promise.all(options.map(async (option) => {
        const childCtx = {
          ...ctx,
          common: {
            ...ctx.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await option._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: childCtx
          }),
          ctx: childCtx
        };
      })).then(handleResults);
    } else {
      let dirty = void 0;
      const issues = [];
      for (const option of options) {
        const childCtx = {
          ...ctx,
          common: {
            ...ctx.common,
            issues: []
          },
          parent: null
        };
        const result = option._parseSync({
          data: ctx.data,
          path: ctx.path,
          parent: childCtx
        });
        if (result.status === "valid") {
          return result;
        } else if (result.status === "dirty" && !dirty) {
          dirty = { result, ctx: childCtx };
        }
        if (childCtx.common.issues.length) {
          issues.push(childCtx.common.issues);
        }
      }
      if (dirty) {
        ctx.common.issues.push(...dirty.ctx.common.issues);
        return dirty.result;
      }
      const unionErrors = issues.map((issues2) => new ZodError(issues2));
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_union,
        unionErrors
      });
      return INVALID;
    }
  }
  get options() {
    return this._def.options;
  }
};
ZodUnion.create = (types3, params) => {
  return new ZodUnion({
    options: types3,
    typeName: ZodFirstPartyTypeKind.ZodUnion,
    ...processCreateParams(params)
  });
};
var getDiscriminator = (type5) => {
  if (type5 instanceof ZodLazy) {
    return getDiscriminator(type5.schema);
  } else if (type5 instanceof ZodEffects) {
    return getDiscriminator(type5.innerType());
  } else if (type5 instanceof ZodLiteral) {
    return [type5.value];
  } else if (type5 instanceof ZodEnum) {
    return type5.options;
  } else if (type5 instanceof ZodNativeEnum) {
    return util.objectValues(type5.enum);
  } else if (type5 instanceof ZodDefault) {
    return getDiscriminator(type5._def.innerType);
  } else if (type5 instanceof ZodUndefined) {
    return [void 0];
  } else if (type5 instanceof ZodNull) {
    return [null];
  } else if (type5 instanceof ZodOptional) {
    return [void 0, ...getDiscriminator(type5.unwrap())];
  } else if (type5 instanceof ZodNullable) {
    return [null, ...getDiscriminator(type5.unwrap())];
  } else if (type5 instanceof ZodBranded) {
    return getDiscriminator(type5.unwrap());
  } else if (type5 instanceof ZodReadonly) {
    return getDiscriminator(type5.unwrap());
  } else if (type5 instanceof ZodCatch) {
    return getDiscriminator(type5._def.innerType);
  } else {
    return [];
  }
};
var ZodDiscriminatedUnion = class _ZodDiscriminatedUnion extends ZodType {
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.object) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.object,
        received: ctx.parsedType
      });
      return INVALID;
    }
    const discriminator = this.discriminator;
    const discriminatorValue = ctx.data[discriminator];
    const option = this.optionsMap.get(discriminatorValue);
    if (!option) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_union_discriminator,
        options: Array.from(this.optionsMap.keys()),
        path: [discriminator]
      });
      return INVALID;
    }
    if (ctx.common.async) {
      return option._parseAsync({
        data: ctx.data,
        path: ctx.path,
        parent: ctx
      });
    } else {
      return option._parseSync({
        data: ctx.data,
        path: ctx.path,
        parent: ctx
      });
    }
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(discriminator, options, params) {
    const optionsMap = /* @__PURE__ */ new Map();
    for (const type5 of options) {
      const discriminatorValues = getDiscriminator(type5.shape[discriminator]);
      if (!discriminatorValues.length) {
        throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
      }
      for (const value of discriminatorValues) {
        if (optionsMap.has(value)) {
          throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
        }
        optionsMap.set(value, type5);
      }
    }
    return new _ZodDiscriminatedUnion({
      typeName: ZodFirstPartyTypeKind.ZodDiscriminatedUnion,
      discriminator,
      options,
      optionsMap,
      ...processCreateParams(params)
    });
  }
};
function mergeValues(a, b) {
  const aType = getParsedType(a);
  const bType = getParsedType(b);
  if (a === b) {
    return { valid: true, data: a };
  } else if (aType === ZodParsedType.object && bType === ZodParsedType.object) {
    const bKeys = util.objectKeys(b);
    const sharedKeys = util.objectKeys(a).filter((key2) => bKeys.indexOf(key2) !== -1);
    const newObj = { ...a, ...b };
    for (const key2 of sharedKeys) {
      const sharedValue = mergeValues(a[key2], b[key2]);
      if (!sharedValue.valid) {
        return { valid: false };
      }
      newObj[key2] = sharedValue.data;
    }
    return { valid: true, data: newObj };
  } else if (aType === ZodParsedType.array && bType === ZodParsedType.array) {
    if (a.length !== b.length) {
      return { valid: false };
    }
    const newArray = [];
    for (let index3 = 0; index3 < a.length; index3++) {
      const itemA = a[index3];
      const itemB = b[index3];
      const sharedValue = mergeValues(itemA, itemB);
      if (!sharedValue.valid) {
        return { valid: false };
      }
      newArray.push(sharedValue.data);
    }
    return { valid: true, data: newArray };
  } else if (aType === ZodParsedType.date && bType === ZodParsedType.date && +a === +b) {
    return { valid: true, data: a };
  } else {
    return { valid: false };
  }
}
var ZodIntersection = class extends ZodType {
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    const handleParsed = (parsedLeft, parsedRight) => {
      if (isAborted(parsedLeft) || isAborted(parsedRight)) {
        return INVALID;
      }
      const merged = mergeValues(parsedLeft.value, parsedRight.value);
      if (!merged.valid) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_intersection_types
        });
        return INVALID;
      }
      if (isDirty(parsedLeft) || isDirty(parsedRight)) {
        status.dirty();
      }
      return { status: status.value, value: merged.data };
    };
    if (ctx.common.async) {
      return Promise.all([
        this._def.left._parseAsync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        }),
        this._def.right._parseAsync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        })
      ]).then(([left2, right2]) => handleParsed(left2, right2));
    } else {
      return handleParsed(this._def.left._parseSync({
        data: ctx.data,
        path: ctx.path,
        parent: ctx
      }), this._def.right._parseSync({
        data: ctx.data,
        path: ctx.path,
        parent: ctx
      }));
    }
  }
};
ZodIntersection.create = (left2, right2, params) => {
  return new ZodIntersection({
    left: left2,
    right: right2,
    typeName: ZodFirstPartyTypeKind.ZodIntersection,
    ...processCreateParams(params)
  });
};
var ZodTuple = class _ZodTuple extends ZodType {
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.array) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.array,
        received: ctx.parsedType
      });
      return INVALID;
    }
    if (ctx.data.length < this._def.items.length) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.too_small,
        minimum: this._def.items.length,
        inclusive: true,
        exact: false,
        type: "array"
      });
      return INVALID;
    }
    const rest = this._def.rest;
    if (!rest && ctx.data.length > this._def.items.length) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.too_big,
        maximum: this._def.items.length,
        inclusive: true,
        exact: false,
        type: "array"
      });
      status.dirty();
    }
    const items = [...ctx.data].map((item, itemIndex) => {
      const schema = this._def.items[itemIndex] || this._def.rest;
      if (!schema)
        return null;
      return schema._parse(new ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
    }).filter((x) => !!x);
    if (ctx.common.async) {
      return Promise.all(items).then((results) => {
        return ParseStatus.mergeArray(status, results);
      });
    } else {
      return ParseStatus.mergeArray(status, items);
    }
  }
  get items() {
    return this._def.items;
  }
  rest(rest) {
    return new _ZodTuple({
      ...this._def,
      rest
    });
  }
};
ZodTuple.create = (schemas, params) => {
  if (!Array.isArray(schemas)) {
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  }
  return new ZodTuple({
    items: schemas,
    typeName: ZodFirstPartyTypeKind.ZodTuple,
    rest: null,
    ...processCreateParams(params)
  });
};
var ZodRecord = class _ZodRecord extends ZodType {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.object) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.object,
        received: ctx.parsedType
      });
      return INVALID;
    }
    const pairs = [];
    const keyType = this._def.keyType;
    const valueType = this._def.valueType;
    for (const key2 in ctx.data) {
      pairs.push({
        key: keyType._parse(new ParseInputLazyPath(ctx, key2, ctx.path, key2)),
        value: valueType._parse(new ParseInputLazyPath(ctx, ctx.data[key2], ctx.path, key2)),
        alwaysSet: key2 in ctx.data
      });
    }
    if (ctx.common.async) {
      return ParseStatus.mergeObjectAsync(status, pairs);
    } else {
      return ParseStatus.mergeObjectSync(status, pairs);
    }
  }
  get element() {
    return this._def.valueType;
  }
  static create(first, second, third) {
    if (second instanceof ZodType) {
      return new _ZodRecord({
        keyType: first,
        valueType: second,
        typeName: ZodFirstPartyTypeKind.ZodRecord,
        ...processCreateParams(third)
      });
    }
    return new _ZodRecord({
      keyType: ZodString.create(),
      valueType: first,
      typeName: ZodFirstPartyTypeKind.ZodRecord,
      ...processCreateParams(second)
    });
  }
};
var ZodMap = class extends ZodType {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.map) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.map,
        received: ctx.parsedType
      });
      return INVALID;
    }
    const keyType = this._def.keyType;
    const valueType = this._def.valueType;
    const pairs = [...ctx.data.entries()].map(([key2, value], index3) => {
      return {
        key: keyType._parse(new ParseInputLazyPath(ctx, key2, ctx.path, [index3, "key"])),
        value: valueType._parse(new ParseInputLazyPath(ctx, value, ctx.path, [index3, "value"]))
      };
    });
    if (ctx.common.async) {
      const finalMap = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const pair of pairs) {
          const key2 = await pair.key;
          const value = await pair.value;
          if (key2.status === "aborted" || value.status === "aborted") {
            return INVALID;
          }
          if (key2.status === "dirty" || value.status === "dirty") {
            status.dirty();
          }
          finalMap.set(key2.value, value.value);
        }
        return { status: status.value, value: finalMap };
      });
    } else {
      const finalMap = /* @__PURE__ */ new Map();
      for (const pair of pairs) {
        const key2 = pair.key;
        const value = pair.value;
        if (key2.status === "aborted" || value.status === "aborted") {
          return INVALID;
        }
        if (key2.status === "dirty" || value.status === "dirty") {
          status.dirty();
        }
        finalMap.set(key2.value, value.value);
      }
      return { status: status.value, value: finalMap };
    }
  }
};
ZodMap.create = (keyType, valueType, params) => {
  return new ZodMap({
    valueType,
    keyType,
    typeName: ZodFirstPartyTypeKind.ZodMap,
    ...processCreateParams(params)
  });
};
var ZodSet = class _ZodSet extends ZodType {
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.set) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.set,
        received: ctx.parsedType
      });
      return INVALID;
    }
    const def = this._def;
    if (def.minSize !== null) {
      if (ctx.data.size < def.minSize.value) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.too_small,
          minimum: def.minSize.value,
          type: "set",
          inclusive: true,
          exact: false,
          message: def.minSize.message
        });
        status.dirty();
      }
    }
    if (def.maxSize !== null) {
      if (ctx.data.size > def.maxSize.value) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.too_big,
          maximum: def.maxSize.value,
          type: "set",
          inclusive: true,
          exact: false,
          message: def.maxSize.message
        });
        status.dirty();
      }
    }
    const valueType = this._def.valueType;
    function finalizeSet(elements2) {
      const parsedSet = /* @__PURE__ */ new Set();
      for (const element of elements2) {
        if (element.status === "aborted")
          return INVALID;
        if (element.status === "dirty")
          status.dirty();
        parsedSet.add(element.value);
      }
      return { status: status.value, value: parsedSet };
    }
    const elements = [...ctx.data.values()].map((item, i) => valueType._parse(new ParseInputLazyPath(ctx, item, ctx.path, i)));
    if (ctx.common.async) {
      return Promise.all(elements).then((elements2) => finalizeSet(elements2));
    } else {
      return finalizeSet(elements);
    }
  }
  min(minSize, message2) {
    return new _ZodSet({
      ...this._def,
      minSize: { value: minSize, message: errorUtil.toString(message2) }
    });
  }
  max(maxSize, message2) {
    return new _ZodSet({
      ...this._def,
      maxSize: { value: maxSize, message: errorUtil.toString(message2) }
    });
  }
  size(size, message2) {
    return this.min(size, message2).max(size, message2);
  }
  nonempty(message2) {
    return this.min(1, message2);
  }
};
ZodSet.create = (valueType, params) => {
  return new ZodSet({
    valueType,
    minSize: null,
    maxSize: null,
    typeName: ZodFirstPartyTypeKind.ZodSet,
    ...processCreateParams(params)
  });
};
var ZodFunction = class _ZodFunction extends ZodType {
  constructor() {
    super(...arguments);
    this.validate = this.implement;
  }
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.function) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.function,
        received: ctx.parsedType
      });
      return INVALID;
    }
    function makeArgsIssue(args, error2) {
      return makeIssue({
        data: args,
        path: ctx.path,
        errorMaps: [ctx.common.contextualErrorMap, ctx.schemaErrorMap, getErrorMap(), en_default].filter((x) => !!x),
        issueData: {
          code: ZodIssueCode.invalid_arguments,
          argumentsError: error2
        }
      });
    }
    function makeReturnsIssue(returns, error2) {
      return makeIssue({
        data: returns,
        path: ctx.path,
        errorMaps: [ctx.common.contextualErrorMap, ctx.schemaErrorMap, getErrorMap(), en_default].filter((x) => !!x),
        issueData: {
          code: ZodIssueCode.invalid_return_type,
          returnTypeError: error2
        }
      });
    }
    const params = { errorMap: ctx.common.contextualErrorMap };
    const fn = ctx.data;
    if (this._def.returns instanceof ZodPromise) {
      const me = this;
      return OK(async function(...args) {
        const error2 = new ZodError([]);
        const parsedArgs = await me._def.args.parseAsync(args, params).catch((e3) => {
          error2.addIssue(makeArgsIssue(args, e3));
          throw error2;
        });
        const result = await Reflect.apply(fn, this, parsedArgs);
        const parsedReturns = await me._def.returns._def.type.parseAsync(result, params).catch((e3) => {
          error2.addIssue(makeReturnsIssue(result, e3));
          throw error2;
        });
        return parsedReturns;
      });
    } else {
      const me = this;
      return OK(function(...args) {
        const parsedArgs = me._def.args.safeParse(args, params);
        if (!parsedArgs.success) {
          throw new ZodError([makeArgsIssue(args, parsedArgs.error)]);
        }
        const result = Reflect.apply(fn, this, parsedArgs.data);
        const parsedReturns = me._def.returns.safeParse(result, params);
        if (!parsedReturns.success) {
          throw new ZodError([makeReturnsIssue(result, parsedReturns.error)]);
        }
        return parsedReturns.data;
      });
    }
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...items) {
    return new _ZodFunction({
      ...this._def,
      args: ZodTuple.create(items).rest(ZodUnknown.create())
    });
  }
  returns(returnType) {
    return new _ZodFunction({
      ...this._def,
      returns: returnType
    });
  }
  implement(func) {
    const validatedFunc = this.parse(func);
    return validatedFunc;
  }
  strictImplement(func) {
    const validatedFunc = this.parse(func);
    return validatedFunc;
  }
  static create(args, returns, params) {
    return new _ZodFunction({
      args: args ? args : ZodTuple.create([]).rest(ZodUnknown.create()),
      returns: returns || ZodUnknown.create(),
      typeName: ZodFirstPartyTypeKind.ZodFunction,
      ...processCreateParams(params)
    });
  }
};
var ZodLazy = class extends ZodType {
  get schema() {
    return this._def.getter();
  }
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    const lazySchema = this._def.getter();
    return lazySchema._parse({ data: ctx.data, path: ctx.path, parent: ctx });
  }
};
ZodLazy.create = (getter, params) => {
  return new ZodLazy({
    getter,
    typeName: ZodFirstPartyTypeKind.ZodLazy,
    ...processCreateParams(params)
  });
};
var ZodLiteral = class extends ZodType {
  _parse(input) {
    if (input.data !== this._def.value) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        received: ctx.data,
        code: ZodIssueCode.invalid_literal,
        expected: this._def.value
      });
      return INVALID;
    }
    return { status: "valid", value: input.data };
  }
  get value() {
    return this._def.value;
  }
};
ZodLiteral.create = (value, params) => {
  return new ZodLiteral({
    value,
    typeName: ZodFirstPartyTypeKind.ZodLiteral,
    ...processCreateParams(params)
  });
};
function createZodEnum(values, params) {
  return new ZodEnum({
    values,
    typeName: ZodFirstPartyTypeKind.ZodEnum,
    ...processCreateParams(params)
  });
}
var ZodEnum = class _ZodEnum extends ZodType {
  _parse(input) {
    if (typeof input.data !== "string") {
      const ctx = this._getOrReturnCtx(input);
      const expectedValues = this._def.values;
      addIssueToContext(ctx, {
        expected: util.joinValues(expectedValues),
        received: ctx.parsedType,
        code: ZodIssueCode.invalid_type
      });
      return INVALID;
    }
    if (!this._cache) {
      this._cache = new Set(this._def.values);
    }
    if (!this._cache.has(input.data)) {
      const ctx = this._getOrReturnCtx(input);
      const expectedValues = this._def.values;
      addIssueToContext(ctx, {
        received: ctx.data,
        code: ZodIssueCode.invalid_enum_value,
        options: expectedValues
      });
      return INVALID;
    }
    return OK(input.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const enumValues = {};
    for (const val of this._def.values) {
      enumValues[val] = val;
    }
    return enumValues;
  }
  get Values() {
    const enumValues = {};
    for (const val of this._def.values) {
      enumValues[val] = val;
    }
    return enumValues;
  }
  get Enum() {
    const enumValues = {};
    for (const val of this._def.values) {
      enumValues[val] = val;
    }
    return enumValues;
  }
  extract(values, newDef = this._def) {
    return _ZodEnum.create(values, {
      ...this._def,
      ...newDef
    });
  }
  exclude(values, newDef = this._def) {
    return _ZodEnum.create(this.options.filter((opt) => !values.includes(opt)), {
      ...this._def,
      ...newDef
    });
  }
};
ZodEnum.create = createZodEnum;
var ZodNativeEnum = class extends ZodType {
  _parse(input) {
    const nativeEnumValues = util.getValidEnumValues(this._def.values);
    const ctx = this._getOrReturnCtx(input);
    if (ctx.parsedType !== ZodParsedType.string && ctx.parsedType !== ZodParsedType.number) {
      const expectedValues = util.objectValues(nativeEnumValues);
      addIssueToContext(ctx, {
        expected: util.joinValues(expectedValues),
        received: ctx.parsedType,
        code: ZodIssueCode.invalid_type
      });
      return INVALID;
    }
    if (!this._cache) {
      this._cache = new Set(util.getValidEnumValues(this._def.values));
    }
    if (!this._cache.has(input.data)) {
      const expectedValues = util.objectValues(nativeEnumValues);
      addIssueToContext(ctx, {
        received: ctx.data,
        code: ZodIssueCode.invalid_enum_value,
        options: expectedValues
      });
      return INVALID;
    }
    return OK(input.data);
  }
  get enum() {
    return this._def.values;
  }
};
ZodNativeEnum.create = (values, params) => {
  return new ZodNativeEnum({
    values,
    typeName: ZodFirstPartyTypeKind.ZodNativeEnum,
    ...processCreateParams(params)
  });
};
var ZodPromise = class extends ZodType {
  unwrap() {
    return this._def.type;
  }
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.promise && ctx.common.async === false) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.promise,
        received: ctx.parsedType
      });
      return INVALID;
    }
    const promisified = ctx.parsedType === ZodParsedType.promise ? ctx.data : Promise.resolve(ctx.data);
    return OK(promisified.then((data2) => {
      return this._def.type.parseAsync(data2, {
        path: ctx.path,
        errorMap: ctx.common.contextualErrorMap
      });
    }));
  }
};
ZodPromise.create = (schema, params) => {
  return new ZodPromise({
    type: schema,
    typeName: ZodFirstPartyTypeKind.ZodPromise,
    ...processCreateParams(params)
  });
};
var ZodEffects = class extends ZodType {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === ZodFirstPartyTypeKind.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    const effect = this._def.effect || null;
    const checkCtx = {
      addIssue: (arg) => {
        addIssueToContext(ctx, arg);
        if (arg.fatal) {
          status.abort();
        } else {
          status.dirty();
        }
      },
      get path() {
        return ctx.path;
      }
    };
    checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
    if (effect.type === "preprocess") {
      const processed = effect.transform(ctx.data, checkCtx);
      if (ctx.common.async) {
        return Promise.resolve(processed).then(async (processed2) => {
          if (status.value === "aborted")
            return INVALID;
          const result = await this._def.schema._parseAsync({
            data: processed2,
            path: ctx.path,
            parent: ctx
          });
          if (result.status === "aborted")
            return INVALID;
          if (result.status === "dirty")
            return DIRTY(result.value);
          if (status.value === "dirty")
            return DIRTY(result.value);
          return result;
        });
      } else {
        if (status.value === "aborted")
          return INVALID;
        const result = this._def.schema._parseSync({
          data: processed,
          path: ctx.path,
          parent: ctx
        });
        if (result.status === "aborted")
          return INVALID;
        if (result.status === "dirty")
          return DIRTY(result.value);
        if (status.value === "dirty")
          return DIRTY(result.value);
        return result;
      }
    }
    if (effect.type === "refinement") {
      const executeRefinement = (acc) => {
        const result = effect.refinement(acc, checkCtx);
        if (ctx.common.async) {
          return Promise.resolve(result);
        }
        if (result instanceof Promise) {
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        }
        return acc;
      };
      if (ctx.common.async === false) {
        const inner = this._def.schema._parseSync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        });
        if (inner.status === "aborted")
          return INVALID;
        if (inner.status === "dirty")
          status.dirty();
        executeRefinement(inner.value);
        return { status: status.value, value: inner.value };
      } else {
        return this._def.schema._parseAsync({ data: ctx.data, path: ctx.path, parent: ctx }).then((inner) => {
          if (inner.status === "aborted")
            return INVALID;
          if (inner.status === "dirty")
            status.dirty();
          return executeRefinement(inner.value).then(() => {
            return { status: status.value, value: inner.value };
          });
        });
      }
    }
    if (effect.type === "transform") {
      if (ctx.common.async === false) {
        const base = this._def.schema._parseSync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        });
        if (!isValid(base))
          return INVALID;
        const result = effect.transform(base.value, checkCtx);
        if (result instanceof Promise) {
          throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
        }
        return { status: status.value, value: result };
      } else {
        return this._def.schema._parseAsync({ data: ctx.data, path: ctx.path, parent: ctx }).then((base) => {
          if (!isValid(base))
            return INVALID;
          return Promise.resolve(effect.transform(base.value, checkCtx)).then((result) => ({
            status: status.value,
            value: result
          }));
        });
      }
    }
    util.assertNever(effect);
  }
};
ZodEffects.create = (schema, effect, params) => {
  return new ZodEffects({
    schema,
    typeName: ZodFirstPartyTypeKind.ZodEffects,
    effect,
    ...processCreateParams(params)
  });
};
ZodEffects.createWithPreprocess = (preprocess, schema, params) => {
  return new ZodEffects({
    schema,
    effect: { type: "preprocess", transform: preprocess },
    typeName: ZodFirstPartyTypeKind.ZodEffects,
    ...processCreateParams(params)
  });
};
var ZodOptional = class extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType === ZodParsedType.undefined) {
      return OK(void 0);
    }
    return this._def.innerType._parse(input);
  }
  unwrap() {
    return this._def.innerType;
  }
};
ZodOptional.create = (type5, params) => {
  return new ZodOptional({
    innerType: type5,
    typeName: ZodFirstPartyTypeKind.ZodOptional,
    ...processCreateParams(params)
  });
};
var ZodNullable = class extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType === ZodParsedType.null) {
      return OK(null);
    }
    return this._def.innerType._parse(input);
  }
  unwrap() {
    return this._def.innerType;
  }
};
ZodNullable.create = (type5, params) => {
  return new ZodNullable({
    innerType: type5,
    typeName: ZodFirstPartyTypeKind.ZodNullable,
    ...processCreateParams(params)
  });
};
var ZodDefault = class extends ZodType {
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    let data2 = ctx.data;
    if (ctx.parsedType === ZodParsedType.undefined) {
      data2 = this._def.defaultValue();
    }
    return this._def.innerType._parse({
      data: data2,
      path: ctx.path,
      parent: ctx
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
};
ZodDefault.create = (type5, params) => {
  return new ZodDefault({
    innerType: type5,
    typeName: ZodFirstPartyTypeKind.ZodDefault,
    defaultValue: typeof params.default === "function" ? params.default : () => params.default,
    ...processCreateParams(params)
  });
};
var ZodCatch = class extends ZodType {
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    const newCtx = {
      ...ctx,
      common: {
        ...ctx.common,
        issues: []
      }
    };
    const result = this._def.innerType._parse({
      data: newCtx.data,
      path: newCtx.path,
      parent: {
        ...newCtx
      }
    });
    if (isAsync(result)) {
      return result.then((result2) => {
        return {
          status: "valid",
          value: result2.status === "valid" ? result2.value : this._def.catchValue({
            get error() {
              return new ZodError(newCtx.common.issues);
            },
            input: newCtx.data
          })
        };
      });
    } else {
      return {
        status: "valid",
        value: result.status === "valid" ? result.value : this._def.catchValue({
          get error() {
            return new ZodError(newCtx.common.issues);
          },
          input: newCtx.data
        })
      };
    }
  }
  removeCatch() {
    return this._def.innerType;
  }
};
ZodCatch.create = (type5, params) => {
  return new ZodCatch({
    innerType: type5,
    typeName: ZodFirstPartyTypeKind.ZodCatch,
    catchValue: typeof params.catch === "function" ? params.catch : () => params.catch,
    ...processCreateParams(params)
  });
};
var ZodNaN = class extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.nan) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.nan,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return { status: "valid", value: input.data };
  }
};
ZodNaN.create = (params) => {
  return new ZodNaN({
    typeName: ZodFirstPartyTypeKind.ZodNaN,
    ...processCreateParams(params)
  });
};
var BRAND = Symbol("zod_brand");
var ZodBranded = class extends ZodType {
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    const data2 = ctx.data;
    return this._def.type._parse({
      data: data2,
      path: ctx.path,
      parent: ctx
    });
  }
  unwrap() {
    return this._def.type;
  }
};
var ZodPipeline = class _ZodPipeline extends ZodType {
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    if (ctx.common.async) {
      const handleAsync = async () => {
        const inResult = await this._def.in._parseAsync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        });
        if (inResult.status === "aborted")
          return INVALID;
        if (inResult.status === "dirty") {
          status.dirty();
          return DIRTY(inResult.value);
        } else {
          return this._def.out._parseAsync({
            data: inResult.value,
            path: ctx.path,
            parent: ctx
          });
        }
      };
      return handleAsync();
    } else {
      const inResult = this._def.in._parseSync({
        data: ctx.data,
        path: ctx.path,
        parent: ctx
      });
      if (inResult.status === "aborted")
        return INVALID;
      if (inResult.status === "dirty") {
        status.dirty();
        return {
          status: "dirty",
          value: inResult.value
        };
      } else {
        return this._def.out._parseSync({
          data: inResult.value,
          path: ctx.path,
          parent: ctx
        });
      }
    }
  }
  static create(a, b) {
    return new _ZodPipeline({
      in: a,
      out: b,
      typeName: ZodFirstPartyTypeKind.ZodPipeline
    });
  }
};
var ZodReadonly = class extends ZodType {
  _parse(input) {
    const result = this._def.innerType._parse(input);
    const freeze = (data2) => {
      if (isValid(data2)) {
        data2.value = Object.freeze(data2.value);
      }
      return data2;
    };
    return isAsync(result) ? result.then((data2) => freeze(data2)) : freeze(result);
  }
  unwrap() {
    return this._def.innerType;
  }
};
ZodReadonly.create = (type5, params) => {
  return new ZodReadonly({
    innerType: type5,
    typeName: ZodFirstPartyTypeKind.ZodReadonly,
    ...processCreateParams(params)
  });
};
function cleanParams(params, data2) {
  const p = typeof params === "function" ? params(data2) : typeof params === "string" ? { message: params } : params;
  const p2 = typeof p === "string" ? { message: p } : p;
  return p2;
}
function custom(check, _params = {}, fatal) {
  if (check)
    return ZodAny.create().superRefine((data2, ctx) => {
      const r2 = check(data2);
      if (r2 instanceof Promise) {
        return r2.then((r3) => {
          if (!r3) {
            const params = cleanParams(_params, data2);
            const _fatal = params.fatal ?? fatal ?? true;
            ctx.addIssue({ code: "custom", ...params, fatal: _fatal });
          }
        });
      }
      if (!r2) {
        const params = cleanParams(_params, data2);
        const _fatal = params.fatal ?? fatal ?? true;
        ctx.addIssue({ code: "custom", ...params, fatal: _fatal });
      }
      return;
    });
  return ZodAny.create();
}
var late = {
  object: ZodObject.lazycreate
};
var ZodFirstPartyTypeKind;
(function(ZodFirstPartyTypeKind2) {
  ZodFirstPartyTypeKind2["ZodString"] = "ZodString";
  ZodFirstPartyTypeKind2["ZodNumber"] = "ZodNumber";
  ZodFirstPartyTypeKind2["ZodNaN"] = "ZodNaN";
  ZodFirstPartyTypeKind2["ZodBigInt"] = "ZodBigInt";
  ZodFirstPartyTypeKind2["ZodBoolean"] = "ZodBoolean";
  ZodFirstPartyTypeKind2["ZodDate"] = "ZodDate";
  ZodFirstPartyTypeKind2["ZodSymbol"] = "ZodSymbol";
  ZodFirstPartyTypeKind2["ZodUndefined"] = "ZodUndefined";
  ZodFirstPartyTypeKind2["ZodNull"] = "ZodNull";
  ZodFirstPartyTypeKind2["ZodAny"] = "ZodAny";
  ZodFirstPartyTypeKind2["ZodUnknown"] = "ZodUnknown";
  ZodFirstPartyTypeKind2["ZodNever"] = "ZodNever";
  ZodFirstPartyTypeKind2["ZodVoid"] = "ZodVoid";
  ZodFirstPartyTypeKind2["ZodArray"] = "ZodArray";
  ZodFirstPartyTypeKind2["ZodObject"] = "ZodObject";
  ZodFirstPartyTypeKind2["ZodUnion"] = "ZodUnion";
  ZodFirstPartyTypeKind2["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
  ZodFirstPartyTypeKind2["ZodIntersection"] = "ZodIntersection";
  ZodFirstPartyTypeKind2["ZodTuple"] = "ZodTuple";
  ZodFirstPartyTypeKind2["ZodRecord"] = "ZodRecord";
  ZodFirstPartyTypeKind2["ZodMap"] = "ZodMap";
  ZodFirstPartyTypeKind2["ZodSet"] = "ZodSet";
  ZodFirstPartyTypeKind2["ZodFunction"] = "ZodFunction";
  ZodFirstPartyTypeKind2["ZodLazy"] = "ZodLazy";
  ZodFirstPartyTypeKind2["ZodLiteral"] = "ZodLiteral";
  ZodFirstPartyTypeKind2["ZodEnum"] = "ZodEnum";
  ZodFirstPartyTypeKind2["ZodEffects"] = "ZodEffects";
  ZodFirstPartyTypeKind2["ZodNativeEnum"] = "ZodNativeEnum";
  ZodFirstPartyTypeKind2["ZodOptional"] = "ZodOptional";
  ZodFirstPartyTypeKind2["ZodNullable"] = "ZodNullable";
  ZodFirstPartyTypeKind2["ZodDefault"] = "ZodDefault";
  ZodFirstPartyTypeKind2["ZodCatch"] = "ZodCatch";
  ZodFirstPartyTypeKind2["ZodPromise"] = "ZodPromise";
  ZodFirstPartyTypeKind2["ZodBranded"] = "ZodBranded";
  ZodFirstPartyTypeKind2["ZodPipeline"] = "ZodPipeline";
  ZodFirstPartyTypeKind2["ZodReadonly"] = "ZodReadonly";
})(ZodFirstPartyTypeKind || (ZodFirstPartyTypeKind = {}));
var instanceOfType = (cls11, params = {
  message: `Input not instance of ${cls11.name}`
}) => custom((data2) => data2 instanceof cls11, params);
var stringType = ZodString.create;
var numberType = ZodNumber.create;
var nanType = ZodNaN.create;
var bigIntType = ZodBigInt.create;
var booleanType = ZodBoolean.create;
var dateType = ZodDate.create;
var symbolType = ZodSymbol.create;
var undefinedType = ZodUndefined.create;
var nullType = ZodNull.create;
var anyType = ZodAny.create;
var unknownType = ZodUnknown.create;
var neverType = ZodNever.create;
var voidType = ZodVoid.create;
var arrayType = ZodArray.create;
var objectType = ZodObject.create;
var strictObjectType = ZodObject.strictCreate;
var unionType = ZodUnion.create;
var discriminatedUnionType = ZodDiscriminatedUnion.create;
var intersectionType = ZodIntersection.create;
var tupleType = ZodTuple.create;
var recordType = ZodRecord.create;
var mapType = ZodMap.create;
var setType = ZodSet.create;
var functionType = ZodFunction.create;
var lazyType = ZodLazy.create;
var literalType = ZodLiteral.create;
var enumType = ZodEnum.create;
var nativeEnumType = ZodNativeEnum.create;
var promiseType = ZodPromise.create;
var effectsType = ZodEffects.create;
var optionalType = ZodOptional.create;
var nullableType = ZodNullable.create;
var preprocessType = ZodEffects.createWithPreprocess;
var pipelineType = ZodPipeline.create;
var ostring = () => stringType().optional();
var onumber = () => numberType().optional();
var oboolean = () => booleanType().optional();
var coerce = {
  string: ((arg) => ZodString.create({ ...arg, coerce: true })),
  number: ((arg) => ZodNumber.create({ ...arg, coerce: true })),
  boolean: ((arg) => ZodBoolean.create({
    ...arg,
    coerce: true
  })),
  bigint: ((arg) => ZodBigInt.create({ ...arg, coerce: true })),
  date: ((arg) => ZodDate.create({ ...arg, coerce: true }))
};
var NEVER = INVALID;

// ../common/dist/esm/src/helper.js
var import_buffer = __toESM(require_buffer());

// ../common/dist/esm/src/schema.js
var langs = ["en", "de"];
var Lang = external_exports.enum(langs);
var Dict = external_exports.object({
  // -----------------used in ui-----------------
  cancel: external_exports.string(),
  close: external_exports.string(),
  set: external_exports.string(),
  clear: external_exports.string(),
  field: external_exports.string(),
  fieldName: external_exports.string(),
  align: external_exports.string(),
  width: external_exports.string(),
  opacity: external_exports.string(),
  height: external_exports.string(),
  rotate: external_exports.string(),
  edit: external_exports.string(),
  required: external_exports.string(),
  editable: external_exports.string(),
  plsInputName: external_exports.string(),
  fieldMustUniq: external_exports.string(),
  notUniq: external_exports.string(),
  noKeyName: external_exports.string(),
  fieldsList: external_exports.string(),
  editField: external_exports.string(),
  type: external_exports.string(),
  errorOccurred: external_exports.string(),
  errorBulkUpdateFieldName: external_exports.string(),
  commitBulkUpdateFieldName: external_exports.string(),
  bulkUpdateFieldName: external_exports.string(),
  addPageAfter: external_exports.string(),
  removePage: external_exports.string(),
  removePageConfirm: external_exports.string(),
  // --------------------validation-------------------
  "validation.uniqueName": external_exports.string(),
  "validation.hexColor": external_exports.string(),
  "validation.dateTimeFormat": external_exports.string(),
  // -----------------used in schemas-----------------
  "schemas.section": external_exports.string(),
  "schemas.label": external_exports.string(),
  "schemas.measurementPoint": external_exports.string(),
  "schemas.color": external_exports.string(),
  "schemas.borderWidth": external_exports.string(),
  "schemas.borderColor": external_exports.string(),
  "schemas.backgroundColor": external_exports.string(),
  "schemas.textColor": external_exports.string(),
  "schemas.bgColor": external_exports.string(),
  "schemas.horizontal": external_exports.string(),
  "schemas.vertical": external_exports.string(),
  "schemas.left": external_exports.string(),
  "schemas.center": external_exports.string(),
  "schemas.right": external_exports.string(),
  "schemas.top": external_exports.string(),
  "schemas.middle": external_exports.string(),
  "schemas.bottom": external_exports.string(),
  "schemas.padding": external_exports.string(),
  "schemas.text.fontName": external_exports.string(),
  "schemas.text.size": external_exports.string(),
  "schemas.text.spacing": external_exports.string(),
  "schemas.text.textAlign": external_exports.string(),
  "schemas.text.verticalAlign": external_exports.string(),
  "schemas.text.lineHeight": external_exports.string(),
  "schemas.text.min": external_exports.string(),
  "schemas.text.max": external_exports.string(),
  "schemas.text.fit": external_exports.string(),
  "schemas.text.dynamicFontSize": external_exports.string(),
  "schemas.text.format": external_exports.string(),
  "schemas.radius": external_exports.string(),
  "schemas.mvt.typingInstructions": external_exports.string(),
  "schemas.mvt.sampleField": external_exports.string(),
  "schemas.mvt.variablesSampleData": external_exports.string(),
  "schemas.barcodes.barColor": external_exports.string(),
  "schemas.barcodes.includetext": external_exports.string(),
  "schemas.table.alternateBackgroundColor": external_exports.string(),
  "schemas.table.tableStyle": external_exports.string(),
  "schemas.table.showHead": external_exports.string(),
  "schemas.table.headStyle": external_exports.string(),
  "schemas.table.bodyStyle": external_exports.string(),
  "schemas.table.columnStyle": external_exports.string(),
  "schemas.date.format": external_exports.string(),
  "schemas.date.locale": external_exports.string(),
  "schemas.select.options": external_exports.string(),
  "schemas.select.optionPlaceholder": external_exports.string(),
  "schemas.radioGroup.groupName": external_exports.string(),
  "schemas.numberOfSides": external_exports.string(),
  "schemas.mvt.showVariables": external_exports.string(),
  "schemas.mvt.variablesList": external_exports.string(),
  "schemas.mvt.close": external_exports.string(),
  "schemas.varText.showVar": external_exports.string(),
  "schemas.varText.availableVar": external_exports.string(),
  "schemas.varText.copy": external_exports.string(),
  "schemas.varText.isCopy": external_exports.string(),
  "schemas.varText.kundennummerB": external_exports.string(),
  "schemas.varText.betreiberName": external_exports.string(),
  "schemas.varText.betreiberPLZ": external_exports.string(),
  "schemas.varText.betreiberAnsprechpartner": external_exports.string(),
  "schemas.varText.betreiberOrt": external_exports.string(),
  "schemas.varText.betreiberTelefonnummer": external_exports.string(),
  "schemas.varText.betreiberEMail": external_exports.string(),
  "schemas.varText.betreiberStrasse": external_exports.string(),
  "schemas.varText.betreiberHausnr": external_exports.string(),
  "schemas.varText.firmaName": external_exports.string(),
  "schemas.varText.firmaEMail": external_exports.string(),
  "schemas.varText.firmaTelefon": external_exports.string(),
  "schemas.varText.firmaStrasse": external_exports.string(),
  "schemas.varText.firmaPLZ": external_exports.string(),
  "schemas.varText.firmaOrt": external_exports.string(),
  "schemas.varText.firmaAnsprechpartner": external_exports.string(),
  "schemas.varText.firmaHausnr": external_exports.string(),
  "schemas.varText.pruefungGrundlage": external_exports.string(),
  "schemas.varText.pruefungVertragsnummer": external_exports.string(),
  "schemas.varText.pruefungPruefDatum": external_exports.string(),
  "schemas.varText.pruefungNaechstePruef": external_exports.string(),
  "schemas.varText.objektHersteller": external_exports.string(),
  "schemas.varText.objektStandort": external_exports.string(),
  "schemas.varText.objektTyp": external_exports.string(),
  "schemas.varText.objektSeriennummer": external_exports.string(),
  "schemas.varText.objektInterneNummer": external_exports.string(),
  "schemas.varText.objektBaujahr": external_exports.string(),
  "schemas.varText.objektSteuerung": external_exports.string(),
  "schemas.varText.objektBetriebsart": external_exports.string(),
  "schemas.varText.objektBreite": external_exports.string(),
  "schemas.varText.objektHoehe": external_exports.string(),
  "schemas.varText.objektBemerkung": external_exports.string(),
  "schemas.varText.prueferVorname": external_exports.string(),
  "schemas.varText.prueferNachname": external_exports.string(),
  "schemas.varText.prueferEMail": external_exports.string(),
  "schemas.measurementPointList.measurement": external_exports.string(),
  "schemas.measurementPointList.contactPoint": external_exports.string(),
  "schemas.measurementPointList.assessment": external_exports.string(),
  "schemas.measurementPointList.max": external_exports.string(),
  "schemas.measurementPointList.average": external_exports.string()
});
var Mode = external_exports.enum(["viewer", "form", "designer"]);
var ColorType = external_exports.enum(["rgb", "cmyk"]).optional();
var Size = external_exports.object({ height: external_exports.number(), width: external_exports.number() });
var Schema = external_exports.object({
  name: external_exports.string(),
  type: external_exports.string(),
  content: external_exports.string().optional(),
  position: external_exports.object({ x: external_exports.number(), y: external_exports.number() }),
  width: external_exports.number(),
  height: external_exports.number(),
  rotate: external_exports.number().optional(),
  opacity: external_exports.number().optional(),
  readOnly: external_exports.boolean().optional(),
  required: external_exports.boolean().optional(),
  __bodyRange: external_exports.object({ start: external_exports.number(), end: external_exports.number().optional() }).optional(),
  __isSplit: external_exports.boolean().optional()
}).passthrough();
var SchemaForUIAdditionalInfo = external_exports.object({ id: external_exports.string() });
var SchemaForUI = Schema.merge(SchemaForUIAdditionalInfo);
var ArrayBufferSchema = external_exports.any().refine((v) => v instanceof ArrayBuffer);
var Uint8ArraySchema = external_exports.any().refine((v) => v instanceof Uint8Array);
var BlankPdf = external_exports.object({
  width: external_exports.number(),
  height: external_exports.number(),
  padding: external_exports.tuple([external_exports.number(), external_exports.number(), external_exports.number(), external_exports.number()]),
  staticSchema: external_exports.array(Schema).optional()
});
var CustomPdf = external_exports.union([external_exports.string(), ArrayBufferSchema, Uint8ArraySchema]);
var BasePdf = external_exports.union([CustomPdf, BlankPdf]);
var LegacySchemaPageArray = external_exports.array(external_exports.record(Schema));
var SchemaPageArray = external_exports.array(external_exports.array(Schema));
var Template = external_exports.object({
  schemas: SchemaPageArray,
  basePdf: BasePdf,
  pdfmeVersion: external_exports.string().optional()
}).passthrough();
var Inputs = external_exports.array(external_exports.record(external_exports.any())).min(1);
var Font = external_exports.record(external_exports.object({
  data: external_exports.union([external_exports.string(), ArrayBufferSchema, Uint8ArraySchema]),
  fallback: external_exports.boolean().optional(),
  subset: external_exports.boolean().optional()
}));
var CommonOptions = external_exports.object({ font: Font.optional() }).passthrough();
var CommonProps = external_exports.object({
  template: Template,
  options: CommonOptions.optional(),
  plugins: external_exports.record(external_exports.object({ ui: external_exports.any(), pdf: external_exports.any(), propPanel: external_exports.any() })).optional()
});
var GeneratorOptions = CommonOptions.extend({
  colorType: ColorType,
  author: external_exports.string().optional(),
  creationDate: external_exports.date().optional(),
  creator: external_exports.string().optional(),
  keywords: external_exports.array(external_exports.string()).optional(),
  lang: Lang.optional(),
  modificationDate: external_exports.date().optional(),
  producer: external_exports.string().optional(),
  subject: external_exports.string().optional(),
  title: external_exports.string().optional()
});
var GenerateProps = CommonProps.extend({
  inputs: Inputs,
  options: GeneratorOptions.optional()
}).strict();
var UIOptions = CommonOptions.extend({
  lang: Lang.optional(),
  labels: external_exports.record(external_exports.string(), external_exports.string()).optional(),
  theme: external_exports.record(external_exports.string(), external_exports.unknown()).optional(),
  icons: external_exports.record(external_exports.string(), external_exports.string()).optional(),
  requiredByDefault: external_exports.boolean().optional(),
  maxZoom: external_exports.number().optional()
});
var HTMLElementSchema = external_exports.any().refine((v) => v instanceof HTMLElement);
var UIProps = CommonProps.extend({
  domContainer: HTMLElementSchema,
  options: UIOptions.optional()
});
var PreviewProps = UIProps.extend({ inputs: Inputs }).strict();
var DesignerProps = UIProps.extend({}).strict();

// ../common/dist/esm/src/helper.js
var cloneDeep = structuredClone;
var uniq = (array4) => Array.from(new Set(array4));
var getFallbackFontName = (font) => {
  const initial = "";
  const fallbackFontName = Object.entries(font).reduce((acc, cur) => {
    const [fontName, fontValue] = cur;
    return !acc && fontValue.fallback ? fontName : acc;
  }, initial);
  if (fallbackFontName === initial) {
    throw Error(`[@pdfme/common] fallback flag is not found in font. true fallback flag must be only one.`);
  }
  return fallbackFontName;
};
var getDefaultFont = () => ({
  [DEFAULT_FONT_NAME]: { data: b64toUint8Array(DEFAULT_FONT_VALUE), fallback: true }
});
var mm2pt = (mm) => {
  return parseFloat(String(mm)) * MM_TO_PT_RATIO;
};
var pt2mm = (pt) => {
  return pt * PT_TO_MM_RATIO;
};
var pt2px = (pt) => {
  return pt * PT_TO_PX_RATIO;
};
var px2mm = (px) => {
  const ratio = 0.26458333333333;
  return parseFloat(String(px)) * ratio;
};
var blob2Base64Pdf = (blob) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      if (reader.result.startsWith("data:application/pdf;")) {
        resolve(reader.result);
      } else {
        reject(Error("[@pdfme/common] template.basePdf must be pdf data."));
      }
    };
    reader.readAsDataURL(blob);
  });
};
var isHexValid = (hex2) => {
  return /^#(?:[A-Fa-f0-9]{3,4}|[A-Fa-f0-9]{6}|[A-Fa-f0-9]{8})$/i.test(hex2);
};
var migrateTemplate = (template) => {
  if (!template.schemas) {
    return;
  }
  if (Array.isArray(template.schemas) && template.schemas.length > 0 && !Array.isArray(template.schemas[0])) {
    template.schemas = template.schemas.map((page) => Object.entries(page).map(([key2, value]) => ({
      ...value,
      name: key2
    })));
  }
};
var getB64BasePdf = async (customPdf) => {
  if (typeof customPdf === "string" && !customPdf.startsWith("data:application/pdf;") && typeof window !== "undefined") {
    const response = await fetch(customPdf);
    const blob = await response.blob();
    return blob2Base64Pdf(blob);
  }
  if (typeof customPdf === "string") {
    return customPdf;
  }
  const uint8Array = customPdf instanceof Uint8Array ? customPdf : new Uint8Array(customPdf);
  return "data:application/pdf;base64," + import_buffer.Buffer.from(uint8Array).toString("base64");
};
var isBlankPdf = (basePdf) => BlankPdf.safeParse(basePdf).success;
var getByteString = (base64) => import_buffer.Buffer.from(base64, "base64").toString("binary");
var b64toUint8Array = (base64) => {
  const data2 = base64.split(";base64,")[1] ? base64.split(";base64,")[1] : base64;
  const byteString = getByteString(data2);
  const unit8arr = new Uint8Array(byteString.length);
  for (let i = 0; i < byteString.length; i += 1) {
    unit8arr[i] = byteString.charCodeAt(i);
  }
  return unit8arr;
};
var getFontNamesInSchemas = (schemas) => uniq(schemas.map((p) => p.map((v) => v.fontName ?? "")).reduce((acc, cur) => acc.concat(cur), []).filter(Boolean));
var checkFont = (arg) => {
  const { font, template: { schemas } } = arg;
  const fontValues = Object.values(font);
  const fallbackFontNum = fontValues.reduce((acc, cur) => cur.fallback ? acc + 1 : acc, 0);
  if (fallbackFontNum === 0) {
    throw Error(`[@pdfme/common] fallback flag is not found in font. true fallback flag must be only one.
Check this document: https://pdfme.com/docs/custom-fonts#about-font-type`);
  }
  if (fallbackFontNum > 1) {
    throw Error(`[@pdfme/common] ${fallbackFontNum} fallback flags found in font. true fallback flag must be only one.
Check this document: https://pdfme.com/docs/custom-fonts#about-font-type`);
  }
  const fontNamesInSchemas = getFontNamesInSchemas(schemas);
  const fontNames = Object.keys(font);
  if (fontNamesInSchemas.some((f) => !fontNames.includes(f))) {
    throw Error(`[@pdfme/common] ${fontNamesInSchemas.filter((f) => !fontNames.includes(f)).join()} of template.schemas is not found in font.
Check this document: https://pdfme.com/docs/custom-fonts`);
  }
};
var checkPlugins = (arg) => {
  const { plugins, template: { schemas } } = arg;
  const allSchemaTypes = uniq(schemas.map((p) => p.map((v) => v.type)).flat());
  const pluginsSchemaTypes = Object.values(plugins).map((p) => p ? p.propPanel.defaultSchema.type : void 0);
  if (allSchemaTypes.some((s) => !pluginsSchemaTypes.includes(s))) {
    throw Error(`[@pdfme/common] ${allSchemaTypes.filter((s) => !pluginsSchemaTypes.includes(s)).join()} of template.schemas is not found in plugins.`);
  }
};
var checkProps = (data2, zodSchema) => {
  try {
    zodSchema.parse(data2);
  } catch (e3) {
    if (e3 instanceof external_exports.ZodError) {
      const messages2 = e3.issues.map((issue) => `ERROR POSITION: ${issue.path.join(".")}
ERROR MESSAGE: ${issue.message}
--------------------------`);
      const message2 = messages2.join("\n");
      throw Error(`[@pdfme/common] Invalid argument:
--------------------------
${message2}`);
    }
  }
  if (data2 && typeof data2 === "object" && "template" in data2 && "options" in data2) {
    const { template, options } = data2;
    if (options && options.font) {
      checkFont({ font: options.font, template });
    }
  }
  if (data2 && typeof data2 === "object" && "template" in data2 && "plugins" in data2) {
    const { template, plugins } = data2;
    if (plugins) {
      checkPlugins({ plugins, template });
    }
  }
};
var checkInputs = (data2) => checkProps(data2, Inputs);
var checkUIOptions = (data2) => checkProps(data2, UIOptions);
var checkPreviewProps = (data2) => checkProps(data2, PreviewProps);
var checkDesignerProps = (data2) => checkProps(data2, DesignerProps);
var checkUIProps = (data2) => {
  if (typeof data2 === "object" && data2 !== null && "template" in data2) {
    migrateTemplate(data2.template);
  }
  checkProps(data2, UIProps);
};
var checkTemplate = (template) => {
  migrateTemplate(template);
  checkProps(template, Template);
};

// ../common/dist/esm/src/dynamicTemplate.js
var LayoutNode = class {
  constructor({ width = 0, height = 0 } = {}) {
    Object.defineProperty(this, "index", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    Object.defineProperty(this, "schema", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "children", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: []
    });
    Object.defineProperty(this, "width", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    Object.defineProperty(this, "height", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    Object.defineProperty(this, "padding", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: [0, 0, 0, 0]
    });
    Object.defineProperty(this, "position", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: { x: 0, y: 0 }
    });
    this.width = width;
    this.height = height;
  }
  setIndex(index3) {
    this.index = index3;
  }
  setSchema(schema) {
    this.schema = schema;
  }
  setWidth(width) {
    this.width = width;
  }
  setHeight(height) {
    this.height = height;
  }
  setPadding(padding) {
    this.padding = padding;
  }
  setPosition(position3) {
    this.position = position3;
  }
  insertChild(child) {
    const index3 = this.getChildCount();
    child.setIndex(index3);
    this.children.splice(index3, 0, child);
  }
  getChildCount() {
    return this.children.length;
  }
  getChild(index3) {
    return this.children[index3];
  }
};
function createPage(basePdf) {
  const page = new LayoutNode({ ...basePdf });
  page.setPadding(basePdf.padding);
  return page;
}
function createNode(arg) {
  const { position: position3, width, height, schema } = arg;
  const node2 = new LayoutNode({ width, height });
  node2.setPosition(position3);
  node2.setSchema(schema);
  return node2;
}
function resortChildren(page, orderMap) {
  page.children = page.children.sort((a, b) => {
    const orderA = orderMap.get(a.schema?.name ?? "");
    const orderB = orderMap.get(b.schema?.name ?? "");
    if (orderA === void 0 || orderB === void 0) {
      throw new Error("[@pdfme/common] order is not defined");
    }
    return orderA - orderB;
  }).map((child, index3) => {
    child.setIndex(index3);
    return child;
  });
}
async function createOnePage(arg) {
  const { basePdf, schemaPage, orderMap, input, options, _cache: _cache2, getDynamicHeights } = arg;
  const page = createPage(basePdf);
  const schemaPositions = [];
  const sortedSchemaEntries = cloneDeep(schemaPage).sort((a, b) => a.position.y - b.position.y);
  const diffMap = /* @__PURE__ */ new Map();
  for (const schema of sortedSchemaEntries) {
    const { position: position3, width } = schema;
    const opt = { schema, basePdf, options, _cache: _cache2 };
    const value = (schema.readOnly ? schema.content : input?.[schema.name]) || "";
    const heights = await getDynamicHeights(value, opt);
    const heightsSum = heights.reduce((acc, cur) => acc + cur, 0);
    const originalHeight = schema.height;
    if (heightsSum !== originalHeight) {
      diffMap.set(position3.y + originalHeight, heightsSum - originalHeight);
    }
    heights.forEach((height, index3) => {
      let y = schema.position.y + heights.reduce((acc, cur, i) => i < index3 ? acc + cur : acc, 0);
      for (const [diffY, diff3] of diffMap.entries()) {
        if (diffY <= schema.position.y) {
          y += diff3;
        }
      }
      const node2 = createNode({ schema, position: { ...position3, y }, width, height });
      schemaPositions.push(y + height + basePdf.padding[2]);
      page.insertChild(node2);
    });
  }
  const pageHeight = Math.max(...schemaPositions, basePdf.height - basePdf.padding[2]);
  page.setHeight(pageHeight);
  resortChildren(page, orderMap);
  return page;
}
function breakIntoPages(arg) {
  const { longPage, orderMap, basePdf } = arg;
  const pages = [createPage(basePdf)];
  const [paddingTop, , paddingBottom] = basePdf.padding;
  const yAdjustments = [];
  const getPageHeight = (pageIndex) => basePdf.height - paddingBottom - (pageIndex > 0 ? paddingTop : 0);
  const calculateNewY = (y, pageIndex) => {
    const newY = y - pageIndex * (basePdf.height - paddingTop - paddingBottom);
    while (pages.length <= pageIndex) {
      if (!pages[pageIndex]) {
        pages.push(createPage(basePdf));
        yAdjustments.push({ page: pageIndex, value: (newY - paddingTop) * -1 });
      }
    }
    return newY + (yAdjustments.find((adj) => adj.page === pageIndex)?.value || 0);
  };
  const children = longPage.children.sort((a, b) => a.position.y - b.position.y);
  for (let i = 0; i < children.length; i++) {
    const { schema, position: position3, height, width } = children[i];
    const { y, x } = position3;
    let targetPageIndex = Math.floor(y / getPageHeight(pages.length - 1));
    let newY = calculateNewY(y, targetPageIndex);
    if (newY + height > basePdf.height - paddingBottom) {
      targetPageIndex++;
      newY = calculateNewY(y, targetPageIndex);
    }
    if (!schema)
      throw new Error("[@pdfme/common] schema is undefined");
    const clonedElement = createNode({ schema, position: { x, y: newY }, width, height });
    pages[targetPageIndex].insertChild(clonedElement);
  }
  pages.forEach((page) => resortChildren(page, orderMap));
  return pages;
}
function createNewTemplate(pages, basePdf) {
  const newTemplate = {
    schemas: Array.from({ length: pages.length }, () => []),
    basePdf
  };
  const nameToSchemas = /* @__PURE__ */ new Map();
  cloneDeep(pages).forEach((page, pageIndex) => {
    page.children.forEach((child) => {
      const { schema } = child;
      if (!schema)
        throw new Error("[@pdfme/common] schema is undefined");
      const name = schema.name;
      if (!nameToSchemas.has(name)) {
        nameToSchemas.set(name, []);
      }
      nameToSchemas.get(name).push(child);
      const sameNameSchemas = page.children.filter((c) => c.schema?.name === name);
      const start = nameToSchemas.get(name).length - sameNameSchemas.length;
      if (sameNameSchemas.length > 0) {
        if (!sameNameSchemas[0].schema) {
          throw new Error("[@pdfme/common] schema is undefined");
        }
        const schema2 = sameNameSchemas[0].schema;
        const height = sameNameSchemas.reduce((acc, cur) => acc + cur.height, 0);
        const position3 = sameNameSchemas[0].position;
        schema2.__bodyRange = {
          start: Math.max(start - 1, 0),
          end: start + sameNameSchemas.length - 1
        };
        schema2.__isSplit = start > 0;
        const newSchema = Object.assign({}, schema2, { position: position3, height });
        const index3 = newTemplate.schemas[pageIndex].findIndex((s) => s.name === name);
        if (index3 !== -1) {
          newTemplate.schemas[pageIndex][index3] = newSchema;
        } else {
          newTemplate.schemas[pageIndex].push(newSchema);
        }
      }
    });
  });
  return newTemplate;
}
var getDynamicTemplate = async (arg) => {
  const { template } = arg;
  if (!isBlankPdf(template.basePdf)) {
    return template;
  }
  const basePdf = template.basePdf;
  const pages = [];
  for (const schemaPage of template.schemas) {
    const orderMap = new Map(schemaPage.map((schema, index3) => [schema.name, index3]));
    const longPage = await createOnePage({ basePdf, schemaPage, orderMap, ...arg });
    const brokenPages = breakIntoPages({ longPage, basePdf, orderMap });
    pages.push(...brokenPages);
  }
  return createNewTemplate(pages, template.basePdf);
};

// ../../node_modules/acorn/dist/acorn.mjs
var astralIdentifierCodes = [509, 0, 227, 0, 150, 4, 294, 9, 1368, 2, 2, 1, 6, 3, 41, 2, 5, 0, 166, 1, 574, 3, 9, 9, 7, 9, 32, 4, 318, 1, 80, 3, 71, 10, 50, 3, 123, 2, 54, 14, 32, 10, 3, 1, 11, 3, 46, 10, 8, 0, 46, 9, 7, 2, 37, 13, 2, 9, 6, 1, 45, 0, 13, 2, 49, 13, 9, 3, 2, 11, 83, 11, 7, 0, 3, 0, 158, 11, 6, 9, 7, 3, 56, 1, 2, 6, 3, 1, 3, 2, 10, 0, 11, 1, 3, 6, 4, 4, 68, 8, 2, 0, 3, 0, 2, 3, 2, 4, 2, 0, 15, 1, 83, 17, 10, 9, 5, 0, 82, 19, 13, 9, 214, 6, 3, 8, 28, 1, 83, 16, 16, 9, 82, 12, 9, 9, 7, 19, 58, 14, 5, 9, 243, 14, 166, 9, 71, 5, 2, 1, 3, 3, 2, 0, 2, 1, 13, 9, 120, 6, 3, 6, 4, 0, 29, 9, 41, 6, 2, 3, 9, 0, 10, 10, 47, 15, 343, 9, 54, 7, 2, 7, 17, 9, 57, 21, 2, 13, 123, 5, 4, 0, 2, 1, 2, 6, 2, 0, 9, 9, 49, 4, 2, 1, 2, 4, 9, 9, 330, 3, 10, 1, 2, 0, 49, 6, 4, 4, 14, 10, 5350, 0, 7, 14, 11465, 27, 2343, 9, 87, 9, 39, 4, 60, 6, 26, 9, 535, 9, 470, 0, 2, 54, 8, 3, 82, 0, 12, 1, 19628, 1, 4178, 9, 519, 45, 3, 22, 543, 4, 4, 5, 9, 7, 3, 6, 31, 3, 149, 2, 1418, 49, 513, 54, 5, 49, 9, 0, 15, 0, 23, 4, 2, 14, 1361, 6, 2, 16, 3, 6, 2, 1, 2, 4, 101, 0, 161, 6, 10, 9, 357, 0, 62, 13, 499, 13, 245, 1, 2, 9, 726, 6, 110, 6, 6, 9, 4759, 9, 787719, 239];
var astralIdentifierStartCodes = [0, 11, 2, 25, 2, 18, 2, 1, 2, 14, 3, 13, 35, 122, 70, 52, 268, 28, 4, 48, 48, 31, 14, 29, 6, 37, 11, 29, 3, 35, 5, 7, 2, 4, 43, 157, 19, 35, 5, 35, 5, 39, 9, 51, 13, 10, 2, 14, 2, 6, 2, 1, 2, 10, 2, 14, 2, 6, 2, 1, 4, 51, 13, 310, 10, 21, 11, 7, 25, 5, 2, 41, 2, 8, 70, 5, 3, 0, 2, 43, 2, 1, 4, 0, 3, 22, 11, 22, 10, 30, 66, 18, 2, 1, 11, 21, 11, 25, 71, 55, 7, 1, 65, 0, 16, 3, 2, 2, 2, 28, 43, 28, 4, 28, 36, 7, 2, 27, 28, 53, 11, 21, 11, 18, 14, 17, 111, 72, 56, 50, 14, 50, 14, 35, 39, 27, 10, 22, 251, 41, 7, 1, 17, 2, 60, 28, 11, 0, 9, 21, 43, 17, 47, 20, 28, 22, 13, 52, 58, 1, 3, 0, 14, 44, 33, 24, 27, 35, 30, 0, 3, 0, 9, 34, 4, 0, 13, 47, 15, 3, 22, 0, 2, 0, 36, 17, 2, 24, 20, 1, 64, 6, 2, 0, 2, 3, 2, 14, 2, 9, 8, 46, 39, 7, 3, 1, 3, 21, 2, 6, 2, 1, 2, 4, 4, 0, 19, 0, 13, 4, 31, 9, 2, 0, 3, 0, 2, 37, 2, 0, 26, 0, 2, 0, 45, 52, 19, 3, 21, 2, 31, 47, 21, 1, 2, 0, 185, 46, 42, 3, 37, 47, 21, 0, 60, 42, 14, 0, 72, 26, 38, 6, 186, 43, 117, 63, 32, 7, 3, 0, 3, 7, 2, 1, 2, 23, 16, 0, 2, 0, 95, 7, 3, 38, 17, 0, 2, 0, 29, 0, 11, 39, 8, 0, 22, 0, 12, 45, 20, 0, 19, 72, 200, 32, 32, 8, 2, 36, 18, 0, 50, 29, 113, 6, 2, 1, 2, 37, 22, 0, 26, 5, 2, 1, 2, 31, 15, 0, 328, 18, 16, 0, 2, 12, 2, 33, 125, 0, 80, 921, 103, 110, 18, 195, 2637, 96, 16, 1071, 18, 5, 26, 3994, 6, 582, 6842, 29, 1763, 568, 8, 30, 18, 78, 18, 29, 19, 47, 17, 3, 32, 20, 6, 18, 433, 44, 212, 63, 129, 74, 6, 0, 67, 12, 65, 1, 2, 0, 29, 6135, 9, 1237, 42, 9, 8936, 3, 2, 6, 2, 1, 2, 290, 16, 0, 30, 2, 3, 0, 15, 3, 9, 395, 2309, 106, 6, 12, 4, 8, 8, 9, 5991, 84, 2, 70, 2, 1, 3, 0, 3, 1, 3, 3, 2, 11, 2, 0, 2, 6, 2, 64, 2, 3, 3, 7, 2, 6, 2, 27, 2, 3, 2, 4, 2, 0, 4, 6, 2, 339, 3, 24, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 7, 1845, 30, 7, 5, 262, 61, 147, 44, 11, 6, 17, 0, 322, 29, 19, 43, 485, 27, 229, 29, 3, 0, 496, 6, 2, 3, 2, 1, 2, 14, 2, 196, 60, 67, 8, 0, 1205, 3, 2, 26, 2, 1, 2, 0, 3, 0, 2, 9, 2, 3, 2, 0, 2, 0, 7, 0, 5, 0, 2, 0, 2, 0, 2, 2, 2, 1, 2, 0, 3, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 1, 2, 0, 3, 3, 2, 6, 2, 3, 2, 3, 2, 0, 2, 9, 2, 16, 6, 2, 2, 4, 2, 16, 4421, 42719, 33, 4153, 7, 221, 3, 5761, 15, 7472, 16, 621, 2467, 541, 1507, 4938, 6, 4191];
var nonASCIIidentifierChars = "\u200C\u200D\xB7\u0300-\u036F\u0387\u0483-\u0487\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u0669\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u06F0-\u06F9\u0711\u0730-\u074A\u07A6-\u07B0\u07C0-\u07C9\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u0897-\u089F\u08CA-\u08E1\u08E3-\u0903\u093A-\u093C\u093E-\u094F\u0951-\u0957\u0962\u0963\u0966-\u096F\u0981-\u0983\u09BC\u09BE-\u09C4\u09C7\u09C8\u09CB-\u09CD\u09D7\u09E2\u09E3\u09E6-\u09EF\u09FE\u0A01-\u0A03\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A66-\u0A71\u0A75\u0A81-\u0A83\u0ABC\u0ABE-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AE2\u0AE3\u0AE6-\u0AEF\u0AFA-\u0AFF\u0B01-\u0B03\u0B3C\u0B3E-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B55-\u0B57\u0B62\u0B63\u0B66-\u0B6F\u0B82\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD7\u0BE6-\u0BEF\u0C00-\u0C04\u0C3C\u0C3E-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C66-\u0C6F\u0C81-\u0C83\u0CBC\u0CBE-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0CE6-\u0CEF\u0CF3\u0D00-\u0D03\u0D3B\u0D3C\u0D3E-\u0D44\u0D46-\u0D48\u0D4A-\u0D4D\u0D57\u0D62\u0D63\u0D66-\u0D6F\u0D81-\u0D83\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0E50-\u0E59\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECE\u0ED0-\u0ED9\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E\u0F3F\u0F71-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102B-\u103E\u1040-\u1049\u1056-\u1059\u105E-\u1060\u1062-\u1064\u1067-\u106D\u1071-\u1074\u1082-\u108D\u108F-\u109D\u135D-\u135F\u1369-\u1371\u1712-\u1715\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4-\u17D3\u17DD\u17E0-\u17E9\u180B-\u180D\u180F-\u1819\u18A9\u1920-\u192B\u1930-\u193B\u1946-\u194F\u19D0-\u19DA\u1A17-\u1A1B\u1A55-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AB0-\u1ABD\u1ABF-\u1ACE\u1B00-\u1B04\u1B34-\u1B44\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1B82\u1BA1-\u1BAD\u1BB0-\u1BB9\u1BE6-\u1BF3\u1C24-\u1C37\u1C40-\u1C49\u1C50-\u1C59\u1CD0-\u1CD2\u1CD4-\u1CE8\u1CED\u1CF4\u1CF7-\u1CF9\u1DC0-\u1DFF\u200C\u200D\u203F\u2040\u2054\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\u30FB\uA620-\uA629\uA66F\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA823-\uA827\uA82C\uA880\uA881\uA8B4-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F1\uA8FF-\uA909\uA926-\uA92D\uA947-\uA953\uA980-\uA983\uA9B3-\uA9C0\uA9D0-\uA9D9\uA9E5\uA9F0-\uA9F9\uAA29-\uAA36\uAA43\uAA4C\uAA4D\uAA50-\uAA59\uAA7B-\uAA7D\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEB-\uAAEF\uAAF5\uAAF6\uABE3-\uABEA\uABEC\uABED\uABF0-\uABF9\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFF10-\uFF19\uFF3F\uFF65";
var nonASCIIidentifierStartChars = "\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088E\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5D\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C8A\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309B-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BF\u31F0-\u31FF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7CD\uA7D0\uA7D1\uA7D3\uA7D5-\uA7DC\uA7F2-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC";
var reservedWords = {
  3: "abstract boolean byte char class double enum export extends final float goto implements import int interface long native package private protected public short static super synchronized throws transient volatile",
  5: "class enum extends super const export import",
  6: "enum",
  strict: "implements interface let package private protected public static yield",
  strictBind: "eval arguments"
};
var ecma5AndLessKeywords = "break case catch continue debugger default do else finally for function if return switch throw try var while with null true false instanceof typeof void delete new in this";
var keywords$1 = {
  5: ecma5AndLessKeywords,
  "5module": ecma5AndLessKeywords + " export import",
  6: ecma5AndLessKeywords + " const class extends export import super"
};
var keywordRelationalOperator = /^in(stanceof)?$/;
var nonASCIIidentifierStart = new RegExp("[" + nonASCIIidentifierStartChars + "]");
var nonASCIIidentifier = new RegExp("[" + nonASCIIidentifierStartChars + nonASCIIidentifierChars + "]");
function isInAstralSet(code2, set4) {
  var pos = 65536;
  for (var i = 0; i < set4.length; i += 2) {
    pos += set4[i];
    if (pos > code2) {
      return false;
    }
    pos += set4[i + 1];
    if (pos >= code2) {
      return true;
    }
  }
  return false;
}
function isIdentifierStart(code2, astral) {
  if (code2 < 65) {
    return code2 === 36;
  }
  if (code2 < 91) {
    return true;
  }
  if (code2 < 97) {
    return code2 === 95;
  }
  if (code2 < 123) {
    return true;
  }
  if (code2 <= 65535) {
    return code2 >= 170 && nonASCIIidentifierStart.test(String.fromCharCode(code2));
  }
  if (astral === false) {
    return false;
  }
  return isInAstralSet(code2, astralIdentifierStartCodes);
}
function isIdentifierChar(code2, astral) {
  if (code2 < 48) {
    return code2 === 36;
  }
  if (code2 < 58) {
    return true;
  }
  if (code2 < 65) {
    return false;
  }
  if (code2 < 91) {
    return true;
  }
  if (code2 < 97) {
    return code2 === 95;
  }
  if (code2 < 123) {
    return true;
  }
  if (code2 <= 65535) {
    return code2 >= 170 && nonASCIIidentifier.test(String.fromCharCode(code2));
  }
  if (astral === false) {
    return false;
  }
  return isInAstralSet(code2, astralIdentifierStartCodes) || isInAstralSet(code2, astralIdentifierCodes);
}
var TokenType = function TokenType2(label, conf) {
  if (conf === void 0) conf = {};
  this.label = label;
  this.keyword = conf.keyword;
  this.beforeExpr = !!conf.beforeExpr;
  this.startsExpr = !!conf.startsExpr;
  this.isLoop = !!conf.isLoop;
  this.isAssign = !!conf.isAssign;
  this.prefix = !!conf.prefix;
  this.postfix = !!conf.postfix;
  this.binop = conf.binop || null;
  this.updateContext = null;
};
function binop(name, prec) {
  return new TokenType(name, { beforeExpr: true, binop: prec });
}
var beforeExpr = { beforeExpr: true };
var startsExpr = { startsExpr: true };
var keywords = {};
function kw(name, options) {
  if (options === void 0) options = {};
  options.keyword = name;
  return keywords[name] = new TokenType(name, options);
}
var types$1 = {
  num: new TokenType("num", startsExpr),
  regexp: new TokenType("regexp", startsExpr),
  string: new TokenType("string", startsExpr),
  name: new TokenType("name", startsExpr),
  privateId: new TokenType("privateId", startsExpr),
  eof: new TokenType("eof"),
  // Punctuation token types.
  bracketL: new TokenType("[", { beforeExpr: true, startsExpr: true }),
  bracketR: new TokenType("]"),
  braceL: new TokenType("{", { beforeExpr: true, startsExpr: true }),
  braceR: new TokenType("}"),
  parenL: new TokenType("(", { beforeExpr: true, startsExpr: true }),
  parenR: new TokenType(")"),
  comma: new TokenType(",", beforeExpr),
  semi: new TokenType(";", beforeExpr),
  colon: new TokenType(":", beforeExpr),
  dot: new TokenType("."),
  question: new TokenType("?", beforeExpr),
  questionDot: new TokenType("?."),
  arrow: new TokenType("=>", beforeExpr),
  template: new TokenType("template"),
  invalidTemplate: new TokenType("invalidTemplate"),
  ellipsis: new TokenType("...", beforeExpr),
  backQuote: new TokenType("`", startsExpr),
  dollarBraceL: new TokenType("${", { beforeExpr: true, startsExpr: true }),
  // Operators. These carry several kinds of properties to help the
  // parser use them properly (the presence of these properties is
  // what categorizes them as operators).
  //
  // `binop`, when present, specifies that this operator is a binary
  // operator, and will refer to its precedence.
  //
  // `prefix` and `postfix` mark the operator as a prefix or postfix
  // unary operator.
  //
  // `isAssign` marks all of `=`, `+=`, `-=` etcetera, which act as
  // binary operators with a very low precedence, that should result
  // in AssignmentExpression nodes.
  eq: new TokenType("=", { beforeExpr: true, isAssign: true }),
  assign: new TokenType("_=", { beforeExpr: true, isAssign: true }),
  incDec: new TokenType("++/--", { prefix: true, postfix: true, startsExpr: true }),
  prefix: new TokenType("!/~", { beforeExpr: true, prefix: true, startsExpr: true }),
  logicalOR: binop("||", 1),
  logicalAND: binop("&&", 2),
  bitwiseOR: binop("|", 3),
  bitwiseXOR: binop("^", 4),
  bitwiseAND: binop("&", 5),
  equality: binop("==/!=/===/!==", 6),
  relational: binop("</>/<=/>=", 7),
  bitShift: binop("<</>>/>>>", 8),
  plusMin: new TokenType("+/-", { beforeExpr: true, binop: 9, prefix: true, startsExpr: true }),
  modulo: binop("%", 10),
  star: binop("*", 10),
  slash: binop("/", 10),
  starstar: new TokenType("**", { beforeExpr: true }),
  coalesce: binop("??", 1),
  // Keyword token types.
  _break: kw("break"),
  _case: kw("case", beforeExpr),
  _catch: kw("catch"),
  _continue: kw("continue"),
  _debugger: kw("debugger"),
  _default: kw("default", beforeExpr),
  _do: kw("do", { isLoop: true, beforeExpr: true }),
  _else: kw("else", beforeExpr),
  _finally: kw("finally"),
  _for: kw("for", { isLoop: true }),
  _function: kw("function", startsExpr),
  _if: kw("if"),
  _return: kw("return", beforeExpr),
  _switch: kw("switch"),
  _throw: kw("throw", beforeExpr),
  _try: kw("try"),
  _var: kw("var"),
  _const: kw("const"),
  _while: kw("while", { isLoop: true }),
  _with: kw("with"),
  _new: kw("new", { beforeExpr: true, startsExpr: true }),
  _this: kw("this", startsExpr),
  _super: kw("super", startsExpr),
  _class: kw("class", startsExpr),
  _extends: kw("extends", beforeExpr),
  _export: kw("export"),
  _import: kw("import", startsExpr),
  _null: kw("null", startsExpr),
  _true: kw("true", startsExpr),
  _false: kw("false", startsExpr),
  _in: kw("in", { beforeExpr: true, binop: 7 }),
  _instanceof: kw("instanceof", { beforeExpr: true, binop: 7 }),
  _typeof: kw("typeof", { beforeExpr: true, prefix: true, startsExpr: true }),
  _void: kw("void", { beforeExpr: true, prefix: true, startsExpr: true }),
  _delete: kw("delete", { beforeExpr: true, prefix: true, startsExpr: true })
};
var lineBreak = /\r\n?|\n|\u2028|\u2029/;
var lineBreakG = new RegExp(lineBreak.source, "g");
function isNewLine(code2) {
  return code2 === 10 || code2 === 13 || code2 === 8232 || code2 === 8233;
}
function nextLineBreak(code2, from2, end) {
  if (end === void 0) end = code2.length;
  for (var i = from2; i < end; i++) {
    var next2 = code2.charCodeAt(i);
    if (isNewLine(next2)) {
      return i < end - 1 && next2 === 13 && code2.charCodeAt(i + 1) === 10 ? i + 2 : i + 1;
    }
  }
  return -1;
}
var nonASCIIwhitespace = /[\u1680\u2000-\u200a\u202f\u205f\u3000\ufeff]/;
var skipWhiteSpace = /(?:\s|\/\/.*|\/\*[^]*?\*\/)*/g;
var ref = Object.prototype;
var hasOwnProperty = ref.hasOwnProperty;
var toString = ref.toString;
var hasOwn = Object.hasOwn || (function(obj, propName) {
  return hasOwnProperty.call(obj, propName);
});
var isArray = Array.isArray || (function(obj) {
  return toString.call(obj) === "[object Array]";
});
var regexpCache = /* @__PURE__ */ Object.create(null);
function wordsRegexp(words) {
  return regexpCache[words] || (regexpCache[words] = new RegExp("^(?:" + words.replace(/ /g, "|") + ")$"));
}
function codePointToString(code2) {
  if (code2 <= 65535) {
    return String.fromCharCode(code2);
  }
  code2 -= 65536;
  return String.fromCharCode((code2 >> 10) + 55296, (code2 & 1023) + 56320);
}
var loneSurrogate = /(?:[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/;
var Position = function Position2(line2, col) {
  this.line = line2;
  this.column = col;
};
Position.prototype.offset = function offset(n2) {
  return new Position(this.line, this.column + n2);
};
var SourceLocation = function SourceLocation2(p, start, end) {
  this.start = start;
  this.end = end;
  if (p.sourceFile !== null) {
    this.source = p.sourceFile;
  }
};
function getLineInfo(input, offset4) {
  for (var line2 = 1, cur = 0; ; ) {
    var nextBreak = nextLineBreak(input, cur, offset4);
    if (nextBreak < 0) {
      return new Position(line2, offset4 - cur);
    }
    ++line2;
    cur = nextBreak;
  }
}
var defaultOptions = {
  // `ecmaVersion` indicates the ECMAScript version to parse. Must be
  // either 3, 5, 6 (or 2015), 7 (2016), 8 (2017), 9 (2018), 10
  // (2019), 11 (2020), 12 (2021), 13 (2022), 14 (2023), or `"latest"`
  // (the latest version the library supports). This influences
  // support for strict mode, the set of reserved words, and support
  // for new syntax features.
  ecmaVersion: null,
  // `sourceType` indicates the mode the code should be parsed in.
  // Can be either `"script"` or `"module"`. This influences global
  // strict mode and parsing of `import` and `export` declarations.
  sourceType: "script",
  // `onInsertedSemicolon` can be a callback that will be called when
  // a semicolon is automatically inserted. It will be passed the
  // position of the inserted semicolon as an offset, and if
  // `locations` is enabled, it is given the location as a `{line,
  // column}` object as second argument.
  onInsertedSemicolon: null,
  // `onTrailingComma` is similar to `onInsertedSemicolon`, but for
  // trailing commas.
  onTrailingComma: null,
  // By default, reserved words are only enforced if ecmaVersion >= 5.
  // Set `allowReserved` to a boolean value to explicitly turn this on
  // an off. When this option has the value "never", reserved words
  // and keywords can also not be used as property names.
  allowReserved: null,
  // When enabled, a return at the top level is not considered an
  // error.
  allowReturnOutsideFunction: false,
  // When enabled, import/export statements are not constrained to
  // appearing at the top of the program, and an import.meta expression
  // in a script isn't considered an error.
  allowImportExportEverywhere: false,
  // By default, await identifiers are allowed to appear at the top-level scope only if ecmaVersion >= 2022.
  // When enabled, await identifiers are allowed to appear at the top-level scope,
  // but they are still not allowed in non-async functions.
  allowAwaitOutsideFunction: null,
  // When enabled, super identifiers are not constrained to
  // appearing in methods and do not raise an error when they appear elsewhere.
  allowSuperOutsideMethod: null,
  // When enabled, hashbang directive in the beginning of file is
  // allowed and treated as a line comment. Enabled by default when
  // `ecmaVersion` >= 2023.
  allowHashBang: false,
  // By default, the parser will verify that private properties are
  // only used in places where they are valid and have been declared.
  // Set this to false to turn such checks off.
  checkPrivateFields: true,
  // When `locations` is on, `loc` properties holding objects with
  // `start` and `end` properties in `{line, column}` form (with
  // line being 1-based and column 0-based) will be attached to the
  // nodes.
  locations: false,
  // A function can be passed as `onToken` option, which will
  // cause Acorn to call that function with object in the same
  // format as tokens returned from `tokenizer().getToken()`. Note
  // that you are not allowed to call the parser from the
  // callback—that will corrupt its internal state.
  onToken: null,
  // A function can be passed as `onComment` option, which will
  // cause Acorn to call that function with `(block, text, start,
  // end)` parameters whenever a comment is skipped. `block` is a
  // boolean indicating whether this is a block (`/* */`) comment,
  // `text` is the content of the comment, and `start` and `end` are
  // character offsets that denote the start and end of the comment.
  // When the `locations` option is on, two more parameters are
  // passed, the full `{line, column}` locations of the start and
  // end of the comments. Note that you are not allowed to call the
  // parser from the callback—that will corrupt its internal state.
  // When this option has an array as value, objects representing the
  // comments are pushed to it.
  onComment: null,
  // Nodes have their start and end characters offsets recorded in
  // `start` and `end` properties (directly on the node, rather than
  // the `loc` object, which holds line/column data. To also add a
  // [semi-standardized][range] `range` property holding a `[start,
  // end]` array with the same numbers, set the `ranges` option to
  // `true`.
  //
  // [range]: https://bugzilla.mozilla.org/show_bug.cgi?id=745678
  ranges: false,
  // It is possible to parse multiple files into a single AST by
  // passing the tree produced by parsing the first file as
  // `program` option in subsequent parses. This will add the
  // toplevel forms of the parsed file to the `Program` (top) node
  // of an existing parse tree.
  program: null,
  // When `locations` is on, you can pass this to record the source
  // file in every node's `loc` object.
  sourceFile: null,
  // This value, if given, is stored in every node, whether
  // `locations` is on or off.
  directSourceFile: null,
  // When enabled, parenthesized expressions are represented by
  // (non-standard) ParenthesizedExpression nodes
  preserveParens: false
};
var warnedAboutEcmaVersion = false;
function getOptions(opts) {
  var options = {};
  for (var opt in defaultOptions) {
    options[opt] = opts && hasOwn(opts, opt) ? opts[opt] : defaultOptions[opt];
  }
  if (options.ecmaVersion === "latest") {
    options.ecmaVersion = 1e8;
  } else if (options.ecmaVersion == null) {
    if (!warnedAboutEcmaVersion && typeof console === "object" && console.warn) {
      warnedAboutEcmaVersion = true;
      console.warn("Since Acorn 8.0.0, options.ecmaVersion is required.\nDefaulting to 2020, but this will stop working in the future.");
    }
    options.ecmaVersion = 11;
  } else if (options.ecmaVersion >= 2015) {
    options.ecmaVersion -= 2009;
  }
  if (options.allowReserved == null) {
    options.allowReserved = options.ecmaVersion < 5;
  }
  if (!opts || opts.allowHashBang == null) {
    options.allowHashBang = options.ecmaVersion >= 14;
  }
  if (isArray(options.onToken)) {
    var tokens = options.onToken;
    options.onToken = function(token2) {
      return tokens.push(token2);
    };
  }
  if (isArray(options.onComment)) {
    options.onComment = pushComment(options, options.onComment);
  }
  return options;
}
function pushComment(options, array4) {
  return function(block, text, start, end, startLoc, endLoc) {
    var comment2 = {
      type: block ? "Block" : "Line",
      value: text,
      start,
      end
    };
    if (options.locations) {
      comment2.loc = new SourceLocation(this, startLoc, endLoc);
    }
    if (options.ranges) {
      comment2.range = [start, end];
    }
    array4.push(comment2);
  };
}
var SCOPE_TOP = 1;
var SCOPE_FUNCTION = 2;
var SCOPE_ASYNC = 4;
var SCOPE_GENERATOR = 8;
var SCOPE_ARROW = 16;
var SCOPE_SIMPLE_CATCH = 32;
var SCOPE_SUPER = 64;
var SCOPE_DIRECT_SUPER = 128;
var SCOPE_CLASS_STATIC_BLOCK = 256;
var SCOPE_CLASS_FIELD_INIT = 512;
var SCOPE_VAR = SCOPE_TOP | SCOPE_FUNCTION | SCOPE_CLASS_STATIC_BLOCK;
function functionFlags(async, generator) {
  return SCOPE_FUNCTION | (async ? SCOPE_ASYNC : 0) | (generator ? SCOPE_GENERATOR : 0);
}
var BIND_NONE = 0;
var BIND_VAR = 1;
var BIND_LEXICAL = 2;
var BIND_FUNCTION = 3;
var BIND_SIMPLE_CATCH = 4;
var BIND_OUTSIDE = 5;
var Parser = function Parser2(options, input, startPos) {
  this.options = options = getOptions(options);
  this.sourceFile = options.sourceFile;
  this.keywords = wordsRegexp(keywords$1[options.ecmaVersion >= 6 ? 6 : options.sourceType === "module" ? "5module" : 5]);
  var reserved = "";
  if (options.allowReserved !== true) {
    reserved = reservedWords[options.ecmaVersion >= 6 ? 6 : options.ecmaVersion === 5 ? 5 : 3];
    if (options.sourceType === "module") {
      reserved += " await";
    }
  }
  this.reservedWords = wordsRegexp(reserved);
  var reservedStrict = (reserved ? reserved + " " : "") + reservedWords.strict;
  this.reservedWordsStrict = wordsRegexp(reservedStrict);
  this.reservedWordsStrictBind = wordsRegexp(reservedStrict + " " + reservedWords.strictBind);
  this.input = String(input);
  this.containsEsc = false;
  if (startPos) {
    this.pos = startPos;
    this.lineStart = this.input.lastIndexOf("\n", startPos - 1) + 1;
    this.curLine = this.input.slice(0, this.lineStart).split(lineBreak).length;
  } else {
    this.pos = this.lineStart = 0;
    this.curLine = 1;
  }
  this.type = types$1.eof;
  this.value = null;
  this.start = this.end = this.pos;
  this.startLoc = this.endLoc = this.curPosition();
  this.lastTokEndLoc = this.lastTokStartLoc = null;
  this.lastTokStart = this.lastTokEnd = this.pos;
  this.context = this.initialContext();
  this.exprAllowed = true;
  this.inModule = options.sourceType === "module";
  this.strict = this.inModule || this.strictDirective(this.pos);
  this.potentialArrowAt = -1;
  this.potentialArrowInForAwait = false;
  this.yieldPos = this.awaitPos = this.awaitIdentPos = 0;
  this.labels = [];
  this.undefinedExports = /* @__PURE__ */ Object.create(null);
  if (this.pos === 0 && options.allowHashBang && this.input.slice(0, 2) === "#!") {
    this.skipLineComment(2);
  }
  this.scopeStack = [];
  this.enterScope(SCOPE_TOP);
  this.regexpState = null;
  this.privateNameStack = [];
};
var prototypeAccessors = { inFunction: { configurable: true }, inGenerator: { configurable: true }, inAsync: { configurable: true }, canAwait: { configurable: true }, allowSuper: { configurable: true }, allowDirectSuper: { configurable: true }, treatFunctionsAsVar: { configurable: true }, allowNewDotTarget: { configurable: true }, inClassStaticBlock: { configurable: true } };
Parser.prototype.parse = function parse() {
  var node2 = this.options.program || this.startNode();
  this.nextToken();
  return this.parseTopLevel(node2);
};
prototypeAccessors.inFunction.get = function() {
  return (this.currentVarScope().flags & SCOPE_FUNCTION) > 0;
};
prototypeAccessors.inGenerator.get = function() {
  return (this.currentVarScope().flags & SCOPE_GENERATOR) > 0;
};
prototypeAccessors.inAsync.get = function() {
  return (this.currentVarScope().flags & SCOPE_ASYNC) > 0;
};
prototypeAccessors.canAwait.get = function() {
  for (var i = this.scopeStack.length - 1; i >= 0; i--) {
    var ref3 = this.scopeStack[i];
    var flags = ref3.flags;
    if (flags & (SCOPE_CLASS_STATIC_BLOCK | SCOPE_CLASS_FIELD_INIT)) {
      return false;
    }
    if (flags & SCOPE_FUNCTION) {
      return (flags & SCOPE_ASYNC) > 0;
    }
  }
  return this.inModule && this.options.ecmaVersion >= 13 || this.options.allowAwaitOutsideFunction;
};
prototypeAccessors.allowSuper.get = function() {
  var ref3 = this.currentThisScope();
  var flags = ref3.flags;
  return (flags & SCOPE_SUPER) > 0 || this.options.allowSuperOutsideMethod;
};
prototypeAccessors.allowDirectSuper.get = function() {
  return (this.currentThisScope().flags & SCOPE_DIRECT_SUPER) > 0;
};
prototypeAccessors.treatFunctionsAsVar.get = function() {
  return this.treatFunctionsAsVarInScope(this.currentScope());
};
prototypeAccessors.allowNewDotTarget.get = function() {
  for (var i = this.scopeStack.length - 1; i >= 0; i--) {
    var ref3 = this.scopeStack[i];
    var flags = ref3.flags;
    if (flags & (SCOPE_CLASS_STATIC_BLOCK | SCOPE_CLASS_FIELD_INIT) || flags & SCOPE_FUNCTION && !(flags & SCOPE_ARROW)) {
      return true;
    }
  }
  return false;
};
prototypeAccessors.inClassStaticBlock.get = function() {
  return (this.currentVarScope().flags & SCOPE_CLASS_STATIC_BLOCK) > 0;
};
Parser.extend = function extend() {
  var plugins = [], len = arguments.length;
  while (len--) plugins[len] = arguments[len];
  var cls11 = this;
  for (var i = 0; i < plugins.length; i++) {
    cls11 = plugins[i](cls11);
  }
  return cls11;
};
Parser.parse = function parse2(input, options) {
  return new this(options, input).parse();
};
Parser.parseExpressionAt = function parseExpressionAt(input, pos, options) {
  var parser = new this(options, input, pos);
  parser.nextToken();
  return parser.parseExpression();
};
Parser.tokenizer = function tokenizer(input, options) {
  return new this(options, input);
};
Object.defineProperties(Parser.prototype, prototypeAccessors);
var pp$9 = Parser.prototype;
var literal = /^(?:'((?:\\[^]|[^'\\])*?)'|"((?:\\[^]|[^"\\])*?)")/;
pp$9.strictDirective = function(start) {
  if (this.options.ecmaVersion < 5) {
    return false;
  }
  for (; ; ) {
    skipWhiteSpace.lastIndex = start;
    start += skipWhiteSpace.exec(this.input)[0].length;
    var match2 = literal.exec(this.input.slice(start));
    if (!match2) {
      return false;
    }
    if ((match2[1] || match2[2]) === "use strict") {
      skipWhiteSpace.lastIndex = start + match2[0].length;
      var spaceAfter = skipWhiteSpace.exec(this.input), end = spaceAfter.index + spaceAfter[0].length;
      var next2 = this.input.charAt(end);
      return next2 === ";" || next2 === "}" || lineBreak.test(spaceAfter[0]) && !(/[(`.[+\-/*%<>=,?^&]/.test(next2) || next2 === "!" && this.input.charAt(end + 1) === "=");
    }
    start += match2[0].length;
    skipWhiteSpace.lastIndex = start;
    start += skipWhiteSpace.exec(this.input)[0].length;
    if (this.input[start] === ";") {
      start++;
    }
  }
};
pp$9.eat = function(type5) {
  if (this.type === type5) {
    this.next();
    return true;
  } else {
    return false;
  }
};
pp$9.isContextual = function(name) {
  return this.type === types$1.name && this.value === name && !this.containsEsc;
};
pp$9.eatContextual = function(name) {
  if (!this.isContextual(name)) {
    return false;
  }
  this.next();
  return true;
};
pp$9.expectContextual = function(name) {
  if (!this.eatContextual(name)) {
    this.unexpected();
  }
};
pp$9.canInsertSemicolon = function() {
  return this.type === types$1.eof || this.type === types$1.braceR || lineBreak.test(this.input.slice(this.lastTokEnd, this.start));
};
pp$9.insertSemicolon = function() {
  if (this.canInsertSemicolon()) {
    if (this.options.onInsertedSemicolon) {
      this.options.onInsertedSemicolon(this.lastTokEnd, this.lastTokEndLoc);
    }
    return true;
  }
};
pp$9.semicolon = function() {
  if (!this.eat(types$1.semi) && !this.insertSemicolon()) {
    this.unexpected();
  }
};
pp$9.afterTrailingComma = function(tokType, notNext) {
  if (this.type === tokType) {
    if (this.options.onTrailingComma) {
      this.options.onTrailingComma(this.lastTokStart, this.lastTokStartLoc);
    }
    if (!notNext) {
      this.next();
    }
    return true;
  }
};
pp$9.expect = function(type5) {
  this.eat(type5) || this.unexpected();
};
pp$9.unexpected = function(pos) {
  this.raise(pos != null ? pos : this.start, "Unexpected token");
};
var DestructuringErrors = function DestructuringErrors2() {
  this.shorthandAssign = this.trailingComma = this.parenthesizedAssign = this.parenthesizedBind = this.doubleProto = -1;
};
pp$9.checkPatternErrors = function(refDestructuringErrors, isAssign) {
  if (!refDestructuringErrors) {
    return;
  }
  if (refDestructuringErrors.trailingComma > -1) {
    this.raiseRecoverable(refDestructuringErrors.trailingComma, "Comma is not permitted after the rest element");
  }
  var parens = isAssign ? refDestructuringErrors.parenthesizedAssign : refDestructuringErrors.parenthesizedBind;
  if (parens > -1) {
    this.raiseRecoverable(parens, isAssign ? "Assigning to rvalue" : "Parenthesized pattern");
  }
};
pp$9.checkExpressionErrors = function(refDestructuringErrors, andThrow) {
  if (!refDestructuringErrors) {
    return false;
  }
  var shorthandAssign = refDestructuringErrors.shorthandAssign;
  var doubleProto = refDestructuringErrors.doubleProto;
  if (!andThrow) {
    return shorthandAssign >= 0 || doubleProto >= 0;
  }
  if (shorthandAssign >= 0) {
    this.raise(shorthandAssign, "Shorthand property assignments are valid only in destructuring patterns");
  }
  if (doubleProto >= 0) {
    this.raiseRecoverable(doubleProto, "Redefinition of __proto__ property");
  }
};
pp$9.checkYieldAwaitInDefaultParams = function() {
  if (this.yieldPos && (!this.awaitPos || this.yieldPos < this.awaitPos)) {
    this.raise(this.yieldPos, "Yield expression cannot be a default value");
  }
  if (this.awaitPos) {
    this.raise(this.awaitPos, "Await expression cannot be a default value");
  }
};
pp$9.isSimpleAssignTarget = function(expr) {
  if (expr.type === "ParenthesizedExpression") {
    return this.isSimpleAssignTarget(expr.expression);
  }
  return expr.type === "Identifier" || expr.type === "MemberExpression";
};
var pp$8 = Parser.prototype;
pp$8.parseTopLevel = function(node2) {
  var exports2 = /* @__PURE__ */ Object.create(null);
  if (!node2.body) {
    node2.body = [];
  }
  while (this.type !== types$1.eof) {
    var stmt = this.parseStatement(null, true, exports2);
    node2.body.push(stmt);
  }
  if (this.inModule) {
    for (var i = 0, list = Object.keys(this.undefinedExports); i < list.length; i += 1) {
      var name = list[i];
      this.raiseRecoverable(this.undefinedExports[name].start, "Export '" + name + "' is not defined");
    }
  }
  this.adaptDirectivePrologue(node2.body);
  this.next();
  node2.sourceType = this.options.sourceType;
  return this.finishNode(node2, "Program");
};
var loopLabel = { kind: "loop" };
var switchLabel = { kind: "switch" };
pp$8.isLet = function(context) {
  if (this.options.ecmaVersion < 6 || !this.isContextual("let")) {
    return false;
  }
  skipWhiteSpace.lastIndex = this.pos;
  var skip = skipWhiteSpace.exec(this.input);
  var next2 = this.pos + skip[0].length, nextCh = this.input.charCodeAt(next2);
  if (nextCh === 91 || nextCh === 92) {
    return true;
  }
  if (context) {
    return false;
  }
  if (nextCh === 123 || nextCh > 55295 && nextCh < 56320) {
    return true;
  }
  if (isIdentifierStart(nextCh, true)) {
    var pos = next2 + 1;
    while (isIdentifierChar(nextCh = this.input.charCodeAt(pos), true)) {
      ++pos;
    }
    if (nextCh === 92 || nextCh > 55295 && nextCh < 56320) {
      return true;
    }
    var ident = this.input.slice(next2, pos);
    if (!keywordRelationalOperator.test(ident)) {
      return true;
    }
  }
  return false;
};
pp$8.isAsyncFunction = function() {
  if (this.options.ecmaVersion < 8 || !this.isContextual("async")) {
    return false;
  }
  skipWhiteSpace.lastIndex = this.pos;
  var skip = skipWhiteSpace.exec(this.input);
  var next2 = this.pos + skip[0].length, after;
  return !lineBreak.test(this.input.slice(this.pos, next2)) && this.input.slice(next2, next2 + 8) === "function" && (next2 + 8 === this.input.length || !(isIdentifierChar(after = this.input.charCodeAt(next2 + 8)) || after > 55295 && after < 56320));
};
pp$8.isUsingKeyword = function(isAwaitUsing, isFor) {
  if (this.options.ecmaVersion < 17 || !this.isContextual(isAwaitUsing ? "await" : "using")) {
    return false;
  }
  skipWhiteSpace.lastIndex = this.pos;
  var skip = skipWhiteSpace.exec(this.input);
  var next2 = this.pos + skip[0].length;
  if (lineBreak.test(this.input.slice(this.pos, next2))) {
    return false;
  }
  if (isAwaitUsing) {
    var awaitEndPos = next2 + 5, after;
    if (this.input.slice(next2, awaitEndPos) !== "using" || awaitEndPos === this.input.length || isIdentifierChar(after = this.input.charCodeAt(awaitEndPos)) || after > 55295 && after < 56320) {
      return false;
    }
    skipWhiteSpace.lastIndex = awaitEndPos;
    var skipAfterUsing = skipWhiteSpace.exec(this.input);
    if (skipAfterUsing && lineBreak.test(this.input.slice(awaitEndPos, awaitEndPos + skipAfterUsing[0].length))) {
      return false;
    }
  }
  if (isFor) {
    var ofEndPos = next2 + 2, after$1;
    if (this.input.slice(next2, ofEndPos) === "of") {
      if (ofEndPos === this.input.length || !isIdentifierChar(after$1 = this.input.charCodeAt(ofEndPos)) && !(after$1 > 55295 && after$1 < 56320)) {
        return false;
      }
    }
  }
  var ch = this.input.charCodeAt(next2);
  return isIdentifierStart(ch, true) || ch === 92;
};
pp$8.isAwaitUsing = function(isFor) {
  return this.isUsingKeyword(true, isFor);
};
pp$8.isUsing = function(isFor) {
  return this.isUsingKeyword(false, isFor);
};
pp$8.parseStatement = function(context, topLevel, exports2) {
  var starttype = this.type, node2 = this.startNode(), kind;
  if (this.isLet(context)) {
    starttype = types$1._var;
    kind = "let";
  }
  switch (starttype) {
    case types$1._break:
    case types$1._continue:
      return this.parseBreakContinueStatement(node2, starttype.keyword);
    case types$1._debugger:
      return this.parseDebuggerStatement(node2);
    case types$1._do:
      return this.parseDoStatement(node2);
    case types$1._for:
      return this.parseForStatement(node2);
    case types$1._function:
      if (context && (this.strict || context !== "if" && context !== "label") && this.options.ecmaVersion >= 6) {
        this.unexpected();
      }
      return this.parseFunctionStatement(node2, false, !context);
    case types$1._class:
      if (context) {
        this.unexpected();
      }
      return this.parseClass(node2, true);
    case types$1._if:
      return this.parseIfStatement(node2);
    case types$1._return:
      return this.parseReturnStatement(node2);
    case types$1._switch:
      return this.parseSwitchStatement(node2);
    case types$1._throw:
      return this.parseThrowStatement(node2);
    case types$1._try:
      return this.parseTryStatement(node2);
    case types$1._const:
    case types$1._var:
      kind = kind || this.value;
      if (context && kind !== "var") {
        this.unexpected();
      }
      return this.parseVarStatement(node2, kind);
    case types$1._while:
      return this.parseWhileStatement(node2);
    case types$1._with:
      return this.parseWithStatement(node2);
    case types$1.braceL:
      return this.parseBlock(true, node2);
    case types$1.semi:
      return this.parseEmptyStatement(node2);
    case types$1._export:
    case types$1._import:
      if (this.options.ecmaVersion > 10 && starttype === types$1._import) {
        skipWhiteSpace.lastIndex = this.pos;
        var skip = skipWhiteSpace.exec(this.input);
        var next2 = this.pos + skip[0].length, nextCh = this.input.charCodeAt(next2);
        if (nextCh === 40 || nextCh === 46) {
          return this.parseExpressionStatement(node2, this.parseExpression());
        }
      }
      if (!this.options.allowImportExportEverywhere) {
        if (!topLevel) {
          this.raise(this.start, "'import' and 'export' may only appear at the top level");
        }
        if (!this.inModule) {
          this.raise(this.start, "'import' and 'export' may appear only with 'sourceType: module'");
        }
      }
      return starttype === types$1._import ? this.parseImport(node2) : this.parseExport(node2, exports2);
    // If the statement does not start with a statement keyword or a
    // brace, it's an ExpressionStatement or LabeledStatement. We
    // simply start parsing an expression, and afterwards, if the
    // next token is a colon and the expression was a simple
    // Identifier node, we switch to interpreting it as a label.
    default:
      if (this.isAsyncFunction()) {
        if (context) {
          this.unexpected();
        }
        this.next();
        return this.parseFunctionStatement(node2, true, !context);
      }
      var usingKind = this.isAwaitUsing(false) ? "await using" : this.isUsing(false) ? "using" : null;
      if (usingKind) {
        if (topLevel && this.options.sourceType === "script") {
          this.raise(this.start, "Using declaration cannot appear in the top level when source type is `script`");
        }
        if (usingKind === "await using") {
          if (!this.canAwait) {
            this.raise(this.start, "Await using cannot appear outside of async function");
          }
          this.next();
        }
        this.next();
        this.parseVar(node2, false, usingKind);
        this.semicolon();
        return this.finishNode(node2, "VariableDeclaration");
      }
      var maybeName = this.value, expr = this.parseExpression();
      if (starttype === types$1.name && expr.type === "Identifier" && this.eat(types$1.colon)) {
        return this.parseLabeledStatement(node2, maybeName, expr, context);
      } else {
        return this.parseExpressionStatement(node2, expr);
      }
  }
};
pp$8.parseBreakContinueStatement = function(node2, keyword) {
  var isBreak = keyword === "break";
  this.next();
  if (this.eat(types$1.semi) || this.insertSemicolon()) {
    node2.label = null;
  } else if (this.type !== types$1.name) {
    this.unexpected();
  } else {
    node2.label = this.parseIdent();
    this.semicolon();
  }
  var i = 0;
  for (; i < this.labels.length; ++i) {
    var lab = this.labels[i];
    if (node2.label == null || lab.name === node2.label.name) {
      if (lab.kind != null && (isBreak || lab.kind === "loop")) {
        break;
      }
      if (node2.label && isBreak) {
        break;
      }
    }
  }
  if (i === this.labels.length) {
    this.raise(node2.start, "Unsyntactic " + keyword);
  }
  return this.finishNode(node2, isBreak ? "BreakStatement" : "ContinueStatement");
};
pp$8.parseDebuggerStatement = function(node2) {
  this.next();
  this.semicolon();
  return this.finishNode(node2, "DebuggerStatement");
};
pp$8.parseDoStatement = function(node2) {
  this.next();
  this.labels.push(loopLabel);
  node2.body = this.parseStatement("do");
  this.labels.pop();
  this.expect(types$1._while);
  node2.test = this.parseParenExpression();
  if (this.options.ecmaVersion >= 6) {
    this.eat(types$1.semi);
  } else {
    this.semicolon();
  }
  return this.finishNode(node2, "DoWhileStatement");
};
pp$8.parseForStatement = function(node2) {
  this.next();
  var awaitAt = this.options.ecmaVersion >= 9 && this.canAwait && this.eatContextual("await") ? this.lastTokStart : -1;
  this.labels.push(loopLabel);
  this.enterScope(0);
  this.expect(types$1.parenL);
  if (this.type === types$1.semi) {
    if (awaitAt > -1) {
      this.unexpected(awaitAt);
    }
    return this.parseFor(node2, null);
  }
  var isLet = this.isLet();
  if (this.type === types$1._var || this.type === types$1._const || isLet) {
    var init$1 = this.startNode(), kind = isLet ? "let" : this.value;
    this.next();
    this.parseVar(init$1, true, kind);
    this.finishNode(init$1, "VariableDeclaration");
    return this.parseForAfterInit(node2, init$1, awaitAt);
  }
  var startsWithLet = this.isContextual("let"), isForOf = false;
  var usingKind = this.isUsing(true) ? "using" : this.isAwaitUsing(true) ? "await using" : null;
  if (usingKind) {
    var init$2 = this.startNode();
    this.next();
    if (usingKind === "await using") {
      this.next();
    }
    this.parseVar(init$2, true, usingKind);
    this.finishNode(init$2, "VariableDeclaration");
    return this.parseForAfterInit(node2, init$2, awaitAt);
  }
  var containsEsc = this.containsEsc;
  var refDestructuringErrors = new DestructuringErrors();
  var initPos = this.start;
  var init2 = awaitAt > -1 ? this.parseExprSubscripts(refDestructuringErrors, "await") : this.parseExpression(true, refDestructuringErrors);
  if (this.type === types$1._in || (isForOf = this.options.ecmaVersion >= 6 && this.isContextual("of"))) {
    if (awaitAt > -1) {
      if (this.type === types$1._in) {
        this.unexpected(awaitAt);
      }
      node2.await = true;
    } else if (isForOf && this.options.ecmaVersion >= 8) {
      if (init2.start === initPos && !containsEsc && init2.type === "Identifier" && init2.name === "async") {
        this.unexpected();
      } else if (this.options.ecmaVersion >= 9) {
        node2.await = false;
      }
    }
    if (startsWithLet && isForOf) {
      this.raise(init2.start, "The left-hand side of a for-of loop may not start with 'let'.");
    }
    this.toAssignable(init2, false, refDestructuringErrors);
    this.checkLValPattern(init2);
    return this.parseForIn(node2, init2);
  } else {
    this.checkExpressionErrors(refDestructuringErrors, true);
  }
  if (awaitAt > -1) {
    this.unexpected(awaitAt);
  }
  return this.parseFor(node2, init2);
};
pp$8.parseForAfterInit = function(node2, init2, awaitAt) {
  if ((this.type === types$1._in || this.options.ecmaVersion >= 6 && this.isContextual("of")) && init2.declarations.length === 1) {
    if (this.options.ecmaVersion >= 9) {
      if (this.type === types$1._in) {
        if (awaitAt > -1) {
          this.unexpected(awaitAt);
        }
      } else {
        node2.await = awaitAt > -1;
      }
    }
    return this.parseForIn(node2, init2);
  }
  if (awaitAt > -1) {
    this.unexpected(awaitAt);
  }
  return this.parseFor(node2, init2);
};
pp$8.parseFunctionStatement = function(node2, isAsync2, declarationPosition) {
  this.next();
  return this.parseFunction(node2, FUNC_STATEMENT | (declarationPosition ? 0 : FUNC_HANGING_STATEMENT), false, isAsync2);
};
pp$8.parseIfStatement = function(node2) {
  this.next();
  node2.test = this.parseParenExpression();
  node2.consequent = this.parseStatement("if");
  node2.alternate = this.eat(types$1._else) ? this.parseStatement("if") : null;
  return this.finishNode(node2, "IfStatement");
};
pp$8.parseReturnStatement = function(node2) {
  if (!this.inFunction && !this.options.allowReturnOutsideFunction) {
    this.raise(this.start, "'return' outside of function");
  }
  this.next();
  if (this.eat(types$1.semi) || this.insertSemicolon()) {
    node2.argument = null;
  } else {
    node2.argument = this.parseExpression();
    this.semicolon();
  }
  return this.finishNode(node2, "ReturnStatement");
};
pp$8.parseSwitchStatement = function(node2) {
  this.next();
  node2.discriminant = this.parseParenExpression();
  node2.cases = [];
  this.expect(types$1.braceL);
  this.labels.push(switchLabel);
  this.enterScope(0);
  var cur;
  for (var sawDefault = false; this.type !== types$1.braceR; ) {
    if (this.type === types$1._case || this.type === types$1._default) {
      var isCase = this.type === types$1._case;
      if (cur) {
        this.finishNode(cur, "SwitchCase");
      }
      node2.cases.push(cur = this.startNode());
      cur.consequent = [];
      this.next();
      if (isCase) {
        cur.test = this.parseExpression();
      } else {
        if (sawDefault) {
          this.raiseRecoverable(this.lastTokStart, "Multiple default clauses");
        }
        sawDefault = true;
        cur.test = null;
      }
      this.expect(types$1.colon);
    } else {
      if (!cur) {
        this.unexpected();
      }
      cur.consequent.push(this.parseStatement(null));
    }
  }
  this.exitScope();
  if (cur) {
    this.finishNode(cur, "SwitchCase");
  }
  this.next();
  this.labels.pop();
  return this.finishNode(node2, "SwitchStatement");
};
pp$8.parseThrowStatement = function(node2) {
  this.next();
  if (lineBreak.test(this.input.slice(this.lastTokEnd, this.start))) {
    this.raise(this.lastTokEnd, "Illegal newline after throw");
  }
  node2.argument = this.parseExpression();
  this.semicolon();
  return this.finishNode(node2, "ThrowStatement");
};
var empty$1 = [];
pp$8.parseCatchClauseParam = function() {
  var param = this.parseBindingAtom();
  var simple = param.type === "Identifier";
  this.enterScope(simple ? SCOPE_SIMPLE_CATCH : 0);
  this.checkLValPattern(param, simple ? BIND_SIMPLE_CATCH : BIND_LEXICAL);
  this.expect(types$1.parenR);
  return param;
};
pp$8.parseTryStatement = function(node2) {
  this.next();
  node2.block = this.parseBlock();
  node2.handler = null;
  if (this.type === types$1._catch) {
    var clause = this.startNode();
    this.next();
    if (this.eat(types$1.parenL)) {
      clause.param = this.parseCatchClauseParam();
    } else {
      if (this.options.ecmaVersion < 10) {
        this.unexpected();
      }
      clause.param = null;
      this.enterScope(0);
    }
    clause.body = this.parseBlock(false);
    this.exitScope();
    node2.handler = this.finishNode(clause, "CatchClause");
  }
  node2.finalizer = this.eat(types$1._finally) ? this.parseBlock() : null;
  if (!node2.handler && !node2.finalizer) {
    this.raise(node2.start, "Missing catch or finally clause");
  }
  return this.finishNode(node2, "TryStatement");
};
pp$8.parseVarStatement = function(node2, kind, allowMissingInitializer) {
  this.next();
  this.parseVar(node2, false, kind, allowMissingInitializer);
  this.semicolon();
  return this.finishNode(node2, "VariableDeclaration");
};
pp$8.parseWhileStatement = function(node2) {
  this.next();
  node2.test = this.parseParenExpression();
  this.labels.push(loopLabel);
  node2.body = this.parseStatement("while");
  this.labels.pop();
  return this.finishNode(node2, "WhileStatement");
};
pp$8.parseWithStatement = function(node2) {
  if (this.strict) {
    this.raise(this.start, "'with' in strict mode");
  }
  this.next();
  node2.object = this.parseParenExpression();
  node2.body = this.parseStatement("with");
  return this.finishNode(node2, "WithStatement");
};
pp$8.parseEmptyStatement = function(node2) {
  this.next();
  return this.finishNode(node2, "EmptyStatement");
};
pp$8.parseLabeledStatement = function(node2, maybeName, expr, context) {
  for (var i$1 = 0, list = this.labels; i$1 < list.length; i$1 += 1) {
    var label = list[i$1];
    if (label.name === maybeName) {
      this.raise(expr.start, "Label '" + maybeName + "' is already declared");
    }
  }
  var kind = this.type.isLoop ? "loop" : this.type === types$1._switch ? "switch" : null;
  for (var i = this.labels.length - 1; i >= 0; i--) {
    var label$1 = this.labels[i];
    if (label$1.statementStart === node2.start) {
      label$1.statementStart = this.start;
      label$1.kind = kind;
    } else {
      break;
    }
  }
  this.labels.push({ name: maybeName, kind, statementStart: this.start });
  node2.body = this.parseStatement(context ? context.indexOf("label") === -1 ? context + "label" : context : "label");
  this.labels.pop();
  node2.label = expr;
  return this.finishNode(node2, "LabeledStatement");
};
pp$8.parseExpressionStatement = function(node2, expr) {
  node2.expression = expr;
  this.semicolon();
  return this.finishNode(node2, "ExpressionStatement");
};
pp$8.parseBlock = function(createNewLexicalScope, node2, exitStrict) {
  if (createNewLexicalScope === void 0) createNewLexicalScope = true;
  if (node2 === void 0) node2 = this.startNode();
  node2.body = [];
  this.expect(types$1.braceL);
  if (createNewLexicalScope) {
    this.enterScope(0);
  }
  while (this.type !== types$1.braceR) {
    var stmt = this.parseStatement(null);
    node2.body.push(stmt);
  }
  if (exitStrict) {
    this.strict = false;
  }
  this.next();
  if (createNewLexicalScope) {
    this.exitScope();
  }
  return this.finishNode(node2, "BlockStatement");
};
pp$8.parseFor = function(node2, init2) {
  node2.init = init2;
  this.expect(types$1.semi);
  node2.test = this.type === types$1.semi ? null : this.parseExpression();
  this.expect(types$1.semi);
  node2.update = this.type === types$1.parenR ? null : this.parseExpression();
  this.expect(types$1.parenR);
  node2.body = this.parseStatement("for");
  this.exitScope();
  this.labels.pop();
  return this.finishNode(node2, "ForStatement");
};
pp$8.parseForIn = function(node2, init2) {
  var isForIn = this.type === types$1._in;
  this.next();
  if (init2.type === "VariableDeclaration" && init2.declarations[0].init != null && (!isForIn || this.options.ecmaVersion < 8 || this.strict || init2.kind !== "var" || init2.declarations[0].id.type !== "Identifier")) {
    this.raise(
      init2.start,
      (isForIn ? "for-in" : "for-of") + " loop variable declaration may not have an initializer"
    );
  }
  node2.left = init2;
  node2.right = isForIn ? this.parseExpression() : this.parseMaybeAssign();
  this.expect(types$1.parenR);
  node2.body = this.parseStatement("for");
  this.exitScope();
  this.labels.pop();
  return this.finishNode(node2, isForIn ? "ForInStatement" : "ForOfStatement");
};
pp$8.parseVar = function(node2, isFor, kind, allowMissingInitializer) {
  node2.declarations = [];
  node2.kind = kind;
  for (; ; ) {
    var decl = this.startNode();
    this.parseVarId(decl, kind);
    if (this.eat(types$1.eq)) {
      decl.init = this.parseMaybeAssign(isFor);
    } else if (!allowMissingInitializer && kind === "const" && !(this.type === types$1._in || this.options.ecmaVersion >= 6 && this.isContextual("of"))) {
      this.unexpected();
    } else if (!allowMissingInitializer && (kind === "using" || kind === "await using") && this.options.ecmaVersion >= 17 && this.type !== types$1._in && !this.isContextual("of")) {
      this.raise(this.lastTokEnd, "Missing initializer in " + kind + " declaration");
    } else if (!allowMissingInitializer && decl.id.type !== "Identifier" && !(isFor && (this.type === types$1._in || this.isContextual("of")))) {
      this.raise(this.lastTokEnd, "Complex binding patterns require an initialization value");
    } else {
      decl.init = null;
    }
    node2.declarations.push(this.finishNode(decl, "VariableDeclarator"));
    if (!this.eat(types$1.comma)) {
      break;
    }
  }
  return node2;
};
pp$8.parseVarId = function(decl, kind) {
  decl.id = kind === "using" || kind === "await using" ? this.parseIdent() : this.parseBindingAtom();
  this.checkLValPattern(decl.id, kind === "var" ? BIND_VAR : BIND_LEXICAL, false);
};
var FUNC_STATEMENT = 1;
var FUNC_HANGING_STATEMENT = 2;
var FUNC_NULLABLE_ID = 4;
pp$8.parseFunction = function(node2, statement, allowExpressionBody, isAsync2, forInit) {
  this.initFunction(node2);
  if (this.options.ecmaVersion >= 9 || this.options.ecmaVersion >= 6 && !isAsync2) {
    if (this.type === types$1.star && statement & FUNC_HANGING_STATEMENT) {
      this.unexpected();
    }
    node2.generator = this.eat(types$1.star);
  }
  if (this.options.ecmaVersion >= 8) {
    node2.async = !!isAsync2;
  }
  if (statement & FUNC_STATEMENT) {
    node2.id = statement & FUNC_NULLABLE_ID && this.type !== types$1.name ? null : this.parseIdent();
    if (node2.id && !(statement & FUNC_HANGING_STATEMENT)) {
      this.checkLValSimple(node2.id, this.strict || node2.generator || node2.async ? this.treatFunctionsAsVar ? BIND_VAR : BIND_LEXICAL : BIND_FUNCTION);
    }
  }
  var oldYieldPos = this.yieldPos, oldAwaitPos = this.awaitPos, oldAwaitIdentPos = this.awaitIdentPos;
  this.yieldPos = 0;
  this.awaitPos = 0;
  this.awaitIdentPos = 0;
  this.enterScope(functionFlags(node2.async, node2.generator));
  if (!(statement & FUNC_STATEMENT)) {
    node2.id = this.type === types$1.name ? this.parseIdent() : null;
  }
  this.parseFunctionParams(node2);
  this.parseFunctionBody(node2, allowExpressionBody, false, forInit);
  this.yieldPos = oldYieldPos;
  this.awaitPos = oldAwaitPos;
  this.awaitIdentPos = oldAwaitIdentPos;
  return this.finishNode(node2, statement & FUNC_STATEMENT ? "FunctionDeclaration" : "FunctionExpression");
};
pp$8.parseFunctionParams = function(node2) {
  this.expect(types$1.parenL);
  node2.params = this.parseBindingList(types$1.parenR, false, this.options.ecmaVersion >= 8);
  this.checkYieldAwaitInDefaultParams();
};
pp$8.parseClass = function(node2, isStatement) {
  this.next();
  var oldStrict = this.strict;
  this.strict = true;
  this.parseClassId(node2, isStatement);
  this.parseClassSuper(node2);
  var privateNameMap = this.enterClassBody();
  var classBody = this.startNode();
  var hadConstructor = false;
  classBody.body = [];
  this.expect(types$1.braceL);
  while (this.type !== types$1.braceR) {
    var element = this.parseClassElement(node2.superClass !== null);
    if (element) {
      classBody.body.push(element);
      if (element.type === "MethodDefinition" && element.kind === "constructor") {
        if (hadConstructor) {
          this.raiseRecoverable(element.start, "Duplicate constructor in the same class");
        }
        hadConstructor = true;
      } else if (element.key && element.key.type === "PrivateIdentifier" && isPrivateNameConflicted(privateNameMap, element)) {
        this.raiseRecoverable(element.key.start, "Identifier '#" + element.key.name + "' has already been declared");
      }
    }
  }
  this.strict = oldStrict;
  this.next();
  node2.body = this.finishNode(classBody, "ClassBody");
  this.exitClassBody();
  return this.finishNode(node2, isStatement ? "ClassDeclaration" : "ClassExpression");
};
pp$8.parseClassElement = function(constructorAllowsSuper) {
  if (this.eat(types$1.semi)) {
    return null;
  }
  var ecmaVersion = this.options.ecmaVersion;
  var node2 = this.startNode();
  var keyName = "";
  var isGenerator = false;
  var isAsync2 = false;
  var kind = "method";
  var isStatic = false;
  if (this.eatContextual("static")) {
    if (ecmaVersion >= 13 && this.eat(types$1.braceL)) {
      this.parseClassStaticBlock(node2);
      return node2;
    }
    if (this.isClassElementNameStart() || this.type === types$1.star) {
      isStatic = true;
    } else {
      keyName = "static";
    }
  }
  node2.static = isStatic;
  if (!keyName && ecmaVersion >= 8 && this.eatContextual("async")) {
    if ((this.isClassElementNameStart() || this.type === types$1.star) && !this.canInsertSemicolon()) {
      isAsync2 = true;
    } else {
      keyName = "async";
    }
  }
  if (!keyName && (ecmaVersion >= 9 || !isAsync2) && this.eat(types$1.star)) {
    isGenerator = true;
  }
  if (!keyName && !isAsync2 && !isGenerator) {
    var lastValue = this.value;
    if (this.eatContextual("get") || this.eatContextual("set")) {
      if (this.isClassElementNameStart()) {
        kind = lastValue;
      } else {
        keyName = lastValue;
      }
    }
  }
  if (keyName) {
    node2.computed = false;
    node2.key = this.startNodeAt(this.lastTokStart, this.lastTokStartLoc);
    node2.key.name = keyName;
    this.finishNode(node2.key, "Identifier");
  } else {
    this.parseClassElementName(node2);
  }
  if (ecmaVersion < 13 || this.type === types$1.parenL || kind !== "method" || isGenerator || isAsync2) {
    var isConstructor = !node2.static && checkKeyName(node2, "constructor");
    var allowsDirectSuper = isConstructor && constructorAllowsSuper;
    if (isConstructor && kind !== "method") {
      this.raise(node2.key.start, "Constructor can't have get/set modifier");
    }
    node2.kind = isConstructor ? "constructor" : kind;
    this.parseClassMethod(node2, isGenerator, isAsync2, allowsDirectSuper);
  } else {
    this.parseClassField(node2);
  }
  return node2;
};
pp$8.isClassElementNameStart = function() {
  return this.type === types$1.name || this.type === types$1.privateId || this.type === types$1.num || this.type === types$1.string || this.type === types$1.bracketL || this.type.keyword;
};
pp$8.parseClassElementName = function(element) {
  if (this.type === types$1.privateId) {
    if (this.value === "constructor") {
      this.raise(this.start, "Classes can't have an element named '#constructor'");
    }
    element.computed = false;
    element.key = this.parsePrivateIdent();
  } else {
    this.parsePropertyName(element);
  }
};
pp$8.parseClassMethod = function(method4, isGenerator, isAsync2, allowsDirectSuper) {
  var key2 = method4.key;
  if (method4.kind === "constructor") {
    if (isGenerator) {
      this.raise(key2.start, "Constructor can't be a generator");
    }
    if (isAsync2) {
      this.raise(key2.start, "Constructor can't be an async method");
    }
  } else if (method4.static && checkKeyName(method4, "prototype")) {
    this.raise(key2.start, "Classes may not have a static property named prototype");
  }
  var value = method4.value = this.parseMethod(isGenerator, isAsync2, allowsDirectSuper);
  if (method4.kind === "get" && value.params.length !== 0) {
    this.raiseRecoverable(value.start, "getter should have no params");
  }
  if (method4.kind === "set" && value.params.length !== 1) {
    this.raiseRecoverable(value.start, "setter should have exactly one param");
  }
  if (method4.kind === "set" && value.params[0].type === "RestElement") {
    this.raiseRecoverable(value.params[0].start, "Setter cannot use rest params");
  }
  return this.finishNode(method4, "MethodDefinition");
};
pp$8.parseClassField = function(field) {
  if (checkKeyName(field, "constructor")) {
    this.raise(field.key.start, "Classes can't have a field named 'constructor'");
  } else if (field.static && checkKeyName(field, "prototype")) {
    this.raise(field.key.start, "Classes can't have a static field named 'prototype'");
  }
  if (this.eat(types$1.eq)) {
    this.enterScope(SCOPE_CLASS_FIELD_INIT | SCOPE_SUPER);
    field.value = this.parseMaybeAssign();
    this.exitScope();
  } else {
    field.value = null;
  }
  this.semicolon();
  return this.finishNode(field, "PropertyDefinition");
};
pp$8.parseClassStaticBlock = function(node2) {
  node2.body = [];
  var oldLabels = this.labels;
  this.labels = [];
  this.enterScope(SCOPE_CLASS_STATIC_BLOCK | SCOPE_SUPER);
  while (this.type !== types$1.braceR) {
    var stmt = this.parseStatement(null);
    node2.body.push(stmt);
  }
  this.next();
  this.exitScope();
  this.labels = oldLabels;
  return this.finishNode(node2, "StaticBlock");
};
pp$8.parseClassId = function(node2, isStatement) {
  if (this.type === types$1.name) {
    node2.id = this.parseIdent();
    if (isStatement) {
      this.checkLValSimple(node2.id, BIND_LEXICAL, false);
    }
  } else {
    if (isStatement === true) {
      this.unexpected();
    }
    node2.id = null;
  }
};
pp$8.parseClassSuper = function(node2) {
  node2.superClass = this.eat(types$1._extends) ? this.parseExprSubscripts(null, false) : null;
};
pp$8.enterClassBody = function() {
  var element = { declared: /* @__PURE__ */ Object.create(null), used: [] };
  this.privateNameStack.push(element);
  return element.declared;
};
pp$8.exitClassBody = function() {
  var ref3 = this.privateNameStack.pop();
  var declared = ref3.declared;
  var used = ref3.used;
  if (!this.options.checkPrivateFields) {
    return;
  }
  var len = this.privateNameStack.length;
  var parent2 = len === 0 ? null : this.privateNameStack[len - 1];
  for (var i = 0; i < used.length; ++i) {
    var id = used[i];
    if (!hasOwn(declared, id.name)) {
      if (parent2) {
        parent2.used.push(id);
      } else {
        this.raiseRecoverable(id.start, "Private field '#" + id.name + "' must be declared in an enclosing class");
      }
    }
  }
};
function isPrivateNameConflicted(privateNameMap, element) {
  var name = element.key.name;
  var curr = privateNameMap[name];
  var next2 = "true";
  if (element.type === "MethodDefinition" && (element.kind === "get" || element.kind === "set")) {
    next2 = (element.static ? "s" : "i") + element.kind;
  }
  if (curr === "iget" && next2 === "iset" || curr === "iset" && next2 === "iget" || curr === "sget" && next2 === "sset" || curr === "sset" && next2 === "sget") {
    privateNameMap[name] = "true";
    return false;
  } else if (!curr) {
    privateNameMap[name] = next2;
    return false;
  } else {
    return true;
  }
}
function checkKeyName(node2, name) {
  var computed = node2.computed;
  var key2 = node2.key;
  return !computed && (key2.type === "Identifier" && key2.name === name || key2.type === "Literal" && key2.value === name);
}
pp$8.parseExportAllDeclaration = function(node2, exports2) {
  if (this.options.ecmaVersion >= 11) {
    if (this.eatContextual("as")) {
      node2.exported = this.parseModuleExportName();
      this.checkExport(exports2, node2.exported, this.lastTokStart);
    } else {
      node2.exported = null;
    }
  }
  this.expectContextual("from");
  if (this.type !== types$1.string) {
    this.unexpected();
  }
  node2.source = this.parseExprAtom();
  if (this.options.ecmaVersion >= 16) {
    node2.attributes = this.parseWithClause();
  }
  this.semicolon();
  return this.finishNode(node2, "ExportAllDeclaration");
};
pp$8.parseExport = function(node2, exports2) {
  this.next();
  if (this.eat(types$1.star)) {
    return this.parseExportAllDeclaration(node2, exports2);
  }
  if (this.eat(types$1._default)) {
    this.checkExport(exports2, "default", this.lastTokStart);
    node2.declaration = this.parseExportDefaultDeclaration();
    return this.finishNode(node2, "ExportDefaultDeclaration");
  }
  if (this.shouldParseExportStatement()) {
    node2.declaration = this.parseExportDeclaration(node2);
    if (node2.declaration.type === "VariableDeclaration") {
      this.checkVariableExport(exports2, node2.declaration.declarations);
    } else {
      this.checkExport(exports2, node2.declaration.id, node2.declaration.id.start);
    }
    node2.specifiers = [];
    node2.source = null;
    if (this.options.ecmaVersion >= 16) {
      node2.attributes = [];
    }
  } else {
    node2.declaration = null;
    node2.specifiers = this.parseExportSpecifiers(exports2);
    if (this.eatContextual("from")) {
      if (this.type !== types$1.string) {
        this.unexpected();
      }
      node2.source = this.parseExprAtom();
      if (this.options.ecmaVersion >= 16) {
        node2.attributes = this.parseWithClause();
      }
    } else {
      for (var i = 0, list = node2.specifiers; i < list.length; i += 1) {
        var spec = list[i];
        this.checkUnreserved(spec.local);
        this.checkLocalExport(spec.local);
        if (spec.local.type === "Literal") {
          this.raise(spec.local.start, "A string literal cannot be used as an exported binding without `from`.");
        }
      }
      node2.source = null;
      if (this.options.ecmaVersion >= 16) {
        node2.attributes = [];
      }
    }
    this.semicolon();
  }
  return this.finishNode(node2, "ExportNamedDeclaration");
};
pp$8.parseExportDeclaration = function(node2) {
  return this.parseStatement(null);
};
pp$8.parseExportDefaultDeclaration = function() {
  var isAsync2;
  if (this.type === types$1._function || (isAsync2 = this.isAsyncFunction())) {
    var fNode = this.startNode();
    this.next();
    if (isAsync2) {
      this.next();
    }
    return this.parseFunction(fNode, FUNC_STATEMENT | FUNC_NULLABLE_ID, false, isAsync2);
  } else if (this.type === types$1._class) {
    var cNode = this.startNode();
    return this.parseClass(cNode, "nullableID");
  } else {
    var declaration2 = this.parseMaybeAssign();
    this.semicolon();
    return declaration2;
  }
};
pp$8.checkExport = function(exports2, name, pos) {
  if (!exports2) {
    return;
  }
  if (typeof name !== "string") {
    name = name.type === "Identifier" ? name.name : name.value;
  }
  if (hasOwn(exports2, name)) {
    this.raiseRecoverable(pos, "Duplicate export '" + name + "'");
  }
  exports2[name] = true;
};
pp$8.checkPatternExport = function(exports2, pat) {
  var type5 = pat.type;
  if (type5 === "Identifier") {
    this.checkExport(exports2, pat, pat.start);
  } else if (type5 === "ObjectPattern") {
    for (var i = 0, list = pat.properties; i < list.length; i += 1) {
      var prop = list[i];
      this.checkPatternExport(exports2, prop);
    }
  } else if (type5 === "ArrayPattern") {
    for (var i$1 = 0, list$1 = pat.elements; i$1 < list$1.length; i$1 += 1) {
      var elt = list$1[i$1];
      if (elt) {
        this.checkPatternExport(exports2, elt);
      }
    }
  } else if (type5 === "Property") {
    this.checkPatternExport(exports2, pat.value);
  } else if (type5 === "AssignmentPattern") {
    this.checkPatternExport(exports2, pat.left);
  } else if (type5 === "RestElement") {
    this.checkPatternExport(exports2, pat.argument);
  }
};
pp$8.checkVariableExport = function(exports2, decls) {
  if (!exports2) {
    return;
  }
  for (var i = 0, list = decls; i < list.length; i += 1) {
    var decl = list[i];
    this.checkPatternExport(exports2, decl.id);
  }
};
pp$8.shouldParseExportStatement = function() {
  return this.type.keyword === "var" || this.type.keyword === "const" || this.type.keyword === "class" || this.type.keyword === "function" || this.isLet() || this.isAsyncFunction();
};
pp$8.parseExportSpecifier = function(exports2) {
  var node2 = this.startNode();
  node2.local = this.parseModuleExportName();
  node2.exported = this.eatContextual("as") ? this.parseModuleExportName() : node2.local;
  this.checkExport(
    exports2,
    node2.exported,
    node2.exported.start
  );
  return this.finishNode(node2, "ExportSpecifier");
};
pp$8.parseExportSpecifiers = function(exports2) {
  var nodes = [], first = true;
  this.expect(types$1.braceL);
  while (!this.eat(types$1.braceR)) {
    if (!first) {
      this.expect(types$1.comma);
      if (this.afterTrailingComma(types$1.braceR)) {
        break;
      }
    } else {
      first = false;
    }
    nodes.push(this.parseExportSpecifier(exports2));
  }
  return nodes;
};
pp$8.parseImport = function(node2) {
  this.next();
  if (this.type === types$1.string) {
    node2.specifiers = empty$1;
    node2.source = this.parseExprAtom();
  } else {
    node2.specifiers = this.parseImportSpecifiers();
    this.expectContextual("from");
    node2.source = this.type === types$1.string ? this.parseExprAtom() : this.unexpected();
  }
  if (this.options.ecmaVersion >= 16) {
    node2.attributes = this.parseWithClause();
  }
  this.semicolon();
  return this.finishNode(node2, "ImportDeclaration");
};
pp$8.parseImportSpecifier = function() {
  var node2 = this.startNode();
  node2.imported = this.parseModuleExportName();
  if (this.eatContextual("as")) {
    node2.local = this.parseIdent();
  } else {
    this.checkUnreserved(node2.imported);
    node2.local = node2.imported;
  }
  this.checkLValSimple(node2.local, BIND_LEXICAL);
  return this.finishNode(node2, "ImportSpecifier");
};
pp$8.parseImportDefaultSpecifier = function() {
  var node2 = this.startNode();
  node2.local = this.parseIdent();
  this.checkLValSimple(node2.local, BIND_LEXICAL);
  return this.finishNode(node2, "ImportDefaultSpecifier");
};
pp$8.parseImportNamespaceSpecifier = function() {
  var node2 = this.startNode();
  this.next();
  this.expectContextual("as");
  node2.local = this.parseIdent();
  this.checkLValSimple(node2.local, BIND_LEXICAL);
  return this.finishNode(node2, "ImportNamespaceSpecifier");
};
pp$8.parseImportSpecifiers = function() {
  var nodes = [], first = true;
  if (this.type === types$1.name) {
    nodes.push(this.parseImportDefaultSpecifier());
    if (!this.eat(types$1.comma)) {
      return nodes;
    }
  }
  if (this.type === types$1.star) {
    nodes.push(this.parseImportNamespaceSpecifier());
    return nodes;
  }
  this.expect(types$1.braceL);
  while (!this.eat(types$1.braceR)) {
    if (!first) {
      this.expect(types$1.comma);
      if (this.afterTrailingComma(types$1.braceR)) {
        break;
      }
    } else {
      first = false;
    }
    nodes.push(this.parseImportSpecifier());
  }
  return nodes;
};
pp$8.parseWithClause = function() {
  var nodes = [];
  if (!this.eat(types$1._with)) {
    return nodes;
  }
  this.expect(types$1.braceL);
  var attributeKeys = {};
  var first = true;
  while (!this.eat(types$1.braceR)) {
    if (!first) {
      this.expect(types$1.comma);
      if (this.afterTrailingComma(types$1.braceR)) {
        break;
      }
    } else {
      first = false;
    }
    var attr = this.parseImportAttribute();
    var keyName = attr.key.type === "Identifier" ? attr.key.name : attr.key.value;
    if (hasOwn(attributeKeys, keyName)) {
      this.raiseRecoverable(attr.key.start, "Duplicate attribute key '" + keyName + "'");
    }
    attributeKeys[keyName] = true;
    nodes.push(attr);
  }
  return nodes;
};
pp$8.parseImportAttribute = function() {
  var node2 = this.startNode();
  node2.key = this.type === types$1.string ? this.parseExprAtom() : this.parseIdent(this.options.allowReserved !== "never");
  this.expect(types$1.colon);
  if (this.type !== types$1.string) {
    this.unexpected();
  }
  node2.value = this.parseExprAtom();
  return this.finishNode(node2, "ImportAttribute");
};
pp$8.parseModuleExportName = function() {
  if (this.options.ecmaVersion >= 13 && this.type === types$1.string) {
    var stringLiteral = this.parseLiteral(this.value);
    if (loneSurrogate.test(stringLiteral.value)) {
      this.raise(stringLiteral.start, "An export name cannot include a lone surrogate.");
    }
    return stringLiteral;
  }
  return this.parseIdent(true);
};
pp$8.adaptDirectivePrologue = function(statements) {
  for (var i = 0; i < statements.length && this.isDirectiveCandidate(statements[i]); ++i) {
    statements[i].directive = statements[i].expression.raw.slice(1, -1);
  }
};
pp$8.isDirectiveCandidate = function(statement) {
  return this.options.ecmaVersion >= 5 && statement.type === "ExpressionStatement" && statement.expression.type === "Literal" && typeof statement.expression.value === "string" && // Reject parenthesized strings.
  (this.input[statement.start] === '"' || this.input[statement.start] === "'");
};
var pp$7 = Parser.prototype;
pp$7.toAssignable = function(node2, isBinding, refDestructuringErrors) {
  if (this.options.ecmaVersion >= 6 && node2) {
    switch (node2.type) {
      case "Identifier":
        if (this.inAsync && node2.name === "await") {
          this.raise(node2.start, "Cannot use 'await' as identifier inside an async function");
        }
        break;
      case "ObjectPattern":
      case "ArrayPattern":
      case "AssignmentPattern":
      case "RestElement":
        break;
      case "ObjectExpression":
        node2.type = "ObjectPattern";
        if (refDestructuringErrors) {
          this.checkPatternErrors(refDestructuringErrors, true);
        }
        for (var i = 0, list = node2.properties; i < list.length; i += 1) {
          var prop = list[i];
          this.toAssignable(prop, isBinding);
          if (prop.type === "RestElement" && (prop.argument.type === "ArrayPattern" || prop.argument.type === "ObjectPattern")) {
            this.raise(prop.argument.start, "Unexpected token");
          }
        }
        break;
      case "Property":
        if (node2.kind !== "init") {
          this.raise(node2.key.start, "Object pattern can't contain getter or setter");
        }
        this.toAssignable(node2.value, isBinding);
        break;
      case "ArrayExpression":
        node2.type = "ArrayPattern";
        if (refDestructuringErrors) {
          this.checkPatternErrors(refDestructuringErrors, true);
        }
        this.toAssignableList(node2.elements, isBinding);
        break;
      case "SpreadElement":
        node2.type = "RestElement";
        this.toAssignable(node2.argument, isBinding);
        if (node2.argument.type === "AssignmentPattern") {
          this.raise(node2.argument.start, "Rest elements cannot have a default value");
        }
        break;
      case "AssignmentExpression":
        if (node2.operator !== "=") {
          this.raise(node2.left.end, "Only '=' operator can be used for specifying default value.");
        }
        node2.type = "AssignmentPattern";
        delete node2.operator;
        this.toAssignable(node2.left, isBinding);
        break;
      case "ParenthesizedExpression":
        this.toAssignable(node2.expression, isBinding, refDestructuringErrors);
        break;
      case "ChainExpression":
        this.raiseRecoverable(node2.start, "Optional chaining cannot appear in left-hand side");
        break;
      case "MemberExpression":
        if (!isBinding) {
          break;
        }
      default:
        this.raise(node2.start, "Assigning to rvalue");
    }
  } else if (refDestructuringErrors) {
    this.checkPatternErrors(refDestructuringErrors, true);
  }
  return node2;
};
pp$7.toAssignableList = function(exprList, isBinding) {
  var end = exprList.length;
  for (var i = 0; i < end; i++) {
    var elt = exprList[i];
    if (elt) {
      this.toAssignable(elt, isBinding);
    }
  }
  if (end) {
    var last2 = exprList[end - 1];
    if (this.options.ecmaVersion === 6 && isBinding && last2 && last2.type === "RestElement" && last2.argument.type !== "Identifier") {
      this.unexpected(last2.argument.start);
    }
  }
  return exprList;
};
pp$7.parseSpread = function(refDestructuringErrors) {
  var node2 = this.startNode();
  this.next();
  node2.argument = this.parseMaybeAssign(false, refDestructuringErrors);
  return this.finishNode(node2, "SpreadElement");
};
pp$7.parseRestBinding = function() {
  var node2 = this.startNode();
  this.next();
  if (this.options.ecmaVersion === 6 && this.type !== types$1.name) {
    this.unexpected();
  }
  node2.argument = this.parseBindingAtom();
  return this.finishNode(node2, "RestElement");
};
pp$7.parseBindingAtom = function() {
  if (this.options.ecmaVersion >= 6) {
    switch (this.type) {
      case types$1.bracketL:
        var node2 = this.startNode();
        this.next();
        node2.elements = this.parseBindingList(types$1.bracketR, true, true);
        return this.finishNode(node2, "ArrayPattern");
      case types$1.braceL:
        return this.parseObj(true);
    }
  }
  return this.parseIdent();
};
pp$7.parseBindingList = function(close, allowEmpty, allowTrailingComma, allowModifiers) {
  var elts = [], first = true;
  while (!this.eat(close)) {
    if (first) {
      first = false;
    } else {
      this.expect(types$1.comma);
    }
    if (allowEmpty && this.type === types$1.comma) {
      elts.push(null);
    } else if (allowTrailingComma && this.afterTrailingComma(close)) {
      break;
    } else if (this.type === types$1.ellipsis) {
      var rest = this.parseRestBinding();
      this.parseBindingListItem(rest);
      elts.push(rest);
      if (this.type === types$1.comma) {
        this.raiseRecoverable(this.start, "Comma is not permitted after the rest element");
      }
      this.expect(close);
      break;
    } else {
      elts.push(this.parseAssignableListItem(allowModifiers));
    }
  }
  return elts;
};
pp$7.parseAssignableListItem = function(allowModifiers) {
  var elem = this.parseMaybeDefault(this.start, this.startLoc);
  this.parseBindingListItem(elem);
  return elem;
};
pp$7.parseBindingListItem = function(param) {
  return param;
};
pp$7.parseMaybeDefault = function(startPos, startLoc, left2) {
  left2 = left2 || this.parseBindingAtom();
  if (this.options.ecmaVersion < 6 || !this.eat(types$1.eq)) {
    return left2;
  }
  var node2 = this.startNodeAt(startPos, startLoc);
  node2.left = left2;
  node2.right = this.parseMaybeAssign();
  return this.finishNode(node2, "AssignmentPattern");
};
pp$7.checkLValSimple = function(expr, bindingType, checkClashes) {
  if (bindingType === void 0) bindingType = BIND_NONE;
  var isBind = bindingType !== BIND_NONE;
  switch (expr.type) {
    case "Identifier":
      if (this.strict && this.reservedWordsStrictBind.test(expr.name)) {
        this.raiseRecoverable(expr.start, (isBind ? "Binding " : "Assigning to ") + expr.name + " in strict mode");
      }
      if (isBind) {
        if (bindingType === BIND_LEXICAL && expr.name === "let") {
          this.raiseRecoverable(expr.start, "let is disallowed as a lexically bound name");
        }
        if (checkClashes) {
          if (hasOwn(checkClashes, expr.name)) {
            this.raiseRecoverable(expr.start, "Argument name clash");
          }
          checkClashes[expr.name] = true;
        }
        if (bindingType !== BIND_OUTSIDE) {
          this.declareName(expr.name, bindingType, expr.start);
        }
      }
      break;
    case "ChainExpression":
      this.raiseRecoverable(expr.start, "Optional chaining cannot appear in left-hand side");
      break;
    case "MemberExpression":
      if (isBind) {
        this.raiseRecoverable(expr.start, "Binding member expression");
      }
      break;
    case "ParenthesizedExpression":
      if (isBind) {
        this.raiseRecoverable(expr.start, "Binding parenthesized expression");
      }
      return this.checkLValSimple(expr.expression, bindingType, checkClashes);
    default:
      this.raise(expr.start, (isBind ? "Binding" : "Assigning to") + " rvalue");
  }
};
pp$7.checkLValPattern = function(expr, bindingType, checkClashes) {
  if (bindingType === void 0) bindingType = BIND_NONE;
  switch (expr.type) {
    case "ObjectPattern":
      for (var i = 0, list = expr.properties; i < list.length; i += 1) {
        var prop = list[i];
        this.checkLValInnerPattern(prop, bindingType, checkClashes);
      }
      break;
    case "ArrayPattern":
      for (var i$1 = 0, list$1 = expr.elements; i$1 < list$1.length; i$1 += 1) {
        var elem = list$1[i$1];
        if (elem) {
          this.checkLValInnerPattern(elem, bindingType, checkClashes);
        }
      }
      break;
    default:
      this.checkLValSimple(expr, bindingType, checkClashes);
  }
};
pp$7.checkLValInnerPattern = function(expr, bindingType, checkClashes) {
  if (bindingType === void 0) bindingType = BIND_NONE;
  switch (expr.type) {
    case "Property":
      this.checkLValInnerPattern(expr.value, bindingType, checkClashes);
      break;
    case "AssignmentPattern":
      this.checkLValPattern(expr.left, bindingType, checkClashes);
      break;
    case "RestElement":
      this.checkLValPattern(expr.argument, bindingType, checkClashes);
      break;
    default:
      this.checkLValPattern(expr, bindingType, checkClashes);
  }
};
var TokContext = function TokContext2(token2, isExpr, preserveSpace, override, generator) {
  this.token = token2;
  this.isExpr = !!isExpr;
  this.preserveSpace = !!preserveSpace;
  this.override = override;
  this.generator = !!generator;
};
var types = {
  b_stat: new TokContext("{", false),
  b_expr: new TokContext("{", true),
  b_tmpl: new TokContext("${", false),
  p_stat: new TokContext("(", false),
  p_expr: new TokContext("(", true),
  q_tmpl: new TokContext("`", true, true, function(p) {
    return p.tryReadTemplateToken();
  }),
  f_stat: new TokContext("function", false),
  f_expr: new TokContext("function", true),
  f_expr_gen: new TokContext("function", true, false, null, true),
  f_gen: new TokContext("function", false, false, null, true)
};
var pp$6 = Parser.prototype;
pp$6.initialContext = function() {
  return [types.b_stat];
};
pp$6.curContext = function() {
  return this.context[this.context.length - 1];
};
pp$6.braceIsBlock = function(prevType) {
  var parent2 = this.curContext();
  if (parent2 === types.f_expr || parent2 === types.f_stat) {
    return true;
  }
  if (prevType === types$1.colon && (parent2 === types.b_stat || parent2 === types.b_expr)) {
    return !parent2.isExpr;
  }
  if (prevType === types$1._return || prevType === types$1.name && this.exprAllowed) {
    return lineBreak.test(this.input.slice(this.lastTokEnd, this.start));
  }
  if (prevType === types$1._else || prevType === types$1.semi || prevType === types$1.eof || prevType === types$1.parenR || prevType === types$1.arrow) {
    return true;
  }
  if (prevType === types$1.braceL) {
    return parent2 === types.b_stat;
  }
  if (prevType === types$1._var || prevType === types$1._const || prevType === types$1.name) {
    return false;
  }
  return !this.exprAllowed;
};
pp$6.inGeneratorContext = function() {
  for (var i = this.context.length - 1; i >= 1; i--) {
    var context = this.context[i];
    if (context.token === "function") {
      return context.generator;
    }
  }
  return false;
};
pp$6.updateContext = function(prevType) {
  var update, type5 = this.type;
  if (type5.keyword && prevType === types$1.dot) {
    this.exprAllowed = false;
  } else if (update = type5.updateContext) {
    update.call(this, prevType);
  } else {
    this.exprAllowed = type5.beforeExpr;
  }
};
pp$6.overrideContext = function(tokenCtx) {
  if (this.curContext() !== tokenCtx) {
    this.context[this.context.length - 1] = tokenCtx;
  }
};
types$1.parenR.updateContext = types$1.braceR.updateContext = function() {
  if (this.context.length === 1) {
    this.exprAllowed = true;
    return;
  }
  var out = this.context.pop();
  if (out === types.b_stat && this.curContext().token === "function") {
    out = this.context.pop();
  }
  this.exprAllowed = !out.isExpr;
};
types$1.braceL.updateContext = function(prevType) {
  this.context.push(this.braceIsBlock(prevType) ? types.b_stat : types.b_expr);
  this.exprAllowed = true;
};
types$1.dollarBraceL.updateContext = function() {
  this.context.push(types.b_tmpl);
  this.exprAllowed = true;
};
types$1.parenL.updateContext = function(prevType) {
  var statementParens = prevType === types$1._if || prevType === types$1._for || prevType === types$1._with || prevType === types$1._while;
  this.context.push(statementParens ? types.p_stat : types.p_expr);
  this.exprAllowed = true;
};
types$1.incDec.updateContext = function() {
};
types$1._function.updateContext = types$1._class.updateContext = function(prevType) {
  if (prevType.beforeExpr && prevType !== types$1._else && !(prevType === types$1.semi && this.curContext() !== types.p_stat) && !(prevType === types$1._return && lineBreak.test(this.input.slice(this.lastTokEnd, this.start))) && !((prevType === types$1.colon || prevType === types$1.braceL) && this.curContext() === types.b_stat)) {
    this.context.push(types.f_expr);
  } else {
    this.context.push(types.f_stat);
  }
  this.exprAllowed = false;
};
types$1.colon.updateContext = function() {
  if (this.curContext().token === "function") {
    this.context.pop();
  }
  this.exprAllowed = true;
};
types$1.backQuote.updateContext = function() {
  if (this.curContext() === types.q_tmpl) {
    this.context.pop();
  } else {
    this.context.push(types.q_tmpl);
  }
  this.exprAllowed = false;
};
types$1.star.updateContext = function(prevType) {
  if (prevType === types$1._function) {
    var index3 = this.context.length - 1;
    if (this.context[index3] === types.f_expr) {
      this.context[index3] = types.f_expr_gen;
    } else {
      this.context[index3] = types.f_gen;
    }
  }
  this.exprAllowed = true;
};
types$1.name.updateContext = function(prevType) {
  var allowed = false;
  if (this.options.ecmaVersion >= 6 && prevType !== types$1.dot) {
    if (this.value === "of" && !this.exprAllowed || this.value === "yield" && this.inGeneratorContext()) {
      allowed = true;
    }
  }
  this.exprAllowed = allowed;
};
var pp$5 = Parser.prototype;
pp$5.checkPropClash = function(prop, propHash, refDestructuringErrors) {
  if (this.options.ecmaVersion >= 9 && prop.type === "SpreadElement") {
    return;
  }
  if (this.options.ecmaVersion >= 6 && (prop.computed || prop.method || prop.shorthand)) {
    return;
  }
  var key2 = prop.key;
  var name;
  switch (key2.type) {
    case "Identifier":
      name = key2.name;
      break;
    case "Literal":
      name = String(key2.value);
      break;
    default:
      return;
  }
  var kind = prop.kind;
  if (this.options.ecmaVersion >= 6) {
    if (name === "__proto__" && kind === "init") {
      if (propHash.proto) {
        if (refDestructuringErrors) {
          if (refDestructuringErrors.doubleProto < 0) {
            refDestructuringErrors.doubleProto = key2.start;
          }
        } else {
          this.raiseRecoverable(key2.start, "Redefinition of __proto__ property");
        }
      }
      propHash.proto = true;
    }
    return;
  }
  name = "$" + name;
  var other = propHash[name];
  if (other) {
    var redefinition;
    if (kind === "init") {
      redefinition = this.strict && other.init || other.get || other.set;
    } else {
      redefinition = other.init || other[kind];
    }
    if (redefinition) {
      this.raiseRecoverable(key2.start, "Redefinition of property");
    }
  } else {
    other = propHash[name] = {
      init: false,
      get: false,
      set: false
    };
  }
  other[kind] = true;
};
pp$5.parseExpression = function(forInit, refDestructuringErrors) {
  var startPos = this.start, startLoc = this.startLoc;
  var expr = this.parseMaybeAssign(forInit, refDestructuringErrors);
  if (this.type === types$1.comma) {
    var node2 = this.startNodeAt(startPos, startLoc);
    node2.expressions = [expr];
    while (this.eat(types$1.comma)) {
      node2.expressions.push(this.parseMaybeAssign(forInit, refDestructuringErrors));
    }
    return this.finishNode(node2, "SequenceExpression");
  }
  return expr;
};
pp$5.parseMaybeAssign = function(forInit, refDestructuringErrors, afterLeftParse) {
  if (this.isContextual("yield")) {
    if (this.inGenerator) {
      return this.parseYield(forInit);
    } else {
      this.exprAllowed = false;
    }
  }
  var ownDestructuringErrors = false, oldParenAssign = -1, oldTrailingComma = -1, oldDoubleProto = -1;
  if (refDestructuringErrors) {
    oldParenAssign = refDestructuringErrors.parenthesizedAssign;
    oldTrailingComma = refDestructuringErrors.trailingComma;
    oldDoubleProto = refDestructuringErrors.doubleProto;
    refDestructuringErrors.parenthesizedAssign = refDestructuringErrors.trailingComma = -1;
  } else {
    refDestructuringErrors = new DestructuringErrors();
    ownDestructuringErrors = true;
  }
  var startPos = this.start, startLoc = this.startLoc;
  if (this.type === types$1.parenL || this.type === types$1.name) {
    this.potentialArrowAt = this.start;
    this.potentialArrowInForAwait = forInit === "await";
  }
  var left2 = this.parseMaybeConditional(forInit, refDestructuringErrors);
  if (afterLeftParse) {
    left2 = afterLeftParse.call(this, left2, startPos, startLoc);
  }
  if (this.type.isAssign) {
    var node2 = this.startNodeAt(startPos, startLoc);
    node2.operator = this.value;
    if (this.type === types$1.eq) {
      left2 = this.toAssignable(left2, false, refDestructuringErrors);
    }
    if (!ownDestructuringErrors) {
      refDestructuringErrors.parenthesizedAssign = refDestructuringErrors.trailingComma = refDestructuringErrors.doubleProto = -1;
    }
    if (refDestructuringErrors.shorthandAssign >= left2.start) {
      refDestructuringErrors.shorthandAssign = -1;
    }
    if (this.type === types$1.eq) {
      this.checkLValPattern(left2);
    } else {
      this.checkLValSimple(left2);
    }
    node2.left = left2;
    this.next();
    node2.right = this.parseMaybeAssign(forInit);
    if (oldDoubleProto > -1) {
      refDestructuringErrors.doubleProto = oldDoubleProto;
    }
    return this.finishNode(node2, "AssignmentExpression");
  } else {
    if (ownDestructuringErrors) {
      this.checkExpressionErrors(refDestructuringErrors, true);
    }
  }
  if (oldParenAssign > -1) {
    refDestructuringErrors.parenthesizedAssign = oldParenAssign;
  }
  if (oldTrailingComma > -1) {
    refDestructuringErrors.trailingComma = oldTrailingComma;
  }
  return left2;
};
pp$5.parseMaybeConditional = function(forInit, refDestructuringErrors) {
  var startPos = this.start, startLoc = this.startLoc;
  var expr = this.parseExprOps(forInit, refDestructuringErrors);
  if (this.checkExpressionErrors(refDestructuringErrors)) {
    return expr;
  }
  if (this.eat(types$1.question)) {
    var node2 = this.startNodeAt(startPos, startLoc);
    node2.test = expr;
    node2.consequent = this.parseMaybeAssign();
    this.expect(types$1.colon);
    node2.alternate = this.parseMaybeAssign(forInit);
    return this.finishNode(node2, "ConditionalExpression");
  }
  return expr;
};
pp$5.parseExprOps = function(forInit, refDestructuringErrors) {
  var startPos = this.start, startLoc = this.startLoc;
  var expr = this.parseMaybeUnary(refDestructuringErrors, false, false, forInit);
  if (this.checkExpressionErrors(refDestructuringErrors)) {
    return expr;
  }
  return expr.start === startPos && expr.type === "ArrowFunctionExpression" ? expr : this.parseExprOp(expr, startPos, startLoc, -1, forInit);
};
pp$5.parseExprOp = function(left2, leftStartPos, leftStartLoc, minPrec, forInit) {
  var prec = this.type.binop;
  if (prec != null && (!forInit || this.type !== types$1._in)) {
    if (prec > minPrec) {
      var logical = this.type === types$1.logicalOR || this.type === types$1.logicalAND;
      var coalesce = this.type === types$1.coalesce;
      if (coalesce) {
        prec = types$1.logicalAND.binop;
      }
      var op = this.value;
      this.next();
      var startPos = this.start, startLoc = this.startLoc;
      var right2 = this.parseExprOp(this.parseMaybeUnary(null, false, false, forInit), startPos, startLoc, prec, forInit);
      var node2 = this.buildBinary(leftStartPos, leftStartLoc, left2, right2, op, logical || coalesce);
      if (logical && this.type === types$1.coalesce || coalesce && (this.type === types$1.logicalOR || this.type === types$1.logicalAND)) {
        this.raiseRecoverable(this.start, "Logical expressions and coalesce expressions cannot be mixed. Wrap either by parentheses");
      }
      return this.parseExprOp(node2, leftStartPos, leftStartLoc, minPrec, forInit);
    }
  }
  return left2;
};
pp$5.buildBinary = function(startPos, startLoc, left2, right2, op, logical) {
  if (right2.type === "PrivateIdentifier") {
    this.raise(right2.start, "Private identifier can only be left side of binary expression");
  }
  var node2 = this.startNodeAt(startPos, startLoc);
  node2.left = left2;
  node2.operator = op;
  node2.right = right2;
  return this.finishNode(node2, logical ? "LogicalExpression" : "BinaryExpression");
};
pp$5.parseMaybeUnary = function(refDestructuringErrors, sawUnary, incDec, forInit) {
  var startPos = this.start, startLoc = this.startLoc, expr;
  if (this.isContextual("await") && this.canAwait) {
    expr = this.parseAwait(forInit);
    sawUnary = true;
  } else if (this.type.prefix) {
    var node2 = this.startNode(), update = this.type === types$1.incDec;
    node2.operator = this.value;
    node2.prefix = true;
    this.next();
    node2.argument = this.parseMaybeUnary(null, true, update, forInit);
    this.checkExpressionErrors(refDestructuringErrors, true);
    if (update) {
      this.checkLValSimple(node2.argument);
    } else if (this.strict && node2.operator === "delete" && isLocalVariableAccess(node2.argument)) {
      this.raiseRecoverable(node2.start, "Deleting local variable in strict mode");
    } else if (node2.operator === "delete" && isPrivateFieldAccess(node2.argument)) {
      this.raiseRecoverable(node2.start, "Private fields can not be deleted");
    } else {
      sawUnary = true;
    }
    expr = this.finishNode(node2, update ? "UpdateExpression" : "UnaryExpression");
  } else if (!sawUnary && this.type === types$1.privateId) {
    if ((forInit || this.privateNameStack.length === 0) && this.options.checkPrivateFields) {
      this.unexpected();
    }
    expr = this.parsePrivateIdent();
    if (this.type !== types$1._in) {
      this.unexpected();
    }
  } else {
    expr = this.parseExprSubscripts(refDestructuringErrors, forInit);
    if (this.checkExpressionErrors(refDestructuringErrors)) {
      return expr;
    }
    while (this.type.postfix && !this.canInsertSemicolon()) {
      var node$1 = this.startNodeAt(startPos, startLoc);
      node$1.operator = this.value;
      node$1.prefix = false;
      node$1.argument = expr;
      this.checkLValSimple(expr);
      this.next();
      expr = this.finishNode(node$1, "UpdateExpression");
    }
  }
  if (!incDec && this.eat(types$1.starstar)) {
    if (sawUnary) {
      this.unexpected(this.lastTokStart);
    } else {
      return this.buildBinary(startPos, startLoc, expr, this.parseMaybeUnary(null, false, false, forInit), "**", false);
    }
  } else {
    return expr;
  }
};
function isLocalVariableAccess(node2) {
  return node2.type === "Identifier" || node2.type === "ParenthesizedExpression" && isLocalVariableAccess(node2.expression);
}
function isPrivateFieldAccess(node2) {
  return node2.type === "MemberExpression" && node2.property.type === "PrivateIdentifier" || node2.type === "ChainExpression" && isPrivateFieldAccess(node2.expression) || node2.type === "ParenthesizedExpression" && isPrivateFieldAccess(node2.expression);
}
pp$5.parseExprSubscripts = function(refDestructuringErrors, forInit) {
  var startPos = this.start, startLoc = this.startLoc;
  var expr = this.parseExprAtom(refDestructuringErrors, forInit);
  if (expr.type === "ArrowFunctionExpression" && this.input.slice(this.lastTokStart, this.lastTokEnd) !== ")") {
    return expr;
  }
  var result = this.parseSubscripts(expr, startPos, startLoc, false, forInit);
  if (refDestructuringErrors && result.type === "MemberExpression") {
    if (refDestructuringErrors.parenthesizedAssign >= result.start) {
      refDestructuringErrors.parenthesizedAssign = -1;
    }
    if (refDestructuringErrors.parenthesizedBind >= result.start) {
      refDestructuringErrors.parenthesizedBind = -1;
    }
    if (refDestructuringErrors.trailingComma >= result.start) {
      refDestructuringErrors.trailingComma = -1;
    }
  }
  return result;
};
pp$5.parseSubscripts = function(base, startPos, startLoc, noCalls, forInit) {
  var maybeAsyncArrow = this.options.ecmaVersion >= 8 && base.type === "Identifier" && base.name === "async" && this.lastTokEnd === base.end && !this.canInsertSemicolon() && base.end - base.start === 5 && this.potentialArrowAt === base.start;
  var optionalChained = false;
  while (true) {
    var element = this.parseSubscript(base, startPos, startLoc, noCalls, maybeAsyncArrow, optionalChained, forInit);
    if (element.optional) {
      optionalChained = true;
    }
    if (element === base || element.type === "ArrowFunctionExpression") {
      if (optionalChained) {
        var chainNode = this.startNodeAt(startPos, startLoc);
        chainNode.expression = element;
        element = this.finishNode(chainNode, "ChainExpression");
      }
      return element;
    }
    base = element;
  }
};
pp$5.shouldParseAsyncArrow = function() {
  return !this.canInsertSemicolon() && this.eat(types$1.arrow);
};
pp$5.parseSubscriptAsyncArrow = function(startPos, startLoc, exprList, forInit) {
  return this.parseArrowExpression(this.startNodeAt(startPos, startLoc), exprList, true, forInit);
};
pp$5.parseSubscript = function(base, startPos, startLoc, noCalls, maybeAsyncArrow, optionalChained, forInit) {
  var optionalSupported = this.options.ecmaVersion >= 11;
  var optional = optionalSupported && this.eat(types$1.questionDot);
  if (noCalls && optional) {
    this.raise(this.lastTokStart, "Optional chaining cannot appear in the callee of new expressions");
  }
  var computed = this.eat(types$1.bracketL);
  if (computed || optional && this.type !== types$1.parenL && this.type !== types$1.backQuote || this.eat(types$1.dot)) {
    var node2 = this.startNodeAt(startPos, startLoc);
    node2.object = base;
    if (computed) {
      node2.property = this.parseExpression();
      this.expect(types$1.bracketR);
    } else if (this.type === types$1.privateId && base.type !== "Super") {
      node2.property = this.parsePrivateIdent();
    } else {
      node2.property = this.parseIdent(this.options.allowReserved !== "never");
    }
    node2.computed = !!computed;
    if (optionalSupported) {
      node2.optional = optional;
    }
    base = this.finishNode(node2, "MemberExpression");
  } else if (!noCalls && this.eat(types$1.parenL)) {
    var refDestructuringErrors = new DestructuringErrors(), oldYieldPos = this.yieldPos, oldAwaitPos = this.awaitPos, oldAwaitIdentPos = this.awaitIdentPos;
    this.yieldPos = 0;
    this.awaitPos = 0;
    this.awaitIdentPos = 0;
    var exprList = this.parseExprList(types$1.parenR, this.options.ecmaVersion >= 8, false, refDestructuringErrors);
    if (maybeAsyncArrow && !optional && this.shouldParseAsyncArrow()) {
      this.checkPatternErrors(refDestructuringErrors, false);
      this.checkYieldAwaitInDefaultParams();
      if (this.awaitIdentPos > 0) {
        this.raise(this.awaitIdentPos, "Cannot use 'await' as identifier inside an async function");
      }
      this.yieldPos = oldYieldPos;
      this.awaitPos = oldAwaitPos;
      this.awaitIdentPos = oldAwaitIdentPos;
      return this.parseSubscriptAsyncArrow(startPos, startLoc, exprList, forInit);
    }
    this.checkExpressionErrors(refDestructuringErrors, true);
    this.yieldPos = oldYieldPos || this.yieldPos;
    this.awaitPos = oldAwaitPos || this.awaitPos;
    this.awaitIdentPos = oldAwaitIdentPos || this.awaitIdentPos;
    var node$1 = this.startNodeAt(startPos, startLoc);
    node$1.callee = base;
    node$1.arguments = exprList;
    if (optionalSupported) {
      node$1.optional = optional;
    }
    base = this.finishNode(node$1, "CallExpression");
  } else if (this.type === types$1.backQuote) {
    if (optional || optionalChained) {
      this.raise(this.start, "Optional chaining cannot appear in the tag of tagged template expressions");
    }
    var node$2 = this.startNodeAt(startPos, startLoc);
    node$2.tag = base;
    node$2.quasi = this.parseTemplate({ isTagged: true });
    base = this.finishNode(node$2, "TaggedTemplateExpression");
  }
  return base;
};
pp$5.parseExprAtom = function(refDestructuringErrors, forInit, forNew) {
  if (this.type === types$1.slash) {
    this.readRegexp();
  }
  var node2, canBeArrow = this.potentialArrowAt === this.start;
  switch (this.type) {
    case types$1._super:
      if (!this.allowSuper) {
        this.raise(this.start, "'super' keyword outside a method");
      }
      node2 = this.startNode();
      this.next();
      if (this.type === types$1.parenL && !this.allowDirectSuper) {
        this.raise(node2.start, "super() call outside constructor of a subclass");
      }
      if (this.type !== types$1.dot && this.type !== types$1.bracketL && this.type !== types$1.parenL) {
        this.unexpected();
      }
      return this.finishNode(node2, "Super");
    case types$1._this:
      node2 = this.startNode();
      this.next();
      return this.finishNode(node2, "ThisExpression");
    case types$1.name:
      var startPos = this.start, startLoc = this.startLoc, containsEsc = this.containsEsc;
      var id = this.parseIdent(false);
      if (this.options.ecmaVersion >= 8 && !containsEsc && id.name === "async" && !this.canInsertSemicolon() && this.eat(types$1._function)) {
        this.overrideContext(types.f_expr);
        return this.parseFunction(this.startNodeAt(startPos, startLoc), 0, false, true, forInit);
      }
      if (canBeArrow && !this.canInsertSemicolon()) {
        if (this.eat(types$1.arrow)) {
          return this.parseArrowExpression(this.startNodeAt(startPos, startLoc), [id], false, forInit);
        }
        if (this.options.ecmaVersion >= 8 && id.name === "async" && this.type === types$1.name && !containsEsc && (!this.potentialArrowInForAwait || this.value !== "of" || this.containsEsc)) {
          id = this.parseIdent(false);
          if (this.canInsertSemicolon() || !this.eat(types$1.arrow)) {
            this.unexpected();
          }
          return this.parseArrowExpression(this.startNodeAt(startPos, startLoc), [id], true, forInit);
        }
      }
      return id;
    case types$1.regexp:
      var value = this.value;
      node2 = this.parseLiteral(value.value);
      node2.regex = { pattern: value.pattern, flags: value.flags };
      return node2;
    case types$1.num:
    case types$1.string:
      return this.parseLiteral(this.value);
    case types$1._null:
    case types$1._true:
    case types$1._false:
      node2 = this.startNode();
      node2.value = this.type === types$1._null ? null : this.type === types$1._true;
      node2.raw = this.type.keyword;
      this.next();
      return this.finishNode(node2, "Literal");
    case types$1.parenL:
      var start = this.start, expr = this.parseParenAndDistinguishExpression(canBeArrow, forInit);
      if (refDestructuringErrors) {
        if (refDestructuringErrors.parenthesizedAssign < 0 && !this.isSimpleAssignTarget(expr)) {
          refDestructuringErrors.parenthesizedAssign = start;
        }
        if (refDestructuringErrors.parenthesizedBind < 0) {
          refDestructuringErrors.parenthesizedBind = start;
        }
      }
      return expr;
    case types$1.bracketL:
      node2 = this.startNode();
      this.next();
      node2.elements = this.parseExprList(types$1.bracketR, true, true, refDestructuringErrors);
      return this.finishNode(node2, "ArrayExpression");
    case types$1.braceL:
      this.overrideContext(types.b_expr);
      return this.parseObj(false, refDestructuringErrors);
    case types$1._function:
      node2 = this.startNode();
      this.next();
      return this.parseFunction(node2, 0);
    case types$1._class:
      return this.parseClass(this.startNode(), false);
    case types$1._new:
      return this.parseNew();
    case types$1.backQuote:
      return this.parseTemplate();
    case types$1._import:
      if (this.options.ecmaVersion >= 11) {
        return this.parseExprImport(forNew);
      } else {
        return this.unexpected();
      }
    default:
      return this.parseExprAtomDefault();
  }
};
pp$5.parseExprAtomDefault = function() {
  this.unexpected();
};
pp$5.parseExprImport = function(forNew) {
  var node2 = this.startNode();
  if (this.containsEsc) {
    this.raiseRecoverable(this.start, "Escape sequence in keyword import");
  }
  this.next();
  if (this.type === types$1.parenL && !forNew) {
    return this.parseDynamicImport(node2);
  } else if (this.type === types$1.dot) {
    var meta = this.startNodeAt(node2.start, node2.loc && node2.loc.start);
    meta.name = "import";
    node2.meta = this.finishNode(meta, "Identifier");
    return this.parseImportMeta(node2);
  } else {
    this.unexpected();
  }
};
pp$5.parseDynamicImport = function(node2) {
  this.next();
  node2.source = this.parseMaybeAssign();
  if (this.options.ecmaVersion >= 16) {
    if (!this.eat(types$1.parenR)) {
      this.expect(types$1.comma);
      if (!this.afterTrailingComma(types$1.parenR)) {
        node2.options = this.parseMaybeAssign();
        if (!this.eat(types$1.parenR)) {
          this.expect(types$1.comma);
          if (!this.afterTrailingComma(types$1.parenR)) {
            this.unexpected();
          }
        }
      } else {
        node2.options = null;
      }
    } else {
      node2.options = null;
    }
  } else {
    if (!this.eat(types$1.parenR)) {
      var errorPos = this.start;
      if (this.eat(types$1.comma) && this.eat(types$1.parenR)) {
        this.raiseRecoverable(errorPos, "Trailing comma is not allowed in import()");
      } else {
        this.unexpected(errorPos);
      }
    }
  }
  return this.finishNode(node2, "ImportExpression");
};
pp$5.parseImportMeta = function(node2) {
  this.next();
  var containsEsc = this.containsEsc;
  node2.property = this.parseIdent(true);
  if (node2.property.name !== "meta") {
    this.raiseRecoverable(node2.property.start, "The only valid meta property for import is 'import.meta'");
  }
  if (containsEsc) {
    this.raiseRecoverable(node2.start, "'import.meta' must not contain escaped characters");
  }
  if (this.options.sourceType !== "module" && !this.options.allowImportExportEverywhere) {
    this.raiseRecoverable(node2.start, "Cannot use 'import.meta' outside a module");
  }
  return this.finishNode(node2, "MetaProperty");
};
pp$5.parseLiteral = function(value) {
  var node2 = this.startNode();
  node2.value = value;
  node2.raw = this.input.slice(this.start, this.end);
  if (node2.raw.charCodeAt(node2.raw.length - 1) === 110) {
    node2.bigint = node2.value != null ? node2.value.toString() : node2.raw.slice(0, -1).replace(/_/g, "");
  }
  this.next();
  return this.finishNode(node2, "Literal");
};
pp$5.parseParenExpression = function() {
  this.expect(types$1.parenL);
  var val = this.parseExpression();
  this.expect(types$1.parenR);
  return val;
};
pp$5.shouldParseArrow = function(exprList) {
  return !this.canInsertSemicolon();
};
pp$5.parseParenAndDistinguishExpression = function(canBeArrow, forInit) {
  var startPos = this.start, startLoc = this.startLoc, val, allowTrailingComma = this.options.ecmaVersion >= 8;
  if (this.options.ecmaVersion >= 6) {
    this.next();
    var innerStartPos = this.start, innerStartLoc = this.startLoc;
    var exprList = [], first = true, lastIsComma = false;
    var refDestructuringErrors = new DestructuringErrors(), oldYieldPos = this.yieldPos, oldAwaitPos = this.awaitPos, spreadStart;
    this.yieldPos = 0;
    this.awaitPos = 0;
    while (this.type !== types$1.parenR) {
      first ? first = false : this.expect(types$1.comma);
      if (allowTrailingComma && this.afterTrailingComma(types$1.parenR, true)) {
        lastIsComma = true;
        break;
      } else if (this.type === types$1.ellipsis) {
        spreadStart = this.start;
        exprList.push(this.parseParenItem(this.parseRestBinding()));
        if (this.type === types$1.comma) {
          this.raiseRecoverable(
            this.start,
            "Comma is not permitted after the rest element"
          );
        }
        break;
      } else {
        exprList.push(this.parseMaybeAssign(false, refDestructuringErrors, this.parseParenItem));
      }
    }
    var innerEndPos = this.lastTokEnd, innerEndLoc = this.lastTokEndLoc;
    this.expect(types$1.parenR);
    if (canBeArrow && this.shouldParseArrow(exprList) && this.eat(types$1.arrow)) {
      this.checkPatternErrors(refDestructuringErrors, false);
      this.checkYieldAwaitInDefaultParams();
      this.yieldPos = oldYieldPos;
      this.awaitPos = oldAwaitPos;
      return this.parseParenArrowList(startPos, startLoc, exprList, forInit);
    }
    if (!exprList.length || lastIsComma) {
      this.unexpected(this.lastTokStart);
    }
    if (spreadStart) {
      this.unexpected(spreadStart);
    }
    this.checkExpressionErrors(refDestructuringErrors, true);
    this.yieldPos = oldYieldPos || this.yieldPos;
    this.awaitPos = oldAwaitPos || this.awaitPos;
    if (exprList.length > 1) {
      val = this.startNodeAt(innerStartPos, innerStartLoc);
      val.expressions = exprList;
      this.finishNodeAt(val, "SequenceExpression", innerEndPos, innerEndLoc);
    } else {
      val = exprList[0];
    }
  } else {
    val = this.parseParenExpression();
  }
  if (this.options.preserveParens) {
    var par = this.startNodeAt(startPos, startLoc);
    par.expression = val;
    return this.finishNode(par, "ParenthesizedExpression");
  } else {
    return val;
  }
};
pp$5.parseParenItem = function(item) {
  return item;
};
pp$5.parseParenArrowList = function(startPos, startLoc, exprList, forInit) {
  return this.parseArrowExpression(this.startNodeAt(startPos, startLoc), exprList, false, forInit);
};
var empty = [];
pp$5.parseNew = function() {
  if (this.containsEsc) {
    this.raiseRecoverable(this.start, "Escape sequence in keyword new");
  }
  var node2 = this.startNode();
  this.next();
  if (this.options.ecmaVersion >= 6 && this.type === types$1.dot) {
    var meta = this.startNodeAt(node2.start, node2.loc && node2.loc.start);
    meta.name = "new";
    node2.meta = this.finishNode(meta, "Identifier");
    this.next();
    var containsEsc = this.containsEsc;
    node2.property = this.parseIdent(true);
    if (node2.property.name !== "target") {
      this.raiseRecoverable(node2.property.start, "The only valid meta property for new is 'new.target'");
    }
    if (containsEsc) {
      this.raiseRecoverable(node2.start, "'new.target' must not contain escaped characters");
    }
    if (!this.allowNewDotTarget) {
      this.raiseRecoverable(node2.start, "'new.target' can only be used in functions and class static block");
    }
    return this.finishNode(node2, "MetaProperty");
  }
  var startPos = this.start, startLoc = this.startLoc;
  node2.callee = this.parseSubscripts(this.parseExprAtom(null, false, true), startPos, startLoc, true, false);
  if (this.eat(types$1.parenL)) {
    node2.arguments = this.parseExprList(types$1.parenR, this.options.ecmaVersion >= 8, false);
  } else {
    node2.arguments = empty;
  }
  return this.finishNode(node2, "NewExpression");
};
pp$5.parseTemplateElement = function(ref3) {
  var isTagged = ref3.isTagged;
  var elem = this.startNode();
  if (this.type === types$1.invalidTemplate) {
    if (!isTagged) {
      this.raiseRecoverable(this.start, "Bad escape sequence in untagged template literal");
    }
    elem.value = {
      raw: this.value.replace(/\r\n?/g, "\n"),
      cooked: null
    };
  } else {
    elem.value = {
      raw: this.input.slice(this.start, this.end).replace(/\r\n?/g, "\n"),
      cooked: this.value
    };
  }
  this.next();
  elem.tail = this.type === types$1.backQuote;
  return this.finishNode(elem, "TemplateElement");
};
pp$5.parseTemplate = function(ref3) {
  if (ref3 === void 0) ref3 = {};
  var isTagged = ref3.isTagged;
  if (isTagged === void 0) isTagged = false;
  var node2 = this.startNode();
  this.next();
  node2.expressions = [];
  var curElt = this.parseTemplateElement({ isTagged });
  node2.quasis = [curElt];
  while (!curElt.tail) {
    if (this.type === types$1.eof) {
      this.raise(this.pos, "Unterminated template literal");
    }
    this.expect(types$1.dollarBraceL);
    node2.expressions.push(this.parseExpression());
    this.expect(types$1.braceR);
    node2.quasis.push(curElt = this.parseTemplateElement({ isTagged }));
  }
  this.next();
  return this.finishNode(node2, "TemplateLiteral");
};
pp$5.isAsyncProp = function(prop) {
  return !prop.computed && prop.key.type === "Identifier" && prop.key.name === "async" && (this.type === types$1.name || this.type === types$1.num || this.type === types$1.string || this.type === types$1.bracketL || this.type.keyword || this.options.ecmaVersion >= 9 && this.type === types$1.star) && !lineBreak.test(this.input.slice(this.lastTokEnd, this.start));
};
pp$5.parseObj = function(isPattern, refDestructuringErrors) {
  var node2 = this.startNode(), first = true, propHash = {};
  node2.properties = [];
  this.next();
  while (!this.eat(types$1.braceR)) {
    if (!first) {
      this.expect(types$1.comma);
      if (this.options.ecmaVersion >= 5 && this.afterTrailingComma(types$1.braceR)) {
        break;
      }
    } else {
      first = false;
    }
    var prop = this.parseProperty(isPattern, refDestructuringErrors);
    if (!isPattern) {
      this.checkPropClash(prop, propHash, refDestructuringErrors);
    }
    node2.properties.push(prop);
  }
  return this.finishNode(node2, isPattern ? "ObjectPattern" : "ObjectExpression");
};
pp$5.parseProperty = function(isPattern, refDestructuringErrors) {
  var prop = this.startNode(), isGenerator, isAsync2, startPos, startLoc;
  if (this.options.ecmaVersion >= 9 && this.eat(types$1.ellipsis)) {
    if (isPattern) {
      prop.argument = this.parseIdent(false);
      if (this.type === types$1.comma) {
        this.raiseRecoverable(this.start, "Comma is not permitted after the rest element");
      }
      return this.finishNode(prop, "RestElement");
    }
    prop.argument = this.parseMaybeAssign(false, refDestructuringErrors);
    if (this.type === types$1.comma && refDestructuringErrors && refDestructuringErrors.trailingComma < 0) {
      refDestructuringErrors.trailingComma = this.start;
    }
    return this.finishNode(prop, "SpreadElement");
  }
  if (this.options.ecmaVersion >= 6) {
    prop.method = false;
    prop.shorthand = false;
    if (isPattern || refDestructuringErrors) {
      startPos = this.start;
      startLoc = this.startLoc;
    }
    if (!isPattern) {
      isGenerator = this.eat(types$1.star);
    }
  }
  var containsEsc = this.containsEsc;
  this.parsePropertyName(prop);
  if (!isPattern && !containsEsc && this.options.ecmaVersion >= 8 && !isGenerator && this.isAsyncProp(prop)) {
    isAsync2 = true;
    isGenerator = this.options.ecmaVersion >= 9 && this.eat(types$1.star);
    this.parsePropertyName(prop);
  } else {
    isAsync2 = false;
  }
  this.parsePropertyValue(prop, isPattern, isGenerator, isAsync2, startPos, startLoc, refDestructuringErrors, containsEsc);
  return this.finishNode(prop, "Property");
};
pp$5.parseGetterSetter = function(prop) {
  var kind = prop.key.name;
  this.parsePropertyName(prop);
  prop.value = this.parseMethod(false);
  prop.kind = kind;
  var paramCount = prop.kind === "get" ? 0 : 1;
  if (prop.value.params.length !== paramCount) {
    var start = prop.value.start;
    if (prop.kind === "get") {
      this.raiseRecoverable(start, "getter should have no params");
    } else {
      this.raiseRecoverable(start, "setter should have exactly one param");
    }
  } else {
    if (prop.kind === "set" && prop.value.params[0].type === "RestElement") {
      this.raiseRecoverable(prop.value.params[0].start, "Setter cannot use rest params");
    }
  }
};
pp$5.parsePropertyValue = function(prop, isPattern, isGenerator, isAsync2, startPos, startLoc, refDestructuringErrors, containsEsc) {
  if ((isGenerator || isAsync2) && this.type === types$1.colon) {
    this.unexpected();
  }
  if (this.eat(types$1.colon)) {
    prop.value = isPattern ? this.parseMaybeDefault(this.start, this.startLoc) : this.parseMaybeAssign(false, refDestructuringErrors);
    prop.kind = "init";
  } else if (this.options.ecmaVersion >= 6 && this.type === types$1.parenL) {
    if (isPattern) {
      this.unexpected();
    }
    prop.method = true;
    prop.value = this.parseMethod(isGenerator, isAsync2);
    prop.kind = "init";
  } else if (!isPattern && !containsEsc && this.options.ecmaVersion >= 5 && !prop.computed && prop.key.type === "Identifier" && (prop.key.name === "get" || prop.key.name === "set") && (this.type !== types$1.comma && this.type !== types$1.braceR && this.type !== types$1.eq)) {
    if (isGenerator || isAsync2) {
      this.unexpected();
    }
    this.parseGetterSetter(prop);
  } else if (this.options.ecmaVersion >= 6 && !prop.computed && prop.key.type === "Identifier") {
    if (isGenerator || isAsync2) {
      this.unexpected();
    }
    this.checkUnreserved(prop.key);
    if (prop.key.name === "await" && !this.awaitIdentPos) {
      this.awaitIdentPos = startPos;
    }
    if (isPattern) {
      prop.value = this.parseMaybeDefault(startPos, startLoc, this.copyNode(prop.key));
    } else if (this.type === types$1.eq && refDestructuringErrors) {
      if (refDestructuringErrors.shorthandAssign < 0) {
        refDestructuringErrors.shorthandAssign = this.start;
      }
      prop.value = this.parseMaybeDefault(startPos, startLoc, this.copyNode(prop.key));
    } else {
      prop.value = this.copyNode(prop.key);
    }
    prop.kind = "init";
    prop.shorthand = true;
  } else {
    this.unexpected();
  }
};
pp$5.parsePropertyName = function(prop) {
  if (this.options.ecmaVersion >= 6) {
    if (this.eat(types$1.bracketL)) {
      prop.computed = true;
      prop.key = this.parseMaybeAssign();
      this.expect(types$1.bracketR);
      return prop.key;
    } else {
      prop.computed = false;
    }
  }
  return prop.key = this.type === types$1.num || this.type === types$1.string ? this.parseExprAtom() : this.parseIdent(this.options.allowReserved !== "never");
};
pp$5.initFunction = function(node2) {
  node2.id = null;
  if (this.options.ecmaVersion >= 6) {
    node2.generator = node2.expression = false;
  }
  if (this.options.ecmaVersion >= 8) {
    node2.async = false;
  }
};
pp$5.parseMethod = function(isGenerator, isAsync2, allowDirectSuper) {
  var node2 = this.startNode(), oldYieldPos = this.yieldPos, oldAwaitPos = this.awaitPos, oldAwaitIdentPos = this.awaitIdentPos;
  this.initFunction(node2);
  if (this.options.ecmaVersion >= 6) {
    node2.generator = isGenerator;
  }
  if (this.options.ecmaVersion >= 8) {
    node2.async = !!isAsync2;
  }
  this.yieldPos = 0;
  this.awaitPos = 0;
  this.awaitIdentPos = 0;
  this.enterScope(functionFlags(isAsync2, node2.generator) | SCOPE_SUPER | (allowDirectSuper ? SCOPE_DIRECT_SUPER : 0));
  this.expect(types$1.parenL);
  node2.params = this.parseBindingList(types$1.parenR, false, this.options.ecmaVersion >= 8);
  this.checkYieldAwaitInDefaultParams();
  this.parseFunctionBody(node2, false, true, false);
  this.yieldPos = oldYieldPos;
  this.awaitPos = oldAwaitPos;
  this.awaitIdentPos = oldAwaitIdentPos;
  return this.finishNode(node2, "FunctionExpression");
};
pp$5.parseArrowExpression = function(node2, params, isAsync2, forInit) {
  var oldYieldPos = this.yieldPos, oldAwaitPos = this.awaitPos, oldAwaitIdentPos = this.awaitIdentPos;
  this.enterScope(functionFlags(isAsync2, false) | SCOPE_ARROW);
  this.initFunction(node2);
  if (this.options.ecmaVersion >= 8) {
    node2.async = !!isAsync2;
  }
  this.yieldPos = 0;
  this.awaitPos = 0;
  this.awaitIdentPos = 0;
  node2.params = this.toAssignableList(params, true);
  this.parseFunctionBody(node2, true, false, forInit);
  this.yieldPos = oldYieldPos;
  this.awaitPos = oldAwaitPos;
  this.awaitIdentPos = oldAwaitIdentPos;
  return this.finishNode(node2, "ArrowFunctionExpression");
};
pp$5.parseFunctionBody = function(node2, isArrowFunction, isMethod, forInit) {
  var isExpression3 = isArrowFunction && this.type !== types$1.braceL;
  var oldStrict = this.strict, useStrict = false;
  if (isExpression3) {
    node2.body = this.parseMaybeAssign(forInit);
    node2.expression = true;
    this.checkParams(node2, false);
  } else {
    var nonSimple = this.options.ecmaVersion >= 7 && !this.isSimpleParamList(node2.params);
    if (!oldStrict || nonSimple) {
      useStrict = this.strictDirective(this.end);
      if (useStrict && nonSimple) {
        this.raiseRecoverable(node2.start, "Illegal 'use strict' directive in function with non-simple parameter list");
      }
    }
    var oldLabels = this.labels;
    this.labels = [];
    if (useStrict) {
      this.strict = true;
    }
    this.checkParams(node2, !oldStrict && !useStrict && !isArrowFunction && !isMethod && this.isSimpleParamList(node2.params));
    if (this.strict && node2.id) {
      this.checkLValSimple(node2.id, BIND_OUTSIDE);
    }
    node2.body = this.parseBlock(false, void 0, useStrict && !oldStrict);
    node2.expression = false;
    this.adaptDirectivePrologue(node2.body.body);
    this.labels = oldLabels;
  }
  this.exitScope();
};
pp$5.isSimpleParamList = function(params) {
  for (var i = 0, list = params; i < list.length; i += 1) {
    var param = list[i];
    if (param.type !== "Identifier") {
      return false;
    }
  }
  return true;
};
pp$5.checkParams = function(node2, allowDuplicates) {
  var nameHash = /* @__PURE__ */ Object.create(null);
  for (var i = 0, list = node2.params; i < list.length; i += 1) {
    var param = list[i];
    this.checkLValInnerPattern(param, BIND_VAR, allowDuplicates ? null : nameHash);
  }
};
pp$5.parseExprList = function(close, allowTrailingComma, allowEmpty, refDestructuringErrors) {
  var elts = [], first = true;
  while (!this.eat(close)) {
    if (!first) {
      this.expect(types$1.comma);
      if (allowTrailingComma && this.afterTrailingComma(close)) {
        break;
      }
    } else {
      first = false;
    }
    var elt = void 0;
    if (allowEmpty && this.type === types$1.comma) {
      elt = null;
    } else if (this.type === types$1.ellipsis) {
      elt = this.parseSpread(refDestructuringErrors);
      if (refDestructuringErrors && this.type === types$1.comma && refDestructuringErrors.trailingComma < 0) {
        refDestructuringErrors.trailingComma = this.start;
      }
    } else {
      elt = this.parseMaybeAssign(false, refDestructuringErrors);
    }
    elts.push(elt);
  }
  return elts;
};
pp$5.checkUnreserved = function(ref3) {
  var start = ref3.start;
  var end = ref3.end;
  var name = ref3.name;
  if (this.inGenerator && name === "yield") {
    this.raiseRecoverable(start, "Cannot use 'yield' as identifier inside a generator");
  }
  if (this.inAsync && name === "await") {
    this.raiseRecoverable(start, "Cannot use 'await' as identifier inside an async function");
  }
  if (!(this.currentThisScope().flags & SCOPE_VAR) && name === "arguments") {
    this.raiseRecoverable(start, "Cannot use 'arguments' in class field initializer");
  }
  if (this.inClassStaticBlock && (name === "arguments" || name === "await")) {
    this.raise(start, "Cannot use " + name + " in class static initialization block");
  }
  if (this.keywords.test(name)) {
    this.raise(start, "Unexpected keyword '" + name + "'");
  }
  if (this.options.ecmaVersion < 6 && this.input.slice(start, end).indexOf("\\") !== -1) {
    return;
  }
  var re = this.strict ? this.reservedWordsStrict : this.reservedWords;
  if (re.test(name)) {
    if (!this.inAsync && name === "await") {
      this.raiseRecoverable(start, "Cannot use keyword 'await' outside an async function");
    }
    this.raiseRecoverable(start, "The keyword '" + name + "' is reserved");
  }
};
pp$5.parseIdent = function(liberal) {
  var node2 = this.parseIdentNode();
  this.next(!!liberal);
  this.finishNode(node2, "Identifier");
  if (!liberal) {
    this.checkUnreserved(node2);
    if (node2.name === "await" && !this.awaitIdentPos) {
      this.awaitIdentPos = node2.start;
    }
  }
  return node2;
};
pp$5.parseIdentNode = function() {
  var node2 = this.startNode();
  if (this.type === types$1.name) {
    node2.name = this.value;
  } else if (this.type.keyword) {
    node2.name = this.type.keyword;
    if ((node2.name === "class" || node2.name === "function") && (this.lastTokEnd !== this.lastTokStart + 1 || this.input.charCodeAt(this.lastTokStart) !== 46)) {
      this.context.pop();
    }
    this.type = types$1.name;
  } else {
    this.unexpected();
  }
  return node2;
};
pp$5.parsePrivateIdent = function() {
  var node2 = this.startNode();
  if (this.type === types$1.privateId) {
    node2.name = this.value;
  } else {
    this.unexpected();
  }
  this.next();
  this.finishNode(node2, "PrivateIdentifier");
  if (this.options.checkPrivateFields) {
    if (this.privateNameStack.length === 0) {
      this.raise(node2.start, "Private field '#" + node2.name + "' must be declared in an enclosing class");
    } else {
      this.privateNameStack[this.privateNameStack.length - 1].used.push(node2);
    }
  }
  return node2;
};
pp$5.parseYield = function(forInit) {
  if (!this.yieldPos) {
    this.yieldPos = this.start;
  }
  var node2 = this.startNode();
  this.next();
  if (this.type === types$1.semi || this.canInsertSemicolon() || this.type !== types$1.star && !this.type.startsExpr) {
    node2.delegate = false;
    node2.argument = null;
  } else {
    node2.delegate = this.eat(types$1.star);
    node2.argument = this.parseMaybeAssign(forInit);
  }
  return this.finishNode(node2, "YieldExpression");
};
pp$5.parseAwait = function(forInit) {
  if (!this.awaitPos) {
    this.awaitPos = this.start;
  }
  var node2 = this.startNode();
  this.next();
  node2.argument = this.parseMaybeUnary(null, true, false, forInit);
  return this.finishNode(node2, "AwaitExpression");
};
var pp$4 = Parser.prototype;
pp$4.raise = function(pos, message2) {
  var loc = getLineInfo(this.input, pos);
  message2 += " (" + loc.line + ":" + loc.column + ")";
  if (this.sourceFile) {
    message2 += " in " + this.sourceFile;
  }
  var err = new SyntaxError(message2);
  err.pos = pos;
  err.loc = loc;
  err.raisedAt = this.pos;
  throw err;
};
pp$4.raiseRecoverable = pp$4.raise;
pp$4.curPosition = function() {
  if (this.options.locations) {
    return new Position(this.curLine, this.pos - this.lineStart);
  }
};
var pp$3 = Parser.prototype;
var Scope = function Scope2(flags) {
  this.flags = flags;
  this.var = [];
  this.lexical = [];
  this.functions = [];
};
pp$3.enterScope = function(flags) {
  this.scopeStack.push(new Scope(flags));
};
pp$3.exitScope = function() {
  this.scopeStack.pop();
};
pp$3.treatFunctionsAsVarInScope = function(scope) {
  return scope.flags & SCOPE_FUNCTION || !this.inModule && scope.flags & SCOPE_TOP;
};
pp$3.declareName = function(name, bindingType, pos) {
  var redeclared = false;
  if (bindingType === BIND_LEXICAL) {
    var scope = this.currentScope();
    redeclared = scope.lexical.indexOf(name) > -1 || scope.functions.indexOf(name) > -1 || scope.var.indexOf(name) > -1;
    scope.lexical.push(name);
    if (this.inModule && scope.flags & SCOPE_TOP) {
      delete this.undefinedExports[name];
    }
  } else if (bindingType === BIND_SIMPLE_CATCH) {
    var scope$1 = this.currentScope();
    scope$1.lexical.push(name);
  } else if (bindingType === BIND_FUNCTION) {
    var scope$2 = this.currentScope();
    if (this.treatFunctionsAsVar) {
      redeclared = scope$2.lexical.indexOf(name) > -1;
    } else {
      redeclared = scope$2.lexical.indexOf(name) > -1 || scope$2.var.indexOf(name) > -1;
    }
    scope$2.functions.push(name);
  } else {
    for (var i = this.scopeStack.length - 1; i >= 0; --i) {
      var scope$3 = this.scopeStack[i];
      if (scope$3.lexical.indexOf(name) > -1 && !(scope$3.flags & SCOPE_SIMPLE_CATCH && scope$3.lexical[0] === name) || !this.treatFunctionsAsVarInScope(scope$3) && scope$3.functions.indexOf(name) > -1) {
        redeclared = true;
        break;
      }
      scope$3.var.push(name);
      if (this.inModule && scope$3.flags & SCOPE_TOP) {
        delete this.undefinedExports[name];
      }
      if (scope$3.flags & SCOPE_VAR) {
        break;
      }
    }
  }
  if (redeclared) {
    this.raiseRecoverable(pos, "Identifier '" + name + "' has already been declared");
  }
};
pp$3.checkLocalExport = function(id) {
  if (this.scopeStack[0].lexical.indexOf(id.name) === -1 && this.scopeStack[0].var.indexOf(id.name) === -1) {
    this.undefinedExports[id.name] = id;
  }
};
pp$3.currentScope = function() {
  return this.scopeStack[this.scopeStack.length - 1];
};
pp$3.currentVarScope = function() {
  for (var i = this.scopeStack.length - 1; ; i--) {
    var scope = this.scopeStack[i];
    if (scope.flags & (SCOPE_VAR | SCOPE_CLASS_FIELD_INIT | SCOPE_CLASS_STATIC_BLOCK)) {
      return scope;
    }
  }
};
pp$3.currentThisScope = function() {
  for (var i = this.scopeStack.length - 1; ; i--) {
    var scope = this.scopeStack[i];
    if (scope.flags & (SCOPE_VAR | SCOPE_CLASS_FIELD_INIT | SCOPE_CLASS_STATIC_BLOCK) && !(scope.flags & SCOPE_ARROW)) {
      return scope;
    }
  }
};
var Node = function Node2(parser, pos, loc) {
  this.type = "";
  this.start = pos;
  this.end = 0;
  if (parser.options.locations) {
    this.loc = new SourceLocation(parser, loc);
  }
  if (parser.options.directSourceFile) {
    this.sourceFile = parser.options.directSourceFile;
  }
  if (parser.options.ranges) {
    this.range = [pos, 0];
  }
};
var pp$2 = Parser.prototype;
pp$2.startNode = function() {
  return new Node(this, this.start, this.startLoc);
};
pp$2.startNodeAt = function(pos, loc) {
  return new Node(this, pos, loc);
};
function finishNodeAt(node2, type5, pos, loc) {
  node2.type = type5;
  node2.end = pos;
  if (this.options.locations) {
    node2.loc.end = loc;
  }
  if (this.options.ranges) {
    node2.range[1] = pos;
  }
  return node2;
}
pp$2.finishNode = function(node2, type5) {
  return finishNodeAt.call(this, node2, type5, this.lastTokEnd, this.lastTokEndLoc);
};
pp$2.finishNodeAt = function(node2, type5, pos, loc) {
  return finishNodeAt.call(this, node2, type5, pos, loc);
};
pp$2.copyNode = function(node2) {
  var newNode = new Node(this, node2.start, this.startLoc);
  for (var prop in node2) {
    newNode[prop] = node2[prop];
  }
  return newNode;
};
var scriptValuesAddedInUnicode = "Gara Garay Gukh Gurung_Khema Hrkt Katakana_Or_Hiragana Kawi Kirat_Rai Krai Nag_Mundari Nagm Ol_Onal Onao Sunu Sunuwar Todhri Todr Tulu_Tigalari Tutg Unknown Zzzz";
var ecma9BinaryProperties = "ASCII ASCII_Hex_Digit AHex Alphabetic Alpha Any Assigned Bidi_Control Bidi_C Bidi_Mirrored Bidi_M Case_Ignorable CI Cased Changes_When_Casefolded CWCF Changes_When_Casemapped CWCM Changes_When_Lowercased CWL Changes_When_NFKC_Casefolded CWKCF Changes_When_Titlecased CWT Changes_When_Uppercased CWU Dash Default_Ignorable_Code_Point DI Deprecated Dep Diacritic Dia Emoji Emoji_Component Emoji_Modifier Emoji_Modifier_Base Emoji_Presentation Extender Ext Grapheme_Base Gr_Base Grapheme_Extend Gr_Ext Hex_Digit Hex IDS_Binary_Operator IDSB IDS_Trinary_Operator IDST ID_Continue IDC ID_Start IDS Ideographic Ideo Join_Control Join_C Logical_Order_Exception LOE Lowercase Lower Math Noncharacter_Code_Point NChar Pattern_Syntax Pat_Syn Pattern_White_Space Pat_WS Quotation_Mark QMark Radical Regional_Indicator RI Sentence_Terminal STerm Soft_Dotted SD Terminal_Punctuation Term Unified_Ideograph UIdeo Uppercase Upper Variation_Selector VS White_Space space XID_Continue XIDC XID_Start XIDS";
var ecma10BinaryProperties = ecma9BinaryProperties + " Extended_Pictographic";
var ecma11BinaryProperties = ecma10BinaryProperties;
var ecma12BinaryProperties = ecma11BinaryProperties + " EBase EComp EMod EPres ExtPict";
var ecma13BinaryProperties = ecma12BinaryProperties;
var ecma14BinaryProperties = ecma13BinaryProperties;
var unicodeBinaryProperties = {
  9: ecma9BinaryProperties,
  10: ecma10BinaryProperties,
  11: ecma11BinaryProperties,
  12: ecma12BinaryProperties,
  13: ecma13BinaryProperties,
  14: ecma14BinaryProperties
};
var ecma14BinaryPropertiesOfStrings = "Basic_Emoji Emoji_Keycap_Sequence RGI_Emoji_Modifier_Sequence RGI_Emoji_Flag_Sequence RGI_Emoji_Tag_Sequence RGI_Emoji_ZWJ_Sequence RGI_Emoji";
var unicodeBinaryPropertiesOfStrings = {
  9: "",
  10: "",
  11: "",
  12: "",
  13: "",
  14: ecma14BinaryPropertiesOfStrings
};
var unicodeGeneralCategoryValues = "Cased_Letter LC Close_Punctuation Pe Connector_Punctuation Pc Control Cc cntrl Currency_Symbol Sc Dash_Punctuation Pd Decimal_Number Nd digit Enclosing_Mark Me Final_Punctuation Pf Format Cf Initial_Punctuation Pi Letter L Letter_Number Nl Line_Separator Zl Lowercase_Letter Ll Mark M Combining_Mark Math_Symbol Sm Modifier_Letter Lm Modifier_Symbol Sk Nonspacing_Mark Mn Number N Open_Punctuation Ps Other C Other_Letter Lo Other_Number No Other_Punctuation Po Other_Symbol So Paragraph_Separator Zp Private_Use Co Punctuation P punct Separator Z Space_Separator Zs Spacing_Mark Mc Surrogate Cs Symbol S Titlecase_Letter Lt Unassigned Cn Uppercase_Letter Lu";
var ecma9ScriptValues = "Adlam Adlm Ahom Anatolian_Hieroglyphs Hluw Arabic Arab Armenian Armn Avestan Avst Balinese Bali Bamum Bamu Bassa_Vah Bass Batak Batk Bengali Beng Bhaiksuki Bhks Bopomofo Bopo Brahmi Brah Braille Brai Buginese Bugi Buhid Buhd Canadian_Aboriginal Cans Carian Cari Caucasian_Albanian Aghb Chakma Cakm Cham Cham Cherokee Cher Common Zyyy Coptic Copt Qaac Cuneiform Xsux Cypriot Cprt Cyrillic Cyrl Deseret Dsrt Devanagari Deva Duployan Dupl Egyptian_Hieroglyphs Egyp Elbasan Elba Ethiopic Ethi Georgian Geor Glagolitic Glag Gothic Goth Grantha Gran Greek Grek Gujarati Gujr Gurmukhi Guru Han Hani Hangul Hang Hanunoo Hano Hatran Hatr Hebrew Hebr Hiragana Hira Imperial_Aramaic Armi Inherited Zinh Qaai Inscriptional_Pahlavi Phli Inscriptional_Parthian Prti Javanese Java Kaithi Kthi Kannada Knda Katakana Kana Kayah_Li Kali Kharoshthi Khar Khmer Khmr Khojki Khoj Khudawadi Sind Lao Laoo Latin Latn Lepcha Lepc Limbu Limb Linear_A Lina Linear_B Linb Lisu Lisu Lycian Lyci Lydian Lydi Mahajani Mahj Malayalam Mlym Mandaic Mand Manichaean Mani Marchen Marc Masaram_Gondi Gonm Meetei_Mayek Mtei Mende_Kikakui Mend Meroitic_Cursive Merc Meroitic_Hieroglyphs Mero Miao Plrd Modi Mongolian Mong Mro Mroo Multani Mult Myanmar Mymr Nabataean Nbat New_Tai_Lue Talu Newa Newa Nko Nkoo Nushu Nshu Ogham Ogam Ol_Chiki Olck Old_Hungarian Hung Old_Italic Ital Old_North_Arabian Narb Old_Permic Perm Old_Persian Xpeo Old_South_Arabian Sarb Old_Turkic Orkh Oriya Orya Osage Osge Osmanya Osma Pahawh_Hmong Hmng Palmyrene Palm Pau_Cin_Hau Pauc Phags_Pa Phag Phoenician Phnx Psalter_Pahlavi Phlp Rejang Rjng Runic Runr Samaritan Samr Saurashtra Saur Sharada Shrd Shavian Shaw Siddham Sidd SignWriting Sgnw Sinhala Sinh Sora_Sompeng Sora Soyombo Soyo Sundanese Sund Syloti_Nagri Sylo Syriac Syrc Tagalog Tglg Tagbanwa Tagb Tai_Le Tale Tai_Tham Lana Tai_Viet Tavt Takri Takr Tamil Taml Tangut Tang Telugu Telu Thaana Thaa Thai Thai Tibetan Tibt Tifinagh Tfng Tirhuta Tirh Ugaritic Ugar Vai Vaii Warang_Citi Wara Yi Yiii Zanabazar_Square Zanb";
var ecma10ScriptValues = ecma9ScriptValues + " Dogra Dogr Gunjala_Gondi Gong Hanifi_Rohingya Rohg Makasar Maka Medefaidrin Medf Old_Sogdian Sogo Sogdian Sogd";
var ecma11ScriptValues = ecma10ScriptValues + " Elymaic Elym Nandinagari Nand Nyiakeng_Puachue_Hmong Hmnp Wancho Wcho";
var ecma12ScriptValues = ecma11ScriptValues + " Chorasmian Chrs Diak Dives_Akuru Khitan_Small_Script Kits Yezi Yezidi";
var ecma13ScriptValues = ecma12ScriptValues + " Cypro_Minoan Cpmn Old_Uyghur Ougr Tangsa Tnsa Toto Vithkuqi Vith";
var ecma14ScriptValues = ecma13ScriptValues + " " + scriptValuesAddedInUnicode;
var unicodeScriptValues = {
  9: ecma9ScriptValues,
  10: ecma10ScriptValues,
  11: ecma11ScriptValues,
  12: ecma12ScriptValues,
  13: ecma13ScriptValues,
  14: ecma14ScriptValues
};
var data = {};
function buildUnicodeData(ecmaVersion) {
  var d = data[ecmaVersion] = {
    binary: wordsRegexp(unicodeBinaryProperties[ecmaVersion] + " " + unicodeGeneralCategoryValues),
    binaryOfStrings: wordsRegexp(unicodeBinaryPropertiesOfStrings[ecmaVersion]),
    nonBinary: {
      General_Category: wordsRegexp(unicodeGeneralCategoryValues),
      Script: wordsRegexp(unicodeScriptValues[ecmaVersion])
    }
  };
  d.nonBinary.Script_Extensions = d.nonBinary.Script;
  d.nonBinary.gc = d.nonBinary.General_Category;
  d.nonBinary.sc = d.nonBinary.Script;
  d.nonBinary.scx = d.nonBinary.Script_Extensions;
}
for (i = 0, list = [9, 10, 11, 12, 13, 14]; i < list.length; i += 1) {
  ecmaVersion = list[i];
  buildUnicodeData(ecmaVersion);
}
var ecmaVersion;
var i;
var list;
var pp$1 = Parser.prototype;
var BranchID = function BranchID2(parent2, base) {
  this.parent = parent2;
  this.base = base || this;
};
BranchID.prototype.separatedFrom = function separatedFrom(alt) {
  for (var self2 = this; self2; self2 = self2.parent) {
    for (var other = alt; other; other = other.parent) {
      if (self2.base === other.base && self2 !== other) {
        return true;
      }
    }
  }
  return false;
};
BranchID.prototype.sibling = function sibling() {
  return new BranchID(this.parent, this.base);
};
var RegExpValidationState = function RegExpValidationState2(parser) {
  this.parser = parser;
  this.validFlags = "gim" + (parser.options.ecmaVersion >= 6 ? "uy" : "") + (parser.options.ecmaVersion >= 9 ? "s" : "") + (parser.options.ecmaVersion >= 13 ? "d" : "") + (parser.options.ecmaVersion >= 15 ? "v" : "");
  this.unicodeProperties = data[parser.options.ecmaVersion >= 14 ? 14 : parser.options.ecmaVersion];
  this.source = "";
  this.flags = "";
  this.start = 0;
  this.switchU = false;
  this.switchV = false;
  this.switchN = false;
  this.pos = 0;
  this.lastIntValue = 0;
  this.lastStringValue = "";
  this.lastAssertionIsQuantifiable = false;
  this.numCapturingParens = 0;
  this.maxBackReference = 0;
  this.groupNames = /* @__PURE__ */ Object.create(null);
  this.backReferenceNames = [];
  this.branchID = null;
};
RegExpValidationState.prototype.reset = function reset(start, pattern6, flags) {
  var unicodeSets = flags.indexOf("v") !== -1;
  var unicode = flags.indexOf("u") !== -1;
  this.start = start | 0;
  this.source = pattern6 + "";
  this.flags = flags;
  if (unicodeSets && this.parser.options.ecmaVersion >= 15) {
    this.switchU = true;
    this.switchV = true;
    this.switchN = true;
  } else {
    this.switchU = unicode && this.parser.options.ecmaVersion >= 6;
    this.switchV = false;
    this.switchN = unicode && this.parser.options.ecmaVersion >= 9;
  }
};
RegExpValidationState.prototype.raise = function raise(message2) {
  this.parser.raiseRecoverable(this.start, "Invalid regular expression: /" + this.source + "/: " + message2);
};
RegExpValidationState.prototype.at = function at(i, forceU) {
  if (forceU === void 0) forceU = false;
  var s = this.source;
  var l2 = s.length;
  if (i >= l2) {
    return -1;
  }
  var c = s.charCodeAt(i);
  if (!(forceU || this.switchU) || c <= 55295 || c >= 57344 || i + 1 >= l2) {
    return c;
  }
  var next2 = s.charCodeAt(i + 1);
  return next2 >= 56320 && next2 <= 57343 ? (c << 10) + next2 - 56613888 : c;
};
RegExpValidationState.prototype.nextIndex = function nextIndex(i, forceU) {
  if (forceU === void 0) forceU = false;
  var s = this.source;
  var l2 = s.length;
  if (i >= l2) {
    return l2;
  }
  var c = s.charCodeAt(i), next2;
  if (!(forceU || this.switchU) || c <= 55295 || c >= 57344 || i + 1 >= l2 || (next2 = s.charCodeAt(i + 1)) < 56320 || next2 > 57343) {
    return i + 1;
  }
  return i + 2;
};
RegExpValidationState.prototype.current = function current(forceU) {
  if (forceU === void 0) forceU = false;
  return this.at(this.pos, forceU);
};
RegExpValidationState.prototype.lookahead = function lookahead(forceU) {
  if (forceU === void 0) forceU = false;
  return this.at(this.nextIndex(this.pos, forceU), forceU);
};
RegExpValidationState.prototype.advance = function advance(forceU) {
  if (forceU === void 0) forceU = false;
  this.pos = this.nextIndex(this.pos, forceU);
};
RegExpValidationState.prototype.eat = function eat(ch, forceU) {
  if (forceU === void 0) forceU = false;
  if (this.current(forceU) === ch) {
    this.advance(forceU);
    return true;
  }
  return false;
};
RegExpValidationState.prototype.eatChars = function eatChars(chs, forceU) {
  if (forceU === void 0) forceU = false;
  var pos = this.pos;
  for (var i = 0, list = chs; i < list.length; i += 1) {
    var ch = list[i];
    var current2 = this.at(pos, forceU);
    if (current2 === -1 || current2 !== ch) {
      return false;
    }
    pos = this.nextIndex(pos, forceU);
  }
  this.pos = pos;
  return true;
};
pp$1.validateRegExpFlags = function(state) {
  var validFlags = state.validFlags;
  var flags = state.flags;
  var u = false;
  var v = false;
  for (var i = 0; i < flags.length; i++) {
    var flag = flags.charAt(i);
    if (validFlags.indexOf(flag) === -1) {
      this.raise(state.start, "Invalid regular expression flag");
    }
    if (flags.indexOf(flag, i + 1) > -1) {
      this.raise(state.start, "Duplicate regular expression flag");
    }
    if (flag === "u") {
      u = true;
    }
    if (flag === "v") {
      v = true;
    }
  }
  if (this.options.ecmaVersion >= 15 && u && v) {
    this.raise(state.start, "Invalid regular expression flag");
  }
};
function hasProp(obj) {
  for (var _ in obj) {
    return true;
  }
  return false;
}
pp$1.validateRegExpPattern = function(state) {
  this.regexp_pattern(state);
  if (!state.switchN && this.options.ecmaVersion >= 9 && hasProp(state.groupNames)) {
    state.switchN = true;
    this.regexp_pattern(state);
  }
};
pp$1.regexp_pattern = function(state) {
  state.pos = 0;
  state.lastIntValue = 0;
  state.lastStringValue = "";
  state.lastAssertionIsQuantifiable = false;
  state.numCapturingParens = 0;
  state.maxBackReference = 0;
  state.groupNames = /* @__PURE__ */ Object.create(null);
  state.backReferenceNames.length = 0;
  state.branchID = null;
  this.regexp_disjunction(state);
  if (state.pos !== state.source.length) {
    if (state.eat(
      41
      /* ) */
    )) {
      state.raise("Unmatched ')'");
    }
    if (state.eat(
      93
      /* ] */
    ) || state.eat(
      125
      /* } */
    )) {
      state.raise("Lone quantifier brackets");
    }
  }
  if (state.maxBackReference > state.numCapturingParens) {
    state.raise("Invalid escape");
  }
  for (var i = 0, list = state.backReferenceNames; i < list.length; i += 1) {
    var name = list[i];
    if (!state.groupNames[name]) {
      state.raise("Invalid named capture referenced");
    }
  }
};
pp$1.regexp_disjunction = function(state) {
  var trackDisjunction = this.options.ecmaVersion >= 16;
  if (trackDisjunction) {
    state.branchID = new BranchID(state.branchID, null);
  }
  this.regexp_alternative(state);
  while (state.eat(
    124
    /* | */
  )) {
    if (trackDisjunction) {
      state.branchID = state.branchID.sibling();
    }
    this.regexp_alternative(state);
  }
  if (trackDisjunction) {
    state.branchID = state.branchID.parent;
  }
  if (this.regexp_eatQuantifier(state, true)) {
    state.raise("Nothing to repeat");
  }
  if (state.eat(
    123
    /* { */
  )) {
    state.raise("Lone quantifier brackets");
  }
};
pp$1.regexp_alternative = function(state) {
  while (state.pos < state.source.length && this.regexp_eatTerm(state)) {
  }
};
pp$1.regexp_eatTerm = function(state) {
  if (this.regexp_eatAssertion(state)) {
    if (state.lastAssertionIsQuantifiable && this.regexp_eatQuantifier(state)) {
      if (state.switchU) {
        state.raise("Invalid quantifier");
      }
    }
    return true;
  }
  if (state.switchU ? this.regexp_eatAtom(state) : this.regexp_eatExtendedAtom(state)) {
    this.regexp_eatQuantifier(state);
    return true;
  }
  return false;
};
pp$1.regexp_eatAssertion = function(state) {
  var start = state.pos;
  state.lastAssertionIsQuantifiable = false;
  if (state.eat(
    94
    /* ^ */
  ) || state.eat(
    36
    /* $ */
  )) {
    return true;
  }
  if (state.eat(
    92
    /* \ */
  )) {
    if (state.eat(
      66
      /* B */
    ) || state.eat(
      98
      /* b */
    )) {
      return true;
    }
    state.pos = start;
  }
  if (state.eat(
    40
    /* ( */
  ) && state.eat(
    63
    /* ? */
  )) {
    var lookbehind = false;
    if (this.options.ecmaVersion >= 9) {
      lookbehind = state.eat(
        60
        /* < */
      );
    }
    if (state.eat(
      61
      /* = */
    ) || state.eat(
      33
      /* ! */
    )) {
      this.regexp_disjunction(state);
      if (!state.eat(
        41
        /* ) */
      )) {
        state.raise("Unterminated group");
      }
      state.lastAssertionIsQuantifiable = !lookbehind;
      return true;
    }
  }
  state.pos = start;
  return false;
};
pp$1.regexp_eatQuantifier = function(state, noError) {
  if (noError === void 0) noError = false;
  if (this.regexp_eatQuantifierPrefix(state, noError)) {
    state.eat(
      63
      /* ? */
    );
    return true;
  }
  return false;
};
pp$1.regexp_eatQuantifierPrefix = function(state, noError) {
  return state.eat(
    42
    /* * */
  ) || state.eat(
    43
    /* + */
  ) || state.eat(
    63
    /* ? */
  ) || this.regexp_eatBracedQuantifier(state, noError);
};
pp$1.regexp_eatBracedQuantifier = function(state, noError) {
  var start = state.pos;
  if (state.eat(
    123
    /* { */
  )) {
    var min = 0, max = -1;
    if (this.regexp_eatDecimalDigits(state)) {
      min = state.lastIntValue;
      if (state.eat(
        44
        /* , */
      ) && this.regexp_eatDecimalDigits(state)) {
        max = state.lastIntValue;
      }
      if (state.eat(
        125
        /* } */
      )) {
        if (max !== -1 && max < min && !noError) {
          state.raise("numbers out of order in {} quantifier");
        }
        return true;
      }
    }
    if (state.switchU && !noError) {
      state.raise("Incomplete quantifier");
    }
    state.pos = start;
  }
  return false;
};
pp$1.regexp_eatAtom = function(state) {
  return this.regexp_eatPatternCharacters(state) || state.eat(
    46
    /* . */
  ) || this.regexp_eatReverseSolidusAtomEscape(state) || this.regexp_eatCharacterClass(state) || this.regexp_eatUncapturingGroup(state) || this.regexp_eatCapturingGroup(state);
};
pp$1.regexp_eatReverseSolidusAtomEscape = function(state) {
  var start = state.pos;
  if (state.eat(
    92
    /* \ */
  )) {
    if (this.regexp_eatAtomEscape(state)) {
      return true;
    }
    state.pos = start;
  }
  return false;
};
pp$1.regexp_eatUncapturingGroup = function(state) {
  var start = state.pos;
  if (state.eat(
    40
    /* ( */
  )) {
    if (state.eat(
      63
      /* ? */
    )) {
      if (this.options.ecmaVersion >= 16) {
        var addModifiers = this.regexp_eatModifiers(state);
        var hasHyphen = state.eat(
          45
          /* - */
        );
        if (addModifiers || hasHyphen) {
          for (var i = 0; i < addModifiers.length; i++) {
            var modifier = addModifiers.charAt(i);
            if (addModifiers.indexOf(modifier, i + 1) > -1) {
              state.raise("Duplicate regular expression modifiers");
            }
          }
          if (hasHyphen) {
            var removeModifiers = this.regexp_eatModifiers(state);
            if (!addModifiers && !removeModifiers && state.current() === 58) {
              state.raise("Invalid regular expression modifiers");
            }
            for (var i$1 = 0; i$1 < removeModifiers.length; i$1++) {
              var modifier$1 = removeModifiers.charAt(i$1);
              if (removeModifiers.indexOf(modifier$1, i$1 + 1) > -1 || addModifiers.indexOf(modifier$1) > -1) {
                state.raise("Duplicate regular expression modifiers");
              }
            }
          }
        }
      }
      if (state.eat(
        58
        /* : */
      )) {
        this.regexp_disjunction(state);
        if (state.eat(
          41
          /* ) */
        )) {
          return true;
        }
        state.raise("Unterminated group");
      }
    }
    state.pos = start;
  }
  return false;
};
pp$1.regexp_eatCapturingGroup = function(state) {
  if (state.eat(
    40
    /* ( */
  )) {
    if (this.options.ecmaVersion >= 9) {
      this.regexp_groupSpecifier(state);
    } else if (state.current() === 63) {
      state.raise("Invalid group");
    }
    this.regexp_disjunction(state);
    if (state.eat(
      41
      /* ) */
    )) {
      state.numCapturingParens += 1;
      return true;
    }
    state.raise("Unterminated group");
  }
  return false;
};
pp$1.regexp_eatModifiers = function(state) {
  var modifiers = "";
  var ch = 0;
  while ((ch = state.current()) !== -1 && isRegularExpressionModifier(ch)) {
    modifiers += codePointToString(ch);
    state.advance();
  }
  return modifiers;
};
function isRegularExpressionModifier(ch) {
  return ch === 105 || ch === 109 || ch === 115;
}
pp$1.regexp_eatExtendedAtom = function(state) {
  return state.eat(
    46
    /* . */
  ) || this.regexp_eatReverseSolidusAtomEscape(state) || this.regexp_eatCharacterClass(state) || this.regexp_eatUncapturingGroup(state) || this.regexp_eatCapturingGroup(state) || this.regexp_eatInvalidBracedQuantifier(state) || this.regexp_eatExtendedPatternCharacter(state);
};
pp$1.regexp_eatInvalidBracedQuantifier = function(state) {
  if (this.regexp_eatBracedQuantifier(state, true)) {
    state.raise("Nothing to repeat");
  }
  return false;
};
pp$1.regexp_eatSyntaxCharacter = function(state) {
  var ch = state.current();
  if (isSyntaxCharacter(ch)) {
    state.lastIntValue = ch;
    state.advance();
    return true;
  }
  return false;
};
function isSyntaxCharacter(ch) {
  return ch === 36 || ch >= 40 && ch <= 43 || ch === 46 || ch === 63 || ch >= 91 && ch <= 94 || ch >= 123 && ch <= 125;
}
pp$1.regexp_eatPatternCharacters = function(state) {
  var start = state.pos;
  var ch = 0;
  while ((ch = state.current()) !== -1 && !isSyntaxCharacter(ch)) {
    state.advance();
  }
  return state.pos !== start;
};
pp$1.regexp_eatExtendedPatternCharacter = function(state) {
  var ch = state.current();
  if (ch !== -1 && ch !== 36 && !(ch >= 40 && ch <= 43) && ch !== 46 && ch !== 63 && ch !== 91 && ch !== 94 && ch !== 124) {
    state.advance();
    return true;
  }
  return false;
};
pp$1.regexp_groupSpecifier = function(state) {
  if (state.eat(
    63
    /* ? */
  )) {
    if (!this.regexp_eatGroupName(state)) {
      state.raise("Invalid group");
    }
    var trackDisjunction = this.options.ecmaVersion >= 16;
    var known = state.groupNames[state.lastStringValue];
    if (known) {
      if (trackDisjunction) {
        for (var i = 0, list = known; i < list.length; i += 1) {
          var altID = list[i];
          if (!altID.separatedFrom(state.branchID)) {
            state.raise("Duplicate capture group name");
          }
        }
      } else {
        state.raise("Duplicate capture group name");
      }
    }
    if (trackDisjunction) {
      (known || (state.groupNames[state.lastStringValue] = [])).push(state.branchID);
    } else {
      state.groupNames[state.lastStringValue] = true;
    }
  }
};
pp$1.regexp_eatGroupName = function(state) {
  state.lastStringValue = "";
  if (state.eat(
    60
    /* < */
  )) {
    if (this.regexp_eatRegExpIdentifierName(state) && state.eat(
      62
      /* > */
    )) {
      return true;
    }
    state.raise("Invalid capture group name");
  }
  return false;
};
pp$1.regexp_eatRegExpIdentifierName = function(state) {
  state.lastStringValue = "";
  if (this.regexp_eatRegExpIdentifierStart(state)) {
    state.lastStringValue += codePointToString(state.lastIntValue);
    while (this.regexp_eatRegExpIdentifierPart(state)) {
      state.lastStringValue += codePointToString(state.lastIntValue);
    }
    return true;
  }
  return false;
};
pp$1.regexp_eatRegExpIdentifierStart = function(state) {
  var start = state.pos;
  var forceU = this.options.ecmaVersion >= 11;
  var ch = state.current(forceU);
  state.advance(forceU);
  if (ch === 92 && this.regexp_eatRegExpUnicodeEscapeSequence(state, forceU)) {
    ch = state.lastIntValue;
  }
  if (isRegExpIdentifierStart(ch)) {
    state.lastIntValue = ch;
    return true;
  }
  state.pos = start;
  return false;
};
function isRegExpIdentifierStart(ch) {
  return isIdentifierStart(ch, true) || ch === 36 || ch === 95;
}
pp$1.regexp_eatRegExpIdentifierPart = function(state) {
  var start = state.pos;
  var forceU = this.options.ecmaVersion >= 11;
  var ch = state.current(forceU);
  state.advance(forceU);
  if (ch === 92 && this.regexp_eatRegExpUnicodeEscapeSequence(state, forceU)) {
    ch = state.lastIntValue;
  }
  if (isRegExpIdentifierPart(ch)) {
    state.lastIntValue = ch;
    return true;
  }
  state.pos = start;
  return false;
};
function isRegExpIdentifierPart(ch) {
  return isIdentifierChar(ch, true) || ch === 36 || ch === 95 || ch === 8204 || ch === 8205;
}
pp$1.regexp_eatAtomEscape = function(state) {
  if (this.regexp_eatBackReference(state) || this.regexp_eatCharacterClassEscape(state) || this.regexp_eatCharacterEscape(state) || state.switchN && this.regexp_eatKGroupName(state)) {
    return true;
  }
  if (state.switchU) {
    if (state.current() === 99) {
      state.raise("Invalid unicode escape");
    }
    state.raise("Invalid escape");
  }
  return false;
};
pp$1.regexp_eatBackReference = function(state) {
  var start = state.pos;
  if (this.regexp_eatDecimalEscape(state)) {
    var n2 = state.lastIntValue;
    if (state.switchU) {
      if (n2 > state.maxBackReference) {
        state.maxBackReference = n2;
      }
      return true;
    }
    if (n2 <= state.numCapturingParens) {
      return true;
    }
    state.pos = start;
  }
  return false;
};
pp$1.regexp_eatKGroupName = function(state) {
  if (state.eat(
    107
    /* k */
  )) {
    if (this.regexp_eatGroupName(state)) {
      state.backReferenceNames.push(state.lastStringValue);
      return true;
    }
    state.raise("Invalid named reference");
  }
  return false;
};
pp$1.regexp_eatCharacterEscape = function(state) {
  return this.regexp_eatControlEscape(state) || this.regexp_eatCControlLetter(state) || this.regexp_eatZero(state) || this.regexp_eatHexEscapeSequence(state) || this.regexp_eatRegExpUnicodeEscapeSequence(state, false) || !state.switchU && this.regexp_eatLegacyOctalEscapeSequence(state) || this.regexp_eatIdentityEscape(state);
};
pp$1.regexp_eatCControlLetter = function(state) {
  var start = state.pos;
  if (state.eat(
    99
    /* c */
  )) {
    if (this.regexp_eatControlLetter(state)) {
      return true;
    }
    state.pos = start;
  }
  return false;
};
pp$1.regexp_eatZero = function(state) {
  if (state.current() === 48 && !isDecimalDigit(state.lookahead())) {
    state.lastIntValue = 0;
    state.advance();
    return true;
  }
  return false;
};
pp$1.regexp_eatControlEscape = function(state) {
  var ch = state.current();
  if (ch === 116) {
    state.lastIntValue = 9;
    state.advance();
    return true;
  }
  if (ch === 110) {
    state.lastIntValue = 10;
    state.advance();
    return true;
  }
  if (ch === 118) {
    state.lastIntValue = 11;
    state.advance();
    return true;
  }
  if (ch === 102) {
    state.lastIntValue = 12;
    state.advance();
    return true;
  }
  if (ch === 114) {
    state.lastIntValue = 13;
    state.advance();
    return true;
  }
  return false;
};
pp$1.regexp_eatControlLetter = function(state) {
  var ch = state.current();
  if (isControlLetter(ch)) {
    state.lastIntValue = ch % 32;
    state.advance();
    return true;
  }
  return false;
};
function isControlLetter(ch) {
  return ch >= 65 && ch <= 90 || ch >= 97 && ch <= 122;
}
pp$1.regexp_eatRegExpUnicodeEscapeSequence = function(state, forceU) {
  if (forceU === void 0) forceU = false;
  var start = state.pos;
  var switchU = forceU || state.switchU;
  if (state.eat(
    117
    /* u */
  )) {
    if (this.regexp_eatFixedHexDigits(state, 4)) {
      var lead = state.lastIntValue;
      if (switchU && lead >= 55296 && lead <= 56319) {
        var leadSurrogateEnd = state.pos;
        if (state.eat(
          92
          /* \ */
        ) && state.eat(
          117
          /* u */
        ) && this.regexp_eatFixedHexDigits(state, 4)) {
          var trail = state.lastIntValue;
          if (trail >= 56320 && trail <= 57343) {
            state.lastIntValue = (lead - 55296) * 1024 + (trail - 56320) + 65536;
            return true;
          }
        }
        state.pos = leadSurrogateEnd;
        state.lastIntValue = lead;
      }
      return true;
    }
    if (switchU && state.eat(
      123
      /* { */
    ) && this.regexp_eatHexDigits(state) && state.eat(
      125
      /* } */
    ) && isValidUnicode(state.lastIntValue)) {
      return true;
    }
    if (switchU) {
      state.raise("Invalid unicode escape");
    }
    state.pos = start;
  }
  return false;
};
function isValidUnicode(ch) {
  return ch >= 0 && ch <= 1114111;
}
pp$1.regexp_eatIdentityEscape = function(state) {
  if (state.switchU) {
    if (this.regexp_eatSyntaxCharacter(state)) {
      return true;
    }
    if (state.eat(
      47
      /* / */
    )) {
      state.lastIntValue = 47;
      return true;
    }
    return false;
  }
  var ch = state.current();
  if (ch !== 99 && (!state.switchN || ch !== 107)) {
    state.lastIntValue = ch;
    state.advance();
    return true;
  }
  return false;
};
pp$1.regexp_eatDecimalEscape = function(state) {
  state.lastIntValue = 0;
  var ch = state.current();
  if (ch >= 49 && ch <= 57) {
    do {
      state.lastIntValue = 10 * state.lastIntValue + (ch - 48);
      state.advance();
    } while ((ch = state.current()) >= 48 && ch <= 57);
    return true;
  }
  return false;
};
var CharSetNone = 0;
var CharSetOk = 1;
var CharSetString = 2;
pp$1.regexp_eatCharacterClassEscape = function(state) {
  var ch = state.current();
  if (isCharacterClassEscape(ch)) {
    state.lastIntValue = -1;
    state.advance();
    return CharSetOk;
  }
  var negate2 = false;
  if (state.switchU && this.options.ecmaVersion >= 9 && ((negate2 = ch === 80) || ch === 112)) {
    state.lastIntValue = -1;
    state.advance();
    var result;
    if (state.eat(
      123
      /* { */
    ) && (result = this.regexp_eatUnicodePropertyValueExpression(state)) && state.eat(
      125
      /* } */
    )) {
      if (negate2 && result === CharSetString) {
        state.raise("Invalid property name");
      }
      return result;
    }
    state.raise("Invalid property name");
  }
  return CharSetNone;
};
function isCharacterClassEscape(ch) {
  return ch === 100 || ch === 68 || ch === 115 || ch === 83 || ch === 119 || ch === 87;
}
pp$1.regexp_eatUnicodePropertyValueExpression = function(state) {
  var start = state.pos;
  if (this.regexp_eatUnicodePropertyName(state) && state.eat(
    61
    /* = */
  )) {
    var name = state.lastStringValue;
    if (this.regexp_eatUnicodePropertyValue(state)) {
      var value = state.lastStringValue;
      this.regexp_validateUnicodePropertyNameAndValue(state, name, value);
      return CharSetOk;
    }
  }
  state.pos = start;
  if (this.regexp_eatLoneUnicodePropertyNameOrValue(state)) {
    var nameOrValue = state.lastStringValue;
    return this.regexp_validateUnicodePropertyNameOrValue(state, nameOrValue);
  }
  return CharSetNone;
};
pp$1.regexp_validateUnicodePropertyNameAndValue = function(state, name, value) {
  if (!hasOwn(state.unicodeProperties.nonBinary, name)) {
    state.raise("Invalid property name");
  }
  if (!state.unicodeProperties.nonBinary[name].test(value)) {
    state.raise("Invalid property value");
  }
};
pp$1.regexp_validateUnicodePropertyNameOrValue = function(state, nameOrValue) {
  if (state.unicodeProperties.binary.test(nameOrValue)) {
    return CharSetOk;
  }
  if (state.switchV && state.unicodeProperties.binaryOfStrings.test(nameOrValue)) {
    return CharSetString;
  }
  state.raise("Invalid property name");
};
pp$1.regexp_eatUnicodePropertyName = function(state) {
  var ch = 0;
  state.lastStringValue = "";
  while (isUnicodePropertyNameCharacter(ch = state.current())) {
    state.lastStringValue += codePointToString(ch);
    state.advance();
  }
  return state.lastStringValue !== "";
};
function isUnicodePropertyNameCharacter(ch) {
  return isControlLetter(ch) || ch === 95;
}
pp$1.regexp_eatUnicodePropertyValue = function(state) {
  var ch = 0;
  state.lastStringValue = "";
  while (isUnicodePropertyValueCharacter(ch = state.current())) {
    state.lastStringValue += codePointToString(ch);
    state.advance();
  }
  return state.lastStringValue !== "";
};
function isUnicodePropertyValueCharacter(ch) {
  return isUnicodePropertyNameCharacter(ch) || isDecimalDigit(ch);
}
pp$1.regexp_eatLoneUnicodePropertyNameOrValue = function(state) {
  return this.regexp_eatUnicodePropertyValue(state);
};
pp$1.regexp_eatCharacterClass = function(state) {
  if (state.eat(
    91
    /* [ */
  )) {
    var negate2 = state.eat(
      94
      /* ^ */
    );
    var result = this.regexp_classContents(state);
    if (!state.eat(
      93
      /* ] */
    )) {
      state.raise("Unterminated character class");
    }
    if (negate2 && result === CharSetString) {
      state.raise("Negated character class may contain strings");
    }
    return true;
  }
  return false;
};
pp$1.regexp_classContents = function(state) {
  if (state.current() === 93) {
    return CharSetOk;
  }
  if (state.switchV) {
    return this.regexp_classSetExpression(state);
  }
  this.regexp_nonEmptyClassRanges(state);
  return CharSetOk;
};
pp$1.regexp_nonEmptyClassRanges = function(state) {
  while (this.regexp_eatClassAtom(state)) {
    var left2 = state.lastIntValue;
    if (state.eat(
      45
      /* - */
    ) && this.regexp_eatClassAtom(state)) {
      var right2 = state.lastIntValue;
      if (state.switchU && (left2 === -1 || right2 === -1)) {
        state.raise("Invalid character class");
      }
      if (left2 !== -1 && right2 !== -1 && left2 > right2) {
        state.raise("Range out of order in character class");
      }
    }
  }
};
pp$1.regexp_eatClassAtom = function(state) {
  var start = state.pos;
  if (state.eat(
    92
    /* \ */
  )) {
    if (this.regexp_eatClassEscape(state)) {
      return true;
    }
    if (state.switchU) {
      var ch$1 = state.current();
      if (ch$1 === 99 || isOctalDigit(ch$1)) {
        state.raise("Invalid class escape");
      }
      state.raise("Invalid escape");
    }
    state.pos = start;
  }
  var ch = state.current();
  if (ch !== 93) {
    state.lastIntValue = ch;
    state.advance();
    return true;
  }
  return false;
};
pp$1.regexp_eatClassEscape = function(state) {
  var start = state.pos;
  if (state.eat(
    98
    /* b */
  )) {
    state.lastIntValue = 8;
    return true;
  }
  if (state.switchU && state.eat(
    45
    /* - */
  )) {
    state.lastIntValue = 45;
    return true;
  }
  if (!state.switchU && state.eat(
    99
    /* c */
  )) {
    if (this.regexp_eatClassControlLetter(state)) {
      return true;
    }
    state.pos = start;
  }
  return this.regexp_eatCharacterClassEscape(state) || this.regexp_eatCharacterEscape(state);
};
pp$1.regexp_classSetExpression = function(state) {
  var result = CharSetOk, subResult;
  if (this.regexp_eatClassSetRange(state)) ;
  else if (subResult = this.regexp_eatClassSetOperand(state)) {
    if (subResult === CharSetString) {
      result = CharSetString;
    }
    var start = state.pos;
    while (state.eatChars(
      [38, 38]
      /* && */
    )) {
      if (state.current() !== 38 && (subResult = this.regexp_eatClassSetOperand(state))) {
        if (subResult !== CharSetString) {
          result = CharSetOk;
        }
        continue;
      }
      state.raise("Invalid character in character class");
    }
    if (start !== state.pos) {
      return result;
    }
    while (state.eatChars(
      [45, 45]
      /* -- */
    )) {
      if (this.regexp_eatClassSetOperand(state)) {
        continue;
      }
      state.raise("Invalid character in character class");
    }
    if (start !== state.pos) {
      return result;
    }
  } else {
    state.raise("Invalid character in character class");
  }
  for (; ; ) {
    if (this.regexp_eatClassSetRange(state)) {
      continue;
    }
    subResult = this.regexp_eatClassSetOperand(state);
    if (!subResult) {
      return result;
    }
    if (subResult === CharSetString) {
      result = CharSetString;
    }
  }
};
pp$1.regexp_eatClassSetRange = function(state) {
  var start = state.pos;
  if (this.regexp_eatClassSetCharacter(state)) {
    var left2 = state.lastIntValue;
    if (state.eat(
      45
      /* - */
    ) && this.regexp_eatClassSetCharacter(state)) {
      var right2 = state.lastIntValue;
      if (left2 !== -1 && right2 !== -1 && left2 > right2) {
        state.raise("Range out of order in character class");
      }
      return true;
    }
    state.pos = start;
  }
  return false;
};
pp$1.regexp_eatClassSetOperand = function(state) {
  if (this.regexp_eatClassSetCharacter(state)) {
    return CharSetOk;
  }
  return this.regexp_eatClassStringDisjunction(state) || this.regexp_eatNestedClass(state);
};
pp$1.regexp_eatNestedClass = function(state) {
  var start = state.pos;
  if (state.eat(
    91
    /* [ */
  )) {
    var negate2 = state.eat(
      94
      /* ^ */
    );
    var result = this.regexp_classContents(state);
    if (state.eat(
      93
      /* ] */
    )) {
      if (negate2 && result === CharSetString) {
        state.raise("Negated character class may contain strings");
      }
      return result;
    }
    state.pos = start;
  }
  if (state.eat(
    92
    /* \ */
  )) {
    var result$1 = this.regexp_eatCharacterClassEscape(state);
    if (result$1) {
      return result$1;
    }
    state.pos = start;
  }
  return null;
};
pp$1.regexp_eatClassStringDisjunction = function(state) {
  var start = state.pos;
  if (state.eatChars(
    [92, 113]
    /* \q */
  )) {
    if (state.eat(
      123
      /* { */
    )) {
      var result = this.regexp_classStringDisjunctionContents(state);
      if (state.eat(
        125
        /* } */
      )) {
        return result;
      }
    } else {
      state.raise("Invalid escape");
    }
    state.pos = start;
  }
  return null;
};
pp$1.regexp_classStringDisjunctionContents = function(state) {
  var result = this.regexp_classString(state);
  while (state.eat(
    124
    /* | */
  )) {
    if (this.regexp_classString(state) === CharSetString) {
      result = CharSetString;
    }
  }
  return result;
};
pp$1.regexp_classString = function(state) {
  var count = 0;
  while (this.regexp_eatClassSetCharacter(state)) {
    count++;
  }
  return count === 1 ? CharSetOk : CharSetString;
};
pp$1.regexp_eatClassSetCharacter = function(state) {
  var start = state.pos;
  if (state.eat(
    92
    /* \ */
  )) {
    if (this.regexp_eatCharacterEscape(state) || this.regexp_eatClassSetReservedPunctuator(state)) {
      return true;
    }
    if (state.eat(
      98
      /* b */
    )) {
      state.lastIntValue = 8;
      return true;
    }
    state.pos = start;
    return false;
  }
  var ch = state.current();
  if (ch < 0 || ch === state.lookahead() && isClassSetReservedDoublePunctuatorCharacter(ch)) {
    return false;
  }
  if (isClassSetSyntaxCharacter(ch)) {
    return false;
  }
  state.advance();
  state.lastIntValue = ch;
  return true;
};
function isClassSetReservedDoublePunctuatorCharacter(ch) {
  return ch === 33 || ch >= 35 && ch <= 38 || ch >= 42 && ch <= 44 || ch === 46 || ch >= 58 && ch <= 64 || ch === 94 || ch === 96 || ch === 126;
}
function isClassSetSyntaxCharacter(ch) {
  return ch === 40 || ch === 41 || ch === 45 || ch === 47 || ch >= 91 && ch <= 93 || ch >= 123 && ch <= 125;
}
pp$1.regexp_eatClassSetReservedPunctuator = function(state) {
  var ch = state.current();
  if (isClassSetReservedPunctuator(ch)) {
    state.lastIntValue = ch;
    state.advance();
    return true;
  }
  return false;
};
function isClassSetReservedPunctuator(ch) {
  return ch === 33 || ch === 35 || ch === 37 || ch === 38 || ch === 44 || ch === 45 || ch >= 58 && ch <= 62 || ch === 64 || ch === 96 || ch === 126;
}
pp$1.regexp_eatClassControlLetter = function(state) {
  var ch = state.current();
  if (isDecimalDigit(ch) || ch === 95) {
    state.lastIntValue = ch % 32;
    state.advance();
    return true;
  }
  return false;
};
pp$1.regexp_eatHexEscapeSequence = function(state) {
  var start = state.pos;
  if (state.eat(
    120
    /* x */
  )) {
    if (this.regexp_eatFixedHexDigits(state, 2)) {
      return true;
    }
    if (state.switchU) {
      state.raise("Invalid escape");
    }
    state.pos = start;
  }
  return false;
};
pp$1.regexp_eatDecimalDigits = function(state) {
  var start = state.pos;
  var ch = 0;
  state.lastIntValue = 0;
  while (isDecimalDigit(ch = state.current())) {
    state.lastIntValue = 10 * state.lastIntValue + (ch - 48);
    state.advance();
  }
  return state.pos !== start;
};
function isDecimalDigit(ch) {
  return ch >= 48 && ch <= 57;
}
pp$1.regexp_eatHexDigits = function(state) {
  var start = state.pos;
  var ch = 0;
  state.lastIntValue = 0;
  while (isHexDigit(ch = state.current())) {
    state.lastIntValue = 16 * state.lastIntValue + hexToInt(ch);
    state.advance();
  }
  return state.pos !== start;
};
function isHexDigit(ch) {
  return ch >= 48 && ch <= 57 || ch >= 65 && ch <= 70 || ch >= 97 && ch <= 102;
}
function hexToInt(ch) {
  if (ch >= 65 && ch <= 70) {
    return 10 + (ch - 65);
  }
  if (ch >= 97 && ch <= 102) {
    return 10 + (ch - 97);
  }
  return ch - 48;
}
pp$1.regexp_eatLegacyOctalEscapeSequence = function(state) {
  if (this.regexp_eatOctalDigit(state)) {
    var n1 = state.lastIntValue;
    if (this.regexp_eatOctalDigit(state)) {
      var n2 = state.lastIntValue;
      if (n1 <= 3 && this.regexp_eatOctalDigit(state)) {
        state.lastIntValue = n1 * 64 + n2 * 8 + state.lastIntValue;
      } else {
        state.lastIntValue = n1 * 8 + n2;
      }
    } else {
      state.lastIntValue = n1;
    }
    return true;
  }
  return false;
};
pp$1.regexp_eatOctalDigit = function(state) {
  var ch = state.current();
  if (isOctalDigit(ch)) {
    state.lastIntValue = ch - 48;
    state.advance();
    return true;
  }
  state.lastIntValue = 0;
  return false;
};
function isOctalDigit(ch) {
  return ch >= 48 && ch <= 55;
}
pp$1.regexp_eatFixedHexDigits = function(state, length2) {
  var start = state.pos;
  state.lastIntValue = 0;
  for (var i = 0; i < length2; ++i) {
    var ch = state.current();
    if (!isHexDigit(ch)) {
      state.pos = start;
      return false;
    }
    state.lastIntValue = 16 * state.lastIntValue + hexToInt(ch);
    state.advance();
  }
  return true;
};
var Token = function Token2(p) {
  this.type = p.type;
  this.value = p.value;
  this.start = p.start;
  this.end = p.end;
  if (p.options.locations) {
    this.loc = new SourceLocation(p, p.startLoc, p.endLoc);
  }
  if (p.options.ranges) {
    this.range = [p.start, p.end];
  }
};
var pp = Parser.prototype;
pp.next = function(ignoreEscapeSequenceInKeyword) {
  if (!ignoreEscapeSequenceInKeyword && this.type.keyword && this.containsEsc) {
    this.raiseRecoverable(this.start, "Escape sequence in keyword " + this.type.keyword);
  }
  if (this.options.onToken) {
    this.options.onToken(new Token(this));
  }
  this.lastTokEnd = this.end;
  this.lastTokStart = this.start;
  this.lastTokEndLoc = this.endLoc;
  this.lastTokStartLoc = this.startLoc;
  this.nextToken();
};
pp.getToken = function() {
  this.next();
  return new Token(this);
};
if (typeof Symbol !== "undefined") {
  pp[Symbol.iterator] = function() {
    var this$1$1 = this;
    return {
      next: function() {
        var token2 = this$1$1.getToken();
        return {
          done: token2.type === types$1.eof,
          value: token2
        };
      }
    };
  };
}
pp.nextToken = function() {
  var curContext = this.curContext();
  if (!curContext || !curContext.preserveSpace) {
    this.skipSpace();
  }
  this.start = this.pos;
  if (this.options.locations) {
    this.startLoc = this.curPosition();
  }
  if (this.pos >= this.input.length) {
    return this.finishToken(types$1.eof);
  }
  if (curContext.override) {
    return curContext.override(this);
  } else {
    this.readToken(this.fullCharCodeAtPos());
  }
};
pp.readToken = function(code2) {
  if (isIdentifierStart(code2, this.options.ecmaVersion >= 6) || code2 === 92) {
    return this.readWord();
  }
  return this.getTokenFromCode(code2);
};
pp.fullCharCodeAtPos = function() {
  var code2 = this.input.charCodeAt(this.pos);
  if (code2 <= 55295 || code2 >= 56320) {
    return code2;
  }
  var next2 = this.input.charCodeAt(this.pos + 1);
  return next2 <= 56319 || next2 >= 57344 ? code2 : (code2 << 10) + next2 - 56613888;
};
pp.skipBlockComment = function() {
  var startLoc = this.options.onComment && this.curPosition();
  var start = this.pos, end = this.input.indexOf("*/", this.pos += 2);
  if (end === -1) {
    this.raise(this.pos - 2, "Unterminated comment");
  }
  this.pos = end + 2;
  if (this.options.locations) {
    for (var nextBreak = void 0, pos = start; (nextBreak = nextLineBreak(this.input, pos, this.pos)) > -1; ) {
      ++this.curLine;
      pos = this.lineStart = nextBreak;
    }
  }
  if (this.options.onComment) {
    this.options.onComment(
      true,
      this.input.slice(start + 2, end),
      start,
      this.pos,
      startLoc,
      this.curPosition()
    );
  }
};
pp.skipLineComment = function(startSkip) {
  var start = this.pos;
  var startLoc = this.options.onComment && this.curPosition();
  var ch = this.input.charCodeAt(this.pos += startSkip);
  while (this.pos < this.input.length && !isNewLine(ch)) {
    ch = this.input.charCodeAt(++this.pos);
  }
  if (this.options.onComment) {
    this.options.onComment(
      false,
      this.input.slice(start + startSkip, this.pos),
      start,
      this.pos,
      startLoc,
      this.curPosition()
    );
  }
};
pp.skipSpace = function() {
  loop: while (this.pos < this.input.length) {
    var ch = this.input.charCodeAt(this.pos);
    switch (ch) {
      case 32:
      case 160:
        ++this.pos;
        break;
      case 13:
        if (this.input.charCodeAt(this.pos + 1) === 10) {
          ++this.pos;
        }
      case 10:
      case 8232:
      case 8233:
        ++this.pos;
        if (this.options.locations) {
          ++this.curLine;
          this.lineStart = this.pos;
        }
        break;
      case 47:
        switch (this.input.charCodeAt(this.pos + 1)) {
          case 42:
            this.skipBlockComment();
            break;
          case 47:
            this.skipLineComment(2);
            break;
          default:
            break loop;
        }
        break;
      default:
        if (ch > 8 && ch < 14 || ch >= 5760 && nonASCIIwhitespace.test(String.fromCharCode(ch))) {
          ++this.pos;
        } else {
          break loop;
        }
    }
  }
};
pp.finishToken = function(type5, val) {
  this.end = this.pos;
  if (this.options.locations) {
    this.endLoc = this.curPosition();
  }
  var prevType = this.type;
  this.type = type5;
  this.value = val;
  this.updateContext(prevType);
};
pp.readToken_dot = function() {
  var next2 = this.input.charCodeAt(this.pos + 1);
  if (next2 >= 48 && next2 <= 57) {
    return this.readNumber(true);
  }
  var next22 = this.input.charCodeAt(this.pos + 2);
  if (this.options.ecmaVersion >= 6 && next2 === 46 && next22 === 46) {
    this.pos += 3;
    return this.finishToken(types$1.ellipsis);
  } else {
    ++this.pos;
    return this.finishToken(types$1.dot);
  }
};
pp.readToken_slash = function() {
  var next2 = this.input.charCodeAt(this.pos + 1);
  if (this.exprAllowed) {
    ++this.pos;
    return this.readRegexp();
  }
  if (next2 === 61) {
    return this.finishOp(types$1.assign, 2);
  }
  return this.finishOp(types$1.slash, 1);
};
pp.readToken_mult_modulo_exp = function(code2) {
  var next2 = this.input.charCodeAt(this.pos + 1);
  var size = 1;
  var tokentype = code2 === 42 ? types$1.star : types$1.modulo;
  if (this.options.ecmaVersion >= 7 && code2 === 42 && next2 === 42) {
    ++size;
    tokentype = types$1.starstar;
    next2 = this.input.charCodeAt(this.pos + 2);
  }
  if (next2 === 61) {
    return this.finishOp(types$1.assign, size + 1);
  }
  return this.finishOp(tokentype, size);
};
pp.readToken_pipe_amp = function(code2) {
  var next2 = this.input.charCodeAt(this.pos + 1);
  if (next2 === code2) {
    if (this.options.ecmaVersion >= 12) {
      var next22 = this.input.charCodeAt(this.pos + 2);
      if (next22 === 61) {
        return this.finishOp(types$1.assign, 3);
      }
    }
    return this.finishOp(code2 === 124 ? types$1.logicalOR : types$1.logicalAND, 2);
  }
  if (next2 === 61) {
    return this.finishOp(types$1.assign, 2);
  }
  return this.finishOp(code2 === 124 ? types$1.bitwiseOR : types$1.bitwiseAND, 1);
};
pp.readToken_caret = function() {
  var next2 = this.input.charCodeAt(this.pos + 1);
  if (next2 === 61) {
    return this.finishOp(types$1.assign, 2);
  }
  return this.finishOp(types$1.bitwiseXOR, 1);
};
pp.readToken_plus_min = function(code2) {
  var next2 = this.input.charCodeAt(this.pos + 1);
  if (next2 === code2) {
    if (next2 === 45 && !this.inModule && this.input.charCodeAt(this.pos + 2) === 62 && (this.lastTokEnd === 0 || lineBreak.test(this.input.slice(this.lastTokEnd, this.pos)))) {
      this.skipLineComment(3);
      this.skipSpace();
      return this.nextToken();
    }
    return this.finishOp(types$1.incDec, 2);
  }
  if (next2 === 61) {
    return this.finishOp(types$1.assign, 2);
  }
  return this.finishOp(types$1.plusMin, 1);
};
pp.readToken_lt_gt = function(code2) {
  var next2 = this.input.charCodeAt(this.pos + 1);
  var size = 1;
  if (next2 === code2) {
    size = code2 === 62 && this.input.charCodeAt(this.pos + 2) === 62 ? 3 : 2;
    if (this.input.charCodeAt(this.pos + size) === 61) {
      return this.finishOp(types$1.assign, size + 1);
    }
    return this.finishOp(types$1.bitShift, size);
  }
  if (next2 === 33 && code2 === 60 && !this.inModule && this.input.charCodeAt(this.pos + 2) === 45 && this.input.charCodeAt(this.pos + 3) === 45) {
    this.skipLineComment(4);
    this.skipSpace();
    return this.nextToken();
  }
  if (next2 === 61) {
    size = 2;
  }
  return this.finishOp(types$1.relational, size);
};
pp.readToken_eq_excl = function(code2) {
  var next2 = this.input.charCodeAt(this.pos + 1);
  if (next2 === 61) {
    return this.finishOp(types$1.equality, this.input.charCodeAt(this.pos + 2) === 61 ? 3 : 2);
  }
  if (code2 === 61 && next2 === 62 && this.options.ecmaVersion >= 6) {
    this.pos += 2;
    return this.finishToken(types$1.arrow);
  }
  return this.finishOp(code2 === 61 ? types$1.eq : types$1.prefix, 1);
};
pp.readToken_question = function() {
  var ecmaVersion = this.options.ecmaVersion;
  if (ecmaVersion >= 11) {
    var next2 = this.input.charCodeAt(this.pos + 1);
    if (next2 === 46) {
      var next22 = this.input.charCodeAt(this.pos + 2);
      if (next22 < 48 || next22 > 57) {
        return this.finishOp(types$1.questionDot, 2);
      }
    }
    if (next2 === 63) {
      if (ecmaVersion >= 12) {
        var next2$1 = this.input.charCodeAt(this.pos + 2);
        if (next2$1 === 61) {
          return this.finishOp(types$1.assign, 3);
        }
      }
      return this.finishOp(types$1.coalesce, 2);
    }
  }
  return this.finishOp(types$1.question, 1);
};
pp.readToken_numberSign = function() {
  var ecmaVersion = this.options.ecmaVersion;
  var code2 = 35;
  if (ecmaVersion >= 13) {
    ++this.pos;
    code2 = this.fullCharCodeAtPos();
    if (isIdentifierStart(code2, true) || code2 === 92) {
      return this.finishToken(types$1.privateId, this.readWord1());
    }
  }
  this.raise(this.pos, "Unexpected character '" + codePointToString(code2) + "'");
};
pp.getTokenFromCode = function(code2) {
  switch (code2) {
    // The interpretation of a dot depends on whether it is followed
    // by a digit or another two dots.
    case 46:
      return this.readToken_dot();
    // Punctuation tokens.
    case 40:
      ++this.pos;
      return this.finishToken(types$1.parenL);
    case 41:
      ++this.pos;
      return this.finishToken(types$1.parenR);
    case 59:
      ++this.pos;
      return this.finishToken(types$1.semi);
    case 44:
      ++this.pos;
      return this.finishToken(types$1.comma);
    case 91:
      ++this.pos;
      return this.finishToken(types$1.bracketL);
    case 93:
      ++this.pos;
      return this.finishToken(types$1.bracketR);
    case 123:
      ++this.pos;
      return this.finishToken(types$1.braceL);
    case 125:
      ++this.pos;
      return this.finishToken(types$1.braceR);
    case 58:
      ++this.pos;
      return this.finishToken(types$1.colon);
    case 96:
      if (this.options.ecmaVersion < 6) {
        break;
      }
      ++this.pos;
      return this.finishToken(types$1.backQuote);
    case 48:
      var next2 = this.input.charCodeAt(this.pos + 1);
      if (next2 === 120 || next2 === 88) {
        return this.readRadixNumber(16);
      }
      if (this.options.ecmaVersion >= 6) {
        if (next2 === 111 || next2 === 79) {
          return this.readRadixNumber(8);
        }
        if (next2 === 98 || next2 === 66) {
          return this.readRadixNumber(2);
        }
      }
    // Anything else beginning with a digit is an integer, octal
    // number, or float.
    case 49:
    case 50:
    case 51:
    case 52:
    case 53:
    case 54:
    case 55:
    case 56:
    case 57:
      return this.readNumber(false);
    // Quotes produce strings.
    case 34:
    case 39:
      return this.readString(code2);
    // Operators are parsed inline in tiny state machines. '=' (61) is
    // often referred to. `finishOp` simply skips the amount of
    // characters it is given as second argument, and returns a token
    // of the type given by its first argument.
    case 47:
      return this.readToken_slash();
    case 37:
    case 42:
      return this.readToken_mult_modulo_exp(code2);
    case 124:
    case 38:
      return this.readToken_pipe_amp(code2);
    case 94:
      return this.readToken_caret();
    case 43:
    case 45:
      return this.readToken_plus_min(code2);
    case 60:
    case 62:
      return this.readToken_lt_gt(code2);
    case 61:
    case 33:
      return this.readToken_eq_excl(code2);
    case 63:
      return this.readToken_question();
    case 126:
      return this.finishOp(types$1.prefix, 1);
    case 35:
      return this.readToken_numberSign();
  }
  this.raise(this.pos, "Unexpected character '" + codePointToString(code2) + "'");
};
pp.finishOp = function(type5, size) {
  var str = this.input.slice(this.pos, this.pos + size);
  this.pos += size;
  return this.finishToken(type5, str);
};
pp.readRegexp = function() {
  var escaped, inClass, start = this.pos;
  for (; ; ) {
    if (this.pos >= this.input.length) {
      this.raise(start, "Unterminated regular expression");
    }
    var ch = this.input.charAt(this.pos);
    if (lineBreak.test(ch)) {
      this.raise(start, "Unterminated regular expression");
    }
    if (!escaped) {
      if (ch === "[") {
        inClass = true;
      } else if (ch === "]" && inClass) {
        inClass = false;
      } else if (ch === "/" && !inClass) {
        break;
      }
      escaped = ch === "\\";
    } else {
      escaped = false;
    }
    ++this.pos;
  }
  var pattern6 = this.input.slice(start, this.pos);
  ++this.pos;
  var flagsStart = this.pos;
  var flags = this.readWord1();
  if (this.containsEsc) {
    this.unexpected(flagsStart);
  }
  var state = this.regexpState || (this.regexpState = new RegExpValidationState(this));
  state.reset(start, pattern6, flags);
  this.validateRegExpFlags(state);
  this.validateRegExpPattern(state);
  var value = null;
  try {
    value = new RegExp(pattern6, flags);
  } catch (e3) {
  }
  return this.finishToken(types$1.regexp, { pattern: pattern6, flags, value });
};
pp.readInt = function(radix, len, maybeLegacyOctalNumericLiteral) {
  var allowSeparators = this.options.ecmaVersion >= 12 && len === void 0;
  var isLegacyOctalNumericLiteral = maybeLegacyOctalNumericLiteral && this.input.charCodeAt(this.pos) === 48;
  var start = this.pos, total = 0, lastCode = 0;
  for (var i = 0, e3 = len == null ? Infinity : len; i < e3; ++i, ++this.pos) {
    var code2 = this.input.charCodeAt(this.pos), val = void 0;
    if (allowSeparators && code2 === 95) {
      if (isLegacyOctalNumericLiteral) {
        this.raiseRecoverable(this.pos, "Numeric separator is not allowed in legacy octal numeric literals");
      }
      if (lastCode === 95) {
        this.raiseRecoverable(this.pos, "Numeric separator must be exactly one underscore");
      }
      if (i === 0) {
        this.raiseRecoverable(this.pos, "Numeric separator is not allowed at the first of digits");
      }
      lastCode = code2;
      continue;
    }
    if (code2 >= 97) {
      val = code2 - 97 + 10;
    } else if (code2 >= 65) {
      val = code2 - 65 + 10;
    } else if (code2 >= 48 && code2 <= 57) {
      val = code2 - 48;
    } else {
      val = Infinity;
    }
    if (val >= radix) {
      break;
    }
    lastCode = code2;
    total = total * radix + val;
  }
  if (allowSeparators && lastCode === 95) {
    this.raiseRecoverable(this.pos - 1, "Numeric separator is not allowed at the last of digits");
  }
  if (this.pos === start || len != null && this.pos - start !== len) {
    return null;
  }
  return total;
};
function stringToNumber(str, isLegacyOctalNumericLiteral) {
  if (isLegacyOctalNumericLiteral) {
    return parseInt(str, 8);
  }
  return parseFloat(str.replace(/_/g, ""));
}
function stringToBigInt(str) {
  if (typeof BigInt !== "function") {
    return null;
  }
  return BigInt(str.replace(/_/g, ""));
}
pp.readRadixNumber = function(radix) {
  var start = this.pos;
  this.pos += 2;
  var val = this.readInt(radix);
  if (val == null) {
    this.raise(this.start + 2, "Expected number in radix " + radix);
  }
  if (this.options.ecmaVersion >= 11 && this.input.charCodeAt(this.pos) === 110) {
    val = stringToBigInt(this.input.slice(start, this.pos));
    ++this.pos;
  } else if (isIdentifierStart(this.fullCharCodeAtPos())) {
    this.raise(this.pos, "Identifier directly after number");
  }
  return this.finishToken(types$1.num, val);
};
pp.readNumber = function(startsWithDot) {
  var start = this.pos;
  if (!startsWithDot && this.readInt(10, void 0, true) === null) {
    this.raise(start, "Invalid number");
  }
  var octal = this.pos - start >= 2 && this.input.charCodeAt(start) === 48;
  if (octal && this.strict) {
    this.raise(start, "Invalid number");
  }
  var next2 = this.input.charCodeAt(this.pos);
  if (!octal && !startsWithDot && this.options.ecmaVersion >= 11 && next2 === 110) {
    var val$1 = stringToBigInt(this.input.slice(start, this.pos));
    ++this.pos;
    if (isIdentifierStart(this.fullCharCodeAtPos())) {
      this.raise(this.pos, "Identifier directly after number");
    }
    return this.finishToken(types$1.num, val$1);
  }
  if (octal && /[89]/.test(this.input.slice(start, this.pos))) {
    octal = false;
  }
  if (next2 === 46 && !octal) {
    ++this.pos;
    this.readInt(10);
    next2 = this.input.charCodeAt(this.pos);
  }
  if ((next2 === 69 || next2 === 101) && !octal) {
    next2 = this.input.charCodeAt(++this.pos);
    if (next2 === 43 || next2 === 45) {
      ++this.pos;
    }
    if (this.readInt(10) === null) {
      this.raise(start, "Invalid number");
    }
  }
  if (isIdentifierStart(this.fullCharCodeAtPos())) {
    this.raise(this.pos, "Identifier directly after number");
  }
  var val = stringToNumber(this.input.slice(start, this.pos), octal);
  return this.finishToken(types$1.num, val);
};
pp.readCodePoint = function() {
  var ch = this.input.charCodeAt(this.pos), code2;
  if (ch === 123) {
    if (this.options.ecmaVersion < 6) {
      this.unexpected();
    }
    var codePos = ++this.pos;
    code2 = this.readHexChar(this.input.indexOf("}", this.pos) - this.pos);
    ++this.pos;
    if (code2 > 1114111) {
      this.invalidStringToken(codePos, "Code point out of bounds");
    }
  } else {
    code2 = this.readHexChar(4);
  }
  return code2;
};
pp.readString = function(quote) {
  var out = "", chunkStart = ++this.pos;
  for (; ; ) {
    if (this.pos >= this.input.length) {
      this.raise(this.start, "Unterminated string constant");
    }
    var ch = this.input.charCodeAt(this.pos);
    if (ch === quote) {
      break;
    }
    if (ch === 92) {
      out += this.input.slice(chunkStart, this.pos);
      out += this.readEscapedChar(false);
      chunkStart = this.pos;
    } else if (ch === 8232 || ch === 8233) {
      if (this.options.ecmaVersion < 10) {
        this.raise(this.start, "Unterminated string constant");
      }
      ++this.pos;
      if (this.options.locations) {
        this.curLine++;
        this.lineStart = this.pos;
      }
    } else {
      if (isNewLine(ch)) {
        this.raise(this.start, "Unterminated string constant");
      }
      ++this.pos;
    }
  }
  out += this.input.slice(chunkStart, this.pos++);
  return this.finishToken(types$1.string, out);
};
var INVALID_TEMPLATE_ESCAPE_ERROR = {};
pp.tryReadTemplateToken = function() {
  this.inTemplateElement = true;
  try {
    this.readTmplToken();
  } catch (err) {
    if (err === INVALID_TEMPLATE_ESCAPE_ERROR) {
      this.readInvalidTemplateToken();
    } else {
      throw err;
    }
  }
  this.inTemplateElement = false;
};
pp.invalidStringToken = function(position3, message2) {
  if (this.inTemplateElement && this.options.ecmaVersion >= 9) {
    throw INVALID_TEMPLATE_ESCAPE_ERROR;
  } else {
    this.raise(position3, message2);
  }
};
pp.readTmplToken = function() {
  var out = "", chunkStart = this.pos;
  for (; ; ) {
    if (this.pos >= this.input.length) {
      this.raise(this.start, "Unterminated template");
    }
    var ch = this.input.charCodeAt(this.pos);
    if (ch === 96 || ch === 36 && this.input.charCodeAt(this.pos + 1) === 123) {
      if (this.pos === this.start && (this.type === types$1.template || this.type === types$1.invalidTemplate)) {
        if (ch === 36) {
          this.pos += 2;
          return this.finishToken(types$1.dollarBraceL);
        } else {
          ++this.pos;
          return this.finishToken(types$1.backQuote);
        }
      }
      out += this.input.slice(chunkStart, this.pos);
      return this.finishToken(types$1.template, out);
    }
    if (ch === 92) {
      out += this.input.slice(chunkStart, this.pos);
      out += this.readEscapedChar(true);
      chunkStart = this.pos;
    } else if (isNewLine(ch)) {
      out += this.input.slice(chunkStart, this.pos);
      ++this.pos;
      switch (ch) {
        case 13:
          if (this.input.charCodeAt(this.pos) === 10) {
            ++this.pos;
          }
        case 10:
          out += "\n";
          break;
        default:
          out += String.fromCharCode(ch);
          break;
      }
      if (this.options.locations) {
        ++this.curLine;
        this.lineStart = this.pos;
      }
      chunkStart = this.pos;
    } else {
      ++this.pos;
    }
  }
};
pp.readInvalidTemplateToken = function() {
  for (; this.pos < this.input.length; this.pos++) {
    switch (this.input[this.pos]) {
      case "\\":
        ++this.pos;
        break;
      case "$":
        if (this.input[this.pos + 1] !== "{") {
          break;
        }
      // fall through
      case "`":
        return this.finishToken(types$1.invalidTemplate, this.input.slice(this.start, this.pos));
      case "\r":
        if (this.input[this.pos + 1] === "\n") {
          ++this.pos;
        }
      // fall through
      case "\n":
      case "\u2028":
      case "\u2029":
        ++this.curLine;
        this.lineStart = this.pos + 1;
        break;
    }
  }
  this.raise(this.start, "Unterminated template");
};
pp.readEscapedChar = function(inTemplate) {
  var ch = this.input.charCodeAt(++this.pos);
  ++this.pos;
  switch (ch) {
    case 110:
      return "\n";
    // 'n' -> '\n'
    case 114:
      return "\r";
    // 'r' -> '\r'
    case 120:
      return String.fromCharCode(this.readHexChar(2));
    // 'x'
    case 117:
      return codePointToString(this.readCodePoint());
    // 'u'
    case 116:
      return "	";
    // 't' -> '\t'
    case 98:
      return "\b";
    // 'b' -> '\b'
    case 118:
      return "\v";
    // 'v' -> '\u000b'
    case 102:
      return "\f";
    // 'f' -> '\f'
    case 13:
      if (this.input.charCodeAt(this.pos) === 10) {
        ++this.pos;
      }
    // '\r\n'
    case 10:
      if (this.options.locations) {
        this.lineStart = this.pos;
        ++this.curLine;
      }
      return "";
    case 56:
    case 57:
      if (this.strict) {
        this.invalidStringToken(
          this.pos - 1,
          "Invalid escape sequence"
        );
      }
      if (inTemplate) {
        var codePos = this.pos - 1;
        this.invalidStringToken(
          codePos,
          "Invalid escape sequence in template string"
        );
      }
    default:
      if (ch >= 48 && ch <= 55) {
        var octalStr = this.input.substr(this.pos - 1, 3).match(/^[0-7]+/)[0];
        var octal = parseInt(octalStr, 8);
        if (octal > 255) {
          octalStr = octalStr.slice(0, -1);
          octal = parseInt(octalStr, 8);
        }
        this.pos += octalStr.length - 1;
        ch = this.input.charCodeAt(this.pos);
        if ((octalStr !== "0" || ch === 56 || ch === 57) && (this.strict || inTemplate)) {
          this.invalidStringToken(
            this.pos - 1 - octalStr.length,
            inTemplate ? "Octal literal in template string" : "Octal literal in strict mode"
          );
        }
        return String.fromCharCode(octal);
      }
      if (isNewLine(ch)) {
        if (this.options.locations) {
          this.lineStart = this.pos;
          ++this.curLine;
        }
        return "";
      }
      return String.fromCharCode(ch);
  }
};
pp.readHexChar = function(len) {
  var codePos = this.pos;
  var n2 = this.readInt(16, len);
  if (n2 === null) {
    this.invalidStringToken(codePos, "Bad character escape sequence");
  }
  return n2;
};
pp.readWord1 = function() {
  this.containsEsc = false;
  var word = "", first = true, chunkStart = this.pos;
  var astral = this.options.ecmaVersion >= 6;
  while (this.pos < this.input.length) {
    var ch = this.fullCharCodeAtPos();
    if (isIdentifierChar(ch, astral)) {
      this.pos += ch <= 65535 ? 1 : 2;
    } else if (ch === 92) {
      this.containsEsc = true;
      word += this.input.slice(chunkStart, this.pos);
      var escStart = this.pos;
      if (this.input.charCodeAt(++this.pos) !== 117) {
        this.invalidStringToken(this.pos, "Expecting Unicode escape sequence \\uXXXX");
      }
      ++this.pos;
      var esc2 = this.readCodePoint();
      if (!(first ? isIdentifierStart : isIdentifierChar)(esc2, astral)) {
        this.invalidStringToken(escStart, "Invalid Unicode escape");
      }
      word += codePointToString(esc2);
      chunkStart = this.pos;
    } else {
      break;
    }
    first = false;
  }
  return word + this.input.slice(chunkStart, this.pos);
};
pp.readWord = function() {
  var word = this.readWord1();
  var type5 = types$1.name;
  if (this.keywords.test(word)) {
    type5 = keywords[word];
  }
  return this.finishToken(type5, word);
};
var version2 = "8.15.0";
Parser.acorn = {
  Parser,
  version: version2,
  defaultOptions,
  Position,
  SourceLocation,
  getLineInfo,
  Node,
  TokenType,
  tokTypes: types$1,
  keywordTypes: keywords,
  TokContext,
  tokContexts: types,
  isIdentifierChar,
  isIdentifierStart,
  Token,
  isNewLine,
  lineBreak,
  lineBreakG,
  nonASCIIwhitespace
};
function parseExpressionAt2(input, pos, options) {
  return Parser.parseExpressionAt(input, pos, options);
}

// ../common/dist/esm/src/expression.js
var expressionCache = /* @__PURE__ */ new Map();
var parseDataCache = /* @__PURE__ */ new Map();
var parseData = (data2) => {
  const key2 = JSON.stringify(data2);
  if (parseDataCache.has(key2)) {
    return parseDataCache.get(key2);
  }
  const parsed = Object.fromEntries(Object.entries(data2).map(([key3, value]) => {
    if (typeof value === "string") {
      try {
        const parsedValue = JSON.parse(value);
        return [key3, parsedValue];
      } catch {
        return [key3, value];
      }
    }
    return [key3, value];
  }));
  parseDataCache.set(key2, parsed);
  return parsed;
};
var padZero = (num) => String(num).padStart(2, "0");
var formatDate = (date4) => `${date4.getFullYear()}/${padZero(date4.getMonth() + 1)}/${padZero(date4.getDate())}`;
var formatDateTime = (date4) => `${formatDate(date4)} ${padZero(date4.getHours())}:${padZero(date4.getMinutes())}`;
var allowedGlobals = {
  Math,
  String,
  Number,
  Boolean,
  Array,
  Object,
  Date,
  JSON,
  isNaN,
  parseFloat,
  parseInt,
  decodeURI,
  decodeURIComponent,
  encodeURI,
  encodeURIComponent
};
var validateAST = (node2) => {
  switch (node2.type) {
    case "Literal":
    case "Identifier":
      break;
    case "BinaryExpression":
    case "LogicalExpression": {
      const binaryNode = node2;
      validateAST(binaryNode.left);
      validateAST(binaryNode.right);
      break;
    }
    case "UnaryExpression": {
      const unaryNode = node2;
      validateAST(unaryNode.argument);
      break;
    }
    case "ConditionalExpression": {
      const condNode = node2;
      validateAST(condNode.test);
      validateAST(condNode.consequent);
      validateAST(condNode.alternate);
      break;
    }
    case "MemberExpression": {
      const memberNode = node2;
      validateAST(memberNode.object);
      if (memberNode.computed) {
        validateAST(memberNode.property);
      } else {
        const propName = memberNode.property.name;
        if (["constructor", "__proto__", "prototype"].includes(propName)) {
          throw new Error("Access to prohibited property");
        }
        const prohibitedMethods = ["toLocaleString", "valueOf"];
        if (typeof propName === "string" && prohibitedMethods.includes(propName)) {
          throw new Error(`Access to prohibited method: ${propName}`);
        }
      }
      break;
    }
    case "CallExpression": {
      const callNode = node2;
      validateAST(callNode.callee);
      callNode.arguments.forEach(validateAST);
      break;
    }
    case "ArrayExpression": {
      const arrayNode = node2;
      arrayNode.elements.forEach((elem) => {
        if (elem)
          validateAST(elem);
      });
      break;
    }
    case "ObjectExpression": {
      const objectNode = node2;
      objectNode.properties.forEach((prop) => {
        const propNode = prop;
        validateAST(propNode.key);
        validateAST(propNode.value);
      });
      break;
    }
    case "ArrowFunctionExpression": {
      const arrowFuncNode = node2;
      arrowFuncNode.params.forEach((param) => {
        if (param.type !== "Identifier") {
          throw new Error("Only identifier parameters are supported in arrow functions");
        }
        validateAST(param);
      });
      validateAST(arrowFuncNode.body);
      break;
    }
    default:
      throw new Error(`Unsupported syntax in placeholder: ${node2.type}`);
  }
};
var evaluateAST = (node2, context) => {
  switch (node2.type) {
    case "Literal": {
      const literalNode = node2;
      return literalNode.value;
    }
    case "Identifier": {
      const idNode = node2;
      if (Object.prototype.hasOwnProperty.call(context, idNode.name)) {
        return context[idNode.name];
      } else if (Object.prototype.hasOwnProperty.call(allowedGlobals, idNode.name)) {
        return allowedGlobals[idNode.name];
      } else {
        throw new Error(`Undefined variable: ${idNode.name}`);
      }
    }
    case "BinaryExpression": {
      const binaryNode = node2;
      const left2 = evaluateAST(binaryNode.left, context);
      const right2 = evaluateAST(binaryNode.right, context);
      switch (binaryNode.operator) {
        case "+":
          return left2 + right2;
        case "-":
          return left2 - right2;
        case "*":
          return left2 * right2;
        case "/":
          return left2 / right2;
        case "%":
          return left2 % right2;
        case "**":
          return left2 ** right2;
        case "==":
          return left2 == right2;
        case "!=":
          return left2 != right2;
        case "===":
          return left2 === right2;
        case "!==":
          return left2 !== right2;
        case "<":
          return left2 < right2;
        case ">":
          return left2 > right2;
        case "<=":
          return left2 <= right2;
        case ">=":
          return left2 >= right2;
        default:
          throw new Error(`Unsupported operator: ${binaryNode.operator}`);
      }
    }
    case "LogicalExpression": {
      const logicalNode = node2;
      const leftLogical = evaluateAST(logicalNode.left, context);
      const rightLogical = evaluateAST(logicalNode.right, context);
      switch (logicalNode.operator) {
        case "&&":
          return leftLogical && rightLogical;
        case "||":
          return leftLogical || rightLogical;
        default:
          throw new Error(`Unsupported operator: ${logicalNode.operator}`);
      }
    }
    case "UnaryExpression": {
      const unaryNode = node2;
      const arg = evaluateAST(unaryNode.argument, context);
      switch (unaryNode.operator) {
        case "+":
          return +arg;
        case "-":
          return -arg;
        case "!":
          return !arg;
        default:
          throw new Error(`Unsupported operator: ${unaryNode.operator}`);
      }
    }
    case "ConditionalExpression": {
      const condNode = node2;
      const test = evaluateAST(condNode.test, context);
      return test ? evaluateAST(condNode.consequent, context) : evaluateAST(condNode.alternate, context);
    }
    case "MemberExpression": {
      const memberNode = node2;
      const obj = evaluateAST(memberNode.object, context);
      let prop;
      if (memberNode.computed) {
        prop = evaluateAST(memberNode.property, context);
      } else {
        prop = memberNode.property.name;
      }
      if (typeof prop === "string" || typeof prop === "number") {
        if (typeof prop === "string" && ["constructor", "__proto__", "prototype"].includes(prop)) {
          throw new Error("Access to prohibited property");
        }
        return obj[prop];
      } else {
        throw new Error("Invalid property access");
      }
    }
    case "CallExpression": {
      const callNode = node2;
      const callee = evaluateAST(callNode.callee, context);
      const args = callNode.arguments.map((argNode) => evaluateAST(argNode, context));
      if (typeof callee === "function") {
        if (callNode.callee.type === "MemberExpression") {
          const memberExpr = callNode.callee;
          const obj = evaluateAST(memberExpr.object, context);
          if (obj !== null && (typeof obj === "object" || typeof obj === "number" || typeof obj === "string" || typeof obj === "boolean")) {
            return callee.call(obj, ...args);
          } else {
            throw new Error("Invalid object in member function call");
          }
        } else {
          return callee(...args);
        }
      } else {
        throw new Error("Attempted to call a non-function");
      }
    }
    case "ArrowFunctionExpression": {
      const arrowFuncNode = node2;
      const params = arrowFuncNode.params.map((param) => param.name);
      const body = arrowFuncNode.body;
      return (...args) => {
        const newContext = { ...context };
        params.forEach((param, index3) => {
          newContext[param] = args[index3];
        });
        return evaluateAST(body, newContext);
      };
    }
    case "ArrayExpression": {
      const arrayNode = node2;
      return arrayNode.elements.map((elem) => elem ? evaluateAST(elem, context) : null);
    }
    case "ObjectExpression": {
      const objectNode = node2;
      const objResult = {};
      objectNode.properties.forEach((prop) => {
        const propNode = prop;
        let key2;
        if (propNode.key.type === "Identifier") {
          key2 = propNode.key.name;
        } else {
          const evaluatedKey = evaluateAST(propNode.key, context);
          if (typeof evaluatedKey !== "string" && typeof evaluatedKey !== "number") {
            throw new Error("Object property keys must be strings or numbers");
          }
          key2 = String(evaluatedKey);
        }
        const value = evaluateAST(propNode.value, context);
        objResult[key2] = value;
      });
      return objResult;
    }
    default:
      throw new Error(`Unsupported syntax in placeholder: ${node2.type}`);
  }
};
var evaluatePlaceholders = (arg) => {
  const { content, context } = arg;
  let resultContent = "";
  let index3 = 0;
  while (index3 < content.length) {
    const startIndex = content.indexOf("{", index3);
    if (startIndex === -1) {
      resultContent += content.slice(index3);
      break;
    }
    resultContent += content.slice(index3, startIndex);
    let braceCount = 1;
    let endIndex = startIndex + 1;
    while (endIndex < content.length && braceCount > 0) {
      if (content[endIndex] === "{") {
        braceCount++;
      } else if (content[endIndex] === "}") {
        braceCount--;
      }
      endIndex++;
    }
    if (braceCount === 0) {
      const code2 = content.slice(startIndex + 1, endIndex - 1).trim();
      if (expressionCache.has(code2)) {
        const evalFunc = expressionCache.get(code2);
        try {
          const value = evalFunc(context);
          resultContent += String(value);
        } catch {
          resultContent += content.slice(startIndex, endIndex);
        }
      } else {
        try {
          const ast = parseExpressionAt2(code2, 0, { ecmaVersion: "latest" });
          validateAST(ast);
          const evalFunc = (ctx) => evaluateAST(ast, ctx);
          expressionCache.set(code2, evalFunc);
          const value = evalFunc(context);
          resultContent += String(value);
        } catch {
          resultContent += content.slice(startIndex, endIndex);
        }
      }
      index3 = endIndex;
    } else {
      throw new Error("Invalid placeholder");
    }
  }
  return resultContent;
};
var replacePlaceholders = (arg) => {
  const { content, variables, schemas } = arg;
  if (!content || typeof content !== "string" || !content.includes("{") || !content.includes("}")) {
    return content;
  }
  const date4 = /* @__PURE__ */ new Date();
  const formattedDate = formatDate(date4);
  const formattedDateTime = formatDateTime(date4);
  const data2 = {
    ...Object.fromEntries(schemas.flat().map((schema) => [schema.name, schema.readOnly ? schema.content || "" : ""])),
    ...variables
  };
  const parsedInput = parseData(data2);
  const context = {
    date: formattedDate,
    dateTime: formattedDateTime,
    ...parsedInput
  };
  Object.entries(context).forEach(([key2, value]) => {
    if (typeof value === "string" && value.includes("{") && value.includes("}")) {
      context[key2] = evaluatePlaceholders({ content: value, context });
    }
  });
  return evaluatePlaceholders({ content, context });
};

// src/class.ts
var import_react_dom = __toESM(require_react_dom());

// src/constants.ts
var DEFAULT_LANG = "en";
var DESTROYED_ERR_MSG = "[@pdfme/ui] this instance is already destroyed";
var SELECTABLE_CLASSNAME = "selectable";
var RULER_HEIGHT = 30;
var PAGE_GAP = 10;
var LEFT_SIDEBAR_WIDTH = 45;
var RIGHT_SIDEBAR_WIDTH = 400;
var BACKGROUND_COLOR = "rgb(74, 74, 74)";
var DEFAULT_MAX_ZOOM = 2;

// ../../node_modules/hotkeys-js/dist/hotkeys.esm.js
var isff = typeof navigator !== "undefined" ? navigator.userAgent.toLowerCase().indexOf("firefox") > 0 : false;
function addEvent(object4, event, method4, useCapture) {
  if (object4.addEventListener) {
    object4.addEventListener(event, method4, useCapture);
  } else if (object4.attachEvent) {
    object4.attachEvent("on".concat(event), method4);
  }
}
function removeEvent(object4, event, method4, useCapture) {
  if (object4.removeEventListener) {
    object4.removeEventListener(event, method4, useCapture);
  } else if (object4.detachEvent) {
    object4.detachEvent("on".concat(event), method4);
  }
}
function getMods(modifier, key2) {
  const mods = key2.slice(0, key2.length - 1);
  for (let i = 0; i < mods.length; i++) mods[i] = modifier[mods[i].toLowerCase()];
  return mods;
}
function getKeys(key2) {
  if (typeof key2 !== "string") key2 = "";
  key2 = key2.replace(/\s/g, "");
  const keys4 = key2.split(",");
  let index3 = keys4.lastIndexOf("");
  for (; index3 >= 0; ) {
    keys4[index3 - 1] += ",";
    keys4.splice(index3, 1);
    index3 = keys4.lastIndexOf("");
  }
  return keys4;
}
function compareArray(a1, a2) {
  const arr1 = a1.length >= a2.length ? a1 : a2;
  const arr2 = a1.length >= a2.length ? a2 : a1;
  let isIndex2 = true;
  for (let i = 0; i < arr1.length; i++) {
    if (arr2.indexOf(arr1[i]) === -1) isIndex2 = false;
  }
  return isIndex2;
}
var _keyMap = {
  backspace: 8,
  "\u232B": 8,
  tab: 9,
  clear: 12,
  enter: 13,
  "\u21A9": 13,
  return: 13,
  esc: 27,
  escape: 27,
  space: 32,
  left: 37,
  up: 38,
  right: 39,
  down: 40,
  /// https://w3c.github.io/uievents/#events-keyboard-key-location
  arrowup: 38,
  arrowdown: 40,
  arrowleft: 37,
  arrowright: 39,
  del: 46,
  delete: 46,
  ins: 45,
  insert: 45,
  home: 36,
  end: 35,
  pageup: 33,
  pagedown: 34,
  capslock: 20,
  num_0: 96,
  num_1: 97,
  num_2: 98,
  num_3: 99,
  num_4: 100,
  num_5: 101,
  num_6: 102,
  num_7: 103,
  num_8: 104,
  num_9: 105,
  num_multiply: 106,
  num_add: 107,
  num_enter: 108,
  num_subtract: 109,
  num_decimal: 110,
  num_divide: 111,
  "\u21EA": 20,
  ",": 188,
  ".": 190,
  "/": 191,
  "`": 192,
  "-": isff ? 173 : 189,
  "=": isff ? 61 : 187,
  ";": isff ? 59 : 186,
  "'": 222,
  "{": 219,
  "}": 221,
  "[": 219,
  "]": 221,
  "\\": 220
};
var _modifier = {
  // shiftKey
  "\u21E7": 16,
  shift: 16,
  // altKey
  "\u2325": 18,
  alt: 18,
  option: 18,
  // ctrlKey
  "\u2303": 17,
  ctrl: 17,
  control: 17,
  // metaKey
  "\u2318": 91,
  cmd: 91,
  meta: 91,
  command: 91
};
var modifierMap = {
  16: "shiftKey",
  18: "altKey",
  17: "ctrlKey",
  91: "metaKey",
  shiftKey: 16,
  ctrlKey: 17,
  altKey: 18,
  metaKey: 91
};
var _mods = {
  16: false,
  18: false,
  17: false,
  91: false
};
var _handlers = {};
for (let k = 1; k < 20; k++) {
  _keyMap["f".concat(k)] = 111 + k;
}
var _downKeys = [];
var winListendFocus = null;
var _scope = "all";
var elementEventMap = /* @__PURE__ */ new Map();
var code = (x) => _keyMap[x.toLowerCase()] || _modifier[x.toLowerCase()] || x.toUpperCase().charCodeAt(0);
var getKey = (x) => Object.keys(_keyMap).find((k) => _keyMap[k] === x);
var getModifier = (x) => Object.keys(_modifier).find((k) => _modifier[k] === x);
function setScope(scope) {
  _scope = scope || "all";
}
function getScope() {
  return _scope || "all";
}
function getPressedKeyCodes() {
  return _downKeys.slice(0);
}
function getPressedKeyString() {
  return _downKeys.map((c) => getKey(c) || getModifier(c) || String.fromCharCode(c));
}
function getAllKeyCodes() {
  const result = [];
  Object.keys(_handlers).forEach((k) => {
    _handlers[k].forEach((_ref) => {
      let {
        key: key2,
        scope,
        mods,
        shortcut
      } = _ref;
      result.push({
        scope,
        shortcut,
        mods,
        keys: key2.split("+").map((v) => code(v))
      });
    });
  });
  return result;
}
function filter(event) {
  const target = event.target || event.srcElement;
  const {
    tagName
  } = target;
  let flag = true;
  const isInput = tagName === "INPUT" && !["checkbox", "radio", "range", "button", "file", "reset", "submit", "color"].includes(target.type);
  if (target.isContentEditable || (isInput || tagName === "TEXTAREA" || tagName === "SELECT") && !target.readOnly) {
    flag = false;
  }
  return flag;
}
function isPressed(keyCode) {
  if (typeof keyCode === "string") {
    keyCode = code(keyCode);
  }
  return _downKeys.indexOf(keyCode) !== -1;
}
function deleteScope(scope, newScope) {
  let handlers;
  let i;
  if (!scope) scope = getScope();
  for (const key2 in _handlers) {
    if (Object.prototype.hasOwnProperty.call(_handlers, key2)) {
      handlers = _handlers[key2];
      for (i = 0; i < handlers.length; ) {
        if (handlers[i].scope === scope) {
          const deleteItems = handlers.splice(i, 1);
          deleteItems.forEach((_ref2) => {
            let {
              element
            } = _ref2;
            return removeKeyEvent(element);
          });
        } else {
          i++;
        }
      }
    }
  }
  if (getScope() === scope) setScope(newScope || "all");
}
function clearModifier(event) {
  let key2 = event.keyCode || event.which || event.charCode;
  if (event.key && event.key.toLowerCase() === "capslock") {
    key2 = code(event.key);
  }
  const i = _downKeys.indexOf(key2);
  if (i >= 0) {
    _downKeys.splice(i, 1);
  }
  if (event.key && event.key.toLowerCase() === "meta") {
    _downKeys.splice(0, _downKeys.length);
  }
  if (key2 === 93 || key2 === 224) key2 = 91;
  if (key2 in _mods) {
    _mods[key2] = false;
    for (const k in _modifier) if (_modifier[k] === key2) hotkeys[k] = false;
  }
}
function unbind(keysInfo) {
  if (typeof keysInfo === "undefined") {
    Object.keys(_handlers).forEach((key2) => {
      Array.isArray(_handlers[key2]) && _handlers[key2].forEach((info) => eachUnbind(info));
      delete _handlers[key2];
    });
    removeKeyEvent(null);
  } else if (Array.isArray(keysInfo)) {
    keysInfo.forEach((info) => {
      if (info.key) eachUnbind(info);
    });
  } else if (typeof keysInfo === "object") {
    if (keysInfo.key) eachUnbind(keysInfo);
  } else if (typeof keysInfo === "string") {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    let [scope, method4] = args;
    if (typeof scope === "function") {
      method4 = scope;
      scope = "";
    }
    eachUnbind({
      key: keysInfo,
      scope,
      method: method4,
      splitKey: "+"
    });
  }
}
var eachUnbind = (_ref3) => {
  let {
    key: key2,
    scope,
    method: method4,
    splitKey = "+"
  } = _ref3;
  const multipleKeys = getKeys(key2);
  multipleKeys.forEach((originKey) => {
    const unbindKeys = originKey.split(splitKey);
    const len = unbindKeys.length;
    const lastKey = unbindKeys[len - 1];
    const keyCode = lastKey === "*" ? "*" : code(lastKey);
    if (!_handlers[keyCode]) return;
    if (!scope) scope = getScope();
    const mods = len > 1 ? getMods(_modifier, unbindKeys) : [];
    const unbindElements = [];
    _handlers[keyCode] = _handlers[keyCode].filter((record) => {
      const isMatchingMethod = method4 ? record.method === method4 : true;
      const isUnbind = isMatchingMethod && record.scope === scope && compareArray(record.mods, mods);
      if (isUnbind) unbindElements.push(record.element);
      return !isUnbind;
    });
    unbindElements.forEach((element) => removeKeyEvent(element));
  });
};
function eventHandler(event, handler, scope, element) {
  if (handler.element !== element) {
    return;
  }
  let modifiersMatch;
  if (handler.scope === scope || handler.scope === "all") {
    modifiersMatch = handler.mods.length > 0;
    for (const y in _mods) {
      if (Object.prototype.hasOwnProperty.call(_mods, y)) {
        if (!_mods[y] && handler.mods.indexOf(+y) > -1 || _mods[y] && handler.mods.indexOf(+y) === -1) {
          modifiersMatch = false;
        }
      }
    }
    if (handler.mods.length === 0 && !_mods[16] && !_mods[18] && !_mods[17] && !_mods[91] || modifiersMatch || handler.shortcut === "*") {
      handler.keys = [];
      handler.keys = handler.keys.concat(_downKeys);
      if (handler.method(event, handler) === false) {
        if (event.preventDefault) event.preventDefault();
        else event.returnValue = false;
        if (event.stopPropagation) event.stopPropagation();
        if (event.cancelBubble) event.cancelBubble = true;
      }
    }
  }
}
function dispatch(event, element) {
  const asterisk = _handlers["*"];
  let key2 = event.keyCode || event.which || event.charCode;
  if (event.key && event.key.toLowerCase() === "capslock") {
    return;
  }
  if (!hotkeys.filter.call(this, event)) return;
  if (key2 === 93 || key2 === 224) key2 = 91;
  if (_downKeys.indexOf(key2) === -1 && key2 !== 229) _downKeys.push(key2);
  ["metaKey", "ctrlKey", "altKey", "shiftKey"].forEach((keyName) => {
    const keyNum = modifierMap[keyName];
    if (event[keyName] && _downKeys.indexOf(keyNum) === -1) {
      _downKeys.push(keyNum);
    } else if (!event[keyName] && _downKeys.indexOf(keyNum) > -1) {
      _downKeys.splice(_downKeys.indexOf(keyNum), 1);
    } else if (keyName === "metaKey" && event[keyName]) {
      _downKeys = _downKeys.filter((k) => k in modifierMap || k === key2);
    }
  });
  if (key2 in _mods) {
    _mods[key2] = true;
    for (const k in _modifier) {
      if (Object.prototype.hasOwnProperty.call(_modifier, k)) {
        const eventKey = modifierMap[_modifier[k]];
        hotkeys[k] = event[eventKey];
      }
    }
    if (!asterisk) return;
  }
  for (const e3 in _mods) {
    if (Object.prototype.hasOwnProperty.call(_mods, e3)) {
      _mods[e3] = event[modifierMap[e3]];
    }
  }
  if (event.getModifierState && !(event.altKey && !event.ctrlKey) && event.getModifierState("AltGraph")) {
    if (_downKeys.indexOf(17) === -1) {
      _downKeys.push(17);
    }
    if (_downKeys.indexOf(18) === -1) {
      _downKeys.push(18);
    }
    _mods[17] = true;
    _mods[18] = true;
  }
  const scope = getScope();
  if (asterisk) {
    for (let i = 0; i < asterisk.length; i++) {
      if (asterisk[i].scope === scope && (event.type === "keydown" && asterisk[i].keydown || event.type === "keyup" && asterisk[i].keyup)) {
        eventHandler(event, asterisk[i], scope, element);
      }
    }
  }
  if (!(key2 in _handlers)) return;
  const handlerKey = _handlers[key2];
  const keyLen = handlerKey.length;
  for (let i = 0; i < keyLen; i++) {
    if (event.type === "keydown" && handlerKey[i].keydown || event.type === "keyup" && handlerKey[i].keyup) {
      if (handlerKey[i].key) {
        const record = handlerKey[i];
        const {
          splitKey
        } = record;
        const keyShortcut = record.key.split(splitKey);
        const _downKeysCurrent = [];
        for (let a = 0; a < keyShortcut.length; a++) {
          _downKeysCurrent.push(code(keyShortcut[a]));
        }
        if (_downKeysCurrent.sort().join("") === _downKeys.sort().join("")) {
          eventHandler(event, record, scope, element);
        }
      }
    }
  }
}
function hotkeys(key2, option, method4) {
  _downKeys = [];
  const keys4 = getKeys(key2);
  let mods = [];
  let scope = "all";
  let element = document;
  let i = 0;
  let keyup = false;
  let keydown = true;
  let splitKey = "+";
  let capture = false;
  let single = false;
  if (method4 === void 0 && typeof option === "function") {
    method4 = option;
  }
  if (Object.prototype.toString.call(option) === "[object Object]") {
    if (option.scope) scope = option.scope;
    if (option.element) element = option.element;
    if (option.keyup) keyup = option.keyup;
    if (option.keydown !== void 0) keydown = option.keydown;
    if (option.capture !== void 0) capture = option.capture;
    if (typeof option.splitKey === "string") splitKey = option.splitKey;
    if (option.single === true) single = true;
  }
  if (typeof option === "string") scope = option;
  if (single) unbind(key2, scope);
  for (; i < keys4.length; i++) {
    key2 = keys4[i].split(splitKey);
    mods = [];
    if (key2.length > 1) mods = getMods(_modifier, key2);
    key2 = key2[key2.length - 1];
    key2 = key2 === "*" ? "*" : code(key2);
    if (!(key2 in _handlers)) _handlers[key2] = [];
    _handlers[key2].push({
      keyup,
      keydown,
      scope,
      mods,
      shortcut: keys4[i],
      method: method4,
      key: keys4[i],
      splitKey,
      element
    });
  }
  if (typeof element !== "undefined" && window) {
    if (!elementEventMap.has(element)) {
      const keydownListener = function() {
        let event = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.event;
        return dispatch(event, element);
      };
      const keyupListenr = function() {
        let event = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.event;
        dispatch(event, element);
        clearModifier(event);
      };
      elementEventMap.set(element, {
        keydownListener,
        keyupListenr,
        capture
      });
      addEvent(element, "keydown", keydownListener, capture);
      addEvent(element, "keyup", keyupListenr, capture);
    }
    if (!winListendFocus) {
      const listener = () => {
        _downKeys = [];
      };
      winListendFocus = {
        listener,
        capture
      };
      addEvent(window, "focus", listener, capture);
    }
  }
}
function trigger(shortcut) {
  let scope = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "all";
  Object.keys(_handlers).forEach((key2) => {
    const dataList = _handlers[key2].filter((item) => item.scope === scope && item.shortcut === shortcut);
    dataList.forEach((data2) => {
      if (data2 && data2.method) {
        data2.method();
      }
    });
  });
}
function removeKeyEvent(element) {
  const values = Object.values(_handlers).flat();
  const findindex = values.findIndex((_ref4) => {
    let {
      element: el
    } = _ref4;
    return el === element;
  });
  if (findindex < 0) {
    const {
      keydownListener,
      keyupListenr,
      capture
    } = elementEventMap.get(element) || {};
    if (keydownListener && keyupListenr) {
      removeEvent(element, "keyup", keyupListenr, capture);
      removeEvent(element, "keydown", keydownListener, capture);
      elementEventMap.delete(element);
    }
  }
  if (values.length <= 0 || elementEventMap.size <= 0) {
    const eventKeys = Object.keys(elementEventMap);
    eventKeys.forEach((el) => {
      const {
        keydownListener,
        keyupListenr,
        capture
      } = elementEventMap.get(el) || {};
      if (keydownListener && keyupListenr) {
        removeEvent(el, "keyup", keyupListenr, capture);
        removeEvent(el, "keydown", keydownListener, capture);
        elementEventMap.delete(el);
      }
    });
    elementEventMap.clear();
    Object.keys(_handlers).forEach((key2) => delete _handlers[key2]);
    if (winListendFocus) {
      const {
        listener,
        capture
      } = winListendFocus;
      removeEvent(window, "focus", listener, capture);
      winListendFocus = null;
    }
  }
}
var _api = {
  getPressedKeyString,
  setScope,
  getScope,
  deleteScope,
  getPressedKeyCodes,
  getAllKeyCodes,
  isPressed,
  filter,
  trigger,
  unbind,
  keyMap: _keyMap,
  modifier: _modifier,
  modifierMap
};
for (const a in _api) {
  if (Object.prototype.hasOwnProperty.call(_api, a)) {
    hotkeys[a] = _api[a];
  }
}
if (typeof window !== "undefined") {
  const _hotkeys = window.hotkeys;
  hotkeys.noConflict = (deep) => {
    if (deep && window.hotkeys === hotkeys) {
      window.hotkeys = _hotkeys;
    }
    return hotkeys;
  };
  window.hotkeys = hotkeys;
}

// src/helper.ts
var import_react2 = __toESM(require_react());

// ../converter/dist/esm/src/index.browser.js
var pdfjsLib = __toESM(require_pdf());
var import_pdf_worker_entry = __toESM(require_pdf_worker_entry());

// ../converter/dist/esm/src/pdf2img.js
async function pdf2img(pdf, options = {}, env) {
  try {
    const { scale = 1, imageType = "jpeg", range: range3 = {} } = options;
    const { start = 0, end = Infinity } = range3;
    const { getDocument: getDocument4, createCanvas, canvasToArrayBuffer } = env;
    const pdfDoc = await getDocument4(pdf);
    const numPages = pdfDoc.numPages;
    const startPage = Math.max(start + 1, 1);
    const endPage = Math.min(end + 1, numPages);
    const results = [];
    for (let pageNum = startPage; pageNum <= endPage; pageNum++) {
      const page = await pdfDoc.getPage(pageNum);
      const viewport = page.getViewport({ scale });
      const canvas = createCanvas(viewport.width, viewport.height);
      if (!canvas) {
        throw new Error("Failed to create canvas");
      }
      const context = canvas.getContext("2d");
      if (!context) {
        throw new Error("Failed to get canvas context");
      }
      await page.render({ canvasContext: context, viewport }).promise;
      const arrayBuffer = canvasToArrayBuffer(canvas, imageType);
      results.push(arrayBuffer);
    }
    return results;
  } catch (error2) {
    throw new Error(`[@pdfme/converter] pdf2img failed: ${error2.message}`);
  }
}

// ../converter/dist/esm/src/pdf2size.js
async function pdf2size(pdf, options = {}, env) {
  const { scale = 1 } = options;
  const { getDocument: getDocument4 } = env;
  const pdfDoc = await getDocument4(pdf);
  const promises = Promise.all(new Array(pdfDoc.numPages).fill("").map(async (_, i) => {
    return await pdfDoc.getPage(i + 1).then((page) => {
      const { height, width } = page.getViewport({ scale, rotation: 0 });
      return { height: pt2mm(height), width: pt2mm(width) };
    });
  }));
  return promises;
}

// ../../node_modules/@pdfme/pdf-lib/dist/esm/src/utils/validators.js
var backtick = (val) => `\`${val}\``;
var getType = (val) => {
  if (val === null)
    return "null";
  if (val === void 0)
    return "undefined";
  if (typeof val === "string")
    return "string";
  if (isNaN(val))
    return "NaN";
  if (typeof val === "number")
    return "number";
  if (typeof val === "boolean")
    return "boolean";
  if (typeof val === "symbol")
    return "symbol";
  if (typeof val === "bigint")
    return "bigint";
  if (val.constructor && val.constructor.name)
    return val.constructor.name;
  if (val.name)
    return val.name;
  if (val.constructor)
    return String(val.constructor);
  return String(val);
};
var isType = (value, type5) => {
  if (type5 === "null")
    return value === null;
  if (type5 === "undefined")
    return value === void 0;
  if (type5 === "string")
    return typeof value === "string";
  if (type5 === "number")
    return typeof value === "number" && !isNaN(value);
  if (type5 === "boolean")
    return typeof value === "boolean";
  if (type5 === "symbol")
    return typeof value === "symbol";
  if (type5 === "bigint")
    return typeof value === "bigint";
  if (type5 === Date)
    return value instanceof Date;
  if (type5 === Array)
    return value instanceof Array;
  if (type5 === Uint8Array)
    return value instanceof Uint8Array;
  if (type5 === ArrayBuffer)
    return value instanceof ArrayBuffer;
  if (type5 === Function)
    return value instanceof Function;
  return value instanceof type5[0];
};
var createTypeErrorMsg = (value, valueName, types3) => {
  const allowedTypes = new Array(types3.length);
  for (let idx = 0, len = types3.length; idx < len; idx++) {
    const type5 = types3[idx];
    if (type5 === "null")
      allowedTypes[idx] = backtick("null");
    if (type5 === "undefined")
      allowedTypes[idx] = backtick("undefined");
    if (type5 === "string")
      allowedTypes[idx] = backtick("string");
    else if (type5 === "number")
      allowedTypes[idx] = backtick("number");
    else if (type5 === "boolean")
      allowedTypes[idx] = backtick("boolean");
    else if (type5 === "symbol")
      allowedTypes[idx] = backtick("symbol");
    else if (type5 === "bigint")
      allowedTypes[idx] = backtick("bigint");
    else if (type5 === Array)
      allowedTypes[idx] = backtick("Array");
    else if (type5 === Uint8Array)
      allowedTypes[idx] = backtick("Uint8Array");
    else if (type5 === ArrayBuffer)
      allowedTypes[idx] = backtick("ArrayBuffer");
    else
      allowedTypes[idx] = backtick(type5[1]);
  }
  const joinedTypes = allowedTypes.join(" or ");
  return `${backtick(valueName)} must be of type ${joinedTypes}, but was actually of type ${backtick(getType(value))}`;
};
var assertIs = (value, valueName, types3) => {
  for (let idx = 0, len = types3.length; idx < len; idx++) {
    if (isType(value, types3[idx]))
      return;
  }
  throw new TypeError(createTypeErrorMsg(value, valueName, types3));
};
var assertRange = (value, valueName, min, max) => {
  assertIs(value, valueName, ["number"]);
  assertIs(min, "min", ["number"]);
  assertIs(max, "max", ["number"]);
  max = Math.max(min, max);
  if (value < min || value > max) {
    throw new Error(`${backtick(valueName)} must be at least ${min} and at most ${max}, but was actually ${value}`);
  }
};

// ../../node_modules/@pdfme/pdf-lib/dist/esm/src/api/rotations.js
var RotationTypes;
(function(RotationTypes2) {
  RotationTypes2["Degrees"] = "degrees";
  RotationTypes2["Radians"] = "radians";
})(RotationTypes || (RotationTypes = {}));
var degrees = (degreeAngle) => {
  assertIs(degreeAngle, "degreeAngle", ["number"]);
  return { type: RotationTypes.Degrees, angle: degreeAngle };
};
var { Radians, Degrees } = RotationTypes;
var degreesToRadians = (degree) => degree * Math.PI / 180;

// ../../node_modules/@pdfme/pdf-lib/dist/esm/src/api/colors.js
var ColorTypes;
(function(ColorTypes2) {
  ColorTypes2["Grayscale"] = "Grayscale";
  ColorTypes2["RGB"] = "RGB";
  ColorTypes2["CMYK"] = "CMYK";
})(ColorTypes || (ColorTypes = {}));
var rgb = (red2, green2, blue2) => {
  assertRange(red2, "red", 0, 1);
  assertRange(green2, "green", 0, 1);
  assertRange(blue2, "blue", 0, 1);
  return { type: ColorTypes.RGB, red: red2, green: green2, blue: blue2 };
};
var cmyk = (cyan2, magenta2, yellow2, key2) => {
  assertRange(cyan2, "cyan", 0, 1);
  assertRange(magenta2, "magenta", 0, 1);
  assertRange(yellow2, "yellow", 0, 1);
  assertRange(key2, "key", 0, 1);
  return { type: ColorTypes.CMYK, cyan: cyan2, magenta: magenta2, yellow: yellow2, key: key2 };
};
var { Grayscale, RGB, CMYK } = ColorTypes;

// ../converter/dist/esm/src/index.browser.js
pdfjsLib.GlobalWorkerOptions.workerSrc = import_pdf_worker_entry.default;
function dataURLToArrayBuffer(dataURL) {
  const base64String = dataURL.split(",")[1];
  const byteString = atob(base64String);
  const arrayBuffer = new ArrayBuffer(byteString.length);
  const uintArray = new Uint8Array(arrayBuffer);
  for (let i = 0; i < byteString.length; i++) {
    uintArray[i] = byteString.charCodeAt(i);
  }
  return arrayBuffer;
}
var pdf2img2 = async (pdf, options = {}) => pdf2img(pdf, options, {
  getDocument: (pdf2) => pdfjsLib.getDocument(pdf2).promise,
  createCanvas: (width, height) => {
    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    return canvas;
  },
  canvasToArrayBuffer: (canvas, imageType) => {
    const dataUrl = canvas.toDataURL(`image/${imageType}`);
    return dataURLToArrayBuffer(dataUrl);
  }
});
var pdf2size2 = async (pdf, options = {}) => pdf2size(pdf, options, {
  getDocument: (pdf2) => pdfjsLib.getDocument(pdf2).promise
});

// src/contexts.ts
var import_react = __toESM(require_react());

// src/i18n.ts
var dictEn = {
  cancel: "Cancel",
  close: "Close",
  field: "field",
  fieldName: "Name",
  align: "Align",
  width: "Width",
  height: "Height",
  opacity: "Opacity",
  rotate: "Rotate",
  required: "Required",
  editable: "Editable",
  edit: "Edit",
  plsInputName: "Please input name",
  fieldMustUniq: "Name of field is not unique",
  notUniq: "(Not unique name)",
  noKeyName: "No name",
  fieldsList: "Field List",
  editField: "Edit Field",
  type: "Type",
  errorOccurred: "An error occurred",
  errorBulkUpdateFieldName: "Cannot commit the change because the number of items has been changed.",
  commitBulkUpdateFieldName: "Commit Changes",
  bulkUpdateFieldName: "Bulk update field names",
  addPageAfter: "Add Page After",
  removePage: "Remove Current Page",
  removePageConfirm: "Are you sure you want to delete this page? This action cannot be undone.",
  "schemas.section": "Section",
  "schemas.label": "Label",
  "schemas.measurementPoint": "Measurement Point",
  "validation.hexColor": "Please enter a valid hex color code.",
  "validation.uniqueName": "Please enter a unique name.",
  "schemas.color": "Color",
  "schemas.borderWidth": "Border Width",
  "schemas.borderColor": "Border Color",
  "schemas.backgroundColor": "Background Color",
  "schemas.textColor": "Text Color",
  "schemas.bgColor": "Background Color",
  "schemas.horizontal": "Horizontal",
  "schemas.vertical": "Vertical",
  "schemas.left": "Left",
  "schemas.center": "Center",
  "schemas.right": "Right",
  "schemas.top": "Top",
  "schemas.middle": "Middle",
  "schemas.bottom": "Bottom",
  "schemas.padding": "Padding",
  "schemas.text.fontName": "Font Name",
  "schemas.text.size": "Size",
  "schemas.text.spacing": "Spacing",
  "schemas.text.textAlign": "Text Align",
  "schemas.text.verticalAlign": "Vertical Align",
  "schemas.text.lineHeight": "Line Height",
  "schemas.text.min": "Min",
  "schemas.text.max": "Max",
  "schemas.text.fit": "Fit",
  "schemas.text.dynamicFontSize": "Dynamic Font Size",
  "schemas.text.format": "Format",
  "schemas.mvt.typingInstructions": "Add variables by typing words surrounded by curly brackets, e.g.",
  "schemas.mvt.sampleField": "name",
  "schemas.mvt.variablesSampleData": "Variables Sample Data",
  "schemas.barcodes.barColor": "Bar Color",
  "schemas.barcodes.includetext": "Include Text",
  "schemas.table.alternateBackgroundColor": "Alternate Background Color",
  "schemas.table.tableStyle": "Table Style",
  "schemas.table.showHead": "Show Head",
  "schemas.table.headStyle": "Header Style",
  "schemas.table.bodyStyle": "Body Style",
  "schemas.table.columnStyle": "Column Style",
  "schemas.date.format": "Date Format",
  "schemas.select.options": "Options",
  "schemas.select.optionPlaceholder": "Enter an option",
  "schemas.radioGroup.groupName": "Group Name",
  "schemas.numberOfSides": "Number of Sides",
  "schemas.mvt.showVariables": "Show Variables",
  "schemas.mvt.variablesList": "Variables List",
  "schemas.mvt.close": "Close",
  "schemas.varText.showVar": "Show available variables",
  "schemas.varText.availableVar": "Available Variable",
  "schemas.varText.copy": "Copy",
  "schemas.varText.isCopy": "Copied!",
  "schemas.varText.kundennummerB": "Customer number",
  "schemas.varText.betreiberName": "Operator name",
  "schemas.varText.betreiberPLZ": "Operator ZIP code",
  "schemas.varText.betreiberAnsprechpartner": "Operator contact person",
  "schemas.varText.betreiberOrt": "Operator city",
  "schemas.varText.betreiberTelefonnummer": "Operator phone number",
  "schemas.varText.betreiberEMail": "Operator e-mail",
  "schemas.varText.betreiberStrasse": "Operator street",
  "schemas.varText.betreiberHausnr": "Operator house number",
  "schemas.varText.firmaName": "Company name",
  "schemas.varText.firmaEMail": "Company e-mail",
  "schemas.varText.firmaTelefon": "Company phone",
  "schemas.varText.firmaStrasse": "Company street",
  "schemas.varText.firmaPLZ": "Company ZIP code",
  "schemas.varText.firmaOrt": "Company city",
  "schemas.varText.firmaAnsprechpartner": "Company contact person",
  "schemas.varText.firmaHausnr": "Company house number",
  "schemas.varText.pruefungGrundlage": "Inspection basis",
  "schemas.varText.pruefungVertragsnummer": "Inspection contract number",
  "schemas.varText.pruefungPruefDatum": "Inspection date",
  "schemas.varText.pruefungNaechstePruef": "Next inspection",
  "schemas.varText.objektHersteller": "Object manufacturer",
  "schemas.varText.objektStandort": "Object location",
  "schemas.varText.objektTyp": "Object type",
  "schemas.varText.objektSeriennummer": "Object serial number",
  "schemas.varText.objektInterneNummer": "Object internal number",
  "schemas.varText.objektBaujahr": "Object year of construction",
  "schemas.varText.objektSteuerung": "Object control",
  "schemas.varText.objektBetriebsart": "Object operating mode",
  "schemas.varText.objektBreite": "Object width",
  "schemas.varText.objektHoehe": "Object height",
  "schemas.varText.objektBemerkung": "Object remark",
  "schemas.varText.prueferVorname": "Inspector first name",
  "schemas.varText.prueferNachname": "Inspector last name",
  "schemas.varText.prueferEMail": "Inspector e-mail",
  "schemas.measurementPointList.measurement": "Measurement",
  "schemas.measurementPointList.contactPoint": "Contact Point",
  "schemas.measurementPointList.assessment": "Assessment",
  "schemas.measurementPointList.max": "Maximum",
  "schemas.measurementPointList.average": "Average",
  set: "",
  clear: "",
  "validation.dateTimeFormat": "",
  "schemas.radius": "",
  "schemas.date.locale": ""
};
var dictDe = {
  cancel: "Abbrechen",
  close: "Schlie\xDFen",
  field: "Feld",
  fieldName: "Name",
  align: "Ausrichten",
  width: "Breite",
  height: "H\xF6he",
  opacity: "Opazit\xE4t",
  rotate: "Drehen",
  required: "Erforderlich",
  editable: "Bearbeitbar",
  edit: "Bearbeiten",
  plsInputName: "Bitte geben Sie einen Namen ein",
  fieldMustUniq: "Feldname ist nicht eindeutig",
  notUniq: "(Nicht eindeutiger Name)",
  noKeyName: "Kein Name",
  fieldsList: "Feldliste",
  editField: "Feld bearbeiten",
  type: "Typ",
  errorOccurred: "Ein Fehler ist aufgetreten",
  errorBulkUpdateFieldName: "Die \xC4nderung kann nicht \xFCbernommen werden, weil die Anzahl der Elemente ge\xE4ndert wurde.",
  commitBulkUpdateFieldName: "\xC4nderungen \xFCbernehmen",
  bulkUpdateFieldName: "Mehrfachaktualisierung der Feldnamen",
  addPageAfter: "Seite danach hinzuf\xFCgen",
  removePage: "Aktuelle Seite entfernen",
  removePageConfirm: "Sind Sie sicher, dass Sie diese Seite l\xF6schen m\xF6chten? Diese Aktion kann nicht r\xFCckg\xE4ngig gemacht werden.",
  "schemas.section": "Abschnitt",
  "schemas.label": "Bezeichnung",
  "schemas.measurementPoint": "Messpunkt",
  "validation.hexColor": "Bitte geben Sie einen g\xFCltigen Hex-Farbcode ein.",
  "validation.uniqueName": "Bitte geben Sie einen eindeutigen Namen ein.",
  "schemas.color": "Farbe",
  "schemas.borderWidth": "Rahmenbreite",
  "schemas.borderColor": "Rahmenfarbe",
  "schemas.backgroundColor": "Hintergrundfarbe",
  "schemas.textColor": "Textfarbe",
  "schemas.bgColor": "Hintergrundfarbe",
  "schemas.horizontal": "Horizontal",
  "schemas.vertical": "Vertikal",
  "schemas.left": "Links",
  "schemas.center": "Zentriert",
  "schemas.right": "Rechts",
  "schemas.top": "Oben",
  "schemas.middle": "Mitte",
  "schemas.bottom": "Unten",
  "schemas.padding": "Polsterung",
  "schemas.text.fontName": "Schriftart",
  "schemas.text.size": "Gr\xF6\xDFe",
  "schemas.text.spacing": "Abstand",
  "schemas.text.textAlign": "Ausrichtung",
  "schemas.text.verticalAlign": "vert. Ausr.",
  "schemas.text.lineHeight": "Zeilenh\xF6he",
  "schemas.text.min": "Min",
  "schemas.text.max": "Max",
  "schemas.text.fit": "Anpassen",
  "schemas.text.dynamicFontSize": "Dynamische Schriftgr\xF6\xDFe",
  "schemas.text.format": "Format",
  "schemas.mvt.typingInstructions": "F\xFCgen Sie Variablen hinzu, indem Sie W\xF6rter in geschweiften Klammern eingeben, z.\xA0B.",
  "schemas.mvt.sampleField": "Name",
  "schemas.mvt.variablesSampleData": "Variablen Beispieldaten",
  "schemas.barcodes.barColor": "Strichcodefarbe",
  "schemas.barcodes.includetext": "Text anzeigen",
  "schemas.table.alternateBackgroundColor": "Wechselnde Hintergrundfarbe",
  "schemas.table.tableStyle": "Tabellenstil",
  "schemas.table.headStyle": "Kopfzeilenstil",
  "schemas.table.showHead": "Kopfzeile anzeigen",
  "schemas.table.bodyStyle": "K\xF6rperstil",
  "schemas.table.columnStyle": "Spaltenstil",
  "schemas.numberOfSides": "Anzahl der Seiten",
  "schemas.mvt.showVariables": "Variablen anzeigen",
  "schemas.mvt.variablesList": "Variablenliste",
  "schemas.mvt.close": "Schlie\xDFen",
  "schemas.date.format": "Datumsformat",
  "schemas.select.options": "Optionen",
  "schemas.select.optionPlaceholder": "Geben Sie eine Option ein",
  "schemas.radioGroup.groupName": "Gruppenname",
  "schemas.varText.showVar": "Verf\xFCgbare Variablen anzeigen",
  "schemas.varText.availableVar": "Verf\xFCgbare Variablen",
  "schemas.varText.copy": "Kopieren",
  "schemas.varText.isCopy": "Kopierd!",
  "schemas.varText.kundennummerB": "Kundennummer",
  "schemas.varText.betreiberName": "Betreiber Name",
  "schemas.varText.betreiberPLZ": "Betreiber PLZ",
  "schemas.varText.betreiberAnsprechpartner": "Betreiber Ansprechpartner",
  "schemas.varText.betreiberOrt": "Betreiber Ort",
  "schemas.varText.betreiberTelefonnummer": "Betreiber Telefonnummer",
  "schemas.varText.betreiberEMail": "Betreiber E-Mail",
  "schemas.varText.betreiberStrasse": "Betreiber Stra\xDFe",
  "schemas.varText.betreiberHausnr": "Betreiber Hausnummer",
  "schemas.varText.firmaName": "Firma Name",
  "schemas.varText.firmaEMail": "Firma E-Mail",
  "schemas.varText.firmaTelefon": "Firma Telefon",
  "schemas.varText.firmaStrasse": "Firma Stra\xDFe",
  "schemas.varText.firmaPLZ": "Firma PLZ",
  "schemas.varText.firmaOrt": "Firma Ort",
  "schemas.varText.firmaAnsprechpartner": "Firma Ansprechpartner",
  "schemas.varText.firmaHausnr": "Firma Hausnummer",
  "schemas.varText.pruefungGrundlage": "Pr\xFCfung Grundlage",
  "schemas.varText.pruefungVertragsnummer": "Pr\xFCfung Vertragsnummer",
  "schemas.varText.pruefungPruefDatum": "Pr\xFCfung Pr\xFCfdatum",
  "schemas.varText.pruefungNaechstePruef": "Pr\xFCfung N\xE4chste Pr\xFCfung",
  "schemas.varText.objektHersteller": "Objekt Hersteller",
  "schemas.varText.objektStandort": "Objekt Standort",
  "schemas.varText.objektTyp": "Objekt Typ",
  "schemas.varText.objektSeriennummer": "Objekt Seriennummer",
  "schemas.varText.objektInterneNummer": "Objekt Interne Nummer",
  "schemas.varText.objektBaujahr": "Objekt Baujahr",
  "schemas.varText.objektSteuerung": "Objekt Steuerung",
  "schemas.varText.objektBetriebsart": "Objekt Betriebsart",
  "schemas.varText.objektBreite": "Objekt Breite",
  "schemas.varText.objektHoehe": "Objekt H\xF6he",
  "schemas.varText.objektBemerkung": "Objekt Bemerkung",
  "schemas.varText.prueferVorname": "Pr\xFCfer Vorname",
  "schemas.varText.prueferNachname": "Pr\xFCfer Nachname",
  "schemas.varText.prueferEMail": "Pr\xFCfer E-Mail",
  "schemas.measurementPointList.measurement": "Messung",
  "schemas.measurementPointList.contactPoint": "Kontaktstelle",
  "schemas.measurementPointList.assessment": "Bewertung",
  "schemas.measurementPointList.max": "Maximalwert",
  "schemas.measurementPointList.average": "Mittelwert",
  set: "",
  clear: "",
  "validation.dateTimeFormat": "",
  "schemas.radius": "",
  "schemas.date.locale": ""
};
var dictionaries = {
  en: dictEn,
  de: dictDe
};
var getDict = (lang) => dictionaries[lang] || dictionaries[DEFAULT_LANG];
var i18n = (key2, dict) => (dict || getDict(DEFAULT_LANG))[key2];

// ../schemas/dist/esm/src/text/constants.js
var DEFAULT_FONT_SIZE = 13;
var ALIGN_LEFT = "left";
var ALIGN_CENTER = "center";
var ALIGN_RIGHT = "right";
var ALIGN_JUSTIFY = "justify";
var DEFAULT_ALIGNMENT = ALIGN_LEFT;
var VERTICAL_ALIGN_TOP = "top";
var VERTICAL_ALIGN_MIDDLE = "middle";
var VERTICAL_ALIGN_BOTTOM = "bottom";
var DEFAULT_VERTICAL_ALIGNMENT = VERTICAL_ALIGN_TOP;
var DEFAULT_LINE_HEIGHT = 1;
var DEFAULT_CHARACTER_SPACING = 0;
var DEFAULT_FONT_COLOR = "#000000";
var PLACEHOLDER_FONT_COLOR = "#A0A0A0";
var DYNAMIC_FIT_VERTICAL = "vertical";
var DYNAMIC_FIT_HORIZONTAL = "horizontal";
var DEFAULT_DYNAMIC_FIT = DYNAMIC_FIT_VERTICAL;
var DEFAULT_DYNAMIC_MIN_FONT_SIZE = 4;
var DEFAULT_DYNAMIC_MAX_FONT_SIZE = 72;
var FONT_SIZE_ADJUSTMENT = 0.25;
var LINE_START_FORBIDDEN_CHARS = [
  // 句読点
  "\u3001",
  "\u3002",
  ",",
  ".",
  // 閉じカッコ類
  "\u300D",
  "\u300F",
  ")",
  "}",
  "\u3011",
  ">",
  "\u226B",
  "]",
  // 記号
  "\u30FB",
  "\u30FC",
  "\u2015",
  "-",
  // 約物
  "!",
  "\uFF01",
  "?",
  "\uFF1F",
  ":",
  "\uFF1A",
  ";",
  "\uFF1B",
  "/",
  "\uFF0F",
  // 繰り返し記号
  "\u309D",
  "\u3005",
  "\u3003",
  // 拗音・促音（小書きのかな）
  "\u3041",
  "\u3043",
  "\u3045",
  "\u3047",
  "\u3049",
  "\u3063",
  "\u3083",
  "\u3085",
  "\u3087",
  "\u30A1",
  "\u30A3",
  "\u30A5",
  "\u30A7",
  "\u30A9",
  "\u30C3",
  "\u30E3",
  "\u30E5",
  "\u30E7"
];
var LINE_END_FORBIDDEN_CHARS = [
  // 始め括弧類
  "\u300C",
  "\u300E",
  "\uFF08",
  "\uFF5B",
  "\u3010",
  "\uFF1C",
  "\u226A",
  "\uFF3B",
  "\u3018",
  "\u3016",
  "\u301D",
  "\u2018",
  "\u201C",
  "\uFF5F",
  "\xAB"
];

// ../../node_modules/restructure/src/DecodeStream.js
var ENCODING_MAPPING = {
  utf16le: "utf-16le",
  ucs2: "utf-16le",
  utf16be: "utf-16be"
};
var DecodeStream = class {
  constructor(buffer) {
    this.buffer = buffer;
    this.view = new DataView(buffer.buffer, buffer.byteOffset, buffer.byteLength);
    this.pos = 0;
    this.length = this.buffer.length;
  }
  readString(length2, encoding = "ascii") {
    encoding = ENCODING_MAPPING[encoding] || encoding;
    let buf = this.readBuffer(length2);
    try {
      let decoder = new TextDecoder(encoding);
      return decoder.decode(buf);
    } catch (err) {
      return buf;
    }
  }
  readBuffer(length2) {
    return this.buffer.slice(this.pos, this.pos += length2);
  }
  readUInt24BE() {
    return (this.readUInt16BE() << 8) + this.readUInt8();
  }
  readUInt24LE() {
    return this.readUInt16LE() + (this.readUInt8() << 16);
  }
  readInt24BE() {
    return (this.readInt16BE() << 8) + this.readUInt8();
  }
  readInt24LE() {
    return this.readUInt16LE() + (this.readInt8() << 16);
  }
};
DecodeStream.TYPES = {
  UInt8: 1,
  UInt16: 2,
  UInt24: 3,
  UInt32: 4,
  Int8: 1,
  Int16: 2,
  Int24: 3,
  Int32: 4,
  Float: 4,
  Double: 8
};
for (let key2 of Object.getOwnPropertyNames(DataView.prototype)) {
  if (key2.slice(0, 3) === "get") {
    let type5 = key2.slice(3).replace("Ui", "UI");
    if (type5 === "Float32") {
      type5 = "Float";
    } else if (type5 === "Float64") {
      type5 = "Double";
    }
    let bytes = DecodeStream.TYPES[type5];
    DecodeStream.prototype["read" + type5 + (bytes === 1 ? "" : "BE")] = function() {
      const ret = this.view[key2](this.pos, false);
      this.pos += bytes;
      return ret;
    };
    if (bytes !== 1) {
      DecodeStream.prototype["read" + type5 + "LE"] = function() {
        const ret = this.view[key2](this.pos, true);
        this.pos += bytes;
        return ret;
      };
    }
  }
}

// ../../node_modules/restructure/src/EncodeStream.js
var textEncoder = new TextEncoder();
var isBigEndian = new Uint8Array(new Uint16Array([4660]).buffer)[0] == 18;
var EncodeStream = class {
  constructor(buffer) {
    this.buffer = buffer;
    this.view = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
    this.pos = 0;
  }
  writeBuffer(buffer) {
    this.buffer.set(buffer, this.pos);
    this.pos += buffer.length;
  }
  writeString(string3, encoding = "ascii") {
    let buf;
    switch (encoding) {
      case "utf16le":
      case "utf16-le":
      case "ucs2":
        buf = stringToUtf16(string3, isBigEndian);
        break;
      case "utf16be":
      case "utf16-be":
        buf = stringToUtf16(string3, !isBigEndian);
        break;
      case "utf8":
        buf = textEncoder.encode(string3);
        break;
      case "ascii":
        buf = stringToAscii(string3);
        break;
      default:
        throw new Error(`Unsupported encoding: ${encoding}`);
    }
    this.writeBuffer(buf);
  }
  writeUInt24BE(val) {
    this.buffer[this.pos++] = val >>> 16 & 255;
    this.buffer[this.pos++] = val >>> 8 & 255;
    this.buffer[this.pos++] = val & 255;
  }
  writeUInt24LE(val) {
    this.buffer[this.pos++] = val & 255;
    this.buffer[this.pos++] = val >>> 8 & 255;
    this.buffer[this.pos++] = val >>> 16 & 255;
  }
  writeInt24BE(val) {
    if (val >= 0) {
      this.writeUInt24BE(val);
    } else {
      this.writeUInt24BE(val + 16777215 + 1);
    }
  }
  writeInt24LE(val) {
    if (val >= 0) {
      this.writeUInt24LE(val);
    } else {
      this.writeUInt24LE(val + 16777215 + 1);
    }
  }
  fill(val, length2) {
    if (length2 < this.buffer.length) {
      this.buffer.fill(val, this.pos, this.pos + length2);
      this.pos += length2;
    } else {
      const buf = new Uint8Array(length2);
      buf.fill(val);
      this.writeBuffer(buf);
    }
  }
};
function stringToUtf16(string3, swap2) {
  let buf = new Uint16Array(string3.length);
  for (let i = 0; i < string3.length; i++) {
    let code2 = string3.charCodeAt(i);
    if (swap2) {
      code2 = code2 >> 8 | (code2 & 255) << 8;
    }
    buf[i] = code2;
  }
  return new Uint8Array(buf.buffer);
}
function stringToAscii(string3) {
  let buf = new Uint8Array(string3.length);
  for (let i = 0; i < string3.length; i++) {
    buf[i] = string3.charCodeAt(i);
  }
  return buf;
}
for (let key2 of Object.getOwnPropertyNames(DataView.prototype)) {
  if (key2.slice(0, 3) === "set") {
    let type5 = key2.slice(3).replace("Ui", "UI");
    if (type5 === "Float32") {
      type5 = "Float";
    } else if (type5 === "Float64") {
      type5 = "Double";
    }
    let bytes = DecodeStream.TYPES[type5];
    EncodeStream.prototype["write" + type5 + (bytes === 1 ? "" : "BE")] = function(value) {
      this.view[key2](this.pos, value, false);
      this.pos += bytes;
    };
    if (bytes !== 1) {
      EncodeStream.prototype["write" + type5 + "LE"] = function(value) {
        this.view[key2](this.pos, value, true);
        this.pos += bytes;
      };
    }
  }
}

// ../../node_modules/restructure/src/Base.js
var Base = class {
  fromBuffer(buffer) {
    let stream = new DecodeStream(buffer);
    return this.decode(stream);
  }
  toBuffer(value) {
    let size = this.size(value);
    let buffer = new Uint8Array(size);
    let stream = new EncodeStream(buffer);
    this.encode(stream, value);
    return buffer;
  }
};

// ../../node_modules/restructure/src/Number.js
var NumberT = class extends Base {
  constructor(type5, endian = "BE") {
    super();
    this.type = type5;
    this.endian = endian;
    this.fn = this.type;
    if (this.type[this.type.length - 1] !== "8") {
      this.fn += this.endian;
    }
  }
  size() {
    return DecodeStream.TYPES[this.type];
  }
  decode(stream) {
    return stream[`read${this.fn}`]();
  }
  encode(stream, val) {
    return stream[`write${this.fn}`](val);
  }
};
var uint8 = new NumberT("UInt8");
var uint16be = new NumberT("UInt16", "BE");
var uint16 = uint16be;
var uint16le = new NumberT("UInt16", "LE");
var uint24be = new NumberT("UInt24", "BE");
var uint24 = uint24be;
var uint24le = new NumberT("UInt24", "LE");
var uint32be = new NumberT("UInt32", "BE");
var uint32 = uint32be;
var uint32le = new NumberT("UInt32", "LE");
var int8 = new NumberT("Int8");
var int16be = new NumberT("Int16", "BE");
var int16 = int16be;
var int16le = new NumberT("Int16", "LE");
var int24be = new NumberT("Int24", "BE");
var int24le = new NumberT("Int24", "LE");
var int32be = new NumberT("Int32", "BE");
var int32 = int32be;
var int32le = new NumberT("Int32", "LE");
var floatbe = new NumberT("Float", "BE");
var floatle = new NumberT("Float", "LE");
var doublebe = new NumberT("Double", "BE");
var doublele = new NumberT("Double", "LE");
var Fixed = class extends NumberT {
  constructor(size, endian, fracBits = size >> 1) {
    super(`Int${size}`, endian);
    this._point = 1 << fracBits;
  }
  decode(stream) {
    return super.decode(stream) / this._point;
  }
  encode(stream, val) {
    return super.encode(stream, val * this._point | 0);
  }
};
var fixed16be = new Fixed(16, "BE");
var fixed16 = fixed16be;
var fixed16le = new Fixed(16, "LE");
var fixed32be = new Fixed(32, "BE");
var fixed32 = fixed32be;
var fixed32le = new Fixed(32, "LE");

// ../../node_modules/restructure/src/utils.js
function resolveLength(length2, stream, parent2) {
  let res;
  if (typeof length2 === "number") {
    res = length2;
  } else if (typeof length2 === "function") {
    res = length2.call(parent2, parent2);
  } else if (parent2 && typeof length2 === "string") {
    res = parent2[length2];
  } else if (stream && length2 instanceof NumberT) {
    res = length2.decode(stream);
  }
  if (isNaN(res)) {
    throw new Error("Not a fixed size");
  }
  return res;
}
var PropertyDescriptor = class {
  constructor(opts = {}) {
    this.enumerable = true;
    this.configurable = true;
    for (let key2 in opts) {
      const val = opts[key2];
      this[key2] = val;
    }
  }
};

// ../../node_modules/restructure/src/Array.js
var ArrayT = class extends Base {
  constructor(type5, length2, lengthType = "count") {
    super();
    this.type = type5;
    this.length = length2;
    this.lengthType = lengthType;
  }
  decode(stream, parent2) {
    let length2;
    const { pos } = stream;
    const res = [];
    let ctx = parent2;
    if (this.length != null) {
      length2 = resolveLength(this.length, stream, parent2);
    }
    if (this.length instanceof NumberT) {
      Object.defineProperties(res, {
        parent: { value: parent2 },
        _startOffset: { value: pos },
        _currentOffset: { value: 0, writable: true },
        _length: { value: length2 }
      });
      ctx = res;
    }
    if (length2 == null || this.lengthType === "bytes") {
      const target = length2 != null ? stream.pos + length2 : (parent2 != null ? parent2._length : void 0) ? parent2._startOffset + parent2._length : stream.length;
      while (stream.pos < target) {
        res.push(this.type.decode(stream, ctx));
      }
    } else {
      for (let i = 0, end = length2; i < end; i++) {
        res.push(this.type.decode(stream, ctx));
      }
    }
    return res;
  }
  size(array4, ctx, includePointers = true) {
    if (!array4) {
      return this.type.size(null, ctx) * resolveLength(this.length, null, ctx);
    }
    let size = 0;
    if (this.length instanceof NumberT) {
      size += this.length.size();
      ctx = { parent: ctx, pointerSize: 0 };
    }
    for (let item of array4) {
      size += this.type.size(item, ctx);
    }
    if (ctx && includePointers && this.length instanceof NumberT) {
      size += ctx.pointerSize;
    }
    return size;
  }
  encode(stream, array4, parent2) {
    let ctx = parent2;
    if (this.length instanceof NumberT) {
      ctx = {
        pointers: [],
        startOffset: stream.pos,
        parent: parent2
      };
      ctx.pointerOffset = stream.pos + this.size(array4, ctx, false);
      this.length.encode(stream, array4.length);
    }
    for (let item of array4) {
      this.type.encode(stream, item, ctx);
    }
    if (this.length instanceof NumberT) {
      let i = 0;
      while (i < ctx.pointers.length) {
        const ptr = ctx.pointers[i++];
        ptr.type.encode(stream, ptr.val, ptr.parent);
      }
    }
  }
};

// ../../node_modules/restructure/src/LazyArray.js
var LazyArray = class extends ArrayT {
  decode(stream, parent2) {
    const { pos } = stream;
    const length2 = resolveLength(this.length, stream, parent2);
    if (this.length instanceof NumberT) {
      parent2 = {
        parent: parent2,
        _startOffset: pos,
        _currentOffset: 0,
        _length: length2
      };
    }
    const res = new LazyArrayValue(this.type, length2, stream, parent2);
    stream.pos += length2 * this.type.size(null, parent2);
    return res;
  }
  size(val, ctx) {
    if (val instanceof LazyArrayValue) {
      val = val.toArray();
    }
    return super.size(val, ctx);
  }
  encode(stream, val, ctx) {
    if (val instanceof LazyArrayValue) {
      val = val.toArray();
    }
    return super.encode(stream, val, ctx);
  }
};
var LazyArrayValue = class {
  constructor(type5, length2, stream, ctx) {
    this.type = type5;
    this.length = length2;
    this.stream = stream;
    this.ctx = ctx;
    this.base = this.stream.pos;
    this.items = [];
  }
  get(index3) {
    if (index3 < 0 || index3 >= this.length) {
      return void 0;
    }
    if (this.items[index3] == null) {
      const { pos } = this.stream;
      this.stream.pos = this.base + this.type.size(null, this.ctx) * index3;
      this.items[index3] = this.type.decode(this.stream, this.ctx);
      this.stream.pos = pos;
    }
    return this.items[index3];
  }
  toArray() {
    const result = [];
    for (let i = 0, end = this.length; i < end; i++) {
      result.push(this.get(i));
    }
    return result;
  }
};

// ../../node_modules/restructure/src/Bitfield.js
var Bitfield = class extends Base {
  constructor(type5, flags = []) {
    super();
    this.type = type5;
    this.flags = flags;
  }
  decode(stream) {
    const val = this.type.decode(stream);
    const res = {};
    for (let i = 0; i < this.flags.length; i++) {
      const flag = this.flags[i];
      if (flag != null) {
        res[flag] = !!(val & 1 << i);
      }
    }
    return res;
  }
  size() {
    return this.type.size();
  }
  encode(stream, keys4) {
    let val = 0;
    for (let i = 0; i < this.flags.length; i++) {
      const flag = this.flags[i];
      if (flag != null) {
        if (keys4[flag]) {
          val |= 1 << i;
        }
      }
    }
    return this.type.encode(stream, val);
  }
};

// ../../node_modules/restructure/src/Buffer.js
var BufferT = class extends Base {
  constructor(length2) {
    super();
    this.length = length2;
  }
  decode(stream, parent2) {
    const length2 = resolveLength(this.length, stream, parent2);
    return stream.readBuffer(length2);
  }
  size(val, parent2) {
    if (!val) {
      return resolveLength(this.length, null, parent2);
    }
    let len = val.length;
    if (this.length instanceof NumberT) {
      len += this.length.size();
    }
    return len;
  }
  encode(stream, buf, parent2) {
    if (this.length instanceof NumberT) {
      this.length.encode(stream, buf.length);
    }
    return stream.writeBuffer(buf);
  }
};

// ../../node_modules/restructure/src/Optional.js
var Optional = class extends Base {
  constructor(type5, condition = true) {
    super();
    this.type = type5;
    this.condition = condition;
  }
  decode(stream, parent2) {
    let { condition } = this;
    if (typeof condition === "function") {
      condition = condition.call(parent2, parent2);
    }
    if (condition) {
      return this.type.decode(stream, parent2);
    }
  }
  size(val, parent2) {
    let { condition } = this;
    if (typeof condition === "function") {
      condition = condition.call(parent2, parent2);
    }
    if (condition) {
      return this.type.size(val, parent2);
    } else {
      return 0;
    }
  }
  encode(stream, val, parent2) {
    let { condition } = this;
    if (typeof condition === "function") {
      condition = condition.call(parent2, parent2);
    }
    if (condition) {
      return this.type.encode(stream, val, parent2);
    }
  }
};

// ../../node_modules/restructure/src/Reserved.js
var Reserved = class extends Base {
  constructor(type5, count = 1) {
    super();
    this.type = type5;
    this.count = count;
  }
  decode(stream, parent2) {
    stream.pos += this.size(null, parent2);
    return void 0;
  }
  size(data2, parent2) {
    const count = resolveLength(this.count, null, parent2);
    return this.type.size() * count;
  }
  encode(stream, val, parent2) {
    return stream.fill(0, this.size(val, parent2));
  }
};

// ../../node_modules/restructure/src/String.js
var StringT = class extends Base {
  constructor(length2, encoding = "ascii") {
    super();
    this.length = length2;
    this.encoding = encoding;
  }
  decode(stream, parent2) {
    let length2, pos;
    let { encoding } = this;
    if (typeof encoding === "function") {
      encoding = encoding.call(parent2, parent2) || "ascii";
    }
    let width = encodingWidth(encoding);
    if (this.length != null) {
      length2 = resolveLength(this.length, stream, parent2);
    } else {
      let buffer;
      ({ buffer, length: length2, pos } = stream);
      while (pos < length2 - width + 1 && (buffer[pos] !== 0 || width === 2 && buffer[pos + 1] !== 0)) {
        pos += width;
      }
      length2 = pos - stream.pos;
    }
    const string3 = stream.readString(length2, encoding);
    if (this.length == null && stream.pos < stream.length) {
      stream.pos += width;
    }
    return string3;
  }
  size(val, parent2) {
    if (val === void 0 || val === null) {
      return resolveLength(this.length, null, parent2);
    }
    let { encoding } = this;
    if (typeof encoding === "function") {
      encoding = encoding.call(parent2 != null ? parent2.val : void 0, parent2 != null ? parent2.val : void 0) || "ascii";
    }
    if (encoding === "utf16be") {
      encoding = "utf16le";
    }
    let size = byteLength(val, encoding);
    if (this.length instanceof NumberT) {
      size += this.length.size();
    }
    if (this.length == null) {
      size += encodingWidth(encoding);
    }
    return size;
  }
  encode(stream, val, parent2) {
    let { encoding } = this;
    if (typeof encoding === "function") {
      encoding = encoding.call(parent2 != null ? parent2.val : void 0, parent2 != null ? parent2.val : void 0) || "ascii";
    }
    if (this.length instanceof NumberT) {
      this.length.encode(stream, byteLength(val, encoding));
    }
    stream.writeString(val, encoding);
    if (this.length == null) {
      return encodingWidth(encoding) == 2 ? stream.writeUInt16LE(0) : stream.writeUInt8(0);
    }
  }
};
function encodingWidth(encoding) {
  switch (encoding) {
    case "ascii":
    case "utf8":
      return 1;
    case "utf16le":
    case "utf16-le":
    case "utf-16be":
    case "utf-16le":
    case "utf16be":
    case "utf16-be":
    case "ucs2":
      return 2;
    default:
      return 1;
  }
}
function byteLength(string3, encoding) {
  switch (encoding) {
    case "ascii":
      return string3.length;
    case "utf8":
      let len = 0;
      for (let i = 0; i < string3.length; i++) {
        let c = string3.charCodeAt(i);
        if (c >= 55296 && c <= 56319 && i < string3.length - 1) {
          let c2 = string3.charCodeAt(++i);
          if ((c2 & 64512) === 56320) {
            c = ((c & 1023) << 10) + (c2 & 1023) + 65536;
          } else {
            i--;
          }
        }
        if ((c & 4294967168) === 0) {
          len++;
        } else if ((c & 4294965248) === 0) {
          len += 2;
        } else if ((c & 4294901760) === 0) {
          len += 3;
        } else if ((c & 4292870144) === 0) {
          len += 4;
        }
      }
      return len;
    case "utf16le":
    case "utf16-le":
    case "utf16be":
    case "utf16-be":
    case "ucs2":
      return string3.length * 2;
    default:
      throw new Error("Unknown encoding " + encoding);
  }
}

// ../../node_modules/restructure/src/Struct.js
var Struct = class extends Base {
  constructor(fields = {}) {
    super();
    this.fields = fields;
  }
  decode(stream, parent2, length2 = 0) {
    const res = this._setup(stream, parent2, length2);
    this._parseFields(stream, res, this.fields);
    if (this.process != null) {
      this.process.call(res, stream);
    }
    return res;
  }
  _setup(stream, parent2, length2) {
    const res = {};
    Object.defineProperties(res, {
      parent: { value: parent2 },
      _startOffset: { value: stream.pos },
      _currentOffset: { value: 0, writable: true },
      _length: { value: length2 }
    });
    return res;
  }
  _parseFields(stream, res, fields) {
    for (let key2 in fields) {
      var val;
      const type5 = fields[key2];
      if (typeof type5 === "function") {
        val = type5.call(res, res);
      } else {
        val = type5.decode(stream, res);
      }
      if (val !== void 0) {
        if (val instanceof PropertyDescriptor) {
          Object.defineProperty(res, key2, val);
        } else {
          res[key2] = val;
        }
      }
      res._currentOffset = stream.pos - res._startOffset;
    }
  }
  size(val, parent2, includePointers = true) {
    if (val == null) {
      val = {};
    }
    const ctx = {
      parent: parent2,
      val,
      pointerSize: 0
    };
    if (this.preEncode != null) {
      this.preEncode.call(val);
    }
    let size = 0;
    for (let key2 in this.fields) {
      const type5 = this.fields[key2];
      if (type5.size != null) {
        size += type5.size(val[key2], ctx);
      }
    }
    if (includePointers) {
      size += ctx.pointerSize;
    }
    return size;
  }
  encode(stream, val, parent2) {
    let type5;
    if (this.preEncode != null) {
      this.preEncode.call(val, stream);
    }
    const ctx = {
      pointers: [],
      startOffset: stream.pos,
      parent: parent2,
      val,
      pointerSize: 0
    };
    ctx.pointerOffset = stream.pos + this.size(val, ctx, false);
    for (let key2 in this.fields) {
      type5 = this.fields[key2];
      if (type5.encode != null) {
        type5.encode(stream, val[key2], ctx);
      }
    }
    let i = 0;
    while (i < ctx.pointers.length) {
      const ptr = ctx.pointers[i++];
      ptr.type.encode(stream, ptr.val, ptr.parent);
    }
  }
};

// ../../node_modules/restructure/src/VersionedStruct.js
var getPath = (object4, pathArray) => {
  return pathArray.reduce((prevObj, key2) => prevObj && prevObj[key2], object4);
};
var VersionedStruct = class _VersionedStruct extends Struct {
  constructor(type5, versions = {}) {
    super();
    this.type = type5;
    this.versions = versions;
    if (typeof type5 === "string") {
      this.versionPath = type5.split(".");
    }
  }
  decode(stream, parent2, length2 = 0) {
    const res = this._setup(stream, parent2, length2);
    if (typeof this.type === "string") {
      res.version = getPath(parent2, this.versionPath);
    } else {
      res.version = this.type.decode(stream);
    }
    if (this.versions.header) {
      this._parseFields(stream, res, this.versions.header);
    }
    const fields = this.versions[res.version];
    if (fields == null) {
      throw new Error(`Unknown version ${res.version}`);
    }
    if (fields instanceof _VersionedStruct) {
      return fields.decode(stream, parent2);
    }
    this._parseFields(stream, res, fields);
    if (this.process != null) {
      this.process.call(res, stream);
    }
    return res;
  }
  size(val, parent2, includePointers = true) {
    let key2, type5;
    if (!val) {
      throw new Error("Not a fixed size");
    }
    if (this.preEncode != null) {
      this.preEncode.call(val);
    }
    const ctx = {
      parent: parent2,
      val,
      pointerSize: 0
    };
    let size = 0;
    if (typeof this.type !== "string") {
      size += this.type.size(val.version, ctx);
    }
    if (this.versions.header) {
      for (key2 in this.versions.header) {
        type5 = this.versions.header[key2];
        if (type5.size != null) {
          size += type5.size(val[key2], ctx);
        }
      }
    }
    const fields = this.versions[val.version];
    if (fields == null) {
      throw new Error(`Unknown version ${val.version}`);
    }
    for (key2 in fields) {
      type5 = fields[key2];
      if (type5.size != null) {
        size += type5.size(val[key2], ctx);
      }
    }
    if (includePointers) {
      size += ctx.pointerSize;
    }
    return size;
  }
  encode(stream, val, parent2) {
    let key2, type5;
    if (this.preEncode != null) {
      this.preEncode.call(val, stream);
    }
    const ctx = {
      pointers: [],
      startOffset: stream.pos,
      parent: parent2,
      val,
      pointerSize: 0
    };
    ctx.pointerOffset = stream.pos + this.size(val, ctx, false);
    if (typeof this.type !== "string") {
      this.type.encode(stream, val.version);
    }
    if (this.versions.header) {
      for (key2 in this.versions.header) {
        type5 = this.versions.header[key2];
        if (type5.encode != null) {
          type5.encode(stream, val[key2], ctx);
        }
      }
    }
    const fields = this.versions[val.version];
    for (key2 in fields) {
      type5 = fields[key2];
      if (type5.encode != null) {
        type5.encode(stream, val[key2], ctx);
      }
    }
    let i = 0;
    while (i < ctx.pointers.length) {
      const ptr = ctx.pointers[i++];
      ptr.type.encode(stream, ptr.val, ptr.parent);
    }
  }
};

// ../../node_modules/restructure/src/Pointer.js
var Pointer = class extends Base {
  constructor(offsetType, type5, options = {}) {
    super();
    this.offsetType = offsetType;
    this.type = type5;
    this.options = options;
    if (this.type === "void") {
      this.type = null;
    }
    if (this.options.type == null) {
      this.options.type = "local";
    }
    if (this.options.allowNull == null) {
      this.options.allowNull = true;
    }
    if (this.options.nullValue == null) {
      this.options.nullValue = 0;
    }
    if (this.options.lazy == null) {
      this.options.lazy = false;
    }
    if (this.options.relativeTo) {
      if (typeof this.options.relativeTo !== "function") {
        throw new Error("relativeTo option must be a function");
      }
      this.relativeToGetter = options.relativeTo;
    }
  }
  decode(stream, ctx) {
    const offset4 = this.offsetType.decode(stream, ctx);
    if (offset4 === this.options.nullValue && this.options.allowNull) {
      return null;
    }
    let relative;
    switch (this.options.type) {
      case "local":
        relative = ctx._startOffset;
        break;
      case "immediate":
        relative = stream.pos - this.offsetType.size();
        break;
      case "parent":
        relative = ctx.parent._startOffset;
        break;
      default:
        var c = ctx;
        while (c.parent) {
          c = c.parent;
        }
        relative = c._startOffset || 0;
    }
    if (this.options.relativeTo) {
      relative += this.relativeToGetter(ctx);
    }
    const ptr = offset4 + relative;
    if (this.type != null) {
      let val = null;
      const decodeValue = () => {
        if (val != null) {
          return val;
        }
        const { pos } = stream;
        stream.pos = ptr;
        val = this.type.decode(stream, ctx);
        stream.pos = pos;
        return val;
      };
      if (this.options.lazy) {
        return new PropertyDescriptor({
          get: decodeValue
        });
      }
      return decodeValue();
    } else {
      return ptr;
    }
  }
  size(val, ctx) {
    const parent2 = ctx;
    switch (this.options.type) {
      case "local":
      case "immediate":
        break;
      case "parent":
        ctx = ctx.parent;
        break;
      default:
        while (ctx.parent) {
          ctx = ctx.parent;
        }
    }
    let { type: type5 } = this;
    if (type5 == null) {
      if (!(val instanceof VoidPointer)) {
        throw new Error("Must be a VoidPointer");
      }
      ({ type: type5 } = val);
      val = val.value;
    }
    if (val && ctx) {
      let size = type5.size(val, parent2);
      ctx.pointerSize += size;
    }
    return this.offsetType.size();
  }
  encode(stream, val, ctx) {
    let relative;
    const parent2 = ctx;
    if (val == null) {
      this.offsetType.encode(stream, this.options.nullValue);
      return;
    }
    switch (this.options.type) {
      case "local":
        relative = ctx.startOffset;
        break;
      case "immediate":
        relative = stream.pos + this.offsetType.size(val, parent2);
        break;
      case "parent":
        ctx = ctx.parent;
        relative = ctx.startOffset;
        break;
      default:
        relative = 0;
        while (ctx.parent) {
          ctx = ctx.parent;
        }
    }
    if (this.options.relativeTo) {
      relative += this.relativeToGetter(parent2.val);
    }
    this.offsetType.encode(stream, ctx.pointerOffset - relative);
    let { type: type5 } = this;
    if (type5 == null) {
      if (!(val instanceof VoidPointer)) {
        throw new Error("Must be a VoidPointer");
      }
      ({ type: type5 } = val);
      val = val.value;
    }
    ctx.pointers.push({
      type: type5,
      val,
      parent: parent2
    });
    return ctx.pointerOffset += type5.size(val, parent2);
  }
};
var VoidPointer = class {
  constructor(type5, value) {
    this.type = type5;
    this.value = value;
  }
};

// ../../node_modules/@swc/helpers/esm/_define_property.js
function _define_property(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else obj[key2] = value;
  return obj;
}

// ../../node_modules/tslib/tslib.es6.mjs
var __assign = function() {
  __assign = Object.assign || function __assign11(t2) {
    for (var s, i = 1, n2 = arguments.length; i < n2; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t2[p] = s[p];
    }
    return t2;
  };
  return __assign.apply(this, arguments);
};
function __rest(s, e3) {
  var t2 = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e3.indexOf(p) < 0)
    t2[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
      if (e3.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
        t2[p[i]] = s[p[i]];
    }
  return t2;
}
function __decorate(decorators, target, key2, desc) {
  var c = arguments.length, r2 = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key2) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r2 = Reflect.decorate(decorators, target, key2, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r2 = (c < 3 ? d(r2) : c > 3 ? d(target, key2, r2) : d(target, key2)) || r2;
  return c > 3 && r2 && Object.defineProperty(target, key2, r2), r2;
}
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function(resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e3) {
        reject(e3);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e3) {
        reject(e3);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __read(o3, n2) {
  var m = typeof Symbol === "function" && o3[Symbol.iterator];
  if (!m) return o3;
  var i = m.call(o3), r2, ar = [], e3;
  try {
    while ((n2 === void 0 || n2-- > 0) && !(r2 = i.next()).done) ar.push(r2.value);
  } catch (error2) {
    e3 = { error: error2 };
  } finally {
    try {
      if (r2 && !r2.done && (m = i["return"])) m.call(i);
    } finally {
      if (e3) throw e3.error;
    }
  }
  return ar;
}

// ../../node_modules/fontkit/dist/browser-module.mjs
var import_fast_deep_equal = __toESM(require_fast_deep_equal(), 1);

// ../../node_modules/unicode-properties/dist/module.mjs
var import_base64_js = __toESM(require_base64_js(), 1);
var import_unicode_trie = __toESM(require_unicode_trie(), 1);
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $f4087201da764553$exports = {};
$f4087201da764553$exports = JSON.parse('{"categories":["Cc","Zs","Po","Sc","Ps","Pe","Sm","Pd","Nd","Lu","Sk","Pc","Ll","So","Lo","Pi","Cf","No","Pf","Lt","Lm","Mn","Me","Mc","Nl","Zl","Zp","Cs","Co"],"combiningClasses":["Not_Reordered","Above","Above_Right","Below","Attached_Above_Right","Attached_Below","Overlay","Iota_Subscript","Double_Below","Double_Above","Below_Right","Above_Left","CCC10","CCC11","CCC12","CCC13","CCC14","CCC15","CCC16","CCC17","CCC18","CCC19","CCC20","CCC21","CCC22","CCC23","CCC24","CCC25","CCC30","CCC31","CCC32","CCC27","CCC28","CCC29","CCC33","CCC34","CCC35","CCC36","Nukta","Virama","CCC84","CCC91","CCC103","CCC107","CCC118","CCC122","CCC129","CCC130","CCC132","Attached_Above","Below_Left","Left","Kana_Voicing","CCC26","Right"],"scripts":["Common","Latin","Bopomofo","Inherited","Greek","Coptic","Cyrillic","Armenian","Hebrew","Arabic","Syriac","Thaana","Nko","Samaritan","Mandaic","Devanagari","Bengali","Gurmukhi","Gujarati","Oriya","Tamil","Telugu","Kannada","Malayalam","Sinhala","Thai","Lao","Tibetan","Myanmar","Georgian","Hangul","Ethiopic","Cherokee","Canadian_Aboriginal","Ogham","Runic","Tagalog","Hanunoo","Buhid","Tagbanwa","Khmer","Mongolian","Limbu","Tai_Le","New_Tai_Lue","Buginese","Tai_Tham","Balinese","Sundanese","Batak","Lepcha","Ol_Chiki","Braille","Glagolitic","Tifinagh","Han","Hiragana","Katakana","Yi","Lisu","Vai","Bamum","Syloti_Nagri","Phags_Pa","Saurashtra","Kayah_Li","Rejang","Javanese","Cham","Tai_Viet","Meetei_Mayek","null","Linear_B","Lycian","Carian","Old_Italic","Gothic","Old_Permic","Ugaritic","Old_Persian","Deseret","Shavian","Osmanya","Osage","Elbasan","Caucasian_Albanian","Linear_A","Cypriot","Imperial_Aramaic","Palmyrene","Nabataean","Hatran","Phoenician","Lydian","Meroitic_Hieroglyphs","Meroitic_Cursive","Kharoshthi","Old_South_Arabian","Old_North_Arabian","Manichaean","Avestan","Inscriptional_Parthian","Inscriptional_Pahlavi","Psalter_Pahlavi","Old_Turkic","Old_Hungarian","Hanifi_Rohingya","Old_Sogdian","Sogdian","Elymaic","Brahmi","Kaithi","Sora_Sompeng","Chakma","Mahajani","Sharada","Khojki","Multani","Khudawadi","Grantha","Newa","Tirhuta","Siddham","Modi","Takri","Ahom","Dogra","Warang_Citi","Nandinagari","Zanabazar_Square","Soyombo","Pau_Cin_Hau","Bhaiksuki","Marchen","Masaram_Gondi","Gunjala_Gondi","Makasar","Cuneiform","Egyptian_Hieroglyphs","Anatolian_Hieroglyphs","Mro","Bassa_Vah","Pahawh_Hmong","Medefaidrin","Miao","Tangut","Nushu","Duployan","SignWriting","Nyiakeng_Puachue_Hmong","Wancho","Mende_Kikakui","Adlam"],"eaw":["N","Na","A","W","H","F"]}');
var $747425b437e121da$var$trie = new (0, import_unicode_trie.default)((0, import_base64_js.default).toByteArray("AAARAAAAAADwfAEAZXl5ONRt+/5bPVFZimRfKoTQJNm37CGE7Iw0j3UsTWKsoyI7kwyyTiEUzSD7NiEzhWYijH0wMVkHE4Mx49fzfo+3nuP4/fdZjvv+XNd5n/d9nef1WZvmKhTxiZndzDQBSEYQqxqKwnsKvGQucFh+6t6cJ792ePQBZv5S9yXSwkyjf/P4T7mTNnIAv1dOVhMlR9lflbUL9JeJguqsjvG9NTj/wLb566VAURnLo2vvRi89S3gW/33ihh2eXpDn40BIW7REl/7coRKIhAFlAiOtbLDTt6mMb4GzMF1gNnvX/sBxtbsAIjfztCNcQjcNDtLThRvuXu5M5g/CBjaLBE4lJm4qy/oZD97+IJryApcXfgWYlkvWbhfXgujOJKVu8B+ozqTLbxyJ5kNiR75CxDqfBM9eOlDMmGeoZ0iQbbS5VUplIwI+ZNXEKQVJxlwqjhOY7w3XwPesbLK5JZE+Tt4X8q8km0dzInsPPzbscrjBMVjF5mOHSeRdJVgKUjLTHiHqXSPkep8N/zFk8167KLp75f6RndkvzdfB6Uz3MmqvRArzdCbs1/iRZjYPLLF3U8Qs+H+Rb8iK51a6NIV2V9+07uJsTGFWpPz8J++7iRu2B6eAKlK/kujrLthwaD/7a6J5w90TusnH1JMAc+gNrql4aspOUG/RrsxUKmPzhHgP4Bleru+6Vfc/MBjgXVx7who94nPn7MPFrnwQP7g0k0Dq0h2GSKO6fTZ8nLodN1SiOUj/5EL/Xo1DBvRm0wmrh3x6phcJ20/9CuMr5h8WPqXMSasLoLHoufTmE7mzYrs6B0dY7KjuCogKqsvxnxAwXWvd9Puc9PnE8DOHT2INHxRlIyVHrqZahtfV2E/A2PDdtA3ewlRHMtFIBKO/T4IozWTQZ+mb+gdKuk/ZHrqloucKdsOSJmlWTSntWjcxVMjUmroXLM10I6TwDLnBq4LP69TxgVeyGsd8yHvhF8ydPlrNRSNs9EP7WmeuSE7Lu10JbOuQcJw/63sDp68wB9iwP5AO+mBpV0R5VDDeyQUFCel1G+4KHBgEVFS0YK+m2sXLWLuGTlkVAd97WwKKdacjWElRCuDRauf33l/yVcDF6sVPKeTes99FC1NpNWcpieGSV/IbO8PCTy5pbUR1U8lxzf4T+y6fZMxOz3LshkQLeeDSd0WmUrQgajmbktrxsb2AZ0ACw2Vgni+gV/m+KvCRWLg08Clx7uhql+v9XySGcjjOHlsp8vBw/e8HS7dtiqF6T/XcSXuaMW66GF1g4q9YyBadHqy3Y5jin1c7yZos6BBr6dsomSHxiUHanYtcYQwnMMZhRhOnaYJeyJzaRuukyCUh48+e/BUvk/aEfDp8ag+jD64BHxNnQ5v/E7WRk7eLjGV13I3oqy45YNONi/1op1oDr7rPjkhPsTXgUpQtGDPlIs55KhQaic9kSGs/UrZ2QKQOflB8MTEQxRF9pullToWO7Eplan6mcMRFnUu2441yxi23x+KqKlr7RWWsi9ZXMWlr8vfP3llk1m2PRj0yudccxBuoa7VfIgRmnFPGX6Pm1WIfMm/Rm4n/xTn8IGqA0GWuqgu48pEUO0U9nN+ZdIvFpPb7VDPphIfRZxznlHeVFebkd9l+raXy9BpTMcIUIvBfgHEb6ndGo8VUkxpief14KjzFOcaANfgvFpvyY8lE8lE4raHizLpluPzMks1hx/e1Hok5yV0p7qQH7GaYeMzzZTFvRpv6k6iaJ4yNqzBvN8J7B430h2wFm1IBPcqbou33G7/NWPgopl4Mllla6e24L3TOTVNkza2zv3QKuDWTeDpClCEYgTQ+5vEBSQZs/rMF50+sm4jofTgWLqgX1x3TkrDEVaRqfY/xZizFZ3Y8/DFEFD31VSfBQ5raEB6nHnZh6ddehtclQJ8fBrldyIh99LNnV32HzKEej04hk6SYjdauCa4aYW0ru/QxvQRGzLKOAQszf3ixJypTW3WWL6BLSF2EMCMIw7OUvWBC6A/gDc2D1jvBapMCc7ztx6jYczwTKsRLL6dMNXb83HS8kdD0pTMMj161zbVHkU0mhSHo9SlBDDXdN6hDvRGizmohtIyR3ot8tF5iUG4GLNcXeGvBudSFrHu+bVZb9jirNVG+rQPI51A7Hu8/b0UeaIaZ4UgDO68PkYx3PE2HWpKapJ764Kxt5TFYpywMy4DLQqVRy11I7SOLhxUFmqiEK52NaijWArIfCg6qG8q5eSiwRCJb1R7GDJG74TrYgx/lVq7w9++Kh929xSJEaoSse5fUOQg9nMAnIZv+7fwVRcNv3gOHI46Vb5jYUC66PYHO6lS+TOmvEQjuYmx4RkffYGxqZIp/DPWNHAixbRBc+XKE3JEOgs4jIwu/dSAwhydruOGF39co91aTs85JJ3Z/LpXoF43hUwJsb/M1Chzdn8HX8vLXnqWUKvRhNLpfAF4PTFqva1sBQG0J+59HyYfmQ3oa4/sxZdapVLlo/fooxSXi/dOEQWIWq8E0FkttEyTFXR2aNMPINMIzZwCNEheYTVltsdaLkMyKoEUluPNAYCM2IG3br0DLy0fVNWKHtbSKbBjfiw7Lu06gQFalC7RC9BwRMSpLYDUo9pDtDfzwUiPJKLJ2LGcSphWBadOI/iJjNqUHV7ucG8yC6+iNM9QYElqBR7ECFXrcTgWQ3eG/tCWacT9bxIkfmxPmi3vOd36KxihAJA73vWNJ+Y9oapXNscVSVqS5g15xOWND/WuUCcA9YAAg6WFbjHamrblZ5c0L6Zx1X58ZittGcfDKU697QRSqW/g+RofNRyvrWMrBn44cPvkRe2HdTu/Cq01C5/riWPHZyXPKHuSDDdW8c1XPgd6ogvLh20qEIu8c19sqr4ufyHrwh37ZN5MkvY1dsGmEz9pUBTxWrvvhNyODyX2Q1k/fbX/T/vbHNcBrmjgDtvBdtZrVtiIg5iXQuzO/DEMvRX8Mi1zymSlt92BGILeKItjoShJXE/H7xwnf0Iewb8BFieJ9MflEBCQYEDm8eZniiEPfGoaYiiEdhQxHQNr2AuRdmbL9mcl18Kumh+HEZLp6z+j35ML9zTbUwahUZCyQQOgQrGfdfQtaR/OYJ/9dYXb2TWZFMijfCA8Nov4sa5FFDUe1T68h4q08WDE7JbbDiej4utRMR9ontevxlXv6LuJTXt1YEv8bDzEt683PuSsIN0afvu0rcBu9AbXZbkOG3K3AhtqQ28N23lXm7S3Yn6KXmAhBhz+GeorJJ4XxO/b3vZk2LXp42+QvsVxGSNVpfSctIFMTR1bD9t70i6sfNF3WKz/uKDEDCpzzztwhL45lsw89H2IpWN10sXHRlhDse9KCdpP5qNNpU84cTY+aiqswqR8XZ9ea0KbVRwRuOGQU3csAtV2fSbnq47U6es6rKlWLWhg3s/B9C9g+oTyp6RtIldR51OOkP5/6nSy6itUVPcMNOp4M/hDdKOz3uK6srbdxOrc2cJgr1Sg02oBxxSky6V7JaG+ziNwlfqnjnvh2/uq1lKfbp+qpwq/D/5OI5gkFl5CejKGxfc2YVJfGqc4E0x5e9PHK2ukbHNI7/RZV6LNe65apbTGjoCaQls0txPPbmQbCQn+/upCoXRZy9yzorWJvZ0KWcbXlBxU/d5I4ERUTxMuVWhSMmF677LNN7NnLwsmKawXkCgbrpcluOl0WChR1qhtSrxGXHu251dEItYhYX3snvn1gS2uXuzdTxCJjZtjsip0iT2sDC0qMS7Bk9su2NyXjFK5/f5ZoWwofg3DtTyjaFqspnOOTSh8xK/CKUFS57guVEkw9xoQuRCwwEO9Lu9z2vYxSa9NFV8DvSxv2C4WYLYF8Nrc4DzWkzNsk81JJOlZ/LYJrGCoj4MmZpnf3AXmzxT4rtl9jsqljEyedz468SGKdBiQzyz/qWKEhFg45ZczlZZ3KGL3l6sn+3TTa3zMVMhPa1obGp/z+fvY0QXTrJTf1XAT3EtQdUfYYlmWZyvPZ/6rWwU7UOQei7pVE0osgN94Iy+T1+omE6z4Rh2O20FjgBeK2y1mcoFiMDOJvuZPn5Moy9fmFH3wyfKvn4+TwfLvt/lHTTVnvrtoUWRBiQXhiNM8nE6ZoWeux/Z0b2unRcdUzdDpmL7CAgd1ToRXwgmHTZOgiGtVT+xr1QH9ObebRTT4NzL+XSpLuuWp62GqQvJVTPoZOeJCb6gIwd9XHMftQ+Kc08IKKdKQANSJ1a2gve3JdRhO0+tNiYzWAZfd7isoeBu67W7xuK8WX7nhJURld98Inb0t/dWOSau/kDvV4DJo/cImw9AO2Gvq0F2n0M7yIZKL8amMbjYld+qFls7hq8Acvq97K2PrCaomuUiesu7qNanGupEl6J/iem8lyr/NMnsTr6o41PO0yhQh3hPFN0wJP7S830je9iTBLzUNgYH+gUZpROo3rN2qgCI+6GewpX8w8CH+ro6QrWiStqmcMzVa3vEel+3/dDxMp0rDv1Q6wTMS3K64zTT6RWzK1y643im25Ja7X2ePCV2mTswd/4jshZPo4bLnerqIosq/hy2bKUAmVn9n4oun1+a0DIZ56UhVwmZHdUNpLa8gmPvxS1eNvCF1T0wo1wKPdCJi0qOrWz7oYRTzgTtkzEzZn308XSLwUog4OWGKJzCn/3FfF9iA32dZHSv30pRCM3KBY9WZoRhtdK/ChHk6DEQBsfV6tN2o1Cn0mLtPBfnkS+qy1L2xfFe9TQPtDE1Be44RTl82E9hPT2rS2+93LFbzhQQO3C/hD2jRFH3BWWbasAfuMhRJFcTri73eE835y016s22DjoFJ862WvLj69fu2TgSF3RHia9D5DSitlQAXYCnbdqjPkR287Lh6dCHDapos+eFDvcZPP2edPmTFxznJE/EBLoQQ0Qmn9EkZOyJmHxMbvKYb8o21ZHmv5YLqgsEPk9gWZwYQY9wLqGXuax/8QlV5qDaPbq9pLPT1yp+zOWKmraEy1OUJI7zdEcEmvBpbdwLrDCgEb2xX8S/nxZgjK4bRi+pbOmbh8bEeoPvU/L9ndx9kntlDALbdAvp0O8ZC3zSUnFg4cePsw7jxewWvL7HRSBLUn6J7vTH9uld5N76JFPgBCdXGF221oEJk++XfRwXplLSyrVO7HFWBEs99nTazKveW3HpbD4dH/YmdAl+lwbSt8BQWyTG7jAsACI7bPPUU9hI9XUHWqQOuezHzUjnx5Qqs6T1qNHfTTHleDtmqK7flA9a0gz2nycIpz1FHBuWxKNtUeTdqP29Fb3tv+tl5JyBqXoR+vCsdzZwZUhf6Lu8bvkB9yQP4x7GGegB0ym0Lpl03Q7e+C0cDsm9GSDepCDji7nUslLyYyluPfvLyKaDSX4xpR+nVYQjQQn5F8KbY1gbIVLiK1J3mW90zTyR1bqApX2BlWh7KG8LAY9/S9nWC0XXh9pZZo6xuir12T43rkaGfQssbQyIslA7uJnSHOV22NhlNtUo0czxPAsXhh8tIQYaTM4l/yAlZlydTcXhlG22Gs/n3BxKBd/3ZjYwg3NaUurVXhNB+afVnFfNr9TbC9ksNdvwpNfeHanyJ8M6GrIVfLlYAPv0ILe4dn0Z+BJSbJkN7eZY/c6+6ttDYcIDeUKIDXqUSE42Xdh5nRbuaObozjht0HJ5H1e+em+NJi/+8kQlyjCbJpPckwThZeIF9/u7lrVIKNeJLCN/TpPAeXxvd31/CUDWHK9MuP1V1TJgngzi4V0qzS3SW3Qy5UiGHqg02wQa5tsEl9s/X9nNMosgLlUgZSfCBj1DiypLfhr9/r0nR0XY2tmhDOcUS4E7cqa4EJBhzqvpbZa35Q5Iz5EqmhYiOGDAYk606Tv74+KGfPjKVuP15rIzgW0I7/niOu9el/sn2bRye0gV+GrePDRDMHjwO1lEdeXH8N+UTO3IoN18kpI3tPxz+fY+n2MGMSGFHAx/83tKeJOl+2i+f1O9v6FfEDBbqrw+lpM8Anav7zHNr7hE78nXUtPNodMbCnITWA7Ma/IHlZ50F9hWge/wzOvSbtqFVFtkS8Of2nssjZwbSFdU+VO8z6tCEc9UA9ACxT5zIUeSrkBB/v1krOpm7bVMrGxEKfI6LcnpB4D8bvn2hDKGqKrJaVAJuDaBEY3F7eXyqnFWlOoFV/8ZLspZiZd7orXLhd4mhHQgbuKbHjJWUzrnm0Dxw/LJLzXCkh7slMxKo8uxZIWZfdKHlfI7uj3LP6ARAuWdF7ZmZ7daOKqKGbz5LxOggTgS39oEioYmrqkCeUDvbxkBYKeHhcLmMN8dMF01ZMb32IpL/cH8R7VHQSI5I0YfL14g9d7P/6cjB1JXXxbozEDbsrPdmL8ph7QW10jio+v7YsqHKQ6xrBbOVtxU0/nFfzUGZwIBLwyUvg49ii+54nv9FyECBpURnQK4Ox6N7lw5fsjdd5l/2SwBcAHMJoyjO1Pifye2dagaOwCVMqdJWAo77pvBe0zdJcTWu5fdzPNfV2p1pc7/JKQ8zhKkwsOELUDhXygPJ5oR8Vpk2lsCen3D3QOQp2zdrSZHjVBstDF/wWO98rrkQ6/7zt/Drip7OHIug1lomNdmRaHRrjmqeodn22sesQQPgzimPOMqC60a5+i/UYh51uZm+ijWkkaI2xjrBO2558DZNZMiuDQlaVAvBy2wLn/bR3FrNzfnO/9oDztYqxZrr7JMIhqmrochbqmQnKowxW29bpqTaJu7kW1VotC72QkYX8OoDDdMDwV1kJRk3mufgJBzf+iwFRJ7XWQwO5ujVglgFgHtycWiMLx5N+6XU+TulLabWjOzoao03fniUW0xvIJNPbk7CQlFZd/RCOPvgQbLjh5ITE8NVJeKt3HGr6JTnFdIzcVOlEtwqbIIX0IM7saC+4N5047MTJ9+Wn11EhyEPIlwsHE5utCeXRjQzlrR+R1Cf/qDzcNbqLXdk3J7gQ39VUrrEkS/VMWjjg+t2oYrqB0tUZClcUF6+LBC3EQ7KnGIwm/qjZX4GKPtjTX1zQKV6nPAb2t/Rza5IqKRf8i2DFEhV/YSifX0YwsiF6TQnp48Gr65TFq0zUe6LGjiY7fq0LSGKL1VnC6ESI2yxvt3XqBx53B3gSlGFeJcPbUbonW1E9E9m4NfuwPh+t5QjRxX34lvBPVxwQd7aeTd+r9dw5CiP1pt8wMZoMdni7GapYdo6KPgeQKcmlFfq4UYhvV0IBgeiR3RnTMBaqDqpZrTRyLdsp4l0IXZTdErfH0sN3dqBG5vRIx3VgCYcHmmkqJ8Hyu3s9K9uBD1d8cZUEx3qYcF5vsqeRpF1GOg8emeWM2OmBlWPdZ6qAXwm3nENFyh+kvXk132PfWAlN0kb7yh4fz2T7VWUY/hEXX5DvxGABC03XRpyOG8t/u3Gh5tZdpsSV9AWaxJN7zwhVglgII1gV28tUViyqn4UMdIh5t+Ea2zo7PO48oba0TwQbiSZOH4YhD578kPF3reuaP7LujPMsjHmaDuId9XEaZBCJhbXJbRg5VCk3KJpryH/+8S3wdhR47pdFcmpZG2p0Bpjp/VbvalgIZMllYX5L31aMPdt1J7r/7wbixt0Mnz2ZvNGTARHPVD+2O1D8SGpWXlVnP2ekgon55YiinADDynyaXtZDXueVqbuTi8z8cHHK325pgqM+mWZwzHeEreMvhZopAScXM14SJHpGwZyRljMlDvcMm9FZ/1e9+r/puOnpXOtc9Iu2fmgBfEP9cGW1Fzb1rGlfJ08pACtq1ZW18bf2cevebzVeHbaA50G9qoUp39JWdPHbYkPCRXjt4gzlq3Cxge28Mky8MoS/+On72kc+ZI2xBtgJytpAQHQ1zrEddMIVyR5urX6yBNu8v5lKC8eLdGKTJtbgIZ3ZyTzSfWmx9f+cvcJe8yM39K/djkp2aUTE/9m2Lj5jg7b8vdRAer7DO3SyLNHs1CAm5x5iAdh2yGJYivArZbCBNY88Tw+w+C1Tbt7wK3zl2rzTHo/D8/gb3c3mYrnEIEipYqPUcdWjnTsSw471O3EUN7Gtg4NOAs9PJrxm03VuZKa5xwXAYCjt7Gs01Km6T2DhOYUMoFcCSu7Hk1p3yP1eG+M3v3Q5luAze6WwBnZIYO0TCucPWK+UJ36KoJ8Y+vpavhLO8g5ed704IjlQdfemrMu//EvPYXTQSGIPPfiagJS9nMqP5IvkxN9pvuJz7h8carPXTKMq8jnTeL0STan6dnLTAqwIswcIwWDR2KwbGddAVN8SYWRB7kfBfBRkSXzvHlIF8D6jo64kUzYk5o/n8oLjKqat0rdXvQ86MkwQGMnnlcasqPPT2+mVtUGb32KuH6cyZQenrRG11TArcAl27+nvOMBDe++EKHf4YdyGf7mznzOz33cFFGEcv329p4qG2hoaQ8ULiMyVz6ENcxhoqGnFIdupcn7GICQWuw3yO3W8S33mzCcMYJ8ywc7U7rmaQf/W5K63Gr4bVTpXOyOp4tbaPyIaatBNpXqlmQUTSZXjxPr19+73PSaT+QnI35YsWn6WpfJjRtK8vlJZoTSgjaRU39AGCkWOZtifJrnefCrqwTKDFmuWUCukEsYcRrMzCoit28wYpP7kSVjMD8WJYQiNc2blMjuqYegmf6SsfC1jqz8XzghMlOX+gn/MKZmgljszrmehEa4V98VreJDxYvHr3j7IeJB9/sBZV41BWT/AZAjuC5XorlIPnZgBAniBEhanp0/0+qZmEWDpu8ige1hUPIyTo6T6gDEcFhWSoduNh8YSu65KgMOGBw7VlNYzNIgwHtq9KP2yyTVysqX5v12sf7D+vQUdR2dRDvCV40rIInXSLWT/yrC6ExOQxBJwIDbeZcl3z1yR5Rj3l8IGpxspapnvBL+fwupA3b6fkFceID9wgiM1ILB0cHVdvo/R4xg8yqKXT8efl0GnGX1/27FUYeUW2L/GNRGGWVGp3i91oaJkb4rybENHre9a2P5viz/yqk8ngWUUS+Kv+fu+9BLFnfLiLXOFcIeBJLhnayCiuDRSqcx0Qu68gVsGYc6EHD500Fkt+gpDj6gvr884n8wZ5o6q7xtL5wA0beXQnffWYkZrs2NGIRgQbsc5NB302SVx+R4ROvmgZaR8wBcji128BMfJ9kcvJ4DC+bQ57kRmv5yxgU4ngZfn0/JNZ8JBwxjTqS+s9kjJFG1unGUGLwMiIuXUD9EFhNIJuyCEAmVZSIGKH4G6v1gRR1LyzQKH2ZqiI1DnHMoDEZspbDjTeaFIAbSvjSq3A+n46y9hhVM8wIpnARSXyzmOD96d9UXvFroSPgGw1dq2vdEqDq9fJN1EbL2WulNmHkFDvxSO9ZT/RX/Bw2gA/BrF90XrJACereVfbV/YXaKfp77Nmx5NjEIUlxojsy7iN7nBHSZigfsbFyVOX1ZTeCCxvqnRSExP4lk5ZeYlRu9caaa743TWNdchRIhEWwadsBIe245C8clpaZ4zrPsk+OwXzxWCvRRumyNSLW5KWaSJyJU95cwheK76gr7228spZ3hmTtLyrfM2QRFqZFMR8/Q6yWfVgwTdfX2Ry4w3+eAO/5VT5nFb5NlzXPvBEAWrNZ6Q3jbH0RF4vcbp+fDngf/ywpoyNQtjrfvcq93AVb1RDWRghvyqgI2BkMr1rwYi8gizZ0G9GmPpMeqPerAQ0dJbzx+KAFM4IBq6iSLpZHUroeyfd9o5o+4fR2EtsZBoJORQEA4SW0CmeXSnblx2e9QkCHIodyqV6+g5ETEpZsLqnd/Na60EKPX/tQpPEcO+COIBPcQdszDzSiHGyQFPly/7KciUh1u+mFfxTCHGv9nn2WqndGgeGjQ/kr02qmTBX7Hc1qiEvgiSz1Tz/sy7Es29wvn6FrDGPP7asXlhOaiHxOctPvTptFA1kHFUk8bME7SsTSnGbFbUrssxrq70LhoSh5OwvQna+w84XdXhZb2sloJ4ZsCg3j+PrjJL08/JBi5zGd6ud/ZxhmcGKLOXPcNunQq5ESW92iJvfsuRrNYtawWwSmNhPYoFj2QqWNF0ffLpGt/ad24RJ8vkb5sXkpyKXmvFG5Vcdzf/44k3PBL/ojJ52+kWGzOArnyp5f969oV3J2c4Li27Nkova9VwRNVKqN0V+gV+mTHitgkXV30aWd3A1RSildEleiNPA+5cp+3+T7X+xfHiRZXQ1s4FA9TxIcnveQs9JSZ5r5qNmgqlW4zMtZ6rYNvgmyVcywKtu8ZxnSbS5vXlBV+NXdIfi3+xzrnJ0TkFL+Un8v1PWOC2PPFCjVPq7qTH7mOpzOYj/b4h0ceT+eHgr97Jqhb1ziVfeANzfN8bFUhPKBi7hJBCukQnB0aGjFTYLJPXL26lQ2b80xrOD5cFWgA8hz3St0e69kwNnD3+nX3gy12FjrjO+ddRvvvfyV3SWbXcxqNHfmsb9u1TV+wHTb9B07/L2sB8WUHJ9eeNomDyysEWZ0deqEhH/oWI2oiEh526gvAK1Nx2kIhNvkYR+tPYHEa9j+nd1VBpQP1uzSjIDO+fDDB7uy029rRjDC5Sk6aKczyz1D5uA9Lu+Rrrapl8JXNL3VRllNQH2K1ZFxOpX8LprttfqQ56MbPM0IttUheXWD/mROOeFqGUbL+kUOVlXLTFX/525g4faLEFO4qWWdmOXMNvVjpIVTWt650HfQjX9oT3Dg5Au6+v1/Ci78La6ZOngYCFPT1AUwxQuZ0yt5xKdNXLaDTISMTeCj16XTryhM36K2mfGRIgot71voWs8tTpL/f1rvcwv3LSDf+/G8THCT7NpfHWcW+lsF/ol8q9Bi6MezNTqp0rpp/kJRiVfNrX/w27cRRTu8RIIqtUblBMkxy4jwAVqCjUJkiPBj2cAoVloG8B2/N5deLdMhDb7xs5nhd3dubJhuj8WbaFRyu1L678DHhhA+rMimNo4C1kGpp0tD/qnCfCFHejpf0LJX43OTr578PY0tnIIrlWyNYyuR/ie6j2xNb1OV6u0dOX/1Dtcd7+ya9W+rY2LmnyQMtk8SMLTon8RAdwOaN2tNg5zVnDKlmVeOxPV2vhHIo9QEPV7jc3f+zVDquiNg1OaHX3cZXJDRY5MJpo+VanAcmqp4oasYLG+wrXUL5vJU0kqk2hGEskhP+Jjigrz1l6QnEwp6n8PMVeJp70Ii6ppeaK9GhF6fJE00ceLyxv08tKiPat4QdxZFgSbQknnEiCLD8Qc1rjazVKM3r3gXnnMeONgdz/yFV1q+haaN+wnF3Fn4uYCI9XsKOuVwDD0LsCO/f0gj5cmxCFcr7sclIcefWjvore+3aSU474cyqDVxH7w1RX3CHsaqsMRX17ZLgjsDXws3kLm2XJdM3Ku383UXqaHqsywzPhx7NFir0Fqjym/w6cxD2U9ypa3dx7Z12w/fi3Jps8sqJ8f8Ah8aZAvkHXvIRyrsxK7rrFaNNdNvjI8+3Emri195DCNa858anj2Qdny6Czshkn4N2+1m+k5S8sunX3Ja7I+JutRzg1mc2e9Yc0Zv9PZn1SwhxIdU9sXwZRTd/J5FoUm0e+PYREeHg3oc2YYzGf2xfJxXExt4pT3RfDRHvMXLUmoXOy63xv5pLuhOEax0dRgSywZ/GH+YBXFgCeTU0hZ8SPEFsn8punp1Kurd1KgXxUZ+la3R5+4ePGR4ZF5UQtOa83+Vj8zh80dfzbhxWCeoJnQ4dkZJM4drzknZOOKx2n3WrvJnzFIS8p0xeic+M3ZRVXIp10tV2DyYKwRxLzulPwzHcLlYTxl4PF7v8l106Azr+6wBFejbq/3P72C/0j78cepY9990/d4eAurn2lqdGKLU8FffnMw7cY7pVeXJRMU73Oxwi2g2vh/+4gX8dvbjfojn/eLVhhYl8GthwCQ50KcZq4z2JeW5eeOnJWFQEnVxDoG459TaC4zXybECEoJ0V5q1tXrQbDMtUxeTV6Pdt1/zJuc7TJoV/9YZFWxUtCf6Ou3Vd/vR/vG0138hJQrHkNeoep5dLe+6umcSquKvMaFpm3EZHDBOvCi0XYyIFHMgX7Cqp3JVXlxJFwQfHSaIUEbI2u1lBVUdlNw4Qa9UsLPEK94Qiln3pyKxQVCeNlx8yd7EegVNQBkFLabKvnietYVB4IPZ1fSor82arbgYec8aSdFMaIluYTYuNx32SxfrjKUdPGq+UNp5YpydoEG3xVLixtmHO9zXxKAnHnPuH2fPGrjx0GcuCDEU+yXUtXh6nfUL+cykws1gJ5vkfYFaFBr9PdCXvVf35OJQxzUMmWjv0W6uGJK11uAGDqSpOwCf6rouSIjPVgw57cJCOQ4b9tkI/Y5WNon9Swe72aZryKo8d+HyHBEdWJKrkary0LIGczA4Irq353Wc0Zga3om7UQiAGCvIl8GGyaqz5zH+1gMP5phWUCpKtttWIyicz09vXg76GxkmiGSMQ06Z9X8BUwqOtauDbPIf4rpK/yYoeAHxJ9soXS9VDe1Aw+awOOxaN8foLrif0TXBvQ55dtRtulRq9emFDBxlQcqKCaD8NeTSE7FOHvcjf/+oKbbtRqz9gbofoc2EzQ3pL6W5JdfJzAWmOk8oeoECe90lVMruwl/ltM015P/zIPazqvdvFmLNVHMIZrwiQ2tIKtGh6PDVH+85ew3caqVt2BsDv5rOcu3G9srQWd7NmgtzCRUXLYknYRSwtH9oUtkqyN3CfP20xQ1faXQl4MEmjQehWR6GmGnkdpYNQYeIG408yAX7uCZmYUic9juOfb+Re28+OVOB+scYK4DaPcBe+5wmji9gymtkMpKo4UKqCz7yxzuN8VIlx9yNozpRJpNaWHtaZVEqP45n2JemTlYBSmNIK1FuSYAUQ1yBLnKxevrjayd+h2i8PjdB3YY6b0nr3JuOXGpPMyh4V2dslpR3DFEvgpsBLqhqLDOWP4yEvIL6f21PpA7/8B"));
var $747425b437e121da$var$log2 = Math.log2 || ((n2) => Math.log(n2) / Math.LN2);
var $747425b437e121da$var$bits = (n2) => $747425b437e121da$var$log2(n2) + 1 | 0;
var $747425b437e121da$var$CATEGORY_BITS = $747425b437e121da$var$bits((0, /* @__PURE__ */ $parcel$interopDefault($f4087201da764553$exports)).categories.length - 1);
var $747425b437e121da$var$COMBINING_BITS = $747425b437e121da$var$bits((0, /* @__PURE__ */ $parcel$interopDefault($f4087201da764553$exports)).combiningClasses.length - 1);
var $747425b437e121da$var$SCRIPT_BITS = $747425b437e121da$var$bits((0, /* @__PURE__ */ $parcel$interopDefault($f4087201da764553$exports)).scripts.length - 1);
var $747425b437e121da$var$EAW_BITS = $747425b437e121da$var$bits((0, /* @__PURE__ */ $parcel$interopDefault($f4087201da764553$exports)).eaw.length - 1);
var $747425b437e121da$var$NUMBER_BITS = 10;
var $747425b437e121da$var$CATEGORY_SHIFT = $747425b437e121da$var$COMBINING_BITS + $747425b437e121da$var$SCRIPT_BITS + $747425b437e121da$var$EAW_BITS + $747425b437e121da$var$NUMBER_BITS;
var $747425b437e121da$var$COMBINING_SHIFT = $747425b437e121da$var$SCRIPT_BITS + $747425b437e121da$var$EAW_BITS + $747425b437e121da$var$NUMBER_BITS;
var $747425b437e121da$var$SCRIPT_SHIFT = $747425b437e121da$var$EAW_BITS + $747425b437e121da$var$NUMBER_BITS;
var $747425b437e121da$var$CATEGORY_MASK = (1 << $747425b437e121da$var$CATEGORY_BITS) - 1;
var $747425b437e121da$var$COMBINING_MASK = (1 << $747425b437e121da$var$COMBINING_BITS) - 1;
var $747425b437e121da$var$SCRIPT_MASK = (1 << $747425b437e121da$var$SCRIPT_BITS) - 1;
var $747425b437e121da$var$EAW_MASK = (1 << $747425b437e121da$var$EAW_BITS) - 1;
var $747425b437e121da$var$NUMBER_MASK = (1 << $747425b437e121da$var$NUMBER_BITS) - 1;
function $747425b437e121da$export$410364bbb673ddbc(codePoint) {
  const val = $747425b437e121da$var$trie.get(codePoint);
  return (0, /* @__PURE__ */ $parcel$interopDefault($f4087201da764553$exports)).categories[val >> $747425b437e121da$var$CATEGORY_SHIFT & $747425b437e121da$var$CATEGORY_MASK];
}
function $747425b437e121da$export$c03b919c6651ed55(codePoint) {
  const val = $747425b437e121da$var$trie.get(codePoint);
  return (0, /* @__PURE__ */ $parcel$interopDefault($f4087201da764553$exports)).combiningClasses[val >> $747425b437e121da$var$COMBINING_SHIFT & $747425b437e121da$var$COMBINING_MASK];
}
function $747425b437e121da$export$941569448d136665(codePoint) {
  const val = $747425b437e121da$var$trie.get(codePoint);
  return (0, /* @__PURE__ */ $parcel$interopDefault($f4087201da764553$exports)).scripts[val >> $747425b437e121da$var$SCRIPT_SHIFT & $747425b437e121da$var$SCRIPT_MASK];
}
function $747425b437e121da$export$727d9dbc4fbb948f(codePoint) {
  return $747425b437e121da$export$410364bbb673ddbc(codePoint) === "Nd";
}
function $747425b437e121da$export$e33ad6871e762338(codePoint) {
  const category = $747425b437e121da$export$410364bbb673ddbc(codePoint);
  return category === "Mn" || category === "Me" || category === "Mc";
}

// ../../node_modules/fontkit/dist/browser-module.mjs
var import_unicode_trie2 = __toESM(require_unicode_trie(), 1);
var import_dfa = __toESM(require_dfa(), 1);
var import_clone = __toESM(require_clone(), 1);
var import_tiny_inflate = __toESM(require_tiny_inflate(), 1);
var import_decompress = __toESM(require_decompress(), 1);
function $parcel$export(e3, n2, v, s) {
  Object.defineProperty(e3, n2, { get: v, set: s, enumerable: true, configurable: true });
}
function $parcel$interopDefault2(a) {
  return a && a.__esModule ? a.default : a;
}
var $d636bc798e7178db$exports = {};
$parcel$export($d636bc798e7178db$exports, "logErrors", () => $d636bc798e7178db$export$bd5c5d8b8dcafd78);
$parcel$export($d636bc798e7178db$exports, "registerFormat", () => $d636bc798e7178db$export$36b2f24e97d43be);
$parcel$export($d636bc798e7178db$exports, "create", () => $d636bc798e7178db$export$185802fd694ee1f5);
$parcel$export($d636bc798e7178db$exports, "defaultLanguage", () => $d636bc798e7178db$export$42940898df819940);
$parcel$export($d636bc798e7178db$exports, "setDefaultLanguage", () => $d636bc798e7178db$export$5157e7780d44cc36);
var $d636bc798e7178db$export$bd5c5d8b8dcafd78 = false;
var $d636bc798e7178db$var$formats = [];
function $d636bc798e7178db$export$36b2f24e97d43be(format3) {
  $d636bc798e7178db$var$formats.push(format3);
}
function $d636bc798e7178db$export$185802fd694ee1f5(buffer, postscriptName) {
  for (let i = 0; i < $d636bc798e7178db$var$formats.length; i++) {
    let format3 = $d636bc798e7178db$var$formats[i];
    if (format3.probe(buffer)) {
      let font = new format3(new (0, DecodeStream)(buffer));
      if (postscriptName) return font.getFont(postscriptName);
      return font;
    }
  }
  throw new Error("Unknown font format");
}
var $d636bc798e7178db$export$42940898df819940 = "en";
function $d636bc798e7178db$export$5157e7780d44cc36(lang = "en") {
  $d636bc798e7178db$export$42940898df819940 = lang;
}
function $e71565f2ce09cb6b$export$69a3209f1a06c04d(target, key2, descriptor) {
  if (descriptor.get) {
    let get3 = descriptor.get;
    descriptor.get = function() {
      let value = get3.call(this);
      Object.defineProperty(this, key2, {
        value
      });
      return value;
    };
  } else if (typeof descriptor.value === "function") {
    let fn = descriptor.value;
    return {
      get() {
        let cache = /* @__PURE__ */ new Map();
        function memoized(...args) {
          let key3 = args.length > 0 ? args[0] : "value";
          if (cache.has(key3)) return cache.get(key3);
          let result = fn.apply(this, args);
          cache.set(key3, result);
          return result;
        }
        Object.defineProperty(this, key2, {
          value: memoized
        });
        return memoized;
      }
    };
  }
}
var $26a62205ad06574e$var$SubHeader = new Struct({
  firstCode: uint16,
  entryCount: uint16,
  idDelta: int16,
  idRangeOffset: uint16
});
var $26a62205ad06574e$var$CmapGroup = new Struct({
  startCharCode: uint32,
  endCharCode: uint32,
  glyphID: uint32
});
var $26a62205ad06574e$var$UnicodeValueRange = new Struct({
  startUnicodeValue: uint24,
  additionalCount: uint8
});
var $26a62205ad06574e$var$UVSMapping = new Struct({
  unicodeValue: uint24,
  glyphID: uint16
});
var $26a62205ad06574e$var$DefaultUVS = new ArrayT($26a62205ad06574e$var$UnicodeValueRange, uint32);
var $26a62205ad06574e$var$NonDefaultUVS = new ArrayT($26a62205ad06574e$var$UVSMapping, uint32);
var $26a62205ad06574e$var$VarSelectorRecord = new Struct({
  varSelector: uint24,
  defaultUVS: new Pointer(uint32, $26a62205ad06574e$var$DefaultUVS, {
    type: "parent"
  }),
  nonDefaultUVS: new Pointer(uint32, $26a62205ad06574e$var$NonDefaultUVS, {
    type: "parent"
  })
});
var $26a62205ad06574e$var$CmapSubtable = new VersionedStruct(uint16, {
  0: {
    length: uint16,
    language: uint16,
    codeMap: new LazyArray(uint8, 256)
  },
  2: {
    length: uint16,
    language: uint16,
    subHeaderKeys: new ArrayT(uint16, 256),
    subHeaderCount: (t2) => Math.max.apply(Math, t2.subHeaderKeys),
    subHeaders: new LazyArray($26a62205ad06574e$var$SubHeader, "subHeaderCount"),
    glyphIndexArray: new LazyArray(uint16, "subHeaderCount")
  },
  4: {
    length: uint16,
    language: uint16,
    segCountX2: uint16,
    segCount: (t2) => t2.segCountX2 >> 1,
    searchRange: uint16,
    entrySelector: uint16,
    rangeShift: uint16,
    endCode: new LazyArray(uint16, "segCount"),
    reservedPad: new Reserved(uint16),
    startCode: new LazyArray(uint16, "segCount"),
    idDelta: new LazyArray(int16, "segCount"),
    idRangeOffset: new LazyArray(uint16, "segCount"),
    glyphIndexArray: new LazyArray(uint16, (t2) => (t2.length - t2._currentOffset) / 2)
  },
  6: {
    length: uint16,
    language: uint16,
    firstCode: uint16,
    entryCount: uint16,
    glyphIndices: new LazyArray(uint16, "entryCount")
  },
  8: {
    reserved: new Reserved(uint16),
    length: uint32,
    language: uint16,
    is32: new LazyArray(uint8, 8192),
    nGroups: uint32,
    groups: new LazyArray($26a62205ad06574e$var$CmapGroup, "nGroups")
  },
  10: {
    reserved: new Reserved(uint16),
    length: uint32,
    language: uint32,
    firstCode: uint32,
    entryCount: uint32,
    glyphIndices: new LazyArray(uint16, "numChars")
  },
  12: {
    reserved: new Reserved(uint16),
    length: uint32,
    language: uint32,
    nGroups: uint32,
    groups: new LazyArray($26a62205ad06574e$var$CmapGroup, "nGroups")
  },
  13: {
    reserved: new Reserved(uint16),
    length: uint32,
    language: uint32,
    nGroups: uint32,
    groups: new LazyArray($26a62205ad06574e$var$CmapGroup, "nGroups")
  },
  14: {
    length: uint32,
    numRecords: uint32,
    varSelectors: new LazyArray($26a62205ad06574e$var$VarSelectorRecord, "numRecords")
  }
});
var $26a62205ad06574e$var$CmapEntry = new Struct({
  platformID: uint16,
  encodingID: uint16,
  table: new Pointer(uint32, $26a62205ad06574e$var$CmapSubtable, {
    type: "parent",
    lazy: true
  })
});
var $26a62205ad06574e$export$2e2bcd8739ae039 = new Struct({
  version: uint16,
  numSubtables: uint16,
  tables: new ArrayT($26a62205ad06574e$var$CmapEntry, "numSubtables")
});
var $f2612a29f92ac062$export$2e2bcd8739ae039 = new Struct({
  version: int32,
  revision: int32,
  checkSumAdjustment: uint32,
  magicNumber: uint32,
  flags: uint16,
  unitsPerEm: uint16,
  created: new ArrayT(int32, 2),
  modified: new ArrayT(int32, 2),
  xMin: int16,
  yMin: int16,
  xMax: int16,
  yMax: int16,
  macStyle: new Bitfield(uint16, [
    "bold",
    "italic",
    "underline",
    "outline",
    "shadow",
    "condensed",
    "extended"
  ]),
  lowestRecPPEM: uint16,
  fontDirectionHint: int16,
  indexToLocFormat: int16,
  glyphDataFormat: int16
  // 0 for current format
});
var $2c179dd593583073$export$2e2bcd8739ae039 = new Struct({
  version: int32,
  ascent: int16,
  descent: int16,
  lineGap: int16,
  advanceWidthMax: uint16,
  minLeftSideBearing: int16,
  minRightSideBearing: int16,
  xMaxExtent: int16,
  caretSlopeRise: int16,
  caretSlopeRun: int16,
  caretOffset: int16,
  reserved: new Reserved(int16, 4),
  metricDataFormat: int16,
  numberOfMetrics: uint16
  // Number of advance widths in 'hmtx' table
});
var $bdc9060542264b85$var$HmtxEntry = new Struct({
  advance: uint16,
  bearing: int16
});
var $bdc9060542264b85$export$2e2bcd8739ae039 = new Struct({
  metrics: new LazyArray($bdc9060542264b85$var$HmtxEntry, (t2) => t2.parent.hhea.numberOfMetrics),
  bearings: new LazyArray(int16, (t2) => t2.parent.maxp.numGlyphs - t2.parent.hhea.numberOfMetrics)
});
var $dbf51cb3d3fe409d$export$2e2bcd8739ae039 = new Struct({
  version: int32,
  numGlyphs: uint16,
  maxPoints: uint16,
  maxContours: uint16,
  maxComponentPoints: uint16,
  maxComponentContours: uint16,
  maxZones: uint16,
  maxTwilightPoints: uint16,
  maxStorage: uint16,
  maxFunctionDefs: uint16,
  maxInstructionDefs: uint16,
  maxStackElements: uint16,
  maxSizeOfInstructions: uint16,
  maxComponentElements: uint16,
  maxComponentDepth: uint16
  // Maximum levels of recursion; 1 for simple components
});
function $e449ad78d50845fe$export$badc544e0651b6b1(platformID, encodingID, languageID = 0) {
  if (platformID === 1 && $e449ad78d50845fe$export$479e671907f486d1[languageID]) return $e449ad78d50845fe$export$479e671907f486d1[languageID];
  return $e449ad78d50845fe$export$6fef87b7618bdf0b[platformID][encodingID];
}
var $e449ad78d50845fe$var$SINGLE_BYTE_ENCODINGS = /* @__PURE__ */ new Set([
  "x-mac-roman",
  "x-mac-cyrillic",
  "iso-8859-6",
  "iso-8859-8"
]);
var $e449ad78d50845fe$var$MAC_ENCODINGS = {
  "x-mac-croatian": "\xC4\xC5\xC7\xC9\xD1\xD6\xDC\xE1\xE0\xE2\xE4\xE3\xE5\xE7\xE9\xE8\xEA\xEB\xED\xEC\xEE\xEF\xF1\xF3\xF2\xF4\xF6\xF5\xFA\xF9\xFB\xFC\u2020\xB0\xA2\xA3\xA7\u2022\xB6\xDF\xAE\u0160\u2122\xB4\xA8\u2260\u017D\xD8\u221E\xB1\u2264\u2265\u2206\xB5\u2202\u2211\u220F\u0161\u222B\xAA\xBA\u03A9\u017E\xF8\xBF\xA1\xAC\u221A\u0192\u2248\u0106\xAB\u010C\u2026 \xC0\xC3\xD5\u0152\u0153\u0110\u2014\u201C\u201D\u2018\u2019\xF7\u25CA\uF8FF\xA9\u2044\u20AC\u2039\u203A\xC6\xBB\u2013\xB7\u201A\u201E\u2030\xC2\u0107\xC1\u010D\xC8\xCD\xCE\xCF\xCC\xD3\xD4\u0111\xD2\xDA\xDB\xD9\u0131\u02C6\u02DC\xAF\u03C0\xCB\u02DA\xB8\xCA\xE6\u02C7",
  "x-mac-gaelic": "\xC4\xC5\xC7\xC9\xD1\xD6\xDC\xE1\xE0\xE2\xE4\xE3\xE5\xE7\xE9\xE8\xEA\xEB\xED\xEC\xEE\xEF\xF1\xF3\xF2\xF4\xF6\xF5\xFA\xF9\xFB\xFC\u2020\xB0\xA2\xA3\xA7\u2022\xB6\xDF\xAE\xA9\u2122\xB4\xA8\u2260\xC6\xD8\u1E02\xB1\u2264\u2265\u1E03\u010A\u010B\u1E0A\u1E0B\u1E1E\u1E1F\u0120\u0121\u1E40\xE6\xF8\u1E41\u1E56\u1E57\u027C\u0192\u017F\u1E60\xAB\xBB\u2026 \xC0\xC3\xD5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\u1E61\u1E9B\xFF\u0178\u1E6A\u20AC\u2039\u203A\u0176\u0177\u1E6B\xB7\u1EF2\u1EF3\u204A\xC2\xCA\xC1\xCB\xC8\xCD\xCE\xCF\xCC\xD3\xD4\u2663\xD2\xDA\xDB\xD9\u0131\xDD\xFD\u0174\u0175\u1E84\u1E85\u1E80\u1E81\u1E82\u1E83",
  "x-mac-greek": "\xC4\xB9\xB2\xC9\xB3\xD6\xDC\u0385\xE0\xE2\xE4\u0384\xA8\xE7\xE9\xE8\xEA\xEB\xA3\u2122\xEE\xEF\u2022\xBD\u2030\xF4\xF6\xA6\u20AC\xF9\xFB\xFC\u2020\u0393\u0394\u0398\u039B\u039E\u03A0\xDF\xAE\xA9\u03A3\u03AA\xA7\u2260\xB0\xB7\u0391\xB1\u2264\u2265\xA5\u0392\u0395\u0396\u0397\u0399\u039A\u039C\u03A6\u03AB\u03A8\u03A9\u03AC\u039D\xAC\u039F\u03A1\u2248\u03A4\xAB\xBB\u2026 \u03A5\u03A7\u0386\u0388\u0153\u2013\u2015\u201C\u201D\u2018\u2019\xF7\u0389\u038A\u038C\u038E\u03AD\u03AE\u03AF\u03CC\u038F\u03CD\u03B1\u03B2\u03C8\u03B4\u03B5\u03C6\u03B3\u03B7\u03B9\u03BE\u03BA\u03BB\u03BC\u03BD\u03BF\u03C0\u03CE\u03C1\u03C3\u03C4\u03B8\u03C9\u03C2\u03C7\u03C5\u03B6\u03CA\u03CB\u0390\u03B0\xAD",
  "x-mac-icelandic": "\xC4\xC5\xC7\xC9\xD1\xD6\xDC\xE1\xE0\xE2\xE4\xE3\xE5\xE7\xE9\xE8\xEA\xEB\xED\xEC\xEE\xEF\xF1\xF3\xF2\xF4\xF6\xF5\xFA\xF9\xFB\xFC\xDD\xB0\xA2\xA3\xA7\u2022\xB6\xDF\xAE\xA9\u2122\xB4\xA8\u2260\xC6\xD8\u221E\xB1\u2264\u2265\xA5\xB5\u2202\u2211\u220F\u03C0\u222B\xAA\xBA\u03A9\xE6\xF8\xBF\xA1\xAC\u221A\u0192\u2248\u2206\xAB\xBB\u2026 \xC0\xC3\xD5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\xF7\u25CA\xFF\u0178\u2044\u20AC\xD0\xF0\xDE\xFE\xFD\xB7\u201A\u201E\u2030\xC2\xCA\xC1\xCB\xC8\xCD\xCE\xCF\xCC\xD3\xD4\uF8FF\xD2\xDA\xDB\xD9\u0131\u02C6\u02DC\xAF\u02D8\u02D9\u02DA\xB8\u02DD\u02DB\u02C7",
  "x-mac-inuit": "\u1403\u1404\u1405\u1406\u140A\u140B\u1431\u1432\u1433\u1434\u1438\u1439\u1449\u144E\u144F\u1450\u1451\u1455\u1456\u1466\u146D\u146E\u146F\u1470\u1472\u1473\u1483\u148B\u148C\u148D\u148E\u1490\u1491\xB0\u14A1\u14A5\u14A6\u2022\xB6\u14A7\xAE\xA9\u2122\u14A8\u14AA\u14AB\u14BB\u14C2\u14C3\u14C4\u14C5\u14C7\u14C8\u14D0\u14EF\u14F0\u14F1\u14F2\u14F4\u14F5\u1505\u14D5\u14D6\u14D7\u14D8\u14DA\u14DB\u14EA\u1528\u1529\u152A\u152B\u152D\u2026 \u152E\u153E\u1555\u1556\u1557\u2013\u2014\u201C\u201D\u2018\u2019\u1558\u1559\u155A\u155D\u1546\u1547\u1548\u1549\u154B\u154C\u1550\u157F\u1580\u1581\u1582\u1583\u1584\u1585\u158F\u1590\u1591\u1592\u1593\u1594\u1595\u1671\u1672\u1673\u1674\u1675\u1676\u1596\u15A0\u15A1\u15A2\u15A3\u15A4\u15A5\u15A6\u157C\u0141\u0142",
  "x-mac-ce": "\xC4\u0100\u0101\xC9\u0104\xD6\xDC\xE1\u0105\u010C\xE4\u010D\u0106\u0107\xE9\u0179\u017A\u010E\xED\u010F\u0112\u0113\u0116\xF3\u0117\xF4\xF6\xF5\xFA\u011A\u011B\xFC\u2020\xB0\u0118\xA3\xA7\u2022\xB6\xDF\xAE\xA9\u2122\u0119\xA8\u2260\u0123\u012E\u012F\u012A\u2264\u2265\u012B\u0136\u2202\u2211\u0142\u013B\u013C\u013D\u013E\u0139\u013A\u0145\u0146\u0143\xAC\u221A\u0144\u0147\u2206\xAB\xBB\u2026 \u0148\u0150\xD5\u0151\u014C\u2013\u2014\u201C\u201D\u2018\u2019\xF7\u25CA\u014D\u0154\u0155\u0158\u2039\u203A\u0159\u0156\u0157\u0160\u201A\u201E\u0161\u015A\u015B\xC1\u0164\u0165\xCD\u017D\u017E\u016A\xD3\xD4\u016B\u016E\xDA\u016F\u0170\u0171\u0172\u0173\xDD\xFD\u0137\u017B\u0141\u017C\u0122\u02C7",
  "x-mac-romanian": "\xC4\xC5\xC7\xC9\xD1\xD6\xDC\xE1\xE0\xE2\xE4\xE3\xE5\xE7\xE9\xE8\xEA\xEB\xED\xEC\xEE\xEF\xF1\xF3\xF2\xF4\xF6\xF5\xFA\xF9\xFB\xFC\u2020\xB0\xA2\xA3\xA7\u2022\xB6\xDF\xAE\xA9\u2122\xB4\xA8\u2260\u0102\u0218\u221E\xB1\u2264\u2265\xA5\xB5\u2202\u2211\u220F\u03C0\u222B\xAA\xBA\u03A9\u0103\u0219\xBF\xA1\xAC\u221A\u0192\u2248\u2206\xAB\xBB\u2026 \xC0\xC3\xD5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\xF7\u25CA\xFF\u0178\u2044\u20AC\u2039\u203A\u021A\u021B\u2021\xB7\u201A\u201E\u2030\xC2\xCA\xC1\xCB\xC8\xCD\xCE\xCF\xCC\xD3\xD4\uF8FF\xD2\xDA\xDB\xD9\u0131\u02C6\u02DC\xAF\u02D8\u02D9\u02DA\xB8\u02DD\u02DB\u02C7",
  "x-mac-turkish": "\xC4\xC5\xC7\xC9\xD1\xD6\xDC\xE1\xE0\xE2\xE4\xE3\xE5\xE7\xE9\xE8\xEA\xEB\xED\xEC\xEE\xEF\xF1\xF3\xF2\xF4\xF6\xF5\xFA\xF9\xFB\xFC\u2020\xB0\xA2\xA3\xA7\u2022\xB6\xDF\xAE\xA9\u2122\xB4\xA8\u2260\xC6\xD8\u221E\xB1\u2264\u2265\xA5\xB5\u2202\u2211\u220F\u03C0\u222B\xAA\xBA\u03A9\xE6\xF8\xBF\xA1\xAC\u221A\u0192\u2248\u2206\xAB\xBB\u2026 \xC0\xC3\xD5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\xF7\u25CA\xFF\u0178\u011E\u011F\u0130\u0131\u015E\u015F\u2021\xB7\u201A\u201E\u2030\xC2\xCA\xC1\xCB\xC8\xCD\xCE\xCF\xCC\xD3\xD4\uF8FF\xD2\xDA\xDB\xD9\uF8A0\u02C6\u02DC\xAF\u02D8\u02D9\u02DA\xB8\u02DD\u02DB\u02C7"
};
var $e449ad78d50845fe$var$encodingCache = /* @__PURE__ */ new Map();
function $e449ad78d50845fe$export$1dceb3c14ed68bee(encoding) {
  let cached2 = $e449ad78d50845fe$var$encodingCache.get(encoding);
  if (cached2) return cached2;
  let mapping2 = $e449ad78d50845fe$var$MAC_ENCODINGS[encoding];
  if (mapping2) {
    let res = /* @__PURE__ */ new Map();
    for (let i = 0; i < mapping2.length; i++) res.set(mapping2.charCodeAt(i), 128 + i);
    $e449ad78d50845fe$var$encodingCache.set(encoding, res);
    return res;
  }
  if ($e449ad78d50845fe$var$SINGLE_BYTE_ENCODINGS.has(encoding)) {
    let decoder = new TextDecoder(encoding);
    let mapping3 = new Uint8Array(128);
    for (let i = 0; i < 128; i++) mapping3[i] = 128 + i;
    let res = /* @__PURE__ */ new Map();
    let s = decoder.decode(mapping3);
    for (let i = 0; i < 128; i++) res.set(s.charCodeAt(i), 128 + i);
    $e449ad78d50845fe$var$encodingCache.set(encoding, res);
    return res;
  }
}
var $e449ad78d50845fe$export$6fef87b7618bdf0b = [
  // unicode
  [
    "utf-16be",
    "utf-16be",
    "utf-16be",
    "utf-16be",
    "utf-16be",
    "utf-16be",
    "utf-16be"
  ],
  // macintosh
  // Mappings available at http://unicode.org/Public/MAPPINGS/VENDORS/APPLE/
  // 0	Roman                 17	Malayalam
  // 1	Japanese	            18	Sinhalese
  // 2	Traditional Chinese	  19	Burmese
  // 3	Korean	              20	Khmer
  // 4	Arabic	              21	Thai
  // 5	Hebrew	              22	Laotian
  // 6	Greek	                23	Georgian
  // 7	Russian	              24	Armenian
  // 8	RSymbol	              25	Simplified Chinese
  // 9	Devanagari	          26	Tibetan
  // 10	Gurmukhi	            27	Mongolian
  // 11	Gujarati	            28	Geez
  // 12	Oriya	                29	Slavic
  // 13	Bengali	              30	Vietnamese
  // 14	Tamil	                31	Sindhi
  // 15	Telugu	              32	(Uninterpreted)
  // 16	Kannada
  [
    "x-mac-roman",
    "shift-jis",
    "big5",
    "euc-kr",
    "iso-8859-6",
    "iso-8859-8",
    "x-mac-greek",
    "x-mac-cyrillic",
    "x-mac-symbol",
    "x-mac-devanagari",
    "x-mac-gurmukhi",
    "x-mac-gujarati",
    "Oriya",
    "Bengali",
    "Tamil",
    "Telugu",
    "Kannada",
    "Malayalam",
    "Sinhalese",
    "Burmese",
    "Khmer",
    "iso-8859-11",
    "Laotian",
    "Georgian",
    "Armenian",
    "gbk",
    "Tibetan",
    "Mongolian",
    "Geez",
    "x-mac-ce",
    "Vietnamese",
    "Sindhi"
  ],
  // ISO (deprecated)
  [
    "ascii",
    null,
    "iso-8859-1"
  ],
  // windows
  // Docs here: http://msdn.microsoft.com/en-us/library/system.text.encoding(v=vs.110).aspx
  [
    "symbol",
    "utf-16be",
    "shift-jis",
    "gb18030",
    "big5",
    "euc-kr",
    "johab",
    null,
    null,
    null,
    "utf-16be"
  ]
];
var $e449ad78d50845fe$export$479e671907f486d1 = {
  15: "x-mac-icelandic",
  17: "x-mac-turkish",
  18: "x-mac-croatian",
  24: "x-mac-ce",
  25: "x-mac-ce",
  26: "x-mac-ce",
  27: "x-mac-ce",
  28: "x-mac-ce",
  30: "x-mac-icelandic",
  37: "x-mac-romanian",
  38: "x-mac-ce",
  39: "x-mac-ce",
  40: "x-mac-ce",
  143: "x-mac-inuit",
  146: "x-mac-gaelic"
};
var $e449ad78d50845fe$export$2092376fd002e13 = [
  // unicode
  [],
  {
    0: "en",
    30: "fo",
    60: "ks",
    90: "rw",
    1: "fr",
    31: "fa",
    61: "ku",
    91: "rn",
    2: "de",
    32: "ru",
    62: "sd",
    92: "ny",
    3: "it",
    33: "zh",
    63: "bo",
    93: "mg",
    4: "nl",
    34: "nl-BE",
    64: "ne",
    94: "eo",
    5: "sv",
    35: "ga",
    65: "sa",
    128: "cy",
    6: "es",
    36: "sq",
    66: "mr",
    129: "eu",
    7: "da",
    37: "ro",
    67: "bn",
    130: "ca",
    8: "pt",
    38: "cz",
    68: "as",
    131: "la",
    9: "no",
    39: "sk",
    69: "gu",
    132: "qu",
    10: "he",
    40: "si",
    70: "pa",
    133: "gn",
    11: "ja",
    41: "yi",
    71: "or",
    134: "ay",
    12: "ar",
    42: "sr",
    72: "ml",
    135: "tt",
    13: "fi",
    43: "mk",
    73: "kn",
    136: "ug",
    14: "el",
    44: "bg",
    74: "ta",
    137: "dz",
    15: "is",
    45: "uk",
    75: "te",
    138: "jv",
    16: "mt",
    46: "be",
    76: "si",
    139: "su",
    17: "tr",
    47: "uz",
    77: "my",
    140: "gl",
    18: "hr",
    48: "kk",
    78: "km",
    141: "af",
    19: "zh-Hant",
    49: "az-Cyrl",
    79: "lo",
    142: "br",
    20: "ur",
    50: "az-Arab",
    80: "vi",
    143: "iu",
    21: "hi",
    51: "hy",
    81: "id",
    144: "gd",
    22: "th",
    52: "ka",
    82: "tl",
    145: "gv",
    23: "ko",
    53: "mo",
    83: "ms",
    146: "ga",
    24: "lt",
    54: "ky",
    84: "ms-Arab",
    147: "to",
    25: "pl",
    55: "tg",
    85: "am",
    148: "el-polyton",
    26: "hu",
    56: "tk",
    86: "ti",
    149: "kl",
    27: "es",
    57: "mn-CN",
    87: "om",
    150: "az",
    28: "lv",
    58: "mn",
    88: "so",
    151: "nn",
    29: "se",
    59: "ps",
    89: "sw"
  },
  // ISO (deprecated)
  [],
  {
    1078: "af",
    16393: "en-IN",
    1159: "rw",
    1074: "tn",
    1052: "sq",
    6153: "en-IE",
    1089: "sw",
    1115: "si",
    1156: "gsw",
    8201: "en-JM",
    1111: "kok",
    1051: "sk",
    1118: "am",
    17417: "en-MY",
    1042: "ko",
    1060: "sl",
    5121: "ar-DZ",
    5129: "en-NZ",
    1088: "ky",
    11274: "es-AR",
    15361: "ar-BH",
    13321: "en-PH",
    1108: "lo",
    16394: "es-BO",
    3073: "ar",
    18441: "en-SG",
    1062: "lv",
    13322: "es-CL",
    2049: "ar-IQ",
    7177: "en-ZA",
    1063: "lt",
    9226: "es-CO",
    11265: "ar-JO",
    11273: "en-TT",
    2094: "dsb",
    5130: "es-CR",
    13313: "ar-KW",
    2057: "en-GB",
    1134: "lb",
    7178: "es-DO",
    12289: "ar-LB",
    1033: "en",
    1071: "mk",
    12298: "es-EC",
    4097: "ar-LY",
    12297: "en-ZW",
    2110: "ms-BN",
    17418: "es-SV",
    6145: "ary",
    1061: "et",
    1086: "ms",
    4106: "es-GT",
    8193: "ar-OM",
    1080: "fo",
    1100: "ml",
    18442: "es-HN",
    16385: "ar-QA",
    1124: "fil",
    1082: "mt",
    2058: "es-MX",
    1025: "ar-SA",
    1035: "fi",
    1153: "mi",
    19466: "es-NI",
    10241: "ar-SY",
    2060: "fr-BE",
    1146: "arn",
    6154: "es-PA",
    7169: "aeb",
    3084: "fr-CA",
    1102: "mr",
    15370: "es-PY",
    14337: "ar-AE",
    1036: "fr",
    1148: "moh",
    10250: "es-PE",
    9217: "ar-YE",
    5132: "fr-LU",
    1104: "mn",
    20490: "es-PR",
    1067: "hy",
    6156: "fr-MC",
    2128: "mn-CN",
    3082: "es",
    1101: "as",
    4108: "fr-CH",
    1121: "ne",
    1034: "es",
    2092: "az-Cyrl",
    1122: "fy",
    1044: "nb",
    21514: "es-US",
    1068: "az",
    1110: "gl",
    2068: "nn",
    14346: "es-UY",
    1133: "ba",
    1079: "ka",
    1154: "oc",
    8202: "es-VE",
    1069: "eu",
    3079: "de-AT",
    1096: "or",
    2077: "sv-FI",
    1059: "be",
    1031: "de",
    1123: "ps",
    1053: "sv",
    2117: "bn",
    5127: "de-LI",
    1045: "pl",
    1114: "syr",
    1093: "bn-IN",
    4103: "de-LU",
    1046: "pt",
    1064: "tg",
    8218: "bs-Cyrl",
    2055: "de-CH",
    2070: "pt-PT",
    2143: "tzm",
    5146: "bs",
    1032: "el",
    1094: "pa",
    1097: "ta",
    1150: "br",
    1135: "kl",
    1131: "qu-BO",
    1092: "tt",
    1026: "bg",
    1095: "gu",
    2155: "qu-EC",
    1098: "te",
    1027: "ca",
    1128: "ha",
    3179: "qu",
    1054: "th",
    3076: "zh-HK",
    1037: "he",
    1048: "ro",
    1105: "bo",
    5124: "zh-MO",
    1081: "hi",
    1047: "rm",
    1055: "tr",
    2052: "zh",
    1038: "hu",
    1049: "ru",
    1090: "tk",
    4100: "zh-SG",
    1039: "is",
    9275: "smn",
    1152: "ug",
    1028: "zh-TW",
    1136: "ig",
    4155: "smj-NO",
    1058: "uk",
    1155: "co",
    1057: "id",
    5179: "smj",
    1070: "hsb",
    1050: "hr",
    1117: "iu",
    3131: "se-FI",
    1056: "ur",
    4122: "hr-BA",
    2141: "iu-Latn",
    1083: "se",
    2115: "uz-Cyrl",
    1029: "cs",
    2108: "ga",
    2107: "se-SE",
    1091: "uz",
    1030: "da",
    1076: "xh",
    8251: "sms",
    1066: "vi",
    1164: "prs",
    1077: "zu",
    6203: "sma-NO",
    1106: "cy",
    1125: "dv",
    1040: "it",
    7227: "sms",
    1160: "wo",
    2067: "nl-BE",
    2064: "it-CH",
    1103: "sa",
    1157: "sah",
    1043: "nl",
    1041: "ja",
    7194: "sr-Cyrl-BA",
    1144: "ii",
    3081: "en-AU",
    1099: "kn",
    3098: "sr",
    1130: "yo",
    10249: "en-BZ",
    1087: "kk",
    6170: "sr-Latn-BA",
    4105: "en-CA",
    1107: "km",
    2074: "sr-Latn",
    9225: "en-029",
    1158: "quc",
    1132: "nso"
  }
];
var $2bcf221753ec8e32$var$NameRecord = new Struct({
  platformID: uint16,
  encodingID: uint16,
  languageID: uint16,
  nameID: uint16,
  length: uint16,
  string: new Pointer(uint16, new StringT("length", (t2) => (0, $e449ad78d50845fe$export$badc544e0651b6b1)(t2.platformID, t2.encodingID, t2.languageID)), {
    type: "parent",
    relativeTo: (ctx) => ctx.parent.stringOffset,
    allowNull: false
  })
});
var $2bcf221753ec8e32$var$LangTagRecord = new Struct({
  length: uint16,
  tag: new Pointer(uint16, new StringT("length", "utf16be"), {
    type: "parent",
    relativeTo: (ctx) => ctx.stringOffset
  })
});
var $2bcf221753ec8e32$var$NameTable = new VersionedStruct(uint16, {
  0: {
    count: uint16,
    stringOffset: uint16,
    records: new ArrayT($2bcf221753ec8e32$var$NameRecord, "count")
  },
  1: {
    count: uint16,
    stringOffset: uint16,
    records: new ArrayT($2bcf221753ec8e32$var$NameRecord, "count"),
    langTagCount: uint16,
    langTags: new ArrayT($2bcf221753ec8e32$var$LangTagRecord, "langTagCount")
  }
});
var $2bcf221753ec8e32$export$2e2bcd8739ae039 = $2bcf221753ec8e32$var$NameTable;
var $2bcf221753ec8e32$var$NAMES = [
  "copyright",
  "fontFamily",
  "fontSubfamily",
  "uniqueSubfamily",
  "fullName",
  "version",
  "postscriptName",
  "trademark",
  "manufacturer",
  "designer",
  "description",
  "vendorURL",
  "designerURL",
  "license",
  "licenseURL",
  null,
  "preferredFamily",
  "preferredSubfamily",
  "compatibleFull",
  "sampleText",
  "postscriptCIDFontName",
  "wwsFamilyName",
  "wwsSubfamilyName"
];
$2bcf221753ec8e32$var$NameTable.process = function(stream) {
  var records = {};
  for (let record of this.records) {
    let language = (0, $e449ad78d50845fe$export$2092376fd002e13)[record.platformID][record.languageID];
    if (language == null && this.langTags != null && record.languageID >= 32768) language = this.langTags[record.languageID - 32768].tag;
    if (language == null) language = record.platformID + "-" + record.languageID;
    let key2 = record.nameID >= 256 ? "fontFeatures" : $2bcf221753ec8e32$var$NAMES[record.nameID] || record.nameID;
    if (records[key2] == null) records[key2] = {};
    let obj = records[key2];
    if (record.nameID >= 256) obj = obj[record.nameID] || (obj[record.nameID] = {});
    if (typeof record.string === "string" || typeof obj[language] !== "string") obj[language] = record.string;
  }
  this.records = records;
};
$2bcf221753ec8e32$var$NameTable.preEncode = function() {
  if (Array.isArray(this.records)) return;
  this.version = 0;
  let records = [];
  for (let key2 in this.records) {
    let val = this.records[key2];
    if (key2 === "fontFeatures") continue;
    records.push({
      platformID: 3,
      encodingID: 1,
      languageID: 1033,
      nameID: $2bcf221753ec8e32$var$NAMES.indexOf(key2),
      length: val.en.length * 2,
      string: val.en
    });
    if (key2 === "postscriptName") records.push({
      platformID: 1,
      encodingID: 0,
      languageID: 0,
      nameID: $2bcf221753ec8e32$var$NAMES.indexOf(key2),
      length: val.en.length,
      string: val.en
    });
  }
  this.records = records;
  this.count = records.length;
  this.stringOffset = $2bcf221753ec8e32$var$NameTable.size(this, null, false);
};
var $84b272aa31b70606$var$OS2 = new VersionedStruct(uint16, {
  header: {
    xAvgCharWidth: int16,
    usWeightClass: uint16,
    usWidthClass: uint16,
    fsType: new Bitfield(uint16, [
      null,
      "noEmbedding",
      "viewOnly",
      "editable",
      null,
      null,
      null,
      null,
      "noSubsetting",
      "bitmapOnly"
    ]),
    ySubscriptXSize: int16,
    ySubscriptYSize: int16,
    ySubscriptXOffset: int16,
    ySubscriptYOffset: int16,
    ySuperscriptXSize: int16,
    ySuperscriptYSize: int16,
    ySuperscriptXOffset: int16,
    ySuperscriptYOffset: int16,
    yStrikeoutSize: int16,
    yStrikeoutPosition: int16,
    sFamilyClass: int16,
    panose: new ArrayT(uint8, 10),
    ulCharRange: new ArrayT(uint32, 4),
    vendorID: new StringT(4),
    fsSelection: new Bitfield(uint16, [
      "italic",
      "underscore",
      "negative",
      "outlined",
      "strikeout",
      "bold",
      "regular",
      "useTypoMetrics",
      "wws",
      "oblique"
    ]),
    usFirstCharIndex: uint16,
    usLastCharIndex: uint16
    // The maximum Unicode index in this font
  },
  // The Apple version of this table ends here, but the Microsoft one continues on...
  0: {},
  1: {
    typoAscender: int16,
    typoDescender: int16,
    typoLineGap: int16,
    winAscent: uint16,
    winDescent: uint16,
    codePageRange: new ArrayT(uint32, 2)
  },
  2: {
    // these should be common with version 1 somehow
    typoAscender: int16,
    typoDescender: int16,
    typoLineGap: int16,
    winAscent: uint16,
    winDescent: uint16,
    codePageRange: new ArrayT(uint32, 2),
    xHeight: int16,
    capHeight: int16,
    defaultChar: uint16,
    breakChar: uint16,
    maxContent: uint16
  },
  5: {
    typoAscender: int16,
    typoDescender: int16,
    typoLineGap: int16,
    winAscent: uint16,
    winDescent: uint16,
    codePageRange: new ArrayT(uint32, 2),
    xHeight: int16,
    capHeight: int16,
    defaultChar: uint16,
    breakChar: uint16,
    maxContent: uint16,
    usLowerOpticalPointSize: uint16,
    usUpperOpticalPointSize: uint16
  }
});
var $84b272aa31b70606$var$versions = $84b272aa31b70606$var$OS2.versions;
$84b272aa31b70606$var$versions[3] = $84b272aa31b70606$var$versions[4] = $84b272aa31b70606$var$versions[2];
var $84b272aa31b70606$export$2e2bcd8739ae039 = $84b272aa31b70606$var$OS2;
var $32d9e2eb9565d93c$export$2e2bcd8739ae039 = new VersionedStruct(fixed32, {
  header: {
    italicAngle: fixed32,
    underlinePosition: int16,
    underlineThickness: int16,
    isFixedPitch: uint32,
    minMemType42: uint32,
    maxMemType42: uint32,
    minMemType1: uint32,
    maxMemType1: uint32
    // Maximum memory usage when a TrueType font is downloaded as a Type 1 font
  },
  1: {},
  2: {
    numberOfGlyphs: uint16,
    glyphNameIndex: new ArrayT(uint16, "numberOfGlyphs"),
    names: new ArrayT(new StringT(uint8))
  },
  2.5: {
    numberOfGlyphs: uint16,
    offsets: new ArrayT(uint8, "numberOfGlyphs")
  },
  3: {},
  4: {
    map: new ArrayT(uint32, (t2) => t2.parent.maxp.numGlyphs)
  }
});
var $5202bd9d9ad8eaac$export$2e2bcd8739ae039 = new Struct({
  controlValues: new ArrayT(int16)
});
var $5c0f37ca5ffb1850$export$2e2bcd8739ae039 = new Struct({
  instructions: new ArrayT(uint8)
});
var $2b2b260902b1c57e$var$loca = new VersionedStruct("head.indexToLocFormat", {
  0: {
    offsets: new ArrayT(uint16)
  },
  1: {
    offsets: new ArrayT(uint32)
  }
});
$2b2b260902b1c57e$var$loca.process = function() {
  if (this.version === 0 && !this._processed) {
    for (let i = 0; i < this.offsets.length; i++) this.offsets[i] <<= 1;
    this._processed = true;
  }
};
$2b2b260902b1c57e$var$loca.preEncode = function() {
  if (this.version === 0 && this._processed !== false) {
    for (let i = 0; i < this.offsets.length; i++) this.offsets[i] >>>= 1;
    this._processed = false;
  }
};
var $2b2b260902b1c57e$export$2e2bcd8739ae039 = $2b2b260902b1c57e$var$loca;
var $7afb878c7bea4f66$export$2e2bcd8739ae039 = new Struct({
  controlValueProgram: new ArrayT(uint8)
});
var $6c92b6371bce8bd9$export$2e2bcd8739ae039 = new ArrayT(new BufferT());
var $43e9821ef3717eec$export$2e2bcd8739ae039 = class {
  getCFFVersion(ctx) {
    while (ctx && !ctx.hdrSize) ctx = ctx.parent;
    return ctx ? ctx.version : -1;
  }
  decode(stream, parent2) {
    let version7 = this.getCFFVersion(parent2);
    let count = version7 >= 2 ? stream.readUInt32BE() : stream.readUInt16BE();
    if (count === 0) return [];
    let offSize = stream.readUInt8();
    let offsetType;
    if (offSize === 1) offsetType = uint8;
    else if (offSize === 2) offsetType = uint16;
    else if (offSize === 3) offsetType = uint24;
    else if (offSize === 4) offsetType = uint32;
    else throw new Error(`Bad offset size in CFFIndex: ${offSize} ${stream.pos}`);
    let ret = [];
    let startPos = stream.pos + (count + 1) * offSize - 1;
    let start = offsetType.decode(stream);
    for (let i = 0; i < count; i++) {
      let end = offsetType.decode(stream);
      if (this.type != null) {
        let pos = stream.pos;
        stream.pos = startPos + start;
        parent2.length = end - start;
        ret.push(this.type.decode(stream, parent2));
        stream.pos = pos;
      } else ret.push({
        offset: startPos + start,
        length: end - start
      });
      start = end;
    }
    stream.pos = startPos + start;
    return ret;
  }
  size(arr, parent2) {
    let size = 2;
    if (arr.length === 0) return size;
    let type5 = this.type || new BufferT();
    let offset4 = 1;
    for (let i = 0; i < arr.length; i++) {
      let item = arr[i];
      offset4 += type5.size(item, parent2);
    }
    let offsetType;
    if (offset4 <= 255) offsetType = uint8;
    else if (offset4 <= 65535) offsetType = uint16;
    else if (offset4 <= 16777215) offsetType = uint24;
    else if (offset4 <= 4294967295) offsetType = uint32;
    else throw new Error("Bad offset in CFFIndex");
    size += 1 + offsetType.size() * (arr.length + 1);
    size += offset4 - 1;
    return size;
  }
  encode(stream, arr, parent2) {
    stream.writeUInt16BE(arr.length);
    if (arr.length === 0) return;
    let type5 = this.type || new BufferT();
    let sizes2 = [];
    let offset4 = 1;
    for (let item of arr) {
      let s = type5.size(item, parent2);
      sizes2.push(s);
      offset4 += s;
    }
    let offsetType;
    if (offset4 <= 255) offsetType = uint8;
    else if (offset4 <= 65535) offsetType = uint16;
    else if (offset4 <= 16777215) offsetType = uint24;
    else if (offset4 <= 4294967295) offsetType = uint32;
    else throw new Error("Bad offset in CFFIndex");
    stream.writeUInt8(offsetType.size());
    offset4 = 1;
    offsetType.encode(stream, offset4);
    for (let size of sizes2) {
      offset4 += size;
      offsetType.encode(stream, offset4);
    }
    for (let item of arr) type5.encode(stream, item, parent2);
    return;
  }
  constructor(type5) {
    this.type = type5;
  }
};
var $c2d28e92708f99da$var$FLOAT_EOF = 15;
var $c2d28e92708f99da$var$FLOAT_LOOKUP = [
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  ".",
  "E",
  "E-",
  null,
  "-"
];
var $c2d28e92708f99da$var$FLOAT_ENCODE_LOOKUP = {
  ".": 10,
  "E": 11,
  "E-": 12,
  "-": 14
};
var $c2d28e92708f99da$export$2e2bcd8739ae039 = class {
  static decode(stream, value) {
    if (32 <= value && value <= 246) return value - 139;
    if (247 <= value && value <= 250) return (value - 247) * 256 + stream.readUInt8() + 108;
    if (251 <= value && value <= 254) return -(value - 251) * 256 - stream.readUInt8() - 108;
    if (value === 28) return stream.readInt16BE();
    if (value === 29) return stream.readInt32BE();
    if (value === 30) {
      let str = "";
      while (true) {
        let b = stream.readUInt8();
        let n1 = b >> 4;
        if (n1 === $c2d28e92708f99da$var$FLOAT_EOF) break;
        str += $c2d28e92708f99da$var$FLOAT_LOOKUP[n1];
        let n2 = b & 15;
        if (n2 === $c2d28e92708f99da$var$FLOAT_EOF) break;
        str += $c2d28e92708f99da$var$FLOAT_LOOKUP[n2];
      }
      return parseFloat(str);
    }
    return null;
  }
  static size(value) {
    if (value.forceLarge) value = 32768;
    if ((value | 0) !== value) {
      let str = "" + value;
      return 1 + Math.ceil((str.length + 1) / 2);
    } else if (-107 <= value && value <= 107) return 1;
    else if (108 <= value && value <= 1131 || -1131 <= value && value <= -108) return 2;
    else if (-32768 <= value && value <= 32767) return 3;
    else return 5;
  }
  static encode(stream, value) {
    let val = Number(value);
    if (value.forceLarge) {
      stream.writeUInt8(29);
      return stream.writeInt32BE(val);
    } else if ((val | 0) !== val) {
      stream.writeUInt8(30);
      let str = "" + val;
      for (let i = 0; i < str.length; i += 2) {
        let c1 = str[i];
        let n1 = $c2d28e92708f99da$var$FLOAT_ENCODE_LOOKUP[c1] || +c1;
        if (i === str.length - 1) var n2 = $c2d28e92708f99da$var$FLOAT_EOF;
        else {
          let c2 = str[i + 1];
          var n2 = $c2d28e92708f99da$var$FLOAT_ENCODE_LOOKUP[c2] || +c2;
        }
        stream.writeUInt8(n1 << 4 | n2 & 15);
      }
      if (n2 !== $c2d28e92708f99da$var$FLOAT_EOF) return stream.writeUInt8($c2d28e92708f99da$var$FLOAT_EOF << 4);
    } else if (-107 <= val && val <= 107) return stream.writeUInt8(val + 139);
    else if (108 <= val && val <= 1131) {
      val -= 108;
      stream.writeUInt8((val >> 8) + 247);
      return stream.writeUInt8(val & 255);
    } else if (-1131 <= val && val <= -108) {
      val = -val - 108;
      stream.writeUInt8((val >> 8) + 251);
      return stream.writeUInt8(val & 255);
    } else if (-32768 <= val && val <= 32767) {
      stream.writeUInt8(28);
      return stream.writeInt16BE(val);
    } else {
      stream.writeUInt8(29);
      return stream.writeInt32BE(val);
    }
  }
};
var $61aa549f16d58b9b$export$2e2bcd8739ae039 = class {
  decodeOperands(type5, stream, ret, operands) {
    if (Array.isArray(type5)) return operands.map((op, i) => this.decodeOperands(type5[i], stream, ret, [
      op
    ]));
    else if (type5.decode != null) return type5.decode(stream, ret, operands);
    else switch (type5) {
      case "number":
      case "offset":
      case "sid":
        return operands[0];
      case "boolean":
        return !!operands[0];
      default:
        return operands;
    }
  }
  encodeOperands(type5, stream, ctx, operands) {
    if (Array.isArray(type5)) return operands.map((op, i) => this.encodeOperands(type5[i], stream, ctx, op)[0]);
    else if (type5.encode != null) return type5.encode(stream, operands, ctx);
    else if (typeof operands === "number") return [
      operands
    ];
    else if (typeof operands === "boolean") return [
      +operands
    ];
    else if (Array.isArray(operands)) return operands;
    else return [
      operands
    ];
  }
  decode(stream, parent2) {
    let end = stream.pos + parent2.length;
    let ret = {};
    let operands = [];
    Object.defineProperties(ret, {
      parent: {
        value: parent2
      },
      _startOffset: {
        value: stream.pos
      }
    });
    for (let key2 in this.fields) {
      let field = this.fields[key2];
      ret[field[1]] = field[3];
    }
    while (stream.pos < end) {
      let b = stream.readUInt8();
      if (b < 28) {
        if (b === 12) b = b << 8 | stream.readUInt8();
        let field = this.fields[b];
        if (!field) throw new Error(`Unknown operator ${b}`);
        let val = this.decodeOperands(field[2], stream, ret, operands);
        if (val != null) {
          if (val instanceof (0, PropertyDescriptor)) Object.defineProperty(ret, field[1], val);
          else ret[field[1]] = val;
        }
        operands = [];
      } else operands.push((0, $c2d28e92708f99da$export$2e2bcd8739ae039).decode(stream, b));
    }
    return ret;
  }
  size(dict, parent2, includePointers = true) {
    let ctx = {
      parent: parent2,
      val: dict,
      pointerSize: 0,
      startOffset: parent2.startOffset || 0
    };
    let len = 0;
    for (let k in this.fields) {
      let field = this.fields[k];
      let val = dict[field[1]];
      if (val == null || (0, import_fast_deep_equal.default)(val, field[3])) continue;
      let operands = this.encodeOperands(field[2], null, ctx, val);
      for (let op of operands) len += (0, $c2d28e92708f99da$export$2e2bcd8739ae039).size(op);
      let key2 = Array.isArray(field[0]) ? field[0] : [
        field[0]
      ];
      len += key2.length;
    }
    if (includePointers) len += ctx.pointerSize;
    return len;
  }
  encode(stream, dict, parent2) {
    let ctx = {
      pointers: [],
      startOffset: stream.pos,
      parent: parent2,
      val: dict,
      pointerSize: 0
    };
    ctx.pointerOffset = stream.pos + this.size(dict, ctx, false);
    for (let field of this.ops) {
      let val = dict[field[1]];
      if (val == null || (0, import_fast_deep_equal.default)(val, field[3])) continue;
      let operands = this.encodeOperands(field[2], stream, ctx, val);
      for (let op of operands) (0, $c2d28e92708f99da$export$2e2bcd8739ae039).encode(stream, op);
      let key2 = Array.isArray(field[0]) ? field[0] : [
        field[0]
      ];
      for (let op of key2) stream.writeUInt8(op);
    }
    let i = 0;
    while (i < ctx.pointers.length) {
      let ptr = ctx.pointers[i++];
      ptr.type.encode(stream, ptr.val, ptr.parent);
    }
    return;
  }
  constructor(ops = []) {
    this.ops = ops;
    this.fields = {};
    for (let field of ops) {
      let key2 = Array.isArray(field[0]) ? field[0][0] << 8 | field[0][1] : field[0];
      this.fields[key2] = field;
    }
  }
};
var $0e34a43d05bde82c$export$2e2bcd8739ae039 = class extends Pointer {
  decode(stream, parent2, operands) {
    this.offsetType = {
      decode: () => operands[0]
    };
    return super.decode(stream, parent2, operands);
  }
  encode(stream, value, ctx) {
    if (!stream) {
      this.offsetType = {
        size: () => 0
      };
      this.size(value, ctx);
      return [
        new $0e34a43d05bde82c$var$Ptr(0)
      ];
    }
    let ptr = null;
    this.offsetType = {
      encode: (stream2, val) => ptr = val
    };
    super.encode(stream, value, ctx);
    return [
      new $0e34a43d05bde82c$var$Ptr(ptr)
    ];
  }
  constructor(type5, options = {}) {
    if (options.type == null) options.type = "global";
    super(null, type5, options);
  }
};
var $0e34a43d05bde82c$var$Ptr = class {
  valueOf() {
    return this.val;
  }
  constructor(val) {
    this.val = val;
    this.forceLarge = true;
  }
};
var $6d59db2e29cc77b3$var$CFFBlendOp = class {
  static decode(stream, parent2, operands) {
    let numBlends = operands.pop();
    while (operands.length > numBlends) operands.pop();
  }
};
var $6d59db2e29cc77b3$export$2e2bcd8739ae039 = new (0, $61aa549f16d58b9b$export$2e2bcd8739ae039)([
  // key       name                    type                                          default
  [
    6,
    "BlueValues",
    "delta",
    null
  ],
  [
    7,
    "OtherBlues",
    "delta",
    null
  ],
  [
    8,
    "FamilyBlues",
    "delta",
    null
  ],
  [
    9,
    "FamilyOtherBlues",
    "delta",
    null
  ],
  [
    [
      12,
      9
    ],
    "BlueScale",
    "number",
    0.039625
  ],
  [
    [
      12,
      10
    ],
    "BlueShift",
    "number",
    7
  ],
  [
    [
      12,
      11
    ],
    "BlueFuzz",
    "number",
    1
  ],
  [
    10,
    "StdHW",
    "number",
    null
  ],
  [
    11,
    "StdVW",
    "number",
    null
  ],
  [
    [
      12,
      12
    ],
    "StemSnapH",
    "delta",
    null
  ],
  [
    [
      12,
      13
    ],
    "StemSnapV",
    "delta",
    null
  ],
  [
    [
      12,
      14
    ],
    "ForceBold",
    "boolean",
    false
  ],
  [
    [
      12,
      17
    ],
    "LanguageGroup",
    "number",
    0
  ],
  [
    [
      12,
      18
    ],
    "ExpansionFactor",
    "number",
    0.06
  ],
  [
    [
      12,
      19
    ],
    "initialRandomSeed",
    "number",
    0
  ],
  [
    20,
    "defaultWidthX",
    "number",
    0
  ],
  [
    21,
    "nominalWidthX",
    "number",
    0
  ],
  [
    22,
    "vsindex",
    "number",
    0
  ],
  [
    23,
    "blend",
    $6d59db2e29cc77b3$var$CFFBlendOp,
    null
  ],
  [
    19,
    "Subrs",
    new (0, $0e34a43d05bde82c$export$2e2bcd8739ae039)(new (0, $43e9821ef3717eec$export$2e2bcd8739ae039)(), {
      type: "local"
    }),
    null
  ]
]);
var $229224aec43783c5$export$2e2bcd8739ae039 = [
  ".notdef",
  "space",
  "exclam",
  "quotedbl",
  "numbersign",
  "dollar",
  "percent",
  "ampersand",
  "quoteright",
  "parenleft",
  "parenright",
  "asterisk",
  "plus",
  "comma",
  "hyphen",
  "period",
  "slash",
  "zero",
  "one",
  "two",
  "three",
  "four",
  "five",
  "six",
  "seven",
  "eight",
  "nine",
  "colon",
  "semicolon",
  "less",
  "equal",
  "greater",
  "question",
  "at",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  "bracketleft",
  "backslash",
  "bracketright",
  "asciicircum",
  "underscore",
  "quoteleft",
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z",
  "braceleft",
  "bar",
  "braceright",
  "asciitilde",
  "exclamdown",
  "cent",
  "sterling",
  "fraction",
  "yen",
  "florin",
  "section",
  "currency",
  "quotesingle",
  "quotedblleft",
  "guillemotleft",
  "guilsinglleft",
  "guilsinglright",
  "fi",
  "fl",
  "endash",
  "dagger",
  "daggerdbl",
  "periodcentered",
  "paragraph",
  "bullet",
  "quotesinglbase",
  "quotedblbase",
  "quotedblright",
  "guillemotright",
  "ellipsis",
  "perthousand",
  "questiondown",
  "grave",
  "acute",
  "circumflex",
  "tilde",
  "macron",
  "breve",
  "dotaccent",
  "dieresis",
  "ring",
  "cedilla",
  "hungarumlaut",
  "ogonek",
  "caron",
  "emdash",
  "AE",
  "ordfeminine",
  "Lslash",
  "Oslash",
  "OE",
  "ordmasculine",
  "ae",
  "dotlessi",
  "lslash",
  "oslash",
  "oe",
  "germandbls",
  "onesuperior",
  "logicalnot",
  "mu",
  "trademark",
  "Eth",
  "onehalf",
  "plusminus",
  "Thorn",
  "onequarter",
  "divide",
  "brokenbar",
  "degree",
  "thorn",
  "threequarters",
  "twosuperior",
  "registered",
  "minus",
  "eth",
  "multiply",
  "threesuperior",
  "copyright",
  "Aacute",
  "Acircumflex",
  "Adieresis",
  "Agrave",
  "Aring",
  "Atilde",
  "Ccedilla",
  "Eacute",
  "Ecircumflex",
  "Edieresis",
  "Egrave",
  "Iacute",
  "Icircumflex",
  "Idieresis",
  "Igrave",
  "Ntilde",
  "Oacute",
  "Ocircumflex",
  "Odieresis",
  "Ograve",
  "Otilde",
  "Scaron",
  "Uacute",
  "Ucircumflex",
  "Udieresis",
  "Ugrave",
  "Yacute",
  "Ydieresis",
  "Zcaron",
  "aacute",
  "acircumflex",
  "adieresis",
  "agrave",
  "aring",
  "atilde",
  "ccedilla",
  "eacute",
  "ecircumflex",
  "edieresis",
  "egrave",
  "iacute",
  "icircumflex",
  "idieresis",
  "igrave",
  "ntilde",
  "oacute",
  "ocircumflex",
  "odieresis",
  "ograve",
  "otilde",
  "scaron",
  "uacute",
  "ucircumflex",
  "udieresis",
  "ugrave",
  "yacute",
  "ydieresis",
  "zcaron",
  "exclamsmall",
  "Hungarumlautsmall",
  "dollaroldstyle",
  "dollarsuperior",
  "ampersandsmall",
  "Acutesmall",
  "parenleftsuperior",
  "parenrightsuperior",
  "twodotenleader",
  "onedotenleader",
  "zerooldstyle",
  "oneoldstyle",
  "twooldstyle",
  "threeoldstyle",
  "fouroldstyle",
  "fiveoldstyle",
  "sixoldstyle",
  "sevenoldstyle",
  "eightoldstyle",
  "nineoldstyle",
  "commasuperior",
  "threequartersemdash",
  "periodsuperior",
  "questionsmall",
  "asuperior",
  "bsuperior",
  "centsuperior",
  "dsuperior",
  "esuperior",
  "isuperior",
  "lsuperior",
  "msuperior",
  "nsuperior",
  "osuperior",
  "rsuperior",
  "ssuperior",
  "tsuperior",
  "ff",
  "ffi",
  "ffl",
  "parenleftinferior",
  "parenrightinferior",
  "Circumflexsmall",
  "hyphensuperior",
  "Gravesmall",
  "Asmall",
  "Bsmall",
  "Csmall",
  "Dsmall",
  "Esmall",
  "Fsmall",
  "Gsmall",
  "Hsmall",
  "Ismall",
  "Jsmall",
  "Ksmall",
  "Lsmall",
  "Msmall",
  "Nsmall",
  "Osmall",
  "Psmall",
  "Qsmall",
  "Rsmall",
  "Ssmall",
  "Tsmall",
  "Usmall",
  "Vsmall",
  "Wsmall",
  "Xsmall",
  "Ysmall",
  "Zsmall",
  "colonmonetary",
  "onefitted",
  "rupiah",
  "Tildesmall",
  "exclamdownsmall",
  "centoldstyle",
  "Lslashsmall",
  "Scaronsmall",
  "Zcaronsmall",
  "Dieresissmall",
  "Brevesmall",
  "Caronsmall",
  "Dotaccentsmall",
  "Macronsmall",
  "figuredash",
  "hypheninferior",
  "Ogoneksmall",
  "Ringsmall",
  "Cedillasmall",
  "questiondownsmall",
  "oneeighth",
  "threeeighths",
  "fiveeighths",
  "seveneighths",
  "onethird",
  "twothirds",
  "zerosuperior",
  "foursuperior",
  "fivesuperior",
  "sixsuperior",
  "sevensuperior",
  "eightsuperior",
  "ninesuperior",
  "zeroinferior",
  "oneinferior",
  "twoinferior",
  "threeinferior",
  "fourinferior",
  "fiveinferior",
  "sixinferior",
  "seveninferior",
  "eightinferior",
  "nineinferior",
  "centinferior",
  "dollarinferior",
  "periodinferior",
  "commainferior",
  "Agravesmall",
  "Aacutesmall",
  "Acircumflexsmall",
  "Atildesmall",
  "Adieresissmall",
  "Aringsmall",
  "AEsmall",
  "Ccedillasmall",
  "Egravesmall",
  "Eacutesmall",
  "Ecircumflexsmall",
  "Edieresissmall",
  "Igravesmall",
  "Iacutesmall",
  "Icircumflexsmall",
  "Idieresissmall",
  "Ethsmall",
  "Ntildesmall",
  "Ogravesmall",
  "Oacutesmall",
  "Ocircumflexsmall",
  "Otildesmall",
  "Odieresissmall",
  "OEsmall",
  "Oslashsmall",
  "Ugravesmall",
  "Uacutesmall",
  "Ucircumflexsmall",
  "Udieresissmall",
  "Yacutesmall",
  "Thornsmall",
  "Ydieresissmall",
  "001.000",
  "001.001",
  "001.002",
  "001.003",
  "Black",
  "Bold",
  "Book",
  "Light",
  "Medium",
  "Regular",
  "Roman",
  "Semibold"
];
var $bc0433d9b7e41f5f$export$dee0027060fa13bd = [
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "space",
  "exclam",
  "quotedbl",
  "numbersign",
  "dollar",
  "percent",
  "ampersand",
  "quoteright",
  "parenleft",
  "parenright",
  "asterisk",
  "plus",
  "comma",
  "hyphen",
  "period",
  "slash",
  "zero",
  "one",
  "two",
  "three",
  "four",
  "five",
  "six",
  "seven",
  "eight",
  "nine",
  "colon",
  "semicolon",
  "less",
  "equal",
  "greater",
  "question",
  "at",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  "bracketleft",
  "backslash",
  "bracketright",
  "asciicircum",
  "underscore",
  "quoteleft",
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z",
  "braceleft",
  "bar",
  "braceright",
  "asciitilde",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "exclamdown",
  "cent",
  "sterling",
  "fraction",
  "yen",
  "florin",
  "section",
  "currency",
  "quotesingle",
  "quotedblleft",
  "guillemotleft",
  "guilsinglleft",
  "guilsinglright",
  "fi",
  "fl",
  "",
  "endash",
  "dagger",
  "daggerdbl",
  "periodcentered",
  "",
  "paragraph",
  "bullet",
  "quotesinglbase",
  "quotedblbase",
  "quotedblright",
  "guillemotright",
  "ellipsis",
  "perthousand",
  "",
  "questiondown",
  "",
  "grave",
  "acute",
  "circumflex",
  "tilde",
  "macron",
  "breve",
  "dotaccent",
  "dieresis",
  "",
  "ring",
  "cedilla",
  "",
  "hungarumlaut",
  "ogonek",
  "caron",
  "emdash",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "AE",
  "",
  "ordfeminine",
  "",
  "",
  "",
  "",
  "Lslash",
  "Oslash",
  "OE",
  "ordmasculine",
  "",
  "",
  "",
  "",
  "",
  "ae",
  "",
  "",
  "",
  "dotlessi",
  "",
  "",
  "lslash",
  "oslash",
  "oe",
  "germandbls"
];
var $bc0433d9b7e41f5f$export$4f58f497e14a53c3 = [
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "space",
  "exclamsmall",
  "Hungarumlautsmall",
  "",
  "dollaroldstyle",
  "dollarsuperior",
  "ampersandsmall",
  "Acutesmall",
  "parenleftsuperior",
  "parenrightsuperior",
  "twodotenleader",
  "onedotenleader",
  "comma",
  "hyphen",
  "period",
  "fraction",
  "zerooldstyle",
  "oneoldstyle",
  "twooldstyle",
  "threeoldstyle",
  "fouroldstyle",
  "fiveoldstyle",
  "sixoldstyle",
  "sevenoldstyle",
  "eightoldstyle",
  "nineoldstyle",
  "colon",
  "semicolon",
  "commasuperior",
  "threequartersemdash",
  "periodsuperior",
  "questionsmall",
  "",
  "asuperior",
  "bsuperior",
  "centsuperior",
  "dsuperior",
  "esuperior",
  "",
  "",
  "isuperior",
  "",
  "",
  "lsuperior",
  "msuperior",
  "nsuperior",
  "osuperior",
  "",
  "",
  "rsuperior",
  "ssuperior",
  "tsuperior",
  "",
  "ff",
  "fi",
  "fl",
  "ffi",
  "ffl",
  "parenleftinferior",
  "",
  "parenrightinferior",
  "Circumflexsmall",
  "hyphensuperior",
  "Gravesmall",
  "Asmall",
  "Bsmall",
  "Csmall",
  "Dsmall",
  "Esmall",
  "Fsmall",
  "Gsmall",
  "Hsmall",
  "Ismall",
  "Jsmall",
  "Ksmall",
  "Lsmall",
  "Msmall",
  "Nsmall",
  "Osmall",
  "Psmall",
  "Qsmall",
  "Rsmall",
  "Ssmall",
  "Tsmall",
  "Usmall",
  "Vsmall",
  "Wsmall",
  "Xsmall",
  "Ysmall",
  "Zsmall",
  "colonmonetary",
  "onefitted",
  "rupiah",
  "Tildesmall",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "exclamdownsmall",
  "centoldstyle",
  "Lslashsmall",
  "",
  "",
  "Scaronsmall",
  "Zcaronsmall",
  "Dieresissmall",
  "Brevesmall",
  "Caronsmall",
  "",
  "Dotaccentsmall",
  "",
  "",
  "Macronsmall",
  "",
  "",
  "figuredash",
  "hypheninferior",
  "",
  "",
  "Ogoneksmall",
  "Ringsmall",
  "Cedillasmall",
  "",
  "",
  "",
  "onequarter",
  "onehalf",
  "threequarters",
  "questiondownsmall",
  "oneeighth",
  "threeeighths",
  "fiveeighths",
  "seveneighths",
  "onethird",
  "twothirds",
  "",
  "",
  "zerosuperior",
  "onesuperior",
  "twosuperior",
  "threesuperior",
  "foursuperior",
  "fivesuperior",
  "sixsuperior",
  "sevensuperior",
  "eightsuperior",
  "ninesuperior",
  "zeroinferior",
  "oneinferior",
  "twoinferior",
  "threeinferior",
  "fourinferior",
  "fiveinferior",
  "sixinferior",
  "seveninferior",
  "eightinferior",
  "nineinferior",
  "centinferior",
  "dollarinferior",
  "periodinferior",
  "commainferior",
  "Agravesmall",
  "Aacutesmall",
  "Acircumflexsmall",
  "Atildesmall",
  "Adieresissmall",
  "Aringsmall",
  "AEsmall",
  "Ccedillasmall",
  "Egravesmall",
  "Eacutesmall",
  "Ecircumflexsmall",
  "Edieresissmall",
  "Igravesmall",
  "Iacutesmall",
  "Icircumflexsmall",
  "Idieresissmall",
  "Ethsmall",
  "Ntildesmall",
  "Ogravesmall",
  "Oacutesmall",
  "Ocircumflexsmall",
  "Otildesmall",
  "Odieresissmall",
  "OEsmall",
  "Oslashsmall",
  "Ugravesmall",
  "Uacutesmall",
  "Ucircumflexsmall",
  "Udieresissmall",
  "Yacutesmall",
  "Thornsmall",
  "Ydieresissmall"
];
var $ef658f5c9a1488b2$export$c33b50336c234f16 = [
  ".notdef",
  "space",
  "exclam",
  "quotedbl",
  "numbersign",
  "dollar",
  "percent",
  "ampersand",
  "quoteright",
  "parenleft",
  "parenright",
  "asterisk",
  "plus",
  "comma",
  "hyphen",
  "period",
  "slash",
  "zero",
  "one",
  "two",
  "three",
  "four",
  "five",
  "six",
  "seven",
  "eight",
  "nine",
  "colon",
  "semicolon",
  "less",
  "equal",
  "greater",
  "question",
  "at",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  "bracketleft",
  "backslash",
  "bracketright",
  "asciicircum",
  "underscore",
  "quoteleft",
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z",
  "braceleft",
  "bar",
  "braceright",
  "asciitilde",
  "exclamdown",
  "cent",
  "sterling",
  "fraction",
  "yen",
  "florin",
  "section",
  "currency",
  "quotesingle",
  "quotedblleft",
  "guillemotleft",
  "guilsinglleft",
  "guilsinglright",
  "fi",
  "fl",
  "endash",
  "dagger",
  "daggerdbl",
  "periodcentered",
  "paragraph",
  "bullet",
  "quotesinglbase",
  "quotedblbase",
  "quotedblright",
  "guillemotright",
  "ellipsis",
  "perthousand",
  "questiondown",
  "grave",
  "acute",
  "circumflex",
  "tilde",
  "macron",
  "breve",
  "dotaccent",
  "dieresis",
  "ring",
  "cedilla",
  "hungarumlaut",
  "ogonek",
  "caron",
  "emdash",
  "AE",
  "ordfeminine",
  "Lslash",
  "Oslash",
  "OE",
  "ordmasculine",
  "ae",
  "dotlessi",
  "lslash",
  "oslash",
  "oe",
  "germandbls",
  "onesuperior",
  "logicalnot",
  "mu",
  "trademark",
  "Eth",
  "onehalf",
  "plusminus",
  "Thorn",
  "onequarter",
  "divide",
  "brokenbar",
  "degree",
  "thorn",
  "threequarters",
  "twosuperior",
  "registered",
  "minus",
  "eth",
  "multiply",
  "threesuperior",
  "copyright",
  "Aacute",
  "Acircumflex",
  "Adieresis",
  "Agrave",
  "Aring",
  "Atilde",
  "Ccedilla",
  "Eacute",
  "Ecircumflex",
  "Edieresis",
  "Egrave",
  "Iacute",
  "Icircumflex",
  "Idieresis",
  "Igrave",
  "Ntilde",
  "Oacute",
  "Ocircumflex",
  "Odieresis",
  "Ograve",
  "Otilde",
  "Scaron",
  "Uacute",
  "Ucircumflex",
  "Udieresis",
  "Ugrave",
  "Yacute",
  "Ydieresis",
  "Zcaron",
  "aacute",
  "acircumflex",
  "adieresis",
  "agrave",
  "aring",
  "atilde",
  "ccedilla",
  "eacute",
  "ecircumflex",
  "edieresis",
  "egrave",
  "iacute",
  "icircumflex",
  "idieresis",
  "igrave",
  "ntilde",
  "oacute",
  "ocircumflex",
  "odieresis",
  "ograve",
  "otilde",
  "scaron",
  "uacute",
  "ucircumflex",
  "udieresis",
  "ugrave",
  "yacute",
  "ydieresis",
  "zcaron"
];
var $ef658f5c9a1488b2$export$3ed0f9e1fee8d489 = [
  ".notdef",
  "space",
  "exclamsmall",
  "Hungarumlautsmall",
  "dollaroldstyle",
  "dollarsuperior",
  "ampersandsmall",
  "Acutesmall",
  "parenleftsuperior",
  "parenrightsuperior",
  "twodotenleader",
  "onedotenleader",
  "comma",
  "hyphen",
  "period",
  "fraction",
  "zerooldstyle",
  "oneoldstyle",
  "twooldstyle",
  "threeoldstyle",
  "fouroldstyle",
  "fiveoldstyle",
  "sixoldstyle",
  "sevenoldstyle",
  "eightoldstyle",
  "nineoldstyle",
  "colon",
  "semicolon",
  "commasuperior",
  "threequartersemdash",
  "periodsuperior",
  "questionsmall",
  "asuperior",
  "bsuperior",
  "centsuperior",
  "dsuperior",
  "esuperior",
  "isuperior",
  "lsuperior",
  "msuperior",
  "nsuperior",
  "osuperior",
  "rsuperior",
  "ssuperior",
  "tsuperior",
  "ff",
  "fi",
  "fl",
  "ffi",
  "ffl",
  "parenleftinferior",
  "parenrightinferior",
  "Circumflexsmall",
  "hyphensuperior",
  "Gravesmall",
  "Asmall",
  "Bsmall",
  "Csmall",
  "Dsmall",
  "Esmall",
  "Fsmall",
  "Gsmall",
  "Hsmall",
  "Ismall",
  "Jsmall",
  "Ksmall",
  "Lsmall",
  "Msmall",
  "Nsmall",
  "Osmall",
  "Psmall",
  "Qsmall",
  "Rsmall",
  "Ssmall",
  "Tsmall",
  "Usmall",
  "Vsmall",
  "Wsmall",
  "Xsmall",
  "Ysmall",
  "Zsmall",
  "colonmonetary",
  "onefitted",
  "rupiah",
  "Tildesmall",
  "exclamdownsmall",
  "centoldstyle",
  "Lslashsmall",
  "Scaronsmall",
  "Zcaronsmall",
  "Dieresissmall",
  "Brevesmall",
  "Caronsmall",
  "Dotaccentsmall",
  "Macronsmall",
  "figuredash",
  "hypheninferior",
  "Ogoneksmall",
  "Ringsmall",
  "Cedillasmall",
  "onequarter",
  "onehalf",
  "threequarters",
  "questiondownsmall",
  "oneeighth",
  "threeeighths",
  "fiveeighths",
  "seveneighths",
  "onethird",
  "twothirds",
  "zerosuperior",
  "onesuperior",
  "twosuperior",
  "threesuperior",
  "foursuperior",
  "fivesuperior",
  "sixsuperior",
  "sevensuperior",
  "eightsuperior",
  "ninesuperior",
  "zeroinferior",
  "oneinferior",
  "twoinferior",
  "threeinferior",
  "fourinferior",
  "fiveinferior",
  "sixinferior",
  "seveninferior",
  "eightinferior",
  "nineinferior",
  "centinferior",
  "dollarinferior",
  "periodinferior",
  "commainferior",
  "Agravesmall",
  "Aacutesmall",
  "Acircumflexsmall",
  "Atildesmall",
  "Adieresissmall",
  "Aringsmall",
  "AEsmall",
  "Ccedillasmall",
  "Egravesmall",
  "Eacutesmall",
  "Ecircumflexsmall",
  "Edieresissmall",
  "Igravesmall",
  "Iacutesmall",
  "Icircumflexsmall",
  "Idieresissmall",
  "Ethsmall",
  "Ntildesmall",
  "Ogravesmall",
  "Oacutesmall",
  "Ocircumflexsmall",
  "Otildesmall",
  "Odieresissmall",
  "OEsmall",
  "Oslashsmall",
  "Ugravesmall",
  "Uacutesmall",
  "Ucircumflexsmall",
  "Udieresissmall",
  "Yacutesmall",
  "Thornsmall",
  "Ydieresissmall"
];
var $ef658f5c9a1488b2$export$dc28be11139d4120 = [
  ".notdef",
  "space",
  "dollaroldstyle",
  "dollarsuperior",
  "parenleftsuperior",
  "parenrightsuperior",
  "twodotenleader",
  "onedotenleader",
  "comma",
  "hyphen",
  "period",
  "fraction",
  "zerooldstyle",
  "oneoldstyle",
  "twooldstyle",
  "threeoldstyle",
  "fouroldstyle",
  "fiveoldstyle",
  "sixoldstyle",
  "sevenoldstyle",
  "eightoldstyle",
  "nineoldstyle",
  "colon",
  "semicolon",
  "commasuperior",
  "threequartersemdash",
  "periodsuperior",
  "asuperior",
  "bsuperior",
  "centsuperior",
  "dsuperior",
  "esuperior",
  "isuperior",
  "lsuperior",
  "msuperior",
  "nsuperior",
  "osuperior",
  "rsuperior",
  "ssuperior",
  "tsuperior",
  "ff",
  "fi",
  "fl",
  "ffi",
  "ffl",
  "parenleftinferior",
  "parenrightinferior",
  "hyphensuperior",
  "colonmonetary",
  "onefitted",
  "rupiah",
  "centoldstyle",
  "figuredash",
  "hypheninferior",
  "onequarter",
  "onehalf",
  "threequarters",
  "oneeighth",
  "threeeighths",
  "fiveeighths",
  "seveneighths",
  "onethird",
  "twothirds",
  "zerosuperior",
  "onesuperior",
  "twosuperior",
  "threesuperior",
  "foursuperior",
  "fivesuperior",
  "sixsuperior",
  "sevensuperior",
  "eightsuperior",
  "ninesuperior",
  "zeroinferior",
  "oneinferior",
  "twoinferior",
  "threeinferior",
  "fourinferior",
  "fiveinferior",
  "sixinferior",
  "seveninferior",
  "eightinferior",
  "nineinferior",
  "centinferior",
  "dollarinferior",
  "periodinferior",
  "commainferior"
];
var $7cbbe4e24ef3cb75$var$LangSysTable = new Struct({
  reserved: new Reserved(uint16),
  reqFeatureIndex: uint16,
  featureCount: uint16,
  featureIndexes: new ArrayT(uint16, "featureCount")
});
var $7cbbe4e24ef3cb75$var$LangSysRecord = new Struct({
  tag: new StringT(4),
  langSys: new Pointer(uint16, $7cbbe4e24ef3cb75$var$LangSysTable, {
    type: "parent"
  })
});
var $7cbbe4e24ef3cb75$var$Script = new Struct({
  defaultLangSys: new Pointer(uint16, $7cbbe4e24ef3cb75$var$LangSysTable),
  count: uint16,
  langSysRecords: new ArrayT($7cbbe4e24ef3cb75$var$LangSysRecord, "count")
});
var $7cbbe4e24ef3cb75$var$ScriptRecord = new Struct({
  tag: new StringT(4),
  script: new Pointer(uint16, $7cbbe4e24ef3cb75$var$Script, {
    type: "parent"
  })
});
var $7cbbe4e24ef3cb75$export$3e15fc05ce864229 = new ArrayT($7cbbe4e24ef3cb75$var$ScriptRecord, uint16);
var $7cbbe4e24ef3cb75$var$FeatureParams = new Struct({
  version: uint16,
  nameID: uint16
});
var $7cbbe4e24ef3cb75$export$6e91cf7616333d5 = new Struct({
  featureParams: new Pointer(uint16, $7cbbe4e24ef3cb75$var$FeatureParams),
  lookupCount: uint16,
  lookupListIndexes: new ArrayT(uint16, "lookupCount")
});
var $7cbbe4e24ef3cb75$var$FeatureRecord = new Struct({
  tag: new StringT(4),
  feature: new Pointer(uint16, $7cbbe4e24ef3cb75$export$6e91cf7616333d5, {
    type: "parent"
  })
});
var $7cbbe4e24ef3cb75$export$aa18130def4b6cb4 = new ArrayT($7cbbe4e24ef3cb75$var$FeatureRecord, uint16);
var $7cbbe4e24ef3cb75$var$LookupFlags = new Struct({
  markAttachmentType: uint8,
  flags: new Bitfield(uint8, [
    "rightToLeft",
    "ignoreBaseGlyphs",
    "ignoreLigatures",
    "ignoreMarks",
    "useMarkFilteringSet"
  ])
});
function $7cbbe4e24ef3cb75$export$df0008c6ff2da22a(SubTable) {
  let Lookup = new Struct({
    lookupType: uint16,
    flags: $7cbbe4e24ef3cb75$var$LookupFlags,
    subTableCount: uint16,
    subTables: new ArrayT(new Pointer(uint16, SubTable), "subTableCount"),
    markFilteringSet: new Optional(uint16, (t2) => t2.flags.flags.useMarkFilteringSet)
  });
  return new LazyArray(new Pointer(uint16, Lookup), uint16);
}
var $7cbbe4e24ef3cb75$var$RangeRecord = new Struct({
  start: uint16,
  end: uint16,
  startCoverageIndex: uint16
});
var $7cbbe4e24ef3cb75$export$17608c3f81a6111 = new VersionedStruct(uint16, {
  1: {
    glyphCount: uint16,
    glyphs: new ArrayT(uint16, "glyphCount")
  },
  2: {
    rangeCount: uint16,
    rangeRecords: new ArrayT($7cbbe4e24ef3cb75$var$RangeRecord, "rangeCount")
  }
});
var $7cbbe4e24ef3cb75$var$ClassRangeRecord = new Struct({
  start: uint16,
  end: uint16,
  class: uint16
});
var $7cbbe4e24ef3cb75$export$843d551fbbafef71 = new VersionedStruct(uint16, {
  1: {
    startGlyph: uint16,
    glyphCount: uint16,
    classValueArray: new ArrayT(uint16, "glyphCount")
  },
  2: {
    classRangeCount: uint16,
    classRangeRecord: new ArrayT($7cbbe4e24ef3cb75$var$ClassRangeRecord, "classRangeCount")
  }
});
var $7cbbe4e24ef3cb75$export$8215d14a63d9fb10 = new Struct({
  a: uint16,
  b: uint16,
  deltaFormat: uint16
});
var $7cbbe4e24ef3cb75$var$LookupRecord = new Struct({
  sequenceIndex: uint16,
  lookupListIndex: uint16
});
var $7cbbe4e24ef3cb75$var$Rule = new Struct({
  glyphCount: uint16,
  lookupCount: uint16,
  input: new ArrayT(uint16, (t2) => t2.glyphCount - 1),
  lookupRecords: new ArrayT($7cbbe4e24ef3cb75$var$LookupRecord, "lookupCount")
});
var $7cbbe4e24ef3cb75$var$RuleSet = new ArrayT(new Pointer(uint16, $7cbbe4e24ef3cb75$var$Rule), uint16);
var $7cbbe4e24ef3cb75$var$ClassRule = new Struct({
  glyphCount: uint16,
  lookupCount: uint16,
  classes: new ArrayT(uint16, (t2) => t2.glyphCount - 1),
  lookupRecords: new ArrayT($7cbbe4e24ef3cb75$var$LookupRecord, "lookupCount")
});
var $7cbbe4e24ef3cb75$var$ClassSet = new ArrayT(new Pointer(uint16, $7cbbe4e24ef3cb75$var$ClassRule), uint16);
var $7cbbe4e24ef3cb75$export$841858b892ce1f4c = new VersionedStruct(uint16, {
  1: {
    coverage: new Pointer(uint16, $7cbbe4e24ef3cb75$export$17608c3f81a6111),
    ruleSetCount: uint16,
    ruleSets: new ArrayT(new Pointer(uint16, $7cbbe4e24ef3cb75$var$RuleSet), "ruleSetCount")
  },
  2: {
    coverage: new Pointer(uint16, $7cbbe4e24ef3cb75$export$17608c3f81a6111),
    classDef: new Pointer(uint16, $7cbbe4e24ef3cb75$export$843d551fbbafef71),
    classSetCnt: uint16,
    classSet: new ArrayT(new Pointer(uint16, $7cbbe4e24ef3cb75$var$ClassSet), "classSetCnt")
  },
  3: {
    glyphCount: uint16,
    lookupCount: uint16,
    coverages: new ArrayT(new Pointer(uint16, $7cbbe4e24ef3cb75$export$17608c3f81a6111), "glyphCount"),
    lookupRecords: new ArrayT($7cbbe4e24ef3cb75$var$LookupRecord, "lookupCount")
  }
});
var $7cbbe4e24ef3cb75$var$ChainRule = new Struct({
  backtrackGlyphCount: uint16,
  backtrack: new ArrayT(uint16, "backtrackGlyphCount"),
  inputGlyphCount: uint16,
  input: new ArrayT(uint16, (t2) => t2.inputGlyphCount - 1),
  lookaheadGlyphCount: uint16,
  lookahead: new ArrayT(uint16, "lookaheadGlyphCount"),
  lookupCount: uint16,
  lookupRecords: new ArrayT($7cbbe4e24ef3cb75$var$LookupRecord, "lookupCount")
});
var $7cbbe4e24ef3cb75$var$ChainRuleSet = new ArrayT(new Pointer(uint16, $7cbbe4e24ef3cb75$var$ChainRule), uint16);
var $7cbbe4e24ef3cb75$export$5e6d09e6861162f6 = new VersionedStruct(uint16, {
  1: {
    coverage: new Pointer(uint16, $7cbbe4e24ef3cb75$export$17608c3f81a6111),
    chainCount: uint16,
    chainRuleSets: new ArrayT(new Pointer(uint16, $7cbbe4e24ef3cb75$var$ChainRuleSet), "chainCount")
  },
  2: {
    coverage: new Pointer(uint16, $7cbbe4e24ef3cb75$export$17608c3f81a6111),
    backtrackClassDef: new Pointer(uint16, $7cbbe4e24ef3cb75$export$843d551fbbafef71),
    inputClassDef: new Pointer(uint16, $7cbbe4e24ef3cb75$export$843d551fbbafef71),
    lookaheadClassDef: new Pointer(uint16, $7cbbe4e24ef3cb75$export$843d551fbbafef71),
    chainCount: uint16,
    chainClassSet: new ArrayT(new Pointer(uint16, $7cbbe4e24ef3cb75$var$ChainRuleSet), "chainCount")
  },
  3: {
    backtrackGlyphCount: uint16,
    backtrackCoverage: new ArrayT(new Pointer(uint16, $7cbbe4e24ef3cb75$export$17608c3f81a6111), "backtrackGlyphCount"),
    inputGlyphCount: uint16,
    inputCoverage: new ArrayT(new Pointer(uint16, $7cbbe4e24ef3cb75$export$17608c3f81a6111), "inputGlyphCount"),
    lookaheadGlyphCount: uint16,
    lookaheadCoverage: new ArrayT(new Pointer(uint16, $7cbbe4e24ef3cb75$export$17608c3f81a6111), "lookaheadGlyphCount"),
    lookupCount: uint16,
    lookupRecords: new ArrayT($7cbbe4e24ef3cb75$var$LookupRecord, "lookupCount")
  }
});
var $1a47b0c45c1c22fe$var$F2DOT14 = new Fixed(16, "BE", 14);
var $1a47b0c45c1c22fe$var$RegionAxisCoordinates = new Struct({
  startCoord: $1a47b0c45c1c22fe$var$F2DOT14,
  peakCoord: $1a47b0c45c1c22fe$var$F2DOT14,
  endCoord: $1a47b0c45c1c22fe$var$F2DOT14
});
var $1a47b0c45c1c22fe$var$VariationRegionList = new Struct({
  axisCount: uint16,
  regionCount: uint16,
  variationRegions: new ArrayT(new ArrayT($1a47b0c45c1c22fe$var$RegionAxisCoordinates, "axisCount"), "regionCount")
});
var $1a47b0c45c1c22fe$var$DeltaSet = new Struct({
  shortDeltas: new ArrayT(int16, (t2) => t2.parent.shortDeltaCount),
  regionDeltas: new ArrayT(int8, (t2) => t2.parent.regionIndexCount - t2.parent.shortDeltaCount),
  deltas: (t2) => t2.shortDeltas.concat(t2.regionDeltas)
});
var $1a47b0c45c1c22fe$var$ItemVariationData = new Struct({
  itemCount: uint16,
  shortDeltaCount: uint16,
  regionIndexCount: uint16,
  regionIndexes: new ArrayT(uint16, "regionIndexCount"),
  deltaSets: new ArrayT($1a47b0c45c1c22fe$var$DeltaSet, "itemCount")
});
var $1a47b0c45c1c22fe$export$fe1b122a2710f241 = new Struct({
  format: uint16,
  variationRegionList: new Pointer(uint32, $1a47b0c45c1c22fe$var$VariationRegionList),
  variationDataCount: uint16,
  itemVariationData: new ArrayT(new Pointer(uint32, $1a47b0c45c1c22fe$var$ItemVariationData), "variationDataCount")
});
var $1a47b0c45c1c22fe$var$ConditionTable = new VersionedStruct(uint16, {
  1: {
    axisIndex: uint16,
    axisIndex: uint16,
    filterRangeMinValue: $1a47b0c45c1c22fe$var$F2DOT14,
    filterRangeMaxValue: $1a47b0c45c1c22fe$var$F2DOT14
  }
});
var $1a47b0c45c1c22fe$var$ConditionSet = new Struct({
  conditionCount: uint16,
  conditionTable: new ArrayT(new Pointer(uint32, $1a47b0c45c1c22fe$var$ConditionTable), "conditionCount")
});
var $1a47b0c45c1c22fe$var$FeatureTableSubstitutionRecord = new Struct({
  featureIndex: uint16,
  alternateFeatureTable: new Pointer(uint32, (0, $7cbbe4e24ef3cb75$export$6e91cf7616333d5), {
    type: "parent"
  })
});
var $1a47b0c45c1c22fe$var$FeatureTableSubstitution = new Struct({
  version: fixed32,
  substitutionCount: uint16,
  substitutions: new ArrayT($1a47b0c45c1c22fe$var$FeatureTableSubstitutionRecord, "substitutionCount")
});
var $1a47b0c45c1c22fe$var$FeatureVariationRecord = new Struct({
  conditionSet: new Pointer(uint32, $1a47b0c45c1c22fe$var$ConditionSet, {
    type: "parent"
  }),
  featureTableSubstitution: new Pointer(uint32, $1a47b0c45c1c22fe$var$FeatureTableSubstitution, {
    type: "parent"
  })
});
var $1a47b0c45c1c22fe$export$441b70b7971dd419 = new Struct({
  majorVersion: uint16,
  minorVersion: uint16,
  featureVariationRecordCount: uint32,
  featureVariationRecords: new ArrayT($1a47b0c45c1c22fe$var$FeatureVariationRecord, "featureVariationRecordCount")
});
var $b84fd3dd9d8eddb2$var$PredefinedOp = class {
  decode(stream, parent2, operands) {
    if (this.predefinedOps[operands[0]]) return this.predefinedOps[operands[0]];
    return this.type.decode(stream, parent2, operands);
  }
  size(value, ctx) {
    return this.type.size(value, ctx);
  }
  encode(stream, value, ctx) {
    let index3 = this.predefinedOps.indexOf(value);
    if (index3 !== -1) return index3;
    return this.type.encode(stream, value, ctx);
  }
  constructor(predefinedOps, type5) {
    this.predefinedOps = predefinedOps;
    this.type = type5;
  }
};
var $b84fd3dd9d8eddb2$var$CFFEncodingVersion = class extends NumberT {
  decode(stream) {
    return uint8.decode(stream) & 127;
  }
  constructor() {
    super("UInt8");
  }
};
var $b84fd3dd9d8eddb2$var$Range1 = new Struct({
  first: uint16,
  nLeft: uint8
});
var $b84fd3dd9d8eddb2$var$Range2 = new Struct({
  first: uint16,
  nLeft: uint16
});
var $b84fd3dd9d8eddb2$var$CFFCustomEncoding = new VersionedStruct(new $b84fd3dd9d8eddb2$var$CFFEncodingVersion(), {
  0: {
    nCodes: uint8,
    codes: new ArrayT(uint8, "nCodes")
  },
  1: {
    nRanges: uint8,
    ranges: new ArrayT($b84fd3dd9d8eddb2$var$Range1, "nRanges")
  }
});
var $b84fd3dd9d8eddb2$var$CFFEncoding = new $b84fd3dd9d8eddb2$var$PredefinedOp([
  (0, $bc0433d9b7e41f5f$export$dee0027060fa13bd),
  (0, $bc0433d9b7e41f5f$export$4f58f497e14a53c3)
], new (0, $0e34a43d05bde82c$export$2e2bcd8739ae039)($b84fd3dd9d8eddb2$var$CFFCustomEncoding, {
  lazy: true
}));
var $b84fd3dd9d8eddb2$var$RangeArray = class extends ArrayT {
  decode(stream, parent2) {
    let length2 = (0, resolveLength)(this.length, stream, parent2);
    let count = 0;
    let res = [];
    while (count < length2) {
      let range3 = this.type.decode(stream, parent2);
      range3.offset = count;
      count += range3.nLeft + 1;
      res.push(range3);
    }
    return res;
  }
};
var $b84fd3dd9d8eddb2$var$CFFCustomCharset = new VersionedStruct(uint8, {
  0: {
    glyphs: new ArrayT(uint16, (t2) => t2.parent.CharStrings.length - 1)
  },
  1: {
    ranges: new $b84fd3dd9d8eddb2$var$RangeArray($b84fd3dd9d8eddb2$var$Range1, (t2) => t2.parent.CharStrings.length - 1)
  },
  2: {
    ranges: new $b84fd3dd9d8eddb2$var$RangeArray($b84fd3dd9d8eddb2$var$Range2, (t2) => t2.parent.CharStrings.length - 1)
  }
});
var $b84fd3dd9d8eddb2$var$CFFCharset = new $b84fd3dd9d8eddb2$var$PredefinedOp([
  (0, $ef658f5c9a1488b2$export$c33b50336c234f16),
  (0, $ef658f5c9a1488b2$export$3ed0f9e1fee8d489),
  (0, $ef658f5c9a1488b2$export$dc28be11139d4120)
], new (0, $0e34a43d05bde82c$export$2e2bcd8739ae039)($b84fd3dd9d8eddb2$var$CFFCustomCharset, {
  lazy: true
}));
var $b84fd3dd9d8eddb2$var$FDRange3 = new Struct({
  first: uint16,
  fd: uint8
});
var $b84fd3dd9d8eddb2$var$FDRange4 = new Struct({
  first: uint32,
  fd: uint16
});
var $b84fd3dd9d8eddb2$var$FDSelect = new VersionedStruct(uint8, {
  0: {
    fds: new ArrayT(uint8, (t2) => t2.parent.CharStrings.length)
  },
  3: {
    nRanges: uint16,
    ranges: new ArrayT($b84fd3dd9d8eddb2$var$FDRange3, "nRanges"),
    sentinel: uint16
  },
  4: {
    nRanges: uint32,
    ranges: new ArrayT($b84fd3dd9d8eddb2$var$FDRange4, "nRanges"),
    sentinel: uint32
  }
});
var $b84fd3dd9d8eddb2$var$ptr = new (0, $0e34a43d05bde82c$export$2e2bcd8739ae039)((0, $6d59db2e29cc77b3$export$2e2bcd8739ae039));
var $b84fd3dd9d8eddb2$var$CFFPrivateOp = class {
  decode(stream, parent2, operands) {
    parent2.length = operands[0];
    return $b84fd3dd9d8eddb2$var$ptr.decode(stream, parent2, [
      operands[1]
    ]);
  }
  size(dict, ctx) {
    return [
      (0, $6d59db2e29cc77b3$export$2e2bcd8739ae039).size(dict, ctx, false),
      $b84fd3dd9d8eddb2$var$ptr.size(dict, ctx)[0]
    ];
  }
  encode(stream, dict, ctx) {
    return [
      (0, $6d59db2e29cc77b3$export$2e2bcd8739ae039).size(dict, ctx, false),
      $b84fd3dd9d8eddb2$var$ptr.encode(stream, dict, ctx)[0]
    ];
  }
};
var $b84fd3dd9d8eddb2$var$FontDict = new (0, $61aa549f16d58b9b$export$2e2bcd8739ae039)([
  // key       name                   type(s)                                 default
  [
    18,
    "Private",
    new $b84fd3dd9d8eddb2$var$CFFPrivateOp(),
    null
  ],
  [
    [
      12,
      38
    ],
    "FontName",
    "sid",
    null
  ],
  [
    [
      12,
      7
    ],
    "FontMatrix",
    "array",
    [
      1e-3,
      0,
      0,
      1e-3,
      0,
      0
    ]
  ],
  [
    [
      12,
      5
    ],
    "PaintType",
    "number",
    0
  ]
]);
var $b84fd3dd9d8eddb2$var$CFFTopDict = new (0, $61aa549f16d58b9b$export$2e2bcd8739ae039)([
  // key       name                   type(s)                                 default
  [
    [
      12,
      30
    ],
    "ROS",
    [
      "sid",
      "sid",
      "number"
    ],
    null
  ],
  [
    0,
    "version",
    "sid",
    null
  ],
  [
    1,
    "Notice",
    "sid",
    null
  ],
  [
    [
      12,
      0
    ],
    "Copyright",
    "sid",
    null
  ],
  [
    2,
    "FullName",
    "sid",
    null
  ],
  [
    3,
    "FamilyName",
    "sid",
    null
  ],
  [
    4,
    "Weight",
    "sid",
    null
  ],
  [
    [
      12,
      1
    ],
    "isFixedPitch",
    "boolean",
    false
  ],
  [
    [
      12,
      2
    ],
    "ItalicAngle",
    "number",
    0
  ],
  [
    [
      12,
      3
    ],
    "UnderlinePosition",
    "number",
    -100
  ],
  [
    [
      12,
      4
    ],
    "UnderlineThickness",
    "number",
    50
  ],
  [
    [
      12,
      5
    ],
    "PaintType",
    "number",
    0
  ],
  [
    [
      12,
      6
    ],
    "CharstringType",
    "number",
    2
  ],
  [
    [
      12,
      7
    ],
    "FontMatrix",
    "array",
    [
      1e-3,
      0,
      0,
      1e-3,
      0,
      0
    ]
  ],
  [
    13,
    "UniqueID",
    "number",
    null
  ],
  [
    5,
    "FontBBox",
    "array",
    [
      0,
      0,
      0,
      0
    ]
  ],
  [
    [
      12,
      8
    ],
    "StrokeWidth",
    "number",
    0
  ],
  [
    14,
    "XUID",
    "array",
    null
  ],
  [
    15,
    "charset",
    $b84fd3dd9d8eddb2$var$CFFCharset,
    (0, $ef658f5c9a1488b2$export$c33b50336c234f16)
  ],
  [
    16,
    "Encoding",
    $b84fd3dd9d8eddb2$var$CFFEncoding,
    (0, $bc0433d9b7e41f5f$export$dee0027060fa13bd)
  ],
  [
    17,
    "CharStrings",
    new (0, $0e34a43d05bde82c$export$2e2bcd8739ae039)(new (0, $43e9821ef3717eec$export$2e2bcd8739ae039)()),
    null
  ],
  [
    18,
    "Private",
    new $b84fd3dd9d8eddb2$var$CFFPrivateOp(),
    null
  ],
  [
    [
      12,
      20
    ],
    "SyntheticBase",
    "number",
    null
  ],
  [
    [
      12,
      21
    ],
    "PostScript",
    "sid",
    null
  ],
  [
    [
      12,
      22
    ],
    "BaseFontName",
    "sid",
    null
  ],
  [
    [
      12,
      23
    ],
    "BaseFontBlend",
    "delta",
    null
  ],
  // CID font specific
  [
    [
      12,
      31
    ],
    "CIDFontVersion",
    "number",
    0
  ],
  [
    [
      12,
      32
    ],
    "CIDFontRevision",
    "number",
    0
  ],
  [
    [
      12,
      33
    ],
    "CIDFontType",
    "number",
    0
  ],
  [
    [
      12,
      34
    ],
    "CIDCount",
    "number",
    8720
  ],
  [
    [
      12,
      35
    ],
    "UIDBase",
    "number",
    null
  ],
  [
    [
      12,
      37
    ],
    "FDSelect",
    new (0, $0e34a43d05bde82c$export$2e2bcd8739ae039)($b84fd3dd9d8eddb2$var$FDSelect),
    null
  ],
  [
    [
      12,
      36
    ],
    "FDArray",
    new (0, $0e34a43d05bde82c$export$2e2bcd8739ae039)(new (0, $43e9821ef3717eec$export$2e2bcd8739ae039)($b84fd3dd9d8eddb2$var$FontDict)),
    null
  ],
  [
    [
      12,
      38
    ],
    "FontName",
    "sid",
    null
  ]
]);
var $b84fd3dd9d8eddb2$var$VariationStore = new Struct({
  length: uint16,
  itemVariationStore: (0, $1a47b0c45c1c22fe$export$fe1b122a2710f241)
});
var $b84fd3dd9d8eddb2$var$CFF2TopDict = new (0, $61aa549f16d58b9b$export$2e2bcd8739ae039)([
  [
    [
      12,
      7
    ],
    "FontMatrix",
    "array",
    [
      1e-3,
      0,
      0,
      1e-3,
      0,
      0
    ]
  ],
  [
    17,
    "CharStrings",
    new (0, $0e34a43d05bde82c$export$2e2bcd8739ae039)(new (0, $43e9821ef3717eec$export$2e2bcd8739ae039)()),
    null
  ],
  [
    [
      12,
      37
    ],
    "FDSelect",
    new (0, $0e34a43d05bde82c$export$2e2bcd8739ae039)($b84fd3dd9d8eddb2$var$FDSelect),
    null
  ],
  [
    [
      12,
      36
    ],
    "FDArray",
    new (0, $0e34a43d05bde82c$export$2e2bcd8739ae039)(new (0, $43e9821ef3717eec$export$2e2bcd8739ae039)($b84fd3dd9d8eddb2$var$FontDict)),
    null
  ],
  [
    24,
    "vstore",
    new (0, $0e34a43d05bde82c$export$2e2bcd8739ae039)($b84fd3dd9d8eddb2$var$VariationStore),
    null
  ],
  [
    25,
    "maxstack",
    "number",
    193
  ]
]);
var $b84fd3dd9d8eddb2$var$CFFTop = new VersionedStruct(fixed16, {
  1: {
    hdrSize: uint8,
    offSize: uint8,
    nameIndex: new (0, $43e9821ef3717eec$export$2e2bcd8739ae039)(new StringT("length")),
    topDictIndex: new (0, $43e9821ef3717eec$export$2e2bcd8739ae039)($b84fd3dd9d8eddb2$var$CFFTopDict),
    stringIndex: new (0, $43e9821ef3717eec$export$2e2bcd8739ae039)(new StringT("length")),
    globalSubrIndex: new (0, $43e9821ef3717eec$export$2e2bcd8739ae039)()
  },
  2: {
    hdrSize: uint8,
    length: uint16,
    topDict: $b84fd3dd9d8eddb2$var$CFF2TopDict,
    globalSubrIndex: new (0, $43e9821ef3717eec$export$2e2bcd8739ae039)()
  }
});
var $b84fd3dd9d8eddb2$export$2e2bcd8739ae039 = $b84fd3dd9d8eddb2$var$CFFTop;
var $822ac0d589e4e237$var$CFFFont = class _$822ac0d589e4e237$var$CFFFont {
  static decode(stream) {
    return new _$822ac0d589e4e237$var$CFFFont(stream);
  }
  decode() {
    let start = this.stream.pos;
    let top = (0, $b84fd3dd9d8eddb2$export$2e2bcd8739ae039).decode(this.stream);
    for (let key2 in top) {
      let val = top[key2];
      this[key2] = val;
    }
    if (this.version < 2) {
      if (this.topDictIndex.length !== 1) throw new Error("Only a single font is allowed in CFF");
      this.topDict = this.topDictIndex[0];
    }
    this.isCIDFont = this.topDict.ROS != null;
    return this;
  }
  string(sid) {
    if (this.version >= 2) return null;
    if (sid < (0, $229224aec43783c5$export$2e2bcd8739ae039).length) return (0, $229224aec43783c5$export$2e2bcd8739ae039)[sid];
    return this.stringIndex[sid - (0, $229224aec43783c5$export$2e2bcd8739ae039).length];
  }
  get postscriptName() {
    if (this.version < 2) return this.nameIndex[0];
    return null;
  }
  get fullName() {
    return this.string(this.topDict.FullName);
  }
  get familyName() {
    return this.string(this.topDict.FamilyName);
  }
  getCharString(glyph) {
    this.stream.pos = this.topDict.CharStrings[glyph].offset;
    return this.stream.readBuffer(this.topDict.CharStrings[glyph].length);
  }
  getGlyphName(gid) {
    if (this.version >= 2) return null;
    if (this.isCIDFont) return null;
    let { charset } = this.topDict;
    if (Array.isArray(charset)) return charset[gid];
    if (gid === 0) return ".notdef";
    gid -= 1;
    switch (charset.version) {
      case 0:
        return this.string(charset.glyphs[gid]);
      case 1:
      case 2:
        for (let i = 0; i < charset.ranges.length; i++) {
          let range3 = charset.ranges[i];
          if (range3.offset <= gid && gid <= range3.offset + range3.nLeft) return this.string(range3.first + (gid - range3.offset));
        }
        break;
    }
    return null;
  }
  fdForGlyph(gid) {
    if (!this.topDict.FDSelect) return null;
    switch (this.topDict.FDSelect.version) {
      case 0:
        return this.topDict.FDSelect.fds[gid];
      case 3:
      case 4:
        let { ranges } = this.topDict.FDSelect;
        let low = 0;
        let high = ranges.length - 1;
        while (low <= high) {
          let mid = low + high >> 1;
          if (gid < ranges[mid].first) high = mid - 1;
          else if (mid < high && gid >= ranges[mid + 1].first) low = mid + 1;
          else return ranges[mid].fd;
        }
      default:
        throw new Error(`Unknown FDSelect version: ${this.topDict.FDSelect.version}`);
    }
  }
  privateDictForGlyph(gid) {
    if (this.topDict.FDSelect) {
      let fd = this.fdForGlyph(gid);
      if (this.topDict.FDArray[fd]) return this.topDict.FDArray[fd].Private;
      return null;
    }
    if (this.version < 2) return this.topDict.Private;
    return this.topDict.FDArray[0].Private;
  }
  constructor(stream) {
    this.stream = stream;
    this.decode();
  }
};
var $822ac0d589e4e237$export$2e2bcd8739ae039 = $822ac0d589e4e237$var$CFFFont;
var $2bbf2bc1ce37cd8f$var$VerticalOrigin = new Struct({
  glyphIndex: uint16,
  vertOriginY: int16
});
var $2bbf2bc1ce37cd8f$export$2e2bcd8739ae039 = new Struct({
  majorVersion: uint16,
  minorVersion: uint16,
  defaultVertOriginY: int16,
  numVertOriginYMetrics: uint16,
  metrics: new ArrayT($2bbf2bc1ce37cd8f$var$VerticalOrigin, "numVertOriginYMetrics")
});
var $0941618dc22a946d$export$16b227cb15d716a0 = new Struct({
  height: uint8,
  width: uint8,
  horiBearingX: int8,
  horiBearingY: int8,
  horiAdvance: uint8,
  vertBearingX: int8,
  vertBearingY: int8,
  vertAdvance: uint8
});
var $0941618dc22a946d$export$62c53e75f69bfe12 = new Struct({
  height: uint8,
  width: uint8,
  bearingX: int8,
  bearingY: int8,
  advance: uint8
});
var $0941618dc22a946d$var$EBDTComponent = new Struct({
  glyph: uint16,
  xOffset: int8,
  yOffset: int8
});
var $0941618dc22a946d$var$ByteAligned = class {
};
var $0941618dc22a946d$var$BitAligned = class {
};
var $0941618dc22a946d$export$f1f5ddeb20d14f = new VersionedStruct("version", {
  1: {
    metrics: $0941618dc22a946d$export$62c53e75f69bfe12,
    data: $0941618dc22a946d$var$ByteAligned
  },
  2: {
    metrics: $0941618dc22a946d$export$62c53e75f69bfe12,
    data: $0941618dc22a946d$var$BitAligned
  },
  // format 3 is deprecated
  // format 4 is not supported by Microsoft
  5: {
    data: $0941618dc22a946d$var$BitAligned
  },
  6: {
    metrics: $0941618dc22a946d$export$16b227cb15d716a0,
    data: $0941618dc22a946d$var$ByteAligned
  },
  7: {
    metrics: $0941618dc22a946d$export$16b227cb15d716a0,
    data: $0941618dc22a946d$var$BitAligned
  },
  8: {
    metrics: $0941618dc22a946d$export$62c53e75f69bfe12,
    pad: new Reserved(uint8),
    numComponents: uint16,
    components: new ArrayT($0941618dc22a946d$var$EBDTComponent, "numComponents")
  },
  9: {
    metrics: $0941618dc22a946d$export$16b227cb15d716a0,
    pad: new Reserved(uint8),
    numComponents: uint16,
    components: new ArrayT($0941618dc22a946d$var$EBDTComponent, "numComponents")
  },
  17: {
    metrics: $0941618dc22a946d$export$62c53e75f69bfe12,
    dataLen: uint32,
    data: new BufferT("dataLen")
  },
  18: {
    metrics: $0941618dc22a946d$export$16b227cb15d716a0,
    dataLen: uint32,
    data: new BufferT("dataLen")
  },
  19: {
    dataLen: uint32,
    data: new BufferT("dataLen")
  }
});
var $9911c4c7201c13de$var$SBitLineMetrics = new Struct({
  ascender: int8,
  descender: int8,
  widthMax: uint8,
  caretSlopeNumerator: int8,
  caretSlopeDenominator: int8,
  caretOffset: int8,
  minOriginSB: int8,
  minAdvanceSB: int8,
  maxBeforeBL: int8,
  minAfterBL: int8,
  pad: new Reserved(int8, 2)
});
var $9911c4c7201c13de$var$CodeOffsetPair = new Struct({
  glyphCode: uint16,
  offset: uint16
});
var $9911c4c7201c13de$var$IndexSubtable = new VersionedStruct(uint16, {
  header: {
    imageFormat: uint16,
    imageDataOffset: uint32
  },
  1: {
    offsetArray: new ArrayT(uint32, (t2) => t2.parent.lastGlyphIndex - t2.parent.firstGlyphIndex + 1)
  },
  2: {
    imageSize: uint32,
    bigMetrics: (0, $0941618dc22a946d$export$16b227cb15d716a0)
  },
  3: {
    offsetArray: new ArrayT(uint16, (t2) => t2.parent.lastGlyphIndex - t2.parent.firstGlyphIndex + 1)
  },
  4: {
    numGlyphs: uint32,
    glyphArray: new ArrayT($9911c4c7201c13de$var$CodeOffsetPair, (t2) => t2.numGlyphs + 1)
  },
  5: {
    imageSize: uint32,
    bigMetrics: (0, $0941618dc22a946d$export$16b227cb15d716a0),
    numGlyphs: uint32,
    glyphCodeArray: new ArrayT(uint16, "numGlyphs")
  }
});
var $9911c4c7201c13de$var$IndexSubtableArray = new Struct({
  firstGlyphIndex: uint16,
  lastGlyphIndex: uint16,
  subtable: new Pointer(uint32, $9911c4c7201c13de$var$IndexSubtable)
});
var $9911c4c7201c13de$var$BitmapSizeTable = new Struct({
  indexSubTableArray: new Pointer(uint32, new ArrayT($9911c4c7201c13de$var$IndexSubtableArray, 1), {
    type: "parent"
  }),
  indexTablesSize: uint32,
  numberOfIndexSubTables: uint32,
  colorRef: uint32,
  hori: $9911c4c7201c13de$var$SBitLineMetrics,
  vert: $9911c4c7201c13de$var$SBitLineMetrics,
  startGlyphIndex: uint16,
  endGlyphIndex: uint16,
  ppemX: uint8,
  ppemY: uint8,
  bitDepth: uint8,
  flags: new Bitfield(uint8, [
    "horizontal",
    "vertical"
  ])
});
var $9911c4c7201c13de$export$2e2bcd8739ae039 = new Struct({
  version: uint32,
  numSizes: uint32,
  sizes: new ArrayT($9911c4c7201c13de$var$BitmapSizeTable, "numSizes")
});
var $abb847051efd51b1$var$ImageTable = new Struct({
  ppem: uint16,
  resolution: uint16,
  imageOffsets: new ArrayT(new Pointer(uint32, "void"), (t2) => t2.parent.parent.maxp.numGlyphs + 1)
});
var $abb847051efd51b1$export$2e2bcd8739ae039 = new Struct({
  version: uint16,
  flags: new Bitfield(uint16, [
    "renderOutlines"
  ]),
  numImgTables: uint32,
  imageTables: new ArrayT(new Pointer(uint32, $abb847051efd51b1$var$ImageTable), "numImgTables")
});
var $eb629188f3dfefdd$var$LayerRecord = new Struct({
  gid: uint16,
  paletteIndex: uint16
  // Index value to use in the appropriate palette. This value must
});
var $eb629188f3dfefdd$var$BaseGlyphRecord = new Struct({
  gid: uint16,
  // and is not rendered for color.
  firstLayerIndex: uint16,
  // There will be numLayers consecutive entries for this base glyph.
  numLayers: uint16
});
var $eb629188f3dfefdd$export$2e2bcd8739ae039 = new Struct({
  version: uint16,
  numBaseGlyphRecords: uint16,
  baseGlyphRecord: new Pointer(uint32, new ArrayT($eb629188f3dfefdd$var$BaseGlyphRecord, "numBaseGlyphRecords")),
  layerRecords: new Pointer(uint32, new ArrayT($eb629188f3dfefdd$var$LayerRecord, "numLayerRecords"), {
    lazy: true
  }),
  numLayerRecords: uint16
});
var $08734b8e7dc64587$var$ColorRecord = new Struct({
  blue: uint8,
  green: uint8,
  red: uint8,
  alpha: uint8
});
var $08734b8e7dc64587$export$2e2bcd8739ae039 = new VersionedStruct(uint16, {
  header: {
    numPaletteEntries: uint16,
    numPalettes: uint16,
    numColorRecords: uint16,
    colorRecords: new Pointer(uint32, new ArrayT($08734b8e7dc64587$var$ColorRecord, "numColorRecords")),
    colorRecordIndices: new ArrayT(uint16, "numPalettes")
  },
  0: {},
  1: {
    offsetPaletteTypeArray: new Pointer(uint32, new ArrayT(uint32, "numPalettes")),
    offsetPaletteLabelArray: new Pointer(uint32, new ArrayT(uint16, "numPalettes")),
    offsetPaletteEntryLabelArray: new Pointer(uint32, new ArrayT(uint16, "numPaletteEntries"))
  }
});
var $497cef411d884e34$var$BaseCoord = new VersionedStruct(uint16, {
  1: {
    coordinate: int16
    // X or Y value, in design units
  },
  2: {
    coordinate: int16,
    referenceGlyph: uint16,
    baseCoordPoint: uint16
    // Index of contour point on the referenceGlyph
  },
  3: {
    coordinate: int16,
    deviceTable: new Pointer(uint16, (0, $7cbbe4e24ef3cb75$export$8215d14a63d9fb10))
    // Device table for X or Y value
  }
});
var $497cef411d884e34$var$BaseValues = new Struct({
  defaultIndex: uint16,
  baseCoordCount: uint16,
  baseCoords: new ArrayT(new Pointer(uint16, $497cef411d884e34$var$BaseCoord), "baseCoordCount")
});
var $497cef411d884e34$var$FeatMinMaxRecord = new Struct({
  tag: new StringT(4),
  minCoord: new Pointer(uint16, $497cef411d884e34$var$BaseCoord, {
    type: "parent"
  }),
  maxCoord: new Pointer(uint16, $497cef411d884e34$var$BaseCoord, {
    type: "parent"
  })
  // May be NULL
});
var $497cef411d884e34$var$MinMax = new Struct({
  minCoord: new Pointer(uint16, $497cef411d884e34$var$BaseCoord),
  maxCoord: new Pointer(uint16, $497cef411d884e34$var$BaseCoord),
  featMinMaxCount: uint16,
  featMinMaxRecords: new ArrayT($497cef411d884e34$var$FeatMinMaxRecord, "featMinMaxCount")
  // In alphabetical order
});
var $497cef411d884e34$var$BaseLangSysRecord = new Struct({
  tag: new StringT(4),
  minMax: new Pointer(uint16, $497cef411d884e34$var$MinMax, {
    type: "parent"
  })
});
var $497cef411d884e34$var$BaseScript = new Struct({
  baseValues: new Pointer(uint16, $497cef411d884e34$var$BaseValues),
  defaultMinMax: new Pointer(uint16, $497cef411d884e34$var$MinMax),
  baseLangSysCount: uint16,
  baseLangSysRecords: new ArrayT($497cef411d884e34$var$BaseLangSysRecord, "baseLangSysCount")
  // in alphabetical order by BaseLangSysTag
});
var $497cef411d884e34$var$BaseScriptRecord = new Struct({
  tag: new StringT(4),
  script: new Pointer(uint16, $497cef411d884e34$var$BaseScript, {
    type: "parent"
  })
});
var $497cef411d884e34$var$BaseScriptList = new ArrayT($497cef411d884e34$var$BaseScriptRecord, uint16);
var $497cef411d884e34$var$BaseTagList = new ArrayT(new StringT(4), uint16);
var $497cef411d884e34$var$Axis = new Struct({
  baseTagList: new Pointer(uint16, $497cef411d884e34$var$BaseTagList),
  baseScriptList: new Pointer(uint16, $497cef411d884e34$var$BaseScriptList)
});
var $497cef411d884e34$export$2e2bcd8739ae039 = new VersionedStruct(uint32, {
  header: {
    horizAxis: new Pointer(uint16, $497cef411d884e34$var$Axis),
    vertAxis: new Pointer(uint16, $497cef411d884e34$var$Axis)
    // May be NULL
  },
  65536: {},
  65537: {
    itemVariationStore: new Pointer(uint32, (0, $1a47b0c45c1c22fe$export$fe1b122a2710f241))
  }
});
var $cf5f33c63ef209e6$var$AttachPoint = new ArrayT(uint16, uint16);
var $cf5f33c63ef209e6$var$AttachList = new Struct({
  coverage: new Pointer(uint16, (0, $7cbbe4e24ef3cb75$export$17608c3f81a6111)),
  glyphCount: uint16,
  attachPoints: new ArrayT(new Pointer(uint16, $cf5f33c63ef209e6$var$AttachPoint), "glyphCount")
});
var $cf5f33c63ef209e6$var$CaretValue = new VersionedStruct(uint16, {
  1: {
    coordinate: int16
  },
  2: {
    caretValuePoint: uint16
  },
  3: {
    coordinate: int16,
    deviceTable: new Pointer(uint16, (0, $7cbbe4e24ef3cb75$export$8215d14a63d9fb10))
  }
});
var $cf5f33c63ef209e6$var$LigGlyph = new ArrayT(new Pointer(uint16, $cf5f33c63ef209e6$var$CaretValue), uint16);
var $cf5f33c63ef209e6$var$LigCaretList = new Struct({
  coverage: new Pointer(uint16, (0, $7cbbe4e24ef3cb75$export$17608c3f81a6111)),
  ligGlyphCount: uint16,
  ligGlyphs: new ArrayT(new Pointer(uint16, $cf5f33c63ef209e6$var$LigGlyph), "ligGlyphCount")
});
var $cf5f33c63ef209e6$var$MarkGlyphSetsDef = new Struct({
  markSetTableFormat: uint16,
  markSetCount: uint16,
  coverage: new ArrayT(new Pointer(uint32, (0, $7cbbe4e24ef3cb75$export$17608c3f81a6111)), "markSetCount")
});
var $cf5f33c63ef209e6$export$2e2bcd8739ae039 = new VersionedStruct(uint32, {
  header: {
    glyphClassDef: new Pointer(uint16, (0, $7cbbe4e24ef3cb75$export$843d551fbbafef71)),
    attachList: new Pointer(uint16, $cf5f33c63ef209e6$var$AttachList),
    ligCaretList: new Pointer(uint16, $cf5f33c63ef209e6$var$LigCaretList),
    markAttachClassDef: new Pointer(uint16, (0, $7cbbe4e24ef3cb75$export$843d551fbbafef71))
  },
  65536: {},
  65538: {
    markGlyphSetsDef: new Pointer(uint16, $cf5f33c63ef209e6$var$MarkGlyphSetsDef)
  },
  65539: {
    markGlyphSetsDef: new Pointer(uint16, $cf5f33c63ef209e6$var$MarkGlyphSetsDef),
    itemVariationStore: new Pointer(uint32, (0, $1a47b0c45c1c22fe$export$fe1b122a2710f241))
  }
});
var $47e0e8ef515d9903$var$ValueFormat = new Bitfield(uint16, [
  "xPlacement",
  "yPlacement",
  "xAdvance",
  "yAdvance",
  "xPlaDevice",
  "yPlaDevice",
  "xAdvDevice",
  "yAdvDevice"
]);
var $47e0e8ef515d9903$var$types = {
  xPlacement: int16,
  yPlacement: int16,
  xAdvance: int16,
  yAdvance: int16,
  xPlaDevice: new Pointer(uint16, (0, $7cbbe4e24ef3cb75$export$8215d14a63d9fb10), {
    type: "global",
    relativeTo: (ctx) => ctx.rel
  }),
  yPlaDevice: new Pointer(uint16, (0, $7cbbe4e24ef3cb75$export$8215d14a63d9fb10), {
    type: "global",
    relativeTo: (ctx) => ctx.rel
  }),
  xAdvDevice: new Pointer(uint16, (0, $7cbbe4e24ef3cb75$export$8215d14a63d9fb10), {
    type: "global",
    relativeTo: (ctx) => ctx.rel
  }),
  yAdvDevice: new Pointer(uint16, (0, $7cbbe4e24ef3cb75$export$8215d14a63d9fb10), {
    type: "global",
    relativeTo: (ctx) => ctx.rel
  })
};
var $47e0e8ef515d9903$var$ValueRecord = class {
  buildStruct(parent2) {
    let struct = parent2;
    while (!struct[this.key] && struct.parent) struct = struct.parent;
    if (!struct[this.key]) return;
    let fields = {};
    fields.rel = () => struct._startOffset;
    let format3 = struct[this.key];
    for (let key2 in format3) if (format3[key2]) fields[key2] = $47e0e8ef515d9903$var$types[key2];
    return new Struct(fields);
  }
  size(val, ctx) {
    return this.buildStruct(ctx).size(val, ctx);
  }
  decode(stream, parent2) {
    let res = this.buildStruct(parent2).decode(stream, parent2);
    delete res.rel;
    return res;
  }
  constructor(key2 = "valueFormat") {
    this.key = key2;
  }
};
var $47e0e8ef515d9903$var$PairValueRecord = new Struct({
  secondGlyph: uint16,
  value1: new $47e0e8ef515d9903$var$ValueRecord("valueFormat1"),
  value2: new $47e0e8ef515d9903$var$ValueRecord("valueFormat2")
});
var $47e0e8ef515d9903$var$PairSet = new ArrayT($47e0e8ef515d9903$var$PairValueRecord, uint16);
var $47e0e8ef515d9903$var$Class2Record = new Struct({
  value1: new $47e0e8ef515d9903$var$ValueRecord("valueFormat1"),
  value2: new $47e0e8ef515d9903$var$ValueRecord("valueFormat2")
});
var $47e0e8ef515d9903$var$Anchor = new VersionedStruct(uint16, {
  1: {
    xCoordinate: int16,
    yCoordinate: int16
  },
  2: {
    xCoordinate: int16,
    yCoordinate: int16,
    anchorPoint: uint16
  },
  3: {
    xCoordinate: int16,
    yCoordinate: int16,
    xDeviceTable: new Pointer(uint16, (0, $7cbbe4e24ef3cb75$export$8215d14a63d9fb10)),
    yDeviceTable: new Pointer(uint16, (0, $7cbbe4e24ef3cb75$export$8215d14a63d9fb10))
  }
});
var $47e0e8ef515d9903$var$EntryExitRecord = new Struct({
  entryAnchor: new Pointer(uint16, $47e0e8ef515d9903$var$Anchor, {
    type: "parent"
  }),
  exitAnchor: new Pointer(uint16, $47e0e8ef515d9903$var$Anchor, {
    type: "parent"
  })
});
var $47e0e8ef515d9903$var$MarkRecord = new Struct({
  class: uint16,
  markAnchor: new Pointer(uint16, $47e0e8ef515d9903$var$Anchor, {
    type: "parent"
  })
});
var $47e0e8ef515d9903$var$MarkArray = new ArrayT($47e0e8ef515d9903$var$MarkRecord, uint16);
var $47e0e8ef515d9903$var$BaseRecord = new ArrayT(new Pointer(uint16, $47e0e8ef515d9903$var$Anchor), (t2) => t2.parent.classCount);
var $47e0e8ef515d9903$var$BaseArray = new ArrayT($47e0e8ef515d9903$var$BaseRecord, uint16);
var $47e0e8ef515d9903$var$ComponentRecord = new ArrayT(new Pointer(uint16, $47e0e8ef515d9903$var$Anchor), (t2) => t2.parent.parent.classCount);
var $47e0e8ef515d9903$var$LigatureAttach = new ArrayT($47e0e8ef515d9903$var$ComponentRecord, uint16);
var $47e0e8ef515d9903$var$LigatureArray = new ArrayT(new Pointer(uint16, $47e0e8ef515d9903$var$LigatureAttach), uint16);
var $47e0e8ef515d9903$export$73a8cfb19cd43a0f = new VersionedStruct("lookupType", {
  1: new VersionedStruct(uint16, {
    1: {
      coverage: new Pointer(uint16, (0, $7cbbe4e24ef3cb75$export$17608c3f81a6111)),
      valueFormat: $47e0e8ef515d9903$var$ValueFormat,
      value: new $47e0e8ef515d9903$var$ValueRecord()
    },
    2: {
      coverage: new Pointer(uint16, (0, $7cbbe4e24ef3cb75$export$17608c3f81a6111)),
      valueFormat: $47e0e8ef515d9903$var$ValueFormat,
      valueCount: uint16,
      values: new LazyArray(new $47e0e8ef515d9903$var$ValueRecord(), "valueCount")
    }
  }),
  2: new VersionedStruct(uint16, {
    1: {
      coverage: new Pointer(uint16, (0, $7cbbe4e24ef3cb75$export$17608c3f81a6111)),
      valueFormat1: $47e0e8ef515d9903$var$ValueFormat,
      valueFormat2: $47e0e8ef515d9903$var$ValueFormat,
      pairSetCount: uint16,
      pairSets: new LazyArray(new Pointer(uint16, $47e0e8ef515d9903$var$PairSet), "pairSetCount")
    },
    2: {
      coverage: new Pointer(uint16, (0, $7cbbe4e24ef3cb75$export$17608c3f81a6111)),
      valueFormat1: $47e0e8ef515d9903$var$ValueFormat,
      valueFormat2: $47e0e8ef515d9903$var$ValueFormat,
      classDef1: new Pointer(uint16, (0, $7cbbe4e24ef3cb75$export$843d551fbbafef71)),
      classDef2: new Pointer(uint16, (0, $7cbbe4e24ef3cb75$export$843d551fbbafef71)),
      class1Count: uint16,
      class2Count: uint16,
      classRecords: new LazyArray(new LazyArray($47e0e8ef515d9903$var$Class2Record, "class2Count"), "class1Count")
    }
  }),
  3: {
    format: uint16,
    coverage: new Pointer(uint16, (0, $7cbbe4e24ef3cb75$export$17608c3f81a6111)),
    entryExitCount: uint16,
    entryExitRecords: new ArrayT($47e0e8ef515d9903$var$EntryExitRecord, "entryExitCount")
  },
  4: {
    format: uint16,
    markCoverage: new Pointer(uint16, (0, $7cbbe4e24ef3cb75$export$17608c3f81a6111)),
    baseCoverage: new Pointer(uint16, (0, $7cbbe4e24ef3cb75$export$17608c3f81a6111)),
    classCount: uint16,
    markArray: new Pointer(uint16, $47e0e8ef515d9903$var$MarkArray),
    baseArray: new Pointer(uint16, $47e0e8ef515d9903$var$BaseArray)
  },
  5: {
    format: uint16,
    markCoverage: new Pointer(uint16, (0, $7cbbe4e24ef3cb75$export$17608c3f81a6111)),
    ligatureCoverage: new Pointer(uint16, (0, $7cbbe4e24ef3cb75$export$17608c3f81a6111)),
    classCount: uint16,
    markArray: new Pointer(uint16, $47e0e8ef515d9903$var$MarkArray),
    ligatureArray: new Pointer(uint16, $47e0e8ef515d9903$var$LigatureArray)
  },
  6: {
    format: uint16,
    mark1Coverage: new Pointer(uint16, (0, $7cbbe4e24ef3cb75$export$17608c3f81a6111)),
    mark2Coverage: new Pointer(uint16, (0, $7cbbe4e24ef3cb75$export$17608c3f81a6111)),
    classCount: uint16,
    mark1Array: new Pointer(uint16, $47e0e8ef515d9903$var$MarkArray),
    mark2Array: new Pointer(uint16, $47e0e8ef515d9903$var$BaseArray)
  },
  7: (0, $7cbbe4e24ef3cb75$export$841858b892ce1f4c),
  8: (0, $7cbbe4e24ef3cb75$export$5e6d09e6861162f6),
  9: {
    posFormat: uint16,
    lookupType: uint16,
    extension: new Pointer(uint32, null)
  }
});
$47e0e8ef515d9903$export$73a8cfb19cd43a0f.versions[9].extension.type = $47e0e8ef515d9903$export$73a8cfb19cd43a0f;
var $47e0e8ef515d9903$export$2e2bcd8739ae039 = new VersionedStruct(uint32, {
  header: {
    scriptList: new Pointer(uint16, (0, $7cbbe4e24ef3cb75$export$3e15fc05ce864229)),
    featureList: new Pointer(uint16, (0, $7cbbe4e24ef3cb75$export$aa18130def4b6cb4)),
    lookupList: new Pointer(uint16, new (0, $7cbbe4e24ef3cb75$export$df0008c6ff2da22a)($47e0e8ef515d9903$export$73a8cfb19cd43a0f))
  },
  65536: {},
  65537: {
    featureVariations: new Pointer(uint32, (0, $1a47b0c45c1c22fe$export$441b70b7971dd419))
  }
});
var $d3f442064af66e06$var$Sequence = new ArrayT(uint16, uint16);
var $d3f442064af66e06$var$AlternateSet = $d3f442064af66e06$var$Sequence;
var $d3f442064af66e06$var$Ligature = new Struct({
  glyph: uint16,
  compCount: uint16,
  components: new ArrayT(uint16, (t2) => t2.compCount - 1)
});
var $d3f442064af66e06$var$LigatureSet = new ArrayT(new Pointer(uint16, $d3f442064af66e06$var$Ligature), uint16);
var $d3f442064af66e06$var$GSUBLookup = new VersionedStruct("lookupType", {
  1: new VersionedStruct(uint16, {
    1: {
      coverage: new Pointer(uint16, (0, $7cbbe4e24ef3cb75$export$17608c3f81a6111)),
      deltaGlyphID: int16
    },
    2: {
      coverage: new Pointer(uint16, (0, $7cbbe4e24ef3cb75$export$17608c3f81a6111)),
      glyphCount: uint16,
      substitute: new LazyArray(uint16, "glyphCount")
    }
  }),
  2: {
    substFormat: uint16,
    coverage: new Pointer(uint16, (0, $7cbbe4e24ef3cb75$export$17608c3f81a6111)),
    count: uint16,
    sequences: new LazyArray(new Pointer(uint16, $d3f442064af66e06$var$Sequence), "count")
  },
  3: {
    substFormat: uint16,
    coverage: new Pointer(uint16, (0, $7cbbe4e24ef3cb75$export$17608c3f81a6111)),
    count: uint16,
    alternateSet: new LazyArray(new Pointer(uint16, $d3f442064af66e06$var$AlternateSet), "count")
  },
  4: {
    substFormat: uint16,
    coverage: new Pointer(uint16, (0, $7cbbe4e24ef3cb75$export$17608c3f81a6111)),
    count: uint16,
    ligatureSets: new LazyArray(new Pointer(uint16, $d3f442064af66e06$var$LigatureSet), "count")
  },
  5: (0, $7cbbe4e24ef3cb75$export$841858b892ce1f4c),
  6: (0, $7cbbe4e24ef3cb75$export$5e6d09e6861162f6),
  7: {
    substFormat: uint16,
    lookupType: uint16,
    extension: new Pointer(uint32, null)
  },
  8: {
    substFormat: uint16,
    coverage: new Pointer(uint16, (0, $7cbbe4e24ef3cb75$export$17608c3f81a6111)),
    backtrackCoverage: new ArrayT(new Pointer(uint16, (0, $7cbbe4e24ef3cb75$export$17608c3f81a6111)), "backtrackGlyphCount"),
    lookaheadGlyphCount: uint16,
    lookaheadCoverage: new ArrayT(new Pointer(uint16, (0, $7cbbe4e24ef3cb75$export$17608c3f81a6111)), "lookaheadGlyphCount"),
    glyphCount: uint16,
    substitutes: new ArrayT(uint16, "glyphCount")
  }
});
$d3f442064af66e06$var$GSUBLookup.versions[7].extension.type = $d3f442064af66e06$var$GSUBLookup;
var $d3f442064af66e06$export$2e2bcd8739ae039 = new VersionedStruct(uint32, {
  header: {
    scriptList: new Pointer(uint16, (0, $7cbbe4e24ef3cb75$export$3e15fc05ce864229)),
    featureList: new Pointer(uint16, (0, $7cbbe4e24ef3cb75$export$aa18130def4b6cb4)),
    lookupList: new Pointer(uint16, new (0, $7cbbe4e24ef3cb75$export$df0008c6ff2da22a)($d3f442064af66e06$var$GSUBLookup))
  },
  65536: {},
  65537: {
    featureVariations: new Pointer(uint32, (0, $1a47b0c45c1c22fe$export$441b70b7971dd419))
  }
});
var $71cfb3c4767fbd0c$var$JstfGSUBModList = new ArrayT(uint16, uint16);
var $71cfb3c4767fbd0c$var$JstfPriority = new Struct({
  shrinkageEnableGSUB: new Pointer(uint16, $71cfb3c4767fbd0c$var$JstfGSUBModList),
  shrinkageDisableGSUB: new Pointer(uint16, $71cfb3c4767fbd0c$var$JstfGSUBModList),
  shrinkageEnableGPOS: new Pointer(uint16, $71cfb3c4767fbd0c$var$JstfGSUBModList),
  shrinkageDisableGPOS: new Pointer(uint16, $71cfb3c4767fbd0c$var$JstfGSUBModList),
  shrinkageJstfMax: new Pointer(uint16, new (0, $7cbbe4e24ef3cb75$export$df0008c6ff2da22a)((0, $47e0e8ef515d9903$export$73a8cfb19cd43a0f))),
  extensionEnableGSUB: new Pointer(uint16, $71cfb3c4767fbd0c$var$JstfGSUBModList),
  extensionDisableGSUB: new Pointer(uint16, $71cfb3c4767fbd0c$var$JstfGSUBModList),
  extensionEnableGPOS: new Pointer(uint16, $71cfb3c4767fbd0c$var$JstfGSUBModList),
  extensionDisableGPOS: new Pointer(uint16, $71cfb3c4767fbd0c$var$JstfGSUBModList),
  extensionJstfMax: new Pointer(uint16, new (0, $7cbbe4e24ef3cb75$export$df0008c6ff2da22a)((0, $47e0e8ef515d9903$export$73a8cfb19cd43a0f)))
});
var $71cfb3c4767fbd0c$var$JstfLangSys = new ArrayT(new Pointer(uint16, $71cfb3c4767fbd0c$var$JstfPriority), uint16);
var $71cfb3c4767fbd0c$var$JstfLangSysRecord = new Struct({
  tag: new StringT(4),
  jstfLangSys: new Pointer(uint16, $71cfb3c4767fbd0c$var$JstfLangSys)
});
var $71cfb3c4767fbd0c$var$JstfScript = new Struct({
  extenderGlyphs: new Pointer(uint16, new ArrayT(uint16, uint16)),
  defaultLangSys: new Pointer(uint16, $71cfb3c4767fbd0c$var$JstfLangSys),
  langSysCount: uint16,
  langSysRecords: new ArrayT($71cfb3c4767fbd0c$var$JstfLangSysRecord, "langSysCount")
});
var $71cfb3c4767fbd0c$var$JstfScriptRecord = new Struct({
  tag: new StringT(4),
  script: new Pointer(uint16, $71cfb3c4767fbd0c$var$JstfScript, {
    type: "parent"
  })
});
var $71cfb3c4767fbd0c$export$2e2bcd8739ae039 = new Struct({
  version: uint32,
  scriptCount: uint16,
  scriptList: new ArrayT($71cfb3c4767fbd0c$var$JstfScriptRecord, "scriptCount")
});
var $d059a6bd2d3b5b63$var$VariableSizeNumber = class {
  decode(stream, parent2) {
    switch (this.size(0, parent2)) {
      case 1:
        return stream.readUInt8();
      case 2:
        return stream.readUInt16BE();
      case 3:
        return stream.readUInt24BE();
      case 4:
        return stream.readUInt32BE();
    }
  }
  size(val, parent2) {
    return (0, resolveLength)(this._size, null, parent2);
  }
  constructor(size) {
    this._size = size;
  }
};
var $d059a6bd2d3b5b63$var$MapDataEntry = new Struct({
  entry: new $d059a6bd2d3b5b63$var$VariableSizeNumber((t2) => ((t2.parent.entryFormat & 48) >> 4) + 1),
  outerIndex: (t2) => t2.entry >> (t2.parent.entryFormat & 15) + 1,
  innerIndex: (t2) => t2.entry & (1 << (t2.parent.entryFormat & 15) + 1) - 1
});
var $d059a6bd2d3b5b63$var$DeltaSetIndexMap = new Struct({
  entryFormat: uint16,
  mapCount: uint16,
  mapData: new ArrayT($d059a6bd2d3b5b63$var$MapDataEntry, "mapCount")
});
var $d059a6bd2d3b5b63$export$2e2bcd8739ae039 = new Struct({
  majorVersion: uint16,
  minorVersion: uint16,
  itemVariationStore: new Pointer(uint32, (0, $1a47b0c45c1c22fe$export$fe1b122a2710f241)),
  advanceWidthMapping: new Pointer(uint32, $d059a6bd2d3b5b63$var$DeltaSetIndexMap),
  LSBMapping: new Pointer(uint32, $d059a6bd2d3b5b63$var$DeltaSetIndexMap),
  RSBMapping: new Pointer(uint32, $d059a6bd2d3b5b63$var$DeltaSetIndexMap)
});
var $dceeca3e1977ce30$var$Signature = new Struct({
  format: uint32,
  length: uint32,
  offset: uint32
});
var $dceeca3e1977ce30$var$SignatureBlock = new Struct({
  reserved: new Reserved(uint16, 2),
  cbSignature: uint32,
  signature: new BufferT("cbSignature")
});
var $dceeca3e1977ce30$export$2e2bcd8739ae039 = new Struct({
  ulVersion: uint32,
  usNumSigs: uint16,
  usFlag: uint16,
  signatures: new ArrayT($dceeca3e1977ce30$var$Signature, "usNumSigs"),
  signatureBlocks: new ArrayT($dceeca3e1977ce30$var$SignatureBlock, "usNumSigs")
});
var $8acd740a9435aad0$var$GaspRange = new Struct({
  rangeMaxPPEM: uint16,
  rangeGaspBehavior: new Bitfield(uint16, [
    "grayscale",
    "gridfit",
    "symmetricSmoothing",
    "symmetricGridfit"
    // only in version 1, for ClearType
  ])
});
var $8acd740a9435aad0$export$2e2bcd8739ae039 = new Struct({
  version: uint16,
  numRanges: uint16,
  gaspRanges: new ArrayT($8acd740a9435aad0$var$GaspRange, "numRanges")
  // Sorted by ppem
});
var $b5f380243c34d6a0$var$DeviceRecord = new Struct({
  pixelSize: uint8,
  maximumWidth: uint8,
  widths: new ArrayT(uint8, (t2) => t2.parent.parent.maxp.numGlyphs)
});
var $b5f380243c34d6a0$export$2e2bcd8739ae039 = new Struct({
  version: uint16,
  numRecords: int16,
  sizeDeviceRecord: int32,
  records: new ArrayT($b5f380243c34d6a0$var$DeviceRecord, "numRecords")
});
var $ca2df1256966e313$var$KernPair = new Struct({
  left: uint16,
  right: uint16,
  value: int16
});
var $ca2df1256966e313$var$ClassTable = new Struct({
  firstGlyph: uint16,
  nGlyphs: uint16,
  offsets: new ArrayT(uint16, "nGlyphs"),
  max: (t2) => t2.offsets.length && Math.max.apply(Math, t2.offsets)
});
var $ca2df1256966e313$var$Kern2Array = new Struct({
  off: (t2) => t2._startOffset - t2.parent.parent._startOffset,
  len: (t2) => ((t2.parent.leftTable.max - t2.off) / t2.parent.rowWidth + 1) * (t2.parent.rowWidth / 2),
  values: new LazyArray(int16, "len")
});
var $ca2df1256966e313$var$KernSubtable = new VersionedStruct("format", {
  0: {
    nPairs: uint16,
    searchRange: uint16,
    entrySelector: uint16,
    rangeShift: uint16,
    pairs: new ArrayT($ca2df1256966e313$var$KernPair, "nPairs")
  },
  2: {
    rowWidth: uint16,
    leftTable: new Pointer(uint16, $ca2df1256966e313$var$ClassTable, {
      type: "parent"
    }),
    rightTable: new Pointer(uint16, $ca2df1256966e313$var$ClassTable, {
      type: "parent"
    }),
    array: new Pointer(uint16, $ca2df1256966e313$var$Kern2Array, {
      type: "parent"
    })
  },
  3: {
    glyphCount: uint16,
    kernValueCount: uint8,
    leftClassCount: uint8,
    rightClassCount: uint8,
    flags: uint8,
    kernValue: new ArrayT(int16, "kernValueCount"),
    leftClass: new ArrayT(uint8, "glyphCount"),
    rightClass: new ArrayT(uint8, "glyphCount"),
    kernIndex: new ArrayT(uint8, (t2) => t2.leftClassCount * t2.rightClassCount)
  }
});
var $ca2df1256966e313$var$KernTable = new VersionedStruct("version", {
  0: {
    subVersion: uint16,
    length: uint16,
    format: uint8,
    coverage: new Bitfield(uint8, [
      "horizontal",
      "minimum",
      "crossStream",
      "override"
      // If set to 1 the value in this table replaces the accumulated value
    ]),
    subtable: $ca2df1256966e313$var$KernSubtable,
    padding: new Reserved(uint8, (t2) => t2.length - t2._currentOffset)
  },
  1: {
    length: uint32,
    coverage: new Bitfield(uint8, [
      null,
      null,
      null,
      null,
      null,
      "variation",
      "crossStream",
      "vertical"
      // Set if table has vertical kerning values
    ]),
    format: uint8,
    tupleIndex: uint16,
    subtable: $ca2df1256966e313$var$KernSubtable,
    padding: new Reserved(uint8, (t2) => t2.length - t2._currentOffset)
  }
});
var $ca2df1256966e313$export$2e2bcd8739ae039 = new VersionedStruct(uint16, {
  0: {
    nTables: uint16,
    tables: new ArrayT($ca2df1256966e313$var$KernTable, "nTables")
  },
  1: {
    reserved: new Reserved(uint16),
    nTables: uint32,
    tables: new ArrayT($ca2df1256966e313$var$KernTable, "nTables")
  }
});
var $7a9f92b0c46ebe33$export$2e2bcd8739ae039 = new Struct({
  version: uint16,
  numGlyphs: uint16,
  yPels: new ArrayT(uint8, "numGlyphs")
});
var $2b2ccc419d152631$export$2e2bcd8739ae039 = new Struct({
  version: uint16,
  fontNumber: uint32,
  pitch: uint16,
  xHeight: uint16,
  style: uint16,
  typeFamily: uint16,
  capHeight: uint16,
  symbolSet: uint16,
  typeface: new StringT(16),
  characterComplement: new StringT(8),
  fileName: new StringT(6),
  strokeWeight: new StringT(1),
  widthType: new StringT(1),
  serifStyle: uint8,
  reserved: new Reserved(uint8)
});
var $ca5b40b9bcda9c9b$var$Ratio = new Struct({
  bCharSet: uint8,
  xRatio: uint8,
  yStartRatio: uint8,
  yEndRatio: uint8
  // Ending y-Ratio value
});
var $ca5b40b9bcda9c9b$var$vTable = new Struct({
  yPelHeight: uint16,
  yMax: int16,
  yMin: int16
  // Minimum value (in pels) for this yPelHeight
});
var $ca5b40b9bcda9c9b$var$VdmxGroup = new Struct({
  recs: uint16,
  startsz: uint8,
  endsz: uint8,
  entries: new ArrayT($ca5b40b9bcda9c9b$var$vTable, "recs")
  // The VDMX records
});
var $ca5b40b9bcda9c9b$export$2e2bcd8739ae039 = new Struct({
  version: uint16,
  numRecs: uint16,
  numRatios: uint16,
  ratioRanges: new ArrayT($ca5b40b9bcda9c9b$var$Ratio, "numRatios"),
  offsets: new ArrayT(uint16, "numRatios"),
  groups: new ArrayT($ca5b40b9bcda9c9b$var$VdmxGroup, "numRecs")
  // The actual VDMX groupings
});
var $69530a3c40755af0$export$2e2bcd8739ae039 = new Struct({
  version: uint16,
  ascent: int16,
  descent: int16,
  lineGap: int16,
  advanceHeightMax: int16,
  minTopSideBearing: int16,
  minBottomSideBearing: int16,
  yMaxExtent: int16,
  caretSlopeRise: int16,
  caretSlopeRun: int16,
  caretOffset: int16,
  reserved: new Reserved(int16, 4),
  metricDataFormat: int16,
  numberOfMetrics: uint16
  // Number of advance heights in the Vertical Metrics table
});
var $344073dd270f0e62$var$VmtxEntry = new Struct({
  advance: uint16,
  bearing: int16
  // The top sidebearing of the glyph
});
var $344073dd270f0e62$export$2e2bcd8739ae039 = new Struct({
  metrics: new LazyArray($344073dd270f0e62$var$VmtxEntry, (t2) => t2.parent.vhea.numberOfMetrics),
  bearings: new LazyArray(int16, (t2) => t2.parent.maxp.numGlyphs - t2.parent.vhea.numberOfMetrics)
});
var $3793b781918cfced$var$shortFrac = new Fixed(16, "BE", 14);
var $3793b781918cfced$var$Correspondence = new Struct({
  fromCoord: $3793b781918cfced$var$shortFrac,
  toCoord: $3793b781918cfced$var$shortFrac
});
var $3793b781918cfced$var$Segment = new Struct({
  pairCount: uint16,
  correspondence: new ArrayT($3793b781918cfced$var$Correspondence, "pairCount")
});
var $3793b781918cfced$export$2e2bcd8739ae039 = new Struct({
  version: fixed32,
  axisCount: uint32,
  segment: new ArrayT($3793b781918cfced$var$Segment, "axisCount")
});
var $6cb7dd5f47d82580$var$UnboundedArrayAccessor = class {
  getItem(index3) {
    if (this._items[index3] == null) {
      let pos = this.stream.pos;
      this.stream.pos = this.base + this.type.size(null, this.parent) * index3;
      this._items[index3] = this.type.decode(this.stream, this.parent);
      this.stream.pos = pos;
    }
    return this._items[index3];
  }
  inspect() {
    return `[UnboundedArray ${this.type.constructor.name}]`;
  }
  constructor(type5, stream, parent2) {
    this.type = type5;
    this.stream = stream;
    this.parent = parent2;
    this.base = this.stream.pos;
    this._items = [];
  }
};
var $6cb7dd5f47d82580$export$c5af1eebc882e39a = class extends ArrayT {
  decode(stream, parent2) {
    return new $6cb7dd5f47d82580$var$UnboundedArrayAccessor(this.type, stream, parent2);
  }
  constructor(type5) {
    super(type5, 0);
  }
};
var $6cb7dd5f47d82580$export$8351f8c2ae2f103c = function(ValueType = uint16) {
  class Shadow {
    decode(stream, ctx) {
      ctx = ctx.parent.parent;
      return this.type.decode(stream, ctx);
    }
    size(val, ctx) {
      ctx = ctx.parent.parent;
      return this.type.size(val, ctx);
    }
    encode(stream, val, ctx) {
      ctx = ctx.parent.parent;
      return this.type.encode(stream, val, ctx);
    }
    constructor(type5) {
      this.type = type5;
    }
  }
  ValueType = new Shadow(ValueType);
  let BinarySearchHeader = new Struct({
    unitSize: uint16,
    nUnits: uint16,
    searchRange: uint16,
    entrySelector: uint16,
    rangeShift: uint16
  });
  let LookupSegmentSingle = new Struct({
    lastGlyph: uint16,
    firstGlyph: uint16,
    value: ValueType
  });
  let LookupSegmentArray = new Struct({
    lastGlyph: uint16,
    firstGlyph: uint16,
    values: new Pointer(uint16, new ArrayT(ValueType, (t2) => t2.lastGlyph - t2.firstGlyph + 1), {
      type: "parent"
    })
  });
  let LookupSingle = new Struct({
    glyph: uint16,
    value: ValueType
  });
  return new VersionedStruct(uint16, {
    0: {
      values: new $6cb7dd5f47d82580$export$c5af1eebc882e39a(ValueType)
      // length == number of glyphs maybe?
    },
    2: {
      binarySearchHeader: BinarySearchHeader,
      segments: new ArrayT(LookupSegmentSingle, (t2) => t2.binarySearchHeader.nUnits)
    },
    4: {
      binarySearchHeader: BinarySearchHeader,
      segments: new ArrayT(LookupSegmentArray, (t2) => t2.binarySearchHeader.nUnits)
    },
    6: {
      binarySearchHeader: BinarySearchHeader,
      segments: new ArrayT(LookupSingle, (t2) => t2.binarySearchHeader.nUnits)
    },
    8: {
      firstGlyph: uint16,
      count: uint16,
      values: new ArrayT(ValueType, "count")
    }
  });
};
function $6cb7dd5f47d82580$export$79f7d93d790934ba(entryData = {}, lookupType = uint16) {
  let entry = Object.assign({
    newState: uint16,
    flags: uint16
  }, entryData);
  let Entry = new Struct(entry);
  let StateArray = new $6cb7dd5f47d82580$export$c5af1eebc882e39a(new ArrayT(uint16, (t2) => t2.nClasses));
  let StateHeader = new Struct({
    nClasses: uint32,
    classTable: new Pointer(uint32, new $6cb7dd5f47d82580$export$8351f8c2ae2f103c(lookupType)),
    stateArray: new Pointer(uint32, StateArray),
    entryTable: new Pointer(uint32, new $6cb7dd5f47d82580$export$c5af1eebc882e39a(Entry))
  });
  return StateHeader;
}
function $6cb7dd5f47d82580$export$105027425199cc51(entryData = {}, lookupType = uint16) {
  let ClassLookupTable = new Struct({
    version() {
      return 8;
    },
    firstGlyph: uint16,
    values: new ArrayT(uint8, uint16)
  });
  let entry = Object.assign({
    newStateOffset: uint16,
    // convert offset to stateArray index
    newState: (t2) => (t2.newStateOffset - (t2.parent.stateArray.base - t2.parent._startOffset)) / t2.parent.nClasses,
    flags: uint16
  }, entryData);
  let Entry = new Struct(entry);
  let StateArray = new $6cb7dd5f47d82580$export$c5af1eebc882e39a(new ArrayT(uint8, (t2) => t2.nClasses));
  let StateHeader1 = new Struct({
    nClasses: uint16,
    classTable: new Pointer(uint16, ClassLookupTable),
    stateArray: new Pointer(uint16, StateArray),
    entryTable: new Pointer(uint16, new $6cb7dd5f47d82580$export$c5af1eebc882e39a(Entry))
  });
  return StateHeader1;
}
var $6a3746e8c708f5a3$var$BslnSubtable = new VersionedStruct("format", {
  0: {
    deltas: new ArrayT(int16, 32)
  },
  1: {
    deltas: new ArrayT(int16, 32),
    mappingData: new (0, $6cb7dd5f47d82580$export$8351f8c2ae2f103c)(uint16)
  },
  2: {
    standardGlyph: uint16,
    controlPoints: new ArrayT(uint16, 32)
  },
  3: {
    standardGlyph: uint16,
    controlPoints: new ArrayT(uint16, 32),
    mappingData: new (0, $6cb7dd5f47d82580$export$8351f8c2ae2f103c)(uint16)
  }
});
var $6a3746e8c708f5a3$export$2e2bcd8739ae039 = new Struct({
  version: fixed32,
  format: uint16,
  defaultBaseline: uint16,
  subtable: $6a3746e8c708f5a3$var$BslnSubtable
});
var $d0c76fac617b308a$var$Setting = new Struct({
  setting: uint16,
  nameIndex: int16,
  name: (t2) => t2.parent.parent.parent.name.records.fontFeatures[t2.nameIndex]
});
var $d0c76fac617b308a$var$FeatureName = new Struct({
  feature: uint16,
  nSettings: uint16,
  settingTable: new Pointer(uint32, new ArrayT($d0c76fac617b308a$var$Setting, "nSettings"), {
    type: "parent"
  }),
  featureFlags: new Bitfield(uint8, [
    null,
    null,
    null,
    null,
    null,
    null,
    "hasDefault",
    "exclusive"
  ]),
  defaultSetting: uint8,
  nameIndex: int16,
  name: (t2) => t2.parent.parent.name.records.fontFeatures[t2.nameIndex]
});
var $d0c76fac617b308a$export$2e2bcd8739ae039 = new Struct({
  version: fixed32,
  featureNameCount: uint16,
  reserved1: new Reserved(uint16),
  reserved2: new Reserved(uint32),
  featureNames: new ArrayT($d0c76fac617b308a$var$FeatureName, "featureNameCount")
});
var $e83fd065f00fcd01$var$Axis = new Struct({
  axisTag: new StringT(4),
  minValue: fixed32,
  defaultValue: fixed32,
  maxValue: fixed32,
  flags: uint16,
  nameID: uint16,
  name: (t2) => t2.parent.parent.name.records.fontFeatures[t2.nameID]
});
var $e83fd065f00fcd01$var$Instance = new Struct({
  nameID: uint16,
  name: (t2) => t2.parent.parent.name.records.fontFeatures[t2.nameID],
  flags: uint16,
  coord: new ArrayT(fixed32, (t2) => t2.parent.axisCount),
  postscriptNameID: new Optional(uint16, (t2) => t2.parent.instanceSize - t2._currentOffset > 0)
});
var $e83fd065f00fcd01$export$2e2bcd8739ae039 = new Struct({
  version: fixed32,
  offsetToData: uint16,
  countSizePairs: uint16,
  axisCount: uint16,
  axisSize: uint16,
  instanceCount: uint16,
  instanceSize: uint16,
  axis: new ArrayT($e83fd065f00fcd01$var$Axis, "axisCount"),
  instance: new ArrayT($e83fd065f00fcd01$var$Instance, "instanceCount")
});
var $dbe33c8d3a7f131c$var$shortFrac = new Fixed(16, "BE", 14);
var $dbe33c8d3a7f131c$var$Offset = class {
  static decode(stream, parent2) {
    return parent2.flags ? stream.readUInt32BE() : stream.readUInt16BE() * 2;
  }
};
var $dbe33c8d3a7f131c$var$gvar = new Struct({
  version: uint16,
  reserved: new Reserved(uint16),
  axisCount: uint16,
  globalCoordCount: uint16,
  globalCoords: new Pointer(uint32, new ArrayT(new ArrayT($dbe33c8d3a7f131c$var$shortFrac, "axisCount"), "globalCoordCount")),
  glyphCount: uint16,
  flags: uint16,
  offsetToData: uint32,
  offsets: new ArrayT(new Pointer($dbe33c8d3a7f131c$var$Offset, "void", {
    relativeTo: (ctx) => ctx.offsetToData,
    allowNull: false
  }), (t2) => t2.glyphCount + 1)
});
var $dbe33c8d3a7f131c$export$2e2bcd8739ae039 = $dbe33c8d3a7f131c$var$gvar;
var $05b01887df96c4ee$var$ClassTable = new Struct({
  length: uint16,
  coverage: uint16,
  subFeatureFlags: uint32,
  stateTable: new (0, $6cb7dd5f47d82580$export$105027425199cc51)()
});
var $05b01887df96c4ee$var$WidthDeltaRecord = new Struct({
  justClass: uint32,
  beforeGrowLimit: fixed32,
  beforeShrinkLimit: fixed32,
  afterGrowLimit: fixed32,
  afterShrinkLimit: fixed32,
  growFlags: uint16,
  shrinkFlags: uint16
});
var $05b01887df96c4ee$var$WidthDeltaCluster = new ArrayT($05b01887df96c4ee$var$WidthDeltaRecord, uint32);
var $05b01887df96c4ee$var$ActionData = new VersionedStruct("actionType", {
  0: {
    lowerLimit: fixed32,
    upperLimit: fixed32,
    order: uint16,
    glyphs: new ArrayT(uint16, uint16)
  },
  1: {
    addGlyph: uint16
  },
  2: {
    substThreshold: fixed32,
    addGlyph: uint16,
    substGlyph: uint16
  },
  3: {},
  4: {
    variationAxis: uint32,
    minimumLimit: fixed32,
    noStretchValue: fixed32,
    maximumLimit: fixed32
  },
  5: {
    flags: uint16,
    glyph: uint16
  }
});
var $05b01887df96c4ee$var$Action = new Struct({
  actionClass: uint16,
  actionType: uint16,
  actionLength: uint32,
  actionData: $05b01887df96c4ee$var$ActionData,
  padding: new Reserved(uint8, (t2) => t2.actionLength - t2._currentOffset)
});
var $05b01887df96c4ee$var$PostcompensationAction = new ArrayT($05b01887df96c4ee$var$Action, uint32);
var $05b01887df96c4ee$var$PostCompensationTable = new Struct({
  lookupTable: new (0, $6cb7dd5f47d82580$export$8351f8c2ae2f103c)(new Pointer(uint16, $05b01887df96c4ee$var$PostcompensationAction))
});
var $05b01887df96c4ee$var$JustificationTable = new Struct({
  classTable: new Pointer(uint16, $05b01887df96c4ee$var$ClassTable, {
    type: "parent"
  }),
  wdcOffset: uint16,
  postCompensationTable: new Pointer(uint16, $05b01887df96c4ee$var$PostCompensationTable, {
    type: "parent"
  }),
  widthDeltaClusters: new (0, $6cb7dd5f47d82580$export$8351f8c2ae2f103c)(new Pointer(uint16, $05b01887df96c4ee$var$WidthDeltaCluster, {
    type: "parent",
    relativeTo: (ctx) => ctx.wdcOffset
  }))
});
var $05b01887df96c4ee$export$2e2bcd8739ae039 = new Struct({
  version: uint32,
  format: uint16,
  horizontal: new Pointer(uint16, $05b01887df96c4ee$var$JustificationTable),
  vertical: new Pointer(uint16, $05b01887df96c4ee$var$JustificationTable)
});
var $03ee6ebd54db1053$var$LigatureData = {
  action: uint16
};
var $03ee6ebd54db1053$var$ContextualData = {
  markIndex: uint16,
  currentIndex: uint16
};
var $03ee6ebd54db1053$var$InsertionData = {
  currentInsertIndex: uint16,
  markedInsertIndex: uint16
};
var $03ee6ebd54db1053$var$SubstitutionTable = new Struct({
  items: new (0, $6cb7dd5f47d82580$export$c5af1eebc882e39a)(new Pointer(uint32, new (0, $6cb7dd5f47d82580$export$8351f8c2ae2f103c)()))
});
var $03ee6ebd54db1053$var$SubtableData = new VersionedStruct("type", {
  0: {
    stateTable: new (0, $6cb7dd5f47d82580$export$79f7d93d790934ba)()
  },
  1: {
    stateTable: new (0, $6cb7dd5f47d82580$export$79f7d93d790934ba)($03ee6ebd54db1053$var$ContextualData),
    substitutionTable: new Pointer(uint32, $03ee6ebd54db1053$var$SubstitutionTable)
  },
  2: {
    stateTable: new (0, $6cb7dd5f47d82580$export$79f7d93d790934ba)($03ee6ebd54db1053$var$LigatureData),
    ligatureActions: new Pointer(uint32, new (0, $6cb7dd5f47d82580$export$c5af1eebc882e39a)(uint32)),
    components: new Pointer(uint32, new (0, $6cb7dd5f47d82580$export$c5af1eebc882e39a)(uint16)),
    ligatureList: new Pointer(uint32, new (0, $6cb7dd5f47d82580$export$c5af1eebc882e39a)(uint16))
  },
  4: {
    lookupTable: new (0, $6cb7dd5f47d82580$export$8351f8c2ae2f103c)()
  },
  5: {
    stateTable: new (0, $6cb7dd5f47d82580$export$79f7d93d790934ba)($03ee6ebd54db1053$var$InsertionData),
    insertionActions: new Pointer(uint32, new (0, $6cb7dd5f47d82580$export$c5af1eebc882e39a)(uint16))
  }
});
var $03ee6ebd54db1053$var$Subtable = new Struct({
  length: uint32,
  coverage: uint24,
  type: uint8,
  subFeatureFlags: uint32,
  table: $03ee6ebd54db1053$var$SubtableData,
  padding: new Reserved(uint8, (t2) => t2.length - t2._currentOffset)
});
var $03ee6ebd54db1053$var$FeatureEntry = new Struct({
  featureType: uint16,
  featureSetting: uint16,
  enableFlags: uint32,
  disableFlags: uint32
});
var $03ee6ebd54db1053$var$MorxChain = new Struct({
  defaultFlags: uint32,
  chainLength: uint32,
  nFeatureEntries: uint32,
  nSubtables: uint32,
  features: new ArrayT($03ee6ebd54db1053$var$FeatureEntry, "nFeatureEntries"),
  subtables: new ArrayT($03ee6ebd54db1053$var$Subtable, "nSubtables")
});
var $03ee6ebd54db1053$export$2e2bcd8739ae039 = new Struct({
  version: uint16,
  unused: new Reserved(uint16),
  nChains: uint32,
  chains: new ArrayT($03ee6ebd54db1053$var$MorxChain, "nChains")
});
var $b7492a80b0d1a056$var$OpticalBounds = new Struct({
  left: int16,
  top: int16,
  right: int16,
  bottom: int16
});
var $b7492a80b0d1a056$export$2e2bcd8739ae039 = new Struct({
  version: fixed32,
  format: uint16,
  lookupTable: new (0, $6cb7dd5f47d82580$export$8351f8c2ae2f103c)($b7492a80b0d1a056$var$OpticalBounds)
});
var $c3395722bea751e2$var$tables = {};
var $c3395722bea751e2$export$2e2bcd8739ae039 = $c3395722bea751e2$var$tables;
$c3395722bea751e2$var$tables.cmap = (0, $26a62205ad06574e$export$2e2bcd8739ae039);
$c3395722bea751e2$var$tables.head = (0, $f2612a29f92ac062$export$2e2bcd8739ae039);
$c3395722bea751e2$var$tables.hhea = (0, $2c179dd593583073$export$2e2bcd8739ae039);
$c3395722bea751e2$var$tables.hmtx = (0, $bdc9060542264b85$export$2e2bcd8739ae039);
$c3395722bea751e2$var$tables.maxp = (0, $dbf51cb3d3fe409d$export$2e2bcd8739ae039);
$c3395722bea751e2$var$tables.name = (0, $2bcf221753ec8e32$export$2e2bcd8739ae039);
$c3395722bea751e2$var$tables["OS/2"] = (0, $84b272aa31b70606$export$2e2bcd8739ae039);
$c3395722bea751e2$var$tables.post = (0, $32d9e2eb9565d93c$export$2e2bcd8739ae039);
$c3395722bea751e2$var$tables.fpgm = (0, $5c0f37ca5ffb1850$export$2e2bcd8739ae039);
$c3395722bea751e2$var$tables.loca = (0, $2b2b260902b1c57e$export$2e2bcd8739ae039);
$c3395722bea751e2$var$tables.prep = (0, $7afb878c7bea4f66$export$2e2bcd8739ae039);
$c3395722bea751e2$var$tables["cvt "] = (0, $5202bd9d9ad8eaac$export$2e2bcd8739ae039);
$c3395722bea751e2$var$tables.glyf = (0, $6c92b6371bce8bd9$export$2e2bcd8739ae039);
$c3395722bea751e2$var$tables["CFF "] = (0, $822ac0d589e4e237$export$2e2bcd8739ae039);
$c3395722bea751e2$var$tables["CFF2"] = (0, $822ac0d589e4e237$export$2e2bcd8739ae039);
$c3395722bea751e2$var$tables.VORG = (0, $2bbf2bc1ce37cd8f$export$2e2bcd8739ae039);
$c3395722bea751e2$var$tables.EBLC = (0, $9911c4c7201c13de$export$2e2bcd8739ae039);
$c3395722bea751e2$var$tables.CBLC = $c3395722bea751e2$var$tables.EBLC;
$c3395722bea751e2$var$tables.sbix = (0, $abb847051efd51b1$export$2e2bcd8739ae039);
$c3395722bea751e2$var$tables.COLR = (0, $eb629188f3dfefdd$export$2e2bcd8739ae039);
$c3395722bea751e2$var$tables.CPAL = (0, $08734b8e7dc64587$export$2e2bcd8739ae039);
$c3395722bea751e2$var$tables.BASE = (0, $497cef411d884e34$export$2e2bcd8739ae039);
$c3395722bea751e2$var$tables.GDEF = (0, $cf5f33c63ef209e6$export$2e2bcd8739ae039);
$c3395722bea751e2$var$tables.GPOS = (0, $47e0e8ef515d9903$export$2e2bcd8739ae039);
$c3395722bea751e2$var$tables.GSUB = (0, $d3f442064af66e06$export$2e2bcd8739ae039);
$c3395722bea751e2$var$tables.JSTF = (0, $71cfb3c4767fbd0c$export$2e2bcd8739ae039);
$c3395722bea751e2$var$tables.HVAR = (0, $d059a6bd2d3b5b63$export$2e2bcd8739ae039);
$c3395722bea751e2$var$tables.DSIG = (0, $dceeca3e1977ce30$export$2e2bcd8739ae039);
$c3395722bea751e2$var$tables.gasp = (0, $8acd740a9435aad0$export$2e2bcd8739ae039);
$c3395722bea751e2$var$tables.hdmx = (0, $b5f380243c34d6a0$export$2e2bcd8739ae039);
$c3395722bea751e2$var$tables.kern = (0, $ca2df1256966e313$export$2e2bcd8739ae039);
$c3395722bea751e2$var$tables.LTSH = (0, $7a9f92b0c46ebe33$export$2e2bcd8739ae039);
$c3395722bea751e2$var$tables.PCLT = (0, $2b2ccc419d152631$export$2e2bcd8739ae039);
$c3395722bea751e2$var$tables.VDMX = (0, $ca5b40b9bcda9c9b$export$2e2bcd8739ae039);
$c3395722bea751e2$var$tables.vhea = (0, $69530a3c40755af0$export$2e2bcd8739ae039);
$c3395722bea751e2$var$tables.vmtx = (0, $344073dd270f0e62$export$2e2bcd8739ae039);
$c3395722bea751e2$var$tables.avar = (0, $3793b781918cfced$export$2e2bcd8739ae039);
$c3395722bea751e2$var$tables.bsln = (0, $6a3746e8c708f5a3$export$2e2bcd8739ae039);
$c3395722bea751e2$var$tables.feat = (0, $d0c76fac617b308a$export$2e2bcd8739ae039);
$c3395722bea751e2$var$tables.fvar = (0, $e83fd065f00fcd01$export$2e2bcd8739ae039);
$c3395722bea751e2$var$tables.gvar = (0, $dbe33c8d3a7f131c$export$2e2bcd8739ae039);
$c3395722bea751e2$var$tables.just = (0, $05b01887df96c4ee$export$2e2bcd8739ae039);
$c3395722bea751e2$var$tables.morx = (0, $03ee6ebd54db1053$export$2e2bcd8739ae039);
$c3395722bea751e2$var$tables.opbd = (0, $b7492a80b0d1a056$export$2e2bcd8739ae039);
var $816c07a04b6dba87$var$TableEntry = new Struct({
  tag: new StringT(4),
  checkSum: uint32,
  offset: new Pointer(uint32, "void", {
    type: "global"
  }),
  length: uint32
});
var $816c07a04b6dba87$var$Directory = new Struct({
  tag: new StringT(4),
  numTables: uint16,
  searchRange: uint16,
  entrySelector: uint16,
  rangeShift: uint16,
  tables: new ArrayT($816c07a04b6dba87$var$TableEntry, "numTables")
});
$816c07a04b6dba87$var$Directory.process = function() {
  let tables = {};
  for (let table of this.tables) tables[table.tag] = table;
  this.tables = tables;
};
$816c07a04b6dba87$var$Directory.preEncode = function() {
  if (!Array.isArray(this.tables)) {
    let tables = [];
    for (let tag in this.tables) {
      let table = this.tables[tag];
      if (table) tables.push({
        tag,
        checkSum: 0,
        offset: new VoidPointer((0, $c3395722bea751e2$export$2e2bcd8739ae039)[tag], table),
        length: (0, $c3395722bea751e2$export$2e2bcd8739ae039)[tag].size(table)
      });
    }
    this.tables = tables;
  }
  this.tag = "true";
  this.numTables = this.tables.length;
  let maxExponentFor2 = Math.floor(Math.log(this.numTables) / Math.LN2);
  let maxPowerOf2 = Math.pow(2, maxExponentFor2);
  this.searchRange = maxPowerOf2 * 16;
  this.entrySelector = Math.log(maxPowerOf2) / Math.LN2;
  this.rangeShift = this.numTables * 16 - this.searchRange;
};
var $816c07a04b6dba87$export$2e2bcd8739ae039 = $816c07a04b6dba87$var$Directory;
function $12727730ddfc8bfe$export$2e0ae67339d5f1ac(arr, cmp) {
  let min = 0;
  let max = arr.length - 1;
  while (min <= max) {
    let mid = min + max >> 1;
    let res = cmp(arr[mid]);
    if (res < 0) max = mid - 1;
    else if (res > 0) min = mid + 1;
    else return mid;
  }
  return -1;
}
function $12727730ddfc8bfe$export$d02631cccf789723(index3, end) {
  let range3 = [];
  while (index3 < end) range3.push(index3++);
  return range3;
}
var $12727730ddfc8bfe$export$3d28c1996ced1f14 = new TextDecoder("ascii");
var $12727730ddfc8bfe$var$CHARS = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
var $12727730ddfc8bfe$var$LOOKUP = new Uint8Array(256);
for (let i = 0; i < $12727730ddfc8bfe$var$CHARS.length; i++) $12727730ddfc8bfe$var$LOOKUP[$12727730ddfc8bfe$var$CHARS.charCodeAt(i)] = i;
function $12727730ddfc8bfe$export$94fdf11bafc8de6b(base64) {
  let bufferLength = base64.length * 0.75;
  if (base64[base64.length - 1] === "=") {
    bufferLength--;
    if (base64[base64.length - 2] === "=") bufferLength--;
  }
  let bytes = new Uint8Array(bufferLength);
  let p = 0;
  for (let i = 0, len = base64.length; i < len; i += 4) {
    let encoded1 = $12727730ddfc8bfe$var$LOOKUP[base64.charCodeAt(i)];
    let encoded2 = $12727730ddfc8bfe$var$LOOKUP[base64.charCodeAt(i + 1)];
    let encoded3 = $12727730ddfc8bfe$var$LOOKUP[base64.charCodeAt(i + 2)];
    let encoded4 = $12727730ddfc8bfe$var$LOOKUP[base64.charCodeAt(i + 3)];
    bytes[p++] = encoded1 << 2 | encoded2 >> 4;
    bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
    bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
  }
  return bytes;
}
var $f08dd41ef10b694c$export$2e2bcd8739ae039 = class {
  findSubtable(cmapTable, pairs) {
    for (let [platformID, encodingID] of pairs) for (let cmap of cmapTable.tables) {
      if (cmap.platformID === platformID && cmap.encodingID === encodingID) return cmap.table;
    }
    return null;
  }
  lookup(codepoint, variationSelector) {
    if (this.encoding) codepoint = this.encoding.get(codepoint) || codepoint;
    else if (variationSelector) {
      let gid = this.getVariationSelector(codepoint, variationSelector);
      if (gid) return gid;
    }
    let cmap = this.cmap;
    switch (cmap.version) {
      case 0:
        return cmap.codeMap.get(codepoint) || 0;
      case 4: {
        let min = 0;
        let max = cmap.segCount - 1;
        while (min <= max) {
          let mid = min + max >> 1;
          if (codepoint < cmap.startCode.get(mid)) max = mid - 1;
          else if (codepoint > cmap.endCode.get(mid)) min = mid + 1;
          else {
            let rangeOffset = cmap.idRangeOffset.get(mid);
            let gid;
            if (rangeOffset === 0) gid = codepoint + cmap.idDelta.get(mid);
            else {
              let index3 = rangeOffset / 2 + (codepoint - cmap.startCode.get(mid)) - (cmap.segCount - mid);
              gid = cmap.glyphIndexArray.get(index3) || 0;
              if (gid !== 0) gid += cmap.idDelta.get(mid);
            }
            return gid & 65535;
          }
        }
        return 0;
      }
      case 8:
        throw new Error("TODO: cmap format 8");
      case 6:
      case 10:
        return cmap.glyphIndices.get(codepoint - cmap.firstCode) || 0;
      case 12:
      case 13: {
        let min = 0;
        let max = cmap.nGroups - 1;
        while (min <= max) {
          let mid = min + max >> 1;
          let group = cmap.groups.get(mid);
          if (codepoint < group.startCharCode) max = mid - 1;
          else if (codepoint > group.endCharCode) min = mid + 1;
          else {
            if (cmap.version === 12) return group.glyphID + (codepoint - group.startCharCode);
            else return group.glyphID;
          }
        }
        return 0;
      }
      case 14:
        throw new Error("TODO: cmap format 14");
      default:
        throw new Error(`Unknown cmap format ${cmap.version}`);
    }
  }
  getVariationSelector(codepoint, variationSelector) {
    if (!this.uvs) return 0;
    let selectors = this.uvs.varSelectors.toArray();
    let i = (0, $12727730ddfc8bfe$export$2e0ae67339d5f1ac)(selectors, (x) => variationSelector - x.varSelector);
    let sel = selectors[i];
    if (i !== -1 && sel.defaultUVS) i = (0, $12727730ddfc8bfe$export$2e0ae67339d5f1ac)(sel.defaultUVS, (x) => codepoint < x.startUnicodeValue ? -1 : codepoint > x.startUnicodeValue + x.additionalCount ? 1 : 0);
    if (i !== -1 && sel.nonDefaultUVS) {
      i = (0, $12727730ddfc8bfe$export$2e0ae67339d5f1ac)(sel.nonDefaultUVS, (x) => codepoint - x.unicodeValue);
      if (i !== -1) return sel.nonDefaultUVS[i].glyphID;
    }
    return 0;
  }
  getCharacterSet() {
    let cmap = this.cmap;
    switch (cmap.version) {
      case 0:
        return (0, $12727730ddfc8bfe$export$d02631cccf789723)(0, cmap.codeMap.length);
      case 4: {
        let res = [];
        let endCodes = cmap.endCode.toArray();
        for (let i = 0; i < endCodes.length; i++) {
          let tail = endCodes[i] + 1;
          let start = cmap.startCode.get(i);
          res.push(...(0, $12727730ddfc8bfe$export$d02631cccf789723)(start, tail));
        }
        return res;
      }
      case 8:
        throw new Error("TODO: cmap format 8");
      case 6:
      case 10:
        return (0, $12727730ddfc8bfe$export$d02631cccf789723)(cmap.firstCode, cmap.firstCode + cmap.glyphIndices.length);
      case 12:
      case 13: {
        let res = [];
        for (let group of cmap.groups.toArray()) res.push(...(0, $12727730ddfc8bfe$export$d02631cccf789723)(group.startCharCode, group.endCharCode + 1));
        return res;
      }
      case 14:
        throw new Error("TODO: cmap format 14");
      default:
        throw new Error(`Unknown cmap format ${cmap.version}`);
    }
  }
  codePointsForGlyph(gid) {
    let cmap = this.cmap;
    switch (cmap.version) {
      case 0: {
        let res = [];
        for (let i = 0; i < 256; i++) if (cmap.codeMap.get(i) === gid) res.push(i);
        return res;
      }
      case 4: {
        let res = [];
        for (let i = 0; i < cmap.segCount; i++) {
          let end = cmap.endCode.get(i);
          let start = cmap.startCode.get(i);
          let rangeOffset = cmap.idRangeOffset.get(i);
          let delta = cmap.idDelta.get(i);
          for (var c = start; c <= end; c++) {
            let g = 0;
            if (rangeOffset === 0) g = c + delta;
            else {
              let index3 = rangeOffset / 2 + (c - start) - (cmap.segCount - i);
              g = cmap.glyphIndexArray.get(index3) || 0;
              if (g !== 0) g += delta;
            }
            if (g === gid) res.push(c);
          }
        }
        return res;
      }
      case 12: {
        let res = [];
        for (let group of cmap.groups.toArray()) if (gid >= group.glyphID && gid <= group.glyphID + (group.endCharCode - group.startCharCode)) res.push(group.startCharCode + (gid - group.glyphID));
        return res;
      }
      case 13: {
        let res = [];
        for (let group of cmap.groups.toArray()) if (gid === group.glyphID) res.push(...(0, $12727730ddfc8bfe$export$d02631cccf789723)(group.startCharCode, group.endCharCode + 1));
        return res;
      }
      default:
        throw new Error(`Unknown cmap format ${cmap.version}`);
    }
  }
  constructor(cmapTable) {
    this.encoding = null;
    this.cmap = this.findSubtable(cmapTable, [
      // 32-bit subtables
      [
        3,
        10
      ],
      [
        0,
        6
      ],
      [
        0,
        4
      ],
      // 16-bit subtables
      [
        3,
        1
      ],
      [
        0,
        3
      ],
      [
        0,
        2
      ],
      [
        0,
        1
      ],
      [
        0,
        0
      ]
    ]);
    if (!this.cmap) for (let cmap of cmapTable.tables) {
      let encoding = (0, $e449ad78d50845fe$export$badc544e0651b6b1)(cmap.platformID, cmap.encodingID, cmap.table.language - 1);
      let mapping2 = (0, $e449ad78d50845fe$export$1dceb3c14ed68bee)(encoding);
      if (mapping2) {
        this.cmap = cmap.table;
        this.encoding = mapping2;
      }
    }
    if (!this.cmap) throw new Error("Could not find a supported cmap table");
    this.uvs = this.findSubtable(cmapTable, [
      [
        0,
        5
      ]
    ]);
    if (this.uvs && this.uvs.version !== 14) this.uvs = null;
  }
};
(0, __decorate)([
  (0, $e71565f2ce09cb6b$export$69a3209f1a06c04d)
], $f08dd41ef10b694c$export$2e2bcd8739ae039.prototype, "getCharacterSet", null);
(0, __decorate)([
  (0, $e71565f2ce09cb6b$export$69a3209f1a06c04d)
], $f08dd41ef10b694c$export$2e2bcd8739ae039.prototype, "codePointsForGlyph", null);
var $0bba3a9db57637f3$export$2e2bcd8739ae039 = class {
  process(glyphs, positions) {
    for (let glyphIndex = 0; glyphIndex < glyphs.length - 1; glyphIndex++) {
      let left2 = glyphs[glyphIndex].id;
      let right2 = glyphs[glyphIndex + 1].id;
      positions[glyphIndex].xAdvance += this.getKerning(left2, right2);
    }
  }
  getKerning(left2, right2) {
    let res = 0;
    for (let table of this.kern.tables) {
      if (table.coverage.crossStream) continue;
      switch (table.version) {
        case 0:
          if (!table.coverage.horizontal) continue;
          break;
        case 1:
          if (table.coverage.vertical || table.coverage.variation) continue;
          break;
        default:
          throw new Error(`Unsupported kerning table version ${table.version}`);
      }
      let val = 0;
      let s = table.subtable;
      switch (table.format) {
        case 0:
          let pairIdx = (0, $12727730ddfc8bfe$export$2e0ae67339d5f1ac)(s.pairs, function(pair) {
            return left2 - pair.left || right2 - pair.right;
          });
          if (pairIdx >= 0) val = s.pairs[pairIdx].value;
          break;
        case 2:
          let leftOffset = 0, rightOffset = 0;
          if (left2 >= s.leftTable.firstGlyph && left2 < s.leftTable.firstGlyph + s.leftTable.nGlyphs) leftOffset = s.leftTable.offsets[left2 - s.leftTable.firstGlyph];
          else leftOffset = s.array.off;
          if (right2 >= s.rightTable.firstGlyph && right2 < s.rightTable.firstGlyph + s.rightTable.nGlyphs) rightOffset = s.rightTable.offsets[right2 - s.rightTable.firstGlyph];
          let index3 = (leftOffset + rightOffset - s.array.off) / 2;
          val = s.array.values.get(index3);
          break;
        case 3:
          if (left2 >= s.glyphCount || right2 >= s.glyphCount) return 0;
          val = s.kernValue[s.kernIndex[s.leftClass[left2] * s.rightClassCount + s.rightClass[right2]]];
          break;
        default:
          throw new Error(`Unsupported kerning sub-table format ${table.format}`);
      }
      if (table.coverage.override) res = val;
      else res += val;
    }
    return res;
  }
  constructor(font) {
    this.kern = font.kern;
  }
};
var $0a4bdfeb6dfd6f5e$export$2e2bcd8739ae039 = class {
  positionGlyphs(glyphs, positions) {
    let clusterStart = 0;
    let clusterEnd = 0;
    for (let index3 = 0; index3 < glyphs.length; index3++) {
      let glyph = glyphs[index3];
      if (glyph.isMark) clusterEnd = index3;
      else {
        if (clusterStart !== clusterEnd) this.positionCluster(glyphs, positions, clusterStart, clusterEnd);
        clusterStart = clusterEnd = index3;
      }
    }
    if (clusterStart !== clusterEnd) this.positionCluster(glyphs, positions, clusterStart, clusterEnd);
    return positions;
  }
  positionCluster(glyphs, positions, clusterStart, clusterEnd) {
    let base = glyphs[clusterStart];
    let baseBox = base.cbox.copy();
    if (base.codePoints.length > 1)
      baseBox.minX += (base.codePoints.length - 1) * baseBox.width / base.codePoints.length;
    let xOffset = -positions[clusterStart].xAdvance;
    let yOffset = 0;
    let yGap = this.font.unitsPerEm / 16;
    for (let index3 = clusterStart + 1; index3 <= clusterEnd; index3++) {
      let mark = glyphs[index3];
      let markBox = mark.cbox;
      let position3 = positions[index3];
      let combiningClass = this.getCombiningClass(mark.codePoints[0]);
      if (combiningClass !== "Not_Reordered") {
        position3.xOffset = position3.yOffset = 0;
        switch (combiningClass) {
          case "Double_Above":
          case "Double_Below":
            position3.xOffset += baseBox.minX - markBox.width / 2 - markBox.minX;
            break;
          case "Attached_Below_Left":
          case "Below_Left":
          case "Above_Left":
            position3.xOffset += baseBox.minX - markBox.minX;
            break;
          case "Attached_Above_Right":
          case "Below_Right":
          case "Above_Right":
            position3.xOffset += baseBox.maxX - markBox.width - markBox.minX;
            break;
          default:
            position3.xOffset += baseBox.minX + (baseBox.width - markBox.width) / 2 - markBox.minX;
        }
        switch (combiningClass) {
          case "Double_Below":
          case "Below_Left":
          case "Below":
          case "Below_Right":
          case "Attached_Below_Left":
          case "Attached_Below":
            if (combiningClass === "Attached_Below_Left" || combiningClass === "Attached_Below") baseBox.minY += yGap;
            position3.yOffset = -baseBox.minY - markBox.maxY;
            baseBox.minY += markBox.height;
            break;
          case "Double_Above":
          case "Above_Left":
          case "Above":
          case "Above_Right":
          case "Attached_Above":
          case "Attached_Above_Right":
            if (combiningClass === "Attached_Above" || combiningClass === "Attached_Above_Right") baseBox.maxY += yGap;
            position3.yOffset = baseBox.maxY - markBox.minY;
            baseBox.maxY += markBox.height;
            break;
        }
        position3.xAdvance = position3.yAdvance = 0;
        position3.xOffset += xOffset;
        position3.yOffset += yOffset;
      } else {
        xOffset -= position3.xAdvance;
        yOffset -= position3.yAdvance;
      }
    }
    return;
  }
  getCombiningClass(codePoint) {
    let combiningClass = (0, $747425b437e121da$export$c03b919c6651ed55)(codePoint);
    if ((codePoint & -256) === 3584) {
      if (combiningClass === "Not_Reordered") switch (codePoint) {
        case 3633:
        case 3636:
        case 3637:
        case 3638:
        case 3639:
        case 3655:
        case 3660:
        case 3645:
        case 3662:
          return "Above_Right";
        case 3761:
        case 3764:
        case 3765:
        case 3766:
        case 3767:
        case 3771:
        case 3788:
        case 3789:
          return "Above";
        case 3772:
          return "Below";
      }
      else if (codePoint === 3642) return "Below_Right";
    }
    switch (combiningClass) {
      // Hebrew
      case "CCC10":
      case "CCC11":
      case "CCC12":
      case "CCC13":
      case "CCC14":
      case "CCC15":
      case "CCC16":
      case "CCC17":
      case "CCC18":
      case "CCC20":
      case "CCC22":
        return "Below";
      case "CCC23":
        return "Attached_Above";
      case "CCC24":
        return "Above_Right";
      case "CCC25":
      case "CCC19":
        return "Above_Left";
      case "CCC26":
        return "Above";
      case "CCC21":
        break;
      // Arabic and Syriac
      case "CCC27":
      case "CCC28":
      case "CCC30":
      case "CCC31":
      case "CCC33":
      case "CCC34":
      case "CCC35":
      case "CCC36":
        return "Above";
      case "CCC29":
      case "CCC32":
        return "Below";
      // Thai
      case "CCC103":
        return "Below_Right";
      case "CCC107":
        return "Above_Right";
      // Lao
      case "CCC118":
        return "Below";
      case "CCC122":
        return "Above";
      // Tibetan
      case "CCC129":
      case "CCC132":
        return "Below";
      case "CCC130":
        return "Above";
    }
    return combiningClass;
  }
  constructor(font) {
    this.font = font;
  }
};
var $f34600ab9d7f70d8$export$2e2bcd8739ae039 = class _$f34600ab9d7f70d8$export$2e2bcd8739ae039 {
  /**
  * The width of the bounding box
  * @type {number}
  */
  get width() {
    return this.maxX - this.minX;
  }
  /**
  * The height of the bounding box
  * @type {number}
  */
  get height() {
    return this.maxY - this.minY;
  }
  addPoint(x, y) {
    if (Math.abs(x) !== Infinity) {
      if (x < this.minX) this.minX = x;
      if (x > this.maxX) this.maxX = x;
    }
    if (Math.abs(y) !== Infinity) {
      if (y < this.minY) this.minY = y;
      if (y > this.maxY) this.maxY = y;
    }
  }
  copy() {
    return new _$f34600ab9d7f70d8$export$2e2bcd8739ae039(this.minX, this.minY, this.maxX, this.maxY);
  }
  constructor(minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity) {
    this.minX = minX;
    this.minY = minY;
    this.maxX = maxX;
    this.maxY = maxY;
  }
};
var $130d1a642ebcd2b7$var$UNICODE_SCRIPTS = {
  Caucasian_Albanian: "aghb",
  Arabic: "arab",
  Imperial_Aramaic: "armi",
  Armenian: "armn",
  Avestan: "avst",
  Balinese: "bali",
  Bamum: "bamu",
  Bassa_Vah: "bass",
  Batak: "batk",
  Bengali: [
    "bng2",
    "beng"
  ],
  Bopomofo: "bopo",
  Brahmi: "brah",
  Braille: "brai",
  Buginese: "bugi",
  Buhid: "buhd",
  Chakma: "cakm",
  Canadian_Aboriginal: "cans",
  Carian: "cari",
  Cham: "cham",
  Cherokee: "cher",
  Coptic: "copt",
  Cypriot: "cprt",
  Cyrillic: "cyrl",
  Devanagari: [
    "dev2",
    "deva"
  ],
  Deseret: "dsrt",
  Duployan: "dupl",
  Egyptian_Hieroglyphs: "egyp",
  Elbasan: "elba",
  Ethiopic: "ethi",
  Georgian: "geor",
  Glagolitic: "glag",
  Gothic: "goth",
  Grantha: "gran",
  Greek: "grek",
  Gujarati: [
    "gjr2",
    "gujr"
  ],
  Gurmukhi: [
    "gur2",
    "guru"
  ],
  Hangul: "hang",
  Han: "hani",
  Hanunoo: "hano",
  Hebrew: "hebr",
  Hiragana: "hira",
  Pahawh_Hmong: "hmng",
  Katakana_Or_Hiragana: "hrkt",
  Old_Italic: "ital",
  Javanese: "java",
  Kayah_Li: "kali",
  Katakana: "kana",
  Kharoshthi: "khar",
  Khmer: "khmr",
  Khojki: "khoj",
  Kannada: [
    "knd2",
    "knda"
  ],
  Kaithi: "kthi",
  Tai_Tham: "lana",
  Lao: "lao ",
  Latin: "latn",
  Lepcha: "lepc",
  Limbu: "limb",
  Linear_A: "lina",
  Linear_B: "linb",
  Lisu: "lisu",
  Lycian: "lyci",
  Lydian: "lydi",
  Mahajani: "mahj",
  Mandaic: "mand",
  Manichaean: "mani",
  Mende_Kikakui: "mend",
  Meroitic_Cursive: "merc",
  Meroitic_Hieroglyphs: "mero",
  Malayalam: [
    "mlm2",
    "mlym"
  ],
  Modi: "modi",
  Mongolian: "mong",
  Mro: "mroo",
  Meetei_Mayek: "mtei",
  Myanmar: [
    "mym2",
    "mymr"
  ],
  Old_North_Arabian: "narb",
  Nabataean: "nbat",
  Nko: "nko ",
  Ogham: "ogam",
  Ol_Chiki: "olck",
  Old_Turkic: "orkh",
  Oriya: [
    "ory2",
    "orya"
  ],
  Osmanya: "osma",
  Palmyrene: "palm",
  Pau_Cin_Hau: "pauc",
  Old_Permic: "perm",
  Phags_Pa: "phag",
  Inscriptional_Pahlavi: "phli",
  Psalter_Pahlavi: "phlp",
  Phoenician: "phnx",
  Miao: "plrd",
  Inscriptional_Parthian: "prti",
  Rejang: "rjng",
  Runic: "runr",
  Samaritan: "samr",
  Old_South_Arabian: "sarb",
  Saurashtra: "saur",
  Shavian: "shaw",
  Sharada: "shrd",
  Siddham: "sidd",
  Khudawadi: "sind",
  Sinhala: "sinh",
  Sora_Sompeng: "sora",
  Sundanese: "sund",
  Syloti_Nagri: "sylo",
  Syriac: "syrc",
  Tagbanwa: "tagb",
  Takri: "takr",
  Tai_Le: "tale",
  New_Tai_Lue: "talu",
  Tamil: [
    "tml2",
    "taml"
  ],
  Tai_Viet: "tavt",
  Telugu: [
    "tel2",
    "telu"
  ],
  Tifinagh: "tfng",
  Tagalog: "tglg",
  Thaana: "thaa",
  Thai: "thai",
  Tibetan: "tibt",
  Tirhuta: "tirh",
  Ugaritic: "ugar",
  Vai: "vai ",
  Warang_Citi: "wara",
  Old_Persian: "xpeo",
  Cuneiform: "xsux",
  Yi: "yi  ",
  Inherited: "zinh",
  Common: "zyyy",
  Unknown: "zzzz"
};
var $130d1a642ebcd2b7$var$OPENTYPE_SCRIPTS = {};
for (let script in $130d1a642ebcd2b7$var$UNICODE_SCRIPTS) {
  let tag = $130d1a642ebcd2b7$var$UNICODE_SCRIPTS[script];
  if (Array.isArray(tag)) for (let t2 of tag) $130d1a642ebcd2b7$var$OPENTYPE_SCRIPTS[t2] = script;
  else $130d1a642ebcd2b7$var$OPENTYPE_SCRIPTS[tag] = script;
}
function $130d1a642ebcd2b7$export$ce50e82f12a827a4(tag) {
  return $130d1a642ebcd2b7$var$OPENTYPE_SCRIPTS[tag];
}
function $130d1a642ebcd2b7$export$e5cb25e204fb8450(string3) {
  let len = string3.length;
  let idx = 0;
  while (idx < len) {
    let code2 = string3.charCodeAt(idx++);
    if (55296 <= code2 && code2 <= 56319 && idx < len) {
      let next2 = string3.charCodeAt(idx);
      if (56320 <= next2 && next2 <= 57343) {
        idx++;
        code2 = ((code2 & 1023) << 10) + (next2 & 1023) + 65536;
      }
    }
    let script = (0, $747425b437e121da$export$941569448d136665)(code2);
    if (script !== "Common" && script !== "Inherited" && script !== "Unknown") return $130d1a642ebcd2b7$var$UNICODE_SCRIPTS[script];
  }
  return $130d1a642ebcd2b7$var$UNICODE_SCRIPTS.Unknown;
}
function $130d1a642ebcd2b7$export$16fab0757cfc223d(codePoints) {
  for (let i = 0; i < codePoints.length; i++) {
    let codePoint = codePoints[i];
    let script = (0, $747425b437e121da$export$941569448d136665)(codePoint);
    if (script !== "Common" && script !== "Inherited" && script !== "Unknown") return $130d1a642ebcd2b7$var$UNICODE_SCRIPTS[script];
  }
  return $130d1a642ebcd2b7$var$UNICODE_SCRIPTS.Unknown;
}
var $130d1a642ebcd2b7$var$RTL = {
  arab: true,
  hebr: true,
  syrc: true,
  thaa: true,
  cprt: true,
  khar: true,
  phnx: true,
  "nko ": true,
  lydi: true,
  avst: true,
  armi: true,
  phli: true,
  prti: true,
  sarb: true,
  orkh: true,
  samr: true,
  mand: true,
  merc: true,
  mero: true,
  // Unicode 7.0 (not listed on http://www.microsoft.com/typography/otspec/scripttags.htm)
  mani: true,
  mend: true,
  nbat: true,
  narb: true,
  palm: true,
  phlp: true
  // Psalter Pahlavi
};
function $130d1a642ebcd2b7$export$9fddb9d0dd7d8a54(script) {
  if ($130d1a642ebcd2b7$var$RTL[script]) return "rtl";
  return "ltr";
}
var $be07b3e97a42687a$export$2e2bcd8739ae039 = class {
  /**
  * The total advance width of the run.
  * @type {number}
  */
  get advanceWidth() {
    let width = 0;
    for (let position3 of this.positions) width += position3.xAdvance;
    return width;
  }
  /**
  * The total advance height of the run.
  * @type {number}
  */
  get advanceHeight() {
    let height = 0;
    for (let position3 of this.positions) height += position3.yAdvance;
    return height;
  }
  /**
  * The bounding box containing all glyphs in the run.
  * @type {BBox}
  */
  get bbox() {
    let bbox = new (0, $f34600ab9d7f70d8$export$2e2bcd8739ae039)();
    let x = 0;
    let y = 0;
    for (let index3 = 0; index3 < this.glyphs.length; index3++) {
      let glyph = this.glyphs[index3];
      let p = this.positions[index3];
      let b = glyph.bbox;
      bbox.addPoint(b.minX + x + p.xOffset, b.minY + y + p.yOffset);
      bbox.addPoint(b.maxX + x + p.xOffset, b.maxY + y + p.yOffset);
      x += p.xAdvance;
      y += p.yAdvance;
    }
    return bbox;
  }
  constructor(glyphs, features, script, language, direction) {
    this.glyphs = glyphs;
    this.positions = null;
    this.script = script;
    this.language = language || null;
    this.direction = direction || $130d1a642ebcd2b7$export$9fddb9d0dd7d8a54(script);
    this.features = {};
    if (Array.isArray(features)) for (let tag of features) this.features[tag] = true;
    else if (typeof features === "object") this.features = features;
  }
};
var $1ac75d9a55b67f01$export$2e2bcd8739ae039 = class {
  constructor(xAdvance = 0, yAdvance = 0, xOffset = 0, yOffset = 0) {
    this.xAdvance = xAdvance;
    this.yAdvance = yAdvance;
    this.xOffset = xOffset;
    this.yOffset = yOffset;
  }
};
var $3b6302b64eccc32c$var$features = {
  allTypographicFeatures: {
    code: 0,
    exclusive: false,
    allTypeFeatures: 0
  },
  ligatures: {
    code: 1,
    exclusive: false,
    requiredLigatures: 0,
    commonLigatures: 2,
    rareLigatures: 4,
    // logos: 6
    rebusPictures: 8,
    diphthongLigatures: 10,
    squaredLigatures: 12,
    abbrevSquaredLigatures: 14,
    symbolLigatures: 16,
    contextualLigatures: 18,
    historicalLigatures: 20
  },
  cursiveConnection: {
    code: 2,
    exclusive: true,
    unconnected: 0,
    partiallyConnected: 1,
    cursive: 2
  },
  letterCase: {
    code: 3,
    exclusive: true
  },
  // upperAndLowerCase: 0          # deprecated
  // allCaps: 1                    # deprecated
  // allLowerCase: 2               # deprecated
  // smallCaps: 3                  # deprecated
  // initialCaps: 4                # deprecated
  // initialCapsAndSmallCaps: 5    # deprecated
  verticalSubstitution: {
    code: 4,
    exclusive: false,
    substituteVerticalForms: 0
  },
  linguisticRearrangement: {
    code: 5,
    exclusive: false,
    linguisticRearrangement: 0
  },
  numberSpacing: {
    code: 6,
    exclusive: true,
    monospacedNumbers: 0,
    proportionalNumbers: 1,
    thirdWidthNumbers: 2,
    quarterWidthNumbers: 3
  },
  smartSwash: {
    code: 8,
    exclusive: false,
    wordInitialSwashes: 0,
    wordFinalSwashes: 2,
    // lineInitialSwashes: 4
    // lineFinalSwashes: 6
    nonFinalSwashes: 8
  },
  diacritics: {
    code: 9,
    exclusive: true,
    showDiacritics: 0,
    hideDiacritics: 1,
    decomposeDiacritics: 2
  },
  verticalPosition: {
    code: 10,
    exclusive: true,
    normalPosition: 0,
    superiors: 1,
    inferiors: 2,
    ordinals: 3,
    scientificInferiors: 4
  },
  fractions: {
    code: 11,
    exclusive: true,
    noFractions: 0,
    verticalFractions: 1,
    diagonalFractions: 2
  },
  overlappingCharacters: {
    code: 13,
    exclusive: false,
    preventOverlap: 0
  },
  typographicExtras: {
    code: 14,
    exclusive: false,
    // hyphensToEmDash: 0
    // hyphenToEnDash: 2
    slashedZero: 4
  },
  // formInterrobang: 6
  // smartQuotes: 8
  // periodsToEllipsis: 10
  mathematicalExtras: {
    code: 15,
    exclusive: false,
    // hyphenToMinus: 0
    // asteristoMultiply: 2
    // slashToDivide: 4
    // inequalityLigatures: 6
    // exponents: 8
    mathematicalGreek: 10
  },
  ornamentSets: {
    code: 16,
    exclusive: true,
    noOrnaments: 0,
    dingbats: 1,
    piCharacters: 2,
    fleurons: 3,
    decorativeBorders: 4,
    internationalSymbols: 5,
    mathSymbols: 6
  },
  characterAlternatives: {
    code: 17,
    exclusive: true,
    noAlternates: 0
  },
  // user defined options
  designComplexity: {
    code: 18,
    exclusive: true,
    designLevel1: 0,
    designLevel2: 1,
    designLevel3: 2,
    designLevel4: 3,
    designLevel5: 4
  },
  styleOptions: {
    code: 19,
    exclusive: true,
    noStyleOptions: 0,
    displayText: 1,
    engravedText: 2,
    illuminatedCaps: 3,
    titlingCaps: 4,
    tallCaps: 5
  },
  characterShape: {
    code: 20,
    exclusive: true,
    traditionalCharacters: 0,
    simplifiedCharacters: 1,
    JIS1978Characters: 2,
    JIS1983Characters: 3,
    JIS1990Characters: 4,
    traditionalAltOne: 5,
    traditionalAltTwo: 6,
    traditionalAltThree: 7,
    traditionalAltFour: 8,
    traditionalAltFive: 9,
    expertCharacters: 10,
    JIS2004Characters: 11,
    hojoCharacters: 12,
    NLCCharacters: 13,
    traditionalNamesCharacters: 14
  },
  numberCase: {
    code: 21,
    exclusive: true,
    lowerCaseNumbers: 0,
    upperCaseNumbers: 1
  },
  textSpacing: {
    code: 22,
    exclusive: true,
    proportionalText: 0,
    monospacedText: 1,
    halfWidthText: 2,
    thirdWidthText: 3,
    quarterWidthText: 4,
    altProportionalText: 5,
    altHalfWidthText: 6
  },
  transliteration: {
    code: 23,
    exclusive: true,
    noTransliteration: 0
  },
  // hanjaToHangul: 1
  // hiraganaToKatakana: 2
  // katakanaToHiragana: 3
  // kanaToRomanization: 4
  // romanizationToHiragana: 5
  // romanizationToKatakana: 6
  // hanjaToHangulAltOne: 7
  // hanjaToHangulAltTwo: 8
  // hanjaToHangulAltThree: 9
  annotation: {
    code: 24,
    exclusive: true,
    noAnnotation: 0,
    boxAnnotation: 1,
    roundedBoxAnnotation: 2,
    circleAnnotation: 3,
    invertedCircleAnnotation: 4,
    parenthesisAnnotation: 5,
    periodAnnotation: 6,
    romanNumeralAnnotation: 7,
    diamondAnnotation: 8,
    invertedBoxAnnotation: 9,
    invertedRoundedBoxAnnotation: 10
  },
  kanaSpacing: {
    code: 25,
    exclusive: true,
    fullWidthKana: 0,
    proportionalKana: 1
  },
  ideographicSpacing: {
    code: 26,
    exclusive: true,
    fullWidthIdeographs: 0,
    proportionalIdeographs: 1,
    halfWidthIdeographs: 2
  },
  unicodeDecomposition: {
    code: 27,
    exclusive: false,
    canonicalComposition: 0,
    compatibilityComposition: 2,
    transcodingComposition: 4
  },
  rubyKana: {
    code: 28,
    exclusive: false,
    // noRubyKana: 0     # deprecated - use rubyKanaOff instead
    // rubyKana: 1     # deprecated - use rubyKanaOn instead
    rubyKana: 2
  },
  CJKSymbolAlternatives: {
    code: 29,
    exclusive: true,
    noCJKSymbolAlternatives: 0,
    CJKSymbolAltOne: 1,
    CJKSymbolAltTwo: 2,
    CJKSymbolAltThree: 3,
    CJKSymbolAltFour: 4,
    CJKSymbolAltFive: 5
  },
  ideographicAlternatives: {
    code: 30,
    exclusive: true,
    noIdeographicAlternatives: 0,
    ideographicAltOne: 1,
    ideographicAltTwo: 2,
    ideographicAltThree: 3,
    ideographicAltFour: 4,
    ideographicAltFive: 5
  },
  CJKVerticalRomanPlacement: {
    code: 31,
    exclusive: true,
    CJKVerticalRomanCentered: 0,
    CJKVerticalRomanHBaseline: 1
  },
  italicCJKRoman: {
    code: 32,
    exclusive: false,
    // noCJKItalicRoman: 0     # deprecated - use CJKItalicRomanOff instead
    // CJKItalicRoman: 1     # deprecated - use CJKItalicRomanOn instead
    CJKItalicRoman: 2
  },
  caseSensitiveLayout: {
    code: 33,
    exclusive: false,
    caseSensitiveLayout: 0,
    caseSensitiveSpacing: 2
  },
  alternateKana: {
    code: 34,
    exclusive: false,
    alternateHorizKana: 0,
    alternateVertKana: 2
  },
  stylisticAlternatives: {
    code: 35,
    exclusive: false,
    noStylisticAlternates: 0,
    stylisticAltOne: 2,
    stylisticAltTwo: 4,
    stylisticAltThree: 6,
    stylisticAltFour: 8,
    stylisticAltFive: 10,
    stylisticAltSix: 12,
    stylisticAltSeven: 14,
    stylisticAltEight: 16,
    stylisticAltNine: 18,
    stylisticAltTen: 20,
    stylisticAltEleven: 22,
    stylisticAltTwelve: 24,
    stylisticAltThirteen: 26,
    stylisticAltFourteen: 28,
    stylisticAltFifteen: 30,
    stylisticAltSixteen: 32,
    stylisticAltSeventeen: 34,
    stylisticAltEighteen: 36,
    stylisticAltNineteen: 38,
    stylisticAltTwenty: 40
  },
  contextualAlternates: {
    code: 36,
    exclusive: false,
    contextualAlternates: 0,
    swashAlternates: 2,
    contextualSwashAlternates: 4
  },
  lowerCase: {
    code: 37,
    exclusive: true,
    defaultLowerCase: 0,
    lowerCaseSmallCaps: 1,
    lowerCasePetiteCaps: 2
  },
  upperCase: {
    code: 38,
    exclusive: true,
    defaultUpperCase: 0,
    upperCaseSmallCaps: 1,
    upperCasePetiteCaps: 2
  },
  languageTag: {
    code: 39,
    exclusive: true
  },
  CJKRomanSpacing: {
    code: 103,
    exclusive: true,
    halfWidthCJKRoman: 0,
    proportionalCJKRoman: 1,
    defaultCJKRoman: 2,
    fullWidthCJKRoman: 3
  }
};
var $3b6302b64eccc32c$var$feature = (name, selector) => [
  $3b6302b64eccc32c$var$features[name].code,
  $3b6302b64eccc32c$var$features[name][selector]
];
var $3b6302b64eccc32c$var$OTMapping = {
  rlig: $3b6302b64eccc32c$var$feature("ligatures", "requiredLigatures"),
  clig: $3b6302b64eccc32c$var$feature("ligatures", "contextualLigatures"),
  dlig: $3b6302b64eccc32c$var$feature("ligatures", "rareLigatures"),
  hlig: $3b6302b64eccc32c$var$feature("ligatures", "historicalLigatures"),
  liga: $3b6302b64eccc32c$var$feature("ligatures", "commonLigatures"),
  hist: $3b6302b64eccc32c$var$feature("ligatures", "historicalLigatures"),
  smcp: $3b6302b64eccc32c$var$feature("lowerCase", "lowerCaseSmallCaps"),
  pcap: $3b6302b64eccc32c$var$feature("lowerCase", "lowerCasePetiteCaps"),
  frac: $3b6302b64eccc32c$var$feature("fractions", "diagonalFractions"),
  dnom: $3b6302b64eccc32c$var$feature("fractions", "diagonalFractions"),
  numr: $3b6302b64eccc32c$var$feature("fractions", "diagonalFractions"),
  afrc: $3b6302b64eccc32c$var$feature("fractions", "verticalFractions"),
  // aalt
  // abvf, abvm, abvs, akhn, blwf, blwm, blws, cfar, cjct, cpsp, falt, isol, jalt, ljmo, mset?
  // ltra, ltrm, nukt, pref, pres, pstf, psts, rand, rkrf, rphf, rtla, rtlm, size, tjmo, tnum?
  // unic, vatu, vhal, vjmo, vpal, vrt2
  // dist -> trak table?
  // kern, vkrn -> kern table
  // lfbd + opbd + rtbd -> opbd table?
  // mark, mkmk -> acnt table?
  // locl -> languageTag + ltag table
  case: $3b6302b64eccc32c$var$feature("caseSensitiveLayout", "caseSensitiveLayout"),
  ccmp: $3b6302b64eccc32c$var$feature("unicodeDecomposition", "canonicalComposition"),
  cpct: $3b6302b64eccc32c$var$feature("CJKVerticalRomanPlacement", "CJKVerticalRomanCentered"),
  valt: $3b6302b64eccc32c$var$feature("CJKVerticalRomanPlacement", "CJKVerticalRomanCentered"),
  swsh: $3b6302b64eccc32c$var$feature("contextualAlternates", "swashAlternates"),
  cswh: $3b6302b64eccc32c$var$feature("contextualAlternates", "contextualSwashAlternates"),
  curs: $3b6302b64eccc32c$var$feature("cursiveConnection", "cursive"),
  c2pc: $3b6302b64eccc32c$var$feature("upperCase", "upperCasePetiteCaps"),
  c2sc: $3b6302b64eccc32c$var$feature("upperCase", "upperCaseSmallCaps"),
  init: $3b6302b64eccc32c$var$feature("smartSwash", "wordInitialSwashes"),
  fin2: $3b6302b64eccc32c$var$feature("smartSwash", "wordFinalSwashes"),
  medi: $3b6302b64eccc32c$var$feature("smartSwash", "nonFinalSwashes"),
  med2: $3b6302b64eccc32c$var$feature("smartSwash", "nonFinalSwashes"),
  fin3: $3b6302b64eccc32c$var$feature("smartSwash", "wordFinalSwashes"),
  fina: $3b6302b64eccc32c$var$feature("smartSwash", "wordFinalSwashes"),
  pkna: $3b6302b64eccc32c$var$feature("kanaSpacing", "proportionalKana"),
  half: $3b6302b64eccc32c$var$feature("textSpacing", "halfWidthText"),
  halt: $3b6302b64eccc32c$var$feature("textSpacing", "altHalfWidthText"),
  hkna: $3b6302b64eccc32c$var$feature("alternateKana", "alternateHorizKana"),
  vkna: $3b6302b64eccc32c$var$feature("alternateKana", "alternateVertKana"),
  // hngl: feature 'transliteration', 'hanjaToHangulSelector' # deprecated
  ital: $3b6302b64eccc32c$var$feature("italicCJKRoman", "CJKItalicRoman"),
  lnum: $3b6302b64eccc32c$var$feature("numberCase", "upperCaseNumbers"),
  onum: $3b6302b64eccc32c$var$feature("numberCase", "lowerCaseNumbers"),
  mgrk: $3b6302b64eccc32c$var$feature("mathematicalExtras", "mathematicalGreek"),
  // nalt: not enough info. what type of annotation?
  // ornm: ditto, which ornament style?
  calt: $3b6302b64eccc32c$var$feature("contextualAlternates", "contextualAlternates"),
  vrt2: $3b6302b64eccc32c$var$feature("verticalSubstitution", "substituteVerticalForms"),
  vert: $3b6302b64eccc32c$var$feature("verticalSubstitution", "substituteVerticalForms"),
  tnum: $3b6302b64eccc32c$var$feature("numberSpacing", "monospacedNumbers"),
  pnum: $3b6302b64eccc32c$var$feature("numberSpacing", "proportionalNumbers"),
  sups: $3b6302b64eccc32c$var$feature("verticalPosition", "superiors"),
  subs: $3b6302b64eccc32c$var$feature("verticalPosition", "inferiors"),
  ordn: $3b6302b64eccc32c$var$feature("verticalPosition", "ordinals"),
  pwid: $3b6302b64eccc32c$var$feature("textSpacing", "proportionalText"),
  hwid: $3b6302b64eccc32c$var$feature("textSpacing", "halfWidthText"),
  qwid: $3b6302b64eccc32c$var$feature("textSpacing", "quarterWidthText"),
  twid: $3b6302b64eccc32c$var$feature("textSpacing", "thirdWidthText"),
  fwid: $3b6302b64eccc32c$var$feature("textSpacing", "proportionalText"),
  palt: $3b6302b64eccc32c$var$feature("textSpacing", "altProportionalText"),
  trad: $3b6302b64eccc32c$var$feature("characterShape", "traditionalCharacters"),
  smpl: $3b6302b64eccc32c$var$feature("characterShape", "simplifiedCharacters"),
  jp78: $3b6302b64eccc32c$var$feature("characterShape", "JIS1978Characters"),
  jp83: $3b6302b64eccc32c$var$feature("characterShape", "JIS1983Characters"),
  jp90: $3b6302b64eccc32c$var$feature("characterShape", "JIS1990Characters"),
  jp04: $3b6302b64eccc32c$var$feature("characterShape", "JIS2004Characters"),
  expt: $3b6302b64eccc32c$var$feature("characterShape", "expertCharacters"),
  hojo: $3b6302b64eccc32c$var$feature("characterShape", "hojoCharacters"),
  nlck: $3b6302b64eccc32c$var$feature("characterShape", "NLCCharacters"),
  tnam: $3b6302b64eccc32c$var$feature("characterShape", "traditionalNamesCharacters"),
  ruby: $3b6302b64eccc32c$var$feature("rubyKana", "rubyKana"),
  titl: $3b6302b64eccc32c$var$feature("styleOptions", "titlingCaps"),
  zero: $3b6302b64eccc32c$var$feature("typographicExtras", "slashedZero"),
  ss01: $3b6302b64eccc32c$var$feature("stylisticAlternatives", "stylisticAltOne"),
  ss02: $3b6302b64eccc32c$var$feature("stylisticAlternatives", "stylisticAltTwo"),
  ss03: $3b6302b64eccc32c$var$feature("stylisticAlternatives", "stylisticAltThree"),
  ss04: $3b6302b64eccc32c$var$feature("stylisticAlternatives", "stylisticAltFour"),
  ss05: $3b6302b64eccc32c$var$feature("stylisticAlternatives", "stylisticAltFive"),
  ss06: $3b6302b64eccc32c$var$feature("stylisticAlternatives", "stylisticAltSix"),
  ss07: $3b6302b64eccc32c$var$feature("stylisticAlternatives", "stylisticAltSeven"),
  ss08: $3b6302b64eccc32c$var$feature("stylisticAlternatives", "stylisticAltEight"),
  ss09: $3b6302b64eccc32c$var$feature("stylisticAlternatives", "stylisticAltNine"),
  ss10: $3b6302b64eccc32c$var$feature("stylisticAlternatives", "stylisticAltTen"),
  ss11: $3b6302b64eccc32c$var$feature("stylisticAlternatives", "stylisticAltEleven"),
  ss12: $3b6302b64eccc32c$var$feature("stylisticAlternatives", "stylisticAltTwelve"),
  ss13: $3b6302b64eccc32c$var$feature("stylisticAlternatives", "stylisticAltThirteen"),
  ss14: $3b6302b64eccc32c$var$feature("stylisticAlternatives", "stylisticAltFourteen"),
  ss15: $3b6302b64eccc32c$var$feature("stylisticAlternatives", "stylisticAltFifteen"),
  ss16: $3b6302b64eccc32c$var$feature("stylisticAlternatives", "stylisticAltSixteen"),
  ss17: $3b6302b64eccc32c$var$feature("stylisticAlternatives", "stylisticAltSeventeen"),
  ss18: $3b6302b64eccc32c$var$feature("stylisticAlternatives", "stylisticAltEighteen"),
  ss19: $3b6302b64eccc32c$var$feature("stylisticAlternatives", "stylisticAltNineteen"),
  ss20: $3b6302b64eccc32c$var$feature("stylisticAlternatives", "stylisticAltTwenty")
};
for (let i = 1; i <= 99; i++) $3b6302b64eccc32c$var$OTMapping[`cv${`00${i}`.slice(-2)}`] = [
  $3b6302b64eccc32c$var$features.characterAlternatives.code,
  i
];
var $3b6302b64eccc32c$var$AATMapping = {};
for (let ot in $3b6302b64eccc32c$var$OTMapping) {
  let aat = $3b6302b64eccc32c$var$OTMapping[ot];
  if ($3b6302b64eccc32c$var$AATMapping[aat[0]] == null) $3b6302b64eccc32c$var$AATMapping[aat[0]] = {};
  $3b6302b64eccc32c$var$AATMapping[aat[0]][aat[1]] = ot;
}
function $3b6302b64eccc32c$export$b813f7d2a1677c16(features) {
  let res = {};
  for (let k in features) {
    let r2;
    if (r2 = $3b6302b64eccc32c$var$OTMapping[k]) {
      if (res[r2[0]] == null) res[r2[0]] = {};
      res[r2[0]][r2[1]] = features[k];
    }
  }
  return res;
}
function $3b6302b64eccc32c$var$mapFeatureStrings(f) {
  let [type5, setting] = f;
  if (isNaN(type5)) var typeCode = $3b6302b64eccc32c$var$features[type5] && $3b6302b64eccc32c$var$features[type5].code;
  else var typeCode = type5;
  if (isNaN(setting)) var settingCode = $3b6302b64eccc32c$var$features[type5] && $3b6302b64eccc32c$var$features[type5][setting];
  else var settingCode = setting;
  return [
    typeCode,
    settingCode
  ];
}
function $3b6302b64eccc32c$export$bd6df347a4f391c4(features) {
  let res = {};
  if (Array.isArray(features)) for (let k = 0; k < features.length; k++) {
    let r2;
    let f = $3b6302b64eccc32c$var$mapFeatureStrings(features[k]);
    if (r2 = $3b6302b64eccc32c$var$AATMapping[f[0]] && $3b6302b64eccc32c$var$AATMapping[f[0]][f[1]]) res[r2] = true;
  }
  else if (typeof features === "object") for (let type5 in features) {
    let feature = features[type5];
    for (let setting in feature) {
      let r2;
      let f = $3b6302b64eccc32c$var$mapFeatureStrings([
        type5,
        setting
      ]);
      if (feature[setting] && (r2 = $3b6302b64eccc32c$var$AATMapping[f[0]] && $3b6302b64eccc32c$var$AATMapping[f[0]][f[1]])) res[r2] = true;
    }
  }
  return Object.keys(res);
}
var $ff5ce077dae0f144$export$2e2bcd8739ae039 = class {
  lookup(glyph) {
    switch (this.table.version) {
      case 0:
        return this.table.values.getItem(glyph);
      case 2:
      case 4: {
        let min = 0;
        let max = this.table.binarySearchHeader.nUnits - 1;
        while (min <= max) {
          var mid = min + max >> 1;
          var seg = this.table.segments[mid];
          if (seg.firstGlyph === 65535) return null;
          if (glyph < seg.firstGlyph) max = mid - 1;
          else if (glyph > seg.lastGlyph) min = mid + 1;
          else {
            if (this.table.version === 2) return seg.value;
            else return seg.values[glyph - seg.firstGlyph];
          }
        }
        return null;
      }
      case 6: {
        let min = 0;
        let max = this.table.binarySearchHeader.nUnits - 1;
        while (min <= max) {
          var mid = min + max >> 1;
          var seg = this.table.segments[mid];
          if (seg.glyph === 65535) return null;
          if (glyph < seg.glyph) max = mid - 1;
          else if (glyph > seg.glyph) min = mid + 1;
          else return seg.value;
        }
        return null;
      }
      case 8:
        return this.table.values[glyph - this.table.firstGlyph];
      default:
        throw new Error(`Unknown lookup table format: ${this.table.version}`);
    }
  }
  glyphsForValue(classValue) {
    let res = [];
    switch (this.table.version) {
      case 2:
      case 4:
        for (let segment of this.table.segments) if (this.table.version === 2 && segment.value === classValue) res.push(...(0, $12727730ddfc8bfe$export$d02631cccf789723)(segment.firstGlyph, segment.lastGlyph + 1));
        else {
          for (let index3 = 0; index3 < segment.values.length; index3++) if (segment.values[index3] === classValue) res.push(segment.firstGlyph + index3);
        }
        break;
      case 6:
        for (let segment of this.table.segments) if (segment.value === classValue) res.push(segment.glyph);
        break;
      case 8:
        for (let i = 0; i < this.table.values.length; i++) if (this.table.values[i] === classValue) res.push(this.table.firstGlyph + i);
        break;
      default:
        throw new Error(`Unknown lookup table format: ${this.table.version}`);
    }
    return res;
  }
  constructor(table) {
    this.table = table;
  }
};
(0, __decorate)([
  (0, $e71565f2ce09cb6b$export$69a3209f1a06c04d)
], $ff5ce077dae0f144$export$2e2bcd8739ae039.prototype, "glyphsForValue", null);
var $50c7aac9316f2948$var$START_OF_TEXT_STATE = 0;
var $50c7aac9316f2948$var$END_OF_TEXT_CLASS = 0;
var $50c7aac9316f2948$var$OUT_OF_BOUNDS_CLASS = 1;
var $50c7aac9316f2948$var$DELETED_GLYPH_CLASS = 2;
var $50c7aac9316f2948$var$DONT_ADVANCE = 16384;
var $50c7aac9316f2948$export$2e2bcd8739ae039 = class {
  process(glyphs, reverse, processEntry) {
    let currentState = $50c7aac9316f2948$var$START_OF_TEXT_STATE;
    let index3 = reverse ? glyphs.length - 1 : 0;
    let dir = reverse ? -1 : 1;
    while (dir === 1 && index3 <= glyphs.length || dir === -1 && index3 >= -1) {
      let glyph = null;
      let classCode = $50c7aac9316f2948$var$OUT_OF_BOUNDS_CLASS;
      let shouldAdvance = true;
      if (index3 === glyphs.length || index3 === -1) classCode = $50c7aac9316f2948$var$END_OF_TEXT_CLASS;
      else {
        glyph = glyphs[index3];
        if (glyph.id === 65535) classCode = $50c7aac9316f2948$var$DELETED_GLYPH_CLASS;
        else {
          classCode = this.lookupTable.lookup(glyph.id);
          if (classCode == null) classCode = $50c7aac9316f2948$var$OUT_OF_BOUNDS_CLASS;
        }
      }
      let row = this.stateTable.stateArray.getItem(currentState);
      let entryIndex = row[classCode];
      let entry = this.stateTable.entryTable.getItem(entryIndex);
      if (classCode !== $50c7aac9316f2948$var$END_OF_TEXT_CLASS && classCode !== $50c7aac9316f2948$var$DELETED_GLYPH_CLASS) {
        processEntry(glyph, entry, index3);
        shouldAdvance = !(entry.flags & $50c7aac9316f2948$var$DONT_ADVANCE);
      }
      currentState = entry.newState;
      if (shouldAdvance) index3 += dir;
    }
    return glyphs;
  }
  /**
  * Performs a depth-first traversal of the glyph strings
  * represented by the state machine.
  */
  traverse(opts, state = 0, visited = /* @__PURE__ */ new Set()) {
    if (visited.has(state)) return;
    visited.add(state);
    let { nClasses, stateArray, entryTable } = this.stateTable;
    let row = stateArray.getItem(state);
    for (let classCode = 4; classCode < nClasses; classCode++) {
      let entryIndex = row[classCode];
      let entry = entryTable.getItem(entryIndex);
      for (let glyph of this.lookupTable.glyphsForValue(classCode)) {
        if (opts.enter) opts.enter(glyph, entry);
        if (entry.newState !== 0) this.traverse(opts, entry.newState, visited);
        if (opts.exit) opts.exit(glyph, entry);
      }
    }
  }
  constructor(stateTable) {
    this.stateTable = stateTable;
    this.lookupTable = new (0, $ff5ce077dae0f144$export$2e2bcd8739ae039)(stateTable.classTable);
  }
};
var $55f71433a605c87d$var$MARK_FIRST = 32768;
var $55f71433a605c87d$var$MARK_LAST = 8192;
var $55f71433a605c87d$var$VERB = 15;
var $55f71433a605c87d$var$SET_MARK = 32768;
var $55f71433a605c87d$var$SET_COMPONENT = 32768;
var $55f71433a605c87d$var$PERFORM_ACTION = 8192;
var $55f71433a605c87d$var$LAST_MASK = 2147483648;
var $55f71433a605c87d$var$STORE_MASK = 1073741824;
var $55f71433a605c87d$var$OFFSET_MASK = 1073741823;
var $55f71433a605c87d$var$REVERSE_DIRECTION = 4194304;
var $55f71433a605c87d$var$CURRENT_INSERT_BEFORE = 2048;
var $55f71433a605c87d$var$MARKED_INSERT_BEFORE = 1024;
var $55f71433a605c87d$var$CURRENT_INSERT_COUNT = 992;
var $55f71433a605c87d$var$MARKED_INSERT_COUNT = 31;
var $55f71433a605c87d$export$2e2bcd8739ae039 = class {
  // Processes an array of glyphs and applies the specified features
  // Features should be in the form of {featureType:{featureSetting:boolean}}
  process(glyphs, features = {}) {
    for (let chain of this.morx.chains) {
      let flags = chain.defaultFlags;
      for (let feature of chain.features) {
        let f;
        if (f = features[feature.featureType]) {
          if (f[feature.featureSetting]) {
            flags &= feature.disableFlags;
            flags |= feature.enableFlags;
          } else if (f[feature.featureSetting] === false) {
            flags |= ~feature.disableFlags;
            flags &= ~feature.enableFlags;
          }
        }
      }
      for (let subtable of chain.subtables) if (subtable.subFeatureFlags & flags) this.processSubtable(subtable, glyphs);
    }
    let index3 = glyphs.length - 1;
    while (index3 >= 0) {
      if (glyphs[index3].id === 65535) glyphs.splice(index3, 1);
      index3--;
    }
    return glyphs;
  }
  processSubtable(subtable, glyphs) {
    this.subtable = subtable;
    this.glyphs = glyphs;
    if (this.subtable.type === 4) {
      this.processNoncontextualSubstitutions(this.subtable, this.glyphs);
      return;
    }
    this.ligatureStack = [];
    this.markedGlyph = null;
    this.firstGlyph = null;
    this.lastGlyph = null;
    this.markedIndex = null;
    let stateMachine = this.getStateMachine(subtable);
    let process2 = this.getProcessor();
    let reverse = !!(this.subtable.coverage & $55f71433a605c87d$var$REVERSE_DIRECTION);
    return stateMachine.process(this.glyphs, reverse, process2);
  }
  getStateMachine(subtable) {
    return new (0, $50c7aac9316f2948$export$2e2bcd8739ae039)(subtable.table.stateTable);
  }
  getProcessor() {
    switch (this.subtable.type) {
      case 0:
        return this.processIndicRearragement;
      case 1:
        return this.processContextualSubstitution;
      case 2:
        return this.processLigature;
      case 4:
        return this.processNoncontextualSubstitutions;
      case 5:
        return this.processGlyphInsertion;
      default:
        throw new Error(`Invalid morx subtable type: ${this.subtable.type}`);
    }
  }
  processIndicRearragement(glyph, entry, index3) {
    if (entry.flags & $55f71433a605c87d$var$MARK_FIRST) this.firstGlyph = index3;
    if (entry.flags & $55f71433a605c87d$var$MARK_LAST) this.lastGlyph = index3;
    $55f71433a605c87d$var$reorderGlyphs(this.glyphs, entry.flags & $55f71433a605c87d$var$VERB, this.firstGlyph, this.lastGlyph);
  }
  processContextualSubstitution(glyph, entry, index3) {
    let subsitutions = this.subtable.table.substitutionTable.items;
    if (entry.markIndex !== 65535) {
      let lookup = subsitutions.getItem(entry.markIndex);
      let lookupTable = new (0, $ff5ce077dae0f144$export$2e2bcd8739ae039)(lookup);
      glyph = this.glyphs[this.markedGlyph];
      var gid = lookupTable.lookup(glyph.id);
      if (gid) this.glyphs[this.markedGlyph] = this.font.getGlyph(gid, glyph.codePoints);
    }
    if (entry.currentIndex !== 65535) {
      let lookup = subsitutions.getItem(entry.currentIndex);
      let lookupTable = new (0, $ff5ce077dae0f144$export$2e2bcd8739ae039)(lookup);
      glyph = this.glyphs[index3];
      var gid = lookupTable.lookup(glyph.id);
      if (gid) this.glyphs[index3] = this.font.getGlyph(gid, glyph.codePoints);
    }
    if (entry.flags & $55f71433a605c87d$var$SET_MARK) this.markedGlyph = index3;
  }
  processLigature(glyph, entry, index3) {
    if (entry.flags & $55f71433a605c87d$var$SET_COMPONENT) this.ligatureStack.push(index3);
    if (entry.flags & $55f71433a605c87d$var$PERFORM_ACTION) {
      let actions = this.subtable.table.ligatureActions;
      let components = this.subtable.table.components;
      let ligatureList = this.subtable.table.ligatureList;
      let actionIndex = entry.action;
      let last2 = false;
      let ligatureIndex = 0;
      let codePoints = [];
      let ligatureGlyphs = [];
      while (!last2) {
        let componentGlyph = this.ligatureStack.pop();
        codePoints.unshift(...this.glyphs[componentGlyph].codePoints);
        let action = actions.getItem(actionIndex++);
        last2 = !!(action & $55f71433a605c87d$var$LAST_MASK);
        let store = !!(action & $55f71433a605c87d$var$STORE_MASK);
        let offset4 = (action & $55f71433a605c87d$var$OFFSET_MASK) << 2 >> 2;
        offset4 += this.glyphs[componentGlyph].id;
        let component = components.getItem(offset4);
        ligatureIndex += component;
        if (last2 || store) {
          let ligatureEntry = ligatureList.getItem(ligatureIndex);
          this.glyphs[componentGlyph] = this.font.getGlyph(ligatureEntry, codePoints);
          ligatureGlyphs.push(componentGlyph);
          ligatureIndex = 0;
          codePoints = [];
        } else this.glyphs[componentGlyph] = this.font.getGlyph(65535);
      }
      this.ligatureStack.push(...ligatureGlyphs);
    }
  }
  processNoncontextualSubstitutions(subtable, glyphs, index3) {
    let lookupTable = new (0, $ff5ce077dae0f144$export$2e2bcd8739ae039)(subtable.table.lookupTable);
    for (index3 = 0; index3 < glyphs.length; index3++) {
      let glyph = glyphs[index3];
      if (glyph.id !== 65535) {
        let gid = lookupTable.lookup(glyph.id);
        if (gid) glyphs[index3] = this.font.getGlyph(gid, glyph.codePoints);
      }
    }
  }
  _insertGlyphs(glyphIndex, insertionActionIndex, count, isBefore) {
    let insertions = [];
    while (count--) {
      let gid = this.subtable.table.insertionActions.getItem(insertionActionIndex++);
      insertions.push(this.font.getGlyph(gid));
    }
    if (!isBefore) glyphIndex++;
    this.glyphs.splice(glyphIndex, 0, ...insertions);
  }
  processGlyphInsertion(glyph, entry, index3) {
    if (entry.flags & $55f71433a605c87d$var$SET_MARK) this.markedIndex = index3;
    if (entry.markedInsertIndex !== 65535) {
      let count = (entry.flags & $55f71433a605c87d$var$MARKED_INSERT_COUNT) >>> 5;
      let isBefore = !!(entry.flags & $55f71433a605c87d$var$MARKED_INSERT_BEFORE);
      this._insertGlyphs(this.markedIndex, entry.markedInsertIndex, count, isBefore);
    }
    if (entry.currentInsertIndex !== 65535) {
      let count = (entry.flags & $55f71433a605c87d$var$CURRENT_INSERT_COUNT) >>> 5;
      let isBefore = !!(entry.flags & $55f71433a605c87d$var$CURRENT_INSERT_BEFORE);
      this._insertGlyphs(index3, entry.currentInsertIndex, count, isBefore);
    }
  }
  getSupportedFeatures() {
    let features = [];
    for (let chain of this.morx.chains) for (let feature of chain.features) features.push([
      feature.featureType,
      feature.featureSetting
    ]);
    return features;
  }
  generateInputs(gid) {
    if (!this.inputCache) this.generateInputCache();
    return this.inputCache[gid] || [];
  }
  generateInputCache() {
    this.inputCache = {};
    for (let chain of this.morx.chains) {
      let flags = chain.defaultFlags;
      for (let subtable of chain.subtables) if (subtable.subFeatureFlags & flags) this.generateInputsForSubtable(subtable);
    }
  }
  generateInputsForSubtable(subtable) {
    if (subtable.type !== 2) return;
    let reverse = !!(subtable.coverage & $55f71433a605c87d$var$REVERSE_DIRECTION);
    if (reverse) throw new Error("Reverse subtable, not supported.");
    this.subtable = subtable;
    this.ligatureStack = [];
    let stateMachine = this.getStateMachine(subtable);
    let process2 = this.getProcessor();
    let input = [];
    let stack = [];
    this.glyphs = [];
    stateMachine.traverse({
      enter: (glyph, entry) => {
        let glyphs = this.glyphs;
        stack.push({
          glyphs: glyphs.slice(),
          ligatureStack: this.ligatureStack.slice()
        });
        let g = this.font.getGlyph(glyph);
        input.push(g);
        glyphs.push(input[input.length - 1]);
        process2(glyphs[glyphs.length - 1], entry, glyphs.length - 1);
        let count = 0;
        let found = 0;
        for (let i = 0; i < glyphs.length && count <= 1; i++) if (glyphs[i].id !== 65535) {
          count++;
          found = glyphs[i].id;
        }
        if (count === 1) {
          let result = input.map((g2) => g2.id);
          let cache = this.inputCache[found];
          if (cache) cache.push(result);
          else this.inputCache[found] = [
            result
          ];
        }
      },
      exit: () => {
        ({ glyphs: this.glyphs, ligatureStack: this.ligatureStack } = stack.pop());
        input.pop();
      }
    });
  }
  constructor(font) {
    this.processIndicRearragement = this.processIndicRearragement.bind(this);
    this.processContextualSubstitution = this.processContextualSubstitution.bind(this);
    this.processLigature = this.processLigature.bind(this);
    this.processNoncontextualSubstitutions = this.processNoncontextualSubstitutions.bind(this);
    this.processGlyphInsertion = this.processGlyphInsertion.bind(this);
    this.font = font;
    this.morx = font.morx;
    this.inputCache = null;
  }
};
(0, __decorate)([
  (0, $e71565f2ce09cb6b$export$69a3209f1a06c04d)
], $55f71433a605c87d$export$2e2bcd8739ae039.prototype, "getStateMachine", null);
function $55f71433a605c87d$var$swap(glyphs, rangeA, rangeB, reverseA = false, reverseB = false) {
  let end = glyphs.splice(rangeB[0] - (rangeB[1] - 1), rangeB[1]);
  if (reverseB) end.reverse();
  let start = glyphs.splice(rangeA[0], rangeA[1], ...end);
  if (reverseA) start.reverse();
  glyphs.splice(rangeB[0] - (rangeA[1] - 1), 0, ...start);
  return glyphs;
}
function $55f71433a605c87d$var$reorderGlyphs(glyphs, verb, firstGlyph, lastGlyph) {
  let length2 = lastGlyph - firstGlyph + 1;
  switch (verb) {
    case 0:
      return glyphs;
    case 1:
      return $55f71433a605c87d$var$swap(glyphs, [
        firstGlyph,
        1
      ], [
        lastGlyph,
        0
      ]);
    case 2:
      return $55f71433a605c87d$var$swap(glyphs, [
        firstGlyph,
        0
      ], [
        lastGlyph,
        1
      ]);
    case 3:
      return $55f71433a605c87d$var$swap(glyphs, [
        firstGlyph,
        1
      ], [
        lastGlyph,
        1
      ]);
    case 4:
      return $55f71433a605c87d$var$swap(glyphs, [
        firstGlyph,
        2
      ], [
        lastGlyph,
        0
      ]);
    case 5:
      return $55f71433a605c87d$var$swap(glyphs, [
        firstGlyph,
        2
      ], [
        lastGlyph,
        0
      ], true, false);
    case 6:
      return $55f71433a605c87d$var$swap(glyphs, [
        firstGlyph,
        0
      ], [
        lastGlyph,
        2
      ]);
    case 7:
      return $55f71433a605c87d$var$swap(glyphs, [
        firstGlyph,
        0
      ], [
        lastGlyph,
        2
      ], false, true);
    case 8:
      return $55f71433a605c87d$var$swap(glyphs, [
        firstGlyph,
        1
      ], [
        lastGlyph,
        2
      ]);
    case 9:
      return $55f71433a605c87d$var$swap(glyphs, [
        firstGlyph,
        1
      ], [
        lastGlyph,
        2
      ], false, true);
    case 10:
      return $55f71433a605c87d$var$swap(glyphs, [
        firstGlyph,
        2
      ], [
        lastGlyph,
        1
      ]);
    case 11:
      return $55f71433a605c87d$var$swap(glyphs, [
        firstGlyph,
        2
      ], [
        lastGlyph,
        1
      ], true, false);
    case 12:
      return $55f71433a605c87d$var$swap(glyphs, [
        firstGlyph,
        2
      ], [
        lastGlyph,
        2
      ]);
    case 13:
      return $55f71433a605c87d$var$swap(glyphs, [
        firstGlyph,
        2
      ], [
        lastGlyph,
        2
      ], true, false);
    case 14:
      return $55f71433a605c87d$var$swap(glyphs, [
        firstGlyph,
        2
      ], [
        lastGlyph,
        2
      ], false, true);
    case 15:
      return $55f71433a605c87d$var$swap(glyphs, [
        firstGlyph,
        2
      ], [
        lastGlyph,
        2
      ], true, true);
    default:
      throw new Error(`Unknown verb: ${verb}`);
  }
}
var $ba6dd74203be8728$export$2e2bcd8739ae039 = class {
  substitute(glyphRun) {
    if (glyphRun.direction === "rtl") glyphRun.glyphs.reverse();
    this.morxProcessor.process(glyphRun.glyphs, $3b6302b64eccc32c$export$b813f7d2a1677c16(glyphRun.features));
  }
  getAvailableFeatures(script, language) {
    return $3b6302b64eccc32c$export$bd6df347a4f391c4(this.morxProcessor.getSupportedFeatures());
  }
  stringsForGlyph(gid) {
    let glyphStrings = this.morxProcessor.generateInputs(gid);
    let result = /* @__PURE__ */ new Set();
    for (let glyphs of glyphStrings) this._addStrings(glyphs, 0, result, "");
    return result;
  }
  _addStrings(glyphs, index3, strings, string3) {
    let codePoints = this.font._cmapProcessor.codePointsForGlyph(glyphs[index3]);
    for (let codePoint of codePoints) {
      let s = string3 + String.fromCodePoint(codePoint);
      if (index3 < glyphs.length - 1) this._addStrings(glyphs, index3 + 1, strings, s);
      else strings.add(s);
    }
  }
  constructor(font) {
    this.font = font;
    this.morxProcessor = new (0, $55f71433a605c87d$export$2e2bcd8739ae039)(font);
    this.fallbackPosition = false;
  }
};
var $94d7a73bd2edfc9a$export$2e2bcd8739ae039 = class {
  /**
  * Adds the given features to the last stage.
  * Ignores features that have already been applied.
  */
  _addFeatures(features, global2) {
    let stageIndex = this.stages.length - 1;
    let stage = this.stages[stageIndex];
    for (let feature of features) if (this.allFeatures[feature] == null) {
      stage.push(feature);
      this.allFeatures[feature] = stageIndex;
      if (global2) this.globalFeatures[feature] = true;
    }
  }
  /**
  * Add features to the last stage
  */
  add(arg, global2 = true) {
    if (this.stages.length === 0) this.stages.push([]);
    if (typeof arg === "string") arg = [
      arg
    ];
    if (Array.isArray(arg)) this._addFeatures(arg, global2);
    else if (typeof arg === "object") {
      this._addFeatures(arg.global || [], true);
      this._addFeatures(arg.local || [], false);
    } else throw new Error("Unsupported argument to ShapingPlan#add");
  }
  /**
  * Add a new stage
  */
  addStage(arg, global2) {
    if (typeof arg === "function") this.stages.push(arg, []);
    else {
      this.stages.push([]);
      this.add(arg, global2);
    }
  }
  setFeatureOverrides(features) {
    if (Array.isArray(features)) this.add(features);
    else if (typeof features === "object") for (let tag in features) {
      if (features[tag]) this.add(tag);
      else if (this.allFeatures[tag] != null) {
        let stage = this.stages[this.allFeatures[tag]];
        stage.splice(stage.indexOf(tag), 1);
        delete this.allFeatures[tag];
        delete this.globalFeatures[tag];
      }
    }
  }
  /**
  * Assigns the global features to the given glyphs
  */
  assignGlobalFeatures(glyphs) {
    for (let glyph of glyphs) for (let feature in this.globalFeatures) glyph.features[feature] = true;
  }
  /**
  * Executes the planned stages using the given OTProcessor
  */
  process(processor, glyphs, positions) {
    for (let stage of this.stages) {
      if (typeof stage === "function") {
        if (!positions) stage(this.font, glyphs, this);
      } else if (stage.length > 0) processor.applyFeatures(stage, glyphs, positions);
    }
  }
  constructor(font, script, direction) {
    this.font = font;
    this.script = script;
    this.direction = direction;
    this.stages = [];
    this.globalFeatures = {};
    this.allFeatures = {};
  }
};
var $649970d87335b30f$var$VARIATION_FEATURES = [
  "rvrn"
];
var $649970d87335b30f$var$COMMON_FEATURES = [
  "ccmp",
  "locl",
  "rlig",
  "mark",
  "mkmk"
];
var $649970d87335b30f$var$FRACTIONAL_FEATURES = [
  "frac",
  "numr",
  "dnom"
];
var $649970d87335b30f$var$HORIZONTAL_FEATURES = [
  "calt",
  "clig",
  "liga",
  "rclt",
  "curs",
  "kern"
];
var $649970d87335b30f$var$DIRECTIONAL_FEATURES = {
  ltr: [
    "ltra",
    "ltrm"
  ],
  rtl: [
    "rtla",
    "rtlm"
  ]
};
var $649970d87335b30f$export$2e2bcd8739ae039 = class {
  static plan(plan, glyphs, features) {
    this.planPreprocessing(plan);
    this.planFeatures(plan);
    this.planPostprocessing(plan, features);
    plan.assignGlobalFeatures(glyphs);
    this.assignFeatures(plan, glyphs);
  }
  static planPreprocessing(plan) {
    plan.add({
      global: [
        ...$649970d87335b30f$var$VARIATION_FEATURES,
        ...$649970d87335b30f$var$DIRECTIONAL_FEATURES[plan.direction]
      ],
      local: $649970d87335b30f$var$FRACTIONAL_FEATURES
    });
  }
  static planFeatures(plan) {
  }
  static planPostprocessing(plan, userFeatures) {
    plan.add([
      ...$649970d87335b30f$var$COMMON_FEATURES,
      ...$649970d87335b30f$var$HORIZONTAL_FEATURES
    ]);
    plan.setFeatureOverrides(userFeatures);
  }
  static assignFeatures(plan, glyphs) {
    for (let i = 0; i < glyphs.length; i++) {
      let glyph = glyphs[i];
      if (glyph.codePoints[0] === 8260) {
        let start = i;
        let end = i + 1;
        while (start > 0 && (0, $747425b437e121da$export$727d9dbc4fbb948f)(glyphs[start - 1].codePoints[0])) {
          glyphs[start - 1].features.numr = true;
          glyphs[start - 1].features.frac = true;
          start--;
        }
        while (end < glyphs.length && (0, $747425b437e121da$export$727d9dbc4fbb948f)(glyphs[end].codePoints[0])) {
          glyphs[end].features.dnom = true;
          glyphs[end].features.frac = true;
          end++;
        }
        glyph.features.frac = true;
        i = end - 1;
      }
    }
  }
};
(0, _define_property)($649970d87335b30f$export$2e2bcd8739ae039, "zeroMarkWidths", "AFTER_GPOS");
var $764eb544bbe1ccf0$var$trie = new (0, import_unicode_trie2.default)((0, $12727730ddfc8bfe$export$94fdf11bafc8de6b)("APABAAAAAAAAOAAAAf0BAv7tmi1MxDAUx7vtvjhAgcDgkEgEAnmXEBIMCYaEcygEiqBQ4FAkCE4ikUgMiiBJSAgSiUQSDMn9L9eSl6bddddug9t7yS/trevre+3r27pcNxZiG+yCfdCVv/9LeQxOwRm4AJegD27ALbgD9+ABPJF+z+BN/h7yDj5k/VOWX6SdmU5+wLWknggxDxaS8u0qiiX4uiz9XamQ3wzDMAzDMAzDMAzDVI/h959V/v7BMAzDMAzDMLlyNTNiMSdewVxbiA44B4/guz1qW58VYlMI0WsJ0W+N6kXw0spvPtdwhtkwnGM6uLaV4Xyzg3v3PM9DPfQ/sOg4xPWjipy31P8LTqbU304c/cLCUmWJLNB2Uz2U1KTeRKNmKHVMfbJC+/0loTZRH/W5cvEvBJPMbREkWt3FD1NcqXZBSpuE2Ad0PBehPtNrPtIEdYP+hiRt/V1jIiE69X4NT/uVZI3PUHE9bm5M7ePGdZWy951v7Nn6j8v1WWKP3mt6ttnsigx6VN7Vc0VomSSGqW2mGNP1muZPl7LfjNUaKNFtDGVf2fvE9O7VlBS5j333c5p/eeoOqcs1R/hIqDWLJ7TTlksirVT1SI7l8k4Yp+g3jafGcrU1RM6l9th80XOpnlN97bDNY4i4s61B0Si/ipa0uHMl6zqEjlFfCZm/TM8KmzQDjmuTAQ=="));
var $764eb544bbe1ccf0$var$FEATURES = [
  "isol",
  "fina",
  "fin2",
  "fin3",
  "medi",
  "med2",
  "init"
];
var $764eb544bbe1ccf0$var$ShapingClasses = {
  Non_Joining: 0,
  Left_Joining: 1,
  Right_Joining: 2,
  Dual_Joining: 3,
  Join_Causing: 3,
  ALAPH: 4,
  "DALATH RISH": 5,
  Transparent: 6
};
var $764eb544bbe1ccf0$var$ISOL = "isol";
var $764eb544bbe1ccf0$var$FINA = "fina";
var $764eb544bbe1ccf0$var$FIN2 = "fin2";
var $764eb544bbe1ccf0$var$FIN3 = "fin3";
var $764eb544bbe1ccf0$var$MEDI = "medi";
var $764eb544bbe1ccf0$var$MED2 = "med2";
var $764eb544bbe1ccf0$var$INIT = "init";
var $764eb544bbe1ccf0$var$NONE = null;
var $764eb544bbe1ccf0$var$STATE_TABLE = [
  //   Non_Joining,        Left_Joining,       Right_Joining,     Dual_Joining,           ALAPH,            DALATH RISH
  // State 0: prev was U,  not willing to join.
  [
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$NONE,
      0
    ],
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$ISOL,
      2
    ],
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$ISOL,
      1
    ],
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$ISOL,
      2
    ],
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$ISOL,
      1
    ],
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$ISOL,
      6
    ]
  ],
  // State 1: prev was R or ISOL/ALAPH,  not willing to join.
  [
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$NONE,
      0
    ],
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$ISOL,
      2
    ],
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$ISOL,
      1
    ],
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$ISOL,
      2
    ],
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$FIN2,
      5
    ],
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$ISOL,
      6
    ]
  ],
  // State 2: prev was D/L in ISOL form,  willing to join.
  [
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$NONE,
      0
    ],
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$ISOL,
      2
    ],
    [
      $764eb544bbe1ccf0$var$INIT,
      $764eb544bbe1ccf0$var$FINA,
      1
    ],
    [
      $764eb544bbe1ccf0$var$INIT,
      $764eb544bbe1ccf0$var$FINA,
      3
    ],
    [
      $764eb544bbe1ccf0$var$INIT,
      $764eb544bbe1ccf0$var$FINA,
      4
    ],
    [
      $764eb544bbe1ccf0$var$INIT,
      $764eb544bbe1ccf0$var$FINA,
      6
    ]
  ],
  // State 3: prev was D in FINA form,  willing to join.
  [
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$NONE,
      0
    ],
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$ISOL,
      2
    ],
    [
      $764eb544bbe1ccf0$var$MEDI,
      $764eb544bbe1ccf0$var$FINA,
      1
    ],
    [
      $764eb544bbe1ccf0$var$MEDI,
      $764eb544bbe1ccf0$var$FINA,
      3
    ],
    [
      $764eb544bbe1ccf0$var$MEDI,
      $764eb544bbe1ccf0$var$FINA,
      4
    ],
    [
      $764eb544bbe1ccf0$var$MEDI,
      $764eb544bbe1ccf0$var$FINA,
      6
    ]
  ],
  // State 4: prev was FINA ALAPH,  not willing to join.
  [
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$NONE,
      0
    ],
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$ISOL,
      2
    ],
    [
      $764eb544bbe1ccf0$var$MED2,
      $764eb544bbe1ccf0$var$ISOL,
      1
    ],
    [
      $764eb544bbe1ccf0$var$MED2,
      $764eb544bbe1ccf0$var$ISOL,
      2
    ],
    [
      $764eb544bbe1ccf0$var$MED2,
      $764eb544bbe1ccf0$var$FIN2,
      5
    ],
    [
      $764eb544bbe1ccf0$var$MED2,
      $764eb544bbe1ccf0$var$ISOL,
      6
    ]
  ],
  // State 5: prev was FIN2/FIN3 ALAPH,  not willing to join.
  [
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$NONE,
      0
    ],
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$ISOL,
      2
    ],
    [
      $764eb544bbe1ccf0$var$ISOL,
      $764eb544bbe1ccf0$var$ISOL,
      1
    ],
    [
      $764eb544bbe1ccf0$var$ISOL,
      $764eb544bbe1ccf0$var$ISOL,
      2
    ],
    [
      $764eb544bbe1ccf0$var$ISOL,
      $764eb544bbe1ccf0$var$FIN2,
      5
    ],
    [
      $764eb544bbe1ccf0$var$ISOL,
      $764eb544bbe1ccf0$var$ISOL,
      6
    ]
  ],
  // State 6: prev was DALATH/RISH,  not willing to join.
  [
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$NONE,
      0
    ],
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$ISOL,
      2
    ],
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$ISOL,
      1
    ],
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$ISOL,
      2
    ],
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$FIN3,
      5
    ],
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$ISOL,
      6
    ]
  ]
];
var $764eb544bbe1ccf0$export$2e2bcd8739ae039 = class extends (0, $649970d87335b30f$export$2e2bcd8739ae039) {
  static planFeatures(plan) {
    plan.add([
      "ccmp",
      "locl"
    ]);
    for (let i = 0; i < $764eb544bbe1ccf0$var$FEATURES.length; i++) {
      let feature = $764eb544bbe1ccf0$var$FEATURES[i];
      plan.addStage(feature, false);
    }
    plan.addStage("mset");
  }
  static assignFeatures(plan, glyphs) {
    super.assignFeatures(plan, glyphs);
    let prev2 = -1;
    let state = 0;
    let actions = [];
    for (let i = 0; i < glyphs.length; i++) {
      let curAction, prevAction;
      var glyph = glyphs[i];
      let type5 = $764eb544bbe1ccf0$var$getShapingClass(glyph.codePoints[0]);
      if (type5 === $764eb544bbe1ccf0$var$ShapingClasses.Transparent) {
        actions[i] = $764eb544bbe1ccf0$var$NONE;
        continue;
      }
      [prevAction, curAction, state] = $764eb544bbe1ccf0$var$STATE_TABLE[state][type5];
      if (prevAction !== $764eb544bbe1ccf0$var$NONE && prev2 !== -1) actions[prev2] = prevAction;
      actions[i] = curAction;
      prev2 = i;
    }
    for (let index3 = 0; index3 < glyphs.length; index3++) {
      let feature;
      var glyph = glyphs[index3];
      if (feature = actions[index3]) glyph.features[feature] = true;
    }
  }
};
function $764eb544bbe1ccf0$var$getShapingClass(codePoint) {
  let res = $764eb544bbe1ccf0$var$trie.get(codePoint);
  if (res) return res - 1;
  let category = (0, $747425b437e121da$export$410364bbb673ddbc)(codePoint);
  if (category === "Mn" || category === "Me" || category === "Cf") return $764eb544bbe1ccf0$var$ShapingClasses.Transparent;
  return $764eb544bbe1ccf0$var$ShapingClasses.Non_Joining;
}
var $85d408632270248b$export$2e2bcd8739ae039 = class {
  reset(options = {}, index3 = 0) {
    this.options = options;
    this.flags = options.flags || {};
    this.markAttachmentType = options.markAttachmentType || 0;
    this.index = index3;
  }
  get cur() {
    return this.glyphs[this.index] || null;
  }
  shouldIgnore(glyph) {
    return this.flags.ignoreMarks && glyph.isMark || this.flags.ignoreBaseGlyphs && glyph.isBase || this.flags.ignoreLigatures && glyph.isLigature || this.markAttachmentType && glyph.isMark && glyph.markAttachmentType !== this.markAttachmentType;
  }
  move(dir) {
    this.index += dir;
    while (0 <= this.index && this.index < this.glyphs.length && this.shouldIgnore(this.glyphs[this.index])) this.index += dir;
    if (0 > this.index || this.index >= this.glyphs.length) return null;
    return this.glyphs[this.index];
  }
  next() {
    return this.move(1);
  }
  prev() {
    return this.move(-1);
  }
  peek(count = 1) {
    let idx = this.index;
    let res = this.increment(count);
    this.index = idx;
    return res;
  }
  peekIndex(count = 1) {
    let idx = this.index;
    this.increment(count);
    let res = this.index;
    this.index = idx;
    return res;
  }
  increment(count = 1) {
    let dir = count < 0 ? -1 : 1;
    count = Math.abs(count);
    while (count--) this.move(dir);
    return this.glyphs[this.index];
  }
  constructor(glyphs, options) {
    this.glyphs = glyphs;
    this.reset(options);
  }
};
var $a83b9c36aaa94fd3$var$DEFAULT_SCRIPTS = [
  "DFLT",
  "dflt",
  "latn"
];
var $a83b9c36aaa94fd3$export$2e2bcd8739ae039 = class {
  findScript(script) {
    if (this.table.scriptList == null) return null;
    if (!Array.isArray(script)) script = [
      script
    ];
    for (let s of script) for (let entry of this.table.scriptList) {
      if (entry.tag === s) return entry;
    }
    return null;
  }
  selectScript(script, language, direction) {
    let changed = false;
    let entry;
    if (!this.script || script !== this.scriptTag) {
      entry = this.findScript(script);
      if (!entry) entry = this.findScript($a83b9c36aaa94fd3$var$DEFAULT_SCRIPTS);
      if (!entry) return this.scriptTag;
      this.scriptTag = entry.tag;
      this.script = entry.script;
      this.language = null;
      this.languageTag = null;
      changed = true;
    }
    if (!direction || direction !== this.direction) this.direction = direction || $130d1a642ebcd2b7$export$9fddb9d0dd7d8a54(script);
    if (language && language.length < 4) language += " ".repeat(4 - language.length);
    if (!language || language !== this.languageTag) {
      this.language = null;
      for (let lang of this.script.langSysRecords) if (lang.tag === language) {
        this.language = lang.langSys;
        this.languageTag = lang.tag;
        break;
      }
      if (!this.language) {
        this.language = this.script.defaultLangSys;
        this.languageTag = null;
      }
      changed = true;
    }
    if (changed) {
      this.features = {};
      if (this.language) for (let featureIndex of this.language.featureIndexes) {
        let record = this.table.featureList[featureIndex];
        let substituteFeature = this.substituteFeatureForVariations(featureIndex);
        this.features[record.tag] = substituteFeature || record.feature;
      }
    }
    return this.scriptTag;
  }
  lookupsForFeatures(userFeatures = [], exclude) {
    let lookups = [];
    for (let tag of userFeatures) {
      let feature = this.features[tag];
      if (!feature) continue;
      for (let lookupIndex of feature.lookupListIndexes) {
        if (exclude && exclude.indexOf(lookupIndex) !== -1) continue;
        lookups.push({
          feature: tag,
          index: lookupIndex,
          lookup: this.table.lookupList.get(lookupIndex)
        });
      }
    }
    lookups.sort((a, b) => a.index - b.index);
    return lookups;
  }
  substituteFeatureForVariations(featureIndex) {
    if (this.variationsIndex === -1) return null;
    let record = this.table.featureVariations.featureVariationRecords[this.variationsIndex];
    let substitutions = record.featureTableSubstitution.substitutions;
    for (let substitution of substitutions) {
      if (substitution.featureIndex === featureIndex) return substitution.alternateFeatureTable;
    }
    return null;
  }
  findVariationsIndex(coords) {
    let variations = this.table.featureVariations;
    if (!variations) return -1;
    let records = variations.featureVariationRecords;
    for (let i = 0; i < records.length; i++) {
      let conditions = records[i].conditionSet.conditionTable;
      if (this.variationConditionsMatch(conditions, coords)) return i;
    }
    return -1;
  }
  variationConditionsMatch(conditions, coords) {
    return conditions.every((condition) => {
      let coord = condition.axisIndex < coords.length ? coords[condition.axisIndex] : 0;
      return condition.filterRangeMinValue <= coord && coord <= condition.filterRangeMaxValue;
    });
  }
  applyFeatures(userFeatures, glyphs, advances) {
    let lookups = this.lookupsForFeatures(userFeatures);
    this.applyLookups(lookups, glyphs, advances);
  }
  applyLookups(lookups, glyphs, positions) {
    this.glyphs = glyphs;
    this.positions = positions;
    this.glyphIterator = new (0, $85d408632270248b$export$2e2bcd8739ae039)(glyphs);
    for (let { feature, lookup } of lookups) {
      this.currentFeature = feature;
      this.glyphIterator.reset(lookup.flags);
      while (this.glyphIterator.index < glyphs.length) {
        if (!(feature in this.glyphIterator.cur.features)) {
          this.glyphIterator.next();
          continue;
        }
        for (let table of lookup.subTables) {
          let res = this.applyLookup(lookup.lookupType, table);
          if (res) break;
        }
        this.glyphIterator.next();
      }
    }
  }
  applyLookup(lookup, table) {
    throw new Error("applyLookup must be implemented by subclasses");
  }
  applyLookupList(lookupRecords) {
    let options = this.glyphIterator.options;
    let glyphIndex = this.glyphIterator.index;
    for (let lookupRecord of lookupRecords) {
      this.glyphIterator.reset(options, glyphIndex);
      this.glyphIterator.increment(lookupRecord.sequenceIndex);
      let lookup = this.table.lookupList.get(lookupRecord.lookupListIndex);
      this.glyphIterator.reset(lookup.flags, this.glyphIterator.index);
      for (let table of lookup.subTables) {
        if (this.applyLookup(lookup.lookupType, table)) break;
      }
    }
    this.glyphIterator.reset(options, glyphIndex);
    return true;
  }
  coverageIndex(coverage, glyph) {
    if (glyph == null) glyph = this.glyphIterator.cur.id;
    switch (coverage.version) {
      case 1:
        return coverage.glyphs.indexOf(glyph);
      case 2:
        for (let range3 of coverage.rangeRecords) {
          if (range3.start <= glyph && glyph <= range3.end) return range3.startCoverageIndex + glyph - range3.start;
        }
        break;
    }
    return -1;
  }
  match(sequenceIndex, sequence, fn, matched) {
    let pos = this.glyphIterator.index;
    let glyph = this.glyphIterator.increment(sequenceIndex);
    let idx = 0;
    while (idx < sequence.length && glyph && fn(sequence[idx], glyph)) {
      if (matched) matched.push(this.glyphIterator.index);
      idx++;
      glyph = this.glyphIterator.next();
    }
    this.glyphIterator.index = pos;
    if (idx < sequence.length) return false;
    return matched || true;
  }
  sequenceMatches(sequenceIndex, sequence) {
    return this.match(sequenceIndex, sequence, (component, glyph) => component === glyph.id);
  }
  sequenceMatchIndices(sequenceIndex, sequence) {
    return this.match(sequenceIndex, sequence, (component, glyph) => {
      if (!(this.currentFeature in glyph.features)) return false;
      return component === glyph.id;
    }, []);
  }
  coverageSequenceMatches(sequenceIndex, sequence) {
    return this.match(sequenceIndex, sequence, (coverage, glyph) => this.coverageIndex(coverage, glyph.id) >= 0);
  }
  getClassID(glyph, classDef) {
    switch (classDef.version) {
      case 1:
        let i = glyph - classDef.startGlyph;
        if (i >= 0 && i < classDef.classValueArray.length) return classDef.classValueArray[i];
        break;
      case 2:
        for (let range3 of classDef.classRangeRecord) {
          if (range3.start <= glyph && glyph <= range3.end) return range3.class;
        }
        break;
    }
    return 0;
  }
  classSequenceMatches(sequenceIndex, sequence, classDef) {
    return this.match(sequenceIndex, sequence, (classID, glyph) => classID === this.getClassID(glyph.id, classDef));
  }
  applyContext(table) {
    let index3, set4;
    switch (table.version) {
      case 1:
        index3 = this.coverageIndex(table.coverage);
        if (index3 === -1) return false;
        set4 = table.ruleSets[index3];
        for (let rule of set4) {
          if (this.sequenceMatches(1, rule.input)) return this.applyLookupList(rule.lookupRecords);
        }
        break;
      case 2:
        if (this.coverageIndex(table.coverage) === -1) return false;
        index3 = this.getClassID(this.glyphIterator.cur.id, table.classDef);
        if (index3 === -1) return false;
        set4 = table.classSet[index3];
        for (let rule of set4) {
          if (this.classSequenceMatches(1, rule.classes, table.classDef)) return this.applyLookupList(rule.lookupRecords);
        }
        break;
      case 3:
        if (this.coverageSequenceMatches(0, table.coverages)) return this.applyLookupList(table.lookupRecords);
        break;
    }
    return false;
  }
  applyChainingContext(table) {
    let index3;
    switch (table.version) {
      case 1:
        index3 = this.coverageIndex(table.coverage);
        if (index3 === -1) return false;
        let set4 = table.chainRuleSets[index3];
        for (let rule of set4) {
          if (this.sequenceMatches(-rule.backtrack.length, rule.backtrack) && this.sequenceMatches(1, rule.input) && this.sequenceMatches(1 + rule.input.length, rule.lookahead)) return this.applyLookupList(rule.lookupRecords);
        }
        break;
      case 2:
        if (this.coverageIndex(table.coverage) === -1) return false;
        index3 = this.getClassID(this.glyphIterator.cur.id, table.inputClassDef);
        let rules = table.chainClassSet[index3];
        if (!rules) return false;
        for (let rule of rules) {
          if (this.classSequenceMatches(-rule.backtrack.length, rule.backtrack, table.backtrackClassDef) && this.classSequenceMatches(1, rule.input, table.inputClassDef) && this.classSequenceMatches(1 + rule.input.length, rule.lookahead, table.lookaheadClassDef)) return this.applyLookupList(rule.lookupRecords);
        }
        break;
      case 3:
        if (this.coverageSequenceMatches(-table.backtrackGlyphCount, table.backtrackCoverage) && this.coverageSequenceMatches(0, table.inputCoverage) && this.coverageSequenceMatches(table.inputGlyphCount, table.lookaheadCoverage)) return this.applyLookupList(table.lookupRecords);
        break;
    }
    return false;
  }
  constructor(font, table) {
    this.font = font;
    this.table = table;
    this.script = null;
    this.scriptTag = null;
    this.language = null;
    this.languageTag = null;
    this.features = {};
    this.lookups = {};
    this.variationsIndex = font._variationProcessor ? this.findVariationsIndex(font._variationProcessor.normalizedCoords) : -1;
    this.selectScript();
    this.glyphs = [];
    this.positions = [];
    this.ligatureID = 1;
    this.currentFeature = null;
  }
};
var $10e7b257e1a9a756$export$2e2bcd8739ae039 = class _$10e7b257e1a9a756$export$2e2bcd8739ae039 {
  get id() {
    return this._id;
  }
  set id(id) {
    this._id = id;
    this.substituted = true;
    let GDEF = this._font.GDEF;
    if (GDEF && GDEF.glyphClassDef) {
      let classID = (0, $a83b9c36aaa94fd3$export$2e2bcd8739ae039).prototype.getClassID(id, GDEF.glyphClassDef);
      this.isBase = classID === 1;
      this.isLigature = classID === 2;
      this.isMark = classID === 3;
      this.markAttachmentType = GDEF.markAttachClassDef ? (0, $a83b9c36aaa94fd3$export$2e2bcd8739ae039).prototype.getClassID(id, GDEF.markAttachClassDef) : 0;
    } else {
      this.isMark = this.codePoints.length > 0 && this.codePoints.every((0, $747425b437e121da$export$e33ad6871e762338));
      this.isBase = !this.isMark;
      this.isLigature = this.codePoints.length > 1;
      this.markAttachmentType = 0;
    }
  }
  copy() {
    return new _$10e7b257e1a9a756$export$2e2bcd8739ae039(this._font, this.id, this.codePoints, this.features);
  }
  constructor(font, id, codePoints = [], features) {
    this._font = font;
    this.codePoints = codePoints;
    this.id = id;
    this.features = {};
    if (Array.isArray(features)) for (let i = 0; i < features.length; i++) {
      let feature = features[i];
      this.features[feature] = true;
    }
    else if (typeof features === "object") Object.assign(this.features, features);
    this.ligatureID = null;
    this.ligatureComponent = null;
    this.isLigated = false;
    this.cursiveAttachment = null;
    this.markAttachment = null;
    this.shaperInfo = null;
    this.substituted = false;
    this.isMultiplied = false;
  }
};
var $e1c6bbc8cb416f8c$export$2e2bcd8739ae039 = class extends (0, $649970d87335b30f$export$2e2bcd8739ae039) {
  static planFeatures(plan) {
    plan.add([
      "ljmo",
      "vjmo",
      "tjmo"
    ], false);
  }
  static assignFeatures(plan, glyphs) {
    let state = 0;
    let i = 0;
    while (i < glyphs.length) {
      let action;
      let glyph = glyphs[i];
      let code2 = glyph.codePoints[0];
      let type5 = $e1c6bbc8cb416f8c$var$getType(code2);
      [action, state] = $e1c6bbc8cb416f8c$var$STATE_TABLE[state][type5];
      switch (action) {
        case $e1c6bbc8cb416f8c$var$DECOMPOSE:
          if (!plan.font.hasGlyphForCodePoint(code2)) i = $e1c6bbc8cb416f8c$var$decompose(glyphs, i, plan.font);
          break;
        case $e1c6bbc8cb416f8c$var$COMPOSE:
          i = $e1c6bbc8cb416f8c$var$compose(glyphs, i, plan.font);
          break;
        case $e1c6bbc8cb416f8c$var$TONE_MARK:
          $e1c6bbc8cb416f8c$var$reorderToneMark(glyphs, i, plan.font);
          break;
        case $e1c6bbc8cb416f8c$var$INVALID:
          i = $e1c6bbc8cb416f8c$var$insertDottedCircle(glyphs, i, plan.font);
          break;
      }
      i++;
    }
  }
};
(0, _define_property)($e1c6bbc8cb416f8c$export$2e2bcd8739ae039, "zeroMarkWidths", "NONE");
var $e1c6bbc8cb416f8c$var$HANGUL_BASE = 44032;
var $e1c6bbc8cb416f8c$var$HANGUL_END = 55204;
var $e1c6bbc8cb416f8c$var$HANGUL_COUNT = $e1c6bbc8cb416f8c$var$HANGUL_END - $e1c6bbc8cb416f8c$var$HANGUL_BASE + 1;
var $e1c6bbc8cb416f8c$var$L_BASE = 4352;
var $e1c6bbc8cb416f8c$var$V_BASE = 4449;
var $e1c6bbc8cb416f8c$var$T_BASE = 4519;
var $e1c6bbc8cb416f8c$var$L_COUNT = 19;
var $e1c6bbc8cb416f8c$var$V_COUNT = 21;
var $e1c6bbc8cb416f8c$var$T_COUNT = 28;
var $e1c6bbc8cb416f8c$var$L_END = $e1c6bbc8cb416f8c$var$L_BASE + $e1c6bbc8cb416f8c$var$L_COUNT - 1;
var $e1c6bbc8cb416f8c$var$V_END = $e1c6bbc8cb416f8c$var$V_BASE + $e1c6bbc8cb416f8c$var$V_COUNT - 1;
var $e1c6bbc8cb416f8c$var$T_END = $e1c6bbc8cb416f8c$var$T_BASE + $e1c6bbc8cb416f8c$var$T_COUNT - 1;
var $e1c6bbc8cb416f8c$var$DOTTED_CIRCLE = 9676;
var $e1c6bbc8cb416f8c$var$isL = (code2) => 4352 <= code2 && code2 <= 4447 || 43360 <= code2 && code2 <= 43388;
var $e1c6bbc8cb416f8c$var$isV = (code2) => 4448 <= code2 && code2 <= 4519 || 55216 <= code2 && code2 <= 55238;
var $e1c6bbc8cb416f8c$var$isT = (code2) => 4520 <= code2 && code2 <= 4607 || 55243 <= code2 && code2 <= 55291;
var $e1c6bbc8cb416f8c$var$isTone = (code2) => 12334 <= code2 && code2 <= 12335;
var $e1c6bbc8cb416f8c$var$isLVT = (code2) => $e1c6bbc8cb416f8c$var$HANGUL_BASE <= code2 && code2 <= $e1c6bbc8cb416f8c$var$HANGUL_END;
var $e1c6bbc8cb416f8c$var$isLV = (code2) => code2 - $e1c6bbc8cb416f8c$var$HANGUL_BASE < $e1c6bbc8cb416f8c$var$HANGUL_COUNT && (code2 - $e1c6bbc8cb416f8c$var$HANGUL_BASE) % $e1c6bbc8cb416f8c$var$T_COUNT === 0;
var $e1c6bbc8cb416f8c$var$isCombiningL = (code2) => $e1c6bbc8cb416f8c$var$L_BASE <= code2 && code2 <= $e1c6bbc8cb416f8c$var$L_END;
var $e1c6bbc8cb416f8c$var$isCombiningV = (code2) => $e1c6bbc8cb416f8c$var$V_BASE <= code2 && code2 <= $e1c6bbc8cb416f8c$var$V_END;
var $e1c6bbc8cb416f8c$var$isCombiningT = (code2) => $e1c6bbc8cb416f8c$var$T_BASE + 1 && 1 <= code2 && code2 <= $e1c6bbc8cb416f8c$var$T_END;
var $e1c6bbc8cb416f8c$var$X = 0;
var $e1c6bbc8cb416f8c$var$L = 1;
var $e1c6bbc8cb416f8c$var$V = 2;
var $e1c6bbc8cb416f8c$var$T = 3;
var $e1c6bbc8cb416f8c$var$LV = 4;
var $e1c6bbc8cb416f8c$var$LVT = 5;
var $e1c6bbc8cb416f8c$var$M = 6;
function $e1c6bbc8cb416f8c$var$getType(code2) {
  if ($e1c6bbc8cb416f8c$var$isL(code2)) return $e1c6bbc8cb416f8c$var$L;
  if ($e1c6bbc8cb416f8c$var$isV(code2)) return $e1c6bbc8cb416f8c$var$V;
  if ($e1c6bbc8cb416f8c$var$isT(code2)) return $e1c6bbc8cb416f8c$var$T;
  if ($e1c6bbc8cb416f8c$var$isLV(code2)) return $e1c6bbc8cb416f8c$var$LV;
  if ($e1c6bbc8cb416f8c$var$isLVT(code2)) return $e1c6bbc8cb416f8c$var$LVT;
  if ($e1c6bbc8cb416f8c$var$isTone(code2)) return $e1c6bbc8cb416f8c$var$M;
  return $e1c6bbc8cb416f8c$var$X;
}
var $e1c6bbc8cb416f8c$var$NO_ACTION = 0;
var $e1c6bbc8cb416f8c$var$DECOMPOSE = 1;
var $e1c6bbc8cb416f8c$var$COMPOSE = 2;
var $e1c6bbc8cb416f8c$var$TONE_MARK = 4;
var $e1c6bbc8cb416f8c$var$INVALID = 5;
var $e1c6bbc8cb416f8c$var$STATE_TABLE = [
  //       X                 L                 V                T                  LV                LVT               M
  // State 0: start state
  [
    [
      $e1c6bbc8cb416f8c$var$NO_ACTION,
      0
    ],
    [
      $e1c6bbc8cb416f8c$var$NO_ACTION,
      1
    ],
    [
      $e1c6bbc8cb416f8c$var$NO_ACTION,
      0
    ],
    [
      $e1c6bbc8cb416f8c$var$NO_ACTION,
      0
    ],
    [
      $e1c6bbc8cb416f8c$var$DECOMPOSE,
      2
    ],
    [
      $e1c6bbc8cb416f8c$var$DECOMPOSE,
      3
    ],
    [
      $e1c6bbc8cb416f8c$var$INVALID,
      0
    ]
  ],
  // State 1: <L>
  [
    [
      $e1c6bbc8cb416f8c$var$NO_ACTION,
      0
    ],
    [
      $e1c6bbc8cb416f8c$var$NO_ACTION,
      1
    ],
    [
      $e1c6bbc8cb416f8c$var$COMPOSE,
      2
    ],
    [
      $e1c6bbc8cb416f8c$var$NO_ACTION,
      0
    ],
    [
      $e1c6bbc8cb416f8c$var$DECOMPOSE,
      2
    ],
    [
      $e1c6bbc8cb416f8c$var$DECOMPOSE,
      3
    ],
    [
      $e1c6bbc8cb416f8c$var$INVALID,
      0
    ]
  ],
  // State 2: <L,V> or <LV>
  [
    [
      $e1c6bbc8cb416f8c$var$NO_ACTION,
      0
    ],
    [
      $e1c6bbc8cb416f8c$var$NO_ACTION,
      1
    ],
    [
      $e1c6bbc8cb416f8c$var$NO_ACTION,
      0
    ],
    [
      $e1c6bbc8cb416f8c$var$COMPOSE,
      3
    ],
    [
      $e1c6bbc8cb416f8c$var$DECOMPOSE,
      2
    ],
    [
      $e1c6bbc8cb416f8c$var$DECOMPOSE,
      3
    ],
    [
      $e1c6bbc8cb416f8c$var$TONE_MARK,
      0
    ]
  ],
  // State 3: <L,V,T> or <LVT>
  [
    [
      $e1c6bbc8cb416f8c$var$NO_ACTION,
      0
    ],
    [
      $e1c6bbc8cb416f8c$var$NO_ACTION,
      1
    ],
    [
      $e1c6bbc8cb416f8c$var$NO_ACTION,
      0
    ],
    [
      $e1c6bbc8cb416f8c$var$NO_ACTION,
      0
    ],
    [
      $e1c6bbc8cb416f8c$var$DECOMPOSE,
      2
    ],
    [
      $e1c6bbc8cb416f8c$var$DECOMPOSE,
      3
    ],
    [
      $e1c6bbc8cb416f8c$var$TONE_MARK,
      0
    ]
  ]
];
function $e1c6bbc8cb416f8c$var$getGlyph(font, code2, features) {
  return new (0, $10e7b257e1a9a756$export$2e2bcd8739ae039)(font, font.glyphForCodePoint(code2).id, [
    code2
  ], features);
}
function $e1c6bbc8cb416f8c$var$decompose(glyphs, i, font) {
  let glyph = glyphs[i];
  let code2 = glyph.codePoints[0];
  let s = code2 - $e1c6bbc8cb416f8c$var$HANGUL_BASE;
  let t2 = $e1c6bbc8cb416f8c$var$T_BASE + s % $e1c6bbc8cb416f8c$var$T_COUNT;
  s = s / $e1c6bbc8cb416f8c$var$T_COUNT | 0;
  let l2 = $e1c6bbc8cb416f8c$var$L_BASE + s / $e1c6bbc8cb416f8c$var$V_COUNT | 0;
  let v = $e1c6bbc8cb416f8c$var$V_BASE + s % $e1c6bbc8cb416f8c$var$V_COUNT;
  if (!font.hasGlyphForCodePoint(l2) || !font.hasGlyphForCodePoint(v) || t2 !== $e1c6bbc8cb416f8c$var$T_BASE && !font.hasGlyphForCodePoint(t2)) return i;
  let ljmo = $e1c6bbc8cb416f8c$var$getGlyph(font, l2, glyph.features);
  ljmo.features.ljmo = true;
  let vjmo = $e1c6bbc8cb416f8c$var$getGlyph(font, v, glyph.features);
  vjmo.features.vjmo = true;
  let insert = [
    ljmo,
    vjmo
  ];
  if (t2 > $e1c6bbc8cb416f8c$var$T_BASE) {
    let tjmo = $e1c6bbc8cb416f8c$var$getGlyph(font, t2, glyph.features);
    tjmo.features.tjmo = true;
    insert.push(tjmo);
  }
  glyphs.splice(i, 1, ...insert);
  return i + insert.length - 1;
}
function $e1c6bbc8cb416f8c$var$compose(glyphs, i, font) {
  let glyph = glyphs[i];
  let code2 = glyphs[i].codePoints[0];
  let type5 = $e1c6bbc8cb416f8c$var$getType(code2);
  let prev2 = glyphs[i - 1].codePoints[0];
  let prevType = $e1c6bbc8cb416f8c$var$getType(prev2);
  let lv, ljmo, vjmo, tjmo;
  if (prevType === $e1c6bbc8cb416f8c$var$LV && type5 === $e1c6bbc8cb416f8c$var$T) {
    lv = prev2;
    tjmo = glyph;
  } else {
    if (type5 === $e1c6bbc8cb416f8c$var$V) {
      ljmo = glyphs[i - 1];
      vjmo = glyph;
    } else {
      ljmo = glyphs[i - 2];
      vjmo = glyphs[i - 1];
      tjmo = glyph;
    }
    let l2 = ljmo.codePoints[0];
    let v = vjmo.codePoints[0];
    if ($e1c6bbc8cb416f8c$var$isCombiningL(l2) && $e1c6bbc8cb416f8c$var$isCombiningV(v)) lv = $e1c6bbc8cb416f8c$var$HANGUL_BASE + ((l2 - $e1c6bbc8cb416f8c$var$L_BASE) * $e1c6bbc8cb416f8c$var$V_COUNT + (v - $e1c6bbc8cb416f8c$var$V_BASE)) * $e1c6bbc8cb416f8c$var$T_COUNT;
  }
  let t2 = tjmo && tjmo.codePoints[0] || $e1c6bbc8cb416f8c$var$T_BASE;
  if (lv != null && (t2 === $e1c6bbc8cb416f8c$var$T_BASE || $e1c6bbc8cb416f8c$var$isCombiningT(t2))) {
    let s = lv + (t2 - $e1c6bbc8cb416f8c$var$T_BASE);
    if (font.hasGlyphForCodePoint(s)) {
      let del = prevType === $e1c6bbc8cb416f8c$var$V ? 3 : 2;
      glyphs.splice(i - del + 1, del, $e1c6bbc8cb416f8c$var$getGlyph(font, s, glyph.features));
      return i - del + 1;
    }
  }
  if (ljmo) ljmo.features.ljmo = true;
  if (vjmo) vjmo.features.vjmo = true;
  if (tjmo) tjmo.features.tjmo = true;
  if (prevType === $e1c6bbc8cb416f8c$var$LV) {
    $e1c6bbc8cb416f8c$var$decompose(glyphs, i - 1, font);
    return i + 1;
  }
  return i;
}
function $e1c6bbc8cb416f8c$var$getLength(code2) {
  switch ($e1c6bbc8cb416f8c$var$getType(code2)) {
    case $e1c6bbc8cb416f8c$var$LV:
    case $e1c6bbc8cb416f8c$var$LVT:
      return 1;
    case $e1c6bbc8cb416f8c$var$V:
      return 2;
    case $e1c6bbc8cb416f8c$var$T:
      return 3;
  }
}
function $e1c6bbc8cb416f8c$var$reorderToneMark(glyphs, i, font) {
  let glyph = glyphs[i];
  let code2 = glyphs[i].codePoints[0];
  if (font.glyphForCodePoint(code2).advanceWidth === 0) return;
  let prev2 = glyphs[i - 1].codePoints[0];
  let len = $e1c6bbc8cb416f8c$var$getLength(prev2);
  glyphs.splice(i, 1);
  return glyphs.splice(i - len, 0, glyph);
}
function $e1c6bbc8cb416f8c$var$insertDottedCircle(glyphs, i, font) {
  let glyph = glyphs[i];
  let code2 = glyphs[i].codePoints[0];
  if (font.hasGlyphForCodePoint($e1c6bbc8cb416f8c$var$DOTTED_CIRCLE)) {
    let dottedCircle = $e1c6bbc8cb416f8c$var$getGlyph(font, $e1c6bbc8cb416f8c$var$DOTTED_CIRCLE, glyph.features);
    let idx = font.glyphForCodePoint(code2).advanceWidth === 0 ? i : i + 1;
    glyphs.splice(idx, 0, dottedCircle);
    i++;
  }
  return i;
}
var $4b0735ca6c692ea5$exports = {};
$4b0735ca6c692ea5$exports = JSON.parse('{"stateTable":[[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,2,3,4,5,6,7,8,9,0,10,11,11,12,13,14,15,16,17],[0,0,0,18,19,20,21,22,23,0,24,0,0,25,26,0,0,27,0],[0,0,0,28,29,30,31,32,33,0,34,0,0,35,36,0,0,37,0],[0,0,0,38,5,7,7,8,9,0,10,0,0,0,13,0,0,16,0],[0,39,0,0,0,40,41,0,9,0,10,0,0,0,42,0,39,0,0],[0,0,0,0,43,44,44,8,9,0,0,0,0,12,43,0,0,0,0],[0,0,0,0,43,44,44,8,9,0,0,0,0,0,43,0,0,0,0],[0,0,0,45,46,47,48,49,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,50,0,0,51,0,10,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,52,0,0,0,0,0,0,0,0],[0,0,0,53,54,55,56,57,58,0,59,0,0,60,61,0,0,62,0],[0,0,0,4,5,7,7,8,9,0,10,0,0,0,13,0,0,16,0],[0,63,64,0,0,40,41,0,9,0,10,0,0,0,42,0,63,0,0],[0,2,3,4,5,6,7,8,9,0,10,11,11,12,13,0,2,16,0],[0,0,0,18,65,20,21,22,23,0,24,0,0,25,26,0,0,27,0],[0,0,0,0,66,67,67,8,9,0,10,0,0,0,68,0,0,0,0],[0,0,0,69,0,70,70,0,71,0,72,0,0,0,0,0,0,0,0],[0,0,0,73,19,74,74,22,23,0,24,0,0,0,26,0,0,27,0],[0,75,0,0,0,76,77,0,23,0,24,0,0,0,78,0,75,0,0],[0,0,0,0,79,80,80,22,23,0,0,0,0,25,79,0,0,0,0],[0,0,0,18,19,20,74,22,23,0,24,0,0,25,26,0,0,27,0],[0,0,0,81,82,83,84,85,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,86,0,0,87,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,88,0,0,0,0,0,0,0,0],[0,0,0,18,19,74,74,22,23,0,24,0,0,0,26,0,0,27,0],[0,89,90,0,0,76,77,0,23,0,24,0,0,0,78,0,89,0,0],[0,0,0,0,91,92,92,22,23,0,24,0,0,0,93,0,0,0,0],[0,0,0,94,29,95,31,32,33,0,34,0,0,0,36,0,0,37,0],[0,96,0,0,0,97,98,0,33,0,34,0,0,0,99,0,96,0,0],[0,0,0,0,100,101,101,32,33,0,0,0,0,35,100,0,0,0,0],[0,0,0,0,100,101,101,32,33,0,0,0,0,0,100,0,0,0,0],[0,0,0,102,103,104,105,106,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,107,0,0,108,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,109,0,0,0,0,0,0,0,0],[0,0,0,28,29,95,31,32,33,0,34,0,0,0,36,0,0,37,0],[0,110,111,0,0,97,98,0,33,0,34,0,0,0,99,0,110,0,0],[0,0,0,0,112,113,113,32,33,0,34,0,0,0,114,0,0,0,0],[0,0,0,0,5,7,7,8,9,0,10,0,0,0,13,0,0,16,0],[0,0,0,115,116,117,118,8,9,0,10,0,0,119,120,0,0,16,0],[0,0,0,0,0,121,121,0,9,0,10,0,0,0,42,0,0,0,0],[0,39,0,122,0,123,123,8,9,0,10,0,0,0,42,0,39,0,0],[0,124,64,0,0,0,0,0,0,0,0,0,0,0,0,0,124,0,0],[0,39,0,0,0,121,125,0,9,0,10,0,0,0,42,0,39,0,0],[0,0,0,0,0,126,126,8,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,46,47,48,49,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,47,47,49,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,127,127,49,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,128,127,127,49,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,129,130,131,132,133,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,10,0,0,0,0,0,0,0,0],[0,0,0,0,0,50,0,0,0,0,10,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,134,0,0,0,0,0,0,0,0],[0,0,0,135,54,56,56,57,58,0,59,0,0,0,61,0,0,62,0],[0,136,0,0,0,137,138,0,58,0,59,0,0,0,139,0,136,0,0],[0,0,0,0,140,141,141,57,58,0,0,0,0,60,140,0,0,0,0],[0,0,0,0,140,141,141,57,58,0,0,0,0,0,140,0,0,0,0],[0,0,0,142,143,144,145,146,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,147,0,0,148,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,149,0,0,0,0,0,0,0,0],[0,0,0,53,54,56,56,57,58,0,59,0,0,0,61,0,0,62,0],[0,150,151,0,0,137,138,0,58,0,59,0,0,0,139,0,150,0,0],[0,0,0,0,152,153,153,57,58,0,59,0,0,0,154,0,0,0,0],[0,0,0,155,116,156,157,8,9,0,10,0,0,158,120,0,0,16,0],[0,0,0,0,0,121,121,0,9,0,10,0,0,0,0,0,0,0,0],[0,75,3,4,5,159,160,8,161,0,162,0,11,12,163,0,75,16,0],[0,0,0,0,0,40,164,0,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,165,44,44,8,9,0,0,0,0,0,165,0,0,0,0],[0,124,64,0,0,40,164,0,9,0,10,0,0,0,42,0,124,0,0],[0,0,0,0,0,70,70,0,71,0,72,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,71,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,166,0,0,167,0,72,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,168,0,0,0,0,0,0,0,0],[0,0,0,0,19,74,74,22,23,0,24,0,0,0,26,0,0,27,0],[0,0,0,0,79,80,80,22,23,0,0,0,0,0,79,0,0,0,0],[0,0,0,169,170,171,172,22,23,0,24,0,0,173,174,0,0,27,0],[0,0,0,0,0,175,175,0,23,0,24,0,0,0,78,0,0,0,0],[0,75,0,176,0,177,177,22,23,0,24,0,0,0,78,0,75,0,0],[0,178,90,0,0,0,0,0,0,0,0,0,0,0,0,0,178,0,0],[0,75,0,0,0,175,179,0,23,0,24,0,0,0,78,0,75,0,0],[0,0,0,0,0,180,180,22,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,82,83,84,85,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,83,83,85,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,181,181,85,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,182,181,181,85,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,183,184,185,186,187,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,86,0,0,0,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,188,0,0,0,0,0,0,0,0],[0,0,0,189,170,190,191,22,23,0,24,0,0,192,174,0,0,27,0],[0,0,0,0,0,175,175,0,23,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,76,193,0,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,194,80,80,22,23,0,0,0,0,0,194,0,0,0,0],[0,178,90,0,0,76,193,0,23,0,24,0,0,0,78,0,178,0,0],[0,0,0,0,29,95,31,32,33,0,34,0,0,0,36,0,0,37,0],[0,0,0,0,100,101,101,32,33,0,0,0,0,0,100,0,0,0,0],[0,0,0,195,196,197,198,32,33,0,34,0,0,199,200,0,0,37,0],[0,0,0,0,0,201,201,0,33,0,34,0,0,0,99,0,0,0,0],[0,96,0,202,0,203,203,32,33,0,34,0,0,0,99,0,96,0,0],[0,204,111,0,0,0,0,0,0,0,0,0,0,0,0,0,204,0,0],[0,96,0,0,0,201,205,0,33,0,34,0,0,0,99,0,96,0,0],[0,0,0,0,0,206,206,32,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,103,104,105,106,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,104,104,106,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,207,207,106,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,208,207,207,106,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,209,210,211,212,213,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,107,0,0,0,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,214,0,0,0,0,0,0,0,0],[0,0,0,215,196,216,217,32,33,0,34,0,0,218,200,0,0,37,0],[0,0,0,0,0,201,201,0,33,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,97,219,0,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,220,101,101,32,33,0,0,0,0,0,220,0,0,0,0],[0,204,111,0,0,97,219,0,33,0,34,0,0,0,99,0,204,0,0],[0,0,0,221,116,222,222,8,9,0,10,0,0,0,120,0,0,16,0],[0,223,0,0,0,40,224,0,9,0,10,0,0,0,42,0,223,0,0],[0,0,0,0,225,44,44,8,9,0,0,0,0,119,225,0,0,0,0],[0,0,0,115,116,117,222,8,9,0,10,0,0,119,120,0,0,16,0],[0,0,0,115,116,222,222,8,9,0,10,0,0,0,120,0,0,16,0],[0,226,64,0,0,40,224,0,9,0,10,0,0,0,42,0,226,0,0],[0,0,0,0,0,0,0,0,9,0,0,0,0,0,0,0,0,0,0],[0,39,0,0,0,121,121,0,9,0,10,0,0,0,42,0,39,0,0],[0,0,0,0,0,44,44,8,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,227,0,228,229,0,9,0,10,0,0,230,0,0,0,0,0],[0,39,0,122,0,121,121,0,9,0,10,0,0,0,42,0,39,0,0],[0,0,0,0,0,0,0,8,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,231,231,49,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,232,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,130,131,132,133,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,131,131,133,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,233,233,133,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,234,233,233,133,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,235,236,237,238,239,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,54,56,56,57,58,0,59,0,0,0,61,0,0,62,0],[0,0,0,240,241,242,243,57,58,0,59,0,0,244,245,0,0,62,0],[0,0,0,0,0,246,246,0,58,0,59,0,0,0,139,0,0,0,0],[0,136,0,247,0,248,248,57,58,0,59,0,0,0,139,0,136,0,0],[0,249,151,0,0,0,0,0,0,0,0,0,0,0,0,0,249,0,0],[0,136,0,0,0,246,250,0,58,0,59,0,0,0,139,0,136,0,0],[0,0,0,0,0,251,251,57,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,143,144,145,146,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,144,144,146,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,252,252,146,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,253,252,252,146,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,254,255,256,257,258,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,147,0,0,0,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,259,0,0,0,0,0,0,0,0],[0,0,0,260,241,261,262,57,58,0,59,0,0,263,245,0,0,62,0],[0,0,0,0,0,246,246,0,58,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,137,264,0,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,265,141,141,57,58,0,0,0,0,0,265,0,0,0,0],[0,249,151,0,0,137,264,0,58,0,59,0,0,0,139,0,249,0,0],[0,0,0,221,116,222,222,8,9,0,10,0,0,0,120,0,0,16,0],[0,0,0,0,225,44,44,8,9,0,0,0,0,158,225,0,0,0,0],[0,0,0,155,116,156,222,8,9,0,10,0,0,158,120,0,0,16,0],[0,0,0,155,116,222,222,8,9,0,10,0,0,0,120,0,0,16,0],[0,0,0,0,43,266,266,8,161,0,24,0,0,12,267,0,0,0,0],[0,75,0,176,43,268,268,269,161,0,24,0,0,0,267,0,75,0,0],[0,0,0,0,0,270,0,0,271,0,162,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,272,0,0,0,0,0,0,0,0],[0,273,274,0,0,40,41,0,9,0,10,0,0,0,42,0,273,0,0],[0,0,0,40,0,123,123,8,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,121,275,0,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,72,0,0,0,0,0,0,0,0],[0,0,0,0,0,166,0,0,0,0,72,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,276,0,0,0,0,0,0,0,0],[0,0,0,277,170,278,278,22,23,0,24,0,0,0,174,0,0,27,0],[0,279,0,0,0,76,280,0,23,0,24,0,0,0,78,0,279,0,0],[0,0,0,0,281,80,80,22,23,0,0,0,0,173,281,0,0,0,0],[0,0,0,169,170,171,278,22,23,0,24,0,0,173,174,0,0,27,0],[0,0,0,169,170,278,278,22,23,0,24,0,0,0,174,0,0,27,0],[0,282,90,0,0,76,280,0,23,0,24,0,0,0,78,0,282,0,0],[0,0,0,0,0,0,0,0,23,0,0,0,0,0,0,0,0,0,0],[0,75,0,0,0,175,175,0,23,0,24,0,0,0,78,0,75,0,0],[0,0,0,0,0,80,80,22,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,283,0,284,285,0,23,0,24,0,0,286,0,0,0,0,0],[0,75,0,176,0,175,175,0,23,0,24,0,0,0,78,0,75,0,0],[0,0,0,0,0,0,0,22,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,287,287,85,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,288,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,184,185,186,187,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,185,185,187,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,289,289,187,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,290,289,289,187,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,291,292,293,294,295,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,277,170,278,278,22,23,0,24,0,0,0,174,0,0,27,0],[0,0,0,0,281,80,80,22,23,0,0,0,0,192,281,0,0,0,0],[0,0,0,189,170,190,278,22,23,0,24,0,0,192,174,0,0,27,0],[0,0,0,189,170,278,278,22,23,0,24,0,0,0,174,0,0,27,0],[0,0,0,76,0,177,177,22,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,175,296,0,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,297,196,298,298,32,33,0,34,0,0,0,200,0,0,37,0],[0,299,0,0,0,97,300,0,33,0,34,0,0,0,99,0,299,0,0],[0,0,0,0,301,101,101,32,33,0,0,0,0,199,301,0,0,0,0],[0,0,0,195,196,197,298,32,33,0,34,0,0,199,200,0,0,37,0],[0,0,0,195,196,298,298,32,33,0,34,0,0,0,200,0,0,37,0],[0,302,111,0,0,97,300,0,33,0,34,0,0,0,99,0,302,0,0],[0,0,0,0,0,0,0,0,33,0,0,0,0,0,0,0,0,0,0],[0,96,0,0,0,201,201,0,33,0,34,0,0,0,99,0,96,0,0],[0,0,0,0,0,101,101,32,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,303,0,304,305,0,33,0,34,0,0,306,0,0,0,0,0],[0,96,0,202,0,201,201,0,33,0,34,0,0,0,99,0,96,0,0],[0,0,0,0,0,0,0,32,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,307,307,106,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,308,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,210,211,212,213,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,211,211,213,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,309,309,213,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,310,309,309,213,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,311,312,313,314,315,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,297,196,298,298,32,33,0,34,0,0,0,200,0,0,37,0],[0,0,0,0,301,101,101,32,33,0,0,0,0,218,301,0,0,0,0],[0,0,0,215,196,216,298,32,33,0,34,0,0,218,200,0,0,37,0],[0,0,0,215,196,298,298,32,33,0,34,0,0,0,200,0,0,37,0],[0,0,0,97,0,203,203,32,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,201,316,0,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,116,222,222,8,9,0,10,0,0,0,120,0,0,16,0],[0,0,0,0,225,44,44,8,9,0,0,0,0,0,225,0,0,0,0],[0,0,0,317,318,319,320,8,9,0,10,0,0,321,322,0,0,16,0],[0,223,0,323,0,123,123,8,9,0,10,0,0,0,42,0,223,0,0],[0,223,0,0,0,121,324,0,9,0,10,0,0,0,42,0,223,0,0],[0,0,0,325,318,326,327,8,9,0,10,0,0,328,322,0,0,16,0],[0,0,0,64,0,121,121,0,9,0,10,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,9,0,0,0,0,230,0,0,0,0,0],[0,0,0,227,0,228,121,0,9,0,10,0,0,230,0,0,0,0,0],[0,0,0,227,0,121,121,0,9,0,10,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,49,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,46,0,0],[0,0,0,0,0,329,329,133,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,330,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,236,237,238,239,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,237,237,239,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,331,331,239,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,332,331,331,239,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,333,40,121,334,0,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,335,241,336,336,57,58,0,59,0,0,0,245,0,0,62,0],[0,337,0,0,0,137,338,0,58,0,59,0,0,0,139,0,337,0,0],[0,0,0,0,339,141,141,57,58,0,0,0,0,244,339,0,0,0,0],[0,0,0,240,241,242,336,57,58,0,59,0,0,244,245,0,0,62,0],[0,0,0,240,241,336,336,57,58,0,59,0,0,0,245,0,0,62,0],[0,340,151,0,0,137,338,0,58,0,59,0,0,0,139,0,340,0,0],[0,0,0,0,0,0,0,0,58,0,0,0,0,0,0,0,0,0,0],[0,136,0,0,0,246,246,0,58,0,59,0,0,0,139,0,136,0,0],[0,0,0,0,0,141,141,57,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,341,0,342,343,0,58,0,59,0,0,344,0,0,0,0,0],[0,136,0,247,0,246,246,0,58,0,59,0,0,0,139,0,136,0,0],[0,0,0,0,0,0,0,57,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,345,345,146,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,346,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,255,256,257,258,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,256,256,258,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,347,347,258,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,348,347,347,258,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,349,350,351,352,353,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,335,241,336,336,57,58,0,59,0,0,0,245,0,0,62,0],[0,0,0,0,339,141,141,57,58,0,0,0,0,263,339,0,0,0,0],[0,0,0,260,241,261,336,57,58,0,59,0,0,263,245,0,0,62,0],[0,0,0,260,241,336,336,57,58,0,59,0,0,0,245,0,0,62,0],[0,0,0,137,0,248,248,57,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,246,354,0,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,126,126,8,23,0,0,0,0,0,0,0,0,0,0],[0,355,90,0,0,121,125,0,9,0,10,0,0,0,42,0,355,0,0],[0,0,0,0,0,356,356,269,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,357,358,359,360,361,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,162,0,0,0,0,0,0,0,0],[0,0,0,0,0,270,0,0,0,0,162,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,363,0,0,0,0,0,0,0,0],[0,0,0,364,116,365,366,8,161,0,162,0,0,367,120,0,0,16,0],[0,0,0,0,0,368,368,0,161,0,162,0,0,0,0,0,0,0,0],[0,0,0,40,0,121,121,0,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,170,278,278,22,23,0,24,0,0,0,174,0,0,27,0],[0,0,0,0,281,80,80,22,23,0,0,0,0,0,281,0,0,0,0],[0,0,0,369,370,371,372,22,23,0,24,0,0,373,374,0,0,27,0],[0,279,0,375,0,177,177,22,23,0,24,0,0,0,78,0,279,0,0],[0,279,0,0,0,175,376,0,23,0,24,0,0,0,78,0,279,0,0],[0,0,0,377,370,378,379,22,23,0,24,0,0,380,374,0,0,27,0],[0,0,0,90,0,175,175,0,23,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,23,0,0,0,0,286,0,0,0,0,0],[0,0,0,283,0,284,175,0,23,0,24,0,0,286,0,0,0,0,0],[0,0,0,283,0,175,175,0,23,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,85,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,82,0,0],[0,0,0,0,0,381,381,187,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,382,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,292,293,294,295,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,293,293,295,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,383,383,295,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,384,383,383,295,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,385,76,175,386,0,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,76,0,175,175,0,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,196,298,298,32,33,0,34,0,0,0,200,0,0,37,0],[0,0,0,0,301,101,101,32,33,0,0,0,0,0,301,0,0,0,0],[0,0,0,387,388,389,390,32,33,0,34,0,0,391,392,0,0,37,0],[0,299,0,393,0,203,203,32,33,0,34,0,0,0,99,0,299,0,0],[0,299,0,0,0,201,394,0,33,0,34,0,0,0,99,0,299,0,0],[0,0,0,395,388,396,397,32,33,0,34,0,0,398,392,0,0,37,0],[0,0,0,111,0,201,201,0,33,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,33,0,0,0,0,306,0,0,0,0,0],[0,0,0,303,0,304,201,0,33,0,34,0,0,306,0,0,0,0,0],[0,0,0,303,0,201,201,0,33,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,106,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,103,0,0],[0,0,0,0,0,399,399,213,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,400,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,312,313,314,315,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,313,313,315,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,401,401,315,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,402,401,401,315,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,403,97,201,404,0,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,97,0,201,201,0,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,405,318,406,406,8,9,0,10,0,0,0,322,0,0,16,0],[0,407,0,0,0,40,408,0,9,0,10,0,0,0,42,0,407,0,0],[0,0,0,0,409,44,44,8,9,0,0,0,0,321,409,0,0,0,0],[0,0,0,317,318,319,406,8,9,0,10,0,0,321,322,0,0,16,0],[0,0,0,317,318,406,406,8,9,0,10,0,0,0,322,0,0,16,0],[0,410,64,0,0,40,408,0,9,0,10,0,0,0,42,0,410,0,0],[0,223,0,0,0,121,121,0,9,0,10,0,0,0,42,0,223,0,0],[0,223,0,323,0,121,121,0,9,0,10,0,0,0,42,0,223,0,0],[0,0,0,405,318,406,406,8,9,0,10,0,0,0,322,0,0,16,0],[0,0,0,0,409,44,44,8,9,0,0,0,0,328,409,0,0,0,0],[0,0,0,325,318,326,406,8,9,0,10,0,0,328,322,0,0,16,0],[0,0,0,325,318,406,406,8,9,0,10,0,0,0,322,0,0,16,0],[0,0,0,0,0,0,0,133,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,130,0,0],[0,0,0,0,0,411,411,239,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,412,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,40,121,334,0,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,413,0,0,0,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,241,336,336,57,58,0,59,0,0,0,245,0,0,62,0],[0,0,0,0,339,141,141,57,58,0,0,0,0,0,339,0,0,0,0],[0,0,0,414,415,416,417,57,58,0,59,0,0,418,419,0,0,62,0],[0,337,0,420,0,248,248,57,58,0,59,0,0,0,139,0,337,0,0],[0,337,0,0,0,246,421,0,58,0,59,0,0,0,139,0,337,0,0],[0,0,0,422,415,423,424,57,58,0,59,0,0,425,419,0,0,62,0],[0,0,0,151,0,246,246,0,58,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,58,0,0,0,0,344,0,0,0,0,0],[0,0,0,341,0,342,246,0,58,0,59,0,0,344,0,0,0,0,0],[0,0,0,341,0,246,246,0,58,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,146,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,143,0,0],[0,0,0,0,0,426,426,258,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,427,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,350,351,352,353,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,351,351,353,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,428,428,353,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,429,428,428,353,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,430,137,246,431,0,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,137,0,246,246,0,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,432,116,433,434,8,161,0,162,0,0,435,120,0,0,16,0],[0,0,0,0,0,180,180,269,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,358,359,360,361,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,359,359,361,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,436,436,361,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,437,436,436,361,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,438,439,440,441,442,161,0,162,0,0,0,362,0,0,0,0],[0,443,274,0,0,0,0,0,0,0,0,0,0,0,0,0,443,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,444,116,445,445,8,161,0,162,0,0,0,120,0,0,16,0],[0,0,0,0,225,44,44,8,161,0,0,0,0,367,225,0,0,0,0],[0,0,0,364,116,365,445,8,161,0,162,0,0,367,120,0,0,16,0],[0,0,0,364,116,445,445,8,161,0,162,0,0,0,120,0,0,16,0],[0,0,0,0,0,0,0,0,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,446,370,447,447,22,23,0,24,0,0,0,374,0,0,27,0],[0,448,0,0,0,76,449,0,23,0,24,0,0,0,78,0,448,0,0],[0,0,0,0,450,80,80,22,23,0,0,0,0,373,450,0,0,0,0],[0,0,0,369,370,371,447,22,23,0,24,0,0,373,374,0,0,27,0],[0,0,0,369,370,447,447,22,23,0,24,0,0,0,374,0,0,27,0],[0,451,90,0,0,76,449,0,23,0,24,0,0,0,78,0,451,0,0],[0,279,0,0,0,175,175,0,23,0,24,0,0,0,78,0,279,0,0],[0,279,0,375,0,175,175,0,23,0,24,0,0,0,78,0,279,0,0],[0,0,0,446,370,447,447,22,23,0,24,0,0,0,374,0,0,27,0],[0,0,0,0,450,80,80,22,23,0,0,0,0,380,450,0,0,0,0],[0,0,0,377,370,378,447,22,23,0,24,0,0,380,374,0,0,27,0],[0,0,0,377,370,447,447,22,23,0,24,0,0,0,374,0,0,27,0],[0,0,0,0,0,0,0,187,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,184,0,0],[0,0,0,0,0,452,452,295,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,453,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,76,175,386,0,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,454,0,0,0,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,455,388,456,456,32,33,0,34,0,0,0,392,0,0,37,0],[0,457,0,0,0,97,458,0,33,0,34,0,0,0,99,0,457,0,0],[0,0,0,0,459,101,101,32,33,0,0,0,0,391,459,0,0,0,0],[0,0,0,387,388,389,456,32,33,0,34,0,0,391,392,0,0,37,0],[0,0,0,387,388,456,456,32,33,0,34,0,0,0,392,0,0,37,0],[0,460,111,0,0,97,458,0,33,0,34,0,0,0,99,0,460,0,0],[0,299,0,0,0,201,201,0,33,0,34,0,0,0,99,0,299,0,0],[0,299,0,393,0,201,201,0,33,0,34,0,0,0,99,0,299,0,0],[0,0,0,455,388,456,456,32,33,0,34,0,0,0,392,0,0,37,0],[0,0,0,0,459,101,101,32,33,0,0,0,0,398,459,0,0,0,0],[0,0,0,395,388,396,456,32,33,0,34,0,0,398,392,0,0,37,0],[0,0,0,395,388,456,456,32,33,0,34,0,0,0,392,0,0,37,0],[0,0,0,0,0,0,0,213,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,210,0,0],[0,0,0,0,0,461,461,315,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,462,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,97,201,404,0,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,463,0,0,0,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,318,406,406,8,9,0,10,0,0,0,322,0,0,16,0],[0,0,0,0,409,44,44,8,9,0,0,0,0,0,409,0,0,0,0],[0,0,0,464,465,466,467,8,9,0,10,0,0,468,469,0,0,16,0],[0,407,0,470,0,123,123,8,9,0,10,0,0,0,42,0,407,0,0],[0,407,0,0,0,121,471,0,9,0,10,0,0,0,42,0,407,0,0],[0,0,0,472,465,473,474,8,9,0,10,0,0,475,469,0,0,16,0],[0,0,0,0,0,0,0,239,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,236,0,0],[0,0,0,0,0,0,476,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,477,415,478,478,57,58,0,59,0,0,0,419,0,0,62,0],[0,479,0,0,0,137,480,0,58,0,59,0,0,0,139,0,479,0,0],[0,0,0,0,481,141,141,57,58,0,0,0,0,418,481,0,0,0,0],[0,0,0,414,415,416,478,57,58,0,59,0,0,418,419,0,0,62,0],[0,0,0,414,415,478,478,57,58,0,59,0,0,0,419,0,0,62,0],[0,482,151,0,0,137,480,0,58,0,59,0,0,0,139,0,482,0,0],[0,337,0,0,0,246,246,0,58,0,59,0,0,0,139,0,337,0,0],[0,337,0,420,0,246,246,0,58,0,59,0,0,0,139,0,337,0,0],[0,0,0,477,415,478,478,57,58,0,59,0,0,0,419,0,0,62,0],[0,0,0,0,481,141,141,57,58,0,0,0,0,425,481,0,0,0,0],[0,0,0,422,415,423,478,57,58,0,59,0,0,425,419,0,0,62,0],[0,0,0,422,415,478,478,57,58,0,59,0,0,0,419,0,0,62,0],[0,0,0,0,0,0,0,258,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,255,0,0],[0,0,0,0,0,483,483,353,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,484,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,137,246,431,0,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,485,0,0,0,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,444,116,445,445,8,161,0,162,0,0,0,120,0,0,16,0],[0,0,0,0,225,44,44,8,161,0,0,0,0,435,225,0,0,0,0],[0,0,0,432,116,433,445,8,161,0,162,0,0,435,120,0,0,16,0],[0,0,0,432,116,445,445,8,161,0,162,0,0,0,120,0,0,16,0],[0,0,0,0,0,486,486,361,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,487,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,439,440,441,442,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,440,440,442,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,488,488,442,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,489,488,488,442,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,490,491,492,493,494,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,495,0,496,497,0,161,0,162,0,0,498,0,0,0,0,0],[0,0,0,0,116,445,445,8,161,0,162,0,0,0,120,0,0,16,0],[0,0,0,0,225,44,44,8,161,0,0,0,0,0,225,0,0,0,0],[0,0,0,0,370,447,447,22,23,0,24,0,0,0,374,0,0,27,0],[0,0,0,0,450,80,80,22,23,0,0,0,0,0,450,0,0,0,0],[0,0,0,499,500,501,502,22,23,0,24,0,0,503,504,0,0,27,0],[0,448,0,505,0,177,177,22,23,0,24,0,0,0,78,0,448,0,0],[0,448,0,0,0,175,506,0,23,0,24,0,0,0,78,0,448,0,0],[0,0,0,507,500,508,509,22,23,0,24,0,0,510,504,0,0,27,0],[0,0,0,0,0,0,0,295,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,292,0,0],[0,0,0,0,0,0,511,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,388,456,456,32,33,0,34,0,0,0,392,0,0,37,0],[0,0,0,0,459,101,101,32,33,0,0,0,0,0,459,0,0,0,0],[0,0,0,512,513,514,515,32,33,0,34,0,0,516,517,0,0,37,0],[0,457,0,518,0,203,203,32,33,0,34,0,0,0,99,0,457,0,0],[0,457,0,0,0,201,519,0,33,0,34,0,0,0,99,0,457,0,0],[0,0,0,520,513,521,522,32,33,0,34,0,0,523,517,0,0,37,0],[0,0,0,0,0,0,0,315,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,312,0,0],[0,0,0,0,0,0,524,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,525,465,526,526,8,9,0,10,0,0,0,469,0,0,16,0],[0,527,0,0,0,40,528,0,9,0,10,0,0,0,42,0,527,0,0],[0,0,0,0,529,44,44,8,9,0,0,0,0,468,529,0,0,0,0],[0,0,0,464,465,466,526,8,9,0,10,0,0,468,469,0,0,16,0],[0,0,0,464,465,526,526,8,9,0,10,0,0,0,469,0,0,16,0],[0,530,64,0,0,40,528,0,9,0,10,0,0,0,42,0,530,0,0],[0,407,0,0,0,121,121,0,9,0,10,0,0,0,42,0,407,0,0],[0,407,0,470,0,121,121,0,9,0,10,0,0,0,42,0,407,0,0],[0,0,0,525,465,526,526,8,9,0,10,0,0,0,469,0,0,16,0],[0,0,0,0,529,44,44,8,9,0,0,0,0,475,529,0,0,0,0],[0,0,0,472,465,473,526,8,9,0,10,0,0,475,469,0,0,16,0],[0,0,0,472,465,526,526,8,9,0,10,0,0,0,469,0,0,16,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,40,0,0],[0,0,0,0,415,478,478,57,58,0,59,0,0,0,419,0,0,62,0],[0,0,0,0,481,141,141,57,58,0,0,0,0,0,481,0,0,0,0],[0,0,0,531,532,533,534,57,58,0,59,0,0,535,536,0,0,62,0],[0,479,0,537,0,248,248,57,58,0,59,0,0,0,139,0,479,0,0],[0,479,0,0,0,246,538,0,58,0,59,0,0,0,139,0,479,0,0],[0,0,0,539,532,540,541,57,58,0,59,0,0,542,536,0,0,62,0],[0,0,0,0,0,0,0,353,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,350,0,0],[0,0,0,0,0,0,543,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,361,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,358,0,0],[0,0,0,0,0,544,544,442,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,545,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,491,492,493,494,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,492,492,494,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,546,546,494,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,547,546,546,494,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,548,549,368,550,0,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,274,0,368,368,0,161,0,162,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,161,0,0,0,0,498,0,0,0,0,0],[0,0,0,495,0,496,368,0,161,0,162,0,0,498,0,0,0,0,0],[0,0,0,495,0,368,368,0,161,0,162,0,0,0,0,0,0,0,0],[0,0,0,551,500,552,552,22,23,0,24,0,0,0,504,0,0,27,0],[0,553,0,0,0,76,554,0,23,0,24,0,0,0,78,0,553,0,0],[0,0,0,0,555,80,80,22,23,0,0,0,0,503,555,0,0,0,0],[0,0,0,499,500,501,552,22,23,0,24,0,0,503,504,0,0,27,0],[0,0,0,499,500,552,552,22,23,0,24,0,0,0,504,0,0,27,0],[0,556,90,0,0,76,554,0,23,0,24,0,0,0,78,0,556,0,0],[0,448,0,0,0,175,175,0,23,0,24,0,0,0,78,0,448,0,0],[0,448,0,505,0,175,175,0,23,0,24,0,0,0,78,0,448,0,0],[0,0,0,551,500,552,552,22,23,0,24,0,0,0,504,0,0,27,0],[0,0,0,0,555,80,80,22,23,0,0,0,0,510,555,0,0,0,0],[0,0,0,507,500,508,552,22,23,0,24,0,0,510,504,0,0,27,0],[0,0,0,507,500,552,552,22,23,0,24,0,0,0,504,0,0,27,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,76,0,0],[0,0,0,557,513,558,558,32,33,0,34,0,0,0,517,0,0,37,0],[0,559,0,0,0,97,560,0,33,0,34,0,0,0,99,0,559,0,0],[0,0,0,0,561,101,101,32,33,0,0,0,0,516,561,0,0,0,0],[0,0,0,512,513,514,558,32,33,0,34,0,0,516,517,0,0,37,0],[0,0,0,512,513,558,558,32,33,0,34,0,0,0,517,0,0,37,0],[0,562,111,0,0,97,560,0,33,0,34,0,0,0,99,0,562,0,0],[0,457,0,0,0,201,201,0,33,0,34,0,0,0,99,0,457,0,0],[0,457,0,518,0,201,201,0,33,0,34,0,0,0,99,0,457,0,0],[0,0,0,557,513,558,558,32,33,0,34,0,0,0,517,0,0,37,0],[0,0,0,0,561,101,101,32,33,0,0,0,0,523,561,0,0,0,0],[0,0,0,520,513,521,558,32,33,0,34,0,0,523,517,0,0,37,0],[0,0,0,520,513,558,558,32,33,0,34,0,0,0,517,0,0,37,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,97,0,0],[0,0,0,0,465,526,526,8,9,0,10,0,0,0,469,0,0,16,0],[0,0,0,0,529,44,44,8,9,0,0,0,0,0,529,0,0,0,0],[0,0,0,563,66,564,565,8,9,0,10,0,0,566,68,0,0,16,0],[0,527,0,567,0,123,123,8,9,0,10,0,0,0,42,0,527,0,0],[0,527,0,0,0,121,568,0,9,0,10,0,0,0,42,0,527,0,0],[0,0,0,569,66,570,571,8,9,0,10,0,0,572,68,0,0,16,0],[0,0,0,573,532,574,574,57,58,0,59,0,0,0,536,0,0,62,0],[0,575,0,0,0,137,576,0,58,0,59,0,0,0,139,0,575,0,0],[0,0,0,0,577,141,141,57,58,0,0,0,0,535,577,0,0,0,0],[0,0,0,531,532,533,574,57,58,0,59,0,0,535,536,0,0,62,0],[0,0,0,531,532,574,574,57,58,0,59,0,0,0,536,0,0,62,0],[0,578,151,0,0,137,576,0,58,0,59,0,0,0,139,0,578,0,0],[0,479,0,0,0,246,246,0,58,0,59,0,0,0,139,0,479,0,0],[0,479,0,537,0,246,246,0,58,0,59,0,0,0,139,0,479,0,0],[0,0,0,573,532,574,574,57,58,0,59,0,0,0,536,0,0,62,0],[0,0,0,0,577,141,141,57,58,0,0,0,0,542,577,0,0,0,0],[0,0,0,539,532,540,574,57,58,0,59,0,0,542,536,0,0,62,0],[0,0,0,539,532,574,574,57,58,0,59,0,0,0,536,0,0,62,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,137,0,0],[0,0,0,0,0,0,0,442,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,439,0,0],[0,0,0,0,0,579,579,494,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,580,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,549,368,550,0,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,368,368,0,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,581,0,0,0,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,500,552,552,22,23,0,24,0,0,0,504,0,0,27,0],[0,0,0,0,555,80,80,22,23,0,0,0,0,0,555,0,0,0,0],[0,0,0,582,91,583,584,22,23,0,24,0,0,585,93,0,0,27,0],[0,553,0,586,0,177,177,22,23,0,24,0,0,0,78,0,553,0,0],[0,553,0,0,0,175,587,0,23,0,24,0,0,0,78,0,553,0,0],[0,0,0,588,91,589,590,22,23,0,24,0,0,591,93,0,0,27,0],[0,0,0,0,513,558,558,32,33,0,34,0,0,0,517,0,0,37,0],[0,0,0,0,561,101,101,32,33,0,0,0,0,0,561,0,0,0,0],[0,0,0,592,112,593,594,32,33,0,34,0,0,595,114,0,0,37,0],[0,559,0,596,0,203,203,32,33,0,34,0,0,0,99,0,559,0,0],[0,559,0,0,0,201,597,0,33,0,34,0,0,0,99,0,559,0,0],[0,0,0,598,112,599,600,32,33,0,34,0,0,601,114,0,0,37,0],[0,0,0,602,66,67,67,8,9,0,10,0,0,0,68,0,0,16,0],[0,0,0,0,165,44,44,8,9,0,0,0,0,566,165,0,0,0,0],[0,0,0,563,66,564,67,8,9,0,10,0,0,566,68,0,0,16,0],[0,0,0,563,66,67,67,8,9,0,10,0,0,0,68,0,0,16,0],[0,527,0,0,0,121,121,0,9,0,10,0,0,0,42,0,527,0,0],[0,527,0,567,0,121,121,0,9,0,10,0,0,0,42,0,527,0,0],[0,0,0,602,66,67,67,8,9,0,10,0,0,0,68,0,0,16,0],[0,0,0,0,165,44,44,8,9,0,0,0,0,572,165,0,0,0,0],[0,0,0,569,66,570,67,8,9,0,10,0,0,572,68,0,0,16,0],[0,0,0,569,66,67,67,8,9,0,10,0,0,0,68,0,0,16,0],[0,0,0,0,532,574,574,57,58,0,59,0,0,0,536,0,0,62,0],[0,0,0,0,577,141,141,57,58,0,0,0,0,0,577,0,0,0,0],[0,0,0,603,152,604,605,57,58,0,59,0,0,606,154,0,0,62,0],[0,575,0,607,0,248,248,57,58,0,59,0,0,0,139,0,575,0,0],[0,575,0,0,0,246,608,0,58,0,59,0,0,0,139,0,575,0,0],[0,0,0,609,152,610,611,57,58,0,59,0,0,612,154,0,0,62,0],[0,0,0,0,0,0,0,494,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,491,0,0],[0,0,0,0,0,0,613,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,614,91,92,92,22,23,0,24,0,0,0,93,0,0,27,0],[0,0,0,0,194,80,80,22,23,0,0,0,0,585,194,0,0,0,0],[0,0,0,582,91,583,92,22,23,0,24,0,0,585,93,0,0,27,0],[0,0,0,582,91,92,92,22,23,0,24,0,0,0,93,0,0,27,0],[0,553,0,0,0,175,175,0,23,0,24,0,0,0,78,0,553,0,0],[0,553,0,586,0,175,175,0,23,0,24,0,0,0,78,0,553,0,0],[0,0,0,614,91,92,92,22,23,0,24,0,0,0,93,0,0,27,0],[0,0,0,0,194,80,80,22,23,0,0,0,0,591,194,0,0,0,0],[0,0,0,588,91,589,92,22,23,0,24,0,0,591,93,0,0,27,0],[0,0,0,588,91,92,92,22,23,0,24,0,0,0,93,0,0,27,0],[0,0,0,615,112,113,113,32,33,0,34,0,0,0,114,0,0,37,0],[0,0,0,0,220,101,101,32,33,0,0,0,0,595,220,0,0,0,0],[0,0,0,592,112,593,113,32,33,0,34,0,0,595,114,0,0,37,0],[0,0,0,592,112,113,113,32,33,0,34,0,0,0,114,0,0,37,0],[0,559,0,0,0,201,201,0,33,0,34,0,0,0,99,0,559,0,0],[0,559,0,596,0,201,201,0,33,0,34,0,0,0,99,0,559,0,0],[0,0,0,615,112,113,113,32,33,0,34,0,0,0,114,0,0,37,0],[0,0,0,0,220,101,101,32,33,0,0,0,0,601,220,0,0,0,0],[0,0,0,598,112,599,113,32,33,0,34,0,0,601,114,0,0,37,0],[0,0,0,598,112,113,113,32,33,0,34,0,0,0,114,0,0,37,0],[0,0,0,0,66,67,67,8,9,0,10,0,0,0,68,0,0,16,0],[0,0,0,616,152,153,153,57,58,0,59,0,0,0,154,0,0,62,0],[0,0,0,0,265,141,141,57,58,0,0,0,0,606,265,0,0,0,0],[0,0,0,603,152,604,153,57,58,0,59,0,0,606,154,0,0,62,0],[0,0,0,603,152,153,153,57,58,0,59,0,0,0,154,0,0,62,0],[0,575,0,0,0,246,246,0,58,0,59,0,0,0,139,0,575,0,0],[0,575,0,607,0,246,246,0,58,0,59,0,0,0,139,0,575,0,0],[0,0,0,616,152,153,153,57,58,0,59,0,0,0,154,0,0,62,0],[0,0,0,0,265,141,141,57,58,0,0,0,0,612,265,0,0,0,0],[0,0,0,609,152,610,153,57,58,0,59,0,0,612,154,0,0,62,0],[0,0,0,609,152,153,153,57,58,0,59,0,0,0,154,0,0,62,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,549,0,0],[0,0,0,0,91,92,92,22,23,0,24,0,0,0,93,0,0,27,0],[0,0,0,0,112,113,113,32,33,0,34,0,0,0,114,0,0,37,0],[0,0,0,0,152,153,153,57,58,0,59,0,0,0,154,0,0,62,0]],"accepting":[false,true,true,true,true,true,false,false,true,true,true,true,true,true,true,true,true,true,true,true,false,true,true,true,true,true,true,true,true,true,false,true,true,true,true,true,true,true,true,true,true,true,false,true,false,true,true,false,false,true,true,true,true,true,true,false,false,true,true,true,true,true,true,true,true,true,true,false,true,true,false,true,true,true,false,true,true,true,false,true,false,true,true,false,false,true,true,true,true,true,true,true,false,true,true,false,true,true,true,false,true,false,true,true,false,false,true,true,true,true,true,true,true,false,true,true,true,false,true,true,true,false,true,false,true,true,false,false,false,true,true,false,false,true,true,true,true,true,true,false,true,false,true,true,false,false,true,true,true,true,true,true,true,false,true,true,false,true,true,true,true,true,true,true,true,true,true,true,true,true,true,false,true,true,true,false,true,false,true,true,false,false,false,true,true,false,false,true,true,true,false,true,true,true,true,true,true,false,true,true,true,false,true,false,true,true,false,false,false,true,true,false,false,true,true,true,false,true,true,true,true,true,false,true,true,true,true,true,false,true,true,false,false,false,false,true,true,false,false,true,true,true,false,true,true,true,false,true,false,true,true,false,false,false,true,true,false,false,true,true,true,false,true,true,true,true,false,true,false,true,true,true,true,true,true,true,true,true,false,true,true,true,true,true,false,true,true,false,false,false,false,true,true,false,false,true,true,true,false,true,true,true,true,true,false,true,true,false,false,false,false,true,true,false,false,true,true,true,true,false,true,true,true,true,true,true,false,true,true,false,false,false,false,true,false,true,false,true,true,true,true,true,false,true,true,false,false,false,false,true,true,false,false,true,true,true,false,true,true,false,false,true,false,true,true,false,true,true,false,true,true,false,true,true,true,true,true,true,false,true,true,false,false,false,false,true,false,true,true,false,true,true,true,true,true,true,false,true,true,false,false,false,false,true,false,true,false,true,true,true,true,false,false,false,true,true,false,true,true,true,true,true,true,false,true,true,false,false,false,false,true,false,true,false,true,true,false,false,true,true,false,false,true,true,true,false,true,false,true,true,true,true,false,false,false,true,false,true,true,true,true,false,false,false,true,true,false,true,true,true,true,true,true,false,true,true,false,true,false,true,true,true,true,false,false,false,false,false,false,false,true,true,false,false,true,true,false,true,true,true,true,false,true,true,true,true,true,true,false,true,true,false,true,true,false,true,true,true,true,true,true,false,true,true,false,true,false,true,true,true,true,true,true,false,true,true,true,true,true,true,false,true,true,false,false,false,false,false,true,true,false,true,false,true,true,true,true,true,false,true,true,true,true,true,false,true,true,true,true,true,false,true,true,true,false,true,true,true,true,false,false,false,true,false,true,true,true,true,true,false,true,true,true,false,true,true,true,true,true,false,true,true,true,true,false,true,true,true,true,true,false,true,true,false,true,true,true],"tags":[[],["broken_cluster"],["consonant_syllable"],["vowel_syllable"],["broken_cluster"],["broken_cluster"],[],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["standalone_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["consonant_syllable"],["broken_cluster"],["symbol_cluster"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],[],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["standalone_cluster"],["standalone_cluster"],[],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["broken_cluster"],["broken_cluster"],["consonant_syllable","broken_cluster"],["broken_cluster"],[],["broken_cluster"],["symbol_cluster"],[],["symbol_cluster"],["symbol_cluster"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],[],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],[],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],[],[],[],["broken_cluster"],["broken_cluster"],[],[],["broken_cluster"],["broken_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],[],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["symbol_cluster"],["symbol_cluster"],["symbol_cluster"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],[],[],[],["consonant_syllable"],["consonant_syllable"],[],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],[],[],[],["vowel_syllable"],["vowel_syllable"],[],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],[],[],[],[],["broken_cluster"],["broken_cluster"],[],[],["broken_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],[],[],[],["standalone_cluster"],["standalone_cluster"],[],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["broken_cluster"],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],["broken_cluster"],["symbol_cluster"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],[],[],[],[],["consonant_syllable"],["consonant_syllable"],[],[],["consonant_syllable"],["consonant_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],[],[],[],[],["vowel_syllable"],["vowel_syllable"],[],[],["vowel_syllable"],["vowel_syllable"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],[],[],[],[],["broken_cluster"],[],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],[],[],[],[],["standalone_cluster"],["standalone_cluster"],[],[],["standalone_cluster"],["standalone_cluster"],["consonant_syllable","broken_cluster"],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],[],["consonant_syllable","broken_cluster"],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],[],[],[],[],["consonant_syllable"],[],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],[],[],[],[],["vowel_syllable"],[],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],[],[],[],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],[],[],[],[],["standalone_cluster"],[],["consonant_syllable","broken_cluster"],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],[],[],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],[],[],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],[],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],[],[],[],[],[],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],[],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],[],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],[],[],[],[],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],[],[],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["broken_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],[],["consonant_syllable"],["vowel_syllable"],["standalone_cluster"]]}');
var $aa333a9607471296$exports = {};
$aa333a9607471296$exports = JSON.parse('{"categories":["O","IND","S","GB","B","FM","CGJ","VMAbv","VMPst","VAbv","VPst","CMBlw","VPre","VBlw","H","VMBlw","CMAbv","MBlw","CS","R","SUB","MPst","MPre","FAbv","FPst","FBlw","null","SMAbv","SMBlw","VMPre","ZWNJ","ZWJ","WJ","M","VS","N","HN","MAbv"],"decompositions":{"2507":[2503,2494],"2508":[2503,2519],"2888":[2887,2902],"2891":[2887,2878],"2892":[2887,2903],"3018":[3014,3006],"3019":[3015,3006],"3020":[3014,3031],"3144":[3142,3158],"3264":[3263,3285],"3271":[3270,3285],"3272":[3270,3286],"3274":[3270,3266],"3275":[3270,3266,3285],"3402":[3398,3390],"3403":[3399,3390],"3404":[3398,3415],"3546":[3545,3530],"3548":[3545,3535],"3549":[3545,3535,3530],"3550":[3545,3551],"3635":[3661,3634],"3763":[3789,3762],"3955":[3953,3954],"3957":[3953,3956],"3958":[4018,3968],"3959":[4018,3953,3968],"3960":[4019,3968],"3961":[4019,3953,3968],"3969":[3953,3968],"6971":[6970,6965],"6973":[6972,6965],"6976":[6974,6965],"6977":[6975,6965],"6979":[6978,6965],"69934":[69937,69927],"69935":[69938,69927],"70475":[70471,70462],"70476":[70471,70487],"70843":[70841,70842],"70844":[70841,70832],"70846":[70841,70845],"71098":[71096,71087],"71099":[71097,71087]},"stateTable":[[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[2,2,3,4,4,5,0,6,7,8,9,10,11,12,13,14,15,16,0,17,18,11,19,20,21,22,0,0,0,23,0,0,2,0,0,24,0,25],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,26,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,27,28,0,0,0,0,0,27,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,34,35,36,37,38,39,40,0,0,41,35,42,43,44,45,0,0,0,46,0,0,0,0,39,0,0,47],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,0,0,0,0,0,0,14,0,0,0,0,0,0,0,20,21,22,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,0,7,0,0,0,0,0,0,0,0,0,0,0,0,0,0,20,21,22,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,8,9,0,0,12,0,14,0,0,0,0,0,0,0,20,21,22,0,0,0,23,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,0,9,0,0,0,0,14,0,0,0,0,0,0,0,20,21,22,0,0,0,23,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,8,9,10,11,12,13,14,0,16,0,0,18,11,19,20,21,22,0,0,0,23,0,0,0,0,0,0,0,25],[0,0,0,0,0,5,0,6,7,8,9,0,11,12,0,14,0,0,0,0,0,0,0,20,21,22,0,0,0,23,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,0,9,0,0,12,0,14,0,0,0,0,0,0,0,20,21,22,0,0,0,23,0,0,0,0,0,0,0,0],[0,0,0,0,18,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,0,7,0,0,0,0,0,0,14,0,0,0,0,0,0,0,20,21,22,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,8,9,10,11,12,13,14,15,16,0,0,18,11,19,20,21,22,0,0,0,23,0,0,0,0,0,0,0,25],[0,0,0,0,0,5,0,6,7,8,9,0,11,12,0,14,0,0,0,0,0,11,0,20,21,22,0,0,0,23,0,0,0,0,0,0,0,0],[0,0,0,4,4,5,0,6,7,8,9,10,11,12,13,14,15,16,0,0,18,11,19,20,21,22,0,0,0,23,0,0,0,0,0,0,0,25],[0,0,0,0,0,5,0,6,7,8,9,48,11,12,13,14,48,16,0,0,18,11,19,20,21,22,0,0,0,23,0,0,0,0,49,0,0,25],[0,0,0,0,0,5,0,6,7,8,9,0,11,12,0,14,0,16,0,0,0,11,0,20,21,22,0,0,0,23,0,0,0,0,0,0,0,25],[0,0,0,0,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,20,21,22,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,21,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,21,22,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,0,0,0,0,0,0,14,0,0,0,0,0,0,0,20,21,22,0,0,0,23,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,50,0,51,0],[0,0,0,0,0,5,0,6,7,8,9,0,11,12,0,14,0,16,0,0,0,11,0,20,21,22,0,0,0,23,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,27,28,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,28,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,0,0,0,0,0,0,38,0,0,0,0,0,0,0,43,44,45,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,0,31,0,0,0,0,0,0,0,0,0,0,0,0,0,0,43,44,45,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,0,0,36,0,38,0,0,0,0,0,0,0,43,44,45,0,0,0,46,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,0,33,0,0,0,0,38,0,0,0,0,0,0,0,43,44,45,0,0,0,46,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,34,35,36,37,38,0,40,0,0,41,35,42,43,44,45,0,0,0,46,0,0,0,0,0,0,0,47],[0,0,0,0,0,29,0,30,31,32,33,0,35,36,0,38,0,0,0,0,0,0,0,43,44,45,0,0,0,46,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,0,33,0,0,36,0,38,0,0,0,0,0,0,0,43,44,45,0,0,0,46,0,0,0,0,0,0,0,0],[0,0,0,0,41,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,0,31,0,0,0,0,0,0,38,0,0,0,0,0,0,0,43,44,45,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,34,35,36,37,38,39,40,0,0,41,35,42,43,44,45,0,0,0,46,0,0,0,0,0,0,0,47],[0,0,0,0,0,29,0,30,31,32,33,0,35,36,0,38,0,0,0,0,0,35,0,43,44,45,0,0,0,46,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,52,35,36,37,38,52,40,0,0,41,35,42,43,44,45,0,0,0,46,0,0,0,0,53,0,0,47],[0,0,0,0,0,29,0,30,31,32,33,0,35,36,0,38,0,40,0,0,0,35,0,43,44,45,0,0,0,46,0,0,0,0,0,0,0,47],[0,0,0,0,0,29,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,43,44,45,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,44,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,44,45,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,0,0,0,0,0,0,38,0,0,0,0,0,0,0,43,44,45,0,0,0,46,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,0,35,36,0,38,0,40,0,0,0,35,0,43,44,45,0,0,0,46,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,8,9,48,11,12,13,14,0,16,0,0,18,11,19,20,21,22,0,0,0,23,0,0,0,0,0,0,0,25],[0,0,0,0,0,5,0,6,7,8,9,48,11,12,13,14,48,16,0,0,18,11,19,20,21,22,0,0,0,23,0,0,0,0,0,0,0,25],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,51,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,54,0,0],[0,0,0,0,0,29,0,30,31,32,33,52,35,36,37,38,0,40,0,0,41,35,42,43,44,45,0,0,0,46,0,0,0,0,0,0,0,47],[0,0,0,0,0,29,0,30,31,32,33,52,35,36,37,38,52,40,0,0,41,35,42,43,44,45,0,0,0,46,0,0,0,0,0,0,0,47],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,50,0,51,0]],"accepting":[false,true,true,true,true,true,true,true,true,true,true,true,true,false,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true],"tags":[[],["broken_cluster"],["independent_cluster"],["symbol_cluster"],["standard_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["numeral_cluster"],["broken_cluster"],["independent_cluster"],["symbol_cluster"],["symbol_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["virama_terminated_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["broken_cluster"],["broken_cluster"],["numeral_cluster"],["number_joiner_terminated_cluster"],["standard_cluster"],["standard_cluster"],["numeral_cluster"]]}');
var $90a9d3398ee54fe5$export$a513ea61a7bee91c = {
  X: 1,
  C: 2,
  V: 4,
  N: 8,
  H: 16,
  ZWNJ: 32,
  ZWJ: 64,
  M: 128,
  SM: 256,
  VD: 512,
  A: 1024,
  Placeholder: 2048,
  Dotted_Circle: 4096,
  RS: 8192,
  Coeng: 16384,
  Repha: 32768,
  Ra: 65536,
  CM: 131072,
  Symbol: 262144
  // Avagraha, etc that take marks (SM,A,VD).
};
var $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0 = {
  Start: 1,
  Ra_To_Become_Reph: 2,
  Pre_M: 4,
  Pre_C: 8,
  Base_C: 16,
  After_Main: 32,
  Above_C: 64,
  Before_Sub: 128,
  Below_C: 256,
  After_Sub: 512,
  Before_Post: 1024,
  Post_C: 2048,
  After_Post: 4096,
  Final_C: 8192,
  SMVD: 16384,
  End: 32768
};
var $90a9d3398ee54fe5$export$8519deaa7de2b07 = $90a9d3398ee54fe5$export$a513ea61a7bee91c.C | $90a9d3398ee54fe5$export$a513ea61a7bee91c.Ra | $90a9d3398ee54fe5$export$a513ea61a7bee91c.CM | $90a9d3398ee54fe5$export$a513ea61a7bee91c.V | $90a9d3398ee54fe5$export$a513ea61a7bee91c.Placeholder | $90a9d3398ee54fe5$export$a513ea61a7bee91c.Dotted_Circle;
var $90a9d3398ee54fe5$export$bbcd928767338e0d = $90a9d3398ee54fe5$export$a513ea61a7bee91c.ZWJ | $90a9d3398ee54fe5$export$a513ea61a7bee91c.ZWNJ;
var $90a9d3398ee54fe5$export$ca9599b2a300afc = $90a9d3398ee54fe5$export$a513ea61a7bee91c.H | $90a9d3398ee54fe5$export$a513ea61a7bee91c.Coeng;
var $90a9d3398ee54fe5$export$e99d119da76a0fc5 = {
  Default: {
    hasOldSpec: false,
    virama: 0,
    basePos: "Last",
    rephPos: $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Before_Post,
    rephMode: "Implicit",
    blwfMode: "Pre_And_Post"
  },
  Devanagari: {
    hasOldSpec: true,
    virama: 2381,
    basePos: "Last",
    rephPos: $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Before_Post,
    rephMode: "Implicit",
    blwfMode: "Pre_And_Post"
  },
  Bengali: {
    hasOldSpec: true,
    virama: 2509,
    basePos: "Last",
    rephPos: $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.After_Sub,
    rephMode: "Implicit",
    blwfMode: "Pre_And_Post"
  },
  Gurmukhi: {
    hasOldSpec: true,
    virama: 2637,
    basePos: "Last",
    rephPos: $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Before_Sub,
    rephMode: "Implicit",
    blwfMode: "Pre_And_Post"
  },
  Gujarati: {
    hasOldSpec: true,
    virama: 2765,
    basePos: "Last",
    rephPos: $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Before_Post,
    rephMode: "Implicit",
    blwfMode: "Pre_And_Post"
  },
  Oriya: {
    hasOldSpec: true,
    virama: 2893,
    basePos: "Last",
    rephPos: $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.After_Main,
    rephMode: "Implicit",
    blwfMode: "Pre_And_Post"
  },
  Tamil: {
    hasOldSpec: true,
    virama: 3021,
    basePos: "Last",
    rephPos: $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.After_Post,
    rephMode: "Implicit",
    blwfMode: "Pre_And_Post"
  },
  Telugu: {
    hasOldSpec: true,
    virama: 3149,
    basePos: "Last",
    rephPos: $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.After_Post,
    rephMode: "Explicit",
    blwfMode: "Post_Only"
  },
  Kannada: {
    hasOldSpec: true,
    virama: 3277,
    basePos: "Last",
    rephPos: $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.After_Post,
    rephMode: "Implicit",
    blwfMode: "Post_Only"
  },
  Malayalam: {
    hasOldSpec: true,
    virama: 3405,
    basePos: "Last",
    rephPos: $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.After_Main,
    rephMode: "Log_Repha",
    blwfMode: "Pre_And_Post"
  },
  // Handled by UniversalShaper
  // Sinhala: {
  //   hasOldSpec: false,
  //   virama: 0x0DCA,
  //   basePos: 'Last_Sinhala',
  //   rephPos: POSITIONS.After_Main,
  //   rephMode: 'Explicit',
  //   blwfMode: 'Pre_And_Post'
  // },
  Khmer: {
    hasOldSpec: false,
    virama: 6098,
    basePos: "First",
    rephPos: $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Ra_To_Become_Reph,
    rephMode: "Vis_Repha",
    blwfMode: "Pre_And_Post"
  }
};
var $90a9d3398ee54fe5$export$f647c9cfdd77d95a = {
  // Khmer
  6078: [
    6081,
    6078
  ],
  6079: [
    6081,
    6079
  ],
  6080: [
    6081,
    6080
  ],
  6084: [
    6081,
    6084
  ],
  6085: [
    6081,
    6085
  ]
};
var { decompositions: $7826f90f6f0cecc9$var$decompositions } = (0, /* @__PURE__ */ $parcel$interopDefault2($aa333a9607471296$exports));
var $7826f90f6f0cecc9$var$trie = new (0, import_unicode_trie2.default)((0, $12727730ddfc8bfe$export$94fdf11bafc8de6b)("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"));
var $7826f90f6f0cecc9$var$stateMachine = new (0, import_dfa.default)((0, /* @__PURE__ */ $parcel$interopDefault2($4b0735ca6c692ea5$exports)));
var $7826f90f6f0cecc9$export$2e2bcd8739ae039 = class extends (0, $649970d87335b30f$export$2e2bcd8739ae039) {
  static planFeatures(plan) {
    plan.addStage($7826f90f6f0cecc9$var$setupSyllables);
    plan.addStage([
      "locl",
      "ccmp"
    ]);
    plan.addStage($7826f90f6f0cecc9$var$initialReordering);
    plan.addStage("nukt");
    plan.addStage("akhn");
    plan.addStage("rphf", false);
    plan.addStage("rkrf");
    plan.addStage("pref", false);
    plan.addStage("blwf", false);
    plan.addStage("abvf", false);
    plan.addStage("half", false);
    plan.addStage("pstf", false);
    plan.addStage("vatu");
    plan.addStage("cjct");
    plan.addStage("cfar", false);
    plan.addStage($7826f90f6f0cecc9$var$finalReordering);
    plan.addStage({
      local: [
        "init"
      ],
      global: [
        "pres",
        "abvs",
        "blws",
        "psts",
        "haln",
        "dist",
        "abvm",
        "blwm",
        "calt",
        "clig"
      ]
    });
    plan.unicodeScript = $130d1a642ebcd2b7$export$ce50e82f12a827a4(plan.script);
    plan.indicConfig = (0, $90a9d3398ee54fe5$export$e99d119da76a0fc5)[plan.unicodeScript] || (0, $90a9d3398ee54fe5$export$e99d119da76a0fc5).Default;
    plan.isOldSpec = plan.indicConfig.hasOldSpec && plan.script[plan.script.length - 1] !== "2";
  }
  static assignFeatures(plan, glyphs) {
    for (let i = glyphs.length - 1; i >= 0; i--) {
      let codepoint = glyphs[i].codePoints[0];
      let d = (0, $90a9d3398ee54fe5$export$f647c9cfdd77d95a)[codepoint] || $7826f90f6f0cecc9$var$decompositions[codepoint];
      if (d) {
        let decomposed = d.map((c) => {
          let g = plan.font.glyphForCodePoint(c);
          return new (0, $10e7b257e1a9a756$export$2e2bcd8739ae039)(plan.font, g.id, [
            c
          ], glyphs[i].features);
        });
        glyphs.splice(i, 1, ...decomposed);
      }
    }
  }
};
(0, _define_property)($7826f90f6f0cecc9$export$2e2bcd8739ae039, "zeroMarkWidths", "NONE");
function $7826f90f6f0cecc9$var$indicCategory(glyph) {
  return $7826f90f6f0cecc9$var$trie.get(glyph.codePoints[0]) >> 8;
}
function $7826f90f6f0cecc9$var$indicPosition(glyph) {
  return 1 << ($7826f90f6f0cecc9$var$trie.get(glyph.codePoints[0]) & 255);
}
var $7826f90f6f0cecc9$var$IndicInfo = class {
  constructor(category, position3, syllableType, syllable) {
    this.category = category;
    this.position = position3;
    this.syllableType = syllableType;
    this.syllable = syllable;
  }
};
function $7826f90f6f0cecc9$var$setupSyllables(font, glyphs) {
  let syllable = 0;
  let last2 = 0;
  for (let [start, end, tags] of $7826f90f6f0cecc9$var$stateMachine.match(glyphs.map($7826f90f6f0cecc9$var$indicCategory))) {
    if (start > last2) {
      ++syllable;
      for (let i = last2; i < start; i++) glyphs[i].shaperInfo = new $7826f90f6f0cecc9$var$IndicInfo((0, $90a9d3398ee54fe5$export$a513ea61a7bee91c).X, (0, $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0).End, "non_indic_cluster", syllable);
    }
    ++syllable;
    for (let i = start; i <= end; i++) glyphs[i].shaperInfo = new $7826f90f6f0cecc9$var$IndicInfo(1 << $7826f90f6f0cecc9$var$indicCategory(glyphs[i]), $7826f90f6f0cecc9$var$indicPosition(glyphs[i]), tags[0], syllable);
    last2 = end + 1;
  }
  if (last2 < glyphs.length) {
    ++syllable;
    for (let i = last2; i < glyphs.length; i++) glyphs[i].shaperInfo = new $7826f90f6f0cecc9$var$IndicInfo((0, $90a9d3398ee54fe5$export$a513ea61a7bee91c).X, (0, $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0).End, "non_indic_cluster", syllable);
  }
}
function $7826f90f6f0cecc9$var$isConsonant(glyph) {
  return glyph.shaperInfo.category & (0, $90a9d3398ee54fe5$export$8519deaa7de2b07);
}
function $7826f90f6f0cecc9$var$isJoiner(glyph) {
  return glyph.shaperInfo.category & (0, $90a9d3398ee54fe5$export$bbcd928767338e0d);
}
function $7826f90f6f0cecc9$var$isHalantOrCoeng(glyph) {
  return glyph.shaperInfo.category & (0, $90a9d3398ee54fe5$export$ca9599b2a300afc);
}
function $7826f90f6f0cecc9$var$wouldSubstitute(glyphs, feature) {
  for (let glyph of glyphs) glyph.features = {
    [feature]: true
  };
  let GSUB = glyphs[0]._font._layoutEngine.engine.GSUBProcessor;
  GSUB.applyFeatures([
    feature
  ], glyphs);
  return glyphs.length === 1;
}
function $7826f90f6f0cecc9$var$consonantPosition(font, consonant, virama) {
  let glyphs = [
    virama,
    consonant,
    virama
  ];
  if ($7826f90f6f0cecc9$var$wouldSubstitute(glyphs.slice(0, 2), "blwf") || $7826f90f6f0cecc9$var$wouldSubstitute(glyphs.slice(1, 3), "blwf")) return (0, $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0).Below_C;
  else if ($7826f90f6f0cecc9$var$wouldSubstitute(glyphs.slice(0, 2), "pstf") || $7826f90f6f0cecc9$var$wouldSubstitute(glyphs.slice(1, 3), "pstf")) return (0, $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0).Post_C;
  else if ($7826f90f6f0cecc9$var$wouldSubstitute(glyphs.slice(0, 2), "pref") || $7826f90f6f0cecc9$var$wouldSubstitute(glyphs.slice(1, 3), "pref")) return (0, $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0).Post_C;
  return (0, $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0).Base_C;
}
function $7826f90f6f0cecc9$var$initialReordering(font, glyphs, plan) {
  let indicConfig = plan.indicConfig;
  let features = font._layoutEngine.engine.GSUBProcessor.features;
  let dottedCircle = font.glyphForCodePoint(9676).id;
  let virama = font.glyphForCodePoint(indicConfig.virama).id;
  if (virama) {
    let info = new (0, $10e7b257e1a9a756$export$2e2bcd8739ae039)(font, virama, [
      indicConfig.virama
    ]);
    for (let i = 0; i < glyphs.length; i++) if (glyphs[i].shaperInfo.position === (0, $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0).Base_C) glyphs[i].shaperInfo.position = $7826f90f6f0cecc9$var$consonantPosition(font, glyphs[i].copy(), info);
  }
  for (let start = 0, end = $7826f90f6f0cecc9$var$nextSyllable(glyphs, 0); start < glyphs.length; start = end, end = $7826f90f6f0cecc9$var$nextSyllable(glyphs, start)) {
    let { category, syllableType } = glyphs[start].shaperInfo;
    if (syllableType === "symbol_cluster" || syllableType === "non_indic_cluster") continue;
    if (syllableType === "broken_cluster" && dottedCircle) {
      let g = new (0, $10e7b257e1a9a756$export$2e2bcd8739ae039)(font, dottedCircle, [
        9676
      ]);
      g.shaperInfo = new $7826f90f6f0cecc9$var$IndicInfo(1 << $7826f90f6f0cecc9$var$indicCategory(g), $7826f90f6f0cecc9$var$indicPosition(g), glyphs[start].shaperInfo.syllableType, glyphs[start].shaperInfo.syllable);
      let i = start;
      while (i < end && glyphs[i].shaperInfo.category === (0, $90a9d3398ee54fe5$export$a513ea61a7bee91c).Repha) i++;
      glyphs.splice(i++, 0, g);
      end++;
    }
    let base = end;
    let limit = start;
    let hasReph = false;
    if (indicConfig.rephPos !== (0, $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0).Ra_To_Become_Reph && features.rphf && start + 3 <= end && (indicConfig.rephMode === "Implicit" && !$7826f90f6f0cecc9$var$isJoiner(glyphs[start + 2]) || indicConfig.rephMode === "Explicit" && glyphs[start + 2].shaperInfo.category === (0, $90a9d3398ee54fe5$export$a513ea61a7bee91c).ZWJ)) {
      let g = [
        glyphs[start].copy(),
        glyphs[start + 1].copy(),
        glyphs[start + 2].copy()
      ];
      if ($7826f90f6f0cecc9$var$wouldSubstitute(g.slice(0, 2), "rphf") || indicConfig.rephMode === "Explicit" && $7826f90f6f0cecc9$var$wouldSubstitute(g, "rphf")) {
        limit += 2;
        while (limit < end && $7826f90f6f0cecc9$var$isJoiner(glyphs[limit])) limit++;
        base = start;
        hasReph = true;
      }
    } else if (indicConfig.rephMode === "Log_Repha" && glyphs[start].shaperInfo.category === (0, $90a9d3398ee54fe5$export$a513ea61a7bee91c).Repha) {
      limit++;
      while (limit < end && $7826f90f6f0cecc9$var$isJoiner(glyphs[limit])) limit++;
      base = start;
      hasReph = true;
    }
    switch (indicConfig.basePos) {
      case "Last": {
        let i = end;
        let seenBelow = false;
        do {
          let info = glyphs[--i].shaperInfo;
          if ($7826f90f6f0cecc9$var$isConsonant(glyphs[i])) {
            if (info.position !== (0, $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0).Below_C && (info.position !== (0, $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0).Post_C || seenBelow)) {
              base = i;
              break;
            }
            if (info.position === (0, $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0).Below_C) seenBelow = true;
            base = i;
          } else if (start < i && info.category === (0, $90a9d3398ee54fe5$export$a513ea61a7bee91c).ZWJ && glyphs[i - 1].shaperInfo.category === (0, $90a9d3398ee54fe5$export$a513ea61a7bee91c).H) break;
        } while (i > limit);
        break;
      }
      case "First":
        base = start;
        for (let i = base + 1; i < end; i++) if ($7826f90f6f0cecc9$var$isConsonant(glyphs[i])) glyphs[i].shaperInfo.position = (0, $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0).Below_C;
    }
    if (hasReph && base === start && limit - base <= 2) hasReph = false;
    for (let i = start; i < base; i++) {
      let info = glyphs[i].shaperInfo;
      info.position = Math.min((0, $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0).Pre_C, info.position);
    }
    if (base < end) glyphs[base].shaperInfo.position = (0, $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0).Base_C;
    for (let i = base + 1; i < end; i++) if (glyphs[i].shaperInfo.category === (0, $90a9d3398ee54fe5$export$a513ea61a7bee91c).M) {
      for (let j = i + 1; j < end; j++) if ($7826f90f6f0cecc9$var$isConsonant(glyphs[j])) {
        glyphs[j].shaperInfo.position = (0, $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0).Final_C;
        break;
      }
      break;
    }
    if (hasReph) glyphs[start].shaperInfo.position = (0, $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0).Ra_To_Become_Reph;
    if (plan.isOldSpec) {
      let disallowDoubleHalants = plan.unicodeScript !== "Malayalam";
      for (let i = base + 1; i < end; i++) if (glyphs[i].shaperInfo.category === (0, $90a9d3398ee54fe5$export$a513ea61a7bee91c).H) {
        let j;
        for (j = end - 1; j > i; j--) {
          if ($7826f90f6f0cecc9$var$isConsonant(glyphs[j]) || disallowDoubleHalants && glyphs[j].shaperInfo.category === (0, $90a9d3398ee54fe5$export$a513ea61a7bee91c).H) break;
        }
        if (glyphs[j].shaperInfo.category !== (0, $90a9d3398ee54fe5$export$a513ea61a7bee91c).H && j > i) {
          let t2 = glyphs[i];
          glyphs.splice(i, 0, ...glyphs.splice(i + 1, j - i));
          glyphs[j] = t2;
        }
        break;
      }
    }
    let lastPos = (0, $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0).Start;
    for (let i = start; i < end; i++) {
      let info = glyphs[i].shaperInfo;
      if (info.category & ((0, $90a9d3398ee54fe5$export$bbcd928767338e0d) | (0, $90a9d3398ee54fe5$export$a513ea61a7bee91c).N | (0, $90a9d3398ee54fe5$export$a513ea61a7bee91c).RS | (0, $90a9d3398ee54fe5$export$a513ea61a7bee91c).CM | (0, $90a9d3398ee54fe5$export$ca9599b2a300afc) & info.category)) {
        info.position = lastPos;
        if (info.category === (0, $90a9d3398ee54fe5$export$a513ea61a7bee91c).H && info.position === (0, $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0).Pre_M) {
          for (let j = i; j > start; j--) if (glyphs[j - 1].shaperInfo.position !== (0, $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0).Pre_M) {
            info.position = glyphs[j - 1].shaperInfo.position;
            break;
          }
        }
      } else if (info.position !== (0, $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0).SMVD) lastPos = info.position;
    }
    let last2 = base;
    for (let i = base + 1; i < end; i++) {
      if ($7826f90f6f0cecc9$var$isConsonant(glyphs[i])) {
        for (let j = last2 + 1; j < i; j++) if (glyphs[j].shaperInfo.position < (0, $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0).SMVD) glyphs[j].shaperInfo.position = glyphs[i].shaperInfo.position;
        last2 = i;
      } else if (glyphs[i].shaperInfo.category === (0, $90a9d3398ee54fe5$export$a513ea61a7bee91c).M) last2 = i;
    }
    let arr = glyphs.slice(start, end);
    arr.sort((a, b) => a.shaperInfo.position - b.shaperInfo.position);
    glyphs.splice(start, arr.length, ...arr);
    for (let i = start; i < end; i++) if (glyphs[i].shaperInfo.position === (0, $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0).Base_C) {
      base = i;
      break;
    }
    for (let i = start; i < end && glyphs[i].shaperInfo.position === (0, $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0).Ra_To_Become_Reph; i++) glyphs[i].features.rphf = true;
    let blwf = !plan.isOldSpec && indicConfig.blwfMode === "Pre_And_Post";
    for (let i = start; i < base; i++) {
      glyphs[i].features.half = true;
      if (blwf) glyphs[i].features.blwf = true;
    }
    for (let i = base + 1; i < end; i++) {
      glyphs[i].features.abvf = true;
      glyphs[i].features.pstf = true;
      glyphs[i].features.blwf = true;
    }
    if (plan.isOldSpec && plan.unicodeScript === "Devanagari") {
      for (let i = start; i + 1 < base; i++) if (glyphs[i].shaperInfo.category === (0, $90a9d3398ee54fe5$export$a513ea61a7bee91c).Ra && glyphs[i + 1].shaperInfo.category === (0, $90a9d3398ee54fe5$export$a513ea61a7bee91c).H && (i + 1 === base || glyphs[i + 2].shaperInfo.category === (0, $90a9d3398ee54fe5$export$a513ea61a7bee91c).ZWJ)) {
        glyphs[i].features.blwf = true;
        glyphs[i + 1].features.blwf = true;
      }
    }
    let prefLen = 2;
    if (features.pref && base + prefLen < end)
      for (let i = base + 1; i + prefLen - 1 < end; i++) {
        let g = [
          glyphs[i].copy(),
          glyphs[i + 1].copy()
        ];
        if ($7826f90f6f0cecc9$var$wouldSubstitute(g, "pref")) {
          for (let j = 0; j < prefLen; j++) glyphs[i++].features.pref = true;
          if (features.cfar) for (; i < end; i++) glyphs[i].features.cfar = true;
          break;
        }
      }
    for (let i = start + 1; i < end; i++) if ($7826f90f6f0cecc9$var$isJoiner(glyphs[i])) {
      let nonJoiner = glyphs[i].shaperInfo.category === (0, $90a9d3398ee54fe5$export$a513ea61a7bee91c).ZWNJ;
      let j = i;
      do {
        j--;
        if (nonJoiner) delete glyphs[j].features.half;
      } while (j > start && !$7826f90f6f0cecc9$var$isConsonant(glyphs[j]));
    }
  }
}
function $7826f90f6f0cecc9$var$finalReordering(font, glyphs, plan) {
  let indicConfig = plan.indicConfig;
  let features = font._layoutEngine.engine.GSUBProcessor.features;
  for (let start = 0, end = $7826f90f6f0cecc9$var$nextSyllable(glyphs, 0); start < glyphs.length; start = end, end = $7826f90f6f0cecc9$var$nextSyllable(glyphs, start)) {
    let tryPref = !!features.pref;
    let base = start;
    for (; base < end; base++) if (glyphs[base].shaperInfo.position >= (0, $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0).Base_C) {
      if (tryPref && base + 1 < end) {
        for (let i = base + 1; i < end; i++) if (glyphs[i].features.pref) {
          if (!(glyphs[i].substituted && glyphs[i].isLigated && !glyphs[i].isMultiplied)) {
            base = i;
            while (base < end && $7826f90f6f0cecc9$var$isHalantOrCoeng(glyphs[base])) base++;
            glyphs[base].shaperInfo.position = (0, $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0).BASE_C;
            tryPref = false;
          }
          break;
        }
      }
      if (plan.unicodeScript === "Malayalam") for (let i = base + 1; i < end; i++) {
        while (i < end && $7826f90f6f0cecc9$var$isJoiner(glyphs[i])) i++;
        if (i === end || !$7826f90f6f0cecc9$var$isHalantOrCoeng(glyphs[i])) break;
        i++;
        while (i < end && $7826f90f6f0cecc9$var$isJoiner(glyphs[i])) i++;
        if (i < end && $7826f90f6f0cecc9$var$isConsonant(glyphs[i]) && glyphs[i].shaperInfo.position === (0, $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0).Below_C) {
          base = i;
          glyphs[base].shaperInfo.position = (0, $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0).Base_C;
        }
      }
      if (start < base && glyphs[base].shaperInfo.position > (0, $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0).Base_C) base--;
      break;
    }
    if (base === end && start < base && glyphs[base - 1].shaperInfo.category === (0, $90a9d3398ee54fe5$export$a513ea61a7bee91c).ZWJ) base--;
    if (base < end) while (start < base && glyphs[base].shaperInfo.category & ((0, $90a9d3398ee54fe5$export$a513ea61a7bee91c).N | (0, $90a9d3398ee54fe5$export$ca9599b2a300afc))) base--;
    if (start + 1 < end && start < base) {
      let newPos = base === end ? base - 2 : base - 1;
      if (plan.unicodeScript !== "Malayalam" && plan.unicodeScript !== "Tamil") {
        while (newPos > start && !(glyphs[newPos].shaperInfo.category & ((0, $90a9d3398ee54fe5$export$a513ea61a7bee91c).M | (0, $90a9d3398ee54fe5$export$ca9599b2a300afc)))) newPos--;
        if ($7826f90f6f0cecc9$var$isHalantOrCoeng(glyphs[newPos]) && glyphs[newPos].shaperInfo.position !== (0, $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0).Pre_M) {
          if (newPos + 1 < end && $7826f90f6f0cecc9$var$isJoiner(glyphs[newPos + 1])) newPos++;
        } else newPos = start;
      }
      if (start < newPos && glyphs[newPos].shaperInfo.position !== (0, $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0).Pre_M) {
        for (let i = newPos; i > start; i--) if (glyphs[i - 1].shaperInfo.position === (0, $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0).Pre_M) {
          let oldPos = i - 1;
          if (oldPos < base && base <= newPos) base--;
          let tmp = glyphs[oldPos];
          glyphs.splice(oldPos, 0, ...glyphs.splice(oldPos + 1, newPos - oldPos));
          glyphs[newPos] = tmp;
          newPos--;
        }
      }
    }
    if (start + 1 < end && glyphs[start].shaperInfo.position === (0, $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0).Ra_To_Become_Reph && glyphs[start].shaperInfo.category === (0, $90a9d3398ee54fe5$export$a513ea61a7bee91c).Repha !== (glyphs[start].isLigated && !glyphs[start].isMultiplied)) {
      let newRephPos;
      let rephPos = indicConfig.rephPos;
      let found = false;
      if (rephPos !== (0, $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0).After_Post) {
        newRephPos = start + 1;
        while (newRephPos < base && !$7826f90f6f0cecc9$var$isHalantOrCoeng(glyphs[newRephPos])) newRephPos++;
        if (newRephPos < base && $7826f90f6f0cecc9$var$isHalantOrCoeng(glyphs[newRephPos])) {
          if (newRephPos + 1 < base && $7826f90f6f0cecc9$var$isJoiner(glyphs[newRephPos + 1])) newRephPos++;
          found = true;
        }
        if (!found && rephPos === (0, $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0).After_Main) {
          newRephPos = base;
          while (newRephPos + 1 < end && glyphs[newRephPos + 1].shaperInfo.position <= (0, $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0).After_Main) newRephPos++;
          found = newRephPos < end;
        }
        if (!found && rephPos === (0, $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0).After_Sub) {
          newRephPos = base;
          while (newRephPos + 1 < end && !(glyphs[newRephPos + 1].shaperInfo.position & ((0, $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0).Post_C | (0, $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0).After_Post | (0, $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0).SMVD))) newRephPos++;
          found = newRephPos < end;
        }
      }
      if (!found) {
        newRephPos = start + 1;
        while (newRephPos < base && !$7826f90f6f0cecc9$var$isHalantOrCoeng(glyphs[newRephPos])) newRephPos++;
        if (newRephPos < base && $7826f90f6f0cecc9$var$isHalantOrCoeng(glyphs[newRephPos])) {
          if (newRephPos + 1 < base && $7826f90f6f0cecc9$var$isJoiner(glyphs[newRephPos + 1])) newRephPos++;
          found = true;
        }
      }
      if (!found) {
        newRephPos = end - 1;
        while (newRephPos > start && glyphs[newRephPos].shaperInfo.position === (0, $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0).SMVD) newRephPos--;
        if ($7826f90f6f0cecc9$var$isHalantOrCoeng(glyphs[newRephPos])) {
          for (let i = base + 1; i < newRephPos; i++) if (glyphs[i].shaperInfo.category === (0, $90a9d3398ee54fe5$export$a513ea61a7bee91c).M) newRephPos--;
        }
      }
      let reph = glyphs[start];
      glyphs.splice(start, 0, ...glyphs.splice(start + 1, newRephPos - start));
      glyphs[newRephPos] = reph;
      if (start < base && base <= newRephPos) base--;
    }
    if (tryPref && base + 1 < end) {
      for (let i = base + 1; i < end; i++) if (glyphs[i].features.pref) {
        if (glyphs[i].isLigated && !glyphs[i].isMultiplied) {
          let newPos = base;
          if (plan.unicodeScript !== "Malayalam" && plan.unicodeScript !== "Tamil") {
            while (newPos > start && !(glyphs[newPos - 1].shaperInfo.category & ((0, $90a9d3398ee54fe5$export$a513ea61a7bee91c).M | (0, $90a9d3398ee54fe5$export$ca9599b2a300afc)))) newPos--;
            if (newPos > start && glyphs[newPos - 1].shaperInfo.category === (0, $90a9d3398ee54fe5$export$a513ea61a7bee91c).M) {
              let oldPos2 = i;
              for (let j = base + 1; j < oldPos2; j++) if (glyphs[j].shaperInfo.category === (0, $90a9d3398ee54fe5$export$a513ea61a7bee91c).M) {
                newPos--;
                break;
              }
            }
          }
          if (newPos > start && $7826f90f6f0cecc9$var$isHalantOrCoeng(glyphs[newPos - 1])) {
            if (newPos < end && $7826f90f6f0cecc9$var$isJoiner(glyphs[newPos])) newPos++;
          }
          let oldPos = i;
          let tmp = glyphs[oldPos];
          glyphs.splice(newPos + 1, 0, ...glyphs.splice(newPos, oldPos - newPos));
          glyphs[newPos] = tmp;
          if (newPos <= base && base < oldPos) base++;
        }
        break;
      }
    }
    if (glyphs[start].shaperInfo.position === (0, $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0).Pre_M && (!start || !/Cf|Mn/.test((0, $747425b437e121da$export$410364bbb673ddbc)(glyphs[start - 1].codePoints[0])))) glyphs[start].features.init = true;
  }
}
function $7826f90f6f0cecc9$var$nextSyllable(glyphs, start) {
  if (start >= glyphs.length) return start;
  let syllable = glyphs[start].shaperInfo.syllable;
  while (++start < glyphs.length && glyphs[start].shaperInfo.syllable === syllable) ;
  return start;
}
var { categories: $7ab494fe977143c6$var$categories, decompositions: $7ab494fe977143c6$var$decompositions } = (0, /* @__PURE__ */ $parcel$interopDefault2($aa333a9607471296$exports));
var $7ab494fe977143c6$var$trie = new (0, import_unicode_trie2.default)((0, $12727730ddfc8bfe$export$94fdf11bafc8de6b)("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"));
var $7ab494fe977143c6$var$stateMachine = new (0, import_dfa.default)((0, /* @__PURE__ */ $parcel$interopDefault2($aa333a9607471296$exports)));
var $7ab494fe977143c6$export$2e2bcd8739ae039 = class extends (0, $649970d87335b30f$export$2e2bcd8739ae039) {
  static planFeatures(plan) {
    plan.addStage($7ab494fe977143c6$var$setupSyllables);
    plan.addStage([
      "locl",
      "ccmp",
      "nukt",
      "akhn"
    ]);
    plan.addStage($7ab494fe977143c6$var$clearSubstitutionFlags);
    plan.addStage([
      "rphf"
    ], false);
    plan.addStage($7ab494fe977143c6$var$recordRphf);
    plan.addStage($7ab494fe977143c6$var$clearSubstitutionFlags);
    plan.addStage([
      "pref"
    ]);
    plan.addStage($7ab494fe977143c6$var$recordPref);
    plan.addStage([
      "rkrf",
      "abvf",
      "blwf",
      "half",
      "pstf",
      "vatu",
      "cjct"
    ]);
    plan.addStage($7ab494fe977143c6$var$reorder);
    plan.addStage([
      "abvs",
      "blws",
      "pres",
      "psts",
      "dist",
      "abvm",
      "blwm"
    ]);
  }
  static assignFeatures(plan, glyphs) {
    for (let i = glyphs.length - 1; i >= 0; i--) {
      let codepoint = glyphs[i].codePoints[0];
      if ($7ab494fe977143c6$var$decompositions[codepoint]) {
        let decomposed = $7ab494fe977143c6$var$decompositions[codepoint].map((c) => {
          let g = plan.font.glyphForCodePoint(c);
          return new (0, $10e7b257e1a9a756$export$2e2bcd8739ae039)(plan.font, g.id, [
            c
          ], glyphs[i].features);
        });
        glyphs.splice(i, 1, ...decomposed);
      }
    }
  }
};
(0, _define_property)($7ab494fe977143c6$export$2e2bcd8739ae039, "zeroMarkWidths", "BEFORE_GPOS");
function $7ab494fe977143c6$var$useCategory(glyph) {
  return $7ab494fe977143c6$var$trie.get(glyph.codePoints[0]);
}
var $7ab494fe977143c6$var$USEInfo = class {
  constructor(category, syllableType, syllable) {
    this.category = category;
    this.syllableType = syllableType;
    this.syllable = syllable;
  }
};
function $7ab494fe977143c6$var$setupSyllables(font, glyphs) {
  let syllable = 0;
  for (let [start, end, tags] of $7ab494fe977143c6$var$stateMachine.match(glyphs.map($7ab494fe977143c6$var$useCategory))) {
    ++syllable;
    for (let i = start; i <= end; i++) glyphs[i].shaperInfo = new $7ab494fe977143c6$var$USEInfo($7ab494fe977143c6$var$categories[$7ab494fe977143c6$var$useCategory(glyphs[i])], tags[0], syllable);
    let limit = glyphs[start].shaperInfo.category === "R" ? 1 : Math.min(3, end - start);
    for (let i = start; i < start + limit; i++) glyphs[i].features.rphf = true;
  }
}
function $7ab494fe977143c6$var$clearSubstitutionFlags(font, glyphs) {
  for (let glyph of glyphs) glyph.substituted = false;
}
function $7ab494fe977143c6$var$recordRphf(font, glyphs) {
  for (let glyph of glyphs) if (glyph.substituted && glyph.features.rphf)
    glyph.shaperInfo.category = "R";
}
function $7ab494fe977143c6$var$recordPref(font, glyphs) {
  for (let glyph of glyphs) if (glyph.substituted)
    glyph.shaperInfo.category = "VPre";
}
function $7ab494fe977143c6$var$reorder(font, glyphs) {
  let dottedCircle = font.glyphForCodePoint(9676).id;
  for (let start = 0, end = $7ab494fe977143c6$var$nextSyllable(glyphs, 0); start < glyphs.length; start = end, end = $7ab494fe977143c6$var$nextSyllable(glyphs, start)) {
    let i, j;
    let info = glyphs[start].shaperInfo;
    let type5 = info.syllableType;
    if (type5 !== "virama_terminated_cluster" && type5 !== "standard_cluster" && type5 !== "broken_cluster") continue;
    if (type5 === "broken_cluster" && dottedCircle) {
      let g = new (0, $10e7b257e1a9a756$export$2e2bcd8739ae039)(font, dottedCircle, [
        9676
      ]);
      g.shaperInfo = info;
      for (i = start; i < end && glyphs[i].shaperInfo.category === "R"; i++) ;
      glyphs.splice(++i, 0, g);
      end++;
    }
    if (info.category === "R" && end - start > 1)
      for (i = start + 1; i < end; i++) {
        info = glyphs[i].shaperInfo;
        if ($7ab494fe977143c6$var$isBase(info) || $7ab494fe977143c6$var$isHalant(glyphs[i])) {
          if ($7ab494fe977143c6$var$isHalant(glyphs[i])) i--;
          glyphs.splice(start, 0, ...glyphs.splice(start + 1, i - start), glyphs[i]);
          break;
        }
      }
    for (i = start, j = end; i < end; i++) {
      info = glyphs[i].shaperInfo;
      if ($7ab494fe977143c6$var$isBase(info) || $7ab494fe977143c6$var$isHalant(glyphs[i]))
        j = $7ab494fe977143c6$var$isHalant(glyphs[i]) ? i + 1 : i;
      else if ((info.category === "VPre" || info.category === "VMPre") && j < i) glyphs.splice(j, 1, glyphs[i], ...glyphs.splice(j, i - j));
    }
  }
}
function $7ab494fe977143c6$var$nextSyllable(glyphs, start) {
  if (start >= glyphs.length) return start;
  let syllable = glyphs[start].shaperInfo.syllable;
  while (++start < glyphs.length && glyphs[start].shaperInfo.syllable === syllable) ;
  return start;
}
function $7ab494fe977143c6$var$isHalant(glyph) {
  return glyph.shaperInfo.category === "H" && !glyph.isLigated;
}
function $7ab494fe977143c6$var$isBase(info) {
  return info.category === "B" || info.category === "GB";
}
var $102b6fe50f1d50b4$var$SHAPERS = {
  arab: (0, $764eb544bbe1ccf0$export$2e2bcd8739ae039),
  mong: (0, $764eb544bbe1ccf0$export$2e2bcd8739ae039),
  syrc: (0, $764eb544bbe1ccf0$export$2e2bcd8739ae039),
  "nko ": (0, $764eb544bbe1ccf0$export$2e2bcd8739ae039),
  phag: (0, $764eb544bbe1ccf0$export$2e2bcd8739ae039),
  mand: (0, $764eb544bbe1ccf0$export$2e2bcd8739ae039),
  mani: (0, $764eb544bbe1ccf0$export$2e2bcd8739ae039),
  phlp: (0, $764eb544bbe1ccf0$export$2e2bcd8739ae039),
  hang: (0, $e1c6bbc8cb416f8c$export$2e2bcd8739ae039),
  bng2: (0, $7826f90f6f0cecc9$export$2e2bcd8739ae039),
  beng: (0, $7826f90f6f0cecc9$export$2e2bcd8739ae039),
  dev2: (0, $7826f90f6f0cecc9$export$2e2bcd8739ae039),
  deva: (0, $7826f90f6f0cecc9$export$2e2bcd8739ae039),
  gjr2: (0, $7826f90f6f0cecc9$export$2e2bcd8739ae039),
  gujr: (0, $7826f90f6f0cecc9$export$2e2bcd8739ae039),
  guru: (0, $7826f90f6f0cecc9$export$2e2bcd8739ae039),
  gur2: (0, $7826f90f6f0cecc9$export$2e2bcd8739ae039),
  knda: (0, $7826f90f6f0cecc9$export$2e2bcd8739ae039),
  knd2: (0, $7826f90f6f0cecc9$export$2e2bcd8739ae039),
  mlm2: (0, $7826f90f6f0cecc9$export$2e2bcd8739ae039),
  mlym: (0, $7826f90f6f0cecc9$export$2e2bcd8739ae039),
  ory2: (0, $7826f90f6f0cecc9$export$2e2bcd8739ae039),
  orya: (0, $7826f90f6f0cecc9$export$2e2bcd8739ae039),
  taml: (0, $7826f90f6f0cecc9$export$2e2bcd8739ae039),
  tml2: (0, $7826f90f6f0cecc9$export$2e2bcd8739ae039),
  telu: (0, $7826f90f6f0cecc9$export$2e2bcd8739ae039),
  tel2: (0, $7826f90f6f0cecc9$export$2e2bcd8739ae039),
  khmr: (0, $7826f90f6f0cecc9$export$2e2bcd8739ae039),
  bali: (0, $7ab494fe977143c6$export$2e2bcd8739ae039),
  batk: (0, $7ab494fe977143c6$export$2e2bcd8739ae039),
  brah: (0, $7ab494fe977143c6$export$2e2bcd8739ae039),
  bugi: (0, $7ab494fe977143c6$export$2e2bcd8739ae039),
  buhd: (0, $7ab494fe977143c6$export$2e2bcd8739ae039),
  cakm: (0, $7ab494fe977143c6$export$2e2bcd8739ae039),
  cham: (0, $7ab494fe977143c6$export$2e2bcd8739ae039),
  dupl: (0, $7ab494fe977143c6$export$2e2bcd8739ae039),
  egyp: (0, $7ab494fe977143c6$export$2e2bcd8739ae039),
  gran: (0, $7ab494fe977143c6$export$2e2bcd8739ae039),
  hano: (0, $7ab494fe977143c6$export$2e2bcd8739ae039),
  java: (0, $7ab494fe977143c6$export$2e2bcd8739ae039),
  kthi: (0, $7ab494fe977143c6$export$2e2bcd8739ae039),
  kali: (0, $7ab494fe977143c6$export$2e2bcd8739ae039),
  khar: (0, $7ab494fe977143c6$export$2e2bcd8739ae039),
  khoj: (0, $7ab494fe977143c6$export$2e2bcd8739ae039),
  sind: (0, $7ab494fe977143c6$export$2e2bcd8739ae039),
  lepc: (0, $7ab494fe977143c6$export$2e2bcd8739ae039),
  limb: (0, $7ab494fe977143c6$export$2e2bcd8739ae039),
  mahj: (0, $7ab494fe977143c6$export$2e2bcd8739ae039),
  // mand: UniversalShaper, // Mandaic
  // mani: UniversalShaper, // Manichaean
  mtei: (0, $7ab494fe977143c6$export$2e2bcd8739ae039),
  modi: (0, $7ab494fe977143c6$export$2e2bcd8739ae039),
  // mong: UniversalShaper, // Mongolian
  // 'nko ': UniversalShaper, // N’Ko
  hmng: (0, $7ab494fe977143c6$export$2e2bcd8739ae039),
  // phag: UniversalShaper, // Phags-pa
  // phlp: UniversalShaper, // Psalter Pahlavi
  rjng: (0, $7ab494fe977143c6$export$2e2bcd8739ae039),
  saur: (0, $7ab494fe977143c6$export$2e2bcd8739ae039),
  shrd: (0, $7ab494fe977143c6$export$2e2bcd8739ae039),
  sidd: (0, $7ab494fe977143c6$export$2e2bcd8739ae039),
  sinh: (0, $7826f90f6f0cecc9$export$2e2bcd8739ae039),
  sund: (0, $7ab494fe977143c6$export$2e2bcd8739ae039),
  sylo: (0, $7ab494fe977143c6$export$2e2bcd8739ae039),
  tglg: (0, $7ab494fe977143c6$export$2e2bcd8739ae039),
  tagb: (0, $7ab494fe977143c6$export$2e2bcd8739ae039),
  tale: (0, $7ab494fe977143c6$export$2e2bcd8739ae039),
  lana: (0, $7ab494fe977143c6$export$2e2bcd8739ae039),
  tavt: (0, $7ab494fe977143c6$export$2e2bcd8739ae039),
  takr: (0, $7ab494fe977143c6$export$2e2bcd8739ae039),
  tibt: (0, $7ab494fe977143c6$export$2e2bcd8739ae039),
  tfng: (0, $7ab494fe977143c6$export$2e2bcd8739ae039),
  tirh: (0, $7ab494fe977143c6$export$2e2bcd8739ae039),
  latn: (0, $649970d87335b30f$export$2e2bcd8739ae039),
  DFLT: (0, $649970d87335b30f$export$2e2bcd8739ae039)
};
function $102b6fe50f1d50b4$export$7877a478dd30fd3d(script) {
  if (!Array.isArray(script)) script = [
    script
  ];
  for (let s of script) {
    let shaper = $102b6fe50f1d50b4$var$SHAPERS[s];
    if (shaper) return shaper;
  }
  return 0, $649970d87335b30f$export$2e2bcd8739ae039;
}
var $0a876c45f1f7c41c$export$2e2bcd8739ae039 = class extends (0, $a83b9c36aaa94fd3$export$2e2bcd8739ae039) {
  applyLookup(lookupType, table) {
    switch (lookupType) {
      case 1: {
        let index3 = this.coverageIndex(table.coverage);
        if (index3 === -1) return false;
        let glyph = this.glyphIterator.cur;
        switch (table.version) {
          case 1:
            glyph.id = glyph.id + table.deltaGlyphID & 65535;
            break;
          case 2:
            glyph.id = table.substitute.get(index3);
            break;
        }
        return true;
      }
      case 2: {
        let index3 = this.coverageIndex(table.coverage);
        if (index3 !== -1) {
          let sequence = table.sequences.get(index3);
          if (sequence.length === 0) {
            this.glyphs.splice(this.glyphIterator.index, 1);
            return true;
          }
          this.glyphIterator.cur.id = sequence[0];
          this.glyphIterator.cur.ligatureComponent = 0;
          let features = this.glyphIterator.cur.features;
          let curGlyph = this.glyphIterator.cur;
          let replacement = sequence.slice(1).map((gid, i) => {
            let glyph = new (0, $10e7b257e1a9a756$export$2e2bcd8739ae039)(this.font, gid, void 0, features);
            glyph.shaperInfo = curGlyph.shaperInfo;
            glyph.isLigated = curGlyph.isLigated;
            glyph.ligatureComponent = i + 1;
            glyph.substituted = true;
            glyph.isMultiplied = true;
            return glyph;
          });
          this.glyphs.splice(this.glyphIterator.index + 1, 0, ...replacement);
          return true;
        }
        return false;
      }
      case 3: {
        let index3 = this.coverageIndex(table.coverage);
        if (index3 !== -1) {
          let USER_INDEX = 0;
          this.glyphIterator.cur.id = table.alternateSet.get(index3)[USER_INDEX];
          return true;
        }
        return false;
      }
      case 4: {
        let index3 = this.coverageIndex(table.coverage);
        if (index3 === -1) return false;
        for (let ligature of table.ligatureSets.get(index3)) {
          let matched = this.sequenceMatchIndices(1, ligature.components);
          if (!matched) continue;
          let curGlyph = this.glyphIterator.cur;
          let characters2 = curGlyph.codePoints.slice();
          for (let index4 of matched) characters2.push(...this.glyphs[index4].codePoints);
          let ligatureGlyph = new (0, $10e7b257e1a9a756$export$2e2bcd8739ae039)(this.font, ligature.glyph, characters2, curGlyph.features);
          ligatureGlyph.shaperInfo = curGlyph.shaperInfo;
          ligatureGlyph.isLigated = true;
          ligatureGlyph.substituted = true;
          let isMarkLigature = curGlyph.isMark;
          for (let i = 0; i < matched.length && isMarkLigature; i++) isMarkLigature = this.glyphs[matched[i]].isMark;
          ligatureGlyph.ligatureID = isMarkLigature ? null : this.ligatureID++;
          let lastLigID = curGlyph.ligatureID;
          let lastNumComps = curGlyph.codePoints.length;
          let curComps = lastNumComps;
          let idx = this.glyphIterator.index + 1;
          for (let matchIndex of matched) {
            if (isMarkLigature) idx = matchIndex;
            else while (idx < matchIndex) {
              var ligatureComponent = curComps - lastNumComps + Math.min(this.glyphs[idx].ligatureComponent || 1, lastNumComps);
              this.glyphs[idx].ligatureID = ligatureGlyph.ligatureID;
              this.glyphs[idx].ligatureComponent = ligatureComponent;
              idx++;
            }
            lastLigID = this.glyphs[idx].ligatureID;
            lastNumComps = this.glyphs[idx].codePoints.length;
            curComps += lastNumComps;
            idx++;
          }
          if (lastLigID && !isMarkLigature) for (let i = idx; i < this.glyphs.length; i++) {
            if (this.glyphs[i].ligatureID === lastLigID) {
              var ligatureComponent = curComps - lastNumComps + Math.min(this.glyphs[i].ligatureComponent || 1, lastNumComps);
              this.glyphs[i].ligatureComponent = ligatureComponent;
            } else break;
          }
          for (let i = matched.length - 1; i >= 0; i--) this.glyphs.splice(matched[i], 1);
          this.glyphs[this.glyphIterator.index] = ligatureGlyph;
          return true;
        }
        return false;
      }
      case 5:
        return this.applyContext(table);
      case 6:
        return this.applyChainingContext(table);
      case 7:
        return this.applyLookup(table.lookupType, table.extension);
      default:
        throw new Error(`GSUB lookupType ${lookupType} is not supported`);
    }
  }
};
var $c96c93587d49c14d$export$2e2bcd8739ae039 = class extends (0, $a83b9c36aaa94fd3$export$2e2bcd8739ae039) {
  applyPositionValue(sequenceIndex, value) {
    let position3 = this.positions[this.glyphIterator.peekIndex(sequenceIndex)];
    if (value.xAdvance != null) position3.xAdvance += value.xAdvance;
    if (value.yAdvance != null) position3.yAdvance += value.yAdvance;
    if (value.xPlacement != null) position3.xOffset += value.xPlacement;
    if (value.yPlacement != null) position3.yOffset += value.yPlacement;
    let variationProcessor = this.font._variationProcessor;
    let variationStore = this.font.GDEF && this.font.GDEF.itemVariationStore;
    if (variationProcessor && variationStore) {
      if (value.xPlaDevice) position3.xOffset += variationProcessor.getDelta(variationStore, value.xPlaDevice.a, value.xPlaDevice.b);
      if (value.yPlaDevice) position3.yOffset += variationProcessor.getDelta(variationStore, value.yPlaDevice.a, value.yPlaDevice.b);
      if (value.xAdvDevice) position3.xAdvance += variationProcessor.getDelta(variationStore, value.xAdvDevice.a, value.xAdvDevice.b);
      if (value.yAdvDevice) position3.yAdvance += variationProcessor.getDelta(variationStore, value.yAdvDevice.a, value.yAdvDevice.b);
    }
  }
  applyLookup(lookupType, table) {
    switch (lookupType) {
      case 1: {
        let index3 = this.coverageIndex(table.coverage);
        if (index3 === -1) return false;
        switch (table.version) {
          case 1:
            this.applyPositionValue(0, table.value);
            break;
          case 2:
            this.applyPositionValue(0, table.values.get(index3));
            break;
        }
        return true;
      }
      case 2: {
        let nextGlyph = this.glyphIterator.peek();
        if (!nextGlyph) return false;
        let index3 = this.coverageIndex(table.coverage);
        if (index3 === -1) return false;
        switch (table.version) {
          case 1:
            let set4 = table.pairSets.get(index3);
            for (let pair2 of set4) if (pair2.secondGlyph === nextGlyph.id) {
              this.applyPositionValue(0, pair2.value1);
              this.applyPositionValue(1, pair2.value2);
              return true;
            }
            return false;
          case 2:
            let class1 = this.getClassID(this.glyphIterator.cur.id, table.classDef1);
            let class2 = this.getClassID(nextGlyph.id, table.classDef2);
            if (class1 === -1 || class2 === -1) return false;
            var pair = table.classRecords.get(class1).get(class2);
            this.applyPositionValue(0, pair.value1);
            this.applyPositionValue(1, pair.value2);
            return true;
        }
      }
      case 3: {
        let nextIndex2 = this.glyphIterator.peekIndex();
        let nextGlyph = this.glyphs[nextIndex2];
        if (!nextGlyph) return false;
        let curRecord = table.entryExitRecords[this.coverageIndex(table.coverage)];
        if (!curRecord || !curRecord.exitAnchor) return false;
        let nextRecord = table.entryExitRecords[this.coverageIndex(table.coverage, nextGlyph.id)];
        if (!nextRecord || !nextRecord.entryAnchor) return false;
        let entry = this.getAnchor(nextRecord.entryAnchor);
        let exit = this.getAnchor(curRecord.exitAnchor);
        let cur = this.positions[this.glyphIterator.index];
        let next2 = this.positions[nextIndex2];
        let d;
        switch (this.direction) {
          case "ltr":
            cur.xAdvance = exit.x + cur.xOffset;
            d = entry.x + next2.xOffset;
            next2.xAdvance -= d;
            next2.xOffset -= d;
            break;
          case "rtl":
            d = exit.x + cur.xOffset;
            cur.xAdvance -= d;
            cur.xOffset -= d;
            next2.xAdvance = entry.x + next2.xOffset;
            break;
        }
        if (this.glyphIterator.flags.rightToLeft) {
          this.glyphIterator.cur.cursiveAttachment = nextIndex2;
          cur.yOffset = entry.y - exit.y;
        } else {
          nextGlyph.cursiveAttachment = this.glyphIterator.index;
          cur.yOffset = exit.y - entry.y;
        }
        return true;
      }
      case 4: {
        let markIndex = this.coverageIndex(table.markCoverage);
        if (markIndex === -1) return false;
        let baseGlyphIndex = this.glyphIterator.index;
        while (--baseGlyphIndex >= 0 && (this.glyphs[baseGlyphIndex].isMark || this.glyphs[baseGlyphIndex].ligatureComponent > 0)) ;
        if (baseGlyphIndex < 0) return false;
        let baseIndex = this.coverageIndex(table.baseCoverage, this.glyphs[baseGlyphIndex].id);
        if (baseIndex === -1) return false;
        let markRecord = table.markArray[markIndex];
        let baseAnchor = table.baseArray[baseIndex][markRecord.class];
        this.applyAnchor(markRecord, baseAnchor, baseGlyphIndex);
        return true;
      }
      case 5: {
        let markIndex = this.coverageIndex(table.markCoverage);
        if (markIndex === -1) return false;
        let baseGlyphIndex = this.glyphIterator.index;
        while (--baseGlyphIndex >= 0 && this.glyphs[baseGlyphIndex].isMark) ;
        if (baseGlyphIndex < 0) return false;
        let ligIndex = this.coverageIndex(table.ligatureCoverage, this.glyphs[baseGlyphIndex].id);
        if (ligIndex === -1) return false;
        let ligAttach = table.ligatureArray[ligIndex];
        let markGlyph = this.glyphIterator.cur;
        let ligGlyph = this.glyphs[baseGlyphIndex];
        let compIndex = ligGlyph.ligatureID && ligGlyph.ligatureID === markGlyph.ligatureID && markGlyph.ligatureComponent > 0 ? Math.min(markGlyph.ligatureComponent, ligGlyph.codePoints.length) - 1 : ligGlyph.codePoints.length - 1;
        let markRecord = table.markArray[markIndex];
        let baseAnchor = ligAttach[compIndex][markRecord.class];
        this.applyAnchor(markRecord, baseAnchor, baseGlyphIndex);
        return true;
      }
      case 6: {
        let mark1Index = this.coverageIndex(table.mark1Coverage);
        if (mark1Index === -1) return false;
        let prevIndex = this.glyphIterator.peekIndex(-1);
        let prev2 = this.glyphs[prevIndex];
        if (!prev2 || !prev2.isMark) return false;
        let cur = this.glyphIterator.cur;
        let good = false;
        if (cur.ligatureID === prev2.ligatureID) {
          if (!cur.ligatureID) good = true;
          else if (cur.ligatureComponent === prev2.ligatureComponent) good = true;
        } else if (cur.ligatureID && !cur.ligatureComponent || prev2.ligatureID && !prev2.ligatureComponent) good = true;
        if (!good) return false;
        let mark2Index = this.coverageIndex(table.mark2Coverage, prev2.id);
        if (mark2Index === -1) return false;
        let markRecord = table.mark1Array[mark1Index];
        let baseAnchor = table.mark2Array[mark2Index][markRecord.class];
        this.applyAnchor(markRecord, baseAnchor, prevIndex);
        return true;
      }
      case 7:
        return this.applyContext(table);
      case 8:
        return this.applyChainingContext(table);
      case 9:
        return this.applyLookup(table.lookupType, table.extension);
      default:
        throw new Error(`Unsupported GPOS table: ${lookupType}`);
    }
  }
  applyAnchor(markRecord, baseAnchor, baseGlyphIndex) {
    let baseCoords = this.getAnchor(baseAnchor);
    let markCoords = this.getAnchor(markRecord.markAnchor);
    let basePos = this.positions[baseGlyphIndex];
    let markPos = this.positions[this.glyphIterator.index];
    markPos.xOffset = baseCoords.x - markCoords.x;
    markPos.yOffset = baseCoords.y - markCoords.y;
    this.glyphIterator.cur.markAttachment = baseGlyphIndex;
  }
  getAnchor(anchor) {
    let x = anchor.xCoordinate;
    let y = anchor.yCoordinate;
    let variationProcessor = this.font._variationProcessor;
    let variationStore = this.font.GDEF && this.font.GDEF.itemVariationStore;
    if (variationProcessor && variationStore) {
      if (anchor.xDeviceTable) x += variationProcessor.getDelta(variationStore, anchor.xDeviceTable.a, anchor.xDeviceTable.b);
      if (anchor.yDeviceTable) y += variationProcessor.getDelta(variationStore, anchor.yDeviceTable.a, anchor.yDeviceTable.b);
    }
    return {
      x,
      y
    };
  }
  applyFeatures(userFeatures, glyphs, advances) {
    super.applyFeatures(userFeatures, glyphs, advances);
    for (var i = 0; i < this.glyphs.length; i++) this.fixCursiveAttachment(i);
    this.fixMarkAttachment();
  }
  fixCursiveAttachment(i) {
    let glyph = this.glyphs[i];
    if (glyph.cursiveAttachment != null) {
      let j = glyph.cursiveAttachment;
      glyph.cursiveAttachment = null;
      this.fixCursiveAttachment(j);
      this.positions[i].yOffset += this.positions[j].yOffset;
    }
  }
  fixMarkAttachment() {
    for (let i = 0; i < this.glyphs.length; i++) {
      let glyph = this.glyphs[i];
      if (glyph.markAttachment != null) {
        let j = glyph.markAttachment;
        this.positions[i].xOffset += this.positions[j].xOffset;
        this.positions[i].yOffset += this.positions[j].yOffset;
        if (this.direction === "ltr") for (let k = j; k < i; k++) {
          this.positions[i].xOffset -= this.positions[k].xAdvance;
          this.positions[i].yOffset -= this.positions[k].yAdvance;
        }
        else for (let k = j + 1; k < i + 1; k++) {
          this.positions[i].xOffset += this.positions[k].xAdvance;
          this.positions[i].yOffset += this.positions[k].yAdvance;
        }
      }
    }
  }
};
var $a62492810de27e3d$export$2e2bcd8739ae039 = class {
  setup(glyphRun) {
    this.glyphInfos = glyphRun.glyphs.map((glyph) => new (0, $10e7b257e1a9a756$export$2e2bcd8739ae039)(this.font, glyph.id, [
      ...glyph.codePoints
    ]));
    let script = null;
    if (this.GPOSProcessor) script = this.GPOSProcessor.selectScript(glyphRun.script, glyphRun.language, glyphRun.direction);
    if (this.GSUBProcessor) script = this.GSUBProcessor.selectScript(glyphRun.script, glyphRun.language, glyphRun.direction);
    this.shaper = $102b6fe50f1d50b4$export$7877a478dd30fd3d(script);
    this.plan = new (0, $94d7a73bd2edfc9a$export$2e2bcd8739ae039)(this.font, script, glyphRun.direction);
    this.shaper.plan(this.plan, this.glyphInfos, glyphRun.features);
    for (let key2 in this.plan.allFeatures) glyphRun.features[key2] = true;
  }
  substitute(glyphRun) {
    if (this.GSUBProcessor) {
      this.plan.process(this.GSUBProcessor, this.glyphInfos);
      glyphRun.glyphs = this.glyphInfos.map((glyphInfo) => this.font.getGlyph(glyphInfo.id, glyphInfo.codePoints));
    }
  }
  position(glyphRun) {
    if (this.shaper.zeroMarkWidths === "BEFORE_GPOS") this.zeroMarkAdvances(glyphRun.positions);
    if (this.GPOSProcessor) this.plan.process(this.GPOSProcessor, this.glyphInfos, glyphRun.positions);
    if (this.shaper.zeroMarkWidths === "AFTER_GPOS") this.zeroMarkAdvances(glyphRun.positions);
    if (glyphRun.direction === "rtl") {
      glyphRun.glyphs.reverse();
      glyphRun.positions.reverse();
    }
    return this.GPOSProcessor && this.GPOSProcessor.features;
  }
  zeroMarkAdvances(positions) {
    for (let i = 0; i < this.glyphInfos.length; i++) if (this.glyphInfos[i].isMark) {
      positions[i].xAdvance = 0;
      positions[i].yAdvance = 0;
    }
  }
  cleanup() {
    this.glyphInfos = null;
    this.plan = null;
    this.shaper = null;
  }
  getAvailableFeatures(script, language) {
    let features = [];
    if (this.GSUBProcessor) {
      this.GSUBProcessor.selectScript(script, language);
      features.push(...Object.keys(this.GSUBProcessor.features));
    }
    if (this.GPOSProcessor) {
      this.GPOSProcessor.selectScript(script, language);
      features.push(...Object.keys(this.GPOSProcessor.features));
    }
    return features;
  }
  constructor(font) {
    this.font = font;
    this.glyphInfos = null;
    this.plan = null;
    this.GSUBProcessor = null;
    this.GPOSProcessor = null;
    this.fallbackPosition = true;
    if (font.GSUB) this.GSUBProcessor = new (0, $0a876c45f1f7c41c$export$2e2bcd8739ae039)(font, font.GSUB);
    if (font.GPOS) this.GPOSProcessor = new (0, $c96c93587d49c14d$export$2e2bcd8739ae039)(font, font.GPOS);
  }
};
var $4c0a7fa5df7a9ab1$export$2e2bcd8739ae039 = class {
  layout(string3, features, script, language, direction) {
    if (typeof features === "string") {
      direction = language;
      language = script;
      script = features;
      features = [];
    }
    if (typeof string3 === "string") {
      if (script == null) script = $130d1a642ebcd2b7$export$e5cb25e204fb8450(string3);
      var glyphs = this.font.glyphsForString(string3);
    } else {
      if (script == null) {
        let codePoints = [];
        for (let glyph of string3) codePoints.push(...glyph.codePoints);
        script = $130d1a642ebcd2b7$export$16fab0757cfc223d(codePoints);
      }
      var glyphs = string3;
    }
    let glyphRun = new (0, $be07b3e97a42687a$export$2e2bcd8739ae039)(glyphs, features, script, language, direction);
    if (glyphs.length === 0) {
      glyphRun.positions = [];
      return glyphRun;
    }
    if (this.engine && this.engine.setup) this.engine.setup(glyphRun);
    this.substitute(glyphRun);
    this.position(glyphRun);
    this.hideDefaultIgnorables(glyphRun.glyphs, glyphRun.positions);
    if (this.engine && this.engine.cleanup) this.engine.cleanup();
    return glyphRun;
  }
  substitute(glyphRun) {
    if (this.engine && this.engine.substitute) this.engine.substitute(glyphRun);
  }
  position(glyphRun) {
    glyphRun.positions = glyphRun.glyphs.map((glyph) => new (0, $1ac75d9a55b67f01$export$2e2bcd8739ae039)(glyph.advanceWidth));
    let positioned = null;
    if (this.engine && this.engine.position) positioned = this.engine.position(glyphRun);
    if (!positioned && (!this.engine || this.engine.fallbackPosition)) {
      if (!this.unicodeLayoutEngine) this.unicodeLayoutEngine = new (0, $0a4bdfeb6dfd6f5e$export$2e2bcd8739ae039)(this.font);
      this.unicodeLayoutEngine.positionGlyphs(glyphRun.glyphs, glyphRun.positions);
    }
    if ((!positioned || !positioned.kern) && glyphRun.features.kern !== false && this.font.kern) {
      if (!this.kernProcessor) this.kernProcessor = new (0, $0bba3a9db57637f3$export$2e2bcd8739ae039)(this.font);
      this.kernProcessor.process(glyphRun.glyphs, glyphRun.positions);
      glyphRun.features.kern = true;
    }
  }
  hideDefaultIgnorables(glyphs, positions) {
    let space = this.font.glyphForCodePoint(32);
    for (let i = 0; i < glyphs.length; i++) if (this.isDefaultIgnorable(glyphs[i].codePoints[0])) {
      glyphs[i] = space;
      positions[i].xAdvance = 0;
      positions[i].yAdvance = 0;
    }
  }
  isDefaultIgnorable(ch) {
    let plane = ch >> 16;
    if (plane === 0)
      switch (ch >> 8) {
        case 0:
          return ch === 173;
        case 3:
          return ch === 847;
        case 6:
          return ch === 1564;
        case 23:
          return 6068 <= ch && ch <= 6069;
        case 24:
          return 6155 <= ch && ch <= 6158;
        case 32:
          return 8203 <= ch && ch <= 8207 || 8234 <= ch && ch <= 8238 || 8288 <= ch && ch <= 8303;
        case 254:
          return 65024 <= ch && ch <= 65039 || ch === 65279;
        case 255:
          return 65520 <= ch && ch <= 65528;
        default:
          return false;
      }
    else
      switch (plane) {
        case 1:
          return 113824 <= ch && ch <= 113827 || 119155 <= ch && ch <= 119162;
        case 14:
          return 917504 <= ch && ch <= 921599;
        default:
          return false;
      }
  }
  getAvailableFeatures(script, language) {
    let features = [];
    if (this.engine) features.push(...this.engine.getAvailableFeatures(script, language));
    if (this.font.kern && features.indexOf("kern") === -1) features.push("kern");
    return features;
  }
  stringsForGlyph(gid) {
    let result = /* @__PURE__ */ new Set();
    let codePoints = this.font._cmapProcessor.codePointsForGlyph(gid);
    for (let codePoint of codePoints) result.add(String.fromCodePoint(codePoint));
    if (this.engine && this.engine.stringsForGlyph) for (let string3 of this.engine.stringsForGlyph(gid)) result.add(string3);
    return Array.from(result);
  }
  constructor(font) {
    this.font = font;
    this.unicodeLayoutEngine = null;
    this.kernProcessor = null;
    if (this.font.morx) this.engine = new (0, $ba6dd74203be8728$export$2e2bcd8739ae039)(this.font);
    else if (this.font.GSUB || this.font.GPOS) this.engine = new (0, $a62492810de27e3d$export$2e2bcd8739ae039)(this.font);
  }
};
var $f43aec954cdfdf21$var$SVG_COMMANDS = {
  moveTo: "M",
  lineTo: "L",
  quadraticCurveTo: "Q",
  bezierCurveTo: "C",
  closePath: "Z"
};
var $f43aec954cdfdf21$export$2e2bcd8739ae039 = class _$f43aec954cdfdf21$export$2e2bcd8739ae039 {
  /**
  * Compiles the path to a JavaScript function that can be applied with
  * a graphics context in order to render the path.
  * @return {string}
  */
  toFunction() {
    return (ctx) => {
      this.commands.forEach((c) => {
        return ctx[c.command].apply(ctx, c.args);
      });
    };
  }
  /**
  * Converts the path to an SVG path data string
  * @return {string}
  */
  toSVG() {
    let cmds = this.commands.map((c) => {
      let args = c.args.map((arg) => Math.round(arg * 100) / 100);
      return `${$f43aec954cdfdf21$var$SVG_COMMANDS[c.command]}${args.join(" ")}`;
    });
    return cmds.join("");
  }
  /**
  * Gets the "control box" of a path.
  * This is like the bounding box, but it includes all points including
  * control points of bezier segments and is much faster to compute than
  * the real bounding box.
  * @type {BBox}
  */
  get cbox() {
    if (!this._cbox) {
      let cbox = new (0, $f34600ab9d7f70d8$export$2e2bcd8739ae039)();
      for (let command of this.commands) for (let i = 0; i < command.args.length; i += 2) cbox.addPoint(command.args[i], command.args[i + 1]);
      this._cbox = Object.freeze(cbox);
    }
    return this._cbox;
  }
  /**
  * Gets the exact bounding box of the path by evaluating curve segments.
  * Slower to compute than the control box, but more accurate.
  * @type {BBox}
  */
  get bbox() {
    if (this._bbox) return this._bbox;
    let bbox = new (0, $f34600ab9d7f70d8$export$2e2bcd8739ae039)();
    let cx = 0, cy = 0;
    let f = (t2) => Math.pow(1 - t2, 3) * p0[i] + 3 * Math.pow(1 - t2, 2) * t2 * p1[i] + 3 * (1 - t2) * Math.pow(t2, 2) * p2[i] + Math.pow(t2, 3) * p3[i];
    for (let c of this.commands) switch (c.command) {
      case "moveTo":
      case "lineTo":
        let [x, y] = c.args;
        bbox.addPoint(x, y);
        cx = x;
        cy = y;
        break;
      case "quadraticCurveTo":
      case "bezierCurveTo":
        if (c.command === "quadraticCurveTo") {
          var [qp1x, qp1y, p3x, p3y] = c.args;
          var cp1x = cx + 2 / 3 * (qp1x - cx);
          var cp1y = cy + 2 / 3 * (qp1y - cy);
          var cp2x = p3x + 2 / 3 * (qp1x - p3x);
          var cp2y = p3y + 2 / 3 * (qp1y - p3y);
        } else var [cp1x, cp1y, cp2x, cp2y, p3x, p3y] = c.args;
        bbox.addPoint(p3x, p3y);
        var p0 = [
          cx,
          cy
        ];
        var p1 = [
          cp1x,
          cp1y
        ];
        var p2 = [
          cp2x,
          cp2y
        ];
        var p3 = [
          p3x,
          p3y
        ];
        for (var i = 0; i <= 1; i++) {
          let b = 6 * p0[i] - 12 * p1[i] + 6 * p2[i];
          let a = -3 * p0[i] + 9 * p1[i] - 9 * p2[i] + 3 * p3[i];
          c = 3 * p1[i] - 3 * p0[i];
          if (a === 0) {
            if (b === 0) continue;
            let t3 = -c / b;
            if (0 < t3 && t3 < 1) {
              if (i === 0) bbox.addPoint(f(t3), bbox.maxY);
              else if (i === 1) bbox.addPoint(bbox.maxX, f(t3));
            }
            continue;
          }
          let b2ac = Math.pow(b, 2) - 4 * c * a;
          if (b2ac < 0) continue;
          let t1 = (-b + Math.sqrt(b2ac)) / (2 * a);
          if (0 < t1 && t1 < 1) {
            if (i === 0) bbox.addPoint(f(t1), bbox.maxY);
            else if (i === 1) bbox.addPoint(bbox.maxX, f(t1));
          }
          let t2 = (-b - Math.sqrt(b2ac)) / (2 * a);
          if (0 < t2 && t2 < 1) {
            if (i === 0) bbox.addPoint(f(t2), bbox.maxY);
            else if (i === 1) bbox.addPoint(bbox.maxX, f(t2));
          }
        }
        cx = p3x;
        cy = p3y;
        break;
    }
    return this._bbox = Object.freeze(bbox);
  }
  /**
  * Applies a mapping function to each point in the path.
  * @param {function} fn
  * @return {Path}
  */
  mapPoints(fn) {
    let path2 = new _$f43aec954cdfdf21$export$2e2bcd8739ae039();
    for (let c of this.commands) {
      let args = [];
      for (let i = 0; i < c.args.length; i += 2) {
        let [x, y] = fn(c.args[i], c.args[i + 1]);
        args.push(x, y);
      }
      path2[c.command](...args);
    }
    return path2;
  }
  /**
  * Transforms the path by the given matrix.
  */
  transform(m0, m1, m2, m3, m4, m5) {
    return this.mapPoints((x, y) => {
      const tx = m0 * x + m2 * y + m4;
      const ty = m1 * x + m3 * y + m5;
      return [
        tx,
        ty
      ];
    });
  }
  /**
  * Translates the path by the given offset.
  */
  translate(x, y) {
    return this.transform(1, 0, 0, 1, x, y);
  }
  /**
  * Rotates the path by the given angle (in radians).
  */
  rotate(angle) {
    let cos = Math.cos(angle);
    let sin = Math.sin(angle);
    return this.transform(cos, sin, -sin, cos, 0, 0);
  }
  /**
  * Scales the path.
  */
  scale(scaleX, scaleY = scaleX) {
    return this.transform(scaleX, 0, 0, scaleY, 0, 0);
  }
  constructor() {
    this.commands = [];
    this._bbox = null;
    this._cbox = null;
  }
};
for (let command of [
  "moveTo",
  "lineTo",
  "quadraticCurveTo",
  "bezierCurveTo",
  "closePath"
]) $f43aec954cdfdf21$export$2e2bcd8739ae039.prototype[command] = function(...args) {
  this._bbox = this._cbox = null;
  this.commands.push({
    command,
    args
  });
  return this;
};
var $7713b9b7b438dff8$export$2e2bcd8739ae039 = [
  ".notdef",
  ".null",
  "nonmarkingreturn",
  "space",
  "exclam",
  "quotedbl",
  "numbersign",
  "dollar",
  "percent",
  "ampersand",
  "quotesingle",
  "parenleft",
  "parenright",
  "asterisk",
  "plus",
  "comma",
  "hyphen",
  "period",
  "slash",
  "zero",
  "one",
  "two",
  "three",
  "four",
  "five",
  "six",
  "seven",
  "eight",
  "nine",
  "colon",
  "semicolon",
  "less",
  "equal",
  "greater",
  "question",
  "at",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  "bracketleft",
  "backslash",
  "bracketright",
  "asciicircum",
  "underscore",
  "grave",
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z",
  "braceleft",
  "bar",
  "braceright",
  "asciitilde",
  "Adieresis",
  "Aring",
  "Ccedilla",
  "Eacute",
  "Ntilde",
  "Odieresis",
  "Udieresis",
  "aacute",
  "agrave",
  "acircumflex",
  "adieresis",
  "atilde",
  "aring",
  "ccedilla",
  "eacute",
  "egrave",
  "ecircumflex",
  "edieresis",
  "iacute",
  "igrave",
  "icircumflex",
  "idieresis",
  "ntilde",
  "oacute",
  "ograve",
  "ocircumflex",
  "odieresis",
  "otilde",
  "uacute",
  "ugrave",
  "ucircumflex",
  "udieresis",
  "dagger",
  "degree",
  "cent",
  "sterling",
  "section",
  "bullet",
  "paragraph",
  "germandbls",
  "registered",
  "copyright",
  "trademark",
  "acute",
  "dieresis",
  "notequal",
  "AE",
  "Oslash",
  "infinity",
  "plusminus",
  "lessequal",
  "greaterequal",
  "yen",
  "mu",
  "partialdiff",
  "summation",
  "product",
  "pi",
  "integral",
  "ordfeminine",
  "ordmasculine",
  "Omega",
  "ae",
  "oslash",
  "questiondown",
  "exclamdown",
  "logicalnot",
  "radical",
  "florin",
  "approxequal",
  "Delta",
  "guillemotleft",
  "guillemotright",
  "ellipsis",
  "nonbreakingspace",
  "Agrave",
  "Atilde",
  "Otilde",
  "OE",
  "oe",
  "endash",
  "emdash",
  "quotedblleft",
  "quotedblright",
  "quoteleft",
  "quoteright",
  "divide",
  "lozenge",
  "ydieresis",
  "Ydieresis",
  "fraction",
  "currency",
  "guilsinglleft",
  "guilsinglright",
  "fi",
  "fl",
  "daggerdbl",
  "periodcentered",
  "quotesinglbase",
  "quotedblbase",
  "perthousand",
  "Acircumflex",
  "Ecircumflex",
  "Aacute",
  "Edieresis",
  "Egrave",
  "Iacute",
  "Icircumflex",
  "Idieresis",
  "Igrave",
  "Oacute",
  "Ocircumflex",
  "apple",
  "Ograve",
  "Uacute",
  "Ucircumflex",
  "Ugrave",
  "dotlessi",
  "circumflex",
  "tilde",
  "macron",
  "breve",
  "dotaccent",
  "ring",
  "cedilla",
  "hungarumlaut",
  "ogonek",
  "caron",
  "Lslash",
  "lslash",
  "Scaron",
  "scaron",
  "Zcaron",
  "zcaron",
  "brokenbar",
  "Eth",
  "eth",
  "Yacute",
  "yacute",
  "Thorn",
  "thorn",
  "minus",
  "multiply",
  "onesuperior",
  "twosuperior",
  "threesuperior",
  "onehalf",
  "onequarter",
  "threequarters",
  "franc",
  "Gbreve",
  "gbreve",
  "Idotaccent",
  "Scedilla",
  "scedilla",
  "Cacute",
  "cacute",
  "Ccaron",
  "ccaron",
  "dcroat"
];
var $f92906be28e61769$export$2e2bcd8739ae039 = class {
  _getPath() {
    return new (0, $f43aec954cdfdf21$export$2e2bcd8739ae039)();
  }
  _getCBox() {
    return this.path.cbox;
  }
  _getBBox() {
    return this.path.bbox;
  }
  _getTableMetrics(table) {
    if (this.id < table.metrics.length) return table.metrics.get(this.id);
    let metric = table.metrics.get(table.metrics.length - 1);
    let res = {
      advance: metric ? metric.advance : 0,
      bearing: table.bearings.get(this.id - table.metrics.length) || 0
    };
    return res;
  }
  _getMetrics(cbox) {
    if (this._metrics) return this._metrics;
    let { advance: advanceWidth, bearing: leftBearing } = this._getTableMetrics(this._font.hmtx);
    if (this._font.vmtx) var { advance: advanceHeight, bearing: topBearing } = this._getTableMetrics(this._font.vmtx);
    else {
      let os2;
      if (typeof cbox === "undefined" || cbox === null) ({ cbox } = this);
      if ((os2 = this._font["OS/2"]) && os2.version > 0) {
        var advanceHeight = Math.abs(os2.typoAscender - os2.typoDescender);
        var topBearing = os2.typoAscender - cbox.maxY;
      } else {
        let { hhea } = this._font;
        var advanceHeight = Math.abs(hhea.ascent - hhea.descent);
        var topBearing = hhea.ascent - cbox.maxY;
      }
    }
    if (this._font._variationProcessor && this._font.HVAR) advanceWidth += this._font._variationProcessor.getAdvanceAdjustment(this.id, this._font.HVAR);
    return this._metrics = {
      advanceWidth,
      advanceHeight,
      leftBearing,
      topBearing
    };
  }
  /**
  * The glyph’s control box.
  * This is often the same as the bounding box, but is faster to compute.
  * Because of the way bezier curves are defined, some of the control points
  * can be outside of the bounding box. Where `bbox` takes this into account,
  * `cbox` does not. Thus, cbox is less accurate, but faster to compute.
  * See [here](http://www.freetype.org/freetype2/docs/glyphs/glyphs-6.html#section-2)
  * for a more detailed description.
  *
  * @type {BBox}
  */
  get cbox() {
    return this._getCBox();
  }
  /**
  * The glyph’s bounding box, i.e. the rectangle that encloses the
  * glyph outline as tightly as possible.
  * @type {BBox}
  */
  get bbox() {
    return this._getBBox();
  }
  /**
  * A vector Path object representing the glyph outline.
  * @type {Path}
  */
  get path() {
    return this._getPath();
  }
  /**
  * Returns a path scaled to the given font size.
  * @param {number} size
  * @return {Path}
  */
  getScaledPath(size) {
    let scale = 1 / this._font.unitsPerEm * size;
    return this.path.scale(scale);
  }
  /**
  * The glyph's advance width.
  * @type {number}
  */
  get advanceWidth() {
    return this._getMetrics().advanceWidth;
  }
  /**
  * The glyph's advance height.
  * @type {number}
  */
  get advanceHeight() {
    return this._getMetrics().advanceHeight;
  }
  get ligatureCaretPositions() {
  }
  _getName() {
    let { post } = this._font;
    if (!post) return null;
    switch (post.version) {
      case 1:
        return (0, $7713b9b7b438dff8$export$2e2bcd8739ae039)[this.id];
      case 2:
        let id = post.glyphNameIndex[this.id];
        if (id < (0, $7713b9b7b438dff8$export$2e2bcd8739ae039).length) return (0, $7713b9b7b438dff8$export$2e2bcd8739ae039)[id];
        return post.names[id - (0, $7713b9b7b438dff8$export$2e2bcd8739ae039).length];
      case 2.5:
        return (0, $7713b9b7b438dff8$export$2e2bcd8739ae039)[this.id + post.offsets[this.id]];
      case 4:
        return String.fromCharCode(post.map[this.id]);
    }
  }
  /**
  * The glyph's name
  * @type {string}
  */
  get name() {
    return this._getName();
  }
  /**
  * Renders the glyph to the given graphics context, at the specified font size.
  * @param {CanvasRenderingContext2d} ctx
  * @param {number} size
  */
  render(ctx, size) {
    ctx.save();
    let scale = 1 / this._font.head.unitsPerEm * size;
    ctx.scale(scale, scale);
    let fn = this.path.toFunction();
    fn(ctx);
    ctx.fill();
    ctx.restore();
  }
  constructor(id, codePoints, font) {
    this.id = id;
    this.codePoints = codePoints;
    this._font = font;
    this.isMark = this.codePoints.length > 0 && this.codePoints.every((0, $747425b437e121da$export$e33ad6871e762338));
    this.isLigature = this.codePoints.length > 1;
  }
};
(0, __decorate)([
  (0, $e71565f2ce09cb6b$export$69a3209f1a06c04d)
], $f92906be28e61769$export$2e2bcd8739ae039.prototype, "cbox", null);
(0, __decorate)([
  (0, $e71565f2ce09cb6b$export$69a3209f1a06c04d)
], $f92906be28e61769$export$2e2bcd8739ae039.prototype, "bbox", null);
(0, __decorate)([
  (0, $e71565f2ce09cb6b$export$69a3209f1a06c04d)
], $f92906be28e61769$export$2e2bcd8739ae039.prototype, "path", null);
(0, __decorate)([
  (0, $e71565f2ce09cb6b$export$69a3209f1a06c04d)
], $f92906be28e61769$export$2e2bcd8739ae039.prototype, "advanceWidth", null);
(0, __decorate)([
  (0, $e71565f2ce09cb6b$export$69a3209f1a06c04d)
], $f92906be28e61769$export$2e2bcd8739ae039.prototype, "advanceHeight", null);
(0, __decorate)([
  (0, $e71565f2ce09cb6b$export$69a3209f1a06c04d)
], $f92906be28e61769$export$2e2bcd8739ae039.prototype, "name", null);
var $69aac16029968692$var$GlyfHeader = new Struct({
  numberOfContours: int16,
  xMin: int16,
  yMin: int16,
  xMax: int16,
  yMax: int16
});
var $69aac16029968692$var$ON_CURVE = 1;
var $69aac16029968692$var$X_SHORT_VECTOR = 2;
var $69aac16029968692$var$Y_SHORT_VECTOR = 4;
var $69aac16029968692$var$REPEAT = 8;
var $69aac16029968692$var$SAME_X = 16;
var $69aac16029968692$var$SAME_Y = 32;
var $69aac16029968692$var$ARG_1_AND_2_ARE_WORDS = 1;
var $69aac16029968692$var$WE_HAVE_A_SCALE = 8;
var $69aac16029968692$var$MORE_COMPONENTS = 32;
var $69aac16029968692$var$WE_HAVE_AN_X_AND_Y_SCALE = 64;
var $69aac16029968692$var$WE_HAVE_A_TWO_BY_TWO = 128;
var $69aac16029968692$var$WE_HAVE_INSTRUCTIONS = 256;
var $69aac16029968692$export$baf26146a414f24a = class _$69aac16029968692$export$baf26146a414f24a {
  copy() {
    return new _$69aac16029968692$export$baf26146a414f24a(this.onCurve, this.endContour, this.x, this.y);
  }
  constructor(onCurve, endContour, x = 0, y = 0) {
    this.onCurve = onCurve;
    this.endContour = endContour;
    this.x = x;
    this.y = y;
  }
};
var $69aac16029968692$var$Component = class {
  constructor(glyphID, dx, dy) {
    this.glyphID = glyphID;
    this.dx = dx;
    this.dy = dy;
    this.pos = 0;
    this.scaleX = this.scaleY = 1;
    this.scale01 = this.scale10 = 0;
  }
};
var $69aac16029968692$export$2e2bcd8739ae039 = class extends (0, $f92906be28e61769$export$2e2bcd8739ae039) {
  // Parses just the glyph header and returns the bounding box
  _getCBox(internal) {
    if (this._font._variationProcessor && !internal) return this.path.cbox;
    let stream = this._font._getTableStream("glyf");
    stream.pos += this._font.loca.offsets[this.id];
    let glyph = $69aac16029968692$var$GlyfHeader.decode(stream);
    let cbox = new (0, $f34600ab9d7f70d8$export$2e2bcd8739ae039)(glyph.xMin, glyph.yMin, glyph.xMax, glyph.yMax);
    return Object.freeze(cbox);
  }
  // Parses a single glyph coordinate
  _parseGlyphCoord(stream, prev2, short, same) {
    if (short) {
      var val = stream.readUInt8();
      if (!same) val = -val;
      val += prev2;
    } else if (same) var val = prev2;
    else var val = prev2 + stream.readInt16BE();
    return val;
  }
  // Decodes the glyph data into points for simple glyphs,
  // or components for composite glyphs
  _decode() {
    let glyfPos = this._font.loca.offsets[this.id];
    let nextPos = this._font.loca.offsets[this.id + 1];
    if (glyfPos === nextPos) return null;
    let stream = this._font._getTableStream("glyf");
    stream.pos += glyfPos;
    let startPos = stream.pos;
    let glyph = $69aac16029968692$var$GlyfHeader.decode(stream);
    if (glyph.numberOfContours > 0) this._decodeSimple(glyph, stream);
    else if (glyph.numberOfContours < 0) this._decodeComposite(glyph, stream, startPos);
    return glyph;
  }
  _decodeSimple(glyph, stream) {
    glyph.points = [];
    let endPtsOfContours = new ArrayT(uint16, glyph.numberOfContours).decode(stream);
    glyph.instructions = new ArrayT(uint8, uint16).decode(stream);
    let flags = [];
    let numCoords = endPtsOfContours[endPtsOfContours.length - 1] + 1;
    while (flags.length < numCoords) {
      var flag = stream.readUInt8();
      flags.push(flag);
      if (flag & $69aac16029968692$var$REPEAT) {
        let count = stream.readUInt8();
        for (let j = 0; j < count; j++) flags.push(flag);
      }
    }
    for (var i = 0; i < flags.length; i++) {
      var flag = flags[i];
      let point = new $69aac16029968692$export$baf26146a414f24a(!!(flag & $69aac16029968692$var$ON_CURVE), endPtsOfContours.indexOf(i) >= 0, 0, 0);
      glyph.points.push(point);
    }
    let px = 0;
    for (var i = 0; i < flags.length; i++) {
      var flag = flags[i];
      glyph.points[i].x = px = this._parseGlyphCoord(stream, px, flag & $69aac16029968692$var$X_SHORT_VECTOR, flag & $69aac16029968692$var$SAME_X);
    }
    let py = 0;
    for (var i = 0; i < flags.length; i++) {
      var flag = flags[i];
      glyph.points[i].y = py = this._parseGlyphCoord(stream, py, flag & $69aac16029968692$var$Y_SHORT_VECTOR, flag & $69aac16029968692$var$SAME_Y);
    }
    if (this._font._variationProcessor) {
      let points = glyph.points.slice();
      points.push(...this._getPhantomPoints(glyph));
      this._font._variationProcessor.transformPoints(this.id, points);
      glyph.phantomPoints = points.slice(-4);
    }
    return;
  }
  _decodeComposite(glyph, stream, offset4 = 0) {
    glyph.components = [];
    let haveInstructions = false;
    let flags = $69aac16029968692$var$MORE_COMPONENTS;
    while (flags & $69aac16029968692$var$MORE_COMPONENTS) {
      flags = stream.readUInt16BE();
      let gPos = stream.pos - offset4;
      let glyphID = stream.readUInt16BE();
      if (!haveInstructions) haveInstructions = (flags & $69aac16029968692$var$WE_HAVE_INSTRUCTIONS) !== 0;
      if (flags & $69aac16029968692$var$ARG_1_AND_2_ARE_WORDS) {
        var dx = stream.readInt16BE();
        var dy = stream.readInt16BE();
      } else {
        var dx = stream.readInt8();
        var dy = stream.readInt8();
      }
      var component = new $69aac16029968692$var$Component(glyphID, dx, dy);
      component.pos = gPos;
      if (flags & $69aac16029968692$var$WE_HAVE_A_SCALE)
        component.scaleX = component.scaleY = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
      else if (flags & $69aac16029968692$var$WE_HAVE_AN_X_AND_Y_SCALE) {
        component.scaleX = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
        component.scaleY = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
      } else if (flags & $69aac16029968692$var$WE_HAVE_A_TWO_BY_TWO) {
        component.scaleX = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
        component.scale01 = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
        component.scale10 = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
        component.scaleY = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
      }
      glyph.components.push(component);
    }
    if (this._font._variationProcessor) {
      let points = [];
      for (let j = 0; j < glyph.components.length; j++) {
        var component = glyph.components[j];
        points.push(new $69aac16029968692$export$baf26146a414f24a(true, true, component.dx, component.dy));
      }
      points.push(...this._getPhantomPoints(glyph));
      this._font._variationProcessor.transformPoints(this.id, points);
      glyph.phantomPoints = points.splice(-4, 4);
      for (let i = 0; i < points.length; i++) {
        let point = points[i];
        glyph.components[i].dx = point.x;
        glyph.components[i].dy = point.y;
      }
    }
    return haveInstructions;
  }
  _getPhantomPoints(glyph) {
    let cbox = this._getCBox(true);
    if (this._metrics == null) this._metrics = (0, $f92906be28e61769$export$2e2bcd8739ae039).prototype._getMetrics.call(this, cbox);
    let { advanceWidth, advanceHeight, leftBearing, topBearing } = this._metrics;
    return [
      new $69aac16029968692$export$baf26146a414f24a(false, true, glyph.xMin - leftBearing, 0),
      new $69aac16029968692$export$baf26146a414f24a(false, true, glyph.xMin - leftBearing + advanceWidth, 0),
      new $69aac16029968692$export$baf26146a414f24a(false, true, 0, glyph.yMax + topBearing),
      new $69aac16029968692$export$baf26146a414f24a(false, true, 0, glyph.yMax + topBearing + advanceHeight)
    ];
  }
  // Decodes font data, resolves composite glyphs, and returns an array of contours
  _getContours() {
    let glyph = this._decode();
    if (!glyph) return [];
    let points = [];
    if (glyph.numberOfContours < 0)
      for (let component of glyph.components) {
        let contours2 = this._font.getGlyph(component.glyphID)._getContours();
        for (let i = 0; i < contours2.length; i++) {
          let contour = contours2[i];
          for (let j = 0; j < contour.length; j++) {
            let point2 = contour[j];
            let x = point2.x * component.scaleX + point2.y * component.scale01 + component.dx;
            let y = point2.y * component.scaleY + point2.x * component.scale10 + component.dy;
            points.push(new $69aac16029968692$export$baf26146a414f24a(point2.onCurve, point2.endContour, x, y));
          }
        }
      }
    else points = glyph.points || [];
    if (glyph.phantomPoints && !this._font.directory.tables.HVAR) {
      this._metrics.advanceWidth = glyph.phantomPoints[1].x - glyph.phantomPoints[0].x;
      this._metrics.advanceHeight = glyph.phantomPoints[3].y - glyph.phantomPoints[2].y;
      this._metrics.leftBearing = glyph.xMin - glyph.phantomPoints[0].x;
      this._metrics.topBearing = glyph.phantomPoints[2].y - glyph.yMax;
    }
    let contours = [];
    let cur = [];
    for (let k = 0; k < points.length; k++) {
      var point = points[k];
      cur.push(point);
      if (point.endContour) {
        contours.push(cur);
        cur = [];
      }
    }
    return contours;
  }
  _getMetrics() {
    if (this._metrics) return this._metrics;
    let cbox = this._getCBox(true);
    super._getMetrics(cbox);
    if (this._font._variationProcessor && !this._font.HVAR)
      this.path;
    return this._metrics;
  }
  // Converts contours to a Path object that can be rendered
  _getPath() {
    let contours = this._getContours();
    let path2 = new (0, $f43aec954cdfdf21$export$2e2bcd8739ae039)();
    for (let i = 0; i < contours.length; i++) {
      let contour = contours[i];
      let firstPt = contour[0];
      let lastPt = contour[contour.length - 1];
      let start = 0;
      if (firstPt.onCurve) {
        var curvePt = null;
        start = 1;
      } else {
        if (lastPt.onCurve)
          firstPt = lastPt;
        else
          firstPt = new $69aac16029968692$export$baf26146a414f24a(false, false, (firstPt.x + lastPt.x) / 2, (firstPt.y + lastPt.y) / 2);
        var curvePt = firstPt;
      }
      path2.moveTo(firstPt.x, firstPt.y);
      for (let j = start; j < contour.length; j++) {
        let pt = contour[j];
        let prevPt = j === 0 ? firstPt : contour[j - 1];
        if (prevPt.onCurve && pt.onCurve) path2.lineTo(pt.x, pt.y);
        else if (prevPt.onCurve && !pt.onCurve) var curvePt = pt;
        else if (!prevPt.onCurve && !pt.onCurve) {
          let midX = (prevPt.x + pt.x) / 2;
          let midY = (prevPt.y + pt.y) / 2;
          path2.quadraticCurveTo(prevPt.x, prevPt.y, midX, midY);
          var curvePt = pt;
        } else if (!prevPt.onCurve && pt.onCurve) {
          path2.quadraticCurveTo(curvePt.x, curvePt.y, pt.x, pt.y);
          var curvePt = null;
        } else throw new Error("Unknown TTF path state");
      }
      if (curvePt) path2.quadraticCurveTo(curvePt.x, curvePt.y, firstPt.x, firstPt.y);
      path2.closePath();
    }
    return path2;
  }
  constructor(...args) {
    super(...args);
    (0, _define_property)(this, "type", "TTF");
  }
};
var $62cc5109c6101893$export$2e2bcd8739ae039 = class extends (0, $f92906be28e61769$export$2e2bcd8739ae039) {
  _getName() {
    if (this._font.CFF2) return super._getName();
    return this._font["CFF "].getGlyphName(this.id);
  }
  bias(s) {
    if (s.length < 1240) return 107;
    else if (s.length < 33900) return 1131;
    else return 32768;
  }
  _getPath() {
    let cff = this._font.CFF2 || this._font["CFF "];
    let { stream } = cff;
    let str = cff.topDict.CharStrings[this.id];
    let end = str.offset + str.length;
    stream.pos = str.offset;
    let path2 = new (0, $f43aec954cdfdf21$export$2e2bcd8739ae039)();
    let stack = [];
    let trans = [];
    let width = null;
    let nStems = 0;
    let x = 0, y = 0;
    let usedGsubrs;
    let usedSubrs;
    let open2 = false;
    this._usedGsubrs = usedGsubrs = {};
    this._usedSubrs = usedSubrs = {};
    let gsubrs = cff.globalSubrIndex || [];
    let gsubrsBias = this.bias(gsubrs);
    let privateDict = cff.privateDictForGlyph(this.id) || {};
    let subrs = privateDict.Subrs || [];
    let subrsBias = this.bias(subrs);
    let vstore = cff.topDict.vstore && cff.topDict.vstore.itemVariationStore;
    let vsindex = privateDict.vsindex;
    let variationProcessor = this._font._variationProcessor;
    function checkWidth() {
      if (width == null) width = stack.shift() + privateDict.nominalWidthX;
    }
    function parseStems() {
      if (stack.length % 2 !== 0) checkWidth();
      nStems += stack.length >> 1;
      return stack.length = 0;
    }
    function moveTo(x2, y2) {
      if (open2) path2.closePath();
      path2.moveTo(x2, y2);
      open2 = true;
    }
    let parse6 = function() {
      while (stream.pos < end) {
        let op = stream.readUInt8();
        if (op < 32) {
          let index3, subr, phase;
          let c1x, c1y, c2x, c2y, c3x, c3y;
          let c4x, c4y, c5x, c5y, c6x, c6y;
          let pts;
          switch (op) {
            case 1:
            case 3:
            case 18:
            case 23:
              parseStems();
              break;
            case 4:
              if (stack.length > 1) checkWidth();
              y += stack.shift();
              moveTo(x, y);
              break;
            case 5:
              while (stack.length >= 2) {
                x += stack.shift();
                y += stack.shift();
                path2.lineTo(x, y);
              }
              break;
            case 6:
            case 7:
              phase = op === 6;
              while (stack.length >= 1) {
                if (phase) x += stack.shift();
                else y += stack.shift();
                path2.lineTo(x, y);
                phase = !phase;
              }
              break;
            case 8:
              while (stack.length > 0) {
                c1x = x + stack.shift();
                c1y = y + stack.shift();
                c2x = c1x + stack.shift();
                c2y = c1y + stack.shift();
                x = c2x + stack.shift();
                y = c2y + stack.shift();
                path2.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
              }
              break;
            case 10:
              index3 = stack.pop() + subrsBias;
              subr = subrs[index3];
              if (subr) {
                usedSubrs[index3] = true;
                let p = stream.pos;
                let e3 = end;
                stream.pos = subr.offset;
                end = subr.offset + subr.length;
                parse6();
                stream.pos = p;
                end = e3;
              }
              break;
            case 11:
              if (cff.version >= 2) break;
              return;
            case 14:
              if (cff.version >= 2) break;
              if (stack.length > 0) checkWidth();
              if (open2) {
                path2.closePath();
                open2 = false;
              }
              break;
            case 15:
              if (cff.version < 2) throw new Error("vsindex operator not supported in CFF v1");
              vsindex = stack.pop();
              break;
            case 16: {
              if (cff.version < 2) throw new Error("blend operator not supported in CFF v1");
              if (!variationProcessor) throw new Error("blend operator in non-variation font");
              let blendVector = variationProcessor.getBlendVector(vstore, vsindex);
              let numBlends = stack.pop();
              let numOperands = numBlends * blendVector.length;
              let delta = stack.length - numOperands;
              let base = delta - numBlends;
              for (let i = 0; i < numBlends; i++) {
                let sum2 = stack[base + i];
                for (let j = 0; j < blendVector.length; j++) sum2 += blendVector[j] * stack[delta++];
                stack[base + i] = sum2;
              }
              while (numOperands--) stack.pop();
              break;
            }
            case 19:
            case 20:
              parseStems();
              stream.pos += nStems + 7 >> 3;
              break;
            case 21:
              if (stack.length > 2) checkWidth();
              x += stack.shift();
              y += stack.shift();
              moveTo(x, y);
              break;
            case 22:
              if (stack.length > 1) checkWidth();
              x += stack.shift();
              moveTo(x, y);
              break;
            case 24:
              while (stack.length >= 8) {
                c1x = x + stack.shift();
                c1y = y + stack.shift();
                c2x = c1x + stack.shift();
                c2y = c1y + stack.shift();
                x = c2x + stack.shift();
                y = c2y + stack.shift();
                path2.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
              }
              x += stack.shift();
              y += stack.shift();
              path2.lineTo(x, y);
              break;
            case 25:
              while (stack.length >= 8) {
                x += stack.shift();
                y += stack.shift();
                path2.lineTo(x, y);
              }
              c1x = x + stack.shift();
              c1y = y + stack.shift();
              c2x = c1x + stack.shift();
              c2y = c1y + stack.shift();
              x = c2x + stack.shift();
              y = c2y + stack.shift();
              path2.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
              break;
            case 26:
              if (stack.length % 2) x += stack.shift();
              while (stack.length >= 4) {
                c1x = x;
                c1y = y + stack.shift();
                c2x = c1x + stack.shift();
                c2y = c1y + stack.shift();
                x = c2x;
                y = c2y + stack.shift();
                path2.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
              }
              break;
            case 27:
              if (stack.length % 2) y += stack.shift();
              while (stack.length >= 4) {
                c1x = x + stack.shift();
                c1y = y;
                c2x = c1x + stack.shift();
                c2y = c1y + stack.shift();
                x = c2x + stack.shift();
                y = c2y;
                path2.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
              }
              break;
            case 28:
              stack.push(stream.readInt16BE());
              break;
            case 29:
              index3 = stack.pop() + gsubrsBias;
              subr = gsubrs[index3];
              if (subr) {
                usedGsubrs[index3] = true;
                let p = stream.pos;
                let e3 = end;
                stream.pos = subr.offset;
                end = subr.offset + subr.length;
                parse6();
                stream.pos = p;
                end = e3;
              }
              break;
            case 30:
            case 31:
              phase = op === 31;
              while (stack.length >= 4) {
                if (phase) {
                  c1x = x + stack.shift();
                  c1y = y;
                  c2x = c1x + stack.shift();
                  c2y = c1y + stack.shift();
                  y = c2y + stack.shift();
                  x = c2x + (stack.length === 1 ? stack.shift() : 0);
                } else {
                  c1x = x;
                  c1y = y + stack.shift();
                  c2x = c1x + stack.shift();
                  c2y = c1y + stack.shift();
                  x = c2x + stack.shift();
                  y = c2y + (stack.length === 1 ? stack.shift() : 0);
                }
                path2.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
                phase = !phase;
              }
              break;
            case 12:
              op = stream.readUInt8();
              switch (op) {
                case 3:
                  let a = stack.pop();
                  let b = stack.pop();
                  stack.push(a && b ? 1 : 0);
                  break;
                case 4:
                  a = stack.pop();
                  b = stack.pop();
                  stack.push(a || b ? 1 : 0);
                  break;
                case 5:
                  a = stack.pop();
                  stack.push(a ? 0 : 1);
                  break;
                case 9:
                  a = stack.pop();
                  stack.push(Math.abs(a));
                  break;
                case 10:
                  a = stack.pop();
                  b = stack.pop();
                  stack.push(a + b);
                  break;
                case 11:
                  a = stack.pop();
                  b = stack.pop();
                  stack.push(a - b);
                  break;
                case 12:
                  a = stack.pop();
                  b = stack.pop();
                  stack.push(a / b);
                  break;
                case 14:
                  a = stack.pop();
                  stack.push(-a);
                  break;
                case 15:
                  a = stack.pop();
                  b = stack.pop();
                  stack.push(a === b ? 1 : 0);
                  break;
                case 18:
                  stack.pop();
                  break;
                case 20:
                  let val = stack.pop();
                  let idx = stack.pop();
                  trans[idx] = val;
                  break;
                case 21:
                  idx = stack.pop();
                  stack.push(trans[idx] || 0);
                  break;
                case 22:
                  let s1 = stack.pop();
                  let s2 = stack.pop();
                  let v1 = stack.pop();
                  let v2 = stack.pop();
                  stack.push(v1 <= v2 ? s1 : s2);
                  break;
                case 23:
                  stack.push(Math.random());
                  break;
                case 24:
                  a = stack.pop();
                  b = stack.pop();
                  stack.push(a * b);
                  break;
                case 26:
                  a = stack.pop();
                  stack.push(Math.sqrt(a));
                  break;
                case 27:
                  a = stack.pop();
                  stack.push(a, a);
                  break;
                case 28:
                  a = stack.pop();
                  b = stack.pop();
                  stack.push(b, a);
                  break;
                case 29:
                  idx = stack.pop();
                  if (idx < 0) idx = 0;
                  else if (idx > stack.length - 1) idx = stack.length - 1;
                  stack.push(stack[idx]);
                  break;
                case 30:
                  let n2 = stack.pop();
                  let j = stack.pop();
                  if (j >= 0) while (j > 0) {
                    var t2 = stack[n2 - 1];
                    for (let i = n2 - 2; i >= 0; i--) stack[i + 1] = stack[i];
                    stack[0] = t2;
                    j--;
                  }
                  else while (j < 0) {
                    var t2 = stack[0];
                    for (let i = 0; i <= n2; i++) stack[i] = stack[i + 1];
                    stack[n2 - 1] = t2;
                    j++;
                  }
                  break;
                case 34:
                  c1x = x + stack.shift();
                  c1y = y;
                  c2x = c1x + stack.shift();
                  c2y = c1y + stack.shift();
                  c3x = c2x + stack.shift();
                  c3y = c2y;
                  c4x = c3x + stack.shift();
                  c4y = c3y;
                  c5x = c4x + stack.shift();
                  c5y = c4y;
                  c6x = c5x + stack.shift();
                  c6y = c5y;
                  x = c6x;
                  y = c6y;
                  path2.bezierCurveTo(c1x, c1y, c2x, c2y, c3x, c3y);
                  path2.bezierCurveTo(c4x, c4y, c5x, c5y, c6x, c6y);
                  break;
                case 35:
                  pts = [];
                  for (let i = 0; i <= 5; i++) {
                    x += stack.shift();
                    y += stack.shift();
                    pts.push(x, y);
                  }
                  path2.bezierCurveTo(...pts.slice(0, 6));
                  path2.bezierCurveTo(...pts.slice(6));
                  stack.shift();
                  break;
                case 36:
                  c1x = x + stack.shift();
                  c1y = y + stack.shift();
                  c2x = c1x + stack.shift();
                  c2y = c1y + stack.shift();
                  c3x = c2x + stack.shift();
                  c3y = c2y;
                  c4x = c3x + stack.shift();
                  c4y = c3y;
                  c5x = c4x + stack.shift();
                  c5y = c4y + stack.shift();
                  c6x = c5x + stack.shift();
                  c6y = c5y;
                  x = c6x;
                  y = c6y;
                  path2.bezierCurveTo(c1x, c1y, c2x, c2y, c3x, c3y);
                  path2.bezierCurveTo(c4x, c4y, c5x, c5y, c6x, c6y);
                  break;
                case 37:
                  let startx = x;
                  let starty = y;
                  pts = [];
                  for (let i = 0; i <= 4; i++) {
                    x += stack.shift();
                    y += stack.shift();
                    pts.push(x, y);
                  }
                  if (Math.abs(x - startx) > Math.abs(y - starty)) {
                    x += stack.shift();
                    y = starty;
                  } else {
                    x = startx;
                    y += stack.shift();
                  }
                  pts.push(x, y);
                  path2.bezierCurveTo(...pts.slice(0, 6));
                  path2.bezierCurveTo(...pts.slice(6));
                  break;
                default:
                  throw new Error(`Unknown op: 12 ${op}`);
              }
              break;
            default:
              throw new Error(`Unknown op: ${op}`);
          }
        } else if (op < 247) stack.push(op - 139);
        else if (op < 251) {
          var b1 = stream.readUInt8();
          stack.push((op - 247) * 256 + b1 + 108);
        } else if (op < 255) {
          var b1 = stream.readUInt8();
          stack.push(-(op - 251) * 256 - b1 - 108);
        } else stack.push(stream.readInt32BE() / 65536);
      }
    };
    parse6();
    if (open2) path2.closePath();
    return path2;
  }
  constructor(...args) {
    super(...args);
    (0, _define_property)(this, "type", "CFF");
  }
};
var $25d8f049c222084c$var$SBIXImage = new Struct({
  originX: uint16,
  originY: uint16,
  type: new StringT(4),
  data: new BufferT((t2) => t2.parent.buflen - t2._currentOffset)
});
var $25d8f049c222084c$export$2e2bcd8739ae039 = class extends (0, $69aac16029968692$export$2e2bcd8739ae039) {
  /**
  * Returns an object representing a glyph image at the given point size.
  * The object has a data property with a Buffer containing the actual image data,
  * along with the image type, and origin.
  *
  * @param {number} size
  * @return {object}
  */
  getImageForSize(size) {
    for (let i = 0; i < this._font.sbix.imageTables.length; i++) {
      var table = this._font.sbix.imageTables[i];
      if (table.ppem >= size) break;
    }
    let offsets = table.imageOffsets;
    let start = offsets[this.id];
    let end = offsets[this.id + 1];
    if (start === end) return null;
    this._font.stream.pos = start;
    return $25d8f049c222084c$var$SBIXImage.decode(this._font.stream, {
      buflen: end - start
    });
  }
  render(ctx, size) {
    let img = this.getImageForSize(size);
    if (img != null) {
      let scale = size / this._font.unitsPerEm;
      ctx.image(img.data, {
        height: size,
        x: img.originX,
        y: (this.bbox.minY - img.originY) * scale
      });
    }
    if (this._font.sbix.flags.renderOutlines) super.render(ctx, size);
  }
  constructor(...args) {
    super(...args);
    (0, _define_property)(this, "type", "SBIX");
  }
};
var $0d411f0165859681$var$COLRLayer = class {
  constructor(glyph, color) {
    this.glyph = glyph;
    this.color = color;
  }
};
var $0d411f0165859681$export$2e2bcd8739ae039 = class extends (0, $f92906be28e61769$export$2e2bcd8739ae039) {
  _getBBox() {
    let bbox = new (0, $f34600ab9d7f70d8$export$2e2bcd8739ae039)();
    for (let i = 0; i < this.layers.length; i++) {
      let layer = this.layers[i];
      let b = layer.glyph.bbox;
      bbox.addPoint(b.minX, b.minY);
      bbox.addPoint(b.maxX, b.maxY);
    }
    return bbox;
  }
  /**
  * Returns an array of objects containing the glyph and color for
  * each layer in the composite color glyph.
  * @type {object[]}
  */
  get layers() {
    let cpal = this._font.CPAL;
    let colr = this._font.COLR;
    let low = 0;
    let high = colr.baseGlyphRecord.length - 1;
    while (low <= high) {
      let mid = low + high >> 1;
      var rec = colr.baseGlyphRecord[mid];
      if (this.id < rec.gid) high = mid - 1;
      else if (this.id > rec.gid) low = mid + 1;
      else {
        var baseLayer = rec;
        break;
      }
    }
    if (baseLayer == null) {
      var g = this._font._getBaseGlyph(this.id);
      var color = {
        red: 0,
        green: 0,
        blue: 0,
        alpha: 255
      };
      return [
        new $0d411f0165859681$var$COLRLayer(g, color)
      ];
    }
    let layers = [];
    for (let i = baseLayer.firstLayerIndex; i < baseLayer.firstLayerIndex + baseLayer.numLayers; i++) {
      var rec = colr.layerRecords[i];
      var color = cpal.colorRecords[rec.paletteIndex];
      var g = this._font._getBaseGlyph(rec.gid);
      layers.push(new $0d411f0165859681$var$COLRLayer(g, color));
    }
    return layers;
  }
  render(ctx, size) {
    for (let { glyph, color } of this.layers) {
      ctx.fillColor([
        color.red,
        color.green,
        color.blue
      ], color.alpha / 255 * 100);
      glyph.render(ctx, size);
    }
    return;
  }
  constructor(...args) {
    super(...args);
    (0, _define_property)(this, "type", "COLR");
  }
};
var $0bb840cac04e911b$var$TUPLES_SHARE_POINT_NUMBERS = 32768;
var $0bb840cac04e911b$var$TUPLE_COUNT_MASK = 4095;
var $0bb840cac04e911b$var$EMBEDDED_TUPLE_COORD = 32768;
var $0bb840cac04e911b$var$INTERMEDIATE_TUPLE = 16384;
var $0bb840cac04e911b$var$PRIVATE_POINT_NUMBERS = 8192;
var $0bb840cac04e911b$var$TUPLE_INDEX_MASK = 4095;
var $0bb840cac04e911b$var$POINTS_ARE_WORDS = 128;
var $0bb840cac04e911b$var$POINT_RUN_COUNT_MASK = 127;
var $0bb840cac04e911b$var$DELTAS_ARE_ZERO = 128;
var $0bb840cac04e911b$var$DELTAS_ARE_WORDS = 64;
var $0bb840cac04e911b$var$DELTA_RUN_COUNT_MASK = 63;
var $0bb840cac04e911b$export$2e2bcd8739ae039 = class {
  normalizeCoords(coords) {
    let normalized2 = [];
    for (var i = 0; i < this.font.fvar.axis.length; i++) {
      let axis = this.font.fvar.axis[i];
      if (coords[i] < axis.defaultValue) normalized2.push((coords[i] - axis.defaultValue + Number.EPSILON) / (axis.defaultValue - axis.minValue + Number.EPSILON));
      else normalized2.push((coords[i] - axis.defaultValue + Number.EPSILON) / (axis.maxValue - axis.defaultValue + Number.EPSILON));
    }
    if (this.font.avar) for (var i = 0; i < this.font.avar.segment.length; i++) {
      let segment = this.font.avar.segment[i];
      for (let j = 0; j < segment.correspondence.length; j++) {
        let pair = segment.correspondence[j];
        if (j >= 1 && normalized2[i] < pair.fromCoord) {
          let prev2 = segment.correspondence[j - 1];
          normalized2[i] = ((normalized2[i] - prev2.fromCoord) * (pair.toCoord - prev2.toCoord) + Number.EPSILON) / (pair.fromCoord - prev2.fromCoord + Number.EPSILON) + prev2.toCoord;
          break;
        }
      }
    }
    return normalized2;
  }
  transformPoints(gid, glyphPoints) {
    if (!this.font.fvar || !this.font.gvar) return;
    let { gvar } = this.font;
    if (gid >= gvar.glyphCount) return;
    let offset4 = gvar.offsets[gid];
    if (offset4 === gvar.offsets[gid + 1]) return;
    let { stream } = this.font;
    stream.pos = offset4;
    if (stream.pos >= stream.length) return;
    let tupleCount = stream.readUInt16BE();
    let offsetToData = offset4 + stream.readUInt16BE();
    if (tupleCount & $0bb840cac04e911b$var$TUPLES_SHARE_POINT_NUMBERS) {
      var here = stream.pos;
      stream.pos = offsetToData;
      var sharedPoints = this.decodePoints();
      offsetToData = stream.pos;
      stream.pos = here;
    }
    let origPoints = glyphPoints.map((pt) => pt.copy());
    tupleCount &= $0bb840cac04e911b$var$TUPLE_COUNT_MASK;
    for (let i = 0; i < tupleCount; i++) {
      let tupleDataSize = stream.readUInt16BE();
      let tupleIndex = stream.readUInt16BE();
      if (tupleIndex & $0bb840cac04e911b$var$EMBEDDED_TUPLE_COORD) {
        var tupleCoords = [];
        for (let a = 0; a < gvar.axisCount; a++) tupleCoords.push(stream.readInt16BE() / 16384);
      } else {
        if ((tupleIndex & $0bb840cac04e911b$var$TUPLE_INDEX_MASK) >= gvar.globalCoordCount) throw new Error("Invalid gvar table");
        var tupleCoords = gvar.globalCoords[tupleIndex & $0bb840cac04e911b$var$TUPLE_INDEX_MASK];
      }
      if (tupleIndex & $0bb840cac04e911b$var$INTERMEDIATE_TUPLE) {
        var startCoords = [];
        for (let a = 0; a < gvar.axisCount; a++) startCoords.push(stream.readInt16BE() / 16384);
        var endCoords = [];
        for (let a = 0; a < gvar.axisCount; a++) endCoords.push(stream.readInt16BE() / 16384);
      }
      let factor = this.tupleFactor(tupleIndex, tupleCoords, startCoords, endCoords);
      if (factor === 0) {
        offsetToData += tupleDataSize;
        continue;
      }
      var here = stream.pos;
      stream.pos = offsetToData;
      if (tupleIndex & $0bb840cac04e911b$var$PRIVATE_POINT_NUMBERS) var points = this.decodePoints();
      else var points = sharedPoints;
      let nPoints = points.length === 0 ? glyphPoints.length : points.length;
      let xDeltas = this.decodeDeltas(nPoints);
      let yDeltas = this.decodeDeltas(nPoints);
      if (points.length === 0) for (let i2 = 0; i2 < glyphPoints.length; i2++) {
        var point = glyphPoints[i2];
        point.x += Math.round(xDeltas[i2] * factor);
        point.y += Math.round(yDeltas[i2] * factor);
      }
      else {
        let outPoints = origPoints.map((pt) => pt.copy());
        let hasDelta = glyphPoints.map(() => false);
        for (let i2 = 0; i2 < points.length; i2++) {
          let idx = points[i2];
          if (idx < glyphPoints.length) {
            let point2 = outPoints[idx];
            hasDelta[idx] = true;
            point2.x += xDeltas[i2] * factor;
            point2.y += yDeltas[i2] * factor;
          }
        }
        this.interpolateMissingDeltas(outPoints, origPoints, hasDelta);
        for (let i2 = 0; i2 < glyphPoints.length; i2++) {
          let deltaX = outPoints[i2].x - origPoints[i2].x;
          let deltaY = outPoints[i2].y - origPoints[i2].y;
          glyphPoints[i2].x = Math.round(glyphPoints[i2].x + deltaX);
          glyphPoints[i2].y = Math.round(glyphPoints[i2].y + deltaY);
        }
      }
      offsetToData += tupleDataSize;
      stream.pos = here;
    }
  }
  decodePoints() {
    let stream = this.font.stream;
    let count = stream.readUInt8();
    if (count & $0bb840cac04e911b$var$POINTS_ARE_WORDS) count = (count & $0bb840cac04e911b$var$POINT_RUN_COUNT_MASK) << 8 | stream.readUInt8();
    let points = new Uint16Array(count);
    let i = 0;
    let point = 0;
    while (i < count) {
      let run = stream.readUInt8();
      let runCount = (run & $0bb840cac04e911b$var$POINT_RUN_COUNT_MASK) + 1;
      let fn = run & $0bb840cac04e911b$var$POINTS_ARE_WORDS ? stream.readUInt16 : stream.readUInt8;
      for (let j = 0; j < runCount && i < count; j++) {
        point += fn.call(stream);
        points[i++] = point;
      }
    }
    return points;
  }
  decodeDeltas(count) {
    let stream = this.font.stream;
    let i = 0;
    let deltas = new Int16Array(count);
    while (i < count) {
      let run = stream.readUInt8();
      let runCount = (run & $0bb840cac04e911b$var$DELTA_RUN_COUNT_MASK) + 1;
      if (run & $0bb840cac04e911b$var$DELTAS_ARE_ZERO) i += runCount;
      else {
        let fn = run & $0bb840cac04e911b$var$DELTAS_ARE_WORDS ? stream.readInt16BE : stream.readInt8;
        for (let j = 0; j < runCount && i < count; j++) deltas[i++] = fn.call(stream);
      }
    }
    return deltas;
  }
  tupleFactor(tupleIndex, tupleCoords, startCoords, endCoords) {
    let normalized2 = this.normalizedCoords;
    let { gvar } = this.font;
    let factor = 1;
    for (let i = 0; i < gvar.axisCount; i++) {
      if (tupleCoords[i] === 0) continue;
      if (normalized2[i] === 0) return 0;
      if ((tupleIndex & $0bb840cac04e911b$var$INTERMEDIATE_TUPLE) === 0) {
        if (normalized2[i] < Math.min(0, tupleCoords[i]) || normalized2[i] > Math.max(0, tupleCoords[i])) return 0;
        factor = (factor * normalized2[i] + Number.EPSILON) / (tupleCoords[i] + Number.EPSILON);
      } else {
        if (normalized2[i] < startCoords[i] || normalized2[i] > endCoords[i]) return 0;
        else if (normalized2[i] < tupleCoords[i]) factor = factor * (normalized2[i] - startCoords[i] + Number.EPSILON) / (tupleCoords[i] - startCoords[i] + Number.EPSILON);
        else factor = factor * (endCoords[i] - normalized2[i] + Number.EPSILON) / (endCoords[i] - tupleCoords[i] + Number.EPSILON);
      }
    }
    return factor;
  }
  // Interpolates points without delta values.
  // Needed for the Ø and Q glyphs in Skia.
  // Algorithm from Freetype.
  interpolateMissingDeltas(points, inPoints, hasDelta) {
    if (points.length === 0) return;
    let point = 0;
    while (point < points.length) {
      let firstPoint = point;
      let endPoint = point;
      let pt = points[endPoint];
      while (!pt.endContour) pt = points[++endPoint];
      while (point <= endPoint && !hasDelta[point]) point++;
      if (point > endPoint) continue;
      let firstDelta = point;
      let curDelta = point;
      point++;
      while (point <= endPoint) {
        if (hasDelta[point]) {
          this.deltaInterpolate(curDelta + 1, point - 1, curDelta, point, inPoints, points);
          curDelta = point;
        }
        point++;
      }
      if (curDelta === firstDelta) this.deltaShift(firstPoint, endPoint, curDelta, inPoints, points);
      else {
        this.deltaInterpolate(curDelta + 1, endPoint, curDelta, firstDelta, inPoints, points);
        if (firstDelta > 0) this.deltaInterpolate(firstPoint, firstDelta - 1, curDelta, firstDelta, inPoints, points);
      }
      point = endPoint + 1;
    }
  }
  deltaInterpolate(p1, p2, ref1, ref22, inPoints, outPoints) {
    if (p1 > p2) return;
    let iterable = [
      "x",
      "y"
    ];
    for (let i = 0; i < iterable.length; i++) {
      let k = iterable[i];
      if (inPoints[ref1][k] > inPoints[ref22][k]) {
        var p = ref1;
        ref1 = ref22;
        ref22 = p;
      }
      let in1 = inPoints[ref1][k];
      let in2 = inPoints[ref22][k];
      let out1 = outPoints[ref1][k];
      let out2 = outPoints[ref22][k];
      if (in1 !== in2 || out1 === out2) {
        let scale = in1 === in2 ? 0 : (out2 - out1) / (in2 - in1);
        for (let p3 = p1; p3 <= p2; p3++) {
          let out = inPoints[p3][k];
          if (out <= in1) out += out1 - in1;
          else if (out >= in2) out += out2 - in2;
          else out = out1 + (out - in1) * scale;
          outPoints[p3][k] = out;
        }
      }
    }
  }
  deltaShift(p1, p2, ref3, inPoints, outPoints) {
    let deltaX = outPoints[ref3].x - inPoints[ref3].x;
    let deltaY = outPoints[ref3].y - inPoints[ref3].y;
    if (deltaX === 0 && deltaY === 0) return;
    for (let p = p1; p <= p2; p++) if (p !== ref3) {
      outPoints[p].x += deltaX;
      outPoints[p].y += deltaY;
    }
  }
  getAdvanceAdjustment(gid, table) {
    let outerIndex, innerIndex;
    if (table.advanceWidthMapping) {
      let idx = gid;
      if (idx >= table.advanceWidthMapping.mapCount) idx = table.advanceWidthMapping.mapCount - 1;
      let entryFormat = table.advanceWidthMapping.entryFormat;
      ({ outerIndex, innerIndex } = table.advanceWidthMapping.mapData[idx]);
    } else {
      outerIndex = 0;
      innerIndex = gid;
    }
    return this.getDelta(table.itemVariationStore, outerIndex, innerIndex);
  }
  // See pseudo code from `Font Variations Overview'
  // in the OpenType specification.
  getDelta(itemStore, outerIndex, innerIndex) {
    if (outerIndex >= itemStore.itemVariationData.length) return 0;
    let varData = itemStore.itemVariationData[outerIndex];
    if (innerIndex >= varData.deltaSets.length) return 0;
    let deltaSet = varData.deltaSets[innerIndex];
    let blendVector = this.getBlendVector(itemStore, outerIndex);
    let netAdjustment = 0;
    for (let master = 0; master < varData.regionIndexCount; master++) netAdjustment += deltaSet.deltas[master] * blendVector[master];
    return netAdjustment;
  }
  getBlendVector(itemStore, outerIndex) {
    let varData = itemStore.itemVariationData[outerIndex];
    if (this.blendVectors.has(varData)) return this.blendVectors.get(varData);
    let normalizedCoords = this.normalizedCoords;
    let blendVector = [];
    for (let master = 0; master < varData.regionIndexCount; master++) {
      let scalar = 1;
      let regionIndex = varData.regionIndexes[master];
      let axes = itemStore.variationRegionList.variationRegions[regionIndex];
      for (let j = 0; j < axes.length; j++) {
        let axis = axes[j];
        let axisScalar;
        if (axis.startCoord > axis.peakCoord || axis.peakCoord > axis.endCoord) axisScalar = 1;
        else if (axis.startCoord < 0 && axis.endCoord > 0 && axis.peakCoord !== 0) axisScalar = 1;
        else if (axis.peakCoord === 0) axisScalar = 1;
        else if (normalizedCoords[j] < axis.startCoord || normalizedCoords[j] > axis.endCoord) axisScalar = 0;
        else {
          if (normalizedCoords[j] === axis.peakCoord) axisScalar = 1;
          else if (normalizedCoords[j] < axis.peakCoord) axisScalar = (normalizedCoords[j] - axis.startCoord + Number.EPSILON) / (axis.peakCoord - axis.startCoord + Number.EPSILON);
          else axisScalar = (axis.endCoord - normalizedCoords[j] + Number.EPSILON) / (axis.endCoord - axis.peakCoord + Number.EPSILON);
        }
        scalar *= axisScalar;
      }
      blendVector[master] = scalar;
    }
    this.blendVectors.set(varData, blendVector);
    return blendVector;
  }
  constructor(font, coords) {
    this.font = font;
    this.normalizedCoords = this.normalizeCoords(coords);
    this.blendVectors = /* @__PURE__ */ new Map();
  }
};
var $5cc7476da92df375$var$resolved = Promise.resolve();
var $5cc7476da92df375$export$2e2bcd8739ae039 = class {
  includeGlyph(glyph) {
    if (typeof glyph === "object") glyph = glyph.id;
    if (this.mapping[glyph] == null) {
      this.glyphs.push(glyph);
      this.mapping[glyph] = this.glyphs.length - 1;
    }
    return this.mapping[glyph];
  }
  constructor(font) {
    this.font = font;
    this.glyphs = [];
    this.mapping = {};
    this.includeGlyph(0);
  }
};
var $807e58506be70005$var$ON_CURVE = 1;
var $807e58506be70005$var$X_SHORT_VECTOR = 2;
var $807e58506be70005$var$Y_SHORT_VECTOR = 4;
var $807e58506be70005$var$REPEAT = 8;
var $807e58506be70005$var$SAME_X = 16;
var $807e58506be70005$var$SAME_Y = 32;
var $807e58506be70005$var$Point = class {
  static size(val) {
    return val >= 0 && val <= 255 ? 1 : 2;
  }
  static encode(stream, value) {
    if (value >= 0 && value <= 255) stream.writeUInt8(value);
    else stream.writeInt16BE(value);
  }
};
var $807e58506be70005$var$Glyf = new Struct({
  numberOfContours: int16,
  xMin: int16,
  yMin: int16,
  xMax: int16,
  yMax: int16,
  endPtsOfContours: new ArrayT(uint16, "numberOfContours"),
  instructions: new ArrayT(uint8, uint16),
  flags: new ArrayT(uint8, 0),
  xPoints: new ArrayT($807e58506be70005$var$Point, 0),
  yPoints: new ArrayT($807e58506be70005$var$Point, 0)
});
var $807e58506be70005$export$2e2bcd8739ae039 = class {
  encodeSimple(path2, instructions = []) {
    let endPtsOfContours = [];
    let xPoints = [];
    let yPoints = [];
    let flags = [];
    let same = 0;
    let lastX = 0, lastY = 0, lastFlag = 0;
    let pointCount = 0;
    for (let i = 0; i < path2.commands.length; i++) {
      let c = path2.commands[i];
      for (let j = 0; j < c.args.length; j += 2) {
        let x = c.args[j];
        let y = c.args[j + 1];
        let flag = 0;
        if (c.command === "quadraticCurveTo" && j === 2) {
          let next2 = path2.commands[i + 1];
          if (next2 && next2.command === "quadraticCurveTo") {
            let midX = (lastX + next2.args[0]) / 2;
            let midY = (lastY + next2.args[1]) / 2;
            if (x === midX && y === midY) continue;
          }
        }
        if (!(c.command === "quadraticCurveTo" && j === 0)) flag |= $807e58506be70005$var$ON_CURVE;
        flag = this._encodePoint(x, lastX, xPoints, flag, $807e58506be70005$var$X_SHORT_VECTOR, $807e58506be70005$var$SAME_X);
        flag = this._encodePoint(y, lastY, yPoints, flag, $807e58506be70005$var$Y_SHORT_VECTOR, $807e58506be70005$var$SAME_Y);
        if (flag === lastFlag && same < 255) {
          flags[flags.length - 1] |= $807e58506be70005$var$REPEAT;
          same++;
        } else {
          if (same > 0) {
            flags.push(same);
            same = 0;
          }
          flags.push(flag);
          lastFlag = flag;
        }
        lastX = x;
        lastY = y;
        pointCount++;
      }
      if (c.command === "closePath") endPtsOfContours.push(pointCount - 1);
    }
    if (path2.commands.length > 1 && path2.commands[path2.commands.length - 1].command !== "closePath") endPtsOfContours.push(pointCount - 1);
    let bbox = path2.bbox;
    let glyf = {
      numberOfContours: endPtsOfContours.length,
      xMin: bbox.minX,
      yMin: bbox.minY,
      xMax: bbox.maxX,
      yMax: bbox.maxY,
      endPtsOfContours,
      instructions,
      flags,
      xPoints,
      yPoints
    };
    let size = $807e58506be70005$var$Glyf.size(glyf);
    let tail = 4 - size % 4;
    let stream = new EncodeStream(size + tail);
    $807e58506be70005$var$Glyf.encode(stream, glyf);
    if (tail !== 0) stream.fill(0, tail);
    return stream.buffer;
  }
  _encodePoint(value, last2, points, flag, shortFlag, sameFlag) {
    let diff3 = value - last2;
    if (value === last2) flag |= sameFlag;
    else {
      if (-255 <= diff3 && diff3 <= 255) {
        flag |= shortFlag;
        if (diff3 < 0) diff3 = -diff3;
        else flag |= sameFlag;
      }
      points.push(diff3);
    }
    return flag;
  }
};
var $4abbb6a5dbdc441a$export$2e2bcd8739ae039 = class extends (0, $5cc7476da92df375$export$2e2bcd8739ae039) {
  _addGlyph(gid) {
    let glyph = this.font.getGlyph(gid);
    let glyf = glyph._decode();
    let curOffset = this.font.loca.offsets[gid];
    let nextOffset = this.font.loca.offsets[gid + 1];
    let stream = this.font._getTableStream("glyf");
    stream.pos += curOffset;
    let buffer = stream.readBuffer(nextOffset - curOffset);
    if (glyf && glyf.numberOfContours < 0) {
      buffer = new Uint8Array(buffer);
      let view = new DataView(buffer.buffer);
      for (let component of glyf.components) {
        gid = this.includeGlyph(component.glyphID);
        view.setUint16(component.pos, gid);
      }
    } else if (glyf && this.font._variationProcessor)
      buffer = this.glyphEncoder.encodeSimple(glyph.path, glyf.instructions);
    this.glyf.push(buffer);
    this.loca.offsets.push(this.offset);
    this.hmtx.metrics.push({
      advance: glyph.advanceWidth,
      bearing: glyph._getMetrics().leftBearing
    });
    this.offset += buffer.length;
    return this.glyf.length - 1;
  }
  encode() {
    this.glyf = [];
    this.offset = 0;
    this.loca = {
      offsets: [],
      version: this.font.loca.version
    };
    this.hmtx = {
      metrics: [],
      bearings: []
    };
    let i = 0;
    while (i < this.glyphs.length) this._addGlyph(this.glyphs[i++]);
    let maxp = (0, import_clone.default)(this.font.maxp);
    maxp.numGlyphs = this.glyf.length;
    this.loca.offsets.push(this.offset);
    let head = (0, import_clone.default)(this.font.head);
    head.indexToLocFormat = this.loca.version;
    let hhea = (0, import_clone.default)(this.font.hhea);
    hhea.numberOfMetrics = this.hmtx.metrics.length;
    return (0, $816c07a04b6dba87$export$2e2bcd8739ae039).toBuffer({
      tables: {
        head,
        hhea,
        loca: this.loca,
        maxp,
        "cvt ": this.font["cvt "],
        prep: this.font.prep,
        glyf: this.glyf,
        hmtx: this.hmtx,
        fpgm: this.font.fpgm
      }
    });
  }
  constructor(font) {
    super(font);
    this.glyphEncoder = new (0, $807e58506be70005$export$2e2bcd8739ae039)();
  }
};
var $001d739428a71d5a$export$2e2bcd8739ae039 = class extends (0, $5cc7476da92df375$export$2e2bcd8739ae039) {
  subsetCharstrings() {
    this.charstrings = [];
    let gsubrs = {};
    for (let gid of this.glyphs) {
      this.charstrings.push(this.cff.getCharString(gid));
      let glyph = this.font.getGlyph(gid);
      let path2 = glyph.path;
      for (let subr in glyph._usedGsubrs) gsubrs[subr] = true;
    }
    this.gsubrs = this.subsetSubrs(this.cff.globalSubrIndex, gsubrs);
  }
  subsetSubrs(subrs, used) {
    let res = [];
    for (let i = 0; i < subrs.length; i++) {
      let subr = subrs[i];
      if (used[i]) {
        this.cff.stream.pos = subr.offset;
        res.push(this.cff.stream.readBuffer(subr.length));
      } else res.push(new Uint8Array([
        11
      ]));
    }
    return res;
  }
  subsetFontdict(topDict) {
    topDict.FDArray = [];
    topDict.FDSelect = {
      version: 0,
      fds: []
    };
    let used_fds = {};
    let used_subrs = [];
    let fd_select = {};
    for (let gid of this.glyphs) {
      let fd = this.cff.fdForGlyph(gid);
      if (fd == null) continue;
      if (!used_fds[fd]) {
        topDict.FDArray.push(Object.assign({}, this.cff.topDict.FDArray[fd]));
        used_subrs.push({});
        fd_select[fd] = topDict.FDArray.length - 1;
      }
      used_fds[fd] = true;
      topDict.FDSelect.fds.push(fd_select[fd]);
      let glyph = this.font.getGlyph(gid);
      let path2 = glyph.path;
      for (let subr in glyph._usedSubrs) used_subrs[fd_select[fd]][subr] = true;
    }
    for (let i = 0; i < topDict.FDArray.length; i++) {
      let dict = topDict.FDArray[i];
      delete dict.FontName;
      if (dict.Private && dict.Private.Subrs) {
        dict.Private = Object.assign({}, dict.Private);
        dict.Private.Subrs = this.subsetSubrs(dict.Private.Subrs, used_subrs[i]);
      }
    }
    return;
  }
  createCIDFontdict(topDict) {
    let used_subrs = {};
    for (let gid of this.glyphs) {
      let glyph = this.font.getGlyph(gid);
      let path2 = glyph.path;
      for (let subr in glyph._usedSubrs) used_subrs[subr] = true;
    }
    let privateDict = Object.assign({}, this.cff.topDict.Private);
    if (this.cff.topDict.Private && this.cff.topDict.Private.Subrs) privateDict.Subrs = this.subsetSubrs(this.cff.topDict.Private.Subrs, used_subrs);
    topDict.FDArray = [
      {
        Private: privateDict
      }
    ];
    return topDict.FDSelect = {
      version: 3,
      nRanges: 1,
      ranges: [
        {
          first: 0,
          fd: 0
        }
      ],
      sentinel: this.charstrings.length
    };
  }
  addString(string3) {
    if (!string3) return null;
    if (!this.strings) this.strings = [];
    this.strings.push(string3);
    return (0, $229224aec43783c5$export$2e2bcd8739ae039).length + this.strings.length - 1;
  }
  encode() {
    this.subsetCharstrings();
    let charset = {
      version: this.charstrings.length > 255 ? 2 : 1,
      ranges: [
        {
          first: 1,
          nLeft: this.charstrings.length - 2
        }
      ]
    };
    let topDict = Object.assign({}, this.cff.topDict);
    topDict.Private = null;
    topDict.charset = charset;
    topDict.Encoding = null;
    topDict.CharStrings = this.charstrings;
    for (let key2 of [
      "version",
      "Notice",
      "Copyright",
      "FullName",
      "FamilyName",
      "Weight",
      "PostScript",
      "BaseFontName",
      "FontName"
    ]) topDict[key2] = this.addString(this.cff.string(topDict[key2]));
    topDict.ROS = [
      this.addString("Adobe"),
      this.addString("Identity"),
      0
    ];
    topDict.CIDCount = this.charstrings.length;
    if (this.cff.isCIDFont) this.subsetFontdict(topDict);
    else this.createCIDFontdict(topDict);
    let top = {
      version: 1,
      hdrSize: this.cff.hdrSize,
      offSize: 4,
      header: this.cff.header,
      nameIndex: [
        this.cff.postscriptName
      ],
      topDictIndex: [
        topDict
      ],
      stringIndex: this.strings,
      globalSubrIndex: this.gsubrs
    };
    return (0, $b84fd3dd9d8eddb2$export$2e2bcd8739ae039).toBuffer(top);
  }
  constructor(font) {
    super(font);
    this.cff = this.font["CFF "];
    if (!this.cff) throw new Error("Not a CFF Font");
  }
};
var $4c1709dee528ea76$export$2e2bcd8739ae039 = class _$4c1709dee528ea76$export$2e2bcd8739ae039 {
  static probe(buffer) {
    let format3 = (0, $12727730ddfc8bfe$export$3d28c1996ced1f14).decode(buffer.slice(0, 4));
    return format3 === "true" || format3 === "OTTO" || format3 === String.fromCharCode(0, 1, 0, 0);
  }
  setDefaultLanguage(lang = null) {
    this.defaultLanguage = lang;
  }
  _getTable(table) {
    if (!(table.tag in this._tables)) try {
      this._tables[table.tag] = this._decodeTable(table);
    } catch (e3) {
      if ($d636bc798e7178db$export$bd5c5d8b8dcafd78) {
        console.error(`Error decoding table ${table.tag}`);
        console.error(e3.stack);
      }
    }
    return this._tables[table.tag];
  }
  _getTableStream(tag) {
    let table = this.directory.tables[tag];
    if (table) {
      this.stream.pos = table.offset;
      return this.stream;
    }
    return null;
  }
  _decodeDirectory() {
    return this.directory = (0, $816c07a04b6dba87$export$2e2bcd8739ae039).decode(this.stream, {
      _startOffset: 0
    });
  }
  _decodeTable(table) {
    let pos = this.stream.pos;
    let stream = this._getTableStream(table.tag);
    let result = (0, $c3395722bea751e2$export$2e2bcd8739ae039)[table.tag].decode(stream, this, table.length);
    this.stream.pos = pos;
    return result;
  }
  /**
  * Gets a string from the font's `name` table
  * `lang` is a BCP-47 language code.
  * @return {string}
  */
  getName(key2, lang = this.defaultLanguage || $d636bc798e7178db$export$42940898df819940) {
    let record = this.name && this.name.records[key2];
    if (record)
      return record[lang] || record[this.defaultLanguage] || record[$d636bc798e7178db$export$42940898df819940] || record["en"] || record[Object.keys(record)[0]] || null;
    return null;
  }
  /**
  * The unique PostScript name for this font, e.g. "Helvetica-Bold"
  * @type {string}
  */
  get postscriptName() {
    return this.getName("postscriptName");
  }
  /**
  * The font's full name, e.g. "Helvetica Bold"
  * @type {string}
  */
  get fullName() {
    return this.getName("fullName");
  }
  /**
  * The font's family name, e.g. "Helvetica"
  * @type {string}
  */
  get familyName() {
    return this.getName("fontFamily");
  }
  /**
  * The font's sub-family, e.g. "Bold".
  * @type {string}
  */
  get subfamilyName() {
    return this.getName("fontSubfamily");
  }
  /**
  * The font's copyright information
  * @type {string}
  */
  get copyright() {
    return this.getName("copyright");
  }
  /**
  * The font's version number
  * @type {string}
  */
  get version() {
    return this.getName("version");
  }
  /**
  * The font’s [ascender](https://en.wikipedia.org/wiki/Ascender_(typography))
  * @type {number}
  */
  get ascent() {
    return this.hhea.ascent;
  }
  /**
  * The font’s [descender](https://en.wikipedia.org/wiki/Descender)
  * @type {number}
  */
  get descent() {
    return this.hhea.descent;
  }
  /**
  * The amount of space that should be included between lines
  * @type {number}
  */
  get lineGap() {
    return this.hhea.lineGap;
  }
  /**
  * The offset from the normal underline position that should be used
  * @type {number}
  */
  get underlinePosition() {
    return this.post.underlinePosition;
  }
  /**
  * The weight of the underline that should be used
  * @type {number}
  */
  get underlineThickness() {
    return this.post.underlineThickness;
  }
  /**
  * If this is an italic font, the angle the cursor should be drawn at to match the font design
  * @type {number}
  */
  get italicAngle() {
    return this.post.italicAngle;
  }
  /**
  * The height of capital letters above the baseline.
  * See [here](https://en.wikipedia.org/wiki/Cap_height) for more details.
  * @type {number}
  */
  get capHeight() {
    let os2 = this["OS/2"];
    return os2 ? os2.capHeight : this.ascent;
  }
  /**
  * The height of lower case letters in the font.
  * See [here](https://en.wikipedia.org/wiki/X-height) for more details.
  * @type {number}
  */
  get xHeight() {
    let os2 = this["OS/2"];
    return os2 ? os2.xHeight : 0;
  }
  /**
  * The number of glyphs in the font.
  * @type {number}
  */
  get numGlyphs() {
    return this.maxp.numGlyphs;
  }
  /**
  * The size of the font’s internal coordinate grid
  * @type {number}
  */
  get unitsPerEm() {
    return this.head.unitsPerEm;
  }
  /**
  * The font’s bounding box, i.e. the box that encloses all glyphs in the font.
  * @type {BBox}
  */
  get bbox() {
    return Object.freeze(new (0, $f34600ab9d7f70d8$export$2e2bcd8739ae039)(this.head.xMin, this.head.yMin, this.head.xMax, this.head.yMax));
  }
  get _cmapProcessor() {
    return new (0, $f08dd41ef10b694c$export$2e2bcd8739ae039)(this.cmap);
  }
  /**
  * An array of all of the unicode code points supported by the font.
  * @type {number[]}
  */
  get characterSet() {
    return this._cmapProcessor.getCharacterSet();
  }
  /**
  * Returns whether there is glyph in the font for the given unicode code point.
  *
  * @param {number} codePoint
  * @return {boolean}
  */
  hasGlyphForCodePoint(codePoint) {
    return !!this._cmapProcessor.lookup(codePoint);
  }
  /**
  * Maps a single unicode code point to a Glyph object.
  * Does not perform any advanced substitutions (there is no context to do so).
  *
  * @param {number} codePoint
  * @return {Glyph}
  */
  glyphForCodePoint(codePoint) {
    return this.getGlyph(this._cmapProcessor.lookup(codePoint), [
      codePoint
    ]);
  }
  /**
  * Returns an array of Glyph objects for the given string.
  * This is only a one-to-one mapping from characters to glyphs.
  * For most uses, you should use font.layout (described below), which
  * provides a much more advanced mapping supporting AAT and OpenType shaping.
  *
  * @param {string} string
  * @return {Glyph[]}
  */
  glyphsForString(string3) {
    let glyphs = [];
    let len = string3.length;
    let idx = 0;
    let last2 = -1;
    let state = -1;
    while (idx <= len) {
      let code2 = 0;
      let nextState = 0;
      if (idx < len) {
        code2 = string3.charCodeAt(idx++);
        if (55296 <= code2 && code2 <= 56319 && idx < len) {
          let next2 = string3.charCodeAt(idx);
          if (56320 <= next2 && next2 <= 57343) {
            idx++;
            code2 = ((code2 & 1023) << 10) + (next2 & 1023) + 65536;
          }
        }
        nextState = 65024 <= code2 && code2 <= 65039 || 917760 <= code2 && code2 <= 917999 ? 1 : 0;
      } else idx++;
      if (state === 0 && nextState === 1)
        glyphs.push(this.getGlyph(this._cmapProcessor.lookup(last2, code2), [
          last2,
          code2
        ]));
      else if (state === 0 && nextState === 0)
        glyphs.push(this.glyphForCodePoint(last2));
      last2 = code2;
      state = nextState;
    }
    return glyphs;
  }
  get _layoutEngine() {
    return new (0, $4c0a7fa5df7a9ab1$export$2e2bcd8739ae039)(this);
  }
  /**
  * Returns a GlyphRun object, which includes an array of Glyphs and GlyphPositions for the given string.
  *
  * @param {string} string
  * @param {string[]} [userFeatures]
  * @param {string} [script]
  * @param {string} [language]
  * @param {string} [direction]
  * @return {GlyphRun}
  */
  layout(string3, userFeatures, script, language, direction) {
    return this._layoutEngine.layout(string3, userFeatures, script, language, direction);
  }
  /**
  * Returns an array of strings that map to the given glyph id.
  * @param {number} gid - glyph id
  */
  stringsForGlyph(gid) {
    return this._layoutEngine.stringsForGlyph(gid);
  }
  /**
  * An array of all [OpenType feature tags](https://www.microsoft.com/typography/otspec/featuretags.htm)
  * (or mapped AAT tags) supported by the font.
  * The features parameter is an array of OpenType feature tags to be applied in addition to the default set.
  * If this is an AAT font, the OpenType feature tags are mapped to AAT features.
  *
  * @type {string[]}
  */
  get availableFeatures() {
    return this._layoutEngine.getAvailableFeatures();
  }
  getAvailableFeatures(script, language) {
    return this._layoutEngine.getAvailableFeatures(script, language);
  }
  _getBaseGlyph(glyph, characters2 = []) {
    if (!this._glyphs[glyph]) {
      if (this.directory.tables.glyf) this._glyphs[glyph] = new (0, $69aac16029968692$export$2e2bcd8739ae039)(glyph, characters2, this);
      else if (this.directory.tables["CFF "] || this.directory.tables.CFF2) this._glyphs[glyph] = new (0, $62cc5109c6101893$export$2e2bcd8739ae039)(glyph, characters2, this);
    }
    return this._glyphs[glyph] || null;
  }
  /**
  * Returns a glyph object for the given glyph id.
  * You can pass the array of code points this glyph represents for
  * your use later, and it will be stored in the glyph object.
  *
  * @param {number} glyph
  * @param {number[]} characters
  * @return {Glyph}
  */
  getGlyph(glyph, characters2 = []) {
    if (!this._glyphs[glyph]) {
      if (this.directory.tables.sbix) this._glyphs[glyph] = new (0, $25d8f049c222084c$export$2e2bcd8739ae039)(glyph, characters2, this);
      else if (this.directory.tables.COLR && this.directory.tables.CPAL) this._glyphs[glyph] = new (0, $0d411f0165859681$export$2e2bcd8739ae039)(glyph, characters2, this);
      else this._getBaseGlyph(glyph, characters2);
    }
    return this._glyphs[glyph] || null;
  }
  /**
  * Returns a Subset for this font.
  * @return {Subset}
  */
  createSubset() {
    if (this.directory.tables["CFF "]) return new (0, $001d739428a71d5a$export$2e2bcd8739ae039)(this);
    return new (0, $4abbb6a5dbdc441a$export$2e2bcd8739ae039)(this);
  }
  /**
  * Returns an object describing the available variation axes
  * that this font supports. Keys are setting tags, and values
  * contain the axis name, range, and default value.
  *
  * @type {object}
  */
  get variationAxes() {
    let res = {};
    if (!this.fvar) return res;
    for (let axis of this.fvar.axis) res[axis.axisTag.trim()] = {
      name: axis.name.en,
      min: axis.minValue,
      default: axis.defaultValue,
      max: axis.maxValue
    };
    return res;
  }
  /**
  * Returns an object describing the named variation instances
  * that the font designer has specified. Keys are variation names
  * and values are the variation settings for this instance.
  *
  * @type {object}
  */
  get namedVariations() {
    let res = {};
    if (!this.fvar) return res;
    for (let instance of this.fvar.instance) {
      let settings = {};
      for (let i = 0; i < this.fvar.axis.length; i++) {
        let axis = this.fvar.axis[i];
        settings[axis.axisTag.trim()] = instance.coord[i];
      }
      res[instance.name.en] = settings;
    }
    return res;
  }
  /**
  * Returns a new font with the given variation settings applied.
  * Settings can either be an instance name, or an object containing
  * variation tags as specified by the `variationAxes` property.
  *
  * @param {object} settings
  * @return {TTFFont}
  */
  getVariation(settings) {
    if (!(this.directory.tables.fvar && (this.directory.tables.gvar && this.directory.tables.glyf || this.directory.tables.CFF2))) throw new Error("Variations require a font with the fvar, gvar and glyf, or CFF2 tables.");
    if (typeof settings === "string") settings = this.namedVariations[settings];
    if (typeof settings !== "object") throw new Error("Variation settings must be either a variation name or settings object.");
    let coords = this.fvar.axis.map((axis, i) => {
      let axisTag = axis.axisTag.trim();
      if (axisTag in settings) return Math.max(axis.minValue, Math.min(axis.maxValue, settings[axisTag]));
      else return axis.defaultValue;
    });
    let stream = new DecodeStream(this.stream.buffer);
    stream.pos = this._directoryPos;
    let font = new _$4c1709dee528ea76$export$2e2bcd8739ae039(stream, coords);
    font._tables = this._tables;
    return font;
  }
  get _variationProcessor() {
    if (!this.fvar) return null;
    let variationCoords = this.variationCoords;
    if (!variationCoords && !this.CFF2) return null;
    if (!variationCoords) variationCoords = this.fvar.axis.map((axis) => axis.defaultValue);
    return new (0, $0bb840cac04e911b$export$2e2bcd8739ae039)(this, variationCoords);
  }
  // Standardized format plugin API
  getFont(name) {
    return this.getVariation(name);
  }
  constructor(stream, variationCoords = null) {
    (0, _define_property)(this, "type", "TTF");
    this.defaultLanguage = null;
    this.stream = stream;
    this.variationCoords = variationCoords;
    this._directoryPos = this.stream.pos;
    this._tables = {};
    this._glyphs = {};
    this._decodeDirectory();
    for (let tag in this.directory.tables) {
      let table = this.directory.tables[tag];
      if ((0, $c3395722bea751e2$export$2e2bcd8739ae039)[tag] && table.length > 0) Object.defineProperty(this, tag, {
        get: this._getTable.bind(this, table)
      });
    }
  }
};
(0, __decorate)([
  (0, $e71565f2ce09cb6b$export$69a3209f1a06c04d)
], $4c1709dee528ea76$export$2e2bcd8739ae039.prototype, "bbox", null);
(0, __decorate)([
  (0, $e71565f2ce09cb6b$export$69a3209f1a06c04d)
], $4c1709dee528ea76$export$2e2bcd8739ae039.prototype, "_cmapProcessor", null);
(0, __decorate)([
  (0, $e71565f2ce09cb6b$export$69a3209f1a06c04d)
], $4c1709dee528ea76$export$2e2bcd8739ae039.prototype, "characterSet", null);
(0, __decorate)([
  (0, $e71565f2ce09cb6b$export$69a3209f1a06c04d)
], $4c1709dee528ea76$export$2e2bcd8739ae039.prototype, "_layoutEngine", null);
(0, __decorate)([
  (0, $e71565f2ce09cb6b$export$69a3209f1a06c04d)
], $4c1709dee528ea76$export$2e2bcd8739ae039.prototype, "variationAxes", null);
(0, __decorate)([
  (0, $e71565f2ce09cb6b$export$69a3209f1a06c04d)
], $4c1709dee528ea76$export$2e2bcd8739ae039.prototype, "namedVariations", null);
(0, __decorate)([
  (0, $e71565f2ce09cb6b$export$69a3209f1a06c04d)
], $4c1709dee528ea76$export$2e2bcd8739ae039.prototype, "_variationProcessor", null);
var $c1726355ecc5b889$var$WOFFDirectoryEntry = new Struct({
  tag: new StringT(4),
  offset: new Pointer(uint32, "void", {
    type: "global"
  }),
  compLength: uint32,
  length: uint32,
  origChecksum: uint32
});
var $c1726355ecc5b889$var$WOFFDirectory = new Struct({
  tag: new StringT(4),
  flavor: uint32,
  length: uint32,
  numTables: uint16,
  reserved: new Reserved(uint16),
  totalSfntSize: uint32,
  majorVersion: uint16,
  minorVersion: uint16,
  metaOffset: uint32,
  metaLength: uint32,
  metaOrigLength: uint32,
  privOffset: uint32,
  privLength: uint32,
  tables: new ArrayT($c1726355ecc5b889$var$WOFFDirectoryEntry, "numTables")
});
$c1726355ecc5b889$var$WOFFDirectory.process = function() {
  let tables = {};
  for (let table of this.tables) tables[table.tag] = table;
  this.tables = tables;
};
var $c1726355ecc5b889$export$2e2bcd8739ae039 = $c1726355ecc5b889$var$WOFFDirectory;
var $760785214b9fc52c$export$2e2bcd8739ae039 = class extends (0, $4c1709dee528ea76$export$2e2bcd8739ae039) {
  static probe(buffer) {
    return (0, $12727730ddfc8bfe$export$3d28c1996ced1f14).decode(buffer.slice(0, 4)) === "wOFF";
  }
  _decodeDirectory() {
    this.directory = (0, $c1726355ecc5b889$export$2e2bcd8739ae039).decode(this.stream, {
      _startOffset: 0
    });
  }
  _getTableStream(tag) {
    let table = this.directory.tables[tag];
    if (table) {
      this.stream.pos = table.offset;
      if (table.compLength < table.length) {
        this.stream.pos += 2;
        let outBuffer = new Uint8Array(table.length);
        let buf = (0, import_tiny_inflate.default)(this.stream.readBuffer(table.compLength - 2), outBuffer);
        return new DecodeStream(buf);
      } else return this.stream;
    }
    return null;
  }
  constructor(...args) {
    super(...args);
    (0, _define_property)(this, "type", "WOFF");
  }
};
var $8046190c9f1ad19e$export$2e2bcd8739ae039 = class extends (0, $69aac16029968692$export$2e2bcd8739ae039) {
  _decode() {
    return this._font._transformedGlyphs[this.id];
  }
  _getCBox() {
    return this.path.bbox;
  }
  constructor(...args) {
    super(...args);
    (0, _define_property)(this, "type", "WOFF2");
  }
};
var $c28ec7bbb3b8de3a$var$Base128 = {
  decode(stream) {
    let result = 0;
    let iterable = [
      0,
      1,
      2,
      3,
      4
    ];
    for (let j = 0; j < iterable.length; j++) {
      let i = iterable[j];
      let code2 = stream.readUInt8();
      if (result & 3758096384) throw new Error("Overflow");
      result = result << 7 | code2 & 127;
      if ((code2 & 128) === 0) return result;
    }
    throw new Error("Bad base 128 number");
  }
};
var $c28ec7bbb3b8de3a$var$knownTags = [
  "cmap",
  "head",
  "hhea",
  "hmtx",
  "maxp",
  "name",
  "OS/2",
  "post",
  "cvt ",
  "fpgm",
  "glyf",
  "loca",
  "prep",
  "CFF ",
  "VORG",
  "EBDT",
  "EBLC",
  "gasp",
  "hdmx",
  "kern",
  "LTSH",
  "PCLT",
  "VDMX",
  "vhea",
  "vmtx",
  "BASE",
  "GDEF",
  "GPOS",
  "GSUB",
  "EBSC",
  "JSTF",
  "MATH",
  "CBDT",
  "CBLC",
  "COLR",
  "CPAL",
  "SVG ",
  "sbix",
  "acnt",
  "avar",
  "bdat",
  "bloc",
  "bsln",
  "cvar",
  "fdsc",
  "feat",
  "fmtx",
  "fvar",
  "gvar",
  "hsty",
  "just",
  "lcar",
  "mort",
  "morx",
  "opbd",
  "prop",
  "trak",
  "Zapf",
  "Silf",
  "Glat",
  "Gloc",
  "Feat",
  "Sill"
];
var $c28ec7bbb3b8de3a$var$WOFF2DirectoryEntry = new Struct({
  flags: uint8,
  customTag: new Optional(new StringT(4), (t2) => (t2.flags & 63) === 63),
  tag: (t2) => t2.customTag || $c28ec7bbb3b8de3a$var$knownTags[t2.flags & 63],
  length: $c28ec7bbb3b8de3a$var$Base128,
  transformVersion: (t2) => t2.flags >>> 6 & 3,
  transformed: (t2) => t2.tag === "glyf" || t2.tag === "loca" ? t2.transformVersion === 0 : t2.transformVersion !== 0,
  transformLength: new Optional($c28ec7bbb3b8de3a$var$Base128, (t2) => t2.transformed)
});
var $c28ec7bbb3b8de3a$var$WOFF2Directory = new Struct({
  tag: new StringT(4),
  flavor: uint32,
  length: uint32,
  numTables: uint16,
  reserved: new Reserved(uint16),
  totalSfntSize: uint32,
  totalCompressedSize: uint32,
  majorVersion: uint16,
  minorVersion: uint16,
  metaOffset: uint32,
  metaLength: uint32,
  metaOrigLength: uint32,
  privOffset: uint32,
  privLength: uint32,
  tables: new ArrayT($c28ec7bbb3b8de3a$var$WOFF2DirectoryEntry, "numTables")
});
$c28ec7bbb3b8de3a$var$WOFF2Directory.process = function() {
  let tables = {};
  for (let i = 0; i < this.tables.length; i++) {
    let table = this.tables[i];
    tables[table.tag] = table;
  }
  return this.tables = tables;
};
var $c28ec7bbb3b8de3a$export$2e2bcd8739ae039 = $c28ec7bbb3b8de3a$var$WOFF2Directory;
var $21ee218f84ac7f32$export$2e2bcd8739ae039 = class extends (0, $4c1709dee528ea76$export$2e2bcd8739ae039) {
  static probe(buffer) {
    return (0, $12727730ddfc8bfe$export$3d28c1996ced1f14).decode(buffer.slice(0, 4)) === "wOF2";
  }
  _decodeDirectory() {
    this.directory = (0, $c28ec7bbb3b8de3a$export$2e2bcd8739ae039).decode(this.stream);
    this._dataPos = this.stream.pos;
  }
  _decompress() {
    if (!this._decompressed) {
      this.stream.pos = this._dataPos;
      let buffer = this.stream.readBuffer(this.directory.totalCompressedSize);
      let decompressedSize = 0;
      for (let tag in this.directory.tables) {
        let entry = this.directory.tables[tag];
        entry.offset = decompressedSize;
        decompressedSize += entry.transformLength != null ? entry.transformLength : entry.length;
      }
      let decompressed = (0, import_decompress.default)(buffer, decompressedSize);
      if (!decompressed) throw new Error("Error decoding compressed data in WOFF2");
      this.stream = new DecodeStream(decompressed);
      this._decompressed = true;
    }
  }
  _decodeTable(table) {
    this._decompress();
    return super._decodeTable(table);
  }
  // Override this method to get a glyph and return our
  // custom subclass if there is a glyf table.
  _getBaseGlyph(glyph, characters2 = []) {
    if (!this._glyphs[glyph]) {
      if (this.directory.tables.glyf && this.directory.tables.glyf.transformed) {
        if (!this._transformedGlyphs) this._transformGlyfTable();
        return this._glyphs[glyph] = new (0, $8046190c9f1ad19e$export$2e2bcd8739ae039)(glyph, characters2, this);
      } else return super._getBaseGlyph(glyph, characters2);
    }
  }
  _transformGlyfTable() {
    this._decompress();
    this.stream.pos = this.directory.tables.glyf.offset;
    let table = $21ee218f84ac7f32$var$GlyfTable.decode(this.stream);
    let glyphs = [];
    for (let index3 = 0; index3 < table.numGlyphs; index3++) {
      let glyph = {};
      let nContours = table.nContours.readInt16BE();
      glyph.numberOfContours = nContours;
      if (nContours > 0) {
        let nPoints = [];
        let totalPoints = 0;
        for (let i = 0; i < nContours; i++) {
          let r2 = $21ee218f84ac7f32$var$read255UInt16(table.nPoints);
          totalPoints += r2;
          nPoints.push(totalPoints);
        }
        glyph.points = $21ee218f84ac7f32$var$decodeTriplet(table.flags, table.glyphs, totalPoints);
        for (let i = 0; i < nContours; i++) glyph.points[nPoints[i] - 1].endContour = true;
        var instructionSize = $21ee218f84ac7f32$var$read255UInt16(table.glyphs);
      } else if (nContours < 0) {
        let haveInstructions = (0, $69aac16029968692$export$2e2bcd8739ae039).prototype._decodeComposite.call({
          _font: this
        }, glyph, table.composites);
        if (haveInstructions) var instructionSize = $21ee218f84ac7f32$var$read255UInt16(table.glyphs);
      }
      glyphs.push(glyph);
    }
    this._transformedGlyphs = glyphs;
  }
  constructor(...args) {
    super(...args);
    (0, _define_property)(this, "type", "WOFF2");
  }
};
var $21ee218f84ac7f32$var$Substream = class {
  decode(stream, parent2) {
    return new DecodeStream(this._buf.decode(stream, parent2));
  }
  constructor(length2) {
    this.length = length2;
    this._buf = new BufferT(length2);
  }
};
var $21ee218f84ac7f32$var$GlyfTable = new Struct({
  version: uint32,
  numGlyphs: uint16,
  indexFormat: uint16,
  nContourStreamSize: uint32,
  nPointsStreamSize: uint32,
  flagStreamSize: uint32,
  glyphStreamSize: uint32,
  compositeStreamSize: uint32,
  bboxStreamSize: uint32,
  instructionStreamSize: uint32,
  nContours: new $21ee218f84ac7f32$var$Substream("nContourStreamSize"),
  nPoints: new $21ee218f84ac7f32$var$Substream("nPointsStreamSize"),
  flags: new $21ee218f84ac7f32$var$Substream("flagStreamSize"),
  glyphs: new $21ee218f84ac7f32$var$Substream("glyphStreamSize"),
  composites: new $21ee218f84ac7f32$var$Substream("compositeStreamSize"),
  bboxes: new $21ee218f84ac7f32$var$Substream("bboxStreamSize"),
  instructions: new $21ee218f84ac7f32$var$Substream("instructionStreamSize")
});
var $21ee218f84ac7f32$var$WORD_CODE = 253;
var $21ee218f84ac7f32$var$ONE_MORE_BYTE_CODE2 = 254;
var $21ee218f84ac7f32$var$ONE_MORE_BYTE_CODE1 = 255;
var $21ee218f84ac7f32$var$LOWEST_U_CODE = 253;
function $21ee218f84ac7f32$var$read255UInt16(stream) {
  let code2 = stream.readUInt8();
  if (code2 === $21ee218f84ac7f32$var$WORD_CODE) return stream.readUInt16BE();
  if (code2 === $21ee218f84ac7f32$var$ONE_MORE_BYTE_CODE1) return stream.readUInt8() + $21ee218f84ac7f32$var$LOWEST_U_CODE;
  if (code2 === $21ee218f84ac7f32$var$ONE_MORE_BYTE_CODE2) return stream.readUInt8() + $21ee218f84ac7f32$var$LOWEST_U_CODE * 2;
  return code2;
}
function $21ee218f84ac7f32$var$withSign(flag, baseval) {
  return flag & 1 ? baseval : -baseval;
}
function $21ee218f84ac7f32$var$decodeTriplet(flags, glyphs, nPoints) {
  let y;
  let x = y = 0;
  let res = [];
  for (let i = 0; i < nPoints; i++) {
    let dx = 0, dy = 0;
    let flag = flags.readUInt8();
    let onCurve = !(flag >> 7);
    flag &= 127;
    if (flag < 10) {
      dx = 0;
      dy = $21ee218f84ac7f32$var$withSign(flag, ((flag & 14) << 7) + glyphs.readUInt8());
    } else if (flag < 20) {
      dx = $21ee218f84ac7f32$var$withSign(flag, ((flag - 10 & 14) << 7) + glyphs.readUInt8());
      dy = 0;
    } else if (flag < 84) {
      var b0 = flag - 20;
      var b1 = glyphs.readUInt8();
      dx = $21ee218f84ac7f32$var$withSign(flag, 1 + (b0 & 48) + (b1 >> 4));
      dy = $21ee218f84ac7f32$var$withSign(flag >> 1, 1 + ((b0 & 12) << 2) + (b1 & 15));
    } else if (flag < 120) {
      var b0 = flag - 84;
      dx = $21ee218f84ac7f32$var$withSign(flag, 1 + (b0 / 12 << 8) + glyphs.readUInt8());
      dy = $21ee218f84ac7f32$var$withSign(flag >> 1, 1 + (b0 % 12 >> 2 << 8) + glyphs.readUInt8());
    } else if (flag < 124) {
      var b1 = glyphs.readUInt8();
      let b2 = glyphs.readUInt8();
      dx = $21ee218f84ac7f32$var$withSign(flag, (b1 << 4) + (b2 >> 4));
      dy = $21ee218f84ac7f32$var$withSign(flag >> 1, ((b2 & 15) << 8) + glyphs.readUInt8());
    } else {
      dx = $21ee218f84ac7f32$var$withSign(flag, glyphs.readUInt16BE());
      dy = $21ee218f84ac7f32$var$withSign(flag >> 1, glyphs.readUInt16BE());
    }
    x += dx;
    y += dy;
    res.push(new (0, $69aac16029968692$export$baf26146a414f24a)(onCurve, false, x, y));
  }
  return res;
}
var $cd5853a56c68fec7$var$TTCHeader = new VersionedStruct(uint32, {
  65536: {
    numFonts: uint32,
    offsets: new ArrayT(uint32, "numFonts")
  },
  131072: {
    numFonts: uint32,
    offsets: new ArrayT(uint32, "numFonts"),
    dsigTag: uint32,
    dsigLength: uint32,
    dsigOffset: uint32
  }
});
var $cd5853a56c68fec7$export$2e2bcd8739ae039 = class {
  static probe(buffer) {
    return (0, $12727730ddfc8bfe$export$3d28c1996ced1f14).decode(buffer.slice(0, 4)) === "ttcf";
  }
  getFont(name) {
    for (let offset4 of this.header.offsets) {
      let stream = new DecodeStream(this.stream.buffer);
      stream.pos = offset4;
      let font = new (0, $4c1709dee528ea76$export$2e2bcd8739ae039)(stream);
      if (font.postscriptName === name || font.postscriptName instanceof Uint8Array && name instanceof Uint8Array && font.postscriptName.every((v, i) => name[i] === v)) return font;
    }
    return null;
  }
  get fonts() {
    let fonts = [];
    for (let offset4 of this.header.offsets) {
      let stream = new DecodeStream(this.stream.buffer);
      stream.pos = offset4;
      fonts.push(new (0, $4c1709dee528ea76$export$2e2bcd8739ae039)(stream));
    }
    return fonts;
  }
  constructor(stream) {
    (0, _define_property)(this, "type", "TTC");
    this.stream = stream;
    if (stream.readString(4) !== "ttcf") throw new Error("Not a TrueType collection");
    this.header = $cd5853a56c68fec7$var$TTCHeader.decode(stream);
  }
};
var $05f49f930186144e$var$DFontName = new StringT(uint8);
var $05f49f930186144e$var$DFontData = new Struct({
  len: uint32,
  buf: new BufferT("len")
});
var $05f49f930186144e$var$Ref = new Struct({
  id: uint16,
  nameOffset: int16,
  attr: uint8,
  dataOffset: uint24,
  handle: uint32
});
var $05f49f930186144e$var$Type = new Struct({
  name: new StringT(4),
  maxTypeIndex: uint16,
  refList: new Pointer(uint16, new ArrayT($05f49f930186144e$var$Ref, (t2) => t2.maxTypeIndex + 1), {
    type: "parent"
  })
});
var $05f49f930186144e$var$TypeList = new Struct({
  length: uint16,
  types: new ArrayT($05f49f930186144e$var$Type, (t2) => t2.length + 1)
});
var $05f49f930186144e$var$DFontMap = new Struct({
  reserved: new Reserved(uint8, 24),
  typeList: new Pointer(uint16, $05f49f930186144e$var$TypeList),
  nameListOffset: new Pointer(uint16, "void")
});
var $05f49f930186144e$var$DFontHeader = new Struct({
  dataOffset: uint32,
  map: new Pointer(uint32, $05f49f930186144e$var$DFontMap),
  dataLength: uint32,
  mapLength: uint32
});
var $05f49f930186144e$export$2e2bcd8739ae039 = class {
  static probe(buffer) {
    let stream = new DecodeStream(buffer);
    try {
      var header = $05f49f930186144e$var$DFontHeader.decode(stream);
    } catch (e3) {
      return false;
    }
    for (let type5 of header.map.typeList.types) {
      if (type5.name === "sfnt") return true;
    }
    return false;
  }
  getFont(name) {
    if (!this.sfnt) return null;
    for (let ref3 of this.sfnt.refList) {
      let pos = this.header.dataOffset + ref3.dataOffset + 4;
      let stream = new DecodeStream(this.stream.buffer.slice(pos));
      let font = new (0, $4c1709dee528ea76$export$2e2bcd8739ae039)(stream);
      if (font.postscriptName === name || font.postscriptName instanceof Uint8Array && name instanceof Uint8Array && font.postscriptName.every((v, i) => name[i] === v)) return font;
    }
    return null;
  }
  get fonts() {
    let fonts = [];
    for (let ref3 of this.sfnt.refList) {
      let pos = this.header.dataOffset + ref3.dataOffset + 4;
      let stream = new DecodeStream(this.stream.buffer.slice(pos));
      fonts.push(new (0, $4c1709dee528ea76$export$2e2bcd8739ae039)(stream));
    }
    return fonts;
  }
  constructor(stream) {
    (0, _define_property)(this, "type", "DFont");
    this.stream = stream;
    this.header = $05f49f930186144e$var$DFontHeader.decode(this.stream);
    for (let type5 of this.header.map.typeList.types) {
      for (let ref3 of type5.refList) if (ref3.nameOffset >= 0) {
        this.stream.pos = ref3.nameOffset + this.header.map.nameListOffset;
        ref3.name = $05f49f930186144e$var$DFontName.decode(this.stream);
      } else ref3.name = null;
      if (type5.name === "sfnt") this.sfnt = type5;
    }
  }
};
(0, $d636bc798e7178db$export$36b2f24e97d43be)((0, $4c1709dee528ea76$export$2e2bcd8739ae039));
(0, $d636bc798e7178db$export$36b2f24e97d43be)((0, $760785214b9fc52c$export$2e2bcd8739ae039));
(0, $d636bc798e7178db$export$36b2f24e97d43be)((0, $21ee218f84ac7f32$export$2e2bcd8739ae039));
(0, $d636bc798e7178db$export$36b2f24e97d43be)((0, $cd5853a56c68fec7$export$2e2bcd8739ae039));
(0, $d636bc798e7178db$export$36b2f24e97d43be)((0, $05f49f930186144e$export$2e2bcd8739ae039));

// ../schemas/dist/esm/src/text/helper.js
var import_buffer2 = __toESM(require_buffer());
var getBrowserVerticalFontAdjustments = (fontKitFont, fontSize, lineHeight, verticalAlignment) => {
  const { ascent, descent, unitsPerEm } = fontKitFont;
  const fontBaseLineHeight = (ascent - descent) / unitsPerEm;
  const topAdjustment = (fontBaseLineHeight * fontSize - fontSize) / 2;
  if (verticalAlignment === VERTICAL_ALIGN_TOP) {
    return { topAdj: pt2px(topAdjustment), bottomAdj: 0 };
  }
  let bottomAdjustment = 0;
  if (lineHeight < fontBaseLineHeight) {
    bottomAdjustment = (fontBaseLineHeight - lineHeight) * fontSize / 2;
  }
  return { topAdj: 0, bottomAdj: pt2px(bottomAdjustment) };
};
var getFontDescentInPt = (fontKitFont, fontSize) => {
  const { descent, unitsPerEm } = fontKitFont;
  return descent / unitsPerEm * fontSize;
};
var heightOfFontAtSize = (fontKitFont, fontSize) => {
  const { ascent, descent, bbox, unitsPerEm } = fontKitFont;
  const scale = 1e3 / unitsPerEm;
  const yTop = (ascent || bbox.maxY) * scale;
  const yBottom = (descent || bbox.minY) * scale;
  let height = yTop - yBottom;
  height -= Math.abs(descent * scale) || 0;
  return height / 1e3 * fontSize;
};
var calculateCharacterSpacing = (textContent, textCharacterSpacing) => {
  return (textContent.length - 1) * textCharacterSpacing;
};
var widthOfTextAtSize = (text, fontKitFont, fontSize, characterSpacing) => {
  const { glyphs } = fontKitFont.layout(text);
  const scale = 1e3 / fontKitFont.unitsPerEm;
  const standardWidth = glyphs.reduce((totalWidth, glyph) => totalWidth + glyph.advanceWidth * scale, 0) * (fontSize / 1e3);
  return standardWidth + calculateCharacterSpacing(text, characterSpacing);
};
var getFallbackFont = (font) => {
  const fallbackFontName = getFallbackFontName(font);
  return font[fallbackFontName];
};
var getCacheKey = (fontName) => `getFontKitFont-${fontName}`;
var getFontKitFont = async (fontName, font, _cache2) => {
  const fntNm = fontName || getFallbackFontName(font);
  const cacheKey = getCacheKey(fntNm);
  if (_cache2.has(cacheKey)) {
    return _cache2.get(cacheKey);
  }
  const currentFont = font[fntNm] || getFallbackFont(font) || getDefaultFont()[DEFAULT_FONT_NAME];
  let fontData = currentFont.data;
  if (typeof fontData === "string") {
    fontData = fontData.startsWith("http") ? await fetch(fontData).then((res) => res.arrayBuffer()) : b64toUint8Array(fontData);
  }
  let fontDataBuffer;
  if (fontData instanceof import_buffer2.Buffer) {
    fontDataBuffer = fontData;
  } else {
    fontDataBuffer = import_buffer2.Buffer.from(fontData);
  }
  const fontKitFont = $d636bc798e7178db$export$185802fd694ee1f5(fontDataBuffer);
  _cache2.set(cacheKey, fontKitFont);
  return fontKitFont;
};
var calculateDynamicFontSize = ({ textSchema: textSchema2, fontKitFont, value, startingFontSize }) => {
  const { fontSize: schemaFontSize, dynamicFontSize: dynamicFontSizeSetting, characterSpacing: schemaCharacterSpacing, width: boxWidth, height: boxHeight, lineHeight = DEFAULT_LINE_HEIGHT } = textSchema2;
  const fontSize = startingFontSize || schemaFontSize || DEFAULT_FONT_SIZE;
  if (!dynamicFontSizeSetting)
    return fontSize;
  if (dynamicFontSizeSetting.max < dynamicFontSizeSetting.min)
    return fontSize;
  const characterSpacing = schemaCharacterSpacing ?? DEFAULT_CHARACTER_SPACING;
  const paragraphs = value.split("\n");
  let dynamicFontSize = fontSize;
  if (dynamicFontSize < dynamicFontSizeSetting.min) {
    dynamicFontSize = dynamicFontSizeSetting.min;
  } else if (dynamicFontSize > dynamicFontSizeSetting.max) {
    dynamicFontSize = dynamicFontSizeSetting.max;
  }
  const dynamicFontFit = dynamicFontSizeSetting.fit ?? DEFAULT_DYNAMIC_FIT;
  const calculateConstraints = (size) => {
    let totalWidthInMm2 = 0;
    let totalHeightInMm2 = 0;
    const boxWidthInPt = mm2pt(boxWidth);
    const firstLineTextHeight = heightOfFontAtSize(fontKitFont, size);
    const firstLineHeightInMm = pt2mm(firstLineTextHeight * lineHeight);
    const otherRowHeightInMm = pt2mm(size * lineHeight);
    paragraphs.forEach((paragraph, paraIndex) => {
      const lines = getSplittedLinesBySegmenter(paragraph, {
        font: fontKitFont,
        fontSize: size,
        characterSpacing,
        boxWidthInPt
      });
      lines.forEach((line2, lineIndex) => {
        if (dynamicFontFit === DYNAMIC_FIT_VERTICAL) {
          const textWidth = widthOfTextAtSize(line2.replace("\n", ""), fontKitFont, size, characterSpacing);
          const textWidthInMm = pt2mm(textWidth);
          totalWidthInMm2 = Math.max(totalWidthInMm2, textWidthInMm);
        }
        if (paraIndex + lineIndex === 0) {
          totalHeightInMm2 += firstLineHeightInMm;
        } else {
          totalHeightInMm2 += otherRowHeightInMm;
        }
      });
      if (dynamicFontFit === DYNAMIC_FIT_HORIZONTAL) {
        const textWidth = widthOfTextAtSize(paragraph, fontKitFont, size, characterSpacing);
        const textWidthInMm = pt2mm(textWidth);
        totalWidthInMm2 = Math.max(totalWidthInMm2, textWidthInMm);
      }
    });
    return { totalWidthInMm: totalWidthInMm2, totalHeightInMm: totalHeightInMm2 };
  };
  const shouldFontGrowToFit = (totalWidthInMm2, totalHeightInMm2) => {
    if (dynamicFontSize >= dynamicFontSizeSetting.max) {
      return false;
    }
    if (dynamicFontFit === DYNAMIC_FIT_HORIZONTAL) {
      return totalWidthInMm2 < boxWidth;
    }
    return totalHeightInMm2 < boxHeight;
  };
  const shouldFontShrinkToFit = (totalWidthInMm2, totalHeightInMm2) => {
    if (dynamicFontSize <= dynamicFontSizeSetting.min || dynamicFontSize <= 0) {
      return false;
    }
    return totalWidthInMm2 > boxWidth || totalHeightInMm2 > boxHeight;
  };
  let { totalWidthInMm, totalHeightInMm } = calculateConstraints(dynamicFontSize);
  while (shouldFontGrowToFit(totalWidthInMm, totalHeightInMm)) {
    dynamicFontSize += FONT_SIZE_ADJUSTMENT;
    const { totalWidthInMm: newWidth, totalHeightInMm: newHeight } = calculateConstraints(dynamicFontSize);
    if (newHeight < boxHeight) {
      totalWidthInMm = newWidth;
      totalHeightInMm = newHeight;
    } else {
      dynamicFontSize -= FONT_SIZE_ADJUSTMENT;
      break;
    }
  }
  while (shouldFontShrinkToFit(totalWidthInMm, totalHeightInMm)) {
    dynamicFontSize -= FONT_SIZE_ADJUSTMENT;
    ({ totalWidthInMm, totalHeightInMm } = calculateConstraints(dynamicFontSize));
  }
  return dynamicFontSize;
};
var splitTextToSize = (arg) => {
  const { value, characterSpacing, fontSize, fontKitFont, boxWidthInPt } = arg;
  const fontWidthCalcValues = {
    font: fontKitFont,
    fontSize,
    characterSpacing,
    boxWidthInPt
  };
  let lines = [];
  value.split(/\r\n|\r|\n|\f|\u000B/g).forEach((line2) => {
    lines = lines.concat(getSplittedLinesBySegmenter(line2, fontWidthCalcValues));
  });
  return lines;
};
var isFirefox = () => navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
var getSplittedLinesBySegmenter = (line2, calcValues) => {
  if (line2.trim() === "") {
    return [""];
  }
  const { font, fontSize, characterSpacing, boxWidthInPt } = calcValues;
  const segmenter = new Intl.Segmenter(void 0, { granularity: "word" });
  const iterator = segmenter.segment(line2.trimEnd())[Symbol.iterator]();
  let lines = [];
  let lineCounter = 0;
  let currentTextSize = 0;
  while (true) {
    const chunk = iterator.next();
    if (chunk.done)
      break;
    const segment = chunk.value.segment;
    const textWidth = widthOfTextAtSize(segment, font, fontSize, characterSpacing);
    if (currentTextSize + textWidth <= boxWidthInPt) {
      if (lines[lineCounter]) {
        lines[lineCounter] += segment;
        currentTextSize += textWidth + characterSpacing;
      } else {
        lines[lineCounter] = segment;
        currentTextSize = textWidth + characterSpacing;
      }
    } else if (segment.trim() === "") {
      lines[++lineCounter] = "";
      currentTextSize = 0;
    } else if (textWidth <= boxWidthInPt) {
      lines[++lineCounter] = segment;
      currentTextSize = textWidth + characterSpacing;
    } else {
      for (const char2 of segment) {
        const size = widthOfTextAtSize(char2, font, fontSize, characterSpacing);
        if (currentTextSize + size <= boxWidthInPt) {
          if (lines[lineCounter]) {
            lines[lineCounter] += char2;
            currentTextSize += size + characterSpacing;
          } else {
            lines[lineCounter] = char2;
            currentTextSize = size + characterSpacing;
          }
        } else {
          lines[++lineCounter] = char2;
          currentTextSize = size + characterSpacing;
        }
      }
    }
  }
  if (lines.some(containsJapanese)) {
    return adjustEndOfLine(filterEndJP(filterStartJP(lines)));
  } else {
    return adjustEndOfLine(lines);
  }
};
var adjustEndOfLine = (lines) => {
  return lines.map((line2, index3) => {
    if (index3 === lines.length - 1) {
      return line2.trimEnd() + "\n";
    } else {
      return line2.trimEnd();
    }
  });
};
function containsJapanese(text) {
  return /[\p{Script=Hiragana}\p{Script=Katakana}\p{Script=Han}]/u.test(text);
}
var filterStartJP = (lines) => {
  const filtered = [];
  let charToAppend = null;
  lines.slice().reverse().forEach((line2) => {
    if (line2.trim().length === 0) {
      filtered.push("");
    } else {
      const charAtStart = line2.charAt(0);
      if (LINE_START_FORBIDDEN_CHARS.includes(charAtStart)) {
        if (line2.trim().length === 1) {
          filtered.push(line2);
          charToAppend = null;
        } else {
          if (charToAppend) {
            filtered.push(line2.slice(1) + charToAppend);
          } else {
            filtered.push(line2.slice(1));
          }
          charToAppend = charAtStart;
        }
      } else {
        if (charToAppend) {
          filtered.push(line2 + charToAppend);
          charToAppend = null;
        } else {
          filtered.push(line2);
        }
      }
    }
  });
  if (charToAppend) {
    const firstItem = filtered.length > 0 ? filtered[0] : "";
    const combinedItem = String(charToAppend) + String(firstItem);
    return [combinedItem, ...filtered.slice(1)].reverse();
  } else {
    return filtered.reverse();
  }
};
var filterEndJP = (lines) => {
  const filtered = [];
  let charToPrepend = null;
  lines.forEach((line2) => {
    if (line2.trim().length === 0) {
      filtered.push("");
    } else {
      const chartAtEnd = line2.slice(-1);
      if (LINE_END_FORBIDDEN_CHARS.includes(chartAtEnd)) {
        if (line2.trim().length === 1) {
          filtered.push(line2);
          charToPrepend = null;
        } else {
          if (charToPrepend) {
            filtered.push(charToPrepend + line2.slice(0, -1));
          } else {
            filtered.push(line2.slice(0, -1));
          }
          charToPrepend = chartAtEnd;
        }
      } else {
        if (charToPrepend) {
          filtered.push(charToPrepend + line2);
          charToPrepend = null;
        } else {
          filtered.push(line2);
        }
      }
    }
  });
  if (charToPrepend) {
    const lastItem = filtered.length > 0 ? filtered[filtered.length - 1] : "";
    const combinedItem = String(lastItem) + String(charToPrepend);
    return [...filtered.slice(0, -1), combinedItem];
  } else {
    return filtered;
  }
};

// ../schemas/dist/esm/src/tables/classes.js
var Cell = class {
  constructor(raw, styles, section) {
    Object.defineProperty(this, "raw", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "text", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "styles", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "section", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "contentHeight", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    Object.defineProperty(this, "contentWidth", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    Object.defineProperty(this, "wrappedWidth", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    Object.defineProperty(this, "minReadableWidth", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    Object.defineProperty(this, "minWidth", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    Object.defineProperty(this, "width", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    Object.defineProperty(this, "height", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    Object.defineProperty(this, "x", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    Object.defineProperty(this, "y", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    this.styles = styles;
    this.section = section;
    this.raw = raw;
    const splitRegex = /\r\n|\r|\n/g;
    this.text = raw.split(splitRegex);
  }
  getContentHeight() {
    const lineCount = Array.isArray(this.text) ? this.text.length : 1;
    const lineHeight = pt2mm(this.styles.fontSize) * this.styles.lineHeight;
    const vPadding = this.padding("top") + this.padding("bottom");
    const height = lineCount * lineHeight + vPadding;
    return Math.max(height, this.styles.minCellHeight);
  }
  padding(name) {
    return this.styles.cellPadding[name];
  }
};
var Column = class {
  constructor(index3) {
    Object.defineProperty(this, "index", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "wrappedWidth", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    Object.defineProperty(this, "minReadableWidth", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    Object.defineProperty(this, "minWidth", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    Object.defineProperty(this, "width", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    this.index = index3;
  }
  getMaxCustomCellWidth(table) {
    let max = 0;
    for (const row of table.allRows()) {
      const cell = row.cells[this.index];
      max = Math.max(max, cell.styles.cellWidth);
    }
    return max;
  }
};
var Row = class {
  constructor(raw, index3, section, cells) {
    Object.defineProperty(this, "raw", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "index", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "section", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "cells", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "height", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    this.raw = raw;
    this.index = index3;
    this.section = section;
    this.cells = cells;
  }
  getMaxCellHeight(columns) {
    return columns.reduce((acc, column2) => Math.max(acc, this.cells[column2.index]?.height || 0), 0);
  }
  getMinimumRowHeight(columns) {
    return columns.reduce((acc, column2) => {
      const cell = this.cells[column2.index];
      if (!cell)
        return 0;
      const vPadding = cell.padding("top") + cell.padding("bottom");
      const oneRowHeight = vPadding + cell.styles.lineHeight;
      return oneRowHeight > acc ? oneRowHeight : acc;
    }, 0);
  }
};
var Table = class _Table {
  constructor(input, content) {
    Object.defineProperty(this, "settings", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "styles", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "columns", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "head", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "body", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    this.settings = input.settings;
    this.styles = input.styles;
    this.columns = content.columns;
    this.head = content.head;
    this.body = content.body;
  }
  static async create(arg) {
    const { input, content, font, _cache: _cache2 } = arg;
    const table = new _Table(input, content);
    await calculateWidths({ table, font, _cache: _cache2 });
    return table;
  }
  getHeadHeight() {
    return this.head.reduce((acc, row) => acc + row.getMaxCellHeight(this.columns), 0);
  }
  getBodyHeight() {
    return this.body.reduce((acc, row) => acc + row.getMaxCellHeight(this.columns), 0);
  }
  allRows() {
    return this.head.concat(this.body);
  }
  getWidth() {
    return this.settings.tableWidth;
  }
  getHeight() {
    return (this.settings.showHead ? this.getHeadHeight() : 0) + this.getBodyHeight();
  }
};
async function calculateWidths(arg) {
  const { table, font, _cache: _cache2 } = arg;
  const getFontKitFontByFontName = (fontName) => getFontKitFont(fontName, font, _cache2);
  await calculate(table, getFontKitFontByFontName);
  const resizableColumns = [];
  let initialTableWidth = 0;
  table.columns.forEach((column2) => {
    const customWidth = column2.getMaxCustomCellWidth(table);
    if (customWidth) {
      column2.width = customWidth;
    } else {
      column2.width = column2.wrappedWidth;
      resizableColumns.push(column2);
    }
    initialTableWidth += column2.width;
  });
  let resizeWidth = table.getWidth() - initialTableWidth;
  if (resizeWidth) {
    resizeWidth = resizeColumns(resizableColumns, resizeWidth, (column2) => Math.max(column2.minReadableWidth, column2.minWidth));
  }
  if (resizeWidth) {
    resizeWidth = resizeColumns(resizableColumns, resizeWidth, (column2) => column2.minWidth);
  }
  resizeWidth = Math.abs(resizeWidth);
  applyColSpans(table);
  await fitContent(table, getFontKitFontByFontName);
  applyRowSpans(table);
}
function applyRowSpans(table) {
  const rowSpanCells = {};
  let colRowSpansLeft = 1;
  const all = table.allRows();
  for (let rowIndex = 0; rowIndex < all.length; rowIndex++) {
    const row = all[rowIndex];
    for (const column2 of table.columns) {
      const data2 = rowSpanCells[column2.index];
      if (colRowSpansLeft > 1) {
        colRowSpansLeft--;
        delete row.cells[column2.index];
      } else if (data2) {
        data2.cell.height += row.height;
        colRowSpansLeft = 1;
        delete row.cells[column2.index];
        data2.left--;
        if (data2.left <= 1) {
          delete rowSpanCells[column2.index];
        }
      } else {
        const cell = row.cells[column2.index];
        if (!cell) {
          continue;
        }
        cell.height = row.height;
      }
    }
  }
}
function applyColSpans(table) {
  const all = table.allRows();
  for (let rowIndex = 0; rowIndex < all.length; rowIndex++) {
    const row = all[rowIndex];
    let colSpanCell = null;
    let combinedColSpanWidth = 0;
    let colSpansLeft = 0;
    for (let columnIndex = 0; columnIndex < table.columns.length; columnIndex++) {
      const column2 = table.columns[columnIndex];
      colSpansLeft -= 1;
      if (colSpansLeft > 1 && table.columns[columnIndex + 1]) {
        combinedColSpanWidth += column2.width;
        delete row.cells[column2.index];
      } else if (colSpanCell) {
        const cell = colSpanCell;
        delete row.cells[column2.index];
        colSpanCell = null;
        cell.width = column2.width + combinedColSpanWidth;
      } else {
        const cell = row.cells[column2.index];
        if (!cell)
          continue;
        colSpansLeft = 1;
        combinedColSpanWidth = 0;
        cell.width = column2.width + combinedColSpanWidth;
      }
    }
  }
}
async function fitContent(table, getFontKitFontByFontName) {
  const rowSpanHeight = { count: 0, height: 0 };
  for (const row of table.allRows()) {
    for (const column2 of table.columns) {
      const cell = row.cells[column2.index];
      if (!cell)
        continue;
      const fontKitFont = await getFontKitFontByFontName(cell.styles.fontName);
      cell.text = splitTextToSize({
        value: cell.raw,
        characterSpacing: cell.styles.characterSpacing,
        boxWidthInPt: mm2pt(cell.width),
        fontSize: cell.styles.fontSize,
        fontKitFont
      });
      cell.contentHeight = cell.getContentHeight();
      let realContentHeight = cell.contentHeight;
      if (rowSpanHeight && rowSpanHeight.count > 0) {
        if (rowSpanHeight.height > realContentHeight) {
          realContentHeight = rowSpanHeight.height;
        }
      }
      if (realContentHeight > row.height) {
        row.height = realContentHeight;
      }
    }
    rowSpanHeight.count--;
  }
}
function resizeColumns(columns, resizeWidth, getMinWidth) {
  const initialResizeWidth = resizeWidth;
  const sumWrappedWidth = columns.reduce((acc, column2) => acc + column2.wrappedWidth, 0);
  for (let i = 0; i < columns.length; i++) {
    const column2 = columns[i];
    const ratio = column2.wrappedWidth / sumWrappedWidth;
    const suggestedChange = initialResizeWidth * ratio;
    const suggestedWidth = column2.width + suggestedChange;
    const minWidth = getMinWidth(column2);
    const newWidth = suggestedWidth < minWidth ? minWidth : suggestedWidth;
    resizeWidth -= newWidth - column2.width;
    column2.width = newWidth;
  }
  resizeWidth = Math.round(resizeWidth * 1e10) / 1e10;
  if (resizeWidth) {
    const resizableColumns = columns.filter((column2) => {
      return resizeWidth < 0 ? column2.width > getMinWidth(column2) : true;
    });
    if (resizableColumns.length) {
      resizeWidth = resizeColumns(resizableColumns, resizeWidth, getMinWidth);
    }
  }
  return resizeWidth;
}
async function calculate(table, getFontKitFontByFontName) {
  for (const row of table.allRows()) {
    for (const column2 of table.columns) {
      const cell = row.cells[column2.index];
      if (!cell)
        continue;
      const hPadding = cell.padding("right") + cell.padding("left");
      const fontKitFont = await getFontKitFontByFontName(cell.styles.fontName);
      cell.contentWidth = getStringWidth(cell, fontKitFont) + hPadding;
      const longestWordWidth = getStringWidth(Object.assign(cell, { text: cell.text.join(" ").split(/\s+/) }), fontKitFont);
      cell.minReadableWidth = longestWordWidth + hPadding;
      cell.minWidth = cell.styles.cellWidth;
      cell.wrappedWidth = cell.styles.cellWidth;
    }
  }
  for (const row of table.allRows()) {
    for (const column2 of table.columns) {
      const cell = row.cells[column2.index];
      if (cell) {
        column2.wrappedWidth = Math.max(column2.wrappedWidth, cell.wrappedWidth);
        column2.minWidth = Math.max(column2.minWidth, cell.minWidth);
        column2.minReadableWidth = Math.max(column2.minReadableWidth, cell.minReadableWidth);
      } else {
        const columnStyles = table.styles.columnStyles[column2.index] || {};
        const cellWidth = columnStyles.cellWidth || columnStyles.minCellWidth;
        if (cellWidth) {
          column2.minWidth = cellWidth;
          column2.wrappedWidth = cellWidth;
        }
      }
    }
  }
}
function getStringWidth(cell, fontKitFont) {
  const text = cell.text;
  const textArr = Array.isArray(text) ? text : [text];
  const fontSize = cell.styles.fontSize;
  const characterSpacing = cell.styles.characterSpacing;
  const widestLineWidth = textArr.map((text2) => widthOfTextAtSize(text2, fontKitFont, fontSize, characterSpacing)).reduce((a, b) => Math.max(a, b), 0);
  return widestLineWidth;
}

// ../schemas/dist/esm/src/tables/tableHelper.js
function parseSection(sectionName, sectionRows, columns, styleProps, fallbackFontName) {
  const rowSpansLeftForColumn = {};
  const result = sectionRows.map((rawRow, rowIndex) => {
    let skippedRowForRowSpans = 0;
    const cells = {};
    let colSpansAdded = 0;
    let columnSpansLeft = 0;
    for (const column2 of columns) {
      if (rowSpansLeftForColumn[column2.index] == null || rowSpansLeftForColumn[column2.index].left === 0) {
        if (columnSpansLeft === 0) {
          let rawCell;
          if (Array.isArray(rawRow)) {
            rawCell = rawRow[column2.index - colSpansAdded - skippedRowForRowSpans];
          } else {
            rawCell = rawRow[column2.index];
          }
          const styles = cellStyles(sectionName, column2, rowIndex, styleProps, fallbackFontName);
          const cell = new Cell(rawCell, styles, sectionName);
          cells[column2.index] = cell;
          columnSpansLeft = 0;
          rowSpansLeftForColumn[column2.index] = {
            left: 0,
            times: columnSpansLeft
          };
        } else {
          columnSpansLeft--;
          colSpansAdded++;
        }
      } else {
        rowSpansLeftForColumn[column2.index].left--;
        columnSpansLeft = rowSpansLeftForColumn[column2.index].times;
        skippedRowForRowSpans++;
      }
    }
    return new Row(rawRow, rowIndex, sectionName, cells);
  });
  return result;
}
function parseContent4Table(input, fallbackFontName) {
  const content = input.content;
  const columns = content.columns.map((index3) => new Column(index3));
  const styles = input.styles;
  return {
    columns,
    head: parseSection("head", content.head, columns, styles, fallbackFontName),
    body: parseSection("body", content.body, columns, styles, fallbackFontName)
  };
}
function cellStyles(sectionName, column2, rowIndex, styles, fallbackFontName) {
  let sectionStyles;
  if (sectionName === "head") {
    sectionStyles = styles.headStyles;
  } else if (sectionName === "body") {
    sectionStyles = styles.bodyStyles;
  }
  const otherStyles = Object.assign({}, styles.styles, sectionStyles);
  const colStyles = styles.columnStyles[column2.index] || styles.columnStyles[column2.index] || {};
  const rowStyles = sectionName === "body" && rowIndex % 2 === 0 ? Object.assign({}, styles.alternateRowStyles) : {};
  const defaultStyle = {
    fontName: fallbackFontName,
    backgroundColor: "",
    textColor: "#000000",
    lineHeight: 1,
    characterSpacing: 0,
    alignment: "left",
    verticalAlignment: "middle",
    fontSize: 10,
    cellPadding: 5,
    lineColor: "#000000",
    lineWidth: 0,
    minCellHeight: 0,
    minCellWidth: 0
  };
  return Object.assign(defaultStyle, otherStyles, rowStyles, colStyles);
}
function mapCellStyle(style2) {
  return {
    fontName: style2.fontName,
    alignment: style2.alignment,
    verticalAlignment: style2.verticalAlignment,
    fontSize: style2.fontSize,
    lineHeight: style2.lineHeight,
    characterSpacing: style2.characterSpacing,
    backgroundColor: style2.backgroundColor,
    // ---
    textColor: style2.fontColor,
    lineColor: style2.borderColor,
    lineWidth: style2.borderWidth,
    cellPadding: style2.padding
  };
}
function getTableOptions(schema, body) {
  const columnStylesWidth = schema.headWidthPercentages.reduce((acc, cur, i) => ({ ...acc, [i]: { cellWidth: schema.width * (cur / 100) } }), {});
  const columnStylesAlignment = Object.entries(schema.columnStyles.alignment || {}).reduce((acc, [key2, value]) => ({ ...acc, [key2]: { alignment: value } }), {});
  const allKeys = /* @__PURE__ */ new Set([
    ...Object.keys(columnStylesWidth).map(Number),
    ...Object.keys(columnStylesAlignment).map(Number)
  ]);
  const columnStyles = Array.from(allKeys).reduce((acc, key2) => {
    const widthStyle = columnStylesWidth[key2] || {};
    const alignmentStyle = columnStylesAlignment[key2] || {};
    return { ...acc, [key2]: { ...widthStyle, ...alignmentStyle } };
  }, {});
  return {
    head: [schema.head],
    body,
    showHead: schema.showHead,
    startY: schema.position.y,
    tableWidth: schema.width,
    tableLineColor: schema.tableStyles.borderColor,
    tableLineWidth: schema.tableStyles.borderWidth,
    headStyles: mapCellStyle(schema.headStyles),
    bodyStyles: mapCellStyle(schema.bodyStyles),
    alternateRowStyles: { backgroundColor: schema.bodyStyles.alternateBackgroundColor },
    columnStyles,
    margin: { top: 0, right: 0, left: schema.position.x, bottom: 0 }
  };
}
function parseStyles(cInput) {
  const styleOptions = {
    styles: {},
    headStyles: {},
    bodyStyles: {},
    alternateRowStyles: {},
    columnStyles: {}
  };
  for (const prop of Object.keys(styleOptions)) {
    if (prop === "columnStyles") {
      const current2 = cInput[prop];
      styleOptions.columnStyles = Object.assign({}, current2);
    } else {
      const allOptions = [cInput];
      const styles = allOptions.map((opts) => opts[prop] || {});
      styleOptions[prop] = Object.assign({}, styles[0], styles[1], styles[2]);
    }
  }
  return styleOptions;
}
function parseContent4Input(options) {
  const head = options.head || [];
  const body = options.body || [];
  const columns = (head[0] || body[0] || []).map((_, index3) => index3);
  return { columns, head, body };
}
function parseInput(schema, body) {
  const options = getTableOptions(schema, body);
  const styles = parseStyles(options);
  const settings = {
    startY: options.startY,
    margin: options.margin,
    tableWidth: options.tableWidth,
    showHead: options.showHead,
    tableLineWidth: options.tableLineWidth ?? 0,
    tableLineColor: options.tableLineColor ?? ""
  };
  const content = parseContent4Input(options);
  return { content, styles, settings };
}
function createSingleTable(body, args) {
  const { options, _cache: _cache2, basePdf } = args;
  if (!isBlankPdf(basePdf)) {
    console.warn("[@pdfme/schema/table]When specifying a custom PDF for basePdf, you cannot use features such as page breaks or re-layout of other elements.To utilize these features, please define basePdf as follows:\n{ width: number; height: number; padding: [number, number, number, number]; }");
  }
  const schema = cloneDeep(args.schema);
  const { start } = schema.__bodyRange || { start: 0 };
  if (start % 2 === 1) {
    const alternateBackgroundColor = schema.bodyStyles.alternateBackgroundColor;
    schema.bodyStyles.alternateBackgroundColor = schema.bodyStyles.backgroundColor;
    schema.bodyStyles.backgroundColor = alternateBackgroundColor;
  }
  schema.showHead = schema.showHead === false ? false : !schema.__isSplit;
  const input = parseInput(schema, body);
  const font = options.font || getDefaultFont();
  const fallbackFontName = getFallbackFontName(font);
  const content = parseContent4Table(input, fallbackFontName);
  return Table.create({
    input,
    content,
    font,
    _cache: _cache2
  });
}

// ../schemas/dist/esm/src/constants.js
var DEFAULT_OPACITY = 1;
var HEX_COLOR_PATTERN = "^#(?:[A-Fa-f0-9]{6})$";

// ../schemas/dist/esm/src/tables/helper.js
var getBody = (value) => {
  if (typeof value === "string") {
    return JSON.parse(value || "[]");
  }
  return value || [];
};
var getBodyWithRange = (value, range3) => {
  const body = getBody(value);
  if (!range3)
    return body;
  return body.slice(range3.start, range3.end);
};

// ../schemas/dist/esm/src/tables/dynamicTemplate.js
var getDynamicHeightsForTable = async (value, args) => {
  if (args.schema.type !== "table")
    return Promise.resolve([args.schema.height]);
  const schema = args.schema;
  const body = schema.__bodyRange?.start === 0 ? getBody(value) : getBodyWithRange(value, schema.__bodyRange);
  const table = await createSingleTable(body, args);
  return schema.showHead ? table.allRows().map((row) => row.height) : [0].concat(table.body.map((row) => row.height));
};

// ../schemas/dist/esm/src/utils.js
var convertForPdfLayoutProps = ({ schema, pageHeight, applyRotateTranslate = true }) => {
  const { width: mmWidth, height: mmHeight, position: position3, rotate: rotate2, opacity } = schema;
  const { x: mmX, y: mmY } = position3;
  const rotateDegrees = rotate2 ? -rotate2 : 0;
  const width = mm2pt(mmWidth);
  const height = mm2pt(mmHeight);
  let x = mm2pt(mmX);
  let y = pageHeight - mm2pt(mmY) - height;
  if (rotateDegrees && applyRotateTranslate) {
    const pivotPoint = { x: x + width / 2, y: pageHeight - mm2pt(mmY) - height / 2 };
    const rotatedPoint = rotatePoint({ x, y }, pivotPoint, rotateDegrees);
    x = rotatedPoint.x;
    y = rotatedPoint.y;
  }
  return {
    position: { x, y },
    height,
    width,
    rotate: degrees(rotateDegrees),
    opacity
  };
};
var rotatePoint = (point, pivot, angleDegrees) => {
  const angleRadians = degreesToRadians(angleDegrees);
  const x = Math.cos(angleRadians) * (point.x - pivot.x) - Math.sin(angleRadians) * (point.y - pivot.y) + pivot.x;
  const y = Math.sin(angleRadians) * (point.x - pivot.x) + Math.cos(angleRadians) * (point.y - pivot.y) + pivot.y;
  return { x, y };
};
var getDynamicHeightsForTable2 = getDynamicHeightsForTable;
var isEditable = (mode, schema) => mode === "designer" || mode === "form" && schema.readOnly !== true;
var hex2rgb = (hex2) => {
  if (hex2.slice(0, 1) === "#")
    hex2 = hex2.slice(1);
  if (hex2.length === 3)
    hex2 = hex2.slice(0, 1) + hex2.slice(0, 1) + hex2.slice(1, 2) + hex2.slice(1, 2) + hex2.slice(2, 3) + hex2.slice(2, 3);
  return [hex2.slice(0, 2), hex2.slice(2, 4), hex2.slice(4, 6)].map((str) => parseInt(str, 16));
};
var hex2RgbColor = (hexString) => {
  if (hexString) {
    const isValid2 = isHexValid(hexString);
    if (!isValid2) {
      throw new Error(`Invalid hex color value ${hexString}`);
    }
    const [r2, g, b] = hex2rgb(hexString);
    return rgb(r2 / 255, g / 255, b / 255);
  }
  return void 0;
};
var hex2CmykColor = (hexString) => {
  if (hexString) {
    const isValid2 = isHexValid(hexString);
    if (!isValid2) {
      throw new Error(`Invalid hex color value ${hexString}`);
    }
    hexString = hexString.replace("#", "");
    const hexColor = hexString.substring(0, 6);
    const opacityColor = hexString.substring(6, 8);
    const opacity = opacityColor ? parseInt(opacityColor, 16) / 255 : 1;
    let r2 = parseInt(hexColor.substring(0, 2), 16) / 255;
    let g = parseInt(hexColor.substring(2, 4), 16) / 255;
    let b = parseInt(hexColor.substring(4, 6), 16) / 255;
    r2 = r2 * opacity + (1 - opacity);
    g = g * opacity + (1 - opacity);
    b = b * opacity + (1 - opacity);
    const k = 1 - Math.max(r2, g, b);
    const c = r2 === 0 ? 0 : (1 - r2 - k) / (1 - k);
    const m = g === 0 ? 0 : (1 - g - k) / (1 - k);
    const y = b === 0 ? 0 : (1 - b - k) / (1 - k);
    return cmyk(c, m, y, k);
  }
  return void 0;
};
var hex2PrintingColor = (color, colorType) => {
  if (typeof color === "object")
    return color;
  return colorType?.toLowerCase() == "cmyk" ? hex2CmykColor(color) : hex2RgbColor(color);
};
var createSvgStr = (icon, attrs) => {
  if (!Array.isArray(icon)) {
    return String(icon);
  }
  const svgAttrs = {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...attrs || {}
  };
  const svgAttrString = Object.entries(svgAttrs).map(([key2, value]) => `${key2}="${value}"`).join(" ");
  const processElement = (element) => {
    if (!Array.isArray(element)) {
      return String(element);
    }
    const [tag, attributes2 = {}, children = []] = element;
    const tagName = String(tag);
    const attrString = Object.entries(attributes2).map(([key2, value]) => `${key2}="${value}"`).join(" ");
    let childrenString = "";
    if (Array.isArray(children) && children.length > 0) {
      childrenString = children.map((child) => processElement(child)).join("");
    }
    if (childrenString) {
      return `<${String(tagName)}${attrString ? " " + String(attrString) : ""}>${childrenString}</${String(tagName)}>`;
    } else {
      return `<${String(tagName)}${attrString ? " " + String(attrString) : ""}/>`;
    }
  };
  const elementsString = Array.isArray(icon) ? icon.map((element) => processElement(element)).join("") : processElement(icon);
  return `<svg ${svgAttrString}>${elementsString}</svg>`;
};

// ../schemas/dist/esm/src/text/pdfRender.js
var embedAndGetFontObj = async (arg) => {
  const { pdfDoc, font, _cache: _cache2 } = arg;
  if (_cache2.has(pdfDoc)) {
    return _cache2.get(pdfDoc);
  }
  const fontValues = await Promise.all(Object.values(font).map(async (v) => {
    let fontData = v.data;
    if (typeof fontData === "string" && fontData.startsWith("http")) {
      fontData = await fetch(fontData).then((res) => res.arrayBuffer());
    }
    return pdfDoc.embedFont(fontData, {
      subset: typeof v.subset === "undefined" ? true : v.subset
    });
  }));
  const fontObj = Object.keys(font).reduce((acc, cur, i) => Object.assign(acc, { [cur]: fontValues[i] }), {});
  _cache2.set(pdfDoc, fontObj);
  return fontObj;
};
var getFontProp = ({ value, fontKitFont, schema, colorType }) => {
  const fontSize = schema.dynamicFontSize ? calculateDynamicFontSize({ textSchema: schema, fontKitFont, value }) : schema.fontSize ?? DEFAULT_FONT_SIZE;
  const color = hex2PrintingColor(schema.fontColor || DEFAULT_FONT_COLOR, colorType);
  return {
    alignment: schema.alignment ?? DEFAULT_ALIGNMENT,
    verticalAlignment: schema.verticalAlignment ?? DEFAULT_VERTICAL_ALIGNMENT,
    lineHeight: schema.lineHeight ?? DEFAULT_LINE_HEIGHT,
    characterSpacing: schema.characterSpacing ?? DEFAULT_CHARACTER_SPACING,
    fontSize,
    color
  };
};
var pdfRender = async (arg) => {
  const { value, pdfDoc, pdfLib, page, options, schema, _cache: _cache2 } = arg;
  if (!value)
    return;
  const { font = getDefaultFont(), colorType } = options;
  const [pdfFontObj, fontKitFont] = await Promise.all([
    embedAndGetFontObj({
      pdfDoc,
      font,
      _cache: _cache2
    }),
    getFontKitFont(schema.fontName, font, _cache2)
  ]);
  const fontProp = getFontProp({ value, fontKitFont, schema, colorType });
  const { fontSize, color, alignment, verticalAlignment, lineHeight, characterSpacing } = fontProp;
  const fontName = schema.fontName ? schema.fontName : getFallbackFontName(font);
  const pdfFontValue = pdfFontObj && pdfFontObj[fontName];
  const pageHeight = page.getHeight();
  const { width, height, rotate: rotate2, position: { x, y }, opacity } = convertForPdfLayoutProps({ schema, pageHeight, applyRotateTranslate: false });
  if (schema.backgroundColor) {
    const color2 = hex2PrintingColor(schema.backgroundColor, colorType);
    page.drawRectangle({ x, y, width, height, rotate: rotate2, color: color2 });
  }
  const firstLineTextHeight = heightOfFontAtSize(fontKitFont, fontSize);
  const descent = getFontDescentInPt(fontKitFont, fontSize);
  const halfLineHeightAdjustment = lineHeight === 0 ? 0 : (lineHeight - 1) * fontSize / 2;
  const lines = splitTextToSize({
    value,
    characterSpacing,
    fontSize,
    fontKitFont,
    boxWidthInPt: width
  });
  let yOffset = 0;
  if (verticalAlignment === VERTICAL_ALIGN_TOP) {
    yOffset = firstLineTextHeight + halfLineHeightAdjustment;
  } else {
    const otherLinesHeight = lineHeight * fontSize * (lines.length - 1);
    if (verticalAlignment === VERTICAL_ALIGN_BOTTOM) {
      yOffset = height - otherLinesHeight + descent - halfLineHeightAdjustment;
    } else if (verticalAlignment === VERTICAL_ALIGN_MIDDLE) {
      yOffset = (height - otherLinesHeight - firstLineTextHeight + descent) / 2 + firstLineTextHeight;
    }
  }
  const pivotPoint = { x: x + width / 2, y: pageHeight - mm2pt(schema.position.y) - height / 2 };
  const segmenter = new Intl.Segmenter(void 0, { granularity: "grapheme" });
  lines.forEach((line2, rowIndex) => {
    const trimmed = line2.replace("\n", "");
    const textWidth = widthOfTextAtSize(trimmed, fontKitFont, fontSize, characterSpacing);
    const textHeight = heightOfFontAtSize(fontKitFont, fontSize);
    const rowYOffset = lineHeight * fontSize * rowIndex;
    if (line2 === "") {
      line2 = "\r\n";
    }
    let xLine = x;
    if (alignment === "center") {
      xLine += (width - textWidth) / 2;
    } else if (alignment === "right") {
      xLine += width - textWidth;
    }
    let yLine = pageHeight - mm2pt(schema.position.y) - yOffset - rowYOffset;
    if (schema.strikethrough && textWidth > 0) {
      const _x = xLine + textWidth + 1;
      const _y = yLine + textHeight / 3;
      page.drawLine({
        start: rotatePoint({ x: xLine, y: _y }, pivotPoint, rotate2.angle),
        end: rotatePoint({ x: _x, y: _y }, pivotPoint, rotate2.angle),
        thickness: 1 / 12 * fontSize,
        color,
        opacity
      });
    }
    if (schema.underline && textWidth > 0) {
      const _x = xLine + textWidth + 1;
      const _y = yLine - textHeight / 12;
      page.drawLine({
        start: rotatePoint({ x: xLine, y: _y }, pivotPoint, rotate2.angle),
        end: rotatePoint({ x: _x, y: _y }, pivotPoint, rotate2.angle),
        thickness: 1 / 12 * fontSize,
        color,
        opacity
      });
    }
    if (rotate2.angle !== 0) {
      const rotatedPoint = rotatePoint({ x: xLine, y: yLine }, pivotPoint, rotate2.angle);
      xLine = rotatedPoint.x;
      yLine = rotatedPoint.y;
    }
    let spacing = characterSpacing;
    if (alignment === "justify" && line2.slice(-1) !== "\n") {
      const iterator = segmenter.segment(trimmed)[Symbol.iterator]();
      const len = Array.from(iterator).length;
      spacing += (width - textWidth) / len;
    }
    page.pushOperators(pdfLib.setCharacterSpacing(spacing));
    page.drawText(trimmed, {
      x: xLine,
      y: yLine,
      rotate: rotate2,
      size: fontSize,
      color,
      lineHeight: lineHeight * fontSize,
      font: pdfFontValue,
      opacity
    });
  });
};

// ../../node_modules/lucide/dist/esm/icons/align-center.js
var AlignCenter = [
  ["path", { d: "M17 12H7" }],
  ["path", { d: "M19 18H5" }],
  ["path", { d: "M21 6H3" }]
];

// ../../node_modules/lucide/dist/esm/icons/align-justify.js
var AlignJustify = [
  ["path", { d: "M3 12h18" }],
  ["path", { d: "M3 18h18" }],
  ["path", { d: "M3 6h18" }]
];

// ../../node_modules/lucide/dist/esm/icons/align-left.js
var AlignLeft = [
  ["path", { d: "M15 12H3" }],
  ["path", { d: "M17 18H3" }],
  ["path", { d: "M21 6H3" }]
];

// ../../node_modules/lucide/dist/esm/icons/align-right.js
var AlignRight = [
  ["path", { d: "M21 12H9" }],
  ["path", { d: "M21 18H7" }],
  ["path", { d: "M21 6H3" }]
];

// ../../node_modules/lucide/dist/esm/icons/arrow-down-to-line.js
var ArrowDownToLine = [
  ["path", { d: "M12 17V3" }],
  ["path", { d: "m6 11 6 6 6-6" }],
  ["path", { d: "M19 21H5" }]
];

// ../../node_modules/lucide/dist/esm/icons/arrow-up-to-line.js
var ArrowUpToLine = [
  ["path", { d: "M5 3h14" }],
  ["path", { d: "m18 13-6-6-6 6" }],
  ["path", { d: "M12 7v14" }]
];

// ../../node_modules/lucide/dist/esm/icons/strikethrough.js
var Strikethrough = [
  ["path", { d: "M16 4H9a3 3 0 0 0-2.83 4" }],
  ["path", { d: "M14 12a4 4 0 0 1 0 8H6" }],
  ["line", { x1: "4", x2: "20", y1: "12", y2: "12" }]
];

// ../../node_modules/lucide/dist/esm/icons/underline.js
var Underline = [
  ["path", { d: "M6 4v6a6 6 0 0 0 12 0V4" }],
  ["line", { x1: "4", x2: "20", y1: "20", y2: "20" }]
];

// ../schemas/dist/esm/src/text/icons/index.js
var TextStrikethroughIcon = createSvgStr(Strikethrough);
var TextUnderlineIcon = createSvgStr(Underline);
var TextAlignLeftIcon = createSvgStr(AlignLeft);
var TextAlignCenterIcon = createSvgStr(AlignCenter);
var TextAlignRightIcon = createSvgStr(AlignRight);
var TextAlignJustifyIcon = createSvgStr(AlignJustify);
var TextVerticalAlignTopIcon = createSvgStr(ArrowUpToLine);
var TextVerticalAlignMiddleIcon = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24"><path d="M8 19h3v4h2v-4h3l-4-4l-4 4zm8-14h-3V1h-2v4H8l4 4l4-4zM4 11v2h16v-2H4z" fill="currentColor"></path></svg>`;
var TextVerticalAlignBottomIcon = createSvgStr(ArrowDownToLine);

// ../schemas/dist/esm/src/text/extraFormatter.js
var Formatter;
(function(Formatter2) {
  Formatter2["STRIKETHROUGH"] = "strikethrough";
  Formatter2["UNDERLINE"] = "underline";
  Formatter2["ALIGNMENT"] = "alignment";
  Formatter2["VERTICAL_ALIGNMENT"] = "verticalAlignment";
})(Formatter || (Formatter = {}));
function getExtraFormatterSchema(i18n2) {
  const buttons = [
    { key: Formatter.STRIKETHROUGH, icon: TextStrikethroughIcon, type: "boolean" },
    { key: Formatter.UNDERLINE, icon: TextUnderlineIcon, type: "boolean" },
    { key: Formatter.ALIGNMENT, icon: TextAlignLeftIcon, type: "select", value: DEFAULT_ALIGNMENT },
    { key: Formatter.ALIGNMENT, icon: TextAlignCenterIcon, type: "select", value: ALIGN_CENTER },
    { key: Formatter.ALIGNMENT, icon: TextAlignRightIcon, type: "select", value: ALIGN_RIGHT },
    { key: Formatter.ALIGNMENT, icon: TextAlignJustifyIcon, type: "select", value: ALIGN_JUSTIFY },
    {
      key: Formatter.VERTICAL_ALIGNMENT,
      icon: TextVerticalAlignTopIcon,
      type: "select",
      value: DEFAULT_VERTICAL_ALIGNMENT
    },
    {
      key: Formatter.VERTICAL_ALIGNMENT,
      icon: TextVerticalAlignMiddleIcon,
      type: "select",
      value: VERTICAL_ALIGN_MIDDLE
    },
    {
      key: Formatter.VERTICAL_ALIGNMENT,
      icon: TextVerticalAlignBottomIcon,
      type: "select",
      value: VERTICAL_ALIGN_BOTTOM
    }
  ];
  return {
    title: i18n2("schemas.text.format"),
    widget: "ButtonGroup",
    buttons,
    span: 24
  };
}

// ../schemas/dist/esm/src/text/propPanel.js
var UseDynamicFontSize = (props) => {
  const { rootElement, changeSchemas: changeSchemas2, activeSchema, i18n: i18n2 } = props;
  const checkbox = document.createElement("input");
  checkbox.type = "checkbox";
  checkbox.checked = Boolean(activeSchema?.dynamicFontSize);
  checkbox.onchange = (e3) => {
    const val = e3.target.checked ? {
      min: DEFAULT_DYNAMIC_MIN_FONT_SIZE,
      max: DEFAULT_DYNAMIC_MAX_FONT_SIZE,
      fit: DEFAULT_DYNAMIC_FIT
    } : void 0;
    changeSchemas2([{ key: "dynamicFontSize", value: val, schemaId: activeSchema.id }]);
  };
  const label = document.createElement("label");
  const span = document.createElement("span");
  span.innerText = i18n2("schemas.text.dynamicFontSize") || "";
  span.style.cssText = "margin-left: 0.5rem";
  label.style.cssText = "display: flex; width: 100%;";
  label.appendChild(checkbox);
  label.appendChild(span);
  rootElement.appendChild(label);
};
var propPanel = {
  schema: ({ options, activeSchema, i18n: i18n2 }) => {
    const font = options.font || { [DEFAULT_FONT_NAME]: { data: "", fallback: true } };
    const fontNames = Object.keys(font);
    const fallbackFontName = getFallbackFontName(font);
    const enableDynamicFont = Boolean(activeSchema?.dynamicFontSize);
    const textSchema2 = {
      fontName: {
        title: i18n2("schemas.text.fontName"),
        type: "string",
        widget: "select",
        default: fallbackFontName,
        placeholder: fallbackFontName,
        props: { options: fontNames.map((name) => ({ label: name, value: name })) },
        span: 12
      },
      fontSize: {
        title: i18n2("schemas.text.size"),
        type: "number",
        widget: "inputNumber",
        span: 6,
        disabled: enableDynamicFont,
        props: { min: 0 }
      },
      characterSpacing: {
        title: i18n2("schemas.text.spacing"),
        type: "number",
        widget: "inputNumber",
        span: 6,
        props: { min: 0 }
      },
      formatter: getExtraFormatterSchema(i18n2),
      lineHeight: {
        title: i18n2("schemas.text.lineHeight"),
        type: "number",
        widget: "inputNumber",
        props: { step: 0.1, min: 0 },
        span: 8
      },
      useDynamicFontSize: { type: "boolean", widget: "UseDynamicFontSize", bind: false, span: 16 },
      dynamicFontSize: {
        type: "object",
        widget: "card",
        column: 3,
        properties: {
          min: {
            title: i18n2("schemas.text.min"),
            type: "number",
            widget: "inputNumber",
            hidden: !enableDynamicFont,
            props: { min: 0 }
          },
          max: {
            title: i18n2("schemas.text.max"),
            type: "number",
            widget: "inputNumber",
            hidden: !enableDynamicFont,
            props: { min: 0 }
          },
          fit: {
            title: i18n2("schemas.text.fit"),
            type: "string",
            widget: "select",
            hidden: !enableDynamicFont,
            props: {
              options: [
                { label: i18n2("schemas.horizontal"), value: DYNAMIC_FIT_HORIZONTAL },
                { label: i18n2("schemas.vertical"), value: DYNAMIC_FIT_VERTICAL }
              ]
            }
          }
        }
      },
      fontColor: {
        title: i18n2("schemas.textColor"),
        type: "string",
        widget: "color",
        props: {
          disabledAlpha: true
        },
        rules: [
          {
            pattern: HEX_COLOR_PATTERN,
            message: i18n2("validation.hexColor")
          }
        ]
      },
      backgroundColor: {
        title: i18n2("schemas.bgColor"),
        type: "string",
        widget: "color",
        props: {
          disabledAlpha: true
        },
        rules: [
          {
            pattern: HEX_COLOR_PATTERN,
            message: i18n2("validation.hexColor")
          }
        ]
      }
    };
    return textSchema2;
  },
  widgets: { UseDynamicFontSize },
  defaultSchema: {
    name: "",
    type: "text",
    content: "Type Something...",
    position: { x: 0, y: 0 },
    width: 45,
    height: 10,
    // If the value of "rotate" is set to undefined or not set at all, rotation will be disabled in the UI.
    // Check this document: https://pdfme.com//docs/custom-schemas#learning-how-to-create-from-pdfmeschemas-code
    rotate: 0,
    alignment: DEFAULT_ALIGNMENT,
    verticalAlignment: DEFAULT_VERTICAL_ALIGNMENT,
    fontSize: DEFAULT_FONT_SIZE,
    lineHeight: DEFAULT_LINE_HEIGHT,
    characterSpacing: DEFAULT_CHARACTER_SPACING,
    dynamicFontSize: void 0,
    fontColor: DEFAULT_FONT_COLOR,
    fontName: void 0,
    backgroundColor: "",
    opacity: DEFAULT_OPACITY,
    strikethrough: false,
    underline: false
  }
};

// ../schemas/dist/esm/src/text/uiRender.js
var replaceUnsupportedChars = (text, fontKitFont) => {
  const charSupportCache = {};
  const isCharSupported = (char2) => {
    if (char2 in charSupportCache) {
      return charSupportCache[char2];
    }
    const isSupported = fontKitFont.hasGlyphForCodePoint(char2.codePointAt(0) || 0);
    charSupportCache[char2] = isSupported;
    return isSupported;
  };
  const segments = text.split(/(\r\n|\n|\r)/);
  return segments.map((segment) => {
    if (/\r\n|\n|\r/.test(segment)) {
      return segment;
    }
    return segment.split("").map((char2) => {
      if (/\s/.test(char2) || char2.charCodeAt(0) < 32) {
        return char2;
      }
      return isCharSupported(char2) ? char2 : "\u303F";
    }).join("");
  }).join("");
};
var uiRender = async (arg) => {
  const { value, schema, mode, onChange, stopEditing, tabIndex, placeholder, options, _cache: _cache2 } = arg;
  const usePlaceholder = isEditable(mode, schema) && placeholder && !value;
  const getText = (element) => {
    let text = element.innerText;
    if (text.endsWith("\n")) {
      text = text.slice(0, -1);
    }
    return text;
  };
  const font = options?.font || getDefaultFont();
  const fontKitFont = await getFontKitFont(schema.fontName, font, _cache2);
  const textBlock = buildStyledTextContainer(arg, fontKitFont, usePlaceholder ? placeholder : value);
  const processedText = replaceUnsupportedChars(value, fontKitFont);
  if (!isEditable(mode, schema)) {
    textBlock.innerHTML = processedText.split("").map((l2, i) => `<span style="letter-spacing:${String(value).length === i + 1 ? 0 : "inherit"};">${l2}</span>`).join("");
    return;
  }
  makeElementPlainTextContentEditable(textBlock);
  textBlock.tabIndex = tabIndex || 0;
  textBlock.innerText = mode === "designer" ? value : processedText;
  textBlock.addEventListener("blur", (e3) => {
    if (onChange)
      onChange({ key: "content", value: getText(e3.target) });
    if (stopEditing)
      stopEditing();
  });
  if (schema.dynamicFontSize) {
    let dynamicFontSize = void 0;
    textBlock.addEventListener("keyup", () => {
      setTimeout(() => {
        (() => {
          if (!textBlock.textContent)
            return;
          dynamicFontSize = calculateDynamicFontSize({
            textSchema: schema,
            fontKitFont,
            value: getText(textBlock),
            startingFontSize: dynamicFontSize
          });
          textBlock.style.fontSize = `${dynamicFontSize}pt`;
          const { topAdj: newTopAdj, bottomAdj: newBottomAdj } = getBrowserVerticalFontAdjustments(fontKitFont, dynamicFontSize ?? schema.fontSize ?? DEFAULT_FONT_SIZE, schema.lineHeight ?? DEFAULT_LINE_HEIGHT, schema.verticalAlignment ?? DEFAULT_VERTICAL_ALIGNMENT);
          textBlock.style.paddingTop = `${newTopAdj}px`;
          textBlock.style.marginBottom = `${newBottomAdj}px`;
        })();
      }, 0);
    });
  }
  if (usePlaceholder) {
    textBlock.style.color = PLACEHOLDER_FONT_COLOR;
    textBlock.addEventListener("focus", () => {
      if (textBlock.innerText === placeholder) {
        textBlock.innerText = "";
        textBlock.style.color = schema.fontColor ?? DEFAULT_FONT_COLOR;
      }
    });
  }
  if (mode === "designer") {
    setTimeout(() => {
      textBlock.focus();
      const selection = window.getSelection();
      const range3 = document.createRange();
      if (selection && range3) {
        range3.selectNodeContents(textBlock);
        range3.collapse(false);
        selection?.removeAllRanges();
        selection?.addRange(range3);
      }
    });
  }
};
var buildStyledTextContainer = (arg, fontKitFont, value) => {
  const { schema, rootElement, mode } = arg;
  let dynamicFontSize = void 0;
  if (schema.dynamicFontSize && value) {
    dynamicFontSize = calculateDynamicFontSize({
      textSchema: schema,
      fontKitFont,
      value,
      startingFontSize: dynamicFontSize
    });
  }
  const { topAdj, bottomAdj } = getBrowserVerticalFontAdjustments(fontKitFont, dynamicFontSize ?? schema.fontSize ?? DEFAULT_FONT_SIZE, schema.lineHeight ?? DEFAULT_LINE_HEIGHT, schema.verticalAlignment ?? DEFAULT_VERTICAL_ALIGNMENT);
  const topAdjustment = topAdj.toString();
  const bottomAdjustment = bottomAdj.toString();
  const container = document.createElement("div");
  const containerStyle = {
    padding: 0,
    resize: "none",
    backgroundColor: getBackgroundColor(value, schema),
    border: "none",
    display: "flex",
    flexDirection: "column",
    justifyContent: mapVerticalAlignToFlex(schema.verticalAlignment),
    width: "100%",
    height: "100%",
    cursor: isEditable(mode, schema) ? "text" : "default"
  };
  Object.assign(container.style, containerStyle);
  rootElement.innerHTML = "";
  rootElement.appendChild(container);
  const textDecorations = [];
  if (schema.strikethrough)
    textDecorations.push("line-through");
  if (schema.underline)
    textDecorations.push("underline");
  const textBlockStyle = {
    // Font formatting styles
    fontFamily: schema.fontName ? `'${schema.fontName}'` : "inherit",
    color: schema.fontColor ? schema.fontColor : DEFAULT_FONT_COLOR,
    fontSize: `${dynamicFontSize ?? schema.fontSize ?? DEFAULT_FONT_SIZE}pt`,
    letterSpacing: `${schema.characterSpacing ?? DEFAULT_CHARACTER_SPACING}pt`,
    lineHeight: `${schema.lineHeight ?? DEFAULT_LINE_HEIGHT}em`,
    textAlign: schema.alignment ?? DEFAULT_ALIGNMENT,
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
    // Block layout styles
    resize: "none",
    border: "none",
    outline: "none",
    marginBottom: `${bottomAdjustment}px`,
    paddingTop: `${topAdjustment}px`,
    backgroundColor: "transparent",
    textDecoration: textDecorations.join(" ")
  };
  const textBlock = document.createElement("div");
  textBlock.id = "text-" + String(schema.id);
  Object.assign(textBlock.style, textBlockStyle);
  container.appendChild(textBlock);
  return textBlock;
};
var makeElementPlainTextContentEditable = (element) => {
  if (!isFirefox()) {
    element.contentEditable = "plaintext-only";
    return;
  }
  element.contentEditable = "true";
  element.addEventListener("keydown", (e3) => {
    if (e3.key === "Enter" && !e3.shiftKey) {
      e3.preventDefault();
      document.execCommand("insertLineBreak", false, void 0);
    }
  });
  element.addEventListener("paste", (e3) => {
    e3.preventDefault();
    const paste = e3.clipboardData?.getData("text");
    const selection = window.getSelection();
    if (!selection?.rangeCount)
      return;
    selection.deleteFromDocument();
    selection.getRangeAt(0).insertNode(document.createTextNode(paste || ""));
    selection.collapseToEnd();
  });
};
var mapVerticalAlignToFlex = (verticalAlignmentValue) => {
  switch (verticalAlignmentValue) {
    case VERTICAL_ALIGN_TOP:
      return "flex-start";
    case VERTICAL_ALIGN_MIDDLE:
      return "center";
    case VERTICAL_ALIGN_BOTTOM:
      return "flex-end";
  }
  return "flex-start";
};
var getBackgroundColor = (value, schema) => {
  if (!value || !schema.backgroundColor)
    return "transparent";
  return schema.backgroundColor;
};

// ../schemas/dist/esm/src/text/index.js
var textSchema = {
  pdf: pdfRender,
  ui: uiRender,
  propPanel,
  icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-type"><polyline points="4 7 4 4 20 4 20 7"/><line x1="9" x2="15" y1="20" y2="20"/><line x1="12" x2="12" y1="4" y2="20"/></svg>'
};
var text_default = textSchema;

// ../schemas/dist/esm/src/index.js
var builtInPlugins = { Text: text_default };

// src/contexts.ts
var I18nContext = (0, import_react.createContext)(i18n);
var FontContext = (0, import_react.createContext)(getDefaultFont());
var PluginsRegistry = (0, import_react.createContext)(builtInPlugins);
var OptionsContext = (0, import_react.createContext)({});
var CacheContext = (0, import_react.createContext)(/* @__PURE__ */ new Map());

// src/helper.ts
var hotkeys2 = function(keys4, callback) {
  return hotkeys(keys4, callback);
};
hotkeys2.shift = false;
hotkeys2.unbind = function(keys4) {
  const hotkeysFn = hotkeys;
  if (typeof hotkeysFn.unbind === "function") {
    hotkeysFn.unbind(keys4);
  }
};
var uuid = () => "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
  const r2 = Math.random() * 16 | 0;
  const v = c == "x" ? r2 : r2 & 3 | 8;
  return v.toString(16);
});
var set = (obj, path2, value) => {
  path2 = Array.isArray(path2) ? path2 : path2.replace("[", ".").replace("]", "").split(".");
  let src = obj;
  path2.forEach((key2, index3, array4) => {
    if (index3 == path2.length - 1) {
      src[key2] = value;
    } else {
      if (!Object.prototype.hasOwnProperty.call(src, key2)) {
        const next2 = array4[index3 + 1];
        src[key2] = String(Number(next2)) === next2 ? [] : {};
      }
      src = src[key2];
    }
  });
};
var debounce = (cb, wait = 20) => {
  let h2 = null;
  const callable = (...args) => {
    if (h2) clearTimeout(h2);
    h2 = setTimeout(() => cb(...args), wait);
  };
  return callable;
};
var shift = (number4, precision, reverseShift) => {
  if (reverseShift) {
    precision = -precision;
  }
  const numArray = `${number4}`.split("e");
  return Number(`${numArray[0]}e${numArray[1] ? Number(numArray[1]) + precision : precision}`);
};
var round = (number4, precision) => {
  return shift(Math.round(shift(number4, precision, false)), precision, true);
};
var flatten = (arr) => [].concat(...arr);
var up = "up";
var shiftUp = "shift+up";
var down = "down";
var shiftDown = "shift+down";
var left = "left";
var shiftLeft = "shift+left";
var right = "right";
var shiftRight = "shift+right";
var rmWin = "backspace";
var rmMac = "delete";
var esc = "esc";
var copyWin = "ctrl+c";
var copyMac = "command+c";
var pasteWin = "ctrl+v";
var pasteMac = "command+v";
var redoWin = "ctrl+y";
var redoMac = "shift+command+z";
var undoWin = "ctrl+z";
var undoMac = "command+z";
var saveWin = "ctrl+s";
var saveMac = "command+s";
var selectAllWin = "ctrl+a";
var selectAllMac = "command+a";
var keys = [
  up,
  shiftUp,
  down,
  shiftDown,
  left,
  shiftLeft,
  right,
  shiftRight,
  rmMac,
  rmWin,
  esc,
  copyWin,
  copyMac,
  pasteWin,
  pasteMac,
  redoWin,
  redoMac,
  undoWin,
  undoMac,
  saveWin,
  saveMac,
  selectAllWin,
  selectAllMac
];
var initShortCuts = (arg) => {
  hotkeys2(keys.join(), (e3, handler) => {
    switch (handler.shortcut) {
      case up:
      case shiftUp:
        e3.preventDefault();
        arg.move("up", hotkeys2.shift);
        break;
      case down:
      case shiftDown:
        e3.preventDefault();
        arg.move("down", hotkeys2.shift);
        break;
      case left:
      case shiftLeft:
        e3.preventDefault();
        arg.move("left", hotkeys2.shift);
        break;
      case right:
      case shiftRight:
        e3.preventDefault();
        arg.move("right", hotkeys2.shift);
        break;
      case rmWin:
      case rmMac:
        arg.remove();
        break;
      case esc:
        arg.esc();
        break;
      case copyWin:
      case copyMac:
        arg.copy();
        break;
      case pasteWin:
      case pasteMac:
        arg.paste();
        break;
      case redoWin:
      case redoMac:
        arg.redo();
        break;
      case undoWin:
      case undoMac:
        arg.undo();
        break;
      case saveWin:
      case saveMac:
        e3.preventDefault();
        arg.save();
        break;
      case selectAllWin:
      case selectAllMac:
        e3.preventDefault();
        arg.selectAll();
        break;
      default:
        break;
    }
  });
};
var destroyShortCuts = () => {
  hotkeys2.unbind(keys.join());
};
function detectMimeType(arrayBuffer) {
  const dataView = new DataView(arrayBuffer);
  if (dataView.getUint8(0) === 137 && dataView.getUint8(1) === 80 && dataView.getUint8(2) === 78 && dataView.getUint8(3) === 71) {
    return "image/png";
  }
  if (dataView.getUint8(0) === 255 && dataView.getUint8(1) === 216 && dataView.getUint8(2) === 255) {
    return "image/jpeg";
  }
  return "";
}
var arrayBufferToBase64 = (arrayBuffer) => {
  const mimeType = detectMimeType(arrayBuffer);
  const bytes = new Uint8Array(arrayBuffer);
  let binary = "";
  for (let i = 0; i < bytes.length; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  const base64String = btoa(binary);
  if (mimeType) {
    return `data:${mimeType};base64,${base64String}`;
  } else {
    return `data:application/octet-stream;base64,${base64String}`;
  }
};
var convertSchemasForUI = (template) => {
  template.schemas.forEach((page) => {
    page.forEach((schema) => {
      schema.id = uuid();
      schema.content = schema.content || "";
    });
  });
  return template.schemas;
};
var template2SchemasList = async (_template) => {
  const template = cloneDeep(_template);
  const { basePdf, schemas } = template;
  const schemasForUI = convertSchemasForUI(template);
  let pageSizes = [];
  if (isBlankPdf(basePdf)) {
    pageSizes = schemas.map(() => ({
      width: basePdf.width,
      height: basePdf.height
    }));
  } else {
    const b64BasePdf = await getB64BasePdf(basePdf);
    const pdfArrayBuffer = b64toUint8Array(b64BasePdf);
    pageSizes = await pdf2size2(pdfArrayBuffer);
  }
  const ssl = schemasForUI.length;
  const psl = pageSizes.length;
  return (ssl < psl ? schemasForUI.concat(new Array(psl - ssl).fill(cloneDeep([]))) : schemasForUI.slice(0, pageSizes.length)).map((schema, i) => {
    Object.values(schema).forEach((value) => {
      const { width, height } = pageSizes[i];
      const xEdge = value.position.x + value.width;
      const yEdge = value.position.y + value.height;
      if (width < xEdge) {
        const diff3 = xEdge - width;
        value.position.x += diff3;
      }
      if (height < yEdge) {
        const diff3 = yEdge - height;
        value.position.y += diff3;
      }
    });
    return schema;
  });
};
var schemasList2template = (schemasList, basePdf) => ({
  schemas: cloneDeep(schemasList).map(
    (page) => page.map((schema) => {
      delete schema.id;
      return schema;
    })
  ),
  basePdf
});
var getUniqueSchemaName = (arg) => {
  const { copiedSchemaName, schema, stackUniqueSchemaNames } = arg;
  const schemaNames = schema.map((s) => s.name).concat(stackUniqueSchemaNames);
  const tmp = schemaNames.reduce(
    (acc, cur) => Object.assign(acc, { originalName: cur, copiedNum: 0 }),
    {}
  );
  const extractOriginalName = (name) => name.replace(/ copy$| copy [0-9]*$/, "");
  schemaNames.filter((name) => / copy$| copy [0-9]*$/.test(name)).forEach((name) => {
    const originalName2 = extractOriginalName(name);
    const match2 = name.match(/[0-9]*$/);
    const copiedNum = match2 && match2[0] ? Number(match2[0]) : 1;
    if ((tmp[originalName2] ?? 0) < copiedNum) {
      tmp[originalName2] = copiedNum;
    }
  });
  const originalName = extractOriginalName(copiedSchemaName);
  if (tmp[originalName]) {
    const copiedNum = tmp[originalName];
    const uniqueName2 = `${originalName} copy ${copiedNum + 1}`;
    stackUniqueSchemaNames.push(uniqueName2);
    return uniqueName2;
  }
  const uniqueName = `${copiedSchemaName} copy`;
  stackUniqueSchemaNames.push(uniqueName);
  return uniqueName;
};
var moveCommandToChangeSchemasArg = (props) => {
  const { command, activeSchemas, isShift, pageSize } = props;
  const key2 = command === "up" || command === "down" ? "y" : "x";
  const num = isShift ? 0.1 : 1;
  const getValue4 = (as) => {
    let value = 0;
    const { position: position3 } = as;
    switch (command) {
      case "up":
        value = round(position3.y - num, 2);
        break;
      case "down":
        value = round(position3.y + num, 2);
        break;
      case "left":
        value = round(position3.x - num, 2);
        break;
      case "right":
        value = round(position3.x + num, 2);
        break;
      default:
        break;
    }
    return value > 0 ? value : 0;
  };
  return activeSchemas.map((as) => {
    let value = getValue4(as);
    const { width, height } = as;
    if (key2 === "x") {
      value = value > pageSize.width - width ? round(pageSize.width - width, 2) : value;
    } else {
      value = value > pageSize.height - height ? round(pageSize.height - height, 2) : value;
    }
    return { key: `position.${key2}`, value, schemaId: as.id };
  });
};
var getPagesScrollTopByIndex = (pageSizes, index3, scale) => {
  return pageSizes.slice(0, index3).reduce((acc, cur) => acc + (cur.height * ZOOM + RULER_HEIGHT * scale) * scale, 0);
};
var getSidebarContentHeight = (sidebarHeight) => sidebarHeight - RULER_HEIGHT - RULER_HEIGHT / 2 - 30;
var handlePositionSizeChange = (schema, key2, value, basePdf, pageSize) => {
  const padding = isBlankPdf(basePdf) ? basePdf.padding : [0, 0, 0, 0];
  const [pt, pr, pb, pl] = padding;
  const { width: pw, height: ph } = pageSize;
  const calcBounds = (v, min, max) => Math.min(Math.max(Number(v), min), max);
  if (key2 === "position.x") {
    schema.position.x = calcBounds(value, pl, pw - schema.width - pr);
  } else if (key2 === "position.y") {
    schema.position.y = calcBounds(value, pt, ph - schema.height - pb);
  } else if (key2 === "width") {
    schema.width = calcBounds(value, 0, pw - schema.position.x - pr);
  } else if (key2 === "height") {
    schema.height = calcBounds(value, 0, ph - schema.position.y - pb);
  }
};
var handleTypeChange = (schema, key2, value, pluginsRegistry) => {
  if (key2 !== "type") return;
  const keysToKeep = ["id", "name", "type", "position", "required"];
  Object.keys(schema).forEach((key3) => {
    if (!keysToKeep.includes(key3)) {
      delete schema[key3];
    }
  });
  const pluginValue = value;
  let plugin;
  const pluginEntries = Object.entries(pluginsRegistry);
  for (let i = 0; i < pluginEntries.length; i++) {
    const [, pluginObj] = pluginEntries[i];
    if (!pluginObj || typeof pluginObj !== "object") continue;
    if (!("propPanel" in pluginObj) || !pluginObj.propPanel || typeof pluginObj.propPanel !== "object")
      continue;
    const propPanel3 = pluginObj.propPanel;
    if (!("defaultSchema" in propPanel3) || !propPanel3.defaultSchema || typeof propPanel3.defaultSchema !== "object")
      continue;
    const defaultSchema = propPanel3.defaultSchema;
    if (!("type" in defaultSchema) || typeof defaultSchema.type !== "string") continue;
    const schemaType = defaultSchema.type;
    if (schemaType === pluginValue) {
      const safeSchema = {
        type: schemaType
      };
      Object.keys(defaultSchema).forEach((key3) => {
        if (key3 !== "type" && Object.prototype.hasOwnProperty.call(defaultSchema, key3)) {
          safeSchema[key3] = defaultSchema[key3];
        }
      });
      plugin = {
        propPanel: {
          defaultSchema: safeSchema
        }
      };
      break;
    }
  }
  const propPanel2 = plugin?.propPanel;
  if (propPanel2?.defaultSchema) {
    const defaultSchema = propPanel2.defaultSchema;
    const schemaRecord = schema;
    for (const key3 of Object.keys(defaultSchema)) {
      if (!Object.prototype.hasOwnProperty.call(schema, key3)) {
        if (Object.prototype.hasOwnProperty.call(defaultSchema, key3)) {
          const propertyValue = defaultSchema[key3];
          if (propertyValue !== void 0) {
            schemaRecord[key3] = propertyValue;
          }
        }
      }
    }
  }
  if (schema.readOnly) {
    schema.required = false;
  }
};
var changeSchemas = (args) => {
  const { objs, schemas, basePdf, pluginsRegistry, pageSize, commitSchemas } = args;
  const newSchemas = objs.reduce((acc, { key: key2, value, schemaId }) => {
    const tgt = acc.find((s) => s.id === schemaId);
    if (!tgt) return acc;
    set(tgt, key2, value);
    if (key2 === "type") {
      handleTypeChange(tgt, key2, value, pluginsRegistry);
    } else if (["position.x", "position.y", "width", "height"].includes(key2)) {
      handlePositionSizeChange(tgt, key2, value, basePdf, pageSize);
    }
    return acc;
  }, cloneDeep(schemas));
  commitSchemas(newSchemas);
};
var useMaxZoom = () => {
  const options = (0, import_react2.useContext)(OptionsContext);
  return options.maxZoom ? options.maxZoom / 100 : DEFAULT_MAX_ZOOM;
};

// src/class.ts
var BaseUIClass = class {
  constructor(props) {
    this.lang = DEFAULT_LANG;
    this.font = getDefaultFont();
    this.pluginsRegistry = builtInPlugins;
    this.options = {};
    this.setSize = debounce(() => {
      if (!this.domContainer) throw Error(DESTROYED_ERR_MSG);
      this.size = {
        height: this.domContainer.clientHeight || window.innerHeight,
        width: this.domContainer.clientWidth || window.innerWidth
      };
      this.render();
    }, 100);
    this.resizeObserver = new ResizeObserver(this.setSize);
    checkUIProps(props);
    const { domContainer, template, options = {}, plugins = {} } = props;
    this.domContainer = domContainer;
    this.template = cloneDeep(template);
    this.options = options;
    this.size = {
      height: this.domContainer.clientHeight || window.innerHeight,
      width: this.domContainer.clientWidth || window.innerWidth
    };
    this.resizeObserver.observe(this.domContainer);
    const { lang, font } = options;
    if (lang) {
      this.lang = lang;
    }
    if (font) {
      this.font = font;
    }
    if (Object.values(plugins).length > 0) {
      this.pluginsRegistry = plugins;
    }
  }
  getLang() {
    return this.lang;
  }
  getFont() {
    return this.font;
  }
  getPluginsRegistry() {
    return this.pluginsRegistry;
  }
  getOptions() {
    return this.options;
  }
  getTemplate() {
    if (!this.domContainer) throw Error(DESTROYED_ERR_MSG);
    return this.template;
  }
  updateTemplate(template) {
    checkTemplate(template);
    if (!this.domContainer) throw Error(DESTROYED_ERR_MSG);
    this.template = cloneDeep(template);
    this.render();
  }
  updateOptions(options) {
    checkUIOptions(options);
    const { lang, font } = options || {};
    if (lang) {
      this.lang = lang;
    }
    if (font) {
      this.font = font;
    }
    this.options = Object.assign(this.options, options);
    this.render();
  }
  destroy() {
    if (!this.domContainer) throw Error(DESTROYED_ERR_MSG);
    import_react_dom.default.unmountComponentAtNode(this.domContainer);
    this.resizeObserver.unobserve(this.domContainer);
    this.domContainer = null;
  }
};
var PreviewUI = class extends BaseUIClass {
  constructor(props) {
    super(props);
    checkPreviewProps(props);
    this.inputs = convertToStingObjectArray(cloneDeep(props.inputs));
  }
  getInputs() {
    if (!this.domContainer) throw Error(DESTROYED_ERR_MSG);
    return this.inputs;
  }
  setInputs(inputs) {
    if (!this.domContainer) throw Error(DESTROYED_ERR_MSG);
    checkInputs(inputs);
    this.inputs = convertToStingObjectArray(inputs);
    this.render();
  }
};
function convertToStingObjectArray(data2) {
  return data2.map((item) => {
    const stringifiedItem = {};
    Object.keys(item).forEach((key2) => {
      const value = item[key2];
      if (Array.isArray(value)) {
        stringifiedItem[key2] = JSON.stringify(value);
      } else {
        stringifiedItem[key2] = value;
      }
    });
    return stringifiedItem;
  });
}

// src/components/Designer/index.tsx
var import_react246 = __toESM(require_react());

// ../../node_modules/@dnd-kit/core/dist/core.esm.js
var import_react5 = __toESM(require_react());
var import_react_dom2 = __toESM(require_react_dom());

// ../../node_modules/@dnd-kit/utilities/dist/utilities.esm.js
var import_react3 = __toESM(require_react());
function useCombinedRefs() {
  for (var _len = arguments.length, refs2 = new Array(_len), _key = 0; _key < _len; _key++) {
    refs2[_key] = arguments[_key];
  }
  return (0, import_react3.useMemo)(
    () => (node2) => {
      refs2.forEach((ref3) => ref3(node2));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    refs2
  );
}
var canUseDOM = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
function isWindow(element) {
  const elementString = Object.prototype.toString.call(element);
  return elementString === "[object Window]" || // In Electron context the Window object serializes to [object global]
  elementString === "[object global]";
}
function isNode(node2) {
  return "nodeType" in node2;
}
function getWindow(target) {
  var _target$ownerDocument, _target$ownerDocument2;
  if (!target) {
    return window;
  }
  if (isWindow(target)) {
    return target;
  }
  if (!isNode(target)) {
    return window;
  }
  return (_target$ownerDocument = (_target$ownerDocument2 = target.ownerDocument) == null ? void 0 : _target$ownerDocument2.defaultView) != null ? _target$ownerDocument : window;
}
function isDocument(node2) {
  const {
    Document: Document2
  } = getWindow(node2);
  return node2 instanceof Document2;
}
function isHTMLElement(node2) {
  if (isWindow(node2)) {
    return false;
  }
  return node2 instanceof getWindow(node2).HTMLElement;
}
function isSVGElement(node2) {
  return node2 instanceof getWindow(node2).SVGElement;
}
function getOwnerDocument(target) {
  if (!target) {
    return document;
  }
  if (isWindow(target)) {
    return target.document;
  }
  if (!isNode(target)) {
    return document;
  }
  if (isDocument(target)) {
    return target;
  }
  if (isHTMLElement(target) || isSVGElement(target)) {
    return target.ownerDocument;
  }
  return document;
}
var useIsomorphicLayoutEffect = canUseDOM ? import_react3.useLayoutEffect : import_react3.useEffect;
function useEvent(handler) {
  const handlerRef = (0, import_react3.useRef)(handler);
  useIsomorphicLayoutEffect(() => {
    handlerRef.current = handler;
  });
  return (0, import_react3.useCallback)(function() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return handlerRef.current == null ? void 0 : handlerRef.current(...args);
  }, []);
}
function useInterval() {
  const intervalRef = (0, import_react3.useRef)(null);
  const set4 = (0, import_react3.useCallback)((listener, duration) => {
    intervalRef.current = setInterval(listener, duration);
  }, []);
  const clear = (0, import_react3.useCallback)(() => {
    if (intervalRef.current !== null) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  }, []);
  return [set4, clear];
}
function useLatestValue(value, dependencies) {
  if (dependencies === void 0) {
    dependencies = [value];
  }
  const valueRef = (0, import_react3.useRef)(value);
  useIsomorphicLayoutEffect(() => {
    if (valueRef.current !== value) {
      valueRef.current = value;
    }
  }, dependencies);
  return valueRef;
}
function useLazyMemo(callback, dependencies) {
  const valueRef = (0, import_react3.useRef)();
  return (0, import_react3.useMemo)(
    () => {
      const newValue = callback(valueRef.current);
      valueRef.current = newValue;
      return newValue;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [...dependencies]
  );
}
function useNodeRef(onChange) {
  const onChangeHandler = useEvent(onChange);
  const node2 = (0, import_react3.useRef)(null);
  const setNodeRef = (0, import_react3.useCallback)(
    (element) => {
      if (element !== node2.current) {
        onChangeHandler == null ? void 0 : onChangeHandler(element, node2.current);
      }
      node2.current = element;
    },
    //eslint-disable-next-line
    []
  );
  return [node2, setNodeRef];
}
function usePrevious(value) {
  const ref3 = (0, import_react3.useRef)();
  (0, import_react3.useEffect)(() => {
    ref3.current = value;
  }, [value]);
  return ref3.current;
}
var ids = {};
function useUniqueId(prefix3, value) {
  return (0, import_react3.useMemo)(() => {
    if (value) {
      return value;
    }
    const id = ids[prefix3] == null ? 0 : ids[prefix3] + 1;
    ids[prefix3] = id;
    return prefix3 + "-" + id;
  }, [prefix3, value]);
}
function createAdjustmentFn(modifier) {
  return function(object4) {
    for (var _len = arguments.length, adjustments = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      adjustments[_key - 1] = arguments[_key];
    }
    return adjustments.reduce((accumulator, adjustment) => {
      const entries = Object.entries(adjustment);
      for (const [key2, valueAdjustment] of entries) {
        const value = accumulator[key2];
        if (value != null) {
          accumulator[key2] = value + modifier * valueAdjustment;
        }
      }
      return accumulator;
    }, {
      ...object4
    });
  };
}
var add = /* @__PURE__ */ createAdjustmentFn(1);
var subtract = /* @__PURE__ */ createAdjustmentFn(-1);
function hasViewportRelativeCoordinates(event) {
  return "clientX" in event && "clientY" in event;
}
function isKeyboardEvent(event) {
  if (!event) {
    return false;
  }
  const {
    KeyboardEvent
  } = getWindow(event.target);
  return KeyboardEvent && event instanceof KeyboardEvent;
}
function isTouchEvent(event) {
  if (!event) {
    return false;
  }
  const {
    TouchEvent
  } = getWindow(event.target);
  return TouchEvent && event instanceof TouchEvent;
}
function getEventCoordinates(event) {
  if (isTouchEvent(event)) {
    if (event.touches && event.touches.length) {
      const {
        clientX: x,
        clientY: y
      } = event.touches[0];
      return {
        x,
        y
      };
    } else if (event.changedTouches && event.changedTouches.length) {
      const {
        clientX: x,
        clientY: y
      } = event.changedTouches[0];
      return {
        x,
        y
      };
    }
  }
  if (hasViewportRelativeCoordinates(event)) {
    return {
      x: event.clientX,
      y: event.clientY
    };
  }
  return null;
}
var CSS2 = /* @__PURE__ */ Object.freeze({
  Translate: {
    toString(transform) {
      if (!transform) {
        return;
      }
      const {
        x,
        y
      } = transform;
      return "translate3d(" + (x ? Math.round(x) : 0) + "px, " + (y ? Math.round(y) : 0) + "px, 0)";
    }
  },
  Scale: {
    toString(transform) {
      if (!transform) {
        return;
      }
      const {
        scaleX,
        scaleY
      } = transform;
      return "scaleX(" + scaleX + ") scaleY(" + scaleY + ")";
    }
  },
  Transform: {
    toString(transform) {
      if (!transform) {
        return;
      }
      return [CSS2.Translate.toString(transform), CSS2.Scale.toString(transform)].join(" ");
    }
  },
  Transition: {
    toString(_ref) {
      let {
        property: property2,
        duration,
        easing
      } = _ref;
      return property2 + " " + duration + "ms " + easing;
    }
  }
});
var SELECTOR = "a,frame,iframe,input:not([type=hidden]):not(:disabled),select:not(:disabled),textarea:not(:disabled),button:not(:disabled),*[tabindex]";
function findFirstFocusableNode(element) {
  if (element.matches(SELECTOR)) {
    return element;
  }
  return element.querySelector(SELECTOR);
}

// ../../node_modules/@dnd-kit/accessibility/dist/accessibility.esm.js
var import_react4 = __toESM(require_react());
var hiddenStyles = {
  display: "none"
};
function HiddenText(_ref) {
  let {
    id,
    value
  } = _ref;
  return import_react4.default.createElement("div", {
    id,
    style: hiddenStyles
  }, value);
}
function LiveRegion(_ref) {
  let {
    id,
    announcement,
    ariaLiveType = "assertive"
  } = _ref;
  const visuallyHidden = {
    position: "fixed",
    top: 0,
    left: 0,
    width: 1,
    height: 1,
    margin: -1,
    border: 0,
    padding: 0,
    overflow: "hidden",
    clip: "rect(0 0 0 0)",
    clipPath: "inset(100%)",
    whiteSpace: "nowrap"
  };
  return import_react4.default.createElement("div", {
    id,
    style: visuallyHidden,
    role: "status",
    "aria-live": ariaLiveType,
    "aria-atomic": true
  }, announcement);
}
function useAnnouncement() {
  const [announcement, setAnnouncement] = (0, import_react4.useState)("");
  const announce = (0, import_react4.useCallback)((value) => {
    if (value != null) {
      setAnnouncement(value);
    }
  }, []);
  return {
    announce,
    announcement
  };
}

// ../../node_modules/@dnd-kit/core/dist/core.esm.js
var DndMonitorContext = /* @__PURE__ */ (0, import_react5.createContext)(null);
function useDndMonitor(listener) {
  const registerListener = (0, import_react5.useContext)(DndMonitorContext);
  (0, import_react5.useEffect)(() => {
    if (!registerListener) {
      throw new Error("useDndMonitor must be used within a children of <DndContext>");
    }
    const unsubscribe = registerListener(listener);
    return unsubscribe;
  }, [listener, registerListener]);
}
function useDndMonitorProvider() {
  const [listeners] = (0, import_react5.useState)(() => /* @__PURE__ */ new Set());
  const registerListener = (0, import_react5.useCallback)((listener) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
  }, [listeners]);
  const dispatch2 = (0, import_react5.useCallback)((_ref) => {
    let {
      type: type5,
      event
    } = _ref;
    listeners.forEach((listener) => {
      var _listener$type;
      return (_listener$type = listener[type5]) == null ? void 0 : _listener$type.call(listener, event);
    });
  }, [listeners]);
  return [dispatch2, registerListener];
}
var defaultScreenReaderInstructions = {
  draggable: "\n    To pick up a draggable item, press the space bar.\n    While dragging, use the arrow keys to move the item.\n    Press space again to drop the item in its new position, or press escape to cancel.\n  "
};
var defaultAnnouncements = {
  onDragStart(_ref) {
    let {
      active
    } = _ref;
    return "Picked up draggable item " + active.id + ".";
  },
  onDragOver(_ref2) {
    let {
      active,
      over
    } = _ref2;
    if (over) {
      return "Draggable item " + active.id + " was moved over droppable area " + over.id + ".";
    }
    return "Draggable item " + active.id + " is no longer over a droppable area.";
  },
  onDragEnd(_ref3) {
    let {
      active,
      over
    } = _ref3;
    if (over) {
      return "Draggable item " + active.id + " was dropped over droppable area " + over.id;
    }
    return "Draggable item " + active.id + " was dropped.";
  },
  onDragCancel(_ref4) {
    let {
      active
    } = _ref4;
    return "Dragging was cancelled. Draggable item " + active.id + " was dropped.";
  }
};
function Accessibility(_ref) {
  let {
    announcements = defaultAnnouncements,
    container,
    hiddenTextDescribedById,
    screenReaderInstructions = defaultScreenReaderInstructions
  } = _ref;
  const {
    announce,
    announcement
  } = useAnnouncement();
  const liveRegionId = useUniqueId("DndLiveRegion");
  const [mounted, setMounted] = (0, import_react5.useState)(false);
  (0, import_react5.useEffect)(() => {
    setMounted(true);
  }, []);
  useDndMonitor((0, import_react5.useMemo)(() => ({
    onDragStart(_ref2) {
      let {
        active
      } = _ref2;
      announce(announcements.onDragStart({
        active
      }));
    },
    onDragMove(_ref3) {
      let {
        active,
        over
      } = _ref3;
      if (announcements.onDragMove) {
        announce(announcements.onDragMove({
          active,
          over
        }));
      }
    },
    onDragOver(_ref4) {
      let {
        active,
        over
      } = _ref4;
      announce(announcements.onDragOver({
        active,
        over
      }));
    },
    onDragEnd(_ref5) {
      let {
        active,
        over
      } = _ref5;
      announce(announcements.onDragEnd({
        active,
        over
      }));
    },
    onDragCancel(_ref6) {
      let {
        active,
        over
      } = _ref6;
      announce(announcements.onDragCancel({
        active,
        over
      }));
    }
  }), [announce, announcements]));
  if (!mounted) {
    return null;
  }
  const markup = import_react5.default.createElement(import_react5.default.Fragment, null, import_react5.default.createElement(HiddenText, {
    id: hiddenTextDescribedById,
    value: screenReaderInstructions.draggable
  }), import_react5.default.createElement(LiveRegion, {
    id: liveRegionId,
    announcement
  }));
  return container ? (0, import_react_dom2.createPortal)(markup, container) : markup;
}
var Action;
(function(Action2) {
  Action2["DragStart"] = "dragStart";
  Action2["DragMove"] = "dragMove";
  Action2["DragEnd"] = "dragEnd";
  Action2["DragCancel"] = "dragCancel";
  Action2["DragOver"] = "dragOver";
  Action2["RegisterDroppable"] = "registerDroppable";
  Action2["SetDroppableDisabled"] = "setDroppableDisabled";
  Action2["UnregisterDroppable"] = "unregisterDroppable";
})(Action || (Action = {}));
function noop() {
}
function useSensor(sensor, options) {
  return (0, import_react5.useMemo)(
    () => ({
      sensor,
      options: options != null ? options : {}
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [sensor, options]
  );
}
function useSensors() {
  for (var _len = arguments.length, sensors = new Array(_len), _key = 0; _key < _len; _key++) {
    sensors[_key] = arguments[_key];
  }
  return (0, import_react5.useMemo)(
    () => [...sensors].filter((sensor) => sensor != null),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [...sensors]
  );
}
var defaultCoordinates = /* @__PURE__ */ Object.freeze({
  x: 0,
  y: 0
});
function distanceBetween(p1, p2) {
  return Math.sqrt(Math.pow(p1.x - p2.x, 2) + Math.pow(p1.y - p2.y, 2));
}
function getRelativeTransformOrigin(event, rect) {
  const eventCoordinates = getEventCoordinates(event);
  if (!eventCoordinates) {
    return "0 0";
  }
  const transformOrigin = {
    x: (eventCoordinates.x - rect.left) / rect.width * 100,
    y: (eventCoordinates.y - rect.top) / rect.height * 100
  };
  return transformOrigin.x + "% " + transformOrigin.y + "%";
}
function sortCollisionsAsc(_ref, _ref2) {
  let {
    data: {
      value: a
    }
  } = _ref;
  let {
    data: {
      value: b
    }
  } = _ref2;
  return a - b;
}
function sortCollisionsDesc(_ref3, _ref4) {
  let {
    data: {
      value: a
    }
  } = _ref3;
  let {
    data: {
      value: b
    }
  } = _ref4;
  return b - a;
}
function cornersOfRectangle(_ref5) {
  let {
    left: left2,
    top,
    height,
    width
  } = _ref5;
  return [{
    x: left2,
    y: top
  }, {
    x: left2 + width,
    y: top
  }, {
    x: left2,
    y: top + height
  }, {
    x: left2 + width,
    y: top + height
  }];
}
function getFirstCollision(collisions, property2) {
  if (!collisions || collisions.length === 0) {
    return null;
  }
  const [firstCollision] = collisions;
  return property2 ? firstCollision[property2] : firstCollision;
}
var closestCorners = (_ref) => {
  let {
    collisionRect,
    droppableRects,
    droppableContainers
  } = _ref;
  const corners = cornersOfRectangle(collisionRect);
  const collisions = [];
  for (const droppableContainer of droppableContainers) {
    const {
      id
    } = droppableContainer;
    const rect = droppableRects.get(id);
    if (rect) {
      const rectCorners = cornersOfRectangle(rect);
      const distances = corners.reduce((accumulator, corner, index3) => {
        return accumulator + distanceBetween(rectCorners[index3], corner);
      }, 0);
      const effectiveDistance = Number((distances / 4).toFixed(4));
      collisions.push({
        id,
        data: {
          droppableContainer,
          value: effectiveDistance
        }
      });
    }
  }
  return collisions.sort(sortCollisionsAsc);
};
function getIntersectionRatio(entry, target) {
  const top = Math.max(target.top, entry.top);
  const left2 = Math.max(target.left, entry.left);
  const right2 = Math.min(target.left + target.width, entry.left + entry.width);
  const bottom = Math.min(target.top + target.height, entry.top + entry.height);
  const width = right2 - left2;
  const height = bottom - top;
  if (left2 < right2 && top < bottom) {
    const targetArea = target.width * target.height;
    const entryArea = entry.width * entry.height;
    const intersectionArea = width * height;
    const intersectionRatio = intersectionArea / (targetArea + entryArea - intersectionArea);
    return Number(intersectionRatio.toFixed(4));
  }
  return 0;
}
var rectIntersection = (_ref) => {
  let {
    collisionRect,
    droppableRects,
    droppableContainers
  } = _ref;
  const collisions = [];
  for (const droppableContainer of droppableContainers) {
    const {
      id
    } = droppableContainer;
    const rect = droppableRects.get(id);
    if (rect) {
      const intersectionRatio = getIntersectionRatio(rect, collisionRect);
      if (intersectionRatio > 0) {
        collisions.push({
          id,
          data: {
            droppableContainer,
            value: intersectionRatio
          }
        });
      }
    }
  }
  return collisions.sort(sortCollisionsDesc);
};
function adjustScale(transform, rect1, rect2) {
  return {
    ...transform,
    scaleX: rect1 && rect2 ? rect1.width / rect2.width : 1,
    scaleY: rect1 && rect2 ? rect1.height / rect2.height : 1
  };
}
function getRectDelta(rect1, rect2) {
  return rect1 && rect2 ? {
    x: rect1.left - rect2.left,
    y: rect1.top - rect2.top
  } : defaultCoordinates;
}
function createRectAdjustmentFn(modifier) {
  return function adjustClientRect(rect) {
    for (var _len = arguments.length, adjustments = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      adjustments[_key - 1] = arguments[_key];
    }
    return adjustments.reduce((acc, adjustment) => ({
      ...acc,
      top: acc.top + modifier * adjustment.y,
      bottom: acc.bottom + modifier * adjustment.y,
      left: acc.left + modifier * adjustment.x,
      right: acc.right + modifier * adjustment.x
    }), {
      ...rect
    });
  };
}
var getAdjustedRect = /* @__PURE__ */ createRectAdjustmentFn(1);
function parseTransform(transform) {
  if (transform.startsWith("matrix3d(")) {
    const transformArray = transform.slice(9, -1).split(/, /);
    return {
      x: +transformArray[12],
      y: +transformArray[13],
      scaleX: +transformArray[0],
      scaleY: +transformArray[5]
    };
  } else if (transform.startsWith("matrix(")) {
    const transformArray = transform.slice(7, -1).split(/, /);
    return {
      x: +transformArray[4],
      y: +transformArray[5],
      scaleX: +transformArray[0],
      scaleY: +transformArray[3]
    };
  }
  return null;
}
function inverseTransform(rect, transform, transformOrigin) {
  const parsedTransform = parseTransform(transform);
  if (!parsedTransform) {
    return rect;
  }
  const {
    scaleX,
    scaleY,
    x: translateX,
    y: translateY
  } = parsedTransform;
  const x = rect.left - translateX - (1 - scaleX) * parseFloat(transformOrigin);
  const y = rect.top - translateY - (1 - scaleY) * parseFloat(transformOrigin.slice(transformOrigin.indexOf(" ") + 1));
  const w = scaleX ? rect.width / scaleX : rect.width;
  const h2 = scaleY ? rect.height / scaleY : rect.height;
  return {
    width: w,
    height: h2,
    top: y,
    right: x + w,
    bottom: y + h2,
    left: x
  };
}
var defaultOptions2 = {
  ignoreTransform: false
};
function getClientRect(element, options) {
  if (options === void 0) {
    options = defaultOptions2;
  }
  let rect = element.getBoundingClientRect();
  if (options.ignoreTransform) {
    const {
      transform,
      transformOrigin
    } = getWindow(element).getComputedStyle(element);
    if (transform) {
      rect = inverseTransform(rect, transform, transformOrigin);
    }
  }
  const {
    top,
    left: left2,
    width,
    height,
    bottom,
    right: right2
  } = rect;
  return {
    top,
    left: left2,
    width,
    height,
    bottom,
    right: right2
  };
}
function getTransformAgnosticClientRect(element) {
  return getClientRect(element, {
    ignoreTransform: true
  });
}
function getWindowClientRect(element) {
  const width = element.innerWidth;
  const height = element.innerHeight;
  return {
    top: 0,
    left: 0,
    right: width,
    bottom: height,
    width,
    height
  };
}
function isFixed(node2, computedStyle) {
  if (computedStyle === void 0) {
    computedStyle = getWindow(node2).getComputedStyle(node2);
  }
  return computedStyle.position === "fixed";
}
function isScrollable(element, computedStyle) {
  if (computedStyle === void 0) {
    computedStyle = getWindow(element).getComputedStyle(element);
  }
  const overflowRegex = /(auto|scroll|overlay)/;
  const properties2 = ["overflow", "overflowX", "overflowY"];
  return properties2.some((property2) => {
    const value = computedStyle[property2];
    return typeof value === "string" ? overflowRegex.test(value) : false;
  });
}
function getScrollableAncestors(element, limit) {
  const scrollParents = [];
  function findScrollableAncestors(node2) {
    if (limit != null && scrollParents.length >= limit) {
      return scrollParents;
    }
    if (!node2) {
      return scrollParents;
    }
    if (isDocument(node2) && node2.scrollingElement != null && !scrollParents.includes(node2.scrollingElement)) {
      scrollParents.push(node2.scrollingElement);
      return scrollParents;
    }
    if (!isHTMLElement(node2) || isSVGElement(node2)) {
      return scrollParents;
    }
    if (scrollParents.includes(node2)) {
      return scrollParents;
    }
    const computedStyle = getWindow(element).getComputedStyle(node2);
    if (node2 !== element) {
      if (isScrollable(node2, computedStyle)) {
        scrollParents.push(node2);
      }
    }
    if (isFixed(node2, computedStyle)) {
      return scrollParents;
    }
    return findScrollableAncestors(node2.parentNode);
  }
  if (!element) {
    return scrollParents;
  }
  return findScrollableAncestors(element);
}
function getFirstScrollableAncestor(node2) {
  const [firstScrollableAncestor] = getScrollableAncestors(node2, 1);
  return firstScrollableAncestor != null ? firstScrollableAncestor : null;
}
function getScrollableElement(element) {
  if (!canUseDOM || !element) {
    return null;
  }
  if (isWindow(element)) {
    return element;
  }
  if (!isNode(element)) {
    return null;
  }
  if (isDocument(element) || element === getOwnerDocument(element).scrollingElement) {
    return window;
  }
  if (isHTMLElement(element)) {
    return element;
  }
  return null;
}
function getScrollXCoordinate(element) {
  if (isWindow(element)) {
    return element.scrollX;
  }
  return element.scrollLeft;
}
function getScrollYCoordinate(element) {
  if (isWindow(element)) {
    return element.scrollY;
  }
  return element.scrollTop;
}
function getScrollCoordinates(element) {
  return {
    x: getScrollXCoordinate(element),
    y: getScrollYCoordinate(element)
  };
}
var Direction;
(function(Direction2) {
  Direction2[Direction2["Forward"] = 1] = "Forward";
  Direction2[Direction2["Backward"] = -1] = "Backward";
})(Direction || (Direction = {}));
function isDocumentScrollingElement(element) {
  if (!canUseDOM || !element) {
    return false;
  }
  return element === document.scrollingElement;
}
function getScrollPosition(scrollingContainer) {
  const minScroll = {
    x: 0,
    y: 0
  };
  const dimensions = isDocumentScrollingElement(scrollingContainer) ? {
    height: window.innerHeight,
    width: window.innerWidth
  } : {
    height: scrollingContainer.clientHeight,
    width: scrollingContainer.clientWidth
  };
  const maxScroll = {
    x: scrollingContainer.scrollWidth - dimensions.width,
    y: scrollingContainer.scrollHeight - dimensions.height
  };
  const isTop = scrollingContainer.scrollTop <= minScroll.y;
  const isLeft = scrollingContainer.scrollLeft <= minScroll.x;
  const isBottom = scrollingContainer.scrollTop >= maxScroll.y;
  const isRight = scrollingContainer.scrollLeft >= maxScroll.x;
  return {
    isTop,
    isLeft,
    isBottom,
    isRight,
    maxScroll,
    minScroll
  };
}
var defaultThreshold = {
  x: 0.2,
  y: 0.2
};
function getScrollDirectionAndSpeed(scrollContainer, scrollContainerRect, _ref, acceleration, thresholdPercentage) {
  let {
    top,
    left: left2,
    right: right2,
    bottom
  } = _ref;
  if (acceleration === void 0) {
    acceleration = 10;
  }
  if (thresholdPercentage === void 0) {
    thresholdPercentage = defaultThreshold;
  }
  const {
    isTop,
    isBottom,
    isLeft,
    isRight
  } = getScrollPosition(scrollContainer);
  const direction = {
    x: 0,
    y: 0
  };
  const speed = {
    x: 0,
    y: 0
  };
  const threshold = {
    height: scrollContainerRect.height * thresholdPercentage.y,
    width: scrollContainerRect.width * thresholdPercentage.x
  };
  if (!isTop && top <= scrollContainerRect.top + threshold.height) {
    direction.y = Direction.Backward;
    speed.y = acceleration * Math.abs((scrollContainerRect.top + threshold.height - top) / threshold.height);
  } else if (!isBottom && bottom >= scrollContainerRect.bottom - threshold.height) {
    direction.y = Direction.Forward;
    speed.y = acceleration * Math.abs((scrollContainerRect.bottom - threshold.height - bottom) / threshold.height);
  }
  if (!isRight && right2 >= scrollContainerRect.right - threshold.width) {
    direction.x = Direction.Forward;
    speed.x = acceleration * Math.abs((scrollContainerRect.right - threshold.width - right2) / threshold.width);
  } else if (!isLeft && left2 <= scrollContainerRect.left + threshold.width) {
    direction.x = Direction.Backward;
    speed.x = acceleration * Math.abs((scrollContainerRect.left + threshold.width - left2) / threshold.width);
  }
  return {
    direction,
    speed
  };
}
function getScrollElementRect(element) {
  if (element === document.scrollingElement) {
    const {
      innerWidth: innerWidth2,
      innerHeight: innerHeight2
    } = window;
    return {
      top: 0,
      left: 0,
      right: innerWidth2,
      bottom: innerHeight2,
      width: innerWidth2,
      height: innerHeight2
    };
  }
  const {
    top,
    left: left2,
    right: right2,
    bottom
  } = element.getBoundingClientRect();
  return {
    top,
    left: left2,
    right: right2,
    bottom,
    width: element.clientWidth,
    height: element.clientHeight
  };
}
function getScrollOffsets(scrollableAncestors) {
  return scrollableAncestors.reduce((acc, node2) => {
    return add(acc, getScrollCoordinates(node2));
  }, defaultCoordinates);
}
function getScrollXOffset(scrollableAncestors) {
  return scrollableAncestors.reduce((acc, node2) => {
    return acc + getScrollXCoordinate(node2);
  }, 0);
}
function getScrollYOffset(scrollableAncestors) {
  return scrollableAncestors.reduce((acc, node2) => {
    return acc + getScrollYCoordinate(node2);
  }, 0);
}
function scrollIntoViewIfNeeded(element, measure) {
  if (measure === void 0) {
    measure = getClientRect;
  }
  if (!element) {
    return;
  }
  const {
    top,
    left: left2,
    bottom,
    right: right2
  } = measure(element);
  const firstScrollableAncestor = getFirstScrollableAncestor(element);
  if (!firstScrollableAncestor) {
    return;
  }
  if (bottom <= 0 || right2 <= 0 || top >= window.innerHeight || left2 >= window.innerWidth) {
    element.scrollIntoView({
      block: "center",
      inline: "center"
    });
  }
}
var properties = [["x", ["left", "right"], getScrollXOffset], ["y", ["top", "bottom"], getScrollYOffset]];
var Rect = class {
  constructor(rect, element) {
    this.rect = void 0;
    this.width = void 0;
    this.height = void 0;
    this.top = void 0;
    this.bottom = void 0;
    this.right = void 0;
    this.left = void 0;
    const scrollableAncestors = getScrollableAncestors(element);
    const scrollOffsets = getScrollOffsets(scrollableAncestors);
    this.rect = {
      ...rect
    };
    this.width = rect.width;
    this.height = rect.height;
    for (const [axis, keys4, getScrollOffset] of properties) {
      for (const key2 of keys4) {
        Object.defineProperty(this, key2, {
          get: () => {
            const currentOffsets = getScrollOffset(scrollableAncestors);
            const scrollOffsetsDeltla = scrollOffsets[axis] - currentOffsets;
            return this.rect[key2] + scrollOffsetsDeltla;
          },
          enumerable: true
        });
      }
    }
    Object.defineProperty(this, "rect", {
      enumerable: false
    });
  }
};
var Listeners = class {
  constructor(target) {
    this.target = void 0;
    this.listeners = [];
    this.removeAll = () => {
      this.listeners.forEach((listener) => {
        var _this$target;
        return (_this$target = this.target) == null ? void 0 : _this$target.removeEventListener(...listener);
      });
    };
    this.target = target;
  }
  add(eventName, handler, options) {
    var _this$target2;
    (_this$target2 = this.target) == null ? void 0 : _this$target2.addEventListener(eventName, handler, options);
    this.listeners.push([eventName, handler, options]);
  }
};
function getEventListenerTarget(target) {
  const {
    EventTarget
  } = getWindow(target);
  return target instanceof EventTarget ? target : getOwnerDocument(target);
}
function hasExceededDistance(delta, measurement) {
  const dx = Math.abs(delta.x);
  const dy = Math.abs(delta.y);
  if (typeof measurement === "number") {
    return Math.sqrt(dx ** 2 + dy ** 2) > measurement;
  }
  if ("x" in measurement && "y" in measurement) {
    return dx > measurement.x && dy > measurement.y;
  }
  if ("x" in measurement) {
    return dx > measurement.x;
  }
  if ("y" in measurement) {
    return dy > measurement.y;
  }
  return false;
}
var EventName;
(function(EventName2) {
  EventName2["Click"] = "click";
  EventName2["DragStart"] = "dragstart";
  EventName2["Keydown"] = "keydown";
  EventName2["ContextMenu"] = "contextmenu";
  EventName2["Resize"] = "resize";
  EventName2["SelectionChange"] = "selectionchange";
  EventName2["VisibilityChange"] = "visibilitychange";
})(EventName || (EventName = {}));
function preventDefault(event) {
  event.preventDefault();
}
function stopPropagation(event) {
  event.stopPropagation();
}
var KeyboardCode;
(function(KeyboardCode2) {
  KeyboardCode2["Space"] = "Space";
  KeyboardCode2["Down"] = "ArrowDown";
  KeyboardCode2["Right"] = "ArrowRight";
  KeyboardCode2["Left"] = "ArrowLeft";
  KeyboardCode2["Up"] = "ArrowUp";
  KeyboardCode2["Esc"] = "Escape";
  KeyboardCode2["Enter"] = "Enter";
  KeyboardCode2["Tab"] = "Tab";
})(KeyboardCode || (KeyboardCode = {}));
var defaultKeyboardCodes = {
  start: [KeyboardCode.Space, KeyboardCode.Enter],
  cancel: [KeyboardCode.Esc],
  end: [KeyboardCode.Space, KeyboardCode.Enter, KeyboardCode.Tab]
};
var defaultKeyboardCoordinateGetter = (event, _ref) => {
  let {
    currentCoordinates
  } = _ref;
  switch (event.code) {
    case KeyboardCode.Right:
      return {
        ...currentCoordinates,
        x: currentCoordinates.x + 25
      };
    case KeyboardCode.Left:
      return {
        ...currentCoordinates,
        x: currentCoordinates.x - 25
      };
    case KeyboardCode.Down:
      return {
        ...currentCoordinates,
        y: currentCoordinates.y + 25
      };
    case KeyboardCode.Up:
      return {
        ...currentCoordinates,
        y: currentCoordinates.y - 25
      };
  }
  return void 0;
};
var KeyboardSensor = class {
  constructor(props) {
    this.props = void 0;
    this.autoScrollEnabled = false;
    this.referenceCoordinates = void 0;
    this.listeners = void 0;
    this.windowListeners = void 0;
    this.props = props;
    const {
      event: {
        target
      }
    } = props;
    this.props = props;
    this.listeners = new Listeners(getOwnerDocument(target));
    this.windowListeners = new Listeners(getWindow(target));
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.attach();
  }
  attach() {
    this.handleStart();
    this.windowListeners.add(EventName.Resize, this.handleCancel);
    this.windowListeners.add(EventName.VisibilityChange, this.handleCancel);
    setTimeout(() => this.listeners.add(EventName.Keydown, this.handleKeyDown));
  }
  handleStart() {
    const {
      activeNode,
      onStart
    } = this.props;
    const node2 = activeNode.node.current;
    if (node2) {
      scrollIntoViewIfNeeded(node2);
    }
    onStart(defaultCoordinates);
  }
  handleKeyDown(event) {
    if (isKeyboardEvent(event)) {
      const {
        active,
        context,
        options
      } = this.props;
      const {
        keyboardCodes = defaultKeyboardCodes,
        coordinateGetter = defaultKeyboardCoordinateGetter,
        scrollBehavior = "smooth"
      } = options;
      const {
        code: code2
      } = event;
      if (keyboardCodes.end.includes(code2)) {
        this.handleEnd(event);
        return;
      }
      if (keyboardCodes.cancel.includes(code2)) {
        this.handleCancel(event);
        return;
      }
      const {
        collisionRect
      } = context.current;
      const currentCoordinates = collisionRect ? {
        x: collisionRect.left,
        y: collisionRect.top
      } : defaultCoordinates;
      if (!this.referenceCoordinates) {
        this.referenceCoordinates = currentCoordinates;
      }
      const newCoordinates = coordinateGetter(event, {
        active,
        context: context.current,
        currentCoordinates
      });
      if (newCoordinates) {
        const coordinatesDelta = subtract(newCoordinates, currentCoordinates);
        const scrollDelta = {
          x: 0,
          y: 0
        };
        const {
          scrollableAncestors
        } = context.current;
        for (const scrollContainer of scrollableAncestors) {
          const direction = event.code;
          const {
            isTop,
            isRight,
            isLeft,
            isBottom,
            maxScroll,
            minScroll
          } = getScrollPosition(scrollContainer);
          const scrollElementRect = getScrollElementRect(scrollContainer);
          const clampedCoordinates = {
            x: Math.min(direction === KeyboardCode.Right ? scrollElementRect.right - scrollElementRect.width / 2 : scrollElementRect.right, Math.max(direction === KeyboardCode.Right ? scrollElementRect.left : scrollElementRect.left + scrollElementRect.width / 2, newCoordinates.x)),
            y: Math.min(direction === KeyboardCode.Down ? scrollElementRect.bottom - scrollElementRect.height / 2 : scrollElementRect.bottom, Math.max(direction === KeyboardCode.Down ? scrollElementRect.top : scrollElementRect.top + scrollElementRect.height / 2, newCoordinates.y))
          };
          const canScrollX = direction === KeyboardCode.Right && !isRight || direction === KeyboardCode.Left && !isLeft;
          const canScrollY = direction === KeyboardCode.Down && !isBottom || direction === KeyboardCode.Up && !isTop;
          if (canScrollX && clampedCoordinates.x !== newCoordinates.x) {
            const newScrollCoordinates = scrollContainer.scrollLeft + coordinatesDelta.x;
            const canScrollToNewCoordinates = direction === KeyboardCode.Right && newScrollCoordinates <= maxScroll.x || direction === KeyboardCode.Left && newScrollCoordinates >= minScroll.x;
            if (canScrollToNewCoordinates && !coordinatesDelta.y) {
              scrollContainer.scrollTo({
                left: newScrollCoordinates,
                behavior: scrollBehavior
              });
              return;
            }
            if (canScrollToNewCoordinates) {
              scrollDelta.x = scrollContainer.scrollLeft - newScrollCoordinates;
            } else {
              scrollDelta.x = direction === KeyboardCode.Right ? scrollContainer.scrollLeft - maxScroll.x : scrollContainer.scrollLeft - minScroll.x;
            }
            if (scrollDelta.x) {
              scrollContainer.scrollBy({
                left: -scrollDelta.x,
                behavior: scrollBehavior
              });
            }
            break;
          } else if (canScrollY && clampedCoordinates.y !== newCoordinates.y) {
            const newScrollCoordinates = scrollContainer.scrollTop + coordinatesDelta.y;
            const canScrollToNewCoordinates = direction === KeyboardCode.Down && newScrollCoordinates <= maxScroll.y || direction === KeyboardCode.Up && newScrollCoordinates >= minScroll.y;
            if (canScrollToNewCoordinates && !coordinatesDelta.x) {
              scrollContainer.scrollTo({
                top: newScrollCoordinates,
                behavior: scrollBehavior
              });
              return;
            }
            if (canScrollToNewCoordinates) {
              scrollDelta.y = scrollContainer.scrollTop - newScrollCoordinates;
            } else {
              scrollDelta.y = direction === KeyboardCode.Down ? scrollContainer.scrollTop - maxScroll.y : scrollContainer.scrollTop - minScroll.y;
            }
            if (scrollDelta.y) {
              scrollContainer.scrollBy({
                top: -scrollDelta.y,
                behavior: scrollBehavior
              });
            }
            break;
          }
        }
        this.handleMove(event, add(subtract(newCoordinates, this.referenceCoordinates), scrollDelta));
      }
    }
  }
  handleMove(event, coordinates) {
    const {
      onMove
    } = this.props;
    event.preventDefault();
    onMove(coordinates);
  }
  handleEnd(event) {
    const {
      onEnd
    } = this.props;
    event.preventDefault();
    this.detach();
    onEnd();
  }
  handleCancel(event) {
    const {
      onCancel
    } = this.props;
    event.preventDefault();
    this.detach();
    onCancel();
  }
  detach() {
    this.listeners.removeAll();
    this.windowListeners.removeAll();
  }
};
KeyboardSensor.activators = [{
  eventName: "onKeyDown",
  handler: (event, _ref, _ref2) => {
    let {
      keyboardCodes = defaultKeyboardCodes,
      onActivation
    } = _ref;
    let {
      active
    } = _ref2;
    const {
      code: code2
    } = event.nativeEvent;
    if (keyboardCodes.start.includes(code2)) {
      const activator = active.activatorNode.current;
      if (activator && event.target !== activator) {
        return false;
      }
      event.preventDefault();
      onActivation == null ? void 0 : onActivation({
        event: event.nativeEvent
      });
      return true;
    }
    return false;
  }
}];
function isDistanceConstraint(constraint) {
  return Boolean(constraint && "distance" in constraint);
}
function isDelayConstraint(constraint) {
  return Boolean(constraint && "delay" in constraint);
}
var AbstractPointerSensor = class {
  constructor(props, events2, listenerTarget) {
    var _getEventCoordinates;
    if (listenerTarget === void 0) {
      listenerTarget = getEventListenerTarget(props.event.target);
    }
    this.props = void 0;
    this.events = void 0;
    this.autoScrollEnabled = true;
    this.document = void 0;
    this.activated = false;
    this.initialCoordinates = void 0;
    this.timeoutId = null;
    this.listeners = void 0;
    this.documentListeners = void 0;
    this.windowListeners = void 0;
    this.props = props;
    this.events = events2;
    const {
      event
    } = props;
    const {
      target
    } = event;
    this.props = props;
    this.events = events2;
    this.document = getOwnerDocument(target);
    this.documentListeners = new Listeners(this.document);
    this.listeners = new Listeners(listenerTarget);
    this.windowListeners = new Listeners(getWindow(target));
    this.initialCoordinates = (_getEventCoordinates = getEventCoordinates(event)) != null ? _getEventCoordinates : defaultCoordinates;
    this.handleStart = this.handleStart.bind(this);
    this.handleMove = this.handleMove.bind(this);
    this.handleEnd = this.handleEnd.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);
    this.removeTextSelection = this.removeTextSelection.bind(this);
    this.attach();
  }
  attach() {
    const {
      events: events2,
      props: {
        options: {
          activationConstraint,
          bypassActivationConstraint
        }
      }
    } = this;
    this.listeners.add(events2.move.name, this.handleMove, {
      passive: false
    });
    this.listeners.add(events2.end.name, this.handleEnd);
    if (events2.cancel) {
      this.listeners.add(events2.cancel.name, this.handleCancel);
    }
    this.windowListeners.add(EventName.Resize, this.handleCancel);
    this.windowListeners.add(EventName.DragStart, preventDefault);
    this.windowListeners.add(EventName.VisibilityChange, this.handleCancel);
    this.windowListeners.add(EventName.ContextMenu, preventDefault);
    this.documentListeners.add(EventName.Keydown, this.handleKeydown);
    if (activationConstraint) {
      if (bypassActivationConstraint != null && bypassActivationConstraint({
        event: this.props.event,
        activeNode: this.props.activeNode,
        options: this.props.options
      })) {
        return this.handleStart();
      }
      if (isDelayConstraint(activationConstraint)) {
        this.timeoutId = setTimeout(this.handleStart, activationConstraint.delay);
        this.handlePending(activationConstraint);
        return;
      }
      if (isDistanceConstraint(activationConstraint)) {
        this.handlePending(activationConstraint);
        return;
      }
    }
    this.handleStart();
  }
  detach() {
    this.listeners.removeAll();
    this.windowListeners.removeAll();
    setTimeout(this.documentListeners.removeAll, 50);
    if (this.timeoutId !== null) {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }
  }
  handlePending(constraint, offset4) {
    const {
      active,
      onPending
    } = this.props;
    onPending(active, constraint, this.initialCoordinates, offset4);
  }
  handleStart() {
    const {
      initialCoordinates
    } = this;
    const {
      onStart
    } = this.props;
    if (initialCoordinates) {
      this.activated = true;
      this.documentListeners.add(EventName.Click, stopPropagation, {
        capture: true
      });
      this.removeTextSelection();
      this.documentListeners.add(EventName.SelectionChange, this.removeTextSelection);
      onStart(initialCoordinates);
    }
  }
  handleMove(event) {
    var _getEventCoordinates2;
    const {
      activated,
      initialCoordinates,
      props
    } = this;
    const {
      onMove,
      options: {
        activationConstraint
      }
    } = props;
    if (!initialCoordinates) {
      return;
    }
    const coordinates = (_getEventCoordinates2 = getEventCoordinates(event)) != null ? _getEventCoordinates2 : defaultCoordinates;
    const delta = subtract(initialCoordinates, coordinates);
    if (!activated && activationConstraint) {
      if (isDistanceConstraint(activationConstraint)) {
        if (activationConstraint.tolerance != null && hasExceededDistance(delta, activationConstraint.tolerance)) {
          return this.handleCancel();
        }
        if (hasExceededDistance(delta, activationConstraint.distance)) {
          return this.handleStart();
        }
      }
      if (isDelayConstraint(activationConstraint)) {
        if (hasExceededDistance(delta, activationConstraint.tolerance)) {
          return this.handleCancel();
        }
      }
      this.handlePending(activationConstraint, delta);
      return;
    }
    if (event.cancelable) {
      event.preventDefault();
    }
    onMove(coordinates);
  }
  handleEnd() {
    const {
      onAbort,
      onEnd
    } = this.props;
    this.detach();
    if (!this.activated) {
      onAbort(this.props.active);
    }
    onEnd();
  }
  handleCancel() {
    const {
      onAbort,
      onCancel
    } = this.props;
    this.detach();
    if (!this.activated) {
      onAbort(this.props.active);
    }
    onCancel();
  }
  handleKeydown(event) {
    if (event.code === KeyboardCode.Esc) {
      this.handleCancel();
    }
  }
  removeTextSelection() {
    var _this$document$getSel;
    (_this$document$getSel = this.document.getSelection()) == null ? void 0 : _this$document$getSel.removeAllRanges();
  }
};
var events = {
  cancel: {
    name: "pointercancel"
  },
  move: {
    name: "pointermove"
  },
  end: {
    name: "pointerup"
  }
};
var PointerSensor = class extends AbstractPointerSensor {
  constructor(props) {
    const {
      event
    } = props;
    const listenerTarget = getOwnerDocument(event.target);
    super(props, events, listenerTarget);
  }
};
PointerSensor.activators = [{
  eventName: "onPointerDown",
  handler: (_ref, _ref2) => {
    let {
      nativeEvent: event
    } = _ref;
    let {
      onActivation
    } = _ref2;
    if (!event.isPrimary || event.button !== 0) {
      return false;
    }
    onActivation == null ? void 0 : onActivation({
      event
    });
    return true;
  }
}];
var events$1 = {
  move: {
    name: "mousemove"
  },
  end: {
    name: "mouseup"
  }
};
var MouseButton;
(function(MouseButton2) {
  MouseButton2[MouseButton2["RightClick"] = 2] = "RightClick";
})(MouseButton || (MouseButton = {}));
var MouseSensor = class extends AbstractPointerSensor {
  constructor(props) {
    super(props, events$1, getOwnerDocument(props.event.target));
  }
};
MouseSensor.activators = [{
  eventName: "onMouseDown",
  handler: (_ref, _ref2) => {
    let {
      nativeEvent: event
    } = _ref;
    let {
      onActivation
    } = _ref2;
    if (event.button === MouseButton.RightClick) {
      return false;
    }
    onActivation == null ? void 0 : onActivation({
      event
    });
    return true;
  }
}];
var events$2 = {
  cancel: {
    name: "touchcancel"
  },
  move: {
    name: "touchmove"
  },
  end: {
    name: "touchend"
  }
};
var TouchSensor = class extends AbstractPointerSensor {
  constructor(props) {
    super(props, events$2);
  }
  static setup() {
    window.addEventListener(events$2.move.name, noop7, {
      capture: false,
      passive: false
    });
    return function teardown() {
      window.removeEventListener(events$2.move.name, noop7);
    };
    function noop7() {
    }
  }
};
TouchSensor.activators = [{
  eventName: "onTouchStart",
  handler: (_ref, _ref2) => {
    let {
      nativeEvent: event
    } = _ref;
    let {
      onActivation
    } = _ref2;
    const {
      touches
    } = event;
    if (touches.length > 1) {
      return false;
    }
    onActivation == null ? void 0 : onActivation({
      event
    });
    return true;
  }
}];
var AutoScrollActivator;
(function(AutoScrollActivator2) {
  AutoScrollActivator2[AutoScrollActivator2["Pointer"] = 0] = "Pointer";
  AutoScrollActivator2[AutoScrollActivator2["DraggableRect"] = 1] = "DraggableRect";
})(AutoScrollActivator || (AutoScrollActivator = {}));
var TraversalOrder;
(function(TraversalOrder2) {
  TraversalOrder2[TraversalOrder2["TreeOrder"] = 0] = "TreeOrder";
  TraversalOrder2[TraversalOrder2["ReversedTreeOrder"] = 1] = "ReversedTreeOrder";
})(TraversalOrder || (TraversalOrder = {}));
function useAutoScroller(_ref) {
  let {
    acceleration,
    activator = AutoScrollActivator.Pointer,
    canScroll,
    draggingRect,
    enabled,
    interval = 5,
    order = TraversalOrder.TreeOrder,
    pointerCoordinates,
    scrollableAncestors,
    scrollableAncestorRects,
    delta,
    threshold
  } = _ref;
  const scrollIntent = useScrollIntent({
    delta,
    disabled: !enabled
  });
  const [setAutoScrollInterval, clearAutoScrollInterval] = useInterval();
  const scrollSpeed = (0, import_react5.useRef)({
    x: 0,
    y: 0
  });
  const scrollDirection = (0, import_react5.useRef)({
    x: 0,
    y: 0
  });
  const rect = (0, import_react5.useMemo)(() => {
    switch (activator) {
      case AutoScrollActivator.Pointer:
        return pointerCoordinates ? {
          top: pointerCoordinates.y,
          bottom: pointerCoordinates.y,
          left: pointerCoordinates.x,
          right: pointerCoordinates.x
        } : null;
      case AutoScrollActivator.DraggableRect:
        return draggingRect;
    }
  }, [activator, draggingRect, pointerCoordinates]);
  const scrollContainerRef = (0, import_react5.useRef)(null);
  const autoScroll = (0, import_react5.useCallback)(() => {
    const scrollContainer = scrollContainerRef.current;
    if (!scrollContainer) {
      return;
    }
    const scrollLeft = scrollSpeed.current.x * scrollDirection.current.x;
    const scrollTop = scrollSpeed.current.y * scrollDirection.current.y;
    scrollContainer.scrollBy(scrollLeft, scrollTop);
  }, []);
  const sortedScrollableAncestors = (0, import_react5.useMemo)(() => order === TraversalOrder.TreeOrder ? [...scrollableAncestors].reverse() : scrollableAncestors, [order, scrollableAncestors]);
  (0, import_react5.useEffect)(
    () => {
      if (!enabled || !scrollableAncestors.length || !rect) {
        clearAutoScrollInterval();
        return;
      }
      for (const scrollContainer of sortedScrollableAncestors) {
        if ((canScroll == null ? void 0 : canScroll(scrollContainer)) === false) {
          continue;
        }
        const index3 = scrollableAncestors.indexOf(scrollContainer);
        const scrollContainerRect = scrollableAncestorRects[index3];
        if (!scrollContainerRect) {
          continue;
        }
        const {
          direction,
          speed
        } = getScrollDirectionAndSpeed(scrollContainer, scrollContainerRect, rect, acceleration, threshold);
        for (const axis of ["x", "y"]) {
          if (!scrollIntent[axis][direction[axis]]) {
            speed[axis] = 0;
            direction[axis] = 0;
          }
        }
        if (speed.x > 0 || speed.y > 0) {
          clearAutoScrollInterval();
          scrollContainerRef.current = scrollContainer;
          setAutoScrollInterval(autoScroll, interval);
          scrollSpeed.current = speed;
          scrollDirection.current = direction;
          return;
        }
      }
      scrollSpeed.current = {
        x: 0,
        y: 0
      };
      scrollDirection.current = {
        x: 0,
        y: 0
      };
      clearAutoScrollInterval();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      acceleration,
      autoScroll,
      canScroll,
      clearAutoScrollInterval,
      enabled,
      interval,
      // eslint-disable-next-line react-hooks/exhaustive-deps
      JSON.stringify(rect),
      // eslint-disable-next-line react-hooks/exhaustive-deps
      JSON.stringify(scrollIntent),
      setAutoScrollInterval,
      scrollableAncestors,
      sortedScrollableAncestors,
      scrollableAncestorRects,
      // eslint-disable-next-line react-hooks/exhaustive-deps
      JSON.stringify(threshold)
    ]
  );
}
var defaultScrollIntent = {
  x: {
    [Direction.Backward]: false,
    [Direction.Forward]: false
  },
  y: {
    [Direction.Backward]: false,
    [Direction.Forward]: false
  }
};
function useScrollIntent(_ref2) {
  let {
    delta,
    disabled
  } = _ref2;
  const previousDelta = usePrevious(delta);
  return useLazyMemo((previousIntent) => {
    if (disabled || !previousDelta || !previousIntent) {
      return defaultScrollIntent;
    }
    const direction = {
      x: Math.sign(delta.x - previousDelta.x),
      y: Math.sign(delta.y - previousDelta.y)
    };
    return {
      x: {
        [Direction.Backward]: previousIntent.x[Direction.Backward] || direction.x === -1,
        [Direction.Forward]: previousIntent.x[Direction.Forward] || direction.x === 1
      },
      y: {
        [Direction.Backward]: previousIntent.y[Direction.Backward] || direction.y === -1,
        [Direction.Forward]: previousIntent.y[Direction.Forward] || direction.y === 1
      }
    };
  }, [disabled, delta, previousDelta]);
}
function useCachedNode(draggableNodes, id) {
  const draggableNode = id != null ? draggableNodes.get(id) : void 0;
  const node2 = draggableNode ? draggableNode.node.current : null;
  return useLazyMemo((cachedNode) => {
    var _ref;
    if (id == null) {
      return null;
    }
    return (_ref = node2 != null ? node2 : cachedNode) != null ? _ref : null;
  }, [node2, id]);
}
function useCombineActivators(sensors, getSyntheticHandler) {
  return (0, import_react5.useMemo)(() => sensors.reduce((accumulator, sensor) => {
    const {
      sensor: Sensor
    } = sensor;
    const sensorActivators = Sensor.activators.map((activator) => ({
      eventName: activator.eventName,
      handler: getSyntheticHandler(activator.handler, sensor)
    }));
    return [...accumulator, ...sensorActivators];
  }, []), [sensors, getSyntheticHandler]);
}
var MeasuringStrategy;
(function(MeasuringStrategy2) {
  MeasuringStrategy2[MeasuringStrategy2["Always"] = 0] = "Always";
  MeasuringStrategy2[MeasuringStrategy2["BeforeDragging"] = 1] = "BeforeDragging";
  MeasuringStrategy2[MeasuringStrategy2["WhileDragging"] = 2] = "WhileDragging";
})(MeasuringStrategy || (MeasuringStrategy = {}));
var MeasuringFrequency;
(function(MeasuringFrequency2) {
  MeasuringFrequency2["Optimized"] = "optimized";
})(MeasuringFrequency || (MeasuringFrequency = {}));
var defaultValue = /* @__PURE__ */ new Map();
function useDroppableMeasuring(containers, _ref) {
  let {
    dragging,
    dependencies,
    config
  } = _ref;
  const [queue, setQueue] = (0, import_react5.useState)(null);
  const {
    frequency,
    measure,
    strategy
  } = config;
  const containersRef = (0, import_react5.useRef)(containers);
  const disabled = isDisabled();
  const disabledRef = useLatestValue(disabled);
  const measureDroppableContainers = (0, import_react5.useCallback)(function(ids2) {
    if (ids2 === void 0) {
      ids2 = [];
    }
    if (disabledRef.current) {
      return;
    }
    setQueue((value) => {
      if (value === null) {
        return ids2;
      }
      return value.concat(ids2.filter((id) => !value.includes(id)));
    });
  }, [disabledRef]);
  const timeoutId = (0, import_react5.useRef)(null);
  const droppableRects = useLazyMemo((previousValue) => {
    if (disabled && !dragging) {
      return defaultValue;
    }
    if (!previousValue || previousValue === defaultValue || containersRef.current !== containers || queue != null) {
      const map = /* @__PURE__ */ new Map();
      for (let container of containers) {
        if (!container) {
          continue;
        }
        if (queue && queue.length > 0 && !queue.includes(container.id) && container.rect.current) {
          map.set(container.id, container.rect.current);
          continue;
        }
        const node2 = container.node.current;
        const rect = node2 ? new Rect(measure(node2), node2) : null;
        container.rect.current = rect;
        if (rect) {
          map.set(container.id, rect);
        }
      }
      return map;
    }
    return previousValue;
  }, [containers, queue, dragging, disabled, measure]);
  (0, import_react5.useEffect)(() => {
    containersRef.current = containers;
  }, [containers]);
  (0, import_react5.useEffect)(
    () => {
      if (disabled) {
        return;
      }
      measureDroppableContainers();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dragging, disabled]
  );
  (0, import_react5.useEffect)(
    () => {
      if (queue && queue.length > 0) {
        setQueue(null);
      }
    },
    //eslint-disable-next-line react-hooks/exhaustive-deps
    [JSON.stringify(queue)]
  );
  (0, import_react5.useEffect)(
    () => {
      if (disabled || typeof frequency !== "number" || timeoutId.current !== null) {
        return;
      }
      timeoutId.current = setTimeout(() => {
        measureDroppableContainers();
        timeoutId.current = null;
      }, frequency);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [frequency, disabled, measureDroppableContainers, ...dependencies]
  );
  return {
    droppableRects,
    measureDroppableContainers,
    measuringScheduled: queue != null
  };
  function isDisabled() {
    switch (strategy) {
      case MeasuringStrategy.Always:
        return false;
      case MeasuringStrategy.BeforeDragging:
        return dragging;
      default:
        return !dragging;
    }
  }
}
function useInitialValue(value, computeFn) {
  return useLazyMemo((previousValue) => {
    if (!value) {
      return null;
    }
    if (previousValue) {
      return previousValue;
    }
    return typeof computeFn === "function" ? computeFn(value) : value;
  }, [computeFn, value]);
}
function useInitialRect(node2, measure) {
  return useInitialValue(node2, measure);
}
function useMutationObserver(_ref) {
  let {
    callback,
    disabled
  } = _ref;
  const handleMutations = useEvent(callback);
  const mutationObserver = (0, import_react5.useMemo)(() => {
    if (disabled || typeof window === "undefined" || typeof window.MutationObserver === "undefined") {
      return void 0;
    }
    const {
      MutationObserver: MutationObserver2
    } = window;
    return new MutationObserver2(handleMutations);
  }, [handleMutations, disabled]);
  (0, import_react5.useEffect)(() => {
    return () => mutationObserver == null ? void 0 : mutationObserver.disconnect();
  }, [mutationObserver]);
  return mutationObserver;
}
function useResizeObserver(_ref) {
  let {
    callback,
    disabled
  } = _ref;
  const handleResize = useEvent(callback);
  const resizeObserver2 = (0, import_react5.useMemo)(
    () => {
      if (disabled || typeof window === "undefined" || typeof window.ResizeObserver === "undefined") {
        return void 0;
      }
      const {
        ResizeObserver: ResizeObserver4
      } = window;
      return new ResizeObserver4(handleResize);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [disabled]
  );
  (0, import_react5.useEffect)(() => {
    return () => resizeObserver2 == null ? void 0 : resizeObserver2.disconnect();
  }, [resizeObserver2]);
  return resizeObserver2;
}
function defaultMeasure(element) {
  return new Rect(getClientRect(element), element);
}
function useRect(element, measure, fallbackRect) {
  if (measure === void 0) {
    measure = defaultMeasure;
  }
  const [rect, setRect] = (0, import_react5.useState)(null);
  function measureRect() {
    setRect((currentRect) => {
      if (!element) {
        return null;
      }
      if (element.isConnected === false) {
        var _ref;
        return (_ref = currentRect != null ? currentRect : fallbackRect) != null ? _ref : null;
      }
      const newRect = measure(element);
      if (JSON.stringify(currentRect) === JSON.stringify(newRect)) {
        return currentRect;
      }
      return newRect;
    });
  }
  const mutationObserver = useMutationObserver({
    callback(records) {
      if (!element) {
        return;
      }
      for (const record of records) {
        const {
          type: type5,
          target
        } = record;
        if (type5 === "childList" && target instanceof HTMLElement && target.contains(element)) {
          measureRect();
          break;
        }
      }
    }
  });
  const resizeObserver2 = useResizeObserver({
    callback: measureRect
  });
  useIsomorphicLayoutEffect(() => {
    measureRect();
    if (element) {
      resizeObserver2 == null ? void 0 : resizeObserver2.observe(element);
      mutationObserver == null ? void 0 : mutationObserver.observe(document.body, {
        childList: true,
        subtree: true
      });
    } else {
      resizeObserver2 == null ? void 0 : resizeObserver2.disconnect();
      mutationObserver == null ? void 0 : mutationObserver.disconnect();
    }
  }, [element]);
  return rect;
}
function useRectDelta(rect) {
  const initialRect = useInitialValue(rect);
  return getRectDelta(rect, initialRect);
}
var defaultValue$1 = [];
function useScrollableAncestors(node2) {
  const previousNode = (0, import_react5.useRef)(node2);
  const ancestors = useLazyMemo((previousValue) => {
    if (!node2) {
      return defaultValue$1;
    }
    if (previousValue && previousValue !== defaultValue$1 && node2 && previousNode.current && node2.parentNode === previousNode.current.parentNode) {
      return previousValue;
    }
    return getScrollableAncestors(node2);
  }, [node2]);
  (0, import_react5.useEffect)(() => {
    previousNode.current = node2;
  }, [node2]);
  return ancestors;
}
function useScrollOffsets(elements) {
  const [scrollCoordinates, setScrollCoordinates] = (0, import_react5.useState)(null);
  const prevElements = (0, import_react5.useRef)(elements);
  const handleScroll = (0, import_react5.useCallback)((event) => {
    const scrollingElement = getScrollableElement(event.target);
    if (!scrollingElement) {
      return;
    }
    setScrollCoordinates((scrollCoordinates2) => {
      if (!scrollCoordinates2) {
        return null;
      }
      scrollCoordinates2.set(scrollingElement, getScrollCoordinates(scrollingElement));
      return new Map(scrollCoordinates2);
    });
  }, []);
  (0, import_react5.useEffect)(() => {
    const previousElements = prevElements.current;
    if (elements !== previousElements) {
      cleanup2(previousElements);
      const entries = elements.map((element) => {
        const scrollableElement = getScrollableElement(element);
        if (scrollableElement) {
          scrollableElement.addEventListener("scroll", handleScroll, {
            passive: true
          });
          return [scrollableElement, getScrollCoordinates(scrollableElement)];
        }
        return null;
      }).filter((entry) => entry != null);
      setScrollCoordinates(entries.length ? new Map(entries) : null);
      prevElements.current = elements;
    }
    return () => {
      cleanup2(elements);
      cleanup2(previousElements);
    };
    function cleanup2(elements2) {
      elements2.forEach((element) => {
        const scrollableElement = getScrollableElement(element);
        scrollableElement == null ? void 0 : scrollableElement.removeEventListener("scroll", handleScroll);
      });
    }
  }, [handleScroll, elements]);
  return (0, import_react5.useMemo)(() => {
    if (elements.length) {
      return scrollCoordinates ? Array.from(scrollCoordinates.values()).reduce((acc, coordinates) => add(acc, coordinates), defaultCoordinates) : getScrollOffsets(elements);
    }
    return defaultCoordinates;
  }, [elements, scrollCoordinates]);
}
function useScrollOffsetsDelta(scrollOffsets, dependencies) {
  if (dependencies === void 0) {
    dependencies = [];
  }
  const initialScrollOffsets = (0, import_react5.useRef)(null);
  (0, import_react5.useEffect)(
    () => {
      initialScrollOffsets.current = null;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    dependencies
  );
  (0, import_react5.useEffect)(() => {
    const hasScrollOffsets = scrollOffsets !== defaultCoordinates;
    if (hasScrollOffsets && !initialScrollOffsets.current) {
      initialScrollOffsets.current = scrollOffsets;
    }
    if (!hasScrollOffsets && initialScrollOffsets.current) {
      initialScrollOffsets.current = null;
    }
  }, [scrollOffsets]);
  return initialScrollOffsets.current ? subtract(scrollOffsets, initialScrollOffsets.current) : defaultCoordinates;
}
function useSensorSetup(sensors) {
  (0, import_react5.useEffect)(
    () => {
      if (!canUseDOM) {
        return;
      }
      const teardownFns = sensors.map((_ref) => {
        let {
          sensor
        } = _ref;
        return sensor.setup == null ? void 0 : sensor.setup();
      });
      return () => {
        for (const teardown of teardownFns) {
          teardown == null ? void 0 : teardown();
        }
      };
    },
    // TO-DO: Sensors length could theoretically change which would not be a valid dependency
    // eslint-disable-next-line react-hooks/exhaustive-deps
    sensors.map((_ref2) => {
      let {
        sensor
      } = _ref2;
      return sensor;
    })
  );
}
function useSyntheticListeners(listeners, id) {
  return (0, import_react5.useMemo)(() => {
    return listeners.reduce((acc, _ref) => {
      let {
        eventName,
        handler
      } = _ref;
      acc[eventName] = (event) => {
        handler(event, id);
      };
      return acc;
    }, {});
  }, [listeners, id]);
}
function useWindowRect(element) {
  return (0, import_react5.useMemo)(() => element ? getWindowClientRect(element) : null, [element]);
}
var defaultValue$2 = [];
function useRects(elements, measure) {
  if (measure === void 0) {
    measure = getClientRect;
  }
  const [firstElement] = elements;
  const windowRect = useWindowRect(firstElement ? getWindow(firstElement) : null);
  const [rects, setRects] = (0, import_react5.useState)(defaultValue$2);
  function measureRects() {
    setRects(() => {
      if (!elements.length) {
        return defaultValue$2;
      }
      return elements.map((element) => isDocumentScrollingElement(element) ? windowRect : new Rect(measure(element), element));
    });
  }
  const resizeObserver2 = useResizeObserver({
    callback: measureRects
  });
  useIsomorphicLayoutEffect(() => {
    resizeObserver2 == null ? void 0 : resizeObserver2.disconnect();
    measureRects();
    elements.forEach((element) => resizeObserver2 == null ? void 0 : resizeObserver2.observe(element));
  }, [elements]);
  return rects;
}
function getMeasurableNode(node2) {
  if (!node2) {
    return null;
  }
  if (node2.children.length > 1) {
    return node2;
  }
  const firstChild = node2.children[0];
  return isHTMLElement(firstChild) ? firstChild : node2;
}
function useDragOverlayMeasuring(_ref) {
  let {
    measure
  } = _ref;
  const [rect, setRect] = (0, import_react5.useState)(null);
  const handleResize = (0, import_react5.useCallback)((entries) => {
    for (const {
      target
    } of entries) {
      if (isHTMLElement(target)) {
        setRect((rect2) => {
          const newRect = measure(target);
          return rect2 ? {
            ...rect2,
            width: newRect.width,
            height: newRect.height
          } : newRect;
        });
        break;
      }
    }
  }, [measure]);
  const resizeObserver2 = useResizeObserver({
    callback: handleResize
  });
  const handleNodeChange = (0, import_react5.useCallback)((element) => {
    const node2 = getMeasurableNode(element);
    resizeObserver2 == null ? void 0 : resizeObserver2.disconnect();
    if (node2) {
      resizeObserver2 == null ? void 0 : resizeObserver2.observe(node2);
    }
    setRect(node2 ? measure(node2) : null);
  }, [measure, resizeObserver2]);
  const [nodeRef, setRef] = useNodeRef(handleNodeChange);
  return (0, import_react5.useMemo)(() => ({
    nodeRef,
    rect,
    setRef
  }), [rect, nodeRef, setRef]);
}
var defaultSensors = [{
  sensor: PointerSensor,
  options: {}
}, {
  sensor: KeyboardSensor,
  options: {}
}];
var defaultData = {
  current: {}
};
var defaultMeasuringConfiguration = {
  draggable: {
    measure: getTransformAgnosticClientRect
  },
  droppable: {
    measure: getTransformAgnosticClientRect,
    strategy: MeasuringStrategy.WhileDragging,
    frequency: MeasuringFrequency.Optimized
  },
  dragOverlay: {
    measure: getClientRect
  }
};
var DroppableContainersMap = class extends Map {
  get(id) {
    var _super$get;
    return id != null ? (_super$get = super.get(id)) != null ? _super$get : void 0 : void 0;
  }
  toArray() {
    return Array.from(this.values());
  }
  getEnabled() {
    return this.toArray().filter((_ref) => {
      let {
        disabled
      } = _ref;
      return !disabled;
    });
  }
  getNodeFor(id) {
    var _this$get$node$curren, _this$get;
    return (_this$get$node$curren = (_this$get = this.get(id)) == null ? void 0 : _this$get.node.current) != null ? _this$get$node$curren : void 0;
  }
};
var defaultPublicContext = {
  activatorEvent: null,
  active: null,
  activeNode: null,
  activeNodeRect: null,
  collisions: null,
  containerNodeRect: null,
  draggableNodes: /* @__PURE__ */ new Map(),
  droppableRects: /* @__PURE__ */ new Map(),
  droppableContainers: /* @__PURE__ */ new DroppableContainersMap(),
  over: null,
  dragOverlay: {
    nodeRef: {
      current: null
    },
    rect: null,
    setRef: noop
  },
  scrollableAncestors: [],
  scrollableAncestorRects: [],
  measuringConfiguration: defaultMeasuringConfiguration,
  measureDroppableContainers: noop,
  windowRect: null,
  measuringScheduled: false
};
var defaultInternalContext = {
  activatorEvent: null,
  activators: [],
  active: null,
  activeNodeRect: null,
  ariaDescribedById: {
    draggable: ""
  },
  dispatch: noop,
  draggableNodes: /* @__PURE__ */ new Map(),
  over: null,
  measureDroppableContainers: noop
};
var InternalContext = /* @__PURE__ */ (0, import_react5.createContext)(defaultInternalContext);
var PublicContext = /* @__PURE__ */ (0, import_react5.createContext)(defaultPublicContext);
function getInitialState() {
  return {
    draggable: {
      active: null,
      initialCoordinates: {
        x: 0,
        y: 0
      },
      nodes: /* @__PURE__ */ new Map(),
      translate: {
        x: 0,
        y: 0
      }
    },
    droppable: {
      containers: new DroppableContainersMap()
    }
  };
}
function reducer(state, action) {
  switch (action.type) {
    case Action.DragStart:
      return {
        ...state,
        draggable: {
          ...state.draggable,
          initialCoordinates: action.initialCoordinates,
          active: action.active
        }
      };
    case Action.DragMove:
      if (state.draggable.active == null) {
        return state;
      }
      return {
        ...state,
        draggable: {
          ...state.draggable,
          translate: {
            x: action.coordinates.x - state.draggable.initialCoordinates.x,
            y: action.coordinates.y - state.draggable.initialCoordinates.y
          }
        }
      };
    case Action.DragEnd:
    case Action.DragCancel:
      return {
        ...state,
        draggable: {
          ...state.draggable,
          active: null,
          initialCoordinates: {
            x: 0,
            y: 0
          },
          translate: {
            x: 0,
            y: 0
          }
        }
      };
    case Action.RegisterDroppable: {
      const {
        element
      } = action;
      const {
        id
      } = element;
      const containers = new DroppableContainersMap(state.droppable.containers);
      containers.set(id, element);
      return {
        ...state,
        droppable: {
          ...state.droppable,
          containers
        }
      };
    }
    case Action.SetDroppableDisabled: {
      const {
        id,
        key: key2,
        disabled
      } = action;
      const element = state.droppable.containers.get(id);
      if (!element || key2 !== element.key) {
        return state;
      }
      const containers = new DroppableContainersMap(state.droppable.containers);
      containers.set(id, {
        ...element,
        disabled
      });
      return {
        ...state,
        droppable: {
          ...state.droppable,
          containers
        }
      };
    }
    case Action.UnregisterDroppable: {
      const {
        id,
        key: key2
      } = action;
      const element = state.droppable.containers.get(id);
      if (!element || key2 !== element.key) {
        return state;
      }
      const containers = new DroppableContainersMap(state.droppable.containers);
      containers.delete(id);
      return {
        ...state,
        droppable: {
          ...state.droppable,
          containers
        }
      };
    }
    default: {
      return state;
    }
  }
}
function RestoreFocus(_ref) {
  let {
    disabled
  } = _ref;
  const {
    active,
    activatorEvent,
    draggableNodes
  } = (0, import_react5.useContext)(InternalContext);
  const previousActivatorEvent = usePrevious(activatorEvent);
  const previousActiveId = usePrevious(active == null ? void 0 : active.id);
  (0, import_react5.useEffect)(() => {
    if (disabled) {
      return;
    }
    if (!activatorEvent && previousActivatorEvent && previousActiveId != null) {
      if (!isKeyboardEvent(previousActivatorEvent)) {
        return;
      }
      if (document.activeElement === previousActivatorEvent.target) {
        return;
      }
      const draggableNode = draggableNodes.get(previousActiveId);
      if (!draggableNode) {
        return;
      }
      const {
        activatorNode,
        node: node2
      } = draggableNode;
      if (!activatorNode.current && !node2.current) {
        return;
      }
      requestAnimationFrame(() => {
        for (const element of [activatorNode.current, node2.current]) {
          if (!element) {
            continue;
          }
          const focusableNode = findFirstFocusableNode(element);
          if (focusableNode) {
            focusableNode.focus();
            break;
          }
        }
      });
    }
  }, [activatorEvent, disabled, draggableNodes, previousActiveId, previousActivatorEvent]);
  return null;
}
function applyModifiers(modifiers, _ref) {
  let {
    transform,
    ...args
  } = _ref;
  return modifiers != null && modifiers.length ? modifiers.reduce((accumulator, modifier) => {
    return modifier({
      transform: accumulator,
      ...args
    });
  }, transform) : transform;
}
function useMeasuringConfiguration(config) {
  return (0, import_react5.useMemo)(
    () => ({
      draggable: {
        ...defaultMeasuringConfiguration.draggable,
        ...config == null ? void 0 : config.draggable
      },
      droppable: {
        ...defaultMeasuringConfiguration.droppable,
        ...config == null ? void 0 : config.droppable
      },
      dragOverlay: {
        ...defaultMeasuringConfiguration.dragOverlay,
        ...config == null ? void 0 : config.dragOverlay
      }
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [config == null ? void 0 : config.draggable, config == null ? void 0 : config.droppable, config == null ? void 0 : config.dragOverlay]
  );
}
function useLayoutShiftScrollCompensation(_ref) {
  let {
    activeNode,
    measure,
    initialRect,
    config = true
  } = _ref;
  const initialized = (0, import_react5.useRef)(false);
  const {
    x,
    y
  } = typeof config === "boolean" ? {
    x: config,
    y: config
  } : config;
  useIsomorphicLayoutEffect(() => {
    const disabled = !x && !y;
    if (disabled || !activeNode) {
      initialized.current = false;
      return;
    }
    if (initialized.current || !initialRect) {
      return;
    }
    const node2 = activeNode == null ? void 0 : activeNode.node.current;
    if (!node2 || node2.isConnected === false) {
      return;
    }
    const rect = measure(node2);
    const rectDelta = getRectDelta(rect, initialRect);
    if (!x) {
      rectDelta.x = 0;
    }
    if (!y) {
      rectDelta.y = 0;
    }
    initialized.current = true;
    if (Math.abs(rectDelta.x) > 0 || Math.abs(rectDelta.y) > 0) {
      const firstScrollableAncestor = getFirstScrollableAncestor(node2);
      if (firstScrollableAncestor) {
        firstScrollableAncestor.scrollBy({
          top: rectDelta.y,
          left: rectDelta.x
        });
      }
    }
  }, [activeNode, x, y, initialRect, measure]);
}
var ActiveDraggableContext = /* @__PURE__ */ (0, import_react5.createContext)({
  ...defaultCoordinates,
  scaleX: 1,
  scaleY: 1
});
var Status;
(function(Status2) {
  Status2[Status2["Uninitialized"] = 0] = "Uninitialized";
  Status2[Status2["Initializing"] = 1] = "Initializing";
  Status2[Status2["Initialized"] = 2] = "Initialized";
})(Status || (Status = {}));
var DndContext = /* @__PURE__ */ (0, import_react5.memo)(function DndContext2(_ref) {
  var _sensorContext$curren, _dragOverlay$nodeRef$, _dragOverlay$rect, _over$rect;
  let {
    id,
    accessibility,
    autoScroll = true,
    children,
    sensors = defaultSensors,
    collisionDetection = rectIntersection,
    measuring,
    modifiers,
    ...props
  } = _ref;
  const store = (0, import_react5.useReducer)(reducer, void 0, getInitialState);
  const [state, dispatch2] = store;
  const [dispatchMonitorEvent, registerMonitorListener] = useDndMonitorProvider();
  const [status, setStatus] = (0, import_react5.useState)(Status.Uninitialized);
  const isInitialized = status === Status.Initialized;
  const {
    draggable: {
      active: activeId,
      nodes: draggableNodes,
      translate
    },
    droppable: {
      containers: droppableContainers
    }
  } = state;
  const node2 = activeId != null ? draggableNodes.get(activeId) : null;
  const activeRects = (0, import_react5.useRef)({
    initial: null,
    translated: null
  });
  const active = (0, import_react5.useMemo)(() => {
    var _node$data;
    return activeId != null ? {
      id: activeId,
      // It's possible for the active node to unmount while dragging
      data: (_node$data = node2 == null ? void 0 : node2.data) != null ? _node$data : defaultData,
      rect: activeRects
    } : null;
  }, [activeId, node2]);
  const activeRef = (0, import_react5.useRef)(null);
  const [activeSensor, setActiveSensor] = (0, import_react5.useState)(null);
  const [activatorEvent, setActivatorEvent] = (0, import_react5.useState)(null);
  const latestProps = useLatestValue(props, Object.values(props));
  const draggableDescribedById = useUniqueId("DndDescribedBy", id);
  const enabledDroppableContainers = (0, import_react5.useMemo)(() => droppableContainers.getEnabled(), [droppableContainers]);
  const measuringConfiguration = useMeasuringConfiguration(measuring);
  const {
    droppableRects,
    measureDroppableContainers,
    measuringScheduled
  } = useDroppableMeasuring(enabledDroppableContainers, {
    dragging: isInitialized,
    dependencies: [translate.x, translate.y],
    config: measuringConfiguration.droppable
  });
  const activeNode = useCachedNode(draggableNodes, activeId);
  const activationCoordinates = (0, import_react5.useMemo)(() => activatorEvent ? getEventCoordinates(activatorEvent) : null, [activatorEvent]);
  const autoScrollOptions = getAutoScrollerOptions();
  const initialActiveNodeRect = useInitialRect(activeNode, measuringConfiguration.draggable.measure);
  useLayoutShiftScrollCompensation({
    activeNode: activeId != null ? draggableNodes.get(activeId) : null,
    config: autoScrollOptions.layoutShiftCompensation,
    initialRect: initialActiveNodeRect,
    measure: measuringConfiguration.draggable.measure
  });
  const activeNodeRect = useRect(activeNode, measuringConfiguration.draggable.measure, initialActiveNodeRect);
  const containerNodeRect = useRect(activeNode ? activeNode.parentElement : null);
  const sensorContext = (0, import_react5.useRef)({
    activatorEvent: null,
    active: null,
    activeNode,
    collisionRect: null,
    collisions: null,
    droppableRects,
    draggableNodes,
    draggingNode: null,
    draggingNodeRect: null,
    droppableContainers,
    over: null,
    scrollableAncestors: [],
    scrollAdjustedTranslate: null
  });
  const overNode = droppableContainers.getNodeFor((_sensorContext$curren = sensorContext.current.over) == null ? void 0 : _sensorContext$curren.id);
  const dragOverlay = useDragOverlayMeasuring({
    measure: measuringConfiguration.dragOverlay.measure
  });
  const draggingNode = (_dragOverlay$nodeRef$ = dragOverlay.nodeRef.current) != null ? _dragOverlay$nodeRef$ : activeNode;
  const draggingNodeRect = isInitialized ? (_dragOverlay$rect = dragOverlay.rect) != null ? _dragOverlay$rect : activeNodeRect : null;
  const usesDragOverlay = Boolean(dragOverlay.nodeRef.current && dragOverlay.rect);
  const nodeRectDelta = useRectDelta(usesDragOverlay ? null : activeNodeRect);
  const windowRect = useWindowRect(draggingNode ? getWindow(draggingNode) : null);
  const scrollableAncestors = useScrollableAncestors(isInitialized ? overNode != null ? overNode : activeNode : null);
  const scrollableAncestorRects = useRects(scrollableAncestors);
  const modifiedTranslate = applyModifiers(modifiers, {
    transform: {
      x: translate.x - nodeRectDelta.x,
      y: translate.y - nodeRectDelta.y,
      scaleX: 1,
      scaleY: 1
    },
    activatorEvent,
    active,
    activeNodeRect,
    containerNodeRect,
    draggingNodeRect,
    over: sensorContext.current.over,
    overlayNodeRect: dragOverlay.rect,
    scrollableAncestors,
    scrollableAncestorRects,
    windowRect
  });
  const pointerCoordinates = activationCoordinates ? add(activationCoordinates, translate) : null;
  const scrollOffsets = useScrollOffsets(scrollableAncestors);
  const scrollAdjustment = useScrollOffsetsDelta(scrollOffsets);
  const activeNodeScrollDelta = useScrollOffsetsDelta(scrollOffsets, [activeNodeRect]);
  const scrollAdjustedTranslate = add(modifiedTranslate, scrollAdjustment);
  const collisionRect = draggingNodeRect ? getAdjustedRect(draggingNodeRect, modifiedTranslate) : null;
  const collisions = active && collisionRect ? collisionDetection({
    active,
    collisionRect,
    droppableRects,
    droppableContainers: enabledDroppableContainers,
    pointerCoordinates
  }) : null;
  const overId = getFirstCollision(collisions, "id");
  const [over, setOver] = (0, import_react5.useState)(null);
  const appliedTranslate = usesDragOverlay ? modifiedTranslate : add(modifiedTranslate, activeNodeScrollDelta);
  const transform = adjustScale(appliedTranslate, (_over$rect = over == null ? void 0 : over.rect) != null ? _over$rect : null, activeNodeRect);
  const activeSensorRef = (0, import_react5.useRef)(null);
  const instantiateSensor = (0, import_react5.useCallback)(
    (event, _ref2) => {
      let {
        sensor: Sensor,
        options
      } = _ref2;
      if (activeRef.current == null) {
        return;
      }
      const activeNode2 = draggableNodes.get(activeRef.current);
      if (!activeNode2) {
        return;
      }
      const activatorEvent2 = event.nativeEvent;
      const sensorInstance = new Sensor({
        active: activeRef.current,
        activeNode: activeNode2,
        event: activatorEvent2,
        options,
        // Sensors need to be instantiated with refs for arguments that change over time
        // otherwise they are frozen in time with the stale arguments
        context: sensorContext,
        onAbort(id2) {
          const draggableNode = draggableNodes.get(id2);
          if (!draggableNode) {
            return;
          }
          const {
            onDragAbort
          } = latestProps.current;
          const event2 = {
            id: id2
          };
          onDragAbort == null ? void 0 : onDragAbort(event2);
          dispatchMonitorEvent({
            type: "onDragAbort",
            event: event2
          });
        },
        onPending(id2, constraint, initialCoordinates, offset4) {
          const draggableNode = draggableNodes.get(id2);
          if (!draggableNode) {
            return;
          }
          const {
            onDragPending
          } = latestProps.current;
          const event2 = {
            id: id2,
            constraint,
            initialCoordinates,
            offset: offset4
          };
          onDragPending == null ? void 0 : onDragPending(event2);
          dispatchMonitorEvent({
            type: "onDragPending",
            event: event2
          });
        },
        onStart(initialCoordinates) {
          const id2 = activeRef.current;
          if (id2 == null) {
            return;
          }
          const draggableNode = draggableNodes.get(id2);
          if (!draggableNode) {
            return;
          }
          const {
            onDragStart
          } = latestProps.current;
          const event2 = {
            activatorEvent: activatorEvent2,
            active: {
              id: id2,
              data: draggableNode.data,
              rect: activeRects
            }
          };
          (0, import_react_dom2.unstable_batchedUpdates)(() => {
            onDragStart == null ? void 0 : onDragStart(event2);
            setStatus(Status.Initializing);
            dispatch2({
              type: Action.DragStart,
              initialCoordinates,
              active: id2
            });
            dispatchMonitorEvent({
              type: "onDragStart",
              event: event2
            });
            setActiveSensor(activeSensorRef.current);
            setActivatorEvent(activatorEvent2);
          });
        },
        onMove(coordinates) {
          dispatch2({
            type: Action.DragMove,
            coordinates
          });
        },
        onEnd: createHandler(Action.DragEnd),
        onCancel: createHandler(Action.DragCancel)
      });
      activeSensorRef.current = sensorInstance;
      function createHandler(type5) {
        return async function handler() {
          const {
            active: active2,
            collisions: collisions2,
            over: over2,
            scrollAdjustedTranslate: scrollAdjustedTranslate2
          } = sensorContext.current;
          let event2 = null;
          if (active2 && scrollAdjustedTranslate2) {
            const {
              cancelDrop
            } = latestProps.current;
            event2 = {
              activatorEvent: activatorEvent2,
              active: active2,
              collisions: collisions2,
              delta: scrollAdjustedTranslate2,
              over: over2
            };
            if (type5 === Action.DragEnd && typeof cancelDrop === "function") {
              const shouldCancel = await Promise.resolve(cancelDrop(event2));
              if (shouldCancel) {
                type5 = Action.DragCancel;
              }
            }
          }
          activeRef.current = null;
          (0, import_react_dom2.unstable_batchedUpdates)(() => {
            dispatch2({
              type: type5
            });
            setStatus(Status.Uninitialized);
            setOver(null);
            setActiveSensor(null);
            setActivatorEvent(null);
            activeSensorRef.current = null;
            const eventName = type5 === Action.DragEnd ? "onDragEnd" : "onDragCancel";
            if (event2) {
              const handler2 = latestProps.current[eventName];
              handler2 == null ? void 0 : handler2(event2);
              dispatchMonitorEvent({
                type: eventName,
                event: event2
              });
            }
          });
        };
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [draggableNodes]
  );
  const bindActivatorToSensorInstantiator = (0, import_react5.useCallback)((handler, sensor) => {
    return (event, active2) => {
      const nativeEvent = event.nativeEvent;
      const activeDraggableNode = draggableNodes.get(active2);
      if (
        // Another sensor is already instantiating
        activeRef.current !== null || // No active draggable
        !activeDraggableNode || // Event has already been captured
        nativeEvent.dndKit || nativeEvent.defaultPrevented
      ) {
        return;
      }
      const activationContext = {
        active: activeDraggableNode
      };
      const shouldActivate = handler(event, sensor.options, activationContext);
      if (shouldActivate === true) {
        nativeEvent.dndKit = {
          capturedBy: sensor.sensor
        };
        activeRef.current = active2;
        instantiateSensor(event, sensor);
      }
    };
  }, [draggableNodes, instantiateSensor]);
  const activators = useCombineActivators(sensors, bindActivatorToSensorInstantiator);
  useSensorSetup(sensors);
  useIsomorphicLayoutEffect(() => {
    if (activeNodeRect && status === Status.Initializing) {
      setStatus(Status.Initialized);
    }
  }, [activeNodeRect, status]);
  (0, import_react5.useEffect)(
    () => {
      const {
        onDragMove
      } = latestProps.current;
      const {
        active: active2,
        activatorEvent: activatorEvent2,
        collisions: collisions2,
        over: over2
      } = sensorContext.current;
      if (!active2 || !activatorEvent2) {
        return;
      }
      const event = {
        active: active2,
        activatorEvent: activatorEvent2,
        collisions: collisions2,
        delta: {
          x: scrollAdjustedTranslate.x,
          y: scrollAdjustedTranslate.y
        },
        over: over2
      };
      (0, import_react_dom2.unstable_batchedUpdates)(() => {
        onDragMove == null ? void 0 : onDragMove(event);
        dispatchMonitorEvent({
          type: "onDragMove",
          event
        });
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [scrollAdjustedTranslate.x, scrollAdjustedTranslate.y]
  );
  (0, import_react5.useEffect)(
    () => {
      const {
        active: active2,
        activatorEvent: activatorEvent2,
        collisions: collisions2,
        droppableContainers: droppableContainers2,
        scrollAdjustedTranslate: scrollAdjustedTranslate2
      } = sensorContext.current;
      if (!active2 || activeRef.current == null || !activatorEvent2 || !scrollAdjustedTranslate2) {
        return;
      }
      const {
        onDragOver
      } = latestProps.current;
      const overContainer = droppableContainers2.get(overId);
      const over2 = overContainer && overContainer.rect.current ? {
        id: overContainer.id,
        rect: overContainer.rect.current,
        data: overContainer.data,
        disabled: overContainer.disabled
      } : null;
      const event = {
        active: active2,
        activatorEvent: activatorEvent2,
        collisions: collisions2,
        delta: {
          x: scrollAdjustedTranslate2.x,
          y: scrollAdjustedTranslate2.y
        },
        over: over2
      };
      (0, import_react_dom2.unstable_batchedUpdates)(() => {
        setOver(over2);
        onDragOver == null ? void 0 : onDragOver(event);
        dispatchMonitorEvent({
          type: "onDragOver",
          event
        });
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [overId]
  );
  useIsomorphicLayoutEffect(() => {
    sensorContext.current = {
      activatorEvent,
      active,
      activeNode,
      collisionRect,
      collisions,
      droppableRects,
      draggableNodes,
      draggingNode,
      draggingNodeRect,
      droppableContainers,
      over,
      scrollableAncestors,
      scrollAdjustedTranslate
    };
    activeRects.current = {
      initial: draggingNodeRect,
      translated: collisionRect
    };
  }, [active, activeNode, collisions, collisionRect, draggableNodes, draggingNode, draggingNodeRect, droppableRects, droppableContainers, over, scrollableAncestors, scrollAdjustedTranslate]);
  useAutoScroller({
    ...autoScrollOptions,
    delta: translate,
    draggingRect: collisionRect,
    pointerCoordinates,
    scrollableAncestors,
    scrollableAncestorRects
  });
  const publicContext = (0, import_react5.useMemo)(() => {
    const context = {
      active,
      activeNode,
      activeNodeRect,
      activatorEvent,
      collisions,
      containerNodeRect,
      dragOverlay,
      draggableNodes,
      droppableContainers,
      droppableRects,
      over,
      measureDroppableContainers,
      scrollableAncestors,
      scrollableAncestorRects,
      measuringConfiguration,
      measuringScheduled,
      windowRect
    };
    return context;
  }, [active, activeNode, activeNodeRect, activatorEvent, collisions, containerNodeRect, dragOverlay, draggableNodes, droppableContainers, droppableRects, over, measureDroppableContainers, scrollableAncestors, scrollableAncestorRects, measuringConfiguration, measuringScheduled, windowRect]);
  const internalContext = (0, import_react5.useMemo)(() => {
    const context = {
      activatorEvent,
      activators,
      active,
      activeNodeRect,
      ariaDescribedById: {
        draggable: draggableDescribedById
      },
      dispatch: dispatch2,
      draggableNodes,
      over,
      measureDroppableContainers
    };
    return context;
  }, [activatorEvent, activators, active, activeNodeRect, dispatch2, draggableDescribedById, draggableNodes, over, measureDroppableContainers]);
  return import_react5.default.createElement(DndMonitorContext.Provider, {
    value: registerMonitorListener
  }, import_react5.default.createElement(InternalContext.Provider, {
    value: internalContext
  }, import_react5.default.createElement(PublicContext.Provider, {
    value: publicContext
  }, import_react5.default.createElement(ActiveDraggableContext.Provider, {
    value: transform
  }, children)), import_react5.default.createElement(RestoreFocus, {
    disabled: (accessibility == null ? void 0 : accessibility.restoreFocus) === false
  })), import_react5.default.createElement(Accessibility, {
    ...accessibility,
    hiddenTextDescribedById: draggableDescribedById
  }));
  function getAutoScrollerOptions() {
    const activeSensorDisablesAutoscroll = (activeSensor == null ? void 0 : activeSensor.autoScrollEnabled) === false;
    const autoScrollGloballyDisabled = typeof autoScroll === "object" ? autoScroll.enabled === false : autoScroll === false;
    const enabled = isInitialized && !activeSensorDisablesAutoscroll && !autoScrollGloballyDisabled;
    if (typeof autoScroll === "object") {
      return {
        ...autoScroll,
        enabled
      };
    }
    return {
      enabled
    };
  }
});
var NullContext = /* @__PURE__ */ (0, import_react5.createContext)(null);
var defaultRole = "button";
var ID_PREFIX = "Draggable";
function useDraggable(_ref) {
  let {
    id,
    data: data2,
    disabled = false,
    attributes: attributes2
  } = _ref;
  const key2 = useUniqueId(ID_PREFIX);
  const {
    activators,
    activatorEvent,
    active,
    activeNodeRect,
    ariaDescribedById,
    draggableNodes,
    over
  } = (0, import_react5.useContext)(InternalContext);
  const {
    role = defaultRole,
    roleDescription = "draggable",
    tabIndex = 0
  } = attributes2 != null ? attributes2 : {};
  const isDragging = (active == null ? void 0 : active.id) === id;
  const transform = (0, import_react5.useContext)(isDragging ? ActiveDraggableContext : NullContext);
  const [node2, setNodeRef] = useNodeRef();
  const [activatorNode, setActivatorNodeRef] = useNodeRef();
  const listeners = useSyntheticListeners(activators, id);
  const dataRef = useLatestValue(data2);
  useIsomorphicLayoutEffect(
    () => {
      draggableNodes.set(id, {
        id,
        key: key2,
        node: node2,
        activatorNode,
        data: dataRef
      });
      return () => {
        const node3 = draggableNodes.get(id);
        if (node3 && node3.key === key2) {
          draggableNodes.delete(id);
        }
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [draggableNodes, id]
  );
  const memoizedAttributes = (0, import_react5.useMemo)(() => ({
    role,
    tabIndex,
    "aria-disabled": disabled,
    "aria-pressed": isDragging && role === defaultRole ? true : void 0,
    "aria-roledescription": roleDescription,
    "aria-describedby": ariaDescribedById.draggable
  }), [disabled, role, tabIndex, isDragging, roleDescription, ariaDescribedById.draggable]);
  return {
    active,
    activatorEvent,
    activeNodeRect,
    attributes: memoizedAttributes,
    isDragging,
    listeners: disabled ? void 0 : listeners,
    node: node2,
    over,
    setNodeRef,
    setActivatorNodeRef,
    transform
  };
}
function useDndContext() {
  return (0, import_react5.useContext)(PublicContext);
}
var ID_PREFIX$1 = "Droppable";
var defaultResizeObserverConfig = {
  timeout: 25
};
function useDroppable(_ref) {
  let {
    data: data2,
    disabled = false,
    id,
    resizeObserverConfig
  } = _ref;
  const key2 = useUniqueId(ID_PREFIX$1);
  const {
    active,
    dispatch: dispatch2,
    over,
    measureDroppableContainers
  } = (0, import_react5.useContext)(InternalContext);
  const previous = (0, import_react5.useRef)({
    disabled
  });
  const resizeObserverConnected = (0, import_react5.useRef)(false);
  const rect = (0, import_react5.useRef)(null);
  const callbackId = (0, import_react5.useRef)(null);
  const {
    disabled: resizeObserverDisabled,
    updateMeasurementsFor,
    timeout: resizeObserverTimeout
  } = {
    ...defaultResizeObserverConfig,
    ...resizeObserverConfig
  };
  const ids2 = useLatestValue(updateMeasurementsFor != null ? updateMeasurementsFor : id);
  const handleResize = (0, import_react5.useCallback)(
    () => {
      if (!resizeObserverConnected.current) {
        resizeObserverConnected.current = true;
        return;
      }
      if (callbackId.current != null) {
        clearTimeout(callbackId.current);
      }
      callbackId.current = setTimeout(() => {
        measureDroppableContainers(Array.isArray(ids2.current) ? ids2.current : [ids2.current]);
        callbackId.current = null;
      }, resizeObserverTimeout);
    },
    //eslint-disable-next-line react-hooks/exhaustive-deps
    [resizeObserverTimeout]
  );
  const resizeObserver2 = useResizeObserver({
    callback: handleResize,
    disabled: resizeObserverDisabled || !active
  });
  const handleNodeChange = (0, import_react5.useCallback)((newElement, previousElement) => {
    if (!resizeObserver2) {
      return;
    }
    if (previousElement) {
      resizeObserver2.unobserve(previousElement);
      resizeObserverConnected.current = false;
    }
    if (newElement) {
      resizeObserver2.observe(newElement);
    }
  }, [resizeObserver2]);
  const [nodeRef, setNodeRef] = useNodeRef(handleNodeChange);
  const dataRef = useLatestValue(data2);
  (0, import_react5.useEffect)(() => {
    if (!resizeObserver2 || !nodeRef.current) {
      return;
    }
    resizeObserver2.disconnect();
    resizeObserverConnected.current = false;
    resizeObserver2.observe(nodeRef.current);
  }, [nodeRef, resizeObserver2]);
  (0, import_react5.useEffect)(
    () => {
      dispatch2({
        type: Action.RegisterDroppable,
        element: {
          id,
          key: key2,
          disabled,
          node: nodeRef,
          rect,
          data: dataRef
        }
      });
      return () => dispatch2({
        type: Action.UnregisterDroppable,
        key: key2,
        id
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [id]
  );
  (0, import_react5.useEffect)(() => {
    if (disabled !== previous.current.disabled) {
      dispatch2({
        type: Action.SetDroppableDisabled,
        id,
        key: key2,
        disabled
      });
      previous.current.disabled = disabled;
    }
  }, [id, key2, disabled, dispatch2]);
  return {
    active,
    rect,
    isOver: (over == null ? void 0 : over.id) === id,
    node: nodeRef,
    over,
    setNodeRef
  };
}
function AnimationManager(_ref) {
  let {
    animation,
    children
  } = _ref;
  const [clonedChildren, setClonedChildren] = (0, import_react5.useState)(null);
  const [element, setElement] = (0, import_react5.useState)(null);
  const previousChildren = usePrevious(children);
  if (!children && !clonedChildren && previousChildren) {
    setClonedChildren(previousChildren);
  }
  useIsomorphicLayoutEffect(() => {
    if (!element) {
      return;
    }
    const key2 = clonedChildren == null ? void 0 : clonedChildren.key;
    const id = clonedChildren == null ? void 0 : clonedChildren.props.id;
    if (key2 == null || id == null) {
      setClonedChildren(null);
      return;
    }
    Promise.resolve(animation(id, element)).then(() => {
      setClonedChildren(null);
    });
  }, [animation, clonedChildren, element]);
  return import_react5.default.createElement(import_react5.default.Fragment, null, children, clonedChildren ? (0, import_react5.cloneElement)(clonedChildren, {
    ref: setElement
  }) : null);
}
var defaultTransform = {
  x: 0,
  y: 0,
  scaleX: 1,
  scaleY: 1
};
function NullifiedContextProvider(_ref) {
  let {
    children
  } = _ref;
  return import_react5.default.createElement(InternalContext.Provider, {
    value: defaultInternalContext
  }, import_react5.default.createElement(ActiveDraggableContext.Provider, {
    value: defaultTransform
  }, children));
}
var baseStyles = {
  position: "fixed",
  touchAction: "none"
};
var defaultTransition = (activatorEvent) => {
  const isKeyboardActivator = isKeyboardEvent(activatorEvent);
  return isKeyboardActivator ? "transform 250ms ease" : void 0;
};
var PositionedOverlay = /* @__PURE__ */ (0, import_react5.forwardRef)((_ref, ref3) => {
  let {
    as,
    activatorEvent,
    adjustScale: adjustScale2,
    children,
    className: className2,
    rect,
    style: style2,
    transform,
    transition = defaultTransition
  } = _ref;
  if (!rect) {
    return null;
  }
  const scaleAdjustedTransform = adjustScale2 ? transform : {
    ...transform,
    scaleX: 1,
    scaleY: 1
  };
  const styles = {
    ...baseStyles,
    width: rect.width,
    height: rect.height,
    top: rect.top,
    left: rect.left,
    transform: CSS2.Transform.toString(scaleAdjustedTransform),
    transformOrigin: adjustScale2 && activatorEvent ? getRelativeTransformOrigin(activatorEvent, rect) : void 0,
    transition: typeof transition === "function" ? transition(activatorEvent) : transition,
    ...style2
  };
  return import_react5.default.createElement(as, {
    className: className2,
    style: styles,
    ref: ref3
  }, children);
});
var defaultDropAnimationSideEffects = (options) => (_ref) => {
  let {
    active,
    dragOverlay
  } = _ref;
  const originalStyles = {};
  const {
    styles,
    className: className2
  } = options;
  if (styles != null && styles.active) {
    for (const [key2, value] of Object.entries(styles.active)) {
      if (value === void 0) {
        continue;
      }
      originalStyles[key2] = active.node.style.getPropertyValue(key2);
      active.node.style.setProperty(key2, value);
    }
  }
  if (styles != null && styles.dragOverlay) {
    for (const [key2, value] of Object.entries(styles.dragOverlay)) {
      if (value === void 0) {
        continue;
      }
      dragOverlay.node.style.setProperty(key2, value);
    }
  }
  if (className2 != null && className2.active) {
    active.node.classList.add(className2.active);
  }
  if (className2 != null && className2.dragOverlay) {
    dragOverlay.node.classList.add(className2.dragOverlay);
  }
  return function cleanup2() {
    for (const [key2, value] of Object.entries(originalStyles)) {
      active.node.style.setProperty(key2, value);
    }
    if (className2 != null && className2.active) {
      active.node.classList.remove(className2.active);
    }
  };
};
var defaultKeyframeResolver = (_ref2) => {
  let {
    transform: {
      initial,
      final
    }
  } = _ref2;
  return [{
    transform: CSS2.Transform.toString(initial)
  }, {
    transform: CSS2.Transform.toString(final)
  }];
};
var defaultDropAnimationConfiguration = {
  duration: 250,
  easing: "ease",
  keyframes: defaultKeyframeResolver,
  sideEffects: /* @__PURE__ */ defaultDropAnimationSideEffects({
    styles: {
      active: {
        opacity: "0"
      }
    }
  })
};
function useDropAnimation(_ref3) {
  let {
    config,
    draggableNodes,
    droppableContainers,
    measuringConfiguration
  } = _ref3;
  return useEvent((id, node2) => {
    if (config === null) {
      return;
    }
    const activeDraggable = draggableNodes.get(id);
    if (!activeDraggable) {
      return;
    }
    const activeNode = activeDraggable.node.current;
    if (!activeNode) {
      return;
    }
    const measurableNode = getMeasurableNode(node2);
    if (!measurableNode) {
      return;
    }
    const {
      transform
    } = getWindow(node2).getComputedStyle(node2);
    const parsedTransform = parseTransform(transform);
    if (!parsedTransform) {
      return;
    }
    const animation = typeof config === "function" ? config : createDefaultDropAnimation(config);
    scrollIntoViewIfNeeded(activeNode, measuringConfiguration.draggable.measure);
    return animation({
      active: {
        id,
        data: activeDraggable.data,
        node: activeNode,
        rect: measuringConfiguration.draggable.measure(activeNode)
      },
      draggableNodes,
      dragOverlay: {
        node: node2,
        rect: measuringConfiguration.dragOverlay.measure(measurableNode)
      },
      droppableContainers,
      measuringConfiguration,
      transform: parsedTransform
    });
  });
}
function createDefaultDropAnimation(options) {
  const {
    duration,
    easing,
    sideEffects,
    keyframes
  } = {
    ...defaultDropAnimationConfiguration,
    ...options
  };
  return (_ref4) => {
    let {
      active,
      dragOverlay,
      transform,
      ...rest
    } = _ref4;
    if (!duration) {
      return;
    }
    const delta = {
      x: dragOverlay.rect.left - active.rect.left,
      y: dragOverlay.rect.top - active.rect.top
    };
    const scale = {
      scaleX: transform.scaleX !== 1 ? active.rect.width * transform.scaleX / dragOverlay.rect.width : 1,
      scaleY: transform.scaleY !== 1 ? active.rect.height * transform.scaleY / dragOverlay.rect.height : 1
    };
    const finalTransform = {
      x: transform.x - delta.x,
      y: transform.y - delta.y,
      ...scale
    };
    const animationKeyframes = keyframes({
      ...rest,
      active,
      dragOverlay,
      transform: {
        initial: transform,
        final: finalTransform
      }
    });
    const [firstKeyframe] = animationKeyframes;
    const lastKeyframe = animationKeyframes[animationKeyframes.length - 1];
    if (JSON.stringify(firstKeyframe) === JSON.stringify(lastKeyframe)) {
      return;
    }
    const cleanup2 = sideEffects == null ? void 0 : sideEffects({
      active,
      dragOverlay,
      ...rest
    });
    const animation = dragOverlay.node.animate(animationKeyframes, {
      duration,
      easing,
      fill: "forwards"
    });
    return new Promise((resolve) => {
      animation.onfinish = () => {
        cleanup2 == null ? void 0 : cleanup2();
        resolve();
      };
    });
  };
}
var key = 0;
function useKey(id) {
  return (0, import_react5.useMemo)(() => {
    if (id == null) {
      return;
    }
    key++;
    return key;
  }, [id]);
}
var DragOverlay = /* @__PURE__ */ import_react5.default.memo((_ref) => {
  let {
    adjustScale: adjustScale2 = false,
    children,
    dropAnimation: dropAnimationConfig,
    style: style2,
    transition,
    modifiers,
    wrapperElement = "div",
    className: className2,
    zIndex = 999
  } = _ref;
  const {
    activatorEvent,
    active,
    activeNodeRect,
    containerNodeRect,
    draggableNodes,
    droppableContainers,
    dragOverlay,
    over,
    measuringConfiguration,
    scrollableAncestors,
    scrollableAncestorRects,
    windowRect
  } = useDndContext();
  const transform = (0, import_react5.useContext)(ActiveDraggableContext);
  const key2 = useKey(active == null ? void 0 : active.id);
  const modifiedTransform = applyModifiers(modifiers, {
    activatorEvent,
    active,
    activeNodeRect,
    containerNodeRect,
    draggingNodeRect: dragOverlay.rect,
    over,
    overlayNodeRect: dragOverlay.rect,
    scrollableAncestors,
    scrollableAncestorRects,
    transform,
    windowRect
  });
  const initialRect = useInitialValue(activeNodeRect);
  const dropAnimation = useDropAnimation({
    config: dropAnimationConfig,
    draggableNodes,
    droppableContainers,
    measuringConfiguration
  });
  const ref3 = initialRect ? dragOverlay.setRef : void 0;
  return import_react5.default.createElement(NullifiedContextProvider, null, import_react5.default.createElement(AnimationManager, {
    animation: dropAnimation
  }, active && key2 ? import_react5.default.createElement(PositionedOverlay, {
    key: key2,
    id: active.id,
    ref: ref3,
    as: wrapperElement,
    activatorEvent,
    adjustScale: adjustScale2,
    className: className2,
    transition,
    rect: initialRect,
    style: {
      zIndex,
      ...style2
    },
    transform: modifiedTransform
  }, children) : null));
});

// src/components/Designer/RightSidebar/index.tsx
var import_react226 = __toESM(require_react());

// ../../node_modules/@babel/runtime/helpers/esm/extends.js
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n2) {
    for (var e3 = 1; e3 < arguments.length; e3++) {
      var t2 = arguments[e3];
      for (var r2 in t2) ({}).hasOwnProperty.call(t2, r2) && (n2[r2] = t2[r2]);
    }
    return n2;
  }, _extends.apply(null, arguments);
}

// ../../node_modules/rc-resize-observer/es/index.js
var React9 = __toESM(require_react());

// ../../node_modules/@babel/runtime/helpers/esm/typeof.js
function _typeof(o3) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o4) {
    return typeof o4;
  } : function(o4) {
    return o4 && "function" == typeof Symbol && o4.constructor === Symbol && o4 !== Symbol.prototype ? "symbol" : typeof o4;
  }, _typeof(o3);
}

// ../../node_modules/rc-util/es/React/isFragment.js
var REACT_ELEMENT_TYPE_18 = Symbol.for("react.element");
var REACT_ELEMENT_TYPE_19 = Symbol.for("react.transitional.element");
var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function isFragment(object4) {
  return (
    // Base object type
    object4 && _typeof(object4) === "object" && // React Element type
    (object4.$$typeof === REACT_ELEMENT_TYPE_18 || object4.$$typeof === REACT_ELEMENT_TYPE_19) && // React Fragment type
    object4.type === REACT_FRAGMENT_TYPE
  );
}

// ../../node_modules/rc-util/es/Children/toArray.js
var import_react6 = __toESM(require_react());
function toArray(children) {
  var option = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var ret = [];
  import_react6.default.Children.forEach(children, function(child) {
    if ((child === void 0 || child === null) && !option.keepEmpty) {
      return;
    }
    if (Array.isArray(child)) {
      ret = ret.concat(toArray(child));
    } else if (isFragment(child) && child.props) {
      ret = ret.concat(toArray(child.props.children, option));
    } else {
      ret.push(child);
    }
  });
  return ret;
}

// ../../node_modules/rc-util/es/warning.js
var warned = {};
var preWarningFns = [];
var preMessage = function preMessage2(fn) {
  preWarningFns.push(fn);
};
function warning(valid, message2) {
  if (!valid && console !== void 0) {
    var finalMessage = preWarningFns.reduce(function(msg, preMessageFn) {
      return preMessageFn(msg !== null && msg !== void 0 ? msg : "", "warning");
    }, message2);
    if (finalMessage) {
      console.error("Warning: ".concat(finalMessage));
    }
  }
}
function note(valid, message2) {
  if (!valid && console !== void 0) {
    var finalMessage = preWarningFns.reduce(function(msg, preMessageFn) {
      return preMessageFn(msg !== null && msg !== void 0 ? msg : "", "note");
    }, message2);
    if (finalMessage) {
      console.warn("Note: ".concat(finalMessage));
    }
  }
}
function resetWarned() {
  warned = {};
}
function call(method4, valid, message2) {
  if (!valid && !warned[message2]) {
    method4(false, message2);
    warned[message2] = true;
  }
}
function warningOnce(valid, message2) {
  call(warning, valid, message2);
}
function noteOnce(valid, message2) {
  call(note, valid, message2);
}
warningOnce.preMessage = preMessage;
warningOnce.resetWarned = resetWarned;
warningOnce.noteOnce = noteOnce;
var warning_default = warningOnce;

// ../../node_modules/@babel/runtime/helpers/esm/toPrimitive.js
function toPrimitive(t2, r2) {
  if ("object" != _typeof(t2) || !t2) return t2;
  var e3 = t2[Symbol.toPrimitive];
  if (void 0 !== e3) {
    var i = e3.call(t2, r2 || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t2);
}

// ../../node_modules/@babel/runtime/helpers/esm/toPropertyKey.js
function toPropertyKey(t2) {
  var i = toPrimitive(t2, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}

// ../../node_modules/@babel/runtime/helpers/esm/defineProperty.js
function _defineProperty(e3, r2, t2) {
  return (r2 = toPropertyKey(r2)) in e3 ? Object.defineProperty(e3, r2, {
    value: t2,
    enumerable: true,
    configurable: true,
    writable: true
  }) : e3[r2] = t2, e3;
}

// ../../node_modules/@babel/runtime/helpers/esm/objectSpread2.js
function ownKeys(e3, r2) {
  var t2 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o3 = Object.getOwnPropertySymbols(e3);
    r2 && (o3 = o3.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t2.push.apply(t2, o3);
  }
  return t2;
}
function _objectSpread2(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t2 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys(Object(t2), true).forEach(function(r3) {
      _defineProperty(e3, r3, t2[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t2)) : ownKeys(Object(t2)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t2, r3));
    });
  }
  return e3;
}

// ../../node_modules/rc-util/es/Dom/findDOMNode.js
var import_react7 = __toESM(require_react());
var import_react_dom3 = __toESM(require_react_dom());
function isDOM(node2) {
  return node2 instanceof HTMLElement || node2 instanceof SVGElement;
}
function getDOM(node2) {
  if (node2 && _typeof(node2) === "object" && isDOM(node2.nativeElement)) {
    return node2.nativeElement;
  }
  if (isDOM(node2)) {
    return node2;
  }
  return null;
}
function findDOMNode(node2) {
  var domNode = getDOM(node2);
  if (domNode) {
    return domNode;
  }
  if (node2 instanceof import_react7.default.Component) {
    var _ReactDOM$findDOMNode;
    return (_ReactDOM$findDOMNode = import_react_dom3.default.findDOMNode) === null || _ReactDOM$findDOMNode === void 0 ? void 0 : _ReactDOM$findDOMNode.call(import_react_dom3.default, node2);
  }
  return null;
}

// ../../node_modules/rc-util/es/ref.js
var import_react8 = __toESM(require_react());
var import_react_is = __toESM(require_react_is());

// ../../node_modules/rc-util/es/hooks/useMemo.js
var React5 = __toESM(require_react());
function useMemo3(getValue4, condition, shouldUpdate) {
  var cacheRef = React5.useRef({});
  if (!("value" in cacheRef.current) || shouldUpdate(cacheRef.current.condition, condition)) {
    cacheRef.current.value = getValue4();
    cacheRef.current.condition = condition;
  }
  return cacheRef.current.value;
}

// ../../node_modules/rc-util/es/ref.js
var ReactMajorVersion = Number(import_react8.version.split(".")[0]);
var fillRef = function fillRef2(ref3, node2) {
  if (typeof ref3 === "function") {
    ref3(node2);
  } else if (_typeof(ref3) === "object" && ref3 && "current" in ref3) {
    ref3.current = node2;
  }
};
var composeRef = function composeRef2() {
  for (var _len = arguments.length, refs2 = new Array(_len), _key = 0; _key < _len; _key++) {
    refs2[_key] = arguments[_key];
  }
  var refList = refs2.filter(Boolean);
  if (refList.length <= 1) {
    return refList[0];
  }
  return function(node2) {
    refs2.forEach(function(ref3) {
      fillRef(ref3, node2);
    });
  };
};
var useComposeRef = function useComposeRef2() {
  for (var _len2 = arguments.length, refs2 = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    refs2[_key2] = arguments[_key2];
  }
  return useMemo3(function() {
    return composeRef.apply(void 0, refs2);
  }, refs2, function(prev2, next2) {
    return prev2.length !== next2.length || prev2.every(function(ref3, i) {
      return ref3 !== next2[i];
    });
  });
};
var supportRef = function supportRef2(nodeOrComponent) {
  var _type$prototype, _nodeOrComponent$prot;
  if (!nodeOrComponent) {
    return false;
  }
  if (isReactElement(nodeOrComponent) && ReactMajorVersion >= 19) {
    return true;
  }
  var type5 = (0, import_react_is.isMemo)(nodeOrComponent) ? nodeOrComponent.type.type : nodeOrComponent.type;
  if (typeof type5 === "function" && !((_type$prototype = type5.prototype) !== null && _type$prototype !== void 0 && _type$prototype.render) && type5.$$typeof !== import_react_is.ForwardRef) {
    return false;
  }
  if (typeof nodeOrComponent === "function" && !((_nodeOrComponent$prot = nodeOrComponent.prototype) !== null && _nodeOrComponent$prot !== void 0 && _nodeOrComponent$prot.render) && nodeOrComponent.$$typeof !== import_react_is.ForwardRef) {
    return false;
  }
  return true;
};
function isReactElement(node2) {
  return /* @__PURE__ */ (0, import_react8.isValidElement)(node2) && !isFragment(node2);
}
var supportNodeRef = function supportNodeRef2(node2) {
  return isReactElement(node2) && supportRef(node2);
};
var getNodeRef = function getNodeRef2(node2) {
  if (node2 && isReactElement(node2)) {
    var ele = node2;
    return ele.props.propertyIsEnumerable("ref") ? ele.props.ref : ele.ref;
  }
  return null;
};

// ../../node_modules/rc-resize-observer/es/SingleObserver/index.js
var React8 = __toESM(require_react());

// ../../node_modules/rc-resize-observer/es/Collection.js
var React6 = __toESM(require_react());
var CollectionContext = /* @__PURE__ */ React6.createContext(null);
function Collection(_ref) {
  var children = _ref.children, onBatchResize = _ref.onBatchResize;
  var resizeIdRef = React6.useRef(0);
  var resizeInfosRef = React6.useRef([]);
  var onCollectionResize = React6.useContext(CollectionContext);
  var onResize2 = React6.useCallback(function(size, element, data2) {
    resizeIdRef.current += 1;
    var currentId = resizeIdRef.current;
    resizeInfosRef.current.push({
      size,
      element,
      data: data2
    });
    Promise.resolve().then(function() {
      if (currentId === resizeIdRef.current) {
        onBatchResize === null || onBatchResize === void 0 || onBatchResize(resizeInfosRef.current);
        resizeInfosRef.current = [];
      }
    });
    onCollectionResize === null || onCollectionResize === void 0 || onCollectionResize(size, element, data2);
  }, [onBatchResize, onCollectionResize]);
  return /* @__PURE__ */ React6.createElement(CollectionContext.Provider, {
    value: onResize2
  }, children);
}

// ../../node_modules/resize-observer-polyfill/dist/ResizeObserver.es.js
var MapShim = (function() {
  if (typeof Map !== "undefined") {
    return Map;
  }
  function getIndex2(arr, key2) {
    var result = -1;
    arr.some(function(entry, index3) {
      if (entry[0] === key2) {
        result = index3;
        return true;
      }
      return false;
    });
    return result;
  }
  return (
    /** @class */
    (function() {
      function class_1() {
        this.__entries__ = [];
      }
      Object.defineProperty(class_1.prototype, "size", {
        /**
         * @returns {boolean}
         */
        get: function() {
          return this.__entries__.length;
        },
        enumerable: true,
        configurable: true
      });
      class_1.prototype.get = function(key2) {
        var index3 = getIndex2(this.__entries__, key2);
        var entry = this.__entries__[index3];
        return entry && entry[1];
      };
      class_1.prototype.set = function(key2, value) {
        var index3 = getIndex2(this.__entries__, key2);
        if (~index3) {
          this.__entries__[index3][1] = value;
        } else {
          this.__entries__.push([key2, value]);
        }
      };
      class_1.prototype.delete = function(key2) {
        var entries = this.__entries__;
        var index3 = getIndex2(entries, key2);
        if (~index3) {
          entries.splice(index3, 1);
        }
      };
      class_1.prototype.has = function(key2) {
        return !!~getIndex2(this.__entries__, key2);
      };
      class_1.prototype.clear = function() {
        this.__entries__.splice(0);
      };
      class_1.prototype.forEach = function(callback, ctx) {
        if (ctx === void 0) {
          ctx = null;
        }
        for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
          var entry = _a[_i];
          callback.call(ctx, entry[1], entry[0]);
        }
      };
      return class_1;
    })()
  );
})();
var isBrowser = typeof window !== "undefined" && typeof document !== "undefined" && window.document === document;
var global$1 = (function() {
  if (typeof global !== "undefined" && global.Math === Math) {
    return global;
  }
  if (typeof self !== "undefined" && self.Math === Math) {
    return self;
  }
  if (typeof window !== "undefined" && window.Math === Math) {
    return window;
  }
  return Function("return this")();
})();
var requestAnimationFrame$1 = (function() {
  if (typeof requestAnimationFrame === "function") {
    return requestAnimationFrame.bind(global$1);
  }
  return function(callback) {
    return setTimeout(function() {
      return callback(Date.now());
    }, 1e3 / 60);
  };
})();
var trailingTimeout = 2;
function throttle(callback, delay) {
  var leadingCall = false, trailingCall = false, lastCallTime = 0;
  function resolvePending() {
    if (leadingCall) {
      leadingCall = false;
      callback();
    }
    if (trailingCall) {
      proxy();
    }
  }
  function timeoutCallback() {
    requestAnimationFrame$1(resolvePending);
  }
  function proxy() {
    var timeStamp = Date.now();
    if (leadingCall) {
      if (timeStamp - lastCallTime < trailingTimeout) {
        return;
      }
      trailingCall = true;
    } else {
      leadingCall = true;
      trailingCall = false;
      setTimeout(timeoutCallback, delay);
    }
    lastCallTime = timeStamp;
  }
  return proxy;
}
var REFRESH_DELAY = 20;
var transitionKeys = ["top", "right", "bottom", "left", "width", "height", "size", "weight"];
var mutationObserverSupported = typeof MutationObserver !== "undefined";
var ResizeObserverController = (
  /** @class */
  (function() {
    function ResizeObserverController2() {
      this.connected_ = false;
      this.mutationEventsAdded_ = false;
      this.mutationsObserver_ = null;
      this.observers_ = [];
      this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
      this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    ResizeObserverController2.prototype.addObserver = function(observer) {
      if (!~this.observers_.indexOf(observer)) {
        this.observers_.push(observer);
      }
      if (!this.connected_) {
        this.connect_();
      }
    };
    ResizeObserverController2.prototype.removeObserver = function(observer) {
      var observers2 = this.observers_;
      var index3 = observers2.indexOf(observer);
      if (~index3) {
        observers2.splice(index3, 1);
      }
      if (!observers2.length && this.connected_) {
        this.disconnect_();
      }
    };
    ResizeObserverController2.prototype.refresh = function() {
      var changesDetected = this.updateObservers_();
      if (changesDetected) {
        this.refresh();
      }
    };
    ResizeObserverController2.prototype.updateObservers_ = function() {
      var activeObservers = this.observers_.filter(function(observer) {
        return observer.gatherActive(), observer.hasActive();
      });
      activeObservers.forEach(function(observer) {
        return observer.broadcastActive();
      });
      return activeObservers.length > 0;
    };
    ResizeObserverController2.prototype.connect_ = function() {
      if (!isBrowser || this.connected_) {
        return;
      }
      document.addEventListener("transitionend", this.onTransitionEnd_);
      window.addEventListener("resize", this.refresh);
      if (mutationObserverSupported) {
        this.mutationsObserver_ = new MutationObserver(this.refresh);
        this.mutationsObserver_.observe(document, {
          attributes: true,
          childList: true,
          characterData: true,
          subtree: true
        });
      } else {
        document.addEventListener("DOMSubtreeModified", this.refresh);
        this.mutationEventsAdded_ = true;
      }
      this.connected_ = true;
    };
    ResizeObserverController2.prototype.disconnect_ = function() {
      if (!isBrowser || !this.connected_) {
        return;
      }
      document.removeEventListener("transitionend", this.onTransitionEnd_);
      window.removeEventListener("resize", this.refresh);
      if (this.mutationsObserver_) {
        this.mutationsObserver_.disconnect();
      }
      if (this.mutationEventsAdded_) {
        document.removeEventListener("DOMSubtreeModified", this.refresh);
      }
      this.mutationsObserver_ = null;
      this.mutationEventsAdded_ = false;
      this.connected_ = false;
    };
    ResizeObserverController2.prototype.onTransitionEnd_ = function(_a) {
      var _b = _a.propertyName, propertyName = _b === void 0 ? "" : _b;
      var isReflowProperty = transitionKeys.some(function(key2) {
        return !!~propertyName.indexOf(key2);
      });
      if (isReflowProperty) {
        this.refresh();
      }
    };
    ResizeObserverController2.getInstance = function() {
      if (!this.instance_) {
        this.instance_ = new ResizeObserverController2();
      }
      return this.instance_;
    };
    ResizeObserverController2.instance_ = null;
    return ResizeObserverController2;
  })()
);
var defineConfigurable = (function(target, props) {
  for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
    var key2 = _a[_i];
    Object.defineProperty(target, key2, {
      value: props[key2],
      enumerable: false,
      writable: false,
      configurable: true
    });
  }
  return target;
});
var getWindowOf = (function(target) {
  var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
  return ownerGlobal || global$1;
});
var emptyRect = createRectInit(0, 0, 0, 0);
function toFloat(value) {
  return parseFloat(value) || 0;
}
function getBordersSize(styles) {
  var positions = [];
  for (var _i = 1; _i < arguments.length; _i++) {
    positions[_i - 1] = arguments[_i];
  }
  return positions.reduce(function(size, position3) {
    var value = styles["border-" + position3 + "-width"];
    return size + toFloat(value);
  }, 0);
}
function getPaddings(styles) {
  var positions = ["top", "right", "bottom", "left"];
  var paddings = {};
  for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
    var position3 = positions_1[_i];
    var value = styles["padding-" + position3];
    paddings[position3] = toFloat(value);
  }
  return paddings;
}
function getSVGContentRect(target) {
  var bbox = target.getBBox();
  return createRectInit(0, 0, bbox.width, bbox.height);
}
function getHTMLElementContentRect(target) {
  var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
  if (!clientWidth && !clientHeight) {
    return emptyRect;
  }
  var styles = getWindowOf(target).getComputedStyle(target);
  var paddings = getPaddings(styles);
  var horizPad = paddings.left + paddings.right;
  var vertPad = paddings.top + paddings.bottom;
  var width = toFloat(styles.width), height = toFloat(styles.height);
  if (styles.boxSizing === "border-box") {
    if (Math.round(width + horizPad) !== clientWidth) {
      width -= getBordersSize(styles, "left", "right") + horizPad;
    }
    if (Math.round(height + vertPad) !== clientHeight) {
      height -= getBordersSize(styles, "top", "bottom") + vertPad;
    }
  }
  if (!isDocumentElement(target)) {
    var vertScrollbar = Math.round(width + horizPad) - clientWidth;
    var horizScrollbar = Math.round(height + vertPad) - clientHeight;
    if (Math.abs(vertScrollbar) !== 1) {
      width -= vertScrollbar;
    }
    if (Math.abs(horizScrollbar) !== 1) {
      height -= horizScrollbar;
    }
  }
  return createRectInit(paddings.left, paddings.top, width, height);
}
var isSVGGraphicsElement = (function() {
  if (typeof SVGGraphicsElement !== "undefined") {
    return function(target) {
      return target instanceof getWindowOf(target).SVGGraphicsElement;
    };
  }
  return function(target) {
    return target instanceof getWindowOf(target).SVGElement && typeof target.getBBox === "function";
  };
})();
function isDocumentElement(target) {
  return target === getWindowOf(target).document.documentElement;
}
function getContentRect(target) {
  if (!isBrowser) {
    return emptyRect;
  }
  if (isSVGGraphicsElement(target)) {
    return getSVGContentRect(target);
  }
  return getHTMLElementContentRect(target);
}
function createReadOnlyRect(_a) {
  var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
  var Constr = typeof DOMRectReadOnly !== "undefined" ? DOMRectReadOnly : Object;
  var rect = Object.create(Constr.prototype);
  defineConfigurable(rect, {
    x,
    y,
    width,
    height,
    top: y,
    right: x + width,
    bottom: height + y,
    left: x
  });
  return rect;
}
function createRectInit(x, y, width, height) {
  return { x, y, width, height };
}
var ResizeObservation = (
  /** @class */
  (function() {
    function ResizeObservation2(target) {
      this.broadcastWidth = 0;
      this.broadcastHeight = 0;
      this.contentRect_ = createRectInit(0, 0, 0, 0);
      this.target = target;
    }
    ResizeObservation2.prototype.isActive = function() {
      var rect = getContentRect(this.target);
      this.contentRect_ = rect;
      return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
    };
    ResizeObservation2.prototype.broadcastRect = function() {
      var rect = this.contentRect_;
      this.broadcastWidth = rect.width;
      this.broadcastHeight = rect.height;
      return rect;
    };
    return ResizeObservation2;
  })()
);
var ResizeObserverEntry = (
  /** @class */
  /* @__PURE__ */ (function() {
    function ResizeObserverEntry2(target, rectInit) {
      var contentRect = createReadOnlyRect(rectInit);
      defineConfigurable(this, { target, contentRect });
    }
    return ResizeObserverEntry2;
  })()
);
var ResizeObserverSPI = (
  /** @class */
  (function() {
    function ResizeObserverSPI2(callback, controller, callbackCtx) {
      this.activeObservations_ = [];
      this.observations_ = new MapShim();
      if (typeof callback !== "function") {
        throw new TypeError("The callback provided as parameter 1 is not a function.");
      }
      this.callback_ = callback;
      this.controller_ = controller;
      this.callbackCtx_ = callbackCtx;
    }
    ResizeObserverSPI2.prototype.observe = function(target) {
      if (!arguments.length) {
        throw new TypeError("1 argument required, but only 0 present.");
      }
      if (typeof Element === "undefined" || !(Element instanceof Object)) {
        return;
      }
      if (!(target instanceof getWindowOf(target).Element)) {
        throw new TypeError('parameter 1 is not of type "Element".');
      }
      var observations = this.observations_;
      if (observations.has(target)) {
        return;
      }
      observations.set(target, new ResizeObservation(target));
      this.controller_.addObserver(this);
      this.controller_.refresh();
    };
    ResizeObserverSPI2.prototype.unobserve = function(target) {
      if (!arguments.length) {
        throw new TypeError("1 argument required, but only 0 present.");
      }
      if (typeof Element === "undefined" || !(Element instanceof Object)) {
        return;
      }
      if (!(target instanceof getWindowOf(target).Element)) {
        throw new TypeError('parameter 1 is not of type "Element".');
      }
      var observations = this.observations_;
      if (!observations.has(target)) {
        return;
      }
      observations.delete(target);
      if (!observations.size) {
        this.controller_.removeObserver(this);
      }
    };
    ResizeObserverSPI2.prototype.disconnect = function() {
      this.clearActive();
      this.observations_.clear();
      this.controller_.removeObserver(this);
    };
    ResizeObserverSPI2.prototype.gatherActive = function() {
      var _this = this;
      this.clearActive();
      this.observations_.forEach(function(observation) {
        if (observation.isActive()) {
          _this.activeObservations_.push(observation);
        }
      });
    };
    ResizeObserverSPI2.prototype.broadcastActive = function() {
      if (!this.hasActive()) {
        return;
      }
      var ctx = this.callbackCtx_;
      var entries = this.activeObservations_.map(function(observation) {
        return new ResizeObserverEntry(observation.target, observation.broadcastRect());
      });
      this.callback_.call(ctx, entries, ctx);
      this.clearActive();
    };
    ResizeObserverSPI2.prototype.clearActive = function() {
      this.activeObservations_.splice(0);
    };
    ResizeObserverSPI2.prototype.hasActive = function() {
      return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI2;
  })()
);
var observers = typeof WeakMap !== "undefined" ? /* @__PURE__ */ new WeakMap() : new MapShim();
var ResizeObserver2 = (
  /** @class */
  /* @__PURE__ */ (function() {
    function ResizeObserver4(callback) {
      if (!(this instanceof ResizeObserver4)) {
        throw new TypeError("Cannot call a class as a function.");
      }
      if (!arguments.length) {
        throw new TypeError("1 argument required, but only 0 present.");
      }
      var controller = ResizeObserverController.getInstance();
      var observer = new ResizeObserverSPI(callback, controller, this);
      observers.set(this, observer);
    }
    return ResizeObserver4;
  })()
);
[
  "observe",
  "unobserve",
  "disconnect"
].forEach(function(method4) {
  ResizeObserver2.prototype[method4] = function() {
    var _a;
    return (_a = observers.get(this))[method4].apply(_a, arguments);
  };
});
var index = (function() {
  if (typeof global$1.ResizeObserver !== "undefined") {
    return global$1.ResizeObserver;
  }
  return ResizeObserver2;
})();
var ResizeObserver_es_default = index;

// ../../node_modules/rc-resize-observer/es/utils/observerUtil.js
var elementListeners = /* @__PURE__ */ new Map();
function onResize(entities) {
  entities.forEach(function(entity) {
    var _elementListeners$get;
    var target = entity.target;
    (_elementListeners$get = elementListeners.get(target)) === null || _elementListeners$get === void 0 || _elementListeners$get.forEach(function(listener) {
      return listener(target);
    });
  });
}
var resizeObserver = new ResizeObserver_es_default(onResize);
function observe(element, callback) {
  if (!elementListeners.has(element)) {
    elementListeners.set(element, /* @__PURE__ */ new Set());
    resizeObserver.observe(element);
  }
  elementListeners.get(element).add(callback);
}
function unobserve(element, callback) {
  if (elementListeners.has(element)) {
    elementListeners.get(element).delete(callback);
    if (!elementListeners.get(element).size) {
      resizeObserver.unobserve(element);
      elementListeners.delete(element);
    }
  }
}

// ../../node_modules/@babel/runtime/helpers/esm/classCallCheck.js
function _classCallCheck(a, n2) {
  if (!(a instanceof n2)) throw new TypeError("Cannot call a class as a function");
}

// ../../node_modules/@babel/runtime/helpers/esm/createClass.js
function _defineProperties(e3, r2) {
  for (var t2 = 0; t2 < r2.length; t2++) {
    var o3 = r2[t2];
    o3.enumerable = o3.enumerable || false, o3.configurable = true, "value" in o3 && (o3.writable = true), Object.defineProperty(e3, toPropertyKey(o3.key), o3);
  }
}
function _createClass(e3, r2, t2) {
  return r2 && _defineProperties(e3.prototype, r2), t2 && _defineProperties(e3, t2), Object.defineProperty(e3, "prototype", {
    writable: false
  }), e3;
}

// ../../node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
function _setPrototypeOf(t2, e3) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t3, e4) {
    return t3.__proto__ = e4, t3;
  }, _setPrototypeOf(t2, e3);
}

// ../../node_modules/@babel/runtime/helpers/esm/inherits.js
function _inherits(t2, e3) {
  if ("function" != typeof e3 && null !== e3) throw new TypeError("Super expression must either be null or a function");
  t2.prototype = Object.create(e3 && e3.prototype, {
    constructor: {
      value: t2,
      writable: true,
      configurable: true
    }
  }), Object.defineProperty(t2, "prototype", {
    writable: false
  }), e3 && _setPrototypeOf(t2, e3);
}

// ../../node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
function _getPrototypeOf(t2) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t3) {
    return t3.__proto__ || Object.getPrototypeOf(t3);
  }, _getPrototypeOf(t2);
}

// ../../node_modules/@babel/runtime/helpers/esm/isNativeReflectConstruct.js
function _isNativeReflectConstruct() {
  try {
    var t2 = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t3) {
  }
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct2() {
    return !!t2;
  })();
}

// ../../node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
function _assertThisInitialized(e3) {
  if (void 0 === e3) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e3;
}

// ../../node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
function _possibleConstructorReturn(t2, e3) {
  if (e3 && ("object" == _typeof(e3) || "function" == typeof e3)) return e3;
  if (void 0 !== e3) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t2);
}

// ../../node_modules/@babel/runtime/helpers/esm/createSuper.js
function _createSuper(t2) {
  var r2 = _isNativeReflectConstruct();
  return function() {
    var e3, o3 = _getPrototypeOf(t2);
    if (r2) {
      var s = _getPrototypeOf(this).constructor;
      e3 = Reflect.construct(o3, arguments, s);
    } else e3 = o3.apply(this, arguments);
    return _possibleConstructorReturn(this, e3);
  };
}

// ../../node_modules/rc-resize-observer/es/SingleObserver/DomWrapper.js
var React7 = __toESM(require_react());
var DomWrapper = /* @__PURE__ */ (function(_React$Component) {
  _inherits(DomWrapper3, _React$Component);
  var _super = _createSuper(DomWrapper3);
  function DomWrapper3() {
    _classCallCheck(this, DomWrapper3);
    return _super.apply(this, arguments);
  }
  _createClass(DomWrapper3, [{
    key: "render",
    value: function render4() {
      return this.props.children;
    }
  }]);
  return DomWrapper3;
})(React7.Component);

// ../../node_modules/rc-resize-observer/es/SingleObserver/index.js
function SingleObserver(props, ref3) {
  var children = props.children, disabled = props.disabled;
  var elementRef = React8.useRef(null);
  var wrapperRef = React8.useRef(null);
  var onCollectionResize = React8.useContext(CollectionContext);
  var isRenderProps = typeof children === "function";
  var mergedChildren = isRenderProps ? children(elementRef) : children;
  var sizeRef = React8.useRef({
    width: -1,
    height: -1,
    offsetWidth: -1,
    offsetHeight: -1
  });
  var canRef = !isRenderProps && /* @__PURE__ */ React8.isValidElement(mergedChildren) && supportRef(mergedChildren);
  var originRef = canRef ? getNodeRef(mergedChildren) : null;
  var mergedRef = useComposeRef(originRef, elementRef);
  var getDom = function getDom2() {
    var _elementRef$current;
    return findDOMNode(elementRef.current) || // Support `nativeElement` format
    (elementRef.current && _typeof(elementRef.current) === "object" ? findDOMNode((_elementRef$current = elementRef.current) === null || _elementRef$current === void 0 ? void 0 : _elementRef$current.nativeElement) : null) || findDOMNode(wrapperRef.current);
  };
  React8.useImperativeHandle(ref3, function() {
    return getDom();
  });
  var propsRef = React8.useRef(props);
  propsRef.current = props;
  var onInternalResize = React8.useCallback(function(target) {
    var _propsRef$current = propsRef.current, onResize2 = _propsRef$current.onResize, data2 = _propsRef$current.data;
    var _target$getBoundingCl = target.getBoundingClientRect(), width = _target$getBoundingCl.width, height = _target$getBoundingCl.height;
    var offsetWidth = target.offsetWidth, offsetHeight = target.offsetHeight;
    var fixedWidth = Math.floor(width);
    var fixedHeight = Math.floor(height);
    if (sizeRef.current.width !== fixedWidth || sizeRef.current.height !== fixedHeight || sizeRef.current.offsetWidth !== offsetWidth || sizeRef.current.offsetHeight !== offsetHeight) {
      var size = {
        width: fixedWidth,
        height: fixedHeight,
        offsetWidth,
        offsetHeight
      };
      sizeRef.current = size;
      var mergedOffsetWidth = offsetWidth === Math.round(width) ? width : offsetWidth;
      var mergedOffsetHeight = offsetHeight === Math.round(height) ? height : offsetHeight;
      var sizeInfo = _objectSpread2(_objectSpread2({}, size), {}, {
        offsetWidth: mergedOffsetWidth,
        offsetHeight: mergedOffsetHeight
      });
      onCollectionResize === null || onCollectionResize === void 0 || onCollectionResize(sizeInfo, target, data2);
      if (onResize2) {
        Promise.resolve().then(function() {
          onResize2(sizeInfo, target);
        });
      }
    }
  }, []);
  React8.useEffect(function() {
    var currentElement = getDom();
    if (currentElement && !disabled) {
      observe(currentElement, onInternalResize);
    }
    return function() {
      return unobserve(currentElement, onInternalResize);
    };
  }, [elementRef.current, disabled]);
  return /* @__PURE__ */ React8.createElement(DomWrapper, {
    ref: wrapperRef
  }, canRef ? /* @__PURE__ */ React8.cloneElement(mergedChildren, {
    ref: mergedRef
  }) : mergedChildren);
}
var RefSingleObserver = /* @__PURE__ */ React8.forwardRef(SingleObserver);
if (true) {
  RefSingleObserver.displayName = "SingleObserver";
}
var SingleObserver_default = RefSingleObserver;

// ../../node_modules/rc-resize-observer/es/index.js
var INTERNAL_PREFIX_KEY = "rc-observer-key";
function ResizeObserver3(props, ref3) {
  var children = props.children;
  var childNodes = typeof children === "function" ? [children] : toArray(children);
  if (true) {
    if (childNodes.length > 1) {
      warning(false, "Find more than one child node with `children` in ResizeObserver. Please use ResizeObserver.Collection instead.");
    } else if (childNodes.length === 0) {
      warning(false, "`children` of ResizeObserver is empty. Nothing is in observe.");
    }
  }
  return childNodes.map(function(child, index3) {
    var key2 = (child === null || child === void 0 ? void 0 : child.key) || "".concat(INTERNAL_PREFIX_KEY, "-").concat(index3);
    return /* @__PURE__ */ React9.createElement(SingleObserver_default, _extends({}, props, {
      key: key2,
      ref: index3 === 0 ? ref3 : void 0
    }), child);
  });
}
var RefResizeObserver = /* @__PURE__ */ React9.forwardRef(ResizeObserver3);
if (true) {
  RefResizeObserver.displayName = "ResizeObserver";
}
RefResizeObserver.Collection = Collection;
var es_default = RefResizeObserver;

// ../../node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
function _arrayLikeToArray(r2, a) {
  (null == a || a > r2.length) && (a = r2.length);
  for (var e3 = 0, n2 = Array(a); e3 < a; e3++) n2[e3] = r2[e3];
  return n2;
}

// ../../node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js
function _arrayWithoutHoles(r2) {
  if (Array.isArray(r2)) return _arrayLikeToArray(r2);
}

// ../../node_modules/@babel/runtime/helpers/esm/iterableToArray.js
function _iterableToArray(r2) {
  if ("undefined" != typeof Symbol && null != r2[Symbol.iterator] || null != r2["@@iterator"]) return Array.from(r2);
}

// ../../node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
function _unsupportedIterableToArray(r2, a) {
  if (r2) {
    if ("string" == typeof r2) return _arrayLikeToArray(r2, a);
    var t2 = {}.toString.call(r2).slice(8, -1);
    return "Object" === t2 && r2.constructor && (t2 = r2.constructor.name), "Map" === t2 || "Set" === t2 ? Array.from(r2) : "Arguments" === t2 || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t2) ? _arrayLikeToArray(r2, a) : void 0;
  }
}

// ../../node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// ../../node_modules/@babel/runtime/helpers/esm/toConsumableArray.js
function _toConsumableArray(r2) {
  return _arrayWithoutHoles(r2) || _iterableToArray(r2) || _unsupportedIterableToArray(r2) || _nonIterableSpread();
}

// ../../node_modules/rc-util/es/raf.js
var raf = function raf2(callback) {
  return +setTimeout(callback, 16);
};
var caf = function caf2(num) {
  return clearTimeout(num);
};
if (typeof window !== "undefined" && "requestAnimationFrame" in window) {
  raf = function raf3(callback) {
    return window.requestAnimationFrame(callback);
  };
  caf = function caf3(handle) {
    return window.cancelAnimationFrame(handle);
  };
}
var rafUUID = 0;
var rafIds = /* @__PURE__ */ new Map();
function cleanup(id) {
  rafIds.delete(id);
}
var wrapperRaf = function wrapperRaf2(callback) {
  var times = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  rafUUID += 1;
  var id = rafUUID;
  function callRef(leftTimes) {
    if (leftTimes === 0) {
      cleanup(id);
      callback();
    } else {
      var realId = raf(function() {
        callRef(leftTimes - 1);
      });
      rafIds.set(id, realId);
    }
  }
  callRef(times);
  return id;
};
wrapperRaf.cancel = function(id) {
  var realId = rafIds.get(id);
  cleanup(id);
  return caf(realId);
};
if (true) {
  wrapperRaf.ids = function() {
    return rafIds;
  };
}
var raf_default = wrapperRaf;

// ../../node_modules/antd/es/config-provider/index.js
var React40 = __toESM(require_react());

// ../../node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles(r2) {
  if (Array.isArray(r2)) return r2;
}

// ../../node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(r2, l2) {
  var t2 = null == r2 ? null : "undefined" != typeof Symbol && r2[Symbol.iterator] || r2["@@iterator"];
  if (null != t2) {
    var e3, n2, i, u, a = [], f = true, o3 = false;
    try {
      if (i = (t2 = t2.call(r2)).next, 0 === l2) {
        if (Object(t2) !== t2) return;
        f = false;
      } else for (; !(f = (e3 = i.call(t2)).done) && (a.push(e3.value), a.length !== l2); f = true) ;
    } catch (r3) {
      o3 = true, n2 = r3;
    } finally {
      try {
        if (!f && null != t2["return"] && (u = t2["return"](), Object(u) !== u)) return;
      } finally {
        if (o3) throw n2;
      }
    }
    return a;
  }
}

// ../../node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js
function _slicedToArray(r2, e3) {
  return _arrayWithHoles(r2) || _iterableToArrayLimit(r2, e3) || _unsupportedIterableToArray(r2, e3) || _nonIterableRest();
}

// ../../node_modules/@emotion/hash/dist/hash.browser.esm.js
function murmur2(str) {
  var h2 = 0;
  var k, i = 0, len = str.length;
  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 255 | (str.charCodeAt(++i) & 255) << 8 | (str.charCodeAt(++i) & 255) << 16 | (str.charCodeAt(++i) & 255) << 24;
    k = /* Math.imul(k, m): */
    (k & 65535) * 1540483477 + ((k >>> 16) * 59797 << 16);
    k ^= /* k >>> r: */
    k >>> 24;
    h2 = /* Math.imul(k, m): */
    (k & 65535) * 1540483477 + ((k >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (h2 & 65535) * 1540483477 + ((h2 >>> 16) * 59797 << 16);
  }
  switch (len) {
    case 3:
      h2 ^= (str.charCodeAt(i + 2) & 255) << 16;
    case 2:
      h2 ^= (str.charCodeAt(i + 1) & 255) << 8;
    case 1:
      h2 ^= str.charCodeAt(i) & 255;
      h2 = /* Math.imul(h, m): */
      (h2 & 65535) * 1540483477 + ((h2 >>> 16) * 59797 << 16);
  }
  h2 ^= h2 >>> 13;
  h2 = /* Math.imul(h, m): */
  (h2 & 65535) * 1540483477 + ((h2 >>> 16) * 59797 << 16);
  return ((h2 ^ h2 >>> 15) >>> 0).toString(36);
}
var hash_browser_esm_default = murmur2;

// ../../node_modules/rc-util/es/Dom/canUseDom.js
function canUseDom() {
  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
}

// ../../node_modules/rc-util/es/Dom/contains.js
function contains(root2, n2) {
  if (!root2) {
    return false;
  }
  if (root2.contains) {
    return root2.contains(n2);
  }
  var node2 = n2;
  while (node2) {
    if (node2 === root2) {
      return true;
    }
    node2 = node2.parentNode;
  }
  return false;
}

// ../../node_modules/rc-util/es/Dom/dynamicCSS.js
var APPEND_ORDER = "data-rc-order";
var APPEND_PRIORITY = "data-rc-priority";
var MARK_KEY = "rc-util-key";
var containerCache = /* @__PURE__ */ new Map();
function getMark() {
  var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, mark = _ref.mark;
  if (mark) {
    return mark.startsWith("data-") ? mark : "data-".concat(mark);
  }
  return MARK_KEY;
}
function getContainer(option) {
  if (option.attachTo) {
    return option.attachTo;
  }
  var head = document.querySelector("head");
  return head || document.body;
}
function getOrder(prepend) {
  if (prepend === "queue") {
    return "prependQueue";
  }
  return prepend ? "prepend" : "append";
}
function findStyles(container) {
  return Array.from((containerCache.get(container) || container).children).filter(function(node2) {
    return node2.tagName === "STYLE";
  });
}
function injectCSS(css2) {
  var option = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (!canUseDom()) {
    return null;
  }
  var csp = option.csp, prepend = option.prepend, _option$priority = option.priority, priority = _option$priority === void 0 ? 0 : _option$priority;
  var mergedOrder = getOrder(prepend);
  var isPrependQueue = mergedOrder === "prependQueue";
  var styleNode = document.createElement("style");
  styleNode.setAttribute(APPEND_ORDER, mergedOrder);
  if (isPrependQueue && priority) {
    styleNode.setAttribute(APPEND_PRIORITY, "".concat(priority));
  }
  if (csp !== null && csp !== void 0 && csp.nonce) {
    styleNode.nonce = csp === null || csp === void 0 ? void 0 : csp.nonce;
  }
  styleNode.innerHTML = css2;
  var container = getContainer(option);
  var firstChild = container.firstChild;
  if (prepend) {
    if (isPrependQueue) {
      var existStyle = (option.styles || findStyles(container)).filter(function(node2) {
        if (!["prepend", "prependQueue"].includes(node2.getAttribute(APPEND_ORDER))) {
          return false;
        }
        var nodePriority = Number(node2.getAttribute(APPEND_PRIORITY) || 0);
        return priority >= nodePriority;
      });
      if (existStyle.length) {
        container.insertBefore(styleNode, existStyle[existStyle.length - 1].nextSibling);
        return styleNode;
      }
    }
    container.insertBefore(styleNode, firstChild);
  } else {
    container.appendChild(styleNode);
  }
  return styleNode;
}
function findExistNode(key2) {
  var option = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var container = getContainer(option);
  return (option.styles || findStyles(container)).find(function(node2) {
    return node2.getAttribute(getMark(option)) === key2;
  });
}
function removeCSS(key2) {
  var option = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var existNode = findExistNode(key2, option);
  if (existNode) {
    var container = getContainer(option);
    container.removeChild(existNode);
  }
}
function syncRealContainer(container, option) {
  var cachedRealContainer = containerCache.get(container);
  if (!cachedRealContainer || !contains(document, cachedRealContainer)) {
    var placeholderStyle = injectCSS("", option);
    var parentNode = placeholderStyle.parentNode;
    containerCache.set(container, parentNode);
    container.removeChild(placeholderStyle);
  }
}
function updateCSS(css2, key2) {
  var originOption = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  var container = getContainer(originOption);
  var styles = findStyles(container);
  var option = _objectSpread2(_objectSpread2({}, originOption), {}, {
    styles
  });
  syncRealContainer(container, option);
  var existNode = findExistNode(key2, option);
  if (existNode) {
    var _option$csp, _option$csp2;
    if ((_option$csp = option.csp) !== null && _option$csp !== void 0 && _option$csp.nonce && existNode.nonce !== ((_option$csp2 = option.csp) === null || _option$csp2 === void 0 ? void 0 : _option$csp2.nonce)) {
      var _option$csp3;
      existNode.nonce = (_option$csp3 = option.csp) === null || _option$csp3 === void 0 ? void 0 : _option$csp3.nonce;
    }
    if (existNode.innerHTML !== css2) {
      existNode.innerHTML = css2;
    }
    return existNode;
  }
  var newNode = injectCSS(css2, option);
  newNode.setAttribute(getMark(option), key2);
  return newNode;
}

// ../../node_modules/@ant-design/cssinjs/es/hooks/useCacheToken.js
var import_react9 = __toESM(require_react());

// ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function _objectWithoutPropertiesLoose(r2, e3) {
  if (null == r2) return {};
  var t2 = {};
  for (var n2 in r2) if ({}.hasOwnProperty.call(r2, n2)) {
    if (-1 !== e3.indexOf(n2)) continue;
    t2[n2] = r2[n2];
  }
  return t2;
}

// ../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
function _objectWithoutProperties(e3, t2) {
  if (null == e3) return {};
  var o3, r2, i = _objectWithoutPropertiesLoose(e3, t2);
  if (Object.getOwnPropertySymbols) {
    var n2 = Object.getOwnPropertySymbols(e3);
    for (r2 = 0; r2 < n2.length; r2++) o3 = n2[r2], -1 === t2.indexOf(o3) && {}.propertyIsEnumerable.call(e3, o3) && (i[o3] = e3[o3]);
  }
  return i;
}

// ../../node_modules/rc-util/es/isEqual.js
function isEqual(obj1, obj2) {
  var shallow = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
  var refSet = /* @__PURE__ */ new Set();
  function deepEqual(a, b) {
    var level = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
    var circular = refSet.has(a);
    warning_default(!circular, "Warning: There may be circular references");
    if (circular) {
      return false;
    }
    if (a === b) {
      return true;
    }
    if (shallow && level > 1) {
      return false;
    }
    refSet.add(a);
    var newLevel = level + 1;
    if (Array.isArray(a)) {
      if (!Array.isArray(b) || a.length !== b.length) {
        return false;
      }
      for (var i = 0; i < a.length; i++) {
        if (!deepEqual(a[i], b[i], newLevel)) {
          return false;
        }
      }
      return true;
    }
    if (a && b && _typeof(a) === "object" && _typeof(b) === "object") {
      var keys4 = Object.keys(a);
      if (keys4.length !== Object.keys(b).length) {
        return false;
      }
      return keys4.every(function(key2) {
        return deepEqual(a[key2], b[key2], newLevel);
      });
    }
    return false;
  }
  return deepEqual(obj1, obj2);
}
var isEqual_default = isEqual;

// ../../node_modules/@ant-design/cssinjs/es/StyleContext.js
var React10 = __toESM(require_react());

// ../../node_modules/@ant-design/cssinjs/es/Cache.js
var SPLIT = "%";
function pathKey(keys4) {
  return keys4.join(SPLIT);
}
var Entity = /* @__PURE__ */ (function() {
  function Entity2(instanceId) {
    _classCallCheck(this, Entity2);
    _defineProperty(this, "instanceId", void 0);
    _defineProperty(this, "cache", /* @__PURE__ */ new Map());
    _defineProperty(this, "extracted", /* @__PURE__ */ new Set());
    this.instanceId = instanceId;
  }
  _createClass(Entity2, [{
    key: "get",
    value: function get3(keys4) {
      return this.opGet(pathKey(keys4));
    }
    /** A fast get cache with `get` concat. */
  }, {
    key: "opGet",
    value: function opGet(keyPathStr) {
      return this.cache.get(keyPathStr) || null;
    }
  }, {
    key: "update",
    value: function update(keys4, valueFn) {
      return this.opUpdate(pathKey(keys4), valueFn);
    }
    /** A fast get cache with `get` concat. */
  }, {
    key: "opUpdate",
    value: function opUpdate(keyPathStr, valueFn) {
      var prevValue = this.cache.get(keyPathStr);
      var nextValue = valueFn(prevValue);
      if (nextValue === null) {
        this.cache.delete(keyPathStr);
      } else {
        this.cache.set(keyPathStr, nextValue);
      }
    }
  }]);
  return Entity2;
})();
var Cache_default = Entity;

// ../../node_modules/@ant-design/cssinjs/es/StyleContext.js
var ATTR_TOKEN = "data-token-hash";
var ATTR_MARK = "data-css-hash";
var ATTR_CACHE_PATH = "data-cache-path";
var CSS_IN_JS_INSTANCE = "__cssinjs_instance__";
function createCache() {
  var cssinjsInstanceId = Math.random().toString(12).slice(2);
  if (typeof document !== "undefined" && document.head && document.body) {
    var styles = document.body.querySelectorAll("style[".concat(ATTR_MARK, "]")) || [];
    var firstChild = document.head.firstChild;
    Array.from(styles).forEach(function(style2) {
      style2[CSS_IN_JS_INSTANCE] = style2[CSS_IN_JS_INSTANCE] || cssinjsInstanceId;
      if (style2[CSS_IN_JS_INSTANCE] === cssinjsInstanceId) {
        document.head.insertBefore(style2, firstChild);
      }
    });
    var styleHash = {};
    Array.from(document.querySelectorAll("style[".concat(ATTR_MARK, "]"))).forEach(function(style2) {
      var hash2 = style2.getAttribute(ATTR_MARK);
      if (styleHash[hash2]) {
        if (style2[CSS_IN_JS_INSTANCE] === cssinjsInstanceId) {
          var _style$parentNode;
          (_style$parentNode = style2.parentNode) === null || _style$parentNode === void 0 || _style$parentNode.removeChild(style2);
        }
      } else {
        styleHash[hash2] = true;
      }
    });
  }
  return new Cache_default(cssinjsInstanceId);
}
var StyleContext = /* @__PURE__ */ React10.createContext({
  hashPriority: "low",
  cache: createCache(),
  defaultCache: true
});
var StyleContext_default = StyleContext;

// ../../node_modules/@ant-design/cssinjs/es/theme/calc/CSSCalculator.js
var CALC_UNIT = "CALC_UNIT";
var regexp = new RegExp(CALC_UNIT, "g");

// ../../node_modules/@ant-design/cssinjs/es/theme/ThemeCache.js
function sameDerivativeOption(left2, right2) {
  if (left2.length !== right2.length) {
    return false;
  }
  for (var i = 0; i < left2.length; i++) {
    if (left2[i] !== right2[i]) {
      return false;
    }
  }
  return true;
}
var ThemeCache = /* @__PURE__ */ (function() {
  function ThemeCache2() {
    _classCallCheck(this, ThemeCache2);
    _defineProperty(this, "cache", void 0);
    _defineProperty(this, "keys", void 0);
    _defineProperty(this, "cacheCallTimes", void 0);
    this.cache = /* @__PURE__ */ new Map();
    this.keys = [];
    this.cacheCallTimes = 0;
  }
  _createClass(ThemeCache2, [{
    key: "size",
    value: function size() {
      return this.keys.length;
    }
  }, {
    key: "internalGet",
    value: function internalGet(derivativeOption) {
      var _cache2, _cache3;
      var updateCallTimes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
      var cache = {
        map: this.cache
      };
      derivativeOption.forEach(function(derivative4) {
        if (!cache) {
          cache = void 0;
        } else {
          var _cache4;
          cache = (_cache4 = cache) === null || _cache4 === void 0 || (_cache4 = _cache4.map) === null || _cache4 === void 0 ? void 0 : _cache4.get(derivative4);
        }
      });
      if ((_cache2 = cache) !== null && _cache2 !== void 0 && _cache2.value && updateCallTimes) {
        cache.value[1] = this.cacheCallTimes++;
      }
      return (_cache3 = cache) === null || _cache3 === void 0 ? void 0 : _cache3.value;
    }
  }, {
    key: "get",
    value: function get3(derivativeOption) {
      var _this$internalGet;
      return (_this$internalGet = this.internalGet(derivativeOption, true)) === null || _this$internalGet === void 0 ? void 0 : _this$internalGet[0];
    }
  }, {
    key: "has",
    value: function has2(derivativeOption) {
      return !!this.internalGet(derivativeOption);
    }
  }, {
    key: "set",
    value: function set4(derivativeOption, value) {
      var _this = this;
      if (!this.has(derivativeOption)) {
        if (this.size() + 1 > ThemeCache2.MAX_CACHE_SIZE + ThemeCache2.MAX_CACHE_OFFSET) {
          var _this$keys$reduce = this.keys.reduce(function(result, key2) {
            var _result = _slicedToArray(result, 2), callTimes = _result[1];
            if (_this.internalGet(key2)[1] < callTimes) {
              return [key2, _this.internalGet(key2)[1]];
            }
            return result;
          }, [this.keys[0], this.cacheCallTimes]), _this$keys$reduce2 = _slicedToArray(_this$keys$reduce, 1), targetKey = _this$keys$reduce2[0];
          this.delete(targetKey);
        }
        this.keys.push(derivativeOption);
      }
      var cache = this.cache;
      derivativeOption.forEach(function(derivative4, index3) {
        if (index3 === derivativeOption.length - 1) {
          cache.set(derivative4, {
            value: [value, _this.cacheCallTimes++]
          });
        } else {
          var cacheValue = cache.get(derivative4);
          if (!cacheValue) {
            cache.set(derivative4, {
              map: /* @__PURE__ */ new Map()
            });
          } else if (!cacheValue.map) {
            cacheValue.map = /* @__PURE__ */ new Map();
          }
          cache = cache.get(derivative4).map;
        }
      });
    }
  }, {
    key: "deleteByPath",
    value: function deleteByPath(currentCache, derivatives) {
      var cache = currentCache.get(derivatives[0]);
      if (derivatives.length === 1) {
        var _cache$value;
        if (!cache.map) {
          currentCache.delete(derivatives[0]);
        } else {
          currentCache.set(derivatives[0], {
            map: cache.map
          });
        }
        return (_cache$value = cache.value) === null || _cache$value === void 0 ? void 0 : _cache$value[0];
      }
      var result = this.deleteByPath(cache.map, derivatives.slice(1));
      if ((!cache.map || cache.map.size === 0) && !cache.value) {
        currentCache.delete(derivatives[0]);
      }
      return result;
    }
  }, {
    key: "delete",
    value: function _delete(derivativeOption) {
      if (this.has(derivativeOption)) {
        this.keys = this.keys.filter(function(item) {
          return !sameDerivativeOption(item, derivativeOption);
        });
        return this.deleteByPath(this.cache, derivativeOption);
      }
      return void 0;
    }
  }]);
  return ThemeCache2;
})();
_defineProperty(ThemeCache, "MAX_CACHE_SIZE", 20);
_defineProperty(ThemeCache, "MAX_CACHE_OFFSET", 5);

// ../../node_modules/@ant-design/cssinjs/es/theme/Theme.js
var uuid2 = 0;
var Theme = /* @__PURE__ */ (function() {
  function Theme2(derivatives) {
    _classCallCheck(this, Theme2);
    _defineProperty(this, "derivatives", void 0);
    _defineProperty(this, "id", void 0);
    this.derivatives = Array.isArray(derivatives) ? derivatives : [derivatives];
    this.id = uuid2;
    if (derivatives.length === 0) {
      warning(derivatives.length > 0, "[Ant Design CSS-in-JS] Theme should have at least one derivative function.");
    }
    uuid2 += 1;
  }
  _createClass(Theme2, [{
    key: "getDerivativeToken",
    value: function getDerivativeToken(token2) {
      return this.derivatives.reduce(function(result, derivative4) {
        return derivative4(token2, result);
      }, void 0);
    }
  }]);
  return Theme2;
})();

// ../../node_modules/@ant-design/cssinjs/es/theme/createTheme.js
var cacheThemes = new ThemeCache();
function createTheme(derivatives) {
  var derivativeArr = Array.isArray(derivatives) ? derivatives : [derivatives];
  if (!cacheThemes.has(derivativeArr)) {
    cacheThemes.set(derivativeArr, new Theme(derivativeArr));
  }
  return cacheThemes.get(derivativeArr);
}

// ../../node_modules/@ant-design/cssinjs/es/util/index.js
var resultCache = /* @__PURE__ */ new WeakMap();
var RESULT_VALUE = {};
function memoResult(callback, deps) {
  var current2 = resultCache;
  for (var i = 0; i < deps.length; i += 1) {
    var dep = deps[i];
    if (!current2.has(dep)) {
      current2.set(dep, /* @__PURE__ */ new WeakMap());
    }
    current2 = current2.get(dep);
  }
  if (!current2.has(RESULT_VALUE)) {
    current2.set(RESULT_VALUE, callback());
  }
  return current2.get(RESULT_VALUE);
}
var flattenTokenCache = /* @__PURE__ */ new WeakMap();
function flattenToken(token2) {
  var str = flattenTokenCache.get(token2) || "";
  if (!str) {
    Object.keys(token2).forEach(function(key2) {
      var value = token2[key2];
      str += key2;
      if (value instanceof Theme) {
        str += value.id;
      } else if (value && _typeof(value) === "object") {
        str += flattenToken(value);
      } else {
        str += value;
      }
    });
    str = hash_browser_esm_default(str);
    flattenTokenCache.set(token2, str);
  }
  return str;
}
function token2key(token2, salt) {
  return hash_browser_esm_default("".concat(salt, "_").concat(flattenToken(token2)));
}
var randomSelectorKey = "random-".concat(Date.now(), "-").concat(Math.random()).replace(/\./g, "");
var isClientSide = canUseDom();
function unit(num) {
  if (typeof num === "number") {
    return "".concat(num, "px");
  }
  return num;
}
function toStyleStr(style2, tokenKey, styleId) {
  var customizeAttrs = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
  var plain = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
  if (plain) {
    return style2;
  }
  var attrs = _objectSpread2(_objectSpread2({}, customizeAttrs), {}, _defineProperty(_defineProperty({}, ATTR_TOKEN, tokenKey), ATTR_MARK, styleId));
  var attrStr = Object.keys(attrs).map(function(attr) {
    var val = attrs[attr];
    return val ? "".concat(attr, '="').concat(val, '"') : null;
  }).filter(function(v) {
    return v;
  }).join(" ");
  return "<style ".concat(attrStr, ">").concat(style2, "</style>");
}

// ../../node_modules/@ant-design/cssinjs/es/util/css-variables.js
var token2CSSVar = function token2CSSVar2(token2) {
  var prefix3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  return "--".concat(prefix3 ? "".concat(prefix3, "-") : "").concat(token2).replace(/([a-z0-9])([A-Z])/g, "$1-$2").replace(/([A-Z]+)([A-Z][a-z0-9]+)/g, "$1-$2").replace(/([a-z])([A-Z0-9])/g, "$1-$2").toLowerCase();
};
var serializeCSSVar = function serializeCSSVar2(cssVars, hashId, options) {
  if (!Object.keys(cssVars).length) {
    return "";
  }
  return ".".concat(hashId).concat(options !== null && options !== void 0 && options.scope ? ".".concat(options.scope) : "", "{").concat(Object.entries(cssVars).map(function(_ref) {
    var _ref2 = _slicedToArray(_ref, 2), key2 = _ref2[0], value = _ref2[1];
    return "".concat(key2, ":").concat(value, ";");
  }).join(""), "}");
};
var transformToken = function transformToken2(token2, themeKey, config) {
  var cssVars = {};
  var result = {};
  Object.entries(token2).forEach(function(_ref3) {
    var _config$preserve, _config$ignore;
    var _ref4 = _slicedToArray(_ref3, 2), key2 = _ref4[0], value = _ref4[1];
    if (config !== null && config !== void 0 && (_config$preserve = config.preserve) !== null && _config$preserve !== void 0 && _config$preserve[key2]) {
      result[key2] = value;
    } else if ((typeof value === "string" || typeof value === "number") && !(config !== null && config !== void 0 && (_config$ignore = config.ignore) !== null && _config$ignore !== void 0 && _config$ignore[key2])) {
      var _config$unitless;
      var cssVar = token2CSSVar(key2, config === null || config === void 0 ? void 0 : config.prefix);
      cssVars[cssVar] = typeof value === "number" && !(config !== null && config !== void 0 && (_config$unitless = config.unitless) !== null && _config$unitless !== void 0 && _config$unitless[key2]) ? "".concat(value, "px") : String(value);
      result[key2] = "var(".concat(cssVar, ")");
    }
  });
  return [result, serializeCSSVar(cssVars, themeKey, {
    scope: config === null || config === void 0 ? void 0 : config.scope
  })];
};

// ../../node_modules/@ant-design/cssinjs/es/hooks/useGlobalCache.js
var React14 = __toESM(require_react());

// ../../node_modules/rc-util/es/hooks/useLayoutEffect.js
var React11 = __toESM(require_react());
var useInternalLayoutEffect = canUseDom() ? React11.useLayoutEffect : React11.useEffect;
var useLayoutEffect3 = function useLayoutEffect4(callback, deps) {
  var firstMountRef = React11.useRef(true);
  useInternalLayoutEffect(function() {
    return callback(firstMountRef.current);
  }, deps);
  useInternalLayoutEffect(function() {
    firstMountRef.current = false;
    return function() {
      firstMountRef.current = true;
    };
  }, []);
};
var useLayoutUpdateEffect = function useLayoutUpdateEffect2(callback, deps) {
  useLayoutEffect3(function(firstMount) {
    if (!firstMount) {
      return callback();
    }
  }, deps);
};
var useLayoutEffect_default = useLayoutEffect3;

// ../../node_modules/@ant-design/cssinjs/es/hooks/useCompatibleInsertionEffect.js
var React12 = __toESM(require_react());
var fullClone = _objectSpread2({}, React12);
var useInsertionEffect = fullClone.useInsertionEffect;
var useInsertionEffectPolyfill = function useInsertionEffectPolyfill2(renderEffect, effect, deps) {
  React12.useMemo(renderEffect, deps);
  useLayoutEffect_default(function() {
    return effect(true);
  }, deps);
};
var useCompatibleInsertionEffect = useInsertionEffect ? function(renderEffect, effect, deps) {
  return useInsertionEffect(function() {
    renderEffect();
    return effect();
  }, deps);
} : useInsertionEffectPolyfill;
var useCompatibleInsertionEffect_default = useCompatibleInsertionEffect;

// ../../node_modules/@ant-design/cssinjs/es/hooks/useEffectCleanupRegister.js
var React13 = __toESM(require_react());
var fullClone2 = _objectSpread2({}, React13);
var useInsertionEffect2 = fullClone2.useInsertionEffect;
var useCleanupRegister = function useCleanupRegister2(deps) {
  var effectCleanups = [];
  var cleanupFlag = false;
  function register2(fn) {
    if (cleanupFlag) {
      if (true) {
        warning(false, "[Ant Design CSS-in-JS] You are registering a cleanup function after unmount, which will not have any effect.");
      }
      return;
    }
    effectCleanups.push(fn);
  }
  React13.useEffect(function() {
    cleanupFlag = false;
    return function() {
      cleanupFlag = true;
      if (effectCleanups.length) {
        effectCleanups.forEach(function(fn) {
          return fn();
        });
      }
    };
  }, deps);
  return register2;
};
var useRun = function useRun2() {
  return function(fn) {
    fn();
  };
};
var useEffectCleanupRegister = typeof useInsertionEffect2 !== "undefined" ? useCleanupRegister : useRun;
var useEffectCleanupRegister_default = useEffectCleanupRegister;

// ../../node_modules/@ant-design/cssinjs/es/hooks/useHMR.js
var webpackHMR = false;
function useDevHMR() {
  return webpackHMR;
}
var useHMR_default = false ? useProdHMR : useDevHMR;
if (typeof module !== "undefined" && module && module.hot && typeof window !== "undefined") {
  win = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : null;
  if (win && typeof win.webpackHotUpdate === "function") {
    originWebpackHotUpdate = win.webpackHotUpdate;
    win.webpackHotUpdate = function() {
      webpackHMR = true;
      setTimeout(function() {
        webpackHMR = false;
      }, 0);
      return originWebpackHotUpdate.apply(void 0, arguments);
    };
  }
}
var win;
var originWebpackHotUpdate;

// ../../node_modules/@ant-design/cssinjs/es/hooks/useGlobalCache.js
function useGlobalCache(prefix3, keyPath, cacheFn, onCacheRemove, onCacheEffect) {
  var _React$useContext = React14.useContext(StyleContext_default), globalCache = _React$useContext.cache;
  var fullPath = [prefix3].concat(_toConsumableArray(keyPath));
  var fullPathStr = pathKey(fullPath);
  var register2 = useEffectCleanupRegister_default([fullPathStr]);
  var HMRUpdate = useHMR_default();
  var buildCache = function buildCache2(updater) {
    globalCache.opUpdate(fullPathStr, function(prevCache) {
      var _ref = prevCache || [void 0, void 0], _ref2 = _slicedToArray(_ref, 2), _ref2$ = _ref2[0], times = _ref2$ === void 0 ? 0 : _ref2$, cache = _ref2[1];
      var tmpCache = cache;
      if (cache && HMRUpdate) {
        onCacheRemove === null || onCacheRemove === void 0 || onCacheRemove(tmpCache, HMRUpdate);
        tmpCache = null;
      }
      var mergedCache = tmpCache || cacheFn();
      var data2 = [times, mergedCache];
      return updater ? updater(data2) : data2;
    });
  };
  React14.useMemo(
    function() {
      buildCache();
    },
    /* eslint-disable react-hooks/exhaustive-deps */
    [fullPathStr]
    /* eslint-enable */
  );
  var cacheEntity = globalCache.opGet(fullPathStr);
  if (!cacheEntity) {
    buildCache();
    cacheEntity = globalCache.opGet(fullPathStr);
  }
  var cacheContent = cacheEntity[1];
  useCompatibleInsertionEffect_default(function() {
    onCacheEffect === null || onCacheEffect === void 0 || onCacheEffect(cacheContent);
  }, function(polyfill) {
    buildCache(function(_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2), times = _ref4[0], cache = _ref4[1];
      if (polyfill && times === 0) {
        onCacheEffect === null || onCacheEffect === void 0 || onCacheEffect(cacheContent);
      }
      return [times + 1, cache];
    });
    return function() {
      globalCache.opUpdate(fullPathStr, function(prevCache) {
        var _ref5 = prevCache || [], _ref6 = _slicedToArray(_ref5, 2), _ref6$ = _ref6[0], times = _ref6$ === void 0 ? 0 : _ref6$, cache = _ref6[1];
        var nextCount = times - 1;
        if (nextCount === 0) {
          register2(function() {
            if (polyfill || !globalCache.opGet(fullPathStr)) {
              onCacheRemove === null || onCacheRemove === void 0 || onCacheRemove(cache, false);
            }
          });
          return null;
        }
        return [times - 1, cache];
      });
    };
  }, [fullPathStr]);
  return cacheContent;
}

// ../../node_modules/@ant-design/cssinjs/es/hooks/useCacheToken.js
var EMPTY_OVERRIDE = {};
var hashPrefix = true ? "css-dev-only-do-not-override" : "css";
var tokenKeys = /* @__PURE__ */ new Map();
function recordCleanToken(tokenKey) {
  tokenKeys.set(tokenKey, (tokenKeys.get(tokenKey) || 0) + 1);
}
function removeStyleTags(key2, instanceId) {
  if (typeof document !== "undefined") {
    var styles = document.querySelectorAll("style[".concat(ATTR_TOKEN, '="').concat(key2, '"]'));
    styles.forEach(function(style2) {
      if (style2[CSS_IN_JS_INSTANCE] === instanceId) {
        var _style$parentNode;
        (_style$parentNode = style2.parentNode) === null || _style$parentNode === void 0 || _style$parentNode.removeChild(style2);
      }
    });
  }
}
var TOKEN_THRESHOLD = 0;
function cleanTokenStyle(tokenKey, instanceId) {
  tokenKeys.set(tokenKey, (tokenKeys.get(tokenKey) || 0) - 1);
  var cleanableKeyList = /* @__PURE__ */ new Set();
  tokenKeys.forEach(function(value, key2) {
    if (value <= 0) cleanableKeyList.add(key2);
  });
  if (tokenKeys.size - cleanableKeyList.size > TOKEN_THRESHOLD) {
    cleanableKeyList.forEach(function(key2) {
      removeStyleTags(key2, instanceId);
      tokenKeys.delete(key2);
    });
  }
}
var getComputedToken = function getComputedToken2(originToken, overrideToken, theme, format3) {
  var derivativeToken = theme.getDerivativeToken(originToken);
  var mergedDerivativeToken = _objectSpread2(_objectSpread2({}, derivativeToken), overrideToken);
  if (format3) {
    mergedDerivativeToken = format3(mergedDerivativeToken);
  }
  return mergedDerivativeToken;
};
var TOKEN_PREFIX = "token";
function useCacheToken(theme, tokens) {
  var option = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  var _useContext = (0, import_react9.useContext)(StyleContext_default), instanceId = _useContext.cache.instanceId, container = _useContext.container;
  var _option$salt = option.salt, salt = _option$salt === void 0 ? "" : _option$salt, _option$override = option.override, override = _option$override === void 0 ? EMPTY_OVERRIDE : _option$override, formatToken2 = option.formatToken, compute = option.getComputedToken, cssVar = option.cssVar;
  var mergedToken = memoResult(function() {
    return Object.assign.apply(Object, [{}].concat(_toConsumableArray(tokens)));
  }, tokens);
  var tokenStr = flattenToken(mergedToken);
  var overrideTokenStr = flattenToken(override);
  var cssVarStr = cssVar ? flattenToken(cssVar) : "";
  var cachedToken = useGlobalCache(TOKEN_PREFIX, [salt, theme.id, tokenStr, overrideTokenStr, cssVarStr], function() {
    var _cssVar$key;
    var mergedDerivativeToken = compute ? compute(mergedToken, override, theme) : getComputedToken(mergedToken, override, theme, formatToken2);
    var actualToken = _objectSpread2({}, mergedDerivativeToken);
    var cssVarsStr = "";
    if (!!cssVar) {
      var _transformToken = transformToken(mergedDerivativeToken, cssVar.key, {
        prefix: cssVar.prefix,
        ignore: cssVar.ignore,
        unitless: cssVar.unitless,
        preserve: cssVar.preserve
      });
      var _transformToken2 = _slicedToArray(_transformToken, 2);
      mergedDerivativeToken = _transformToken2[0];
      cssVarsStr = _transformToken2[1];
    }
    var tokenKey = token2key(mergedDerivativeToken, salt);
    mergedDerivativeToken._tokenKey = tokenKey;
    actualToken._tokenKey = token2key(actualToken, salt);
    var themeKey = (_cssVar$key = cssVar === null || cssVar === void 0 ? void 0 : cssVar.key) !== null && _cssVar$key !== void 0 ? _cssVar$key : tokenKey;
    mergedDerivativeToken._themeKey = themeKey;
    recordCleanToken(themeKey);
    var hashId = "".concat(hashPrefix, "-").concat(hash_browser_esm_default(tokenKey));
    mergedDerivativeToken._hashId = hashId;
    return [mergedDerivativeToken, hashId, actualToken, cssVarsStr, (cssVar === null || cssVar === void 0 ? void 0 : cssVar.key) || ""];
  }, function(cache) {
    cleanTokenStyle(cache[0]._themeKey, instanceId);
  }, function(_ref) {
    var _ref2 = _slicedToArray(_ref, 4), token2 = _ref2[0], cssVarsStr = _ref2[3];
    if (cssVar && cssVarsStr) {
      var style2 = updateCSS(cssVarsStr, hash_browser_esm_default("css-variables-".concat(token2._themeKey)), {
        mark: ATTR_MARK,
        prepend: "queue",
        attachTo: container,
        priority: -999
      });
      style2[CSS_IN_JS_INSTANCE] = instanceId;
      style2.setAttribute(ATTR_TOKEN, token2._themeKey);
    }
  });
  return cachedToken;
}
var extract = function extract2(cache, effectStyles, options) {
  var _cache2 = _slicedToArray(cache, 5), realToken = _cache2[2], styleStr = _cache2[3], cssVarKey = _cache2[4];
  var _ref3 = options || {}, plain = _ref3.plain;
  if (!styleStr) {
    return null;
  }
  var styleId = realToken._tokenKey;
  var order = -999;
  var sharedAttrs = {
    "data-rc-order": "prependQueue",
    "data-rc-priority": "".concat(order)
  };
  var styleText = toStyleStr(styleStr, cssVarKey, styleId, sharedAttrs, plain);
  return [order, styleId, styleText];
};

// ../../node_modules/@ant-design/cssinjs/es/hooks/useCSSVarRegister.js
var import_react10 = __toESM(require_react());

// ../../node_modules/@ant-design/cssinjs/es/hooks/useStyleRegister.js
var React15 = __toESM(require_react());

// ../../node_modules/@emotion/unitless/dist/unitless.browser.esm.js
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
var unitless_browser_esm_default = unitlessKeys;

// ../../node_modules/stylis/src/Enum.js
var COMMENT = "comm";
var RULESET = "rule";
var DECLARATION = "decl";
var IMPORT = "@import";
var NAMESPACE = "@namespace";
var KEYFRAMES = "@keyframes";
var LAYER = "@layer";

// ../../node_modules/stylis/src/Utility.js
var abs = Math.abs;
var from = String.fromCharCode;
function trim(value) {
  return value.trim();
}
function replace(value, pattern6, replacement) {
  return value.replace(pattern6, replacement);
}
function indexof(value, search, position3) {
  return value.indexOf(search, position3);
}
function charat(value, index3) {
  return value.charCodeAt(index3) | 0;
}
function substr(value, begin, end) {
  return value.slice(begin, end);
}
function strlen(value) {
  return value.length;
}
function sizeof(value) {
  return value.length;
}
function append(value, array4) {
  return array4.push(value), value;
}

// ../../node_modules/stylis/src/Tokenizer.js
var line = 1;
var column = 1;
var length = 0;
var position = 0;
var character = 0;
var characters = "";
function node(value, root2, parent2, type5, props, children, length2, siblings) {
  return { value, root: root2, parent: parent2, type: type5, props, children, line, column, length: length2, return: "", siblings };
}
function char() {
  return character;
}
function prev() {
  character = position > 0 ? charat(characters, --position) : 0;
  if (column--, character === 10)
    column = 1, line--;
  return character;
}
function next() {
  character = position < length ? charat(characters, position++) : 0;
  if (column++, character === 10)
    column = 1, line++;
  return character;
}
function peek() {
  return charat(characters, position);
}
function caret() {
  return position;
}
function slice(begin, end) {
  return substr(characters, begin, end);
}
function token(type5) {
  switch (type5) {
    // \0 \t \n \r \s whitespace token
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    // ! + , / > @ ~ isolate token
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    // ; { } breakpoint token
    case 59:
    case 123:
    case 125:
      return 4;
    // : accompanied token
    case 58:
      return 3;
    // " ' ( [ opening delimit token
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    // ) ] closing delimit token
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function alloc(value) {
  return line = column = 1, length = strlen(characters = value), position = 0, [];
}
function dealloc(value) {
  return characters = "", value;
}
function delimit(type5) {
  return trim(slice(position - 1, delimiter(type5 === 91 ? type5 + 2 : type5 === 40 ? type5 + 1 : type5)));
}
function whitespace(type5) {
  while (character = peek())
    if (character < 33)
      next();
    else
      break;
  return token(type5) > 2 || token(character) > 3 ? "" : " ";
}
function escaping(index3, count) {
  while (--count && next())
    if (character < 48 || character > 102 || character > 57 && character < 65 || character > 70 && character < 97)
      break;
  return slice(index3, caret() + (count < 6 && peek() == 32 && next() == 32));
}
function delimiter(type5) {
  while (next())
    switch (character) {
      // ] ) " '
      case type5:
        return position;
      // " '
      case 34:
      case 39:
        if (type5 !== 34 && type5 !== 39)
          delimiter(character);
        break;
      // (
      case 40:
        if (type5 === 41)
          delimiter(type5);
        break;
      // \
      case 92:
        next();
        break;
    }
  return position;
}
function commenter(type5, index3) {
  while (next())
    if (type5 + character === 47 + 10)
      break;
    else if (type5 + character === 42 + 42 && peek() === 47)
      break;
  return "/*" + slice(index3, position - 1) + "*" + from(type5 === 47 ? type5 : next());
}
function identifier(index3) {
  while (!token(peek()))
    next();
  return slice(index3, position);
}

// ../../node_modules/stylis/src/Parser.js
function compile(value) {
  return dealloc(parse3("", null, null, null, [""], value = alloc(value), 0, [0], value));
}
function parse3(value, root2, parent2, rule, rules, rulesets, pseudo, points, declarations) {
  var index3 = 0;
  var offset4 = 0;
  var length2 = pseudo;
  var atrule = 0;
  var property2 = 0;
  var previous = 0;
  var variable = 1;
  var scanning = 1;
  var ampersand = 1;
  var character2 = 0;
  var type5 = "";
  var props = rules;
  var children = rulesets;
  var reference = rule;
  var characters2 = type5;
  while (scanning)
    switch (previous = character2, character2 = next()) {
      // (
      case 40:
        if (previous != 108 && charat(characters2, length2 - 1) == 58) {
          if (indexof(characters2 += replace(delimit(character2), "&", "&\f"), "&\f", abs(index3 ? points[index3 - 1] : 0)) != -1)
            ampersand = -1;
          break;
        }
      // " ' [
      case 34:
      case 39:
      case 91:
        characters2 += delimit(character2);
        break;
      // \t \n \r \s
      case 9:
      case 10:
      case 13:
      case 32:
        characters2 += whitespace(previous);
        break;
      // \
      case 92:
        characters2 += escaping(caret() - 1, 7);
        continue;
      // /
      case 47:
        switch (peek()) {
          case 42:
          case 47:
            append(comment(commenter(next(), caret()), root2, parent2, declarations), declarations);
            if ((token(previous || 1) == 5 || token(peek() || 1) == 5) && strlen(characters2) && substr(characters2, -1, void 0) !== " ") characters2 += " ";
            break;
          default:
            characters2 += "/";
        }
        break;
      // {
      case 123 * variable:
        points[index3++] = strlen(characters2) * ampersand;
      // } ; \0
      case 125 * variable:
      case 59:
      case 0:
        switch (character2) {
          // \0 }
          case 0:
          case 125:
            scanning = 0;
          // ;
          case 59 + offset4:
            if (ampersand == -1) characters2 = replace(characters2, /\f/g, "");
            if (property2 > 0 && (strlen(characters2) - length2 || variable === 0 && previous === 47))
              append(property2 > 32 ? declaration(characters2 + ";", rule, parent2, length2 - 1, declarations) : declaration(replace(characters2, " ", "") + ";", rule, parent2, length2 - 2, declarations), declarations);
            break;
          // @ ;
          case 59:
            characters2 += ";";
          // { rule/at-rule
          default:
            append(reference = ruleset(characters2, root2, parent2, index3, offset4, rules, points, type5, props = [], children = [], length2, rulesets), rulesets);
            if (character2 === 123)
              if (offset4 === 0)
                parse3(characters2, root2, reference, reference, props, rulesets, length2, points, children);
              else {
                switch (atrule) {
                  // c(ontainer)
                  case 99:
                    if (charat(characters2, 3) === 110) break;
                  // l(ayer)
                  case 108:
                    if (charat(characters2, 2) === 97) break;
                  default:
                    offset4 = 0;
                  // d(ocument) m(edia) s(upports)
                  case 100:
                  case 109:
                  case 115:
                }
                if (offset4) parse3(value, reference, reference, rule && append(ruleset(value, reference, reference, 0, 0, rules, points, type5, rules, props = [], length2, children), children), rules, children, length2, points, rule ? props : children);
                else parse3(characters2, reference, reference, reference, [""], children, 0, points, children);
              }
        }
        index3 = offset4 = property2 = 0, variable = ampersand = 1, type5 = characters2 = "", length2 = pseudo;
        break;
      // :
      case 58:
        length2 = 1 + strlen(characters2), property2 = previous;
      default:
        if (variable < 1) {
          if (character2 == 123)
            --variable;
          else if (character2 == 125 && variable++ == 0 && prev() == 125)
            continue;
        }
        switch (characters2 += from(character2), character2 * variable) {
          // &
          case 38:
            ampersand = offset4 > 0 ? 1 : (characters2 += "\f", -1);
            break;
          // ,
          case 44:
            points[index3++] = (strlen(characters2) - 1) * ampersand, ampersand = 1;
            break;
          // @
          case 64:
            if (peek() === 45)
              characters2 += delimit(next());
            atrule = peek(), offset4 = length2 = strlen(type5 = characters2 += identifier(caret())), character2++;
            break;
          // -
          case 45:
            if (previous === 45 && strlen(characters2) == 2)
              variable = 0;
        }
    }
  return rulesets;
}
function ruleset(value, root2, parent2, index3, offset4, rules, points, type5, props, children, length2, siblings) {
  var post = offset4 - 1;
  var rule = offset4 === 0 ? rules : [""];
  var size = sizeof(rule);
  for (var i = 0, j = 0, k = 0; i < index3; ++i)
    for (var x = 0, y = substr(value, post + 1, post = abs(j = points[i])), z = value; x < size; ++x)
      if (z = trim(j > 0 ? rule[x] + " " + y : replace(y, /&\f/g, rule[x])))
        props[k++] = z;
  return node(value, root2, parent2, offset4 === 0 ? RULESET : type5, props, children, length2, siblings);
}
function comment(value, root2, parent2, siblings) {
  return node(value, root2, parent2, COMMENT, from(char()), substr(value, 2, -2), 0, siblings);
}
function declaration(value, root2, parent2, length2, siblings) {
  return node(value, root2, parent2, DECLARATION, substr(value, 0, length2), substr(value, length2 + 1, -1), length2, siblings);
}

// ../../node_modules/stylis/src/Serializer.js
function serialize(children, callback) {
  var output = "";
  for (var i = 0; i < children.length; i++)
    output += callback(children[i], i, children, callback) || "";
  return output;
}
function stringify(element, index3, children, callback) {
  switch (element.type) {
    case LAYER:
      if (element.children.length) break;
    case IMPORT:
    case NAMESPACE:
    case DECLARATION:
      return element.return = element.return || element.value;
    case COMMENT:
      return "";
    case KEYFRAMES:
      return element.return = element.value + "{" + serialize(element.children, callback) + "}";
    case RULESET:
      if (!strlen(element.value = element.props.join(","))) return "";
  }
  return strlen(children = serialize(element.children, callback)) ? element.return = element.value + "{" + children + "}" : "";
}

// ../../node_modules/@ant-design/cssinjs/es/linters/utils.js
function lintWarning(message2, info) {
  var path2 = info.path, parentSelectors = info.parentSelectors;
  warning_default(false, "[Ant Design CSS-in-JS] ".concat(path2 ? "Error in ".concat(path2, ": ") : "").concat(message2).concat(parentSelectors.length ? " Selector: ".concat(parentSelectors.join(" | ")) : ""));
}

// ../../node_modules/@ant-design/cssinjs/es/linters/contentQuotesLinter.js
var linter = function linter2(key2, value, info) {
  if (key2 === "content") {
    var contentValuePattern = /(attr|counters?|url|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/;
    var contentValues = ["normal", "none", "initial", "inherit", "unset"];
    if (typeof value !== "string" || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
      lintWarning("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"".concat(value, "\"'`."), info);
    }
  }
};
var contentQuotesLinter_default = linter;

// ../../node_modules/@ant-design/cssinjs/es/linters/hashedAnimationLinter.js
var linter3 = function linter4(key2, value, info) {
  if (key2 === "animation") {
    if (info.hashId && value !== "none") {
      lintWarning("You seem to be using hashed animation '".concat(value, "', in which case 'animationName' with Keyframe as value is recommended."), info);
    }
  }
};
var hashedAnimationLinter_default = linter3;

// ../../node_modules/@ant-design/cssinjs/es/util/cacheMapUtil.js
var ATTR_CACHE_MAP = "data-ant-cssinjs-cache-path";
var CSS_FILE_STYLE = "_FILE_STYLE__";
var cachePathMap;
var fromCSSFile = true;
function prepare() {
  if (!cachePathMap) {
    cachePathMap = {};
    if (canUseDom()) {
      var div = document.createElement("div");
      div.className = ATTR_CACHE_MAP;
      div.style.position = "fixed";
      div.style.visibility = "hidden";
      div.style.top = "-9999px";
      document.body.appendChild(div);
      var content = getComputedStyle(div).content || "";
      content = content.replace(/^"/, "").replace(/"$/, "");
      content.split(";").forEach(function(item) {
        var _item$split = item.split(":"), _item$split2 = _slicedToArray(_item$split, 2), path2 = _item$split2[0], hash2 = _item$split2[1];
        cachePathMap[path2] = hash2;
      });
      var inlineMapStyle = document.querySelector("style[".concat(ATTR_CACHE_MAP, "]"));
      if (inlineMapStyle) {
        var _inlineMapStyle$paren;
        fromCSSFile = false;
        (_inlineMapStyle$paren = inlineMapStyle.parentNode) === null || _inlineMapStyle$paren === void 0 || _inlineMapStyle$paren.removeChild(inlineMapStyle);
      }
      document.body.removeChild(div);
    }
  }
}
function existPath(path2) {
  prepare();
  return !!cachePathMap[path2];
}
function getStyleAndHash(path2) {
  var hash2 = cachePathMap[path2];
  var styleStr = null;
  if (hash2 && canUseDom()) {
    if (fromCSSFile) {
      styleStr = CSS_FILE_STYLE;
    } else {
      var _style = document.querySelector("style[".concat(ATTR_MARK, '="').concat(cachePathMap[path2], '"]'));
      if (_style) {
        styleStr = _style.innerHTML;
      } else {
        delete cachePathMap[path2];
      }
    }
  }
  return [styleStr, hash2];
}

// ../../node_modules/@ant-design/cssinjs/es/hooks/useStyleRegister.js
var SKIP_CHECK = "_skip_check_";
var MULTI_VALUE = "_multi_value_";
function normalizeStyle(styleStr) {
  var serialized = serialize(compile(styleStr), stringify);
  return serialized.replace(/\{%%%\:[^;];}/g, ";");
}
function isCompoundCSSProperty(value) {
  return _typeof(value) === "object" && value && (SKIP_CHECK in value || MULTI_VALUE in value);
}
function injectSelectorHash(key2, hashId, hashPriority) {
  if (!hashId) {
    return key2;
  }
  var hashClassName = ".".concat(hashId);
  var hashSelector = hashPriority === "low" ? ":where(".concat(hashClassName, ")") : hashClassName;
  var keys4 = key2.split(",").map(function(k) {
    var _firstPath$match;
    var fullPath = k.trim().split(/\s+/);
    var firstPath = fullPath[0] || "";
    var htmlElement = ((_firstPath$match = firstPath.match(/^\w+/)) === null || _firstPath$match === void 0 ? void 0 : _firstPath$match[0]) || "";
    firstPath = "".concat(htmlElement).concat(hashSelector).concat(firstPath.slice(htmlElement.length));
    return [firstPath].concat(_toConsumableArray(fullPath.slice(1))).join(" ");
  });
  return keys4.join(",");
}
var parseStyle = function parseStyle2(interpolation) {
  var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
    root: true,
    parentSelectors: []
  }, root2 = _ref.root, injectHash = _ref.injectHash, parentSelectors = _ref.parentSelectors;
  var hashId = config.hashId, layer = config.layer, path2 = config.path, hashPriority = config.hashPriority, _config$transformers = config.transformers, transformers = _config$transformers === void 0 ? [] : _config$transformers, _config$linters = config.linters, linters = _config$linters === void 0 ? [] : _config$linters;
  var styleStr = "";
  var effectStyle = {};
  function parseKeyframes(keyframes) {
    var animationName = keyframes.getName(hashId);
    if (!effectStyle[animationName]) {
      var _parseStyle = parseStyle2(keyframes.style, config, {
        root: false,
        parentSelectors
      }), _parseStyle2 = _slicedToArray(_parseStyle, 1), _parsedStr = _parseStyle2[0];
      effectStyle[animationName] = "@keyframes ".concat(keyframes.getName(hashId)).concat(_parsedStr);
    }
  }
  function flattenList(list) {
    var fullList = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    list.forEach(function(item) {
      if (Array.isArray(item)) {
        flattenList(item, fullList);
      } else if (item) {
        fullList.push(item);
      }
    });
    return fullList;
  }
  var flattenStyleList = flattenList(Array.isArray(interpolation) ? interpolation : [interpolation]);
  flattenStyleList.forEach(function(originStyle) {
    var style2 = typeof originStyle === "string" && !root2 ? {} : originStyle;
    if (typeof style2 === "string") {
      styleStr += "".concat(style2, "\n");
    } else if (style2._keyframe) {
      parseKeyframes(style2);
    } else {
      var mergedStyle = transformers.reduce(function(prev2, trans) {
        var _trans$visit;
        return (trans === null || trans === void 0 || (_trans$visit = trans.visit) === null || _trans$visit === void 0 ? void 0 : _trans$visit.call(trans, prev2)) || prev2;
      }, style2);
      Object.keys(mergedStyle).forEach(function(key2) {
        var value = mergedStyle[key2];
        if (_typeof(value) === "object" && value && (key2 !== "animationName" || !value._keyframe) && !isCompoundCSSProperty(value)) {
          var subInjectHash = false;
          var mergedKey = key2.trim();
          var nextRoot = false;
          if ((root2 || injectHash) && hashId) {
            if (mergedKey.startsWith("@")) {
              subInjectHash = true;
            } else if (mergedKey === "&") {
              mergedKey = injectSelectorHash("", hashId, hashPriority);
            } else {
              mergedKey = injectSelectorHash(key2, hashId, hashPriority);
            }
          } else if (root2 && !hashId && (mergedKey === "&" || mergedKey === "")) {
            mergedKey = "";
            nextRoot = true;
          }
          var _parseStyle3 = parseStyle2(value, config, {
            root: nextRoot,
            injectHash: subInjectHash,
            parentSelectors: [].concat(_toConsumableArray(parentSelectors), [mergedKey])
          }), _parseStyle4 = _slicedToArray(_parseStyle3, 2), _parsedStr2 = _parseStyle4[0], childEffectStyle = _parseStyle4[1];
          effectStyle = _objectSpread2(_objectSpread2({}, effectStyle), childEffectStyle);
          styleStr += "".concat(mergedKey).concat(_parsedStr2);
        } else {
          let appendStyle = function(cssKey, cssValue) {
            if (_typeof(value) !== "object" || !(value !== null && value !== void 0 && value[SKIP_CHECK])) {
              [contentQuotesLinter_default, hashedAnimationLinter_default].concat(_toConsumableArray(linters)).forEach(function(linter5) {
                return linter5(cssKey, cssValue, {
                  path: path2,
                  hashId,
                  parentSelectors
                });
              });
            }
            var styleName = cssKey.replace(/[A-Z]/g, function(match2) {
              return "-".concat(match2.toLowerCase());
            });
            var formatValue2 = cssValue;
            if (!unitless_browser_esm_default[cssKey] && typeof formatValue2 === "number" && formatValue2 !== 0) {
              formatValue2 = "".concat(formatValue2, "px");
            }
            if (cssKey === "animationName" && cssValue !== null && cssValue !== void 0 && cssValue._keyframe) {
              parseKeyframes(cssValue);
              formatValue2 = cssValue.getName(hashId);
            }
            styleStr += "".concat(styleName, ":").concat(formatValue2, ";");
          };
          var _value;
          var actualValue = (_value = value === null || value === void 0 ? void 0 : value.value) !== null && _value !== void 0 ? _value : value;
          if (_typeof(value) === "object" && value !== null && value !== void 0 && value[MULTI_VALUE] && Array.isArray(actualValue)) {
            actualValue.forEach(function(item) {
              appendStyle(key2, item);
            });
          } else {
            appendStyle(key2, actualValue);
          }
        }
      });
    }
  });
  if (!root2) {
    styleStr = "{".concat(styleStr, "}");
  } else if (layer) {
    if (styleStr) {
      styleStr = "@layer ".concat(layer.name, " {").concat(styleStr, "}");
    }
    if (layer.dependencies) {
      effectStyle["@layer ".concat(layer.name)] = layer.dependencies.map(function(deps) {
        return "@layer ".concat(deps, ", ").concat(layer.name, ";");
      }).join("\n");
    }
  }
  return [styleStr, effectStyle];
};
function uniqueHash(path2, styleStr) {
  return hash_browser_esm_default("".concat(path2.join("%")).concat(styleStr));
}
function Empty() {
  return null;
}
var STYLE_PREFIX = "style";
function useStyleRegister(info, styleFn) {
  var token2 = info.token, path2 = info.path, hashId = info.hashId, layer = info.layer, nonce = info.nonce, clientOnly = info.clientOnly, _info$order = info.order, order = _info$order === void 0 ? 0 : _info$order;
  var _React$useContext = React15.useContext(StyleContext_default), autoClear = _React$useContext.autoClear, mock = _React$useContext.mock, defaultCache = _React$useContext.defaultCache, hashPriority = _React$useContext.hashPriority, container = _React$useContext.container, ssrInline = _React$useContext.ssrInline, transformers = _React$useContext.transformers, linters = _React$useContext.linters, cache = _React$useContext.cache, enableLayer = _React$useContext.layer;
  var tokenKey = token2._tokenKey;
  var fullPath = [tokenKey];
  if (enableLayer) {
    fullPath.push("layer");
  }
  fullPath.push.apply(fullPath, _toConsumableArray(path2));
  var isMergedClientSide = isClientSide;
  if (mock !== void 0) {
    isMergedClientSide = mock === "client";
  }
  var _useGlobalCache = useGlobalCache(
    STYLE_PREFIX,
    fullPath,
    // Create cache if needed
    function() {
      var cachePath = fullPath.join("|");
      if (existPath(cachePath)) {
        var _getStyleAndHash = getStyleAndHash(cachePath), _getStyleAndHash2 = _slicedToArray(_getStyleAndHash, 2), inlineCacheStyleStr = _getStyleAndHash2[0], styleHash = _getStyleAndHash2[1];
        if (inlineCacheStyleStr) {
          return [inlineCacheStyleStr, tokenKey, styleHash, {}, clientOnly, order];
        }
      }
      var styleObj = styleFn();
      var _parseStyle5 = parseStyle(styleObj, {
        hashId,
        hashPriority,
        layer: enableLayer ? layer : void 0,
        path: path2.join("-"),
        transformers,
        linters
      }), _parseStyle6 = _slicedToArray(_parseStyle5, 2), parsedStyle = _parseStyle6[0], effectStyle = _parseStyle6[1];
      var styleStr = normalizeStyle(parsedStyle);
      var styleId = uniqueHash(fullPath, styleStr);
      return [styleStr, tokenKey, styleId, effectStyle, clientOnly, order];
    },
    // Remove cache if no need
    function(_ref2, fromHMR) {
      var _ref3 = _slicedToArray(_ref2, 3), styleId = _ref3[2];
      if ((fromHMR || autoClear) && isClientSide) {
        removeCSS(styleId, {
          mark: ATTR_MARK,
          attachTo: container
        });
      }
    },
    // Effect: Inject style here
    function(_ref4) {
      var _ref5 = _slicedToArray(_ref4, 4), styleStr = _ref5[0], _ = _ref5[1], styleId = _ref5[2], effectStyle = _ref5[3];
      if (isMergedClientSide && styleStr !== CSS_FILE_STYLE) {
        var mergedCSSConfig = {
          mark: ATTR_MARK,
          prepend: enableLayer ? false : "queue",
          attachTo: container,
          priority: order
        };
        var nonceStr = typeof nonce === "function" ? nonce() : nonce;
        if (nonceStr) {
          mergedCSSConfig.csp = {
            nonce: nonceStr
          };
        }
        var effectLayerKeys = [];
        var effectRestKeys = [];
        Object.keys(effectStyle).forEach(function(key2) {
          if (key2.startsWith("@layer")) {
            effectLayerKeys.push(key2);
          } else {
            effectRestKeys.push(key2);
          }
        });
        effectLayerKeys.forEach(function(effectKey) {
          updateCSS(normalizeStyle(effectStyle[effectKey]), "_layer-".concat(effectKey), _objectSpread2(_objectSpread2({}, mergedCSSConfig), {}, {
            prepend: true
          }));
        });
        var style2 = updateCSS(styleStr, styleId, mergedCSSConfig);
        style2[CSS_IN_JS_INSTANCE] = cache.instanceId;
        style2.setAttribute(ATTR_TOKEN, tokenKey);
        if (true) {
          style2.setAttribute(ATTR_CACHE_PATH, fullPath.join("|"));
        }
        effectRestKeys.forEach(function(effectKey) {
          updateCSS(normalizeStyle(effectStyle[effectKey]), "_effect-".concat(effectKey), mergedCSSConfig);
        });
      }
    }
  ), _useGlobalCache2 = _slicedToArray(_useGlobalCache, 3), cachedStyleStr = _useGlobalCache2[0], cachedTokenKey = _useGlobalCache2[1], cachedStyleId = _useGlobalCache2[2];
  return function(node2) {
    var styleNode;
    if (!ssrInline || isMergedClientSide || !defaultCache) {
      styleNode = /* @__PURE__ */ React15.createElement(Empty, null);
    } else {
      styleNode = /* @__PURE__ */ React15.createElement("style", _extends({}, _defineProperty(_defineProperty({}, ATTR_TOKEN, cachedTokenKey), ATTR_MARK, cachedStyleId), {
        dangerouslySetInnerHTML: {
          __html: cachedStyleStr
        }
      }));
    }
    return /* @__PURE__ */ React15.createElement(React15.Fragment, null, styleNode, node2);
  };
}
var extract3 = function extract4(cache, effectStyles, options) {
  var _cache2 = _slicedToArray(cache, 6), styleStr = _cache2[0], tokenKey = _cache2[1], styleId = _cache2[2], effectStyle = _cache2[3], clientOnly = _cache2[4], order = _cache2[5];
  var _ref7 = options || {}, plain = _ref7.plain;
  if (clientOnly) {
    return null;
  }
  var keyStyleText = styleStr;
  var sharedAttrs = {
    "data-rc-order": "prependQueue",
    "data-rc-priority": "".concat(order)
  };
  keyStyleText = toStyleStr(styleStr, tokenKey, styleId, sharedAttrs, plain);
  if (effectStyle) {
    Object.keys(effectStyle).forEach(function(effectKey) {
      if (!effectStyles[effectKey]) {
        effectStyles[effectKey] = true;
        var effectStyleStr = normalizeStyle(effectStyle[effectKey]);
        var effectStyleHTML = toStyleStr(effectStyleStr, tokenKey, "_effect-".concat(effectKey), sharedAttrs, plain);
        if (effectKey.startsWith("@layer")) {
          keyStyleText = effectStyleHTML + keyStyleText;
        } else {
          keyStyleText += effectStyleHTML;
        }
      }
    });
  }
  return [order, styleId, keyStyleText];
};

// ../../node_modules/@ant-design/cssinjs/es/hooks/useCSSVarRegister.js
var CSS_VAR_PREFIX = "cssVar";
var useCSSVarRegister = function useCSSVarRegister2(config, fn) {
  var key2 = config.key, prefix3 = config.prefix, unitless2 = config.unitless, ignore2 = config.ignore, token2 = config.token, _config$scope = config.scope, scope = _config$scope === void 0 ? "" : _config$scope;
  var _useContext = (0, import_react10.useContext)(StyleContext_default), instanceId = _useContext.cache.instanceId, container = _useContext.container;
  var tokenKey = token2._tokenKey;
  var stylePath = [].concat(_toConsumableArray(config.path), [key2, scope, tokenKey]);
  var cache = useGlobalCache(CSS_VAR_PREFIX, stylePath, function() {
    var originToken = fn();
    var _transformToken = transformToken(originToken, key2, {
      prefix: prefix3,
      unitless: unitless2,
      ignore: ignore2,
      scope
    }), _transformToken2 = _slicedToArray(_transformToken, 2), mergedToken = _transformToken2[0], cssVarsStr = _transformToken2[1];
    var styleId = uniqueHash(stylePath, cssVarsStr);
    return [mergedToken, cssVarsStr, styleId, key2];
  }, function(_ref) {
    var _ref2 = _slicedToArray(_ref, 3), styleId = _ref2[2];
    if (isClientSide) {
      removeCSS(styleId, {
        mark: ATTR_MARK,
        attachTo: container
      });
    }
  }, function(_ref3) {
    var _ref4 = _slicedToArray(_ref3, 3), cssVarsStr = _ref4[1], styleId = _ref4[2];
    if (!cssVarsStr) {
      return;
    }
    var style2 = updateCSS(cssVarsStr, styleId, {
      mark: ATTR_MARK,
      prepend: "queue",
      attachTo: container,
      priority: -999
    });
    style2[CSS_IN_JS_INSTANCE] = instanceId;
    style2.setAttribute(ATTR_TOKEN, key2);
  });
  return cache;
};
var extract5 = function extract6(cache, effectStyles, options) {
  var _cache2 = _slicedToArray(cache, 4), styleStr = _cache2[1], styleId = _cache2[2], cssVarKey = _cache2[3];
  var _ref5 = options || {}, plain = _ref5.plain;
  if (!styleStr) {
    return null;
  }
  var order = -999;
  var sharedAttrs = {
    "data-rc-order": "prependQueue",
    "data-rc-priority": "".concat(order)
  };
  var styleText = toStyleStr(styleStr, cssVarKey, styleId, sharedAttrs, plain);
  return [order, styleId, styleText];
};
var useCSSVarRegister_default = useCSSVarRegister;

// ../../node_modules/@ant-design/cssinjs/es/extractStyle.js
var ExtractStyleFns = _defineProperty(_defineProperty(_defineProperty({}, STYLE_PREFIX, extract3), TOKEN_PREFIX, extract), CSS_VAR_PREFIX, extract5);

// ../../node_modules/@ant-design/cssinjs/es/Keyframes.js
var Keyframe = /* @__PURE__ */ (function() {
  function Keyframe2(name, style2) {
    _classCallCheck(this, Keyframe2);
    _defineProperty(this, "name", void 0);
    _defineProperty(this, "style", void 0);
    _defineProperty(this, "_keyframe", true);
    this.name = name;
    this.style = style2;
  }
  _createClass(Keyframe2, [{
    key: "getName",
    value: function getName() {
      var hashId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
      return hashId ? "".concat(hashId, "-").concat(this.name) : this.name;
    }
  }]);
  return Keyframe2;
})();
var Keyframes_default = Keyframe;

// ../../node_modules/@ant-design/cssinjs/es/transformers/legacyLogicalProperties.js
function noSplit(list) {
  list.notSplit = true;
  return list;
}
var keyMap = {
  // Inset
  inset: ["top", "right", "bottom", "left"],
  insetBlock: ["top", "bottom"],
  insetBlockStart: ["top"],
  insetBlockEnd: ["bottom"],
  insetInline: ["left", "right"],
  insetInlineStart: ["left"],
  insetInlineEnd: ["right"],
  // Margin
  marginBlock: ["marginTop", "marginBottom"],
  marginBlockStart: ["marginTop"],
  marginBlockEnd: ["marginBottom"],
  marginInline: ["marginLeft", "marginRight"],
  marginInlineStart: ["marginLeft"],
  marginInlineEnd: ["marginRight"],
  // Padding
  paddingBlock: ["paddingTop", "paddingBottom"],
  paddingBlockStart: ["paddingTop"],
  paddingBlockEnd: ["paddingBottom"],
  paddingInline: ["paddingLeft", "paddingRight"],
  paddingInlineStart: ["paddingLeft"],
  paddingInlineEnd: ["paddingRight"],
  // Border
  borderBlock: noSplit(["borderTop", "borderBottom"]),
  borderBlockStart: noSplit(["borderTop"]),
  borderBlockEnd: noSplit(["borderBottom"]),
  borderInline: noSplit(["borderLeft", "borderRight"]),
  borderInlineStart: noSplit(["borderLeft"]),
  borderInlineEnd: noSplit(["borderRight"]),
  // Border width
  borderBlockWidth: ["borderTopWidth", "borderBottomWidth"],
  borderBlockStartWidth: ["borderTopWidth"],
  borderBlockEndWidth: ["borderBottomWidth"],
  borderInlineWidth: ["borderLeftWidth", "borderRightWidth"],
  borderInlineStartWidth: ["borderLeftWidth"],
  borderInlineEndWidth: ["borderRightWidth"],
  // Border style
  borderBlockStyle: ["borderTopStyle", "borderBottomStyle"],
  borderBlockStartStyle: ["borderTopStyle"],
  borderBlockEndStyle: ["borderBottomStyle"],
  borderInlineStyle: ["borderLeftStyle", "borderRightStyle"],
  borderInlineStartStyle: ["borderLeftStyle"],
  borderInlineEndStyle: ["borderRightStyle"],
  // Border color
  borderBlockColor: ["borderTopColor", "borderBottomColor"],
  borderBlockStartColor: ["borderTopColor"],
  borderBlockEndColor: ["borderBottomColor"],
  borderInlineColor: ["borderLeftColor", "borderRightColor"],
  borderInlineStartColor: ["borderLeftColor"],
  borderInlineEndColor: ["borderRightColor"],
  // Border radius
  borderStartStartRadius: ["borderTopLeftRadius"],
  borderStartEndRadius: ["borderTopRightRadius"],
  borderEndStartRadius: ["borderBottomLeftRadius"],
  borderEndEndRadius: ["borderBottomRightRadius"]
};

// ../../node_modules/@ant-design/icons/es/components/Context.js
var import_react11 = __toESM(require_react());
var IconContext = /* @__PURE__ */ (0, import_react11.createContext)({});
var Context_default = IconContext;

// ../../node_modules/@babel/runtime/helpers/esm/toArray.js
function _toArray(r2) {
  return _arrayWithHoles(r2) || _iterableToArray(r2) || _unsupportedIterableToArray(r2) || _nonIterableRest();
}

// ../../node_modules/rc-util/es/utils/get.js
function get(entity, path2) {
  var current2 = entity;
  for (var i = 0; i < path2.length; i += 1) {
    if (current2 === null || current2 === void 0) {
      return void 0;
    }
    current2 = current2[path2[i]];
  }
  return current2;
}

// ../../node_modules/rc-util/es/utils/set.js
function internalSet(entity, paths, value, removeIfUndefined) {
  if (!paths.length) {
    return value;
  }
  var _paths = _toArray(paths), path2 = _paths[0], restPath = _paths.slice(1);
  var clone;
  if (!entity && typeof path2 === "number") {
    clone = [];
  } else if (Array.isArray(entity)) {
    clone = _toConsumableArray(entity);
  } else {
    clone = _objectSpread2({}, entity);
  }
  if (removeIfUndefined && value === void 0 && restPath.length === 1) {
    delete clone[path2][restPath[0]];
  } else {
    clone[path2] = internalSet(clone[path2], restPath, value, removeIfUndefined);
  }
  return clone;
}
function set2(entity, paths, value) {
  var removeIfUndefined = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
  if (paths.length && removeIfUndefined && value === void 0 && !get(entity, paths.slice(0, -1))) {
    return entity;
  }
  return internalSet(entity, paths, value, removeIfUndefined);
}
function isObject(obj) {
  return _typeof(obj) === "object" && obj !== null && Object.getPrototypeOf(obj) === Object.prototype;
}
function createEmpty(source) {
  return Array.isArray(source) ? [] : {};
}
var keys2 = typeof Reflect === "undefined" ? Object.keys : Reflect.ownKeys;
function merge() {
  for (var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++) {
    sources[_key] = arguments[_key];
  }
  var clone = createEmpty(sources[0]);
  sources.forEach(function(src) {
    function internalMerge(path2, parentLoopSet) {
      var loopSet = new Set(parentLoopSet);
      var value = get(src, path2);
      var isArr = Array.isArray(value);
      if (isArr || isObject(value)) {
        if (!loopSet.has(value)) {
          loopSet.add(value);
          var originValue = get(clone, path2);
          if (isArr) {
            clone = set2(clone, path2, []);
          } else if (!originValue || _typeof(originValue) !== "object") {
            clone = set2(clone, path2, createEmpty(value));
          }
          keys2(value).forEach(function(key2) {
            internalMerge([].concat(_toConsumableArray(path2), [key2]), loopSet);
          });
        }
      } else {
        clone = set2(clone, path2, value);
      }
    }
    internalMerge([]);
  });
  return clone;
}

// ../../node_modules/antd/es/_util/warning.js
var React16 = __toESM(require_react());
function noop2() {
}
var deprecatedWarnList = null;
var _warning = noop2;
if (true) {
  _warning = (valid, component, message2) => {
    warning_default(valid, `[antd: ${component}] ${message2}`);
    if (false) {
      resetWarned();
    }
  };
}
var warning2 = _warning;
var WarningContext = /* @__PURE__ */ React16.createContext({});
var devUseWarning = true ? (component) => {
  const {
    strict
  } = React16.useContext(WarningContext);
  const typeWarning = (valid, type5, message2) => {
    if (!valid) {
      if (strict === false && type5 === "deprecated") {
        const existWarning = deprecatedWarnList;
        if (!deprecatedWarnList) {
          deprecatedWarnList = {};
        }
        deprecatedWarnList[component] = deprecatedWarnList[component] || [];
        if (!deprecatedWarnList[component].includes(message2 || "")) {
          deprecatedWarnList[component].push(message2 || "");
        }
        if (!existWarning) {
          console.warn("[antd] There exists deprecated usage in your code:", deprecatedWarnList);
        }
      } else {
        true ? warning2(valid, component, message2) : void 0;
      }
    }
  };
  typeWarning.deprecated = (valid, oldProp, newProp, message2) => {
    typeWarning(valid, "deprecated", `\`${oldProp}\` is deprecated. Please use \`${newProp}\` instead.${message2 ? ` ${message2}` : ""}`);
  };
  return typeWarning;
} : () => {
  const noopWarning = () => {
  };
  noopWarning.deprecated = noop2;
  return noopWarning;
};
var warning_default2 = warning2;

// ../../node_modules/antd/es/form/validateMessagesContext.js
var import_react12 = __toESM(require_react());
var validateMessagesContext_default = /* @__PURE__ */ (0, import_react12.createContext)(void 0);

// ../../node_modules/antd/es/locale/index.js
var React18 = __toESM(require_react());

// ../../node_modules/rc-pagination/es/locale/en_US.js
var locale = {
  // Options
  items_per_page: "/ page",
  jump_to: "Go to",
  jump_to_confirm: "confirm",
  page: "Page",
  // Pagination
  prev_page: "Previous Page",
  next_page: "Next Page",
  prev_5: "Previous 5 Pages",
  next_5: "Next 5 Pages",
  prev_3: "Previous 3 Pages",
  next_3: "Next 3 Pages",
  page_size: "Page Size"
};
var en_US_default = locale;

// ../../node_modules/rc-picker/es/locale/common.js
var commonLocale = {
  yearFormat: "YYYY",
  dayFormat: "D",
  cellMeridiemFormat: "A",
  monthBeforeYear: true
};

// ../../node_modules/rc-picker/es/locale/en_US.js
var locale2 = _objectSpread2(_objectSpread2({}, commonLocale), {}, {
  locale: "en_US",
  today: "Today",
  now: "Now",
  backToToday: "Back to today",
  ok: "OK",
  clear: "Clear",
  week: "Week",
  month: "Month",
  year: "Year",
  timeSelect: "select time",
  dateSelect: "select date",
  weekSelect: "Choose a week",
  monthSelect: "Choose a month",
  yearSelect: "Choose a year",
  decadeSelect: "Choose a decade",
  dateFormat: "M/D/YYYY",
  dateTimeFormat: "M/D/YYYY HH:mm:ss",
  previousMonth: "Previous month (PageUp)",
  nextMonth: "Next month (PageDown)",
  previousYear: "Last year (Control + left)",
  nextYear: "Next year (Control + right)",
  previousDecade: "Last decade",
  nextDecade: "Next decade",
  previousCentury: "Last century",
  nextCentury: "Next century"
});
var en_US_default2 = locale2;

// ../../node_modules/antd/es/time-picker/locale/en_US.js
var locale3 = {
  placeholder: "Select time",
  rangePlaceholder: ["Start time", "End time"]
};
var en_US_default3 = locale3;

// ../../node_modules/antd/es/date-picker/locale/en_US.js
var locale4 = {
  lang: Object.assign({
    placeholder: "Select date",
    yearPlaceholder: "Select year",
    quarterPlaceholder: "Select quarter",
    monthPlaceholder: "Select month",
    weekPlaceholder: "Select week",
    rangePlaceholder: ["Start date", "End date"],
    rangeYearPlaceholder: ["Start year", "End year"],
    rangeQuarterPlaceholder: ["Start quarter", "End quarter"],
    rangeMonthPlaceholder: ["Start month", "End month"],
    rangeWeekPlaceholder: ["Start week", "End week"]
  }, en_US_default2),
  timePickerLocale: Object.assign({}, en_US_default3)
};
var en_US_default4 = locale4;

// ../../node_modules/antd/es/calendar/locale/en_US.js
var en_US_default5 = en_US_default4;

// ../../node_modules/antd/es/locale/en_US.js
var typeTemplate = "${label} is not a valid ${type}";
var localeValues = {
  locale: "en",
  Pagination: en_US_default,
  DatePicker: en_US_default4,
  TimePicker: en_US_default3,
  Calendar: en_US_default5,
  global: {
    placeholder: "Please select",
    close: "Close"
  },
  Table: {
    filterTitle: "Filter menu",
    filterConfirm: "OK",
    filterReset: "Reset",
    filterEmptyText: "No filters",
    filterCheckAll: "Select all items",
    filterSearchPlaceholder: "Search in filters",
    emptyText: "No data",
    selectAll: "Select current page",
    selectInvert: "Invert current page",
    selectNone: "Clear all data",
    selectionAll: "Select all data",
    sortTitle: "Sort",
    expand: "Expand row",
    collapse: "Collapse row",
    triggerDesc: "Click to sort descending",
    triggerAsc: "Click to sort ascending",
    cancelSort: "Click to cancel sorting"
  },
  Tour: {
    Next: "Next",
    Previous: "Previous",
    Finish: "Finish"
  },
  Modal: {
    okText: "OK",
    cancelText: "Cancel",
    justOkText: "OK"
  },
  Popconfirm: {
    okText: "OK",
    cancelText: "Cancel"
  },
  Transfer: {
    titles: ["", ""],
    searchPlaceholder: "Search here",
    itemUnit: "item",
    itemsUnit: "items",
    remove: "Remove",
    selectCurrent: "Select current page",
    removeCurrent: "Remove current page",
    selectAll: "Select all data",
    deselectAll: "Deselect all data",
    removeAll: "Remove all data",
    selectInvert: "Invert current page"
  },
  Upload: {
    uploading: "Uploading...",
    removeFile: "Remove file",
    uploadError: "Upload error",
    previewFile: "Preview file",
    downloadFile: "Download file"
  },
  Empty: {
    description: "No data"
  },
  Icon: {
    icon: "icon"
  },
  Text: {
    edit: "Edit",
    copy: "Copy",
    copied: "Copied",
    expand: "Expand",
    collapse: "Collapse"
  },
  Form: {
    optional: "(optional)",
    defaultValidateMessages: {
      default: "Field validation error for ${label}",
      required: "Please enter ${label}",
      enum: "${label} must be one of [${enum}]",
      whitespace: "${label} cannot be a blank character",
      date: {
        format: "${label} date format is invalid",
        parse: "${label} cannot be converted to a date",
        invalid: "${label} is an invalid date"
      },
      types: {
        string: typeTemplate,
        method: typeTemplate,
        array: typeTemplate,
        object: typeTemplate,
        number: typeTemplate,
        date: typeTemplate,
        boolean: typeTemplate,
        integer: typeTemplate,
        float: typeTemplate,
        regexp: typeTemplate,
        email: typeTemplate,
        url: typeTemplate,
        hex: typeTemplate
      },
      string: {
        len: "${label} must be ${len} characters",
        min: "${label} must be at least ${min} characters",
        max: "${label} must be up to ${max} characters",
        range: "${label} must be between ${min}-${max} characters"
      },
      number: {
        len: "${label} must be equal to ${len}",
        min: "${label} must be minimum ${min}",
        max: "${label} must be maximum ${max}",
        range: "${label} must be between ${min}-${max}"
      },
      array: {
        len: "Must be ${len} ${label}",
        min: "At least ${min} ${label}",
        max: "At most ${max} ${label}",
        range: "The amount of ${label} must be between ${min}-${max}"
      },
      pattern: {
        mismatch: "${label} does not match the pattern ${pattern}"
      }
    }
  },
  Image: {
    preview: "Preview"
  },
  QRCode: {
    expired: "QR code expired",
    refresh: "Refresh",
    scanned: "Scanned"
  },
  ColorPicker: {
    presetEmpty: "Empty",
    transparent: "Transparent",
    singleColor: "Single",
    gradientColor: "Gradient"
  }
};
var en_US_default6 = localeValues;

// ../../node_modules/antd/es/modal/locale.js
var runtimeLocale = Object.assign({}, en_US_default6.Modal);
var localeList = [];
var generateLocale = () => localeList.reduce((merged, locale6) => Object.assign(Object.assign({}, merged), locale6), en_US_default6.Modal);
function changeConfirmLocale(newLocale) {
  if (newLocale) {
    const cloneLocale = Object.assign({}, newLocale);
    localeList.push(cloneLocale);
    runtimeLocale = generateLocale();
    return () => {
      localeList = localeList.filter((locale6) => locale6 !== cloneLocale);
      runtimeLocale = generateLocale();
    };
  }
  runtimeLocale = Object.assign({}, en_US_default6.Modal);
}

// ../../node_modules/antd/es/locale/context.js
var import_react13 = __toESM(require_react());
var LocaleContext = /* @__PURE__ */ (0, import_react13.createContext)(void 0);
var context_default = LocaleContext;

// ../../node_modules/antd/es/locale/useLocale.js
var React17 = __toESM(require_react());
var useLocale = (componentName, defaultLocale) => {
  const fullLocale = React17.useContext(context_default);
  const getLocale = React17.useMemo(() => {
    var _a;
    const locale6 = defaultLocale || en_US_default6[componentName];
    const localeFromContext = (_a = fullLocale === null || fullLocale === void 0 ? void 0 : fullLocale[componentName]) !== null && _a !== void 0 ? _a : {};
    return Object.assign(Object.assign({}, typeof locale6 === "function" ? locale6() : locale6), localeFromContext || {});
  }, [componentName, defaultLocale, fullLocale]);
  const getLocaleCode = React17.useMemo(() => {
    const localeCode = fullLocale === null || fullLocale === void 0 ? void 0 : fullLocale.locale;
    if ((fullLocale === null || fullLocale === void 0 ? void 0 : fullLocale.exist) && !localeCode) {
      return en_US_default6.locale;
    }
    return localeCode;
  }, [fullLocale]);
  return [getLocale, getLocaleCode];
};
var useLocale_default = useLocale;

// ../../node_modules/antd/es/locale/index.js
var ANT_MARK = "internalMark";
var LocaleProvider = (props) => {
  const {
    locale: locale6 = {},
    children,
    _ANT_MARK__
  } = props;
  if (true) {
    const warning6 = devUseWarning("LocaleProvider");
    true ? warning6(_ANT_MARK__ === ANT_MARK, "deprecated", "`LocaleProvider` is deprecated. Please use `locale` with `ConfigProvider` instead: http://u.ant.design/locale") : void 0;
  }
  React18.useEffect(() => {
    const clearLocale = changeConfirmLocale(locale6 === null || locale6 === void 0 ? void 0 : locale6.Modal);
    return clearLocale;
  }, [locale6]);
  const getMemoizedContextValue = React18.useMemo(() => Object.assign(Object.assign({}, locale6), {
    exist: true
  }), [locale6]);
  return /* @__PURE__ */ React18.createElement(context_default.Provider, {
    value: getMemoizedContextValue
  }, children);
};
if (true) {
  LocaleProvider.displayName = "LocaleProvider";
}
var locale_default = LocaleProvider;

// ../../node_modules/antd/es/theme/context.js
var import_react14 = __toESM(require_react());

// ../../node_modules/antd/es/theme/themes/seed.js
var defaultPresetColors = {
  blue: "#1677FF",
  purple: "#722ED1",
  cyan: "#13C2C2",
  green: "#52C41A",
  magenta: "#EB2F96",
  /**
   * @deprecated Use magenta instead
   */
  pink: "#EB2F96",
  red: "#F5222D",
  orange: "#FA8C16",
  yellow: "#FADB14",
  volcano: "#FA541C",
  geekblue: "#2F54EB",
  gold: "#FAAD14",
  lime: "#A0D911"
};
var seedToken = Object.assign(Object.assign({}, defaultPresetColors), {
  // Color
  colorPrimary: "#1677ff",
  colorSuccess: "#52c41a",
  colorWarning: "#faad14",
  colorError: "#ff4d4f",
  colorInfo: "#1677ff",
  colorLink: "",
  colorTextBase: "",
  colorBgBase: "",
  // Font
  fontFamily: `-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,
'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',
'Noto Color Emoji'`,
  fontFamilyCode: `'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace`,
  fontSize: 14,
  // Line
  lineWidth: 1,
  lineType: "solid",
  // Motion
  motionUnit: 0.1,
  motionBase: 0,
  motionEaseOutCirc: "cubic-bezier(0.08, 0.82, 0.17, 1)",
  motionEaseInOutCirc: "cubic-bezier(0.78, 0.14, 0.15, 0.86)",
  motionEaseOut: "cubic-bezier(0.215, 0.61, 0.355, 1)",
  motionEaseInOut: "cubic-bezier(0.645, 0.045, 0.355, 1)",
  motionEaseOutBack: "cubic-bezier(0.12, 0.4, 0.29, 1.46)",
  motionEaseInBack: "cubic-bezier(0.71, -0.46, 0.88, 0.6)",
  motionEaseInQuint: "cubic-bezier(0.755, 0.05, 0.855, 0.06)",
  motionEaseOutQuint: "cubic-bezier(0.23, 1, 0.32, 1)",
  // Radius
  borderRadius: 6,
  // Size
  sizeUnit: 4,
  sizeStep: 4,
  sizePopupArrow: 16,
  // Control Base
  controlHeight: 32,
  // zIndex
  zIndexBase: 0,
  zIndexPopupBase: 1e3,
  // Image
  opacityImage: 1,
  // Wireframe
  wireframe: false,
  // Motion
  motion: true
});
var seed_default = seedToken;

// ../../node_modules/@ant-design/fast-color/es/FastColor.js
var round2 = Math.round;
function splitColorStr(str, parseNum) {
  const match2 = str.replace(/^[^(]*\((.*)/, "$1").replace(/\).*/, "").match(/\d*\.?\d+%?/g) || [];
  const numList = match2.map((item) => parseFloat(item));
  for (let i = 0; i < 3; i += 1) {
    numList[i] = parseNum(numList[i] || 0, match2[i] || "", i);
  }
  if (match2[3]) {
    numList[3] = match2[3].includes("%") ? numList[3] / 100 : numList[3];
  } else {
    numList[3] = 1;
  }
  return numList;
}
var parseHSVorHSL = (num, _, index3) => index3 === 0 ? num : num / 100;
function limitRange(value, max) {
  const mergedMax = max || 255;
  if (value > mergedMax) {
    return mergedMax;
  }
  if (value < 0) {
    return 0;
  }
  return value;
}
var FastColor = class _FastColor {
  constructor(input) {
    _defineProperty(this, "isValid", true);
    _defineProperty(this, "r", 0);
    _defineProperty(this, "g", 0);
    _defineProperty(this, "b", 0);
    _defineProperty(this, "a", 1);
    _defineProperty(this, "_h", void 0);
    _defineProperty(this, "_s", void 0);
    _defineProperty(this, "_l", void 0);
    _defineProperty(this, "_v", void 0);
    _defineProperty(this, "_max", void 0);
    _defineProperty(this, "_min", void 0);
    _defineProperty(this, "_brightness", void 0);
    function matchFormat(str) {
      return str[0] in input && str[1] in input && str[2] in input;
    }
    if (!input) {
    } else if (typeof input === "string") {
      let matchPrefix = function(prefix3) {
        return trimStr.startsWith(prefix3);
      };
      const trimStr = input.trim();
      if (/^#?[A-F\d]{3,8}$/i.test(trimStr)) {
        this.fromHexString(trimStr);
      } else if (matchPrefix("rgb")) {
        this.fromRgbString(trimStr);
      } else if (matchPrefix("hsl")) {
        this.fromHslString(trimStr);
      } else if (matchPrefix("hsv") || matchPrefix("hsb")) {
        this.fromHsvString(trimStr);
      }
    } else if (input instanceof _FastColor) {
      this.r = input.r;
      this.g = input.g;
      this.b = input.b;
      this.a = input.a;
      this._h = input._h;
      this._s = input._s;
      this._l = input._l;
      this._v = input._v;
    } else if (matchFormat("rgb")) {
      this.r = limitRange(input.r);
      this.g = limitRange(input.g);
      this.b = limitRange(input.b);
      this.a = typeof input.a === "number" ? limitRange(input.a, 1) : 1;
    } else if (matchFormat("hsl")) {
      this.fromHsl(input);
    } else if (matchFormat("hsv")) {
      this.fromHsv(input);
    } else {
      throw new Error("@ant-design/fast-color: unsupported input " + JSON.stringify(input));
    }
  }
  // ======================= Setter =======================
  setR(value) {
    return this._sc("r", value);
  }
  setG(value) {
    return this._sc("g", value);
  }
  setB(value) {
    return this._sc("b", value);
  }
  setA(value) {
    return this._sc("a", value, 1);
  }
  setHue(value) {
    const hsv = this.toHsv();
    hsv.h = value;
    return this._c(hsv);
  }
  // ======================= Getter =======================
  /**
   * Returns the perceived luminance of a color, from 0-1.
   * @see http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
   */
  getLuminance() {
    function adjustGamma(raw) {
      const val = raw / 255;
      return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
    }
    const R = adjustGamma(this.r);
    const G = adjustGamma(this.g);
    const B = adjustGamma(this.b);
    return 0.2126 * R + 0.7152 * G + 0.0722 * B;
  }
  getHue() {
    if (typeof this._h === "undefined") {
      const delta = this.getMax() - this.getMin();
      if (delta === 0) {
        this._h = 0;
      } else {
        this._h = round2(60 * (this.r === this.getMax() ? (this.g - this.b) / delta + (this.g < this.b ? 6 : 0) : this.g === this.getMax() ? (this.b - this.r) / delta + 2 : (this.r - this.g) / delta + 4));
      }
    }
    return this._h;
  }
  getSaturation() {
    if (typeof this._s === "undefined") {
      const delta = this.getMax() - this.getMin();
      if (delta === 0) {
        this._s = 0;
      } else {
        this._s = delta / this.getMax();
      }
    }
    return this._s;
  }
  getLightness() {
    if (typeof this._l === "undefined") {
      this._l = (this.getMax() + this.getMin()) / 510;
    }
    return this._l;
  }
  getValue() {
    if (typeof this._v === "undefined") {
      this._v = this.getMax() / 255;
    }
    return this._v;
  }
  /**
   * Returns the perceived brightness of the color, from 0-255.
   * Note: this is not the b of HSB
   * @see http://www.w3.org/TR/AERT#color-contrast
   */
  getBrightness() {
    if (typeof this._brightness === "undefined") {
      this._brightness = (this.r * 299 + this.g * 587 + this.b * 114) / 1e3;
    }
    return this._brightness;
  }
  // ======================== Func ========================
  darken(amount = 10) {
    const h2 = this.getHue();
    const s = this.getSaturation();
    let l2 = this.getLightness() - amount / 100;
    if (l2 < 0) {
      l2 = 0;
    }
    return this._c({
      h: h2,
      s,
      l: l2,
      a: this.a
    });
  }
  lighten(amount = 10) {
    const h2 = this.getHue();
    const s = this.getSaturation();
    let l2 = this.getLightness() + amount / 100;
    if (l2 > 1) {
      l2 = 1;
    }
    return this._c({
      h: h2,
      s,
      l: l2,
      a: this.a
    });
  }
  /**
   * Mix the current color a given amount with another color, from 0 to 100.
   * 0 means no mixing (return current color).
   */
  mix(input, amount = 50) {
    const color = this._c(input);
    const p = amount / 100;
    const calc = (key2) => (color[key2] - this[key2]) * p + this[key2];
    const rgba = {
      r: round2(calc("r")),
      g: round2(calc("g")),
      b: round2(calc("b")),
      a: round2(calc("a") * 100) / 100
    };
    return this._c(rgba);
  }
  /**
   * Mix the color with pure white, from 0 to 100.
   * Providing 0 will do nothing, providing 100 will always return white.
   */
  tint(amount = 10) {
    return this.mix({
      r: 255,
      g: 255,
      b: 255,
      a: 1
    }, amount);
  }
  /**
   * Mix the color with pure black, from 0 to 100.
   * Providing 0 will do nothing, providing 100 will always return black.
   */
  shade(amount = 10) {
    return this.mix({
      r: 0,
      g: 0,
      b: 0,
      a: 1
    }, amount);
  }
  onBackground(background) {
    const bg = this._c(background);
    const alpha = this.a + bg.a * (1 - this.a);
    const calc = (key2) => {
      return round2((this[key2] * this.a + bg[key2] * bg.a * (1 - this.a)) / alpha);
    };
    return this._c({
      r: calc("r"),
      g: calc("g"),
      b: calc("b"),
      a: alpha
    });
  }
  // ======================= Status =======================
  isDark() {
    return this.getBrightness() < 128;
  }
  isLight() {
    return this.getBrightness() >= 128;
  }
  // ======================== MISC ========================
  equals(other) {
    return this.r === other.r && this.g === other.g && this.b === other.b && this.a === other.a;
  }
  clone() {
    return this._c(this);
  }
  // ======================= Format =======================
  toHexString() {
    let hex2 = "#";
    const rHex = (this.r || 0).toString(16);
    hex2 += rHex.length === 2 ? rHex : "0" + rHex;
    const gHex = (this.g || 0).toString(16);
    hex2 += gHex.length === 2 ? gHex : "0" + gHex;
    const bHex = (this.b || 0).toString(16);
    hex2 += bHex.length === 2 ? bHex : "0" + bHex;
    if (typeof this.a === "number" && this.a >= 0 && this.a < 1) {
      const aHex = round2(this.a * 255).toString(16);
      hex2 += aHex.length === 2 ? aHex : "0" + aHex;
    }
    return hex2;
  }
  /** CSS support color pattern */
  toHsl() {
    return {
      h: this.getHue(),
      s: this.getSaturation(),
      l: this.getLightness(),
      a: this.a
    };
  }
  /** CSS support color pattern */
  toHslString() {
    const h2 = this.getHue();
    const s = round2(this.getSaturation() * 100);
    const l2 = round2(this.getLightness() * 100);
    return this.a !== 1 ? `hsla(${h2},${s}%,${l2}%,${this.a})` : `hsl(${h2},${s}%,${l2}%)`;
  }
  /** Same as toHsb */
  toHsv() {
    return {
      h: this.getHue(),
      s: this.getSaturation(),
      v: this.getValue(),
      a: this.a
    };
  }
  toRgb() {
    return {
      r: this.r,
      g: this.g,
      b: this.b,
      a: this.a
    };
  }
  toRgbString() {
    return this.a !== 1 ? `rgba(${this.r},${this.g},${this.b},${this.a})` : `rgb(${this.r},${this.g},${this.b})`;
  }
  toString() {
    return this.toRgbString();
  }
  // ====================== Privates ======================
  /** Return a new FastColor object with one channel changed */
  _sc(rgb2, value, max) {
    const clone = this.clone();
    clone[rgb2] = limitRange(value, max);
    return clone;
  }
  _c(input) {
    return new this.constructor(input);
  }
  getMax() {
    if (typeof this._max === "undefined") {
      this._max = Math.max(this.r, this.g, this.b);
    }
    return this._max;
  }
  getMin() {
    if (typeof this._min === "undefined") {
      this._min = Math.min(this.r, this.g, this.b);
    }
    return this._min;
  }
  fromHexString(trimStr) {
    const withoutPrefix = trimStr.replace("#", "");
    function connectNum(index1, index22) {
      return parseInt(withoutPrefix[index1] + withoutPrefix[index22 || index1], 16);
    }
    if (withoutPrefix.length < 6) {
      this.r = connectNum(0);
      this.g = connectNum(1);
      this.b = connectNum(2);
      this.a = withoutPrefix[3] ? connectNum(3) / 255 : 1;
    } else {
      this.r = connectNum(0, 1);
      this.g = connectNum(2, 3);
      this.b = connectNum(4, 5);
      this.a = withoutPrefix[6] ? connectNum(6, 7) / 255 : 1;
    }
  }
  fromHsl({
    h: h2,
    s,
    l: l2,
    a
  }) {
    this._h = h2 % 360;
    this._s = s;
    this._l = l2;
    this.a = typeof a === "number" ? a : 1;
    if (s <= 0) {
      const rgb2 = round2(l2 * 255);
      this.r = rgb2;
      this.g = rgb2;
      this.b = rgb2;
    }
    let r2 = 0, g = 0, b = 0;
    const huePrime = h2 / 60;
    const chroma = (1 - Math.abs(2 * l2 - 1)) * s;
    const secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
    if (huePrime >= 0 && huePrime < 1) {
      r2 = chroma;
      g = secondComponent;
    } else if (huePrime >= 1 && huePrime < 2) {
      r2 = secondComponent;
      g = chroma;
    } else if (huePrime >= 2 && huePrime < 3) {
      g = chroma;
      b = secondComponent;
    } else if (huePrime >= 3 && huePrime < 4) {
      g = secondComponent;
      b = chroma;
    } else if (huePrime >= 4 && huePrime < 5) {
      r2 = secondComponent;
      b = chroma;
    } else if (huePrime >= 5 && huePrime < 6) {
      r2 = chroma;
      b = secondComponent;
    }
    const lightnessModification = l2 - chroma / 2;
    this.r = round2((r2 + lightnessModification) * 255);
    this.g = round2((g + lightnessModification) * 255);
    this.b = round2((b + lightnessModification) * 255);
  }
  fromHsv({
    h: h2,
    s,
    v,
    a
  }) {
    this._h = h2 % 360;
    this._s = s;
    this._v = v;
    this.a = typeof a === "number" ? a : 1;
    const vv = round2(v * 255);
    this.r = vv;
    this.g = vv;
    this.b = vv;
    if (s <= 0) {
      return;
    }
    const hh = h2 / 60;
    const i = Math.floor(hh);
    const ff = hh - i;
    const p = round2(v * (1 - s) * 255);
    const q = round2(v * (1 - s * ff) * 255);
    const t2 = round2(v * (1 - s * (1 - ff)) * 255);
    switch (i) {
      case 0:
        this.g = t2;
        this.b = p;
        break;
      case 1:
        this.r = q;
        this.b = p;
        break;
      case 2:
        this.r = p;
        this.b = t2;
        break;
      case 3:
        this.r = p;
        this.g = q;
        break;
      case 4:
        this.r = t2;
        this.g = p;
        break;
      case 5:
      default:
        this.g = p;
        this.b = q;
        break;
    }
  }
  fromHsvString(trimStr) {
    const cells = splitColorStr(trimStr, parseHSVorHSL);
    this.fromHsv({
      h: cells[0],
      s: cells[1],
      v: cells[2],
      a: cells[3]
    });
  }
  fromHslString(trimStr) {
    const cells = splitColorStr(trimStr, parseHSVorHSL);
    this.fromHsl({
      h: cells[0],
      s: cells[1],
      l: cells[2],
      a: cells[3]
    });
  }
  fromRgbString(trimStr) {
    const cells = splitColorStr(trimStr, (num, txt) => (
      // Convert percentage to number. e.g. 50% -> 128
      txt.includes("%") ? round2(num / 100 * 255) : num
    ));
    this.r = cells[0];
    this.g = cells[1];
    this.b = cells[2];
    this.a = cells[3];
  }
};

// ../../node_modules/@ant-design/colors/es/generate.js
var hueStep = 2;
var saturationStep = 0.16;
var saturationStep2 = 0.05;
var brightnessStep1 = 0.05;
var brightnessStep2 = 0.15;
var lightColorCount = 5;
var darkColorCount = 4;
var darkColorMap = [{
  index: 7,
  amount: 15
}, {
  index: 6,
  amount: 25
}, {
  index: 5,
  amount: 30
}, {
  index: 5,
  amount: 45
}, {
  index: 5,
  amount: 65
}, {
  index: 5,
  amount: 85
}, {
  index: 4,
  amount: 90
}, {
  index: 3,
  amount: 95
}, {
  index: 2,
  amount: 97
}, {
  index: 1,
  amount: 98
}];
function getHue(hsv, i, light) {
  var hue;
  if (Math.round(hsv.h) >= 60 && Math.round(hsv.h) <= 240) {
    hue = light ? Math.round(hsv.h) - hueStep * i : Math.round(hsv.h) + hueStep * i;
  } else {
    hue = light ? Math.round(hsv.h) + hueStep * i : Math.round(hsv.h) - hueStep * i;
  }
  if (hue < 0) {
    hue += 360;
  } else if (hue >= 360) {
    hue -= 360;
  }
  return hue;
}
function getSaturation(hsv, i, light) {
  if (hsv.h === 0 && hsv.s === 0) {
    return hsv.s;
  }
  var saturation;
  if (light) {
    saturation = hsv.s - saturationStep * i;
  } else if (i === darkColorCount) {
    saturation = hsv.s + saturationStep;
  } else {
    saturation = hsv.s + saturationStep2 * i;
  }
  if (saturation > 1) {
    saturation = 1;
  }
  if (light && i === lightColorCount && saturation > 0.1) {
    saturation = 0.1;
  }
  if (saturation < 0.06) {
    saturation = 0.06;
  }
  return Math.round(saturation * 100) / 100;
}
function getValue(hsv, i, light) {
  var value;
  if (light) {
    value = hsv.v + brightnessStep1 * i;
  } else {
    value = hsv.v - brightnessStep2 * i;
  }
  value = Math.max(0, Math.min(1, value));
  return Math.round(value * 100) / 100;
}
function generate(color) {
  var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var patterns = [];
  var pColor = new FastColor(color);
  var hsv = pColor.toHsv();
  for (var i = lightColorCount; i > 0; i -= 1) {
    var c = new FastColor({
      h: getHue(hsv, i, true),
      s: getSaturation(hsv, i, true),
      v: getValue(hsv, i, true)
    });
    patterns.push(c);
  }
  patterns.push(pColor);
  for (var _i = 1; _i <= darkColorCount; _i += 1) {
    var _c = new FastColor({
      h: getHue(hsv, _i),
      s: getSaturation(hsv, _i),
      v: getValue(hsv, _i)
    });
    patterns.push(_c);
  }
  if (opts.theme === "dark") {
    return darkColorMap.map(function(_ref) {
      var index3 = _ref.index, amount = _ref.amount;
      return new FastColor(opts.backgroundColor || "#141414").mix(patterns[index3], amount).toHexString();
    });
  }
  return patterns.map(function(c2) {
    return c2.toHexString();
  });
}

// ../../node_modules/@ant-design/colors/es/presets.js
var presetPrimaryColors = {
  "red": "#F5222D",
  "volcano": "#FA541C",
  "orange": "#FA8C16",
  "gold": "#FAAD14",
  "yellow": "#FADB14",
  "lime": "#A0D911",
  "green": "#52C41A",
  "cyan": "#13C2C2",
  "blue": "#1677FF",
  "geekblue": "#2F54EB",
  "purple": "#722ED1",
  "magenta": "#EB2F96",
  "grey": "#666666"
};
var red = ["#fff1f0", "#ffccc7", "#ffa39e", "#ff7875", "#ff4d4f", "#f5222d", "#cf1322", "#a8071a", "#820014", "#5c0011"];
red.primary = red[5];
var volcano = ["#fff2e8", "#ffd8bf", "#ffbb96", "#ff9c6e", "#ff7a45", "#fa541c", "#d4380d", "#ad2102", "#871400", "#610b00"];
volcano.primary = volcano[5];
var orange = ["#fff7e6", "#ffe7ba", "#ffd591", "#ffc069", "#ffa940", "#fa8c16", "#d46b08", "#ad4e00", "#873800", "#612500"];
orange.primary = orange[5];
var gold = ["#fffbe6", "#fff1b8", "#ffe58f", "#ffd666", "#ffc53d", "#faad14", "#d48806", "#ad6800", "#874d00", "#613400"];
gold.primary = gold[5];
var yellow = ["#feffe6", "#ffffb8", "#fffb8f", "#fff566", "#ffec3d", "#fadb14", "#d4b106", "#ad8b00", "#876800", "#614700"];
yellow.primary = yellow[5];
var lime = ["#fcffe6", "#f4ffb8", "#eaff8f", "#d3f261", "#bae637", "#a0d911", "#7cb305", "#5b8c00", "#3f6600", "#254000"];
lime.primary = lime[5];
var green = ["#f6ffed", "#d9f7be", "#b7eb8f", "#95de64", "#73d13d", "#52c41a", "#389e0d", "#237804", "#135200", "#092b00"];
green.primary = green[5];
var cyan = ["#e6fffb", "#b5f5ec", "#87e8de", "#5cdbd3", "#36cfc9", "#13c2c2", "#08979c", "#006d75", "#00474f", "#002329"];
cyan.primary = cyan[5];
var blue = ["#e6f4ff", "#bae0ff", "#91caff", "#69b1ff", "#4096ff", "#1677ff", "#0958d9", "#003eb3", "#002c8c", "#001d66"];
blue.primary = blue[5];
var geekblue = ["#f0f5ff", "#d6e4ff", "#adc6ff", "#85a5ff", "#597ef7", "#2f54eb", "#1d39c4", "#10239e", "#061178", "#030852"];
geekblue.primary = geekblue[5];
var purple = ["#f9f0ff", "#efdbff", "#d3adf7", "#b37feb", "#9254de", "#722ed1", "#531dab", "#391085", "#22075e", "#120338"];
purple.primary = purple[5];
var magenta = ["#fff0f6", "#ffd6e7", "#ffadd2", "#ff85c0", "#f759ab", "#eb2f96", "#c41d7f", "#9e1068", "#780650", "#520339"];
magenta.primary = magenta[5];
var grey = ["#a6a6a6", "#999999", "#8c8c8c", "#808080", "#737373", "#666666", "#404040", "#1a1a1a", "#000000", "#000000"];
grey.primary = grey[5];
var presetPalettes = {
  red,
  volcano,
  orange,
  gold,
  yellow,
  lime,
  green,
  cyan,
  blue,
  geekblue,
  purple,
  magenta,
  grey
};
var redDark = ["#2a1215", "#431418", "#58181c", "#791a1f", "#a61d24", "#d32029", "#e84749", "#f37370", "#f89f9a", "#fac8c3"];
redDark.primary = redDark[5];
var volcanoDark = ["#2b1611", "#441d12", "#592716", "#7c3118", "#aa3e19", "#d84a1b", "#e87040", "#f3956a", "#f8b692", "#fad4bc"];
volcanoDark.primary = volcanoDark[5];
var orangeDark = ["#2b1d11", "#442a11", "#593815", "#7c4a15", "#aa6215", "#d87a16", "#e89a3c", "#f3b765", "#f8cf8d", "#fae3b7"];
orangeDark.primary = orangeDark[5];
var goldDark = ["#2b2111", "#443111", "#594214", "#7c5914", "#aa7714", "#d89614", "#e8b339", "#f3cc62", "#f8df8b", "#faedb5"];
goldDark.primary = goldDark[5];
var yellowDark = ["#2b2611", "#443b11", "#595014", "#7c6e14", "#aa9514", "#d8bd14", "#e8d639", "#f3ea62", "#f8f48b", "#fafab5"];
yellowDark.primary = yellowDark[5];
var limeDark = ["#1f2611", "#2e3c10", "#3e4f13", "#536d13", "#6f9412", "#8bbb11", "#a9d134", "#c9e75d", "#e4f88b", "#f0fab5"];
limeDark.primary = limeDark[5];
var greenDark = ["#162312", "#1d3712", "#274916", "#306317", "#3c8618", "#49aa19", "#6abe39", "#8fd460", "#b2e58b", "#d5f2bb"];
greenDark.primary = greenDark[5];
var cyanDark = ["#112123", "#113536", "#144848", "#146262", "#138585", "#13a8a8", "#33bcb7", "#58d1c9", "#84e2d8", "#b2f1e8"];
cyanDark.primary = cyanDark[5];
var blueDark = ["#111a2c", "#112545", "#15325b", "#15417e", "#1554ad", "#1668dc", "#3c89e8", "#65a9f3", "#8dc5f8", "#b7dcfa"];
blueDark.primary = blueDark[5];
var geekblueDark = ["#131629", "#161d40", "#1c2755", "#203175", "#263ea0", "#2b4acb", "#5273e0", "#7f9ef3", "#a8c1f8", "#d2e0fa"];
geekblueDark.primary = geekblueDark[5];
var purpleDark = ["#1a1325", "#24163a", "#301c4d", "#3e2069", "#51258f", "#642ab5", "#854eca", "#ab7ae0", "#cda8f0", "#ebd7fa"];
purpleDark.primary = purpleDark[5];
var magentaDark = ["#291321", "#40162f", "#551c3b", "#75204f", "#a02669", "#cb2b83", "#e0529c", "#f37fb7", "#f8a8cc", "#fad2e3"];
magentaDark.primary = magentaDark[5];
var greyDark = ["#151515", "#1f1f1f", "#2d2d2d", "#393939", "#494949", "#5a5a5a", "#6a6a6a", "#7b7b7b", "#888888", "#969696"];
greyDark.primary = greyDark[5];

// ../../node_modules/antd/es/theme/themes/shared/genColorMapToken.js
function genColorMapToken(seed, {
  generateColorPalettes: generateColorPalettes3,
  generateNeutralColorPalettes: generateNeutralColorPalettes3
}) {
  const {
    colorSuccess: colorSuccessBase,
    colorWarning: colorWarningBase,
    colorError: colorErrorBase,
    colorInfo: colorInfoBase,
    colorPrimary: colorPrimaryBase,
    colorBgBase,
    colorTextBase
  } = seed;
  const primaryColors = generateColorPalettes3(colorPrimaryBase);
  const successColors = generateColorPalettes3(colorSuccessBase);
  const warningColors = generateColorPalettes3(colorWarningBase);
  const errorColors = generateColorPalettes3(colorErrorBase);
  const infoColors = generateColorPalettes3(colorInfoBase);
  const neutralColors = generateNeutralColorPalettes3(colorBgBase, colorTextBase);
  const colorLink = seed.colorLink || seed.colorInfo;
  const linkColors = generateColorPalettes3(colorLink);
  const colorErrorBgFilledHover = new FastColor(errorColors[1]).mix(new FastColor(errorColors[3]), 50).toHexString();
  return Object.assign(Object.assign({}, neutralColors), {
    colorPrimaryBg: primaryColors[1],
    colorPrimaryBgHover: primaryColors[2],
    colorPrimaryBorder: primaryColors[3],
    colorPrimaryBorderHover: primaryColors[4],
    colorPrimaryHover: primaryColors[5],
    colorPrimary: primaryColors[6],
    colorPrimaryActive: primaryColors[7],
    colorPrimaryTextHover: primaryColors[8],
    colorPrimaryText: primaryColors[9],
    colorPrimaryTextActive: primaryColors[10],
    colorSuccessBg: successColors[1],
    colorSuccessBgHover: successColors[2],
    colorSuccessBorder: successColors[3],
    colorSuccessBorderHover: successColors[4],
    colorSuccessHover: successColors[4],
    colorSuccess: successColors[6],
    colorSuccessActive: successColors[7],
    colorSuccessTextHover: successColors[8],
    colorSuccessText: successColors[9],
    colorSuccessTextActive: successColors[10],
    colorErrorBg: errorColors[1],
    colorErrorBgHover: errorColors[2],
    colorErrorBgFilledHover,
    colorErrorBgActive: errorColors[3],
    colorErrorBorder: errorColors[3],
    colorErrorBorderHover: errorColors[4],
    colorErrorHover: errorColors[5],
    colorError: errorColors[6],
    colorErrorActive: errorColors[7],
    colorErrorTextHover: errorColors[8],
    colorErrorText: errorColors[9],
    colorErrorTextActive: errorColors[10],
    colorWarningBg: warningColors[1],
    colorWarningBgHover: warningColors[2],
    colorWarningBorder: warningColors[3],
    colorWarningBorderHover: warningColors[4],
    colorWarningHover: warningColors[4],
    colorWarning: warningColors[6],
    colorWarningActive: warningColors[7],
    colorWarningTextHover: warningColors[8],
    colorWarningText: warningColors[9],
    colorWarningTextActive: warningColors[10],
    colorInfoBg: infoColors[1],
    colorInfoBgHover: infoColors[2],
    colorInfoBorder: infoColors[3],
    colorInfoBorderHover: infoColors[4],
    colorInfoHover: infoColors[4],
    colorInfo: infoColors[6],
    colorInfoActive: infoColors[7],
    colorInfoTextHover: infoColors[8],
    colorInfoText: infoColors[9],
    colorInfoTextActive: infoColors[10],
    colorLinkHover: linkColors[4],
    colorLink: linkColors[6],
    colorLinkActive: linkColors[7],
    colorBgMask: new FastColor("#000").setA(0.45).toRgbString(),
    colorWhite: "#fff"
  });
}

// ../../node_modules/antd/es/theme/themes/shared/genRadius.js
var genRadius = (radiusBase) => {
  let radiusLG = radiusBase;
  let radiusSM = radiusBase;
  let radiusXS = radiusBase;
  let radiusOuter = radiusBase;
  if (radiusBase < 6 && radiusBase >= 5) {
    radiusLG = radiusBase + 1;
  } else if (radiusBase < 16 && radiusBase >= 6) {
    radiusLG = radiusBase + 2;
  } else if (radiusBase >= 16) {
    radiusLG = 16;
  }
  if (radiusBase < 7 && radiusBase >= 5) {
    radiusSM = 4;
  } else if (radiusBase < 8 && radiusBase >= 7) {
    radiusSM = 5;
  } else if (radiusBase < 14 && radiusBase >= 8) {
    radiusSM = 6;
  } else if (radiusBase < 16 && radiusBase >= 14) {
    radiusSM = 7;
  } else if (radiusBase >= 16) {
    radiusSM = 8;
  }
  if (radiusBase < 6 && radiusBase >= 2) {
    radiusXS = 1;
  } else if (radiusBase >= 6) {
    radiusXS = 2;
  }
  if (radiusBase > 4 && radiusBase < 8) {
    radiusOuter = 4;
  } else if (radiusBase >= 8) {
    radiusOuter = 6;
  }
  return {
    borderRadius: radiusBase,
    borderRadiusXS: radiusXS,
    borderRadiusSM: radiusSM,
    borderRadiusLG: radiusLG,
    borderRadiusOuter: radiusOuter
  };
};
var genRadius_default = genRadius;

// ../../node_modules/antd/es/theme/themes/shared/genCommonMapToken.js
function genCommonMapToken(token2) {
  const {
    motionUnit,
    motionBase,
    borderRadius,
    lineWidth
  } = token2;
  return Object.assign({
    // motion
    motionDurationFast: `${(motionBase + motionUnit).toFixed(1)}s`,
    motionDurationMid: `${(motionBase + motionUnit * 2).toFixed(1)}s`,
    motionDurationSlow: `${(motionBase + motionUnit * 3).toFixed(1)}s`,
    // line
    lineWidthBold: lineWidth + 1
  }, genRadius_default(borderRadius));
}

// ../../node_modules/antd/es/theme/themes/shared/genControlHeight.js
var genControlHeight = (token2) => {
  const {
    controlHeight
  } = token2;
  return {
    controlHeightSM: controlHeight * 0.75,
    controlHeightXS: controlHeight * 0.5,
    controlHeightLG: controlHeight * 1.25
  };
};
var genControlHeight_default = genControlHeight;

// ../../node_modules/antd/es/theme/themes/shared/genFontSizes.js
function getLineHeight(fontSize) {
  return (fontSize + 8) / fontSize;
}
function getFontSizes(base) {
  const fontSizes = Array.from({
    length: 10
  }).map((_, index3) => {
    const i = index3 - 1;
    const baseSize = base * Math.pow(Math.E, i / 5);
    const intSize = index3 > 1 ? Math.floor(baseSize) : Math.ceil(baseSize);
    return Math.floor(intSize / 2) * 2;
  });
  fontSizes[1] = base;
  return fontSizes.map((size) => ({
    size,
    lineHeight: getLineHeight(size)
  }));
}

// ../../node_modules/antd/es/theme/themes/shared/genFontMapToken.js
var genFontMapToken = (fontSize) => {
  const fontSizePairs = getFontSizes(fontSize);
  const fontSizes = fontSizePairs.map((pair) => pair.size);
  const lineHeights = fontSizePairs.map((pair) => pair.lineHeight);
  const fontSizeMD = fontSizes[1];
  const fontSizeSM = fontSizes[0];
  const fontSizeLG = fontSizes[2];
  const lineHeight = lineHeights[1];
  const lineHeightSM = lineHeights[0];
  const lineHeightLG = lineHeights[2];
  return {
    fontSizeSM,
    fontSize: fontSizeMD,
    fontSizeLG,
    fontSizeXL: fontSizes[3],
    fontSizeHeading1: fontSizes[6],
    fontSizeHeading2: fontSizes[5],
    fontSizeHeading3: fontSizes[4],
    fontSizeHeading4: fontSizes[3],
    fontSizeHeading5: fontSizes[2],
    lineHeight,
    lineHeightLG,
    lineHeightSM,
    fontHeight: Math.round(lineHeight * fontSizeMD),
    fontHeightLG: Math.round(lineHeightLG * fontSizeLG),
    fontHeightSM: Math.round(lineHeightSM * fontSizeSM),
    lineHeightHeading1: lineHeights[6],
    lineHeightHeading2: lineHeights[5],
    lineHeightHeading3: lineHeights[4],
    lineHeightHeading4: lineHeights[3],
    lineHeightHeading5: lineHeights[2]
  };
};
var genFontMapToken_default = genFontMapToken;

// ../../node_modules/antd/es/theme/themes/shared/genSizeMapToken.js
function genSizeMapToken(token2) {
  const {
    sizeUnit,
    sizeStep
  } = token2;
  return {
    sizeXXL: sizeUnit * (sizeStep + 8),
    // 48
    sizeXL: sizeUnit * (sizeStep + 4),
    // 32
    sizeLG: sizeUnit * (sizeStep + 2),
    // 24
    sizeMD: sizeUnit * (sizeStep + 1),
    // 20
    sizeMS: sizeUnit * sizeStep,
    // 16
    size: sizeUnit * sizeStep,
    // 16
    sizeSM: sizeUnit * (sizeStep - 1),
    // 12
    sizeXS: sizeUnit * (sizeStep - 2),
    // 8
    sizeXXS: sizeUnit * (sizeStep - 3)
    // 4
  };
}

// ../../node_modules/antd/es/theme/themes/default/colorAlgorithm.js
var getAlphaColor = (baseColor, alpha) => new FastColor(baseColor).setA(alpha).toRgbString();
var getSolidColor = (baseColor, brightness) => {
  const instance = new FastColor(baseColor);
  return instance.darken(brightness).toHexString();
};

// ../../node_modules/antd/es/theme/themes/default/colors.js
var generateColorPalettes = (baseColor) => {
  const colors = generate(baseColor);
  return {
    1: colors[0],
    2: colors[1],
    3: colors[2],
    4: colors[3],
    5: colors[4],
    6: colors[5],
    7: colors[6],
    8: colors[4],
    9: colors[5],
    10: colors[6]
    // 8: colors[7],
    // 9: colors[8],
    // 10: colors[9],
  };
};
var generateNeutralColorPalettes = (bgBaseColor, textBaseColor) => {
  const colorBgBase = bgBaseColor || "#fff";
  const colorTextBase = textBaseColor || "#000";
  return {
    colorBgBase,
    colorTextBase,
    colorText: getAlphaColor(colorTextBase, 0.88),
    colorTextSecondary: getAlphaColor(colorTextBase, 0.65),
    colorTextTertiary: getAlphaColor(colorTextBase, 0.45),
    colorTextQuaternary: getAlphaColor(colorTextBase, 0.25),
    colorFill: getAlphaColor(colorTextBase, 0.15),
    colorFillSecondary: getAlphaColor(colorTextBase, 0.06),
    colorFillTertiary: getAlphaColor(colorTextBase, 0.04),
    colorFillQuaternary: getAlphaColor(colorTextBase, 0.02),
    colorBgSolid: getAlphaColor(colorTextBase, 1),
    colorBgSolidHover: getAlphaColor(colorTextBase, 0.75),
    colorBgSolidActive: getAlphaColor(colorTextBase, 0.95),
    colorBgLayout: getSolidColor(colorBgBase, 4),
    colorBgContainer: getSolidColor(colorBgBase, 0),
    colorBgElevated: getSolidColor(colorBgBase, 0),
    colorBgSpotlight: getAlphaColor(colorTextBase, 0.85),
    colorBgBlur: "transparent",
    colorBorder: getSolidColor(colorBgBase, 15),
    colorBorderSecondary: getSolidColor(colorBgBase, 6)
  };
};

// ../../node_modules/antd/es/theme/themes/default/index.js
function derivative(token2) {
  presetPrimaryColors.pink = presetPrimaryColors.magenta;
  presetPalettes.pink = presetPalettes.magenta;
  const colorPalettes = Object.keys(defaultPresetColors).map((colorKey) => {
    const colors = token2[colorKey] === presetPrimaryColors[colorKey] ? presetPalettes[colorKey] : generate(token2[colorKey]);
    return Array.from({
      length: 10
    }, () => 1).reduce((prev2, _, i) => {
      prev2[`${colorKey}-${i + 1}`] = colors[i];
      prev2[`${colorKey}${i + 1}`] = colors[i];
      return prev2;
    }, {});
  }).reduce((prev2, cur) => {
    prev2 = Object.assign(Object.assign({}, prev2), cur);
    return prev2;
  }, {});
  return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, token2), colorPalettes), genColorMapToken(token2, {
    generateColorPalettes,
    generateNeutralColorPalettes
  })), genFontMapToken_default(token2.fontSize)), genSizeMapToken(token2)), genControlHeight_default(token2)), genCommonMapToken(token2));
}

// ../../node_modules/antd/es/theme/themes/default/theme.js
var defaultTheme = createTheme(derivative);
var theme_default = defaultTheme;

// ../../node_modules/antd/es/theme/context.js
var defaultConfig = {
  token: seed_default,
  override: {
    override: seed_default
  },
  hashed: true
};
var DesignTokenContext = /* @__PURE__ */ import_react14.default.createContext(defaultConfig);

// ../../node_modules/antd/es/config-provider/context.js
var React20 = __toESM(require_react());
var defaultPrefixCls = "ant";
var defaultIconPrefixCls = "anticon";
var Variants = ["outlined", "borderless", "filled", "underlined"];
var defaultGetPrefixCls = (suffixCls, customizePrefixCls) => {
  if (customizePrefixCls) {
    return customizePrefixCls;
  }
  return suffixCls ? `${defaultPrefixCls}-${suffixCls}` : defaultPrefixCls;
};
var ConfigContext = /* @__PURE__ */ React20.createContext({
  // We provide a default function for Context without provider
  getPrefixCls: defaultGetPrefixCls,
  iconPrefixCls: defaultIconPrefixCls
});
var {
  Consumer: ConfigConsumer
} = ConfigContext;
var EMPTY_OBJECT = {};
function useComponentConfig(propName) {
  const context = React20.useContext(ConfigContext);
  const {
    getPrefixCls,
    direction,
    getPopupContainer
  } = context;
  const propValue = context[propName];
  return Object.assign(Object.assign({
    classNames: EMPTY_OBJECT,
    styles: EMPTY_OBJECT
  }, propValue), {
    getPrefixCls,
    direction,
    getPopupContainer
  });
}

// ../../node_modules/antd/es/config-provider/cssVariables.js
var dynamicStyleMark = `-ant-${Date.now()}-${Math.random()}`;
function getStyle(globalPrefixCls2, theme) {
  const variables = {};
  const formatColor = (color, updater) => {
    let clone = color.clone();
    clone = (updater === null || updater === void 0 ? void 0 : updater(clone)) || clone;
    return clone.toRgbString();
  };
  const fillColor = (colorVal, type5) => {
    const baseColor = new FastColor(colorVal);
    const colorPalettes = generate(baseColor.toRgbString());
    variables[`${type5}-color`] = formatColor(baseColor);
    variables[`${type5}-color-disabled`] = colorPalettes[1];
    variables[`${type5}-color-hover`] = colorPalettes[4];
    variables[`${type5}-color-active`] = colorPalettes[6];
    variables[`${type5}-color-outline`] = baseColor.clone().setA(0.2).toRgbString();
    variables[`${type5}-color-deprecated-bg`] = colorPalettes[0];
    variables[`${type5}-color-deprecated-border`] = colorPalettes[2];
  };
  if (theme.primaryColor) {
    fillColor(theme.primaryColor, "primary");
    const primaryColor = new FastColor(theme.primaryColor);
    const primaryColors = generate(primaryColor.toRgbString());
    primaryColors.forEach((color, index3) => {
      variables[`primary-${index3 + 1}`] = color;
    });
    variables["primary-color-deprecated-l-35"] = formatColor(primaryColor, (c) => c.lighten(35));
    variables["primary-color-deprecated-l-20"] = formatColor(primaryColor, (c) => c.lighten(20));
    variables["primary-color-deprecated-t-20"] = formatColor(primaryColor, (c) => c.tint(20));
    variables["primary-color-deprecated-t-50"] = formatColor(primaryColor, (c) => c.tint(50));
    variables["primary-color-deprecated-f-12"] = formatColor(primaryColor, (c) => c.setA(c.a * 0.12));
    const primaryActiveColor = new FastColor(primaryColors[0]);
    variables["primary-color-active-deprecated-f-30"] = formatColor(primaryActiveColor, (c) => c.setA(c.a * 0.3));
    variables["primary-color-active-deprecated-d-02"] = formatColor(primaryActiveColor, (c) => c.darken(2));
  }
  if (theme.successColor) {
    fillColor(theme.successColor, "success");
  }
  if (theme.warningColor) {
    fillColor(theme.warningColor, "warning");
  }
  if (theme.errorColor) {
    fillColor(theme.errorColor, "error");
  }
  if (theme.infoColor) {
    fillColor(theme.infoColor, "info");
  }
  const cssList = Object.keys(variables).map((key2) => `--${globalPrefixCls2}-${key2}: ${variables[key2]};`);
  return `
  :root {
    ${cssList.join("\n")}
  }
  `.trim();
}
function registerTheme(globalPrefixCls2, theme) {
  const style2 = getStyle(globalPrefixCls2, theme);
  if (canUseDom()) {
    updateCSS(style2, `${dynamicStyleMark}-dynamic-theme`);
  } else {
    true ? warning_default2(false, "ConfigProvider", "SSR do not support dynamic theme with css variables.") : void 0;
  }
}

// ../../node_modules/antd/es/config-provider/DisabledContext.js
var React21 = __toESM(require_react());
var DisabledContext = /* @__PURE__ */ React21.createContext(false);
var DisabledContextProvider = ({
  children,
  disabled
}) => {
  const originDisabled = React21.useContext(DisabledContext);
  return /* @__PURE__ */ React21.createElement(DisabledContext.Provider, {
    value: disabled !== null && disabled !== void 0 ? disabled : originDisabled
  }, children);
};
var DisabledContext_default = DisabledContext;

// ../../node_modules/antd/es/config-provider/hooks/useConfig.js
var import_react15 = __toESM(require_react());

// ../../node_modules/antd/es/config-provider/SizeContext.js
var React22 = __toESM(require_react());
var SizeContext = /* @__PURE__ */ React22.createContext(void 0);
var SizeContextProvider = ({
  children,
  size
}) => {
  const originSize = React22.useContext(SizeContext);
  return /* @__PURE__ */ React22.createElement(SizeContext.Provider, {
    value: size || originSize
  }, children);
};
var SizeContext_default = SizeContext;

// ../../node_modules/antd/es/config-provider/hooks/useConfig.js
function useConfig() {
  const componentDisabled = (0, import_react15.useContext)(DisabledContext_default);
  const componentSize = (0, import_react15.useContext)(SizeContext_default);
  return {
    componentDisabled,
    componentSize
  };
}
var useConfig_default = useConfig;

// ../../node_modules/@ant-design/cssinjs-utils/es/util/genStyleUtils.js
var import_react17 = __toESM(require_react());

// ../../node_modules/@ant-design/cssinjs-utils/es/util/calc/calculator.js
var AbstractCalculator = /* @__PURE__ */ _createClass(function AbstractCalculator2() {
  _classCallCheck(this, AbstractCalculator2);
});
var calculator_default2 = AbstractCalculator;

// ../../node_modules/@ant-design/cssinjs-utils/es/util/calc/CSSCalculator.js
var CALC_UNIT2 = "CALC_UNIT";
var regexp2 = new RegExp(CALC_UNIT2, "g");
function unit2(value) {
  if (typeof value === "number") {
    return "".concat(value).concat(CALC_UNIT2);
  }
  return value;
}
var CSSCalculator2 = /* @__PURE__ */ (function(_AbstractCalculator) {
  _inherits(CSSCalculator3, _AbstractCalculator);
  var _super = _createSuper(CSSCalculator3);
  function CSSCalculator3(num, unitlessCssVar) {
    var _this;
    _classCallCheck(this, CSSCalculator3);
    _this = _super.call(this);
    _defineProperty(_assertThisInitialized(_this), "result", "");
    _defineProperty(_assertThisInitialized(_this), "unitlessCssVar", void 0);
    _defineProperty(_assertThisInitialized(_this), "lowPriority", void 0);
    var numType = _typeof(num);
    _this.unitlessCssVar = unitlessCssVar;
    if (num instanceof CSSCalculator3) {
      _this.result = "(".concat(num.result, ")");
    } else if (numType === "number") {
      _this.result = unit2(num);
    } else if (numType === "string") {
      _this.result = num;
    }
    return _this;
  }
  _createClass(CSSCalculator3, [{
    key: "add",
    value: function add3(num) {
      if (num instanceof CSSCalculator3) {
        this.result = "".concat(this.result, " + ").concat(num.getResult());
      } else if (typeof num === "number" || typeof num === "string") {
        this.result = "".concat(this.result, " + ").concat(unit2(num));
      }
      this.lowPriority = true;
      return this;
    }
  }, {
    key: "sub",
    value: function sub(num) {
      if (num instanceof CSSCalculator3) {
        this.result = "".concat(this.result, " - ").concat(num.getResult());
      } else if (typeof num === "number" || typeof num === "string") {
        this.result = "".concat(this.result, " - ").concat(unit2(num));
      }
      this.lowPriority = true;
      return this;
    }
  }, {
    key: "mul",
    value: function mul(num) {
      if (this.lowPriority) {
        this.result = "(".concat(this.result, ")");
      }
      if (num instanceof CSSCalculator3) {
        this.result = "".concat(this.result, " * ").concat(num.getResult(true));
      } else if (typeof num === "number" || typeof num === "string") {
        this.result = "".concat(this.result, " * ").concat(num);
      }
      this.lowPriority = false;
      return this;
    }
  }, {
    key: "div",
    value: function div(num) {
      if (this.lowPriority) {
        this.result = "(".concat(this.result, ")");
      }
      if (num instanceof CSSCalculator3) {
        this.result = "".concat(this.result, " / ").concat(num.getResult(true));
      } else if (typeof num === "number" || typeof num === "string") {
        this.result = "".concat(this.result, " / ").concat(num);
      }
      this.lowPriority = false;
      return this;
    }
  }, {
    key: "getResult",
    value: function getResult(force) {
      return this.lowPriority || force ? "(".concat(this.result, ")") : this.result;
    }
  }, {
    key: "equal",
    value: function equal(options) {
      var _this2 = this;
      var _ref = options || {}, cssUnit = _ref.unit;
      var mergedUnit = true;
      if (typeof cssUnit === "boolean") {
        mergedUnit = cssUnit;
      } else if (Array.from(this.unitlessCssVar).some(function(cssVar) {
        return _this2.result.includes(cssVar);
      })) {
        mergedUnit = false;
      }
      this.result = this.result.replace(regexp2, mergedUnit ? "px" : "");
      if (typeof this.lowPriority !== "undefined") {
        return "calc(".concat(this.result, ")");
      }
      return this.result;
    }
  }]);
  return CSSCalculator3;
})(calculator_default2);

// ../../node_modules/@ant-design/cssinjs-utils/es/util/calc/NumCalculator.js
var NumCalculator2 = /* @__PURE__ */ (function(_AbstractCalculator) {
  _inherits(NumCalculator3, _AbstractCalculator);
  var _super = _createSuper(NumCalculator3);
  function NumCalculator3(num) {
    var _this;
    _classCallCheck(this, NumCalculator3);
    _this = _super.call(this);
    _defineProperty(_assertThisInitialized(_this), "result", 0);
    if (num instanceof NumCalculator3) {
      _this.result = num.result;
    } else if (typeof num === "number") {
      _this.result = num;
    }
    return _this;
  }
  _createClass(NumCalculator3, [{
    key: "add",
    value: function add3(num) {
      if (num instanceof NumCalculator3) {
        this.result += num.result;
      } else if (typeof num === "number") {
        this.result += num;
      }
      return this;
    }
  }, {
    key: "sub",
    value: function sub(num) {
      if (num instanceof NumCalculator3) {
        this.result -= num.result;
      } else if (typeof num === "number") {
        this.result -= num;
      }
      return this;
    }
  }, {
    key: "mul",
    value: function mul(num) {
      if (num instanceof NumCalculator3) {
        this.result *= num.result;
      } else if (typeof num === "number") {
        this.result *= num;
      }
      return this;
    }
  }, {
    key: "div",
    value: function div(num) {
      if (num instanceof NumCalculator3) {
        this.result /= num.result;
      } else if (typeof num === "number") {
        this.result /= num;
      }
      return this;
    }
  }, {
    key: "equal",
    value: function equal() {
      return this.result;
    }
  }]);
  return NumCalculator3;
})(calculator_default2);
var NumCalculator_default = NumCalculator2;

// ../../node_modules/@ant-design/cssinjs-utils/es/util/calc/index.js
var genCalc = function genCalc2(type5, unitlessCssVar) {
  var Calculator = type5 === "css" ? CSSCalculator2 : NumCalculator_default;
  return function(num) {
    return new Calculator(num, unitlessCssVar);
  };
};
var calc_default2 = genCalc;

// ../../node_modules/@ant-design/cssinjs-utils/es/util/getCompVarPrefix.js
var getCompVarPrefix = function getCompVarPrefix2(component, prefix3) {
  return "".concat([prefix3, component.replace(/([A-Z]+)([A-Z][a-z]+)/g, "$1-$2").replace(/([a-z])([A-Z])/g, "$1-$2")].filter(Boolean).join("-"));
};
var getCompVarPrefix_default = getCompVarPrefix;

// ../../node_modules/rc-util/es/hooks/useEvent.js
var React23 = __toESM(require_react());
function useEvent2(callback) {
  var fnRef = React23.useRef();
  fnRef.current = callback;
  var memoFn = React23.useCallback(function() {
    var _fnRef$current;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return (_fnRef$current = fnRef.current) === null || _fnRef$current === void 0 ? void 0 : _fnRef$current.call.apply(_fnRef$current, [fnRef].concat(args));
  }, []);
  return memoFn;
}

// ../../node_modules/rc-util/es/hooks/useState.js
var React24 = __toESM(require_react());
function useSafeState(defaultValue2) {
  var destroyRef = React24.useRef(false);
  var _React$useState = React24.useState(defaultValue2), _React$useState2 = _slicedToArray(_React$useState, 2), value = _React$useState2[0], setValue = _React$useState2[1];
  React24.useEffect(function() {
    destroyRef.current = false;
    return function() {
      destroyRef.current = true;
    };
  }, []);
  function safeSetState(updater, ignoreDestroy) {
    if (ignoreDestroy && destroyRef.current) {
      return;
    }
    setValue(updater);
  }
  return [value, safeSetState];
}

// ../../node_modules/rc-util/es/hooks/useMergedState.js
function hasValue(value) {
  return value !== void 0;
}
function useMergedState(defaultStateValue, option) {
  var _ref = option || {}, defaultValue2 = _ref.defaultValue, value = _ref.value, onChange = _ref.onChange, postState = _ref.postState;
  var _useState = useSafeState(function() {
    if (hasValue(value)) {
      return value;
    } else if (hasValue(defaultValue2)) {
      return typeof defaultValue2 === "function" ? defaultValue2() : defaultValue2;
    } else {
      return typeof defaultStateValue === "function" ? defaultStateValue() : defaultStateValue;
    }
  }), _useState2 = _slicedToArray(_useState, 2), innerValue = _useState2[0], setInnerValue = _useState2[1];
  var mergedValue = value !== void 0 ? value : innerValue;
  var postMergedValue = postState ? postState(mergedValue) : mergedValue;
  var onChangeFn = useEvent2(onChange);
  var _useState3 = useSafeState([mergedValue]), _useState4 = _slicedToArray(_useState3, 2), prevValue = _useState4[0], setPrevValue = _useState4[1];
  useLayoutUpdateEffect(function() {
    var prev2 = prevValue[0];
    if (innerValue !== prev2) {
      onChangeFn(innerValue, prev2);
    }
  }, [prevValue]);
  useLayoutUpdateEffect(function() {
    if (!hasValue(value)) {
      setInnerValue(value);
    }
  }, [value]);
  var triggerChange = useEvent2(function(updater, ignoreDestroy) {
    setInnerValue(updater, ignoreDestroy);
    setPrevValue([mergedValue], ignoreDestroy);
  });
  return [postMergedValue, triggerChange];
}

// ../../node_modules/@ant-design/cssinjs-utils/es/util/getComponentToken.js
function getComponentToken(component, token2, defaultToken, options) {
  var customToken = _objectSpread2({}, token2[component]);
  if (options !== null && options !== void 0 && options.deprecatedTokens) {
    var deprecatedTokens = options.deprecatedTokens;
    deprecatedTokens.forEach(function(_ref) {
      var _ref2 = _slicedToArray(_ref, 2), oldTokenKey = _ref2[0], newTokenKey = _ref2[1];
      if (true) {
        warning_default(!(customToken !== null && customToken !== void 0 && customToken[oldTokenKey]), "Component Token `".concat(String(oldTokenKey), "` of ").concat(String(component), " is deprecated. Please use `").concat(String(newTokenKey), "` instead."));
      }
      if (customToken !== null && customToken !== void 0 && customToken[oldTokenKey] || customToken !== null && customToken !== void 0 && customToken[newTokenKey]) {
        var _customToken$newToken;
        (_customToken$newToken = customToken[newTokenKey]) !== null && _customToken$newToken !== void 0 ? _customToken$newToken : customToken[newTokenKey] = customToken === null || customToken === void 0 ? void 0 : customToken[oldTokenKey];
      }
    });
  }
  var mergedToken = _objectSpread2(_objectSpread2({}, defaultToken), customToken);
  Object.keys(mergedToken).forEach(function(key2) {
    if (mergedToken[key2] === token2[key2]) {
      delete mergedToken[key2];
    }
  });
  return mergedToken;
}
var getComponentToken_default = getComponentToken;

// ../../node_modules/@ant-design/cssinjs-utils/es/util/statistic.js
var enableStatistic = true;
var recording = true;
function merge2() {
  for (var _len = arguments.length, objs = new Array(_len), _key = 0; _key < _len; _key++) {
    objs[_key] = arguments[_key];
  }
  if (!enableStatistic) {
    return Object.assign.apply(Object, [{}].concat(objs));
  }
  recording = false;
  var ret = {};
  objs.forEach(function(obj) {
    if (_typeof(obj) !== "object") {
      return;
    }
    var keys4 = Object.keys(obj);
    keys4.forEach(function(key2) {
      Object.defineProperty(ret, key2, {
        configurable: true,
        enumerable: true,
        get: function get3() {
          return obj[key2];
        }
      });
    });
  });
  recording = true;
  return ret;
}
var statistic = {};
function noop3() {
}
var statisticToken = function statisticToken2(token2) {
  var tokenKeys2;
  var proxy = token2;
  var flush = noop3;
  if (enableStatistic && typeof Proxy !== "undefined") {
    tokenKeys2 = /* @__PURE__ */ new Set();
    proxy = new Proxy(token2, {
      get: function get3(obj, prop) {
        if (recording) {
          var _tokenKeys;
          (_tokenKeys = tokenKeys2) === null || _tokenKeys === void 0 || _tokenKeys.add(prop);
        }
        return obj[prop];
      }
    });
    flush = function flush2(componentName, componentToken) {
      var _statistic$componentN;
      statistic[componentName] = {
        global: Array.from(tokenKeys2),
        component: _objectSpread2(_objectSpread2({}, (_statistic$componentN = statistic[componentName]) === null || _statistic$componentN === void 0 ? void 0 : _statistic$componentN.component), componentToken)
      };
    };
  }
  return {
    token: proxy,
    keys: tokenKeys2,
    flush
  };
};
var statistic_default = statisticToken;

// ../../node_modules/@ant-design/cssinjs-utils/es/util/getDefaultComponentToken.js
function getDefaultComponentToken(component, token2, getDefaultToken) {
  if (typeof getDefaultToken === "function") {
    var _token$component;
    return getDefaultToken(merge2(token2, (_token$component = token2[component]) !== null && _token$component !== void 0 ? _token$component : {}));
  }
  return getDefaultToken !== null && getDefaultToken !== void 0 ? getDefaultToken : {};
}
var getDefaultComponentToken_default = getDefaultComponentToken;

// ../../node_modules/@ant-design/cssinjs-utils/es/util/maxmin.js
function genMaxMin(type5) {
  if (type5 === "js") {
    return {
      max: Math.max,
      min: Math.min
    };
  }
  return {
    max: function max() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return "max(".concat(args.map(function(value) {
        return unit(value);
      }).join(","), ")");
    },
    min: function min() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      return "min(".concat(args.map(function(value) {
        return unit(value);
      }).join(","), ")");
    }
  };
}
var maxmin_default = genMaxMin;

// ../../node_modules/@ant-design/cssinjs-utils/es/_util/hooks/useUniqueMemo.js
var import_react16 = __toESM(require_react());
var BEAT_LIMIT = 1e3 * 60 * 10;
var ArrayKeyMap = /* @__PURE__ */ (function() {
  function ArrayKeyMap2() {
    _classCallCheck(this, ArrayKeyMap2);
    _defineProperty(this, "map", /* @__PURE__ */ new Map());
    _defineProperty(this, "objectIDMap", /* @__PURE__ */ new WeakMap());
    _defineProperty(this, "nextID", 0);
    _defineProperty(this, "lastAccessBeat", /* @__PURE__ */ new Map());
    _defineProperty(this, "accessBeat", 0);
  }
  _createClass(ArrayKeyMap2, [{
    key: "set",
    value: function set4(keys4, value) {
      this.clear();
      var compositeKey = this.getCompositeKey(keys4);
      this.map.set(compositeKey, value);
      this.lastAccessBeat.set(compositeKey, Date.now());
    }
  }, {
    key: "get",
    value: function get3(keys4) {
      var compositeKey = this.getCompositeKey(keys4);
      var cache = this.map.get(compositeKey);
      this.lastAccessBeat.set(compositeKey, Date.now());
      this.accessBeat += 1;
      return cache;
    }
  }, {
    key: "getCompositeKey",
    value: function getCompositeKey(keys4) {
      var _this = this;
      var ids2 = keys4.map(function(key2) {
        if (key2 && _typeof(key2) === "object") {
          return "obj_".concat(_this.getObjectID(key2));
        }
        return "".concat(_typeof(key2), "_").concat(key2);
      });
      return ids2.join("|");
    }
  }, {
    key: "getObjectID",
    value: function getObjectID(obj) {
      if (this.objectIDMap.has(obj)) {
        return this.objectIDMap.get(obj);
      }
      var id = this.nextID;
      this.objectIDMap.set(obj, id);
      this.nextID += 1;
      return id;
    }
  }, {
    key: "clear",
    value: function clear() {
      var _this2 = this;
      if (this.accessBeat > 1e4) {
        var now4 = Date.now();
        this.lastAccessBeat.forEach(function(beat, key2) {
          if (now4 - beat > BEAT_LIMIT) {
            _this2.map.delete(key2);
            _this2.lastAccessBeat.delete(key2);
          }
        });
        this.accessBeat = 0;
      }
    }
  }]);
  return ArrayKeyMap2;
})();
var uniqueMap = new ArrayKeyMap();
function useUniqueMemo(memoFn, deps) {
  return import_react16.default.useMemo(function() {
    var cachedValue = uniqueMap.get(deps);
    if (cachedValue) {
      return cachedValue;
    }
    var newValue = memoFn();
    uniqueMap.set(deps, newValue);
    return newValue;
  }, deps);
}
var useUniqueMemo_default = useUniqueMemo;

// ../../node_modules/@ant-design/cssinjs-utils/es/hooks/useCSP.js
var useDefaultCSP = function useDefaultCSP2() {
  return {};
};
var useCSP_default = useDefaultCSP;

// ../../node_modules/@ant-design/cssinjs-utils/es/util/genStyleUtils.js
function genStyleUtils(config) {
  var _config$useCSP = config.useCSP, useCSP = _config$useCSP === void 0 ? useCSP_default : _config$useCSP, useToken3 = config.useToken, usePrefix = config.usePrefix, getResetStyles2 = config.getResetStyles, getCommonStyle = config.getCommonStyle, getCompUnitless = config.getCompUnitless;
  function genStyleHooks2(component, styleFn, getDefaultToken, options) {
    var componentName = Array.isArray(component) ? component[0] : component;
    function prefixToken(key2) {
      return "".concat(String(componentName)).concat(key2.slice(0, 1).toUpperCase()).concat(key2.slice(1));
    }
    var originUnitless = (options === null || options === void 0 ? void 0 : options.unitless) || {};
    var originCompUnitless = typeof getCompUnitless === "function" ? getCompUnitless(component) : {};
    var compUnitless = _objectSpread2(_objectSpread2({}, originCompUnitless), {}, _defineProperty({}, prefixToken("zIndexPopup"), true));
    Object.keys(originUnitless).forEach(function(key2) {
      compUnitless[prefixToken(key2)] = originUnitless[key2];
    });
    var mergedOptions = _objectSpread2(_objectSpread2({}, options), {}, {
      unitless: compUnitless,
      prefixToken
    });
    var useStyle = genComponentStyleHook2(component, styleFn, getDefaultToken, mergedOptions);
    var useCSSVar = genCSSVarRegister(componentName, getDefaultToken, mergedOptions);
    return function(prefixCls) {
      var rootCls = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : prefixCls;
      var _useStyle = useStyle(prefixCls, rootCls), _useStyle2 = _slicedToArray(_useStyle, 2), hashId = _useStyle2[1];
      var _useCSSVar = useCSSVar(rootCls), _useCSSVar2 = _slicedToArray(_useCSSVar, 2), wrapCSSVar = _useCSSVar2[0], cssVarCls = _useCSSVar2[1];
      return [wrapCSSVar, hashId, cssVarCls];
    };
  }
  function genCSSVarRegister(component, getDefaultToken, options) {
    var compUnitless = options.unitless, _options$injectStyle = options.injectStyle, injectStyle2 = _options$injectStyle === void 0 ? true : _options$injectStyle, prefixToken = options.prefixToken, ignore2 = options.ignore;
    var CSSVarRegister = function CSSVarRegister2(_ref) {
      var rootCls = _ref.rootCls, _ref$cssVar = _ref.cssVar, cssVar = _ref$cssVar === void 0 ? {} : _ref$cssVar;
      var _useToken = useToken3(), realToken = _useToken.realToken;
      useCSSVarRegister_default({
        path: [component],
        prefix: cssVar.prefix,
        key: cssVar.key,
        unitless: compUnitless,
        ignore: ignore2,
        token: realToken,
        scope: rootCls
      }, function() {
        var defaultToken = getDefaultComponentToken_default(component, realToken, getDefaultToken);
        var componentToken = getComponentToken_default(component, realToken, defaultToken, {
          deprecatedTokens: options === null || options === void 0 ? void 0 : options.deprecatedTokens
        });
        Object.keys(defaultToken).forEach(function(key2) {
          componentToken[prefixToken(key2)] = componentToken[key2];
          delete componentToken[key2];
        });
        return componentToken;
      });
      return null;
    };
    var useCSSVar = function useCSSVar2(rootCls) {
      var _useToken2 = useToken3(), cssVar = _useToken2.cssVar;
      return [function(node2) {
        return injectStyle2 && cssVar ? /* @__PURE__ */ import_react17.default.createElement(import_react17.default.Fragment, null, /* @__PURE__ */ import_react17.default.createElement(CSSVarRegister, {
          rootCls,
          cssVar,
          component
        }), node2) : node2;
      }, cssVar === null || cssVar === void 0 ? void 0 : cssVar.key];
    };
    return useCSSVar;
  }
  function genComponentStyleHook2(componentName, styleFn, getDefaultToken) {
    var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    var cells = Array.isArray(componentName) ? componentName : [componentName, componentName];
    var _cells = _slicedToArray(cells, 1), component = _cells[0];
    var concatComponent = cells.join("-");
    var mergedLayer = config.layer || {
      name: "antd"
    };
    return function(prefixCls) {
      var rootCls = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : prefixCls;
      var _useToken3 = useToken3(), theme = _useToken3.theme, realToken = _useToken3.realToken, hashId = _useToken3.hashId, token2 = _useToken3.token, cssVar = _useToken3.cssVar;
      var _usePrefix = usePrefix(), rootPrefixCls = _usePrefix.rootPrefixCls, iconPrefixCls = _usePrefix.iconPrefixCls;
      var csp = useCSP();
      var type5 = cssVar ? "css" : "js";
      var calc = useUniqueMemo_default(function() {
        var unitlessCssVar = /* @__PURE__ */ new Set();
        if (cssVar) {
          Object.keys(options.unitless || {}).forEach(function(key2) {
            unitlessCssVar.add(token2CSSVar(key2, cssVar.prefix));
            unitlessCssVar.add(token2CSSVar(key2, getCompVarPrefix_default(component, cssVar.prefix)));
          });
        }
        return calc_default2(type5, unitlessCssVar);
      }, [type5, component, cssVar === null || cssVar === void 0 ? void 0 : cssVar.prefix]);
      var _genMaxMin = maxmin_default(type5), max = _genMaxMin.max, min = _genMaxMin.min;
      var sharedConfig = {
        theme,
        token: token2,
        hashId,
        nonce: function nonce() {
          return csp.nonce;
        },
        clientOnly: options.clientOnly,
        layer: mergedLayer,
        // antd is always at top of styles
        order: options.order || -999
      };
      if (typeof getResetStyles2 === "function") {
        useStyleRegister(_objectSpread2(_objectSpread2({}, sharedConfig), {}, {
          clientOnly: false,
          path: ["Shared", rootPrefixCls]
        }), function() {
          return getResetStyles2(token2, {
            prefix: {
              rootPrefixCls,
              iconPrefixCls
            },
            csp
          });
        });
      }
      var wrapSSR = useStyleRegister(_objectSpread2(_objectSpread2({}, sharedConfig), {}, {
        path: [concatComponent, prefixCls, iconPrefixCls]
      }), function() {
        if (options.injectStyle === false) {
          return [];
        }
        var _statisticToken = statistic_default(token2), proxyToken = _statisticToken.token, flush = _statisticToken.flush;
        var defaultComponentToken = getDefaultComponentToken_default(component, realToken, getDefaultToken);
        var componentCls = ".".concat(prefixCls);
        var componentToken = getComponentToken_default(component, realToken, defaultComponentToken, {
          deprecatedTokens: options.deprecatedTokens
        });
        if (cssVar && defaultComponentToken && _typeof(defaultComponentToken) === "object") {
          Object.keys(defaultComponentToken).forEach(function(key2) {
            defaultComponentToken[key2] = "var(".concat(token2CSSVar(key2, getCompVarPrefix_default(component, cssVar.prefix)), ")");
          });
        }
        var mergedToken = merge2(proxyToken, {
          componentCls,
          prefixCls,
          iconCls: ".".concat(iconPrefixCls),
          antCls: ".".concat(rootPrefixCls),
          calc,
          // @ts-ignore
          max,
          // @ts-ignore
          min
        }, cssVar ? defaultComponentToken : componentToken);
        var styleInterpolation = styleFn(mergedToken, {
          hashId,
          prefixCls,
          rootPrefixCls,
          iconPrefixCls
        });
        flush(component, componentToken);
        var commonStyle = typeof getCommonStyle === "function" ? getCommonStyle(mergedToken, prefixCls, rootCls, options.resetFont) : null;
        return [options.resetStyle === false ? null : commonStyle, styleInterpolation];
      });
      return [wrapSSR, hashId];
    };
  }
  function genSubStyleComponent2(componentName, styleFn, getDefaultToken) {
    var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    var useStyle = genComponentStyleHook2(componentName, styleFn, getDefaultToken, _objectSpread2({
      resetStyle: false,
      // Sub Style should default after root one
      order: -998
    }, options));
    var StyledComponent = function StyledComponent2(_ref2) {
      var prefixCls = _ref2.prefixCls, _ref2$rootCls = _ref2.rootCls, rootCls = _ref2$rootCls === void 0 ? prefixCls : _ref2$rootCls;
      useStyle(prefixCls, rootCls);
      return null;
    };
    if (true) {
      StyledComponent.displayName = "SubStyle_".concat(String(Array.isArray(componentName) ? componentName.join(".") : componentName));
    }
    return StyledComponent;
  }
  return {
    genStyleHooks: genStyleHooks2,
    genSubStyleComponent: genSubStyleComponent2,
    genComponentStyleHook: genComponentStyleHook2
  };
}
var genStyleUtils_default = genStyleUtils;

// ../../node_modules/antd/es/theme/interface/presetColors.js
var PresetColors = ["blue", "purple", "cyan", "green", "magenta", "pink", "red", "orange", "yellow", "volcano", "geekblue", "lime", "gold"];

// ../../node_modules/antd/es/theme/useToken.js
var import_react18 = __toESM(require_react());

// ../../node_modules/antd/es/version/version.js
var version_default = "5.27.2";

// ../../node_modules/antd/es/version/index.js
var version_default2 = version_default;

// ../../node_modules/antd/es/theme/util/getAlphaColor.js
function isStableColor(color) {
  return color >= 0 && color <= 255;
}
function getAlphaColor2(frontColor, backgroundColor) {
  const {
    r: fR,
    g: fG,
    b: fB,
    a: originAlpha
  } = new FastColor(frontColor).toRgb();
  if (originAlpha < 1) {
    return frontColor;
  }
  const {
    r: bR,
    g: bG,
    b: bB
  } = new FastColor(backgroundColor).toRgb();
  for (let fA = 0.01; fA <= 1; fA += 0.01) {
    const r2 = Math.round((fR - bR * (1 - fA)) / fA);
    const g = Math.round((fG - bG * (1 - fA)) / fA);
    const b = Math.round((fB - bB * (1 - fA)) / fA);
    if (isStableColor(r2) && isStableColor(g) && isStableColor(b)) {
      return new FastColor({
        r: r2,
        g,
        b,
        a: Math.round(fA * 100) / 100
      }).toRgbString();
    }
  }
  return new FastColor({
    r: fR,
    g: fG,
    b: fB,
    a: 1
  }).toRgbString();
}
var getAlphaColor_default = getAlphaColor2;

// ../../node_modules/antd/es/theme/util/alias.js
var __rest2 = function(s, e3) {
  var t2 = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e3.indexOf(p) < 0) t2[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e3.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t2[p[i]] = s[p[i]];
  }
  return t2;
};
function formatToken(derivativeToken) {
  const {
    override
  } = derivativeToken, restToken = __rest2(derivativeToken, ["override"]);
  const overrideTokens = Object.assign({}, override);
  Object.keys(seed_default).forEach((token2) => {
    delete overrideTokens[token2];
  });
  const mergedToken = Object.assign(Object.assign({}, restToken), overrideTokens);
  const screenXS = 480;
  const screenSM = 576;
  const screenMD = 768;
  const screenLG = 992;
  const screenXL = 1200;
  const screenXXL = 1600;
  if (mergedToken.motion === false) {
    const fastDuration = "0s";
    mergedToken.motionDurationFast = fastDuration;
    mergedToken.motionDurationMid = fastDuration;
    mergedToken.motionDurationSlow = fastDuration;
  }
  const aliasToken = Object.assign(Object.assign(Object.assign({}, mergedToken), {
    // ============== Background ============== //
    colorFillContent: mergedToken.colorFillSecondary,
    colorFillContentHover: mergedToken.colorFill,
    colorFillAlter: mergedToken.colorFillQuaternary,
    colorBgContainerDisabled: mergedToken.colorFillTertiary,
    // ============== Split ============== //
    colorBorderBg: mergedToken.colorBgContainer,
    colorSplit: getAlphaColor_default(mergedToken.colorBorderSecondary, mergedToken.colorBgContainer),
    // ============== Text ============== //
    colorTextPlaceholder: mergedToken.colorTextQuaternary,
    colorTextDisabled: mergedToken.colorTextQuaternary,
    colorTextHeading: mergedToken.colorText,
    colorTextLabel: mergedToken.colorTextSecondary,
    colorTextDescription: mergedToken.colorTextTertiary,
    colorTextLightSolid: mergedToken.colorWhite,
    colorHighlight: mergedToken.colorError,
    colorBgTextHover: mergedToken.colorFillSecondary,
    colorBgTextActive: mergedToken.colorFill,
    colorIcon: mergedToken.colorTextTertiary,
    colorIconHover: mergedToken.colorText,
    colorErrorOutline: getAlphaColor_default(mergedToken.colorErrorBg, mergedToken.colorBgContainer),
    colorWarningOutline: getAlphaColor_default(mergedToken.colorWarningBg, mergedToken.colorBgContainer),
    // Font
    fontSizeIcon: mergedToken.fontSizeSM,
    // Line
    lineWidthFocus: mergedToken.lineWidth * 3,
    // Control
    lineWidth: mergedToken.lineWidth,
    controlOutlineWidth: mergedToken.lineWidth * 2,
    // Checkbox size and expand icon size
    controlInteractiveSize: mergedToken.controlHeight / 2,
    controlItemBgHover: mergedToken.colorFillTertiary,
    controlItemBgActive: mergedToken.colorPrimaryBg,
    controlItemBgActiveHover: mergedToken.colorPrimaryBgHover,
    controlItemBgActiveDisabled: mergedToken.colorFill,
    controlTmpOutline: mergedToken.colorFillQuaternary,
    controlOutline: getAlphaColor_default(mergedToken.colorPrimaryBg, mergedToken.colorBgContainer),
    lineType: mergedToken.lineType,
    borderRadius: mergedToken.borderRadius,
    borderRadiusXS: mergedToken.borderRadiusXS,
    borderRadiusSM: mergedToken.borderRadiusSM,
    borderRadiusLG: mergedToken.borderRadiusLG,
    fontWeightStrong: 600,
    opacityLoading: 0.65,
    linkDecoration: "none",
    linkHoverDecoration: "none",
    linkFocusDecoration: "none",
    controlPaddingHorizontal: 12,
    controlPaddingHorizontalSM: 8,
    paddingXXS: mergedToken.sizeXXS,
    paddingXS: mergedToken.sizeXS,
    paddingSM: mergedToken.sizeSM,
    padding: mergedToken.size,
    paddingMD: mergedToken.sizeMD,
    paddingLG: mergedToken.sizeLG,
    paddingXL: mergedToken.sizeXL,
    paddingContentHorizontalLG: mergedToken.sizeLG,
    paddingContentVerticalLG: mergedToken.sizeMS,
    paddingContentHorizontal: mergedToken.sizeMS,
    paddingContentVertical: mergedToken.sizeSM,
    paddingContentHorizontalSM: mergedToken.size,
    paddingContentVerticalSM: mergedToken.sizeXS,
    marginXXS: mergedToken.sizeXXS,
    marginXS: mergedToken.sizeXS,
    marginSM: mergedToken.sizeSM,
    margin: mergedToken.size,
    marginMD: mergedToken.sizeMD,
    marginLG: mergedToken.sizeLG,
    marginXL: mergedToken.sizeXL,
    marginXXL: mergedToken.sizeXXL,
    boxShadow: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowSecondary: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowTertiary: `
      0 1px 2px 0 rgba(0, 0, 0, 0.03),
      0 1px 6px -1px rgba(0, 0, 0, 0.02),
      0 2px 4px 0 rgba(0, 0, 0, 0.02)
    `,
    screenXS,
    screenXSMin: screenXS,
    screenXSMax: screenSM - 1,
    screenSM,
    screenSMMin: screenSM,
    screenSMMax: screenMD - 1,
    screenMD,
    screenMDMin: screenMD,
    screenMDMax: screenLG - 1,
    screenLG,
    screenLGMin: screenLG,
    screenLGMax: screenXL - 1,
    screenXL,
    screenXLMin: screenXL,
    screenXLMax: screenXXL - 1,
    screenXXL,
    screenXXLMin: screenXXL,
    boxShadowPopoverArrow: "2px 2px 5px rgba(0, 0, 0, 0.05)",
    boxShadowCard: `
      0 1px 2px -2px ${new FastColor("rgba(0, 0, 0, 0.16)").toRgbString()},
      0 3px 6px 0 ${new FastColor("rgba(0, 0, 0, 0.12)").toRgbString()},
      0 5px 12px 4px ${new FastColor("rgba(0, 0, 0, 0.09)").toRgbString()}
    `,
    boxShadowDrawerRight: `
      -6px 0 16px 0 rgba(0, 0, 0, 0.08),
      -3px 0 6px -4px rgba(0, 0, 0, 0.12),
      -9px 0 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowDrawerLeft: `
      6px 0 16px 0 rgba(0, 0, 0, 0.08),
      3px 0 6px -4px rgba(0, 0, 0, 0.12),
      9px 0 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowDrawerUp: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowDrawerDown: `
      0 -6px 16px 0 rgba(0, 0, 0, 0.08),
      0 -3px 6px -4px rgba(0, 0, 0, 0.12),
      0 -9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowTabsOverflowLeft: "inset 10px 0 8px -8px rgba(0, 0, 0, 0.08)",
    boxShadowTabsOverflowRight: "inset -10px 0 8px -8px rgba(0, 0, 0, 0.08)",
    boxShadowTabsOverflowTop: "inset 0 10px 8px -8px rgba(0, 0, 0, 0.08)",
    boxShadowTabsOverflowBottom: "inset 0 -10px 8px -8px rgba(0, 0, 0, 0.08)"
  }), overrideTokens);
  return aliasToken;
}

// ../../node_modules/antd/es/theme/useToken.js
var __rest3 = function(s, e3) {
  var t2 = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e3.indexOf(p) < 0) t2[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e3.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t2[p[i]] = s[p[i]];
  }
  return t2;
};
var unitless = {
  lineHeight: true,
  lineHeightSM: true,
  lineHeightLG: true,
  lineHeightHeading1: true,
  lineHeightHeading2: true,
  lineHeightHeading3: true,
  lineHeightHeading4: true,
  lineHeightHeading5: true,
  opacityLoading: true,
  fontWeightStrong: true,
  zIndexPopupBase: true,
  zIndexBase: true,
  opacityImage: true
};
var ignore = {
  motionBase: true,
  motionUnit: true
};
var preserve = {
  screenXS: true,
  screenXSMin: true,
  screenXSMax: true,
  screenSM: true,
  screenSMMin: true,
  screenSMMax: true,
  screenMD: true,
  screenMDMin: true,
  screenMDMax: true,
  screenLG: true,
  screenLGMin: true,
  screenLGMax: true,
  screenXL: true,
  screenXLMin: true,
  screenXLMax: true,
  screenXXL: true,
  screenXXLMin: true
};
var getComputedToken3 = (originToken, overrideToken, theme) => {
  const derivativeToken = theme.getDerivativeToken(originToken);
  const {
    override
  } = overrideToken, components = __rest3(overrideToken, ["override"]);
  let mergedDerivativeToken = Object.assign(Object.assign({}, derivativeToken), {
    override
  });
  mergedDerivativeToken = formatToken(mergedDerivativeToken);
  if (components) {
    Object.entries(components).forEach(([key2, value]) => {
      const {
        theme: componentTheme
      } = value, componentTokens = __rest3(value, ["theme"]);
      let mergedComponentToken = componentTokens;
      if (componentTheme) {
        mergedComponentToken = getComputedToken3(Object.assign(Object.assign({}, mergedDerivativeToken), componentTokens), {
          override: componentTokens
        }, componentTheme);
      }
      mergedDerivativeToken[key2] = mergedComponentToken;
    });
  }
  return mergedDerivativeToken;
};
function useToken() {
  const {
    token: rootDesignToken,
    hashed,
    theme,
    override,
    cssVar
  } = import_react18.default.useContext(DesignTokenContext);
  const salt = `${version_default2}-${hashed || ""}`;
  const mergedTheme = theme || theme_default;
  const [token2, hashId, realToken] = useCacheToken(mergedTheme, [seed_default, rootDesignToken], {
    salt,
    override,
    getComputedToken: getComputedToken3,
    // formatToken will not be consumed after 1.15.0 with getComputedToken.
    // But token will break if @ant-design/cssinjs is under 1.15.0 without it
    formatToken,
    cssVar: cssVar && {
      prefix: cssVar.prefix,
      key: cssVar.key,
      unitless,
      ignore,
      preserve
    }
  });
  return [mergedTheme, realToken, hashed ? hashId : "", token2, cssVar];
}

// ../../node_modules/antd/es/theme/util/genStyleUtils.js
var import_react19 = __toESM(require_react());

// ../../node_modules/antd/es/style/index.js
var textEllipsis = {
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis"
};
var resetComponent = (token2, needInheritFontFamily = false) => ({
  boxSizing: "border-box",
  margin: 0,
  padding: 0,
  color: token2.colorText,
  fontSize: token2.fontSize,
  // font-variant: @font-variant-base;
  lineHeight: token2.lineHeight,
  listStyle: "none",
  // font-feature-settings: @font-feature-settings-base;
  fontFamily: needInheritFontFamily ? "inherit" : token2.fontFamily
});
var resetIcon = () => ({
  display: "inline-flex",
  alignItems: "center",
  color: "inherit",
  fontStyle: "normal",
  lineHeight: 0,
  textAlign: "center",
  textTransform: "none",
  // for SVG icon, see https://blog.prototypr.io/align-svg-icons-to-text-and-say-goodbye-to-font-icons-d44b3d7b26b4
  verticalAlign: "-0.125em",
  textRendering: "optimizeLegibility",
  "-webkit-font-smoothing": "antialiased",
  "-moz-osx-font-smoothing": "grayscale",
  "> *": {
    lineHeight: 1
  },
  svg: {
    display: "inline-block"
  }
});
var clearFix = () => ({
  // https://github.com/ant-design/ant-design/issues/21301#issuecomment-583955229
  "&::before": {
    display: "table",
    content: '""'
  },
  "&::after": {
    // https://github.com/ant-design/ant-design/issues/21864
    display: "table",
    clear: "both",
    content: '""'
  }
});
var genLinkStyle = (token2) => ({
  a: {
    color: token2.colorLink,
    textDecoration: token2.linkDecoration,
    backgroundColor: "transparent",
    // remove the gray background on active links in IE 10.
    outline: "none",
    cursor: "pointer",
    transition: `color ${token2.motionDurationSlow}`,
    "-webkit-text-decoration-skip": "objects",
    // remove gaps in links underline in iOS 8+ and Safari 8+.
    "&:hover": {
      color: token2.colorLinkHover
    },
    "&:active": {
      color: token2.colorLinkActive
    },
    "&:active, &:hover": {
      textDecoration: token2.linkHoverDecoration,
      outline: 0
    },
    // https://github.com/ant-design/ant-design/issues/22503
    "&:focus": {
      textDecoration: token2.linkFocusDecoration,
      outline: 0
    },
    "&[disabled]": {
      color: token2.colorTextDisabled,
      cursor: "not-allowed"
    }
  }
});
var genCommonStyle = (token2, componentPrefixCls, rootCls, resetFont) => {
  const prefixSelector = `[class^="${componentPrefixCls}"], [class*=" ${componentPrefixCls}"]`;
  const rootPrefixSelector = rootCls ? `.${rootCls}` : prefixSelector;
  const resetStyle = {
    boxSizing: "border-box",
    "&::before, &::after": {
      boxSizing: "border-box"
    }
  };
  let resetFontStyle = {};
  if (resetFont !== false) {
    resetFontStyle = {
      fontFamily: token2.fontFamily,
      fontSize: token2.fontSize
    };
  }
  return {
    [rootPrefixSelector]: Object.assign(Object.assign(Object.assign({}, resetFontStyle), resetStyle), {
      [prefixSelector]: resetStyle
    })
  };
};
var genFocusOutline = (token2, offset4) => ({
  outline: `${unit(token2.lineWidthFocus)} solid ${token2.colorPrimaryBorder}`,
  outlineOffset: offset4 !== null && offset4 !== void 0 ? offset4 : 1,
  transition: "outline-offset 0s, outline 0s"
});
var genFocusStyle = (token2, offset4) => ({
  "&:focus-visible": genFocusOutline(token2, offset4)
});
var genIconStyle = (iconPrefixCls) => ({
  [`.${iconPrefixCls}`]: Object.assign(Object.assign({}, resetIcon()), {
    [`.${iconPrefixCls} .${iconPrefixCls}-icon`]: {
      display: "block"
    }
  })
});
var operationUnit = (token2) => Object.assign(Object.assign({
  // FIXME: This use link but is a operation unit. Seems should be a colorPrimary.
  // And Typography use this to generate link style which should not do this.
  color: token2.colorLink,
  textDecoration: token2.linkDecoration,
  outline: "none",
  cursor: "pointer",
  transition: `all ${token2.motionDurationSlow}`,
  border: 0,
  padding: 0,
  background: "none",
  userSelect: "none"
}, genFocusStyle(token2)), {
  "&:hover": {
    color: token2.colorLinkHover,
    textDecoration: token2.linkHoverDecoration
  },
  "&:focus": {
    color: token2.colorLinkHover,
    textDecoration: token2.linkFocusDecoration
  },
  "&:active": {
    color: token2.colorLinkActive,
    textDecoration: token2.linkHoverDecoration
  }
});

// ../../node_modules/antd/es/theme/util/genStyleUtils.js
var {
  genStyleHooks,
  genComponentStyleHook,
  genSubStyleComponent
} = genStyleUtils_default({
  usePrefix: () => {
    const {
      getPrefixCls,
      iconPrefixCls
    } = (0, import_react19.useContext)(ConfigContext);
    const rootPrefixCls = getPrefixCls();
    return {
      rootPrefixCls,
      iconPrefixCls
    };
  },
  useToken: () => {
    const [theme, realToken, hashId, token2, cssVar] = useToken();
    return {
      theme,
      realToken,
      hashId,
      token: token2,
      cssVar
    };
  },
  useCSP: () => {
    const {
      csp
    } = (0, import_react19.useContext)(ConfigContext);
    return csp !== null && csp !== void 0 ? csp : {};
  },
  getResetStyles: (token2, config) => {
    var _a;
    const linkStyle = genLinkStyle(token2);
    return [linkStyle, {
      "&": linkStyle
    }, genIconStyle((_a = config === null || config === void 0 ? void 0 : config.prefix.iconPrefixCls) !== null && _a !== void 0 ? _a : defaultIconPrefixCls)];
  },
  getCommonStyle: genCommonStyle,
  getCompUnitless: () => unitless
});

// ../../node_modules/antd/es/theme/util/genPresetColor.js
function genPresetColor(token2, genCss) {
  return PresetColors.reduce((prev2, colorKey) => {
    const lightColor = token2[`${colorKey}1`];
    const lightBorderColor = token2[`${colorKey}3`];
    const darkColor = token2[`${colorKey}6`];
    const textColor = token2[`${colorKey}7`];
    return Object.assign(Object.assign({}, prev2), genCss(colorKey, {
      lightColor,
      lightBorderColor,
      darkColor,
      textColor
    }));
  }, {});
}

// ../../node_modules/antd/es/theme/util/useResetIconStyle.js
var useResetIconStyle = (iconPrefixCls, csp) => {
  const [theme, token2] = useToken();
  return useStyleRegister({
    theme,
    token: token2,
    hashId: "",
    path: ["ant-design-icons", iconPrefixCls],
    nonce: () => csp === null || csp === void 0 ? void 0 : csp.nonce,
    layer: {
      name: "antd"
    }
  }, () => genIconStyle(iconPrefixCls));
};
var useResetIconStyle_default = useResetIconStyle;

// ../../node_modules/antd/es/config-provider/hooks/useThemeKey.js
var React28 = __toESM(require_react());
var fullClone3 = Object.assign({}, React28);
var {
  useId
} = fullClone3;
var useEmptyId = () => "";
var useThemeKey = typeof useId === "undefined" ? useEmptyId : useId;
var useThemeKey_default = useThemeKey;

// ../../node_modules/antd/es/config-provider/hooks/useTheme.js
function useTheme(theme, parentTheme, config) {
  var _a, _b;
  const warning6 = devUseWarning("ConfigProvider");
  const themeConfig = theme || {};
  const parentThemeConfig = themeConfig.inherit === false || !parentTheme ? Object.assign(Object.assign({}, defaultConfig), {
    hashed: (_a = parentTheme === null || parentTheme === void 0 ? void 0 : parentTheme.hashed) !== null && _a !== void 0 ? _a : defaultConfig.hashed,
    cssVar: parentTheme === null || parentTheme === void 0 ? void 0 : parentTheme.cssVar
  }) : parentTheme;
  const themeKey = useThemeKey_default();
  if (true) {
    const cssVarEnabled = themeConfig.cssVar || parentThemeConfig.cssVar;
    const validKey = !!(typeof themeConfig.cssVar === "object" && ((_b = themeConfig.cssVar) === null || _b === void 0 ? void 0 : _b.key) || themeKey);
    true ? warning6(!cssVarEnabled || validKey, "breaking", "Missing key in `cssVar` config. Please upgrade to React 18 or set `cssVar.key` manually in each ConfigProvider inside `cssVar` enabled ConfigProvider.") : void 0;
  }
  return useMemo3(() => {
    var _a2, _b2;
    if (!theme) {
      return parentTheme;
    }
    const mergedComponents = Object.assign({}, parentThemeConfig.components);
    Object.keys(theme.components || {}).forEach((componentName) => {
      mergedComponents[componentName] = Object.assign(Object.assign({}, mergedComponents[componentName]), theme.components[componentName]);
    });
    const cssVarKey = `css-var-${themeKey.replace(/:/g, "")}`;
    const mergedCssVar = ((_a2 = themeConfig.cssVar) !== null && _a2 !== void 0 ? _a2 : parentThemeConfig.cssVar) && Object.assign(Object.assign(Object.assign({
      prefix: config === null || config === void 0 ? void 0 : config.prefixCls
    }, typeof parentThemeConfig.cssVar === "object" ? parentThemeConfig.cssVar : {}), typeof themeConfig.cssVar === "object" ? themeConfig.cssVar : {}), {
      key: typeof themeConfig.cssVar === "object" && ((_b2 = themeConfig.cssVar) === null || _b2 === void 0 ? void 0 : _b2.key) || cssVarKey
    });
    return Object.assign(Object.assign(Object.assign({}, parentThemeConfig), themeConfig), {
      token: Object.assign(Object.assign({}, parentThemeConfig.token), themeConfig.token),
      components: mergedComponents,
      cssVar: mergedCssVar
    });
  }, [themeConfig, parentThemeConfig], (prev2, next2) => prev2.some((prevTheme, index3) => {
    const nextTheme = next2[index3];
    return !isEqual_default(prevTheme, nextTheme, true);
  }));
}

// ../../node_modules/antd/es/config-provider/MotionWrapper.js
var React38 = __toESM(require_react());

// ../../node_modules/rc-motion/es/CSSMotion.js
var import_classnames = __toESM(require_classnames());
var React36 = __toESM(require_react());
var import_react23 = __toESM(require_react());

// ../../node_modules/rc-motion/es/context.js
var React29 = __toESM(require_react());
var _excluded = ["children"];
var Context = /* @__PURE__ */ React29.createContext({});
function MotionProvider(_ref) {
  var children = _ref.children, props = _objectWithoutProperties(_ref, _excluded);
  return /* @__PURE__ */ React29.createElement(Context.Provider, {
    value: props
  }, children);
}

// ../../node_modules/rc-motion/es/DomWrapper.js
var React30 = __toESM(require_react());
var DomWrapper2 = /* @__PURE__ */ (function(_React$Component) {
  _inherits(DomWrapper3, _React$Component);
  var _super = _createSuper(DomWrapper3);
  function DomWrapper3() {
    _classCallCheck(this, DomWrapper3);
    return _super.apply(this, arguments);
  }
  _createClass(DomWrapper3, [{
    key: "render",
    value: function render4() {
      return this.props.children;
    }
  }]);
  return DomWrapper3;
})(React30.Component);
var DomWrapper_default = DomWrapper2;

// ../../node_modules/rc-util/es/hooks/useSyncState.js
var React31 = __toESM(require_react());
function useSyncState(defaultValue2) {
  var _React$useReducer = React31.useReducer(function(x) {
    return x + 1;
  }, 0), _React$useReducer2 = _slicedToArray(_React$useReducer, 2), forceUpdate = _React$useReducer2[1];
  var currentValueRef = React31.useRef(defaultValue2);
  var getValue4 = useEvent2(function() {
    return currentValueRef.current;
  });
  var setValue = useEvent2(function(updater) {
    currentValueRef.current = typeof updater === "function" ? updater(currentValueRef.current) : updater;
    forceUpdate();
  });
  return [getValue4, setValue];
}

// ../../node_modules/rc-motion/es/hooks/useStatus.js
var React35 = __toESM(require_react());
var import_react22 = __toESM(require_react());

// ../../node_modules/rc-motion/es/interface.js
var STATUS_NONE = "none";
var STATUS_APPEAR = "appear";
var STATUS_ENTER = "enter";
var STATUS_LEAVE = "leave";
var STEP_NONE = "none";
var STEP_PREPARE = "prepare";
var STEP_START = "start";
var STEP_ACTIVE = "active";
var STEP_ACTIVATED = "end";
var STEP_PREPARED = "prepared";

// ../../node_modules/rc-motion/es/hooks/useDomMotionEvents.js
var React32 = __toESM(require_react());
var import_react20 = __toESM(require_react());

// ../../node_modules/rc-motion/es/util/motion.js
function makePrefixMap(styleProp, eventName) {
  var prefixes = {};
  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
  prefixes["Webkit".concat(styleProp)] = "webkit".concat(eventName);
  prefixes["Moz".concat(styleProp)] = "moz".concat(eventName);
  prefixes["ms".concat(styleProp)] = "MS".concat(eventName);
  prefixes["O".concat(styleProp)] = "o".concat(eventName.toLowerCase());
  return prefixes;
}
function getVendorPrefixes(domSupport, win) {
  var prefixes = {
    animationend: makePrefixMap("Animation", "AnimationEnd"),
    transitionend: makePrefixMap("Transition", "TransitionEnd")
  };
  if (domSupport) {
    if (!("AnimationEvent" in win)) {
      delete prefixes.animationend.animation;
    }
    if (!("TransitionEvent" in win)) {
      delete prefixes.transitionend.transition;
    }
  }
  return prefixes;
}
var vendorPrefixes = getVendorPrefixes(canUseDom(), typeof window !== "undefined" ? window : {});
var style = {};
if (canUseDom()) {
  _document$createEleme = document.createElement("div");
  style = _document$createEleme.style;
}
var _document$createEleme;
var prefixedEventNames = {};
function getVendorPrefixedEventName(eventName) {
  if (prefixedEventNames[eventName]) {
    return prefixedEventNames[eventName];
  }
  var prefixMap = vendorPrefixes[eventName];
  if (prefixMap) {
    var stylePropList = Object.keys(prefixMap);
    var len = stylePropList.length;
    for (var i = 0; i < len; i += 1) {
      var styleProp = stylePropList[i];
      if (Object.prototype.hasOwnProperty.call(prefixMap, styleProp) && styleProp in style) {
        prefixedEventNames[eventName] = prefixMap[styleProp];
        return prefixedEventNames[eventName];
      }
    }
  }
  return "";
}
var internalAnimationEndName = getVendorPrefixedEventName("animationend");
var internalTransitionEndName = getVendorPrefixedEventName("transitionend");
var supportTransition = !!(internalAnimationEndName && internalTransitionEndName);
var animationEndName = internalAnimationEndName || "animationend";
var transitionEndName = internalTransitionEndName || "transitionend";
function getTransitionName(transitionName, transitionType) {
  if (!transitionName) return null;
  if (_typeof(transitionName) === "object") {
    var type5 = transitionType.replace(/-\w/g, function(match2) {
      return match2[1].toUpperCase();
    });
    return transitionName[type5];
  }
  return "".concat(transitionName, "-").concat(transitionType);
}

// ../../node_modules/rc-motion/es/hooks/useDomMotionEvents.js
var useDomMotionEvents_default = (function(onInternalMotionEnd) {
  var cacheElementRef = (0, import_react20.useRef)();
  function removeMotionEvents(element) {
    if (element) {
      element.removeEventListener(transitionEndName, onInternalMotionEnd);
      element.removeEventListener(animationEndName, onInternalMotionEnd);
    }
  }
  function patchMotionEvents(element) {
    if (cacheElementRef.current && cacheElementRef.current !== element) {
      removeMotionEvents(cacheElementRef.current);
    }
    if (element && element !== cacheElementRef.current) {
      element.addEventListener(transitionEndName, onInternalMotionEnd);
      element.addEventListener(animationEndName, onInternalMotionEnd);
      cacheElementRef.current = element;
    }
  }
  React32.useEffect(function() {
    return function() {
      removeMotionEvents(cacheElementRef.current);
    };
  }, []);
  return [patchMotionEvents, removeMotionEvents];
});

// ../../node_modules/rc-motion/es/hooks/useIsomorphicLayoutEffect.js
var import_react21 = __toESM(require_react());
var useIsomorphicLayoutEffect2 = canUseDom() ? import_react21.useLayoutEffect : import_react21.useEffect;
var useIsomorphicLayoutEffect_default = useIsomorphicLayoutEffect2;

// ../../node_modules/rc-motion/es/hooks/useStepQueue.js
var React34 = __toESM(require_react());

// ../../node_modules/rc-motion/es/hooks/useNextFrame.js
var React33 = __toESM(require_react());
var useNextFrame_default = (function() {
  var nextFrameRef = React33.useRef(null);
  function cancelNextFrame() {
    raf_default.cancel(nextFrameRef.current);
  }
  function nextFrame(callback) {
    var delay = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    cancelNextFrame();
    var nextFrameId = raf_default(function() {
      if (delay <= 1) {
        callback({
          isCanceled: function isCanceled() {
            return nextFrameId !== nextFrameRef.current;
          }
        });
      } else {
        nextFrame(callback, delay - 1);
      }
    });
    nextFrameRef.current = nextFrameId;
  }
  React33.useEffect(function() {
    return function() {
      cancelNextFrame();
    };
  }, []);
  return [nextFrame, cancelNextFrame];
});

// ../../node_modules/rc-motion/es/hooks/useStepQueue.js
var FULL_STEP_QUEUE = [STEP_PREPARE, STEP_START, STEP_ACTIVE, STEP_ACTIVATED];
var SIMPLE_STEP_QUEUE = [STEP_PREPARE, STEP_PREPARED];
var SkipStep = false;
var DoStep = true;
function isActive(step) {
  return step === STEP_ACTIVE || step === STEP_ACTIVATED;
}
var useStepQueue_default = (function(status, prepareOnly, callback) {
  var _useState = useSafeState(STEP_NONE), _useState2 = _slicedToArray(_useState, 2), step = _useState2[0], setStep = _useState2[1];
  var _useNextFrame = useNextFrame_default(), _useNextFrame2 = _slicedToArray(_useNextFrame, 2), nextFrame = _useNextFrame2[0], cancelNextFrame = _useNextFrame2[1];
  function startQueue() {
    setStep(STEP_PREPARE, true);
  }
  var STEP_QUEUE = prepareOnly ? SIMPLE_STEP_QUEUE : FULL_STEP_QUEUE;
  useIsomorphicLayoutEffect_default(function() {
    if (step !== STEP_NONE && step !== STEP_ACTIVATED) {
      var index3 = STEP_QUEUE.indexOf(step);
      var nextStep = STEP_QUEUE[index3 + 1];
      var result = callback(step);
      if (result === SkipStep) {
        setStep(nextStep, true);
      } else if (nextStep) {
        nextFrame(function(info) {
          function doNext() {
            if (info.isCanceled()) return;
            setStep(nextStep, true);
          }
          if (result === true) {
            doNext();
          } else {
            Promise.resolve(result).then(doNext);
          }
        });
      }
    }
  }, [status, step]);
  React34.useEffect(function() {
    return function() {
      cancelNextFrame();
    };
  }, []);
  return [startQueue, step];
});

// ../../node_modules/rc-motion/es/hooks/useStatus.js
function useStatus(supportMotion, visible, getElement, _ref) {
  var _ref$motionEnter = _ref.motionEnter, motionEnter = _ref$motionEnter === void 0 ? true : _ref$motionEnter, _ref$motionAppear = _ref.motionAppear, motionAppear = _ref$motionAppear === void 0 ? true : _ref$motionAppear, _ref$motionLeave = _ref.motionLeave, motionLeave = _ref$motionLeave === void 0 ? true : _ref$motionLeave, motionDeadline = _ref.motionDeadline, motionLeaveImmediately = _ref.motionLeaveImmediately, onAppearPrepare = _ref.onAppearPrepare, onEnterPrepare = _ref.onEnterPrepare, onLeavePrepare = _ref.onLeavePrepare, onAppearStart = _ref.onAppearStart, onEnterStart = _ref.onEnterStart, onLeaveStart = _ref.onLeaveStart, onAppearActive = _ref.onAppearActive, onEnterActive = _ref.onEnterActive, onLeaveActive = _ref.onLeaveActive, onAppearEnd = _ref.onAppearEnd, onEnterEnd = _ref.onEnterEnd, onLeaveEnd = _ref.onLeaveEnd, onVisibleChanged = _ref.onVisibleChanged;
  var _useState = useSafeState(), _useState2 = _slicedToArray(_useState, 2), asyncVisible = _useState2[0], setAsyncVisible = _useState2[1];
  var _useSyncState = useSyncState(STATUS_NONE), _useSyncState2 = _slicedToArray(_useSyncState, 2), getStatus2 = _useSyncState2[0], setStatus = _useSyncState2[1];
  var _useState3 = useSafeState(null), _useState4 = _slicedToArray(_useState3, 2), style2 = _useState4[0], setStyle = _useState4[1];
  var currentStatus = getStatus2();
  var mountedRef = (0, import_react22.useRef)(false);
  var deadlineRef = (0, import_react22.useRef)(null);
  function getDomElement() {
    return getElement();
  }
  var activeRef = (0, import_react22.useRef)(false);
  function updateMotionEndStatus() {
    setStatus(STATUS_NONE);
    setStyle(null, true);
  }
  var onInternalMotionEnd = useEvent2(function(event) {
    var status = getStatus2();
    if (status === STATUS_NONE) {
      return;
    }
    var element = getDomElement();
    if (event && !event.deadline && event.target !== element) {
      return;
    }
    var currentActive = activeRef.current;
    var canEnd;
    if (status === STATUS_APPEAR && currentActive) {
      canEnd = onAppearEnd === null || onAppearEnd === void 0 ? void 0 : onAppearEnd(element, event);
    } else if (status === STATUS_ENTER && currentActive) {
      canEnd = onEnterEnd === null || onEnterEnd === void 0 ? void 0 : onEnterEnd(element, event);
    } else if (status === STATUS_LEAVE && currentActive) {
      canEnd = onLeaveEnd === null || onLeaveEnd === void 0 ? void 0 : onLeaveEnd(element, event);
    }
    if (currentActive && canEnd !== false) {
      updateMotionEndStatus();
    }
  });
  var _useDomMotionEvents = useDomMotionEvents_default(onInternalMotionEnd), _useDomMotionEvents2 = _slicedToArray(_useDomMotionEvents, 1), patchMotionEvents = _useDomMotionEvents2[0];
  var getEventHandlers = function getEventHandlers2(targetStatus) {
    switch (targetStatus) {
      case STATUS_APPEAR:
        return _defineProperty(_defineProperty(_defineProperty({}, STEP_PREPARE, onAppearPrepare), STEP_START, onAppearStart), STEP_ACTIVE, onAppearActive);
      case STATUS_ENTER:
        return _defineProperty(_defineProperty(_defineProperty({}, STEP_PREPARE, onEnterPrepare), STEP_START, onEnterStart), STEP_ACTIVE, onEnterActive);
      case STATUS_LEAVE:
        return _defineProperty(_defineProperty(_defineProperty({}, STEP_PREPARE, onLeavePrepare), STEP_START, onLeaveStart), STEP_ACTIVE, onLeaveActive);
      default:
        return {};
    }
  };
  var eventHandlers = React35.useMemo(function() {
    return getEventHandlers(currentStatus);
  }, [currentStatus]);
  var _useStepQueue = useStepQueue_default(currentStatus, !supportMotion, function(newStep) {
    if (newStep === STEP_PREPARE) {
      var onPrepare = eventHandlers[STEP_PREPARE];
      if (!onPrepare) {
        return SkipStep;
      }
      return onPrepare(getDomElement());
    }
    if (step in eventHandlers) {
      var _eventHandlers$step;
      setStyle(((_eventHandlers$step = eventHandlers[step]) === null || _eventHandlers$step === void 0 ? void 0 : _eventHandlers$step.call(eventHandlers, getDomElement(), null)) || null);
    }
    if (step === STEP_ACTIVE && currentStatus !== STATUS_NONE) {
      patchMotionEvents(getDomElement());
      if (motionDeadline > 0) {
        clearTimeout(deadlineRef.current);
        deadlineRef.current = setTimeout(function() {
          onInternalMotionEnd({
            deadline: true
          });
        }, motionDeadline);
      }
    }
    if (step === STEP_PREPARED) {
      updateMotionEndStatus();
    }
    return DoStep;
  }), _useStepQueue2 = _slicedToArray(_useStepQueue, 2), startStep = _useStepQueue2[0], step = _useStepQueue2[1];
  var active = isActive(step);
  activeRef.current = active;
  var visibleRef = (0, import_react22.useRef)(null);
  useIsomorphicLayoutEffect_default(function() {
    if (mountedRef.current && visibleRef.current === visible) {
      return;
    }
    setAsyncVisible(visible);
    var isMounted = mountedRef.current;
    mountedRef.current = true;
    var nextStatus;
    if (!isMounted && visible && motionAppear) {
      nextStatus = STATUS_APPEAR;
    }
    if (isMounted && visible && motionEnter) {
      nextStatus = STATUS_ENTER;
    }
    if (isMounted && !visible && motionLeave || !isMounted && motionLeaveImmediately && !visible && motionLeave) {
      nextStatus = STATUS_LEAVE;
    }
    var nextEventHandlers = getEventHandlers(nextStatus);
    if (nextStatus && (supportMotion || nextEventHandlers[STEP_PREPARE])) {
      setStatus(nextStatus);
      startStep();
    } else {
      setStatus(STATUS_NONE);
    }
    visibleRef.current = visible;
  }, [visible]);
  (0, import_react22.useEffect)(function() {
    if (
      // Cancel appear
      currentStatus === STATUS_APPEAR && !motionAppear || // Cancel enter
      currentStatus === STATUS_ENTER && !motionEnter || // Cancel leave
      currentStatus === STATUS_LEAVE && !motionLeave
    ) {
      setStatus(STATUS_NONE);
    }
  }, [motionAppear, motionEnter, motionLeave]);
  (0, import_react22.useEffect)(function() {
    return function() {
      mountedRef.current = false;
      clearTimeout(deadlineRef.current);
    };
  }, []);
  var firstMountChangeRef = React35.useRef(false);
  (0, import_react22.useEffect)(function() {
    if (asyncVisible) {
      firstMountChangeRef.current = true;
    }
    if (asyncVisible !== void 0 && currentStatus === STATUS_NONE) {
      if (firstMountChangeRef.current || asyncVisible) {
        onVisibleChanged === null || onVisibleChanged === void 0 || onVisibleChanged(asyncVisible);
      }
      firstMountChangeRef.current = true;
    }
  }, [asyncVisible, currentStatus]);
  var mergedStyle = style2;
  if (eventHandlers[STEP_PREPARE] && step === STEP_START) {
    mergedStyle = _objectSpread2({
      transition: "none"
    }, mergedStyle);
  }
  return [currentStatus, step, mergedStyle, asyncVisible !== null && asyncVisible !== void 0 ? asyncVisible : visible];
}

// ../../node_modules/rc-motion/es/CSSMotion.js
function genCSSMotion(config) {
  var transitionSupport = config;
  if (_typeof(config) === "object") {
    transitionSupport = config.transitionSupport;
  }
  function isSupportTransition(props, contextMotion) {
    return !!(props.motionName && transitionSupport && contextMotion !== false);
  }
  var CSSMotion = /* @__PURE__ */ React36.forwardRef(function(props, ref3) {
    var _props$visible = props.visible, visible = _props$visible === void 0 ? true : _props$visible, _props$removeOnLeave = props.removeOnLeave, removeOnLeave = _props$removeOnLeave === void 0 ? true : _props$removeOnLeave, forceRender = props.forceRender, children = props.children, motionName = props.motionName, leavedClassName = props.leavedClassName, eventProps = props.eventProps;
    var _React$useContext = React36.useContext(Context), contextMotion = _React$useContext.motion;
    var supportMotion = isSupportTransition(props, contextMotion);
    var nodeRef = (0, import_react23.useRef)();
    var wrapperNodeRef = (0, import_react23.useRef)();
    function getDomElement() {
      try {
        return nodeRef.current instanceof HTMLElement ? nodeRef.current : findDOMNode(wrapperNodeRef.current);
      } catch (e3) {
        return null;
      }
    }
    var _useStatus = useStatus(supportMotion, visible, getDomElement, props), _useStatus2 = _slicedToArray(_useStatus, 4), status = _useStatus2[0], statusStep = _useStatus2[1], statusStyle = _useStatus2[2], mergedVisible = _useStatus2[3];
    var renderedRef = React36.useRef(mergedVisible);
    if (mergedVisible) {
      renderedRef.current = true;
    }
    var setNodeRef = React36.useCallback(function(node2) {
      nodeRef.current = node2;
      fillRef(ref3, node2);
    }, [ref3]);
    var motionChildren;
    var mergedProps = _objectSpread2(_objectSpread2({}, eventProps), {}, {
      visible
    });
    if (!children) {
      motionChildren = null;
    } else if (status === STATUS_NONE) {
      if (mergedVisible) {
        motionChildren = children(_objectSpread2({}, mergedProps), setNodeRef);
      } else if (!removeOnLeave && renderedRef.current && leavedClassName) {
        motionChildren = children(_objectSpread2(_objectSpread2({}, mergedProps), {}, {
          className: leavedClassName
        }), setNodeRef);
      } else if (forceRender || !removeOnLeave && !leavedClassName) {
        motionChildren = children(_objectSpread2(_objectSpread2({}, mergedProps), {}, {
          style: {
            display: "none"
          }
        }), setNodeRef);
      } else {
        motionChildren = null;
      }
    } else {
      var statusSuffix;
      if (statusStep === STEP_PREPARE) {
        statusSuffix = "prepare";
      } else if (isActive(statusStep)) {
        statusSuffix = "active";
      } else if (statusStep === STEP_START) {
        statusSuffix = "start";
      }
      var motionCls = getTransitionName(motionName, "".concat(status, "-").concat(statusSuffix));
      motionChildren = children(_objectSpread2(_objectSpread2({}, mergedProps), {}, {
        className: (0, import_classnames.default)(getTransitionName(motionName, status), _defineProperty(_defineProperty({}, motionCls, motionCls && statusSuffix), motionName, typeof motionName === "string")),
        style: statusStyle
      }), setNodeRef);
    }
    if (/* @__PURE__ */ React36.isValidElement(motionChildren) && supportRef(motionChildren)) {
      var originNodeRef = getNodeRef(motionChildren);
      if (!originNodeRef) {
        motionChildren = /* @__PURE__ */ React36.cloneElement(motionChildren, {
          ref: setNodeRef
        });
      }
    }
    return /* @__PURE__ */ React36.createElement(DomWrapper_default, {
      ref: wrapperNodeRef
    }, motionChildren);
  });
  CSSMotion.displayName = "CSSMotion";
  return CSSMotion;
}
var CSSMotion_default = genCSSMotion(supportTransition);

// ../../node_modules/rc-motion/es/CSSMotionList.js
var React37 = __toESM(require_react());

// ../../node_modules/rc-motion/es/util/diff.js
var STATUS_ADD = "add";
var STATUS_KEEP = "keep";
var STATUS_REMOVE = "remove";
var STATUS_REMOVED = "removed";
function wrapKeyToObject(key2) {
  var keyObj;
  if (key2 && _typeof(key2) === "object" && "key" in key2) {
    keyObj = key2;
  } else {
    keyObj = {
      key: key2
    };
  }
  return _objectSpread2(_objectSpread2({}, keyObj), {}, {
    key: String(keyObj.key)
  });
}
function parseKeys() {
  var keys4 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  return keys4.map(wrapKeyToObject);
}
function diffKeys() {
  var prevKeys = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  var currentKeys = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  var list = [];
  var currentIndex = 0;
  var currentLen = currentKeys.length;
  var prevKeyObjects = parseKeys(prevKeys);
  var currentKeyObjects = parseKeys(currentKeys);
  prevKeyObjects.forEach(function(keyObj) {
    var hit = false;
    for (var i = currentIndex; i < currentLen; i += 1) {
      var currentKeyObj = currentKeyObjects[i];
      if (currentKeyObj.key === keyObj.key) {
        if (currentIndex < i) {
          list = list.concat(currentKeyObjects.slice(currentIndex, i).map(function(obj) {
            return _objectSpread2(_objectSpread2({}, obj), {}, {
              status: STATUS_ADD
            });
          }));
          currentIndex = i;
        }
        list.push(_objectSpread2(_objectSpread2({}, currentKeyObj), {}, {
          status: STATUS_KEEP
        }));
        currentIndex += 1;
        hit = true;
        break;
      }
    }
    if (!hit) {
      list.push(_objectSpread2(_objectSpread2({}, keyObj), {}, {
        status: STATUS_REMOVE
      }));
    }
  });
  if (currentIndex < currentLen) {
    list = list.concat(currentKeyObjects.slice(currentIndex).map(function(obj) {
      return _objectSpread2(_objectSpread2({}, obj), {}, {
        status: STATUS_ADD
      });
    }));
  }
  var keys4 = {};
  list.forEach(function(_ref) {
    var key2 = _ref.key;
    keys4[key2] = (keys4[key2] || 0) + 1;
  });
  var duplicatedKeys = Object.keys(keys4).filter(function(key2) {
    return keys4[key2] > 1;
  });
  duplicatedKeys.forEach(function(matchKey) {
    list = list.filter(function(_ref2) {
      var key2 = _ref2.key, status = _ref2.status;
      return key2 !== matchKey || status !== STATUS_REMOVE;
    });
    list.forEach(function(node2) {
      if (node2.key === matchKey) {
        node2.status = STATUS_KEEP;
      }
    });
  });
  return list;
}

// ../../node_modules/rc-motion/es/CSSMotionList.js
var _excluded2 = ["component", "children", "onVisibleChanged", "onAllRemoved"];
var _excluded22 = ["status"];
var MOTION_PROP_NAMES = ["eventProps", "visible", "children", "motionName", "motionAppear", "motionEnter", "motionLeave", "motionLeaveImmediately", "motionDeadline", "removeOnLeave", "leavedClassName", "onAppearPrepare", "onAppearStart", "onAppearActive", "onAppearEnd", "onEnterStart", "onEnterActive", "onEnterEnd", "onLeaveStart", "onLeaveActive", "onLeaveEnd"];
function genCSSMotionList(transitionSupport) {
  var CSSMotion = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : CSSMotion_default;
  var CSSMotionList = /* @__PURE__ */ (function(_React$Component) {
    _inherits(CSSMotionList2, _React$Component);
    var _super = _createSuper(CSSMotionList2);
    function CSSMotionList2() {
      var _this;
      _classCallCheck(this, CSSMotionList2);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _defineProperty(_assertThisInitialized(_this), "state", {
        keyEntities: []
      });
      _defineProperty(_assertThisInitialized(_this), "removeKey", function(removeKey) {
        _this.setState(function(prevState) {
          var nextKeyEntities = prevState.keyEntities.map(function(entity) {
            if (entity.key !== removeKey) return entity;
            return _objectSpread2(_objectSpread2({}, entity), {}, {
              status: STATUS_REMOVED
            });
          });
          return {
            keyEntities: nextKeyEntities
          };
        }, function() {
          var keyEntities = _this.state.keyEntities;
          var restKeysCount = keyEntities.filter(function(_ref) {
            var status = _ref.status;
            return status !== STATUS_REMOVED;
          }).length;
          if (restKeysCount === 0 && _this.props.onAllRemoved) {
            _this.props.onAllRemoved();
          }
        });
      });
      return _this;
    }
    _createClass(CSSMotionList2, [{
      key: "render",
      value: function render4() {
        var _this2 = this;
        var keyEntities = this.state.keyEntities;
        var _this$props = this.props, component = _this$props.component, children = _this$props.children, _onVisibleChanged = _this$props.onVisibleChanged, onAllRemoved = _this$props.onAllRemoved, restProps = _objectWithoutProperties(_this$props, _excluded2);
        var Component10 = component || React37.Fragment;
        var motionProps = {};
        MOTION_PROP_NAMES.forEach(function(prop) {
          motionProps[prop] = restProps[prop];
          delete restProps[prop];
        });
        delete restProps.keys;
        return /* @__PURE__ */ React37.createElement(Component10, restProps, keyEntities.map(function(_ref2, index3) {
          var status = _ref2.status, eventProps = _objectWithoutProperties(_ref2, _excluded22);
          var visible = status === STATUS_ADD || status === STATUS_KEEP;
          return /* @__PURE__ */ React37.createElement(CSSMotion, _extends({}, motionProps, {
            key: eventProps.key,
            visible,
            eventProps,
            onVisibleChanged: function onVisibleChanged(changedVisible) {
              _onVisibleChanged === null || _onVisibleChanged === void 0 || _onVisibleChanged(changedVisible, {
                key: eventProps.key
              });
              if (!changedVisible) {
                _this2.removeKey(eventProps.key);
              }
            }
          }), function(props, ref3) {
            return children(_objectSpread2(_objectSpread2({}, props), {}, {
              index: index3
            }), ref3);
          });
        }));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function getDerivedStateFromProps(_ref3, _ref4) {
        var keys4 = _ref3.keys;
        var keyEntities = _ref4.keyEntities;
        var parsedKeyObjects = parseKeys(keys4);
        var mixedKeyEntities = diffKeys(keyEntities, parsedKeyObjects);
        return {
          keyEntities: mixedKeyEntities.filter(function(entity) {
            var prevEntity = keyEntities.find(function(_ref5) {
              var key2 = _ref5.key;
              return entity.key === key2;
            });
            if (prevEntity && prevEntity.status === STATUS_REMOVED && entity.status === STATUS_REMOVE) {
              return false;
            }
            return true;
          })
        };
      }
    }]);
    return CSSMotionList2;
  })(React37.Component);
  _defineProperty(CSSMotionList, "defaultProps", {
    component: "div"
  });
  return CSSMotionList;
}
var CSSMotionList_default = genCSSMotionList(supportTransition);

// ../../node_modules/rc-motion/es/index.js
var es_default2 = CSSMotion_default;

// ../../node_modules/antd/es/config-provider/MotionWrapper.js
var MotionCacheContext = /* @__PURE__ */ React38.createContext(true);
if (true) {
  MotionCacheContext.displayName = "MotionCacheContext";
}
function MotionWrapper(props) {
  const parentMotion = React38.useContext(MotionCacheContext);
  const {
    children
  } = props;
  const [, token2] = useToken();
  const {
    motion: motion2
  } = token2;
  const needWrapMotionProviderRef = React38.useRef(false);
  needWrapMotionProviderRef.current || (needWrapMotionProviderRef.current = parentMotion !== motion2);
  if (needWrapMotionProviderRef.current) {
    return /* @__PURE__ */ React38.createElement(MotionCacheContext.Provider, {
      value: motion2
    }, /* @__PURE__ */ React38.createElement(MotionProvider, {
      motion: motion2
    }, children));
  }
  return children;
}

// ../../node_modules/antd/es/config-provider/PropWarning.js
var React39 = __toESM(require_react());
var PropWarning = /* @__PURE__ */ React39.memo(({
  dropdownMatchSelectWidth
}) => {
  const warning6 = devUseWarning("ConfigProvider");
  warning6.deprecated(dropdownMatchSelectWidth === void 0, "dropdownMatchSelectWidth", "popupMatchSelectWidth");
  return null;
});
if (true) {
  PropWarning.displayName = "PropWarning";
}
var PropWarning_default = true ? PropWarning : () => null;

// ../../node_modules/antd/es/config-provider/index.js
var __rest4 = function(s, e3) {
  var t2 = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e3.indexOf(p) < 0) t2[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e3.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t2[p[i]] = s[p[i]];
  }
  return t2;
};
var existThemeConfig = false;
var warnContext = true ? (componentName) => {
  true ? warning_default2(!existThemeConfig, componentName, `Static function can not consume context like dynamic theme. Please use 'App' component instead.`) : void 0;
} : (
  /* istanbul ignore next */
  null
);
var PASSED_PROPS = ["getTargetContainer", "getPopupContainer", "renderEmpty", "input", "pagination", "form", "select", "button"];
var globalPrefixCls;
var globalIconPrefixCls;
var globalTheme;
var globalHolderRender;
function getGlobalPrefixCls() {
  return globalPrefixCls || defaultPrefixCls;
}
function getGlobalIconPrefixCls() {
  return globalIconPrefixCls || defaultIconPrefixCls;
}
function isLegacyTheme(theme) {
  return Object.keys(theme).some((key2) => key2.endsWith("Color"));
}
var setGlobalConfig = (props) => {
  const {
    prefixCls,
    iconPrefixCls,
    theme,
    holderRender
  } = props;
  if (prefixCls !== void 0) {
    globalPrefixCls = prefixCls;
  }
  if (iconPrefixCls !== void 0) {
    globalIconPrefixCls = iconPrefixCls;
  }
  if ("holderRender" in props) {
    globalHolderRender = holderRender;
  }
  if (theme) {
    if (isLegacyTheme(theme)) {
      true ? warning_default2(false, "ConfigProvider", "`config` of css variable theme is not work in v5. Please use new `theme` config instead.") : void 0;
      registerTheme(getGlobalPrefixCls(), theme);
    } else {
      globalTheme = theme;
    }
  }
};
var globalConfig = () => ({
  getPrefixCls: (suffixCls, customizePrefixCls) => {
    if (customizePrefixCls) {
      return customizePrefixCls;
    }
    return suffixCls ? `${getGlobalPrefixCls()}-${suffixCls}` : getGlobalPrefixCls();
  },
  getIconPrefixCls: getGlobalIconPrefixCls,
  getRootPrefixCls: () => {
    if (globalPrefixCls) {
      return globalPrefixCls;
    }
    return getGlobalPrefixCls();
  },
  getTheme: () => globalTheme,
  holderRender: globalHolderRender
});
var ProviderChildren = (props) => {
  const {
    children,
    csp: customCsp,
    autoInsertSpaceInButton,
    alert: alert2,
    anchor,
    form,
    locale: locale6,
    componentSize,
    direction,
    space,
    splitter,
    virtual,
    dropdownMatchSelectWidth,
    popupMatchSelectWidth,
    popupOverflow,
    legacyLocale,
    parentContext,
    iconPrefixCls: customIconPrefixCls,
    theme,
    componentDisabled,
    segmented,
    statistic: statistic2,
    spin,
    calendar,
    carousel,
    cascader,
    collapse,
    typography,
    checkbox,
    descriptions,
    divider,
    drawer,
    skeleton,
    steps,
    image,
    layout,
    list,
    mentions,
    modal,
    progress,
    result,
    slider,
    breadcrumb,
    menu,
    pagination,
    input,
    textArea,
    empty: empty3,
    badge,
    radio,
    rate,
    switch: SWITCH,
    transfer,
    avatar,
    message: message2,
    tag,
    table,
    card,
    tabs,
    timeline,
    timePicker,
    upload: upload2,
    notification,
    tree,
    colorPicker,
    datePicker,
    rangePicker,
    flex,
    wave,
    dropdown,
    warning: warningConfig,
    tour,
    tooltip,
    popover,
    popconfirm,
    floatButton,
    floatButtonGroup,
    variant,
    inputNumber,
    treeSelect
  } = props;
  const getPrefixCls = React40.useCallback((suffixCls, customizePrefixCls) => {
    const {
      prefixCls
    } = props;
    if (customizePrefixCls) {
      return customizePrefixCls;
    }
    const mergedPrefixCls = prefixCls || parentContext.getPrefixCls("");
    return suffixCls ? `${mergedPrefixCls}-${suffixCls}` : mergedPrefixCls;
  }, [parentContext.getPrefixCls, props.prefixCls]);
  const iconPrefixCls = customIconPrefixCls || parentContext.iconPrefixCls || defaultIconPrefixCls;
  const csp = customCsp || parentContext.csp;
  useResetIconStyle_default(iconPrefixCls, csp);
  const mergedTheme = useTheme(theme, parentContext.theme, {
    prefixCls: getPrefixCls("")
  });
  if (true) {
    existThemeConfig = existThemeConfig || !!mergedTheme;
  }
  const baseConfig = {
    csp,
    autoInsertSpaceInButton,
    alert: alert2,
    anchor,
    locale: locale6 || legacyLocale,
    direction,
    space,
    splitter,
    virtual,
    popupMatchSelectWidth: popupMatchSelectWidth !== null && popupMatchSelectWidth !== void 0 ? popupMatchSelectWidth : dropdownMatchSelectWidth,
    popupOverflow,
    getPrefixCls,
    iconPrefixCls,
    theme: mergedTheme,
    segmented,
    statistic: statistic2,
    spin,
    calendar,
    carousel,
    cascader,
    collapse,
    typography,
    checkbox,
    descriptions,
    divider,
    drawer,
    skeleton,
    steps,
    image,
    input,
    textArea,
    layout,
    list,
    mentions,
    modal,
    progress,
    result,
    slider,
    breadcrumb,
    menu,
    pagination,
    empty: empty3,
    badge,
    radio,
    rate,
    switch: SWITCH,
    transfer,
    avatar,
    message: message2,
    tag,
    table,
    card,
    tabs,
    timeline,
    timePicker,
    upload: upload2,
    notification,
    tree,
    colorPicker,
    datePicker,
    rangePicker,
    flex,
    wave,
    dropdown,
    warning: warningConfig,
    tour,
    tooltip,
    popover,
    popconfirm,
    floatButton,
    floatButtonGroup,
    variant,
    inputNumber,
    treeSelect
  };
  if (true) {
    const warningFn = devUseWarning("ConfigProvider");
    warningFn(!("autoInsertSpaceInButton" in props), "deprecated", "`autoInsertSpaceInButton` is deprecated. Please use `{ button: { autoInsertSpace: boolean }}` instead.");
  }
  const config = Object.assign({}, parentContext);
  Object.keys(baseConfig).forEach((key2) => {
    if (baseConfig[key2] !== void 0) {
      config[key2] = baseConfig[key2];
    }
  });
  PASSED_PROPS.forEach((propName) => {
    const propValue = props[propName];
    if (propValue) {
      config[propName] = propValue;
    }
  });
  if (typeof autoInsertSpaceInButton !== "undefined") {
    config.button = Object.assign({
      autoInsertSpace: autoInsertSpaceInButton
    }, config.button);
  }
  const memoedConfig = useMemo3(() => config, config, (prevConfig, currentConfig) => {
    const prevKeys = Object.keys(prevConfig);
    const currentKeys = Object.keys(currentConfig);
    return prevKeys.length !== currentKeys.length || prevKeys.some((key2) => prevConfig[key2] !== currentConfig[key2]);
  });
  const {
    layer
  } = React40.useContext(StyleContext_default);
  const memoIconContextValue = React40.useMemo(() => ({
    prefixCls: iconPrefixCls,
    csp,
    layer: layer ? "antd" : void 0
  }), [iconPrefixCls, csp, layer]);
  let childNode = /* @__PURE__ */ React40.createElement(React40.Fragment, null, /* @__PURE__ */ React40.createElement(PropWarning_default, {
    dropdownMatchSelectWidth
  }), children);
  const validateMessages = React40.useMemo(() => {
    var _a, _b, _c, _d;
    return merge(((_a = en_US_default6.Form) === null || _a === void 0 ? void 0 : _a.defaultValidateMessages) || {}, ((_c = (_b = memoedConfig.locale) === null || _b === void 0 ? void 0 : _b.Form) === null || _c === void 0 ? void 0 : _c.defaultValidateMessages) || {}, ((_d = memoedConfig.form) === null || _d === void 0 ? void 0 : _d.validateMessages) || {}, (form === null || form === void 0 ? void 0 : form.validateMessages) || {});
  }, [memoedConfig, form === null || form === void 0 ? void 0 : form.validateMessages]);
  if (Object.keys(validateMessages).length > 0) {
    childNode = /* @__PURE__ */ React40.createElement(validateMessagesContext_default.Provider, {
      value: validateMessages
    }, childNode);
  }
  if (locale6) {
    childNode = /* @__PURE__ */ React40.createElement(locale_default, {
      locale: locale6,
      _ANT_MARK__: ANT_MARK
    }, childNode);
  }
  if (iconPrefixCls || csp) {
    childNode = /* @__PURE__ */ React40.createElement(Context_default.Provider, {
      value: memoIconContextValue
    }, childNode);
  }
  if (componentSize) {
    childNode = /* @__PURE__ */ React40.createElement(SizeContextProvider, {
      size: componentSize
    }, childNode);
  }
  childNode = /* @__PURE__ */ React40.createElement(MotionWrapper, null, childNode);
  const memoTheme = React40.useMemo(() => {
    const _a = mergedTheme || {}, {
      algorithm,
      token: token2,
      components,
      cssVar
    } = _a, rest = __rest4(_a, ["algorithm", "token", "components", "cssVar"]);
    const themeObj = algorithm && (!Array.isArray(algorithm) || algorithm.length > 0) ? createTheme(algorithm) : theme_default;
    const parsedComponents = {};
    Object.entries(components || {}).forEach(([componentName, componentToken]) => {
      const parsedToken = Object.assign({}, componentToken);
      if ("algorithm" in parsedToken) {
        if (parsedToken.algorithm === true) {
          parsedToken.theme = themeObj;
        } else if (Array.isArray(parsedToken.algorithm) || typeof parsedToken.algorithm === "function") {
          parsedToken.theme = createTheme(parsedToken.algorithm);
        }
        delete parsedToken.algorithm;
      }
      parsedComponents[componentName] = parsedToken;
    });
    const mergedToken = Object.assign(Object.assign({}, seed_default), token2);
    return Object.assign(Object.assign({}, rest), {
      theme: themeObj,
      token: mergedToken,
      components: parsedComponents,
      override: Object.assign({
        override: mergedToken
      }, parsedComponents),
      cssVar
    });
  }, [mergedTheme]);
  if (theme) {
    childNode = /* @__PURE__ */ React40.createElement(DesignTokenContext.Provider, {
      value: memoTheme
    }, childNode);
  }
  if (memoedConfig.warning) {
    childNode = /* @__PURE__ */ React40.createElement(WarningContext.Provider, {
      value: memoedConfig.warning
    }, childNode);
  }
  if (componentDisabled !== void 0) {
    childNode = /* @__PURE__ */ React40.createElement(DisabledContextProvider, {
      disabled: componentDisabled
    }, childNode);
  }
  return /* @__PURE__ */ React40.createElement(ConfigContext.Provider, {
    value: memoedConfig
  }, childNode);
};
var ConfigProvider = (props) => {
  const context = React40.useContext(ConfigContext);
  const antLocale = React40.useContext(context_default);
  return /* @__PURE__ */ React40.createElement(ProviderChildren, Object.assign({
    parentContext: context,
    legacyLocale: antLocale
  }, props));
};
ConfigProvider.ConfigContext = ConfigContext;
ConfigProvider.SizeContext = SizeContext_default;
ConfigProvider.config = setGlobalConfig;
ConfigProvider.useConfig = useConfig_default;
Object.defineProperty(ConfigProvider, "SizeContext", {
  get: () => {
    true ? warning_default2(false, "ConfigProvider", "ConfigProvider.SizeContext is deprecated. Please use `ConfigProvider.useConfig().componentSize` instead.") : void 0;
    return SizeContext_default;
  }
});
if (true) {
  ConfigProvider.displayName = "ConfigProvider";
}
var config_provider_default = ConfigProvider;

// ../../node_modules/@ant-design/icons/es/icons/CheckCircleFilled.js
var React44 = __toESM(require_react());

// ../../node_modules/@ant-design/icons-svg/es/asn/CheckCircleFilled.js
var CheckCircleFilled = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 01-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z" } }] }, "name": "check-circle", "theme": "filled" };
var CheckCircleFilled_default = CheckCircleFilled;

// ../../node_modules/@ant-design/icons/es/components/AntdIcon.js
var React43 = __toESM(require_react());
var import_classnames2 = __toESM(require_classnames());

// ../../node_modules/@ant-design/icons/es/components/IconBase.js
var React42 = __toESM(require_react());

// ../../node_modules/rc-util/es/Dom/shadow.js
function getRoot(ele) {
  var _ele$getRootNode;
  return ele === null || ele === void 0 || (_ele$getRootNode = ele.getRootNode) === null || _ele$getRootNode === void 0 ? void 0 : _ele$getRootNode.call(ele);
}
function inShadow(ele) {
  return getRoot(ele) instanceof ShadowRoot;
}
function getShadowRoot(ele) {
  return inShadow(ele) ? getRoot(ele) : null;
}

// ../../node_modules/@ant-design/icons/es/utils.js
var import_react24 = __toESM(require_react());
function camelCase(input) {
  return input.replace(/-(.)/g, function(match2, g) {
    return g.toUpperCase();
  });
}
function warning3(valid, message2) {
  warning_default(valid, "[@ant-design/icons] ".concat(message2));
}
function isIconDefinition(target) {
  return _typeof(target) === "object" && typeof target.name === "string" && typeof target.theme === "string" && (_typeof(target.icon) === "object" || typeof target.icon === "function");
}
function normalizeAttrs() {
  var attrs = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  return Object.keys(attrs).reduce(function(acc, key2) {
    var val = attrs[key2];
    switch (key2) {
      case "class":
        acc.className = val;
        delete acc.class;
        break;
      default:
        delete acc[key2];
        acc[camelCase(key2)] = val;
    }
    return acc;
  }, {});
}
function generate2(node2, key2, rootProps) {
  if (!rootProps) {
    return /* @__PURE__ */ import_react24.default.createElement(node2.tag, _objectSpread2({
      key: key2
    }, normalizeAttrs(node2.attrs)), (node2.children || []).map(function(child, index3) {
      return generate2(child, "".concat(key2, "-").concat(node2.tag, "-").concat(index3));
    }));
  }
  return /* @__PURE__ */ import_react24.default.createElement(node2.tag, _objectSpread2(_objectSpread2({
    key: key2
  }, normalizeAttrs(node2.attrs)), rootProps), (node2.children || []).map(function(child, index3) {
    return generate2(child, "".concat(key2, "-").concat(node2.tag, "-").concat(index3));
  }));
}
function getSecondaryColor(primaryColor) {
  return generate(primaryColor)[0];
}
function normalizeTwoToneColors(twoToneColor) {
  if (!twoToneColor) {
    return [];
  }
  return Array.isArray(twoToneColor) ? twoToneColor : [twoToneColor];
}
var iconStyles = "\n.anticon {\n  display: inline-flex;\n  align-items: center;\n  color: inherit;\n  font-style: normal;\n  line-height: 0;\n  text-align: center;\n  text-transform: none;\n  vertical-align: -0.125em;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.anticon > * {\n  line-height: 1;\n}\n\n.anticon svg {\n  display: inline-block;\n}\n\n.anticon::before {\n  display: none;\n}\n\n.anticon .anticon-icon {\n  display: block;\n}\n\n.anticon[tabindex] {\n  cursor: pointer;\n}\n\n.anticon-spin::before,\n.anticon-spin {\n  display: inline-block;\n  -webkit-animation: loadingCircle 1s infinite linear;\n  animation: loadingCircle 1s infinite linear;\n}\n\n@-webkit-keyframes loadingCircle {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes loadingCircle {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n";
var useInsertStyles = function useInsertStyles2(eleRef) {
  var _useContext = (0, import_react24.useContext)(Context_default), csp = _useContext.csp, prefixCls = _useContext.prefixCls, layer = _useContext.layer;
  var mergedStyleStr = iconStyles;
  if (prefixCls) {
    mergedStyleStr = mergedStyleStr.replace(/anticon/g, prefixCls);
  }
  if (layer) {
    mergedStyleStr = "@layer ".concat(layer, " {\n").concat(mergedStyleStr, "\n}");
  }
  (0, import_react24.useEffect)(function() {
    var ele = eleRef.current;
    var shadowRoot = getShadowRoot(ele);
    updateCSS(mergedStyleStr, "@ant-design-icons", {
      prepend: !layer,
      csp,
      attachTo: shadowRoot
    });
  }, []);
};

// ../../node_modules/@ant-design/icons/es/components/IconBase.js
var _excluded3 = ["icon", "className", "onClick", "style", "primaryColor", "secondaryColor"];
var twoToneColorPalette = {
  primaryColor: "#333",
  secondaryColor: "#E6E6E6",
  calculated: false
};
function setTwoToneColors(_ref) {
  var primaryColor = _ref.primaryColor, secondaryColor = _ref.secondaryColor;
  twoToneColorPalette.primaryColor = primaryColor;
  twoToneColorPalette.secondaryColor = secondaryColor || getSecondaryColor(primaryColor);
  twoToneColorPalette.calculated = !!secondaryColor;
}
function getTwoToneColors() {
  return _objectSpread2({}, twoToneColorPalette);
}
var IconBase = function IconBase2(props) {
  var icon = props.icon, className2 = props.className, onClick = props.onClick, style2 = props.style, primaryColor = props.primaryColor, secondaryColor = props.secondaryColor, restProps = _objectWithoutProperties(props, _excluded3);
  var svgRef = React42.useRef();
  var colors = twoToneColorPalette;
  if (primaryColor) {
    colors = {
      primaryColor,
      secondaryColor: secondaryColor || getSecondaryColor(primaryColor)
    };
  }
  useInsertStyles(svgRef);
  warning3(isIconDefinition(icon), "icon should be icon definiton, but got ".concat(icon));
  if (!isIconDefinition(icon)) {
    return null;
  }
  var target = icon;
  if (target && typeof target.icon === "function") {
    target = _objectSpread2(_objectSpread2({}, target), {}, {
      icon: target.icon(colors.primaryColor, colors.secondaryColor)
    });
  }
  return generate2(target.icon, "svg-".concat(target.name), _objectSpread2(_objectSpread2({
    className: className2,
    onClick,
    style: style2,
    "data-icon": target.name,
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true"
  }, restProps), {}, {
    ref: svgRef
  }));
};
IconBase.displayName = "IconReact";
IconBase.getTwoToneColors = getTwoToneColors;
IconBase.setTwoToneColors = setTwoToneColors;
var IconBase_default = IconBase;

// ../../node_modules/@ant-design/icons/es/components/twoTonePrimaryColor.js
function setTwoToneColor(twoToneColor) {
  var _normalizeTwoToneColo = normalizeTwoToneColors(twoToneColor), _normalizeTwoToneColo2 = _slicedToArray(_normalizeTwoToneColo, 2), primaryColor = _normalizeTwoToneColo2[0], secondaryColor = _normalizeTwoToneColo2[1];
  return IconBase_default.setTwoToneColors({
    primaryColor,
    secondaryColor
  });
}
function getTwoToneColor() {
  var colors = IconBase_default.getTwoToneColors();
  if (!colors.calculated) {
    return colors.primaryColor;
  }
  return [colors.primaryColor, colors.secondaryColor];
}

// ../../node_modules/@ant-design/icons/es/components/AntdIcon.js
var _excluded4 = ["className", "icon", "spin", "rotate", "tabIndex", "onClick", "twoToneColor"];
setTwoToneColor(blue.primary);
var Icon = /* @__PURE__ */ React43.forwardRef(function(props, ref3) {
  var className2 = props.className, icon = props.icon, spin = props.spin, rotate2 = props.rotate, tabIndex = props.tabIndex, onClick = props.onClick, twoToneColor = props.twoToneColor, restProps = _objectWithoutProperties(props, _excluded4);
  var _React$useContext = React43.useContext(Context_default), _React$useContext$pre = _React$useContext.prefixCls, prefixCls = _React$useContext$pre === void 0 ? "anticon" : _React$useContext$pre, rootClassName = _React$useContext.rootClassName;
  var classString = (0, import_classnames2.default)(rootClassName, prefixCls, _defineProperty(_defineProperty({}, "".concat(prefixCls, "-").concat(icon.name), !!icon.name), "".concat(prefixCls, "-spin"), !!spin || icon.name === "loading"), className2);
  var iconTabIndex = tabIndex;
  if (iconTabIndex === void 0 && onClick) {
    iconTabIndex = -1;
  }
  var svgStyle = rotate2 ? {
    msTransform: "rotate(".concat(rotate2, "deg)"),
    transform: "rotate(".concat(rotate2, "deg)")
  } : void 0;
  var _normalizeTwoToneColo = normalizeTwoToneColors(twoToneColor), _normalizeTwoToneColo2 = _slicedToArray(_normalizeTwoToneColo, 2), primaryColor = _normalizeTwoToneColo2[0], secondaryColor = _normalizeTwoToneColo2[1];
  return /* @__PURE__ */ React43.createElement("span", _extends({
    role: "img",
    "aria-label": icon.name
  }, restProps, {
    ref: ref3,
    tabIndex: iconTabIndex,
    onClick,
    className: classString
  }), /* @__PURE__ */ React43.createElement(IconBase_default, {
    icon,
    primaryColor,
    secondaryColor,
    style: svgStyle
  }));
});
Icon.displayName = "AntdIcon";
Icon.getTwoToneColor = getTwoToneColor;
Icon.setTwoToneColor = setTwoToneColor;
var AntdIcon_default = Icon;

// ../../node_modules/@ant-design/icons/es/icons/CheckCircleFilled.js
var CheckCircleFilled2 = function CheckCircleFilled3(props, ref3) {
  return /* @__PURE__ */ React44.createElement(AntdIcon_default, _extends({}, props, {
    ref: ref3,
    icon: CheckCircleFilled_default
  }));
};
var RefIcon = /* @__PURE__ */ React44.forwardRef(CheckCircleFilled2);
if (true) {
  RefIcon.displayName = "CheckCircleFilled";
}
var CheckCircleFilled_default2 = RefIcon;

// ../../node_modules/@ant-design/icons/es/icons/CloseCircleFilled.js
var React45 = __toESM(require_react());

// ../../node_modules/@ant-design/icons-svg/es/asn/CloseCircleFilled.js
var CloseCircleFilled = { "icon": { "tag": "svg", "attrs": { "fill-rule": "evenodd", "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64zm127.98 274.82h-.04l-.08.06L512 466.75 384.14 338.88c-.04-.05-.06-.06-.08-.06a.12.12 0 00-.07 0c-.03 0-.05.01-.09.05l-45.02 45.02a.2.2 0 00-.05.09.12.12 0 000 .07v.02a.27.27 0 00.06.06L466.75 512 338.88 639.86c-.05.04-.06.06-.06.08a.12.12 0 000 .07c0 .03.01.05.05.09l45.02 45.02a.2.2 0 00.09.05.12.12 0 00.07 0c.02 0 .04-.01.08-.05L512 557.25l127.86 127.87c.04.04.06.05.08.05a.12.12 0 00.07 0c.03 0 .05-.01.09-.05l45.02-45.02a.2.2 0 00.05-.09.12.12 0 000-.07v-.02a.27.27 0 00-.05-.06L557.25 512l127.87-127.86c.04-.04.05-.06.05-.08a.12.12 0 000-.07c0-.03-.01-.05-.05-.09l-45.02-45.02a.2.2 0 00-.09-.05.12.12 0 00-.07 0z" } }] }, "name": "close-circle", "theme": "filled" };
var CloseCircleFilled_default = CloseCircleFilled;

// ../../node_modules/@ant-design/icons/es/icons/CloseCircleFilled.js
var CloseCircleFilled2 = function CloseCircleFilled3(props, ref3) {
  return /* @__PURE__ */ React45.createElement(AntdIcon_default, _extends({}, props, {
    ref: ref3,
    icon: CloseCircleFilled_default
  }));
};
var RefIcon2 = /* @__PURE__ */ React45.forwardRef(CloseCircleFilled2);
if (true) {
  RefIcon2.displayName = "CloseCircleFilled";
}
var CloseCircleFilled_default2 = RefIcon2;

// ../../node_modules/@ant-design/icons/es/icons/CloseOutlined.js
var React46 = __toESM(require_react());

// ../../node_modules/@ant-design/icons-svg/es/asn/CloseOutlined.js
var CloseOutlined = { "icon": { "tag": "svg", "attrs": { "fill-rule": "evenodd", "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M799.86 166.31c.02 0 .04.02.08.06l57.69 57.7c.04.03.05.05.06.08a.12.12 0 010 .06c0 .03-.02.05-.06.09L569.93 512l287.7 287.7c.04.04.05.06.06.09a.12.12 0 010 .07c0 .02-.02.04-.06.08l-57.7 57.69c-.03.04-.05.05-.07.06a.12.12 0 01-.07 0c-.03 0-.05-.02-.09-.06L512 569.93l-287.7 287.7c-.04.04-.06.05-.09.06a.12.12 0 01-.07 0c-.02 0-.04-.02-.08-.06l-57.69-57.7c-.04-.03-.05-.05-.06-.07a.12.12 0 010-.07c0-.03.02-.05.06-.09L454.07 512l-287.7-287.7c-.04-.04-.05-.06-.06-.09a.12.12 0 010-.07c0-.02.02-.04.06-.08l57.7-57.69c.03-.04.05-.05.07-.06a.12.12 0 01.07 0c.03 0 .05.02.09.06L512 454.07l287.7-287.7c.04-.04.06-.05.09-.06a.12.12 0 01.07 0z" } }] }, "name": "close", "theme": "outlined" };
var CloseOutlined_default = CloseOutlined;

// ../../node_modules/@ant-design/icons/es/icons/CloseOutlined.js
var CloseOutlined2 = function CloseOutlined3(props, ref3) {
  return /* @__PURE__ */ React46.createElement(AntdIcon_default, _extends({}, props, {
    ref: ref3,
    icon: CloseOutlined_default
  }));
};
var RefIcon3 = /* @__PURE__ */ React46.forwardRef(CloseOutlined2);
if (true) {
  RefIcon3.displayName = "CloseOutlined";
}
var CloseOutlined_default2 = RefIcon3;

// ../../node_modules/@ant-design/icons/es/icons/ExclamationCircleFilled.js
var React47 = __toESM(require_react());

// ../../node_modules/@ant-design/icons-svg/es/asn/ExclamationCircleFilled.js
var ExclamationCircleFilled = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, "name": "exclamation-circle", "theme": "filled" };
var ExclamationCircleFilled_default = ExclamationCircleFilled;

// ../../node_modules/@ant-design/icons/es/icons/ExclamationCircleFilled.js
var ExclamationCircleFilled2 = function ExclamationCircleFilled3(props, ref3) {
  return /* @__PURE__ */ React47.createElement(AntdIcon_default, _extends({}, props, {
    ref: ref3,
    icon: ExclamationCircleFilled_default
  }));
};
var RefIcon4 = /* @__PURE__ */ React47.forwardRef(ExclamationCircleFilled2);
if (true) {
  RefIcon4.displayName = "ExclamationCircleFilled";
}
var ExclamationCircleFilled_default2 = RefIcon4;

// ../../node_modules/@ant-design/icons/es/icons/InfoCircleFilled.js
var React48 = __toESM(require_react());

// ../../node_modules/@ant-design/icons-svg/es/asn/InfoCircleFilled.js
var InfoCircleFilled = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, "name": "info-circle", "theme": "filled" };
var InfoCircleFilled_default = InfoCircleFilled;

// ../../node_modules/@ant-design/icons/es/icons/InfoCircleFilled.js
var InfoCircleFilled2 = function InfoCircleFilled3(props, ref3) {
  return /* @__PURE__ */ React48.createElement(AntdIcon_default, _extends({}, props, {
    ref: ref3,
    icon: InfoCircleFilled_default
  }));
};
var RefIcon5 = /* @__PURE__ */ React48.forwardRef(InfoCircleFilled2);
if (true) {
  RefIcon5.displayName = "InfoCircleFilled";
}
var InfoCircleFilled_default2 = RefIcon5;

// ../../node_modules/rc-util/es/pickAttrs.js
var attributes = "accept acceptCharset accessKey action allowFullScreen allowTransparency\n    alt async autoComplete autoFocus autoPlay capture cellPadding cellSpacing challenge\n    charSet checked classID className colSpan cols content contentEditable contextMenu\n    controls coords crossOrigin data dateTime default defer dir disabled download draggable\n    encType form formAction formEncType formMethod formNoValidate formTarget frameBorder\n    headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity\n    is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media\n    mediaGroup method min minLength multiple muted name noValidate nonce open\n    optimum pattern placeholder poster preload radioGroup readOnly rel required\n    reversed role rowSpan rows sandbox scope scoped scrolling seamless selected\n    shape size sizes span spellCheck src srcDoc srcLang srcSet start step style\n    summary tabIndex target title type useMap value width wmode wrap";
var eventsName = "onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown\n    onKeyPress onKeyUp onFocus onBlur onChange onInput onSubmit onClick onContextMenu onDoubleClick\n    onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown\n    onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel\n    onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough\n    onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata\n    onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onError";
var propList = "".concat(attributes, " ").concat(eventsName).split(/[\s\n]+/);
var ariaPrefix = "aria-";
var dataPrefix = "data-";
function match(key2, prefix3) {
  return key2.indexOf(prefix3) === 0;
}
function pickAttrs(props) {
  var ariaOnly = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
  var mergedConfig;
  if (ariaOnly === false) {
    mergedConfig = {
      aria: true,
      data: true,
      attr: true
    };
  } else if (ariaOnly === true) {
    mergedConfig = {
      aria: true
    };
  } else {
    mergedConfig = _objectSpread2({}, ariaOnly);
  }
  var attrs = {};
  Object.keys(props).forEach(function(key2) {
    if (
      // Aria
      mergedConfig.aria && (key2 === "role" || match(key2, ariaPrefix)) || // Data
      mergedConfig.data && match(key2, dataPrefix) || // Attr
      mergedConfig.attr && propList.includes(key2)
    ) {
      attrs[key2] = props[key2];
    }
  });
  return attrs;
}

// ../../node_modules/antd/es/_util/reactNode.js
var import_react25 = __toESM(require_react());
function isFragment2(child) {
  return child && /* @__PURE__ */ import_react25.default.isValidElement(child) && child.type === import_react25.default.Fragment;
}
var replaceElement = (element, replacement, props) => {
  if (!/* @__PURE__ */ import_react25.default.isValidElement(element)) {
    return replacement;
  }
  return /* @__PURE__ */ import_react25.default.cloneElement(element, typeof props === "function" ? props(element.props || {}) : props);
};
function cloneElement4(element, props) {
  return replaceElement(element, element, props);
}

// ../../node_modules/compute-scroll-into-view/dist/index.js
var t = (t2) => "object" == typeof t2 && null != t2 && 1 === t2.nodeType;
var e = (t2, e3) => (!e3 || "hidden" !== t2) && ("visible" !== t2 && "clip" !== t2);
var n = (t2, n2) => {
  if (t2.clientHeight < t2.scrollHeight || t2.clientWidth < t2.scrollWidth) {
    const o3 = getComputedStyle(t2, null);
    return e(o3.overflowY, n2) || e(o3.overflowX, n2) || ((t3) => {
      const e3 = ((t4) => {
        if (!t4.ownerDocument || !t4.ownerDocument.defaultView) return null;
        try {
          return t4.ownerDocument.defaultView.frameElement;
        } catch (t5) {
          return null;
        }
      })(t3);
      return !!e3 && (e3.clientHeight < t3.scrollHeight || e3.clientWidth < t3.scrollWidth);
    })(t2);
  }
  return false;
};
var o = (t2, e3, n2, o3, l2, r2, i, s) => r2 < t2 && i > e3 || r2 > t2 && i < e3 ? 0 : r2 <= t2 && s <= n2 || i >= e3 && s >= n2 ? r2 - t2 - o3 : i > e3 && s < n2 || r2 < t2 && s > n2 ? i - e3 + l2 : 0;
var l = (t2) => {
  const e3 = t2.parentElement;
  return null == e3 ? t2.getRootNode().host || null : e3;
};
var r = (e3, r2) => {
  var i, s, d, h2;
  if ("undefined" == typeof document) return [];
  const { scrollMode: c, block: f, inline: u, boundary: a, skipOverflowHiddenElements: g } = r2, p = "function" == typeof a ? a : (t2) => t2 !== a;
  if (!t(e3)) throw new TypeError("Invalid target");
  const m = document.scrollingElement || document.documentElement, w = [];
  let W = e3;
  for (; t(W) && p(W); ) {
    if (W = l(W), W === m) {
      w.push(W);
      break;
    }
    null != W && W === document.body && n(W) && !n(document.documentElement) || null != W && n(W, g) && w.push(W);
  }
  const b = null != (s = null == (i = window.visualViewport) ? void 0 : i.width) ? s : innerWidth, H = null != (h2 = null == (d = window.visualViewport) ? void 0 : d.height) ? h2 : innerHeight, { scrollX: y, scrollY: M } = window, { height: v, width: E, top: x, right: C, bottom: I, left: R } = e3.getBoundingClientRect(), { top: T, right: B, bottom: F, left: V } = ((t2) => {
    const e4 = window.getComputedStyle(t2);
    return { top: parseFloat(e4.scrollMarginTop) || 0, right: parseFloat(e4.scrollMarginRight) || 0, bottom: parseFloat(e4.scrollMarginBottom) || 0, left: parseFloat(e4.scrollMarginLeft) || 0 };
  })(e3);
  let k = "start" === f || "nearest" === f ? x - T : "end" === f ? I + F : x + v / 2 - T + F, D = "center" === u ? R + E / 2 - V + B : "end" === u ? C + B : R - V;
  const L = [];
  for (let t2 = 0; t2 < w.length; t2++) {
    const e4 = w[t2], { height: l2, width: r3, top: i2, right: s2, bottom: d2, left: h3 } = e4.getBoundingClientRect();
    if ("if-needed" === c && x >= 0 && R >= 0 && I <= H && C <= b && (e4 === m && !n(e4) || x >= i2 && I <= d2 && R >= h3 && C <= s2)) return L;
    const a2 = getComputedStyle(e4), g2 = parseInt(a2.borderLeftWidth, 10), p2 = parseInt(a2.borderTopWidth, 10), W2 = parseInt(a2.borderRightWidth, 10), T2 = parseInt(a2.borderBottomWidth, 10);
    let B2 = 0, F2 = 0;
    const V2 = "offsetWidth" in e4 ? e4.offsetWidth - e4.clientWidth - g2 - W2 : 0, S = "offsetHeight" in e4 ? e4.offsetHeight - e4.clientHeight - p2 - T2 : 0, X2 = "offsetWidth" in e4 ? 0 === e4.offsetWidth ? 0 : r3 / e4.offsetWidth : 0, Y = "offsetHeight" in e4 ? 0 === e4.offsetHeight ? 0 : l2 / e4.offsetHeight : 0;
    if (m === e4) B2 = "start" === f ? k : "end" === f ? k - H : "nearest" === f ? o(M, M + H, H, p2, T2, M + k, M + k + v, v) : k - H / 2, F2 = "start" === u ? D : "center" === u ? D - b / 2 : "end" === u ? D - b : o(y, y + b, b, g2, W2, y + D, y + D + E, E), B2 = Math.max(0, B2 + M), F2 = Math.max(0, F2 + y);
    else {
      B2 = "start" === f ? k - i2 - p2 : "end" === f ? k - d2 + T2 + S : "nearest" === f ? o(i2, d2, l2, p2, T2 + S, k, k + v, v) : k - (i2 + l2 / 2) + S / 2, F2 = "start" === u ? D - h3 - g2 : "center" === u ? D - (h3 + r3 / 2) + V2 / 2 : "end" === u ? D - s2 + W2 + V2 : o(h3, s2, r3, g2, W2 + V2, D, D + E, E);
      const { scrollLeft: t3, scrollTop: n2 } = e4;
      B2 = 0 === Y ? 0 : Math.max(0, Math.min(n2 + B2 / Y, e4.scrollHeight - l2 / Y + S)), F2 = 0 === X2 ? 0 : Math.max(0, Math.min(t3 + F2 / X2, e4.scrollWidth - r3 / X2 + V2)), k += n2 - B2, D += t3 - F2;
    }
    L.push({ el: e4, top: B2, left: F2 });
  }
  return L;
};

// ../../node_modules/scroll-into-view-if-needed/dist/index.js
var o2 = (t2) => false === t2 ? { block: "end", inline: "nearest" } : ((t3) => t3 === Object(t3) && 0 !== Object.keys(t3).length)(t2) ? t2 : { block: "start", inline: "nearest" };
function e2(e3, r2) {
  if (!e3.isConnected || !((t2) => {
    let o3 = t2;
    for (; o3 && o3.parentNode; ) {
      if (o3.parentNode === document) return true;
      o3 = o3.parentNode instanceof ShadowRoot ? o3.parentNode.host : o3.parentNode;
    }
    return false;
  })(e3)) return;
  const n2 = ((t2) => {
    const o3 = window.getComputedStyle(t2);
    return { top: parseFloat(o3.scrollMarginTop) || 0, right: parseFloat(o3.scrollMarginRight) || 0, bottom: parseFloat(o3.scrollMarginBottom) || 0, left: parseFloat(o3.scrollMarginLeft) || 0 };
  })(e3);
  if (((t2) => "object" == typeof t2 && "function" == typeof t2.behavior)(r2)) return r2.behavior(r(e3, r2));
  const l2 = "boolean" == typeof r2 || null == r2 ? void 0 : r2.behavior;
  for (const { el: a, top: i, left: s } of r(e3, o2(r2))) {
    const t2 = i - n2.top + n2.bottom, o3 = s - n2.left + n2.right;
    a.scroll({ top: t2, left: o3, behavior: l2 });
  }
}

// ../../node_modules/antd/es/_util/getScroll.js
function isWindow2(obj) {
  return obj !== null && obj !== void 0 && obj === obj.window;
}
var getScroll = (target) => {
  var _a, _b;
  if (typeof window === "undefined") {
    return 0;
  }
  let result = 0;
  if (isWindow2(target)) {
    result = target.pageYOffset;
  } else if (target instanceof Document) {
    result = target.documentElement.scrollTop;
  } else if (target instanceof HTMLElement) {
    result = target.scrollTop;
  } else if (target) {
    result = target["scrollTop"];
  }
  if (target && !isWindow2(target) && typeof result !== "number") {
    result = (_b = ((_a = target.ownerDocument) !== null && _a !== void 0 ? _a : target).documentElement) === null || _b === void 0 ? void 0 : _b.scrollTop;
  }
  return result;
};
var getScroll_default = getScroll;

// ../../node_modules/antd/es/_util/easings.js
function easeInOutCubic(t2, b, c, d) {
  const cc = c - b;
  t2 /= d / 2;
  if (t2 < 1) {
    return cc / 2 * t2 * t2 * t2 + b;
  }
  return cc / 2 * ((t2 -= 2) * t2 * t2 + 2) + b;
}

// ../../node_modules/antd/es/_util/scrollTo.js
function scrollTo(y, options = {}) {
  const {
    getContainer: getContainer2 = () => window,
    callback,
    duration = 450
  } = options;
  const container = getContainer2();
  const scrollTop = getScroll_default(container);
  const startTime = Date.now();
  const frameFunc = () => {
    const timestamp = Date.now();
    const time = timestamp - startTime;
    const nextScrollTop = easeInOutCubic(time > duration ? duration : time, scrollTop, y, duration);
    if (isWindow2(container)) {
      container.scrollTo(window.pageXOffset, nextScrollTop);
    } else if (container instanceof Document || container.constructor.name === "HTMLDocument") {
      container.documentElement.scrollTop = nextScrollTop;
    } else {
      container.scrollTop = nextScrollTop;
    }
    if (time < duration) {
      raf_default(frameFunc);
    } else if (typeof callback === "function") {
      callback();
    }
  };
  raf_default(frameFunc);
}

// ../../node_modules/antd/es/config-provider/hooks/useCSSVarCls.js
var useCSSVarCls = (prefixCls) => {
  const [, , , , cssVar] = useToken();
  return cssVar ? `${prefixCls}-css-var` : "";
};
var useCSSVarCls_default = useCSSVarCls;

// ../../node_modules/antd/es/message/useMessage.js
var React59 = __toESM(require_react());
var import_classnames6 = __toESM(require_classnames());

// ../../node_modules/rc-notification/es/hooks/useNotification.js
var React54 = __toESM(require_react());

// ../../node_modules/rc-notification/es/Notifications.js
var React53 = __toESM(require_react());
var import_react_dom4 = __toESM(require_react_dom());

// ../../node_modules/rc-notification/es/NoticeList.js
var import_react27 = __toESM(require_react());
var import_classnames4 = __toESM(require_classnames());

// ../../node_modules/rc-notification/es/Notice.js
var import_classnames3 = __toESM(require_classnames());

// ../../node_modules/rc-util/es/KeyCode.js
var KeyCode = {
  /**
   * MAC_ENTER
   */
  MAC_ENTER: 3,
  /**
   * BACKSPACE
   */
  BACKSPACE: 8,
  /**
   * TAB
   */
  TAB: 9,
  /**
   * NUMLOCK on FF/Safari Mac
   */
  NUM_CENTER: 12,
  // NUMLOCK on FF/Safari Mac
  /**
   * ENTER
   */
  ENTER: 13,
  /**
   * SHIFT
   */
  SHIFT: 16,
  /**
   * CTRL
   */
  CTRL: 17,
  /**
   * ALT
   */
  ALT: 18,
  /**
   * PAUSE
   */
  PAUSE: 19,
  /**
   * CAPS_LOCK
   */
  CAPS_LOCK: 20,
  /**
   * ESC
   */
  ESC: 27,
  /**
   * SPACE
   */
  SPACE: 32,
  /**
   * PAGE_UP
   */
  PAGE_UP: 33,
  // also NUM_NORTH_EAST
  /**
   * PAGE_DOWN
   */
  PAGE_DOWN: 34,
  // also NUM_SOUTH_EAST
  /**
   * END
   */
  END: 35,
  // also NUM_SOUTH_WEST
  /**
   * HOME
   */
  HOME: 36,
  // also NUM_NORTH_WEST
  /**
   * LEFT
   */
  LEFT: 37,
  // also NUM_WEST
  /**
   * UP
   */
  UP: 38,
  // also NUM_NORTH
  /**
   * RIGHT
   */
  RIGHT: 39,
  // also NUM_EAST
  /**
   * DOWN
   */
  DOWN: 40,
  // also NUM_SOUTH
  /**
   * PRINT_SCREEN
   */
  PRINT_SCREEN: 44,
  /**
   * INSERT
   */
  INSERT: 45,
  // also NUM_INSERT
  /**
   * DELETE
   */
  DELETE: 46,
  // also NUM_DELETE
  /**
   * ZERO
   */
  ZERO: 48,
  /**
   * ONE
   */
  ONE: 49,
  /**
   * TWO
   */
  TWO: 50,
  /**
   * THREE
   */
  THREE: 51,
  /**
   * FOUR
   */
  FOUR: 52,
  /**
   * FIVE
   */
  FIVE: 53,
  /**
   * SIX
   */
  SIX: 54,
  /**
   * SEVEN
   */
  SEVEN: 55,
  /**
   * EIGHT
   */
  EIGHT: 56,
  /**
   * NINE
   */
  NINE: 57,
  /**
   * QUESTION_MARK
   */
  QUESTION_MARK: 63,
  // needs localization
  /**
   * A
   */
  A: 65,
  /**
   * B
   */
  B: 66,
  /**
   * C
   */
  C: 67,
  /**
   * D
   */
  D: 68,
  /**
   * E
   */
  E: 69,
  /**
   * F
   */
  F: 70,
  /**
   * G
   */
  G: 71,
  /**
   * H
   */
  H: 72,
  /**
   * I
   */
  I: 73,
  /**
   * J
   */
  J: 74,
  /**
   * K
   */
  K: 75,
  /**
   * L
   */
  L: 76,
  /**
   * M
   */
  M: 77,
  /**
   * N
   */
  N: 78,
  /**
   * O
   */
  O: 79,
  /**
   * P
   */
  P: 80,
  /**
   * Q
   */
  Q: 81,
  /**
   * R
   */
  R: 82,
  /**
   * S
   */
  S: 83,
  /**
   * T
   */
  T: 84,
  /**
   * U
   */
  U: 85,
  /**
   * V
   */
  V: 86,
  /**
   * W
   */
  W: 87,
  /**
   * X
   */
  X: 88,
  /**
   * Y
   */
  Y: 89,
  /**
   * Z
   */
  Z: 90,
  /**
   * META
   */
  META: 91,
  // WIN_KEY_LEFT
  /**
   * WIN_KEY_RIGHT
   */
  WIN_KEY_RIGHT: 92,
  /**
   * CONTEXT_MENU
   */
  CONTEXT_MENU: 93,
  /**
   * NUM_ZERO
   */
  NUM_ZERO: 96,
  /**
   * NUM_ONE
   */
  NUM_ONE: 97,
  /**
   * NUM_TWO
   */
  NUM_TWO: 98,
  /**
   * NUM_THREE
   */
  NUM_THREE: 99,
  /**
   * NUM_FOUR
   */
  NUM_FOUR: 100,
  /**
   * NUM_FIVE
   */
  NUM_FIVE: 101,
  /**
   * NUM_SIX
   */
  NUM_SIX: 102,
  /**
   * NUM_SEVEN
   */
  NUM_SEVEN: 103,
  /**
   * NUM_EIGHT
   */
  NUM_EIGHT: 104,
  /**
   * NUM_NINE
   */
  NUM_NINE: 105,
  /**
   * NUM_MULTIPLY
   */
  NUM_MULTIPLY: 106,
  /**
   * NUM_PLUS
   */
  NUM_PLUS: 107,
  /**
   * NUM_MINUS
   */
  NUM_MINUS: 109,
  /**
   * NUM_PERIOD
   */
  NUM_PERIOD: 110,
  /**
   * NUM_DIVISION
   */
  NUM_DIVISION: 111,
  /**
   * F1
   */
  F1: 112,
  /**
   * F2
   */
  F2: 113,
  /**
   * F3
   */
  F3: 114,
  /**
   * F4
   */
  F4: 115,
  /**
   * F5
   */
  F5: 116,
  /**
   * F6
   */
  F6: 117,
  /**
   * F7
   */
  F7: 118,
  /**
   * F8
   */
  F8: 119,
  /**
   * F9
   */
  F9: 120,
  /**
   * F10
   */
  F10: 121,
  /**
   * F11
   */
  F11: 122,
  /**
   * F12
   */
  F12: 123,
  /**
   * NUMLOCK
   */
  NUMLOCK: 144,
  /**
   * SEMICOLON
   */
  SEMICOLON: 186,
  // needs localization
  /**
   * DASH
   */
  DASH: 189,
  // needs localization
  /**
   * EQUALS
   */
  EQUALS: 187,
  // needs localization
  /**
   * COMMA
   */
  COMMA: 188,
  // needs localization
  /**
   * PERIOD
   */
  PERIOD: 190,
  // needs localization
  /**
   * SLASH
   */
  SLASH: 191,
  // needs localization
  /**
   * APOSTROPHE
   */
  APOSTROPHE: 192,
  // needs localization
  /**
   * SINGLE_QUOTE
   */
  SINGLE_QUOTE: 222,
  // needs localization
  /**
   * OPEN_SQUARE_BRACKET
   */
  OPEN_SQUARE_BRACKET: 219,
  // needs localization
  /**
   * BACKSLASH
   */
  BACKSLASH: 220,
  // needs localization
  /**
   * CLOSE_SQUARE_BRACKET
   */
  CLOSE_SQUARE_BRACKET: 221,
  // needs localization
  /**
   * WIN_KEY
   */
  WIN_KEY: 224,
  /**
   * MAC_FF_META
   */
  MAC_FF_META: 224,
  // Firefox (Gecko) fires this for the meta key instead of 91
  /**
   * WIN_IME
   */
  WIN_IME: 229,
  // ======================== Function ========================
  /**
   * whether text and modified key is entered at the same time.
   */
  isTextModifyingKeyEvent: function isTextModifyingKeyEvent(e3) {
    var keyCode = e3.keyCode;
    if (e3.altKey && !e3.ctrlKey || e3.metaKey || // Function keys don't generate text
    keyCode >= KeyCode.F1 && keyCode <= KeyCode.F12) {
      return false;
    }
    switch (keyCode) {
      case KeyCode.ALT:
      case KeyCode.CAPS_LOCK:
      case KeyCode.CONTEXT_MENU:
      case KeyCode.CTRL:
      case KeyCode.DOWN:
      case KeyCode.END:
      case KeyCode.ESC:
      case KeyCode.HOME:
      case KeyCode.INSERT:
      case KeyCode.LEFT:
      case KeyCode.MAC_FF_META:
      case KeyCode.META:
      case KeyCode.NUMLOCK:
      case KeyCode.NUM_CENTER:
      case KeyCode.PAGE_DOWN:
      case KeyCode.PAGE_UP:
      case KeyCode.PAUSE:
      case KeyCode.PRINT_SCREEN:
      case KeyCode.RIGHT:
      case KeyCode.SHIFT:
      case KeyCode.UP:
      case KeyCode.WIN_KEY:
      case KeyCode.WIN_KEY_RIGHT:
        return false;
      default:
        return true;
    }
  },
  /**
   * whether character is entered.
   */
  isCharacterKey: function isCharacterKey(keyCode) {
    if (keyCode >= KeyCode.ZERO && keyCode <= KeyCode.NINE) {
      return true;
    }
    if (keyCode >= KeyCode.NUM_ZERO && keyCode <= KeyCode.NUM_MULTIPLY) {
      return true;
    }
    if (keyCode >= KeyCode.A && keyCode <= KeyCode.Z) {
      return true;
    }
    if (window.navigator.userAgent.indexOf("WebKit") !== -1 && keyCode === 0) {
      return true;
    }
    switch (keyCode) {
      case KeyCode.SPACE:
      case KeyCode.QUESTION_MARK:
      case KeyCode.NUM_PLUS:
      case KeyCode.NUM_MINUS:
      case KeyCode.NUM_PERIOD:
      case KeyCode.NUM_DIVISION:
      case KeyCode.SEMICOLON:
      case KeyCode.DASH:
      case KeyCode.EQUALS:
      case KeyCode.COMMA:
      case KeyCode.PERIOD:
      case KeyCode.SLASH:
      case KeyCode.APOSTROPHE:
      case KeyCode.SINGLE_QUOTE:
      case KeyCode.OPEN_SQUARE_BRACKET:
      case KeyCode.BACKSLASH:
      case KeyCode.CLOSE_SQUARE_BRACKET:
        return true;
      default:
        return false;
    }
  }
};
var KeyCode_default = KeyCode;

// ../../node_modules/rc-notification/es/Notice.js
var React50 = __toESM(require_react());
var Notify = /* @__PURE__ */ React50.forwardRef(function(props, ref3) {
  var prefixCls = props.prefixCls, style2 = props.style, className2 = props.className, _props$duration = props.duration, duration = _props$duration === void 0 ? 4.5 : _props$duration, showProgress = props.showProgress, _props$pauseOnHover = props.pauseOnHover, pauseOnHover = _props$pauseOnHover === void 0 ? true : _props$pauseOnHover, eventKey = props.eventKey, content = props.content, closable = props.closable, _props$closeIcon = props.closeIcon, closeIcon = _props$closeIcon === void 0 ? "x" : _props$closeIcon, divProps = props.props, onClick = props.onClick, onNoticeClose = props.onNoticeClose, times = props.times, forcedHovering = props.hovering;
  var _React$useState = React50.useState(false), _React$useState2 = _slicedToArray(_React$useState, 2), hovering = _React$useState2[0], setHovering = _React$useState2[1];
  var _React$useState3 = React50.useState(0), _React$useState4 = _slicedToArray(_React$useState3, 2), percent = _React$useState4[0], setPercent = _React$useState4[1];
  var _React$useState5 = React50.useState(0), _React$useState6 = _slicedToArray(_React$useState5, 2), spentTime = _React$useState6[0], setSpentTime = _React$useState6[1];
  var mergedHovering = forcedHovering || hovering;
  var mergedShowProgress = duration > 0 && showProgress;
  var onInternalClose = function onInternalClose2() {
    onNoticeClose(eventKey);
  };
  var onCloseKeyDown = function onCloseKeyDown2(e3) {
    if (e3.key === "Enter" || e3.code === "Enter" || e3.keyCode === KeyCode_default.ENTER) {
      onInternalClose();
    }
  };
  React50.useEffect(function() {
    if (!mergedHovering && duration > 0) {
      var start = Date.now() - spentTime;
      var timeout = setTimeout(function() {
        onInternalClose();
      }, duration * 1e3 - spentTime);
      return function() {
        if (pauseOnHover) {
          clearTimeout(timeout);
        }
        setSpentTime(Date.now() - start);
      };
    }
  }, [duration, mergedHovering, times]);
  React50.useEffect(function() {
    if (!mergedHovering && mergedShowProgress && (pauseOnHover || spentTime === 0)) {
      var start = performance.now();
      var animationFrame;
      var calculate3 = function calculate4() {
        cancelAnimationFrame(animationFrame);
        animationFrame = requestAnimationFrame(function(timestamp) {
          var runtime = timestamp + spentTime - start;
          var progress = Math.min(runtime / (duration * 1e3), 1);
          setPercent(progress * 100);
          if (progress < 1) {
            calculate4();
          }
        });
      };
      calculate3();
      return function() {
        if (pauseOnHover) {
          cancelAnimationFrame(animationFrame);
        }
      };
    }
  }, [duration, spentTime, mergedHovering, mergedShowProgress, times]);
  var closableObj = React50.useMemo(function() {
    if (_typeof(closable) === "object" && closable !== null) {
      return closable;
    }
    if (closable) {
      return {
        closeIcon
      };
    }
    return {};
  }, [closable, closeIcon]);
  var ariaProps = pickAttrs(closableObj, true);
  var validPercent = 100 - (!percent || percent < 0 ? 0 : percent > 100 ? 100 : percent);
  var noticePrefixCls = "".concat(prefixCls, "-notice");
  return /* @__PURE__ */ React50.createElement("div", _extends({}, divProps, {
    ref: ref3,
    className: (0, import_classnames3.default)(noticePrefixCls, className2, _defineProperty({}, "".concat(noticePrefixCls, "-closable"), closable)),
    style: style2,
    onMouseEnter: function onMouseEnter(e3) {
      var _divProps$onMouseEnte;
      setHovering(true);
      divProps === null || divProps === void 0 || (_divProps$onMouseEnte = divProps.onMouseEnter) === null || _divProps$onMouseEnte === void 0 || _divProps$onMouseEnte.call(divProps, e3);
    },
    onMouseLeave: function onMouseLeave(e3) {
      var _divProps$onMouseLeav;
      setHovering(false);
      divProps === null || divProps === void 0 || (_divProps$onMouseLeav = divProps.onMouseLeave) === null || _divProps$onMouseLeav === void 0 || _divProps$onMouseLeav.call(divProps, e3);
    },
    onClick
  }), /* @__PURE__ */ React50.createElement("div", {
    className: "".concat(noticePrefixCls, "-content")
  }, content), closable && /* @__PURE__ */ React50.createElement("a", _extends({
    tabIndex: 0,
    className: "".concat(noticePrefixCls, "-close"),
    onKeyDown: onCloseKeyDown,
    "aria-label": "Close"
  }, ariaProps, {
    onClick: function onClick2(e3) {
      e3.preventDefault();
      e3.stopPropagation();
      onInternalClose();
    }
  }), closableObj.closeIcon), mergedShowProgress && /* @__PURE__ */ React50.createElement("progress", {
    className: "".concat(noticePrefixCls, "-progress"),
    max: "100",
    value: validPercent
  }, validPercent + "%"));
});
var Notice_default = Notify;

// ../../node_modules/rc-notification/es/NotificationProvider.js
var import_react26 = __toESM(require_react());
var NotificationContext = /* @__PURE__ */ import_react26.default.createContext({});
var NotificationProvider = function NotificationProvider2(_ref) {
  var children = _ref.children, classNames186 = _ref.classNames;
  return /* @__PURE__ */ import_react26.default.createElement(NotificationContext.Provider, {
    value: {
      classNames: classNames186
    }
  }, children);
};
var NotificationProvider_default = NotificationProvider;

// ../../node_modules/rc-notification/es/hooks/useStack.js
var DEFAULT_OFFSET = 8;
var DEFAULT_THRESHOLD = 3;
var DEFAULT_GAP = 16;
var useStack = function useStack2(config) {
  var result = {
    offset: DEFAULT_OFFSET,
    threshold: DEFAULT_THRESHOLD,
    gap: DEFAULT_GAP
  };
  if (config && _typeof(config) === "object") {
    var _config$offset, _config$threshold, _config$gap;
    result.offset = (_config$offset = config.offset) !== null && _config$offset !== void 0 ? _config$offset : DEFAULT_OFFSET;
    result.threshold = (_config$threshold = config.threshold) !== null && _config$threshold !== void 0 ? _config$threshold : DEFAULT_THRESHOLD;
    result.gap = (_config$gap = config.gap) !== null && _config$gap !== void 0 ? _config$gap : DEFAULT_GAP;
  }
  return [!!config, result];
};
var useStack_default = useStack;

// ../../node_modules/rc-notification/es/NoticeList.js
var _excluded5 = ["className", "style", "classNames", "styles"];
var NoticeList = function NoticeList2(props) {
  var configList = props.configList, placement = props.placement, prefixCls = props.prefixCls, className2 = props.className, style2 = props.style, motion2 = props.motion, onAllNoticeRemoved = props.onAllNoticeRemoved, onNoticeClose = props.onNoticeClose, stackConfig = props.stack;
  var _useContext = (0, import_react27.useContext)(NotificationContext), ctxCls = _useContext.classNames;
  var dictRef = (0, import_react27.useRef)({});
  var _useState = (0, import_react27.useState)(null), _useState2 = _slicedToArray(_useState, 2), latestNotice = _useState2[0], setLatestNotice = _useState2[1];
  var _useState3 = (0, import_react27.useState)([]), _useState4 = _slicedToArray(_useState3, 2), hoverKeys = _useState4[0], setHoverKeys = _useState4[1];
  var keys4 = configList.map(function(config) {
    return {
      config,
      key: String(config.key)
    };
  });
  var _useStack = useStack_default(stackConfig), _useStack2 = _slicedToArray(_useStack, 2), stack = _useStack2[0], _useStack2$ = _useStack2[1], offset4 = _useStack2$.offset, threshold = _useStack2$.threshold, gap = _useStack2$.gap;
  var expanded = stack && (hoverKeys.length > 0 || keys4.length <= threshold);
  var placementMotion = typeof motion2 === "function" ? motion2(placement) : motion2;
  (0, import_react27.useEffect)(function() {
    if (stack && hoverKeys.length > 1) {
      setHoverKeys(function(prev2) {
        return prev2.filter(function(key2) {
          return keys4.some(function(_ref) {
            var dataKey = _ref.key;
            return key2 === dataKey;
          });
        });
      });
    }
  }, [hoverKeys, keys4, stack]);
  (0, import_react27.useEffect)(function() {
    var _keys;
    if (stack && dictRef.current[(_keys = keys4[keys4.length - 1]) === null || _keys === void 0 ? void 0 : _keys.key]) {
      var _keys2;
      setLatestNotice(dictRef.current[(_keys2 = keys4[keys4.length - 1]) === null || _keys2 === void 0 ? void 0 : _keys2.key]);
    }
  }, [keys4, stack]);
  return /* @__PURE__ */ import_react27.default.createElement(CSSMotionList_default, _extends({
    key: placement,
    className: (0, import_classnames4.default)(prefixCls, "".concat(prefixCls, "-").concat(placement), ctxCls === null || ctxCls === void 0 ? void 0 : ctxCls.list, className2, _defineProperty(_defineProperty({}, "".concat(prefixCls, "-stack"), !!stack), "".concat(prefixCls, "-stack-expanded"), expanded)),
    style: style2,
    keys: keys4,
    motionAppear: true
  }, placementMotion, {
    onAllRemoved: function onAllRemoved() {
      onAllNoticeRemoved(placement);
    }
  }), function(_ref2, nodeRef) {
    var config = _ref2.config, motionClassName = _ref2.className, motionStyle = _ref2.style, motionIndex = _ref2.index;
    var _ref3 = config, key2 = _ref3.key, times = _ref3.times;
    var strKey = String(key2);
    var _ref4 = config, configClassName = _ref4.className, configStyle = _ref4.style, configClassNames = _ref4.classNames, configStyles = _ref4.styles, restConfig = _objectWithoutProperties(_ref4, _excluded5);
    var dataIndex = keys4.findIndex(function(item) {
      return item.key === strKey;
    });
    var stackStyle = {};
    if (stack) {
      var index3 = keys4.length - 1 - (dataIndex > -1 ? dataIndex : motionIndex - 1);
      var transformX = placement === "top" || placement === "bottom" ? "-50%" : "0";
      if (index3 > 0) {
        var _dictRef$current$strK, _dictRef$current$strK2, _dictRef$current$strK3;
        stackStyle.height = expanded ? (_dictRef$current$strK = dictRef.current[strKey]) === null || _dictRef$current$strK === void 0 ? void 0 : _dictRef$current$strK.offsetHeight : latestNotice === null || latestNotice === void 0 ? void 0 : latestNotice.offsetHeight;
        var verticalOffset = 0;
        for (var i = 0; i < index3; i++) {
          var _dictRef$current$keys;
          verticalOffset += ((_dictRef$current$keys = dictRef.current[keys4[keys4.length - 1 - i].key]) === null || _dictRef$current$keys === void 0 ? void 0 : _dictRef$current$keys.offsetHeight) + gap;
        }
        var transformY = (expanded ? verticalOffset : index3 * offset4) * (placement.startsWith("top") ? 1 : -1);
        var scaleX = !expanded && latestNotice !== null && latestNotice !== void 0 && latestNotice.offsetWidth && (_dictRef$current$strK2 = dictRef.current[strKey]) !== null && _dictRef$current$strK2 !== void 0 && _dictRef$current$strK2.offsetWidth ? ((latestNotice === null || latestNotice === void 0 ? void 0 : latestNotice.offsetWidth) - offset4 * 2 * (index3 < 3 ? index3 : 3)) / ((_dictRef$current$strK3 = dictRef.current[strKey]) === null || _dictRef$current$strK3 === void 0 ? void 0 : _dictRef$current$strK3.offsetWidth) : 1;
        stackStyle.transform = "translate3d(".concat(transformX, ", ").concat(transformY, "px, 0) scaleX(").concat(scaleX, ")");
      } else {
        stackStyle.transform = "translate3d(".concat(transformX, ", 0, 0)");
      }
    }
    return /* @__PURE__ */ import_react27.default.createElement("div", {
      ref: nodeRef,
      className: (0, import_classnames4.default)("".concat(prefixCls, "-notice-wrapper"), motionClassName, configClassNames === null || configClassNames === void 0 ? void 0 : configClassNames.wrapper),
      style: _objectSpread2(_objectSpread2(_objectSpread2({}, motionStyle), stackStyle), configStyles === null || configStyles === void 0 ? void 0 : configStyles.wrapper),
      onMouseEnter: function onMouseEnter() {
        return setHoverKeys(function(prev2) {
          return prev2.includes(strKey) ? prev2 : [].concat(_toConsumableArray(prev2), [strKey]);
        });
      },
      onMouseLeave: function onMouseLeave() {
        return setHoverKeys(function(prev2) {
          return prev2.filter(function(k) {
            return k !== strKey;
          });
        });
      }
    }, /* @__PURE__ */ import_react27.default.createElement(Notice_default, _extends({}, restConfig, {
      ref: function ref3(node2) {
        if (dataIndex > -1) {
          dictRef.current[strKey] = node2;
        } else {
          delete dictRef.current[strKey];
        }
      },
      prefixCls,
      classNames: configClassNames,
      styles: configStyles,
      className: (0, import_classnames4.default)(configClassName, ctxCls === null || ctxCls === void 0 ? void 0 : ctxCls.notice),
      style: configStyle,
      times,
      key: key2,
      eventKey: key2,
      onNoticeClose,
      hovering: stack && hoverKeys.length > 0
    })));
  });
};
if (true) {
  NoticeList.displayName = "NoticeList";
}
var NoticeList_default = NoticeList;

// ../../node_modules/rc-notification/es/Notifications.js
var Notifications = /* @__PURE__ */ React53.forwardRef(function(props, ref3) {
  var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-notification" : _props$prefixCls, container = props.container, motion2 = props.motion, maxCount = props.maxCount, className2 = props.className, style2 = props.style, onAllRemoved = props.onAllRemoved, stack = props.stack, renderNotifications2 = props.renderNotifications;
  var _React$useState = React53.useState([]), _React$useState2 = _slicedToArray(_React$useState, 2), configList = _React$useState2[0], setConfigList = _React$useState2[1];
  var onNoticeClose = function onNoticeClose2(key2) {
    var _config$onClose;
    var config = configList.find(function(item) {
      return item.key === key2;
    });
    config === null || config === void 0 || (_config$onClose = config.onClose) === null || _config$onClose === void 0 || _config$onClose.call(config);
    setConfigList(function(list) {
      return list.filter(function(item) {
        return item.key !== key2;
      });
    });
  };
  React53.useImperativeHandle(ref3, function() {
    return {
      open: function open2(config) {
        setConfigList(function(list) {
          var clone = _toConsumableArray(list);
          var index3 = clone.findIndex(function(item) {
            return item.key === config.key;
          });
          var innerConfig = _objectSpread2({}, config);
          if (index3 >= 0) {
            var _list$index;
            innerConfig.times = (((_list$index = list[index3]) === null || _list$index === void 0 ? void 0 : _list$index.times) || 0) + 1;
            clone[index3] = innerConfig;
          } else {
            innerConfig.times = 0;
            clone.push(innerConfig);
          }
          if (maxCount > 0 && clone.length > maxCount) {
            clone = clone.slice(-maxCount);
          }
          return clone;
        });
      },
      close: function close(key2) {
        onNoticeClose(key2);
      },
      destroy: function destroy2() {
        setConfigList([]);
      }
    };
  });
  var _React$useState3 = React53.useState({}), _React$useState4 = _slicedToArray(_React$useState3, 2), placements4 = _React$useState4[0], setPlacements = _React$useState4[1];
  React53.useEffect(function() {
    var nextPlacements = {};
    configList.forEach(function(config) {
      var _config$placement = config.placement, placement = _config$placement === void 0 ? "topRight" : _config$placement;
      if (placement) {
        nextPlacements[placement] = nextPlacements[placement] || [];
        nextPlacements[placement].push(config);
      }
    });
    Object.keys(placements4).forEach(function(placement) {
      nextPlacements[placement] = nextPlacements[placement] || [];
    });
    setPlacements(nextPlacements);
  }, [configList]);
  var onAllNoticeRemoved = function onAllNoticeRemoved2(placement) {
    setPlacements(function(originPlacements) {
      var clone = _objectSpread2({}, originPlacements);
      var list = clone[placement] || [];
      if (!list.length) {
        delete clone[placement];
      }
      return clone;
    });
  };
  var emptyRef = React53.useRef(false);
  React53.useEffect(function() {
    if (Object.keys(placements4).length > 0) {
      emptyRef.current = true;
    } else if (emptyRef.current) {
      onAllRemoved === null || onAllRemoved === void 0 || onAllRemoved();
      emptyRef.current = false;
    }
  }, [placements4]);
  if (!container) {
    return null;
  }
  var placementList = Object.keys(placements4);
  return /* @__PURE__ */ (0, import_react_dom4.createPortal)(/* @__PURE__ */ React53.createElement(React53.Fragment, null, placementList.map(function(placement) {
    var placementConfigList = placements4[placement];
    var list = /* @__PURE__ */ React53.createElement(NoticeList_default, {
      key: placement,
      configList: placementConfigList,
      placement,
      prefixCls,
      className: className2 === null || className2 === void 0 ? void 0 : className2(placement),
      style: style2 === null || style2 === void 0 ? void 0 : style2(placement),
      motion: motion2,
      onNoticeClose,
      onAllNoticeRemoved,
      stack
    });
    return renderNotifications2 ? renderNotifications2(list, {
      prefixCls,
      key: placement
    }) : list;
  })), container);
});
if (true) {
  Notifications.displayName = "Notifications";
}
var Notifications_default = Notifications;

// ../../node_modules/rc-notification/es/hooks/useNotification.js
var _excluded6 = ["getContainer", "motion", "prefixCls", "maxCount", "className", "style", "onAllRemoved", "stack", "renderNotifications"];
var defaultGetContainer = function defaultGetContainer2() {
  return document.body;
};
var uniqueKey = 0;
function mergeConfig() {
  var clone = {};
  for (var _len = arguments.length, objList = new Array(_len), _key = 0; _key < _len; _key++) {
    objList[_key] = arguments[_key];
  }
  objList.forEach(function(obj) {
    if (obj) {
      Object.keys(obj).forEach(function(key2) {
        var val = obj[key2];
        if (val !== void 0) {
          clone[key2] = val;
        }
      });
    }
  });
  return clone;
}
function useNotification() {
  var rootConfig = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  var _rootConfig$getContai = rootConfig.getContainer, getContainer2 = _rootConfig$getContai === void 0 ? defaultGetContainer : _rootConfig$getContai, motion2 = rootConfig.motion, prefixCls = rootConfig.prefixCls, maxCount = rootConfig.maxCount, className2 = rootConfig.className, style2 = rootConfig.style, onAllRemoved = rootConfig.onAllRemoved, stack = rootConfig.stack, renderNotifications2 = rootConfig.renderNotifications, shareConfig = _objectWithoutProperties(rootConfig, _excluded6);
  var _React$useState = React54.useState(), _React$useState2 = _slicedToArray(_React$useState, 2), container = _React$useState2[0], setContainer = _React$useState2[1];
  var notificationsRef = React54.useRef();
  var contextHolder = /* @__PURE__ */ React54.createElement(Notifications_default, {
    container,
    ref: notificationsRef,
    prefixCls,
    motion: motion2,
    maxCount,
    className: className2,
    style: style2,
    onAllRemoved,
    stack,
    renderNotifications: renderNotifications2
  });
  var _React$useState3 = React54.useState([]), _React$useState4 = _slicedToArray(_React$useState3, 2), taskQueue2 = _React$useState4[0], setTaskQueue = _React$useState4[1];
  var open2 = useEvent2(function(config) {
    var mergedConfig = mergeConfig(shareConfig, config);
    if (mergedConfig.key === null || mergedConfig.key === void 0) {
      mergedConfig.key = "rc-notification-".concat(uniqueKey);
      uniqueKey += 1;
    }
    setTaskQueue(function(queue) {
      return [].concat(_toConsumableArray(queue), [{
        type: "open",
        config: mergedConfig
      }]);
    });
  });
  var api = React54.useMemo(function() {
    return {
      open: open2,
      close: function close(key2) {
        setTaskQueue(function(queue) {
          return [].concat(_toConsumableArray(queue), [{
            type: "close",
            key: key2
          }]);
        });
      },
      destroy: function destroy2() {
        setTaskQueue(function(queue) {
          return [].concat(_toConsumableArray(queue), [{
            type: "destroy"
          }]);
        });
      }
    };
  }, []);
  React54.useEffect(function() {
    setContainer(getContainer2());
  });
  React54.useEffect(function() {
    if (notificationsRef.current && taskQueue2.length) {
      taskQueue2.forEach(function(task) {
        switch (task.type) {
          case "open":
            notificationsRef.current.open(task.config);
            break;
          case "close":
            notificationsRef.current.close(task.key);
            break;
          case "destroy":
            notificationsRef.current.destroy();
            break;
        }
      });
      var oriTaskQueue;
      var tgtTaskQueue;
      setTaskQueue(function(oriQueue) {
        if (oriTaskQueue !== oriQueue || !tgtTaskQueue) {
          oriTaskQueue = oriQueue;
          tgtTaskQueue = oriQueue.filter(function(task) {
            return !taskQueue2.includes(task);
          });
        }
        return tgtTaskQueue;
      });
    }
  }, [taskQueue2]);
  return [api, contextHolder];
}

// ../../node_modules/antd/es/message/PurePanel.js
var React58 = __toESM(require_react());

// ../../node_modules/@ant-design/icons/es/icons/LoadingOutlined.js
var React55 = __toESM(require_react());

// ../../node_modules/@ant-design/icons-svg/es/asn/LoadingOutlined.js
var LoadingOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z" } }] }, "name": "loading", "theme": "outlined" };
var LoadingOutlined_default = LoadingOutlined;

// ../../node_modules/@ant-design/icons/es/icons/LoadingOutlined.js
var LoadingOutlined2 = function LoadingOutlined3(props, ref3) {
  return /* @__PURE__ */ React55.createElement(AntdIcon_default, _extends({}, props, {
    ref: ref3,
    icon: LoadingOutlined_default
  }));
};
var RefIcon6 = /* @__PURE__ */ React55.forwardRef(LoadingOutlined2);
if (true) {
  RefIcon6.displayName = "LoadingOutlined";
}
var LoadingOutlined_default2 = RefIcon6;

// ../../node_modules/antd/es/message/PurePanel.js
var import_classnames5 = __toESM(require_classnames());

// ../../node_modules/antd/es/_util/hooks/useZIndex.js
var import_react29 = __toESM(require_react());

// ../../node_modules/antd/es/_util/zindexContext.js
var import_react28 = __toESM(require_react());
var zIndexContext = /* @__PURE__ */ import_react28.default.createContext(void 0);
if (true) {
  zIndexContext.displayName = "zIndexContext";
}
var zindexContext_default = zIndexContext;

// ../../node_modules/antd/es/_util/hooks/useZIndex.js
var CONTAINER_OFFSET = 100;
var CONTAINER_OFFSET_MAX_COUNT = 10;
var CONTAINER_MAX_OFFSET = CONTAINER_OFFSET * CONTAINER_OFFSET_MAX_COUNT;
var CONTAINER_MAX_OFFSET_WITH_CHILDREN = CONTAINER_MAX_OFFSET + CONTAINER_OFFSET;
var containerBaseZIndexOffset = {
  Modal: CONTAINER_OFFSET,
  Drawer: CONTAINER_OFFSET,
  Popover: CONTAINER_OFFSET,
  Popconfirm: CONTAINER_OFFSET,
  Tooltip: CONTAINER_OFFSET,
  Tour: CONTAINER_OFFSET,
  FloatButton: CONTAINER_OFFSET
};
var consumerBaseZIndexOffset = {
  SelectLike: 50,
  Dropdown: 50,
  DatePicker: 50,
  Menu: 50,
  ImagePreview: 1
};
function isContainerType(type5) {
  return type5 in containerBaseZIndexOffset;
}
var useZIndex = (componentType, customZIndex) => {
  const [, token2] = useToken();
  const parentZIndex = import_react29.default.useContext(zindexContext_default);
  const isContainer = isContainerType(componentType);
  let result;
  if (customZIndex !== void 0) {
    result = [customZIndex, customZIndex];
  } else {
    let zIndex = parentZIndex !== null && parentZIndex !== void 0 ? parentZIndex : 0;
    if (isContainer) {
      zIndex += // Use preset token zIndex by default but not stack when has parent container
      (parentZIndex ? 0 : token2.zIndexPopupBase) + // Container offset
      containerBaseZIndexOffset[componentType];
    } else {
      zIndex += consumerBaseZIndexOffset[componentType];
    }
    result = [parentZIndex === void 0 ? customZIndex : zIndex, zIndex];
  }
  if (true) {
    const warning6 = devUseWarning(componentType);
    const maxZIndex = token2.zIndexPopupBase + CONTAINER_MAX_OFFSET_WITH_CHILDREN;
    const currentZIndex = result[0] || 0;
    true ? warning6(customZIndex !== void 0 || currentZIndex <= maxZIndex, "usage", "`zIndex` is over design token `zIndexPopupBase` too much. It may cause unexpected override.") : void 0;
  }
  return result;
};

// ../../node_modules/antd/es/message/style/index.js
var genMessageStyle = (token2) => {
  const {
    componentCls,
    iconCls,
    boxShadow,
    colorText,
    colorSuccess,
    colorError,
    colorWarning,
    colorInfo,
    fontSizeLG,
    motionEaseInOutCirc,
    motionDurationSlow,
    marginXS,
    paddingXS,
    borderRadiusLG,
    zIndexPopup,
    // Custom token
    contentPadding,
    contentBg
  } = token2;
  const noticeCls = `${componentCls}-notice`;
  const messageMoveIn = new Keyframes_default("MessageMoveIn", {
    "0%": {
      padding: 0,
      transform: "translateY(-100%)",
      opacity: 0
    },
    "100%": {
      padding: paddingXS,
      transform: "translateY(0)",
      opacity: 1
    }
  });
  const messageMoveOut = new Keyframes_default("MessageMoveOut", {
    "0%": {
      maxHeight: token2.height,
      padding: paddingXS,
      opacity: 1
    },
    "100%": {
      maxHeight: 0,
      padding: 0,
      opacity: 0
    }
  });
  const noticeStyle = {
    padding: paddingXS,
    textAlign: "center",
    [`${componentCls}-custom-content`]: {
      display: "flex",
      alignItems: "center"
    },
    [`${componentCls}-custom-content > ${iconCls}`]: {
      marginInlineEnd: marginXS,
      // affected by ltr or rtl
      fontSize: fontSizeLG
    },
    [`${noticeCls}-content`]: {
      display: "inline-block",
      padding: contentPadding,
      background: contentBg,
      borderRadius: borderRadiusLG,
      boxShadow,
      pointerEvents: "all"
    },
    [`${componentCls}-success > ${iconCls}`]: {
      color: colorSuccess
    },
    [`${componentCls}-error > ${iconCls}`]: {
      color: colorError
    },
    [`${componentCls}-warning > ${iconCls}`]: {
      color: colorWarning
    },
    [`${componentCls}-info > ${iconCls},
      ${componentCls}-loading > ${iconCls}`]: {
      color: colorInfo
    }
  };
  return [
    // ============================ Holder ============================
    {
      [componentCls]: Object.assign(Object.assign({}, resetComponent(token2)), {
        color: colorText,
        position: "fixed",
        top: marginXS,
        width: "100%",
        pointerEvents: "none",
        zIndex: zIndexPopup,
        [`${componentCls}-move-up`]: {
          animationFillMode: "forwards"
        },
        [`
        ${componentCls}-move-up-appear,
        ${componentCls}-move-up-enter
      `]: {
          animationName: messageMoveIn,
          animationDuration: motionDurationSlow,
          animationPlayState: "paused",
          animationTimingFunction: motionEaseInOutCirc
        },
        [`
        ${componentCls}-move-up-appear${componentCls}-move-up-appear-active,
        ${componentCls}-move-up-enter${componentCls}-move-up-enter-active
      `]: {
          animationPlayState: "running"
        },
        [`${componentCls}-move-up-leave`]: {
          animationName: messageMoveOut,
          animationDuration: motionDurationSlow,
          animationPlayState: "paused",
          animationTimingFunction: motionEaseInOutCirc
        },
        [`${componentCls}-move-up-leave${componentCls}-move-up-leave-active`]: {
          animationPlayState: "running"
        },
        "&-rtl": {
          direction: "rtl",
          span: {
            direction: "rtl"
          }
        }
      })
    },
    // ============================ Notice ============================
    {
      [componentCls]: {
        [`${noticeCls}-wrapper`]: Object.assign({}, noticeStyle)
      }
    },
    // ============================= Pure =============================
    {
      [`${componentCls}-notice-pure-panel`]: Object.assign(Object.assign({}, noticeStyle), {
        padding: 0,
        textAlign: "start"
      })
    }
  ];
};
var prepareComponentToken = (token2) => ({
  zIndexPopup: token2.zIndexPopupBase + CONTAINER_MAX_OFFSET + 10,
  contentBg: token2.colorBgElevated,
  contentPadding: `${(token2.controlHeightLG - token2.fontSize * token2.lineHeight) / 2}px ${token2.paddingSM}px`
});
var style_default = genStyleHooks("Message", (token2) => {
  const combinedToken = merge2(token2, {
    height: 150
  });
  return genMessageStyle(combinedToken);
}, prepareComponentToken);

// ../../node_modules/antd/es/message/PurePanel.js
var __rest5 = function(s, e3) {
  var t2 = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e3.indexOf(p) < 0) t2[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e3.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t2[p[i]] = s[p[i]];
  }
  return t2;
};
var TypeIcon = {
  info: /* @__PURE__ */ React58.createElement(InfoCircleFilled_default2, null),
  success: /* @__PURE__ */ React58.createElement(CheckCircleFilled_default2, null),
  error: /* @__PURE__ */ React58.createElement(CloseCircleFilled_default2, null),
  warning: /* @__PURE__ */ React58.createElement(ExclamationCircleFilled_default2, null),
  loading: /* @__PURE__ */ React58.createElement(LoadingOutlined_default2, null)
};
var PureContent = ({
  prefixCls,
  type: type5,
  icon,
  children
}) => /* @__PURE__ */ React58.createElement("div", {
  className: (0, import_classnames5.default)(`${prefixCls}-custom-content`, `${prefixCls}-${type5}`)
}, icon || TypeIcon[type5], /* @__PURE__ */ React58.createElement("span", null, children));
var PurePanel = (props) => {
  const {
    prefixCls: staticPrefixCls,
    className: className2,
    type: type5,
    icon,
    content
  } = props, restProps = __rest5(props, ["prefixCls", "className", "type", "icon", "content"]);
  const {
    getPrefixCls
  } = React58.useContext(ConfigContext);
  const prefixCls = staticPrefixCls || getPrefixCls("message");
  const rootCls = useCSSVarCls_default(prefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = style_default(prefixCls, rootCls);
  return wrapCSSVar(/* @__PURE__ */ React58.createElement(Notice_default, Object.assign({}, restProps, {
    prefixCls,
    className: (0, import_classnames5.default)(className2, hashId, `${prefixCls}-notice-pure-panel`, cssVarCls, rootCls),
    eventKey: "pure",
    duration: null,
    content: /* @__PURE__ */ React58.createElement(PureContent, {
      prefixCls,
      type: type5,
      icon
    }, content)
  })));
};
var PurePanel_default = PurePanel;

// ../../node_modules/antd/es/message/util.js
function getMotion(prefixCls, transitionName) {
  return {
    motionName: transitionName !== null && transitionName !== void 0 ? transitionName : `${prefixCls}-move-up`
  };
}
function wrapPromiseFn(openFn) {
  let closeFn;
  const closePromise = new Promise((resolve) => {
    closeFn = openFn(() => {
      resolve(true);
    });
  });
  const result = () => {
    closeFn === null || closeFn === void 0 ? void 0 : closeFn();
  };
  result.then = (filled, rejected) => closePromise.then(filled, rejected);
  result.promise = closePromise;
  return result;
}

// ../../node_modules/antd/es/message/useMessage.js
var __rest6 = function(s, e3) {
  var t2 = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e3.indexOf(p) < 0) t2[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e3.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t2[p[i]] = s[p[i]];
  }
  return t2;
};
var DEFAULT_OFFSET2 = 8;
var DEFAULT_DURATION = 3;
var Wrapper = ({
  children,
  prefixCls
}) => {
  const rootCls = useCSSVarCls_default(prefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = style_default(prefixCls, rootCls);
  return wrapCSSVar(/* @__PURE__ */ React59.createElement(NotificationProvider_default, {
    classNames: {
      list: (0, import_classnames6.default)(hashId, cssVarCls, rootCls)
    }
  }, children));
};
var renderNotifications = (node2, {
  prefixCls,
  key: key2
}) => /* @__PURE__ */ React59.createElement(Wrapper, {
  prefixCls,
  key: key2
}, node2);
var Holder = /* @__PURE__ */ React59.forwardRef((props, ref3) => {
  const {
    top,
    prefixCls: staticPrefixCls,
    getContainer: staticGetContainer,
    maxCount,
    duration = DEFAULT_DURATION,
    rtl,
    transitionName,
    onAllRemoved
  } = props;
  const {
    getPrefixCls,
    getPopupContainer,
    message: message2,
    direction
  } = React59.useContext(ConfigContext);
  const prefixCls = staticPrefixCls || getPrefixCls("message");
  const getStyle4 = () => ({
    left: "50%",
    transform: "translateX(-50%)",
    top: top !== null && top !== void 0 ? top : DEFAULT_OFFSET2
  });
  const getClassName = () => (0, import_classnames6.default)({
    [`${prefixCls}-rtl`]: rtl !== null && rtl !== void 0 ? rtl : direction === "rtl"
  });
  const getNotificationMotion = () => getMotion(prefixCls, transitionName);
  const mergedCloseIcon = /* @__PURE__ */ React59.createElement("span", {
    className: `${prefixCls}-close-x`
  }, /* @__PURE__ */ React59.createElement(CloseOutlined_default2, {
    className: `${prefixCls}-close-icon`
  }));
  const [api, holder] = useNotification({
    prefixCls,
    style: getStyle4,
    className: getClassName,
    motion: getNotificationMotion,
    closable: false,
    closeIcon: mergedCloseIcon,
    duration,
    getContainer: () => (staticGetContainer === null || staticGetContainer === void 0 ? void 0 : staticGetContainer()) || (getPopupContainer === null || getPopupContainer === void 0 ? void 0 : getPopupContainer()) || document.body,
    maxCount,
    onAllRemoved,
    renderNotifications
  });
  React59.useImperativeHandle(ref3, () => Object.assign(Object.assign({}, api), {
    prefixCls,
    message: message2
  }));
  return holder;
});
var keyIndex = 0;
function useInternalMessage(messageConfig) {
  const holderRef = React59.useRef(null);
  const warning6 = devUseWarning("Message");
  const wrapAPI = React59.useMemo(() => {
    const close = (key2) => {
      var _a;
      (_a = holderRef.current) === null || _a === void 0 ? void 0 : _a.close(key2);
    };
    const open2 = (config) => {
      if (!holderRef.current) {
        true ? warning6(false, "usage", "You are calling notice in render which will break in React 18 concurrent mode. Please trigger in effect instead.") : void 0;
        const fakeResult = () => {
        };
        fakeResult.then = () => {
        };
        return fakeResult;
      }
      const {
        open: originOpen,
        prefixCls,
        message: message2
      } = holderRef.current;
      const noticePrefixCls = `${prefixCls}-notice`;
      const {
        content,
        icon,
        type: type5,
        key: key2,
        className: className2,
        style: style2,
        onClose
      } = config, restConfig = __rest6(config, ["content", "icon", "type", "key", "className", "style", "onClose"]);
      let mergedKey = key2;
      if (mergedKey === void 0 || mergedKey === null) {
        keyIndex += 1;
        mergedKey = `antd-message-${keyIndex}`;
      }
      return wrapPromiseFn((resolve) => {
        originOpen(Object.assign(Object.assign({}, restConfig), {
          key: mergedKey,
          content: /* @__PURE__ */ React59.createElement(PureContent, {
            prefixCls,
            type: type5,
            icon
          }, content),
          placement: "top",
          className: (0, import_classnames6.default)(type5 && `${noticePrefixCls}-${type5}`, className2, message2 === null || message2 === void 0 ? void 0 : message2.className),
          style: Object.assign(Object.assign({}, message2 === null || message2 === void 0 ? void 0 : message2.style), style2),
          onClose: () => {
            onClose === null || onClose === void 0 ? void 0 : onClose();
            resolve();
          }
        }));
        return () => {
          close(mergedKey);
        };
      });
    };
    const destroy2 = (key2) => {
      var _a;
      if (key2 !== void 0) {
        close(key2);
      } else {
        (_a = holderRef.current) === null || _a === void 0 ? void 0 : _a.destroy();
      }
    };
    const clone = {
      open: open2,
      destroy: destroy2
    };
    const keys4 = ["info", "success", "warning", "error", "loading"];
    keys4.forEach((type5) => {
      const typeOpen2 = (jointContent, duration, onClose) => {
        let config;
        if (jointContent && typeof jointContent === "object" && "content" in jointContent) {
          config = jointContent;
        } else {
          config = {
            content: jointContent
          };
        }
        let mergedDuration;
        let mergedOnClose;
        if (typeof duration === "function") {
          mergedOnClose = duration;
        } else {
          mergedDuration = duration;
          mergedOnClose = onClose;
        }
        const mergedConfig = Object.assign(Object.assign({
          onClose: mergedOnClose,
          duration: mergedDuration
        }, config), {
          type: type5
        });
        return open2(mergedConfig);
      };
      clone[type5] = typeOpen2;
    });
    return clone;
  }, []);
  return [wrapAPI, /* @__PURE__ */ React59.createElement(Holder, Object.assign({
    key: "message-holder"
  }, messageConfig, {
    ref: holderRef
  }))];
}
function useMessage(messageConfig) {
  return useInternalMessage(messageConfig);
}

// ../../node_modules/antd/es/config-provider/UnstableContext.js
var React60 = __toESM(require_react());
var ReactDOM4 = __toESM(require_react_dom());

// ../../node_modules/@babel/runtime/helpers/esm/OverloadYield.js
function _OverloadYield(e3, d) {
  this.v = e3, this.k = d;
}

// ../../node_modules/@babel/runtime/helpers/esm/regeneratorDefine.js
function _regeneratorDefine(e3, r2, n2, t2) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e4) {
    i = 0;
  }
  _regeneratorDefine = function regeneratorDefine(e4, r3, n3, t3) {
    function o3(r4, n4) {
      _regeneratorDefine(e4, r4, function(e5) {
        return this._invoke(r4, n4, e5);
      });
    }
    r3 ? i ? i(e4, r3, {
      value: n3,
      enumerable: !t3,
      configurable: !t3,
      writable: !t3
    }) : e4[r3] = n3 : (o3("next", 0), o3("throw", 1), o3("return", 2));
  }, _regeneratorDefine(e3, r2, n2, t2);
}

// ../../node_modules/@babel/runtime/helpers/esm/regenerator.js
function _regenerator() {
  var e3, t2, r2 = "function" == typeof Symbol ? Symbol : {}, n2 = r2.iterator || "@@iterator", o3 = r2.toStringTag || "@@toStringTag";
  function i(r3, n3, o4, i2) {
    var c2 = n3 && n3.prototype instanceof Generator ? n3 : Generator, u2 = Object.create(c2.prototype);
    return _regeneratorDefine(u2, "_invoke", (function(r4, n4, o5) {
      var i3, c3, u3, f2 = 0, p = o5 || [], y = false, G = {
        p: 0,
        n: 0,
        v: e3,
        a: d,
        f: d.bind(e3, 4),
        d: function d2(t3, r5) {
          return i3 = t3, c3 = 0, u3 = e3, G.n = r5, a;
        }
      };
      function d(r5, n5) {
        for (c3 = r5, u3 = n5, t2 = 0; !y && f2 && !o6 && t2 < p.length; t2++) {
          var o6, i4 = p[t2], d2 = G.p, l2 = i4[2];
          r5 > 3 ? (o6 = l2 === n5) && (u3 = i4[(c3 = i4[4]) ? 5 : (c3 = 3, 3)], i4[4] = i4[5] = e3) : i4[0] <= d2 && ((o6 = r5 < 2 && d2 < i4[1]) ? (c3 = 0, G.v = n5, G.n = i4[1]) : d2 < l2 && (o6 = r5 < 3 || i4[0] > n5 || n5 > l2) && (i4[4] = r5, i4[5] = n5, G.n = l2, c3 = 0));
        }
        if (o6 || r5 > 1) return a;
        throw y = true, n5;
      }
      return function(o6, p2, l2) {
        if (f2 > 1) throw TypeError("Generator is already running");
        for (y && 1 === p2 && d(p2, l2), c3 = p2, u3 = l2; (t2 = c3 < 2 ? e3 : u3) || !y; ) {
          i3 || (c3 ? c3 < 3 ? (c3 > 1 && (G.n = -1), d(c3, u3)) : G.n = u3 : G.v = u3);
          try {
            if (f2 = 2, i3) {
              if (c3 || (o6 = "next"), t2 = i3[o6]) {
                if (!(t2 = t2.call(i3, u3))) throw TypeError("iterator result is not an object");
                if (!t2.done) return t2;
                u3 = t2.value, c3 < 2 && (c3 = 0);
              } else 1 === c3 && (t2 = i3["return"]) && t2.call(i3), c3 < 2 && (u3 = TypeError("The iterator does not provide a '" + o6 + "' method"), c3 = 1);
              i3 = e3;
            } else if ((t2 = (y = G.n < 0) ? u3 : r4.call(n4, G)) !== a) break;
          } catch (t3) {
            i3 = e3, c3 = 1, u3 = t3;
          } finally {
            f2 = 1;
          }
        }
        return {
          value: t2,
          done: y
        };
      };
    })(r3, o4, i2), true), u2;
  }
  var a = {};
  function Generator() {
  }
  function GeneratorFunction() {
  }
  function GeneratorFunctionPrototype() {
  }
  t2 = Object.getPrototypeOf;
  var c = [][n2] ? t2(t2([][n2]())) : (_regeneratorDefine(t2 = {}, n2, function() {
    return this;
  }), t2), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e4) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e4, GeneratorFunctionPrototype) : (e4.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine(e4, o3, "GeneratorFunction")), e4.prototype = Object.create(u), e4;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine(GeneratorFunctionPrototype, o3, "GeneratorFunction"), _regeneratorDefine(u), _regeneratorDefine(u, o3, "Generator"), _regeneratorDefine(u, n2, function() {
    return this;
  }), _regeneratorDefine(u, "toString", function() {
    return "[object Generator]";
  }), (_regenerator = function _regenerator2() {
    return {
      w: i,
      m: f
    };
  })();
}

// ../../node_modules/@babel/runtime/helpers/esm/regeneratorAsyncIterator.js
function AsyncIterator2(t2, e3) {
  function n2(r3, o3, i, f) {
    try {
      var c = t2[r3](o3), u = c.value;
      return u instanceof _OverloadYield ? e3.resolve(u.v).then(function(t3) {
        n2("next", t3, i, f);
      }, function(t3) {
        n2("throw", t3, i, f);
      }) : e3.resolve(u).then(function(t3) {
        c.value = t3, i(c);
      }, function(t3) {
        return n2("throw", t3, i, f);
      });
    } catch (t3) {
      f(t3);
    }
  }
  var r2;
  this.next || (_regeneratorDefine(AsyncIterator2.prototype), _regeneratorDefine(AsyncIterator2.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function() {
    return this;
  })), _regeneratorDefine(this, "_invoke", function(t3, o3, i) {
    function f() {
      return new e3(function(e4, r3) {
        n2(t3, i, e4, r3);
      });
    }
    return r2 = r2 ? r2.then(f, f) : f();
  }, true);
}

// ../../node_modules/@babel/runtime/helpers/esm/regeneratorAsyncGen.js
function _regeneratorAsyncGen(r2, e3, t2, o3, n2) {
  return new AsyncIterator2(_regenerator().w(r2, e3, t2, o3), n2 || Promise);
}

// ../../node_modules/@babel/runtime/helpers/esm/regeneratorAsync.js
function _regeneratorAsync(n2, e3, r2, t2, o3) {
  var a = _regeneratorAsyncGen(n2, e3, r2, t2, o3);
  return a.next().then(function(n3) {
    return n3.done ? n3.value : a.next();
  });
}

// ../../node_modules/@babel/runtime/helpers/esm/regeneratorKeys.js
function _regeneratorKeys(e3) {
  var n2 = Object(e3), r2 = [];
  for (var t2 in n2) r2.unshift(t2);
  return function e4() {
    for (; r2.length; ) if ((t2 = r2.pop()) in n2) return e4.value = t2, e4.done = false, e4;
    return e4.done = true, e4;
  };
}

// ../../node_modules/@babel/runtime/helpers/esm/regeneratorValues.js
function _regeneratorValues(e3) {
  if (null != e3) {
    var t2 = e3["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r2 = 0;
    if (t2) return t2.call(e3);
    if ("function" == typeof e3.next) return e3;
    if (!isNaN(e3.length)) return {
      next: function next2() {
        return e3 && r2 >= e3.length && (e3 = void 0), {
          value: e3 && e3[r2++],
          done: !e3
        };
      }
    };
  }
  throw new TypeError(_typeof(e3) + " is not iterable");
}

// ../../node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js
function _regeneratorRuntime() {
  "use strict";
  var r2 = _regenerator(), e3 = r2.m(_regeneratorRuntime), t2 = (Object.getPrototypeOf ? Object.getPrototypeOf(e3) : e3.__proto__).constructor;
  function n2(r3) {
    var e4 = "function" == typeof r3 && r3.constructor;
    return !!e4 && (e4 === t2 || "GeneratorFunction" === (e4.displayName || e4.name));
  }
  var o3 = {
    "throw": 1,
    "return": 2,
    "break": 3,
    "continue": 3
  };
  function a(r3) {
    var e4, t3;
    return function(n3) {
      e4 || (e4 = {
        stop: function stop() {
          return t3(n3.a, 2);
        },
        "catch": function _catch() {
          return n3.v;
        },
        abrupt: function abrupt(r4, e5) {
          return t3(n3.a, o3[r4], e5);
        },
        delegateYield: function delegateYield(r4, o4, a2) {
          return e4.resultName = o4, t3(n3.d, _regeneratorValues(r4), a2);
        },
        finish: function finish(r4) {
          return t3(n3.f, r4);
        }
      }, t3 = function t4(r4, _t, o4) {
        n3.p = e4.prev, n3.n = e4.next;
        try {
          return r4(_t, o4);
        } finally {
          e4.next = n3.n;
        }
      }), e4.resultName && (e4[e4.resultName] = n3.v, e4.resultName = void 0), e4.sent = n3.v, e4.next = n3.n;
      try {
        return r3.call(this, e4);
      } finally {
        n3.p = e4.prev, n3.n = e4.next;
      }
    };
  }
  return (_regeneratorRuntime = function _regeneratorRuntime6() {
    return {
      wrap: function wrap(e4, t3, n3, o4) {
        return r2.w(a(e4), t3, n3, o4 && o4.reverse());
      },
      isGeneratorFunction: n2,
      mark: r2.m,
      awrap: function awrap(r3, e4) {
        return new _OverloadYield(r3, e4);
      },
      AsyncIterator: AsyncIterator2,
      async: function async(r3, e4, t3, o4, u) {
        return (n2(e4) ? _regeneratorAsyncGen : _regeneratorAsync)(a(r3), e4, t3, o4, u);
      },
      keys: _regeneratorKeys,
      values: _regeneratorValues
    };
  })();
}

// ../../node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
function asyncGeneratorStep(n2, t2, e3, r2, o3, a, c) {
  try {
    var i = n2[a](c), u = i.value;
  } catch (n3) {
    return void e3(n3);
  }
  i.done ? t2(u) : Promise.resolve(u).then(r2, o3);
}
function _asyncToGenerator(n2) {
  return function() {
    var t2 = this, e3 = arguments;
    return new Promise(function(r2, o3) {
      var a = n2.apply(t2, e3);
      function _next(n3) {
        asyncGeneratorStep(a, r2, o3, _next, _throw, "next", n3);
      }
      function _throw(n3) {
        asyncGeneratorStep(a, r2, o3, _next, _throw, "throw", n3);
      }
      _next(void 0);
    });
  };
}

// ../../node_modules/rc-util/es/React/render.js
var ReactDOM3 = __toESM(require_react_dom());
var fullClone4 = _objectSpread2({}, ReactDOM3);
var version4 = fullClone4.version;
var reactRender = fullClone4.render;
var unmountComponentAtNode = fullClone4.unmountComponentAtNode;
var createRoot;
try {
  mainVersion = Number((version4 || "").split(".")[0]);
  if (mainVersion >= 18) {
    createRoot = fullClone4.createRoot;
  }
} catch (e3) {
}
var mainVersion;
function toggleWarning(skip) {
  var __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = fullClone4.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
  if (__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED && _typeof(__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === "object") {
    __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.usingClientEntryPoint = skip;
  }
}
var MARK = "__rc_react_root__";
function modernRender(node2, container) {
  toggleWarning(true);
  var root2 = container[MARK] || createRoot(container);
  toggleWarning(false);
  root2.render(node2);
  container[MARK] = root2;
}
function legacyRender(node2, container) {
  reactRender === null || reactRender === void 0 || reactRender(node2, container);
}
function render(node2, container) {
  if (createRoot) {
    modernRender(node2, container);
    return;
  }
  legacyRender(node2, container);
}
function modernUnmount(_x) {
  return _modernUnmount.apply(this, arguments);
}
function _modernUnmount() {
  _modernUnmount = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee(container) {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", Promise.resolve().then(function() {
            var _container$MARK;
            (_container$MARK = container[MARK]) === null || _container$MARK === void 0 || _container$MARK.unmount();
            delete container[MARK];
          }));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _modernUnmount.apply(this, arguments);
}
function legacyUnmount(container) {
  unmountComponentAtNode(container);
}
function unmount(_x2) {
  return _unmount.apply(this, arguments);
}
function _unmount() {
  _unmount = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee2(container) {
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (!(createRoot !== void 0)) {
            _context2.next = 2;
            break;
          }
          return _context2.abrupt("return", modernUnmount(container));
        case 2:
          legacyUnmount(container);
        case 3:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _unmount.apply(this, arguments);
}

// ../../node_modules/antd/es/config-provider/UnstableContext.js
var defaultReactRender = (node2, container) => {
  if (true) {
    const majorVersion = parseInt(React60.version.split(".")[0], 10);
    const fullKeys = Object.keys(ReactDOM4);
    true ? warning_default2(majorVersion < 19 || fullKeys.includes("createRoot"), "compatible", "antd v5 support React is 16 ~ 18. see https://u.ant.design/v5-for-19 for compatible.") : void 0;
  }
  render(node2, container);
  return () => {
    return unmount(container);
  };
};
var unstableRender = defaultReactRender;
function unstableSetRender(render4) {
  if (render4) {
    unstableRender = render4;
  }
  return unstableRender;
}

// ../../node_modules/antd/es/_util/motion.js
var getCollapsedHeight = () => ({
  height: 0,
  opacity: 0
});
var getRealHeight = (node2) => {
  const {
    scrollHeight
  } = node2;
  return {
    height: scrollHeight,
    opacity: 1
  };
};
var getCurrentHeight = (node2) => ({
  height: node2 ? node2.offsetHeight : 0
});
var skipOpacityTransition = (_, event) => (event === null || event === void 0 ? void 0 : event.deadline) === true || event.propertyName === "height";
var initCollapseMotion = (rootCls = defaultPrefixCls) => ({
  motionName: `${rootCls}-motion-collapse`,
  onAppearStart: getCollapsedHeight,
  onEnterStart: getCollapsedHeight,
  onAppearActive: getRealHeight,
  onEnterActive: getRealHeight,
  onLeaveStart: getCurrentHeight,
  onLeaveActive: getCollapsedHeight,
  onAppearEnd: skipOpacityTransition,
  onEnterEnd: skipOpacityTransition,
  onLeaveEnd: skipOpacityTransition,
  motionDeadline: 500
});
var getTransitionName2 = (rootPrefixCls, motion2, transitionName) => {
  if (transitionName !== void 0) {
    return transitionName;
  }
  return `${rootPrefixCls}-${motion2}`;
};
var motion_default = initCollapseMotion;

// ../../node_modules/antd/es/_util/ActionButton.js
var React88 = __toESM(require_react());

// ../../node_modules/antd/es/button/button.js
var import_react50 = __toESM(require_react());
var import_classnames23 = __toESM(require_classnames());

// ../../node_modules/rc-util/es/omit.js
function omit(obj, fields) {
  var clone = Object.assign({}, obj);
  if (Array.isArray(fields)) {
    fields.forEach(function(key2) {
      delete clone[key2];
    });
  }
  return clone;
}

// ../../node_modules/antd/es/_util/wave/index.js
var import_react30 = __toESM(require_react());
var import_classnames8 = __toESM(require_classnames());

// ../../node_modules/rc-util/es/Dom/isVisible.js
var isVisible_default = (function(element) {
  if (!element) {
    return false;
  }
  if (element instanceof Element) {
    if (element.offsetParent) {
      return true;
    }
    if (element.getBBox) {
      var _getBBox = element.getBBox(), width = _getBBox.width, height = _getBBox.height;
      if (width || height) {
        return true;
      }
    }
    if (element.getBoundingClientRect) {
      var _element$getBoundingC = element.getBoundingClientRect(), _width = _element$getBoundingC.width, _height = _element$getBoundingC.height;
      if (_width || _height) {
        return true;
      }
    }
  }
  return false;
});

// ../../node_modules/antd/es/_util/wave/style.js
var genWaveStyle = (token2) => {
  const {
    componentCls,
    colorPrimary
  } = token2;
  return {
    [componentCls]: {
      position: "absolute",
      background: "transparent",
      pointerEvents: "none",
      boxSizing: "border-box",
      color: `var(--wave-color, ${colorPrimary})`,
      boxShadow: `0 0 0 0 currentcolor`,
      opacity: 0.2,
      // =================== Motion ===================
      "&.wave-motion-appear": {
        transition: [`box-shadow 0.4s ${token2.motionEaseOutCirc}`, `opacity 2s ${token2.motionEaseOutCirc}`].join(","),
        "&-active": {
          boxShadow: `0 0 0 6px currentcolor`,
          opacity: 0
        },
        "&.wave-quick": {
          transition: [`box-shadow ${token2.motionDurationSlow} ${token2.motionEaseInOut}`, `opacity ${token2.motionDurationSlow} ${token2.motionEaseInOut}`].join(",")
        }
      }
    }
  };
};
var style_default2 = genComponentStyleHook("Wave", genWaveStyle);

// ../../node_modules/antd/es/_util/wave/useWave.js
var React62 = __toESM(require_react());

// ../../node_modules/antd/es/_util/wave/interface.js
var TARGET_CLS = `${defaultPrefixCls}-wave-target`;

// ../../node_modules/antd/es/_util/wave/WaveEffect.js
var React61 = __toESM(require_react());
var import_classnames7 = __toESM(require_classnames());

// ../../node_modules/antd/es/_util/wave/util.js
function isValidWaveColor(color) {
  return color && color !== "#fff" && color !== "#ffffff" && color !== "rgb(255, 255, 255)" && color !== "rgba(255, 255, 255, 1)" && !/rgba\((?:\d*, ){3}0\)/.test(color) && // any transparent rgba color
  color !== "transparent" && color !== "canvastext";
}
function getTargetWaveColor(node2) {
  var _a;
  const {
    borderTopColor,
    borderColor,
    backgroundColor
  } = getComputedStyle(node2);
  return (_a = [borderTopColor, borderColor, backgroundColor].find(isValidWaveColor)) !== null && _a !== void 0 ? _a : null;
}

// ../../node_modules/antd/es/_util/wave/WaveEffect.js
function validateNum(value) {
  return Number.isNaN(value) ? 0 : value;
}
var WaveEffect = (props) => {
  const {
    className: className2,
    target,
    component,
    registerUnmount
  } = props;
  const divRef = React61.useRef(null);
  const unmountRef = React61.useRef(null);
  React61.useEffect(() => {
    unmountRef.current = registerUnmount();
  }, []);
  const [color, setWaveColor] = React61.useState(null);
  const [borderRadius, setBorderRadius] = React61.useState([]);
  const [left2, setLeft] = React61.useState(0);
  const [top, setTop] = React61.useState(0);
  const [width, setWidth] = React61.useState(0);
  const [height, setHeight] = React61.useState(0);
  const [enabled, setEnabled] = React61.useState(false);
  const waveStyle = {
    left: left2,
    top,
    width,
    height,
    borderRadius: borderRadius.map((radius2) => `${radius2}px`).join(" ")
  };
  if (color) {
    waveStyle["--wave-color"] = color;
  }
  function syncPos() {
    const nodeStyle = getComputedStyle(target);
    setWaveColor(getTargetWaveColor(target));
    const isStatic = nodeStyle.position === "static";
    const {
      borderLeftWidth,
      borderTopWidth
    } = nodeStyle;
    setLeft(isStatic ? target.offsetLeft : validateNum(-parseFloat(borderLeftWidth)));
    setTop(isStatic ? target.offsetTop : validateNum(-parseFloat(borderTopWidth)));
    setWidth(target.offsetWidth);
    setHeight(target.offsetHeight);
    const {
      borderTopLeftRadius,
      borderTopRightRadius,
      borderBottomLeftRadius,
      borderBottomRightRadius
    } = nodeStyle;
    setBorderRadius([borderTopLeftRadius, borderTopRightRadius, borderBottomRightRadius, borderBottomLeftRadius].map((radius2) => validateNum(parseFloat(radius2))));
  }
  React61.useEffect(() => {
    if (target) {
      const id = raf_default(() => {
        syncPos();
        setEnabled(true);
      });
      let resizeObserver2;
      if (typeof ResizeObserver !== "undefined") {
        resizeObserver2 = new ResizeObserver(syncPos);
        resizeObserver2.observe(target);
      }
      return () => {
        raf_default.cancel(id);
        resizeObserver2 === null || resizeObserver2 === void 0 ? void 0 : resizeObserver2.disconnect();
      };
    }
  }, []);
  if (!enabled) {
    return null;
  }
  const isSmallComponent = (component === "Checkbox" || component === "Radio") && (target === null || target === void 0 ? void 0 : target.classList.contains(TARGET_CLS));
  return /* @__PURE__ */ React61.createElement(es_default2, {
    visible: true,
    motionAppear: true,
    motionName: "wave-motion",
    motionDeadline: 5e3,
    onAppearEnd: (_, event) => {
      var _a, _b;
      if (event.deadline || event.propertyName === "opacity") {
        const holder = (_a = divRef.current) === null || _a === void 0 ? void 0 : _a.parentElement;
        (_b = unmountRef.current) === null || _b === void 0 ? void 0 : _b.call(unmountRef).then(() => {
          holder === null || holder === void 0 ? void 0 : holder.remove();
        });
      }
      return false;
    }
  }, ({
    className: motionClassName
  }, ref3) => /* @__PURE__ */ React61.createElement("div", {
    ref: composeRef(divRef, ref3),
    className: (0, import_classnames7.default)(className2, motionClassName, {
      "wave-quick": isSmallComponent
    }),
    style: waveStyle
  }));
};
var showWaveEffect = (target, info) => {
  var _a;
  const {
    component
  } = info;
  if (component === "Checkbox" && !((_a = target.querySelector("input")) === null || _a === void 0 ? void 0 : _a.checked)) {
    return;
  }
  const holder = document.createElement("div");
  holder.style.position = "absolute";
  holder.style.left = "0px";
  holder.style.top = "0px";
  target === null || target === void 0 ? void 0 : target.insertBefore(holder, target === null || target === void 0 ? void 0 : target.firstChild);
  const reactRender2 = unstableSetRender();
  let unmountCallback = null;
  function registerUnmount() {
    return unmountCallback;
  }
  unmountCallback = reactRender2(/* @__PURE__ */ React61.createElement(WaveEffect, Object.assign({}, info, {
    target,
    registerUnmount
  })), holder);
};
var WaveEffect_default = showWaveEffect;

// ../../node_modules/antd/es/_util/wave/useWave.js
var useWave = (nodeRef, className2, component) => {
  const {
    wave
  } = React62.useContext(ConfigContext);
  const [, token2, hashId] = useToken();
  const showWave = useEvent2((event) => {
    const node2 = nodeRef.current;
    if ((wave === null || wave === void 0 ? void 0 : wave.disabled) || !node2) {
      return;
    }
    const targetNode = node2.querySelector(`.${TARGET_CLS}`) || node2;
    const {
      showEffect
    } = wave || {};
    (showEffect || WaveEffect_default)(targetNode, {
      className: className2,
      token: token2,
      component,
      event,
      hashId
    });
  });
  const rafId = React62.useRef(null);
  const showDebounceWave = (event) => {
    raf_default.cancel(rafId.current);
    rafId.current = raf_default(() => {
      showWave(event);
    });
  };
  return showDebounceWave;
};
var useWave_default = useWave;

// ../../node_modules/antd/es/_util/wave/index.js
var Wave = (props) => {
  const {
    children,
    disabled,
    component
  } = props;
  const {
    getPrefixCls
  } = (0, import_react30.useContext)(ConfigContext);
  const containerRef = (0, import_react30.useRef)(null);
  const prefixCls = getPrefixCls("wave");
  const [, hashId] = style_default2(prefixCls);
  const showWave = useWave_default(containerRef, (0, import_classnames8.default)(prefixCls, hashId), component);
  import_react30.default.useEffect(() => {
    const node2 = containerRef.current;
    if (!node2 || node2.nodeType !== 1 || disabled) {
      return;
    }
    const onClick = (e3) => {
      if (!isVisible_default(e3.target) || // No need wave
      !node2.getAttribute || node2.getAttribute("disabled") || node2.disabled || node2.className.includes("disabled") || node2.className.includes("-leave")) {
        return;
      }
      showWave(e3);
    };
    node2.addEventListener("click", onClick, true);
    return () => {
      node2.removeEventListener("click", onClick, true);
    };
  }, [disabled]);
  if (!/* @__PURE__ */ import_react30.default.isValidElement(children)) {
    return children !== null && children !== void 0 ? children : null;
  }
  const ref3 = supportRef(children) ? composeRef(getNodeRef(children), containerRef) : containerRef;
  return cloneElement4(children, {
    ref: ref3
  });
};
if (true) {
  Wave.displayName = "Wave";
}
var wave_default = Wave;

// ../../node_modules/antd/es/config-provider/hooks/useSize.js
var import_react31 = __toESM(require_react());
var useSize = (customSize) => {
  const size = import_react31.default.useContext(SizeContext_default);
  const mergedSize = import_react31.default.useMemo(() => {
    if (!customSize) {
      return size;
    }
    if (typeof customSize === "string") {
      return customSize !== null && customSize !== void 0 ? customSize : size;
    }
    if (typeof customSize === "function") {
      return customSize(size);
    }
    return size;
  }, [customSize, size]);
  return mergedSize;
};
var useSize_default = useSize;

// ../../node_modules/antd/es/space/Compact.js
var React65 = __toESM(require_react());
var import_classnames9 = __toESM(require_classnames());

// ../../node_modules/antd/es/space/style/compact.js
var genSpaceCompactStyle = (token2) => {
  const {
    componentCls
  } = token2;
  return {
    [componentCls]: {
      "&-block": {
        display: "flex",
        width: "100%"
      },
      "&-vertical": {
        flexDirection: "column"
      }
    }
  };
};
var compact_default = genSpaceCompactStyle;

// ../../node_modules/antd/es/space/style/index.js
var genSpaceStyle = (token2) => {
  const {
    componentCls,
    antCls
  } = token2;
  return {
    [componentCls]: {
      display: "inline-flex",
      "&-rtl": {
        direction: "rtl"
      },
      "&-vertical": {
        flexDirection: "column"
      },
      "&-align": {
        flexDirection: "column",
        "&-center": {
          alignItems: "center"
        },
        "&-start": {
          alignItems: "flex-start"
        },
        "&-end": {
          alignItems: "flex-end"
        },
        "&-baseline": {
          alignItems: "baseline"
        }
      },
      [`${componentCls}-item:empty`]: {
        display: "none"
      },
      // https://github.com/ant-design/ant-design/issues/47875
      [`${componentCls}-item > ${antCls}-badge-not-a-wrapper:only-child`]: {
        display: "block"
      }
    }
  };
};
var genSpaceGapStyle = (token2) => {
  const {
    componentCls
  } = token2;
  return {
    [componentCls]: {
      "&-gap-row-small": {
        rowGap: token2.spaceGapSmallSize
      },
      "&-gap-row-middle": {
        rowGap: token2.spaceGapMiddleSize
      },
      "&-gap-row-large": {
        rowGap: token2.spaceGapLargeSize
      },
      "&-gap-col-small": {
        columnGap: token2.spaceGapSmallSize
      },
      "&-gap-col-middle": {
        columnGap: token2.spaceGapMiddleSize
      },
      "&-gap-col-large": {
        columnGap: token2.spaceGapLargeSize
      }
    }
  };
};
var style_default3 = genStyleHooks("Space", (token2) => {
  const spaceToken = merge2(token2, {
    spaceGapSmallSize: token2.paddingXS,
    spaceGapMiddleSize: token2.padding,
    spaceGapLargeSize: token2.paddingLG
  });
  return [genSpaceStyle(spaceToken), genSpaceGapStyle(spaceToken), compact_default(spaceToken)];
}, () => ({}), {
  // Space component don't apply extra font style
  // https://github.com/ant-design/ant-design/issues/40315
  resetStyle: false
});

// ../../node_modules/antd/es/space/Compact.js
var __rest7 = function(s, e3) {
  var t2 = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e3.indexOf(p) < 0) t2[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e3.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t2[p[i]] = s[p[i]];
  }
  return t2;
};
var SpaceCompactItemContext = /* @__PURE__ */ React65.createContext(null);
var useCompactItemContext = (prefixCls, direction) => {
  const compactItemContext = React65.useContext(SpaceCompactItemContext);
  const compactItemClassnames = React65.useMemo(() => {
    if (!compactItemContext) {
      return "";
    }
    const {
      compactDirection,
      isFirstItem,
      isLastItem
    } = compactItemContext;
    const separator = compactDirection === "vertical" ? "-vertical-" : "-";
    return (0, import_classnames9.default)(`${prefixCls}-compact${separator}item`, {
      [`${prefixCls}-compact${separator}first-item`]: isFirstItem,
      [`${prefixCls}-compact${separator}last-item`]: isLastItem,
      [`${prefixCls}-compact${separator}item-rtl`]: direction === "rtl"
    });
  }, [prefixCls, direction, compactItemContext]);
  return {
    compactSize: compactItemContext === null || compactItemContext === void 0 ? void 0 : compactItemContext.compactSize,
    compactDirection: compactItemContext === null || compactItemContext === void 0 ? void 0 : compactItemContext.compactDirection,
    compactItemClassnames
  };
};
var NoCompactStyle = (props) => {
  const {
    children
  } = props;
  return /* @__PURE__ */ React65.createElement(SpaceCompactItemContext.Provider, {
    value: null
  }, children);
};
var CompactItem = (props) => {
  const {
    children
  } = props, others = __rest7(props, ["children"]);
  return /* @__PURE__ */ React65.createElement(SpaceCompactItemContext.Provider, {
    value: React65.useMemo(() => others, [others])
  }, children);
};
var Compact = (props) => {
  const {
    getPrefixCls,
    direction: directionConfig
  } = React65.useContext(ConfigContext);
  const {
    size,
    direction,
    block,
    prefixCls: customizePrefixCls,
    className: className2,
    rootClassName,
    children
  } = props, restProps = __rest7(props, ["size", "direction", "block", "prefixCls", "className", "rootClassName", "children"]);
  const mergedSize = useSize_default((ctx) => size !== null && size !== void 0 ? size : ctx);
  const prefixCls = getPrefixCls("space-compact", customizePrefixCls);
  const [wrapCSSVar, hashId] = style_default3(prefixCls);
  const clx = (0, import_classnames9.default)(prefixCls, hashId, {
    [`${prefixCls}-rtl`]: directionConfig === "rtl",
    [`${prefixCls}-block`]: block,
    [`${prefixCls}-vertical`]: direction === "vertical"
  }, className2, rootClassName);
  const compactItemContext = React65.useContext(SpaceCompactItemContext);
  const childNodes = toArray(children);
  const nodes = React65.useMemo(() => childNodes.map((child, i) => {
    const key2 = (child === null || child === void 0 ? void 0 : child.key) || `${prefixCls}-item-${i}`;
    return /* @__PURE__ */ React65.createElement(CompactItem, {
      key: key2,
      compactSize: mergedSize,
      compactDirection: direction,
      isFirstItem: i === 0 && (!compactItemContext || (compactItemContext === null || compactItemContext === void 0 ? void 0 : compactItemContext.isFirstItem)),
      isLastItem: i === childNodes.length - 1 && (!compactItemContext || (compactItemContext === null || compactItemContext === void 0 ? void 0 : compactItemContext.isLastItem))
    }, child);
  }), [size, childNodes, compactItemContext]);
  if (childNodes.length === 0) {
    return null;
  }
  return wrapCSSVar(/* @__PURE__ */ React65.createElement("div", Object.assign({
    className: clx
  }, restProps), nodes));
};
var Compact_default = Compact;

// ../../node_modules/antd/es/button/button-group.js
var React66 = __toESM(require_react());
var import_classnames10 = __toESM(require_classnames());
var __rest8 = function(s, e3) {
  var t2 = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e3.indexOf(p) < 0) t2[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e3.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t2[p[i]] = s[p[i]];
  }
  return t2;
};
var GroupSizeContext = /* @__PURE__ */ React66.createContext(void 0);
var ButtonGroup = (props) => {
  const {
    getPrefixCls,
    direction
  } = React66.useContext(ConfigContext);
  const {
    prefixCls: customizePrefixCls,
    size,
    className: className2
  } = props, others = __rest8(props, ["prefixCls", "size", "className"]);
  const prefixCls = getPrefixCls("btn-group", customizePrefixCls);
  const [, , hashId] = useToken();
  const sizeCls = React66.useMemo(() => {
    switch (size) {
      case "large":
        return "lg";
      case "small":
        return "sm";
      default:
        return "";
    }
  }, [size]);
  if (true) {
    const warning6 = devUseWarning("Button.Group");
    warning6.deprecated(false, "Button.Group", "Space.Compact");
    true ? warning6(!size || ["large", "small", "middle"].includes(size), "usage", "Invalid prop `size`.") : void 0;
  }
  const classes = (0, import_classnames10.default)(prefixCls, {
    [`${prefixCls}-${sizeCls}`]: sizeCls,
    [`${prefixCls}-rtl`]: direction === "rtl"
  }, className2, hashId);
  return /* @__PURE__ */ React66.createElement(GroupSizeContext.Provider, {
    value: size
  }, /* @__PURE__ */ React66.createElement("div", Object.assign({}, others, {
    className: classes
  })));
};
var button_group_default = ButtonGroup;

// ../../node_modules/antd/es/button/buttonHelpers.js
var import_react32 = __toESM(require_react());
var rxTwoCNChar = /^[\u4E00-\u9FA5]{2}$/;
var isTwoCNChar = rxTwoCNChar.test.bind(rxTwoCNChar);
function convertLegacyProps(type5) {
  if (type5 === "danger") {
    return {
      danger: true
    };
  }
  return {
    type: type5
  };
}
function isString(str) {
  return typeof str === "string";
}
function isUnBorderedButtonVariant(type5) {
  return type5 === "text" || type5 === "link";
}
function splitCNCharsBySpace(child, needInserted) {
  if (child === null || child === void 0) {
    return;
  }
  const SPACE = needInserted ? " " : "";
  if (typeof child !== "string" && typeof child !== "number" && isString(child.type) && isTwoCNChar(child.props.children)) {
    return cloneElement4(child, {
      children: child.props.children.split("").join(SPACE)
    });
  }
  if (isString(child)) {
    return isTwoCNChar(child) ? /* @__PURE__ */ import_react32.default.createElement("span", null, child.split("").join(SPACE)) : /* @__PURE__ */ import_react32.default.createElement("span", null, child);
  }
  if (isFragment2(child)) {
    return /* @__PURE__ */ import_react32.default.createElement("span", null, child);
  }
  return child;
}
function spaceChildren(children, needInserted) {
  let isPrevChildPure = false;
  const childList = [];
  import_react32.default.Children.forEach(children, (child) => {
    const type5 = typeof child;
    const isCurrentChildPure = type5 === "string" || type5 === "number";
    if (isPrevChildPure && isCurrentChildPure) {
      const lastIndex = childList.length - 1;
      const lastChild = childList[lastIndex];
      childList[lastIndex] = `${lastChild}${child}`;
    } else {
      childList.push(child);
    }
    isPrevChildPure = isCurrentChildPure;
  });
  return import_react32.default.Children.map(childList, (child) => splitCNCharsBySpace(child, needInserted));
}
var _ButtonColorTypes = ["default", "primary", "danger"].concat(_toConsumableArray(PresetColors));

// ../../node_modules/antd/es/button/DefaultLoadingIcon.js
var import_react34 = __toESM(require_react());
var import_classnames12 = __toESM(require_classnames());

// ../../node_modules/antd/es/button/IconWrapper.js
var import_react33 = __toESM(require_react());
var import_classnames11 = __toESM(require_classnames());
var IconWrapper = /* @__PURE__ */ (0, import_react33.forwardRef)((props, ref3) => {
  const {
    className: className2,
    style: style2,
    children,
    prefixCls
  } = props;
  const iconWrapperCls = (0, import_classnames11.default)(`${prefixCls}-icon`, className2);
  return /* @__PURE__ */ import_react33.default.createElement("span", {
    ref: ref3,
    className: iconWrapperCls,
    style: style2
  }, children);
});
var IconWrapper_default = IconWrapper;

// ../../node_modules/antd/es/button/DefaultLoadingIcon.js
var InnerLoadingIcon = /* @__PURE__ */ (0, import_react34.forwardRef)((props, ref3) => {
  const {
    prefixCls,
    className: className2,
    style: style2,
    iconClassName
  } = props;
  const mergedIconCls = (0, import_classnames12.default)(`${prefixCls}-loading-icon`, className2);
  return /* @__PURE__ */ import_react34.default.createElement(IconWrapper_default, {
    prefixCls,
    className: mergedIconCls,
    style: style2,
    ref: ref3
  }, /* @__PURE__ */ import_react34.default.createElement(LoadingOutlined_default2, {
    className: iconClassName
  }));
});
var getCollapsedWidth = () => ({
  width: 0,
  opacity: 0,
  transform: "scale(0)"
});
var getRealWidth = (node2) => ({
  width: node2.scrollWidth,
  opacity: 1,
  transform: "scale(1)"
});
var DefaultLoadingIcon = (props) => {
  const {
    prefixCls,
    loading,
    existIcon,
    className: className2,
    style: style2,
    mount
  } = props;
  const visible = !!loading;
  if (existIcon) {
    return /* @__PURE__ */ import_react34.default.createElement(InnerLoadingIcon, {
      prefixCls,
      className: className2,
      style: style2
    });
  }
  return /* @__PURE__ */ import_react34.default.createElement(es_default2, {
    visible,
    // Used for minus flex gap style only
    motionName: `${prefixCls}-loading-icon-motion`,
    motionAppear: !mount,
    motionEnter: !mount,
    motionLeave: !mount,
    removeOnLeave: true,
    onAppearStart: getCollapsedWidth,
    onAppearActive: getRealWidth,
    onEnterStart: getCollapsedWidth,
    onEnterActive: getRealWidth,
    onLeaveStart: getRealWidth,
    onLeaveActive: getCollapsedWidth
  }, ({
    className: motionCls,
    style: motionStyle
  }, ref3) => {
    const mergedStyle = Object.assign(Object.assign({}, style2), motionStyle);
    return /* @__PURE__ */ import_react34.default.createElement(InnerLoadingIcon, {
      prefixCls,
      className: (0, import_classnames12.default)(className2, motionCls),
      style: mergedStyle,
      ref: ref3
    });
  });
};
var DefaultLoadingIcon_default = DefaultLoadingIcon;

// ../../node_modules/antd/es/button/style/group.js
var genButtonBorderStyle = (buttonTypeCls, borderColor) => ({
  // Border
  [`> span, > ${buttonTypeCls}`]: {
    "&:not(:last-child)": {
      [`&, & > ${buttonTypeCls}`]: {
        "&:not(:disabled)": {
          borderInlineEndColor: borderColor
        }
      }
    },
    "&:not(:first-child)": {
      [`&, & > ${buttonTypeCls}`]: {
        "&:not(:disabled)": {
          borderInlineStartColor: borderColor
        }
      }
    }
  }
});
var genGroupStyle = (token2) => {
  const {
    componentCls,
    fontSize,
    lineWidth,
    groupBorderColor,
    colorErrorHover
  } = token2;
  return {
    [`${componentCls}-group`]: [
      {
        position: "relative",
        display: "inline-flex",
        // Border
        [`> span, > ${componentCls}`]: {
          "&:not(:last-child)": {
            [`&, & > ${componentCls}`]: {
              borderStartEndRadius: 0,
              borderEndEndRadius: 0
            }
          },
          "&:not(:first-child)": {
            marginInlineStart: token2.calc(lineWidth).mul(-1).equal(),
            [`&, & > ${componentCls}`]: {
              borderStartStartRadius: 0,
              borderEndStartRadius: 0
            }
          }
        },
        [componentCls]: {
          position: "relative",
          zIndex: 1,
          "&:hover, &:focus, &:active": {
            zIndex: 2
          },
          "&[disabled]": {
            zIndex: 0
          }
        },
        [`${componentCls}-icon-only`]: {
          fontSize
        }
      },
      // Border Color
      genButtonBorderStyle(`${componentCls}-primary`, groupBorderColor),
      genButtonBorderStyle(`${componentCls}-danger`, colorErrorHover)
    ]
  };
};
var group_default = genGroupStyle;

// ../../node_modules/@rc-component/color-picker/es/ColorPicker.js
var import_react44 = __toESM(require_react());

// ../../node_modules/@rc-component/color-picker/es/color.js
var _excluded7 = ["b"];
var _excluded23 = ["v"];
var getRoundNumber = function getRoundNumber2(value) {
  return Math.round(Number(value || 0));
};
var convertHsb2Hsv = function convertHsb2Hsv2(color) {
  if (color instanceof FastColor) {
    return color;
  }
  if (color && _typeof(color) === "object" && "h" in color && "b" in color) {
    var _ref = color, b = _ref.b, resets = _objectWithoutProperties(_ref, _excluded7);
    return _objectSpread2(_objectSpread2({}, resets), {}, {
      v: b
    });
  }
  if (typeof color === "string" && /hsb/.test(color)) {
    return color.replace(/hsb/, "hsv");
  }
  return color;
};
var Color = /* @__PURE__ */ (function(_FastColor) {
  _inherits(Color5, _FastColor);
  var _super = _createSuper(Color5);
  function Color5(color) {
    _classCallCheck(this, Color5);
    return _super.call(this, convertHsb2Hsv(color));
  }
  _createClass(Color5, [{
    key: "toHsbString",
    value: function toHsbString() {
      var hsb = this.toHsb();
      var saturation = getRoundNumber(hsb.s * 100);
      var lightness = getRoundNumber(hsb.b * 100);
      var hue = getRoundNumber(hsb.h);
      var alpha = hsb.a;
      var hsbString = "hsb(".concat(hue, ", ").concat(saturation, "%, ").concat(lightness, "%)");
      var hsbaString = "hsba(".concat(hue, ", ").concat(saturation, "%, ").concat(lightness, "%, ").concat(alpha.toFixed(alpha === 0 ? 0 : 2), ")");
      return alpha === 1 ? hsbString : hsbaString;
    }
  }, {
    key: "toHsb",
    value: function toHsb() {
      var _this$toHsv = this.toHsv(), v = _this$toHsv.v, resets = _objectWithoutProperties(_this$toHsv, _excluded23);
      return _objectSpread2(_objectSpread2({}, resets), {}, {
        b: v,
        a: this.a
      });
    }
  }]);
  return Color5;
})(FastColor);

// ../../node_modules/@rc-component/color-picker/es/util.js
var ColorPickerPrefixCls = "rc-color-picker";
var generateColor = function generateColor2(color) {
  if (color instanceof Color) {
    return color;
  }
  return new Color(color);
};
var defaultColor = generateColor("#1677ff");
var calculateColor = function calculateColor2(props) {
  var offset4 = props.offset, targetRef = props.targetRef, containerRef = props.containerRef, color = props.color, type5 = props.type;
  var _containerRef$current = containerRef.current.getBoundingClientRect(), width = _containerRef$current.width, height = _containerRef$current.height;
  var _targetRef$current$ge = targetRef.current.getBoundingClientRect(), targetWidth = _targetRef$current$ge.width, targetHeight = _targetRef$current$ge.height;
  var centerOffsetX = targetWidth / 2;
  var centerOffsetY = targetHeight / 2;
  var saturation = (offset4.x + centerOffsetX) / width;
  var bright = 1 - (offset4.y + centerOffsetY) / height;
  var hsb = color.toHsb();
  var alphaOffset = saturation;
  var hueOffset = (offset4.x + centerOffsetX) / width * 360;
  if (type5) {
    switch (type5) {
      case "hue":
        return generateColor(_objectSpread2(_objectSpread2({}, hsb), {}, {
          h: hueOffset <= 0 ? 0 : hueOffset
        }));
      case "alpha":
        return generateColor(_objectSpread2(_objectSpread2({}, hsb), {}, {
          a: alphaOffset <= 0 ? 0 : alphaOffset
        }));
    }
  }
  return generateColor({
    h: hsb.h,
    s: saturation <= 0 ? 0 : saturation,
    b: bright >= 1 ? 1 : bright,
    a: hsb.a
  });
};
var calcOffset = function calcOffset2(color, type5) {
  var hsb = color.toHsb();
  switch (type5) {
    case "hue":
      return {
        x: hsb.h / 360 * 100,
        y: 50
      };
    case "alpha":
      return {
        x: color.a * 100,
        y: 50
      };
    // Picker panel
    default:
      return {
        x: hsb.s * 100,
        y: (1 - hsb.b) * 100
      };
  }
};

// ../../node_modules/@rc-component/color-picker/es/ColorPicker.js
var import_classnames16 = __toESM(require_classnames());

// ../../node_modules/@rc-component/color-picker/es/components/ColorBlock.js
var import_classnames13 = __toESM(require_classnames());
var import_react35 = __toESM(require_react());
var ColorBlock = function ColorBlock2(_ref) {
  var color = _ref.color, prefixCls = _ref.prefixCls, className2 = _ref.className, style2 = _ref.style, onClick = _ref.onClick;
  var colorBlockCls = "".concat(prefixCls, "-color-block");
  return /* @__PURE__ */ import_react35.default.createElement("div", {
    className: (0, import_classnames13.default)(colorBlockCls, className2),
    style: style2,
    onClick
  }, /* @__PURE__ */ import_react35.default.createElement("div", {
    className: "".concat(colorBlockCls, "-inner"),
    style: {
      background: color
    }
  }));
};
var ColorBlock_default = ColorBlock;

// ../../node_modules/@rc-component/color-picker/es/components/Picker.js
var import_react40 = __toESM(require_react());

// ../../node_modules/@rc-component/color-picker/es/hooks/useColorDrag.js
var import_react36 = __toESM(require_react());
function getPosition(e3) {
  var obj = "touches" in e3 ? e3.touches[0] : e3;
  var scrollXOffset = document.documentElement.scrollLeft || document.body.scrollLeft || window.pageXOffset;
  var scrollYOffset = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;
  return {
    pageX: obj.pageX - scrollXOffset,
    pageY: obj.pageY - scrollYOffset
  };
}
function useColorDrag(props) {
  var targetRef = props.targetRef, containerRef = props.containerRef, direction = props.direction, onDragChange = props.onDragChange, onDragChangeComplete = props.onDragChangeComplete, calculate3 = props.calculate, color = props.color, disabledDrag = props.disabledDrag;
  var _useState = (0, import_react36.useState)({
    x: 0,
    y: 0
  }), _useState2 = _slicedToArray(_useState, 2), offsetValue = _useState2[0], setOffsetValue = _useState2[1];
  var mouseMoveRef = (0, import_react36.useRef)(null);
  var mouseUpRef = (0, import_react36.useRef)(null);
  (0, import_react36.useEffect)(function() {
    setOffsetValue(calculate3());
  }, [color]);
  (0, import_react36.useEffect)(function() {
    return function() {
      document.removeEventListener("mousemove", mouseMoveRef.current);
      document.removeEventListener("mouseup", mouseUpRef.current);
      document.removeEventListener("touchmove", mouseMoveRef.current);
      document.removeEventListener("touchend", mouseUpRef.current);
      mouseMoveRef.current = null;
      mouseUpRef.current = null;
    };
  }, []);
  var updateOffset = function updateOffset2(e3) {
    var _getPosition = getPosition(e3), pageX = _getPosition.pageX, pageY = _getPosition.pageY;
    var _containerRef$current = containerRef.current.getBoundingClientRect(), rectX = _containerRef$current.x, rectY = _containerRef$current.y, width = _containerRef$current.width, height = _containerRef$current.height;
    var _targetRef$current$ge = targetRef.current.getBoundingClientRect(), targetWidth = _targetRef$current$ge.width, targetHeight = _targetRef$current$ge.height;
    var centerOffsetX = targetWidth / 2;
    var centerOffsetY = targetHeight / 2;
    var offsetX = Math.max(0, Math.min(pageX - rectX, width)) - centerOffsetX;
    var offsetY = Math.max(0, Math.min(pageY - rectY, height)) - centerOffsetY;
    var calcOffset3 = {
      x: offsetX,
      y: direction === "x" ? offsetValue.y : offsetY
    };
    if (targetWidth === 0 && targetHeight === 0 || targetWidth !== targetHeight) {
      return false;
    }
    onDragChange === null || onDragChange === void 0 || onDragChange(calcOffset3);
  };
  var onDragMove = function onDragMove2(e3) {
    e3.preventDefault();
    updateOffset(e3);
  };
  var onDragStop = function onDragStop2(e3) {
    e3.preventDefault();
    document.removeEventListener("mousemove", mouseMoveRef.current);
    document.removeEventListener("mouseup", mouseUpRef.current);
    document.removeEventListener("touchmove", mouseMoveRef.current);
    document.removeEventListener("touchend", mouseUpRef.current);
    mouseMoveRef.current = null;
    mouseUpRef.current = null;
    onDragChangeComplete === null || onDragChangeComplete === void 0 || onDragChangeComplete();
  };
  var onDragStart = function onDragStart2(e3) {
    document.removeEventListener("mousemove", mouseMoveRef.current);
    document.removeEventListener("mouseup", mouseUpRef.current);
    if (disabledDrag) {
      return;
    }
    updateOffset(e3);
    document.addEventListener("mousemove", onDragMove);
    document.addEventListener("mouseup", onDragStop);
    document.addEventListener("touchmove", onDragMove);
    document.addEventListener("touchend", onDragStop);
    mouseMoveRef.current = onDragMove;
    mouseUpRef.current = onDragStop;
  };
  return [offsetValue, onDragStart];
}
var useColorDrag_default = useColorDrag;

// ../../node_modules/@rc-component/color-picker/es/components/Handler.js
var import_classnames14 = __toESM(require_classnames());
var import_react37 = __toESM(require_react());
var Handler = function Handler2(_ref) {
  var _ref$size = _ref.size, size = _ref$size === void 0 ? "default" : _ref$size, color = _ref.color, prefixCls = _ref.prefixCls;
  return /* @__PURE__ */ import_react37.default.createElement("div", {
    className: (0, import_classnames14.default)("".concat(prefixCls, "-handler"), _defineProperty({}, "".concat(prefixCls, "-handler-sm"), size === "small")),
    style: {
      backgroundColor: color
    }
  });
};
var Handler_default = Handler;

// ../../node_modules/@rc-component/color-picker/es/components/Palette.js
var import_react38 = __toESM(require_react());
var Palette = function Palette2(_ref) {
  var children = _ref.children, style2 = _ref.style, prefixCls = _ref.prefixCls;
  return /* @__PURE__ */ import_react38.default.createElement("div", {
    className: "".concat(prefixCls, "-palette"),
    style: _objectSpread2({
      position: "relative"
    }, style2)
  }, children);
};
var Palette_default = Palette;

// ../../node_modules/@rc-component/color-picker/es/components/Transform.js
var import_react39 = __toESM(require_react());
var Transform = /* @__PURE__ */ (0, import_react39.forwardRef)(function(props, ref3) {
  var children = props.children, x = props.x, y = props.y;
  return /* @__PURE__ */ import_react39.default.createElement("div", {
    ref: ref3,
    style: {
      position: "absolute",
      left: "".concat(x, "%"),
      top: "".concat(y, "%"),
      zIndex: 1,
      transform: "translate(-50%, -50%)"
    }
  }, children);
});
var Transform_default = Transform;

// ../../node_modules/@rc-component/color-picker/es/components/Picker.js
var Picker = function Picker2(_ref) {
  var color = _ref.color, onChange = _ref.onChange, prefixCls = _ref.prefixCls, onChangeComplete = _ref.onChangeComplete, disabled = _ref.disabled;
  var pickerRef = (0, import_react40.useRef)();
  var transformRef = (0, import_react40.useRef)();
  var colorRef = (0, import_react40.useRef)(color);
  var onDragChange = useEvent2(function(offsetValue) {
    var calcColor = calculateColor({
      offset: offsetValue,
      targetRef: transformRef,
      containerRef: pickerRef,
      color
    });
    colorRef.current = calcColor;
    onChange(calcColor);
  });
  var _useColorDrag = useColorDrag_default({
    color,
    containerRef: pickerRef,
    targetRef: transformRef,
    calculate: function calculate3() {
      return calcOffset(color);
    },
    onDragChange,
    onDragChangeComplete: function onDragChangeComplete() {
      return onChangeComplete === null || onChangeComplete === void 0 ? void 0 : onChangeComplete(colorRef.current);
    },
    disabledDrag: disabled
  }), _useColorDrag2 = _slicedToArray(_useColorDrag, 2), offset4 = _useColorDrag2[0], dragStartHandle = _useColorDrag2[1];
  return /* @__PURE__ */ import_react40.default.createElement("div", {
    ref: pickerRef,
    className: "".concat(prefixCls, "-select"),
    onMouseDown: dragStartHandle,
    onTouchStart: dragStartHandle
  }, /* @__PURE__ */ import_react40.default.createElement(Palette_default, {
    prefixCls
  }, /* @__PURE__ */ import_react40.default.createElement(Transform_default, {
    x: offset4.x,
    y: offset4.y,
    ref: transformRef
  }, /* @__PURE__ */ import_react40.default.createElement(Handler_default, {
    color: color.toRgbString(),
    prefixCls
  })), /* @__PURE__ */ import_react40.default.createElement("div", {
    className: "".concat(prefixCls, "-saturation"),
    style: {
      backgroundColor: "hsl(".concat(color.toHsb().h, ",100%, 50%)"),
      backgroundImage: "linear-gradient(0deg, #000, transparent),linear-gradient(90deg, #fff, hsla(0, 0%, 100%, 0))"
    }
  })));
};
var Picker_default = Picker;

// ../../node_modules/@rc-component/color-picker/es/hooks/useColorState.js
var import_react41 = __toESM(require_react());
var useColorState = function useColorState2(defaultValue2, value) {
  var _useMergedState = useMergedState(defaultValue2, {
    value
  }), _useMergedState2 = _slicedToArray(_useMergedState, 2), mergedValue = _useMergedState2[0], setValue = _useMergedState2[1];
  var color = (0, import_react41.useMemo)(function() {
    return generateColor(mergedValue);
  }, [mergedValue]);
  return [color, setValue];
};
var useColorState_default = useColorState;

// ../../node_modules/@rc-component/color-picker/es/hooks/useComponent.js
var React77 = __toESM(require_react());

// ../../node_modules/@rc-component/color-picker/es/components/Slider.js
var import_react43 = __toESM(require_react());
var import_classnames15 = __toESM(require_classnames());

// ../../node_modules/@rc-component/color-picker/es/components/Gradient.js
var import_react42 = __toESM(require_react());
var Gradient = function Gradient2(_ref) {
  var colors = _ref.colors, children = _ref.children, _ref$direction = _ref.direction, direction = _ref$direction === void 0 ? "to right" : _ref$direction, type5 = _ref.type, prefixCls = _ref.prefixCls;
  var gradientColors = (0, import_react42.useMemo)(function() {
    return colors.map(function(color, idx) {
      var result = generateColor(color);
      if (type5 === "alpha" && idx === colors.length - 1) {
        result = new Color(result.setA(1));
      }
      return result.toRgbString();
    }).join(",");
  }, [colors, type5]);
  return /* @__PURE__ */ import_react42.default.createElement("div", {
    className: "".concat(prefixCls, "-gradient"),
    style: {
      position: "absolute",
      inset: 0,
      background: "linear-gradient(".concat(direction, ", ").concat(gradientColors, ")")
    }
  }, children);
};
var Gradient_default = Gradient;

// ../../node_modules/@rc-component/color-picker/es/components/Slider.js
var Slider = function Slider2(props) {
  var prefixCls = props.prefixCls, colors = props.colors, disabled = props.disabled, onChange = props.onChange, onChangeComplete = props.onChangeComplete, color = props.color, type5 = props.type;
  var sliderRef = (0, import_react43.useRef)();
  var transformRef = (0, import_react43.useRef)();
  var colorRef = (0, import_react43.useRef)(color);
  var getValue4 = function getValue5(c) {
    return type5 === "hue" ? c.getHue() : c.a * 100;
  };
  var onDragChange = useEvent2(function(offsetValue) {
    var calcColor = calculateColor({
      offset: offsetValue,
      targetRef: transformRef,
      containerRef: sliderRef,
      color,
      type: type5
    });
    colorRef.current = calcColor;
    onChange(getValue4(calcColor));
  });
  var _useColorDrag = useColorDrag_default({
    color,
    targetRef: transformRef,
    containerRef: sliderRef,
    calculate: function calculate3() {
      return calcOffset(color, type5);
    },
    onDragChange,
    onDragChangeComplete: function onDragChangeComplete() {
      onChangeComplete(getValue4(colorRef.current));
    },
    direction: "x",
    disabledDrag: disabled
  }), _useColorDrag2 = _slicedToArray(_useColorDrag, 2), offset4 = _useColorDrag2[0], dragStartHandle = _useColorDrag2[1];
  var handleColor = import_react43.default.useMemo(function() {
    if (type5 === "hue") {
      var hsb = color.toHsb();
      hsb.s = 1;
      hsb.b = 1;
      hsb.a = 1;
      var lightColor = new Color(hsb);
      return lightColor;
    }
    return color;
  }, [color, type5]);
  var gradientList = import_react43.default.useMemo(function() {
    return colors.map(function(info) {
      return "".concat(info.color, " ").concat(info.percent, "%");
    });
  }, [colors]);
  return /* @__PURE__ */ import_react43.default.createElement("div", {
    ref: sliderRef,
    className: (0, import_classnames15.default)("".concat(prefixCls, "-slider"), "".concat(prefixCls, "-slider-").concat(type5)),
    onMouseDown: dragStartHandle,
    onTouchStart: dragStartHandle
  }, /* @__PURE__ */ import_react43.default.createElement(Palette_default, {
    prefixCls
  }, /* @__PURE__ */ import_react43.default.createElement(Transform_default, {
    x: offset4.x,
    y: offset4.y,
    ref: transformRef
  }, /* @__PURE__ */ import_react43.default.createElement(Handler_default, {
    size: "small",
    color: handleColor.toHexString(),
    prefixCls
  })), /* @__PURE__ */ import_react43.default.createElement(Gradient_default, {
    colors: gradientList,
    type: type5,
    prefixCls
  })));
};
var Slider_default = Slider;

// ../../node_modules/@rc-component/color-picker/es/hooks/useComponent.js
function useComponent(components) {
  return React77.useMemo(function() {
    var _ref = components || {}, slider = _ref.slider;
    return [slider || Slider_default];
  }, [components]);
}

// ../../node_modules/@rc-component/color-picker/es/ColorPicker.js
var HUE_COLORS = [{
  color: "rgb(255, 0, 0)",
  percent: 0
}, {
  color: "rgb(255, 255, 0)",
  percent: 17
}, {
  color: "rgb(0, 255, 0)",
  percent: 33
}, {
  color: "rgb(0, 255, 255)",
  percent: 50
}, {
  color: "rgb(0, 0, 255)",
  percent: 67
}, {
  color: "rgb(255, 0, 255)",
  percent: 83
}, {
  color: "rgb(255, 0, 0)",
  percent: 100
}];
var ColorPicker = /* @__PURE__ */ (0, import_react44.forwardRef)(function(props, ref3) {
  var value = props.value, defaultValue2 = props.defaultValue, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? ColorPickerPrefixCls : _props$prefixCls, onChange = props.onChange, onChangeComplete = props.onChangeComplete, className2 = props.className, style2 = props.style, panelRender = props.panelRender, _props$disabledAlpha = props.disabledAlpha, disabledAlpha = _props$disabledAlpha === void 0 ? false : _props$disabledAlpha, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, components = props.components;
  var _useComponent = useComponent(components), _useComponent2 = _slicedToArray(_useComponent, 1), Slider5 = _useComponent2[0];
  var _useColorState = useColorState_default(defaultValue2 || defaultColor, value), _useColorState2 = _slicedToArray(_useColorState, 2), colorValue = _useColorState2[0], setColorValue = _useColorState2[1];
  var alphaColor = (0, import_react44.useMemo)(function() {
    return colorValue.setA(1).toRgbString();
  }, [colorValue]);
  var handleChange = function handleChange2(data2, type5) {
    if (!value) {
      setColorValue(data2);
    }
    onChange === null || onChange === void 0 || onChange(data2, type5);
  };
  var getHueColor = function getHueColor2(hue) {
    return new Color(colorValue.setHue(hue));
  };
  var getAlphaColor4 = function getAlphaColor5(alpha) {
    return new Color(colorValue.setA(alpha / 100));
  };
  var onHueChange = function onHueChange2(hue) {
    handleChange(getHueColor(hue), {
      type: "hue",
      value: hue
    });
  };
  var onAlphaChange = function onAlphaChange2(alpha) {
    handleChange(getAlphaColor4(alpha), {
      type: "alpha",
      value: alpha
    });
  };
  var onHueChangeComplete = function onHueChangeComplete2(hue) {
    if (onChangeComplete) {
      onChangeComplete(getHueColor(hue));
    }
  };
  var onAlphaChangeComplete = function onAlphaChangeComplete2(alpha) {
    if (onChangeComplete) {
      onChangeComplete(getAlphaColor4(alpha));
    }
  };
  var mergeCls = (0, import_classnames16.default)("".concat(prefixCls, "-panel"), className2, _defineProperty({}, "".concat(prefixCls, "-panel-disabled"), disabled));
  var sharedSliderProps = {
    prefixCls,
    disabled,
    color: colorValue
  };
  var defaultPanel = /* @__PURE__ */ import_react44.default.createElement(import_react44.default.Fragment, null, /* @__PURE__ */ import_react44.default.createElement(Picker_default, _extends({
    onChange: handleChange
  }, sharedSliderProps, {
    onChangeComplete
  })), /* @__PURE__ */ import_react44.default.createElement("div", {
    className: "".concat(prefixCls, "-slider-container")
  }, /* @__PURE__ */ import_react44.default.createElement("div", {
    className: (0, import_classnames16.default)("".concat(prefixCls, "-slider-group"), _defineProperty({}, "".concat(prefixCls, "-slider-group-disabled-alpha"), disabledAlpha))
  }, /* @__PURE__ */ import_react44.default.createElement(Slider5, _extends({}, sharedSliderProps, {
    type: "hue",
    colors: HUE_COLORS,
    min: 0,
    max: 359,
    value: colorValue.getHue(),
    onChange: onHueChange,
    onChangeComplete: onHueChangeComplete
  })), !disabledAlpha && /* @__PURE__ */ import_react44.default.createElement(Slider5, _extends({}, sharedSliderProps, {
    type: "alpha",
    colors: [{
      percent: 0,
      color: "rgba(255, 0, 4, 0)"
    }, {
      percent: 100,
      color: alphaColor
    }],
    min: 0,
    max: 100,
    value: colorValue.a * 100,
    onChange: onAlphaChange,
    onChangeComplete: onAlphaChangeComplete
  }))), /* @__PURE__ */ import_react44.default.createElement(ColorBlock_default, {
    color: colorValue.toRgbString(),
    prefixCls
  })));
  return /* @__PURE__ */ import_react44.default.createElement("div", {
    className: mergeCls,
    style: style2,
    ref: ref3
  }, typeof panelRender === "function" ? panelRender(defaultPanel) : defaultPanel);
});
if (true) {
  ColorPicker.displayName = "ColorPicker";
}

// ../../node_modules/antd/es/color-picker/color.js
var toHexFormat = (value, alpha) => (value === null || value === void 0 ? void 0 : value.replace(/[^\w/]/g, "").slice(0, alpha ? 8 : 6)) || "";
var getHex = (value, alpha) => value ? toHexFormat(value, alpha) : "";
var AggregationColor = /* @__PURE__ */ (function() {
  function AggregationColor2(color) {
    _classCallCheck(this, AggregationColor2);
    var _a;
    this.cleared = false;
    if (color instanceof AggregationColor2) {
      this.metaColor = color.metaColor.clone();
      this.colors = (_a = color.colors) === null || _a === void 0 ? void 0 : _a.map((info) => ({
        color: new AggregationColor2(info.color),
        percent: info.percent
      }));
      this.cleared = color.cleared;
      return;
    }
    const isArray6 = Array.isArray(color);
    if (isArray6 && color.length) {
      this.colors = color.map(({
        color: c,
        percent
      }) => ({
        color: new AggregationColor2(c),
        percent
      }));
      this.metaColor = new Color(this.colors[0].color.metaColor);
    } else {
      this.metaColor = new Color(isArray6 ? "" : color);
    }
    if (!color || isArray6 && !this.colors) {
      this.metaColor = this.metaColor.setA(0);
      this.cleared = true;
    }
  }
  return _createClass(AggregationColor2, [{
    key: "toHsb",
    value: function toHsb() {
      return this.metaColor.toHsb();
    }
  }, {
    key: "toHsbString",
    value: function toHsbString() {
      return this.metaColor.toHsbString();
    }
  }, {
    key: "toHex",
    value: function toHex() {
      return getHex(this.toHexString(), this.metaColor.a < 1);
    }
  }, {
    key: "toHexString",
    value: function toHexString() {
      return this.metaColor.toHexString();
    }
  }, {
    key: "toRgb",
    value: function toRgb() {
      return this.metaColor.toRgb();
    }
  }, {
    key: "toRgbString",
    value: function toRgbString() {
      return this.metaColor.toRgbString();
    }
  }, {
    key: "isGradient",
    value: function isGradient() {
      return !!this.colors && !this.cleared;
    }
  }, {
    key: "getColors",
    value: function getColors() {
      return this.colors || [{
        color: this,
        percent: 0
      }];
    }
  }, {
    key: "toCssString",
    value: function toCssString() {
      const {
        colors
      } = this;
      if (colors) {
        const colorsStr = colors.map((c) => `${c.color.toRgbString()} ${c.percent}%`).join(", ");
        return `linear-gradient(90deg, ${colorsStr})`;
      }
      return this.metaColor.toRgbString();
    }
  }, {
    key: "equals",
    value: function equals2(color) {
      if (!color || this.isGradient() !== color.isGradient()) {
        return false;
      }
      if (!this.isGradient()) {
        return this.toHexString() === color.toHexString();
      }
      return this.colors.length === color.colors.length && this.colors.every((c, i) => {
        const target = color.colors[i];
        return c.percent === target.percent && c.color.equals(target.color);
      });
    }
  }]);
})();

// ../../node_modules/antd/es/color-picker/components/ColorPresets.js
var import_react49 = __toESM(require_react());
var import_classnames22 = __toESM(require_classnames());

// ../../node_modules/antd/es/collapse/Collapse.js
var React85 = __toESM(require_react());

// ../../node_modules/@ant-design/icons/es/icons/RightOutlined.js
var React79 = __toESM(require_react());

// ../../node_modules/@ant-design/icons-svg/es/asn/RightOutlined.js
var RightOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z" } }] }, "name": "right", "theme": "outlined" };
var RightOutlined_default = RightOutlined;

// ../../node_modules/@ant-design/icons/es/icons/RightOutlined.js
var RightOutlined2 = function RightOutlined3(props, ref3) {
  return /* @__PURE__ */ React79.createElement(AntdIcon_default, _extends({}, props, {
    ref: ref3,
    icon: RightOutlined_default
  }));
};
var RefIcon7 = /* @__PURE__ */ React79.forwardRef(RightOutlined2);
if (true) {
  RefIcon7.displayName = "RightOutlined";
}
var RightOutlined_default2 = RefIcon7;

// ../../node_modules/antd/es/collapse/Collapse.js
var import_classnames21 = __toESM(require_classnames());

// ../../node_modules/rc-collapse/es/Collapse.js
var import_classnames19 = __toESM(require_classnames());
var import_react48 = __toESM(require_react());

// ../../node_modules/rc-collapse/es/hooks/useItems.js
var import_react47 = __toESM(require_react());

// ../../node_modules/rc-collapse/es/Panel.js
var import_classnames18 = __toESM(require_classnames());
var import_react46 = __toESM(require_react());

// ../../node_modules/rc-collapse/es/PanelContent.js
var import_classnames17 = __toESM(require_classnames());
var import_react45 = __toESM(require_react());
var PanelContent = /* @__PURE__ */ import_react45.default.forwardRef(function(props, ref3) {
  var prefixCls = props.prefixCls, forceRender = props.forceRender, className2 = props.className, style2 = props.style, children = props.children, isActive2 = props.isActive, role = props.role, customizeClassNames = props.classNames, styles = props.styles;
  var _React$useState = import_react45.default.useState(isActive2 || forceRender), _React$useState2 = _slicedToArray(_React$useState, 2), rendered = _React$useState2[0], setRendered = _React$useState2[1];
  import_react45.default.useEffect(function() {
    if (forceRender || isActive2) {
      setRendered(true);
    }
  }, [forceRender, isActive2]);
  if (!rendered) {
    return null;
  }
  return /* @__PURE__ */ import_react45.default.createElement("div", {
    ref: ref3,
    className: (0, import_classnames17.default)("".concat(prefixCls, "-content"), _defineProperty(_defineProperty({}, "".concat(prefixCls, "-content-active"), isActive2), "".concat(prefixCls, "-content-inactive"), !isActive2), className2),
    style: style2,
    role
  }, /* @__PURE__ */ import_react45.default.createElement("div", {
    className: (0, import_classnames17.default)("".concat(prefixCls, "-content-box"), customizeClassNames === null || customizeClassNames === void 0 ? void 0 : customizeClassNames.body),
    style: styles === null || styles === void 0 ? void 0 : styles.body
  }, children));
});
PanelContent.displayName = "PanelContent";
var PanelContent_default = PanelContent;

// ../../node_modules/rc-collapse/es/Panel.js
var _excluded8 = ["showArrow", "headerClass", "isActive", "onItemClick", "forceRender", "className", "classNames", "styles", "prefixCls", "collapsible", "accordion", "panelKey", "extra", "header", "expandIcon", "openMotion", "destroyInactivePanel", "children"];
var CollapsePanel = /* @__PURE__ */ import_react46.default.forwardRef(function(props, ref3) {
  var _props$showArrow = props.showArrow, showArrow = _props$showArrow === void 0 ? true : _props$showArrow, headerClass = props.headerClass, isActive2 = props.isActive, onItemClick = props.onItemClick, forceRender = props.forceRender, className2 = props.className, _props$classNames = props.classNames, customizeClassNames = _props$classNames === void 0 ? {} : _props$classNames, _props$styles = props.styles, styles = _props$styles === void 0 ? {} : _props$styles, prefixCls = props.prefixCls, collapsible = props.collapsible, accordion = props.accordion, panelKey = props.panelKey, extra = props.extra, header = props.header, expandIcon = props.expandIcon, openMotion = props.openMotion, destroyInactivePanel = props.destroyInactivePanel, children = props.children, resetProps = _objectWithoutProperties(props, _excluded8);
  var disabled = collapsible === "disabled";
  var ifExtraExist = extra !== null && extra !== void 0 && typeof extra !== "boolean";
  var collapsibleProps = _defineProperty(_defineProperty(_defineProperty({
    onClick: function onClick() {
      onItemClick === null || onItemClick === void 0 || onItemClick(panelKey);
    },
    onKeyDown: function onKeyDown2(e3) {
      if (e3.key === "Enter" || e3.keyCode === KeyCode_default.ENTER || e3.which === KeyCode_default.ENTER) {
        onItemClick === null || onItemClick === void 0 || onItemClick(panelKey);
      }
    },
    role: accordion ? "tab" : "button"
  }, "aria-expanded", isActive2), "aria-disabled", disabled), "tabIndex", disabled ? -1 : 0);
  var iconNodeInner = typeof expandIcon === "function" ? expandIcon(props) : /* @__PURE__ */ import_react46.default.createElement("i", {
    className: "arrow"
  });
  var iconNode = iconNodeInner && /* @__PURE__ */ import_react46.default.createElement("div", _extends({
    className: "".concat(prefixCls, "-expand-icon")
  }, ["header", "icon"].includes(collapsible) ? collapsibleProps : {}), iconNodeInner);
  var collapsePanelClassNames = (0, import_classnames18.default)("".concat(prefixCls, "-item"), _defineProperty(_defineProperty({}, "".concat(prefixCls, "-item-active"), isActive2), "".concat(prefixCls, "-item-disabled"), disabled), className2);
  var headerClassName = (0, import_classnames18.default)(headerClass, "".concat(prefixCls, "-header"), _defineProperty({}, "".concat(prefixCls, "-collapsible-").concat(collapsible), !!collapsible), customizeClassNames.header);
  var headerProps = _objectSpread2({
    className: headerClassName,
    style: styles.header
  }, ["header", "icon"].includes(collapsible) ? {} : collapsibleProps);
  return /* @__PURE__ */ import_react46.default.createElement("div", _extends({}, resetProps, {
    ref: ref3,
    className: collapsePanelClassNames
  }), /* @__PURE__ */ import_react46.default.createElement("div", headerProps, showArrow && iconNode, /* @__PURE__ */ import_react46.default.createElement("span", _extends({
    className: "".concat(prefixCls, "-header-text")
  }, collapsible === "header" ? collapsibleProps : {}), header), ifExtraExist && /* @__PURE__ */ import_react46.default.createElement("div", {
    className: "".concat(prefixCls, "-extra")
  }, extra)), /* @__PURE__ */ import_react46.default.createElement(es_default2, _extends({
    visible: isActive2,
    leavedClassName: "".concat(prefixCls, "-content-hidden")
  }, openMotion, {
    forceRender,
    removeOnLeave: destroyInactivePanel
  }), function(_ref, motionRef) {
    var motionClassName = _ref.className, motionStyle = _ref.style;
    return /* @__PURE__ */ import_react46.default.createElement(PanelContent_default, {
      ref: motionRef,
      prefixCls,
      className: motionClassName,
      classNames: customizeClassNames,
      style: motionStyle,
      styles,
      isActive: isActive2,
      forceRender,
      role: accordion ? "tabpanel" : void 0
    }, children);
  }));
});
var Panel_default = CollapsePanel;

// ../../node_modules/rc-collapse/es/hooks/useItems.js
var _excluded9 = ["children", "label", "key", "collapsible", "onItemClick", "destroyInactivePanel"];
var convertItemsToNodes = function convertItemsToNodes2(items, props) {
  var prefixCls = props.prefixCls, accordion = props.accordion, collapsible = props.collapsible, destroyInactivePanel = props.destroyInactivePanel, onItemClick = props.onItemClick, activeKey = props.activeKey, openMotion = props.openMotion, expandIcon = props.expandIcon;
  return items.map(function(item, index3) {
    var children = item.children, label = item.label, rawKey = item.key, rawCollapsible = item.collapsible, rawOnItemClick = item.onItemClick, rawDestroyInactivePanel = item.destroyInactivePanel, restProps = _objectWithoutProperties(item, _excluded9);
    var key2 = String(rawKey !== null && rawKey !== void 0 ? rawKey : index3);
    var mergeCollapsible = rawCollapsible !== null && rawCollapsible !== void 0 ? rawCollapsible : collapsible;
    var mergeDestroyInactivePanel = rawDestroyInactivePanel !== null && rawDestroyInactivePanel !== void 0 ? rawDestroyInactivePanel : destroyInactivePanel;
    var handleItemClick = function handleItemClick2(value) {
      if (mergeCollapsible === "disabled") return;
      onItemClick(value);
      rawOnItemClick === null || rawOnItemClick === void 0 || rawOnItemClick(value);
    };
    var isActive2 = false;
    if (accordion) {
      isActive2 = activeKey[0] === key2;
    } else {
      isActive2 = activeKey.indexOf(key2) > -1;
    }
    return /* @__PURE__ */ import_react47.default.createElement(Panel_default, _extends({}, restProps, {
      prefixCls,
      key: key2,
      panelKey: key2,
      isActive: isActive2,
      accordion,
      openMotion,
      expandIcon,
      header: label,
      collapsible: mergeCollapsible,
      onItemClick: handleItemClick,
      destroyInactivePanel: mergeDestroyInactivePanel
    }), children);
  });
};
var getNewChild = function getNewChild2(child, index3, props) {
  if (!child) return null;
  var prefixCls = props.prefixCls, accordion = props.accordion, collapsible = props.collapsible, destroyInactivePanel = props.destroyInactivePanel, onItemClick = props.onItemClick, activeKey = props.activeKey, openMotion = props.openMotion, expandIcon = props.expandIcon;
  var key2 = child.key || String(index3);
  var _child$props = child.props, header = _child$props.header, headerClass = _child$props.headerClass, childDestroyInactivePanel = _child$props.destroyInactivePanel, childCollapsible = _child$props.collapsible, childOnItemClick = _child$props.onItemClick;
  var isActive2 = false;
  if (accordion) {
    isActive2 = activeKey[0] === key2;
  } else {
    isActive2 = activeKey.indexOf(key2) > -1;
  }
  var mergeCollapsible = childCollapsible !== null && childCollapsible !== void 0 ? childCollapsible : collapsible;
  var handleItemClick = function handleItemClick2(value) {
    if (mergeCollapsible === "disabled") return;
    onItemClick(value);
    childOnItemClick === null || childOnItemClick === void 0 || childOnItemClick(value);
  };
  var childProps = {
    key: key2,
    panelKey: key2,
    header,
    headerClass,
    isActive: isActive2,
    prefixCls,
    destroyInactivePanel: childDestroyInactivePanel !== null && childDestroyInactivePanel !== void 0 ? childDestroyInactivePanel : destroyInactivePanel,
    openMotion,
    accordion,
    children: child.props.children,
    onItemClick: handleItemClick,
    expandIcon,
    collapsible: mergeCollapsible
  };
  if (typeof child.type === "string") {
    return child;
  }
  Object.keys(childProps).forEach(function(propName) {
    if (typeof childProps[propName] === "undefined") {
      delete childProps[propName];
    }
  });
  return /* @__PURE__ */ import_react47.default.cloneElement(child, childProps);
};
function useItems(items, rawChildren, props) {
  if (Array.isArray(items)) {
    return convertItemsToNodes(items, props);
  }
  return toArray(rawChildren).map(function(child, index3) {
    return getNewChild(child, index3, props);
  });
}
var useItems_default = useItems;

// ../../node_modules/rc-collapse/es/Collapse.js
function getActiveKeysArray(activeKey) {
  var currentActiveKey = activeKey;
  if (!Array.isArray(currentActiveKey)) {
    var activeKeyType = _typeof(currentActiveKey);
    currentActiveKey = activeKeyType === "number" || activeKeyType === "string" ? [currentActiveKey] : [];
  }
  return currentActiveKey.map(function(key2) {
    return String(key2);
  });
}
var Collapse = /* @__PURE__ */ import_react48.default.forwardRef(function(props, ref3) {
  var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-collapse" : _props$prefixCls, _props$destroyInactiv = props.destroyInactivePanel, destroyInactivePanel = _props$destroyInactiv === void 0 ? false : _props$destroyInactiv, style2 = props.style, accordion = props.accordion, className2 = props.className, children = props.children, collapsible = props.collapsible, openMotion = props.openMotion, expandIcon = props.expandIcon, rawActiveKey = props.activeKey, defaultActiveKey = props.defaultActiveKey, _onChange = props.onChange, items = props.items;
  var collapseClassName = (0, import_classnames19.default)(prefixCls, className2);
  var _useMergedState = useMergedState([], {
    value: rawActiveKey,
    onChange: function onChange(v) {
      return _onChange === null || _onChange === void 0 ? void 0 : _onChange(v);
    },
    defaultValue: defaultActiveKey,
    postState: getActiveKeysArray
  }), _useMergedState2 = _slicedToArray(_useMergedState, 2), activeKey = _useMergedState2[0], setActiveKey = _useMergedState2[1];
  var onItemClick = function onItemClick2(key2) {
    return setActiveKey(function() {
      if (accordion) {
        return activeKey[0] === key2 ? [] : [key2];
      }
      var index3 = activeKey.indexOf(key2);
      var isActive2 = index3 > -1;
      if (isActive2) {
        return activeKey.filter(function(item) {
          return item !== key2;
        });
      }
      return [].concat(_toConsumableArray(activeKey), [key2]);
    });
  };
  warning_default(!children, "[rc-collapse] `children` will be removed in next major version. Please use `items` instead.");
  var mergedChildren = useItems_default(items, children, {
    prefixCls,
    accordion,
    openMotion,
    expandIcon,
    collapsible,
    destroyInactivePanel,
    onItemClick,
    activeKey
  });
  return /* @__PURE__ */ import_react48.default.createElement("div", _extends({
    ref: ref3,
    className: collapseClassName,
    style: style2,
    role: accordion ? "tablist" : void 0
  }, pickAttrs(props, {
    aria: true,
    data: true
  })), mergedChildren);
});
var Collapse_default = Object.assign(Collapse, {
  /**
   * @deprecated use `items` instead, will be removed in `v4.0.0`
   */
  Panel: Panel_default
});

// ../../node_modules/rc-collapse/es/index.js
var es_default3 = Collapse_default;
var Panel = Collapse_default.Panel;

// ../../node_modules/antd/es/collapse/CollapsePanel.js
var React84 = __toESM(require_react());
var import_classnames20 = __toESM(require_classnames());
var CollapsePanel2 = /* @__PURE__ */ React84.forwardRef((props, ref3) => {
  if (true) {
    const warning6 = devUseWarning("Collapse.Panel");
    warning6.deprecated(!("disabled" in props), "disabled", 'collapsible="disabled"');
  }
  const {
    getPrefixCls
  } = React84.useContext(ConfigContext);
  const {
    prefixCls: customizePrefixCls,
    className: className2,
    showArrow = true
  } = props;
  const prefixCls = getPrefixCls("collapse", customizePrefixCls);
  const collapsePanelClassName = (0, import_classnames20.default)({
    [`${prefixCls}-no-arrow`]: !showArrow
  }, className2);
  return /* @__PURE__ */ React84.createElement(es_default3.Panel, Object.assign({
    ref: ref3
  }, props, {
    prefixCls,
    className: collapsePanelClassName
  }));
});
var CollapsePanel_default = CollapsePanel2;

// ../../node_modules/antd/es/style/motion/collapse.js
var genCollapseMotion = (token2) => ({
  [token2.componentCls]: {
    // For common/openAnimation
    [`${token2.antCls}-motion-collapse-legacy`]: {
      overflow: "hidden",
      "&-active": {
        transition: `height ${token2.motionDurationMid} ${token2.motionEaseInOut},
        opacity ${token2.motionDurationMid} ${token2.motionEaseInOut} !important`
      }
    },
    [`${token2.antCls}-motion-collapse`]: {
      overflow: "hidden",
      transition: `height ${token2.motionDurationMid} ${token2.motionEaseInOut},
        opacity ${token2.motionDurationMid} ${token2.motionEaseInOut} !important`
    }
  }
});
var collapse_default = genCollapseMotion;

// ../../node_modules/antd/es/style/motion/motion.js
var initMotionCommon = (duration) => ({
  animationDuration: duration,
  animationFillMode: "both"
});
var initMotionCommonLeave = (duration) => ({
  animationDuration: duration,
  animationFillMode: "both"
});
var initMotion = (motionCls, inKeyframes, outKeyframes, duration, sameLevel = false) => {
  const sameLevelPrefix = sameLevel ? "&" : "";
  return {
    [`
      ${sameLevelPrefix}${motionCls}-enter,
      ${sameLevelPrefix}${motionCls}-appear
    `]: Object.assign(Object.assign({}, initMotionCommon(duration)), {
      animationPlayState: "paused"
    }),
    [`${sameLevelPrefix}${motionCls}-leave`]: Object.assign(Object.assign({}, initMotionCommonLeave(duration)), {
      animationPlayState: "paused"
    }),
    [`
      ${sameLevelPrefix}${motionCls}-enter${motionCls}-enter-active,
      ${sameLevelPrefix}${motionCls}-appear${motionCls}-appear-active
    `]: {
      animationName: inKeyframes,
      animationPlayState: "running"
    },
    [`${sameLevelPrefix}${motionCls}-leave${motionCls}-leave-active`]: {
      animationName: outKeyframes,
      animationPlayState: "running",
      pointerEvents: "none"
    }
  };
};

// ../../node_modules/antd/es/style/motion/fade.js
var fadeIn = new Keyframes_default("antFadeIn", {
  "0%": {
    opacity: 0
  },
  "100%": {
    opacity: 1
  }
});
var fadeOut = new Keyframes_default("antFadeOut", {
  "0%": {
    opacity: 1
  },
  "100%": {
    opacity: 0
  }
});
var initFadeMotion = (token2, sameLevel = false) => {
  const {
    antCls
  } = token2;
  const motionCls = `${antCls}-fade`;
  const sameLevelPrefix = sameLevel ? "&" : "";
  return [initMotion(motionCls, fadeIn, fadeOut, token2.motionDurationMid, sameLevel), {
    [`
        ${sameLevelPrefix}${motionCls}-enter,
        ${sameLevelPrefix}${motionCls}-appear
      `]: {
      opacity: 0,
      animationTimingFunction: "linear"
    },
    [`${sameLevelPrefix}${motionCls}-leave`]: {
      animationTimingFunction: "linear"
    }
  }];
};

// ../../node_modules/antd/es/style/motion/move.js
var moveDownIn = new Keyframes_default("antMoveDownIn", {
  "0%": {
    transform: "translate3d(0, 100%, 0)",
    transformOrigin: "0 0",
    opacity: 0
  },
  "100%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  }
});
var moveDownOut = new Keyframes_default("antMoveDownOut", {
  "0%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  },
  "100%": {
    transform: "translate3d(0, 100%, 0)",
    transformOrigin: "0 0",
    opacity: 0
  }
});
var moveLeftIn = new Keyframes_default("antMoveLeftIn", {
  "0%": {
    transform: "translate3d(-100%, 0, 0)",
    transformOrigin: "0 0",
    opacity: 0
  },
  "100%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  }
});
var moveLeftOut = new Keyframes_default("antMoveLeftOut", {
  "0%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  },
  "100%": {
    transform: "translate3d(-100%, 0, 0)",
    transformOrigin: "0 0",
    opacity: 0
  }
});
var moveRightIn = new Keyframes_default("antMoveRightIn", {
  "0%": {
    transform: "translate3d(100%, 0, 0)",
    transformOrigin: "0 0",
    opacity: 0
  },
  "100%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  }
});
var moveRightOut = new Keyframes_default("antMoveRightOut", {
  "0%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  },
  "100%": {
    transform: "translate3d(100%, 0, 0)",
    transformOrigin: "0 0",
    opacity: 0
  }
});
var moveUpIn = new Keyframes_default("antMoveUpIn", {
  "0%": {
    transform: "translate3d(0, -100%, 0)",
    transformOrigin: "0 0",
    opacity: 0
  },
  "100%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  }
});
var moveUpOut = new Keyframes_default("antMoveUpOut", {
  "0%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  },
  "100%": {
    transform: "translate3d(0, -100%, 0)",
    transformOrigin: "0 0",
    opacity: 0
  }
});
var moveMotion = {
  "move-up": {
    inKeyframes: moveUpIn,
    outKeyframes: moveUpOut
  },
  "move-down": {
    inKeyframes: moveDownIn,
    outKeyframes: moveDownOut
  },
  "move-left": {
    inKeyframes: moveLeftIn,
    outKeyframes: moveLeftOut
  },
  "move-right": {
    inKeyframes: moveRightIn,
    outKeyframes: moveRightOut
  }
};
var initMoveMotion = (token2, motionName) => {
  const {
    antCls
  } = token2;
  const motionCls = `${antCls}-${motionName}`;
  const {
    inKeyframes,
    outKeyframes
  } = moveMotion[motionName];
  return [initMotion(motionCls, inKeyframes, outKeyframes, token2.motionDurationMid), {
    [`
        ${motionCls}-enter,
        ${motionCls}-appear
      `]: {
      opacity: 0,
      animationTimingFunction: token2.motionEaseOutCirc
    },
    [`${motionCls}-leave`]: {
      animationTimingFunction: token2.motionEaseInOutCirc
    }
  }];
};

// ../../node_modules/antd/es/style/motion/slide.js
var slideUpIn = new Keyframes_default("antSlideUpIn", {
  "0%": {
    transform: "scaleY(0.8)",
    transformOrigin: "0% 0%",
    opacity: 0
  },
  "100%": {
    transform: "scaleY(1)",
    transformOrigin: "0% 0%",
    opacity: 1
  }
});
var slideUpOut = new Keyframes_default("antSlideUpOut", {
  "0%": {
    transform: "scaleY(1)",
    transformOrigin: "0% 0%",
    opacity: 1
  },
  "100%": {
    transform: "scaleY(0.8)",
    transformOrigin: "0% 0%",
    opacity: 0
  }
});
var slideDownIn = new Keyframes_default("antSlideDownIn", {
  "0%": {
    transform: "scaleY(0.8)",
    transformOrigin: "100% 100%",
    opacity: 0
  },
  "100%": {
    transform: "scaleY(1)",
    transformOrigin: "100% 100%",
    opacity: 1
  }
});
var slideDownOut = new Keyframes_default("antSlideDownOut", {
  "0%": {
    transform: "scaleY(1)",
    transformOrigin: "100% 100%",
    opacity: 1
  },
  "100%": {
    transform: "scaleY(0.8)",
    transformOrigin: "100% 100%",
    opacity: 0
  }
});
var slideLeftIn = new Keyframes_default("antSlideLeftIn", {
  "0%": {
    transform: "scaleX(0.8)",
    transformOrigin: "0% 0%",
    opacity: 0
  },
  "100%": {
    transform: "scaleX(1)",
    transformOrigin: "0% 0%",
    opacity: 1
  }
});
var slideLeftOut = new Keyframes_default("antSlideLeftOut", {
  "0%": {
    transform: "scaleX(1)",
    transformOrigin: "0% 0%",
    opacity: 1
  },
  "100%": {
    transform: "scaleX(0.8)",
    transformOrigin: "0% 0%",
    opacity: 0
  }
});
var slideRightIn = new Keyframes_default("antSlideRightIn", {
  "0%": {
    transform: "scaleX(0.8)",
    transformOrigin: "100% 0%",
    opacity: 0
  },
  "100%": {
    transform: "scaleX(1)",
    transformOrigin: "100% 0%",
    opacity: 1
  }
});
var slideRightOut = new Keyframes_default("antSlideRightOut", {
  "0%": {
    transform: "scaleX(1)",
    transformOrigin: "100% 0%",
    opacity: 1
  },
  "100%": {
    transform: "scaleX(0.8)",
    transformOrigin: "100% 0%",
    opacity: 0
  }
});
var slideMotion = {
  "slide-up": {
    inKeyframes: slideUpIn,
    outKeyframes: slideUpOut
  },
  "slide-down": {
    inKeyframes: slideDownIn,
    outKeyframes: slideDownOut
  },
  "slide-left": {
    inKeyframes: slideLeftIn,
    outKeyframes: slideLeftOut
  },
  "slide-right": {
    inKeyframes: slideRightIn,
    outKeyframes: slideRightOut
  }
};
var initSlideMotion = (token2, motionName) => {
  const {
    antCls
  } = token2;
  const motionCls = `${antCls}-${motionName}`;
  const {
    inKeyframes,
    outKeyframes
  } = slideMotion[motionName];
  return [initMotion(motionCls, inKeyframes, outKeyframes, token2.motionDurationMid), {
    [`
      ${motionCls}-enter,
      ${motionCls}-appear
    `]: {
      transform: "scale(0)",
      transformOrigin: "0% 0%",
      opacity: 0,
      animationTimingFunction: token2.motionEaseOutQuint,
      "&-prepare": {
        transform: "scale(1)"
      }
    },
    [`${motionCls}-leave`]: {
      animationTimingFunction: token2.motionEaseInQuint
    }
  }];
};

// ../../node_modules/antd/es/style/motion/zoom.js
var zoomIn = new Keyframes_default("antZoomIn", {
  "0%": {
    transform: "scale(0.2)",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    opacity: 1
  }
});
var zoomOut = new Keyframes_default("antZoomOut", {
  "0%": {
    transform: "scale(1)"
  },
  "100%": {
    transform: "scale(0.2)",
    opacity: 0
  }
});
var zoomBigIn = new Keyframes_default("antZoomBigIn", {
  "0%": {
    transform: "scale(0.8)",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    opacity: 1
  }
});
var zoomBigOut = new Keyframes_default("antZoomBigOut", {
  "0%": {
    transform: "scale(1)"
  },
  "100%": {
    transform: "scale(0.8)",
    opacity: 0
  }
});
var zoomUpIn = new Keyframes_default("antZoomUpIn", {
  "0%": {
    transform: "scale(0.8)",
    transformOrigin: "50% 0%",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    transformOrigin: "50% 0%"
  }
});
var zoomUpOut = new Keyframes_default("antZoomUpOut", {
  "0%": {
    transform: "scale(1)",
    transformOrigin: "50% 0%"
  },
  "100%": {
    transform: "scale(0.8)",
    transformOrigin: "50% 0%",
    opacity: 0
  }
});
var zoomLeftIn = new Keyframes_default("antZoomLeftIn", {
  "0%": {
    transform: "scale(0.8)",
    transformOrigin: "0% 50%",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    transformOrigin: "0% 50%"
  }
});
var zoomLeftOut = new Keyframes_default("antZoomLeftOut", {
  "0%": {
    transform: "scale(1)",
    transformOrigin: "0% 50%"
  },
  "100%": {
    transform: "scale(0.8)",
    transformOrigin: "0% 50%",
    opacity: 0
  }
});
var zoomRightIn = new Keyframes_default("antZoomRightIn", {
  "0%": {
    transform: "scale(0.8)",
    transformOrigin: "100% 50%",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    transformOrigin: "100% 50%"
  }
});
var zoomRightOut = new Keyframes_default("antZoomRightOut", {
  "0%": {
    transform: "scale(1)",
    transformOrigin: "100% 50%"
  },
  "100%": {
    transform: "scale(0.8)",
    transformOrigin: "100% 50%",
    opacity: 0
  }
});
var zoomDownIn = new Keyframes_default("antZoomDownIn", {
  "0%": {
    transform: "scale(0.8)",
    transformOrigin: "50% 100%",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    transformOrigin: "50% 100%"
  }
});
var zoomDownOut = new Keyframes_default("antZoomDownOut", {
  "0%": {
    transform: "scale(1)",
    transformOrigin: "50% 100%"
  },
  "100%": {
    transform: "scale(0.8)",
    transformOrigin: "50% 100%",
    opacity: 0
  }
});
var zoomMotion = {
  zoom: {
    inKeyframes: zoomIn,
    outKeyframes: zoomOut
  },
  "zoom-big": {
    inKeyframes: zoomBigIn,
    outKeyframes: zoomBigOut
  },
  "zoom-big-fast": {
    inKeyframes: zoomBigIn,
    outKeyframes: zoomBigOut
  },
  "zoom-left": {
    inKeyframes: zoomLeftIn,
    outKeyframes: zoomLeftOut
  },
  "zoom-right": {
    inKeyframes: zoomRightIn,
    outKeyframes: zoomRightOut
  },
  "zoom-up": {
    inKeyframes: zoomUpIn,
    outKeyframes: zoomUpOut
  },
  "zoom-down": {
    inKeyframes: zoomDownIn,
    outKeyframes: zoomDownOut
  }
};
var initZoomMotion = (token2, motionName) => {
  const {
    antCls
  } = token2;
  const motionCls = `${antCls}-${motionName}`;
  const {
    inKeyframes,
    outKeyframes
  } = zoomMotion[motionName];
  return [initMotion(motionCls, inKeyframes, outKeyframes, motionName === "zoom-big-fast" ? token2.motionDurationFast : token2.motionDurationMid), {
    [`
        ${motionCls}-enter,
        ${motionCls}-appear
      `]: {
      transform: "scale(0)",
      opacity: 0,
      animationTimingFunction: token2.motionEaseOutCirc,
      "&-prepare": {
        transform: "none"
      }
    },
    [`${motionCls}-leave`]: {
      animationTimingFunction: token2.motionEaseInOutCirc
    }
  }];
};

// ../../node_modules/antd/es/collapse/style/index.js
var genBaseStyle = (token2) => {
  const {
    componentCls,
    contentBg,
    padding,
    headerBg,
    headerPadding,
    collapseHeaderPaddingSM,
    collapseHeaderPaddingLG,
    collapsePanelBorderRadius,
    lineWidth,
    lineType,
    colorBorder,
    colorText,
    colorTextHeading,
    colorTextDisabled,
    fontSizeLG,
    lineHeight,
    lineHeightLG,
    marginSM,
    paddingSM,
    paddingLG,
    paddingXS,
    motionDurationSlow,
    fontSizeIcon,
    contentPadding,
    fontHeight,
    fontHeightLG
  } = token2;
  const borderBase = `${unit(lineWidth)} ${lineType} ${colorBorder}`;
  return {
    [componentCls]: Object.assign(Object.assign({}, resetComponent(token2)), {
      backgroundColor: headerBg,
      border: borderBase,
      borderRadius: collapsePanelBorderRadius,
      "&-rtl": {
        direction: "rtl"
      },
      [`& > ${componentCls}-item`]: {
        borderBottom: borderBase,
        "&:first-child": {
          [`
            &,
            & > ${componentCls}-header`]: {
            borderRadius: `${unit(collapsePanelBorderRadius)} ${unit(collapsePanelBorderRadius)} 0 0`
          }
        },
        "&:last-child": {
          [`
            &,
            & > ${componentCls}-header`]: {
            borderRadius: `0 0 ${unit(collapsePanelBorderRadius)} ${unit(collapsePanelBorderRadius)}`
          }
        },
        [`> ${componentCls}-header`]: Object.assign(Object.assign({
          position: "relative",
          display: "flex",
          flexWrap: "nowrap",
          alignItems: "flex-start",
          padding: headerPadding,
          color: colorTextHeading,
          lineHeight,
          cursor: "pointer",
          transition: `all ${motionDurationSlow}, visibility 0s`
        }, genFocusStyle(token2)), {
          [`> ${componentCls}-header-text`]: {
            flex: "auto"
          },
          // >>>>> Arrow
          [`${componentCls}-expand-icon`]: {
            height: fontHeight,
            display: "flex",
            alignItems: "center",
            paddingInlineEnd: marginSM
          },
          [`${componentCls}-arrow`]: Object.assign(Object.assign({}, resetIcon()), {
            fontSize: fontSizeIcon,
            // when `transform: rotate()` is applied to icon's root element
            transition: `transform ${motionDurationSlow}`,
            // when `transform: rotate()` is applied to icon's child element
            svg: {
              transition: `transform ${motionDurationSlow}`
            }
          }),
          // >>>>> Text
          [`${componentCls}-header-text`]: {
            marginInlineEnd: "auto"
          }
        }),
        [`${componentCls}-collapsible-header`]: {
          cursor: "default",
          [`${componentCls}-header-text`]: {
            flex: "none",
            cursor: "pointer"
          },
          [`${componentCls}-expand-icon`]: {
            cursor: "pointer"
          }
        },
        [`${componentCls}-collapsible-icon`]: {
          cursor: "unset",
          [`${componentCls}-expand-icon`]: {
            cursor: "pointer"
          }
        }
      },
      [`${componentCls}-content`]: {
        color: colorText,
        backgroundColor: contentBg,
        borderTop: borderBase,
        [`& > ${componentCls}-content-box`]: {
          padding: contentPadding
        },
        "&-hidden": {
          display: "none"
        }
      },
      "&-small": {
        [`> ${componentCls}-item`]: {
          [`> ${componentCls}-header`]: {
            padding: collapseHeaderPaddingSM,
            paddingInlineStart: paddingXS,
            [`> ${componentCls}-expand-icon`]: {
              // Arrow offset
              marginInlineStart: token2.calc(paddingSM).sub(paddingXS).equal()
            }
          },
          [`> ${componentCls}-content > ${componentCls}-content-box`]: {
            padding: paddingSM
          }
        }
      },
      "&-large": {
        [`> ${componentCls}-item`]: {
          fontSize: fontSizeLG,
          lineHeight: lineHeightLG,
          [`> ${componentCls}-header`]: {
            padding: collapseHeaderPaddingLG,
            paddingInlineStart: padding,
            [`> ${componentCls}-expand-icon`]: {
              height: fontHeightLG,
              // Arrow offset
              marginInlineStart: token2.calc(paddingLG).sub(padding).equal()
            }
          },
          [`> ${componentCls}-content > ${componentCls}-content-box`]: {
            padding: paddingLG
          }
        }
      },
      [`${componentCls}-item:last-child`]: {
        borderBottom: 0,
        [`> ${componentCls}-content`]: {
          borderRadius: `0 0 ${unit(collapsePanelBorderRadius)} ${unit(collapsePanelBorderRadius)}`
        }
      },
      [`& ${componentCls}-item-disabled > ${componentCls}-header`]: {
        [`
          &,
          & > .arrow
        `]: {
          color: colorTextDisabled,
          cursor: "not-allowed"
        }
      },
      // ========================== Icon Position ==========================
      [`&${componentCls}-icon-position-end`]: {
        [`& > ${componentCls}-item`]: {
          [`> ${componentCls}-header`]: {
            [`${componentCls}-expand-icon`]: {
              order: 1,
              paddingInlineEnd: 0,
              paddingInlineStart: marginSM
            }
          }
        }
      }
    })
  };
};
var genArrowStyle = (token2) => {
  const {
    componentCls
  } = token2;
  const fixedSelector = `> ${componentCls}-item > ${componentCls}-header ${componentCls}-arrow`;
  return {
    [`${componentCls}-rtl`]: {
      [fixedSelector]: {
        transform: `rotate(180deg)`
      }
    }
  };
};
var genBorderlessStyle = (token2) => {
  const {
    componentCls,
    headerBg,
    borderlessContentPadding,
    borderlessContentBg,
    colorBorder
  } = token2;
  return {
    [`${componentCls}-borderless`]: {
      backgroundColor: headerBg,
      border: 0,
      [`> ${componentCls}-item`]: {
        borderBottom: `1px solid ${colorBorder}`
      },
      [`
        > ${componentCls}-item:last-child,
        > ${componentCls}-item:last-child ${componentCls}-header
      `]: {
        borderRadius: 0
      },
      [`> ${componentCls}-item:last-child`]: {
        borderBottom: 0
      },
      [`> ${componentCls}-item > ${componentCls}-content`]: {
        backgroundColor: borderlessContentBg,
        borderTop: 0
      },
      [`> ${componentCls}-item > ${componentCls}-content > ${componentCls}-content-box`]: {
        padding: borderlessContentPadding
      }
    }
  };
};
var genGhostStyle = (token2) => {
  const {
    componentCls,
    paddingSM
  } = token2;
  return {
    [`${componentCls}-ghost`]: {
      backgroundColor: "transparent",
      border: 0,
      [`> ${componentCls}-item`]: {
        borderBottom: 0,
        [`> ${componentCls}-content`]: {
          backgroundColor: "transparent",
          border: 0,
          [`> ${componentCls}-content-box`]: {
            paddingBlock: paddingSM
          }
        }
      }
    }
  };
};
var prepareComponentToken2 = (token2) => ({
  headerPadding: `${token2.paddingSM}px ${token2.padding}px`,
  headerBg: token2.colorFillAlter,
  contentPadding: `${token2.padding}px 16px`,
  // Fixed Value
  contentBg: token2.colorBgContainer,
  borderlessContentPadding: `${token2.paddingXXS}px 16px ${token2.padding}px`,
  borderlessContentBg: "transparent"
});
var style_default4 = genStyleHooks("Collapse", (token2) => {
  const collapseToken = merge2(token2, {
    collapseHeaderPaddingSM: `${unit(token2.paddingXS)} ${unit(token2.paddingSM)}`,
    collapseHeaderPaddingLG: `${unit(token2.padding)} ${unit(token2.paddingLG)}`,
    collapsePanelBorderRadius: token2.borderRadiusLG
  });
  return [genBaseStyle(collapseToken), genBorderlessStyle(collapseToken), genGhostStyle(collapseToken), genArrowStyle(collapseToken), collapse_default(collapseToken)];
}, prepareComponentToken2);

// ../../node_modules/antd/es/collapse/Collapse.js
var Collapse2 = /* @__PURE__ */ React85.forwardRef((props, ref3) => {
  const {
    getPrefixCls,
    direction,
    expandIcon: contextExpandIcon,
    className: contextClassName,
    style: contextStyle
  } = useComponentConfig("collapse");
  const {
    prefixCls: customizePrefixCls,
    className: className2,
    rootClassName,
    style: style2,
    bordered = true,
    ghost,
    size: customizeSize,
    expandIconPosition = "start",
    children,
    destroyInactivePanel,
    destroyOnHidden,
    expandIcon
  } = props;
  const mergedSize = useSize_default((ctx) => {
    var _a;
    return (_a = customizeSize !== null && customizeSize !== void 0 ? customizeSize : ctx) !== null && _a !== void 0 ? _a : "middle";
  });
  const prefixCls = getPrefixCls("collapse", customizePrefixCls);
  const rootPrefixCls = getPrefixCls();
  const [wrapCSSVar, hashId, cssVarCls] = style_default4(prefixCls);
  if (true) {
    const warning6 = devUseWarning("Collapse");
    true ? warning6(expandIconPosition !== "left" && expandIconPosition !== "right", "deprecated", "`expandIconPosition` with `left` or `right` is deprecated. Please use `start` or `end` instead.") : void 0;
    warning6.deprecated(!("destroyInactivePanel" in props), "destroyInactivePanel", "destroyOnHidden");
  }
  const mergedExpandIconPosition = React85.useMemo(() => {
    if (expandIconPosition === "left") {
      return "start";
    }
    return expandIconPosition === "right" ? "end" : expandIconPosition;
  }, [expandIconPosition]);
  const mergedExpandIcon = expandIcon !== null && expandIcon !== void 0 ? expandIcon : contextExpandIcon;
  const renderExpandIcon3 = React85.useCallback((panelProps = {}) => {
    const icon = typeof mergedExpandIcon === "function" ? mergedExpandIcon(panelProps) : /* @__PURE__ */ React85.createElement(RightOutlined_default2, {
      rotate: panelProps.isActive ? direction === "rtl" ? -90 : 90 : void 0,
      "aria-label": panelProps.isActive ? "expanded" : "collapsed"
    });
    return cloneElement4(icon, () => {
      var _a;
      return {
        className: (0, import_classnames21.default)((_a = icon.props) === null || _a === void 0 ? void 0 : _a.className, `${prefixCls}-arrow`)
      };
    });
  }, [mergedExpandIcon, prefixCls, direction]);
  const collapseClassName = (0, import_classnames21.default)(`${prefixCls}-icon-position-${mergedExpandIconPosition}`, {
    [`${prefixCls}-borderless`]: !bordered,
    [`${prefixCls}-rtl`]: direction === "rtl",
    [`${prefixCls}-ghost`]: !!ghost,
    [`${prefixCls}-${mergedSize}`]: mergedSize !== "middle"
  }, contextClassName, className2, rootClassName, hashId, cssVarCls);
  const openMotion = React85.useMemo(() => Object.assign(Object.assign({}, motion_default(rootPrefixCls)), {
    motionAppear: false,
    leavedClassName: `${prefixCls}-content-hidden`
  }), [rootPrefixCls, prefixCls]);
  const items = React85.useMemo(() => {
    if (!children) {
      return null;
    }
    return toArray(children).map((child, index3) => {
      var _a, _b;
      const childProps = child.props;
      if (childProps === null || childProps === void 0 ? void 0 : childProps.disabled) {
        const key2 = (_a = child.key) !== null && _a !== void 0 ? _a : String(index3);
        const mergedChildProps = Object.assign(Object.assign({}, omit(child.props, ["disabled"])), {
          key: key2,
          collapsible: (_b = childProps.collapsible) !== null && _b !== void 0 ? _b : "disabled"
        });
        return cloneElement4(child, mergedChildProps);
      }
      return child;
    });
  }, [children]);
  return wrapCSSVar(
    // @ts-ignore
    /* @__PURE__ */ React85.createElement(es_default3, Object.assign({
      ref: ref3,
      openMotion
    }, omit(props, ["rootClassName"]), {
      expandIcon: renderExpandIcon3,
      prefixCls,
      className: collapseClassName,
      style: Object.assign(Object.assign({}, contextStyle), style2),
      // TODO: In the future, destroyInactivePanel in rc-collapse needs to be upgrade to destroyOnHidden
      destroyInactivePanel: destroyOnHidden !== null && destroyOnHidden !== void 0 ? destroyOnHidden : destroyInactivePanel
    }), items)
  );
});
if (true) {
  Collapse2.displayName = "Collapse";
}
var Collapse_default2 = Object.assign(Collapse2, {
  Panel: CollapsePanel_default
});

// ../../node_modules/antd/es/collapse/index.js
var collapse_default2 = Collapse_default2;

// ../../node_modules/antd/es/color-picker/util.js
var generateColor3 = (color) => {
  if (color instanceof AggregationColor) {
    return color;
  }
  return new AggregationColor(color);
};

// ../../node_modules/antd/es/color-picker/components/ColorPresets.js
var isBright = (value, bgColorToken) => {
  const {
    r: r2,
    g,
    b,
    a
  } = value.toRgb();
  const hsv = new Color(value.toRgbString()).onBackground(bgColorToken).toHsv();
  if (a <= 0.5) {
    return hsv.v > 0.5;
  }
  return r2 * 0.299 + g * 0.587 + b * 0.114 > 192;
};

// ../../node_modules/antd/es/button/style/token.js
var prepareToken = (token2) => {
  const {
    paddingInline,
    onlyIconSize
  } = token2;
  const buttonToken = merge2(token2, {
    buttonPaddingHorizontal: paddingInline,
    buttonPaddingVertical: 0,
    buttonIconOnlyFontSize: onlyIconSize
  });
  return buttonToken;
};
var prepareComponentToken3 = (token2) => {
  var _a, _b, _c, _d, _e, _f;
  const contentFontSize = (_a = token2.contentFontSize) !== null && _a !== void 0 ? _a : token2.fontSize;
  const contentFontSizeSM = (_b = token2.contentFontSizeSM) !== null && _b !== void 0 ? _b : token2.fontSize;
  const contentFontSizeLG = (_c = token2.contentFontSizeLG) !== null && _c !== void 0 ? _c : token2.fontSizeLG;
  const contentLineHeight = (_d = token2.contentLineHeight) !== null && _d !== void 0 ? _d : getLineHeight(contentFontSize);
  const contentLineHeightSM = (_e = token2.contentLineHeightSM) !== null && _e !== void 0 ? _e : getLineHeight(contentFontSizeSM);
  const contentLineHeightLG = (_f = token2.contentLineHeightLG) !== null && _f !== void 0 ? _f : getLineHeight(contentFontSizeLG);
  const solidTextColor = isBright(new AggregationColor(token2.colorBgSolid), "#fff") ? "#000" : "#fff";
  const shadowColorTokens = PresetColors.reduce((prev2, colorKey) => Object.assign(Object.assign({}, prev2), {
    [`${colorKey}ShadowColor`]: `0 ${unit(token2.controlOutlineWidth)} 0 ${getAlphaColor_default(token2[`${colorKey}1`], token2.colorBgContainer)}`
  }), {});
  return Object.assign(Object.assign({}, shadowColorTokens), {
    fontWeight: 400,
    iconGap: token2.marginXS,
    defaultShadow: `0 ${token2.controlOutlineWidth}px 0 ${token2.controlTmpOutline}`,
    primaryShadow: `0 ${token2.controlOutlineWidth}px 0 ${token2.controlOutline}`,
    dangerShadow: `0 ${token2.controlOutlineWidth}px 0 ${token2.colorErrorOutline}`,
    primaryColor: token2.colorTextLightSolid,
    dangerColor: token2.colorTextLightSolid,
    borderColorDisabled: token2.colorBorder,
    defaultGhostColor: token2.colorBgContainer,
    ghostBg: "transparent",
    defaultGhostBorderColor: token2.colorBgContainer,
    paddingInline: token2.paddingContentHorizontal - token2.lineWidth,
    paddingInlineLG: token2.paddingContentHorizontal - token2.lineWidth,
    paddingInlineSM: 8 - token2.lineWidth,
    onlyIconSize: "inherit",
    onlyIconSizeSM: "inherit",
    onlyIconSizeLG: "inherit",
    groupBorderColor: token2.colorPrimaryHover,
    linkHoverBg: "transparent",
    textTextColor: token2.colorText,
    textTextHoverColor: token2.colorText,
    textTextActiveColor: token2.colorText,
    textHoverBg: token2.colorFillTertiary,
    defaultColor: token2.colorText,
    defaultBg: token2.colorBgContainer,
    defaultBorderColor: token2.colorBorder,
    defaultBorderColorDisabled: token2.colorBorder,
    defaultHoverBg: token2.colorBgContainer,
    defaultHoverColor: token2.colorPrimaryHover,
    defaultHoverBorderColor: token2.colorPrimaryHover,
    defaultActiveBg: token2.colorBgContainer,
    defaultActiveColor: token2.colorPrimaryActive,
    defaultActiveBorderColor: token2.colorPrimaryActive,
    solidTextColor,
    contentFontSize,
    contentFontSizeSM,
    contentFontSizeLG,
    contentLineHeight,
    contentLineHeightSM,
    contentLineHeightLG,
    paddingBlock: Math.max((token2.controlHeight - contentFontSize * contentLineHeight) / 2 - token2.lineWidth, 0),
    paddingBlockSM: Math.max((token2.controlHeightSM - contentFontSizeSM * contentLineHeightSM) / 2 - token2.lineWidth, 0),
    paddingBlockLG: Math.max((token2.controlHeightLG - contentFontSizeLG * contentLineHeightLG) / 2 - token2.lineWidth, 0)
  });
};

// ../../node_modules/antd/es/button/style/index.js
var genSharedButtonStyle = (token2) => {
  const {
    componentCls,
    iconCls,
    fontWeight,
    opacityLoading,
    motionDurationSlow,
    motionEaseInOut,
    iconGap,
    calc
  } = token2;
  return {
    [componentCls]: {
      outline: "none",
      position: "relative",
      display: "inline-flex",
      gap: iconGap,
      alignItems: "center",
      justifyContent: "center",
      fontWeight,
      whiteSpace: "nowrap",
      textAlign: "center",
      backgroundImage: "none",
      background: "transparent",
      border: `${unit(token2.lineWidth)} ${token2.lineType} transparent`,
      cursor: "pointer",
      transition: `all ${token2.motionDurationMid} ${token2.motionEaseInOut}`,
      userSelect: "none",
      touchAction: "manipulation",
      color: token2.colorText,
      "&:disabled > *": {
        pointerEvents: "none"
      },
      // https://github.com/ant-design/ant-design/issues/51380
      [`${componentCls}-icon > svg`]: resetIcon(),
      "> a": {
        color: "currentColor"
      },
      "&:not(:disabled)": genFocusStyle(token2),
      [`&${componentCls}-two-chinese-chars::first-letter`]: {
        letterSpacing: "0.34em"
      },
      [`&${componentCls}-two-chinese-chars > *:not(${iconCls})`]: {
        marginInlineEnd: "-0.34em",
        letterSpacing: "0.34em"
      },
      [`&${componentCls}-icon-only`]: {
        paddingInline: 0,
        // make `btn-icon-only` not too narrow
        [`&${componentCls}-compact-item`]: {
          flex: "none"
        },
        [`&${componentCls}-round`]: {
          width: "auto"
        }
      },
      // Loading
      [`&${componentCls}-loading`]: {
        opacity: opacityLoading,
        cursor: "default"
      },
      [`${componentCls}-loading-icon`]: {
        transition: ["width", "opacity", "margin"].map((transition) => `${transition} ${motionDurationSlow} ${motionEaseInOut}`).join(",")
      },
      // iconPosition
      [`&:not(${componentCls}-icon-end)`]: {
        [`${componentCls}-loading-icon-motion`]: {
          "&-appear-start, &-enter-start": {
            marginInlineEnd: calc(iconGap).mul(-1).equal()
          },
          "&-appear-active, &-enter-active": {
            marginInlineEnd: 0
          },
          "&-leave-start": {
            marginInlineEnd: 0
          },
          "&-leave-active": {
            marginInlineEnd: calc(iconGap).mul(-1).equal()
          }
        }
      },
      "&-icon-end": {
        flexDirection: "row-reverse",
        [`${componentCls}-loading-icon-motion`]: {
          "&-appear-start, &-enter-start": {
            marginInlineStart: calc(iconGap).mul(-1).equal()
          },
          "&-appear-active, &-enter-active": {
            marginInlineStart: 0
          },
          "&-leave-start": {
            marginInlineStart: 0
          },
          "&-leave-active": {
            marginInlineStart: calc(iconGap).mul(-1).equal()
          }
        }
      }
    }
  };
};
var genHoverActiveButtonStyle = (btnCls, hoverStyle, activeStyle) => ({
  [`&:not(:disabled):not(${btnCls}-disabled)`]: {
    "&:hover": hoverStyle,
    "&:active": activeStyle
  }
});
var genCircleButtonStyle = (token2) => ({
  minWidth: token2.controlHeight,
  paddingInline: 0,
  borderRadius: "50%"
});
var genRoundButtonStyle = (token2) => {
  var _a;
  return {
    borderRadius: token2.controlHeight,
    paddingInline: (_a = token2.paddingInline) !== null && _a !== void 0 ? _a : token2.calc(token2.controlHeight).div(2).equal()
  };
};
var genDisabledStyle = (token2) => ({
  cursor: "not-allowed",
  borderColor: token2.borderColorDisabled,
  color: token2.colorTextDisabled,
  background: token2.colorBgContainerDisabled,
  boxShadow: "none"
});
var genGhostButtonStyle = (btnCls, background, textColor, borderColor, textColorDisabled, borderColorDisabled, hoverStyle, activeStyle) => ({
  [`&${btnCls}-background-ghost`]: Object.assign(Object.assign({
    color: textColor || void 0,
    background,
    borderColor: borderColor || void 0,
    boxShadow: "none"
  }, genHoverActiveButtonStyle(btnCls, Object.assign({
    background
  }, hoverStyle), Object.assign({
    background
  }, activeStyle))), {
    "&:disabled": {
      cursor: "not-allowed",
      color: textColorDisabled || void 0,
      borderColor: borderColorDisabled || void 0
    }
  })
});
var genSolidDisabledButtonStyle = (token2) => ({
  [`&:disabled, &${token2.componentCls}-disabled`]: Object.assign({}, genDisabledStyle(token2))
});
var genPureDisabledButtonStyle = (token2) => ({
  [`&:disabled, &${token2.componentCls}-disabled`]: {
    cursor: "not-allowed",
    color: token2.colorTextDisabled
  }
});
var genVariantButtonStyle = (token2, hoverStyle, activeStyle, variant) => {
  const isPureDisabled = variant && ["link", "text"].includes(variant);
  const genDisabledButtonStyle = isPureDisabled ? genPureDisabledButtonStyle : genSolidDisabledButtonStyle;
  return Object.assign(Object.assign({}, genDisabledButtonStyle(token2)), genHoverActiveButtonStyle(token2.componentCls, hoverStyle, activeStyle));
};
var genSolidButtonStyle = (token2, textColor, background, hoverStyle, activeStyle) => ({
  [`&${token2.componentCls}-variant-solid`]: Object.assign({
    color: textColor,
    background
  }, genVariantButtonStyle(token2, hoverStyle, activeStyle))
});
var genOutlinedDashedButtonStyle = (token2, borderColor, background, hoverStyle, activeStyle) => ({
  [`&${token2.componentCls}-variant-outlined, &${token2.componentCls}-variant-dashed`]: Object.assign({
    borderColor,
    background
  }, genVariantButtonStyle(token2, hoverStyle, activeStyle))
});
var genDashedButtonStyle = (token2) => ({
  [`&${token2.componentCls}-variant-dashed`]: {
    borderStyle: "dashed"
  }
});
var genFilledButtonStyle = (token2, background, hoverStyle, activeStyle) => ({
  [`&${token2.componentCls}-variant-filled`]: Object.assign({
    boxShadow: "none",
    background
  }, genVariantButtonStyle(token2, hoverStyle, activeStyle))
});
var genTextLinkButtonStyle = (token2, textColor, variant, hoverStyle, activeStyle) => ({
  [`&${token2.componentCls}-variant-${variant}`]: Object.assign({
    color: textColor,
    boxShadow: "none"
  }, genVariantButtonStyle(token2, hoverStyle, activeStyle, variant))
});
var genPresetColorStyle = (token2) => {
  const {
    componentCls
  } = token2;
  return PresetColors.reduce((prev2, colorKey) => {
    const darkColor = token2[`${colorKey}6`];
    const lightColor = token2[`${colorKey}1`];
    const hoverColor = token2[`${colorKey}5`];
    const lightHoverColor = token2[`${colorKey}2`];
    const lightBorderColor = token2[`${colorKey}3`];
    const activeColor = token2[`${colorKey}7`];
    return Object.assign(Object.assign({}, prev2), {
      [`&${componentCls}-color-${colorKey}`]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
        color: darkColor,
        boxShadow: token2[`${colorKey}ShadowColor`]
      }, genSolidButtonStyle(token2, token2.colorTextLightSolid, darkColor, {
        background: hoverColor
      }, {
        background: activeColor
      })), genOutlinedDashedButtonStyle(token2, darkColor, token2.colorBgContainer, {
        color: hoverColor,
        borderColor: hoverColor,
        background: token2.colorBgContainer
      }, {
        color: activeColor,
        borderColor: activeColor,
        background: token2.colorBgContainer
      })), genDashedButtonStyle(token2)), genFilledButtonStyle(token2, lightColor, {
        color: darkColor,
        background: lightHoverColor
      }, {
        color: darkColor,
        background: lightBorderColor
      })), genTextLinkButtonStyle(token2, darkColor, "link", {
        color: hoverColor
      }, {
        color: activeColor
      })), genTextLinkButtonStyle(token2, darkColor, "text", {
        color: hoverColor,
        background: lightColor
      }, {
        color: activeColor,
        background: lightBorderColor
      }))
    });
  }, {});
};
var genDefaultButtonStyle = (token2) => Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
  color: token2.defaultColor,
  boxShadow: token2.defaultShadow
}, genSolidButtonStyle(token2, token2.solidTextColor, token2.colorBgSolid, {
  color: token2.solidTextColor,
  background: token2.colorBgSolidHover
}, {
  color: token2.solidTextColor,
  background: token2.colorBgSolidActive
})), genDashedButtonStyle(token2)), genFilledButtonStyle(token2, token2.colorFillTertiary, {
  color: token2.defaultColor,
  background: token2.colorFillSecondary
}, {
  color: token2.defaultColor,
  background: token2.colorFill
})), genGhostButtonStyle(token2.componentCls, token2.ghostBg, token2.defaultGhostColor, token2.defaultGhostBorderColor, token2.colorTextDisabled, token2.colorBorder)), genTextLinkButtonStyle(token2, token2.textTextColor, "link", {
  color: token2.colorLinkHover,
  background: token2.linkHoverBg
}, {
  color: token2.colorLinkActive
}));
var genPrimaryButtonStyle = (token2) => Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
  color: token2.colorPrimary,
  boxShadow: token2.primaryShadow
}, genOutlinedDashedButtonStyle(token2, token2.colorPrimary, token2.colorBgContainer, {
  color: token2.colorPrimaryTextHover,
  borderColor: token2.colorPrimaryHover,
  background: token2.colorBgContainer
}, {
  color: token2.colorPrimaryTextActive,
  borderColor: token2.colorPrimaryActive,
  background: token2.colorBgContainer
})), genDashedButtonStyle(token2)), genFilledButtonStyle(token2, token2.colorPrimaryBg, {
  color: token2.colorPrimary,
  background: token2.colorPrimaryBgHover
}, {
  color: token2.colorPrimary,
  background: token2.colorPrimaryBorder
})), genTextLinkButtonStyle(token2, token2.colorPrimaryText, "text", {
  color: token2.colorPrimaryTextHover,
  background: token2.colorPrimaryBg
}, {
  color: token2.colorPrimaryTextActive,
  background: token2.colorPrimaryBorder
})), genTextLinkButtonStyle(token2, token2.colorPrimaryText, "link", {
  color: token2.colorPrimaryTextHover,
  background: token2.linkHoverBg
}, {
  color: token2.colorPrimaryTextActive
})), genGhostButtonStyle(token2.componentCls, token2.ghostBg, token2.colorPrimary, token2.colorPrimary, token2.colorTextDisabled, token2.colorBorder, {
  color: token2.colorPrimaryHover,
  borderColor: token2.colorPrimaryHover
}, {
  color: token2.colorPrimaryActive,
  borderColor: token2.colorPrimaryActive
}));
var genDangerousStyle = (token2) => Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
  color: token2.colorError,
  boxShadow: token2.dangerShadow
}, genSolidButtonStyle(token2, token2.dangerColor, token2.colorError, {
  background: token2.colorErrorHover
}, {
  background: token2.colorErrorActive
})), genOutlinedDashedButtonStyle(token2, token2.colorError, token2.colorBgContainer, {
  color: token2.colorErrorHover,
  borderColor: token2.colorErrorBorderHover
}, {
  color: token2.colorErrorActive,
  borderColor: token2.colorErrorActive
})), genDashedButtonStyle(token2)), genFilledButtonStyle(token2, token2.colorErrorBg, {
  color: token2.colorError,
  background: token2.colorErrorBgFilledHover
}, {
  color: token2.colorError,
  background: token2.colorErrorBgActive
})), genTextLinkButtonStyle(token2, token2.colorError, "text", {
  color: token2.colorErrorHover,
  background: token2.colorErrorBg
}, {
  color: token2.colorErrorHover,
  background: token2.colorErrorBgActive
})), genTextLinkButtonStyle(token2, token2.colorError, "link", {
  color: token2.colorErrorHover
}, {
  color: token2.colorErrorActive
})), genGhostButtonStyle(token2.componentCls, token2.ghostBg, token2.colorError, token2.colorError, token2.colorTextDisabled, token2.colorBorder, {
  color: token2.colorErrorHover,
  borderColor: token2.colorErrorHover
}, {
  color: token2.colorErrorActive,
  borderColor: token2.colorErrorActive
}));
var genLinkStyle2 = (token2) => Object.assign(Object.assign({}, genTextLinkButtonStyle(token2, token2.colorLink, "link", {
  color: token2.colorLinkHover
}, {
  color: token2.colorLinkActive
})), genGhostButtonStyle(token2.componentCls, token2.ghostBg, token2.colorInfo, token2.colorInfo, token2.colorTextDisabled, token2.colorBorder, {
  color: token2.colorInfoHover,
  borderColor: token2.colorInfoHover
}, {
  color: token2.colorInfoActive,
  borderColor: token2.colorInfoActive
}));
var genColorButtonStyle = (token2) => {
  const {
    componentCls
  } = token2;
  return Object.assign({
    [`${componentCls}-color-default`]: genDefaultButtonStyle(token2),
    [`${componentCls}-color-primary`]: genPrimaryButtonStyle(token2),
    [`${componentCls}-color-dangerous`]: genDangerousStyle(token2),
    [`${componentCls}-color-link`]: genLinkStyle2(token2)
  }, genPresetColorStyle(token2));
};
var genCompatibleButtonStyle = (token2) => Object.assign(Object.assign(Object.assign(Object.assign({}, genOutlinedDashedButtonStyle(token2, token2.defaultBorderColor, token2.defaultBg, {
  color: token2.defaultHoverColor,
  borderColor: token2.defaultHoverBorderColor,
  background: token2.defaultHoverBg
}, {
  color: token2.defaultActiveColor,
  borderColor: token2.defaultActiveBorderColor,
  background: token2.defaultActiveBg
})), genTextLinkButtonStyle(token2, token2.textTextColor, "text", {
  color: token2.textTextHoverColor,
  background: token2.textHoverBg
}, {
  color: token2.textTextActiveColor,
  background: token2.colorBgTextActive
})), genSolidButtonStyle(token2, token2.primaryColor, token2.colorPrimary, {
  background: token2.colorPrimaryHover,
  color: token2.primaryColor
}, {
  background: token2.colorPrimaryActive,
  color: token2.primaryColor
})), genTextLinkButtonStyle(token2, token2.colorLink, "link", {
  color: token2.colorLinkHover,
  background: token2.linkHoverBg
}, {
  color: token2.colorLinkActive
}));
var genButtonStyle = (token2, prefixCls = "") => {
  const {
    componentCls,
    controlHeight,
    fontSize,
    borderRadius,
    buttonPaddingHorizontal,
    iconCls,
    buttonPaddingVertical,
    buttonIconOnlyFontSize
  } = token2;
  return [
    {
      [prefixCls]: {
        fontSize,
        height: controlHeight,
        padding: `${unit(buttonPaddingVertical)} ${unit(buttonPaddingHorizontal)}`,
        borderRadius,
        [`&${componentCls}-icon-only`]: {
          width: controlHeight,
          [iconCls]: {
            fontSize: buttonIconOnlyFontSize
          }
        }
      }
    },
    // Shape - patch prefixCls again to override solid border radius style
    {
      [`${componentCls}${componentCls}-circle${prefixCls}`]: genCircleButtonStyle(token2)
    },
    {
      [`${componentCls}${componentCls}-round${prefixCls}`]: genRoundButtonStyle(token2)
    }
  ];
};
var genSizeBaseButtonStyle = (token2) => {
  const baseToken = merge2(token2, {
    fontSize: token2.contentFontSize
  });
  return genButtonStyle(baseToken, token2.componentCls);
};
var genSizeSmallButtonStyle = (token2) => {
  const smallToken = merge2(token2, {
    controlHeight: token2.controlHeightSM,
    fontSize: token2.contentFontSizeSM,
    padding: token2.paddingXS,
    buttonPaddingHorizontal: token2.paddingInlineSM,
    buttonPaddingVertical: 0,
    borderRadius: token2.borderRadiusSM,
    buttonIconOnlyFontSize: token2.onlyIconSizeSM
  });
  return genButtonStyle(smallToken, `${token2.componentCls}-sm`);
};
var genSizeLargeButtonStyle = (token2) => {
  const largeToken = merge2(token2, {
    controlHeight: token2.controlHeightLG,
    fontSize: token2.contentFontSizeLG,
    buttonPaddingHorizontal: token2.paddingInlineLG,
    buttonPaddingVertical: 0,
    borderRadius: token2.borderRadiusLG,
    buttonIconOnlyFontSize: token2.onlyIconSizeLG
  });
  return genButtonStyle(largeToken, `${token2.componentCls}-lg`);
};
var genBlockButtonStyle = (token2) => {
  const {
    componentCls
  } = token2;
  return {
    [componentCls]: {
      [`&${componentCls}-block`]: {
        width: "100%"
      }
    }
  };
};
var style_default5 = genStyleHooks("Button", (token2) => {
  const buttonToken = prepareToken(token2);
  return [
    // Shared
    genSharedButtonStyle(buttonToken),
    // Size
    genSizeBaseButtonStyle(buttonToken),
    genSizeSmallButtonStyle(buttonToken),
    genSizeLargeButtonStyle(buttonToken),
    // Block
    genBlockButtonStyle(buttonToken),
    // Color
    genColorButtonStyle(buttonToken),
    // https://github.com/ant-design/ant-design/issues/50969
    genCompatibleButtonStyle(buttonToken),
    // Button Group
    group_default(buttonToken)
  ];
}, prepareComponentToken3, {
  unitless: {
    fontWeight: true,
    contentLineHeight: true,
    contentLineHeightSM: true,
    contentLineHeightLG: true
  }
});

// ../../node_modules/antd/es/style/compact-item.js
function compactItemBorder(token2, parentCls, options, prefixCls) {
  const {
    focusElCls,
    focus,
    borderElCls
  } = options;
  const childCombinator = borderElCls ? "> *" : "";
  const hoverEffects = ["hover", focus ? "focus" : null, "active"].filter(Boolean).map((n2) => `&:${n2} ${childCombinator}`).join(",");
  return {
    [`&-item:not(${parentCls}-last-item)`]: {
      marginInlineEnd: token2.calc(token2.lineWidth).mul(-1).equal()
    },
    [`&-item:not(${prefixCls}-status-success)`]: {
      zIndex: 2
    },
    "&-item": Object.assign(Object.assign({
      [hoverEffects]: {
        zIndex: 3
      }
    }, focusElCls ? {
      [`&${focusElCls}`]: {
        zIndex: 3
      }
    } : {}), {
      [`&[disabled] ${childCombinator}`]: {
        zIndex: 0
      }
    })
  };
}
function compactItemBorderRadius(prefixCls, parentCls, options) {
  const {
    borderElCls
  } = options;
  const childCombinator = borderElCls ? `> ${borderElCls}` : "";
  return {
    [`&-item:not(${parentCls}-first-item):not(${parentCls}-last-item) ${childCombinator}`]: {
      borderRadius: 0
    },
    [`&-item:not(${parentCls}-last-item)${parentCls}-first-item`]: {
      [`& ${childCombinator}, &${prefixCls}-sm ${childCombinator}, &${prefixCls}-lg ${childCombinator}`]: {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0
      }
    },
    [`&-item:not(${parentCls}-first-item)${parentCls}-last-item`]: {
      [`& ${childCombinator}, &${prefixCls}-sm ${childCombinator}, &${prefixCls}-lg ${childCombinator}`]: {
        borderStartStartRadius: 0,
        borderEndStartRadius: 0
      }
    }
  };
}
function genCompactItemStyle(token2, options = {
  focus: true
}) {
  const {
    componentCls
  } = token2;
  const compactCls = `${componentCls}-compact`;
  return {
    [compactCls]: Object.assign(Object.assign({}, compactItemBorder(token2, compactCls, options, componentCls)), compactItemBorderRadius(componentCls, compactCls, options))
  };
}

// ../../node_modules/antd/es/style/compact-item-vertical.js
function compactItemVerticalBorder(token2, parentCls, prefixCls) {
  return {
    // border collapse
    [`&-item:not(${parentCls}-last-item)`]: {
      marginBottom: token2.calc(token2.lineWidth).mul(-1).equal()
    },
    [`&-item:not(${prefixCls}-status-success)`]: {
      zIndex: 2
    },
    "&-item": {
      "&:hover,&:focus,&:active": {
        zIndex: 3
      },
      "&[disabled]": {
        zIndex: 0
      }
    }
  };
}
function compactItemBorderVerticalRadius(prefixCls, parentCls) {
  return {
    [`&-item:not(${parentCls}-first-item):not(${parentCls}-last-item)`]: {
      borderRadius: 0
    },
    [`&-item${parentCls}-first-item:not(${parentCls}-last-item)`]: {
      [`&, &${prefixCls}-sm, &${prefixCls}-lg`]: {
        borderEndEndRadius: 0,
        borderEndStartRadius: 0
      }
    },
    [`&-item${parentCls}-last-item:not(${parentCls}-first-item)`]: {
      [`&, &${prefixCls}-sm, &${prefixCls}-lg`]: {
        borderStartStartRadius: 0,
        borderStartEndRadius: 0
      }
    }
  };
}
function genCompactItemVerticalStyle(token2) {
  const compactCls = `${token2.componentCls}-compact-vertical`;
  return {
    [compactCls]: Object.assign(Object.assign({}, compactItemVerticalBorder(token2, compactCls, token2.componentCls)), compactItemBorderVerticalRadius(token2.componentCls, compactCls))
  };
}

// ../../node_modules/antd/es/button/style/compact.js
var genButtonCompactStyle = (token2) => {
  const {
    componentCls,
    colorPrimaryHover,
    lineWidth,
    calc
  } = token2;
  const insetOffset = calc(lineWidth).mul(-1).equal();
  const getCompactBorderStyle = (vertical) => {
    const selector = `${componentCls}-compact${vertical ? "-vertical" : ""}-item${componentCls}-primary:not([disabled])`;
    return {
      [`${selector} + ${selector}::before`]: {
        position: "absolute",
        top: vertical ? insetOffset : 0,
        insetInlineStart: vertical ? 0 : insetOffset,
        backgroundColor: colorPrimaryHover,
        content: '""',
        width: vertical ? "100%" : lineWidth,
        height: vertical ? lineWidth : "100%"
      }
    };
  };
  return Object.assign(Object.assign({}, getCompactBorderStyle()), getCompactBorderStyle(true));
};
var compact_default2 = genSubStyleComponent(["Button", "compact"], (token2) => {
  const buttonToken = prepareToken(token2);
  return [
    // Space Compact
    genCompactItemStyle(buttonToken),
    genCompactItemVerticalStyle(buttonToken),
    genButtonCompactStyle(buttonToken)
  ];
}, prepareComponentToken3);

// ../../node_modules/antd/es/button/button.js
var __rest9 = function(s, e3) {
  var t2 = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e3.indexOf(p) < 0) t2[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e3.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t2[p[i]] = s[p[i]];
  }
  return t2;
};
function getLoadingConfig(loading) {
  if (typeof loading === "object" && loading) {
    let delay = loading === null || loading === void 0 ? void 0 : loading.delay;
    delay = !Number.isNaN(delay) && typeof delay === "number" ? delay : 0;
    return {
      loading: delay <= 0,
      delay
    };
  }
  return {
    loading: !!loading,
    delay: 0
  };
}
var ButtonTypeMap = {
  default: ["default", "outlined"],
  primary: ["primary", "solid"],
  dashed: ["default", "dashed"],
  // `link` is not a real color but we should compatible with it
  link: ["link", "link"],
  text: ["default", "text"]
};
var InternalCompoundedButton = /* @__PURE__ */ import_react50.default.forwardRef((props, ref3) => {
  var _a, _b;
  const {
    loading = false,
    prefixCls: customizePrefixCls,
    color,
    variant,
    type: type5,
    danger = false,
    shape: customizeShape,
    size: customizeSize,
    styles,
    disabled: customDisabled,
    className: className2,
    rootClassName,
    children,
    icon,
    iconPosition = "start",
    ghost = false,
    block = false,
    // React does not recognize the `htmlType` prop on a DOM element. Here we pick it out of `rest`.
    htmlType = "button",
    classNames: customClassNames,
    style: customStyle = {},
    autoInsertSpace,
    autoFocus
  } = props, rest = __rest9(props, ["loading", "prefixCls", "color", "variant", "type", "danger", "shape", "size", "styles", "disabled", "className", "rootClassName", "children", "icon", "iconPosition", "ghost", "block", "htmlType", "classNames", "style", "autoInsertSpace", "autoFocus"]);
  const mergedType = type5 || "default";
  const {
    button
  } = import_react50.default.useContext(ConfigContext);
  const shape = customizeShape || (button === null || button === void 0 ? void 0 : button.shape) || "default";
  const [mergedColor, mergedVariant] = (0, import_react50.useMemo)(() => {
    if (color && variant) {
      return [color, variant];
    }
    if (type5 || danger) {
      const colorVariantPair = ButtonTypeMap[mergedType] || [];
      if (danger) {
        return ["danger", colorVariantPair[1]];
      }
      return colorVariantPair;
    }
    if ((button === null || button === void 0 ? void 0 : button.color) && (button === null || button === void 0 ? void 0 : button.variant)) {
      return [button.color, button.variant];
    }
    return ["default", "outlined"];
  }, [type5, color, variant, danger, button === null || button === void 0 ? void 0 : button.variant, button === null || button === void 0 ? void 0 : button.color]);
  const isDanger = mergedColor === "danger";
  const mergedColorText = isDanger ? "dangerous" : mergedColor;
  const {
    getPrefixCls,
    direction,
    autoInsertSpace: contextAutoInsertSpace,
    className: contextClassName,
    style: contextStyle,
    classNames: contextClassNames,
    styles: contextStyles
  } = useComponentConfig("button");
  const mergedInsertSpace = (_a = autoInsertSpace !== null && autoInsertSpace !== void 0 ? autoInsertSpace : contextAutoInsertSpace) !== null && _a !== void 0 ? _a : true;
  const prefixCls = getPrefixCls("btn", customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = style_default5(prefixCls);
  const disabled = (0, import_react50.useContext)(DisabledContext_default);
  const mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
  const groupSize = (0, import_react50.useContext)(GroupSizeContext);
  const loadingOrDelay = (0, import_react50.useMemo)(() => getLoadingConfig(loading), [loading]);
  const [innerLoading, setLoading] = (0, import_react50.useState)(loadingOrDelay.loading);
  const [hasTwoCNChar, setHasTwoCNChar] = (0, import_react50.useState)(false);
  const buttonRef = (0, import_react50.useRef)(null);
  const mergedRef = useComposeRef(ref3, buttonRef);
  const needInserted = import_react50.Children.count(children) === 1 && !icon && !isUnBorderedButtonVariant(mergedVariant);
  const isMountRef = (0, import_react50.useRef)(true);
  import_react50.default.useEffect(() => {
    isMountRef.current = false;
    return () => {
      isMountRef.current = true;
    };
  }, []);
  useLayoutEffect_default(() => {
    let delayTimer = null;
    if (loadingOrDelay.delay > 0) {
      delayTimer = setTimeout(() => {
        delayTimer = null;
        setLoading(true);
      }, loadingOrDelay.delay);
    } else {
      setLoading(loadingOrDelay.loading);
    }
    function cleanupTimer() {
      if (delayTimer) {
        clearTimeout(delayTimer);
        delayTimer = null;
      }
    }
    return cleanupTimer;
  }, [loadingOrDelay.delay, loadingOrDelay.loading]);
  (0, import_react50.useEffect)(() => {
    if (!buttonRef.current || !mergedInsertSpace) {
      return;
    }
    const buttonText = buttonRef.current.textContent || "";
    if (needInserted && isTwoCNChar(buttonText)) {
      if (!hasTwoCNChar) {
        setHasTwoCNChar(true);
      }
    } else if (hasTwoCNChar) {
      setHasTwoCNChar(false);
    }
  });
  (0, import_react50.useEffect)(() => {
    if (autoFocus && buttonRef.current) {
      buttonRef.current.focus();
    }
  }, []);
  const handleClick = import_react50.default.useCallback((e3) => {
    var _a2;
    if (innerLoading || mergedDisabled) {
      e3.preventDefault();
      return;
    }
    (_a2 = props.onClick) === null || _a2 === void 0 ? void 0 : _a2.call(props, "href" in props ? e3 : e3);
  }, [props.onClick, innerLoading, mergedDisabled]);
  if (true) {
    const warning6 = devUseWarning("Button");
    true ? warning6(!(typeof icon === "string" && icon.length > 2), "breaking", `\`icon\` is using ReactNode instead of string naming in v4. Please check \`${icon}\` at https://ant.design/components/icon`) : void 0;
    true ? warning6(!(ghost && isUnBorderedButtonVariant(mergedVariant)), "usage", "`link` or `text` button can't be a `ghost` button.") : void 0;
  }
  const {
    compactSize,
    compactItemClassnames
  } = useCompactItemContext(prefixCls, direction);
  const sizeClassNameMap2 = {
    large: "lg",
    small: "sm",
    middle: void 0
  };
  const sizeFullName = useSize_default((ctxSize) => {
    var _a2, _b2;
    return (_b2 = (_a2 = customizeSize !== null && customizeSize !== void 0 ? customizeSize : compactSize) !== null && _a2 !== void 0 ? _a2 : groupSize) !== null && _b2 !== void 0 ? _b2 : ctxSize;
  });
  const sizeCls = sizeFullName ? (_b = sizeClassNameMap2[sizeFullName]) !== null && _b !== void 0 ? _b : "" : "";
  const iconType = innerLoading ? "loading" : icon;
  const linkButtonRestProps = omit(rest, ["navigate"]);
  const classes = (0, import_classnames23.default)(prefixCls, hashId, cssVarCls, {
    [`${prefixCls}-${shape}`]: shape !== "default" && shape,
    // Compatible with versions earlier than 5.21.0
    [`${prefixCls}-${mergedType}`]: mergedType,
    [`${prefixCls}-dangerous`]: danger,
    [`${prefixCls}-color-${mergedColorText}`]: mergedColorText,
    [`${prefixCls}-variant-${mergedVariant}`]: mergedVariant,
    [`${prefixCls}-${sizeCls}`]: sizeCls,
    [`${prefixCls}-icon-only`]: !children && children !== 0 && !!iconType,
    [`${prefixCls}-background-ghost`]: ghost && !isUnBorderedButtonVariant(mergedVariant),
    [`${prefixCls}-loading`]: innerLoading,
    [`${prefixCls}-two-chinese-chars`]: hasTwoCNChar && mergedInsertSpace && !innerLoading,
    [`${prefixCls}-block`]: block,
    [`${prefixCls}-rtl`]: direction === "rtl",
    [`${prefixCls}-icon-end`]: iconPosition === "end"
  }, compactItemClassnames, className2, rootClassName, contextClassName);
  const fullStyle = Object.assign(Object.assign({}, contextStyle), customStyle);
  const iconClasses = (0, import_classnames23.default)(customClassNames === null || customClassNames === void 0 ? void 0 : customClassNames.icon, contextClassNames.icon);
  const iconStyle = Object.assign(Object.assign({}, (styles === null || styles === void 0 ? void 0 : styles.icon) || {}), contextStyles.icon || {});
  const iconNode = icon && !innerLoading ? /* @__PURE__ */ import_react50.default.createElement(IconWrapper_default, {
    prefixCls,
    className: iconClasses,
    style: iconStyle
  }, icon) : loading && typeof loading === "object" && loading.icon ? /* @__PURE__ */ import_react50.default.createElement(IconWrapper_default, {
    prefixCls,
    className: iconClasses,
    style: iconStyle
  }, loading.icon) : /* @__PURE__ */ import_react50.default.createElement(DefaultLoadingIcon_default, {
    existIcon: !!icon,
    prefixCls,
    loading: innerLoading,
    mount: isMountRef.current
  });
  const kids = children || children === 0 ? spaceChildren(children, needInserted && mergedInsertSpace) : null;
  if (linkButtonRestProps.href !== void 0) {
    return wrapCSSVar(/* @__PURE__ */ import_react50.default.createElement("a", Object.assign({}, linkButtonRestProps, {
      className: (0, import_classnames23.default)(classes, {
        [`${prefixCls}-disabled`]: mergedDisabled
      }),
      href: mergedDisabled ? void 0 : linkButtonRestProps.href,
      style: fullStyle,
      onClick: handleClick,
      ref: mergedRef,
      tabIndex: mergedDisabled ? -1 : 0,
      "aria-disabled": mergedDisabled
    }), iconNode, kids));
  }
  let buttonNode = /* @__PURE__ */ import_react50.default.createElement("button", Object.assign({}, rest, {
    type: htmlType,
    className: classes,
    style: fullStyle,
    onClick: handleClick,
    disabled: mergedDisabled,
    ref: mergedRef
  }), iconNode, kids, compactItemClassnames && /* @__PURE__ */ import_react50.default.createElement(compact_default2, {
    prefixCls
  }));
  if (!isUnBorderedButtonVariant(mergedVariant)) {
    buttonNode = /* @__PURE__ */ import_react50.default.createElement(wave_default, {
      component: "Button",
      disabled: innerLoading
    }, buttonNode);
  }
  return wrapCSSVar(buttonNode);
});
var Button = InternalCompoundedButton;
Button.Group = button_group_default;
Button.__ANT_BUTTON = true;
if (true) {
  Button.displayName = "Button";
}
var button_default = Button;

// ../../node_modules/antd/es/button/index.js
var button_default2 = button_default;

// ../../node_modules/antd/es/_util/ActionButton.js
function isThenable(thing) {
  return !!(thing === null || thing === void 0 ? void 0 : thing.then);
}
var ActionButton = (props) => {
  const {
    type: type5,
    children,
    prefixCls,
    buttonProps,
    close,
    autoFocus,
    emitEvent,
    isSilent,
    quitOnNullishReturnValue,
    actionFn
  } = props;
  const clickedRef = React88.useRef(false);
  const buttonRef = React88.useRef(null);
  const [loading, setLoading] = useSafeState(false);
  const onInternalClose = (...args) => {
    close === null || close === void 0 ? void 0 : close.apply(void 0, args);
  };
  React88.useEffect(() => {
    let timeoutId = null;
    if (autoFocus) {
      timeoutId = setTimeout(() => {
        var _a;
        (_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.focus({
          preventScroll: true
        });
      });
    }
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, []);
  const handlePromiseOnOk = (returnValueOfOnOk) => {
    if (!isThenable(returnValueOfOnOk)) {
      return;
    }
    setLoading(true);
    returnValueOfOnOk.then((...args) => {
      setLoading(false, true);
      onInternalClose.apply(void 0, args);
      clickedRef.current = false;
    }, (e3) => {
      setLoading(false, true);
      clickedRef.current = false;
      if (isSilent === null || isSilent === void 0 ? void 0 : isSilent()) {
        return;
      }
      return Promise.reject(e3);
    });
  };
  const onClick = (e3) => {
    if (clickedRef.current) {
      return;
    }
    clickedRef.current = true;
    if (!actionFn) {
      onInternalClose();
      return;
    }
    let returnValueOfOnOk;
    if (emitEvent) {
      returnValueOfOnOk = actionFn(e3);
      if (quitOnNullishReturnValue && !isThenable(returnValueOfOnOk)) {
        clickedRef.current = false;
        onInternalClose(e3);
        return;
      }
    } else if (actionFn.length) {
      returnValueOfOnOk = actionFn(close);
      clickedRef.current = false;
    } else {
      returnValueOfOnOk = actionFn();
      if (!isThenable(returnValueOfOnOk)) {
        onInternalClose();
        return;
      }
    }
    handlePromiseOnOk(returnValueOfOnOk);
  };
  return /* @__PURE__ */ React88.createElement(button_default2, Object.assign({}, convertLegacyProps(type5), {
    onClick,
    loading,
    prefixCls
  }, buttonProps, {
    ref: buttonRef
  }), children);
};
var ActionButton_default = ActionButton;

// ../../node_modules/@rc-component/portal/es/Portal.js
var React92 = __toESM(require_react());
var import_react_dom5 = __toESM(require_react_dom());

// ../../node_modules/@rc-component/portal/es/Context.js
var React89 = __toESM(require_react());
var OrderContext = /* @__PURE__ */ React89.createContext(null);
var Context_default2 = OrderContext;

// ../../node_modules/@rc-component/portal/es/useDom.js
var React90 = __toESM(require_react());
var EMPTY_LIST = [];
function useDom(render4, debug) {
  var _React$useState = React90.useState(function() {
    if (!canUseDom()) {
      return null;
    }
    var defaultEle = document.createElement("div");
    if (debug) {
      defaultEle.setAttribute("data-debug", debug);
    }
    return defaultEle;
  }), _React$useState2 = _slicedToArray(_React$useState, 1), ele = _React$useState2[0];
  var appendedRef = React90.useRef(false);
  var queueCreate = React90.useContext(Context_default2);
  var _React$useState3 = React90.useState(EMPTY_LIST), _React$useState4 = _slicedToArray(_React$useState3, 2), queue = _React$useState4[0], setQueue = _React$useState4[1];
  var mergedQueueCreate = queueCreate || (appendedRef.current ? void 0 : function(appendFn) {
    setQueue(function(origin) {
      var newQueue = [appendFn].concat(_toConsumableArray(origin));
      return newQueue;
    });
  });
  function append2() {
    if (!ele.parentElement) {
      document.body.appendChild(ele);
    }
    appendedRef.current = true;
  }
  function cleanup2() {
    var _ele$parentElement;
    (_ele$parentElement = ele.parentElement) === null || _ele$parentElement === void 0 ? void 0 : _ele$parentElement.removeChild(ele);
    appendedRef.current = false;
  }
  useLayoutEffect_default(function() {
    if (render4) {
      if (queueCreate) {
        queueCreate(append2);
      } else {
        append2();
      }
    } else {
      cleanup2();
    }
    return cleanup2;
  }, [render4]);
  useLayoutEffect_default(function() {
    if (queue.length) {
      queue.forEach(function(appendFn) {
        return appendFn();
      });
      setQueue(EMPTY_LIST);
    }
  }, [queue]);
  return [ele, mergedQueueCreate];
}

// ../../node_modules/@rc-component/portal/es/useScrollLocker.js
var React91 = __toESM(require_react());

// ../../node_modules/rc-util/es/getScrollBarSize.js
var cached;
function measureScrollbarSize(ele) {
  var randomId = "rc-scrollbar-measure-".concat(Math.random().toString(36).substring(7));
  var measureEle = document.createElement("div");
  measureEle.id = randomId;
  var measureStyle = measureEle.style;
  measureStyle.position = "absolute";
  measureStyle.left = "0";
  measureStyle.top = "0";
  measureStyle.width = "100px";
  measureStyle.height = "100px";
  measureStyle.overflow = "scroll";
  var fallbackWidth;
  var fallbackHeight;
  if (ele) {
    var targetStyle = getComputedStyle(ele);
    measureStyle.scrollbarColor = targetStyle.scrollbarColor;
    measureStyle.scrollbarWidth = targetStyle.scrollbarWidth;
    var webkitScrollbarStyle = getComputedStyle(ele, "::-webkit-scrollbar");
    var width = parseInt(webkitScrollbarStyle.width, 10);
    var height = parseInt(webkitScrollbarStyle.height, 10);
    try {
      var widthStyle = width ? "width: ".concat(webkitScrollbarStyle.width, ";") : "";
      var heightStyle = height ? "height: ".concat(webkitScrollbarStyle.height, ";") : "";
      updateCSS("\n#".concat(randomId, "::-webkit-scrollbar {\n").concat(widthStyle, "\n").concat(heightStyle, "\n}"), randomId);
    } catch (e3) {
      console.error(e3);
      fallbackWidth = width;
      fallbackHeight = height;
    }
  }
  document.body.appendChild(measureEle);
  var scrollWidth = ele && fallbackWidth && !isNaN(fallbackWidth) ? fallbackWidth : measureEle.offsetWidth - measureEle.clientWidth;
  var scrollHeight = ele && fallbackHeight && !isNaN(fallbackHeight) ? fallbackHeight : measureEle.offsetHeight - measureEle.clientHeight;
  document.body.removeChild(measureEle);
  removeCSS(randomId);
  return {
    width: scrollWidth,
    height: scrollHeight
  };
}
function getScrollBarSize(fresh) {
  if (typeof document === "undefined") {
    return 0;
  }
  if (fresh || cached === void 0) {
    cached = measureScrollbarSize();
  }
  return cached.width;
}
function getTargetScrollBarSize(target) {
  if (typeof document === "undefined" || !target || !(target instanceof Element)) {
    return {
      width: 0,
      height: 0
    };
  }
  return measureScrollbarSize(target);
}

// ../../node_modules/@rc-component/portal/es/util.js
function isBodyOverflowing() {
  return document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight) && window.innerWidth > document.body.offsetWidth;
}

// ../../node_modules/@rc-component/portal/es/useScrollLocker.js
var UNIQUE_ID = "rc-util-locker-".concat(Date.now());
var uuid3 = 0;
function useScrollLocker(lock) {
  var mergedLock = !!lock;
  var _React$useState = React91.useState(function() {
    uuid3 += 1;
    return "".concat(UNIQUE_ID, "_").concat(uuid3);
  }), _React$useState2 = _slicedToArray(_React$useState, 1), id = _React$useState2[0];
  useLayoutEffect_default(function() {
    if (mergedLock) {
      var scrollbarSize = getTargetScrollBarSize(document.body).width;
      var isOverflow = isBodyOverflowing();
      updateCSS("\nhtml body {\n  overflow-y: hidden;\n  ".concat(isOverflow ? "width: calc(100% - ".concat(scrollbarSize, "px);") : "", "\n}"), id);
    } else {
      removeCSS(id);
    }
    return function() {
      removeCSS(id);
    };
  }, [mergedLock, id]);
}

// ../../node_modules/@rc-component/portal/es/mock.js
var inline = false;
function inlineMock(nextInline) {
  if (typeof nextInline === "boolean") {
    inline = nextInline;
  }
  return inline;
}

// ../../node_modules/@rc-component/portal/es/Portal.js
var getPortalContainer = function getPortalContainer2(getContainer2) {
  if (getContainer2 === false) {
    return false;
  }
  if (!canUseDom() || !getContainer2) {
    return null;
  }
  if (typeof getContainer2 === "string") {
    return document.querySelector(getContainer2);
  }
  if (typeof getContainer2 === "function") {
    return getContainer2();
  }
  return getContainer2;
};
var Portal = /* @__PURE__ */ React92.forwardRef(function(props, ref3) {
  var open2 = props.open, autoLock = props.autoLock, getContainer2 = props.getContainer, debug = props.debug, _props$autoDestroy = props.autoDestroy, autoDestroy = _props$autoDestroy === void 0 ? true : _props$autoDestroy, children = props.children;
  var _React$useState = React92.useState(open2), _React$useState2 = _slicedToArray(_React$useState, 2), shouldRender = _React$useState2[0], setShouldRender = _React$useState2[1];
  var mergedRender = shouldRender || open2;
  if (true) {
    warning_default(canUseDom() || !open2, "Portal only work in client side. Please call 'useEffect' to show Portal instead default render in SSR.");
  }
  React92.useEffect(function() {
    if (autoDestroy || open2) {
      setShouldRender(open2);
    }
  }, [open2, autoDestroy]);
  var _React$useState3 = React92.useState(function() {
    return getPortalContainer(getContainer2);
  }), _React$useState4 = _slicedToArray(_React$useState3, 2), innerContainer = _React$useState4[0], setInnerContainer = _React$useState4[1];
  React92.useEffect(function() {
    var customizeContainer = getPortalContainer(getContainer2);
    setInnerContainer(customizeContainer !== null && customizeContainer !== void 0 ? customizeContainer : null);
  });
  var _useDom = useDom(mergedRender && !innerContainer, debug), _useDom2 = _slicedToArray(_useDom, 2), defaultContainer2 = _useDom2[0], queueCreate = _useDom2[1];
  var mergedContainer = innerContainer !== null && innerContainer !== void 0 ? innerContainer : defaultContainer2;
  useScrollLocker(autoLock && open2 && canUseDom() && (mergedContainer === defaultContainer2 || mergedContainer === document.body));
  var childRef = null;
  if (children && supportRef(children) && ref3) {
    var _ref = children;
    childRef = _ref.ref;
  }
  var mergedRef = useComposeRef(childRef, ref3);
  if (!mergedRender || !canUseDom() || innerContainer === void 0) {
    return null;
  }
  var renderInline = mergedContainer === false || inlineMock();
  var reffedChildren = children;
  if (ref3) {
    reffedChildren = /* @__PURE__ */ React92.cloneElement(children, {
      ref: mergedRef
    });
  }
  return /* @__PURE__ */ React92.createElement(Context_default2.Provider, {
    value: queueCreate
  }, renderInline ? reffedChildren : /* @__PURE__ */ (0, import_react_dom5.createPortal)(reffedChildren, mergedContainer));
});
if (true) {
  Portal.displayName = "Portal";
}
var Portal_default = Portal;

// ../../node_modules/@rc-component/portal/es/index.js
var es_default4 = Portal_default;

// ../../node_modules/rc-dialog/es/DialogWrap.js
var React100 = __toESM(require_react());

// ../../node_modules/rc-dialog/es/context.js
var React93 = __toESM(require_react());
var RefContext = /* @__PURE__ */ React93.createContext({});

// ../../node_modules/rc-dialog/es/Dialog/index.js
var import_classnames27 = __toESM(require_classnames());

// ../../node_modules/rc-util/es/hooks/useId.js
var React94 = __toESM(require_react());
function getUseId() {
  var fullClone5 = _objectSpread2({}, React94);
  return fullClone5.useId;
}
var uuid4 = 0;
var useOriginId = getUseId();
var useId_default = useOriginId ? (
  // Use React `useId`
  function useId2(id) {
    var reactId = useOriginId();
    if (id) {
      return id;
    }
    if (false) {
      return "test-id";
    }
    return reactId;
  }
) : (
  // Use compatible of `useId`
  function useCompatId(id) {
    var _React$useState = React94.useState("ssr-id"), _React$useState2 = _slicedToArray(_React$useState, 2), innerId = _React$useState2[0], setInnerId = _React$useState2[1];
    React94.useEffect(function() {
      var nextId = uuid4;
      uuid4 += 1;
      setInnerId("rc_unique_".concat(nextId));
    }, []);
    if (id) {
      return id;
    }
    if (false) {
      return "test-id";
    }
    return innerId;
  }
);

// ../../node_modules/rc-dialog/es/Dialog/index.js
var React99 = __toESM(require_react());
var import_react53 = __toESM(require_react());

// ../../node_modules/rc-dialog/es/util.js
function getMotionName(prefixCls, transitionName, animationName) {
  var motionName = transitionName;
  if (!motionName && animationName) {
    motionName = "".concat(prefixCls, "-").concat(animationName);
  }
  return motionName;
}
function getScroll2(w, top) {
  var ret = w["page".concat(top ? "Y" : "X", "Offset")];
  var method4 = "scroll".concat(top ? "Top" : "Left");
  if (typeof ret !== "number") {
    var d = w.document;
    ret = d.documentElement[method4];
    if (typeof ret !== "number") {
      ret = d.body[method4];
    }
  }
  return ret;
}
function offset2(el) {
  var rect = el.getBoundingClientRect();
  var pos = {
    left: rect.left,
    top: rect.top
  };
  var doc2 = el.ownerDocument;
  var w = doc2.defaultView || doc2.parentWindow;
  pos.left += getScroll2(w);
  pos.top += getScroll2(w, true);
  return pos;
}

// ../../node_modules/rc-dialog/es/Dialog/Content/index.js
var React97 = __toESM(require_react());
var import_react52 = __toESM(require_react());
var import_classnames25 = __toESM(require_classnames());

// ../../node_modules/rc-dialog/es/Dialog/Content/Panel.js
var import_classnames24 = __toESM(require_classnames());
var import_react51 = __toESM(require_react());

// ../../node_modules/rc-dialog/es/Dialog/Content/MemoChildren.js
var React95 = __toESM(require_react());
var MemoChildren_default = /* @__PURE__ */ React95.memo(function(_ref) {
  var children = _ref.children;
  return children;
}, function(_, _ref2) {
  var shouldUpdate = _ref2.shouldUpdate;
  return !shouldUpdate;
});

// ../../node_modules/rc-dialog/es/Dialog/Content/Panel.js
var sentinelStyle = {
  width: 0,
  height: 0,
  overflow: "hidden",
  outline: "none"
};
var entityStyle = {
  outline: "none"
};
var Panel2 = /* @__PURE__ */ import_react51.default.forwardRef(function(props, ref3) {
  var prefixCls = props.prefixCls, className2 = props.className, style2 = props.style, title = props.title, ariaId = props.ariaId, footer = props.footer, closable = props.closable, closeIcon = props.closeIcon, onClose = props.onClose, children = props.children, bodyStyle = props.bodyStyle, bodyProps = props.bodyProps, modalRender = props.modalRender, onMouseDown = props.onMouseDown, onMouseUp = props.onMouseUp, holderRef = props.holderRef, visible = props.visible, forceRender = props.forceRender, width = props.width, height = props.height, modalClassNames = props.classNames, modalStyles = props.styles;
  var _React$useContext = import_react51.default.useContext(RefContext), panelRef = _React$useContext.panel;
  var mergedRef = useComposeRef(holderRef, panelRef);
  var sentinelStartRef = (0, import_react51.useRef)();
  var sentinelEndRef = (0, import_react51.useRef)();
  import_react51.default.useImperativeHandle(ref3, function() {
    return {
      focus: function focus() {
        var _sentinelStartRef$cur;
        (_sentinelStartRef$cur = sentinelStartRef.current) === null || _sentinelStartRef$cur === void 0 || _sentinelStartRef$cur.focus({
          preventScroll: true
        });
      },
      changeActive: function changeActive(next2) {
        var _document = document, activeElement = _document.activeElement;
        if (next2 && activeElement === sentinelEndRef.current) {
          sentinelStartRef.current.focus({
            preventScroll: true
          });
        } else if (!next2 && activeElement === sentinelStartRef.current) {
          sentinelEndRef.current.focus({
            preventScroll: true
          });
        }
      }
    };
  });
  var contentStyle = {};
  if (width !== void 0) {
    contentStyle.width = width;
  }
  if (height !== void 0) {
    contentStyle.height = height;
  }
  var footerNode = footer ? /* @__PURE__ */ import_react51.default.createElement("div", {
    className: (0, import_classnames24.default)("".concat(prefixCls, "-footer"), modalClassNames === null || modalClassNames === void 0 ? void 0 : modalClassNames.footer),
    style: _objectSpread2({}, modalStyles === null || modalStyles === void 0 ? void 0 : modalStyles.footer)
  }, footer) : null;
  var headerNode = title ? /* @__PURE__ */ import_react51.default.createElement("div", {
    className: (0, import_classnames24.default)("".concat(prefixCls, "-header"), modalClassNames === null || modalClassNames === void 0 ? void 0 : modalClassNames.header),
    style: _objectSpread2({}, modalStyles === null || modalStyles === void 0 ? void 0 : modalStyles.header)
  }, /* @__PURE__ */ import_react51.default.createElement("div", {
    className: "".concat(prefixCls, "-title"),
    id: ariaId
  }, title)) : null;
  var closableObj = (0, import_react51.useMemo)(function() {
    if (_typeof(closable) === "object" && closable !== null) {
      return closable;
    }
    if (closable) {
      return {
        closeIcon: closeIcon !== null && closeIcon !== void 0 ? closeIcon : /* @__PURE__ */ import_react51.default.createElement("span", {
          className: "".concat(prefixCls, "-close-x")
        })
      };
    }
    return {};
  }, [closable, closeIcon, prefixCls]);
  var ariaProps = pickAttrs(closableObj, true);
  var closeBtnIsDisabled = _typeof(closable) === "object" && closable.disabled;
  var closerNode = closable ? /* @__PURE__ */ import_react51.default.createElement("button", _extends({
    type: "button",
    onClick: onClose,
    "aria-label": "Close"
  }, ariaProps, {
    className: "".concat(prefixCls, "-close"),
    disabled: closeBtnIsDisabled
  }), closableObj.closeIcon) : null;
  var content = /* @__PURE__ */ import_react51.default.createElement("div", {
    className: (0, import_classnames24.default)("".concat(prefixCls, "-content"), modalClassNames === null || modalClassNames === void 0 ? void 0 : modalClassNames.content),
    style: modalStyles === null || modalStyles === void 0 ? void 0 : modalStyles.content
  }, closerNode, headerNode, /* @__PURE__ */ import_react51.default.createElement("div", _extends({
    className: (0, import_classnames24.default)("".concat(prefixCls, "-body"), modalClassNames === null || modalClassNames === void 0 ? void 0 : modalClassNames.body),
    style: _objectSpread2(_objectSpread2({}, bodyStyle), modalStyles === null || modalStyles === void 0 ? void 0 : modalStyles.body)
  }, bodyProps), children), footerNode);
  return /* @__PURE__ */ import_react51.default.createElement("div", {
    key: "dialog-element",
    role: "dialog",
    "aria-labelledby": title ? ariaId : null,
    "aria-modal": "true",
    ref: mergedRef,
    style: _objectSpread2(_objectSpread2({}, style2), contentStyle),
    className: (0, import_classnames24.default)(prefixCls, className2),
    onMouseDown,
    onMouseUp
  }, /* @__PURE__ */ import_react51.default.createElement("div", {
    ref: sentinelStartRef,
    tabIndex: 0,
    style: entityStyle
  }, /* @__PURE__ */ import_react51.default.createElement(MemoChildren_default, {
    shouldUpdate: visible || forceRender
  }, modalRender ? modalRender(content) : content)), /* @__PURE__ */ import_react51.default.createElement("div", {
    tabIndex: 0,
    ref: sentinelEndRef,
    style: sentinelStyle
  }));
});
if (true) {
  Panel2.displayName = "Panel";
}
var Panel_default2 = Panel2;

// ../../node_modules/rc-dialog/es/Dialog/Content/index.js
var Content = /* @__PURE__ */ React97.forwardRef(function(props, ref3) {
  var prefixCls = props.prefixCls, title = props.title, style2 = props.style, className2 = props.className, visible = props.visible, forceRender = props.forceRender, destroyOnClose = props.destroyOnClose, motionName = props.motionName, ariaId = props.ariaId, onVisibleChanged = props.onVisibleChanged, mousePosition = props.mousePosition;
  var dialogRef = (0, import_react52.useRef)();
  var _React$useState = React97.useState(), _React$useState2 = _slicedToArray(_React$useState, 2), transformOrigin = _React$useState2[0], setTransformOrigin = _React$useState2[1];
  var contentStyle = {};
  if (transformOrigin) {
    contentStyle.transformOrigin = transformOrigin;
  }
  function onPrepare() {
    var elementOffset = offset2(dialogRef.current);
    setTransformOrigin(mousePosition && (mousePosition.x || mousePosition.y) ? "".concat(mousePosition.x - elementOffset.left, "px ").concat(mousePosition.y - elementOffset.top, "px") : "");
  }
  return /* @__PURE__ */ React97.createElement(es_default2, {
    visible,
    onVisibleChanged,
    onAppearPrepare: onPrepare,
    onEnterPrepare: onPrepare,
    forceRender,
    motionName,
    removeOnLeave: destroyOnClose,
    ref: dialogRef
  }, function(_ref, motionRef) {
    var motionClassName = _ref.className, motionStyle = _ref.style;
    return /* @__PURE__ */ React97.createElement(Panel_default2, _extends({}, props, {
      ref: ref3,
      title,
      ariaId,
      prefixCls,
      holderRef: motionRef,
      style: _objectSpread2(_objectSpread2(_objectSpread2({}, motionStyle), style2), contentStyle),
      className: (0, import_classnames25.default)(className2, motionClassName)
    }));
  });
});
Content.displayName = "Content";
var Content_default = Content;

// ../../node_modules/rc-dialog/es/Dialog/Mask.js
var React98 = __toESM(require_react());
var import_classnames26 = __toESM(require_classnames());
var Mask = function Mask2(props) {
  var prefixCls = props.prefixCls, style2 = props.style, visible = props.visible, maskProps = props.maskProps, motionName = props.motionName, className2 = props.className;
  return /* @__PURE__ */ React98.createElement(es_default2, {
    key: "mask",
    visible,
    motionName,
    leavedClassName: "".concat(prefixCls, "-mask-hidden")
  }, function(_ref, ref3) {
    var motionClassName = _ref.className, motionStyle = _ref.style;
    return /* @__PURE__ */ React98.createElement("div", _extends({
      ref: ref3,
      style: _objectSpread2(_objectSpread2({}, motionStyle), style2),
      className: (0, import_classnames26.default)("".concat(prefixCls, "-mask"), motionClassName, className2)
    }, maskProps));
  });
};
var Mask_default = Mask;

// ../../node_modules/rc-dialog/es/Dialog/index.js
var Dialog = function Dialog2(props) {
  var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-dialog" : _props$prefixCls, zIndex = props.zIndex, _props$visible = props.visible, visible = _props$visible === void 0 ? false : _props$visible, _props$keyboard = props.keyboard, keyboard = _props$keyboard === void 0 ? true : _props$keyboard, _props$focusTriggerAf = props.focusTriggerAfterClose, focusTriggerAfterClose = _props$focusTriggerAf === void 0 ? true : _props$focusTriggerAf, wrapStyle = props.wrapStyle, wrapClassName = props.wrapClassName, wrapProps = props.wrapProps, onClose = props.onClose, afterOpenChange = props.afterOpenChange, afterClose = props.afterClose, transitionName = props.transitionName, animation = props.animation, _props$closable = props.closable, closable = _props$closable === void 0 ? true : _props$closable, _props$mask = props.mask, mask = _props$mask === void 0 ? true : _props$mask, maskTransitionName = props.maskTransitionName, maskAnimation = props.maskAnimation, _props$maskClosable = props.maskClosable, maskClosable = _props$maskClosable === void 0 ? true : _props$maskClosable, maskStyle = props.maskStyle, maskProps = props.maskProps, rootClassName = props.rootClassName, modalClassNames = props.classNames, modalStyles = props.styles;
  if (true) {
    ["wrapStyle", "bodyStyle", "maskStyle"].forEach(function(prop) {
      warning(!(prop in props), "".concat(prop, " is deprecated, please use styles instead."));
    });
    if ("wrapClassName" in props) {
      warning(false, "wrapClassName is deprecated, please use classNames instead.");
    }
  }
  var lastOutSideActiveElementRef = (0, import_react53.useRef)();
  var wrapperRef = (0, import_react53.useRef)();
  var contentRef = (0, import_react53.useRef)();
  var _React$useState = React99.useState(visible), _React$useState2 = _slicedToArray(_React$useState, 2), animatedVisible = _React$useState2[0], setAnimatedVisible = _React$useState2[1];
  var ariaId = useId_default();
  function saveLastOutSideActiveElementRef() {
    if (!contains(wrapperRef.current, document.activeElement)) {
      lastOutSideActiveElementRef.current = document.activeElement;
    }
  }
  function focusDialogContent() {
    if (!contains(wrapperRef.current, document.activeElement)) {
      var _contentRef$current;
      (_contentRef$current = contentRef.current) === null || _contentRef$current === void 0 || _contentRef$current.focus();
    }
  }
  function onDialogVisibleChanged(newVisible) {
    if (newVisible) {
      focusDialogContent();
    } else {
      setAnimatedVisible(false);
      if (mask && lastOutSideActiveElementRef.current && focusTriggerAfterClose) {
        try {
          lastOutSideActiveElementRef.current.focus({
            preventScroll: true
          });
        } catch (e3) {
        }
        lastOutSideActiveElementRef.current = null;
      }
      if (animatedVisible) {
        afterClose === null || afterClose === void 0 || afterClose();
      }
    }
    afterOpenChange === null || afterOpenChange === void 0 || afterOpenChange(newVisible);
  }
  function onInternalClose(e3) {
    onClose === null || onClose === void 0 || onClose(e3);
  }
  var contentClickRef = (0, import_react53.useRef)(false);
  var contentTimeoutRef = (0, import_react53.useRef)();
  var onContentMouseDown = function onContentMouseDown2() {
    clearTimeout(contentTimeoutRef.current);
    contentClickRef.current = true;
  };
  var onContentMouseUp = function onContentMouseUp2() {
    contentTimeoutRef.current = setTimeout(function() {
      contentClickRef.current = false;
    });
  };
  var onWrapperClick = null;
  if (maskClosable) {
    onWrapperClick = function onWrapperClick2(e3) {
      if (contentClickRef.current) {
        contentClickRef.current = false;
      } else if (wrapperRef.current === e3.target) {
        onInternalClose(e3);
      }
    };
  }
  function onWrapperKeyDown(e3) {
    if (keyboard && e3.keyCode === KeyCode_default.ESC) {
      e3.stopPropagation();
      onInternalClose(e3);
      return;
    }
    if (visible && e3.keyCode === KeyCode_default.TAB) {
      contentRef.current.changeActive(!e3.shiftKey);
    }
  }
  (0, import_react53.useEffect)(function() {
    if (visible) {
      setAnimatedVisible(true);
      saveLastOutSideActiveElementRef();
    }
  }, [visible]);
  (0, import_react53.useEffect)(function() {
    return function() {
      clearTimeout(contentTimeoutRef.current);
    };
  }, []);
  var mergedStyle = _objectSpread2(_objectSpread2(_objectSpread2({
    zIndex
  }, wrapStyle), modalStyles === null || modalStyles === void 0 ? void 0 : modalStyles.wrapper), {}, {
    display: !animatedVisible ? "none" : null
  });
  return /* @__PURE__ */ React99.createElement("div", _extends({
    className: (0, import_classnames27.default)("".concat(prefixCls, "-root"), rootClassName)
  }, pickAttrs(props, {
    data: true
  })), /* @__PURE__ */ React99.createElement(Mask_default, {
    prefixCls,
    visible: mask && visible,
    motionName: getMotionName(prefixCls, maskTransitionName, maskAnimation),
    style: _objectSpread2(_objectSpread2({
      zIndex
    }, maskStyle), modalStyles === null || modalStyles === void 0 ? void 0 : modalStyles.mask),
    maskProps,
    className: modalClassNames === null || modalClassNames === void 0 ? void 0 : modalClassNames.mask
  }), /* @__PURE__ */ React99.createElement("div", _extends({
    tabIndex: -1,
    onKeyDown: onWrapperKeyDown,
    className: (0, import_classnames27.default)("".concat(prefixCls, "-wrap"), wrapClassName, modalClassNames === null || modalClassNames === void 0 ? void 0 : modalClassNames.wrapper),
    ref: wrapperRef,
    onClick: onWrapperClick,
    style: mergedStyle
  }, wrapProps), /* @__PURE__ */ React99.createElement(Content_default, _extends({}, props, {
    onMouseDown: onContentMouseDown,
    onMouseUp: onContentMouseUp,
    ref: contentRef,
    closable,
    ariaId,
    prefixCls,
    visible: visible && animatedVisible,
    onClose: onInternalClose,
    onVisibleChanged: onDialogVisibleChanged,
    motionName: getMotionName(prefixCls, transitionName, animation)
  }))));
};
var Dialog_default = Dialog;

// ../../node_modules/rc-dialog/es/DialogWrap.js
var DialogWrap = function DialogWrap2(props) {
  var visible = props.visible, getContainer2 = props.getContainer, forceRender = props.forceRender, _props$destroyOnClose = props.destroyOnClose, destroyOnClose = _props$destroyOnClose === void 0 ? false : _props$destroyOnClose, _afterClose = props.afterClose, panelRef = props.panelRef;
  var _React$useState = React100.useState(visible), _React$useState2 = _slicedToArray(_React$useState, 2), animatedVisible = _React$useState2[0], setAnimatedVisible = _React$useState2[1];
  var refContext = React100.useMemo(function() {
    return {
      panel: panelRef
    };
  }, [panelRef]);
  React100.useEffect(function() {
    if (visible) {
      setAnimatedVisible(true);
    }
  }, [visible]);
  if (!forceRender && destroyOnClose && !animatedVisible) {
    return null;
  }
  return /* @__PURE__ */ React100.createElement(RefContext.Provider, {
    value: refContext
  }, /* @__PURE__ */ React100.createElement(es_default4, {
    open: visible || forceRender || animatedVisible,
    autoDestroy: false,
    getContainer: getContainer2,
    autoLock: visible || animatedVisible
  }, /* @__PURE__ */ React100.createElement(Dialog_default, _extends({}, props, {
    destroyOnClose,
    afterClose: function afterClose() {
      _afterClose === null || _afterClose === void 0 || _afterClose();
      setAnimatedVisible(false);
    }
  }))));
};
DialogWrap.displayName = "Dialog";
var DialogWrap_default = DialogWrap;

// ../../node_modules/rc-dialog/es/index.js
var es_default5 = DialogWrap_default;

// ../../node_modules/antd/es/_util/ContextIsolator.js
var import_react55 = __toESM(require_react());

// ../../node_modules/antd/es/form/context.js
var React110 = __toESM(require_react());

// ../../node_modules/rc-field-form/es/index.js
var React109 = __toESM(require_react());

// ../../node_modules/rc-field-form/es/Field.js
var React104 = __toESM(require_react());

// ../../node_modules/rc-field-form/es/FieldContext.js
var React101 = __toESM(require_react());
var HOOK_MARK = "RC_FORM_INTERNAL_HOOKS";
var warningFunc = function warningFunc2() {
  warning_default(false, "Can not find FormContext. Please make sure you wrap Field under Form.");
};
var Context2 = /* @__PURE__ */ React101.createContext({
  getFieldValue: warningFunc,
  getFieldsValue: warningFunc,
  getFieldError: warningFunc,
  getFieldWarning: warningFunc,
  getFieldsError: warningFunc,
  isFieldsTouched: warningFunc,
  isFieldTouched: warningFunc,
  isFieldValidating: warningFunc,
  isFieldsValidating: warningFunc,
  resetFields: warningFunc,
  setFields: warningFunc,
  setFieldValue: warningFunc,
  setFieldsValue: warningFunc,
  validateFields: warningFunc,
  submit: warningFunc,
  getInternalHooks: function getInternalHooks() {
    warningFunc();
    return {
      dispatch: warningFunc,
      initEntityValue: warningFunc,
      registerField: warningFunc,
      useSubscribe: warningFunc,
      setInitialValues: warningFunc,
      destroyForm: warningFunc,
      setCallbacks: warningFunc,
      registerWatch: warningFunc,
      getFields: warningFunc,
      setValidateMessages: warningFunc,
      setPreserve: warningFunc,
      getInitialValue: warningFunc
    };
  }
});
var FieldContext_default = Context2;

// ../../node_modules/rc-field-form/es/ListContext.js
var React102 = __toESM(require_react());
var ListContext = /* @__PURE__ */ React102.createContext(null);
var ListContext_default = ListContext;

// ../../node_modules/rc-field-form/es/utils/typeUtil.js
function toArray2(value) {
  if (value === void 0 || value === null) {
    return [];
  }
  return Array.isArray(value) ? value : [value];
}
function isFormInstance(form) {
  return form && !!form._init;
}

// ../../node_modules/@rc-component/async-validator/es/messages.js
function newMessages() {
  return {
    default: "Validation error on field %s",
    required: "%s is required",
    enum: "%s must be one of %s",
    whitespace: "%s cannot be empty",
    date: {
      format: "%s date %s is invalid for format %s",
      parse: "%s date could not be parsed, %s is invalid ",
      invalid: "%s date %s is invalid"
    },
    types: {
      string: "%s is not a %s",
      method: "%s is not a %s (function)",
      array: "%s is not an %s",
      object: "%s is not an %s",
      number: "%s is not a %s",
      date: "%s is not a %s",
      boolean: "%s is not a %s",
      integer: "%s is not an %s",
      float: "%s is not a %s",
      regexp: "%s is not a valid %s",
      email: "%s is not a valid %s",
      url: "%s is not a valid %s",
      hex: "%s is not a valid %s"
    },
    string: {
      len: "%s must be exactly %s characters",
      min: "%s must be at least %s characters",
      max: "%s cannot be longer than %s characters",
      range: "%s must be between %s and %s characters"
    },
    number: {
      len: "%s must equal %s",
      min: "%s cannot be less than %s",
      max: "%s cannot be greater than %s",
      range: "%s must be between %s and %s"
    },
    array: {
      len: "%s must be exactly %s in length",
      min: "%s cannot be less than %s in length",
      max: "%s cannot be greater than %s in length",
      range: "%s must be between %s and %s in length"
    },
    pattern: {
      mismatch: "%s value %s does not match pattern %s"
    },
    clone: function clone() {
      var cloned = JSON.parse(JSON.stringify(this));
      cloned.clone = this.clone;
      return cloned;
    }
  };
}
var messages = newMessages();

// ../../node_modules/@babel/runtime/helpers/esm/isNativeFunction.js
function _isNativeFunction(t2) {
  try {
    return -1 !== Function.toString.call(t2).indexOf("[native code]");
  } catch (n2) {
    return "function" == typeof t2;
  }
}

// ../../node_modules/@babel/runtime/helpers/esm/construct.js
function _construct(t2, e3, r2) {
  if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
  var o3 = [null];
  o3.push.apply(o3, e3);
  var p = new (t2.bind.apply(t2, o3))();
  return r2 && _setPrototypeOf(p, r2.prototype), p;
}

// ../../node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js
function _wrapNativeSuper(t2) {
  var r2 = "function" == typeof Map ? /* @__PURE__ */ new Map() : void 0;
  return _wrapNativeSuper = function _wrapNativeSuper2(t3) {
    if (null === t3 || !_isNativeFunction(t3)) return t3;
    if ("function" != typeof t3) throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== r2) {
      if (r2.has(t3)) return r2.get(t3);
      r2.set(t3, Wrapper3);
    }
    function Wrapper3() {
      return _construct(t3, arguments, _getPrototypeOf(this).constructor);
    }
    return Wrapper3.prototype = Object.create(t3.prototype, {
      constructor: {
        value: Wrapper3,
        enumerable: false,
        writable: true,
        configurable: true
      }
    }), _setPrototypeOf(Wrapper3, t3);
  }, _wrapNativeSuper(t2);
}

// ../../node_modules/@rc-component/async-validator/es/util.js
var formatRegExp = /%[sdj%]/g;
var warning4 = function warning5() {
};
if (typeof process !== "undefined" && process.env && true && typeof window !== "undefined" && typeof document !== "undefined") {
  warning4 = function warning6(type5, errors) {
    if (typeof console !== "undefined" && console.warn && typeof ASYNC_VALIDATOR_NO_WARNING === "undefined") {
      if (errors.every(function(e3) {
        return typeof e3 === "string";
      })) {
        console.warn(type5, errors);
      }
    }
  };
}
function convertFieldsError(errors) {
  if (!errors || !errors.length) return null;
  var fields = {};
  errors.forEach(function(error2) {
    var field = error2.field;
    fields[field] = fields[field] || [];
    fields[field].push(error2);
  });
  return fields;
}
function format(template) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  var i = 0;
  var len = args.length;
  if (typeof template === "function") {
    return template.apply(null, args);
  }
  if (typeof template === "string") {
    var str = template.replace(formatRegExp, function(x) {
      if (x === "%%") {
        return "%";
      }
      if (i >= len) {
        return x;
      }
      switch (x) {
        case "%s":
          return String(args[i++]);
        case "%d":
          return Number(args[i++]);
        case "%j":
          try {
            return JSON.stringify(args[i++]);
          } catch (_) {
            return "[Circular]";
          }
          break;
        default:
          return x;
      }
    });
    return str;
  }
  return template;
}
function isNativeStringType(type5) {
  return type5 === "string" || type5 === "url" || type5 === "hex" || type5 === "email" || type5 === "date" || type5 === "pattern";
}
function isEmptyValue(value, type5) {
  if (value === void 0 || value === null) {
    return true;
  }
  if (type5 === "array" && Array.isArray(value) && !value.length) {
    return true;
  }
  if (isNativeStringType(type5) && typeof value === "string" && !value) {
    return true;
  }
  return false;
}
function asyncParallelArray(arr, func, callback) {
  var results = [];
  var total = 0;
  var arrLength = arr.length;
  function count(errors) {
    results.push.apply(results, _toConsumableArray(errors || []));
    total++;
    if (total === arrLength) {
      callback(results);
    }
  }
  arr.forEach(function(a) {
    func(a, count);
  });
}
function asyncSerialArray(arr, func, callback) {
  var index3 = 0;
  var arrLength = arr.length;
  function next2(errors) {
    if (errors && errors.length) {
      callback(errors);
      return;
    }
    var original = index3;
    index3 = index3 + 1;
    if (original < arrLength) {
      func(arr[original], next2);
    } else {
      callback([]);
    }
  }
  next2([]);
}
function flattenObjArr(objArr) {
  var ret = [];
  Object.keys(objArr).forEach(function(k) {
    ret.push.apply(ret, _toConsumableArray(objArr[k] || []));
  });
  return ret;
}
var AsyncValidationError = /* @__PURE__ */ (function(_Error) {
  _inherits(AsyncValidationError2, _Error);
  var _super = _createSuper(AsyncValidationError2);
  function AsyncValidationError2(errors, fields) {
    var _this;
    _classCallCheck(this, AsyncValidationError2);
    _this = _super.call(this, "Async Validation Error");
    _defineProperty(_assertThisInitialized(_this), "errors", void 0);
    _defineProperty(_assertThisInitialized(_this), "fields", void 0);
    _this.errors = errors;
    _this.fields = fields;
    return _this;
  }
  return _createClass(AsyncValidationError2);
})(/* @__PURE__ */ _wrapNativeSuper(Error));
function asyncMap(objArr, option, func, callback, source) {
  if (option.first) {
    var _pending = new Promise(function(resolve, reject) {
      var next2 = function next3(errors) {
        callback(errors);
        return errors.length ? reject(new AsyncValidationError(errors, convertFieldsError(errors))) : resolve(source);
      };
      var flattenArr = flattenObjArr(objArr);
      asyncSerialArray(flattenArr, func, next2);
    });
    _pending.catch(function(e3) {
      return e3;
    });
    return _pending;
  }
  var firstFields = option.firstFields === true ? Object.keys(objArr) : option.firstFields || [];
  var objArrKeys = Object.keys(objArr);
  var objArrLength = objArrKeys.length;
  var total = 0;
  var results = [];
  var pending = new Promise(function(resolve, reject) {
    var next2 = function next3(errors) {
      results.push.apply(results, errors);
      total++;
      if (total === objArrLength) {
        callback(results);
        return results.length ? reject(new AsyncValidationError(results, convertFieldsError(results))) : resolve(source);
      }
    };
    if (!objArrKeys.length) {
      callback(results);
      resolve(source);
    }
    objArrKeys.forEach(function(key2) {
      var arr = objArr[key2];
      if (firstFields.indexOf(key2) !== -1) {
        asyncSerialArray(arr, func, next2);
      } else {
        asyncParallelArray(arr, func, next2);
      }
    });
  });
  pending.catch(function(e3) {
    return e3;
  });
  return pending;
}
function isErrorObj(obj) {
  return !!(obj && obj.message !== void 0);
}
function getValue2(value, path2) {
  var v = value;
  for (var i = 0; i < path2.length; i++) {
    if (v == void 0) {
      return v;
    }
    v = v[path2[i]];
  }
  return v;
}
function complementError(rule, source) {
  return function(oe) {
    var fieldValue;
    if (rule.fullFields) {
      fieldValue = getValue2(source, rule.fullFields);
    } else {
      fieldValue = source[oe.field || rule.fullField];
    }
    if (isErrorObj(oe)) {
      oe.field = oe.field || rule.fullField;
      oe.fieldValue = fieldValue;
      return oe;
    }
    return {
      message: typeof oe === "function" ? oe() : oe,
      fieldValue,
      field: oe.field || rule.fullField
    };
  };
}
function deepMerge(target, source) {
  if (source) {
    for (var s in source) {
      if (source.hasOwnProperty(s)) {
        var value = source[s];
        if (_typeof(value) === "object" && _typeof(target[s]) === "object") {
          target[s] = _objectSpread2(_objectSpread2({}, target[s]), value);
        } else {
          target[s] = value;
        }
      }
    }
  }
  return target;
}

// ../../node_modules/@rc-component/async-validator/es/rule/enum.js
var ENUM = "enum";
var enumerable = function enumerable2(rule, value, source, errors, options) {
  rule[ENUM] = Array.isArray(rule[ENUM]) ? rule[ENUM] : [];
  if (rule[ENUM].indexOf(value) === -1) {
    errors.push(format(options.messages[ENUM], rule.fullField, rule[ENUM].join(", ")));
  }
};
var enum_default = enumerable;

// ../../node_modules/@rc-component/async-validator/es/rule/pattern.js
var pattern = function pattern2(rule, value, source, errors, options) {
  if (rule.pattern) {
    if (rule.pattern instanceof RegExp) {
      rule.pattern.lastIndex = 0;
      if (!rule.pattern.test(value)) {
        errors.push(format(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
      }
    } else if (typeof rule.pattern === "string") {
      var _pattern = new RegExp(rule.pattern);
      if (!_pattern.test(value)) {
        errors.push(format(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
      }
    }
  }
};
var pattern_default = pattern;

// ../../node_modules/@rc-component/async-validator/es/rule/range.js
var range = function range2(rule, value, source, errors, options) {
  var len = typeof rule.len === "number";
  var min = typeof rule.min === "number";
  var max = typeof rule.max === "number";
  var spRegexp = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
  var val = value;
  var key2 = null;
  var num = typeof value === "number";
  var str = typeof value === "string";
  var arr = Array.isArray(value);
  if (num) {
    key2 = "number";
  } else if (str) {
    key2 = "string";
  } else if (arr) {
    key2 = "array";
  }
  if (!key2) {
    return false;
  }
  if (arr) {
    val = value.length;
  }
  if (str) {
    val = value.replace(spRegexp, "_").length;
  }
  if (len) {
    if (val !== rule.len) {
      errors.push(format(options.messages[key2].len, rule.fullField, rule.len));
    }
  } else if (min && !max && val < rule.min) {
    errors.push(format(options.messages[key2].min, rule.fullField, rule.min));
  } else if (max && !min && val > rule.max) {
    errors.push(format(options.messages[key2].max, rule.fullField, rule.max));
  } else if (min && max && (val < rule.min || val > rule.max)) {
    errors.push(format(options.messages[key2].range, rule.fullField, rule.min, rule.max));
  }
};
var range_default = range;

// ../../node_modules/@rc-component/async-validator/es/rule/required.js
var required = function required2(rule, value, source, errors, options, type5) {
  if (rule.required && (!source.hasOwnProperty(rule.field) || isEmptyValue(value, type5 || rule.type))) {
    errors.push(format(options.messages.required, rule.fullField));
  }
};
var required_default = required;

// ../../node_modules/@rc-component/async-validator/es/rule/url.js
var urlReg;
var url_default = (function() {
  if (urlReg) {
    return urlReg;
  }
  var word = "[a-fA-F\\d:]";
  var b = function b2(options) {
    return options && options.includeBoundaries ? "(?:(?<=\\s|^)(?=".concat(word, ")|(?<=").concat(word, ")(?=\\s|$))") : "";
  };
  var v4 = "(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}";
  var v6seg = "[a-fA-F\\d]{1,4}";
  var v6List = [
    "(?:".concat(v6seg, ":){7}(?:").concat(v6seg, "|:)"),
    // 1:2:3:4:5:6:7::  1:2:3:4:5:6:7:8
    "(?:".concat(v6seg, ":){6}(?:").concat(v4, "|:").concat(v6seg, "|:)"),
    // 1:2:3:4:5:6::    1:2:3:4:5:6::8   1:2:3:4:5:6::8  1:2:3:4:5:6::
    "(?:".concat(v6seg, ":){5}(?::").concat(v4, "|(?::").concat(v6seg, "){1,2}|:)"),
    // 1:2:3:4:5::      1:2:3:4:5::7:8   1:2:3:4:5::8    1:2:3:4:5::
    "(?:".concat(v6seg, ":){4}(?:(?::").concat(v6seg, "){0,1}:").concat(v4, "|(?::").concat(v6seg, "){1,3}|:)"),
    // 1:2:3:4::        1:2:3:4::6:7:8   1:2:3:4::8      1:2:3:4::
    "(?:".concat(v6seg, ":){3}(?:(?::").concat(v6seg, "){0,2}:").concat(v4, "|(?::").concat(v6seg, "){1,4}|:)"),
    // 1:2:3::          1:2:3::5:6:7:8   1:2:3::8        1:2:3::
    "(?:".concat(v6seg, ":){2}(?:(?::").concat(v6seg, "){0,3}:").concat(v4, "|(?::").concat(v6seg, "){1,5}|:)"),
    // 1:2::            1:2::4:5:6:7:8   1:2::8          1:2::
    "(?:".concat(v6seg, ":){1}(?:(?::").concat(v6seg, "){0,4}:").concat(v4, "|(?::").concat(v6seg, "){1,6}|:)"),
    // 1::              1::3:4:5:6:7:8   1::8            1::
    "(?::(?:(?::".concat(v6seg, "){0,5}:").concat(v4, "|(?::").concat(v6seg, "){1,7}|:))")
    // ::2:3:4:5:6:7:8  ::2:3:4:5:6:7:8  ::8             ::
  ];
  var v6Eth0 = "(?:%[0-9a-zA-Z]{1,})?";
  var v6 = "(?:".concat(v6List.join("|"), ")").concat(v6Eth0);
  var v46Exact = new RegExp("(?:^".concat(v4, "$)|(?:^").concat(v6, "$)"));
  var v4exact = new RegExp("^".concat(v4, "$"));
  var v6exact = new RegExp("^".concat(v6, "$"));
  var ip = function ip2(options) {
    return options && options.exact ? v46Exact : new RegExp("(?:".concat(b(options)).concat(v4).concat(b(options), ")|(?:").concat(b(options)).concat(v6).concat(b(options), ")"), "g");
  };
  ip.v4 = function(options) {
    return options && options.exact ? v4exact : new RegExp("".concat(b(options)).concat(v4).concat(b(options)), "g");
  };
  ip.v6 = function(options) {
    return options && options.exact ? v6exact : new RegExp("".concat(b(options)).concat(v6).concat(b(options)), "g");
  };
  var protocol = "(?:(?:[a-z]+:)?//)";
  var auth = "(?:\\S+(?::\\S*)?@)?";
  var ipv4 = ip.v4().source;
  var ipv6 = ip.v6().source;
  var host = "(?:(?:[a-z\\u00a1-\\uffff0-9][-_]*)*[a-z\\u00a1-\\uffff0-9]+)";
  var domain = "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*";
  var tld = "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))";
  var port = "(?::\\d{2,5})?";
  var path2 = '(?:[/?#][^\\s"]*)?';
  var regex = "(?:".concat(protocol, "|www\\.)").concat(auth, "(?:localhost|").concat(ipv4, "|").concat(ipv6, "|").concat(host).concat(domain).concat(tld, ")").concat(port).concat(path2);
  urlReg = new RegExp("(?:^".concat(regex, "$)"), "i");
  return urlReg;
});

// ../../node_modules/@rc-component/async-validator/es/rule/type.js
var pattern3 = {
  // http://emailregex.com/
  email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+\.)+[a-zA-Z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}))$/,
  // url: new RegExp(
  //   '^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$',
  //   'i',
  // ),
  hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i
};
var types2 = {
  integer: function integer(value) {
    return types2.number(value) && parseInt(value, 10) === value;
  },
  float: function float(value) {
    return types2.number(value) && !types2.integer(value);
  },
  array: function array(value) {
    return Array.isArray(value);
  },
  regexp: function regexp3(value) {
    if (value instanceof RegExp) {
      return true;
    }
    try {
      return !!new RegExp(value);
    } catch (e3) {
      return false;
    }
  },
  date: function date(value) {
    return typeof value.getTime === "function" && typeof value.getMonth === "function" && typeof value.getYear === "function" && !isNaN(value.getTime());
  },
  number: function number(value) {
    if (isNaN(value)) {
      return false;
    }
    return typeof value === "number";
  },
  object: function object(value) {
    return _typeof(value) === "object" && !types2.array(value);
  },
  method: function method(value) {
    return typeof value === "function";
  },
  email: function email(value) {
    return typeof value === "string" && value.length <= 320 && !!value.match(pattern3.email);
  },
  url: function url(value) {
    return typeof value === "string" && value.length <= 2048 && !!value.match(url_default());
  },
  hex: function hex(value) {
    return typeof value === "string" && !!value.match(pattern3.hex);
  }
};
var type = function type2(rule, value, source, errors, options) {
  if (rule.required && value === void 0) {
    required_default(rule, value, source, errors, options);
    return;
  }
  var custom2 = ["integer", "float", "array", "regexp", "object", "method", "email", "number", "date", "url", "hex"];
  var ruleType = rule.type;
  if (custom2.indexOf(ruleType) > -1) {
    if (!types2[ruleType](value)) {
      errors.push(format(options.messages.types[ruleType], rule.fullField, rule.type));
    }
  } else if (ruleType && _typeof(value) !== rule.type) {
    errors.push(format(options.messages.types[ruleType], rule.fullField, rule.type));
  }
};
var type_default = type;

// ../../node_modules/@rc-component/async-validator/es/rule/whitespace.js
var whitespace2 = function whitespace3(rule, value, source, errors, options) {
  if (/^\s+$/.test(value) || value === "") {
    errors.push(format(options.messages.whitespace, rule.fullField));
  }
};
var whitespace_default = whitespace2;

// ../../node_modules/@rc-component/async-validator/es/rule/index.js
var rule_default = {
  required: required_default,
  whitespace: whitespace_default,
  type: type_default,
  range: range_default,
  enum: enum_default,
  pattern: pattern_default
};

// ../../node_modules/@rc-component/async-validator/es/validator/any.js
var any = function any2(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }
    rule_default.required(rule, value, source, errors, options);
  }
  callback(errors);
};
var any_default = any;

// ../../node_modules/@rc-component/async-validator/es/validator/array.js
var array2 = function array3(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((value === void 0 || value === null) && !rule.required) {
      return callback();
    }
    rule_default.required(rule, value, source, errors, options, "array");
    if (value !== void 0 && value !== null) {
      rule_default.type(rule, value, source, errors, options);
      rule_default.range(rule, value, source, errors, options);
    }
  }
  callback(errors);
};
var array_default = array2;

// ../../node_modules/@rc-component/async-validator/es/validator/boolean.js
var boolean = function boolean2(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }
    rule_default.required(rule, value, source, errors, options);
    if (value !== void 0) {
      rule_default.type(rule, value, source, errors, options);
    }
  }
  callback(errors);
};
var boolean_default = boolean;

// ../../node_modules/@rc-component/async-validator/es/validator/date.js
var date2 = function date3(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (isEmptyValue(value, "date") && !rule.required) {
      return callback();
    }
    rule_default.required(rule, value, source, errors, options);
    if (!isEmptyValue(value, "date")) {
      var dateObject;
      if (value instanceof Date) {
        dateObject = value;
      } else {
        dateObject = new Date(value);
      }
      rule_default.type(rule, dateObject, source, errors, options);
      if (dateObject) {
        rule_default.range(rule, dateObject.getTime(), source, errors, options);
      }
    }
  }
  callback(errors);
};
var date_default = date2;

// ../../node_modules/@rc-component/async-validator/es/validator/enum.js
var ENUM2 = "enum";
var enumerable3 = function enumerable4(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }
    rule_default.required(rule, value, source, errors, options);
    if (value !== void 0) {
      rule_default[ENUM2](rule, value, source, errors, options);
    }
  }
  callback(errors);
};
var enum_default2 = enumerable3;

// ../../node_modules/@rc-component/async-validator/es/validator/float.js
var floatFn = function floatFn2(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }
    rule_default.required(rule, value, source, errors, options);
    if (value !== void 0) {
      rule_default.type(rule, value, source, errors, options);
      rule_default.range(rule, value, source, errors, options);
    }
  }
  callback(errors);
};
var float_default = floatFn;

// ../../node_modules/@rc-component/async-validator/es/validator/integer.js
var integer2 = function integer3(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }
    rule_default.required(rule, value, source, errors, options);
    if (value !== void 0) {
      rule_default.type(rule, value, source, errors, options);
      rule_default.range(rule, value, source, errors, options);
    }
  }
  callback(errors);
};
var integer_default = integer2;

// ../../node_modules/@rc-component/async-validator/es/validator/method.js
var method2 = function method3(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }
    rule_default.required(rule, value, source, errors, options);
    if (value !== void 0) {
      rule_default.type(rule, value, source, errors, options);
    }
  }
  callback(errors);
};
var method_default = method2;

// ../../node_modules/@rc-component/async-validator/es/validator/number.js
var number2 = function number3(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (value === "") {
      value = void 0;
    }
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }
    rule_default.required(rule, value, source, errors, options);
    if (value !== void 0) {
      rule_default.type(rule, value, source, errors, options);
      rule_default.range(rule, value, source, errors, options);
    }
  }
  callback(errors);
};
var number_default = number2;

// ../../node_modules/@rc-component/async-validator/es/validator/object.js
var object2 = function object3(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }
    rule_default.required(rule, value, source, errors, options);
    if (value !== void 0) {
      rule_default.type(rule, value, source, errors, options);
    }
  }
  callback(errors);
};
var object_default = object2;

// ../../node_modules/@rc-component/async-validator/es/validator/pattern.js
var pattern4 = function pattern5(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (isEmptyValue(value, "string") && !rule.required) {
      return callback();
    }
    rule_default.required(rule, value, source, errors, options);
    if (!isEmptyValue(value, "string")) {
      rule_default.pattern(rule, value, source, errors, options);
    }
  }
  callback(errors);
};
var pattern_default2 = pattern4;

// ../../node_modules/@rc-component/async-validator/es/validator/regexp.js
var regexp4 = function regexp5(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }
    rule_default.required(rule, value, source, errors, options);
    if (!isEmptyValue(value)) {
      rule_default.type(rule, value, source, errors, options);
    }
  }
  callback(errors);
};
var regexp_default = regexp4;

// ../../node_modules/@rc-component/async-validator/es/validator/required.js
var required3 = function required4(rule, value, callback, source, options) {
  var errors = [];
  var type5 = Array.isArray(value) ? "array" : _typeof(value);
  rule_default.required(rule, value, source, errors, options, type5);
  callback(errors);
};
var required_default2 = required3;

// ../../node_modules/@rc-component/async-validator/es/validator/string.js
var string = function string2(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (isEmptyValue(value, "string") && !rule.required) {
      return callback();
    }
    rule_default.required(rule, value, source, errors, options, "string");
    if (!isEmptyValue(value, "string")) {
      rule_default.type(rule, value, source, errors, options);
      rule_default.range(rule, value, source, errors, options);
      rule_default.pattern(rule, value, source, errors, options);
      if (rule.whitespace === true) {
        rule_default.whitespace(rule, value, source, errors, options);
      }
    }
  }
  callback(errors);
};
var string_default = string;

// ../../node_modules/@rc-component/async-validator/es/validator/type.js
var type3 = function type4(rule, value, callback, source, options) {
  var ruleType = rule.type;
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (isEmptyValue(value, ruleType) && !rule.required) {
      return callback();
    }
    rule_default.required(rule, value, source, errors, options, ruleType);
    if (!isEmptyValue(value, ruleType)) {
      rule_default.type(rule, value, source, errors, options);
    }
  }
  callback(errors);
};
var type_default2 = type3;

// ../../node_modules/@rc-component/async-validator/es/validator/index.js
var validator_default = {
  string: string_default,
  method: method_default,
  number: number_default,
  boolean: boolean_default,
  regexp: regexp_default,
  integer: integer_default,
  float: float_default,
  array: array_default,
  object: object_default,
  enum: enum_default2,
  pattern: pattern_default2,
  date: date_default,
  url: type_default2,
  hex: type_default2,
  email: type_default2,
  required: required_default2,
  any: any_default
};

// ../../node_modules/@rc-component/async-validator/es/index.js
var Schema2 = /* @__PURE__ */ (function() {
  function Schema5(descriptor) {
    _classCallCheck(this, Schema5);
    _defineProperty(this, "rules", null);
    _defineProperty(this, "_messages", messages);
    this.define(descriptor);
  }
  _createClass(Schema5, [{
    key: "define",
    value: function define2(rules) {
      var _this = this;
      if (!rules) {
        throw new Error("Cannot configure a schema with no rules");
      }
      if (_typeof(rules) !== "object" || Array.isArray(rules)) {
        throw new Error("Rules must be an object");
      }
      this.rules = {};
      Object.keys(rules).forEach(function(name) {
        var item = rules[name];
        _this.rules[name] = Array.isArray(item) ? item : [item];
      });
    }
  }, {
    key: "messages",
    value: function messages2(_messages) {
      if (_messages) {
        this._messages = deepMerge(newMessages(), _messages);
      }
      return this._messages;
    }
  }, {
    key: "validate",
    value: function validate(source_) {
      var _this2 = this;
      var o3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      var oc = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function() {
      };
      var source = source_;
      var options = o3;
      var callback = oc;
      if (typeof options === "function") {
        callback = options;
        options = {};
      }
      if (!this.rules || Object.keys(this.rules).length === 0) {
        if (callback) {
          callback(null, source);
        }
        return Promise.resolve(source);
      }
      function complete(results) {
        var errors = [];
        var fields = {};
        function add3(e3) {
          if (Array.isArray(e3)) {
            var _errors;
            errors = (_errors = errors).concat.apply(_errors, _toConsumableArray(e3));
          } else {
            errors.push(e3);
          }
        }
        for (var i = 0; i < results.length; i++) {
          add3(results[i]);
        }
        if (!errors.length) {
          callback(null, source);
        } else {
          fields = convertFieldsError(errors);
          callback(errors, fields);
        }
      }
      if (options.messages) {
        var messages2 = this.messages();
        if (messages2 === messages) {
          messages2 = newMessages();
        }
        deepMerge(messages2, options.messages);
        options.messages = messages2;
      } else {
        options.messages = this.messages();
      }
      var series = {};
      var keys4 = options.keys || Object.keys(this.rules);
      keys4.forEach(function(z) {
        var arr = _this2.rules[z];
        var value = source[z];
        arr.forEach(function(r2) {
          var rule = r2;
          if (typeof rule.transform === "function") {
            if (source === source_) {
              source = _objectSpread2({}, source);
            }
            value = source[z] = rule.transform(value);
            if (value !== void 0 && value !== null) {
              rule.type = rule.type || (Array.isArray(value) ? "array" : _typeof(value));
            }
          }
          if (typeof rule === "function") {
            rule = {
              validator: rule
            };
          } else {
            rule = _objectSpread2({}, rule);
          }
          rule.validator = _this2.getValidationMethod(rule);
          if (!rule.validator) {
            return;
          }
          rule.field = z;
          rule.fullField = rule.fullField || z;
          rule.type = _this2.getType(rule);
          series[z] = series[z] || [];
          series[z].push({
            rule,
            value,
            source,
            field: z
          });
        });
      });
      var errorFields = {};
      return asyncMap(series, options, function(data2, doIt) {
        var rule = data2.rule;
        var deep = (rule.type === "object" || rule.type === "array") && (_typeof(rule.fields) === "object" || _typeof(rule.defaultField) === "object");
        deep = deep && (rule.required || !rule.required && data2.value);
        rule.field = data2.field;
        function addFullField(key2, schema) {
          return _objectSpread2(_objectSpread2({}, schema), {}, {
            fullField: "".concat(rule.fullField, ".").concat(key2),
            fullFields: rule.fullFields ? [].concat(_toConsumableArray(rule.fullFields), [key2]) : [key2]
          });
        }
        function cb() {
          var e3 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
          var errorList = Array.isArray(e3) ? e3 : [e3];
          if (!options.suppressWarning && errorList.length) {
            Schema5.warning("async-validator:", errorList);
          }
          if (errorList.length && rule.message !== void 0) {
            errorList = [].concat(rule.message);
          }
          var filledErrors = errorList.map(complementError(rule, source));
          if (options.first && filledErrors.length) {
            errorFields[rule.field] = 1;
            return doIt(filledErrors);
          }
          if (!deep) {
            doIt(filledErrors);
          } else {
            if (rule.required && !data2.value) {
              if (rule.message !== void 0) {
                filledErrors = [].concat(rule.message).map(complementError(rule, source));
              } else if (options.error) {
                filledErrors = [options.error(rule, format(options.messages.required, rule.field))];
              }
              return doIt(filledErrors);
            }
            var fieldsSchema = {};
            if (rule.defaultField) {
              Object.keys(data2.value).map(function(key2) {
                fieldsSchema[key2] = rule.defaultField;
              });
            }
            fieldsSchema = _objectSpread2(_objectSpread2({}, fieldsSchema), data2.rule.fields);
            var paredFieldsSchema = {};
            Object.keys(fieldsSchema).forEach(function(field) {
              var fieldSchema = fieldsSchema[field];
              var fieldSchemaList = Array.isArray(fieldSchema) ? fieldSchema : [fieldSchema];
              paredFieldsSchema[field] = fieldSchemaList.map(addFullField.bind(null, field));
            });
            var schema = new Schema5(paredFieldsSchema);
            schema.messages(options.messages);
            if (data2.rule.options) {
              data2.rule.options.messages = options.messages;
              data2.rule.options.error = options.error;
            }
            schema.validate(data2.value, data2.rule.options || options, function(errs) {
              var finalErrors = [];
              if (filledErrors && filledErrors.length) {
                finalErrors.push.apply(finalErrors, _toConsumableArray(filledErrors));
              }
              if (errs && errs.length) {
                finalErrors.push.apply(finalErrors, _toConsumableArray(errs));
              }
              doIt(finalErrors.length ? finalErrors : null);
            });
          }
        }
        var res;
        if (rule.asyncValidator) {
          res = rule.asyncValidator(rule, data2.value, cb, data2.source, options);
        } else if (rule.validator) {
          try {
            res = rule.validator(rule, data2.value, cb, data2.source, options);
          } catch (error2) {
            var _console$error, _console;
            (_console$error = (_console = console).error) === null || _console$error === void 0 || _console$error.call(_console, error2);
            if (!options.suppressValidatorError) {
              setTimeout(function() {
                throw error2;
              }, 0);
            }
            cb(error2.message);
          }
          if (res === true) {
            cb();
          } else if (res === false) {
            cb(typeof rule.message === "function" ? rule.message(rule.fullField || rule.field) : rule.message || "".concat(rule.fullField || rule.field, " fails"));
          } else if (res instanceof Array) {
            cb(res);
          } else if (res instanceof Error) {
            cb(res.message);
          }
        }
        if (res && res.then) {
          res.then(function() {
            return cb();
          }, function(e3) {
            return cb(e3);
          });
        }
      }, function(results) {
        complete(results);
      }, source);
    }
  }, {
    key: "getType",
    value: function getType2(rule) {
      if (rule.type === void 0 && rule.pattern instanceof RegExp) {
        rule.type = "pattern";
      }
      if (typeof rule.validator !== "function" && rule.type && !validator_default.hasOwnProperty(rule.type)) {
        throw new Error(format("Unknown rule type %s", rule.type));
      }
      return rule.type || "string";
    }
  }, {
    key: "getValidationMethod",
    value: function getValidationMethod(rule) {
      if (typeof rule.validator === "function") {
        return rule.validator;
      }
      var keys4 = Object.keys(rule);
      var messageIndex = keys4.indexOf("message");
      if (messageIndex !== -1) {
        keys4.splice(messageIndex, 1);
      }
      if (keys4.length === 1 && keys4[0] === "required") {
        return validator_default.required;
      }
      return validator_default[this.getType(rule)] || void 0;
    }
  }]);
  return Schema5;
})();
_defineProperty(Schema2, "register", function register(type5, validator) {
  if (typeof validator !== "function") {
    throw new Error("Cannot register a validator by type, validator is not a function");
  }
  validator_default[type5] = validator;
});
_defineProperty(Schema2, "warning", warning4);
_defineProperty(Schema2, "messages", messages);
_defineProperty(Schema2, "validators", validator_default);
var es_default6 = Schema2;

// ../../node_modules/rc-field-form/es/utils/validateUtil.js
var React103 = __toESM(require_react());

// ../../node_modules/rc-field-form/es/utils/messages.js
var typeTemplate2 = "'${name}' is not a valid ${type}";
var defaultValidateMessages = {
  default: "Validation error on field '${name}'",
  required: "'${name}' is required",
  enum: "'${name}' must be one of [${enum}]",
  whitespace: "'${name}' cannot be empty",
  date: {
    format: "'${name}' is invalid for format date",
    parse: "'${name}' could not be parsed as date",
    invalid: "'${name}' is invalid date"
  },
  types: {
    string: typeTemplate2,
    method: typeTemplate2,
    array: typeTemplate2,
    object: typeTemplate2,
    number: typeTemplate2,
    date: typeTemplate2,
    boolean: typeTemplate2,
    integer: typeTemplate2,
    float: typeTemplate2,
    regexp: typeTemplate2,
    email: typeTemplate2,
    url: typeTemplate2,
    hex: typeTemplate2
  },
  string: {
    len: "'${name}' must be exactly ${len} characters",
    min: "'${name}' must be at least ${min} characters",
    max: "'${name}' cannot be longer than ${max} characters",
    range: "'${name}' must be between ${min} and ${max} characters"
  },
  number: {
    len: "'${name}' must equal ${len}",
    min: "'${name}' cannot be less than ${min}",
    max: "'${name}' cannot be greater than ${max}",
    range: "'${name}' must be between ${min} and ${max}"
  },
  array: {
    len: "'${name}' must be exactly ${len} in length",
    min: "'${name}' cannot be less than ${min} in length",
    max: "'${name}' cannot be greater than ${max} in length",
    range: "'${name}' must be between ${min} and ${max} in length"
  },
  pattern: {
    mismatch: "'${name}' does not match pattern ${pattern}"
  }
};

// ../../node_modules/rc-field-form/es/utils/validateUtil.js
var AsyncValidator = es_default6;
function replaceMessage(template, kv) {
  return template.replace(/\\?\$\{\w+\}/g, function(str) {
    if (str.startsWith("\\")) {
      return str.slice(1);
    }
    var key2 = str.slice(2, -1);
    return kv[key2];
  });
}
var CODE_LOGIC_ERROR = "CODE_LOGIC_ERROR";
function validateRule(_x, _x2, _x3, _x4, _x5) {
  return _validateRule.apply(this, arguments);
}
function _validateRule() {
  _validateRule = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee2(name, value, rule, options, messageVariables) {
    var cloneRule, originValidator, subRuleField, validator, messages2, result, subResults, kv, fillVariableResult;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          cloneRule = _objectSpread2({}, rule);
          delete cloneRule.ruleIndex;
          AsyncValidator.warning = function() {
            return void 0;
          };
          if (cloneRule.validator) {
            originValidator = cloneRule.validator;
            cloneRule.validator = function() {
              try {
                return originValidator.apply(void 0, arguments);
              } catch (error2) {
                console.error(error2);
                return Promise.reject(CODE_LOGIC_ERROR);
              }
            };
          }
          subRuleField = null;
          if (cloneRule && cloneRule.type === "array" && cloneRule.defaultField) {
            subRuleField = cloneRule.defaultField;
            delete cloneRule.defaultField;
          }
          validator = new AsyncValidator(_defineProperty({}, name, [cloneRule]));
          messages2 = merge(defaultValidateMessages, options.validateMessages);
          validator.messages(messages2);
          result = [];
          _context2.prev = 10;
          _context2.next = 13;
          return Promise.resolve(validator.validate(_defineProperty({}, name, value), _objectSpread2({}, options)));
        case 13:
          _context2.next = 18;
          break;
        case 15:
          _context2.prev = 15;
          _context2.t0 = _context2["catch"](10);
          if (_context2.t0.errors) {
            result = _context2.t0.errors.map(function(_ref4, index3) {
              var message2 = _ref4.message;
              var mergedMessage = message2 === CODE_LOGIC_ERROR ? messages2.default : message2;
              return /* @__PURE__ */ React103.isValidElement(mergedMessage) ? (
                // Wrap ReactNode with `key`
                /* @__PURE__ */ React103.cloneElement(mergedMessage, {
                  key: "error_".concat(index3)
                })
              ) : mergedMessage;
            });
          }
        case 18:
          if (!(!result.length && subRuleField)) {
            _context2.next = 23;
            break;
          }
          _context2.next = 21;
          return Promise.all(value.map(function(subValue, i) {
            return validateRule("".concat(name, ".").concat(i), subValue, subRuleField, options, messageVariables);
          }));
        case 21:
          subResults = _context2.sent;
          return _context2.abrupt("return", subResults.reduce(function(prev2, errors) {
            return [].concat(_toConsumableArray(prev2), _toConsumableArray(errors));
          }, []));
        case 23:
          kv = _objectSpread2(_objectSpread2({}, rule), {}, {
            name,
            enum: (rule.enum || []).join(", ")
          }, messageVariables);
          fillVariableResult = result.map(function(error2) {
            if (typeof error2 === "string") {
              return replaceMessage(error2, kv);
            }
            return error2;
          });
          return _context2.abrupt("return", fillVariableResult);
        case 26:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[10, 15]]);
  }));
  return _validateRule.apply(this, arguments);
}
function validateRules(namePath, value, rules, options, validateFirst, messageVariables) {
  var name = namePath.join(".");
  var filledRules = rules.map(function(currentRule, ruleIndex) {
    var originValidatorFunc = currentRule.validator;
    var cloneRule = _objectSpread2(_objectSpread2({}, currentRule), {}, {
      ruleIndex
    });
    if (originValidatorFunc) {
      cloneRule.validator = function(rule, val, callback) {
        var hasPromise = false;
        var wrappedCallback = function wrappedCallback2() {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          Promise.resolve().then(function() {
            warning_default(!hasPromise, "Your validator function has already return a promise. `callback` will be ignored.");
            if (!hasPromise) {
              callback.apply(void 0, args);
            }
          });
        };
        var promise = originValidatorFunc(rule, val, wrappedCallback);
        hasPromise = promise && typeof promise.then === "function" && typeof promise.catch === "function";
        warning_default(hasPromise, "`callback` is deprecated. Please return a promise instead.");
        if (hasPromise) {
          promise.then(function() {
            callback();
          }).catch(function(err) {
            callback(err || " ");
          });
        }
      };
    }
    return cloneRule;
  }).sort(function(_ref, _ref2) {
    var w1 = _ref.warningOnly, i1 = _ref.ruleIndex;
    var w2 = _ref2.warningOnly, i2 = _ref2.ruleIndex;
    if (!!w1 === !!w2) {
      return i1 - i2;
    }
    if (w1) {
      return 1;
    }
    return -1;
  });
  var summaryPromise;
  if (validateFirst === true) {
    summaryPromise = new Promise(/* @__PURE__ */ (function() {
      var _ref3 = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee(resolve, reject) {
        var i, rule, errors;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              i = 0;
            case 1:
              if (!(i < filledRules.length)) {
                _context.next = 12;
                break;
              }
              rule = filledRules[i];
              _context.next = 5;
              return validateRule(name, value, rule, options, messageVariables);
            case 5:
              errors = _context.sent;
              if (!errors.length) {
                _context.next = 9;
                break;
              }
              reject([{
                errors,
                rule
              }]);
              return _context.abrupt("return");
            case 9:
              i += 1;
              _context.next = 1;
              break;
            case 12:
              resolve([]);
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function(_x6, _x7) {
        return _ref3.apply(this, arguments);
      };
    })());
  } else {
    var rulePromises = filledRules.map(function(rule) {
      return validateRule(name, value, rule, options, messageVariables).then(function(errors) {
        return {
          errors,
          rule
        };
      });
    });
    summaryPromise = (validateFirst ? finishOnFirstFailed(rulePromises) : finishOnAllFailed(rulePromises)).then(function(errors) {
      return Promise.reject(errors);
    });
  }
  summaryPromise.catch(function(e3) {
    return e3;
  });
  return summaryPromise;
}
function finishOnAllFailed(_x8) {
  return _finishOnAllFailed.apply(this, arguments);
}
function _finishOnAllFailed() {
  _finishOnAllFailed = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee3(rulePromises) {
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          return _context3.abrupt("return", Promise.all(rulePromises).then(function(errorsList) {
            var _ref5;
            var errors = (_ref5 = []).concat.apply(_ref5, _toConsumableArray(errorsList));
            return errors;
          }));
        case 1:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _finishOnAllFailed.apply(this, arguments);
}
function finishOnFirstFailed(_x9) {
  return _finishOnFirstFailed.apply(this, arguments);
}
function _finishOnFirstFailed() {
  _finishOnFirstFailed = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee4(rulePromises) {
    var count;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          count = 0;
          return _context4.abrupt("return", new Promise(function(resolve) {
            rulePromises.forEach(function(promise) {
              promise.then(function(ruleError) {
                if (ruleError.errors.length) {
                  resolve([ruleError]);
                }
                count += 1;
                if (count === rulePromises.length) {
                  resolve([]);
                }
              });
            });
          }));
        case 2:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _finishOnFirstFailed.apply(this, arguments);
}

// ../../node_modules/rc-field-form/es/utils/valueUtil.js
function getNamePath(path2) {
  return toArray2(path2);
}
function cloneByNamePathList(store, namePathList) {
  var newStore = {};
  namePathList.forEach(function(namePath) {
    var value = get(store, namePath);
    newStore = set2(newStore, namePath, value);
  });
  return newStore;
}
function containsNamePath(namePathList, namePath) {
  var partialMatch = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
  return namePathList && namePathList.some(function(path2) {
    return matchNamePath(namePath, path2, partialMatch);
  });
}
function matchNamePath(namePath, subNamePath) {
  var partialMatch = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
  if (!namePath || !subNamePath) {
    return false;
  }
  if (!partialMatch && namePath.length !== subNamePath.length) {
    return false;
  }
  return subNamePath.every(function(nameUnit, i) {
    return namePath[i] === nameUnit;
  });
}
function isSimilar(source, target) {
  if (source === target) {
    return true;
  }
  if (!source && target || source && !target) {
    return false;
  }
  if (!source || !target || _typeof(source) !== "object" || _typeof(target) !== "object") {
    return false;
  }
  var sourceKeys = Object.keys(source);
  var targetKeys = Object.keys(target);
  var keys4 = new Set([].concat(sourceKeys, targetKeys));
  return _toConsumableArray(keys4).every(function(key2) {
    var sourceValue = source[key2];
    var targetValue = target[key2];
    if (typeof sourceValue === "function" && typeof targetValue === "function") {
      return true;
    }
    return sourceValue === targetValue;
  });
}
function defaultGetValueFromEvent(valuePropName) {
  var event = arguments.length <= 1 ? void 0 : arguments[1];
  if (event && event.target && _typeof(event.target) === "object" && valuePropName in event.target) {
    return event.target[valuePropName];
  }
  return event;
}
function move(array4, moveIndex, toIndex) {
  var length2 = array4.length;
  if (moveIndex < 0 || moveIndex >= length2 || toIndex < 0 || toIndex >= length2) {
    return array4;
  }
  var item = array4[moveIndex];
  var diff3 = moveIndex - toIndex;
  if (diff3 > 0) {
    return [].concat(_toConsumableArray(array4.slice(0, toIndex)), [item], _toConsumableArray(array4.slice(toIndex, moveIndex)), _toConsumableArray(array4.slice(moveIndex + 1, length2)));
  }
  if (diff3 < 0) {
    return [].concat(_toConsumableArray(array4.slice(0, moveIndex)), _toConsumableArray(array4.slice(moveIndex + 1, toIndex + 1)), [item], _toConsumableArray(array4.slice(toIndex + 1, length2)));
  }
  return array4;
}

// ../../node_modules/rc-field-form/es/Field.js
var _excluded10 = ["name"];
var EMPTY_ERRORS = [];
function requireUpdate(shouldUpdate, prev2, next2, prevValue, nextValue, info) {
  if (typeof shouldUpdate === "function") {
    return shouldUpdate(prev2, next2, "source" in info ? {
      source: info.source
    } : {});
  }
  return prevValue !== nextValue;
}
var Field = /* @__PURE__ */ (function(_React$Component) {
  _inherits(Field2, _React$Component);
  var _super = _createSuper(Field2);
  function Field2(props) {
    var _this;
    _classCallCheck(this, Field2);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "state", {
      resetCount: 0
    });
    _defineProperty(_assertThisInitialized(_this), "cancelRegisterFunc", null);
    _defineProperty(_assertThisInitialized(_this), "mounted", false);
    _defineProperty(_assertThisInitialized(_this), "touched", false);
    _defineProperty(_assertThisInitialized(_this), "dirty", false);
    _defineProperty(_assertThisInitialized(_this), "validatePromise", void 0);
    _defineProperty(_assertThisInitialized(_this), "prevValidating", void 0);
    _defineProperty(_assertThisInitialized(_this), "errors", EMPTY_ERRORS);
    _defineProperty(_assertThisInitialized(_this), "warnings", EMPTY_ERRORS);
    _defineProperty(_assertThisInitialized(_this), "cancelRegister", function() {
      var _this$props = _this.props, preserve2 = _this$props.preserve, isListField = _this$props.isListField, name = _this$props.name;
      if (_this.cancelRegisterFunc) {
        _this.cancelRegisterFunc(isListField, preserve2, getNamePath(name));
      }
      _this.cancelRegisterFunc = null;
    });
    _defineProperty(_assertThisInitialized(_this), "getNamePath", function() {
      var _this$props2 = _this.props, name = _this$props2.name, fieldContext = _this$props2.fieldContext;
      var _fieldContext$prefixN = fieldContext.prefixName, prefixName = _fieldContext$prefixN === void 0 ? [] : _fieldContext$prefixN;
      return name !== void 0 ? [].concat(_toConsumableArray(prefixName), _toConsumableArray(name)) : [];
    });
    _defineProperty(_assertThisInitialized(_this), "getRules", function() {
      var _this$props3 = _this.props, _this$props3$rules = _this$props3.rules, rules = _this$props3$rules === void 0 ? [] : _this$props3$rules, fieldContext = _this$props3.fieldContext;
      return rules.map(function(rule) {
        if (typeof rule === "function") {
          return rule(fieldContext);
        }
        return rule;
      });
    });
    _defineProperty(_assertThisInitialized(_this), "refresh", function() {
      if (!_this.mounted) return;
      _this.setState(function(_ref) {
        var resetCount = _ref.resetCount;
        return {
          resetCount: resetCount + 1
        };
      });
    });
    _defineProperty(_assertThisInitialized(_this), "metaCache", null);
    _defineProperty(_assertThisInitialized(_this), "triggerMetaEvent", function(destroy2) {
      var onMetaChange = _this.props.onMetaChange;
      if (onMetaChange) {
        var _meta = _objectSpread2(_objectSpread2({}, _this.getMeta()), {}, {
          destroy: destroy2
        });
        if (!isEqual_default(_this.metaCache, _meta)) {
          onMetaChange(_meta);
        }
        _this.metaCache = _meta;
      } else {
        _this.metaCache = null;
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onStoreChange", function(prevStore, namePathList, info) {
      var _this$props4 = _this.props, shouldUpdate = _this$props4.shouldUpdate, _this$props4$dependen = _this$props4.dependencies, dependencies = _this$props4$dependen === void 0 ? [] : _this$props4$dependen, onReset = _this$props4.onReset;
      var store = info.store;
      var namePath = _this.getNamePath();
      var prevValue = _this.getValue(prevStore);
      var curValue = _this.getValue(store);
      var namePathMatch = namePathList && containsNamePath(namePathList, namePath);
      if (info.type === "valueUpdate" && info.source === "external" && !isEqual_default(prevValue, curValue)) {
        _this.touched = true;
        _this.dirty = true;
        _this.validatePromise = null;
        _this.errors = EMPTY_ERRORS;
        _this.warnings = EMPTY_ERRORS;
        _this.triggerMetaEvent();
      }
      switch (info.type) {
        case "reset":
          if (!namePathList || namePathMatch) {
            _this.touched = false;
            _this.dirty = false;
            _this.validatePromise = void 0;
            _this.errors = EMPTY_ERRORS;
            _this.warnings = EMPTY_ERRORS;
            _this.triggerMetaEvent();
            onReset === null || onReset === void 0 || onReset();
            _this.refresh();
            return;
          }
          break;
        /**
         * In case field with `preserve = false` nest deps like:
         * - A = 1 => show B
         * - B = 1 => show C
         * - Reset A, need clean B, C
         */
        case "remove": {
          if (shouldUpdate && requireUpdate(shouldUpdate, prevStore, store, prevValue, curValue, info)) {
            _this.reRender();
            return;
          }
          break;
        }
        case "setField": {
          var data2 = info.data;
          if (namePathMatch) {
            if ("touched" in data2) {
              _this.touched = data2.touched;
            }
            if ("validating" in data2 && !("originRCField" in data2)) {
              _this.validatePromise = data2.validating ? Promise.resolve([]) : null;
            }
            if ("errors" in data2) {
              _this.errors = data2.errors || EMPTY_ERRORS;
            }
            if ("warnings" in data2) {
              _this.warnings = data2.warnings || EMPTY_ERRORS;
            }
            _this.dirty = true;
            _this.triggerMetaEvent();
            _this.reRender();
            return;
          } else if ("value" in data2 && containsNamePath(namePathList, namePath, true)) {
            _this.reRender();
            return;
          }
          if (shouldUpdate && !namePath.length && requireUpdate(shouldUpdate, prevStore, store, prevValue, curValue, info)) {
            _this.reRender();
            return;
          }
          break;
        }
        case "dependenciesUpdate": {
          var dependencyList = dependencies.map(getNamePath);
          if (dependencyList.some(function(dependency) {
            return containsNamePath(info.relatedFields, dependency);
          })) {
            _this.reRender();
            return;
          }
          break;
        }
        default:
          if (namePathMatch || (!dependencies.length || namePath.length || shouldUpdate) && requireUpdate(shouldUpdate, prevStore, store, prevValue, curValue, info)) {
            _this.reRender();
            return;
          }
          break;
      }
      if (shouldUpdate === true) {
        _this.reRender();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "validateRules", function(options) {
      var namePath = _this.getNamePath();
      var currentValue = _this.getValue();
      var _ref2 = options || {}, triggerName = _ref2.triggerName, _ref2$validateOnly = _ref2.validateOnly, validateOnly = _ref2$validateOnly === void 0 ? false : _ref2$validateOnly;
      var rootPromise = Promise.resolve().then(/* @__PURE__ */ _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee() {
        var _this$props5, _this$props5$validate, validateFirst, messageVariables, validateDebounce, filteredRules, promise;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (_this.mounted) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return", []);
            case 2:
              _this$props5 = _this.props, _this$props5$validate = _this$props5.validateFirst, validateFirst = _this$props5$validate === void 0 ? false : _this$props5$validate, messageVariables = _this$props5.messageVariables, validateDebounce = _this$props5.validateDebounce;
              filteredRules = _this.getRules();
              if (triggerName) {
                filteredRules = filteredRules.filter(function(rule) {
                  return rule;
                }).filter(function(rule) {
                  var validateTrigger = rule.validateTrigger;
                  if (!validateTrigger) {
                    return true;
                  }
                  var triggerList = toArray2(validateTrigger);
                  return triggerList.includes(triggerName);
                });
              }
              if (!(validateDebounce && triggerName)) {
                _context.next = 10;
                break;
              }
              _context.next = 8;
              return new Promise(function(resolve) {
                setTimeout(resolve, validateDebounce);
              });
            case 8:
              if (!(_this.validatePromise !== rootPromise)) {
                _context.next = 10;
                break;
              }
              return _context.abrupt("return", []);
            case 10:
              promise = validateRules(namePath, currentValue, filteredRules, options, validateFirst, messageVariables);
              promise.catch(function(e3) {
                return e3;
              }).then(function() {
                var ruleErrors = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : EMPTY_ERRORS;
                if (_this.validatePromise === rootPromise) {
                  var _ruleErrors$forEach;
                  _this.validatePromise = null;
                  var nextErrors = [];
                  var nextWarnings = [];
                  (_ruleErrors$forEach = ruleErrors.forEach) === null || _ruleErrors$forEach === void 0 || _ruleErrors$forEach.call(ruleErrors, function(_ref4) {
                    var warningOnly = _ref4.rule.warningOnly, _ref4$errors = _ref4.errors, errors = _ref4$errors === void 0 ? EMPTY_ERRORS : _ref4$errors;
                    if (warningOnly) {
                      nextWarnings.push.apply(nextWarnings, _toConsumableArray(errors));
                    } else {
                      nextErrors.push.apply(nextErrors, _toConsumableArray(errors));
                    }
                  });
                  _this.errors = nextErrors;
                  _this.warnings = nextWarnings;
                  _this.triggerMetaEvent();
                  _this.reRender();
                }
              });
              return _context.abrupt("return", promise);
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee);
      })));
      if (validateOnly) {
        return rootPromise;
      }
      _this.validatePromise = rootPromise;
      _this.dirty = true;
      _this.errors = EMPTY_ERRORS;
      _this.warnings = EMPTY_ERRORS;
      _this.triggerMetaEvent();
      _this.reRender();
      return rootPromise;
    });
    _defineProperty(_assertThisInitialized(_this), "isFieldValidating", function() {
      return !!_this.validatePromise;
    });
    _defineProperty(_assertThisInitialized(_this), "isFieldTouched", function() {
      return _this.touched;
    });
    _defineProperty(_assertThisInitialized(_this), "isFieldDirty", function() {
      if (_this.dirty || _this.props.initialValue !== void 0) {
        return true;
      }
      var fieldContext = _this.props.fieldContext;
      var _fieldContext$getInte = fieldContext.getInternalHooks(HOOK_MARK), getInitialValue = _fieldContext$getInte.getInitialValue;
      if (getInitialValue(_this.getNamePath()) !== void 0) {
        return true;
      }
      return false;
    });
    _defineProperty(_assertThisInitialized(_this), "getErrors", function() {
      return _this.errors;
    });
    _defineProperty(_assertThisInitialized(_this), "getWarnings", function() {
      return _this.warnings;
    });
    _defineProperty(_assertThisInitialized(_this), "isListField", function() {
      return _this.props.isListField;
    });
    _defineProperty(_assertThisInitialized(_this), "isList", function() {
      return _this.props.isList;
    });
    _defineProperty(_assertThisInitialized(_this), "isPreserve", function() {
      return _this.props.preserve;
    });
    _defineProperty(_assertThisInitialized(_this), "getMeta", function() {
      _this.prevValidating = _this.isFieldValidating();
      var meta = {
        touched: _this.isFieldTouched(),
        validating: _this.prevValidating,
        errors: _this.errors,
        warnings: _this.warnings,
        name: _this.getNamePath(),
        validated: _this.validatePromise === null
      };
      return meta;
    });
    _defineProperty(_assertThisInitialized(_this), "getOnlyChild", function(children) {
      if (typeof children === "function") {
        var _meta2 = _this.getMeta();
        return _objectSpread2(_objectSpread2({}, _this.getOnlyChild(children(_this.getControlled(), _meta2, _this.props.fieldContext))), {}, {
          isFunction: true
        });
      }
      var childList = toArray(children);
      if (childList.length !== 1 || !/* @__PURE__ */ React104.isValidElement(childList[0])) {
        return {
          child: childList,
          isFunction: false
        };
      }
      return {
        child: childList[0],
        isFunction: false
      };
    });
    _defineProperty(_assertThisInitialized(_this), "getValue", function(store) {
      var getFieldsValue = _this.props.fieldContext.getFieldsValue;
      var namePath = _this.getNamePath();
      return get(store || getFieldsValue(true), namePath);
    });
    _defineProperty(_assertThisInitialized(_this), "getControlled", function() {
      var childProps = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      var _this$props6 = _this.props, name = _this$props6.name, trigger2 = _this$props6.trigger, validateTrigger = _this$props6.validateTrigger, getValueFromEvent = _this$props6.getValueFromEvent, normalize2 = _this$props6.normalize, valuePropName = _this$props6.valuePropName, getValueProps = _this$props6.getValueProps, fieldContext = _this$props6.fieldContext;
      var mergedValidateTrigger = validateTrigger !== void 0 ? validateTrigger : fieldContext.validateTrigger;
      var namePath = _this.getNamePath();
      var getInternalHooks3 = fieldContext.getInternalHooks, getFieldsValue = fieldContext.getFieldsValue;
      var _getInternalHooks = getInternalHooks3(HOOK_MARK), dispatch2 = _getInternalHooks.dispatch;
      var value = _this.getValue();
      var mergedGetValueProps = getValueProps || function(val) {
        return _defineProperty({}, valuePropName, val);
      };
      var originTriggerFunc = childProps[trigger2];
      var valueProps = name !== void 0 ? mergedGetValueProps(value) : {};
      if (valueProps) {
        Object.keys(valueProps).forEach(function(key2) {
          warning_default(typeof valueProps[key2] !== "function", "It's not recommended to generate dynamic function prop by `getValueProps`. Please pass it to child component directly (prop: ".concat(key2, ")"));
        });
      }
      var control = _objectSpread2(_objectSpread2({}, childProps), valueProps);
      control[trigger2] = function() {
        _this.touched = true;
        _this.dirty = true;
        _this.triggerMetaEvent();
        var newValue;
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        if (getValueFromEvent) {
          newValue = getValueFromEvent.apply(void 0, args);
        } else {
          newValue = defaultGetValueFromEvent.apply(void 0, [valuePropName].concat(args));
        }
        if (normalize2) {
          newValue = normalize2(newValue, value, getFieldsValue(true));
        }
        if (newValue !== value) {
          dispatch2({
            type: "updateValue",
            namePath,
            value: newValue
          });
        }
        if (originTriggerFunc) {
          originTriggerFunc.apply(void 0, args);
        }
      };
      var validateTriggerList = toArray2(mergedValidateTrigger || []);
      validateTriggerList.forEach(function(triggerName) {
        var originTrigger = control[triggerName];
        control[triggerName] = function() {
          if (originTrigger) {
            originTrigger.apply(void 0, arguments);
          }
          var rules = _this.props.rules;
          if (rules && rules.length) {
            dispatch2({
              type: "validateField",
              namePath,
              triggerName
            });
          }
        };
      });
      return control;
    });
    if (props.fieldContext) {
      var getInternalHooks2 = props.fieldContext.getInternalHooks;
      var _getInternalHooks2 = getInternalHooks2(HOOK_MARK), initEntityValue = _getInternalHooks2.initEntityValue;
      initEntityValue(_assertThisInitialized(_this));
    }
    return _this;
  }
  _createClass(Field2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props7 = this.props, shouldUpdate = _this$props7.shouldUpdate, fieldContext = _this$props7.fieldContext;
      this.mounted = true;
      if (fieldContext) {
        var getInternalHooks2 = fieldContext.getInternalHooks;
        var _getInternalHooks3 = getInternalHooks2(HOOK_MARK), registerField = _getInternalHooks3.registerField;
        this.cancelRegisterFunc = registerField(this);
      }
      if (shouldUpdate === true) {
        this.reRender();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.cancelRegister();
      this.triggerMetaEvent(true);
      this.mounted = false;
    }
  }, {
    key: "reRender",
    value: function reRender() {
      if (!this.mounted) return;
      this.forceUpdate();
    }
  }, {
    key: "render",
    value: function render4() {
      var resetCount = this.state.resetCount;
      var children = this.props.children;
      var _this$getOnlyChild = this.getOnlyChild(children), child = _this$getOnlyChild.child, isFunction6 = _this$getOnlyChild.isFunction;
      var returnChildNode;
      if (isFunction6) {
        returnChildNode = child;
      } else if (/* @__PURE__ */ React104.isValidElement(child)) {
        returnChildNode = /* @__PURE__ */ React104.cloneElement(child, this.getControlled(child.props));
      } else {
        warning_default(!child, "`children` of Field is not validate ReactElement.");
        returnChildNode = child;
      }
      return /* @__PURE__ */ React104.createElement(React104.Fragment, {
        key: resetCount
      }, returnChildNode);
    }
  }]);
  return Field2;
})(React104.Component);
_defineProperty(Field, "contextType", FieldContext_default);
_defineProperty(Field, "defaultProps", {
  trigger: "onChange",
  valuePropName: "value"
});
function WrapperField(_ref6) {
  var _restProps$isListFiel;
  var name = _ref6.name, restProps = _objectWithoutProperties(_ref6, _excluded10);
  var fieldContext = React104.useContext(FieldContext_default);
  var listContext = React104.useContext(ListContext_default);
  var namePath = name !== void 0 ? getNamePath(name) : void 0;
  var isMergedListField = (_restProps$isListFiel = restProps.isListField) !== null && _restProps$isListFiel !== void 0 ? _restProps$isListFiel : !!listContext;
  var key2 = "keep";
  if (!isMergedListField) {
    key2 = "_".concat((namePath || []).join("_"));
  }
  if (restProps.preserve === false && isMergedListField && namePath.length <= 1) {
    warning_default(false, "`preserve` should not apply on Form.List fields.");
  }
  return /* @__PURE__ */ React104.createElement(Field, _extends({
    key: key2,
    name: namePath,
    isListField: isMergedListField
  }, restProps, {
    fieldContext
  }));
}
var Field_default = WrapperField;

// ../../node_modules/rc-field-form/es/List.js
var React105 = __toESM(require_react());
function List(_ref) {
  var name = _ref.name, initialValue = _ref.initialValue, children = _ref.children, rules = _ref.rules, validateTrigger = _ref.validateTrigger, isListField = _ref.isListField;
  var context = React105.useContext(FieldContext_default);
  var wrapperListContext = React105.useContext(ListContext_default);
  var keyRef = React105.useRef({
    keys: [],
    id: 0
  });
  var keyManager = keyRef.current;
  var prefixName = React105.useMemo(function() {
    var parentPrefixName = getNamePath(context.prefixName) || [];
    return [].concat(_toConsumableArray(parentPrefixName), _toConsumableArray(getNamePath(name)));
  }, [context.prefixName, name]);
  var fieldContext = React105.useMemo(function() {
    return _objectSpread2(_objectSpread2({}, context), {}, {
      prefixName
    });
  }, [context, prefixName]);
  var listContext = React105.useMemo(function() {
    return {
      getKey: function getKey5(namePath) {
        var len = prefixName.length;
        var pathName = namePath[len];
        return [keyManager.keys[pathName], namePath.slice(len + 1)];
      }
    };
  }, [prefixName]);
  if (typeof children !== "function") {
    warning_default(false, "Form.List only accepts function as children.");
    return null;
  }
  var shouldUpdate = function shouldUpdate2(prevValue, nextValue, _ref2) {
    var source = _ref2.source;
    if (source === "internal") {
      return false;
    }
    return prevValue !== nextValue;
  };
  return /* @__PURE__ */ React105.createElement(ListContext_default.Provider, {
    value: listContext
  }, /* @__PURE__ */ React105.createElement(FieldContext_default.Provider, {
    value: fieldContext
  }, /* @__PURE__ */ React105.createElement(Field_default, {
    name: [],
    shouldUpdate,
    rules,
    validateTrigger,
    initialValue,
    isList: true,
    isListField: isListField !== null && isListField !== void 0 ? isListField : !!wrapperListContext
  }, function(_ref3, meta) {
    var _ref3$value = _ref3.value, value = _ref3$value === void 0 ? [] : _ref3$value, onChange = _ref3.onChange;
    var getFieldValue = context.getFieldValue;
    var getNewValue = function getNewValue2() {
      var values = getFieldValue(prefixName || []);
      return values || [];
    };
    var operations = {
      add: function add3(defaultValue2, index3) {
        var newValue = getNewValue();
        if (index3 >= 0 && index3 <= newValue.length) {
          keyManager.keys = [].concat(_toConsumableArray(keyManager.keys.slice(0, index3)), [keyManager.id], _toConsumableArray(keyManager.keys.slice(index3)));
          onChange([].concat(_toConsumableArray(newValue.slice(0, index3)), [defaultValue2], _toConsumableArray(newValue.slice(index3))));
        } else {
          if (index3 < 0 || index3 > newValue.length) {
            warning_default(false, "The second parameter of the add function should be a valid positive number.");
          }
          keyManager.keys = [].concat(_toConsumableArray(keyManager.keys), [keyManager.id]);
          onChange([].concat(_toConsumableArray(newValue), [defaultValue2]));
        }
        keyManager.id += 1;
      },
      remove: function remove(index3) {
        var newValue = getNewValue();
        var indexSet = new Set(Array.isArray(index3) ? index3 : [index3]);
        if (indexSet.size <= 0) {
          return;
        }
        keyManager.keys = keyManager.keys.filter(function(_, keysIndex) {
          return !indexSet.has(keysIndex);
        });
        onChange(newValue.filter(function(_, valueIndex) {
          return !indexSet.has(valueIndex);
        }));
      },
      move: function move2(from2, to) {
        if (from2 === to) {
          return;
        }
        var newValue = getNewValue();
        if (from2 < 0 || from2 >= newValue.length || to < 0 || to >= newValue.length) {
          return;
        }
        keyManager.keys = move(keyManager.keys, from2, to);
        onChange(move(newValue, from2, to));
      }
    };
    var listValue = value || [];
    if (!Array.isArray(listValue)) {
      listValue = [];
      if (true) {
        warning_default(false, "Current value of '".concat(prefixName.join(" > "), "' is not an array type."));
      }
    }
    return children(listValue.map(function(__, index3) {
      var key2 = keyManager.keys[index3];
      if (key2 === void 0) {
        keyManager.keys[index3] = keyManager.id;
        key2 = keyManager.keys[index3];
        keyManager.id += 1;
      }
      return {
        name: index3,
        key: key2,
        isListField: true
      };
    }), operations, meta);
  })));
}
var List_default = List;

// ../../node_modules/rc-field-form/es/useForm.js
var React106 = __toESM(require_react());

// ../../node_modules/rc-field-form/es/utils/asyncUtil.js
function allPromiseFinish(promiseList) {
  var hasError = false;
  var count = promiseList.length;
  var results = [];
  if (!promiseList.length) {
    return Promise.resolve([]);
  }
  return new Promise(function(resolve, reject) {
    promiseList.forEach(function(promise, index3) {
      promise.catch(function(e3) {
        hasError = true;
        return e3;
      }).then(function(result) {
        count -= 1;
        results[index3] = result;
        if (count > 0) {
          return;
        }
        if (hasError) {
          reject(results);
        }
        resolve(results);
      });
    });
  });
}

// ../../node_modules/rc-field-form/es/utils/NameMap.js
var SPLIT2 = "__@field_split__";
function normalize(namePath) {
  return namePath.map(function(cell) {
    return "".concat(_typeof(cell), ":").concat(cell);
  }).join(SPLIT2);
}
var NameMap = /* @__PURE__ */ (function() {
  function NameMap2() {
    _classCallCheck(this, NameMap2);
    _defineProperty(this, "kvs", /* @__PURE__ */ new Map());
  }
  _createClass(NameMap2, [{
    key: "set",
    value: function set4(key2, value) {
      this.kvs.set(normalize(key2), value);
    }
  }, {
    key: "get",
    value: function get3(key2) {
      return this.kvs.get(normalize(key2));
    }
  }, {
    key: "update",
    value: function update(key2, updater) {
      var origin = this.get(key2);
      var next2 = updater(origin);
      if (!next2) {
        this.delete(key2);
      } else {
        this.set(key2, next2);
      }
    }
  }, {
    key: "delete",
    value: function _delete(key2) {
      this.kvs.delete(normalize(key2));
    }
    // Since we only use this in test, let simply realize this
  }, {
    key: "map",
    value: function map(callback) {
      return _toConsumableArray(this.kvs.entries()).map(function(_ref) {
        var _ref2 = _slicedToArray(_ref, 2), key2 = _ref2[0], value = _ref2[1];
        var cells = key2.split(SPLIT2);
        return callback({
          key: cells.map(function(cell) {
            var _cell$match = cell.match(/^([^:]*):(.*)$/), _cell$match2 = _slicedToArray(_cell$match, 3), type5 = _cell$match2[1], unit3 = _cell$match2[2];
            return type5 === "number" ? Number(unit3) : unit3;
          }),
          value
        });
      });
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var json = {};
      this.map(function(_ref3) {
        var key2 = _ref3.key, value = _ref3.value;
        json[key2.join(".")] = value;
        return null;
      });
      return json;
    }
  }]);
  return NameMap2;
})();
var NameMap_default = NameMap;

// ../../node_modules/rc-field-form/es/useForm.js
var _excluded11 = ["name"];
var FormStore = /* @__PURE__ */ _createClass(function FormStore2(forceRootUpdate) {
  var _this = this;
  _classCallCheck(this, FormStore2);
  _defineProperty(this, "formHooked", false);
  _defineProperty(this, "forceRootUpdate", void 0);
  _defineProperty(this, "subscribable", true);
  _defineProperty(this, "store", {});
  _defineProperty(this, "fieldEntities", []);
  _defineProperty(this, "initialValues", {});
  _defineProperty(this, "callbacks", {});
  _defineProperty(this, "validateMessages", null);
  _defineProperty(this, "preserve", null);
  _defineProperty(this, "lastValidatePromise", null);
  _defineProperty(this, "getForm", function() {
    return {
      getFieldValue: _this.getFieldValue,
      getFieldsValue: _this.getFieldsValue,
      getFieldError: _this.getFieldError,
      getFieldWarning: _this.getFieldWarning,
      getFieldsError: _this.getFieldsError,
      isFieldsTouched: _this.isFieldsTouched,
      isFieldTouched: _this.isFieldTouched,
      isFieldValidating: _this.isFieldValidating,
      isFieldsValidating: _this.isFieldsValidating,
      resetFields: _this.resetFields,
      setFields: _this.setFields,
      setFieldValue: _this.setFieldValue,
      setFieldsValue: _this.setFieldsValue,
      validateFields: _this.validateFields,
      submit: _this.submit,
      _init: true,
      getInternalHooks: _this.getInternalHooks
    };
  });
  _defineProperty(this, "getInternalHooks", function(key2) {
    if (key2 === HOOK_MARK) {
      _this.formHooked = true;
      return {
        dispatch: _this.dispatch,
        initEntityValue: _this.initEntityValue,
        registerField: _this.registerField,
        useSubscribe: _this.useSubscribe,
        setInitialValues: _this.setInitialValues,
        destroyForm: _this.destroyForm,
        setCallbacks: _this.setCallbacks,
        setValidateMessages: _this.setValidateMessages,
        getFields: _this.getFields,
        setPreserve: _this.setPreserve,
        getInitialValue: _this.getInitialValue,
        registerWatch: _this.registerWatch
      };
    }
    warning_default(false, "`getInternalHooks` is internal usage. Should not call directly.");
    return null;
  });
  _defineProperty(this, "useSubscribe", function(subscribable) {
    _this.subscribable = subscribable;
  });
  _defineProperty(this, "prevWithoutPreserves", null);
  _defineProperty(this, "setInitialValues", function(initialValues, init2) {
    _this.initialValues = initialValues || {};
    if (init2) {
      var _this$prevWithoutPres;
      var nextStore = merge(initialValues, _this.store);
      (_this$prevWithoutPres = _this.prevWithoutPreserves) === null || _this$prevWithoutPres === void 0 || _this$prevWithoutPres.map(function(_ref) {
        var namePath = _ref.key;
        nextStore = set2(nextStore, namePath, get(initialValues, namePath));
      });
      _this.prevWithoutPreserves = null;
      _this.updateStore(nextStore);
    }
  });
  _defineProperty(this, "destroyForm", function(clearOnDestroy) {
    if (clearOnDestroy) {
      _this.updateStore({});
    } else {
      var prevWithoutPreserves = new NameMap_default();
      _this.getFieldEntities(true).forEach(function(entity) {
        if (!_this.isMergedPreserve(entity.isPreserve())) {
          prevWithoutPreserves.set(entity.getNamePath(), true);
        }
      });
      _this.prevWithoutPreserves = prevWithoutPreserves;
    }
  });
  _defineProperty(this, "getInitialValue", function(namePath) {
    var initValue = get(_this.initialValues, namePath);
    return namePath.length ? merge(initValue) : initValue;
  });
  _defineProperty(this, "setCallbacks", function(callbacks) {
    _this.callbacks = callbacks;
  });
  _defineProperty(this, "setValidateMessages", function(validateMessages) {
    _this.validateMessages = validateMessages;
  });
  _defineProperty(this, "setPreserve", function(preserve2) {
    _this.preserve = preserve2;
  });
  _defineProperty(this, "watchList", []);
  _defineProperty(this, "registerWatch", function(callback) {
    _this.watchList.push(callback);
    return function() {
      _this.watchList = _this.watchList.filter(function(fn) {
        return fn !== callback;
      });
    };
  });
  _defineProperty(this, "notifyWatch", function() {
    var namePath = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    if (_this.watchList.length) {
      var values = _this.getFieldsValue();
      var allValues = _this.getFieldsValue(true);
      _this.watchList.forEach(function(callback) {
        callback(values, allValues, namePath);
      });
    }
  });
  _defineProperty(this, "timeoutId", null);
  _defineProperty(this, "warningUnhooked", function() {
    if (!_this.timeoutId && typeof window !== "undefined") {
      _this.timeoutId = setTimeout(function() {
        _this.timeoutId = null;
        if (!_this.formHooked) {
          warning_default(false, "Instance created by `useForm` is not connected to any Form element. Forget to pass `form` prop?");
        }
      });
    }
  });
  _defineProperty(this, "updateStore", function(nextStore) {
    _this.store = nextStore;
  });
  _defineProperty(this, "getFieldEntities", function() {
    var pure = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    if (!pure) {
      return _this.fieldEntities;
    }
    return _this.fieldEntities.filter(function(field) {
      return field.getNamePath().length;
    });
  });
  _defineProperty(this, "getFieldsMap", function() {
    var pure = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var cache = new NameMap_default();
    _this.getFieldEntities(pure).forEach(function(field) {
      var namePath = field.getNamePath();
      cache.set(namePath, field);
    });
    return cache;
  });
  _defineProperty(this, "getFieldEntitiesForNamePathList", function(nameList) {
    if (!nameList) {
      return _this.getFieldEntities(true);
    }
    var cache = _this.getFieldsMap(true);
    return nameList.map(function(name) {
      var namePath = getNamePath(name);
      return cache.get(namePath) || {
        INVALIDATE_NAME_PATH: getNamePath(name)
      };
    });
  });
  _defineProperty(this, "getFieldsValue", function(nameList, filterFunc) {
    _this.warningUnhooked();
    var mergedNameList;
    var mergedFilterFunc;
    var mergedStrict;
    if (nameList === true || Array.isArray(nameList)) {
      mergedNameList = nameList;
      mergedFilterFunc = filterFunc;
    } else if (nameList && _typeof(nameList) === "object") {
      mergedStrict = nameList.strict;
      mergedFilterFunc = nameList.filter;
    }
    if (mergedNameList === true && !mergedFilterFunc) {
      return _this.store;
    }
    var fieldEntities = _this.getFieldEntitiesForNamePathList(Array.isArray(mergedNameList) ? mergedNameList : null);
    var filteredNameList = [];
    fieldEntities.forEach(function(entity) {
      var _isListField, _ref3;
      var namePath = "INVALIDATE_NAME_PATH" in entity ? entity.INVALIDATE_NAME_PATH : entity.getNamePath();
      if (mergedStrict) {
        var _isList, _ref2;
        if ((_isList = (_ref2 = entity).isList) !== null && _isList !== void 0 && _isList.call(_ref2)) {
          return;
        }
      } else if (!mergedNameList && (_isListField = (_ref3 = entity).isListField) !== null && _isListField !== void 0 && _isListField.call(_ref3)) {
        return;
      }
      if (!mergedFilterFunc) {
        filteredNameList.push(namePath);
      } else {
        var meta = "getMeta" in entity ? entity.getMeta() : null;
        if (mergedFilterFunc(meta)) {
          filteredNameList.push(namePath);
        }
      }
    });
    return cloneByNamePathList(_this.store, filteredNameList.map(getNamePath));
  });
  _defineProperty(this, "getFieldValue", function(name) {
    _this.warningUnhooked();
    var namePath = getNamePath(name);
    return get(_this.store, namePath);
  });
  _defineProperty(this, "getFieldsError", function(nameList) {
    _this.warningUnhooked();
    var fieldEntities = _this.getFieldEntitiesForNamePathList(nameList);
    return fieldEntities.map(function(entity, index3) {
      if (entity && !("INVALIDATE_NAME_PATH" in entity)) {
        return {
          name: entity.getNamePath(),
          errors: entity.getErrors(),
          warnings: entity.getWarnings()
        };
      }
      return {
        name: getNamePath(nameList[index3]),
        errors: [],
        warnings: []
      };
    });
  });
  _defineProperty(this, "getFieldError", function(name) {
    _this.warningUnhooked();
    var namePath = getNamePath(name);
    var fieldError = _this.getFieldsError([namePath])[0];
    return fieldError.errors;
  });
  _defineProperty(this, "getFieldWarning", function(name) {
    _this.warningUnhooked();
    var namePath = getNamePath(name);
    var fieldError = _this.getFieldsError([namePath])[0];
    return fieldError.warnings;
  });
  _defineProperty(this, "isFieldsTouched", function() {
    _this.warningUnhooked();
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var arg0 = args[0], arg1 = args[1];
    var namePathList;
    var isAllFieldsTouched = false;
    if (args.length === 0) {
      namePathList = null;
    } else if (args.length === 1) {
      if (Array.isArray(arg0)) {
        namePathList = arg0.map(getNamePath);
        isAllFieldsTouched = false;
      } else {
        namePathList = null;
        isAllFieldsTouched = arg0;
      }
    } else {
      namePathList = arg0.map(getNamePath);
      isAllFieldsTouched = arg1;
    }
    var fieldEntities = _this.getFieldEntities(true);
    var isFieldTouched = function isFieldTouched2(field) {
      return field.isFieldTouched();
    };
    if (!namePathList) {
      return isAllFieldsTouched ? fieldEntities.every(function(entity) {
        return isFieldTouched(entity) || entity.isList();
      }) : fieldEntities.some(isFieldTouched);
    }
    var map = new NameMap_default();
    namePathList.forEach(function(shortNamePath) {
      map.set(shortNamePath, []);
    });
    fieldEntities.forEach(function(field) {
      var fieldNamePath = field.getNamePath();
      namePathList.forEach(function(shortNamePath) {
        if (shortNamePath.every(function(nameUnit, i) {
          return fieldNamePath[i] === nameUnit;
        })) {
          map.update(shortNamePath, function(list) {
            return [].concat(_toConsumableArray(list), [field]);
          });
        }
      });
    });
    var isNamePathListTouched = function isNamePathListTouched2(entities) {
      return entities.some(isFieldTouched);
    };
    var namePathListEntities = map.map(function(_ref4) {
      var value = _ref4.value;
      return value;
    });
    return isAllFieldsTouched ? namePathListEntities.every(isNamePathListTouched) : namePathListEntities.some(isNamePathListTouched);
  });
  _defineProperty(this, "isFieldTouched", function(name) {
    _this.warningUnhooked();
    return _this.isFieldsTouched([name]);
  });
  _defineProperty(this, "isFieldsValidating", function(nameList) {
    _this.warningUnhooked();
    var fieldEntities = _this.getFieldEntities();
    if (!nameList) {
      return fieldEntities.some(function(testField) {
        return testField.isFieldValidating();
      });
    }
    var namePathList = nameList.map(getNamePath);
    return fieldEntities.some(function(testField) {
      var fieldNamePath = testField.getNamePath();
      return containsNamePath(namePathList, fieldNamePath) && testField.isFieldValidating();
    });
  });
  _defineProperty(this, "isFieldValidating", function(name) {
    _this.warningUnhooked();
    return _this.isFieldsValidating([name]);
  });
  _defineProperty(this, "resetWithFieldInitialValue", function() {
    var info = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var cache = new NameMap_default();
    var fieldEntities = _this.getFieldEntities(true);
    fieldEntities.forEach(function(field) {
      var initialValue = field.props.initialValue;
      var namePath = field.getNamePath();
      if (initialValue !== void 0) {
        var records = cache.get(namePath) || /* @__PURE__ */ new Set();
        records.add({
          entity: field,
          value: initialValue
        });
        cache.set(namePath, records);
      }
    });
    var resetWithFields = function resetWithFields2(entities) {
      entities.forEach(function(field) {
        var initialValue = field.props.initialValue;
        if (initialValue !== void 0) {
          var namePath = field.getNamePath();
          var formInitialValue = _this.getInitialValue(namePath);
          if (formInitialValue !== void 0) {
            warning_default(false, "Form already set 'initialValues' with path '".concat(namePath.join("."), "'. Field can not overwrite it."));
          } else {
            var records = cache.get(namePath);
            if (records && records.size > 1) {
              warning_default(false, "Multiple Field with path '".concat(namePath.join("."), "' set 'initialValue'. Can not decide which one to pick."));
            } else if (records) {
              var originValue = _this.getFieldValue(namePath);
              var isListField = field.isListField();
              if (!isListField && (!info.skipExist || originValue === void 0)) {
                _this.updateStore(set2(_this.store, namePath, _toConsumableArray(records)[0].value));
              }
            }
          }
        }
      });
    };
    var requiredFieldEntities;
    if (info.entities) {
      requiredFieldEntities = info.entities;
    } else if (info.namePathList) {
      requiredFieldEntities = [];
      info.namePathList.forEach(function(namePath) {
        var records = cache.get(namePath);
        if (records) {
          var _requiredFieldEntitie;
          (_requiredFieldEntitie = requiredFieldEntities).push.apply(_requiredFieldEntitie, _toConsumableArray(_toConsumableArray(records).map(function(r2) {
            return r2.entity;
          })));
        }
      });
    } else {
      requiredFieldEntities = fieldEntities;
    }
    resetWithFields(requiredFieldEntities);
  });
  _defineProperty(this, "resetFields", function(nameList) {
    _this.warningUnhooked();
    var prevStore = _this.store;
    if (!nameList) {
      _this.updateStore(merge(_this.initialValues));
      _this.resetWithFieldInitialValue();
      _this.notifyObservers(prevStore, null, {
        type: "reset"
      });
      _this.notifyWatch();
      return;
    }
    var namePathList = nameList.map(getNamePath);
    namePathList.forEach(function(namePath) {
      var initialValue = _this.getInitialValue(namePath);
      _this.updateStore(set2(_this.store, namePath, initialValue));
    });
    _this.resetWithFieldInitialValue({
      namePathList
    });
    _this.notifyObservers(prevStore, namePathList, {
      type: "reset"
    });
    _this.notifyWatch(namePathList);
  });
  _defineProperty(this, "setFields", function(fields) {
    _this.warningUnhooked();
    var prevStore = _this.store;
    var namePathList = [];
    fields.forEach(function(fieldData) {
      var name = fieldData.name, data2 = _objectWithoutProperties(fieldData, _excluded11);
      var namePath = getNamePath(name);
      namePathList.push(namePath);
      if ("value" in data2) {
        _this.updateStore(set2(_this.store, namePath, data2.value));
      }
      _this.notifyObservers(prevStore, [namePath], {
        type: "setField",
        data: fieldData
      });
    });
    _this.notifyWatch(namePathList);
  });
  _defineProperty(this, "getFields", function() {
    var entities = _this.getFieldEntities(true);
    var fields = entities.map(function(field) {
      var namePath = field.getNamePath();
      var meta = field.getMeta();
      var fieldData = _objectSpread2(_objectSpread2({}, meta), {}, {
        name: namePath,
        value: _this.getFieldValue(namePath)
      });
      Object.defineProperty(fieldData, "originRCField", {
        value: true
      });
      return fieldData;
    });
    return fields;
  });
  _defineProperty(this, "initEntityValue", function(entity) {
    var initialValue = entity.props.initialValue;
    if (initialValue !== void 0) {
      var namePath = entity.getNamePath();
      var prevValue = get(_this.store, namePath);
      if (prevValue === void 0) {
        _this.updateStore(set2(_this.store, namePath, initialValue));
      }
    }
  });
  _defineProperty(this, "isMergedPreserve", function(fieldPreserve) {
    var mergedPreserve = fieldPreserve !== void 0 ? fieldPreserve : _this.preserve;
    return mergedPreserve !== null && mergedPreserve !== void 0 ? mergedPreserve : true;
  });
  _defineProperty(this, "registerField", function(entity) {
    _this.fieldEntities.push(entity);
    var namePath = entity.getNamePath();
    _this.notifyWatch([namePath]);
    if (entity.props.initialValue !== void 0) {
      var prevStore = _this.store;
      _this.resetWithFieldInitialValue({
        entities: [entity],
        skipExist: true
      });
      _this.notifyObservers(prevStore, [entity.getNamePath()], {
        type: "valueUpdate",
        source: "internal"
      });
    }
    return function(isListField, preserve2) {
      var subNamePath = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
      _this.fieldEntities = _this.fieldEntities.filter(function(item) {
        return item !== entity;
      });
      if (!_this.isMergedPreserve(preserve2) && (!isListField || subNamePath.length > 1)) {
        var defaultValue2 = isListField ? void 0 : _this.getInitialValue(namePath);
        if (namePath.length && _this.getFieldValue(namePath) !== defaultValue2 && _this.fieldEntities.every(function(field) {
          return (
            // Only reset when no namePath exist
            !matchNamePath(field.getNamePath(), namePath)
          );
        })) {
          var _prevStore = _this.store;
          _this.updateStore(set2(_prevStore, namePath, defaultValue2, true));
          _this.notifyObservers(_prevStore, [namePath], {
            type: "remove"
          });
          _this.triggerDependenciesUpdate(_prevStore, namePath);
        }
      }
      _this.notifyWatch([namePath]);
    };
  });
  _defineProperty(this, "dispatch", function(action) {
    switch (action.type) {
      case "updateValue": {
        var namePath = action.namePath, value = action.value;
        _this.updateValue(namePath, value);
        break;
      }
      case "validateField": {
        var _namePath = action.namePath, triggerName = action.triggerName;
        _this.validateFields([_namePath], {
          triggerName
        });
        break;
      }
      default:
    }
  });
  _defineProperty(this, "notifyObservers", function(prevStore, namePathList, info) {
    if (_this.subscribable) {
      var mergedInfo = _objectSpread2(_objectSpread2({}, info), {}, {
        store: _this.getFieldsValue(true)
      });
      _this.getFieldEntities().forEach(function(_ref5) {
        var onStoreChange = _ref5.onStoreChange;
        onStoreChange(prevStore, namePathList, mergedInfo);
      });
    } else {
      _this.forceRootUpdate();
    }
  });
  _defineProperty(this, "triggerDependenciesUpdate", function(prevStore, namePath) {
    var childrenFields = _this.getDependencyChildrenFields(namePath);
    if (childrenFields.length) {
      _this.validateFields(childrenFields);
    }
    _this.notifyObservers(prevStore, childrenFields, {
      type: "dependenciesUpdate",
      relatedFields: [namePath].concat(_toConsumableArray(childrenFields))
    });
    return childrenFields;
  });
  _defineProperty(this, "updateValue", function(name, value) {
    var namePath = getNamePath(name);
    var prevStore = _this.store;
    _this.updateStore(set2(_this.store, namePath, value));
    _this.notifyObservers(prevStore, [namePath], {
      type: "valueUpdate",
      source: "internal"
    });
    _this.notifyWatch([namePath]);
    var childrenFields = _this.triggerDependenciesUpdate(prevStore, namePath);
    var onValuesChange = _this.callbacks.onValuesChange;
    if (onValuesChange) {
      var changedValues = cloneByNamePathList(_this.store, [namePath]);
      onValuesChange(changedValues, _this.getFieldsValue());
    }
    _this.triggerOnFieldsChange([namePath].concat(_toConsumableArray(childrenFields)));
  });
  _defineProperty(this, "setFieldsValue", function(store) {
    _this.warningUnhooked();
    var prevStore = _this.store;
    if (store) {
      var nextStore = merge(_this.store, store);
      _this.updateStore(nextStore);
    }
    _this.notifyObservers(prevStore, null, {
      type: "valueUpdate",
      source: "external"
    });
    _this.notifyWatch();
  });
  _defineProperty(this, "setFieldValue", function(name, value) {
    _this.setFields([{
      name,
      value,
      errors: [],
      warnings: []
    }]);
  });
  _defineProperty(this, "getDependencyChildrenFields", function(rootNamePath) {
    var children = /* @__PURE__ */ new Set();
    var childrenFields = [];
    var dependencies2fields = new NameMap_default();
    _this.getFieldEntities().forEach(function(field) {
      var dependencies = field.props.dependencies;
      (dependencies || []).forEach(function(dependency) {
        var dependencyNamePath = getNamePath(dependency);
        dependencies2fields.update(dependencyNamePath, function() {
          var fields = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : /* @__PURE__ */ new Set();
          fields.add(field);
          return fields;
        });
      });
    });
    var fillChildren = function fillChildren2(namePath) {
      var fields = dependencies2fields.get(namePath) || /* @__PURE__ */ new Set();
      fields.forEach(function(field) {
        if (!children.has(field)) {
          children.add(field);
          var fieldNamePath = field.getNamePath();
          if (field.isFieldDirty() && fieldNamePath.length) {
            childrenFields.push(fieldNamePath);
            fillChildren2(fieldNamePath);
          }
        }
      });
    };
    fillChildren(rootNamePath);
    return childrenFields;
  });
  _defineProperty(this, "triggerOnFieldsChange", function(namePathList, filedErrors) {
    var onFieldsChange = _this.callbacks.onFieldsChange;
    if (onFieldsChange) {
      var fields = _this.getFields();
      if (filedErrors) {
        var cache = new NameMap_default();
        filedErrors.forEach(function(_ref6) {
          var name = _ref6.name, errors = _ref6.errors;
          cache.set(name, errors);
        });
        fields.forEach(function(field) {
          field.errors = cache.get(field.name) || field.errors;
        });
      }
      var changedFields = fields.filter(function(_ref7) {
        var fieldName = _ref7.name;
        return containsNamePath(namePathList, fieldName);
      });
      if (changedFields.length) {
        onFieldsChange(changedFields, fields);
      }
    }
  });
  _defineProperty(this, "validateFields", function(arg1, arg2) {
    _this.warningUnhooked();
    var nameList;
    var options;
    if (Array.isArray(arg1) || typeof arg1 === "string" || typeof arg2 === "string") {
      nameList = arg1;
      options = arg2;
    } else {
      options = arg1;
    }
    var provideNameList = !!nameList;
    var namePathList = provideNameList ? nameList.map(getNamePath) : [];
    var promiseList = [];
    var TMP_SPLIT = String(Date.now());
    var validateNamePathList = /* @__PURE__ */ new Set();
    var _ref8 = options || {}, recursive = _ref8.recursive, dirty = _ref8.dirty;
    _this.getFieldEntities(true).forEach(function(field) {
      if (!provideNameList) {
        namePathList.push(field.getNamePath());
      }
      if (!field.props.rules || !field.props.rules.length) {
        return;
      }
      if (dirty && !field.isFieldDirty()) {
        return;
      }
      var fieldNamePath = field.getNamePath();
      validateNamePathList.add(fieldNamePath.join(TMP_SPLIT));
      if (!provideNameList || containsNamePath(namePathList, fieldNamePath, recursive)) {
        var promise = field.validateRules(_objectSpread2({
          validateMessages: _objectSpread2(_objectSpread2({}, defaultValidateMessages), _this.validateMessages)
        }, options));
        promiseList.push(promise.then(function() {
          return {
            name: fieldNamePath,
            errors: [],
            warnings: []
          };
        }).catch(function(ruleErrors) {
          var _ruleErrors$forEach;
          var mergedErrors = [];
          var mergedWarnings = [];
          (_ruleErrors$forEach = ruleErrors.forEach) === null || _ruleErrors$forEach === void 0 || _ruleErrors$forEach.call(ruleErrors, function(_ref9) {
            var warningOnly = _ref9.rule.warningOnly, errors = _ref9.errors;
            if (warningOnly) {
              mergedWarnings.push.apply(mergedWarnings, _toConsumableArray(errors));
            } else {
              mergedErrors.push.apply(mergedErrors, _toConsumableArray(errors));
            }
          });
          if (mergedErrors.length) {
            return Promise.reject({
              name: fieldNamePath,
              errors: mergedErrors,
              warnings: mergedWarnings
            });
          }
          return {
            name: fieldNamePath,
            errors: mergedErrors,
            warnings: mergedWarnings
          };
        }));
      }
    });
    var summaryPromise = allPromiseFinish(promiseList);
    _this.lastValidatePromise = summaryPromise;
    summaryPromise.catch(function(results) {
      return results;
    }).then(function(results) {
      var resultNamePathList = results.map(function(_ref10) {
        var name = _ref10.name;
        return name;
      });
      _this.notifyObservers(_this.store, resultNamePathList, {
        type: "validateFinish"
      });
      _this.triggerOnFieldsChange(resultNamePathList, results);
    });
    var returnPromise = summaryPromise.then(function() {
      if (_this.lastValidatePromise === summaryPromise) {
        return Promise.resolve(_this.getFieldsValue(namePathList));
      }
      return Promise.reject([]);
    }).catch(function(results) {
      var errorList = results.filter(function(result) {
        return result && result.errors.length;
      });
      return Promise.reject({
        values: _this.getFieldsValue(namePathList),
        errorFields: errorList,
        outOfDate: _this.lastValidatePromise !== summaryPromise
      });
    });
    returnPromise.catch(function(e3) {
      return e3;
    });
    var triggerNamePathList = namePathList.filter(function(namePath) {
      return validateNamePathList.has(namePath.join(TMP_SPLIT));
    });
    _this.triggerOnFieldsChange(triggerNamePathList);
    return returnPromise;
  });
  _defineProperty(this, "submit", function() {
    _this.warningUnhooked();
    _this.validateFields().then(function(values) {
      var onFinish = _this.callbacks.onFinish;
      if (onFinish) {
        try {
          onFinish(values);
        } catch (err) {
          console.error(err);
        }
      }
    }).catch(function(e3) {
      var onFinishFailed = _this.callbacks.onFinishFailed;
      if (onFinishFailed) {
        onFinishFailed(e3);
      }
    });
  });
  this.forceRootUpdate = forceRootUpdate;
});
function useForm(form) {
  var formRef = React106.useRef();
  var _React$useState = React106.useState({}), _React$useState2 = _slicedToArray(_React$useState, 2), forceUpdate = _React$useState2[1];
  if (!formRef.current) {
    if (form) {
      formRef.current = form;
    } else {
      var forceReRender = function forceReRender2() {
        forceUpdate({});
      };
      var formStore = new FormStore(forceReRender);
      formRef.current = formStore.getForm();
    }
  }
  return [formRef.current];
}
var useForm_default = useForm;

// ../../node_modules/rc-field-form/es/Form.js
var React108 = __toESM(require_react());

// ../../node_modules/rc-field-form/es/FormContext.js
var React107 = __toESM(require_react());
var FormContext = /* @__PURE__ */ React107.createContext({
  triggerFormChange: function triggerFormChange() {
  },
  triggerFormFinish: function triggerFormFinish() {
  },
  registerForm: function registerForm() {
  },
  unregisterForm: function unregisterForm() {
  }
});
var FormProvider = function FormProvider2(_ref) {
  var validateMessages = _ref.validateMessages, onFormChange = _ref.onFormChange, onFormFinish = _ref.onFormFinish, children = _ref.children;
  var formContext = React107.useContext(FormContext);
  var formsRef = React107.useRef({});
  return /* @__PURE__ */ React107.createElement(FormContext.Provider, {
    value: _objectSpread2(_objectSpread2({}, formContext), {}, {
      validateMessages: _objectSpread2(_objectSpread2({}, formContext.validateMessages), validateMessages),
      // =========================================================
      // =                  Global Form Control                  =
      // =========================================================
      triggerFormChange: function triggerFormChange2(name, changedFields) {
        if (onFormChange) {
          onFormChange(name, {
            changedFields,
            forms: formsRef.current
          });
        }
        formContext.triggerFormChange(name, changedFields);
      },
      triggerFormFinish: function triggerFormFinish2(name, values) {
        if (onFormFinish) {
          onFormFinish(name, {
            values,
            forms: formsRef.current
          });
        }
        formContext.triggerFormFinish(name, values);
      },
      registerForm: function registerForm2(name, form) {
        if (name) {
          formsRef.current = _objectSpread2(_objectSpread2({}, formsRef.current), {}, _defineProperty({}, name, form));
        }
        formContext.registerForm(name, form);
      },
      unregisterForm: function unregisterForm2(name) {
        var newForms = _objectSpread2({}, formsRef.current);
        delete newForms[name];
        formsRef.current = newForms;
        formContext.unregisterForm(name);
      }
    })
  }, children);
};
var FormContext_default = FormContext;

// ../../node_modules/rc-field-form/es/Form.js
var _excluded12 = ["name", "initialValues", "fields", "form", "preserve", "children", "component", "validateMessages", "validateTrigger", "onValuesChange", "onFieldsChange", "onFinish", "onFinishFailed", "clearOnDestroy"];
var Form = function Form2(_ref, ref3) {
  var name = _ref.name, initialValues = _ref.initialValues, fields = _ref.fields, form = _ref.form, preserve2 = _ref.preserve, children = _ref.children, _ref$component = _ref.component, Component10 = _ref$component === void 0 ? "form" : _ref$component, validateMessages = _ref.validateMessages, _ref$validateTrigger = _ref.validateTrigger, validateTrigger = _ref$validateTrigger === void 0 ? "onChange" : _ref$validateTrigger, onValuesChange = _ref.onValuesChange, _onFieldsChange = _ref.onFieldsChange, _onFinish = _ref.onFinish, onFinishFailed = _ref.onFinishFailed, clearOnDestroy = _ref.clearOnDestroy, restProps = _objectWithoutProperties(_ref, _excluded12);
  var nativeElementRef = React108.useRef(null);
  var formContext = React108.useContext(FormContext_default);
  var _useForm = useForm_default(form), _useForm2 = _slicedToArray(_useForm, 1), formInstance = _useForm2[0];
  var _getInternalHooks = formInstance.getInternalHooks(HOOK_MARK), useSubscribe = _getInternalHooks.useSubscribe, setInitialValues = _getInternalHooks.setInitialValues, setCallbacks = _getInternalHooks.setCallbacks, setValidateMessages = _getInternalHooks.setValidateMessages, setPreserve = _getInternalHooks.setPreserve, destroyForm = _getInternalHooks.destroyForm;
  React108.useImperativeHandle(ref3, function() {
    return _objectSpread2(_objectSpread2({}, formInstance), {}, {
      nativeElement: nativeElementRef.current
    });
  });
  React108.useEffect(function() {
    formContext.registerForm(name, formInstance);
    return function() {
      formContext.unregisterForm(name);
    };
  }, [formContext, formInstance, name]);
  setValidateMessages(_objectSpread2(_objectSpread2({}, formContext.validateMessages), validateMessages));
  setCallbacks({
    onValuesChange,
    onFieldsChange: function onFieldsChange(changedFields) {
      formContext.triggerFormChange(name, changedFields);
      if (_onFieldsChange) {
        for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          rest[_key - 1] = arguments[_key];
        }
        _onFieldsChange.apply(void 0, [changedFields].concat(rest));
      }
    },
    onFinish: function onFinish(values) {
      formContext.triggerFormFinish(name, values);
      if (_onFinish) {
        _onFinish(values);
      }
    },
    onFinishFailed
  });
  setPreserve(preserve2);
  var mountRef = React108.useRef(null);
  setInitialValues(initialValues, !mountRef.current);
  if (!mountRef.current) {
    mountRef.current = true;
  }
  React108.useEffect(
    function() {
      return function() {
        return destroyForm(clearOnDestroy);
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  var childrenNode;
  var childrenRenderProps = typeof children === "function";
  if (childrenRenderProps) {
    var _values = formInstance.getFieldsValue(true);
    childrenNode = children(_values, formInstance);
  } else {
    childrenNode = children;
  }
  useSubscribe(!childrenRenderProps);
  var prevFieldsRef = React108.useRef();
  React108.useEffect(function() {
    if (!isSimilar(prevFieldsRef.current || [], fields || [])) {
      formInstance.setFields(fields || []);
    }
    prevFieldsRef.current = fields;
  }, [fields, formInstance]);
  var formContextValue = React108.useMemo(function() {
    return _objectSpread2(_objectSpread2({}, formInstance), {}, {
      validateTrigger
    });
  }, [formInstance, validateTrigger]);
  var wrapperNode = /* @__PURE__ */ React108.createElement(ListContext_default.Provider, {
    value: null
  }, /* @__PURE__ */ React108.createElement(FieldContext_default.Provider, {
    value: formContextValue
  }, childrenNode));
  if (Component10 === false) {
    return wrapperNode;
  }
  return /* @__PURE__ */ React108.createElement(Component10, _extends({}, restProps, {
    ref: nativeElementRef,
    onSubmit: function onSubmit(event) {
      event.preventDefault();
      event.stopPropagation();
      formInstance.submit();
    },
    onReset: function onReset(event) {
      var _restProps$onReset;
      event.preventDefault();
      formInstance.resetFields();
      (_restProps$onReset = restProps.onReset) === null || _restProps$onReset === void 0 || _restProps$onReset.call(restProps, event);
    }
  }), wrapperNode);
};
var Form_default = Form;

// ../../node_modules/rc-field-form/es/useWatch.js
var import_react54 = __toESM(require_react());
function stringify2(value) {
  try {
    return JSON.stringify(value);
  } catch (err) {
    return Math.random();
  }
}
var useWatchWarning = true ? function(namePath) {
  var fullyStr = namePath.join("__RC_FIELD_FORM_SPLIT__");
  var nameStrRef = (0, import_react54.useRef)(fullyStr);
  warning_default(nameStrRef.current === fullyStr, "`useWatch` is not support dynamic `namePath`. Please provide static instead.");
} : function() {
};
function useWatch() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var dependencies = args[0], _args$ = args[1], _form = _args$ === void 0 ? {} : _args$;
  var options = isFormInstance(_form) ? {
    form: _form
  } : _form;
  var form = options.form;
  var _useState = (0, import_react54.useState)(), _useState2 = _slicedToArray(_useState, 2), value = _useState2[0], setValue = _useState2[1];
  var valueStr = (0, import_react54.useMemo)(function() {
    return stringify2(value);
  }, [value]);
  var valueStrRef = (0, import_react54.useRef)(valueStr);
  valueStrRef.current = valueStr;
  var fieldContext = (0, import_react54.useContext)(FieldContext_default);
  var formInstance = form || fieldContext;
  var isValidForm = formInstance && formInstance._init;
  if (true) {
    warning_default(args.length === 2 ? form ? isValidForm : true : isValidForm, "useWatch requires a form instance since it can not auto detect from context.");
  }
  var namePath = getNamePath(dependencies);
  var namePathRef = (0, import_react54.useRef)(namePath);
  namePathRef.current = namePath;
  useWatchWarning(namePath);
  (0, import_react54.useEffect)(
    function() {
      if (!isValidForm) {
        return;
      }
      var getFieldsValue = formInstance.getFieldsValue, getInternalHooks2 = formInstance.getInternalHooks;
      var _getInternalHooks = getInternalHooks2(HOOK_MARK), registerWatch = _getInternalHooks.registerWatch;
      var getWatchValue = function getWatchValue2(values, allValues) {
        var watchValue2 = options.preserve ? allValues : values;
        return typeof dependencies === "function" ? dependencies(watchValue2) : get(watchValue2, namePathRef.current);
      };
      var cancelRegister = registerWatch(function(values, allValues) {
        var newValue = getWatchValue(values, allValues);
        var nextValueStr = stringify2(newValue);
        if (valueStrRef.current !== nextValueStr) {
          valueStrRef.current = nextValueStr;
          setValue(newValue);
        }
      });
      var initialValue = getWatchValue(getFieldsValue(), getFieldsValue(true));
      if (value !== initialValue) {
        setValue(initialValue);
      }
      return cancelRegister;
    },
    // We do not need re-register since namePath content is the same
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isValidForm]
  );
  return value;
}
var useWatch_default = useWatch;

// ../../node_modules/rc-field-form/es/index.js
var InternalForm = /* @__PURE__ */ React109.forwardRef(Form_default);
var RefForm = InternalForm;
RefForm.FormProvider = FormProvider;
RefForm.Field = Field_default;
RefForm.List = List_default;
RefForm.useForm = useForm_default;
RefForm.useWatch = useWatch_default;
var es_default7 = RefForm;

// ../../node_modules/antd/es/form/context.js
var FormContext2 = /* @__PURE__ */ React110.createContext({
  labelAlign: "right",
  layout: "horizontal",
  itemRef: () => {
  }
});
var NoStyleItemContext = /* @__PURE__ */ React110.createContext(null);
var FormProvider3 = (props) => {
  const providerProps = omit(props, ["prefixCls"]);
  return /* @__PURE__ */ React110.createElement(FormProvider, Object.assign({}, providerProps));
};
var FormItemPrefixContext = /* @__PURE__ */ React110.createContext({
  prefixCls: ""
});
var FormItemInputContext = /* @__PURE__ */ React110.createContext({});
if (true) {
  FormItemInputContext.displayName = "FormItemInputContext";
}
var NoFormStyle = ({
  children,
  status,
  override
}) => {
  const formItemInputContext = React110.useContext(FormItemInputContext);
  const newFormItemInputContext = React110.useMemo(() => {
    const newContext = Object.assign({}, formItemInputContext);
    if (override) {
      delete newContext.isFormItemInput;
    }
    if (status) {
      delete newContext.status;
      delete newContext.hasFeedback;
      delete newContext.feedbackIcon;
    }
    return newContext;
  }, [status, override, formItemInputContext]);
  return /* @__PURE__ */ React110.createElement(FormItemInputContext.Provider, {
    value: newFormItemInputContext
  }, children);
};
var VariantContext = /* @__PURE__ */ React110.createContext(void 0);

// ../../node_modules/antd/es/_util/ContextIsolator.js
var ContextIsolator = (props) => {
  const {
    space,
    form,
    children
  } = props;
  if (children === void 0 || children === null) {
    return null;
  }
  let result = children;
  if (form) {
    result = /* @__PURE__ */ import_react55.default.createElement(NoFormStyle, {
      override: true,
      status: true
    }, result);
  }
  if (space) {
    result = /* @__PURE__ */ import_react55.default.createElement(NoCompactStyle, null, result);
  }
  return result;
};
var ContextIsolator_default = ContextIsolator;

// ../../node_modules/antd/es/_util/hooks/useClosable.js
var import_react56 = __toESM(require_react());

// ../../node_modules/antd/es/_util/extendsObject.js
function mergeProps(...items) {
  const ret = {};
  items.forEach((item) => {
    if (item) {
      Object.keys(item).forEach((key2) => {
        if (item[key2] !== void 0) {
          ret[key2] = item[key2];
        }
      });
    }
  });
  return ret;
}
var extendsObject_default = mergeProps;

// ../../node_modules/antd/es/_util/hooks/useClosable.js
function pickClosable(context) {
  if (!context) {
    return void 0;
  }
  const {
    closable,
    closeIcon
  } = context;
  return {
    closable,
    closeIcon
  };
}
function useClosableConfig(closableCollection) {
  const {
    closable,
    closeIcon
  } = closableCollection || {};
  return import_react56.default.useMemo(() => {
    if (
      // If `closable`, whatever rest be should be true
      !closable && (closable === false || closeIcon === false || closeIcon === null)
    ) {
      return false;
    }
    if (closable === void 0 && closeIcon === void 0) {
      return null;
    }
    let closableConfig = {
      closeIcon: typeof closeIcon !== "boolean" && closeIcon !== null ? closeIcon : void 0
    };
    if (closable && typeof closable === "object") {
      closableConfig = Object.assign(Object.assign({}, closableConfig), closable);
    }
    return closableConfig;
  }, [closable, closeIcon]);
}
var EmptyFallbackCloseCollection = {};
function useClosable(propCloseCollection, contextCloseCollection, fallbackCloseCollection = EmptyFallbackCloseCollection) {
  const propCloseConfig = useClosableConfig(propCloseCollection);
  const contextCloseConfig = useClosableConfig(contextCloseCollection);
  const [contextLocale] = useLocale_default("global", en_US_default6.global);
  const closeBtnIsDisabled = typeof propCloseConfig !== "boolean" ? !!(propCloseConfig === null || propCloseConfig === void 0 ? void 0 : propCloseConfig.disabled) : false;
  const mergedFallbackCloseCollection = import_react56.default.useMemo(() => Object.assign({
    closeIcon: /* @__PURE__ */ import_react56.default.createElement(CloseOutlined_default2, null)
  }, fallbackCloseCollection), [fallbackCloseCollection]);
  const mergedClosableConfig = import_react56.default.useMemo(() => {
    if (propCloseConfig === false) {
      return false;
    }
    if (propCloseConfig) {
      return extendsObject_default(mergedFallbackCloseCollection, contextCloseConfig, propCloseConfig);
    }
    if (contextCloseConfig === false) {
      return false;
    }
    if (contextCloseConfig) {
      return extendsObject_default(mergedFallbackCloseCollection, contextCloseConfig);
    }
    return !mergedFallbackCloseCollection.closable ? false : mergedFallbackCloseCollection;
  }, [propCloseConfig, contextCloseConfig, mergedFallbackCloseCollection]);
  return import_react56.default.useMemo(() => {
    var _a, _b;
    if (mergedClosableConfig === false) {
      return [false, null, closeBtnIsDisabled, {}];
    }
    const {
      closeIconRender
    } = mergedFallbackCloseCollection;
    const {
      closeIcon
    } = mergedClosableConfig;
    let mergedCloseIcon = closeIcon;
    const ariaOrDataProps = pickAttrs(mergedClosableConfig, true);
    if (mergedCloseIcon !== null && mergedCloseIcon !== void 0) {
      if (closeIconRender) {
        mergedCloseIcon = closeIconRender(closeIcon);
      }
      mergedCloseIcon = /* @__PURE__ */ import_react56.default.isValidElement(mergedCloseIcon) ? /* @__PURE__ */ import_react56.default.cloneElement(mergedCloseIcon, Object.assign(Object.assign(Object.assign({}, mergedCloseIcon.props), {
        "aria-label": (_b = (_a = mergedCloseIcon.props) === null || _a === void 0 ? void 0 : _a["aria-label"]) !== null && _b !== void 0 ? _b : contextLocale.close
      }), ariaOrDataProps)) : /* @__PURE__ */ import_react56.default.createElement("span", Object.assign({
        "aria-label": contextLocale.close
      }, ariaOrDataProps), mergedCloseIcon);
    }
    return [true, mergedCloseIcon, closeBtnIsDisabled, ariaOrDataProps];
  }, [mergedClosableConfig, mergedFallbackCloseCollection]);
}

// ../../node_modules/rc-util/es/Dom/styleChecker.js
var isStyleNameSupport = function isStyleNameSupport2(styleName) {
  if (canUseDom() && window.document.documentElement) {
    var styleNameList = Array.isArray(styleName) ? styleName : [styleName];
    var documentElement = window.document.documentElement;
    return styleNameList.some(function(name) {
      return name in documentElement.style;
    });
  }
  return false;
};
var isStyleValueSupport = function isStyleValueSupport2(styleName, value) {
  if (!isStyleNameSupport(styleName)) {
    return false;
  }
  var ele = document.createElement("div");
  var origin = ele.style[styleName];
  ele.style[styleName] = value;
  return ele.style[styleName] !== origin;
};
function isStyleSupport(styleName, styleValue) {
  if (!Array.isArray(styleName) && styleValue !== void 0) {
    return isStyleValueSupport(styleName, styleValue);
  }
  return isStyleNameSupport(styleName);
}

// ../../node_modules/antd/es/skeleton/Skeleton.js
var React121 = __toESM(require_react());
var import_classnames36 = __toESM(require_classnames());

// ../../node_modules/antd/es/skeleton/Avatar.js
var React114 = __toESM(require_react());
var import_classnames29 = __toESM(require_classnames());

// ../../node_modules/antd/es/skeleton/Element.js
var React113 = __toESM(require_react());
var import_classnames28 = __toESM(require_classnames());
var Element2 = (props) => {
  const {
    prefixCls,
    className: className2,
    style: style2,
    size,
    shape
  } = props;
  const sizeCls = (0, import_classnames28.default)({
    [`${prefixCls}-lg`]: size === "large",
    [`${prefixCls}-sm`]: size === "small"
  });
  const shapeCls = (0, import_classnames28.default)({
    [`${prefixCls}-circle`]: shape === "circle",
    [`${prefixCls}-square`]: shape === "square",
    [`${prefixCls}-round`]: shape === "round"
  });
  const sizeStyle = React113.useMemo(() => typeof size === "number" ? {
    width: size,
    height: size,
    lineHeight: `${size}px`
  } : {}, [size]);
  return /* @__PURE__ */ React113.createElement("span", {
    className: (0, import_classnames28.default)(prefixCls, sizeCls, shapeCls, className2),
    style: Object.assign(Object.assign({}, sizeStyle), style2)
  });
};
var Element_default = Element2;

// ../../node_modules/antd/es/skeleton/style/index.js
var skeletonClsLoading = new Keyframes_default(`ant-skeleton-loading`, {
  "0%": {
    backgroundPosition: "100% 50%"
  },
  "100%": {
    backgroundPosition: "0 50%"
  }
});
var genSkeletonElementCommonSize = (size) => ({
  height: size,
  lineHeight: unit(size)
});
var genSkeletonElementAvatarSize = (size) => Object.assign({
  width: size
}, genSkeletonElementCommonSize(size));
var genSkeletonColor = (token2) => ({
  background: token2.skeletonLoadingBackground,
  backgroundSize: "400% 100%",
  animationName: skeletonClsLoading,
  animationDuration: token2.skeletonLoadingMotionDuration,
  animationTimingFunction: "ease",
  animationIterationCount: "infinite"
});
var genSkeletonElementInputSize = (size, calc) => Object.assign({
  width: calc(size).mul(5).equal(),
  minWidth: calc(size).mul(5).equal()
}, genSkeletonElementCommonSize(size));
var genSkeletonElementAvatar = (token2) => {
  const {
    skeletonAvatarCls,
    gradientFromColor,
    controlHeight,
    controlHeightLG,
    controlHeightSM
  } = token2;
  return {
    [skeletonAvatarCls]: Object.assign({
      display: "inline-block",
      verticalAlign: "top",
      background: gradientFromColor
    }, genSkeletonElementAvatarSize(controlHeight)),
    [`${skeletonAvatarCls}${skeletonAvatarCls}-circle`]: {
      borderRadius: "50%"
    },
    [`${skeletonAvatarCls}${skeletonAvatarCls}-lg`]: Object.assign({}, genSkeletonElementAvatarSize(controlHeightLG)),
    [`${skeletonAvatarCls}${skeletonAvatarCls}-sm`]: Object.assign({}, genSkeletonElementAvatarSize(controlHeightSM))
  };
};
var genSkeletonElementInput = (token2) => {
  const {
    controlHeight,
    borderRadiusSM,
    skeletonInputCls,
    controlHeightLG,
    controlHeightSM,
    gradientFromColor,
    calc
  } = token2;
  return {
    [skeletonInputCls]: Object.assign({
      display: "inline-block",
      verticalAlign: "top",
      background: gradientFromColor,
      borderRadius: borderRadiusSM
    }, genSkeletonElementInputSize(controlHeight, calc)),
    [`${skeletonInputCls}-lg`]: Object.assign({}, genSkeletonElementInputSize(controlHeightLG, calc)),
    [`${skeletonInputCls}-sm`]: Object.assign({}, genSkeletonElementInputSize(controlHeightSM, calc))
  };
};
var genSkeletonElementImageSize = (size) => Object.assign({
  width: size
}, genSkeletonElementCommonSize(size));
var genSkeletonElementImage = (token2) => {
  const {
    skeletonImageCls,
    imageSizeBase,
    gradientFromColor,
    borderRadiusSM,
    calc
  } = token2;
  return {
    [skeletonImageCls]: Object.assign(Object.assign({
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      verticalAlign: "middle",
      background: gradientFromColor,
      borderRadius: borderRadiusSM
    }, genSkeletonElementImageSize(calc(imageSizeBase).mul(2).equal())), {
      [`${skeletonImageCls}-path`]: {
        fill: "#bfbfbf"
      },
      [`${skeletonImageCls}-svg`]: Object.assign(Object.assign({}, genSkeletonElementImageSize(imageSizeBase)), {
        maxWidth: calc(imageSizeBase).mul(4).equal(),
        maxHeight: calc(imageSizeBase).mul(4).equal()
      }),
      [`${skeletonImageCls}-svg${skeletonImageCls}-svg-circle`]: {
        borderRadius: "50%"
      }
    }),
    [`${skeletonImageCls}${skeletonImageCls}-circle`]: {
      borderRadius: "50%"
    }
  };
};
var genSkeletonElementButtonShape = (token2, size, buttonCls) => {
  const {
    skeletonButtonCls
  } = token2;
  return {
    [`${buttonCls}${skeletonButtonCls}-circle`]: {
      width: size,
      minWidth: size,
      borderRadius: "50%"
    },
    [`${buttonCls}${skeletonButtonCls}-round`]: {
      borderRadius: size
    }
  };
};
var genSkeletonElementButtonSize = (size, calc) => Object.assign({
  width: calc(size).mul(2).equal(),
  minWidth: calc(size).mul(2).equal()
}, genSkeletonElementCommonSize(size));
var genSkeletonElementButton = (token2) => {
  const {
    borderRadiusSM,
    skeletonButtonCls,
    controlHeight,
    controlHeightLG,
    controlHeightSM,
    gradientFromColor,
    calc
  } = token2;
  return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
    [skeletonButtonCls]: Object.assign({
      display: "inline-block",
      verticalAlign: "top",
      background: gradientFromColor,
      borderRadius: borderRadiusSM,
      width: calc(controlHeight).mul(2).equal(),
      minWidth: calc(controlHeight).mul(2).equal()
    }, genSkeletonElementButtonSize(controlHeight, calc))
  }, genSkeletonElementButtonShape(token2, controlHeight, skeletonButtonCls)), {
    [`${skeletonButtonCls}-lg`]: Object.assign({}, genSkeletonElementButtonSize(controlHeightLG, calc))
  }), genSkeletonElementButtonShape(token2, controlHeightLG, `${skeletonButtonCls}-lg`)), {
    [`${skeletonButtonCls}-sm`]: Object.assign({}, genSkeletonElementButtonSize(controlHeightSM, calc))
  }), genSkeletonElementButtonShape(token2, controlHeightSM, `${skeletonButtonCls}-sm`));
};
var genBaseStyle2 = (token2) => {
  const {
    componentCls,
    skeletonAvatarCls,
    skeletonTitleCls,
    skeletonParagraphCls,
    skeletonButtonCls,
    skeletonInputCls,
    skeletonImageCls,
    controlHeight,
    controlHeightLG,
    controlHeightSM,
    gradientFromColor,
    padding,
    marginSM,
    borderRadius,
    titleHeight,
    blockRadius,
    paragraphLiHeight,
    controlHeightXS,
    paragraphMarginTop
  } = token2;
  return {
    [componentCls]: {
      display: "table",
      width: "100%",
      [`${componentCls}-header`]: {
        display: "table-cell",
        paddingInlineEnd: padding,
        verticalAlign: "top",
        // Avatar
        [skeletonAvatarCls]: Object.assign({
          display: "inline-block",
          verticalAlign: "top",
          background: gradientFromColor
        }, genSkeletonElementAvatarSize(controlHeight)),
        [`${skeletonAvatarCls}-circle`]: {
          borderRadius: "50%"
        },
        [`${skeletonAvatarCls}-lg`]: Object.assign({}, genSkeletonElementAvatarSize(controlHeightLG)),
        [`${skeletonAvatarCls}-sm`]: Object.assign({}, genSkeletonElementAvatarSize(controlHeightSM))
      },
      [`${componentCls}-content`]: {
        display: "table-cell",
        width: "100%",
        verticalAlign: "top",
        // Title
        [skeletonTitleCls]: {
          width: "100%",
          height: titleHeight,
          background: gradientFromColor,
          borderRadius: blockRadius,
          [`+ ${skeletonParagraphCls}`]: {
            marginBlockStart: controlHeightSM
          }
        },
        // paragraph
        [skeletonParagraphCls]: {
          padding: 0,
          "> li": {
            width: "100%",
            height: paragraphLiHeight,
            listStyle: "none",
            background: gradientFromColor,
            borderRadius: blockRadius,
            "+ li": {
              marginBlockStart: controlHeightXS
            }
          }
        },
        [`${skeletonParagraphCls}> li:last-child:not(:first-child):not(:nth-child(2))`]: {
          width: "61%"
        }
      },
      [`&-round ${componentCls}-content`]: {
        [`${skeletonTitleCls}, ${skeletonParagraphCls} > li`]: {
          borderRadius
        }
      }
    },
    [`${componentCls}-with-avatar ${componentCls}-content`]: {
      // Title
      [skeletonTitleCls]: {
        marginBlockStart: marginSM,
        [`+ ${skeletonParagraphCls}`]: {
          marginBlockStart: paragraphMarginTop
        }
      }
    },
    // Skeleton element
    [`${componentCls}${componentCls}-element`]: Object.assign(Object.assign(Object.assign(Object.assign({
      display: "inline-block",
      width: "auto"
    }, genSkeletonElementButton(token2)), genSkeletonElementAvatar(token2)), genSkeletonElementInput(token2)), genSkeletonElementImage(token2)),
    // Skeleton Block Button, Input
    [`${componentCls}${componentCls}-block`]: {
      width: "100%",
      [skeletonButtonCls]: {
        width: "100%"
      },
      [skeletonInputCls]: {
        width: "100%"
      }
    },
    // With active animation
    [`${componentCls}${componentCls}-active`]: {
      [`
        ${skeletonTitleCls},
        ${skeletonParagraphCls} > li,
        ${skeletonAvatarCls},
        ${skeletonButtonCls},
        ${skeletonInputCls},
        ${skeletonImageCls}
      `]: Object.assign({}, genSkeletonColor(token2))
    }
  };
};
var prepareComponentToken4 = (token2) => {
  const {
    colorFillContent,
    colorFill
  } = token2;
  const gradientFromColor = colorFillContent;
  const gradientToColor = colorFill;
  return {
    color: gradientFromColor,
    colorGradientEnd: gradientToColor,
    gradientFromColor,
    gradientToColor,
    titleHeight: token2.controlHeight / 2,
    blockRadius: token2.borderRadiusSM,
    paragraphMarginTop: token2.marginLG + token2.marginXXS,
    paragraphLiHeight: token2.controlHeight / 2
  };
};
var style_default6 = genStyleHooks("Skeleton", (token2) => {
  const {
    componentCls,
    calc
  } = token2;
  const skeletonToken = merge2(token2, {
    skeletonAvatarCls: `${componentCls}-avatar`,
    skeletonTitleCls: `${componentCls}-title`,
    skeletonParagraphCls: `${componentCls}-paragraph`,
    skeletonButtonCls: `${componentCls}-button`,
    skeletonInputCls: `${componentCls}-input`,
    skeletonImageCls: `${componentCls}-image`,
    imageSizeBase: calc(token2.controlHeight).mul(1.5).equal(),
    borderRadius: 100,
    // Large number to make capsule shape
    skeletonLoadingBackground: `linear-gradient(90deg, ${token2.gradientFromColor} 25%, ${token2.gradientToColor} 37%, ${token2.gradientFromColor} 63%)`,
    skeletonLoadingMotionDuration: "1.4s"
  });
  return genBaseStyle2(skeletonToken);
}, prepareComponentToken4, {
  deprecatedTokens: [["color", "gradientFromColor"], ["colorGradientEnd", "gradientToColor"]]
});

// ../../node_modules/antd/es/skeleton/Avatar.js
var SkeletonAvatar = (props) => {
  const {
    prefixCls: customizePrefixCls,
    className: className2,
    rootClassName,
    active,
    shape = "circle",
    size = "default"
  } = props;
  const {
    getPrefixCls
  } = React114.useContext(ConfigContext);
  const prefixCls = getPrefixCls("skeleton", customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = style_default6(prefixCls);
  const otherProps = omit(props, ["prefixCls", "className"]);
  const cls11 = (0, import_classnames29.default)(prefixCls, `${prefixCls}-element`, {
    [`${prefixCls}-active`]: active
  }, className2, rootClassName, hashId, cssVarCls);
  return wrapCSSVar(/* @__PURE__ */ React114.createElement("div", {
    className: cls11
  }, /* @__PURE__ */ React114.createElement(Element_default, Object.assign({
    prefixCls: `${prefixCls}-avatar`,
    shape,
    size
  }, otherProps))));
};
var Avatar_default = SkeletonAvatar;

// ../../node_modules/antd/es/skeleton/Button.js
var React115 = __toESM(require_react());
var import_classnames30 = __toESM(require_classnames());
var SkeletonButton = (props) => {
  const {
    prefixCls: customizePrefixCls,
    className: className2,
    rootClassName,
    active,
    block = false,
    size = "default"
  } = props;
  const {
    getPrefixCls
  } = React115.useContext(ConfigContext);
  const prefixCls = getPrefixCls("skeleton", customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = style_default6(prefixCls);
  const otherProps = omit(props, ["prefixCls"]);
  const cls11 = (0, import_classnames30.default)(prefixCls, `${prefixCls}-element`, {
    [`${prefixCls}-active`]: active,
    [`${prefixCls}-block`]: block
  }, className2, rootClassName, hashId, cssVarCls);
  return wrapCSSVar(/* @__PURE__ */ React115.createElement("div", {
    className: cls11
  }, /* @__PURE__ */ React115.createElement(Element_default, Object.assign({
    prefixCls: `${prefixCls}-button`,
    size
  }, otherProps))));
};
var Button_default = SkeletonButton;

// ../../node_modules/antd/es/skeleton/Image.js
var React116 = __toESM(require_react());
var import_classnames31 = __toESM(require_classnames());
var path = "M365.714286 329.142857q0 45.714286-32.036571 77.677714t-77.677714 32.036571-77.677714-32.036571-32.036571-77.677714 32.036571-77.677714 77.677714-32.036571 77.677714 32.036571 32.036571 77.677714zM950.857143 548.571429l0 256-804.571429 0 0-109.714286 182.857143-182.857143 91.428571 91.428571 292.571429-292.571429zM1005.714286 146.285714l-914.285714 0q-7.460571 0-12.873143 5.412571t-5.412571 12.873143l0 694.857143q0 7.460571 5.412571 12.873143t12.873143 5.412571l914.285714 0q7.460571 0 12.873143-5.412571t5.412571-12.873143l0-694.857143q0-7.460571-5.412571-12.873143t-12.873143-5.412571zM1097.142857 164.571429l0 694.857143q0 37.741714-26.843429 64.585143t-64.585143 26.843429l-914.285714 0q-37.741714 0-64.585143-26.843429t-26.843429-64.585143l0-694.857143q0-37.741714 26.843429-64.585143t64.585143-26.843429l914.285714 0q37.741714 0 64.585143 26.843429t26.843429 64.585143z";
var SkeletonImage = (props) => {
  const {
    prefixCls: customizePrefixCls,
    className: className2,
    rootClassName,
    style: style2,
    active
  } = props;
  const {
    getPrefixCls
  } = React116.useContext(ConfigContext);
  const prefixCls = getPrefixCls("skeleton", customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = style_default6(prefixCls);
  const cls11 = (0, import_classnames31.default)(prefixCls, `${prefixCls}-element`, {
    [`${prefixCls}-active`]: active
  }, className2, rootClassName, hashId, cssVarCls);
  return wrapCSSVar(/* @__PURE__ */ React116.createElement("div", {
    className: cls11
  }, /* @__PURE__ */ React116.createElement("div", {
    className: (0, import_classnames31.default)(`${prefixCls}-image`, className2),
    style: style2
  }, /* @__PURE__ */ React116.createElement("svg", {
    viewBox: "0 0 1098 1024",
    xmlns: "http://www.w3.org/2000/svg",
    className: `${prefixCls}-image-svg`
  }, /* @__PURE__ */ React116.createElement("title", null, "Image placeholder"), /* @__PURE__ */ React116.createElement("path", {
    d: path,
    className: `${prefixCls}-image-path`
  })))));
};
var Image_default = SkeletonImage;

// ../../node_modules/antd/es/skeleton/Input.js
var React117 = __toESM(require_react());
var import_classnames32 = __toESM(require_classnames());
var SkeletonInput = (props) => {
  const {
    prefixCls: customizePrefixCls,
    className: className2,
    rootClassName,
    active,
    block,
    size = "default"
  } = props;
  const {
    getPrefixCls
  } = React117.useContext(ConfigContext);
  const prefixCls = getPrefixCls("skeleton", customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = style_default6(prefixCls);
  const otherProps = omit(props, ["prefixCls"]);
  const cls11 = (0, import_classnames32.default)(prefixCls, `${prefixCls}-element`, {
    [`${prefixCls}-active`]: active,
    [`${prefixCls}-block`]: block
  }, className2, rootClassName, hashId, cssVarCls);
  return wrapCSSVar(/* @__PURE__ */ React117.createElement("div", {
    className: cls11
  }, /* @__PURE__ */ React117.createElement(Element_default, Object.assign({
    prefixCls: `${prefixCls}-input`,
    size
  }, otherProps))));
};
var Input_default = SkeletonInput;

// ../../node_modules/antd/es/skeleton/Node.js
var React118 = __toESM(require_react());
var import_classnames33 = __toESM(require_classnames());
var SkeletonNode = (props) => {
  const {
    prefixCls: customizePrefixCls,
    className: className2,
    rootClassName,
    style: style2,
    active,
    children
  } = props;
  const {
    getPrefixCls
  } = React118.useContext(ConfigContext);
  const prefixCls = getPrefixCls("skeleton", customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = style_default6(prefixCls);
  const cls11 = (0, import_classnames33.default)(prefixCls, `${prefixCls}-element`, {
    [`${prefixCls}-active`]: active
  }, hashId, className2, rootClassName, cssVarCls);
  return wrapCSSVar(/* @__PURE__ */ React118.createElement("div", {
    className: cls11
  }, /* @__PURE__ */ React118.createElement("div", {
    className: (0, import_classnames33.default)(`${prefixCls}-image`, className2),
    style: style2
  }, children)));
};
var Node_default = SkeletonNode;

// ../../node_modules/antd/es/skeleton/Paragraph.js
var React119 = __toESM(require_react());
var import_classnames34 = __toESM(require_classnames());
var getWidth = (index3, props) => {
  const {
    width,
    rows = 2
  } = props;
  if (Array.isArray(width)) {
    return width[index3];
  }
  if (rows - 1 === index3) {
    return width;
  }
  return void 0;
};
var Paragraph = (props) => {
  const {
    prefixCls,
    className: className2,
    style: style2,
    rows = 0
  } = props;
  const rowList = Array.from({
    length: rows
  }).map((_, index3) => (
    // eslint-disable-next-line react/no-array-index-key
    /* @__PURE__ */ React119.createElement("li", {
      key: index3,
      style: {
        width: getWidth(index3, props)
      }
    })
  ));
  return /* @__PURE__ */ React119.createElement("ul", {
    className: (0, import_classnames34.default)(prefixCls, className2),
    style: style2
  }, rowList);
};
var Paragraph_default = Paragraph;

// ../../node_modules/antd/es/skeleton/Title.js
var React120 = __toESM(require_react());
var import_classnames35 = __toESM(require_classnames());
var Title = ({
  prefixCls,
  className: className2,
  width,
  style: style2
}) => (
  // biome-ignore lint/a11y/useHeadingContent: HOC here
  /* @__PURE__ */ React120.createElement("h3", {
    className: (0, import_classnames35.default)(prefixCls, className2),
    style: Object.assign({
      width
    }, style2)
  })
);
var Title_default = Title;

// ../../node_modules/antd/es/skeleton/Skeleton.js
function getComponentProps(prop) {
  if (prop && typeof prop === "object") {
    return prop;
  }
  return {};
}
function getAvatarBasicProps(hasTitle, hasParagraph) {
  if (hasTitle && !hasParagraph) {
    return {
      size: "large",
      shape: "square"
    };
  }
  return {
    size: "large",
    shape: "circle"
  };
}
function getTitleBasicProps(hasAvatar, hasParagraph) {
  if (!hasAvatar && hasParagraph) {
    return {
      width: "38%"
    };
  }
  if (hasAvatar && hasParagraph) {
    return {
      width: "50%"
    };
  }
  return {};
}
function getParagraphBasicProps(hasAvatar, hasTitle) {
  const basicProps = {};
  if (!hasAvatar || !hasTitle) {
    basicProps.width = "61%";
  }
  if (!hasAvatar && hasTitle) {
    basicProps.rows = 3;
  } else {
    basicProps.rows = 2;
  }
  return basicProps;
}
var Skeleton = (props) => {
  const {
    prefixCls: customizePrefixCls,
    loading,
    className: className2,
    rootClassName,
    style: style2,
    children,
    avatar = false,
    title = true,
    paragraph = true,
    active,
    round: round3
  } = props;
  const {
    getPrefixCls,
    direction,
    className: contextClassName,
    style: contextStyle
  } = useComponentConfig("skeleton");
  const prefixCls = getPrefixCls("skeleton", customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = style_default6(prefixCls);
  if (loading || !("loading" in props)) {
    const hasAvatar = !!avatar;
    const hasTitle = !!title;
    const hasParagraph = !!paragraph;
    let avatarNode;
    if (hasAvatar) {
      const avatarProps = Object.assign(Object.assign({
        prefixCls: `${prefixCls}-avatar`
      }, getAvatarBasicProps(hasTitle, hasParagraph)), getComponentProps(avatar));
      avatarNode = /* @__PURE__ */ React121.createElement("div", {
        className: `${prefixCls}-header`
      }, /* @__PURE__ */ React121.createElement(Element_default, Object.assign({}, avatarProps)));
    }
    let contentNode;
    if (hasTitle || hasParagraph) {
      let $title;
      if (hasTitle) {
        const titleProps = Object.assign(Object.assign({
          prefixCls: `${prefixCls}-title`
        }, getTitleBasicProps(hasAvatar, hasParagraph)), getComponentProps(title));
        $title = /* @__PURE__ */ React121.createElement(Title_default, Object.assign({}, titleProps));
      }
      let paragraphNode;
      if (hasParagraph) {
        const paragraphProps = Object.assign(Object.assign({
          prefixCls: `${prefixCls}-paragraph`
        }, getParagraphBasicProps(hasAvatar, hasTitle)), getComponentProps(paragraph));
        paragraphNode = /* @__PURE__ */ React121.createElement(Paragraph_default, Object.assign({}, paragraphProps));
      }
      contentNode = /* @__PURE__ */ React121.createElement("div", {
        className: `${prefixCls}-content`
      }, $title, paragraphNode);
    }
    const cls11 = (0, import_classnames36.default)(prefixCls, {
      [`${prefixCls}-with-avatar`]: hasAvatar,
      [`${prefixCls}-active`]: active,
      [`${prefixCls}-rtl`]: direction === "rtl",
      [`${prefixCls}-round`]: round3
    }, contextClassName, className2, rootClassName, hashId, cssVarCls);
    return wrapCSSVar(/* @__PURE__ */ React121.createElement("div", {
      className: cls11,
      style: Object.assign(Object.assign({}, contextStyle), style2)
    }, avatarNode, contentNode));
  }
  return children !== null && children !== void 0 ? children : null;
};
Skeleton.Button = Button_default;
Skeleton.Avatar = Avatar_default;
Skeleton.Input = Input_default;
Skeleton.Image = Image_default;
Skeleton.Node = Node_default;
if (true) {
  Skeleton.displayName = "Skeleton";
}
var Skeleton_default = Skeleton;

// ../../node_modules/antd/es/skeleton/index.js
var skeleton_default = Skeleton_default;

// ../../node_modules/antd/es/watermark/context.js
var React122 = __toESM(require_react());
function voidFunc() {
}
var WatermarkContext = /* @__PURE__ */ React122.createContext({
  add: voidFunc,
  remove: voidFunc
});
function usePanelRef(panelSelector) {
  const watermark = React122.useContext(WatermarkContext);
  const panelEleRef = React122.useRef(null);
  const panelRef = useEvent2((ele) => {
    if (ele) {
      const innerContentEle = panelSelector ? ele.querySelector(panelSelector) : ele;
      watermark.add(innerContentEle);
      panelEleRef.current = innerContentEle;
    } else {
      watermark.remove(panelEleRef.current);
    }
  });
  return panelRef;
}

// ../../node_modules/antd/es/grid/style/index.js
var genGridRowStyle = (token2) => {
  const {
    componentCls
  } = token2;
  return {
    // Grid system
    [componentCls]: {
      display: "flex",
      flexFlow: "row wrap",
      minWidth: 0,
      "&::before, &::after": {
        display: "flex"
      },
      "&-no-wrap": {
        flexWrap: "nowrap"
      },
      // The origin of the X-axis
      "&-start": {
        justifyContent: "flex-start"
      },
      // The center of the X-axis
      "&-center": {
        justifyContent: "center"
      },
      // The opposite of the X-axis
      "&-end": {
        justifyContent: "flex-end"
      },
      "&-space-between": {
        justifyContent: "space-between"
      },
      "&-space-around": {
        justifyContent: "space-around"
      },
      "&-space-evenly": {
        justifyContent: "space-evenly"
      },
      // Align at the top
      "&-top": {
        alignItems: "flex-start"
      },
      // Align at the center
      "&-middle": {
        alignItems: "center"
      },
      "&-bottom": {
        alignItems: "flex-end"
      }
    }
  };
};
var genGridColStyle = (token2) => {
  const {
    componentCls
  } = token2;
  return {
    // Grid system
    [componentCls]: {
      position: "relative",
      maxWidth: "100%",
      // Prevent columns from collapsing when empty
      minHeight: 1
    }
  };
};
var genLoopGridColumnsStyle = (token2, sizeCls) => {
  const {
    prefixCls,
    componentCls,
    gridColumns
  } = token2;
  const gridColumnsStyle = {};
  for (let i = gridColumns; i >= 0; i--) {
    if (i === 0) {
      gridColumnsStyle[`${componentCls}${sizeCls}-${i}`] = {
        display: "none"
      };
      gridColumnsStyle[`${componentCls}-push-${i}`] = {
        insetInlineStart: "auto"
      };
      gridColumnsStyle[`${componentCls}-pull-${i}`] = {
        insetInlineEnd: "auto"
      };
      gridColumnsStyle[`${componentCls}${sizeCls}-push-${i}`] = {
        insetInlineStart: "auto"
      };
      gridColumnsStyle[`${componentCls}${sizeCls}-pull-${i}`] = {
        insetInlineEnd: "auto"
      };
      gridColumnsStyle[`${componentCls}${sizeCls}-offset-${i}`] = {
        marginInlineStart: 0
      };
      gridColumnsStyle[`${componentCls}${sizeCls}-order-${i}`] = {
        order: 0
      };
    } else {
      gridColumnsStyle[`${componentCls}${sizeCls}-${i}`] = [
        // https://github.com/ant-design/ant-design/issues/44456
        // Form set `display: flex` on Col which will override `display: block`.
        // Let's get it from css variable to support override.
        {
          ["--ant-display"]: "block",
          // Fallback to display if variable not support
          display: "block"
        },
        {
          display: "var(--ant-display)",
          flex: `0 0 ${i / gridColumns * 100}%`,
          maxWidth: `${i / gridColumns * 100}%`
        }
      ];
      gridColumnsStyle[`${componentCls}${sizeCls}-push-${i}`] = {
        insetInlineStart: `${i / gridColumns * 100}%`
      };
      gridColumnsStyle[`${componentCls}${sizeCls}-pull-${i}`] = {
        insetInlineEnd: `${i / gridColumns * 100}%`
      };
      gridColumnsStyle[`${componentCls}${sizeCls}-offset-${i}`] = {
        marginInlineStart: `${i / gridColumns * 100}%`
      };
      gridColumnsStyle[`${componentCls}${sizeCls}-order-${i}`] = {
        order: i
      };
    }
  }
  gridColumnsStyle[`${componentCls}${sizeCls}-flex`] = {
    flex: `var(--${prefixCls}${sizeCls}-flex)`
  };
  return gridColumnsStyle;
};
var genGridStyle = (token2, sizeCls) => genLoopGridColumnsStyle(token2, sizeCls);
var genGridMediaStyle = (token2, screenSize, sizeCls) => ({
  [`@media (min-width: ${unit(screenSize)})`]: Object.assign({}, genGridStyle(token2, sizeCls))
});
var prepareRowComponentToken = () => ({});
var prepareColComponentToken = () => ({});
var useRowStyle = genStyleHooks("Grid", genGridRowStyle, prepareRowComponentToken);
var getMediaSize = (token2) => {
  const mediaSizesMap = {
    xs: token2.screenXSMin,
    sm: token2.screenSMMin,
    md: token2.screenMDMin,
    lg: token2.screenLGMin,
    xl: token2.screenXLMin,
    xxl: token2.screenXXLMin
  };
  return mediaSizesMap;
};
var useColStyle = genStyleHooks("Grid", (token2) => {
  const gridToken = merge2(token2, {
    gridColumns: 24
    // Row is divided into 24 parts in Grid
  });
  const gridMediaSizesMap = getMediaSize(gridToken);
  delete gridMediaSizesMap.xs;
  return [genGridColStyle(gridToken), genGridStyle(gridToken, ""), genGridStyle(gridToken, "-xs"), Object.keys(gridMediaSizesMap).map((key2) => genGridMediaStyle(gridToken, gridMediaSizesMap[key2], `-${key2}`)).reduce((pre, cur) => Object.assign(Object.assign({}, pre), cur), {})];
}, prepareColComponentToken);

// ../../node_modules/antd/es/modal/style/index.js
function box(position3) {
  return {
    position: position3,
    inset: 0
  };
}
var genModalMaskStyle = (token2) => {
  const {
    componentCls,
    antCls
  } = token2;
  return [{
    [`${componentCls}-root`]: {
      [`${componentCls}${antCls}-zoom-enter, ${componentCls}${antCls}-zoom-appear`]: {
        // reset scale avoid mousePosition bug
        transform: "none",
        opacity: 0,
        animationDuration: token2.motionDurationSlow,
        // https://github.com/ant-design/ant-design/issues/11777
        userSelect: "none"
      },
      // https://github.com/ant-design/ant-design/issues/37329
      // https://github.com/ant-design/ant-design/issues/40272
      [`${componentCls}${antCls}-zoom-leave ${componentCls}-content`]: {
        pointerEvents: "none"
      },
      [`${componentCls}-mask`]: Object.assign(Object.assign({}, box("fixed")), {
        zIndex: token2.zIndexPopupBase,
        height: "100%",
        backgroundColor: token2.colorBgMask,
        pointerEvents: "none",
        [`${componentCls}-hidden`]: {
          display: "none"
        }
      }),
      [`${componentCls}-wrap`]: Object.assign(Object.assign({}, box("fixed")), {
        zIndex: token2.zIndexPopupBase,
        overflow: "auto",
        outline: 0,
        WebkitOverflowScrolling: "touch"
      })
    }
  }, {
    [`${componentCls}-root`]: initFadeMotion(token2)
  }];
};
var genModalStyle = (token2) => {
  const {
    componentCls
  } = token2;
  return [
    // ======================== Root =========================
    {
      [`${componentCls}-root`]: {
        [`${componentCls}-wrap-rtl`]: {
          direction: "rtl"
        },
        [`${componentCls}-centered`]: {
          textAlign: "center",
          "&::before": {
            display: "inline-block",
            width: 0,
            height: "100%",
            verticalAlign: "middle",
            content: '""'
          },
          [componentCls]: {
            top: 0,
            display: "inline-block",
            paddingBottom: 0,
            textAlign: "start",
            verticalAlign: "middle"
          }
        },
        [`@media (max-width: ${token2.screenSMMax}px)`]: {
          [componentCls]: {
            maxWidth: "calc(100vw - 16px)",
            margin: `${unit(token2.marginXS)} auto`
          },
          [`${componentCls}-centered`]: {
            [componentCls]: {
              flex: 1
            }
          }
        }
      }
    },
    // ======================== Modal ========================
    {
      [componentCls]: Object.assign(Object.assign({}, resetComponent(token2)), {
        pointerEvents: "none",
        position: "relative",
        top: 100,
        width: "auto",
        maxWidth: `calc(100vw - ${unit(token2.calc(token2.margin).mul(2).equal())})`,
        margin: "0 auto",
        paddingBottom: token2.paddingLG,
        [`${componentCls}-title`]: {
          margin: 0,
          color: token2.titleColor,
          fontWeight: token2.fontWeightStrong,
          fontSize: token2.titleFontSize,
          lineHeight: token2.titleLineHeight,
          wordWrap: "break-word"
        },
        [`${componentCls}-content`]: {
          position: "relative",
          backgroundColor: token2.contentBg,
          backgroundClip: "padding-box",
          border: 0,
          borderRadius: token2.borderRadiusLG,
          boxShadow: token2.boxShadow,
          pointerEvents: "auto",
          padding: token2.contentPadding
        },
        [`${componentCls}-close`]: Object.assign({
          position: "absolute",
          top: token2.calc(token2.modalHeaderHeight).sub(token2.modalCloseBtnSize).div(2).equal(),
          insetInlineEnd: token2.calc(token2.modalHeaderHeight).sub(token2.modalCloseBtnSize).div(2).equal(),
          zIndex: token2.calc(token2.zIndexPopupBase).add(10).equal(),
          padding: 0,
          color: token2.modalCloseIconColor,
          fontWeight: token2.fontWeightStrong,
          lineHeight: 1,
          textDecoration: "none",
          background: "transparent",
          borderRadius: token2.borderRadiusSM,
          width: token2.modalCloseBtnSize,
          height: token2.modalCloseBtnSize,
          border: 0,
          outline: 0,
          cursor: "pointer",
          transition: `color ${token2.motionDurationMid}, background-color ${token2.motionDurationMid}`,
          "&-x": {
            display: "flex",
            fontSize: token2.fontSizeLG,
            fontStyle: "normal",
            lineHeight: unit(token2.modalCloseBtnSize),
            justifyContent: "center",
            textTransform: "none",
            textRendering: "auto"
          },
          "&:disabled": {
            pointerEvents: "none"
          },
          "&:hover": {
            color: token2.modalCloseIconHoverColor,
            backgroundColor: token2.colorBgTextHover,
            textDecoration: "none"
          },
          "&:active": {
            backgroundColor: token2.colorBgTextActive
          }
        }, genFocusStyle(token2)),
        [`${componentCls}-header`]: {
          color: token2.colorText,
          background: token2.headerBg,
          borderRadius: `${unit(token2.borderRadiusLG)} ${unit(token2.borderRadiusLG)} 0 0`,
          marginBottom: token2.headerMarginBottom,
          padding: token2.headerPadding,
          borderBottom: token2.headerBorderBottom
        },
        [`${componentCls}-body`]: {
          fontSize: token2.fontSize,
          lineHeight: token2.lineHeight,
          wordWrap: "break-word",
          padding: token2.bodyPadding,
          [`${componentCls}-body-skeleton`]: {
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: `${unit(token2.margin)} auto`
          }
        },
        [`${componentCls}-footer`]: {
          textAlign: "end",
          background: token2.footerBg,
          marginTop: token2.footerMarginTop,
          padding: token2.footerPadding,
          borderTop: token2.footerBorderTop,
          borderRadius: token2.footerBorderRadius,
          [`> ${token2.antCls}-btn + ${token2.antCls}-btn`]: {
            marginInlineStart: token2.marginXS
          }
        },
        [`${componentCls}-open`]: {
          overflow: "hidden"
        }
      })
    },
    // ======================== Pure =========================
    {
      [`${componentCls}-pure-panel`]: {
        top: "auto",
        padding: 0,
        display: "flex",
        flexDirection: "column",
        [`${componentCls}-content,
          ${componentCls}-body,
          ${componentCls}-confirm-body-wrapper`]: {
          display: "flex",
          flexDirection: "column",
          flex: "auto"
        },
        [`${componentCls}-confirm-body`]: {
          marginBottom: "auto"
        }
      }
    }
  ];
};
var genRTLStyle = (token2) => {
  const {
    componentCls
  } = token2;
  return {
    [`${componentCls}-root`]: {
      [`${componentCls}-wrap-rtl`]: {
        direction: "rtl",
        [`${componentCls}-confirm-body`]: {
          direction: "rtl"
        }
      }
    }
  };
};
var genResponsiveWidthStyle = (token2) => {
  const {
    componentCls
  } = token2;
  const oriGridMediaSizesMap = getMediaSize(token2);
  const gridMediaSizesMap = Object.assign({}, oriGridMediaSizesMap);
  delete gridMediaSizesMap.xs;
  const cssVarPrefix = `--${componentCls.replace(".", "")}-`;
  const responsiveStyles = Object.keys(gridMediaSizesMap).map((key2) => ({
    [`@media (min-width: ${unit(gridMediaSizesMap[key2])})`]: {
      width: `var(${cssVarPrefix}${key2}-width)`
    }
  }));
  return {
    [`${componentCls}-root`]: {
      [componentCls]: [].concat(_toConsumableArray(Object.keys(oriGridMediaSizesMap).map((currentKey, index3) => {
        const previousKey = Object.keys(oriGridMediaSizesMap)[index3 - 1];
        return previousKey ? {
          [`${cssVarPrefix}${currentKey}-width`]: `var(${cssVarPrefix}${previousKey}-width)`
        } : null;
      })), [{
        width: `var(${cssVarPrefix}xs-width)`
      }], _toConsumableArray(responsiveStyles))
    }
  };
};
var prepareToken2 = (token2) => {
  const headerPaddingVertical = token2.padding;
  const headerFontSize = token2.fontSizeHeading5;
  const headerLineHeight = token2.lineHeightHeading5;
  const modalToken = merge2(token2, {
    modalHeaderHeight: token2.calc(token2.calc(headerLineHeight).mul(headerFontSize).equal()).add(token2.calc(headerPaddingVertical).mul(2).equal()).equal(),
    modalFooterBorderColorSplit: token2.colorSplit,
    modalFooterBorderStyle: token2.lineType,
    modalFooterBorderWidth: token2.lineWidth,
    modalCloseIconColor: token2.colorIcon,
    modalCloseIconHoverColor: token2.colorIconHover,
    modalCloseBtnSize: token2.controlHeight,
    modalConfirmIconSize: token2.fontHeight,
    modalTitleHeight: token2.calc(token2.titleFontSize).mul(token2.titleLineHeight).equal()
  });
  return modalToken;
};
var prepareComponentToken5 = (token2) => ({
  footerBg: "transparent",
  headerBg: token2.colorBgElevated,
  titleLineHeight: token2.lineHeightHeading5,
  titleFontSize: token2.fontSizeHeading5,
  contentBg: token2.colorBgElevated,
  titleColor: token2.colorTextHeading,
  // internal
  contentPadding: token2.wireframe ? 0 : `${unit(token2.paddingMD)} ${unit(token2.paddingContentHorizontalLG)}`,
  headerPadding: token2.wireframe ? `${unit(token2.padding)} ${unit(token2.paddingLG)}` : 0,
  headerBorderBottom: token2.wireframe ? `${unit(token2.lineWidth)} ${token2.lineType} ${token2.colorSplit}` : "none",
  headerMarginBottom: token2.wireframe ? 0 : token2.marginXS,
  bodyPadding: token2.wireframe ? token2.paddingLG : 0,
  footerPadding: token2.wireframe ? `${unit(token2.paddingXS)} ${unit(token2.padding)}` : 0,
  footerBorderTop: token2.wireframe ? `${unit(token2.lineWidth)} ${token2.lineType} ${token2.colorSplit}` : "none",
  footerBorderRadius: token2.wireframe ? `0 0 ${unit(token2.borderRadiusLG)} ${unit(token2.borderRadiusLG)}` : 0,
  footerMarginTop: token2.wireframe ? 0 : token2.marginSM,
  confirmBodyPadding: token2.wireframe ? `${unit(token2.padding * 2)} ${unit(token2.padding * 2)} ${unit(token2.paddingLG)}` : 0,
  confirmIconMarginInlineEnd: token2.wireframe ? token2.margin : token2.marginSM,
  confirmBtnsMarginTop: token2.wireframe ? token2.marginLG : token2.marginSM
});
var style_default7 = genStyleHooks("Modal", (token2) => {
  const modalToken = prepareToken2(token2);
  return [genModalStyle(modalToken), genRTLStyle(modalToken), genModalMaskStyle(modalToken), initZoomMotion(modalToken, "zoom"), genResponsiveWidthStyle(modalToken)];
}, prepareComponentToken5, {
  unitless: {
    titleLineHeight: true
  }
});

// ../../node_modules/antd/es/app/context.js
var import_react57 = __toESM(require_react());
var AppConfigContext = /* @__PURE__ */ import_react57.default.createContext({});

// ../../node_modules/antd/es/_util/PurePanel.js
var React124 = __toESM(require_react());
function withPureRenderTheme(Component10) {
  return (props) => /* @__PURE__ */ React124.createElement(config_provider_default, {
    theme: {
      token: {
        motion: false,
        zIndexPopupBase: 0
      }
    }
  }, /* @__PURE__ */ React124.createElement(Component10, Object.assign({}, props)));
}
var genPurePanel = (Component10, alignPropName, postProps, defaultPrefixCls2, getDropdownCls) => {
  const PurePanel9 = (props) => {
    const {
      prefixCls: customizePrefixCls,
      style: style2
    } = props;
    const holderRef = React124.useRef(null);
    const [popupHeight, setPopupHeight] = React124.useState(0);
    const [popupWidth, setPopupWidth] = React124.useState(0);
    const [open2, setOpen] = useMergedState(false, {
      value: props.open
    });
    const {
      getPrefixCls
    } = React124.useContext(ConfigContext);
    const prefixCls = getPrefixCls(defaultPrefixCls2 || "select", customizePrefixCls);
    React124.useEffect(() => {
      setOpen(true);
      if (typeof ResizeObserver !== "undefined") {
        const resizeObserver2 = new ResizeObserver((entries) => {
          const element = entries[0].target;
          setPopupHeight(element.offsetHeight + 8);
          setPopupWidth(element.offsetWidth);
        });
        const interval = setInterval(() => {
          var _a;
          const dropdownCls = getDropdownCls ? `.${getDropdownCls(prefixCls)}` : `.${prefixCls}-dropdown`;
          const popup = (_a = holderRef.current) === null || _a === void 0 ? void 0 : _a.querySelector(dropdownCls);
          if (popup) {
            clearInterval(interval);
            resizeObserver2.observe(popup);
          }
        }, 10);
        return () => {
          clearInterval(interval);
          resizeObserver2.disconnect();
        };
      }
    }, []);
    let mergedProps = Object.assign(Object.assign({}, props), {
      style: Object.assign(Object.assign({}, style2), {
        margin: 0
      }),
      open: open2,
      visible: open2,
      getPopupContainer: () => holderRef.current
    });
    if (postProps) {
      mergedProps = postProps(mergedProps);
    }
    if (alignPropName) {
      Object.assign(mergedProps, {
        [alignPropName]: {
          overflow: {
            adjustX: false,
            adjustY: false
          }
        }
      });
    }
    const mergedStyle = {
      paddingBottom: popupHeight,
      position: "relative",
      minWidth: popupWidth
    };
    return /* @__PURE__ */ React124.createElement("div", {
      ref: holderRef,
      style: mergedStyle
    }, /* @__PURE__ */ React124.createElement(Component10, Object.assign({}, mergedProps)));
  };
  return withPureRenderTheme(PurePanel9);
};
var PurePanel_default2 = genPurePanel;

// ../../node_modules/antd/es/select/index.js
var React184 = __toESM(require_react());
var import_classnames55 = __toESM(require_classnames());

// ../../node_modules/rc-select/es/Select.js
var React173 = __toESM(require_react());

// ../../node_modules/rc-select/es/BaseSelect/index.js
var import_classnames48 = __toESM(require_classnames());

// ../../node_modules/rc-util/es/isMobile.js
var isMobile_default = (function() {
  if (typeof navigator === "undefined" || typeof window === "undefined") {
    return false;
  }
  var agent3 = navigator.userAgent || navigator.vendor || window.opera;
  return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(agent3) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(agent3 === null || agent3 === void 0 ? void 0 : agent3.substr(0, 4));
});

// ../../node_modules/rc-select/es/BaseSelect/index.js
var React154 = __toESM(require_react());

// ../../node_modules/rc-select/es/TransBtn.js
var React125 = __toESM(require_react());
var import_classnames37 = __toESM(require_classnames());
var TransBtn = function TransBtn2(props) {
  var className2 = props.className, customizeIcon = props.customizeIcon, customizeIconProps = props.customizeIconProps, children = props.children, _onMouseDown = props.onMouseDown, onClick = props.onClick;
  var icon = typeof customizeIcon === "function" ? customizeIcon(customizeIconProps) : customizeIcon;
  return /* @__PURE__ */ React125.createElement("span", {
    className: className2,
    onMouseDown: function onMouseDown(event) {
      event.preventDefault();
      _onMouseDown === null || _onMouseDown === void 0 || _onMouseDown(event);
    },
    style: {
      userSelect: "none",
      WebkitUserSelect: "none"
    },
    unselectable: "on",
    onClick,
    "aria-hidden": true
  }, icon !== void 0 ? icon : /* @__PURE__ */ React125.createElement("span", {
    className: (0, import_classnames37.default)(className2.split(/\s+/).map(function(cls11) {
      return "".concat(cls11, "-icon");
    }))
  }, children));
};
var TransBtn_default = TransBtn;

// ../../node_modules/rc-select/es/hooks/useAllowClear.js
var import_react58 = __toESM(require_react());
var useAllowClear = function useAllowClear2(prefixCls, onClearMouseDown, displayValues, allowClear, clearIcon) {
  var disabled = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false;
  var mergedSearchValue = arguments.length > 6 ? arguments[6] : void 0;
  var mode = arguments.length > 7 ? arguments[7] : void 0;
  var mergedClearIcon = import_react58.default.useMemo(function() {
    if (_typeof(allowClear) === "object") {
      return allowClear.clearIcon;
    }
    if (clearIcon) {
      return clearIcon;
    }
  }, [allowClear, clearIcon]);
  var mergedAllowClear = import_react58.default.useMemo(function() {
    if (!disabled && !!allowClear && (displayValues.length || mergedSearchValue) && !(mode === "combobox" && mergedSearchValue === "")) {
      return true;
    }
    return false;
  }, [allowClear, disabled, displayValues.length, mergedSearchValue, mode]);
  return {
    allowClear: mergedAllowClear,
    clearIcon: /* @__PURE__ */ import_react58.default.createElement(TransBtn_default, {
      className: "".concat(prefixCls, "-clear"),
      onMouseDown: onClearMouseDown,
      customizeIcon: mergedClearIcon
    }, "\xD7")
  };
};

// ../../node_modules/rc-select/es/hooks/useBaseProps.js
var React127 = __toESM(require_react());
var BaseSelectContext = /* @__PURE__ */ React127.createContext(null);
function useBaseProps() {
  return React127.useContext(BaseSelectContext);
}

// ../../node_modules/rc-select/es/hooks/useDelayReset.js
var React128 = __toESM(require_react());
function useDelayReset() {
  var timeout = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 10;
  var _React$useState = React128.useState(false), _React$useState2 = _slicedToArray(_React$useState, 2), bool = _React$useState2[0], setBool = _React$useState2[1];
  var delayRef = React128.useRef(null);
  var cancelLatest = function cancelLatest2() {
    window.clearTimeout(delayRef.current);
  };
  React128.useEffect(function() {
    return cancelLatest;
  }, []);
  var delaySetBool = function delaySetBool2(value, callback) {
    cancelLatest();
    delayRef.current = window.setTimeout(function() {
      setBool(value);
      if (callback) {
        callback();
      }
    }, timeout);
  };
  return [bool, delaySetBool, cancelLatest];
}

// ../../node_modules/rc-select/es/hooks/useLock.js
var React129 = __toESM(require_react());
function useLock() {
  var duration = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 250;
  var lockRef = React129.useRef(null);
  var timeoutRef = React129.useRef(null);
  React129.useEffect(function() {
    return function() {
      window.clearTimeout(timeoutRef.current);
    };
  }, []);
  function doLock(locked) {
    if (locked || lockRef.current === null) {
      lockRef.current = locked;
    }
    window.clearTimeout(timeoutRef.current);
    timeoutRef.current = window.setTimeout(function() {
      lockRef.current = null;
    }, duration);
  }
  return [function() {
    return lockRef.current;
  }, doLock];
}

// ../../node_modules/rc-select/es/hooks/useSelectTriggerControl.js
var React130 = __toESM(require_react());
function useSelectTriggerControl(elements, open2, triggerOpen, customizedTrigger) {
  var propsRef = React130.useRef(null);
  propsRef.current = {
    open: open2,
    triggerOpen,
    customizedTrigger
  };
  React130.useEffect(function() {
    function onGlobalMouseDown(event) {
      var _propsRef$current;
      if ((_propsRef$current = propsRef.current) !== null && _propsRef$current !== void 0 && _propsRef$current.customizedTrigger) {
        return;
      }
      var target = event.target;
      if (target.shadowRoot && event.composed) {
        target = event.composedPath()[0] || target;
      }
      if (propsRef.current.open && elements().filter(function(element) {
        return element;
      }).every(function(element) {
        return !element.contains(target) && element !== target;
      })) {
        propsRef.current.triggerOpen(false);
      }
    }
    window.addEventListener("mousedown", onGlobalMouseDown);
    return function() {
      return window.removeEventListener("mousedown", onGlobalMouseDown);
    };
  }, []);
}

// ../../node_modules/rc-select/es/Selector/index.js
var React140 = __toESM(require_react());
var import_react62 = __toESM(require_react());

// ../../node_modules/rc-select/es/utils/keyUtil.js
function isValidateOpenKey(currentKeyCode) {
  return (
    // Undefined for Edge bug:
    // https://github.com/ant-design/ant-design/issues/51292
    currentKeyCode && // Other keys
    ![
      // System function button
      KeyCode_default.ESC,
      KeyCode_default.SHIFT,
      KeyCode_default.BACKSPACE,
      KeyCode_default.TAB,
      KeyCode_default.WIN_KEY,
      KeyCode_default.ALT,
      KeyCode_default.META,
      KeyCode_default.WIN_KEY_RIGHT,
      KeyCode_default.CTRL,
      KeyCode_default.SEMICOLON,
      KeyCode_default.EQUALS,
      KeyCode_default.CAPS_LOCK,
      KeyCode_default.CONTEXT_MENU,
      // F1-F12
      KeyCode_default.F1,
      KeyCode_default.F2,
      KeyCode_default.F3,
      KeyCode_default.F4,
      KeyCode_default.F5,
      KeyCode_default.F6,
      KeyCode_default.F7,
      KeyCode_default.F8,
      KeyCode_default.F9,
      KeyCode_default.F10,
      KeyCode_default.F11,
      KeyCode_default.F12
    ].includes(currentKeyCode)
  );
}

// ../../node_modules/rc-select/es/Selector/MultipleSelector.js
var React138 = __toESM(require_react());
var import_react61 = __toESM(require_react());
var import_classnames42 = __toESM(require_classnames());

// ../../node_modules/rc-overflow/es/Overflow.js
var React135 = __toESM(require_react());
var import_react60 = __toESM(require_react());
var import_classnames40 = __toESM(require_classnames());

// ../../node_modules/rc-overflow/es/Item.js
var React131 = __toESM(require_react());
var import_classnames38 = __toESM(require_classnames());
var _excluded13 = ["prefixCls", "invalidate", "item", "renderItem", "responsive", "responsiveDisabled", "registerSize", "itemKey", "className", "style", "children", "display", "order", "component"];
var UNDEFINED = void 0;
function InternalItem(props, ref3) {
  var prefixCls = props.prefixCls, invalidate = props.invalidate, item = props.item, renderItem3 = props.renderItem, responsive = props.responsive, responsiveDisabled = props.responsiveDisabled, registerSize = props.registerSize, itemKey3 = props.itemKey, className2 = props.className, style2 = props.style, children = props.children, display = props.display, order = props.order, _props$component = props.component, Component10 = _props$component === void 0 ? "div" : _props$component, restProps = _objectWithoutProperties(props, _excluded13);
  var mergedHidden = responsive && !display;
  function internalRegisterSize(width) {
    registerSize(itemKey3, width);
  }
  React131.useEffect(function() {
    return function() {
      internalRegisterSize(null);
    };
  }, []);
  var childNode = renderItem3 && item !== UNDEFINED ? renderItem3(item, {
    index: order
  }) : children;
  var overflowStyle;
  if (!invalidate) {
    overflowStyle = {
      opacity: mergedHidden ? 0 : 1,
      height: mergedHidden ? 0 : UNDEFINED,
      overflowY: mergedHidden ? "hidden" : UNDEFINED,
      order: responsive ? order : UNDEFINED,
      pointerEvents: mergedHidden ? "none" : UNDEFINED,
      position: mergedHidden ? "absolute" : UNDEFINED
    };
  }
  var overflowProps = {};
  if (mergedHidden) {
    overflowProps["aria-hidden"] = true;
  }
  var itemNode = /* @__PURE__ */ React131.createElement(Component10, _extends({
    className: (0, import_classnames38.default)(!invalidate && prefixCls, className2),
    style: _objectSpread2(_objectSpread2({}, overflowStyle), style2)
  }, overflowProps, restProps, {
    ref: ref3
  }), childNode);
  if (responsive) {
    itemNode = /* @__PURE__ */ React131.createElement(es_default, {
      onResize: function onResize2(_ref) {
        var offsetWidth = _ref.offsetWidth;
        internalRegisterSize(offsetWidth);
      },
      disabled: responsiveDisabled
    }, itemNode);
  }
  return itemNode;
}
var Item = /* @__PURE__ */ React131.forwardRef(InternalItem);
Item.displayName = "Item";
var Item_default = Item;

// ../../node_modules/rc-overflow/es/hooks/useEffectState.js
var React132 = __toESM(require_react());
var import_react_dom6 = __toESM(require_react_dom());

// ../../node_modules/rc-overflow/es/hooks/channelUpdate.js
function channelUpdate(callback) {
  if (typeof MessageChannel === "undefined") {
    raf_default(callback);
  } else {
    var channel = new MessageChannel();
    channel.port1.onmessage = function() {
      return callback();
    };
    channel.port2.postMessage(void 0);
  }
}

// ../../node_modules/rc-overflow/es/hooks/useEffectState.js
function useBatcher() {
  var updateFuncRef = React132.useRef(null);
  var notifyEffectUpdate = function notifyEffectUpdate2(callback) {
    if (!updateFuncRef.current) {
      updateFuncRef.current = [];
      channelUpdate(function() {
        (0, import_react_dom6.unstable_batchedUpdates)(function() {
          updateFuncRef.current.forEach(function(fn) {
            fn();
          });
          updateFuncRef.current = null;
        });
      });
    }
    updateFuncRef.current.push(callback);
  };
  return notifyEffectUpdate;
}
function useEffectState(notifyEffectUpdate, defaultValue2) {
  var _React$useState = React132.useState(defaultValue2), _React$useState2 = _slicedToArray(_React$useState, 2), stateValue = _React$useState2[0], setStateValue = _React$useState2[1];
  var setEffectVal = useEvent2(function(nextValue) {
    notifyEffectUpdate(function() {
      setStateValue(nextValue);
    });
  });
  return [stateValue, setEffectVal];
}

// ../../node_modules/rc-overflow/es/RawItem.js
var React134 = __toESM(require_react());
var import_classnames39 = __toESM(require_classnames());

// ../../node_modules/rc-overflow/es/context.js
var import_react59 = __toESM(require_react());
var OverflowContext = /* @__PURE__ */ import_react59.default.createContext(null);

// ../../node_modules/rc-overflow/es/RawItem.js
var _excluded14 = ["component"];
var _excluded24 = ["className"];
var _excluded32 = ["className"];
var InternalRawItem = function InternalRawItem2(props, ref3) {
  var context = React134.useContext(OverflowContext);
  if (!context) {
    var _props$component = props.component, Component10 = _props$component === void 0 ? "div" : _props$component, _restProps = _objectWithoutProperties(props, _excluded14);
    return /* @__PURE__ */ React134.createElement(Component10, _extends({}, _restProps, {
      ref: ref3
    }));
  }
  var contextClassName = context.className, restContext = _objectWithoutProperties(context, _excluded24);
  var className2 = props.className, restProps = _objectWithoutProperties(props, _excluded32);
  return /* @__PURE__ */ React134.createElement(OverflowContext.Provider, {
    value: null
  }, /* @__PURE__ */ React134.createElement(Item_default, _extends({
    ref: ref3,
    className: (0, import_classnames39.default)(contextClassName, className2)
  }, restContext, restProps)));
};
var RawItem = /* @__PURE__ */ React134.forwardRef(InternalRawItem);
RawItem.displayName = "RawItem";
var RawItem_default = RawItem;

// ../../node_modules/rc-overflow/es/Overflow.js
var _excluded15 = ["prefixCls", "data", "renderItem", "renderRawItem", "itemKey", "itemWidth", "ssr", "style", "className", "maxCount", "renderRest", "renderRawRest", "suffix", "component", "itemComponent", "onVisibleChange"];
var RESPONSIVE = "responsive";
var INVALIDATE = "invalidate";
function defaultRenderRest(omittedItems) {
  return "+ ".concat(omittedItems.length, " ...");
}
function Overflow(props, ref3) {
  var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-overflow" : _props$prefixCls, _props$data = props.data, data2 = _props$data === void 0 ? [] : _props$data, renderItem3 = props.renderItem, renderRawItem = props.renderRawItem, itemKey3 = props.itemKey, _props$itemWidth = props.itemWidth, itemWidth = _props$itemWidth === void 0 ? 10 : _props$itemWidth, ssr = props.ssr, style2 = props.style, className2 = props.className, maxCount = props.maxCount, renderRest = props.renderRest, renderRawRest = props.renderRawRest, suffix = props.suffix, _props$component = props.component, Component10 = _props$component === void 0 ? "div" : _props$component, itemComponent = props.itemComponent, onVisibleChange = props.onVisibleChange, restProps = _objectWithoutProperties(props, _excluded15);
  var fullySSR = ssr === "full";
  var notifyEffectUpdate = useBatcher();
  var _useEffectState = useEffectState(notifyEffectUpdate, null), _useEffectState2 = _slicedToArray(_useEffectState, 2), containerWidth = _useEffectState2[0], setContainerWidth = _useEffectState2[1];
  var mergedContainerWidth = containerWidth || 0;
  var _useEffectState3 = useEffectState(notifyEffectUpdate, /* @__PURE__ */ new Map()), _useEffectState4 = _slicedToArray(_useEffectState3, 2), itemWidths = _useEffectState4[0], setItemWidths = _useEffectState4[1];
  var _useEffectState5 = useEffectState(notifyEffectUpdate, 0), _useEffectState6 = _slicedToArray(_useEffectState5, 2), prevRestWidth = _useEffectState6[0], setPrevRestWidth = _useEffectState6[1];
  var _useEffectState7 = useEffectState(notifyEffectUpdate, 0), _useEffectState8 = _slicedToArray(_useEffectState7, 2), restWidth = _useEffectState8[0], setRestWidth = _useEffectState8[1];
  var _useEffectState9 = useEffectState(notifyEffectUpdate, 0), _useEffectState10 = _slicedToArray(_useEffectState9, 2), suffixWidth = _useEffectState10[0], setSuffixWidth = _useEffectState10[1];
  var _useState = (0, import_react60.useState)(null), _useState2 = _slicedToArray(_useState, 2), suffixFixedStart = _useState2[0], setSuffixFixedStart = _useState2[1];
  var _useState3 = (0, import_react60.useState)(null), _useState4 = _slicedToArray(_useState3, 2), displayCount = _useState4[0], setDisplayCount = _useState4[1];
  var mergedDisplayCount = React135.useMemo(function() {
    if (displayCount === null && fullySSR) {
      return Number.MAX_SAFE_INTEGER;
    }
    return displayCount || 0;
  }, [displayCount, containerWidth]);
  var _useState5 = (0, import_react60.useState)(false), _useState6 = _slicedToArray(_useState5, 2), restReady = _useState6[0], setRestReady = _useState6[1];
  var itemPrefixCls = "".concat(prefixCls, "-item");
  var mergedRestWidth = Math.max(prevRestWidth, restWidth);
  var isResponsive = maxCount === RESPONSIVE;
  var shouldResponsive = data2.length && isResponsive;
  var invalidate = maxCount === INVALIDATE;
  var showRest = shouldResponsive || typeof maxCount === "number" && data2.length > maxCount;
  var mergedData = (0, import_react60.useMemo)(function() {
    var items = data2;
    if (shouldResponsive) {
      if (containerWidth === null && fullySSR) {
        items = data2;
      } else {
        items = data2.slice(0, Math.min(data2.length, mergedContainerWidth / itemWidth));
      }
    } else if (typeof maxCount === "number") {
      items = data2.slice(0, maxCount);
    }
    return items;
  }, [data2, itemWidth, containerWidth, maxCount, shouldResponsive]);
  var omittedItems = (0, import_react60.useMemo)(function() {
    if (shouldResponsive) {
      return data2.slice(mergedDisplayCount + 1);
    }
    return data2.slice(mergedData.length);
  }, [data2, mergedData, shouldResponsive, mergedDisplayCount]);
  var getKey5 = (0, import_react60.useCallback)(function(item, index3) {
    var _ref;
    if (typeof itemKey3 === "function") {
      return itemKey3(item);
    }
    return (_ref = itemKey3 && (item === null || item === void 0 ? void 0 : item[itemKey3])) !== null && _ref !== void 0 ? _ref : index3;
  }, [itemKey3]);
  var mergedRenderItem = (0, import_react60.useCallback)(renderItem3 || function(item) {
    return item;
  }, [renderItem3]);
  function updateDisplayCount(count, suffixFixedStartVal, notReady) {
    if (displayCount === count && (suffixFixedStartVal === void 0 || suffixFixedStartVal === suffixFixedStart)) {
      return;
    }
    setDisplayCount(count);
    if (!notReady) {
      setRestReady(count < data2.length - 1);
      onVisibleChange === null || onVisibleChange === void 0 || onVisibleChange(count);
    }
    if (suffixFixedStartVal !== void 0) {
      setSuffixFixedStart(suffixFixedStartVal);
    }
  }
  function onOverflowResize(_, element) {
    setContainerWidth(element.clientWidth);
  }
  function registerSize(key2, width) {
    setItemWidths(function(origin) {
      var clone = new Map(origin);
      if (width === null) {
        clone.delete(key2);
      } else {
        clone.set(key2, width);
      }
      return clone;
    });
  }
  function registerOverflowSize(_, width) {
    setRestWidth(width);
    setPrevRestWidth(restWidth);
  }
  function registerSuffixSize(_, width) {
    setSuffixWidth(width);
  }
  function getItemWidth(index3) {
    return itemWidths.get(getKey5(mergedData[index3], index3));
  }
  useLayoutEffect_default(function() {
    if (mergedContainerWidth && typeof mergedRestWidth === "number" && mergedData) {
      var totalWidth = suffixWidth;
      var len = mergedData.length;
      var lastIndex = len - 1;
      if (!len) {
        updateDisplayCount(0, null);
        return;
      }
      for (var i = 0; i < len; i += 1) {
        var currentItemWidth = getItemWidth(i);
        if (fullySSR) {
          currentItemWidth = currentItemWidth || 0;
        }
        if (currentItemWidth === void 0) {
          updateDisplayCount(i - 1, void 0, true);
          break;
        }
        totalWidth += currentItemWidth;
        if (
          // Only one means `totalWidth` is the final width
          lastIndex === 0 && totalWidth <= mergedContainerWidth || // Last two width will be the final width
          i === lastIndex - 1 && totalWidth + getItemWidth(lastIndex) <= mergedContainerWidth
        ) {
          updateDisplayCount(lastIndex, null);
          break;
        } else if (totalWidth + mergedRestWidth > mergedContainerWidth) {
          updateDisplayCount(i - 1, totalWidth - currentItemWidth - suffixWidth + restWidth);
          break;
        }
      }
      if (suffix && getItemWidth(0) + suffixWidth > mergedContainerWidth) {
        setSuffixFixedStart(null);
      }
    }
  }, [mergedContainerWidth, itemWidths, restWidth, suffixWidth, getKey5, mergedData]);
  var displayRest = restReady && !!omittedItems.length;
  var suffixStyle = {};
  if (suffixFixedStart !== null && shouldResponsive) {
    suffixStyle = {
      position: "absolute",
      left: suffixFixedStart,
      top: 0
    };
  }
  var itemSharedProps = {
    prefixCls: itemPrefixCls,
    responsive: shouldResponsive,
    component: itemComponent,
    invalidate
  };
  var internalRenderItemNode = renderRawItem ? function(item, index3) {
    var key2 = getKey5(item, index3);
    return /* @__PURE__ */ React135.createElement(OverflowContext.Provider, {
      key: key2,
      value: _objectSpread2(_objectSpread2({}, itemSharedProps), {}, {
        order: index3,
        item,
        itemKey: key2,
        registerSize,
        display: index3 <= mergedDisplayCount
      })
    }, renderRawItem(item, index3));
  } : function(item, index3) {
    var key2 = getKey5(item, index3);
    return /* @__PURE__ */ React135.createElement(Item_default, _extends({}, itemSharedProps, {
      order: index3,
      key: key2,
      item,
      renderItem: mergedRenderItem,
      itemKey: key2,
      registerSize,
      display: index3 <= mergedDisplayCount
    }));
  };
  var restContextProps = {
    order: displayRest ? mergedDisplayCount : Number.MAX_SAFE_INTEGER,
    className: "".concat(itemPrefixCls, "-rest"),
    registerSize: registerOverflowSize,
    display: displayRest
  };
  var mergedRenderRest = renderRest || defaultRenderRest;
  var restNode = renderRawRest ? /* @__PURE__ */ React135.createElement(OverflowContext.Provider, {
    value: _objectSpread2(_objectSpread2({}, itemSharedProps), restContextProps)
  }, renderRawRest(omittedItems)) : /* @__PURE__ */ React135.createElement(Item_default, _extends({}, itemSharedProps, restContextProps), typeof mergedRenderRest === "function" ? mergedRenderRest(omittedItems) : mergedRenderRest);
  var overflowNode = /* @__PURE__ */ React135.createElement(Component10, _extends({
    className: (0, import_classnames40.default)(!invalidate && prefixCls, className2),
    style: style2,
    ref: ref3
  }, restProps), mergedData.map(internalRenderItemNode), showRest ? restNode : null, suffix && /* @__PURE__ */ React135.createElement(Item_default, _extends({}, itemSharedProps, {
    responsive: isResponsive,
    responsiveDisabled: !shouldResponsive,
    order: mergedDisplayCount,
    className: "".concat(itemPrefixCls, "-suffix"),
    registerSize: registerSuffixSize,
    display: true,
    style: suffixStyle
  }), suffix));
  return isResponsive ? /* @__PURE__ */ React135.createElement(es_default, {
    onResize: onOverflowResize,
    disabled: !shouldResponsive
  }, overflowNode) : overflowNode;
}
var ForwardOverflow = /* @__PURE__ */ React135.forwardRef(Overflow);
ForwardOverflow.displayName = "Overflow";
ForwardOverflow.Item = RawItem_default;
ForwardOverflow.RESPONSIVE = RESPONSIVE;
ForwardOverflow.INVALIDATE = INVALIDATE;
var Overflow_default = ForwardOverflow;

// ../../node_modules/rc-overflow/es/index.js
var es_default8 = Overflow_default;

// ../../node_modules/rc-select/es/Selector/Input.js
var React136 = __toESM(require_react());
var import_classnames41 = __toESM(require_classnames());

// ../../node_modules/rc-util/es/composeProps.js
function composeProps(originProps, patchProps, isAll) {
  var composedProps = _objectSpread2(_objectSpread2({}, originProps), isAll ? patchProps : {});
  Object.keys(patchProps).forEach(function(key2) {
    var func = patchProps[key2];
    if (typeof func === "function") {
      composedProps[key2] = function() {
        var _originProps$key;
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        func.apply(void 0, args);
        return (_originProps$key = originProps[key2]) === null || _originProps$key === void 0 ? void 0 : _originProps$key.call.apply(_originProps$key, [originProps].concat(args));
      };
    }
  });
  return composedProps;
}
var composeProps_default = composeProps;

// ../../node_modules/rc-select/es/Selector/Input.js
var _excluded16 = ["prefixCls", "id", "inputElement", "autoFocus", "autoComplete", "editable", "activeDescendantId", "value", "open", "attrs"];
var Input = function Input2(props, ref3) {
  var prefixCls = props.prefixCls, id = props.id, inputElement = props.inputElement, autoFocus = props.autoFocus, autoComplete = props.autoComplete, editable = props.editable, activeDescendantId = props.activeDescendantId, value = props.value, open2 = props.open, attrs = props.attrs, restProps = _objectWithoutProperties(props, _excluded16);
  var inputNode = inputElement || /* @__PURE__ */ React136.createElement("input", null);
  var _inputNode = inputNode, originRef = _inputNode.ref, originProps = _inputNode.props;
  warning(!("maxLength" in inputNode.props), "Passing 'maxLength' to input element directly may not work because input in BaseSelect is controlled.");
  inputNode = /* @__PURE__ */ React136.cloneElement(inputNode, _objectSpread2(_objectSpread2(_objectSpread2({
    type: "search"
  }, composeProps_default(restProps, originProps, true)), {}, {
    // Override over origin props
    id,
    ref: composeRef(ref3, originRef),
    autoComplete: autoComplete || "off",
    autoFocus,
    className: (0, import_classnames41.default)("".concat(prefixCls, "-selection-search-input"), originProps === null || originProps === void 0 ? void 0 : originProps.className),
    role: "combobox",
    "aria-expanded": open2 || false,
    "aria-haspopup": "listbox",
    "aria-owns": "".concat(id, "_list"),
    "aria-autocomplete": "list",
    "aria-controls": "".concat(id, "_list"),
    "aria-activedescendant": open2 ? activeDescendantId : void 0
  }, attrs), {}, {
    value: editable ? value : "",
    readOnly: !editable,
    unselectable: !editable ? "on" : null,
    style: _objectSpread2(_objectSpread2({}, originProps.style), {}, {
      opacity: editable ? null : 0
    })
  }));
  return inputNode;
};
var RefInput = /* @__PURE__ */ React136.forwardRef(Input);
if (true) {
  RefInput.displayName = "Input";
}
var Input_default2 = RefInput;

// ../../node_modules/rc-select/es/hooks/useLayoutEffect.js
var React137 = __toESM(require_react());

// ../../node_modules/rc-select/es/utils/commonUtil.js
function toArray3(value) {
  if (Array.isArray(value)) {
    return value;
  }
  return value !== void 0 ? [value] : [];
}
var isClient = typeof window !== "undefined" && window.document && window.document.documentElement;
var isBrowserClient = isClient;
function hasValue2(value) {
  return value !== void 0 && value !== null;
}
function isComboNoValue(value) {
  return !value && value !== 0;
}
function isTitleType(title) {
  return ["string", "number"].includes(_typeof(title));
}
function getTitle(item) {
  var title = void 0;
  if (item) {
    if (isTitleType(item.title)) {
      title = item.title.toString();
    } else if (isTitleType(item.label)) {
      title = item.label.toString();
    }
  }
  return title;
}

// ../../node_modules/rc-select/es/hooks/useLayoutEffect.js
function useLayoutEffect7(effect, deps) {
  if (isBrowserClient) {
    React137.useLayoutEffect(effect, deps);
  } else {
    React137.useEffect(effect, deps);
  }
}

// ../../node_modules/rc-select/es/Selector/MultipleSelector.js
function itemKey(value) {
  var _value$key;
  return (_value$key = value.key) !== null && _value$key !== void 0 ? _value$key : value.value;
}
var onPreventMouseDown = function onPreventMouseDown2(event) {
  event.preventDefault();
  event.stopPropagation();
};
var SelectSelector = function SelectSelector2(props) {
  var id = props.id, prefixCls = props.prefixCls, values = props.values, open2 = props.open, searchValue = props.searchValue, autoClearSearchValue = props.autoClearSearchValue, inputRef = props.inputRef, placeholder = props.placeholder, disabled = props.disabled, mode = props.mode, showSearch = props.showSearch, autoFocus = props.autoFocus, autoComplete = props.autoComplete, activeDescendantId = props.activeDescendantId, tabIndex = props.tabIndex, removeIcon = props.removeIcon, maxTagCount = props.maxTagCount, maxTagTextLength = props.maxTagTextLength, _props$maxTagPlacehol = props.maxTagPlaceholder, maxTagPlaceholder = _props$maxTagPlacehol === void 0 ? function(omittedValues) {
    return "+ ".concat(omittedValues.length, " ...");
  } : _props$maxTagPlacehol, tagRender = props.tagRender, onToggleOpen = props.onToggleOpen, onRemove = props.onRemove, onInputChange = props.onInputChange, onInputPaste = props.onInputPaste, onInputKeyDown = props.onInputKeyDown, onInputMouseDown = props.onInputMouseDown, onInputCompositionStart = props.onInputCompositionStart, onInputCompositionEnd = props.onInputCompositionEnd, onInputBlur = props.onInputBlur;
  var measureRef = React138.useRef(null);
  var _useState = (0, import_react61.useState)(0), _useState2 = _slicedToArray(_useState, 2), inputWidth = _useState2[0], setInputWidth = _useState2[1];
  var _useState3 = (0, import_react61.useState)(false), _useState4 = _slicedToArray(_useState3, 2), focused = _useState4[0], setFocused = _useState4[1];
  var selectionPrefixCls = "".concat(prefixCls, "-selection");
  var inputValue = open2 || mode === "multiple" && autoClearSearchValue === false || mode === "tags" ? searchValue : "";
  var inputEditable = mode === "tags" || mode === "multiple" && autoClearSearchValue === false || showSearch && (open2 || focused);
  useLayoutEffect7(function() {
    setInputWidth(measureRef.current.scrollWidth);
  }, [inputValue]);
  var defaultRenderSelector = function defaultRenderSelector2(item, content, itemDisabled, closable, onClose) {
    return /* @__PURE__ */ React138.createElement("span", {
      title: getTitle(item),
      className: (0, import_classnames42.default)("".concat(selectionPrefixCls, "-item"), _defineProperty({}, "".concat(selectionPrefixCls, "-item-disabled"), itemDisabled))
    }, /* @__PURE__ */ React138.createElement("span", {
      className: "".concat(selectionPrefixCls, "-item-content")
    }, content), closable && /* @__PURE__ */ React138.createElement(TransBtn_default, {
      className: "".concat(selectionPrefixCls, "-item-remove"),
      onMouseDown: onPreventMouseDown,
      onClick: onClose,
      customizeIcon: removeIcon
    }, "\xD7"));
  };
  var customizeRenderSelector = function customizeRenderSelector2(value, content, itemDisabled, closable, onClose, isMaxTag) {
    var onMouseDown = function onMouseDown2(e3) {
      onPreventMouseDown(e3);
      onToggleOpen(!open2);
    };
    return /* @__PURE__ */ React138.createElement("span", {
      onMouseDown
    }, tagRender({
      label: content,
      value,
      disabled: itemDisabled,
      closable,
      onClose,
      isMaxTag: !!isMaxTag
    }));
  };
  var renderItem3 = function renderItem4(valueItem) {
    var itemDisabled = valueItem.disabled, label = valueItem.label, value = valueItem.value;
    var closable = !disabled && !itemDisabled;
    var displayLabel = label;
    if (typeof maxTagTextLength === "number") {
      if (typeof label === "string" || typeof label === "number") {
        var strLabel = String(displayLabel);
        if (strLabel.length > maxTagTextLength) {
          displayLabel = "".concat(strLabel.slice(0, maxTagTextLength), "...");
        }
      }
    }
    var onClose = function onClose2(event) {
      if (event) {
        event.stopPropagation();
      }
      onRemove(valueItem);
    };
    return typeof tagRender === "function" ? customizeRenderSelector(value, displayLabel, itemDisabled, closable, onClose) : defaultRenderSelector(valueItem, displayLabel, itemDisabled, closable, onClose);
  };
  var renderRest = function renderRest2(omittedValues) {
    if (!values.length) {
      return null;
    }
    var content = typeof maxTagPlaceholder === "function" ? maxTagPlaceholder(omittedValues) : maxTagPlaceholder;
    return typeof tagRender === "function" ? customizeRenderSelector(void 0, content, false, false, void 0, true) : defaultRenderSelector({
      title: content
    }, content, false);
  };
  var inputNode = /* @__PURE__ */ React138.createElement("div", {
    className: "".concat(selectionPrefixCls, "-search"),
    style: {
      width: inputWidth
    },
    onFocus: function onFocus() {
      setFocused(true);
    },
    onBlur: function onBlur() {
      setFocused(false);
    }
  }, /* @__PURE__ */ React138.createElement(Input_default2, {
    ref: inputRef,
    open: open2,
    prefixCls,
    id,
    inputElement: null,
    disabled,
    autoFocus,
    autoComplete,
    editable: inputEditable,
    activeDescendantId,
    value: inputValue,
    onKeyDown: onInputKeyDown,
    onMouseDown: onInputMouseDown,
    onChange: onInputChange,
    onPaste: onInputPaste,
    onCompositionStart: onInputCompositionStart,
    onCompositionEnd: onInputCompositionEnd,
    onBlur: onInputBlur,
    tabIndex,
    attrs: pickAttrs(props, true)
  }), /* @__PURE__ */ React138.createElement("span", {
    ref: measureRef,
    className: "".concat(selectionPrefixCls, "-search-mirror"),
    "aria-hidden": true
  }, inputValue, "\xA0"));
  var selectionNode = /* @__PURE__ */ React138.createElement(es_default8, {
    prefixCls: "".concat(selectionPrefixCls, "-overflow"),
    data: values,
    renderItem: renderItem3,
    renderRest,
    suffix: inputNode,
    itemKey,
    maxCount: maxTagCount
  });
  return /* @__PURE__ */ React138.createElement("span", {
    className: "".concat(selectionPrefixCls, "-wrap")
  }, selectionNode, !values.length && !inputValue && /* @__PURE__ */ React138.createElement("span", {
    className: "".concat(selectionPrefixCls, "-placeholder")
  }, placeholder));
};
var MultipleSelector_default = SelectSelector;

// ../../node_modules/rc-select/es/Selector/SingleSelector.js
var React139 = __toESM(require_react());
var SingleSelector = function SingleSelector2(props) {
  var inputElement = props.inputElement, prefixCls = props.prefixCls, id = props.id, inputRef = props.inputRef, disabled = props.disabled, autoFocus = props.autoFocus, autoComplete = props.autoComplete, activeDescendantId = props.activeDescendantId, mode = props.mode, open2 = props.open, values = props.values, placeholder = props.placeholder, tabIndex = props.tabIndex, showSearch = props.showSearch, searchValue = props.searchValue, activeValue = props.activeValue, maxLength = props.maxLength, onInputKeyDown = props.onInputKeyDown, onInputMouseDown = props.onInputMouseDown, onInputChange = props.onInputChange, onInputPaste = props.onInputPaste, onInputCompositionStart = props.onInputCompositionStart, onInputCompositionEnd = props.onInputCompositionEnd, onInputBlur = props.onInputBlur, title = props.title;
  var _React$useState = React139.useState(false), _React$useState2 = _slicedToArray(_React$useState, 2), inputChanged = _React$useState2[0], setInputChanged = _React$useState2[1];
  var combobox = mode === "combobox";
  var inputEditable = combobox || showSearch;
  var item = values[0];
  var inputValue = searchValue || "";
  if (combobox && activeValue && !inputChanged) {
    inputValue = activeValue;
  }
  React139.useEffect(function() {
    if (combobox) {
      setInputChanged(false);
    }
  }, [combobox, activeValue]);
  var hasTextInput = mode !== "combobox" && !open2 && !showSearch ? false : !!inputValue;
  var selectionTitle = title === void 0 ? getTitle(item) : title;
  var placeholderNode = React139.useMemo(function() {
    if (item) {
      return null;
    }
    return /* @__PURE__ */ React139.createElement("span", {
      className: "".concat(prefixCls, "-selection-placeholder"),
      style: hasTextInput ? {
        visibility: "hidden"
      } : void 0
    }, placeholder);
  }, [item, hasTextInput, placeholder, prefixCls]);
  return /* @__PURE__ */ React139.createElement("span", {
    className: "".concat(prefixCls, "-selection-wrap")
  }, /* @__PURE__ */ React139.createElement("span", {
    className: "".concat(prefixCls, "-selection-search")
  }, /* @__PURE__ */ React139.createElement(Input_default2, {
    ref: inputRef,
    prefixCls,
    id,
    open: open2,
    inputElement,
    disabled,
    autoFocus,
    autoComplete,
    editable: inputEditable,
    activeDescendantId,
    value: inputValue,
    onKeyDown: onInputKeyDown,
    onMouseDown: onInputMouseDown,
    onChange: function onChange(e3) {
      setInputChanged(true);
      onInputChange(e3);
    },
    onPaste: onInputPaste,
    onCompositionStart: onInputCompositionStart,
    onCompositionEnd: onInputCompositionEnd,
    onBlur: onInputBlur,
    tabIndex,
    attrs: pickAttrs(props, true),
    maxLength: combobox ? maxLength : void 0
  })), !combobox && item ? /* @__PURE__ */ React139.createElement("span", {
    className: "".concat(prefixCls, "-selection-item"),
    title: selectionTitle,
    style: hasTextInput ? {
      visibility: "hidden"
    } : void 0
  }, item.label) : null, placeholderNode);
};
var SingleSelector_default = SingleSelector;

// ../../node_modules/rc-select/es/Selector/index.js
var Selector = function Selector2(props, ref3) {
  var inputRef = (0, import_react62.useRef)(null);
  var compositionStatusRef = (0, import_react62.useRef)(false);
  var prefixCls = props.prefixCls, open2 = props.open, mode = props.mode, showSearch = props.showSearch, tokenWithEnter = props.tokenWithEnter, disabled = props.disabled, prefix3 = props.prefix, autoClearSearchValue = props.autoClearSearchValue, onSearch = props.onSearch, onSearchSubmit = props.onSearchSubmit, onToggleOpen = props.onToggleOpen, onInputKeyDown = props.onInputKeyDown, onInputBlur = props.onInputBlur, domRef = props.domRef;
  React140.useImperativeHandle(ref3, function() {
    return {
      focus: function focus(options) {
        inputRef.current.focus(options);
      },
      blur: function blur() {
        inputRef.current.blur();
      }
    };
  });
  var _useLock = useLock(0), _useLock2 = _slicedToArray(_useLock, 2), getInputMouseDown = _useLock2[0], setInputMouseDown = _useLock2[1];
  var onInternalInputKeyDown = function onInternalInputKeyDown2(event) {
    var which = event.which;
    var isTextAreaElement = inputRef.current instanceof HTMLTextAreaElement;
    if (!isTextAreaElement && open2 && (which === KeyCode_default.UP || which === KeyCode_default.DOWN)) {
      event.preventDefault();
    }
    if (onInputKeyDown) {
      onInputKeyDown(event);
    }
    if (which === KeyCode_default.ENTER && mode === "tags" && !compositionStatusRef.current && !open2) {
      onSearchSubmit === null || onSearchSubmit === void 0 || onSearchSubmit(event.target.value);
    }
    if (isTextAreaElement && !open2 && ~[KeyCode_default.UP, KeyCode_default.DOWN, KeyCode_default.LEFT, KeyCode_default.RIGHT].indexOf(which)) {
      return;
    }
    if (isValidateOpenKey(which)) {
      onToggleOpen(true);
    }
  };
  var onInternalInputMouseDown = function onInternalInputMouseDown2() {
    setInputMouseDown(true);
  };
  var pastedTextRef = (0, import_react62.useRef)(null);
  var triggerOnSearch = function triggerOnSearch2(value) {
    if (onSearch(value, true, compositionStatusRef.current) !== false) {
      onToggleOpen(true);
    }
  };
  var onInputCompositionStart = function onInputCompositionStart2() {
    compositionStatusRef.current = true;
  };
  var onInputCompositionEnd = function onInputCompositionEnd2(e3) {
    compositionStatusRef.current = false;
    if (mode !== "combobox") {
      triggerOnSearch(e3.target.value);
    }
  };
  var onInputChange = function onInputChange2(event) {
    var value = event.target.value;
    if (tokenWithEnter && pastedTextRef.current && /[\r\n]/.test(pastedTextRef.current)) {
      var replacedText = pastedTextRef.current.replace(/[\r\n]+$/, "").replace(/\r\n/g, " ").replace(/[\r\n]/g, " ");
      value = value.replace(replacedText, pastedTextRef.current);
    }
    pastedTextRef.current = null;
    triggerOnSearch(value);
  };
  var onInputPaste = function onInputPaste2(e3) {
    var clipboardData = e3.clipboardData;
    var value = clipboardData === null || clipboardData === void 0 ? void 0 : clipboardData.getData("text");
    pastedTextRef.current = value || "";
  };
  var onClick = function onClick2(_ref) {
    var target = _ref.target;
    if (target !== inputRef.current) {
      var isIE = document.body.style.msTouchAction !== void 0;
      if (isIE) {
        setTimeout(function() {
          inputRef.current.focus();
        });
      } else {
        inputRef.current.focus();
      }
    }
  };
  var onMouseDown = function onMouseDown2(event) {
    var inputMouseDown = getInputMouseDown();
    if (event.target !== inputRef.current && !inputMouseDown && !(mode === "combobox" && disabled)) {
      event.preventDefault();
    }
    if (mode !== "combobox" && (!showSearch || !inputMouseDown) || !open2) {
      if (open2 && autoClearSearchValue !== false) {
        onSearch("", true, false);
      }
      onToggleOpen();
    }
  };
  var sharedProps = {
    inputRef,
    onInputKeyDown: onInternalInputKeyDown,
    onInputMouseDown: onInternalInputMouseDown,
    onInputChange,
    onInputPaste,
    onInputCompositionStart,
    onInputCompositionEnd,
    onInputBlur
  };
  var selectNode = mode === "multiple" || mode === "tags" ? /* @__PURE__ */ React140.createElement(MultipleSelector_default, _extends({}, props, sharedProps)) : /* @__PURE__ */ React140.createElement(SingleSelector_default, _extends({}, props, sharedProps));
  return /* @__PURE__ */ React140.createElement("div", {
    ref: domRef,
    className: "".concat(prefixCls, "-selector"),
    onClick,
    onMouseDown
  }, prefix3 && /* @__PURE__ */ React140.createElement("div", {
    className: "".concat(prefixCls, "-prefix")
  }, prefix3), selectNode);
};
var ForwardSelector = /* @__PURE__ */ React140.forwardRef(Selector);
if (true) {
  ForwardSelector.displayName = "Selector";
}
var Selector_default = ForwardSelector;

// ../../node_modules/@rc-component/trigger/es/index.js
var import_classnames46 = __toESM(require_classnames());
var React150 = __toESM(require_react());

// ../../node_modules/@rc-component/trigger/es/Popup/index.js
var import_classnames45 = __toESM(require_classnames());
var React144 = __toESM(require_react());

// ../../node_modules/@rc-component/trigger/es/Popup/Arrow.js
var import_classnames43 = __toESM(require_classnames());
var React141 = __toESM(require_react());
function Arrow(props) {
  var prefixCls = props.prefixCls, align = props.align, arrow = props.arrow, arrowPos = props.arrowPos;
  var _ref = arrow || {}, className2 = _ref.className, content = _ref.content;
  var _arrowPos$x = arrowPos.x, x = _arrowPos$x === void 0 ? 0 : _arrowPos$x, _arrowPos$y = arrowPos.y, y = _arrowPos$y === void 0 ? 0 : _arrowPos$y;
  var arrowRef = React141.useRef();
  if (!align || !align.points) {
    return null;
  }
  var alignStyle = {
    position: "absolute"
  };
  if (align.autoArrow !== false) {
    var popupPoints = align.points[0];
    var targetPoints = align.points[1];
    var popupTB = popupPoints[0];
    var popupLR = popupPoints[1];
    var targetTB = targetPoints[0];
    var targetLR = targetPoints[1];
    if (popupTB === targetTB || !["t", "b"].includes(popupTB)) {
      alignStyle.top = y;
    } else if (popupTB === "t") {
      alignStyle.top = 0;
    } else {
      alignStyle.bottom = 0;
    }
    if (popupLR === targetLR || !["l", "r"].includes(popupLR)) {
      alignStyle.left = x;
    } else if (popupLR === "l") {
      alignStyle.left = 0;
    } else {
      alignStyle.right = 0;
    }
  }
  return /* @__PURE__ */ React141.createElement("div", {
    ref: arrowRef,
    className: (0, import_classnames43.default)("".concat(prefixCls, "-arrow"), className2),
    style: alignStyle
  }, content);
}

// ../../node_modules/@rc-component/trigger/es/Popup/Mask.js
var import_classnames44 = __toESM(require_classnames());
var React142 = __toESM(require_react());
function Mask3(props) {
  var prefixCls = props.prefixCls, open2 = props.open, zIndex = props.zIndex, mask = props.mask, motion2 = props.motion;
  if (!mask) {
    return null;
  }
  return /* @__PURE__ */ React142.createElement(es_default2, _extends({}, motion2, {
    motionAppear: true,
    visible: open2,
    removeOnLeave: true
  }), function(_ref) {
    var className2 = _ref.className;
    return /* @__PURE__ */ React142.createElement("div", {
      style: {
        zIndex
      },
      className: (0, import_classnames44.default)("".concat(prefixCls, "-mask"), className2)
    });
  });
}

// ../../node_modules/@rc-component/trigger/es/Popup/PopupContent.js
var React143 = __toESM(require_react());
var PopupContent = /* @__PURE__ */ React143.memo(function(_ref) {
  var children = _ref.children;
  return children;
}, function(_, next2) {
  return next2.cache;
});
if (true) {
  PopupContent.displayName = "PopupContent";
}
var PopupContent_default = PopupContent;

// ../../node_modules/@rc-component/trigger/es/Popup/index.js
var Popup = /* @__PURE__ */ React144.forwardRef(function(props, ref3) {
  var popup = props.popup, className2 = props.className, prefixCls = props.prefixCls, style2 = props.style, target = props.target, _onVisibleChanged = props.onVisibleChanged, open2 = props.open, keepDom = props.keepDom, fresh = props.fresh, onClick = props.onClick, mask = props.mask, arrow = props.arrow, arrowPos = props.arrowPos, align = props.align, motion2 = props.motion, maskMotion = props.maskMotion, forceRender = props.forceRender, getPopupContainer = props.getPopupContainer, autoDestroy = props.autoDestroy, Portal2 = props.portal, zIndex = props.zIndex, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, onPointerEnter = props.onPointerEnter, onPointerDownCapture = props.onPointerDownCapture, ready = props.ready, offsetX = props.offsetX, offsetY = props.offsetY, offsetR = props.offsetR, offsetB = props.offsetB, onAlign = props.onAlign, onPrepare = props.onPrepare, stretch = props.stretch, targetWidth = props.targetWidth, targetHeight = props.targetHeight;
  var childNode = typeof popup === "function" ? popup() : popup;
  var isNodeVisible = open2 || keepDom;
  var getPopupContainerNeedParams = (getPopupContainer === null || getPopupContainer === void 0 ? void 0 : getPopupContainer.length) > 0;
  var _React$useState = React144.useState(!getPopupContainer || !getPopupContainerNeedParams), _React$useState2 = _slicedToArray(_React$useState, 2), show = _React$useState2[0], setShow = _React$useState2[1];
  useLayoutEffect_default(function() {
    if (!show && getPopupContainerNeedParams && target) {
      setShow(true);
    }
  }, [show, getPopupContainerNeedParams, target]);
  if (!show) {
    return null;
  }
  var AUTO = "auto";
  var offsetStyle = {
    left: "-1000vw",
    top: "-1000vh",
    right: AUTO,
    bottom: AUTO
  };
  if (ready || !open2) {
    var _experimental;
    var points = align.points;
    var dynamicInset = align.dynamicInset || ((_experimental = align._experimental) === null || _experimental === void 0 ? void 0 : _experimental.dynamicInset);
    var alignRight = dynamicInset && points[0][1] === "r";
    var alignBottom = dynamicInset && points[0][0] === "b";
    if (alignRight) {
      offsetStyle.right = offsetR;
      offsetStyle.left = AUTO;
    } else {
      offsetStyle.left = offsetX;
      offsetStyle.right = AUTO;
    }
    if (alignBottom) {
      offsetStyle.bottom = offsetB;
      offsetStyle.top = AUTO;
    } else {
      offsetStyle.top = offsetY;
      offsetStyle.bottom = AUTO;
    }
  }
  var miscStyle = {};
  if (stretch) {
    if (stretch.includes("height") && targetHeight) {
      miscStyle.height = targetHeight;
    } else if (stretch.includes("minHeight") && targetHeight) {
      miscStyle.minHeight = targetHeight;
    }
    if (stretch.includes("width") && targetWidth) {
      miscStyle.width = targetWidth;
    } else if (stretch.includes("minWidth") && targetWidth) {
      miscStyle.minWidth = targetWidth;
    }
  }
  if (!open2) {
    miscStyle.pointerEvents = "none";
  }
  return /* @__PURE__ */ React144.createElement(Portal2, {
    open: forceRender || isNodeVisible,
    getContainer: getPopupContainer && function() {
      return getPopupContainer(target);
    },
    autoDestroy
  }, /* @__PURE__ */ React144.createElement(Mask3, {
    prefixCls,
    open: open2,
    zIndex,
    mask,
    motion: maskMotion
  }), /* @__PURE__ */ React144.createElement(es_default, {
    onResize: onAlign,
    disabled: !open2
  }, function(resizeObserverRef) {
    return /* @__PURE__ */ React144.createElement(es_default2, _extends({
      motionAppear: true,
      motionEnter: true,
      motionLeave: true,
      removeOnLeave: false,
      forceRender,
      leavedClassName: "".concat(prefixCls, "-hidden")
    }, motion2, {
      onAppearPrepare: onPrepare,
      onEnterPrepare: onPrepare,
      visible: open2,
      onVisibleChanged: function onVisibleChanged(nextVisible) {
        var _motion$onVisibleChan;
        motion2 === null || motion2 === void 0 || (_motion$onVisibleChan = motion2.onVisibleChanged) === null || _motion$onVisibleChan === void 0 || _motion$onVisibleChan.call(motion2, nextVisible);
        _onVisibleChanged(nextVisible);
      }
    }), function(_ref, motionRef) {
      var motionClassName = _ref.className, motionStyle = _ref.style;
      var cls11 = (0, import_classnames45.default)(prefixCls, motionClassName, className2);
      return /* @__PURE__ */ React144.createElement("div", {
        ref: composeRef(resizeObserverRef, ref3, motionRef),
        className: cls11,
        style: _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({
          "--arrow-x": "".concat(arrowPos.x || 0, "px"),
          "--arrow-y": "".concat(arrowPos.y || 0, "px")
        }, offsetStyle), miscStyle), motionStyle), {}, {
          boxSizing: "border-box",
          zIndex
        }, style2),
        onMouseEnter,
        onMouseLeave,
        onPointerEnter,
        onClick,
        onPointerDownCapture
      }, arrow && /* @__PURE__ */ React144.createElement(Arrow, {
        prefixCls,
        arrow,
        arrowPos,
        align
      }), /* @__PURE__ */ React144.createElement(PopupContent_default, {
        cache: !open2 && !fresh
      }, childNode));
    });
  }));
});
if (true) {
  Popup.displayName = "Popup";
}
var Popup_default = Popup;

// ../../node_modules/@rc-component/trigger/es/TriggerWrapper.js
var React145 = __toESM(require_react());
var TriggerWrapper = /* @__PURE__ */ React145.forwardRef(function(props, ref3) {
  var children = props.children, getTriggerDOMNode = props.getTriggerDOMNode;
  var canUseRef = supportRef(children);
  var setRef = React145.useCallback(function(node2) {
    fillRef(ref3, getTriggerDOMNode ? getTriggerDOMNode(node2) : node2);
  }, [getTriggerDOMNode]);
  var mergedRef = useComposeRef(setRef, getNodeRef(children));
  return canUseRef ? /* @__PURE__ */ React145.cloneElement(children, {
    ref: mergedRef
  }) : children;
});
if (true) {
  TriggerWrapper.displayName = "TriggerWrapper";
}
var TriggerWrapper_default = TriggerWrapper;

// ../../node_modules/@rc-component/trigger/es/context.js
var React146 = __toESM(require_react());
var TriggerContext = /* @__PURE__ */ React146.createContext(null);
var context_default2 = TriggerContext;

// ../../node_modules/@rc-component/trigger/es/hooks/useAction.js
var React147 = __toESM(require_react());
function toArray4(val) {
  return val ? Array.isArray(val) ? val : [val] : [];
}
function useAction(mobile, action, showAction, hideAction) {
  return React147.useMemo(function() {
    var mergedShowAction = toArray4(showAction !== null && showAction !== void 0 ? showAction : action);
    var mergedHideAction = toArray4(hideAction !== null && hideAction !== void 0 ? hideAction : action);
    var showActionSet = new Set(mergedShowAction);
    var hideActionSet = new Set(mergedHideAction);
    if (mobile) {
      if (showActionSet.has("hover")) {
        showActionSet.delete("hover");
        showActionSet.add("click");
      }
      if (hideActionSet.has("hover")) {
        hideActionSet.delete("hover");
        hideActionSet.add("click");
      }
    }
    return [showActionSet, hideActionSet];
  }, [mobile, action, showAction, hideAction]);
}

// ../../node_modules/@rc-component/trigger/es/hooks/useAlign.js
var React148 = __toESM(require_react());

// ../../node_modules/@rc-component/trigger/es/util.js
function isPointsEq() {
  var a1 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  var a2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  var isAlignPoint = arguments.length > 2 ? arguments[2] : void 0;
  if (isAlignPoint) {
    return a1[0] === a2[0];
  }
  return a1[0] === a2[0] && a1[1] === a2[1];
}
function getAlignPopupClassName(builtinPlacements, prefixCls, align, isAlignPoint) {
  var points = align.points;
  var placements4 = Object.keys(builtinPlacements);
  for (var i = 0; i < placements4.length; i += 1) {
    var _builtinPlacements$pl;
    var placement = placements4[i];
    if (isPointsEq((_builtinPlacements$pl = builtinPlacements[placement]) === null || _builtinPlacements$pl === void 0 ? void 0 : _builtinPlacements$pl.points, points, isAlignPoint)) {
      return "".concat(prefixCls, "-placement-").concat(placement);
    }
  }
  return "";
}
function getMotion2(prefixCls, motion2, animation, transitionName) {
  if (motion2) {
    return motion2;
  }
  if (animation) {
    return {
      motionName: "".concat(prefixCls, "-").concat(animation)
    };
  }
  if (transitionName) {
    return {
      motionName: transitionName
    };
  }
  return null;
}
function getWin(ele) {
  return ele.ownerDocument.defaultView;
}
function collectScroller(ele) {
  var scrollerList = [];
  var current2 = ele === null || ele === void 0 ? void 0 : ele.parentElement;
  var scrollStyle = ["hidden", "scroll", "clip", "auto"];
  while (current2) {
    var _getWin$getComputedSt = getWin(current2).getComputedStyle(current2), overflowX = _getWin$getComputedSt.overflowX, overflowY = _getWin$getComputedSt.overflowY, overflow = _getWin$getComputedSt.overflow;
    if ([overflowX, overflowY, overflow].some(function(o3) {
      return scrollStyle.includes(o3);
    })) {
      scrollerList.push(current2);
    }
    current2 = current2.parentElement;
  }
  return scrollerList;
}
function toNum(num) {
  var defaultValue2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  return Number.isNaN(num) ? defaultValue2 : num;
}
function getPxValue(val) {
  return toNum(parseFloat(val), 0);
}
function getVisibleArea(initArea, scrollerList) {
  var visibleArea = _objectSpread2({}, initArea);
  (scrollerList || []).forEach(function(ele) {
    if (ele instanceof HTMLBodyElement || ele instanceof HTMLHtmlElement) {
      return;
    }
    var _getWin$getComputedSt2 = getWin(ele).getComputedStyle(ele), overflow = _getWin$getComputedSt2.overflow, overflowClipMargin = _getWin$getComputedSt2.overflowClipMargin, borderTopWidth = _getWin$getComputedSt2.borderTopWidth, borderBottomWidth = _getWin$getComputedSt2.borderBottomWidth, borderLeftWidth = _getWin$getComputedSt2.borderLeftWidth, borderRightWidth = _getWin$getComputedSt2.borderRightWidth;
    var eleRect = ele.getBoundingClientRect();
    var eleOutHeight = ele.offsetHeight, eleInnerHeight = ele.clientHeight, eleOutWidth = ele.offsetWidth, eleInnerWidth = ele.clientWidth;
    var borderTopNum = getPxValue(borderTopWidth);
    var borderBottomNum = getPxValue(borderBottomWidth);
    var borderLeftNum = getPxValue(borderLeftWidth);
    var borderRightNum = getPxValue(borderRightWidth);
    var scaleX = toNum(Math.round(eleRect.width / eleOutWidth * 1e3) / 1e3);
    var scaleY = toNum(Math.round(eleRect.height / eleOutHeight * 1e3) / 1e3);
    var eleScrollWidth = (eleOutWidth - eleInnerWidth - borderLeftNum - borderRightNum) * scaleX;
    var eleScrollHeight = (eleOutHeight - eleInnerHeight - borderTopNum - borderBottomNum) * scaleY;
    var scaledBorderTopWidth = borderTopNum * scaleY;
    var scaledBorderBottomWidth = borderBottomNum * scaleY;
    var scaledBorderLeftWidth = borderLeftNum * scaleX;
    var scaledBorderRightWidth = borderRightNum * scaleX;
    var clipMarginWidth = 0;
    var clipMarginHeight = 0;
    if (overflow === "clip") {
      var clipNum = getPxValue(overflowClipMargin);
      clipMarginWidth = clipNum * scaleX;
      clipMarginHeight = clipNum * scaleY;
    }
    var eleLeft = eleRect.x + scaledBorderLeftWidth - clipMarginWidth;
    var eleTop = eleRect.y + scaledBorderTopWidth - clipMarginHeight;
    var eleRight = eleLeft + eleRect.width + 2 * clipMarginWidth - scaledBorderLeftWidth - scaledBorderRightWidth - eleScrollWidth;
    var eleBottom = eleTop + eleRect.height + 2 * clipMarginHeight - scaledBorderTopWidth - scaledBorderBottomWidth - eleScrollHeight;
    visibleArea.left = Math.max(visibleArea.left, eleLeft);
    visibleArea.top = Math.max(visibleArea.top, eleTop);
    visibleArea.right = Math.min(visibleArea.right, eleRight);
    visibleArea.bottom = Math.min(visibleArea.bottom, eleBottom);
  });
  return visibleArea;
}

// ../../node_modules/@rc-component/trigger/es/hooks/useAlign.js
function getUnitOffset(size) {
  var offset4 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  var offsetStr = "".concat(offset4);
  var cells = offsetStr.match(/^(.*)\%$/);
  if (cells) {
    return size * (parseFloat(cells[1]) / 100);
  }
  return parseFloat(offsetStr);
}
function getNumberOffset(rect, offset4) {
  var _ref = offset4 || [], _ref2 = _slicedToArray(_ref, 2), offsetX = _ref2[0], offsetY = _ref2[1];
  return [getUnitOffset(rect.width, offsetX), getUnitOffset(rect.height, offsetY)];
}
function splitPoints() {
  var points = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  return [points[0], points[1]];
}
function getAlignPoint(rect, points) {
  var topBottom = points[0];
  var leftRight = points[1];
  var x;
  var y;
  if (topBottom === "t") {
    y = rect.y;
  } else if (topBottom === "b") {
    y = rect.y + rect.height;
  } else {
    y = rect.y + rect.height / 2;
  }
  if (leftRight === "l") {
    x = rect.x;
  } else if (leftRight === "r") {
    x = rect.x + rect.width;
  } else {
    x = rect.x + rect.width / 2;
  }
  return {
    x,
    y
  };
}
function reversePoints(points, index3) {
  var reverseMap = {
    t: "b",
    b: "t",
    l: "r",
    r: "l"
  };
  return points.map(function(point, i) {
    if (i === index3) {
      return reverseMap[point] || "c";
    }
    return point;
  }).join("");
}
function useAlign(open2, popupEle, target, placement, builtinPlacements, popupAlign, onPopupAlign) {
  var _React$useState = React148.useState({
    ready: false,
    offsetX: 0,
    offsetY: 0,
    offsetR: 0,
    offsetB: 0,
    arrowX: 0,
    arrowY: 0,
    scaleX: 1,
    scaleY: 1,
    align: builtinPlacements[placement] || {}
  }), _React$useState2 = _slicedToArray(_React$useState, 2), offsetInfo = _React$useState2[0], setOffsetInfo = _React$useState2[1];
  var alignCountRef = React148.useRef(0);
  var scrollerList = React148.useMemo(function() {
    if (!popupEle) {
      return [];
    }
    return collectScroller(popupEle);
  }, [popupEle]);
  var prevFlipRef = React148.useRef({});
  var resetFlipCache = function resetFlipCache2() {
    prevFlipRef.current = {};
  };
  if (!open2) {
    resetFlipCache();
  }
  var onAlign = useEvent2(function() {
    if (popupEle && target && open2) {
      let getIntersectionVisibleArea = function(offsetX, offsetY) {
        var area = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : visibleArea;
        var l2 = popupRect.x + offsetX;
        var t2 = popupRect.y + offsetY;
        var r2 = l2 + popupWidth;
        var b = t2 + popupHeight;
        var visibleL = Math.max(l2, area.left);
        var visibleT = Math.max(t2, area.top);
        var visibleR = Math.min(r2, area.right);
        var visibleB = Math.min(b, area.bottom);
        return Math.max(0, (visibleR - visibleL) * (visibleB - visibleT));
      }, syncNextPopupPosition = function() {
        nextPopupY = popupRect.y + nextOffsetY;
        nextPopupBottom = nextPopupY + popupHeight;
        nextPopupX = popupRect.x + nextOffsetX;
        nextPopupRight = nextPopupX + popupWidth;
      };
      var _popupElement$parentE, _popupRect$x, _popupRect$y, _popupElement$parentE2;
      var popupElement = popupEle;
      var doc2 = popupElement.ownerDocument;
      var win = getWin(popupElement);
      var _win$getComputedStyle = win.getComputedStyle(popupElement), popupPosition = _win$getComputedStyle.position;
      var originLeft = popupElement.style.left;
      var originTop = popupElement.style.top;
      var originRight = popupElement.style.right;
      var originBottom = popupElement.style.bottom;
      var originOverflow = popupElement.style.overflow;
      var placementInfo = _objectSpread2(_objectSpread2({}, builtinPlacements[placement]), popupAlign);
      var placeholderElement = doc2.createElement("div");
      (_popupElement$parentE = popupElement.parentElement) === null || _popupElement$parentE === void 0 || _popupElement$parentE.appendChild(placeholderElement);
      placeholderElement.style.left = "".concat(popupElement.offsetLeft, "px");
      placeholderElement.style.top = "".concat(popupElement.offsetTop, "px");
      placeholderElement.style.position = popupPosition;
      placeholderElement.style.height = "".concat(popupElement.offsetHeight, "px");
      placeholderElement.style.width = "".concat(popupElement.offsetWidth, "px");
      popupElement.style.left = "0";
      popupElement.style.top = "0";
      popupElement.style.right = "auto";
      popupElement.style.bottom = "auto";
      popupElement.style.overflow = "hidden";
      var targetRect;
      if (Array.isArray(target)) {
        targetRect = {
          x: target[0],
          y: target[1],
          width: 0,
          height: 0
        };
      } else {
        var _rect$x, _rect$y;
        var rect = target.getBoundingClientRect();
        rect.x = (_rect$x = rect.x) !== null && _rect$x !== void 0 ? _rect$x : rect.left;
        rect.y = (_rect$y = rect.y) !== null && _rect$y !== void 0 ? _rect$y : rect.top;
        targetRect = {
          x: rect.x,
          y: rect.y,
          width: rect.width,
          height: rect.height
        };
      }
      var popupRect = popupElement.getBoundingClientRect();
      var _win$getComputedStyle2 = win.getComputedStyle(popupElement), height = _win$getComputedStyle2.height, width = _win$getComputedStyle2.width;
      popupRect.x = (_popupRect$x = popupRect.x) !== null && _popupRect$x !== void 0 ? _popupRect$x : popupRect.left;
      popupRect.y = (_popupRect$y = popupRect.y) !== null && _popupRect$y !== void 0 ? _popupRect$y : popupRect.top;
      var _doc$documentElement = doc2.documentElement, clientWidth = _doc$documentElement.clientWidth, clientHeight = _doc$documentElement.clientHeight, scrollWidth = _doc$documentElement.scrollWidth, scrollHeight = _doc$documentElement.scrollHeight, scrollTop = _doc$documentElement.scrollTop, scrollLeft = _doc$documentElement.scrollLeft;
      var popupHeight = popupRect.height;
      var popupWidth = popupRect.width;
      var targetHeight = targetRect.height;
      var targetWidth = targetRect.width;
      var visibleRegion = {
        left: 0,
        top: 0,
        right: clientWidth,
        bottom: clientHeight
      };
      var scrollRegion = {
        left: -scrollLeft,
        top: -scrollTop,
        right: scrollWidth - scrollLeft,
        bottom: scrollHeight - scrollTop
      };
      var htmlRegion = placementInfo.htmlRegion;
      var VISIBLE = "visible";
      var VISIBLE_FIRST = "visibleFirst";
      if (htmlRegion !== "scroll" && htmlRegion !== VISIBLE_FIRST) {
        htmlRegion = VISIBLE;
      }
      var isVisibleFirst = htmlRegion === VISIBLE_FIRST;
      var scrollRegionArea = getVisibleArea(scrollRegion, scrollerList);
      var visibleRegionArea = getVisibleArea(visibleRegion, scrollerList);
      var visibleArea = htmlRegion === VISIBLE ? visibleRegionArea : scrollRegionArea;
      var adjustCheckVisibleArea = isVisibleFirst ? visibleRegionArea : visibleArea;
      popupElement.style.left = "auto";
      popupElement.style.top = "auto";
      popupElement.style.right = "0";
      popupElement.style.bottom = "0";
      var popupMirrorRect = popupElement.getBoundingClientRect();
      popupElement.style.left = originLeft;
      popupElement.style.top = originTop;
      popupElement.style.right = originRight;
      popupElement.style.bottom = originBottom;
      popupElement.style.overflow = originOverflow;
      (_popupElement$parentE2 = popupElement.parentElement) === null || _popupElement$parentE2 === void 0 || _popupElement$parentE2.removeChild(placeholderElement);
      var _scaleX = toNum(Math.round(popupWidth / parseFloat(width) * 1e3) / 1e3);
      var _scaleY = toNum(Math.round(popupHeight / parseFloat(height) * 1e3) / 1e3);
      if (_scaleX === 0 || _scaleY === 0 || isDOM(target) && !isVisible_default(target)) {
        return;
      }
      var offset4 = placementInfo.offset, targetOffset3 = placementInfo.targetOffset;
      var _getNumberOffset = getNumberOffset(popupRect, offset4), _getNumberOffset2 = _slicedToArray(_getNumberOffset, 2), popupOffsetX = _getNumberOffset2[0], popupOffsetY = _getNumberOffset2[1];
      var _getNumberOffset3 = getNumberOffset(targetRect, targetOffset3), _getNumberOffset4 = _slicedToArray(_getNumberOffset3, 2), targetOffsetX = _getNumberOffset4[0], targetOffsetY = _getNumberOffset4[1];
      targetRect.x -= targetOffsetX;
      targetRect.y -= targetOffsetY;
      var _ref3 = placementInfo.points || [], _ref4 = _slicedToArray(_ref3, 2), popupPoint = _ref4[0], targetPoint = _ref4[1];
      var targetPoints = splitPoints(targetPoint);
      var popupPoints = splitPoints(popupPoint);
      var targetAlignPoint = getAlignPoint(targetRect, targetPoints);
      var popupAlignPoint = getAlignPoint(popupRect, popupPoints);
      var nextAlignInfo = _objectSpread2({}, placementInfo);
      var nextOffsetX = targetAlignPoint.x - popupAlignPoint.x + popupOffsetX;
      var nextOffsetY = targetAlignPoint.y - popupAlignPoint.y + popupOffsetY;
      var originIntersectionVisibleArea = getIntersectionVisibleArea(nextOffsetX, nextOffsetY);
      var originIntersectionRecommendArea = getIntersectionVisibleArea(nextOffsetX, nextOffsetY, visibleRegionArea);
      var targetAlignPointTL = getAlignPoint(targetRect, ["t", "l"]);
      var popupAlignPointTL = getAlignPoint(popupRect, ["t", "l"]);
      var targetAlignPointBR = getAlignPoint(targetRect, ["b", "r"]);
      var popupAlignPointBR = getAlignPoint(popupRect, ["b", "r"]);
      var overflow = placementInfo.overflow || {};
      var adjustX = overflow.adjustX, adjustY = overflow.adjustY, shiftX = overflow.shiftX, shiftY = overflow.shiftY;
      var supportAdjust = function supportAdjust2(val) {
        if (typeof val === "boolean") {
          return val;
        }
        return val >= 0;
      };
      var nextPopupY;
      var nextPopupBottom;
      var nextPopupX;
      var nextPopupRight;
      syncNextPopupPosition();
      var needAdjustY = supportAdjust(adjustY);
      var sameTB = popupPoints[0] === targetPoints[0];
      if (needAdjustY && popupPoints[0] === "t" && (nextPopupBottom > adjustCheckVisibleArea.bottom || prevFlipRef.current.bt)) {
        var tmpNextOffsetY = nextOffsetY;
        if (sameTB) {
          tmpNextOffsetY -= popupHeight - targetHeight;
        } else {
          tmpNextOffsetY = targetAlignPointTL.y - popupAlignPointBR.y - popupOffsetY;
        }
        var newVisibleArea = getIntersectionVisibleArea(nextOffsetX, tmpNextOffsetY);
        var newVisibleRecommendArea = getIntersectionVisibleArea(nextOffsetX, tmpNextOffsetY, visibleRegionArea);
        if (
          // Of course use larger one
          newVisibleArea > originIntersectionVisibleArea || newVisibleArea === originIntersectionVisibleArea && (!isVisibleFirst || // Choose recommend one
          newVisibleRecommendArea >= originIntersectionRecommendArea)
        ) {
          prevFlipRef.current.bt = true;
          nextOffsetY = tmpNextOffsetY;
          popupOffsetY = -popupOffsetY;
          nextAlignInfo.points = [reversePoints(popupPoints, 0), reversePoints(targetPoints, 0)];
        } else {
          prevFlipRef.current.bt = false;
        }
      }
      if (needAdjustY && popupPoints[0] === "b" && (nextPopupY < adjustCheckVisibleArea.top || prevFlipRef.current.tb)) {
        var _tmpNextOffsetY = nextOffsetY;
        if (sameTB) {
          _tmpNextOffsetY += popupHeight - targetHeight;
        } else {
          _tmpNextOffsetY = targetAlignPointBR.y - popupAlignPointTL.y - popupOffsetY;
        }
        var _newVisibleArea = getIntersectionVisibleArea(nextOffsetX, _tmpNextOffsetY);
        var _newVisibleRecommendArea = getIntersectionVisibleArea(nextOffsetX, _tmpNextOffsetY, visibleRegionArea);
        if (
          // Of course use larger one
          _newVisibleArea > originIntersectionVisibleArea || _newVisibleArea === originIntersectionVisibleArea && (!isVisibleFirst || // Choose recommend one
          _newVisibleRecommendArea >= originIntersectionRecommendArea)
        ) {
          prevFlipRef.current.tb = true;
          nextOffsetY = _tmpNextOffsetY;
          popupOffsetY = -popupOffsetY;
          nextAlignInfo.points = [reversePoints(popupPoints, 0), reversePoints(targetPoints, 0)];
        } else {
          prevFlipRef.current.tb = false;
        }
      }
      var needAdjustX = supportAdjust(adjustX);
      var sameLR = popupPoints[1] === targetPoints[1];
      if (needAdjustX && popupPoints[1] === "l" && (nextPopupRight > adjustCheckVisibleArea.right || prevFlipRef.current.rl)) {
        var tmpNextOffsetX = nextOffsetX;
        if (sameLR) {
          tmpNextOffsetX -= popupWidth - targetWidth;
        } else {
          tmpNextOffsetX = targetAlignPointTL.x - popupAlignPointBR.x - popupOffsetX;
        }
        var _newVisibleArea2 = getIntersectionVisibleArea(tmpNextOffsetX, nextOffsetY);
        var _newVisibleRecommendArea2 = getIntersectionVisibleArea(tmpNextOffsetX, nextOffsetY, visibleRegionArea);
        if (
          // Of course use larger one
          _newVisibleArea2 > originIntersectionVisibleArea || _newVisibleArea2 === originIntersectionVisibleArea && (!isVisibleFirst || // Choose recommend one
          _newVisibleRecommendArea2 >= originIntersectionRecommendArea)
        ) {
          prevFlipRef.current.rl = true;
          nextOffsetX = tmpNextOffsetX;
          popupOffsetX = -popupOffsetX;
          nextAlignInfo.points = [reversePoints(popupPoints, 1), reversePoints(targetPoints, 1)];
        } else {
          prevFlipRef.current.rl = false;
        }
      }
      if (needAdjustX && popupPoints[1] === "r" && (nextPopupX < adjustCheckVisibleArea.left || prevFlipRef.current.lr)) {
        var _tmpNextOffsetX = nextOffsetX;
        if (sameLR) {
          _tmpNextOffsetX += popupWidth - targetWidth;
        } else {
          _tmpNextOffsetX = targetAlignPointBR.x - popupAlignPointTL.x - popupOffsetX;
        }
        var _newVisibleArea3 = getIntersectionVisibleArea(_tmpNextOffsetX, nextOffsetY);
        var _newVisibleRecommendArea3 = getIntersectionVisibleArea(_tmpNextOffsetX, nextOffsetY, visibleRegionArea);
        if (
          // Of course use larger one
          _newVisibleArea3 > originIntersectionVisibleArea || _newVisibleArea3 === originIntersectionVisibleArea && (!isVisibleFirst || // Choose recommend one
          _newVisibleRecommendArea3 >= originIntersectionRecommendArea)
        ) {
          prevFlipRef.current.lr = true;
          nextOffsetX = _tmpNextOffsetX;
          popupOffsetX = -popupOffsetX;
          nextAlignInfo.points = [reversePoints(popupPoints, 1), reversePoints(targetPoints, 1)];
        } else {
          prevFlipRef.current.lr = false;
        }
      }
      syncNextPopupPosition();
      var numShiftX = shiftX === true ? 0 : shiftX;
      if (typeof numShiftX === "number") {
        if (nextPopupX < visibleRegionArea.left) {
          nextOffsetX -= nextPopupX - visibleRegionArea.left - popupOffsetX;
          if (targetRect.x + targetWidth < visibleRegionArea.left + numShiftX) {
            nextOffsetX += targetRect.x - visibleRegionArea.left + targetWidth - numShiftX;
          }
        }
        if (nextPopupRight > visibleRegionArea.right) {
          nextOffsetX -= nextPopupRight - visibleRegionArea.right - popupOffsetX;
          if (targetRect.x > visibleRegionArea.right - numShiftX) {
            nextOffsetX += targetRect.x - visibleRegionArea.right + numShiftX;
          }
        }
      }
      var numShiftY = shiftY === true ? 0 : shiftY;
      if (typeof numShiftY === "number") {
        if (nextPopupY < visibleRegionArea.top) {
          nextOffsetY -= nextPopupY - visibleRegionArea.top - popupOffsetY;
          if (targetRect.y + targetHeight < visibleRegionArea.top + numShiftY) {
            nextOffsetY += targetRect.y - visibleRegionArea.top + targetHeight - numShiftY;
          }
        }
        if (nextPopupBottom > visibleRegionArea.bottom) {
          nextOffsetY -= nextPopupBottom - visibleRegionArea.bottom - popupOffsetY;
          if (targetRect.y > visibleRegionArea.bottom - numShiftY) {
            nextOffsetY += targetRect.y - visibleRegionArea.bottom + numShiftY;
          }
        }
      }
      var popupLeft = popupRect.x + nextOffsetX;
      var popupRight = popupLeft + popupWidth;
      var popupTop = popupRect.y + nextOffsetY;
      var popupBottom = popupTop + popupHeight;
      var targetLeft = targetRect.x;
      var targetRight = targetLeft + targetWidth;
      var targetTop = targetRect.y;
      var targetBottom = targetTop + targetHeight;
      var maxLeft = Math.max(popupLeft, targetLeft);
      var minRight = Math.min(popupRight, targetRight);
      var xCenter = (maxLeft + minRight) / 2;
      var nextArrowX = xCenter - popupLeft;
      var maxTop = Math.max(popupTop, targetTop);
      var minBottom = Math.min(popupBottom, targetBottom);
      var yCenter = (maxTop + minBottom) / 2;
      var nextArrowY = yCenter - popupTop;
      onPopupAlign === null || onPopupAlign === void 0 || onPopupAlign(popupEle, nextAlignInfo);
      var offsetX4Right = popupMirrorRect.right - popupRect.x - (nextOffsetX + popupRect.width);
      var offsetY4Bottom = popupMirrorRect.bottom - popupRect.y - (nextOffsetY + popupRect.height);
      if (_scaleX === 1) {
        nextOffsetX = Math.round(nextOffsetX);
        offsetX4Right = Math.round(offsetX4Right);
      }
      if (_scaleY === 1) {
        nextOffsetY = Math.round(nextOffsetY);
        offsetY4Bottom = Math.round(offsetY4Bottom);
      }
      var nextOffsetInfo = {
        ready: true,
        offsetX: nextOffsetX / _scaleX,
        offsetY: nextOffsetY / _scaleY,
        offsetR: offsetX4Right / _scaleX,
        offsetB: offsetY4Bottom / _scaleY,
        arrowX: nextArrowX / _scaleX,
        arrowY: nextArrowY / _scaleY,
        scaleX: _scaleX,
        scaleY: _scaleY,
        align: nextAlignInfo
      };
      setOffsetInfo(nextOffsetInfo);
    }
  });
  var triggerAlign = function triggerAlign2() {
    alignCountRef.current += 1;
    var id = alignCountRef.current;
    Promise.resolve().then(function() {
      if (alignCountRef.current === id) {
        onAlign();
      }
    });
  };
  var resetReady = function resetReady2() {
    setOffsetInfo(function(ori) {
      return _objectSpread2(_objectSpread2({}, ori), {}, {
        ready: false
      });
    });
  };
  useLayoutEffect_default(resetReady, [placement]);
  useLayoutEffect_default(function() {
    if (!open2) {
      resetReady();
    }
  }, [open2]);
  return [offsetInfo.ready, offsetInfo.offsetX, offsetInfo.offsetY, offsetInfo.offsetR, offsetInfo.offsetB, offsetInfo.arrowX, offsetInfo.arrowY, offsetInfo.scaleX, offsetInfo.scaleY, offsetInfo.align, triggerAlign];
}

// ../../node_modules/@rc-component/trigger/es/hooks/useWatch.js
function useWatch2(open2, target, popup, onAlign, onScroll) {
  useLayoutEffect_default(function() {
    if (open2 && target && popup) {
      let notifyScroll = function() {
        onAlign();
        onScroll();
      };
      var targetElement = target;
      var popupElement = popup;
      var targetScrollList = collectScroller(targetElement);
      var popupScrollList = collectScroller(popupElement);
      var win = getWin(popupElement);
      var mergedList = new Set([win].concat(_toConsumableArray(targetScrollList), _toConsumableArray(popupScrollList)));
      mergedList.forEach(function(scroller) {
        scroller.addEventListener("scroll", notifyScroll, {
          passive: true
        });
      });
      win.addEventListener("resize", notifyScroll, {
        passive: true
      });
      onAlign();
      return function() {
        mergedList.forEach(function(scroller) {
          scroller.removeEventListener("scroll", notifyScroll);
          win.removeEventListener("resize", notifyScroll);
        });
      };
    }
  }, [open2, target, popup]);
}

// ../../node_modules/@rc-component/trigger/es/hooks/useWinClick.js
var React149 = __toESM(require_react());
function useWinClick(open2, clickToHide, targetEle, popupEle, mask, maskClosable, inPopupOrChild, triggerOpen) {
  var openRef = React149.useRef(open2);
  openRef.current = open2;
  var popupPointerDownRef = React149.useRef(false);
  React149.useEffect(function() {
    if (clickToHide && popupEle && (!mask || maskClosable)) {
      var onPointerDown = function onPointerDown2() {
        popupPointerDownRef.current = false;
      };
      var onTriggerClose = function onTriggerClose2(e3) {
        var _e$composedPath;
        if (openRef.current && !inPopupOrChild(((_e$composedPath = e3.composedPath) === null || _e$composedPath === void 0 || (_e$composedPath = _e$composedPath.call(e3)) === null || _e$composedPath === void 0 ? void 0 : _e$composedPath[0]) || e3.target) && !popupPointerDownRef.current) {
          triggerOpen(false);
        }
      };
      var win = getWin(popupEle);
      win.addEventListener("pointerdown", onPointerDown, true);
      win.addEventListener("mousedown", onTriggerClose, true);
      win.addEventListener("contextmenu", onTriggerClose, true);
      var targetShadowRoot = getShadowRoot(targetEle);
      if (targetShadowRoot) {
        targetShadowRoot.addEventListener("mousedown", onTriggerClose, true);
        targetShadowRoot.addEventListener("contextmenu", onTriggerClose, true);
      }
      if (true) {
        var _targetEle$getRootNod, _popupEle$getRootNode;
        var targetRoot = targetEle === null || targetEle === void 0 || (_targetEle$getRootNod = targetEle.getRootNode) === null || _targetEle$getRootNod === void 0 ? void 0 : _targetEle$getRootNod.call(targetEle);
        var popupRoot = (_popupEle$getRootNode = popupEle.getRootNode) === null || _popupEle$getRootNode === void 0 ? void 0 : _popupEle$getRootNode.call(popupEle);
        warning(targetRoot === popupRoot, "trigger element and popup element should in same shadow root.");
      }
      return function() {
        win.removeEventListener("pointerdown", onPointerDown, true);
        win.removeEventListener("mousedown", onTriggerClose, true);
        win.removeEventListener("contextmenu", onTriggerClose, true);
        if (targetShadowRoot) {
          targetShadowRoot.removeEventListener("mousedown", onTriggerClose, true);
          targetShadowRoot.removeEventListener("contextmenu", onTriggerClose, true);
        }
      };
    }
  }, [clickToHide, targetEle, popupEle, mask, maskClosable]);
  function onPopupPointerDown() {
    popupPointerDownRef.current = true;
  }
  return onPopupPointerDown;
}

// ../../node_modules/@rc-component/trigger/es/index.js
var _excluded17 = ["prefixCls", "children", "action", "showAction", "hideAction", "popupVisible", "defaultPopupVisible", "onPopupVisibleChange", "afterPopupVisibleChange", "mouseEnterDelay", "mouseLeaveDelay", "focusDelay", "blurDelay", "mask", "maskClosable", "getPopupContainer", "forceRender", "autoDestroy", "destroyPopupOnHide", "popup", "popupClassName", "popupStyle", "popupPlacement", "builtinPlacements", "popupAlign", "zIndex", "stretch", "getPopupClassNameFromAlign", "fresh", "alignPoint", "onPopupClick", "onPopupAlign", "arrow", "popupMotion", "maskMotion", "popupTransitionName", "popupAnimation", "maskTransitionName", "maskAnimation", "className", "getTriggerDOMNode"];
function generateTrigger() {
  var PortalComponent = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : es_default4;
  var Trigger = /* @__PURE__ */ React150.forwardRef(function(props, ref3) {
    var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-trigger-popup" : _props$prefixCls, children = props.children, _props$action = props.action, action = _props$action === void 0 ? "hover" : _props$action, showAction = props.showAction, hideAction = props.hideAction, popupVisible = props.popupVisible, defaultPopupVisible = props.defaultPopupVisible, onPopupVisibleChange = props.onPopupVisibleChange, afterPopupVisibleChange = props.afterPopupVisibleChange, mouseEnterDelay = props.mouseEnterDelay, _props$mouseLeaveDela = props.mouseLeaveDelay, mouseLeaveDelay = _props$mouseLeaveDela === void 0 ? 0.1 : _props$mouseLeaveDela, focusDelay = props.focusDelay, blurDelay = props.blurDelay, mask = props.mask, _props$maskClosable = props.maskClosable, maskClosable = _props$maskClosable === void 0 ? true : _props$maskClosable, getPopupContainer = props.getPopupContainer, forceRender = props.forceRender, autoDestroy = props.autoDestroy, destroyPopupOnHide = props.destroyPopupOnHide, popup = props.popup, popupClassName = props.popupClassName, popupStyle = props.popupStyle, popupPlacement = props.popupPlacement, _props$builtinPlaceme = props.builtinPlacements, builtinPlacements = _props$builtinPlaceme === void 0 ? {} : _props$builtinPlaceme, popupAlign = props.popupAlign, zIndex = props.zIndex, stretch = props.stretch, getPopupClassNameFromAlign = props.getPopupClassNameFromAlign, fresh = props.fresh, alignPoint = props.alignPoint, onPopupClick = props.onPopupClick, onPopupAlign = props.onPopupAlign, arrow = props.arrow, popupMotion = props.popupMotion, maskMotion = props.maskMotion, popupTransitionName = props.popupTransitionName, popupAnimation = props.popupAnimation, maskTransitionName = props.maskTransitionName, maskAnimation = props.maskAnimation, className2 = props.className, getTriggerDOMNode = props.getTriggerDOMNode, restProps = _objectWithoutProperties(props, _excluded17);
    var mergedAutoDestroy = autoDestroy || destroyPopupOnHide || false;
    var _React$useState = React150.useState(false), _React$useState2 = _slicedToArray(_React$useState, 2), mobile = _React$useState2[0], setMobile = _React$useState2[1];
    useLayoutEffect_default(function() {
      setMobile(isMobile_default());
    }, []);
    var subPopupElements = React150.useRef({});
    var parentContext = React150.useContext(context_default2);
    var context = React150.useMemo(function() {
      return {
        registerSubPopup: function registerSubPopup(id2, subPopupEle) {
          subPopupElements.current[id2] = subPopupEle;
          parentContext === null || parentContext === void 0 || parentContext.registerSubPopup(id2, subPopupEle);
        }
      };
    }, [parentContext]);
    var id = useId_default();
    var _React$useState3 = React150.useState(null), _React$useState4 = _slicedToArray(_React$useState3, 2), popupEle = _React$useState4[0], setPopupEle = _React$useState4[1];
    var externalPopupRef = React150.useRef(null);
    var setPopupRef = useEvent2(function(node2) {
      externalPopupRef.current = node2;
      if (isDOM(node2) && popupEle !== node2) {
        setPopupEle(node2);
      }
      parentContext === null || parentContext === void 0 || parentContext.registerSubPopup(id, node2);
    });
    var _React$useState5 = React150.useState(null), _React$useState6 = _slicedToArray(_React$useState5, 2), targetEle = _React$useState6[0], setTargetEle = _React$useState6[1];
    var externalForwardRef = React150.useRef(null);
    var setTargetRef = useEvent2(function(node2) {
      if (isDOM(node2) && targetEle !== node2) {
        setTargetEle(node2);
        externalForwardRef.current = node2;
      }
    });
    var child = React150.Children.only(children);
    var originChildProps = (child === null || child === void 0 ? void 0 : child.props) || {};
    var cloneProps = {};
    var inPopupOrChild = useEvent2(function(ele) {
      var _getShadowRoot, _getShadowRoot2;
      var childDOM = targetEle;
      return (childDOM === null || childDOM === void 0 ? void 0 : childDOM.contains(ele)) || ((_getShadowRoot = getShadowRoot(childDOM)) === null || _getShadowRoot === void 0 ? void 0 : _getShadowRoot.host) === ele || ele === childDOM || (popupEle === null || popupEle === void 0 ? void 0 : popupEle.contains(ele)) || ((_getShadowRoot2 = getShadowRoot(popupEle)) === null || _getShadowRoot2 === void 0 ? void 0 : _getShadowRoot2.host) === ele || ele === popupEle || Object.values(subPopupElements.current).some(function(subPopupEle) {
        return (subPopupEle === null || subPopupEle === void 0 ? void 0 : subPopupEle.contains(ele)) || ele === subPopupEle;
      });
    });
    var mergePopupMotion = getMotion2(prefixCls, popupMotion, popupAnimation, popupTransitionName);
    var mergeMaskMotion = getMotion2(prefixCls, maskMotion, maskAnimation, maskTransitionName);
    var _React$useState7 = React150.useState(defaultPopupVisible || false), _React$useState8 = _slicedToArray(_React$useState7, 2), internalOpen = _React$useState8[0], setInternalOpen = _React$useState8[1];
    var mergedOpen = popupVisible !== null && popupVisible !== void 0 ? popupVisible : internalOpen;
    var setMergedOpen = useEvent2(function(nextOpen) {
      if (popupVisible === void 0) {
        setInternalOpen(nextOpen);
      }
    });
    useLayoutEffect_default(function() {
      setInternalOpen(popupVisible || false);
    }, [popupVisible]);
    var openRef = React150.useRef(mergedOpen);
    openRef.current = mergedOpen;
    var lastTriggerRef = React150.useRef([]);
    lastTriggerRef.current = [];
    var internalTriggerOpen = useEvent2(function(nextOpen) {
      var _lastTriggerRef$curre;
      setMergedOpen(nextOpen);
      if (((_lastTriggerRef$curre = lastTriggerRef.current[lastTriggerRef.current.length - 1]) !== null && _lastTriggerRef$curre !== void 0 ? _lastTriggerRef$curre : mergedOpen) !== nextOpen) {
        lastTriggerRef.current.push(nextOpen);
        onPopupVisibleChange === null || onPopupVisibleChange === void 0 || onPopupVisibleChange(nextOpen);
      }
    });
    var delayRef = React150.useRef();
    var clearDelay = function clearDelay2() {
      clearTimeout(delayRef.current);
    };
    var triggerOpen = function triggerOpen2(nextOpen) {
      var delay = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
      clearDelay();
      if (delay === 0) {
        internalTriggerOpen(nextOpen);
      } else {
        delayRef.current = setTimeout(function() {
          internalTriggerOpen(nextOpen);
        }, delay * 1e3);
      }
    };
    React150.useEffect(function() {
      return clearDelay;
    }, []);
    var _React$useState9 = React150.useState(false), _React$useState10 = _slicedToArray(_React$useState9, 2), inMotion = _React$useState10[0], setInMotion = _React$useState10[1];
    useLayoutEffect_default(function(firstMount) {
      if (!firstMount || mergedOpen) {
        setInMotion(true);
      }
    }, [mergedOpen]);
    var _React$useState11 = React150.useState(null), _React$useState12 = _slicedToArray(_React$useState11, 2), motionPrepareResolve = _React$useState12[0], setMotionPrepareResolve = _React$useState12[1];
    var _React$useState13 = React150.useState(null), _React$useState14 = _slicedToArray(_React$useState13, 2), mousePos = _React$useState14[0], setMousePos = _React$useState14[1];
    var setMousePosByEvent = function setMousePosByEvent2(event) {
      setMousePos([event.clientX, event.clientY]);
    };
    var _useAlign = useAlign(mergedOpen, popupEle, alignPoint && mousePos !== null ? mousePos : targetEle, popupPlacement, builtinPlacements, popupAlign, onPopupAlign), _useAlign2 = _slicedToArray(_useAlign, 11), ready = _useAlign2[0], offsetX = _useAlign2[1], offsetY = _useAlign2[2], offsetR = _useAlign2[3], offsetB = _useAlign2[4], arrowX = _useAlign2[5], arrowY = _useAlign2[6], scaleX = _useAlign2[7], scaleY = _useAlign2[8], alignInfo = _useAlign2[9], onAlign = _useAlign2[10];
    var _useAction = useAction(mobile, action, showAction, hideAction), _useAction2 = _slicedToArray(_useAction, 2), showActions = _useAction2[0], hideActions = _useAction2[1];
    var clickToShow = showActions.has("click");
    var clickToHide = hideActions.has("click") || hideActions.has("contextMenu");
    var triggerAlign = useEvent2(function() {
      if (!inMotion) {
        onAlign();
      }
    });
    var onScroll = function onScroll2() {
      if (openRef.current && alignPoint && clickToHide) {
        triggerOpen(false);
      }
    };
    useWatch2(mergedOpen, targetEle, popupEle, triggerAlign, onScroll);
    useLayoutEffect_default(function() {
      triggerAlign();
    }, [mousePos, popupPlacement]);
    useLayoutEffect_default(function() {
      if (mergedOpen && !(builtinPlacements !== null && builtinPlacements !== void 0 && builtinPlacements[popupPlacement])) {
        triggerAlign();
      }
    }, [JSON.stringify(popupAlign)]);
    var alignedClassName = React150.useMemo(function() {
      var baseClassName2 = getAlignPopupClassName(builtinPlacements, prefixCls, alignInfo, alignPoint);
      return (0, import_classnames46.default)(baseClassName2, getPopupClassNameFromAlign === null || getPopupClassNameFromAlign === void 0 ? void 0 : getPopupClassNameFromAlign(alignInfo));
    }, [alignInfo, getPopupClassNameFromAlign, builtinPlacements, prefixCls, alignPoint]);
    React150.useImperativeHandle(ref3, function() {
      return {
        nativeElement: externalForwardRef.current,
        popupElement: externalPopupRef.current,
        forceAlign: triggerAlign
      };
    });
    var _React$useState15 = React150.useState(0), _React$useState16 = _slicedToArray(_React$useState15, 2), targetWidth = _React$useState16[0], setTargetWidth = _React$useState16[1];
    var _React$useState17 = React150.useState(0), _React$useState18 = _slicedToArray(_React$useState17, 2), targetHeight = _React$useState18[0], setTargetHeight = _React$useState18[1];
    var syncTargetSize = function syncTargetSize2() {
      if (stretch && targetEle) {
        var rect = targetEle.getBoundingClientRect();
        setTargetWidth(rect.width);
        setTargetHeight(rect.height);
      }
    };
    var onTargetResize = function onTargetResize2() {
      syncTargetSize();
      triggerAlign();
    };
    var onVisibleChanged = function onVisibleChanged2(visible) {
      setInMotion(false);
      onAlign();
      afterPopupVisibleChange === null || afterPopupVisibleChange === void 0 || afterPopupVisibleChange(visible);
    };
    var onPrepare = function onPrepare2() {
      return new Promise(function(resolve) {
        syncTargetSize();
        setMotionPrepareResolve(function() {
          return resolve;
        });
      });
    };
    useLayoutEffect_default(function() {
      if (motionPrepareResolve) {
        onAlign();
        motionPrepareResolve();
        setMotionPrepareResolve(null);
      }
    }, [motionPrepareResolve]);
    function wrapperAction(eventName, nextOpen, delay, preEvent) {
      cloneProps[eventName] = function(event) {
        var _originChildProps$eve;
        preEvent === null || preEvent === void 0 || preEvent(event);
        triggerOpen(nextOpen, delay);
        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }
        (_originChildProps$eve = originChildProps[eventName]) === null || _originChildProps$eve === void 0 || _originChildProps$eve.call.apply(_originChildProps$eve, [originChildProps, event].concat(args));
      };
    }
    if (clickToShow || clickToHide) {
      cloneProps.onClick = function(event) {
        var _originChildProps$onC;
        if (openRef.current && clickToHide) {
          triggerOpen(false);
        } else if (!openRef.current && clickToShow) {
          setMousePosByEvent(event);
          triggerOpen(true);
        }
        for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }
        (_originChildProps$onC = originChildProps.onClick) === null || _originChildProps$onC === void 0 || _originChildProps$onC.call.apply(_originChildProps$onC, [originChildProps, event].concat(args));
      };
    }
    var onPopupPointerDown = useWinClick(mergedOpen, clickToHide, targetEle, popupEle, mask, maskClosable, inPopupOrChild, triggerOpen);
    var hoverToShow = showActions.has("hover");
    var hoverToHide = hideActions.has("hover");
    var onPopupMouseEnter;
    var onPopupMouseLeave;
    if (hoverToShow) {
      wrapperAction("onMouseEnter", true, mouseEnterDelay, function(event) {
        setMousePosByEvent(event);
      });
      wrapperAction("onPointerEnter", true, mouseEnterDelay, function(event) {
        setMousePosByEvent(event);
      });
      onPopupMouseEnter = function onPopupMouseEnter2(event) {
        if ((mergedOpen || inMotion) && popupEle !== null && popupEle !== void 0 && popupEle.contains(event.target)) {
          triggerOpen(true, mouseEnterDelay);
        }
      };
      if (alignPoint) {
        cloneProps.onMouseMove = function(event) {
          var _originChildProps$onM;
          (_originChildProps$onM = originChildProps.onMouseMove) === null || _originChildProps$onM === void 0 || _originChildProps$onM.call(originChildProps, event);
        };
      }
    }
    if (hoverToHide) {
      wrapperAction("onMouseLeave", false, mouseLeaveDelay);
      wrapperAction("onPointerLeave", false, mouseLeaveDelay);
      onPopupMouseLeave = function onPopupMouseLeave2() {
        triggerOpen(false, mouseLeaveDelay);
      };
    }
    if (showActions.has("focus")) {
      wrapperAction("onFocus", true, focusDelay);
    }
    if (hideActions.has("focus")) {
      wrapperAction("onBlur", false, blurDelay);
    }
    if (showActions.has("contextMenu")) {
      cloneProps.onContextMenu = function(event) {
        var _originChildProps$onC2;
        if (openRef.current && hideActions.has("contextMenu")) {
          triggerOpen(false);
        } else {
          setMousePosByEvent(event);
          triggerOpen(true);
        }
        event.preventDefault();
        for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
          args[_key3 - 1] = arguments[_key3];
        }
        (_originChildProps$onC2 = originChildProps.onContextMenu) === null || _originChildProps$onC2 === void 0 || _originChildProps$onC2.call.apply(_originChildProps$onC2, [originChildProps, event].concat(args));
      };
    }
    if (className2) {
      cloneProps.className = (0, import_classnames46.default)(originChildProps.className, className2);
    }
    var renderedRef = React150.useRef(false);
    renderedRef.current || (renderedRef.current = forceRender || mergedOpen || inMotion);
    var mergedChildrenProps = _objectSpread2(_objectSpread2({}, originChildProps), cloneProps);
    var passedProps = {};
    var passedEventList = ["onContextMenu", "onClick", "onMouseDown", "onTouchStart", "onMouseEnter", "onMouseLeave", "onFocus", "onBlur"];
    passedEventList.forEach(function(eventName) {
      if (restProps[eventName]) {
        passedProps[eventName] = function() {
          var _mergedChildrenProps$;
          for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
            args[_key4] = arguments[_key4];
          }
          (_mergedChildrenProps$ = mergedChildrenProps[eventName]) === null || _mergedChildrenProps$ === void 0 || _mergedChildrenProps$.call.apply(_mergedChildrenProps$, [mergedChildrenProps].concat(args));
          restProps[eventName].apply(restProps, args);
        };
      }
    });
    var triggerNode = /* @__PURE__ */ React150.cloneElement(child, _objectSpread2(_objectSpread2({}, mergedChildrenProps), passedProps));
    var arrowPos = {
      x: arrowX,
      y: arrowY
    };
    var innerArrow = arrow ? _objectSpread2({}, arrow !== true ? arrow : {}) : null;
    return /* @__PURE__ */ React150.createElement(React150.Fragment, null, /* @__PURE__ */ React150.createElement(es_default, {
      disabled: !mergedOpen,
      ref: setTargetRef,
      onResize: onTargetResize
    }, /* @__PURE__ */ React150.createElement(TriggerWrapper_default, {
      getTriggerDOMNode
    }, triggerNode)), renderedRef.current && /* @__PURE__ */ React150.createElement(context_default2.Provider, {
      value: context
    }, /* @__PURE__ */ React150.createElement(Popup_default, {
      portal: PortalComponent,
      ref: setPopupRef,
      prefixCls,
      popup,
      className: (0, import_classnames46.default)(popupClassName, alignedClassName),
      style: popupStyle,
      target: targetEle,
      onMouseEnter: onPopupMouseEnter,
      onMouseLeave: onPopupMouseLeave,
      onPointerEnter: onPopupMouseEnter,
      zIndex,
      open: mergedOpen,
      keepDom: inMotion,
      fresh,
      onClick: onPopupClick,
      onPointerDownCapture: onPopupPointerDown,
      mask,
      motion: mergePopupMotion,
      maskMotion: mergeMaskMotion,
      onVisibleChanged,
      onPrepare,
      forceRender,
      autoDestroy: mergedAutoDestroy,
      getPopupContainer,
      align: alignInfo,
      arrow: innerArrow,
      arrowPos,
      ready,
      offsetX,
      offsetY,
      offsetR,
      offsetB,
      onAlign: triggerAlign,
      stretch,
      targetWidth: targetWidth / scaleX,
      targetHeight: targetHeight / scaleY
    })));
  });
  if (true) {
    Trigger.displayName = "Trigger";
  }
  return Trigger;
}
var es_default9 = generateTrigger(es_default4);

// ../../node_modules/rc-select/es/SelectTrigger.js
var import_classnames47 = __toESM(require_classnames());
var React151 = __toESM(require_react());
var _excluded18 = ["prefixCls", "disabled", "visible", "children", "popupElement", "animation", "transitionName", "dropdownStyle", "dropdownClassName", "direction", "placement", "builtinPlacements", "dropdownMatchSelectWidth", "dropdownRender", "dropdownAlign", "getPopupContainer", "empty", "getTriggerDOMNode", "onPopupVisibleChange", "onPopupMouseEnter"];
var getBuiltInPlacements = function getBuiltInPlacements2(dropdownMatchSelectWidth) {
  var adjustX = dropdownMatchSelectWidth === true ? 0 : 1;
  return {
    bottomLeft: {
      points: ["tl", "bl"],
      offset: [0, 4],
      overflow: {
        adjustX,
        adjustY: 1
      },
      htmlRegion: "scroll"
    },
    bottomRight: {
      points: ["tr", "br"],
      offset: [0, 4],
      overflow: {
        adjustX,
        adjustY: 1
      },
      htmlRegion: "scroll"
    },
    topLeft: {
      points: ["bl", "tl"],
      offset: [0, -4],
      overflow: {
        adjustX,
        adjustY: 1
      },
      htmlRegion: "scroll"
    },
    topRight: {
      points: ["br", "tr"],
      offset: [0, -4],
      overflow: {
        adjustX,
        adjustY: 1
      },
      htmlRegion: "scroll"
    }
  };
};
var SelectTrigger = function SelectTrigger2(props, ref3) {
  var prefixCls = props.prefixCls, disabled = props.disabled, visible = props.visible, children = props.children, popupElement = props.popupElement, animation = props.animation, transitionName = props.transitionName, dropdownStyle = props.dropdownStyle, dropdownClassName = props.dropdownClassName, _props$direction = props.direction, direction = _props$direction === void 0 ? "ltr" : _props$direction, placement = props.placement, builtinPlacements = props.builtinPlacements, dropdownMatchSelectWidth = props.dropdownMatchSelectWidth, dropdownRender = props.dropdownRender, dropdownAlign = props.dropdownAlign, getPopupContainer = props.getPopupContainer, empty3 = props.empty, getTriggerDOMNode = props.getTriggerDOMNode, onPopupVisibleChange = props.onPopupVisibleChange, onPopupMouseEnter = props.onPopupMouseEnter, restProps = _objectWithoutProperties(props, _excluded18);
  var dropdownPrefixCls = "".concat(prefixCls, "-dropdown");
  var popupNode = popupElement;
  if (dropdownRender) {
    popupNode = dropdownRender(popupElement);
  }
  var mergedBuiltinPlacements2 = React151.useMemo(function() {
    return builtinPlacements || getBuiltInPlacements(dropdownMatchSelectWidth);
  }, [builtinPlacements, dropdownMatchSelectWidth]);
  var mergedTransitionName = animation ? "".concat(dropdownPrefixCls, "-").concat(animation) : transitionName;
  var isNumberPopupWidth = typeof dropdownMatchSelectWidth === "number";
  var stretch = React151.useMemo(function() {
    if (isNumberPopupWidth) {
      return null;
    }
    return dropdownMatchSelectWidth === false ? "minWidth" : "width";
  }, [dropdownMatchSelectWidth, isNumberPopupWidth]);
  var popupStyle = dropdownStyle;
  if (isNumberPopupWidth) {
    popupStyle = _objectSpread2(_objectSpread2({}, popupStyle), {}, {
      width: dropdownMatchSelectWidth
    });
  }
  var triggerPopupRef = React151.useRef(null);
  React151.useImperativeHandle(ref3, function() {
    return {
      getPopupElement: function getPopupElement() {
        var _triggerPopupRef$curr;
        return (_triggerPopupRef$curr = triggerPopupRef.current) === null || _triggerPopupRef$curr === void 0 ? void 0 : _triggerPopupRef$curr.popupElement;
      }
    };
  });
  return /* @__PURE__ */ React151.createElement(es_default9, _extends({}, restProps, {
    showAction: onPopupVisibleChange ? ["click"] : [],
    hideAction: onPopupVisibleChange ? ["click"] : [],
    popupPlacement: placement || (direction === "rtl" ? "bottomRight" : "bottomLeft"),
    builtinPlacements: mergedBuiltinPlacements2,
    prefixCls: dropdownPrefixCls,
    popupTransitionName: mergedTransitionName,
    popup: /* @__PURE__ */ React151.createElement("div", {
      onMouseEnter: onPopupMouseEnter
    }, popupNode),
    ref: triggerPopupRef,
    stretch,
    popupAlign: dropdownAlign,
    popupVisible: visible,
    getPopupContainer,
    popupClassName: (0, import_classnames47.default)(dropdownClassName, _defineProperty({}, "".concat(dropdownPrefixCls, "-empty"), empty3)),
    popupStyle,
    getTriggerDOMNode,
    onPopupVisibleChange
  }), children);
};
var RefSelectTrigger = /* @__PURE__ */ React151.forwardRef(SelectTrigger);
if (true) {
  RefSelectTrigger.displayName = "SelectTrigger";
}
var SelectTrigger_default = RefSelectTrigger;

// ../../node_modules/rc-select/es/utils/valueUtil.js
function getKey2(data2, index3) {
  var key2 = data2.key;
  var value;
  if ("value" in data2) {
    value = data2.value;
  }
  if (key2 !== null && key2 !== void 0) {
    return key2;
  }
  if (value !== void 0) {
    return value;
  }
  return "rc-index-key-".concat(index3);
}
function isValidCount(value) {
  return typeof value !== "undefined" && !Number.isNaN(value);
}
function fillFieldNames(fieldNames, childrenAsData) {
  var _ref = fieldNames || {}, label = _ref.label, value = _ref.value, options = _ref.options, groupLabel = _ref.groupLabel;
  var mergedLabel = label || (childrenAsData ? "children" : "label");
  return {
    label: mergedLabel,
    value: value || "value",
    options: options || "options",
    groupLabel: groupLabel || mergedLabel
  };
}
function flattenOptions(options) {
  var _ref2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, fieldNames = _ref2.fieldNames, childrenAsData = _ref2.childrenAsData;
  var flattenList = [];
  var _fillFieldNames = fillFieldNames(fieldNames, false), fieldLabel = _fillFieldNames.label, fieldValue = _fillFieldNames.value, fieldOptions = _fillFieldNames.options, groupLabel = _fillFieldNames.groupLabel;
  function dig(list, isGroupOption) {
    if (!Array.isArray(list)) {
      return;
    }
    list.forEach(function(data2) {
      if (isGroupOption || !(fieldOptions in data2)) {
        var value = data2[fieldValue];
        flattenList.push({
          key: getKey2(data2, flattenList.length),
          groupOption: isGroupOption,
          data: data2,
          label: data2[fieldLabel],
          value
        });
      } else {
        var grpLabel = data2[groupLabel];
        if (grpLabel === void 0 && childrenAsData) {
          grpLabel = data2.label;
        }
        flattenList.push({
          key: getKey2(data2, flattenList.length),
          group: true,
          data: data2,
          label: grpLabel
        });
        dig(data2[fieldOptions], true);
      }
    });
  }
  dig(options, false);
  return flattenList;
}
function injectPropsWithOption(option) {
  var newOption = _objectSpread2({}, option);
  if (!("props" in newOption)) {
    Object.defineProperty(newOption, "props", {
      get: function get3() {
        warning_default(false, "Return type is option instead of Option instance. Please read value directly instead of reading from `props`.");
        return newOption;
      }
    });
  }
  return newOption;
}
var getSeparatedContent = function getSeparatedContent2(text, tokens, end) {
  if (!tokens || !tokens.length) {
    return null;
  }
  var match2 = false;
  var separate = function separate2(str, _ref3) {
    var _ref4 = _toArray(_ref3), token2 = _ref4[0], restTokens = _ref4.slice(1);
    if (!token2) {
      return [str];
    }
    var list2 = str.split(token2);
    match2 = match2 || list2.length > 1;
    return list2.reduce(function(prevList, unitStr) {
      return [].concat(_toConsumableArray(prevList), _toConsumableArray(separate2(unitStr, restTokens)));
    }, []).filter(Boolean);
  };
  var list = separate(text, tokens);
  if (match2) {
    return typeof end !== "undefined" ? list.slice(0, end) : list;
  } else {
    return null;
  }
};

// ../../node_modules/rc-select/es/SelectContext.js
var React152 = __toESM(require_react());
var SelectContext = /* @__PURE__ */ React152.createContext(null);
var SelectContext_default = SelectContext;

// ../../node_modules/rc-select/es/BaseSelect/Polite.js
var React153 = __toESM(require_react());
function Polite(props) {
  var visible = props.visible, values = props.values;
  if (!visible) {
    return null;
  }
  var MAX_COUNT = 50;
  return /* @__PURE__ */ React153.createElement("span", {
    "aria-live": "polite",
    style: {
      width: 0,
      height: 0,
      position: "absolute",
      overflow: "hidden",
      opacity: 0
    }
  }, "".concat(values.slice(0, MAX_COUNT).map(function(_ref) {
    var label = _ref.label, value = _ref.value;
    return ["number", "string"].includes(_typeof(label)) ? label : value;
  }).join(", ")), values.length > MAX_COUNT ? ", ..." : null);
}

// ../../node_modules/rc-select/es/BaseSelect/index.js
var _excluded19 = ["id", "prefixCls", "className", "showSearch", "tagRender", "direction", "omitDomProps", "displayValues", "onDisplayValuesChange", "emptyOptions", "notFoundContent", "onClear", "mode", "disabled", "loading", "getInputElement", "getRawInputElement", "open", "defaultOpen", "onDropdownVisibleChange", "activeValue", "onActiveValueChange", "activeDescendantId", "searchValue", "autoClearSearchValue", "onSearch", "onSearchSplit", "tokenSeparators", "allowClear", "prefix", "suffixIcon", "clearIcon", "OptionList", "animation", "transitionName", "dropdownStyle", "dropdownClassName", "dropdownMatchSelectWidth", "dropdownRender", "dropdownAlign", "placement", "builtinPlacements", "getPopupContainer", "showAction", "onFocus", "onBlur", "onKeyUp", "onKeyDown", "onMouseDown"];
var DEFAULT_OMIT_PROPS = ["value", "onChange", "removeIcon", "placeholder", "autoFocus", "maxTagCount", "maxTagTextLength", "maxTagPlaceholder", "choiceTransitionName", "onInputKeyDown", "onPopupScroll", "tabIndex"];
var isMultiple = function isMultiple2(mode) {
  return mode === "tags" || mode === "multiple";
};
var BaseSelect = /* @__PURE__ */ React154.forwardRef(function(props, ref3) {
  var _customizeRawInputEle;
  var id = props.id, prefixCls = props.prefixCls, className2 = props.className, showSearch = props.showSearch, tagRender = props.tagRender, direction = props.direction, omitDomProps = props.omitDomProps, displayValues = props.displayValues, onDisplayValuesChange = props.onDisplayValuesChange, emptyOptions = props.emptyOptions, _props$notFoundConten = props.notFoundContent, notFoundContent = _props$notFoundConten === void 0 ? "Not Found" : _props$notFoundConten, onClear = props.onClear, mode = props.mode, disabled = props.disabled, loading = props.loading, getInputElement = props.getInputElement, getRawInputElement = props.getRawInputElement, open2 = props.open, defaultOpen = props.defaultOpen, onDropdownVisibleChange = props.onDropdownVisibleChange, activeValue = props.activeValue, onActiveValueChange = props.onActiveValueChange, activeDescendantId = props.activeDescendantId, searchValue = props.searchValue, autoClearSearchValue = props.autoClearSearchValue, onSearch = props.onSearch, onSearchSplit = props.onSearchSplit, tokenSeparators = props.tokenSeparators, allowClear = props.allowClear, prefix3 = props.prefix, suffixIcon = props.suffixIcon, clearIcon = props.clearIcon, OptionList5 = props.OptionList, animation = props.animation, transitionName = props.transitionName, dropdownStyle = props.dropdownStyle, dropdownClassName = props.dropdownClassName, dropdownMatchSelectWidth = props.dropdownMatchSelectWidth, dropdownRender = props.dropdownRender, dropdownAlign = props.dropdownAlign, placement = props.placement, builtinPlacements = props.builtinPlacements, getPopupContainer = props.getPopupContainer, _props$showAction = props.showAction, showAction = _props$showAction === void 0 ? [] : _props$showAction, onFocus = props.onFocus, onBlur = props.onBlur, onKeyUp = props.onKeyUp, onKeyDown2 = props.onKeyDown, onMouseDown = props.onMouseDown, restProps = _objectWithoutProperties(props, _excluded19);
  var multiple = isMultiple(mode);
  var mergedShowSearch = (showSearch !== void 0 ? showSearch : multiple) || mode === "combobox";
  var domProps = _objectSpread2({}, restProps);
  DEFAULT_OMIT_PROPS.forEach(function(propName) {
    delete domProps[propName];
  });
  omitDomProps === null || omitDomProps === void 0 || omitDomProps.forEach(function(propName) {
    delete domProps[propName];
  });
  var _React$useState = React154.useState(false), _React$useState2 = _slicedToArray(_React$useState, 2), mobile = _React$useState2[0], setMobile = _React$useState2[1];
  React154.useEffect(function() {
    setMobile(isMobile_default());
  }, []);
  var containerRef = React154.useRef(null);
  var selectorDomRef = React154.useRef(null);
  var triggerRef = React154.useRef(null);
  var selectorRef = React154.useRef(null);
  var listRef = React154.useRef(null);
  var blurRef = React154.useRef(false);
  var _useDelayReset = useDelayReset(), _useDelayReset2 = _slicedToArray(_useDelayReset, 3), mockFocused = _useDelayReset2[0], setMockFocused = _useDelayReset2[1], cancelSetMockFocused = _useDelayReset2[2];
  React154.useImperativeHandle(ref3, function() {
    var _selectorRef$current, _selectorRef$current2;
    return {
      focus: (_selectorRef$current = selectorRef.current) === null || _selectorRef$current === void 0 ? void 0 : _selectorRef$current.focus,
      blur: (_selectorRef$current2 = selectorRef.current) === null || _selectorRef$current2 === void 0 ? void 0 : _selectorRef$current2.blur,
      scrollTo: function scrollTo2(arg) {
        var _listRef$current;
        return (_listRef$current = listRef.current) === null || _listRef$current === void 0 ? void 0 : _listRef$current.scrollTo(arg);
      },
      nativeElement: containerRef.current || selectorDomRef.current
    };
  });
  var mergedSearchValue = React154.useMemo(function() {
    var _displayValues$;
    if (mode !== "combobox") {
      return searchValue;
    }
    var val = (_displayValues$ = displayValues[0]) === null || _displayValues$ === void 0 ? void 0 : _displayValues$.value;
    return typeof val === "string" || typeof val === "number" ? String(val) : "";
  }, [searchValue, mode, displayValues]);
  var customizeInputElement = mode === "combobox" && typeof getInputElement === "function" && getInputElement() || null;
  var customizeRawInputElement = typeof getRawInputElement === "function" && getRawInputElement();
  var customizeRawInputRef = useComposeRef(selectorDomRef, customizeRawInputElement === null || customizeRawInputElement === void 0 || (_customizeRawInputEle = customizeRawInputElement.props) === null || _customizeRawInputEle === void 0 ? void 0 : _customizeRawInputEle.ref);
  var _React$useState3 = React154.useState(false), _React$useState4 = _slicedToArray(_React$useState3, 2), rendered = _React$useState4[0], setRendered = _React$useState4[1];
  useLayoutEffect_default(function() {
    setRendered(true);
  }, []);
  var _useMergedState = useMergedState(false, {
    defaultValue: defaultOpen,
    value: open2
  }), _useMergedState2 = _slicedToArray(_useMergedState, 2), innerOpen = _useMergedState2[0], setInnerOpen = _useMergedState2[1];
  var mergedOpen = rendered ? innerOpen : false;
  var emptyListContent = !notFoundContent && emptyOptions;
  if (disabled || emptyListContent && mergedOpen && mode === "combobox") {
    mergedOpen = false;
  }
  var triggerOpen = emptyListContent ? false : mergedOpen;
  var onToggleOpen = React154.useCallback(function(newOpen) {
    var nextOpen = newOpen !== void 0 ? newOpen : !mergedOpen;
    if (!disabled) {
      setInnerOpen(nextOpen);
      if (mergedOpen !== nextOpen) {
        onDropdownVisibleChange === null || onDropdownVisibleChange === void 0 || onDropdownVisibleChange(nextOpen);
      }
    }
  }, [disabled, mergedOpen, setInnerOpen, onDropdownVisibleChange]);
  var tokenWithEnter = React154.useMemo(function() {
    return (tokenSeparators || []).some(function(tokenSeparator) {
      return ["\n", "\r\n"].includes(tokenSeparator);
    });
  }, [tokenSeparators]);
  var _ref = React154.useContext(SelectContext_default) || {}, maxCount = _ref.maxCount, rawValues = _ref.rawValues;
  var onInternalSearch = function onInternalSearch2(searchText, fromTyping, isCompositing) {
    if (multiple && isValidCount(maxCount) && (rawValues === null || rawValues === void 0 ? void 0 : rawValues.size) >= maxCount) {
      return;
    }
    var ret = true;
    var newSearchText = searchText;
    onActiveValueChange === null || onActiveValueChange === void 0 || onActiveValueChange(null);
    var separatedList = getSeparatedContent(searchText, tokenSeparators, isValidCount(maxCount) ? maxCount - rawValues.size : void 0);
    var patchLabels = isCompositing ? null : separatedList;
    if (mode !== "combobox" && patchLabels) {
      newSearchText = "";
      onSearchSplit === null || onSearchSplit === void 0 || onSearchSplit(patchLabels);
      onToggleOpen(false);
      ret = false;
    }
    if (onSearch && mergedSearchValue !== newSearchText) {
      onSearch(newSearchText, {
        source: fromTyping ? "typing" : "effect"
      });
    }
    return ret;
  };
  var onInternalSearchSubmit = function onInternalSearchSubmit2(searchText) {
    if (!searchText || !searchText.trim()) {
      return;
    }
    onSearch(searchText, {
      source: "submit"
    });
  };
  React154.useEffect(function() {
    if (!mergedOpen && !multiple && mode !== "combobox") {
      onInternalSearch("", false, false);
    }
  }, [mergedOpen]);
  React154.useEffect(function() {
    if (innerOpen && disabled) {
      setInnerOpen(false);
    }
    if (disabled && !blurRef.current) {
      setMockFocused(false);
    }
  }, [disabled]);
  var _useLock = useLock(), _useLock2 = _slicedToArray(_useLock, 2), getClearLock = _useLock2[0], setClearLock = _useLock2[1];
  var keyLockRef = React154.useRef(false);
  var onInternalKeyDown = function onInternalKeyDown2(event) {
    var clearLock = getClearLock();
    var key2 = event.key;
    var isEnterKey = key2 === "Enter";
    if (isEnterKey) {
      if (mode !== "combobox") {
        event.preventDefault();
      }
      if (!mergedOpen) {
        onToggleOpen(true);
      }
    }
    setClearLock(!!mergedSearchValue);
    if (key2 === "Backspace" && !clearLock && multiple && !mergedSearchValue && displayValues.length) {
      var cloneDisplayValues = _toConsumableArray(displayValues);
      var removedDisplayValue = null;
      for (var i = cloneDisplayValues.length - 1; i >= 0; i -= 1) {
        var current2 = cloneDisplayValues[i];
        if (!current2.disabled) {
          cloneDisplayValues.splice(i, 1);
          removedDisplayValue = current2;
          break;
        }
      }
      if (removedDisplayValue) {
        onDisplayValuesChange(cloneDisplayValues, {
          type: "remove",
          values: [removedDisplayValue]
        });
      }
    }
    for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      rest[_key - 1] = arguments[_key];
    }
    if (mergedOpen && (!isEnterKey || !keyLockRef.current)) {
      var _listRef$current2;
      if (isEnterKey) {
        keyLockRef.current = true;
      }
      (_listRef$current2 = listRef.current) === null || _listRef$current2 === void 0 || _listRef$current2.onKeyDown.apply(_listRef$current2, [event].concat(rest));
    }
    onKeyDown2 === null || onKeyDown2 === void 0 || onKeyDown2.apply(void 0, [event].concat(rest));
  };
  var onInternalKeyUp = function onInternalKeyUp2(event) {
    for (var _len2 = arguments.length, rest = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      rest[_key2 - 1] = arguments[_key2];
    }
    if (mergedOpen) {
      var _listRef$current3;
      (_listRef$current3 = listRef.current) === null || _listRef$current3 === void 0 || _listRef$current3.onKeyUp.apply(_listRef$current3, [event].concat(rest));
    }
    if (event.key === "Enter") {
      keyLockRef.current = false;
    }
    onKeyUp === null || onKeyUp === void 0 || onKeyUp.apply(void 0, [event].concat(rest));
  };
  var onSelectorRemove = function onSelectorRemove2(val) {
    var newValues = displayValues.filter(function(i) {
      return i !== val;
    });
    onDisplayValuesChange(newValues, {
      type: "remove",
      values: [val]
    });
  };
  var onInputBlur = function onInputBlur2() {
    keyLockRef.current = false;
  };
  var focusRef = React154.useRef(false);
  var onContainerFocus = function onContainerFocus2() {
    setMockFocused(true);
    if (!disabled) {
      if (onFocus && !focusRef.current) {
        onFocus.apply(void 0, arguments);
      }
      if (showAction.includes("focus")) {
        onToggleOpen(true);
      }
    }
    focusRef.current = true;
  };
  var onContainerBlur = function onContainerBlur2() {
    blurRef.current = true;
    setMockFocused(false, function() {
      focusRef.current = false;
      blurRef.current = false;
      onToggleOpen(false);
    });
    if (disabled) {
      return;
    }
    if (mergedSearchValue) {
      if (mode === "tags") {
        onSearch(mergedSearchValue, {
          source: "submit"
        });
      } else if (mode === "multiple") {
        onSearch("", {
          source: "blur"
        });
      }
    }
    if (onBlur) {
      onBlur.apply(void 0, arguments);
    }
  };
  var activeTimeoutIds = [];
  React154.useEffect(function() {
    return function() {
      activeTimeoutIds.forEach(function(timeoutId) {
        return clearTimeout(timeoutId);
      });
      activeTimeoutIds.splice(0, activeTimeoutIds.length);
    };
  }, []);
  var onInternalMouseDown = function onInternalMouseDown2(event) {
    var _triggerRef$current;
    var target = event.target;
    var popupElement = (_triggerRef$current = triggerRef.current) === null || _triggerRef$current === void 0 ? void 0 : _triggerRef$current.getPopupElement();
    if (popupElement && popupElement.contains(target)) {
      var timeoutId = setTimeout(function() {
        var index3 = activeTimeoutIds.indexOf(timeoutId);
        if (index3 !== -1) {
          activeTimeoutIds.splice(index3, 1);
        }
        cancelSetMockFocused();
        if (!mobile && !popupElement.contains(document.activeElement)) {
          var _selectorRef$current3;
          (_selectorRef$current3 = selectorRef.current) === null || _selectorRef$current3 === void 0 || _selectorRef$current3.focus();
        }
      });
      activeTimeoutIds.push(timeoutId);
    }
    for (var _len3 = arguments.length, restArgs = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
      restArgs[_key3 - 1] = arguments[_key3];
    }
    onMouseDown === null || onMouseDown === void 0 || onMouseDown.apply(void 0, [event].concat(restArgs));
  };
  var _React$useState5 = React154.useState({}), _React$useState6 = _slicedToArray(_React$useState5, 2), forceUpdate = _React$useState6[1];
  function onPopupMouseEnter() {
    forceUpdate({});
  }
  var onTriggerVisibleChange;
  if (customizeRawInputElement) {
    onTriggerVisibleChange = function onTriggerVisibleChange2(newOpen) {
      onToggleOpen(newOpen);
    };
  }
  useSelectTriggerControl(function() {
    var _triggerRef$current2;
    return [containerRef.current, (_triggerRef$current2 = triggerRef.current) === null || _triggerRef$current2 === void 0 ? void 0 : _triggerRef$current2.getPopupElement()];
  }, triggerOpen, onToggleOpen, !!customizeRawInputElement);
  var baseSelectContext = React154.useMemo(function() {
    return _objectSpread2(_objectSpread2({}, props), {}, {
      notFoundContent,
      open: mergedOpen,
      triggerOpen,
      id,
      showSearch: mergedShowSearch,
      multiple,
      toggleOpen: onToggleOpen
    });
  }, [props, notFoundContent, triggerOpen, mergedOpen, id, mergedShowSearch, multiple, onToggleOpen]);
  var showSuffixIcon = !!suffixIcon || loading;
  var arrowNode;
  if (showSuffixIcon) {
    arrowNode = /* @__PURE__ */ React154.createElement(TransBtn_default, {
      className: (0, import_classnames48.default)("".concat(prefixCls, "-arrow"), _defineProperty({}, "".concat(prefixCls, "-arrow-loading"), loading)),
      customizeIcon: suffixIcon,
      customizeIconProps: {
        loading,
        searchValue: mergedSearchValue,
        open: mergedOpen,
        focused: mockFocused,
        showSearch: mergedShowSearch
      }
    });
  }
  var onClearMouseDown = function onClearMouseDown2() {
    var _selectorRef$current4;
    onClear === null || onClear === void 0 || onClear();
    (_selectorRef$current4 = selectorRef.current) === null || _selectorRef$current4 === void 0 || _selectorRef$current4.focus();
    onDisplayValuesChange([], {
      type: "clear",
      values: displayValues
    });
    onInternalSearch("", false, false);
  };
  var _useAllowClear = useAllowClear(prefixCls, onClearMouseDown, displayValues, allowClear, clearIcon, disabled, mergedSearchValue, mode), mergedAllowClear = _useAllowClear.allowClear, clearNode = _useAllowClear.clearIcon;
  var optionList = /* @__PURE__ */ React154.createElement(OptionList5, {
    ref: listRef
  });
  var mergedClassName = (0, import_classnames48.default)(prefixCls, className2, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "".concat(prefixCls, "-focused"), mockFocused), "".concat(prefixCls, "-multiple"), multiple), "".concat(prefixCls, "-single"), !multiple), "".concat(prefixCls, "-allow-clear"), allowClear), "".concat(prefixCls, "-show-arrow"), showSuffixIcon), "".concat(prefixCls, "-disabled"), disabled), "".concat(prefixCls, "-loading"), loading), "".concat(prefixCls, "-open"), mergedOpen), "".concat(prefixCls, "-customize-input"), customizeInputElement), "".concat(prefixCls, "-show-search"), mergedShowSearch));
  var selectorNode = /* @__PURE__ */ React154.createElement(SelectTrigger_default, {
    ref: triggerRef,
    disabled,
    prefixCls,
    visible: triggerOpen,
    popupElement: optionList,
    animation,
    transitionName,
    dropdownStyle,
    dropdownClassName,
    direction,
    dropdownMatchSelectWidth,
    dropdownRender,
    dropdownAlign,
    placement,
    builtinPlacements,
    getPopupContainer,
    empty: emptyOptions,
    getTriggerDOMNode: function getTriggerDOMNode(node2) {
      return (
        // TODO: This is workaround and should be removed in `rc-select`
        // And use new standard `nativeElement` for ref.
        // But we should update `rc-resize-observer` first.
        selectorDomRef.current || node2
      );
    },
    onPopupVisibleChange: onTriggerVisibleChange,
    onPopupMouseEnter
  }, customizeRawInputElement ? /* @__PURE__ */ React154.cloneElement(customizeRawInputElement, {
    ref: customizeRawInputRef
  }) : /* @__PURE__ */ React154.createElement(Selector_default, _extends({}, props, {
    domRef: selectorDomRef,
    prefixCls,
    inputElement: customizeInputElement,
    ref: selectorRef,
    id,
    prefix: prefix3,
    showSearch: mergedShowSearch,
    autoClearSearchValue,
    mode,
    activeDescendantId,
    tagRender,
    values: displayValues,
    open: mergedOpen,
    onToggleOpen,
    activeValue,
    searchValue: mergedSearchValue,
    onSearch: onInternalSearch,
    onSearchSubmit: onInternalSearchSubmit,
    onRemove: onSelectorRemove,
    tokenWithEnter,
    onInputBlur
  })));
  var renderNode;
  if (customizeRawInputElement) {
    renderNode = selectorNode;
  } else {
    renderNode = /* @__PURE__ */ React154.createElement("div", _extends({
      className: mergedClassName
    }, domProps, {
      ref: containerRef,
      onMouseDown: onInternalMouseDown,
      onKeyDown: onInternalKeyDown,
      onKeyUp: onInternalKeyUp,
      onFocus: onContainerFocus,
      onBlur: onContainerBlur
    }), /* @__PURE__ */ React154.createElement(Polite, {
      visible: mockFocused && !mergedOpen,
      values: displayValues
    }), selectorNode, arrowNode, mergedAllowClear && clearNode);
  }
  return /* @__PURE__ */ React154.createElement(BaseSelectContext.Provider, {
    value: baseSelectContext
  }, renderNode);
});
if (true) {
  BaseSelect.displayName = "BaseSelect";
}
var BaseSelect_default = BaseSelect;

// ../../node_modules/rc-select/es/OptGroup.js
var OptGroup = function OptGroup2() {
  return null;
};
OptGroup.isSelectOptGroup = true;
var OptGroup_default = OptGroup;

// ../../node_modules/rc-select/es/Option.js
var Option = function Option2() {
  return null;
};
Option.isSelectOption = true;
var Option_default = Option;

// ../../node_modules/rc-select/es/OptionList.js
var import_classnames52 = __toESM(require_classnames());

// ../../node_modules/rc-virtual-list/es/List.js
var import_classnames51 = __toESM(require_classnames());
var React164 = __toESM(require_react());
var import_react67 = __toESM(require_react());
var import_react_dom7 = __toESM(require_react_dom());

// ../../node_modules/rc-virtual-list/es/Filler.js
var React155 = __toESM(require_react());
var import_classnames49 = __toESM(require_classnames());
var Filler = /* @__PURE__ */ React155.forwardRef(function(_ref, ref3) {
  var height = _ref.height, offsetY = _ref.offsetY, offsetX = _ref.offsetX, children = _ref.children, prefixCls = _ref.prefixCls, onInnerResize = _ref.onInnerResize, innerProps = _ref.innerProps, rtl = _ref.rtl, extra = _ref.extra;
  var outerStyle = {};
  var innerStyle = {
    display: "flex",
    flexDirection: "column"
  };
  if (offsetY !== void 0) {
    outerStyle = {
      height,
      position: "relative",
      overflow: "hidden"
    };
    innerStyle = _objectSpread2(_objectSpread2({}, innerStyle), {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
      transform: "translateY(".concat(offsetY, "px)")
    }, rtl ? "marginRight" : "marginLeft", -offsetX), "position", "absolute"), "left", 0), "right", 0), "top", 0));
  }
  return /* @__PURE__ */ React155.createElement("div", {
    style: outerStyle
  }, /* @__PURE__ */ React155.createElement(es_default, {
    onResize: function onResize2(_ref2) {
      var offsetHeight = _ref2.offsetHeight;
      if (offsetHeight && onInnerResize) {
        onInnerResize();
      }
    }
  }, /* @__PURE__ */ React155.createElement("div", _extends({
    style: innerStyle,
    className: (0, import_classnames49.default)(_defineProperty({}, "".concat(prefixCls, "-holder-inner"), prefixCls)),
    ref: ref3
  }, innerProps), children, extra)));
});
Filler.displayName = "Filler";
var Filler_default = Filler;

// ../../node_modules/rc-virtual-list/es/hooks/useChildren.js
var React157 = __toESM(require_react());

// ../../node_modules/rc-virtual-list/es/Item.js
var React156 = __toESM(require_react());
function Item2(_ref) {
  var children = _ref.children, setRef = _ref.setRef;
  var refFunc = React156.useCallback(function(node2) {
    setRef(node2);
  }, []);
  return /* @__PURE__ */ React156.cloneElement(children, {
    ref: refFunc
  });
}

// ../../node_modules/rc-virtual-list/es/hooks/useChildren.js
function useChildren(list, startIndex, endIndex, scrollWidth, offsetX, setNodeRef, renderFunc, _ref) {
  var getKey5 = _ref.getKey;
  return list.slice(startIndex, endIndex + 1).map(function(item, index3) {
    var eleIndex = startIndex + index3;
    var node2 = renderFunc(item, eleIndex, {
      style: {
        width: scrollWidth
      },
      offsetX
    });
    var key2 = getKey5(item);
    return /* @__PURE__ */ React157.createElement(Item2, {
      key: key2,
      setRef: function setRef(ele) {
        return setNodeRef(item, ele);
      }
    }, node2);
  });
}

// ../../node_modules/rc-virtual-list/es/hooks/useDiffItem.js
var React158 = __toESM(require_react());

// ../../node_modules/rc-virtual-list/es/utils/algorithmUtil.js
function findListDiffIndex(originList, targetList, getKey5) {
  var originLen = originList.length;
  var targetLen = targetList.length;
  var shortList;
  var longList;
  if (originLen === 0 && targetLen === 0) {
    return null;
  }
  if (originLen < targetLen) {
    shortList = originList;
    longList = targetList;
  } else {
    shortList = targetList;
    longList = originList;
  }
  var notExistKey = {
    __EMPTY_ITEM__: true
  };
  function getItemKey(item) {
    if (item !== void 0) {
      return getKey5(item);
    }
    return notExistKey;
  }
  var diffIndex = null;
  var multiple = Math.abs(originLen - targetLen) !== 1;
  for (var i = 0; i < longList.length; i += 1) {
    var shortKey = getItemKey(shortList[i]);
    var longKey = getItemKey(longList[i]);
    if (shortKey !== longKey) {
      diffIndex = i;
      multiple = multiple || shortKey !== getItemKey(longList[i + 1]);
      break;
    }
  }
  return diffIndex === null ? null : {
    index: diffIndex,
    multiple
  };
}

// ../../node_modules/rc-virtual-list/es/hooks/useDiffItem.js
function useDiffItem(data2, getKey5, onDiff) {
  var _React$useState = React158.useState(data2), _React$useState2 = _slicedToArray(_React$useState, 2), prevData = _React$useState2[0], setPrevData = _React$useState2[1];
  var _React$useState3 = React158.useState(null), _React$useState4 = _slicedToArray(_React$useState3, 2), diffItem = _React$useState4[0], setDiffItem = _React$useState4[1];
  React158.useEffect(function() {
    var diff3 = findListDiffIndex(prevData || [], data2 || [], getKey5);
    if ((diff3 === null || diff3 === void 0 ? void 0 : diff3.index) !== void 0) {
      onDiff === null || onDiff === void 0 || onDiff(diff3.index);
      setDiffItem(data2[diff3.index]);
    }
    setPrevData(data2);
  }, [data2]);
  return [diffItem];
}

// ../../node_modules/rc-virtual-list/es/hooks/useFrameWheel.js
var import_react64 = __toESM(require_react());

// ../../node_modules/rc-virtual-list/es/utils/isFirefox.js
var isFF = (typeof navigator === "undefined" ? "undefined" : _typeof(navigator)) === "object" && /Firefox/i.test(navigator.userAgent);
var isFirefox_default = isFF;

// ../../node_modules/rc-virtual-list/es/hooks/useOriginScroll.js
var import_react63 = __toESM(require_react());
var useOriginScroll_default = (function(isScrollAtTop, isScrollAtBottom, isScrollAtLeft, isScrollAtRight) {
  var lockRef = (0, import_react63.useRef)(false);
  var lockTimeoutRef = (0, import_react63.useRef)(null);
  function lockScroll() {
    clearTimeout(lockTimeoutRef.current);
    lockRef.current = true;
    lockTimeoutRef.current = setTimeout(function() {
      lockRef.current = false;
    }, 50);
  }
  var scrollPingRef = (0, import_react63.useRef)({
    top: isScrollAtTop,
    bottom: isScrollAtBottom,
    left: isScrollAtLeft,
    right: isScrollAtRight
  });
  scrollPingRef.current.top = isScrollAtTop;
  scrollPingRef.current.bottom = isScrollAtBottom;
  scrollPingRef.current.left = isScrollAtLeft;
  scrollPingRef.current.right = isScrollAtRight;
  return function(isHorizontal, delta) {
    var smoothOffset = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var originScroll = isHorizontal ? (
      // Pass origin wheel when on the left
      delta < 0 && scrollPingRef.current.left || // Pass origin wheel when on the right
      delta > 0 && scrollPingRef.current.right
    ) : delta < 0 && scrollPingRef.current.top || // Pass origin wheel when on the bottom
    delta > 0 && scrollPingRef.current.bottom;
    if (smoothOffset && originScroll) {
      clearTimeout(lockTimeoutRef.current);
      lockRef.current = false;
    } else if (!originScroll || lockRef.current) {
      lockScroll();
    }
    return !lockRef.current && originScroll;
  };
});

// ../../node_modules/rc-virtual-list/es/hooks/useFrameWheel.js
function useFrameWheel(inVirtual, isScrollAtTop, isScrollAtBottom, isScrollAtLeft, isScrollAtRight, horizontalScroll, onWheelDelta) {
  var offsetRef = (0, import_react64.useRef)(0);
  var nextFrameRef = (0, import_react64.useRef)(null);
  var wheelValueRef = (0, import_react64.useRef)(null);
  var isMouseScrollRef = (0, import_react64.useRef)(false);
  var originScroll = useOriginScroll_default(isScrollAtTop, isScrollAtBottom, isScrollAtLeft, isScrollAtRight);
  function onWheelY(e3, deltaY) {
    raf_default.cancel(nextFrameRef.current);
    if (originScroll(false, deltaY)) return;
    var event = e3;
    if (!event._virtualHandled) {
      event._virtualHandled = true;
    } else {
      return;
    }
    offsetRef.current += deltaY;
    wheelValueRef.current = deltaY;
    if (!isFirefox_default) {
      event.preventDefault();
    }
    nextFrameRef.current = raf_default(function() {
      var patchMultiple = isMouseScrollRef.current ? 10 : 1;
      onWheelDelta(offsetRef.current * patchMultiple, false);
      offsetRef.current = 0;
    });
  }
  function onWheelX(event, deltaX) {
    onWheelDelta(deltaX, true);
    if (!isFirefox_default) {
      event.preventDefault();
    }
  }
  var wheelDirectionRef = (0, import_react64.useRef)(null);
  var wheelDirectionCleanRef = (0, import_react64.useRef)(null);
  function onWheel(event) {
    if (!inVirtual) return;
    raf_default.cancel(wheelDirectionCleanRef.current);
    wheelDirectionCleanRef.current = raf_default(function() {
      wheelDirectionRef.current = null;
    }, 2);
    var deltaX = event.deltaX, deltaY = event.deltaY, shiftKey = event.shiftKey;
    var mergedDeltaX = deltaX;
    var mergedDeltaY = deltaY;
    if (wheelDirectionRef.current === "sx" || !wheelDirectionRef.current && (shiftKey || false) && deltaY && !deltaX) {
      mergedDeltaX = deltaY;
      mergedDeltaY = 0;
      wheelDirectionRef.current = "sx";
    }
    var absX = Math.abs(mergedDeltaX);
    var absY = Math.abs(mergedDeltaY);
    if (wheelDirectionRef.current === null) {
      wheelDirectionRef.current = horizontalScroll && absX > absY ? "x" : "y";
    }
    if (wheelDirectionRef.current === "y") {
      onWheelY(event, mergedDeltaY);
    } else {
      onWheelX(event, mergedDeltaX);
    }
  }
  function onFireFoxScroll(event) {
    if (!inVirtual) return;
    isMouseScrollRef.current = event.detail === wheelValueRef.current;
  }
  return [onWheel, onFireFoxScroll];
}

// ../../node_modules/rc-virtual-list/es/hooks/useGetSize.js
var React159 = __toESM(require_react());
function useGetSize(mergedData, getKey5, heights, itemHeight) {
  var _React$useMemo = React159.useMemo(function() {
    return [/* @__PURE__ */ new Map(), []];
  }, [mergedData, heights.id, itemHeight]), _React$useMemo2 = _slicedToArray(_React$useMemo, 2), key2Index = _React$useMemo2[0], bottomList = _React$useMemo2[1];
  var getSize5 = function getSize6(startKey) {
    var endKey = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : startKey;
    var startIndex = key2Index.get(startKey);
    var endIndex = key2Index.get(endKey);
    if (startIndex === void 0 || endIndex === void 0) {
      var dataLen = mergedData.length;
      for (var i = bottomList.length; i < dataLen; i += 1) {
        var _heights$get;
        var item = mergedData[i];
        var key2 = getKey5(item);
        key2Index.set(key2, i);
        var cacheHeight = (_heights$get = heights.get(key2)) !== null && _heights$get !== void 0 ? _heights$get : itemHeight;
        bottomList[i] = (bottomList[i - 1] || 0) + cacheHeight;
        if (key2 === startKey) {
          startIndex = i;
        }
        if (key2 === endKey) {
          endIndex = i;
        }
        if (startIndex !== void 0 && endIndex !== void 0) {
          break;
        }
      }
    }
    return {
      top: bottomList[startIndex - 1] || 0,
      bottom: bottomList[endIndex]
    };
  };
  return getSize5;
}

// ../../node_modules/rc-virtual-list/es/hooks/useHeights.js
var React160 = __toESM(require_react());
var import_react65 = __toESM(require_react());

// ../../node_modules/rc-virtual-list/es/utils/CacheMap.js
var CacheMap = /* @__PURE__ */ (function() {
  function CacheMap2() {
    _classCallCheck(this, CacheMap2);
    _defineProperty(this, "maps", void 0);
    _defineProperty(this, "id", 0);
    _defineProperty(this, "diffRecords", /* @__PURE__ */ new Map());
    this.maps = /* @__PURE__ */ Object.create(null);
  }
  _createClass(CacheMap2, [{
    key: "set",
    value: function set4(key2, value) {
      this.diffRecords.set(key2, this.maps[key2]);
      this.maps[key2] = value;
      this.id += 1;
    }
  }, {
    key: "get",
    value: function get3(key2) {
      return this.maps[key2];
    }
    /**
     * CacheMap will record the key changed.
     * To help to know what's update in the next render.
     */
  }, {
    key: "resetRecord",
    value: function resetRecord() {
      this.diffRecords.clear();
    }
  }, {
    key: "getRecord",
    value: function getRecord() {
      return this.diffRecords;
    }
  }]);
  return CacheMap2;
})();
var CacheMap_default = CacheMap;

// ../../node_modules/rc-virtual-list/es/hooks/useHeights.js
function parseNumber(value) {
  var num = parseFloat(value);
  return isNaN(num) ? 0 : num;
}
function useHeights(getKey5, onItemAdd, onItemRemove) {
  var _React$useState = React160.useState(0), _React$useState2 = _slicedToArray(_React$useState, 2), updatedMark = _React$useState2[0], setUpdatedMark = _React$useState2[1];
  var instanceRef = (0, import_react65.useRef)(/* @__PURE__ */ new Map());
  var heightsRef = (0, import_react65.useRef)(new CacheMap_default());
  var promiseIdRef = (0, import_react65.useRef)(0);
  function cancelRaf() {
    promiseIdRef.current += 1;
  }
  function collectHeight() {
    var sync = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    cancelRaf();
    var doCollect = function doCollect2() {
      var changed = false;
      instanceRef.current.forEach(function(element, key2) {
        if (element && element.offsetParent) {
          var offsetHeight = element.offsetHeight;
          var _getComputedStyle = getComputedStyle(element), marginTop = _getComputedStyle.marginTop, marginBottom = _getComputedStyle.marginBottom;
          var marginTopNum = parseNumber(marginTop);
          var marginBottomNum = parseNumber(marginBottom);
          var totalHeight = offsetHeight + marginTopNum + marginBottomNum;
          if (heightsRef.current.get(key2) !== totalHeight) {
            heightsRef.current.set(key2, totalHeight);
            changed = true;
          }
        }
      });
      if (changed) {
        setUpdatedMark(function(c) {
          return c + 1;
        });
      }
    };
    if (sync) {
      doCollect();
    } else {
      promiseIdRef.current += 1;
      var id = promiseIdRef.current;
      Promise.resolve().then(function() {
        if (id === promiseIdRef.current) {
          doCollect();
        }
      });
    }
  }
  function setInstanceRef(item, instance) {
    var key2 = getKey5(item);
    var origin = instanceRef.current.get(key2);
    if (instance) {
      instanceRef.current.set(key2, instance);
      collectHeight();
    } else {
      instanceRef.current.delete(key2);
    }
    if (!origin !== !instance) {
      if (instance) {
        onItemAdd === null || onItemAdd === void 0 || onItemAdd(item);
      } else {
        onItemRemove === null || onItemRemove === void 0 || onItemRemove(item);
      }
    }
  }
  (0, import_react65.useEffect)(function() {
    return cancelRaf;
  }, []);
  return [setInstanceRef, collectHeight, heightsRef.current, updatedMark];
}

// ../../node_modules/rc-virtual-list/es/hooks/useMobileTouchMove.js
var import_react66 = __toESM(require_react());
var SMOOTH_PTG = 14 / 15;
function useMobileTouchMove(inVirtual, listRef, callback) {
  var touchedRef = (0, import_react66.useRef)(false);
  var touchXRef = (0, import_react66.useRef)(0);
  var touchYRef = (0, import_react66.useRef)(0);
  var elementRef = (0, import_react66.useRef)(null);
  var intervalRef = (0, import_react66.useRef)(null);
  var cleanUpEvents;
  var onTouchMove = function onTouchMove2(e3) {
    if (touchedRef.current) {
      var currentX = Math.ceil(e3.touches[0].pageX);
      var currentY = Math.ceil(e3.touches[0].pageY);
      var offsetX = touchXRef.current - currentX;
      var offsetY = touchYRef.current - currentY;
      var _isHorizontal = Math.abs(offsetX) > Math.abs(offsetY);
      if (_isHorizontal) {
        touchXRef.current = currentX;
      } else {
        touchYRef.current = currentY;
      }
      var scrollHandled = callback(_isHorizontal, _isHorizontal ? offsetX : offsetY, false, e3);
      if (scrollHandled) {
        e3.preventDefault();
      }
      clearInterval(intervalRef.current);
      if (scrollHandled) {
        intervalRef.current = setInterval(function() {
          if (_isHorizontal) {
            offsetX *= SMOOTH_PTG;
          } else {
            offsetY *= SMOOTH_PTG;
          }
          var offset4 = Math.floor(_isHorizontal ? offsetX : offsetY);
          if (!callback(_isHorizontal, offset4, true) || Math.abs(offset4) <= 0.1) {
            clearInterval(intervalRef.current);
          }
        }, 16);
      }
    }
  };
  var onTouchEnd = function onTouchEnd2() {
    touchedRef.current = false;
    cleanUpEvents();
  };
  var onTouchStart = function onTouchStart2(e3) {
    cleanUpEvents();
    if (e3.touches.length === 1 && !touchedRef.current) {
      touchedRef.current = true;
      touchXRef.current = Math.ceil(e3.touches[0].pageX);
      touchYRef.current = Math.ceil(e3.touches[0].pageY);
      elementRef.current = e3.target;
      elementRef.current.addEventListener("touchmove", onTouchMove, {
        passive: false
      });
      elementRef.current.addEventListener("touchend", onTouchEnd, {
        passive: true
      });
    }
  };
  cleanUpEvents = function cleanUpEvents2() {
    if (elementRef.current) {
      elementRef.current.removeEventListener("touchmove", onTouchMove);
      elementRef.current.removeEventListener("touchend", onTouchEnd);
    }
  };
  useLayoutEffect_default(function() {
    if (inVirtual) {
      listRef.current.addEventListener("touchstart", onTouchStart, {
        passive: true
      });
    }
    return function() {
      var _listRef$current;
      (_listRef$current = listRef.current) === null || _listRef$current === void 0 || _listRef$current.removeEventListener("touchstart", onTouchStart);
      cleanUpEvents();
      clearInterval(intervalRef.current);
    };
  }, [inVirtual]);
}

// ../../node_modules/rc-virtual-list/es/hooks/useScrollDrag.js
var React161 = __toESM(require_react());
function smoothScrollOffset(offset4) {
  return Math.floor(Math.pow(offset4, 0.5));
}
function getPageXY(e3, horizontal) {
  var obj = "touches" in e3 ? e3.touches[0] : e3;
  return obj[horizontal ? "pageX" : "pageY"] - window[horizontal ? "scrollX" : "scrollY"];
}
function useScrollDrag(inVirtual, componentRef, onScrollOffset) {
  React161.useEffect(function() {
    var ele = componentRef.current;
    if (inVirtual && ele) {
      var mouseDownLock = false;
      var rafId;
      var _offset;
      var stopScroll = function stopScroll2() {
        raf_default.cancel(rafId);
      };
      var continueScroll = function continueScroll2() {
        stopScroll();
        rafId = raf_default(function() {
          onScrollOffset(_offset);
          continueScroll2();
        });
      };
      var onMouseDown = function onMouseDown2(e3) {
        if (e3.target.draggable || e3.button !== 0) {
          return;
        }
        var event = e3;
        if (!event._virtualHandled) {
          event._virtualHandled = true;
          mouseDownLock = true;
        }
      };
      var onMouseUp = function onMouseUp2() {
        mouseDownLock = false;
        stopScroll();
      };
      var onMouseMove = function onMouseMove2(e3) {
        if (mouseDownLock) {
          var mouseY = getPageXY(e3, false);
          var _ele$getBoundingClien = ele.getBoundingClientRect(), top = _ele$getBoundingClien.top, bottom = _ele$getBoundingClien.bottom;
          if (mouseY <= top) {
            var diff3 = top - mouseY;
            _offset = -smoothScrollOffset(diff3);
            continueScroll();
          } else if (mouseY >= bottom) {
            var _diff = mouseY - bottom;
            _offset = smoothScrollOffset(_diff);
            continueScroll();
          } else {
            stopScroll();
          }
        }
      };
      ele.addEventListener("mousedown", onMouseDown);
      ele.ownerDocument.addEventListener("mouseup", onMouseUp);
      ele.ownerDocument.addEventListener("mousemove", onMouseMove);
      return function() {
        ele.removeEventListener("mousedown", onMouseDown);
        ele.ownerDocument.removeEventListener("mouseup", onMouseUp);
        ele.ownerDocument.removeEventListener("mousemove", onMouseMove);
        stopScroll();
      };
    }
  }, [inVirtual]);
}

// ../../node_modules/rc-virtual-list/es/hooks/useScrollTo.js
var React162 = __toESM(require_react());
var MAX_TIMES = 10;
function useScrollTo(containerRef, data2, heights, itemHeight, getKey5, collectHeight, syncScrollTop, triggerFlash) {
  var scrollRef = React162.useRef();
  var _React$useState = React162.useState(null), _React$useState2 = _slicedToArray(_React$useState, 2), syncState = _React$useState2[0], setSyncState = _React$useState2[1];
  useLayoutEffect_default(function() {
    if (syncState && syncState.times < MAX_TIMES) {
      if (!containerRef.current) {
        setSyncState(function(ori) {
          return _objectSpread2({}, ori);
        });
        return;
      }
      collectHeight();
      var targetAlign = syncState.targetAlign, originAlign = syncState.originAlign, index3 = syncState.index, offset4 = syncState.offset;
      var height = containerRef.current.clientHeight;
      var needCollectHeight = false;
      var newTargetAlign = targetAlign;
      var targetTop = null;
      if (height) {
        var mergedAlign = targetAlign || originAlign;
        var stackTop = 0;
        var itemTop = 0;
        var itemBottom = 0;
        var maxLen = Math.min(data2.length - 1, index3);
        for (var i = 0; i <= maxLen; i += 1) {
          var key2 = getKey5(data2[i]);
          itemTop = stackTop;
          var cacheHeight = heights.get(key2);
          itemBottom = itemTop + (cacheHeight === void 0 ? itemHeight : cacheHeight);
          stackTop = itemBottom;
        }
        var leftHeight = mergedAlign === "top" ? offset4 : height - offset4;
        for (var _i = maxLen; _i >= 0; _i -= 1) {
          var _key = getKey5(data2[_i]);
          var _cacheHeight = heights.get(_key);
          if (_cacheHeight === void 0) {
            needCollectHeight = true;
            break;
          }
          leftHeight -= _cacheHeight;
          if (leftHeight <= 0) {
            break;
          }
        }
        switch (mergedAlign) {
          case "top":
            targetTop = itemTop - offset4;
            break;
          case "bottom":
            targetTop = itemBottom - height + offset4;
            break;
          default: {
            var scrollTop = containerRef.current.scrollTop;
            var scrollBottom = scrollTop + height;
            if (itemTop < scrollTop) {
              newTargetAlign = "top";
            } else if (itemBottom > scrollBottom) {
              newTargetAlign = "bottom";
            }
          }
        }
        if (targetTop !== null) {
          syncScrollTop(targetTop);
        }
        if (targetTop !== syncState.lastTop) {
          needCollectHeight = true;
        }
      }
      if (needCollectHeight) {
        setSyncState(_objectSpread2(_objectSpread2({}, syncState), {}, {
          times: syncState.times + 1,
          targetAlign: newTargetAlign,
          lastTop: targetTop
        }));
      }
    } else if ((syncState === null || syncState === void 0 ? void 0 : syncState.times) === MAX_TIMES) {
      warning_default(false, "Seems `scrollTo` with `rc-virtual-list` reach the max limitation. Please fire issue for us. Thanks.");
    }
  }, [syncState, containerRef.current]);
  return function(arg) {
    if (arg === null || arg === void 0) {
      triggerFlash();
      return;
    }
    raf_default.cancel(scrollRef.current);
    if (typeof arg === "number") {
      syncScrollTop(arg);
    } else if (arg && _typeof(arg) === "object") {
      var index3;
      var align = arg.align;
      if ("index" in arg) {
        index3 = arg.index;
      } else {
        index3 = data2.findIndex(function(item) {
          return getKey5(item) === arg.key;
        });
      }
      var _arg$offset = arg.offset, offset4 = _arg$offset === void 0 ? 0 : _arg$offset;
      setSyncState({
        times: 0,
        index: index3,
        offset: offset4,
        originAlign: align
      });
    }
  };
}

// ../../node_modules/rc-virtual-list/es/ScrollBar.js
var import_classnames50 = __toESM(require_classnames());
var React163 = __toESM(require_react());
var ScrollBar = /* @__PURE__ */ React163.forwardRef(function(props, ref3) {
  var prefixCls = props.prefixCls, rtl = props.rtl, scrollOffset = props.scrollOffset, scrollRange = props.scrollRange, onStartMove = props.onStartMove, onStopMove = props.onStopMove, onScroll = props.onScroll, horizontal = props.horizontal, spinSize = props.spinSize, containerSize = props.containerSize, style2 = props.style, propsThumbStyle = props.thumbStyle, showScrollBar = props.showScrollBar;
  var _React$useState = React163.useState(false), _React$useState2 = _slicedToArray(_React$useState, 2), dragging = _React$useState2[0], setDragging = _React$useState2[1];
  var _React$useState3 = React163.useState(null), _React$useState4 = _slicedToArray(_React$useState3, 2), pageXY = _React$useState4[0], setPageXY = _React$useState4[1];
  var _React$useState5 = React163.useState(null), _React$useState6 = _slicedToArray(_React$useState5, 2), startTop = _React$useState6[0], setStartTop = _React$useState6[1];
  var isLTR = !rtl;
  var scrollbarRef = React163.useRef();
  var thumbRef = React163.useRef();
  var _React$useState7 = React163.useState(showScrollBar), _React$useState8 = _slicedToArray(_React$useState7, 2), visible = _React$useState8[0], setVisible = _React$useState8[1];
  var visibleTimeoutRef = React163.useRef();
  var delayHidden = function delayHidden2() {
    if (showScrollBar === true || showScrollBar === false) return;
    clearTimeout(visibleTimeoutRef.current);
    setVisible(true);
    visibleTimeoutRef.current = setTimeout(function() {
      setVisible(false);
    }, 3e3);
  };
  var enableScrollRange = scrollRange - containerSize || 0;
  var enableOffsetRange = containerSize - spinSize || 0;
  var top = React163.useMemo(function() {
    if (scrollOffset === 0 || enableScrollRange === 0) {
      return 0;
    }
    var ptg = scrollOffset / enableScrollRange;
    return ptg * enableOffsetRange;
  }, [scrollOffset, enableScrollRange, enableOffsetRange]);
  var onContainerMouseDown = function onContainerMouseDown2(e3) {
    e3.stopPropagation();
    e3.preventDefault();
  };
  var stateRef = React163.useRef({
    top,
    dragging,
    pageY: pageXY,
    startTop
  });
  stateRef.current = {
    top,
    dragging,
    pageY: pageXY,
    startTop
  };
  var onThumbMouseDown = function onThumbMouseDown2(e3) {
    setDragging(true);
    setPageXY(getPageXY(e3, horizontal));
    setStartTop(stateRef.current.top);
    onStartMove();
    e3.stopPropagation();
    e3.preventDefault();
  };
  React163.useEffect(function() {
    var onScrollbarTouchStart = function onScrollbarTouchStart2(e3) {
      e3.preventDefault();
    };
    var scrollbarEle = scrollbarRef.current;
    var thumbEle = thumbRef.current;
    scrollbarEle.addEventListener("touchstart", onScrollbarTouchStart, {
      passive: false
    });
    thumbEle.addEventListener("touchstart", onThumbMouseDown, {
      passive: false
    });
    return function() {
      scrollbarEle.removeEventListener("touchstart", onScrollbarTouchStart);
      thumbEle.removeEventListener("touchstart", onThumbMouseDown);
    };
  }, []);
  var enableScrollRangeRef = React163.useRef();
  enableScrollRangeRef.current = enableScrollRange;
  var enableOffsetRangeRef = React163.useRef();
  enableOffsetRangeRef.current = enableOffsetRange;
  React163.useEffect(function() {
    if (dragging) {
      var moveRafId;
      var onMouseMove = function onMouseMove2(e3) {
        var _stateRef$current = stateRef.current, stateDragging = _stateRef$current.dragging, statePageY = _stateRef$current.pageY, stateStartTop = _stateRef$current.startTop;
        raf_default.cancel(moveRafId);
        var rect = scrollbarRef.current.getBoundingClientRect();
        var scale = containerSize / (horizontal ? rect.width : rect.height);
        if (stateDragging) {
          var offset4 = (getPageXY(e3, horizontal) - statePageY) * scale;
          var newTop = stateStartTop;
          if (!isLTR && horizontal) {
            newTop -= offset4;
          } else {
            newTop += offset4;
          }
          var tmpEnableScrollRange = enableScrollRangeRef.current;
          var tmpEnableOffsetRange = enableOffsetRangeRef.current;
          var ptg = tmpEnableOffsetRange ? newTop / tmpEnableOffsetRange : 0;
          var newScrollTop = Math.ceil(ptg * tmpEnableScrollRange);
          newScrollTop = Math.max(newScrollTop, 0);
          newScrollTop = Math.min(newScrollTop, tmpEnableScrollRange);
          moveRafId = raf_default(function() {
            onScroll(newScrollTop, horizontal);
          });
        }
      };
      var onMouseUp = function onMouseUp2() {
        setDragging(false);
        onStopMove();
      };
      window.addEventListener("mousemove", onMouseMove, {
        passive: true
      });
      window.addEventListener("touchmove", onMouseMove, {
        passive: true
      });
      window.addEventListener("mouseup", onMouseUp, {
        passive: true
      });
      window.addEventListener("touchend", onMouseUp, {
        passive: true
      });
      return function() {
        window.removeEventListener("mousemove", onMouseMove);
        window.removeEventListener("touchmove", onMouseMove);
        window.removeEventListener("mouseup", onMouseUp);
        window.removeEventListener("touchend", onMouseUp);
        raf_default.cancel(moveRafId);
      };
    }
  }, [dragging]);
  React163.useEffect(function() {
    delayHidden();
    return function() {
      clearTimeout(visibleTimeoutRef.current);
    };
  }, [scrollOffset]);
  React163.useImperativeHandle(ref3, function() {
    return {
      delayHidden
    };
  });
  var scrollbarPrefixCls = "".concat(prefixCls, "-scrollbar");
  var containerStyle = {
    position: "absolute",
    visibility: visible ? null : "hidden"
  };
  var thumbStyle = {
    position: "absolute",
    borderRadius: 99,
    background: "var(--rc-virtual-list-scrollbar-bg, rgba(0, 0, 0, 0.5))",
    cursor: "pointer",
    userSelect: "none"
  };
  if (horizontal) {
    Object.assign(containerStyle, {
      height: 8,
      left: 0,
      right: 0,
      bottom: 0
    });
    Object.assign(thumbStyle, _defineProperty({
      height: "100%",
      width: spinSize
    }, isLTR ? "left" : "right", top));
  } else {
    Object.assign(containerStyle, _defineProperty({
      width: 8,
      top: 0,
      bottom: 0
    }, isLTR ? "right" : "left", 0));
    Object.assign(thumbStyle, {
      width: "100%",
      height: spinSize,
      top
    });
  }
  return /* @__PURE__ */ React163.createElement("div", {
    ref: scrollbarRef,
    className: (0, import_classnames50.default)(scrollbarPrefixCls, _defineProperty(_defineProperty(_defineProperty({}, "".concat(scrollbarPrefixCls, "-horizontal"), horizontal), "".concat(scrollbarPrefixCls, "-vertical"), !horizontal), "".concat(scrollbarPrefixCls, "-visible"), visible)),
    style: _objectSpread2(_objectSpread2({}, containerStyle), style2),
    onMouseDown: onContainerMouseDown,
    onMouseMove: delayHidden
  }, /* @__PURE__ */ React163.createElement("div", {
    ref: thumbRef,
    className: (0, import_classnames50.default)("".concat(scrollbarPrefixCls, "-thumb"), _defineProperty({}, "".concat(scrollbarPrefixCls, "-thumb-moving"), dragging)),
    style: _objectSpread2(_objectSpread2({}, thumbStyle), propsThumbStyle),
    onMouseDown: onThumbMouseDown
  }));
});
if (true) {
  ScrollBar.displayName = "ScrollBar";
}
var ScrollBar_default = ScrollBar;

// ../../node_modules/rc-virtual-list/es/utils/scrollbarUtil.js
var MIN_SIZE = 20;
function getSpinSize() {
  var containerSize = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
  var scrollRange = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  var baseSize = containerSize / scrollRange * containerSize;
  if (isNaN(baseSize)) {
    baseSize = 0;
  }
  baseSize = Math.max(baseSize, MIN_SIZE);
  return Math.floor(baseSize);
}

// ../../node_modules/rc-virtual-list/es/List.js
var _excluded20 = ["prefixCls", "className", "height", "itemHeight", "fullHeight", "style", "data", "children", "itemKey", "virtual", "direction", "scrollWidth", "component", "onScroll", "onVirtualScroll", "onVisibleChange", "innerProps", "extraRender", "styles", "showScrollBar"];
var EMPTY_DATA = [];
var ScrollStyle = {
  overflowY: "auto",
  overflowAnchor: "none"
};
function RawList(props, ref3) {
  var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-virtual-list" : _props$prefixCls, className2 = props.className, height = props.height, itemHeight = props.itemHeight, _props$fullHeight = props.fullHeight, fullHeight = _props$fullHeight === void 0 ? true : _props$fullHeight, style2 = props.style, data2 = props.data, children = props.children, itemKey3 = props.itemKey, virtual = props.virtual, direction = props.direction, scrollWidth = props.scrollWidth, _props$component = props.component, Component10 = _props$component === void 0 ? "div" : _props$component, onScroll = props.onScroll, onVirtualScroll = props.onVirtualScroll, onVisibleChange = props.onVisibleChange, innerProps = props.innerProps, extraRender = props.extraRender, styles = props.styles, _props$showScrollBar = props.showScrollBar, showScrollBar = _props$showScrollBar === void 0 ? "optional" : _props$showScrollBar, restProps = _objectWithoutProperties(props, _excluded20);
  var getKey5 = React164.useCallback(function(item) {
    if (typeof itemKey3 === "function") {
      return itemKey3(item);
    }
    return item === null || item === void 0 ? void 0 : item[itemKey3];
  }, [itemKey3]);
  var _useHeights = useHeights(getKey5, null, null), _useHeights2 = _slicedToArray(_useHeights, 4), setInstanceRef = _useHeights2[0], collectHeight = _useHeights2[1], heights = _useHeights2[2], heightUpdatedMark = _useHeights2[3];
  var useVirtual = !!(virtual !== false && height && itemHeight);
  var containerHeight = React164.useMemo(function() {
    return Object.values(heights.maps).reduce(function(total, curr) {
      return total + curr;
    }, 0);
  }, [heights.id, heights.maps]);
  var inVirtual = useVirtual && data2 && (Math.max(itemHeight * data2.length, containerHeight) > height || !!scrollWidth);
  var isRTL = direction === "rtl";
  var mergedClassName = (0, import_classnames51.default)(prefixCls, _defineProperty({}, "".concat(prefixCls, "-rtl"), isRTL), className2);
  var mergedData = data2 || EMPTY_DATA;
  var componentRef = (0, import_react67.useRef)();
  var fillerInnerRef = (0, import_react67.useRef)();
  var containerRef = (0, import_react67.useRef)();
  var _useState = (0, import_react67.useState)(0), _useState2 = _slicedToArray(_useState, 2), offsetTop = _useState2[0], setOffsetTop = _useState2[1];
  var _useState3 = (0, import_react67.useState)(0), _useState4 = _slicedToArray(_useState3, 2), offsetLeft = _useState4[0], setOffsetLeft = _useState4[1];
  var _useState5 = (0, import_react67.useState)(false), _useState6 = _slicedToArray(_useState5, 2), scrollMoving = _useState6[0], setScrollMoving = _useState6[1];
  var onScrollbarStartMove = function onScrollbarStartMove2() {
    setScrollMoving(true);
  };
  var onScrollbarStopMove = function onScrollbarStopMove2() {
    setScrollMoving(false);
  };
  var sharedConfig = {
    getKey: getKey5
  };
  function syncScrollTop(newTop) {
    setOffsetTop(function(origin) {
      var value;
      if (typeof newTop === "function") {
        value = newTop(origin);
      } else {
        value = newTop;
      }
      var alignedTop = keepInRange(value);
      componentRef.current.scrollTop = alignedTop;
      return alignedTop;
    });
  }
  var rangeRef = (0, import_react67.useRef)({
    start: 0,
    end: mergedData.length
  });
  var diffItemRef = (0, import_react67.useRef)();
  var _useDiffItem = useDiffItem(mergedData, getKey5), _useDiffItem2 = _slicedToArray(_useDiffItem, 1), diffItem = _useDiffItem2[0];
  diffItemRef.current = diffItem;
  var _React$useMemo = React164.useMemo(function() {
    if (!useVirtual) {
      return {
        scrollHeight: void 0,
        start: 0,
        end: mergedData.length - 1,
        offset: void 0
      };
    }
    if (!inVirtual) {
      var _fillerInnerRef$curre;
      return {
        scrollHeight: ((_fillerInnerRef$curre = fillerInnerRef.current) === null || _fillerInnerRef$curre === void 0 ? void 0 : _fillerInnerRef$curre.offsetHeight) || 0,
        start: 0,
        end: mergedData.length - 1,
        offset: void 0
      };
    }
    var itemTop = 0;
    var startIndex;
    var startOffset;
    var endIndex;
    var dataLen = mergedData.length;
    for (var i = 0; i < dataLen; i += 1) {
      var _item = mergedData[i];
      var key2 = getKey5(_item);
      var cacheHeight = heights.get(key2);
      var currentItemBottom = itemTop + (cacheHeight === void 0 ? itemHeight : cacheHeight);
      if (currentItemBottom >= offsetTop && startIndex === void 0) {
        startIndex = i;
        startOffset = itemTop;
      }
      if (currentItemBottom > offsetTop + height && endIndex === void 0) {
        endIndex = i;
      }
      itemTop = currentItemBottom;
    }
    if (startIndex === void 0) {
      startIndex = 0;
      startOffset = 0;
      endIndex = Math.ceil(height / itemHeight);
    }
    if (endIndex === void 0) {
      endIndex = mergedData.length - 1;
    }
    endIndex = Math.min(endIndex + 1, mergedData.length - 1);
    return {
      scrollHeight: itemTop,
      start: startIndex,
      end: endIndex,
      offset: startOffset
    };
  }, [inVirtual, useVirtual, offsetTop, mergedData, heightUpdatedMark, height]), scrollHeight = _React$useMemo.scrollHeight, start = _React$useMemo.start, end = _React$useMemo.end, fillerOffset = _React$useMemo.offset;
  rangeRef.current.start = start;
  rangeRef.current.end = end;
  React164.useLayoutEffect(function() {
    var changedRecord = heights.getRecord();
    if (changedRecord.size === 1) {
      var recordKey = Array.from(changedRecord.keys())[0];
      var prevCacheHeight = changedRecord.get(recordKey);
      var startItem = mergedData[start];
      if (startItem && prevCacheHeight === void 0) {
        var startIndexKey = getKey5(startItem);
        if (startIndexKey === recordKey) {
          var realStartHeight = heights.get(recordKey);
          var diffHeight = realStartHeight - itemHeight;
          syncScrollTop(function(ori) {
            return ori + diffHeight;
          });
        }
      }
    }
    heights.resetRecord();
  }, [scrollHeight]);
  var _React$useState = React164.useState({
    width: 0,
    height
  }), _React$useState2 = _slicedToArray(_React$useState, 2), size = _React$useState2[0], setSize = _React$useState2[1];
  var onHolderResize = function onHolderResize2(sizeInfo) {
    setSize({
      width: sizeInfo.offsetWidth,
      height: sizeInfo.offsetHeight
    });
  };
  var verticalScrollBarRef = (0, import_react67.useRef)();
  var horizontalScrollBarRef = (0, import_react67.useRef)();
  var horizontalScrollBarSpinSize = React164.useMemo(function() {
    return getSpinSize(size.width, scrollWidth);
  }, [size.width, scrollWidth]);
  var verticalScrollBarSpinSize = React164.useMemo(function() {
    return getSpinSize(size.height, scrollHeight);
  }, [size.height, scrollHeight]);
  var maxScrollHeight = scrollHeight - height;
  var maxScrollHeightRef = (0, import_react67.useRef)(maxScrollHeight);
  maxScrollHeightRef.current = maxScrollHeight;
  function keepInRange(newScrollTop) {
    var newTop = newScrollTop;
    if (!Number.isNaN(maxScrollHeightRef.current)) {
      newTop = Math.min(newTop, maxScrollHeightRef.current);
    }
    newTop = Math.max(newTop, 0);
    return newTop;
  }
  var isScrollAtTop = offsetTop <= 0;
  var isScrollAtBottom = offsetTop >= maxScrollHeight;
  var isScrollAtLeft = offsetLeft <= 0;
  var isScrollAtRight = offsetLeft >= scrollWidth;
  var originScroll = useOriginScroll_default(isScrollAtTop, isScrollAtBottom, isScrollAtLeft, isScrollAtRight);
  var getVirtualScrollInfo = function getVirtualScrollInfo2() {
    return {
      x: isRTL ? -offsetLeft : offsetLeft,
      y: offsetTop
    };
  };
  var lastVirtualScrollInfoRef = (0, import_react67.useRef)(getVirtualScrollInfo());
  var triggerScroll = useEvent2(function(params) {
    if (onVirtualScroll) {
      var nextInfo = _objectSpread2(_objectSpread2({}, getVirtualScrollInfo()), params);
      if (lastVirtualScrollInfoRef.current.x !== nextInfo.x || lastVirtualScrollInfoRef.current.y !== nextInfo.y) {
        onVirtualScroll(nextInfo);
        lastVirtualScrollInfoRef.current = nextInfo;
      }
    }
  });
  function onScrollBar(newScrollOffset, horizontal) {
    var newOffset = newScrollOffset;
    if (horizontal) {
      (0, import_react_dom7.flushSync)(function() {
        setOffsetLeft(newOffset);
      });
      triggerScroll();
    } else {
      syncScrollTop(newOffset);
    }
  }
  function onFallbackScroll(e3) {
    var newScrollTop = e3.currentTarget.scrollTop;
    if (newScrollTop !== offsetTop) {
      syncScrollTop(newScrollTop);
    }
    onScroll === null || onScroll === void 0 || onScroll(e3);
    triggerScroll();
  }
  var keepInHorizontalRange = function keepInHorizontalRange2(nextOffsetLeft) {
    var tmpOffsetLeft = nextOffsetLeft;
    var max = !!scrollWidth ? scrollWidth - size.width : 0;
    tmpOffsetLeft = Math.max(tmpOffsetLeft, 0);
    tmpOffsetLeft = Math.min(tmpOffsetLeft, max);
    return tmpOffsetLeft;
  };
  var onWheelDelta = useEvent2(function(offsetXY, fromHorizontal) {
    if (fromHorizontal) {
      (0, import_react_dom7.flushSync)(function() {
        setOffsetLeft(function(left2) {
          var nextOffsetLeft = left2 + (isRTL ? -offsetXY : offsetXY);
          return keepInHorizontalRange(nextOffsetLeft);
        });
      });
      triggerScroll();
    } else {
      syncScrollTop(function(top) {
        var newTop = top + offsetXY;
        return newTop;
      });
    }
  });
  var _useFrameWheel = useFrameWheel(useVirtual, isScrollAtTop, isScrollAtBottom, isScrollAtLeft, isScrollAtRight, !!scrollWidth, onWheelDelta), _useFrameWheel2 = _slicedToArray(_useFrameWheel, 2), onRawWheel = _useFrameWheel2[0], onFireFoxScroll = _useFrameWheel2[1];
  useMobileTouchMove(useVirtual, componentRef, function(isHorizontal, delta, smoothOffset, e3) {
    var event = e3;
    if (originScroll(isHorizontal, delta, smoothOffset)) {
      return false;
    }
    if (!event || !event._virtualHandled) {
      if (event) {
        event._virtualHandled = true;
      }
      onRawWheel({
        preventDefault: function preventDefault2() {
        },
        deltaX: isHorizontal ? delta : 0,
        deltaY: isHorizontal ? 0 : delta
      });
      return true;
    }
    return false;
  });
  useScrollDrag(inVirtual, componentRef, function(offset4) {
    syncScrollTop(function(top) {
      return top + offset4;
    });
  });
  useLayoutEffect_default(function() {
    function onMozMousePixelScroll(e3) {
      var scrollingUpAtTop = isScrollAtTop && e3.detail < 0;
      var scrollingDownAtBottom = isScrollAtBottom && e3.detail > 0;
      if (useVirtual && !scrollingUpAtTop && !scrollingDownAtBottom) {
        e3.preventDefault();
      }
    }
    var componentEle = componentRef.current;
    componentEle.addEventListener("wheel", onRawWheel, {
      passive: false
    });
    componentEle.addEventListener("DOMMouseScroll", onFireFoxScroll, {
      passive: true
    });
    componentEle.addEventListener("MozMousePixelScroll", onMozMousePixelScroll, {
      passive: false
    });
    return function() {
      componentEle.removeEventListener("wheel", onRawWheel);
      componentEle.removeEventListener("DOMMouseScroll", onFireFoxScroll);
      componentEle.removeEventListener("MozMousePixelScroll", onMozMousePixelScroll);
    };
  }, [useVirtual, isScrollAtTop, isScrollAtBottom]);
  useLayoutEffect_default(function() {
    if (scrollWidth) {
      var newOffsetLeft = keepInHorizontalRange(offsetLeft);
      setOffsetLeft(newOffsetLeft);
      triggerScroll({
        x: newOffsetLeft
      });
    }
  }, [size.width, scrollWidth]);
  var delayHideScrollBar = function delayHideScrollBar2() {
    var _verticalScrollBarRef, _horizontalScrollBarR;
    (_verticalScrollBarRef = verticalScrollBarRef.current) === null || _verticalScrollBarRef === void 0 || _verticalScrollBarRef.delayHidden();
    (_horizontalScrollBarR = horizontalScrollBarRef.current) === null || _horizontalScrollBarR === void 0 || _horizontalScrollBarR.delayHidden();
  };
  var _scrollTo = useScrollTo(componentRef, mergedData, heights, itemHeight, getKey5, function() {
    return collectHeight(true);
  }, syncScrollTop, delayHideScrollBar);
  React164.useImperativeHandle(ref3, function() {
    return {
      nativeElement: containerRef.current,
      getScrollInfo: getVirtualScrollInfo,
      scrollTo: function scrollTo2(config) {
        function isPosScroll(arg) {
          return arg && _typeof(arg) === "object" && ("left" in arg || "top" in arg);
        }
        if (isPosScroll(config)) {
          if (config.left !== void 0) {
            setOffsetLeft(keepInHorizontalRange(config.left));
          }
          _scrollTo(config.top);
        } else {
          _scrollTo(config);
        }
      }
    };
  });
  useLayoutEffect_default(function() {
    if (onVisibleChange) {
      var renderList = mergedData.slice(start, end + 1);
      onVisibleChange(renderList, mergedData);
    }
  }, [start, end, mergedData]);
  var getSize5 = useGetSize(mergedData, getKey5, heights, itemHeight);
  var extraContent = extraRender === null || extraRender === void 0 ? void 0 : extraRender({
    start,
    end,
    virtual: inVirtual,
    offsetX: offsetLeft,
    offsetY: fillerOffset,
    rtl: isRTL,
    getSize: getSize5
  });
  var listChildren = useChildren(mergedData, start, end, scrollWidth, offsetLeft, setInstanceRef, children, sharedConfig);
  var componentStyle = null;
  if (height) {
    componentStyle = _objectSpread2(_defineProperty({}, fullHeight ? "height" : "maxHeight", height), ScrollStyle);
    if (useVirtual) {
      componentStyle.overflowY = "hidden";
      if (scrollWidth) {
        componentStyle.overflowX = "hidden";
      }
      if (scrollMoving) {
        componentStyle.pointerEvents = "none";
      }
    }
  }
  var containerProps = {};
  if (isRTL) {
    containerProps.dir = "rtl";
  }
  return /* @__PURE__ */ React164.createElement("div", _extends({
    ref: containerRef,
    style: _objectSpread2(_objectSpread2({}, style2), {}, {
      position: "relative"
    }),
    className: mergedClassName
  }, containerProps, restProps), /* @__PURE__ */ React164.createElement(es_default, {
    onResize: onHolderResize
  }, /* @__PURE__ */ React164.createElement(Component10, {
    className: "".concat(prefixCls, "-holder"),
    style: componentStyle,
    ref: componentRef,
    onScroll: onFallbackScroll,
    onMouseEnter: delayHideScrollBar
  }, /* @__PURE__ */ React164.createElement(Filler_default, {
    prefixCls,
    height: scrollHeight,
    offsetX: offsetLeft,
    offsetY: fillerOffset,
    scrollWidth,
    onInnerResize: collectHeight,
    ref: fillerInnerRef,
    innerProps,
    rtl: isRTL,
    extra: extraContent
  }, listChildren))), inVirtual && scrollHeight > height && /* @__PURE__ */ React164.createElement(ScrollBar_default, {
    ref: verticalScrollBarRef,
    prefixCls,
    scrollOffset: offsetTop,
    scrollRange: scrollHeight,
    rtl: isRTL,
    onScroll: onScrollBar,
    onStartMove: onScrollbarStartMove,
    onStopMove: onScrollbarStopMove,
    spinSize: verticalScrollBarSpinSize,
    containerSize: size.height,
    style: styles === null || styles === void 0 ? void 0 : styles.verticalScrollBar,
    thumbStyle: styles === null || styles === void 0 ? void 0 : styles.verticalScrollBarThumb,
    showScrollBar
  }), inVirtual && scrollWidth > size.width && /* @__PURE__ */ React164.createElement(ScrollBar_default, {
    ref: horizontalScrollBarRef,
    prefixCls,
    scrollOffset: offsetLeft,
    scrollRange: scrollWidth,
    rtl: isRTL,
    onScroll: onScrollBar,
    onStartMove: onScrollbarStartMove,
    onStopMove: onScrollbarStopMove,
    spinSize: horizontalScrollBarSpinSize,
    containerSize: size.width,
    horizontal: true,
    style: styles === null || styles === void 0 ? void 0 : styles.horizontalScrollBar,
    thumbStyle: styles === null || styles === void 0 ? void 0 : styles.horizontalScrollBarThumb,
    showScrollBar
  }));
}
var List2 = /* @__PURE__ */ React164.forwardRef(RawList);
List2.displayName = "List";
var List_default2 = List2;

// ../../node_modules/rc-virtual-list/es/index.js
var es_default10 = List_default2;

// ../../node_modules/rc-select/es/OptionList.js
var React165 = __toESM(require_react());
var import_react68 = __toESM(require_react());

// ../../node_modules/rc-select/es/utils/platformUtil.js
function isPlatformMac() {
  return /(mac\sos|macintosh)/i.test(navigator.appVersion);
}

// ../../node_modules/rc-select/es/OptionList.js
var _excluded21 = ["disabled", "title", "children", "style", "className"];
function isTitleType2(content) {
  return typeof content === "string" || typeof content === "number";
}
var OptionList = function OptionList2(_, ref3) {
  var _useBaseProps = useBaseProps(), prefixCls = _useBaseProps.prefixCls, id = _useBaseProps.id, open2 = _useBaseProps.open, multiple = _useBaseProps.multiple, mode = _useBaseProps.mode, searchValue = _useBaseProps.searchValue, toggleOpen = _useBaseProps.toggleOpen, notFoundContent = _useBaseProps.notFoundContent, onPopupScroll = _useBaseProps.onPopupScroll;
  var _React$useContext = React165.useContext(SelectContext_default), maxCount = _React$useContext.maxCount, flattenOptions2 = _React$useContext.flattenOptions, onActiveValue = _React$useContext.onActiveValue, defaultActiveFirstOption = _React$useContext.defaultActiveFirstOption, onSelect = _React$useContext.onSelect, menuItemSelectedIcon = _React$useContext.menuItemSelectedIcon, rawValues = _React$useContext.rawValues, fieldNames = _React$useContext.fieldNames, virtual = _React$useContext.virtual, direction = _React$useContext.direction, listHeight = _React$useContext.listHeight, listItemHeight = _React$useContext.listItemHeight, optionRender = _React$useContext.optionRender;
  var itemPrefixCls = "".concat(prefixCls, "-item");
  var memoFlattenOptions = useMemo3(function() {
    return flattenOptions2;
  }, [open2, flattenOptions2], function(prev2, next2) {
    return next2[0] && prev2[1] !== next2[1];
  });
  var listRef = React165.useRef(null);
  var overMaxCount = React165.useMemo(function() {
    return multiple && isValidCount(maxCount) && (rawValues === null || rawValues === void 0 ? void 0 : rawValues.size) >= maxCount;
  }, [multiple, maxCount, rawValues === null || rawValues === void 0 ? void 0 : rawValues.size]);
  var onListMouseDown = function onListMouseDown2(event) {
    event.preventDefault();
  };
  var scrollIntoView = function scrollIntoView2(args) {
    var _listRef$current;
    (_listRef$current = listRef.current) === null || _listRef$current === void 0 || _listRef$current.scrollTo(typeof args === "number" ? {
      index: args
    } : args);
  };
  var isSelected = React165.useCallback(function(value) {
    if (mode === "combobox") {
      return false;
    }
    return rawValues.has(value);
  }, [mode, _toConsumableArray(rawValues).toString(), rawValues.size]);
  var getEnabledActiveIndex = function getEnabledActiveIndex2(index3) {
    var offset4 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    var len = memoFlattenOptions.length;
    for (var i = 0; i < len; i += 1) {
      var current2 = (index3 + i * offset4 + len) % len;
      var _ref = memoFlattenOptions[current2] || {}, group = _ref.group, data2 = _ref.data;
      if (!group && !(data2 !== null && data2 !== void 0 && data2.disabled) && (isSelected(data2.value) || !overMaxCount)) {
        return current2;
      }
    }
    return -1;
  };
  var _React$useState = React165.useState(function() {
    return getEnabledActiveIndex(0);
  }), _React$useState2 = _slicedToArray(_React$useState, 2), activeIndex = _React$useState2[0], setActiveIndex = _React$useState2[1];
  var setActive = function setActive2(index3) {
    var fromKeyboard = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    setActiveIndex(index3);
    var info = {
      source: fromKeyboard ? "keyboard" : "mouse"
    };
    var flattenItem = memoFlattenOptions[index3];
    if (!flattenItem) {
      onActiveValue(null, -1, info);
      return;
    }
    onActiveValue(flattenItem.value, index3, info);
  };
  (0, import_react68.useEffect)(function() {
    setActive(defaultActiveFirstOption !== false ? getEnabledActiveIndex(0) : -1);
  }, [memoFlattenOptions.length, searchValue]);
  var isAriaSelected = React165.useCallback(function(value) {
    if (mode === "combobox") {
      return String(value).toLowerCase() === searchValue.toLowerCase();
    }
    return rawValues.has(value);
  }, [mode, searchValue, _toConsumableArray(rawValues).toString(), rawValues.size]);
  (0, import_react68.useEffect)(function() {
    var timeoutId = setTimeout(function() {
      if (!multiple && open2 && rawValues.size === 1) {
        var value = Array.from(rawValues)[0];
        var index3 = memoFlattenOptions.findIndex(function(_ref2) {
          var data2 = _ref2.data;
          return searchValue ? String(data2.value).startsWith(searchValue) : data2.value === value;
        });
        if (index3 !== -1) {
          setActive(index3);
          scrollIntoView(index3);
        }
      }
    });
    if (open2) {
      var _listRef$current2;
      (_listRef$current2 = listRef.current) === null || _listRef$current2 === void 0 || _listRef$current2.scrollTo(void 0);
    }
    return function() {
      return clearTimeout(timeoutId);
    };
  }, [open2, searchValue]);
  var onSelectValue = function onSelectValue2(value) {
    if (value !== void 0) {
      onSelect(value, {
        selected: !rawValues.has(value)
      });
    }
    if (!multiple) {
      toggleOpen(false);
    }
  };
  React165.useImperativeHandle(ref3, function() {
    return {
      onKeyDown: function onKeyDown2(event) {
        var which = event.which, ctrlKey = event.ctrlKey;
        switch (which) {
          // >>> Arrow keys & ctrl + n/p on Mac
          case KeyCode_default.N:
          case KeyCode_default.P:
          case KeyCode_default.UP:
          case KeyCode_default.DOWN: {
            var offset4 = 0;
            if (which === KeyCode_default.UP) {
              offset4 = -1;
            } else if (which === KeyCode_default.DOWN) {
              offset4 = 1;
            } else if (isPlatformMac() && ctrlKey) {
              if (which === KeyCode_default.N) {
                offset4 = 1;
              } else if (which === KeyCode_default.P) {
                offset4 = -1;
              }
            }
            if (offset4 !== 0) {
              var nextActiveIndex = getEnabledActiveIndex(activeIndex + offset4, offset4);
              scrollIntoView(nextActiveIndex);
              setActive(nextActiveIndex, true);
            }
            break;
          }
          // >>> Select (Tab / Enter)
          case KeyCode_default.TAB:
          case KeyCode_default.ENTER: {
            var _item$data;
            var item = memoFlattenOptions[activeIndex];
            if (item && !(item !== null && item !== void 0 && (_item$data = item.data) !== null && _item$data !== void 0 && _item$data.disabled) && !overMaxCount) {
              onSelectValue(item.value);
            } else {
              onSelectValue(void 0);
            }
            if (open2) {
              event.preventDefault();
            }
            break;
          }
          // >>> Close
          case KeyCode_default.ESC: {
            toggleOpen(false);
            if (open2) {
              event.stopPropagation();
            }
          }
        }
      },
      onKeyUp: function onKeyUp() {
      },
      scrollTo: function scrollTo2(index3) {
        scrollIntoView(index3);
      }
    };
  });
  if (memoFlattenOptions.length === 0) {
    return /* @__PURE__ */ React165.createElement("div", {
      role: "listbox",
      id: "".concat(id, "_list"),
      className: "".concat(itemPrefixCls, "-empty"),
      onMouseDown: onListMouseDown
    }, notFoundContent);
  }
  var omitFieldNameList = Object.keys(fieldNames).map(function(key2) {
    return fieldNames[key2];
  });
  var getLabel5 = function getLabel6(item) {
    return item.label;
  };
  function getItemAriaProps(item, index3) {
    var group = item.group;
    return {
      role: group ? "presentation" : "option",
      id: "".concat(id, "_list_").concat(index3)
    };
  }
  var renderItem3 = function renderItem4(index3) {
    var item = memoFlattenOptions[index3];
    if (!item) {
      return null;
    }
    var itemData = item.data || {};
    var value = itemData.value;
    var group = item.group;
    var attrs = pickAttrs(itemData, true);
    var mergedLabel = getLabel5(item);
    return item ? /* @__PURE__ */ React165.createElement("div", _extends({
      "aria-label": typeof mergedLabel === "string" && !group ? mergedLabel : null
    }, attrs, {
      key: index3
    }, getItemAriaProps(item, index3), {
      "aria-selected": isAriaSelected(value)
    }), value) : null;
  };
  var a11yProps = {
    role: "listbox",
    id: "".concat(id, "_list")
  };
  return /* @__PURE__ */ React165.createElement(React165.Fragment, null, virtual && /* @__PURE__ */ React165.createElement("div", _extends({}, a11yProps, {
    style: {
      height: 0,
      width: 0,
      overflow: "hidden"
    }
  }), renderItem3(activeIndex - 1), renderItem3(activeIndex), renderItem3(activeIndex + 1)), /* @__PURE__ */ React165.createElement(es_default10, {
    itemKey: "key",
    ref: listRef,
    data: memoFlattenOptions,
    height: listHeight,
    itemHeight: listItemHeight,
    fullHeight: false,
    onMouseDown: onListMouseDown,
    onScroll: onPopupScroll,
    virtual,
    direction,
    innerProps: virtual ? null : a11yProps
  }, function(item, itemIndex) {
    var group = item.group, groupOption = item.groupOption, data2 = item.data, label = item.label, value = item.value;
    var key2 = data2.key;
    if (group) {
      var _data$title;
      var groupTitle = (_data$title = data2.title) !== null && _data$title !== void 0 ? _data$title : isTitleType2(label) ? label.toString() : void 0;
      return /* @__PURE__ */ React165.createElement("div", {
        className: (0, import_classnames52.default)(itemPrefixCls, "".concat(itemPrefixCls, "-group"), data2.className),
        title: groupTitle
      }, label !== void 0 ? label : key2);
    }
    var disabled = data2.disabled, title = data2.title, children = data2.children, style2 = data2.style, className2 = data2.className, otherProps = _objectWithoutProperties(data2, _excluded21);
    var passedProps = omit(otherProps, omitFieldNameList);
    var selected = isSelected(value);
    var mergedDisabled = disabled || !selected && overMaxCount;
    var optionPrefixCls = "".concat(itemPrefixCls, "-option");
    var optionClassName = (0, import_classnames52.default)(itemPrefixCls, optionPrefixCls, className2, _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "".concat(optionPrefixCls, "-grouped"), groupOption), "".concat(optionPrefixCls, "-active"), activeIndex === itemIndex && !mergedDisabled), "".concat(optionPrefixCls, "-disabled"), mergedDisabled), "".concat(optionPrefixCls, "-selected"), selected));
    var mergedLabel = getLabel5(item);
    var iconVisible = !menuItemSelectedIcon || typeof menuItemSelectedIcon === "function" || selected;
    var content = typeof mergedLabel === "number" ? mergedLabel : mergedLabel || value;
    var optionTitle = isTitleType2(content) ? content.toString() : void 0;
    if (title !== void 0) {
      optionTitle = title;
    }
    return /* @__PURE__ */ React165.createElement("div", _extends({}, pickAttrs(passedProps), !virtual ? getItemAriaProps(item, itemIndex) : {}, {
      "aria-selected": isAriaSelected(value),
      className: optionClassName,
      title: optionTitle,
      onMouseMove: function onMouseMove() {
        if (activeIndex === itemIndex || mergedDisabled) {
          return;
        }
        setActive(itemIndex);
      },
      onClick: function onClick() {
        if (!mergedDisabled) {
          onSelectValue(value);
        }
      },
      style: style2
    }), /* @__PURE__ */ React165.createElement("div", {
      className: "".concat(optionPrefixCls, "-content")
    }, typeof optionRender === "function" ? optionRender(item, {
      index: itemIndex
    }) : content), /* @__PURE__ */ React165.isValidElement(menuItemSelectedIcon) || selected, iconVisible && /* @__PURE__ */ React165.createElement(TransBtn_default, {
      className: "".concat(itemPrefixCls, "-option-state"),
      customizeIcon: menuItemSelectedIcon,
      customizeIconProps: {
        value,
        disabled: mergedDisabled,
        isSelected: selected
      }
    }, selected ? "\u2713" : null));
  }));
};
var RefOptionList = /* @__PURE__ */ React165.forwardRef(OptionList);
if (true) {
  RefOptionList.displayName = "OptionList";
}
var OptionList_default = RefOptionList;

// ../../node_modules/rc-select/es/hooks/useCache.js
var React166 = __toESM(require_react());
var useCache_default = (function(labeledValues, valueOptions) {
  var cacheRef = React166.useRef({
    values: /* @__PURE__ */ new Map(),
    options: /* @__PURE__ */ new Map()
  });
  var filledLabeledValues = React166.useMemo(function() {
    var _cacheRef$current = cacheRef.current, prevValueCache = _cacheRef$current.values, prevOptionCache = _cacheRef$current.options;
    var patchedValues = labeledValues.map(function(item) {
      if (item.label === void 0) {
        var _prevValueCache$get;
        return _objectSpread2(_objectSpread2({}, item), {}, {
          label: (_prevValueCache$get = prevValueCache.get(item.value)) === null || _prevValueCache$get === void 0 ? void 0 : _prevValueCache$get.label
        });
      }
      return item;
    });
    var valueCache = /* @__PURE__ */ new Map();
    var optionCache = /* @__PURE__ */ new Map();
    patchedValues.forEach(function(item) {
      valueCache.set(item.value, item);
      optionCache.set(item.value, valueOptions.get(item.value) || prevOptionCache.get(item.value));
    });
    cacheRef.current.values = valueCache;
    cacheRef.current.options = optionCache;
    return patchedValues;
  }, [labeledValues, valueOptions]);
  var getOption = React166.useCallback(function(val) {
    return valueOptions.get(val) || cacheRef.current.options.get(val);
  }, [valueOptions]);
  return [filledLabeledValues, getOption];
});

// ../../node_modules/rc-select/es/hooks/useFilterOptions.js
var React167 = __toESM(require_react());
function includes(test, search) {
  return toArray3(test).join("").toUpperCase().includes(search);
}
var useFilterOptions_default = (function(options, fieldNames, searchValue, filterOption, optionFilterProp) {
  return React167.useMemo(function() {
    if (!searchValue || filterOption === false) {
      return options;
    }
    var fieldOptions = fieldNames.options, fieldLabel = fieldNames.label, fieldValue = fieldNames.value;
    var filteredOptions = [];
    var customizeFilter = typeof filterOption === "function";
    var upperSearch = searchValue.toUpperCase();
    var filterFunc = customizeFilter ? filterOption : function(_, option) {
      if (optionFilterProp) {
        return includes(option[optionFilterProp], upperSearch);
      }
      if (option[fieldOptions]) {
        return includes(option[fieldLabel !== "children" ? fieldLabel : "label"], upperSearch);
      }
      return includes(option[fieldValue], upperSearch);
    };
    var wrapOption = customizeFilter ? function(opt) {
      return injectPropsWithOption(opt);
    } : function(opt) {
      return opt;
    };
    options.forEach(function(item) {
      if (item[fieldOptions]) {
        var matchGroup = filterFunc(searchValue, wrapOption(item));
        if (matchGroup) {
          filteredOptions.push(item);
        } else {
          var subOptions = item[fieldOptions].filter(function(subItem) {
            return filterFunc(searchValue, wrapOption(subItem));
          });
          if (subOptions.length) {
            filteredOptions.push(_objectSpread2(_objectSpread2({}, item), {}, _defineProperty({}, fieldOptions, subOptions)));
          }
        }
        return;
      }
      if (filterFunc(searchValue, wrapOption(item))) {
        filteredOptions.push(item);
      }
    });
    return filteredOptions;
  }, [options, filterOption, optionFilterProp, searchValue, fieldNames]);
});

// ../../node_modules/rc-select/es/hooks/useId.js
var React168 = __toESM(require_react());
var uuid5 = 0;
var isBrowserClient2 = canUseDom();
function getUUID() {
  var retId;
  if (isBrowserClient2) {
    retId = uuid5;
    uuid5 += 1;
  } else {
    retId = "TEST_OR_SSR";
  }
  return retId;
}
function useId3(id) {
  var _React$useState = React168.useState(), _React$useState2 = _slicedToArray(_React$useState, 2), innerId = _React$useState2[0], setInnerId = _React$useState2[1];
  React168.useEffect(function() {
    setInnerId("rc_select_".concat(getUUID()));
  }, []);
  return id || innerId;
}

// ../../node_modules/rc-select/es/hooks/useOptions.js
var React170 = __toESM(require_react());

// ../../node_modules/rc-select/es/utils/legacyUtil.js
var React169 = __toESM(require_react());
var _excluded25 = ["children", "value"];
var _excluded26 = ["children"];
function convertNodeToOption(node2) {
  var _ref = node2, key2 = _ref.key, _ref$props = _ref.props, children = _ref$props.children, value = _ref$props.value, restProps = _objectWithoutProperties(_ref$props, _excluded25);
  return _objectSpread2({
    key: key2,
    value: value !== void 0 ? value : key2,
    children
  }, restProps);
}
function convertChildrenToData(nodes) {
  var optionOnly = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
  return toArray(nodes).map(function(node2, index3) {
    if (!/* @__PURE__ */ React169.isValidElement(node2) || !node2.type) {
      return null;
    }
    var _ref2 = node2, isSelectOptGroup = _ref2.type.isSelectOptGroup, key2 = _ref2.key, _ref2$props = _ref2.props, children = _ref2$props.children, restProps = _objectWithoutProperties(_ref2$props, _excluded26);
    if (optionOnly || !isSelectOptGroup) {
      return convertNodeToOption(node2);
    }
    return _objectSpread2(_objectSpread2({
      key: "__RC_SELECT_GRP__".concat(key2 === null ? index3 : key2, "__"),
      label: key2
    }, restProps), {}, {
      options: convertChildrenToData(children)
    });
  }).filter(function(data2) {
    return data2;
  });
}

// ../../node_modules/rc-select/es/hooks/useOptions.js
var useOptions = function useOptions2(options, children, fieldNames, optionFilterProp, optionLabelProp) {
  return React170.useMemo(function() {
    var mergedOptions = options;
    var childrenAsData = !options;
    if (childrenAsData) {
      mergedOptions = convertChildrenToData(children);
    }
    var valueOptions = /* @__PURE__ */ new Map();
    var labelOptions = /* @__PURE__ */ new Map();
    var setLabelOptions = function setLabelOptions2(labelOptionsMap, option, key2) {
      if (key2 && typeof key2 === "string") {
        labelOptionsMap.set(option[key2], option);
      }
    };
    var dig = function dig2(optionList) {
      var isChildren = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
      for (var i = 0; i < optionList.length; i += 1) {
        var option = optionList[i];
        if (!option[fieldNames.options] || isChildren) {
          valueOptions.set(option[fieldNames.value], option);
          setLabelOptions(labelOptions, option, fieldNames.label);
          setLabelOptions(labelOptions, option, optionFilterProp);
          setLabelOptions(labelOptions, option, optionLabelProp);
        } else {
          dig2(option[fieldNames.options], true);
        }
      }
    };
    dig(mergedOptions);
    return {
      options: mergedOptions,
      valueOptions,
      labelOptions
    };
  }, [options, children, fieldNames, optionFilterProp, optionLabelProp]);
};
var useOptions_default = useOptions;

// ../../node_modules/rc-select/es/hooks/useRefFunc.js
var React171 = __toESM(require_react());
function useRefFunc(callback) {
  var funcRef = React171.useRef();
  funcRef.current = callback;
  var cacheFn = React171.useCallback(function() {
    return funcRef.current.apply(funcRef, arguments);
  }, []);
  return cacheFn;
}

// ../../node_modules/rc-select/es/utils/warningPropsUtil.js
var React172 = __toESM(require_react());
function warningProps(props) {
  var mode = props.mode, options = props.options, children = props.children, backfill = props.backfill, allowClear = props.allowClear, placeholder = props.placeholder, getInputElement = props.getInputElement, showSearch = props.showSearch, onSearch = props.onSearch, defaultOpen = props.defaultOpen, autoFocus = props.autoFocus, labelInValue = props.labelInValue, value = props.value, inputValue = props.inputValue, optionLabelProp = props.optionLabelProp;
  var multiple = isMultiple(mode);
  var mergedShowSearch = showSearch !== void 0 ? showSearch : multiple || mode === "combobox";
  var mergedOptions = options || convertChildrenToData(children);
  warning_default(mode !== "tags" || mergedOptions.every(function(opt) {
    return !opt.disabled;
  }), "Please avoid setting option to disabled in tags mode since user can always type text as tag.");
  if (mode === "tags" || mode === "combobox") {
    var hasNumberValue = mergedOptions.some(function(item) {
      if (item.options) {
        return item.options.some(function(opt) {
          return typeof ("value" in opt ? opt.value : opt.key) === "number";
        });
      }
      return typeof ("value" in item ? item.value : item.key) === "number";
    });
    warning_default(!hasNumberValue, "`value` of Option should not use number type when `mode` is `tags` or `combobox`.");
  }
  warning_default(mode !== "combobox" || !optionLabelProp, "`combobox` mode not support `optionLabelProp`. Please set `value` on Option directly.");
  warning_default(mode === "combobox" || !backfill, "`backfill` only works with `combobox` mode.");
  warning_default(mode === "combobox" || !getInputElement, "`getInputElement` only work with `combobox` mode.");
  noteOnce(mode !== "combobox" || !getInputElement || !allowClear || !placeholder, "Customize `getInputElement` should customize clear and placeholder logic instead of configuring `allowClear` and `placeholder`.");
  if (onSearch && !mergedShowSearch && mode !== "combobox" && mode !== "tags") {
    warning_default(false, "`onSearch` should work with `showSearch` instead of use alone.");
  }
  noteOnce(!defaultOpen || autoFocus, "`defaultOpen` makes Select open without focus which means it will not close by click outside. You can set `autoFocus` if needed.");
  if (value !== void 0 && value !== null) {
    var values = toArray3(value);
    warning_default(!labelInValue || values.every(function(val) {
      return _typeof(val) === "object" && ("key" in val || "value" in val);
    }), "`value` should in shape of `{ value: string | number, label?: ReactNode }` when you set `labelInValue` to `true`");
    warning_default(!multiple || Array.isArray(value), "`value` should be array when `mode` is `multiple` or `tags`");
  }
  if (children) {
    var invalidateChildType = null;
    toArray(children).some(function(node2) {
      if (!/* @__PURE__ */ React172.isValidElement(node2) || !node2.type) {
        return false;
      }
      var _ref = node2, type5 = _ref.type;
      if (type5.isSelectOption) {
        return false;
      }
      if (type5.isSelectOptGroup) {
        var allChildrenValid = toArray(node2.props.children).every(function(subNode) {
          if (!/* @__PURE__ */ React172.isValidElement(subNode) || !node2.type || subNode.type.isSelectOption) {
            return true;
          }
          invalidateChildType = subNode.type;
          return false;
        });
        if (allChildrenValid) {
          return false;
        }
        return true;
      }
      invalidateChildType = type5;
      return true;
    });
    if (invalidateChildType) {
      warning_default(false, "`children` should be `Select.Option` or `Select.OptGroup` instead of `".concat(invalidateChildType.displayName || invalidateChildType.name || invalidateChildType, "`."));
    }
    warning_default(inputValue === void 0, "`inputValue` is deprecated, please use `searchValue` instead.");
  }
}
function warningNullOptions(options, fieldNames) {
  if (options) {
    var recursiveOptions = function recursiveOptions2(optionsList) {
      var inGroup = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
      for (var i = 0; i < optionsList.length; i++) {
        var option = optionsList[i];
        if (option[fieldNames === null || fieldNames === void 0 ? void 0 : fieldNames.value] === null) {
          warning_default(false, "`value` in Select options should not be `null`.");
          return true;
        }
        if (!inGroup && Array.isArray(option[fieldNames === null || fieldNames === void 0 ? void 0 : fieldNames.options]) && recursiveOptions2(option[fieldNames === null || fieldNames === void 0 ? void 0 : fieldNames.options], true)) {
          break;
        }
      }
    };
    recursiveOptions(options);
  }
}
var warningPropsUtil_default = warningProps;

// ../../node_modules/rc-select/es/Select.js
var _excluded27 = ["id", "mode", "prefixCls", "backfill", "fieldNames", "inputValue", "searchValue", "onSearch", "autoClearSearchValue", "onSelect", "onDeselect", "dropdownMatchSelectWidth", "filterOption", "filterSort", "optionFilterProp", "optionLabelProp", "options", "optionRender", "children", "defaultActiveFirstOption", "menuItemSelectedIcon", "virtual", "direction", "listHeight", "listItemHeight", "labelRender", "value", "defaultValue", "labelInValue", "onChange", "maxCount"];
var OMIT_DOM_PROPS = ["inputValue"];
function isRawValue(value) {
  return !value || _typeof(value) !== "object";
}
var Select = /* @__PURE__ */ React173.forwardRef(function(props, ref3) {
  var id = props.id, mode = props.mode, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-select" : _props$prefixCls, backfill = props.backfill, fieldNames = props.fieldNames, inputValue = props.inputValue, searchValue = props.searchValue, onSearch = props.onSearch, _props$autoClearSearc = props.autoClearSearchValue, autoClearSearchValue = _props$autoClearSearc === void 0 ? true : _props$autoClearSearc, onSelect = props.onSelect, onDeselect = props.onDeselect, _props$dropdownMatchS = props.dropdownMatchSelectWidth, dropdownMatchSelectWidth = _props$dropdownMatchS === void 0 ? true : _props$dropdownMatchS, filterOption = props.filterOption, filterSort = props.filterSort, optionFilterProp = props.optionFilterProp, optionLabelProp = props.optionLabelProp, options = props.options, optionRender = props.optionRender, children = props.children, defaultActiveFirstOption = props.defaultActiveFirstOption, menuItemSelectedIcon = props.menuItemSelectedIcon, virtual = props.virtual, direction = props.direction, _props$listHeight = props.listHeight, listHeight = _props$listHeight === void 0 ? 200 : _props$listHeight, _props$listItemHeight = props.listItemHeight, listItemHeight = _props$listItemHeight === void 0 ? 20 : _props$listItemHeight, labelRender = props.labelRender, value = props.value, defaultValue2 = props.defaultValue, labelInValue = props.labelInValue, onChange = props.onChange, maxCount = props.maxCount, restProps = _objectWithoutProperties(props, _excluded27);
  var mergedId = useId3(id);
  var multiple = isMultiple(mode);
  var childrenAsData = !!(!options && children);
  var mergedFilterOption = React173.useMemo(function() {
    if (filterOption === void 0 && mode === "combobox") {
      return false;
    }
    return filterOption;
  }, [filterOption, mode]);
  var mergedFieldNames = React173.useMemo(
    function() {
      return fillFieldNames(fieldNames, childrenAsData);
    },
    /* eslint-disable react-hooks/exhaustive-deps */
    [
      // We stringify fieldNames to avoid unnecessary re-renders.
      JSON.stringify(fieldNames),
      childrenAsData
    ]
    /* eslint-enable react-hooks/exhaustive-deps */
  );
  var _useMergedState = useMergedState("", {
    value: searchValue !== void 0 ? searchValue : inputValue,
    postState: function postState(search) {
      return search || "";
    }
  }), _useMergedState2 = _slicedToArray(_useMergedState, 2), mergedSearchValue = _useMergedState2[0], setSearchValue = _useMergedState2[1];
  var parsedOptions = useOptions_default(options, children, mergedFieldNames, optionFilterProp, optionLabelProp);
  var valueOptions = parsedOptions.valueOptions, labelOptions = parsedOptions.labelOptions, mergedOptions = parsedOptions.options;
  var convert2LabelValues = React173.useCallback(function(draftValues) {
    var valueList = toArray3(draftValues);
    return valueList.map(function(val) {
      var rawValue;
      var rawLabel;
      var rawKey;
      var rawDisabled;
      var rawTitle;
      if (isRawValue(val)) {
        rawValue = val;
      } else {
        var _val$value;
        rawKey = val.key;
        rawLabel = val.label;
        rawValue = (_val$value = val.value) !== null && _val$value !== void 0 ? _val$value : rawKey;
      }
      var option = valueOptions.get(rawValue);
      if (option) {
        var _option$key;
        if (rawLabel === void 0) rawLabel = option === null || option === void 0 ? void 0 : option[optionLabelProp || mergedFieldNames.label];
        if (rawKey === void 0) rawKey = (_option$key = option === null || option === void 0 ? void 0 : option.key) !== null && _option$key !== void 0 ? _option$key : rawValue;
        rawDisabled = option === null || option === void 0 ? void 0 : option.disabled;
        rawTitle = option === null || option === void 0 ? void 0 : option.title;
        if (!optionLabelProp) {
          var optionLabel = option === null || option === void 0 ? void 0 : option[mergedFieldNames.label];
          if (optionLabel !== void 0 && !/* @__PURE__ */ React173.isValidElement(optionLabel) && !/* @__PURE__ */ React173.isValidElement(rawLabel) && optionLabel !== rawLabel) {
            warning_default(false, "`label` of `value` is not same as `label` in Select options.");
          }
        }
      }
      return {
        label: rawLabel,
        value: rawValue,
        key: rawKey,
        disabled: rawDisabled,
        title: rawTitle
      };
    });
  }, [mergedFieldNames, optionLabelProp, valueOptions]);
  var _useMergedState3 = useMergedState(defaultValue2, {
    value
  }), _useMergedState4 = _slicedToArray(_useMergedState3, 2), internalValue = _useMergedState4[0], setInternalValue = _useMergedState4[1];
  var rawLabeledValues = React173.useMemo(function() {
    var _values$;
    var newInternalValue = multiple && internalValue === null ? [] : internalValue;
    var values = convert2LabelValues(newInternalValue);
    if (mode === "combobox" && isComboNoValue((_values$ = values[0]) === null || _values$ === void 0 ? void 0 : _values$.value)) {
      return [];
    }
    return values;
  }, [internalValue, convert2LabelValues, mode, multiple]);
  var _useCache = useCache_default(rawLabeledValues, valueOptions), _useCache2 = _slicedToArray(_useCache, 2), mergedValues = _useCache2[0], getMixedOption = _useCache2[1];
  var displayValues = React173.useMemo(function() {
    if (!mode && mergedValues.length === 1) {
      var firstValue = mergedValues[0];
      if (firstValue.value === null && (firstValue.label === null || firstValue.label === void 0)) {
        return [];
      }
    }
    return mergedValues.map(function(item) {
      var _ref;
      return _objectSpread2(_objectSpread2({}, item), {}, {
        label: (_ref = typeof labelRender === "function" ? labelRender(item) : item.label) !== null && _ref !== void 0 ? _ref : item.value
      });
    });
  }, [mode, mergedValues, labelRender]);
  var rawValues = React173.useMemo(function() {
    return new Set(mergedValues.map(function(val) {
      return val.value;
    }));
  }, [mergedValues]);
  React173.useEffect(function() {
    if (mode === "combobox") {
      var _mergedValues$;
      var strValue = (_mergedValues$ = mergedValues[0]) === null || _mergedValues$ === void 0 ? void 0 : _mergedValues$.value;
      setSearchValue(hasValue2(strValue) ? String(strValue) : "");
    }
  }, [mergedValues]);
  var createTagOption = useRefFunc(function(val, label) {
    var mergedLabel = label !== null && label !== void 0 ? label : val;
    return _defineProperty(_defineProperty({}, mergedFieldNames.value, val), mergedFieldNames.label, mergedLabel);
  });
  var filledTagOptions = React173.useMemo(function() {
    if (mode !== "tags") {
      return mergedOptions;
    }
    var cloneOptions = _toConsumableArray(mergedOptions);
    var existOptions = function existOptions2(val) {
      return valueOptions.has(val);
    };
    _toConsumableArray(mergedValues).sort(function(a, b) {
      return a.value < b.value ? -1 : 1;
    }).forEach(function(item) {
      var val = item.value;
      if (!existOptions(val)) {
        cloneOptions.push(createTagOption(val, item.label));
      }
    });
    return cloneOptions;
  }, [createTagOption, mergedOptions, valueOptions, mergedValues, mode]);
  var filteredOptions = useFilterOptions_default(filledTagOptions, mergedFieldNames, mergedSearchValue, mergedFilterOption, optionFilterProp);
  var filledSearchOptions = React173.useMemo(function() {
    if (mode !== "tags" || !mergedSearchValue || filteredOptions.some(function(item) {
      return item[optionFilterProp || "value"] === mergedSearchValue;
    })) {
      return filteredOptions;
    }
    if (filteredOptions.some(function(item) {
      return item[mergedFieldNames.value] === mergedSearchValue;
    })) {
      return filteredOptions;
    }
    return [createTagOption(mergedSearchValue)].concat(_toConsumableArray(filteredOptions));
  }, [createTagOption, optionFilterProp, mode, filteredOptions, mergedSearchValue, mergedFieldNames]);
  var sorter = function sorter2(inputOptions) {
    var sortedOptions = _toConsumableArray(inputOptions).sort(function(a, b) {
      return filterSort(a, b, {
        searchValue: mergedSearchValue
      });
    });
    return sortedOptions.map(function(item) {
      if (Array.isArray(item.options)) {
        return _objectSpread2(_objectSpread2({}, item), {}, {
          options: item.options.length > 0 ? sorter2(item.options) : item.options
        });
      }
      return item;
    });
  };
  var orderedFilteredOptions = React173.useMemo(function() {
    if (!filterSort) {
      return filledSearchOptions;
    }
    return sorter(filledSearchOptions);
  }, [filledSearchOptions, filterSort, mergedSearchValue]);
  var displayOptions = React173.useMemo(function() {
    return flattenOptions(orderedFilteredOptions, {
      fieldNames: mergedFieldNames,
      childrenAsData
    });
  }, [orderedFilteredOptions, mergedFieldNames, childrenAsData]);
  var triggerChange = function triggerChange2(values) {
    var labeledValues = convert2LabelValues(values);
    setInternalValue(labeledValues);
    if (onChange && // Trigger event only when value changed
    (labeledValues.length !== mergedValues.length || labeledValues.some(function(newVal, index3) {
      var _mergedValues$index;
      return ((_mergedValues$index = mergedValues[index3]) === null || _mergedValues$index === void 0 ? void 0 : _mergedValues$index.value) !== (newVal === null || newVal === void 0 ? void 0 : newVal.value);
    }))) {
      var returnValues = labelInValue ? labeledValues : labeledValues.map(function(v) {
        return v.value;
      });
      var returnOptions = labeledValues.map(function(v) {
        return injectPropsWithOption(getMixedOption(v.value));
      });
      onChange(
        // Value
        multiple ? returnValues : returnValues[0],
        // Option
        multiple ? returnOptions : returnOptions[0]
      );
    }
  };
  var _React$useState = React173.useState(null), _React$useState2 = _slicedToArray(_React$useState, 2), activeValue = _React$useState2[0], setActiveValue = _React$useState2[1];
  var _React$useState3 = React173.useState(0), _React$useState4 = _slicedToArray(_React$useState3, 2), accessibilityIndex = _React$useState4[0], setAccessibilityIndex = _React$useState4[1];
  var mergedDefaultActiveFirstOption = defaultActiveFirstOption !== void 0 ? defaultActiveFirstOption : mode !== "combobox";
  var onActiveValue = React173.useCallback(function(active, index3) {
    var _ref3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _ref3$source = _ref3.source, source = _ref3$source === void 0 ? "keyboard" : _ref3$source;
    setAccessibilityIndex(index3);
    if (backfill && mode === "combobox" && active !== null && source === "keyboard") {
      setActiveValue(String(active));
    }
  }, [backfill, mode]);
  var triggerSelect = function triggerSelect2(val, selected, type5) {
    var getSelectEnt = function getSelectEnt2() {
      var _option$key2;
      var option = getMixedOption(val);
      return [labelInValue ? {
        label: option === null || option === void 0 ? void 0 : option[mergedFieldNames.label],
        value: val,
        key: (_option$key2 = option === null || option === void 0 ? void 0 : option.key) !== null && _option$key2 !== void 0 ? _option$key2 : val
      } : val, injectPropsWithOption(option)];
    };
    if (selected && onSelect) {
      var _getSelectEnt = getSelectEnt(), _getSelectEnt2 = _slicedToArray(_getSelectEnt, 2), wrappedValue = _getSelectEnt2[0], _option = _getSelectEnt2[1];
      onSelect(wrappedValue, _option);
    } else if (!selected && onDeselect && type5 !== "clear") {
      var _getSelectEnt3 = getSelectEnt(), _getSelectEnt4 = _slicedToArray(_getSelectEnt3, 2), _wrappedValue = _getSelectEnt4[0], _option2 = _getSelectEnt4[1];
      onDeselect(_wrappedValue, _option2);
    }
  };
  var onInternalSelect = useRefFunc(function(val, info) {
    var cloneValues;
    var mergedSelect = multiple ? info.selected : true;
    if (mergedSelect) {
      cloneValues = multiple ? [].concat(_toConsumableArray(mergedValues), [val]) : [val];
    } else {
      cloneValues = mergedValues.filter(function(v) {
        return v.value !== val;
      });
    }
    triggerChange(cloneValues);
    triggerSelect(val, mergedSelect);
    if (mode === "combobox") {
      setActiveValue("");
    } else if (!isMultiple || autoClearSearchValue) {
      setSearchValue("");
      setActiveValue("");
    }
  });
  var onDisplayValuesChange = function onDisplayValuesChange2(nextValues, info) {
    triggerChange(nextValues);
    var type5 = info.type, values = info.values;
    if (type5 === "remove" || type5 === "clear") {
      values.forEach(function(item) {
        triggerSelect(item.value, false, type5);
      });
    }
  };
  var onInternalSearch = function onInternalSearch2(searchText, info) {
    setSearchValue(searchText);
    setActiveValue(null);
    if (info.source === "submit") {
      var formatted = (searchText || "").trim();
      if (formatted) {
        var newRawValues = Array.from(new Set([].concat(_toConsumableArray(rawValues), [formatted])));
        triggerChange(newRawValues);
        triggerSelect(formatted, true);
        setSearchValue("");
      }
      return;
    }
    if (info.source !== "blur") {
      if (mode === "combobox") {
        triggerChange(searchText);
      }
      onSearch === null || onSearch === void 0 || onSearch(searchText);
    }
  };
  var onInternalSearchSplit = function onInternalSearchSplit2(words) {
    var patchValues = words;
    if (mode !== "tags") {
      patchValues = words.map(function(word) {
        var opt = labelOptions.get(word);
        return opt === null || opt === void 0 ? void 0 : opt.value;
      }).filter(function(val) {
        return val !== void 0;
      });
    }
    var newRawValues = Array.from(new Set([].concat(_toConsumableArray(rawValues), _toConsumableArray(patchValues))));
    triggerChange(newRawValues);
    newRawValues.forEach(function(newRawValue) {
      triggerSelect(newRawValue, true);
    });
  };
  var selectContext = React173.useMemo(function() {
    var realVirtual = virtual !== false && dropdownMatchSelectWidth !== false;
    return _objectSpread2(_objectSpread2({}, parsedOptions), {}, {
      flattenOptions: displayOptions,
      onActiveValue,
      defaultActiveFirstOption: mergedDefaultActiveFirstOption,
      onSelect: onInternalSelect,
      menuItemSelectedIcon,
      rawValues,
      fieldNames: mergedFieldNames,
      virtual: realVirtual,
      direction,
      listHeight,
      listItemHeight,
      childrenAsData,
      maxCount,
      optionRender
    });
  }, [maxCount, parsedOptions, displayOptions, onActiveValue, mergedDefaultActiveFirstOption, onInternalSelect, menuItemSelectedIcon, rawValues, mergedFieldNames, virtual, dropdownMatchSelectWidth, direction, listHeight, listItemHeight, childrenAsData, optionRender]);
  if (true) {
    warningPropsUtil_default(props);
    warningNullOptions(mergedOptions, mergedFieldNames);
  }
  return /* @__PURE__ */ React173.createElement(SelectContext_default.Provider, {
    value: selectContext
  }, /* @__PURE__ */ React173.createElement(BaseSelect_default, _extends({}, restProps, {
    // >>> MISC
    id: mergedId,
    prefixCls,
    ref: ref3,
    omitDomProps: OMIT_DOM_PROPS,
    mode,
    displayValues,
    onDisplayValuesChange,
    direction,
    searchValue: mergedSearchValue,
    onSearch: onInternalSearch,
    autoClearSearchValue,
    onSearchSplit: onInternalSearchSplit,
    dropdownMatchSelectWidth,
    OptionList: OptionList_default,
    emptyOptions: !displayOptions.length,
    activeValue,
    activeDescendantId: "".concat(mergedId, "_list_").concat(accessibilityIndex)
  })));
});
if (true) {
  Select.displayName = "Select";
}
var TypedSelect = Select;
TypedSelect.Option = Option_default;
TypedSelect.OptGroup = OptGroup_default;
var Select_default = TypedSelect;

// ../../node_modules/rc-select/es/index.js
var es_default11 = Select_default;

// ../../node_modules/antd/es/_util/statusUtils.js
var import_classnames53 = __toESM(require_classnames());
function getStatusClassNames(prefixCls, status, hasFeedback) {
  return (0, import_classnames53.default)({
    [`${prefixCls}-status-success`]: status === "success",
    [`${prefixCls}-status-warning`]: status === "warning",
    [`${prefixCls}-status-error`]: status === "error",
    [`${prefixCls}-status-validating`]: status === "validating",
    [`${prefixCls}-has-feedback`]: hasFeedback
  });
}
var getMergedStatus = (contextStatus, customStatus) => customStatus || contextStatus;

// ../../node_modules/antd/es/config-provider/defaultRenderEmpty.js
var import_react70 = __toESM(require_react());

// ../../node_modules/antd/es/empty/index.js
var React176 = __toESM(require_react());
var import_classnames54 = __toESM(require_classnames());

// ../../node_modules/antd/es/empty/empty.js
var React174 = __toESM(require_react());
var Empty2 = () => {
  const [, token2] = useToken();
  const [locale6] = useLocale_default("Empty");
  const bgColor = new FastColor(token2.colorBgBase);
  const themeStyle = bgColor.toHsl().l < 0.5 ? {
    opacity: 0.65
  } : {};
  return /* @__PURE__ */ React174.createElement("svg", {
    style: themeStyle,
    width: "184",
    height: "152",
    viewBox: "0 0 184 152",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React174.createElement("title", null, (locale6 === null || locale6 === void 0 ? void 0 : locale6.description) || "Empty"), /* @__PURE__ */ React174.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /* @__PURE__ */ React174.createElement("g", {
    transform: "translate(24 31.67)"
  }, /* @__PURE__ */ React174.createElement("ellipse", {
    fillOpacity: ".8",
    fill: "#F5F5F7",
    cx: "67.797",
    cy: "106.89",
    rx: "67.797",
    ry: "12.668"
  }), /* @__PURE__ */ React174.createElement("path", {
    d: "M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z",
    fill: "#AEB8C2"
  }), /* @__PURE__ */ React174.createElement("path", {
    d: "M101.537 86.214L80.63 61.102c-1.001-1.207-2.507-1.867-4.048-1.867H31.724c-1.54 0-3.047.66-4.048 1.867L6.769 86.214v13.792h94.768V86.214z",
    fill: "url(#linearGradient-1)",
    transform: "translate(13.56)"
  }), /* @__PURE__ */ React174.createElement("path", {
    d: "M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z",
    fill: "#F5F5F7"
  }), /* @__PURE__ */ React174.createElement("path", {
    d: "M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z",
    fill: "#DCE0E6"
  })), /* @__PURE__ */ React174.createElement("path", {
    d: "M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z",
    fill: "#DCE0E6"
  }), /* @__PURE__ */ React174.createElement("g", {
    transform: "translate(149.65 15.383)",
    fill: "#FFF"
  }, /* @__PURE__ */ React174.createElement("ellipse", {
    cx: "20.654",
    cy: "3.167",
    rx: "2.849",
    ry: "2.815"
  }), /* @__PURE__ */ React174.createElement("path", {
    d: "M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z"
  }))));
};
if (true) {
  Empty2.displayName = "EmptyImage";
}
var empty_default = Empty2;

// ../../node_modules/antd/es/empty/simple.js
var React175 = __toESM(require_react());
var import_react69 = __toESM(require_react());
var Simple = () => {
  const [, token2] = useToken();
  const [locale6] = useLocale_default("Empty");
  const {
    colorFill,
    colorFillTertiary,
    colorFillQuaternary,
    colorBgContainer
  } = token2;
  const {
    borderColor,
    shadowColor,
    contentColor
  } = (0, import_react69.useMemo)(() => ({
    borderColor: new FastColor(colorFill).onBackground(colorBgContainer).toHexString(),
    shadowColor: new FastColor(colorFillTertiary).onBackground(colorBgContainer).toHexString(),
    contentColor: new FastColor(colorFillQuaternary).onBackground(colorBgContainer).toHexString()
  }), [colorFill, colorFillTertiary, colorFillQuaternary, colorBgContainer]);
  return /* @__PURE__ */ React175.createElement("svg", {
    width: "64",
    height: "41",
    viewBox: "0 0 64 41",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React175.createElement("title", null, (locale6 === null || locale6 === void 0 ? void 0 : locale6.description) || "Empty"), /* @__PURE__ */ React175.createElement("g", {
    transform: "translate(0 1)",
    fill: "none",
    fillRule: "evenodd"
  }, /* @__PURE__ */ React175.createElement("ellipse", {
    fill: shadowColor,
    cx: "32",
    cy: "33",
    rx: "32",
    ry: "7"
  }), /* @__PURE__ */ React175.createElement("g", {
    fillRule: "nonzero",
    stroke: borderColor
  }, /* @__PURE__ */ React175.createElement("path", {
    d: "M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z"
  }), /* @__PURE__ */ React175.createElement("path", {
    d: "M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z",
    fill: contentColor
  }))));
};
if (true) {
  Simple.displayName = "SimpleImage";
}
var simple_default = Simple;

// ../../node_modules/antd/es/empty/style/index.js
var genSharedEmptyStyle = (token2) => {
  const {
    componentCls,
    margin,
    marginXS,
    marginXL,
    fontSize,
    lineHeight
  } = token2;
  return {
    [componentCls]: {
      marginInline: marginXS,
      fontSize,
      lineHeight,
      textAlign: "center",
      // 原来 &-image 没有父子结构，现在为了外层承担我们的 hashId，改成父子结构
      [`${componentCls}-image`]: {
        height: token2.emptyImgHeight,
        marginBottom: marginXS,
        opacity: token2.opacityImage,
        img: {
          height: "100%"
        },
        svg: {
          maxWidth: "100%",
          height: "100%",
          margin: "auto"
        }
      },
      [`${componentCls}-description`]: {
        color: token2.colorTextDescription
      },
      // 原来 &-footer 没有父子结构，现在为了外层承担我们的 hashId，改成父子结构
      [`${componentCls}-footer`]: {
        marginTop: margin
      },
      "&-normal": {
        marginBlock: marginXL,
        color: token2.colorTextDescription,
        [`${componentCls}-description`]: {
          color: token2.colorTextDescription
        },
        [`${componentCls}-image`]: {
          height: token2.emptyImgHeightMD
        }
      },
      "&-small": {
        marginBlock: marginXS,
        color: token2.colorTextDescription,
        [`${componentCls}-image`]: {
          height: token2.emptyImgHeightSM
        }
      }
    }
  };
};
var style_default8 = genStyleHooks("Empty", (token2) => {
  const {
    componentCls,
    controlHeightLG,
    calc
  } = token2;
  const emptyToken = merge2(token2, {
    emptyImgCls: `${componentCls}-img`,
    emptyImgHeight: calc(controlHeightLG).mul(2.5).equal(),
    emptyImgHeightMD: controlHeightLG,
    emptyImgHeightSM: calc(controlHeightLG).mul(0.875).equal()
  });
  return genSharedEmptyStyle(emptyToken);
});

// ../../node_modules/antd/es/empty/index.js
var __rest10 = function(s, e3) {
  var t2 = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e3.indexOf(p) < 0) t2[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e3.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t2[p[i]] = s[p[i]];
  }
  return t2;
};
var defaultEmptyImg = /* @__PURE__ */ React176.createElement(empty_default, null);
var simpleEmptyImg = /* @__PURE__ */ React176.createElement(simple_default, null);
var Empty3 = (props) => {
  var _a;
  const {
    className: className2,
    rootClassName,
    prefixCls: customizePrefixCls,
    image,
    description,
    children,
    imageStyle,
    style: style2,
    classNames: emptyClassNames,
    styles
  } = props, restProps = __rest10(props, ["className", "rootClassName", "prefixCls", "image", "description", "children", "imageStyle", "style", "classNames", "styles"]);
  const {
    getPrefixCls,
    direction,
    className: contextClassName,
    style: contextStyle,
    classNames: contextClassNames,
    styles: contextStyles,
    image: contextImage
  } = useComponentConfig("empty");
  const prefixCls = getPrefixCls("empty", customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = style_default8(prefixCls);
  const [locale6] = useLocale_default("Empty");
  const des = typeof description !== "undefined" ? description : locale6 === null || locale6 === void 0 ? void 0 : locale6.description;
  const alt = typeof des === "string" ? des : "empty";
  const mergedImage = (_a = image !== null && image !== void 0 ? image : contextImage) !== null && _a !== void 0 ? _a : defaultEmptyImg;
  let imageNode = null;
  if (typeof mergedImage === "string") {
    imageNode = /* @__PURE__ */ React176.createElement("img", {
      alt,
      src: mergedImage
    });
  } else {
    imageNode = mergedImage;
  }
  if (true) {
    const warning6 = devUseWarning("Empty");
    [["imageStyle", "styles: { image: {} }"]].forEach(([deprecatedName, newName]) => {
      warning6.deprecated(!(deprecatedName in props), deprecatedName, newName);
    });
  }
  return wrapCSSVar(/* @__PURE__ */ React176.createElement("div", Object.assign({
    className: (0, import_classnames54.default)(hashId, cssVarCls, prefixCls, contextClassName, {
      [`${prefixCls}-normal`]: mergedImage === simpleEmptyImg,
      [`${prefixCls}-rtl`]: direction === "rtl"
    }, className2, rootClassName, contextClassNames.root, emptyClassNames === null || emptyClassNames === void 0 ? void 0 : emptyClassNames.root),
    style: Object.assign(Object.assign(Object.assign(Object.assign({}, contextStyles.root), contextStyle), styles === null || styles === void 0 ? void 0 : styles.root), style2)
  }, restProps), /* @__PURE__ */ React176.createElement("div", {
    className: (0, import_classnames54.default)(`${prefixCls}-image`, contextClassNames.image, emptyClassNames === null || emptyClassNames === void 0 ? void 0 : emptyClassNames.image),
    style: Object.assign(Object.assign(Object.assign({}, imageStyle), contextStyles.image), styles === null || styles === void 0 ? void 0 : styles.image)
  }, imageNode), des && /* @__PURE__ */ React176.createElement("div", {
    className: (0, import_classnames54.default)(`${prefixCls}-description`, contextClassNames.description, emptyClassNames === null || emptyClassNames === void 0 ? void 0 : emptyClassNames.description),
    style: Object.assign(Object.assign({}, contextStyles.description), styles === null || styles === void 0 ? void 0 : styles.description)
  }, des), children && /* @__PURE__ */ React176.createElement("div", {
    className: (0, import_classnames54.default)(`${prefixCls}-footer`, contextClassNames.footer, emptyClassNames === null || emptyClassNames === void 0 ? void 0 : emptyClassNames.footer),
    style: Object.assign(Object.assign({}, contextStyles.footer), styles === null || styles === void 0 ? void 0 : styles.footer)
  }, children)));
};
Empty3.PRESENTED_IMAGE_DEFAULT = defaultEmptyImg;
Empty3.PRESENTED_IMAGE_SIMPLE = simpleEmptyImg;
if (true) {
  Empty3.displayName = "Empty";
}
var empty_default2 = Empty3;

// ../../node_modules/antd/es/config-provider/defaultRenderEmpty.js
var DefaultRenderEmpty = (props) => {
  const {
    componentName
  } = props;
  const {
    getPrefixCls
  } = (0, import_react70.useContext)(ConfigContext);
  const prefix3 = getPrefixCls("empty");
  switch (componentName) {
    case "Table":
    case "List":
      return /* @__PURE__ */ import_react70.default.createElement(empty_default2, {
        image: empty_default2.PRESENTED_IMAGE_SIMPLE
      });
    case "Select":
    case "TreeSelect":
    case "Cascader":
    case "Transfer":
    case "Mentions":
      return /* @__PURE__ */ import_react70.default.createElement(empty_default2, {
        image: empty_default2.PRESENTED_IMAGE_SIMPLE,
        className: `${prefix3}-small`
      });
    /**
     * This type of component should satisfy the nullish coalescing operator(??) on the left-hand side.
     * to let the component itself implement the logic.
     * For example `Table.filter`.
     */
    case "Table.filter":
      return null;
    default:
      return /* @__PURE__ */ import_react70.default.createElement(empty_default2, null);
  }
};
var defaultRenderEmpty_default = DefaultRenderEmpty;

// ../../node_modules/antd/es/form/hooks/useVariants.js
var React178 = __toESM(require_react());
var useVariant = (component, variant, legacyBordered = void 0) => {
  var _a, _b;
  const {
    variant: configVariant,
    [component]: componentConfig
  } = React178.useContext(ConfigContext);
  const ctxVariant = React178.useContext(VariantContext);
  const configComponentVariant = componentConfig === null || componentConfig === void 0 ? void 0 : componentConfig.variant;
  let mergedVariant;
  if (typeof variant !== "undefined") {
    mergedVariant = variant;
  } else if (legacyBordered === false) {
    mergedVariant = "borderless";
  } else {
    mergedVariant = (_b = (_a = ctxVariant !== null && ctxVariant !== void 0 ? ctxVariant : configComponentVariant) !== null && _a !== void 0 ? _a : configVariant) !== null && _b !== void 0 ? _b : "outlined";
  }
  const enableVariantCls = Variants.includes(mergedVariant);
  return [mergedVariant, enableVariantCls];
};
var useVariants_default = useVariant;

// ../../node_modules/antd/es/select/mergedBuiltinPlacements.js
var getBuiltInPlacements3 = (popupOverflow) => {
  const htmlRegion = popupOverflow === "scroll" ? "scroll" : "visible";
  const sharedConfig = {
    overflow: {
      adjustX: true,
      adjustY: true,
      shiftY: true
    },
    htmlRegion,
    dynamicInset: true
  };
  return {
    bottomLeft: Object.assign(Object.assign({}, sharedConfig), {
      points: ["tl", "bl"],
      offset: [0, 4]
    }),
    bottomRight: Object.assign(Object.assign({}, sharedConfig), {
      points: ["tr", "br"],
      offset: [0, 4]
    }),
    topLeft: Object.assign(Object.assign({}, sharedConfig), {
      points: ["bl", "tl"],
      offset: [0, -4]
    }),
    topRight: Object.assign(Object.assign({}, sharedConfig), {
      points: ["br", "tr"],
      offset: [0, -4]
    })
  };
};
function mergedBuiltinPlacements(buildInPlacements, popupOverflow) {
  return buildInPlacements || getBuiltInPlacements3(popupOverflow);
}
var mergedBuiltinPlacements_default = mergedBuiltinPlacements;

// ../../node_modules/antd/es/select/style/dropdown.js
var genItemStyle = (token2) => {
  const {
    optionHeight,
    optionFontSize,
    optionLineHeight,
    optionPadding
  } = token2;
  return {
    position: "relative",
    display: "block",
    minHeight: optionHeight,
    padding: optionPadding,
    color: token2.colorText,
    fontWeight: "normal",
    fontSize: optionFontSize,
    lineHeight: optionLineHeight,
    boxSizing: "border-box"
  };
};
var genSingleStyle = (token2) => {
  const {
    antCls,
    componentCls
  } = token2;
  const selectItemCls = `${componentCls}-item`;
  const slideUpEnterActive = `&${antCls}-slide-up-enter${antCls}-slide-up-enter-active`;
  const slideUpAppearActive = `&${antCls}-slide-up-appear${antCls}-slide-up-appear-active`;
  const slideUpLeaveActive = `&${antCls}-slide-up-leave${antCls}-slide-up-leave-active`;
  const dropdownPlacementCls = `${componentCls}-dropdown-placement-`;
  const selectedItemCls = `${selectItemCls}-option-selected`;
  return [
    {
      [`${componentCls}-dropdown`]: Object.assign(Object.assign({}, resetComponent(token2)), {
        position: "absolute",
        top: -9999,
        zIndex: token2.zIndexPopup,
        boxSizing: "border-box",
        padding: token2.paddingXXS,
        overflow: "hidden",
        fontSize: token2.fontSize,
        // Fix select render lag of long text in chrome
        // https://github.com/ant-design/ant-design/issues/11456
        // https://github.com/ant-design/ant-design/issues/11843
        fontVariant: "initial",
        backgroundColor: token2.colorBgElevated,
        borderRadius: token2.borderRadiusLG,
        outline: "none",
        boxShadow: token2.boxShadowSecondary,
        [`
          ${slideUpEnterActive}${dropdownPlacementCls}bottomLeft,
          ${slideUpAppearActive}${dropdownPlacementCls}bottomLeft
        `]: {
          animationName: slideUpIn
        },
        [`
          ${slideUpEnterActive}${dropdownPlacementCls}topLeft,
          ${slideUpAppearActive}${dropdownPlacementCls}topLeft,
          ${slideUpEnterActive}${dropdownPlacementCls}topRight,
          ${slideUpAppearActive}${dropdownPlacementCls}topRight
        `]: {
          animationName: slideDownIn
        },
        [`${slideUpLeaveActive}${dropdownPlacementCls}bottomLeft`]: {
          animationName: slideUpOut
        },
        [`
          ${slideUpLeaveActive}${dropdownPlacementCls}topLeft,
          ${slideUpLeaveActive}${dropdownPlacementCls}topRight
        `]: {
          animationName: slideDownOut
        },
        "&-hidden": {
          display: "none"
        },
        [selectItemCls]: Object.assign(Object.assign({}, genItemStyle(token2)), {
          cursor: "pointer",
          transition: `background ${token2.motionDurationSlow} ease`,
          borderRadius: token2.borderRadiusSM,
          // =========== Group ============
          "&-group": {
            color: token2.colorTextDescription,
            fontSize: token2.fontSizeSM,
            cursor: "default"
          },
          // =========== Option ===========
          "&-option": {
            display: "flex",
            "&-content": Object.assign({
              flex: "auto"
            }, textEllipsis),
            "&-state": {
              flex: "none",
              display: "flex",
              alignItems: "center"
            },
            [`&-active:not(${selectItemCls}-option-disabled)`]: {
              backgroundColor: token2.optionActiveBg
            },
            [`&-selected:not(${selectItemCls}-option-disabled)`]: {
              color: token2.optionSelectedColor,
              fontWeight: token2.optionSelectedFontWeight,
              backgroundColor: token2.optionSelectedBg,
              [`${selectItemCls}-option-state`]: {
                color: token2.colorPrimary
              }
            },
            "&-disabled": {
              [`&${selectItemCls}-option-selected`]: {
                backgroundColor: token2.colorBgContainerDisabled
              },
              color: token2.colorTextDisabled,
              cursor: "not-allowed"
            },
            "&-grouped": {
              paddingInlineStart: token2.calc(token2.controlPaddingHorizontal).mul(2).equal()
            }
          },
          "&-empty": Object.assign(Object.assign({}, genItemStyle(token2)), {
            color: token2.colorTextDisabled
          })
        }),
        // https://github.com/ant-design/ant-design/pull/46646
        [`${selectedItemCls}:has(+ ${selectedItemCls})`]: {
          borderEndStartRadius: 0,
          borderEndEndRadius: 0,
          [`& + ${selectedItemCls}`]: {
            borderStartStartRadius: 0,
            borderStartEndRadius: 0
          }
        },
        // =========================== RTL ===========================
        "&-rtl": {
          direction: "rtl"
        }
      })
    },
    // Follow code may reuse in other components
    initSlideMotion(token2, "slide-up"),
    initSlideMotion(token2, "slide-down"),
    initMoveMotion(token2, "move-up"),
    initMoveMotion(token2, "move-down")
  ];
};
var dropdown_default = genSingleStyle;

// ../../node_modules/antd/es/select/style/multiple.js
var getMultipleSelectorUnit = (token2) => {
  const {
    multipleSelectItemHeight,
    paddingXXS,
    lineWidth,
    INTERNAL_FIXED_ITEM_MARGIN
  } = token2;
  const basePadding = token2.max(token2.calc(paddingXXS).sub(lineWidth).equal(), 0);
  const containerPadding = token2.max(token2.calc(basePadding).sub(INTERNAL_FIXED_ITEM_MARGIN).equal(), 0);
  return {
    basePadding,
    containerPadding,
    itemHeight: unit(multipleSelectItemHeight),
    itemLineHeight: unit(token2.calc(multipleSelectItemHeight).sub(token2.calc(token2.lineWidth).mul(2)).equal())
  };
};
var getSelectItemStyle = (token2) => {
  const {
    multipleSelectItemHeight,
    selectHeight,
    lineWidth
  } = token2;
  const selectItemDist = token2.calc(selectHeight).sub(multipleSelectItemHeight).div(2).sub(lineWidth).equal();
  return selectItemDist;
};
var genOverflowStyle = (token2) => {
  const {
    componentCls,
    iconCls,
    borderRadiusSM,
    motionDurationSlow,
    paddingXS,
    multipleItemColorDisabled,
    multipleItemBorderColorDisabled,
    colorIcon,
    colorIconHover,
    INTERNAL_FIXED_ITEM_MARGIN
  } = token2;
  const selectOverflowPrefixCls = `${componentCls}-selection-overflow`;
  return {
    /**
     * Do not merge `height` & `line-height` under style with `selection` & `search`, since chrome
     * may update to redesign with its align logic.
     */
    // =========================== Overflow ===========================
    [selectOverflowPrefixCls]: {
      position: "relative",
      display: "flex",
      flex: "auto",
      flexWrap: "wrap",
      maxWidth: "100%",
      "&-item": {
        flex: "none",
        alignSelf: "center",
        // https://github.com/ant-design/ant-design/issues/54179
        maxWidth: "calc(100% - 4px)",
        display: "inline-flex"
      },
      // ======================== Selections ==========================
      [`${componentCls}-selection-item`]: {
        display: "flex",
        alignSelf: "center",
        flex: "none",
        boxSizing: "border-box",
        maxWidth: "100%",
        marginBlock: INTERNAL_FIXED_ITEM_MARGIN,
        borderRadius: borderRadiusSM,
        cursor: "default",
        transition: `font-size ${motionDurationSlow}, line-height ${motionDurationSlow}, height ${motionDurationSlow}`,
        marginInlineEnd: token2.calc(INTERNAL_FIXED_ITEM_MARGIN).mul(2).equal(),
        paddingInlineStart: paddingXS,
        paddingInlineEnd: token2.calc(paddingXS).div(2).equal(),
        [`${componentCls}-disabled&`]: {
          color: multipleItemColorDisabled,
          borderColor: multipleItemBorderColorDisabled,
          cursor: "not-allowed"
        },
        // It's ok not to do this, but 24px makes bottom narrow in view should adjust
        "&-content": {
          display: "inline-block",
          marginInlineEnd: token2.calc(paddingXS).div(2).equal(),
          overflow: "hidden",
          whiteSpace: "pre",
          // fix whitespace wrapping. custom tags display all whitespace within.
          textOverflow: "ellipsis"
        },
        "&-remove": Object.assign(Object.assign({}, resetIcon()), {
          display: "inline-flex",
          alignItems: "center",
          color: colorIcon,
          fontWeight: "bold",
          fontSize: 10,
          lineHeight: "inherit",
          cursor: "pointer",
          [`> ${iconCls}`]: {
            verticalAlign: "-0.2em"
          },
          "&:hover": {
            color: colorIconHover
          }
        })
      }
    }
  };
};
var genSelectionStyle = (token2, suffix) => {
  const {
    componentCls,
    INTERNAL_FIXED_ITEM_MARGIN
  } = token2;
  const selectOverflowPrefixCls = `${componentCls}-selection-overflow`;
  const selectItemHeight = token2.multipleSelectItemHeight;
  const selectItemDist = getSelectItemStyle(token2);
  const suffixCls = suffix ? `${componentCls}-${suffix}` : "";
  const multipleSelectorUnit = getMultipleSelectorUnit(token2);
  return {
    [`${componentCls}-multiple${suffixCls}`]: Object.assign(Object.assign({}, genOverflowStyle(token2)), {
      // ========================= Selector =========================
      [`${componentCls}-selector`]: {
        display: "flex",
        alignItems: "center",
        width: "100%",
        height: "100%",
        // Multiple is little different that horizontal is follow the vertical
        paddingInline: multipleSelectorUnit.basePadding,
        paddingBlock: multipleSelectorUnit.containerPadding,
        borderRadius: token2.borderRadius,
        [`${componentCls}-disabled&`]: {
          background: token2.multipleSelectorBgDisabled,
          cursor: "not-allowed"
        },
        "&:after": {
          display: "inline-block",
          width: 0,
          margin: `${unit(INTERNAL_FIXED_ITEM_MARGIN)} 0`,
          lineHeight: unit(selectItemHeight),
          visibility: "hidden",
          content: '"\\a0"'
        }
      },
      // ======================== Selections ========================
      [`${componentCls}-selection-item`]: {
        height: multipleSelectorUnit.itemHeight,
        lineHeight: unit(multipleSelectorUnit.itemLineHeight)
      },
      // ========================== Wrap ===========================
      [`${componentCls}-selection-wrap`]: {
        alignSelf: "flex-start",
        "&:after": {
          lineHeight: unit(selectItemHeight),
          marginBlock: INTERNAL_FIXED_ITEM_MARGIN
        }
      },
      // ========================== Input ==========================
      [`${componentCls}-prefix`]: {
        marginInlineStart: token2.calc(token2.inputPaddingHorizontalBase).sub(multipleSelectorUnit.basePadding).equal()
      },
      [`${selectOverflowPrefixCls}-item + ${selectOverflowPrefixCls}-item,
        ${componentCls}-prefix + ${componentCls}-selection-wrap
      `]: {
        [`${componentCls}-selection-search`]: {
          marginInlineStart: 0
        },
        [`${componentCls}-selection-placeholder`]: {
          insetInlineStart: 0
        }
      },
      // https://github.com/ant-design/ant-design/issues/44754
      // Same as `wrap:after`
      [`${selectOverflowPrefixCls}-item-suffix`]: {
        minHeight: multipleSelectorUnit.itemHeight,
        marginBlock: INTERNAL_FIXED_ITEM_MARGIN
      },
      [`${componentCls}-selection-search`]: {
        display: "inline-flex",
        position: "relative",
        maxWidth: "100%",
        marginInlineStart: token2.calc(token2.inputPaddingHorizontalBase).sub(selectItemDist).equal(),
        [`
          &-input,
          &-mirror
        `]: {
          height: selectItemHeight,
          fontFamily: token2.fontFamily,
          lineHeight: unit(selectItemHeight),
          transition: `all ${token2.motionDurationSlow}`
        },
        "&-input": {
          width: "100%",
          minWidth: 4.1
          // fix search cursor missing
        },
        "&-mirror": {
          position: "absolute",
          top: 0,
          insetInlineStart: 0,
          insetInlineEnd: "auto",
          zIndex: 999,
          whiteSpace: "pre",
          // fix whitespace wrapping caused width calculation bug
          visibility: "hidden"
        }
      },
      // ======================= Placeholder =======================
      [`${componentCls}-selection-placeholder`]: {
        position: "absolute",
        top: "50%",
        insetInlineStart: token2.calc(token2.inputPaddingHorizontalBase).sub(multipleSelectorUnit.basePadding).equal(),
        insetInlineEnd: token2.inputPaddingHorizontalBase,
        transform: "translateY(-50%)",
        transition: `all ${token2.motionDurationSlow}`
      }
    })
  };
};
function genSizeStyle(token2, suffix) {
  const {
    componentCls
  } = token2;
  const suffixCls = suffix ? `${componentCls}-${suffix}` : "";
  const rawStyle = {
    [`${componentCls}-multiple${suffixCls}`]: {
      fontSize: token2.fontSize,
      // ========================= Selector =========================
      [`${componentCls}-selector`]: {
        [`${componentCls}-show-search&`]: {
          cursor: "text"
        }
      },
      [`
        &${componentCls}-show-arrow ${componentCls}-selector,
        &${componentCls}-allow-clear ${componentCls}-selector
      `]: {
        paddingInlineEnd: token2.calc(token2.fontSizeIcon).add(token2.controlPaddingHorizontal).equal()
      }
    }
  };
  return [genSelectionStyle(token2, suffix), rawStyle];
}
var genMultipleStyle = (token2) => {
  const {
    componentCls
  } = token2;
  const smallToken = merge2(token2, {
    selectHeight: token2.controlHeightSM,
    multipleSelectItemHeight: token2.multipleItemHeightSM,
    borderRadius: token2.borderRadiusSM,
    borderRadiusSM: token2.borderRadiusXS
  });
  const largeToken = merge2(token2, {
    fontSize: token2.fontSizeLG,
    selectHeight: token2.controlHeightLG,
    multipleSelectItemHeight: token2.multipleItemHeightLG,
    borderRadius: token2.borderRadiusLG,
    borderRadiusSM: token2.borderRadius
  });
  return [
    genSizeStyle(token2),
    // ======================== Small ========================
    genSizeStyle(smallToken, "sm"),
    // Padding
    {
      [`${componentCls}-multiple${componentCls}-sm`]: {
        [`${componentCls}-selection-placeholder`]: {
          insetInline: token2.calc(token2.controlPaddingHorizontalSM).sub(token2.lineWidth).equal()
        },
        // https://github.com/ant-design/ant-design/issues/29559
        [`${componentCls}-selection-search`]: {
          marginInlineStart: 2
          // Magic Number
        }
      }
    },
    // ======================== Large ========================
    genSizeStyle(largeToken, "lg")
  ];
};
var multiple_default = genMultipleStyle;

// ../../node_modules/antd/es/select/style/single.js
function genSizeStyle2(token2, suffix) {
  const {
    componentCls,
    inputPaddingHorizontalBase,
    borderRadius
  } = token2;
  const selectHeightWithoutBorder = token2.calc(token2.controlHeight).sub(token2.calc(token2.lineWidth).mul(2)).equal();
  const suffixCls = suffix ? `${componentCls}-${suffix}` : "";
  return {
    [`${componentCls}-single${suffixCls}`]: {
      fontSize: token2.fontSize,
      height: token2.controlHeight,
      // ========================= Selector =========================
      [`${componentCls}-selector`]: Object.assign(Object.assign({}, resetComponent(token2, true)), {
        display: "flex",
        borderRadius,
        flex: "1 1 auto",
        [`${componentCls}-selection-wrap:after`]: {
          lineHeight: unit(selectHeightWithoutBorder)
        },
        [`${componentCls}-selection-search`]: {
          position: "absolute",
          inset: 0,
          width: "100%",
          "&-input": {
            width: "100%",
            WebkitAppearance: "textfield"
          }
        },
        [`
          ${componentCls}-selection-item,
          ${componentCls}-selection-placeholder
        `]: {
          display: "block",
          padding: 0,
          lineHeight: unit(selectHeightWithoutBorder),
          transition: `all ${token2.motionDurationSlow}, visibility 0s`,
          alignSelf: "center"
        },
        [`${componentCls}-selection-placeholder`]: {
          transition: "none",
          pointerEvents: "none"
        },
        // For common baseline align
        [[
          "&:after",
          /* For '' value baseline align */
          `${componentCls}-selection-item:empty:after`,
          /* For undefined value baseline align */
          `${componentCls}-selection-placeholder:empty:after`
        ].join(",")]: {
          display: "inline-block",
          width: 0,
          visibility: "hidden",
          content: '"\\a0"'
        }
      }),
      [`
        &${componentCls}-show-arrow ${componentCls}-selection-item,
        &${componentCls}-show-arrow ${componentCls}-selection-search,
        &${componentCls}-show-arrow ${componentCls}-selection-placeholder
      `]: {
        paddingInlineEnd: token2.showArrowPaddingInlineEnd
      },
      // Opacity selection if open
      [`&${componentCls}-open ${componentCls}-selection-item`]: {
        color: token2.colorTextPlaceholder
      },
      // ========================== Input ==========================
      // We only change the style of non-customize input which is only support by `combobox` mode.
      // Not customize
      [`&:not(${componentCls}-customize-input)`]: {
        [`${componentCls}-selector`]: {
          width: "100%",
          height: "100%",
          alignItems: "center",
          padding: `0 ${unit(inputPaddingHorizontalBase)}`,
          [`${componentCls}-selection-search-input`]: {
            height: selectHeightWithoutBorder,
            fontSize: token2.fontSize
          },
          "&:after": {
            lineHeight: unit(selectHeightWithoutBorder)
          }
        }
      },
      [`&${componentCls}-customize-input`]: {
        [`${componentCls}-selector`]: {
          "&:after": {
            display: "none"
          },
          [`${componentCls}-selection-search`]: {
            position: "static",
            width: "100%"
          },
          [`${componentCls}-selection-placeholder`]: {
            position: "absolute",
            insetInlineStart: 0,
            insetInlineEnd: 0,
            padding: `0 ${unit(inputPaddingHorizontalBase)}`,
            "&:after": {
              display: "none"
            }
          }
        }
      }
    }
  };
}
function genSingleStyle2(token2) {
  const {
    componentCls
  } = token2;
  const inputPaddingHorizontalSM = token2.calc(token2.controlPaddingHorizontalSM).sub(token2.lineWidth).equal();
  return [
    genSizeStyle2(token2),
    // ======================== Small ========================
    // Shared
    genSizeStyle2(merge2(token2, {
      controlHeight: token2.controlHeightSM,
      borderRadius: token2.borderRadiusSM
    }), "sm"),
    // padding
    {
      [`${componentCls}-single${componentCls}-sm`]: {
        [`&:not(${componentCls}-customize-input)`]: {
          [`${componentCls}-selector`]: {
            padding: `0 ${unit(inputPaddingHorizontalSM)}`
          },
          // With arrow should provides `padding-right` to show the arrow
          [`&${componentCls}-show-arrow ${componentCls}-selection-search`]: {
            insetInlineEnd: token2.calc(inputPaddingHorizontalSM).add(token2.calc(token2.fontSize).mul(1.5)).equal()
          },
          [`
            &${componentCls}-show-arrow ${componentCls}-selection-item,
            &${componentCls}-show-arrow ${componentCls}-selection-placeholder
          `]: {
            paddingInlineEnd: token2.calc(token2.fontSize).mul(1.5).equal()
          }
        }
      }
    },
    // ======================== Large ========================
    // Shared
    genSizeStyle2(merge2(token2, {
      controlHeight: token2.singleItemHeightLG,
      fontSize: token2.fontSizeLG,
      borderRadius: token2.borderRadiusLG
    }), "lg")
  ];
}

// ../../node_modules/antd/es/select/style/token.js
var prepareComponentToken6 = (token2) => {
  const {
    fontSize,
    lineHeight,
    lineWidth,
    controlHeight,
    controlHeightSM,
    controlHeightLG,
    paddingXXS,
    controlPaddingHorizontal,
    zIndexPopupBase,
    colorText,
    fontWeightStrong,
    controlItemBgActive,
    controlItemBgHover,
    colorBgContainer,
    colorFillSecondary,
    colorBgContainerDisabled,
    colorTextDisabled,
    colorPrimaryHover,
    colorPrimary,
    controlOutline
  } = token2;
  const dblPaddingXXS = paddingXXS * 2;
  const dblLineWidth = lineWidth * 2;
  const multipleItemHeight = Math.min(controlHeight - dblPaddingXXS, controlHeight - dblLineWidth);
  const multipleItemHeightSM = Math.min(controlHeightSM - dblPaddingXXS, controlHeightSM - dblLineWidth);
  const multipleItemHeightLG = Math.min(controlHeightLG - dblPaddingXXS, controlHeightLG - dblLineWidth);
  const INTERNAL_FIXED_ITEM_MARGIN = Math.floor(paddingXXS / 2);
  return {
    INTERNAL_FIXED_ITEM_MARGIN,
    zIndexPopup: zIndexPopupBase + 50,
    optionSelectedColor: colorText,
    optionSelectedFontWeight: fontWeightStrong,
    optionSelectedBg: controlItemBgActive,
    optionActiveBg: controlItemBgHover,
    optionPadding: `${(controlHeight - fontSize * lineHeight) / 2}px ${controlPaddingHorizontal}px`,
    optionFontSize: fontSize,
    optionLineHeight: lineHeight,
    optionHeight: controlHeight,
    selectorBg: colorBgContainer,
    clearBg: colorBgContainer,
    singleItemHeightLG: controlHeightLG,
    multipleItemBg: colorFillSecondary,
    multipleItemBorderColor: "transparent",
    multipleItemHeight,
    multipleItemHeightSM,
    multipleItemHeightLG,
    multipleSelectorBgDisabled: colorBgContainerDisabled,
    multipleItemColorDisabled: colorTextDisabled,
    multipleItemBorderColorDisabled: "transparent",
    showArrowPaddingInlineEnd: Math.ceil(token2.fontSize * 1.25),
    hoverBorderColor: colorPrimaryHover,
    activeBorderColor: colorPrimary,
    activeOutlineColor: controlOutline,
    selectAffixPadding: paddingXXS
  };
};

// ../../node_modules/antd/es/select/style/variants.js
var genBaseOutlinedStyle = (token2, options) => {
  const {
    componentCls,
    antCls,
    controlOutlineWidth
  } = token2;
  return {
    [`&:not(${componentCls}-customize-input) ${componentCls}-selector`]: {
      border: `${unit(token2.lineWidth)} ${token2.lineType} ${options.borderColor}`,
      background: token2.selectorBg
    },
    [`&:not(${componentCls}-disabled):not(${componentCls}-customize-input):not(${antCls}-pagination-size-changer)`]: {
      [`&:hover ${componentCls}-selector`]: {
        borderColor: options.hoverBorderHover
      },
      [`${componentCls}-focused& ${componentCls}-selector`]: {
        borderColor: options.activeBorderColor,
        boxShadow: `0 0 0 ${unit(controlOutlineWidth)} ${options.activeOutlineColor}`,
        outline: 0
      },
      [`${componentCls}-prefix`]: {
        color: options.color
      }
    }
  };
};
var genOutlinedStatusStyle = (token2, options) => ({
  [`&${token2.componentCls}-status-${options.status}`]: Object.assign({}, genBaseOutlinedStyle(token2, options))
});
var genOutlinedStyle = (token2) => ({
  "&-outlined": Object.assign(Object.assign(Object.assign(Object.assign({}, genBaseOutlinedStyle(token2, {
    borderColor: token2.colorBorder,
    hoverBorderHover: token2.hoverBorderColor,
    activeBorderColor: token2.activeBorderColor,
    activeOutlineColor: token2.activeOutlineColor,
    color: token2.colorText
  })), genOutlinedStatusStyle(token2, {
    status: "error",
    borderColor: token2.colorError,
    hoverBorderHover: token2.colorErrorHover,
    activeBorderColor: token2.colorError,
    activeOutlineColor: token2.colorErrorOutline,
    color: token2.colorError
  })), genOutlinedStatusStyle(token2, {
    status: "warning",
    borderColor: token2.colorWarning,
    hoverBorderHover: token2.colorWarningHover,
    activeBorderColor: token2.colorWarning,
    activeOutlineColor: token2.colorWarningOutline,
    color: token2.colorWarning
  })), {
    [`&${token2.componentCls}-disabled`]: {
      [`&:not(${token2.componentCls}-customize-input) ${token2.componentCls}-selector`]: {
        background: token2.colorBgContainerDisabled,
        color: token2.colorTextDisabled
      }
    },
    [`&${token2.componentCls}-multiple ${token2.componentCls}-selection-item`]: {
      background: token2.multipleItemBg,
      border: `${unit(token2.lineWidth)} ${token2.lineType} ${token2.multipleItemBorderColor}`
    }
  })
});
var genBaseFilledStyle = (token2, options) => {
  const {
    componentCls,
    antCls
  } = token2;
  return {
    [`&:not(${componentCls}-customize-input) ${componentCls}-selector`]: {
      background: options.bg,
      border: `${unit(token2.lineWidth)} ${token2.lineType} transparent`,
      color: options.color
    },
    [`&:not(${componentCls}-disabled):not(${componentCls}-customize-input):not(${antCls}-pagination-size-changer)`]: {
      [`&:hover ${componentCls}-selector`]: {
        background: options.hoverBg
      },
      [`${componentCls}-focused& ${componentCls}-selector`]: {
        background: token2.selectorBg,
        borderColor: options.activeBorderColor,
        outline: 0
      }
    }
  };
};
var genFilledStatusStyle = (token2, options) => ({
  [`&${token2.componentCls}-status-${options.status}`]: Object.assign({}, genBaseFilledStyle(token2, options))
});
var genFilledStyle = (token2) => ({
  "&-filled": Object.assign(Object.assign(Object.assign(Object.assign({}, genBaseFilledStyle(token2, {
    bg: token2.colorFillTertiary,
    hoverBg: token2.colorFillSecondary,
    activeBorderColor: token2.activeBorderColor,
    color: token2.colorText
  })), genFilledStatusStyle(token2, {
    status: "error",
    bg: token2.colorErrorBg,
    hoverBg: token2.colorErrorBgHover,
    activeBorderColor: token2.colorError,
    color: token2.colorError
  })), genFilledStatusStyle(token2, {
    status: "warning",
    bg: token2.colorWarningBg,
    hoverBg: token2.colorWarningBgHover,
    activeBorderColor: token2.colorWarning,
    color: token2.colorWarning
  })), {
    [`&${token2.componentCls}-disabled`]: {
      [`&:not(${token2.componentCls}-customize-input) ${token2.componentCls}-selector`]: {
        borderColor: token2.colorBorder,
        background: token2.colorBgContainerDisabled,
        color: token2.colorTextDisabled
      }
    },
    [`&${token2.componentCls}-multiple ${token2.componentCls}-selection-item`]: {
      background: token2.colorBgContainer,
      border: `${unit(token2.lineWidth)} ${token2.lineType} ${token2.colorSplit}`
    }
  })
});
var genBorderlessStyle2 = (token2) => ({
  "&-borderless": {
    [`${token2.componentCls}-selector`]: {
      background: "transparent",
      border: `${unit(token2.lineWidth)} ${token2.lineType} transparent`
    },
    [`&${token2.componentCls}-disabled`]: {
      [`&:not(${token2.componentCls}-customize-input) ${token2.componentCls}-selector`]: {
        color: token2.colorTextDisabled
      }
    },
    [`&${token2.componentCls}-multiple ${token2.componentCls}-selection-item`]: {
      background: token2.multipleItemBg,
      border: `${unit(token2.lineWidth)} ${token2.lineType} ${token2.multipleItemBorderColor}`
    },
    // Status
    [`&${token2.componentCls}-status-error`]: {
      [`${token2.componentCls}-prefix, ${token2.componentCls}-selection-item`]: {
        color: token2.colorError
      }
    },
    [`&${token2.componentCls}-status-warning`]: {
      [`${token2.componentCls}-prefix, ${token2.componentCls}-selection-item`]: {
        color: token2.colorWarning
      }
    }
  }
});
var genBaseUnderlinedStyle = (token2, options) => {
  const {
    componentCls,
    antCls
  } = token2;
  return {
    [`&:not(${componentCls}-customize-input) ${componentCls}-selector`]: {
      borderWidth: `0 0 ${unit(token2.lineWidth)} 0`,
      borderStyle: `none none ${token2.lineType} none`,
      borderColor: options.borderColor,
      background: token2.selectorBg,
      borderRadius: 0
    },
    [`&:not(${componentCls}-disabled):not(${componentCls}-customize-input):not(${antCls}-pagination-size-changer)`]: {
      [`&:hover ${componentCls}-selector`]: {
        borderColor: options.hoverBorderHover
      },
      [`${componentCls}-focused& ${componentCls}-selector`]: {
        borderColor: options.activeBorderColor,
        outline: 0
      },
      [`${componentCls}-prefix`]: {
        color: options.color
      }
    }
  };
};
var genUnderlinedStatusStyle = (token2, options) => ({
  [`&${token2.componentCls}-status-${options.status}`]: Object.assign({}, genBaseUnderlinedStyle(token2, options))
});
var genUnderlinedStyle = (token2) => ({
  "&-underlined": Object.assign(Object.assign(Object.assign(Object.assign({}, genBaseUnderlinedStyle(token2, {
    borderColor: token2.colorBorder,
    hoverBorderHover: token2.hoverBorderColor,
    activeBorderColor: token2.activeBorderColor,
    activeOutlineColor: token2.activeOutlineColor,
    color: token2.colorText
  })), genUnderlinedStatusStyle(token2, {
    status: "error",
    borderColor: token2.colorError,
    hoverBorderHover: token2.colorErrorHover,
    activeBorderColor: token2.colorError,
    activeOutlineColor: token2.colorErrorOutline,
    color: token2.colorError
  })), genUnderlinedStatusStyle(token2, {
    status: "warning",
    borderColor: token2.colorWarning,
    hoverBorderHover: token2.colorWarningHover,
    activeBorderColor: token2.colorWarning,
    activeOutlineColor: token2.colorWarningOutline,
    color: token2.colorWarning
  })), {
    [`&${token2.componentCls}-disabled`]: {
      [`&:not(${token2.componentCls}-customize-input) ${token2.componentCls}-selector`]: {
        color: token2.colorTextDisabled
      }
    },
    [`&${token2.componentCls}-multiple ${token2.componentCls}-selection-item`]: {
      background: token2.multipleItemBg,
      border: `${unit(token2.lineWidth)} ${token2.lineType} ${token2.multipleItemBorderColor}`
    }
  })
});
var genVariantsStyle = (token2) => ({
  [token2.componentCls]: Object.assign(Object.assign(Object.assign(Object.assign({}, genOutlinedStyle(token2)), genFilledStyle(token2)), genBorderlessStyle2(token2)), genUnderlinedStyle(token2))
});
var variants_default = genVariantsStyle;

// ../../node_modules/antd/es/select/style/index.js
var genSelectorStyle = (token2) => {
  const {
    componentCls
  } = token2;
  return {
    position: "relative",
    transition: `all ${token2.motionDurationMid} ${token2.motionEaseInOut}`,
    input: {
      cursor: "pointer"
    },
    [`${componentCls}-show-search&`]: {
      cursor: "text",
      input: {
        cursor: "auto",
        color: "inherit",
        height: "100%"
      }
    },
    [`${componentCls}-disabled&`]: {
      cursor: "not-allowed",
      input: {
        cursor: "not-allowed"
      }
    }
  };
};
var getSearchInputWithoutBorderStyle = (token2) => {
  const {
    componentCls
  } = token2;
  return {
    [`${componentCls}-selection-search-input`]: {
      margin: 0,
      padding: 0,
      background: "transparent",
      border: "none",
      outline: "none",
      appearance: "none",
      fontFamily: "inherit",
      "&::-webkit-search-cancel-button": {
        display: "none",
        appearance: "none"
      }
    }
  };
};
var genBaseStyle3 = (token2) => {
  const {
    antCls,
    componentCls,
    inputPaddingHorizontalBase,
    iconCls
  } = token2;
  const hoverShowClearStyle = {
    [`${componentCls}-clear`]: {
      opacity: 1,
      background: token2.colorBgBase,
      borderRadius: "50%"
    }
  };
  return {
    [componentCls]: Object.assign(Object.assign({}, resetComponent(token2)), {
      position: "relative",
      display: "inline-flex",
      cursor: "pointer",
      [`&:not(${componentCls}-customize-input) ${componentCls}-selector`]: Object.assign(Object.assign({}, genSelectorStyle(token2)), getSearchInputWithoutBorderStyle(token2)),
      // ======================== Selection ========================
      [`${componentCls}-selection-item`]: Object.assign(Object.assign({
        flex: 1,
        fontWeight: "normal",
        position: "relative",
        userSelect: "none"
      }, textEllipsis), {
        // https://github.com/ant-design/ant-design/issues/40421
        [`> ${antCls}-typography`]: {
          display: "inline"
        }
      }),
      // ======================= Placeholder =======================
      [`${componentCls}-selection-placeholder`]: Object.assign(Object.assign({}, textEllipsis), {
        flex: 1,
        color: token2.colorTextPlaceholder,
        pointerEvents: "none"
      }),
      // ========================== Arrow ==========================
      [`${componentCls}-arrow`]: Object.assign(Object.assign({}, resetIcon()), {
        position: "absolute",
        top: "50%",
        insetInlineStart: "auto",
        insetInlineEnd: inputPaddingHorizontalBase,
        height: token2.fontSizeIcon,
        marginTop: token2.calc(token2.fontSizeIcon).mul(-1).div(2).equal(),
        color: token2.colorTextQuaternary,
        fontSize: token2.fontSizeIcon,
        lineHeight: 1,
        textAlign: "center",
        pointerEvents: "none",
        display: "flex",
        alignItems: "center",
        transition: `opacity ${token2.motionDurationSlow} ease`,
        [iconCls]: {
          verticalAlign: "top",
          transition: `transform ${token2.motionDurationSlow}`,
          "> svg": {
            verticalAlign: "top"
          },
          [`&:not(${componentCls}-suffix)`]: {
            pointerEvents: "auto"
          }
        },
        [`${componentCls}-disabled &`]: {
          cursor: "not-allowed"
        },
        "> *:not(:last-child)": {
          marginInlineEnd: 8
          // FIXME: magic
        }
      }),
      // ========================== Wrap ===========================
      [`${componentCls}-selection-wrap`]: {
        display: "flex",
        width: "100%",
        position: "relative",
        minWidth: 0,
        // https://github.com/ant-design/ant-design/issues/51669
        "&:after": {
          content: '"\\a0"',
          width: 0,
          overflow: "hidden"
        }
      },
      // ========================= Prefix ==========================
      [`${componentCls}-prefix`]: {
        flex: "none",
        marginInlineEnd: token2.selectAffixPadding
      },
      // ========================== Clear ==========================
      [`${componentCls}-clear`]: {
        position: "absolute",
        top: "50%",
        insetInlineStart: "auto",
        insetInlineEnd: inputPaddingHorizontalBase,
        zIndex: 1,
        display: "inline-block",
        width: token2.fontSizeIcon,
        height: token2.fontSizeIcon,
        marginTop: token2.calc(token2.fontSizeIcon).mul(-1).div(2).equal(),
        color: token2.colorTextQuaternary,
        fontSize: token2.fontSizeIcon,
        fontStyle: "normal",
        lineHeight: 1,
        textAlign: "center",
        textTransform: "none",
        cursor: "pointer",
        opacity: 0,
        transition: `color ${token2.motionDurationMid} ease, opacity ${token2.motionDurationSlow} ease`,
        textRendering: "auto",
        // https://github.com/ant-design/ant-design/issues/54205
        // Force GPU compositing on Safari to prevent flickering on opacity/transform transitions
        transform: "translateZ(0)",
        "&:before": {
          display: "block"
        },
        "&:hover": {
          color: token2.colorIcon
        }
      },
      "@media(hover:none)": hoverShowClearStyle,
      "&:hover": hoverShowClearStyle
    }),
    // ========================= Feedback ==========================
    [`${componentCls}-status`]: {
      "&-error, &-warning, &-success, &-validating": {
        [`&${componentCls}-has-feedback`]: {
          [`${componentCls}-clear`]: {
            insetInlineEnd: token2.calc(inputPaddingHorizontalBase).add(token2.fontSize).add(token2.paddingXS).equal()
          }
        }
      }
    }
  };
};
var genSelectStyle = (token2) => {
  const {
    componentCls
  } = token2;
  return [
    {
      [componentCls]: {
        // ==================== In Form ====================
        [`&${componentCls}-in-form-item`]: {
          width: "100%"
        }
      }
    },
    // =====================================================
    // ==                       LTR                       ==
    // =====================================================
    // Base
    genBaseStyle3(token2),
    // Single
    genSingleStyle2(token2),
    // Multiple
    multiple_default(token2),
    // Dropdown
    dropdown_default(token2),
    // =====================================================
    // ==                       RTL                       ==
    // =====================================================
    {
      [`${componentCls}-rtl`]: {
        direction: "rtl"
      }
    },
    // =====================================================
    // ==             Space Compact                       ==
    // =====================================================
    genCompactItemStyle(token2, {
      borderElCls: `${componentCls}-selector`,
      focusElCls: `${componentCls}-focused`
    })
  ];
};
var style_default9 = genStyleHooks("Select", (token2, {
  rootPrefixCls
}) => {
  const selectToken = merge2(token2, {
    rootPrefixCls,
    inputPaddingHorizontalBase: token2.calc(token2.paddingSM).sub(1).equal(),
    multipleSelectItemHeight: token2.multipleItemHeight,
    selectHeight: token2.controlHeight
  });
  return [genSelectStyle(selectToken), variants_default(selectToken)];
}, prepareComponentToken6, {
  unitless: {
    optionLineHeight: true,
    optionSelectedFontWeight: true
  }
});

// ../../node_modules/antd/es/select/useIcons.js
var React182 = __toESM(require_react());

// ../../node_modules/@ant-design/icons/es/icons/CheckOutlined.js
var React179 = __toESM(require_react());

// ../../node_modules/@ant-design/icons-svg/es/asn/CheckOutlined.js
var CheckOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z" } }] }, "name": "check", "theme": "outlined" };
var CheckOutlined_default = CheckOutlined;

// ../../node_modules/@ant-design/icons/es/icons/CheckOutlined.js
var CheckOutlined2 = function CheckOutlined3(props, ref3) {
  return /* @__PURE__ */ React179.createElement(AntdIcon_default, _extends({}, props, {
    ref: ref3,
    icon: CheckOutlined_default
  }));
};
var RefIcon8 = /* @__PURE__ */ React179.forwardRef(CheckOutlined2);
if (true) {
  RefIcon8.displayName = "CheckOutlined";
}
var CheckOutlined_default2 = RefIcon8;

// ../../node_modules/@ant-design/icons/es/icons/DownOutlined.js
var React180 = __toESM(require_react());

// ../../node_modules/@ant-design/icons-svg/es/asn/DownOutlined.js
var DownOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z" } }] }, "name": "down", "theme": "outlined" };
var DownOutlined_default = DownOutlined;

// ../../node_modules/@ant-design/icons/es/icons/DownOutlined.js
var DownOutlined2 = function DownOutlined3(props, ref3) {
  return /* @__PURE__ */ React180.createElement(AntdIcon_default, _extends({}, props, {
    ref: ref3,
    icon: DownOutlined_default
  }));
};
var RefIcon9 = /* @__PURE__ */ React180.forwardRef(DownOutlined2);
if (true) {
  RefIcon9.displayName = "DownOutlined";
}
var DownOutlined_default2 = RefIcon9;

// ../../node_modules/@ant-design/icons/es/icons/SearchOutlined.js
var React181 = __toESM(require_react());

// ../../node_modules/@ant-design/icons-svg/es/asn/SearchOutlined.js
var SearchOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0011.6 0l43.6-43.5a8.2 8.2 0 000-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z" } }] }, "name": "search", "theme": "outlined" };
var SearchOutlined_default = SearchOutlined;

// ../../node_modules/@ant-design/icons/es/icons/SearchOutlined.js
var SearchOutlined2 = function SearchOutlined3(props, ref3) {
  return /* @__PURE__ */ React181.createElement(AntdIcon_default, _extends({}, props, {
    ref: ref3,
    icon: SearchOutlined_default
  }));
};
var RefIcon10 = /* @__PURE__ */ React181.forwardRef(SearchOutlined2);
if (true) {
  RefIcon10.displayName = "SearchOutlined";
}
var SearchOutlined_default2 = RefIcon10;

// ../../node_modules/antd/es/select/useIcons.js
function useIcons({
  suffixIcon,
  clearIcon,
  menuItemSelectedIcon,
  removeIcon,
  loading,
  multiple,
  hasFeedback,
  prefixCls,
  showSuffixIcon,
  feedbackIcon,
  showArrow,
  componentName
}) {
  if (true) {
    const warning6 = devUseWarning(componentName);
    warning6.deprecated(!clearIcon, "clearIcon", "allowClear={{ clearIcon: React.ReactNode }}");
  }
  const mergedClearIcon = clearIcon !== null && clearIcon !== void 0 ? clearIcon : /* @__PURE__ */ React182.createElement(CloseCircleFilled_default2, null);
  const getSuffixIconNode = (arrowIcon) => {
    if (suffixIcon === null && !hasFeedback && !showArrow) {
      return null;
    }
    return /* @__PURE__ */ React182.createElement(React182.Fragment, null, showSuffixIcon !== false && arrowIcon, hasFeedback && feedbackIcon);
  };
  let mergedSuffixIcon = null;
  if (suffixIcon !== void 0) {
    mergedSuffixIcon = getSuffixIconNode(suffixIcon);
  } else if (loading) {
    mergedSuffixIcon = getSuffixIconNode(/* @__PURE__ */ React182.createElement(LoadingOutlined_default2, {
      spin: true
    }));
  } else {
    const iconCls = `${prefixCls}-suffix`;
    mergedSuffixIcon = ({
      open: open2,
      showSearch
    }) => {
      if (open2 && showSearch) {
        return getSuffixIconNode(/* @__PURE__ */ React182.createElement(SearchOutlined_default2, {
          className: iconCls
        }));
      }
      return getSuffixIconNode(/* @__PURE__ */ React182.createElement(DownOutlined_default2, {
        className: iconCls
      }));
    };
  }
  let mergedItemIcon = null;
  if (menuItemSelectedIcon !== void 0) {
    mergedItemIcon = menuItemSelectedIcon;
  } else if (multiple) {
    mergedItemIcon = /* @__PURE__ */ React182.createElement(CheckOutlined_default2, null);
  } else {
    mergedItemIcon = null;
  }
  let mergedRemoveIcon = null;
  if (removeIcon !== void 0) {
    mergedRemoveIcon = removeIcon;
  } else {
    mergedRemoveIcon = /* @__PURE__ */ React182.createElement(CloseOutlined_default2, null);
  }
  return {
    clearIcon: mergedClearIcon,
    suffixIcon: mergedSuffixIcon,
    itemIcon: mergedItemIcon,
    removeIcon: mergedRemoveIcon
  };
}

// ../../node_modules/antd/es/select/usePopupRender.js
var import_react71 = __toESM(require_react());
function usePopupRender(renderFn) {
  return import_react71.default.useMemo(() => {
    if (!renderFn) {
      return void 0;
    }
    return (...args) => /* @__PURE__ */ import_react71.default.createElement(ContextIsolator_default, {
      space: true
    }, renderFn.apply(void 0, args));
  }, [renderFn]);
}
var usePopupRender_default = usePopupRender;

// ../../node_modules/antd/es/select/useShowArrow.js
function useShowArrow(suffixIcon, showArrow) {
  return showArrow !== void 0 ? showArrow : suffixIcon !== null;
}

// ../../node_modules/antd/es/select/index.js
var __rest11 = function(s, e3) {
  var t2 = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e3.indexOf(p) < 0) t2[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e3.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t2[p[i]] = s[p[i]];
  }
  return t2;
};
var SECRET_COMBOBOX_MODE_DO_NOT_USE = "SECRET_COMBOBOX_MODE_DO_NOT_USE";
var InternalSelect = (props, ref3) => {
  var _a, _b, _c, _d, _e;
  const {
    prefixCls: customizePrefixCls,
    bordered,
    className: className2,
    rootClassName,
    getPopupContainer,
    popupClassName,
    dropdownClassName,
    listHeight = 256,
    placement,
    listItemHeight: customListItemHeight,
    size: customizeSize,
    disabled: customDisabled,
    notFoundContent,
    status: customStatus,
    builtinPlacements,
    dropdownMatchSelectWidth,
    popupMatchSelectWidth,
    direction: propDirection,
    style: style2,
    allowClear,
    variant: customizeVariant,
    dropdownStyle,
    transitionName,
    tagRender,
    maxCount,
    prefix: prefix3,
    dropdownRender,
    popupRender,
    onDropdownVisibleChange,
    onOpenChange,
    styles,
    classNames: classNames186
  } = props, rest = __rest11(props, ["prefixCls", "bordered", "className", "rootClassName", "getPopupContainer", "popupClassName", "dropdownClassName", "listHeight", "placement", "listItemHeight", "size", "disabled", "notFoundContent", "status", "builtinPlacements", "dropdownMatchSelectWidth", "popupMatchSelectWidth", "direction", "style", "allowClear", "variant", "dropdownStyle", "transitionName", "tagRender", "maxCount", "prefix", "dropdownRender", "popupRender", "onDropdownVisibleChange", "onOpenChange", "styles", "classNames"]);
  const {
    getPopupContainer: getContextPopupContainer,
    getPrefixCls,
    renderEmpty,
    direction: contextDirection,
    virtual,
    popupMatchSelectWidth: contextPopupMatchSelectWidth,
    popupOverflow
  } = React184.useContext(ConfigContext);
  const {
    showSearch,
    style: contextStyle,
    styles: contextStyles,
    className: contextClassName,
    classNames: contextClassNames
  } = useComponentConfig("select");
  const [, token2] = useToken();
  const listItemHeight = customListItemHeight !== null && customListItemHeight !== void 0 ? customListItemHeight : token2 === null || token2 === void 0 ? void 0 : token2.controlHeight;
  const prefixCls = getPrefixCls("select", customizePrefixCls);
  const rootPrefixCls = getPrefixCls();
  const direction = propDirection !== null && propDirection !== void 0 ? propDirection : contextDirection;
  const {
    compactSize,
    compactItemClassnames
  } = useCompactItemContext(prefixCls, direction);
  const [variant, enableVariantCls] = useVariants_default("select", customizeVariant, bordered);
  const rootCls = useCSSVarCls_default(prefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = style_default9(prefixCls, rootCls);
  const mode = React184.useMemo(() => {
    const {
      mode: m
    } = props;
    if (m === "combobox") {
      return void 0;
    }
    if (m === SECRET_COMBOBOX_MODE_DO_NOT_USE) {
      return "combobox";
    }
    return m;
  }, [props.mode]);
  const isMultiple3 = mode === "multiple" || mode === "tags";
  const showSuffixIcon = useShowArrow(props.suffixIcon, props.showArrow);
  const mergedPopupMatchSelectWidth = (_a = popupMatchSelectWidth !== null && popupMatchSelectWidth !== void 0 ? popupMatchSelectWidth : dropdownMatchSelectWidth) !== null && _a !== void 0 ? _a : contextPopupMatchSelectWidth;
  const mergedPopupStyle = ((_b = styles === null || styles === void 0 ? void 0 : styles.popup) === null || _b === void 0 ? void 0 : _b.root) || ((_c = contextStyles.popup) === null || _c === void 0 ? void 0 : _c.root) || dropdownStyle;
  const mergedPopupRender = usePopupRender_default(popupRender || dropdownRender);
  const mergedOnOpenChange = onOpenChange || onDropdownVisibleChange;
  const {
    status: contextStatus,
    hasFeedback,
    isFormItemInput,
    feedbackIcon
  } = React184.useContext(FormItemInputContext);
  const mergedStatus = getMergedStatus(contextStatus, customStatus);
  let mergedNotFound;
  if (notFoundContent !== void 0) {
    mergedNotFound = notFoundContent;
  } else if (mode === "combobox") {
    mergedNotFound = null;
  } else {
    mergedNotFound = (renderEmpty === null || renderEmpty === void 0 ? void 0 : renderEmpty("Select")) || /* @__PURE__ */ React184.createElement(defaultRenderEmpty_default, {
      componentName: "Select"
    });
  }
  const {
    suffixIcon,
    itemIcon,
    removeIcon,
    clearIcon
  } = useIcons(Object.assign(Object.assign({}, rest), {
    multiple: isMultiple3,
    hasFeedback,
    feedbackIcon,
    showSuffixIcon,
    prefixCls,
    componentName: "Select"
  }));
  const mergedAllowClear = allowClear === true ? {
    clearIcon
  } : allowClear;
  const selectProps = omit(rest, ["suffixIcon", "itemIcon"]);
  const mergedPopupClassName = (0, import_classnames55.default)(((_d = classNames186 === null || classNames186 === void 0 ? void 0 : classNames186.popup) === null || _d === void 0 ? void 0 : _d.root) || ((_e = contextClassNames === null || contextClassNames === void 0 ? void 0 : contextClassNames.popup) === null || _e === void 0 ? void 0 : _e.root) || popupClassName || dropdownClassName, {
    [`${prefixCls}-dropdown-${direction}`]: direction === "rtl"
  }, rootClassName, contextClassNames.root, classNames186 === null || classNames186 === void 0 ? void 0 : classNames186.root, cssVarCls, rootCls, hashId);
  const mergedSize = useSize_default((ctx) => {
    var _a2;
    return (_a2 = customizeSize !== null && customizeSize !== void 0 ? customizeSize : compactSize) !== null && _a2 !== void 0 ? _a2 : ctx;
  });
  const disabled = React184.useContext(DisabledContext_default);
  const mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
  const mergedClassName = (0, import_classnames55.default)({
    [`${prefixCls}-lg`]: mergedSize === "large",
    [`${prefixCls}-sm`]: mergedSize === "small",
    [`${prefixCls}-rtl`]: direction === "rtl",
    [`${prefixCls}-${variant}`]: enableVariantCls,
    [`${prefixCls}-in-form-item`]: isFormItemInput
  }, getStatusClassNames(prefixCls, mergedStatus, hasFeedback), compactItemClassnames, contextClassName, className2, contextClassNames.root, classNames186 === null || classNames186 === void 0 ? void 0 : classNames186.root, rootClassName, cssVarCls, rootCls, hashId);
  const memoPlacement = React184.useMemo(() => {
    if (placement !== void 0) {
      return placement;
    }
    return direction === "rtl" ? "bottomRight" : "bottomLeft";
  }, [placement, direction]);
  if (true) {
    const warning6 = devUseWarning("Select");
    const deprecatedProps = {
      dropdownMatchSelectWidth: "popupMatchSelectWidth",
      dropdownStyle: "styles.popup.root",
      dropdownClassName: "classNames.popup.root",
      popupClassName: "classNames.popup.root",
      dropdownRender: "popupRender",
      onDropdownVisibleChange: "onOpenChange",
      bordered: "variant"
    };
    Object.entries(deprecatedProps).forEach(([oldProp, newProp]) => {
      warning6.deprecated(!(oldProp in props), oldProp, newProp);
    });
    true ? warning6(!("showArrow" in props), "deprecated", "`showArrow` is deprecated which will be removed in next major version. It will be a default behavior, you can hide it by setting `suffixIcon` to null.") : void 0;
    true ? warning6(!(typeof maxCount !== "undefined" && !isMultiple3), "usage", "`maxCount` only works with mode `multiple` or `tags`") : void 0;
  }
  const [zIndex] = useZIndex("SelectLike", mergedPopupStyle === null || mergedPopupStyle === void 0 ? void 0 : mergedPopupStyle.zIndex);
  return wrapCSSVar(/* @__PURE__ */ React184.createElement(es_default11, Object.assign({
    ref: ref3,
    virtual,
    showSearch
  }, selectProps, {
    style: Object.assign(Object.assign(Object.assign(Object.assign({}, contextStyles.root), styles === null || styles === void 0 ? void 0 : styles.root), contextStyle), style2),
    dropdownMatchSelectWidth: mergedPopupMatchSelectWidth,
    transitionName: getTransitionName2(rootPrefixCls, "slide-up", transitionName),
    builtinPlacements: mergedBuiltinPlacements_default(builtinPlacements, popupOverflow),
    listHeight,
    listItemHeight,
    mode,
    prefixCls,
    placement: memoPlacement,
    direction,
    prefix: prefix3,
    suffixIcon,
    menuItemSelectedIcon: itemIcon,
    removeIcon,
    allowClear: mergedAllowClear,
    notFoundContent: mergedNotFound,
    className: mergedClassName,
    getPopupContainer: getPopupContainer || getContextPopupContainer,
    dropdownClassName: mergedPopupClassName,
    disabled: mergedDisabled,
    dropdownStyle: Object.assign(Object.assign({}, mergedPopupStyle), {
      zIndex
    }),
    maxCount: isMultiple3 ? maxCount : void 0,
    tagRender: isMultiple3 ? tagRender : void 0,
    dropdownRender: mergedPopupRender,
    onDropdownVisibleChange: mergedOnOpenChange
  })));
};
if (true) {
  InternalSelect.displayName = "Select";
}
var Select2 = /* @__PURE__ */ React184.forwardRef(InternalSelect);
var PurePanel2 = PurePanel_default2(Select2, "dropdownAlign");
Select2.SECRET_COMBOBOX_MODE_DO_NOT_USE = SECRET_COMBOBOX_MODE_DO_NOT_USE;
Select2.Option = Option_default;
Select2.OptGroup = OptGroup_default;
Select2._InternalPanelDoNotUseOrYouWillBeFired = PurePanel2;
if (true) {
  Select2.displayName = "Select";
}
var select_default = Select2;

// ../../node_modules/antd/es/_util/responsiveObserver.js
var import_react72 = __toESM(require_react());

// ../../node_modules/antd/es/_util/mediaQueryUtil.js
var addMediaQueryListener = (mql, handler) => {
  if (typeof (mql === null || mql === void 0 ? void 0 : mql.addEventListener) !== "undefined") {
    mql.addEventListener("change", handler);
  } else if (typeof (mql === null || mql === void 0 ? void 0 : mql.addListener) !== "undefined") {
    mql.addListener(handler);
  }
};
var removeMediaQueryListener = (mql, handler) => {
  if (typeof (mql === null || mql === void 0 ? void 0 : mql.removeEventListener) !== "undefined") {
    mql.removeEventListener("change", handler);
  } else if (typeof (mql === null || mql === void 0 ? void 0 : mql.removeListener) !== "undefined") {
    mql.removeListener(handler);
  }
};

// ../../node_modules/antd/es/_util/responsiveObserver.js
var responsiveArray = ["xxl", "xl", "lg", "md", "sm", "xs"];
var getResponsiveMap = (token2) => ({
  xs: `(max-width: ${token2.screenXSMax}px)`,
  sm: `(min-width: ${token2.screenSM}px)`,
  md: `(min-width: ${token2.screenMD}px)`,
  lg: `(min-width: ${token2.screenLG}px)`,
  xl: `(min-width: ${token2.screenXL}px)`,
  xxl: `(min-width: ${token2.screenXXL}px)`
});
var validateBreakpoints = (token2) => {
  const indexableToken = token2;
  const revBreakpoints = [].concat(responsiveArray).reverse();
  revBreakpoints.forEach((breakpoint, i) => {
    const breakpointUpper = breakpoint.toUpperCase();
    const screenMin = `screen${breakpointUpper}Min`;
    const screen = `screen${breakpointUpper}`;
    if (!(indexableToken[screenMin] <= indexableToken[screen])) {
      throw new Error(`${screenMin}<=${screen} fails : !(${indexableToken[screenMin]}<=${indexableToken[screen]})`);
    }
    if (i < revBreakpoints.length - 1) {
      const screenMax = `screen${breakpointUpper}Max`;
      if (!(indexableToken[screen] <= indexableToken[screenMax])) {
        throw new Error(`${screen}<=${screenMax} fails : !(${indexableToken[screen]}<=${indexableToken[screenMax]})`);
      }
      const nextBreakpointUpperMin = revBreakpoints[i + 1].toUpperCase();
      const nextScreenMin = `screen${nextBreakpointUpperMin}Min`;
      if (!(indexableToken[screenMax] <= indexableToken[nextScreenMin])) {
        throw new Error(`${screenMax}<=${nextScreenMin} fails : !(${indexableToken[screenMax]}<=${indexableToken[nextScreenMin]})`);
      }
    }
  });
  return token2;
};
var useResponsiveObserver = () => {
  const [, token2] = useToken();
  const responsiveMap = getResponsiveMap(validateBreakpoints(token2));
  return import_react72.default.useMemo(() => {
    const subscribers = /* @__PURE__ */ new Map();
    let subUid = -1;
    let screens = {};
    return {
      responsiveMap,
      matchHandlers: {},
      dispatch(pointMap) {
        screens = pointMap;
        subscribers.forEach((func) => func(screens));
        return subscribers.size >= 1;
      },
      subscribe(func) {
        if (!subscribers.size) {
          this.register();
        }
        subUid += 1;
        subscribers.set(subUid, func);
        func(screens);
        return subUid;
      },
      unsubscribe(paramToken) {
        subscribers.delete(paramToken);
        if (!subscribers.size) {
          this.unregister();
        }
      },
      register() {
        Object.entries(responsiveMap).forEach(([screen, mediaQuery]) => {
          const listener = ({
            matches
          }) => {
            this.dispatch(Object.assign(Object.assign({}, screens), {
              [screen]: matches
            }));
          };
          const mql = window.matchMedia(mediaQuery);
          addMediaQueryListener(mql, listener);
          this.matchHandlers[mediaQuery] = {
            mql,
            listener
          };
          listener(mql);
        });
      },
      unregister() {
        Object.values(responsiveMap).forEach((mediaQuery) => {
          const handler = this.matchHandlers[mediaQuery];
          removeMediaQueryListener(handler === null || handler === void 0 ? void 0 : handler.mql, handler === null || handler === void 0 ? void 0 : handler.listener);
        });
        subscribers.clear();
      }
    };
  }, [token2]);
};
var responsiveObserver_default = useResponsiveObserver;

// ../../node_modules/antd/es/grid/hooks/useBreakpoint.js
var import_react73 = __toESM(require_react());

// ../../node_modules/antd/es/_util/hooks/useForceUpdate.js
var React186 = __toESM(require_react());
function useForceUpdate() {
  const [, forceUpdate] = React186.useReducer((x) => x + 1, 0);
  return forceUpdate;
}

// ../../node_modules/antd/es/grid/hooks/useBreakpoint.js
function useBreakpoint(refreshOnChange = true, defaultScreens = {}) {
  const screensRef = (0, import_react73.useRef)(defaultScreens);
  const forceUpdate = useForceUpdate();
  const responsiveObserver = responsiveObserver_default();
  useLayoutEffect_default(() => {
    const token2 = responsiveObserver.subscribe((supportScreens) => {
      screensRef.current = supportScreens;
      if (refreshOnChange) {
        forceUpdate();
      }
    });
    return () => responsiveObserver.unsubscribe(token2);
  }, []);
  return screensRef.current;
}
var useBreakpoint_default = useBreakpoint;

// ../../node_modules/antd/es/popover/index.js
var React192 = __toESM(require_react());
var import_react75 = __toESM(require_react());
var import_classnames62 = __toESM(require_classnames());

// ../../node_modules/antd/es/_util/getRenderPropValue.js
var getRenderPropValue = (propValue) => {
  if (!propValue) {
    return null;
  }
  return typeof propValue === "function" ? propValue() : propValue;
};

// ../../node_modules/antd/es/tooltip/index.js
var React190 = __toESM(require_react());
var import_classnames60 = __toESM(require_classnames());

// ../../node_modules/rc-tooltip/es/Popup.js
var import_classnames56 = __toESM(require_classnames());
var React187 = __toESM(require_react());
function Popup2(props) {
  var children = props.children, prefixCls = props.prefixCls, id = props.id, innerStyle = props.overlayInnerStyle, bodyClassName = props.bodyClassName, className2 = props.className, style2 = props.style;
  return /* @__PURE__ */ React187.createElement("div", {
    className: (0, import_classnames56.default)("".concat(prefixCls, "-content"), className2),
    style: style2
  }, /* @__PURE__ */ React187.createElement("div", {
    className: (0, import_classnames56.default)("".concat(prefixCls, "-inner"), bodyClassName),
    id,
    role: "tooltip",
    style: innerStyle
  }, typeof children === "function" ? children() : children));
}

// ../../node_modules/rc-tooltip/es/Tooltip.js
var import_classnames57 = __toESM(require_classnames());
var React188 = __toESM(require_react());
var import_react74 = __toESM(require_react());

// ../../node_modules/rc-tooltip/es/placements.js
var autoAdjustOverflowTopBottom = {
  shiftX: 64,
  adjustY: 1
};
var autoAdjustOverflowLeftRight = {
  adjustX: 1,
  shiftY: true
};
var targetOffset = [0, 0];
var placements = {
  left: {
    points: ["cr", "cl"],
    overflow: autoAdjustOverflowLeftRight,
    offset: [-4, 0],
    targetOffset
  },
  right: {
    points: ["cl", "cr"],
    overflow: autoAdjustOverflowLeftRight,
    offset: [4, 0],
    targetOffset
  },
  top: {
    points: ["bc", "tc"],
    overflow: autoAdjustOverflowTopBottom,
    offset: [0, -4],
    targetOffset
  },
  bottom: {
    points: ["tc", "bc"],
    overflow: autoAdjustOverflowTopBottom,
    offset: [0, 4],
    targetOffset
  },
  topLeft: {
    points: ["bl", "tl"],
    overflow: autoAdjustOverflowTopBottom,
    offset: [0, -4],
    targetOffset
  },
  leftTop: {
    points: ["tr", "tl"],
    overflow: autoAdjustOverflowLeftRight,
    offset: [-4, 0],
    targetOffset
  },
  topRight: {
    points: ["br", "tr"],
    overflow: autoAdjustOverflowTopBottom,
    offset: [0, -4],
    targetOffset
  },
  rightTop: {
    points: ["tl", "tr"],
    overflow: autoAdjustOverflowLeftRight,
    offset: [4, 0],
    targetOffset
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: autoAdjustOverflowTopBottom,
    offset: [0, 4],
    targetOffset
  },
  rightBottom: {
    points: ["bl", "br"],
    overflow: autoAdjustOverflowLeftRight,
    offset: [4, 0],
    targetOffset
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: autoAdjustOverflowTopBottom,
    offset: [0, 4],
    targetOffset
  },
  leftBottom: {
    points: ["br", "bl"],
    overflow: autoAdjustOverflowLeftRight,
    offset: [-4, 0],
    targetOffset
  }
};

// ../../node_modules/rc-tooltip/es/Tooltip.js
var _excluded28 = ["overlayClassName", "trigger", "mouseEnterDelay", "mouseLeaveDelay", "overlayStyle", "prefixCls", "children", "onVisibleChange", "afterVisibleChange", "transitionName", "animation", "motion", "placement", "align", "destroyTooltipOnHide", "defaultVisible", "getTooltipContainer", "overlayInnerStyle", "arrowContent", "overlay", "id", "showArrow", "classNames", "styles"];
var Tooltip = function Tooltip2(props, ref3) {
  var overlayClassName = props.overlayClassName, _props$trigger = props.trigger, trigger2 = _props$trigger === void 0 ? ["hover"] : _props$trigger, _props$mouseEnterDela = props.mouseEnterDelay, mouseEnterDelay = _props$mouseEnterDela === void 0 ? 0 : _props$mouseEnterDela, _props$mouseLeaveDela = props.mouseLeaveDelay, mouseLeaveDelay = _props$mouseLeaveDela === void 0 ? 0.1 : _props$mouseLeaveDela, overlayStyle = props.overlayStyle, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-tooltip" : _props$prefixCls, children = props.children, onVisibleChange = props.onVisibleChange, afterVisibleChange = props.afterVisibleChange, transitionName = props.transitionName, animation = props.animation, motion2 = props.motion, _props$placement = props.placement, placement = _props$placement === void 0 ? "right" : _props$placement, _props$align = props.align, align = _props$align === void 0 ? {} : _props$align, _props$destroyTooltip = props.destroyTooltipOnHide, destroyTooltipOnHide = _props$destroyTooltip === void 0 ? false : _props$destroyTooltip, defaultVisible = props.defaultVisible, getTooltipContainer = props.getTooltipContainer, overlayInnerStyle = props.overlayInnerStyle, arrowContent = props.arrowContent, overlay = props.overlay, id = props.id, _props$showArrow = props.showArrow, showArrow = _props$showArrow === void 0 ? true : _props$showArrow, tooltipClassNames = props.classNames, tooltipStyles = props.styles, restProps = _objectWithoutProperties(props, _excluded28);
  var mergedId = useId_default(id);
  var triggerRef = (0, import_react74.useRef)(null);
  (0, import_react74.useImperativeHandle)(ref3, function() {
    return triggerRef.current;
  });
  var extraProps = _objectSpread2({}, restProps);
  if ("visible" in props) {
    extraProps.popupVisible = props.visible;
  }
  var getPopupElement = function getPopupElement2() {
    return /* @__PURE__ */ React188.createElement(Popup2, {
      key: "content",
      prefixCls,
      id: mergedId,
      bodyClassName: tooltipClassNames === null || tooltipClassNames === void 0 ? void 0 : tooltipClassNames.body,
      overlayInnerStyle: _objectSpread2(_objectSpread2({}, overlayInnerStyle), tooltipStyles === null || tooltipStyles === void 0 ? void 0 : tooltipStyles.body)
    }, overlay);
  };
  var getChildren = function getChildren2() {
    var child = React188.Children.only(children);
    var originalProps = (child === null || child === void 0 ? void 0 : child.props) || {};
    var childProps = _objectSpread2(_objectSpread2({}, originalProps), {}, {
      "aria-describedby": overlay ? mergedId : null
    });
    return /* @__PURE__ */ React188.cloneElement(children, childProps);
  };
  return /* @__PURE__ */ React188.createElement(es_default9, _extends({
    popupClassName: (0, import_classnames57.default)(overlayClassName, tooltipClassNames === null || tooltipClassNames === void 0 ? void 0 : tooltipClassNames.root),
    prefixCls,
    popup: getPopupElement,
    action: trigger2,
    builtinPlacements: placements,
    popupPlacement: placement,
    ref: triggerRef,
    popupAlign: align,
    getPopupContainer: getTooltipContainer,
    onPopupVisibleChange: onVisibleChange,
    afterPopupVisibleChange: afterVisibleChange,
    popupTransitionName: transitionName,
    popupAnimation: animation,
    popupMotion: motion2,
    defaultPopupVisible: defaultVisible,
    autoDestroy: destroyTooltipOnHide,
    mouseLeaveDelay,
    popupStyle: _objectSpread2(_objectSpread2({}, overlayStyle), tooltipStyles === null || tooltipStyles === void 0 ? void 0 : tooltipStyles.root),
    mouseEnterDelay,
    arrow: showArrow
  }, extraProps), getChildren());
};
var Tooltip_default = /* @__PURE__ */ (0, import_react74.forwardRef)(Tooltip);

// ../../node_modules/rc-tooltip/es/index.js
var es_default12 = Tooltip_default;

// ../../node_modules/antd/es/style/roundedArrow.js
function getArrowToken(token2) {
  const {
    sizePopupArrow,
    borderRadiusXS,
    borderRadiusOuter
  } = token2;
  const unitWidth = sizePopupArrow / 2;
  const ax = 0;
  const ay = unitWidth;
  const bx = borderRadiusOuter * 1 / Math.sqrt(2);
  const by = unitWidth - borderRadiusOuter * (1 - 1 / Math.sqrt(2));
  const cx = unitWidth - borderRadiusXS * (1 / Math.sqrt(2));
  const cy = borderRadiusOuter * (Math.sqrt(2) - 1) + borderRadiusXS * (1 / Math.sqrt(2));
  const dx = 2 * unitWidth - cx;
  const dy = cy;
  const ex = 2 * unitWidth - bx;
  const ey = by;
  const fx = 2 * unitWidth - ax;
  const fy = ay;
  const shadowWidth = unitWidth * Math.sqrt(2) + borderRadiusOuter * (Math.sqrt(2) - 2);
  const polygonOffset = borderRadiusOuter * (Math.sqrt(2) - 1);
  const arrowPolygon = `polygon(${polygonOffset}px 100%, 50% ${polygonOffset}px, ${2 * unitWidth - polygonOffset}px 100%, ${polygonOffset}px 100%)`;
  const arrowPath = `path('M ${ax} ${ay} A ${borderRadiusOuter} ${borderRadiusOuter} 0 0 0 ${bx} ${by} L ${cx} ${cy} A ${borderRadiusXS} ${borderRadiusXS} 0 0 1 ${dx} ${dy} L ${ex} ${ey} A ${borderRadiusOuter} ${borderRadiusOuter} 0 0 0 ${fx} ${fy} Z')`;
  return {
    arrowShadowWidth: shadowWidth,
    arrowPath,
    arrowPolygon
  };
}
var genRoundedArrow = (token2, bgColor, boxShadow) => {
  const {
    sizePopupArrow,
    arrowPolygon,
    arrowPath,
    arrowShadowWidth,
    borderRadiusXS,
    calc
  } = token2;
  return {
    pointerEvents: "none",
    width: sizePopupArrow,
    height: sizePopupArrow,
    overflow: "hidden",
    "&::before": {
      position: "absolute",
      bottom: 0,
      insetInlineStart: 0,
      width: sizePopupArrow,
      height: calc(sizePopupArrow).div(2).equal(),
      background: bgColor,
      clipPath: {
        _multi_value_: true,
        value: [arrowPolygon, arrowPath]
      },
      content: '""'
    },
    "&::after": {
      content: '""',
      position: "absolute",
      width: arrowShadowWidth,
      height: arrowShadowWidth,
      bottom: 0,
      insetInline: 0,
      margin: "auto",
      borderRadius: {
        _skip_check_: true,
        value: `0 0 ${unit(borderRadiusXS)} 0`
      },
      transform: "translateY(50%) rotate(-135deg)",
      boxShadow,
      zIndex: 0,
      background: "transparent"
    }
  };
};

// ../../node_modules/antd/es/style/placementArrow.js
var MAX_VERTICAL_CONTENT_RADIUS = 8;
function getArrowOffsetToken(options) {
  const {
    contentRadius,
    limitVerticalRadius
  } = options;
  const arrowOffset = contentRadius > 12 ? contentRadius + 2 : 12;
  const arrowOffsetVertical = limitVerticalRadius ? MAX_VERTICAL_CONTENT_RADIUS : arrowOffset;
  return {
    arrowOffsetHorizontal: arrowOffset,
    arrowOffsetVertical
  };
}
function isInject(valid, code2) {
  if (!valid) {
    return {};
  }
  return code2;
}
function getArrowStyle(token2, colorBg, options) {
  const {
    componentCls,
    boxShadowPopoverArrow,
    arrowOffsetVertical,
    arrowOffsetHorizontal
  } = token2;
  const {
    arrowDistance = 0,
    arrowPlacement = {
      left: true,
      right: true,
      top: true,
      bottom: true
    }
  } = options || {};
  return {
    [componentCls]: Object.assign(Object.assign(Object.assign(Object.assign({
      // ============================ Basic ============================
      [`${componentCls}-arrow`]: [Object.assign(Object.assign({
        position: "absolute",
        zIndex: 1,
        display: "block"
      }, genRoundedArrow(token2, colorBg, boxShadowPopoverArrow)), {
        "&:before": {
          background: colorBg
        }
      })]
    }, isInject(!!arrowPlacement.top, {
      [[`&-placement-top > ${componentCls}-arrow`, `&-placement-topLeft > ${componentCls}-arrow`, `&-placement-topRight > ${componentCls}-arrow`].join(",")]: {
        bottom: arrowDistance,
        transform: "translateY(100%) rotate(180deg)"
      },
      [`&-placement-top > ${componentCls}-arrow`]: {
        left: {
          _skip_check_: true,
          value: "50%"
        },
        transform: "translateX(-50%) translateY(100%) rotate(180deg)"
      },
      "&-placement-topLeft": {
        "--arrow-offset-horizontal": arrowOffsetHorizontal,
        [`> ${componentCls}-arrow`]: {
          left: {
            _skip_check_: true,
            value: arrowOffsetHorizontal
          }
        }
      },
      "&-placement-topRight": {
        "--arrow-offset-horizontal": `calc(100% - ${unit(arrowOffsetHorizontal)})`,
        [`> ${componentCls}-arrow`]: {
          right: {
            _skip_check_: true,
            value: arrowOffsetHorizontal
          }
        }
      }
    })), isInject(!!arrowPlacement.bottom, {
      [[`&-placement-bottom > ${componentCls}-arrow`, `&-placement-bottomLeft > ${componentCls}-arrow`, `&-placement-bottomRight > ${componentCls}-arrow`].join(",")]: {
        top: arrowDistance,
        transform: `translateY(-100%)`
      },
      [`&-placement-bottom > ${componentCls}-arrow`]: {
        left: {
          _skip_check_: true,
          value: "50%"
        },
        transform: `translateX(-50%) translateY(-100%)`
      },
      "&-placement-bottomLeft": {
        "--arrow-offset-horizontal": arrowOffsetHorizontal,
        [`> ${componentCls}-arrow`]: {
          left: {
            _skip_check_: true,
            value: arrowOffsetHorizontal
          }
        }
      },
      "&-placement-bottomRight": {
        "--arrow-offset-horizontal": `calc(100% - ${unit(arrowOffsetHorizontal)})`,
        [`> ${componentCls}-arrow`]: {
          right: {
            _skip_check_: true,
            value: arrowOffsetHorizontal
          }
        }
      }
    })), isInject(!!arrowPlacement.left, {
      [[`&-placement-left > ${componentCls}-arrow`, `&-placement-leftTop > ${componentCls}-arrow`, `&-placement-leftBottom > ${componentCls}-arrow`].join(",")]: {
        right: {
          _skip_check_: true,
          value: arrowDistance
        },
        transform: "translateX(100%) rotate(90deg)"
      },
      [`&-placement-left > ${componentCls}-arrow`]: {
        top: {
          _skip_check_: true,
          value: "50%"
        },
        transform: "translateY(-50%) translateX(100%) rotate(90deg)"
      },
      [`&-placement-leftTop > ${componentCls}-arrow`]: {
        top: arrowOffsetVertical
      },
      [`&-placement-leftBottom > ${componentCls}-arrow`]: {
        bottom: arrowOffsetVertical
      }
    })), isInject(!!arrowPlacement.right, {
      [[`&-placement-right > ${componentCls}-arrow`, `&-placement-rightTop > ${componentCls}-arrow`, `&-placement-rightBottom > ${componentCls}-arrow`].join(",")]: {
        left: {
          _skip_check_: true,
          value: arrowDistance
        },
        transform: "translateX(-100%) rotate(-90deg)"
      },
      [`&-placement-right > ${componentCls}-arrow`]: {
        top: {
          _skip_check_: true,
          value: "50%"
        },
        transform: "translateY(-50%) translateX(-100%) rotate(-90deg)"
      },
      [`&-placement-rightTop > ${componentCls}-arrow`]: {
        top: arrowOffsetVertical
      },
      [`&-placement-rightBottom > ${componentCls}-arrow`]: {
        bottom: arrowOffsetVertical
      }
    }))
  };
}

// ../../node_modules/antd/es/_util/placements.js
function getOverflowOptions(placement, arrowOffset, arrowWidth, autoAdjustOverflow3) {
  if (autoAdjustOverflow3 === false) {
    return {
      adjustX: false,
      adjustY: false
    };
  }
  const overflow = autoAdjustOverflow3 && typeof autoAdjustOverflow3 === "object" ? autoAdjustOverflow3 : {};
  const baseOverflow = {};
  switch (placement) {
    case "top":
    case "bottom":
      baseOverflow.shiftX = arrowOffset.arrowOffsetHorizontal * 2 + arrowWidth;
      baseOverflow.shiftY = true;
      baseOverflow.adjustY = true;
      break;
    case "left":
    case "right":
      baseOverflow.shiftY = arrowOffset.arrowOffsetVertical * 2 + arrowWidth;
      baseOverflow.shiftX = true;
      baseOverflow.adjustX = true;
      break;
  }
  const mergedOverflow = Object.assign(Object.assign({}, baseOverflow), overflow);
  if (!mergedOverflow.shiftX) {
    mergedOverflow.adjustX = true;
  }
  if (!mergedOverflow.shiftY) {
    mergedOverflow.adjustY = true;
  }
  return mergedOverflow;
}
var PlacementAlignMap = {
  left: {
    points: ["cr", "cl"]
  },
  right: {
    points: ["cl", "cr"]
  },
  top: {
    points: ["bc", "tc"]
  },
  bottom: {
    points: ["tc", "bc"]
  },
  topLeft: {
    points: ["bl", "tl"]
  },
  leftTop: {
    points: ["tr", "tl"]
  },
  topRight: {
    points: ["br", "tr"]
  },
  rightTop: {
    points: ["tl", "tr"]
  },
  bottomRight: {
    points: ["tr", "br"]
  },
  rightBottom: {
    points: ["bl", "br"]
  },
  bottomLeft: {
    points: ["tl", "bl"]
  },
  leftBottom: {
    points: ["br", "bl"]
  }
};
var ArrowCenterPlacementAlignMap = {
  topLeft: {
    points: ["bl", "tc"]
  },
  leftTop: {
    points: ["tr", "cl"]
  },
  topRight: {
    points: ["br", "tc"]
  },
  rightTop: {
    points: ["tl", "cr"]
  },
  bottomRight: {
    points: ["tr", "bc"]
  },
  rightBottom: {
    points: ["bl", "cr"]
  },
  bottomLeft: {
    points: ["tl", "bc"]
  },
  leftBottom: {
    points: ["br", "cl"]
  }
};
var DisableAutoArrowList = /* @__PURE__ */ new Set(["topLeft", "topRight", "bottomLeft", "bottomRight", "leftTop", "leftBottom", "rightTop", "rightBottom"]);
function getPlacements(config) {
  const {
    arrowWidth,
    autoAdjustOverflow: autoAdjustOverflow3,
    arrowPointAtCenter,
    offset: offset4,
    borderRadius,
    visibleFirst
  } = config;
  const halfArrowWidth = arrowWidth / 2;
  const placementMap = {};
  const arrowOffset = getArrowOffsetToken({
    contentRadius: borderRadius,
    limitVerticalRadius: true
  });
  Object.keys(PlacementAlignMap).forEach((key2) => {
    const template = arrowPointAtCenter && ArrowCenterPlacementAlignMap[key2] || PlacementAlignMap[key2];
    const placementInfo = Object.assign(Object.assign({}, template), {
      offset: [0, 0],
      dynamicInset: true
    });
    placementMap[key2] = placementInfo;
    if (DisableAutoArrowList.has(key2)) {
      placementInfo.autoArrow = false;
    }
    switch (key2) {
      case "top":
      case "topLeft":
      case "topRight":
        placementInfo.offset[1] = -halfArrowWidth - offset4;
        break;
      case "bottom":
      case "bottomLeft":
      case "bottomRight":
        placementInfo.offset[1] = halfArrowWidth + offset4;
        break;
      case "left":
      case "leftTop":
      case "leftBottom":
        placementInfo.offset[0] = -halfArrowWidth - offset4;
        break;
      case "right":
      case "rightTop":
      case "rightBottom":
        placementInfo.offset[0] = halfArrowWidth + offset4;
        break;
    }
    if (arrowPointAtCenter) {
      switch (key2) {
        case "topLeft":
        case "bottomLeft":
          placementInfo.offset[0] = -arrowOffset.arrowOffsetHorizontal - halfArrowWidth;
          break;
        case "topRight":
        case "bottomRight":
          placementInfo.offset[0] = arrowOffset.arrowOffsetHorizontal + halfArrowWidth;
          break;
        case "leftTop":
        case "rightTop":
          placementInfo.offset[1] = -arrowOffset.arrowOffsetHorizontal * 2 + halfArrowWidth;
          break;
        case "leftBottom":
        case "rightBottom":
          placementInfo.offset[1] = arrowOffset.arrowOffsetHorizontal * 2 - halfArrowWidth;
          break;
      }
    }
    placementInfo.overflow = getOverflowOptions(key2, arrowOffset, arrowWidth, autoAdjustOverflow3);
    if (visibleFirst) {
      placementInfo.htmlRegion = "visibleFirst";
    }
  });
  return placementMap;
}

// ../../node_modules/antd/es/tooltip/PurePanel.js
var React189 = __toESM(require_react());
var import_classnames59 = __toESM(require_classnames());

// ../../node_modules/antd/es/tooltip/style/index.js
var genTooltipStyle = (token2) => {
  const {
    calc,
    componentCls,
    // ant-tooltip
    tooltipMaxWidth,
    tooltipColor,
    tooltipBg,
    tooltipBorderRadius,
    zIndexPopup,
    controlHeight,
    boxShadowSecondary,
    paddingSM,
    paddingXS,
    arrowOffsetHorizontal,
    sizePopupArrow
  } = token2;
  const edgeAlignMinWidth = calc(tooltipBorderRadius).add(sizePopupArrow).add(arrowOffsetHorizontal).equal();
  const centerAlignMinWidth = calc(tooltipBorderRadius).mul(2).add(sizePopupArrow).equal();
  return [
    {
      [componentCls]: Object.assign(Object.assign(Object.assign(Object.assign({}, resetComponent(token2)), {
        position: "absolute",
        zIndex: zIndexPopup,
        display: "block",
        width: "max-content",
        maxWidth: tooltipMaxWidth,
        visibility: "visible",
        // When use `autoArrow`, origin will follow the arrow position
        "--valid-offset-x": "var(--arrow-offset-horizontal, var(--arrow-x))",
        transformOrigin: [`var(--valid-offset-x, 50%)`, `var(--arrow-y, 50%)`].join(" "),
        "&-hidden": {
          display: "none"
        },
        "--antd-arrow-background-color": tooltipBg,
        // Wrapper for the tooltip content
        [`${componentCls}-inner`]: {
          minWidth: centerAlignMinWidth,
          minHeight: controlHeight,
          padding: `${unit(token2.calc(paddingSM).div(2).equal())} ${unit(paddingXS)}`,
          color: `var(--ant-tooltip-color, ${tooltipColor})`,
          textAlign: "start",
          textDecoration: "none",
          wordWrap: "break-word",
          backgroundColor: tooltipBg,
          borderRadius: tooltipBorderRadius,
          boxShadow: boxShadowSecondary,
          boxSizing: "border-box"
        },
        // Align placement should have another min width
        [[`&-placement-topLeft`, `&-placement-topRight`, `&-placement-bottomLeft`, `&-placement-bottomRight`].join(",")]: {
          minWidth: edgeAlignMinWidth
        },
        // Limit left and right placement radius
        [[`&-placement-left`, `&-placement-leftTop`, `&-placement-leftBottom`, `&-placement-right`, `&-placement-rightTop`, `&-placement-rightBottom`].join(",")]: {
          [`${componentCls}-inner`]: {
            borderRadius: token2.min(tooltipBorderRadius, MAX_VERTICAL_CONTENT_RADIUS)
          }
        },
        [`${componentCls}-content`]: {
          position: "relative"
        }
      }), genPresetColor(token2, (colorKey, {
        darkColor
      }) => ({
        [`&${componentCls}-${colorKey}`]: {
          [`${componentCls}-inner`]: {
            backgroundColor: darkColor
          },
          [`${componentCls}-arrow`]: {
            "--antd-arrow-background-color": darkColor
          }
        }
      }))), {
        // RTL
        "&-rtl": {
          direction: "rtl"
        }
      })
    },
    // Arrow Style
    getArrowStyle(token2, "var(--antd-arrow-background-color)"),
    // Pure Render
    {
      [`${componentCls}-pure`]: {
        position: "relative",
        maxWidth: "none",
        margin: token2.sizePopupArrow
      }
    }
  ];
};
var prepareComponentToken7 = (token2) => Object.assign(Object.assign({
  zIndexPopup: token2.zIndexPopupBase + 70
}, getArrowOffsetToken({
  contentRadius: token2.borderRadius,
  limitVerticalRadius: true
})), getArrowToken(merge2(token2, {
  borderRadiusOuter: Math.min(token2.borderRadiusOuter, 4)
})));
var style_default10 = (prefixCls, injectStyle2 = true) => {
  const useStyle = genStyleHooks("Tooltip", (token2) => {
    const {
      borderRadius,
      colorTextLightSolid,
      colorBgSpotlight
    } = token2;
    const TooltipToken = merge2(token2, {
      // default variables
      tooltipMaxWidth: 250,
      tooltipColor: colorTextLightSolid,
      tooltipBorderRadius: borderRadius,
      tooltipBg: colorBgSpotlight
    });
    return [genTooltipStyle(TooltipToken), initZoomMotion(token2, "zoom-big-fast")];
  }, prepareComponentToken7, {
    resetStyle: false,
    // Popover use Tooltip as internal component. We do not need to handle this.
    injectStyle: injectStyle2
  });
  return useStyle(prefixCls);
};

// ../../node_modules/antd/es/tooltip/util.js
var import_classnames58 = __toESM(require_classnames());

// ../../node_modules/antd/es/_util/colors.js
var inverseColors = PresetColors.map((color) => `${color}-inverse`);
function isPresetColor(color, includeInverse = true) {
  if (includeInverse) {
    return [].concat(_toConsumableArray(inverseColors), _toConsumableArray(PresetColors)).includes(color);
  }
  return PresetColors.includes(color);
}

// ../../node_modules/antd/es/tooltip/util.js
function parseColor(prefixCls, color) {
  const isInternalColor = isPresetColor(color);
  const className2 = (0, import_classnames58.default)({
    [`${prefixCls}-${color}`]: color && isInternalColor
  });
  const overlayStyle = {};
  const arrowStyle = {};
  const rgb2 = generateColor3(color).toRgb();
  const luminance = (0.299 * rgb2.r + 0.587 * rgb2.g + 0.114 * rgb2.b) / 255;
  const textColor = luminance < 0.5 ? "#FFF" : "#000";
  if (color && !isInternalColor) {
    overlayStyle.background = color;
    overlayStyle["--ant-tooltip-color"] = textColor;
    arrowStyle["--antd-arrow-background-color"] = color;
  }
  return {
    className: className2,
    overlayStyle,
    arrowStyle
  };
}

// ../../node_modules/antd/es/tooltip/PurePanel.js
var PurePanel3 = (props) => {
  const {
    prefixCls: customizePrefixCls,
    className: className2,
    placement = "top",
    title,
    color,
    overlayInnerStyle
  } = props;
  const {
    getPrefixCls
  } = React189.useContext(ConfigContext);
  const prefixCls = getPrefixCls("tooltip", customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = style_default10(prefixCls);
  const colorInfo = parseColor(prefixCls, color);
  const arrowContentStyle = colorInfo.arrowStyle;
  const formattedOverlayInnerStyle = Object.assign(Object.assign({}, overlayInnerStyle), colorInfo.overlayStyle);
  const cls11 = (0, import_classnames59.default)(hashId, cssVarCls, prefixCls, `${prefixCls}-pure`, `${prefixCls}-placement-${placement}`, className2, colorInfo.className);
  return wrapCSSVar(/* @__PURE__ */ React189.createElement("div", {
    className: cls11,
    style: arrowContentStyle
  }, /* @__PURE__ */ React189.createElement("div", {
    className: `${prefixCls}-arrow`
  }), /* @__PURE__ */ React189.createElement(Popup2, Object.assign({}, props, {
    className: hashId,
    prefixCls,
    overlayInnerStyle: formattedOverlayInnerStyle
  }), title)));
};
var PurePanel_default3 = PurePanel3;

// ../../node_modules/antd/es/tooltip/index.js
var __rest12 = function(s, e3) {
  var t2 = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e3.indexOf(p) < 0) t2[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e3.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t2[p[i]] = s[p[i]];
  }
  return t2;
};
var InternalTooltip = /* @__PURE__ */ React190.forwardRef((props, ref3) => {
  var _a, _b;
  const {
    prefixCls: customizePrefixCls,
    openClassName,
    getTooltipContainer,
    color,
    overlayInnerStyle,
    children,
    afterOpenChange,
    afterVisibleChange,
    destroyTooltipOnHide,
    destroyOnHidden,
    arrow = true,
    title,
    overlay,
    builtinPlacements,
    arrowPointAtCenter = false,
    autoAdjustOverflow: autoAdjustOverflow3 = true,
    motion: motion2,
    getPopupContainer,
    placement = "top",
    mouseEnterDelay = 0.1,
    mouseLeaveDelay = 0.1,
    overlayStyle,
    rootClassName,
    overlayClassName,
    styles,
    classNames: tooltipClassNames
  } = props, restProps = __rest12(props, ["prefixCls", "openClassName", "getTooltipContainer", "color", "overlayInnerStyle", "children", "afterOpenChange", "afterVisibleChange", "destroyTooltipOnHide", "destroyOnHidden", "arrow", "title", "overlay", "builtinPlacements", "arrowPointAtCenter", "autoAdjustOverflow", "motion", "getPopupContainer", "placement", "mouseEnterDelay", "mouseLeaveDelay", "overlayStyle", "rootClassName", "overlayClassName", "styles", "classNames"]);
  const mergedShowArrow = !!arrow;
  const [, token2] = useToken();
  const {
    getPopupContainer: getContextPopupContainer,
    getPrefixCls,
    direction,
    className: contextClassName,
    style: contextStyle,
    classNames: contextClassNames,
    styles: contextStyles
  } = useComponentConfig("tooltip");
  const warning6 = devUseWarning("Tooltip");
  const tooltipRef = React190.useRef(null);
  const forceAlign = () => {
    var _a2;
    (_a2 = tooltipRef.current) === null || _a2 === void 0 ? void 0 : _a2.forceAlign();
  };
  React190.useImperativeHandle(ref3, () => {
    var _a2, _b2;
    return {
      forceAlign,
      forcePopupAlign: () => {
        warning6.deprecated(false, "forcePopupAlign", "forceAlign");
        forceAlign();
      },
      nativeElement: (_a2 = tooltipRef.current) === null || _a2 === void 0 ? void 0 : _a2.nativeElement,
      popupElement: (_b2 = tooltipRef.current) === null || _b2 === void 0 ? void 0 : _b2.popupElement
    };
  });
  if (true) {
    [["visible", "open"], ["defaultVisible", "defaultOpen"], ["onVisibleChange", "onOpenChange"], ["afterVisibleChange", "afterOpenChange"], ["destroyTooltipOnHide", "destroyOnHidden"], ["arrowPointAtCenter", "arrow={{ pointAtCenter: true }}"], ["overlayStyle", "styles={{ root: {} }}"], ["overlayInnerStyle", "styles={{ body: {} }}"], ["overlayClassName", 'classNames={{ root: "" }}']].forEach(([deprecatedName, newName]) => {
      warning6.deprecated(!(deprecatedName in props), deprecatedName, newName);
    });
    true ? warning6(!destroyTooltipOnHide || typeof destroyTooltipOnHide === "boolean", "usage", "`destroyTooltipOnHide` no need config `keepParent` anymore. Please use `boolean` value directly.") : void 0;
    true ? warning6(!arrow || typeof arrow === "boolean" || !("arrowPointAtCenter" in arrow), "deprecated", "`arrowPointAtCenter` in `arrow` is deprecated. Please use `pointAtCenter` instead.") : void 0;
  }
  const [open2, setOpen] = useMergedState(false, {
    value: (_a = props.open) !== null && _a !== void 0 ? _a : props.visible,
    defaultValue: (_b = props.defaultOpen) !== null && _b !== void 0 ? _b : props.defaultVisible
  });
  const noTitle = !title && !overlay && title !== 0;
  const onOpenChange = (vis) => {
    var _a2, _b2;
    setOpen(noTitle ? false : vis);
    if (!noTitle) {
      (_a2 = props.onOpenChange) === null || _a2 === void 0 ? void 0 : _a2.call(props, vis);
      (_b2 = props.onVisibleChange) === null || _b2 === void 0 ? void 0 : _b2.call(props, vis);
    }
  };
  const tooltipPlacements = React190.useMemo(() => {
    var _a2, _b2;
    let mergedArrowPointAtCenter = arrowPointAtCenter;
    if (typeof arrow === "object") {
      mergedArrowPointAtCenter = (_b2 = (_a2 = arrow.pointAtCenter) !== null && _a2 !== void 0 ? _a2 : arrow.arrowPointAtCenter) !== null && _b2 !== void 0 ? _b2 : arrowPointAtCenter;
    }
    return builtinPlacements || getPlacements({
      arrowPointAtCenter: mergedArrowPointAtCenter,
      autoAdjustOverflow: autoAdjustOverflow3,
      arrowWidth: mergedShowArrow ? token2.sizePopupArrow : 0,
      borderRadius: token2.borderRadius,
      offset: token2.marginXXS,
      visibleFirst: true
    });
  }, [arrowPointAtCenter, arrow, builtinPlacements, token2]);
  const memoOverlay = React190.useMemo(() => {
    if (title === 0) {
      return title;
    }
    return overlay || title || "";
  }, [overlay, title]);
  const memoOverlayWrapper = /* @__PURE__ */ React190.createElement(ContextIsolator_default, {
    space: true
  }, typeof memoOverlay === "function" ? memoOverlay() : memoOverlay);
  const prefixCls = getPrefixCls("tooltip", customizePrefixCls);
  const rootPrefixCls = getPrefixCls();
  const injectFromPopover = props["data-popover-inject"];
  let tempOpen = open2;
  if (!("open" in props) && !("visible" in props) && noTitle) {
    tempOpen = false;
  }
  const child = /* @__PURE__ */ React190.isValidElement(children) && !isFragment2(children) ? children : /* @__PURE__ */ React190.createElement("span", null, children);
  const childProps = child.props;
  const childCls = !childProps.className || typeof childProps.className === "string" ? (0, import_classnames60.default)(childProps.className, openClassName || `${prefixCls}-open`) : childProps.className;
  const [wrapCSSVar, hashId, cssVarCls] = style_default10(prefixCls, !injectFromPopover);
  const colorInfo = parseColor(prefixCls, color);
  const arrowContentStyle = colorInfo.arrowStyle;
  const rootClassNames = (0, import_classnames60.default)(overlayClassName, {
    [`${prefixCls}-rtl`]: direction === "rtl"
  }, colorInfo.className, rootClassName, hashId, cssVarCls, contextClassName, contextClassNames.root, tooltipClassNames === null || tooltipClassNames === void 0 ? void 0 : tooltipClassNames.root);
  const bodyClassNames = (0, import_classnames60.default)(contextClassNames.body, tooltipClassNames === null || tooltipClassNames === void 0 ? void 0 : tooltipClassNames.body);
  const [zIndex, contextZIndex] = useZIndex("Tooltip", restProps.zIndex);
  const content = /* @__PURE__ */ React190.createElement(es_default12, Object.assign({}, restProps, {
    zIndex,
    showArrow: mergedShowArrow,
    placement,
    mouseEnterDelay,
    mouseLeaveDelay,
    prefixCls,
    classNames: {
      root: rootClassNames,
      body: bodyClassNames
    },
    styles: {
      root: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, arrowContentStyle), contextStyles.root), contextStyle), overlayStyle), styles === null || styles === void 0 ? void 0 : styles.root),
      body: Object.assign(Object.assign(Object.assign(Object.assign({}, contextStyles.body), overlayInnerStyle), styles === null || styles === void 0 ? void 0 : styles.body), colorInfo.overlayStyle)
    },
    getTooltipContainer: getPopupContainer || getTooltipContainer || getContextPopupContainer,
    ref: tooltipRef,
    builtinPlacements: tooltipPlacements,
    overlay: memoOverlayWrapper,
    visible: tempOpen,
    onVisibleChange: onOpenChange,
    afterVisibleChange: afterOpenChange !== null && afterOpenChange !== void 0 ? afterOpenChange : afterVisibleChange,
    arrowContent: /* @__PURE__ */ React190.createElement("span", {
      className: `${prefixCls}-arrow-content`
    }),
    motion: {
      motionName: getTransitionName2(rootPrefixCls, "zoom-big-fast", props.transitionName),
      motionDeadline: 1e3
    },
    // TODO: In the future, destroyTooltipOnHide in rc-tooltip needs to be upgrade to destroyOnHidden
    destroyTooltipOnHide: destroyOnHidden !== null && destroyOnHidden !== void 0 ? destroyOnHidden : !!destroyTooltipOnHide
  }), tempOpen ? cloneElement4(child, {
    className: childCls
  }) : child);
  return wrapCSSVar(/* @__PURE__ */ React190.createElement(zindexContext_default.Provider, {
    value: contextZIndex
  }, content));
});
var Tooltip3 = InternalTooltip;
if (true) {
  Tooltip3.displayName = "Tooltip";
}
Tooltip3._InternalPanelDoNotUseOrYouWillBeFired = PurePanel_default3;
var tooltip_default = Tooltip3;

// ../../node_modules/antd/es/popover/PurePanel.js
var React191 = __toESM(require_react());
var import_classnames61 = __toESM(require_classnames());

// ../../node_modules/antd/es/popover/style/index.js
var genBaseStyle4 = (token2) => {
  const {
    componentCls,
    popoverColor,
    titleMinWidth,
    fontWeightStrong,
    innerPadding,
    boxShadowSecondary,
    colorTextHeading,
    borderRadiusLG,
    zIndexPopup,
    titleMarginBottom,
    colorBgElevated,
    popoverBg,
    titleBorderBottom,
    innerContentPadding,
    titlePadding
  } = token2;
  return [
    {
      [componentCls]: Object.assign(Object.assign({}, resetComponent(token2)), {
        position: "absolute",
        top: 0,
        // use `left` to fix https://github.com/ant-design/ant-design/issues/39195
        left: {
          _skip_check_: true,
          value: 0
        },
        zIndex: zIndexPopup,
        fontWeight: "normal",
        whiteSpace: "normal",
        textAlign: "start",
        cursor: "auto",
        userSelect: "text",
        // When use `autoArrow`, origin will follow the arrow position
        "--valid-offset-x": "var(--arrow-offset-horizontal, var(--arrow-x))",
        transformOrigin: [`var(--valid-offset-x, 50%)`, `var(--arrow-y, 50%)`].join(" "),
        "--antd-arrow-background-color": colorBgElevated,
        width: "max-content",
        maxWidth: "100vw",
        "&-rtl": {
          direction: "rtl"
        },
        "&-hidden": {
          display: "none"
        },
        [`${componentCls}-content`]: {
          position: "relative"
        },
        [`${componentCls}-inner`]: {
          backgroundColor: popoverBg,
          backgroundClip: "padding-box",
          borderRadius: borderRadiusLG,
          boxShadow: boxShadowSecondary,
          padding: innerPadding
        },
        [`${componentCls}-title`]: {
          minWidth: titleMinWidth,
          marginBottom: titleMarginBottom,
          color: colorTextHeading,
          fontWeight: fontWeightStrong,
          borderBottom: titleBorderBottom,
          padding: titlePadding
        },
        [`${componentCls}-inner-content`]: {
          color: popoverColor,
          padding: innerContentPadding
        }
      })
    },
    // Arrow Style
    getArrowStyle(token2, "var(--antd-arrow-background-color)"),
    // Pure Render
    {
      [`${componentCls}-pure`]: {
        position: "relative",
        maxWidth: "none",
        margin: token2.sizePopupArrow,
        display: "inline-block",
        [`${componentCls}-content`]: {
          display: "inline-block"
        }
      }
    }
  ];
};
var genColorStyle = (token2) => {
  const {
    componentCls
  } = token2;
  return {
    [componentCls]: PresetColors.map((colorKey) => {
      const lightColor = token2[`${colorKey}6`];
      return {
        [`&${componentCls}-${colorKey}`]: {
          "--antd-arrow-background-color": lightColor,
          [`${componentCls}-inner`]: {
            backgroundColor: lightColor
          },
          [`${componentCls}-arrow`]: {
            background: "transparent"
          }
        }
      };
    })
  };
};
var prepareComponentToken8 = (token2) => {
  const {
    lineWidth,
    controlHeight,
    fontHeight,
    padding,
    wireframe,
    zIndexPopupBase,
    borderRadiusLG,
    marginXS,
    lineType,
    colorSplit,
    paddingSM
  } = token2;
  const titlePaddingBlockDist = controlHeight - fontHeight;
  const popoverTitlePaddingBlockTop = titlePaddingBlockDist / 2;
  const popoverTitlePaddingBlockBottom = titlePaddingBlockDist / 2 - lineWidth;
  const popoverPaddingHorizontal = padding;
  return Object.assign(Object.assign(Object.assign({
    titleMinWidth: 177,
    zIndexPopup: zIndexPopupBase + 30
  }, getArrowToken(token2)), getArrowOffsetToken({
    contentRadius: borderRadiusLG,
    limitVerticalRadius: true
  })), {
    // internal
    innerPadding: wireframe ? 0 : 12,
    titleMarginBottom: wireframe ? 0 : marginXS,
    titlePadding: wireframe ? `${popoverTitlePaddingBlockTop}px ${popoverPaddingHorizontal}px ${popoverTitlePaddingBlockBottom}px` : 0,
    titleBorderBottom: wireframe ? `${lineWidth}px ${lineType} ${colorSplit}` : "none",
    innerContentPadding: wireframe ? `${paddingSM}px ${popoverPaddingHorizontal}px` : 0
  });
};
var style_default11 = genStyleHooks("Popover", (token2) => {
  const {
    colorBgElevated,
    colorText
  } = token2;
  const popoverToken = merge2(token2, {
    popoverBg: colorBgElevated,
    popoverColor: colorText
  });
  return [genBaseStyle4(popoverToken), genColorStyle(popoverToken), initZoomMotion(popoverToken, "zoom-big")];
}, prepareComponentToken8, {
  resetStyle: false,
  deprecatedTokens: [["width", "titleMinWidth"], ["minWidth", "titleMinWidth"]]
});

// ../../node_modules/antd/es/popover/PurePanel.js
var __rest13 = function(s, e3) {
  var t2 = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e3.indexOf(p) < 0) t2[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e3.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t2[p[i]] = s[p[i]];
  }
  return t2;
};
var Overlay = ({
  title,
  content,
  prefixCls
}) => {
  if (!title && !content) {
    return null;
  }
  return /* @__PURE__ */ React191.createElement(React191.Fragment, null, title && /* @__PURE__ */ React191.createElement("div", {
    className: `${prefixCls}-title`
  }, title), content && /* @__PURE__ */ React191.createElement("div", {
    className: `${prefixCls}-inner-content`
  }, content));
};
var RawPurePanel = (props) => {
  const {
    hashId,
    prefixCls,
    className: className2,
    style: style2,
    placement = "top",
    title,
    content,
    children
  } = props;
  const titleNode = getRenderPropValue(title);
  const contentNode = getRenderPropValue(content);
  const cls11 = (0, import_classnames61.default)(hashId, prefixCls, `${prefixCls}-pure`, `${prefixCls}-placement-${placement}`, className2);
  return /* @__PURE__ */ React191.createElement("div", {
    className: cls11,
    style: style2
  }, /* @__PURE__ */ React191.createElement("div", {
    className: `${prefixCls}-arrow`
  }), /* @__PURE__ */ React191.createElement(Popup2, Object.assign({}, props, {
    className: hashId,
    prefixCls
  }), children || /* @__PURE__ */ React191.createElement(Overlay, {
    prefixCls,
    title: titleNode,
    content: contentNode
  })));
};
var PurePanel4 = (props) => {
  const {
    prefixCls: customizePrefixCls,
    className: className2
  } = props, restProps = __rest13(props, ["prefixCls", "className"]);
  const {
    getPrefixCls
  } = React191.useContext(ConfigContext);
  const prefixCls = getPrefixCls("popover", customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = style_default11(prefixCls);
  return wrapCSSVar(/* @__PURE__ */ React191.createElement(RawPurePanel, Object.assign({}, restProps, {
    prefixCls,
    hashId,
    className: (0, import_classnames61.default)(className2, cssVarCls)
  })));
};
var PurePanel_default4 = PurePanel4;

// ../../node_modules/antd/es/popover/index.js
var __rest14 = function(s, e3) {
  var t2 = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e3.indexOf(p) < 0) t2[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e3.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t2[p[i]] = s[p[i]];
  }
  return t2;
};
var InternalPopover = /* @__PURE__ */ React192.forwardRef((props, ref3) => {
  var _a, _b;
  const {
    prefixCls: customizePrefixCls,
    title,
    content,
    overlayClassName,
    placement = "top",
    trigger: trigger2 = "hover",
    children,
    mouseEnterDelay = 0.1,
    mouseLeaveDelay = 0.1,
    onOpenChange,
    overlayStyle = {},
    styles,
    classNames: popoverClassNames
  } = props, otherProps = __rest14(props, ["prefixCls", "title", "content", "overlayClassName", "placement", "trigger", "children", "mouseEnterDelay", "mouseLeaveDelay", "onOpenChange", "overlayStyle", "styles", "classNames"]);
  const {
    getPrefixCls,
    className: contextClassName,
    style: contextStyle,
    classNames: contextClassNames,
    styles: contextStyles
  } = useComponentConfig("popover");
  const prefixCls = getPrefixCls("popover", customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = style_default11(prefixCls);
  const rootPrefixCls = getPrefixCls();
  const rootClassNames = (0, import_classnames62.default)(overlayClassName, hashId, cssVarCls, contextClassName, contextClassNames.root, popoverClassNames === null || popoverClassNames === void 0 ? void 0 : popoverClassNames.root);
  const bodyClassNames = (0, import_classnames62.default)(contextClassNames.body, popoverClassNames === null || popoverClassNames === void 0 ? void 0 : popoverClassNames.body);
  const [open2, setOpen] = useMergedState(false, {
    value: (_a = props.open) !== null && _a !== void 0 ? _a : props.visible,
    defaultValue: (_b = props.defaultOpen) !== null && _b !== void 0 ? _b : props.defaultVisible
  });
  const settingOpen = (value, e3) => {
    setOpen(value, true);
    onOpenChange === null || onOpenChange === void 0 ? void 0 : onOpenChange(value, e3);
  };
  const onKeyDown2 = (e3) => {
    if (e3.keyCode === KeyCode_default.ESC) {
      settingOpen(false, e3);
    }
  };
  const onInternalOpenChange = (value) => {
    settingOpen(value);
  };
  const titleNode = getRenderPropValue(title);
  const contentNode = getRenderPropValue(content);
  return wrapCSSVar(/* @__PURE__ */ React192.createElement(tooltip_default, Object.assign({
    placement,
    trigger: trigger2,
    mouseEnterDelay,
    mouseLeaveDelay
  }, otherProps, {
    prefixCls,
    classNames: {
      root: rootClassNames,
      body: bodyClassNames
    },
    styles: {
      root: Object.assign(Object.assign(Object.assign(Object.assign({}, contextStyles.root), contextStyle), overlayStyle), styles === null || styles === void 0 ? void 0 : styles.root),
      body: Object.assign(Object.assign({}, contextStyles.body), styles === null || styles === void 0 ? void 0 : styles.body)
    },
    ref: ref3,
    open: open2,
    onOpenChange: onInternalOpenChange,
    overlay: titleNode || contentNode ? /* @__PURE__ */ React192.createElement(Overlay, {
      prefixCls,
      title: titleNode,
      content: contentNode
    }) : null,
    transitionName: getTransitionName2(rootPrefixCls, "zoom-big", otherProps.transitionName),
    "data-popover-inject": true
  }), cloneElement4(children, {
    onKeyDown: (e3) => {
      var _a2, _b2;
      if (/* @__PURE__ */ (0, import_react75.isValidElement)(children)) {
        (_b2 = children === null || children === void 0 ? void 0 : (_a2 = children.props).onKeyDown) === null || _b2 === void 0 ? void 0 : _b2.call(_a2, e3);
      }
      onKeyDown2(e3);
    }
  })));
});
var Popover = InternalPopover;
Popover._InternalPanelDoNotUseOrYouWillBeFired = PurePanel_default4;
if (true) {
  Popover.displayName = "Popover";
}
var popover_default = Popover;

// ../../node_modules/antd/es/dropdown/dropdown.js
var React228 = __toESM(require_react());

// ../../node_modules/@ant-design/icons/es/icons/LeftOutlined.js
var React193 = __toESM(require_react());

// ../../node_modules/@ant-design/icons-svg/es/asn/LeftOutlined.js
var LeftOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 000 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z" } }] }, "name": "left", "theme": "outlined" };
var LeftOutlined_default = LeftOutlined;

// ../../node_modules/@ant-design/icons/es/icons/LeftOutlined.js
var LeftOutlined2 = function LeftOutlined3(props, ref3) {
  return /* @__PURE__ */ React193.createElement(AntdIcon_default, _extends({}, props, {
    ref: ref3,
    icon: LeftOutlined_default
  }));
};
var RefIcon11 = /* @__PURE__ */ React193.forwardRef(LeftOutlined2);
if (true) {
  RefIcon11.displayName = "LeftOutlined";
}
var LeftOutlined_default2 = RefIcon11;

// ../../node_modules/antd/es/dropdown/dropdown.js
var import_classnames76 = __toESM(require_classnames());

// ../../node_modules/rc-dropdown/es/Dropdown.js
var import_classnames63 = __toESM(require_classnames());
var import_react77 = __toESM(require_react());

// ../../node_modules/rc-dropdown/es/hooks/useAccessibility.js
var React194 = __toESM(require_react());
var ESC = KeyCode_default.ESC;
var TAB = KeyCode_default.TAB;
function useAccessibility(_ref) {
  var visible = _ref.visible, triggerRef = _ref.triggerRef, onVisibleChange = _ref.onVisibleChange, autoFocus = _ref.autoFocus, overlayRef = _ref.overlayRef;
  var focusMenuRef = React194.useRef(false);
  var handleCloseMenuAndReturnFocus = function handleCloseMenuAndReturnFocus2() {
    if (visible) {
      var _triggerRef$current, _triggerRef$current$f;
      (_triggerRef$current = triggerRef.current) === null || _triggerRef$current === void 0 || (_triggerRef$current$f = _triggerRef$current.focus) === null || _triggerRef$current$f === void 0 || _triggerRef$current$f.call(_triggerRef$current);
      onVisibleChange === null || onVisibleChange === void 0 || onVisibleChange(false);
    }
  };
  var focusMenu = function focusMenu2() {
    var _overlayRef$current;
    if ((_overlayRef$current = overlayRef.current) !== null && _overlayRef$current !== void 0 && _overlayRef$current.focus) {
      overlayRef.current.focus();
      focusMenuRef.current = true;
      return true;
    }
    return false;
  };
  var handleKeyDown = function handleKeyDown2(event) {
    switch (event.keyCode) {
      case ESC:
        handleCloseMenuAndReturnFocus();
        break;
      case TAB: {
        var focusResult = false;
        if (!focusMenuRef.current) {
          focusResult = focusMenu();
        }
        if (focusResult) {
          event.preventDefault();
        } else {
          handleCloseMenuAndReturnFocus();
        }
        break;
      }
    }
  };
  React194.useEffect(function() {
    if (visible) {
      window.addEventListener("keydown", handleKeyDown);
      if (autoFocus) {
        raf_default(focusMenu, 3);
      }
      return function() {
        window.removeEventListener("keydown", handleKeyDown);
        focusMenuRef.current = false;
      };
    }
    return function() {
      focusMenuRef.current = false;
    };
  }, [visible]);
}

// ../../node_modules/rc-dropdown/es/Overlay.js
var import_react76 = __toESM(require_react());
var Overlay2 = /* @__PURE__ */ (0, import_react76.forwardRef)(function(props, ref3) {
  var overlay = props.overlay, arrow = props.arrow, prefixCls = props.prefixCls;
  var overlayNode = (0, import_react76.useMemo)(function() {
    var overlayElement;
    if (typeof overlay === "function") {
      overlayElement = overlay();
    } else {
      overlayElement = overlay;
    }
    return overlayElement;
  }, [overlay]);
  var composedRef = composeRef(ref3, getNodeRef(overlayNode));
  return /* @__PURE__ */ import_react76.default.createElement(import_react76.default.Fragment, null, arrow && /* @__PURE__ */ import_react76.default.createElement("div", {
    className: "".concat(prefixCls, "-arrow")
  }), /* @__PURE__ */ import_react76.default.cloneElement(overlayNode, {
    ref: supportRef(overlayNode) ? composedRef : void 0
  }));
});
var Overlay_default = Overlay2;

// ../../node_modules/rc-dropdown/es/placements.js
var autoAdjustOverflow = {
  adjustX: 1,
  adjustY: 1
};
var targetOffset2 = [0, 0];
var placements2 = {
  topLeft: {
    points: ["bl", "tl"],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset2
  },
  top: {
    points: ["bc", "tc"],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset2
  },
  topRight: {
    points: ["br", "tr"],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset2
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset2
  },
  bottom: {
    points: ["tc", "bc"],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset2
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset2
  }
};
var placements_default = placements2;

// ../../node_modules/rc-dropdown/es/Dropdown.js
var _excluded29 = ["arrow", "prefixCls", "transitionName", "animation", "align", "placement", "placements", "getPopupContainer", "showAction", "hideAction", "overlayClassName", "overlayStyle", "visible", "trigger", "autoFocus", "overlay", "children", "onVisibleChange"];
function Dropdown(props, ref3) {
  var _children$props;
  var _props$arrow = props.arrow, arrow = _props$arrow === void 0 ? false : _props$arrow, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-dropdown" : _props$prefixCls, transitionName = props.transitionName, animation = props.animation, align = props.align, _props$placement = props.placement, placement = _props$placement === void 0 ? "bottomLeft" : _props$placement, _props$placements = props.placements, placements4 = _props$placements === void 0 ? placements_default : _props$placements, getPopupContainer = props.getPopupContainer, showAction = props.showAction, hideAction = props.hideAction, overlayClassName = props.overlayClassName, overlayStyle = props.overlayStyle, visible = props.visible, _props$trigger = props.trigger, trigger2 = _props$trigger === void 0 ? ["hover"] : _props$trigger, autoFocus = props.autoFocus, overlay = props.overlay, children = props.children, onVisibleChange = props.onVisibleChange, otherProps = _objectWithoutProperties(props, _excluded29);
  var _React$useState = import_react77.default.useState(), _React$useState2 = _slicedToArray(_React$useState, 2), triggerVisible = _React$useState2[0], setTriggerVisible = _React$useState2[1];
  var mergedVisible = "visible" in props ? visible : triggerVisible;
  var triggerRef = import_react77.default.useRef(null);
  var overlayRef = import_react77.default.useRef(null);
  var childRef = import_react77.default.useRef(null);
  import_react77.default.useImperativeHandle(ref3, function() {
    return triggerRef.current;
  });
  var handleVisibleChange = function handleVisibleChange2(newVisible) {
    setTriggerVisible(newVisible);
    onVisibleChange === null || onVisibleChange === void 0 || onVisibleChange(newVisible);
  };
  useAccessibility({
    visible: mergedVisible,
    triggerRef: childRef,
    onVisibleChange: handleVisibleChange,
    autoFocus,
    overlayRef
  });
  var onClick = function onClick2(e3) {
    var onOverlayClick = props.onOverlayClick;
    setTriggerVisible(false);
    if (onOverlayClick) {
      onOverlayClick(e3);
    }
  };
  var getMenuElement = function getMenuElement2() {
    return /* @__PURE__ */ import_react77.default.createElement(Overlay_default, {
      ref: overlayRef,
      overlay,
      prefixCls,
      arrow
    });
  };
  var getMenuElementOrLambda = function getMenuElementOrLambda2() {
    if (typeof overlay === "function") {
      return getMenuElement;
    }
    return getMenuElement();
  };
  var getMinOverlayWidthMatchTrigger = function getMinOverlayWidthMatchTrigger2() {
    var minOverlayWidthMatchTrigger = props.minOverlayWidthMatchTrigger, alignPoint = props.alignPoint;
    if ("minOverlayWidthMatchTrigger" in props) {
      return minOverlayWidthMatchTrigger;
    }
    return !alignPoint;
  };
  var getOpenClassName = function getOpenClassName2() {
    var openClassName = props.openClassName;
    if (openClassName !== void 0) {
      return openClassName;
    }
    return "".concat(prefixCls, "-open");
  };
  var childrenNode = /* @__PURE__ */ import_react77.default.cloneElement(children, {
    className: (0, import_classnames63.default)((_children$props = children.props) === null || _children$props === void 0 ? void 0 : _children$props.className, mergedVisible && getOpenClassName()),
    ref: supportRef(children) ? composeRef(childRef, getNodeRef(children)) : void 0
  });
  var triggerHideAction = hideAction;
  if (!triggerHideAction && trigger2.indexOf("contextMenu") !== -1) {
    triggerHideAction = ["click"];
  }
  return /* @__PURE__ */ import_react77.default.createElement(es_default9, _extends({
    builtinPlacements: placements4
  }, otherProps, {
    prefixCls,
    ref: triggerRef,
    popupClassName: (0, import_classnames63.default)(overlayClassName, _defineProperty({}, "".concat(prefixCls, "-show-arrow"), arrow)),
    popupStyle: overlayStyle,
    action: trigger2,
    showAction,
    hideAction: triggerHideAction,
    popupPlacement: placement,
    popupAlign: align,
    popupTransitionName: transitionName,
    popupAnimation: animation,
    popupVisible: mergedVisible,
    stretch: getMinOverlayWidthMatchTrigger() ? "minWidth" : "",
    popup: getMenuElementOrLambda(),
    onPopupVisibleChange: handleVisibleChange,
    onPopupClick: onClick,
    getPopupContainer
  }), childrenNode);
}
var Dropdown_default = /* @__PURE__ */ import_react77.default.forwardRef(Dropdown);

// ../../node_modules/rc-dropdown/es/index.js
var es_default13 = Dropdown_default;

// ../../node_modules/antd/es/_util/isPrimitive.js
var isPrimitive = (value) => typeof value !== "object" && typeof value !== "function" || value === null;
var isPrimitive_default = isPrimitive;

// ../../node_modules/antd/es/menu/index.js
var React227 = __toESM(require_react());
var import_react83 = __toESM(require_react());

// ../../node_modules/rc-menu/es/Menu.js
var import_classnames70 = __toESM(require_classnames());
var React217 = __toESM(require_react());
var import_react79 = __toESM(require_react());
var import_react_dom8 = __toESM(require_react_dom());

// ../../node_modules/rc-menu/es/context/IdContext.js
var React197 = __toESM(require_react());
var IdContext = /* @__PURE__ */ React197.createContext(null);
function getMenuId(uuid8, eventKey) {
  if (uuid8 === void 0) {
    return null;
  }
  return "".concat(uuid8, "-").concat(eventKey);
}
function useMenuId(eventKey) {
  var id = React197.useContext(IdContext);
  return getMenuId(id, eventKey);
}

// ../../node_modules/rc-menu/es/context/MenuContext.js
var React198 = __toESM(require_react());
var _excluded30 = ["children", "locked"];
var MenuContext = /* @__PURE__ */ React198.createContext(null);
function mergeProps2(origin, target) {
  var clone = _objectSpread2({}, origin);
  Object.keys(target).forEach(function(key2) {
    var value = target[key2];
    if (value !== void 0) {
      clone[key2] = value;
    }
  });
  return clone;
}
function InheritableContextProvider(_ref) {
  var children = _ref.children, locked = _ref.locked, restProps = _objectWithoutProperties(_ref, _excluded30);
  var context = React198.useContext(MenuContext);
  var inheritableContext = useMemo3(function() {
    return mergeProps2(context, restProps);
  }, [context, restProps], function(prev2, next2) {
    return !locked && (prev2[0] !== next2[0] || !isEqual_default(prev2[1], next2[1], true));
  });
  return /* @__PURE__ */ React198.createElement(MenuContext.Provider, {
    value: inheritableContext
  }, children);
}

// ../../node_modules/rc-menu/es/context/PathContext.js
var React199 = __toESM(require_react());
var EmptyList = [];
var PathRegisterContext = /* @__PURE__ */ React199.createContext(null);
function useMeasure() {
  return React199.useContext(PathRegisterContext);
}
var PathTrackerContext = /* @__PURE__ */ React199.createContext(EmptyList);
function useFullPath(eventKey) {
  var parentKeyPath = React199.useContext(PathTrackerContext);
  return React199.useMemo(function() {
    return eventKey !== void 0 ? [].concat(_toConsumableArray(parentKeyPath), [eventKey]) : parentKeyPath;
  }, [parentKeyPath, eventKey]);
}
var PathUserContext = /* @__PURE__ */ React199.createContext(null);

// ../../node_modules/rc-menu/es/context/PrivateContext.js
var React200 = __toESM(require_react());
var PrivateContext = /* @__PURE__ */ React200.createContext({});
var PrivateContext_default = PrivateContext;

// ../../node_modules/rc-util/es/Dom/focus.js
function focusable(node2) {
  var includePositive = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
  if (isVisible_default(node2)) {
    var nodeName = node2.nodeName.toLowerCase();
    var isFocusableElement = (
      // Focusable element
      ["input", "select", "textarea", "button"].includes(nodeName) || // Editable element
      node2.isContentEditable || // Anchor with href element
      nodeName === "a" && !!node2.getAttribute("href")
    );
    var tabIndexAttr = node2.getAttribute("tabindex");
    var tabIndexNum = Number(tabIndexAttr);
    var tabIndex = null;
    if (tabIndexAttr && !Number.isNaN(tabIndexNum)) {
      tabIndex = tabIndexNum;
    } else if (isFocusableElement && tabIndex === null) {
      tabIndex = 0;
    }
    if (isFocusableElement && node2.disabled) {
      tabIndex = null;
    }
    return tabIndex !== null && (tabIndex >= 0 || includePositive && tabIndex < 0);
  }
  return false;
}
function getFocusNodeList(node2) {
  var includePositive = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
  var res = _toConsumableArray(node2.querySelectorAll("*")).filter(function(child) {
    return focusable(child, includePositive);
  });
  if (focusable(node2, includePositive)) {
    res.unshift(node2);
  }
  return res;
}

// ../../node_modules/rc-menu/es/hooks/useAccessibility.js
var React201 = __toESM(require_react());
var LEFT = KeyCode_default.LEFT;
var RIGHT = KeyCode_default.RIGHT;
var UP = KeyCode_default.UP;
var DOWN = KeyCode_default.DOWN;
var ENTER = KeyCode_default.ENTER;
var ESC2 = KeyCode_default.ESC;
var HOME = KeyCode_default.HOME;
var END = KeyCode_default.END;
var ArrowKeys = [UP, DOWN, LEFT, RIGHT];
function getOffset(mode, isRootLevel, isRtl, which) {
  var _offsets;
  var prev2 = "prev";
  var next2 = "next";
  var children = "children";
  var parent2 = "parent";
  if (mode === "inline" && which === ENTER) {
    return {
      inlineTrigger: true
    };
  }
  var inline2 = _defineProperty(_defineProperty({}, UP, prev2), DOWN, next2);
  var horizontal = _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, LEFT, isRtl ? next2 : prev2), RIGHT, isRtl ? prev2 : next2), DOWN, children), ENTER, children);
  var vertical = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, UP, prev2), DOWN, next2), ENTER, children), ESC2, parent2), LEFT, isRtl ? children : parent2), RIGHT, isRtl ? parent2 : children);
  var offsets = {
    inline: inline2,
    horizontal,
    vertical,
    inlineSub: inline2,
    horizontalSub: vertical,
    verticalSub: vertical
  };
  var type5 = (_offsets = offsets["".concat(mode).concat(isRootLevel ? "" : "Sub")]) === null || _offsets === void 0 ? void 0 : _offsets[which];
  switch (type5) {
    case prev2:
      return {
        offset: -1,
        sibling: true
      };
    case next2:
      return {
        offset: 1,
        sibling: true
      };
    case parent2:
      return {
        offset: -1,
        sibling: false
      };
    case children:
      return {
        offset: 1,
        sibling: false
      };
    default:
      return null;
  }
}
function findContainerUL(element) {
  var current2 = element;
  while (current2) {
    if (current2.getAttribute("data-menu-list")) {
      return current2;
    }
    current2 = current2.parentElement;
  }
  return null;
}
function getFocusElement(activeElement, elements) {
  var current2 = activeElement || document.activeElement;
  while (current2) {
    if (elements.has(current2)) {
      return current2;
    }
    current2 = current2.parentElement;
  }
  return null;
}
function getFocusableElements(container, elements) {
  var list = getFocusNodeList(container, true);
  return list.filter(function(ele) {
    return elements.has(ele);
  });
}
function getNextFocusElement(parentQueryContainer, elements, focusMenuElement) {
  var offset4 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1;
  if (!parentQueryContainer) {
    return null;
  }
  var sameLevelFocusableMenuElementList = getFocusableElements(parentQueryContainer, elements);
  var count = sameLevelFocusableMenuElementList.length;
  var focusIndex = sameLevelFocusableMenuElementList.findIndex(function(ele) {
    return focusMenuElement === ele;
  });
  if (offset4 < 0) {
    if (focusIndex === -1) {
      focusIndex = count - 1;
    } else {
      focusIndex -= 1;
    }
  } else if (offset4 > 0) {
    focusIndex += 1;
  }
  focusIndex = (focusIndex + count) % count;
  return sameLevelFocusableMenuElementList[focusIndex];
}
var refreshElements = function refreshElements2(keys4, id) {
  var elements = /* @__PURE__ */ new Set();
  var key2element = /* @__PURE__ */ new Map();
  var element2key = /* @__PURE__ */ new Map();
  keys4.forEach(function(key2) {
    var element = document.querySelector("[data-menu-id='".concat(getMenuId(id, key2), "']"));
    if (element) {
      elements.add(element);
      element2key.set(element, key2);
      key2element.set(key2, element);
    }
  });
  return {
    elements,
    key2element,
    element2key
  };
};
function useAccessibility2(mode, activeKey, isRtl, id, containerRef, getKeys3, getKeyPath, triggerActiveKey, triggerAccessibilityOpen, originOnKeyDown) {
  var rafRef = React201.useRef();
  var activeRef = React201.useRef();
  activeRef.current = activeKey;
  var cleanRaf = function cleanRaf2() {
    raf_default.cancel(rafRef.current);
  };
  React201.useEffect(function() {
    return function() {
      cleanRaf();
    };
  }, []);
  return function(e3) {
    var which = e3.which;
    if ([].concat(ArrowKeys, [ENTER, ESC2, HOME, END]).includes(which)) {
      var keys4 = getKeys3();
      var refreshedElements = refreshElements(keys4, id);
      var _refreshedElements = refreshedElements, elements = _refreshedElements.elements, key2element = _refreshedElements.key2element, element2key = _refreshedElements.element2key;
      var activeElement = key2element.get(activeKey);
      var focusMenuElement = getFocusElement(activeElement, elements);
      var focusMenuKey = element2key.get(focusMenuElement);
      var offsetObj = getOffset(mode, getKeyPath(focusMenuKey, true).length === 1, isRtl, which);
      if (!offsetObj && which !== HOME && which !== END) {
        return;
      }
      if (ArrowKeys.includes(which) || [HOME, END].includes(which)) {
        e3.preventDefault();
      }
      var tryFocus = function tryFocus2(menuElement) {
        if (menuElement) {
          var focusTargetElement = menuElement;
          var link = menuElement.querySelector("a");
          if (link !== null && link !== void 0 && link.getAttribute("href")) {
            focusTargetElement = link;
          }
          var targetKey = element2key.get(menuElement);
          triggerActiveKey(targetKey);
          cleanRaf();
          rafRef.current = raf_default(function() {
            if (activeRef.current === targetKey) {
              focusTargetElement.focus();
            }
          });
        }
      };
      if ([HOME, END].includes(which) || offsetObj.sibling || !focusMenuElement) {
        var parentQueryContainer;
        if (!focusMenuElement || mode === "inline") {
          parentQueryContainer = containerRef.current;
        } else {
          parentQueryContainer = findContainerUL(focusMenuElement);
        }
        var targetElement;
        var focusableElements = getFocusableElements(parentQueryContainer, elements);
        if (which === HOME) {
          targetElement = focusableElements[0];
        } else if (which === END) {
          targetElement = focusableElements[focusableElements.length - 1];
        } else {
          targetElement = getNextFocusElement(parentQueryContainer, elements, focusMenuElement, offsetObj.offset);
        }
        tryFocus(targetElement);
      } else if (offsetObj.inlineTrigger) {
        triggerAccessibilityOpen(focusMenuKey);
      } else if (offsetObj.offset > 0) {
        triggerAccessibilityOpen(focusMenuKey, true);
        cleanRaf();
        rafRef.current = raf_default(function() {
          refreshedElements = refreshElements(keys4, id);
          var controlId = focusMenuElement.getAttribute("aria-controls");
          var subQueryContainer = document.getElementById(controlId);
          var targetElement2 = getNextFocusElement(subQueryContainer, refreshedElements.elements);
          tryFocus(targetElement2);
        }, 5);
      } else if (offsetObj.offset < 0) {
        var keyPath = getKeyPath(focusMenuKey, true);
        var parentKey = keyPath[keyPath.length - 2];
        var parentMenuElement = key2element.get(parentKey);
        triggerAccessibilityOpen(parentKey, false);
        tryFocus(parentMenuElement);
      }
    }
    originOnKeyDown === null || originOnKeyDown === void 0 || originOnKeyDown(e3);
  };
}

// ../../node_modules/rc-menu/es/hooks/useKeyRecords.js
var React202 = __toESM(require_react());
var import_react78 = __toESM(require_react());

// ../../node_modules/rc-menu/es/utils/timeUtil.js
function nextSlice(callback) {
  Promise.resolve().then(callback);
}

// ../../node_modules/rc-menu/es/hooks/useKeyRecords.js
var PATH_SPLIT = "__RC_UTIL_PATH_SPLIT__";
var getPathStr = function getPathStr2(keyPath) {
  return keyPath.join(PATH_SPLIT);
};
var getPathKeys = function getPathKeys2(keyPathStr) {
  return keyPathStr.split(PATH_SPLIT);
};
var OVERFLOW_KEY = "rc-menu-more";
function useKeyRecords() {
  var _React$useState = React202.useState({}), _React$useState2 = _slicedToArray(_React$useState, 2), internalForceUpdate = _React$useState2[1];
  var key2pathRef = (0, import_react78.useRef)(/* @__PURE__ */ new Map());
  var path2keyRef = (0, import_react78.useRef)(/* @__PURE__ */ new Map());
  var _React$useState3 = React202.useState([]), _React$useState4 = _slicedToArray(_React$useState3, 2), overflowKeys = _React$useState4[0], setOverflowKeys = _React$useState4[1];
  var updateRef = (0, import_react78.useRef)(0);
  var destroyRef = (0, import_react78.useRef)(false);
  var forceUpdate = function forceUpdate2() {
    if (!destroyRef.current) {
      internalForceUpdate({});
    }
  };
  var registerPath = (0, import_react78.useCallback)(function(key2, keyPath) {
    if (true) {
      warning_default(!key2pathRef.current.has(key2), "Duplicated key '".concat(key2, "' used in Menu by path [").concat(keyPath.join(" > "), "]"));
    }
    var connectedPath = getPathStr(keyPath);
    path2keyRef.current.set(connectedPath, key2);
    key2pathRef.current.set(key2, connectedPath);
    updateRef.current += 1;
    var id = updateRef.current;
    nextSlice(function() {
      if (id === updateRef.current) {
        forceUpdate();
      }
    });
  }, []);
  var unregisterPath = (0, import_react78.useCallback)(function(key2, keyPath) {
    var connectedPath = getPathStr(keyPath);
    path2keyRef.current.delete(connectedPath);
    key2pathRef.current.delete(key2);
  }, []);
  var refreshOverflowKeys = (0, import_react78.useCallback)(function(keys4) {
    setOverflowKeys(keys4);
  }, []);
  var getKeyPath = (0, import_react78.useCallback)(function(eventKey, includeOverflow) {
    var fullPath = key2pathRef.current.get(eventKey) || "";
    var keys4 = getPathKeys(fullPath);
    if (includeOverflow && overflowKeys.includes(keys4[0])) {
      keys4.unshift(OVERFLOW_KEY);
    }
    return keys4;
  }, [overflowKeys]);
  var isSubPathKey = (0, import_react78.useCallback)(function(pathKeys, eventKey) {
    return pathKeys.filter(function(item) {
      return item !== void 0;
    }).some(function(pathKey2) {
      var pathKeyList = getKeyPath(pathKey2, true);
      return pathKeyList.includes(eventKey);
    });
  }, [getKeyPath]);
  var getKeys3 = function getKeys4() {
    var keys4 = _toConsumableArray(key2pathRef.current.keys());
    if (overflowKeys.length) {
      keys4.push(OVERFLOW_KEY);
    }
    return keys4;
  };
  var getSubPathKeys = (0, import_react78.useCallback)(function(key2) {
    var connectedPath = "".concat(key2pathRef.current.get(key2)).concat(PATH_SPLIT);
    var pathKeys = /* @__PURE__ */ new Set();
    _toConsumableArray(path2keyRef.current.keys()).forEach(function(pathKey2) {
      if (pathKey2.startsWith(connectedPath)) {
        pathKeys.add(path2keyRef.current.get(pathKey2));
      }
    });
    return pathKeys;
  }, []);
  React202.useEffect(function() {
    return function() {
      destroyRef.current = true;
    };
  }, []);
  return {
    // Register
    registerPath,
    unregisterPath,
    refreshOverflowKeys,
    // Util
    isSubPathKey,
    getKeyPath,
    getKeys: getKeys3,
    getSubPathKeys
  };
}

// ../../node_modules/rc-menu/es/hooks/useMemoCallback.js
var React203 = __toESM(require_react());
function useMemoCallback(func) {
  var funRef = React203.useRef(func);
  funRef.current = func;
  var callback = React203.useCallback(function() {
    var _funRef$current;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return (_funRef$current = funRef.current) === null || _funRef$current === void 0 ? void 0 : _funRef$current.call.apply(_funRef$current, [funRef].concat(args));
  }, []);
  return func ? callback : void 0;
}

// ../../node_modules/rc-menu/es/hooks/useUUID.js
var React204 = __toESM(require_react());
var uniquePrefix = Math.random().toFixed(5).toString().slice(2);
var internalId = 0;
function useUUID(id) {
  var _useMergedState = useMergedState(id, {
    value: id
  }), _useMergedState2 = _slicedToArray(_useMergedState, 2), uuid8 = _useMergedState2[0], setUUID = _useMergedState2[1];
  React204.useEffect(function() {
    internalId += 1;
    var newId = false ? "test" : "".concat(uniquePrefix, "-").concat(internalId);
    setUUID("rc-menu-uuid-".concat(newId));
  }, []);
  return uuid8;
}

// ../../node_modules/rc-menu/es/MenuItem.js
var import_classnames64 = __toESM(require_classnames());
var React208 = __toESM(require_react());

// ../../node_modules/rc-menu/es/hooks/useActive.js
var React205 = __toESM(require_react());
function useActive(eventKey, disabled, onMouseEnter, onMouseLeave) {
  var _React$useContext = React205.useContext(MenuContext), activeKey = _React$useContext.activeKey, onActive = _React$useContext.onActive, onInactive = _React$useContext.onInactive;
  var ret = {
    active: activeKey === eventKey
  };
  if (!disabled) {
    ret.onMouseEnter = function(domEvent) {
      onMouseEnter === null || onMouseEnter === void 0 || onMouseEnter({
        key: eventKey,
        domEvent
      });
      onActive(eventKey);
    };
    ret.onMouseLeave = function(domEvent) {
      onMouseLeave === null || onMouseLeave === void 0 || onMouseLeave({
        key: eventKey,
        domEvent
      });
      onInactive(eventKey);
    };
  }
  return ret;
}

// ../../node_modules/rc-menu/es/hooks/useDirectionStyle.js
var React206 = __toESM(require_react());
function useDirectionStyle(level) {
  var _React$useContext = React206.useContext(MenuContext), mode = _React$useContext.mode, rtl = _React$useContext.rtl, inlineIndent = _React$useContext.inlineIndent;
  if (mode !== "inline") {
    return null;
  }
  var len = level;
  return rtl ? {
    paddingRight: len * inlineIndent
  } : {
    paddingLeft: len * inlineIndent
  };
}

// ../../node_modules/rc-menu/es/Icon.js
var React207 = __toESM(require_react());
function Icon2(_ref) {
  var icon = _ref.icon, props = _ref.props, children = _ref.children;
  var iconNode;
  if (icon === null || icon === false) {
    return null;
  }
  if (typeof icon === "function") {
    iconNode = /* @__PURE__ */ React207.createElement(icon, _objectSpread2({}, props));
  } else if (typeof icon !== "boolean") {
    iconNode = icon;
  }
  return iconNode || children || null;
}

// ../../node_modules/rc-menu/es/utils/warnUtil.js
var _excluded31 = ["item"];
function warnItemProp(_ref) {
  var item = _ref.item, restInfo = _objectWithoutProperties(_ref, _excluded31);
  Object.defineProperty(restInfo, "item", {
    get: function get3() {
      warning_default(false, "`info.item` is deprecated since we will move to function component that not provides React Node instance in future.");
      return item;
    }
  });
  return restInfo;
}

// ../../node_modules/rc-menu/es/MenuItem.js
var _excluded33 = ["title", "attribute", "elementRef"];
var _excluded210 = ["style", "className", "eventKey", "warnKey", "disabled", "itemIcon", "children", "role", "onMouseEnter", "onMouseLeave", "onClick", "onKeyDown", "onFocus"];
var _excluded34 = ["active"];
var LegacyMenuItem = /* @__PURE__ */ (function(_React$Component) {
  _inherits(LegacyMenuItem2, _React$Component);
  var _super = _createSuper(LegacyMenuItem2);
  function LegacyMenuItem2() {
    _classCallCheck(this, LegacyMenuItem2);
    return _super.apply(this, arguments);
  }
  _createClass(LegacyMenuItem2, [{
    key: "render",
    value: function render4() {
      var _this$props = this.props, title = _this$props.title, attribute = _this$props.attribute, elementRef = _this$props.elementRef, restProps = _objectWithoutProperties(_this$props, _excluded33);
      var passedProps = omit(restProps, ["eventKey", "popupClassName", "popupOffset", "onTitleClick"]);
      warning_default(!attribute, "`attribute` of Menu.Item is deprecated. Please pass attribute directly.");
      return /* @__PURE__ */ React208.createElement(es_default8.Item, _extends({}, attribute, {
        title: typeof title === "string" ? title : void 0
      }, passedProps, {
        ref: elementRef
      }));
    }
  }]);
  return LegacyMenuItem2;
})(React208.Component);
var InternalMenuItem = /* @__PURE__ */ React208.forwardRef(function(props, ref3) {
  var style2 = props.style, className2 = props.className, eventKey = props.eventKey, warnKey = props.warnKey, disabled = props.disabled, itemIcon = props.itemIcon, children = props.children, role = props.role, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, onClick = props.onClick, onKeyDown2 = props.onKeyDown, onFocus = props.onFocus, restProps = _objectWithoutProperties(props, _excluded210);
  var domDataId = useMenuId(eventKey);
  var _React$useContext = React208.useContext(MenuContext), prefixCls = _React$useContext.prefixCls, onItemClick = _React$useContext.onItemClick, contextDisabled = _React$useContext.disabled, overflowDisabled = _React$useContext.overflowDisabled, contextItemIcon = _React$useContext.itemIcon, selectedKeys = _React$useContext.selectedKeys, onActive = _React$useContext.onActive;
  var _React$useContext2 = React208.useContext(PrivateContext_default), _internalRenderMenuItem = _React$useContext2._internalRenderMenuItem;
  var itemCls = "".concat(prefixCls, "-item");
  var legacyMenuItemRef = React208.useRef();
  var elementRef = React208.useRef();
  var mergedDisabled = contextDisabled || disabled;
  var mergedEleRef = useComposeRef(ref3, elementRef);
  var connectedKeys = useFullPath(eventKey);
  if (warnKey) {
    warning_default(false, "MenuItem should not leave undefined `key`.");
  }
  var getEventInfo = function getEventInfo2(e3) {
    return {
      key: eventKey,
      // Note: For legacy code is reversed which not like other antd component
      keyPath: _toConsumableArray(connectedKeys).reverse(),
      item: legacyMenuItemRef.current,
      domEvent: e3
    };
  };
  var mergedItemIcon = itemIcon || contextItemIcon;
  var _useActive = useActive(eventKey, mergedDisabled, onMouseEnter, onMouseLeave), active = _useActive.active, activeProps = _objectWithoutProperties(_useActive, _excluded34);
  var selected = selectedKeys.includes(eventKey);
  var directionStyle = useDirectionStyle(connectedKeys.length);
  var onInternalClick = function onInternalClick2(e3) {
    if (mergedDisabled) {
      return;
    }
    var info = getEventInfo(e3);
    onClick === null || onClick === void 0 || onClick(warnItemProp(info));
    onItemClick(info);
  };
  var onInternalKeyDown = function onInternalKeyDown2(e3) {
    onKeyDown2 === null || onKeyDown2 === void 0 || onKeyDown2(e3);
    if (e3.which === KeyCode_default.ENTER) {
      var info = getEventInfo(e3);
      onClick === null || onClick === void 0 || onClick(warnItemProp(info));
      onItemClick(info);
    }
  };
  var onInternalFocus = function onInternalFocus2(e3) {
    onActive(eventKey);
    onFocus === null || onFocus === void 0 || onFocus(e3);
  };
  var optionRoleProps = {};
  if (props.role === "option") {
    optionRoleProps["aria-selected"] = selected;
  }
  var renderNode = /* @__PURE__ */ React208.createElement(LegacyMenuItem, _extends({
    ref: legacyMenuItemRef,
    elementRef: mergedEleRef,
    role: role === null ? "none" : role || "menuitem",
    tabIndex: disabled ? null : -1,
    "data-menu-id": overflowDisabled && domDataId ? null : domDataId
  }, omit(restProps, ["extra"]), activeProps, optionRoleProps, {
    component: "li",
    "aria-disabled": disabled,
    style: _objectSpread2(_objectSpread2({}, directionStyle), style2),
    className: (0, import_classnames64.default)(itemCls, _defineProperty(_defineProperty(_defineProperty({}, "".concat(itemCls, "-active"), active), "".concat(itemCls, "-selected"), selected), "".concat(itemCls, "-disabled"), mergedDisabled), className2),
    onClick: onInternalClick,
    onKeyDown: onInternalKeyDown,
    onFocus: onInternalFocus
  }), children, /* @__PURE__ */ React208.createElement(Icon2, {
    props: _objectSpread2(_objectSpread2({}, props), {}, {
      isSelected: selected
    }),
    icon: mergedItemIcon
  }));
  if (_internalRenderMenuItem) {
    renderNode = _internalRenderMenuItem(renderNode, props, {
      selected
    });
  }
  return renderNode;
});
function MenuItem(props, ref3) {
  var eventKey = props.eventKey;
  var measure = useMeasure();
  var connectedKeyPath = useFullPath(eventKey);
  React208.useEffect(function() {
    if (measure) {
      measure.registerPath(eventKey, connectedKeyPath);
      return function() {
        measure.unregisterPath(eventKey, connectedKeyPath);
      };
    }
  }, [connectedKeyPath]);
  if (measure) {
    return null;
  }
  return /* @__PURE__ */ React208.createElement(InternalMenuItem, _extends({}, props, {
    ref: ref3
  }));
}
var MenuItem_default = /* @__PURE__ */ React208.forwardRef(MenuItem);

// ../../node_modules/rc-menu/es/SubMenu/index.js
var React213 = __toESM(require_react());
var import_classnames67 = __toESM(require_classnames());

// ../../node_modules/rc-menu/es/SubMenu/SubMenuList.js
var React209 = __toESM(require_react());
var import_classnames65 = __toESM(require_classnames());
var _excluded35 = ["className", "children"];
var InternalSubMenuList = function InternalSubMenuList2(_ref, ref3) {
  var className2 = _ref.className, children = _ref.children, restProps = _objectWithoutProperties(_ref, _excluded35);
  var _React$useContext = React209.useContext(MenuContext), prefixCls = _React$useContext.prefixCls, mode = _React$useContext.mode, rtl = _React$useContext.rtl;
  return /* @__PURE__ */ React209.createElement("ul", _extends({
    className: (0, import_classnames65.default)(prefixCls, rtl && "".concat(prefixCls, "-rtl"), "".concat(prefixCls, "-sub"), "".concat(prefixCls, "-").concat(mode === "inline" ? "inline" : "vertical"), className2),
    role: "menu"
  }, restProps, {
    "data-menu-list": true,
    ref: ref3
  }), children);
};
var SubMenuList = /* @__PURE__ */ React209.forwardRef(InternalSubMenuList);
SubMenuList.displayName = "SubMenuList";
var SubMenuList_default = SubMenuList;

// ../../node_modules/rc-menu/es/utils/commonUtil.js
var React210 = __toESM(require_react());
function parseChildren(children, keyPath) {
  return toArray(children).map(function(child, index3) {
    if (/* @__PURE__ */ React210.isValidElement(child)) {
      var _eventKey, _child$props;
      var key2 = child.key;
      var eventKey = (_eventKey = (_child$props = child.props) === null || _child$props === void 0 ? void 0 : _child$props.eventKey) !== null && _eventKey !== void 0 ? _eventKey : key2;
      var emptyKey = eventKey === null || eventKey === void 0;
      if (emptyKey) {
        eventKey = "tmp_key-".concat([].concat(_toConsumableArray(keyPath), [index3]).join("-"));
      }
      var cloneProps = {
        key: eventKey,
        eventKey
      };
      if (emptyKey) {
        cloneProps.warnKey = true;
      }
      return /* @__PURE__ */ React210.cloneElement(child, cloneProps);
    }
    return child;
  });
}

// ../../node_modules/rc-menu/es/SubMenu/PopupTrigger.js
var React211 = __toESM(require_react());
var import_classnames66 = __toESM(require_classnames());

// ../../node_modules/rc-menu/es/placements.js
var autoAdjustOverflow2 = {
  adjustX: 1,
  adjustY: 1
};
var placements3 = {
  topLeft: {
    points: ["bl", "tl"],
    overflow: autoAdjustOverflow2
  },
  topRight: {
    points: ["br", "tr"],
    overflow: autoAdjustOverflow2
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: autoAdjustOverflow2
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: autoAdjustOverflow2
  },
  leftTop: {
    points: ["tr", "tl"],
    overflow: autoAdjustOverflow2
  },
  leftBottom: {
    points: ["br", "bl"],
    overflow: autoAdjustOverflow2
  },
  rightTop: {
    points: ["tl", "tr"],
    overflow: autoAdjustOverflow2
  },
  rightBottom: {
    points: ["bl", "br"],
    overflow: autoAdjustOverflow2
  }
};
var placementsRtl = {
  topLeft: {
    points: ["bl", "tl"],
    overflow: autoAdjustOverflow2
  },
  topRight: {
    points: ["br", "tr"],
    overflow: autoAdjustOverflow2
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: autoAdjustOverflow2
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: autoAdjustOverflow2
  },
  rightTop: {
    points: ["tr", "tl"],
    overflow: autoAdjustOverflow2
  },
  rightBottom: {
    points: ["br", "bl"],
    overflow: autoAdjustOverflow2
  },
  leftTop: {
    points: ["tl", "tr"],
    overflow: autoAdjustOverflow2
  },
  leftBottom: {
    points: ["bl", "br"],
    overflow: autoAdjustOverflow2
  }
};

// ../../node_modules/rc-menu/es/utils/motionUtil.js
function getMotion3(mode, motion2, defaultMotions) {
  if (motion2) {
    return motion2;
  }
  if (defaultMotions) {
    return defaultMotions[mode] || defaultMotions.other;
  }
  return void 0;
}

// ../../node_modules/rc-menu/es/SubMenu/PopupTrigger.js
var popupPlacementMap = {
  horizontal: "bottomLeft",
  vertical: "rightTop",
  "vertical-left": "rightTop",
  "vertical-right": "leftTop"
};
function PopupTrigger(_ref) {
  var prefixCls = _ref.prefixCls, visible = _ref.visible, children = _ref.children, popup = _ref.popup, popupStyle = _ref.popupStyle, popupClassName = _ref.popupClassName, popupOffset = _ref.popupOffset, disabled = _ref.disabled, mode = _ref.mode, onVisibleChange = _ref.onVisibleChange;
  var _React$useContext = React211.useContext(MenuContext), getPopupContainer = _React$useContext.getPopupContainer, rtl = _React$useContext.rtl, subMenuOpenDelay = _React$useContext.subMenuOpenDelay, subMenuCloseDelay = _React$useContext.subMenuCloseDelay, builtinPlacements = _React$useContext.builtinPlacements, triggerSubMenuAction = _React$useContext.triggerSubMenuAction, forceSubMenuRender = _React$useContext.forceSubMenuRender, rootClassName = _React$useContext.rootClassName, motion2 = _React$useContext.motion, defaultMotions = _React$useContext.defaultMotions;
  var _React$useState = React211.useState(false), _React$useState2 = _slicedToArray(_React$useState, 2), innerVisible = _React$useState2[0], setInnerVisible = _React$useState2[1];
  var placement = rtl ? _objectSpread2(_objectSpread2({}, placementsRtl), builtinPlacements) : _objectSpread2(_objectSpread2({}, placements3), builtinPlacements);
  var popupPlacement = popupPlacementMap[mode];
  var targetMotion = getMotion3(mode, motion2, defaultMotions);
  var targetMotionRef = React211.useRef(targetMotion);
  if (mode !== "inline") {
    targetMotionRef.current = targetMotion;
  }
  var mergedMotion = _objectSpread2(_objectSpread2({}, targetMotionRef.current), {}, {
    leavedClassName: "".concat(prefixCls, "-hidden"),
    removeOnLeave: false,
    motionAppear: true
  });
  var visibleRef = React211.useRef();
  React211.useEffect(function() {
    visibleRef.current = raf_default(function() {
      setInnerVisible(visible);
    });
    return function() {
      raf_default.cancel(visibleRef.current);
    };
  }, [visible]);
  return /* @__PURE__ */ React211.createElement(es_default9, {
    prefixCls,
    popupClassName: (0, import_classnames66.default)("".concat(prefixCls, "-popup"), _defineProperty({}, "".concat(prefixCls, "-rtl"), rtl), popupClassName, rootClassName),
    stretch: mode === "horizontal" ? "minWidth" : null,
    getPopupContainer,
    builtinPlacements: placement,
    popupPlacement,
    popupVisible: innerVisible,
    popup,
    popupStyle,
    popupAlign: popupOffset && {
      offset: popupOffset
    },
    action: disabled ? [] : [triggerSubMenuAction],
    mouseEnterDelay: subMenuOpenDelay,
    mouseLeaveDelay: subMenuCloseDelay,
    onPopupVisibleChange: onVisibleChange,
    forceRender: forceSubMenuRender,
    popupMotion: mergedMotion,
    fresh: true
  }, children);
}

// ../../node_modules/rc-menu/es/SubMenu/InlineSubMenuList.js
var React212 = __toESM(require_react());
function InlineSubMenuList(_ref) {
  var id = _ref.id, open2 = _ref.open, keyPath = _ref.keyPath, children = _ref.children;
  var fixedMode = "inline";
  var _React$useContext = React212.useContext(MenuContext), prefixCls = _React$useContext.prefixCls, forceSubMenuRender = _React$useContext.forceSubMenuRender, motion2 = _React$useContext.motion, defaultMotions = _React$useContext.defaultMotions, mode = _React$useContext.mode;
  var sameModeRef = React212.useRef(false);
  sameModeRef.current = mode === fixedMode;
  var _React$useState = React212.useState(!sameModeRef.current), _React$useState2 = _slicedToArray(_React$useState, 2), destroy2 = _React$useState2[0], setDestroy = _React$useState2[1];
  var mergedOpen = sameModeRef.current ? open2 : false;
  React212.useEffect(function() {
    if (sameModeRef.current) {
      setDestroy(false);
    }
  }, [mode]);
  var mergedMotion = _objectSpread2({}, getMotion3(fixedMode, motion2, defaultMotions));
  if (keyPath.length > 1) {
    mergedMotion.motionAppear = false;
  }
  var originOnVisibleChanged = mergedMotion.onVisibleChanged;
  mergedMotion.onVisibleChanged = function(newVisible) {
    if (!sameModeRef.current && !newVisible) {
      setDestroy(true);
    }
    return originOnVisibleChanged === null || originOnVisibleChanged === void 0 ? void 0 : originOnVisibleChanged(newVisible);
  };
  if (destroy2) {
    return null;
  }
  return /* @__PURE__ */ React212.createElement(InheritableContextProvider, {
    mode: fixedMode,
    locked: !sameModeRef.current
  }, /* @__PURE__ */ React212.createElement(es_default2, _extends({
    visible: mergedOpen
  }, mergedMotion, {
    forceRender: forceSubMenuRender,
    removeOnLeave: false,
    leavedClassName: "".concat(prefixCls, "-hidden")
  }), function(_ref2) {
    var motionClassName = _ref2.className, motionStyle = _ref2.style;
    return /* @__PURE__ */ React212.createElement(SubMenuList_default, {
      id,
      className: motionClassName,
      style: motionStyle
    }, children);
  }));
}

// ../../node_modules/rc-menu/es/SubMenu/index.js
var _excluded36 = ["style", "className", "title", "eventKey", "warnKey", "disabled", "internalPopupClose", "children", "itemIcon", "expandIcon", "popupClassName", "popupOffset", "popupStyle", "onClick", "onMouseEnter", "onMouseLeave", "onTitleClick", "onTitleMouseEnter", "onTitleMouseLeave"];
var _excluded211 = ["active"];
var InternalSubMenu = /* @__PURE__ */ React213.forwardRef(function(props, ref3) {
  var style2 = props.style, className2 = props.className, title = props.title, eventKey = props.eventKey, warnKey = props.warnKey, disabled = props.disabled, internalPopupClose = props.internalPopupClose, children = props.children, itemIcon = props.itemIcon, expandIcon = props.expandIcon, popupClassName = props.popupClassName, popupOffset = props.popupOffset, popupStyle = props.popupStyle, onClick = props.onClick, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, onTitleClick = props.onTitleClick, onTitleMouseEnter = props.onTitleMouseEnter, onTitleMouseLeave = props.onTitleMouseLeave, restProps = _objectWithoutProperties(props, _excluded36);
  var domDataId = useMenuId(eventKey);
  var _React$useContext = React213.useContext(MenuContext), prefixCls = _React$useContext.prefixCls, mode = _React$useContext.mode, openKeys = _React$useContext.openKeys, contextDisabled = _React$useContext.disabled, overflowDisabled = _React$useContext.overflowDisabled, activeKey = _React$useContext.activeKey, selectedKeys = _React$useContext.selectedKeys, contextItemIcon = _React$useContext.itemIcon, contextExpandIcon = _React$useContext.expandIcon, onItemClick = _React$useContext.onItemClick, onOpenChange = _React$useContext.onOpenChange, onActive = _React$useContext.onActive;
  var _React$useContext2 = React213.useContext(PrivateContext_default), _internalRenderSubMenuItem = _React$useContext2._internalRenderSubMenuItem;
  var _React$useContext3 = React213.useContext(PathUserContext), isSubPathKey = _React$useContext3.isSubPathKey;
  var connectedPath = useFullPath();
  var subMenuPrefixCls = "".concat(prefixCls, "-submenu");
  var mergedDisabled = contextDisabled || disabled;
  var elementRef = React213.useRef();
  var popupRef = React213.useRef();
  if (warnKey) {
    warning_default(false, "SubMenu should not leave undefined `key`.");
  }
  var mergedItemIcon = itemIcon !== null && itemIcon !== void 0 ? itemIcon : contextItemIcon;
  var mergedExpandIcon = expandIcon !== null && expandIcon !== void 0 ? expandIcon : contextExpandIcon;
  var originOpen = openKeys.includes(eventKey);
  var open2 = !overflowDisabled && originOpen;
  var childrenSelected = isSubPathKey(selectedKeys, eventKey);
  var _useActive = useActive(eventKey, mergedDisabled, onTitleMouseEnter, onTitleMouseLeave), active = _useActive.active, activeProps = _objectWithoutProperties(_useActive, _excluded211);
  var _React$useState = React213.useState(false), _React$useState2 = _slicedToArray(_React$useState, 2), childrenActive = _React$useState2[0], setChildrenActive = _React$useState2[1];
  var triggerChildrenActive = function triggerChildrenActive2(newActive) {
    if (!mergedDisabled) {
      setChildrenActive(newActive);
    }
  };
  var onInternalMouseEnter = function onInternalMouseEnter2(domEvent) {
    triggerChildrenActive(true);
    onMouseEnter === null || onMouseEnter === void 0 || onMouseEnter({
      key: eventKey,
      domEvent
    });
  };
  var onInternalMouseLeave = function onInternalMouseLeave2(domEvent) {
    triggerChildrenActive(false);
    onMouseLeave === null || onMouseLeave === void 0 || onMouseLeave({
      key: eventKey,
      domEvent
    });
  };
  var mergedActive = React213.useMemo(function() {
    if (active) {
      return active;
    }
    if (mode !== "inline") {
      return childrenActive || isSubPathKey([activeKey], eventKey);
    }
    return false;
  }, [mode, active, activeKey, childrenActive, eventKey, isSubPathKey]);
  var directionStyle = useDirectionStyle(connectedPath.length);
  var onInternalTitleClick = function onInternalTitleClick2(e3) {
    if (mergedDisabled) {
      return;
    }
    onTitleClick === null || onTitleClick === void 0 || onTitleClick({
      key: eventKey,
      domEvent: e3
    });
    if (mode === "inline") {
      onOpenChange(eventKey, !originOpen);
    }
  };
  var onMergedItemClick = useMemoCallback(function(info) {
    onClick === null || onClick === void 0 || onClick(warnItemProp(info));
    onItemClick(info);
  });
  var onPopupVisibleChange = function onPopupVisibleChange2(newVisible) {
    if (mode !== "inline") {
      onOpenChange(eventKey, newVisible);
    }
  };
  var onInternalFocus = function onInternalFocus2() {
    onActive(eventKey);
  };
  var popupId = domDataId && "".concat(domDataId, "-popup");
  var expandIconNode = React213.useMemo(function() {
    return /* @__PURE__ */ React213.createElement(Icon2, {
      icon: mode !== "horizontal" ? mergedExpandIcon : void 0,
      props: _objectSpread2(_objectSpread2({}, props), {}, {
        isOpen: open2,
        // [Legacy] Not sure why need this mark
        isSubMenu: true
      })
    }, /* @__PURE__ */ React213.createElement("i", {
      className: "".concat(subMenuPrefixCls, "-arrow")
    }));
  }, [mode, mergedExpandIcon, props, open2, subMenuPrefixCls]);
  var titleNode = /* @__PURE__ */ React213.createElement("div", _extends({
    role: "menuitem",
    style: directionStyle,
    className: "".concat(subMenuPrefixCls, "-title"),
    tabIndex: mergedDisabled ? null : -1,
    ref: elementRef,
    title: typeof title === "string" ? title : null,
    "data-menu-id": overflowDisabled && domDataId ? null : domDataId,
    "aria-expanded": open2,
    "aria-haspopup": true,
    "aria-controls": popupId,
    "aria-disabled": mergedDisabled,
    onClick: onInternalTitleClick,
    onFocus: onInternalFocus
  }, activeProps), title, expandIconNode);
  var triggerModeRef = React213.useRef(mode);
  if (mode !== "inline" && connectedPath.length > 1) {
    triggerModeRef.current = "vertical";
  } else {
    triggerModeRef.current = mode;
  }
  if (!overflowDisabled) {
    var triggerMode = triggerModeRef.current;
    titleNode = /* @__PURE__ */ React213.createElement(PopupTrigger, {
      mode: triggerMode,
      prefixCls: subMenuPrefixCls,
      visible: !internalPopupClose && open2 && mode !== "inline",
      popupClassName,
      popupOffset,
      popupStyle,
      popup: /* @__PURE__ */ React213.createElement(
        InheritableContextProvider,
        {
          mode: triggerMode === "horizontal" ? "vertical" : triggerMode
        },
        /* @__PURE__ */ React213.createElement(SubMenuList_default, {
          id: popupId,
          ref: popupRef
        }, children)
      ),
      disabled: mergedDisabled,
      onVisibleChange: onPopupVisibleChange
    }, titleNode);
  }
  var listNode = /* @__PURE__ */ React213.createElement(es_default8.Item, _extends({
    ref: ref3,
    role: "none"
  }, restProps, {
    component: "li",
    style: style2,
    className: (0, import_classnames67.default)(subMenuPrefixCls, "".concat(subMenuPrefixCls, "-").concat(mode), className2, _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "".concat(subMenuPrefixCls, "-open"), open2), "".concat(subMenuPrefixCls, "-active"), mergedActive), "".concat(subMenuPrefixCls, "-selected"), childrenSelected), "".concat(subMenuPrefixCls, "-disabled"), mergedDisabled)),
    onMouseEnter: onInternalMouseEnter,
    onMouseLeave: onInternalMouseLeave
  }), titleNode, !overflowDisabled && /* @__PURE__ */ React213.createElement(InlineSubMenuList, {
    id: popupId,
    open: open2,
    keyPath: connectedPath
  }, children));
  if (_internalRenderSubMenuItem) {
    listNode = _internalRenderSubMenuItem(listNode, props, {
      selected: childrenSelected,
      active: mergedActive,
      open: open2,
      disabled: mergedDisabled
    });
  }
  return /* @__PURE__ */ React213.createElement(InheritableContextProvider, {
    onItemClick: onMergedItemClick,
    mode: mode === "horizontal" ? "vertical" : mode,
    itemIcon: mergedItemIcon,
    expandIcon: mergedExpandIcon
  }, listNode);
});
var SubMenu = /* @__PURE__ */ React213.forwardRef(function(props, ref3) {
  var eventKey = props.eventKey, children = props.children;
  var connectedKeyPath = useFullPath(eventKey);
  var childList = parseChildren(children, connectedKeyPath);
  var measure = useMeasure();
  React213.useEffect(function() {
    if (measure) {
      measure.registerPath(eventKey, connectedKeyPath);
      return function() {
        measure.unregisterPath(eventKey, connectedKeyPath);
      };
    }
  }, [connectedKeyPath]);
  var renderNode;
  if (measure) {
    renderNode = childList;
  } else {
    renderNode = /* @__PURE__ */ React213.createElement(InternalSubMenu, _extends({
      ref: ref3
    }, props), childList);
  }
  return /* @__PURE__ */ React213.createElement(PathTrackerContext.Provider, {
    value: connectedKeyPath
  }, renderNode);
});
if (true) {
  SubMenu.displayName = "SubMenu";
}
var SubMenu_default = SubMenu;

// ../../node_modules/rc-menu/es/utils/nodeUtil.js
var React216 = __toESM(require_react());

// ../../node_modules/rc-menu/es/Divider.js
var React214 = __toESM(require_react());
var import_classnames68 = __toESM(require_classnames());
function Divider(_ref) {
  var className2 = _ref.className, style2 = _ref.style;
  var _React$useContext = React214.useContext(MenuContext), prefixCls = _React$useContext.prefixCls;
  var measure = useMeasure();
  if (measure) {
    return null;
  }
  return /* @__PURE__ */ React214.createElement("li", {
    role: "separator",
    className: (0, import_classnames68.default)("".concat(prefixCls, "-item-divider"), className2),
    style: style2
  });
}

// ../../node_modules/rc-menu/es/MenuItemGroup.js
var import_classnames69 = __toESM(require_classnames());
var React215 = __toESM(require_react());
var _excluded37 = ["className", "title", "eventKey", "children"];
var InternalMenuItemGroup = /* @__PURE__ */ React215.forwardRef(function(props, ref3) {
  var className2 = props.className, title = props.title, eventKey = props.eventKey, children = props.children, restProps = _objectWithoutProperties(props, _excluded37);
  var _React$useContext = React215.useContext(MenuContext), prefixCls = _React$useContext.prefixCls;
  var groupPrefixCls = "".concat(prefixCls, "-item-group");
  return /* @__PURE__ */ React215.createElement("li", _extends({
    ref: ref3,
    role: "presentation"
  }, restProps, {
    onClick: function onClick(e3) {
      return e3.stopPropagation();
    },
    className: (0, import_classnames69.default)(groupPrefixCls, className2)
  }), /* @__PURE__ */ React215.createElement("div", {
    role: "presentation",
    className: "".concat(groupPrefixCls, "-title"),
    title: typeof title === "string" ? title : void 0
  }, title), /* @__PURE__ */ React215.createElement("ul", {
    role: "group",
    className: "".concat(groupPrefixCls, "-list")
  }, children));
});
var MenuItemGroup = /* @__PURE__ */ React215.forwardRef(function(props, ref3) {
  var eventKey = props.eventKey, children = props.children;
  var connectedKeyPath = useFullPath(eventKey);
  var childList = parseChildren(children, connectedKeyPath);
  var measure = useMeasure();
  if (measure) {
    return childList;
  }
  return /* @__PURE__ */ React215.createElement(InternalMenuItemGroup, _extends({
    ref: ref3
  }, omit(props, ["warnKey"])), childList);
});
if (true) {
  MenuItemGroup.displayName = "MenuItemGroup";
}
var MenuItemGroup_default = MenuItemGroup;

// ../../node_modules/rc-menu/es/utils/nodeUtil.js
var _excluded38 = ["label", "children", "key", "type", "extra"];
function convertItemsToNodes3(list, components, prefixCls) {
  var MergedMenuItem = components.item, MergedMenuItemGroup = components.group, MergedSubMenu = components.submenu, MergedDivider = components.divider;
  return (list || []).map(function(opt, index3) {
    if (opt && _typeof(opt) === "object") {
      var _ref = opt, label = _ref.label, children = _ref.children, key2 = _ref.key, type5 = _ref.type, extra = _ref.extra, restProps = _objectWithoutProperties(_ref, _excluded38);
      var mergedKey = key2 !== null && key2 !== void 0 ? key2 : "tmp-".concat(index3);
      if (children || type5 === "group") {
        if (type5 === "group") {
          return /* @__PURE__ */ React216.createElement(MergedMenuItemGroup, _extends({
            key: mergedKey
          }, restProps, {
            title: label
          }), convertItemsToNodes3(children, components, prefixCls));
        }
        return /* @__PURE__ */ React216.createElement(MergedSubMenu, _extends({
          key: mergedKey
        }, restProps, {
          title: label
        }), convertItemsToNodes3(children, components, prefixCls));
      }
      if (type5 === "divider") {
        return /* @__PURE__ */ React216.createElement(MergedDivider, _extends({
          key: mergedKey
        }, restProps));
      }
      return /* @__PURE__ */ React216.createElement(MergedMenuItem, _extends({
        key: mergedKey
      }, restProps, {
        extra
      }), label, (!!extra || extra === 0) && /* @__PURE__ */ React216.createElement("span", {
        className: "".concat(prefixCls, "-item-extra")
      }, extra));
    }
    return null;
  }).filter(function(opt) {
    return opt;
  });
}
function parseItems(children, items, keyPath, components, prefixCls) {
  var childNodes = children;
  var mergedComponents = _objectSpread2({
    divider: Divider,
    item: MenuItem_default,
    group: MenuItemGroup_default,
    submenu: SubMenu_default
  }, components);
  if (items) {
    childNodes = convertItemsToNodes3(items, mergedComponents, prefixCls);
  }
  return parseChildren(childNodes, keyPath);
}

// ../../node_modules/rc-menu/es/Menu.js
var _excluded39 = ["prefixCls", "rootClassName", "style", "className", "tabIndex", "items", "children", "direction", "id", "mode", "inlineCollapsed", "disabled", "disabledOverflow", "subMenuOpenDelay", "subMenuCloseDelay", "forceSubMenuRender", "defaultOpenKeys", "openKeys", "activeKey", "defaultActiveFirst", "selectable", "multiple", "defaultSelectedKeys", "selectedKeys", "onSelect", "onDeselect", "inlineIndent", "motion", "defaultMotions", "triggerSubMenuAction", "builtinPlacements", "itemIcon", "expandIcon", "overflowedIndicator", "overflowedIndicatorPopupClassName", "getPopupContainer", "onClick", "onOpenChange", "onKeyDown", "openAnimation", "openTransitionName", "_internalRenderMenuItem", "_internalRenderSubMenuItem", "_internalComponents"];
var EMPTY_LIST2 = [];
var Menu = /* @__PURE__ */ React217.forwardRef(function(props, ref3) {
  var _childList$;
  var _ref = props, _ref$prefixCls = _ref.prefixCls, prefixCls = _ref$prefixCls === void 0 ? "rc-menu" : _ref$prefixCls, rootClassName = _ref.rootClassName, style2 = _ref.style, className2 = _ref.className, _ref$tabIndex = _ref.tabIndex, tabIndex = _ref$tabIndex === void 0 ? 0 : _ref$tabIndex, items = _ref.items, children = _ref.children, direction = _ref.direction, id = _ref.id, _ref$mode = _ref.mode, mode = _ref$mode === void 0 ? "vertical" : _ref$mode, inlineCollapsed = _ref.inlineCollapsed, disabled = _ref.disabled, disabledOverflow = _ref.disabledOverflow, _ref$subMenuOpenDelay = _ref.subMenuOpenDelay, subMenuOpenDelay = _ref$subMenuOpenDelay === void 0 ? 0.1 : _ref$subMenuOpenDelay, _ref$subMenuCloseDela = _ref.subMenuCloseDelay, subMenuCloseDelay = _ref$subMenuCloseDela === void 0 ? 0.1 : _ref$subMenuCloseDela, forceSubMenuRender = _ref.forceSubMenuRender, defaultOpenKeys = _ref.defaultOpenKeys, openKeys = _ref.openKeys, activeKey = _ref.activeKey, defaultActiveFirst = _ref.defaultActiveFirst, _ref$selectable = _ref.selectable, selectable = _ref$selectable === void 0 ? true : _ref$selectable, _ref$multiple = _ref.multiple, multiple = _ref$multiple === void 0 ? false : _ref$multiple, defaultSelectedKeys = _ref.defaultSelectedKeys, selectedKeys = _ref.selectedKeys, onSelect = _ref.onSelect, onDeselect = _ref.onDeselect, _ref$inlineIndent = _ref.inlineIndent, inlineIndent = _ref$inlineIndent === void 0 ? 24 : _ref$inlineIndent, motion2 = _ref.motion, defaultMotions = _ref.defaultMotions, _ref$triggerSubMenuAc = _ref.triggerSubMenuAction, triggerSubMenuAction = _ref$triggerSubMenuAc === void 0 ? "hover" : _ref$triggerSubMenuAc, builtinPlacements = _ref.builtinPlacements, itemIcon = _ref.itemIcon, expandIcon = _ref.expandIcon, _ref$overflowedIndica = _ref.overflowedIndicator, overflowedIndicator = _ref$overflowedIndica === void 0 ? "..." : _ref$overflowedIndica, overflowedIndicatorPopupClassName = _ref.overflowedIndicatorPopupClassName, getPopupContainer = _ref.getPopupContainer, onClick = _ref.onClick, onOpenChange = _ref.onOpenChange, onKeyDown2 = _ref.onKeyDown, openAnimation = _ref.openAnimation, openTransitionName = _ref.openTransitionName, _internalRenderMenuItem = _ref._internalRenderMenuItem, _internalRenderSubMenuItem = _ref._internalRenderSubMenuItem, _internalComponents = _ref._internalComponents, restProps = _objectWithoutProperties(_ref, _excluded39);
  var _React$useMemo = React217.useMemo(function() {
    return [parseItems(children, items, EMPTY_LIST2, _internalComponents, prefixCls), parseItems(children, items, EMPTY_LIST2, {}, prefixCls)];
  }, [children, items, _internalComponents]), _React$useMemo2 = _slicedToArray(_React$useMemo, 2), childList = _React$useMemo2[0], measureChildList = _React$useMemo2[1];
  var _React$useState = React217.useState(false), _React$useState2 = _slicedToArray(_React$useState, 2), mounted = _React$useState2[0], setMounted = _React$useState2[1];
  var containerRef = React217.useRef();
  var uuid8 = useUUID(id);
  var isRtl = direction === "rtl";
  if (true) {
    warning_default(!openAnimation && !openTransitionName, "`openAnimation` and `openTransitionName` is removed. Please use `motion` or `defaultMotion` instead.");
  }
  var _useMergedState = useMergedState(defaultOpenKeys, {
    value: openKeys,
    postState: function postState(keys4) {
      return keys4 || EMPTY_LIST2;
    }
  }), _useMergedState2 = _slicedToArray(_useMergedState, 2), mergedOpenKeys = _useMergedState2[0], setMergedOpenKeys = _useMergedState2[1];
  var triggerOpenKeys = function triggerOpenKeys2(keys4) {
    var forceFlush = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    function doUpdate() {
      setMergedOpenKeys(keys4);
      onOpenChange === null || onOpenChange === void 0 || onOpenChange(keys4);
    }
    if (forceFlush) {
      (0, import_react_dom8.flushSync)(doUpdate);
    } else {
      doUpdate();
    }
  };
  var _React$useState3 = React217.useState(mergedOpenKeys), _React$useState4 = _slicedToArray(_React$useState3, 2), inlineCacheOpenKeys = _React$useState4[0], setInlineCacheOpenKeys = _React$useState4[1];
  var mountRef = React217.useRef(false);
  var _React$useMemo3 = React217.useMemo(function() {
    if ((mode === "inline" || mode === "vertical") && inlineCollapsed) {
      return ["vertical", inlineCollapsed];
    }
    return [mode, false];
  }, [mode, inlineCollapsed]), _React$useMemo4 = _slicedToArray(_React$useMemo3, 2), mergedMode = _React$useMemo4[0], mergedInlineCollapsed = _React$useMemo4[1];
  var isInlineMode = mergedMode === "inline";
  var _React$useState5 = React217.useState(mergedMode), _React$useState6 = _slicedToArray(_React$useState5, 2), internalMode = _React$useState6[0], setInternalMode = _React$useState6[1];
  var _React$useState7 = React217.useState(mergedInlineCollapsed), _React$useState8 = _slicedToArray(_React$useState7, 2), internalInlineCollapsed = _React$useState8[0], setInternalInlineCollapsed = _React$useState8[1];
  React217.useEffect(function() {
    setInternalMode(mergedMode);
    setInternalInlineCollapsed(mergedInlineCollapsed);
    if (!mountRef.current) {
      return;
    }
    if (isInlineMode) {
      setMergedOpenKeys(inlineCacheOpenKeys);
    } else {
      triggerOpenKeys(EMPTY_LIST2);
    }
  }, [mergedMode, mergedInlineCollapsed]);
  var _React$useState9 = React217.useState(0), _React$useState10 = _slicedToArray(_React$useState9, 2), lastVisibleIndex = _React$useState10[0], setLastVisibleIndex = _React$useState10[1];
  var allVisible = lastVisibleIndex >= childList.length - 1 || internalMode !== "horizontal" || disabledOverflow;
  React217.useEffect(function() {
    if (isInlineMode) {
      setInlineCacheOpenKeys(mergedOpenKeys);
    }
  }, [mergedOpenKeys]);
  React217.useEffect(function() {
    mountRef.current = true;
    return function() {
      mountRef.current = false;
    };
  }, []);
  var _useKeyRecords = useKeyRecords(), registerPath = _useKeyRecords.registerPath, unregisterPath = _useKeyRecords.unregisterPath, refreshOverflowKeys = _useKeyRecords.refreshOverflowKeys, isSubPathKey = _useKeyRecords.isSubPathKey, getKeyPath = _useKeyRecords.getKeyPath, getKeys3 = _useKeyRecords.getKeys, getSubPathKeys = _useKeyRecords.getSubPathKeys;
  var registerPathContext = React217.useMemo(function() {
    return {
      registerPath,
      unregisterPath
    };
  }, [registerPath, unregisterPath]);
  var pathUserContext = React217.useMemo(function() {
    return {
      isSubPathKey
    };
  }, [isSubPathKey]);
  React217.useEffect(function() {
    refreshOverflowKeys(allVisible ? EMPTY_LIST2 : childList.slice(lastVisibleIndex + 1).map(function(child) {
      return child.key;
    }));
  }, [lastVisibleIndex, allVisible]);
  var _useMergedState3 = useMergedState(activeKey || defaultActiveFirst && ((_childList$ = childList[0]) === null || _childList$ === void 0 ? void 0 : _childList$.key), {
    value: activeKey
  }), _useMergedState4 = _slicedToArray(_useMergedState3, 2), mergedActiveKey = _useMergedState4[0], setMergedActiveKey = _useMergedState4[1];
  var onActive = useMemoCallback(function(key2) {
    setMergedActiveKey(key2);
  });
  var onInactive = useMemoCallback(function() {
    setMergedActiveKey(void 0);
  });
  (0, import_react79.useImperativeHandle)(ref3, function() {
    return {
      list: containerRef.current,
      focus: function focus(options) {
        var _childList$find;
        var keys4 = getKeys3();
        var _refreshElements = refreshElements(keys4, uuid8), elements = _refreshElements.elements, key2element = _refreshElements.key2element, element2key = _refreshElements.element2key;
        var focusableElements = getFocusableElements(containerRef.current, elements);
        var shouldFocusKey = mergedActiveKey !== null && mergedActiveKey !== void 0 ? mergedActiveKey : focusableElements[0] ? element2key.get(focusableElements[0]) : (_childList$find = childList.find(function(node2) {
          return !node2.props.disabled;
        })) === null || _childList$find === void 0 ? void 0 : _childList$find.key;
        var elementToFocus = key2element.get(shouldFocusKey);
        if (shouldFocusKey && elementToFocus) {
          var _elementToFocus$focus;
          elementToFocus === null || elementToFocus === void 0 || (_elementToFocus$focus = elementToFocus.focus) === null || _elementToFocus$focus === void 0 || _elementToFocus$focus.call(elementToFocus, options);
        }
      }
    };
  });
  var _useMergedState5 = useMergedState(defaultSelectedKeys || [], {
    value: selectedKeys,
    // Legacy convert key to array
    postState: function postState(keys4) {
      if (Array.isArray(keys4)) {
        return keys4;
      }
      if (keys4 === null || keys4 === void 0) {
        return EMPTY_LIST2;
      }
      return [keys4];
    }
  }), _useMergedState6 = _slicedToArray(_useMergedState5, 2), mergedSelectKeys = _useMergedState6[0], setMergedSelectKeys = _useMergedState6[1];
  var triggerSelection = function triggerSelection2(info) {
    if (selectable) {
      var targetKey = info.key;
      var exist = mergedSelectKeys.includes(targetKey);
      var newSelectKeys;
      if (multiple) {
        if (exist) {
          newSelectKeys = mergedSelectKeys.filter(function(key2) {
            return key2 !== targetKey;
          });
        } else {
          newSelectKeys = [].concat(_toConsumableArray(mergedSelectKeys), [targetKey]);
        }
      } else {
        newSelectKeys = [targetKey];
      }
      setMergedSelectKeys(newSelectKeys);
      var selectInfo = _objectSpread2(_objectSpread2({}, info), {}, {
        selectedKeys: newSelectKeys
      });
      if (exist) {
        onDeselect === null || onDeselect === void 0 || onDeselect(selectInfo);
      } else {
        onSelect === null || onSelect === void 0 || onSelect(selectInfo);
      }
    }
    if (!multiple && mergedOpenKeys.length && internalMode !== "inline") {
      triggerOpenKeys(EMPTY_LIST2);
    }
  };
  var onInternalClick = useMemoCallback(function(info) {
    onClick === null || onClick === void 0 || onClick(warnItemProp(info));
    triggerSelection(info);
  });
  var onInternalOpenChange = useMemoCallback(function(key2, open2) {
    var newOpenKeys = mergedOpenKeys.filter(function(k) {
      return k !== key2;
    });
    if (open2) {
      newOpenKeys.push(key2);
    } else if (internalMode !== "inline") {
      var subPathKeys = getSubPathKeys(key2);
      newOpenKeys = newOpenKeys.filter(function(k) {
        return !subPathKeys.has(k);
      });
    }
    if (!isEqual_default(mergedOpenKeys, newOpenKeys, true)) {
      triggerOpenKeys(newOpenKeys, true);
    }
  });
  var triggerAccessibilityOpen = function triggerAccessibilityOpen2(key2, open2) {
    var nextOpen = open2 !== null && open2 !== void 0 ? open2 : !mergedOpenKeys.includes(key2);
    onInternalOpenChange(key2, nextOpen);
  };
  var onInternalKeyDown = useAccessibility2(internalMode, mergedActiveKey, isRtl, uuid8, containerRef, getKeys3, getKeyPath, setMergedActiveKey, triggerAccessibilityOpen, onKeyDown2);
  React217.useEffect(function() {
    setMounted(true);
  }, []);
  var privateContext = React217.useMemo(function() {
    return {
      _internalRenderMenuItem,
      _internalRenderSubMenuItem
    };
  }, [_internalRenderMenuItem, _internalRenderSubMenuItem]);
  var wrappedChildList = internalMode !== "horizontal" || disabledOverflow ? childList : (
    // Need wrap for overflow dropdown that do not response for open
    childList.map(function(child, index3) {
      return (
        // Always wrap provider to avoid sub node re-mount
        /* @__PURE__ */ React217.createElement(InheritableContextProvider, {
          key: child.key,
          overflowDisabled: index3 > lastVisibleIndex
        }, child)
      );
    })
  );
  var container = /* @__PURE__ */ React217.createElement(es_default8, _extends({
    id,
    ref: containerRef,
    prefixCls: "".concat(prefixCls, "-overflow"),
    component: "ul",
    itemComponent: MenuItem_default,
    className: (0, import_classnames70.default)(prefixCls, "".concat(prefixCls, "-root"), "".concat(prefixCls, "-").concat(internalMode), className2, _defineProperty(_defineProperty({}, "".concat(prefixCls, "-inline-collapsed"), internalInlineCollapsed), "".concat(prefixCls, "-rtl"), isRtl), rootClassName),
    dir: direction,
    style: style2,
    role: "menu",
    tabIndex,
    data: wrappedChildList,
    renderRawItem: function renderRawItem(node2) {
      return node2;
    },
    renderRawRest: function renderRawRest(omitItems) {
      var len = omitItems.length;
      var originOmitItems = len ? childList.slice(-len) : null;
      return /* @__PURE__ */ React217.createElement(SubMenu_default, {
        eventKey: OVERFLOW_KEY,
        title: overflowedIndicator,
        disabled: allVisible,
        internalPopupClose: len === 0,
        popupClassName: overflowedIndicatorPopupClassName
      }, originOmitItems);
    },
    maxCount: internalMode !== "horizontal" || disabledOverflow ? es_default8.INVALIDATE : es_default8.RESPONSIVE,
    ssr: "full",
    "data-menu-list": true,
    onVisibleChange: function onVisibleChange(newLastIndex) {
      setLastVisibleIndex(newLastIndex);
    },
    onKeyDown: onInternalKeyDown
  }, restProps));
  return /* @__PURE__ */ React217.createElement(PrivateContext_default.Provider, {
    value: privateContext
  }, /* @__PURE__ */ React217.createElement(IdContext.Provider, {
    value: uuid8
  }, /* @__PURE__ */ React217.createElement(InheritableContextProvider, {
    prefixCls,
    rootClassName,
    mode: internalMode,
    openKeys: mergedOpenKeys,
    rtl: isRtl,
    disabled,
    motion: mounted ? motion2 : null,
    defaultMotions: mounted ? defaultMotions : null,
    activeKey: mergedActiveKey,
    onActive,
    onInactive,
    selectedKeys: mergedSelectKeys,
    inlineIndent,
    subMenuOpenDelay,
    subMenuCloseDelay,
    forceSubMenuRender,
    builtinPlacements,
    triggerSubMenuAction,
    getPopupContainer,
    itemIcon,
    expandIcon,
    onItemClick: onInternalClick,
    onOpenChange: onInternalOpenChange
  }, /* @__PURE__ */ React217.createElement(PathUserContext.Provider, {
    value: pathUserContext
  }, container), /* @__PURE__ */ React217.createElement("div", {
    style: {
      display: "none"
    },
    "aria-hidden": true
  }, /* @__PURE__ */ React217.createElement(PathRegisterContext.Provider, {
    value: registerPathContext
  }, measureChildList)))));
});
var Menu_default = Menu;

// ../../node_modules/rc-menu/es/index.js
var ExportMenu = Menu_default;
ExportMenu.Item = MenuItem_default;
ExportMenu.SubMenu = SubMenu_default;
ExportMenu.ItemGroup = MenuItemGroup_default;
ExportMenu.Divider = Divider;
var es_default14 = ExportMenu;

// ../../node_modules/antd/es/layout/Sider.js
var React220 = __toESM(require_react());
var import_react80 = __toESM(require_react());

// ../../node_modules/@ant-design/icons/es/icons/BarsOutlined.js
var React218 = __toESM(require_react());

// ../../node_modules/@ant-design/icons-svg/es/asn/BarsOutlined.js
var BarsOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M912 192H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM104 228a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0z" } }] }, "name": "bars", "theme": "outlined" };
var BarsOutlined_default = BarsOutlined;

// ../../node_modules/@ant-design/icons/es/icons/BarsOutlined.js
var BarsOutlined2 = function BarsOutlined3(props, ref3) {
  return /* @__PURE__ */ React218.createElement(AntdIcon_default, _extends({}, props, {
    ref: ref3,
    icon: BarsOutlined_default
  }));
};
var RefIcon12 = /* @__PURE__ */ React218.forwardRef(BarsOutlined2);
if (true) {
  RefIcon12.displayName = "BarsOutlined";
}
var BarsOutlined_default2 = RefIcon12;

// ../../node_modules/antd/es/layout/Sider.js
var import_classnames71 = __toESM(require_classnames());

// ../../node_modules/antd/es/layout/context.js
var React219 = __toESM(require_react());
var LayoutContext = /* @__PURE__ */ React219.createContext({
  siderHook: {
    addSider: () => null,
    removeSider: () => null
  }
});

// ../../node_modules/antd/es/layout/style/index.js
var genLayoutStyle = (token2) => {
  const {
    antCls,
    // .ant
    componentCls,
    // .ant-layout
    colorText,
    footerBg,
    headerHeight,
    headerPadding,
    headerColor,
    footerPadding,
    fontSize,
    bodyBg,
    headerBg
  } = token2;
  return {
    [componentCls]: {
      display: "flex",
      flex: "auto",
      flexDirection: "column",
      /* fix firefox can't set height smaller than content on flex item */
      minHeight: 0,
      background: bodyBg,
      "&, *": {
        boxSizing: "border-box"
      },
      [`&${componentCls}-has-sider`]: {
        flexDirection: "row",
        [`> ${componentCls}, > ${componentCls}-content`]: {
          // https://segmentfault.com/a/1190000019498300
          width: 0
        }
      },
      [`${componentCls}-header, &${componentCls}-footer`]: {
        flex: "0 0 auto"
      },
      // RTL
      "&-rtl": {
        direction: "rtl"
      }
    },
    // ==================== Header ====================
    [`${componentCls}-header`]: {
      height: headerHeight,
      padding: headerPadding,
      color: headerColor,
      lineHeight: unit(headerHeight),
      background: headerBg,
      // Other components/menu/style/index.less line:686
      // Integration with header element so menu items have the same height
      [`${antCls}-menu`]: {
        lineHeight: "inherit"
      }
    },
    // ==================== Footer ====================
    [`${componentCls}-footer`]: {
      padding: footerPadding,
      color: colorText,
      fontSize,
      background: footerBg
    },
    // =================== Content ====================
    [`${componentCls}-content`]: {
      flex: "auto",
      color: colorText,
      // fix firefox can't set height smaller than content on flex item
      minHeight: 0
    }
  };
};
var prepareComponentToken9 = (token2) => {
  const {
    colorBgLayout,
    controlHeight,
    controlHeightLG,
    colorText,
    controlHeightSM,
    marginXXS,
    colorTextLightSolid,
    colorBgContainer
  } = token2;
  const paddingInline = controlHeightLG * 1.25;
  return {
    // Deprecated
    colorBgHeader: "#001529",
    colorBgBody: colorBgLayout,
    colorBgTrigger: "#002140",
    bodyBg: colorBgLayout,
    headerBg: "#001529",
    headerHeight: controlHeight * 2,
    headerPadding: `0 ${paddingInline}px`,
    headerColor: colorText,
    footerPadding: `${controlHeightSM}px ${paddingInline}px`,
    footerBg: colorBgLayout,
    siderBg: "#001529",
    triggerHeight: controlHeightLG + marginXXS * 2,
    triggerBg: "#002140",
    triggerColor: colorTextLightSolid,
    zeroTriggerWidth: controlHeightLG,
    zeroTriggerHeight: controlHeightLG,
    lightSiderBg: colorBgContainer,
    lightTriggerBg: colorBgContainer,
    lightTriggerColor: colorText
  };
};
var DEPRECATED_TOKENS = [["colorBgBody", "bodyBg"], ["colorBgHeader", "headerBg"], ["colorBgTrigger", "triggerBg"]];
var style_default12 = genStyleHooks("Layout", genLayoutStyle, prepareComponentToken9, {
  deprecatedTokens: DEPRECATED_TOKENS
});

// ../../node_modules/antd/es/layout/style/sider.js
var genSiderStyle = (token2) => {
  const {
    componentCls,
    siderBg,
    motionDurationMid,
    motionDurationSlow,
    antCls,
    triggerHeight,
    triggerColor,
    triggerBg,
    headerHeight,
    zeroTriggerWidth,
    zeroTriggerHeight,
    borderRadiusLG,
    lightSiderBg,
    lightTriggerColor,
    lightTriggerBg,
    bodyBg
  } = token2;
  return {
    [componentCls]: {
      position: "relative",
      // fix firefox can't set width smaller than content on flex item
      minWidth: 0,
      background: siderBg,
      transition: `all ${motionDurationMid}, background 0s`,
      "&-has-trigger": {
        paddingBottom: triggerHeight
      },
      "&-right": {
        order: 1
      },
      [`${componentCls}-children`]: {
        height: "100%",
        // Hack for fixing margin collapse bug
        // https://github.com/ant-design/ant-design/issues/7967
        // solution from https://stackoverflow.com/a/33132624/3040605
        marginTop: -0.1,
        paddingTop: 0.1,
        [`${antCls}-menu${antCls}-menu-inline-collapsed`]: {
          width: "auto"
        }
      },
      [`&-zero-width ${componentCls}-children`]: {
        overflow: "hidden"
      },
      [`${componentCls}-trigger`]: {
        position: "fixed",
        bottom: 0,
        zIndex: 1,
        height: triggerHeight,
        color: triggerColor,
        lineHeight: unit(triggerHeight),
        textAlign: "center",
        background: triggerBg,
        cursor: "pointer",
        transition: `all ${motionDurationMid}`
      },
      [`${componentCls}-zero-width-trigger`]: {
        position: "absolute",
        top: headerHeight,
        insetInlineEnd: token2.calc(zeroTriggerWidth).mul(-1).equal(),
        zIndex: 1,
        width: zeroTriggerWidth,
        height: zeroTriggerHeight,
        color: triggerColor,
        fontSize: token2.fontSizeXL,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: siderBg,
        borderRadius: `0 ${unit(borderRadiusLG)} ${unit(borderRadiusLG)} 0`,
        cursor: "pointer",
        transition: `background ${motionDurationSlow} ease`,
        "&::after": {
          position: "absolute",
          inset: 0,
          background: "transparent",
          transition: `all ${motionDurationSlow}`,
          content: '""'
        },
        "&:hover::after": {
          background: `rgba(255, 255, 255, 0.2)`
        },
        "&-right": {
          insetInlineStart: token2.calc(zeroTriggerWidth).mul(-1).equal(),
          borderRadius: `${unit(borderRadiusLG)} 0 0 ${unit(borderRadiusLG)}`
        }
      },
      // Light
      "&-light": {
        background: lightSiderBg,
        [`${componentCls}-trigger`]: {
          color: lightTriggerColor,
          background: lightTriggerBg
        },
        [`${componentCls}-zero-width-trigger`]: {
          color: lightTriggerColor,
          background: lightTriggerBg,
          border: `1px solid ${bodyBg}`,
          // Safe to modify to any other color
          borderInlineStart: 0
        }
      }
    }
  };
};
var sider_default = genStyleHooks(["Layout", "Sider"], genSiderStyle, prepareComponentToken9, {
  deprecatedTokens: DEPRECATED_TOKENS
});

// ../../node_modules/antd/es/layout/Sider.js
var __rest15 = function(s, e3) {
  var t2 = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e3.indexOf(p) < 0) t2[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e3.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t2[p[i]] = s[p[i]];
  }
  return t2;
};
var dimensionMaxMap = {
  xs: "479.98px",
  sm: "575.98px",
  md: "767.98px",
  lg: "991.98px",
  xl: "1199.98px",
  xxl: "1599.98px"
};
var isNumeric = (value) => !Number.isNaN(Number.parseFloat(value)) && isFinite(value);
var SiderContext = /* @__PURE__ */ React220.createContext({});
var generateId = /* @__PURE__ */ (() => {
  let i = 0;
  return (prefix3 = "") => {
    i += 1;
    return `${prefix3}${i}`;
  };
})();
var Sider = /* @__PURE__ */ React220.forwardRef((props, ref3) => {
  const {
    prefixCls: customizePrefixCls,
    className: className2,
    trigger: trigger2,
    children,
    defaultCollapsed = false,
    theme = "dark",
    style: style2 = {},
    collapsible = false,
    reverseArrow = false,
    width = 200,
    collapsedWidth = 80,
    zeroWidthTriggerStyle,
    breakpoint,
    onCollapse,
    onBreakpoint
  } = props, otherProps = __rest15(props, ["prefixCls", "className", "trigger", "children", "defaultCollapsed", "theme", "style", "collapsible", "reverseArrow", "width", "collapsedWidth", "zeroWidthTriggerStyle", "breakpoint", "onCollapse", "onBreakpoint"]);
  const {
    siderHook
  } = (0, import_react80.useContext)(LayoutContext);
  const [collapsed, setCollapsed] = (0, import_react80.useState)("collapsed" in props ? props.collapsed : defaultCollapsed);
  const [below, setBelow] = (0, import_react80.useState)(false);
  (0, import_react80.useEffect)(() => {
    if ("collapsed" in props) {
      setCollapsed(props.collapsed);
    }
  }, [props.collapsed]);
  const handleSetCollapsed = (value, type5) => {
    if (!("collapsed" in props)) {
      setCollapsed(value);
    }
    onCollapse === null || onCollapse === void 0 ? void 0 : onCollapse(value, type5);
  };
  const {
    getPrefixCls,
    direction
  } = (0, import_react80.useContext)(ConfigContext);
  const prefixCls = getPrefixCls("layout-sider", customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = sider_default(prefixCls);
  const responsiveHandlerRef = (0, import_react80.useRef)(null);
  responsiveHandlerRef.current = (mql) => {
    setBelow(mql.matches);
    onBreakpoint === null || onBreakpoint === void 0 ? void 0 : onBreakpoint(mql.matches);
    if (collapsed !== mql.matches) {
      handleSetCollapsed(mql.matches, "responsive");
    }
  };
  (0, import_react80.useEffect)(() => {
    function responsiveHandler(mql2) {
      var _a;
      return (_a = responsiveHandlerRef.current) === null || _a === void 0 ? void 0 : _a.call(responsiveHandlerRef, mql2);
    }
    let mql;
    if (typeof (window === null || window === void 0 ? void 0 : window.matchMedia) !== "undefined" && breakpoint && breakpoint in dimensionMaxMap) {
      mql = window.matchMedia(`screen and (max-width: ${dimensionMaxMap[breakpoint]})`);
      addMediaQueryListener(mql, responsiveHandler);
      responsiveHandler(mql);
    }
    return () => {
      removeMediaQueryListener(mql, responsiveHandler);
    };
  }, [breakpoint]);
  (0, import_react80.useEffect)(() => {
    const uniqueId = generateId("ant-sider-");
    siderHook.addSider(uniqueId);
    return () => siderHook.removeSider(uniqueId);
  }, []);
  const toggle = () => {
    handleSetCollapsed(!collapsed, "clickTrigger");
  };
  const divProps = omit(otherProps, ["collapsed"]);
  const rawWidth = collapsed ? collapsedWidth : width;
  const siderWidth = isNumeric(rawWidth) ? `${rawWidth}px` : String(rawWidth);
  const zeroWidthTrigger = parseFloat(String(collapsedWidth || 0)) === 0 ? /* @__PURE__ */ React220.createElement("span", {
    onClick: toggle,
    className: (0, import_classnames71.default)(`${prefixCls}-zero-width-trigger`, `${prefixCls}-zero-width-trigger-${reverseArrow ? "right" : "left"}`),
    style: zeroWidthTriggerStyle
  }, trigger2 || /* @__PURE__ */ React220.createElement(BarsOutlined_default2, null)) : null;
  const reverseIcon = direction === "rtl" === !reverseArrow;
  const iconObj = {
    expanded: reverseIcon ? /* @__PURE__ */ React220.createElement(RightOutlined_default2, null) : /* @__PURE__ */ React220.createElement(LeftOutlined_default2, null),
    collapsed: reverseIcon ? /* @__PURE__ */ React220.createElement(LeftOutlined_default2, null) : /* @__PURE__ */ React220.createElement(RightOutlined_default2, null)
  };
  const status = collapsed ? "collapsed" : "expanded";
  const defaultTrigger = iconObj[status];
  const triggerDom = trigger2 !== null ? zeroWidthTrigger || /* @__PURE__ */ React220.createElement("div", {
    className: `${prefixCls}-trigger`,
    onClick: toggle,
    style: {
      width: siderWidth
    }
  }, trigger2 || defaultTrigger) : null;
  const divStyle = Object.assign(Object.assign({}, style2), {
    flex: `0 0 ${siderWidth}`,
    maxWidth: siderWidth,
    minWidth: siderWidth,
    width: siderWidth
  });
  const siderCls = (0, import_classnames71.default)(prefixCls, `${prefixCls}-${theme}`, {
    [`${prefixCls}-collapsed`]: !!collapsed,
    [`${prefixCls}-has-trigger`]: collapsible && trigger2 !== null && !zeroWidthTrigger,
    [`${prefixCls}-below`]: !!below,
    [`${prefixCls}-zero-width`]: parseFloat(siderWidth) === 0
  }, className2, hashId, cssVarCls);
  const contextValue = React220.useMemo(() => ({
    siderCollapsed: collapsed
  }), [collapsed]);
  return wrapCSSVar(/* @__PURE__ */ React220.createElement(SiderContext.Provider, {
    value: contextValue
  }, /* @__PURE__ */ React220.createElement("aside", Object.assign({
    className: siderCls
  }, divProps, {
    style: divStyle,
    ref: ref3
  }), /* @__PURE__ */ React220.createElement("div", {
    className: `${prefixCls}-children`
  }, children), collapsible || below && zeroWidthTrigger ? triggerDom : null)));
});
if (true) {
  Sider.displayName = "Sider";
}

// ../../node_modules/antd/es/menu/menu.js
var React226 = __toESM(require_react());
var import_react82 = __toESM(require_react());

// ../../node_modules/@ant-design/icons/es/icons/EllipsisOutlined.js
var React221 = __toESM(require_react());

// ../../node_modules/@ant-design/icons-svg/es/asn/EllipsisOutlined.js
var EllipsisOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M176 511a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0z" } }] }, "name": "ellipsis", "theme": "outlined" };
var EllipsisOutlined_default = EllipsisOutlined;

// ../../node_modules/@ant-design/icons/es/icons/EllipsisOutlined.js
var EllipsisOutlined2 = function EllipsisOutlined3(props, ref3) {
  return /* @__PURE__ */ React221.createElement(AntdIcon_default, _extends({}, props, {
    ref: ref3,
    icon: EllipsisOutlined_default
  }));
};
var RefIcon13 = /* @__PURE__ */ React221.forwardRef(EllipsisOutlined2);
if (true) {
  RefIcon13.displayName = "EllipsisOutlined";
}
var EllipsisOutlined_default2 = RefIcon13;

// ../../node_modules/antd/es/menu/menu.js
var import_classnames75 = __toESM(require_classnames());

// ../../node_modules/antd/es/menu/MenuContext.js
var import_react81 = __toESM(require_react());
var MenuContext2 = /* @__PURE__ */ (0, import_react81.createContext)({
  prefixCls: "",
  firstLevel: true,
  inlineCollapsed: false
});
var MenuContext_default = MenuContext2;

// ../../node_modules/antd/es/menu/MenuDivider.js
var React222 = __toESM(require_react());
var import_classnames72 = __toESM(require_classnames());
var __rest16 = function(s, e3) {
  var t2 = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e3.indexOf(p) < 0) t2[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e3.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t2[p[i]] = s[p[i]];
  }
  return t2;
};
var MenuDivider = (props) => {
  const {
    prefixCls: customizePrefixCls,
    className: className2,
    dashed
  } = props, restProps = __rest16(props, ["prefixCls", "className", "dashed"]);
  const {
    getPrefixCls
  } = React222.useContext(ConfigContext);
  const prefixCls = getPrefixCls("menu", customizePrefixCls);
  const classString = (0, import_classnames72.default)({
    [`${prefixCls}-item-divider-dashed`]: !!dashed
  }, className2);
  return /* @__PURE__ */ React222.createElement(Divider, Object.assign({
    className: classString
  }, restProps));
};
var MenuDivider_default = MenuDivider;

// ../../node_modules/antd/es/menu/MenuItem.js
var React223 = __toESM(require_react());
var import_classnames73 = __toESM(require_classnames());
var MenuItem2 = (props) => {
  var _a;
  const {
    className: className2,
    children,
    icon,
    title,
    danger,
    extra
  } = props;
  const {
    prefixCls,
    firstLevel,
    direction,
    disableMenuItemTitleTooltip,
    inlineCollapsed: isInlineCollapsed
  } = React223.useContext(MenuContext_default);
  const renderItemChildren = (inlineCollapsed) => {
    const label = children === null || children === void 0 ? void 0 : children[0];
    const wrapNode = /* @__PURE__ */ React223.createElement("span", {
      className: (0, import_classnames73.default)(`${prefixCls}-title-content`, {
        [`${prefixCls}-title-content-with-extra`]: !!extra || extra === 0
      })
    }, children);
    if (!icon || /* @__PURE__ */ React223.isValidElement(children) && children.type === "span") {
      if (children && inlineCollapsed && firstLevel && typeof label === "string") {
        return /* @__PURE__ */ React223.createElement("div", {
          className: `${prefixCls}-inline-collapsed-noicon`
        }, label.charAt(0));
      }
    }
    return wrapNode;
  };
  const {
    siderCollapsed
  } = React223.useContext(SiderContext);
  let tooltipTitle = title;
  if (typeof title === "undefined") {
    tooltipTitle = firstLevel ? children : "";
  } else if (title === false) {
    tooltipTitle = "";
  }
  const tooltipProps = {
    title: tooltipTitle
  };
  if (!siderCollapsed && !isInlineCollapsed) {
    tooltipProps.title = null;
    tooltipProps.open = false;
  }
  const childrenLength = toArray(children).length;
  let returnNode = /* @__PURE__ */ React223.createElement(MenuItem_default, Object.assign({}, omit(props, ["title", "icon", "danger"]), {
    className: (0, import_classnames73.default)({
      [`${prefixCls}-item-danger`]: danger,
      [`${prefixCls}-item-only-child`]: (icon ? childrenLength + 1 : childrenLength) === 1
    }, className2),
    title: typeof title === "string" ? title : void 0
  }), cloneElement4(icon, {
    className: (0, import_classnames73.default)(/* @__PURE__ */ React223.isValidElement(icon) ? (_a = icon.props) === null || _a === void 0 ? void 0 : _a.className : void 0, `${prefixCls}-item-icon`)
  }), renderItemChildren(isInlineCollapsed));
  if (!disableMenuItemTitleTooltip) {
    returnNode = /* @__PURE__ */ React223.createElement(tooltip_default, Object.assign({}, tooltipProps, {
      placement: direction === "rtl" ? "left" : "right",
      classNames: {
        root: `${prefixCls}-inline-collapsed-tooltip`
      }
    }), returnNode);
  }
  return returnNode;
};
var MenuItem_default2 = MenuItem2;

// ../../node_modules/antd/es/menu/OverrideContext.js
var React224 = __toESM(require_react());
var __rest17 = function(s, e3) {
  var t2 = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e3.indexOf(p) < 0) t2[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e3.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t2[p[i]] = s[p[i]];
  }
  return t2;
};
var OverrideContext = /* @__PURE__ */ React224.createContext(null);
var OverrideProvider = /* @__PURE__ */ React224.forwardRef((props, ref3) => {
  const {
    children
  } = props, restProps = __rest17(props, ["children"]);
  const override = React224.useContext(OverrideContext);
  const context = React224.useMemo(() => Object.assign(Object.assign({}, override), restProps), [
    override,
    restProps.prefixCls,
    // restProps.expandIcon, Not mark as deps since this is a ReactNode
    restProps.mode,
    restProps.selectable,
    restProps.rootClassName
    // restProps.validator, Not mark as deps since this is a function
  ]);
  const canRef = supportNodeRef(children);
  const mergedRef = useComposeRef(ref3, canRef ? getNodeRef(children) : null);
  return /* @__PURE__ */ React224.createElement(OverrideContext.Provider, {
    value: context
  }, /* @__PURE__ */ React224.createElement(ContextIsolator_default, {
    space: true
  }, canRef ? /* @__PURE__ */ React224.cloneElement(children, {
    ref: mergedRef
  }) : children));
});
var OverrideContext_default = OverrideContext;

// ../../node_modules/antd/es/menu/style/horizontal.js
var getHorizontalStyle = (token2) => {
  const {
    componentCls,
    motionDurationSlow,
    horizontalLineHeight,
    colorSplit,
    lineWidth,
    lineType,
    itemPaddingInline
  } = token2;
  return {
    [`${componentCls}-horizontal`]: {
      lineHeight: horizontalLineHeight,
      border: 0,
      borderBottom: `${unit(lineWidth)} ${lineType} ${colorSplit}`,
      boxShadow: "none",
      "&::after": {
        display: "block",
        clear: "both",
        height: 0,
        content: '"\\20"'
      },
      // ======================= Item =======================
      [`${componentCls}-item, ${componentCls}-submenu`]: {
        position: "relative",
        display: "inline-block",
        verticalAlign: "bottom",
        paddingInline: itemPaddingInline
      },
      [`> ${componentCls}-item:hover,
        > ${componentCls}-item-active,
        > ${componentCls}-submenu ${componentCls}-submenu-title:hover`]: {
        backgroundColor: "transparent"
      },
      [`${componentCls}-item, ${componentCls}-submenu-title`]: {
        transition: [`border-color ${motionDurationSlow}`, `background ${motionDurationSlow}`].join(",")
      },
      // ===================== Sub Menu =====================
      [`${componentCls}-submenu-arrow`]: {
        display: "none"
      }
    }
  };
};
var horizontal_default = getHorizontalStyle;

// ../../node_modules/antd/es/menu/style/rtl.js
var getRTLStyle = ({
  componentCls,
  menuArrowOffset,
  calc
}) => ({
  [`${componentCls}-rtl`]: {
    direction: "rtl"
  },
  [`${componentCls}-submenu-rtl`]: {
    transformOrigin: "100% 0"
  },
  // Vertical Arrow
  [`${componentCls}-rtl${componentCls}-vertical,
    ${componentCls}-submenu-rtl ${componentCls}-vertical`]: {
    [`${componentCls}-submenu-arrow`]: {
      "&::before": {
        transform: `rotate(-45deg) translateY(${unit(calc(menuArrowOffset).mul(-1).equal())})`
      },
      "&::after": {
        transform: `rotate(45deg) translateY(${unit(menuArrowOffset)})`
      }
    }
  }
});
var rtl_default = getRTLStyle;

// ../../node_modules/antd/es/menu/style/theme.js
var accessibilityFocus = (token2) => genFocusOutline(token2);
var getThemeStyle = (token2, themeSuffix) => {
  const {
    componentCls,
    itemColor,
    itemSelectedColor,
    subMenuItemSelectedColor,
    groupTitleColor,
    itemBg,
    subMenuItemBg,
    itemSelectedBg,
    activeBarHeight,
    activeBarWidth,
    activeBarBorderWidth,
    motionDurationSlow,
    motionEaseInOut,
    motionEaseOut,
    itemPaddingInline,
    motionDurationMid,
    itemHoverColor,
    lineType,
    colorSplit,
    // Disabled
    itemDisabledColor,
    // Danger
    dangerItemColor,
    dangerItemHoverColor,
    dangerItemSelectedColor,
    dangerItemActiveBg,
    dangerItemSelectedBg,
    // Bg
    popupBg,
    itemHoverBg,
    itemActiveBg,
    menuSubMenuBg,
    // Horizontal
    horizontalItemSelectedColor,
    horizontalItemSelectedBg,
    horizontalItemBorderRadius,
    horizontalItemHoverBg
  } = token2;
  return {
    [`${componentCls}-${themeSuffix}, ${componentCls}-${themeSuffix} > ${componentCls}`]: {
      color: itemColor,
      background: itemBg,
      [`&${componentCls}-root:focus-visible`]: Object.assign({}, accessibilityFocus(token2)),
      // ======================== Item ========================
      [`${componentCls}-item`]: {
        "&-group-title, &-extra": {
          color: groupTitleColor
        }
      },
      [`${componentCls}-submenu-selected > ${componentCls}-submenu-title`]: {
        color: subMenuItemSelectedColor
      },
      [`${componentCls}-item, ${componentCls}-submenu-title`]: {
        color: itemColor,
        [`&:not(${componentCls}-item-disabled):focus-visible`]: Object.assign({}, accessibilityFocus(token2))
      },
      // Disabled
      [`${componentCls}-item-disabled, ${componentCls}-submenu-disabled`]: {
        color: `${itemDisabledColor} !important`
      },
      // Hover
      [`${componentCls}-item:not(${componentCls}-item-selected):not(${componentCls}-submenu-selected)`]: {
        [`&:hover, > ${componentCls}-submenu-title:hover`]: {
          color: itemHoverColor
        }
      },
      [`&:not(${componentCls}-horizontal)`]: {
        [`${componentCls}-item:not(${componentCls}-item-selected)`]: {
          "&:hover": {
            backgroundColor: itemHoverBg
          },
          "&:active": {
            backgroundColor: itemActiveBg
          }
        },
        [`${componentCls}-submenu-title`]: {
          "&:hover": {
            backgroundColor: itemHoverBg
          },
          "&:active": {
            backgroundColor: itemActiveBg
          }
        }
      },
      // Danger - only Item has
      [`${componentCls}-item-danger`]: {
        color: dangerItemColor,
        [`&${componentCls}-item:hover`]: {
          [`&:not(${componentCls}-item-selected):not(${componentCls}-submenu-selected)`]: {
            color: dangerItemHoverColor
          }
        },
        [`&${componentCls}-item:active`]: {
          background: dangerItemActiveBg
        }
      },
      [`${componentCls}-item a`]: {
        "&, &:hover": {
          color: "inherit"
        }
      },
      [`${componentCls}-item-selected`]: {
        color: itemSelectedColor,
        // Danger
        [`&${componentCls}-item-danger`]: {
          color: dangerItemSelectedColor
        },
        "a, a:hover": {
          color: "inherit"
        }
      },
      [`& ${componentCls}-item-selected`]: {
        backgroundColor: itemSelectedBg,
        // Danger
        [`&${componentCls}-item-danger`]: {
          backgroundColor: dangerItemSelectedBg
        }
      },
      [`&${componentCls}-submenu > ${componentCls}`]: {
        backgroundColor: menuSubMenuBg
      },
      // ===== 设置浮层的颜色 =======
      // ！dark 模式会被popupBg 会被rest 为 darkPopupBg
      [`&${componentCls}-popup > ${componentCls}`]: {
        backgroundColor: popupBg
      },
      [`&${componentCls}-submenu-popup > ${componentCls}`]: {
        backgroundColor: popupBg
      },
      // ===== 设置浮层的颜色 end =======
      // ====================== Horizontal ======================
      [`&${componentCls}-horizontal`]: Object.assign(Object.assign({}, themeSuffix === "dark" ? {
        borderBottom: 0
      } : {}), {
        [`> ${componentCls}-item, > ${componentCls}-submenu`]: {
          top: activeBarBorderWidth,
          marginTop: token2.calc(activeBarBorderWidth).mul(-1).equal(),
          marginBottom: 0,
          borderRadius: horizontalItemBorderRadius,
          "&::after": {
            position: "absolute",
            insetInline: itemPaddingInline,
            bottom: 0,
            borderBottom: `${unit(activeBarHeight)} solid transparent`,
            transition: `border-color ${motionDurationSlow} ${motionEaseInOut}`,
            content: '""'
          },
          "&:hover, &-active, &-open": {
            background: horizontalItemHoverBg,
            "&::after": {
              borderBottomWidth: activeBarHeight,
              borderBottomColor: horizontalItemSelectedColor
            }
          },
          "&-selected": {
            color: horizontalItemSelectedColor,
            backgroundColor: horizontalItemSelectedBg,
            "&:hover": {
              backgroundColor: horizontalItemSelectedBg
            },
            "&::after": {
              borderBottomWidth: activeBarHeight,
              borderBottomColor: horizontalItemSelectedColor
            }
          }
        }
      }),
      // ================== Inline & Vertical ===================
      //
      [`&${componentCls}-root`]: {
        [`&${componentCls}-inline, &${componentCls}-vertical`]: {
          borderInlineEnd: `${unit(activeBarBorderWidth)} ${lineType} ${colorSplit}`
        }
      },
      // ======================== Inline ========================
      [`&${componentCls}-inline`]: {
        // Sub
        [`${componentCls}-sub${componentCls}-inline`]: {
          background: subMenuItemBg
        },
        [`${componentCls}-item`]: {
          position: "relative",
          "&::after": {
            position: "absolute",
            insetBlock: 0,
            insetInlineEnd: 0,
            borderInlineEnd: `${unit(activeBarWidth)} solid ${itemSelectedColor}`,
            transform: "scaleY(0.0001)",
            opacity: 0,
            transition: [`transform ${motionDurationMid} ${motionEaseOut}`, `opacity ${motionDurationMid} ${motionEaseOut}`].join(","),
            content: '""'
          },
          // Danger
          [`&${componentCls}-item-danger`]: {
            "&::after": {
              borderInlineEndColor: dangerItemSelectedColor
            }
          }
        },
        [`${componentCls}-selected, ${componentCls}-item-selected`]: {
          "&::after": {
            transform: "scaleY(1)",
            opacity: 1,
            transition: [`transform ${motionDurationMid} ${motionEaseInOut}`, `opacity ${motionDurationMid} ${motionEaseInOut}`].join(",")
          }
        }
      }
    }
  };
};
var theme_default2 = getThemeStyle;

// ../../node_modules/antd/es/menu/style/vertical.js
var getVerticalInlineStyle = (token2) => {
  const {
    componentCls,
    itemHeight,
    itemMarginInline,
    padding,
    menuArrowSize,
    marginXS,
    itemMarginBlock,
    itemWidth,
    itemPaddingInline
  } = token2;
  const paddingWithArrow = token2.calc(menuArrowSize).add(padding).add(marginXS).equal();
  return {
    [`${componentCls}-item`]: {
      position: "relative",
      overflow: "hidden"
    },
    [`${componentCls}-item, ${componentCls}-submenu-title`]: {
      height: itemHeight,
      lineHeight: unit(itemHeight),
      paddingInline: itemPaddingInline,
      overflow: "hidden",
      textOverflow: "ellipsis",
      marginInline: itemMarginInline,
      marginBlock: itemMarginBlock,
      width: itemWidth
    },
    [`> ${componentCls}-item,
            > ${componentCls}-submenu > ${componentCls}-submenu-title`]: {
      height: itemHeight,
      lineHeight: unit(itemHeight)
    },
    [`${componentCls}-item-group-list ${componentCls}-submenu-title,
            ${componentCls}-submenu-title`]: {
      paddingInlineEnd: paddingWithArrow
    }
  };
};
var getVerticalStyle = (token2) => {
  const {
    componentCls,
    iconCls,
    itemHeight,
    colorTextLightSolid,
    dropdownWidth,
    controlHeightLG,
    motionEaseOut,
    paddingXL,
    itemMarginInline,
    fontSizeLG,
    motionDurationFast,
    motionDurationSlow,
    paddingXS,
    boxShadowSecondary,
    collapsedWidth,
    collapsedIconSize
  } = token2;
  const inlineItemStyle = {
    height: itemHeight,
    lineHeight: unit(itemHeight),
    listStylePosition: "inside",
    listStyleType: "disc"
  };
  return [
    {
      [componentCls]: {
        "&-inline, &-vertical": Object.assign({
          [`&${componentCls}-root`]: {
            boxShadow: "none"
          }
        }, getVerticalInlineStyle(token2))
      },
      [`${componentCls}-submenu-popup`]: {
        [`${componentCls}-vertical`]: Object.assign(Object.assign({}, getVerticalInlineStyle(token2)), {
          boxShadow: boxShadowSecondary
        })
      }
    },
    // Vertical only
    {
      [`${componentCls}-submenu-popup ${componentCls}-vertical${componentCls}-sub`]: {
        minWidth: dropdownWidth,
        maxHeight: `calc(100vh - ${unit(token2.calc(controlHeightLG).mul(2.5).equal())})`,
        padding: "0",
        overflow: "hidden",
        borderInlineEnd: 0,
        // https://github.com/ant-design/ant-design/issues/22244
        // https://github.com/ant-design/ant-design/issues/26812
        "&:not([class*='-active'])": {
          overflowX: "hidden",
          overflowY: "auto"
        }
      }
    },
    // Inline Only
    {
      [`${componentCls}-inline`]: {
        width: "100%",
        // Motion enhance for first level
        [`&${componentCls}-root`]: {
          [`${componentCls}-item, ${componentCls}-submenu-title`]: {
            display: "flex",
            alignItems: "center",
            transition: [`border-color ${motionDurationSlow}`, `background ${motionDurationSlow}`, `padding ${motionDurationFast} ${motionEaseOut}`].join(","),
            [`> ${componentCls}-title-content`]: {
              flex: "auto",
              minWidth: 0,
              overflow: "hidden",
              textOverflow: "ellipsis"
            },
            "> *": {
              flex: "none"
            }
          }
        },
        // >>>>> Sub
        [`${componentCls}-sub${componentCls}-inline`]: {
          padding: 0,
          border: 0,
          borderRadius: 0,
          boxShadow: "none",
          [`& > ${componentCls}-submenu > ${componentCls}-submenu-title`]: inlineItemStyle,
          [`& ${componentCls}-item-group-title`]: {
            paddingInlineStart: paddingXL
          }
        },
        // >>>>> Item
        [`${componentCls}-item`]: inlineItemStyle
      }
    },
    // Inline Collapse Only
    {
      [`${componentCls}-inline-collapsed`]: {
        width: collapsedWidth,
        [`&${componentCls}-root`]: {
          [`${componentCls}-item, ${componentCls}-submenu ${componentCls}-submenu-title`]: {
            [`> ${componentCls}-inline-collapsed-noicon`]: {
              fontSize: fontSizeLG,
              textAlign: "center"
            }
          }
        },
        [`> ${componentCls}-item,
          > ${componentCls}-item-group > ${componentCls}-item-group-list > ${componentCls}-item,
          > ${componentCls}-item-group > ${componentCls}-item-group-list > ${componentCls}-submenu > ${componentCls}-submenu-title,
          > ${componentCls}-submenu > ${componentCls}-submenu-title`]: {
          insetInlineStart: 0,
          paddingInline: `calc(50% - ${unit(token2.calc(collapsedIconSize).div(2).equal())} - ${unit(itemMarginInline)})`,
          textOverflow: "clip",
          [`
            ${componentCls}-submenu-arrow,
            ${componentCls}-submenu-expand-icon
          `]: {
            opacity: 0
          },
          [`${componentCls}-item-icon, ${iconCls}`]: {
            margin: 0,
            fontSize: collapsedIconSize,
            lineHeight: unit(itemHeight),
            "+ span": {
              display: "inline-block",
              opacity: 0
            }
          }
        },
        [`${componentCls}-item-icon, ${iconCls}`]: {
          display: "inline-block"
        },
        "&-tooltip": {
          pointerEvents: "none",
          [`${componentCls}-item-icon, ${iconCls}`]: {
            display: "none"
          },
          "a, a:hover": {
            color: colorTextLightSolid
          }
        },
        [`${componentCls}-item-group-title`]: Object.assign(Object.assign({}, textEllipsis), {
          paddingInline: paddingXS
        })
      }
    }
  ];
};
var vertical_default = getVerticalStyle;

// ../../node_modules/antd/es/menu/style/index.js
var genMenuItemStyle = (token2) => {
  const {
    componentCls,
    motionDurationSlow,
    motionDurationMid,
    motionEaseInOut,
    motionEaseOut,
    iconCls,
    iconSize,
    iconMarginInlineEnd
  } = token2;
  return {
    // >>>>> Item
    [`${componentCls}-item, ${componentCls}-submenu-title`]: {
      position: "relative",
      display: "block",
      margin: 0,
      whiteSpace: "nowrap",
      cursor: "pointer",
      transition: [`border-color ${motionDurationSlow}`, `background ${motionDurationSlow}`, `padding calc(${motionDurationSlow} + 0.1s) ${motionEaseInOut}`].join(","),
      [`${componentCls}-item-icon, ${iconCls}`]: {
        minWidth: iconSize,
        fontSize: iconSize,
        transition: [`font-size ${motionDurationMid} ${motionEaseOut}`, `margin ${motionDurationSlow} ${motionEaseInOut}`, `color ${motionDurationSlow}`].join(","),
        "+ span": {
          marginInlineStart: iconMarginInlineEnd,
          opacity: 1,
          transition: [`opacity ${motionDurationSlow} ${motionEaseInOut}`, `margin ${motionDurationSlow}`, `color ${motionDurationSlow}`].join(",")
        }
      },
      [`${componentCls}-item-icon`]: Object.assign({}, resetIcon()),
      [`&${componentCls}-item-only-child`]: {
        [`> ${iconCls}, > ${componentCls}-item-icon`]: {
          marginInlineEnd: 0
        }
      }
    },
    // Disabled state sets text to gray and nukes hover/tab effects
    [`${componentCls}-item-disabled, ${componentCls}-submenu-disabled`]: {
      background: "none !important",
      cursor: "not-allowed",
      "&::after": {
        borderColor: "transparent !important"
      },
      a: {
        color: "inherit !important",
        cursor: "not-allowed",
        pointerEvents: "none"
      },
      [`> ${componentCls}-submenu-title`]: {
        color: "inherit !important",
        cursor: "not-allowed"
      }
    }
  };
};
var genSubMenuArrowStyle = (token2) => {
  const {
    componentCls,
    motionDurationSlow,
    motionEaseInOut,
    borderRadius,
    menuArrowSize,
    menuArrowOffset
  } = token2;
  return {
    [`${componentCls}-submenu`]: {
      "&-expand-icon, &-arrow": {
        position: "absolute",
        top: "50%",
        insetInlineEnd: token2.margin,
        width: menuArrowSize,
        color: "currentcolor",
        transform: "translateY(-50%)",
        transition: `transform ${motionDurationSlow} ${motionEaseInOut}, opacity ${motionDurationSlow}`
      },
      "&-arrow": {
        // →
        "&::before, &::after": {
          position: "absolute",
          width: token2.calc(menuArrowSize).mul(0.6).equal(),
          height: token2.calc(menuArrowSize).mul(0.15).equal(),
          backgroundColor: "currentcolor",
          borderRadius,
          transition: [`background ${motionDurationSlow} ${motionEaseInOut}`, `transform ${motionDurationSlow} ${motionEaseInOut}`, `top ${motionDurationSlow} ${motionEaseInOut}`, `color ${motionDurationSlow} ${motionEaseInOut}`].join(","),
          content: '""'
        },
        "&::before": {
          transform: `rotate(45deg) translateY(${unit(token2.calc(menuArrowOffset).mul(-1).equal())})`
        },
        "&::after": {
          transform: `rotate(-45deg) translateY(${unit(menuArrowOffset)})`
        }
      }
    }
  };
};
var getBaseStyle = (token2) => {
  const {
    antCls,
    componentCls,
    fontSize,
    motionDurationSlow,
    motionDurationMid,
    motionEaseInOut,
    paddingXS,
    padding,
    colorSplit,
    lineWidth,
    zIndexPopup,
    borderRadiusLG,
    subMenuItemBorderRadius,
    menuArrowSize,
    menuArrowOffset,
    lineType,
    groupTitleLineHeight,
    groupTitleFontSize
  } = token2;
  return [
    // Misc
    {
      "": {
        [componentCls]: Object.assign(Object.assign({}, clearFix()), {
          // Hidden
          "&-hidden": {
            display: "none"
          }
        })
      },
      [`${componentCls}-submenu-hidden`]: {
        display: "none"
      }
    },
    {
      [componentCls]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, resetComponent(token2)), clearFix()), {
        marginBottom: 0,
        paddingInlineStart: 0,
        // Override default ul/ol
        fontSize,
        lineHeight: 0,
        listStyle: "none",
        outline: "none",
        // Magic cubic here but smooth transition
        transition: `width ${motionDurationSlow} cubic-bezier(0.2, 0, 0, 1) 0s`,
        "ul, ol": {
          margin: 0,
          padding: 0,
          listStyle: "none"
        },
        // Overflow ellipsis
        "&-overflow": {
          display: "flex",
          [`${componentCls}-item`]: {
            flex: "none"
          }
        },
        [`${componentCls}-item, ${componentCls}-submenu, ${componentCls}-submenu-title`]: {
          borderRadius: token2.itemBorderRadius
        },
        [`${componentCls}-item-group-title`]: {
          padding: `${unit(paddingXS)} ${unit(padding)}`,
          fontSize: groupTitleFontSize,
          lineHeight: groupTitleLineHeight,
          transition: `all ${motionDurationSlow}`
        },
        [`&-horizontal ${componentCls}-submenu`]: {
          transition: [`border-color ${motionDurationSlow} ${motionEaseInOut}`, `background ${motionDurationSlow} ${motionEaseInOut}`].join(",")
        },
        [`${componentCls}-submenu, ${componentCls}-submenu-inline`]: {
          transition: [`border-color ${motionDurationSlow} ${motionEaseInOut}`, `background ${motionDurationSlow} ${motionEaseInOut}`, `padding ${motionDurationMid} ${motionEaseInOut}`].join(",")
        },
        [`${componentCls}-submenu ${componentCls}-sub`]: {
          cursor: "initial",
          transition: [`background ${motionDurationSlow} ${motionEaseInOut}`, `padding ${motionDurationSlow} ${motionEaseInOut}`].join(",")
        },
        [`${componentCls}-title-content`]: {
          transition: `color ${motionDurationSlow}`,
          "&-with-extra": {
            display: "inline-flex",
            alignItems: "center",
            width: "100%"
          },
          // https://github.com/ant-design/ant-design/issues/41143
          [`> ${antCls}-typography-ellipsis-single-line`]: {
            display: "inline",
            verticalAlign: "unset"
          },
          [`${componentCls}-item-extra`]: {
            marginInlineStart: "auto",
            paddingInlineStart: token2.padding
          }
        },
        [`${componentCls}-item a`]: {
          "&::before": {
            position: "absolute",
            inset: 0,
            backgroundColor: "transparent",
            content: '""'
          }
        },
        // Removed a Badge related style seems it's safe
        // https://github.com/ant-design/ant-design/issues/19809
        // >>>>> Divider
        [`${componentCls}-item-divider`]: {
          overflow: "hidden",
          lineHeight: 0,
          borderColor: colorSplit,
          borderStyle: lineType,
          borderWidth: 0,
          borderTopWidth: lineWidth,
          marginBlock: lineWidth,
          padding: 0,
          "&-dashed": {
            borderStyle: "dashed"
          }
        }
      }), genMenuItemStyle(token2)), {
        [`${componentCls}-item-group`]: {
          [`${componentCls}-item-group-list`]: {
            margin: 0,
            padding: 0,
            [`${componentCls}-item, ${componentCls}-submenu-title`]: {
              paddingInline: `${unit(token2.calc(fontSize).mul(2).equal())} ${unit(padding)}`
            }
          }
        },
        // ======================= Sub Menu =======================
        "&-submenu": {
          "&-popup": {
            position: "absolute",
            zIndex: zIndexPopup,
            borderRadius: borderRadiusLG,
            boxShadow: "none",
            transformOrigin: "0 0",
            [`&${componentCls}-submenu`]: {
              background: "transparent"
            },
            // https://github.com/ant-design/ant-design/issues/13955
            "&::before": {
              position: "absolute",
              inset: 0,
              zIndex: -1,
              width: "100%",
              height: "100%",
              opacity: 0,
              content: '""'
            },
            [`> ${componentCls}`]: Object.assign(Object.assign(Object.assign({
              borderRadius: borderRadiusLG
            }, genMenuItemStyle(token2)), genSubMenuArrowStyle(token2)), {
              [`${componentCls}-item, ${componentCls}-submenu > ${componentCls}-submenu-title`]: {
                borderRadius: subMenuItemBorderRadius
              },
              [`${componentCls}-submenu-title::after`]: {
                transition: `transform ${motionDurationSlow} ${motionEaseInOut}`
              }
            })
          },
          [`
          &-placement-leftTop,
          &-placement-bottomRight,
          `]: {
            transformOrigin: "100% 0"
          },
          [`
          &-placement-leftBottom,
          &-placement-topRight,
          `]: {
            transformOrigin: "100% 100%"
          },
          [`
          &-placement-rightBottom,
          &-placement-topLeft,
          `]: {
            transformOrigin: "0 100%"
          },
          [`
          &-placement-bottomLeft,
          &-placement-rightTop,
          `]: {
            transformOrigin: "0 0"
          },
          [`
          &-placement-leftTop,
          &-placement-leftBottom
          `]: {
            paddingInlineEnd: token2.paddingXS
          },
          [`
          &-placement-rightTop,
          &-placement-rightBottom
          `]: {
            paddingInlineStart: token2.paddingXS
          },
          [`
          &-placement-topRight,
          &-placement-topLeft
          `]: {
            paddingBottom: token2.paddingXS
          },
          [`
          &-placement-bottomRight,
          &-placement-bottomLeft
          `]: {
            paddingTop: token2.paddingXS
          }
        }
      }), genSubMenuArrowStyle(token2)), {
        [`&-inline-collapsed ${componentCls}-submenu-arrow,
        &-inline ${componentCls}-submenu-arrow`]: {
          // ↓
          "&::before": {
            transform: `rotate(-45deg) translateX(${unit(menuArrowOffset)})`
          },
          "&::after": {
            transform: `rotate(45deg) translateX(${unit(token2.calc(menuArrowOffset).mul(-1).equal())})`
          }
        },
        [`${componentCls}-submenu-open${componentCls}-submenu-inline > ${componentCls}-submenu-title > ${componentCls}-submenu-arrow`]: {
          // ↑
          transform: `translateY(${unit(token2.calc(menuArrowSize).mul(0.2).mul(-1).equal())})`,
          "&::after": {
            transform: `rotate(-45deg) translateX(${unit(token2.calc(menuArrowOffset).mul(-1).equal())})`
          },
          "&::before": {
            transform: `rotate(45deg) translateX(${unit(menuArrowOffset)})`
          }
        }
      })
    },
    // Integration with header element so menu items have the same height
    {
      [`${antCls}-layout-header`]: {
        [componentCls]: {
          lineHeight: "inherit"
        }
      }
    }
  ];
};
var prepareComponentToken10 = (token2) => {
  var _a, _b, _c;
  const {
    colorPrimary,
    colorError,
    colorTextDisabled,
    colorErrorBg,
    colorText,
    colorTextDescription,
    colorBgContainer,
    colorFillAlter,
    colorFillContent,
    lineWidth,
    lineWidthBold,
    controlItemBgActive,
    colorBgTextHover,
    controlHeightLG,
    lineHeight,
    colorBgElevated,
    marginXXS,
    padding,
    fontSize,
    controlHeightSM,
    fontSizeLG,
    colorTextLightSolid,
    colorErrorHover
  } = token2;
  const activeBarWidth = (_a = token2.activeBarWidth) !== null && _a !== void 0 ? _a : 0;
  const activeBarBorderWidth = (_b = token2.activeBarBorderWidth) !== null && _b !== void 0 ? _b : lineWidth;
  const itemMarginInline = (_c = token2.itemMarginInline) !== null && _c !== void 0 ? _c : token2.marginXXS;
  const colorTextDark = new FastColor(colorTextLightSolid).setA(0.65).toRgbString();
  return {
    dropdownWidth: 160,
    zIndexPopup: token2.zIndexPopupBase + 50,
    radiusItem: token2.borderRadiusLG,
    itemBorderRadius: token2.borderRadiusLG,
    radiusSubMenuItem: token2.borderRadiusSM,
    subMenuItemBorderRadius: token2.borderRadiusSM,
    colorItemText: colorText,
    itemColor: colorText,
    colorItemTextHover: colorText,
    itemHoverColor: colorText,
    colorItemTextHoverHorizontal: colorPrimary,
    horizontalItemHoverColor: colorPrimary,
    colorGroupTitle: colorTextDescription,
    groupTitleColor: colorTextDescription,
    colorItemTextSelected: colorPrimary,
    itemSelectedColor: colorPrimary,
    subMenuItemSelectedColor: colorPrimary,
    colorItemTextSelectedHorizontal: colorPrimary,
    horizontalItemSelectedColor: colorPrimary,
    colorItemBg: colorBgContainer,
    itemBg: colorBgContainer,
    colorItemBgHover: colorBgTextHover,
    itemHoverBg: colorBgTextHover,
    colorItemBgActive: colorFillContent,
    itemActiveBg: controlItemBgActive,
    colorSubItemBg: colorFillAlter,
    subMenuItemBg: colorFillAlter,
    colorItemBgSelected: controlItemBgActive,
    itemSelectedBg: controlItemBgActive,
    colorItemBgSelectedHorizontal: "transparent",
    horizontalItemSelectedBg: "transparent",
    colorActiveBarWidth: 0,
    activeBarWidth,
    colorActiveBarHeight: lineWidthBold,
    activeBarHeight: lineWidthBold,
    colorActiveBarBorderSize: lineWidth,
    activeBarBorderWidth,
    // Disabled
    colorItemTextDisabled: colorTextDisabled,
    itemDisabledColor: colorTextDisabled,
    // Danger
    colorDangerItemText: colorError,
    dangerItemColor: colorError,
    colorDangerItemTextHover: colorError,
    dangerItemHoverColor: colorError,
    colorDangerItemTextSelected: colorError,
    dangerItemSelectedColor: colorError,
    colorDangerItemBgActive: colorErrorBg,
    dangerItemActiveBg: colorErrorBg,
    colorDangerItemBgSelected: colorErrorBg,
    dangerItemSelectedBg: colorErrorBg,
    itemMarginInline,
    horizontalItemBorderRadius: 0,
    horizontalItemHoverBg: "transparent",
    itemHeight: controlHeightLG,
    groupTitleLineHeight: lineHeight,
    collapsedWidth: controlHeightLG * 2,
    popupBg: colorBgElevated,
    itemMarginBlock: marginXXS,
    itemPaddingInline: padding,
    horizontalLineHeight: `${controlHeightLG * 1.15}px`,
    iconSize: fontSize,
    iconMarginInlineEnd: controlHeightSM - fontSize,
    collapsedIconSize: fontSizeLG,
    groupTitleFontSize: fontSize,
    // Disabled
    darkItemDisabledColor: new FastColor(colorTextLightSolid).setA(0.25).toRgbString(),
    // Dark
    darkItemColor: colorTextDark,
    darkDangerItemColor: colorError,
    darkItemBg: "#001529",
    darkPopupBg: "#001529",
    darkSubMenuItemBg: "#000c17",
    darkItemSelectedColor: colorTextLightSolid,
    darkItemSelectedBg: colorPrimary,
    darkDangerItemSelectedBg: colorError,
    darkItemHoverBg: "transparent",
    darkGroupTitleColor: colorTextDark,
    darkItemHoverColor: colorTextLightSolid,
    darkDangerItemHoverColor: colorErrorHover,
    darkDangerItemSelectedColor: colorTextLightSolid,
    darkDangerItemActiveBg: colorError,
    // internal
    itemWidth: activeBarWidth ? `calc(100% + ${activeBarBorderWidth}px)` : `calc(100% - ${itemMarginInline * 2}px)`
  };
};
var style_default13 = (prefixCls, rootCls = prefixCls, injectStyle2 = true) => {
  const useStyle = genStyleHooks("Menu", (token2) => {
    const {
      colorBgElevated,
      controlHeightLG,
      fontSize,
      darkItemColor,
      darkDangerItemColor,
      darkItemBg,
      darkSubMenuItemBg,
      darkItemSelectedColor,
      darkItemSelectedBg,
      darkDangerItemSelectedBg,
      darkItemHoverBg,
      darkGroupTitleColor,
      darkItemHoverColor,
      darkItemDisabledColor,
      darkDangerItemHoverColor,
      darkDangerItemSelectedColor,
      darkDangerItemActiveBg,
      popupBg,
      darkPopupBg
    } = token2;
    const menuArrowSize = token2.calc(fontSize).div(7).mul(5).equal();
    const menuToken = merge2(token2, {
      menuArrowSize,
      menuHorizontalHeight: token2.calc(controlHeightLG).mul(1.15).equal(),
      menuArrowOffset: token2.calc(menuArrowSize).mul(0.25).equal(),
      menuSubMenuBg: colorBgElevated,
      calc: token2.calc,
      popupBg
    });
    const menuDarkToken = merge2(menuToken, {
      itemColor: darkItemColor,
      itemHoverColor: darkItemHoverColor,
      groupTitleColor: darkGroupTitleColor,
      itemSelectedColor: darkItemSelectedColor,
      subMenuItemSelectedColor: darkItemSelectedColor,
      itemBg: darkItemBg,
      popupBg: darkPopupBg,
      subMenuItemBg: darkSubMenuItemBg,
      itemActiveBg: "transparent",
      itemSelectedBg: darkItemSelectedBg,
      activeBarHeight: 0,
      activeBarBorderWidth: 0,
      itemHoverBg: darkItemHoverBg,
      // Disabled
      itemDisabledColor: darkItemDisabledColor,
      // Danger
      dangerItemColor: darkDangerItemColor,
      dangerItemHoverColor: darkDangerItemHoverColor,
      dangerItemSelectedColor: darkDangerItemSelectedColor,
      dangerItemActiveBg: darkDangerItemActiveBg,
      dangerItemSelectedBg: darkDangerItemSelectedBg,
      menuSubMenuBg: darkSubMenuItemBg,
      // Horizontal
      horizontalItemSelectedColor: darkItemSelectedColor,
      horizontalItemSelectedBg: darkItemSelectedBg
    });
    return [
      // Basic
      getBaseStyle(menuToken),
      // Horizontal
      horizontal_default(menuToken),
      // Hard code for some light style
      // Vertical
      vertical_default(menuToken),
      // Hard code for some light style
      // Theme
      theme_default2(menuToken, "light"),
      theme_default2(menuDarkToken, "dark"),
      // RTL
      rtl_default(menuToken),
      // Motion
      collapse_default(menuToken),
      initSlideMotion(menuToken, "slide-up"),
      initSlideMotion(menuToken, "slide-down"),
      initZoomMotion(menuToken, "zoom-big")
    ];
  }, prepareComponentToken10, {
    deprecatedTokens: [["colorGroupTitle", "groupTitleColor"], ["radiusItem", "itemBorderRadius"], ["radiusSubMenuItem", "subMenuItemBorderRadius"], ["colorItemText", "itemColor"], ["colorItemTextHover", "itemHoverColor"], ["colorItemTextHoverHorizontal", "horizontalItemHoverColor"], ["colorItemTextSelected", "itemSelectedColor"], ["colorItemTextSelectedHorizontal", "horizontalItemSelectedColor"], ["colorItemTextDisabled", "itemDisabledColor"], ["colorDangerItemText", "dangerItemColor"], ["colorDangerItemTextHover", "dangerItemHoverColor"], ["colorDangerItemTextSelected", "dangerItemSelectedColor"], ["colorDangerItemBgActive", "dangerItemActiveBg"], ["colorDangerItemBgSelected", "dangerItemSelectedBg"], ["colorItemBg", "itemBg"], ["colorItemBgHover", "itemHoverBg"], ["colorSubItemBg", "subMenuItemBg"], ["colorItemBgActive", "itemActiveBg"], ["colorItemBgSelectedHorizontal", "horizontalItemSelectedBg"], ["colorActiveBarWidth", "activeBarWidth"], ["colorActiveBarHeight", "activeBarHeight"], ["colorActiveBarBorderSize", "activeBarBorderWidth"], ["colorItemBgSelected", "itemSelectedBg"]],
    // Dropdown will handle menu style self. We do not need to handle this.
    injectStyle: injectStyle2,
    unitless: {
      groupTitleLineHeight: true
    }
  });
  return useStyle(prefixCls, rootCls);
};

// ../../node_modules/antd/es/menu/SubMenu.js
var React225 = __toESM(require_react());
var import_classnames74 = __toESM(require_classnames());
var SubMenu2 = (props) => {
  var _a;
  const {
    popupClassName,
    icon,
    title,
    theme: customTheme
  } = props;
  const context = React225.useContext(MenuContext_default);
  const {
    prefixCls,
    inlineCollapsed,
    theme: contextTheme
  } = context;
  const parentPath = useFullPath();
  let titleNode;
  if (!icon) {
    titleNode = inlineCollapsed && !parentPath.length && title && typeof title === "string" ? /* @__PURE__ */ React225.createElement("div", {
      className: `${prefixCls}-inline-collapsed-noicon`
    }, title.charAt(0)) : /* @__PURE__ */ React225.createElement("span", {
      className: `${prefixCls}-title-content`
    }, title);
  } else {
    const titleIsSpan = /* @__PURE__ */ React225.isValidElement(title) && title.type === "span";
    titleNode = /* @__PURE__ */ React225.createElement(React225.Fragment, null, cloneElement4(icon, {
      className: (0, import_classnames74.default)(/* @__PURE__ */ React225.isValidElement(icon) ? (_a = icon.props) === null || _a === void 0 ? void 0 : _a.className : void 0, `${prefixCls}-item-icon`)
    }), titleIsSpan ? title : /* @__PURE__ */ React225.createElement("span", {
      className: `${prefixCls}-title-content`
    }, title));
  }
  const contextValue = React225.useMemo(() => Object.assign(Object.assign({}, context), {
    firstLevel: false
  }), [context]);
  const [zIndex] = useZIndex("Menu");
  return /* @__PURE__ */ React225.createElement(MenuContext_default.Provider, {
    value: contextValue
  }, /* @__PURE__ */ React225.createElement(SubMenu_default, Object.assign({}, omit(props, ["icon"]), {
    title: titleNode,
    popupClassName: (0, import_classnames74.default)(prefixCls, popupClassName, `${prefixCls}-${customTheme || contextTheme}`),
    popupStyle: Object.assign({
      zIndex
    }, props.popupStyle)
  })));
};
var SubMenu_default2 = SubMenu2;

// ../../node_modules/antd/es/menu/menu.js
var __rest18 = function(s, e3) {
  var t2 = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e3.indexOf(p) < 0) t2[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e3.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t2[p[i]] = s[p[i]];
  }
  return t2;
};
function isEmptyIcon(icon) {
  return icon === null || icon === false;
}
var MENU_COMPONENTS = {
  item: MenuItem_default2,
  submenu: SubMenu_default2,
  divider: MenuDivider_default
};
var InternalMenu = /* @__PURE__ */ (0, import_react82.forwardRef)((props, ref3) => {
  var _a;
  const override = React226.useContext(OverrideContext_default);
  const overrideObj = override || {};
  const {
    getPrefixCls,
    getPopupContainer,
    direction,
    menu
  } = React226.useContext(ConfigContext);
  const rootPrefixCls = getPrefixCls();
  const {
    prefixCls: customizePrefixCls,
    className: className2,
    style: style2,
    theme = "light",
    expandIcon,
    _internalDisableMenuItemTitleTooltip,
    inlineCollapsed,
    siderCollapsed,
    rootClassName,
    mode,
    selectable,
    onClick,
    overflowedIndicatorPopupClassName
  } = props, restProps = __rest18(props, ["prefixCls", "className", "style", "theme", "expandIcon", "_internalDisableMenuItemTitleTooltip", "inlineCollapsed", "siderCollapsed", "rootClassName", "mode", "selectable", "onClick", "overflowedIndicatorPopupClassName"]);
  const passedProps = omit(restProps, ["collapsedWidth"]);
  if (true) {
    const warning6 = devUseWarning("Menu");
    true ? warning6(!("inlineCollapsed" in props && mode !== "inline"), "usage", "`inlineCollapsed` should only be used when `mode` is inline.") : void 0;
    warning6.deprecated("items" in props && !props.children, "children", "items");
  }
  (_a = overrideObj.validator) === null || _a === void 0 ? void 0 : _a.call(overrideObj, {
    mode
  });
  const onItemClick = useEvent2((...args) => {
    var _a2;
    onClick === null || onClick === void 0 ? void 0 : onClick.apply(void 0, args);
    (_a2 = overrideObj.onClick) === null || _a2 === void 0 ? void 0 : _a2.call(overrideObj);
  });
  const mergedMode = overrideObj.mode || mode;
  const mergedSelectable = selectable !== null && selectable !== void 0 ? selectable : overrideObj.selectable;
  const mergedInlineCollapsed = inlineCollapsed !== null && inlineCollapsed !== void 0 ? inlineCollapsed : siderCollapsed;
  const defaultMotions = {
    horizontal: {
      motionName: `${rootPrefixCls}-slide-up`
    },
    inline: motion_default(rootPrefixCls),
    other: {
      motionName: `${rootPrefixCls}-zoom-big`
    }
  };
  const prefixCls = getPrefixCls("menu", customizePrefixCls || overrideObj.prefixCls);
  const rootCls = useCSSVarCls_default(prefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = style_default13(prefixCls, rootCls, !override);
  const menuClassName = (0, import_classnames75.default)(`${prefixCls}-${theme}`, menu === null || menu === void 0 ? void 0 : menu.className, className2);
  const mergedExpandIcon = React226.useMemo(() => {
    var _a2, _b;
    if (typeof expandIcon === "function" || isEmptyIcon(expandIcon)) {
      return expandIcon || null;
    }
    if (typeof overrideObj.expandIcon === "function" || isEmptyIcon(overrideObj.expandIcon)) {
      return overrideObj.expandIcon || null;
    }
    if (typeof (menu === null || menu === void 0 ? void 0 : menu.expandIcon) === "function" || isEmptyIcon(menu === null || menu === void 0 ? void 0 : menu.expandIcon)) {
      return (menu === null || menu === void 0 ? void 0 : menu.expandIcon) || null;
    }
    const mergedIcon = (_a2 = expandIcon !== null && expandIcon !== void 0 ? expandIcon : overrideObj === null || overrideObj === void 0 ? void 0 : overrideObj.expandIcon) !== null && _a2 !== void 0 ? _a2 : menu === null || menu === void 0 ? void 0 : menu.expandIcon;
    return cloneElement4(mergedIcon, {
      className: (0, import_classnames75.default)(`${prefixCls}-submenu-expand-icon`, /* @__PURE__ */ React226.isValidElement(mergedIcon) ? (_b = mergedIcon.props) === null || _b === void 0 ? void 0 : _b.className : void 0)
    });
  }, [expandIcon, overrideObj === null || overrideObj === void 0 ? void 0 : overrideObj.expandIcon, menu === null || menu === void 0 ? void 0 : menu.expandIcon, prefixCls]);
  const contextValue = React226.useMemo(() => ({
    prefixCls,
    inlineCollapsed: mergedInlineCollapsed || false,
    direction,
    firstLevel: true,
    theme,
    mode: mergedMode,
    disableMenuItemTitleTooltip: _internalDisableMenuItemTitleTooltip
  }), [prefixCls, mergedInlineCollapsed, direction, _internalDisableMenuItemTitleTooltip, theme]);
  return wrapCSSVar(/* @__PURE__ */ React226.createElement(OverrideContext_default.Provider, {
    value: null
  }, /* @__PURE__ */ React226.createElement(MenuContext_default.Provider, {
    value: contextValue
  }, /* @__PURE__ */ React226.createElement(es_default14, Object.assign({
    getPopupContainer,
    overflowedIndicator: /* @__PURE__ */ React226.createElement(EllipsisOutlined_default2, null),
    overflowedIndicatorPopupClassName: (0, import_classnames75.default)(prefixCls, `${prefixCls}-${theme}`, overflowedIndicatorPopupClassName),
    mode: mergedMode,
    selectable: mergedSelectable,
    onClick: onItemClick
  }, passedProps, {
    inlineCollapsed: mergedInlineCollapsed,
    style: Object.assign(Object.assign({}, menu === null || menu === void 0 ? void 0 : menu.style), style2),
    className: menuClassName,
    prefixCls,
    direction,
    defaultMotions,
    expandIcon: mergedExpandIcon,
    ref: ref3,
    rootClassName: (0, import_classnames75.default)(rootClassName, hashId, overrideObj.rootClassName, cssVarCls, rootCls),
    _internalComponents: MENU_COMPONENTS
  })))));
});
var menu_default = InternalMenu;

// ../../node_modules/antd/es/menu/index.js
var Menu2 = /* @__PURE__ */ (0, import_react83.forwardRef)((props, ref3) => {
  const menuRef = (0, import_react83.useRef)(null);
  const context = React227.useContext(SiderContext);
  (0, import_react83.useImperativeHandle)(ref3, () => ({
    menu: menuRef.current,
    focus: (options) => {
      var _a;
      (_a = menuRef.current) === null || _a === void 0 ? void 0 : _a.focus(options);
    }
  }));
  return /* @__PURE__ */ React227.createElement(menu_default, Object.assign({
    ref: menuRef
  }, props, context));
});
Menu2.Item = MenuItem_default2;
Menu2.SubMenu = SubMenu_default2;
Menu2.Divider = MenuDivider_default;
Menu2.ItemGroup = MenuItemGroup_default;
if (true) {
  Menu2.displayName = "Menu";
}
var menu_default2 = Menu2;

// ../../node_modules/antd/es/dropdown/style/status.js
var genStatusStyle = (token2) => {
  const {
    componentCls,
    menuCls,
    colorError,
    colorTextLightSolid
  } = token2;
  const itemCls = `${menuCls}-item`;
  return {
    [`${componentCls}, ${componentCls}-menu-submenu`]: {
      [`${menuCls} ${itemCls}`]: {
        [`&${itemCls}-danger:not(${itemCls}-disabled)`]: {
          color: colorError,
          "&:hover": {
            color: colorTextLightSolid,
            backgroundColor: colorError
          }
        }
      }
    }
  };
};
var status_default = genStatusStyle;

// ../../node_modules/antd/es/dropdown/style/index.js
var genBaseStyle5 = (token2) => {
  const {
    componentCls,
    menuCls,
    zIndexPopup,
    dropdownArrowDistance,
    sizePopupArrow,
    antCls,
    iconCls,
    motionDurationMid,
    paddingBlock,
    fontSize,
    dropdownEdgeChildPadding,
    colorTextDisabled,
    fontSizeIcon,
    controlPaddingHorizontal,
    colorBgElevated
  } = token2;
  return [
    {
      [componentCls]: {
        position: "absolute",
        top: -9999,
        left: {
          _skip_check_: true,
          value: -9999
        },
        zIndex: zIndexPopup,
        display: "block",
        // A placeholder out of dropdown visible range to avoid close when user moving
        "&::before": {
          position: "absolute",
          insetBlock: token2.calc(sizePopupArrow).div(2).sub(dropdownArrowDistance).equal(),
          // insetInlineStart: -7, // FIXME: Seems not work for hidden element
          zIndex: -9999,
          opacity: 1e-4,
          content: '""'
        },
        // Makes vertical dropdowns have a scrollbar once they become taller than the viewport.
        "&-menu-vertical": {
          maxHeight: "100vh",
          overflowY: "auto"
        },
        [`&-trigger${antCls}-btn`]: {
          [`& > ${iconCls}-down, & > ${antCls}-btn-icon > ${iconCls}-down`]: {
            fontSize: fontSizeIcon
          }
        },
        [`${componentCls}-wrap`]: {
          position: "relative",
          [`${antCls}-btn > ${iconCls}-down`]: {
            fontSize: fontSizeIcon
          },
          [`${iconCls}-down::before`]: {
            transition: `transform ${motionDurationMid}`
          }
        },
        [`${componentCls}-wrap-open`]: {
          [`${iconCls}-down::before`]: {
            transform: `rotate(180deg)`
          }
        },
        [`
        &-hidden,
        &-menu-hidden,
        &-menu-submenu-hidden
      `]: {
          display: "none"
        },
        // =============================================================
        // ==                         Motion                          ==
        // =============================================================
        // When position is not enough for dropdown, the placement will revert.
        // We will handle this with revert motion name.
        [`&${antCls}-slide-down-enter${antCls}-slide-down-enter-active${componentCls}-placement-bottomLeft,
          &${antCls}-slide-down-appear${antCls}-slide-down-appear-active${componentCls}-placement-bottomLeft,
          &${antCls}-slide-down-enter${antCls}-slide-down-enter-active${componentCls}-placement-bottom,
          &${antCls}-slide-down-appear${antCls}-slide-down-appear-active${componentCls}-placement-bottom,
          &${antCls}-slide-down-enter${antCls}-slide-down-enter-active${componentCls}-placement-bottomRight,
          &${antCls}-slide-down-appear${antCls}-slide-down-appear-active${componentCls}-placement-bottomRight`]: {
          animationName: slideUpIn
        },
        [`&${antCls}-slide-up-enter${antCls}-slide-up-enter-active${componentCls}-placement-topLeft,
          &${antCls}-slide-up-appear${antCls}-slide-up-appear-active${componentCls}-placement-topLeft,
          &${antCls}-slide-up-enter${antCls}-slide-up-enter-active${componentCls}-placement-top,
          &${antCls}-slide-up-appear${antCls}-slide-up-appear-active${componentCls}-placement-top,
          &${antCls}-slide-up-enter${antCls}-slide-up-enter-active${componentCls}-placement-topRight,
          &${antCls}-slide-up-appear${antCls}-slide-up-appear-active${componentCls}-placement-topRight`]: {
          animationName: slideDownIn
        },
        [`&${antCls}-slide-down-leave${antCls}-slide-down-leave-active${componentCls}-placement-bottomLeft,
          &${antCls}-slide-down-leave${antCls}-slide-down-leave-active${componentCls}-placement-bottom,
          &${antCls}-slide-down-leave${antCls}-slide-down-leave-active${componentCls}-placement-bottomRight`]: {
          animationName: slideUpOut
        },
        [`&${antCls}-slide-up-leave${antCls}-slide-up-leave-active${componentCls}-placement-topLeft,
          &${antCls}-slide-up-leave${antCls}-slide-up-leave-active${componentCls}-placement-top,
          &${antCls}-slide-up-leave${antCls}-slide-up-leave-active${componentCls}-placement-topRight`]: {
          animationName: slideDownOut
        }
      }
    },
    // =============================================================
    // ==                        Arrow style                      ==
    // =============================================================
    getArrowStyle(token2, colorBgElevated, {
      arrowPlacement: {
        top: true,
        bottom: true
      }
    }),
    {
      // =============================================================
      // ==                          Menu                           ==
      // =============================================================
      [`${componentCls} ${menuCls}`]: {
        position: "relative",
        margin: 0
      },
      [`${menuCls}-submenu-popup`]: {
        position: "absolute",
        zIndex: zIndexPopup,
        background: "transparent",
        boxShadow: "none",
        transformOrigin: "0 0",
        "ul, li": {
          listStyle: "none",
          margin: 0
        }
      },
      [`${componentCls}, ${componentCls}-menu-submenu`]: Object.assign(Object.assign({}, resetComponent(token2)), {
        [menuCls]: Object.assign(Object.assign({
          padding: dropdownEdgeChildPadding,
          listStyleType: "none",
          backgroundColor: colorBgElevated,
          backgroundClip: "padding-box",
          borderRadius: token2.borderRadiusLG,
          outline: "none",
          boxShadow: token2.boxShadowSecondary
        }, genFocusStyle(token2)), {
          "&:empty": {
            padding: 0,
            boxShadow: "none"
          },
          [`${menuCls}-item-group-title`]: {
            padding: `${unit(paddingBlock)} ${unit(controlPaddingHorizontal)}`,
            color: token2.colorTextDescription,
            transition: `all ${motionDurationMid}`
          },
          // ======================= Item Content =======================
          [`${menuCls}-item`]: {
            position: "relative",
            display: "flex",
            alignItems: "center"
          },
          [`${menuCls}-item-icon`]: {
            minWidth: fontSize,
            marginInlineEnd: token2.marginXS,
            fontSize: token2.fontSizeSM
          },
          [`${menuCls}-title-content`]: {
            flex: "auto",
            "&-with-extra": {
              display: "inline-flex",
              alignItems: "center",
              width: "100%"
            },
            "> a": {
              color: "inherit",
              transition: `all ${motionDurationMid}`,
              "&:hover": {
                color: "inherit"
              },
              "&::after": {
                position: "absolute",
                inset: 0,
                content: '""'
              }
            },
            [`${menuCls}-item-extra`]: {
              paddingInlineStart: token2.padding,
              marginInlineStart: "auto",
              fontSize: token2.fontSizeSM,
              color: token2.colorTextDescription
            }
          },
          // =========================== Item ===========================
          [`${menuCls}-item, ${menuCls}-submenu-title`]: Object.assign(Object.assign({
            display: "flex",
            margin: 0,
            padding: `${unit(paddingBlock)} ${unit(controlPaddingHorizontal)}`,
            color: token2.colorText,
            fontWeight: "normal",
            fontSize,
            lineHeight: token2.lineHeight,
            cursor: "pointer",
            transition: `all ${motionDurationMid}`,
            borderRadius: token2.borderRadiusSM,
            "&:hover, &-active": {
              backgroundColor: token2.controlItemBgHover
            }
          }, genFocusStyle(token2)), {
            "&-selected": {
              color: token2.colorPrimary,
              backgroundColor: token2.controlItemBgActive,
              "&:hover, &-active": {
                backgroundColor: token2.controlItemBgActiveHover
              }
            },
            "&-disabled": {
              color: colorTextDisabled,
              cursor: "not-allowed",
              "&:hover": {
                color: colorTextDisabled,
                backgroundColor: colorBgElevated,
                cursor: "not-allowed"
              },
              a: {
                pointerEvents: "none"
              }
            },
            "&-divider": {
              height: 1,
              // By design
              margin: `${unit(token2.marginXXS)} 0`,
              overflow: "hidden",
              lineHeight: 0,
              backgroundColor: token2.colorSplit
            },
            [`${componentCls}-menu-submenu-expand-icon`]: {
              position: "absolute",
              insetInlineEnd: token2.paddingXS,
              [`${componentCls}-menu-submenu-arrow-icon`]: {
                marginInlineEnd: "0 !important",
                color: token2.colorIcon,
                fontSize: fontSizeIcon,
                fontStyle: "normal"
              }
            }
          }),
          [`${menuCls}-item-group-list`]: {
            margin: `0 ${unit(token2.marginXS)}`,
            padding: 0,
            listStyle: "none"
          },
          [`${menuCls}-submenu-title`]: {
            paddingInlineEnd: token2.calc(controlPaddingHorizontal).add(token2.fontSizeSM).equal()
          },
          [`${menuCls}-submenu-vertical`]: {
            position: "relative"
          },
          [`${menuCls}-submenu${menuCls}-submenu-disabled ${componentCls}-menu-submenu-title`]: {
            [`&, ${componentCls}-menu-submenu-arrow-icon`]: {
              color: colorTextDisabled,
              backgroundColor: colorBgElevated,
              cursor: "not-allowed"
            }
          },
          // https://github.com/ant-design/ant-design/issues/19264
          [`${menuCls}-submenu-selected ${componentCls}-menu-submenu-title`]: {
            color: token2.colorPrimary
          }
        })
      })
    },
    // Follow code may reuse in other components
    [initSlideMotion(token2, "slide-up"), initSlideMotion(token2, "slide-down"), initMoveMotion(token2, "move-up"), initMoveMotion(token2, "move-down"), initZoomMotion(token2, "zoom-big")]
  ];
};
var prepareComponentToken11 = (token2) => Object.assign(Object.assign({
  zIndexPopup: token2.zIndexPopupBase + 50,
  paddingBlock: (token2.controlHeight - token2.fontSize * token2.lineHeight) / 2
}, getArrowOffsetToken({
  contentRadius: token2.borderRadiusLG,
  limitVerticalRadius: true
})), getArrowToken(token2));
var style_default14 = genStyleHooks("Dropdown", (token2) => {
  const {
    marginXXS,
    sizePopupArrow,
    paddingXXS,
    componentCls
  } = token2;
  const dropdownToken = merge2(token2, {
    menuCls: `${componentCls}-menu`,
    dropdownArrowDistance: token2.calc(sizePopupArrow).div(2).add(marginXXS).equal(),
    dropdownEdgeChildPadding: paddingXXS
  });
  return [genBaseStyle5(dropdownToken), status_default(dropdownToken)];
}, prepareComponentToken11, {
  resetStyle: false
});

// ../../node_modules/antd/es/dropdown/dropdown.js
var Dropdown2 = (props) => {
  var _a;
  const {
    menu,
    arrow,
    prefixCls: customizePrefixCls,
    children,
    trigger: trigger2,
    disabled,
    dropdownRender,
    popupRender,
    getPopupContainer,
    overlayClassName,
    rootClassName,
    overlayStyle,
    open: open2,
    onOpenChange,
    // Deprecated
    visible,
    onVisibleChange,
    mouseEnterDelay = 0.15,
    mouseLeaveDelay = 0.1,
    autoAdjustOverflow: autoAdjustOverflow3 = true,
    placement = "",
    overlay,
    transitionName,
    destroyOnHidden,
    destroyPopupOnHide
  } = props;
  const {
    getPopupContainer: getContextPopupContainer,
    getPrefixCls,
    direction,
    dropdown
  } = React228.useContext(ConfigContext);
  const mergedPopupRender = popupRender || dropdownRender;
  const warning6 = devUseWarning("Dropdown");
  if (true) {
    const deprecatedProps = {
      visible: "open",
      onVisibleChange: "onOpenChange",
      overlay: "menu",
      dropdownRender: "popupRender",
      destroyPopupOnHide: "destroyOnHidden"
    };
    Object.entries(deprecatedProps).forEach(([deprecatedName, newName]) => {
      warning6.deprecated(!(deprecatedName in props), deprecatedName, newName);
    });
    if (placement.includes("Center")) {
      warning6.deprecated(!placement.includes("Center"), `placement: ${placement}`, `placement: ${placement.slice(0, placement.indexOf("Center"))}`);
    }
  }
  const memoTransitionName = React228.useMemo(() => {
    const rootPrefixCls = getPrefixCls();
    if (transitionName !== void 0) {
      return transitionName;
    }
    if (placement.includes("top")) {
      return `${rootPrefixCls}-slide-down`;
    }
    return `${rootPrefixCls}-slide-up`;
  }, [getPrefixCls, placement, transitionName]);
  const memoPlacement = React228.useMemo(() => {
    if (!placement) {
      return direction === "rtl" ? "bottomRight" : "bottomLeft";
    }
    if (placement.includes("Center")) {
      return placement.slice(0, placement.indexOf("Center"));
    }
    return placement;
  }, [placement, direction]);
  const prefixCls = getPrefixCls("dropdown", customizePrefixCls);
  const rootCls = useCSSVarCls_default(prefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = style_default14(prefixCls, rootCls);
  const [, token2] = useToken();
  const child = React228.Children.only(isPrimitive_default(children) ? /* @__PURE__ */ React228.createElement("span", null, children) : children);
  const popupTrigger = cloneElement4(child, {
    className: (0, import_classnames76.default)(`${prefixCls}-trigger`, {
      [`${prefixCls}-rtl`]: direction === "rtl"
    }, child.props.className),
    disabled: (_a = child.props.disabled) !== null && _a !== void 0 ? _a : disabled
  });
  const triggerActions = disabled ? [] : trigger2;
  const alignPoint = !!(triggerActions === null || triggerActions === void 0 ? void 0 : triggerActions.includes("contextMenu"));
  const [mergedOpen, setOpen] = useMergedState(false, {
    value: open2 !== null && open2 !== void 0 ? open2 : visible
  });
  const onInnerOpenChange = useEvent2((nextOpen) => {
    onOpenChange === null || onOpenChange === void 0 ? void 0 : onOpenChange(nextOpen, {
      source: "trigger"
    });
    onVisibleChange === null || onVisibleChange === void 0 ? void 0 : onVisibleChange(nextOpen);
    setOpen(nextOpen);
  });
  const overlayClassNameCustomized = (0, import_classnames76.default)(overlayClassName, rootClassName, hashId, cssVarCls, rootCls, dropdown === null || dropdown === void 0 ? void 0 : dropdown.className, {
    [`${prefixCls}-rtl`]: direction === "rtl"
  });
  const builtinPlacements = getPlacements({
    arrowPointAtCenter: typeof arrow === "object" && arrow.pointAtCenter,
    autoAdjustOverflow: autoAdjustOverflow3,
    offset: token2.marginXXS,
    arrowWidth: arrow ? token2.sizePopupArrow : 0,
    borderRadius: token2.borderRadius
  });
  const onMenuClick = React228.useCallback(() => {
    if ((menu === null || menu === void 0 ? void 0 : menu.selectable) && (menu === null || menu === void 0 ? void 0 : menu.multiple)) {
      return;
    }
    onOpenChange === null || onOpenChange === void 0 ? void 0 : onOpenChange(false, {
      source: "menu"
    });
    setOpen(false);
  }, [menu === null || menu === void 0 ? void 0 : menu.selectable, menu === null || menu === void 0 ? void 0 : menu.multiple]);
  const renderOverlay = () => {
    let overlayNode;
    if (menu === null || menu === void 0 ? void 0 : menu.items) {
      overlayNode = /* @__PURE__ */ React228.createElement(menu_default2, Object.assign({}, menu));
    } else if (typeof overlay === "function") {
      overlayNode = overlay();
    } else {
      overlayNode = overlay;
    }
    if (mergedPopupRender) {
      overlayNode = mergedPopupRender(overlayNode);
    }
    overlayNode = React228.Children.only(typeof overlayNode === "string" ? /* @__PURE__ */ React228.createElement("span", null, overlayNode) : overlayNode);
    return /* @__PURE__ */ React228.createElement(OverrideProvider, {
      prefixCls: `${prefixCls}-menu`,
      rootClassName: (0, import_classnames76.default)(cssVarCls, rootCls),
      expandIcon: /* @__PURE__ */ React228.createElement("span", {
        className: `${prefixCls}-menu-submenu-arrow`
      }, direction === "rtl" ? /* @__PURE__ */ React228.createElement(LeftOutlined_default2, {
        className: `${prefixCls}-menu-submenu-arrow-icon`
      }) : /* @__PURE__ */ React228.createElement(RightOutlined_default2, {
        className: `${prefixCls}-menu-submenu-arrow-icon`
      })),
      mode: "vertical",
      selectable: false,
      onClick: onMenuClick,
      validator: ({
        mode
      }) => {
        true ? warning6(!mode || mode === "vertical", "usage", `mode="${mode}" is not supported for Dropdown's Menu.`) : void 0;
      }
    }, overlayNode);
  };
  const [zIndex, contextZIndex] = useZIndex("Dropdown", overlayStyle === null || overlayStyle === void 0 ? void 0 : overlayStyle.zIndex);
  let renderNode = /* @__PURE__ */ React228.createElement(es_default13, Object.assign({
    alignPoint
  }, omit(props, ["rootClassName"]), {
    mouseEnterDelay,
    mouseLeaveDelay,
    visible: mergedOpen,
    builtinPlacements,
    arrow: !!arrow,
    overlayClassName: overlayClassNameCustomized,
    prefixCls,
    getPopupContainer: getPopupContainer || getContextPopupContainer,
    transitionName: memoTransitionName,
    trigger: triggerActions,
    overlay: renderOverlay,
    placement: memoPlacement,
    onVisibleChange: onInnerOpenChange,
    overlayStyle: Object.assign(Object.assign(Object.assign({}, dropdown === null || dropdown === void 0 ? void 0 : dropdown.style), overlayStyle), {
      zIndex
    }),
    autoDestroy: destroyOnHidden !== null && destroyOnHidden !== void 0 ? destroyOnHidden : destroyPopupOnHide
  }), popupTrigger);
  if (zIndex) {
    renderNode = /* @__PURE__ */ React228.createElement(zindexContext_default.Provider, {
      value: contextZIndex
    }, renderNode);
  }
  return wrapCSSVar(renderNode);
};
var PurePanel5 = PurePanel_default2(Dropdown2, "align", void 0, "dropdown", (prefixCls) => prefixCls);
var WrapPurePanel = (props) => /* @__PURE__ */ React228.createElement(PurePanel5, Object.assign({}, props), /* @__PURE__ */ React228.createElement("span", null));
Dropdown2._InternalPanelDoNotUseOrYouWillBeFired = WrapPurePanel;
if (true) {
  Dropdown2.displayName = "Dropdown";
}
var dropdown_default2 = Dropdown2;

// ../../node_modules/rc-picker/es/generate/dayjs.js
var import_dayjs = __toESM(require_dayjs_min());
var import_weekday = __toESM(require_weekday());
var import_localeData = __toESM(require_localeData());
var import_weekOfYear = __toESM(require_weekOfYear());
var import_weekYear = __toESM(require_weekYear());
var import_advancedFormat = __toESM(require_advancedFormat());
var import_customParseFormat = __toESM(require_customParseFormat());
import_dayjs.default.extend(import_customParseFormat.default);
import_dayjs.default.extend(import_advancedFormat.default);
import_dayjs.default.extend(import_weekday.default);
import_dayjs.default.extend(import_localeData.default);
import_dayjs.default.extend(import_weekOfYear.default);
import_dayjs.default.extend(import_weekYear.default);
import_dayjs.default.extend(function(o3, c) {
  var proto = c.prototype;
  var oldFormat = proto.format;
  proto.format = function f(formatStr) {
    var str = (formatStr || "").replace("Wo", "wo");
    return oldFormat.bind(this)(str);
  };
});
var localeMap = {
  // ar_EG:
  // az_AZ:
  // bg_BG:
  bn_BD: "bn-bd",
  by_BY: "be",
  // ca_ES:
  // cs_CZ:
  // da_DK:
  // de_DE:
  // el_GR:
  en_GB: "en-gb",
  en_US: "en",
  // es_ES:
  // et_EE:
  // fa_IR:
  // fi_FI:
  fr_BE: "fr",
  // todo: dayjs has no fr_BE locale, use fr at present
  fr_CA: "fr-ca",
  // fr_FR:
  // ga_IE:
  // gl_ES:
  // he_IL:
  // hi_IN:
  // hr_HR:
  // hu_HU:
  hy_AM: "hy-am",
  // id_ID:
  // is_IS:
  // it_IT:
  // ja_JP:
  // ka_GE:
  // kk_KZ:
  // km_KH:
  kmr_IQ: "ku",
  // kn_IN:
  // ko_KR:
  // ku_IQ: // previous ku in antd
  // lt_LT:
  // lv_LV:
  // mk_MK:
  // ml_IN:
  // mn_MN:
  // ms_MY:
  // nb_NO:
  // ne_NP:
  nl_BE: "nl-be",
  // nl_NL:
  // pl_PL:
  pt_BR: "pt-br",
  // pt_PT:
  // ro_RO:
  // ru_RU:
  // sk_SK:
  // sl_SI:
  // sr_RS:
  // sv_SE:
  // ta_IN:
  // th_TH:
  // tr_TR:
  // uk_UA:
  // ur_PK:
  // vi_VN:
  zh_CN: "zh-cn",
  zh_HK: "zh-hk",
  zh_TW: "zh-tw"
};
var parseLocale = function parseLocale2(locale6) {
  var mapLocale = localeMap[locale6];
  return mapLocale || locale6.split("_")[0];
};
var parseNoMatchNotice = function parseNoMatchNotice2() {
};
var generateConfig = {
  // get
  getNow: function getNow() {
    var now4 = (0, import_dayjs.default)();
    if (typeof now4.tz === "function") {
      return now4.tz();
    }
    return now4;
  },
  getFixedDate: function getFixedDate(string3) {
    return (0, import_dayjs.default)(string3, ["YYYY-M-DD", "YYYY-MM-DD"]);
  },
  getEndDate: function getEndDate(date4) {
    return date4.endOf("month");
  },
  getWeekDay: function getWeekDay(date4) {
    var clone = date4.locale("en");
    return clone.weekday() + clone.localeData().firstDayOfWeek();
  },
  getYear: function getYear(date4) {
    return date4.year();
  },
  getMonth: function getMonth(date4) {
    return date4.month();
  },
  getDate: function getDate(date4) {
    return date4.date();
  },
  getHour: function getHour(date4) {
    return date4.hour();
  },
  getMinute: function getMinute(date4) {
    return date4.minute();
  },
  getSecond: function getSecond(date4) {
    return date4.second();
  },
  getMillisecond: function getMillisecond(date4) {
    return date4.millisecond();
  },
  // set
  addYear: function addYear(date4, diff3) {
    return date4.add(diff3, "year");
  },
  addMonth: function addMonth(date4, diff3) {
    return date4.add(diff3, "month");
  },
  addDate: function addDate(date4, diff3) {
    return date4.add(diff3, "day");
  },
  setYear: function setYear(date4, year) {
    return date4.year(year);
  },
  setMonth: function setMonth(date4, month) {
    return date4.month(month);
  },
  setDate: function setDate(date4, num) {
    return date4.date(num);
  },
  setHour: function setHour(date4, hour) {
    return date4.hour(hour);
  },
  setMinute: function setMinute(date4, minute) {
    return date4.minute(minute);
  },
  setSecond: function setSecond(date4, second) {
    return date4.second(second);
  },
  setMillisecond: function setMillisecond(date4, milliseconds) {
    return date4.millisecond(milliseconds);
  },
  // Compare
  isAfter: function isAfter(date1, date22) {
    return date1.isAfter(date22);
  },
  isValidate: function isValidate(date4) {
    return date4.isValid();
  },
  locale: {
    getWeekFirstDay: function getWeekFirstDay(locale6) {
      return (0, import_dayjs.default)().locale(parseLocale(locale6)).localeData().firstDayOfWeek();
    },
    getWeekFirstDate: function getWeekFirstDate(locale6, date4) {
      return date4.locale(parseLocale(locale6)).weekday(0);
    },
    getWeek: function getWeek(locale6, date4) {
      return date4.locale(parseLocale(locale6)).week();
    },
    getShortWeekDays: function getShortWeekDays(locale6) {
      return (0, import_dayjs.default)().locale(parseLocale(locale6)).localeData().weekdaysMin();
    },
    getShortMonths: function getShortMonths(locale6) {
      return (0, import_dayjs.default)().locale(parseLocale(locale6)).localeData().monthsShort();
    },
    format: function format2(locale6, date4, _format) {
      return date4.locale(parseLocale(locale6)).format(_format);
    },
    parse: function parse4(locale6, text, formats) {
      var localeStr = parseLocale(locale6);
      for (var i = 0; i < formats.length; i += 1) {
        var format3 = formats[i];
        var formatText = text;
        if (format3.includes("wo") || format3.includes("Wo")) {
          var year = formatText.split("-")[0];
          var weekStr = formatText.split("-")[1];
          var firstWeek = (0, import_dayjs.default)(year, "YYYY").startOf("year").locale(localeStr);
          for (var j = 0; j <= 52; j += 1) {
            var nextWeek = firstWeek.add(j, "week");
            if (nextWeek.format("Wo") === weekStr) {
              return nextWeek;
            }
          }
          parseNoMatchNotice();
          return null;
        }
        var date4 = (0, import_dayjs.default)(formatText, format3, true).locale(localeStr);
        if (date4.isValid()) {
          return date4;
        }
      }
      if (text) {
        parseNoMatchNotice();
      }
      return null;
    }
  }
};
var dayjs_default = generateConfig;

// ../../node_modules/rc-picker/es/PickerInput/RangePicker.js
var React270 = __toESM(require_react());

// ../../node_modules/rc-picker/es/PickerTrigger/index.js
var import_classnames77 = __toESM(require_classnames());
var React230 = __toESM(require_react());

// ../../node_modules/rc-picker/es/utils/uiUtil.js
function getRealPlacement(placement, rtl) {
  if (placement !== void 0) {
    return placement;
  }
  return rtl ? "bottomRight" : "bottomLeft";
}

// ../../node_modules/rc-picker/es/PickerInput/context.js
var React229 = __toESM(require_react());
var PickerContext = /* @__PURE__ */ React229.createContext(null);
var context_default3 = PickerContext;

// ../../node_modules/rc-picker/es/PickerTrigger/index.js
var BUILT_IN_PLACEMENTS = {
  bottomLeft: {
    points: ["tl", "bl"],
    offset: [0, 4],
    overflow: {
      adjustX: 1,
      adjustY: 1
    }
  },
  bottomRight: {
    points: ["tr", "br"],
    offset: [0, 4],
    overflow: {
      adjustX: 1,
      adjustY: 1
    }
  },
  topLeft: {
    points: ["bl", "tl"],
    offset: [0, -4],
    overflow: {
      adjustX: 0,
      adjustY: 1
    }
  },
  topRight: {
    points: ["br", "tr"],
    offset: [0, -4],
    overflow: {
      adjustX: 0,
      adjustY: 1
    }
  }
};
function PickerTrigger(_ref) {
  var popupElement = _ref.popupElement, popupStyle = _ref.popupStyle, popupClassName = _ref.popupClassName, popupAlign = _ref.popupAlign, transitionName = _ref.transitionName, getPopupContainer = _ref.getPopupContainer, children = _ref.children, range3 = _ref.range, placement = _ref.placement, _ref$builtinPlacement = _ref.builtinPlacements, builtinPlacements = _ref$builtinPlacement === void 0 ? BUILT_IN_PLACEMENTS : _ref$builtinPlacement, direction = _ref.direction, visible = _ref.visible, onClose = _ref.onClose;
  var _React$useContext = React230.useContext(context_default3), prefixCls = _React$useContext.prefixCls;
  var dropdownPrefixCls = "".concat(prefixCls, "-dropdown");
  var realPlacement = getRealPlacement(placement, direction === "rtl");
  return /* @__PURE__ */ React230.createElement(es_default9, {
    showAction: [],
    hideAction: ["click"],
    popupPlacement: realPlacement,
    builtinPlacements,
    prefixCls: dropdownPrefixCls,
    popupTransitionName: transitionName,
    popup: popupElement,
    popupAlign,
    popupVisible: visible,
    popupClassName: (0, import_classnames77.default)(popupClassName, _defineProperty(_defineProperty({}, "".concat(dropdownPrefixCls, "-range"), range3), "".concat(dropdownPrefixCls, "-rtl"), direction === "rtl")),
    popupStyle,
    stretch: "minWidth",
    getPopupContainer,
    onPopupVisibleChange: function onPopupVisibleChange(nextVisible) {
      if (!nextVisible) {
        onClose();
      }
    }
  }, children);
}
var PickerTrigger_default = PickerTrigger;

// ../../node_modules/rc-picker/es/utils/miscUtil.js
function leftPad(str, length2) {
  var fill = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "0";
  var current2 = String(str);
  while (current2.length < length2) {
    current2 = "".concat(fill).concat(current2);
  }
  return current2;
}
function toArray5(val) {
  if (val === null || val === void 0) {
    return [];
  }
  return Array.isArray(val) ? val : [val];
}
function fillIndex(ori, index3, value) {
  var clone = _toConsumableArray(ori);
  clone[index3] = value;
  return clone;
}
function pickProps(props, keys4) {
  var clone = {};
  var mergedKeys = keys4 || Object.keys(props);
  mergedKeys.forEach(function(key2) {
    if (props[key2] !== void 0) {
      clone[key2] = props[key2];
    }
  });
  return clone;
}
function getRowFormat(picker, locale6, format3) {
  if (format3) {
    return format3;
  }
  switch (picker) {
    // All from the `locale.fieldXXXFormat` first
    case "time":
      return locale6.fieldTimeFormat;
    case "datetime":
      return locale6.fieldDateTimeFormat;
    case "month":
      return locale6.fieldMonthFormat;
    case "year":
      return locale6.fieldYearFormat;
    case "quarter":
      return locale6.fieldQuarterFormat;
    case "week":
      return locale6.fieldWeekFormat;
    default:
      return locale6.fieldDateFormat;
  }
}
function getFromDate(calendarValues, activeIndexList, activeIndex) {
  var mergedActiveIndex = activeIndex !== void 0 ? activeIndex : activeIndexList[activeIndexList.length - 1];
  var firstValuedIndex = activeIndexList.find(function(index3) {
    return calendarValues[index3];
  });
  return mergedActiveIndex !== firstValuedIndex ? calendarValues[firstValuedIndex] : void 0;
}

// ../../node_modules/rc-picker/es/PickerTrigger/util.js
function pickTriggerProps(props) {
  return pickProps(props, ["placement", "builtinPlacements", "popupAlign", "getPopupContainer", "transitionName", "direction"]);
}

// ../../node_modules/rc-picker/es/PickerInput/hooks/useCellRender.js
var React231 = __toESM(require_react());
function useCellRender(cellRender, dateRender, monthCellRender, range3) {
  if (true) {
    warning_default(!dateRender, "'dateRender' is deprecated. Please use 'cellRender' instead.");
    warning_default(!monthCellRender, "'monthCellRender' is deprecated. Please use 'cellRender' instead.");
  }
  var mergedCellRender = React231.useMemo(function() {
    if (cellRender) {
      return cellRender;
    }
    return function(current2, info) {
      var date4 = current2;
      if (dateRender && info.type === "date") {
        return dateRender(date4, info.today);
      }
      if (monthCellRender && info.type === "month") {
        return monthCellRender(date4, info.locale);
      }
      return info.originNode;
    };
  }, [cellRender, monthCellRender, dateRender]);
  var onInternalCellRender = React231.useCallback(function(date4, info) {
    return mergedCellRender(date4, _objectSpread2(_objectSpread2({}, info), {}, {
      range: range3
    }));
  }, [mergedCellRender, range3]);
  return onInternalCellRender;
}

// ../../node_modules/rc-picker/es/PickerInput/hooks/useFieldsInvalidate.js
var React232 = __toESM(require_react());
function useFieldsInvalidate(calendarValue, isInvalidateDate) {
  var allowEmpty = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
  var _React$useState = React232.useState([false, false]), _React$useState2 = _slicedToArray(_React$useState, 2), fieldsInvalidates = _React$useState2[0], setFieldsInvalidates = _React$useState2[1];
  var onSelectorInvalid = function onSelectorInvalid2(invalid, index3) {
    setFieldsInvalidates(function(ori) {
      return fillIndex(ori, index3, invalid);
    });
  };
  var submitInvalidates = React232.useMemo(function() {
    return fieldsInvalidates.map(function(invalid, index3) {
      if (invalid) {
        return true;
      }
      var current2 = calendarValue[index3];
      if (!current2) {
        return false;
      }
      if (!allowEmpty[index3] && !current2) {
        return true;
      }
      if (current2 && isInvalidateDate(current2, {
        activeIndex: index3
      })) {
        return true;
      }
      return false;
    });
  }, [calendarValue, fieldsInvalidates, isInvalidateDate, allowEmpty]);
  return [submitInvalidates, onSelectorInvalid];
}

// ../../node_modules/rc-picker/es/PickerInput/hooks/useFilledProps.js
var React236 = __toESM(require_react());

// ../../node_modules/rc-picker/es/hooks/useLocale.js
var import_react84 = __toESM(require_react());
function fillTimeFormat(showHour, showMinute, showSecond, showMillisecond, showMeridiem) {
  var timeFormat = "";
  var cells = [];
  if (showHour) {
    cells.push(showMeridiem ? "hh" : "HH");
  }
  if (showMinute) {
    cells.push("mm");
  }
  if (showSecond) {
    cells.push("ss");
  }
  timeFormat = cells.join(":");
  if (showMillisecond) {
    timeFormat += ".SSS";
  }
  if (showMeridiem) {
    timeFormat += " A";
  }
  return timeFormat;
}
function fillLocale(locale6, showHour, showMinute, showSecond, showMillisecond, use12Hours) {
  var fieldDateTimeFormat = locale6.fieldDateTimeFormat, fieldDateFormat = locale6.fieldDateFormat, fieldTimeFormat = locale6.fieldTimeFormat, fieldMonthFormat = locale6.fieldMonthFormat, fieldYearFormat = locale6.fieldYearFormat, fieldWeekFormat = locale6.fieldWeekFormat, fieldQuarterFormat = locale6.fieldQuarterFormat, yearFormat = locale6.yearFormat, cellYearFormat = locale6.cellYearFormat, cellQuarterFormat = locale6.cellQuarterFormat, dayFormat = locale6.dayFormat, cellDateFormat = locale6.cellDateFormat;
  var timeFormat = fillTimeFormat(showHour, showMinute, showSecond, showMillisecond, use12Hours);
  return _objectSpread2(_objectSpread2({}, locale6), {}, {
    fieldDateTimeFormat: fieldDateTimeFormat || "YYYY-MM-DD ".concat(timeFormat),
    fieldDateFormat: fieldDateFormat || "YYYY-MM-DD",
    fieldTimeFormat: fieldTimeFormat || timeFormat,
    fieldMonthFormat: fieldMonthFormat || "YYYY-MM",
    fieldYearFormat: fieldYearFormat || "YYYY",
    fieldWeekFormat: fieldWeekFormat || "gggg-wo",
    fieldQuarterFormat: fieldQuarterFormat || "YYYY-[Q]Q",
    yearFormat: yearFormat || "YYYY",
    cellYearFormat: cellYearFormat || "YYYY",
    cellQuarterFormat: cellQuarterFormat || "[Q]Q",
    cellDateFormat: cellDateFormat || dayFormat || "D"
  });
}
function useLocale2(locale6, showProps) {
  var showHour = showProps.showHour, showMinute = showProps.showMinute, showSecond = showProps.showSecond, showMillisecond = showProps.showMillisecond, use12Hours = showProps.use12Hours;
  return import_react84.default.useMemo(function() {
    return fillLocale(locale6, showHour, showMinute, showSecond, showMillisecond, use12Hours);
  }, [locale6, showHour, showMinute, showSecond, showMillisecond, use12Hours]);
}

// ../../node_modules/rc-picker/es/hooks/useTimeConfig.js
function checkShow(format3, keywords2, show) {
  return show !== null && show !== void 0 ? show : keywords2.some(function(keyword) {
    return format3.includes(keyword);
  });
}
var showTimeKeys = [
  // 'format',
  "showNow",
  "showHour",
  "showMinute",
  "showSecond",
  "showMillisecond",
  "use12Hours",
  "hourStep",
  "minuteStep",
  "secondStep",
  "millisecondStep",
  "hideDisabledOptions",
  "defaultValue",
  "disabledHours",
  "disabledMinutes",
  "disabledSeconds",
  "disabledMilliseconds",
  "disabledTime",
  "changeOnScroll",
  "defaultOpenValue"
];
function pickTimeProps(props) {
  var timeProps = pickProps(props, showTimeKeys);
  var format3 = props.format, picker = props.picker;
  var propFormat = null;
  if (format3) {
    propFormat = format3;
    if (Array.isArray(propFormat)) {
      propFormat = propFormat[0];
    }
    propFormat = _typeof(propFormat) === "object" ? propFormat.format : propFormat;
  }
  if (picker === "time") {
    timeProps.format = propFormat;
  }
  return [timeProps, propFormat];
}
function isStringFormat(format3) {
  return format3 && typeof format3 === "string";
}
function existShowConfig(showHour, showMinute, showSecond, showMillisecond) {
  return [showHour, showMinute, showSecond, showMillisecond].some(function(show) {
    return show !== void 0;
  });
}
function fillShowConfig(hasShowConfig, showHour, showMinute, showSecond, showMillisecond) {
  var parsedShowHour = showHour;
  var parsedShowMinute = showMinute;
  var parsedShowSecond = showSecond;
  if (!hasShowConfig && !parsedShowHour && !parsedShowMinute && !parsedShowSecond && !showMillisecond) {
    parsedShowHour = true;
    parsedShowMinute = true;
    parsedShowSecond = true;
  } else if (hasShowConfig) {
    var _parsedShowHour, _parsedShowMinute, _parsedShowSecond;
    var existFalse = [parsedShowHour, parsedShowMinute, parsedShowSecond].some(function(show) {
      return show === false;
    });
    var existTrue = [parsedShowHour, parsedShowMinute, parsedShowSecond].some(function(show) {
      return show === true;
    });
    var defaultShow = existFalse ? true : !existTrue;
    parsedShowHour = (_parsedShowHour = parsedShowHour) !== null && _parsedShowHour !== void 0 ? _parsedShowHour : defaultShow;
    parsedShowMinute = (_parsedShowMinute = parsedShowMinute) !== null && _parsedShowMinute !== void 0 ? _parsedShowMinute : defaultShow;
    parsedShowSecond = (_parsedShowSecond = parsedShowSecond) !== null && _parsedShowSecond !== void 0 ? _parsedShowSecond : defaultShow;
  }
  return [parsedShowHour, parsedShowMinute, parsedShowSecond, showMillisecond];
}
function getTimeProps(componentProps) {
  var showTime = componentProps.showTime;
  var _pickTimeProps = pickTimeProps(componentProps), _pickTimeProps2 = _slicedToArray(_pickTimeProps, 2), pickedProps = _pickTimeProps2[0], propFormat = _pickTimeProps2[1];
  var showTimeConfig = showTime && _typeof(showTime) === "object" ? showTime : {};
  var timeConfig = _objectSpread2(_objectSpread2({
    defaultOpenValue: showTimeConfig.defaultOpenValue || showTimeConfig.defaultValue
  }, pickedProps), showTimeConfig);
  var showMillisecond = timeConfig.showMillisecond;
  var showHour = timeConfig.showHour, showMinute = timeConfig.showMinute, showSecond = timeConfig.showSecond;
  var hasShowConfig = existShowConfig(showHour, showMinute, showSecond, showMillisecond);
  var _fillShowConfig = fillShowConfig(hasShowConfig, showHour, showMinute, showSecond, showMillisecond);
  var _fillShowConfig2 = _slicedToArray(_fillShowConfig, 3);
  showHour = _fillShowConfig2[0];
  showMinute = _fillShowConfig2[1];
  showSecond = _fillShowConfig2[2];
  return [timeConfig, _objectSpread2(_objectSpread2({}, timeConfig), {}, {
    showHour,
    showMinute,
    showSecond,
    showMillisecond
  }), timeConfig.format, propFormat];
}
function fillShowTimeConfig(picker, showTimeFormat, propFormat, timeConfig, locale6) {
  var isTimePicker = picker === "time";
  if (picker === "datetime" || isTimePicker) {
    var pickedProps = timeConfig;
    var defaultLocaleFormat = getRowFormat(picker, locale6, null);
    var baselineFormat = defaultLocaleFormat;
    var formatList = [showTimeFormat, propFormat];
    for (var i = 0; i < formatList.length; i += 1) {
      var format3 = toArray5(formatList[i])[0];
      if (isStringFormat(format3)) {
        baselineFormat = format3;
        break;
      }
    }
    var showHour = pickedProps.showHour, showMinute = pickedProps.showMinute, showSecond = pickedProps.showSecond, showMillisecond = pickedProps.showMillisecond;
    var use12Hours = pickedProps.use12Hours;
    var showMeridiem = checkShow(baselineFormat, ["a", "A", "LT", "LLL", "LTS"], use12Hours);
    var hasShowConfig = existShowConfig(showHour, showMinute, showSecond, showMillisecond);
    if (!hasShowConfig) {
      showHour = checkShow(baselineFormat, ["H", "h", "k", "LT", "LLL"]);
      showMinute = checkShow(baselineFormat, ["m", "LT", "LLL"]);
      showSecond = checkShow(baselineFormat, ["s", "LTS"]);
      showMillisecond = checkShow(baselineFormat, ["SSS"]);
    }
    var _fillShowConfig3 = fillShowConfig(hasShowConfig, showHour, showMinute, showSecond, showMillisecond);
    var _fillShowConfig4 = _slicedToArray(_fillShowConfig3, 3);
    showHour = _fillShowConfig4[0];
    showMinute = _fillShowConfig4[1];
    showSecond = _fillShowConfig4[2];
    var timeFormat = showTimeFormat || fillTimeFormat(showHour, showMinute, showSecond, showMillisecond, showMeridiem);
    return _objectSpread2(_objectSpread2({}, pickedProps), {}, {
      // Format
      format: timeFormat,
      // Show Config
      showHour,
      showMinute,
      showSecond,
      showMillisecond,
      use12Hours: showMeridiem
    });
  }
  return null;
}

// ../../node_modules/rc-picker/es/PickerInput/Selector/hooks/useClearIcon.js
var React234 = __toESM(require_react());
function fillClearIcon(prefixCls, allowClear, clearIcon) {
  if (clearIcon) {
    warning_default(false, "`clearIcon` will be removed in future. Please use `allowClear` instead.");
  }
  if (allowClear === false) {
    return null;
  }
  var config = allowClear && _typeof(allowClear) === "object" ? allowClear : {};
  return config.clearIcon || clearIcon || /* @__PURE__ */ React234.createElement("span", {
    className: "".concat(prefixCls, "-clear-btn")
  });
}

// ../../node_modules/rc-picker/es/utils/dateUtil.js
var WEEK_DAY_COUNT = 7;
function nullableCompare(value1, value2, oriCompareFn) {
  if (!value1 && !value2 || value1 === value2) {
    return true;
  }
  if (!value1 || !value2) {
    return false;
  }
  return oriCompareFn();
}
function isSameDecade(generateConfig2, decade1, decade2) {
  return nullableCompare(decade1, decade2, function() {
    var num1 = Math.floor(generateConfig2.getYear(decade1) / 10);
    var num2 = Math.floor(generateConfig2.getYear(decade2) / 10);
    return num1 === num2;
  });
}
function isSameYear(generateConfig2, year1, year2) {
  return nullableCompare(year1, year2, function() {
    return generateConfig2.getYear(year1) === generateConfig2.getYear(year2);
  });
}
function getQuarter(generateConfig2, date4) {
  var quota = Math.floor(generateConfig2.getMonth(date4) / 3);
  return quota + 1;
}
function isSameQuarter(generateConfig2, quarter1, quarter2) {
  return nullableCompare(quarter1, quarter2, function() {
    return isSameYear(generateConfig2, quarter1, quarter2) && getQuarter(generateConfig2, quarter1) === getQuarter(generateConfig2, quarter2);
  });
}
function isSameMonth(generateConfig2, month1, month2) {
  return nullableCompare(month1, month2, function() {
    return isSameYear(generateConfig2, month1, month2) && generateConfig2.getMonth(month1) === generateConfig2.getMonth(month2);
  });
}
function isSameDate(generateConfig2, date1, date22) {
  return nullableCompare(date1, date22, function() {
    return isSameYear(generateConfig2, date1, date22) && isSameMonth(generateConfig2, date1, date22) && generateConfig2.getDate(date1) === generateConfig2.getDate(date22);
  });
}
function isSameTime(generateConfig2, time1, time2) {
  return nullableCompare(time1, time2, function() {
    return generateConfig2.getHour(time1) === generateConfig2.getHour(time2) && generateConfig2.getMinute(time1) === generateConfig2.getMinute(time2) && generateConfig2.getSecond(time1) === generateConfig2.getSecond(time2);
  });
}
function isSameTimestamp(generateConfig2, time1, time2) {
  return nullableCompare(time1, time2, function() {
    return isSameDate(generateConfig2, time1, time2) && isSameTime(generateConfig2, time1, time2) && generateConfig2.getMillisecond(time1) === generateConfig2.getMillisecond(time2);
  });
}
function isSameWeek(generateConfig2, locale6, date1, date22) {
  return nullableCompare(date1, date22, function() {
    var weekStartDate1 = generateConfig2.locale.getWeekFirstDate(locale6, date1);
    var weekStartDate2 = generateConfig2.locale.getWeekFirstDate(locale6, date22);
    return isSameYear(generateConfig2, weekStartDate1, weekStartDate2) && generateConfig2.locale.getWeek(locale6, date1) === generateConfig2.locale.getWeek(locale6, date22);
  });
}
function isSame(generateConfig2, locale6, source, target, type5) {
  switch (type5) {
    case "date":
      return isSameDate(generateConfig2, source, target);
    case "week":
      return isSameWeek(generateConfig2, locale6.locale, source, target);
    case "month":
      return isSameMonth(generateConfig2, source, target);
    case "quarter":
      return isSameQuarter(generateConfig2, source, target);
    case "year":
      return isSameYear(generateConfig2, source, target);
    case "decade":
      return isSameDecade(generateConfig2, source, target);
    case "time":
      return isSameTime(generateConfig2, source, target);
    default:
      return isSameTimestamp(generateConfig2, source, target);
  }
}
function isInRange(generateConfig2, startDate, endDate, current2) {
  if (!startDate || !endDate || !current2) {
    return false;
  }
  return generateConfig2.isAfter(current2, startDate) && generateConfig2.isAfter(endDate, current2);
}
function isSameOrAfter(generateConfig2, locale6, date1, date22, type5) {
  if (isSame(generateConfig2, locale6, date1, date22, type5)) {
    return true;
  }
  return generateConfig2.isAfter(date1, date22);
}
function getWeekStartDate(locale6, generateConfig2, value) {
  var weekFirstDay = generateConfig2.locale.getWeekFirstDay(locale6);
  var monthStartDate = generateConfig2.setDate(value, 1);
  var startDateWeekDay = generateConfig2.getWeekDay(monthStartDate);
  var alignStartDate = generateConfig2.addDate(monthStartDate, weekFirstDay - startDateWeekDay);
  if (generateConfig2.getMonth(alignStartDate) === generateConfig2.getMonth(value) && generateConfig2.getDate(alignStartDate) > 1) {
    alignStartDate = generateConfig2.addDate(alignStartDate, -7);
  }
  return alignStartDate;
}
function formatValue(value, _ref) {
  var generateConfig2 = _ref.generateConfig, locale6 = _ref.locale, format3 = _ref.format;
  if (!value) {
    return "";
  }
  return typeof format3 === "function" ? format3(value) : generateConfig2.locale.format(locale6.locale, value, format3);
}
function fillTime(generateConfig2, date4, time) {
  var tmpDate = date4;
  var getFn = ["getHour", "getMinute", "getSecond", "getMillisecond"];
  var setFn = ["setHour", "setMinute", "setSecond", "setMillisecond"];
  setFn.forEach(function(fn, index3) {
    if (time) {
      tmpDate = generateConfig2[fn](tmpDate, generateConfig2[getFn[index3]](time));
    } else {
      tmpDate = generateConfig2[fn](tmpDate, 0);
    }
  });
  return tmpDate;
}

// ../../node_modules/rc-picker/es/PickerInput/hooks/useDisabledBoundary.js
function useDisabledBoundary(generateConfig2, locale6, disabledDate, minDate, maxDate) {
  var mergedDisabledDate = useEvent2(function(date4, info) {
    if (disabledDate && disabledDate(date4, info)) {
      return true;
    }
    if (minDate && generateConfig2.isAfter(minDate, date4) && !isSame(generateConfig2, locale6, minDate, date4, info.type)) {
      return true;
    }
    if (maxDate && generateConfig2.isAfter(date4, maxDate) && !isSame(generateConfig2, locale6, maxDate, date4, info.type)) {
      return true;
    }
    return false;
  });
  return mergedDisabledDate;
}

// ../../node_modules/rc-picker/es/PickerInput/hooks/useFieldFormat.js
var React235 = __toESM(require_react());
function useFieldFormat(picker, locale6, format3) {
  return React235.useMemo(function() {
    var rawFormat = getRowFormat(picker, locale6, format3);
    var formatList = toArray5(rawFormat);
    var firstFormat = formatList[0];
    var maskFormat = _typeof(firstFormat) === "object" && firstFormat.type === "mask" ? firstFormat.format : null;
    return [
      // Format list
      formatList.map(function(config) {
        return typeof config === "string" || typeof config === "function" ? config : config.format;
      }),
      // Mask Format
      maskFormat
    ];
  }, [picker, locale6, format3]);
}

// ../../node_modules/rc-picker/es/PickerInput/hooks/useInputReadOnly.js
function useInputReadOnly(formatList, inputReadOnly, multiple) {
  if (typeof formatList[0] === "function" || multiple) {
    return true;
  }
  return inputReadOnly;
}

// ../../node_modules/rc-picker/es/PickerInput/hooks/useInvalidate.js
function useInvalidate(generateConfig2, picker, disabledDate, showTime) {
  var isInvalidate = useEvent2(function(date4, info) {
    var outsideInfo = _objectSpread2({
      type: picker
    }, info);
    delete outsideInfo.activeIndex;
    if (
      // Date object is invalid
      !generateConfig2.isValidate(date4) || // Date is disabled by `disabledDate`
      disabledDate && disabledDate(date4, outsideInfo)
    ) {
      return true;
    }
    if ((picker === "date" || picker === "time") && showTime) {
      var _showTime$disabledTim;
      var range3 = info && info.activeIndex === 1 ? "end" : "start";
      var _ref = ((_showTime$disabledTim = showTime.disabledTime) === null || _showTime$disabledTim === void 0 ? void 0 : _showTime$disabledTim.call(showTime, date4, range3, {
        from: outsideInfo.from
      })) || {}, disabledHours = _ref.disabledHours, disabledMinutes = _ref.disabledMinutes, disabledSeconds = _ref.disabledSeconds, disabledMilliseconds = _ref.disabledMilliseconds;
      var legacyDisabledHours = showTime.disabledHours, legacyDisabledMinutes = showTime.disabledMinutes, legacyDisabledSeconds = showTime.disabledSeconds;
      var mergedDisabledHours = disabledHours || legacyDisabledHours;
      var mergedDisabledMinutes = disabledMinutes || legacyDisabledMinutes;
      var mergedDisabledSeconds = disabledSeconds || legacyDisabledSeconds;
      var hour = generateConfig2.getHour(date4);
      var minute = generateConfig2.getMinute(date4);
      var second = generateConfig2.getSecond(date4);
      var millisecond = generateConfig2.getMillisecond(date4);
      if (mergedDisabledHours && mergedDisabledHours().includes(hour)) {
        return true;
      }
      if (mergedDisabledMinutes && mergedDisabledMinutes(hour).includes(minute)) {
        return true;
      }
      if (mergedDisabledSeconds && mergedDisabledSeconds(hour, minute).includes(second)) {
        return true;
      }
      if (disabledMilliseconds && disabledMilliseconds(hour, minute, second).includes(millisecond)) {
        return true;
      }
    }
    return false;
  });
  return isInvalidate;
}

// ../../node_modules/rc-picker/es/PickerInput/hooks/useFilledProps.js
function useList(value) {
  var fillMode = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
  var values = React236.useMemo(function() {
    var list = value ? toArray5(value) : value;
    if (fillMode && list) {
      list[1] = list[1] || list[0];
    }
    return list;
  }, [value, fillMode]);
  return values;
}
function useFilledProps(props, updater) {
  var generateConfig2 = props.generateConfig, locale6 = props.locale, _props$picker = props.picker, picker = _props$picker === void 0 ? "date" : _props$picker, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-picker" : _props$prefixCls, _props$styles = props.styles, styles = _props$styles === void 0 ? {} : _props$styles, _props$classNames = props.classNames, classNames186 = _props$classNames === void 0 ? {} : _props$classNames, _props$order = props.order, order = _props$order === void 0 ? true : _props$order, _props$components = props.components, components = _props$components === void 0 ? {} : _props$components, inputRender = props.inputRender, allowClear = props.allowClear, clearIcon = props.clearIcon, needConfirm = props.needConfirm, multiple = props.multiple, format3 = props.format, inputReadOnly = props.inputReadOnly, disabledDate = props.disabledDate, minDate = props.minDate, maxDate = props.maxDate, showTime = props.showTime, value = props.value, defaultValue2 = props.defaultValue, pickerValue = props.pickerValue, defaultPickerValue = props.defaultPickerValue;
  var values = useList(value);
  var defaultValues = useList(defaultValue2);
  var pickerValues = useList(pickerValue);
  var defaultPickerValues = useList(defaultPickerValue);
  var internalPicker = picker === "date" && showTime ? "datetime" : picker;
  var multipleInteractivePicker = internalPicker === "time" || internalPicker === "datetime";
  var complexPicker = multipleInteractivePicker || multiple;
  var mergedNeedConfirm = needConfirm !== null && needConfirm !== void 0 ? needConfirm : multipleInteractivePicker;
  var _getTimeProps = getTimeProps(props), _getTimeProps2 = _slicedToArray(_getTimeProps, 4), timeProps = _getTimeProps2[0], localeTimeProps = _getTimeProps2[1], showTimeFormat = _getTimeProps2[2], propFormat = _getTimeProps2[3];
  var mergedLocale = useLocale2(locale6, localeTimeProps);
  var mergedShowTime = React236.useMemo(function() {
    return fillShowTimeConfig(internalPicker, showTimeFormat, propFormat, timeProps, mergedLocale);
  }, [internalPicker, showTimeFormat, propFormat, timeProps, mergedLocale]);
  if (picker === "time") {
    if (["disabledHours", "disabledMinutes", "disabledSeconds"].some(function(key2) {
      return props[key2];
    })) {
      warning_default(false, "'disabledHours', 'disabledMinutes', 'disabledSeconds' will be removed in the next major version, please use 'disabledTime' instead.");
    }
  }
  var filledProps = React236.useMemo(function() {
    return _objectSpread2(_objectSpread2({}, props), {}, {
      prefixCls,
      locale: mergedLocale,
      picker,
      styles,
      classNames: classNames186,
      order,
      components: _objectSpread2({
        input: inputRender
      }, components),
      clearIcon: fillClearIcon(prefixCls, allowClear, clearIcon),
      showTime: mergedShowTime,
      value: values,
      defaultValue: defaultValues,
      pickerValue: pickerValues,
      defaultPickerValue: defaultPickerValues
    }, updater === null || updater === void 0 ? void 0 : updater());
  }, [props]);
  var _useFieldFormat = useFieldFormat(internalPicker, mergedLocale, format3), _useFieldFormat2 = _slicedToArray(_useFieldFormat, 2), formatList = _useFieldFormat2[0], maskFormat = _useFieldFormat2[1];
  var mergedInputReadOnly = useInputReadOnly(formatList, inputReadOnly, multiple);
  var disabledBoundaryDate = useDisabledBoundary(generateConfig2, locale6, disabledDate, minDate, maxDate);
  var isInvalidateDate = useInvalidate(generateConfig2, picker, disabledBoundaryDate, mergedShowTime);
  var mergedProps = React236.useMemo(function() {
    return _objectSpread2(_objectSpread2({}, filledProps), {}, {
      needConfirm: mergedNeedConfirm,
      inputReadOnly: mergedInputReadOnly,
      disabledDate: disabledBoundaryDate
    });
  }, [filledProps, mergedNeedConfirm, mergedInputReadOnly, disabledBoundaryDate]);
  return [mergedProps, internalPicker, complexPicker, formatList, maskFormat, isInvalidateDate];
}

// ../../node_modules/rc-picker/es/PickerInput/hooks/useDelayState.js
var import_react85 = __toESM(require_react());
function useDelayState(value, defaultValue2, onChange) {
  var _useMergedState = useMergedState(defaultValue2, {
    value
  }), _useMergedState2 = _slicedToArray(_useMergedState, 2), state = _useMergedState2[0], setState = _useMergedState2[1];
  var nextValueRef = import_react85.default.useRef(value);
  var rafRef = import_react85.default.useRef();
  var cancelRaf = function cancelRaf2() {
    raf_default.cancel(rafRef.current);
  };
  var doUpdate = useEvent2(function() {
    setState(nextValueRef.current);
    if (onChange && state !== nextValueRef.current) {
      onChange(nextValueRef.current);
    }
  });
  var updateValue = useEvent2(function(next2, immediately) {
    cancelRaf();
    nextValueRef.current = next2;
    if (next2 || immediately) {
      doUpdate();
    } else {
      rafRef.current = raf_default(doUpdate);
    }
  });
  import_react85.default.useEffect(function() {
    return cancelRaf;
  }, []);
  return [state, updateValue];
}

// ../../node_modules/rc-picker/es/PickerInput/hooks/useOpen.js
function useOpen(open2, defaultOpen) {
  var disabledList = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
  var onOpenChange = arguments.length > 3 ? arguments[3] : void 0;
  var mergedOpen = disabledList.every(function(disabled) {
    return disabled;
  }) ? false : open2;
  var _useDelayState = useDelayState(mergedOpen, defaultOpen || false, onOpenChange), _useDelayState2 = _slicedToArray(_useDelayState, 2), rafOpen = _useDelayState2[0], setRafOpen = _useDelayState2[1];
  function setOpen(next2) {
    var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!config.inherit || rafOpen) {
      setRafOpen(next2, config.force);
    }
  }
  return [rafOpen, setOpen];
}

// ../../node_modules/rc-picker/es/PickerInput/hooks/usePickerRef.js
var React238 = __toESM(require_react());
function usePickerRef(ref3) {
  var selectorRef = React238.useRef();
  React238.useImperativeHandle(ref3, function() {
    var _selectorRef$current;
    return {
      nativeElement: (_selectorRef$current = selectorRef.current) === null || _selectorRef$current === void 0 ? void 0 : _selectorRef$current.nativeElement,
      focus: function focus(options) {
        var _selectorRef$current2;
        (_selectorRef$current2 = selectorRef.current) === null || _selectorRef$current2 === void 0 || _selectorRef$current2.focus(options);
      },
      blur: function blur() {
        var _selectorRef$current3;
        (_selectorRef$current3 = selectorRef.current) === null || _selectorRef$current3 === void 0 || _selectorRef$current3.blur();
      }
    };
  });
  return selectorRef;
}

// ../../node_modules/rc-picker/es/PickerInput/hooks/usePresets.js
var React239 = __toESM(require_react());
function usePresets(presets, legacyRanges) {
  return React239.useMemo(function() {
    if (presets) {
      return presets;
    }
    if (legacyRanges) {
      warning_default(false, "`ranges` is deprecated. Please use `presets` instead.");
      return Object.entries(legacyRanges).map(function(_ref) {
        var _ref2 = _slicedToArray(_ref, 2), label = _ref2[0], value = _ref2[1];
        return {
          label,
          value
        };
      });
    }
    return [];
  }, [presets, legacyRanges]);
}

// ../../node_modules/rc-picker/es/PickerInput/hooks/useRangeActive.js
var React241 = __toESM(require_react());

// ../../node_modules/rc-picker/es/PickerInput/hooks/useLockEffect.js
var React240 = __toESM(require_react());
function useLockEffect(condition, callback) {
  var delayFrames = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
  var callbackRef = React240.useRef(callback);
  callbackRef.current = callback;
  useLayoutUpdateEffect(function() {
    if (condition) {
      callbackRef.current(condition);
    } else {
      var id = raf_default(function() {
        callbackRef.current(condition);
      }, delayFrames);
      return function() {
        raf_default.cancel(id);
      };
    }
  }, [condition]);
}

// ../../node_modules/rc-picker/es/PickerInput/hooks/useRangeActive.js
function useRangeActive(disabled) {
  var empty3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  var mergedOpen = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
  var _React$useState = React241.useState(0), _React$useState2 = _slicedToArray(_React$useState, 2), activeIndex = _React$useState2[0], setActiveIndex = _React$useState2[1];
  var _React$useState3 = React241.useState(false), _React$useState4 = _slicedToArray(_React$useState3, 2), focused = _React$useState4[0], setFocused = _React$useState4[1];
  var activeListRef = React241.useRef([]);
  var submitIndexRef = React241.useRef(null);
  var lastOperationRef = React241.useRef(null);
  var updateSubmitIndex = function updateSubmitIndex2(index3) {
    submitIndexRef.current = index3;
  };
  var hasActiveSubmitValue = function hasActiveSubmitValue2(index3) {
    return submitIndexRef.current === index3;
  };
  var triggerFocus2 = function triggerFocus3(nextFocus) {
    setFocused(nextFocus);
  };
  var lastOperation = function lastOperation2(type5) {
    if (type5) {
      lastOperationRef.current = type5;
    }
    return lastOperationRef.current;
  };
  var nextActiveIndex = function nextActiveIndex2(nextValue) {
    var list = activeListRef.current;
    var filledActiveSet = new Set(list.filter(function(index3) {
      return nextValue[index3] || empty3[index3];
    }));
    var nextIndex2 = list[list.length - 1] === 0 ? 1 : 0;
    if (filledActiveSet.size >= 2 || disabled[nextIndex2]) {
      return null;
    }
    return nextIndex2;
  };
  useLockEffect(focused || mergedOpen, function() {
    if (!focused) {
      activeListRef.current = [];
      updateSubmitIndex(null);
    }
  });
  React241.useEffect(function() {
    if (focused) {
      activeListRef.current.push(activeIndex);
    }
  }, [focused, activeIndex]);
  return [focused, triggerFocus2, lastOperation, activeIndex, setActiveIndex, nextActiveIndex, activeListRef.current, updateSubmitIndex, hasActiveSubmitValue];
}

// ../../node_modules/rc-picker/es/PickerInput/hooks/useRangeDisabledDate.js
function useRangeDisabledDate(values, disabled, activeIndexList, generateConfig2, locale6, disabledDate) {
  var activeIndex = activeIndexList[activeIndexList.length - 1];
  var rangeDisabledDate = function rangeDisabledDate2(date4, info) {
    var _values = _slicedToArray(values, 2), start = _values[0], end = _values[1];
    var mergedInfo = _objectSpread2(_objectSpread2({}, info), {}, {
      from: getFromDate(values, activeIndexList)
    });
    if (activeIndex === 1 && disabled[0] && start && // Same date isOK
    !isSame(generateConfig2, locale6, start, date4, mergedInfo.type) && // Before start date
    generateConfig2.isAfter(start, date4)) {
      return true;
    }
    if (activeIndex === 0 && disabled[1] && end && // Same date isOK
    !isSame(generateConfig2, locale6, end, date4, mergedInfo.type) && // After end date
    generateConfig2.isAfter(date4, end)) {
      return true;
    }
    return disabledDate === null || disabledDate === void 0 ? void 0 : disabledDate(date4, mergedInfo);
  };
  return rangeDisabledDate;
}

// ../../node_modules/rc-picker/es/PickerInput/hooks/useRangePickerValue.js
var React242 = __toESM(require_react());
function offsetPanelDate(generateConfig2, picker, date4, offset4) {
  switch (picker) {
    case "date":
    case "week":
      return generateConfig2.addMonth(date4, offset4);
    case "month":
    case "quarter":
      return generateConfig2.addYear(date4, offset4);
    case "year":
      return generateConfig2.addYear(date4, offset4 * 10);
    case "decade":
      return generateConfig2.addYear(date4, offset4 * 100);
    default:
      return date4;
  }
}
var EMPTY_LIST3 = [];
function useRangePickerValue(generateConfig2, locale6, calendarValue, modes, open2, activeIndex, pickerMode, multiplePanel) {
  var defaultPickerValue = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : EMPTY_LIST3;
  var pickerValue = arguments.length > 9 && arguments[9] !== void 0 ? arguments[9] : EMPTY_LIST3;
  var timeDefaultValue = arguments.length > 10 && arguments[10] !== void 0 ? arguments[10] : EMPTY_LIST3;
  var onPickerValueChange = arguments.length > 11 ? arguments[11] : void 0;
  var minDate = arguments.length > 12 ? arguments[12] : void 0;
  var maxDate = arguments.length > 13 ? arguments[13] : void 0;
  var isTimePicker = pickerMode === "time";
  var mergedActiveIndex = activeIndex || 0;
  var getDefaultPickerValue = function getDefaultPickerValue2(index3) {
    var now4 = generateConfig2.getNow();
    if (isTimePicker) {
      now4 = fillTime(generateConfig2, now4);
    }
    return defaultPickerValue[index3] || calendarValue[index3] || now4;
  };
  var _pickerValue = _slicedToArray(pickerValue, 2), startPickerValue = _pickerValue[0], endPickerValue = _pickerValue[1];
  var _useMergedState = useMergedState(function() {
    return getDefaultPickerValue(0);
  }, {
    value: startPickerValue
  }), _useMergedState2 = _slicedToArray(_useMergedState, 2), mergedStartPickerValue = _useMergedState2[0], setStartPickerValue = _useMergedState2[1];
  var _useMergedState3 = useMergedState(function() {
    return getDefaultPickerValue(1);
  }, {
    value: endPickerValue
  }), _useMergedState4 = _slicedToArray(_useMergedState3, 2), mergedEndPickerValue = _useMergedState4[0], setEndPickerValue = _useMergedState4[1];
  var currentPickerValue = React242.useMemo(function() {
    var current2 = [mergedStartPickerValue, mergedEndPickerValue][mergedActiveIndex];
    return isTimePicker ? current2 : fillTime(generateConfig2, current2, timeDefaultValue[mergedActiveIndex]);
  }, [isTimePicker, mergedStartPickerValue, mergedEndPickerValue, mergedActiveIndex, generateConfig2, timeDefaultValue]);
  var setCurrentPickerValue = function setCurrentPickerValue2(nextPickerValue) {
    var source = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "panel";
    var updater = [setStartPickerValue, setEndPickerValue][mergedActiveIndex];
    updater(nextPickerValue);
    var clone = [mergedStartPickerValue, mergedEndPickerValue];
    clone[mergedActiveIndex] = nextPickerValue;
    if (onPickerValueChange && (!isSame(generateConfig2, locale6, mergedStartPickerValue, clone[0], pickerMode) || !isSame(generateConfig2, locale6, mergedEndPickerValue, clone[1], pickerMode))) {
      onPickerValueChange(clone, {
        source,
        range: mergedActiveIndex === 1 ? "end" : "start",
        mode: modes
      });
    }
  };
  var getEndDatePickerValue = function getEndDatePickerValue2(startDate, endDate) {
    if (multiplePanel) {
      var SAME_CHECKER = {
        date: "month",
        week: "month",
        month: "year",
        quarter: "year"
      };
      var mode = SAME_CHECKER[pickerMode];
      if (mode && !isSame(generateConfig2, locale6, startDate, endDate, mode)) {
        return offsetPanelDate(generateConfig2, pickerMode, endDate, -1);
      }
      if (pickerMode === "year" && startDate) {
        var srcYear = Math.floor(generateConfig2.getYear(startDate) / 10);
        var tgtYear = Math.floor(generateConfig2.getYear(endDate) / 10);
        if (srcYear !== tgtYear) {
          return offsetPanelDate(generateConfig2, pickerMode, endDate, -1);
        }
      }
    }
    return endDate;
  };
  var prevActiveIndexRef = React242.useRef(null);
  useLayoutEffect_default(function() {
    if (open2) {
      if (!defaultPickerValue[mergedActiveIndex]) {
        var nextPickerValue = isTimePicker ? null : generateConfig2.getNow();
        if (prevActiveIndexRef.current !== null && prevActiveIndexRef.current !== mergedActiveIndex) {
          nextPickerValue = [mergedStartPickerValue, mergedEndPickerValue][mergedActiveIndex ^ 1];
        } else if (calendarValue[mergedActiveIndex]) {
          nextPickerValue = mergedActiveIndex === 0 ? calendarValue[0] : getEndDatePickerValue(calendarValue[0], calendarValue[1]);
        } else if (calendarValue[mergedActiveIndex ^ 1]) {
          nextPickerValue = calendarValue[mergedActiveIndex ^ 1];
        }
        if (nextPickerValue) {
          if (minDate && generateConfig2.isAfter(minDate, nextPickerValue)) {
            nextPickerValue = minDate;
          }
          var offsetPickerValue = multiplePanel ? offsetPanelDate(generateConfig2, pickerMode, nextPickerValue, 1) : nextPickerValue;
          if (maxDate && generateConfig2.isAfter(offsetPickerValue, maxDate)) {
            nextPickerValue = multiplePanel ? offsetPanelDate(generateConfig2, pickerMode, maxDate, -1) : maxDate;
          }
          setCurrentPickerValue(nextPickerValue, "reset");
        }
      }
    }
  }, [open2, mergedActiveIndex, calendarValue[mergedActiveIndex]]);
  React242.useEffect(function() {
    if (open2) {
      prevActiveIndexRef.current = mergedActiveIndex;
    } else {
      prevActiveIndexRef.current = null;
    }
  }, [open2, mergedActiveIndex]);
  useLayoutEffect_default(function() {
    if (open2 && defaultPickerValue) {
      if (defaultPickerValue[mergedActiveIndex]) {
        setCurrentPickerValue(defaultPickerValue[mergedActiveIndex], "reset");
      }
    }
  }, [open2, mergedActiveIndex]);
  return [currentPickerValue, setCurrentPickerValue];
}

// ../../node_modules/rc-picker/es/PickerInput/hooks/useRangeValue.js
var React244 = __toESM(require_react());

// ../../node_modules/rc-picker/es/hooks/useSyncState.js
var React243 = __toESM(require_react());
function useSyncState2(defaultValue2, controlledValue) {
  var valueRef = React243.useRef(defaultValue2);
  var _React$useState = React243.useState({}), _React$useState2 = _slicedToArray(_React$useState, 2), forceUpdate = _React$useState2[1];
  var getter = function getter2(useControlledValueFirst) {
    return useControlledValueFirst && controlledValue !== void 0 ? controlledValue : valueRef.current;
  };
  var setter = function setter2(nextValue) {
    valueRef.current = nextValue;
    forceUpdate({});
  };
  return [getter, setter, getter(true)];
}

// ../../node_modules/rc-picker/es/PickerInput/hooks/useRangeValue.js
var EMPTY_VALUE = [];
function useUtil(generateConfig2, locale6, formatList) {
  var getDateTexts = function getDateTexts2(dates) {
    return dates.map(function(date4) {
      return formatValue(date4, {
        generateConfig: generateConfig2,
        locale: locale6,
        format: formatList[0]
      });
    });
  };
  var isSameDates = function isSameDates2(source, target) {
    var maxLen = Math.max(source.length, target.length);
    var diffIndex = -1;
    for (var i = 0; i < maxLen; i += 1) {
      var prev2 = source[i] || null;
      var next2 = target[i] || null;
      if (prev2 !== next2 && !isSameTimestamp(generateConfig2, prev2, next2)) {
        diffIndex = i;
        break;
      }
    }
    return [diffIndex < 0, diffIndex !== 0];
  };
  return [getDateTexts, isSameDates];
}
function orderDates(dates, generateConfig2) {
  return _toConsumableArray(dates).sort(function(a, b) {
    return generateConfig2.isAfter(a, b) ? 1 : -1;
  });
}
function useCalendarValue(mergedValue) {
  var _useSyncState = useSyncState2(mergedValue), _useSyncState2 = _slicedToArray(_useSyncState, 2), calendarValue = _useSyncState2[0], setCalendarValue = _useSyncState2[1];
  var syncWithValue = useEvent2(function() {
    setCalendarValue(mergedValue);
  });
  React244.useEffect(function() {
    syncWithValue();
  }, [mergedValue]);
  return [calendarValue, setCalendarValue];
}
function useInnerValue(generateConfig2, locale6, formatList, rangeValue, order, defaultValue2, value, onCalendarChange, onOk) {
  var _useMergedState = useMergedState(defaultValue2, {
    value
  }), _useMergedState2 = _slicedToArray(_useMergedState, 2), innerValue = _useMergedState2[0], setInnerValue = _useMergedState2[1];
  var mergedValue = innerValue || EMPTY_VALUE;
  var _useCalendarValue = useCalendarValue(mergedValue), _useCalendarValue2 = _slicedToArray(_useCalendarValue, 2), calendarValue = _useCalendarValue2[0], setCalendarValue = _useCalendarValue2[1];
  var _useUtil = useUtil(generateConfig2, locale6, formatList), _useUtil2 = _slicedToArray(_useUtil, 2), getDateTexts = _useUtil2[0], isSameDates = _useUtil2[1];
  var triggerCalendarChange = useEvent2(function(nextCalendarValues) {
    var clone = _toConsumableArray(nextCalendarValues);
    if (rangeValue) {
      for (var i = 0; i < 2; i += 1) {
        clone[i] = clone[i] || null;
      }
    } else if (order) {
      clone = orderDates(clone.filter(function(date4) {
        return date4;
      }), generateConfig2);
    }
    var _isSameDates = isSameDates(calendarValue(), clone), _isSameDates2 = _slicedToArray(_isSameDates, 2), isSameMergedDates = _isSameDates2[0], isSameStart = _isSameDates2[1];
    if (!isSameMergedDates) {
      setCalendarValue(clone);
      if (onCalendarChange) {
        var cellTexts = getDateTexts(clone);
        onCalendarChange(clone, cellTexts, {
          range: isSameStart ? "end" : "start"
        });
      }
    }
  });
  var triggerOk = function triggerOk2() {
    if (onOk) {
      onOk(calendarValue());
    }
  };
  return [mergedValue, setInnerValue, calendarValue, triggerCalendarChange, triggerOk];
}
function useRangeValue(info, mergedValue, setInnerValue, getCalendarValue, triggerCalendarChange, disabled, formatList, focused, open2, isInvalidateDate) {
  var generateConfig2 = info.generateConfig, locale6 = info.locale, picker = info.picker, onChange = info.onChange, allowEmpty = info.allowEmpty, order = info.order;
  var orderOnChange = disabled.some(function(d) {
    return d;
  }) ? false : order;
  var _useUtil3 = useUtil(generateConfig2, locale6, formatList), _useUtil4 = _slicedToArray(_useUtil3, 2), getDateTexts = _useUtil4[0], isSameDates = _useUtil4[1];
  var _useSyncState3 = useSyncState2(mergedValue), _useSyncState4 = _slicedToArray(_useSyncState3, 2), submitValue = _useSyncState4[0], setSubmitValue = _useSyncState4[1];
  var syncWithValue = useEvent2(function() {
    setSubmitValue(mergedValue);
  });
  React244.useEffect(function() {
    syncWithValue();
  }, [mergedValue]);
  var triggerSubmit = useEvent2(function(nextValue) {
    var isNullValue = nextValue === null;
    var clone = _toConsumableArray(nextValue || submitValue());
    if (isNullValue) {
      var maxLen = Math.max(disabled.length, clone.length);
      for (var i = 0; i < maxLen; i += 1) {
        if (!disabled[i]) {
          clone[i] = null;
        }
      }
    }
    if (orderOnChange && clone[0] && clone[1]) {
      clone = orderDates(clone, generateConfig2);
    }
    triggerCalendarChange(clone);
    var _clone = clone, _clone2 = _slicedToArray(_clone, 2), start = _clone2[0], end = _clone2[1];
    var startEmpty = !start;
    var endEmpty = !end;
    var validateEmptyDateRange = allowEmpty ? (
      // Validate empty start
      (!startEmpty || allowEmpty[0]) && // Validate empty end
      (!endEmpty || allowEmpty[1])
    ) : true;
    var validateOrder = !order || startEmpty || endEmpty || isSame(generateConfig2, locale6, start, end, picker) || generateConfig2.isAfter(end, start);
    var validateDates = (
      // Validate start
      (disabled[0] || !start || !isInvalidateDate(start, {
        activeIndex: 0
      })) && // Validate end
      (disabled[1] || !end || !isInvalidateDate(end, {
        from: start,
        activeIndex: 1
      }))
    );
    var allPassed = (
      // Null value is from clear button
      isNullValue || // Normal check
      validateEmptyDateRange && validateOrder && validateDates
    );
    if (allPassed) {
      setInnerValue(clone);
      var _isSameDates3 = isSameDates(clone, mergedValue), _isSameDates4 = _slicedToArray(_isSameDates3, 1), isSameMergedDates = _isSameDates4[0];
      if (onChange && !isSameMergedDates) {
        onChange(
          // Return null directly if all date are empty
          isNullValue && clone.every(function(val) {
            return !val;
          }) ? null : clone,
          getDateTexts(clone)
        );
      }
    }
    return allPassed;
  });
  var flushSubmit = useEvent2(function(index3, needTriggerChange) {
    var nextSubmitValue = fillIndex(submitValue(), index3, getCalendarValue()[index3]);
    setSubmitValue(nextSubmitValue);
    if (needTriggerChange) {
      triggerSubmit();
    }
  });
  var interactiveFinished = !focused && !open2;
  useLockEffect(!interactiveFinished, function() {
    if (interactiveFinished) {
      triggerSubmit();
      triggerCalendarChange(mergedValue);
      syncWithValue();
    }
  }, 2);
  return [flushSubmit, triggerSubmit];
}

// ../../node_modules/rc-picker/es/PickerInput/hooks/useShowNow.js
function useShowNow(picker, mode, showNow, showToday, rangePicker) {
  if (mode !== "date" && mode !== "time") {
    return false;
  }
  if (showNow !== void 0) {
    return showNow;
  }
  if (showToday !== void 0) {
    return showToday;
  }
  return !rangePicker && (picker === "date" || picker === "time");
}

// ../../node_modules/rc-picker/es/PickerInput/Popup/index.js
var import_classnames86 = __toESM(require_classnames());
var React264 = __toESM(require_react());

// ../../node_modules/rc-picker/es/PickerInput/Popup/Footer.js
var import_classnames78 = __toESM(require_classnames());
var React246 = __toESM(require_react());

// ../../node_modules/rc-picker/es/hooks/useTimeInfo.js
var React245 = __toESM(require_react());

// ../../node_modules/rc-picker/es/PickerPanel/TimePanel/TimePanelBody/util.js
function findValidateTime(date4, getHourUnits, getMinuteUnits, getSecondUnits, getMillisecondUnits, generateConfig2) {
  var nextDate = date4;
  function alignValidate(getUnitValue3, setUnitValue, units) {
    var nextValue = generateConfig2[getUnitValue3](nextDate);
    var nextUnit = units.find(function(unit3) {
      return unit3.value === nextValue;
    });
    if (!nextUnit || nextUnit.disabled) {
      var validateUnits = units.filter(function(unit3) {
        return !unit3.disabled;
      });
      var reverseEnabledUnits = _toConsumableArray(validateUnits).reverse();
      var validateUnit = reverseEnabledUnits.find(function(unit3) {
        return unit3.value <= nextValue;
      }) || validateUnits[0];
      if (validateUnit) {
        nextValue = validateUnit.value;
        nextDate = generateConfig2[setUnitValue](nextDate, nextValue);
      }
    }
    return nextValue;
  }
  var nextHour = alignValidate("getHour", "setHour", getHourUnits());
  var nextMinute = alignValidate("getMinute", "setMinute", getMinuteUnits(nextHour));
  var nextSecond = alignValidate("getSecond", "setSecond", getSecondUnits(nextHour, nextMinute));
  alignValidate("getMillisecond", "setMillisecond", getMillisecondUnits(nextHour, nextMinute, nextSecond));
  return nextDate;
}

// ../../node_modules/rc-picker/es/hooks/useTimeInfo.js
function emptyDisabled() {
  return [];
}
function generateUnits(start, end) {
  var step = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
  var hideDisabledOptions = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
  var disabledUnits = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : [];
  var pad = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 2;
  var units = [];
  var integerStep = step >= 1 ? step | 0 : 1;
  for (var i = start; i <= end; i += integerStep) {
    var disabled = disabledUnits.includes(i);
    if (!disabled || !hideDisabledOptions) {
      units.push({
        label: leftPad(i, pad),
        value: i,
        disabled
      });
    }
  }
  return units;
}
function useTimeInfo(generateConfig2) {
  var props = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var date4 = arguments.length > 2 ? arguments[2] : void 0;
  var _ref = props || {}, use12Hours = _ref.use12Hours, _ref$hourStep = _ref.hourStep, hourStep = _ref$hourStep === void 0 ? 1 : _ref$hourStep, _ref$minuteStep = _ref.minuteStep, minuteStep = _ref$minuteStep === void 0 ? 1 : _ref$minuteStep, _ref$secondStep = _ref.secondStep, secondStep = _ref$secondStep === void 0 ? 1 : _ref$secondStep, _ref$millisecondStep = _ref.millisecondStep, millisecondStep = _ref$millisecondStep === void 0 ? 100 : _ref$millisecondStep, hideDisabledOptions = _ref.hideDisabledOptions, disabledTime = _ref.disabledTime, disabledHours = _ref.disabledHours, disabledMinutes = _ref.disabledMinutes, disabledSeconds = _ref.disabledSeconds;
  var mergedDate = React245.useMemo(function() {
    return date4 || generateConfig2.getNow();
  }, [date4, generateConfig2]);
  if (true) {
    var isHourStepValid = 24 % hourStep === 0;
    var isMinuteStepValid = 60 % minuteStep === 0;
    var isSecondStepValid = 60 % secondStep === 0;
    warning_default(isHourStepValid, "`hourStep` ".concat(hourStep, " is invalid. It should be a factor of 24."));
    warning_default(isMinuteStepValid, "`minuteStep` ".concat(minuteStep, " is invalid. It should be a factor of 60."));
    warning_default(isSecondStepValid, "`secondStep` ".concat(secondStep, " is invalid. It should be a factor of 60."));
  }
  var getDisabledTimes = React245.useCallback(function(targetDate) {
    var disabledConfig = (disabledTime === null || disabledTime === void 0 ? void 0 : disabledTime(targetDate)) || {};
    return [disabledConfig.disabledHours || disabledHours || emptyDisabled, disabledConfig.disabledMinutes || disabledMinutes || emptyDisabled, disabledConfig.disabledSeconds || disabledSeconds || emptyDisabled, disabledConfig.disabledMilliseconds || emptyDisabled];
  }, [disabledTime, disabledHours, disabledMinutes, disabledSeconds]);
  var _React$useMemo = React245.useMemo(function() {
    return getDisabledTimes(mergedDate);
  }, [mergedDate, getDisabledTimes]), _React$useMemo2 = _slicedToArray(_React$useMemo, 4), mergedDisabledHours = _React$useMemo2[0], mergedDisabledMinutes = _React$useMemo2[1], mergedDisabledSeconds = _React$useMemo2[2], mergedDisabledMilliseconds = _React$useMemo2[3];
  var getAllUnits = React245.useCallback(function(getDisabledHours, getDisabledMinutes, getDisabledSeconds, getDisabledMilliseconds) {
    var hours = generateUnits(0, 23, hourStep, hideDisabledOptions, getDisabledHours());
    var rowHourUnits2 = use12Hours ? hours.map(function(unit3) {
      return _objectSpread2(_objectSpread2({}, unit3), {}, {
        label: leftPad(unit3.value % 12 || 12, 2)
      });
    }) : hours;
    var getMinuteUnits2 = function getMinuteUnits3(nextHour) {
      return generateUnits(0, 59, minuteStep, hideDisabledOptions, getDisabledMinutes(nextHour));
    };
    var getSecondUnits2 = function getSecondUnits3(nextHour, nextMinute) {
      return generateUnits(0, 59, secondStep, hideDisabledOptions, getDisabledSeconds(nextHour, nextMinute));
    };
    var getMillisecondUnits2 = function getMillisecondUnits3(nextHour, nextMinute, nextSecond) {
      return generateUnits(0, 999, millisecondStep, hideDisabledOptions, getDisabledMilliseconds(nextHour, nextMinute, nextSecond), 3);
    };
    return [rowHourUnits2, getMinuteUnits2, getSecondUnits2, getMillisecondUnits2];
  }, [hideDisabledOptions, hourStep, use12Hours, millisecondStep, minuteStep, secondStep]);
  var _React$useMemo3 = React245.useMemo(function() {
    return getAllUnits(mergedDisabledHours, mergedDisabledMinutes, mergedDisabledSeconds, mergedDisabledMilliseconds);
  }, [getAllUnits, mergedDisabledHours, mergedDisabledMinutes, mergedDisabledSeconds, mergedDisabledMilliseconds]), _React$useMemo4 = _slicedToArray(_React$useMemo3, 4), rowHourUnits = _React$useMemo4[0], getMinuteUnits = _React$useMemo4[1], getSecondUnits = _React$useMemo4[2], getMillisecondUnits = _React$useMemo4[3];
  var getValidTime = function getValidTime2(nextTime, certainDate) {
    var getCheckHourUnits = function getCheckHourUnits2() {
      return rowHourUnits;
    };
    var getCheckMinuteUnits = getMinuteUnits;
    var getCheckSecondUnits = getSecondUnits;
    var getCheckMillisecondUnits = getMillisecondUnits;
    if (certainDate) {
      var _getDisabledTimes = getDisabledTimes(certainDate), _getDisabledTimes2 = _slicedToArray(_getDisabledTimes, 4), targetDisabledHours = _getDisabledTimes2[0], targetDisabledMinutes = _getDisabledTimes2[1], targetDisabledSeconds = _getDisabledTimes2[2], targetDisabledMilliseconds = _getDisabledTimes2[3];
      var _getAllUnits = getAllUnits(targetDisabledHours, targetDisabledMinutes, targetDisabledSeconds, targetDisabledMilliseconds), _getAllUnits2 = _slicedToArray(_getAllUnits, 4), targetRowHourUnits = _getAllUnits2[0], targetGetMinuteUnits = _getAllUnits2[1], targetGetSecondUnits = _getAllUnits2[2], targetGetMillisecondUnits = _getAllUnits2[3];
      getCheckHourUnits = function getCheckHourUnits2() {
        return targetRowHourUnits;
      };
      getCheckMinuteUnits = targetGetMinuteUnits;
      getCheckSecondUnits = targetGetSecondUnits;
      getCheckMillisecondUnits = targetGetMillisecondUnits;
    }
    var validateDate = findValidateTime(nextTime, getCheckHourUnits, getCheckMinuteUnits, getCheckSecondUnits, getCheckMillisecondUnits, generateConfig2);
    return validateDate;
  };
  return [
    // getValidTime
    getValidTime,
    // Units
    rowHourUnits,
    getMinuteUnits,
    getSecondUnits,
    getMillisecondUnits
  ];
}

// ../../node_modules/rc-picker/es/PickerInput/Popup/Footer.js
function Footer(props) {
  var mode = props.mode, internalMode = props.internalMode, renderExtraFooter = props.renderExtraFooter, showNow = props.showNow, showTime = props.showTime, onSubmit = props.onSubmit, onNow = props.onNow, invalid = props.invalid, needConfirm = props.needConfirm, generateConfig2 = props.generateConfig, disabledDate = props.disabledDate;
  var _React$useContext = React246.useContext(context_default3), prefixCls = _React$useContext.prefixCls, locale6 = _React$useContext.locale, _React$useContext$but = _React$useContext.button, Button2 = _React$useContext$but === void 0 ? "button" : _React$useContext$but;
  var now4 = generateConfig2.getNow();
  var _useTimeInfo = useTimeInfo(generateConfig2, showTime, now4), _useTimeInfo2 = _slicedToArray(_useTimeInfo, 1), getValidTime = _useTimeInfo2[0];
  var extraNode = renderExtraFooter === null || renderExtraFooter === void 0 ? void 0 : renderExtraFooter(mode);
  var nowDisabled = disabledDate(now4, {
    type: mode
  });
  var onInternalNow = function onInternalNow2() {
    if (!nowDisabled) {
      var validateNow = getValidTime(now4);
      onNow(validateNow);
    }
  };
  var nowPrefixCls = "".concat(prefixCls, "-now");
  var nowBtnPrefixCls = "".concat(nowPrefixCls, "-btn");
  var presetNode = showNow && /* @__PURE__ */ React246.createElement("li", {
    className: nowPrefixCls
  }, /* @__PURE__ */ React246.createElement("a", {
    className: (0, import_classnames78.default)(nowBtnPrefixCls, nowDisabled && "".concat(nowBtnPrefixCls, "-disabled")),
    "aria-disabled": nowDisabled,
    onClick: onInternalNow
  }, internalMode === "date" ? locale6.today : locale6.now));
  var okNode = needConfirm && /* @__PURE__ */ React246.createElement("li", {
    className: "".concat(prefixCls, "-ok")
  }, /* @__PURE__ */ React246.createElement(Button2, {
    disabled: invalid,
    onClick: onSubmit
  }, locale6.ok));
  var rangeNode = (presetNode || okNode) && /* @__PURE__ */ React246.createElement("ul", {
    className: "".concat(prefixCls, "-ranges")
  }, presetNode, okNode);
  if (!extraNode && !rangeNode) {
    return null;
  }
  return /* @__PURE__ */ React246.createElement("div", {
    className: "".concat(prefixCls, "-footer")
  }, extraNode && /* @__PURE__ */ React246.createElement("div", {
    className: "".concat(prefixCls, "-footer-extra")
  }, extraNode), rangeNode);
}

// ../../node_modules/rc-picker/es/PickerInput/Popup/PopupPanel.js
var React262 = __toESM(require_react());

// ../../node_modules/rc-picker/es/PickerPanel/index.js
var import_classnames85 = __toESM(require_classnames());
var React261 = __toESM(require_react());

// ../../node_modules/rc-picker/es/hooks/useToggleDates.js
function useToggleDates(generateConfig2, locale6, panelMode) {
  function toggleDates(list, target) {
    var index3 = list.findIndex(function(date4) {
      return isSame(generateConfig2, locale6, date4, target, panelMode);
    });
    if (index3 === -1) {
      return [].concat(_toConsumableArray(list), [target]);
    }
    var sliceList = _toConsumableArray(list);
    sliceList.splice(index3, 1);
    return sliceList;
  }
  return toggleDates;
}

// ../../node_modules/rc-picker/es/PickerPanel/context.js
var React247 = __toESM(require_react());
var PanelContext = /* @__PURE__ */ React247.createContext(null);
function usePanelContext() {
  return React247.useContext(PanelContext);
}
function useInfo(props, panelType) {
  var prefixCls = props.prefixCls, generateConfig2 = props.generateConfig, locale6 = props.locale, disabledDate = props.disabledDate, minDate = props.minDate, maxDate = props.maxDate, cellRender = props.cellRender, hoverValue = props.hoverValue, hoverRangeValue = props.hoverRangeValue, onHover = props.onHover, values = props.values, pickerValue = props.pickerValue, onSelect = props.onSelect, prevIcon = props.prevIcon, nextIcon = props.nextIcon, superPrevIcon = props.superPrevIcon, superNextIcon = props.superNextIcon;
  var now4 = generateConfig2.getNow();
  var info = {
    now: now4,
    values,
    pickerValue,
    prefixCls,
    disabledDate,
    minDate,
    maxDate,
    cellRender,
    hoverValue,
    hoverRangeValue,
    onHover,
    locale: locale6,
    generateConfig: generateConfig2,
    onSelect,
    panelType,
    // Icons
    prevIcon,
    nextIcon,
    superPrevIcon,
    superNextIcon
  };
  return [info, now4];
}
var PickerHackContext = /* @__PURE__ */ React247.createContext({});
if (true) {
  PickerHackContext.displayName = "PickerHackContext";
}

// ../../node_modules/rc-picker/es/PickerPanel/DatePanel/index.js
var import_classnames81 = __toESM(require_classnames());
var React250 = __toESM(require_react());

// ../../node_modules/rc-picker/es/PickerPanel/PanelBody.js
var import_classnames79 = __toESM(require_classnames());
var React248 = __toESM(require_react());
function PanelBody(props) {
  var rowNum = props.rowNum, colNum = props.colNum, baseDate = props.baseDate, getCellDate = props.getCellDate, prefixColumn = props.prefixColumn, rowClassName = props.rowClassName, titleFormat = props.titleFormat, getCellText = props.getCellText, getCellClassName = props.getCellClassName, headerCells = props.headerCells, _props$cellSelection = props.cellSelection, cellSelection = _props$cellSelection === void 0 ? true : _props$cellSelection, disabledDate = props.disabledDate;
  var _usePanelContext = usePanelContext(), prefixCls = _usePanelContext.prefixCls, type5 = _usePanelContext.panelType, now4 = _usePanelContext.now, contextDisabledDate = _usePanelContext.disabledDate, cellRender = _usePanelContext.cellRender, onHover = _usePanelContext.onHover, hoverValue = _usePanelContext.hoverValue, hoverRangeValue = _usePanelContext.hoverRangeValue, generateConfig2 = _usePanelContext.generateConfig, values = _usePanelContext.values, locale6 = _usePanelContext.locale, onSelect = _usePanelContext.onSelect;
  var mergedDisabledDate = disabledDate || contextDisabledDate;
  var cellPrefixCls = "".concat(prefixCls, "-cell");
  var _React$useContext = React248.useContext(PickerHackContext), onCellDblClick = _React$useContext.onCellDblClick;
  var matchValues = function matchValues2(date4) {
    return values.some(function(singleValue) {
      return singleValue && isSame(generateConfig2, locale6, date4, singleValue, type5);
    });
  };
  var rows = [];
  for (var row = 0; row < rowNum; row += 1) {
    var rowNode = [];
    var rowStartDate = void 0;
    var _loop = function _loop2() {
      var offset4 = row * colNum + col;
      var currentDate = getCellDate(baseDate, offset4);
      var disabled = mergedDisabledDate === null || mergedDisabledDate === void 0 ? void 0 : mergedDisabledDate(currentDate, {
        type: type5
      });
      if (col === 0) {
        rowStartDate = currentDate;
        if (prefixColumn) {
          rowNode.push(prefixColumn(rowStartDate));
        }
      }
      var inRange = false;
      var rangeStart = false;
      var rangeEnd = false;
      if (cellSelection && hoverRangeValue) {
        var _hoverRangeValue = _slicedToArray(hoverRangeValue, 2), hoverStart = _hoverRangeValue[0], hoverEnd = _hoverRangeValue[1];
        inRange = isInRange(generateConfig2, hoverStart, hoverEnd, currentDate);
        rangeStart = isSame(generateConfig2, locale6, currentDate, hoverStart, type5);
        rangeEnd = isSame(generateConfig2, locale6, currentDate, hoverEnd, type5);
      }
      var title = titleFormat ? formatValue(currentDate, {
        locale: locale6,
        format: titleFormat,
        generateConfig: generateConfig2
      }) : void 0;
      var inner = /* @__PURE__ */ React248.createElement("div", {
        className: "".concat(cellPrefixCls, "-inner")
      }, getCellText(currentDate));
      rowNode.push(/* @__PURE__ */ React248.createElement("td", {
        key: col,
        title,
        className: (0, import_classnames79.default)(cellPrefixCls, _objectSpread2(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "".concat(cellPrefixCls, "-disabled"), disabled), "".concat(cellPrefixCls, "-hover"), (hoverValue || []).some(function(date4) {
          return isSame(generateConfig2, locale6, currentDate, date4, type5);
        })), "".concat(cellPrefixCls, "-in-range"), inRange && !rangeStart && !rangeEnd), "".concat(cellPrefixCls, "-range-start"), rangeStart), "".concat(cellPrefixCls, "-range-end"), rangeEnd), "".concat(prefixCls, "-cell-selected"), !hoverRangeValue && // WeekPicker use row instead
        type5 !== "week" && matchValues(currentDate)), getCellClassName(currentDate))),
        onClick: function onClick() {
          if (!disabled) {
            onSelect(currentDate);
          }
        },
        onDoubleClick: function onDoubleClick() {
          if (!disabled && onCellDblClick) {
            onCellDblClick();
          }
        },
        onMouseEnter: function onMouseEnter() {
          if (!disabled) {
            onHover === null || onHover === void 0 || onHover(currentDate);
          }
        },
        onMouseLeave: function onMouseLeave() {
          if (!disabled) {
            onHover === null || onHover === void 0 || onHover(null);
          }
        }
      }, cellRender ? cellRender(currentDate, {
        prefixCls,
        originNode: inner,
        today: now4,
        type: type5,
        locale: locale6
      }) : inner));
    };
    for (var col = 0; col < colNum; col += 1) {
      _loop();
    }
    rows.push(/* @__PURE__ */ React248.createElement("tr", {
      key: row,
      className: rowClassName === null || rowClassName === void 0 ? void 0 : rowClassName(rowStartDate)
    }, rowNode));
  }
  return /* @__PURE__ */ React248.createElement("div", {
    className: "".concat(prefixCls, "-body")
  }, /* @__PURE__ */ React248.createElement("table", {
    className: "".concat(prefixCls, "-content")
  }, headerCells && /* @__PURE__ */ React248.createElement("thead", null, /* @__PURE__ */ React248.createElement("tr", null, headerCells)), /* @__PURE__ */ React248.createElement("tbody", null, rows)));
}

// ../../node_modules/rc-picker/es/PickerPanel/PanelHeader.js
var import_classnames80 = __toESM(require_classnames());
var React249 = __toESM(require_react());
var HIDDEN_STYLE = {
  visibility: "hidden"
};
function PanelHeader(props) {
  var offset4 = props.offset, superOffset = props.superOffset, onChange = props.onChange, getStart = props.getStart, getEnd = props.getEnd, children = props.children;
  var _usePanelContext = usePanelContext(), prefixCls = _usePanelContext.prefixCls, _usePanelContext$prev = _usePanelContext.prevIcon, prevIcon = _usePanelContext$prev === void 0 ? "\u2039" : _usePanelContext$prev, _usePanelContext$next = _usePanelContext.nextIcon, nextIcon = _usePanelContext$next === void 0 ? "\u203A" : _usePanelContext$next, _usePanelContext$supe = _usePanelContext.superPrevIcon, superPrevIcon = _usePanelContext$supe === void 0 ? "\xAB" : _usePanelContext$supe, _usePanelContext$supe2 = _usePanelContext.superNextIcon, superNextIcon = _usePanelContext$supe2 === void 0 ? "\xBB" : _usePanelContext$supe2, minDate = _usePanelContext.minDate, maxDate = _usePanelContext.maxDate, generateConfig2 = _usePanelContext.generateConfig, locale6 = _usePanelContext.locale, pickerValue = _usePanelContext.pickerValue, type5 = _usePanelContext.panelType;
  var headerPrefixCls = "".concat(prefixCls, "-header");
  var _React$useContext = React249.useContext(PickerHackContext), hidePrev = _React$useContext.hidePrev, hideNext = _React$useContext.hideNext, hideHeader = _React$useContext.hideHeader;
  var disabledOffsetPrev = React249.useMemo(function() {
    if (!minDate || !offset4 || !getEnd) {
      return false;
    }
    var prevPanelLimitDate = getEnd(offset4(-1, pickerValue));
    return !isSameOrAfter(generateConfig2, locale6, prevPanelLimitDate, minDate, type5);
  }, [minDate, offset4, pickerValue, getEnd, generateConfig2, locale6, type5]);
  var disabledSuperOffsetPrev = React249.useMemo(function() {
    if (!minDate || !superOffset || !getEnd) {
      return false;
    }
    var prevPanelLimitDate = getEnd(superOffset(-1, pickerValue));
    return !isSameOrAfter(generateConfig2, locale6, prevPanelLimitDate, minDate, type5);
  }, [minDate, superOffset, pickerValue, getEnd, generateConfig2, locale6, type5]);
  var disabledOffsetNext = React249.useMemo(function() {
    if (!maxDate || !offset4 || !getStart) {
      return false;
    }
    var nextPanelLimitDate = getStart(offset4(1, pickerValue));
    return !isSameOrAfter(generateConfig2, locale6, maxDate, nextPanelLimitDate, type5);
  }, [maxDate, offset4, pickerValue, getStart, generateConfig2, locale6, type5]);
  var disabledSuperOffsetNext = React249.useMemo(function() {
    if (!maxDate || !superOffset || !getStart) {
      return false;
    }
    var nextPanelLimitDate = getStart(superOffset(1, pickerValue));
    return !isSameOrAfter(generateConfig2, locale6, maxDate, nextPanelLimitDate, type5);
  }, [maxDate, superOffset, pickerValue, getStart, generateConfig2, locale6, type5]);
  var onOffset = function onOffset2(distance) {
    if (offset4) {
      onChange(offset4(distance, pickerValue));
    }
  };
  var onSuperOffset = function onSuperOffset2(distance) {
    if (superOffset) {
      onChange(superOffset(distance, pickerValue));
    }
  };
  if (hideHeader) {
    return null;
  }
  var prevBtnCls = "".concat(headerPrefixCls, "-prev-btn");
  var nextBtnCls = "".concat(headerPrefixCls, "-next-btn");
  var superPrevBtnCls = "".concat(headerPrefixCls, "-super-prev-btn");
  var superNextBtnCls = "".concat(headerPrefixCls, "-super-next-btn");
  return /* @__PURE__ */ React249.createElement("div", {
    className: headerPrefixCls
  }, superOffset && /* @__PURE__ */ React249.createElement("button", {
    type: "button",
    "aria-label": locale6.previousYear,
    onClick: function onClick() {
      return onSuperOffset(-1);
    },
    tabIndex: -1,
    className: (0, import_classnames80.default)(superPrevBtnCls, disabledSuperOffsetPrev && "".concat(superPrevBtnCls, "-disabled")),
    disabled: disabledSuperOffsetPrev,
    style: hidePrev ? HIDDEN_STYLE : {}
  }, superPrevIcon), offset4 && /* @__PURE__ */ React249.createElement("button", {
    type: "button",
    "aria-label": locale6.previousMonth,
    onClick: function onClick() {
      return onOffset(-1);
    },
    tabIndex: -1,
    className: (0, import_classnames80.default)(prevBtnCls, disabledOffsetPrev && "".concat(prevBtnCls, "-disabled")),
    disabled: disabledOffsetPrev,
    style: hidePrev ? HIDDEN_STYLE : {}
  }, prevIcon), /* @__PURE__ */ React249.createElement("div", {
    className: "".concat(headerPrefixCls, "-view")
  }, children), offset4 && /* @__PURE__ */ React249.createElement("button", {
    type: "button",
    "aria-label": locale6.nextMonth,
    onClick: function onClick() {
      return onOffset(1);
    },
    tabIndex: -1,
    className: (0, import_classnames80.default)(nextBtnCls, disabledOffsetNext && "".concat(nextBtnCls, "-disabled")),
    disabled: disabledOffsetNext,
    style: hideNext ? HIDDEN_STYLE : {}
  }, nextIcon), superOffset && /* @__PURE__ */ React249.createElement("button", {
    type: "button",
    "aria-label": locale6.nextYear,
    onClick: function onClick() {
      return onSuperOffset(1);
    },
    tabIndex: -1,
    className: (0, import_classnames80.default)(superNextBtnCls, disabledSuperOffsetNext && "".concat(superNextBtnCls, "-disabled")),
    disabled: disabledSuperOffsetNext,
    style: hideNext ? HIDDEN_STYLE : {}
  }, superNextIcon));
}
var PanelHeader_default = PanelHeader;

// ../../node_modules/rc-picker/es/PickerPanel/DatePanel/index.js
function DatePanel(props) {
  var prefixCls = props.prefixCls, _props$panelName = props.panelName, panelName = _props$panelName === void 0 ? "date" : _props$panelName, locale6 = props.locale, generateConfig2 = props.generateConfig, pickerValue = props.pickerValue, onPickerValueChange = props.onPickerValueChange, onModeChange = props.onModeChange, _props$mode = props.mode, mode = _props$mode === void 0 ? "date" : _props$mode, disabledDate = props.disabledDate, onSelect = props.onSelect, onHover = props.onHover, showWeek = props.showWeek;
  var panelPrefixCls = "".concat(prefixCls, "-").concat(panelName, "-panel");
  var cellPrefixCls = "".concat(prefixCls, "-cell");
  var isWeek = mode === "week";
  var _useInfo = useInfo(props, mode), _useInfo2 = _slicedToArray(_useInfo, 2), info = _useInfo2[0], now4 = _useInfo2[1];
  var weekFirstDay = generateConfig2.locale.getWeekFirstDay(locale6.locale);
  var monthStartDate = generateConfig2.setDate(pickerValue, 1);
  var baseDate = getWeekStartDate(locale6.locale, generateConfig2, monthStartDate);
  var month = generateConfig2.getMonth(pickerValue);
  var showPrefixColumn = showWeek === void 0 ? isWeek : showWeek;
  var prefixColumn = showPrefixColumn ? function(date4) {
    var disabled = disabledDate === null || disabledDate === void 0 ? void 0 : disabledDate(date4, {
      type: "week"
    });
    return /* @__PURE__ */ React250.createElement("td", {
      key: "week",
      className: (0, import_classnames81.default)(cellPrefixCls, "".concat(cellPrefixCls, "-week"), _defineProperty({}, "".concat(cellPrefixCls, "-disabled"), disabled)),
      onClick: function onClick() {
        if (!disabled) {
          onSelect(date4);
        }
      },
      onMouseEnter: function onMouseEnter() {
        if (!disabled) {
          onHover === null || onHover === void 0 || onHover(date4);
        }
      },
      onMouseLeave: function onMouseLeave() {
        if (!disabled) {
          onHover === null || onHover === void 0 || onHover(null);
        }
      }
    }, /* @__PURE__ */ React250.createElement("div", {
      className: "".concat(cellPrefixCls, "-inner")
    }, generateConfig2.locale.getWeek(locale6.locale, date4)));
  } : null;
  var headerCells = [];
  var weekDaysLocale = locale6.shortWeekDays || (generateConfig2.locale.getShortWeekDays ? generateConfig2.locale.getShortWeekDays(locale6.locale) : []);
  if (prefixColumn) {
    headerCells.push(/* @__PURE__ */ React250.createElement("th", {
      key: "empty"
    }, /* @__PURE__ */ React250.createElement("span", {
      style: {
        width: 0,
        height: 0,
        position: "absolute",
        overflow: "hidden",
        opacity: 0
      }
    }, locale6.week)));
  }
  for (var i = 0; i < WEEK_DAY_COUNT; i += 1) {
    headerCells.push(/* @__PURE__ */ React250.createElement("th", {
      key: i
    }, weekDaysLocale[(i + weekFirstDay) % WEEK_DAY_COUNT]));
  }
  var getCellDate = function getCellDate2(date4, offset4) {
    return generateConfig2.addDate(date4, offset4);
  };
  var getCellText = function getCellText2(date4) {
    return formatValue(date4, {
      locale: locale6,
      format: locale6.cellDateFormat,
      generateConfig: generateConfig2
    });
  };
  var getCellClassName = function getCellClassName2(date4) {
    var classObj = _defineProperty(_defineProperty({}, "".concat(prefixCls, "-cell-in-view"), isSameMonth(generateConfig2, date4, pickerValue)), "".concat(prefixCls, "-cell-today"), isSameDate(generateConfig2, date4, now4));
    return classObj;
  };
  var monthsLocale = locale6.shortMonths || (generateConfig2.locale.getShortMonths ? generateConfig2.locale.getShortMonths(locale6.locale) : []);
  var yearNode = /* @__PURE__ */ React250.createElement("button", {
    type: "button",
    "aria-label": locale6.yearSelect,
    key: "year",
    onClick: function onClick() {
      onModeChange("year", pickerValue);
    },
    tabIndex: -1,
    className: "".concat(prefixCls, "-year-btn")
  }, formatValue(pickerValue, {
    locale: locale6,
    format: locale6.yearFormat,
    generateConfig: generateConfig2
  }));
  var monthNode = /* @__PURE__ */ React250.createElement("button", {
    type: "button",
    "aria-label": locale6.monthSelect,
    key: "month",
    onClick: function onClick() {
      onModeChange("month", pickerValue);
    },
    tabIndex: -1,
    className: "".concat(prefixCls, "-month-btn")
  }, locale6.monthFormat ? formatValue(pickerValue, {
    locale: locale6,
    format: locale6.monthFormat,
    generateConfig: generateConfig2
  }) : monthsLocale[month]);
  var monthYearNodes = locale6.monthBeforeYear ? [monthNode, yearNode] : [yearNode, monthNode];
  return /* @__PURE__ */ React250.createElement(PanelContext.Provider, {
    value: info
  }, /* @__PURE__ */ React250.createElement("div", {
    className: (0, import_classnames81.default)(panelPrefixCls, showWeek && "".concat(panelPrefixCls, "-show-week"))
  }, /* @__PURE__ */ React250.createElement(PanelHeader_default, {
    offset: function offset4(distance) {
      return generateConfig2.addMonth(pickerValue, distance);
    },
    superOffset: function superOffset(distance) {
      return generateConfig2.addYear(pickerValue, distance);
    },
    onChange: onPickerValueChange,
    getStart: function getStart(date4) {
      return generateConfig2.setDate(date4, 1);
    },
    getEnd: function getEnd(date4) {
      var clone = generateConfig2.setDate(date4, 1);
      clone = generateConfig2.addMonth(clone, 1);
      return generateConfig2.addDate(clone, -1);
    }
  }, monthYearNodes), /* @__PURE__ */ React250.createElement(PanelBody, _extends({
    titleFormat: locale6.fieldDateFormat
  }, props, {
    colNum: WEEK_DAY_COUNT,
    rowNum: 6,
    baseDate,
    headerCells,
    getCellDate,
    getCellText,
    getCellClassName,
    prefixColumn,
    cellSelection: !isWeek
  }))));
}

// ../../node_modules/rc-picker/es/PickerPanel/DateTimePanel/index.js
var React255 = __toESM(require_react());

// ../../node_modules/rc-picker/es/PickerPanel/TimePanel/index.js
var import_classnames83 = __toESM(require_classnames());
var React254 = __toESM(require_react());

// ../../node_modules/rc-picker/es/PickerPanel/TimePanel/TimePanelBody/index.js
var React253 = __toESM(require_react());

// ../../node_modules/rc-picker/es/PickerPanel/TimePanel/TimePanelBody/TimeColumn.js
var import_classnames82 = __toESM(require_classnames());
var React252 = __toESM(require_react());

// ../../node_modules/rc-picker/es/PickerPanel/TimePanel/TimePanelBody/useScrollTo.js
var React251 = __toESM(require_react());
var SPEED_PTG = 1 / 3;
function useScrollTo2(ulRef, value) {
  var scrollingRef = React251.useRef(false);
  var scrollRafRef = React251.useRef(null);
  var scrollDistRef = React251.useRef(null);
  var isScrolling = function isScrolling2() {
    return scrollingRef.current;
  };
  var stopScroll = function stopScroll2() {
    raf_default.cancel(scrollRafRef.current);
    scrollingRef.current = false;
  };
  var scrollRafTimesRef = React251.useRef();
  var startScroll = function startScroll2() {
    var ul = ulRef.current;
    scrollDistRef.current = null;
    scrollRafTimesRef.current = 0;
    if (ul) {
      var targetLi = ul.querySelector('[data-value="'.concat(value, '"]'));
      var firstLi = ul.querySelector("li");
      var doScroll = function doScroll2() {
        stopScroll();
        scrollingRef.current = true;
        scrollRafTimesRef.current += 1;
        var currentTop = ul.scrollTop;
        var firstLiTop = firstLi.offsetTop;
        var targetLiTop = targetLi.offsetTop;
        var targetTop = targetLiTop - firstLiTop;
        if (targetLiTop === 0 && targetLi !== firstLi || !isVisible_default(ul)) {
          if (scrollRafTimesRef.current <= 5) {
            scrollRafRef.current = raf_default(doScroll2);
          }
          return;
        }
        var nextTop = currentTop + (targetTop - currentTop) * SPEED_PTG;
        var dist = Math.abs(targetTop - nextTop);
        if (scrollDistRef.current !== null && scrollDistRef.current < dist) {
          stopScroll();
          return;
        }
        scrollDistRef.current = dist;
        if (dist <= 1) {
          ul.scrollTop = targetTop;
          stopScroll();
          return;
        }
        ul.scrollTop = nextTop;
        scrollRafRef.current = raf_default(doScroll2);
      };
      if (targetLi && firstLi) {
        doScroll();
      }
    }
  };
  var syncScroll = useEvent2(startScroll);
  return [syncScroll, stopScroll, isScrolling];
}

// ../../node_modules/rc-picker/es/PickerPanel/TimePanel/TimePanelBody/TimeColumn.js
var SCROLL_DELAY = 300;
function flattenUnits(units) {
  return units.map(function(_ref) {
    var value = _ref.value, label = _ref.label, disabled = _ref.disabled;
    return [value, label, disabled].join(",");
  }).join(";");
}
function TimeColumn(props) {
  var units = props.units, value = props.value, optionalValue = props.optionalValue, type5 = props.type, onChange = props.onChange, onHover = props.onHover, onDblClick = props.onDblClick, changeOnScroll = props.changeOnScroll;
  var _usePanelContext = usePanelContext(), prefixCls = _usePanelContext.prefixCls, cellRender = _usePanelContext.cellRender, now4 = _usePanelContext.now, locale6 = _usePanelContext.locale;
  var panelPrefixCls = "".concat(prefixCls, "-time-panel");
  var cellPrefixCls = "".concat(prefixCls, "-time-panel-cell");
  var ulRef = React252.useRef(null);
  var checkDelayRef = React252.useRef();
  var clearDelayCheck = function clearDelayCheck2() {
    clearTimeout(checkDelayRef.current);
  };
  var _useScrollTo = useScrollTo2(ulRef, value !== null && value !== void 0 ? value : optionalValue), _useScrollTo2 = _slicedToArray(_useScrollTo, 3), syncScroll = _useScrollTo2[0], stopScroll = _useScrollTo2[1], isScrolling = _useScrollTo2[2];
  useLayoutEffect_default(function() {
    syncScroll();
    clearDelayCheck();
    return function() {
      stopScroll();
      clearDelayCheck();
    };
  }, [value, optionalValue, flattenUnits(units)]);
  var onInternalScroll = function onInternalScroll2(event) {
    clearDelayCheck();
    var target = event.target;
    if (!isScrolling() && changeOnScroll) {
      checkDelayRef.current = setTimeout(function() {
        var ul = ulRef.current;
        var firstLiTop = ul.querySelector("li").offsetTop;
        var liList = Array.from(ul.querySelectorAll("li"));
        var liTopList = liList.map(function(li) {
          return li.offsetTop - firstLiTop;
        });
        var liDistList = liTopList.map(function(top, index3) {
          if (units[index3].disabled) {
            return Number.MAX_SAFE_INTEGER;
          }
          return Math.abs(top - target.scrollTop);
        });
        var minDist = Math.min.apply(Math, _toConsumableArray(liDistList));
        var minDistIndex = liDistList.findIndex(function(dist) {
          return dist === minDist;
        });
        var targetUnit = units[minDistIndex];
        if (targetUnit && !targetUnit.disabled) {
          onChange(targetUnit.value);
        }
      }, SCROLL_DELAY);
    }
  };
  var columnPrefixCls = "".concat(panelPrefixCls, "-column");
  return /* @__PURE__ */ React252.createElement("ul", {
    className: columnPrefixCls,
    ref: ulRef,
    "data-type": type5,
    onScroll: onInternalScroll
  }, units.map(function(_ref2) {
    var label = _ref2.label, unitValue = _ref2.value, disabled = _ref2.disabled;
    var inner = /* @__PURE__ */ React252.createElement("div", {
      className: "".concat(cellPrefixCls, "-inner")
    }, label);
    return /* @__PURE__ */ React252.createElement("li", {
      key: unitValue,
      className: (0, import_classnames82.default)(cellPrefixCls, _defineProperty(_defineProperty({}, "".concat(cellPrefixCls, "-selected"), value === unitValue), "".concat(cellPrefixCls, "-disabled"), disabled)),
      onClick: function onClick() {
        if (!disabled) {
          onChange(unitValue);
        }
      },
      onDoubleClick: function onDoubleClick() {
        if (!disabled && onDblClick) {
          onDblClick();
        }
      },
      onMouseEnter: function onMouseEnter() {
        onHover(unitValue);
      },
      onMouseLeave: function onMouseLeave() {
        onHover(null);
      },
      "data-value": unitValue
    }, cellRender ? cellRender(unitValue, {
      prefixCls,
      originNode: inner,
      today: now4,
      type: "time",
      subType: type5,
      locale: locale6
    }) : inner);
  }));
}

// ../../node_modules/rc-picker/es/PickerPanel/TimePanel/TimePanelBody/index.js
function isAM(hour) {
  return hour < 12;
}
function TimePanelBody(props) {
  var showHour = props.showHour, showMinute = props.showMinute, showSecond = props.showSecond, showMillisecond = props.showMillisecond, showMeridiem = props.use12Hours, changeOnScroll = props.changeOnScroll;
  var _usePanelContext = usePanelContext(), prefixCls = _usePanelContext.prefixCls, values = _usePanelContext.values, generateConfig2 = _usePanelContext.generateConfig, locale6 = _usePanelContext.locale, onSelect = _usePanelContext.onSelect, _usePanelContext$onHo = _usePanelContext.onHover, onHover = _usePanelContext$onHo === void 0 ? function() {
  } : _usePanelContext$onHo, pickerValue = _usePanelContext.pickerValue;
  var value = (values === null || values === void 0 ? void 0 : values[0]) || null;
  var _React$useContext = React253.useContext(PickerHackContext), onCellDblClick = _React$useContext.onCellDblClick;
  var _useTimeInfo = useTimeInfo(generateConfig2, props, value), _useTimeInfo2 = _slicedToArray(_useTimeInfo, 5), getValidTime = _useTimeInfo2[0], rowHourUnits = _useTimeInfo2[1], getMinuteUnits = _useTimeInfo2[2], getSecondUnits = _useTimeInfo2[3], getMillisecondUnits = _useTimeInfo2[4];
  var getUnitValue3 = function getUnitValue4(func) {
    var valueUnitVal = value && generateConfig2[func](value);
    var pickerUnitValue = pickerValue && generateConfig2[func](pickerValue);
    return [valueUnitVal, pickerUnitValue];
  };
  var _getUnitValue = getUnitValue3("getHour"), _getUnitValue2 = _slicedToArray(_getUnitValue, 2), hour = _getUnitValue2[0], pickerHour = _getUnitValue2[1];
  var _getUnitValue3 = getUnitValue3("getMinute"), _getUnitValue4 = _slicedToArray(_getUnitValue3, 2), minute = _getUnitValue4[0], pickerMinute = _getUnitValue4[1];
  var _getUnitValue5 = getUnitValue3("getSecond"), _getUnitValue6 = _slicedToArray(_getUnitValue5, 2), second = _getUnitValue6[0], pickerSecond = _getUnitValue6[1];
  var _getUnitValue7 = getUnitValue3("getMillisecond"), _getUnitValue8 = _slicedToArray(_getUnitValue7, 2), millisecond = _getUnitValue8[0], pickerMillisecond = _getUnitValue8[1];
  var meridiem = hour === null ? null : isAM(hour) ? "am" : "pm";
  var hourUnits = React253.useMemo(function() {
    if (!showMeridiem) {
      return rowHourUnits;
    }
    return isAM(hour) ? rowHourUnits.filter(function(h2) {
      return isAM(h2.value);
    }) : rowHourUnits.filter(function(h2) {
      return !isAM(h2.value);
    });
  }, [hour, rowHourUnits, showMeridiem]);
  var getEnabled = function getEnabled2(units, val) {
    var _enabledUnits$;
    var enabledUnits = units.filter(function(unit3) {
      return !unit3.disabled;
    });
    return val !== null && val !== void 0 ? val : (
      // Fallback to enabled value
      enabledUnits === null || enabledUnits === void 0 || (_enabledUnits$ = enabledUnits[0]) === null || _enabledUnits$ === void 0 ? void 0 : _enabledUnits$.value
    );
  };
  var validHour = getEnabled(rowHourUnits, hour);
  var minuteUnits = React253.useMemo(function() {
    return getMinuteUnits(validHour);
  }, [getMinuteUnits, validHour]);
  var validMinute = getEnabled(minuteUnits, minute);
  var secondUnits = React253.useMemo(function() {
    return getSecondUnits(validHour, validMinute);
  }, [getSecondUnits, validHour, validMinute]);
  var validSecond = getEnabled(secondUnits, second);
  var millisecondUnits = React253.useMemo(function() {
    return getMillisecondUnits(validHour, validMinute, validSecond);
  }, [getMillisecondUnits, validHour, validMinute, validSecond]);
  var validMillisecond = getEnabled(millisecondUnits, millisecond);
  var meridiemUnits = React253.useMemo(function() {
    if (!showMeridiem) {
      return [];
    }
    var base = generateConfig2.getNow();
    var amDate = generateConfig2.setHour(base, 6);
    var pmDate = generateConfig2.setHour(base, 18);
    var formatMeridiem = function formatMeridiem2(date4, defaultLabel) {
      var cellMeridiemFormat = locale6.cellMeridiemFormat;
      return cellMeridiemFormat ? formatValue(date4, {
        generateConfig: generateConfig2,
        locale: locale6,
        format: cellMeridiemFormat
      }) : defaultLabel;
    };
    return [{
      label: formatMeridiem(amDate, "AM"),
      value: "am",
      disabled: rowHourUnits.every(function(h2) {
        return h2.disabled || !isAM(h2.value);
      })
    }, {
      label: formatMeridiem(pmDate, "PM"),
      value: "pm",
      disabled: rowHourUnits.every(function(h2) {
        return h2.disabled || isAM(h2.value);
      })
    }];
  }, [rowHourUnits, showMeridiem, generateConfig2, locale6]);
  var triggerChange = function triggerChange2(nextDate) {
    var validateDate = getValidTime(nextDate);
    onSelect(validateDate);
  };
  var triggerDateTmpl = React253.useMemo(function() {
    var tmpl = value || pickerValue || generateConfig2.getNow();
    var isNotNull = function isNotNull2(num) {
      return num !== null && num !== void 0;
    };
    if (isNotNull(hour)) {
      tmpl = generateConfig2.setHour(tmpl, hour);
      tmpl = generateConfig2.setMinute(tmpl, minute);
      tmpl = generateConfig2.setSecond(tmpl, second);
      tmpl = generateConfig2.setMillisecond(tmpl, millisecond);
    } else if (isNotNull(pickerHour)) {
      tmpl = generateConfig2.setHour(tmpl, pickerHour);
      tmpl = generateConfig2.setMinute(tmpl, pickerMinute);
      tmpl = generateConfig2.setSecond(tmpl, pickerSecond);
      tmpl = generateConfig2.setMillisecond(tmpl, pickerMillisecond);
    } else if (isNotNull(validHour)) {
      tmpl = generateConfig2.setHour(tmpl, validHour);
      tmpl = generateConfig2.setMinute(tmpl, validMinute);
      tmpl = generateConfig2.setSecond(tmpl, validSecond);
      tmpl = generateConfig2.setMillisecond(tmpl, validMillisecond);
    }
    return tmpl;
  }, [value, pickerValue, hour, minute, second, millisecond, validHour, validMinute, validSecond, validMillisecond, pickerHour, pickerMinute, pickerSecond, pickerMillisecond, generateConfig2]);
  var fillColumnValue = function fillColumnValue2(val, func) {
    if (val === null) {
      return null;
    }
    return generateConfig2[func](triggerDateTmpl, val);
  };
  var getNextHourTime = function getNextHourTime2(val) {
    return fillColumnValue(val, "setHour");
  };
  var getNextMinuteTime = function getNextMinuteTime2(val) {
    return fillColumnValue(val, "setMinute");
  };
  var getNextSecondTime = function getNextSecondTime2(val) {
    return fillColumnValue(val, "setSecond");
  };
  var getNextMillisecondTime = function getNextMillisecondTime2(val) {
    return fillColumnValue(val, "setMillisecond");
  };
  var getMeridiemTime = function getMeridiemTime2(val) {
    if (val === null) {
      return null;
    }
    if (val === "am" && !isAM(hour)) {
      return generateConfig2.setHour(triggerDateTmpl, hour - 12);
    } else if (val === "pm" && isAM(hour)) {
      return generateConfig2.setHour(triggerDateTmpl, hour + 12);
    }
    return triggerDateTmpl;
  };
  var onHourChange = function onHourChange2(val) {
    triggerChange(getNextHourTime(val));
  };
  var onMinuteChange = function onMinuteChange2(val) {
    triggerChange(getNextMinuteTime(val));
  };
  var onSecondChange = function onSecondChange2(val) {
    triggerChange(getNextSecondTime(val));
  };
  var onMillisecondChange = function onMillisecondChange2(val) {
    triggerChange(getNextMillisecondTime(val));
  };
  var onMeridiemChange = function onMeridiemChange2(val) {
    triggerChange(getMeridiemTime(val));
  };
  var onHourHover = function onHourHover2(val) {
    onHover(getNextHourTime(val));
  };
  var onMinuteHover = function onMinuteHover2(val) {
    onHover(getNextMinuteTime(val));
  };
  var onSecondHover = function onSecondHover2(val) {
    onHover(getNextSecondTime(val));
  };
  var onMillisecondHover = function onMillisecondHover2(val) {
    onHover(getNextMillisecondTime(val));
  };
  var onMeridiemHover = function onMeridiemHover2(val) {
    onHover(getMeridiemTime(val));
  };
  var sharedColumnProps = {
    onDblClick: onCellDblClick,
    changeOnScroll
  };
  return /* @__PURE__ */ React253.createElement("div", {
    className: "".concat(prefixCls, "-content")
  }, showHour && /* @__PURE__ */ React253.createElement(TimeColumn, _extends({
    units: hourUnits,
    value: hour,
    optionalValue: pickerHour,
    type: "hour",
    onChange: onHourChange,
    onHover: onHourHover
  }, sharedColumnProps)), showMinute && /* @__PURE__ */ React253.createElement(TimeColumn, _extends({
    units: minuteUnits,
    value: minute,
    optionalValue: pickerMinute,
    type: "minute",
    onChange: onMinuteChange,
    onHover: onMinuteHover
  }, sharedColumnProps)), showSecond && /* @__PURE__ */ React253.createElement(TimeColumn, _extends({
    units: secondUnits,
    value: second,
    optionalValue: pickerSecond,
    type: "second",
    onChange: onSecondChange,
    onHover: onSecondHover
  }, sharedColumnProps)), showMillisecond && /* @__PURE__ */ React253.createElement(TimeColumn, _extends({
    units: millisecondUnits,
    value: millisecond,
    optionalValue: pickerMillisecond,
    type: "millisecond",
    onChange: onMillisecondChange,
    onHover: onMillisecondHover
  }, sharedColumnProps)), showMeridiem && /* @__PURE__ */ React253.createElement(TimeColumn, _extends({
    units: meridiemUnits,
    value: meridiem,
    type: "meridiem",
    onChange: onMeridiemChange,
    onHover: onMeridiemHover
  }, sharedColumnProps)));
}

// ../../node_modules/rc-picker/es/PickerPanel/TimePanel/index.js
function TimePanel(props) {
  var prefixCls = props.prefixCls, value = props.value, locale6 = props.locale, generateConfig2 = props.generateConfig, showTime = props.showTime;
  var _ref = showTime || {}, format3 = _ref.format;
  var panelPrefixCls = "".concat(prefixCls, "-time-panel");
  var _useInfo = useInfo(props, "time"), _useInfo2 = _slicedToArray(_useInfo, 1), info = _useInfo2[0];
  return /* @__PURE__ */ React254.createElement(PanelContext.Provider, {
    value: info
  }, /* @__PURE__ */ React254.createElement("div", {
    className: (0, import_classnames83.default)(panelPrefixCls)
  }, /* @__PURE__ */ React254.createElement(PanelHeader_default, null, value ? formatValue(value, {
    locale: locale6,
    format: format3,
    generateConfig: generateConfig2
  }) : "\xA0"), /* @__PURE__ */ React254.createElement(TimePanelBody, showTime)));
}

// ../../node_modules/rc-picker/es/PickerPanel/DateTimePanel/index.js
function DateTimePanel(props) {
  var prefixCls = props.prefixCls, generateConfig2 = props.generateConfig, showTime = props.showTime, onSelect = props.onSelect, value = props.value, pickerValue = props.pickerValue, onHover = props.onHover;
  var panelPrefixCls = "".concat(prefixCls, "-datetime-panel");
  var _useTimeInfo = useTimeInfo(generateConfig2, showTime), _useTimeInfo2 = _slicedToArray(_useTimeInfo, 1), getValidTime = _useTimeInfo2[0];
  var mergeTime = function mergeTime2(date4) {
    if (value) {
      return fillTime(generateConfig2, date4, value);
    }
    return fillTime(generateConfig2, date4, pickerValue);
  };
  var onDateHover = function onDateHover2(date4) {
    onHover === null || onHover === void 0 || onHover(date4 ? mergeTime(date4) : date4);
  };
  var onDateSelect = function onDateSelect2(date4) {
    var cloneDate = mergeTime(date4);
    onSelect(getValidTime(cloneDate, cloneDate));
  };
  return /* @__PURE__ */ React255.createElement("div", {
    className: panelPrefixCls
  }, /* @__PURE__ */ React255.createElement(DatePanel, _extends({}, props, {
    onSelect: onDateSelect,
    onHover: onDateHover
  })), /* @__PURE__ */ React255.createElement(TimePanel, props));
}

// ../../node_modules/rc-picker/es/PickerPanel/DecadePanel/index.js
var React256 = __toESM(require_react());
function DecadePanel(props) {
  var prefixCls = props.prefixCls, locale6 = props.locale, generateConfig2 = props.generateConfig, pickerValue = props.pickerValue, disabledDate = props.disabledDate, onPickerValueChange = props.onPickerValueChange;
  var panelPrefixCls = "".concat(prefixCls, "-decade-panel");
  var _useInfo = useInfo(props, "decade"), _useInfo2 = _slicedToArray(_useInfo, 1), info = _useInfo2[0];
  var getStartYear = function getStartYear2(date4) {
    var startYear = Math.floor(generateConfig2.getYear(date4) / 100) * 100;
    return generateConfig2.setYear(date4, startYear);
  };
  var getEndYear = function getEndYear2(date4) {
    var startYear = getStartYear(date4);
    return generateConfig2.addYear(startYear, 99);
  };
  var startYearDate = getStartYear(pickerValue);
  var endYearDate = getEndYear(pickerValue);
  var baseDate = generateConfig2.addYear(startYearDate, -10);
  var getCellDate = function getCellDate2(date4, offset4) {
    return generateConfig2.addYear(date4, offset4 * 10);
  };
  var getCellText = function getCellText2(date4) {
    var cellYearFormat = locale6.cellYearFormat;
    var startYearStr = formatValue(date4, {
      locale: locale6,
      format: cellYearFormat,
      generateConfig: generateConfig2
    });
    var endYearStr = formatValue(generateConfig2.addYear(date4, 9), {
      locale: locale6,
      format: cellYearFormat,
      generateConfig: generateConfig2
    });
    return "".concat(startYearStr, "-").concat(endYearStr);
  };
  var getCellClassName = function getCellClassName2(date4) {
    return _defineProperty({}, "".concat(prefixCls, "-cell-in-view"), isSameDecade(generateConfig2, date4, startYearDate) || isSameDecade(generateConfig2, date4, endYearDate) || isInRange(generateConfig2, startYearDate, endYearDate, date4));
  };
  var mergedDisabledDate = disabledDate ? function(currentDate, disabledInfo) {
    var baseStartDate = generateConfig2.setDate(currentDate, 1);
    var baseStartMonth = generateConfig2.setMonth(baseStartDate, 0);
    var baseStartYear = generateConfig2.setYear(baseStartMonth, Math.floor(generateConfig2.getYear(baseStartMonth) / 10) * 10);
    var baseEndYear = generateConfig2.addYear(baseStartYear, 10);
    var baseEndDate = generateConfig2.addDate(baseEndYear, -1);
    return disabledDate(baseStartYear, disabledInfo) && disabledDate(baseEndDate, disabledInfo);
  } : null;
  var yearNode = "".concat(formatValue(startYearDate, {
    locale: locale6,
    format: locale6.yearFormat,
    generateConfig: generateConfig2
  }), "-").concat(formatValue(endYearDate, {
    locale: locale6,
    format: locale6.yearFormat,
    generateConfig: generateConfig2
  }));
  return /* @__PURE__ */ React256.createElement(PanelContext.Provider, {
    value: info
  }, /* @__PURE__ */ React256.createElement("div", {
    className: panelPrefixCls
  }, /* @__PURE__ */ React256.createElement(PanelHeader_default, {
    superOffset: function superOffset(distance) {
      return generateConfig2.addYear(pickerValue, distance * 100);
    },
    onChange: onPickerValueChange,
    getStart: getStartYear,
    getEnd: getEndYear
  }, yearNode), /* @__PURE__ */ React256.createElement(PanelBody, _extends({}, props, {
    disabledDate: mergedDisabledDate,
    colNum: 3,
    rowNum: 4,
    baseDate,
    getCellDate,
    getCellText,
    getCellClassName
  }))));
}

// ../../node_modules/rc-picker/es/PickerPanel/MonthPanel/index.js
var React257 = __toESM(require_react());
function MonthPanel(props) {
  var prefixCls = props.prefixCls, locale6 = props.locale, generateConfig2 = props.generateConfig, pickerValue = props.pickerValue, disabledDate = props.disabledDate, onPickerValueChange = props.onPickerValueChange, onModeChange = props.onModeChange;
  var panelPrefixCls = "".concat(prefixCls, "-month-panel");
  var _useInfo = useInfo(props, "month"), _useInfo2 = _slicedToArray(_useInfo, 1), info = _useInfo2[0];
  var baseDate = generateConfig2.setMonth(pickerValue, 0);
  var monthsLocale = locale6.shortMonths || (generateConfig2.locale.getShortMonths ? generateConfig2.locale.getShortMonths(locale6.locale) : []);
  var getCellDate = function getCellDate2(date4, offset4) {
    return generateConfig2.addMonth(date4, offset4);
  };
  var getCellText = function getCellText2(date4) {
    var month = generateConfig2.getMonth(date4);
    return locale6.monthFormat ? formatValue(date4, {
      locale: locale6,
      format: locale6.monthFormat,
      generateConfig: generateConfig2
    }) : monthsLocale[month];
  };
  var getCellClassName = function getCellClassName2() {
    return _defineProperty({}, "".concat(prefixCls, "-cell-in-view"), true);
  };
  var mergedDisabledDate = disabledDate ? function(currentDate, disabledInfo) {
    var startDate = generateConfig2.setDate(currentDate, 1);
    var nextMonthStartDate = generateConfig2.setMonth(startDate, generateConfig2.getMonth(startDate) + 1);
    var endDate = generateConfig2.addDate(nextMonthStartDate, -1);
    return disabledDate(startDate, disabledInfo) && disabledDate(endDate, disabledInfo);
  } : null;
  var yearNode = /* @__PURE__ */ React257.createElement("button", {
    type: "button",
    key: "year",
    "aria-label": locale6.yearSelect,
    onClick: function onClick() {
      onModeChange("year");
    },
    tabIndex: -1,
    className: "".concat(prefixCls, "-year-btn")
  }, formatValue(pickerValue, {
    locale: locale6,
    format: locale6.yearFormat,
    generateConfig: generateConfig2
  }));
  return /* @__PURE__ */ React257.createElement(PanelContext.Provider, {
    value: info
  }, /* @__PURE__ */ React257.createElement("div", {
    className: panelPrefixCls
  }, /* @__PURE__ */ React257.createElement(PanelHeader_default, {
    superOffset: function superOffset(distance) {
      return generateConfig2.addYear(pickerValue, distance);
    },
    onChange: onPickerValueChange,
    getStart: function getStart(date4) {
      return generateConfig2.setMonth(date4, 0);
    },
    getEnd: function getEnd(date4) {
      return generateConfig2.setMonth(date4, 11);
    }
  }, yearNode), /* @__PURE__ */ React257.createElement(PanelBody, _extends({}, props, {
    disabledDate: mergedDisabledDate,
    titleFormat: locale6.fieldMonthFormat,
    colNum: 3,
    rowNum: 4,
    baseDate,
    getCellDate,
    getCellText,
    getCellClassName
  }))));
}

// ../../node_modules/rc-picker/es/PickerPanel/QuarterPanel/index.js
var React258 = __toESM(require_react());
function QuarterPanel(props) {
  var prefixCls = props.prefixCls, locale6 = props.locale, generateConfig2 = props.generateConfig, pickerValue = props.pickerValue, onPickerValueChange = props.onPickerValueChange, onModeChange = props.onModeChange;
  var panelPrefixCls = "".concat(prefixCls, "-quarter-panel");
  var _useInfo = useInfo(props, "quarter"), _useInfo2 = _slicedToArray(_useInfo, 1), info = _useInfo2[0];
  var baseDate = generateConfig2.setMonth(pickerValue, 0);
  var getCellDate = function getCellDate2(date4, offset4) {
    return generateConfig2.addMonth(date4, offset4 * 3);
  };
  var getCellText = function getCellText2(date4) {
    return formatValue(date4, {
      locale: locale6,
      format: locale6.cellQuarterFormat,
      generateConfig: generateConfig2
    });
  };
  var getCellClassName = function getCellClassName2() {
    return _defineProperty({}, "".concat(prefixCls, "-cell-in-view"), true);
  };
  var yearNode = /* @__PURE__ */ React258.createElement("button", {
    type: "button",
    key: "year",
    "aria-label": locale6.yearSelect,
    onClick: function onClick() {
      onModeChange("year");
    },
    tabIndex: -1,
    className: "".concat(prefixCls, "-year-btn")
  }, formatValue(pickerValue, {
    locale: locale6,
    format: locale6.yearFormat,
    generateConfig: generateConfig2
  }));
  return /* @__PURE__ */ React258.createElement(PanelContext.Provider, {
    value: info
  }, /* @__PURE__ */ React258.createElement("div", {
    className: panelPrefixCls
  }, /* @__PURE__ */ React258.createElement(PanelHeader_default, {
    superOffset: function superOffset(distance) {
      return generateConfig2.addYear(pickerValue, distance);
    },
    onChange: onPickerValueChange,
    getStart: function getStart(date4) {
      return generateConfig2.setMonth(date4, 0);
    },
    getEnd: function getEnd(date4) {
      return generateConfig2.setMonth(date4, 11);
    }
  }, yearNode), /* @__PURE__ */ React258.createElement(PanelBody, _extends({}, props, {
    titleFormat: locale6.fieldQuarterFormat,
    colNum: 4,
    rowNum: 1,
    baseDate,
    getCellDate,
    getCellText,
    getCellClassName
  }))));
}

// ../../node_modules/rc-picker/es/PickerPanel/WeekPanel/index.js
var import_classnames84 = __toESM(require_classnames());
var React259 = __toESM(require_react());
function WeekPanel(props) {
  var prefixCls = props.prefixCls, generateConfig2 = props.generateConfig, locale6 = props.locale, value = props.value, hoverValue = props.hoverValue, hoverRangeValue = props.hoverRangeValue;
  var localeName = locale6.locale;
  var rowPrefixCls = "".concat(prefixCls, "-week-panel-row");
  var rowClassName = function rowClassName2(currentDate) {
    var rangeCls = {};
    if (hoverRangeValue) {
      var _hoverRangeValue = _slicedToArray(hoverRangeValue, 2), rangeStart = _hoverRangeValue[0], rangeEnd = _hoverRangeValue[1];
      var isRangeStart = isSameWeek(generateConfig2, localeName, rangeStart, currentDate);
      var isRangeEnd = isSameWeek(generateConfig2, localeName, rangeEnd, currentDate);
      rangeCls["".concat(rowPrefixCls, "-range-start")] = isRangeStart;
      rangeCls["".concat(rowPrefixCls, "-range-end")] = isRangeEnd;
      rangeCls["".concat(rowPrefixCls, "-range-hover")] = !isRangeStart && !isRangeEnd && isInRange(generateConfig2, rangeStart, rangeEnd, currentDate);
    }
    if (hoverValue) {
      rangeCls["".concat(rowPrefixCls, "-hover")] = hoverValue.some(function(date4) {
        return isSameWeek(generateConfig2, localeName, currentDate, date4);
      });
    }
    return (0, import_classnames84.default)(
      rowPrefixCls,
      _defineProperty({}, "".concat(rowPrefixCls, "-selected"), !hoverRangeValue && isSameWeek(generateConfig2, localeName, value, currentDate)),
      // Patch for hover range
      rangeCls
    );
  };
  return /* @__PURE__ */ React259.createElement(DatePanel, _extends({}, props, {
    mode: "week",
    panelName: "week",
    rowClassName
  }));
}

// ../../node_modules/rc-picker/es/PickerPanel/YearPanel/index.js
var React260 = __toESM(require_react());
function YearPanel(props) {
  var prefixCls = props.prefixCls, locale6 = props.locale, generateConfig2 = props.generateConfig, pickerValue = props.pickerValue, disabledDate = props.disabledDate, onPickerValueChange = props.onPickerValueChange, onModeChange = props.onModeChange;
  var panelPrefixCls = "".concat(prefixCls, "-year-panel");
  var _useInfo = useInfo(props, "year"), _useInfo2 = _slicedToArray(_useInfo, 1), info = _useInfo2[0];
  var getStartYear = function getStartYear2(date4) {
    var startYear = Math.floor(generateConfig2.getYear(date4) / 10) * 10;
    return generateConfig2.setYear(date4, startYear);
  };
  var getEndYear = function getEndYear2(date4) {
    var startYear = getStartYear(date4);
    return generateConfig2.addYear(startYear, 9);
  };
  var startYearDate = getStartYear(pickerValue);
  var endYearDate = getEndYear(pickerValue);
  var baseDate = generateConfig2.addYear(startYearDate, -1);
  var getCellDate = function getCellDate2(date4, offset4) {
    return generateConfig2.addYear(date4, offset4);
  };
  var getCellText = function getCellText2(date4) {
    return formatValue(date4, {
      locale: locale6,
      format: locale6.cellYearFormat,
      generateConfig: generateConfig2
    });
  };
  var getCellClassName = function getCellClassName2(date4) {
    return _defineProperty({}, "".concat(prefixCls, "-cell-in-view"), isSameYear(generateConfig2, date4, startYearDate) || isSameYear(generateConfig2, date4, endYearDate) || isInRange(generateConfig2, startYearDate, endYearDate, date4));
  };
  var mergedDisabledDate = disabledDate ? function(currentDate, disabledInfo) {
    var startMonth = generateConfig2.setMonth(currentDate, 0);
    var startDate = generateConfig2.setDate(startMonth, 1);
    var endMonth = generateConfig2.addYear(startDate, 1);
    var endDate = generateConfig2.addDate(endMonth, -1);
    return disabledDate(startDate, disabledInfo) && disabledDate(endDate, disabledInfo);
  } : null;
  var yearNode = /* @__PURE__ */ React260.createElement("button", {
    type: "button",
    key: "decade",
    "aria-label": locale6.decadeSelect,
    onClick: function onClick() {
      onModeChange("decade");
    },
    tabIndex: -1,
    className: "".concat(prefixCls, "-decade-btn")
  }, formatValue(startYearDate, {
    locale: locale6,
    format: locale6.yearFormat,
    generateConfig: generateConfig2
  }), "-", formatValue(endYearDate, {
    locale: locale6,
    format: locale6.yearFormat,
    generateConfig: generateConfig2
  }));
  return /* @__PURE__ */ React260.createElement(PanelContext.Provider, {
    value: info
  }, /* @__PURE__ */ React260.createElement("div", {
    className: panelPrefixCls
  }, /* @__PURE__ */ React260.createElement(PanelHeader_default, {
    superOffset: function superOffset(distance) {
      return generateConfig2.addYear(pickerValue, distance * 10);
    },
    onChange: onPickerValueChange,
    getStart: getStartYear,
    getEnd: getEndYear
  }, yearNode), /* @__PURE__ */ React260.createElement(PanelBody, _extends({}, props, {
    disabledDate: mergedDisabledDate,
    titleFormat: locale6.fieldYearFormat,
    colNum: 3,
    rowNum: 4,
    baseDate,
    getCellDate,
    getCellText,
    getCellClassName
  }))));
}

// ../../node_modules/rc-picker/es/PickerPanel/index.js
var DefaultComponents = {
  date: DatePanel,
  datetime: DateTimePanel,
  week: WeekPanel,
  month: MonthPanel,
  quarter: QuarterPanel,
  year: YearPanel,
  decade: DecadePanel,
  time: TimePanel
};
function PickerPanel(props, ref3) {
  var _React$useContext;
  var locale6 = props.locale, generateConfig2 = props.generateConfig, direction = props.direction, prefixCls = props.prefixCls, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, multiple = props.multiple, defaultValue2 = props.defaultValue, value = props.value, onChange = props.onChange, onSelect = props.onSelect, defaultPickerValue = props.defaultPickerValue, pickerValue = props.pickerValue, onPickerValueChange = props.onPickerValueChange, mode = props.mode, onPanelChange = props.onPanelChange, _props$picker = props.picker, picker = _props$picker === void 0 ? "date" : _props$picker, showTime = props.showTime, hoverValue = props.hoverValue, hoverRangeValue = props.hoverRangeValue, cellRender = props.cellRender, dateRender = props.dateRender, monthCellRender = props.monthCellRender, _props$components = props.components, components = _props$components === void 0 ? {} : _props$components, hideHeader = props.hideHeader;
  var mergedPrefixCls = ((_React$useContext = React261.useContext(context_default3)) === null || _React$useContext === void 0 ? void 0 : _React$useContext.prefixCls) || prefixCls || "rc-picker";
  var rootRef = React261.useRef();
  React261.useImperativeHandle(ref3, function() {
    return {
      nativeElement: rootRef.current
    };
  });
  var _getTimeProps = getTimeProps(props), _getTimeProps2 = _slicedToArray(_getTimeProps, 4), timeProps = _getTimeProps2[0], localeTimeProps = _getTimeProps2[1], showTimeFormat = _getTimeProps2[2], propFormat = _getTimeProps2[3];
  var filledLocale = useLocale2(locale6, localeTimeProps);
  var internalPicker = picker === "date" && showTime ? "datetime" : picker;
  var mergedShowTime = React261.useMemo(function() {
    return fillShowTimeConfig(internalPicker, showTimeFormat, propFormat, timeProps, filledLocale);
  }, [internalPicker, showTimeFormat, propFormat, timeProps, filledLocale]);
  var now4 = generateConfig2.getNow();
  var _useMergedState = useMergedState(picker, {
    value: mode,
    postState: function postState(val) {
      return val || "date";
    }
  }), _useMergedState2 = _slicedToArray(_useMergedState, 2), mergedMode = _useMergedState2[0], setMergedMode = _useMergedState2[1];
  var internalMode = mergedMode === "date" && mergedShowTime ? "datetime" : mergedMode;
  var toggleDates = useToggleDates(generateConfig2, locale6, internalPicker);
  var _useMergedState3 = useMergedState(defaultValue2, {
    value
  }), _useMergedState4 = _slicedToArray(_useMergedState3, 2), innerValue = _useMergedState4[0], setMergedValue = _useMergedState4[1];
  var mergedValue = React261.useMemo(function() {
    var values = toArray5(innerValue).filter(function(val) {
      return val;
    });
    return multiple ? values : values.slice(0, 1);
  }, [innerValue, multiple]);
  var triggerChange = useEvent2(function(nextValue) {
    setMergedValue(nextValue);
    if (onChange && (nextValue === null || mergedValue.length !== nextValue.length || mergedValue.some(function(ori, index3) {
      return !isSame(generateConfig2, locale6, ori, nextValue[index3], internalPicker);
    }))) {
      onChange === null || onChange === void 0 || onChange(multiple ? nextValue : nextValue[0]);
    }
  });
  var onInternalSelect = useEvent2(function(newDate) {
    onSelect === null || onSelect === void 0 || onSelect(newDate);
    if (mergedMode === picker) {
      var nextValues = multiple ? toggleDates(mergedValue, newDate) : [newDate];
      triggerChange(nextValues);
    }
  });
  var _useMergedState5 = useMergedState(defaultPickerValue || mergedValue[0] || now4, {
    value: pickerValue
  }), _useMergedState6 = _slicedToArray(_useMergedState5, 2), mergedPickerValue = _useMergedState6[0], setInternalPickerValue = _useMergedState6[1];
  React261.useEffect(function() {
    if (mergedValue[0] && !pickerValue) {
      setInternalPickerValue(mergedValue[0]);
    }
  }, [mergedValue[0]]);
  var triggerPanelChange = function triggerPanelChange2(viewDate, nextMode) {
    onPanelChange === null || onPanelChange === void 0 || onPanelChange(viewDate || pickerValue, nextMode || mergedMode);
  };
  var setPickerValue = function setPickerValue2(nextPickerValue) {
    var triggerPanelEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    setInternalPickerValue(nextPickerValue);
    onPickerValueChange === null || onPickerValueChange === void 0 || onPickerValueChange(nextPickerValue);
    if (triggerPanelEvent) {
      triggerPanelChange(nextPickerValue);
    }
  };
  var triggerModeChange = function triggerModeChange2(nextMode, viewDate) {
    setMergedMode(nextMode);
    if (viewDate) {
      setPickerValue(viewDate);
    }
    triggerPanelChange(viewDate, nextMode);
  };
  var onPanelValueSelect = function onPanelValueSelect2(nextValue) {
    onInternalSelect(nextValue);
    setPickerValue(nextValue);
    if (mergedMode !== picker) {
      var decadeYearQueue = ["decade", "year"];
      var decadeYearMonthQueue = [].concat(decadeYearQueue, ["month"]);
      var pickerQueue = {
        quarter: [].concat(decadeYearQueue, ["quarter"]),
        week: [].concat(_toConsumableArray(decadeYearMonthQueue), ["week"]),
        date: [].concat(_toConsumableArray(decadeYearMonthQueue), ["date"])
      };
      var queue = pickerQueue[picker] || decadeYearMonthQueue;
      var index3 = queue.indexOf(mergedMode);
      var nextMode = queue[index3 + 1];
      if (nextMode) {
        triggerModeChange(nextMode, nextValue);
      }
    }
  };
  var hoverRangeDate = React261.useMemo(function() {
    var start;
    var end;
    if (Array.isArray(hoverRangeValue)) {
      var _hoverRangeValue = _slicedToArray(hoverRangeValue, 2);
      start = _hoverRangeValue[0];
      end = _hoverRangeValue[1];
    } else {
      start = hoverRangeValue;
    }
    if (!start && !end) {
      return null;
    }
    start = start || end;
    end = end || start;
    return generateConfig2.isAfter(start, end) ? [end, start] : [start, end];
  }, [hoverRangeValue, generateConfig2]);
  var onInternalCellRender = useCellRender(cellRender, dateRender, monthCellRender);
  var PanelComponent = components[internalMode] || DefaultComponents[internalMode] || DatePanel;
  var parentHackContext = React261.useContext(PickerHackContext);
  var pickerPanelContext = React261.useMemo(function() {
    return _objectSpread2(_objectSpread2({}, parentHackContext), {}, {
      hideHeader
    });
  }, [parentHackContext, hideHeader]);
  if (true) {
    warning_default(!mergedValue || mergedValue.every(function(val) {
      return generateConfig2.isValidate(val);
    }), "Invalidate date pass to `value` or `defaultValue`.");
  }
  var panelCls = "".concat(mergedPrefixCls, "-panel");
  var panelProps = pickProps(props, [
    // Week
    "showWeek",
    // Icons
    "prevIcon",
    "nextIcon",
    "superPrevIcon",
    "superNextIcon",
    // Disabled
    "disabledDate",
    "minDate",
    "maxDate",
    // Hover
    "onHover"
  ]);
  return /* @__PURE__ */ React261.createElement(PickerHackContext.Provider, {
    value: pickerPanelContext
  }, /* @__PURE__ */ React261.createElement("div", {
    ref: rootRef,
    tabIndex,
    className: (0, import_classnames85.default)(panelCls, _defineProperty({}, "".concat(panelCls, "-rtl"), direction === "rtl"))
  }, /* @__PURE__ */ React261.createElement(PanelComponent, _extends({}, panelProps, {
    // Time
    showTime: mergedShowTime,
    prefixCls: mergedPrefixCls,
    locale: filledLocale,
    generateConfig: generateConfig2,
    onModeChange: triggerModeChange,
    pickerValue: mergedPickerValue,
    onPickerValueChange: function onPickerValueChange2(nextPickerValue) {
      setPickerValue(nextPickerValue, true);
    },
    value: mergedValue[0],
    onSelect: onPanelValueSelect,
    values: mergedValue,
    cellRender: onInternalCellRender,
    hoverRangeValue: hoverRangeDate,
    hoverValue
  }))));
}
var RefPanelPicker = /* @__PURE__ */ React261.memo(/* @__PURE__ */ React261.forwardRef(PickerPanel));
if (true) {
  RefPanelPicker.displayName = "PanelPicker";
}
var PickerPanel_default = RefPanelPicker;

// ../../node_modules/rc-picker/es/PickerInput/Popup/PopupPanel.js
function PopupPanel(props) {
  var picker = props.picker, multiplePanel = props.multiplePanel, pickerValue = props.pickerValue, onPickerValueChange = props.onPickerValueChange, needConfirm = props.needConfirm, onSubmit = props.onSubmit, range3 = props.range, hoverValue = props.hoverValue;
  var _React$useContext = React262.useContext(context_default3), prefixCls = _React$useContext.prefixCls, generateConfig2 = _React$useContext.generateConfig;
  var internalOffsetDate = React262.useCallback(function(date4, offset4) {
    return offsetPanelDate(generateConfig2, picker, date4, offset4);
  }, [generateConfig2, picker]);
  var nextPickerValue = React262.useMemo(function() {
    return internalOffsetDate(pickerValue, 1);
  }, [pickerValue, internalOffsetDate]);
  var onSecondPickerValueChange = function onSecondPickerValueChange2(nextDate) {
    onPickerValueChange(internalOffsetDate(nextDate, -1));
  };
  var sharedContext = {
    onCellDblClick: function onCellDblClick() {
      if (needConfirm) {
        onSubmit();
      }
    }
  };
  var hideHeader = picker === "time";
  var pickerProps = _objectSpread2(_objectSpread2({}, props), {}, {
    hoverValue: null,
    hoverRangeValue: null,
    hideHeader
  });
  if (range3) {
    pickerProps.hoverRangeValue = hoverValue;
  } else {
    pickerProps.hoverValue = hoverValue;
  }
  if (multiplePanel) {
    return /* @__PURE__ */ React262.createElement("div", {
      className: "".concat(prefixCls, "-panels")
    }, /* @__PURE__ */ React262.createElement(PickerHackContext.Provider, {
      value: _objectSpread2(_objectSpread2({}, sharedContext), {}, {
        hideNext: true
      })
    }, /* @__PURE__ */ React262.createElement(PickerPanel_default, pickerProps)), /* @__PURE__ */ React262.createElement(PickerHackContext.Provider, {
      value: _objectSpread2(_objectSpread2({}, sharedContext), {}, {
        hidePrev: true
      })
    }, /* @__PURE__ */ React262.createElement(PickerPanel_default, _extends({}, pickerProps, {
      pickerValue: nextPickerValue,
      onPickerValueChange: onSecondPickerValueChange
    }))));
  }
  return /* @__PURE__ */ React262.createElement(PickerHackContext.Provider, {
    value: _objectSpread2({}, sharedContext)
  }, /* @__PURE__ */ React262.createElement(PickerPanel_default, pickerProps));
}

// ../../node_modules/rc-picker/es/PickerInput/Popup/PresetPanel.js
var React263 = __toESM(require_react());
function executeValue(value) {
  return typeof value === "function" ? value() : value;
}
function PresetPanel(props) {
  var prefixCls = props.prefixCls, presets = props.presets, _onClick = props.onClick, onHover = props.onHover;
  if (!presets.length) {
    return null;
  }
  return /* @__PURE__ */ React263.createElement("div", {
    className: "".concat(prefixCls, "-presets")
  }, /* @__PURE__ */ React263.createElement("ul", null, presets.map(function(_ref, index3) {
    var label = _ref.label, value = _ref.value;
    return /* @__PURE__ */ React263.createElement("li", {
      key: index3,
      onClick: function onClick() {
        _onClick(executeValue(value));
      },
      onMouseEnter: function onMouseEnter() {
        onHover(executeValue(value));
      },
      onMouseLeave: function onMouseLeave() {
        onHover(null);
      }
    }, label);
  })));
}

// ../../node_modules/rc-picker/es/PickerInput/Popup/index.js
function Popup3(props) {
  var panelRender = props.panelRender, internalMode = props.internalMode, picker = props.picker, showNow = props.showNow, range3 = props.range, multiple = props.multiple, _props$activeInfo = props.activeInfo, activeInfo = _props$activeInfo === void 0 ? [0, 0, 0] : _props$activeInfo, presets = props.presets, onPresetHover = props.onPresetHover, onPresetSubmit = props.onPresetSubmit, onFocus = props.onFocus, onBlur = props.onBlur, onPanelMouseDown = props.onPanelMouseDown, direction = props.direction, value = props.value, onSelect = props.onSelect, isInvalid = props.isInvalid, defaultOpenValue = props.defaultOpenValue, onOk = props.onOk, onSubmit = props.onSubmit;
  var _React$useContext = React264.useContext(context_default3), prefixCls = _React$useContext.prefixCls;
  var panelPrefixCls = "".concat(prefixCls, "-panel");
  var rtl = direction === "rtl";
  var arrowRef = React264.useRef(null);
  var wrapperRef = React264.useRef(null);
  var _React$useState = React264.useState(0), _React$useState2 = _slicedToArray(_React$useState, 2), containerWidth = _React$useState2[0], setContainerWidth = _React$useState2[1];
  var _React$useState3 = React264.useState(0), _React$useState4 = _slicedToArray(_React$useState3, 2), containerOffset = _React$useState4[0], setContainerOffset = _React$useState4[1];
  var _React$useState5 = React264.useState(0), _React$useState6 = _slicedToArray(_React$useState5, 2), arrowOffset = _React$useState6[0], setArrowOffset = _React$useState6[1];
  var onResize2 = function onResize3(info) {
    if (info.width) {
      setContainerWidth(info.width);
    }
  };
  var _activeInfo = _slicedToArray(activeInfo, 3), activeInputLeft = _activeInfo[0], activeInputRight = _activeInfo[1], selectorWidth = _activeInfo[2];
  var _React$useState7 = React264.useState(0), _React$useState8 = _slicedToArray(_React$useState7, 2), retryTimes = _React$useState8[0], setRetryTimes = _React$useState8[1];
  React264.useEffect(function() {
    setRetryTimes(10);
  }, [activeInputLeft]);
  React264.useEffect(function() {
    if (range3 && wrapperRef.current) {
      var _arrowRef$current;
      var arrowWidth = ((_arrowRef$current = arrowRef.current) === null || _arrowRef$current === void 0 ? void 0 : _arrowRef$current.offsetWidth) || 0;
      var wrapperRect = wrapperRef.current.getBoundingClientRect();
      if (!wrapperRect.height || wrapperRect.right < 0) {
        setRetryTimes(function(times) {
          return Math.max(0, times - 1);
        });
        return;
      }
      var nextArrowOffset = (rtl ? activeInputRight - arrowWidth : activeInputLeft) - wrapperRect.left;
      setArrowOffset(nextArrowOffset);
      if (containerWidth && containerWidth < selectorWidth) {
        var offset4 = rtl ? wrapperRect.right - (activeInputRight - arrowWidth + containerWidth) : activeInputLeft + arrowWidth - wrapperRect.left - containerWidth;
        var safeOffset = Math.max(0, offset4);
        setContainerOffset(safeOffset);
      } else {
        setContainerOffset(0);
      }
    }
  }, [retryTimes, rtl, containerWidth, activeInputLeft, activeInputRight, selectorWidth, range3]);
  function filterEmpty(list) {
    return list.filter(function(item) {
      return item;
    });
  }
  var valueList = React264.useMemo(function() {
    return filterEmpty(toArray5(value));
  }, [value]);
  var isTimePickerEmptyValue = picker === "time" && !valueList.length;
  var footerSubmitValue = React264.useMemo(function() {
    if (isTimePickerEmptyValue) {
      return filterEmpty([defaultOpenValue]);
    }
    return valueList;
  }, [isTimePickerEmptyValue, valueList, defaultOpenValue]);
  var popupPanelValue = isTimePickerEmptyValue ? defaultOpenValue : valueList;
  var disableSubmit = React264.useMemo(function() {
    if (!footerSubmitValue.length) {
      return true;
    }
    return footerSubmitValue.some(function(val) {
      return isInvalid(val);
    });
  }, [footerSubmitValue, isInvalid]);
  var onFooterSubmit = function onFooterSubmit2() {
    if (isTimePickerEmptyValue) {
      onSelect(defaultOpenValue);
    }
    onOk();
    onSubmit();
  };
  var mergedNodes = /* @__PURE__ */ React264.createElement("div", {
    className: "".concat(prefixCls, "-panel-layout")
  }, /* @__PURE__ */ React264.createElement(PresetPanel, {
    prefixCls,
    presets,
    onClick: onPresetSubmit,
    onHover: onPresetHover
  }), /* @__PURE__ */ React264.createElement("div", null, /* @__PURE__ */ React264.createElement(PopupPanel, _extends({}, props, {
    value: popupPanelValue
  })), /* @__PURE__ */ React264.createElement(Footer, _extends({}, props, {
    showNow: multiple ? false : showNow,
    invalid: disableSubmit,
    onSubmit: onFooterSubmit
  }))));
  if (panelRender) {
    mergedNodes = panelRender(mergedNodes);
  }
  var containerPrefixCls = "".concat(panelPrefixCls, "-container");
  var marginLeft = "marginLeft";
  var marginRight = "marginRight";
  var renderNode = /* @__PURE__ */ React264.createElement("div", {
    onMouseDown: onPanelMouseDown,
    tabIndex: -1,
    className: (0, import_classnames86.default)(
      containerPrefixCls,
      // Used for Today Button style, safe to remove if no need
      "".concat(prefixCls, "-").concat(internalMode, "-panel-container")
    ),
    style: _defineProperty(_defineProperty({}, rtl ? marginRight : marginLeft, containerOffset), rtl ? marginLeft : marginRight, "auto"),
    onFocus,
    onBlur
  }, mergedNodes);
  if (range3) {
    renderNode = /* @__PURE__ */ React264.createElement("div", {
      onMouseDown: onPanelMouseDown,
      ref: wrapperRef,
      className: (0, import_classnames86.default)("".concat(prefixCls, "-range-wrapper"), "".concat(prefixCls, "-").concat(picker, "-range-wrapper"))
    }, /* @__PURE__ */ React264.createElement("div", {
      ref: arrowRef,
      className: "".concat(prefixCls, "-range-arrow"),
      style: {
        left: arrowOffset
      }
    }), /* @__PURE__ */ React264.createElement(es_default, {
      onResize: onResize2
    }, renderNode));
  }
  return renderNode;
}

// ../../node_modules/rc-picker/es/PickerInput/Selector/RangeSelector.js
var import_classnames88 = __toESM(require_classnames());
var React269 = __toESM(require_react());

// ../../node_modules/rc-picker/es/PickerInput/Selector/hooks/useInputProps.js
var React265 = __toESM(require_react());
function useInputProps(props, postProps) {
  var format3 = props.format, maskFormat = props.maskFormat, generateConfig2 = props.generateConfig, locale6 = props.locale, preserveInvalidOnBlur = props.preserveInvalidOnBlur, inputReadOnly = props.inputReadOnly, required5 = props.required, ariaRequired = props["aria-required"], onSubmit = props.onSubmit, _onFocus = props.onFocus, _onBlur = props.onBlur, onInputChange = props.onInputChange, onInvalid = props.onInvalid, open2 = props.open, onOpenChange = props.onOpenChange, _onKeyDown = props.onKeyDown, _onChange = props.onChange, activeHelp = props.activeHelp, name = props.name, autoComplete = props.autoComplete, id = props.id, value = props.value, invalid = props.invalid, placeholder = props.placeholder, disabled = props.disabled, activeIndex = props.activeIndex, allHelp = props.allHelp, picker = props.picker;
  var parseDate = function parseDate2(str, formatStr) {
    var parsed = generateConfig2.locale.parse(locale6.locale, str, [formatStr]);
    return parsed && generateConfig2.isValidate(parsed) ? parsed : null;
  };
  var firstFormat = format3[0];
  var getText = React265.useCallback(function(date4) {
    return formatValue(date4, {
      locale: locale6,
      format: firstFormat,
      generateConfig: generateConfig2
    });
  }, [locale6, generateConfig2, firstFormat]);
  var valueTexts = React265.useMemo(function() {
    return value.map(getText);
  }, [value, getText]);
  var size = React265.useMemo(function() {
    var defaultSize = picker === "time" ? 8 : 10;
    var length2 = typeof firstFormat === "function" ? firstFormat(generateConfig2.getNow()).length : firstFormat.length;
    return Math.max(defaultSize, length2) + 2;
  }, [firstFormat, picker, generateConfig2]);
  var _validateFormat = function validateFormat(text) {
    for (var i = 0; i < format3.length; i += 1) {
      var singleFormat = format3[i];
      if (typeof singleFormat === "string") {
        var parsed = parseDate(text, singleFormat);
        if (parsed) {
          return parsed;
        }
      }
    }
    return false;
  };
  var getInputProps = function getInputProps2(index3) {
    function getProp(propValue) {
      return index3 !== void 0 ? propValue[index3] : propValue;
    }
    var pickedAttrs = pickAttrs(props, {
      aria: true,
      data: true
    });
    var inputProps = _objectSpread2(_objectSpread2({}, pickedAttrs), {}, {
      // ============== Shared ==============
      format: maskFormat,
      validateFormat: function validateFormat(text) {
        return !!_validateFormat(text);
      },
      preserveInvalidOnBlur,
      readOnly: inputReadOnly,
      required: required5,
      "aria-required": ariaRequired,
      name,
      autoComplete,
      size,
      // ============= By Index =============
      id: getProp(id),
      value: getProp(valueTexts) || "",
      invalid: getProp(invalid),
      placeholder: getProp(placeholder),
      active: activeIndex === index3,
      helped: allHelp || activeHelp && activeIndex === index3,
      disabled: getProp(disabled),
      onFocus: function onFocus(event) {
        _onFocus(event, index3);
      },
      onBlur: function onBlur(event) {
        _onBlur(event, index3);
      },
      onSubmit,
      // Get validate text value
      onChange: function onChange(text) {
        onInputChange();
        var parsed = _validateFormat(text);
        if (parsed) {
          onInvalid(false, index3);
          _onChange(parsed, index3);
          return;
        }
        onInvalid(!!text, index3);
      },
      onHelp: function onHelp() {
        onOpenChange(true, {
          index: index3
        });
      },
      onKeyDown: function onKeyDown2(event) {
        var prevented = false;
        _onKeyDown === null || _onKeyDown === void 0 || _onKeyDown(event, function() {
          if (true) {
            warning_default(false, "`preventDefault` callback is deprecated. Please call `event.preventDefault` directly.");
          }
          prevented = true;
        });
        if (!event.defaultPrevented && !prevented) {
          switch (event.key) {
            case "Escape":
              onOpenChange(false, {
                index: index3
              });
              break;
            case "Enter":
              if (!open2) {
                onOpenChange(true);
              }
              break;
          }
        }
      }
    }, postProps === null || postProps === void 0 ? void 0 : postProps({
      valueTexts
    }));
    Object.keys(inputProps).forEach(function(key2) {
      if (inputProps[key2] === void 0) {
        delete inputProps[key2];
      }
    });
    return inputProps;
  };
  return [getInputProps, getText];
}

// ../../node_modules/rc-picker/es/PickerInput/Selector/hooks/useRootProps.js
var React266 = __toESM(require_react());
var propNames = ["onMouseEnter", "onMouseLeave"];
function useRootProps(props) {
  return React266.useMemo(function() {
    return pickProps(props, propNames);
  }, [props]);
}

// ../../node_modules/rc-picker/es/PickerInput/Selector/Icon.js
var React267 = __toESM(require_react());
var _excluded40 = ["icon", "type"];
var _excluded212 = ["onClear"];
function Icon3(props) {
  var icon = props.icon, type5 = props.type, restProps = _objectWithoutProperties(props, _excluded40);
  var _React$useContext = React267.useContext(context_default3), prefixCls = _React$useContext.prefixCls;
  return icon ? /* @__PURE__ */ React267.createElement("span", _extends({
    className: "".concat(prefixCls, "-").concat(type5)
  }, restProps), icon) : null;
}
function ClearIcon(_ref) {
  var onClear = _ref.onClear, restProps = _objectWithoutProperties(_ref, _excluded212);
  return /* @__PURE__ */ React267.createElement(Icon3, _extends({}, restProps, {
    type: "clear",
    role: "button",
    onMouseDown: function onMouseDown(e3) {
      e3.preventDefault();
    },
    onClick: function onClick(e3) {
      e3.stopPropagation();
      onClear();
    }
  }));
}

// ../../node_modules/rc-picker/es/PickerInput/Selector/Input.js
var import_classnames87 = __toESM(require_classnames());
var React268 = __toESM(require_react());

// ../../node_modules/rc-picker/es/PickerInput/Selector/MaskFormat.js
var FORMAT_KEYS = ["YYYY", "MM", "DD", "HH", "mm", "ss", "SSS"];
var REPLACE_KEY = "\u9867";
var MaskFormat = /* @__PURE__ */ (function() {
  function MaskFormat2(format3) {
    _classCallCheck(this, MaskFormat2);
    _defineProperty(this, "format", void 0);
    _defineProperty(this, "maskFormat", void 0);
    _defineProperty(this, "cells", void 0);
    _defineProperty(this, "maskCells", void 0);
    this.format = format3;
    var replaceKeys = FORMAT_KEYS.map(function(key2) {
      return "(".concat(key2, ")");
    }).join("|");
    var replaceReg = new RegExp(replaceKeys, "g");
    this.maskFormat = format3.replace(
      replaceReg,
      // Use Chinese character to avoid user use it in format
      function(key2) {
        return REPLACE_KEY.repeat(key2.length);
      }
    );
    var cellReg = new RegExp("(".concat(FORMAT_KEYS.join("|"), ")"));
    var strCells = (format3.split(cellReg) || []).filter(function(str) {
      return str;
    });
    var offset4 = 0;
    this.cells = strCells.map(function(text) {
      var mask = FORMAT_KEYS.includes(text);
      var start = offset4;
      var end = offset4 + text.length;
      offset4 = end;
      return {
        text,
        mask,
        start,
        end
      };
    });
    this.maskCells = this.cells.filter(function(cell) {
      return cell.mask;
    });
  }
  _createClass(MaskFormat2, [{
    key: "getSelection",
    value: function getSelection(maskCellIndex) {
      var _ref = this.maskCells[maskCellIndex] || {}, start = _ref.start, end = _ref.end;
      return [start || 0, end || 0];
    }
    /** Check given text match format */
  }, {
    key: "match",
    value: function match2(text) {
      for (var i = 0; i < this.maskFormat.length; i += 1) {
        var maskChar = this.maskFormat[i];
        var textChar = text[i];
        if (!textChar || maskChar !== REPLACE_KEY && maskChar !== textChar) {
          return false;
        }
      }
      return true;
    }
    /** Get mask cell count */
  }, {
    key: "size",
    value: function size() {
      return this.maskCells.length;
    }
  }, {
    key: "getMaskCellIndex",
    value: function getMaskCellIndex(anchorIndex) {
      var closetDist = Number.MAX_SAFE_INTEGER;
      var closetIndex = 0;
      for (var i = 0; i < this.maskCells.length; i += 1) {
        var _this$maskCells$i = this.maskCells[i], start = _this$maskCells$i.start, end = _this$maskCells$i.end;
        if (anchorIndex >= start && anchorIndex <= end) {
          return i;
        }
        var dist = Math.min(Math.abs(anchorIndex - start), Math.abs(anchorIndex - end));
        if (dist < closetDist) {
          closetDist = dist;
          closetIndex = i;
        }
      }
      return closetIndex;
    }
  }]);
  return MaskFormat2;
})();

// ../../node_modules/rc-picker/es/PickerInput/Selector/util.js
function getMaskRange(key2) {
  var PresetRange = {
    YYYY: [0, 9999, (/* @__PURE__ */ new Date()).getFullYear()],
    MM: [1, 12],
    DD: [1, 31],
    HH: [0, 23],
    mm: [0, 59],
    ss: [0, 59],
    SSS: [0, 999]
  };
  return PresetRange[key2];
}

// ../../node_modules/rc-picker/es/PickerInput/Selector/Input.js
var _excluded41 = ["active", "showActiveCls", "suffixIcon", "format", "validateFormat", "onChange", "onInput", "helped", "onHelp", "onSubmit", "onKeyDown", "preserveInvalidOnBlur", "invalid", "clearIcon"];
var Input3 = /* @__PURE__ */ React268.forwardRef(function(props, ref3) {
  var active = props.active, _props$showActiveCls = props.showActiveCls, showActiveCls = _props$showActiveCls === void 0 ? true : _props$showActiveCls, suffixIcon = props.suffixIcon, format3 = props.format, validateFormat = props.validateFormat, onChange = props.onChange, onInput = props.onInput, helped = props.helped, onHelp = props.onHelp, onSubmit = props.onSubmit, onKeyDown2 = props.onKeyDown, _props$preserveInvali = props.preserveInvalidOnBlur, preserveInvalidOnBlur = _props$preserveInvali === void 0 ? false : _props$preserveInvali, invalid = props.invalid, clearIcon = props.clearIcon, restProps = _objectWithoutProperties(props, _excluded41);
  var value = props.value, onFocus = props.onFocus, onBlur = props.onBlur, onMouseUp = props.onMouseUp;
  var _React$useContext = React268.useContext(context_default3), prefixCls = _React$useContext.prefixCls, _React$useContext$inp = _React$useContext.input, Component10 = _React$useContext$inp === void 0 ? "input" : _React$useContext$inp;
  var inputPrefixCls = "".concat(prefixCls, "-input");
  var _React$useState = React268.useState(false), _React$useState2 = _slicedToArray(_React$useState, 2), focused = _React$useState2[0], setFocused = _React$useState2[1];
  var _React$useState3 = React268.useState(value), _React$useState4 = _slicedToArray(_React$useState3, 2), internalInputValue = _React$useState4[0], setInputValue = _React$useState4[1];
  var _React$useState5 = React268.useState(""), _React$useState6 = _slicedToArray(_React$useState5, 2), focusCellText = _React$useState6[0], setFocusCellText = _React$useState6[1];
  var _React$useState7 = React268.useState(null), _React$useState8 = _slicedToArray(_React$useState7, 2), focusCellIndex = _React$useState8[0], setFocusCellIndex = _React$useState8[1];
  var _React$useState9 = React268.useState(null), _React$useState10 = _slicedToArray(_React$useState9, 2), forceSelectionSyncMark = _React$useState10[0], forceSelectionSync = _React$useState10[1];
  var inputValue = internalInputValue || "";
  React268.useEffect(function() {
    setInputValue(value);
  }, [value]);
  var holderRef = React268.useRef();
  var inputRef = React268.useRef();
  React268.useImperativeHandle(ref3, function() {
    return {
      nativeElement: holderRef.current,
      inputElement: inputRef.current,
      focus: function focus(options) {
        inputRef.current.focus(options);
      },
      blur: function blur() {
        inputRef.current.blur();
      }
    };
  });
  var maskFormat = React268.useMemo(function() {
    return new MaskFormat(format3 || "");
  }, [format3]);
  var _React$useMemo = React268.useMemo(function() {
    if (helped) {
      return [0, 0];
    }
    return maskFormat.getSelection(focusCellIndex);
  }, [maskFormat, focusCellIndex, helped]), _React$useMemo2 = _slicedToArray(_React$useMemo, 2), selectionStart = _React$useMemo2[0], selectionEnd = _React$useMemo2[1];
  var onModify = function onModify2(text) {
    if (text && text !== format3 && text !== value) {
      onHelp();
    }
  };
  var triggerInputChange = useEvent2(function(text) {
    if (validateFormat(text)) {
      onChange(text);
    }
    setInputValue(text);
    onModify(text);
  });
  var onInternalChange = function onInternalChange2(event) {
    if (!format3) {
      var text = event.target.value;
      onModify(text);
      setInputValue(text);
      onChange(text);
    }
  };
  var onFormatPaste = function onFormatPaste2(event) {
    var pasteText = event.clipboardData.getData("text");
    if (validateFormat(pasteText)) {
      triggerInputChange(pasteText);
    }
  };
  var mouseDownRef = React268.useRef(false);
  var onFormatMouseDown = function onFormatMouseDown2() {
    mouseDownRef.current = true;
  };
  var onFormatMouseUp = function onFormatMouseUp2(event) {
    var _ref = event.target, start = _ref.selectionStart;
    var closeMaskIndex = maskFormat.getMaskCellIndex(start);
    setFocusCellIndex(closeMaskIndex);
    forceSelectionSync({});
    onMouseUp === null || onMouseUp === void 0 || onMouseUp(event);
    mouseDownRef.current = false;
  };
  var onFormatFocus = function onFormatFocus2(event) {
    setFocused(true);
    setFocusCellIndex(0);
    setFocusCellText("");
    onFocus(event);
  };
  var onSharedBlur = function onSharedBlur2(event) {
    onBlur(event);
  };
  var onFormatBlur = function onFormatBlur2(event) {
    setFocused(false);
    onSharedBlur(event);
  };
  useLockEffect(active, function() {
    if (!active && !preserveInvalidOnBlur) {
      setInputValue(value);
    }
  });
  var onSharedKeyDown = function onSharedKeyDown2(event) {
    if (event.key === "Enter" && validateFormat(inputValue)) {
      onSubmit();
    }
    onKeyDown2 === null || onKeyDown2 === void 0 || onKeyDown2(event);
  };
  var onFormatKeyDown = function onFormatKeyDown2(event) {
    onSharedKeyDown(event);
    var key2 = event.key;
    var nextCellText = null;
    var nextFillText = null;
    var maskCellLen = selectionEnd - selectionStart;
    var cellFormat = format3.slice(selectionStart, selectionEnd);
    var offsetCellIndex = function offsetCellIndex2(offset4) {
      setFocusCellIndex(function(idx) {
        var nextIndex2 = idx + offset4;
        nextIndex2 = Math.max(nextIndex2, 0);
        nextIndex2 = Math.min(nextIndex2, maskFormat.size() - 1);
        return nextIndex2;
      });
    };
    var offsetCellValue = function offsetCellValue2(offset4) {
      var _getMaskRange = getMaskRange(cellFormat), _getMaskRange2 = _slicedToArray(_getMaskRange, 3), rangeStart = _getMaskRange2[0], rangeEnd = _getMaskRange2[1], rangeDefault = _getMaskRange2[2];
      var currentText = inputValue.slice(selectionStart, selectionEnd);
      var currentTextNum = Number(currentText);
      if (isNaN(currentTextNum)) {
        return String(rangeDefault ? rangeDefault : offset4 > 0 ? rangeStart : rangeEnd);
      }
      var num = currentTextNum + offset4;
      var range3 = rangeEnd - rangeStart + 1;
      return String(rangeStart + (range3 + num - rangeStart) % range3);
    };
    switch (key2) {
      // =============== Remove ===============
      case "Backspace":
      case "Delete":
        nextCellText = "";
        nextFillText = cellFormat;
        break;
      // =============== Arrows ===============
      // Left key
      case "ArrowLeft":
        nextCellText = "";
        offsetCellIndex(-1);
        break;
      // Right key
      case "ArrowRight":
        nextCellText = "";
        offsetCellIndex(1);
        break;
      // Up key
      case "ArrowUp":
        nextCellText = "";
        nextFillText = offsetCellValue(1);
        break;
      // Down key
      case "ArrowDown":
        nextCellText = "";
        nextFillText = offsetCellValue(-1);
        break;
      // =============== Number ===============
      default:
        if (!isNaN(Number(key2))) {
          nextCellText = focusCellText + key2;
          nextFillText = nextCellText;
        }
        break;
    }
    if (nextCellText !== null) {
      setFocusCellText(nextCellText);
      if (nextCellText.length >= maskCellLen) {
        offsetCellIndex(1);
        setFocusCellText("");
      }
    }
    if (nextFillText !== null) {
      var nextFocusValue = (
        // before
        inputValue.slice(0, selectionStart) + // replace
        leftPad(nextFillText, maskCellLen) + // after
        inputValue.slice(selectionEnd)
      );
      triggerInputChange(nextFocusValue.slice(0, format3.length));
    }
    forceSelectionSync({});
  };
  var rafRef = React268.useRef();
  useLayoutEffect_default(function() {
    if (!focused || !format3 || mouseDownRef.current) {
      return;
    }
    if (!maskFormat.match(inputValue)) {
      triggerInputChange(format3);
      return;
    }
    inputRef.current.setSelectionRange(selectionStart, selectionEnd);
    rafRef.current = raf_default(function() {
      inputRef.current.setSelectionRange(selectionStart, selectionEnd);
    });
    return function() {
      raf_default.cancel(rafRef.current);
    };
  }, [maskFormat, format3, focused, inputValue, focusCellIndex, selectionStart, selectionEnd, forceSelectionSyncMark, triggerInputChange]);
  var inputProps = format3 ? {
    onFocus: onFormatFocus,
    onBlur: onFormatBlur,
    onKeyDown: onFormatKeyDown,
    onMouseDown: onFormatMouseDown,
    onMouseUp: onFormatMouseUp,
    onPaste: onFormatPaste
  } : {};
  return /* @__PURE__ */ React268.createElement("div", {
    ref: holderRef,
    className: (0, import_classnames87.default)(inputPrefixCls, _defineProperty(_defineProperty({}, "".concat(inputPrefixCls, "-active"), active && showActiveCls), "".concat(inputPrefixCls, "-placeholder"), helped))
  }, /* @__PURE__ */ React268.createElement(Component10, _extends({
    ref: inputRef,
    "aria-invalid": invalid,
    autoComplete: "off"
  }, restProps, {
    onKeyDown: onSharedKeyDown,
    onBlur: onSharedBlur
    // Replace with format
  }, inputProps, {
    // Value
    value: inputValue,
    onChange: onInternalChange
  })), /* @__PURE__ */ React268.createElement(Icon3, {
    type: "suffix",
    icon: suffixIcon
  }), clearIcon);
});
if (true) {
  Input3.displayName = "Input";
}
var Input_default3 = Input3;

// ../../node_modules/rc-picker/es/PickerInput/Selector/RangeSelector.js
var _excluded42 = ["id", "prefix", "clearIcon", "suffixIcon", "separator", "activeIndex", "activeHelp", "allHelp", "focused", "onFocus", "onBlur", "onKeyDown", "locale", "generateConfig", "placeholder", "className", "style", "onClick", "onClear", "value", "onChange", "onSubmit", "onInputChange", "format", "maskFormat", "preserveInvalidOnBlur", "onInvalid", "disabled", "invalid", "inputReadOnly", "direction", "onOpenChange", "onActiveInfo", "placement", "onMouseDown", "required", "aria-required", "autoFocus", "tabIndex"];
var _excluded213 = ["index"];
function RangeSelector(props, ref3) {
  var id = props.id, prefix3 = props.prefix, clearIcon = props.clearIcon, suffixIcon = props.suffixIcon, _props$separator = props.separator, separator = _props$separator === void 0 ? "~" : _props$separator, activeIndex = props.activeIndex, activeHelp = props.activeHelp, allHelp = props.allHelp, focused = props.focused, onFocus = props.onFocus, onBlur = props.onBlur, onKeyDown2 = props.onKeyDown, locale6 = props.locale, generateConfig2 = props.generateConfig, placeholder = props.placeholder, className2 = props.className, style2 = props.style, onClick = props.onClick, onClear = props.onClear, value = props.value, onChange = props.onChange, onSubmit = props.onSubmit, onInputChange = props.onInputChange, format3 = props.format, maskFormat = props.maskFormat, preserveInvalidOnBlur = props.preserveInvalidOnBlur, onInvalid = props.onInvalid, disabled = props.disabled, invalid = props.invalid, inputReadOnly = props.inputReadOnly, direction = props.direction, onOpenChange = props.onOpenChange, onActiveInfo = props.onActiveInfo, placement = props.placement, _onMouseDown = props.onMouseDown, required5 = props.required, ariaRequired = props["aria-required"], autoFocus = props.autoFocus, tabIndex = props.tabIndex, restProps = _objectWithoutProperties(props, _excluded42);
  var rtl = direction === "rtl";
  var _React$useContext = React269.useContext(context_default3), prefixCls = _React$useContext.prefixCls;
  var ids2 = React269.useMemo(function() {
    if (typeof id === "string") {
      return [id];
    }
    var mergedId = id || {};
    return [mergedId.start, mergedId.end];
  }, [id]);
  var rootRef = React269.useRef();
  var inputStartRef = React269.useRef();
  var inputEndRef = React269.useRef();
  var getInput = function getInput2(index3) {
    var _index;
    return (_index = [inputStartRef, inputEndRef][index3]) === null || _index === void 0 ? void 0 : _index.current;
  };
  React269.useImperativeHandle(ref3, function() {
    return {
      nativeElement: rootRef.current,
      focus: function focus(options) {
        if (_typeof(options) === "object") {
          var _getInput;
          var _ref = options || {}, _ref$index = _ref.index, _index2 = _ref$index === void 0 ? 0 : _ref$index, rest = _objectWithoutProperties(_ref, _excluded213);
          (_getInput = getInput(_index2)) === null || _getInput === void 0 || _getInput.focus(rest);
        } else {
          var _getInput2;
          (_getInput2 = getInput(options !== null && options !== void 0 ? options : 0)) === null || _getInput2 === void 0 || _getInput2.focus();
        }
      },
      blur: function blur() {
        var _getInput3, _getInput4;
        (_getInput3 = getInput(0)) === null || _getInput3 === void 0 || _getInput3.blur();
        (_getInput4 = getInput(1)) === null || _getInput4 === void 0 || _getInput4.blur();
      }
    };
  });
  var rootProps = useRootProps(restProps);
  var mergedPlaceholder = React269.useMemo(function() {
    return Array.isArray(placeholder) ? placeholder : [placeholder, placeholder];
  }, [placeholder]);
  var _useInputProps = useInputProps(_objectSpread2(_objectSpread2({}, props), {}, {
    id: ids2,
    placeholder: mergedPlaceholder
  })), _useInputProps2 = _slicedToArray(_useInputProps, 1), getInputProps = _useInputProps2[0];
  var _React$useState = React269.useState({
    position: "absolute",
    width: 0
  }), _React$useState2 = _slicedToArray(_React$useState, 2), activeBarStyle = _React$useState2[0], setActiveBarStyle = _React$useState2[1];
  var syncActiveOffset = useEvent2(function() {
    var input = getInput(activeIndex);
    if (input) {
      var inputRect = input.nativeElement.getBoundingClientRect();
      var parentRect = rootRef.current.getBoundingClientRect();
      var rectOffset = inputRect.left - parentRect.left;
      setActiveBarStyle(function(ori) {
        return _objectSpread2(_objectSpread2({}, ori), {}, {
          width: inputRect.width,
          left: rectOffset
        });
      });
      onActiveInfo([inputRect.left, inputRect.right, parentRect.width]);
    }
  });
  React269.useEffect(function() {
    syncActiveOffset();
  }, [activeIndex]);
  var showClear = clearIcon && (value[0] && !disabled[0] || value[1] && !disabled[1]);
  var startAutoFocus = autoFocus && !disabled[0];
  var endAutoFocus = autoFocus && !startAutoFocus && !disabled[1];
  return /* @__PURE__ */ React269.createElement(es_default, {
    onResize: syncActiveOffset
  }, /* @__PURE__ */ React269.createElement("div", _extends({}, rootProps, {
    className: (0, import_classnames88.default)(prefixCls, "".concat(prefixCls, "-range"), _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "".concat(prefixCls, "-focused"), focused), "".concat(prefixCls, "-disabled"), disabled.every(function(i) {
      return i;
    })), "".concat(prefixCls, "-invalid"), invalid.some(function(i) {
      return i;
    })), "".concat(prefixCls, "-rtl"), rtl), className2),
    style: style2,
    ref: rootRef,
    onClick,
    onMouseDown: function onMouseDown(e3) {
      var target = e3.target;
      if (target !== inputStartRef.current.inputElement && target !== inputEndRef.current.inputElement) {
        e3.preventDefault();
      }
      _onMouseDown === null || _onMouseDown === void 0 || _onMouseDown(e3);
    }
  }), prefix3 && /* @__PURE__ */ React269.createElement("div", {
    className: "".concat(prefixCls, "-prefix")
  }, prefix3), /* @__PURE__ */ React269.createElement(Input_default3, _extends({
    ref: inputStartRef
  }, getInputProps(0), {
    autoFocus: startAutoFocus,
    tabIndex,
    "date-range": "start"
  })), /* @__PURE__ */ React269.createElement("div", {
    className: "".concat(prefixCls, "-range-separator")
  }, separator), /* @__PURE__ */ React269.createElement(Input_default3, _extends({
    ref: inputEndRef
  }, getInputProps(1), {
    autoFocus: endAutoFocus,
    tabIndex,
    "date-range": "end"
  })), /* @__PURE__ */ React269.createElement("div", {
    className: "".concat(prefixCls, "-active-bar"),
    style: activeBarStyle
  }), /* @__PURE__ */ React269.createElement(Icon3, {
    type: "suffix",
    icon: suffixIcon
  }), showClear && /* @__PURE__ */ React269.createElement(ClearIcon, {
    icon: clearIcon,
    onClear
  })));
}
var RefRangeSelector = /* @__PURE__ */ React269.forwardRef(RangeSelector);
if (true) {
  RefRangeSelector.displayName = "RangeSelector";
}
var RangeSelector_default = RefRangeSelector;

// ../../node_modules/rc-picker/es/PickerInput/RangePicker.js
function separateConfig(config, defaultConfig2) {
  var singleConfig = config !== null && config !== void 0 ? config : defaultConfig2;
  if (Array.isArray(singleConfig)) {
    return singleConfig;
  }
  return [singleConfig, singleConfig];
}
function getActiveRange(activeIndex) {
  return activeIndex === 1 ? "end" : "start";
}
function RangePicker(props, ref3) {
  var _useFilledProps = useFilledProps(props, function() {
    var disabled2 = props.disabled, allowEmpty2 = props.allowEmpty;
    var mergedDisabled = separateConfig(disabled2, false);
    var mergedAllowEmpty = separateConfig(allowEmpty2, false);
    return {
      disabled: mergedDisabled,
      allowEmpty: mergedAllowEmpty
    };
  }), _useFilledProps2 = _slicedToArray(_useFilledProps, 6), filledProps = _useFilledProps2[0], internalPicker = _useFilledProps2[1], complexPicker = _useFilledProps2[2], formatList = _useFilledProps2[3], maskFormat = _useFilledProps2[4], isInvalidateDate = _useFilledProps2[5];
  var prefixCls = filledProps.prefixCls, styles = filledProps.styles, classNames186 = filledProps.classNames, defaultValue2 = filledProps.defaultValue, value = filledProps.value, needConfirm = filledProps.needConfirm, onKeyDown2 = filledProps.onKeyDown, disabled = filledProps.disabled, allowEmpty = filledProps.allowEmpty, disabledDate = filledProps.disabledDate, minDate = filledProps.minDate, maxDate = filledProps.maxDate, defaultOpen = filledProps.defaultOpen, open2 = filledProps.open, onOpenChange = filledProps.onOpenChange, locale6 = filledProps.locale, generateConfig2 = filledProps.generateConfig, picker = filledProps.picker, showNow = filledProps.showNow, showToday = filledProps.showToday, showTime = filledProps.showTime, mode = filledProps.mode, onPanelChange = filledProps.onPanelChange, onCalendarChange = filledProps.onCalendarChange, onOk = filledProps.onOk, defaultPickerValue = filledProps.defaultPickerValue, pickerValue = filledProps.pickerValue, onPickerValueChange = filledProps.onPickerValueChange, inputReadOnly = filledProps.inputReadOnly, suffixIcon = filledProps.suffixIcon, onFocus = filledProps.onFocus, onBlur = filledProps.onBlur, presets = filledProps.presets, ranges = filledProps.ranges, components = filledProps.components, cellRender = filledProps.cellRender, dateRender = filledProps.dateRender, monthCellRender = filledProps.monthCellRender, onClick = filledProps.onClick;
  var selectorRef = usePickerRef(ref3);
  var _useOpen = useOpen(open2, defaultOpen, disabled, onOpenChange), _useOpen2 = _slicedToArray(_useOpen, 2), mergedOpen = _useOpen2[0], setMergeOpen = _useOpen2[1];
  var triggerOpen = function triggerOpen2(nextOpen, config) {
    if (disabled.some(function(fieldDisabled) {
      return !fieldDisabled;
    }) || !nextOpen) {
      setMergeOpen(nextOpen, config);
    }
  };
  var _useInnerValue = useInnerValue(generateConfig2, locale6, formatList, true, false, defaultValue2, value, onCalendarChange, onOk), _useInnerValue2 = _slicedToArray(_useInnerValue, 5), mergedValue = _useInnerValue2[0], setInnerValue = _useInnerValue2[1], getCalendarValue = _useInnerValue2[2], triggerCalendarChange = _useInnerValue2[3], triggerOk = _useInnerValue2[4];
  var calendarValue = getCalendarValue();
  var _useRangeActive = useRangeActive(disabled, allowEmpty, mergedOpen), _useRangeActive2 = _slicedToArray(_useRangeActive, 9), focused = _useRangeActive2[0], triggerFocus2 = _useRangeActive2[1], lastOperation = _useRangeActive2[2], activeIndex = _useRangeActive2[3], setActiveIndex = _useRangeActive2[4], nextActiveIndex = _useRangeActive2[5], activeIndexList = _useRangeActive2[6], updateSubmitIndex = _useRangeActive2[7], hasActiveSubmitValue = _useRangeActive2[8];
  var onSharedFocus = function onSharedFocus2(event, index3) {
    triggerFocus2(true);
    onFocus === null || onFocus === void 0 || onFocus(event, {
      range: getActiveRange(index3 !== null && index3 !== void 0 ? index3 : activeIndex)
    });
  };
  var onSharedBlur = function onSharedBlur2(event, index3) {
    triggerFocus2(false);
    onBlur === null || onBlur === void 0 || onBlur(event, {
      range: getActiveRange(index3 !== null && index3 !== void 0 ? index3 : activeIndex)
    });
  };
  var mergedShowTime = React270.useMemo(function() {
    if (!showTime) {
      return null;
    }
    var disabledTime = showTime.disabledTime;
    var proxyDisabledTime = disabledTime ? function(date4) {
      var range3 = getActiveRange(activeIndex);
      var fromDate = getFromDate(calendarValue, activeIndexList, activeIndex);
      return disabledTime(date4, range3, {
        from: fromDate
      });
    } : void 0;
    return _objectSpread2(_objectSpread2({}, showTime), {}, {
      disabledTime: proxyDisabledTime
    });
  }, [showTime, activeIndex, calendarValue, activeIndexList]);
  var _useMergedState = useMergedState([picker, picker], {
    value: mode
  }), _useMergedState2 = _slicedToArray(_useMergedState, 2), modes = _useMergedState2[0], setModes = _useMergedState2[1];
  var mergedMode = modes[activeIndex] || picker;
  var internalMode = mergedMode === "date" && mergedShowTime ? "datetime" : mergedMode;
  var multiplePanel = internalMode === picker && internalMode !== "time";
  var mergedShowNow = useShowNow(picker, mergedMode, showNow, showToday, true);
  var _useRangeValue = useRangeValue(filledProps, mergedValue, setInnerValue, getCalendarValue, triggerCalendarChange, disabled, formatList, focused, mergedOpen, isInvalidateDate), _useRangeValue2 = _slicedToArray(_useRangeValue, 2), flushSubmit = _useRangeValue2[0], triggerSubmitChange = _useRangeValue2[1];
  var mergedDisabledDate = useRangeDisabledDate(calendarValue, disabled, activeIndexList, generateConfig2, locale6, disabledDate);
  var _useFieldsInvalidate = useFieldsInvalidate(calendarValue, isInvalidateDate, allowEmpty), _useFieldsInvalidate2 = _slicedToArray(_useFieldsInvalidate, 2), submitInvalidates = _useFieldsInvalidate2[0], onSelectorInvalid = _useFieldsInvalidate2[1];
  var _useRangePickerValue = useRangePickerValue(generateConfig2, locale6, calendarValue, modes, mergedOpen, activeIndex, internalPicker, multiplePanel, defaultPickerValue, pickerValue, mergedShowTime === null || mergedShowTime === void 0 ? void 0 : mergedShowTime.defaultOpenValue, onPickerValueChange, minDate, maxDate), _useRangePickerValue2 = _slicedToArray(_useRangePickerValue, 2), currentPickerValue = _useRangePickerValue2[0], setCurrentPickerValue = _useRangePickerValue2[1];
  var triggerModeChange = useEvent2(function(nextPickerValue, nextMode, triggerEvent2) {
    var clone = fillIndex(modes, activeIndex, nextMode);
    if (clone[0] !== modes[0] || clone[1] !== modes[1]) {
      setModes(clone);
    }
    if (onPanelChange && triggerEvent2 !== false) {
      var clonePickerValue = _toConsumableArray(calendarValue);
      if (nextPickerValue) {
        clonePickerValue[activeIndex] = nextPickerValue;
      }
      onPanelChange(clonePickerValue, clone);
    }
  });
  var fillCalendarValue = function fillCalendarValue2(date4, index3) {
    return (
      // Trigger change only when date changed
      fillIndex(calendarValue, index3, date4)
    );
  };
  var triggerPartConfirm = function triggerPartConfirm2(date4, skipFocus) {
    var nextValue = calendarValue;
    if (date4) {
      nextValue = fillCalendarValue(date4, activeIndex);
    }
    updateSubmitIndex(activeIndex);
    var nextIndex2 = nextActiveIndex(nextValue);
    triggerCalendarChange(nextValue);
    flushSubmit(activeIndex, nextIndex2 === null);
    if (nextIndex2 === null) {
      triggerOpen(false, {
        force: true
      });
    } else if (!skipFocus) {
      selectorRef.current.focus({
        index: nextIndex2
      });
    }
  };
  var onSelectorClick = function onSelectorClick2(event) {
    var _activeElement;
    var rootNode = event.target.getRootNode();
    if (!selectorRef.current.nativeElement.contains((_activeElement = rootNode.activeElement) !== null && _activeElement !== void 0 ? _activeElement : document.activeElement)) {
      var enabledIndex = disabled.findIndex(function(d) {
        return !d;
      });
      if (enabledIndex >= 0) {
        selectorRef.current.focus({
          index: enabledIndex
        });
      }
    }
    triggerOpen(true);
    onClick === null || onClick === void 0 || onClick(event);
  };
  var onSelectorClear = function onSelectorClear2() {
    triggerSubmitChange(null);
    triggerOpen(false, {
      force: true
    });
  };
  var _React$useState = React270.useState(null), _React$useState2 = _slicedToArray(_React$useState, 2), hoverSource = _React$useState2[0], setHoverSource = _React$useState2[1];
  var _React$useState3 = React270.useState(null), _React$useState4 = _slicedToArray(_React$useState3, 2), internalHoverValues = _React$useState4[0], setInternalHoverValues = _React$useState4[1];
  var hoverValues = React270.useMemo(function() {
    return internalHoverValues || calendarValue;
  }, [calendarValue, internalHoverValues]);
  React270.useEffect(function() {
    if (!mergedOpen) {
      setInternalHoverValues(null);
    }
  }, [mergedOpen]);
  var _React$useState5 = React270.useState([0, 0, 0]), _React$useState6 = _slicedToArray(_React$useState5, 2), activeInfo = _React$useState6[0], setActiveInfo = _React$useState6[1];
  var presetList = usePresets(presets, ranges);
  var onPresetHover = function onPresetHover2(nextValues) {
    setInternalHoverValues(nextValues);
    setHoverSource("preset");
  };
  var onPresetSubmit = function onPresetSubmit2(nextValues) {
    var passed = triggerSubmitChange(nextValues);
    if (passed) {
      triggerOpen(false, {
        force: true
      });
    }
  };
  var onNow = function onNow2(now4) {
    triggerPartConfirm(now4);
  };
  var onPanelHover = function onPanelHover2(date4) {
    setInternalHoverValues(date4 ? fillCalendarValue(date4, activeIndex) : null);
    setHoverSource("cell");
  };
  var onPanelFocus = function onPanelFocus2(event) {
    triggerOpen(true);
    onSharedFocus(event);
  };
  var onPanelMouseDown = function onPanelMouseDown2() {
    lastOperation("panel");
  };
  var onPanelSelect = function onPanelSelect2(date4) {
    var clone = fillIndex(calendarValue, activeIndex, date4);
    triggerCalendarChange(clone);
    if (!needConfirm && !complexPicker && internalPicker === internalMode) {
      triggerPartConfirm(date4);
    }
  };
  var onPopupClose = function onPopupClose2() {
    triggerOpen(false);
  };
  var onInternalCellRender = useCellRender(cellRender, dateRender, monthCellRender, getActiveRange(activeIndex));
  var panelValue = calendarValue[activeIndex] || null;
  var isPopupInvalidateDate = useEvent2(function(date4) {
    return isInvalidateDate(date4, {
      activeIndex
    });
  });
  var panelProps = React270.useMemo(function() {
    var domProps = pickAttrs(filledProps, false);
    var restProps = omit(filledProps, [].concat(_toConsumableArray(Object.keys(domProps)), ["onChange", "onCalendarChange", "style", "className", "onPanelChange", "disabledTime"]));
    return restProps;
  }, [filledProps]);
  var panel = /* @__PURE__ */ React270.createElement(Popup3, _extends({}, panelProps, {
    showNow: mergedShowNow,
    showTime: mergedShowTime,
    range: true,
    multiplePanel,
    activeInfo,
    disabledDate: mergedDisabledDate,
    onFocus: onPanelFocus,
    onBlur: onSharedBlur,
    onPanelMouseDown,
    picker,
    mode: mergedMode,
    internalMode,
    onPanelChange: triggerModeChange,
    format: maskFormat,
    value: panelValue,
    isInvalid: isPopupInvalidateDate,
    onChange: null,
    onSelect: onPanelSelect,
    pickerValue: currentPickerValue,
    defaultOpenValue: toArray5(showTime === null || showTime === void 0 ? void 0 : showTime.defaultOpenValue)[activeIndex],
    onPickerValueChange: setCurrentPickerValue,
    hoverValue: hoverValues,
    onHover: onPanelHover,
    needConfirm,
    onSubmit: triggerPartConfirm,
    onOk: triggerOk,
    presets: presetList,
    onPresetHover,
    onPresetSubmit,
    onNow,
    cellRender: onInternalCellRender
  }));
  var onSelectorChange = function onSelectorChange2(date4, index3) {
    var clone = fillCalendarValue(date4, index3);
    triggerCalendarChange(clone);
  };
  var onSelectorInputChange = function onSelectorInputChange2() {
    lastOperation("input");
  };
  var onSelectorFocus = function onSelectorFocus2(event, index3) {
    var activeListLen = activeIndexList.length;
    var lastActiveIndex = activeIndexList[activeListLen - 1];
    if (activeListLen && lastActiveIndex !== index3 && needConfirm && // Not change index if is not filled
    !allowEmpty[lastActiveIndex] && !hasActiveSubmitValue(lastActiveIndex) && calendarValue[lastActiveIndex]) {
      selectorRef.current.focus({
        index: lastActiveIndex
      });
      return;
    }
    lastOperation("input");
    triggerOpen(true, {
      inherit: true
    });
    if (activeIndex !== index3 && mergedOpen && !needConfirm && complexPicker) {
      triggerPartConfirm(null, true);
    }
    setActiveIndex(index3);
    onSharedFocus(event, index3);
  };
  var onSelectorBlur = function onSelectorBlur2(event, index3) {
    triggerOpen(false);
    if (!needConfirm && lastOperation() === "input") {
      var nextIndex2 = nextActiveIndex(calendarValue);
      flushSubmit(activeIndex, nextIndex2 === null);
    }
    onSharedBlur(event, index3);
  };
  var onSelectorKeyDown = function onSelectorKeyDown2(event, preventDefault2) {
    if (event.key === "Tab") {
      triggerPartConfirm(null, true);
    }
    onKeyDown2 === null || onKeyDown2 === void 0 || onKeyDown2(event, preventDefault2);
  };
  var context = React270.useMemo(function() {
    return {
      prefixCls,
      locale: locale6,
      generateConfig: generateConfig2,
      button: components.button,
      input: components.input
    };
  }, [prefixCls, locale6, generateConfig2, components.button, components.input]);
  useLayoutEffect_default(function() {
    if (mergedOpen && activeIndex !== void 0) {
      triggerModeChange(null, picker, false);
    }
  }, [mergedOpen, activeIndex, picker]);
  useLayoutEffect_default(function() {
    var lastOp = lastOperation();
    if (!mergedOpen && lastOp === "input") {
      triggerOpen(false);
      triggerPartConfirm(null, true);
    }
    if (!mergedOpen && complexPicker && !needConfirm && lastOp === "panel") {
      triggerOpen(true);
      triggerPartConfirm();
    }
  }, [mergedOpen]);
  if (true) {
    var isIndexEmpty = function isIndexEmpty2(index3) {
      return (
        // Value is empty
        !(value !== null && value !== void 0 && value[index3]) && // DefaultValue is empty
        !(defaultValue2 !== null && defaultValue2 !== void 0 && defaultValue2[index3])
      );
    };
    if (disabled.some(function(fieldDisabled, index3) {
      return fieldDisabled && isIndexEmpty(index3) && !allowEmpty[index3];
    })) {
      warning_default(false, "`disabled` should not set with empty `value`. You should set `allowEmpty` or `value` instead.");
    }
  }
  return /* @__PURE__ */ React270.createElement(context_default3.Provider, {
    value: context
  }, /* @__PURE__ */ React270.createElement(PickerTrigger_default, _extends({}, pickTriggerProps(filledProps), {
    popupElement: panel,
    popupStyle: styles.popup,
    popupClassName: classNames186.popup,
    visible: mergedOpen,
    onClose: onPopupClose,
    range: true
  }), /* @__PURE__ */ React270.createElement(
    RangeSelector_default,
    _extends({}, filledProps, {
      // Ref
      ref: selectorRef,
      suffixIcon,
      activeIndex: focused || mergedOpen ? activeIndex : null,
      activeHelp: !!internalHoverValues,
      allHelp: !!internalHoverValues && hoverSource === "preset",
      focused,
      onFocus: onSelectorFocus,
      onBlur: onSelectorBlur,
      onKeyDown: onSelectorKeyDown,
      onSubmit: triggerPartConfirm,
      value: hoverValues,
      maskFormat,
      onChange: onSelectorChange,
      onInputChange: onSelectorInputChange,
      format: formatList,
      inputReadOnly,
      disabled,
      open: mergedOpen,
      onOpenChange: triggerOpen,
      onClick: onSelectorClick,
      onClear: onSelectorClear,
      invalid: submitInvalidates,
      onInvalid: onSelectorInvalid,
      onActiveInfo: setActiveInfo
    })
  )));
}
var RefRangePicker = /* @__PURE__ */ React270.forwardRef(RangePicker);
if (true) {
  RefRangePicker.displayName = "RefRangePicker";
}
var RangePicker_default = RefRangePicker;

// ../../node_modules/rc-picker/es/PickerInput/SinglePicker.js
var React273 = __toESM(require_react());

// ../../node_modules/rc-picker/es/PickerInput/Selector/SingleSelector/index.js
var import_classnames90 = __toESM(require_classnames());
var React272 = __toESM(require_react());

// ../../node_modules/rc-picker/es/PickerInput/Selector/SingleSelector/MultipleDates.js
var import_classnames89 = __toESM(require_classnames());
var React271 = __toESM(require_react());
function MultipleDates(props) {
  var prefixCls = props.prefixCls, value = props.value, onRemove = props.onRemove, _props$removeIcon = props.removeIcon, removeIcon = _props$removeIcon === void 0 ? "\xD7" : _props$removeIcon, formatDate2 = props.formatDate, disabled = props.disabled, maxTagCount = props.maxTagCount, placeholder = props.placeholder;
  var selectorCls = "".concat(prefixCls, "-selector");
  var selectionCls = "".concat(prefixCls, "-selection");
  var overflowCls = "".concat(selectionCls, "-overflow");
  function renderSelector(content, onClose) {
    return /* @__PURE__ */ React271.createElement("span", {
      className: (0, import_classnames89.default)("".concat(selectionCls, "-item")),
      title: typeof content === "string" ? content : null
    }, /* @__PURE__ */ React271.createElement("span", {
      className: "".concat(selectionCls, "-item-content")
    }, content), !disabled && onClose && /* @__PURE__ */ React271.createElement("span", {
      onMouseDown: function onMouseDown(e3) {
        e3.preventDefault();
      },
      onClick: onClose,
      className: "".concat(selectionCls, "-item-remove")
    }, removeIcon));
  }
  function renderItem3(date4) {
    var displayLabel = formatDate2(date4);
    var onClose = function onClose2(event) {
      if (event) event.stopPropagation();
      onRemove(date4);
    };
    return renderSelector(displayLabel, onClose);
  }
  function renderRest(omittedValues) {
    var content = "+ ".concat(omittedValues.length, " ...");
    return renderSelector(content);
  }
  return /* @__PURE__ */ React271.createElement("div", {
    className: selectorCls
  }, /* @__PURE__ */ React271.createElement(es_default8, {
    prefixCls: overflowCls,
    data: value,
    renderItem: renderItem3,
    renderRest,
    itemKey: function itemKey3(date4) {
      return formatDate2(date4);
    },
    maxCount: maxTagCount
  }), !value.length && /* @__PURE__ */ React271.createElement("span", {
    className: "".concat(prefixCls, "-selection-placeholder")
  }, placeholder));
}

// ../../node_modules/rc-picker/es/PickerInput/Selector/SingleSelector/index.js
var _excluded43 = ["id", "open", "prefix", "clearIcon", "suffixIcon", "activeHelp", "allHelp", "focused", "onFocus", "onBlur", "onKeyDown", "locale", "generateConfig", "placeholder", "className", "style", "onClick", "onClear", "internalPicker", "value", "onChange", "onSubmit", "onInputChange", "multiple", "maxTagCount", "format", "maskFormat", "preserveInvalidOnBlur", "onInvalid", "disabled", "invalid", "inputReadOnly", "direction", "onOpenChange", "onMouseDown", "required", "aria-required", "autoFocus", "tabIndex", "removeIcon"];
function SingleSelector3(props, ref3) {
  var id = props.id, open2 = props.open, prefix3 = props.prefix, clearIcon = props.clearIcon, suffixIcon = props.suffixIcon, activeHelp = props.activeHelp, allHelp = props.allHelp, focused = props.focused, onFocus = props.onFocus, onBlur = props.onBlur, onKeyDown2 = props.onKeyDown, locale6 = props.locale, generateConfig2 = props.generateConfig, placeholder = props.placeholder, className2 = props.className, style2 = props.style, onClick = props.onClick, onClear = props.onClear, internalPicker = props.internalPicker, value = props.value, onChange = props.onChange, onSubmit = props.onSubmit, onInputChange = props.onInputChange, multiple = props.multiple, maxTagCount = props.maxTagCount, format3 = props.format, maskFormat = props.maskFormat, preserveInvalidOnBlur = props.preserveInvalidOnBlur, onInvalid = props.onInvalid, disabled = props.disabled, invalid = props.invalid, inputReadOnly = props.inputReadOnly, direction = props.direction, onOpenChange = props.onOpenChange, _onMouseDown = props.onMouseDown, required5 = props.required, ariaRequired = props["aria-required"], autoFocus = props.autoFocus, tabIndex = props.tabIndex, removeIcon = props.removeIcon, restProps = _objectWithoutProperties(props, _excluded43);
  var rtl = direction === "rtl";
  var _React$useContext = React272.useContext(context_default3), prefixCls = _React$useContext.prefixCls;
  var rootRef = React272.useRef();
  var inputRef = React272.useRef();
  React272.useImperativeHandle(ref3, function() {
    return {
      nativeElement: rootRef.current,
      focus: function focus(options) {
        var _inputRef$current;
        (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || _inputRef$current.focus(options);
      },
      blur: function blur() {
        var _inputRef$current2;
        (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 || _inputRef$current2.blur();
      }
    };
  });
  var rootProps = useRootProps(restProps);
  var onSingleChange = function onSingleChange2(date4) {
    onChange([date4]);
  };
  var onMultipleRemove = function onMultipleRemove2(date4) {
    var nextValues = value.filter(function(oriDate) {
      return oriDate && !isSame(generateConfig2, locale6, oriDate, date4, internalPicker);
    });
    onChange(nextValues);
    if (!open2) {
      onSubmit();
    }
  };
  var _useInputProps = useInputProps(_objectSpread2(_objectSpread2({}, props), {}, {
    onChange: onSingleChange
  }), function(_ref) {
    var valueTexts = _ref.valueTexts;
    return {
      value: valueTexts[0] || "",
      active: focused
    };
  }), _useInputProps2 = _slicedToArray(_useInputProps, 2), getInputProps = _useInputProps2[0], getText = _useInputProps2[1];
  var showClear = !!(clearIcon && value.length && !disabled);
  var selectorNode = multiple ? /* @__PURE__ */ React272.createElement(React272.Fragment, null, /* @__PURE__ */ React272.createElement(MultipleDates, {
    prefixCls,
    value,
    onRemove: onMultipleRemove,
    formatDate: getText,
    maxTagCount,
    disabled,
    removeIcon,
    placeholder
  }), /* @__PURE__ */ React272.createElement("input", {
    className: "".concat(prefixCls, "-multiple-input"),
    value: value.map(getText).join(","),
    ref: inputRef,
    readOnly: true,
    autoFocus,
    tabIndex
  }), /* @__PURE__ */ React272.createElement(Icon3, {
    type: "suffix",
    icon: suffixIcon
  }), showClear && /* @__PURE__ */ React272.createElement(ClearIcon, {
    icon: clearIcon,
    onClear
  })) : /* @__PURE__ */ React272.createElement(Input_default3, _extends({
    ref: inputRef
  }, getInputProps(), {
    autoFocus,
    tabIndex,
    suffixIcon,
    clearIcon: showClear && /* @__PURE__ */ React272.createElement(ClearIcon, {
      icon: clearIcon,
      onClear
    }),
    showActiveCls: false
  }));
  return /* @__PURE__ */ React272.createElement("div", _extends({}, rootProps, {
    className: (0, import_classnames90.default)(prefixCls, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "".concat(prefixCls, "-multiple"), multiple), "".concat(prefixCls, "-focused"), focused), "".concat(prefixCls, "-disabled"), disabled), "".concat(prefixCls, "-invalid"), invalid), "".concat(prefixCls, "-rtl"), rtl), className2),
    style: style2,
    ref: rootRef,
    onClick,
    onMouseDown: function onMouseDown(e3) {
      var _inputRef$current3;
      var target = e3.target;
      if (target !== ((_inputRef$current3 = inputRef.current) === null || _inputRef$current3 === void 0 ? void 0 : _inputRef$current3.inputElement)) {
        e3.preventDefault();
      }
      _onMouseDown === null || _onMouseDown === void 0 || _onMouseDown(e3);
    }
  }), prefix3 && /* @__PURE__ */ React272.createElement("div", {
    className: "".concat(prefixCls, "-prefix")
  }, prefix3), selectorNode);
}
var RefSingleSelector = /* @__PURE__ */ React272.forwardRef(SingleSelector3);
if (true) {
  RefSingleSelector.displayName = "SingleSelector";
}
var SingleSelector_default2 = RefSingleSelector;

// ../../node_modules/rc-picker/es/PickerInput/SinglePicker.js
function Picker3(props, ref3) {
  var _useFilledProps = useFilledProps(props), _useFilledProps2 = _slicedToArray(_useFilledProps, 6), filledProps = _useFilledProps2[0], internalPicker = _useFilledProps2[1], complexPicker = _useFilledProps2[2], formatList = _useFilledProps2[3], maskFormat = _useFilledProps2[4], isInvalidateDate = _useFilledProps2[5];
  var _ref = filledProps, prefixCls = _ref.prefixCls, styles = _ref.styles, classNames186 = _ref.classNames, order = _ref.order, defaultValue2 = _ref.defaultValue, value = _ref.value, needConfirm = _ref.needConfirm, onChange = _ref.onChange, onKeyDown2 = _ref.onKeyDown, disabled = _ref.disabled, disabledDate = _ref.disabledDate, minDate = _ref.minDate, maxDate = _ref.maxDate, defaultOpen = _ref.defaultOpen, open2 = _ref.open, onOpenChange = _ref.onOpenChange, locale6 = _ref.locale, generateConfig2 = _ref.generateConfig, picker = _ref.picker, showNow = _ref.showNow, showToday = _ref.showToday, showTime = _ref.showTime, mode = _ref.mode, onPanelChange = _ref.onPanelChange, onCalendarChange = _ref.onCalendarChange, onOk = _ref.onOk, multiple = _ref.multiple, defaultPickerValue = _ref.defaultPickerValue, pickerValue = _ref.pickerValue, onPickerValueChange = _ref.onPickerValueChange, inputReadOnly = _ref.inputReadOnly, suffixIcon = _ref.suffixIcon, removeIcon = _ref.removeIcon, onFocus = _ref.onFocus, onBlur = _ref.onBlur, presets = _ref.presets, components = _ref.components, cellRender = _ref.cellRender, dateRender = _ref.dateRender, monthCellRender = _ref.monthCellRender, onClick = _ref.onClick;
  var selectorRef = usePickerRef(ref3);
  function pickerParam(values) {
    if (values === null) {
      return null;
    }
    return multiple ? values : values[0];
  }
  var toggleDates = useToggleDates(generateConfig2, locale6, internalPicker);
  var _useOpen = useOpen(open2, defaultOpen, [disabled], onOpenChange), _useOpen2 = _slicedToArray(_useOpen, 2), mergedOpen = _useOpen2[0], triggerOpen = _useOpen2[1];
  var onInternalCalendarChange = function onInternalCalendarChange2(dates, dateStrings, info) {
    if (onCalendarChange) {
      var filteredInfo = _objectSpread2({}, info);
      delete filteredInfo.range;
      onCalendarChange(pickerParam(dates), pickerParam(dateStrings), filteredInfo);
    }
  };
  var onInternalOk = function onInternalOk2(dates) {
    onOk === null || onOk === void 0 || onOk(pickerParam(dates));
  };
  var _useInnerValue = useInnerValue(generateConfig2, locale6, formatList, false, order, defaultValue2, value, onInternalCalendarChange, onInternalOk), _useInnerValue2 = _slicedToArray(_useInnerValue, 5), mergedValue = _useInnerValue2[0], setInnerValue = _useInnerValue2[1], getCalendarValue = _useInnerValue2[2], triggerCalendarChange = _useInnerValue2[3], triggerOk = _useInnerValue2[4];
  var calendarValue = getCalendarValue();
  var _useRangeActive = useRangeActive([disabled]), _useRangeActive2 = _slicedToArray(_useRangeActive, 4), focused = _useRangeActive2[0], triggerFocus2 = _useRangeActive2[1], lastOperation = _useRangeActive2[2], activeIndex = _useRangeActive2[3];
  var onSharedFocus = function onSharedFocus2(event) {
    triggerFocus2(true);
    onFocus === null || onFocus === void 0 || onFocus(event, {});
  };
  var onSharedBlur = function onSharedBlur2(event) {
    triggerFocus2(false);
    onBlur === null || onBlur === void 0 || onBlur(event, {});
  };
  var _useMergedState = useMergedState(picker, {
    value: mode
  }), _useMergedState2 = _slicedToArray(_useMergedState, 2), mergedMode = _useMergedState2[0], setMode = _useMergedState2[1];
  var internalMode = mergedMode === "date" && showTime ? "datetime" : mergedMode;
  var mergedShowNow = useShowNow(picker, mergedMode, showNow, showToday);
  var onInternalChange = onChange && function(dates, dateStrings) {
    onChange(pickerParam(dates), pickerParam(dateStrings));
  };
  var _useRangeValue = useRangeValue(
    _objectSpread2(_objectSpread2({}, filledProps), {}, {
      onChange: onInternalChange
    }),
    mergedValue,
    setInnerValue,
    getCalendarValue,
    triggerCalendarChange,
    [],
    //disabled,
    formatList,
    focused,
    mergedOpen,
    isInvalidateDate
  ), _useRangeValue2 = _slicedToArray(_useRangeValue, 2), triggerSubmitChange = _useRangeValue2[1];
  var _useFieldsInvalidate = useFieldsInvalidate(calendarValue, isInvalidateDate), _useFieldsInvalidate2 = _slicedToArray(_useFieldsInvalidate, 2), submitInvalidates = _useFieldsInvalidate2[0], onSelectorInvalid = _useFieldsInvalidate2[1];
  var submitInvalidate = React273.useMemo(function() {
    return submitInvalidates.some(function(invalidated) {
      return invalidated;
    });
  }, [submitInvalidates]);
  var onInternalPickerValueChange = function onInternalPickerValueChange2(dates, info) {
    if (onPickerValueChange) {
      var cleanInfo = _objectSpread2(_objectSpread2({}, info), {}, {
        mode: info.mode[0]
      });
      delete cleanInfo.range;
      onPickerValueChange(dates[0], cleanInfo);
    }
  };
  var _useRangePickerValue = useRangePickerValue(
    generateConfig2,
    locale6,
    calendarValue,
    [mergedMode],
    mergedOpen,
    activeIndex,
    internalPicker,
    false,
    // multiplePanel,
    defaultPickerValue,
    pickerValue,
    toArray5(showTime === null || showTime === void 0 ? void 0 : showTime.defaultOpenValue),
    onInternalPickerValueChange,
    minDate,
    maxDate
  ), _useRangePickerValue2 = _slicedToArray(_useRangePickerValue, 2), currentPickerValue = _useRangePickerValue2[0], setCurrentPickerValue = _useRangePickerValue2[1];
  var triggerModeChange = useEvent2(function(nextPickerValue, nextMode, triggerEvent2) {
    setMode(nextMode);
    if (onPanelChange && triggerEvent2 !== false) {
      var lastPickerValue = nextPickerValue || calendarValue[calendarValue.length - 1];
      onPanelChange(lastPickerValue, nextMode);
    }
  });
  var triggerConfirm = function triggerConfirm2() {
    triggerSubmitChange(getCalendarValue());
    triggerOpen(false, {
      force: true
    });
  };
  var onSelectorClick = function onSelectorClick2(event) {
    if (!disabled && !selectorRef.current.nativeElement.contains(document.activeElement)) {
      selectorRef.current.focus();
    }
    triggerOpen(true);
    onClick === null || onClick === void 0 || onClick(event);
  };
  var onSelectorClear = function onSelectorClear2() {
    triggerSubmitChange(null);
    triggerOpen(false, {
      force: true
    });
  };
  var _React$useState = React273.useState(null), _React$useState2 = _slicedToArray(_React$useState, 2), hoverSource = _React$useState2[0], setHoverSource = _React$useState2[1];
  var _React$useState3 = React273.useState(null), _React$useState4 = _slicedToArray(_React$useState3, 2), internalHoverValue = _React$useState4[0], setInternalHoverValue = _React$useState4[1];
  var hoverValues = React273.useMemo(function() {
    var values = [internalHoverValue].concat(_toConsumableArray(calendarValue)).filter(function(date4) {
      return date4;
    });
    return multiple ? values : values.slice(0, 1);
  }, [calendarValue, internalHoverValue, multiple]);
  var selectorValues = React273.useMemo(function() {
    if (!multiple && internalHoverValue) {
      return [internalHoverValue];
    }
    return calendarValue.filter(function(date4) {
      return date4;
    });
  }, [calendarValue, internalHoverValue, multiple]);
  React273.useEffect(function() {
    if (!mergedOpen) {
      setInternalHoverValue(null);
    }
  }, [mergedOpen]);
  var presetList = usePresets(presets);
  var onPresetHover = function onPresetHover2(nextValue) {
    setInternalHoverValue(nextValue);
    setHoverSource("preset");
  };
  var onPresetSubmit = function onPresetSubmit2(nextValue) {
    var nextCalendarValues = multiple ? toggleDates(getCalendarValue(), nextValue) : [nextValue];
    var passed = triggerSubmitChange(nextCalendarValues);
    if (passed && !multiple) {
      triggerOpen(false, {
        force: true
      });
    }
  };
  var onNow = function onNow2(now4) {
    onPresetSubmit(now4);
  };
  var onPanelHover = function onPanelHover2(date4) {
    setInternalHoverValue(date4);
    setHoverSource("cell");
  };
  var onPanelFocus = function onPanelFocus2(event) {
    triggerOpen(true);
    onSharedFocus(event);
  };
  var onPanelSelect = function onPanelSelect2(date4) {
    lastOperation("panel");
    if (multiple && internalMode !== picker) {
      return;
    }
    var nextValues = multiple ? toggleDates(getCalendarValue(), date4) : [date4];
    triggerCalendarChange(nextValues);
    if (!needConfirm && !complexPicker && internalPicker === internalMode) {
      triggerConfirm();
    }
  };
  var onPopupClose = function onPopupClose2() {
    triggerOpen(false);
  };
  var onInternalCellRender = useCellRender(cellRender, dateRender, monthCellRender);
  var panelProps = React273.useMemo(function() {
    var domProps = pickAttrs(filledProps, false);
    var restProps = omit(filledProps, [].concat(_toConsumableArray(Object.keys(domProps)), ["onChange", "onCalendarChange", "style", "className", "onPanelChange"]));
    return _objectSpread2(_objectSpread2({}, restProps), {}, {
      multiple: filledProps.multiple
    });
  }, [filledProps]);
  var panel = /* @__PURE__ */ React273.createElement(Popup3, _extends({}, panelProps, {
    showNow: mergedShowNow,
    showTime,
    disabledDate,
    onFocus: onPanelFocus,
    onBlur: onSharedBlur,
    picker,
    mode: mergedMode,
    internalMode,
    onPanelChange: triggerModeChange,
    format: maskFormat,
    value: calendarValue,
    isInvalid: isInvalidateDate,
    onChange: null,
    onSelect: onPanelSelect,
    pickerValue: currentPickerValue,
    defaultOpenValue: showTime === null || showTime === void 0 ? void 0 : showTime.defaultOpenValue,
    onPickerValueChange: setCurrentPickerValue,
    hoverValue: hoverValues,
    onHover: onPanelHover,
    needConfirm,
    onSubmit: triggerConfirm,
    onOk: triggerOk,
    presets: presetList,
    onPresetHover,
    onPresetSubmit,
    onNow,
    cellRender: onInternalCellRender
  }));
  var onSelectorChange = function onSelectorChange2(date4) {
    triggerCalendarChange(date4);
  };
  var onSelectorInputChange = function onSelectorInputChange2() {
    lastOperation("input");
  };
  var onSelectorFocus = function onSelectorFocus2(event) {
    lastOperation("input");
    triggerOpen(true, {
      inherit: true
    });
    onSharedFocus(event);
  };
  var onSelectorBlur = function onSelectorBlur2(event) {
    triggerOpen(false);
    onSharedBlur(event);
  };
  var onSelectorKeyDown = function onSelectorKeyDown2(event, preventDefault2) {
    if (event.key === "Tab") {
      triggerConfirm();
    }
    onKeyDown2 === null || onKeyDown2 === void 0 || onKeyDown2(event, preventDefault2);
  };
  var context = React273.useMemo(function() {
    return {
      prefixCls,
      locale: locale6,
      generateConfig: generateConfig2,
      button: components.button,
      input: components.input
    };
  }, [prefixCls, locale6, generateConfig2, components.button, components.input]);
  useLayoutEffect_default(function() {
    if (mergedOpen && activeIndex !== void 0) {
      triggerModeChange(null, picker, false);
    }
  }, [mergedOpen, activeIndex, picker]);
  useLayoutEffect_default(function() {
    var lastOp = lastOperation();
    if (!mergedOpen && lastOp === "input") {
      triggerOpen(false);
      triggerConfirm();
    }
    if (!mergedOpen && complexPicker && !needConfirm && lastOp === "panel") {
      triggerConfirm();
    }
  }, [mergedOpen]);
  return /* @__PURE__ */ React273.createElement(context_default3.Provider, {
    value: context
  }, /* @__PURE__ */ React273.createElement(PickerTrigger_default, _extends({}, pickTriggerProps(filledProps), {
    popupElement: panel,
    popupStyle: styles.popup,
    popupClassName: classNames186.popup,
    visible: mergedOpen,
    onClose: onPopupClose
  }), /* @__PURE__ */ React273.createElement(
    SingleSelector_default2,
    _extends({}, filledProps, {
      // Ref
      ref: selectorRef,
      suffixIcon,
      removeIcon,
      activeHelp: !!internalHoverValue,
      allHelp: !!internalHoverValue && hoverSource === "preset",
      focused,
      onFocus: onSelectorFocus,
      onBlur: onSelectorBlur,
      onKeyDown: onSelectorKeyDown,
      onSubmit: triggerConfirm,
      value: selectorValues,
      maskFormat,
      onChange: onSelectorChange,
      onInputChange: onSelectorInputChange,
      internalPicker,
      format: formatList,
      inputReadOnly,
      disabled,
      open: mergedOpen,
      onOpenChange: triggerOpen,
      onClick: onSelectorClick,
      onClear: onSelectorClear,
      invalid: submitInvalidate,
      onInvalid: function onInvalid(invalid) {
        onSelectorInvalid(invalid, 0);
      }
    })
  )));
}
var RefPicker = /* @__PURE__ */ React273.forwardRef(Picker3);
if (true) {
  RefPicker.displayName = "RefPicker";
}
var SinglePicker_default = RefPicker;

// ../../node_modules/rc-picker/es/index.js
var es_default15 = SinglePicker_default;

// ../../node_modules/antd/es/radio/group.js
var React279 = __toESM(require_react());
var import_classnames93 = __toESM(require_classnames());

// ../../node_modules/antd/es/radio/context.js
var React274 = __toESM(require_react());
var RadioGroupContext = /* @__PURE__ */ React274.createContext(null);
var RadioGroupContextProvider = RadioGroupContext.Provider;
var context_default4 = RadioGroupContext;
var RadioOptionTypeContext = /* @__PURE__ */ React274.createContext(null);
var RadioOptionTypeContextProvider = RadioOptionTypeContext.Provider;

// ../../node_modules/antd/es/radio/radio.js
var React277 = __toESM(require_react());
var import_classnames92 = __toESM(require_classnames());

// ../../node_modules/rc-checkbox/es/index.js
var import_classnames91 = __toESM(require_classnames());
var React275 = __toESM(require_react());
var import_react86 = __toESM(require_react());
var _excluded44 = ["prefixCls", "className", "style", "checked", "disabled", "defaultChecked", "type", "title", "onChange"];
var Checkbox = /* @__PURE__ */ (0, import_react86.forwardRef)(function(props, ref3) {
  var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-checkbox" : _props$prefixCls, className2 = props.className, style2 = props.style, checked = props.checked, disabled = props.disabled, _props$defaultChecked = props.defaultChecked, defaultChecked = _props$defaultChecked === void 0 ? false : _props$defaultChecked, _props$type = props.type, type5 = _props$type === void 0 ? "checkbox" : _props$type, title = props.title, onChange = props.onChange, inputProps = _objectWithoutProperties(props, _excluded44);
  var inputRef = (0, import_react86.useRef)(null);
  var holderRef = (0, import_react86.useRef)(null);
  var _useMergedState = useMergedState(defaultChecked, {
    value: checked
  }), _useMergedState2 = _slicedToArray(_useMergedState, 2), rawValue = _useMergedState2[0], setRawValue = _useMergedState2[1];
  (0, import_react86.useImperativeHandle)(ref3, function() {
    return {
      focus: function focus(options) {
        var _inputRef$current;
        (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || _inputRef$current.focus(options);
      },
      blur: function blur() {
        var _inputRef$current2;
        (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 || _inputRef$current2.blur();
      },
      input: inputRef.current,
      nativeElement: holderRef.current
    };
  });
  var classString = (0, import_classnames91.default)(prefixCls, className2, _defineProperty(_defineProperty({}, "".concat(prefixCls, "-checked"), rawValue), "".concat(prefixCls, "-disabled"), disabled));
  var handleChange = function handleChange2(e3) {
    if (disabled) {
      return;
    }
    if (!("checked" in props)) {
      setRawValue(e3.target.checked);
    }
    onChange === null || onChange === void 0 || onChange({
      target: _objectSpread2(_objectSpread2({}, props), {}, {
        type: type5,
        checked: e3.target.checked
      }),
      stopPropagation: function stopPropagation2() {
        e3.stopPropagation();
      },
      preventDefault: function preventDefault2() {
        e3.preventDefault();
      },
      nativeEvent: e3.nativeEvent
    });
  };
  return /* @__PURE__ */ React275.createElement("span", {
    className: classString,
    title,
    style: style2,
    ref: holderRef
  }, /* @__PURE__ */ React275.createElement("input", _extends({}, inputProps, {
    className: "".concat(prefixCls, "-input"),
    ref: inputRef,
    onChange: handleChange,
    disabled,
    checked: !!rawValue,
    type: type5
  })), /* @__PURE__ */ React275.createElement("span", {
    className: "".concat(prefixCls, "-inner")
  }));
});
var es_default16 = Checkbox;

// ../../node_modules/antd/es/checkbox/useBubbleLock.js
var import_react87 = __toESM(require_react());
function useBubbleLock(onOriginInputClick) {
  const labelClickLockRef = import_react87.default.useRef(null);
  const clearLock = () => {
    raf_default.cancel(labelClickLockRef.current);
    labelClickLockRef.current = null;
  };
  const onLabelClick = () => {
    clearLock();
    labelClickLockRef.current = raf_default(() => {
      labelClickLockRef.current = null;
    });
  };
  const onInputClick = (e3) => {
    if (labelClickLockRef.current) {
      e3.stopPropagation();
      clearLock();
    }
    onOriginInputClick === null || onOriginInputClick === void 0 ? void 0 : onOriginInputClick(e3);
  };
  return [onLabelClick, onInputClick];
}

// ../../node_modules/antd/es/radio/style/index.js
var getGroupRadioStyle = (token2) => {
  const {
    componentCls,
    antCls
  } = token2;
  const groupPrefixCls = `${componentCls}-group`;
  return {
    [groupPrefixCls]: Object.assign(Object.assign({}, resetComponent(token2)), {
      display: "inline-block",
      fontSize: 0,
      // RTL
      [`&${groupPrefixCls}-rtl`]: {
        direction: "rtl"
      },
      [`&${groupPrefixCls}-block`]: {
        display: "flex"
      },
      [`${antCls}-badge ${antCls}-badge-count`]: {
        zIndex: 1
      },
      [`> ${antCls}-badge:not(:first-child) > ${antCls}-button-wrapper`]: {
        borderInlineStart: "none"
      }
    })
  };
};
var getRadioBasicStyle = (token2) => {
  const {
    componentCls,
    wrapperMarginInlineEnd,
    colorPrimary,
    radioSize,
    motionDurationSlow,
    motionDurationMid,
    motionEaseInOutCirc,
    colorBgContainer,
    colorBorder,
    lineWidth,
    colorBgContainerDisabled,
    colorTextDisabled,
    paddingXS,
    dotColorDisabled,
    lineType,
    radioColor,
    radioBgColor,
    calc
  } = token2;
  const radioInnerPrefixCls = `${componentCls}-inner`;
  const dotPadding = 4;
  const radioDotDisabledSize = calc(radioSize).sub(calc(dotPadding).mul(2));
  const radioSizeCalc = calc(1).mul(radioSize).equal({
    unit: true
  });
  return {
    [`${componentCls}-wrapper`]: Object.assign(Object.assign({}, resetComponent(token2)), {
      display: "inline-flex",
      alignItems: "baseline",
      marginInlineStart: 0,
      marginInlineEnd: wrapperMarginInlineEnd,
      cursor: "pointer",
      "&:last-child": {
        marginInlineEnd: 0
      },
      // RTL
      [`&${componentCls}-wrapper-rtl`]: {
        direction: "rtl"
      },
      "&-disabled": {
        cursor: "not-allowed",
        color: token2.colorTextDisabled
      },
      "&::after": {
        display: "inline-block",
        width: 0,
        overflow: "hidden",
        content: '"\\a0"'
      },
      "&-block": {
        flex: 1,
        justifyContent: "center"
      },
      // hashId 在 wrapper 上，只能铺平
      [`${componentCls}-checked::after`]: {
        position: "absolute",
        insetBlockStart: 0,
        insetInlineStart: 0,
        width: "100%",
        height: "100%",
        border: `${unit(lineWidth)} ${lineType} ${colorPrimary}`,
        borderRadius: "50%",
        visibility: "hidden",
        opacity: 0,
        content: '""'
      },
      [componentCls]: Object.assign(Object.assign({}, resetComponent(token2)), {
        position: "relative",
        display: "inline-block",
        outline: "none",
        cursor: "pointer",
        alignSelf: "center",
        borderRadius: "50%"
      }),
      [`${componentCls}-wrapper:hover &,
        &:hover ${radioInnerPrefixCls}`]: {
        borderColor: colorPrimary
      },
      [`${componentCls}-input:focus-visible + ${radioInnerPrefixCls}`]: genFocusOutline(token2),
      [`${componentCls}:hover::after, ${componentCls}-wrapper:hover &::after`]: {
        visibility: "visible"
      },
      [`${componentCls}-inner`]: {
        "&::after": {
          boxSizing: "border-box",
          position: "absolute",
          insetBlockStart: "50%",
          insetInlineStart: "50%",
          display: "block",
          width: radioSizeCalc,
          height: radioSizeCalc,
          marginBlockStart: calc(1).mul(radioSize).div(-2).equal({
            unit: true
          }),
          marginInlineStart: calc(1).mul(radioSize).div(-2).equal({
            unit: true
          }),
          backgroundColor: radioColor,
          borderBlockStart: 0,
          borderInlineStart: 0,
          borderRadius: radioSizeCalc,
          transform: "scale(0)",
          opacity: 0,
          transition: `all ${motionDurationSlow} ${motionEaseInOutCirc}`,
          content: '""'
        },
        boxSizing: "border-box",
        position: "relative",
        insetBlockStart: 0,
        insetInlineStart: 0,
        display: "block",
        width: radioSizeCalc,
        height: radioSizeCalc,
        backgroundColor: colorBgContainer,
        borderColor: colorBorder,
        borderStyle: "solid",
        borderWidth: lineWidth,
        borderRadius: "50%",
        transition: `all ${motionDurationMid}`
      },
      [`${componentCls}-input`]: {
        position: "absolute",
        inset: 0,
        zIndex: 1,
        cursor: "pointer",
        opacity: 0
      },
      // 选中状态
      [`${componentCls}-checked`]: {
        [radioInnerPrefixCls]: {
          borderColor: colorPrimary,
          backgroundColor: radioBgColor,
          "&::after": {
            transform: `scale(${token2.calc(token2.dotSize).div(radioSize).equal()})`,
            opacity: 1,
            transition: `all ${motionDurationSlow} ${motionEaseInOutCirc}`
          }
        }
      },
      [`${componentCls}-disabled`]: {
        cursor: "not-allowed",
        [radioInnerPrefixCls]: {
          backgroundColor: colorBgContainerDisabled,
          borderColor: colorBorder,
          cursor: "not-allowed",
          "&::after": {
            backgroundColor: dotColorDisabled
          }
        },
        [`${componentCls}-input`]: {
          cursor: "not-allowed"
        },
        [`${componentCls}-disabled + span`]: {
          color: colorTextDisabled,
          cursor: "not-allowed"
        },
        [`&${componentCls}-checked`]: {
          [radioInnerPrefixCls]: {
            "&::after": {
              transform: `scale(${calc(radioDotDisabledSize).div(radioSize).equal()})`
            }
          }
        }
      },
      [`span${componentCls} + *`]: {
        paddingInlineStart: paddingXS,
        paddingInlineEnd: paddingXS
      }
    })
  };
};
var getRadioButtonStyle = (token2) => {
  const {
    buttonColor,
    controlHeight,
    componentCls,
    lineWidth,
    lineType,
    colorBorder,
    motionDurationMid,
    buttonPaddingInline,
    fontSize,
    buttonBg,
    fontSizeLG,
    controlHeightLG,
    controlHeightSM,
    paddingXS,
    borderRadius,
    borderRadiusSM,
    borderRadiusLG,
    buttonCheckedBg,
    buttonSolidCheckedColor,
    colorTextDisabled,
    colorBgContainerDisabled,
    buttonCheckedBgDisabled,
    buttonCheckedColorDisabled,
    colorPrimary,
    colorPrimaryHover,
    colorPrimaryActive,
    buttonSolidCheckedBg,
    buttonSolidCheckedHoverBg,
    buttonSolidCheckedActiveBg,
    calc
  } = token2;
  return {
    [`${componentCls}-button-wrapper`]: {
      position: "relative",
      display: "inline-block",
      height: controlHeight,
      margin: 0,
      paddingInline: buttonPaddingInline,
      paddingBlock: 0,
      color: buttonColor,
      fontSize,
      lineHeight: unit(calc(controlHeight).sub(calc(lineWidth).mul(2)).equal()),
      background: buttonBg,
      border: `${unit(lineWidth)} ${lineType} ${colorBorder}`,
      // strange align fix for chrome but works
      // https://gw.alipayobjects.com/zos/rmsportal/VFTfKXJuogBAXcvfAUWJ.gif
      borderBlockStartWidth: calc(lineWidth).add(0.02).equal(),
      borderInlineEndWidth: lineWidth,
      cursor: "pointer",
      transition: [`color ${motionDurationMid}`, `background ${motionDurationMid}`, `box-shadow ${motionDurationMid}`].join(","),
      a: {
        color: buttonColor
      },
      [`> ${componentCls}-button`]: {
        position: "absolute",
        insetBlockStart: 0,
        insetInlineStart: 0,
        zIndex: -1,
        width: "100%",
        height: "100%"
      },
      "&:not(:last-child)": {
        marginInlineEnd: calc(lineWidth).mul(-1).equal()
      },
      "&:first-child": {
        borderInlineStart: `${unit(lineWidth)} ${lineType} ${colorBorder}`,
        borderStartStartRadius: borderRadius,
        borderEndStartRadius: borderRadius
      },
      "&:last-child": {
        borderStartEndRadius: borderRadius,
        borderEndEndRadius: borderRadius
      },
      "&:first-child:last-child": {
        borderRadius
      },
      [`${componentCls}-group-large &`]: {
        height: controlHeightLG,
        fontSize: fontSizeLG,
        lineHeight: unit(calc(controlHeightLG).sub(calc(lineWidth).mul(2)).equal()),
        "&:first-child": {
          borderStartStartRadius: borderRadiusLG,
          borderEndStartRadius: borderRadiusLG
        },
        "&:last-child": {
          borderStartEndRadius: borderRadiusLG,
          borderEndEndRadius: borderRadiusLG
        }
      },
      [`${componentCls}-group-small &`]: {
        height: controlHeightSM,
        paddingInline: calc(paddingXS).sub(lineWidth).equal(),
        paddingBlock: 0,
        lineHeight: unit(calc(controlHeightSM).sub(calc(lineWidth).mul(2)).equal()),
        "&:first-child": {
          borderStartStartRadius: borderRadiusSM,
          borderEndStartRadius: borderRadiusSM
        },
        "&:last-child": {
          borderStartEndRadius: borderRadiusSM,
          borderEndEndRadius: borderRadiusSM
        }
      },
      "&:hover": {
        position: "relative",
        color: colorPrimary
      },
      "&:has(:focus-visible)": genFocusOutline(token2),
      [`${componentCls}-inner, input[type='checkbox'], input[type='radio']`]: {
        width: 0,
        height: 0,
        opacity: 0,
        pointerEvents: "none"
      },
      [`&-checked:not(${componentCls}-button-wrapper-disabled)`]: {
        zIndex: 1,
        color: colorPrimary,
        background: buttonCheckedBg,
        borderColor: colorPrimary,
        "&::before": {
          backgroundColor: colorPrimary
        },
        "&:first-child": {
          borderColor: colorPrimary
        },
        "&:hover": {
          color: colorPrimaryHover,
          borderColor: colorPrimaryHover,
          "&::before": {
            backgroundColor: colorPrimaryHover
          }
        },
        "&:active": {
          color: colorPrimaryActive,
          borderColor: colorPrimaryActive,
          "&::before": {
            backgroundColor: colorPrimaryActive
          }
        }
      },
      [`${componentCls}-group-solid &-checked:not(${componentCls}-button-wrapper-disabled)`]: {
        color: buttonSolidCheckedColor,
        background: buttonSolidCheckedBg,
        borderColor: buttonSolidCheckedBg,
        "&:hover": {
          color: buttonSolidCheckedColor,
          background: buttonSolidCheckedHoverBg,
          borderColor: buttonSolidCheckedHoverBg
        },
        "&:active": {
          color: buttonSolidCheckedColor,
          background: buttonSolidCheckedActiveBg,
          borderColor: buttonSolidCheckedActiveBg
        }
      },
      "&-disabled": {
        color: colorTextDisabled,
        backgroundColor: colorBgContainerDisabled,
        borderColor: colorBorder,
        cursor: "not-allowed",
        "&:first-child, &:hover": {
          color: colorTextDisabled,
          backgroundColor: colorBgContainerDisabled,
          borderColor: colorBorder
        }
      },
      [`&-disabled${componentCls}-button-wrapper-checked`]: {
        color: buttonCheckedColorDisabled,
        backgroundColor: buttonCheckedBgDisabled,
        borderColor: colorBorder,
        boxShadow: "none"
      },
      "&-block": {
        flex: 1,
        textAlign: "center"
      }
    }
  };
};
var prepareComponentToken12 = (token2) => {
  const {
    wireframe,
    padding,
    marginXS,
    lineWidth,
    fontSizeLG,
    colorText,
    colorBgContainer,
    colorTextDisabled,
    controlItemBgActiveDisabled,
    colorTextLightSolid,
    colorPrimary,
    colorPrimaryHover,
    colorPrimaryActive,
    colorWhite
  } = token2;
  const dotPadding = 4;
  const radioSize = fontSizeLG;
  const radioDotSize = wireframe ? radioSize - dotPadding * 2 : radioSize - (dotPadding + lineWidth) * 2;
  return {
    // Radio
    radioSize,
    dotSize: radioDotSize,
    dotColorDisabled: colorTextDisabled,
    // Radio buttons
    buttonSolidCheckedColor: colorTextLightSolid,
    buttonSolidCheckedBg: colorPrimary,
    buttonSolidCheckedHoverBg: colorPrimaryHover,
    buttonSolidCheckedActiveBg: colorPrimaryActive,
    buttonBg: colorBgContainer,
    buttonCheckedBg: colorBgContainer,
    buttonColor: colorText,
    buttonCheckedBgDisabled: controlItemBgActiveDisabled,
    buttonCheckedColorDisabled: colorTextDisabled,
    buttonPaddingInline: padding - lineWidth,
    wrapperMarginInlineEnd: marginXS,
    // internal
    radioColor: wireframe ? colorPrimary : colorWhite,
    radioBgColor: wireframe ? colorBgContainer : colorPrimary
  };
};
var style_default15 = genStyleHooks("Radio", (token2) => {
  const {
    controlOutline,
    controlOutlineWidth
  } = token2;
  const radioFocusShadow = `0 0 0 ${unit(controlOutlineWidth)} ${controlOutline}`;
  const radioButtonFocusShadow = radioFocusShadow;
  const radioToken = merge2(token2, {
    radioFocusShadow,
    radioButtonFocusShadow
  });
  return [getGroupRadioStyle(radioToken), getRadioBasicStyle(radioToken), getRadioButtonStyle(radioToken)];
}, prepareComponentToken12, {
  unitless: {
    radioSize: true,
    dotSize: true
  }
});

// ../../node_modules/antd/es/radio/radio.js
var __rest19 = function(s, e3) {
  var t2 = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e3.indexOf(p) < 0) t2[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e3.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t2[p[i]] = s[p[i]];
  }
  return t2;
};
var InternalRadio = (props, ref3) => {
  var _a, _b;
  const groupContext = React277.useContext(context_default4);
  const radioOptionTypeContext = React277.useContext(RadioOptionTypeContext);
  const {
    getPrefixCls,
    direction,
    radio
  } = React277.useContext(ConfigContext);
  const innerRef = React277.useRef(null);
  const mergedRef = composeRef(ref3, innerRef);
  const {
    isFormItemInput
  } = React277.useContext(FormItemInputContext);
  if (true) {
    const warning6 = devUseWarning("Radio");
    true ? warning6(!("optionType" in props), "usage", "`optionType` is only support in Radio.Group.") : void 0;
  }
  const onChange = (e3) => {
    var _a2, _b2;
    (_a2 = props.onChange) === null || _a2 === void 0 ? void 0 : _a2.call(props, e3);
    (_b2 = groupContext === null || groupContext === void 0 ? void 0 : groupContext.onChange) === null || _b2 === void 0 ? void 0 : _b2.call(groupContext, e3);
  };
  const {
    prefixCls: customizePrefixCls,
    className: className2,
    rootClassName,
    children,
    style: style2,
    title
  } = props, restProps = __rest19(props, ["prefixCls", "className", "rootClassName", "children", "style", "title"]);
  const radioPrefixCls = getPrefixCls("radio", customizePrefixCls);
  const isButtonType = ((groupContext === null || groupContext === void 0 ? void 0 : groupContext.optionType) || radioOptionTypeContext) === "button";
  const prefixCls = isButtonType ? `${radioPrefixCls}-button` : radioPrefixCls;
  const rootCls = useCSSVarCls_default(radioPrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = style_default15(radioPrefixCls, rootCls);
  const radioProps = Object.assign({}, restProps);
  const disabled = React277.useContext(DisabledContext_default);
  if (groupContext) {
    radioProps.name = groupContext.name;
    radioProps.onChange = onChange;
    radioProps.checked = props.value === groupContext.value;
    radioProps.disabled = (_a = radioProps.disabled) !== null && _a !== void 0 ? _a : groupContext.disabled;
  }
  radioProps.disabled = (_b = radioProps.disabled) !== null && _b !== void 0 ? _b : disabled;
  const wrapperClassString = (0, import_classnames92.default)(`${prefixCls}-wrapper`, {
    [`${prefixCls}-wrapper-checked`]: radioProps.checked,
    [`${prefixCls}-wrapper-disabled`]: radioProps.disabled,
    [`${prefixCls}-wrapper-rtl`]: direction === "rtl",
    [`${prefixCls}-wrapper-in-form-item`]: isFormItemInput,
    [`${prefixCls}-wrapper-block`]: !!(groupContext === null || groupContext === void 0 ? void 0 : groupContext.block)
  }, radio === null || radio === void 0 ? void 0 : radio.className, className2, rootClassName, hashId, cssVarCls, rootCls);
  const [onLabelClick, onInputClick] = useBubbleLock(radioProps.onClick);
  return wrapCSSVar(/* @__PURE__ */ React277.createElement(wave_default, {
    component: "Radio",
    disabled: radioProps.disabled
  }, /* @__PURE__ */ React277.createElement("label", {
    className: wrapperClassString,
    style: Object.assign(Object.assign({}, radio === null || radio === void 0 ? void 0 : radio.style), style2),
    onMouseEnter: props.onMouseEnter,
    onMouseLeave: props.onMouseLeave,
    title,
    onClick: onLabelClick
  }, /* @__PURE__ */ React277.createElement(es_default16, Object.assign({}, radioProps, {
    className: (0, import_classnames92.default)(radioProps.className, {
      [TARGET_CLS]: !isButtonType
    }),
    type: "radio",
    prefixCls,
    ref: mergedRef,
    onClick: onInputClick
  })), children !== void 0 ? /* @__PURE__ */ React277.createElement("span", {
    className: `${prefixCls}-label`
  }, children) : null)));
};
var Radio = /* @__PURE__ */ React277.forwardRef(InternalRadio);
if (true) {
  Radio.displayName = "Radio";
}
var radio_default = Radio;

// ../../node_modules/antd/es/form/hooks/useForm.js
var React278 = __toESM(require_react());

// ../../node_modules/antd/es/form/util.js
var formItemNameBlackList = ["parentNode"];
var defaultItemNamePrefixCls = "form_item";
function toArray6(candidate) {
  if (candidate === void 0 || candidate === false) return [];
  return Array.isArray(candidate) ? candidate : [candidate];
}
function getFieldId(namePath, formName) {
  if (!namePath.length) {
    return void 0;
  }
  const mergedId = namePath.join("_");
  if (formName) {
    return `${formName}_${mergedId}`;
  }
  const isIllegalName = formItemNameBlackList.includes(mergedId);
  return isIllegalName ? `${defaultItemNamePrefixCls}_${mergedId}` : mergedId;
}
function getStatus(errors, warnings, meta, defaultValidateStatus, hasFeedback, validateStatus) {
  let status = defaultValidateStatus;
  if (validateStatus !== void 0) {
    status = validateStatus;
  } else if (meta.validating) {
    status = "validating";
  } else if (errors.length) {
    status = "error";
  } else if (warnings.length) {
    status = "warning";
  } else if (meta.touched || hasFeedback && meta.validated) {
    status = "success";
  }
  return status;
}

// ../../node_modules/antd/es/form/hooks/useForm.js
var __rest20 = function(s, e3) {
  var t2 = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e3.indexOf(p) < 0) t2[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e3.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t2[p[i]] = s[p[i]];
  }
  return t2;
};
function toNamePathStr(name) {
  const namePath = toArray6(name);
  return namePath.join("_");
}
function getFieldDOMNode(name, wrapForm) {
  const field = wrapForm.getFieldInstance(name);
  const fieldDom = getDOM(field);
  if (fieldDom) {
    return fieldDom;
  }
  const fieldId = getFieldId(toArray6(name), wrapForm.__INTERNAL__.name);
  if (fieldId) {
    return document.getElementById(fieldId);
  }
}
function useForm2(form) {
  const [rcForm] = useForm_default();
  const itemsRef = React278.useRef({});
  const wrapForm = React278.useMemo(() => form !== null && form !== void 0 ? form : Object.assign(Object.assign({}, rcForm), {
    __INTERNAL__: {
      itemRef: (name) => (node2) => {
        const namePathStr = toNamePathStr(name);
        if (node2) {
          itemsRef.current[namePathStr] = node2;
        } else {
          delete itemsRef.current[namePathStr];
        }
      }
    },
    scrollToField: (name, options = {}) => {
      const {
        focus
      } = options, restOpt = __rest20(options, ["focus"]);
      const node2 = getFieldDOMNode(name, wrapForm);
      if (node2) {
        e2(node2, Object.assign({
          scrollMode: "if-needed",
          block: "nearest"
        }, restOpt));
        if (focus) {
          wrapForm.focusField(name);
        }
      }
    },
    focusField: (name) => {
      var _a, _b;
      const itemRef = wrapForm.getFieldInstance(name);
      if (typeof (itemRef === null || itemRef === void 0 ? void 0 : itemRef.focus) === "function") {
        itemRef.focus();
      } else {
        (_b = (_a = getFieldDOMNode(name, wrapForm)) === null || _a === void 0 ? void 0 : _a.focus) === null || _b === void 0 ? void 0 : _b.call(_a);
      }
    },
    getFieldInstance: (name) => {
      const namePathStr = toNamePathStr(name);
      return itemsRef.current[namePathStr];
    }
  }), [form, rcForm]);
  return [wrapForm];
}

// ../../node_modules/antd/es/radio/group.js
var RadioGroup = /* @__PURE__ */ React279.forwardRef((props, ref3) => {
  const {
    getPrefixCls,
    direction
  } = React279.useContext(ConfigContext);
  const {
    name: formItemName
  } = React279.useContext(FormItemInputContext);
  const defaultName = useId_default(toNamePathStr(formItemName));
  const {
    prefixCls: customizePrefixCls,
    className: className2,
    rootClassName,
    options,
    buttonStyle = "outline",
    disabled,
    children,
    size: customizeSize,
    style: style2,
    id,
    optionType,
    name = defaultName,
    defaultValue: defaultValue2,
    value: customizedValue,
    block = false,
    onChange,
    onMouseEnter,
    onMouseLeave,
    onFocus,
    onBlur
  } = props;
  const [value, setValue] = useMergedState(defaultValue2, {
    value: customizedValue
  });
  const onRadioChange = React279.useCallback((event) => {
    const lastValue = value;
    const val = event.target.value;
    if (!("value" in props)) {
      setValue(val);
    }
    if (val !== lastValue) {
      onChange === null || onChange === void 0 ? void 0 : onChange(event);
    }
  }, [value, setValue, onChange]);
  const prefixCls = getPrefixCls("radio", customizePrefixCls);
  const groupPrefixCls = `${prefixCls}-group`;
  const rootCls = useCSSVarCls_default(prefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = style_default15(prefixCls, rootCls);
  let childrenToRender = children;
  if (options && options.length > 0) {
    childrenToRender = options.map((option) => {
      if (typeof option === "string" || typeof option === "number") {
        return /* @__PURE__ */ React279.createElement(radio_default, {
          key: option.toString(),
          prefixCls,
          disabled,
          value: option,
          checked: value === option
        }, option);
      }
      return /* @__PURE__ */ React279.createElement(radio_default, {
        key: `radio-group-value-options-${option.value}`,
        prefixCls,
        disabled: option.disabled || disabled,
        value: option.value,
        checked: value === option.value,
        title: option.title,
        style: option.style,
        className: option.className,
        id: option.id,
        required: option.required
      }, option.label);
    });
  }
  const mergedSize = useSize_default(customizeSize);
  const classString = (0, import_classnames93.default)(groupPrefixCls, `${groupPrefixCls}-${buttonStyle}`, {
    [`${groupPrefixCls}-${mergedSize}`]: mergedSize,
    [`${groupPrefixCls}-rtl`]: direction === "rtl",
    [`${groupPrefixCls}-block`]: block
  }, className2, rootClassName, hashId, cssVarCls, rootCls);
  const memoizedValue = React279.useMemo(() => ({
    onChange: onRadioChange,
    value,
    disabled,
    name,
    optionType,
    block
  }), [onRadioChange, value, disabled, name, optionType, block]);
  return wrapCSSVar(/* @__PURE__ */ React279.createElement("div", Object.assign({}, pickAttrs(props, {
    aria: true,
    data: true
  }), {
    className: classString,
    style: style2,
    onMouseEnter,
    onMouseLeave,
    onFocus,
    onBlur,
    id,
    ref: ref3
  }), /* @__PURE__ */ React279.createElement(RadioGroupContextProvider, {
    value: memoizedValue
  }, childrenToRender)));
});
var group_default2 = /* @__PURE__ */ React279.memo(RadioGroup);

// ../../node_modules/antd/es/radio/radioButton.js
var React280 = __toESM(require_react());
var __rest21 = function(s, e3) {
  var t2 = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e3.indexOf(p) < 0) t2[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e3.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t2[p[i]] = s[p[i]];
  }
  return t2;
};
var RadioButton = (props, ref3) => {
  const {
    getPrefixCls
  } = React280.useContext(ConfigContext);
  const {
    prefixCls: customizePrefixCls
  } = props, radioProps = __rest21(props, ["prefixCls"]);
  const prefixCls = getPrefixCls("radio", customizePrefixCls);
  return /* @__PURE__ */ React280.createElement(RadioOptionTypeContextProvider, {
    value: "button"
  }, /* @__PURE__ */ React280.createElement(radio_default, Object.assign({
    prefixCls
  }, radioProps, {
    type: "radio",
    ref: ref3
  })));
};
var radioButton_default = /* @__PURE__ */ React280.forwardRef(RadioButton);

// ../../node_modules/antd/es/radio/index.js
var Radio2 = radio_default;
Radio2.Button = radioButton_default;
Radio2.Group = group_default2;
Radio2.__ANT_RADIO = true;
var radio_default2 = Radio2;

// ../../node_modules/antd/es/input/style/token.js
function initInputToken(token2) {
  return merge2(token2, {
    inputAffixPadding: token2.paddingXXS
  });
}
var initComponentToken = (token2) => {
  const {
    controlHeight,
    fontSize,
    lineHeight,
    lineWidth,
    controlHeightSM,
    controlHeightLG,
    fontSizeLG,
    lineHeightLG,
    paddingSM,
    controlPaddingHorizontalSM,
    controlPaddingHorizontal,
    colorFillAlter,
    colorPrimaryHover,
    colorPrimary,
    controlOutlineWidth,
    controlOutline,
    colorErrorOutline,
    colorWarningOutline,
    colorBgContainer,
    inputFontSize,
    inputFontSizeLG,
    inputFontSizeSM
  } = token2;
  const mergedFontSize = inputFontSize || fontSize;
  const mergedFontSizeSM = inputFontSizeSM || mergedFontSize;
  const mergedFontSizeLG = inputFontSizeLG || fontSizeLG;
  const paddingBlock = Math.round((controlHeight - mergedFontSize * lineHeight) / 2 * 10) / 10 - lineWidth;
  const paddingBlockSM = Math.round((controlHeightSM - mergedFontSizeSM * lineHeight) / 2 * 10) / 10 - lineWidth;
  const paddingBlockLG = Math.ceil((controlHeightLG - mergedFontSizeLG * lineHeightLG) / 2 * 10) / 10 - lineWidth;
  return {
    paddingBlock: Math.max(paddingBlock, 0),
    paddingBlockSM: Math.max(paddingBlockSM, 0),
    paddingBlockLG: Math.max(paddingBlockLG, 0),
    paddingInline: paddingSM - lineWidth,
    paddingInlineSM: controlPaddingHorizontalSM - lineWidth,
    paddingInlineLG: controlPaddingHorizontal - lineWidth,
    addonBg: colorFillAlter,
    activeBorderColor: colorPrimary,
    hoverBorderColor: colorPrimaryHover,
    activeShadow: `0 0 0 ${controlOutlineWidth}px ${controlOutline}`,
    errorActiveShadow: `0 0 0 ${controlOutlineWidth}px ${colorErrorOutline}`,
    warningActiveShadow: `0 0 0 ${controlOutlineWidth}px ${colorWarningOutline}`,
    hoverBg: colorBgContainer,
    activeBg: colorBgContainer,
    inputFontSize: mergedFontSize,
    inputFontSizeLG: mergedFontSizeLG,
    inputFontSizeSM: mergedFontSizeSM
  };
};

// ../../node_modules/antd/es/input/style/variants.js
var genHoverStyle = (token2) => ({
  borderColor: token2.hoverBorderColor,
  backgroundColor: token2.hoverBg
});
var genDisabledStyle2 = (token2) => ({
  color: token2.colorTextDisabled,
  backgroundColor: token2.colorBgContainerDisabled,
  borderColor: token2.colorBorder,
  boxShadow: "none",
  cursor: "not-allowed",
  opacity: 1,
  "input[disabled], textarea[disabled]": {
    cursor: "not-allowed"
  },
  "&:hover:not([disabled])": Object.assign({}, genHoverStyle(merge2(token2, {
    hoverBorderColor: token2.colorBorder,
    hoverBg: token2.colorBgContainerDisabled
  })))
});
var genBaseOutlinedStyle2 = (token2, options) => ({
  background: token2.colorBgContainer,
  borderWidth: token2.lineWidth,
  borderStyle: token2.lineType,
  borderColor: options.borderColor,
  "&:hover": {
    borderColor: options.hoverBorderColor,
    backgroundColor: token2.hoverBg
  },
  "&:focus, &:focus-within": {
    borderColor: options.activeBorderColor,
    boxShadow: options.activeShadow,
    outline: 0,
    backgroundColor: token2.activeBg
  }
});
var genOutlinedStatusStyle2 = (token2, options) => ({
  [`&${token2.componentCls}-status-${options.status}:not(${token2.componentCls}-disabled)`]: Object.assign(Object.assign({}, genBaseOutlinedStyle2(token2, options)), {
    [`${token2.componentCls}-prefix, ${token2.componentCls}-suffix`]: {
      color: options.affixColor
    }
  }),
  [`&${token2.componentCls}-status-${options.status}${token2.componentCls}-disabled`]: {
    borderColor: options.borderColor
  }
});
var genOutlinedStyle2 = (token2, extraStyles) => ({
  "&-outlined": Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, genBaseOutlinedStyle2(token2, {
    borderColor: token2.colorBorder,
    hoverBorderColor: token2.hoverBorderColor,
    activeBorderColor: token2.activeBorderColor,
    activeShadow: token2.activeShadow
  })), {
    [`&${token2.componentCls}-disabled, &[disabled]`]: Object.assign({}, genDisabledStyle2(token2))
  }), genOutlinedStatusStyle2(token2, {
    status: "error",
    borderColor: token2.colorError,
    hoverBorderColor: token2.colorErrorBorderHover,
    activeBorderColor: token2.colorError,
    activeShadow: token2.errorActiveShadow,
    affixColor: token2.colorError
  })), genOutlinedStatusStyle2(token2, {
    status: "warning",
    borderColor: token2.colorWarning,
    hoverBorderColor: token2.colorWarningBorderHover,
    activeBorderColor: token2.colorWarning,
    activeShadow: token2.warningActiveShadow,
    affixColor: token2.colorWarning
  })), extraStyles)
});
var genOutlinedGroupStatusStyle = (token2, options) => ({
  [`&${token2.componentCls}-group-wrapper-status-${options.status}`]: {
    [`${token2.componentCls}-group-addon`]: {
      borderColor: options.addonBorderColor,
      color: options.addonColor
    }
  }
});
var genOutlinedGroupStyle = (token2) => ({
  "&-outlined": Object.assign(Object.assign(Object.assign({
    [`${token2.componentCls}-group`]: {
      "&-addon": {
        background: token2.addonBg,
        border: `${unit(token2.lineWidth)} ${token2.lineType} ${token2.colorBorder}`
      },
      "&-addon:first-child": {
        borderInlineEnd: 0
      },
      "&-addon:last-child": {
        borderInlineStart: 0
      }
    }
  }, genOutlinedGroupStatusStyle(token2, {
    status: "error",
    addonBorderColor: token2.colorError,
    addonColor: token2.colorErrorText
  })), genOutlinedGroupStatusStyle(token2, {
    status: "warning",
    addonBorderColor: token2.colorWarning,
    addonColor: token2.colorWarningText
  })), {
    [`&${token2.componentCls}-group-wrapper-disabled`]: {
      [`${token2.componentCls}-group-addon`]: Object.assign({}, genDisabledStyle2(token2))
    }
  })
});
var genBorderlessStyle3 = (token2, extraStyles) => {
  const {
    componentCls
  } = token2;
  return {
    "&-borderless": Object.assign({
      background: "transparent",
      border: "none",
      "&:focus, &:focus-within": {
        outline: "none"
      },
      // >>>>> Disabled
      [`&${componentCls}-disabled, &[disabled]`]: {
        color: token2.colorTextDisabled,
        cursor: "not-allowed"
      },
      // >>>>> Status
      [`&${componentCls}-status-error`]: {
        "&, & input, & textarea": {
          color: token2.colorError
        }
      },
      [`&${componentCls}-status-warning`]: {
        "&, & input, & textarea": {
          color: token2.colorWarning
        }
      }
    }, extraStyles)
  };
};
var genBaseFilledStyle2 = (token2, options) => {
  var _a;
  return {
    background: options.bg,
    borderWidth: token2.lineWidth,
    borderStyle: token2.lineType,
    borderColor: "transparent",
    "input&, & input, textarea&, & textarea": {
      color: (_a = options === null || options === void 0 ? void 0 : options.inputColor) !== null && _a !== void 0 ? _a : "unset"
    },
    "&:hover": {
      background: options.hoverBg
    },
    "&:focus, &:focus-within": {
      outline: 0,
      borderColor: options.activeBorderColor,
      backgroundColor: token2.activeBg
    }
  };
};
var genFilledStatusStyle2 = (token2, options) => ({
  [`&${token2.componentCls}-status-${options.status}:not(${token2.componentCls}-disabled)`]: Object.assign(Object.assign({}, genBaseFilledStyle2(token2, options)), {
    [`${token2.componentCls}-prefix, ${token2.componentCls}-suffix`]: {
      color: options.affixColor
    }
  })
});
var genFilledStyle2 = (token2, extraStyles) => ({
  "&-filled": Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, genBaseFilledStyle2(token2, {
    bg: token2.colorFillTertiary,
    hoverBg: token2.colorFillSecondary,
    activeBorderColor: token2.activeBorderColor
  })), {
    [`&${token2.componentCls}-disabled, &[disabled]`]: Object.assign({}, genDisabledStyle2(token2))
  }), genFilledStatusStyle2(token2, {
    status: "error",
    bg: token2.colorErrorBg,
    hoverBg: token2.colorErrorBgHover,
    activeBorderColor: token2.colorError,
    inputColor: token2.colorErrorText,
    affixColor: token2.colorError
  })), genFilledStatusStyle2(token2, {
    status: "warning",
    bg: token2.colorWarningBg,
    hoverBg: token2.colorWarningBgHover,
    activeBorderColor: token2.colorWarning,
    inputColor: token2.colorWarningText,
    affixColor: token2.colorWarning
  })), extraStyles)
});
var genFilledGroupStatusStyle = (token2, options) => ({
  [`&${token2.componentCls}-group-wrapper-status-${options.status}`]: {
    [`${token2.componentCls}-group-addon`]: {
      background: options.addonBg,
      color: options.addonColor
    }
  }
});
var genFilledGroupStyle = (token2) => ({
  "&-filled": Object.assign(Object.assign(Object.assign({
    [`${token2.componentCls}-group-addon`]: {
      background: token2.colorFillTertiary,
      "&:last-child": {
        position: "static"
      }
    }
  }, genFilledGroupStatusStyle(token2, {
    status: "error",
    addonBg: token2.colorErrorBg,
    addonColor: token2.colorErrorText
  })), genFilledGroupStatusStyle(token2, {
    status: "warning",
    addonBg: token2.colorWarningBg,
    addonColor: token2.colorWarningText
  })), {
    [`&${token2.componentCls}-group-wrapper-disabled`]: {
      [`${token2.componentCls}-group`]: {
        "&-addon": {
          background: token2.colorFillTertiary,
          color: token2.colorTextDisabled
        },
        "&-addon:first-child": {
          borderInlineStart: `${unit(token2.lineWidth)} ${token2.lineType} ${token2.colorBorder}`,
          borderTop: `${unit(token2.lineWidth)} ${token2.lineType} ${token2.colorBorder}`,
          borderBottom: `${unit(token2.lineWidth)} ${token2.lineType} ${token2.colorBorder}`
        },
        "&-addon:last-child": {
          borderInlineEnd: `${unit(token2.lineWidth)} ${token2.lineType} ${token2.colorBorder}`,
          borderTop: `${unit(token2.lineWidth)} ${token2.lineType} ${token2.colorBorder}`,
          borderBottom: `${unit(token2.lineWidth)} ${token2.lineType} ${token2.colorBorder}`
        }
      }
    }
  })
});
var genBaseUnderlinedStyle2 = (token2, options) => ({
  background: token2.colorBgContainer,
  borderWidth: `${unit(token2.lineWidth)} 0`,
  borderStyle: `${token2.lineType} none`,
  borderColor: `transparent transparent ${options.borderColor} transparent`,
  borderRadius: 0,
  "&:hover": {
    borderColor: `transparent transparent ${options.borderColor} transparent`,
    backgroundColor: token2.hoverBg
  },
  "&:focus, &:focus-within": {
    borderColor: `transparent transparent ${options.activeBorderColor} transparent`,
    outline: 0,
    backgroundColor: token2.activeBg
  }
});
var genUnderlinedStatusStyle2 = (token2, options) => ({
  [`&${token2.componentCls}-status-${options.status}:not(${token2.componentCls}-disabled)`]: Object.assign(Object.assign({}, genBaseUnderlinedStyle2(token2, options)), {
    [`${token2.componentCls}-prefix, ${token2.componentCls}-suffix`]: {
      color: options.affixColor
    }
  }),
  [`&${token2.componentCls}-status-${options.status}${token2.componentCls}-disabled`]: {
    borderColor: `transparent transparent ${options.borderColor} transparent`
  }
});
var genUnderlinedStyle2 = (token2, extraStyles) => ({
  "&-underlined": Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, genBaseUnderlinedStyle2(token2, {
    borderColor: token2.colorBorder,
    hoverBorderColor: token2.hoverBorderColor,
    activeBorderColor: token2.activeBorderColor,
    activeShadow: token2.activeShadow
  })), {
    // >>>>> Disabled
    [`&${token2.componentCls}-disabled, &[disabled]`]: {
      color: token2.colorTextDisabled,
      boxShadow: "none",
      cursor: "not-allowed",
      "&:hover": {
        borderColor: `transparent transparent ${token2.colorBorder} transparent`
      }
    },
    "input[disabled], textarea[disabled]": {
      cursor: "not-allowed"
    }
  }), genUnderlinedStatusStyle2(token2, {
    status: "error",
    borderColor: token2.colorError,
    hoverBorderColor: token2.colorErrorBorderHover,
    activeBorderColor: token2.colorError,
    activeShadow: token2.errorActiveShadow,
    affixColor: token2.colorError
  })), genUnderlinedStatusStyle2(token2, {
    status: "warning",
    borderColor: token2.colorWarning,
    hoverBorderColor: token2.colorWarningBorderHover,
    activeBorderColor: token2.colorWarning,
    activeShadow: token2.warningActiveShadow,
    affixColor: token2.colorWarning
  })), extraStyles)
});

// ../../node_modules/antd/es/input/style/index.js
var genPlaceholderStyle = (color) => ({
  // Firefox
  "&::-moz-placeholder": {
    opacity: 1
  },
  "&::placeholder": {
    color,
    userSelect: "none"
    // https://github.com/ant-design/ant-design/pull/32639
  },
  "&:placeholder-shown": {
    textOverflow: "ellipsis"
  }
});
var genInputLargeStyle = (token2) => {
  const {
    paddingBlockLG,
    lineHeightLG,
    borderRadiusLG,
    paddingInlineLG
  } = token2;
  return {
    padding: `${unit(paddingBlockLG)} ${unit(paddingInlineLG)}`,
    fontSize: token2.inputFontSizeLG,
    lineHeight: lineHeightLG,
    borderRadius: borderRadiusLG
  };
};
var genInputSmallStyle = (token2) => ({
  padding: `${unit(token2.paddingBlockSM)} ${unit(token2.paddingInlineSM)}`,
  fontSize: token2.inputFontSizeSM,
  borderRadius: token2.borderRadiusSM
});
var genBasicInputStyle = (token2) => Object.assign(Object.assign({
  position: "relative",
  display: "inline-block",
  width: "100%",
  minWidth: 0,
  padding: `${unit(token2.paddingBlock)} ${unit(token2.paddingInline)}`,
  color: token2.colorText,
  fontSize: token2.inputFontSize,
  lineHeight: token2.lineHeight,
  borderRadius: token2.borderRadius,
  transition: `all ${token2.motionDurationMid}`
}, genPlaceholderStyle(token2.colorTextPlaceholder)), {
  // Size
  "&-lg": Object.assign({}, genInputLargeStyle(token2)),
  "&-sm": Object.assign({}, genInputSmallStyle(token2)),
  // RTL
  "&-rtl, &-textarea-rtl": {
    direction: "rtl"
  }
});
var genInputGroupStyle = (token2) => {
  const {
    componentCls,
    antCls
  } = token2;
  return {
    position: "relative",
    display: "table",
    width: "100%",
    borderCollapse: "separate",
    borderSpacing: 0,
    // Undo padding and float of grid classes
    "&[class*='col-']": {
      paddingInlineEnd: token2.paddingXS,
      "&:last-child": {
        paddingInlineEnd: 0
      }
    },
    // Sizing options
    [`&-lg ${componentCls}, &-lg > ${componentCls}-group-addon`]: Object.assign({}, genInputLargeStyle(token2)),
    [`&-sm ${componentCls}, &-sm > ${componentCls}-group-addon`]: Object.assign({}, genInputSmallStyle(token2)),
    // Fix https://github.com/ant-design/ant-design/issues/5754
    [`&-lg ${antCls}-select-single ${antCls}-select-selector`]: {
      height: token2.controlHeightLG
    },
    [`&-sm ${antCls}-select-single ${antCls}-select-selector`]: {
      height: token2.controlHeightSM
    },
    [`> ${componentCls}`]: {
      display: "table-cell",
      "&:not(:first-child):not(:last-child)": {
        borderRadius: 0
      }
    },
    [`${componentCls}-group`]: {
      "&-addon, &-wrap": {
        display: "table-cell",
        width: 1,
        whiteSpace: "nowrap",
        verticalAlign: "middle",
        "&:not(:first-child):not(:last-child)": {
          borderRadius: 0
        }
      },
      "&-wrap > *": {
        display: "block !important"
      },
      "&-addon": {
        position: "relative",
        padding: `0 ${unit(token2.paddingInline)}`,
        color: token2.colorText,
        fontWeight: "normal",
        fontSize: token2.inputFontSize,
        textAlign: "center",
        borderRadius: token2.borderRadius,
        transition: `all ${token2.motionDurationSlow}`,
        lineHeight: 1,
        // Reset Select's style in addon
        [`${antCls}-select`]: {
          margin: `${unit(token2.calc(token2.paddingBlock).add(1).mul(-1).equal())} ${unit(token2.calc(token2.paddingInline).mul(-1).equal())}`,
          [`&${antCls}-select-single:not(${antCls}-select-customize-input):not(${antCls}-pagination-size-changer)`]: {
            [`${antCls}-select-selector`]: {
              backgroundColor: "inherit",
              border: `${unit(token2.lineWidth)} ${token2.lineType} transparent`,
              boxShadow: "none"
            }
          }
        },
        // https://github.com/ant-design/ant-design/issues/31333
        [`${antCls}-cascader-picker`]: {
          margin: `-9px ${unit(token2.calc(token2.paddingInline).mul(-1).equal())}`,
          backgroundColor: "transparent",
          [`${antCls}-cascader-input`]: {
            textAlign: "start",
            border: 0,
            boxShadow: "none"
          }
        }
      }
    },
    [componentCls]: {
      width: "100%",
      marginBottom: 0,
      textAlign: "inherit",
      "&:focus": {
        zIndex: 1,
        // Fix https://gw.alipayobjects.com/zos/rmsportal/DHNpoqfMXSfrSnlZvhsJ.png
        borderInlineEndWidth: 1
      },
      "&:hover": {
        zIndex: 1,
        borderInlineEndWidth: 1,
        [`${componentCls}-search-with-button &`]: {
          zIndex: 0
        }
      }
    },
    // Reset rounded corners
    [`> ${componentCls}:first-child, ${componentCls}-group-addon:first-child`]: {
      borderStartEndRadius: 0,
      borderEndEndRadius: 0,
      // Reset Select's style in addon
      [`${antCls}-select ${antCls}-select-selector`]: {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0
      }
    },
    [`> ${componentCls}-affix-wrapper`]: {
      [`&:not(:first-child) ${componentCls}`]: {
        borderStartStartRadius: 0,
        borderEndStartRadius: 0
      },
      [`&:not(:last-child) ${componentCls}`]: {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0
      }
    },
    [`> ${componentCls}:last-child, ${componentCls}-group-addon:last-child`]: {
      borderStartStartRadius: 0,
      borderEndStartRadius: 0,
      // Reset Select's style in addon
      [`${antCls}-select ${antCls}-select-selector`]: {
        borderStartStartRadius: 0,
        borderEndStartRadius: 0
      }
    },
    [`${componentCls}-affix-wrapper`]: {
      "&:not(:last-child)": {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0,
        [`${componentCls}-search &`]: {
          borderStartStartRadius: token2.borderRadius,
          borderEndStartRadius: token2.borderRadius
        }
      },
      [`&:not(:first-child), ${componentCls}-search &:not(:first-child)`]: {
        borderStartStartRadius: 0,
        borderEndStartRadius: 0
      }
    },
    [`&${componentCls}-group-compact`]: Object.assign(Object.assign({
      display: "block"
    }, clearFix()), {
      [`${componentCls}-group-addon, ${componentCls}-group-wrap, > ${componentCls}`]: {
        "&:not(:first-child):not(:last-child)": {
          borderInlineEndWidth: token2.lineWidth,
          "&:hover, &:focus": {
            zIndex: 1
          }
        }
      },
      "& > *": {
        display: "inline-flex",
        float: "none",
        verticalAlign: "top",
        // https://github.com/ant-design/ant-design-pro/issues/139
        borderRadius: 0
      },
      [`
        & > ${componentCls}-affix-wrapper,
        & > ${componentCls}-number-affix-wrapper,
        & > ${antCls}-picker-range
      `]: {
        display: "inline-flex"
      },
      "& > *:not(:last-child)": {
        marginInlineEnd: token2.calc(token2.lineWidth).mul(-1).equal(),
        borderInlineEndWidth: token2.lineWidth
      },
      // Undo float for .ant-input-group .ant-input
      [componentCls]: {
        float: "none"
      },
      // reset border for Select, DatePicker, AutoComplete, Cascader, Mention, TimePicker, Input
      [`& > ${antCls}-select > ${antCls}-select-selector,
      & > ${antCls}-select-auto-complete ${componentCls},
      & > ${antCls}-cascader-picker ${componentCls},
      & > ${componentCls}-group-wrapper ${componentCls}`]: {
        borderInlineEndWidth: token2.lineWidth,
        borderRadius: 0,
        "&:hover, &:focus": {
          zIndex: 1
        }
      },
      [`& > ${antCls}-select-focused`]: {
        zIndex: 1
      },
      // update z-index for arrow icon
      [`& > ${antCls}-select > ${antCls}-select-arrow`]: {
        zIndex: 1
        // https://github.com/ant-design/ant-design/issues/20371
      },
      [`& > *:first-child,
      & > ${antCls}-select:first-child > ${antCls}-select-selector,
      & > ${antCls}-select-auto-complete:first-child ${componentCls},
      & > ${antCls}-cascader-picker:first-child ${componentCls}`]: {
        borderStartStartRadius: token2.borderRadius,
        borderEndStartRadius: token2.borderRadius
      },
      [`& > *:last-child,
      & > ${antCls}-select:last-child > ${antCls}-select-selector,
      & > ${antCls}-cascader-picker:last-child ${componentCls},
      & > ${antCls}-cascader-picker-focused:last-child ${componentCls}`]: {
        borderInlineEndWidth: token2.lineWidth,
        borderStartEndRadius: token2.borderRadius,
        borderEndEndRadius: token2.borderRadius
      },
      // https://github.com/ant-design/ant-design/issues/12493
      [`& > ${antCls}-select-auto-complete ${componentCls}`]: {
        verticalAlign: "top"
      },
      [`${componentCls}-group-wrapper + ${componentCls}-group-wrapper`]: {
        marginInlineStart: token2.calc(token2.lineWidth).mul(-1).equal(),
        [`${componentCls}-affix-wrapper`]: {
          borderRadius: 0
        }
      },
      [`${componentCls}-group-wrapper:not(:last-child)`]: {
        [`&${componentCls}-search > ${componentCls}-group`]: {
          [`& > ${componentCls}-group-addon > ${componentCls}-search-button`]: {
            borderRadius: 0
          },
          [`& > ${componentCls}`]: {
            borderStartStartRadius: token2.borderRadius,
            borderStartEndRadius: 0,
            borderEndEndRadius: 0,
            borderEndStartRadius: token2.borderRadius
          }
        }
      }
    })
  };
};
var genInputStyle = (token2) => {
  const {
    componentCls,
    controlHeightSM,
    lineWidth,
    calc
  } = token2;
  const FIXED_CHROME_COLOR_HEIGHT = 16;
  const colorSmallPadding = calc(controlHeightSM).sub(calc(lineWidth).mul(2)).sub(FIXED_CHROME_COLOR_HEIGHT).div(2).equal();
  return {
    [componentCls]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, resetComponent(token2)), genBasicInputStyle(token2)), genOutlinedStyle2(token2)), genFilledStyle2(token2)), genBorderlessStyle3(token2)), genUnderlinedStyle2(token2)), {
      '&[type="color"]': {
        height: token2.controlHeight,
        [`&${componentCls}-lg`]: {
          height: token2.controlHeightLG
        },
        [`&${componentCls}-sm`]: {
          height: controlHeightSM,
          paddingTop: colorSmallPadding,
          paddingBottom: colorSmallPadding
        }
      },
      '&[type="search"]::-webkit-search-cancel-button, &[type="search"]::-webkit-search-decoration': {
        appearance: "none"
      }
    })
  };
};
var genAllowClearStyle = (token2) => {
  const {
    componentCls
  } = token2;
  return {
    // ========================= Input =========================
    [`${componentCls}-clear-icon`]: {
      margin: 0,
      padding: 0,
      lineHeight: 0,
      color: token2.colorTextQuaternary,
      fontSize: token2.fontSizeIcon,
      verticalAlign: -1,
      // https://github.com/ant-design/ant-design/pull/18151
      // https://codesandbox.io/s/wizardly-sun-u10br
      cursor: "pointer",
      transition: `color ${token2.motionDurationSlow}`,
      border: "none",
      outline: "none",
      backgroundColor: "transparent",
      "&:hover": {
        color: token2.colorIcon
      },
      "&:active": {
        color: token2.colorText
      },
      "&-hidden": {
        visibility: "hidden"
      },
      "&-has-suffix": {
        margin: `0 ${unit(token2.inputAffixPadding)}`
      }
    }
  };
};
var genAffixStyle = (token2) => {
  const {
    componentCls,
    inputAffixPadding,
    colorTextDescription,
    motionDurationSlow,
    colorIcon,
    colorIconHover,
    iconCls
  } = token2;
  const affixCls = `${componentCls}-affix-wrapper`;
  const affixClsDisabled = `${componentCls}-affix-wrapper-disabled`;
  return {
    [affixCls]: Object.assign(Object.assign(Object.assign(Object.assign({}, genBasicInputStyle(token2)), {
      display: "inline-flex",
      [`&:not(${componentCls}-disabled):hover`]: {
        zIndex: 1,
        [`${componentCls}-search-with-button &`]: {
          zIndex: 0
        }
      },
      "&-focused, &:focus": {
        zIndex: 1
      },
      [`> input${componentCls}`]: {
        padding: 0
      },
      [`> input${componentCls}, > textarea${componentCls}`]: {
        fontSize: "inherit",
        border: "none",
        borderRadius: 0,
        outline: "none",
        background: "transparent",
        color: "inherit",
        "&::-ms-reveal": {
          display: "none"
        },
        "&:focus": {
          boxShadow: "none !important"
        }
      },
      "&::before": {
        display: "inline-block",
        width: 0,
        visibility: "hidden",
        content: '"\\a0"'
      },
      [componentCls]: {
        "&-prefix, &-suffix": {
          display: "flex",
          flex: "none",
          alignItems: "center",
          "> *:not(:last-child)": {
            marginInlineEnd: token2.paddingXS
          }
        },
        "&-show-count-suffix": {
          color: colorTextDescription,
          direction: "ltr"
        },
        "&-show-count-has-suffix": {
          marginInlineEnd: token2.paddingXXS
        },
        "&-prefix": {
          marginInlineEnd: inputAffixPadding
        },
        "&-suffix": {
          marginInlineStart: inputAffixPadding
        }
      }
    }), genAllowClearStyle(token2)), {
      // password
      [`${iconCls}${componentCls}-password-icon`]: {
        color: colorIcon,
        cursor: "pointer",
        transition: `all ${motionDurationSlow}`,
        "&:hover": {
          color: colorIconHover
        }
      }
    }),
    // 覆盖 affix-wrapper borderRadius！
    [`${componentCls}-underlined`]: {
      borderRadius: 0
    },
    [affixClsDisabled]: {
      // password disabled
      [`${iconCls}${componentCls}-password-icon`]: {
        color: colorIcon,
        cursor: "not-allowed",
        "&:hover": {
          color: colorIcon
        }
      }
    }
  };
};
var genGroupStyle2 = (token2) => {
  const {
    componentCls,
    borderRadiusLG,
    borderRadiusSM
  } = token2;
  return {
    [`${componentCls}-group`]: Object.assign(Object.assign(Object.assign({}, resetComponent(token2)), genInputGroupStyle(token2)), {
      "&-rtl": {
        direction: "rtl"
      },
      "&-wrapper": Object.assign(Object.assign(Object.assign({
        display: "inline-block",
        width: "100%",
        textAlign: "start",
        verticalAlign: "top",
        "&-rtl": {
          direction: "rtl"
        },
        // Size
        "&-lg": {
          [`${componentCls}-group-addon`]: {
            borderRadius: borderRadiusLG,
            fontSize: token2.inputFontSizeLG
          }
        },
        "&-sm": {
          [`${componentCls}-group-addon`]: {
            borderRadius: borderRadiusSM
          }
        }
      }, genOutlinedGroupStyle(token2)), genFilledGroupStyle(token2)), {
        // '&-disabled': {
        //   [`${componentCls}-group-addon`]: {
        //     ...genDisabledStyle(token),
        //   },
        // },
        // Fix the issue of using icons in Space Compact mode
        // https://github.com/ant-design/ant-design/issues/42122
        [`&:not(${componentCls}-compact-first-item):not(${componentCls}-compact-last-item)${componentCls}-compact-item`]: {
          [`${componentCls}, ${componentCls}-group-addon`]: {
            borderRadius: 0
          }
        },
        [`&:not(${componentCls}-compact-last-item)${componentCls}-compact-first-item`]: {
          [`${componentCls}, ${componentCls}-group-addon`]: {
            borderStartEndRadius: 0,
            borderEndEndRadius: 0
          }
        },
        [`&:not(${componentCls}-compact-first-item)${componentCls}-compact-last-item`]: {
          [`${componentCls}, ${componentCls}-group-addon`]: {
            borderStartStartRadius: 0,
            borderEndStartRadius: 0
          }
        },
        // Fix the issue of input use show-count param in space compact mode
        // https://github.com/ant-design/ant-design/issues/46872
        [`&:not(${componentCls}-compact-last-item)${componentCls}-compact-item`]: {
          [`${componentCls}-affix-wrapper`]: {
            borderStartEndRadius: 0,
            borderEndEndRadius: 0
          }
        },
        // Fix the issue of input use `addonAfter` param in space compact mode
        // https://github.com/ant-design/ant-design/issues/52483
        [`&:not(${componentCls}-compact-first-item)${componentCls}-compact-item`]: {
          [`${componentCls}-affix-wrapper`]: {
            borderStartStartRadius: 0,
            borderEndStartRadius: 0
          }
        }
      })
    })
  };
};
var genSearchInputStyle = (token2) => {
  const {
    componentCls,
    antCls
  } = token2;
  const searchPrefixCls = `${componentCls}-search`;
  return {
    [searchPrefixCls]: {
      [componentCls]: {
        "&:hover, &:focus": {
          [`+ ${componentCls}-group-addon ${searchPrefixCls}-button:not(${antCls}-btn-color-primary):not(${antCls}-btn-variant-text)`]: {
            borderInlineStartColor: token2.colorPrimaryHover
          }
        }
      },
      [`${componentCls}-affix-wrapper`]: {
        height: token2.controlHeight,
        borderRadius: 0
      },
      // fix slight height diff in Firefox:
      // https://ant.design/components/auto-complete-cn/#auto-complete-demo-certain-category
      [`${componentCls}-lg`]: {
        lineHeight: token2.calc(token2.lineHeightLG).sub(2e-4).equal()
      },
      [`> ${componentCls}-group`]: {
        [`> ${componentCls}-group-addon:last-child`]: {
          insetInlineStart: -1,
          padding: 0,
          border: 0,
          [`${searchPrefixCls}-button`]: {
            // Fix https://github.com/ant-design/ant-design/issues/47150
            marginInlineEnd: -1,
            borderStartStartRadius: 0,
            borderEndStartRadius: 0,
            boxShadow: "none"
          },
          [`${searchPrefixCls}-button:not(${antCls}-btn-color-primary)`]: {
            color: token2.colorTextDescription,
            "&:hover": {
              color: token2.colorPrimaryHover
            },
            "&:active": {
              color: token2.colorPrimaryActive
            },
            [`&${antCls}-btn-loading::before`]: {
              inset: 0
            }
          }
        }
      },
      [`${searchPrefixCls}-button`]: {
        height: token2.controlHeight,
        "&:hover, &:focus": {
          zIndex: 1
        }
      },
      "&-large": {
        [`${componentCls}-affix-wrapper, ${searchPrefixCls}-button`]: {
          height: token2.controlHeightLG
        }
      },
      "&-small": {
        [`${componentCls}-affix-wrapper, ${searchPrefixCls}-button`]: {
          height: token2.controlHeightSM
        }
      },
      "&-rtl": {
        direction: "rtl"
      },
      // ===================== Compact Item Customized Styles =====================
      [`&${componentCls}-compact-item`]: {
        [`&:not(${componentCls}-compact-last-item)`]: {
          [`${componentCls}-group-addon`]: {
            [`${componentCls}-search-button`]: {
              marginInlineEnd: token2.calc(token2.lineWidth).mul(-1).equal(),
              borderRadius: 0
            }
          }
        },
        [`&:not(${componentCls}-compact-first-item)`]: {
          [`${componentCls},${componentCls}-affix-wrapper`]: {
            borderRadius: 0
          }
        },
        [`> ${componentCls}-group-addon ${componentCls}-search-button,
        > ${componentCls},
        ${componentCls}-affix-wrapper`]: {
          "&:hover, &:focus, &:active": {
            zIndex: 2
          }
        },
        [`> ${componentCls}-affix-wrapper-focused`]: {
          zIndex: 2
        }
      }
    }
  };
};
var genRangeStyle = (token2) => {
  const {
    componentCls
  } = token2;
  return {
    [`${componentCls}-out-of-range`]: {
      [`&, & input, & textarea, ${componentCls}-show-count-suffix, ${componentCls}-data-count`]: {
        color: token2.colorError
      }
    }
  };
};
var useSharedStyle = genStyleHooks(["Input", "Shared"], (token2) => {
  const inputToken = merge2(token2, initInputToken(token2));
  return [genInputStyle(inputToken), genAffixStyle(inputToken)];
}, initComponentToken, {
  resetFont: false
});
var style_default16 = genStyleHooks(["Input", "Component"], (token2) => {
  const inputToken = merge2(token2, initInputToken(token2));
  return [
    genGroupStyle2(inputToken),
    genSearchInputStyle(inputToken),
    genRangeStyle(inputToken),
    // =====================================================
    // ==             Space Compact                       ==
    // =====================================================
    genCompactItemStyle(inputToken)
  ];
}, initComponentToken, {
  resetFont: false
});

// ../../node_modules/antd/es/date-picker/style/multiple.js
var genSize = (token2, suffix) => {
  const {
    componentCls,
    controlHeight
  } = token2;
  const suffixCls = suffix ? `${componentCls}-${suffix}` : "";
  const multipleSelectorUnit = getMultipleSelectorUnit(token2);
  return [
    // genSelectionStyle(token, suffix),
    {
      [`${componentCls}-multiple${suffixCls}`]: {
        paddingBlock: multipleSelectorUnit.containerPadding,
        paddingInlineStart: multipleSelectorUnit.basePadding,
        minHeight: controlHeight,
        // ======================== Selections ========================
        [`${componentCls}-selection-item`]: {
          height: multipleSelectorUnit.itemHeight,
          lineHeight: unit(multipleSelectorUnit.itemLineHeight)
        }
      }
    }
  ];
};
var genPickerMultipleStyle = (token2) => {
  const {
    componentCls,
    calc,
    lineWidth
  } = token2;
  const smallToken = merge2(token2, {
    fontHeight: token2.fontSize,
    selectHeight: token2.controlHeightSM,
    multipleSelectItemHeight: token2.multipleItemHeightSM,
    borderRadius: token2.borderRadiusSM,
    borderRadiusSM: token2.borderRadiusXS,
    controlHeight: token2.controlHeightSM
  });
  const largeToken = merge2(token2, {
    fontHeight: calc(token2.multipleItemHeightLG).sub(calc(lineWidth).mul(2).equal()).equal(),
    fontSize: token2.fontSizeLG,
    selectHeight: token2.controlHeightLG,
    multipleSelectItemHeight: token2.multipleItemHeightLG,
    borderRadius: token2.borderRadiusLG,
    borderRadiusSM: token2.borderRadius,
    controlHeight: token2.controlHeightLG
  });
  return [
    // ======================== Size ========================
    genSize(smallToken, "small"),
    genSize(token2),
    genSize(largeToken, "large"),
    // ====================== Selection ======================
    {
      [`${componentCls}${componentCls}-multiple`]: Object.assign(Object.assign({
        width: "100%",
        cursor: "text",
        // ==================== Selector =====================
        [`${componentCls}-selector`]: {
          flex: "auto",
          padding: 0,
          position: "relative",
          "&:after": {
            margin: 0
          },
          // ================== placeholder ==================
          [`${componentCls}-selection-placeholder`]: {
            position: "absolute",
            top: "50%",
            insetInlineStart: token2.inputPaddingHorizontalBase,
            insetInlineEnd: 0,
            transform: "translateY(-50%)",
            transition: `all ${token2.motionDurationSlow}`,
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            flex: 1,
            color: token2.colorTextPlaceholder,
            pointerEvents: "none"
          }
        }
      }, genOverflowStyle(token2)), {
        // ====================== Input ======================
        // Input is `readonly`, which is used for a11y only
        [`${componentCls}-multiple-input`]: {
          width: 0,
          height: 0,
          border: 0,
          visibility: "hidden",
          position: "absolute",
          zIndex: -1
        }
      })
    }
  ];
};
var multiple_default2 = genPickerMultipleStyle;

// ../../node_modules/antd/es/date-picker/style/panel.js
var genPickerCellInnerStyle = (token2) => {
  const {
    pickerCellCls,
    pickerCellInnerCls,
    cellHeight,
    borderRadiusSM,
    motionDurationMid,
    cellHoverBg,
    lineWidth,
    lineType,
    colorPrimary,
    cellActiveWithRangeBg,
    colorTextLightSolid,
    colorTextDisabled,
    cellBgDisabled,
    colorFillSecondary
  } = token2;
  return {
    "&::before": {
      position: "absolute",
      top: "50%",
      insetInlineStart: 0,
      insetInlineEnd: 0,
      zIndex: 1,
      height: cellHeight,
      transform: "translateY(-50%)",
      content: '""',
      pointerEvents: "none"
    },
    // >>> Default
    [pickerCellInnerCls]: {
      position: "relative",
      zIndex: 2,
      display: "inline-block",
      minWidth: cellHeight,
      height: cellHeight,
      lineHeight: unit(cellHeight),
      borderRadius: borderRadiusSM,
      transition: `background ${motionDurationMid}`
    },
    // >>> Hover
    [`&:hover:not(${pickerCellCls}-in-view):not(${pickerCellCls}-disabled),
    &:hover:not(${pickerCellCls}-selected):not(${pickerCellCls}-range-start):not(${pickerCellCls}-range-end):not(${pickerCellCls}-disabled)`]: {
      [pickerCellInnerCls]: {
        background: cellHoverBg
      }
    },
    // >>> Today
    [`&-in-view${pickerCellCls}-today ${pickerCellInnerCls}`]: {
      "&::before": {
        position: "absolute",
        top: 0,
        insetInlineEnd: 0,
        bottom: 0,
        insetInlineStart: 0,
        zIndex: 1,
        border: `${unit(lineWidth)} ${lineType} ${colorPrimary}`,
        borderRadius: borderRadiusSM,
        content: '""'
      }
    },
    // >>> In Range
    [`&-in-view${pickerCellCls}-in-range,
      &-in-view${pickerCellCls}-range-start,
      &-in-view${pickerCellCls}-range-end`]: {
      position: "relative",
      [`&:not(${pickerCellCls}-disabled):before`]: {
        background: cellActiveWithRangeBg
      }
    },
    // >>> Selected
    [`&-in-view${pickerCellCls}-selected,
      &-in-view${pickerCellCls}-range-start,
      &-in-view${pickerCellCls}-range-end`]: {
      [`&:not(${pickerCellCls}-disabled) ${pickerCellInnerCls}`]: {
        color: colorTextLightSolid,
        background: colorPrimary
      },
      [`&${pickerCellCls}-disabled ${pickerCellInnerCls}`]: {
        background: colorFillSecondary
      }
    },
    [`&-in-view${pickerCellCls}-range-start:not(${pickerCellCls}-disabled):before`]: {
      insetInlineStart: "50%"
    },
    [`&-in-view${pickerCellCls}-range-end:not(${pickerCellCls}-disabled):before`]: {
      insetInlineEnd: "50%"
    },
    // range start border-radius
    [`&-in-view${pickerCellCls}-range-start:not(${pickerCellCls}-range-end) ${pickerCellInnerCls}`]: {
      borderStartStartRadius: borderRadiusSM,
      borderEndStartRadius: borderRadiusSM,
      borderStartEndRadius: 0,
      borderEndEndRadius: 0
    },
    // range end border-radius
    [`&-in-view${pickerCellCls}-range-end:not(${pickerCellCls}-range-start) ${pickerCellInnerCls}`]: {
      borderStartStartRadius: 0,
      borderEndStartRadius: 0,
      borderStartEndRadius: borderRadiusSM,
      borderEndEndRadius: borderRadiusSM
    },
    // >>> Disabled
    "&-disabled": {
      color: colorTextDisabled,
      cursor: "not-allowed",
      [pickerCellInnerCls]: {
        background: "transparent"
      },
      "&::before": {
        background: cellBgDisabled
      }
    },
    [`&-disabled${pickerCellCls}-today ${pickerCellInnerCls}::before`]: {
      borderColor: colorTextDisabled
    }
  };
};
var genPanelStyle = (token2) => {
  const {
    componentCls,
    pickerCellCls,
    pickerCellInnerCls,
    pickerYearMonthCellWidth,
    pickerControlIconSize,
    cellWidth,
    paddingSM,
    paddingXS,
    paddingXXS,
    colorBgContainer,
    lineWidth,
    lineType,
    borderRadiusLG,
    colorPrimary,
    colorTextHeading,
    colorSplit,
    pickerControlIconBorderWidth,
    colorIcon,
    textHeight,
    motionDurationMid,
    colorIconHover,
    fontWeightStrong,
    cellHeight,
    pickerCellPaddingVertical,
    colorTextDisabled,
    colorText,
    fontSize,
    motionDurationSlow,
    withoutTimeCellHeight,
    pickerQuarterPanelContentHeight,
    borderRadiusSM,
    colorTextLightSolid,
    cellHoverBg,
    timeColumnHeight,
    timeColumnWidth,
    timeCellHeight,
    controlItemBgActive,
    marginXXS,
    pickerDatePanelPaddingHorizontal,
    pickerControlIconMargin
  } = token2;
  const pickerPanelWidth = token2.calc(cellWidth).mul(7).add(token2.calc(pickerDatePanelPaddingHorizontal).mul(2)).equal();
  return {
    [componentCls]: {
      "&-panel": {
        display: "inline-flex",
        flexDirection: "column",
        textAlign: "center",
        background: colorBgContainer,
        borderRadius: borderRadiusLG,
        outline: "none",
        "&-focused": {
          borderColor: colorPrimary
        },
        "&-rtl": {
          [`${componentCls}-prev-icon,
              ${componentCls}-super-prev-icon`]: {
            transform: "rotate(45deg)"
          },
          [`${componentCls}-next-icon,
              ${componentCls}-super-next-icon`]: {
            transform: "rotate(-135deg)"
          },
          [`${componentCls}-time-panel`]: {
            [`${componentCls}-content`]: {
              direction: "ltr",
              "> *": {
                direction: "rtl"
              }
            }
          }
        }
      },
      // ========================================================
      // =                     Shared Panel                     =
      // ========================================================
      [`&-decade-panel,
        &-year-panel,
        &-quarter-panel,
        &-month-panel,
        &-week-panel,
        &-date-panel,
        &-time-panel`]: {
        display: "flex",
        flexDirection: "column",
        width: pickerPanelWidth
      },
      // ======================= Header =======================
      "&-header": {
        display: "flex",
        padding: `0 ${unit(paddingXS)}`,
        color: colorTextHeading,
        borderBottom: `${unit(lineWidth)} ${lineType} ${colorSplit}`,
        "> *": {
          flex: "none"
        },
        button: {
          padding: 0,
          color: colorIcon,
          lineHeight: unit(textHeight),
          background: "transparent",
          border: 0,
          cursor: "pointer",
          transition: `color ${motionDurationMid}`,
          fontSize: "inherit",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          "&:empty": {
            display: "none"
          }
        },
        "> button": {
          minWidth: "1.6em",
          fontSize,
          "&:hover": {
            color: colorIconHover
          },
          "&:disabled": {
            opacity: 0.25,
            pointerEvents: "none"
          }
        },
        "&-view": {
          flex: "auto",
          fontWeight: fontWeightStrong,
          lineHeight: unit(textHeight),
          "> button": {
            color: "inherit",
            fontWeight: "inherit",
            verticalAlign: "top",
            "&:not(:first-child)": {
              marginInlineStart: paddingXS
            },
            "&:hover": {
              color: colorPrimary
            }
          }
        }
      },
      // Arrow button
      [`&-prev-icon,
        &-next-icon,
        &-super-prev-icon,
        &-super-next-icon`]: {
        position: "relative",
        width: pickerControlIconSize,
        height: pickerControlIconSize,
        "&::before": {
          position: "absolute",
          top: 0,
          insetInlineStart: 0,
          width: pickerControlIconSize,
          height: pickerControlIconSize,
          border: `0 solid currentcolor`,
          borderBlockStartWidth: pickerControlIconBorderWidth,
          borderInlineStartWidth: pickerControlIconBorderWidth,
          content: '""'
        }
      },
      [`&-super-prev-icon,
        &-super-next-icon`]: {
        "&::after": {
          position: "absolute",
          top: pickerControlIconMargin,
          insetInlineStart: pickerControlIconMargin,
          display: "inline-block",
          width: pickerControlIconSize,
          height: pickerControlIconSize,
          border: "0 solid currentcolor",
          borderBlockStartWidth: pickerControlIconBorderWidth,
          borderInlineStartWidth: pickerControlIconBorderWidth,
          content: '""'
        }
      },
      "&-prev-icon, &-super-prev-icon": {
        transform: "rotate(-45deg)"
      },
      "&-next-icon, &-super-next-icon": {
        transform: "rotate(135deg)"
      },
      // ======================== Body ========================
      "&-content": {
        width: "100%",
        tableLayout: "fixed",
        borderCollapse: "collapse",
        "th, td": {
          position: "relative",
          minWidth: cellHeight,
          fontWeight: "normal"
        },
        th: {
          height: token2.calc(cellHeight).add(token2.calc(pickerCellPaddingVertical).mul(2)).equal(),
          color: colorText,
          verticalAlign: "middle"
        }
      },
      "&-cell": Object.assign({
        padding: `${unit(pickerCellPaddingVertical)} 0`,
        color: colorTextDisabled,
        cursor: "pointer",
        // In view
        "&-in-view": {
          color: colorText
        }
      }, genPickerCellInnerStyle(token2)),
      [`&-decade-panel,
        &-year-panel,
        &-quarter-panel,
        &-month-panel`]: {
        [`${componentCls}-content`]: {
          height: token2.calc(withoutTimeCellHeight).mul(4).equal()
        },
        [pickerCellInnerCls]: {
          padding: `0 ${unit(paddingXS)}`
        }
      },
      "&-quarter-panel": {
        [`${componentCls}-content`]: {
          height: pickerQuarterPanelContentHeight
        }
      },
      // ========================================================
      // =                       Special                        =
      // ========================================================
      // ===================== Decade Panel =====================
      "&-decade-panel": {
        [pickerCellInnerCls]: {
          padding: `0 ${unit(token2.calc(paddingXS).div(2).equal())}`
        },
        [`${componentCls}-cell::before`]: {
          display: "none"
        }
      },
      // ============= Year & Quarter & Month Panel =============
      [`&-year-panel,
        &-quarter-panel,
        &-month-panel`]: {
        [`${componentCls}-body`]: {
          padding: `0 ${unit(paddingXS)}`
        },
        [pickerCellInnerCls]: {
          width: pickerYearMonthCellWidth
        }
      },
      // ====================== Date Panel ======================
      "&-date-panel": {
        [`${componentCls}-body`]: {
          padding: `${unit(paddingXS)} ${unit(pickerDatePanelPaddingHorizontal)}`
        },
        [`${componentCls}-content th`]: {
          boxSizing: "border-box",
          padding: 0
        }
      },
      // ====================== Week Panel ======================
      "&-week-panel-row": {
        td: {
          "&:before": {
            transition: `background ${motionDurationMid}`
          },
          "&:first-child:before": {
            borderStartStartRadius: borderRadiusSM,
            borderEndStartRadius: borderRadiusSM
          },
          "&:last-child:before": {
            borderStartEndRadius: borderRadiusSM,
            borderEndEndRadius: borderRadiusSM
          }
        },
        "&:hover td:before": {
          background: cellHoverBg
        },
        "&-range-start td, &-range-end td, &-selected td, &-hover td": {
          // Rise priority to override hover style
          [`&${pickerCellCls}`]: {
            "&:before": {
              background: colorPrimary
            },
            [`&${componentCls}-cell-week`]: {
              color: new FastColor(colorTextLightSolid).setA(0.5).toHexString()
            },
            [pickerCellInnerCls]: {
              color: colorTextLightSolid
            }
          }
        },
        "&-range-hover td:before": {
          background: controlItemBgActive
        }
      },
      // >>> ShowWeek
      "&-week-panel, &-date-panel-show-week": {
        [`${componentCls}-body`]: {
          padding: `${unit(paddingXS)} ${unit(paddingSM)}`
        },
        [`${componentCls}-content th`]: {
          width: "auto"
        }
      },
      // ==================== Datetime Panel ====================
      "&-datetime-panel": {
        display: "flex",
        [`${componentCls}-time-panel`]: {
          borderInlineStart: `${unit(lineWidth)} ${lineType} ${colorSplit}`
        },
        [`${componentCls}-date-panel,
          ${componentCls}-time-panel`]: {
          transition: `opacity ${motionDurationSlow}`
        },
        // Keyboard
        "&-active": {
          [`${componentCls}-date-panel,
            ${componentCls}-time-panel`]: {
            opacity: 0.3,
            "&-active": {
              opacity: 1
            }
          }
        }
      },
      // ====================== Time Panel ======================
      "&-time-panel": {
        width: "auto",
        minWidth: "auto",
        [`${componentCls}-content`]: {
          display: "flex",
          flex: "auto",
          height: timeColumnHeight
        },
        "&-column": {
          flex: "1 0 auto",
          width: timeColumnWidth,
          margin: `${unit(paddingXXS)} 0`,
          padding: 0,
          overflowY: "hidden",
          textAlign: "start",
          listStyle: "none",
          transition: `background ${motionDurationMid}`,
          overflowX: "hidden",
          "&::-webkit-scrollbar": {
            width: 8,
            backgroundColor: "transparent"
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: token2.colorTextTertiary,
            borderRadius: token2.borderRadiusSM
          },
          // For Firefox
          "&": {
            scrollbarWidth: "thin",
            scrollbarColor: `${token2.colorTextTertiary} transparent`
          },
          "&::after": {
            display: "block",
            height: `calc(100% - ${unit(timeCellHeight)})`,
            content: '""'
          },
          "&:not(:first-child)": {
            borderInlineStart: `${unit(lineWidth)} ${lineType} ${colorSplit}`
          },
          "&-active": {
            background: new FastColor(controlItemBgActive).setA(0.2).toHexString()
          },
          "&:hover": {
            overflowY: "auto"
          },
          "> li": {
            margin: 0,
            padding: 0,
            [`&${componentCls}-time-panel-cell`]: {
              marginInline: marginXXS,
              [`${componentCls}-time-panel-cell-inner`]: {
                display: "block",
                width: token2.calc(timeColumnWidth).sub(token2.calc(marginXXS).mul(2)).equal(),
                height: timeCellHeight,
                margin: 0,
                paddingBlock: 0,
                paddingInlineEnd: 0,
                paddingInlineStart: token2.calc(timeColumnWidth).sub(timeCellHeight).div(2).equal(),
                color: colorText,
                lineHeight: unit(timeCellHeight),
                borderRadius: borderRadiusSM,
                cursor: "pointer",
                transition: `background ${motionDurationMid}`,
                "&:hover": {
                  background: cellHoverBg
                }
              },
              "&-selected": {
                [`${componentCls}-time-panel-cell-inner`]: {
                  background: controlItemBgActive
                }
              },
              "&-disabled": {
                [`${componentCls}-time-panel-cell-inner`]: {
                  color: colorTextDisabled,
                  background: "transparent",
                  cursor: "not-allowed"
                }
              }
            }
          }
        }
      }
    }
  };
};
var genPickerPanelStyle = (token2) => {
  const {
    componentCls,
    textHeight,
    lineWidth,
    paddingSM,
    antCls,
    colorPrimary,
    cellActiveWithRangeBg,
    colorPrimaryBorder,
    lineType,
    colorSplit
  } = token2;
  return {
    [`${componentCls}-dropdown`]: {
      // ======================== Footer ========================
      [`${componentCls}-footer`]: {
        borderTop: `${unit(lineWidth)} ${lineType} ${colorSplit}`,
        "&-extra": {
          padding: `0 ${unit(paddingSM)}`,
          lineHeight: unit(token2.calc(textHeight).sub(token2.calc(lineWidth).mul(2)).equal()),
          textAlign: "start",
          "&:not(:last-child)": {
            borderBottom: `${unit(lineWidth)} ${lineType} ${colorSplit}`
          }
        }
      },
      // ==================== Footer > Ranges ===================
      [`${componentCls}-panels + ${componentCls}-footer ${componentCls}-ranges`]: {
        justifyContent: "space-between"
      },
      [`${componentCls}-ranges`]: {
        marginBlock: 0,
        paddingInline: unit(paddingSM),
        overflow: "hidden",
        textAlign: "start",
        listStyle: "none",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        "> li": {
          lineHeight: unit(token2.calc(textHeight).sub(token2.calc(lineWidth).mul(2)).equal()),
          display: "inline-block"
        },
        [`${componentCls}-now-btn-disabled`]: {
          pointerEvents: "none",
          color: token2.colorTextDisabled
        },
        // https://github.com/ant-design/ant-design/issues/23687
        [`${componentCls}-preset > ${antCls}-tag-blue`]: {
          color: colorPrimary,
          background: cellActiveWithRangeBg,
          borderColor: colorPrimaryBorder,
          cursor: "pointer"
        },
        [`${componentCls}-ok`]: {
          paddingBlock: token2.calc(lineWidth).mul(2).equal(),
          marginInlineStart: "auto"
        }
      }
    }
  };
};
var panel_default = genPickerPanelStyle;

// ../../node_modules/antd/es/date-picker/style/token.js
var initPickerPanelToken = (token2) => {
  const {
    componentCls,
    controlHeightLG,
    paddingXXS,
    padding
  } = token2;
  return {
    pickerCellCls: `${componentCls}-cell`,
    pickerCellInnerCls: `${componentCls}-cell-inner`,
    pickerYearMonthCellWidth: token2.calc(controlHeightLG).mul(1.5).equal(),
    pickerQuarterPanelContentHeight: token2.calc(controlHeightLG).mul(1.4).equal(),
    pickerCellPaddingVertical: token2.calc(paddingXXS).add(token2.calc(paddingXXS).div(2)).equal(),
    pickerCellBorderGap: 2,
    // Magic for gap between cells
    pickerControlIconSize: 7,
    pickerControlIconMargin: 4,
    pickerControlIconBorderWidth: 1.5,
    pickerDatePanelPaddingHorizontal: token2.calc(padding).add(token2.calc(paddingXXS).div(2)).equal()
    // 18 in normal
  };
};
var initPanelComponentToken = (token2) => {
  const {
    colorBgContainerDisabled,
    controlHeight,
    controlHeightSM,
    controlHeightLG,
    paddingXXS,
    lineWidth
  } = token2;
  const dblPaddingXXS = paddingXXS * 2;
  const dblLineWidth = lineWidth * 2;
  const multipleItemHeight = Math.min(controlHeight - dblPaddingXXS, controlHeight - dblLineWidth);
  const multipleItemHeightSM = Math.min(controlHeightSM - dblPaddingXXS, controlHeightSM - dblLineWidth);
  const multipleItemHeightLG = Math.min(controlHeightLG - dblPaddingXXS, controlHeightLG - dblLineWidth);
  const INTERNAL_FIXED_ITEM_MARGIN = Math.floor(paddingXXS / 2);
  const filledToken = {
    INTERNAL_FIXED_ITEM_MARGIN,
    cellHoverBg: token2.controlItemBgHover,
    cellActiveWithRangeBg: token2.controlItemBgActive,
    cellHoverWithRangeBg: new FastColor(token2.colorPrimary).lighten(35).toHexString(),
    cellRangeBorderColor: new FastColor(token2.colorPrimary).lighten(20).toHexString(),
    cellBgDisabled: colorBgContainerDisabled,
    timeColumnWidth: controlHeightLG * 1.4,
    timeColumnHeight: 28 * 8,
    timeCellHeight: 28,
    cellWidth: controlHeightSM * 1.5,
    cellHeight: controlHeightSM,
    textHeight: controlHeightLG,
    withoutTimeCellHeight: controlHeightLG * 1.65,
    multipleItemBg: token2.colorFillSecondary,
    multipleItemBorderColor: "transparent",
    multipleItemHeight,
    multipleItemHeightSM,
    multipleItemHeightLG,
    multipleSelectorBgDisabled: colorBgContainerDisabled,
    multipleItemColorDisabled: token2.colorTextDisabled,
    multipleItemBorderColorDisabled: "transparent"
  };
  return filledToken;
};
var prepareComponentToken13 = (token2) => Object.assign(Object.assign(Object.assign(Object.assign({}, initComponentToken(token2)), initPanelComponentToken(token2)), getArrowToken(token2)), {
  presetsWidth: 120,
  presetsMaxWidth: 200,
  zIndexPopup: token2.zIndexPopupBase + 50
});

// ../../node_modules/antd/es/date-picker/style/variants.js
var genVariantsStyle2 = (token2) => {
  const {
    componentCls
  } = token2;
  return {
    [componentCls]: [
      Object.assign(Object.assign(Object.assign(Object.assign({}, genOutlinedStyle2(token2)), genUnderlinedStyle2(token2)), genFilledStyle2(token2)), genBorderlessStyle3(token2)),
      // ========================= Multiple =========================
      {
        "&-outlined": {
          [`&${componentCls}-multiple ${componentCls}-selection-item`]: {
            background: token2.multipleItemBg,
            border: `${unit(token2.lineWidth)} ${token2.lineType} ${token2.multipleItemBorderColor}`
          }
        },
        "&-filled": {
          [`&${componentCls}-multiple ${componentCls}-selection-item`]: {
            background: token2.colorBgContainer,
            border: `${unit(token2.lineWidth)} ${token2.lineType} ${token2.colorSplit}`
          }
        },
        "&-borderless": {
          [`&${componentCls}-multiple ${componentCls}-selection-item`]: {
            background: token2.multipleItemBg,
            border: `${unit(token2.lineWidth)} ${token2.lineType} ${token2.multipleItemBorderColor}`
          }
        },
        "&-underlined": {
          [`&${componentCls}-multiple ${componentCls}-selection-item`]: {
            background: token2.multipleItemBg,
            border: `${unit(token2.lineWidth)} ${token2.lineType} ${token2.multipleItemBorderColor}`
          }
        }
      }
    ]
  };
};
var variants_default2 = genVariantsStyle2;

// ../../node_modules/antd/es/date-picker/style/index.js
var genPickerPadding = (paddingBlock, paddingInline) => {
  return {
    padding: `${unit(paddingBlock)} ${unit(paddingInline)}`
  };
};
var genPickerStatusStyle = (token2) => {
  const {
    componentCls,
    colorError,
    colorWarning
  } = token2;
  return {
    [`${componentCls}:not(${componentCls}-disabled):not([disabled])`]: {
      [`&${componentCls}-status-error`]: {
        [`${componentCls}-active-bar`]: {
          background: colorError
        }
      },
      [`&${componentCls}-status-warning`]: {
        [`${componentCls}-active-bar`]: {
          background: colorWarning
        }
      }
    }
  };
};
var genPickerStyle = (token2) => {
  var _a;
  const {
    componentCls,
    antCls,
    paddingInline,
    lineWidth,
    lineType,
    colorBorder,
    borderRadius,
    motionDurationMid,
    colorTextDisabled,
    colorTextPlaceholder,
    fontSizeLG,
    inputFontSizeLG,
    fontSizeSM,
    inputFontSizeSM,
    controlHeightSM,
    paddingInlineSM,
    paddingXS,
    marginXS,
    colorIcon,
    lineWidthBold,
    colorPrimary,
    motionDurationSlow,
    zIndexPopup,
    paddingXXS,
    sizePopupArrow,
    colorBgElevated,
    borderRadiusLG,
    boxShadowSecondary,
    borderRadiusSM,
    colorSplit,
    cellHoverBg,
    presetsWidth,
    presetsMaxWidth,
    boxShadowPopoverArrow,
    fontHeight,
    lineHeightLG
  } = token2;
  return [
    {
      [componentCls]: Object.assign(Object.assign(Object.assign({}, resetComponent(token2)), genPickerPadding(token2.paddingBlock, token2.paddingInline)), {
        position: "relative",
        display: "inline-flex",
        alignItems: "center",
        lineHeight: 1,
        borderRadius,
        transition: `border ${motionDurationMid}, box-shadow ${motionDurationMid}, background ${motionDurationMid}`,
        [`${componentCls}-prefix`]: {
          flex: "0 0 auto",
          marginInlineEnd: token2.inputAffixPadding
        },
        // ======================== Input =========================
        [`${componentCls}-input`]: {
          position: "relative",
          display: "inline-flex",
          alignItems: "center",
          width: "100%",
          "> input": Object.assign(Object.assign({
            position: "relative",
            display: "inline-block",
            width: "100%",
            color: "inherit",
            fontSize: (_a = token2.inputFontSize) !== null && _a !== void 0 ? _a : token2.fontSize,
            lineHeight: token2.lineHeight,
            transition: `all ${motionDurationMid}`
          }, genPlaceholderStyle(colorTextPlaceholder)), {
            flex: "auto",
            // Fix Firefox flex not correct:
            // https://github.com/ant-design/ant-design/pull/20023#issuecomment-564389553
            minWidth: 1,
            height: "auto",
            padding: 0,
            background: "transparent",
            border: 0,
            fontFamily: "inherit",
            "&:focus": {
              boxShadow: "none",
              outline: 0
            },
            "&[disabled]": {
              background: "transparent",
              color: colorTextDisabled,
              cursor: "not-allowed"
            }
          }),
          "&-placeholder": {
            "> input": {
              color: colorTextPlaceholder
            }
          }
        },
        // Size
        "&-large": Object.assign(Object.assign({}, genPickerPadding(token2.paddingBlockLG, token2.paddingInlineLG)), {
          [`${componentCls}-input > input`]: {
            fontSize: inputFontSizeLG !== null && inputFontSizeLG !== void 0 ? inputFontSizeLG : fontSizeLG,
            lineHeight: lineHeightLG
          }
        }),
        "&-small": Object.assign(Object.assign({}, genPickerPadding(token2.paddingBlockSM, token2.paddingInlineSM)), {
          [`${componentCls}-input > input`]: {
            fontSize: inputFontSizeSM !== null && inputFontSizeSM !== void 0 ? inputFontSizeSM : fontSizeSM
          }
        }),
        [`${componentCls}-suffix`]: {
          display: "flex",
          flex: "none",
          alignSelf: "center",
          marginInlineStart: token2.calc(paddingXS).div(2).equal(),
          color: colorTextDisabled,
          lineHeight: 1,
          pointerEvents: "none",
          transition: `opacity ${motionDurationMid}, color ${motionDurationMid}`,
          "> *": {
            verticalAlign: "top",
            "&:not(:last-child)": {
              marginInlineEnd: marginXS
            }
          }
        },
        [`${componentCls}-clear`]: {
          position: "absolute",
          top: "50%",
          insetInlineEnd: 0,
          color: colorTextDisabled,
          lineHeight: 1,
          transform: "translateY(-50%)",
          cursor: "pointer",
          opacity: 0,
          transition: `opacity ${motionDurationMid}, color ${motionDurationMid}`,
          "> *": {
            verticalAlign: "top"
          },
          "&:hover": {
            color: colorIcon
          }
        },
        "&:hover": {
          [`${componentCls}-clear`]: {
            opacity: 1
          },
          // Should use the following selector, but since `:has` has poor compatibility,
          // we use `:not(:last-child)` instead, which may cause some problems in some cases.
          // [`${componentCls}-suffix:has(+ ${componentCls}-clear)`]: {
          [`${componentCls}-suffix:not(:last-child)`]: {
            opacity: 0
          }
        },
        [`${componentCls}-separator`]: {
          position: "relative",
          display: "inline-block",
          width: "1em",
          height: fontSizeLG,
          color: colorTextDisabled,
          fontSize: fontSizeLG,
          verticalAlign: "top",
          cursor: "default",
          [`${componentCls}-focused &`]: {
            color: colorIcon
          },
          [`${componentCls}-range-separator &`]: {
            [`${componentCls}-disabled &`]: {
              cursor: "not-allowed"
            }
          }
        },
        // ======================== Range =========================
        "&-range": {
          position: "relative",
          display: "inline-flex",
          // Active bar
          [`${componentCls}-active-bar`]: {
            bottom: token2.calc(lineWidth).mul(-1).equal(),
            height: lineWidthBold,
            background: colorPrimary,
            opacity: 0,
            transition: `all ${motionDurationSlow} ease-out`,
            pointerEvents: "none"
          },
          [`&${componentCls}-focused`]: {
            [`${componentCls}-active-bar`]: {
              opacity: 1
            }
          },
          [`${componentCls}-range-separator`]: {
            alignItems: "center",
            padding: `0 ${unit(paddingXS)}`,
            lineHeight: 1
          }
        },
        // ======================== Clear =========================
        "&-range, &-multiple": {
          // Clear
          [`${componentCls}-clear`]: {
            insetInlineEnd: paddingInline
          },
          [`&${componentCls}-small`]: {
            [`${componentCls}-clear`]: {
              insetInlineEnd: paddingInlineSM
            }
          }
        },
        // ======================= Dropdown =======================
        "&-dropdown": Object.assign(Object.assign(Object.assign({}, resetComponent(token2)), genPanelStyle(token2)), {
          pointerEvents: "none",
          position: "absolute",
          // Fix incorrect position of picker popup
          // https://github.com/ant-design/ant-design/issues/35590
          top: -9999,
          left: {
            _skip_check_: true,
            value: -9999
          },
          zIndex: zIndexPopup,
          [`&${componentCls}-dropdown-hidden`]: {
            display: "none"
          },
          "&-rtl": {
            direction: "rtl"
          },
          [`&${componentCls}-dropdown-placement-bottomLeft,
            &${componentCls}-dropdown-placement-bottomRight`]: {
            [`${componentCls}-range-arrow`]: {
              top: 0,
              display: "block",
              transform: "translateY(-100%)"
            }
          },
          [`&${componentCls}-dropdown-placement-topLeft,
            &${componentCls}-dropdown-placement-topRight`]: {
            [`${componentCls}-range-arrow`]: {
              bottom: 0,
              display: "block",
              transform: "translateY(100%) rotate(180deg)"
            }
          },
          [`&${antCls}-slide-up-appear, &${antCls}-slide-up-enter`]: {
            [`${componentCls}-range-arrow${componentCls}-range-arrow`]: {
              transition: "none"
            }
          },
          [`&${antCls}-slide-up-enter${antCls}-slide-up-enter-active${componentCls}-dropdown-placement-topLeft,
          &${antCls}-slide-up-enter${antCls}-slide-up-enter-active${componentCls}-dropdown-placement-topRight,
          &${antCls}-slide-up-appear${antCls}-slide-up-appear-active${componentCls}-dropdown-placement-topLeft,
          &${antCls}-slide-up-appear${antCls}-slide-up-appear-active${componentCls}-dropdown-placement-topRight`]: {
            animationName: slideDownIn
          },
          [`&${antCls}-slide-up-enter${antCls}-slide-up-enter-active${componentCls}-dropdown-placement-bottomLeft,
          &${antCls}-slide-up-enter${antCls}-slide-up-enter-active${componentCls}-dropdown-placement-bottomRight,
          &${antCls}-slide-up-appear${antCls}-slide-up-appear-active${componentCls}-dropdown-placement-bottomLeft,
          &${antCls}-slide-up-appear${antCls}-slide-up-appear-active${componentCls}-dropdown-placement-bottomRight`]: {
            animationName: slideUpIn
          },
          // https://github.com/ant-design/ant-design/issues/48727
          [`&${antCls}-slide-up-leave ${componentCls}-panel-container`]: {
            pointerEvents: "none"
          },
          [`&${antCls}-slide-up-leave${antCls}-slide-up-leave-active${componentCls}-dropdown-placement-topLeft,
          &${antCls}-slide-up-leave${antCls}-slide-up-leave-active${componentCls}-dropdown-placement-topRight`]: {
            animationName: slideDownOut
          },
          [`&${antCls}-slide-up-leave${antCls}-slide-up-leave-active${componentCls}-dropdown-placement-bottomLeft,
          &${antCls}-slide-up-leave${antCls}-slide-up-leave-active${componentCls}-dropdown-placement-bottomRight`]: {
            animationName: slideUpOut
          },
          // Time picker with additional style
          [`${componentCls}-panel > ${componentCls}-time-panel`]: {
            paddingTop: paddingXXS
          },
          // ======================== Ranges ========================
          [`${componentCls}-range-wrapper`]: {
            display: "flex",
            position: "relative"
          },
          [`${componentCls}-range-arrow`]: Object.assign(Object.assign({
            position: "absolute",
            zIndex: 1,
            display: "none",
            paddingInline: token2.calc(paddingInline).mul(1.5).equal(),
            boxSizing: "content-box",
            transition: `all ${motionDurationSlow} ease-out`
          }, genRoundedArrow(token2, colorBgElevated, boxShadowPopoverArrow)), {
            "&:before": {
              insetInlineStart: token2.calc(paddingInline).mul(1.5).equal()
            }
          }),
          [`${componentCls}-panel-container`]: {
            overflow: "hidden",
            verticalAlign: "top",
            background: colorBgElevated,
            borderRadius: borderRadiusLG,
            boxShadow: boxShadowSecondary,
            transition: `margin ${motionDurationSlow}`,
            display: "inline-block",
            pointerEvents: "auto",
            // ======================== Layout ========================
            [`${componentCls}-panel-layout`]: {
              display: "flex",
              flexWrap: "nowrap",
              alignItems: "stretch"
            },
            // ======================== Preset ========================
            [`${componentCls}-presets`]: {
              display: "flex",
              flexDirection: "column",
              minWidth: presetsWidth,
              maxWidth: presetsMaxWidth,
              ul: {
                height: 0,
                flex: "auto",
                listStyle: "none",
                overflow: "auto",
                margin: 0,
                padding: paddingXS,
                borderInlineEnd: `${unit(lineWidth)} ${lineType} ${colorSplit}`,
                li: Object.assign(Object.assign({}, textEllipsis), {
                  borderRadius: borderRadiusSM,
                  paddingInline: paddingXS,
                  paddingBlock: token2.calc(controlHeightSM).sub(fontHeight).div(2).equal(),
                  cursor: "pointer",
                  transition: `all ${motionDurationSlow}`,
                  "+ li": {
                    marginTop: marginXS
                  },
                  "&:hover": {
                    background: cellHoverBg
                  }
                })
              }
            },
            // ======================== Panels ========================
            [`${componentCls}-panels`]: {
              display: "inline-flex",
              flexWrap: "nowrap",
              // [`${componentCls}-panel`]: {
              //   borderWidth: `0 0 ${unit(lineWidth)}`,
              // },
              "&:last-child": {
                [`${componentCls}-panel`]: {
                  borderWidth: 0
                }
              }
            },
            [`${componentCls}-panel`]: {
              verticalAlign: "top",
              background: "transparent",
              borderRadius: 0,
              borderWidth: 0,
              [`${componentCls}-content, table`]: {
                textAlign: "center"
              },
              "&-focused": {
                borderColor: colorBorder
              }
            }
          }
        }),
        "&-dropdown-range": {
          padding: `${unit(token2.calc(sizePopupArrow).mul(2).div(3).equal())} 0`,
          "&-hidden": {
            display: "none"
          }
        },
        "&-rtl": {
          direction: "rtl",
          [`${componentCls}-separator`]: {
            transform: "scale(-1, 1)"
          },
          [`${componentCls}-footer`]: {
            "&-extra": {
              direction: "rtl"
            }
          }
        }
      })
    },
    // Follow code may reuse in other components
    initSlideMotion(token2, "slide-up"),
    initSlideMotion(token2, "slide-down"),
    initMoveMotion(token2, "move-up"),
    initMoveMotion(token2, "move-down")
  ];
};
var style_default17 = genStyleHooks("DatePicker", (token2) => {
  const pickerToken = merge2(initInputToken(token2), initPickerPanelToken(token2), {
    inputPaddingHorizontalBase: token2.calc(token2.paddingSM).sub(1).equal(),
    multipleSelectItemHeight: token2.multipleItemHeight,
    selectHeight: token2.controlHeight
  });
  return [
    panel_default(pickerToken),
    genPickerStyle(pickerToken),
    variants_default2(pickerToken),
    genPickerStatusStyle(pickerToken),
    multiple_default2(pickerToken),
    // =====================================================
    // ==             Space Compact                       ==
    // =====================================================
    genCompactItemStyle(token2, {
      focusElCls: `${token2.componentCls}-focused`
    })
  ];
}, prepareComponentToken13);

// ../../node_modules/antd/es/card/Card.js
var React297 = __toESM(require_react());
var import_classnames102 = __toESM(require_classnames());

// ../../node_modules/antd/es/tabs/index.js
var React295 = __toESM(require_react());

// ../../node_modules/@ant-design/icons/es/icons/PlusOutlined.js
var React281 = __toESM(require_react());

// ../../node_modules/@ant-design/icons-svg/es/asn/PlusOutlined.js
var PlusOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8z" } }, { "tag": "path", "attrs": { "d": "M192 474h672q8 0 8 8v60q0 8-8 8H160q-8 0-8-8v-60q0-8 8-8z" } }] }, "name": "plus", "theme": "outlined" };
var PlusOutlined_default = PlusOutlined;

// ../../node_modules/@ant-design/icons/es/icons/PlusOutlined.js
var PlusOutlined2 = function PlusOutlined3(props, ref3) {
  return /* @__PURE__ */ React281.createElement(AntdIcon_default, _extends({}, props, {
    ref: ref3,
    icon: PlusOutlined_default
  }));
};
var RefIcon14 = /* @__PURE__ */ React281.forwardRef(PlusOutlined2);
if (true) {
  RefIcon14.displayName = "PlusOutlined";
}
var PlusOutlined_default2 = RefIcon14;

// ../../node_modules/antd/es/tabs/index.js
var import_classnames100 = __toESM(require_classnames());

// ../../node_modules/rc-tabs/es/Tabs.js
var import_classnames99 = __toESM(require_classnames());
var React293 = __toESM(require_react());
var import_react96 = __toESM(require_react());

// ../../node_modules/rc-tabs/es/TabContext.js
var import_react88 = __toESM(require_react());
var TabContext_default = /* @__PURE__ */ (0, import_react88.createContext)(null);

// ../../node_modules/rc-tabs/es/TabNavList/Wrapper.js
var React291 = __toESM(require_react());

// ../../node_modules/rc-tabs/es/TabNavList/index.js
var import_classnames96 = __toESM(require_classnames());
var React289 = __toESM(require_react());
var import_react95 = __toESM(require_react());

// ../../node_modules/rc-tabs/es/hooks/useIndicator.js
var import_react89 = __toESM(require_react());
var useIndicator = function useIndicator2(options) {
  var activeTabOffset = options.activeTabOffset, horizontal = options.horizontal, rtl = options.rtl, _options$indicator = options.indicator, indicator = _options$indicator === void 0 ? {} : _options$indicator;
  var size = indicator.size, _indicator$align = indicator.align, align = _indicator$align === void 0 ? "center" : _indicator$align;
  var _useState = (0, import_react89.useState)(), _useState2 = _slicedToArray(_useState, 2), inkStyle = _useState2[0], setInkStyle = _useState2[1];
  var inkBarRafRef = (0, import_react89.useRef)();
  var getLength = import_react89.default.useCallback(function(origin) {
    if (typeof size === "function") {
      return size(origin);
    }
    if (typeof size === "number") {
      return size;
    }
    return origin;
  }, [size]);
  function cleanInkBarRaf() {
    raf_default.cancel(inkBarRafRef.current);
  }
  (0, import_react89.useEffect)(function() {
    var newInkStyle = {};
    if (activeTabOffset) {
      if (horizontal) {
        newInkStyle.width = getLength(activeTabOffset.width);
        var key2 = rtl ? "right" : "left";
        if (align === "start") {
          newInkStyle[key2] = activeTabOffset[key2];
        }
        if (align === "center") {
          newInkStyle[key2] = activeTabOffset[key2] + activeTabOffset.width / 2;
          newInkStyle.transform = rtl ? "translateX(50%)" : "translateX(-50%)";
        }
        if (align === "end") {
          newInkStyle[key2] = activeTabOffset[key2] + activeTabOffset.width;
          newInkStyle.transform = "translateX(-100%)";
        }
      } else {
        newInkStyle.height = getLength(activeTabOffset.height);
        if (align === "start") {
          newInkStyle.top = activeTabOffset.top;
        }
        if (align === "center") {
          newInkStyle.top = activeTabOffset.top + activeTabOffset.height / 2;
          newInkStyle.transform = "translateY(-50%)";
        }
        if (align === "end") {
          newInkStyle.top = activeTabOffset.top + activeTabOffset.height;
          newInkStyle.transform = "translateY(-100%)";
        }
      }
    }
    cleanInkBarRaf();
    inkBarRafRef.current = raf_default(function() {
      var isEqual2 = inkStyle && newInkStyle && Object.keys(newInkStyle).every(function(key3) {
        var newValue = newInkStyle[key3];
        var oldValue = inkStyle[key3];
        return typeof newValue === "number" && typeof oldValue === "number" ? Math.round(newValue) === Math.round(oldValue) : newValue === oldValue;
      });
      if (!isEqual2) {
        setInkStyle(newInkStyle);
      }
    });
    return cleanInkBarRaf;
  }, [JSON.stringify(activeTabOffset), horizontal, rtl, align, getLength]);
  return {
    style: inkStyle
  };
};
var useIndicator_default = useIndicator;

// ../../node_modules/rc-tabs/es/hooks/useOffsets.js
var import_react90 = __toESM(require_react());
var DEFAULT_SIZE = {
  width: 0,
  height: 0,
  left: 0,
  top: 0
};
function useOffsets(tabs, tabSizes, holderScrollWidth) {
  return (0, import_react90.useMemo)(function() {
    var _tabs$;
    var map = /* @__PURE__ */ new Map();
    var lastOffset = tabSizes.get((_tabs$ = tabs[0]) === null || _tabs$ === void 0 ? void 0 : _tabs$.key) || DEFAULT_SIZE;
    var rightOffset = lastOffset.left + lastOffset.width;
    for (var i = 0; i < tabs.length; i += 1) {
      var key2 = tabs[i].key;
      var data2 = tabSizes.get(key2);
      if (!data2) {
        var _tabs;
        data2 = tabSizes.get((_tabs = tabs[i - 1]) === null || _tabs === void 0 ? void 0 : _tabs.key) || DEFAULT_SIZE;
      }
      var entity = map.get(key2) || _objectSpread2({}, data2);
      entity.right = rightOffset - entity.left - entity.width;
      map.set(key2, entity);
    }
    return map;
  }, [tabs.map(function(tab) {
    return tab.key;
  }).join("_"), tabSizes, holderScrollWidth]);
}

// ../../node_modules/rc-tabs/es/hooks/useSyncState.js
var React283 = __toESM(require_react());
function useSyncState3(defaultState, onChange) {
  var stateRef = React283.useRef(defaultState);
  var _React$useState = React283.useState({}), _React$useState2 = _slicedToArray(_React$useState, 2), forceUpdate = _React$useState2[1];
  function setState(updater) {
    var newValue = typeof updater === "function" ? updater(stateRef.current) : updater;
    if (newValue !== stateRef.current) {
      onChange(newValue, stateRef.current);
    }
    stateRef.current = newValue;
    forceUpdate({});
  }
  return [stateRef.current, setState];
}

// ../../node_modules/rc-tabs/es/hooks/useTouchMove.js
var React284 = __toESM(require_react());
var import_react91 = __toESM(require_react());
var MIN_SWIPE_DISTANCE = 0.1;
var STOP_SWIPE_DISTANCE = 0.01;
var REFRESH_INTERVAL = 20;
var SPEED_OFF_MULTIPLE = Math.pow(0.995, REFRESH_INTERVAL);
function useTouchMove(ref3, onOffset) {
  var _useState = (0, import_react91.useState)(), _useState2 = _slicedToArray(_useState, 2), touchPosition = _useState2[0], setTouchPosition = _useState2[1];
  var _useState3 = (0, import_react91.useState)(0), _useState4 = _slicedToArray(_useState3, 2), lastTimestamp = _useState4[0], setLastTimestamp = _useState4[1];
  var _useState5 = (0, import_react91.useState)(0), _useState6 = _slicedToArray(_useState5, 2), lastTimeDiff = _useState6[0], setLastTimeDiff = _useState6[1];
  var _useState7 = (0, import_react91.useState)(), _useState8 = _slicedToArray(_useState7, 2), lastOffset = _useState8[0], setLastOffset = _useState8[1];
  var motionRef = (0, import_react91.useRef)();
  function onTouchStart(e3) {
    var _e$touches$ = e3.touches[0], screenX = _e$touches$.screenX, screenY = _e$touches$.screenY;
    setTouchPosition({
      x: screenX,
      y: screenY
    });
    window.clearInterval(motionRef.current);
  }
  function onTouchMove(e3) {
    if (!touchPosition) return;
    var _e$touches$2 = e3.touches[0], screenX = _e$touches$2.screenX, screenY = _e$touches$2.screenY;
    setTouchPosition({
      x: screenX,
      y: screenY
    });
    var offsetX = screenX - touchPosition.x;
    var offsetY = screenY - touchPosition.y;
    onOffset(offsetX, offsetY);
    var now4 = Date.now();
    setLastTimestamp(now4);
    setLastTimeDiff(now4 - lastTimestamp);
    setLastOffset({
      x: offsetX,
      y: offsetY
    });
  }
  function onTouchEnd() {
    if (!touchPosition) return;
    setTouchPosition(null);
    setLastOffset(null);
    if (lastOffset) {
      var distanceX = lastOffset.x / lastTimeDiff;
      var distanceY = lastOffset.y / lastTimeDiff;
      var absX = Math.abs(distanceX);
      var absY = Math.abs(distanceY);
      if (Math.max(absX, absY) < MIN_SWIPE_DISTANCE) return;
      var currentX = distanceX;
      var currentY = distanceY;
      motionRef.current = window.setInterval(function() {
        if (Math.abs(currentX) < STOP_SWIPE_DISTANCE && Math.abs(currentY) < STOP_SWIPE_DISTANCE) {
          window.clearInterval(motionRef.current);
          return;
        }
        currentX *= SPEED_OFF_MULTIPLE;
        currentY *= SPEED_OFF_MULTIPLE;
        onOffset(currentX * REFRESH_INTERVAL, currentY * REFRESH_INTERVAL);
      }, REFRESH_INTERVAL);
    }
  }
  var lastWheelDirectionRef = (0, import_react91.useRef)();
  function onWheel(e3) {
    var deltaX = e3.deltaX, deltaY = e3.deltaY;
    var mixed = 0;
    var absX = Math.abs(deltaX);
    var absY = Math.abs(deltaY);
    if (absX === absY) {
      mixed = lastWheelDirectionRef.current === "x" ? deltaX : deltaY;
    } else if (absX > absY) {
      mixed = deltaX;
      lastWheelDirectionRef.current = "x";
    } else {
      mixed = deltaY;
      lastWheelDirectionRef.current = "y";
    }
    if (onOffset(-mixed, -mixed)) {
      e3.preventDefault();
    }
  }
  var touchEventsRef = (0, import_react91.useRef)(null);
  touchEventsRef.current = {
    onTouchStart,
    onTouchMove,
    onTouchEnd,
    onWheel
  };
  React284.useEffect(function() {
    function onProxyTouchStart(e3) {
      touchEventsRef.current.onTouchStart(e3);
    }
    function onProxyTouchMove(e3) {
      touchEventsRef.current.onTouchMove(e3);
    }
    function onProxyTouchEnd(e3) {
      touchEventsRef.current.onTouchEnd(e3);
    }
    function onProxyWheel(e3) {
      touchEventsRef.current.onWheel(e3);
    }
    document.addEventListener("touchmove", onProxyTouchMove, {
      passive: false
    });
    document.addEventListener("touchend", onProxyTouchEnd, {
      passive: true
    });
    ref3.current.addEventListener("touchstart", onProxyTouchStart, {
      passive: true
    });
    ref3.current.addEventListener("wheel", onProxyWheel, {
      passive: false
    });
    return function() {
      document.removeEventListener("touchmove", onProxyTouchMove);
      document.removeEventListener("touchend", onProxyTouchEnd);
    };
  }, []);
}

// ../../node_modules/rc-tabs/es/hooks/useUpdate.js
var import_react92 = __toESM(require_react());
function useUpdate(callback) {
  var _useState = (0, import_react92.useState)(0), _useState2 = _slicedToArray(_useState, 2), count = _useState2[0], setCount = _useState2[1];
  var effectRef = (0, import_react92.useRef)(0);
  var callbackRef = (0, import_react92.useRef)();
  callbackRef.current = callback;
  useLayoutUpdateEffect(function() {
    var _callbackRef$current;
    (_callbackRef$current = callbackRef.current) === null || _callbackRef$current === void 0 || _callbackRef$current.call(callbackRef);
  }, [count]);
  return function() {
    if (effectRef.current !== count) {
      return;
    }
    effectRef.current += 1;
    setCount(effectRef.current);
  };
}
function useUpdateState(defaultState) {
  var batchRef = (0, import_react92.useRef)([]);
  var _useState3 = (0, import_react92.useState)({}), _useState4 = _slicedToArray(_useState3, 2), forceUpdate = _useState4[1];
  var state = (0, import_react92.useRef)(typeof defaultState === "function" ? defaultState() : defaultState);
  var flushUpdate = useUpdate(function() {
    var current2 = state.current;
    batchRef.current.forEach(function(callback) {
      current2 = callback(current2);
    });
    batchRef.current = [];
    state.current = current2;
    forceUpdate({});
  });
  function updater(callback) {
    batchRef.current.push(callback);
    flushUpdate();
  }
  return [state.current, updater];
}

// ../../node_modules/rc-tabs/es/hooks/useVisibleRange.js
var import_react93 = __toESM(require_react());
var DEFAULT_SIZE2 = {
  width: 0,
  height: 0,
  left: 0,
  top: 0,
  right: 0
};
function useVisibleRange(tabOffsets, visibleTabContentValue, transform, tabContentSizeValue, addNodeSizeValue, operationNodeSizeValue, _ref) {
  var tabs = _ref.tabs, tabPosition = _ref.tabPosition, rtl = _ref.rtl;
  var charUnit;
  var position3;
  var transformSize;
  if (["top", "bottom"].includes(tabPosition)) {
    charUnit = "width";
    position3 = rtl ? "right" : "left";
    transformSize = Math.abs(transform);
  } else {
    charUnit = "height";
    position3 = "top";
    transformSize = -transform;
  }
  return (0, import_react93.useMemo)(function() {
    if (!tabs.length) {
      return [0, 0];
    }
    var len = tabs.length;
    var endIndex = len;
    for (var i = 0; i < len; i += 1) {
      var offset4 = tabOffsets.get(tabs[i].key) || DEFAULT_SIZE2;
      if (Math.floor(offset4[position3] + offset4[charUnit]) > Math.floor(transformSize + visibleTabContentValue)) {
        endIndex = i - 1;
        break;
      }
    }
    var startIndex = 0;
    for (var _i = len - 1; _i >= 0; _i -= 1) {
      var _offset = tabOffsets.get(tabs[_i].key) || DEFAULT_SIZE2;
      if (_offset[position3] < transformSize) {
        startIndex = _i + 1;
        break;
      }
    }
    return startIndex > endIndex ? [0, -1] : [startIndex, endIndex];
  }, [tabOffsets, visibleTabContentValue, tabContentSizeValue, addNodeSizeValue, operationNodeSizeValue, transformSize, tabPosition, tabs.map(function(tab) {
    return tab.key;
  }).join("_"), rtl]);
}

// ../../node_modules/rc-tabs/es/util.js
function stringify3(obj) {
  var tgt;
  if (obj instanceof Map) {
    tgt = {};
    obj.forEach(function(v, k) {
      tgt[k] = v;
    });
  } else {
    tgt = obj;
  }
  return JSON.stringify(tgt);
}
var RC_TABS_DOUBLE_QUOTE = "TABS_DQ";
function genDataNodeKey(key2) {
  return String(key2).replace(/"/g, RC_TABS_DOUBLE_QUOTE);
}
function getRemovable(closable, closeIcon, editable, disabled) {
  if (
    // Only editable tabs can be removed
    !editable || // Tabs cannot be removed when disabled
    disabled || // closable is false
    closable === false || // If closable is undefined, the remove button should be hidden when closeIcon is null or false
    closable === void 0 && (closeIcon === false || closeIcon === null)
  ) {
    return false;
  }
  return true;
}

// ../../node_modules/rc-tabs/es/TabNavList/AddButton.js
var React285 = __toESM(require_react());
var AddButton = /* @__PURE__ */ React285.forwardRef(function(props, ref3) {
  var prefixCls = props.prefixCls, editable = props.editable, locale6 = props.locale, style2 = props.style;
  if (!editable || editable.showAdd === false) {
    return null;
  }
  return /* @__PURE__ */ React285.createElement("button", {
    ref: ref3,
    type: "button",
    className: "".concat(prefixCls, "-nav-add"),
    style: style2,
    "aria-label": (locale6 === null || locale6 === void 0 ? void 0 : locale6.addAriaLabel) || "Add tab",
    onClick: function onClick(event) {
      editable.onEdit("add", {
        event
      });
    }
  }, editable.addIcon || "+");
});
var AddButton_default = AddButton;

// ../../node_modules/rc-tabs/es/TabNavList/ExtraContent.js
var React286 = __toESM(require_react());
var ExtraContent = /* @__PURE__ */ React286.forwardRef(function(props, ref3) {
  var position3 = props.position, prefixCls = props.prefixCls, extra = props.extra;
  if (!extra) {
    return null;
  }
  var content;
  var assertExtra = {};
  if (_typeof(extra) === "object" && !/* @__PURE__ */ React286.isValidElement(extra)) {
    assertExtra = extra;
  } else {
    assertExtra.right = extra;
  }
  if (position3 === "right") {
    content = assertExtra.right;
  }
  if (position3 === "left") {
    content = assertExtra.left;
  }
  return content ? /* @__PURE__ */ React286.createElement("div", {
    className: "".concat(prefixCls, "-extra-content"),
    ref: ref3
  }, content) : null;
});
if (true) {
  ExtraContent.displayName = "ExtraContent";
}
var ExtraContent_default = ExtraContent;

// ../../node_modules/rc-tabs/es/TabNavList/OperationNode.js
var import_classnames94 = __toESM(require_classnames());
var React287 = __toESM(require_react());
var import_react94 = __toESM(require_react());
var OperationNode = /* @__PURE__ */ React287.forwardRef(function(props, ref3) {
  var prefixCls = props.prefixCls, id = props.id, tabs = props.tabs, locale6 = props.locale, mobile = props.mobile, _props$more = props.more, moreProps = _props$more === void 0 ? {} : _props$more, style2 = props.style, className2 = props.className, editable = props.editable, tabBarGutter = props.tabBarGutter, rtl = props.rtl, removeAriaLabel = props.removeAriaLabel, onTabClick = props.onTabClick, getPopupContainer = props.getPopupContainer, popupClassName = props.popupClassName;
  var _useState = (0, import_react94.useState)(false), _useState2 = _slicedToArray(_useState, 2), open2 = _useState2[0], setOpen = _useState2[1];
  var _useState3 = (0, import_react94.useState)(null), _useState4 = _slicedToArray(_useState3, 2), selectedKey = _useState4[0], setSelectedKey = _useState4[1];
  var _moreProps$icon = moreProps.icon, moreIcon = _moreProps$icon === void 0 ? "More" : _moreProps$icon;
  var popupId = "".concat(id, "-more-popup");
  var dropdownPrefix = "".concat(prefixCls, "-dropdown");
  var selectedItemId = selectedKey !== null ? "".concat(popupId, "-").concat(selectedKey) : null;
  var dropdownAriaLabel = locale6 === null || locale6 === void 0 ? void 0 : locale6.dropdownAriaLabel;
  function onRemoveTab(event, key2) {
    event.preventDefault();
    event.stopPropagation();
    editable.onEdit("remove", {
      key: key2,
      event
    });
  }
  var menu = /* @__PURE__ */ React287.createElement(es_default14, {
    onClick: function onClick(_ref) {
      var key2 = _ref.key, domEvent = _ref.domEvent;
      onTabClick(key2, domEvent);
      setOpen(false);
    },
    prefixCls: "".concat(dropdownPrefix, "-menu"),
    id: popupId,
    tabIndex: -1,
    role: "listbox",
    "aria-activedescendant": selectedItemId,
    selectedKeys: [selectedKey],
    "aria-label": dropdownAriaLabel !== void 0 ? dropdownAriaLabel : "expanded dropdown"
  }, tabs.map(function(tab) {
    var closable = tab.closable, disabled = tab.disabled, closeIcon = tab.closeIcon, key2 = tab.key, label = tab.label;
    var removable = getRemovable(closable, closeIcon, editable, disabled);
    return /* @__PURE__ */ React287.createElement(MenuItem_default, {
      key: key2,
      id: "".concat(popupId, "-").concat(key2),
      role: "option",
      "aria-controls": id && "".concat(id, "-panel-").concat(key2),
      disabled
    }, /* @__PURE__ */ React287.createElement("span", null, label), removable && /* @__PURE__ */ React287.createElement("button", {
      type: "button",
      "aria-label": removeAriaLabel || "remove",
      tabIndex: 0,
      className: "".concat(dropdownPrefix, "-menu-item-remove"),
      onClick: function onClick(e3) {
        e3.stopPropagation();
        onRemoveTab(e3, key2);
      }
    }, closeIcon || editable.removeIcon || "\xD7"));
  }));
  function selectOffset(offset4) {
    var enabledTabs = tabs.filter(function(tab2) {
      return !tab2.disabled;
    });
    var selectedIndex = enabledTabs.findIndex(function(tab2) {
      return tab2.key === selectedKey;
    }) || 0;
    var len = enabledTabs.length;
    for (var i = 0; i < len; i += 1) {
      selectedIndex = (selectedIndex + offset4 + len) % len;
      var tab = enabledTabs[selectedIndex];
      if (!tab.disabled) {
        setSelectedKey(tab.key);
        return;
      }
    }
  }
  function onKeyDown2(e3) {
    var which = e3.which;
    if (!open2) {
      if ([KeyCode_default.DOWN, KeyCode_default.SPACE, KeyCode_default.ENTER].includes(which)) {
        setOpen(true);
        e3.preventDefault();
      }
      return;
    }
    switch (which) {
      case KeyCode_default.UP:
        selectOffset(-1);
        e3.preventDefault();
        break;
      case KeyCode_default.DOWN:
        selectOffset(1);
        e3.preventDefault();
        break;
      case KeyCode_default.ESC:
        setOpen(false);
        break;
      case KeyCode_default.SPACE:
      case KeyCode_default.ENTER:
        if (selectedKey !== null) {
          onTabClick(selectedKey, e3);
        }
        break;
    }
  }
  (0, import_react94.useEffect)(function() {
    var ele = document.getElementById(selectedItemId);
    if (ele && ele.scrollIntoView) {
      ele.scrollIntoView(false);
    }
  }, [selectedKey]);
  (0, import_react94.useEffect)(function() {
    if (!open2) {
      setSelectedKey(null);
    }
  }, [open2]);
  var moreStyle = _defineProperty({}, rtl ? "marginRight" : "marginLeft", tabBarGutter);
  if (!tabs.length) {
    moreStyle.visibility = "hidden";
    moreStyle.order = 1;
  }
  var overlayClassName = (0, import_classnames94.default)(_defineProperty({}, "".concat(dropdownPrefix, "-rtl"), rtl));
  var moreNode = mobile ? null : /* @__PURE__ */ React287.createElement(es_default13, _extends({
    prefixCls: dropdownPrefix,
    overlay: menu,
    visible: tabs.length ? open2 : false,
    onVisibleChange: setOpen,
    overlayClassName: (0, import_classnames94.default)(overlayClassName, popupClassName),
    mouseEnterDelay: 0.1,
    mouseLeaveDelay: 0.1,
    getPopupContainer
  }, moreProps), /* @__PURE__ */ React287.createElement("button", {
    type: "button",
    className: "".concat(prefixCls, "-nav-more"),
    style: moreStyle,
    "aria-haspopup": "listbox",
    "aria-controls": popupId,
    id: "".concat(id, "-more"),
    "aria-expanded": open2,
    onKeyDown: onKeyDown2
  }, moreIcon));
  return /* @__PURE__ */ React287.createElement("div", {
    className: (0, import_classnames94.default)("".concat(prefixCls, "-nav-operations"), className2),
    style: style2,
    ref: ref3
  }, moreNode, /* @__PURE__ */ React287.createElement(AddButton_default, {
    prefixCls,
    locale: locale6,
    editable
  }));
});
var OperationNode_default = /* @__PURE__ */ React287.memo(OperationNode, function(_, next2) {
  return (
    // https://github.com/ant-design/ant-design/issues/32544
    // We'd better remove syntactic sugar in `rc-menu` since this has perf issue
    next2.tabMoving
  );
});

// ../../node_modules/rc-tabs/es/TabNavList/TabNode.js
var import_classnames95 = __toESM(require_classnames());
var React288 = __toESM(require_react());
var TabNode = function TabNode2(props) {
  var prefixCls = props.prefixCls, id = props.id, active = props.active, focus = props.focus, _props$tab = props.tab, key2 = _props$tab.key, label = _props$tab.label, disabled = _props$tab.disabled, closeIcon = _props$tab.closeIcon, icon = _props$tab.icon, closable = props.closable, renderWrapper = props.renderWrapper, removeAriaLabel = props.removeAriaLabel, editable = props.editable, onClick = props.onClick, onFocus = props.onFocus, onBlur = props.onBlur, onKeyDown2 = props.onKeyDown, onMouseDown = props.onMouseDown, onMouseUp = props.onMouseUp, style2 = props.style, tabCount = props.tabCount, currentPosition = props.currentPosition;
  var tabPrefix = "".concat(prefixCls, "-tab");
  var removable = getRemovable(closable, closeIcon, editable, disabled);
  function onInternalClick(e3) {
    if (disabled) {
      return;
    }
    onClick(e3);
  }
  function onRemoveTab(event) {
    event.preventDefault();
    event.stopPropagation();
    editable.onEdit("remove", {
      key: key2,
      event
    });
  }
  var labelNode = React288.useMemo(function() {
    return icon && typeof label === "string" ? /* @__PURE__ */ React288.createElement("span", null, label) : label;
  }, [label, icon]);
  var btnRef = React288.useRef(null);
  React288.useEffect(function() {
    if (focus && btnRef.current) {
      btnRef.current.focus();
    }
  }, [focus]);
  var node2 = /* @__PURE__ */ React288.createElement("div", {
    key: key2,
    "data-node-key": genDataNodeKey(key2),
    className: (0, import_classnames95.default)(tabPrefix, _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "".concat(tabPrefix, "-with-remove"), removable), "".concat(tabPrefix, "-active"), active), "".concat(tabPrefix, "-disabled"), disabled), "".concat(tabPrefix, "-focus"), focus)),
    style: style2,
    onClick: onInternalClick
  }, /* @__PURE__ */ React288.createElement("div", {
    ref: btnRef,
    role: "tab",
    "aria-selected": active,
    id: id && "".concat(id, "-tab-").concat(key2),
    className: "".concat(tabPrefix, "-btn"),
    "aria-controls": id && "".concat(id, "-panel-").concat(key2),
    "aria-disabled": disabled,
    tabIndex: disabled ? null : active ? 0 : -1,
    onClick: function onClick2(e3) {
      e3.stopPropagation();
      onInternalClick(e3);
    },
    onKeyDown: onKeyDown2,
    onMouseDown,
    onMouseUp,
    onFocus,
    onBlur
  }, focus && /* @__PURE__ */ React288.createElement("div", {
    "aria-live": "polite",
    style: {
      width: 0,
      height: 0,
      position: "absolute",
      overflow: "hidden",
      opacity: 0
    }
  }, "Tab ".concat(currentPosition, " of ").concat(tabCount)), icon && /* @__PURE__ */ React288.createElement("span", {
    className: "".concat(tabPrefix, "-icon")
  }, icon), label && labelNode), removable && /* @__PURE__ */ React288.createElement("button", {
    type: "button",
    role: "tab",
    "aria-label": removeAriaLabel || "remove",
    tabIndex: active ? 0 : -1,
    className: "".concat(tabPrefix, "-remove"),
    onClick: function onClick2(e3) {
      e3.stopPropagation();
      onRemoveTab(e3);
    }
  }, closeIcon || editable.removeIcon || "\xD7"));
  return renderWrapper ? renderWrapper(node2) : node2;
};
var TabNode_default = TabNode;

// ../../node_modules/rc-tabs/es/TabNavList/index.js
var getTabSize = function getTabSize2(tab, containerRect) {
  var offsetWidth = tab.offsetWidth, offsetHeight = tab.offsetHeight, offsetTop = tab.offsetTop, offsetLeft = tab.offsetLeft;
  var _tab$getBoundingClien = tab.getBoundingClientRect(), width = _tab$getBoundingClien.width, height = _tab$getBoundingClien.height, left2 = _tab$getBoundingClien.left, top = _tab$getBoundingClien.top;
  if (Math.abs(width - offsetWidth) < 1) {
    return [width, height, left2 - containerRect.left, top - containerRect.top];
  }
  return [offsetWidth, offsetHeight, offsetLeft, offsetTop];
};
var getSize = function getSize2(refObj) {
  var _ref = refObj.current || {}, _ref$offsetWidth = _ref.offsetWidth, offsetWidth = _ref$offsetWidth === void 0 ? 0 : _ref$offsetWidth, _ref$offsetHeight = _ref.offsetHeight, offsetHeight = _ref$offsetHeight === void 0 ? 0 : _ref$offsetHeight;
  if (refObj.current) {
    var _refObj$current$getBo = refObj.current.getBoundingClientRect(), width = _refObj$current$getBo.width, height = _refObj$current$getBo.height;
    if (Math.abs(width - offsetWidth) < 1) {
      return [width, height];
    }
  }
  return [offsetWidth, offsetHeight];
};
var getUnitValue = function getUnitValue2(size, tabPositionTopOrBottom) {
  return size[tabPositionTopOrBottom ? 0 : 1];
};
var TabNavList = /* @__PURE__ */ React289.forwardRef(function(props, ref3) {
  var className2 = props.className, style2 = props.style, id = props.id, animated = props.animated, activeKey = props.activeKey, rtl = props.rtl, extra = props.extra, editable = props.editable, locale6 = props.locale, tabPosition = props.tabPosition, tabBarGutter = props.tabBarGutter, children = props.children, onTabClick = props.onTabClick, onTabScroll = props.onTabScroll, indicator = props.indicator;
  var _React$useContext = React289.useContext(TabContext_default), prefixCls = _React$useContext.prefixCls, tabs = _React$useContext.tabs;
  var containerRef = (0, import_react95.useRef)(null);
  var extraLeftRef = (0, import_react95.useRef)(null);
  var extraRightRef = (0, import_react95.useRef)(null);
  var tabsWrapperRef = (0, import_react95.useRef)(null);
  var tabListRef = (0, import_react95.useRef)(null);
  var operationsRef = (0, import_react95.useRef)(null);
  var innerAddButtonRef = (0, import_react95.useRef)(null);
  var tabPositionTopOrBottom = tabPosition === "top" || tabPosition === "bottom";
  var _useSyncState = useSyncState3(0, function(next2, prev2) {
    if (tabPositionTopOrBottom && onTabScroll) {
      onTabScroll({
        direction: next2 > prev2 ? "left" : "right"
      });
    }
  }), _useSyncState2 = _slicedToArray(_useSyncState, 2), transformLeft = _useSyncState2[0], setTransformLeft = _useSyncState2[1];
  var _useSyncState3 = useSyncState3(0, function(next2, prev2) {
    if (!tabPositionTopOrBottom && onTabScroll) {
      onTabScroll({
        direction: next2 > prev2 ? "top" : "bottom"
      });
    }
  }), _useSyncState4 = _slicedToArray(_useSyncState3, 2), transformTop = _useSyncState4[0], setTransformTop = _useSyncState4[1];
  var _useState = (0, import_react95.useState)([0, 0]), _useState2 = _slicedToArray(_useState, 2), containerExcludeExtraSize = _useState2[0], setContainerExcludeExtraSize = _useState2[1];
  var _useState3 = (0, import_react95.useState)([0, 0]), _useState4 = _slicedToArray(_useState3, 2), tabContentSize = _useState4[0], setTabContentSize = _useState4[1];
  var _useState5 = (0, import_react95.useState)([0, 0]), _useState6 = _slicedToArray(_useState5, 2), addSize = _useState6[0], setAddSize = _useState6[1];
  var _useState7 = (0, import_react95.useState)([0, 0]), _useState8 = _slicedToArray(_useState7, 2), operationSize = _useState8[0], setOperationSize = _useState8[1];
  var _useUpdateState = useUpdateState(/* @__PURE__ */ new Map()), _useUpdateState2 = _slicedToArray(_useUpdateState, 2), tabSizes = _useUpdateState2[0], setTabSizes = _useUpdateState2[1];
  var tabOffsets = useOffsets(tabs, tabSizes, tabContentSize[0]);
  var containerExcludeExtraSizeValue = getUnitValue(containerExcludeExtraSize, tabPositionTopOrBottom);
  var tabContentSizeValue = getUnitValue(tabContentSize, tabPositionTopOrBottom);
  var addSizeValue = getUnitValue(addSize, tabPositionTopOrBottom);
  var operationSizeValue = getUnitValue(operationSize, tabPositionTopOrBottom);
  var needScroll = Math.floor(containerExcludeExtraSizeValue) < Math.floor(tabContentSizeValue + addSizeValue);
  var visibleTabContentValue = needScroll ? containerExcludeExtraSizeValue - operationSizeValue : containerExcludeExtraSizeValue - addSizeValue;
  var operationsHiddenClassName = "".concat(prefixCls, "-nav-operations-hidden");
  var transformMin = 0;
  var transformMax = 0;
  if (!tabPositionTopOrBottom) {
    transformMin = Math.min(0, visibleTabContentValue - tabContentSizeValue);
    transformMax = 0;
  } else if (rtl) {
    transformMin = 0;
    transformMax = Math.max(0, tabContentSizeValue - visibleTabContentValue);
  } else {
    transformMin = Math.min(0, visibleTabContentValue - tabContentSizeValue);
    transformMax = 0;
  }
  function alignInRange(value) {
    if (value < transformMin) {
      return transformMin;
    }
    if (value > transformMax) {
      return transformMax;
    }
    return value;
  }
  var touchMovingRef = (0, import_react95.useRef)(null);
  var _useState9 = (0, import_react95.useState)(), _useState10 = _slicedToArray(_useState9, 2), lockAnimation = _useState10[0], setLockAnimation = _useState10[1];
  function doLockAnimation() {
    setLockAnimation(Date.now());
  }
  function clearTouchMoving() {
    if (touchMovingRef.current) {
      clearTimeout(touchMovingRef.current);
    }
  }
  useTouchMove(tabsWrapperRef, function(offsetX, offsetY) {
    function doMove(setState, offset4) {
      setState(function(value) {
        var newValue = alignInRange(value + offset4);
        return newValue;
      });
    }
    if (!needScroll) {
      return false;
    }
    if (tabPositionTopOrBottom) {
      doMove(setTransformLeft, offsetX);
    } else {
      doMove(setTransformTop, offsetY);
    }
    clearTouchMoving();
    doLockAnimation();
    return true;
  });
  (0, import_react95.useEffect)(function() {
    clearTouchMoving();
    if (lockAnimation) {
      touchMovingRef.current = setTimeout(function() {
        setLockAnimation(0);
      }, 100);
    }
    return clearTouchMoving;
  }, [lockAnimation]);
  var _useVisibleRange = useVisibleRange(
    tabOffsets,
    // Container
    visibleTabContentValue,
    // Transform
    tabPositionTopOrBottom ? transformLeft : transformTop,
    // Tabs
    tabContentSizeValue,
    // Add
    addSizeValue,
    // Operation
    operationSizeValue,
    _objectSpread2(_objectSpread2({}, props), {}, {
      tabs
    })
  ), _useVisibleRange2 = _slicedToArray(_useVisibleRange, 2), visibleStart = _useVisibleRange2[0], visibleEnd = _useVisibleRange2[1];
  var scrollToTab = useEvent2(function() {
    var key2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : activeKey;
    var tabOffset = tabOffsets.get(key2) || {
      width: 0,
      height: 0,
      left: 0,
      right: 0,
      top: 0
    };
    if (tabPositionTopOrBottom) {
      var newTransform = transformLeft;
      if (rtl) {
        if (tabOffset.right < transformLeft) {
          newTransform = tabOffset.right;
        } else if (tabOffset.right + tabOffset.width > transformLeft + visibleTabContentValue) {
          newTransform = tabOffset.right + tabOffset.width - visibleTabContentValue;
        }
      } else if (tabOffset.left < -transformLeft) {
        newTransform = -tabOffset.left;
      } else if (tabOffset.left + tabOffset.width > -transformLeft + visibleTabContentValue) {
        newTransform = -(tabOffset.left + tabOffset.width - visibleTabContentValue);
      }
      setTransformTop(0);
      setTransformLeft(alignInRange(newTransform));
    } else {
      var _newTransform = transformTop;
      if (tabOffset.top < -transformTop) {
        _newTransform = -tabOffset.top;
      } else if (tabOffset.top + tabOffset.height > -transformTop + visibleTabContentValue) {
        _newTransform = -(tabOffset.top + tabOffset.height - visibleTabContentValue);
      }
      setTransformLeft(0);
      setTransformTop(alignInRange(_newTransform));
    }
  });
  var _useState11 = (0, import_react95.useState)(), _useState12 = _slicedToArray(_useState11, 2), focusKey = _useState12[0], setFocusKey = _useState12[1];
  var _useState13 = (0, import_react95.useState)(false), _useState14 = _slicedToArray(_useState13, 2), isMouse = _useState14[0], setIsMouse = _useState14[1];
  var enabledTabs = tabs.filter(function(tab) {
    return !tab.disabled;
  }).map(function(tab) {
    return tab.key;
  });
  var onOffset = function onOffset2(offset4) {
    var currentIndex = enabledTabs.indexOf(focusKey || activeKey);
    var len = enabledTabs.length;
    var nextIndex2 = (currentIndex + offset4 + len) % len;
    var newKey = enabledTabs[nextIndex2];
    setFocusKey(newKey);
  };
  var handleRemoveTab = function handleRemoveTab2(removalTabKey, e3) {
    var removeIndex = enabledTabs.indexOf(removalTabKey);
    var removeTab = tabs.find(function(tab) {
      return tab.key === removalTabKey;
    });
    var removable = getRemovable(removeTab === null || removeTab === void 0 ? void 0 : removeTab.closable, removeTab === null || removeTab === void 0 ? void 0 : removeTab.closeIcon, editable, removeTab === null || removeTab === void 0 ? void 0 : removeTab.disabled);
    if (removable) {
      e3.preventDefault();
      e3.stopPropagation();
      editable.onEdit("remove", {
        key: removalTabKey,
        event: e3
      });
      if (removeIndex === enabledTabs.length - 1) {
        onOffset(-1);
      } else {
        onOffset(1);
      }
    }
  };
  var handleMouseDown = function handleMouseDown2(key2, e3) {
    setIsMouse(true);
    if (e3.button === 1) {
      handleRemoveTab(key2, e3);
    }
  };
  var handleKeyDown = function handleKeyDown2(e3) {
    var code2 = e3.code;
    var isRTL = rtl && tabPositionTopOrBottom;
    var firstEnabledTab = enabledTabs[0];
    var lastEnabledTab = enabledTabs[enabledTabs.length - 1];
    switch (code2) {
      // LEFT
      case "ArrowLeft": {
        if (tabPositionTopOrBottom) {
          onOffset(isRTL ? 1 : -1);
        }
        break;
      }
      // RIGHT
      case "ArrowRight": {
        if (tabPositionTopOrBottom) {
          onOffset(isRTL ? -1 : 1);
        }
        break;
      }
      // UP
      case "ArrowUp": {
        e3.preventDefault();
        if (!tabPositionTopOrBottom) {
          onOffset(-1);
        }
        break;
      }
      // DOWN
      case "ArrowDown": {
        e3.preventDefault();
        if (!tabPositionTopOrBottom) {
          onOffset(1);
        }
        break;
      }
      // HOME
      case "Home": {
        e3.preventDefault();
        setFocusKey(firstEnabledTab);
        break;
      }
      // END
      case "End": {
        e3.preventDefault();
        setFocusKey(lastEnabledTab);
        break;
      }
      // Enter & Space
      case "Enter":
      case "Space": {
        e3.preventDefault();
        onTabClick(focusKey !== null && focusKey !== void 0 ? focusKey : activeKey, e3);
        break;
      }
      // Backspace
      case "Backspace":
      case "Delete": {
        handleRemoveTab(focusKey, e3);
        break;
      }
    }
  };
  var tabNodeStyle = {};
  if (tabPositionTopOrBottom) {
    tabNodeStyle[rtl ? "marginRight" : "marginLeft"] = tabBarGutter;
  } else {
    tabNodeStyle.marginTop = tabBarGutter;
  }
  var tabNodes = tabs.map(function(tab, i) {
    var key2 = tab.key;
    return /* @__PURE__ */ React289.createElement(TabNode_default, {
      id,
      prefixCls,
      key: key2,
      tab,
      style: i === 0 ? void 0 : tabNodeStyle,
      closable: tab.closable,
      editable,
      active: key2 === activeKey,
      focus: key2 === focusKey,
      renderWrapper: children,
      removeAriaLabel: locale6 === null || locale6 === void 0 ? void 0 : locale6.removeAriaLabel,
      tabCount: enabledTabs.length,
      currentPosition: i + 1,
      onClick: function onClick(e3) {
        onTabClick(key2, e3);
      },
      onKeyDown: handleKeyDown,
      onFocus: function onFocus() {
        if (!isMouse) {
          setFocusKey(key2);
        }
        scrollToTab(key2);
        doLockAnimation();
        if (!tabsWrapperRef.current) {
          return;
        }
        if (!rtl) {
          tabsWrapperRef.current.scrollLeft = 0;
        }
        tabsWrapperRef.current.scrollTop = 0;
      },
      onBlur: function onBlur() {
        setFocusKey(void 0);
      },
      onMouseDown: function onMouseDown(e3) {
        return handleMouseDown(key2, e3);
      },
      onMouseUp: function onMouseUp() {
        setIsMouse(false);
      }
    });
  });
  var updateTabSizes = function updateTabSizes2() {
    return setTabSizes(function() {
      var _tabListRef$current;
      var newSizes = /* @__PURE__ */ new Map();
      var listRect = (_tabListRef$current = tabListRef.current) === null || _tabListRef$current === void 0 ? void 0 : _tabListRef$current.getBoundingClientRect();
      tabs.forEach(function(_ref2) {
        var _tabListRef$current2;
        var key2 = _ref2.key;
        var btnNode = (_tabListRef$current2 = tabListRef.current) === null || _tabListRef$current2 === void 0 ? void 0 : _tabListRef$current2.querySelector('[data-node-key="'.concat(genDataNodeKey(key2), '"]'));
        if (btnNode) {
          var _getTabSize = getTabSize(btnNode, listRect), _getTabSize2 = _slicedToArray(_getTabSize, 4), width = _getTabSize2[0], height = _getTabSize2[1], left2 = _getTabSize2[2], top = _getTabSize2[3];
          newSizes.set(key2, {
            width,
            height,
            left: left2,
            top
          });
        }
      });
      return newSizes;
    });
  };
  (0, import_react95.useEffect)(function() {
    updateTabSizes();
  }, [tabs.map(function(tab) {
    return tab.key;
  }).join("_")]);
  var onListHolderResize = useUpdate(function() {
    var containerSize = getSize(containerRef);
    var extraLeftSize = getSize(extraLeftRef);
    var extraRightSize = getSize(extraRightRef);
    setContainerExcludeExtraSize([containerSize[0] - extraLeftSize[0] - extraRightSize[0], containerSize[1] - extraLeftSize[1] - extraRightSize[1]]);
    var newAddSize = getSize(innerAddButtonRef);
    setAddSize(newAddSize);
    var newOperationSize = getSize(operationsRef);
    setOperationSize(newOperationSize);
    var tabContentFullSize = getSize(tabListRef);
    setTabContentSize([tabContentFullSize[0] - newAddSize[0], tabContentFullSize[1] - newAddSize[1]]);
    updateTabSizes();
  });
  var startHiddenTabs = tabs.slice(0, visibleStart);
  var endHiddenTabs = tabs.slice(visibleEnd + 1);
  var hiddenTabs = [].concat(_toConsumableArray(startHiddenTabs), _toConsumableArray(endHiddenTabs));
  var activeTabOffset = tabOffsets.get(activeKey);
  var _useIndicator = useIndicator_default({
    activeTabOffset,
    horizontal: tabPositionTopOrBottom,
    indicator,
    rtl
  }), indicatorStyle = _useIndicator.style;
  (0, import_react95.useEffect)(function() {
    scrollToTab();
  }, [activeKey, transformMin, transformMax, stringify3(activeTabOffset), stringify3(tabOffsets), tabPositionTopOrBottom]);
  (0, import_react95.useEffect)(function() {
    onListHolderResize();
  }, [rtl]);
  var hasDropdown = !!hiddenTabs.length;
  var wrapPrefix = "".concat(prefixCls, "-nav-wrap");
  var pingLeft;
  var pingRight;
  var pingTop;
  var pingBottom;
  if (tabPositionTopOrBottom) {
    if (rtl) {
      pingRight = transformLeft > 0;
      pingLeft = transformLeft !== transformMax;
    } else {
      pingLeft = transformLeft < 0;
      pingRight = transformLeft !== transformMin;
    }
  } else {
    pingTop = transformTop < 0;
    pingBottom = transformTop !== transformMin;
  }
  return /* @__PURE__ */ React289.createElement(es_default, {
    onResize: onListHolderResize
  }, /* @__PURE__ */ React289.createElement("div", {
    ref: useComposeRef(ref3, containerRef),
    role: "tablist",
    "aria-orientation": tabPositionTopOrBottom ? "horizontal" : "vertical",
    className: (0, import_classnames96.default)("".concat(prefixCls, "-nav"), className2),
    style: style2,
    onKeyDown: function onKeyDown2() {
      doLockAnimation();
    }
  }, /* @__PURE__ */ React289.createElement(ExtraContent_default, {
    ref: extraLeftRef,
    position: "left",
    extra,
    prefixCls
  }), /* @__PURE__ */ React289.createElement(es_default, {
    onResize: onListHolderResize
  }, /* @__PURE__ */ React289.createElement("div", {
    className: (0, import_classnames96.default)(wrapPrefix, _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "".concat(wrapPrefix, "-ping-left"), pingLeft), "".concat(wrapPrefix, "-ping-right"), pingRight), "".concat(wrapPrefix, "-ping-top"), pingTop), "".concat(wrapPrefix, "-ping-bottom"), pingBottom)),
    ref: tabsWrapperRef
  }, /* @__PURE__ */ React289.createElement(es_default, {
    onResize: onListHolderResize
  }, /* @__PURE__ */ React289.createElement("div", {
    ref: tabListRef,
    className: "".concat(prefixCls, "-nav-list"),
    style: {
      transform: "translate(".concat(transformLeft, "px, ").concat(transformTop, "px)"),
      transition: lockAnimation ? "none" : void 0
    }
  }, tabNodes, /* @__PURE__ */ React289.createElement(AddButton_default, {
    ref: innerAddButtonRef,
    prefixCls,
    locale: locale6,
    editable,
    style: _objectSpread2(_objectSpread2({}, tabNodes.length === 0 ? void 0 : tabNodeStyle), {}, {
      visibility: hasDropdown ? "hidden" : null
    })
  }), /* @__PURE__ */ React289.createElement("div", {
    className: (0, import_classnames96.default)("".concat(prefixCls, "-ink-bar"), _defineProperty({}, "".concat(prefixCls, "-ink-bar-animated"), animated.inkBar)),
    style: indicatorStyle
  }))))), /* @__PURE__ */ React289.createElement(OperationNode_default, _extends({}, props, {
    removeAriaLabel: locale6 === null || locale6 === void 0 ? void 0 : locale6.removeAriaLabel,
    ref: operationsRef,
    prefixCls,
    tabs: hiddenTabs,
    className: !hasDropdown && operationsHiddenClassName,
    tabMoving: !!lockAnimation
  })), /* @__PURE__ */ React289.createElement(ExtraContent_default, {
    ref: extraRightRef,
    position: "right",
    extra,
    prefixCls
  })));
});
var TabNavList_default = TabNavList;

// ../../node_modules/rc-tabs/es/TabPanelList/TabPane.js
var import_classnames97 = __toESM(require_classnames());
var React290 = __toESM(require_react());
var TabPane = /* @__PURE__ */ React290.forwardRef(function(props, ref3) {
  var prefixCls = props.prefixCls, className2 = props.className, style2 = props.style, id = props.id, active = props.active, tabKey = props.tabKey, children = props.children;
  return /* @__PURE__ */ React290.createElement("div", {
    id: id && "".concat(id, "-panel-").concat(tabKey),
    role: "tabpanel",
    tabIndex: active ? 0 : -1,
    "aria-labelledby": id && "".concat(id, "-tab-").concat(tabKey),
    "aria-hidden": !active,
    style: style2,
    className: (0, import_classnames97.default)(prefixCls, active && "".concat(prefixCls, "-active"), className2),
    ref: ref3
  }, children);
});
if (true) {
  TabPane.displayName = "TabPane";
}
var TabPane_default = TabPane;

// ../../node_modules/rc-tabs/es/TabNavList/Wrapper.js
var _excluded45 = ["renderTabBar"];
var _excluded214 = ["label", "key"];
var TabNavListWrapper = function TabNavListWrapper2(_ref) {
  var renderTabBar = _ref.renderTabBar, restProps = _objectWithoutProperties(_ref, _excluded45);
  var _React$useContext = React291.useContext(TabContext_default), tabs = _React$useContext.tabs;
  if (renderTabBar) {
    var tabNavBarProps = _objectSpread2(_objectSpread2({}, restProps), {}, {
      // Legacy support. We do not use this actually
      panes: tabs.map(function(_ref2) {
        var label = _ref2.label, key2 = _ref2.key, restTabProps = _objectWithoutProperties(_ref2, _excluded214);
        return /* @__PURE__ */ React291.createElement(TabPane_default, _extends({
          tab: label,
          key: key2,
          tabKey: key2
        }, restTabProps));
      })
    });
    return renderTabBar(tabNavBarProps, TabNavList_default);
  }
  return /* @__PURE__ */ React291.createElement(TabNavList_default, restProps);
};
if (true) {
  TabNavListWrapper.displayName = "TabNavListWrapper";
}
var Wrapper_default = TabNavListWrapper;

// ../../node_modules/rc-tabs/es/TabPanelList/index.js
var import_classnames98 = __toESM(require_classnames());
var React292 = __toESM(require_react());
var _excluded46 = ["key", "forceRender", "style", "className", "destroyInactiveTabPane"];
var TabPanelList = function TabPanelList2(props) {
  var id = props.id, activeKey = props.activeKey, animated = props.animated, tabPosition = props.tabPosition, destroyInactiveTabPane = props.destroyInactiveTabPane;
  var _React$useContext = React292.useContext(TabContext_default), prefixCls = _React$useContext.prefixCls, tabs = _React$useContext.tabs;
  var tabPaneAnimated = animated.tabPane;
  var tabPanePrefixCls = "".concat(prefixCls, "-tabpane");
  return /* @__PURE__ */ React292.createElement("div", {
    className: (0, import_classnames98.default)("".concat(prefixCls, "-content-holder"))
  }, /* @__PURE__ */ React292.createElement("div", {
    className: (0, import_classnames98.default)("".concat(prefixCls, "-content"), "".concat(prefixCls, "-content-").concat(tabPosition), _defineProperty({}, "".concat(prefixCls, "-content-animated"), tabPaneAnimated))
  }, tabs.map(function(item) {
    var key2 = item.key, forceRender = item.forceRender, paneStyle = item.style, paneClassName = item.className, itemDestroyInactiveTabPane = item.destroyInactiveTabPane, restTabProps = _objectWithoutProperties(item, _excluded46);
    var active = key2 === activeKey;
    return /* @__PURE__ */ React292.createElement(es_default2, _extends({
      key: key2,
      visible: active,
      forceRender,
      removeOnLeave: !!(destroyInactiveTabPane || itemDestroyInactiveTabPane),
      leavedClassName: "".concat(tabPanePrefixCls, "-hidden")
    }, animated.tabPaneMotion), function(_ref, ref3) {
      var motionStyle = _ref.style, motionClassName = _ref.className;
      return /* @__PURE__ */ React292.createElement(TabPane_default, _extends({}, restTabProps, {
        prefixCls: tabPanePrefixCls,
        id,
        tabKey: key2,
        animated: tabPaneAnimated,
        active,
        style: _objectSpread2(_objectSpread2({}, paneStyle), motionStyle),
        className: (0, import_classnames98.default)(paneClassName, motionClassName),
        ref: ref3
      }));
    });
  })));
};
var TabPanelList_default = TabPanelList;

// ../../node_modules/rc-tabs/es/hooks/useAnimateConfig.js
function useAnimateConfig() {
  var animated = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
    inkBar: true,
    tabPane: false
  };
  var mergedAnimated;
  if (animated === false) {
    mergedAnimated = {
      inkBar: false,
      tabPane: false
    };
  } else if (animated === true) {
    mergedAnimated = {
      inkBar: true,
      tabPane: false
    };
  } else {
    mergedAnimated = _objectSpread2({
      inkBar: true
    }, _typeof(animated) === "object" ? animated : {});
  }
  if (mergedAnimated.tabPaneMotion && mergedAnimated.tabPane === void 0) {
    mergedAnimated.tabPane = true;
  }
  if (!mergedAnimated.tabPaneMotion && mergedAnimated.tabPane) {
    if (true) {
      warning_default(false, "`animated.tabPane` is true but `animated.tabPaneMotion` is not provided. Motion will not work.");
    }
    mergedAnimated.tabPane = false;
  }
  return mergedAnimated;
}

// ../../node_modules/rc-tabs/es/Tabs.js
var _excluded47 = ["id", "prefixCls", "className", "items", "direction", "activeKey", "defaultActiveKey", "editable", "animated", "tabPosition", "tabBarGutter", "tabBarStyle", "tabBarExtraContent", "locale", "more", "destroyInactiveTabPane", "renderTabBar", "onChange", "onTabClick", "onTabScroll", "getPopupContainer", "popupClassName", "indicator"];
var uuid6 = 0;
var Tabs = /* @__PURE__ */ React293.forwardRef(function(props, ref3) {
  var id = props.id, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-tabs" : _props$prefixCls, className2 = props.className, items = props.items, direction = props.direction, activeKey = props.activeKey, defaultActiveKey = props.defaultActiveKey, editable = props.editable, animated = props.animated, _props$tabPosition = props.tabPosition, tabPosition = _props$tabPosition === void 0 ? "top" : _props$tabPosition, tabBarGutter = props.tabBarGutter, tabBarStyle = props.tabBarStyle, tabBarExtraContent = props.tabBarExtraContent, locale6 = props.locale, more = props.more, destroyInactiveTabPane = props.destroyInactiveTabPane, renderTabBar = props.renderTabBar, onChange = props.onChange, onTabClick = props.onTabClick, onTabScroll = props.onTabScroll, getPopupContainer = props.getPopupContainer, popupClassName = props.popupClassName, indicator = props.indicator, restProps = _objectWithoutProperties(props, _excluded47);
  var tabs = React293.useMemo(function() {
    return (items || []).filter(function(item) {
      return item && _typeof(item) === "object" && "key" in item;
    });
  }, [items]);
  var rtl = direction === "rtl";
  var mergedAnimated = useAnimateConfig(animated);
  var _useState = (0, import_react96.useState)(false), _useState2 = _slicedToArray(_useState, 2), mobile = _useState2[0], setMobile = _useState2[1];
  (0, import_react96.useEffect)(function() {
    setMobile(isMobile_default());
  }, []);
  var _useMergedState = useMergedState(function() {
    var _tabs$;
    return (_tabs$ = tabs[0]) === null || _tabs$ === void 0 ? void 0 : _tabs$.key;
  }, {
    value: activeKey,
    defaultValue: defaultActiveKey
  }), _useMergedState2 = _slicedToArray(_useMergedState, 2), mergedActiveKey = _useMergedState2[0], setMergedActiveKey = _useMergedState2[1];
  var _useState3 = (0, import_react96.useState)(function() {
    return tabs.findIndex(function(tab) {
      return tab.key === mergedActiveKey;
    });
  }), _useState4 = _slicedToArray(_useState3, 2), activeIndex = _useState4[0], setActiveIndex = _useState4[1];
  (0, import_react96.useEffect)(function() {
    var newActiveIndex = tabs.findIndex(function(tab) {
      return tab.key === mergedActiveKey;
    });
    if (newActiveIndex === -1) {
      var _tabs$newActiveIndex;
      newActiveIndex = Math.max(0, Math.min(activeIndex, tabs.length - 1));
      setMergedActiveKey((_tabs$newActiveIndex = tabs[newActiveIndex]) === null || _tabs$newActiveIndex === void 0 ? void 0 : _tabs$newActiveIndex.key);
    }
    setActiveIndex(newActiveIndex);
  }, [tabs.map(function(tab) {
    return tab.key;
  }).join("_"), mergedActiveKey, activeIndex]);
  var _useMergedState3 = useMergedState(null, {
    value: id
  }), _useMergedState4 = _slicedToArray(_useMergedState3, 2), mergedId = _useMergedState4[0], setMergedId = _useMergedState4[1];
  (0, import_react96.useEffect)(function() {
    if (!id) {
      setMergedId("rc-tabs-".concat(false ? "test" : uuid6));
      uuid6 += 1;
    }
  }, []);
  function onInternalTabClick(key2, e3) {
    onTabClick === null || onTabClick === void 0 || onTabClick(key2, e3);
    var isActiveChanged = key2 !== mergedActiveKey;
    setMergedActiveKey(key2);
    if (isActiveChanged) {
      onChange === null || onChange === void 0 || onChange(key2);
    }
  }
  var sharedProps = {
    id: mergedId,
    activeKey: mergedActiveKey,
    animated: mergedAnimated,
    tabPosition,
    rtl,
    mobile
  };
  var tabNavBarProps = _objectSpread2(_objectSpread2({}, sharedProps), {}, {
    editable,
    locale: locale6,
    more,
    tabBarGutter,
    onTabClick: onInternalTabClick,
    onTabScroll,
    extra: tabBarExtraContent,
    style: tabBarStyle,
    panes: null,
    getPopupContainer,
    popupClassName,
    indicator
  });
  return /* @__PURE__ */ React293.createElement(TabContext_default.Provider, {
    value: {
      tabs,
      prefixCls
    }
  }, /* @__PURE__ */ React293.createElement("div", _extends({
    ref: ref3,
    id,
    className: (0, import_classnames99.default)(prefixCls, "".concat(prefixCls, "-").concat(tabPosition), _defineProperty(_defineProperty(_defineProperty({}, "".concat(prefixCls, "-mobile"), mobile), "".concat(prefixCls, "-editable"), editable), "".concat(prefixCls, "-rtl"), rtl), className2)
  }, restProps), /* @__PURE__ */ React293.createElement(Wrapper_default, _extends({}, tabNavBarProps, {
    renderTabBar
  })), /* @__PURE__ */ React293.createElement(TabPanelList_default, _extends({
    destroyInactiveTabPane
  }, sharedProps, {
    animated: mergedAnimated
  }))));
});
if (true) {
  Tabs.displayName = "Tabs";
}
var Tabs_default = Tabs;

// ../../node_modules/rc-tabs/es/index.js
var es_default17 = Tabs_default;

// ../../node_modules/antd/es/tabs/hooks/useAnimateConfig.js
var motion = {
  motionAppear: false,
  motionEnter: true,
  motionLeave: true
};
function useAnimateConfig2(prefixCls, animated = {
  inkBar: true,
  tabPane: false
}) {
  let mergedAnimated;
  if (animated === false) {
    mergedAnimated = {
      inkBar: false,
      tabPane: false
    };
  } else if (animated === true) {
    mergedAnimated = {
      inkBar: true,
      tabPane: true
    };
  } else {
    mergedAnimated = Object.assign({
      inkBar: true
    }, typeof animated === "object" ? animated : {});
  }
  if (mergedAnimated.tabPane) {
    mergedAnimated.tabPaneMotion = Object.assign(Object.assign({}, motion), {
      motionName: getTransitionName2(prefixCls, "switch")
    });
  }
  return mergedAnimated;
}

// ../../node_modules/antd/es/tabs/hooks/useLegacyItems.js
var React294 = __toESM(require_react());
var __rest22 = function(s, e3) {
  var t2 = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e3.indexOf(p) < 0) t2[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e3.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t2[p[i]] = s[p[i]];
  }
  return t2;
};
function filter2(items) {
  return items.filter((item) => item);
}
function useLegacyItems(items, children) {
  if (true) {
    const warning6 = devUseWarning("Tabs");
    warning6.deprecated(!children, "Tabs.TabPane", "items");
  }
  if (items) {
    return items.map((item) => {
      var _a;
      const mergedDestroyOnHidden = (_a = item.destroyOnHidden) !== null && _a !== void 0 ? _a : item.destroyInactiveTabPane;
      return Object.assign(Object.assign({}, item), {
        // TODO: In the future, destroyInactiveTabPane in rc-tabs needs to be upgrade to destroyOnHidden
        destroyInactiveTabPane: mergedDestroyOnHidden
      });
    });
  }
  const childrenItems = toArray(children).map((node2) => {
    if (/* @__PURE__ */ React294.isValidElement(node2)) {
      const {
        key: key2,
        props
      } = node2;
      const _a = props || {}, {
        tab
      } = _a, restProps = __rest22(_a, ["tab"]);
      const item = Object.assign(Object.assign({
        key: String(key2)
      }, restProps), {
        label: tab
      });
      return item;
    }
    return null;
  });
  return filter2(childrenItems);
}
var useLegacyItems_default = useLegacyItems;

// ../../node_modules/antd/es/tabs/style/motion.js
var genMotionStyle = (token2) => {
  const {
    componentCls,
    motionDurationSlow
  } = token2;
  return [
    {
      [componentCls]: {
        [`${componentCls}-switch`]: {
          "&-appear, &-enter": {
            transition: "none",
            "&-start": {
              opacity: 0
            },
            "&-active": {
              opacity: 1,
              transition: `opacity ${motionDurationSlow}`
            }
          },
          "&-leave": {
            position: "absolute",
            transition: "none",
            inset: 0,
            "&-start": {
              opacity: 1
            },
            "&-active": {
              opacity: 0,
              transition: `opacity ${motionDurationSlow}`
            }
          }
        }
      }
    },
    // Follow code may reuse in other components
    [initSlideMotion(token2, "slide-up"), initSlideMotion(token2, "slide-down")]
  ];
};
var motion_default2 = genMotionStyle;

// ../../node_modules/antd/es/tabs/style/index.js
var genCardStyle = (token2) => {
  const {
    componentCls,
    tabsCardPadding,
    cardBg,
    cardGutter,
    colorBorderSecondary,
    itemSelectedColor
  } = token2;
  return {
    [`${componentCls}-card`]: {
      [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
        [`${componentCls}-tab`]: {
          margin: 0,
          padding: tabsCardPadding,
          background: cardBg,
          border: `${unit(token2.lineWidth)} ${token2.lineType} ${colorBorderSecondary}`,
          transition: `all ${token2.motionDurationSlow} ${token2.motionEaseInOut}`
        },
        [`${componentCls}-tab-active`]: {
          color: itemSelectedColor,
          background: token2.colorBgContainer
        },
        [`${componentCls}-tab-focus:has(${componentCls}-tab-btn:focus-visible)`]: genFocusOutline(token2, -3),
        [`& ${componentCls}-tab${componentCls}-tab-focus ${componentCls}-tab-btn:focus-visible`]: {
          outline: "none"
        },
        [`${componentCls}-ink-bar`]: {
          visibility: "hidden"
        }
      },
      // ========================== Top & Bottom ==========================
      [`&${componentCls}-top, &${componentCls}-bottom`]: {
        [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
          [`${componentCls}-tab + ${componentCls}-tab`]: {
            marginLeft: {
              _skip_check_: true,
              value: unit(cardGutter)
            }
          }
        }
      },
      [`&${componentCls}-top`]: {
        [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
          [`${componentCls}-tab`]: {
            borderRadius: `${unit(token2.borderRadiusLG)} ${unit(token2.borderRadiusLG)} 0 0`
          },
          [`${componentCls}-tab-active`]: {
            borderBottomColor: token2.colorBgContainer
          }
        }
      },
      [`&${componentCls}-bottom`]: {
        [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
          [`${componentCls}-tab`]: {
            borderRadius: `0 0 ${unit(token2.borderRadiusLG)} ${unit(token2.borderRadiusLG)}`
          },
          [`${componentCls}-tab-active`]: {
            borderTopColor: token2.colorBgContainer
          }
        }
      },
      // ========================== Left & Right ==========================
      [`&${componentCls}-left, &${componentCls}-right`]: {
        [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
          [`${componentCls}-tab + ${componentCls}-tab`]: {
            marginTop: unit(cardGutter)
          }
        }
      },
      [`&${componentCls}-left`]: {
        [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
          [`${componentCls}-tab`]: {
            borderRadius: {
              _skip_check_: true,
              value: `${unit(token2.borderRadiusLG)} 0 0 ${unit(token2.borderRadiusLG)}`
            }
          },
          [`${componentCls}-tab-active`]: {
            borderRightColor: {
              _skip_check_: true,
              value: token2.colorBgContainer
            }
          }
        }
      },
      [`&${componentCls}-right`]: {
        [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
          [`${componentCls}-tab`]: {
            borderRadius: {
              _skip_check_: true,
              value: `0 ${unit(token2.borderRadiusLG)} ${unit(token2.borderRadiusLG)} 0`
            }
          },
          [`${componentCls}-tab-active`]: {
            borderLeftColor: {
              _skip_check_: true,
              value: token2.colorBgContainer
            }
          }
        }
      }
    }
  };
};
var genDropdownStyle = (token2) => {
  const {
    componentCls,
    itemHoverColor,
    dropdownEdgeChildVerticalPadding
  } = token2;
  return {
    [`${componentCls}-dropdown`]: Object.assign(Object.assign({}, resetComponent(token2)), {
      position: "absolute",
      top: -9999,
      left: {
        _skip_check_: true,
        value: -9999
      },
      zIndex: token2.zIndexPopup,
      display: "block",
      "&-hidden": {
        display: "none"
      },
      [`${componentCls}-dropdown-menu`]: {
        maxHeight: token2.tabsDropdownHeight,
        margin: 0,
        padding: `${unit(dropdownEdgeChildVerticalPadding)} 0`,
        overflowX: "hidden",
        overflowY: "auto",
        textAlign: {
          _skip_check_: true,
          value: "left"
        },
        listStyleType: "none",
        backgroundColor: token2.colorBgContainer,
        backgroundClip: "padding-box",
        borderRadius: token2.borderRadiusLG,
        outline: "none",
        boxShadow: token2.boxShadowSecondary,
        "&-item": Object.assign(Object.assign({}, textEllipsis), {
          display: "flex",
          alignItems: "center",
          minWidth: token2.tabsDropdownWidth,
          margin: 0,
          padding: `${unit(token2.paddingXXS)} ${unit(token2.paddingSM)}`,
          color: token2.colorText,
          fontWeight: "normal",
          fontSize: token2.fontSize,
          lineHeight: token2.lineHeight,
          cursor: "pointer",
          transition: `all ${token2.motionDurationSlow}`,
          "> span": {
            flex: 1,
            whiteSpace: "nowrap"
          },
          "&-remove": {
            flex: "none",
            marginLeft: {
              _skip_check_: true,
              value: token2.marginSM
            },
            color: token2.colorIcon,
            fontSize: token2.fontSizeSM,
            background: "transparent",
            border: 0,
            cursor: "pointer",
            "&:hover": {
              color: itemHoverColor
            }
          },
          "&:hover": {
            background: token2.controlItemBgHover
          },
          "&-disabled": {
            "&, &:hover": {
              color: token2.colorTextDisabled,
              background: "transparent",
              cursor: "not-allowed"
            }
          }
        })
      }
    })
  };
};
var genPositionStyle = (token2) => {
  const {
    componentCls,
    margin,
    colorBorderSecondary,
    horizontalMargin,
    verticalItemPadding,
    verticalItemMargin,
    calc
  } = token2;
  return {
    // ========================== Top & Bottom ==========================
    [`${componentCls}-top, ${componentCls}-bottom`]: {
      flexDirection: "column",
      [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
        margin: horizontalMargin,
        "&::before": {
          position: "absolute",
          right: {
            _skip_check_: true,
            value: 0
          },
          left: {
            _skip_check_: true,
            value: 0
          },
          borderBottom: `${unit(token2.lineWidth)} ${token2.lineType} ${colorBorderSecondary}`,
          content: "''"
        },
        [`${componentCls}-ink-bar`]: {
          height: token2.lineWidthBold,
          "&-animated": {
            transition: `width ${token2.motionDurationSlow}, left ${token2.motionDurationSlow},
            right ${token2.motionDurationSlow}`
          }
        },
        [`${componentCls}-nav-wrap`]: {
          "&::before, &::after": {
            top: 0,
            bottom: 0,
            width: token2.controlHeight
          },
          "&::before": {
            left: {
              _skip_check_: true,
              value: 0
            },
            boxShadow: token2.boxShadowTabsOverflowLeft
          },
          "&::after": {
            right: {
              _skip_check_: true,
              value: 0
            },
            boxShadow: token2.boxShadowTabsOverflowRight
          },
          [`&${componentCls}-nav-wrap-ping-left::before`]: {
            opacity: 1
          },
          [`&${componentCls}-nav-wrap-ping-right::after`]: {
            opacity: 1
          }
        }
      }
    },
    [`${componentCls}-top`]: {
      [`> ${componentCls}-nav,
        > div > ${componentCls}-nav`]: {
        "&::before": {
          bottom: 0
        },
        [`${componentCls}-ink-bar`]: {
          bottom: 0
        }
      }
    },
    [`${componentCls}-bottom`]: {
      [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
        order: 1,
        marginTop: margin,
        marginBottom: 0,
        "&::before": {
          top: 0
        },
        [`${componentCls}-ink-bar`]: {
          top: 0
        }
      },
      [`> ${componentCls}-content-holder, > div > ${componentCls}-content-holder`]: {
        order: 0
      }
    },
    // ========================== Left & Right ==========================
    [`${componentCls}-left, ${componentCls}-right`]: {
      [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
        flexDirection: "column",
        minWidth: calc(token2.controlHeight).mul(1.25).equal(),
        // >>>>>>>>>>> Tab
        [`${componentCls}-tab`]: {
          padding: verticalItemPadding,
          textAlign: "center"
        },
        [`${componentCls}-tab + ${componentCls}-tab`]: {
          margin: verticalItemMargin
        },
        // >>>>>>>>>>> Nav
        [`${componentCls}-nav-wrap`]: {
          flexDirection: "column",
          "&::before, &::after": {
            right: {
              _skip_check_: true,
              value: 0
            },
            left: {
              _skip_check_: true,
              value: 0
            },
            height: token2.controlHeight
          },
          "&::before": {
            top: 0,
            boxShadow: token2.boxShadowTabsOverflowTop
          },
          "&::after": {
            bottom: 0,
            boxShadow: token2.boxShadowTabsOverflowBottom
          },
          [`&${componentCls}-nav-wrap-ping-top::before`]: {
            opacity: 1
          },
          [`&${componentCls}-nav-wrap-ping-bottom::after`]: {
            opacity: 1
          }
        },
        // >>>>>>>>>>> Ink Bar
        [`${componentCls}-ink-bar`]: {
          width: token2.lineWidthBold,
          "&-animated": {
            transition: `height ${token2.motionDurationSlow}, top ${token2.motionDurationSlow}`
          }
        },
        [`${componentCls}-nav-list, ${componentCls}-nav-operations`]: {
          flex: "1 0 auto",
          // fix safari scroll problem
          flexDirection: "column"
        }
      }
    },
    [`${componentCls}-left`]: {
      [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
        [`${componentCls}-ink-bar`]: {
          right: {
            _skip_check_: true,
            value: 0
          }
        }
      },
      [`> ${componentCls}-content-holder, > div > ${componentCls}-content-holder`]: {
        marginLeft: {
          _skip_check_: true,
          value: unit(calc(token2.lineWidth).mul(-1).equal())
        },
        borderLeft: {
          _skip_check_: true,
          value: `${unit(token2.lineWidth)} ${token2.lineType} ${token2.colorBorder}`
        },
        [`> ${componentCls}-content > ${componentCls}-tabpane`]: {
          paddingLeft: {
            _skip_check_: true,
            value: token2.paddingLG
          }
        }
      }
    },
    [`${componentCls}-right`]: {
      [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
        order: 1,
        [`${componentCls}-ink-bar`]: {
          left: {
            _skip_check_: true,
            value: 0
          }
        }
      },
      [`> ${componentCls}-content-holder, > div > ${componentCls}-content-holder`]: {
        order: 0,
        marginRight: {
          _skip_check_: true,
          value: calc(token2.lineWidth).mul(-1).equal()
        },
        borderRight: {
          _skip_check_: true,
          value: `${unit(token2.lineWidth)} ${token2.lineType} ${token2.colorBorder}`
        },
        [`> ${componentCls}-content > ${componentCls}-tabpane`]: {
          paddingRight: {
            _skip_check_: true,
            value: token2.paddingLG
          }
        }
      }
    }
  };
};
var genSizeStyle3 = (token2) => {
  const {
    componentCls,
    cardPaddingSM,
    cardPaddingLG,
    cardHeightSM,
    cardHeightLG,
    horizontalItemPaddingSM,
    horizontalItemPaddingLG
  } = token2;
  return {
    // >>>>> shared
    [componentCls]: {
      "&-small": {
        [`> ${componentCls}-nav`]: {
          [`${componentCls}-tab`]: {
            padding: horizontalItemPaddingSM,
            fontSize: token2.titleFontSizeSM
          }
        }
      },
      "&-large": {
        [`> ${componentCls}-nav`]: {
          [`${componentCls}-tab`]: {
            padding: horizontalItemPaddingLG,
            fontSize: token2.titleFontSizeLG,
            lineHeight: token2.lineHeightLG
          }
        }
      }
    },
    // >>>>> card
    [`${componentCls}-card`]: {
      // Small
      [`&${componentCls}-small`]: {
        [`> ${componentCls}-nav`]: {
          [`${componentCls}-tab`]: {
            padding: cardPaddingSM
          },
          [`${componentCls}-nav-add`]: {
            minWidth: cardHeightSM,
            minHeight: cardHeightSM
          }
        },
        [`&${componentCls}-bottom`]: {
          [`> ${componentCls}-nav ${componentCls}-tab`]: {
            borderRadius: `0 0 ${unit(token2.borderRadius)} ${unit(token2.borderRadius)}`
          }
        },
        [`&${componentCls}-top`]: {
          [`> ${componentCls}-nav ${componentCls}-tab`]: {
            borderRadius: `${unit(token2.borderRadius)} ${unit(token2.borderRadius)} 0 0`
          }
        },
        [`&${componentCls}-right`]: {
          [`> ${componentCls}-nav ${componentCls}-tab`]: {
            borderRadius: {
              _skip_check_: true,
              value: `0 ${unit(token2.borderRadius)} ${unit(token2.borderRadius)} 0`
            }
          }
        },
        [`&${componentCls}-left`]: {
          [`> ${componentCls}-nav ${componentCls}-tab`]: {
            borderRadius: {
              _skip_check_: true,
              value: `${unit(token2.borderRadius)} 0 0 ${unit(token2.borderRadius)}`
            }
          }
        }
      },
      // Large
      [`&${componentCls}-large`]: {
        [`> ${componentCls}-nav`]: {
          [`${componentCls}-tab`]: {
            padding: cardPaddingLG
          },
          [`${componentCls}-nav-add`]: {
            minWidth: cardHeightLG,
            minHeight: cardHeightLG
          }
        }
      }
    }
  };
};
var genTabStyle = (token2) => {
  const {
    componentCls,
    itemActiveColor,
    itemHoverColor,
    iconCls,
    tabsHorizontalItemMargin,
    horizontalItemPadding,
    itemSelectedColor,
    itemColor
  } = token2;
  const tabCls = `${componentCls}-tab`;
  return {
    [tabCls]: {
      position: "relative",
      WebkitTouchCallout: "none",
      WebkitTapHighlightColor: "transparent",
      display: "inline-flex",
      alignItems: "center",
      padding: horizontalItemPadding,
      fontSize: token2.titleFontSize,
      background: "transparent",
      border: 0,
      outline: "none",
      cursor: "pointer",
      color: itemColor,
      "&-btn, &-remove": {
        "&:focus:not(:focus-visible), &:active": {
          color: itemActiveColor
        }
      },
      "&-btn": {
        outline: "none",
        transition: `all ${token2.motionDurationSlow}`,
        [`${tabCls}-icon:not(:last-child)`]: {
          marginInlineEnd: token2.marginSM
        }
      },
      "&-remove": Object.assign({
        flex: "none",
        lineHeight: 1,
        marginRight: {
          _skip_check_: true,
          value: token2.calc(token2.marginXXS).mul(-1).equal()
        },
        marginLeft: {
          _skip_check_: true,
          value: token2.marginXS
        },
        color: token2.colorIcon,
        fontSize: token2.fontSizeSM,
        background: "transparent",
        border: "none",
        outline: "none",
        cursor: "pointer",
        transition: `all ${token2.motionDurationSlow}`,
        "&:hover": {
          color: token2.colorTextHeading
        }
      }, genFocusStyle(token2)),
      "&:hover": {
        color: itemHoverColor
      },
      [`&${tabCls}-active ${tabCls}-btn`]: {
        color: itemSelectedColor,
        textShadow: token2.tabsActiveTextShadow
      },
      [`&${tabCls}-focus ${tabCls}-btn:focus-visible`]: genFocusOutline(token2),
      [`&${tabCls}-disabled`]: {
        color: token2.colorTextDisabled,
        cursor: "not-allowed"
      },
      [`&${tabCls}-disabled ${tabCls}-btn, &${tabCls}-disabled ${componentCls}-remove`]: {
        "&:focus, &:active": {
          color: token2.colorTextDisabled
        }
      },
      [`& ${tabCls}-remove ${iconCls}`]: {
        margin: 0,
        verticalAlign: "middle"
      },
      [`${iconCls}:not(:last-child)`]: {
        marginRight: {
          _skip_check_: true,
          value: token2.marginSM
        }
      }
    },
    [`${tabCls} + ${tabCls}`]: {
      margin: {
        _skip_check_: true,
        value: tabsHorizontalItemMargin
      }
    }
  };
};
var genRtlStyle = (token2) => {
  const {
    componentCls,
    tabsHorizontalItemMarginRTL,
    iconCls,
    cardGutter,
    calc
  } = token2;
  const rtlCls = `${componentCls}-rtl`;
  return {
    [rtlCls]: {
      direction: "rtl",
      [`${componentCls}-nav`]: {
        [`${componentCls}-tab`]: {
          margin: {
            _skip_check_: true,
            value: tabsHorizontalItemMarginRTL
          },
          [`${componentCls}-tab:last-of-type`]: {
            marginLeft: {
              _skip_check_: true,
              value: 0
            }
          },
          [iconCls]: {
            marginRight: {
              _skip_check_: true,
              value: 0
            },
            marginLeft: {
              _skip_check_: true,
              value: unit(token2.marginSM)
            }
          },
          [`${componentCls}-tab-remove`]: {
            marginRight: {
              _skip_check_: true,
              value: unit(token2.marginXS)
            },
            marginLeft: {
              _skip_check_: true,
              value: unit(calc(token2.marginXXS).mul(-1).equal())
            },
            [iconCls]: {
              margin: 0
            }
          }
        }
      },
      [`&${componentCls}-left`]: {
        [`> ${componentCls}-nav`]: {
          order: 1
        },
        [`> ${componentCls}-content-holder`]: {
          order: 0
        }
      },
      [`&${componentCls}-right`]: {
        [`> ${componentCls}-nav`]: {
          order: 0
        },
        [`> ${componentCls}-content-holder`]: {
          order: 1
        }
      },
      // ====================== Card ======================
      [`&${componentCls}-card${componentCls}-top, &${componentCls}-card${componentCls}-bottom`]: {
        [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
          [`${componentCls}-tab + ${componentCls}-tab`]: {
            marginRight: {
              _skip_check_: true,
              value: cardGutter
            },
            marginLeft: {
              _skip_check_: true,
              value: 0
            }
          }
        }
      }
    },
    [`${componentCls}-dropdown-rtl`]: {
      direction: "rtl"
    },
    [`${componentCls}-menu-item`]: {
      [`${componentCls}-dropdown-rtl`]: {
        textAlign: {
          _skip_check_: true,
          value: "right"
        }
      }
    }
  };
};
var genTabsStyle = (token2) => {
  const {
    componentCls,
    tabsCardPadding,
    cardHeight,
    cardGutter,
    itemHoverColor,
    itemActiveColor,
    colorBorderSecondary
  } = token2;
  return {
    [componentCls]: Object.assign(Object.assign(Object.assign(Object.assign({}, resetComponent(token2)), {
      display: "flex",
      // ========================== Navigation ==========================
      [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
        position: "relative",
        display: "flex",
        flex: "none",
        alignItems: "center",
        [`${componentCls}-nav-wrap`]: {
          position: "relative",
          display: "flex",
          flex: "auto",
          alignSelf: "stretch",
          overflow: "hidden",
          whiteSpace: "nowrap",
          transform: "translate(0)",
          // Fix chrome render bug
          // >>>>> Ping shadow
          "&::before, &::after": {
            position: "absolute",
            zIndex: 1,
            opacity: 0,
            transition: `opacity ${token2.motionDurationSlow}`,
            content: "''",
            pointerEvents: "none"
          }
        },
        [`${componentCls}-nav-list`]: {
          position: "relative",
          display: "flex",
          transition: `opacity ${token2.motionDurationSlow}`
        },
        // >>>>>>>> Operations
        [`${componentCls}-nav-operations`]: {
          display: "flex",
          alignSelf: "stretch"
        },
        [`${componentCls}-nav-operations-hidden`]: {
          position: "absolute",
          visibility: "hidden",
          pointerEvents: "none"
        },
        [`${componentCls}-nav-more`]: {
          position: "relative",
          padding: tabsCardPadding,
          background: "transparent",
          border: 0,
          color: token2.colorText,
          "&::after": {
            position: "absolute",
            right: {
              _skip_check_: true,
              value: 0
            },
            bottom: 0,
            left: {
              _skip_check_: true,
              value: 0
            },
            height: token2.calc(token2.controlHeightLG).div(8).equal(),
            transform: "translateY(100%)",
            content: "''"
          }
        },
        [`${componentCls}-nav-add`]: Object.assign({
          minWidth: cardHeight,
          minHeight: cardHeight,
          marginLeft: {
            _skip_check_: true,
            value: cardGutter
          },
          background: "transparent",
          border: `${unit(token2.lineWidth)} ${token2.lineType} ${colorBorderSecondary}`,
          borderRadius: `${unit(token2.borderRadiusLG)} ${unit(token2.borderRadiusLG)} 0 0`,
          outline: "none",
          cursor: "pointer",
          color: token2.colorText,
          transition: `all ${token2.motionDurationSlow} ${token2.motionEaseInOut}`,
          "&:hover": {
            color: itemHoverColor
          },
          "&:active, &:focus:not(:focus-visible)": {
            color: itemActiveColor
          }
        }, genFocusStyle(token2, -3))
      },
      [`${componentCls}-extra-content`]: {
        flex: "none"
      },
      // ============================ InkBar ============================
      [`${componentCls}-ink-bar`]: {
        position: "absolute",
        background: token2.inkBarColor,
        pointerEvents: "none"
      }
    }), genTabStyle(token2)), {
      // =========================== TabPanes ===========================
      [`${componentCls}-content`]: {
        position: "relative",
        width: "100%"
      },
      [`${componentCls}-content-holder`]: {
        flex: "auto",
        minWidth: 0,
        minHeight: 0
      },
      [`${componentCls}-tabpane`]: Object.assign(Object.assign({}, genFocusStyle(token2)), {
        "&-hidden": {
          display: "none"
        }
      })
    }),
    [`${componentCls}-centered`]: {
      [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
        [`${componentCls}-nav-wrap`]: {
          [`&:not([class*='${componentCls}-nav-wrap-ping']) > ${componentCls}-nav-list`]: {
            margin: "auto"
          }
        }
      }
    }
  };
};
var prepareComponentToken14 = (token2) => {
  const {
    cardHeight,
    cardHeightSM,
    cardHeightLG,
    controlHeight,
    controlHeightLG
  } = token2;
  const mergedCardHeight = cardHeight || controlHeightLG;
  const mergedCardHeightSM = cardHeightSM || controlHeight;
  const mergedCardHeightLG = cardHeightLG || controlHeightLG + 8;
  return {
    zIndexPopup: token2.zIndexPopupBase + 50,
    cardBg: token2.colorFillAlter,
    // We can not pass this as valid value,
    // Since `cardHeight` will lock nav add button height.
    cardHeight: mergedCardHeight,
    cardHeightSM: mergedCardHeightSM,
    cardHeightLG: mergedCardHeightLG,
    // Initialize with empty string, because cardPadding will be calculated with cardHeight by default.
    cardPadding: `${(mergedCardHeight - token2.fontHeight) / 2 - token2.lineWidth}px ${token2.padding}px`,
    cardPaddingSM: `${(mergedCardHeightSM - token2.fontHeight) / 2 - token2.lineWidth}px ${token2.paddingXS}px`,
    cardPaddingLG: `${(mergedCardHeightLG - token2.fontHeightLG) / 2 - token2.lineWidth}px ${token2.padding}px`,
    titleFontSize: token2.fontSize,
    titleFontSizeLG: token2.fontSizeLG,
    titleFontSizeSM: token2.fontSize,
    inkBarColor: token2.colorPrimary,
    horizontalMargin: `0 0 ${token2.margin}px 0`,
    horizontalItemGutter: 32,
    // Fixed Value
    // Initialize with empty string, because horizontalItemMargin will be calculated with horizontalItemGutter by default.
    horizontalItemMargin: ``,
    horizontalItemMarginRTL: ``,
    horizontalItemPadding: `${token2.paddingSM}px 0`,
    horizontalItemPaddingSM: `${token2.paddingXS}px 0`,
    horizontalItemPaddingLG: `${token2.padding}px 0`,
    verticalItemPadding: `${token2.paddingXS}px ${token2.paddingLG}px`,
    verticalItemMargin: `${token2.margin}px 0 0 0`,
    itemColor: token2.colorText,
    itemSelectedColor: token2.colorPrimary,
    itemHoverColor: token2.colorPrimaryHover,
    itemActiveColor: token2.colorPrimaryActive,
    cardGutter: token2.marginXXS / 2
  };
};
var style_default18 = genStyleHooks("Tabs", (token2) => {
  const tabsToken = merge2(token2, {
    // `cardPadding` is empty by default, so we could calculate with dynamic `cardHeight`
    tabsCardPadding: token2.cardPadding,
    dropdownEdgeChildVerticalPadding: token2.paddingXXS,
    tabsActiveTextShadow: "0 0 0.25px currentcolor",
    tabsDropdownHeight: 200,
    tabsDropdownWidth: 120,
    tabsHorizontalItemMargin: `0 0 0 ${unit(token2.horizontalItemGutter)}`,
    tabsHorizontalItemMarginRTL: `0 0 0 ${unit(token2.horizontalItemGutter)}`
  });
  return [genSizeStyle3(tabsToken), genRtlStyle(tabsToken), genPositionStyle(tabsToken), genDropdownStyle(tabsToken), genCardStyle(tabsToken), genTabsStyle(tabsToken), motion_default2(tabsToken)];
}, prepareComponentToken14);

// ../../node_modules/antd/es/tabs/TabPane.js
var TabPane2 = () => null;
if (true) {
  TabPane2.displayName = "DeprecatedTabPane";
}
var TabPane_default2 = TabPane2;

// ../../node_modules/antd/es/tabs/index.js
var __rest23 = function(s, e3) {
  var t2 = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e3.indexOf(p) < 0) t2[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e3.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t2[p[i]] = s[p[i]];
  }
  return t2;
};
var InternalTabs = /* @__PURE__ */ React295.forwardRef((props, ref3) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
  const {
    type: type5,
    className: className2,
    rootClassName,
    size: customSize,
    onEdit,
    hideAdd,
    centered,
    addIcon,
    removeIcon,
    moreIcon,
    more,
    popupClassName,
    children,
    items,
    animated,
    style: style2,
    indicatorSize,
    indicator,
    destroyInactiveTabPane,
    destroyOnHidden
  } = props, otherProps = __rest23(props, ["type", "className", "rootClassName", "size", "onEdit", "hideAdd", "centered", "addIcon", "removeIcon", "moreIcon", "more", "popupClassName", "children", "items", "animated", "style", "indicatorSize", "indicator", "destroyInactiveTabPane", "destroyOnHidden"]);
  const {
    prefixCls: customizePrefixCls
  } = otherProps;
  const {
    direction,
    tabs,
    getPrefixCls,
    getPopupContainer
  } = React295.useContext(ConfigContext);
  const prefixCls = getPrefixCls("tabs", customizePrefixCls);
  const rootCls = useCSSVarCls_default(prefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = style_default18(prefixCls, rootCls);
  const tabsRef = React295.useRef(null);
  React295.useImperativeHandle(ref3, () => ({
    nativeElement: tabsRef.current
  }));
  let editable;
  if (type5 === "editable-card") {
    editable = {
      onEdit: (editType, {
        key: key2,
        event
      }) => {
        onEdit === null || onEdit === void 0 ? void 0 : onEdit(editType === "add" ? event : key2, editType);
      },
      removeIcon: (_a = removeIcon !== null && removeIcon !== void 0 ? removeIcon : tabs === null || tabs === void 0 ? void 0 : tabs.removeIcon) !== null && _a !== void 0 ? _a : /* @__PURE__ */ React295.createElement(CloseOutlined_default2, null),
      addIcon: (addIcon !== null && addIcon !== void 0 ? addIcon : tabs === null || tabs === void 0 ? void 0 : tabs.addIcon) || /* @__PURE__ */ React295.createElement(PlusOutlined_default2, null),
      showAdd: hideAdd !== true
    };
  }
  const rootPrefixCls = getPrefixCls();
  if (true) {
    const warning6 = devUseWarning("Tabs");
    true ? warning6(!("onPrevClick" in props) && !("onNextClick" in props), "breaking", "`onPrevClick` and `onNextClick` has been removed. Please use `onTabScroll` instead.") : void 0;
    true ? warning6(!(indicatorSize || (tabs === null || tabs === void 0 ? void 0 : tabs.indicatorSize)), "deprecated", "`indicatorSize` has been deprecated. Please use `indicator={{ size: ... }}` instead.") : void 0;
    warning6.deprecated(!("destroyInactiveTabPane" in props || (items === null || items === void 0 ? void 0 : items.some((item) => "destroyInactiveTabPane" in item))), "destroyInactiveTabPane", "destroyOnHidden");
  }
  const size = useSize_default(customSize);
  const mergedItems = useLegacyItems_default(items, children);
  const mergedAnimated = useAnimateConfig2(prefixCls, animated);
  const mergedStyle = Object.assign(Object.assign({}, tabs === null || tabs === void 0 ? void 0 : tabs.style), style2);
  const mergedIndicator = {
    align: (_b = indicator === null || indicator === void 0 ? void 0 : indicator.align) !== null && _b !== void 0 ? _b : (_c = tabs === null || tabs === void 0 ? void 0 : tabs.indicator) === null || _c === void 0 ? void 0 : _c.align,
    size: (_g = (_e = (_d = indicator === null || indicator === void 0 ? void 0 : indicator.size) !== null && _d !== void 0 ? _d : indicatorSize) !== null && _e !== void 0 ? _e : (_f = tabs === null || tabs === void 0 ? void 0 : tabs.indicator) === null || _f === void 0 ? void 0 : _f.size) !== null && _g !== void 0 ? _g : tabs === null || tabs === void 0 ? void 0 : tabs.indicatorSize
  };
  return wrapCSSVar(/* @__PURE__ */ React295.createElement(es_default17, Object.assign({
    ref: tabsRef,
    direction,
    getPopupContainer
  }, otherProps, {
    items: mergedItems,
    className: (0, import_classnames100.default)({
      [`${prefixCls}-${size}`]: size,
      [`${prefixCls}-card`]: ["card", "editable-card"].includes(type5),
      [`${prefixCls}-editable-card`]: type5 === "editable-card",
      [`${prefixCls}-centered`]: centered
    }, tabs === null || tabs === void 0 ? void 0 : tabs.className, className2, rootClassName, hashId, cssVarCls, rootCls),
    popupClassName: (0, import_classnames100.default)(popupClassName, hashId, cssVarCls, rootCls),
    style: mergedStyle,
    editable,
    more: Object.assign({
      icon: (_l = (_k = (_j = (_h = tabs === null || tabs === void 0 ? void 0 : tabs.more) === null || _h === void 0 ? void 0 : _h.icon) !== null && _j !== void 0 ? _j : tabs === null || tabs === void 0 ? void 0 : tabs.moreIcon) !== null && _k !== void 0 ? _k : moreIcon) !== null && _l !== void 0 ? _l : /* @__PURE__ */ React295.createElement(EllipsisOutlined_default2, null),
      transitionName: `${rootPrefixCls}-slide-up`
    }, more),
    prefixCls,
    animated: mergedAnimated,
    indicator: mergedIndicator,
    // TODO: In the future, destroyInactiveTabPane in rc-tabs needs to be upgrade to destroyOnHidden
    destroyInactiveTabPane: destroyOnHidden !== null && destroyOnHidden !== void 0 ? destroyOnHidden : destroyInactiveTabPane
  })));
});
var Tabs2 = InternalTabs;
Tabs2.TabPane = TabPane_default2;
if (true) {
  Tabs2.displayName = "Tabs";
}
var tabs_default = Tabs2;

// ../../node_modules/antd/es/card/Grid.js
var React296 = __toESM(require_react());
var import_classnames101 = __toESM(require_classnames());
var __rest24 = function(s, e3) {
  var t2 = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e3.indexOf(p) < 0) t2[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e3.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t2[p[i]] = s[p[i]];
  }
  return t2;
};
var Grid = (_a) => {
  var {
    prefixCls,
    className: className2,
    hoverable = true
  } = _a, props = __rest24(_a, ["prefixCls", "className", "hoverable"]);
  const {
    getPrefixCls
  } = React296.useContext(ConfigContext);
  const prefix3 = getPrefixCls("card", prefixCls);
  const classString = (0, import_classnames101.default)(`${prefix3}-grid`, className2, {
    [`${prefix3}-grid-hoverable`]: hoverable
  });
  return /* @__PURE__ */ React296.createElement("div", Object.assign({}, props, {
    className: classString
  }));
};
var Grid_default = Grid;

// ../../node_modules/antd/es/card/style/index.js
var genCardHeadStyle = (token2) => {
  const {
    antCls,
    componentCls,
    headerHeight,
    headerPadding,
    tabsMarginBottom
  } = token2;
  return Object.assign(Object.assign({
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    minHeight: headerHeight,
    marginBottom: -1,
    padding: `0 ${unit(headerPadding)}`,
    color: token2.colorTextHeading,
    fontWeight: token2.fontWeightStrong,
    fontSize: token2.headerFontSize,
    background: token2.headerBg,
    borderBottom: `${unit(token2.lineWidth)} ${token2.lineType} ${token2.colorBorderSecondary}`,
    borderRadius: `${unit(token2.borderRadiusLG)} ${unit(token2.borderRadiusLG)} 0 0`
  }, clearFix()), {
    "&-wrapper": {
      width: "100%",
      display: "flex",
      alignItems: "center"
    },
    "&-title": Object.assign(Object.assign({
      display: "inline-block",
      flex: 1
    }, textEllipsis), {
      [`
          > ${componentCls}-typography,
          > ${componentCls}-typography-edit-content
        `]: {
        insetInlineStart: 0,
        marginTop: 0,
        marginBottom: 0
      }
    }),
    [`${antCls}-tabs-top`]: {
      clear: "both",
      marginBottom: tabsMarginBottom,
      color: token2.colorText,
      fontWeight: "normal",
      fontSize: token2.fontSize,
      "&-bar": {
        borderBottom: `${unit(token2.lineWidth)} ${token2.lineType} ${token2.colorBorderSecondary}`
      }
    }
  });
};
var genCardGridStyle = (token2) => {
  const {
    cardPaddingBase,
    colorBorderSecondary,
    cardShadow,
    lineWidth
  } = token2;
  return {
    width: "33.33%",
    padding: cardPaddingBase,
    border: 0,
    borderRadius: 0,
    boxShadow: `
      ${unit(lineWidth)} 0 0 0 ${colorBorderSecondary},
      0 ${unit(lineWidth)} 0 0 ${colorBorderSecondary},
      ${unit(lineWidth)} ${unit(lineWidth)} 0 0 ${colorBorderSecondary},
      ${unit(lineWidth)} 0 0 0 ${colorBorderSecondary} inset,
      0 ${unit(lineWidth)} 0 0 ${colorBorderSecondary} inset;
    `,
    transition: `all ${token2.motionDurationMid}`,
    "&-hoverable:hover": {
      position: "relative",
      zIndex: 1,
      boxShadow: cardShadow
    }
  };
};
var genCardActionsStyle = (token2) => {
  const {
    componentCls,
    iconCls,
    actionsLiMargin,
    cardActionsIconSize,
    colorBorderSecondary,
    actionsBg
  } = token2;
  return Object.assign(Object.assign({
    margin: 0,
    padding: 0,
    listStyle: "none",
    background: actionsBg,
    borderTop: `${unit(token2.lineWidth)} ${token2.lineType} ${colorBorderSecondary}`,
    display: "flex",
    borderRadius: `0 0 ${unit(token2.borderRadiusLG)} ${unit(token2.borderRadiusLG)}`
  }, clearFix()), {
    "& > li": {
      margin: actionsLiMargin,
      color: token2.colorTextDescription,
      textAlign: "center",
      "> span": {
        position: "relative",
        display: "block",
        minWidth: token2.calc(token2.cardActionsIconSize).mul(2).equal(),
        fontSize: token2.fontSize,
        lineHeight: token2.lineHeight,
        cursor: "pointer",
        "&:hover": {
          color: token2.colorPrimary,
          transition: `color ${token2.motionDurationMid}`
        },
        [`a:not(${componentCls}-btn), > ${iconCls}`]: {
          display: "inline-block",
          width: "100%",
          color: token2.colorIcon,
          lineHeight: unit(token2.fontHeight),
          transition: `color ${token2.motionDurationMid}`,
          "&:hover": {
            color: token2.colorPrimary
          }
        },
        [`> ${iconCls}`]: {
          fontSize: cardActionsIconSize,
          lineHeight: unit(token2.calc(cardActionsIconSize).mul(token2.lineHeight).equal())
        }
      },
      "&:not(:last-child)": {
        borderInlineEnd: `${unit(token2.lineWidth)} ${token2.lineType} ${colorBorderSecondary}`
      }
    }
  });
};
var genCardMetaStyle = (token2) => Object.assign(Object.assign({
  margin: `${unit(token2.calc(token2.marginXXS).mul(-1).equal())} 0`,
  display: "flex"
}, clearFix()), {
  "&-avatar": {
    paddingInlineEnd: token2.padding
  },
  "&-detail": {
    overflow: "hidden",
    flex: 1,
    "> div:not(:last-child)": {
      marginBottom: token2.marginXS
    }
  },
  "&-title": Object.assign({
    color: token2.colorTextHeading,
    fontWeight: token2.fontWeightStrong,
    fontSize: token2.fontSizeLG
  }, textEllipsis),
  "&-description": {
    color: token2.colorTextDescription
  }
});
var genCardTypeInnerStyle = (token2) => {
  const {
    componentCls,
    colorFillAlter,
    headerPadding,
    bodyPadding
  } = token2;
  return {
    [`${componentCls}-head`]: {
      padding: `0 ${unit(headerPadding)}`,
      background: colorFillAlter,
      "&-title": {
        fontSize: token2.fontSize
      }
    },
    [`${componentCls}-body`]: {
      padding: `${unit(token2.padding)} ${unit(bodyPadding)}`
    }
  };
};
var genCardLoadingStyle = (token2) => {
  const {
    componentCls
  } = token2;
  return {
    overflow: "hidden",
    [`${componentCls}-body`]: {
      userSelect: "none"
    }
  };
};
var genCardStyle2 = (token2) => {
  const {
    componentCls,
    cardShadow,
    cardHeadPadding,
    colorBorderSecondary,
    boxShadowTertiary,
    bodyPadding,
    extraColor
  } = token2;
  return {
    [componentCls]: Object.assign(Object.assign({}, resetComponent(token2)), {
      position: "relative",
      background: token2.colorBgContainer,
      borderRadius: token2.borderRadiusLG,
      [`&:not(${componentCls}-bordered)`]: {
        boxShadow: boxShadowTertiary
      },
      [`${componentCls}-head`]: genCardHeadStyle(token2),
      [`${componentCls}-extra`]: {
        // https://stackoverflow.com/a/22429853/3040605
        marginInlineStart: "auto",
        color: extraColor,
        fontWeight: "normal",
        fontSize: token2.fontSize
      },
      [`${componentCls}-body`]: Object.assign({
        padding: bodyPadding,
        borderRadius: `0 0 ${unit(token2.borderRadiusLG)} ${unit(token2.borderRadiusLG)}`
      }, clearFix()),
      [`${componentCls}-grid`]: genCardGridStyle(token2),
      [`${componentCls}-cover`]: {
        "> *": {
          display: "block",
          width: "100%",
          borderRadius: `${unit(token2.borderRadiusLG)} ${unit(token2.borderRadiusLG)} 0 0`
        }
      },
      [`${componentCls}-actions`]: genCardActionsStyle(token2),
      [`${componentCls}-meta`]: genCardMetaStyle(token2)
    }),
    [`${componentCls}-bordered`]: {
      border: `${unit(token2.lineWidth)} ${token2.lineType} ${colorBorderSecondary}`,
      [`${componentCls}-cover`]: {
        marginTop: -1,
        marginInlineStart: -1,
        marginInlineEnd: -1
      }
    },
    [`${componentCls}-hoverable`]: {
      cursor: "pointer",
      transition: `box-shadow ${token2.motionDurationMid}, border-color ${token2.motionDurationMid}`,
      "&:hover": {
        borderColor: "transparent",
        boxShadow: cardShadow
      }
    },
    [`${componentCls}-contain-grid`]: {
      borderRadius: `${unit(token2.borderRadiusLG)} ${unit(token2.borderRadiusLG)} 0 0 `,
      [`${componentCls}-body`]: {
        display: "flex",
        flexWrap: "wrap"
      },
      [`&:not(${componentCls}-loading) ${componentCls}-body`]: {
        marginBlockStart: token2.calc(token2.lineWidth).mul(-1).equal(),
        marginInlineStart: token2.calc(token2.lineWidth).mul(-1).equal(),
        padding: 0
      }
    },
    [`${componentCls}-contain-tabs`]: {
      [`> div${componentCls}-head`]: {
        minHeight: 0,
        [`${componentCls}-head-title, ${componentCls}-extra`]: {
          paddingTop: cardHeadPadding
        }
      }
    },
    [`${componentCls}-type-inner`]: genCardTypeInnerStyle(token2),
    [`${componentCls}-loading`]: genCardLoadingStyle(token2),
    [`${componentCls}-rtl`]: {
      direction: "rtl"
    }
  };
};
var genCardSizeStyle = (token2) => {
  const {
    componentCls,
    bodyPaddingSM,
    headerPaddingSM,
    headerHeightSM,
    headerFontSizeSM
  } = token2;
  return {
    [`${componentCls}-small`]: {
      [`> ${componentCls}-head`]: {
        minHeight: headerHeightSM,
        padding: `0 ${unit(headerPaddingSM)}`,
        fontSize: headerFontSizeSM,
        [`> ${componentCls}-head-wrapper`]: {
          [`> ${componentCls}-extra`]: {
            fontSize: token2.fontSize
          }
        }
      },
      [`> ${componentCls}-body`]: {
        padding: bodyPaddingSM
      }
    },
    [`${componentCls}-small${componentCls}-contain-tabs`]: {
      [`> ${componentCls}-head`]: {
        [`${componentCls}-head-title, ${componentCls}-extra`]: {
          paddingTop: 0,
          display: "flex",
          alignItems: "center"
        }
      }
    }
  };
};
var prepareComponentToken15 = (token2) => {
  var _a, _b;
  return {
    headerBg: "transparent",
    headerFontSize: token2.fontSizeLG,
    headerFontSizeSM: token2.fontSize,
    headerHeight: token2.fontSizeLG * token2.lineHeightLG + token2.padding * 2,
    headerHeightSM: token2.fontSize * token2.lineHeight + token2.paddingXS * 2,
    actionsBg: token2.colorBgContainer,
    actionsLiMargin: `${token2.paddingSM}px 0`,
    tabsMarginBottom: -token2.padding - token2.lineWidth,
    extraColor: token2.colorText,
    bodyPaddingSM: 12,
    // Fixed padding.
    headerPaddingSM: 12,
    bodyPadding: (_a = token2.bodyPadding) !== null && _a !== void 0 ? _a : token2.paddingLG,
    headerPadding: (_b = token2.headerPadding) !== null && _b !== void 0 ? _b : token2.paddingLG
  };
};
var style_default19 = genStyleHooks("Card", (token2) => {
  const cardToken = merge2(token2, {
    cardShadow: token2.boxShadowCard,
    cardHeadPadding: token2.padding,
    cardPaddingBase: token2.paddingLG,
    cardActionsIconSize: token2.fontSize
  });
  return [
    // Style
    genCardStyle2(cardToken),
    // Size
    genCardSizeStyle(cardToken)
  ];
}, prepareComponentToken15);

// ../../node_modules/antd/es/card/Card.js
var __rest25 = function(s, e3) {
  var t2 = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e3.indexOf(p) < 0) t2[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e3.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t2[p[i]] = s[p[i]];
  }
  return t2;
};
var ActionNode = (props) => {
  const {
    actionClasses,
    actions = [],
    actionStyle
  } = props;
  return /* @__PURE__ */ React297.createElement("ul", {
    className: actionClasses,
    style: actionStyle
  }, actions.map((action, index3) => {
    const key2 = `action-${index3}`;
    return /* @__PURE__ */ React297.createElement("li", {
      style: {
        width: `${100 / actions.length}%`
      },
      key: key2
    }, /* @__PURE__ */ React297.createElement("span", null, action));
  }));
};
var Card = /* @__PURE__ */ React297.forwardRef((props, ref3) => {
  const {
    prefixCls: customizePrefixCls,
    className: className2,
    rootClassName,
    style: style2,
    extra,
    headStyle = {},
    bodyStyle = {},
    title,
    loading,
    bordered,
    variant: customVariant,
    size: customizeSize,
    type: type5,
    cover,
    actions,
    tabList,
    children,
    activeTabKey,
    defaultActiveTabKey,
    tabBarExtraContent,
    hoverable,
    tabProps = {},
    classNames: customClassNames,
    styles: customStyles
  } = props, others = __rest25(props, ["prefixCls", "className", "rootClassName", "style", "extra", "headStyle", "bodyStyle", "title", "loading", "bordered", "variant", "size", "type", "cover", "actions", "tabList", "children", "activeTabKey", "defaultActiveTabKey", "tabBarExtraContent", "hoverable", "tabProps", "classNames", "styles"]);
  const {
    getPrefixCls,
    direction,
    card
  } = React297.useContext(ConfigContext);
  const [variant] = useVariants_default("card", customVariant, bordered);
  if (true) {
    const warning6 = devUseWarning("Card");
    [["headStyle", "styles.header"], ["bodyStyle", "styles.body"], ["bordered", "variant"]].forEach(([deprecatedName, newName]) => {
      warning6.deprecated(!(deprecatedName in props), deprecatedName, newName);
    });
  }
  const onTabChange = (key2) => {
    var _a;
    (_a = props.onTabChange) === null || _a === void 0 ? void 0 : _a.call(props, key2);
  };
  const moduleClass = (moduleName) => {
    var _a;
    return (0, import_classnames102.default)((_a = card === null || card === void 0 ? void 0 : card.classNames) === null || _a === void 0 ? void 0 : _a[moduleName], customClassNames === null || customClassNames === void 0 ? void 0 : customClassNames[moduleName]);
  };
  const moduleStyle = (moduleName) => {
    var _a;
    return Object.assign(Object.assign({}, (_a = card === null || card === void 0 ? void 0 : card.styles) === null || _a === void 0 ? void 0 : _a[moduleName]), customStyles === null || customStyles === void 0 ? void 0 : customStyles[moduleName]);
  };
  const isContainGrid = React297.useMemo(() => {
    let containGrid = false;
    React297.Children.forEach(children, (element) => {
      if ((element === null || element === void 0 ? void 0 : element.type) === Grid_default) {
        containGrid = true;
      }
    });
    return containGrid;
  }, [children]);
  const prefixCls = getPrefixCls("card", customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = style_default19(prefixCls);
  const loadingBlock = /* @__PURE__ */ React297.createElement(skeleton_default, {
    loading: true,
    active: true,
    paragraph: {
      rows: 4
    },
    title: false
  }, children);
  const hasActiveTabKey = activeTabKey !== void 0;
  const extraProps = Object.assign(Object.assign({}, tabProps), {
    [hasActiveTabKey ? "activeKey" : "defaultActiveKey"]: hasActiveTabKey ? activeTabKey : defaultActiveTabKey,
    tabBarExtraContent
  });
  let head;
  const mergedSize = useSize_default(customizeSize);
  const tabSize = !mergedSize || mergedSize === "default" ? "large" : mergedSize;
  const tabs = tabList ? /* @__PURE__ */ React297.createElement(tabs_default, Object.assign({
    size: tabSize
  }, extraProps, {
    className: `${prefixCls}-head-tabs`,
    onChange: onTabChange,
    items: tabList.map((_a) => {
      var {
        tab
      } = _a, item = __rest25(_a, ["tab"]);
      return Object.assign({
        label: tab
      }, item);
    })
  })) : null;
  if (title || extra || tabs) {
    const headClasses = (0, import_classnames102.default)(`${prefixCls}-head`, moduleClass("header"));
    const titleClasses = (0, import_classnames102.default)(`${prefixCls}-head-title`, moduleClass("title"));
    const extraClasses = (0, import_classnames102.default)(`${prefixCls}-extra`, moduleClass("extra"));
    const mergedHeadStyle = Object.assign(Object.assign({}, headStyle), moduleStyle("header"));
    head = /* @__PURE__ */ React297.createElement("div", {
      className: headClasses,
      style: mergedHeadStyle
    }, /* @__PURE__ */ React297.createElement("div", {
      className: `${prefixCls}-head-wrapper`
    }, title && /* @__PURE__ */ React297.createElement("div", {
      className: titleClasses,
      style: moduleStyle("title")
    }, title), extra && /* @__PURE__ */ React297.createElement("div", {
      className: extraClasses,
      style: moduleStyle("extra")
    }, extra)), tabs);
  }
  const coverClasses = (0, import_classnames102.default)(`${prefixCls}-cover`, moduleClass("cover"));
  const coverDom = cover ? /* @__PURE__ */ React297.createElement("div", {
    className: coverClasses,
    style: moduleStyle("cover")
  }, cover) : null;
  const bodyClasses = (0, import_classnames102.default)(`${prefixCls}-body`, moduleClass("body"));
  const mergedBodyStyle = Object.assign(Object.assign({}, bodyStyle), moduleStyle("body"));
  const body = /* @__PURE__ */ React297.createElement("div", {
    className: bodyClasses,
    style: mergedBodyStyle
  }, loading ? loadingBlock : children);
  const actionClasses = (0, import_classnames102.default)(`${prefixCls}-actions`, moduleClass("actions"));
  const actionDom = (actions === null || actions === void 0 ? void 0 : actions.length) ? /* @__PURE__ */ React297.createElement(ActionNode, {
    actionClasses,
    actionStyle: moduleStyle("actions"),
    actions
  }) : null;
  const divProps = omit(others, ["onTabChange"]);
  const classString = (0, import_classnames102.default)(prefixCls, card === null || card === void 0 ? void 0 : card.className, {
    [`${prefixCls}-loading`]: loading,
    [`${prefixCls}-bordered`]: variant !== "borderless",
    [`${prefixCls}-hoverable`]: hoverable,
    [`${prefixCls}-contain-grid`]: isContainGrid,
    [`${prefixCls}-contain-tabs`]: tabList === null || tabList === void 0 ? void 0 : tabList.length,
    [`${prefixCls}-${mergedSize}`]: mergedSize,
    [`${prefixCls}-type-${type5}`]: !!type5,
    [`${prefixCls}-rtl`]: direction === "rtl"
  }, className2, rootClassName, hashId, cssVarCls);
  const mergedStyle = Object.assign(Object.assign({}, card === null || card === void 0 ? void 0 : card.style), style2);
  return wrapCSSVar(/* @__PURE__ */ React297.createElement("div", Object.assign({
    ref: ref3
  }, divProps, {
    className: classString,
    style: mergedStyle
  }), head, coverDom, body, actionDom));
});
var Card_default = Card;

// ../../node_modules/antd/es/card/Meta.js
var React298 = __toESM(require_react());
var import_classnames103 = __toESM(require_classnames());
var __rest26 = function(s, e3) {
  var t2 = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e3.indexOf(p) < 0) t2[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e3.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t2[p[i]] = s[p[i]];
  }
  return t2;
};
var Meta = (props) => {
  const {
    prefixCls: customizePrefixCls,
    className: className2,
    avatar,
    title,
    description
  } = props, others = __rest26(props, ["prefixCls", "className", "avatar", "title", "description"]);
  const {
    getPrefixCls
  } = React298.useContext(ConfigContext);
  const prefixCls = getPrefixCls("card", customizePrefixCls);
  const classString = (0, import_classnames103.default)(`${prefixCls}-meta`, className2);
  const avatarDom = avatar ? /* @__PURE__ */ React298.createElement("div", {
    className: `${prefixCls}-meta-avatar`
  }, avatar) : null;
  const titleDom = title ? /* @__PURE__ */ React298.createElement("div", {
    className: `${prefixCls}-meta-title`
  }, title) : null;
  const descriptionDom = description ? /* @__PURE__ */ React298.createElement("div", {
    className: `${prefixCls}-meta-description`
  }, description) : null;
  const MetaDetail = titleDom || descriptionDom ? /* @__PURE__ */ React298.createElement("div", {
    className: `${prefixCls}-meta-detail`
  }, titleDom, descriptionDom) : null;
  return /* @__PURE__ */ React298.createElement("div", Object.assign({}, others, {
    className: classString
  }), avatarDom, MetaDetail);
};
var Meta_default = Meta;

// ../../node_modules/antd/es/card/index.js
var Card2 = Card_default;
Card2.Grid = Grid_default;
Card2.Meta = Meta_default;
if (true) {
  Card2.displayName = "Card";
}
var card_default = Card2;

// ../../node_modules/throttle-debounce/esm/index.js
function throttle2(delay, callback, options) {
  var _ref = options || {}, _ref$noTrailing = _ref.noTrailing, noTrailing = _ref$noTrailing === void 0 ? false : _ref$noTrailing, _ref$noLeading = _ref.noLeading, noLeading = _ref$noLeading === void 0 ? false : _ref$noLeading, _ref$debounceMode = _ref.debounceMode, debounceMode = _ref$debounceMode === void 0 ? void 0 : _ref$debounceMode;
  var timeoutID;
  var cancelled = false;
  var lastExec = 0;
  function clearExistingTimeout() {
    if (timeoutID) {
      clearTimeout(timeoutID);
    }
  }
  function cancel(options2) {
    var _ref2 = options2 || {}, _ref2$upcomingOnly = _ref2.upcomingOnly, upcomingOnly = _ref2$upcomingOnly === void 0 ? false : _ref2$upcomingOnly;
    clearExistingTimeout();
    cancelled = !upcomingOnly;
  }
  function wrapper() {
    for (var _len = arguments.length, arguments_ = new Array(_len), _key = 0; _key < _len; _key++) {
      arguments_[_key] = arguments[_key];
    }
    var self2 = this;
    var elapsed = Date.now() - lastExec;
    if (cancelled) {
      return;
    }
    function exec() {
      lastExec = Date.now();
      callback.apply(self2, arguments_);
    }
    function clear() {
      timeoutID = void 0;
    }
    if (!noLeading && debounceMode && !timeoutID) {
      exec();
    }
    clearExistingTimeout();
    if (debounceMode === void 0 && elapsed > delay) {
      if (noLeading) {
        lastExec = Date.now();
        if (!noTrailing) {
          timeoutID = setTimeout(debounceMode ? clear : exec, delay);
        }
      } else {
        exec();
      }
    } else if (noTrailing !== true) {
      timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === void 0 ? delay - elapsed : delay);
    }
  }
  wrapper.cancel = cancel;
  return wrapper;
}
function debounce2(delay, callback, options) {
  var _ref = options || {}, _ref$atBegin = _ref.atBegin, atBegin = _ref$atBegin === void 0 ? false : _ref$atBegin;
  return throttle2(delay, callback, {
    debounceMode: atBegin !== false
  });
}

// ../../node_modules/rc-tree/es/utils/keyUtil.js
function getEntity(keyEntities, key2) {
  return keyEntities[key2];
}

// ../../node_modules/rc-tree/es/utils/treeUtil.js
var _excluded48 = ["children"];
function getPosition2(level, index3) {
  return "".concat(level, "-").concat(index3);
}
function isTreeNode(node2) {
  return node2 && node2.type && node2.type.isTreeNode;
}
function getKey3(key2, pos) {
  if (key2 !== null && key2 !== void 0) {
    return key2;
  }
  return pos;
}
function fillFieldNames2(fieldNames) {
  var _ref = fieldNames || {}, title = _ref.title, _title = _ref._title, key2 = _ref.key, children = _ref.children;
  var mergedTitle = title || "title";
  return {
    title: mergedTitle,
    _title: _title || [mergedTitle],
    key: key2 || "key",
    children: children || "children"
  };
}
function warningWithoutKey(treeData, fieldNames) {
  var keys4 = /* @__PURE__ */ new Map();
  function dig(list) {
    var path2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    (list || []).forEach(function(treeNode) {
      var key2 = treeNode[fieldNames.key];
      var children = treeNode[fieldNames.children];
      warning_default(key2 !== null && key2 !== void 0, "Tree node must have a certain key: [".concat(path2).concat(key2, "]"));
      var recordKey = String(key2);
      warning_default(!keys4.has(recordKey) || key2 === null || key2 === void 0, "Same 'key' exist in the Tree: ".concat(recordKey));
      keys4.set(recordKey, true);
      dig(children, "".concat(path2).concat(recordKey, " > "));
    });
  }
  dig(treeData);
}
function convertTreeToData(rootNodes) {
  function dig(node2) {
    var treeNodes = toArray(node2);
    return treeNodes.map(function(treeNode) {
      if (!isTreeNode(treeNode)) {
        warning_default(!treeNode, "Tree/TreeNode can only accept TreeNode as children.");
        return null;
      }
      var key2 = treeNode.key;
      var _treeNode$props = treeNode.props, children = _treeNode$props.children, rest = _objectWithoutProperties(_treeNode$props, _excluded48);
      var dataNode = _objectSpread2({
        key: key2
      }, rest);
      var parsedChildren = dig(children);
      if (parsedChildren.length) {
        dataNode.children = parsedChildren;
      }
      return dataNode;
    }).filter(function(dataNode) {
      return dataNode;
    });
  }
  return dig(rootNodes);
}
function flattenTreeData(treeNodeList, expandedKeys, fieldNames) {
  var _fillFieldNames = fillFieldNames2(fieldNames), fieldTitles = _fillFieldNames._title, fieldKey = _fillFieldNames.key, fieldChildren = _fillFieldNames.children;
  var expandedKeySet = new Set(expandedKeys === true ? [] : expandedKeys);
  var flattenList = [];
  function dig(list) {
    var parent2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    return list.map(function(treeNode, index3) {
      var pos = getPosition2(parent2 ? parent2.pos : "0", index3);
      var mergedKey = getKey3(treeNode[fieldKey], pos);
      var mergedTitle;
      for (var i = 0; i < fieldTitles.length; i += 1) {
        var fieldTitle = fieldTitles[i];
        if (treeNode[fieldTitle] !== void 0) {
          mergedTitle = treeNode[fieldTitle];
          break;
        }
      }
      var flattenNode = Object.assign(omit(treeNode, [].concat(_toConsumableArray(fieldTitles), [fieldKey, fieldChildren])), {
        title: mergedTitle,
        key: mergedKey,
        parent: parent2,
        pos,
        children: null,
        data: treeNode,
        isStart: [].concat(_toConsumableArray(parent2 ? parent2.isStart : []), [index3 === 0]),
        isEnd: [].concat(_toConsumableArray(parent2 ? parent2.isEnd : []), [index3 === list.length - 1])
      });
      flattenList.push(flattenNode);
      if (expandedKeys === true || expandedKeySet.has(mergedKey)) {
        flattenNode.children = dig(treeNode[fieldChildren] || [], flattenNode);
      } else {
        flattenNode.children = [];
      }
      return flattenNode;
    });
  }
  dig(treeNodeList);
  return flattenList;
}
function traverseDataNodes(dataNodes, callback, config) {
  var mergedConfig = {};
  if (_typeof(config) === "object") {
    mergedConfig = config;
  } else {
    mergedConfig = {
      externalGetKey: config
    };
  }
  mergedConfig = mergedConfig || {};
  var _mergedConfig = mergedConfig, childrenPropName = _mergedConfig.childrenPropName, externalGetKey = _mergedConfig.externalGetKey, fieldNames = _mergedConfig.fieldNames;
  var _fillFieldNames2 = fillFieldNames2(fieldNames), fieldKey = _fillFieldNames2.key, fieldChildren = _fillFieldNames2.children;
  var mergeChildrenPropName = childrenPropName || fieldChildren;
  var syntheticGetKey;
  if (externalGetKey) {
    if (typeof externalGetKey === "string") {
      syntheticGetKey = function syntheticGetKey2(node2) {
        return node2[externalGetKey];
      };
    } else if (typeof externalGetKey === "function") {
      syntheticGetKey = function syntheticGetKey2(node2) {
        return externalGetKey(node2);
      };
    }
  } else {
    syntheticGetKey = function syntheticGetKey2(node2, pos) {
      return getKey3(node2[fieldKey], pos);
    };
  }
  function processNode(node2, index3, parent2, pathNodes) {
    var children = node2 ? node2[mergeChildrenPropName] : dataNodes;
    var pos = node2 ? getPosition2(parent2.pos, index3) : "0";
    var connectNodes = node2 ? [].concat(_toConsumableArray(pathNodes), [node2]) : [];
    if (node2) {
      var key2 = syntheticGetKey(node2, pos);
      var _data = {
        node: node2,
        index: index3,
        pos,
        key: key2,
        parentPos: parent2.node ? parent2.pos : null,
        level: parent2.level + 1,
        nodes: connectNodes
      };
      callback(_data);
    }
    if (children) {
      children.forEach(function(subNode, subIndex) {
        processNode(subNode, subIndex, {
          node: node2,
          pos,
          level: parent2 ? parent2.level + 1 : -1
        }, connectNodes);
      });
    }
  }
  processNode(null);
}
function convertDataToEntities(dataNodes) {
  var _ref2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, initWrapper = _ref2.initWrapper, processEntity = _ref2.processEntity, onProcessFinished = _ref2.onProcessFinished, externalGetKey = _ref2.externalGetKey, childrenPropName = _ref2.childrenPropName, fieldNames = _ref2.fieldNames;
  var legacyExternalGetKey = arguments.length > 2 ? arguments[2] : void 0;
  var mergedExternalGetKey = externalGetKey || legacyExternalGetKey;
  var posEntities = {};
  var keyEntities = {};
  var wrapper = {
    posEntities,
    keyEntities
  };
  if (initWrapper) {
    wrapper = initWrapper(wrapper) || wrapper;
  }
  traverseDataNodes(dataNodes, function(item) {
    var node2 = item.node, index3 = item.index, pos = item.pos, key2 = item.key, parentPos = item.parentPos, level = item.level, nodes = item.nodes;
    var entity = {
      node: node2,
      nodes,
      index: index3,
      key: key2,
      pos,
      level
    };
    var mergedKey = getKey3(key2, pos);
    posEntities[pos] = entity;
    keyEntities[mergedKey] = entity;
    entity.parent = posEntities[parentPos];
    if (entity.parent) {
      entity.parent.children = entity.parent.children || [];
      entity.parent.children.push(entity);
    }
    if (processEntity) {
      processEntity(entity, wrapper);
    }
  }, {
    externalGetKey: mergedExternalGetKey,
    childrenPropName,
    fieldNames
  });
  if (onProcessFinished) {
    onProcessFinished(wrapper);
  }
  return wrapper;
}
function getTreeNodeProps(key2, _ref3) {
  var expandedKeys = _ref3.expandedKeys, selectedKeys = _ref3.selectedKeys, loadedKeys = _ref3.loadedKeys, loadingKeys = _ref3.loadingKeys, checkedKeys = _ref3.checkedKeys, halfCheckedKeys = _ref3.halfCheckedKeys, dragOverNodeKey = _ref3.dragOverNodeKey, dropPosition = _ref3.dropPosition, keyEntities = _ref3.keyEntities;
  var entity = getEntity(keyEntities, key2);
  var treeNodeProps = {
    eventKey: key2,
    expanded: expandedKeys.indexOf(key2) !== -1,
    selected: selectedKeys.indexOf(key2) !== -1,
    loaded: loadedKeys.indexOf(key2) !== -1,
    loading: loadingKeys.indexOf(key2) !== -1,
    checked: checkedKeys.indexOf(key2) !== -1,
    halfChecked: halfCheckedKeys.indexOf(key2) !== -1,
    pos: String(entity ? entity.pos : ""),
    // [Legacy] Drag props
    // Since the interaction of drag is changed, the semantic of the props are
    // not accuracy, I think it should be finally removed
    dragOver: dragOverNodeKey === key2 && dropPosition === 0,
    dragOverGapTop: dragOverNodeKey === key2 && dropPosition === -1,
    dragOverGapBottom: dragOverNodeKey === key2 && dropPosition === 1
  };
  return treeNodeProps;
}
function convertNodePropsToEventData(props) {
  var data2 = props.data, expanded = props.expanded, selected = props.selected, checked = props.checked, loaded = props.loaded, loading = props.loading, halfChecked = props.halfChecked, dragOver = props.dragOver, dragOverGapTop = props.dragOverGapTop, dragOverGapBottom = props.dragOverGapBottom, pos = props.pos, active = props.active, eventKey = props.eventKey;
  var eventData = _objectSpread2(_objectSpread2({}, data2), {}, {
    expanded,
    selected,
    checked,
    loaded,
    loading,
    halfChecked,
    dragOver,
    dragOverGapTop,
    dragOverGapBottom,
    pos,
    active,
    key: eventKey
  });
  if (!("props" in eventData)) {
    Object.defineProperty(eventData, "props", {
      get: function get3() {
        warning_default(false, "Second param return from event is node data instead of TreeNode instance. Please read value directly instead of reading from `props`.");
        return props;
      }
    });
  }
  return eventData;
}

// ../../node_modules/rc-tree/es/utils/conductUtil.js
function removeFromCheckedKeys(halfCheckedKeys, checkedKeys) {
  var filteredKeys = /* @__PURE__ */ new Set();
  halfCheckedKeys.forEach(function(key2) {
    if (!checkedKeys.has(key2)) {
      filteredKeys.add(key2);
    }
  });
  return filteredKeys;
}
function isCheckDisabled(node2) {
  var _ref = node2 || {}, disabled = _ref.disabled, disableCheckbox = _ref.disableCheckbox, checkable = _ref.checkable;
  return !!(disabled || disableCheckbox) || checkable === false;
}
function fillConductCheck(keys4, levelEntities, maxLevel, syntheticGetCheckDisabled) {
  var checkedKeys = new Set(keys4);
  var halfCheckedKeys = /* @__PURE__ */ new Set();
  for (var level = 0; level <= maxLevel; level += 1) {
    var entities = levelEntities.get(level) || /* @__PURE__ */ new Set();
    entities.forEach(function(entity) {
      var key2 = entity.key, node2 = entity.node, _entity$children = entity.children, children = _entity$children === void 0 ? [] : _entity$children;
      if (checkedKeys.has(key2) && !syntheticGetCheckDisabled(node2)) {
        children.filter(function(childEntity) {
          return !syntheticGetCheckDisabled(childEntity.node);
        }).forEach(function(childEntity) {
          checkedKeys.add(childEntity.key);
        });
      }
    });
  }
  var visitedKeys = /* @__PURE__ */ new Set();
  for (var _level = maxLevel; _level >= 0; _level -= 1) {
    var _entities = levelEntities.get(_level) || /* @__PURE__ */ new Set();
    _entities.forEach(function(entity) {
      var parent2 = entity.parent, node2 = entity.node;
      if (syntheticGetCheckDisabled(node2) || !entity.parent || visitedKeys.has(entity.parent.key)) {
        return;
      }
      if (syntheticGetCheckDisabled(entity.parent.node)) {
        visitedKeys.add(parent2.key);
        return;
      }
      var allChecked = true;
      var partialChecked = false;
      (parent2.children || []).filter(function(childEntity) {
        return !syntheticGetCheckDisabled(childEntity.node);
      }).forEach(function(_ref2) {
        var key2 = _ref2.key;
        var checked = checkedKeys.has(key2);
        if (allChecked && !checked) {
          allChecked = false;
        }
        if (!partialChecked && (checked || halfCheckedKeys.has(key2))) {
          partialChecked = true;
        }
      });
      if (allChecked) {
        checkedKeys.add(parent2.key);
      }
      if (partialChecked) {
        halfCheckedKeys.add(parent2.key);
      }
      visitedKeys.add(parent2.key);
    });
  }
  return {
    checkedKeys: Array.from(checkedKeys),
    halfCheckedKeys: Array.from(removeFromCheckedKeys(halfCheckedKeys, checkedKeys))
  };
}
function cleanConductCheck(keys4, halfKeys, levelEntities, maxLevel, syntheticGetCheckDisabled) {
  var checkedKeys = new Set(keys4);
  var halfCheckedKeys = new Set(halfKeys);
  for (var level = 0; level <= maxLevel; level += 1) {
    var entities = levelEntities.get(level) || /* @__PURE__ */ new Set();
    entities.forEach(function(entity) {
      var key2 = entity.key, node2 = entity.node, _entity$children2 = entity.children, children = _entity$children2 === void 0 ? [] : _entity$children2;
      if (!checkedKeys.has(key2) && !halfCheckedKeys.has(key2) && !syntheticGetCheckDisabled(node2)) {
        children.filter(function(childEntity) {
          return !syntheticGetCheckDisabled(childEntity.node);
        }).forEach(function(childEntity) {
          checkedKeys.delete(childEntity.key);
        });
      }
    });
  }
  halfCheckedKeys = /* @__PURE__ */ new Set();
  var visitedKeys = /* @__PURE__ */ new Set();
  for (var _level2 = maxLevel; _level2 >= 0; _level2 -= 1) {
    var _entities2 = levelEntities.get(_level2) || /* @__PURE__ */ new Set();
    _entities2.forEach(function(entity) {
      var parent2 = entity.parent, node2 = entity.node;
      if (syntheticGetCheckDisabled(node2) || !entity.parent || visitedKeys.has(entity.parent.key)) {
        return;
      }
      if (syntheticGetCheckDisabled(entity.parent.node)) {
        visitedKeys.add(parent2.key);
        return;
      }
      var allChecked = true;
      var partialChecked = false;
      (parent2.children || []).filter(function(childEntity) {
        return !syntheticGetCheckDisabled(childEntity.node);
      }).forEach(function(_ref3) {
        var key2 = _ref3.key;
        var checked = checkedKeys.has(key2);
        if (allChecked && !checked) {
          allChecked = false;
        }
        if (!partialChecked && (checked || halfCheckedKeys.has(key2))) {
          partialChecked = true;
        }
      });
      if (!allChecked) {
        checkedKeys.delete(parent2.key);
      }
      if (partialChecked) {
        halfCheckedKeys.add(parent2.key);
      }
      visitedKeys.add(parent2.key);
    });
  }
  return {
    checkedKeys: Array.from(checkedKeys),
    halfCheckedKeys: Array.from(removeFromCheckedKeys(halfCheckedKeys, checkedKeys))
  };
}
function conductCheck(keyList, checked, keyEntities, getCheckDisabled) {
  var warningMissKeys = [];
  var syntheticGetCheckDisabled;
  if (getCheckDisabled) {
    syntheticGetCheckDisabled = getCheckDisabled;
  } else {
    syntheticGetCheckDisabled = isCheckDisabled;
  }
  var keys4 = new Set(keyList.filter(function(key2) {
    var hasEntity = !!getEntity(keyEntities, key2);
    if (!hasEntity) {
      warningMissKeys.push(key2);
    }
    return hasEntity;
  }));
  var levelEntities = /* @__PURE__ */ new Map();
  var maxLevel = 0;
  Object.keys(keyEntities).forEach(function(key2) {
    var entity = keyEntities[key2];
    var level = entity.level;
    var levelSet = levelEntities.get(level);
    if (!levelSet) {
      levelSet = /* @__PURE__ */ new Set();
      levelEntities.set(level, levelSet);
    }
    levelSet.add(entity);
    maxLevel = Math.max(maxLevel, level);
  });
  warning_default(!warningMissKeys.length, "Tree missing follow keys: ".concat(warningMissKeys.slice(0, 100).map(function(key2) {
    return "'".concat(key2, "'");
  }).join(", ")));
  var result;
  if (checked === true) {
    result = fillConductCheck(keys4, levelEntities, maxLevel, syntheticGetCheckDisabled);
  } else {
    result = cleanConductCheck(keys4, checked.halfCheckedKeys, levelEntities, maxLevel, syntheticGetCheckDisabled);
  }
  return result;
}

// ../../node_modules/antd/es/checkbox/style/index.js
var genCheckboxStyle = (token2) => {
  const {
    checkboxCls
  } = token2;
  const wrapperCls = `${checkboxCls}-wrapper`;
  return [
    // ===================== Basic =====================
    {
      // Group
      [`${checkboxCls}-group`]: Object.assign(Object.assign({}, resetComponent(token2)), {
        display: "inline-flex",
        flexWrap: "wrap",
        columnGap: token2.marginXS,
        // Group > Grid
        [`> ${token2.antCls}-row`]: {
          flex: 1
        }
      }),
      // Wrapper
      [wrapperCls]: Object.assign(Object.assign({}, resetComponent(token2)), {
        display: "inline-flex",
        alignItems: "baseline",
        cursor: "pointer",
        // Fix checkbox & radio in flex align #30260
        "&:after": {
          display: "inline-block",
          width: 0,
          overflow: "hidden",
          content: "'\\a0'"
        },
        // Checkbox near checkbox
        [`& + ${wrapperCls}`]: {
          marginInlineStart: 0
        },
        [`&${wrapperCls}-in-form-item`]: {
          'input[type="checkbox"]': {
            width: 14,
            // FIXME: magic
            height: 14
            // FIXME: magic
          }
        }
      }),
      // Wrapper > Checkbox
      [checkboxCls]: Object.assign(Object.assign({}, resetComponent(token2)), {
        position: "relative",
        whiteSpace: "nowrap",
        lineHeight: 1,
        cursor: "pointer",
        borderRadius: token2.borderRadiusSM,
        // To make alignment right when `controlHeight` is changed
        // Ref: https://github.com/ant-design/ant-design/issues/41564
        alignSelf: "center",
        // Wrapper > Checkbox > input
        [`${checkboxCls}-input`]: {
          position: "absolute",
          // Since baseline align will get additional space offset,
          // we need to move input to top to make it align with text.
          // Ref: https://github.com/ant-design/ant-design/issues/38926#issuecomment-1486137799
          inset: 0,
          zIndex: 1,
          cursor: "pointer",
          opacity: 0,
          margin: 0,
          [`&:focus-visible + ${checkboxCls}-inner`]: genFocusOutline(token2)
        },
        // Wrapper > Checkbox > inner
        [`${checkboxCls}-inner`]: {
          boxSizing: "border-box",
          display: "block",
          width: token2.checkboxSize,
          height: token2.checkboxSize,
          direction: "ltr",
          backgroundColor: token2.colorBgContainer,
          border: `${unit(token2.lineWidth)} ${token2.lineType} ${token2.colorBorder}`,
          borderRadius: token2.borderRadiusSM,
          borderCollapse: "separate",
          transition: `all ${token2.motionDurationSlow}`,
          "&:after": {
            boxSizing: "border-box",
            position: "absolute",
            top: "50%",
            insetInlineStart: "25%",
            display: "table",
            width: token2.calc(token2.checkboxSize).div(14).mul(5).equal(),
            height: token2.calc(token2.checkboxSize).div(14).mul(8).equal(),
            border: `${unit(token2.lineWidthBold)} solid ${token2.colorWhite}`,
            borderTop: 0,
            borderInlineStart: 0,
            transform: "rotate(45deg) scale(0) translate(-50%,-50%)",
            opacity: 0,
            content: '""',
            transition: `all ${token2.motionDurationFast} ${token2.motionEaseInBack}, opacity ${token2.motionDurationFast}`
          }
        },
        // Wrapper > Checkbox + Text
        "& + span": {
          paddingInlineStart: token2.paddingXS,
          paddingInlineEnd: token2.paddingXS
        }
      })
    },
    // ===================== Hover =====================
    {
      // Wrapper & Wrapper > Checkbox
      [`
        ${wrapperCls}:not(${wrapperCls}-disabled),
        ${checkboxCls}:not(${checkboxCls}-disabled)
      `]: {
        [`&:hover ${checkboxCls}-inner`]: {
          borderColor: token2.colorPrimary
        }
      },
      [`${wrapperCls}:not(${wrapperCls}-disabled)`]: {
        [`&:hover ${checkboxCls}-checked:not(${checkboxCls}-disabled) ${checkboxCls}-inner`]: {
          backgroundColor: token2.colorPrimaryHover,
          borderColor: "transparent"
        },
        [`&:hover ${checkboxCls}-checked:not(${checkboxCls}-disabled):after`]: {
          borderColor: token2.colorPrimaryHover
        }
      }
    },
    // ==================== Checked ====================
    {
      // Wrapper > Checkbox
      [`${checkboxCls}-checked`]: {
        [`${checkboxCls}-inner`]: {
          backgroundColor: token2.colorPrimary,
          borderColor: token2.colorPrimary,
          "&:after": {
            opacity: 1,
            transform: "rotate(45deg) scale(1) translate(-50%,-50%)",
            transition: `all ${token2.motionDurationMid} ${token2.motionEaseOutBack} ${token2.motionDurationFast}`
          }
        }
      },
      [`
        ${wrapperCls}-checked:not(${wrapperCls}-disabled),
        ${checkboxCls}-checked:not(${checkboxCls}-disabled)
      `]: {
        [`&:hover ${checkboxCls}-inner`]: {
          backgroundColor: token2.colorPrimaryHover,
          borderColor: "transparent"
        }
      }
    },
    // ================= Indeterminate =================
    {
      [checkboxCls]: {
        "&-indeterminate": {
          "&": {
            // Wrapper > Checkbox > inner
            [`${checkboxCls}-inner`]: {
              backgroundColor: `${token2.colorBgContainer}`,
              borderColor: `${token2.colorBorder}`,
              "&:after": {
                top: "50%",
                insetInlineStart: "50%",
                width: token2.calc(token2.fontSizeLG).div(2).equal(),
                height: token2.calc(token2.fontSizeLG).div(2).equal(),
                backgroundColor: token2.colorPrimary,
                border: 0,
                transform: "translate(-50%, -50%) scale(1)",
                opacity: 1,
                content: '""'
              }
            },
            // https://github.com/ant-design/ant-design/issues/50074
            [`&:hover ${checkboxCls}-inner`]: {
              backgroundColor: `${token2.colorBgContainer}`,
              borderColor: `${token2.colorPrimary}`
            }
          }
        }
      }
    },
    // ==================== Disable ====================
    {
      // Wrapper
      [`${wrapperCls}-disabled`]: {
        cursor: "not-allowed"
      },
      // Wrapper > Checkbox
      [`${checkboxCls}-disabled`]: {
        // Wrapper > Checkbox > input
        [`&, ${checkboxCls}-input`]: {
          cursor: "not-allowed",
          // Disabled for native input to enable Tooltip event handler
          // ref: https://github.com/ant-design/ant-design/issues/39822#issuecomment-1365075901
          pointerEvents: "none"
        },
        // Wrapper > Checkbox > inner
        [`${checkboxCls}-inner`]: {
          background: token2.colorBgContainerDisabled,
          borderColor: token2.colorBorder,
          "&:after": {
            borderColor: token2.colorTextDisabled
          }
        },
        "&:after": {
          display: "none"
        },
        "& + span": {
          color: token2.colorTextDisabled
        },
        [`&${checkboxCls}-indeterminate ${checkboxCls}-inner::after`]: {
          background: token2.colorTextDisabled
        }
      }
    }
  ];
};
function getStyle2(prefixCls, token2) {
  const checkboxToken = merge2(token2, {
    checkboxCls: `.${prefixCls}`,
    checkboxSize: token2.controlInteractiveSize
  });
  return genCheckboxStyle(checkboxToken);
}
var style_default20 = genStyleHooks("Checkbox", (token2, {
  prefixCls
}) => [getStyle2(prefixCls, token2)]);

// ../../node_modules/antd/es/checkbox/Checkbox.js
var React300 = __toESM(require_react());
var import_classnames104 = __toESM(require_classnames());

// ../../node_modules/antd/es/checkbox/GroupContext.js
var import_react97 = __toESM(require_react());
var GroupContext = /* @__PURE__ */ import_react97.default.createContext(null);
var GroupContext_default = GroupContext;

// ../../node_modules/antd/es/checkbox/Checkbox.js
var __rest27 = function(s, e3) {
  var t2 = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e3.indexOf(p) < 0) t2[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e3.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t2[p[i]] = s[p[i]];
  }
  return t2;
};
var InternalCheckbox = (props, ref3) => {
  var _a;
  const {
    prefixCls: customizePrefixCls,
    className: className2,
    rootClassName,
    children,
    indeterminate = false,
    style: style2,
    onMouseEnter,
    onMouseLeave,
    skipGroup = false,
    disabled
  } = props, restProps = __rest27(props, ["prefixCls", "className", "rootClassName", "children", "indeterminate", "style", "onMouseEnter", "onMouseLeave", "skipGroup", "disabled"]);
  const {
    getPrefixCls,
    direction,
    checkbox
  } = React300.useContext(ConfigContext);
  const checkboxGroup = React300.useContext(GroupContext_default);
  const {
    isFormItemInput
  } = React300.useContext(FormItemInputContext);
  const contextDisabled = React300.useContext(DisabledContext_default);
  const mergedDisabled = (_a = (checkboxGroup === null || checkboxGroup === void 0 ? void 0 : checkboxGroup.disabled) || disabled) !== null && _a !== void 0 ? _a : contextDisabled;
  const prevValue = React300.useRef(restProps.value);
  const checkboxRef = React300.useRef(null);
  const mergedRef = composeRef(ref3, checkboxRef);
  if (true) {
    const warning6 = devUseWarning("Checkbox");
    true ? warning6("checked" in restProps || !!checkboxGroup || !("value" in restProps), "usage", "`value` is not a valid prop, do you mean `checked`?") : void 0;
  }
  React300.useEffect(() => {
    checkboxGroup === null || checkboxGroup === void 0 ? void 0 : checkboxGroup.registerValue(restProps.value);
  }, []);
  React300.useEffect(() => {
    if (skipGroup) {
      return;
    }
    if (restProps.value !== prevValue.current) {
      checkboxGroup === null || checkboxGroup === void 0 ? void 0 : checkboxGroup.cancelValue(prevValue.current);
      checkboxGroup === null || checkboxGroup === void 0 ? void 0 : checkboxGroup.registerValue(restProps.value);
      prevValue.current = restProps.value;
    }
    return () => checkboxGroup === null || checkboxGroup === void 0 ? void 0 : checkboxGroup.cancelValue(restProps.value);
  }, [restProps.value]);
  React300.useEffect(() => {
    var _a2;
    if ((_a2 = checkboxRef.current) === null || _a2 === void 0 ? void 0 : _a2.input) {
      checkboxRef.current.input.indeterminate = indeterminate;
    }
  }, [indeterminate]);
  const prefixCls = getPrefixCls("checkbox", customizePrefixCls);
  const rootCls = useCSSVarCls_default(prefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = style_default20(prefixCls, rootCls);
  const checkboxProps = Object.assign({}, restProps);
  if (checkboxGroup && !skipGroup) {
    checkboxProps.onChange = (...args) => {
      if (restProps.onChange) {
        restProps.onChange.apply(restProps, args);
      }
      if (checkboxGroup.toggleOption) {
        checkboxGroup.toggleOption({
          label: children,
          value: restProps.value
        });
      }
    };
    checkboxProps.name = checkboxGroup.name;
    checkboxProps.checked = checkboxGroup.value.includes(restProps.value);
  }
  const classString = (0, import_classnames104.default)(`${prefixCls}-wrapper`, {
    [`${prefixCls}-rtl`]: direction === "rtl",
    [`${prefixCls}-wrapper-checked`]: checkboxProps.checked,
    [`${prefixCls}-wrapper-disabled`]: mergedDisabled,
    [`${prefixCls}-wrapper-in-form-item`]: isFormItemInput
  }, checkbox === null || checkbox === void 0 ? void 0 : checkbox.className, className2, rootClassName, cssVarCls, rootCls, hashId);
  const checkboxClass = (0, import_classnames104.default)({
    [`${prefixCls}-indeterminate`]: indeterminate
  }, TARGET_CLS, hashId);
  const [onLabelClick, onInputClick] = useBubbleLock(checkboxProps.onClick);
  return wrapCSSVar(/* @__PURE__ */ React300.createElement(wave_default, {
    component: "Checkbox",
    disabled: mergedDisabled
  }, /* @__PURE__ */ React300.createElement("label", {
    className: classString,
    style: Object.assign(Object.assign({}, checkbox === null || checkbox === void 0 ? void 0 : checkbox.style), style2),
    onMouseEnter,
    onMouseLeave,
    onClick: onLabelClick
  }, /* @__PURE__ */ React300.createElement(es_default16, Object.assign({}, checkboxProps, {
    onClick: onInputClick,
    prefixCls,
    className: checkboxClass,
    disabled: mergedDisabled,
    ref: mergedRef
  })), children !== void 0 && children !== null && /* @__PURE__ */ React300.createElement("span", {
    className: `${prefixCls}-label`
  }, children))));
};
var Checkbox2 = /* @__PURE__ */ React300.forwardRef(InternalCheckbox);
if (true) {
  Checkbox2.displayName = "Checkbox";
}
var Checkbox_default = Checkbox2;

// ../../node_modules/antd/es/checkbox/Group.js
var React301 = __toESM(require_react());
var import_classnames105 = __toESM(require_classnames());
var __rest28 = function(s, e3) {
  var t2 = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e3.indexOf(p) < 0) t2[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e3.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t2[p[i]] = s[p[i]];
  }
  return t2;
};
var CheckboxGroup = /* @__PURE__ */ React301.forwardRef((props, ref3) => {
  const {
    defaultValue: defaultValue2,
    children,
    options = [],
    prefixCls: customizePrefixCls,
    className: className2,
    rootClassName,
    style: style2,
    onChange
  } = props, restProps = __rest28(props, ["defaultValue", "children", "options", "prefixCls", "className", "rootClassName", "style", "onChange"]);
  const {
    getPrefixCls,
    direction
  } = React301.useContext(ConfigContext);
  const [value, setValue] = React301.useState(restProps.value || defaultValue2 || []);
  const [registeredValues, setRegisteredValues] = React301.useState([]);
  React301.useEffect(() => {
    if ("value" in restProps) {
      setValue(restProps.value || []);
    }
  }, [restProps.value]);
  const memoizedOptions = React301.useMemo(() => options.map((option) => {
    if (typeof option === "string" || typeof option === "number") {
      return {
        label: option,
        value: option
      };
    }
    return option;
  }), [options]);
  const cancelValue = (val) => {
    setRegisteredValues((prevValues) => prevValues.filter((v) => v !== val));
  };
  const registerValue = (val) => {
    setRegisteredValues((prevValues) => [].concat(_toConsumableArray(prevValues), [val]));
  };
  const toggleOption = (option) => {
    const optionIndex = value.indexOf(option.value);
    const newValue = _toConsumableArray(value);
    if (optionIndex === -1) {
      newValue.push(option.value);
    } else {
      newValue.splice(optionIndex, 1);
    }
    if (!("value" in restProps)) {
      setValue(newValue);
    }
    onChange === null || onChange === void 0 ? void 0 : onChange(newValue.filter((val) => registeredValues.includes(val)).sort((a, b) => {
      const indexA = memoizedOptions.findIndex((opt) => opt.value === a);
      const indexB = memoizedOptions.findIndex((opt) => opt.value === b);
      return indexA - indexB;
    }));
  };
  const prefixCls = getPrefixCls("checkbox", customizePrefixCls);
  const groupPrefixCls = `${prefixCls}-group`;
  const rootCls = useCSSVarCls_default(prefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = style_default20(prefixCls, rootCls);
  const domProps = omit(restProps, ["value", "disabled"]);
  const childrenNode = options.length ? memoizedOptions.map((option) => /* @__PURE__ */ React301.createElement(Checkbox_default, {
    prefixCls,
    key: option.value.toString(),
    disabled: "disabled" in option ? option.disabled : restProps.disabled,
    value: option.value,
    checked: value.includes(option.value),
    onChange: option.onChange,
    className: (0, import_classnames105.default)(`${groupPrefixCls}-item`, option.className),
    style: option.style,
    title: option.title,
    id: option.id,
    required: option.required
  }, option.label)) : children;
  const memoizedContext = React301.useMemo(() => ({
    toggleOption,
    value,
    disabled: restProps.disabled,
    name: restProps.name,
    // https://github.com/ant-design/ant-design/issues/16376
    registerValue,
    cancelValue
  }), [toggleOption, value, restProps.disabled, restProps.name, registerValue, cancelValue]);
  const classString = (0, import_classnames105.default)(groupPrefixCls, {
    [`${groupPrefixCls}-rtl`]: direction === "rtl"
  }, className2, rootClassName, cssVarCls, rootCls, hashId);
  return wrapCSSVar(/* @__PURE__ */ React301.createElement("div", Object.assign({
    className: classString,
    style: style2
  }, domProps, {
    ref: ref3
  }), /* @__PURE__ */ React301.createElement(GroupContext_default.Provider, {
    value: memoizedContext
  }, childrenNode)));
});
var Group_default = CheckboxGroup;

// ../../node_modules/antd/es/checkbox/index.js
var Checkbox3 = Checkbox_default;
Checkbox3.Group = Group_default;
Checkbox3.__ANT_CHECKBOX = true;
if (true) {
  Checkbox3.displayName = "Checkbox";
}
var checkbox_default = Checkbox3;

// ../../node_modules/antd/es/grid/col.js
var React302 = __toESM(require_react());
var import_classnames106 = __toESM(require_classnames());

// ../../node_modules/antd/es/grid/RowContext.js
var import_react98 = __toESM(require_react());
var RowContext = /* @__PURE__ */ (0, import_react98.createContext)({});
var RowContext_default = RowContext;

// ../../node_modules/antd/es/grid/col.js
var __rest29 = function(s, e3) {
  var t2 = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e3.indexOf(p) < 0) t2[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e3.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t2[p[i]] = s[p[i]];
  }
  return t2;
};
function parseFlex(flex) {
  if (typeof flex === "number") {
    return `${flex} ${flex} auto`;
  }
  if (/^\d+(\.\d+)?(px|em|rem|%)$/.test(flex)) {
    return `0 0 ${flex}`;
  }
  return flex;
}
var sizes = ["xs", "sm", "md", "lg", "xl", "xxl"];
var Col = /* @__PURE__ */ React302.forwardRef((props, ref3) => {
  const {
    getPrefixCls,
    direction
  } = React302.useContext(ConfigContext);
  const {
    gutter,
    wrap
  } = React302.useContext(RowContext_default);
  const {
    prefixCls: customizePrefixCls,
    span,
    order,
    offset: offset4,
    push,
    pull,
    className: className2,
    children,
    flex,
    style: style2
  } = props, others = __rest29(props, ["prefixCls", "span", "order", "offset", "push", "pull", "className", "children", "flex", "style"]);
  const prefixCls = getPrefixCls("col", customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = useColStyle(prefixCls);
  const sizeStyle = {};
  let sizeClassObj = {};
  sizes.forEach((size) => {
    let sizeProps = {};
    const propSize = props[size];
    if (typeof propSize === "number") {
      sizeProps.span = propSize;
    } else if (typeof propSize === "object") {
      sizeProps = propSize || {};
    }
    delete others[size];
    sizeClassObj = Object.assign(Object.assign({}, sizeClassObj), {
      [`${prefixCls}-${size}-${sizeProps.span}`]: sizeProps.span !== void 0,
      [`${prefixCls}-${size}-order-${sizeProps.order}`]: sizeProps.order || sizeProps.order === 0,
      [`${prefixCls}-${size}-offset-${sizeProps.offset}`]: sizeProps.offset || sizeProps.offset === 0,
      [`${prefixCls}-${size}-push-${sizeProps.push}`]: sizeProps.push || sizeProps.push === 0,
      [`${prefixCls}-${size}-pull-${sizeProps.pull}`]: sizeProps.pull || sizeProps.pull === 0,
      [`${prefixCls}-rtl`]: direction === "rtl"
    });
    if (sizeProps.flex) {
      sizeClassObj[`${prefixCls}-${size}-flex`] = true;
      sizeStyle[`--${prefixCls}-${size}-flex`] = parseFlex(sizeProps.flex);
    }
  });
  const classes = (0, import_classnames106.default)(prefixCls, {
    [`${prefixCls}-${span}`]: span !== void 0,
    [`${prefixCls}-order-${order}`]: order,
    [`${prefixCls}-offset-${offset4}`]: offset4,
    [`${prefixCls}-push-${push}`]: push,
    [`${prefixCls}-pull-${pull}`]: pull
  }, className2, sizeClassObj, hashId, cssVarCls);
  const mergedStyle = {};
  if (gutter && gutter[0] > 0) {
    const horizontalGutter = gutter[0] / 2;
    mergedStyle.paddingLeft = horizontalGutter;
    mergedStyle.paddingRight = horizontalGutter;
  }
  if (flex) {
    mergedStyle.flex = parseFlex(flex);
    if (wrap === false && !mergedStyle.minWidth) {
      mergedStyle.minWidth = 0;
    }
  }
  return wrapCSSVar(/* @__PURE__ */ React302.createElement("div", Object.assign({}, others, {
    style: Object.assign(Object.assign(Object.assign({}, mergedStyle), style2), sizeStyle),
    className: classes,
    ref: ref3
  }), children));
});
if (true) {
  Col.displayName = "Col";
}
var col_default = Col;

// ../../node_modules/antd/es/grid/row.js
var React303 = __toESM(require_react());
var import_classnames107 = __toESM(require_classnames());

// ../../node_modules/antd/es/grid/hooks/useGutter.js
function useGutter(gutter, screens) {
  const results = [void 0, void 0];
  const normalizedGutter = Array.isArray(gutter) ? gutter : [gutter, void 0];
  const mergedScreens = screens || {
    xs: true,
    sm: true,
    md: true,
    lg: true,
    xl: true,
    xxl: true
  };
  normalizedGutter.forEach((g, index3) => {
    if (typeof g === "object" && g !== null) {
      for (let i = 0; i < responsiveArray.length; i++) {
        const breakpoint = responsiveArray[i];
        if (mergedScreens[breakpoint] && g[breakpoint] !== void 0) {
          results[index3] = g[breakpoint];
          break;
        }
      }
    } else {
      results[index3] = g;
    }
  });
  return results;
}

// ../../node_modules/antd/es/grid/row.js
var __rest30 = function(s, e3) {
  var t2 = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e3.indexOf(p) < 0) t2[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e3.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t2[p[i]] = s[p[i]];
  }
  return t2;
};
function useMergedPropByScreen(oriProp, screen) {
  const [prop, setProp] = React303.useState(typeof oriProp === "string" ? oriProp : "");
  const calcMergedAlignOrJustify = () => {
    if (typeof oriProp === "string") {
      setProp(oriProp);
    }
    if (typeof oriProp !== "object") {
      return;
    }
    for (let i = 0; i < responsiveArray.length; i++) {
      const breakpoint = responsiveArray[i];
      if (!screen || !screen[breakpoint]) {
        continue;
      }
      const curVal = oriProp[breakpoint];
      if (curVal !== void 0) {
        setProp(curVal);
        return;
      }
    }
  };
  React303.useEffect(() => {
    calcMergedAlignOrJustify();
  }, [JSON.stringify(oriProp), screen]);
  return prop;
}
var Row2 = /* @__PURE__ */ React303.forwardRef((props, ref3) => {
  const {
    prefixCls: customizePrefixCls,
    justify,
    align,
    className: className2,
    style: style2,
    children,
    gutter = 0,
    wrap
  } = props, others = __rest30(props, ["prefixCls", "justify", "align", "className", "style", "children", "gutter", "wrap"]);
  const {
    getPrefixCls,
    direction
  } = React303.useContext(ConfigContext);
  const screens = useBreakpoint_default(true, null);
  const mergedAlign = useMergedPropByScreen(align, screens);
  const mergedJustify = useMergedPropByScreen(justify, screens);
  const prefixCls = getPrefixCls("row", customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = useRowStyle(prefixCls);
  const gutters = useGutter(gutter, screens);
  const classes = (0, import_classnames107.default)(prefixCls, {
    [`${prefixCls}-no-wrap`]: wrap === false,
    [`${prefixCls}-${mergedJustify}`]: mergedJustify,
    [`${prefixCls}-${mergedAlign}`]: mergedAlign,
    [`${prefixCls}-rtl`]: direction === "rtl"
  }, className2, hashId, cssVarCls);
  const rowStyle = {};
  const horizontalGutter = gutters[0] != null && gutters[0] > 0 ? gutters[0] / -2 : void 0;
  if (horizontalGutter) {
    rowStyle.marginLeft = horizontalGutter;
    rowStyle.marginRight = horizontalGutter;
  }
  const [gutterH, gutterV] = gutters;
  rowStyle.rowGap = gutterV;
  const rowContext = React303.useMemo(() => ({
    gutter: [gutterH, gutterV],
    wrap
  }), [gutterH, gutterV, wrap]);
  return wrapCSSVar(/* @__PURE__ */ React303.createElement(RowContext_default.Provider, {
    value: rowContext
  }, /* @__PURE__ */ React303.createElement("div", Object.assign({}, others, {
    className: classes,
    style: Object.assign(Object.assign({}, rowStyle), style2),
    ref: ref3
  }), children)));
});
if (true) {
  Row2.displayName = "Row";
}
var row_default = Row2;

// ../../node_modules/antd/es/col/index.js
var col_default2 = col_default;

// ../../node_modules/antd/es/divider/index.js
var React304 = __toESM(require_react());
var import_classnames108 = __toESM(require_classnames());

// ../../node_modules/antd/es/divider/style/index.js
var genSizeDividerStyle = (token2) => {
  const {
    componentCls
  } = token2;
  return {
    [componentCls]: {
      "&-horizontal": {
        [`&${componentCls}`]: {
          "&-sm": {
            marginBlock: token2.marginXS
          },
          "&-md": {
            marginBlock: token2.margin
          }
        }
      }
    }
  };
};
var genSharedDividerStyle = (token2) => {
  const {
    componentCls,
    sizePaddingEdgeHorizontal,
    colorSplit,
    lineWidth,
    textPaddingInline,
    orientationMargin,
    verticalMarginInline
  } = token2;
  return {
    [componentCls]: Object.assign(Object.assign({}, resetComponent(token2)), {
      borderBlockStart: `${unit(lineWidth)} solid ${colorSplit}`,
      // vertical
      "&-vertical": {
        position: "relative",
        top: "-0.06em",
        display: "inline-block",
        height: "0.9em",
        marginInline: verticalMarginInline,
        marginBlock: 0,
        verticalAlign: "middle",
        borderTop: 0,
        borderInlineStart: `${unit(lineWidth)} solid ${colorSplit}`
      },
      "&-horizontal": {
        display: "flex",
        clear: "both",
        width: "100%",
        minWidth: "100%",
        // Fix https://github.com/ant-design/ant-design/issues/10914
        margin: `${unit(token2.marginLG)} 0`
      },
      [`&-horizontal${componentCls}-with-text`]: {
        display: "flex",
        alignItems: "center",
        margin: `${unit(token2.dividerHorizontalWithTextGutterMargin)} 0`,
        color: token2.colorTextHeading,
        fontWeight: 500,
        fontSize: token2.fontSizeLG,
        whiteSpace: "nowrap",
        textAlign: "center",
        borderBlockStart: `0 ${colorSplit}`,
        "&::before, &::after": {
          position: "relative",
          width: "50%",
          borderBlockStart: `${unit(lineWidth)} solid transparent`,
          // Chrome not accept `inherit` in `border-top`
          borderBlockStartColor: "inherit",
          borderBlockEnd: 0,
          transform: "translateY(50%)",
          content: "''"
        }
      },
      [`&-horizontal${componentCls}-with-text-start`]: {
        "&::before": {
          width: `calc(${orientationMargin} * 100%)`
        },
        "&::after": {
          width: `calc(100% - ${orientationMargin} * 100%)`
        }
      },
      [`&-horizontal${componentCls}-with-text-end`]: {
        "&::before": {
          width: `calc(100% - ${orientationMargin} * 100%)`
        },
        "&::after": {
          width: `calc(${orientationMargin} * 100%)`
        }
      },
      [`${componentCls}-inner-text`]: {
        display: "inline-block",
        paddingBlock: 0,
        paddingInline: textPaddingInline
      },
      "&-dashed": {
        background: "none",
        borderColor: colorSplit,
        borderStyle: "dashed",
        borderWidth: `${unit(lineWidth)} 0 0`
      },
      [`&-horizontal${componentCls}-with-text${componentCls}-dashed`]: {
        "&::before, &::after": {
          borderStyle: "dashed none none"
        }
      },
      [`&-vertical${componentCls}-dashed`]: {
        borderInlineStartWidth: lineWidth,
        borderInlineEnd: 0,
        borderBlockStart: 0,
        borderBlockEnd: 0
      },
      "&-dotted": {
        background: "none",
        borderColor: colorSplit,
        borderStyle: "dotted",
        borderWidth: `${unit(lineWidth)} 0 0`
      },
      [`&-horizontal${componentCls}-with-text${componentCls}-dotted`]: {
        "&::before, &::after": {
          borderStyle: "dotted none none"
        }
      },
      [`&-vertical${componentCls}-dotted`]: {
        borderInlineStartWidth: lineWidth,
        borderInlineEnd: 0,
        borderBlockStart: 0,
        borderBlockEnd: 0
      },
      [`&-plain${componentCls}-with-text`]: {
        color: token2.colorText,
        fontWeight: "normal",
        fontSize: token2.fontSize
      },
      [`&-horizontal${componentCls}-with-text-start${componentCls}-no-default-orientation-margin-start`]: {
        "&::before": {
          width: 0
        },
        "&::after": {
          width: "100%"
        },
        [`${componentCls}-inner-text`]: {
          paddingInlineStart: sizePaddingEdgeHorizontal
        }
      },
      [`&-horizontal${componentCls}-with-text-end${componentCls}-no-default-orientation-margin-end`]: {
        "&::before": {
          width: "100%"
        },
        "&::after": {
          width: 0
        },
        [`${componentCls}-inner-text`]: {
          paddingInlineEnd: sizePaddingEdgeHorizontal
        }
      }
    })
  };
};
var prepareComponentToken16 = (token2) => ({
  textPaddingInline: "1em",
  orientationMargin: 0.05,
  verticalMarginInline: token2.marginXS
});
var style_default21 = genStyleHooks("Divider", (token2) => {
  const dividerToken = merge2(token2, {
    dividerHorizontalWithTextGutterMargin: token2.margin,
    sizePaddingEdgeHorizontal: 0
  });
  return [genSharedDividerStyle(dividerToken), genSizeDividerStyle(dividerToken)];
}, prepareComponentToken16, {
  unitless: {
    orientationMargin: true
  }
});

// ../../node_modules/antd/es/divider/index.js
var __rest31 = function(s, e3) {
  var t2 = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e3.indexOf(p) < 0) t2[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e3.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t2[p[i]] = s[p[i]];
  }
  return t2;
};
var sizeClassNameMap = {
  small: "sm",
  middle: "md"
};
var Divider2 = (props) => {
  const {
    getPrefixCls,
    direction,
    className: dividerClassName,
    style: dividerStyle
  } = useComponentConfig("divider");
  const {
    prefixCls: customizePrefixCls,
    type: type5 = "horizontal",
    orientation = "center",
    orientationMargin,
    className: className2,
    rootClassName,
    children,
    dashed,
    variant = "solid",
    plain,
    style: style2,
    size: customSize
  } = props, restProps = __rest31(props, ["prefixCls", "type", "orientation", "orientationMargin", "className", "rootClassName", "children", "dashed", "variant", "plain", "style", "size"]);
  const prefixCls = getPrefixCls("divider", customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = style_default21(prefixCls);
  const sizeFullName = useSize_default(customSize);
  const sizeCls = sizeClassNameMap[sizeFullName];
  const hasChildren = !!children;
  const mergedOrientation = React304.useMemo(() => {
    if (orientation === "left") {
      return direction === "rtl" ? "end" : "start";
    }
    if (orientation === "right") {
      return direction === "rtl" ? "start" : "end";
    }
    return orientation;
  }, [direction, orientation]);
  const hasMarginStart = mergedOrientation === "start" && orientationMargin != null;
  const hasMarginEnd = mergedOrientation === "end" && orientationMargin != null;
  const classString = (0, import_classnames108.default)(prefixCls, dividerClassName, hashId, cssVarCls, `${prefixCls}-${type5}`, {
    [`${prefixCls}-with-text`]: hasChildren,
    [`${prefixCls}-with-text-${mergedOrientation}`]: hasChildren,
    [`${prefixCls}-dashed`]: !!dashed,
    [`${prefixCls}-${variant}`]: variant !== "solid",
    [`${prefixCls}-plain`]: !!plain,
    [`${prefixCls}-rtl`]: direction === "rtl",
    [`${prefixCls}-no-default-orientation-margin-start`]: hasMarginStart,
    [`${prefixCls}-no-default-orientation-margin-end`]: hasMarginEnd,
    [`${prefixCls}-${sizeCls}`]: !!sizeCls
  }, className2, rootClassName);
  const memoizedOrientationMargin = React304.useMemo(() => {
    if (typeof orientationMargin === "number") {
      return orientationMargin;
    }
    if (/^\d+$/.test(orientationMargin)) {
      return Number(orientationMargin);
    }
    return orientationMargin;
  }, [orientationMargin]);
  const innerStyle = {
    marginInlineStart: hasMarginStart ? memoizedOrientationMargin : void 0,
    marginInlineEnd: hasMarginEnd ? memoizedOrientationMargin : void 0
  };
  if (true) {
    const warning6 = devUseWarning("Divider");
    true ? warning6(!children || type5 !== "vertical", "usage", "`children` not working in `vertical` mode.") : void 0;
  }
  return wrapCSSVar(/* @__PURE__ */ React304.createElement("div", Object.assign({
    className: classString,
    style: Object.assign(Object.assign({}, dividerStyle), style2)
  }, restProps, {
    role: "separator"
  }), children && type5 !== "vertical" && /* @__PURE__ */ React304.createElement("span", {
    className: `${prefixCls}-inner-text`,
    style: innerStyle
  }, children)));
};
if (true) {
  Divider2.displayName = "Divider";
}
var divider_default = Divider2;

// ../../node_modules/antd/es/input-number/index.js
var React311 = __toESM(require_react());

// ../../node_modules/@ant-design/icons/es/icons/UpOutlined.js
var React305 = __toESM(require_react());

// ../../node_modules/@ant-design/icons-svg/es/asn/UpOutlined.js
var UpOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M890.5 755.3L537.9 269.2c-12.8-17.6-39-17.6-51.7 0L133.5 755.3A8 8 0 00140 768h75c5.1 0 9.9-2.5 12.9-6.6L512 369.8l284.1 391.6c3 4.1 7.8 6.6 12.9 6.6h75c6.5 0 10.3-7.4 6.5-12.7z" } }] }, "name": "up", "theme": "outlined" };
var UpOutlined_default = UpOutlined;

// ../../node_modules/@ant-design/icons/es/icons/UpOutlined.js
var UpOutlined2 = function UpOutlined3(props, ref3) {
  return /* @__PURE__ */ React305.createElement(AntdIcon_default, _extends({}, props, {
    ref: ref3,
    icon: UpOutlined_default
  }));
};
var RefIcon15 = /* @__PURE__ */ React305.forwardRef(UpOutlined2);
if (true) {
  RefIcon15.displayName = "UpOutlined";
}
var UpOutlined_default2 = RefIcon15;

// ../../node_modules/antd/es/input-number/index.js
var import_classnames113 = __toESM(require_classnames());

// ../../node_modules/@rc-component/mini-decimal/es/supportUtil.js
function supportBigInt() {
  return typeof BigInt === "function";
}

// ../../node_modules/@rc-component/mini-decimal/es/numberUtil.js
function isEmpty(value) {
  return !value && value !== 0 && !Number.isNaN(value) || !String(value).trim();
}
function trimNumber(numStr) {
  var str = numStr.trim();
  var negative = str.startsWith("-");
  if (negative) {
    str = str.slice(1);
  }
  str = str.replace(/(\.\d*[^0])0*$/, "$1").replace(/\.0*$/, "").replace(/^0+/, "");
  if (str.startsWith(".")) {
    str = "0".concat(str);
  }
  var trimStr = str || "0";
  var splitNumber = trimStr.split(".");
  var integerStr = splitNumber[0] || "0";
  var decimalStr = splitNumber[1] || "0";
  if (integerStr === "0" && decimalStr === "0") {
    negative = false;
  }
  var negativeStr = negative ? "-" : "";
  return {
    negative,
    negativeStr,
    trimStr,
    integerStr,
    decimalStr,
    fullStr: "".concat(negativeStr).concat(trimStr)
  };
}
function isE(number4) {
  var str = String(number4);
  return !Number.isNaN(Number(str)) && str.includes("e");
}
function getNumberPrecision(number4) {
  var numStr = String(number4);
  if (isE(number4)) {
    var precision = Number(numStr.slice(numStr.indexOf("e-") + 2));
    var decimalMatch = numStr.match(/\.(\d+)/);
    if (decimalMatch !== null && decimalMatch !== void 0 && decimalMatch[1]) {
      precision += decimalMatch[1].length;
    }
    return precision;
  }
  return numStr.includes(".") && validateNumber(numStr) ? numStr.length - numStr.indexOf(".") - 1 : 0;
}
function num2str(number4) {
  var numStr = String(number4);
  if (isE(number4)) {
    if (number4 > Number.MAX_SAFE_INTEGER) {
      return String(supportBigInt() ? BigInt(number4).toString() : Number.MAX_SAFE_INTEGER);
    }
    if (number4 < Number.MIN_SAFE_INTEGER) {
      return String(supportBigInt() ? BigInt(number4).toString() : Number.MIN_SAFE_INTEGER);
    }
    numStr = number4.toFixed(getNumberPrecision(numStr));
  }
  return trimNumber(numStr).fullStr;
}
function validateNumber(num) {
  if (typeof num === "number") {
    return !Number.isNaN(num);
  }
  if (!num) {
    return false;
  }
  return (
    // Normal type: 11.28
    /^\s*-?\d+(\.\d+)?\s*$/.test(num) || // Pre-number: 1.
    /^\s*-?\d+\.\s*$/.test(num) || // Post-number: .1
    /^\s*-?\.\d+\s*$/.test(num)
  );
}

// ../../node_modules/@rc-component/mini-decimal/es/BigIntDecimal.js
var BigIntDecimal = /* @__PURE__ */ (function() {
  function BigIntDecimal2(value) {
    _classCallCheck(this, BigIntDecimal2);
    _defineProperty(this, "origin", "");
    _defineProperty(this, "negative", void 0);
    _defineProperty(this, "integer", void 0);
    _defineProperty(this, "decimal", void 0);
    _defineProperty(this, "decimalLen", void 0);
    _defineProperty(this, "empty", void 0);
    _defineProperty(this, "nan", void 0);
    if (isEmpty(value)) {
      this.empty = true;
      return;
    }
    this.origin = String(value);
    if (value === "-" || Number.isNaN(value)) {
      this.nan = true;
      return;
    }
    var mergedValue = value;
    if (isE(mergedValue)) {
      mergedValue = Number(mergedValue);
    }
    mergedValue = typeof mergedValue === "string" ? mergedValue : num2str(mergedValue);
    if (validateNumber(mergedValue)) {
      var trimRet = trimNumber(mergedValue);
      this.negative = trimRet.negative;
      var numbers = trimRet.trimStr.split(".");
      this.integer = BigInt(numbers[0]);
      var decimalStr = numbers[1] || "0";
      this.decimal = BigInt(decimalStr);
      this.decimalLen = decimalStr.length;
    } else {
      this.nan = true;
    }
  }
  _createClass(BigIntDecimal2, [{
    key: "getMark",
    value: function getMark2() {
      return this.negative ? "-" : "";
    }
  }, {
    key: "getIntegerStr",
    value: function getIntegerStr() {
      return this.integer.toString();
    }
    /**
     * @private get decimal string
     */
  }, {
    key: "getDecimalStr",
    value: function getDecimalStr() {
      return this.decimal.toString().padStart(this.decimalLen, "0");
    }
    /**
     * @private Align BigIntDecimal with same decimal length. e.g. 12.3 + 5 = 1230000
     * This is used for add function only.
     */
  }, {
    key: "alignDecimal",
    value: function alignDecimal(decimalLength) {
      var str = "".concat(this.getMark()).concat(this.getIntegerStr()).concat(this.getDecimalStr().padEnd(decimalLength, "0"));
      return BigInt(str);
    }
  }, {
    key: "negate",
    value: function negate2() {
      var clone = new BigIntDecimal2(this.toString());
      clone.negative = !clone.negative;
      return clone;
    }
  }, {
    key: "cal",
    value: function cal(offset4, calculator, calDecimalLen) {
      var maxDecimalLength = Math.max(this.getDecimalStr().length, offset4.getDecimalStr().length);
      var myAlignedDecimal = this.alignDecimal(maxDecimalLength);
      var offsetAlignedDecimal = offset4.alignDecimal(maxDecimalLength);
      var valueStr = calculator(myAlignedDecimal, offsetAlignedDecimal).toString();
      var nextDecimalLength = calDecimalLen(maxDecimalLength);
      var _trimNumber = trimNumber(valueStr), negativeStr = _trimNumber.negativeStr, trimStr = _trimNumber.trimStr;
      var hydrateValueStr = "".concat(negativeStr).concat(trimStr.padStart(nextDecimalLength + 1, "0"));
      return new BigIntDecimal2("".concat(hydrateValueStr.slice(0, -nextDecimalLength), ".").concat(hydrateValueStr.slice(-nextDecimalLength)));
    }
  }, {
    key: "add",
    value: function add3(value) {
      if (this.isInvalidate()) {
        return new BigIntDecimal2(value);
      }
      var offset4 = new BigIntDecimal2(value);
      if (offset4.isInvalidate()) {
        return this;
      }
      return this.cal(offset4, function(num1, num2) {
        return num1 + num2;
      }, function(len) {
        return len;
      });
    }
  }, {
    key: "multi",
    value: function multi(value) {
      var target = new BigIntDecimal2(value);
      if (this.isInvalidate() || target.isInvalidate()) {
        return new BigIntDecimal2(NaN);
      }
      return this.cal(target, function(num1, num2) {
        return num1 * num2;
      }, function(len) {
        return len * 2;
      });
    }
  }, {
    key: "isEmpty",
    value: function isEmpty2() {
      return this.empty;
    }
  }, {
    key: "isNaN",
    value: function isNaN2() {
      return this.nan;
    }
  }, {
    key: "isInvalidate",
    value: function isInvalidate() {
      return this.isEmpty() || this.isNaN();
    }
  }, {
    key: "equals",
    value: function equals2(target) {
      return this.toString() === (target === null || target === void 0 ? void 0 : target.toString());
    }
  }, {
    key: "lessEquals",
    value: function lessEquals(target) {
      return this.add(target.negate().toString()).toNumber() <= 0;
    }
  }, {
    key: "toNumber",
    value: function toNumber2() {
      if (this.isNaN()) {
        return NaN;
      }
      return Number(this.toString());
    }
  }, {
    key: "toString",
    value: function toString3() {
      var safe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
      if (!safe) {
        return this.origin;
      }
      if (this.isInvalidate()) {
        return "";
      }
      return trimNumber("".concat(this.getMark()).concat(this.getIntegerStr(), ".").concat(this.getDecimalStr())).fullStr;
    }
  }]);
  return BigIntDecimal2;
})();

// ../../node_modules/@rc-component/mini-decimal/es/NumberDecimal.js
var NumberDecimal = /* @__PURE__ */ (function() {
  function NumberDecimal2(value) {
    _classCallCheck(this, NumberDecimal2);
    _defineProperty(this, "origin", "");
    _defineProperty(this, "number", void 0);
    _defineProperty(this, "empty", void 0);
    if (isEmpty(value)) {
      this.empty = true;
      return;
    }
    this.origin = String(value);
    this.number = Number(value);
  }
  _createClass(NumberDecimal2, [{
    key: "negate",
    value: function negate2() {
      return new NumberDecimal2(-this.toNumber());
    }
  }, {
    key: "add",
    value: function add3(value) {
      if (this.isInvalidate()) {
        return new NumberDecimal2(value);
      }
      var target = Number(value);
      if (Number.isNaN(target)) {
        return this;
      }
      var number4 = this.number + target;
      if (number4 > Number.MAX_SAFE_INTEGER) {
        return new NumberDecimal2(Number.MAX_SAFE_INTEGER);
      }
      if (number4 < Number.MIN_SAFE_INTEGER) {
        return new NumberDecimal2(Number.MIN_SAFE_INTEGER);
      }
      var maxPrecision = Math.max(getNumberPrecision(this.number), getNumberPrecision(target));
      return new NumberDecimal2(number4.toFixed(maxPrecision));
    }
  }, {
    key: "multi",
    value: function multi(value) {
      var target = Number(value);
      if (this.isInvalidate() || Number.isNaN(target)) {
        return new NumberDecimal2(NaN);
      }
      var number4 = this.number * target;
      if (number4 > Number.MAX_SAFE_INTEGER) {
        return new NumberDecimal2(Number.MAX_SAFE_INTEGER);
      }
      if (number4 < Number.MIN_SAFE_INTEGER) {
        return new NumberDecimal2(Number.MIN_SAFE_INTEGER);
      }
      var maxPrecision = Math.max(getNumberPrecision(this.number), getNumberPrecision(target));
      return new NumberDecimal2(number4.toFixed(maxPrecision));
    }
  }, {
    key: "isEmpty",
    value: function isEmpty2() {
      return this.empty;
    }
  }, {
    key: "isNaN",
    value: function isNaN2() {
      return Number.isNaN(this.number);
    }
  }, {
    key: "isInvalidate",
    value: function isInvalidate() {
      return this.isEmpty() || this.isNaN();
    }
  }, {
    key: "equals",
    value: function equals2(target) {
      return this.toNumber() === (target === null || target === void 0 ? void 0 : target.toNumber());
    }
  }, {
    key: "lessEquals",
    value: function lessEquals(target) {
      return this.add(target.negate().toString()).toNumber() <= 0;
    }
  }, {
    key: "toNumber",
    value: function toNumber2() {
      return this.number;
    }
  }, {
    key: "toString",
    value: function toString3() {
      var safe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
      if (!safe) {
        return this.origin;
      }
      if (this.isInvalidate()) {
        return "";
      }
      return num2str(this.number);
    }
  }]);
  return NumberDecimal2;
})();

// ../../node_modules/@rc-component/mini-decimal/es/MiniDecimal.js
function getMiniDecimal(value) {
  if (supportBigInt()) {
    return new BigIntDecimal(value);
  }
  return new NumberDecimal(value);
}
function toFixed(numStr, separatorStr, precision) {
  var cutOnly = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
  if (numStr === "") {
    return "";
  }
  var _trimNumber = trimNumber(numStr), negativeStr = _trimNumber.negativeStr, integerStr = _trimNumber.integerStr, decimalStr = _trimNumber.decimalStr;
  var precisionDecimalStr = "".concat(separatorStr).concat(decimalStr);
  var numberWithoutDecimal = "".concat(negativeStr).concat(integerStr);
  if (precision >= 0) {
    var advancedNum = Number(decimalStr[precision]);
    if (advancedNum >= 5 && !cutOnly) {
      var advancedDecimal = getMiniDecimal(numStr).add("".concat(negativeStr, "0.").concat("0".repeat(precision)).concat(10 - advancedNum));
      return toFixed(advancedDecimal.toString(), separatorStr, precision, cutOnly);
    }
    if (precision === 0) {
      return numberWithoutDecimal;
    }
    return "".concat(numberWithoutDecimal).concat(separatorStr).concat(decimalStr.padEnd(precision, "0").slice(0, precision));
  }
  if (precisionDecimalStr === ".0") {
    return numberWithoutDecimal;
  }
  return "".concat(numberWithoutDecimal).concat(precisionDecimalStr);
}

// ../../node_modules/@rc-component/mini-decimal/es/index.js
var es_default18 = getMiniDecimal;

// ../../node_modules/rc-input-number/es/InputNumber.js
var import_classnames112 = __toESM(require_classnames());

// ../../node_modules/rc-input/es/BaseInput.js
var import_classnames109 = __toESM(require_classnames());
var import_react99 = __toESM(require_react());

// ../../node_modules/rc-input/es/utils/commonUtils.js
function hasAddon(props) {
  return !!(props.addonBefore || props.addonAfter);
}
function hasPrefixSuffix(props) {
  return !!(props.prefix || props.suffix || props.allowClear);
}
function cloneEvent(event, target, value) {
  var currentTarget = target.cloneNode(true);
  var newEvent = Object.create(event, {
    target: {
      value: currentTarget
    },
    currentTarget: {
      value: currentTarget
    }
  });
  currentTarget.value = value;
  if (typeof target.selectionStart === "number" && typeof target.selectionEnd === "number") {
    currentTarget.selectionStart = target.selectionStart;
    currentTarget.selectionEnd = target.selectionEnd;
  }
  currentTarget.setSelectionRange = function() {
    target.setSelectionRange.apply(target, arguments);
  };
  return newEvent;
}
function resolveOnChange(target, e3, onChange, targetValue) {
  if (!onChange) {
    return;
  }
  var event = e3;
  if (e3.type === "click") {
    event = cloneEvent(e3, target, "");
    onChange(event);
    return;
  }
  if (target.type !== "file" && targetValue !== void 0) {
    event = cloneEvent(e3, target, targetValue);
    onChange(event);
    return;
  }
  onChange(event);
}
function triggerFocus(element, option) {
  if (!element) return;
  element.focus(option);
  var _ref = option || {}, cursor = _ref.cursor;
  if (cursor) {
    var len = element.value.length;
    switch (cursor) {
      case "start":
        element.setSelectionRange(0, 0);
        break;
      case "end":
        element.setSelectionRange(len, len);
        break;
      default:
        element.setSelectionRange(0, len);
    }
  }
}

// ../../node_modules/rc-input/es/BaseInput.js
var BaseInput = /* @__PURE__ */ import_react99.default.forwardRef(function(props, ref3) {
  var _props, _props2, _props3;
  var inputEl = props.inputElement, children = props.children, prefixCls = props.prefixCls, prefix3 = props.prefix, suffix = props.suffix, addonBefore = props.addonBefore, addonAfter = props.addonAfter, className2 = props.className, style2 = props.style, disabled = props.disabled, readOnly = props.readOnly, focused = props.focused, triggerFocus2 = props.triggerFocus, allowClear = props.allowClear, value = props.value, handleReset = props.handleReset, hidden = props.hidden, classes = props.classes, classNames186 = props.classNames, dataAttrs = props.dataAttrs, styles = props.styles, components = props.components, onClear = props.onClear;
  var inputElement = children !== null && children !== void 0 ? children : inputEl;
  var AffixWrapperComponent = (components === null || components === void 0 ? void 0 : components.affixWrapper) || "span";
  var GroupWrapperComponent = (components === null || components === void 0 ? void 0 : components.groupWrapper) || "span";
  var WrapperComponent = (components === null || components === void 0 ? void 0 : components.wrapper) || "span";
  var GroupAddonComponent = (components === null || components === void 0 ? void 0 : components.groupAddon) || "span";
  var containerRef = (0, import_react99.useRef)(null);
  var onInputClick = function onInputClick2(e3) {
    var _containerRef$current;
    if ((_containerRef$current = containerRef.current) !== null && _containerRef$current !== void 0 && _containerRef$current.contains(e3.target)) {
      triggerFocus2 === null || triggerFocus2 === void 0 || triggerFocus2();
    }
  };
  var hasAffix = hasPrefixSuffix(props);
  var element = /* @__PURE__ */ (0, import_react99.cloneElement)(inputElement, {
    value,
    className: (0, import_classnames109.default)((_props = inputElement.props) === null || _props === void 0 ? void 0 : _props.className, !hasAffix && (classNames186 === null || classNames186 === void 0 ? void 0 : classNames186.variant)) || null
  });
  var groupRef = (0, import_react99.useRef)(null);
  import_react99.default.useImperativeHandle(ref3, function() {
    return {
      nativeElement: groupRef.current || containerRef.current
    };
  });
  if (hasAffix) {
    var clearIcon = null;
    if (allowClear) {
      var needClear = !disabled && !readOnly && value;
      var clearIconCls = "".concat(prefixCls, "-clear-icon");
      var iconNode = _typeof(allowClear) === "object" && allowClear !== null && allowClear !== void 0 && allowClear.clearIcon ? allowClear.clearIcon : "\u2716";
      clearIcon = /* @__PURE__ */ import_react99.default.createElement("button", {
        type: "button",
        tabIndex: -1,
        onClick: function onClick(event) {
          handleReset === null || handleReset === void 0 || handleReset(event);
          onClear === null || onClear === void 0 || onClear();
        },
        onMouseDown: function onMouseDown(e3) {
          return e3.preventDefault();
        },
        className: (0, import_classnames109.default)(clearIconCls, _defineProperty(_defineProperty({}, "".concat(clearIconCls, "-hidden"), !needClear), "".concat(clearIconCls, "-has-suffix"), !!suffix))
      }, iconNode);
    }
    var affixWrapperPrefixCls = "".concat(prefixCls, "-affix-wrapper");
    var affixWrapperCls = (0, import_classnames109.default)(affixWrapperPrefixCls, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "".concat(prefixCls, "-disabled"), disabled), "".concat(affixWrapperPrefixCls, "-disabled"), disabled), "".concat(affixWrapperPrefixCls, "-focused"), focused), "".concat(affixWrapperPrefixCls, "-readonly"), readOnly), "".concat(affixWrapperPrefixCls, "-input-with-clear-btn"), suffix && allowClear && value), classes === null || classes === void 0 ? void 0 : classes.affixWrapper, classNames186 === null || classNames186 === void 0 ? void 0 : classNames186.affixWrapper, classNames186 === null || classNames186 === void 0 ? void 0 : classNames186.variant);
    var suffixNode = (suffix || allowClear) && /* @__PURE__ */ import_react99.default.createElement("span", {
      className: (0, import_classnames109.default)("".concat(prefixCls, "-suffix"), classNames186 === null || classNames186 === void 0 ? void 0 : classNames186.suffix),
      style: styles === null || styles === void 0 ? void 0 : styles.suffix
    }, clearIcon, suffix);
    element = /* @__PURE__ */ import_react99.default.createElement(AffixWrapperComponent, _extends({
      className: affixWrapperCls,
      style: styles === null || styles === void 0 ? void 0 : styles.affixWrapper,
      onClick: onInputClick
    }, dataAttrs === null || dataAttrs === void 0 ? void 0 : dataAttrs.affixWrapper, {
      ref: containerRef
    }), prefix3 && /* @__PURE__ */ import_react99.default.createElement("span", {
      className: (0, import_classnames109.default)("".concat(prefixCls, "-prefix"), classNames186 === null || classNames186 === void 0 ? void 0 : classNames186.prefix),
      style: styles === null || styles === void 0 ? void 0 : styles.prefix
    }, prefix3), element, suffixNode);
  }
  if (hasAddon(props)) {
    var wrapperCls = "".concat(prefixCls, "-group");
    var addonCls = "".concat(wrapperCls, "-addon");
    var groupWrapperCls = "".concat(wrapperCls, "-wrapper");
    var mergedWrapperClassName = (0, import_classnames109.default)("".concat(prefixCls, "-wrapper"), wrapperCls, classes === null || classes === void 0 ? void 0 : classes.wrapper, classNames186 === null || classNames186 === void 0 ? void 0 : classNames186.wrapper);
    var mergedGroupClassName = (0, import_classnames109.default)(groupWrapperCls, _defineProperty({}, "".concat(groupWrapperCls, "-disabled"), disabled), classes === null || classes === void 0 ? void 0 : classes.group, classNames186 === null || classNames186 === void 0 ? void 0 : classNames186.groupWrapper);
    element = /* @__PURE__ */ import_react99.default.createElement(GroupWrapperComponent, {
      className: mergedGroupClassName,
      ref: groupRef
    }, /* @__PURE__ */ import_react99.default.createElement(WrapperComponent, {
      className: mergedWrapperClassName
    }, addonBefore && /* @__PURE__ */ import_react99.default.createElement(GroupAddonComponent, {
      className: addonCls
    }, addonBefore), element, addonAfter && /* @__PURE__ */ import_react99.default.createElement(GroupAddonComponent, {
      className: addonCls
    }, addonAfter)));
  }
  return /* @__PURE__ */ import_react99.default.cloneElement(element, {
    className: (0, import_classnames109.default)((_props2 = element.props) === null || _props2 === void 0 ? void 0 : _props2.className, className2) || null,
    style: _objectSpread2(_objectSpread2({}, (_props3 = element.props) === null || _props3 === void 0 ? void 0 : _props3.style), style2),
    hidden
  });
});
var BaseInput_default = BaseInput;

// ../../node_modules/rc-input/es/Input.js
var import_classnames110 = __toESM(require_classnames());
var import_react100 = __toESM(require_react());

// ../../node_modules/rc-input/es/hooks/useCount.js
var React307 = __toESM(require_react());
var _excluded49 = ["show"];
function useCount(count, showCount) {
  return React307.useMemo(function() {
    var mergedConfig = {};
    if (showCount) {
      mergedConfig.show = _typeof(showCount) === "object" && showCount.formatter ? showCount.formatter : !!showCount;
    }
    mergedConfig = _objectSpread2(_objectSpread2({}, mergedConfig), count);
    var _ref = mergedConfig, show = _ref.show, rest = _objectWithoutProperties(_ref, _excluded49);
    return _objectSpread2(_objectSpread2({}, rest), {}, {
      show: !!show,
      showFormatter: typeof show === "function" ? show : void 0,
      strategy: rest.strategy || function(value) {
        return value.length;
      }
    });
  }, [count, showCount]);
}

// ../../node_modules/rc-input/es/Input.js
var _excluded50 = ["autoComplete", "onChange", "onFocus", "onBlur", "onPressEnter", "onKeyDown", "onKeyUp", "prefixCls", "disabled", "htmlSize", "className", "maxLength", "suffix", "showCount", "count", "type", "classes", "classNames", "styles", "onCompositionStart", "onCompositionEnd"];
var Input4 = /* @__PURE__ */ (0, import_react100.forwardRef)(function(props, ref3) {
  var autoComplete = props.autoComplete, onChange = props.onChange, onFocus = props.onFocus, onBlur = props.onBlur, onPressEnter = props.onPressEnter, onKeyDown2 = props.onKeyDown, onKeyUp = props.onKeyUp, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-input" : _props$prefixCls, disabled = props.disabled, htmlSize = props.htmlSize, className2 = props.className, maxLength = props.maxLength, suffix = props.suffix, showCount = props.showCount, count = props.count, _props$type = props.type, type5 = _props$type === void 0 ? "text" : _props$type, classes = props.classes, classNames186 = props.classNames, styles = props.styles, _onCompositionStart = props.onCompositionStart, onCompositionEnd = props.onCompositionEnd, rest = _objectWithoutProperties(props, _excluded50);
  var _useState = (0, import_react100.useState)(false), _useState2 = _slicedToArray(_useState, 2), focused = _useState2[0], setFocused = _useState2[1];
  var compositionRef = (0, import_react100.useRef)(false);
  var keyLockRef = (0, import_react100.useRef)(false);
  var inputRef = (0, import_react100.useRef)(null);
  var holderRef = (0, import_react100.useRef)(null);
  var focus = function focus2(option) {
    if (inputRef.current) {
      triggerFocus(inputRef.current, option);
    }
  };
  var _useMergedState = useMergedState(props.defaultValue, {
    value: props.value
  }), _useMergedState2 = _slicedToArray(_useMergedState, 2), value = _useMergedState2[0], setValue = _useMergedState2[1];
  var formatValue2 = value === void 0 || value === null ? "" : String(value);
  var _useState3 = (0, import_react100.useState)(null), _useState4 = _slicedToArray(_useState3, 2), selection = _useState4[0], setSelection = _useState4[1];
  var countConfig = useCount(count, showCount);
  var mergedMax = countConfig.max || maxLength;
  var valueLength = countConfig.strategy(formatValue2);
  var isOutOfRange = !!mergedMax && valueLength > mergedMax;
  (0, import_react100.useImperativeHandle)(ref3, function() {
    var _holderRef$current;
    return {
      focus,
      blur: function blur() {
        var _inputRef$current;
        (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || _inputRef$current.blur();
      },
      setSelectionRange: function setSelectionRange(start, end, direction) {
        var _inputRef$current2;
        (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 || _inputRef$current2.setSelectionRange(start, end, direction);
      },
      select: function select() {
        var _inputRef$current3;
        (_inputRef$current3 = inputRef.current) === null || _inputRef$current3 === void 0 || _inputRef$current3.select();
      },
      input: inputRef.current,
      nativeElement: ((_holderRef$current = holderRef.current) === null || _holderRef$current === void 0 ? void 0 : _holderRef$current.nativeElement) || inputRef.current
    };
  });
  (0, import_react100.useEffect)(function() {
    if (keyLockRef.current) {
      keyLockRef.current = false;
    }
    setFocused(function(prev2) {
      return prev2 && disabled ? false : prev2;
    });
  }, [disabled]);
  var triggerChange = function triggerChange2(e3, currentValue, info) {
    var cutValue = currentValue;
    if (!compositionRef.current && countConfig.exceedFormatter && countConfig.max && countConfig.strategy(currentValue) > countConfig.max) {
      cutValue = countConfig.exceedFormatter(currentValue, {
        max: countConfig.max
      });
      if (currentValue !== cutValue) {
        var _inputRef$current4, _inputRef$current5;
        setSelection([((_inputRef$current4 = inputRef.current) === null || _inputRef$current4 === void 0 ? void 0 : _inputRef$current4.selectionStart) || 0, ((_inputRef$current5 = inputRef.current) === null || _inputRef$current5 === void 0 ? void 0 : _inputRef$current5.selectionEnd) || 0]);
      }
    } else if (info.source === "compositionEnd") {
      return;
    }
    setValue(cutValue);
    if (inputRef.current) {
      resolveOnChange(inputRef.current, e3, onChange, cutValue);
    }
  };
  (0, import_react100.useEffect)(function() {
    if (selection) {
      var _inputRef$current6;
      (_inputRef$current6 = inputRef.current) === null || _inputRef$current6 === void 0 || _inputRef$current6.setSelectionRange.apply(_inputRef$current6, _toConsumableArray(selection));
    }
  }, [selection]);
  var onInternalChange = function onInternalChange2(e3) {
    triggerChange(e3, e3.target.value, {
      source: "change"
    });
  };
  var onInternalCompositionEnd = function onInternalCompositionEnd2(e3) {
    compositionRef.current = false;
    triggerChange(e3, e3.currentTarget.value, {
      source: "compositionEnd"
    });
    onCompositionEnd === null || onCompositionEnd === void 0 || onCompositionEnd(e3);
  };
  var handleKeyDown = function handleKeyDown2(e3) {
    if (onPressEnter && e3.key === "Enter" && !keyLockRef.current) {
      keyLockRef.current = true;
      onPressEnter(e3);
    }
    onKeyDown2 === null || onKeyDown2 === void 0 || onKeyDown2(e3);
  };
  var handleKeyUp = function handleKeyUp2(e3) {
    if (e3.key === "Enter") {
      keyLockRef.current = false;
    }
    onKeyUp === null || onKeyUp === void 0 || onKeyUp(e3);
  };
  var handleFocus = function handleFocus2(e3) {
    setFocused(true);
    onFocus === null || onFocus === void 0 || onFocus(e3);
  };
  var handleBlur = function handleBlur2(e3) {
    if (keyLockRef.current) {
      keyLockRef.current = false;
    }
    setFocused(false);
    onBlur === null || onBlur === void 0 || onBlur(e3);
  };
  var handleReset = function handleReset2(e3) {
    setValue("");
    focus();
    if (inputRef.current) {
      resolveOnChange(inputRef.current, e3, onChange);
    }
  };
  var outOfRangeCls = isOutOfRange && "".concat(prefixCls, "-out-of-range");
  var getInputElement = function getInputElement2() {
    var otherProps = omit(props, [
      "prefixCls",
      "onPressEnter",
      "addonBefore",
      "addonAfter",
      "prefix",
      "suffix",
      "allowClear",
      // Input elements must be either controlled or uncontrolled,
      // specify either the value prop, or the defaultValue prop, but not both.
      "defaultValue",
      "showCount",
      "count",
      "classes",
      "htmlSize",
      "styles",
      "classNames",
      "onClear"
    ]);
    return /* @__PURE__ */ import_react100.default.createElement("input", _extends({
      autoComplete
    }, otherProps, {
      onChange: onInternalChange,
      onFocus: handleFocus,
      onBlur: handleBlur,
      onKeyDown: handleKeyDown,
      onKeyUp: handleKeyUp,
      className: (0, import_classnames110.default)(prefixCls, _defineProperty({}, "".concat(prefixCls, "-disabled"), disabled), classNames186 === null || classNames186 === void 0 ? void 0 : classNames186.input),
      style: styles === null || styles === void 0 ? void 0 : styles.input,
      ref: inputRef,
      size: htmlSize,
      type: type5,
      onCompositionStart: function onCompositionStart(e3) {
        compositionRef.current = true;
        _onCompositionStart === null || _onCompositionStart === void 0 || _onCompositionStart(e3);
      },
      onCompositionEnd: onInternalCompositionEnd
    }));
  };
  var getSuffix = function getSuffix2() {
    var hasMaxLength = Number(mergedMax) > 0;
    if (suffix || countConfig.show) {
      var dataCount = countConfig.showFormatter ? countConfig.showFormatter({
        value: formatValue2,
        count: valueLength,
        maxLength: mergedMax
      }) : "".concat(valueLength).concat(hasMaxLength ? " / ".concat(mergedMax) : "");
      return /* @__PURE__ */ import_react100.default.createElement(import_react100.default.Fragment, null, countConfig.show && /* @__PURE__ */ import_react100.default.createElement("span", {
        className: (0, import_classnames110.default)("".concat(prefixCls, "-show-count-suffix"), _defineProperty({}, "".concat(prefixCls, "-show-count-has-suffix"), !!suffix), classNames186 === null || classNames186 === void 0 ? void 0 : classNames186.count),
        style: _objectSpread2({}, styles === null || styles === void 0 ? void 0 : styles.count)
      }, dataCount), suffix);
    }
    return null;
  };
  return /* @__PURE__ */ import_react100.default.createElement(BaseInput_default, _extends({}, rest, {
    prefixCls,
    className: (0, import_classnames110.default)(className2, outOfRangeCls),
    handleReset,
    value: formatValue2,
    focused,
    triggerFocus: focus,
    suffix: getSuffix(),
    disabled,
    classes,
    classNames: classNames186,
    styles,
    ref: holderRef
  }), getInputElement());
});
var Input_default4 = Input4;

// ../../node_modules/rc-input/es/index.js
var es_default19 = Input_default4;

// ../../node_modules/rc-util/es/proxyObject.js
function proxyObject(obj, extendProps) {
  if (typeof Proxy !== "undefined" && obj) {
    return new Proxy(obj, {
      get: function get3(target, prop) {
        if (extendProps[prop]) {
          return extendProps[prop];
        }
        var originProp = target[prop];
        return typeof originProp === "function" ? originProp.bind(target) : originProp;
      }
    });
  }
  return obj;
}

// ../../node_modules/rc-input-number/es/InputNumber.js
var React310 = __toESM(require_react());

// ../../node_modules/rc-input-number/es/hooks/useCursor.js
var import_react101 = __toESM(require_react());
function useCursor(input, focused) {
  var selectionRef = (0, import_react101.useRef)(null);
  function recordCursor() {
    try {
      var start = input.selectionStart, end = input.selectionEnd, value = input.value;
      var beforeTxt = value.substring(0, start);
      var afterTxt = value.substring(end);
      selectionRef.current = {
        start,
        end,
        value,
        beforeTxt,
        afterTxt
      };
    } catch (e3) {
    }
  }
  function restoreCursor() {
    if (input && selectionRef.current && focused) {
      try {
        var value = input.value;
        var _selectionRef$current = selectionRef.current, beforeTxt = _selectionRef$current.beforeTxt, afterTxt = _selectionRef$current.afterTxt, start = _selectionRef$current.start;
        var startPos = value.length;
        if (value.startsWith(beforeTxt)) {
          startPos = beforeTxt.length;
        } else if (value.endsWith(afterTxt)) {
          startPos = value.length - selectionRef.current.afterTxt.length;
        } else {
          var beforeLastChar = beforeTxt[start - 1];
          var newIndex = value.indexOf(beforeLastChar, start - 1);
          if (newIndex !== -1) {
            startPos = newIndex + 1;
          }
        }
        input.setSelectionRange(startPos, startPos);
      } catch (e3) {
        warning_default(false, "Something warning of cursor restore. Please fire issue about this: ".concat(e3.message));
      }
    }
  }
  return [recordCursor, restoreCursor];
}

// ../../node_modules/rc-input-number/es/StepHandler.js
var React309 = __toESM(require_react());
var import_classnames111 = __toESM(require_classnames());

// ../../node_modules/rc-util/es/hooks/useMobile.js
var import_react102 = __toESM(require_react());
var useMobile = function useMobile2() {
  var _useState = (0, import_react102.useState)(false), _useState2 = _slicedToArray(_useState, 2), mobile = _useState2[0], setMobile = _useState2[1];
  useLayoutEffect_default(function() {
    setMobile(isMobile_default());
  }, []);
  return mobile;
};
var useMobile_default = useMobile;

// ../../node_modules/rc-input-number/es/StepHandler.js
var STEP_INTERVAL = 200;
var STEP_DELAY = 600;
function StepHandler(_ref) {
  var prefixCls = _ref.prefixCls, upNode = _ref.upNode, downNode = _ref.downNode, upDisabled = _ref.upDisabled, downDisabled = _ref.downDisabled, onStep = _ref.onStep;
  var stepTimeoutRef = React309.useRef();
  var frameIds = React309.useRef([]);
  var onStepRef = React309.useRef();
  onStepRef.current = onStep;
  var onStopStep = function onStopStep2() {
    clearTimeout(stepTimeoutRef.current);
  };
  var onStepMouseDown = function onStepMouseDown2(e3, up2) {
    e3.preventDefault();
    onStopStep();
    onStepRef.current(up2);
    function loopStep() {
      onStepRef.current(up2);
      stepTimeoutRef.current = setTimeout(loopStep, STEP_INTERVAL);
    }
    stepTimeoutRef.current = setTimeout(loopStep, STEP_DELAY);
  };
  React309.useEffect(function() {
    return function() {
      onStopStep();
      frameIds.current.forEach(function(id) {
        return raf_default.cancel(id);
      });
    };
  }, []);
  var isMobile = useMobile_default();
  if (isMobile) {
    return null;
  }
  var handlerClassName = "".concat(prefixCls, "-handler");
  var upClassName = (0, import_classnames111.default)(handlerClassName, "".concat(handlerClassName, "-up"), _defineProperty({}, "".concat(handlerClassName, "-up-disabled"), upDisabled));
  var downClassName = (0, import_classnames111.default)(handlerClassName, "".concat(handlerClassName, "-down"), _defineProperty({}, "".concat(handlerClassName, "-down-disabled"), downDisabled));
  var safeOnStopStep = function safeOnStopStep2() {
    return frameIds.current.push(raf_default(onStopStep));
  };
  var sharedHandlerProps = {
    unselectable: "on",
    role: "button",
    onMouseUp: safeOnStopStep,
    onMouseLeave: safeOnStopStep
  };
  return /* @__PURE__ */ React309.createElement("div", {
    className: "".concat(handlerClassName, "-wrap")
  }, /* @__PURE__ */ React309.createElement("span", _extends({}, sharedHandlerProps, {
    onMouseDown: function onMouseDown(e3) {
      onStepMouseDown(e3, true);
    },
    "aria-label": "Increase Value",
    "aria-disabled": upDisabled,
    className: upClassName
  }), upNode || /* @__PURE__ */ React309.createElement("span", {
    unselectable: "on",
    className: "".concat(prefixCls, "-handler-up-inner")
  })), /* @__PURE__ */ React309.createElement("span", _extends({}, sharedHandlerProps, {
    onMouseDown: function onMouseDown(e3) {
      onStepMouseDown(e3, false);
    },
    "aria-label": "Decrease Value",
    "aria-disabled": downDisabled,
    className: downClassName
  }), downNode || /* @__PURE__ */ React309.createElement("span", {
    unselectable: "on",
    className: "".concat(prefixCls, "-handler-down-inner")
  })));
}

// ../../node_modules/rc-input-number/es/utils/numberUtil.js
function getDecupleSteps(step) {
  var stepStr = typeof step === "number" ? num2str(step) : trimNumber(step).fullStr;
  var hasPoint = stepStr.includes(".");
  if (!hasPoint) {
    return step + "0";
  }
  return trimNumber(stepStr.replace(/(\d)\.(\d)/g, "$1$2.")).fullStr;
}

// ../../node_modules/rc-input-number/es/hooks/useFrame.js
var import_react103 = __toESM(require_react());
var useFrame_default = (function() {
  var idRef = (0, import_react103.useRef)(0);
  var cleanUp = function cleanUp2() {
    raf_default.cancel(idRef.current);
  };
  (0, import_react103.useEffect)(function() {
    return cleanUp;
  }, []);
  return function(callback) {
    cleanUp();
    idRef.current = raf_default(function() {
      callback();
    });
  };
});

// ../../node_modules/rc-input-number/es/InputNumber.js
var _excluded51 = ["prefixCls", "className", "style", "min", "max", "step", "defaultValue", "value", "disabled", "readOnly", "upHandler", "downHandler", "keyboard", "changeOnWheel", "controls", "classNames", "stringMode", "parser", "formatter", "precision", "decimalSeparator", "onChange", "onInput", "onPressEnter", "onStep", "changeOnBlur", "domRef"];
var _excluded215 = ["disabled", "style", "prefixCls", "value", "prefix", "suffix", "addonBefore", "addonAfter", "className", "classNames"];
var getDecimalValue = function getDecimalValue2(stringMode, decimalValue) {
  if (stringMode || decimalValue.isEmpty()) {
    return decimalValue.toString();
  }
  return decimalValue.toNumber();
};
var getDecimalIfValidate = function getDecimalIfValidate2(value) {
  var decimal = es_default18(value);
  return decimal.isInvalidate() ? null : decimal;
};
var InternalInputNumber = /* @__PURE__ */ React310.forwardRef(function(props, ref3) {
  var prefixCls = props.prefixCls, className2 = props.className, style2 = props.style, min = props.min, max = props.max, _props$step = props.step, step = _props$step === void 0 ? 1 : _props$step, defaultValue2 = props.defaultValue, value = props.value, disabled = props.disabled, readOnly = props.readOnly, upHandler = props.upHandler, downHandler = props.downHandler, keyboard = props.keyboard, _props$changeOnWheel = props.changeOnWheel, changeOnWheel = _props$changeOnWheel === void 0 ? false : _props$changeOnWheel, _props$controls = props.controls, controls = _props$controls === void 0 ? true : _props$controls, classNames186 = props.classNames, stringMode = props.stringMode, parser = props.parser, formatter = props.formatter, precision = props.precision, decimalSeparator = props.decimalSeparator, onChange = props.onChange, onInput = props.onInput, onPressEnter = props.onPressEnter, onStep = props.onStep, _props$changeOnBlur = props.changeOnBlur, changeOnBlur = _props$changeOnBlur === void 0 ? true : _props$changeOnBlur, domRef = props.domRef, inputProps = _objectWithoutProperties(props, _excluded51);
  var inputClassName = "".concat(prefixCls, "-input");
  var inputRef = React310.useRef(null);
  var _React$useState = React310.useState(false), _React$useState2 = _slicedToArray(_React$useState, 2), focus = _React$useState2[0], setFocus = _React$useState2[1];
  var userTypingRef = React310.useRef(false);
  var compositionRef = React310.useRef(false);
  var shiftKeyRef = React310.useRef(false);
  var _React$useState3 = React310.useState(function() {
    return es_default18(value !== null && value !== void 0 ? value : defaultValue2);
  }), _React$useState4 = _slicedToArray(_React$useState3, 2), decimalValue = _React$useState4[0], setDecimalValue = _React$useState4[1];
  function setUncontrolledDecimalValue(newDecimal) {
    if (value === void 0) {
      setDecimalValue(newDecimal);
    }
  }
  var getPrecision = React310.useCallback(function(numStr, userTyping) {
    if (userTyping) {
      return void 0;
    }
    if (precision >= 0) {
      return precision;
    }
    return Math.max(getNumberPrecision(numStr), getNumberPrecision(step));
  }, [precision, step]);
  var mergedParser = React310.useCallback(function(num) {
    var numStr = String(num);
    if (parser) {
      return parser(numStr);
    }
    var parsedStr = numStr;
    if (decimalSeparator) {
      parsedStr = parsedStr.replace(decimalSeparator, ".");
    }
    return parsedStr.replace(/[^\w.-]+/g, "");
  }, [parser, decimalSeparator]);
  var inputValueRef = React310.useRef("");
  var mergedFormatter = React310.useCallback(function(number4, userTyping) {
    if (formatter) {
      return formatter(number4, {
        userTyping,
        input: String(inputValueRef.current)
      });
    }
    var str = typeof number4 === "number" ? num2str(number4) : number4;
    if (!userTyping) {
      var mergedPrecision = getPrecision(str, userTyping);
      if (validateNumber(str) && (decimalSeparator || mergedPrecision >= 0)) {
        var separatorStr = decimalSeparator || ".";
        str = toFixed(str, separatorStr, mergedPrecision);
      }
    }
    return str;
  }, [formatter, getPrecision, decimalSeparator]);
  var _React$useState5 = React310.useState(function() {
    var initValue = defaultValue2 !== null && defaultValue2 !== void 0 ? defaultValue2 : value;
    if (decimalValue.isInvalidate() && ["string", "number"].includes(_typeof(initValue))) {
      return Number.isNaN(initValue) ? "" : initValue;
    }
    return mergedFormatter(decimalValue.toString(), false);
  }), _React$useState6 = _slicedToArray(_React$useState5, 2), inputValue = _React$useState6[0], setInternalInputValue = _React$useState6[1];
  inputValueRef.current = inputValue;
  function setInputValue(newValue, userTyping) {
    setInternalInputValue(mergedFormatter(
      // Invalidate number is sometime passed by external control, we should let it go
      // Otherwise is controlled by internal interactive logic which check by userTyping
      // You can ref 'show limited value when input is not focused' test for more info.
      newValue.isInvalidate() ? newValue.toString(false) : newValue.toString(!userTyping),
      userTyping
    ));
  }
  var maxDecimal = React310.useMemo(function() {
    return getDecimalIfValidate(max);
  }, [max, precision]);
  var minDecimal = React310.useMemo(function() {
    return getDecimalIfValidate(min);
  }, [min, precision]);
  var upDisabled = React310.useMemo(function() {
    if (!maxDecimal || !decimalValue || decimalValue.isInvalidate()) {
      return false;
    }
    return maxDecimal.lessEquals(decimalValue);
  }, [maxDecimal, decimalValue]);
  var downDisabled = React310.useMemo(function() {
    if (!minDecimal || !decimalValue || decimalValue.isInvalidate()) {
      return false;
    }
    return decimalValue.lessEquals(minDecimal);
  }, [minDecimal, decimalValue]);
  var _useCursor = useCursor(inputRef.current, focus), _useCursor2 = _slicedToArray(_useCursor, 2), recordCursor = _useCursor2[0], restoreCursor = _useCursor2[1];
  var getRangeValue = function getRangeValue2(target) {
    if (maxDecimal && !target.lessEquals(maxDecimal)) {
      return maxDecimal;
    }
    if (minDecimal && !minDecimal.lessEquals(target)) {
      return minDecimal;
    }
    return null;
  };
  var isInRange2 = function isInRange3(target) {
    return !getRangeValue(target);
  };
  var triggerValueUpdate = function triggerValueUpdate2(newValue, userTyping) {
    var updateValue = newValue;
    var isRangeValidate = isInRange2(updateValue) || updateValue.isEmpty();
    if (!updateValue.isEmpty() && !userTyping) {
      updateValue = getRangeValue(updateValue) || updateValue;
      isRangeValidate = true;
    }
    if (!readOnly && !disabled && isRangeValidate) {
      var numStr = updateValue.toString();
      var mergedPrecision = getPrecision(numStr, userTyping);
      if (mergedPrecision >= 0) {
        updateValue = es_default18(toFixed(numStr, ".", mergedPrecision));
        if (!isInRange2(updateValue)) {
          updateValue = es_default18(toFixed(numStr, ".", mergedPrecision, true));
        }
      }
      if (!updateValue.equals(decimalValue)) {
        setUncontrolledDecimalValue(updateValue);
        onChange === null || onChange === void 0 || onChange(updateValue.isEmpty() ? null : getDecimalValue(stringMode, updateValue));
        if (value === void 0) {
          setInputValue(updateValue, userTyping);
        }
      }
      return updateValue;
    }
    return decimalValue;
  };
  var onNextPromise = useFrame_default();
  var collectInputValue = function collectInputValue2(inputStr) {
    recordCursor();
    inputValueRef.current = inputStr;
    setInternalInputValue(inputStr);
    if (!compositionRef.current) {
      var finalValue = mergedParser(inputStr);
      var finalDecimal = es_default18(finalValue);
      if (!finalDecimal.isNaN()) {
        triggerValueUpdate(finalDecimal, true);
      }
    }
    onInput === null || onInput === void 0 || onInput(inputStr);
    onNextPromise(function() {
      var nextInputStr = inputStr;
      if (!parser) {
        nextInputStr = inputStr.replace(/。/g, ".");
      }
      if (nextInputStr !== inputStr) {
        collectInputValue2(nextInputStr);
      }
    });
  };
  var onCompositionStart = function onCompositionStart2() {
    compositionRef.current = true;
  };
  var onCompositionEnd = function onCompositionEnd2() {
    compositionRef.current = false;
    collectInputValue(inputRef.current.value);
  };
  var onInternalInput = function onInternalInput2(e3) {
    collectInputValue(e3.target.value);
  };
  var onInternalStep = function onInternalStep2(up2) {
    var _inputRef$current;
    if (up2 && upDisabled || !up2 && downDisabled) {
      return;
    }
    userTypingRef.current = false;
    var stepDecimal = es_default18(shiftKeyRef.current ? getDecupleSteps(step) : step);
    if (!up2) {
      stepDecimal = stepDecimal.negate();
    }
    var target = (decimalValue || es_default18(0)).add(stepDecimal.toString());
    var updatedValue = triggerValueUpdate(target, false);
    onStep === null || onStep === void 0 || onStep(getDecimalValue(stringMode, updatedValue), {
      offset: shiftKeyRef.current ? getDecupleSteps(step) : step,
      type: up2 ? "up" : "down"
    });
    (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || _inputRef$current.focus();
  };
  var flushInputValue = function flushInputValue2(userTyping) {
    var parsedValue = es_default18(mergedParser(inputValue));
    var formatValue2;
    if (!parsedValue.isNaN()) {
      formatValue2 = triggerValueUpdate(parsedValue, userTyping);
    } else {
      formatValue2 = triggerValueUpdate(decimalValue, userTyping);
    }
    if (value !== void 0) {
      setInputValue(decimalValue, false);
    } else if (!formatValue2.isNaN()) {
      setInputValue(formatValue2, false);
    }
  };
  var onBeforeInput = function onBeforeInput2() {
    userTypingRef.current = true;
  };
  var onKeyDown2 = function onKeyDown3(event) {
    var key2 = event.key, shiftKey = event.shiftKey;
    userTypingRef.current = true;
    shiftKeyRef.current = shiftKey;
    if (key2 === "Enter") {
      if (!compositionRef.current) {
        userTypingRef.current = false;
      }
      flushInputValue(false);
      onPressEnter === null || onPressEnter === void 0 || onPressEnter(event);
    }
    if (keyboard === false) {
      return;
    }
    if (!compositionRef.current && ["Up", "ArrowUp", "Down", "ArrowDown"].includes(key2)) {
      onInternalStep(key2 === "Up" || key2 === "ArrowUp");
      event.preventDefault();
    }
  };
  var onKeyUp = function onKeyUp2() {
    userTypingRef.current = false;
    shiftKeyRef.current = false;
  };
  React310.useEffect(function() {
    if (changeOnWheel && focus) {
      var onWheel = function onWheel2(event) {
        onInternalStep(event.deltaY < 0);
        event.preventDefault();
      };
      var input = inputRef.current;
      if (input) {
        input.addEventListener("wheel", onWheel, {
          passive: false
        });
        return function() {
          return input.removeEventListener("wheel", onWheel);
        };
      }
    }
  });
  var onBlur = function onBlur2() {
    if (changeOnBlur) {
      flushInputValue(false);
    }
    setFocus(false);
    userTypingRef.current = false;
  };
  useLayoutUpdateEffect(function() {
    if (!decimalValue.isInvalidate()) {
      setInputValue(decimalValue, false);
    }
  }, [precision, formatter]);
  useLayoutUpdateEffect(function() {
    var newValue = es_default18(value);
    setDecimalValue(newValue);
    var currentParsedValue = es_default18(mergedParser(inputValue));
    if (!newValue.equals(currentParsedValue) || !userTypingRef.current || formatter) {
      setInputValue(newValue, userTypingRef.current);
    }
  }, [value]);
  useLayoutUpdateEffect(function() {
    if (formatter) {
      restoreCursor();
    }
  }, [inputValue]);
  return /* @__PURE__ */ React310.createElement("div", {
    ref: domRef,
    className: (0, import_classnames112.default)(prefixCls, className2, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "".concat(prefixCls, "-focused"), focus), "".concat(prefixCls, "-disabled"), disabled), "".concat(prefixCls, "-readonly"), readOnly), "".concat(prefixCls, "-not-a-number"), decimalValue.isNaN()), "".concat(prefixCls, "-out-of-range"), !decimalValue.isInvalidate() && !isInRange2(decimalValue))),
    style: style2,
    onFocus: function onFocus() {
      setFocus(true);
    },
    onBlur,
    onKeyDown: onKeyDown2,
    onKeyUp,
    onCompositionStart,
    onCompositionEnd,
    onBeforeInput
  }, controls && /* @__PURE__ */ React310.createElement(StepHandler, {
    prefixCls,
    upNode: upHandler,
    downNode: downHandler,
    upDisabled,
    downDisabled,
    onStep: onInternalStep
  }), /* @__PURE__ */ React310.createElement("div", {
    className: "".concat(inputClassName, "-wrap")
  }, /* @__PURE__ */ React310.createElement("input", _extends({
    autoComplete: "off",
    role: "spinbutton",
    "aria-valuemin": min,
    "aria-valuemax": max,
    "aria-valuenow": decimalValue.isInvalidate() ? null : decimalValue.toString(),
    step
  }, inputProps, {
    ref: composeRef(inputRef, ref3),
    className: inputClassName,
    value: inputValue,
    onChange: onInternalInput,
    disabled,
    readOnly
  }))));
});
var InputNumber = /* @__PURE__ */ React310.forwardRef(function(props, ref3) {
  var disabled = props.disabled, style2 = props.style, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-input-number" : _props$prefixCls, value = props.value, prefix3 = props.prefix, suffix = props.suffix, addonBefore = props.addonBefore, addonAfter = props.addonAfter, className2 = props.className, classNames186 = props.classNames, rest = _objectWithoutProperties(props, _excluded215);
  var holderRef = React310.useRef(null);
  var inputNumberDomRef = React310.useRef(null);
  var inputFocusRef = React310.useRef(null);
  var focus = function focus2(option) {
    if (inputFocusRef.current) {
      triggerFocus(inputFocusRef.current, option);
    }
  };
  React310.useImperativeHandle(ref3, function() {
    return proxyObject(inputFocusRef.current, {
      focus,
      nativeElement: holderRef.current.nativeElement || inputNumberDomRef.current
    });
  });
  return /* @__PURE__ */ React310.createElement(BaseInput_default, {
    className: className2,
    triggerFocus: focus,
    prefixCls,
    value,
    disabled,
    style: style2,
    prefix: prefix3,
    suffix,
    addonAfter,
    addonBefore,
    classNames: classNames186,
    components: {
      affixWrapper: "div",
      groupWrapper: "div",
      wrapper: "div",
      groupAddon: "div"
    },
    ref: holderRef
  }, /* @__PURE__ */ React310.createElement(InternalInputNumber, _extends({
    prefixCls,
    disabled,
    ref: inputFocusRef,
    domRef: inputNumberDomRef,
    className: classNames186 === null || classNames186 === void 0 ? void 0 : classNames186.input
  }, rest)));
});
if (true) {
  InputNumber.displayName = "InputNumber";
}
var InputNumber_default = InputNumber;

// ../../node_modules/rc-input-number/es/index.js
var es_default20 = InputNumber_default;

// ../../node_modules/antd/es/input-number/style/token.js
var prepareComponentToken17 = (token2) => {
  var _a;
  const handleVisible = (_a = token2.handleVisible) !== null && _a !== void 0 ? _a : "auto";
  const handleWidth = token2.controlHeightSM - token2.lineWidth * 2;
  return Object.assign(Object.assign({}, initComponentToken(token2)), {
    controlWidth: 90,
    handleWidth,
    handleFontSize: token2.fontSize / 2,
    handleVisible,
    handleActiveBg: token2.colorFillAlter,
    handleBg: token2.colorBgContainer,
    filledHandleBg: new FastColor(token2.colorFillSecondary).onBackground(token2.colorBgContainer).toHexString(),
    handleHoverColor: token2.colorPrimary,
    handleBorderColor: token2.colorBorder,
    handleOpacity: handleVisible === true ? 1 : 0,
    handleVisibleWidth: handleVisible === true ? handleWidth : 0
  });
};

// ../../node_modules/antd/es/input-number/style/index.js
var genRadiusStyle = ({
  componentCls,
  borderRadiusSM,
  borderRadiusLG
}, size) => {
  const borderRadius = size === "lg" ? borderRadiusLG : borderRadiusSM;
  return {
    [`&-${size}`]: {
      [`${componentCls}-handler-wrap`]: {
        borderStartEndRadius: borderRadius,
        borderEndEndRadius: borderRadius
      },
      [`${componentCls}-handler-up`]: {
        borderStartEndRadius: borderRadius
      },
      [`${componentCls}-handler-down`]: {
        borderEndEndRadius: borderRadius
      }
    }
  };
};
var genInputNumberStyles = (token2) => {
  const {
    componentCls,
    lineWidth,
    lineType,
    borderRadius,
    inputFontSizeSM,
    inputFontSizeLG,
    controlHeightLG,
    controlHeightSM,
    colorError,
    paddingInlineSM,
    paddingBlockSM,
    paddingBlockLG,
    paddingInlineLG,
    colorIcon,
    motionDurationMid,
    handleHoverColor,
    handleOpacity,
    paddingInline,
    paddingBlock,
    handleBg,
    handleActiveBg,
    colorTextDisabled,
    borderRadiusSM,
    borderRadiusLG,
    controlWidth,
    handleBorderColor,
    filledHandleBg,
    lineHeightLG,
    calc
  } = token2;
  return [
    {
      [componentCls]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, resetComponent(token2)), genBasicInputStyle(token2)), {
        display: "inline-block",
        width: controlWidth,
        margin: 0,
        padding: 0,
        borderRadius
      }), genOutlinedStyle2(token2, {
        [`${componentCls}-handler-wrap`]: {
          background: handleBg,
          [`${componentCls}-handler-down`]: {
            borderBlockStart: `${unit(lineWidth)} ${lineType} ${handleBorderColor}`
          }
        }
      })), genFilledStyle2(token2, {
        [`${componentCls}-handler-wrap`]: {
          background: filledHandleBg,
          [`${componentCls}-handler-down`]: {
            borderBlockStart: `${unit(lineWidth)} ${lineType} ${handleBorderColor}`
          }
        },
        "&:focus-within": {
          [`${componentCls}-handler-wrap`]: {
            background: handleBg
          }
        }
      })), genUnderlinedStyle2(token2, {
        [`${componentCls}-handler-wrap`]: {
          background: handleBg,
          [`${componentCls}-handler-down`]: {
            borderBlockStart: `${unit(lineWidth)} ${lineType} ${handleBorderColor}`
          }
        }
      })), genBorderlessStyle3(token2)), {
        "&-rtl": {
          direction: "rtl",
          [`${componentCls}-input`]: {
            direction: "rtl"
          }
        },
        "&-lg": {
          padding: 0,
          fontSize: inputFontSizeLG,
          lineHeight: lineHeightLG,
          borderRadius: borderRadiusLG,
          [`input${componentCls}-input`]: {
            height: calc(controlHeightLG).sub(calc(lineWidth).mul(2)).equal(),
            padding: `${unit(paddingBlockLG)} ${unit(paddingInlineLG)}`
          }
        },
        "&-sm": {
          padding: 0,
          fontSize: inputFontSizeSM,
          borderRadius: borderRadiusSM,
          [`input${componentCls}-input`]: {
            height: calc(controlHeightSM).sub(calc(lineWidth).mul(2)).equal(),
            padding: `${unit(paddingBlockSM)} ${unit(paddingInlineSM)}`
          }
        },
        // ===================== Out Of Range =====================
        "&-out-of-range": {
          [`${componentCls}-input-wrap`]: {
            input: {
              color: colorError
            }
          }
        },
        // Style for input-group: input with label, with button or dropdown...
        "&-group": Object.assign(Object.assign(Object.assign({}, resetComponent(token2)), genInputGroupStyle(token2)), {
          "&-wrapper": Object.assign(Object.assign(Object.assign({
            display: "inline-block",
            textAlign: "start",
            verticalAlign: "top",
            [`${componentCls}-affix-wrapper`]: {
              width: "100%"
            },
            // Size
            "&-lg": {
              [`${componentCls}-group-addon`]: {
                borderRadius: borderRadiusLG,
                fontSize: token2.fontSizeLG
              }
            },
            "&-sm": {
              [`${componentCls}-group-addon`]: {
                borderRadius: borderRadiusSM
              }
            }
          }, genOutlinedGroupStyle(token2)), genFilledGroupStyle(token2)), {
            // Fix the issue of using icons in Space Compact mode
            // https://github.com/ant-design/ant-design/issues/45764
            [`&:not(${componentCls}-compact-first-item):not(${componentCls}-compact-last-item)${componentCls}-compact-item`]: {
              [`${componentCls}, ${componentCls}-group-addon`]: {
                borderRadius: 0
              }
            },
            [`&:not(${componentCls}-compact-last-item)${componentCls}-compact-first-item`]: {
              [`${componentCls}, ${componentCls}-group-addon`]: {
                borderStartEndRadius: 0,
                borderEndEndRadius: 0
              }
            },
            [`&:not(${componentCls}-compact-first-item)${componentCls}-compact-last-item`]: {
              [`${componentCls}, ${componentCls}-group-addon`]: {
                borderStartStartRadius: 0,
                borderEndStartRadius: 0
              }
            }
          })
        }),
        [`&-disabled ${componentCls}-input`]: {
          cursor: "not-allowed"
        },
        [componentCls]: {
          "&-input": Object.assign(Object.assign(Object.assign(Object.assign({}, resetComponent(token2)), {
            width: "100%",
            padding: `${unit(paddingBlock)} ${unit(paddingInline)}`,
            textAlign: "start",
            backgroundColor: "transparent",
            border: 0,
            borderRadius,
            outline: 0,
            transition: `all ${motionDurationMid} linear`,
            appearance: "textfield",
            fontSize: "inherit"
          }), genPlaceholderStyle(token2.colorTextPlaceholder)), {
            '&[type="number"]::-webkit-inner-spin-button, &[type="number"]::-webkit-outer-spin-button': {
              margin: 0,
              appearance: "none"
            }
          })
        },
        [`&:hover ${componentCls}-handler-wrap, &-focused ${componentCls}-handler-wrap`]: {
          width: token2.handleWidth,
          opacity: 1
        }
      })
    },
    // Handler
    {
      [componentCls]: Object.assign(Object.assign(Object.assign({
        [`${componentCls}-handler-wrap`]: {
          position: "absolute",
          insetBlockStart: 0,
          insetInlineEnd: 0,
          width: token2.handleVisibleWidth,
          opacity: handleOpacity,
          height: "100%",
          borderStartStartRadius: 0,
          borderStartEndRadius: borderRadius,
          borderEndEndRadius: borderRadius,
          borderEndStartRadius: 0,
          display: "flex",
          flexDirection: "column",
          alignItems: "stretch",
          transition: `all ${motionDurationMid}`,
          overflow: "hidden",
          // Fix input number inside Menu makes icon too large
          // We arise the selector priority by nest selector here
          // https://github.com/ant-design/ant-design/issues/14367
          [`${componentCls}-handler`]: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flex: "auto",
            height: "40%",
            [`
              ${componentCls}-handler-up-inner,
              ${componentCls}-handler-down-inner
            `]: {
              marginInlineEnd: 0,
              fontSize: token2.handleFontSize
            }
          }
        },
        [`${componentCls}-handler`]: {
          height: "50%",
          overflow: "hidden",
          color: colorIcon,
          fontWeight: "bold",
          lineHeight: 0,
          textAlign: "center",
          cursor: "pointer",
          borderInlineStart: `${unit(lineWidth)} ${lineType} ${handleBorderColor}`,
          transition: `all ${motionDurationMid} linear`,
          "&:active": {
            background: handleActiveBg
          },
          // Hover
          "&:hover": {
            height: `60%`,
            [`
              ${componentCls}-handler-up-inner,
              ${componentCls}-handler-down-inner
            `]: {
              color: handleHoverColor
            }
          },
          "&-up-inner, &-down-inner": Object.assign(Object.assign({}, resetIcon()), {
            color: colorIcon,
            transition: `all ${motionDurationMid} linear`,
            userSelect: "none"
          })
        },
        [`${componentCls}-handler-up`]: {
          borderStartEndRadius: borderRadius
        },
        [`${componentCls}-handler-down`]: {
          borderEndEndRadius: borderRadius
        }
      }, genRadiusStyle(token2, "lg")), genRadiusStyle(token2, "sm")), {
        // Disabled
        "&-disabled, &-readonly": {
          [`${componentCls}-handler-wrap`]: {
            display: "none"
          },
          [`${componentCls}-input`]: {
            color: "inherit"
          }
        },
        [`
          ${componentCls}-handler-up-disabled,
          ${componentCls}-handler-down-disabled
        `]: {
          cursor: "not-allowed"
        },
        [`
          ${componentCls}-handler-up-disabled:hover &-handler-up-inner,
          ${componentCls}-handler-down-disabled:hover &-handler-down-inner
        `]: {
          color: colorTextDisabled
        }
      })
    }
  ];
};
var genAffixWrapperStyles = (token2) => {
  const {
    componentCls,
    paddingBlock,
    paddingInline,
    inputAffixPadding,
    controlWidth,
    borderRadiusLG,
    borderRadiusSM,
    paddingInlineLG,
    paddingInlineSM,
    paddingBlockLG,
    paddingBlockSM,
    motionDurationMid
  } = token2;
  return {
    [`${componentCls}-affix-wrapper`]: Object.assign(Object.assign({
      [`input${componentCls}-input`]: {
        padding: `${unit(paddingBlock)} 0`
      }
    }, genBasicInputStyle(token2)), {
      // or number handler will cover form status
      position: "relative",
      display: "inline-flex",
      alignItems: "center",
      width: controlWidth,
      padding: 0,
      paddingInlineStart: paddingInline,
      "&-lg": {
        borderRadius: borderRadiusLG,
        paddingInlineStart: paddingInlineLG,
        [`input${componentCls}-input`]: {
          padding: `${unit(paddingBlockLG)} 0`
        }
      },
      "&-sm": {
        borderRadius: borderRadiusSM,
        paddingInlineStart: paddingInlineSM,
        [`input${componentCls}-input`]: {
          padding: `${unit(paddingBlockSM)} 0`
        }
      },
      [`&:not(${componentCls}-disabled):hover`]: {
        zIndex: 1
      },
      "&-focused, &:focus": {
        zIndex: 1
      },
      [`&-disabled > ${componentCls}-disabled`]: {
        background: "transparent"
      },
      [`> div${componentCls}`]: {
        width: "100%",
        border: "none",
        outline: "none",
        [`&${componentCls}-focused`]: {
          boxShadow: "none !important"
        }
      },
      "&::before": {
        display: "inline-block",
        width: 0,
        visibility: "hidden",
        content: '"\\a0"'
      },
      [`${componentCls}-handler-wrap`]: {
        zIndex: 2
      },
      [componentCls]: {
        position: "static",
        color: "inherit",
        "&-prefix, &-suffix": {
          display: "flex",
          flex: "none",
          alignItems: "center",
          pointerEvents: "none"
        },
        "&-prefix": {
          marginInlineEnd: inputAffixPadding
        },
        "&-suffix": {
          insetBlockStart: 0,
          insetInlineEnd: 0,
          height: "100%",
          marginInlineEnd: paddingInline,
          marginInlineStart: inputAffixPadding,
          transition: `margin ${motionDurationMid}`
        }
      },
      [`&:hover ${componentCls}-handler-wrap, &-focused ${componentCls}-handler-wrap`]: {
        width: token2.handleWidth,
        opacity: 1
      },
      [`&:not(${componentCls}-affix-wrapper-without-controls):hover ${componentCls}-suffix`]: {
        marginInlineEnd: token2.calc(token2.handleWidth).add(paddingInline).equal()
      }
    }),
    // 覆盖 affix-wrapper borderRadius！
    [`${componentCls}-underlined`]: {
      borderRadius: 0
    }
  };
};
var style_default22 = genStyleHooks("InputNumber", (token2) => {
  const inputNumberToken = merge2(token2, initInputToken(token2));
  return [
    genInputNumberStyles(inputNumberToken),
    genAffixWrapperStyles(inputNumberToken),
    // =====================================================
    // ==             Space Compact                       ==
    // =====================================================
    genCompactItemStyle(inputNumberToken)
  ];
}, prepareComponentToken17, {
  unitless: {
    handleOpacity: true
  },
  resetFont: false
});

// ../../node_modules/antd/es/input-number/index.js
var __rest32 = function(s, e3) {
  var t2 = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e3.indexOf(p) < 0) t2[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e3.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t2[p[i]] = s[p[i]];
  }
  return t2;
};
var InputNumber2 = /* @__PURE__ */ React311.forwardRef((props, ref3) => {
  if (true) {
    const typeWarning = devUseWarning("InputNumber");
    typeWarning.deprecated(!("bordered" in props), "bordered", "variant");
    typeWarning(!(props.type === "number" && props.changeOnWheel), "usage", "When `type=number` is used together with `changeOnWheel`, changeOnWheel may not work properly. Please delete `type=number` if it is not necessary.");
  }
  const {
    getPrefixCls,
    direction
  } = React311.useContext(ConfigContext);
  const inputRef = React311.useRef(null);
  React311.useImperativeHandle(ref3, () => inputRef.current);
  const {
    className: className2,
    rootClassName,
    size: customizeSize,
    disabled: customDisabled,
    prefixCls: customizePrefixCls,
    addonBefore,
    addonAfter,
    prefix: prefix3,
    suffix,
    bordered,
    readOnly,
    status: customStatus,
    controls,
    variant: customVariant
  } = props, others = __rest32(props, ["className", "rootClassName", "size", "disabled", "prefixCls", "addonBefore", "addonAfter", "prefix", "suffix", "bordered", "readOnly", "status", "controls", "variant"]);
  const prefixCls = getPrefixCls("input-number", customizePrefixCls);
  const rootCls = useCSSVarCls_default(prefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = style_default22(prefixCls, rootCls);
  const {
    compactSize,
    compactItemClassnames
  } = useCompactItemContext(prefixCls, direction);
  let upIcon = /* @__PURE__ */ React311.createElement(UpOutlined_default2, {
    className: `${prefixCls}-handler-up-inner`
  });
  let downIcon = /* @__PURE__ */ React311.createElement(DownOutlined_default2, {
    className: `${prefixCls}-handler-down-inner`
  });
  const controlsTemp = typeof controls === "boolean" ? controls : void 0;
  if (typeof controls === "object") {
    upIcon = typeof controls.upIcon === "undefined" ? upIcon : /* @__PURE__ */ React311.createElement("span", {
      className: `${prefixCls}-handler-up-inner`
    }, controls.upIcon);
    downIcon = typeof controls.downIcon === "undefined" ? downIcon : /* @__PURE__ */ React311.createElement("span", {
      className: `${prefixCls}-handler-down-inner`
    }, controls.downIcon);
  }
  const {
    hasFeedback,
    status: contextStatus,
    isFormItemInput,
    feedbackIcon
  } = React311.useContext(FormItemInputContext);
  const mergedStatus = getMergedStatus(contextStatus, customStatus);
  const mergedSize = useSize_default((ctx) => {
    var _a;
    return (_a = customizeSize !== null && customizeSize !== void 0 ? customizeSize : compactSize) !== null && _a !== void 0 ? _a : ctx;
  });
  const disabled = React311.useContext(DisabledContext_default);
  const mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
  const [variant, enableVariantCls] = useVariants_default("inputNumber", customVariant, bordered);
  const suffixNode = hasFeedback && /* @__PURE__ */ React311.createElement(React311.Fragment, null, feedbackIcon);
  const inputNumberClass = (0, import_classnames113.default)({
    [`${prefixCls}-lg`]: mergedSize === "large",
    [`${prefixCls}-sm`]: mergedSize === "small",
    [`${prefixCls}-rtl`]: direction === "rtl",
    [`${prefixCls}-in-form-item`]: isFormItemInput
  }, hashId);
  const wrapperClassName = `${prefixCls}-group`;
  const element = /* @__PURE__ */ React311.createElement(es_default20, Object.assign({
    ref: inputRef,
    disabled: mergedDisabled,
    className: (0, import_classnames113.default)(cssVarCls, rootCls, className2, rootClassName, compactItemClassnames),
    upHandler: upIcon,
    downHandler: downIcon,
    prefixCls,
    readOnly,
    controls: controlsTemp,
    prefix: prefix3,
    suffix: suffixNode || suffix,
    addonBefore: addonBefore && /* @__PURE__ */ React311.createElement(ContextIsolator_default, {
      form: true,
      space: true
    }, addonBefore),
    addonAfter: addonAfter && /* @__PURE__ */ React311.createElement(ContextIsolator_default, {
      form: true,
      space: true
    }, addonAfter),
    classNames: {
      input: inputNumberClass,
      variant: (0, import_classnames113.default)({
        [`${prefixCls}-${variant}`]: enableVariantCls
      }, getStatusClassNames(prefixCls, mergedStatus, hasFeedback)),
      affixWrapper: (0, import_classnames113.default)({
        [`${prefixCls}-affix-wrapper-sm`]: mergedSize === "small",
        [`${prefixCls}-affix-wrapper-lg`]: mergedSize === "large",
        [`${prefixCls}-affix-wrapper-rtl`]: direction === "rtl",
        [`${prefixCls}-affix-wrapper-without-controls`]: controls === false || mergedDisabled || readOnly
      }, hashId),
      wrapper: (0, import_classnames113.default)({
        [`${wrapperClassName}-rtl`]: direction === "rtl"
      }, hashId),
      groupWrapper: (0, import_classnames113.default)({
        [`${prefixCls}-group-wrapper-sm`]: mergedSize === "small",
        [`${prefixCls}-group-wrapper-lg`]: mergedSize === "large",
        [`${prefixCls}-group-wrapper-rtl`]: direction === "rtl",
        [`${prefixCls}-group-wrapper-${variant}`]: enableVariantCls
      }, getStatusClassNames(`${prefixCls}-group-wrapper`, mergedStatus, hasFeedback), hashId)
    }
  }, others));
  return wrapCSSVar(element);
});
var TypedInputNumber = InputNumber2;
var PureInputNumber = (props) => /* @__PURE__ */ React311.createElement(config_provider_default, {
  theme: {
    components: {
      InputNumber: {
        handleVisible: true
      }
    }
  }
}, /* @__PURE__ */ React311.createElement(InputNumber2, Object.assign({}, props)));
if (true) {
  TypedInputNumber.displayName = "InputNumber";
}
TypedInputNumber._InternalPanelDoNotUseOrYouWillBeFired = PureInputNumber;
var input_number_default = TypedInputNumber;

// ../../node_modules/antd/es/input/Input.js
var import_react106 = __toESM(require_react());
var import_classnames114 = __toESM(require_classnames());

// ../../node_modules/antd/es/_util/getAllowClear.js
var import_react104 = __toESM(require_react());
var getAllowClear = (allowClear) => {
  let mergedAllowClear;
  if (typeof allowClear === "object" && (allowClear === null || allowClear === void 0 ? void 0 : allowClear.clearIcon)) {
    mergedAllowClear = allowClear;
  } else if (allowClear) {
    mergedAllowClear = {
      clearIcon: /* @__PURE__ */ import_react104.default.createElement(CloseCircleFilled_default2, null)
    };
  }
  return mergedAllowClear;
};
var getAllowClear_default = getAllowClear;

// ../../node_modules/antd/es/input/hooks/useRemovePasswordTimeout.js
var import_react105 = __toESM(require_react());
function useRemovePasswordTimeout(inputRef, triggerOnMount) {
  const removePasswordTimeoutRef = (0, import_react105.useRef)([]);
  const removePasswordTimeout = () => {
    removePasswordTimeoutRef.current.push(setTimeout(() => {
      var _a, _b, _c, _d;
      if (((_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.input) && ((_b = inputRef.current) === null || _b === void 0 ? void 0 : _b.input.getAttribute("type")) === "password" && ((_c = inputRef.current) === null || _c === void 0 ? void 0 : _c.input.hasAttribute("value"))) {
        (_d = inputRef.current) === null || _d === void 0 ? void 0 : _d.input.removeAttribute("value");
      }
    }));
  };
  (0, import_react105.useEffect)(() => {
    if (triggerOnMount) {
      removePasswordTimeout();
    }
    return () => removePasswordTimeoutRef.current.forEach((timer) => {
      if (timer) {
        clearTimeout(timer);
      }
    });
  }, []);
  return removePasswordTimeout;
}

// ../../node_modules/antd/es/input/utils.js
function hasPrefixSuffix2(props) {
  return !!(props.prefix || props.suffix || props.allowClear || props.showCount);
}

// ../../node_modules/antd/es/input/Input.js
var __rest33 = function(s, e3) {
  var t2 = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e3.indexOf(p) < 0) t2[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e3.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t2[p[i]] = s[p[i]];
  }
  return t2;
};
var Input5 = /* @__PURE__ */ (0, import_react106.forwardRef)((props, ref3) => {
  const {
    prefixCls: customizePrefixCls,
    bordered = true,
    status: customStatus,
    size: customSize,
    disabled: customDisabled,
    onBlur,
    onFocus,
    suffix,
    allowClear,
    addonAfter,
    addonBefore,
    className: className2,
    style: style2,
    styles,
    rootClassName,
    onChange,
    classNames: classNames186,
    variant: customVariant
  } = props, rest = __rest33(props, ["prefixCls", "bordered", "status", "size", "disabled", "onBlur", "onFocus", "suffix", "allowClear", "addonAfter", "addonBefore", "className", "style", "styles", "rootClassName", "onChange", "classNames", "variant"]);
  if (true) {
    const {
      deprecated
    } = devUseWarning("Input");
    deprecated(!("bordered" in props), "bordered", "variant");
  }
  const {
    getPrefixCls,
    direction,
    allowClear: contextAllowClear,
    autoComplete: contextAutoComplete,
    className: contextClassName,
    style: contextStyle,
    classNames: contextClassNames,
    styles: contextStyles
  } = useComponentConfig("input");
  const prefixCls = getPrefixCls("input", customizePrefixCls);
  const inputRef = (0, import_react106.useRef)(null);
  const rootCls = useCSSVarCls_default(prefixCls);
  const [wrapSharedCSSVar, hashId, cssVarCls] = useSharedStyle(prefixCls, rootClassName);
  const [wrapCSSVar] = style_default16(prefixCls, rootCls);
  const {
    compactSize,
    compactItemClassnames
  } = useCompactItemContext(prefixCls, direction);
  const mergedSize = useSize_default((ctx) => {
    var _a;
    return (_a = customSize !== null && customSize !== void 0 ? customSize : compactSize) !== null && _a !== void 0 ? _a : ctx;
  });
  const disabled = import_react106.default.useContext(DisabledContext_default);
  const mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
  const {
    status: contextStatus,
    hasFeedback,
    feedbackIcon
  } = (0, import_react106.useContext)(FormItemInputContext);
  const mergedStatus = getMergedStatus(contextStatus, customStatus);
  const inputHasPrefixSuffix = hasPrefixSuffix2(props) || !!hasFeedback;
  const prevHasPrefixSuffix = (0, import_react106.useRef)(inputHasPrefixSuffix);
  if (true) {
    const warning6 = devUseWarning("Input");
    (0, import_react106.useEffect)(() => {
      var _a;
      if (inputHasPrefixSuffix && !prevHasPrefixSuffix.current) {
        true ? warning6(document.activeElement === ((_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.input), "usage", `When Input is focused, dynamic add or remove prefix / suffix will make it lose focus caused by dom structure change. Read more: https://ant.design/components/input/#FAQ`) : void 0;
      }
      prevHasPrefixSuffix.current = inputHasPrefixSuffix;
    }, [inputHasPrefixSuffix]);
  }
  const removePasswordTimeout = useRemovePasswordTimeout(inputRef, true);
  const handleBlur = (e3) => {
    removePasswordTimeout();
    onBlur === null || onBlur === void 0 ? void 0 : onBlur(e3);
  };
  const handleFocus = (e3) => {
    removePasswordTimeout();
    onFocus === null || onFocus === void 0 ? void 0 : onFocus(e3);
  };
  const handleChange = (e3) => {
    removePasswordTimeout();
    onChange === null || onChange === void 0 ? void 0 : onChange(e3);
  };
  const suffixNode = (hasFeedback || suffix) && /* @__PURE__ */ import_react106.default.createElement(import_react106.default.Fragment, null, suffix, hasFeedback && feedbackIcon);
  const mergedAllowClear = getAllowClear_default(allowClear !== null && allowClear !== void 0 ? allowClear : contextAllowClear);
  const [variant, enableVariantCls] = useVariants_default("input", customVariant, bordered);
  return wrapSharedCSSVar(wrapCSSVar(/* @__PURE__ */ import_react106.default.createElement(es_default19, Object.assign({
    ref: composeRef(ref3, inputRef),
    prefixCls,
    autoComplete: contextAutoComplete
  }, rest, {
    disabled: mergedDisabled,
    onBlur: handleBlur,
    onFocus: handleFocus,
    style: Object.assign(Object.assign({}, contextStyle), style2),
    styles: Object.assign(Object.assign({}, contextStyles), styles),
    suffix: suffixNode,
    allowClear: mergedAllowClear,
    className: (0, import_classnames114.default)(className2, rootClassName, cssVarCls, rootCls, compactItemClassnames, contextClassName),
    onChange: handleChange,
    addonBefore: addonBefore && /* @__PURE__ */ import_react106.default.createElement(ContextIsolator_default, {
      form: true,
      space: true
    }, addonBefore),
    addonAfter: addonAfter && /* @__PURE__ */ import_react106.default.createElement(ContextIsolator_default, {
      form: true,
      space: true
    }, addonAfter),
    classNames: Object.assign(Object.assign(Object.assign({}, classNames186), contextClassNames), {
      input: (0, import_classnames114.default)({
        [`${prefixCls}-sm`]: mergedSize === "small",
        [`${prefixCls}-lg`]: mergedSize === "large",
        [`${prefixCls}-rtl`]: direction === "rtl"
      }, classNames186 === null || classNames186 === void 0 ? void 0 : classNames186.input, contextClassNames.input, hashId),
      variant: (0, import_classnames114.default)({
        [`${prefixCls}-${variant}`]: enableVariantCls
      }, getStatusClassNames(prefixCls, mergedStatus)),
      affixWrapper: (0, import_classnames114.default)({
        [`${prefixCls}-affix-wrapper-sm`]: mergedSize === "small",
        [`${prefixCls}-affix-wrapper-lg`]: mergedSize === "large",
        [`${prefixCls}-affix-wrapper-rtl`]: direction === "rtl"
      }, hashId),
      wrapper: (0, import_classnames114.default)({
        [`${prefixCls}-group-rtl`]: direction === "rtl"
      }, hashId),
      groupWrapper: (0, import_classnames114.default)({
        [`${prefixCls}-group-wrapper-sm`]: mergedSize === "small",
        [`${prefixCls}-group-wrapper-lg`]: mergedSize === "large",
        [`${prefixCls}-group-wrapper-rtl`]: direction === "rtl",
        [`${prefixCls}-group-wrapper-${variant}`]: enableVariantCls
      }, getStatusClassNames(`${prefixCls}-group-wrapper`, mergedStatus, hasFeedback), hashId)
    })
  }))));
});
if (true) {
  Input5.displayName = "Input";
}
var Input_default5 = Input5;

// ../../node_modules/rc-slider/es/Slider.js
var import_classnames120 = __toESM(require_classnames());
var React325 = __toESM(require_react());

// ../../node_modules/rc-slider/es/Handles/index.js
var React316 = __toESM(require_react());
var import_react_dom9 = __toESM(require_react_dom());

// ../../node_modules/rc-slider/es/util.js
function getOffset2(value, min, max) {
  return (value - min) / (max - min);
}
function getDirectionStyle(direction, value, min, max) {
  var offset4 = getOffset2(value, min, max);
  var positionStyle = {};
  switch (direction) {
    case "rtl":
      positionStyle.right = "".concat(offset4 * 100, "%");
      positionStyle.transform = "translateX(50%)";
      break;
    case "btt":
      positionStyle.bottom = "".concat(offset4 * 100, "%");
      positionStyle.transform = "translateY(50%)";
      break;
    case "ttb":
      positionStyle.top = "".concat(offset4 * 100, "%");
      positionStyle.transform = "translateY(-50%)";
      break;
    default:
      positionStyle.left = "".concat(offset4 * 100, "%");
      positionStyle.transform = "translateX(-50%)";
      break;
  }
  return positionStyle;
}
function getIndex(value, index3) {
  return Array.isArray(value) ? value[index3] : value;
}

// ../../node_modules/rc-slider/es/Handles/Handle.js
var import_classnames115 = __toESM(require_classnames());
var React315 = __toESM(require_react());

// ../../node_modules/rc-slider/es/context.js
var React314 = __toESM(require_react());
var SliderContext = /* @__PURE__ */ React314.createContext({
  min: 0,
  max: 0,
  direction: "ltr",
  step: 1,
  includedStart: 0,
  includedEnd: 0,
  tabIndex: 0,
  keyboard: true,
  styles: {},
  classNames: {}
});
var context_default5 = SliderContext;
var UnstableContext = /* @__PURE__ */ React314.createContext({});

// ../../node_modules/rc-slider/es/Handles/Handle.js
var _excluded52 = ["prefixCls", "value", "valueIndex", "onStartMove", "onDelete", "style", "render", "dragging", "draggingDelete", "onOffsetChange", "onChangeComplete", "onFocus", "onMouseEnter"];
var Handle = /* @__PURE__ */ React315.forwardRef(function(props, ref3) {
  var prefixCls = props.prefixCls, value = props.value, valueIndex = props.valueIndex, onStartMove = props.onStartMove, onDelete = props.onDelete, style2 = props.style, render4 = props.render, dragging = props.dragging, draggingDelete = props.draggingDelete, onOffsetChange = props.onOffsetChange, onChangeComplete = props.onChangeComplete, onFocus = props.onFocus, onMouseEnter = props.onMouseEnter, restProps = _objectWithoutProperties(props, _excluded52);
  var _React$useContext = React315.useContext(context_default5), min = _React$useContext.min, max = _React$useContext.max, direction = _React$useContext.direction, disabled = _React$useContext.disabled, keyboard = _React$useContext.keyboard, range3 = _React$useContext.range, tabIndex = _React$useContext.tabIndex, ariaLabelForHandle = _React$useContext.ariaLabelForHandle, ariaLabelledByForHandle = _React$useContext.ariaLabelledByForHandle, ariaRequired = _React$useContext.ariaRequired, ariaValueTextFormatterForHandle = _React$useContext.ariaValueTextFormatterForHandle, styles = _React$useContext.styles, classNames186 = _React$useContext.classNames;
  var handlePrefixCls = "".concat(prefixCls, "-handle");
  var onInternalStartMove = function onInternalStartMove2(e3) {
    if (!disabled) {
      onStartMove(e3, valueIndex);
    }
  };
  var onInternalFocus = function onInternalFocus2(e3) {
    onFocus === null || onFocus === void 0 || onFocus(e3, valueIndex);
  };
  var onInternalMouseEnter = function onInternalMouseEnter2(e3) {
    onMouseEnter(e3, valueIndex);
  };
  var onKeyDown2 = function onKeyDown3(e3) {
    if (!disabled && keyboard) {
      var offset4 = null;
      switch (e3.which || e3.keyCode) {
        case KeyCode_default.LEFT:
          offset4 = direction === "ltr" || direction === "btt" ? -1 : 1;
          break;
        case KeyCode_default.RIGHT:
          offset4 = direction === "ltr" || direction === "btt" ? 1 : -1;
          break;
        // Up is plus
        case KeyCode_default.UP:
          offset4 = direction !== "ttb" ? 1 : -1;
          break;
        // Down is minus
        case KeyCode_default.DOWN:
          offset4 = direction !== "ttb" ? -1 : 1;
          break;
        case KeyCode_default.HOME:
          offset4 = "min";
          break;
        case KeyCode_default.END:
          offset4 = "max";
          break;
        case KeyCode_default.PAGE_UP:
          offset4 = 2;
          break;
        case KeyCode_default.PAGE_DOWN:
          offset4 = -2;
          break;
        case KeyCode_default.BACKSPACE:
        case KeyCode_default.DELETE:
          onDelete(valueIndex);
          break;
      }
      if (offset4 !== null) {
        e3.preventDefault();
        onOffsetChange(offset4, valueIndex);
      }
    }
  };
  var handleKeyUp = function handleKeyUp2(e3) {
    switch (e3.which || e3.keyCode) {
      case KeyCode_default.LEFT:
      case KeyCode_default.RIGHT:
      case KeyCode_default.UP:
      case KeyCode_default.DOWN:
      case KeyCode_default.HOME:
      case KeyCode_default.END:
      case KeyCode_default.PAGE_UP:
      case KeyCode_default.PAGE_DOWN:
        onChangeComplete === null || onChangeComplete === void 0 || onChangeComplete();
        break;
    }
  };
  var positionStyle = getDirectionStyle(direction, value, min, max);
  var divProps = {};
  if (valueIndex !== null) {
    var _getIndex;
    divProps = {
      tabIndex: disabled ? null : getIndex(tabIndex, valueIndex),
      role: "slider",
      "aria-valuemin": min,
      "aria-valuemax": max,
      "aria-valuenow": value,
      "aria-disabled": disabled,
      "aria-label": getIndex(ariaLabelForHandle, valueIndex),
      "aria-labelledby": getIndex(ariaLabelledByForHandle, valueIndex),
      "aria-required": getIndex(ariaRequired, valueIndex),
      "aria-valuetext": (_getIndex = getIndex(ariaValueTextFormatterForHandle, valueIndex)) === null || _getIndex === void 0 ? void 0 : _getIndex(value),
      "aria-orientation": direction === "ltr" || direction === "rtl" ? "horizontal" : "vertical",
      onMouseDown: onInternalStartMove,
      onTouchStart: onInternalStartMove,
      onFocus: onInternalFocus,
      onMouseEnter: onInternalMouseEnter,
      onKeyDown: onKeyDown2,
      onKeyUp: handleKeyUp
    };
  }
  var handleNode = /* @__PURE__ */ React315.createElement("div", _extends({
    ref: ref3,
    className: (0, import_classnames115.default)(handlePrefixCls, _defineProperty(_defineProperty(_defineProperty({}, "".concat(handlePrefixCls, "-").concat(valueIndex + 1), valueIndex !== null && range3), "".concat(handlePrefixCls, "-dragging"), dragging), "".concat(handlePrefixCls, "-dragging-delete"), draggingDelete), classNames186.handle),
    style: _objectSpread2(_objectSpread2(_objectSpread2({}, positionStyle), style2), styles.handle)
  }, divProps, restProps));
  if (render4) {
    handleNode = render4(handleNode, {
      index: valueIndex,
      prefixCls,
      value,
      dragging,
      draggingDelete
    });
  }
  return handleNode;
});
if (true) {
  Handle.displayName = "Handle";
}
var Handle_default = Handle;

// ../../node_modules/rc-slider/es/Handles/index.js
var _excluded53 = ["prefixCls", "style", "onStartMove", "onOffsetChange", "values", "handleRender", "activeHandleRender", "draggingIndex", "draggingDelete", "onFocus"];
var Handles = /* @__PURE__ */ React316.forwardRef(function(props, ref3) {
  var prefixCls = props.prefixCls, style2 = props.style, onStartMove = props.onStartMove, onOffsetChange = props.onOffsetChange, values = props.values, handleRender = props.handleRender, activeHandleRender = props.activeHandleRender, draggingIndex = props.draggingIndex, draggingDelete = props.draggingDelete, onFocus = props.onFocus, restProps = _objectWithoutProperties(props, _excluded53);
  var handlesRef = React316.useRef({});
  var _React$useState = React316.useState(false), _React$useState2 = _slicedToArray(_React$useState, 2), activeVisible = _React$useState2[0], setActiveVisible = _React$useState2[1];
  var _React$useState3 = React316.useState(-1), _React$useState4 = _slicedToArray(_React$useState3, 2), activeIndex = _React$useState4[0], setActiveIndex = _React$useState4[1];
  var onActive = function onActive2(index3) {
    setActiveIndex(index3);
    setActiveVisible(true);
  };
  var onHandleFocus = function onHandleFocus2(e3, index3) {
    onActive(index3);
    onFocus === null || onFocus === void 0 || onFocus(e3);
  };
  var onHandleMouseEnter = function onHandleMouseEnter2(e3, index3) {
    onActive(index3);
  };
  React316.useImperativeHandle(ref3, function() {
    return {
      focus: function focus(index3) {
        var _handlesRef$current$i;
        (_handlesRef$current$i = handlesRef.current[index3]) === null || _handlesRef$current$i === void 0 || _handlesRef$current$i.focus();
      },
      hideHelp: function hideHelp() {
        (0, import_react_dom9.flushSync)(function() {
          setActiveVisible(false);
        });
      }
    };
  });
  var handleProps = _objectSpread2({
    prefixCls,
    onStartMove,
    onOffsetChange,
    render: handleRender,
    onFocus: onHandleFocus,
    onMouseEnter: onHandleMouseEnter
  }, restProps);
  return /* @__PURE__ */ React316.createElement(React316.Fragment, null, values.map(function(value, index3) {
    var dragging = draggingIndex === index3;
    return /* @__PURE__ */ React316.createElement(Handle_default, _extends({
      ref: function ref4(node2) {
        if (!node2) {
          delete handlesRef.current[index3];
        } else {
          handlesRef.current[index3] = node2;
        }
      },
      dragging,
      draggingDelete: dragging && draggingDelete,
      style: getIndex(style2, index3),
      key: index3,
      value,
      valueIndex: index3
    }, handleProps));
  }), activeHandleRender && activeVisible && /* @__PURE__ */ React316.createElement(Handle_default, _extends({
    key: "a11y"
  }, handleProps, {
    value: values[activeIndex],
    valueIndex: null,
    dragging: draggingIndex !== -1,
    draggingDelete,
    render: activeHandleRender,
    style: {
      pointerEvents: "none"
    },
    tabIndex: null,
    "aria-hidden": true
  })));
});
if (true) {
  Handles.displayName = "Handles";
}
var Handles_default = Handles;

// ../../node_modules/rc-slider/es/Marks/index.js
var React318 = __toESM(require_react());

// ../../node_modules/rc-slider/es/Marks/Mark.js
var import_classnames116 = __toESM(require_classnames());
var React317 = __toESM(require_react());
var Mark = function Mark2(props) {
  var prefixCls = props.prefixCls, style2 = props.style, children = props.children, value = props.value, _onClick = props.onClick;
  var _React$useContext = React317.useContext(context_default5), min = _React$useContext.min, max = _React$useContext.max, direction = _React$useContext.direction, includedStart = _React$useContext.includedStart, includedEnd = _React$useContext.includedEnd, included = _React$useContext.included;
  var textCls = "".concat(prefixCls, "-text");
  var positionStyle = getDirectionStyle(direction, value, min, max);
  return /* @__PURE__ */ React317.createElement("span", {
    className: (0, import_classnames116.default)(textCls, _defineProperty({}, "".concat(textCls, "-active"), included && includedStart <= value && value <= includedEnd)),
    style: _objectSpread2(_objectSpread2({}, positionStyle), style2),
    onMouseDown: function onMouseDown(e3) {
      e3.stopPropagation();
    },
    onClick: function onClick() {
      _onClick(value);
    }
  }, children);
};
var Mark_default = Mark;

// ../../node_modules/rc-slider/es/Marks/index.js
var Marks = function Marks2(props) {
  var prefixCls = props.prefixCls, marks = props.marks, onClick = props.onClick;
  var markPrefixCls = "".concat(prefixCls, "-mark");
  if (!marks.length) {
    return null;
  }
  return /* @__PURE__ */ React318.createElement("div", {
    className: markPrefixCls
  }, marks.map(function(_ref) {
    var value = _ref.value, style2 = _ref.style, label = _ref.label;
    return /* @__PURE__ */ React318.createElement(Mark_default, {
      key: value,
      prefixCls: markPrefixCls,
      style: style2,
      value,
      onClick
    }, label);
  }));
};
var Marks_default = Marks;

// ../../node_modules/rc-slider/es/Steps/index.js
var React320 = __toESM(require_react());

// ../../node_modules/rc-slider/es/Steps/Dot.js
var import_classnames117 = __toESM(require_classnames());
var React319 = __toESM(require_react());
var Dot = function Dot2(props) {
  var prefixCls = props.prefixCls, value = props.value, style2 = props.style, activeStyle = props.activeStyle;
  var _React$useContext = React319.useContext(context_default5), min = _React$useContext.min, max = _React$useContext.max, direction = _React$useContext.direction, included = _React$useContext.included, includedStart = _React$useContext.includedStart, includedEnd = _React$useContext.includedEnd;
  var dotClassName = "".concat(prefixCls, "-dot");
  var active = included && includedStart <= value && value <= includedEnd;
  var mergedStyle = _objectSpread2(_objectSpread2({}, getDirectionStyle(direction, value, min, max)), typeof style2 === "function" ? style2(value) : style2);
  if (active) {
    mergedStyle = _objectSpread2(_objectSpread2({}, mergedStyle), typeof activeStyle === "function" ? activeStyle(value) : activeStyle);
  }
  return /* @__PURE__ */ React319.createElement("span", {
    className: (0, import_classnames117.default)(dotClassName, _defineProperty({}, "".concat(dotClassName, "-active"), active)),
    style: mergedStyle
  });
};
var Dot_default = Dot;

// ../../node_modules/rc-slider/es/Steps/index.js
var Steps = function Steps2(props) {
  var prefixCls = props.prefixCls, marks = props.marks, dots = props.dots, style2 = props.style, activeStyle = props.activeStyle;
  var _React$useContext = React320.useContext(context_default5), min = _React$useContext.min, max = _React$useContext.max, step = _React$useContext.step;
  var stepDots = React320.useMemo(function() {
    var dotSet = /* @__PURE__ */ new Set();
    marks.forEach(function(mark) {
      dotSet.add(mark.value);
    });
    if (dots && step !== null) {
      var current2 = min;
      while (current2 <= max) {
        dotSet.add(current2);
        current2 += step;
      }
    }
    return Array.from(dotSet);
  }, [min, max, step, dots, marks]);
  return /* @__PURE__ */ React320.createElement("div", {
    className: "".concat(prefixCls, "-step")
  }, stepDots.map(function(dotValue) {
    return /* @__PURE__ */ React320.createElement(Dot_default, {
      prefixCls,
      key: dotValue,
      value: dotValue,
      style: style2,
      activeStyle
    });
  }));
};
var Steps_default = Steps;

// ../../node_modules/rc-slider/es/Tracks/index.js
var import_classnames119 = __toESM(require_classnames());
var React322 = __toESM(require_react());

// ../../node_modules/rc-slider/es/Tracks/Track.js
var import_classnames118 = __toESM(require_classnames());
var React321 = __toESM(require_react());
var Track = function Track2(props) {
  var prefixCls = props.prefixCls, style2 = props.style, start = props.start, end = props.end, index3 = props.index, onStartMove = props.onStartMove, replaceCls = props.replaceCls;
  var _React$useContext = React321.useContext(context_default5), direction = _React$useContext.direction, min = _React$useContext.min, max = _React$useContext.max, disabled = _React$useContext.disabled, range3 = _React$useContext.range, classNames186 = _React$useContext.classNames;
  var trackPrefixCls = "".concat(prefixCls, "-track");
  var offsetStart = getOffset2(start, min, max);
  var offsetEnd = getOffset2(end, min, max);
  var onInternalStartMove = function onInternalStartMove2(e3) {
    if (!disabled && onStartMove) {
      onStartMove(e3, -1);
    }
  };
  var positionStyle = {};
  switch (direction) {
    case "rtl":
      positionStyle.right = "".concat(offsetStart * 100, "%");
      positionStyle.width = "".concat(offsetEnd * 100 - offsetStart * 100, "%");
      break;
    case "btt":
      positionStyle.bottom = "".concat(offsetStart * 100, "%");
      positionStyle.height = "".concat(offsetEnd * 100 - offsetStart * 100, "%");
      break;
    case "ttb":
      positionStyle.top = "".concat(offsetStart * 100, "%");
      positionStyle.height = "".concat(offsetEnd * 100 - offsetStart * 100, "%");
      break;
    default:
      positionStyle.left = "".concat(offsetStart * 100, "%");
      positionStyle.width = "".concat(offsetEnd * 100 - offsetStart * 100, "%");
  }
  var className2 = replaceCls || (0, import_classnames118.default)(trackPrefixCls, _defineProperty(_defineProperty({}, "".concat(trackPrefixCls, "-").concat(index3 + 1), index3 !== null && range3), "".concat(prefixCls, "-track-draggable"), onStartMove), classNames186.track);
  return /* @__PURE__ */ React321.createElement("div", {
    className: className2,
    style: _objectSpread2(_objectSpread2({}, positionStyle), style2),
    onMouseDown: onInternalStartMove,
    onTouchStart: onInternalStartMove
  });
};
var Track_default = Track;

// ../../node_modules/rc-slider/es/Tracks/index.js
var Tracks = function Tracks2(props) {
  var prefixCls = props.prefixCls, style2 = props.style, values = props.values, startPoint = props.startPoint, onStartMove = props.onStartMove;
  var _React$useContext = React322.useContext(context_default5), included = _React$useContext.included, range3 = _React$useContext.range, min = _React$useContext.min, styles = _React$useContext.styles, classNames186 = _React$useContext.classNames;
  var trackList = React322.useMemo(function() {
    if (!range3) {
      if (values.length === 0) {
        return [];
      }
      var startValue = startPoint !== null && startPoint !== void 0 ? startPoint : min;
      var endValue = values[0];
      return [{
        start: Math.min(startValue, endValue),
        end: Math.max(startValue, endValue)
      }];
    }
    var list = [];
    for (var i = 0; i < values.length - 1; i += 1) {
      list.push({
        start: values[i],
        end: values[i + 1]
      });
    }
    return list;
  }, [values, range3, startPoint, min]);
  if (!included) {
    return null;
  }
  var tracksNode = trackList !== null && trackList !== void 0 && trackList.length && (classNames186.tracks || styles.tracks) ? /* @__PURE__ */ React322.createElement(Track_default, {
    index: null,
    prefixCls,
    start: trackList[0].start,
    end: trackList[trackList.length - 1].end,
    replaceCls: (0, import_classnames119.default)(classNames186.tracks, "".concat(prefixCls, "-tracks")),
    style: styles.tracks
  }) : null;
  return /* @__PURE__ */ React322.createElement(React322.Fragment, null, tracksNode, trackList.map(function(_ref, index3) {
    var start = _ref.start, end = _ref.end;
    return /* @__PURE__ */ React322.createElement(Track_default, {
      index: index3,
      prefixCls,
      style: _objectSpread2(_objectSpread2({}, getIndex(style2, index3)), styles.track),
      start,
      end,
      key: index3,
      onStartMove
    });
  }));
};
var Tracks_default = Tracks;

// ../../node_modules/rc-slider/es/hooks/useDrag.js
var React323 = __toESM(require_react());
var REMOVE_DIST = 130;
function getPosition3(e3) {
  var obj = "targetTouches" in e3 ? e3.targetTouches[0] : e3;
  return {
    pageX: obj.pageX,
    pageY: obj.pageY
  };
}
function useDrag(containerRef, direction, rawValues, min, max, formatValue2, triggerChange, finishChange, offsetValues, editable, minCount) {
  var _React$useState = React323.useState(null), _React$useState2 = _slicedToArray(_React$useState, 2), draggingValue = _React$useState2[0], setDraggingValue = _React$useState2[1];
  var _React$useState3 = React323.useState(-1), _React$useState4 = _slicedToArray(_React$useState3, 2), draggingIndex = _React$useState4[0], setDraggingIndex = _React$useState4[1];
  var _React$useState5 = React323.useState(false), _React$useState6 = _slicedToArray(_React$useState5, 2), draggingDelete = _React$useState6[0], setDraggingDelete = _React$useState6[1];
  var _React$useState7 = React323.useState(rawValues), _React$useState8 = _slicedToArray(_React$useState7, 2), cacheValues = _React$useState8[0], setCacheValues = _React$useState8[1];
  var _React$useState9 = React323.useState(rawValues), _React$useState10 = _slicedToArray(_React$useState9, 2), originValues = _React$useState10[0], setOriginValues = _React$useState10[1];
  var mouseMoveEventRef = React323.useRef(null);
  var mouseUpEventRef = React323.useRef(null);
  var touchEventTargetRef = React323.useRef(null);
  var _React$useContext = React323.useContext(UnstableContext), onDragStart = _React$useContext.onDragStart, onDragChange = _React$useContext.onDragChange;
  useLayoutEffect_default(function() {
    if (draggingIndex === -1) {
      setCacheValues(rawValues);
    }
  }, [rawValues, draggingIndex]);
  React323.useEffect(function() {
    return function() {
      document.removeEventListener("mousemove", mouseMoveEventRef.current);
      document.removeEventListener("mouseup", mouseUpEventRef.current);
      if (touchEventTargetRef.current) {
        touchEventTargetRef.current.removeEventListener("touchmove", mouseMoveEventRef.current);
        touchEventTargetRef.current.removeEventListener("touchend", mouseUpEventRef.current);
      }
    };
  }, []);
  var flushValues = function flushValues2(nextValues, nextValue, deleteMark) {
    if (nextValue !== void 0) {
      setDraggingValue(nextValue);
    }
    setCacheValues(nextValues);
    var changeValues = nextValues;
    if (deleteMark) {
      changeValues = nextValues.filter(function(_, i) {
        return i !== draggingIndex;
      });
    }
    triggerChange(changeValues);
    if (onDragChange) {
      onDragChange({
        rawValues: nextValues,
        deleteIndex: deleteMark ? draggingIndex : -1,
        draggingIndex,
        draggingValue: nextValue
      });
    }
  };
  var updateCacheValue = useEvent2(function(valueIndex, offsetPercent, deleteMark) {
    if (valueIndex === -1) {
      var startValue = originValues[0];
      var endValue = originValues[originValues.length - 1];
      var maxStartOffset = min - startValue;
      var maxEndOffset = max - endValue;
      var offset4 = offsetPercent * (max - min);
      offset4 = Math.max(offset4, maxStartOffset);
      offset4 = Math.min(offset4, maxEndOffset);
      var formatStartValue = formatValue2(startValue + offset4);
      offset4 = formatStartValue - startValue;
      var cloneCacheValues = originValues.map(function(val) {
        return val + offset4;
      });
      flushValues(cloneCacheValues);
    } else {
      var offsetDist = (max - min) * offsetPercent;
      var cloneValues = _toConsumableArray(cacheValues);
      cloneValues[valueIndex] = originValues[valueIndex];
      var next2 = offsetValues(cloneValues, offsetDist, valueIndex, "dist");
      flushValues(next2.values, next2.value, deleteMark);
    }
  });
  var onStartMove = function onStartMove2(e3, valueIndex, startValues) {
    e3.stopPropagation();
    var initialValues = startValues || rawValues;
    var originValue = initialValues[valueIndex];
    setDraggingIndex(valueIndex);
    setDraggingValue(originValue);
    setOriginValues(initialValues);
    setCacheValues(initialValues);
    setDraggingDelete(false);
    var _getPosition = getPosition3(e3), startX = _getPosition.pageX, startY = _getPosition.pageY;
    var deleteMark = false;
    if (onDragStart) {
      onDragStart({
        rawValues: initialValues,
        draggingIndex: valueIndex,
        draggingValue: originValue
      });
    }
    var onMouseMove = function onMouseMove2(event) {
      event.preventDefault();
      var _getPosition2 = getPosition3(event), moveX = _getPosition2.pageX, moveY = _getPosition2.pageY;
      var offsetX = moveX - startX;
      var offsetY = moveY - startY;
      var _containerRef$current = containerRef.current.getBoundingClientRect(), width = _containerRef$current.width, height = _containerRef$current.height;
      var offSetPercent;
      var removeDist;
      switch (direction) {
        case "btt":
          offSetPercent = -offsetY / height;
          removeDist = offsetX;
          break;
        case "ttb":
          offSetPercent = offsetY / height;
          removeDist = offsetX;
          break;
        case "rtl":
          offSetPercent = -offsetX / width;
          removeDist = offsetY;
          break;
        default:
          offSetPercent = offsetX / width;
          removeDist = offsetY;
      }
      deleteMark = editable ? Math.abs(removeDist) > REMOVE_DIST && minCount < cacheValues.length : false;
      setDraggingDelete(deleteMark);
      updateCacheValue(valueIndex, offSetPercent, deleteMark);
    };
    var onMouseUp = function onMouseUp2(event) {
      event.preventDefault();
      document.removeEventListener("mouseup", onMouseUp2);
      document.removeEventListener("mousemove", onMouseMove);
      if (touchEventTargetRef.current) {
        touchEventTargetRef.current.removeEventListener("touchmove", mouseMoveEventRef.current);
        touchEventTargetRef.current.removeEventListener("touchend", mouseUpEventRef.current);
      }
      mouseMoveEventRef.current = null;
      mouseUpEventRef.current = null;
      touchEventTargetRef.current = null;
      finishChange(deleteMark);
      setDraggingIndex(-1);
      setDraggingDelete(false);
    };
    document.addEventListener("mouseup", onMouseUp);
    document.addEventListener("mousemove", onMouseMove);
    e3.currentTarget.addEventListener("touchend", onMouseUp);
    e3.currentTarget.addEventListener("touchmove", onMouseMove);
    mouseMoveEventRef.current = onMouseMove;
    mouseUpEventRef.current = onMouseUp;
    touchEventTargetRef.current = e3.currentTarget;
  };
  var returnValues = React323.useMemo(function() {
    var sourceValues = _toConsumableArray(rawValues).sort(function(a, b) {
      return a - b;
    });
    var targetValues = _toConsumableArray(cacheValues).sort(function(a, b) {
      return a - b;
    });
    var counts = {};
    targetValues.forEach(function(val) {
      counts[val] = (counts[val] || 0) + 1;
    });
    sourceValues.forEach(function(val) {
      counts[val] = (counts[val] || 0) - 1;
    });
    var maxDiffCount = editable ? 1 : 0;
    var diffCount = Object.values(counts).reduce(function(prev2, next2) {
      return prev2 + Math.abs(next2);
    }, 0);
    return diffCount <= maxDiffCount ? cacheValues : rawValues;
  }, [rawValues, cacheValues, editable]);
  return [draggingIndex, draggingValue, draggingDelete, returnValues, onStartMove];
}
var useDrag_default = useDrag;

// ../../node_modules/rc-slider/es/hooks/useOffset.js
var React324 = __toESM(require_react());
function useOffset(min, max, step, markList, allowCross, pushable) {
  var formatRangeValue = React324.useCallback(function(val) {
    return Math.max(min, Math.min(max, val));
  }, [min, max]);
  var formatStepValue = React324.useCallback(function(val) {
    if (step !== null) {
      var stepValue = min + Math.round((formatRangeValue(val) - min) / step) * step;
      var getDecimal = function getDecimal2(num) {
        return (String(num).split(".")[1] || "").length;
      };
      var maxDecimal = Math.max(getDecimal(step), getDecimal(max), getDecimal(min));
      var fixedValue = Number(stepValue.toFixed(maxDecimal));
      return min <= fixedValue && fixedValue <= max ? fixedValue : null;
    }
    return null;
  }, [step, min, max, formatRangeValue]);
  var formatValue2 = React324.useCallback(function(val) {
    var formatNextValue = formatRangeValue(val);
    var alignValues = markList.map(function(mark) {
      return mark.value;
    });
    if (step !== null) {
      alignValues.push(formatStepValue(val));
    }
    alignValues.push(min, max);
    var closeValue = alignValues[0];
    var closeDist = max - min;
    alignValues.forEach(function(alignValue) {
      var dist = Math.abs(formatNextValue - alignValue);
      if (dist <= closeDist) {
        closeValue = alignValue;
        closeDist = dist;
      }
    });
    return closeValue;
  }, [min, max, markList, step, formatRangeValue, formatStepValue]);
  var offsetValue = function offsetValue2(values, offset4, valueIndex) {
    var mode = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "unit";
    if (typeof offset4 === "number") {
      var nextValue;
      var originValue = values[valueIndex];
      var targetDistValue = originValue + offset4;
      var potentialValues = [];
      markList.forEach(function(mark) {
        potentialValues.push(mark.value);
      });
      potentialValues.push(min, max);
      potentialValues.push(formatStepValue(originValue));
      var sign2 = offset4 > 0 ? 1 : -1;
      if (mode === "unit") {
        potentialValues.push(formatStepValue(originValue + sign2 * step));
      } else {
        potentialValues.push(formatStepValue(targetDistValue));
      }
      potentialValues = potentialValues.filter(function(val) {
        return val !== null;
      }).filter(function(val) {
        return offset4 < 0 ? val <= originValue : val >= originValue;
      });
      if (mode === "unit") {
        potentialValues = potentialValues.filter(function(val) {
          return val !== originValue;
        });
      }
      var compareValue = mode === "unit" ? originValue : targetDistValue;
      nextValue = potentialValues[0];
      var valueDist = Math.abs(nextValue - compareValue);
      potentialValues.forEach(function(potentialValue) {
        var dist = Math.abs(potentialValue - compareValue);
        if (dist < valueDist) {
          nextValue = potentialValue;
          valueDist = dist;
        }
      });
      if (nextValue === void 0) {
        return offset4 < 0 ? min : max;
      }
      if (mode === "dist") {
        return nextValue;
      }
      if (Math.abs(offset4) > 1) {
        var cloneValues = _toConsumableArray(values);
        cloneValues[valueIndex] = nextValue;
        return offsetValue2(cloneValues, offset4 - sign2, valueIndex, mode);
      }
      return nextValue;
    } else if (offset4 === "min") {
      return min;
    } else if (offset4 === "max") {
      return max;
    }
  };
  var offsetChangedValue = function offsetChangedValue2(values, offset4, valueIndex) {
    var mode = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "unit";
    var originValue = values[valueIndex];
    var nextValue = offsetValue(values, offset4, valueIndex, mode);
    return {
      value: nextValue,
      changed: nextValue !== originValue
    };
  };
  var needPush = function needPush2(dist) {
    return pushable === null && dist === 0 || typeof pushable === "number" && dist < pushable;
  };
  var offsetValues = function offsetValues2(values, offset4, valueIndex) {
    var mode = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "unit";
    var nextValues = values.map(formatValue2);
    var originValue = nextValues[valueIndex];
    var nextValue = offsetValue(nextValues, offset4, valueIndex, mode);
    nextValues[valueIndex] = nextValue;
    if (allowCross === false) {
      var pushNum = pushable || 0;
      if (valueIndex > 0 && nextValues[valueIndex - 1] !== originValue) {
        nextValues[valueIndex] = Math.max(nextValues[valueIndex], nextValues[valueIndex - 1] + pushNum);
      }
      if (valueIndex < nextValues.length - 1 && nextValues[valueIndex + 1] !== originValue) {
        nextValues[valueIndex] = Math.min(nextValues[valueIndex], nextValues[valueIndex + 1] - pushNum);
      }
    } else if (typeof pushable === "number" || pushable === null) {
      for (var i = valueIndex + 1; i < nextValues.length; i += 1) {
        var changed = true;
        while (needPush(nextValues[i] - nextValues[i - 1]) && changed) {
          var _offsetChangedValue = offsetChangedValue(nextValues, 1, i);
          nextValues[i] = _offsetChangedValue.value;
          changed = _offsetChangedValue.changed;
        }
      }
      for (var _i = valueIndex; _i > 0; _i -= 1) {
        var _changed = true;
        while (needPush(nextValues[_i] - nextValues[_i - 1]) && _changed) {
          var _offsetChangedValue2 = offsetChangedValue(nextValues, -1, _i - 1);
          nextValues[_i - 1] = _offsetChangedValue2.value;
          _changed = _offsetChangedValue2.changed;
        }
      }
      for (var _i2 = nextValues.length - 1; _i2 > 0; _i2 -= 1) {
        var _changed2 = true;
        while (needPush(nextValues[_i2] - nextValues[_i2 - 1]) && _changed2) {
          var _offsetChangedValue3 = offsetChangedValue(nextValues, -1, _i2 - 1);
          nextValues[_i2 - 1] = _offsetChangedValue3.value;
          _changed2 = _offsetChangedValue3.changed;
        }
      }
      for (var _i3 = 0; _i3 < nextValues.length - 1; _i3 += 1) {
        var _changed3 = true;
        while (needPush(nextValues[_i3 + 1] - nextValues[_i3]) && _changed3) {
          var _offsetChangedValue4 = offsetChangedValue(nextValues, 1, _i3 + 1);
          nextValues[_i3 + 1] = _offsetChangedValue4.value;
          _changed3 = _offsetChangedValue4.changed;
        }
      }
    }
    return {
      value: nextValues[valueIndex],
      values: nextValues
    };
  };
  return [formatValue2, offsetValues];
}

// ../../node_modules/rc-slider/es/hooks/useRange.js
var import_react107 = __toESM(require_react());
function useRange(range3) {
  return (0, import_react107.useMemo)(function() {
    if (range3 === true || !range3) {
      return [!!range3, false, false, 0];
    }
    var editable = range3.editable, draggableTrack = range3.draggableTrack, minCount = range3.minCount, maxCount = range3.maxCount;
    if (true) {
      warning(!editable || !draggableTrack, "`editable` can not work with `draggableTrack`.");
    }
    return [true, editable, !editable && draggableTrack, minCount || 0, maxCount];
  }, [range3]);
}

// ../../node_modules/rc-slider/es/Slider.js
var Slider3 = /* @__PURE__ */ React325.forwardRef(function(props, ref3) {
  var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-slider" : _props$prefixCls, className2 = props.className, style2 = props.style, classNames186 = props.classNames, styles = props.styles, id = props.id, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$keyboard = props.keyboard, keyboard = _props$keyboard === void 0 ? true : _props$keyboard, autoFocus = props.autoFocus, onFocus = props.onFocus, onBlur = props.onBlur, _props$min = props.min, min = _props$min === void 0 ? 0 : _props$min, _props$max = props.max, max = _props$max === void 0 ? 100 : _props$max, _props$step = props.step, step = _props$step === void 0 ? 1 : _props$step, value = props.value, defaultValue2 = props.defaultValue, range3 = props.range, count = props.count, onChange = props.onChange, onBeforeChange = props.onBeforeChange, onAfterChange = props.onAfterChange, onChangeComplete = props.onChangeComplete, _props$allowCross = props.allowCross, allowCross = _props$allowCross === void 0 ? true : _props$allowCross, _props$pushable = props.pushable, pushable = _props$pushable === void 0 ? false : _props$pushable, reverse = props.reverse, vertical = props.vertical, _props$included = props.included, included = _props$included === void 0 ? true : _props$included, startPoint = props.startPoint, trackStyle = props.trackStyle, handleStyle = props.handleStyle, railStyle = props.railStyle, dotStyle = props.dotStyle, activeDotStyle = props.activeDotStyle, marks = props.marks, dots = props.dots, handleRender = props.handleRender, activeHandleRender = props.activeHandleRender, track = props.track, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, ariaLabelForHandle = props.ariaLabelForHandle, ariaLabelledByForHandle = props.ariaLabelledByForHandle, ariaRequired = props.ariaRequired, ariaValueTextFormatterForHandle = props.ariaValueTextFormatterForHandle;
  var handlesRef = React325.useRef(null);
  var containerRef = React325.useRef(null);
  var direction = React325.useMemo(function() {
    if (vertical) {
      return reverse ? "ttb" : "btt";
    }
    return reverse ? "rtl" : "ltr";
  }, [reverse, vertical]);
  var _useRange = useRange(range3), _useRange2 = _slicedToArray(_useRange, 5), rangeEnabled = _useRange2[0], rangeEditable = _useRange2[1], rangeDraggableTrack = _useRange2[2], minCount = _useRange2[3], maxCount = _useRange2[4];
  var mergedMin = React325.useMemo(function() {
    return isFinite(min) ? min : 0;
  }, [min]);
  var mergedMax = React325.useMemo(function() {
    return isFinite(max) ? max : 100;
  }, [max]);
  var mergedStep = React325.useMemo(function() {
    return step !== null && step <= 0 ? 1 : step;
  }, [step]);
  var mergedPush = React325.useMemo(function() {
    if (typeof pushable === "boolean") {
      return pushable ? mergedStep : false;
    }
    return pushable >= 0 ? pushable : false;
  }, [pushable, mergedStep]);
  var markList = React325.useMemo(function() {
    return Object.keys(marks || {}).map(function(key2) {
      var mark = marks[key2];
      var markObj = {
        value: Number(key2)
      };
      if (mark && _typeof(mark) === "object" && !/* @__PURE__ */ React325.isValidElement(mark) && ("label" in mark || "style" in mark)) {
        markObj.style = mark.style;
        markObj.label = mark.label;
      } else {
        markObj.label = mark;
      }
      return markObj;
    }).filter(function(_ref) {
      var label = _ref.label;
      return label || typeof label === "number";
    }).sort(function(a, b) {
      return a.value - b.value;
    });
  }, [marks]);
  var _useOffset = useOffset(mergedMin, mergedMax, mergedStep, markList, allowCross, mergedPush), _useOffset2 = _slicedToArray(_useOffset, 2), formatValue2 = _useOffset2[0], offsetValues = _useOffset2[1];
  var _useMergedState = useMergedState(defaultValue2, {
    value
  }), _useMergedState2 = _slicedToArray(_useMergedState, 2), mergedValue = _useMergedState2[0], setValue = _useMergedState2[1];
  var rawValues = React325.useMemo(function() {
    var valueList = mergedValue === null || mergedValue === void 0 ? [] : Array.isArray(mergedValue) ? mergedValue : [mergedValue];
    var _valueList = _slicedToArray(valueList, 1), _valueList$ = _valueList[0], val0 = _valueList$ === void 0 ? mergedMin : _valueList$;
    var returnValues = mergedValue === null ? [] : [val0];
    if (rangeEnabled) {
      returnValues = _toConsumableArray(valueList);
      if (count || mergedValue === void 0) {
        var pointCount = count >= 0 ? count + 1 : 2;
        returnValues = returnValues.slice(0, pointCount);
        while (returnValues.length < pointCount) {
          var _returnValues;
          returnValues.push((_returnValues = returnValues[returnValues.length - 1]) !== null && _returnValues !== void 0 ? _returnValues : mergedMin);
        }
      }
      returnValues.sort(function(a, b) {
        return a - b;
      });
    }
    returnValues.forEach(function(val, index3) {
      returnValues[index3] = formatValue2(val);
    });
    return returnValues;
  }, [mergedValue, rangeEnabled, mergedMin, count, formatValue2]);
  var getTriggerValue = function getTriggerValue2(triggerValues) {
    return rangeEnabled ? triggerValues : triggerValues[0];
  };
  var triggerChange = useEvent2(function(nextValues) {
    var cloneNextValues = _toConsumableArray(nextValues).sort(function(a, b) {
      return a - b;
    });
    if (onChange && !isEqual_default(cloneNextValues, rawValues, true)) {
      onChange(getTriggerValue(cloneNextValues));
    }
    setValue(cloneNextValues);
  });
  var finishChange = useEvent2(function(draggingDelete2) {
    if (draggingDelete2) {
      handlesRef.current.hideHelp();
    }
    var finishValue = getTriggerValue(rawValues);
    onAfterChange === null || onAfterChange === void 0 || onAfterChange(finishValue);
    warning_default(!onAfterChange, "[rc-slider] `onAfterChange` is deprecated. Please use `onChangeComplete` instead.");
    onChangeComplete === null || onChangeComplete === void 0 || onChangeComplete(finishValue);
  });
  var onDelete = function onDelete2(index3) {
    if (disabled || !rangeEditable || rawValues.length <= minCount) {
      return;
    }
    var cloneNextValues = _toConsumableArray(rawValues);
    cloneNextValues.splice(index3, 1);
    onBeforeChange === null || onBeforeChange === void 0 || onBeforeChange(getTriggerValue(cloneNextValues));
    triggerChange(cloneNextValues);
    var nextFocusIndex = Math.max(0, index3 - 1);
    handlesRef.current.hideHelp();
    handlesRef.current.focus(nextFocusIndex);
  };
  var _useDrag = useDrag_default(containerRef, direction, rawValues, mergedMin, mergedMax, formatValue2, triggerChange, finishChange, offsetValues, rangeEditable, minCount), _useDrag2 = _slicedToArray(_useDrag, 5), draggingIndex = _useDrag2[0], draggingValue = _useDrag2[1], draggingDelete = _useDrag2[2], cacheValues = _useDrag2[3], onStartDrag = _useDrag2[4];
  var changeToCloseValue = function changeToCloseValue2(newValue, e3) {
    if (!disabled) {
      var cloneNextValues = _toConsumableArray(rawValues);
      var valueIndex = 0;
      var valueBeforeIndex = 0;
      var valueDist = mergedMax - mergedMin;
      rawValues.forEach(function(val, index3) {
        var dist = Math.abs(newValue - val);
        if (dist <= valueDist) {
          valueDist = dist;
          valueIndex = index3;
        }
        if (val < newValue) {
          valueBeforeIndex = index3;
        }
      });
      var focusIndex = valueIndex;
      if (rangeEditable && valueDist !== 0 && (!maxCount || rawValues.length < maxCount)) {
        cloneNextValues.splice(valueBeforeIndex + 1, 0, newValue);
        focusIndex = valueBeforeIndex + 1;
      } else {
        cloneNextValues[valueIndex] = newValue;
      }
      if (rangeEnabled && !rawValues.length && count === void 0) {
        cloneNextValues.push(newValue);
      }
      var nextValue = getTriggerValue(cloneNextValues);
      onBeforeChange === null || onBeforeChange === void 0 || onBeforeChange(nextValue);
      triggerChange(cloneNextValues);
      if (e3) {
        var _document$activeEleme, _document$activeEleme2;
        (_document$activeEleme = document.activeElement) === null || _document$activeEleme === void 0 || (_document$activeEleme2 = _document$activeEleme.blur) === null || _document$activeEleme2 === void 0 || _document$activeEleme2.call(_document$activeEleme);
        handlesRef.current.focus(focusIndex);
        onStartDrag(e3, focusIndex, cloneNextValues);
      } else {
        onAfterChange === null || onAfterChange === void 0 || onAfterChange(nextValue);
        warning_default(!onAfterChange, "[rc-slider] `onAfterChange` is deprecated. Please use `onChangeComplete` instead.");
        onChangeComplete === null || onChangeComplete === void 0 || onChangeComplete(nextValue);
      }
    }
  };
  var onSliderMouseDown = function onSliderMouseDown2(e3) {
    e3.preventDefault();
    var _containerRef$current = containerRef.current.getBoundingClientRect(), width = _containerRef$current.width, height = _containerRef$current.height, left2 = _containerRef$current.left, top = _containerRef$current.top, bottom = _containerRef$current.bottom, right2 = _containerRef$current.right;
    var clientX = e3.clientX, clientY = e3.clientY;
    var percent;
    switch (direction) {
      case "btt":
        percent = (bottom - clientY) / height;
        break;
      case "ttb":
        percent = (clientY - top) / height;
        break;
      case "rtl":
        percent = (right2 - clientX) / width;
        break;
      default:
        percent = (clientX - left2) / width;
    }
    var nextValue = mergedMin + percent * (mergedMax - mergedMin);
    changeToCloseValue(formatValue2(nextValue), e3);
  };
  var _React$useState = React325.useState(null), _React$useState2 = _slicedToArray(_React$useState, 2), keyboardValue = _React$useState2[0], setKeyboardValue = _React$useState2[1];
  var onHandleOffsetChange = function onHandleOffsetChange2(offset4, valueIndex) {
    if (!disabled) {
      var next2 = offsetValues(rawValues, offset4, valueIndex);
      onBeforeChange === null || onBeforeChange === void 0 || onBeforeChange(getTriggerValue(rawValues));
      triggerChange(next2.values);
      setKeyboardValue(next2.value);
    }
  };
  React325.useEffect(function() {
    if (keyboardValue !== null) {
      var valueIndex = rawValues.indexOf(keyboardValue);
      if (valueIndex >= 0) {
        handlesRef.current.focus(valueIndex);
      }
    }
    setKeyboardValue(null);
  }, [keyboardValue]);
  var mergedDraggableTrack = React325.useMemo(function() {
    if (rangeDraggableTrack && mergedStep === null) {
      if (true) {
        warning_default(false, "`draggableTrack` is not supported when `step` is `null`.");
      }
      return false;
    }
    return rangeDraggableTrack;
  }, [rangeDraggableTrack, mergedStep]);
  var onStartMove = useEvent2(function(e3, valueIndex) {
    onStartDrag(e3, valueIndex);
    onBeforeChange === null || onBeforeChange === void 0 || onBeforeChange(getTriggerValue(rawValues));
  });
  var dragging = draggingIndex !== -1;
  React325.useEffect(function() {
    if (!dragging) {
      var valueIndex = rawValues.lastIndexOf(draggingValue);
      handlesRef.current.focus(valueIndex);
    }
  }, [dragging]);
  var sortedCacheValues = React325.useMemo(function() {
    return _toConsumableArray(cacheValues).sort(function(a, b) {
      return a - b;
    });
  }, [cacheValues]);
  var _React$useMemo = React325.useMemo(function() {
    if (!rangeEnabled) {
      return [mergedMin, sortedCacheValues[0]];
    }
    return [sortedCacheValues[0], sortedCacheValues[sortedCacheValues.length - 1]];
  }, [sortedCacheValues, rangeEnabled, mergedMin]), _React$useMemo2 = _slicedToArray(_React$useMemo, 2), includedStart = _React$useMemo2[0], includedEnd = _React$useMemo2[1];
  React325.useImperativeHandle(ref3, function() {
    return {
      focus: function focus() {
        handlesRef.current.focus(0);
      },
      blur: function blur() {
        var _containerRef$current2;
        var _document = document, activeElement = _document.activeElement;
        if ((_containerRef$current2 = containerRef.current) !== null && _containerRef$current2 !== void 0 && _containerRef$current2.contains(activeElement)) {
          activeElement === null || activeElement === void 0 || activeElement.blur();
        }
      }
    };
  });
  React325.useEffect(function() {
    if (autoFocus) {
      handlesRef.current.focus(0);
    }
  }, []);
  var context = React325.useMemo(function() {
    return {
      min: mergedMin,
      max: mergedMax,
      direction,
      disabled,
      keyboard,
      step: mergedStep,
      included,
      includedStart,
      includedEnd,
      range: rangeEnabled,
      tabIndex,
      ariaLabelForHandle,
      ariaLabelledByForHandle,
      ariaRequired,
      ariaValueTextFormatterForHandle,
      styles: styles || {},
      classNames: classNames186 || {}
    };
  }, [mergedMin, mergedMax, direction, disabled, keyboard, mergedStep, included, includedStart, includedEnd, rangeEnabled, tabIndex, ariaLabelForHandle, ariaLabelledByForHandle, ariaRequired, ariaValueTextFormatterForHandle, styles, classNames186]);
  return /* @__PURE__ */ React325.createElement(context_default5.Provider, {
    value: context
  }, /* @__PURE__ */ React325.createElement("div", {
    ref: containerRef,
    className: (0, import_classnames120.default)(prefixCls, className2, _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "".concat(prefixCls, "-disabled"), disabled), "".concat(prefixCls, "-vertical"), vertical), "".concat(prefixCls, "-horizontal"), !vertical), "".concat(prefixCls, "-with-marks"), markList.length)),
    style: style2,
    onMouseDown: onSliderMouseDown,
    id
  }, /* @__PURE__ */ React325.createElement("div", {
    className: (0, import_classnames120.default)("".concat(prefixCls, "-rail"), classNames186 === null || classNames186 === void 0 ? void 0 : classNames186.rail),
    style: _objectSpread2(_objectSpread2({}, railStyle), styles === null || styles === void 0 ? void 0 : styles.rail)
  }), track !== false && /* @__PURE__ */ React325.createElement(Tracks_default, {
    prefixCls,
    style: trackStyle,
    values: rawValues,
    startPoint,
    onStartMove: mergedDraggableTrack ? onStartMove : void 0
  }), /* @__PURE__ */ React325.createElement(Steps_default, {
    prefixCls,
    marks: markList,
    dots,
    style: dotStyle,
    activeStyle: activeDotStyle
  }), /* @__PURE__ */ React325.createElement(Handles_default, {
    ref: handlesRef,
    prefixCls,
    style: handleStyle,
    values: cacheValues,
    draggingIndex,
    draggingDelete,
    onStartMove,
    onOffsetChange: onHandleOffsetChange,
    onFocus,
    onBlur,
    handleRender,
    activeHandleRender,
    onChangeComplete: finishChange,
    onDelete: rangeEditable ? onDelete : void 0
  }), /* @__PURE__ */ React325.createElement(Marks_default, {
    prefixCls,
    marks: markList,
    onClick: changeToCloseValue
  })));
});
if (true) {
  Slider3.displayName = "Slider";
}
var Slider_default2 = Slider3;

// ../../node_modules/rc-slider/es/index.js
var es_default21 = Slider_default2;

// ../../node_modules/antd/es/slider/index.js
var import_react110 = __toESM(require_react());
var import_classnames121 = __toESM(require_classnames());

// ../../node_modules/antd/es/slider/Context.js
var import_react108 = __toESM(require_react());
var SliderInternalContext = /* @__PURE__ */ (0, import_react108.createContext)({});
var Context_default3 = SliderInternalContext;

// ../../node_modules/antd/es/slider/SliderTooltip.js
var React326 = __toESM(require_react());
var import_react109 = __toESM(require_react());
var SliderTooltip = /* @__PURE__ */ React326.forwardRef((props, ref3) => {
  const {
    open: open2,
    draggingDelete,
    value
  } = props;
  const innerRef = (0, import_react109.useRef)(null);
  const mergedOpen = open2 && !draggingDelete;
  const rafRef = (0, import_react109.useRef)(null);
  function cancelKeepAlign() {
    raf_default.cancel(rafRef.current);
    rafRef.current = null;
  }
  function keepAlign() {
    rafRef.current = raf_default(() => {
      var _a;
      (_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.forceAlign();
      rafRef.current = null;
    });
  }
  React326.useEffect(() => {
    if (mergedOpen) {
      keepAlign();
    } else {
      cancelKeepAlign();
    }
    return cancelKeepAlign;
  }, [mergedOpen, props.title, value]);
  return /* @__PURE__ */ React326.createElement(tooltip_default, Object.assign({
    ref: composeRef(innerRef, ref3)
  }, props, {
    open: mergedOpen
  }));
});
if (true) {
  SliderTooltip.displayName = "SliderTooltip";
}
var SliderTooltip_default = SliderTooltip;

// ../../node_modules/antd/es/slider/style/index.js
var genBaseStyle6 = (token2) => {
  const {
    componentCls,
    antCls,
    controlSize,
    dotSize,
    marginFull,
    marginPart,
    colorFillContentHover,
    handleColorDisabled,
    calc,
    handleSize,
    handleSizeHover,
    handleActiveColor,
    handleActiveOutlineColor,
    handleLineWidth,
    handleLineWidthHover,
    motionDurationMid
  } = token2;
  return {
    [componentCls]: Object.assign(Object.assign({}, resetComponent(token2)), {
      position: "relative",
      height: controlSize,
      margin: `${unit(marginPart)} ${unit(marginFull)}`,
      padding: 0,
      cursor: "pointer",
      touchAction: "none",
      "&-vertical": {
        margin: `${unit(marginFull)} ${unit(marginPart)}`
      },
      [`${componentCls}-rail`]: {
        position: "absolute",
        backgroundColor: token2.railBg,
        borderRadius: token2.borderRadiusXS,
        transition: `background-color ${motionDurationMid}`
      },
      [`${componentCls}-track,${componentCls}-tracks`]: {
        position: "absolute",
        transition: `background-color ${motionDurationMid}`
      },
      [`${componentCls}-track`]: {
        backgroundColor: token2.trackBg,
        borderRadius: token2.borderRadiusXS
      },
      [`${componentCls}-track-draggable`]: {
        boxSizing: "content-box",
        backgroundClip: "content-box",
        border: "solid rgba(0,0,0,0)"
      },
      "&:hover": {
        [`${componentCls}-rail`]: {
          backgroundColor: token2.railHoverBg
        },
        [`${componentCls}-track`]: {
          backgroundColor: token2.trackHoverBg
        },
        [`${componentCls}-dot`]: {
          borderColor: colorFillContentHover
        },
        [`${componentCls}-handle::after`]: {
          boxShadow: `0 0 0 ${unit(handleLineWidth)} ${token2.colorPrimaryBorderHover}`
        },
        [`${componentCls}-dot-active`]: {
          borderColor: token2.dotActiveBorderColor
        }
      },
      [`${componentCls}-handle`]: {
        position: "absolute",
        width: handleSize,
        height: handleSize,
        outline: "none",
        userSelect: "none",
        // Dragging status
        "&-dragging-delete": {
          opacity: 0
        },
        // 扩大选区
        "&::before": {
          content: '""',
          position: "absolute",
          insetInlineStart: calc(handleLineWidth).mul(-1).equal(),
          insetBlockStart: calc(handleLineWidth).mul(-1).equal(),
          width: calc(handleSize).add(calc(handleLineWidth).mul(2)).equal(),
          height: calc(handleSize).add(calc(handleLineWidth).mul(2)).equal(),
          backgroundColor: "transparent"
        },
        "&::after": {
          content: '""',
          position: "absolute",
          insetBlockStart: 0,
          insetInlineStart: 0,
          width: handleSize,
          height: handleSize,
          backgroundColor: token2.colorBgElevated,
          boxShadow: `0 0 0 ${unit(handleLineWidth)} ${token2.handleColor}`,
          outline: `0px solid transparent`,
          borderRadius: "50%",
          cursor: "pointer",
          transition: `
            inset-inline-start ${motionDurationMid},
            inset-block-start ${motionDurationMid},
            width ${motionDurationMid},
            height ${motionDurationMid},
            box-shadow ${motionDurationMid},
            outline ${motionDurationMid}
          `
        },
        "&:hover, &:active, &:focus": {
          "&::before": {
            insetInlineStart: calc(handleSizeHover).sub(handleSize).div(2).add(handleLineWidthHover).mul(-1).equal(),
            insetBlockStart: calc(handleSizeHover).sub(handleSize).div(2).add(handleLineWidthHover).mul(-1).equal(),
            width: calc(handleSizeHover).add(calc(handleLineWidthHover).mul(2)).equal(),
            height: calc(handleSizeHover).add(calc(handleLineWidthHover).mul(2)).equal()
          },
          "&::after": {
            boxShadow: `0 0 0 ${unit(handleLineWidthHover)} ${handleActiveColor}`,
            outline: `6px solid ${handleActiveOutlineColor}`,
            width: handleSizeHover,
            height: handleSizeHover,
            insetInlineStart: token2.calc(handleSize).sub(handleSizeHover).div(2).equal(),
            insetBlockStart: token2.calc(handleSize).sub(handleSizeHover).div(2).equal()
          }
        }
      },
      [`&-lock ${componentCls}-handle`]: {
        "&::before, &::after": {
          transition: "none"
        }
      },
      [`${componentCls}-mark`]: {
        position: "absolute",
        fontSize: token2.fontSize
      },
      [`${componentCls}-mark-text`]: {
        position: "absolute",
        display: "inline-block",
        color: token2.colorTextDescription,
        textAlign: "center",
        wordBreak: "keep-all",
        cursor: "pointer",
        userSelect: "none",
        "&-active": {
          color: token2.colorText
        }
      },
      [`${componentCls}-step`]: {
        position: "absolute",
        background: "transparent",
        pointerEvents: "none"
      },
      [`${componentCls}-dot`]: {
        position: "absolute",
        width: dotSize,
        height: dotSize,
        backgroundColor: token2.colorBgElevated,
        border: `${unit(handleLineWidth)} solid ${token2.dotBorderColor}`,
        borderRadius: "50%",
        cursor: "pointer",
        transition: `border-color ${token2.motionDurationSlow}`,
        pointerEvents: "auto",
        "&-active": {
          borderColor: token2.dotActiveBorderColor
        }
      },
      [`&${componentCls}-disabled`]: {
        cursor: "not-allowed",
        [`${componentCls}-rail`]: {
          backgroundColor: `${token2.railBg} !important`
        },
        [`${componentCls}-track`]: {
          backgroundColor: `${token2.trackBgDisabled} !important`
        },
        [`
          ${componentCls}-dot
        `]: {
          backgroundColor: token2.colorBgElevated,
          borderColor: token2.trackBgDisabled,
          boxShadow: "none",
          cursor: "not-allowed"
        },
        [`${componentCls}-handle::after`]: {
          backgroundColor: token2.colorBgElevated,
          cursor: "not-allowed",
          width: handleSize,
          height: handleSize,
          boxShadow: `0 0 0 ${unit(handleLineWidth)} ${handleColorDisabled}`,
          insetInlineStart: 0,
          insetBlockStart: 0
        },
        [`
          ${componentCls}-mark-text,
          ${componentCls}-dot
        `]: {
          cursor: `not-allowed !important`
        }
      },
      [`&-tooltip ${antCls}-tooltip-inner`]: {
        minWidth: "unset"
      }
    })
  };
};
var genDirectionStyle = (token2, horizontal) => {
  const {
    componentCls,
    railSize,
    handleSize,
    dotSize,
    marginFull,
    calc
  } = token2;
  const railPadding = horizontal ? "paddingBlock" : "paddingInline";
  const full = horizontal ? "width" : "height";
  const part = horizontal ? "height" : "width";
  const handlePos = horizontal ? "insetBlockStart" : "insetInlineStart";
  const markInset = horizontal ? "top" : "insetInlineStart";
  const handlePosSize = calc(railSize).mul(3).sub(handleSize).div(2).equal();
  const draggableBorderSize = calc(handleSize).sub(railSize).div(2).equal();
  const draggableBorder = horizontal ? {
    borderWidth: `${unit(draggableBorderSize)} 0`,
    transform: `translateY(${unit(calc(draggableBorderSize).mul(-1).equal())})`
  } : {
    borderWidth: `0 ${unit(draggableBorderSize)}`,
    transform: `translateX(${unit(token2.calc(draggableBorderSize).mul(-1).equal())})`
  };
  return {
    [railPadding]: railSize,
    [part]: calc(railSize).mul(3).equal(),
    [`${componentCls}-rail`]: {
      [full]: "100%",
      [part]: railSize
    },
    [`${componentCls}-track,${componentCls}-tracks`]: {
      [part]: railSize
    },
    [`${componentCls}-track-draggable`]: Object.assign({}, draggableBorder),
    [`${componentCls}-handle`]: {
      [handlePos]: handlePosSize
    },
    [`${componentCls}-mark`]: {
      // Reset all
      insetInlineStart: 0,
      top: 0,
      // https://github.com/ant-design/ant-design/issues/43731
      [markInset]: calc(railSize).mul(3).add(horizontal ? 0 : marginFull).equal(),
      [full]: "100%"
    },
    [`${componentCls}-step`]: {
      // Reset all
      insetInlineStart: 0,
      top: 0,
      [markInset]: railSize,
      [full]: "100%",
      [part]: railSize
    },
    [`${componentCls}-dot`]: {
      position: "absolute",
      [handlePos]: calc(railSize).sub(dotSize).div(2).equal()
    }
  };
};
var genHorizontalStyle = (token2) => {
  const {
    componentCls,
    marginPartWithMark
  } = token2;
  return {
    [`${componentCls}-horizontal`]: Object.assign(Object.assign({}, genDirectionStyle(token2, true)), {
      [`&${componentCls}-with-marks`]: {
        marginBottom: marginPartWithMark
      }
    })
  };
};
var genVerticalStyle = (token2) => {
  const {
    componentCls
  } = token2;
  return {
    [`${componentCls}-vertical`]: Object.assign(Object.assign({}, genDirectionStyle(token2, false)), {
      height: "100%"
    })
  };
};
var prepareComponentToken18 = (token2) => {
  const increaseHandleWidth = 1;
  const controlSize = token2.controlHeightLG / 4;
  const controlSizeHover = token2.controlHeightSM / 2;
  const handleLineWidth = token2.lineWidth + increaseHandleWidth;
  const handleLineWidthHover = token2.lineWidth + increaseHandleWidth * 1.5;
  const handleActiveColor = token2.colorPrimary;
  const handleActiveOutlineColor = new FastColor(handleActiveColor).setA(0.2).toRgbString();
  return {
    controlSize,
    railSize: 4,
    handleSize: controlSize,
    handleSizeHover: controlSizeHover,
    dotSize: 8,
    handleLineWidth,
    handleLineWidthHover,
    railBg: token2.colorFillTertiary,
    railHoverBg: token2.colorFillSecondary,
    trackBg: token2.colorPrimaryBorder,
    trackHoverBg: token2.colorPrimaryBorderHover,
    handleColor: token2.colorPrimaryBorder,
    handleActiveColor,
    handleActiveOutlineColor,
    handleColorDisabled: new FastColor(token2.colorTextDisabled).onBackground(token2.colorBgContainer).toHexString(),
    dotBorderColor: token2.colorBorderSecondary,
    dotActiveBorderColor: token2.colorPrimaryBorder,
    trackBgDisabled: token2.colorBgContainerDisabled
  };
};
var style_default23 = genStyleHooks("Slider", (token2) => {
  const sliderToken = merge2(token2, {
    marginPart: token2.calc(token2.controlHeight).sub(token2.controlSize).div(2).equal(),
    marginFull: token2.calc(token2.controlSize).div(2).equal(),
    marginPartWithMark: token2.calc(token2.controlHeightLG).sub(token2.controlSize).equal()
  });
  return [genBaseStyle6(sliderToken), genHorizontalStyle(sliderToken), genVerticalStyle(sliderToken)];
}, prepareComponentToken18);

// ../../node_modules/antd/es/slider/useRafLock.js
var React327 = __toESM(require_react());
function useRafLock() {
  const [state, setState] = React327.useState(false);
  const rafRef = React327.useRef(null);
  const cleanup2 = () => {
    raf_default.cancel(rafRef.current);
  };
  const setDelayState = (nextState) => {
    cleanup2();
    if (nextState) {
      setState(nextState);
    } else {
      rafRef.current = raf_default(() => {
        setState(nextState);
      });
    }
  };
  React327.useEffect(() => cleanup2, []);
  return [state, setDelayState];
}

// ../../node_modules/antd/es/slider/index.js
var __rest34 = function(s, e3) {
  var t2 = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e3.indexOf(p) < 0) t2[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e3.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t2[p[i]] = s[p[i]];
  }
  return t2;
};
function getTipFormatter(tipFormatter, legacyTipFormatter) {
  if (tipFormatter || tipFormatter === null) {
    return tipFormatter;
  }
  if (legacyTipFormatter || legacyTipFormatter === null) {
    return legacyTipFormatter;
  }
  return (val) => typeof val === "number" ? val.toString() : "";
}
var Slider4 = /* @__PURE__ */ import_react110.default.forwardRef((props, ref3) => {
  const {
    prefixCls: customizePrefixCls,
    range: range3,
    className: className2,
    rootClassName,
    style: style2,
    disabled,
    // Deprecated Props
    tooltipPrefixCls: legacyTooltipPrefixCls,
    tipFormatter: legacyTipFormatter,
    tooltipVisible: legacyTooltipVisible,
    getTooltipPopupContainer: legacyGetTooltipPopupContainer,
    tooltipPlacement: legacyTooltipPlacement,
    tooltip = {},
    onChangeComplete,
    classNames: sliderClassNames,
    styles
  } = props, restProps = __rest34(props, ["prefixCls", "range", "className", "rootClassName", "style", "disabled", "tooltipPrefixCls", "tipFormatter", "tooltipVisible", "getTooltipPopupContainer", "tooltipPlacement", "tooltip", "onChangeComplete", "classNames", "styles"]);
  const {
    vertical
  } = props;
  const {
    getPrefixCls,
    direction: contextDirection,
    className: contextClassName,
    style: contextStyle,
    classNames: contextClassNames,
    styles: contextStyles,
    getPopupContainer
  } = useComponentConfig("slider");
  const contextDisabled = import_react110.default.useContext(DisabledContext_default);
  const mergedDisabled = disabled !== null && disabled !== void 0 ? disabled : contextDisabled;
  const {
    handleRender: contextHandleRender,
    direction: internalContextDirection
  } = import_react110.default.useContext(Context_default3);
  const mergedDirection = internalContextDirection || contextDirection;
  const isRTL = mergedDirection === "rtl";
  const [hoverOpen, setHoverOpen] = useRafLock();
  const [focusOpen, setFocusOpen] = useRafLock();
  const tooltipProps = Object.assign({}, tooltip);
  const {
    open: tooltipOpen,
    placement: tooltipPlacement,
    getPopupContainer: getTooltipPopupContainer,
    prefixCls: customizeTooltipPrefixCls,
    formatter: tipFormatter
  } = tooltipProps;
  const lockOpen = tooltipOpen !== null && tooltipOpen !== void 0 ? tooltipOpen : legacyTooltipVisible;
  const activeOpen = (hoverOpen || focusOpen) && lockOpen !== false;
  const mergedTipFormatter = getTipFormatter(tipFormatter, legacyTipFormatter);
  const [dragging, setDragging] = useRafLock();
  const onInternalChangeComplete = (nextValues) => {
    onChangeComplete === null || onChangeComplete === void 0 ? void 0 : onChangeComplete(nextValues);
    setDragging(false);
  };
  const getTooltipPlacement = (placement, vert) => {
    if (placement) {
      return placement;
    }
    if (!vert) {
      return "top";
    }
    return isRTL ? "left" : "right";
  };
  const prefixCls = getPrefixCls("slider", customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = style_default23(prefixCls);
  const rootClassNames = (0, import_classnames121.default)(className2, contextClassName, contextClassNames.root, sliderClassNames === null || sliderClassNames === void 0 ? void 0 : sliderClassNames.root, rootClassName, {
    [`${prefixCls}-rtl`]: isRTL,
    [`${prefixCls}-lock`]: dragging
  }, hashId, cssVarCls);
  if (isRTL && !restProps.vertical) {
    restProps.reverse = !restProps.reverse;
  }
  if (true) {
    const warning6 = devUseWarning("Slider");
    [["tooltipPrefixCls", "prefixCls"], ["getTooltipPopupContainer", "getPopupContainer"], ["tipFormatter", "formatter"], ["tooltipPlacement", "placement"], ["tooltipVisible", "open"]].forEach(([deprecatedName, newName]) => {
      warning6.deprecated(!(deprecatedName in props), deprecatedName, `tooltip.${newName}`);
    });
  }
  import_react110.default.useEffect(() => {
    const onMouseUp = () => {
      raf_default(() => {
        setFocusOpen(false);
      }, 1);
    };
    document.addEventListener("mouseup", onMouseUp);
    return () => {
      document.removeEventListener("mouseup", onMouseUp);
    };
  }, []);
  const useActiveTooltipHandle = range3 && !lockOpen;
  const handleRender = contextHandleRender || ((node2, info) => {
    const {
      index: index3
    } = info;
    const nodeProps = node2.props;
    function proxyEvent(eventName, event, triggerRestPropsEvent) {
      var _a, _b, _c, _d;
      if (triggerRestPropsEvent) {
        (_b = (_a = restProps)[eventName]) === null || _b === void 0 ? void 0 : _b.call(_a, event);
      }
      (_d = (_c = nodeProps)[eventName]) === null || _d === void 0 ? void 0 : _d.call(_c, event);
    }
    const passedProps = Object.assign(Object.assign({}, nodeProps), {
      onMouseEnter: (e3) => {
        setHoverOpen(true);
        proxyEvent("onMouseEnter", e3);
      },
      onMouseLeave: (e3) => {
        setHoverOpen(false);
        proxyEvent("onMouseLeave", e3);
      },
      onMouseDown: (e3) => {
        setFocusOpen(true);
        setDragging(true);
        proxyEvent("onMouseDown", e3);
      },
      onFocus: (e3) => {
        var _a;
        setFocusOpen(true);
        (_a = restProps.onFocus) === null || _a === void 0 ? void 0 : _a.call(restProps, e3);
        proxyEvent("onFocus", e3, true);
      },
      onBlur: (e3) => {
        var _a;
        setFocusOpen(false);
        (_a = restProps.onBlur) === null || _a === void 0 ? void 0 : _a.call(restProps, e3);
        proxyEvent("onBlur", e3, true);
      }
    });
    const cloneNode = /* @__PURE__ */ import_react110.default.cloneElement(node2, passedProps);
    const open2 = (!!lockOpen || activeOpen) && mergedTipFormatter !== null;
    if (!useActiveTooltipHandle) {
      return /* @__PURE__ */ import_react110.default.createElement(SliderTooltip_default, Object.assign({}, tooltipProps, {
        prefixCls: getPrefixCls("tooltip", customizeTooltipPrefixCls !== null && customizeTooltipPrefixCls !== void 0 ? customizeTooltipPrefixCls : legacyTooltipPrefixCls),
        title: mergedTipFormatter ? mergedTipFormatter(info.value) : "",
        value: info.value,
        open: open2,
        placement: getTooltipPlacement(tooltipPlacement !== null && tooltipPlacement !== void 0 ? tooltipPlacement : legacyTooltipPlacement, vertical),
        key: index3,
        classNames: {
          root: `${prefixCls}-tooltip`
        },
        getPopupContainer: getTooltipPopupContainer || legacyGetTooltipPopupContainer || getPopupContainer
      }), cloneNode);
    }
    return cloneNode;
  });
  const activeHandleRender = useActiveTooltipHandle ? (handle, info) => {
    const cloneNode = /* @__PURE__ */ import_react110.default.cloneElement(handle, {
      style: Object.assign(Object.assign({}, handle.props.style), {
        visibility: "hidden"
      })
    });
    return /* @__PURE__ */ import_react110.default.createElement(SliderTooltip_default, Object.assign({}, tooltipProps, {
      prefixCls: getPrefixCls("tooltip", customizeTooltipPrefixCls !== null && customizeTooltipPrefixCls !== void 0 ? customizeTooltipPrefixCls : legacyTooltipPrefixCls),
      title: mergedTipFormatter ? mergedTipFormatter(info.value) : "",
      open: mergedTipFormatter !== null && activeOpen,
      placement: getTooltipPlacement(tooltipPlacement !== null && tooltipPlacement !== void 0 ? tooltipPlacement : legacyTooltipPlacement, vertical),
      key: "tooltip",
      classNames: {
        root: `${prefixCls}-tooltip`
      },
      getPopupContainer: getTooltipPopupContainer || legacyGetTooltipPopupContainer || getPopupContainer,
      draggingDelete: info.draggingDelete
    }), cloneNode);
  } : void 0;
  const rootStyle = Object.assign(Object.assign(Object.assign(Object.assign({}, contextStyles.root), contextStyle), styles === null || styles === void 0 ? void 0 : styles.root), style2);
  const mergedTracks = Object.assign(Object.assign({}, contextStyles.tracks), styles === null || styles === void 0 ? void 0 : styles.tracks);
  const mergedTracksClassNames = (0, import_classnames121.default)(contextClassNames.tracks, sliderClassNames === null || sliderClassNames === void 0 ? void 0 : sliderClassNames.tracks);
  return wrapCSSVar(
    // @ts-ignore
    /* @__PURE__ */ import_react110.default.createElement(es_default21, Object.assign({}, restProps, {
      classNames: Object.assign({
        handle: (0, import_classnames121.default)(contextClassNames.handle, sliderClassNames === null || sliderClassNames === void 0 ? void 0 : sliderClassNames.handle),
        rail: (0, import_classnames121.default)(contextClassNames.rail, sliderClassNames === null || sliderClassNames === void 0 ? void 0 : sliderClassNames.rail),
        track: (0, import_classnames121.default)(contextClassNames.track, sliderClassNames === null || sliderClassNames === void 0 ? void 0 : sliderClassNames.track)
      }, mergedTracksClassNames ? {
        tracks: mergedTracksClassNames
      } : {}),
      styles: Object.assign({
        handle: Object.assign(Object.assign({}, contextStyles.handle), styles === null || styles === void 0 ? void 0 : styles.handle),
        rail: Object.assign(Object.assign({}, contextStyles.rail), styles === null || styles === void 0 ? void 0 : styles.rail),
        track: Object.assign(Object.assign({}, contextStyles.track), styles === null || styles === void 0 ? void 0 : styles.track)
      }, Object.keys(mergedTracks).length ? {
        tracks: mergedTracks
      } : {}),
      step: restProps.step,
      range: range3,
      className: rootClassNames,
      style: rootStyle,
      disabled: mergedDisabled,
      ref: ref3,
      prefixCls,
      handleRender,
      activeHandleRender,
      onChangeComplete: onInternalChangeComplete
    }))
  );
});
if (true) {
  Slider4.displayName = "Slider";
}
var slider_default = Slider4;

// ../../node_modules/antd/es/date-picker/generatePicker/generateRangePicker.js
var React336 = __toESM(require_react());
var import_react112 = __toESM(require_react());

// ../../node_modules/@ant-design/icons/es/icons/CalendarOutlined.js
var React329 = __toESM(require_react());

// ../../node_modules/@ant-design/icons-svg/es/asn/CalendarOutlined.js
var CalendarOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V460h656v380zM184 392V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v136H184z" } }] }, "name": "calendar", "theme": "outlined" };
var CalendarOutlined_default = CalendarOutlined;

// ../../node_modules/@ant-design/icons/es/icons/CalendarOutlined.js
var CalendarOutlined2 = function CalendarOutlined3(props, ref3) {
  return /* @__PURE__ */ React329.createElement(AntdIcon_default, _extends({}, props, {
    ref: ref3,
    icon: CalendarOutlined_default
  }));
};
var RefIcon16 = /* @__PURE__ */ React329.forwardRef(CalendarOutlined2);
if (true) {
  RefIcon16.displayName = "CalendarOutlined";
}
var CalendarOutlined_default2 = RefIcon16;

// ../../node_modules/@ant-design/icons/es/icons/ClockCircleOutlined.js
var React330 = __toESM(require_react());

// ../../node_modules/@ant-design/icons-svg/es/asn/ClockCircleOutlined.js
var ClockCircleOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }, { "tag": "path", "attrs": { "d": "M686.7 638.6L544.1 535.5V288c0-4.4-3.6-8-8-8H488c-4.4 0-8 3.6-8 8v275.4c0 2.6 1.2 5 3.3 6.5l165.4 120.6c3.6 2.6 8.6 1.8 11.2-1.7l28.6-39c2.6-3.7 1.8-8.7-1.8-11.2z" } }] }, "name": "clock-circle", "theme": "outlined" };
var ClockCircleOutlined_default = ClockCircleOutlined;

// ../../node_modules/@ant-design/icons/es/icons/ClockCircleOutlined.js
var ClockCircleOutlined2 = function ClockCircleOutlined3(props, ref3) {
  return /* @__PURE__ */ React330.createElement(AntdIcon_default, _extends({}, props, {
    ref: ref3,
    icon: ClockCircleOutlined_default
  }));
};
var RefIcon17 = /* @__PURE__ */ React330.forwardRef(ClockCircleOutlined2);
if (true) {
  RefIcon17.displayName = "ClockCircleOutlined";
}
var ClockCircleOutlined_default2 = RefIcon17;

// ../../node_modules/@ant-design/icons/es/icons/SwapRightOutlined.js
var React331 = __toESM(require_react());

// ../../node_modules/@ant-design/icons-svg/es/asn/SwapRightOutlined.js
var SwapRightOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M873.1 596.2l-164-208A32 32 0 00684 376h-64.8c-6.7 0-10.4 7.7-6.3 13l144.3 183H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h695.9c26.8 0 41.7-30.8 25.2-51.8z" } }] }, "name": "swap-right", "theme": "outlined" };
var SwapRightOutlined_default = SwapRightOutlined;

// ../../node_modules/@ant-design/icons/es/icons/SwapRightOutlined.js
var SwapRightOutlined2 = function SwapRightOutlined3(props, ref3) {
  return /* @__PURE__ */ React331.createElement(AntdIcon_default, _extends({}, props, {
    ref: ref3,
    icon: SwapRightOutlined_default
  }));
};
var RefIcon18 = /* @__PURE__ */ React331.forwardRef(SwapRightOutlined2);
if (true) {
  RefIcon18.displayName = "SwapRightOutlined";
}
var SwapRightOutlined_default2 = RefIcon18;

// ../../node_modules/antd/es/date-picker/generatePicker/generateRangePicker.js
var import_classnames124 = __toESM(require_classnames());

// ../../node_modules/antd/es/date-picker/util.js
var React332 = __toESM(require_react());
function getPlaceholder(locale6, picker, customizePlaceholder) {
  if (customizePlaceholder !== void 0) {
    return customizePlaceholder;
  }
  if (picker === "year" && locale6.lang.yearPlaceholder) {
    return locale6.lang.yearPlaceholder;
  }
  if (picker === "quarter" && locale6.lang.quarterPlaceholder) {
    return locale6.lang.quarterPlaceholder;
  }
  if (picker === "month" && locale6.lang.monthPlaceholder) {
    return locale6.lang.monthPlaceholder;
  }
  if (picker === "week" && locale6.lang.weekPlaceholder) {
    return locale6.lang.weekPlaceholder;
  }
  if (picker === "time" && locale6.timePickerLocale.placeholder) {
    return locale6.timePickerLocale.placeholder;
  }
  return locale6.lang.placeholder;
}
function getRangePlaceholder(locale6, picker, customizePlaceholder) {
  if (customizePlaceholder !== void 0) {
    return customizePlaceholder;
  }
  if (picker === "year" && locale6.lang.yearPlaceholder) {
    return locale6.lang.rangeYearPlaceholder;
  }
  if (picker === "quarter" && locale6.lang.quarterPlaceholder) {
    return locale6.lang.rangeQuarterPlaceholder;
  }
  if (picker === "month" && locale6.lang.monthPlaceholder) {
    return locale6.lang.rangeMonthPlaceholder;
  }
  if (picker === "week" && locale6.lang.weekPlaceholder) {
    return locale6.lang.rangeWeekPlaceholder;
  }
  if (picker === "time" && locale6.timePickerLocale.placeholder) {
    return locale6.timePickerLocale.rangePlaceholder;
  }
  return locale6.lang.rangePlaceholder;
}
function useIcons2(props, prefixCls) {
  const {
    allowClear = true
  } = props;
  const {
    clearIcon,
    removeIcon
  } = useIcons(Object.assign(Object.assign({}, props), {
    prefixCls,
    componentName: "DatePicker"
  }));
  const mergedAllowClear = React332.useMemo(() => {
    if (allowClear === false) {
      return false;
    }
    const allowClearConfig = allowClear === true ? {} : allowClear;
    return Object.assign({
      clearIcon
    }, allowClearConfig);
  }, [allowClear, clearIcon]);
  return [mergedAllowClear, removeIcon];
}

// ../../node_modules/antd/es/date-picker/generatePicker/constant.js
var [WEEK, WEEKPICKER] = ["week", "WeekPicker"];
var [MONTH, MONTHPICKER] = ["month", "MonthPicker"];
var [YEAR, YEARPICKER] = ["year", "YearPicker"];
var [QUARTER, QUARTERPICKER] = ["quarter", "QuarterPicker"];
var [TIME, TIMEPICKER] = ["time", "TimePicker"];

// ../../node_modules/antd/es/date-picker/generatePicker/useComponents.js
var import_react111 = __toESM(require_react());

// ../../node_modules/antd/es/date-picker/PickerButton.js
var React333 = __toESM(require_react());
var PickerButton = (props) => /* @__PURE__ */ React333.createElement(button_default2, Object.assign({
  size: "small",
  type: "primary"
}, props));
var PickerButton_default = PickerButton;

// ../../node_modules/antd/es/date-picker/generatePicker/useComponents.js
function useComponents(components) {
  return (0, import_react111.useMemo)(() => Object.assign({
    button: PickerButton_default
  }, components), [components]);
}

// ../../node_modules/antd/es/date-picker/hooks/useMergedPickerSemantic.js
var React335 = __toESM(require_react());
var import_classnames123 = __toESM(require_classnames());

// ../../node_modules/antd/es/_util/hooks/useMergeSemantic/index.js
var React334 = __toESM(require_react());
var import_classnames122 = __toESM(require_classnames());
function mergeClassNames(schema, ...classNames186) {
  const mergedSchema = schema || {};
  return classNames186.reduce((acc, cur) => {
    Object.keys(cur || {}).forEach((key2) => {
      const keySchema = mergedSchema[key2];
      const curVal = cur[key2];
      if (keySchema && typeof keySchema === "object") {
        if (curVal && typeof curVal === "object") {
          acc[key2] = mergeClassNames(keySchema, acc[key2], curVal);
        } else {
          const {
            _default: defaultField
          } = keySchema;
          acc[key2] = acc[key2] || {};
          acc[key2][defaultField] = (0, import_classnames122.default)(acc[key2][defaultField], curVal);
        }
      } else {
        acc[key2] = (0, import_classnames122.default)(acc[key2], curVal);
      }
    });
    return acc;
  }, {});
}
function useSemanticClassNames(schema, ...classNames186) {
  return React334.useMemo(() => mergeClassNames.apply(void 0, [schema].concat(classNames186)), [classNames186]);
}
function useSemanticStyles(...styles) {
  return React334.useMemo(() => {
    return styles.reduce((acc, cur = {}) => {
      Object.keys(cur).forEach((key2) => {
        acc[key2] = Object.assign(Object.assign({}, acc[key2]), cur[key2]);
      });
      return acc;
    }, {});
  }, [styles]);
}
function fillObjectBySchema(obj, schema) {
  const newObj = Object.assign({}, obj);
  Object.keys(schema).forEach((key2) => {
    if (key2 !== "_default") {
      const nestSchema = schema[key2];
      const nextValue = newObj[key2] || {};
      newObj[key2] = nestSchema ? fillObjectBySchema(nextValue, nestSchema) : nextValue;
    }
  });
  return newObj;
}
function useMergeSemantic(classNamesList, stylesList, schema) {
  const mergedClassNames = useSemanticClassNames.apply(void 0, [schema].concat(_toConsumableArray(classNamesList)));
  const mergedStyles = useSemanticStyles.apply(void 0, _toConsumableArray(stylesList));
  return React334.useMemo(() => {
    return [fillObjectBySchema(mergedClassNames, schema), fillObjectBySchema(mergedStyles, schema)];
  }, [mergedClassNames, mergedStyles]);
}

// ../../node_modules/antd/es/date-picker/hooks/useMergedPickerSemantic.js
var useMergedPickerSemantic = (pickerType, classNames186, styles, popupClassName, popupStyle) => {
  const {
    classNames: contextClassNames,
    styles: contextStyles
  } = useComponentConfig(pickerType);
  const [mergedClassNames, mergedStyles] = useMergeSemantic([contextClassNames, classNames186], [contextStyles, styles], {
    popup: {
      _default: "root"
    }
  });
  return React335.useMemo(() => {
    var _a, _b;
    const filledClassNames = Object.assign(Object.assign({}, mergedClassNames), {
      popup: Object.assign(Object.assign({}, mergedClassNames.popup), {
        root: (0, import_classnames123.default)((_a = mergedClassNames.popup) === null || _a === void 0 ? void 0 : _a.root, popupClassName)
      })
    });
    const filledStyles = Object.assign(Object.assign({}, mergedStyles), {
      popup: Object.assign(Object.assign({}, mergedStyles.popup), {
        root: Object.assign(Object.assign({}, (_b = mergedStyles.popup) === null || _b === void 0 ? void 0 : _b.root), popupStyle)
      })
    });
    return [filledClassNames, filledStyles];
  }, [mergedClassNames, mergedStyles, popupClassName, popupStyle]);
};
var useMergedPickerSemantic_default = useMergedPickerSemantic;

// ../../node_modules/antd/es/date-picker/generatePicker/generateRangePicker.js
var __rest35 = function(s, e3) {
  var t2 = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e3.indexOf(p) < 0) t2[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e3.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t2[p[i]] = s[p[i]];
  }
  return t2;
};
var generateRangePicker = (generateConfig2) => {
  const RangePicker4 = /* @__PURE__ */ (0, import_react112.forwardRef)((props, ref3) => {
    var _a;
    const {
      prefixCls: customizePrefixCls,
      getPopupContainer: customGetPopupContainer,
      components,
      className: className2,
      style: style2,
      placement,
      size: customizeSize,
      disabled: customDisabled,
      bordered = true,
      placeholder,
      popupStyle,
      popupClassName,
      dropdownClassName,
      status: customStatus,
      rootClassName,
      variant: customVariant,
      picker,
      styles,
      classNames: classNames186
    } = props, restProps = __rest35(props, ["prefixCls", "getPopupContainer", "components", "className", "style", "placement", "size", "disabled", "bordered", "placeholder", "popupStyle", "popupClassName", "dropdownClassName", "status", "rootClassName", "variant", "picker", "styles", "classNames"]);
    const pickerType = picker === TIME ? "timePicker" : "datePicker";
    const innerRef = React336.useRef(null);
    const {
      getPrefixCls,
      direction,
      getPopupContainer,
      rangePicker
    } = (0, import_react112.useContext)(ConfigContext);
    const prefixCls = getPrefixCls("picker", customizePrefixCls);
    const {
      compactSize,
      compactItemClassnames
    } = useCompactItemContext(prefixCls, direction);
    const rootPrefixCls = getPrefixCls();
    const [variant, enableVariantCls] = useVariants_default("rangePicker", customVariant, bordered);
    const rootCls = useCSSVarCls_default(prefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = style_default17(prefixCls, rootCls);
    if (true) {
      const warning6 = devUseWarning("DatePicker.RangePicker");
      const deprecatedProps = {
        dropdownClassName: "classNames.popup.root",
        popupClassName: "classNames.popup.root",
        popupStyle: "styles.popup.root",
        bordered: "variant",
        onSelect: "onCalendarChange"
      };
      Object.entries(deprecatedProps).forEach(([oldProp, newProp]) => {
        warning6.deprecated(!(oldProp in props), oldProp, newProp);
      });
    }
    const [mergedClassNames, mergedStyles] = useMergedPickerSemantic_default(pickerType, classNames186, styles, popupClassName || dropdownClassName, popupStyle);
    const [mergedAllowClear] = useIcons2(props, prefixCls);
    const mergedComponents = useComponents(components);
    const mergedSize = useSize_default((ctx) => {
      var _a2;
      return (_a2 = customizeSize !== null && customizeSize !== void 0 ? customizeSize : compactSize) !== null && _a2 !== void 0 ? _a2 : ctx;
    });
    const disabled = React336.useContext(DisabledContext_default);
    const mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
    const formItemContext = (0, import_react112.useContext)(FormItemInputContext);
    const {
      hasFeedback,
      status: contextStatus,
      feedbackIcon
    } = formItemContext;
    const suffixNode = /* @__PURE__ */ React336.createElement(React336.Fragment, null, picker === TIME ? /* @__PURE__ */ React336.createElement(ClockCircleOutlined_default2, null) : /* @__PURE__ */ React336.createElement(CalendarOutlined_default2, null), hasFeedback && feedbackIcon);
    (0, import_react112.useImperativeHandle)(ref3, () => innerRef.current);
    const [contextLocale] = useLocale_default("Calendar", en_US_default4);
    const locale6 = Object.assign(Object.assign({}, contextLocale), props.locale);
    const [zIndex] = useZIndex("DatePicker", (_a = mergedStyles.popup.root) === null || _a === void 0 ? void 0 : _a.zIndex);
    return wrapCSSVar(/* @__PURE__ */ React336.createElement(ContextIsolator_default, {
      space: true
    }, /* @__PURE__ */ React336.createElement(RangePicker_default, Object.assign({
      separator: /* @__PURE__ */ React336.createElement("span", {
        "aria-label": "to",
        className: `${prefixCls}-separator`
      }, /* @__PURE__ */ React336.createElement(SwapRightOutlined_default2, null)),
      disabled: mergedDisabled,
      ref: innerRef,
      placement,
      placeholder: getRangePlaceholder(locale6, picker, placeholder),
      suffixIcon: suffixNode,
      prevIcon: /* @__PURE__ */ React336.createElement("span", {
        className: `${prefixCls}-prev-icon`
      }),
      nextIcon: /* @__PURE__ */ React336.createElement("span", {
        className: `${prefixCls}-next-icon`
      }),
      superPrevIcon: /* @__PURE__ */ React336.createElement("span", {
        className: `${prefixCls}-super-prev-icon`
      }),
      superNextIcon: /* @__PURE__ */ React336.createElement("span", {
        className: `${prefixCls}-super-next-icon`
      }),
      transitionName: `${rootPrefixCls}-slide-up`,
      picker
    }, restProps, {
      className: (0, import_classnames124.default)({
        [`${prefixCls}-${mergedSize}`]: mergedSize,
        [`${prefixCls}-${variant}`]: enableVariantCls
      }, getStatusClassNames(prefixCls, getMergedStatus(contextStatus, customStatus), hasFeedback), hashId, compactItemClassnames, className2, rangePicker === null || rangePicker === void 0 ? void 0 : rangePicker.className, cssVarCls, rootCls, rootClassName, mergedClassNames.root),
      style: Object.assign(Object.assign(Object.assign({}, rangePicker === null || rangePicker === void 0 ? void 0 : rangePicker.style), style2), mergedStyles.root),
      locale: locale6.lang,
      prefixCls,
      getPopupContainer: customGetPopupContainer || getPopupContainer,
      generateConfig: generateConfig2,
      components: mergedComponents,
      direction,
      classNames: {
        popup: (0, import_classnames124.default)(hashId, cssVarCls, rootCls, rootClassName, mergedClassNames.popup.root)
      },
      styles: {
        popup: Object.assign(Object.assign({}, mergedStyles.popup.root), {
          zIndex
        })
      },
      allowClear: mergedAllowClear
    }))));
  });
  if (true) {
    RangePicker4.displayName = "RangePicker";
  }
  return RangePicker4;
};
var generateRangePicker_default = generateRangePicker;

// ../../node_modules/antd/es/date-picker/generatePicker/generateSinglePicker.js
var React337 = __toESM(require_react());
var import_react113 = __toESM(require_react());
var import_classnames125 = __toESM(require_classnames());
var __rest36 = function(s, e3) {
  var t2 = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e3.indexOf(p) < 0) t2[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e3.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t2[p[i]] = s[p[i]];
  }
  return t2;
};
var generatePicker = (generateConfig2) => {
  const getPicker = (picker, displayName) => {
    const consumerName = displayName === TIMEPICKER ? "timePicker" : "datePicker";
    const Picker4 = /* @__PURE__ */ (0, import_react113.forwardRef)((props, ref3) => {
      var _a;
      const {
        prefixCls: customizePrefixCls,
        getPopupContainer: customizeGetPopupContainer,
        components,
        style: style2,
        className: className2,
        rootClassName,
        size: customizeSize,
        bordered,
        placement,
        placeholder,
        popupStyle,
        popupClassName,
        dropdownClassName,
        disabled: customDisabled,
        status: customStatus,
        variant: customVariant,
        onCalendarChange,
        styles,
        classNames: classNames186
      } = props, restProps = __rest36(props, ["prefixCls", "getPopupContainer", "components", "style", "className", "rootClassName", "size", "bordered", "placement", "placeholder", "popupStyle", "popupClassName", "dropdownClassName", "disabled", "status", "variant", "onCalendarChange", "styles", "classNames"]);
      const {
        getPrefixCls,
        direction,
        getPopupContainer,
        // Consume different styles according to different names
        [consumerName]: consumerStyle
      } = (0, import_react113.useContext)(ConfigContext);
      const prefixCls = getPrefixCls("picker", customizePrefixCls);
      const {
        compactSize,
        compactItemClassnames
      } = useCompactItemContext(prefixCls, direction);
      const innerRef = React337.useRef(null);
      const [variant, enableVariantCls] = useVariants_default("datePicker", customVariant, bordered);
      const rootCls = useCSSVarCls_default(prefixCls);
      const [wrapCSSVar, hashId, cssVarCls] = style_default17(prefixCls, rootCls);
      (0, import_react113.useImperativeHandle)(ref3, () => innerRef.current);
      const additionalProps = {
        showToday: true
      };
      const mergedPicker = picker || props.picker;
      const rootPrefixCls = getPrefixCls();
      const {
        onSelect,
        multiple
      } = restProps;
      const hasLegacyOnSelect = onSelect && picker === "time" && !multiple;
      const onInternalCalendarChange = (date4, dateStr, info) => {
        onCalendarChange === null || onCalendarChange === void 0 ? void 0 : onCalendarChange(date4, dateStr, info);
        if (hasLegacyOnSelect) {
          onSelect(date4);
        }
      };
      if (true) {
        const warning6 = devUseWarning(displayName || "DatePicker");
        true ? warning6(picker !== "quarter", "deprecated", `DatePicker.${displayName} is legacy usage. Please use DatePicker[picker='${picker}'] directly.`) : void 0;
        const deprecatedProps = {
          dropdownClassName: "classNames.popup.root",
          popupClassName: "classNames.popup.root",
          popupStyle: "styles.popup.root",
          bordered: "variant",
          onSelect: "onCalendarChange"
        };
        Object.entries(deprecatedProps).forEach(([oldProp, newProp]) => {
          warning6.deprecated(!(oldProp in props), oldProp, newProp);
        });
      }
      const [mergedClassNames, mergedStyles] = useMergedPickerSemantic_default(consumerName, classNames186, styles, popupClassName || dropdownClassName, popupStyle);
      const [mergedAllowClear, removeIcon] = useIcons2(props, prefixCls);
      const mergedComponents = useComponents(components);
      const mergedSize = useSize_default((ctx) => {
        var _a2;
        return (_a2 = customizeSize !== null && customizeSize !== void 0 ? customizeSize : compactSize) !== null && _a2 !== void 0 ? _a2 : ctx;
      });
      const disabled = React337.useContext(DisabledContext_default);
      const mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
      const formItemContext = (0, import_react113.useContext)(FormItemInputContext);
      const {
        hasFeedback,
        status: contextStatus,
        feedbackIcon
      } = formItemContext;
      const suffixNode = /* @__PURE__ */ React337.createElement(React337.Fragment, null, mergedPicker === "time" ? /* @__PURE__ */ React337.createElement(ClockCircleOutlined_default2, null) : /* @__PURE__ */ React337.createElement(CalendarOutlined_default2, null), hasFeedback && feedbackIcon);
      const [contextLocale] = useLocale_default("DatePicker", en_US_default4);
      const locale6 = Object.assign(Object.assign({}, contextLocale), props.locale);
      const [zIndex] = useZIndex("DatePicker", (_a = mergedStyles.popup.root) === null || _a === void 0 ? void 0 : _a.zIndex);
      return wrapCSSVar(/* @__PURE__ */ React337.createElement(ContextIsolator_default, {
        space: true
      }, /* @__PURE__ */ React337.createElement(es_default15, Object.assign({
        ref: innerRef,
        placeholder: getPlaceholder(locale6, mergedPicker, placeholder),
        suffixIcon: suffixNode,
        placement,
        prevIcon: /* @__PURE__ */ React337.createElement("span", {
          className: `${prefixCls}-prev-icon`
        }),
        nextIcon: /* @__PURE__ */ React337.createElement("span", {
          className: `${prefixCls}-next-icon`
        }),
        superPrevIcon: /* @__PURE__ */ React337.createElement("span", {
          className: `${prefixCls}-super-prev-icon`
        }),
        superNextIcon: /* @__PURE__ */ React337.createElement("span", {
          className: `${prefixCls}-super-next-icon`
        }),
        transitionName: `${rootPrefixCls}-slide-up`,
        picker,
        onCalendarChange: onInternalCalendarChange
      }, additionalProps, restProps, {
        locale: locale6.lang,
        className: (0, import_classnames125.default)({
          [`${prefixCls}-${mergedSize}`]: mergedSize,
          [`${prefixCls}-${variant}`]: enableVariantCls
        }, getStatusClassNames(prefixCls, getMergedStatus(contextStatus, customStatus), hasFeedback), hashId, compactItemClassnames, consumerStyle === null || consumerStyle === void 0 ? void 0 : consumerStyle.className, className2, cssVarCls, rootCls, rootClassName, mergedClassNames.root),
        style: Object.assign(Object.assign(Object.assign({}, consumerStyle === null || consumerStyle === void 0 ? void 0 : consumerStyle.style), style2), mergedStyles.root),
        prefixCls,
        getPopupContainer: customizeGetPopupContainer || getPopupContainer,
        generateConfig: generateConfig2,
        components: mergedComponents,
        direction,
        disabled: mergedDisabled,
        classNames: {
          popup: (0, import_classnames125.default)(hashId, cssVarCls, rootCls, rootClassName, mergedClassNames.popup.root)
        },
        styles: {
          popup: Object.assign(Object.assign({}, mergedStyles.popup.root), {
            zIndex
          })
        },
        allowClear: mergedAllowClear,
        removeIcon
      }))));
    });
    if (displayName) {
      Picker4.displayName = displayName;
    }
    return Picker4;
  };
  const DatePicker2 = getPicker();
  const WeekPicker = getPicker(WEEK, WEEKPICKER);
  const MonthPicker = getPicker(MONTH, MONTHPICKER);
  const YearPicker = getPicker(YEAR, YEARPICKER);
  const QuarterPicker = getPicker(QUARTER, QUARTERPICKER);
  const TimePicker2 = getPicker(TIME, TIMEPICKER);
  return {
    DatePicker: DatePicker2,
    WeekPicker,
    MonthPicker,
    YearPicker,
    TimePicker: TimePicker2,
    QuarterPicker
  };
};
var generateSinglePicker_default = generatePicker;

// ../../node_modules/antd/es/date-picker/generatePicker/index.js
var generatePicker2 = (generateConfig2) => {
  const {
    DatePicker: DatePicker2,
    WeekPicker,
    MonthPicker,
    YearPicker,
    TimePicker: TimePicker2,
    QuarterPicker
  } = generateSinglePicker_default(generateConfig2);
  const RangePicker4 = generateRangePicker_default(generateConfig2);
  const MergedDatePicker = DatePicker2;
  MergedDatePicker.WeekPicker = WeekPicker;
  MergedDatePicker.MonthPicker = MonthPicker;
  MergedDatePicker.YearPicker = YearPicker;
  MergedDatePicker.RangePicker = RangePicker4;
  MergedDatePicker.TimePicker = TimePicker2;
  MergedDatePicker.QuarterPicker = QuarterPicker;
  if (true) {
    MergedDatePicker.displayName = "DatePicker";
  }
  return MergedDatePicker;
};
var generatePicker_default = generatePicker2;

// ../../node_modules/antd/es/drawer/index.js
var React343 = __toESM(require_react());
var import_classnames129 = __toESM(require_classnames());

// ../../node_modules/rc-drawer/es/Drawer.js
var React341 = __toESM(require_react());

// ../../node_modules/rc-drawer/es/context.js
var React338 = __toESM(require_react());
var DrawerContext = /* @__PURE__ */ React338.createContext(null);
var RefContext2 = /* @__PURE__ */ React338.createContext({});
var context_default6 = DrawerContext;

// ../../node_modules/rc-drawer/es/DrawerPopup.js
var import_classnames127 = __toESM(require_classnames());
var React340 = __toESM(require_react());

// ../../node_modules/rc-drawer/es/DrawerPanel.js
var import_classnames126 = __toESM(require_classnames());
var React339 = __toESM(require_react());
var _excluded54 = ["prefixCls", "className", "containerRef"];
var DrawerPanel = function DrawerPanel2(props) {
  var prefixCls = props.prefixCls, className2 = props.className, containerRef = props.containerRef, restProps = _objectWithoutProperties(props, _excluded54);
  var _React$useContext = React339.useContext(RefContext2), panelRef = _React$useContext.panel;
  var mergedRef = useComposeRef(panelRef, containerRef);
  return /* @__PURE__ */ React339.createElement("div", _extends({
    className: (0, import_classnames126.default)("".concat(prefixCls, "-content"), className2),
    role: "dialog",
    ref: mergedRef
  }, pickAttrs(props, {
    aria: true
  }), {
    "aria-modal": "true"
  }, restProps));
};
if (true) {
  DrawerPanel.displayName = "DrawerPanel";
}
var DrawerPanel_default = DrawerPanel;

// ../../node_modules/rc-drawer/es/util.js
function parseWidthHeight(value) {
  if (typeof value === "string" && String(Number(value)) === value) {
    warning_default(false, "Invalid value type of `width` or `height` which should be number type instead.");
    return Number(value);
  }
  return value;
}
function warnCheck(props) {
  warning_default(!("wrapperClassName" in props), "'wrapperClassName' is removed. Please use 'rootClassName' instead.");
  warning_default(canUseDom() || !props.open, "Drawer with 'open' in SSR is not work since no place to createPortal. Please move to 'useEffect' instead.");
}

// ../../node_modules/rc-drawer/es/DrawerPopup.js
var sentinelStyle2 = {
  width: 0,
  height: 0,
  overflow: "hidden",
  outline: "none",
  position: "absolute"
};
function DrawerPopup(props, ref3) {
  var _ref, _pushConfig$distance, _pushConfig;
  var prefixCls = props.prefixCls, open2 = props.open, placement = props.placement, inline2 = props.inline, push = props.push, forceRender = props.forceRender, autoFocus = props.autoFocus, keyboard = props.keyboard, drawerClassNames = props.classNames, rootClassName = props.rootClassName, rootStyle = props.rootStyle, zIndex = props.zIndex, className2 = props.className, id = props.id, style2 = props.style, motion2 = props.motion, width = props.width, height = props.height, children = props.children, mask = props.mask, maskClosable = props.maskClosable, maskMotion = props.maskMotion, maskClassName = props.maskClassName, maskStyle = props.maskStyle, afterOpenChange = props.afterOpenChange, onClose = props.onClose, onMouseEnter = props.onMouseEnter, onMouseOver = props.onMouseOver, onMouseLeave = props.onMouseLeave, onClick = props.onClick, onKeyDown2 = props.onKeyDown, onKeyUp = props.onKeyUp, styles = props.styles, drawerRender = props.drawerRender;
  var panelRef = React340.useRef();
  var sentinelStartRef = React340.useRef();
  var sentinelEndRef = React340.useRef();
  React340.useImperativeHandle(ref3, function() {
    return panelRef.current;
  });
  var onPanelKeyDown = function onPanelKeyDown2(event) {
    var keyCode = event.keyCode, shiftKey = event.shiftKey;
    switch (keyCode) {
      // Tab active
      case KeyCode_default.TAB: {
        if (keyCode === KeyCode_default.TAB) {
          if (!shiftKey && document.activeElement === sentinelEndRef.current) {
            var _sentinelStartRef$cur;
            (_sentinelStartRef$cur = sentinelStartRef.current) === null || _sentinelStartRef$cur === void 0 || _sentinelStartRef$cur.focus({
              preventScroll: true
            });
          } else if (shiftKey && document.activeElement === sentinelStartRef.current) {
            var _sentinelEndRef$curre;
            (_sentinelEndRef$curre = sentinelEndRef.current) === null || _sentinelEndRef$curre === void 0 || _sentinelEndRef$curre.focus({
              preventScroll: true
            });
          }
        }
        break;
      }
      // Close
      case KeyCode_default.ESC: {
        if (onClose && keyboard) {
          event.stopPropagation();
          onClose(event);
        }
        break;
      }
    }
  };
  React340.useEffect(function() {
    if (open2 && autoFocus) {
      var _panelRef$current;
      (_panelRef$current = panelRef.current) === null || _panelRef$current === void 0 || _panelRef$current.focus({
        preventScroll: true
      });
    }
  }, [open2]);
  var _React$useState = React340.useState(false), _React$useState2 = _slicedToArray(_React$useState, 2), pushed = _React$useState2[0], setPushed = _React$useState2[1];
  var parentContext = React340.useContext(context_default6);
  var pushConfig;
  if (typeof push === "boolean") {
    pushConfig = push ? {} : {
      distance: 0
    };
  } else {
    pushConfig = push || {};
  }
  var pushDistance = (_ref = (_pushConfig$distance = (_pushConfig = pushConfig) === null || _pushConfig === void 0 ? void 0 : _pushConfig.distance) !== null && _pushConfig$distance !== void 0 ? _pushConfig$distance : parentContext === null || parentContext === void 0 ? void 0 : parentContext.pushDistance) !== null && _ref !== void 0 ? _ref : 180;
  var mergedContext = React340.useMemo(function() {
    return {
      pushDistance,
      push: function push2() {
        setPushed(true);
      },
      pull: function pull() {
        setPushed(false);
      }
    };
  }, [pushDistance]);
  React340.useEffect(function() {
    if (open2) {
      var _parentContext$push;
      parentContext === null || parentContext === void 0 || (_parentContext$push = parentContext.push) === null || _parentContext$push === void 0 || _parentContext$push.call(parentContext);
    } else {
      var _parentContext$pull;
      parentContext === null || parentContext === void 0 || (_parentContext$pull = parentContext.pull) === null || _parentContext$pull === void 0 || _parentContext$pull.call(parentContext);
    }
  }, [open2]);
  React340.useEffect(function() {
    return function() {
      var _parentContext$pull2;
      parentContext === null || parentContext === void 0 || (_parentContext$pull2 = parentContext.pull) === null || _parentContext$pull2 === void 0 || _parentContext$pull2.call(parentContext);
    };
  }, []);
  var maskNode = /* @__PURE__ */ React340.createElement(es_default2, _extends({
    key: "mask"
  }, maskMotion, {
    visible: mask && open2
  }), function(_ref2, maskRef) {
    var motionMaskClassName = _ref2.className, motionMaskStyle = _ref2.style;
    return /* @__PURE__ */ React340.createElement("div", {
      className: (0, import_classnames127.default)("".concat(prefixCls, "-mask"), motionMaskClassName, drawerClassNames === null || drawerClassNames === void 0 ? void 0 : drawerClassNames.mask, maskClassName),
      style: _objectSpread2(_objectSpread2(_objectSpread2({}, motionMaskStyle), maskStyle), styles === null || styles === void 0 ? void 0 : styles.mask),
      onClick: maskClosable && open2 ? onClose : void 0,
      ref: maskRef
    });
  });
  var motionProps = typeof motion2 === "function" ? motion2(placement) : motion2;
  var wrapperStyle = {};
  if (pushed && pushDistance) {
    switch (placement) {
      case "top":
        wrapperStyle.transform = "translateY(".concat(pushDistance, "px)");
        break;
      case "bottom":
        wrapperStyle.transform = "translateY(".concat(-pushDistance, "px)");
        break;
      case "left":
        wrapperStyle.transform = "translateX(".concat(pushDistance, "px)");
        break;
      default:
        wrapperStyle.transform = "translateX(".concat(-pushDistance, "px)");
        break;
    }
  }
  if (placement === "left" || placement === "right") {
    wrapperStyle.width = parseWidthHeight(width);
  } else {
    wrapperStyle.height = parseWidthHeight(height);
  }
  var eventHandlers = {
    onMouseEnter,
    onMouseOver,
    onMouseLeave,
    onClick,
    onKeyDown: onKeyDown2,
    onKeyUp
  };
  var panelNode = /* @__PURE__ */ React340.createElement(es_default2, _extends({
    key: "panel"
  }, motionProps, {
    visible: open2,
    forceRender,
    onVisibleChanged: function onVisibleChanged(nextVisible) {
      afterOpenChange === null || afterOpenChange === void 0 || afterOpenChange(nextVisible);
    },
    removeOnLeave: false,
    leavedClassName: "".concat(prefixCls, "-content-wrapper-hidden")
  }), function(_ref3, motionRef) {
    var motionClassName = _ref3.className, motionStyle = _ref3.style;
    var content = /* @__PURE__ */ React340.createElement(DrawerPanel_default, _extends({
      id,
      containerRef: motionRef,
      prefixCls,
      className: (0, import_classnames127.default)(className2, drawerClassNames === null || drawerClassNames === void 0 ? void 0 : drawerClassNames.content),
      style: _objectSpread2(_objectSpread2({}, style2), styles === null || styles === void 0 ? void 0 : styles.content)
    }, pickAttrs(props, {
      aria: true
    }), eventHandlers), children);
    return /* @__PURE__ */ React340.createElement("div", _extends({
      className: (0, import_classnames127.default)("".concat(prefixCls, "-content-wrapper"), drawerClassNames === null || drawerClassNames === void 0 ? void 0 : drawerClassNames.wrapper, motionClassName),
      style: _objectSpread2(_objectSpread2(_objectSpread2({}, wrapperStyle), motionStyle), styles === null || styles === void 0 ? void 0 : styles.wrapper)
    }, pickAttrs(props, {
      data: true
    })), drawerRender ? drawerRender(content) : content);
  });
  var containerStyle = _objectSpread2({}, rootStyle);
  if (zIndex) {
    containerStyle.zIndex = zIndex;
  }
  return /* @__PURE__ */ React340.createElement(context_default6.Provider, {
    value: mergedContext
  }, /* @__PURE__ */ React340.createElement("div", {
    className: (0, import_classnames127.default)(prefixCls, "".concat(prefixCls, "-").concat(placement), rootClassName, _defineProperty(_defineProperty({}, "".concat(prefixCls, "-open"), open2), "".concat(prefixCls, "-inline"), inline2)),
    style: containerStyle,
    tabIndex: -1,
    ref: panelRef,
    onKeyDown: onPanelKeyDown
  }, maskNode, /* @__PURE__ */ React340.createElement("div", {
    tabIndex: 0,
    ref: sentinelStartRef,
    style: sentinelStyle2,
    "aria-hidden": "true",
    "data-sentinel": "start"
  }), panelNode, /* @__PURE__ */ React340.createElement("div", {
    tabIndex: 0,
    ref: sentinelEndRef,
    style: sentinelStyle2,
    "aria-hidden": "true",
    "data-sentinel": "end"
  })));
}
var RefDrawerPopup = /* @__PURE__ */ React340.forwardRef(DrawerPopup);
if (true) {
  RefDrawerPopup.displayName = "DrawerPopup";
}
var DrawerPopup_default = RefDrawerPopup;

// ../../node_modules/rc-drawer/es/Drawer.js
var Drawer = function Drawer2(props) {
  var _props$open = props.open, open2 = _props$open === void 0 ? false : _props$open, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-drawer" : _props$prefixCls, _props$placement = props.placement, placement = _props$placement === void 0 ? "right" : _props$placement, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, _props$keyboard = props.keyboard, keyboard = _props$keyboard === void 0 ? true : _props$keyboard, _props$width = props.width, width = _props$width === void 0 ? 378 : _props$width, _props$mask = props.mask, mask = _props$mask === void 0 ? true : _props$mask, _props$maskClosable = props.maskClosable, maskClosable = _props$maskClosable === void 0 ? true : _props$maskClosable, getContainer2 = props.getContainer, forceRender = props.forceRender, afterOpenChange = props.afterOpenChange, destroyOnClose = props.destroyOnClose, onMouseEnter = props.onMouseEnter, onMouseOver = props.onMouseOver, onMouseLeave = props.onMouseLeave, onClick = props.onClick, onKeyDown2 = props.onKeyDown, onKeyUp = props.onKeyUp, panelRef = props.panelRef;
  var _React$useState = React341.useState(false), _React$useState2 = _slicedToArray(_React$useState, 2), animatedVisible = _React$useState2[0], setAnimatedVisible = _React$useState2[1];
  if (true) {
    warnCheck(props);
  }
  var _React$useState3 = React341.useState(false), _React$useState4 = _slicedToArray(_React$useState3, 2), mounted = _React$useState4[0], setMounted = _React$useState4[1];
  useLayoutEffect_default(function() {
    setMounted(true);
  }, []);
  var mergedOpen = mounted ? open2 : false;
  var popupRef = React341.useRef();
  var lastActiveRef = React341.useRef();
  useLayoutEffect_default(function() {
    if (mergedOpen) {
      lastActiveRef.current = document.activeElement;
    }
  }, [mergedOpen]);
  var internalAfterOpenChange = function internalAfterOpenChange2(nextVisible) {
    var _popupRef$current;
    setAnimatedVisible(nextVisible);
    afterOpenChange === null || afterOpenChange === void 0 || afterOpenChange(nextVisible);
    if (!nextVisible && lastActiveRef.current && !((_popupRef$current = popupRef.current) !== null && _popupRef$current !== void 0 && _popupRef$current.contains(lastActiveRef.current))) {
      var _lastActiveRef$curren;
      (_lastActiveRef$curren = lastActiveRef.current) === null || _lastActiveRef$curren === void 0 || _lastActiveRef$curren.focus({
        preventScroll: true
      });
    }
  };
  var refContext = React341.useMemo(function() {
    return {
      panel: panelRef
    };
  }, [panelRef]);
  if (!forceRender && !animatedVisible && !mergedOpen && destroyOnClose) {
    return null;
  }
  var eventHandlers = {
    onMouseEnter,
    onMouseOver,
    onMouseLeave,
    onClick,
    onKeyDown: onKeyDown2,
    onKeyUp
  };
  var drawerPopupProps = _objectSpread2(_objectSpread2({}, props), {}, {
    open: mergedOpen,
    prefixCls,
    placement,
    autoFocus,
    keyboard,
    width,
    mask,
    maskClosable,
    inline: getContainer2 === false,
    afterOpenChange: internalAfterOpenChange,
    ref: popupRef
  }, eventHandlers);
  return /* @__PURE__ */ React341.createElement(RefContext2.Provider, {
    value: refContext
  }, /* @__PURE__ */ React341.createElement(es_default4, {
    open: mergedOpen || forceRender || animatedVisible,
    autoDestroy: false,
    getContainer: getContainer2,
    autoLock: mask && (mergedOpen || animatedVisible)
  }, /* @__PURE__ */ React341.createElement(DrawerPopup_default, drawerPopupProps)));
};
if (true) {
  Drawer.displayName = "Drawer";
}
var Drawer_default = Drawer;

// ../../node_modules/rc-drawer/es/index.js
var es_default22 = Drawer_default;

// ../../node_modules/antd/es/drawer/DrawerPanel.js
var React342 = __toESM(require_react());
var import_classnames128 = __toESM(require_classnames());
var DrawerPanel3 = (props) => {
  var _a, _b;
  const {
    prefixCls,
    title,
    footer,
    extra,
    loading,
    onClose,
    headerStyle,
    bodyStyle,
    footerStyle,
    children,
    classNames: drawerClassNames,
    styles: drawerStyles
  } = props;
  const drawerContext = useComponentConfig("drawer");
  const customCloseIconRender = React342.useCallback((icon) => /* @__PURE__ */ React342.createElement("button", {
    type: "button",
    onClick: onClose,
    className: `${prefixCls}-close`
  }, icon), [onClose]);
  const [mergedClosable, mergedCloseIcon] = useClosable(pickClosable(props), pickClosable(drawerContext), {
    closable: true,
    closeIconRender: customCloseIconRender
  });
  const headerNode = React342.useMemo(() => {
    var _a2, _b2;
    if (!title && !mergedClosable) {
      return null;
    }
    return /* @__PURE__ */ React342.createElement("div", {
      style: Object.assign(Object.assign(Object.assign({}, (_a2 = drawerContext.styles) === null || _a2 === void 0 ? void 0 : _a2.header), headerStyle), drawerStyles === null || drawerStyles === void 0 ? void 0 : drawerStyles.header),
      className: (0, import_classnames128.default)(`${prefixCls}-header`, {
        [`${prefixCls}-header-close-only`]: mergedClosable && !title && !extra
      }, (_b2 = drawerContext.classNames) === null || _b2 === void 0 ? void 0 : _b2.header, drawerClassNames === null || drawerClassNames === void 0 ? void 0 : drawerClassNames.header)
    }, /* @__PURE__ */ React342.createElement("div", {
      className: `${prefixCls}-header-title`
    }, mergedCloseIcon, title && /* @__PURE__ */ React342.createElement("div", {
      className: `${prefixCls}-title`
    }, title)), extra && /* @__PURE__ */ React342.createElement("div", {
      className: `${prefixCls}-extra`
    }, extra));
  }, [mergedClosable, mergedCloseIcon, extra, headerStyle, prefixCls, title]);
  const footerNode = React342.useMemo(() => {
    var _a2, _b2;
    if (!footer) {
      return null;
    }
    const footerClassName = `${prefixCls}-footer`;
    return /* @__PURE__ */ React342.createElement("div", {
      className: (0, import_classnames128.default)(footerClassName, (_a2 = drawerContext.classNames) === null || _a2 === void 0 ? void 0 : _a2.footer, drawerClassNames === null || drawerClassNames === void 0 ? void 0 : drawerClassNames.footer),
      style: Object.assign(Object.assign(Object.assign({}, (_b2 = drawerContext.styles) === null || _b2 === void 0 ? void 0 : _b2.footer), footerStyle), drawerStyles === null || drawerStyles === void 0 ? void 0 : drawerStyles.footer)
    }, footer);
  }, [footer, footerStyle, prefixCls]);
  return /* @__PURE__ */ React342.createElement(React342.Fragment, null, headerNode, /* @__PURE__ */ React342.createElement("div", {
    className: (0, import_classnames128.default)(`${prefixCls}-body`, drawerClassNames === null || drawerClassNames === void 0 ? void 0 : drawerClassNames.body, (_a = drawerContext.classNames) === null || _a === void 0 ? void 0 : _a.body),
    style: Object.assign(Object.assign(Object.assign({}, (_b = drawerContext.styles) === null || _b === void 0 ? void 0 : _b.body), bodyStyle), drawerStyles === null || drawerStyles === void 0 ? void 0 : drawerStyles.body)
  }, loading ? /* @__PURE__ */ React342.createElement(skeleton_default, {
    active: true,
    title: false,
    paragraph: {
      rows: 5
    },
    className: `${prefixCls}-body-skeleton`
  }) : children), footerNode);
};
var DrawerPanel_default2 = DrawerPanel3;

// ../../node_modules/antd/es/drawer/style/motion.js
var getMoveTranslate = (direction) => {
  const value = "100%";
  return {
    left: `translateX(-${value})`,
    right: `translateX(${value})`,
    top: `translateY(-${value})`,
    bottom: `translateY(${value})`
  }[direction];
};
var getEnterLeaveStyle = (startStyle, endStyle) => ({
  "&-enter, &-appear": Object.assign(Object.assign({}, startStyle), {
    "&-active": endStyle
  }),
  "&-leave": Object.assign(Object.assign({}, endStyle), {
    "&-active": startStyle
  })
});
var getFadeStyle = (from2, duration) => Object.assign({
  "&-enter, &-appear, &-leave": {
    "&-start": {
      transition: "none"
    },
    "&-active": {
      transition: `all ${duration}`
    }
  }
}, getEnterLeaveStyle({
  opacity: from2
}, {
  opacity: 1
}));
var getPanelMotionStyles = (direction, duration) => [getFadeStyle(0.7, duration), getEnterLeaveStyle({
  transform: getMoveTranslate(direction)
}, {
  transform: "none"
})];
var genMotionStyle2 = (token2) => {
  const {
    componentCls,
    motionDurationSlow
  } = token2;
  return {
    [componentCls]: {
      // ======================== Mask ========================
      [`${componentCls}-mask-motion`]: getFadeStyle(0, motionDurationSlow),
      // ======================= Panel ========================
      [`${componentCls}-panel-motion`]: ["left", "right", "top", "bottom"].reduce((obj, direction) => Object.assign(Object.assign({}, obj), {
        [`&-${direction}`]: getPanelMotionStyles(direction, motionDurationSlow)
      }), {})
    }
  };
};
var motion_default3 = genMotionStyle2;

// ../../node_modules/antd/es/drawer/style/index.js
var genDrawerStyle = (token2) => {
  const {
    borderRadiusSM,
    componentCls,
    zIndexPopup,
    colorBgMask,
    colorBgElevated,
    motionDurationSlow,
    motionDurationMid,
    paddingXS,
    padding,
    paddingLG,
    fontSizeLG,
    lineHeightLG,
    lineWidth,
    lineType,
    colorSplit,
    marginXS,
    colorIcon,
    colorIconHover,
    colorBgTextHover,
    colorBgTextActive,
    colorText,
    fontWeightStrong,
    footerPaddingBlock,
    footerPaddingInline,
    calc
  } = token2;
  const wrapperCls = `${componentCls}-content-wrapper`;
  return {
    [componentCls]: {
      position: "fixed",
      inset: 0,
      zIndex: zIndexPopup,
      pointerEvents: "none",
      color: colorText,
      "&-pure": {
        position: "relative",
        background: colorBgElevated,
        display: "flex",
        flexDirection: "column",
        [`&${componentCls}-left`]: {
          boxShadow: token2.boxShadowDrawerLeft
        },
        [`&${componentCls}-right`]: {
          boxShadow: token2.boxShadowDrawerRight
        },
        [`&${componentCls}-top`]: {
          boxShadow: token2.boxShadowDrawerUp
        },
        [`&${componentCls}-bottom`]: {
          boxShadow: token2.boxShadowDrawerDown
        }
      },
      "&-inline": {
        position: "absolute"
      },
      // ====================== Mask ======================
      [`${componentCls}-mask`]: {
        position: "absolute",
        inset: 0,
        zIndex: zIndexPopup,
        background: colorBgMask,
        pointerEvents: "auto"
      },
      // ==================== Content =====================
      [wrapperCls]: {
        position: "absolute",
        zIndex: zIndexPopup,
        maxWidth: "100vw",
        transition: `all ${motionDurationSlow}`,
        "&-hidden": {
          display: "none"
        }
      },
      // Placement
      [`&-left > ${wrapperCls}`]: {
        top: 0,
        bottom: 0,
        left: {
          _skip_check_: true,
          value: 0
        },
        boxShadow: token2.boxShadowDrawerLeft
      },
      [`&-right > ${wrapperCls}`]: {
        top: 0,
        right: {
          _skip_check_: true,
          value: 0
        },
        bottom: 0,
        boxShadow: token2.boxShadowDrawerRight
      },
      [`&-top > ${wrapperCls}`]: {
        top: 0,
        insetInline: 0,
        boxShadow: token2.boxShadowDrawerUp
      },
      [`&-bottom > ${wrapperCls}`]: {
        bottom: 0,
        insetInline: 0,
        boxShadow: token2.boxShadowDrawerDown
      },
      [`${componentCls}-content`]: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "100%",
        overflow: "auto",
        background: colorBgElevated,
        pointerEvents: "auto"
      },
      // Header
      [`${componentCls}-header`]: {
        display: "flex",
        flex: 0,
        alignItems: "center",
        padding: `${unit(padding)} ${unit(paddingLG)}`,
        fontSize: fontSizeLG,
        lineHeight: lineHeightLG,
        borderBottom: `${unit(lineWidth)} ${lineType} ${colorSplit}`,
        "&-title": {
          display: "flex",
          flex: 1,
          alignItems: "center",
          minWidth: 0,
          minHeight: 0
        }
      },
      [`${componentCls}-extra`]: {
        flex: "none"
      },
      [`${componentCls}-close`]: Object.assign({
        display: "inline-flex",
        width: calc(fontSizeLG).add(paddingXS).equal(),
        height: calc(fontSizeLG).add(paddingXS).equal(),
        borderRadius: borderRadiusSM,
        justifyContent: "center",
        alignItems: "center",
        marginInlineEnd: marginXS,
        color: colorIcon,
        fontWeight: fontWeightStrong,
        fontSize: fontSizeLG,
        fontStyle: "normal",
        lineHeight: 1,
        textAlign: "center",
        textTransform: "none",
        textDecoration: "none",
        background: "transparent",
        border: 0,
        cursor: "pointer",
        transition: `all ${motionDurationMid}`,
        textRendering: "auto",
        "&:hover": {
          color: colorIconHover,
          backgroundColor: colorBgTextHover,
          textDecoration: "none"
        },
        "&:active": {
          backgroundColor: colorBgTextActive
        }
      }, genFocusStyle(token2)),
      [`${componentCls}-title`]: {
        flex: 1,
        margin: 0,
        fontWeight: token2.fontWeightStrong,
        fontSize: fontSizeLG,
        lineHeight: lineHeightLG
      },
      // Body
      [`${componentCls}-body`]: {
        flex: 1,
        minWidth: 0,
        minHeight: 0,
        padding: paddingLG,
        overflow: "auto",
        [`${componentCls}-body-skeleton`]: {
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center"
        }
      },
      // Footer
      [`${componentCls}-footer`]: {
        flexShrink: 0,
        padding: `${unit(footerPaddingBlock)} ${unit(footerPaddingInline)}`,
        borderTop: `${unit(lineWidth)} ${lineType} ${colorSplit}`
      },
      // ====================== RTL =======================
      "&-rtl": {
        direction: "rtl"
      }
    }
  };
};
var prepareComponentToken19 = (token2) => ({
  zIndexPopup: token2.zIndexPopupBase,
  footerPaddingBlock: token2.paddingXS,
  footerPaddingInline: token2.padding
});
var style_default24 = genStyleHooks("Drawer", (token2) => {
  const drawerToken = merge2(token2, {});
  return [genDrawerStyle(drawerToken), motion_default3(drawerToken)];
}, prepareComponentToken19);

// ../../node_modules/antd/es/drawer/index.js
var __rest37 = function(s, e3) {
  var t2 = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e3.indexOf(p) < 0) t2[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e3.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t2[p[i]] = s[p[i]];
  }
  return t2;
};
var defaultPushState = {
  distance: 180
};
var Drawer3 = (props) => {
  var _a;
  const {
    rootClassName,
    width,
    height,
    size = "default",
    mask = true,
    push = defaultPushState,
    open: open2,
    afterOpenChange,
    onClose,
    prefixCls: customizePrefixCls,
    getContainer: customizeGetContainer,
    panelRef = null,
    style: style2,
    className: className2,
    // Deprecated
    visible,
    afterVisibleChange,
    maskStyle,
    drawerStyle,
    contentWrapperStyle,
    destroyOnClose,
    destroyOnHidden
  } = props, rest = __rest37(props, ["rootClassName", "width", "height", "size", "mask", "push", "open", "afterOpenChange", "onClose", "prefixCls", "getContainer", "panelRef", "style", "className", "visible", "afterVisibleChange", "maskStyle", "drawerStyle", "contentWrapperStyle", "destroyOnClose", "destroyOnHidden"]);
  const {
    getPopupContainer,
    getPrefixCls,
    direction,
    className: contextClassName,
    style: contextStyle,
    classNames: contextClassNames,
    styles: contextStyles
  } = useComponentConfig("drawer");
  const prefixCls = getPrefixCls("drawer", customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = style_default24(prefixCls);
  const getContainer2 = (
    // 有可能为 false，所以不能直接判断
    customizeGetContainer === void 0 && getPopupContainer ? () => getPopupContainer(document.body) : customizeGetContainer
  );
  const drawerClassName = (0, import_classnames129.default)({
    "no-mask": !mask,
    [`${prefixCls}-rtl`]: direction === "rtl"
  }, rootClassName, hashId, cssVarCls);
  if (true) {
    const warning6 = devUseWarning("Drawer");
    [["visible", "open"], ["afterVisibleChange", "afterOpenChange"], ["headerStyle", "styles.header"], ["bodyStyle", "styles.body"], ["footerStyle", "styles.footer"], ["contentWrapperStyle", "styles.wrapper"], ["maskStyle", "styles.mask"], ["drawerStyle", "styles.content"], ["destroyInactivePanel", "destroyOnHidden"]].forEach(([deprecatedName, newName]) => {
      warning6.deprecated(!(deprecatedName in props), deprecatedName, newName);
    });
    if (getContainer2 !== void 0 && ((_a = props.style) === null || _a === void 0 ? void 0 : _a.position) === "absolute") {
      true ? warning6(false, "breaking", "`style` is replaced by `rootStyle` in v5. Please check that `position: absolute` is necessary.") : void 0;
    }
  }
  const mergedWidth = React343.useMemo(() => width !== null && width !== void 0 ? width : size === "large" ? 736 : 378, [width, size]);
  const mergedHeight = React343.useMemo(() => height !== null && height !== void 0 ? height : size === "large" ? 736 : 378, [height, size]);
  const maskMotion = {
    motionName: getTransitionName2(prefixCls, "mask-motion"),
    motionAppear: true,
    motionEnter: true,
    motionLeave: true,
    motionDeadline: 500
  };
  const panelMotion = (motionPlacement) => ({
    motionName: getTransitionName2(prefixCls, `panel-motion-${motionPlacement}`),
    motionAppear: true,
    motionEnter: true,
    motionLeave: true,
    motionDeadline: 500
  });
  const innerPanelRef = usePanelRef();
  const mergedPanelRef = composeRef(panelRef, innerPanelRef);
  const [zIndex, contextZIndex] = useZIndex("Drawer", rest.zIndex);
  const {
    classNames: propClassNames = {},
    styles: propStyles = {}
  } = rest;
  return wrapCSSVar(/* @__PURE__ */ React343.createElement(ContextIsolator_default, {
    form: true,
    space: true
  }, /* @__PURE__ */ React343.createElement(zindexContext_default.Provider, {
    value: contextZIndex
  }, /* @__PURE__ */ React343.createElement(es_default22, Object.assign({
    prefixCls,
    onClose,
    maskMotion,
    motion: panelMotion
  }, rest, {
    classNames: {
      mask: (0, import_classnames129.default)(propClassNames.mask, contextClassNames.mask),
      content: (0, import_classnames129.default)(propClassNames.content, contextClassNames.content),
      wrapper: (0, import_classnames129.default)(propClassNames.wrapper, contextClassNames.wrapper)
    },
    styles: {
      mask: Object.assign(Object.assign(Object.assign({}, propStyles.mask), maskStyle), contextStyles.mask),
      content: Object.assign(Object.assign(Object.assign({}, propStyles.content), drawerStyle), contextStyles.content),
      wrapper: Object.assign(Object.assign(Object.assign({}, propStyles.wrapper), contentWrapperStyle), contextStyles.wrapper)
    },
    open: open2 !== null && open2 !== void 0 ? open2 : visible,
    mask,
    push,
    width: mergedWidth,
    height: mergedHeight,
    style: Object.assign(Object.assign({}, contextStyle), style2),
    className: (0, import_classnames129.default)(contextClassName, className2),
    rootClassName: drawerClassName,
    getContainer: getContainer2,
    afterOpenChange: afterOpenChange !== null && afterOpenChange !== void 0 ? afterOpenChange : afterVisibleChange,
    panelRef: mergedPanelRef,
    zIndex,
    // TODO: In the future, destroyOnClose in rc-drawer needs to be upgrade to destroyOnHidden
    destroyOnClose: destroyOnHidden !== null && destroyOnHidden !== void 0 ? destroyOnHidden : destroyOnClose
  }), /* @__PURE__ */ React343.createElement(DrawerPanel_default2, Object.assign({
    prefixCls
  }, rest, {
    onClose
  }))))));
};
var PurePanel6 = (props) => {
  const {
    prefixCls: customizePrefixCls,
    style: style2,
    className: className2,
    placement = "right"
  } = props, restProps = __rest37(props, ["prefixCls", "style", "className", "placement"]);
  const {
    getPrefixCls
  } = React343.useContext(ConfigContext);
  const prefixCls = getPrefixCls("drawer", customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = style_default24(prefixCls);
  const cls11 = (0, import_classnames129.default)(prefixCls, `${prefixCls}-pure`, `${prefixCls}-${placement}`, hashId, cssVarCls, className2);
  return wrapCSSVar(/* @__PURE__ */ React343.createElement("div", {
    className: cls11,
    style: style2
  }, /* @__PURE__ */ React343.createElement(DrawerPanel_default2, Object.assign({
    prefixCls
  }, restProps))));
};
Drawer3._InternalPanelDoNotUseOrYouWillBeFired = PurePanel6;
if (true) {
  Drawer3.displayName = "Drawer";
}
var drawer_default = Drawer3;

// ../../node_modules/antd/es/dropdown/dropdown-button.js
var React347 = __toESM(require_react());
var import_classnames131 = __toESM(require_classnames());

// ../../node_modules/antd/es/space/index.js
var React346 = __toESM(require_react());
var import_classnames130 = __toESM(require_classnames());

// ../../node_modules/antd/es/_util/gapSize.js
function isPresetSize(size) {
  return ["small", "middle", "large"].includes(size);
}
function isValidGapNumber(size) {
  if (!size) {
    return false;
  }
  return typeof size === "number" && !Number.isNaN(size);
}

// ../../node_modules/antd/es/space/context.js
var import_react114 = __toESM(require_react());
var SpaceContext = /* @__PURE__ */ import_react114.default.createContext({
  latestIndex: 0
});
var SpaceContextProvider = SpaceContext.Provider;

// ../../node_modules/antd/es/space/Item.js
var React345 = __toESM(require_react());
var Item3 = ({
  className: className2,
  index: index3,
  children,
  split,
  style: style2
}) => {
  const {
    latestIndex
  } = React345.useContext(SpaceContext);
  if (children === null || children === void 0) {
    return null;
  }
  return /* @__PURE__ */ React345.createElement(React345.Fragment, null, /* @__PURE__ */ React345.createElement("div", {
    className: className2,
    style: style2
  }, children), index3 < latestIndex && split && /* @__PURE__ */ React345.createElement("span", {
    className: `${className2}-split`
  }, split));
};
var Item_default2 = Item3;

// ../../node_modules/antd/es/space/index.js
var __rest38 = function(s, e3) {
  var t2 = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e3.indexOf(p) < 0) t2[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e3.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t2[p[i]] = s[p[i]];
  }
  return t2;
};
var InternalSpace = /* @__PURE__ */ React346.forwardRef((props, ref3) => {
  var _a;
  const {
    getPrefixCls,
    direction: directionConfig,
    size: contextSize,
    className: contextClassName,
    style: contextStyle,
    classNames: contextClassNames,
    styles: contextStyles
  } = useComponentConfig("space");
  const {
    size = contextSize !== null && contextSize !== void 0 ? contextSize : "small",
    align,
    className: className2,
    rootClassName,
    children,
    direction = "horizontal",
    prefixCls: customizePrefixCls,
    split,
    style: style2,
    wrap = false,
    classNames: customClassNames,
    styles
  } = props, otherProps = __rest38(props, ["size", "align", "className", "rootClassName", "children", "direction", "prefixCls", "split", "style", "wrap", "classNames", "styles"]);
  const [horizontalSize, verticalSize] = Array.isArray(size) ? size : [size, size];
  const isPresetVerticalSize = isPresetSize(verticalSize);
  const isPresetHorizontalSize = isPresetSize(horizontalSize);
  const isValidVerticalSize = isValidGapNumber(verticalSize);
  const isValidHorizontalSize = isValidGapNumber(horizontalSize);
  const childNodes = toArray(children, {
    keepEmpty: true
  });
  const mergedAlign = align === void 0 && direction === "horizontal" ? "center" : align;
  const prefixCls = getPrefixCls("space", customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = style_default3(prefixCls);
  const cls11 = (0, import_classnames130.default)(prefixCls, contextClassName, hashId, `${prefixCls}-${direction}`, {
    [`${prefixCls}-rtl`]: directionConfig === "rtl",
    [`${prefixCls}-align-${mergedAlign}`]: mergedAlign,
    [`${prefixCls}-gap-row-${verticalSize}`]: isPresetVerticalSize,
    [`${prefixCls}-gap-col-${horizontalSize}`]: isPresetHorizontalSize
  }, className2, rootClassName, cssVarCls);
  const itemClassName = (0, import_classnames130.default)(`${prefixCls}-item`, (_a = customClassNames === null || customClassNames === void 0 ? void 0 : customClassNames.item) !== null && _a !== void 0 ? _a : contextClassNames.item);
  let latestIndex = 0;
  const nodes = childNodes.map((child, i) => {
    var _a2;
    if (child !== null && child !== void 0) {
      latestIndex = i;
    }
    const key2 = (child === null || child === void 0 ? void 0 : child.key) || `${itemClassName}-${i}`;
    return /* @__PURE__ */ React346.createElement(Item_default2, {
      className: itemClassName,
      key: key2,
      index: i,
      split,
      style: (_a2 = styles === null || styles === void 0 ? void 0 : styles.item) !== null && _a2 !== void 0 ? _a2 : contextStyles.item
    }, child);
  });
  const spaceContext = React346.useMemo(() => ({
    latestIndex
  }), [latestIndex]);
  if (childNodes.length === 0) {
    return null;
  }
  const gapStyle = {};
  if (wrap) {
    gapStyle.flexWrap = "wrap";
  }
  if (!isPresetHorizontalSize && isValidHorizontalSize) {
    gapStyle.columnGap = horizontalSize;
  }
  if (!isPresetVerticalSize && isValidVerticalSize) {
    gapStyle.rowGap = verticalSize;
  }
  return wrapCSSVar(/* @__PURE__ */ React346.createElement("div", Object.assign({
    ref: ref3,
    className: cls11,
    style: Object.assign(Object.assign(Object.assign({}, gapStyle), contextStyle), style2)
  }, otherProps), /* @__PURE__ */ React346.createElement(SpaceContextProvider, {
    value: spaceContext
  }, nodes)));
});
var Space = InternalSpace;
Space.Compact = Compact_default;
if (true) {
  Space.displayName = "Space";
}
var space_default = Space;

// ../../node_modules/antd/es/dropdown/dropdown-button.js
var __rest39 = function(s, e3) {
  var t2 = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e3.indexOf(p) < 0) t2[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e3.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t2[p[i]] = s[p[i]];
  }
  return t2;
};
var DropdownButton = (props) => {
  const {
    getPopupContainer: getContextPopupContainer,
    getPrefixCls,
    direction
  } = React347.useContext(ConfigContext);
  const {
    prefixCls: customizePrefixCls,
    type: type5 = "default",
    danger,
    disabled,
    loading,
    onClick,
    htmlType,
    children,
    className: className2,
    menu,
    arrow,
    autoFocus,
    overlay,
    trigger: trigger2,
    align,
    open: open2,
    onOpenChange,
    placement,
    getPopupContainer,
    href,
    icon = /* @__PURE__ */ React347.createElement(EllipsisOutlined_default2, null),
    title,
    buttonsRender = (buttons) => buttons,
    mouseEnterDelay,
    mouseLeaveDelay,
    overlayClassName,
    overlayStyle,
    destroyOnHidden,
    destroyPopupOnHide,
    dropdownRender,
    popupRender
  } = props, restProps = __rest39(props, ["prefixCls", "type", "danger", "disabled", "loading", "onClick", "htmlType", "children", "className", "menu", "arrow", "autoFocus", "overlay", "trigger", "align", "open", "onOpenChange", "placement", "getPopupContainer", "href", "icon", "title", "buttonsRender", "mouseEnterDelay", "mouseLeaveDelay", "overlayClassName", "overlayStyle", "destroyOnHidden", "destroyPopupOnHide", "dropdownRender", "popupRender"]);
  const prefixCls = getPrefixCls("dropdown", customizePrefixCls);
  const buttonPrefixCls = `${prefixCls}-button`;
  const mergedPopupRender = popupRender || dropdownRender;
  const dropdownProps = {
    menu,
    arrow,
    autoFocus,
    align,
    disabled,
    trigger: disabled ? [] : trigger2,
    onOpenChange,
    getPopupContainer: getPopupContainer || getContextPopupContainer,
    mouseEnterDelay,
    mouseLeaveDelay,
    overlayClassName,
    overlayStyle,
    destroyOnHidden,
    popupRender: mergedPopupRender
  };
  const {
    compactSize,
    compactItemClassnames
  } = useCompactItemContext(prefixCls, direction);
  const classes = (0, import_classnames131.default)(buttonPrefixCls, compactItemClassnames, className2);
  if ("destroyPopupOnHide" in props) {
    dropdownProps.destroyPopupOnHide = destroyPopupOnHide;
  }
  if ("overlay" in props) {
    dropdownProps.overlay = overlay;
  }
  if ("open" in props) {
    dropdownProps.open = open2;
  }
  if ("placement" in props) {
    dropdownProps.placement = placement;
  } else {
    dropdownProps.placement = direction === "rtl" ? "bottomLeft" : "bottomRight";
  }
  const leftButton = /* @__PURE__ */ React347.createElement(button_default2, {
    type: type5,
    danger,
    disabled,
    loading,
    onClick,
    htmlType,
    href,
    title
  }, children);
  const rightButton = /* @__PURE__ */ React347.createElement(button_default2, {
    type: type5,
    danger,
    icon
  });
  const [leftButtonToRender, rightButtonToRender] = buttonsRender([leftButton, rightButton]);
  return /* @__PURE__ */ React347.createElement(space_default.Compact, Object.assign({
    className: classes,
    size: compactSize,
    block: true
  }, restProps), leftButtonToRender, /* @__PURE__ */ React347.createElement(dropdown_default2, Object.assign({}, dropdownProps), rightButtonToRender));
};
DropdownButton.__ANT_BUTTON = true;
var dropdown_button_default = DropdownButton;

// ../../node_modules/antd/es/dropdown/index.js
var Dropdown3 = dropdown_default2;
Dropdown3.Button = dropdown_button_default;
var dropdown_default3 = Dropdown3;

// ../../node_modules/antd/es/_util/convertToTooltipProps.js
var import_react115 = __toESM(require_react());
function convertToTooltipProps(tooltip) {
  if (tooltip === void 0 || tooltip === null) {
    return null;
  }
  if (typeof tooltip === "object" && !/* @__PURE__ */ (0, import_react115.isValidElement)(tooltip)) {
    return tooltip;
  }
  return {
    title: tooltip
  };
}
var convertToTooltipProps_default = convertToTooltipProps;

// ../../node_modules/antd/es/form/ErrorList.js
var React349 = __toESM(require_react());
var import_classnames132 = __toESM(require_classnames());

// ../../node_modules/antd/es/form/hooks/useDebounce.js
var React348 = __toESM(require_react());
function useDebounce(value) {
  const [cacheValue, setCacheValue] = React348.useState(value);
  React348.useEffect(() => {
    const timeout = setTimeout(() => {
      setCacheValue(value);
    }, value.length ? 0 : 10);
    return () => {
      clearTimeout(timeout);
    };
  }, [value]);
  return cacheValue;
}

// ../../node_modules/antd/es/form/style/explain.js
var genFormValidateMotionStyle = (token2) => {
  const {
    componentCls
  } = token2;
  const helpCls = `${componentCls}-show-help`;
  const helpItemCls = `${componentCls}-show-help-item`;
  return {
    [helpCls]: {
      // Explain holder
      transition: `opacity ${token2.motionDurationFast} ${token2.motionEaseInOut}`,
      "&-appear, &-enter": {
        opacity: 0,
        "&-active": {
          opacity: 1
        }
      },
      "&-leave": {
        opacity: 1,
        "&-active": {
          opacity: 0
        }
      },
      // Explain
      [helpItemCls]: {
        overflow: "hidden",
        transition: `height ${token2.motionDurationFast} ${token2.motionEaseInOut},
                     opacity ${token2.motionDurationFast} ${token2.motionEaseInOut},
                     transform ${token2.motionDurationFast} ${token2.motionEaseInOut} !important`,
        [`&${helpItemCls}-appear, &${helpItemCls}-enter`]: {
          transform: `translateY(-5px)`,
          opacity: 0,
          "&-active": {
            transform: "translateY(0)",
            opacity: 1
          }
        },
        [`&${helpItemCls}-leave-active`]: {
          transform: `translateY(-5px)`
        }
      }
    }
  };
};
var explain_default = genFormValidateMotionStyle;

// ../../node_modules/antd/es/form/style/index.js
var resetForm = (token2) => ({
  legend: {
    display: "block",
    width: "100%",
    marginBottom: token2.marginLG,
    padding: 0,
    color: token2.colorTextDescription,
    fontSize: token2.fontSizeLG,
    lineHeight: "inherit",
    border: 0,
    borderBottom: `${unit(token2.lineWidth)} ${token2.lineType} ${token2.colorBorder}`
  },
  'input[type="search"]': {
    boxSizing: "border-box"
  },
  // Position radios and checkboxes better
  'input[type="radio"], input[type="checkbox"]': {
    lineHeight: "normal"
  },
  'input[type="file"]': {
    display: "block"
  },
  // Make range inputs behave like textual form controls
  'input[type="range"]': {
    display: "block",
    width: "100%"
  },
  // Make multiple select elements height not fixed
  "select[multiple], select[size]": {
    height: "auto"
  },
  // Focus for file, radio, and checkbox
  [`input[type='file']:focus,
  input[type='radio']:focus,
  input[type='checkbox']:focus`]: {
    outline: 0,
    boxShadow: `0 0 0 ${unit(token2.controlOutlineWidth)} ${token2.controlOutline}`
  },
  // Adjust output element
  output: {
    display: "block",
    paddingTop: 15,
    color: token2.colorText,
    fontSize: token2.fontSize,
    lineHeight: token2.lineHeight
  }
});
var genFormSize = (token2, height) => {
  const {
    formItemCls
  } = token2;
  return {
    [formItemCls]: {
      [`${formItemCls}-label > label`]: {
        height
      },
      [`${formItemCls}-control-input`]: {
        minHeight: height
      }
    }
  };
};
var genFormStyle = (token2) => {
  const {
    componentCls
  } = token2;
  return {
    [token2.componentCls]: Object.assign(Object.assign(Object.assign({}, resetComponent(token2)), resetForm(token2)), {
      [`${componentCls}-text`]: {
        display: "inline-block",
        paddingInlineEnd: token2.paddingSM
      },
      // ================================================================
      // =                             Size                             =
      // ================================================================
      "&-small": Object.assign({}, genFormSize(token2, token2.controlHeightSM)),
      "&-large": Object.assign({}, genFormSize(token2, token2.controlHeightLG))
    })
  };
};
var genFormItemStyle = (token2) => {
  const {
    formItemCls,
    iconCls,
    rootPrefixCls,
    antCls,
    labelRequiredMarkColor,
    labelColor,
    labelFontSize,
    labelHeight,
    labelColonMarginInlineStart,
    labelColonMarginInlineEnd,
    itemMarginBottom
  } = token2;
  return {
    [formItemCls]: Object.assign(Object.assign({}, resetComponent(token2)), {
      marginBottom: itemMarginBottom,
      verticalAlign: "top",
      "&-with-help": {
        transition: "none"
      },
      [`&-hidden,
        &-hidden${antCls}-row`]: {
        // https://github.com/ant-design/ant-design/issues/26141
        display: "none"
      },
      "&-has-warning": {
        [`${formItemCls}-split`]: {
          color: token2.colorError
        }
      },
      "&-has-error": {
        [`${formItemCls}-split`]: {
          color: token2.colorWarning
        }
      },
      // ==============================================================
      // =                            Label                           =
      // ==============================================================
      [`${formItemCls}-label`]: {
        flexGrow: 0,
        overflow: "hidden",
        whiteSpace: "nowrap",
        textAlign: "end",
        verticalAlign: "middle",
        "&-left": {
          textAlign: "start"
        },
        "&-wrap": {
          overflow: "unset",
          lineHeight: token2.lineHeight,
          whiteSpace: "unset",
          "> label": {
            verticalAlign: "middle",
            textWrap: "balance"
          }
        },
        "> label": {
          position: "relative",
          display: "inline-flex",
          alignItems: "center",
          maxWidth: "100%",
          height: labelHeight,
          color: labelColor,
          fontSize: labelFontSize,
          [`> ${iconCls}`]: {
            fontSize: token2.fontSize,
            verticalAlign: "top"
          },
          [`&${formItemCls}-required`]: {
            "&::before": {
              display: "inline-block",
              marginInlineEnd: token2.marginXXS,
              color: labelRequiredMarkColor,
              fontSize: token2.fontSize,
              fontFamily: "SimSun, sans-serif",
              lineHeight: 1,
              content: '"*"'
            },
            [`&${formItemCls}-required-mark-hidden, &${formItemCls}-required-mark-optional`]: {
              "&::before": {
                display: "none"
              }
            }
          },
          // Optional mark
          [`${formItemCls}-optional`]: {
            display: "inline-block",
            marginInlineStart: token2.marginXXS,
            color: token2.colorTextDescription,
            [`&${formItemCls}-required-mark-hidden`]: {
              display: "none"
            }
          },
          // Optional mark
          [`${formItemCls}-tooltip`]: {
            color: token2.colorTextDescription,
            cursor: "help",
            writingMode: "horizontal-tb",
            marginInlineStart: token2.marginXXS
          },
          "&::after": {
            content: '":"',
            position: "relative",
            marginBlock: 0,
            marginInlineStart: labelColonMarginInlineStart,
            marginInlineEnd: labelColonMarginInlineEnd
          },
          [`&${formItemCls}-no-colon::after`]: {
            content: '"\\a0"'
          }
        }
      },
      // ==============================================================
      // =                            Input                           =
      // ==============================================================
      [`${formItemCls}-control`]: {
        ["--ant-display"]: "flex",
        flexDirection: "column",
        flexGrow: 1,
        [`&:first-child:not([class^="'${rootPrefixCls}-col-'"]):not([class*="' ${rootPrefixCls}-col-'"])`]: {
          width: "100%"
        },
        "&-input": {
          position: "relative",
          display: "flex",
          alignItems: "center",
          minHeight: token2.controlHeight,
          "&-content": {
            flex: "auto",
            maxWidth: "100%",
            // Fix https://github.com/ant-design/ant-design/issues/54042
            // Remove impact of whitespaces
            [`&:has(> ${antCls}-switch:only-child, > ${antCls}-rate:only-child)`]: {
              display: "flex",
              alignItems: "center"
            }
          }
        }
      },
      // ==============================================================
      // =                           Explain                          =
      // ==============================================================
      [formItemCls]: {
        "&-additional": {
          display: "flex",
          flexDirection: "column"
        },
        "&-explain, &-extra": {
          clear: "both",
          color: token2.colorTextDescription,
          fontSize: token2.fontSize,
          lineHeight: token2.lineHeight
        },
        "&-explain-connected": {
          width: "100%"
        },
        "&-extra": {
          minHeight: token2.controlHeightSM,
          transition: `color ${token2.motionDurationMid} ${token2.motionEaseOut}`
          // sync input color transition
        },
        "&-explain": {
          "&-error": {
            color: token2.colorError
          },
          "&-warning": {
            color: token2.colorWarning
          }
        }
      },
      [`&-with-help ${formItemCls}-explain`]: {
        height: "auto",
        opacity: 1
      },
      // ==============================================================
      // =                        Feedback Icon                       =
      // ==============================================================
      [`${formItemCls}-feedback-icon`]: {
        fontSize: token2.fontSize,
        textAlign: "center",
        visibility: "visible",
        animationName: zoomIn,
        animationDuration: token2.motionDurationMid,
        animationTimingFunction: token2.motionEaseOutBack,
        pointerEvents: "none",
        "&-success": {
          color: token2.colorSuccess
        },
        "&-error": {
          color: token2.colorError
        },
        "&-warning": {
          color: token2.colorWarning
        },
        "&-validating": {
          color: token2.colorPrimary
        }
      }
    })
  };
};
var makeVerticalLayoutLabel = (token2) => ({
  padding: token2.verticalLabelPadding,
  margin: token2.verticalLabelMargin,
  whiteSpace: "initial",
  textAlign: "start",
  "> label": {
    margin: 0,
    "&::after": {
      // https://github.com/ant-design/ant-design/issues/43538
      visibility: "hidden"
    }
  }
});
var genHorizontalStyle2 = (token2) => {
  const {
    antCls,
    formItemCls
  } = token2;
  return {
    [`${formItemCls}-horizontal`]: {
      [`${formItemCls}-label`]: {
        flexGrow: 0
      },
      [`${formItemCls}-control`]: {
        flex: "1 1 0",
        // https://github.com/ant-design/ant-design/issues/32777
        // https://github.com/ant-design/ant-design/issues/33773
        minWidth: 0
      },
      // Do not change this to `ant-col-24`! `-24` match all the responsive rules
      // https://github.com/ant-design/ant-design/issues/32980
      // https://github.com/ant-design/ant-design/issues/34903
      // https://github.com/ant-design/ant-design/issues/44538
      [`${formItemCls}-label[class$='-24'], ${formItemCls}-label[class*='-24 ']`]: {
        [`& + ${formItemCls}-control`]: {
          minWidth: "unset"
        }
      },
      [`${antCls}-col-24${formItemCls}-label,
        ${antCls}-col-xl-24${formItemCls}-label`]: makeVerticalLayoutLabel(token2)
    }
  };
};
var genInlineStyle = (token2) => {
  const {
    componentCls,
    formItemCls,
    inlineItemMarginBottom
  } = token2;
  return {
    [`${componentCls}-inline`]: {
      display: "flex",
      flexWrap: "wrap",
      [`${formItemCls}-inline`]: {
        flex: "none",
        marginInlineEnd: token2.margin,
        marginBottom: inlineItemMarginBottom,
        "&-row": {
          flexWrap: "nowrap"
        },
        [`> ${formItemCls}-label,
        > ${formItemCls}-control`]: {
          display: "inline-block",
          verticalAlign: "top"
        },
        [`> ${formItemCls}-label`]: {
          flex: "none"
        },
        [`${componentCls}-text`]: {
          display: "inline-block"
        },
        [`${formItemCls}-has-feedback`]: {
          display: "inline-block"
        }
      }
    }
  };
};
var makeVerticalLayout = (token2) => {
  const {
    componentCls,
    formItemCls,
    rootPrefixCls
  } = token2;
  return {
    [`${formItemCls} ${formItemCls}-label`]: makeVerticalLayoutLabel(token2),
    // ref: https://github.com/ant-design/ant-design/issues/45122
    [`${componentCls}:not(${componentCls}-inline)`]: {
      [formItemCls]: {
        flexWrap: "wrap",
        [`${formItemCls}-label, ${formItemCls}-control`]: {
          // When developer pass `xs: { span }`,
          // It should follow the `xs` screen config
          // ref: https://github.com/ant-design/ant-design/issues/44386
          [`&:not([class*=" ${rootPrefixCls}-col-xs"])`]: {
            flex: "0 0 100%",
            maxWidth: "100%"
          }
        }
      }
    }
  };
};
var genVerticalStyle2 = (token2) => {
  const {
    componentCls,
    formItemCls,
    antCls
  } = token2;
  return {
    [`${formItemCls}-vertical`]: {
      [`${formItemCls}-row`]: {
        flexDirection: "column"
      },
      [`${formItemCls}-label > label`]: {
        height: "auto"
      },
      [`${formItemCls}-control`]: {
        width: "100%"
      },
      [`${formItemCls}-label,
        ${antCls}-col-24${formItemCls}-label,
        ${antCls}-col-xl-24${formItemCls}-label`]: makeVerticalLayoutLabel(token2)
    },
    [`@media (max-width: ${unit(token2.screenXSMax)})`]: [makeVerticalLayout(token2), {
      [componentCls]: {
        [`${formItemCls}:not(${formItemCls}-horizontal)`]: {
          [`${antCls}-col-xs-24${formItemCls}-label`]: makeVerticalLayoutLabel(token2)
        }
      }
    }],
    [`@media (max-width: ${unit(token2.screenSMMax)})`]: {
      [componentCls]: {
        [`${formItemCls}:not(${formItemCls}-horizontal)`]: {
          [`${antCls}-col-sm-24${formItemCls}-label`]: makeVerticalLayoutLabel(token2)
        }
      }
    },
    [`@media (max-width: ${unit(token2.screenMDMax)})`]: {
      [componentCls]: {
        [`${formItemCls}:not(${formItemCls}-horizontal)`]: {
          [`${antCls}-col-md-24${formItemCls}-label`]: makeVerticalLayoutLabel(token2)
        }
      }
    },
    [`@media (max-width: ${unit(token2.screenLGMax)})`]: {
      [componentCls]: {
        [`${formItemCls}:not(${formItemCls}-horizontal)`]: {
          [`${antCls}-col-lg-24${formItemCls}-label`]: makeVerticalLayoutLabel(token2)
        }
      }
    }
  };
};
var prepareComponentToken20 = (token2) => ({
  labelRequiredMarkColor: token2.colorError,
  labelColor: token2.colorTextHeading,
  labelFontSize: token2.fontSize,
  labelHeight: token2.controlHeight,
  labelColonMarginInlineStart: token2.marginXXS / 2,
  labelColonMarginInlineEnd: token2.marginXS,
  itemMarginBottom: token2.marginLG,
  verticalLabelPadding: `0 0 ${token2.paddingXS}px`,
  verticalLabelMargin: 0,
  inlineItemMarginBottom: 0
});
var prepareToken3 = (token2, rootPrefixCls) => {
  const formToken = merge2(token2, {
    formItemCls: `${token2.componentCls}-item`,
    rootPrefixCls
  });
  return formToken;
};
var style_default25 = genStyleHooks("Form", (token2, {
  rootPrefixCls
}) => {
  const formToken = prepareToken3(token2, rootPrefixCls);
  return [genFormStyle(formToken), genFormItemStyle(formToken), explain_default(formToken), genHorizontalStyle2(formToken), genInlineStyle(formToken), genVerticalStyle2(formToken), collapse_default(formToken), zoomIn];
}, prepareComponentToken20, {
  // Let From style before the Grid
  // ref https://github.com/ant-design/ant-design/issues/44386
  order: -1e3
});

// ../../node_modules/antd/es/form/ErrorList.js
var EMPTY_LIST4 = [];
function toErrorEntity(error2, prefix3, errorStatus, index3 = 0) {
  return {
    key: typeof error2 === "string" ? error2 : `${prefix3}-${index3}`,
    error: error2,
    errorStatus
  };
}
var ErrorList = ({
  help,
  helpStatus,
  errors = EMPTY_LIST4,
  warnings = EMPTY_LIST4,
  className: rootClassName,
  fieldId,
  onVisibleChanged
}) => {
  const {
    prefixCls
  } = React349.useContext(FormItemPrefixContext);
  const baseClassName2 = `${prefixCls}-item-explain`;
  const rootCls = useCSSVarCls_default(prefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = style_default25(prefixCls, rootCls);
  const collapseMotion = React349.useMemo(() => motion_default(prefixCls), [prefixCls]);
  const debounceErrors = useDebounce(errors);
  const debounceWarnings = useDebounce(warnings);
  const fullKeyList = React349.useMemo(() => {
    if (help !== void 0 && help !== null) {
      return [toErrorEntity(help, "help", helpStatus)];
    }
    return [].concat(_toConsumableArray(debounceErrors.map((error2, index3) => toErrorEntity(error2, "error", "error", index3))), _toConsumableArray(debounceWarnings.map((warning6, index3) => toErrorEntity(warning6, "warning", "warning", index3))));
  }, [help, helpStatus, debounceErrors, debounceWarnings]);
  const filledKeyFullKeyList = React349.useMemo(() => {
    const keysCount = {};
    fullKeyList.forEach(({
      key: key2
    }) => {
      keysCount[key2] = (keysCount[key2] || 0) + 1;
    });
    return fullKeyList.map((entity, index3) => Object.assign(Object.assign({}, entity), {
      key: keysCount[entity.key] > 1 ? `${entity.key}-fallback-${index3}` : entity.key
    }));
  }, [fullKeyList]);
  const helpProps = {};
  if (fieldId) {
    helpProps.id = `${fieldId}_help`;
  }
  return wrapCSSVar(/* @__PURE__ */ React349.createElement(es_default2, {
    motionDeadline: collapseMotion.motionDeadline,
    motionName: `${prefixCls}-show-help`,
    visible: !!filledKeyFullKeyList.length,
    onVisibleChanged
  }, (holderProps) => {
    const {
      className: holderClassName,
      style: holderStyle
    } = holderProps;
    return /* @__PURE__ */ React349.createElement("div", Object.assign({}, helpProps, {
      className: (0, import_classnames132.default)(baseClassName2, holderClassName, cssVarCls, rootCls, rootClassName, hashId),
      style: holderStyle
    }), /* @__PURE__ */ React349.createElement(CSSMotionList_default, Object.assign({
      keys: filledKeyFullKeyList
    }, motion_default(prefixCls), {
      motionName: `${prefixCls}-show-help-item`,
      component: false
    }), (itemProps) => {
      const {
        key: key2,
        error: error2,
        errorStatus,
        className: itemClassName,
        style: itemStyle
      } = itemProps;
      return /* @__PURE__ */ React349.createElement("div", {
        key: key2,
        className: (0, import_classnames132.default)(itemClassName, {
          [`${baseClassName2}-${errorStatus}`]: errorStatus
        }),
        style: itemStyle
      }, error2);
    }));
  }));
};
var ErrorList_default = ErrorList;

// ../../node_modules/antd/es/form/Form.js
var React351 = __toESM(require_react());
var import_classnames133 = __toESM(require_classnames());

// ../../node_modules/antd/es/form/hooks/useFormWarning.js
var React350 = __toESM(require_react());
var names = {};
function useFormWarning({
  name
}) {
  const warning6 = devUseWarning("Form");
  React350.useEffect(() => {
    if (name) {
      names[name] = (names[name] || 0) + 1;
      true ? warning6(names[name] <= 1, "usage", "There exist multiple Form with same `name`.") : void 0;
      return () => {
        names[name] -= 1;
      };
    }
  }, [name]);
}

// ../../node_modules/antd/es/form/Form.js
var __rest40 = function(s, e3) {
  var t2 = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e3.indexOf(p) < 0) t2[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e3.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t2[p[i]] = s[p[i]];
  }
  return t2;
};
var InternalForm2 = (props, ref3) => {
  const contextDisabled = React351.useContext(DisabledContext_default);
  const {
    getPrefixCls,
    direction,
    requiredMark: contextRequiredMark,
    colon: contextColon,
    scrollToFirstError: contextScrollToFirstError,
    className: contextClassName,
    style: contextStyle
  } = useComponentConfig("form");
  const {
    prefixCls: customizePrefixCls,
    className: className2,
    rootClassName,
    size,
    disabled = contextDisabled,
    form,
    colon,
    labelAlign,
    labelWrap,
    labelCol,
    wrapperCol,
    hideRequiredMark,
    layout = "horizontal",
    scrollToFirstError,
    requiredMark,
    onFinishFailed,
    name,
    style: style2,
    feedbackIcons,
    variant
  } = props, restFormProps = __rest40(props, ["prefixCls", "className", "rootClassName", "size", "disabled", "form", "colon", "labelAlign", "labelWrap", "labelCol", "wrapperCol", "hideRequiredMark", "layout", "scrollToFirstError", "requiredMark", "onFinishFailed", "name", "style", "feedbackIcons", "variant"]);
  const mergedSize = useSize_default(size);
  const contextValidateMessages = React351.useContext(validateMessagesContext_default);
  if (true) {
    useFormWarning(props);
  }
  const mergedRequiredMark = React351.useMemo(() => {
    if (requiredMark !== void 0) {
      return requiredMark;
    }
    if (hideRequiredMark) {
      return false;
    }
    if (contextRequiredMark !== void 0) {
      return contextRequiredMark;
    }
    return true;
  }, [hideRequiredMark, requiredMark, contextRequiredMark]);
  const mergedColon = colon !== null && colon !== void 0 ? colon : contextColon;
  const prefixCls = getPrefixCls("form", customizePrefixCls);
  const rootCls = useCSSVarCls_default(prefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = style_default25(prefixCls, rootCls);
  const formClassName = (0, import_classnames133.default)(prefixCls, `${prefixCls}-${layout}`, {
    [`${prefixCls}-hide-required-mark`]: mergedRequiredMark === false,
    // todo: remove in next major version
    [`${prefixCls}-rtl`]: direction === "rtl",
    [`${prefixCls}-${mergedSize}`]: mergedSize
  }, cssVarCls, rootCls, hashId, contextClassName, className2, rootClassName);
  const [wrapForm] = useForm2(form);
  const {
    __INTERNAL__
  } = wrapForm;
  __INTERNAL__.name = name;
  const formContextValue = React351.useMemo(() => ({
    name,
    labelAlign,
    labelCol,
    labelWrap,
    wrapperCol,
    layout,
    colon: mergedColon,
    requiredMark: mergedRequiredMark,
    itemRef: __INTERNAL__.itemRef,
    form: wrapForm,
    feedbackIcons
  }), [name, labelAlign, labelCol, wrapperCol, layout, mergedColon, mergedRequiredMark, wrapForm, feedbackIcons]);
  const nativeElementRef = React351.useRef(null);
  React351.useImperativeHandle(ref3, () => {
    var _a;
    return Object.assign(Object.assign({}, wrapForm), {
      nativeElement: (_a = nativeElementRef.current) === null || _a === void 0 ? void 0 : _a.nativeElement
    });
  });
  const scrollToField = (options, fieldName) => {
    if (options) {
      let defaultScrollToFirstError = {
        block: "nearest"
      };
      if (typeof options === "object") {
        defaultScrollToFirstError = Object.assign(Object.assign({}, defaultScrollToFirstError), options);
      }
      wrapForm.scrollToField(fieldName, defaultScrollToFirstError);
    }
  };
  const onInternalFinishFailed = (errorInfo) => {
    onFinishFailed === null || onFinishFailed === void 0 ? void 0 : onFinishFailed(errorInfo);
    if (errorInfo.errorFields.length) {
      const fieldName = errorInfo.errorFields[0].name;
      if (scrollToFirstError !== void 0) {
        scrollToField(scrollToFirstError, fieldName);
        return;
      }
      if (contextScrollToFirstError !== void 0) {
        scrollToField(contextScrollToFirstError, fieldName);
      }
    }
  };
  return wrapCSSVar(/* @__PURE__ */ React351.createElement(VariantContext.Provider, {
    value: variant
  }, /* @__PURE__ */ React351.createElement(DisabledContextProvider, {
    disabled
  }, /* @__PURE__ */ React351.createElement(SizeContext_default.Provider, {
    value: mergedSize
  }, /* @__PURE__ */ React351.createElement(FormProvider3, {
    // This is not list in API, we pass with spread
    validateMessages: contextValidateMessages
  }, /* @__PURE__ */ React351.createElement(FormContext2.Provider, {
    value: formContextValue
  }, /* @__PURE__ */ React351.createElement(NoFormStyle, {
    status: true
  }, /* @__PURE__ */ React351.createElement(es_default7, Object.assign({
    id: name
  }, restFormProps, {
    name,
    onFinishFailed: onInternalFinishFailed,
    form: wrapForm,
    ref: nativeElementRef,
    style: Object.assign(Object.assign({}, contextStyle), style2),
    className: formClassName
  })))))))));
};
var Form3 = /* @__PURE__ */ React351.forwardRef(InternalForm2);
if (true) {
  Form3.displayName = "Form";
}
var Form_default2 = Form3;

// ../../node_modules/antd/es/form/FormItem/index.js
var React360 = __toESM(require_react());
var import_classnames138 = __toESM(require_classnames());

// ../../node_modules/antd/es/form/hooks/useChildren.js
function useChildren2(children) {
  if (typeof children === "function") {
    return children;
  }
  const childList = toArray(children);
  return childList.length <= 1 ? childList[0] : childList;
}

// ../../node_modules/antd/es/form/hooks/useFormItemStatus.js
var React352 = __toESM(require_react());
var useFormItemStatus = () => {
  const {
    status,
    errors = [],
    warnings = []
  } = React352.useContext(FormItemInputContext);
  if (true) {
    const warning6 = devUseWarning("Form.Item");
    true ? warning6(status !== void 0, "usage", "Form.Item.useStatus should be used under Form.Item component. For more information: https://u.ant.design/form-item-usestatus") : void 0;
  }
  return {
    status,
    errors,
    warnings
  };
};
useFormItemStatus.Context = FormItemInputContext;
var useFormItemStatus_default = useFormItemStatus;

// ../../node_modules/antd/es/form/hooks/useFrameState.js
var React353 = __toESM(require_react());
function useFrameState(defaultValue2) {
  const [value, setValue] = React353.useState(defaultValue2);
  const frameRef = React353.useRef(null);
  const batchRef = React353.useRef([]);
  const destroyRef = React353.useRef(false);
  React353.useEffect(() => {
    destroyRef.current = false;
    return () => {
      destroyRef.current = true;
      raf_default.cancel(frameRef.current);
      frameRef.current = null;
    };
  }, []);
  function setFrameValue(updater) {
    if (destroyRef.current) {
      return;
    }
    if (frameRef.current === null) {
      batchRef.current = [];
      frameRef.current = raf_default(() => {
        frameRef.current = null;
        setValue((prevValue) => {
          let current2 = prevValue;
          batchRef.current.forEach((func) => {
            current2 = func(current2);
          });
          return current2;
        });
      });
    }
    batchRef.current.push(updater);
  }
  return [value, setFrameValue];
}

// ../../node_modules/antd/es/form/hooks/useItemRef.js
var React354 = __toESM(require_react());
function useItemRef() {
  const {
    itemRef
  } = React354.useContext(FormContext2);
  const cacheRef = React354.useRef({});
  function getRef(name, children) {
    const childrenRef = children && typeof children === "object" && getNodeRef(children);
    const nameStr = name.join("_");
    if (cacheRef.current.name !== nameStr || cacheRef.current.originRef !== childrenRef) {
      cacheRef.current.name = nameStr;
      cacheRef.current.originRef = childrenRef;
      cacheRef.current.ref = composeRef(itemRef(name), childrenRef);
    }
    return cacheRef.current.ref;
  }
  return getRef;
}

// ../../node_modules/antd/es/form/FormItem/ItemHolder.js
var React359 = __toESM(require_react());
var import_classnames137 = __toESM(require_classnames());

// ../../node_modules/antd/es/form/FormItemInput.js
var React355 = __toESM(require_react());
var import_classnames134 = __toESM(require_classnames());

// ../../node_modules/antd/es/form/style/fallbackCmp.js
var genFallbackStyle = (token2) => {
  const {
    formItemCls
  } = token2;
  return {
    "@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)": {
      // Fallback for IE, safe to remove we not support it anymore
      [`${formItemCls}-control`]: {
        display: "flex"
      }
    }
  };
};
var fallbackCmp_default = genSubStyleComponent(["Form", "item-item"], (token2, {
  rootPrefixCls
}) => {
  const formToken = prepareToken3(token2, rootPrefixCls);
  return genFallbackStyle(formToken);
});

// ../../node_modules/antd/es/form/FormItemInput.js
var __rest41 = function(s, e3) {
  var t2 = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e3.indexOf(p) < 0) t2[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e3.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t2[p[i]] = s[p[i]];
  }
  return t2;
};
var GRID_MAX = 24;
var FormItemInput = (props) => {
  const {
    prefixCls,
    status,
    labelCol,
    wrapperCol,
    children,
    errors,
    warnings,
    _internalItemRender: formItemRender,
    extra,
    help,
    fieldId,
    marginBottom,
    onErrorVisibleChanged,
    label
  } = props;
  const baseClassName2 = `${prefixCls}-item`;
  const formContext = React355.useContext(FormContext2);
  const mergedWrapperCol = React355.useMemo(() => {
    let mergedWrapper = Object.assign({}, wrapperCol || formContext.wrapperCol || {});
    if (label === null && !labelCol && !wrapperCol && formContext.labelCol) {
      const list = [void 0, "xs", "sm", "md", "lg", "xl", "xxl"];
      list.forEach((size) => {
        const _size = size ? [size] : [];
        const formLabel = get(formContext.labelCol, _size);
        const formLabelObj = typeof formLabel === "object" ? formLabel : {};
        const wrapper = get(mergedWrapper, _size);
        const wrapperObj = typeof wrapper === "object" ? wrapper : {};
        if ("span" in formLabelObj && !("offset" in wrapperObj) && formLabelObj.span < GRID_MAX) {
          mergedWrapper = set2(mergedWrapper, [].concat(_size, ["offset"]), formLabelObj.span);
        }
      });
    }
    return mergedWrapper;
  }, [wrapperCol, formContext]);
  const className2 = (0, import_classnames134.default)(`${baseClassName2}-control`, mergedWrapperCol.className);
  const subFormContext = React355.useMemo(() => {
    const {
      labelCol: labelCol2,
      wrapperCol: wrapperCol2
    } = formContext, rest = __rest41(formContext, ["labelCol", "wrapperCol"]);
    return rest;
  }, [formContext]);
  const extraRef = React355.useRef(null);
  const [extraHeight, setExtraHeight] = React355.useState(0);
  useLayoutEffect_default(() => {
    if (extra && extraRef.current) {
      setExtraHeight(extraRef.current.clientHeight);
    } else {
      setExtraHeight(0);
    }
  }, [extra]);
  const inputDom = /* @__PURE__ */ React355.createElement("div", {
    className: `${baseClassName2}-control-input`
  }, /* @__PURE__ */ React355.createElement("div", {
    className: `${baseClassName2}-control-input-content`
  }, children));
  const formItemContext = React355.useMemo(() => ({
    prefixCls,
    status
  }), [prefixCls, status]);
  const errorListDom = marginBottom !== null || errors.length || warnings.length ? /* @__PURE__ */ React355.createElement(FormItemPrefixContext.Provider, {
    value: formItemContext
  }, /* @__PURE__ */ React355.createElement(ErrorList_default, {
    fieldId,
    errors,
    warnings,
    help,
    helpStatus: status,
    className: `${baseClassName2}-explain-connected`,
    onVisibleChanged: onErrorVisibleChanged
  })) : null;
  const extraProps = {};
  if (fieldId) {
    extraProps.id = `${fieldId}_extra`;
  }
  const extraDom = extra ? /* @__PURE__ */ React355.createElement("div", Object.assign({}, extraProps, {
    className: `${baseClassName2}-extra`,
    ref: extraRef
  }), extra) : null;
  const additionalDom = errorListDom || extraDom ? /* @__PURE__ */ React355.createElement("div", {
    className: `${baseClassName2}-additional`,
    style: marginBottom ? {
      minHeight: marginBottom + extraHeight
    } : {}
  }, errorListDom, extraDom) : null;
  const dom = formItemRender && formItemRender.mark === "pro_table_render" && formItemRender.render ? formItemRender.render(props, {
    input: inputDom,
    errorList: errorListDom,
    extra: extraDom
  }) : /* @__PURE__ */ React355.createElement(React355.Fragment, null, inputDom, additionalDom);
  return /* @__PURE__ */ React355.createElement(FormContext2.Provider, {
    value: subFormContext
  }, /* @__PURE__ */ React355.createElement(col_default, Object.assign({}, mergedWrapperCol, {
    className: className2
  }), dom), /* @__PURE__ */ React355.createElement(fallbackCmp_default, {
    prefixCls
  }));
};
var FormItemInput_default = FormItemInput;

// ../../node_modules/antd/es/form/FormItemLabel.js
var React357 = __toESM(require_react());

// ../../node_modules/@ant-design/icons/es/icons/QuestionCircleOutlined.js
var React356 = __toESM(require_react());

// ../../node_modules/@ant-design/icons-svg/es/asn/QuestionCircleOutlined.js
var QuestionCircleOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }, { "tag": "path", "attrs": { "d": "M623.6 316.7C593.6 290.4 554 276 512 276s-81.6 14.5-111.6 40.7C369.2 344 352 380.7 352 420v7.6c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V420c0-44.1 43.1-80 96-80s96 35.9 96 80c0 31.1-22 59.6-56.1 72.7-21.2 8.1-39.2 22.3-52.1 40.9-13.1 19-19.9 41.8-19.9 64.9V620c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-22.7a48.3 48.3 0 0130.9-44.8c59-22.7 97.1-74.7 97.1-132.5.1-39.3-17.1-76-48.3-103.3zM472 732a40 40 0 1080 0 40 40 0 10-80 0z" } }] }, "name": "question-circle", "theme": "outlined" };
var QuestionCircleOutlined_default = QuestionCircleOutlined;

// ../../node_modules/@ant-design/icons/es/icons/QuestionCircleOutlined.js
var QuestionCircleOutlined2 = function QuestionCircleOutlined3(props, ref3) {
  return /* @__PURE__ */ React356.createElement(AntdIcon_default, _extends({}, props, {
    ref: ref3,
    icon: QuestionCircleOutlined_default
  }));
};
var RefIcon19 = /* @__PURE__ */ React356.forwardRef(QuestionCircleOutlined2);
if (true) {
  RefIcon19.displayName = "QuestionCircleOutlined";
}
var QuestionCircleOutlined_default2 = RefIcon19;

// ../../node_modules/antd/es/form/FormItemLabel.js
var import_classnames135 = __toESM(require_classnames());
var __rest42 = function(s, e3) {
  var t2 = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e3.indexOf(p) < 0) t2[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e3.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t2[p[i]] = s[p[i]];
  }
  return t2;
};
var FormItemLabel = ({
  prefixCls,
  label,
  htmlFor,
  labelCol,
  labelAlign,
  colon,
  required: required5,
  requiredMark,
  tooltip,
  vertical
}) => {
  var _a;
  const [formLocale] = useLocale_default("Form");
  const {
    labelAlign: contextLabelAlign,
    labelCol: contextLabelCol,
    labelWrap,
    colon: contextColon
  } = React357.useContext(FormContext2);
  if (!label) {
    return null;
  }
  const mergedLabelCol = labelCol || contextLabelCol || {};
  const mergedLabelAlign = labelAlign || contextLabelAlign;
  const labelClsBasic = `${prefixCls}-item-label`;
  const labelColClassName = (0, import_classnames135.default)(labelClsBasic, mergedLabelAlign === "left" && `${labelClsBasic}-left`, mergedLabelCol.className, {
    [`${labelClsBasic}-wrap`]: !!labelWrap
  });
  let labelChildren = label;
  const computedColon = colon === true || contextColon !== false && colon !== false;
  const haveColon = computedColon && !vertical;
  if (haveColon && typeof label === "string" && label.trim()) {
    labelChildren = label.replace(/[:|：]\s*$/, "");
  }
  const tooltipProps = convertToTooltipProps_default(tooltip);
  if (tooltipProps) {
    const {
      icon = /* @__PURE__ */ React357.createElement(QuestionCircleOutlined_default2, null)
    } = tooltipProps, restTooltipProps = __rest42(tooltipProps, ["icon"]);
    const tooltipNode = /* @__PURE__ */ React357.createElement(tooltip_default, Object.assign({}, restTooltipProps), /* @__PURE__ */ React357.cloneElement(icon, {
      className: `${prefixCls}-item-tooltip`,
      title: "",
      onClick: (e3) => {
        e3.preventDefault();
      },
      tabIndex: null
    }));
    labelChildren = /* @__PURE__ */ React357.createElement(React357.Fragment, null, labelChildren, tooltipNode);
  }
  const isOptionalMark = requiredMark === "optional";
  const isRenderMark = typeof requiredMark === "function";
  const hideRequiredMark = requiredMark === false;
  if (isRenderMark) {
    labelChildren = requiredMark(labelChildren, {
      required: !!required5
    });
  } else if (isOptionalMark && !required5) {
    labelChildren = /* @__PURE__ */ React357.createElement(React357.Fragment, null, labelChildren, /* @__PURE__ */ React357.createElement("span", {
      className: `${prefixCls}-item-optional`,
      title: ""
    }, (formLocale === null || formLocale === void 0 ? void 0 : formLocale.optional) || ((_a = en_US_default6.Form) === null || _a === void 0 ? void 0 : _a.optional)));
  }
  let markType;
  if (hideRequiredMark) {
    markType = "hidden";
  } else if (isOptionalMark || isRenderMark) {
    markType = "optional";
  }
  const labelClassName = (0, import_classnames135.default)({
    [`${prefixCls}-item-required`]: required5,
    [`${prefixCls}-item-required-mark-${markType}`]: markType,
    [`${prefixCls}-item-no-colon`]: !computedColon
  });
  return /* @__PURE__ */ React357.createElement(col_default, Object.assign({}, mergedLabelCol, {
    className: labelColClassName
  }), /* @__PURE__ */ React357.createElement("label", {
    htmlFor,
    className: labelClassName,
    title: typeof label === "string" ? label : ""
  }, labelChildren));
};
var FormItemLabel_default = FormItemLabel;

// ../../node_modules/antd/es/form/FormItem/StatusProvider.js
var React358 = __toESM(require_react());
var import_classnames136 = __toESM(require_classnames());
var iconMap = {
  success: CheckCircleFilled_default2,
  warning: ExclamationCircleFilled_default2,
  error: CloseCircleFilled_default2,
  validating: LoadingOutlined_default2
};
function StatusProvider({
  children,
  errors,
  warnings,
  hasFeedback,
  validateStatus,
  prefixCls,
  meta,
  noStyle,
  name
}) {
  const itemPrefixCls = `${prefixCls}-item`;
  const {
    feedbackIcons
  } = React358.useContext(FormContext2);
  const mergedValidateStatus = getStatus(errors, warnings, meta, null, !!hasFeedback, validateStatus);
  const {
    isFormItemInput: parentIsFormItemInput,
    status: parentStatus,
    hasFeedback: parentHasFeedback,
    feedbackIcon: parentFeedbackIcon,
    name: parentName
  } = React358.useContext(FormItemInputContext);
  const formItemStatusContext = React358.useMemo(() => {
    var _a;
    let feedbackIcon;
    if (hasFeedback) {
      const customIcons = hasFeedback !== true && hasFeedback.icons || feedbackIcons;
      const customIconNode = mergedValidateStatus && ((_a = customIcons === null || customIcons === void 0 ? void 0 : customIcons({
        status: mergedValidateStatus,
        errors,
        warnings
      })) === null || _a === void 0 ? void 0 : _a[mergedValidateStatus]);
      const IconNode = mergedValidateStatus && iconMap[mergedValidateStatus];
      feedbackIcon = customIconNode !== false && IconNode ? /* @__PURE__ */ React358.createElement("span", {
        className: (0, import_classnames136.default)(`${itemPrefixCls}-feedback-icon`, `${itemPrefixCls}-feedback-icon-${mergedValidateStatus}`)
      }, customIconNode || /* @__PURE__ */ React358.createElement(IconNode, null)) : null;
    }
    const context = {
      status: mergedValidateStatus || "",
      errors,
      warnings,
      hasFeedback: !!hasFeedback,
      feedbackIcon,
      isFormItemInput: true,
      name
    };
    if (noStyle) {
      context.status = (mergedValidateStatus !== null && mergedValidateStatus !== void 0 ? mergedValidateStatus : parentStatus) || "";
      context.isFormItemInput = parentIsFormItemInput;
      context.hasFeedback = !!(hasFeedback !== null && hasFeedback !== void 0 ? hasFeedback : parentHasFeedback);
      context.feedbackIcon = hasFeedback !== void 0 ? context.feedbackIcon : parentFeedbackIcon;
      context.name = name !== null && name !== void 0 ? name : parentName;
    }
    return context;
  }, [mergedValidateStatus, hasFeedback, noStyle, parentIsFormItemInput, parentStatus]);
  return /* @__PURE__ */ React358.createElement(FormItemInputContext.Provider, {
    value: formItemStatusContext
  }, children);
}

// ../../node_modules/antd/es/form/FormItem/ItemHolder.js
var __rest43 = function(s, e3) {
  var t2 = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e3.indexOf(p) < 0) t2[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e3.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t2[p[i]] = s[p[i]];
  }
  return t2;
};
function ItemHolder(props) {
  const {
    prefixCls,
    className: className2,
    rootClassName,
    style: style2,
    help,
    errors,
    warnings,
    validateStatus,
    meta,
    hasFeedback,
    hidden,
    children,
    fieldId,
    required: required5,
    isRequired,
    onSubItemMetaChange,
    layout: propsLayout,
    name
  } = props, restProps = __rest43(props, ["prefixCls", "className", "rootClassName", "style", "help", "errors", "warnings", "validateStatus", "meta", "hasFeedback", "hidden", "children", "fieldId", "required", "isRequired", "onSubItemMetaChange", "layout", "name"]);
  const itemPrefixCls = `${prefixCls}-item`;
  const {
    requiredMark,
    layout: formLayout
  } = React359.useContext(FormContext2);
  const layout = propsLayout || formLayout;
  const vertical = layout === "vertical";
  const itemRef = React359.useRef(null);
  const debounceErrors = useDebounce(errors);
  const debounceWarnings = useDebounce(warnings);
  const hasHelp = help !== void 0 && help !== null;
  const hasError = !!(hasHelp || errors.length || warnings.length);
  const isOnScreen = !!itemRef.current && isVisible_default(itemRef.current);
  const [marginBottom, setMarginBottom] = React359.useState(null);
  useLayoutEffect_default(() => {
    if (hasError && itemRef.current) {
      const itemStyle = getComputedStyle(itemRef.current);
      setMarginBottom(parseInt(itemStyle.marginBottom, 10));
    }
  }, [hasError, isOnScreen]);
  const onErrorVisibleChanged = (nextVisible) => {
    if (!nextVisible) {
      setMarginBottom(null);
    }
  };
  const getValidateState = (isDebounce = false) => {
    const _errors = isDebounce ? debounceErrors : meta.errors;
    const _warnings = isDebounce ? debounceWarnings : meta.warnings;
    return getStatus(_errors, _warnings, meta, "", !!hasFeedback, validateStatus);
  };
  const mergedValidateStatus = getValidateState();
  const itemClassName = (0, import_classnames137.default)(itemPrefixCls, className2, rootClassName, {
    [`${itemPrefixCls}-with-help`]: hasHelp || debounceErrors.length || debounceWarnings.length,
    // Status
    [`${itemPrefixCls}-has-feedback`]: mergedValidateStatus && hasFeedback,
    [`${itemPrefixCls}-has-success`]: mergedValidateStatus === "success",
    [`${itemPrefixCls}-has-warning`]: mergedValidateStatus === "warning",
    [`${itemPrefixCls}-has-error`]: mergedValidateStatus === "error",
    [`${itemPrefixCls}-is-validating`]: mergedValidateStatus === "validating",
    [`${itemPrefixCls}-hidden`]: hidden,
    // Layout
    [`${itemPrefixCls}-${layout}`]: layout
  });
  return /* @__PURE__ */ React359.createElement("div", {
    className: itemClassName,
    style: style2,
    ref: itemRef
  }, /* @__PURE__ */ React359.createElement(row_default, Object.assign({
    className: `${itemPrefixCls}-row`
  }, omit(restProps, [
    "_internalItemRender",
    "colon",
    "dependencies",
    "extra",
    "fieldKey",
    "getValueFromEvent",
    "getValueProps",
    "htmlFor",
    "id",
    // It is deprecated because `htmlFor` is its replacement.
    "initialValue",
    "isListField",
    "label",
    "labelAlign",
    "labelCol",
    "labelWrap",
    "messageVariables",
    "name",
    "normalize",
    "noStyle",
    "preserve",
    "requiredMark",
    "rules",
    "shouldUpdate",
    "trigger",
    "tooltip",
    "validateFirst",
    "validateTrigger",
    "valuePropName",
    "wrapperCol",
    "validateDebounce"
  ])), /* @__PURE__ */ React359.createElement(FormItemLabel_default, Object.assign({
    htmlFor: fieldId
  }, props, {
    requiredMark,
    required: required5 !== null && required5 !== void 0 ? required5 : isRequired,
    prefixCls,
    vertical
  })), /* @__PURE__ */ React359.createElement(FormItemInput_default, Object.assign({}, props, meta, {
    errors: debounceErrors,
    warnings: debounceWarnings,
    prefixCls,
    status: mergedValidateStatus,
    help,
    marginBottom,
    onErrorVisibleChanged
  }), /* @__PURE__ */ React359.createElement(NoStyleItemContext.Provider, {
    value: onSubItemMetaChange
  }, /* @__PURE__ */ React359.createElement(StatusProvider, {
    prefixCls,
    meta,
    errors: meta.errors,
    warnings: meta.warnings,
    hasFeedback,
    // Already calculated
    validateStatus: mergedValidateStatus,
    name
  }, children)))), !!marginBottom && /* @__PURE__ */ React359.createElement("div", {
    className: `${itemPrefixCls}-margin-offset`,
    style: {
      marginBottom: -marginBottom
    }
  }));
}

// ../../node_modules/antd/es/form/FormItem/index.js
var NAME_SPLIT = "__SPLIT__";
function isSimilarControl(a, b) {
  const keysA = Object.keys(a);
  const keysB = Object.keys(b);
  return keysA.length === keysB.length && keysA.every((key2) => {
    const propValueA = a[key2];
    const propValueB = b[key2];
    return propValueA === propValueB || typeof propValueA === "function" || typeof propValueB === "function";
  });
}
var MemoInput = /* @__PURE__ */ React360.memo(({
  children
}) => children, (prev2, next2) => isSimilarControl(prev2.control, next2.control) && prev2.update === next2.update && prev2.childProps.length === next2.childProps.length && prev2.childProps.every((value, index3) => value === next2.childProps[index3]));
function genEmptyMeta() {
  return {
    errors: [],
    warnings: [],
    touched: false,
    validating: false,
    name: [],
    validated: false
  };
}
function InternalFormItem(props) {
  const {
    name,
    noStyle,
    className: className2,
    dependencies,
    prefixCls: customizePrefixCls,
    shouldUpdate,
    rules,
    children,
    required: required5,
    label,
    messageVariables,
    trigger: trigger2 = "onChange",
    validateTrigger,
    hidden,
    help,
    layout
  } = props;
  const {
    getPrefixCls
  } = React360.useContext(ConfigContext);
  const {
    name: formName
  } = React360.useContext(FormContext2);
  const mergedChildren = useChildren2(children);
  const isRenderProps = typeof mergedChildren === "function";
  const notifyParentMetaChange = React360.useContext(NoStyleItemContext);
  const {
    validateTrigger: contextValidateTrigger
  } = React360.useContext(FieldContext_default);
  const mergedValidateTrigger = validateTrigger !== void 0 ? validateTrigger : contextValidateTrigger;
  const hasName = !(name === void 0 || name === null);
  const prefixCls = getPrefixCls("form", customizePrefixCls);
  const rootCls = useCSSVarCls_default(prefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = style_default25(prefixCls, rootCls);
  const warning6 = devUseWarning("Form.Item");
  if (true) {
    true ? warning6(name !== null, "usage", "`null` is passed as `name` property") : void 0;
  }
  const listContext = React360.useContext(ListContext_default);
  const fieldKeyPathRef = React360.useRef(null);
  const [subFieldErrors, setSubFieldErrors] = useFrameState({});
  const [meta, setMeta] = useSafeState(() => genEmptyMeta());
  const onMetaChange = (nextMeta) => {
    const keyInfo = listContext === null || listContext === void 0 ? void 0 : listContext.getKey(nextMeta.name);
    setMeta(nextMeta.destroy ? genEmptyMeta() : nextMeta, true);
    if (noStyle && help !== false && notifyParentMetaChange) {
      let namePath = nextMeta.name;
      if (!nextMeta.destroy) {
        if (keyInfo !== void 0) {
          const [fieldKey, restPath] = keyInfo;
          namePath = [fieldKey].concat(_toConsumableArray(restPath));
          fieldKeyPathRef.current = namePath;
        }
      } else {
        namePath = fieldKeyPathRef.current || namePath;
      }
      notifyParentMetaChange(nextMeta, namePath);
    }
  };
  const onSubItemMetaChange = (subMeta, uniqueKeys) => {
    setSubFieldErrors((prevSubFieldErrors) => {
      const clone = Object.assign({}, prevSubFieldErrors);
      const mergedNamePath = [].concat(_toConsumableArray(subMeta.name.slice(0, -1)), _toConsumableArray(uniqueKeys));
      const mergedNameKey = mergedNamePath.join(NAME_SPLIT);
      if (subMeta.destroy) {
        delete clone[mergedNameKey];
      } else {
        clone[mergedNameKey] = subMeta;
      }
      return clone;
    });
  };
  const [mergedErrors, mergedWarnings] = React360.useMemo(() => {
    const errorList = _toConsumableArray(meta.errors);
    const warningList = _toConsumableArray(meta.warnings);
    Object.values(subFieldErrors).forEach((subFieldError) => {
      errorList.push.apply(errorList, _toConsumableArray(subFieldError.errors || []));
      warningList.push.apply(warningList, _toConsumableArray(subFieldError.warnings || []));
    });
    return [errorList, warningList];
  }, [subFieldErrors, meta.errors, meta.warnings]);
  const getItemRef = useItemRef();
  function renderLayout(baseChildren, fieldId, isRequired) {
    if (noStyle && !hidden) {
      return /* @__PURE__ */ React360.createElement(StatusProvider, {
        prefixCls,
        hasFeedback: props.hasFeedback,
        validateStatus: props.validateStatus,
        meta,
        errors: mergedErrors,
        warnings: mergedWarnings,
        noStyle: true,
        name
      }, baseChildren);
    }
    return /* @__PURE__ */ React360.createElement(ItemHolder, Object.assign({
      key: "row"
    }, props, {
      className: (0, import_classnames138.default)(className2, cssVarCls, rootCls, hashId),
      prefixCls,
      fieldId,
      isRequired,
      errors: mergedErrors,
      warnings: mergedWarnings,
      meta,
      onSubItemMetaChange,
      layout,
      name
    }), baseChildren);
  }
  if (!hasName && !isRenderProps && !dependencies) {
    return wrapCSSVar(renderLayout(mergedChildren));
  }
  let variables = {};
  if (typeof label === "string") {
    variables.label = label;
  } else if (name) {
    variables.label = String(name);
  }
  if (messageVariables) {
    variables = Object.assign(Object.assign({}, variables), messageVariables);
  }
  return wrapCSSVar(/* @__PURE__ */ React360.createElement(Field_default, Object.assign({}, props, {
    messageVariables: variables,
    trigger: trigger2,
    validateTrigger: mergedValidateTrigger,
    onMetaChange
  }), (control, renderMeta, context) => {
    const mergedName = toArray6(name).length && renderMeta ? renderMeta.name : [];
    const fieldId = getFieldId(mergedName, formName);
    const isRequired = required5 !== void 0 ? required5 : !!(rules === null || rules === void 0 ? void 0 : rules.some((rule) => {
      if (rule && typeof rule === "object" && rule.required && !rule.warningOnly) {
        return true;
      }
      if (typeof rule === "function") {
        const ruleEntity = rule(context);
        return (ruleEntity === null || ruleEntity === void 0 ? void 0 : ruleEntity.required) && !(ruleEntity === null || ruleEntity === void 0 ? void 0 : ruleEntity.warningOnly);
      }
      return false;
    }));
    const mergedControl = Object.assign({}, control);
    let childNode = null;
    true ? warning6(!(shouldUpdate && dependencies), "usage", "`shouldUpdate` and `dependencies` shouldn't be used together. See https://u.ant.design/form-deps.") : void 0;
    if (Array.isArray(mergedChildren) && hasName) {
      true ? warning6(false, "usage", "A `Form.Item` with a `name` prop must have a single child element. For information on how to render more complex form items, see https://u.ant.design/complex-form-item.") : void 0;
      childNode = mergedChildren;
    } else if (isRenderProps && (!(shouldUpdate || dependencies) || hasName)) {
      true ? warning6(!!(shouldUpdate || dependencies), "usage", "A `Form.Item` with a render function must have either `shouldUpdate` or `dependencies`.") : void 0;
      true ? warning6(!hasName, "usage", "A `Form.Item` with a render function cannot be a field, and thus cannot have a `name` prop.") : void 0;
    } else if (dependencies && !isRenderProps && !hasName) {
      true ? warning6(false, "usage", "Must set `name` or use a render function when `dependencies` is set.") : void 0;
    } else if (/* @__PURE__ */ React360.isValidElement(mergedChildren)) {
      true ? warning6(mergedChildren.props.defaultValue === void 0, "usage", "`defaultValue` will not work on controlled Field. You should use `initialValues` of Form instead.") : void 0;
      const childProps = Object.assign(Object.assign({}, mergedChildren.props), mergedControl);
      if (!childProps.id) {
        childProps.id = fieldId;
      }
      if (help || mergedErrors.length > 0 || mergedWarnings.length > 0 || props.extra) {
        const describedbyArr = [];
        if (help || mergedErrors.length > 0) {
          describedbyArr.push(`${fieldId}_help`);
        }
        if (props.extra) {
          describedbyArr.push(`${fieldId}_extra`);
        }
        childProps["aria-describedby"] = describedbyArr.join(" ");
      }
      if (mergedErrors.length > 0) {
        childProps["aria-invalid"] = "true";
      }
      if (isRequired) {
        childProps["aria-required"] = "true";
      }
      if (supportRef(mergedChildren)) {
        childProps.ref = getItemRef(mergedName, mergedChildren);
      }
      const triggers = new Set([].concat(_toConsumableArray(toArray6(trigger2)), _toConsumableArray(toArray6(mergedValidateTrigger))));
      triggers.forEach((eventName) => {
        childProps[eventName] = (...args) => {
          var _a2, _c2;
          var _a, _b, _c;
          (_a = mergedControl[eventName]) === null || _a === void 0 ? void 0 : (_a2 = _a).call.apply(_a2, [mergedControl].concat(args));
          (_c = (_b = mergedChildren.props)[eventName]) === null || _c === void 0 ? void 0 : (_c2 = _c).call.apply(_c2, [_b].concat(args));
        };
      });
      const watchingChildProps = [childProps["aria-required"], childProps["aria-invalid"], childProps["aria-describedby"]];
      childNode = /* @__PURE__ */ React360.createElement(MemoInput, {
        control: mergedControl,
        update: mergedChildren,
        childProps: watchingChildProps
      }, cloneElement4(mergedChildren, childProps));
    } else if (isRenderProps && (shouldUpdate || dependencies) && !hasName) {
      childNode = mergedChildren(context);
    } else {
      true ? warning6(!mergedName.length || !!noStyle, "usage", "`name` is only used for validate React element. If you are using Form.Item as layout display, please remove `name` instead.") : void 0;
      childNode = mergedChildren;
    }
    return renderLayout(childNode, fieldId, isRequired);
  }));
}
var FormItem = InternalFormItem;
FormItem.useStatus = useFormItemStatus_default;
var FormItem_default = FormItem;

// ../../node_modules/antd/es/form/FormList.js
var React361 = __toESM(require_react());
var __rest44 = function(s, e3) {
  var t2 = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e3.indexOf(p) < 0) t2[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e3.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t2[p[i]] = s[p[i]];
  }
  return t2;
};
var FormList = (_a) => {
  var {
    prefixCls: customizePrefixCls,
    children
  } = _a, props = __rest44(_a, ["prefixCls", "children"]);
  if (true) {
    const warning6 = devUseWarning("Form.List");
    true ? warning6(typeof props.name === "number" || (Array.isArray(props.name) ? !!props.name.length : !!props.name), "usage", "Miss `name` prop.") : void 0;
  }
  const {
    getPrefixCls
  } = React361.useContext(ConfigContext);
  const prefixCls = getPrefixCls("form", customizePrefixCls);
  const contextValue = React361.useMemo(() => ({
    prefixCls,
    status: "error"
  }), [prefixCls]);
  return /* @__PURE__ */ React361.createElement(List_default, Object.assign({}, props), (fields, operation, meta) => /* @__PURE__ */ React361.createElement(FormItemPrefixContext.Provider, {
    value: contextValue
  }, children(fields.map((field) => Object.assign(Object.assign({}, field), {
    fieldKey: field.key
  })), operation, {
    errors: meta.errors,
    warnings: meta.warnings
  })));
};
var FormList_default = FormList;

// ../../node_modules/antd/es/form/hooks/useFormInstance.js
var React362 = __toESM(require_react());
function useFormInstance() {
  const {
    form
  } = React362.useContext(FormContext2);
  return form;
}

// ../../node_modules/antd/es/form/index.js
var Form4 = Form_default2;
Form4.Item = FormItem_default;
Form4.List = FormList_default;
Form4.ErrorList = ErrorList_default;
Form4.useForm = useForm2;
Form4.useFormInstance = useFormInstance;
Form4.useWatch = useWatch_default;
Form4.Provider = FormProvider3;
Form4.create = () => {
  true ? warning_default2(false, "Form", "antd v4 removed `Form.create`. Please remove or use `@ant-design/compatible` instead.") : void 0;
};
var form_default = Form4;

// ../../node_modules/antd/es/image/index.js
var React377 = __toESM(require_react());

// ../../node_modules/@ant-design/icons/es/icons/EyeOutlined.js
var React363 = __toESM(require_react());

// ../../node_modules/@ant-design/icons-svg/es/asn/EyeOutlined.js
var EyeOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z" } }] }, "name": "eye", "theme": "outlined" };
var EyeOutlined_default = EyeOutlined;

// ../../node_modules/@ant-design/icons/es/icons/EyeOutlined.js
var EyeOutlined2 = function EyeOutlined3(props, ref3) {
  return /* @__PURE__ */ React363.createElement(AntdIcon_default, _extends({}, props, {
    ref: ref3,
    icon: EyeOutlined_default
  }));
};
var RefIcon20 = /* @__PURE__ */ React363.forwardRef(EyeOutlined2);
if (true) {
  RefIcon20.displayName = "EyeOutlined";
}
var EyeOutlined_default2 = RefIcon20;

// ../../node_modules/antd/es/image/index.js
var import_classnames143 = __toESM(require_classnames());

// ../../node_modules/rc-image/es/Image.js
var import_classnames141 = __toESM(require_classnames());

// ../../node_modules/rc-util/es/Dom/css.js
function getClientSize() {
  var width = document.documentElement.clientWidth;
  var height = window.innerHeight || document.documentElement.clientHeight;
  return {
    width,
    height
  };
}
function getOffset3(node2) {
  var box2 = node2.getBoundingClientRect();
  var docElem = document.documentElement;
  return {
    left: box2.left + (window.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || document.body.clientLeft || 0),
    top: box2.top + (window.pageYOffset || docElem.scrollTop) - (docElem.clientTop || document.body.clientTop || 0)
  };
}

// ../../node_modules/rc-image/es/Image.js
var React370 = __toESM(require_react());
var import_react123 = __toESM(require_react());

// ../../node_modules/rc-image/es/Preview.js
var import_classnames140 = __toESM(require_classnames());

// ../../node_modules/rc-util/es/Dom/addEventListener.js
var import_react_dom10 = __toESM(require_react_dom());
function addEventListenerWrap(target, eventType, cb, option) {
  var callback = import_react_dom10.default.unstable_batchedUpdates ? function run(e3) {
    import_react_dom10.default.unstable_batchedUpdates(cb, e3);
  } : cb;
  if (target !== null && target !== void 0 && target.addEventListener) {
    target.addEventListener(eventType, callback, option);
  }
  return {
    remove: function remove() {
      if (target !== null && target !== void 0 && target.removeEventListener) {
        target.removeEventListener(eventType, callback, option);
      }
    }
  };
}

// ../../node_modules/rc-image/es/Preview.js
var import_react121 = __toESM(require_react());

// ../../node_modules/rc-image/es/Operations.js
var import_classnames139 = __toESM(require_classnames());
var React365 = __toESM(require_react());
var import_react116 = __toESM(require_react());

// ../../node_modules/rc-image/es/context.js
var React364 = __toESM(require_react());
var PreviewGroupContext = /* @__PURE__ */ React364.createContext(null);

// ../../node_modules/rc-image/es/Operations.js
var Operations = function Operations2(props) {
  var visible = props.visible, maskTransitionName = props.maskTransitionName, getContainer2 = props.getContainer, prefixCls = props.prefixCls, rootClassName = props.rootClassName, icons3 = props.icons, countRender = props.countRender, showSwitch = props.showSwitch, showProgress = props.showProgress, current2 = props.current, transform = props.transform, count = props.count, scale = props.scale, minScale = props.minScale, maxScale = props.maxScale, closeIcon = props.closeIcon, onActive = props.onActive, onClose = props.onClose, onZoomIn = props.onZoomIn, onZoomOut = props.onZoomOut, onRotateRight = props.onRotateRight, onRotateLeft = props.onRotateLeft, onFlipX = props.onFlipX, onFlipY = props.onFlipY, onReset = props.onReset, toolbarRender = props.toolbarRender, zIndex = props.zIndex, image = props.image;
  var groupContext = (0, import_react116.useContext)(PreviewGroupContext);
  var rotateLeft = icons3.rotateLeft, rotateRight = icons3.rotateRight, zoomIn2 = icons3.zoomIn, zoomOut2 = icons3.zoomOut, close = icons3.close, left2 = icons3.left, right2 = icons3.right, flipX = icons3.flipX, flipY = icons3.flipY;
  var toolClassName = "".concat(prefixCls, "-operations-operation");
  React365.useEffect(function() {
    var onKeyDown2 = function onKeyDown3(e3) {
      if (e3.keyCode === KeyCode_default.ESC) {
        onClose();
      }
    };
    if (visible) {
      window.addEventListener("keydown", onKeyDown2);
    }
    return function() {
      window.removeEventListener("keydown", onKeyDown2);
    };
  }, [visible]);
  var handleActive = function handleActive2(e3, offset4) {
    e3.preventDefault();
    e3.stopPropagation();
    onActive(offset4);
  };
  var renderOperation = React365.useCallback(function(_ref) {
    var type5 = _ref.type, disabled = _ref.disabled, onClick = _ref.onClick, icon = _ref.icon;
    return /* @__PURE__ */ React365.createElement("div", {
      key: type5,
      className: (0, import_classnames139.default)(toolClassName, "".concat(prefixCls, "-operations-operation-").concat(type5), _defineProperty({}, "".concat(prefixCls, "-operations-operation-disabled"), !!disabled)),
      onClick
    }, icon);
  }, [toolClassName, prefixCls]);
  var switchPrevNode = showSwitch ? renderOperation({
    icon: left2,
    onClick: function onClick(e3) {
      return handleActive(e3, -1);
    },
    type: "prev",
    disabled: current2 === 0
  }) : void 0;
  var switchNextNode = showSwitch ? renderOperation({
    icon: right2,
    onClick: function onClick(e3) {
      return handleActive(e3, 1);
    },
    type: "next",
    disabled: current2 === count - 1
  }) : void 0;
  var flipYNode = renderOperation({
    icon: flipY,
    onClick: onFlipY,
    type: "flipY"
  });
  var flipXNode = renderOperation({
    icon: flipX,
    onClick: onFlipX,
    type: "flipX"
  });
  var rotateLeftNode = renderOperation({
    icon: rotateLeft,
    onClick: onRotateLeft,
    type: "rotateLeft"
  });
  var rotateRightNode = renderOperation({
    icon: rotateRight,
    onClick: onRotateRight,
    type: "rotateRight"
  });
  var zoomOutNode = renderOperation({
    icon: zoomOut2,
    onClick: onZoomOut,
    type: "zoomOut",
    disabled: scale <= minScale
  });
  var zoomInNode = renderOperation({
    icon: zoomIn2,
    onClick: onZoomIn,
    type: "zoomIn",
    disabled: scale === maxScale
  });
  var toolbarNode = /* @__PURE__ */ React365.createElement("div", {
    className: "".concat(prefixCls, "-operations")
  }, flipYNode, flipXNode, rotateLeftNode, rotateRightNode, zoomOutNode, zoomInNode);
  return /* @__PURE__ */ React365.createElement(es_default2, {
    visible,
    motionName: maskTransitionName
  }, function(_ref2) {
    var className2 = _ref2.className, style2 = _ref2.style;
    return /* @__PURE__ */ React365.createElement(es_default4, {
      open: true,
      getContainer: getContainer2 !== null && getContainer2 !== void 0 ? getContainer2 : document.body
    }, /* @__PURE__ */ React365.createElement("div", {
      className: (0, import_classnames139.default)("".concat(prefixCls, "-operations-wrapper"), className2, rootClassName),
      style: _objectSpread2(_objectSpread2({}, style2), {}, {
        zIndex
      })
    }, closeIcon === null ? null : /* @__PURE__ */ React365.createElement("button", {
      className: "".concat(prefixCls, "-close"),
      onClick: onClose
    }, closeIcon || close), showSwitch && /* @__PURE__ */ React365.createElement(React365.Fragment, null, /* @__PURE__ */ React365.createElement("div", {
      className: (0, import_classnames139.default)("".concat(prefixCls, "-switch-left"), _defineProperty({}, "".concat(prefixCls, "-switch-left-disabled"), current2 === 0)),
      onClick: function onClick(e3) {
        return handleActive(e3, -1);
      }
    }, left2), /* @__PURE__ */ React365.createElement("div", {
      className: (0, import_classnames139.default)("".concat(prefixCls, "-switch-right"), _defineProperty({}, "".concat(prefixCls, "-switch-right-disabled"), current2 === count - 1)),
      onClick: function onClick(e3) {
        return handleActive(e3, 1);
      }
    }, right2)), /* @__PURE__ */ React365.createElement("div", {
      className: "".concat(prefixCls, "-footer")
    }, showProgress && /* @__PURE__ */ React365.createElement("div", {
      className: "".concat(prefixCls, "-progress")
    }, countRender ? countRender(current2 + 1, count) : /* @__PURE__ */ React365.createElement("bdi", null, "".concat(current2 + 1, " / ").concat(count))), toolbarRender ? toolbarRender(toolbarNode, _objectSpread2(_objectSpread2({
      icons: {
        prevIcon: switchPrevNode,
        nextIcon: switchNextNode,
        flipYIcon: flipYNode,
        flipXIcon: flipXNode,
        rotateLeftIcon: rotateLeftNode,
        rotateRightIcon: rotateRightNode,
        zoomOutIcon: zoomOutNode,
        zoomInIcon: zoomInNode
      },
      actions: {
        onActive,
        onFlipY,
        onFlipX,
        onRotateLeft,
        onRotateRight,
        onZoomOut,
        onZoomIn,
        onReset,
        onClose
      },
      transform
    }, groupContext ? {
      current: current2,
      total: count
    } : {}), {}, {
      image
    })) : toolbarNode)));
  });
};
var Operations_default = Operations;

// ../../node_modules/rc-image/es/hooks/useImageTransform.js
var import_react117 = __toESM(require_react());
var initialTransform = {
  x: 0,
  y: 0,
  rotate: 0,
  scale: 1,
  flipX: false,
  flipY: false
};
function useImageTransform(imgRef, minScale, maxScale, onTransform) {
  var frame = (0, import_react117.useRef)(null);
  var queue = (0, import_react117.useRef)([]);
  var _useState = (0, import_react117.useState)(initialTransform), _useState2 = _slicedToArray(_useState, 2), transform = _useState2[0], setTransform = _useState2[1];
  var resetTransform = function resetTransform2(action) {
    setTransform(initialTransform);
    if (!isEqual_default(initialTransform, transform)) {
      onTransform === null || onTransform === void 0 || onTransform({
        transform: initialTransform,
        action
      });
    }
  };
  var updateTransform = function updateTransform2(newTransform, action) {
    if (frame.current === null) {
      queue.current = [];
      frame.current = raf_default(function() {
        setTransform(function(preState) {
          var memoState = preState;
          queue.current.forEach(function(queueState) {
            memoState = _objectSpread2(_objectSpread2({}, memoState), queueState);
          });
          frame.current = null;
          onTransform === null || onTransform === void 0 || onTransform({
            transform: memoState,
            action
          });
          return memoState;
        });
      });
    }
    queue.current.push(_objectSpread2(_objectSpread2({}, transform), newTransform));
  };
  var dispatchZoomChange = function dispatchZoomChange2(ratio, action, centerX, centerY, isTouch) {
    var _imgRef$current = imgRef.current, width = _imgRef$current.width, height = _imgRef$current.height, offsetWidth = _imgRef$current.offsetWidth, offsetHeight = _imgRef$current.offsetHeight, offsetLeft = _imgRef$current.offsetLeft, offsetTop = _imgRef$current.offsetTop;
    var newRatio = ratio;
    var newScale = transform.scale * ratio;
    if (newScale > maxScale) {
      newScale = maxScale;
      newRatio = maxScale / transform.scale;
    } else if (newScale < minScale) {
      newScale = isTouch ? newScale : minScale;
      newRatio = newScale / transform.scale;
    }
    var mergedCenterX = centerX !== null && centerX !== void 0 ? centerX : innerWidth / 2;
    var mergedCenterY = centerY !== null && centerY !== void 0 ? centerY : innerHeight / 2;
    var diffRatio = newRatio - 1;
    var diffImgX = diffRatio * width * 0.5;
    var diffImgY = diffRatio * height * 0.5;
    var diffOffsetLeft = diffRatio * (mergedCenterX - transform.x - offsetLeft);
    var diffOffsetTop = diffRatio * (mergedCenterY - transform.y - offsetTop);
    var newX = transform.x - (diffOffsetLeft - diffImgX);
    var newY = transform.y - (diffOffsetTop - diffImgY);
    if (ratio < 1 && newScale === 1) {
      var mergedWidth = offsetWidth * newScale;
      var mergedHeight = offsetHeight * newScale;
      var _getClientSize = getClientSize(), clientWidth = _getClientSize.width, clientHeight = _getClientSize.height;
      if (mergedWidth <= clientWidth && mergedHeight <= clientHeight) {
        newX = 0;
        newY = 0;
      }
    }
    updateTransform({
      x: newX,
      y: newY,
      scale: newScale
    }, action);
  };
  return {
    transform,
    resetTransform,
    updateTransform,
    dispatchZoomChange
  };
}

// ../../node_modules/rc-image/es/hooks/useMouseEvent.js
var import_react118 = __toESM(require_react());

// ../../node_modules/rc-image/es/getFixScaleEleTransPosition.js
function fixPoint(key2, start, width, clientWidth) {
  var startAddWidth = start + width;
  var offsetStart = (width - clientWidth) / 2;
  if (width > clientWidth) {
    if (start > 0) {
      return _defineProperty({}, key2, offsetStart);
    }
    if (start < 0 && startAddWidth < clientWidth) {
      return _defineProperty({}, key2, -offsetStart);
    }
  } else if (start < 0 || startAddWidth > clientWidth) {
    return _defineProperty({}, key2, start < 0 ? offsetStart : -offsetStart);
  }
  return {};
}
function getFixScaleEleTransPosition(width, height, left2, top) {
  var _getClientSize = getClientSize(), clientWidth = _getClientSize.width, clientHeight = _getClientSize.height;
  var fixPos = null;
  if (width <= clientWidth && height <= clientHeight) {
    fixPos = {
      x: 0,
      y: 0
    };
  } else if (width > clientWidth || height > clientHeight) {
    fixPos = _objectSpread2(_objectSpread2({}, fixPoint("x", left2, width, clientWidth)), fixPoint("y", top, height, clientHeight));
  }
  return fixPos;
}

// ../../node_modules/rc-image/es/previewConfig.js
var BASE_SCALE_RATIO = 1;
var WHEEL_MAX_SCALE_RATIO = 1;

// ../../node_modules/rc-image/es/hooks/useMouseEvent.js
function useMouseEvent(imgRef, movable, visible, scaleStep, transform, updateTransform, dispatchZoomChange) {
  var rotate2 = transform.rotate, scale = transform.scale, x = transform.x, y = transform.y;
  var _useState = (0, import_react118.useState)(false), _useState2 = _slicedToArray(_useState, 2), isMoving = _useState2[0], setMoving = _useState2[1];
  var startPositionInfo = (0, import_react118.useRef)({
    diffX: 0,
    diffY: 0,
    transformX: 0,
    transformY: 0
  });
  var onMouseDown = function onMouseDown2(event) {
    if (!movable || event.button !== 0) return;
    event.preventDefault();
    event.stopPropagation();
    startPositionInfo.current = {
      diffX: event.pageX - x,
      diffY: event.pageY - y,
      transformX: x,
      transformY: y
    };
    setMoving(true);
  };
  var onMouseMove = function onMouseMove2(event) {
    if (visible && isMoving) {
      updateTransform({
        x: event.pageX - startPositionInfo.current.diffX,
        y: event.pageY - startPositionInfo.current.diffY
      }, "move");
    }
  };
  var onMouseUp = function onMouseUp2() {
    if (visible && isMoving) {
      setMoving(false);
      var _startPositionInfo$cu = startPositionInfo.current, transformX = _startPositionInfo$cu.transformX, transformY = _startPositionInfo$cu.transformY;
      var hasChangedPosition = x !== transformX && y !== transformY;
      if (!hasChangedPosition) return;
      var width = imgRef.current.offsetWidth * scale;
      var height = imgRef.current.offsetHeight * scale;
      var _imgRef$current$getBo = imgRef.current.getBoundingClientRect(), left2 = _imgRef$current$getBo.left, top = _imgRef$current$getBo.top;
      var isRotate = rotate2 % 180 !== 0;
      var fixState = getFixScaleEleTransPosition(isRotate ? height : width, isRotate ? width : height, left2, top);
      if (fixState) {
        updateTransform(_objectSpread2({}, fixState), "dragRebound");
      }
    }
  };
  var onWheel = function onWheel2(event) {
    if (!visible || event.deltaY == 0) return;
    var scaleRatio = Math.abs(event.deltaY / 100);
    var mergedScaleRatio = Math.min(scaleRatio, WHEEL_MAX_SCALE_RATIO);
    var ratio = BASE_SCALE_RATIO + mergedScaleRatio * scaleStep;
    if (event.deltaY > 0) {
      ratio = BASE_SCALE_RATIO / ratio;
    }
    dispatchZoomChange(ratio, "wheel", event.clientX, event.clientY);
  };
  (0, import_react118.useEffect)(function() {
    var onTopMouseUpListener;
    var onTopMouseMoveListener;
    var onMouseUpListener;
    var onMouseMoveListener;
    if (movable) {
      onMouseUpListener = addEventListenerWrap(window, "mouseup", onMouseUp, false);
      onMouseMoveListener = addEventListenerWrap(window, "mousemove", onMouseMove, false);
      try {
        if (window.top !== window.self) {
          onTopMouseUpListener = addEventListenerWrap(window.top, "mouseup", onMouseUp, false);
          onTopMouseMoveListener = addEventListenerWrap(window.top, "mousemove", onMouseMove, false);
        }
      } catch (error2) {
        warning(false, "[rc-image] ".concat(error2));
      }
    }
    return function() {
      var _onMouseUpListener, _onMouseMoveListener, _onTopMouseUpListener, _onTopMouseMoveListen;
      (_onMouseUpListener = onMouseUpListener) === null || _onMouseUpListener === void 0 || _onMouseUpListener.remove();
      (_onMouseMoveListener = onMouseMoveListener) === null || _onMouseMoveListener === void 0 || _onMouseMoveListener.remove();
      (_onTopMouseUpListener = onTopMouseUpListener) === null || _onTopMouseUpListener === void 0 || _onTopMouseUpListener.remove();
      (_onTopMouseMoveListen = onTopMouseMoveListener) === null || _onTopMouseMoveListen === void 0 || _onTopMouseMoveListen.remove();
    };
  }, [visible, isMoving, x, y, rotate2, movable]);
  return {
    isMoving,
    onMouseDown,
    onMouseMove,
    onMouseUp,
    onWheel
  };
}

// ../../node_modules/rc-image/es/hooks/useStatus.js
var import_react119 = __toESM(require_react());

// ../../node_modules/rc-image/es/util.js
function isImageValid(src) {
  return new Promise(function(resolve) {
    if (!src) {
      resolve(false);
      return;
    }
    var img = document.createElement("img");
    img.onerror = function() {
      return resolve(false);
    };
    img.onload = function() {
      return resolve(true);
    };
    img.src = src;
  });
}

// ../../node_modules/rc-image/es/hooks/useStatus.js
function useStatus2(_ref) {
  var src = _ref.src, isCustomPlaceholder = _ref.isCustomPlaceholder, fallback = _ref.fallback;
  var _useState = (0, import_react119.useState)(isCustomPlaceholder ? "loading" : "normal"), _useState2 = _slicedToArray(_useState, 2), status = _useState2[0], setStatus = _useState2[1];
  var isLoaded = (0, import_react119.useRef)(false);
  var isError = status === "error";
  (0, import_react119.useEffect)(function() {
    var isCurrentSrc = true;
    isImageValid(src).then(function(isValid2) {
      if (!isValid2 && isCurrentSrc) {
        setStatus("error");
      }
    });
    return function() {
      isCurrentSrc = false;
    };
  }, [src]);
  (0, import_react119.useEffect)(function() {
    if (isCustomPlaceholder && !isLoaded.current) {
      setStatus("loading");
    } else if (isError) {
      setStatus("normal");
    }
  }, [src]);
  var onLoad = function onLoad2() {
    setStatus("normal");
  };
  var getImgRef = function getImgRef2(img) {
    isLoaded.current = false;
    if (status === "loading" && img !== null && img !== void 0 && img.complete && (img.naturalWidth || img.naturalHeight)) {
      isLoaded.current = true;
      onLoad();
    }
  };
  var srcAndOnload = isError && fallback ? {
    src: fallback
  } : {
    onLoad,
    src
  };
  return [getImgRef, srcAndOnload, status];
}

// ../../node_modules/rc-image/es/hooks/useTouchEvent.js
var import_react120 = __toESM(require_react());
function getDistance(a, b) {
  var x = a.x - b.x;
  var y = a.y - b.y;
  return Math.hypot(x, y);
}
function getCenter(oldPoint1, oldPoint2, newPoint1, newPoint2) {
  var distance1 = getDistance(oldPoint1, newPoint1);
  var distance2 = getDistance(oldPoint2, newPoint2);
  if (distance1 === 0 && distance2 === 0) {
    return [oldPoint1.x, oldPoint1.y];
  }
  var ratio = distance1 / (distance1 + distance2);
  var x = oldPoint1.x + ratio * (oldPoint2.x - oldPoint1.x);
  var y = oldPoint1.y + ratio * (oldPoint2.y - oldPoint1.y);
  return [x, y];
}
function useTouchEvent(imgRef, movable, visible, minScale, transform, updateTransform, dispatchZoomChange) {
  var rotate2 = transform.rotate, scale = transform.scale, x = transform.x, y = transform.y;
  var _useState = (0, import_react120.useState)(false), _useState2 = _slicedToArray(_useState, 2), isTouching = _useState2[0], setIsTouching = _useState2[1];
  var touchPointInfo = (0, import_react120.useRef)({
    point1: {
      x: 0,
      y: 0
    },
    point2: {
      x: 0,
      y: 0
    },
    eventType: "none"
  });
  var updateTouchPointInfo = function updateTouchPointInfo2(values) {
    touchPointInfo.current = _objectSpread2(_objectSpread2({}, touchPointInfo.current), values);
  };
  var onTouchStart = function onTouchStart2(event) {
    if (!movable) return;
    event.stopPropagation();
    setIsTouching(true);
    var _event$touches = event.touches, touches = _event$touches === void 0 ? [] : _event$touches;
    if (touches.length > 1) {
      updateTouchPointInfo({
        point1: {
          x: touches[0].clientX,
          y: touches[0].clientY
        },
        point2: {
          x: touches[1].clientX,
          y: touches[1].clientY
        },
        eventType: "touchZoom"
      });
    } else {
      updateTouchPointInfo({
        point1: {
          x: touches[0].clientX - x,
          y: touches[0].clientY - y
        },
        eventType: "move"
      });
    }
  };
  var onTouchMove = function onTouchMove2(event) {
    var _event$touches2 = event.touches, touches = _event$touches2 === void 0 ? [] : _event$touches2;
    var _touchPointInfo$curre = touchPointInfo.current, point1 = _touchPointInfo$curre.point1, point2 = _touchPointInfo$curre.point2, eventType = _touchPointInfo$curre.eventType;
    if (touches.length > 1 && eventType === "touchZoom") {
      var newPoint1 = {
        x: touches[0].clientX,
        y: touches[0].clientY
      };
      var newPoint2 = {
        x: touches[1].clientX,
        y: touches[1].clientY
      };
      var _getCenter = getCenter(point1, point2, newPoint1, newPoint2), _getCenter2 = _slicedToArray(_getCenter, 2), centerX = _getCenter2[0], centerY = _getCenter2[1];
      var ratio = getDistance(newPoint1, newPoint2) / getDistance(point1, point2);
      dispatchZoomChange(ratio, "touchZoom", centerX, centerY, true);
      updateTouchPointInfo({
        point1: newPoint1,
        point2: newPoint2,
        eventType: "touchZoom"
      });
    } else if (eventType === "move") {
      updateTransform({
        x: touches[0].clientX - point1.x,
        y: touches[0].clientY - point1.y
      }, "move");
      updateTouchPointInfo({
        eventType: "move"
      });
    }
  };
  var onTouchEnd = function onTouchEnd2() {
    if (!visible) return;
    if (isTouching) {
      setIsTouching(false);
    }
    updateTouchPointInfo({
      eventType: "none"
    });
    if (minScale > scale) {
      return updateTransform({
        x: 0,
        y: 0,
        scale: minScale
      }, "touchZoom");
    }
    var width = imgRef.current.offsetWidth * scale;
    var height = imgRef.current.offsetHeight * scale;
    var _imgRef$current$getBo = imgRef.current.getBoundingClientRect(), left2 = _imgRef$current$getBo.left, top = _imgRef$current$getBo.top;
    var isRotate = rotate2 % 180 !== 0;
    var fixState = getFixScaleEleTransPosition(isRotate ? height : width, isRotate ? width : height, left2, top);
    if (fixState) {
      updateTransform(_objectSpread2({}, fixState), "dragRebound");
    }
  };
  (0, import_react120.useEffect)(function() {
    var onTouchMoveListener;
    if (visible && movable) {
      onTouchMoveListener = addEventListenerWrap(window, "touchmove", function(e3) {
        return e3.preventDefault();
      }, {
        passive: false
      });
    }
    return function() {
      var _onTouchMoveListener;
      (_onTouchMoveListener = onTouchMoveListener) === null || _onTouchMoveListener === void 0 || _onTouchMoveListener.remove();
    };
  }, [visible, movable]);
  return {
    isTouching,
    onTouchStart,
    onTouchMove,
    onTouchEnd
  };
}

// ../../node_modules/rc-image/es/Preview.js
var _excluded55 = ["fallback", "src", "imgRef"];
var _excluded216 = ["prefixCls", "src", "alt", "imageInfo", "fallback", "movable", "onClose", "visible", "icons", "rootClassName", "closeIcon", "getContainer", "current", "count", "countRender", "scaleStep", "minScale", "maxScale", "transitionName", "maskTransitionName", "imageRender", "imgCommonProps", "toolbarRender", "onTransform", "onChange"];
var PreviewImage = function PreviewImage2(_ref) {
  var fallback = _ref.fallback, src = _ref.src, imgRef = _ref.imgRef, props = _objectWithoutProperties(_ref, _excluded55);
  var _useStatus = useStatus2({
    src,
    fallback
  }), _useStatus2 = _slicedToArray(_useStatus, 2), getImgRef = _useStatus2[0], srcAndOnload = _useStatus2[1];
  return /* @__PURE__ */ import_react121.default.createElement("img", _extends({
    ref: function ref3(_ref2) {
      imgRef.current = _ref2;
      getImgRef(_ref2);
    }
  }, props, srcAndOnload));
};
var Preview = function Preview2(props) {
  var prefixCls = props.prefixCls, src = props.src, alt = props.alt, imageInfo = props.imageInfo, fallback = props.fallback, _props$movable = props.movable, movable = _props$movable === void 0 ? true : _props$movable, onClose = props.onClose, visible = props.visible, _props$icons = props.icons, icons3 = _props$icons === void 0 ? {} : _props$icons, rootClassName = props.rootClassName, closeIcon = props.closeIcon, getContainer2 = props.getContainer, _props$current = props.current, current2 = _props$current === void 0 ? 0 : _props$current, _props$count = props.count, count = _props$count === void 0 ? 1 : _props$count, countRender = props.countRender, _props$scaleStep = props.scaleStep, scaleStep = _props$scaleStep === void 0 ? 0.5 : _props$scaleStep, _props$minScale = props.minScale, minScale = _props$minScale === void 0 ? 1 : _props$minScale, _props$maxScale = props.maxScale, maxScale = _props$maxScale === void 0 ? 50 : _props$maxScale, _props$transitionName = props.transitionName, transitionName = _props$transitionName === void 0 ? "zoom" : _props$transitionName, _props$maskTransition = props.maskTransitionName, maskTransitionName = _props$maskTransition === void 0 ? "fade" : _props$maskTransition, imageRender = props.imageRender, imgCommonProps = props.imgCommonProps, toolbarRender = props.toolbarRender, onTransform = props.onTransform, onChange = props.onChange, restProps = _objectWithoutProperties(props, _excluded216);
  var imgRef = (0, import_react121.useRef)();
  var groupContext = (0, import_react121.useContext)(PreviewGroupContext);
  var showLeftOrRightSwitches = groupContext && count > 1;
  var showOperationsProgress = groupContext && count >= 1;
  var _useState = (0, import_react121.useState)(true), _useState2 = _slicedToArray(_useState, 2), enableTransition = _useState2[0], setEnableTransition = _useState2[1];
  var _useImageTransform = useImageTransform(imgRef, minScale, maxScale, onTransform), transform = _useImageTransform.transform, resetTransform = _useImageTransform.resetTransform, updateTransform = _useImageTransform.updateTransform, dispatchZoomChange = _useImageTransform.dispatchZoomChange;
  var _useMouseEvent = useMouseEvent(imgRef, movable, visible, scaleStep, transform, updateTransform, dispatchZoomChange), isMoving = _useMouseEvent.isMoving, onMouseDown = _useMouseEvent.onMouseDown, onWheel = _useMouseEvent.onWheel;
  var _useTouchEvent = useTouchEvent(imgRef, movable, visible, minScale, transform, updateTransform, dispatchZoomChange), isTouching = _useTouchEvent.isTouching, onTouchStart = _useTouchEvent.onTouchStart, onTouchMove = _useTouchEvent.onTouchMove, onTouchEnd = _useTouchEvent.onTouchEnd;
  var rotate2 = transform.rotate, scale = transform.scale;
  var wrapClassName = (0, import_classnames140.default)(_defineProperty({}, "".concat(prefixCls, "-moving"), isMoving));
  (0, import_react121.useEffect)(function() {
    if (!enableTransition) {
      setEnableTransition(true);
    }
  }, [enableTransition]);
  var onAfterClose = function onAfterClose2() {
    resetTransform("close");
  };
  var onZoomIn = function onZoomIn2() {
    dispatchZoomChange(BASE_SCALE_RATIO + scaleStep, "zoomIn");
  };
  var onZoomOut = function onZoomOut2() {
    dispatchZoomChange(BASE_SCALE_RATIO / (BASE_SCALE_RATIO + scaleStep), "zoomOut");
  };
  var onRotateRight = function onRotateRight2() {
    updateTransform({
      rotate: rotate2 + 90
    }, "rotateRight");
  };
  var onRotateLeft = function onRotateLeft2() {
    updateTransform({
      rotate: rotate2 - 90
    }, "rotateLeft");
  };
  var onFlipX = function onFlipX2() {
    updateTransform({
      flipX: !transform.flipX
    }, "flipX");
  };
  var onFlipY = function onFlipY2() {
    updateTransform({
      flipY: !transform.flipY
    }, "flipY");
  };
  var onReset = function onReset2() {
    resetTransform("reset");
  };
  var onActive = function onActive2(offset4) {
    var position3 = current2 + offset4;
    if (!Number.isInteger(position3) || position3 < 0 || position3 > count - 1) {
      return;
    }
    setEnableTransition(false);
    resetTransform(offset4 < 0 ? "prev" : "next");
    onChange === null || onChange === void 0 || onChange(position3, current2);
  };
  var onKeyDown2 = function onKeyDown3(event) {
    if (!visible || !showLeftOrRightSwitches) return;
    if (event.keyCode === KeyCode_default.LEFT) {
      onActive(-1);
    } else if (event.keyCode === KeyCode_default.RIGHT) {
      onActive(1);
    }
  };
  var onDoubleClick = function onDoubleClick2(event) {
    if (visible) {
      if (scale !== 1) {
        updateTransform({
          x: 0,
          y: 0,
          scale: 1
        }, "doubleClick");
      } else {
        dispatchZoomChange(BASE_SCALE_RATIO + scaleStep, "doubleClick", event.clientX, event.clientY);
      }
    }
  };
  (0, import_react121.useEffect)(function() {
    var onKeyDownListener = addEventListenerWrap(window, "keydown", onKeyDown2, false);
    return function() {
      onKeyDownListener.remove();
    };
  }, [visible, showLeftOrRightSwitches, current2]);
  var imgNode = /* @__PURE__ */ import_react121.default.createElement(PreviewImage, _extends({}, imgCommonProps, {
    width: props.width,
    height: props.height,
    imgRef,
    className: "".concat(prefixCls, "-img"),
    alt,
    style: {
      transform: "translate3d(".concat(transform.x, "px, ").concat(transform.y, "px, 0) scale3d(").concat(transform.flipX ? "-" : "").concat(scale, ", ").concat(transform.flipY ? "-" : "").concat(scale, ", 1) rotate(").concat(rotate2, "deg)"),
      transitionDuration: (!enableTransition || isTouching) && "0s"
    },
    fallback,
    src,
    onWheel,
    onMouseDown,
    onDoubleClick,
    onTouchStart,
    onTouchMove,
    onTouchEnd,
    onTouchCancel: onTouchEnd
  }));
  var image = _objectSpread2({
    url: src,
    alt
  }, imageInfo);
  return /* @__PURE__ */ import_react121.default.createElement(import_react121.default.Fragment, null, /* @__PURE__ */ import_react121.default.createElement(es_default5, _extends({
    transitionName,
    maskTransitionName,
    closable: false,
    keyboard: true,
    prefixCls,
    onClose,
    visible,
    classNames: {
      wrapper: wrapClassName
    },
    rootClassName,
    getContainer: getContainer2
  }, restProps, {
    afterClose: onAfterClose
  }), /* @__PURE__ */ import_react121.default.createElement("div", {
    className: "".concat(prefixCls, "-img-wrapper")
  }, imageRender ? imageRender(imgNode, _objectSpread2({
    transform,
    image
  }, groupContext ? {
    current: current2
  } : {})) : imgNode)), /* @__PURE__ */ import_react121.default.createElement(Operations_default, {
    visible,
    transform,
    maskTransitionName,
    closeIcon,
    getContainer: getContainer2,
    prefixCls,
    rootClassName,
    icons: icons3,
    countRender,
    showSwitch: showLeftOrRightSwitches,
    showProgress: showOperationsProgress,
    current: current2,
    count,
    scale,
    minScale,
    maxScale,
    toolbarRender,
    onActive,
    onZoomIn,
    onZoomOut,
    onRotateRight,
    onRotateLeft,
    onFlipX,
    onFlipY,
    onClose,
    onReset,
    zIndex: restProps.zIndex !== void 0 ? restProps.zIndex + 1 : void 0,
    image
  }));
};
var Preview_default = Preview;

// ../../node_modules/rc-image/es/PreviewGroup.js
var React368 = __toESM(require_react());
var import_react122 = __toESM(require_react());

// ../../node_modules/rc-image/es/hooks/usePreviewItems.js
var React367 = __toESM(require_react());

// ../../node_modules/rc-image/es/common.js
var COMMON_PROPS = ["crossOrigin", "decoding", "draggable", "loading", "referrerPolicy", "sizes", "srcSet", "useMap", "alt"];

// ../../node_modules/rc-image/es/hooks/usePreviewItems.js
function usePreviewItems(items) {
  var _React$useState = React367.useState({}), _React$useState2 = _slicedToArray(_React$useState, 2), images = _React$useState2[0], setImages = _React$useState2[1];
  var registerImage = React367.useCallback(function(id, data2) {
    setImages(function(imgs) {
      return _objectSpread2(_objectSpread2({}, imgs), {}, _defineProperty({}, id, data2));
    });
    return function() {
      setImages(function(imgs) {
        var cloneImgs = _objectSpread2({}, imgs);
        delete cloneImgs[id];
        return cloneImgs;
      });
    };
  }, []);
  var mergedItems = React367.useMemo(function() {
    if (items) {
      return items.map(function(item) {
        if (typeof item === "string") {
          return {
            data: {
              src: item
            }
          };
        }
        var data2 = {};
        Object.keys(item).forEach(function(key2) {
          if (["src"].concat(_toConsumableArray(COMMON_PROPS)).includes(key2)) {
            data2[key2] = item[key2];
          }
        });
        return {
          data: data2
        };
      });
    }
    return Object.keys(images).reduce(function(total, id) {
      var _images$id = images[id], canPreview = _images$id.canPreview, data2 = _images$id.data;
      if (canPreview) {
        total.push({
          data: data2,
          id
        });
      }
      return total;
    }, []);
  }, [items, images]);
  return [mergedItems, registerImage, !!items];
}

// ../../node_modules/rc-image/es/PreviewGroup.js
var _excluded56 = ["visible", "onVisibleChange", "getContainer", "current", "movable", "minScale", "maxScale", "countRender", "closeIcon", "onChange", "onTransform", "toolbarRender", "imageRender"];
var _excluded217 = ["src"];
var Group = function Group2(_ref) {
  var _mergedItems$current;
  var _ref$previewPrefixCls = _ref.previewPrefixCls, previewPrefixCls = _ref$previewPrefixCls === void 0 ? "rc-image-preview" : _ref$previewPrefixCls, children = _ref.children, _ref$icons = _ref.icons, icons3 = _ref$icons === void 0 ? {} : _ref$icons, items = _ref.items, preview = _ref.preview, fallback = _ref.fallback;
  var _ref2 = _typeof(preview) === "object" ? preview : {}, previewVisible = _ref2.visible, onVisibleChange = _ref2.onVisibleChange, getContainer2 = _ref2.getContainer, currentIndex = _ref2.current, movable = _ref2.movable, minScale = _ref2.minScale, maxScale = _ref2.maxScale, countRender = _ref2.countRender, closeIcon = _ref2.closeIcon, onChange = _ref2.onChange, onTransform = _ref2.onTransform, toolbarRender = _ref2.toolbarRender, imageRender = _ref2.imageRender, dialogProps = _objectWithoutProperties(_ref2, _excluded56);
  var _usePreviewItems = usePreviewItems(items), _usePreviewItems2 = _slicedToArray(_usePreviewItems, 3), mergedItems = _usePreviewItems2[0], register2 = _usePreviewItems2[1], fromItems = _usePreviewItems2[2];
  var _useMergedState = useMergedState(0, {
    value: currentIndex
  }), _useMergedState2 = _slicedToArray(_useMergedState, 2), current2 = _useMergedState2[0], setCurrent = _useMergedState2[1];
  var _useState = (0, import_react122.useState)(false), _useState2 = _slicedToArray(_useState, 2), keepOpenIndex = _useState2[0], setKeepOpenIndex = _useState2[1];
  var _ref3 = ((_mergedItems$current = mergedItems[current2]) === null || _mergedItems$current === void 0 ? void 0 : _mergedItems$current.data) || {}, src = _ref3.src, imgCommonProps = _objectWithoutProperties(_ref3, _excluded217);
  var _useMergedState3 = useMergedState(!!previewVisible, {
    value: previewVisible,
    onChange: function onChange2(val, prevVal) {
      onVisibleChange === null || onVisibleChange === void 0 || onVisibleChange(val, prevVal, current2);
    }
  }), _useMergedState4 = _slicedToArray(_useMergedState3, 2), isShowPreview = _useMergedState4[0], setShowPreview = _useMergedState4[1];
  var _useState3 = (0, import_react122.useState)(null), _useState4 = _slicedToArray(_useState3, 2), mousePosition = _useState4[0], setMousePosition = _useState4[1];
  var onPreviewFromImage = React368.useCallback(function(id, imageSrc, mouseX, mouseY) {
    var index3 = fromItems ? mergedItems.findIndex(function(item) {
      return item.data.src === imageSrc;
    }) : mergedItems.findIndex(function(item) {
      return item.id === id;
    });
    setCurrent(index3 < 0 ? 0 : index3);
    setShowPreview(true);
    setMousePosition({
      x: mouseX,
      y: mouseY
    });
    setKeepOpenIndex(true);
  }, [mergedItems, fromItems]);
  React368.useEffect(function() {
    if (isShowPreview) {
      if (!keepOpenIndex) {
        setCurrent(0);
      }
    } else {
      setKeepOpenIndex(false);
    }
  }, [isShowPreview]);
  var onInternalChange = function onInternalChange2(next2, prev2) {
    setCurrent(next2);
    onChange === null || onChange === void 0 || onChange(next2, prev2);
  };
  var onPreviewClose = function onPreviewClose2() {
    setShowPreview(false);
    setMousePosition(null);
  };
  var previewGroupContext = React368.useMemo(function() {
    return {
      register: register2,
      onPreview: onPreviewFromImage
    };
  }, [register2, onPreviewFromImage]);
  return /* @__PURE__ */ React368.createElement(PreviewGroupContext.Provider, {
    value: previewGroupContext
  }, children, /* @__PURE__ */ React368.createElement(Preview_default, _extends({
    "aria-hidden": !isShowPreview,
    movable,
    visible: isShowPreview,
    prefixCls: previewPrefixCls,
    closeIcon,
    onClose: onPreviewClose,
    mousePosition,
    imgCommonProps,
    src,
    fallback,
    icons: icons3,
    minScale,
    maxScale,
    getContainer: getContainer2,
    current: current2,
    count: mergedItems.length,
    countRender,
    onTransform,
    toolbarRender,
    imageRender,
    onChange: onInternalChange
  }, dialogProps)));
};
var PreviewGroup_default = Group;

// ../../node_modules/rc-image/es/hooks/useRegisterImage.js
var React369 = __toESM(require_react());
var uid = 0;
function useRegisterImage(canPreview, data2) {
  var _React$useState = React369.useState(function() {
    uid += 1;
    return String(uid);
  }), _React$useState2 = _slicedToArray(_React$useState, 1), id = _React$useState2[0];
  var groupContext = React369.useContext(PreviewGroupContext);
  var registerData = {
    data: data2,
    canPreview
  };
  React369.useEffect(function() {
    if (groupContext) {
      return groupContext.register(id, registerData);
    }
  }, []);
  React369.useEffect(function() {
    if (groupContext) {
      groupContext.register(id, registerData);
    }
  }, [canPreview, data2]);
  return id;
}

// ../../node_modules/rc-image/es/Image.js
var _excluded57 = ["src", "alt", "onPreviewClose", "prefixCls", "previewPrefixCls", "placeholder", "fallback", "width", "height", "style", "preview", "className", "onClick", "onError", "wrapperClassName", "wrapperStyle", "rootClassName"];
var _excluded218 = ["src", "visible", "onVisibleChange", "getContainer", "mask", "maskClassName", "movable", "icons", "scaleStep", "minScale", "maxScale", "imageRender", "toolbarRender"];
var ImageInternal = function ImageInternal2(props) {
  var imgSrc = props.src, alt = props.alt, onInitialPreviewClose = props.onPreviewClose, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-image" : _props$prefixCls, _props$previewPrefixC = props.previewPrefixCls, previewPrefixCls = _props$previewPrefixC === void 0 ? "".concat(prefixCls, "-preview") : _props$previewPrefixC, placeholder = props.placeholder, fallback = props.fallback, width = props.width, height = props.height, style2 = props.style, _props$preview = props.preview, preview = _props$preview === void 0 ? true : _props$preview, className2 = props.className, onClick = props.onClick, onError = props.onError, wrapperClassName = props.wrapperClassName, wrapperStyle = props.wrapperStyle, rootClassName = props.rootClassName, otherProps = _objectWithoutProperties(props, _excluded57);
  var isCustomPlaceholder = placeholder && placeholder !== true;
  var _ref = _typeof(preview) === "object" ? preview : {}, previewSrc = _ref.src, _ref$visible = _ref.visible, previewVisible = _ref$visible === void 0 ? void 0 : _ref$visible, _ref$onVisibleChange = _ref.onVisibleChange, onPreviewVisibleChange = _ref$onVisibleChange === void 0 ? onInitialPreviewClose : _ref$onVisibleChange, _ref$getContainer = _ref.getContainer, getPreviewContainer = _ref$getContainer === void 0 ? void 0 : _ref$getContainer, previewMask = _ref.mask, maskClassName = _ref.maskClassName, movable = _ref.movable, icons3 = _ref.icons, scaleStep = _ref.scaleStep, minScale = _ref.minScale, maxScale = _ref.maxScale, imageRender = _ref.imageRender, toolbarRender = _ref.toolbarRender, dialogProps = _objectWithoutProperties(_ref, _excluded218);
  var src = previewSrc !== null && previewSrc !== void 0 ? previewSrc : imgSrc;
  var _useMergedState = useMergedState(!!previewVisible, {
    value: previewVisible,
    onChange: onPreviewVisibleChange
  }), _useMergedState2 = _slicedToArray(_useMergedState, 2), isShowPreview = _useMergedState2[0], setShowPreview = _useMergedState2[1];
  var _useStatus = useStatus2({
    src: imgSrc,
    isCustomPlaceholder,
    fallback
  }), _useStatus2 = _slicedToArray(_useStatus, 3), getImgRef = _useStatus2[0], srcAndOnload = _useStatus2[1], status = _useStatus2[2];
  var _useState = (0, import_react123.useState)(null), _useState2 = _slicedToArray(_useState, 2), mousePosition = _useState2[0], setMousePosition = _useState2[1];
  var groupContext = (0, import_react123.useContext)(PreviewGroupContext);
  var canPreview = !!preview;
  var onPreviewClose = function onPreviewClose2() {
    setShowPreview(false);
    setMousePosition(null);
  };
  var wrapperClass = (0, import_classnames141.default)(prefixCls, wrapperClassName, rootClassName, _defineProperty({}, "".concat(prefixCls, "-error"), status === "error"));
  var imgCommonProps = (0, import_react123.useMemo)(function() {
    var obj = {};
    COMMON_PROPS.forEach(function(prop) {
      if (props[prop] !== void 0) {
        obj[prop] = props[prop];
      }
    });
    return obj;
  }, COMMON_PROPS.map(function(prop) {
    return props[prop];
  }));
  var registerData = (0, import_react123.useMemo)(function() {
    return _objectSpread2(_objectSpread2({}, imgCommonProps), {}, {
      src
    });
  }, [src, imgCommonProps]);
  var imageId = useRegisterImage(canPreview, registerData);
  var onPreview = function onPreview2(e3) {
    var _getOffset = getOffset3(e3.target), left2 = _getOffset.left, top = _getOffset.top;
    if (groupContext) {
      groupContext.onPreview(imageId, src, left2, top);
    } else {
      setMousePosition({
        x: left2,
        y: top
      });
      setShowPreview(true);
    }
    onClick === null || onClick === void 0 || onClick(e3);
  };
  return /* @__PURE__ */ React370.createElement(React370.Fragment, null, /* @__PURE__ */ React370.createElement("div", _extends({}, otherProps, {
    className: wrapperClass,
    onClick: canPreview ? onPreview : onClick,
    style: _objectSpread2({
      width,
      height
    }, wrapperStyle)
  }), /* @__PURE__ */ React370.createElement("img", _extends({}, imgCommonProps, {
    className: (0, import_classnames141.default)("".concat(prefixCls, "-img"), _defineProperty({}, "".concat(prefixCls, "-img-placeholder"), placeholder === true), className2),
    style: _objectSpread2({
      height
    }, style2),
    ref: getImgRef
  }, srcAndOnload, {
    width,
    height,
    onError
  })), status === "loading" && /* @__PURE__ */ React370.createElement("div", {
    "aria-hidden": "true",
    className: "".concat(prefixCls, "-placeholder")
  }, placeholder), previewMask && canPreview && /* @__PURE__ */ React370.createElement("div", {
    className: (0, import_classnames141.default)("".concat(prefixCls, "-mask"), maskClassName),
    style: {
      display: (style2 === null || style2 === void 0 ? void 0 : style2.display) === "none" ? "none" : void 0
    }
  }, previewMask)), !groupContext && canPreview && /* @__PURE__ */ React370.createElement(Preview_default, _extends({
    "aria-hidden": !isShowPreview,
    visible: isShowPreview,
    prefixCls: previewPrefixCls,
    onClose: onPreviewClose,
    mousePosition,
    src,
    alt,
    imageInfo: {
      width,
      height
    },
    fallback,
    getContainer: getPreviewContainer,
    icons: icons3,
    movable,
    scaleStep,
    minScale,
    maxScale,
    rootClassName,
    imageRender,
    imgCommonProps,
    toolbarRender
  }, dialogProps)));
};
ImageInternal.PreviewGroup = PreviewGroup_default;
if (true) {
  ImageInternal.displayName = "Image";
}
var Image_default2 = ImageInternal;

// ../../node_modules/rc-image/es/index.js
var es_default23 = Image_default2;

// ../../node_modules/antd/es/image/PreviewGroup.js
var React376 = __toESM(require_react());

// ../../node_modules/@ant-design/icons/es/icons/RotateLeftOutlined.js
var React371 = __toESM(require_react());

// ../../node_modules/@ant-design/icons-svg/es/asn/RotateLeftOutlined.js
var RotateLeftOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M672 418H144c-17.7 0-32 14.3-32 32v414c0 17.7 14.3 32 32 32h528c17.7 0 32-14.3 32-32V450c0-17.7-14.3-32-32-32zm-44 402H188V494h440v326z" } }, { "tag": "path", "attrs": { "d": "M819.3 328.5c-78.8-100.7-196-153.6-314.6-154.2l-.2-64c0-6.5-7.6-10.1-12.6-6.1l-128 101c-4 3.1-3.9 9.1 0 12.3L492 318.6c5.1 4 12.7.4 12.6-6.1v-63.9c12.9.1 25.9.9 38.8 2.5 42.1 5.2 82.1 18.2 119 38.7 38.1 21.2 71.2 49.7 98.4 84.3 27.1 34.7 46.7 73.7 58.1 115.8a325.95 325.95 0 016.5 140.9h74.9c14.8-103.6-11.3-213-81-302.3z" } }] }, "name": "rotate-left", "theme": "outlined" };
var RotateLeftOutlined_default = RotateLeftOutlined;

// ../../node_modules/@ant-design/icons/es/icons/RotateLeftOutlined.js
var RotateLeftOutlined2 = function RotateLeftOutlined3(props, ref3) {
  return /* @__PURE__ */ React371.createElement(AntdIcon_default, _extends({}, props, {
    ref: ref3,
    icon: RotateLeftOutlined_default
  }));
};
var RefIcon21 = /* @__PURE__ */ React371.forwardRef(RotateLeftOutlined2);
if (true) {
  RefIcon21.displayName = "RotateLeftOutlined";
}
var RotateLeftOutlined_default2 = RefIcon21;

// ../../node_modules/@ant-design/icons/es/icons/RotateRightOutlined.js
var React372 = __toESM(require_react());

// ../../node_modules/@ant-design/icons-svg/es/asn/RotateRightOutlined.js
var RotateRightOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M480.5 251.2c13-1.6 25.9-2.4 38.8-2.5v63.9c0 6.5 7.5 10.1 12.6 6.1L660 217.6c4-3.2 4-9.2 0-12.3l-128-101c-5.1-4-12.6-.4-12.6 6.1l-.2 64c-118.6.5-235.8 53.4-314.6 154.2A399.75 399.75 0 00123.5 631h74.9c-.9-5.3-1.7-10.7-2.4-16.1-5.1-42.1-2.1-84.1 8.9-124.8 11.4-42.2 31-81.1 58.1-115.8 27.2-34.7 60.3-63.2 98.4-84.3 37-20.6 76.9-33.6 119.1-38.8z" } }, { "tag": "path", "attrs": { "d": "M880 418H352c-17.7 0-32 14.3-32 32v414c0 17.7 14.3 32 32 32h528c17.7 0 32-14.3 32-32V450c0-17.7-14.3-32-32-32zm-44 402H396V494h440v326z" } }] }, "name": "rotate-right", "theme": "outlined" };
var RotateRightOutlined_default = RotateRightOutlined;

// ../../node_modules/@ant-design/icons/es/icons/RotateRightOutlined.js
var RotateRightOutlined2 = function RotateRightOutlined3(props, ref3) {
  return /* @__PURE__ */ React372.createElement(AntdIcon_default, _extends({}, props, {
    ref: ref3,
    icon: RotateRightOutlined_default
  }));
};
var RefIcon22 = /* @__PURE__ */ React372.forwardRef(RotateRightOutlined2);
if (true) {
  RefIcon22.displayName = "RotateRightOutlined";
}
var RotateRightOutlined_default2 = RefIcon22;

// ../../node_modules/@ant-design/icons/es/icons/SwapOutlined.js
var React373 = __toESM(require_react());

// ../../node_modules/@ant-design/icons-svg/es/asn/SwapOutlined.js
var SwapOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M847.9 592H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h605.2L612.9 851c-4.1 5.2-.4 13 6.3 13h72.5c4.9 0 9.5-2.2 12.6-6.1l168.8-214.1c16.5-21 1.6-51.8-25.2-51.8zM872 356H266.8l144.3-183c4.1-5.2.4-13-6.3-13h-72.5c-4.9 0-9.5 2.2-12.6 6.1L150.9 380.2c-16.5 21-1.6 51.8 25.1 51.8h696c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z" } }] }, "name": "swap", "theme": "outlined" };
var SwapOutlined_default = SwapOutlined;

// ../../node_modules/@ant-design/icons/es/icons/SwapOutlined.js
var SwapOutlined2 = function SwapOutlined3(props, ref3) {
  return /* @__PURE__ */ React373.createElement(AntdIcon_default, _extends({}, props, {
    ref: ref3,
    icon: SwapOutlined_default
  }));
};
var RefIcon23 = /* @__PURE__ */ React373.forwardRef(SwapOutlined2);
if (true) {
  RefIcon23.displayName = "SwapOutlined";
}
var SwapOutlined_default2 = RefIcon23;

// ../../node_modules/@ant-design/icons/es/icons/ZoomInOutlined.js
var React374 = __toESM(require_react());

// ../../node_modules/@ant-design/icons-svg/es/asn/ZoomInOutlined.js
var ZoomInOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M637 443H519V309c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v134H325c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h118v134c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V519h118c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm284 424L775 721c122.1-148.9 113.6-369.5-26-509-148-148.1-388.4-148.1-537 0-148.1 148.6-148.1 389 0 537 139.5 139.6 360.1 148.1 509 26l146 146c3.2 2.8 8.3 2.8 11 0l43-43c2.8-2.7 2.8-7.8 0-11zM696 696c-118.8 118.7-311.2 118.7-430 0-118.7-118.8-118.7-311.2 0-430 118.8-118.7 311.2-118.7 430 0 118.7 118.8 118.7 311.2 0 430z" } }] }, "name": "zoom-in", "theme": "outlined" };
var ZoomInOutlined_default = ZoomInOutlined;

// ../../node_modules/@ant-design/icons/es/icons/ZoomInOutlined.js
var ZoomInOutlined2 = function ZoomInOutlined3(props, ref3) {
  return /* @__PURE__ */ React374.createElement(AntdIcon_default, _extends({}, props, {
    ref: ref3,
    icon: ZoomInOutlined_default
  }));
};
var RefIcon24 = /* @__PURE__ */ React374.forwardRef(ZoomInOutlined2);
if (true) {
  RefIcon24.displayName = "ZoomInOutlined";
}
var ZoomInOutlined_default2 = RefIcon24;

// ../../node_modules/@ant-design/icons/es/icons/ZoomOutOutlined.js
var React375 = __toESM(require_react());

// ../../node_modules/@ant-design/icons-svg/es/asn/ZoomOutOutlined.js
var ZoomOutOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M637 443H325c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h312c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm284 424L775 721c122.1-148.9 113.6-369.5-26-509-148-148.1-388.4-148.1-537 0-148.1 148.6-148.1 389 0 537 139.5 139.6 360.1 148.1 509 26l146 146c3.2 2.8 8.3 2.8 11 0l43-43c2.8-2.7 2.8-7.8 0-11zM696 696c-118.8 118.7-311.2 118.7-430 0-118.7-118.8-118.7-311.2 0-430 118.8-118.7 311.2-118.7 430 0 118.7 118.8 118.7 311.2 0 430z" } }] }, "name": "zoom-out", "theme": "outlined" };
var ZoomOutOutlined_default = ZoomOutOutlined;

// ../../node_modules/@ant-design/icons/es/icons/ZoomOutOutlined.js
var ZoomOutOutlined2 = function ZoomOutOutlined3(props, ref3) {
  return /* @__PURE__ */ React375.createElement(AntdIcon_default, _extends({}, props, {
    ref: ref3,
    icon: ZoomOutOutlined_default
  }));
};
var RefIcon25 = /* @__PURE__ */ React375.forwardRef(ZoomOutOutlined2);
if (true) {
  RefIcon25.displayName = "ZoomOutOutlined";
}
var ZoomOutOutlined_default2 = RefIcon25;

// ../../node_modules/antd/es/image/PreviewGroup.js
var import_classnames142 = __toESM(require_classnames());

// ../../node_modules/antd/es/image/style/index.js
var genBoxStyle = (position3) => ({
  position: position3 || "absolute",
  inset: 0
});
var genImageMaskStyle = (token2) => {
  const {
    iconCls,
    motionDurationSlow,
    paddingXXS,
    marginXXS,
    prefixCls,
    colorTextLightSolid
  } = token2;
  return {
    position: "absolute",
    inset: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: colorTextLightSolid,
    background: new FastColor("#000").setA(0.5).toRgbString(),
    cursor: "pointer",
    opacity: 0,
    transition: `opacity ${motionDurationSlow}`,
    [`.${prefixCls}-mask-info`]: Object.assign(Object.assign({}, textEllipsis), {
      padding: `0 ${unit(paddingXXS)}`,
      [iconCls]: {
        marginInlineEnd: marginXXS,
        svg: {
          verticalAlign: "baseline"
        }
      }
    })
  };
};
var genPreviewOperationsStyle = (token2) => {
  const {
    previewCls,
    modalMaskBg,
    paddingSM,
    marginXL,
    margin,
    paddingLG,
    previewOperationColorDisabled,
    previewOperationHoverColor,
    motionDurationSlow,
    iconCls,
    colorTextLightSolid
  } = token2;
  const operationBg = new FastColor(modalMaskBg).setA(0.1);
  const operationBgHover = operationBg.clone().setA(0.2);
  return {
    [`${previewCls}-footer`]: {
      position: "fixed",
      bottom: marginXL,
      left: {
        _skip_check_: true,
        value: "50%"
      },
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      color: token2.previewOperationColor,
      transform: "translateX(-50%)"
    },
    [`${previewCls}-progress`]: {
      marginBottom: margin
    },
    [`${previewCls}-close`]: {
      position: "fixed",
      top: marginXL,
      right: {
        _skip_check_: true,
        value: marginXL
      },
      display: "flex",
      color: colorTextLightSolid,
      backgroundColor: operationBg.toRgbString(),
      borderRadius: "50%",
      padding: paddingSM,
      outline: 0,
      border: 0,
      cursor: "pointer",
      transition: `all ${motionDurationSlow}`,
      "&:hover": {
        backgroundColor: operationBgHover.toRgbString()
      },
      [`& > ${iconCls}`]: {
        fontSize: token2.previewOperationSize
      }
    },
    [`${previewCls}-operations`]: {
      display: "flex",
      alignItems: "center",
      padding: `0 ${unit(paddingLG)}`,
      backgroundColor: operationBg.toRgbString(),
      borderRadius: 100,
      "&-operation": {
        marginInlineStart: paddingSM,
        padding: paddingSM,
        cursor: "pointer",
        transition: `all ${motionDurationSlow}`,
        userSelect: "none",
        [`&:not(${previewCls}-operations-operation-disabled):hover > ${iconCls}`]: {
          color: previewOperationHoverColor
        },
        "&-disabled": {
          color: previewOperationColorDisabled,
          cursor: "not-allowed"
        },
        "&:first-of-type": {
          marginInlineStart: 0
        },
        [`& > ${iconCls}`]: {
          fontSize: token2.previewOperationSize
        }
      }
    }
  };
};
var genPreviewSwitchStyle = (token2) => {
  const {
    modalMaskBg,
    iconCls,
    previewOperationColorDisabled,
    previewCls,
    zIndexPopup,
    motionDurationSlow
  } = token2;
  const operationBg = new FastColor(modalMaskBg).setA(0.1);
  const operationBgHover = operationBg.clone().setA(0.2);
  return {
    [`${previewCls}-switch-left, ${previewCls}-switch-right`]: {
      position: "fixed",
      insetBlockStart: "50%",
      zIndex: token2.calc(zIndexPopup).add(1).equal(),
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: token2.imagePreviewSwitchSize,
      height: token2.imagePreviewSwitchSize,
      marginTop: token2.calc(token2.imagePreviewSwitchSize).mul(-1).div(2).equal(),
      color: token2.previewOperationColor,
      background: operationBg.toRgbString(),
      borderRadius: "50%",
      transform: `translateY(-50%)`,
      cursor: "pointer",
      transition: `all ${motionDurationSlow}`,
      userSelect: "none",
      "&:hover": {
        background: operationBgHover.toRgbString()
      },
      "&-disabled": {
        "&, &:hover": {
          color: previewOperationColorDisabled,
          background: "transparent",
          cursor: "not-allowed",
          [`> ${iconCls}`]: {
            cursor: "not-allowed"
          }
        }
      },
      [`> ${iconCls}`]: {
        fontSize: token2.previewOperationSize
      }
    },
    [`${previewCls}-switch-left`]: {
      insetInlineStart: token2.marginSM
    },
    [`${previewCls}-switch-right`]: {
      insetInlineEnd: token2.marginSM
    }
  };
};
var genImagePreviewStyle = (token2) => {
  const {
    motionEaseOut,
    previewCls,
    motionDurationSlow,
    componentCls
  } = token2;
  return [
    {
      [`${componentCls}-preview-root`]: {
        [previewCls]: {
          height: "100%",
          textAlign: "center",
          pointerEvents: "none"
        },
        [`${previewCls}-body`]: Object.assign(Object.assign({}, genBoxStyle()), {
          overflow: "hidden"
        }),
        [`${previewCls}-img`]: {
          maxWidth: "100%",
          maxHeight: "70%",
          verticalAlign: "middle",
          transform: "scale3d(1, 1, 1)",
          cursor: "grab",
          transition: `transform ${motionDurationSlow} ${motionEaseOut} 0s`,
          userSelect: "none",
          "&-wrapper": Object.assign(Object.assign({}, genBoxStyle()), {
            transition: `transform ${motionDurationSlow} ${motionEaseOut} 0s`,
            // https://github.com/ant-design/ant-design/issues/39913
            // TailwindCSS will reset img default style.
            // Let's set back.
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            "& > *": {
              pointerEvents: "auto"
            },
            "&::before": {
              display: "inline-block",
              width: 1,
              height: "50%",
              marginInlineEnd: -1,
              content: '""'
            }
          })
        },
        [`${previewCls}-moving`]: {
          [`${previewCls}-preview-img`]: {
            cursor: "grabbing",
            "&-wrapper": {
              transitionDuration: "0s"
            }
          }
        }
      }
    },
    // Override
    {
      [`${componentCls}-preview-root`]: {
        [`${previewCls}-wrap`]: {
          zIndex: token2.zIndexPopup
        }
      }
    },
    // Preview operations & switch
    {
      [`${componentCls}-preview-operations-wrapper`]: {
        position: "fixed",
        zIndex: token2.calc(token2.zIndexPopup).add(1).equal()
      },
      "&": [genPreviewOperationsStyle(token2), genPreviewSwitchStyle(token2)]
    }
  ];
};
var genImageStyle = (token2) => {
  const {
    componentCls
  } = token2;
  return {
    // ============================== image ==============================
    [componentCls]: {
      position: "relative",
      display: "inline-block",
      [`${componentCls}-img`]: {
        width: "100%",
        height: "auto",
        verticalAlign: "middle"
      },
      [`${componentCls}-img-placeholder`]: {
        backgroundColor: token2.colorBgContainerDisabled,
        backgroundImage: "url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTQuNSAyLjVoLTEzQS41LjUgMCAwIDAgMSAzdjEwYS41LjUgMCAwIDAgLjUuNWgxM2EuNS41IDAgMCAwIC41LS41VjNhLjUuNSAwIDAgMC0uNS0uNXpNNS4yODEgNC43NWExIDEgMCAwIDEgMCAyIDEgMSAwIDAgMSAwLTJ6bTguMDMgNi44M2EuMTI3LjEyNyAwIDAgMS0uMDgxLjAzSDIuNzY5YS4xMjUuMTI1IDAgMCAxLS4wOTYtLjIwN2wyLjY2MS0zLjE1NmEuMTI2LjEyNiAwIDAgMSAuMTc3LS4wMTZsLjAxNi4wMTZMNy4wOCAxMC4wOWwyLjQ3LTIuOTNhLjEyNi4xMjYgMCAwIDEgLjE3Ny0uMDE2bC4wMTUuMDE2IDMuNTg4IDQuMjQ0YS4xMjcuMTI3IDAgMCAxLS4wMi4xNzV6IiBmaWxsPSIjOEM4QzhDIiBmaWxsLXJ1bGU9Im5vbnplcm8iLz48L3N2Zz4=')",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center",
        backgroundSize: "30%"
      },
      [`${componentCls}-mask`]: Object.assign({}, genImageMaskStyle(token2)),
      [`${componentCls}-mask:hover`]: {
        opacity: 1
      },
      [`${componentCls}-placeholder`]: Object.assign({}, genBoxStyle())
    }
  };
};
var genPreviewMotion = (token2) => {
  const {
    previewCls
  } = token2;
  return {
    [`${previewCls}-root`]: initZoomMotion(token2, "zoom"),
    "&": initFadeMotion(token2, true)
  };
};
var prepareComponentToken21 = (token2) => ({
  zIndexPopup: token2.zIndexPopupBase + 80,
  previewOperationColor: new FastColor(token2.colorTextLightSolid).setA(0.65).toRgbString(),
  previewOperationHoverColor: new FastColor(token2.colorTextLightSolid).setA(0.85).toRgbString(),
  previewOperationColorDisabled: new FastColor(token2.colorTextLightSolid).setA(0.25).toRgbString(),
  previewOperationSize: token2.fontSizeIcon * 1.5
  // FIXME: fontSizeIconLG
});
var style_default26 = genStyleHooks("Image", (token2) => {
  const previewCls = `${token2.componentCls}-preview`;
  const imageToken = merge2(token2, {
    previewCls,
    modalMaskBg: new FastColor("#000").setA(0.45).toRgbString(),
    // FIXME: Shared Token
    imagePreviewSwitchSize: token2.controlHeightLG
  });
  return [genImageStyle(imageToken), genImagePreviewStyle(imageToken), genModalMaskStyle(merge2(imageToken, {
    componentCls: previewCls
  })), genPreviewMotion(imageToken)];
}, prepareComponentToken21);

// ../../node_modules/antd/es/image/PreviewGroup.js
var __rest45 = function(s, e3) {
  var t2 = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e3.indexOf(p) < 0) t2[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e3.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t2[p[i]] = s[p[i]];
  }
  return t2;
};
var icons = {
  rotateLeft: /* @__PURE__ */ React376.createElement(RotateLeftOutlined_default2, null),
  rotateRight: /* @__PURE__ */ React376.createElement(RotateRightOutlined_default2, null),
  zoomIn: /* @__PURE__ */ React376.createElement(ZoomInOutlined_default2, null),
  zoomOut: /* @__PURE__ */ React376.createElement(ZoomOutOutlined_default2, null),
  close: /* @__PURE__ */ React376.createElement(CloseOutlined_default2, null),
  left: /* @__PURE__ */ React376.createElement(LeftOutlined_default2, null),
  right: /* @__PURE__ */ React376.createElement(RightOutlined_default2, null),
  flipX: /* @__PURE__ */ React376.createElement(SwapOutlined_default2, null),
  flipY: /* @__PURE__ */ React376.createElement(SwapOutlined_default2, {
    rotate: 90
  })
};
var InternalPreviewGroup = (_a) => {
  var {
    previewPrefixCls: customizePrefixCls,
    preview
  } = _a, otherProps = __rest45(_a, ["previewPrefixCls", "preview"]);
  const {
    getPrefixCls,
    direction
  } = React376.useContext(ConfigContext);
  const prefixCls = getPrefixCls("image", customizePrefixCls);
  const previewPrefixCls = `${prefixCls}-preview`;
  const rootPrefixCls = getPrefixCls();
  const rootCls = useCSSVarCls_default(prefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = style_default26(prefixCls, rootCls);
  const [zIndex] = useZIndex("ImagePreview", typeof preview === "object" ? preview.zIndex : void 0);
  const memoizedIcons = React376.useMemo(() => Object.assign(Object.assign({}, icons), {
    left: direction === "rtl" ? /* @__PURE__ */ React376.createElement(RightOutlined_default2, null) : /* @__PURE__ */ React376.createElement(LeftOutlined_default2, null),
    right: direction === "rtl" ? /* @__PURE__ */ React376.createElement(LeftOutlined_default2, null) : /* @__PURE__ */ React376.createElement(RightOutlined_default2, null)
  }), [direction]);
  const mergedPreview = React376.useMemo(() => {
    var _a2;
    if (preview === false) {
      return preview;
    }
    const _preview = typeof preview === "object" ? preview : {};
    const mergedRootClassName = (0, import_classnames142.default)(hashId, cssVarCls, rootCls, (_a2 = _preview.rootClassName) !== null && _a2 !== void 0 ? _a2 : "");
    return Object.assign(Object.assign({}, _preview), {
      transitionName: getTransitionName2(rootPrefixCls, "zoom", _preview.transitionName),
      maskTransitionName: getTransitionName2(rootPrefixCls, "fade", _preview.maskTransitionName),
      rootClassName: mergedRootClassName,
      zIndex
    });
  }, [preview]);
  return wrapCSSVar(/* @__PURE__ */ React376.createElement(es_default23.PreviewGroup, Object.assign({
    preview: mergedPreview,
    previewPrefixCls,
    icons: memoizedIcons
  }, otherProps)));
};
var PreviewGroup_default2 = InternalPreviewGroup;

// ../../node_modules/antd/es/image/index.js
var __rest46 = function(s, e3) {
  var t2 = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e3.indexOf(p) < 0) t2[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e3.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t2[p[i]] = s[p[i]];
  }
  return t2;
};
var Image2 = (props) => {
  const {
    prefixCls: customizePrefixCls,
    preview,
    className: className2,
    rootClassName,
    style: style2
  } = props, otherProps = __rest46(props, ["prefixCls", "preview", "className", "rootClassName", "style"]);
  if (true) {
    const warning6 = devUseWarning("Image");
    warning6.deprecated(!(preview && typeof preview === "object" && "destroyOnClose" in preview), "destroyOnClose", "destroyOnHidden");
  }
  const {
    getPrefixCls,
    getPopupContainer: getContextPopupContainer,
    className: contextClassName,
    style: contextStyle,
    preview: contextPreview
  } = useComponentConfig("image");
  const [imageLocale] = useLocale_default("Image");
  const prefixCls = getPrefixCls("image", customizePrefixCls);
  const rootPrefixCls = getPrefixCls();
  const rootCls = useCSSVarCls_default(prefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = style_default26(prefixCls, rootCls);
  const mergedRootClassName = (0, import_classnames143.default)(rootClassName, hashId, cssVarCls, rootCls);
  const mergedClassName = (0, import_classnames143.default)(className2, hashId, contextClassName);
  const [zIndex] = useZIndex("ImagePreview", typeof preview === "object" ? preview.zIndex : void 0);
  const mergedPreview = React377.useMemo(() => {
    if (preview === false) {
      return preview;
    }
    const _preview = typeof preview === "object" ? preview : {};
    const {
      getContainer: getContainer2,
      closeIcon,
      rootClassName: rootClassName2,
      destroyOnClose,
      destroyOnHidden
    } = _preview, restPreviewProps = __rest46(_preview, ["getContainer", "closeIcon", "rootClassName", "destroyOnClose", "destroyOnHidden"]);
    return Object.assign(Object.assign({
      mask: /* @__PURE__ */ React377.createElement("div", {
        className: `${prefixCls}-mask-info`
      }, /* @__PURE__ */ React377.createElement(EyeOutlined_default2, null), imageLocale === null || imageLocale === void 0 ? void 0 : imageLocale.preview),
      icons
    }, restPreviewProps), {
      // TODO: In the future, destroyOnClose in rc-image needs to be upgrade to destroyOnHidden
      destroyOnClose: destroyOnHidden !== null && destroyOnHidden !== void 0 ? destroyOnHidden : destroyOnClose,
      rootClassName: (0, import_classnames143.default)(mergedRootClassName, rootClassName2),
      getContainer: getContainer2 !== null && getContainer2 !== void 0 ? getContainer2 : getContextPopupContainer,
      transitionName: getTransitionName2(rootPrefixCls, "zoom", _preview.transitionName),
      maskTransitionName: getTransitionName2(rootPrefixCls, "fade", _preview.maskTransitionName),
      zIndex,
      closeIcon: closeIcon !== null && closeIcon !== void 0 ? closeIcon : contextPreview === null || contextPreview === void 0 ? void 0 : contextPreview.closeIcon
    });
  }, [preview, imageLocale, contextPreview === null || contextPreview === void 0 ? void 0 : contextPreview.closeIcon]);
  const mergedStyle = Object.assign(Object.assign({}, contextStyle), style2);
  return wrapCSSVar(/* @__PURE__ */ React377.createElement(es_default23, Object.assign({
    prefixCls,
    preview: mergedPreview,
    rootClassName: mergedRootClassName,
    className: mergedClassName,
    style: mergedStyle
  }, otherProps)));
};
Image2.PreviewGroup = PreviewGroup_default2;
if (true) {
  Image2.displayName = "Image";
}
var image_default = Image2;

// ../../node_modules/antd/es/input/Group.js
var React378 = __toESM(require_react());
var import_react124 = __toESM(require_react());
var import_classnames144 = __toESM(require_classnames());
var Group3 = (props) => {
  const {
    getPrefixCls,
    direction
  } = (0, import_react124.useContext)(ConfigContext);
  const {
    prefixCls: customizePrefixCls,
    className: className2
  } = props;
  const prefixCls = getPrefixCls("input-group", customizePrefixCls);
  const inputPrefixCls = getPrefixCls("input");
  const [wrapCSSVar, hashId, cssVarCls] = style_default16(inputPrefixCls);
  const cls11 = (0, import_classnames144.default)(prefixCls, cssVarCls, {
    [`${prefixCls}-lg`]: props.size === "large",
    [`${prefixCls}-sm`]: props.size === "small",
    [`${prefixCls}-compact`]: props.compact,
    [`${prefixCls}-rtl`]: direction === "rtl"
  }, hashId, className2);
  const formItemContext = (0, import_react124.useContext)(FormItemInputContext);
  const groupFormItemContext = (0, import_react124.useMemo)(() => Object.assign(Object.assign({}, formItemContext), {
    isFormItemInput: false
  }), [formItemContext]);
  if (true) {
    const warning6 = devUseWarning("Input.Group");
    warning6.deprecated(false, "Input.Group", "Space.Compact");
  }
  return wrapCSSVar(/* @__PURE__ */ React378.createElement("span", {
    className: cls11,
    style: props.style,
    onMouseEnter: props.onMouseEnter,
    onMouseLeave: props.onMouseLeave,
    onFocus: props.onFocus,
    onBlur: props.onBlur
  }, /* @__PURE__ */ React378.createElement(FormItemInputContext.Provider, {
    value: groupFormItemContext
  }, props.children)));
};
var Group_default2 = Group3;

// ../../node_modules/antd/es/input/OTP/index.js
var React380 = __toESM(require_react());
var import_classnames146 = __toESM(require_classnames());

// ../../node_modules/antd/es/input/style/otp.js
var genOTPStyle = (token2) => {
  const {
    componentCls,
    paddingXS
  } = token2;
  return {
    [componentCls]: {
      display: "inline-flex",
      alignItems: "center",
      flexWrap: "nowrap",
      columnGap: paddingXS,
      [`${componentCls}-input-wrapper`]: {
        position: "relative",
        [`${componentCls}-mask-icon`]: {
          position: "absolute",
          zIndex: "1",
          top: "50%",
          right: "50%",
          transform: "translate(50%, -50%)",
          pointerEvents: "none"
        },
        [`${componentCls}-mask-input`]: {
          color: "transparent",
          caretColor: token2.colorText
        },
        [`${componentCls}-mask-input[type=number]::-webkit-inner-spin-button`]: {
          "-webkit-appearance": "none",
          margin: 0
        },
        [`${componentCls}-mask-input[type=number]`]: {
          "-moz-appearance": "textfield"
        }
      },
      "&-rtl": {
        direction: "rtl"
      },
      [`${componentCls}-input`]: {
        textAlign: "center",
        paddingInline: token2.paddingXXS
      },
      // ================= Size =================
      [`&${componentCls}-sm ${componentCls}-input`]: {
        paddingInline: token2.calc(token2.paddingXXS).div(2).equal()
      },
      [`&${componentCls}-lg ${componentCls}-input`]: {
        paddingInline: token2.paddingXS
      }
    }
  };
};
var otp_default = genStyleHooks(["Input", "OTP"], (token2) => {
  const inputToken = merge2(token2, initInputToken(token2));
  return genOTPStyle(inputToken);
}, initComponentToken);

// ../../node_modules/antd/es/input/OTP/OTPInput.js
var React379 = __toESM(require_react());
var import_classnames145 = __toESM(require_classnames());
var __rest47 = function(s, e3) {
  var t2 = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e3.indexOf(p) < 0) t2[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e3.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t2[p[i]] = s[p[i]];
  }
  return t2;
};
var OTPInput = /* @__PURE__ */ React379.forwardRef((props, ref3) => {
  const {
    className: className2,
    value,
    onChange,
    onActiveChange,
    index: index3,
    mask
  } = props, restProps = __rest47(props, ["className", "value", "onChange", "onActiveChange", "index", "mask"]);
  const {
    getPrefixCls
  } = React379.useContext(ConfigContext);
  const prefixCls = getPrefixCls("otp");
  const maskValue = typeof mask === "string" ? mask : value;
  const inputRef = React379.useRef(null);
  React379.useImperativeHandle(ref3, () => inputRef.current);
  const onInternalChange = (e3) => {
    onChange(index3, e3.target.value);
  };
  const syncSelection = () => {
    raf_default(() => {
      var _a;
      const inputEle = (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.input;
      if (document.activeElement === inputEle && inputEle) {
        inputEle.select();
      }
    });
  };
  const onInternalKeyDown = (event) => {
    const {
      key: key2,
      ctrlKey,
      metaKey
    } = event;
    if (key2 === "ArrowLeft") {
      onActiveChange(index3 - 1);
    } else if (key2 === "ArrowRight") {
      onActiveChange(index3 + 1);
    } else if (key2 === "z" && (ctrlKey || metaKey)) {
      event.preventDefault();
    }
    syncSelection();
  };
  const onInternalKeyUp = (e3) => {
    if (e3.key === "Backspace" && !value) {
      onActiveChange(index3 - 1);
    }
    syncSelection();
  };
  return /* @__PURE__ */ React379.createElement("span", {
    className: `${prefixCls}-input-wrapper`,
    role: "presentation"
  }, mask && value !== "" && value !== void 0 && /* @__PURE__ */ React379.createElement("span", {
    className: `${prefixCls}-mask-icon`,
    "aria-hidden": "true"
  }, maskValue), /* @__PURE__ */ React379.createElement(Input_default5, Object.assign({
    "aria-label": `OTP Input ${index3 + 1}`,
    type: mask === true ? "password" : "text"
  }, restProps, {
    ref: inputRef,
    value,
    onInput: onInternalChange,
    onFocus: syncSelection,
    onKeyDown: onInternalKeyDown,
    onKeyUp: onInternalKeyUp,
    onMouseDown: syncSelection,
    onMouseUp: syncSelection,
    className: (0, import_classnames145.default)(className2, {
      [`${prefixCls}-mask-input`]: mask
    })
  })));
});
var OTPInput_default = OTPInput;

// ../../node_modules/antd/es/input/OTP/index.js
var __rest48 = function(s, e3) {
  var t2 = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e3.indexOf(p) < 0) t2[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e3.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t2[p[i]] = s[p[i]];
  }
  return t2;
};
function strToArr(str) {
  return (str || "").split("");
}
var Separator = (props) => {
  const {
    index: index3,
    prefixCls,
    separator
  } = props;
  const separatorNode = typeof separator === "function" ? separator(index3) : separator;
  if (!separatorNode) {
    return null;
  }
  return /* @__PURE__ */ React380.createElement("span", {
    className: `${prefixCls}-separator`
  }, separatorNode);
};
var OTP = /* @__PURE__ */ React380.forwardRef((props, ref3) => {
  const {
    prefixCls: customizePrefixCls,
    length: length2 = 6,
    size: customSize,
    defaultValue: defaultValue2,
    value,
    onChange,
    formatter,
    separator,
    variant,
    disabled,
    status: customStatus,
    autoFocus,
    mask,
    type: type5,
    onInput,
    inputMode
  } = props, restProps = __rest48(props, ["prefixCls", "length", "size", "defaultValue", "value", "onChange", "formatter", "separator", "variant", "disabled", "status", "autoFocus", "mask", "type", "onInput", "inputMode"]);
  if (true) {
    const warning6 = devUseWarning("Input.OTP");
    true ? warning6(!(typeof mask === "string" && mask.length > 1), "usage", "`mask` prop should be a single character.") : void 0;
  }
  const {
    getPrefixCls,
    direction
  } = React380.useContext(ConfigContext);
  const prefixCls = getPrefixCls("otp", customizePrefixCls);
  const domAttrs = pickAttrs(restProps, {
    aria: true,
    data: true,
    attr: true
  });
  const [wrapCSSVar, hashId, cssVarCls] = otp_default(prefixCls);
  const mergedSize = useSize_default((ctx) => customSize !== null && customSize !== void 0 ? customSize : ctx);
  const formContext = React380.useContext(FormItemInputContext);
  const mergedStatus = getMergedStatus(formContext.status, customStatus);
  const proxyFormContext = React380.useMemo(() => Object.assign(Object.assign({}, formContext), {
    status: mergedStatus,
    hasFeedback: false,
    feedbackIcon: null
  }), [formContext, mergedStatus]);
  const containerRef = React380.useRef(null);
  const refs2 = React380.useRef({});
  React380.useImperativeHandle(ref3, () => ({
    focus: () => {
      var _a;
      (_a = refs2.current[0]) === null || _a === void 0 ? void 0 : _a.focus();
    },
    blur: () => {
      var _a;
      for (let i = 0; i < length2; i += 1) {
        (_a = refs2.current[i]) === null || _a === void 0 ? void 0 : _a.blur();
      }
    },
    nativeElement: containerRef.current
  }));
  const internalFormatter = (txt) => formatter ? formatter(txt) : txt;
  const [valueCells, setValueCells] = React380.useState(() => strToArr(internalFormatter(defaultValue2 || "")));
  React380.useEffect(() => {
    if (value !== void 0) {
      setValueCells(strToArr(value));
    }
  }, [value]);
  const triggerValueCellsChange = useEvent2((nextValueCells) => {
    setValueCells(nextValueCells);
    if (onInput) {
      onInput(nextValueCells);
    }
    if (onChange && nextValueCells.length === length2 && nextValueCells.every((c) => c) && nextValueCells.some((c, index3) => valueCells[index3] !== c)) {
      onChange(nextValueCells.join(""));
    }
  });
  const patchValue = useEvent2((index3, txt) => {
    let nextCells = _toConsumableArray(valueCells);
    for (let i = 0; i < index3; i += 1) {
      if (!nextCells[i]) {
        nextCells[i] = "";
      }
    }
    if (txt.length <= 1) {
      nextCells[index3] = txt;
    } else {
      nextCells = nextCells.slice(0, index3).concat(strToArr(txt));
    }
    nextCells = nextCells.slice(0, length2);
    for (let i = nextCells.length - 1; i >= 0; i -= 1) {
      if (nextCells[i]) {
        break;
      }
      nextCells.pop();
    }
    const formattedValue = internalFormatter(nextCells.map((c) => c || " ").join(""));
    nextCells = strToArr(formattedValue).map((c, i) => {
      if (c === " " && !nextCells[i]) {
        return nextCells[i];
      }
      return c;
    });
    return nextCells;
  });
  const onInputChange = (index3, txt) => {
    var _a;
    const nextCells = patchValue(index3, txt);
    const nextIndex2 = Math.min(index3 + txt.length, length2 - 1);
    if (nextIndex2 !== index3 && nextCells[index3] !== void 0) {
      (_a = refs2.current[nextIndex2]) === null || _a === void 0 ? void 0 : _a.focus();
    }
    triggerValueCellsChange(nextCells);
  };
  const onInputActiveChange = (nextIndex2) => {
    var _a;
    (_a = refs2.current[nextIndex2]) === null || _a === void 0 ? void 0 : _a.focus();
  };
  const inputSharedProps = {
    variant,
    disabled,
    status: mergedStatus,
    mask,
    type: type5,
    inputMode
  };
  return wrapCSSVar(/* @__PURE__ */ React380.createElement("div", Object.assign({}, domAttrs, {
    ref: containerRef,
    className: (0, import_classnames146.default)(prefixCls, {
      [`${prefixCls}-sm`]: mergedSize === "small",
      [`${prefixCls}-lg`]: mergedSize === "large",
      [`${prefixCls}-rtl`]: direction === "rtl"
    }, cssVarCls, hashId),
    role: "group"
  }), /* @__PURE__ */ React380.createElement(FormItemInputContext.Provider, {
    value: proxyFormContext
  }, Array.from({
    length: length2
  }).map((_, index3) => {
    const key2 = `otp-${index3}`;
    const singleValue = valueCells[index3] || "";
    return /* @__PURE__ */ React380.createElement(React380.Fragment, {
      key: key2
    }, /* @__PURE__ */ React380.createElement(OTPInput_default, Object.assign({
      ref: (inputEle) => {
        refs2.current[index3] = inputEle;
      },
      index: index3,
      size: mergedSize,
      htmlSize: 1,
      className: `${prefixCls}-input`,
      onChange: onInputChange,
      value: singleValue,
      onActiveChange: onInputActiveChange,
      autoFocus: index3 === 0 && autoFocus
    }, inputSharedProps)), index3 < length2 - 1 && /* @__PURE__ */ React380.createElement(Separator, {
      separator,
      index: index3,
      prefixCls
    }));
  }))));
});
var OTP_default = OTP;

// ../../node_modules/antd/es/input/Password.js
var React382 = __toESM(require_react());
var import_react125 = __toESM(require_react());

// ../../node_modules/@ant-design/icons/es/icons/EyeInvisibleOutlined.js
var React381 = __toESM(require_react());

// ../../node_modules/@ant-design/icons-svg/es/asn/EyeInvisibleOutlined.js
var EyeInvisibleOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M942.2 486.2Q889.47 375.11 816.7 305l-50.88 50.88C807.31 395.53 843.45 447.4 874.7 512 791.5 684.2 673.4 766 512 766q-72.67 0-133.87-22.38L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 000-51.5zm-63.57-320.64L836 122.88a8 8 0 00-11.32 0L715.31 232.2Q624.86 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 000 51.5q56.69 119.4 136.5 191.41L112.48 835a8 8 0 000 11.31L155.17 889a8 8 0 0011.31 0l712.15-712.12a8 8 0 000-11.32zM149.3 512C232.6 339.8 350.7 258 512 258c54.54 0 104.13 9.36 149.12 28.39l-70.3 70.3a176 176 0 00-238.13 238.13l-83.42 83.42C223.1 637.49 183.3 582.28 149.3 512zm246.7 0a112.11 112.11 0 01146.2-106.69L401.31 546.2A112 112 0 01396 512z" } }, { "tag": "path", "attrs": { "d": "M508 624c-3.46 0-6.87-.16-10.25-.47l-52.82 52.82a176.09 176.09 0 00227.42-227.42l-52.82 52.82c.31 3.38.47 6.79.47 10.25a111.94 111.94 0 01-112 112z" } }] }, "name": "eye-invisible", "theme": "outlined" };
var EyeInvisibleOutlined_default = EyeInvisibleOutlined;

// ../../node_modules/@ant-design/icons/es/icons/EyeInvisibleOutlined.js
var EyeInvisibleOutlined2 = function EyeInvisibleOutlined3(props, ref3) {
  return /* @__PURE__ */ React381.createElement(AntdIcon_default, _extends({}, props, {
    ref: ref3,
    icon: EyeInvisibleOutlined_default
  }));
};
var RefIcon26 = /* @__PURE__ */ React381.forwardRef(EyeInvisibleOutlined2);
if (true) {
  RefIcon26.displayName = "EyeInvisibleOutlined";
}
var EyeInvisibleOutlined_default2 = RefIcon26;

// ../../node_modules/antd/es/input/Password.js
var import_classnames147 = __toESM(require_classnames());
var __rest49 = function(s, e3) {
  var t2 = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e3.indexOf(p) < 0) t2[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e3.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t2[p[i]] = s[p[i]];
  }
  return t2;
};
var defaultIconRender = (visible) => visible ? /* @__PURE__ */ React382.createElement(EyeOutlined_default2, null) : /* @__PURE__ */ React382.createElement(EyeInvisibleOutlined_default2, null);
var actionMap = {
  click: "onClick",
  hover: "onMouseOver"
};
var Password = /* @__PURE__ */ React382.forwardRef((props, ref3) => {
  const {
    disabled: customDisabled,
    action = "click",
    visibilityToggle = true,
    iconRender = defaultIconRender,
    suffix
  } = props;
  const disabled = React382.useContext(DisabledContext_default);
  const mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
  const visibilityControlled = typeof visibilityToggle === "object" && visibilityToggle.visible !== void 0;
  const [visible, setVisible] = (0, import_react125.useState)(() => visibilityControlled ? visibilityToggle.visible : false);
  const inputRef = (0, import_react125.useRef)(null);
  React382.useEffect(() => {
    if (visibilityControlled) {
      setVisible(visibilityToggle.visible);
    }
  }, [visibilityControlled, visibilityToggle]);
  const removePasswordTimeout = useRemovePasswordTimeout(inputRef);
  const onVisibleChange = () => {
    var _a;
    if (mergedDisabled) {
      return;
    }
    if (visible) {
      removePasswordTimeout();
    }
    const nextVisible = !visible;
    setVisible(nextVisible);
    if (typeof visibilityToggle === "object") {
      (_a = visibilityToggle.onVisibleChange) === null || _a === void 0 ? void 0 : _a.call(visibilityToggle, nextVisible);
    }
  };
  const getIcon2 = (prefixCls2) => {
    const iconTrigger = actionMap[action] || "";
    const icon = iconRender(visible);
    const iconProps = {
      [iconTrigger]: onVisibleChange,
      className: `${prefixCls2}-icon`,
      key: "passwordIcon",
      onMouseDown: (e3) => {
        e3.preventDefault();
      },
      onMouseUp: (e3) => {
        e3.preventDefault();
      }
    };
    return /* @__PURE__ */ React382.cloneElement(/* @__PURE__ */ React382.isValidElement(icon) ? icon : /* @__PURE__ */ React382.createElement("span", null, icon), iconProps);
  };
  const {
    className: className2,
    prefixCls: customizePrefixCls,
    inputPrefixCls: customizeInputPrefixCls,
    size
  } = props, restProps = __rest49(props, ["className", "prefixCls", "inputPrefixCls", "size"]);
  const {
    getPrefixCls
  } = React382.useContext(ConfigContext);
  const inputPrefixCls = getPrefixCls("input", customizeInputPrefixCls);
  const prefixCls = getPrefixCls("input-password", customizePrefixCls);
  const suffixIcon = visibilityToggle && getIcon2(prefixCls);
  const inputClassName = (0, import_classnames147.default)(prefixCls, className2, {
    [`${prefixCls}-${size}`]: !!size
  });
  const omittedProps = Object.assign(Object.assign({}, omit(restProps, ["suffix", "iconRender", "visibilityToggle"])), {
    type: visible ? "text" : "password",
    className: inputClassName,
    prefixCls: inputPrefixCls,
    suffix: /* @__PURE__ */ React382.createElement(React382.Fragment, null, suffixIcon, suffix)
  });
  if (size) {
    omittedProps.size = size;
  }
  return /* @__PURE__ */ React382.createElement(Input_default5, Object.assign({
    ref: composeRef(ref3, inputRef)
  }, omittedProps));
});
if (true) {
  Password.displayName = "Input.Password";
}
var Password_default = Password;

// ../../node_modules/antd/es/input/Search.js
var React383 = __toESM(require_react());
var import_classnames148 = __toESM(require_classnames());
var __rest50 = function(s, e3) {
  var t2 = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e3.indexOf(p) < 0) t2[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e3.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t2[p[i]] = s[p[i]];
  }
  return t2;
};
var Search = /* @__PURE__ */ React383.forwardRef((props, ref3) => {
  const {
    prefixCls: customizePrefixCls,
    inputPrefixCls: customizeInputPrefixCls,
    className: className2,
    size: customizeSize,
    suffix,
    enterButton = false,
    addonAfter,
    loading,
    disabled,
    onSearch: customOnSearch,
    onChange: customOnChange,
    onCompositionStart,
    onCompositionEnd,
    variant,
    onPressEnter: customOnPressEnter
  } = props, restProps = __rest50(props, ["prefixCls", "inputPrefixCls", "className", "size", "suffix", "enterButton", "addonAfter", "loading", "disabled", "onSearch", "onChange", "onCompositionStart", "onCompositionEnd", "variant", "onPressEnter"]);
  const {
    getPrefixCls,
    direction
  } = React383.useContext(ConfigContext);
  const composedRef = React383.useRef(false);
  const prefixCls = getPrefixCls("input-search", customizePrefixCls);
  const inputPrefixCls = getPrefixCls("input", customizeInputPrefixCls);
  const {
    compactSize
  } = useCompactItemContext(prefixCls, direction);
  const size = useSize_default((ctx) => {
    var _a;
    return (_a = customizeSize !== null && customizeSize !== void 0 ? customizeSize : compactSize) !== null && _a !== void 0 ? _a : ctx;
  });
  const inputRef = React383.useRef(null);
  const onChange = (e3) => {
    if ((e3 === null || e3 === void 0 ? void 0 : e3.target) && e3.type === "click" && customOnSearch) {
      customOnSearch(e3.target.value, e3, {
        source: "clear"
      });
    }
    customOnChange === null || customOnChange === void 0 ? void 0 : customOnChange(e3);
  };
  const onMouseDown = (e3) => {
    var _a;
    if (document.activeElement === ((_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.input)) {
      e3.preventDefault();
    }
  };
  const onSearch = (e3) => {
    var _a, _b;
    if (customOnSearch) {
      customOnSearch((_b = (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.input) === null || _b === void 0 ? void 0 : _b.value, e3, {
        source: "input"
      });
    }
  };
  const onPressEnter = (e3) => {
    if (composedRef.current || loading) {
      return;
    }
    customOnPressEnter === null || customOnPressEnter === void 0 ? void 0 : customOnPressEnter(e3);
    onSearch(e3);
  };
  const searchIcon = typeof enterButton === "boolean" ? /* @__PURE__ */ React383.createElement(SearchOutlined_default2, null) : null;
  const btnClassName = `${prefixCls}-button`;
  let button;
  const enterButtonAsElement = enterButton || {};
  const isAntdButton = enterButtonAsElement.type && enterButtonAsElement.type.__ANT_BUTTON === true;
  if (isAntdButton || enterButtonAsElement.type === "button") {
    button = cloneElement4(enterButtonAsElement, Object.assign({
      onMouseDown,
      onClick: (e3) => {
        var _a, _b;
        (_b = (_a = enterButtonAsElement === null || enterButtonAsElement === void 0 ? void 0 : enterButtonAsElement.props) === null || _a === void 0 ? void 0 : _a.onClick) === null || _b === void 0 ? void 0 : _b.call(_a, e3);
        onSearch(e3);
      },
      key: "enterButton"
    }, isAntdButton ? {
      className: btnClassName,
      size
    } : {}));
  } else {
    button = /* @__PURE__ */ React383.createElement(button_default2, {
      className: btnClassName,
      color: enterButton ? "primary" : "default",
      size,
      disabled,
      key: "enterButton",
      onMouseDown,
      onClick: onSearch,
      loading,
      icon: searchIcon,
      variant: variant === "borderless" || variant === "filled" || variant === "underlined" ? "text" : enterButton ? "solid" : void 0
    }, enterButton);
  }
  if (addonAfter) {
    button = [button, cloneElement4(addonAfter, {
      key: "addonAfter"
    })];
  }
  const cls11 = (0, import_classnames148.default)(prefixCls, {
    [`${prefixCls}-rtl`]: direction === "rtl",
    [`${prefixCls}-${size}`]: !!size,
    [`${prefixCls}-with-button`]: !!enterButton
  }, className2);
  const handleOnCompositionStart = (e3) => {
    composedRef.current = true;
    onCompositionStart === null || onCompositionStart === void 0 ? void 0 : onCompositionStart(e3);
  };
  const handleOnCompositionEnd = (e3) => {
    composedRef.current = false;
    onCompositionEnd === null || onCompositionEnd === void 0 ? void 0 : onCompositionEnd(e3);
  };
  const inputProps = Object.assign(Object.assign({}, restProps), {
    className: cls11,
    prefixCls: inputPrefixCls,
    type: "search",
    size,
    variant,
    onPressEnter,
    onCompositionStart: handleOnCompositionStart,
    onCompositionEnd: handleOnCompositionEnd,
    addonAfter: button,
    suffix,
    onChange,
    disabled
  });
  return /* @__PURE__ */ React383.createElement(Input_default5, Object.assign({
    ref: composeRef(inputRef, ref3)
  }, inputProps));
});
if (true) {
  Search.displayName = "Search";
}
var Search_default = Search;

// ../../node_modules/antd/es/input/TextArea.js
var React386 = __toESM(require_react());
var import_react127 = __toESM(require_react());
var import_classnames151 = __toESM(require_classnames());

// ../../node_modules/rc-textarea/es/TextArea.js
var import_classnames150 = __toESM(require_classnames());
var import_react126 = __toESM(require_react());

// ../../node_modules/rc-textarea/es/ResizableTextArea.js
var import_classnames149 = __toESM(require_classnames());
var React384 = __toESM(require_react());

// ../../node_modules/rc-textarea/es/calculateNodeHeight.js
var HIDDEN_TEXTAREA_STYLE = "\n  min-height:0 !important;\n  max-height:none !important;\n  height:0 !important;\n  visibility:hidden !important;\n  overflow:hidden !important;\n  position:absolute !important;\n  z-index:-1000 !important;\n  top:0 !important;\n  right:0 !important;\n  pointer-events: none !important;\n";
var SIZING_STYLE = ["letter-spacing", "line-height", "padding-top", "padding-bottom", "font-family", "font-weight", "font-size", "font-variant", "text-rendering", "text-transform", "width", "text-indent", "padding-left", "padding-right", "border-width", "box-sizing", "word-break", "white-space"];
var computedStyleCache = {};
var hiddenTextarea;
function calculateNodeStyling(node2) {
  var useCache = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
  var nodeRef = node2.getAttribute("id") || node2.getAttribute("data-reactid") || node2.getAttribute("name");
  if (useCache && computedStyleCache[nodeRef]) {
    return computedStyleCache[nodeRef];
  }
  var style2 = window.getComputedStyle(node2);
  var boxSizing = style2.getPropertyValue("box-sizing") || style2.getPropertyValue("-moz-box-sizing") || style2.getPropertyValue("-webkit-box-sizing");
  var paddingSize = parseFloat(style2.getPropertyValue("padding-bottom")) + parseFloat(style2.getPropertyValue("padding-top"));
  var borderSize = parseFloat(style2.getPropertyValue("border-bottom-width")) + parseFloat(style2.getPropertyValue("border-top-width"));
  var sizingStyle = SIZING_STYLE.map(function(name) {
    return "".concat(name, ":").concat(style2.getPropertyValue(name));
  }).join(";");
  var nodeInfo = {
    sizingStyle,
    paddingSize,
    borderSize,
    boxSizing
  };
  if (useCache && nodeRef) {
    computedStyleCache[nodeRef] = nodeInfo;
  }
  return nodeInfo;
}
function calculateAutoSizeStyle(uiTextNode) {
  var useCache = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
  var minRows = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
  var maxRows = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
  if (!hiddenTextarea) {
    hiddenTextarea = document.createElement("textarea");
    hiddenTextarea.setAttribute("tab-index", "-1");
    hiddenTextarea.setAttribute("aria-hidden", "true");
    hiddenTextarea.setAttribute("name", "hiddenTextarea");
    document.body.appendChild(hiddenTextarea);
  }
  if (uiTextNode.getAttribute("wrap")) {
    hiddenTextarea.setAttribute("wrap", uiTextNode.getAttribute("wrap"));
  } else {
    hiddenTextarea.removeAttribute("wrap");
  }
  var _calculateNodeStyling = calculateNodeStyling(uiTextNode, useCache), paddingSize = _calculateNodeStyling.paddingSize, borderSize = _calculateNodeStyling.borderSize, boxSizing = _calculateNodeStyling.boxSizing, sizingStyle = _calculateNodeStyling.sizingStyle;
  hiddenTextarea.setAttribute("style", "".concat(sizingStyle, ";").concat(HIDDEN_TEXTAREA_STYLE));
  hiddenTextarea.value = uiTextNode.value || uiTextNode.placeholder || "";
  var minHeight = void 0;
  var maxHeight = void 0;
  var overflowY;
  var height = hiddenTextarea.scrollHeight;
  if (boxSizing === "border-box") {
    height += borderSize;
  } else if (boxSizing === "content-box") {
    height -= paddingSize;
  }
  if (minRows !== null || maxRows !== null) {
    hiddenTextarea.value = " ";
    var singleRowHeight = hiddenTextarea.scrollHeight - paddingSize;
    if (minRows !== null) {
      minHeight = singleRowHeight * minRows;
      if (boxSizing === "border-box") {
        minHeight = minHeight + paddingSize + borderSize;
      }
      height = Math.max(minHeight, height);
    }
    if (maxRows !== null) {
      maxHeight = singleRowHeight * maxRows;
      if (boxSizing === "border-box") {
        maxHeight = maxHeight + paddingSize + borderSize;
      }
      overflowY = height > maxHeight ? "" : "hidden";
      height = Math.min(maxHeight, height);
    }
  }
  var style2 = {
    height,
    overflowY,
    resize: "none"
  };
  if (minHeight) {
    style2.minHeight = minHeight;
  }
  if (maxHeight) {
    style2.maxHeight = maxHeight;
  }
  return style2;
}

// ../../node_modules/rc-textarea/es/ResizableTextArea.js
var _excluded58 = ["prefixCls", "defaultValue", "value", "autoSize", "onResize", "className", "style", "disabled", "onChange", "onInternalAutoSize"];
var RESIZE_START = 0;
var RESIZE_MEASURING = 1;
var RESIZE_STABLE = 2;
var ResizableTextArea = /* @__PURE__ */ React384.forwardRef(function(props, ref3) {
  var _ref = props, prefixCls = _ref.prefixCls, defaultValue2 = _ref.defaultValue, value = _ref.value, autoSize = _ref.autoSize, onResize2 = _ref.onResize, className2 = _ref.className, style2 = _ref.style, disabled = _ref.disabled, onChange = _ref.onChange, onInternalAutoSize = _ref.onInternalAutoSize, restProps = _objectWithoutProperties(_ref, _excluded58);
  var _useMergedState = useMergedState(defaultValue2, {
    value,
    postState: function postState(val) {
      return val !== null && val !== void 0 ? val : "";
    }
  }), _useMergedState2 = _slicedToArray(_useMergedState, 2), mergedValue = _useMergedState2[0], setMergedValue = _useMergedState2[1];
  var onInternalChange = function onInternalChange2(event) {
    setMergedValue(event.target.value);
    onChange === null || onChange === void 0 || onChange(event);
  };
  var textareaRef = React384.useRef();
  React384.useImperativeHandle(ref3, function() {
    return {
      textArea: textareaRef.current
    };
  });
  var _React$useMemo = React384.useMemo(function() {
    if (autoSize && _typeof(autoSize) === "object") {
      return [autoSize.minRows, autoSize.maxRows];
    }
    return [];
  }, [autoSize]), _React$useMemo2 = _slicedToArray(_React$useMemo, 2), minRows = _React$useMemo2[0], maxRows = _React$useMemo2[1];
  var needAutoSize = !!autoSize;
  var _React$useState = React384.useState(RESIZE_STABLE), _React$useState2 = _slicedToArray(_React$useState, 2), resizeState = _React$useState2[0], setResizeState = _React$useState2[1];
  var _React$useState3 = React384.useState(), _React$useState4 = _slicedToArray(_React$useState3, 2), autoSizeStyle = _React$useState4[0], setAutoSizeStyle = _React$useState4[1];
  var startResize = function startResize2() {
    setResizeState(RESIZE_START);
    if (false) {
      onInternalAutoSize === null || onInternalAutoSize === void 0 || onInternalAutoSize();
    }
  };
  useLayoutEffect_default(function() {
    if (needAutoSize) {
      startResize();
    }
  }, [value, minRows, maxRows, needAutoSize]);
  useLayoutEffect_default(function() {
    if (resizeState === RESIZE_START) {
      setResizeState(RESIZE_MEASURING);
    } else if (resizeState === RESIZE_MEASURING) {
      var textareaStyles = calculateAutoSizeStyle(textareaRef.current, false, minRows, maxRows);
      setResizeState(RESIZE_STABLE);
      setAutoSizeStyle(textareaStyles);
    } else {
    }
  }, [resizeState]);
  var resizeRafRef = React384.useRef();
  var cleanRaf = function cleanRaf2() {
    raf_default.cancel(resizeRafRef.current);
  };
  var onInternalResize = function onInternalResize2(size) {
    if (resizeState === RESIZE_STABLE) {
      onResize2 === null || onResize2 === void 0 || onResize2(size);
      if (autoSize) {
        cleanRaf();
        resizeRafRef.current = raf_default(function() {
          startResize();
        });
      }
    }
  };
  React384.useEffect(function() {
    return cleanRaf;
  }, []);
  var mergedAutoSizeStyle = needAutoSize ? autoSizeStyle : null;
  var mergedStyle = _objectSpread2(_objectSpread2({}, style2), mergedAutoSizeStyle);
  if (resizeState === RESIZE_START || resizeState === RESIZE_MEASURING) {
    mergedStyle.overflowY = "hidden";
    mergedStyle.overflowX = "hidden";
  }
  return /* @__PURE__ */ React384.createElement(es_default, {
    onResize: onInternalResize,
    disabled: !(autoSize || onResize2)
  }, /* @__PURE__ */ React384.createElement("textarea", _extends({}, restProps, {
    ref: textareaRef,
    style: mergedStyle,
    className: (0, import_classnames149.default)(prefixCls, className2, _defineProperty({}, "".concat(prefixCls, "-disabled"), disabled)),
    disabled,
    value: mergedValue,
    onChange: onInternalChange
  })));
});
var ResizableTextArea_default = ResizableTextArea;

// ../../node_modules/rc-textarea/es/TextArea.js
var _excluded59 = ["defaultValue", "value", "onFocus", "onBlur", "onChange", "allowClear", "maxLength", "onCompositionStart", "onCompositionEnd", "suffix", "prefixCls", "showCount", "count", "className", "style", "disabled", "hidden", "classNames", "styles", "onResize", "onClear", "onPressEnter", "readOnly", "autoSize", "onKeyDown"];
var TextArea = /* @__PURE__ */ import_react126.default.forwardRef(function(_ref, ref3) {
  var _countConfig$max;
  var defaultValue2 = _ref.defaultValue, customValue = _ref.value, onFocus = _ref.onFocus, onBlur = _ref.onBlur, onChange = _ref.onChange, allowClear = _ref.allowClear, maxLength = _ref.maxLength, onCompositionStart = _ref.onCompositionStart, onCompositionEnd = _ref.onCompositionEnd, suffix = _ref.suffix, _ref$prefixCls = _ref.prefixCls, prefixCls = _ref$prefixCls === void 0 ? "rc-textarea" : _ref$prefixCls, showCount = _ref.showCount, count = _ref.count, className2 = _ref.className, style2 = _ref.style, disabled = _ref.disabled, hidden = _ref.hidden, classNames186 = _ref.classNames, styles = _ref.styles, onResize2 = _ref.onResize, onClear = _ref.onClear, onPressEnter = _ref.onPressEnter, readOnly = _ref.readOnly, autoSize = _ref.autoSize, onKeyDown2 = _ref.onKeyDown, rest = _objectWithoutProperties(_ref, _excluded59);
  var _useMergedState = useMergedState(defaultValue2, {
    value: customValue,
    defaultValue: defaultValue2
  }), _useMergedState2 = _slicedToArray(_useMergedState, 2), value = _useMergedState2[0], setValue = _useMergedState2[1];
  var formatValue2 = value === void 0 || value === null ? "" : String(value);
  var _React$useState = import_react126.default.useState(false), _React$useState2 = _slicedToArray(_React$useState, 2), focused = _React$useState2[0], setFocused = _React$useState2[1];
  var compositionRef = import_react126.default.useRef(false);
  var _React$useState3 = import_react126.default.useState(null), _React$useState4 = _slicedToArray(_React$useState3, 2), textareaResized = _React$useState4[0], setTextareaResized = _React$useState4[1];
  var holderRef = (0, import_react126.useRef)(null);
  var resizableTextAreaRef = (0, import_react126.useRef)(null);
  var getTextArea = function getTextArea2() {
    var _resizableTextAreaRef;
    return (_resizableTextAreaRef = resizableTextAreaRef.current) === null || _resizableTextAreaRef === void 0 ? void 0 : _resizableTextAreaRef.textArea;
  };
  var focus = function focus2() {
    getTextArea().focus();
  };
  (0, import_react126.useImperativeHandle)(ref3, function() {
    var _holderRef$current;
    return {
      resizableTextArea: resizableTextAreaRef.current,
      focus,
      blur: function blur() {
        getTextArea().blur();
      },
      nativeElement: ((_holderRef$current = holderRef.current) === null || _holderRef$current === void 0 ? void 0 : _holderRef$current.nativeElement) || getTextArea()
    };
  });
  (0, import_react126.useEffect)(function() {
    setFocused(function(prev2) {
      return !disabled && prev2;
    });
  }, [disabled]);
  var _React$useState5 = import_react126.default.useState(null), _React$useState6 = _slicedToArray(_React$useState5, 2), selection = _React$useState6[0], setSelection = _React$useState6[1];
  import_react126.default.useEffect(function() {
    if (selection) {
      var _getTextArea;
      (_getTextArea = getTextArea()).setSelectionRange.apply(_getTextArea, _toConsumableArray(selection));
    }
  }, [selection]);
  var countConfig = useCount(count, showCount);
  var mergedMax = (_countConfig$max = countConfig.max) !== null && _countConfig$max !== void 0 ? _countConfig$max : maxLength;
  var hasMaxLength = Number(mergedMax) > 0;
  var valueLength = countConfig.strategy(formatValue2);
  var isOutOfRange = !!mergedMax && valueLength > mergedMax;
  var triggerChange = function triggerChange2(e3, currentValue) {
    var cutValue = currentValue;
    if (!compositionRef.current && countConfig.exceedFormatter && countConfig.max && countConfig.strategy(currentValue) > countConfig.max) {
      cutValue = countConfig.exceedFormatter(currentValue, {
        max: countConfig.max
      });
      if (currentValue !== cutValue) {
        setSelection([getTextArea().selectionStart || 0, getTextArea().selectionEnd || 0]);
      }
    }
    setValue(cutValue);
    resolveOnChange(e3.currentTarget, e3, onChange, cutValue);
  };
  var onInternalCompositionStart = function onInternalCompositionStart2(e3) {
    compositionRef.current = true;
    onCompositionStart === null || onCompositionStart === void 0 || onCompositionStart(e3);
  };
  var onInternalCompositionEnd = function onInternalCompositionEnd2(e3) {
    compositionRef.current = false;
    triggerChange(e3, e3.currentTarget.value);
    onCompositionEnd === null || onCompositionEnd === void 0 || onCompositionEnd(e3);
  };
  var onInternalChange = function onInternalChange2(e3) {
    triggerChange(e3, e3.target.value);
  };
  var handleKeyDown = function handleKeyDown2(e3) {
    if (e3.key === "Enter" && onPressEnter) {
      onPressEnter(e3);
    }
    onKeyDown2 === null || onKeyDown2 === void 0 || onKeyDown2(e3);
  };
  var handleFocus = function handleFocus2(e3) {
    setFocused(true);
    onFocus === null || onFocus === void 0 || onFocus(e3);
  };
  var handleBlur = function handleBlur2(e3) {
    setFocused(false);
    onBlur === null || onBlur === void 0 || onBlur(e3);
  };
  var handleReset = function handleReset2(e3) {
    setValue("");
    focus();
    resolveOnChange(getTextArea(), e3, onChange);
  };
  var suffixNode = suffix;
  var dataCount;
  if (countConfig.show) {
    if (countConfig.showFormatter) {
      dataCount = countConfig.showFormatter({
        value: formatValue2,
        count: valueLength,
        maxLength: mergedMax
      });
    } else {
      dataCount = "".concat(valueLength).concat(hasMaxLength ? " / ".concat(mergedMax) : "");
    }
    suffixNode = /* @__PURE__ */ import_react126.default.createElement(import_react126.default.Fragment, null, suffixNode, /* @__PURE__ */ import_react126.default.createElement("span", {
      className: (0, import_classnames150.default)("".concat(prefixCls, "-data-count"), classNames186 === null || classNames186 === void 0 ? void 0 : classNames186.count),
      style: styles === null || styles === void 0 ? void 0 : styles.count
    }, dataCount));
  }
  var handleResize = function handleResize2(size) {
    var _getTextArea2;
    onResize2 === null || onResize2 === void 0 || onResize2(size);
    if ((_getTextArea2 = getTextArea()) !== null && _getTextArea2 !== void 0 && _getTextArea2.style.height) {
      setTextareaResized(true);
    }
  };
  var isPureTextArea = !autoSize && !showCount && !allowClear;
  return /* @__PURE__ */ import_react126.default.createElement(BaseInput_default, {
    ref: holderRef,
    value: formatValue2,
    allowClear,
    handleReset,
    suffix: suffixNode,
    prefixCls,
    classNames: _objectSpread2(_objectSpread2({}, classNames186), {}, {
      affixWrapper: (0, import_classnames150.default)(classNames186 === null || classNames186 === void 0 ? void 0 : classNames186.affixWrapper, _defineProperty(_defineProperty({}, "".concat(prefixCls, "-show-count"), showCount), "".concat(prefixCls, "-textarea-allow-clear"), allowClear))
    }),
    disabled,
    focused,
    className: (0, import_classnames150.default)(className2, isOutOfRange && "".concat(prefixCls, "-out-of-range")),
    style: _objectSpread2(_objectSpread2({}, style2), textareaResized && !isPureTextArea ? {
      height: "auto"
    } : {}),
    dataAttrs: {
      affixWrapper: {
        "data-count": typeof dataCount === "string" ? dataCount : void 0
      }
    },
    hidden,
    readOnly,
    onClear
  }, /* @__PURE__ */ import_react126.default.createElement(ResizableTextArea_default, _extends({}, rest, {
    autoSize,
    maxLength,
    onKeyDown: handleKeyDown,
    onChange: onInternalChange,
    onFocus: handleFocus,
    onBlur: handleBlur,
    onCompositionStart: onInternalCompositionStart,
    onCompositionEnd: onInternalCompositionEnd,
    className: (0, import_classnames150.default)(classNames186 === null || classNames186 === void 0 ? void 0 : classNames186.textarea),
    style: _objectSpread2(_objectSpread2({}, styles === null || styles === void 0 ? void 0 : styles.textarea), {}, {
      resize: style2 === null || style2 === void 0 ? void 0 : style2.resize
    }),
    disabled,
    prefixCls,
    onResize: handleResize,
    ref: resizableTextAreaRef,
    readOnly
  })));
});
var TextArea_default = TextArea;

// ../../node_modules/rc-textarea/es/index.js
var es_default24 = TextArea_default;

// ../../node_modules/antd/es/input/style/textarea.js
var genTextAreaStyle = (token2) => {
  const {
    componentCls,
    paddingLG
  } = token2;
  const textareaPrefixCls = `${componentCls}-textarea`;
  return {
    // Raw Textarea
    [`textarea${componentCls}`]: {
      maxWidth: "100%",
      // prevent textarea resize from coming out of its container
      height: "auto",
      minHeight: token2.controlHeight,
      lineHeight: token2.lineHeight,
      verticalAlign: "bottom",
      transition: `all ${token2.motionDurationSlow}`,
      resize: "vertical",
      [`&${componentCls}-mouse-active`]: {
        transition: `all ${token2.motionDurationSlow}, height 0s, width 0s`
      }
    },
    // Wrapper for resize
    [`${componentCls}-textarea-affix-wrapper-resize-dirty`]: {
      width: "auto"
    },
    [textareaPrefixCls]: {
      position: "relative",
      "&-show-count": {
        [`${componentCls}-data-count`]: {
          position: "absolute",
          bottom: token2.calc(token2.fontSize).mul(token2.lineHeight).mul(-1).equal(),
          insetInlineEnd: 0,
          color: token2.colorTextDescription,
          whiteSpace: "nowrap",
          pointerEvents: "none"
        }
      },
      [`
        &-allow-clear > ${componentCls},
        &-affix-wrapper${textareaPrefixCls}-has-feedback ${componentCls}
      `]: {
        paddingInlineEnd: paddingLG
      },
      [`&-affix-wrapper${componentCls}-affix-wrapper`]: {
        padding: 0,
        [`> textarea${componentCls}`]: {
          fontSize: "inherit",
          border: "none",
          outline: "none",
          background: "transparent",
          minHeight: token2.calc(token2.controlHeight).sub(token2.calc(token2.lineWidth).mul(2)).equal(),
          "&:focus": {
            boxShadow: "none !important"
          }
        },
        [`${componentCls}-suffix`]: {
          margin: 0,
          "> *:not(:last-child)": {
            marginInline: 0
          },
          // Clear Icon
          [`${componentCls}-clear-icon`]: {
            position: "absolute",
            insetInlineEnd: token2.paddingInline,
            insetBlockStart: token2.paddingXS
          },
          // Feedback Icon
          [`${textareaPrefixCls}-suffix`]: {
            position: "absolute",
            top: 0,
            insetInlineEnd: token2.paddingInline,
            bottom: 0,
            zIndex: 1,
            display: "inline-flex",
            alignItems: "center",
            margin: "auto",
            pointerEvents: "none"
          }
        }
      },
      [`&-affix-wrapper${componentCls}-affix-wrapper-rtl`]: {
        [`${componentCls}-suffix`]: {
          [`${componentCls}-data-count`]: {
            direction: "ltr",
            insetInlineStart: 0
          }
        }
      },
      [`&-affix-wrapper${componentCls}-affix-wrapper-sm`]: {
        [`${componentCls}-suffix`]: {
          [`${componentCls}-clear-icon`]: {
            insetInlineEnd: token2.paddingInlineSM
          }
        }
      }
    }
  };
};
var textarea_default = genStyleHooks(["Input", "TextArea"], (token2) => {
  const inputToken = merge2(token2, initInputToken(token2));
  return genTextAreaStyle(inputToken);
}, initComponentToken, {
  resetFont: false
});

// ../../node_modules/antd/es/input/TextArea.js
var __rest51 = function(s, e3) {
  var t2 = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e3.indexOf(p) < 0) t2[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e3.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t2[p[i]] = s[p[i]];
  }
  return t2;
};
var TextArea2 = /* @__PURE__ */ (0, import_react127.forwardRef)((props, ref3) => {
  var _a;
  const {
    prefixCls: customizePrefixCls,
    bordered = true,
    size: customizeSize,
    disabled: customDisabled,
    status: customStatus,
    allowClear,
    classNames: classes,
    rootClassName,
    className: className2,
    style: style2,
    styles,
    variant: customVariant,
    showCount,
    onMouseDown,
    onResize: onResize2
  } = props, rest = __rest51(props, ["prefixCls", "bordered", "size", "disabled", "status", "allowClear", "classNames", "rootClassName", "className", "style", "styles", "variant", "showCount", "onMouseDown", "onResize"]);
  if (true) {
    const {
      deprecated
    } = devUseWarning("TextArea");
    deprecated(!("bordered" in props), "bordered", "variant");
  }
  const {
    getPrefixCls,
    direction,
    allowClear: contextAllowClear,
    autoComplete: contextAutoComplete,
    className: contextClassName,
    style: contextStyle,
    classNames: contextClassNames,
    styles: contextStyles
  } = useComponentConfig("textArea");
  const disabled = React386.useContext(DisabledContext_default);
  const mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
  const {
    status: contextStatus,
    hasFeedback,
    feedbackIcon
  } = React386.useContext(FormItemInputContext);
  const mergedStatus = getMergedStatus(contextStatus, customStatus);
  const innerRef = React386.useRef(null);
  React386.useImperativeHandle(ref3, () => {
    var _a2;
    return {
      resizableTextArea: (_a2 = innerRef.current) === null || _a2 === void 0 ? void 0 : _a2.resizableTextArea,
      focus: (option) => {
        var _a3, _b;
        triggerFocus((_b = (_a3 = innerRef.current) === null || _a3 === void 0 ? void 0 : _a3.resizableTextArea) === null || _b === void 0 ? void 0 : _b.textArea, option);
      },
      blur: () => {
        var _a3;
        return (_a3 = innerRef.current) === null || _a3 === void 0 ? void 0 : _a3.blur();
      }
    };
  });
  const prefixCls = getPrefixCls("input", customizePrefixCls);
  const rootCls = useCSSVarCls_default(prefixCls);
  const [wrapSharedCSSVar, hashId, cssVarCls] = useSharedStyle(prefixCls, rootClassName);
  const [wrapCSSVar] = textarea_default(prefixCls, rootCls);
  const {
    compactSize,
    compactItemClassnames
  } = useCompactItemContext(prefixCls, direction);
  const mergedSize = useSize_default((ctx) => {
    var _a2;
    return (_a2 = customizeSize !== null && customizeSize !== void 0 ? customizeSize : compactSize) !== null && _a2 !== void 0 ? _a2 : ctx;
  });
  const [variant, enableVariantCls] = useVariants_default("textArea", customVariant, bordered);
  const mergedAllowClear = getAllowClear_default(allowClear !== null && allowClear !== void 0 ? allowClear : contextAllowClear);
  const [isMouseDown, setIsMouseDown] = React386.useState(false);
  const [resizeDirty, setResizeDirty] = React386.useState(false);
  const onInternalMouseDown = (e3) => {
    setIsMouseDown(true);
    onMouseDown === null || onMouseDown === void 0 ? void 0 : onMouseDown(e3);
    const onMouseUp = () => {
      setIsMouseDown(false);
      document.removeEventListener("mouseup", onMouseUp);
    };
    document.addEventListener("mouseup", onMouseUp);
  };
  const onInternalResize = (size) => {
    var _a2, _b;
    onResize2 === null || onResize2 === void 0 ? void 0 : onResize2(size);
    if (isMouseDown && typeof getComputedStyle === "function") {
      const ele = (_b = (_a2 = innerRef.current) === null || _a2 === void 0 ? void 0 : _a2.nativeElement) === null || _b === void 0 ? void 0 : _b.querySelector("textarea");
      if (ele && getComputedStyle(ele).resize === "both") {
        setResizeDirty(true);
      }
    }
  };
  return wrapSharedCSSVar(wrapCSSVar(/* @__PURE__ */ React386.createElement(es_default24, Object.assign({
    autoComplete: contextAutoComplete
  }, rest, {
    style: Object.assign(Object.assign({}, contextStyle), style2),
    styles: Object.assign(Object.assign({}, contextStyles), styles),
    disabled: mergedDisabled,
    allowClear: mergedAllowClear,
    className: (0, import_classnames151.default)(
      cssVarCls,
      rootCls,
      className2,
      rootClassName,
      compactItemClassnames,
      contextClassName,
      // Only for wrapper
      resizeDirty && `${prefixCls}-textarea-affix-wrapper-resize-dirty`
    ),
    classNames: Object.assign(Object.assign(Object.assign({}, classes), contextClassNames), {
      textarea: (0, import_classnames151.default)({
        [`${prefixCls}-sm`]: mergedSize === "small",
        [`${prefixCls}-lg`]: mergedSize === "large"
      }, hashId, classes === null || classes === void 0 ? void 0 : classes.textarea, contextClassNames.textarea, isMouseDown && `${prefixCls}-mouse-active`),
      variant: (0, import_classnames151.default)({
        [`${prefixCls}-${variant}`]: enableVariantCls
      }, getStatusClassNames(prefixCls, mergedStatus)),
      affixWrapper: (0, import_classnames151.default)(`${prefixCls}-textarea-affix-wrapper`, {
        [`${prefixCls}-affix-wrapper-rtl`]: direction === "rtl",
        [`${prefixCls}-affix-wrapper-sm`]: mergedSize === "small",
        [`${prefixCls}-affix-wrapper-lg`]: mergedSize === "large",
        [`${prefixCls}-textarea-show-count`]: showCount || ((_a = props.count) === null || _a === void 0 ? void 0 : _a.show)
      }, hashId)
    }),
    prefixCls,
    suffix: hasFeedback && /* @__PURE__ */ React386.createElement("span", {
      className: `${prefixCls}-textarea-suffix`
    }, feedbackIcon),
    showCount,
    ref: innerRef,
    onResize: onInternalResize,
    onMouseDown: onInternalMouseDown
  }))));
});
var TextArea_default2 = TextArea2;

// ../../node_modules/antd/es/input/index.js
var Input6 = Input_default5;
Input6.Group = Group_default2;
Input6.Search = Search_default;
Input6.TextArea = TextArea_default2;
Input6.Password = Password_default;
Input6.OTP = OTP_default;
var input_default = Input6;

// ../../node_modules/antd/es/list/index.js
var React400 = __toESM(require_react());
var import_classnames160 = __toESM(require_classnames());

// ../../node_modules/antd/es/pagination/Pagination.js
var React392 = __toESM(require_react());

// ../../node_modules/@ant-design/icons/es/icons/DoubleLeftOutlined.js
var React387 = __toESM(require_react());

// ../../node_modules/@ant-design/icons-svg/es/asn/DoubleLeftOutlined.js
var DoubleLeftOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M272.9 512l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L186.8 492.3a31.99 31.99 0 000 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H532c6.7 0 10.4-7.7 6.3-12.9L272.9 512zm304 0l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L490.8 492.3a31.99 31.99 0 000 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H836c6.7 0 10.4-7.7 6.3-12.9L576.9 512z" } }] }, "name": "double-left", "theme": "outlined" };
var DoubleLeftOutlined_default = DoubleLeftOutlined;

// ../../node_modules/@ant-design/icons/es/icons/DoubleLeftOutlined.js
var DoubleLeftOutlined2 = function DoubleLeftOutlined3(props, ref3) {
  return /* @__PURE__ */ React387.createElement(AntdIcon_default, _extends({}, props, {
    ref: ref3,
    icon: DoubleLeftOutlined_default
  }));
};
var RefIcon27 = /* @__PURE__ */ React387.forwardRef(DoubleLeftOutlined2);
if (true) {
  RefIcon27.displayName = "DoubleLeftOutlined";
}
var DoubleLeftOutlined_default2 = RefIcon27;

// ../../node_modules/@ant-design/icons/es/icons/DoubleRightOutlined.js
var React388 = __toESM(require_react());

// ../../node_modules/@ant-design/icons-svg/es/asn/DoubleRightOutlined.js
var DoubleRightOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M533.2 492.3L277.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H188c-6.7 0-10.4 7.7-6.3 12.9L447.1 512 181.7 851.1A7.98 7.98 0 00188 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5zm304 0L581.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H492c-6.7 0-10.4 7.7-6.3 12.9L751.1 512 485.7 851.1A7.98 7.98 0 00492 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5z" } }] }, "name": "double-right", "theme": "outlined" };
var DoubleRightOutlined_default = DoubleRightOutlined;

// ../../node_modules/@ant-design/icons/es/icons/DoubleRightOutlined.js
var DoubleRightOutlined2 = function DoubleRightOutlined3(props, ref3) {
  return /* @__PURE__ */ React388.createElement(AntdIcon_default, _extends({}, props, {
    ref: ref3,
    icon: DoubleRightOutlined_default
  }));
};
var RefIcon28 = /* @__PURE__ */ React388.forwardRef(DoubleRightOutlined2);
if (true) {
  RefIcon28.displayName = "DoubleRightOutlined";
}
var DoubleRightOutlined_default2 = RefIcon28;

// ../../node_modules/antd/es/pagination/Pagination.js
var import_classnames154 = __toESM(require_classnames());

// ../../node_modules/rc-pagination/es/Pagination.js
var import_classnames153 = __toESM(require_classnames());
var import_react130 = __toESM(require_react());

// ../../node_modules/rc-pagination/es/locale/zh_CN.js
var locale5 = {
  // Options
  items_per_page: "\u6761/\u9875",
  jump_to: "\u8DF3\u81F3",
  jump_to_confirm: "\u786E\u5B9A",
  page: "\u9875",
  // Pagination
  prev_page: "\u4E0A\u4E00\u9875",
  next_page: "\u4E0B\u4E00\u9875",
  prev_5: "\u5411\u524D 5 \u9875",
  next_5: "\u5411\u540E 5 \u9875",
  prev_3: "\u5411\u524D 3 \u9875",
  next_3: "\u5411\u540E 3 \u9875",
  page_size: "\u9875\u7801"
};
var zh_CN_default = locale5;

// ../../node_modules/rc-pagination/es/Options.js
var import_react128 = __toESM(require_react());
var defaultPageSizeOptions = [10, 20, 50, 100];
var Options = function Options2(props) {
  var _props$pageSizeOption = props.pageSizeOptions, pageSizeOptions = _props$pageSizeOption === void 0 ? defaultPageSizeOptions : _props$pageSizeOption, locale6 = props.locale, changeSize = props.changeSize, pageSize = props.pageSize, goButton = props.goButton, quickGo = props.quickGo, rootPrefixCls = props.rootPrefixCls, disabled = props.disabled, buildOptionText = props.buildOptionText, showSizeChanger = props.showSizeChanger, sizeChangerRender = props.sizeChangerRender;
  var _React$useState = import_react128.default.useState(""), _React$useState2 = _slicedToArray(_React$useState, 2), goInputText = _React$useState2[0], setGoInputText = _React$useState2[1];
  var getValidValue = function getValidValue2() {
    return !goInputText || Number.isNaN(goInputText) ? void 0 : Number(goInputText);
  };
  var mergeBuildOptionText = typeof buildOptionText === "function" ? buildOptionText : function(value) {
    return "".concat(value, " ").concat(locale6.items_per_page);
  };
  var handleChange = function handleChange2(e3) {
    setGoInputText(e3.target.value);
  };
  var handleBlur = function handleBlur2(e3) {
    if (goButton || goInputText === "") {
      return;
    }
    setGoInputText("");
    if (e3.relatedTarget && (e3.relatedTarget.className.indexOf("".concat(rootPrefixCls, "-item-link")) >= 0 || e3.relatedTarget.className.indexOf("".concat(rootPrefixCls, "-item")) >= 0)) {
      return;
    }
    quickGo === null || quickGo === void 0 || quickGo(getValidValue());
  };
  var go = function go2(e3) {
    if (goInputText === "") {
      return;
    }
    if (e3.keyCode === KeyCode_default.ENTER || e3.type === "click") {
      setGoInputText("");
      quickGo === null || quickGo === void 0 || quickGo(getValidValue());
    }
  };
  var getPageSizeOptions = function getPageSizeOptions2() {
    if (pageSizeOptions.some(function(option) {
      return option.toString() === pageSize.toString();
    })) {
      return pageSizeOptions;
    }
    return pageSizeOptions.concat([pageSize]).sort(function(a, b) {
      var numberA = Number.isNaN(Number(a)) ? 0 : Number(a);
      var numberB = Number.isNaN(Number(b)) ? 0 : Number(b);
      return numberA - numberB;
    });
  };
  var prefixCls = "".concat(rootPrefixCls, "-options");
  if (!showSizeChanger && !quickGo) {
    return null;
  }
  var changeSelect = null;
  var goInput = null;
  var gotoButton = null;
  if (showSizeChanger && sizeChangerRender) {
    changeSelect = sizeChangerRender({
      disabled,
      size: pageSize,
      onSizeChange: function onSizeChange(nextValue) {
        changeSize === null || changeSize === void 0 || changeSize(Number(nextValue));
      },
      "aria-label": locale6.page_size,
      className: "".concat(prefixCls, "-size-changer"),
      options: getPageSizeOptions().map(function(opt) {
        return {
          label: mergeBuildOptionText(opt),
          value: opt
        };
      })
    });
  }
  if (quickGo) {
    if (goButton) {
      gotoButton = typeof goButton === "boolean" ? /* @__PURE__ */ import_react128.default.createElement("button", {
        type: "button",
        onClick: go,
        onKeyUp: go,
        disabled,
        className: "".concat(prefixCls, "-quick-jumper-button")
      }, locale6.jump_to_confirm) : /* @__PURE__ */ import_react128.default.createElement("span", {
        onClick: go,
        onKeyUp: go
      }, goButton);
    }
    goInput = /* @__PURE__ */ import_react128.default.createElement("div", {
      className: "".concat(prefixCls, "-quick-jumper")
    }, locale6.jump_to, /* @__PURE__ */ import_react128.default.createElement("input", {
      disabled,
      type: "text",
      value: goInputText,
      onChange: handleChange,
      onKeyUp: go,
      onBlur: handleBlur,
      "aria-label": locale6.page
    }), locale6.page, gotoButton);
  }
  return /* @__PURE__ */ import_react128.default.createElement("li", {
    className: prefixCls
  }, changeSelect, goInput);
};
if (true) {
  Options.displayName = "Options";
}
var Options_default = Options;

// ../../node_modules/rc-pagination/es/Pager.js
var import_classnames152 = __toESM(require_classnames());
var import_react129 = __toESM(require_react());
var Pager = function Pager2(props) {
  var rootPrefixCls = props.rootPrefixCls, page = props.page, active = props.active, className2 = props.className, showTitle = props.showTitle, onClick = props.onClick, onKeyPress = props.onKeyPress, itemRender = props.itemRender;
  var prefixCls = "".concat(rootPrefixCls, "-item");
  var cls11 = (0, import_classnames152.default)(prefixCls, "".concat(prefixCls, "-").concat(page), _defineProperty(_defineProperty({}, "".concat(prefixCls, "-active"), active), "".concat(prefixCls, "-disabled"), !page), className2);
  var handleClick = function handleClick2() {
    onClick(page);
  };
  var handleKeyPress = function handleKeyPress2(e3) {
    onKeyPress(e3, onClick, page);
  };
  var pager = itemRender(page, "page", /* @__PURE__ */ import_react129.default.createElement("a", {
    rel: "nofollow"
  }, page));
  return pager ? /* @__PURE__ */ import_react129.default.createElement("li", {
    title: showTitle ? String(page) : null,
    className: cls11,
    onClick: handleClick,
    onKeyDown: handleKeyPress,
    tabIndex: 0
  }, pager) : null;
};
if (true) {
  Pager.displayName = "Pager";
}
var Pager_default = Pager;

// ../../node_modules/rc-pagination/es/Pagination.js
var defaultItemRender = function defaultItemRender2(page, type5, element) {
  return element;
};
function noop4() {
}
function isInteger(v) {
  var value = Number(v);
  return typeof value === "number" && !Number.isNaN(value) && isFinite(value) && Math.floor(value) === value;
}
function calculatePage(p, pageSize, total) {
  var _pageSize = typeof p === "undefined" ? pageSize : p;
  return Math.floor((total - 1) / _pageSize) + 1;
}
var Pagination = function Pagination2(props) {
  var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-pagination" : _props$prefixCls, _props$selectPrefixCl = props.selectPrefixCls, selectPrefixCls = _props$selectPrefixCl === void 0 ? "rc-select" : _props$selectPrefixCl, className2 = props.className, currentProp = props.current, _props$defaultCurrent = props.defaultCurrent, defaultCurrent = _props$defaultCurrent === void 0 ? 1 : _props$defaultCurrent, _props$total = props.total, total = _props$total === void 0 ? 0 : _props$total, pageSizeProp = props.pageSize, _props$defaultPageSiz = props.defaultPageSize, defaultPageSize = _props$defaultPageSiz === void 0 ? 10 : _props$defaultPageSiz, _props$onChange = props.onChange, onChange = _props$onChange === void 0 ? noop4 : _props$onChange, hideOnSinglePage = props.hideOnSinglePage, align = props.align, _props$showPrevNextJu = props.showPrevNextJumpers, showPrevNextJumpers = _props$showPrevNextJu === void 0 ? true : _props$showPrevNextJu, showQuickJumper = props.showQuickJumper, showLessItems = props.showLessItems, _props$showTitle = props.showTitle, showTitle = _props$showTitle === void 0 ? true : _props$showTitle, _props$onShowSizeChan = props.onShowSizeChange, onShowSizeChange = _props$onShowSizeChan === void 0 ? noop4 : _props$onShowSizeChan, _props$locale = props.locale, locale6 = _props$locale === void 0 ? zh_CN_default : _props$locale, style2 = props.style, _props$totalBoundaryS = props.totalBoundaryShowSizeChanger, totalBoundaryShowSizeChanger = _props$totalBoundaryS === void 0 ? 50 : _props$totalBoundaryS, disabled = props.disabled, simple = props.simple, showTotal = props.showTotal, _props$showSizeChange = props.showSizeChanger, showSizeChanger = _props$showSizeChange === void 0 ? total > totalBoundaryShowSizeChanger : _props$showSizeChange, sizeChangerRender = props.sizeChangerRender, pageSizeOptions = props.pageSizeOptions, _props$itemRender = props.itemRender, itemRender = _props$itemRender === void 0 ? defaultItemRender : _props$itemRender, jumpPrevIcon = props.jumpPrevIcon, jumpNextIcon = props.jumpNextIcon, prevIcon = props.prevIcon, nextIcon = props.nextIcon;
  var paginationRef = import_react130.default.useRef(null);
  var _useMergedState = useMergedState(10, {
    value: pageSizeProp,
    defaultValue: defaultPageSize
  }), _useMergedState2 = _slicedToArray(_useMergedState, 2), pageSize = _useMergedState2[0], setPageSize = _useMergedState2[1];
  var _useMergedState3 = useMergedState(1, {
    value: currentProp,
    defaultValue: defaultCurrent,
    postState: function postState(c) {
      return Math.max(1, Math.min(c, calculatePage(void 0, pageSize, total)));
    }
  }), _useMergedState4 = _slicedToArray(_useMergedState3, 2), current2 = _useMergedState4[0], setCurrent = _useMergedState4[1];
  var _React$useState = import_react130.default.useState(current2), _React$useState2 = _slicedToArray(_React$useState, 2), internalInputVal = _React$useState2[0], setInternalInputVal = _React$useState2[1];
  (0, import_react130.useEffect)(function() {
    setInternalInputVal(current2);
  }, [current2]);
  var hasOnChange = onChange !== noop4;
  var hasCurrent = "current" in props;
  if (true) {
    warning_default(hasCurrent ? hasOnChange : true, "You provided a `current` prop to a Pagination component without an `onChange` handler. This will render a read-only component.");
  }
  var jumpPrevPage = Math.max(1, current2 - (showLessItems ? 3 : 5));
  var jumpNextPage = Math.min(calculatePage(void 0, pageSize, total), current2 + (showLessItems ? 3 : 5));
  function getItemIcon(icon, label) {
    var iconNode = icon || /* @__PURE__ */ import_react130.default.createElement("button", {
      type: "button",
      "aria-label": label,
      className: "".concat(prefixCls, "-item-link")
    });
    if (typeof icon === "function") {
      iconNode = /* @__PURE__ */ import_react130.default.createElement(icon, _objectSpread2({}, props));
    }
    return iconNode;
  }
  function getValidValue(e3) {
    var inputValue = e3.target.value;
    var allPages2 = calculatePage(void 0, pageSize, total);
    var value;
    if (inputValue === "") {
      value = inputValue;
    } else if (Number.isNaN(Number(inputValue))) {
      value = internalInputVal;
    } else if (inputValue >= allPages2) {
      value = allPages2;
    } else {
      value = Number(inputValue);
    }
    return value;
  }
  function isValid2(page) {
    return isInteger(page) && page !== current2 && isInteger(total) && total > 0;
  }
  var shouldDisplayQuickJumper = total > pageSize ? showQuickJumper : false;
  function handleKeyDown(event) {
    if (event.keyCode === KeyCode_default.UP || event.keyCode === KeyCode_default.DOWN) {
      event.preventDefault();
    }
  }
  function handleKeyUp(event) {
    var value = getValidValue(event);
    if (value !== internalInputVal) {
      setInternalInputVal(value);
    }
    switch (event.keyCode) {
      case KeyCode_default.ENTER:
        handleChange(value);
        break;
      case KeyCode_default.UP:
        handleChange(value - 1);
        break;
      case KeyCode_default.DOWN:
        handleChange(value + 1);
        break;
      default:
        break;
    }
  }
  function handleBlur(event) {
    handleChange(getValidValue(event));
  }
  function changePageSize(size) {
    var newCurrent = calculatePage(size, pageSize, total);
    var nextCurrent = current2 > newCurrent && newCurrent !== 0 ? newCurrent : current2;
    setPageSize(size);
    setInternalInputVal(nextCurrent);
    onShowSizeChange === null || onShowSizeChange === void 0 || onShowSizeChange(current2, size);
    setCurrent(nextCurrent);
    onChange === null || onChange === void 0 || onChange(nextCurrent, size);
  }
  function handleChange(page) {
    if (isValid2(page) && !disabled) {
      var currentPage = calculatePage(void 0, pageSize, total);
      var newPage = page;
      if (page > currentPage) {
        newPage = currentPage;
      } else if (page < 1) {
        newPage = 1;
      }
      if (newPage !== internalInputVal) {
        setInternalInputVal(newPage);
      }
      setCurrent(newPage);
      onChange === null || onChange === void 0 || onChange(newPage, pageSize);
      return newPage;
    }
    return current2;
  }
  var hasPrev = current2 > 1;
  var hasNext = current2 < calculatePage(void 0, pageSize, total);
  function prevHandle() {
    if (hasPrev) handleChange(current2 - 1);
  }
  function nextHandle() {
    if (hasNext) handleChange(current2 + 1);
  }
  function jumpPrevHandle() {
    handleChange(jumpPrevPage);
  }
  function jumpNextHandle() {
    handleChange(jumpNextPage);
  }
  function runIfEnter(event, callback) {
    if (event.key === "Enter" || event.charCode === KeyCode_default.ENTER || event.keyCode === KeyCode_default.ENTER) {
      for (var _len = arguments.length, restParams = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        restParams[_key - 2] = arguments[_key];
      }
      callback.apply(void 0, restParams);
    }
  }
  function runIfEnterPrev(event) {
    runIfEnter(event, prevHandle);
  }
  function runIfEnterNext(event) {
    runIfEnter(event, nextHandle);
  }
  function runIfEnterJumpPrev(event) {
    runIfEnter(event, jumpPrevHandle);
  }
  function runIfEnterJumpNext(event) {
    runIfEnter(event, jumpNextHandle);
  }
  function renderPrev(prevPage2) {
    var prevButton = itemRender(prevPage2, "prev", getItemIcon(prevIcon, "prev page"));
    return /* @__PURE__ */ import_react130.default.isValidElement(prevButton) ? /* @__PURE__ */ import_react130.default.cloneElement(prevButton, {
      disabled: !hasPrev
    }) : prevButton;
  }
  function renderNext(nextPage2) {
    var nextButton = itemRender(nextPage2, "next", getItemIcon(nextIcon, "next page"));
    return /* @__PURE__ */ import_react130.default.isValidElement(nextButton) ? /* @__PURE__ */ import_react130.default.cloneElement(nextButton, {
      disabled: !hasNext
    }) : nextButton;
  }
  function handleGoTO(event) {
    if (event.type === "click" || event.keyCode === KeyCode_default.ENTER) {
      handleChange(internalInputVal);
    }
  }
  var jumpPrev = null;
  var dataOrAriaAttributeProps = pickAttrs(props, {
    aria: true,
    data: true
  });
  var totalText = showTotal && /* @__PURE__ */ import_react130.default.createElement("li", {
    className: "".concat(prefixCls, "-total-text")
  }, showTotal(total, [total === 0 ? 0 : (current2 - 1) * pageSize + 1, current2 * pageSize > total ? total : current2 * pageSize]));
  var jumpNext = null;
  var allPages = calculatePage(void 0, pageSize, total);
  if (hideOnSinglePage && total <= pageSize) {
    return null;
  }
  var pagerList = [];
  var pagerProps = {
    rootPrefixCls: prefixCls,
    onClick: handleChange,
    onKeyPress: runIfEnter,
    showTitle,
    itemRender,
    page: -1
  };
  var prevPage = current2 - 1 > 0 ? current2 - 1 : 0;
  var nextPage = current2 + 1 < allPages ? current2 + 1 : allPages;
  var goButton = showQuickJumper && showQuickJumper.goButton;
  var isReadOnly = _typeof(simple) === "object" ? simple.readOnly : !simple;
  var gotoButton = goButton;
  var simplePager = null;
  if (simple) {
    if (goButton) {
      if (typeof goButton === "boolean") {
        gotoButton = /* @__PURE__ */ import_react130.default.createElement("button", {
          type: "button",
          onClick: handleGoTO,
          onKeyUp: handleGoTO
        }, locale6.jump_to_confirm);
      } else {
        gotoButton = /* @__PURE__ */ import_react130.default.createElement("span", {
          onClick: handleGoTO,
          onKeyUp: handleGoTO
        }, goButton);
      }
      gotoButton = /* @__PURE__ */ import_react130.default.createElement("li", {
        title: showTitle ? "".concat(locale6.jump_to).concat(current2, "/").concat(allPages) : null,
        className: "".concat(prefixCls, "-simple-pager")
      }, gotoButton);
    }
    simplePager = /* @__PURE__ */ import_react130.default.createElement("li", {
      title: showTitle ? "".concat(current2, "/").concat(allPages) : null,
      className: "".concat(prefixCls, "-simple-pager")
    }, isReadOnly ? internalInputVal : /* @__PURE__ */ import_react130.default.createElement("input", {
      type: "text",
      "aria-label": locale6.jump_to,
      value: internalInputVal,
      disabled,
      onKeyDown: handleKeyDown,
      onKeyUp: handleKeyUp,
      onChange: handleKeyUp,
      onBlur: handleBlur,
      size: 3
    }), /* @__PURE__ */ import_react130.default.createElement("span", {
      className: "".concat(prefixCls, "-slash")
    }, "/"), allPages);
  }
  var pageBufferSize = showLessItems ? 1 : 2;
  if (allPages <= 3 + pageBufferSize * 2) {
    if (!allPages) {
      pagerList.push(/* @__PURE__ */ import_react130.default.createElement(Pager_default, _extends({}, pagerProps, {
        key: "noPager",
        page: 1,
        className: "".concat(prefixCls, "-item-disabled")
      })));
    }
    for (var i = 1; i <= allPages; i += 1) {
      pagerList.push(/* @__PURE__ */ import_react130.default.createElement(Pager_default, _extends({}, pagerProps, {
        key: i,
        page: i,
        active: current2 === i
      })));
    }
  } else {
    var prevItemTitle = showLessItems ? locale6.prev_3 : locale6.prev_5;
    var nextItemTitle = showLessItems ? locale6.next_3 : locale6.next_5;
    var jumpPrevContent = itemRender(jumpPrevPage, "jump-prev", getItemIcon(jumpPrevIcon, "prev page"));
    var jumpNextContent = itemRender(jumpNextPage, "jump-next", getItemIcon(jumpNextIcon, "next page"));
    if (showPrevNextJumpers) {
      jumpPrev = jumpPrevContent ? /* @__PURE__ */ import_react130.default.createElement("li", {
        title: showTitle ? prevItemTitle : null,
        key: "prev",
        onClick: jumpPrevHandle,
        tabIndex: 0,
        onKeyDown: runIfEnterJumpPrev,
        className: (0, import_classnames153.default)("".concat(prefixCls, "-jump-prev"), _defineProperty({}, "".concat(prefixCls, "-jump-prev-custom-icon"), !!jumpPrevIcon))
      }, jumpPrevContent) : null;
      jumpNext = jumpNextContent ? /* @__PURE__ */ import_react130.default.createElement("li", {
        title: showTitle ? nextItemTitle : null,
        key: "next",
        onClick: jumpNextHandle,
        tabIndex: 0,
        onKeyDown: runIfEnterJumpNext,
        className: (0, import_classnames153.default)("".concat(prefixCls, "-jump-next"), _defineProperty({}, "".concat(prefixCls, "-jump-next-custom-icon"), !!jumpNextIcon))
      }, jumpNextContent) : null;
    }
    var left2 = Math.max(1, current2 - pageBufferSize);
    var right2 = Math.min(current2 + pageBufferSize, allPages);
    if (current2 - 1 <= pageBufferSize) {
      right2 = 1 + pageBufferSize * 2;
    }
    if (allPages - current2 <= pageBufferSize) {
      left2 = allPages - pageBufferSize * 2;
    }
    for (var _i = left2; _i <= right2; _i += 1) {
      pagerList.push(/* @__PURE__ */ import_react130.default.createElement(Pager_default, _extends({}, pagerProps, {
        key: _i,
        page: _i,
        active: current2 === _i
      })));
    }
    if (current2 - 1 >= pageBufferSize * 2 && current2 !== 1 + 2) {
      pagerList[0] = /* @__PURE__ */ import_react130.default.cloneElement(pagerList[0], {
        className: (0, import_classnames153.default)("".concat(prefixCls, "-item-after-jump-prev"), pagerList[0].props.className)
      });
      pagerList.unshift(jumpPrev);
    }
    if (allPages - current2 >= pageBufferSize * 2 && current2 !== allPages - 2) {
      var lastOne = pagerList[pagerList.length - 1];
      pagerList[pagerList.length - 1] = /* @__PURE__ */ import_react130.default.cloneElement(lastOne, {
        className: (0, import_classnames153.default)("".concat(prefixCls, "-item-before-jump-next"), lastOne.props.className)
      });
      pagerList.push(jumpNext);
    }
    if (left2 !== 1) {
      pagerList.unshift(/* @__PURE__ */ import_react130.default.createElement(Pager_default, _extends({}, pagerProps, {
        key: 1,
        page: 1
      })));
    }
    if (right2 !== allPages) {
      pagerList.push(/* @__PURE__ */ import_react130.default.createElement(Pager_default, _extends({}, pagerProps, {
        key: allPages,
        page: allPages
      })));
    }
  }
  var prev2 = renderPrev(prevPage);
  if (prev2) {
    var prevDisabled = !hasPrev || !allPages;
    prev2 = /* @__PURE__ */ import_react130.default.createElement("li", {
      title: showTitle ? locale6.prev_page : null,
      onClick: prevHandle,
      tabIndex: prevDisabled ? null : 0,
      onKeyDown: runIfEnterPrev,
      className: (0, import_classnames153.default)("".concat(prefixCls, "-prev"), _defineProperty({}, "".concat(prefixCls, "-disabled"), prevDisabled)),
      "aria-disabled": prevDisabled
    }, prev2);
  }
  var next2 = renderNext(nextPage);
  if (next2) {
    var nextDisabled, nextTabIndex;
    if (simple) {
      nextDisabled = !hasNext;
      nextTabIndex = hasPrev ? 0 : null;
    } else {
      nextDisabled = !hasNext || !allPages;
      nextTabIndex = nextDisabled ? null : 0;
    }
    next2 = /* @__PURE__ */ import_react130.default.createElement("li", {
      title: showTitle ? locale6.next_page : null,
      onClick: nextHandle,
      tabIndex: nextTabIndex,
      onKeyDown: runIfEnterNext,
      className: (0, import_classnames153.default)("".concat(prefixCls, "-next"), _defineProperty({}, "".concat(prefixCls, "-disabled"), nextDisabled)),
      "aria-disabled": nextDisabled
    }, next2);
  }
  var cls11 = (0, import_classnames153.default)(prefixCls, className2, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "".concat(prefixCls, "-start"), align === "start"), "".concat(prefixCls, "-center"), align === "center"), "".concat(prefixCls, "-end"), align === "end"), "".concat(prefixCls, "-simple"), simple), "".concat(prefixCls, "-disabled"), disabled));
  return /* @__PURE__ */ import_react130.default.createElement("ul", _extends({
    className: cls11,
    style: style2,
    ref: paginationRef
  }, dataOrAriaAttributeProps), totalText, prev2, simple ? simplePager : pagerList, next2, /* @__PURE__ */ import_react130.default.createElement(Options_default, {
    locale: locale6,
    rootPrefixCls: prefixCls,
    disabled,
    selectPrefixCls,
    changeSize: changePageSize,
    pageSize,
    pageSizeOptions,
    quickGo: shouldDisplayQuickJumper ? handleChange : null,
    goButton: gotoButton,
    showSizeChanger,
    sizeChangerRender
  }));
};
if (true) {
  Pagination.displayName = "Pagination";
}
var Pagination_default = Pagination;

// ../../node_modules/antd/es/pagination/style/index.js
var genPaginationDisabledStyle = (token2) => {
  const {
    componentCls
  } = token2;
  return {
    [`${componentCls}-disabled`]: {
      "&, &:hover": {
        cursor: "not-allowed",
        [`${componentCls}-item-link`]: {
          color: token2.colorTextDisabled,
          cursor: "not-allowed"
        }
      },
      "&:focus-visible": {
        cursor: "not-allowed",
        [`${componentCls}-item-link`]: {
          color: token2.colorTextDisabled,
          cursor: "not-allowed"
        }
      }
    },
    [`&${componentCls}-disabled`]: {
      cursor: "not-allowed",
      [`${componentCls}-item`]: {
        cursor: "not-allowed",
        backgroundColor: "transparent",
        "&:hover, &:active": {
          backgroundColor: "transparent"
        },
        a: {
          color: token2.colorTextDisabled,
          backgroundColor: "transparent",
          border: "none",
          cursor: "not-allowed"
        },
        "&-active": {
          borderColor: token2.colorBorder,
          backgroundColor: token2.itemActiveBgDisabled,
          "&:hover, &:active": {
            backgroundColor: token2.itemActiveBgDisabled
          },
          a: {
            color: token2.itemActiveColorDisabled
          }
        }
      },
      [`${componentCls}-item-link`]: {
        color: token2.colorTextDisabled,
        cursor: "not-allowed",
        "&:hover, &:active": {
          backgroundColor: "transparent"
        },
        [`${componentCls}-simple&`]: {
          backgroundColor: "transparent",
          "&:hover, &:active": {
            backgroundColor: "transparent"
          }
        }
      },
      [`${componentCls}-simple-pager`]: {
        color: token2.colorTextDisabled
      },
      [`${componentCls}-jump-prev, ${componentCls}-jump-next`]: {
        [`${componentCls}-item-link-icon`]: {
          opacity: 0
        },
        [`${componentCls}-item-ellipsis`]: {
          opacity: 1
        }
      }
    }
  };
};
var genPaginationMiniStyle = (token2) => {
  const {
    componentCls
  } = token2;
  return {
    [`&${componentCls}-mini ${componentCls}-total-text, &${componentCls}-mini ${componentCls}-simple-pager`]: {
      height: token2.itemSizeSM,
      lineHeight: unit(token2.itemSizeSM)
    },
    [`&${componentCls}-mini ${componentCls}-item`]: {
      minWidth: token2.itemSizeSM,
      height: token2.itemSizeSM,
      margin: 0,
      lineHeight: unit(token2.calc(token2.itemSizeSM).sub(2).equal())
    },
    [`&${componentCls}-mini ${componentCls}-prev, &${componentCls}-mini ${componentCls}-next`]: {
      minWidth: token2.itemSizeSM,
      height: token2.itemSizeSM,
      margin: 0,
      lineHeight: unit(token2.itemSizeSM)
    },
    [`&${componentCls}-mini:not(${componentCls}-disabled)`]: {
      [`${componentCls}-prev, ${componentCls}-next`]: {
        [`&:hover ${componentCls}-item-link`]: {
          backgroundColor: token2.colorBgTextHover
        },
        [`&:active ${componentCls}-item-link`]: {
          backgroundColor: token2.colorBgTextActive
        },
        [`&${componentCls}-disabled:hover ${componentCls}-item-link`]: {
          backgroundColor: "transparent"
        }
      }
    },
    [`
    &${componentCls}-mini ${componentCls}-prev ${componentCls}-item-link,
    &${componentCls}-mini ${componentCls}-next ${componentCls}-item-link
    `]: {
      backgroundColor: "transparent",
      borderColor: "transparent",
      "&::after": {
        height: token2.itemSizeSM,
        lineHeight: unit(token2.itemSizeSM)
      }
    },
    [`&${componentCls}-mini ${componentCls}-jump-prev, &${componentCls}-mini ${componentCls}-jump-next`]: {
      height: token2.itemSizeSM,
      marginInlineEnd: 0,
      lineHeight: unit(token2.itemSizeSM)
    },
    [`&${componentCls}-mini ${componentCls}-options`]: {
      marginInlineStart: token2.paginationMiniOptionsMarginInlineStart,
      "&-size-changer": {
        top: token2.miniOptionsSizeChangerTop
      },
      "&-quick-jumper": {
        height: token2.itemSizeSM,
        lineHeight: unit(token2.itemSizeSM),
        input: Object.assign(Object.assign({}, genInputSmallStyle(token2)), {
          width: token2.paginationMiniQuickJumperInputWidth,
          height: token2.controlHeightSM
        })
      }
    }
  };
};
var genPaginationSimpleStyle = (token2) => {
  const {
    componentCls
  } = token2;
  return {
    [`&${componentCls}-simple`]: {
      [`${componentCls}-prev, ${componentCls}-next`]: {
        height: token2.itemSize,
        lineHeight: unit(token2.itemSize),
        verticalAlign: "top",
        [`${componentCls}-item-link`]: {
          height: token2.itemSize,
          backgroundColor: "transparent",
          border: 0,
          "&:hover": {
            backgroundColor: token2.colorBgTextHover
          },
          "&:active": {
            backgroundColor: token2.colorBgTextActive
          },
          "&::after": {
            height: token2.itemSize,
            lineHeight: unit(token2.itemSize)
          }
        }
      },
      [`${componentCls}-simple-pager`]: {
        display: "inline-flex",
        alignItems: "center",
        height: token2.itemSize,
        marginInlineEnd: token2.marginXS,
        input: {
          boxSizing: "border-box",
          height: "100%",
          width: token2.quickJumperInputWidth,
          padding: `0 ${unit(token2.paginationItemPaddingInline)}`,
          textAlign: "center",
          backgroundColor: token2.itemInputBg,
          border: `${unit(token2.lineWidth)} ${token2.lineType} ${token2.colorBorder}`,
          borderRadius: token2.borderRadius,
          outline: "none",
          transition: `border-color ${token2.motionDurationMid}`,
          color: "inherit",
          "&:hover": {
            borderColor: token2.colorPrimary
          },
          "&:focus": {
            borderColor: token2.colorPrimaryHover,
            boxShadow: `${unit(token2.inputOutlineOffset)} 0 ${unit(token2.controlOutlineWidth)} ${token2.controlOutline}`
          },
          "&[disabled]": {
            color: token2.colorTextDisabled,
            backgroundColor: token2.colorBgContainerDisabled,
            borderColor: token2.colorBorder,
            cursor: "not-allowed"
          }
        }
      },
      [`&${componentCls}-disabled`]: {
        [`${componentCls}-prev, ${componentCls}-next`]: {
          [`${componentCls}-item-link`]: {
            "&:hover, &:active": {
              backgroundColor: "transparent"
            }
          }
        }
      },
      [`&${componentCls}-mini`]: {
        [`${componentCls}-prev, ${componentCls}-next`]: {
          height: token2.itemSizeSM,
          lineHeight: unit(token2.itemSizeSM),
          [`${componentCls}-item-link`]: {
            height: token2.itemSizeSM,
            "&::after": {
              height: token2.itemSizeSM,
              lineHeight: unit(token2.itemSizeSM)
            }
          }
        },
        [`${componentCls}-simple-pager`]: {
          height: token2.itemSizeSM,
          width: token2.paginationMiniQuickJumperInputWidth
        }
      }
    }
  };
};
var genPaginationJumpStyle = (token2) => {
  const {
    componentCls
  } = token2;
  return {
    [`${componentCls}-jump-prev, ${componentCls}-jump-next`]: {
      outline: 0,
      [`${componentCls}-item-container`]: {
        position: "relative",
        [`${componentCls}-item-link-icon`]: {
          color: token2.colorPrimary,
          fontSize: token2.fontSizeSM,
          opacity: 0,
          transition: `all ${token2.motionDurationMid}`,
          "&-svg": {
            top: 0,
            insetInlineEnd: 0,
            bottom: 0,
            insetInlineStart: 0,
            margin: "auto"
          }
        },
        [`${componentCls}-item-ellipsis`]: {
          position: "absolute",
          top: 0,
          insetInlineEnd: 0,
          bottom: 0,
          insetInlineStart: 0,
          display: "block",
          margin: "auto",
          color: token2.colorTextDisabled,
          letterSpacing: token2.paginationEllipsisLetterSpacing,
          textAlign: "center",
          textIndent: token2.paginationEllipsisTextIndent,
          opacity: 1,
          transition: `all ${token2.motionDurationMid}`
        }
      },
      "&:hover": {
        [`${componentCls}-item-link-icon`]: {
          opacity: 1
        },
        [`${componentCls}-item-ellipsis`]: {
          opacity: 0
        }
      }
    },
    [`
    ${componentCls}-prev,
    ${componentCls}-jump-prev,
    ${componentCls}-jump-next
    `]: {
      marginInlineEnd: token2.marginXS
    },
    [`
    ${componentCls}-prev,
    ${componentCls}-next,
    ${componentCls}-jump-prev,
    ${componentCls}-jump-next
    `]: {
      display: "inline-block",
      minWidth: token2.itemSize,
      height: token2.itemSize,
      color: token2.colorText,
      fontFamily: token2.fontFamily,
      lineHeight: unit(token2.itemSize),
      textAlign: "center",
      verticalAlign: "middle",
      listStyle: "none",
      borderRadius: token2.borderRadius,
      cursor: "pointer",
      transition: `all ${token2.motionDurationMid}`
    },
    [`${componentCls}-prev, ${componentCls}-next`]: {
      outline: 0,
      button: {
        color: token2.colorText,
        cursor: "pointer",
        userSelect: "none"
      },
      [`${componentCls}-item-link`]: {
        display: "block",
        width: "100%",
        height: "100%",
        padding: 0,
        fontSize: token2.fontSizeSM,
        textAlign: "center",
        backgroundColor: "transparent",
        border: `${unit(token2.lineWidth)} ${token2.lineType} transparent`,
        borderRadius: token2.borderRadius,
        outline: "none",
        transition: `all ${token2.motionDurationMid}`
      },
      [`&:hover ${componentCls}-item-link`]: {
        backgroundColor: token2.colorBgTextHover
      },
      [`&:active ${componentCls}-item-link`]: {
        backgroundColor: token2.colorBgTextActive
      },
      [`&${componentCls}-disabled:hover`]: {
        [`${componentCls}-item-link`]: {
          backgroundColor: "transparent"
        }
      }
    },
    [`${componentCls}-slash`]: {
      marginInlineEnd: token2.paginationSlashMarginInlineEnd,
      marginInlineStart: token2.paginationSlashMarginInlineStart
    },
    [`${componentCls}-options`]: {
      display: "inline-block",
      marginInlineStart: token2.margin,
      verticalAlign: "middle",
      "&-size-changer": {
        display: "inline-block",
        width: "auto"
      },
      "&-quick-jumper": {
        display: "inline-block",
        height: token2.controlHeight,
        marginInlineStart: token2.marginXS,
        lineHeight: unit(token2.controlHeight),
        verticalAlign: "top",
        input: Object.assign(Object.assign(Object.assign({}, genBasicInputStyle(token2)), genBaseOutlinedStyle2(token2, {
          borderColor: token2.colorBorder,
          hoverBorderColor: token2.colorPrimaryHover,
          activeBorderColor: token2.colorPrimary,
          activeShadow: token2.activeShadow
        })), {
          "&[disabled]": Object.assign({}, genDisabledStyle2(token2)),
          width: token2.quickJumperInputWidth,
          height: token2.controlHeight,
          boxSizing: "border-box",
          margin: 0,
          marginInlineStart: token2.marginXS,
          marginInlineEnd: token2.marginXS
        })
      }
    }
  };
};
var genPaginationItemStyle = (token2) => {
  const {
    componentCls
  } = token2;
  return {
    [`${componentCls}-item`]: {
      display: "inline-block",
      minWidth: token2.itemSize,
      height: token2.itemSize,
      marginInlineEnd: token2.marginXS,
      fontFamily: token2.fontFamily,
      lineHeight: unit(token2.calc(token2.itemSize).sub(2).equal()),
      textAlign: "center",
      verticalAlign: "middle",
      listStyle: "none",
      backgroundColor: token2.itemBg,
      border: `${unit(token2.lineWidth)} ${token2.lineType} transparent`,
      borderRadius: token2.borderRadius,
      outline: 0,
      cursor: "pointer",
      userSelect: "none",
      a: {
        display: "block",
        padding: `0 ${unit(token2.paginationItemPaddingInline)}`,
        color: token2.colorText,
        "&:hover": {
          textDecoration: "none"
        }
      },
      [`&:not(${componentCls}-item-active)`]: {
        "&:hover": {
          transition: `all ${token2.motionDurationMid}`,
          backgroundColor: token2.colorBgTextHover
        },
        "&:active": {
          backgroundColor: token2.colorBgTextActive
        }
      },
      "&-active": {
        fontWeight: token2.fontWeightStrong,
        backgroundColor: token2.itemActiveBg,
        borderColor: token2.colorPrimary,
        a: {
          color: token2.colorPrimary
        },
        "&:hover": {
          borderColor: token2.colorPrimaryHover
        },
        "&:hover a": {
          color: token2.colorPrimaryHover
        }
      }
    }
  };
};
var genPaginationStyle = (token2) => {
  const {
    componentCls
  } = token2;
  return {
    [componentCls]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, resetComponent(token2)), {
      display: "flex",
      "&-start": {
        justifyContent: "start"
      },
      "&-center": {
        justifyContent: "center"
      },
      "&-end": {
        justifyContent: "end"
      },
      "ul, ol": {
        margin: 0,
        padding: 0,
        listStyle: "none"
      },
      "&::after": {
        display: "block",
        clear: "both",
        height: 0,
        overflow: "hidden",
        visibility: "hidden",
        content: '""'
      },
      [`${componentCls}-total-text`]: {
        display: "inline-block",
        height: token2.itemSize,
        marginInlineEnd: token2.marginXS,
        lineHeight: unit(token2.calc(token2.itemSize).sub(2).equal()),
        verticalAlign: "middle"
      }
    }), genPaginationItemStyle(token2)), genPaginationJumpStyle(token2)), genPaginationSimpleStyle(token2)), genPaginationMiniStyle(token2)), genPaginationDisabledStyle(token2)), {
      // media query style
      [`@media only screen and (max-width: ${token2.screenLG}px)`]: {
        [`${componentCls}-item`]: {
          "&-after-jump-prev, &-before-jump-next": {
            display: "none"
          }
        }
      },
      [`@media only screen and (max-width: ${token2.screenSM}px)`]: {
        [`${componentCls}-options`]: {
          display: "none"
        }
      }
    }),
    // rtl style
    [`&${token2.componentCls}-rtl`]: {
      direction: "rtl"
    }
  };
};
var genPaginationFocusStyle = (token2) => {
  const {
    componentCls
  } = token2;
  return {
    [`${componentCls}:not(${componentCls}-disabled)`]: {
      [`${componentCls}-item`]: Object.assign({}, genFocusStyle(token2)),
      [`${componentCls}-jump-prev, ${componentCls}-jump-next`]: {
        "&:focus-visible": Object.assign({
          [`${componentCls}-item-link-icon`]: {
            opacity: 1
          },
          [`${componentCls}-item-ellipsis`]: {
            opacity: 0
          }
        }, genFocusOutline(token2))
      },
      [`${componentCls}-prev, ${componentCls}-next`]: {
        [`&:focus-visible ${componentCls}-item-link`]: genFocusOutline(token2)
      }
    }
  };
};
var prepareComponentToken22 = (token2) => Object.assign({
  itemBg: token2.colorBgContainer,
  itemSize: token2.controlHeight,
  itemSizeSM: token2.controlHeightSM,
  itemActiveBg: token2.colorBgContainer,
  itemLinkBg: token2.colorBgContainer,
  itemActiveColorDisabled: token2.colorTextDisabled,
  itemActiveBgDisabled: token2.controlItemBgActiveDisabled,
  itemInputBg: token2.colorBgContainer,
  miniOptionsSizeChangerTop: 0
}, initComponentToken(token2));
var prepareToken4 = (token2) => merge2(token2, {
  inputOutlineOffset: 0,
  quickJumperInputWidth: token2.calc(token2.controlHeightLG).mul(1.25).equal(),
  paginationMiniOptionsMarginInlineStart: token2.calc(token2.marginXXS).div(2).equal(),
  paginationMiniQuickJumperInputWidth: token2.calc(token2.controlHeightLG).mul(1.1).equal(),
  paginationItemPaddingInline: token2.calc(token2.marginXXS).mul(1.5).equal(),
  paginationEllipsisLetterSpacing: token2.calc(token2.marginXXS).div(2).equal(),
  paginationSlashMarginInlineStart: token2.marginSM,
  paginationSlashMarginInlineEnd: token2.marginSM,
  paginationEllipsisTextIndent: "0.13em"
  // magic for ui experience
}, initInputToken(token2));
var style_default27 = genStyleHooks("Pagination", (token2) => {
  const paginationToken = prepareToken4(token2);
  return [genPaginationStyle(paginationToken), genPaginationFocusStyle(paginationToken)];
}, prepareComponentToken22);

// ../../node_modules/antd/es/pagination/style/bordered.js
var genBorderedStyle = (token2) => {
  const {
    componentCls
  } = token2;
  return {
    [`${componentCls}${componentCls}-bordered${componentCls}-disabled:not(${componentCls}-mini)`]: {
      "&, &:hover": {
        [`${componentCls}-item-link`]: {
          borderColor: token2.colorBorder
        }
      },
      "&:focus-visible": {
        [`${componentCls}-item-link`]: {
          borderColor: token2.colorBorder
        }
      },
      [`${componentCls}-item, ${componentCls}-item-link`]: {
        backgroundColor: token2.colorBgContainerDisabled,
        borderColor: token2.colorBorder,
        [`&:hover:not(${componentCls}-item-active)`]: {
          backgroundColor: token2.colorBgContainerDisabled,
          borderColor: token2.colorBorder,
          a: {
            color: token2.colorTextDisabled
          }
        },
        [`&${componentCls}-item-active`]: {
          backgroundColor: token2.itemActiveBgDisabled
        }
      },
      [`${componentCls}-prev, ${componentCls}-next`]: {
        "&:hover button": {
          backgroundColor: token2.colorBgContainerDisabled,
          borderColor: token2.colorBorder,
          color: token2.colorTextDisabled
        },
        [`${componentCls}-item-link`]: {
          backgroundColor: token2.colorBgContainerDisabled,
          borderColor: token2.colorBorder
        }
      }
    },
    [`${componentCls}${componentCls}-bordered:not(${componentCls}-mini)`]: {
      [`${componentCls}-prev, ${componentCls}-next`]: {
        "&:hover button": {
          borderColor: token2.colorPrimaryHover,
          backgroundColor: token2.itemBg
        },
        [`${componentCls}-item-link`]: {
          backgroundColor: token2.itemLinkBg,
          borderColor: token2.colorBorder
        },
        [`&:hover ${componentCls}-item-link`]: {
          borderColor: token2.colorPrimary,
          backgroundColor: token2.itemBg,
          color: token2.colorPrimary
        },
        [`&${componentCls}-disabled`]: {
          [`${componentCls}-item-link`]: {
            borderColor: token2.colorBorder,
            color: token2.colorTextDisabled
          }
        }
      },
      [`${componentCls}-item`]: {
        backgroundColor: token2.itemBg,
        border: `${unit(token2.lineWidth)} ${token2.lineType} ${token2.colorBorder}`,
        [`&:hover:not(${componentCls}-item-active)`]: {
          borderColor: token2.colorPrimary,
          backgroundColor: token2.itemBg,
          a: {
            color: token2.colorPrimary
          }
        },
        "&-active": {
          borderColor: token2.colorPrimary
        }
      }
    }
  };
};
var bordered_default = genSubStyleComponent(["Pagination", "bordered"], (token2) => {
  const paginationToken = prepareToken4(token2);
  return genBorderedStyle(paginationToken);
}, prepareComponentToken22);

// ../../node_modules/antd/es/pagination/useShowSizeChanger.js
var import_react131 = __toESM(require_react());
function useShowSizeChanger(showSizeChanger) {
  return (0, import_react131.useMemo)(() => {
    if (typeof showSizeChanger === "boolean") {
      return [showSizeChanger, {}];
    }
    if (showSizeChanger && typeof showSizeChanger === "object") {
      return [true, showSizeChanger];
    }
    return [void 0, void 0];
  }, [showSizeChanger]);
}

// ../../node_modules/antd/es/pagination/Pagination.js
var __rest52 = function(s, e3) {
  var t2 = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e3.indexOf(p) < 0) t2[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e3.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t2[p[i]] = s[p[i]];
  }
  return t2;
};
var Pagination3 = (props) => {
  const {
    align,
    prefixCls: customizePrefixCls,
    selectPrefixCls: customizeSelectPrefixCls,
    className: className2,
    rootClassName,
    style: style2,
    size: customizeSize,
    locale: customLocale,
    responsive,
    showSizeChanger,
    selectComponentClass,
    pageSizeOptions
  } = props, restProps = __rest52(props, ["align", "prefixCls", "selectPrefixCls", "className", "rootClassName", "style", "size", "locale", "responsive", "showSizeChanger", "selectComponentClass", "pageSizeOptions"]);
  const {
    xs
  } = useBreakpoint_default(responsive);
  const [, token2] = useToken();
  const {
    getPrefixCls,
    direction,
    showSizeChanger: contextShowSizeChangerConfig,
    className: contextClassName,
    style: contextStyle
  } = useComponentConfig("pagination");
  const prefixCls = getPrefixCls("pagination", customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = style_default27(prefixCls);
  const mergedSize = useSize_default(customizeSize);
  const isSmall = mergedSize === "small" || !!(xs && !mergedSize && responsive);
  const [contextLocale] = useLocale_default("Pagination", en_US_default);
  const locale6 = Object.assign(Object.assign({}, contextLocale), customLocale);
  const [propShowSizeChanger, propSizeChangerSelectProps] = useShowSizeChanger(showSizeChanger);
  const [contextShowSizeChanger, contextSizeChangerSelectProps] = useShowSizeChanger(contextShowSizeChangerConfig);
  const mergedShowSizeChanger = propShowSizeChanger !== null && propShowSizeChanger !== void 0 ? propShowSizeChanger : contextShowSizeChanger;
  const mergedShowSizeChangerSelectProps = propSizeChangerSelectProps !== null && propSizeChangerSelectProps !== void 0 ? propSizeChangerSelectProps : contextSizeChangerSelectProps;
  const SizeChanger = selectComponentClass || select_default;
  const mergedPageSizeOptions = React392.useMemo(() => {
    return pageSizeOptions ? pageSizeOptions.map((option) => Number(option)) : void 0;
  }, [pageSizeOptions]);
  const sizeChangerRender = (info) => {
    var _a;
    const {
      disabled,
      size: pageSize,
      onSizeChange,
      "aria-label": ariaLabel,
      className: sizeChangerClassName,
      options
    } = info;
    const {
      className: propSizeChangerClassName,
      onChange: propSizeChangerOnChange
    } = mergedShowSizeChangerSelectProps || {};
    const selectedValue = (_a = options.find((option) => String(option.value) === String(pageSize))) === null || _a === void 0 ? void 0 : _a.value;
    return /* @__PURE__ */ React392.createElement(SizeChanger, Object.assign({
      disabled,
      showSearch: true,
      popupMatchSelectWidth: false,
      getPopupContainer: (triggerNode) => triggerNode.parentNode,
      "aria-label": ariaLabel,
      options
    }, mergedShowSizeChangerSelectProps, {
      value: selectedValue,
      onChange: (nextSize, option) => {
        onSizeChange === null || onSizeChange === void 0 ? void 0 : onSizeChange(nextSize);
        propSizeChangerOnChange === null || propSizeChangerOnChange === void 0 ? void 0 : propSizeChangerOnChange(nextSize, option);
      },
      size: isSmall ? "small" : "middle",
      className: (0, import_classnames154.default)(sizeChangerClassName, propSizeChangerClassName)
    }));
  };
  if (true) {
    const warning6 = devUseWarning("Pagination");
    true ? warning6(!selectComponentClass, "usage", "`selectComponentClass` is not official api which will be removed.") : void 0;
  }
  const iconsProps = React392.useMemo(() => {
    const ellipsis = /* @__PURE__ */ React392.createElement("span", {
      className: `${prefixCls}-item-ellipsis`
    }, "\u2022\u2022\u2022");
    const prevIcon = /* @__PURE__ */ React392.createElement("button", {
      className: `${prefixCls}-item-link`,
      type: "button",
      tabIndex: -1
    }, direction === "rtl" ? /* @__PURE__ */ React392.createElement(RightOutlined_default2, null) : /* @__PURE__ */ React392.createElement(LeftOutlined_default2, null));
    const nextIcon = /* @__PURE__ */ React392.createElement("button", {
      className: `${prefixCls}-item-link`,
      type: "button",
      tabIndex: -1
    }, direction === "rtl" ? /* @__PURE__ */ React392.createElement(LeftOutlined_default2, null) : /* @__PURE__ */ React392.createElement(RightOutlined_default2, null));
    const jumpPrevIcon = (
      // biome-ignore lint/a11y/useValidAnchor: it is hard to refactor
      /* @__PURE__ */ React392.createElement("a", {
        className: `${prefixCls}-item-link`
      }, /* @__PURE__ */ React392.createElement("div", {
        className: `${prefixCls}-item-container`
      }, direction === "rtl" ? /* @__PURE__ */ React392.createElement(DoubleRightOutlined_default2, {
        className: `${prefixCls}-item-link-icon`
      }) : /* @__PURE__ */ React392.createElement(DoubleLeftOutlined_default2, {
        className: `${prefixCls}-item-link-icon`
      }), ellipsis))
    );
    const jumpNextIcon = (
      // biome-ignore lint/a11y/useValidAnchor: it is hard to refactor
      /* @__PURE__ */ React392.createElement("a", {
        className: `${prefixCls}-item-link`
      }, /* @__PURE__ */ React392.createElement("div", {
        className: `${prefixCls}-item-container`
      }, direction === "rtl" ? /* @__PURE__ */ React392.createElement(DoubleLeftOutlined_default2, {
        className: `${prefixCls}-item-link-icon`
      }) : /* @__PURE__ */ React392.createElement(DoubleRightOutlined_default2, {
        className: `${prefixCls}-item-link-icon`
      }), ellipsis))
    );
    return {
      prevIcon,
      nextIcon,
      jumpPrevIcon,
      jumpNextIcon
    };
  }, [direction, prefixCls]);
  const selectPrefixCls = getPrefixCls("select", customizeSelectPrefixCls);
  const extendedClassName = (0, import_classnames154.default)({
    [`${prefixCls}-${align}`]: !!align,
    [`${prefixCls}-mini`]: isSmall,
    [`${prefixCls}-rtl`]: direction === "rtl",
    [`${prefixCls}-bordered`]: token2.wireframe
  }, contextClassName, className2, rootClassName, hashId, cssVarCls);
  const mergedStyle = Object.assign(Object.assign({}, contextStyle), style2);
  return wrapCSSVar(/* @__PURE__ */ React392.createElement(React392.Fragment, null, token2.wireframe && /* @__PURE__ */ React392.createElement(bordered_default, {
    prefixCls
  }), /* @__PURE__ */ React392.createElement(Pagination_default, Object.assign({}, iconsProps, restProps, {
    style: mergedStyle,
    prefixCls,
    selectPrefixCls,
    className: extendedClassName,
    locale: locale6,
    pageSizeOptions: mergedPageSizeOptions,
    showSizeChanger: mergedShowSizeChanger,
    sizeChangerRender
  }))));
};
if (true) {
  Pagination3.displayName = "Pagination";
}
var Pagination_default2 = Pagination3;

// ../../node_modules/antd/es/pagination/index.js
var pagination_default = Pagination_default2;

// ../../node_modules/antd/es/spin/index.js
var React397 = __toESM(require_react());
var import_classnames158 = __toESM(require_classnames());

// ../../node_modules/antd/es/spin/Indicator/index.js
var React395 = __toESM(require_react());
var import_classnames157 = __toESM(require_classnames());

// ../../node_modules/antd/es/spin/Indicator/Looper.js
var React394 = __toESM(require_react());
var import_classnames156 = __toESM(require_classnames());

// ../../node_modules/antd/es/spin/Indicator/Progress.js
var React393 = __toESM(require_react());
var import_classnames155 = __toESM(require_classnames());
var viewSize = 100;
var borderWidth = viewSize / 5;
var radius = viewSize / 2 - borderWidth / 2;
var circumference = radius * 2 * Math.PI;
var position2 = 50;
var CustomCircle = (props) => {
  const {
    dotClassName,
    style: style2,
    hasCircleCls
  } = props;
  return /* @__PURE__ */ React393.createElement("circle", {
    className: (0, import_classnames155.default)(`${dotClassName}-circle`, {
      [`${dotClassName}-circle-bg`]: hasCircleCls
    }),
    r: radius,
    cx: position2,
    cy: position2,
    strokeWidth: borderWidth,
    style: style2
  });
};
var Progress = ({
  percent,
  prefixCls
}) => {
  const dotClassName = `${prefixCls}-dot`;
  const holderClassName = `${dotClassName}-holder`;
  const hideClassName = `${holderClassName}-hidden`;
  const [render4, setRender] = React393.useState(false);
  useLayoutEffect_default(() => {
    if (percent !== 0) {
      setRender(true);
    }
  }, [percent !== 0]);
  const safePtg = Math.max(Math.min(percent, 100), 0);
  if (!render4) {
    return null;
  }
  const circleStyle = {
    strokeDashoffset: `${circumference / 4}`,
    strokeDasharray: `${circumference * safePtg / 100} ${circumference * (100 - safePtg) / 100}`
  };
  return /* @__PURE__ */ React393.createElement("span", {
    className: (0, import_classnames155.default)(holderClassName, `${dotClassName}-progress`, safePtg <= 0 && hideClassName)
  }, /* @__PURE__ */ React393.createElement("svg", {
    viewBox: `0 0 ${viewSize} ${viewSize}`,
    role: "progressbar",
    "aria-valuemin": 0,
    "aria-valuemax": 100,
    "aria-valuenow": safePtg
  }, /* @__PURE__ */ React393.createElement(CustomCircle, {
    dotClassName,
    hasCircleCls: true
  }), /* @__PURE__ */ React393.createElement(CustomCircle, {
    dotClassName,
    style: circleStyle
  })));
};
var Progress_default = Progress;

// ../../node_modules/antd/es/spin/Indicator/Looper.js
function Looper(props) {
  const {
    prefixCls,
    percent = 0
  } = props;
  const dotClassName = `${prefixCls}-dot`;
  const holderClassName = `${dotClassName}-holder`;
  const hideClassName = `${holderClassName}-hidden`;
  return /* @__PURE__ */ React394.createElement(React394.Fragment, null, /* @__PURE__ */ React394.createElement("span", {
    className: (0, import_classnames156.default)(holderClassName, percent > 0 && hideClassName)
  }, /* @__PURE__ */ React394.createElement("span", {
    className: (0, import_classnames156.default)(dotClassName, `${prefixCls}-dot-spin`)
  }, [1, 2, 3, 4].map((i) => /* @__PURE__ */ React394.createElement("i", {
    className: `${prefixCls}-dot-item`,
    key: i
  })))), /* @__PURE__ */ React394.createElement(Progress_default, {
    prefixCls,
    percent
  }));
}

// ../../node_modules/antd/es/spin/Indicator/index.js
function Indicator(props) {
  var _a;
  const {
    prefixCls,
    indicator,
    percent
  } = props;
  const dotClassName = `${prefixCls}-dot`;
  if (indicator && /* @__PURE__ */ React395.isValidElement(indicator)) {
    return cloneElement4(indicator, {
      className: (0, import_classnames157.default)((_a = indicator.props) === null || _a === void 0 ? void 0 : _a.className, dotClassName),
      percent
    });
  }
  return /* @__PURE__ */ React395.createElement(Looper, {
    prefixCls,
    percent
  });
}

// ../../node_modules/antd/es/spin/style/index.js
var antSpinMove = new Keyframes_default("antSpinMove", {
  to: {
    opacity: 1
  }
});
var antRotate = new Keyframes_default("antRotate", {
  to: {
    transform: "rotate(405deg)"
  }
});
var genSpinStyle = (token2) => {
  const {
    componentCls,
    calc
  } = token2;
  return {
    [componentCls]: Object.assign(Object.assign({}, resetComponent(token2)), {
      position: "absolute",
      display: "none",
      color: token2.colorPrimary,
      fontSize: 0,
      textAlign: "center",
      verticalAlign: "middle",
      opacity: 0,
      transition: `transform ${token2.motionDurationSlow} ${token2.motionEaseInOutCirc}`,
      "&-spinning": {
        position: "relative",
        display: "inline-block",
        opacity: 1
      },
      [`${componentCls}-text`]: {
        fontSize: token2.fontSize,
        paddingTop: calc(calc(token2.dotSize).sub(token2.fontSize)).div(2).add(2).equal()
      },
      "&-fullscreen": {
        position: "fixed",
        width: "100vw",
        height: "100vh",
        backgroundColor: token2.colorBgMask,
        zIndex: token2.zIndexPopupBase,
        inset: 0,
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "center",
        opacity: 0,
        visibility: "hidden",
        transition: `all ${token2.motionDurationMid}`,
        "&-show": {
          opacity: 1,
          visibility: "visible"
        },
        [componentCls]: {
          [`${componentCls}-dot-holder`]: {
            color: token2.colorWhite
          },
          [`${componentCls}-text`]: {
            color: token2.colorTextLightSolid
          }
        }
      },
      "&-nested-loading": {
        position: "relative",
        [`> div > ${componentCls}`]: {
          position: "absolute",
          top: 0,
          insetInlineStart: 0,
          zIndex: 4,
          display: "block",
          width: "100%",
          height: "100%",
          maxHeight: token2.contentHeight,
          [`${componentCls}-dot`]: {
            position: "absolute",
            top: "50%",
            insetInlineStart: "50%",
            margin: calc(token2.dotSize).mul(-1).div(2).equal()
          },
          [`${componentCls}-text`]: {
            position: "absolute",
            top: "50%",
            width: "100%",
            textShadow: `0 1px 2px ${token2.colorBgContainer}`
            // FIXME: shadow
          },
          [`&${componentCls}-show-text ${componentCls}-dot`]: {
            marginTop: calc(token2.dotSize).div(2).mul(-1).sub(10).equal()
          },
          "&-sm": {
            [`${componentCls}-dot`]: {
              margin: calc(token2.dotSizeSM).mul(-1).div(2).equal()
            },
            [`${componentCls}-text`]: {
              paddingTop: calc(calc(token2.dotSizeSM).sub(token2.fontSize)).div(2).add(2).equal()
            },
            [`&${componentCls}-show-text ${componentCls}-dot`]: {
              marginTop: calc(token2.dotSizeSM).div(2).mul(-1).sub(10).equal()
            }
          },
          "&-lg": {
            [`${componentCls}-dot`]: {
              margin: calc(token2.dotSizeLG).mul(-1).div(2).equal()
            },
            [`${componentCls}-text`]: {
              paddingTop: calc(calc(token2.dotSizeLG).sub(token2.fontSize)).div(2).add(2).equal()
            },
            [`&${componentCls}-show-text ${componentCls}-dot`]: {
              marginTop: calc(token2.dotSizeLG).div(2).mul(-1).sub(10).equal()
            }
          }
        },
        [`${componentCls}-container`]: {
          position: "relative",
          transition: `opacity ${token2.motionDurationSlow}`,
          "&::after": {
            position: "absolute",
            top: 0,
            insetInlineEnd: 0,
            bottom: 0,
            insetInlineStart: 0,
            zIndex: 10,
            width: "100%",
            height: "100%",
            background: token2.colorBgContainer,
            opacity: 0,
            transition: `all ${token2.motionDurationSlow}`,
            content: '""',
            pointerEvents: "none"
          }
        },
        [`${componentCls}-blur`]: {
          clear: "both",
          opacity: 0.5,
          userSelect: "none",
          pointerEvents: "none",
          "&::after": {
            opacity: 0.4,
            pointerEvents: "auto"
          }
        }
      },
      // tip
      // ------------------------------
      "&-tip": {
        color: token2.spinDotDefault
      },
      // holder
      // ------------------------------
      [`${componentCls}-dot-holder`]: {
        width: "1em",
        height: "1em",
        fontSize: token2.dotSize,
        display: "inline-block",
        transition: `transform ${token2.motionDurationSlow} ease, opacity ${token2.motionDurationSlow} ease`,
        transformOrigin: "50% 50%",
        lineHeight: 1,
        color: token2.colorPrimary,
        "&-hidden": {
          transform: "scale(0.3)",
          opacity: 0
        }
      },
      // progress
      // ------------------------------
      [`${componentCls}-dot-progress`]: {
        position: "absolute",
        inset: 0
      },
      // dots
      // ------------------------------
      [`${componentCls}-dot`]: {
        position: "relative",
        display: "inline-block",
        fontSize: token2.dotSize,
        width: "1em",
        height: "1em",
        "&-item": {
          position: "absolute",
          display: "block",
          width: calc(token2.dotSize).sub(calc(token2.marginXXS).div(2)).div(2).equal(),
          height: calc(token2.dotSize).sub(calc(token2.marginXXS).div(2)).div(2).equal(),
          background: "currentColor",
          borderRadius: "100%",
          transform: "scale(0.75)",
          transformOrigin: "50% 50%",
          opacity: 0.3,
          animationName: antSpinMove,
          animationDuration: "1s",
          animationIterationCount: "infinite",
          animationTimingFunction: "linear",
          animationDirection: "alternate",
          "&:nth-child(1)": {
            top: 0,
            insetInlineStart: 0,
            animationDelay: "0s"
          },
          "&:nth-child(2)": {
            top: 0,
            insetInlineEnd: 0,
            animationDelay: "0.4s"
          },
          "&:nth-child(3)": {
            insetInlineEnd: 0,
            bottom: 0,
            animationDelay: "0.8s"
          },
          "&:nth-child(4)": {
            bottom: 0,
            insetInlineStart: 0,
            animationDelay: "1.2s"
          }
        },
        "&-spin": {
          transform: "rotate(45deg)",
          animationName: antRotate,
          animationDuration: "1.2s",
          animationIterationCount: "infinite",
          animationTimingFunction: "linear"
        },
        "&-circle": {
          strokeLinecap: "round",
          transition: ["stroke-dashoffset", "stroke-dasharray", "stroke", "stroke-width", "opacity"].map((item) => `${item} ${token2.motionDurationSlow} ease`).join(","),
          fillOpacity: 0,
          stroke: "currentcolor"
        },
        "&-circle-bg": {
          stroke: token2.colorFillSecondary
        }
      },
      // small
      [`&-sm ${componentCls}-dot`]: {
        "&, &-holder": {
          fontSize: token2.dotSizeSM
        }
      },
      [`&-sm ${componentCls}-dot-holder`]: {
        i: {
          width: calc(calc(token2.dotSizeSM).sub(calc(token2.marginXXS).div(2))).div(2).equal(),
          height: calc(calc(token2.dotSizeSM).sub(calc(token2.marginXXS).div(2))).div(2).equal()
        }
      },
      // large
      [`&-lg ${componentCls}-dot`]: {
        "&, &-holder": {
          fontSize: token2.dotSizeLG
        }
      },
      [`&-lg ${componentCls}-dot-holder`]: {
        i: {
          width: calc(calc(token2.dotSizeLG).sub(token2.marginXXS)).div(2).equal(),
          height: calc(calc(token2.dotSizeLG).sub(token2.marginXXS)).div(2).equal()
        }
      },
      [`&${componentCls}-show-text ${componentCls}-text`]: {
        display: "block"
      }
    })
  };
};
var prepareComponentToken23 = (token2) => {
  const {
    controlHeightLG,
    controlHeight
  } = token2;
  return {
    contentHeight: 400,
    dotSize: controlHeightLG / 2,
    dotSizeSM: controlHeightLG * 0.35,
    dotSizeLG: controlHeight
  };
};
var style_default28 = genStyleHooks("Spin", (token2) => {
  const spinToken = merge2(token2, {
    spinDotDefault: token2.colorTextDescription
  });
  return genSpinStyle(spinToken);
}, prepareComponentToken23);

// ../../node_modules/antd/es/spin/usePercent.js
var React396 = __toESM(require_react());
var AUTO_INTERVAL = 200;
var STEP_BUCKETS = [[30, 0.05], [70, 0.03], [96, 0.01]];
function usePercent(spinning, percent) {
  const [mockPercent, setMockPercent] = React396.useState(0);
  const mockIntervalRef = React396.useRef(null);
  const isAuto = percent === "auto";
  React396.useEffect(() => {
    if (isAuto && spinning) {
      setMockPercent(0);
      mockIntervalRef.current = setInterval(() => {
        setMockPercent((prev2) => {
          const restPTG = 100 - prev2;
          for (let i = 0; i < STEP_BUCKETS.length; i += 1) {
            const [limit, stepPtg] = STEP_BUCKETS[i];
            if (prev2 <= limit) {
              return prev2 + restPTG * stepPtg;
            }
          }
          return prev2;
        });
      }, AUTO_INTERVAL);
    }
    return () => {
      clearInterval(mockIntervalRef.current);
    };
  }, [isAuto, spinning]);
  return isAuto ? mockPercent : percent;
}

// ../../node_modules/antd/es/spin/index.js
var __rest53 = function(s, e3) {
  var t2 = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e3.indexOf(p) < 0) t2[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e3.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t2[p[i]] = s[p[i]];
  }
  return t2;
};
var defaultIndicator;
function shouldDelay(spinning, delay) {
  return !!spinning && !!delay && !Number.isNaN(Number(delay));
}
var Spin = (props) => {
  var _a;
  const {
    prefixCls: customizePrefixCls,
    spinning: customSpinning = true,
    delay = 0,
    className: className2,
    rootClassName,
    size = "default",
    tip,
    wrapperClassName,
    style: style2,
    children,
    fullscreen = false,
    indicator,
    percent
  } = props, restProps = __rest53(props, ["prefixCls", "spinning", "delay", "className", "rootClassName", "size", "tip", "wrapperClassName", "style", "children", "fullscreen", "indicator", "percent"]);
  const {
    getPrefixCls,
    direction,
    className: contextClassName,
    style: contextStyle,
    indicator: contextIndicator
  } = useComponentConfig("spin");
  const prefixCls = getPrefixCls("spin", customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = style_default28(prefixCls);
  const [spinning, setSpinning] = React397.useState(() => customSpinning && !shouldDelay(customSpinning, delay));
  const mergedPercent = usePercent(spinning, percent);
  React397.useEffect(() => {
    if (customSpinning) {
      const showSpinning = debounce2(delay, () => {
        setSpinning(true);
      });
      showSpinning();
      return () => {
        var _a2;
        (_a2 = showSpinning === null || showSpinning === void 0 ? void 0 : showSpinning.cancel) === null || _a2 === void 0 ? void 0 : _a2.call(showSpinning);
      };
    }
    setSpinning(false);
  }, [delay, customSpinning]);
  const isNestedPattern = React397.useMemo(() => typeof children !== "undefined" && !fullscreen, [children, fullscreen]);
  if (true) {
    const warning6 = devUseWarning("Spin");
    true ? warning6(!tip || isNestedPattern || fullscreen, "usage", "`tip` only work in nest or fullscreen pattern.") : void 0;
  }
  const spinClassName = (0, import_classnames158.default)(prefixCls, contextClassName, {
    [`${prefixCls}-sm`]: size === "small",
    [`${prefixCls}-lg`]: size === "large",
    [`${prefixCls}-spinning`]: spinning,
    [`${prefixCls}-show-text`]: !!tip,
    [`${prefixCls}-rtl`]: direction === "rtl"
  }, className2, !fullscreen && rootClassName, hashId, cssVarCls);
  const containerClassName = (0, import_classnames158.default)(`${prefixCls}-container`, {
    [`${prefixCls}-blur`]: spinning
  });
  const mergedIndicator = (_a = indicator !== null && indicator !== void 0 ? indicator : contextIndicator) !== null && _a !== void 0 ? _a : defaultIndicator;
  const mergedStyle = Object.assign(Object.assign({}, contextStyle), style2);
  const spinElement = /* @__PURE__ */ React397.createElement("div", Object.assign({}, restProps, {
    style: mergedStyle,
    className: spinClassName,
    "aria-live": "polite",
    "aria-busy": spinning
  }), /* @__PURE__ */ React397.createElement(Indicator, {
    prefixCls,
    indicator: mergedIndicator,
    percent: mergedPercent
  }), tip && (isNestedPattern || fullscreen) ? /* @__PURE__ */ React397.createElement("div", {
    className: `${prefixCls}-text`
  }, tip) : null);
  if (isNestedPattern) {
    return wrapCSSVar(/* @__PURE__ */ React397.createElement("div", Object.assign({}, restProps, {
      className: (0, import_classnames158.default)(`${prefixCls}-nested-loading`, wrapperClassName, hashId, cssVarCls)
    }), spinning && /* @__PURE__ */ React397.createElement("div", {
      key: "loading"
    }, spinElement), /* @__PURE__ */ React397.createElement("div", {
      className: containerClassName,
      key: "container"
    }, children)));
  }
  if (fullscreen) {
    return wrapCSSVar(/* @__PURE__ */ React397.createElement("div", {
      className: (0, import_classnames158.default)(`${prefixCls}-fullscreen`, {
        [`${prefixCls}-fullscreen-show`]: spinning
      }, rootClassName, hashId, cssVarCls)
    }, spinElement));
  }
  return wrapCSSVar(spinElement);
};
Spin.setDefaultIndicator = (indicator) => {
  defaultIndicator = indicator;
};
if (true) {
  Spin.displayName = "Spin";
}
var spin_default = Spin;

// ../../node_modules/antd/es/list/context.js
var import_react132 = __toESM(require_react());
var ListContext2 = /* @__PURE__ */ import_react132.default.createContext({});
var ListConsumer = ListContext2.Consumer;

// ../../node_modules/antd/es/list/Item.js
var import_react133 = __toESM(require_react());
var import_classnames159 = __toESM(require_classnames());
var __rest54 = function(s, e3) {
  var t2 = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e3.indexOf(p) < 0) t2[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e3.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t2[p[i]] = s[p[i]];
  }
  return t2;
};
var Meta2 = (_a) => {
  var {
    prefixCls: customizePrefixCls,
    className: className2,
    avatar,
    title,
    description
  } = _a, others = __rest54(_a, ["prefixCls", "className", "avatar", "title", "description"]);
  const {
    getPrefixCls
  } = (0, import_react133.useContext)(ConfigContext);
  const prefixCls = getPrefixCls("list", customizePrefixCls);
  const classString = (0, import_classnames159.default)(`${prefixCls}-item-meta`, className2);
  const content = /* @__PURE__ */ import_react133.default.createElement("div", {
    className: `${prefixCls}-item-meta-content`
  }, title && /* @__PURE__ */ import_react133.default.createElement("h4", {
    className: `${prefixCls}-item-meta-title`
  }, title), description && /* @__PURE__ */ import_react133.default.createElement("div", {
    className: `${prefixCls}-item-meta-description`
  }, description));
  return /* @__PURE__ */ import_react133.default.createElement("div", Object.assign({}, others, {
    className: classString
  }), avatar && /* @__PURE__ */ import_react133.default.createElement("div", {
    className: `${prefixCls}-item-meta-avatar`
  }, avatar), (title || description) && content);
};
var InternalItem2 = /* @__PURE__ */ import_react133.default.forwardRef((props, ref3) => {
  const {
    prefixCls: customizePrefixCls,
    children,
    actions,
    extra,
    styles,
    className: className2,
    classNames: customizeClassNames,
    colStyle
  } = props, others = __rest54(props, ["prefixCls", "children", "actions", "extra", "styles", "className", "classNames", "colStyle"]);
  const {
    grid,
    itemLayout
  } = (0, import_react133.useContext)(ListContext2);
  const {
    getPrefixCls,
    list
  } = (0, import_react133.useContext)(ConfigContext);
  const moduleClass = (moduleName) => {
    var _a, _b;
    return (0, import_classnames159.default)((_b = (_a = list === null || list === void 0 ? void 0 : list.item) === null || _a === void 0 ? void 0 : _a.classNames) === null || _b === void 0 ? void 0 : _b[moduleName], customizeClassNames === null || customizeClassNames === void 0 ? void 0 : customizeClassNames[moduleName]);
  };
  const moduleStyle = (moduleName) => {
    var _a, _b;
    return Object.assign(Object.assign({}, (_b = (_a = list === null || list === void 0 ? void 0 : list.item) === null || _a === void 0 ? void 0 : _a.styles) === null || _b === void 0 ? void 0 : _b[moduleName]), styles === null || styles === void 0 ? void 0 : styles[moduleName]);
  };
  const isItemContainsTextNodeAndNotSingular = () => {
    let result = false;
    import_react133.Children.forEach(children, (element) => {
      if (typeof element === "string") {
        result = true;
      }
    });
    return result && import_react133.Children.count(children) > 1;
  };
  const isFlexMode = () => {
    if (itemLayout === "vertical") {
      return !!extra;
    }
    return !isItemContainsTextNodeAndNotSingular();
  };
  const prefixCls = getPrefixCls("list", customizePrefixCls);
  const actionsContent = actions && actions.length > 0 && /* @__PURE__ */ import_react133.default.createElement("ul", {
    className: (0, import_classnames159.default)(`${prefixCls}-item-action`, moduleClass("actions")),
    key: "actions",
    style: moduleStyle("actions")
  }, actions.map((action, i) => (
    // eslint-disable-next-line react/no-array-index-key
    /* @__PURE__ */ import_react133.default.createElement("li", {
      key: `${prefixCls}-item-action-${i}`
    }, action, i !== actions.length - 1 && /* @__PURE__ */ import_react133.default.createElement("em", {
      className: `${prefixCls}-item-action-split`
    }))
  )));
  const Element3 = grid ? "div" : "li";
  const itemChildren = /* @__PURE__ */ import_react133.default.createElement(Element3, Object.assign({}, others, !grid ? {
    ref: ref3
  } : {}, {
    className: (0, import_classnames159.default)(`${prefixCls}-item`, {
      [`${prefixCls}-item-no-flex`]: !isFlexMode()
    }, className2)
  }), itemLayout === "vertical" && extra ? [/* @__PURE__ */ import_react133.default.createElement("div", {
    className: `${prefixCls}-item-main`,
    key: "content"
  }, children, actionsContent), /* @__PURE__ */ import_react133.default.createElement("div", {
    className: (0, import_classnames159.default)(`${prefixCls}-item-extra`, moduleClass("extra")),
    key: "extra",
    style: moduleStyle("extra")
  }, extra)] : [children, actionsContent, cloneElement4(extra, {
    key: "extra"
  })]);
  return grid ? /* @__PURE__ */ import_react133.default.createElement(col_default, {
    ref: ref3,
    flex: 1,
    style: colStyle
  }, itemChildren) : itemChildren;
});
var Item4 = InternalItem2;
Item4.Meta = Meta2;
var Item_default3 = Item4;

// ../../node_modules/antd/es/list/style/index.js
var genBorderedStyle2 = (token2) => {
  const {
    listBorderedCls,
    componentCls,
    paddingLG,
    margin,
    itemPaddingSM,
    itemPaddingLG,
    marginLG,
    borderRadiusLG
  } = token2;
  return {
    [listBorderedCls]: {
      border: `${unit(token2.lineWidth)} ${token2.lineType} ${token2.colorBorder}`,
      borderRadius: borderRadiusLG,
      [`${componentCls}-header,${componentCls}-footer,${componentCls}-item`]: {
        paddingInline: paddingLG
      },
      [`${componentCls}-pagination`]: {
        margin: `${unit(margin)} ${unit(marginLG)}`
      }
    },
    [`${listBorderedCls}${componentCls}-sm`]: {
      [`${componentCls}-item,${componentCls}-header,${componentCls}-footer`]: {
        padding: itemPaddingSM
      }
    },
    [`${listBorderedCls}${componentCls}-lg`]: {
      [`${componentCls}-item,${componentCls}-header,${componentCls}-footer`]: {
        padding: itemPaddingLG
      }
    }
  };
};
var genResponsiveStyle = (token2) => {
  const {
    componentCls,
    screenSM,
    screenMD,
    marginLG,
    marginSM,
    margin
  } = token2;
  return {
    [`@media screen and (max-width:${screenMD}px)`]: {
      [componentCls]: {
        [`${componentCls}-item`]: {
          [`${componentCls}-item-action`]: {
            marginInlineStart: marginLG
          }
        }
      },
      [`${componentCls}-vertical`]: {
        [`${componentCls}-item`]: {
          [`${componentCls}-item-extra`]: {
            marginInlineStart: marginLG
          }
        }
      }
    },
    [`@media screen and (max-width: ${screenSM}px)`]: {
      [componentCls]: {
        [`${componentCls}-item`]: {
          flexWrap: "wrap",
          [`${componentCls}-action`]: {
            marginInlineStart: marginSM
          }
        }
      },
      [`${componentCls}-vertical`]: {
        [`${componentCls}-item`]: {
          flexWrap: "wrap-reverse",
          [`${componentCls}-item-main`]: {
            minWidth: token2.contentWidth
          },
          [`${componentCls}-item-extra`]: {
            margin: `auto auto ${unit(margin)}`
          }
        }
      }
    }
  };
};
var genBaseStyle7 = (token2) => {
  const {
    componentCls,
    antCls,
    controlHeight,
    minHeight,
    paddingSM,
    marginLG,
    padding,
    itemPadding,
    colorPrimary,
    itemPaddingSM,
    itemPaddingLG,
    paddingXS,
    margin,
    colorText,
    colorTextDescription,
    motionDurationSlow,
    lineWidth,
    headerBg,
    footerBg,
    emptyTextPadding,
    metaMarginBottom,
    avatarMarginRight,
    titleMarginBottom,
    descriptionFontSize
  } = token2;
  return {
    [componentCls]: Object.assign(Object.assign({}, resetComponent(token2)), {
      position: "relative",
      // fix https://github.com/ant-design/ant-design/issues/46177
      ["--rc-virtual-list-scrollbar-bg"]: token2.colorSplit,
      "*": {
        outline: "none"
      },
      [`${componentCls}-header`]: {
        background: headerBg
      },
      [`${componentCls}-footer`]: {
        background: footerBg
      },
      [`${componentCls}-header, ${componentCls}-footer`]: {
        paddingBlock: paddingSM
      },
      [`${componentCls}-pagination`]: {
        marginBlockStart: marginLG,
        // https://github.com/ant-design/ant-design/issues/20037
        [`${antCls}-pagination-options`]: {
          textAlign: "start"
        }
      },
      [`${componentCls}-spin`]: {
        minHeight,
        textAlign: "center"
      },
      [`${componentCls}-items`]: {
        margin: 0,
        padding: 0,
        listStyle: "none"
      },
      [`${componentCls}-item`]: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: itemPadding,
        color: colorText,
        [`${componentCls}-item-meta`]: {
          display: "flex",
          flex: 1,
          alignItems: "flex-start",
          maxWidth: "100%",
          [`${componentCls}-item-meta-avatar`]: {
            marginInlineEnd: avatarMarginRight
          },
          [`${componentCls}-item-meta-content`]: {
            flex: "1 0",
            width: 0,
            color: colorText
          },
          [`${componentCls}-item-meta-title`]: {
            margin: `0 0 ${unit(token2.marginXXS)} 0`,
            color: colorText,
            fontSize: token2.fontSize,
            lineHeight: token2.lineHeight,
            "> a": {
              color: colorText,
              transition: `all ${motionDurationSlow}`,
              "&:hover": {
                color: colorPrimary
              }
            }
          },
          [`${componentCls}-item-meta-description`]: {
            color: colorTextDescription,
            fontSize: descriptionFontSize,
            lineHeight: token2.lineHeight
          }
        },
        [`${componentCls}-item-action`]: {
          flex: "0 0 auto",
          marginInlineStart: token2.marginXXL,
          padding: 0,
          fontSize: 0,
          listStyle: "none",
          "& > li": {
            position: "relative",
            display: "inline-block",
            padding: `0 ${unit(paddingXS)}`,
            color: colorTextDescription,
            fontSize: token2.fontSize,
            lineHeight: token2.lineHeight,
            textAlign: "center",
            "&:first-child": {
              paddingInlineStart: 0
            }
          },
          [`${componentCls}-item-action-split`]: {
            position: "absolute",
            insetBlockStart: "50%",
            insetInlineEnd: 0,
            width: lineWidth,
            height: token2.calc(token2.fontHeight).sub(token2.calc(token2.marginXXS).mul(2)).equal(),
            transform: "translateY(-50%)",
            backgroundColor: token2.colorSplit
          }
        }
      },
      [`${componentCls}-empty`]: {
        padding: `${unit(padding)} 0`,
        color: colorTextDescription,
        fontSize: token2.fontSizeSM,
        textAlign: "center"
      },
      [`${componentCls}-empty-text`]: {
        padding: emptyTextPadding,
        color: token2.colorTextDisabled,
        fontSize: token2.fontSize,
        textAlign: "center"
      },
      // ============================ without flex ============================
      [`${componentCls}-item-no-flex`]: {
        display: "block"
      }
    }),
    [`${componentCls}-grid ${antCls}-col > ${componentCls}-item`]: {
      display: "block",
      maxWidth: "100%",
      marginBlockEnd: margin,
      paddingBlock: 0,
      borderBlockEnd: "none"
    },
    [`${componentCls}-vertical ${componentCls}-item`]: {
      alignItems: "initial",
      [`${componentCls}-item-main`]: {
        display: "block",
        flex: 1
      },
      [`${componentCls}-item-extra`]: {
        marginInlineStart: marginLG
      },
      [`${componentCls}-item-meta`]: {
        marginBlockEnd: metaMarginBottom,
        [`${componentCls}-item-meta-title`]: {
          marginBlockStart: 0,
          marginBlockEnd: titleMarginBottom,
          color: colorText,
          fontSize: token2.fontSizeLG,
          lineHeight: token2.lineHeightLG
        }
      },
      [`${componentCls}-item-action`]: {
        marginBlockStart: padding,
        marginInlineStart: "auto",
        "> li": {
          padding: `0 ${unit(padding)}`,
          "&:first-child": {
            paddingInlineStart: 0
          }
        }
      }
    },
    [`${componentCls}-split ${componentCls}-item`]: {
      borderBlockEnd: `${unit(token2.lineWidth)} ${token2.lineType} ${token2.colorSplit}`,
      "&:last-child": {
        borderBlockEnd: "none"
      }
    },
    [`${componentCls}-split ${componentCls}-header`]: {
      borderBlockEnd: `${unit(token2.lineWidth)} ${token2.lineType} ${token2.colorSplit}`
    },
    [`${componentCls}-split${componentCls}-empty ${componentCls}-footer`]: {
      borderTop: `${unit(token2.lineWidth)} ${token2.lineType} ${token2.colorSplit}`
    },
    [`${componentCls}-loading ${componentCls}-spin-nested-loading`]: {
      minHeight: controlHeight
    },
    [`${componentCls}-split${componentCls}-something-after-last-item ${antCls}-spin-container > ${componentCls}-items > ${componentCls}-item:last-child`]: {
      borderBlockEnd: `${unit(token2.lineWidth)} ${token2.lineType} ${token2.colorSplit}`
    },
    [`${componentCls}-lg ${componentCls}-item`]: {
      padding: itemPaddingLG
    },
    [`${componentCls}-sm ${componentCls}-item`]: {
      padding: itemPaddingSM
    },
    // Horizontal
    [`${componentCls}:not(${componentCls}-vertical)`]: {
      [`${componentCls}-item-no-flex`]: {
        [`${componentCls}-item-action`]: {
          float: "right"
        }
      }
    }
  };
};
var prepareComponentToken24 = (token2) => ({
  contentWidth: 220,
  itemPadding: `${unit(token2.paddingContentVertical)} 0`,
  itemPaddingSM: `${unit(token2.paddingContentVerticalSM)} ${unit(token2.paddingContentHorizontal)}`,
  itemPaddingLG: `${unit(token2.paddingContentVerticalLG)} ${unit(token2.paddingContentHorizontalLG)}`,
  headerBg: "transparent",
  footerBg: "transparent",
  emptyTextPadding: token2.padding,
  metaMarginBottom: token2.padding,
  avatarMarginRight: token2.padding,
  titleMarginBottom: token2.paddingSM,
  descriptionFontSize: token2.fontSize
});
var style_default29 = genStyleHooks("List", (token2) => {
  const listToken = merge2(token2, {
    listBorderedCls: `${token2.componentCls}-bordered`,
    minHeight: token2.controlHeightLG
  });
  return [genBaseStyle7(listToken), genBorderedStyle2(listToken), genResponsiveStyle(listToken)];
}, prepareComponentToken24);

// ../../node_modules/antd/es/list/index.js
var __rest55 = function(s, e3) {
  var t2 = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e3.indexOf(p) < 0) t2[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e3.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t2[p[i]] = s[p[i]];
  }
  return t2;
};
function InternalList(props, ref3) {
  const {
    pagination = false,
    prefixCls: customizePrefixCls,
    bordered = false,
    split = true,
    className: className2,
    rootClassName,
    style: style2,
    children,
    itemLayout,
    loadMore,
    grid,
    dataSource = [],
    size: customizeSize,
    header,
    footer,
    loading = false,
    rowKey,
    renderItem: renderItem3,
    locale: locale6
  } = props, rest = __rest55(props, ["pagination", "prefixCls", "bordered", "split", "className", "rootClassName", "style", "children", "itemLayout", "loadMore", "grid", "dataSource", "size", "header", "footer", "loading", "rowKey", "renderItem", "locale"]);
  const paginationObj = pagination && typeof pagination === "object" ? pagination : {};
  const [paginationCurrent, setPaginationCurrent] = React400.useState(paginationObj.defaultCurrent || 1);
  const [paginationSize, setPaginationSize] = React400.useState(paginationObj.defaultPageSize || 10);
  const {
    getPrefixCls,
    direction,
    className: contextClassName,
    style: contextStyle
  } = useComponentConfig("list");
  const {
    renderEmpty
  } = React400.useContext(ConfigContext);
  const defaultPaginationProps = {
    current: 1,
    total: 0,
    position: "bottom"
  };
  const triggerPaginationEvent = (eventName) => (page, pageSize) => {
    var _a;
    setPaginationCurrent(page);
    setPaginationSize(pageSize);
    if (pagination) {
      (_a = pagination === null || pagination === void 0 ? void 0 : pagination[eventName]) === null || _a === void 0 ? void 0 : _a.call(pagination, page, pageSize);
    }
  };
  const onPaginationChange = triggerPaginationEvent("onChange");
  const onPaginationShowSizeChange = triggerPaginationEvent("onShowSizeChange");
  const renderInternalItem = (item, index3) => {
    if (!renderItem3) {
      return null;
    }
    let key2;
    if (typeof rowKey === "function") {
      key2 = rowKey(item);
    } else if (rowKey) {
      key2 = item[rowKey];
    } else {
      key2 = item.key;
    }
    if (!key2) {
      key2 = `list-item-${index3}`;
    }
    return /* @__PURE__ */ React400.createElement(React400.Fragment, {
      key: key2
    }, renderItem3(item, index3));
  };
  const isSomethingAfterLastItem = !!(loadMore || pagination || footer);
  const prefixCls = getPrefixCls("list", customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = style_default29(prefixCls);
  let loadingProp = loading;
  if (typeof loadingProp === "boolean") {
    loadingProp = {
      spinning: loadingProp
    };
  }
  const isLoading = !!(loadingProp === null || loadingProp === void 0 ? void 0 : loadingProp.spinning);
  const mergedSize = useSize_default(customizeSize);
  let sizeCls = "";
  switch (mergedSize) {
    case "large":
      sizeCls = "lg";
      break;
    case "small":
      sizeCls = "sm";
      break;
    default:
      break;
  }
  const classString = (0, import_classnames160.default)(prefixCls, {
    [`${prefixCls}-vertical`]: itemLayout === "vertical",
    [`${prefixCls}-${sizeCls}`]: sizeCls,
    [`${prefixCls}-split`]: split,
    [`${prefixCls}-bordered`]: bordered,
    [`${prefixCls}-loading`]: isLoading,
    [`${prefixCls}-grid`]: !!grid,
    [`${prefixCls}-something-after-last-item`]: isSomethingAfterLastItem,
    [`${prefixCls}-rtl`]: direction === "rtl"
  }, contextClassName, className2, rootClassName, hashId, cssVarCls);
  const paginationProps = extendsObject_default(defaultPaginationProps, {
    total: dataSource.length,
    current: paginationCurrent,
    pageSize: paginationSize
  }, pagination || {});
  const largestPage = Math.ceil(paginationProps.total / paginationProps.pageSize);
  paginationProps.current = Math.min(paginationProps.current, largestPage);
  const paginationContent = pagination && /* @__PURE__ */ React400.createElement("div", {
    className: (0, import_classnames160.default)(`${prefixCls}-pagination`)
  }, /* @__PURE__ */ React400.createElement(pagination_default, Object.assign({
    align: "end"
  }, paginationProps, {
    onChange: onPaginationChange,
    onShowSizeChange: onPaginationShowSizeChange
  })));
  let splitDataSource = _toConsumableArray(dataSource);
  if (pagination) {
    if (dataSource.length > (paginationProps.current - 1) * paginationProps.pageSize) {
      splitDataSource = _toConsumableArray(dataSource).splice((paginationProps.current - 1) * paginationProps.pageSize, paginationProps.pageSize);
    }
  }
  const needResponsive = Object.keys(grid || {}).some((key2) => ["xs", "sm", "md", "lg", "xl", "xxl"].includes(key2));
  const screens = useBreakpoint_default(needResponsive);
  const currentBreakpoint = React400.useMemo(() => {
    for (let i = 0; i < responsiveArray.length; i += 1) {
      const breakpoint = responsiveArray[i];
      if (screens[breakpoint]) {
        return breakpoint;
      }
    }
    return void 0;
  }, [screens]);
  const colStyle = React400.useMemo(() => {
    if (!grid) {
      return void 0;
    }
    const columnCount = currentBreakpoint && grid[currentBreakpoint] ? grid[currentBreakpoint] : grid.column;
    if (columnCount) {
      return {
        width: `${100 / columnCount}%`,
        maxWidth: `${100 / columnCount}%`
      };
    }
  }, [JSON.stringify(grid), currentBreakpoint]);
  let childrenContent = isLoading && /* @__PURE__ */ React400.createElement("div", {
    style: {
      minHeight: 53
    }
  });
  if (splitDataSource.length > 0) {
    const items = splitDataSource.map(renderInternalItem);
    childrenContent = grid ? /* @__PURE__ */ React400.createElement(row_default, {
      gutter: grid.gutter
    }, React400.Children.map(items, (child) => /* @__PURE__ */ React400.createElement("div", {
      key: child === null || child === void 0 ? void 0 : child.key,
      style: colStyle
    }, child))) : /* @__PURE__ */ React400.createElement("ul", {
      className: `${prefixCls}-items`
    }, items);
  } else if (!children && !isLoading) {
    childrenContent = /* @__PURE__ */ React400.createElement("div", {
      className: `${prefixCls}-empty-text`
    }, (locale6 === null || locale6 === void 0 ? void 0 : locale6.emptyText) || (renderEmpty === null || renderEmpty === void 0 ? void 0 : renderEmpty("List")) || /* @__PURE__ */ React400.createElement(defaultRenderEmpty_default, {
      componentName: "List"
    }));
  }
  const paginationPosition = paginationProps.position;
  const contextValue = React400.useMemo(() => ({
    grid,
    itemLayout
  }), [JSON.stringify(grid), itemLayout]);
  return wrapCSSVar(/* @__PURE__ */ React400.createElement(ListContext2.Provider, {
    value: contextValue
  }, /* @__PURE__ */ React400.createElement("div", Object.assign({
    ref: ref3,
    style: Object.assign(Object.assign({}, contextStyle), style2),
    className: classString
  }, rest), (paginationPosition === "top" || paginationPosition === "both") && paginationContent, header && /* @__PURE__ */ React400.createElement("div", {
    className: `${prefixCls}-header`
  }, header), /* @__PURE__ */ React400.createElement(spin_default, Object.assign({}, loadingProp), childrenContent, children), footer && /* @__PURE__ */ React400.createElement("div", {
    className: `${prefixCls}-footer`
  }, footer), loadMore || (paginationPosition === "bottom" || paginationPosition === "both") && paginationContent)));
}
var ListWithForwardRef = /* @__PURE__ */ React400.forwardRef(InternalList);
if (true) {
  ListWithForwardRef.displayName = "List";
}
var List3 = ListWithForwardRef;
List3.Item = Item_default3;
var list_default = List3;

// ../../node_modules/antd/es/_util/toList.js
var toList = (candidate, skipEmpty = false) => {
  if (skipEmpty && (candidate === void 0 || candidate === null)) {
    return [];
  }
  return Array.isArray(candidate) ? candidate : [candidate];
};
var toList_default = toList;

// ../../node_modules/antd/es/message/index.js
var import_react134 = __toESM(require_react());
var message = null;
var act = (callback) => callback();
var taskQueue = [];
var defaultGlobalConfig = {};
function getGlobalContext() {
  const {
    getContainer: getContainer2,
    duration,
    rtl,
    maxCount,
    top
  } = defaultGlobalConfig;
  const mergedContainer = (getContainer2 === null || getContainer2 === void 0 ? void 0 : getContainer2()) || document.body;
  return {
    getContainer: () => mergedContainer,
    duration,
    rtl,
    maxCount,
    top
  };
}
var GlobalHolder = /* @__PURE__ */ import_react134.default.forwardRef((props, ref3) => {
  const {
    messageConfig,
    sync
  } = props;
  const {
    getPrefixCls
  } = (0, import_react134.useContext)(ConfigContext);
  const prefixCls = defaultGlobalConfig.prefixCls || getPrefixCls("message");
  const appConfig = (0, import_react134.useContext)(AppConfigContext);
  const [api, holder] = useInternalMessage(Object.assign(Object.assign(Object.assign({}, messageConfig), {
    prefixCls
  }), appConfig.message));
  import_react134.default.useImperativeHandle(ref3, () => {
    const instance = Object.assign({}, api);
    Object.keys(instance).forEach((method4) => {
      instance[method4] = (...args) => {
        sync();
        return api[method4].apply(api, args);
      };
    });
    return {
      instance,
      sync
    };
  });
  return holder;
});
var GlobalHolderWrapper = /* @__PURE__ */ import_react134.default.forwardRef((_, ref3) => {
  const [messageConfig, setMessageConfig] = import_react134.default.useState(getGlobalContext);
  const sync = () => {
    setMessageConfig(getGlobalContext);
  };
  import_react134.default.useEffect(sync, []);
  const global2 = globalConfig();
  const rootPrefixCls = global2.getRootPrefixCls();
  const rootIconPrefixCls = global2.getIconPrefixCls();
  const theme = global2.getTheme();
  const dom = /* @__PURE__ */ import_react134.default.createElement(GlobalHolder, {
    ref: ref3,
    sync,
    messageConfig
  });
  return /* @__PURE__ */ import_react134.default.createElement(config_provider_default, {
    prefixCls: rootPrefixCls,
    iconPrefixCls: rootIconPrefixCls,
    theme
  }, global2.holderRender ? global2.holderRender(dom) : dom);
});
var flushMessageQueue = () => {
  if (!message) {
    const holderFragment = document.createDocumentFragment();
    const newMessage = {
      fragment: holderFragment
    };
    message = newMessage;
    act(() => {
      const reactRender2 = unstableSetRender();
      reactRender2(/* @__PURE__ */ import_react134.default.createElement(GlobalHolderWrapper, {
        ref: (node2) => {
          const {
            instance,
            sync
          } = node2 || {};
          Promise.resolve().then(() => {
            if (!newMessage.instance && instance) {
              newMessage.instance = instance;
              newMessage.sync = sync;
              flushMessageQueue();
            }
          });
        }
      }), holderFragment);
    });
    return;
  }
  if (!message.instance) {
    return;
  }
  taskQueue.forEach((task) => {
    const {
      type: type5,
      skipped
    } = task;
    if (!skipped) {
      switch (type5) {
        case "open": {
          act(() => {
            const closeFn = message.instance.open(Object.assign(Object.assign({}, defaultGlobalConfig), task.config));
            closeFn === null || closeFn === void 0 ? void 0 : closeFn.then(task.resolve);
            task.setCloseFn(closeFn);
          });
          break;
        }
        case "destroy":
          act(() => {
            message === null || message === void 0 ? void 0 : message.instance.destroy(task.key);
          });
          break;
        // Other type open
        default: {
          act(() => {
            var _message$instance;
            const closeFn = (_message$instance = message.instance)[type5].apply(_message$instance, _toConsumableArray(task.args));
            closeFn === null || closeFn === void 0 ? void 0 : closeFn.then(task.resolve);
            task.setCloseFn(closeFn);
          });
        }
      }
    }
  });
  taskQueue = [];
};
function setMessageGlobalConfig(config) {
  defaultGlobalConfig = Object.assign(Object.assign({}, defaultGlobalConfig), config);
  act(() => {
    var _a;
    (_a = message === null || message === void 0 ? void 0 : message.sync) === null || _a === void 0 ? void 0 : _a.call(message);
  });
}
function open(config) {
  const result = wrapPromiseFn((resolve) => {
    let closeFn;
    const task = {
      type: "open",
      config,
      resolve,
      setCloseFn: (fn) => {
        closeFn = fn;
      }
    };
    taskQueue.push(task);
    return () => {
      if (closeFn) {
        act(() => {
          closeFn();
        });
      } else {
        task.skipped = true;
      }
    };
  });
  flushMessageQueue();
  return result;
}
function typeOpen(type5, args) {
  const global2 = globalConfig();
  if (!global2.holderRender) {
    warnContext("message");
  }
  const result = wrapPromiseFn((resolve) => {
    let closeFn;
    const task = {
      type: type5,
      args,
      resolve,
      setCloseFn: (fn) => {
        closeFn = fn;
      }
    };
    taskQueue.push(task);
    return () => {
      if (closeFn) {
        act(() => {
          closeFn();
        });
      } else {
        task.skipped = true;
      }
    };
  });
  flushMessageQueue();
  return result;
}
var destroy = (key2) => {
  taskQueue.push({
    type: "destroy",
    key: key2
  });
  flushMessageQueue();
};
var methods = ["success", "info", "warning", "error", "loading"];
var baseStaticMethods = {
  open,
  destroy,
  config: setMessageGlobalConfig,
  useMessage,
  _InternalPanelDoNotUseOrYouWillBeFired: PurePanel_default
};
var staticMethods = baseStaticMethods;
methods.forEach((type5) => {
  staticMethods[type5] = (...args) => typeOpen(type5, args);
});
if (false) {
  _actWrapper = (wrapper) => {
    act = wrapper;
  };
}
if (false) {
  _actDestroy = () => {
    message = null;
  };
}
var message_default = staticMethods;

// ../../node_modules/antd/es/popconfirm/index.js
var React403 = __toESM(require_react());
var import_classnames162 = __toESM(require_classnames());

// ../../node_modules/antd/es/popconfirm/PurePanel.js
var React402 = __toESM(require_react());
var import_classnames161 = __toESM(require_classnames());

// ../../node_modules/antd/es/popconfirm/style/index.js
var genBaseStyle8 = (token2) => {
  const {
    componentCls,
    iconCls,
    antCls,
    zIndexPopup,
    colorText,
    colorWarning,
    marginXXS,
    marginXS,
    fontSize,
    fontWeightStrong,
    colorTextHeading
  } = token2;
  return {
    [componentCls]: {
      zIndex: zIndexPopup,
      [`&${antCls}-popover`]: {
        fontSize
      },
      [`${componentCls}-message`]: {
        marginBottom: marginXS,
        display: "flex",
        flexWrap: "nowrap",
        alignItems: "start",
        [`> ${componentCls}-message-icon ${iconCls}`]: {
          color: colorWarning,
          fontSize,
          lineHeight: 1,
          marginInlineEnd: marginXS
        },
        [`${componentCls}-title`]: {
          fontWeight: fontWeightStrong,
          color: colorTextHeading,
          "&:only-child": {
            fontWeight: "normal"
          }
        },
        [`${componentCls}-description`]: {
          marginTop: marginXXS,
          color: colorText
        }
      },
      [`${componentCls}-buttons`]: {
        textAlign: "end",
        whiteSpace: "nowrap",
        button: {
          marginInlineStart: marginXS
        }
      }
    }
  };
};
var prepareComponentToken25 = (token2) => {
  const {
    zIndexPopupBase
  } = token2;
  return {
    zIndexPopup: zIndexPopupBase + 60
  };
};
var style_default30 = genStyleHooks("Popconfirm", (token2) => genBaseStyle8(token2), prepareComponentToken25, {
  resetStyle: false
});

// ../../node_modules/antd/es/popconfirm/PurePanel.js
var __rest56 = function(s, e3) {
  var t2 = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e3.indexOf(p) < 0) t2[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e3.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t2[p[i]] = s[p[i]];
  }
  return t2;
};
var Overlay3 = (props) => {
  const {
    prefixCls,
    okButtonProps,
    cancelButtonProps,
    title,
    description,
    cancelText,
    okText,
    okType = "primary",
    icon = /* @__PURE__ */ React402.createElement(ExclamationCircleFilled_default2, null),
    showCancel = true,
    close,
    onConfirm,
    onCancel,
    onPopupClick
  } = props;
  const {
    getPrefixCls
  } = React402.useContext(ConfigContext);
  const [contextLocale] = useLocale_default("Popconfirm", en_US_default6.Popconfirm);
  const titleNode = getRenderPropValue(title);
  const descriptionNode = getRenderPropValue(description);
  return /* @__PURE__ */ React402.createElement("div", {
    className: `${prefixCls}-inner-content`,
    onClick: onPopupClick
  }, /* @__PURE__ */ React402.createElement("div", {
    className: `${prefixCls}-message`
  }, icon && /* @__PURE__ */ React402.createElement("span", {
    className: `${prefixCls}-message-icon`
  }, icon), /* @__PURE__ */ React402.createElement("div", {
    className: `${prefixCls}-message-text`
  }, titleNode && /* @__PURE__ */ React402.createElement("div", {
    className: `${prefixCls}-title`
  }, titleNode), descriptionNode && /* @__PURE__ */ React402.createElement("div", {
    className: `${prefixCls}-description`
  }, descriptionNode))), /* @__PURE__ */ React402.createElement("div", {
    className: `${prefixCls}-buttons`
  }, showCancel && /* @__PURE__ */ React402.createElement(button_default2, Object.assign({
    onClick: onCancel,
    size: "small"
  }, cancelButtonProps), cancelText || (contextLocale === null || contextLocale === void 0 ? void 0 : contextLocale.cancelText)), /* @__PURE__ */ React402.createElement(ActionButton_default, {
    buttonProps: Object.assign(Object.assign({
      size: "small"
    }, convertLegacyProps(okType)), okButtonProps),
    actionFn: onConfirm,
    close,
    prefixCls: getPrefixCls("btn"),
    quitOnNullishReturnValue: true,
    emitEvent: true
  }, okText || (contextLocale === null || contextLocale === void 0 ? void 0 : contextLocale.okText))));
};
var PurePanel7 = (props) => {
  const {
    prefixCls: customizePrefixCls,
    placement,
    className: className2,
    style: style2
  } = props, restProps = __rest56(props, ["prefixCls", "placement", "className", "style"]);
  const {
    getPrefixCls
  } = React402.useContext(ConfigContext);
  const prefixCls = getPrefixCls("popconfirm", customizePrefixCls);
  const [wrapCSSVar] = style_default30(prefixCls);
  return wrapCSSVar(/* @__PURE__ */ React402.createElement(PurePanel_default4, {
    placement,
    className: (0, import_classnames161.default)(prefixCls, className2),
    style: style2,
    content: /* @__PURE__ */ React402.createElement(Overlay3, Object.assign({
      prefixCls
    }, restProps))
  }));
};
var PurePanel_default5 = PurePanel7;

// ../../node_modules/antd/es/popconfirm/index.js
var __rest57 = function(s, e3) {
  var t2 = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e3.indexOf(p) < 0) t2[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e3.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t2[p[i]] = s[p[i]];
  }
  return t2;
};
var InternalPopconfirm = /* @__PURE__ */ React403.forwardRef((props, ref3) => {
  var _a, _b;
  const {
    prefixCls: customizePrefixCls,
    placement = "top",
    trigger: trigger2 = "click",
    okType = "primary",
    icon = /* @__PURE__ */ React403.createElement(ExclamationCircleFilled_default2, null),
    children,
    overlayClassName,
    onOpenChange,
    onVisibleChange,
    overlayStyle,
    styles,
    classNames: popconfirmClassNames
  } = props, restProps = __rest57(props, ["prefixCls", "placement", "trigger", "okType", "icon", "children", "overlayClassName", "onOpenChange", "onVisibleChange", "overlayStyle", "styles", "classNames"]);
  const {
    getPrefixCls,
    className: contextClassName,
    style: contextStyle,
    classNames: contextClassNames,
    styles: contextStyles
  } = useComponentConfig("popconfirm");
  const [open2, setOpen] = useMergedState(false, {
    value: (_a = props.open) !== null && _a !== void 0 ? _a : props.visible,
    defaultValue: (_b = props.defaultOpen) !== null && _b !== void 0 ? _b : props.defaultVisible
  });
  const settingOpen = (value, e3) => {
    setOpen(value, true);
    onVisibleChange === null || onVisibleChange === void 0 ? void 0 : onVisibleChange(value);
    onOpenChange === null || onOpenChange === void 0 ? void 0 : onOpenChange(value, e3);
  };
  const close = (e3) => {
    settingOpen(false, e3);
  };
  const onConfirm = (e3) => {
    var _a2;
    return (_a2 = props.onConfirm) === null || _a2 === void 0 ? void 0 : _a2.call(void 0, e3);
  };
  const onCancel = (e3) => {
    var _a2;
    settingOpen(false, e3);
    (_a2 = props.onCancel) === null || _a2 === void 0 ? void 0 : _a2.call(void 0, e3);
  };
  const onInternalOpenChange = (value, e3) => {
    const {
      disabled = false
    } = props;
    if (disabled) {
      return;
    }
    settingOpen(value, e3);
  };
  const prefixCls = getPrefixCls("popconfirm", customizePrefixCls);
  const rootClassNames = (0, import_classnames162.default)(prefixCls, contextClassName, overlayClassName, contextClassNames.root, popconfirmClassNames === null || popconfirmClassNames === void 0 ? void 0 : popconfirmClassNames.root);
  const bodyClassNames = (0, import_classnames162.default)(contextClassNames.body, popconfirmClassNames === null || popconfirmClassNames === void 0 ? void 0 : popconfirmClassNames.body);
  const [wrapCSSVar] = style_default30(prefixCls);
  return wrapCSSVar(/* @__PURE__ */ React403.createElement(popover_default, Object.assign({}, omit(restProps, ["title"]), {
    trigger: trigger2,
    placement,
    onOpenChange: onInternalOpenChange,
    open: open2,
    ref: ref3,
    classNames: {
      root: rootClassNames,
      body: bodyClassNames
    },
    styles: {
      root: Object.assign(Object.assign(Object.assign(Object.assign({}, contextStyles.root), contextStyle), overlayStyle), styles === null || styles === void 0 ? void 0 : styles.root),
      body: Object.assign(Object.assign({}, contextStyles.body), styles === null || styles === void 0 ? void 0 : styles.body)
    },
    content: /* @__PURE__ */ React403.createElement(Overlay3, Object.assign({
      okType,
      icon
    }, props, {
      prefixCls,
      close,
      onConfirm,
      onCancel
    })),
    "data-popover-inject": true
  }), children));
});
var Popconfirm = InternalPopconfirm;
Popconfirm._InternalPanelDoNotUseOrYouWillBeFired = PurePanel_default5;
if (true) {
  Popconfirm.displayName = "Popconfirm";
}
var popconfirm_default = Popconfirm;

// ../../node_modules/antd/es/progress/progress.js
var React411 = __toESM(require_react());
var import_classnames168 = __toESM(require_classnames());

// ../../node_modules/antd/es/progress/Circle.js
var React408 = __toESM(require_react());
var import_classnames165 = __toESM(require_classnames());

// ../../node_modules/rc-progress/es/Line.js
var React404 = __toESM(require_react());
var import_classnames163 = __toESM(require_classnames());

// ../../node_modules/rc-progress/es/common.js
var import_react135 = __toESM(require_react());
var defaultProps = {
  percent: 0,
  prefixCls: "rc-progress",
  strokeColor: "#2db7f5",
  strokeLinecap: "round",
  strokeWidth: 1,
  trailColor: "#D9D9D9",
  trailWidth: 1,
  gapPosition: "bottom"
};
var useTransitionDuration = function useTransitionDuration2() {
  var pathsRef = (0, import_react135.useRef)([]);
  var prevTimeStamp = (0, import_react135.useRef)(null);
  (0, import_react135.useEffect)(function() {
    var now4 = Date.now();
    var updated = false;
    pathsRef.current.forEach(function(path2) {
      if (!path2) {
        return;
      }
      updated = true;
      var pathStyle = path2.style;
      pathStyle.transitionDuration = ".3s, .3s, .3s, .06s";
      if (prevTimeStamp.current && now4 - prevTimeStamp.current < 100) {
        pathStyle.transitionDuration = "0s, 0s";
      }
    });
    if (updated) {
      prevTimeStamp.current = Date.now();
    }
  });
  return pathsRef.current;
};

// ../../node_modules/rc-progress/es/Line.js
var _excluded60 = ["className", "percent", "prefixCls", "strokeColor", "strokeLinecap", "strokeWidth", "style", "trailColor", "trailWidth", "transition"];
var Line = function Line2(props) {
  var _defaultProps$props = _objectSpread2(_objectSpread2({}, defaultProps), props), className2 = _defaultProps$props.className, percent = _defaultProps$props.percent, prefixCls = _defaultProps$props.prefixCls, strokeColor = _defaultProps$props.strokeColor, strokeLinecap = _defaultProps$props.strokeLinecap, strokeWidth = _defaultProps$props.strokeWidth, style2 = _defaultProps$props.style, trailColor = _defaultProps$props.trailColor, trailWidth = _defaultProps$props.trailWidth, transition = _defaultProps$props.transition, restProps = _objectWithoutProperties(_defaultProps$props, _excluded60);
  delete restProps.gapPosition;
  var percentList = Array.isArray(percent) ? percent : [percent];
  var strokeColorList = Array.isArray(strokeColor) ? strokeColor : [strokeColor];
  var paths = useTransitionDuration();
  var center = strokeWidth / 2;
  var right2 = 100 - strokeWidth / 2;
  var pathString = "M ".concat(strokeLinecap === "round" ? center : 0, ",").concat(center, "\n         L ").concat(strokeLinecap === "round" ? right2 : 100, ",").concat(center);
  var viewBoxString = "0 0 100 ".concat(strokeWidth);
  var stackPtg = 0;
  return /* @__PURE__ */ React404.createElement("svg", _extends({
    className: (0, import_classnames163.default)("".concat(prefixCls, "-line"), className2),
    viewBox: viewBoxString,
    preserveAspectRatio: "none",
    style: style2
  }, restProps), /* @__PURE__ */ React404.createElement("path", {
    className: "".concat(prefixCls, "-line-trail"),
    d: pathString,
    strokeLinecap,
    stroke: trailColor,
    strokeWidth: trailWidth || strokeWidth,
    fillOpacity: "0"
  }), percentList.map(function(ptg, index3) {
    var dashPercent = 1;
    switch (strokeLinecap) {
      case "round":
        dashPercent = 1 - strokeWidth / 100;
        break;
      case "square":
        dashPercent = 1 - strokeWidth / 2 / 100;
        break;
      default:
        dashPercent = 1;
        break;
    }
    var pathStyle = {
      strokeDasharray: "".concat(ptg * dashPercent, "px, 100px"),
      strokeDashoffset: "-".concat(stackPtg, "px"),
      transition: transition || "stroke-dashoffset 0.3s ease 0s, stroke-dasharray .3s ease 0s, stroke 0.3s linear"
    };
    var color = strokeColorList[index3] || strokeColorList[strokeColorList.length - 1];
    stackPtg += ptg;
    return /* @__PURE__ */ React404.createElement("path", {
      key: index3,
      className: "".concat(prefixCls, "-line-path"),
      d: pathString,
      strokeLinecap,
      stroke: color,
      strokeWidth,
      fillOpacity: "0",
      ref: function ref3(elem) {
        paths[index3] = elem;
      },
      style: pathStyle
    });
  }));
};
if (true) {
  Line.displayName = "Line";
}

// ../../node_modules/rc-progress/es/Circle/index.js
var React407 = __toESM(require_react());
var import_classnames164 = __toESM(require_classnames());

// ../../node_modules/rc-progress/es/hooks/useId.js
var React405 = __toESM(require_react());
var uuid7 = 0;
var isBrowserClient3 = canUseDom();
function getUUID2() {
  var retId;
  if (isBrowserClient3) {
    retId = uuid7;
    uuid7 += 1;
  } else {
    retId = "TEST_OR_SSR";
  }
  return retId;
}
var useId_default2 = (function(id) {
  var _React$useState = React405.useState(), _React$useState2 = _slicedToArray(_React$useState, 2), innerId = _React$useState2[0], setInnerId = _React$useState2[1];
  React405.useEffect(function() {
    setInnerId("rc_progress_".concat(getUUID2()));
  }, []);
  return id || innerId;
});

// ../../node_modules/rc-progress/es/Circle/PtgCircle.js
var React406 = __toESM(require_react());
var Block = function Block2(_ref) {
  var bg = _ref.bg, children = _ref.children;
  return /* @__PURE__ */ React406.createElement("div", {
    style: {
      width: "100%",
      height: "100%",
      background: bg
    }
  }, children);
};
function getPtgColors(color, scale) {
  return Object.keys(color).map(function(key2) {
    var parsedKey = parseFloat(key2);
    var ptgKey = "".concat(Math.floor(parsedKey * scale), "%");
    return "".concat(color[key2], " ").concat(ptgKey);
  });
}
var PtgCircle = /* @__PURE__ */ React406.forwardRef(function(props, ref3) {
  var prefixCls = props.prefixCls, color = props.color, gradientId = props.gradientId, radius2 = props.radius, circleStyleForStack = props.style, ptg = props.ptg, strokeLinecap = props.strokeLinecap, strokeWidth = props.strokeWidth, size = props.size, gapDegree = props.gapDegree;
  var isGradient = color && _typeof(color) === "object";
  var stroke = isGradient ? "#FFF" : void 0;
  var halfSize = size / 2;
  var circleNode = /* @__PURE__ */ React406.createElement("circle", {
    className: "".concat(prefixCls, "-circle-path"),
    r: radius2,
    cx: halfSize,
    cy: halfSize,
    stroke,
    strokeLinecap,
    strokeWidth,
    opacity: ptg === 0 ? 0 : 1,
    style: circleStyleForStack,
    ref: ref3
  });
  if (!isGradient) {
    return circleNode;
  }
  var maskId = "".concat(gradientId, "-conic");
  var fromDeg = gapDegree ? "".concat(180 + gapDegree / 2, "deg") : "0deg";
  var conicColors = getPtgColors(color, (360 - gapDegree) / 360);
  var linearColors = getPtgColors(color, 1);
  var conicColorBg = "conic-gradient(from ".concat(fromDeg, ", ").concat(conicColors.join(", "), ")");
  var linearColorBg = "linear-gradient(to ".concat(gapDegree ? "bottom" : "top", ", ").concat(linearColors.join(", "), ")");
  return /* @__PURE__ */ React406.createElement(React406.Fragment, null, /* @__PURE__ */ React406.createElement("mask", {
    id: maskId
  }, circleNode), /* @__PURE__ */ React406.createElement("foreignObject", {
    x: 0,
    y: 0,
    width: size,
    height: size,
    mask: "url(#".concat(maskId, ")")
  }, /* @__PURE__ */ React406.createElement(Block, {
    bg: linearColorBg
  }, /* @__PURE__ */ React406.createElement(Block, {
    bg: conicColorBg
  }))));
});
if (true) {
  PtgCircle.displayName = "PtgCircle";
}
var PtgCircle_default = PtgCircle;

// ../../node_modules/rc-progress/es/Circle/util.js
var VIEW_BOX_SIZE = 100;
var getCircleStyle = function getCircleStyle2(perimeter, perimeterWithoutGap, offset4, percent, rotateDeg, gapDegree, gapPosition, strokeColor, strokeLinecap, strokeWidth) {
  var stepSpace = arguments.length > 10 && arguments[10] !== void 0 ? arguments[10] : 0;
  var offsetDeg = offset4 / 100 * 360 * ((360 - gapDegree) / 360);
  var positionDeg = gapDegree === 0 ? 0 : {
    bottom: 0,
    top: 180,
    left: 90,
    right: -90
  }[gapPosition];
  var strokeDashoffset = (100 - percent) / 100 * perimeterWithoutGap;
  if (strokeLinecap === "round" && percent !== 100) {
    strokeDashoffset += strokeWidth / 2;
    if (strokeDashoffset >= perimeterWithoutGap) {
      strokeDashoffset = perimeterWithoutGap - 0.01;
    }
  }
  var halfSize = VIEW_BOX_SIZE / 2;
  return {
    stroke: typeof strokeColor === "string" ? strokeColor : void 0,
    strokeDasharray: "".concat(perimeterWithoutGap, "px ").concat(perimeter),
    strokeDashoffset: strokeDashoffset + stepSpace,
    transform: "rotate(".concat(rotateDeg + offsetDeg + positionDeg, "deg)"),
    transformOrigin: "".concat(halfSize, "px ").concat(halfSize, "px"),
    transition: "stroke-dashoffset .3s ease 0s, stroke-dasharray .3s ease 0s, stroke .3s, stroke-width .06s ease .3s, opacity .3s ease 0s",
    fillOpacity: 0
  };
};

// ../../node_modules/rc-progress/es/Circle/index.js
var _excluded61 = ["id", "prefixCls", "steps", "strokeWidth", "trailWidth", "gapDegree", "gapPosition", "trailColor", "strokeLinecap", "style", "className", "strokeColor", "percent"];
function toArray7(value) {
  var mergedValue = value !== null && value !== void 0 ? value : [];
  return Array.isArray(mergedValue) ? mergedValue : [mergedValue];
}
var Circle = function Circle2(props) {
  var _defaultProps$props = _objectSpread2(_objectSpread2({}, defaultProps), props), id = _defaultProps$props.id, prefixCls = _defaultProps$props.prefixCls, steps = _defaultProps$props.steps, strokeWidth = _defaultProps$props.strokeWidth, trailWidth = _defaultProps$props.trailWidth, _defaultProps$props$g = _defaultProps$props.gapDegree, gapDegree = _defaultProps$props$g === void 0 ? 0 : _defaultProps$props$g, gapPosition = _defaultProps$props.gapPosition, trailColor = _defaultProps$props.trailColor, strokeLinecap = _defaultProps$props.strokeLinecap, style2 = _defaultProps$props.style, className2 = _defaultProps$props.className, strokeColor = _defaultProps$props.strokeColor, percent = _defaultProps$props.percent, restProps = _objectWithoutProperties(_defaultProps$props, _excluded61);
  var halfSize = VIEW_BOX_SIZE / 2;
  var mergedId = useId_default2(id);
  var gradientId = "".concat(mergedId, "-gradient");
  var radius2 = halfSize - strokeWidth / 2;
  var perimeter = Math.PI * 2 * radius2;
  var rotateDeg = gapDegree > 0 ? 90 + gapDegree / 2 : -90;
  var perimeterWithoutGap = perimeter * ((360 - gapDegree) / 360);
  var _ref = _typeof(steps) === "object" ? steps : {
    count: steps,
    gap: 2
  }, stepCount = _ref.count, stepGap = _ref.gap;
  var percentList = toArray7(percent);
  var strokeColorList = toArray7(strokeColor);
  var gradient = strokeColorList.find(function(color) {
    return color && _typeof(color) === "object";
  });
  var isConicGradient = gradient && _typeof(gradient) === "object";
  var mergedStrokeLinecap = isConicGradient ? "butt" : strokeLinecap;
  var circleStyle = getCircleStyle(perimeter, perimeterWithoutGap, 0, 100, rotateDeg, gapDegree, gapPosition, trailColor, mergedStrokeLinecap, strokeWidth);
  var paths = useTransitionDuration();
  var getStokeList = function getStokeList2() {
    var stackPtg = 0;
    return percentList.map(function(ptg, index3) {
      var color = strokeColorList[index3] || strokeColorList[strokeColorList.length - 1];
      var circleStyleForStack = getCircleStyle(perimeter, perimeterWithoutGap, stackPtg, ptg, rotateDeg, gapDegree, gapPosition, color, mergedStrokeLinecap, strokeWidth);
      stackPtg += ptg;
      return /* @__PURE__ */ React407.createElement(PtgCircle_default, {
        key: index3,
        color,
        ptg,
        radius: radius2,
        prefixCls,
        gradientId,
        style: circleStyleForStack,
        strokeLinecap: mergedStrokeLinecap,
        strokeWidth,
        gapDegree,
        ref: function ref3(elem) {
          paths[index3] = elem;
        },
        size: VIEW_BOX_SIZE
      });
    }).reverse();
  };
  var getStepStokeList = function getStepStokeList2() {
    var current2 = Math.round(stepCount * (percentList[0] / 100));
    var stepPtg = 100 / stepCount;
    var stackPtg = 0;
    return new Array(stepCount).fill(null).map(function(_, index3) {
      var color = index3 <= current2 - 1 ? strokeColorList[0] : trailColor;
      var stroke = color && _typeof(color) === "object" ? "url(#".concat(gradientId, ")") : void 0;
      var circleStyleForStack = getCircleStyle(perimeter, perimeterWithoutGap, stackPtg, stepPtg, rotateDeg, gapDegree, gapPosition, color, "butt", strokeWidth, stepGap);
      stackPtg += (perimeterWithoutGap - circleStyleForStack.strokeDashoffset + stepGap) * 100 / perimeterWithoutGap;
      return /* @__PURE__ */ React407.createElement("circle", {
        key: index3,
        className: "".concat(prefixCls, "-circle-path"),
        r: radius2,
        cx: halfSize,
        cy: halfSize,
        stroke,
        strokeWidth,
        opacity: 1,
        style: circleStyleForStack,
        ref: function ref3(elem) {
          paths[index3] = elem;
        }
      });
    });
  };
  return /* @__PURE__ */ React407.createElement("svg", _extends({
    className: (0, import_classnames164.default)("".concat(prefixCls, "-circle"), className2),
    viewBox: "0 0 ".concat(VIEW_BOX_SIZE, " ").concat(VIEW_BOX_SIZE),
    style: style2,
    id,
    role: "presentation"
  }, restProps), !stepCount && /* @__PURE__ */ React407.createElement("circle", {
    className: "".concat(prefixCls, "-circle-trail"),
    r: radius2,
    cx: halfSize,
    cy: halfSize,
    stroke: trailColor,
    strokeLinecap: mergedStrokeLinecap,
    strokeWidth: trailWidth || strokeWidth,
    style: circleStyle
  }), stepCount ? getStepStokeList() : getStokeList());
};
if (true) {
  Circle.displayName = "Circle";
}
var Circle_default = Circle;

// ../../node_modules/antd/es/progress/utils.js
function validProgress(progress) {
  if (!progress || progress < 0) {
    return 0;
  }
  if (progress > 100) {
    return 100;
  }
  return progress;
}
function getSuccessPercent({
  success,
  successPercent
}) {
  let percent = successPercent;
  if (success && "progress" in success) {
    percent = success.progress;
  }
  if (success && "percent" in success) {
    percent = success.percent;
  }
  return percent;
}
var getPercentage = ({
  percent,
  success,
  successPercent
}) => {
  const realSuccessPercent = validProgress(getSuccessPercent({
    success,
    successPercent
  }));
  return [realSuccessPercent, validProgress(validProgress(percent) - realSuccessPercent)];
};
var getStrokeColor = ({
  success = {},
  strokeColor
}) => {
  const {
    strokeColor: successColor
  } = success;
  return [successColor || presetPrimaryColors.green, strokeColor || null];
};
var getSize3 = (size, type5, extra) => {
  var _a, _b, _c, _d;
  let width = -1;
  let height = -1;
  if (type5 === "step") {
    const steps = extra.steps;
    const strokeWidth = extra.strokeWidth;
    if (typeof size === "string" || typeof size === "undefined") {
      width = size === "small" ? 2 : 14;
      height = strokeWidth !== null && strokeWidth !== void 0 ? strokeWidth : 8;
    } else if (typeof size === "number") {
      [width, height] = [size, size];
    } else {
      [width = 14, height = 8] = Array.isArray(size) ? size : [size.width, size.height];
    }
    width *= steps;
  } else if (type5 === "line") {
    const strokeWidth = extra === null || extra === void 0 ? void 0 : extra.strokeWidth;
    if (typeof size === "string" || typeof size === "undefined") {
      height = strokeWidth || (size === "small" ? 6 : 8);
    } else if (typeof size === "number") {
      [width, height] = [size, size];
    } else {
      [width = -1, height = 8] = Array.isArray(size) ? size : [size.width, size.height];
    }
  } else if (type5 === "circle" || type5 === "dashboard") {
    if (typeof size === "string" || typeof size === "undefined") {
      [width, height] = size === "small" ? [60, 60] : [120, 120];
    } else if (typeof size === "number") {
      [width, height] = [size, size];
    } else if (Array.isArray(size)) {
      width = (_b = (_a = size[0]) !== null && _a !== void 0 ? _a : size[1]) !== null && _b !== void 0 ? _b : 120;
      height = (_d = (_c = size[0]) !== null && _c !== void 0 ? _c : size[1]) !== null && _d !== void 0 ? _d : 120;
    }
  }
  return [width, height];
};

// ../../node_modules/antd/es/progress/Circle.js
var CIRCLE_MIN_STROKE_WIDTH = 3;
var getMinPercent = (width) => CIRCLE_MIN_STROKE_WIDTH / width * 100;
var Circle3 = (props) => {
  const {
    prefixCls,
    trailColor = null,
    strokeLinecap = "round",
    gapPosition,
    gapDegree,
    width: originWidth = 120,
    type: type5,
    children,
    success,
    size = originWidth,
    steps
  } = props;
  const [width, height] = getSize3(size, "circle");
  let {
    strokeWidth
  } = props;
  if (strokeWidth === void 0) {
    strokeWidth = Math.max(getMinPercent(width), 6);
  }
  const circleStyle = {
    width,
    height,
    fontSize: width * 0.15 + 6
  };
  const realGapDegree = React408.useMemo(() => {
    if (gapDegree || gapDegree === 0) {
      return gapDegree;
    }
    if (type5 === "dashboard") {
      return 75;
    }
    return void 0;
  }, [gapDegree, type5]);
  const percentArray = getPercentage(props);
  const gapPos = gapPosition || type5 === "dashboard" && "bottom" || void 0;
  const isGradient = Object.prototype.toString.call(props.strokeColor) === "[object Object]";
  const strokeColor = getStrokeColor({
    success,
    strokeColor: props.strokeColor
  });
  const wrapperClassName = (0, import_classnames165.default)(`${prefixCls}-inner`, {
    [`${prefixCls}-circle-gradient`]: isGradient
  });
  const circleContent = /* @__PURE__ */ React408.createElement(Circle_default, {
    steps,
    percent: steps ? percentArray[1] : percentArray,
    strokeWidth,
    trailWidth: strokeWidth,
    strokeColor: steps ? strokeColor[1] : strokeColor,
    strokeLinecap,
    trailColor,
    prefixCls,
    gapDegree: realGapDegree,
    gapPosition: gapPos
  });
  const smallCircle = width <= 20;
  const node2 = /* @__PURE__ */ React408.createElement("div", {
    className: wrapperClassName,
    style: circleStyle
  }, circleContent, !smallCircle && children);
  if (smallCircle) {
    return /* @__PURE__ */ React408.createElement(tooltip_default, {
      title: children
    }, node2);
  }
  return node2;
};
var Circle_default2 = Circle3;

// ../../node_modules/antd/es/progress/Line.js
var React409 = __toESM(require_react());
var import_classnames166 = __toESM(require_classnames());

// ../../node_modules/antd/es/progress/style/index.js
var LineStrokeColorVar = "--progress-line-stroke-color";
var Percent = "--progress-percent";
var genAntProgressActive = (isRtl) => {
  const direction = isRtl ? "100%" : "-100%";
  return new Keyframes_default(`antProgress${isRtl ? "RTL" : "LTR"}Active`, {
    "0%": {
      transform: `translateX(${direction}) scaleX(0)`,
      opacity: 0.1
    },
    "20%": {
      transform: `translateX(${direction}) scaleX(0)`,
      opacity: 0.5
    },
    to: {
      transform: "translateX(0) scaleX(1)",
      opacity: 0
    }
  });
};
var genBaseStyle9 = (token2) => {
  const {
    componentCls: progressCls,
    iconCls: iconPrefixCls
  } = token2;
  return {
    [progressCls]: Object.assign(Object.assign({}, resetComponent(token2)), {
      display: "inline-block",
      "&-rtl": {
        direction: "rtl"
      },
      "&-line": {
        position: "relative",
        width: "100%",
        fontSize: token2.fontSize
      },
      [`${progressCls}-outer`]: {
        display: "inline-flex",
        alignItems: "center",
        width: "100%"
      },
      [`${progressCls}-inner`]: {
        position: "relative",
        display: "inline-block",
        width: "100%",
        flex: 1,
        overflow: "hidden",
        verticalAlign: "middle",
        backgroundColor: token2.remainingColor,
        borderRadius: token2.lineBorderRadius
      },
      [`${progressCls}-inner:not(${progressCls}-circle-gradient)`]: {
        [`${progressCls}-circle-path`]: {
          stroke: token2.defaultColor
        }
      },
      [`${progressCls}-success-bg, ${progressCls}-bg`]: {
        position: "relative",
        background: token2.defaultColor,
        borderRadius: token2.lineBorderRadius,
        transition: `all ${token2.motionDurationSlow} ${token2.motionEaseInOutCirc}`
      },
      [`${progressCls}-layout-bottom`]: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        [`${progressCls}-text`]: {
          width: "max-content",
          marginInlineStart: 0,
          marginTop: token2.marginXXS
        }
      },
      [`${progressCls}-bg`]: {
        overflow: "hidden",
        "&::after": {
          content: '""',
          background: {
            _multi_value_: true,
            value: ["inherit", `var(${LineStrokeColorVar})`]
          },
          height: "100%",
          width: `calc(1 / var(${Percent}) * 100%)`,
          display: "block"
        },
        [`&${progressCls}-bg-inner`]: {
          minWidth: "max-content",
          "&::after": {
            content: "none"
          },
          [`${progressCls}-text-inner`]: {
            color: token2.colorWhite,
            [`&${progressCls}-text-bright`]: {
              color: "rgba(0, 0, 0, 0.45)"
            }
          }
        }
      },
      [`${progressCls}-success-bg`]: {
        position: "absolute",
        insetBlockStart: 0,
        insetInlineStart: 0,
        backgroundColor: token2.colorSuccess
      },
      [`${progressCls}-text`]: {
        display: "inline-block",
        marginInlineStart: token2.marginXS,
        color: token2.colorText,
        lineHeight: 1,
        width: "2em",
        whiteSpace: "nowrap",
        textAlign: "start",
        verticalAlign: "middle",
        wordBreak: "normal",
        [iconPrefixCls]: {
          fontSize: token2.fontSize
        },
        [`&${progressCls}-text-outer`]: {
          width: "max-content"
        },
        [`&${progressCls}-text-outer${progressCls}-text-start`]: {
          width: "max-content",
          marginInlineStart: 0,
          marginInlineEnd: token2.marginXS
        }
      },
      [`${progressCls}-text-inner`]: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        height: "100%",
        marginInlineStart: 0,
        padding: `0 ${unit(token2.paddingXXS)}`,
        [`&${progressCls}-text-start`]: {
          justifyContent: "start"
        },
        [`&${progressCls}-text-end`]: {
          justifyContent: "end"
        }
      },
      [`&${progressCls}-status-active`]: {
        [`${progressCls}-bg::before`]: {
          position: "absolute",
          inset: 0,
          backgroundColor: token2.colorBgContainer,
          borderRadius: token2.lineBorderRadius,
          opacity: 0,
          animationName: genAntProgressActive(),
          animationDuration: token2.progressActiveMotionDuration,
          animationTimingFunction: token2.motionEaseOutQuint,
          animationIterationCount: "infinite",
          content: '""'
        }
      },
      [`&${progressCls}-rtl${progressCls}-status-active`]: {
        [`${progressCls}-bg::before`]: {
          animationName: genAntProgressActive(true)
        }
      },
      [`&${progressCls}-status-exception`]: {
        [`${progressCls}-bg`]: {
          backgroundColor: token2.colorError
        },
        [`${progressCls}-text`]: {
          color: token2.colorError
        }
      },
      [`&${progressCls}-status-exception ${progressCls}-inner:not(${progressCls}-circle-gradient)`]: {
        [`${progressCls}-circle-path`]: {
          stroke: token2.colorError
        }
      },
      [`&${progressCls}-status-success`]: {
        [`${progressCls}-bg`]: {
          backgroundColor: token2.colorSuccess
        },
        [`${progressCls}-text`]: {
          color: token2.colorSuccess
        }
      },
      [`&${progressCls}-status-success ${progressCls}-inner:not(${progressCls}-circle-gradient)`]: {
        [`${progressCls}-circle-path`]: {
          stroke: token2.colorSuccess
        }
      }
    })
  };
};
var genCircleStyle = (token2) => {
  const {
    componentCls: progressCls,
    iconCls: iconPrefixCls
  } = token2;
  return {
    [progressCls]: {
      [`${progressCls}-circle-trail`]: {
        stroke: token2.remainingColor
      },
      [`&${progressCls}-circle ${progressCls}-inner`]: {
        position: "relative",
        lineHeight: 1,
        backgroundColor: "transparent"
      },
      [`&${progressCls}-circle ${progressCls}-text`]: {
        position: "absolute",
        insetBlockStart: "50%",
        insetInlineStart: 0,
        width: "100%",
        margin: 0,
        padding: 0,
        color: token2.circleTextColor,
        fontSize: token2.circleTextFontSize,
        lineHeight: 1,
        whiteSpace: "normal",
        textAlign: "center",
        transform: "translateY(-50%)",
        [iconPrefixCls]: {
          fontSize: token2.circleIconFontSize
        }
      },
      [`${progressCls}-circle&-status-exception`]: {
        [`${progressCls}-text`]: {
          color: token2.colorError
        }
      },
      [`${progressCls}-circle&-status-success`]: {
        [`${progressCls}-text`]: {
          color: token2.colorSuccess
        }
      }
    },
    [`${progressCls}-inline-circle`]: {
      lineHeight: 1,
      [`${progressCls}-inner`]: {
        verticalAlign: "bottom"
      }
    }
  };
};
var genStepStyle = (token2) => {
  const {
    componentCls: progressCls
  } = token2;
  return {
    [progressCls]: {
      [`${progressCls}-steps`]: {
        display: "inline-block",
        "&-outer": {
          display: "flex",
          flexDirection: "row",
          alignItems: "center"
        },
        "&-item": {
          flexShrink: 0,
          minWidth: token2.progressStepMinWidth,
          marginInlineEnd: token2.progressStepMarginInlineEnd,
          backgroundColor: token2.remainingColor,
          transition: `all ${token2.motionDurationSlow}`,
          "&-active": {
            backgroundColor: token2.defaultColor
          }
        }
      }
    }
  };
};
var genSmallLine = (token2) => {
  const {
    componentCls: progressCls,
    iconCls: iconPrefixCls
  } = token2;
  return {
    [progressCls]: {
      [`${progressCls}-small&-line, ${progressCls}-small&-line ${progressCls}-text ${iconPrefixCls}`]: {
        fontSize: token2.fontSizeSM
      }
    }
  };
};
var prepareComponentToken26 = (token2) => ({
  circleTextColor: token2.colorText,
  defaultColor: token2.colorInfo,
  remainingColor: token2.colorFillSecondary,
  lineBorderRadius: 100,
  // magic for capsule shape, should be a very large number
  circleTextFontSize: "1em",
  circleIconFontSize: `${token2.fontSize / token2.fontSizeSM}em`
});
var style_default31 = genStyleHooks("Progress", (token2) => {
  const progressStepMarginInlineEnd = token2.calc(token2.marginXXS).div(2).equal();
  const progressToken = merge2(token2, {
    progressStepMarginInlineEnd,
    progressStepMinWidth: progressStepMarginInlineEnd,
    progressActiveMotionDuration: "2.4s"
  });
  return [genBaseStyle9(progressToken), genCircleStyle(progressToken), genStepStyle(progressToken), genSmallLine(progressToken)];
}, prepareComponentToken26);

// ../../node_modules/antd/es/progress/Line.js
var __rest58 = function(s, e3) {
  var t2 = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e3.indexOf(p) < 0) t2[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e3.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t2[p[i]] = s[p[i]];
  }
  return t2;
};
var sortGradient = (gradients) => {
  let tempArr = [];
  Object.keys(gradients).forEach((key2) => {
    const formattedKey = parseFloat(key2.replace(/%/g, ""));
    if (!Number.isNaN(formattedKey)) {
      tempArr.push({
        key: formattedKey,
        value: gradients[key2]
      });
    }
  });
  tempArr = tempArr.sort((a, b) => a.key - b.key);
  return tempArr.map(({
    key: key2,
    value
  }) => `${value} ${key2}%`).join(", ");
};
var handleGradient = (strokeColor, directionConfig) => {
  const {
    from: from2 = presetPrimaryColors.blue,
    to = presetPrimaryColors.blue,
    direction = directionConfig === "rtl" ? "to left" : "to right"
  } = strokeColor, rest = __rest58(strokeColor, ["from", "to", "direction"]);
  if (Object.keys(rest).length !== 0) {
    const sortedGradients = sortGradient(rest);
    const background2 = `linear-gradient(${direction}, ${sortedGradients})`;
    return {
      background: background2,
      [LineStrokeColorVar]: background2
    };
  }
  const background = `linear-gradient(${direction}, ${from2}, ${to})`;
  return {
    background,
    [LineStrokeColorVar]: background
  };
};
var Line3 = (props) => {
  const {
    prefixCls,
    direction: directionConfig,
    percent,
    size,
    strokeWidth,
    strokeColor,
    strokeLinecap = "round",
    children,
    trailColor = null,
    percentPosition,
    success
  } = props;
  const {
    align: infoAlign,
    type: infoPosition
  } = percentPosition;
  const backgroundProps = strokeColor && typeof strokeColor !== "string" ? handleGradient(strokeColor, directionConfig) : {
    [LineStrokeColorVar]: strokeColor,
    background: strokeColor
  };
  const borderRadius = strokeLinecap === "square" || strokeLinecap === "butt" ? 0 : void 0;
  const mergedSize = size !== null && size !== void 0 ? size : [-1, strokeWidth || (size === "small" ? 6 : 8)];
  const [width, height] = getSize3(mergedSize, "line", {
    strokeWidth
  });
  if (true) {
    const warning6 = devUseWarning("Progress");
    warning6.deprecated(!("strokeWidth" in props), "strokeWidth", "size");
  }
  const trailStyle = {
    backgroundColor: trailColor || void 0,
    borderRadius
  };
  const percentStyle = Object.assign(Object.assign({
    width: `${validProgress(percent)}%`,
    height,
    borderRadius
  }, backgroundProps), {
    [Percent]: validProgress(percent) / 100
  });
  const successPercent = getSuccessPercent(props);
  const successPercentStyle = {
    width: `${validProgress(successPercent)}%`,
    height,
    borderRadius,
    backgroundColor: success === null || success === void 0 ? void 0 : success.strokeColor
  };
  const outerStyle = {
    width: width < 0 ? "100%" : width
  };
  const lineInner = /* @__PURE__ */ React409.createElement("div", {
    className: `${prefixCls}-inner`,
    style: trailStyle
  }, /* @__PURE__ */ React409.createElement("div", {
    className: (0, import_classnames166.default)(`${prefixCls}-bg`, `${prefixCls}-bg-${infoPosition}`),
    style: percentStyle
  }, infoPosition === "inner" && children), successPercent !== void 0 && /* @__PURE__ */ React409.createElement("div", {
    className: `${prefixCls}-success-bg`,
    style: successPercentStyle
  }));
  const isOuterStart = infoPosition === "outer" && infoAlign === "start";
  const isOuterEnd = infoPosition === "outer" && infoAlign === "end";
  return infoPosition === "outer" && infoAlign === "center" ? /* @__PURE__ */ React409.createElement("div", {
    className: `${prefixCls}-layout-bottom`
  }, lineInner, children) : /* @__PURE__ */ React409.createElement("div", {
    className: `${prefixCls}-outer`,
    style: outerStyle
  }, isOuterStart && children, lineInner, isOuterEnd && children);
};
var Line_default2 = Line3;

// ../../node_modules/antd/es/progress/Steps.js
var React410 = __toESM(require_react());
var import_classnames167 = __toESM(require_classnames());
var Steps3 = (props) => {
  const {
    size,
    steps,
    rounding: customRounding = Math.round,
    percent = 0,
    strokeWidth = 8,
    strokeColor,
    trailColor = null,
    prefixCls,
    children
  } = props;
  const current2 = customRounding(steps * (percent / 100));
  const stepWidth = size === "small" ? 2 : 14;
  const mergedSize = size !== null && size !== void 0 ? size : [stepWidth, strokeWidth];
  const [width, height] = getSize3(mergedSize, "step", {
    steps,
    strokeWidth
  });
  const unitWidth = width / steps;
  const styledSteps = Array.from({
    length: steps
  });
  for (let i = 0; i < steps; i++) {
    const color = Array.isArray(strokeColor) ? strokeColor[i] : strokeColor;
    styledSteps[i] = /* @__PURE__ */ React410.createElement("div", {
      key: i,
      className: (0, import_classnames167.default)(`${prefixCls}-steps-item`, {
        [`${prefixCls}-steps-item-active`]: i <= current2 - 1
      }),
      style: {
        backgroundColor: i <= current2 - 1 ? color : trailColor,
        width: unitWidth,
        height
      }
    });
  }
  return /* @__PURE__ */ React410.createElement("div", {
    className: `${prefixCls}-steps-outer`
  }, styledSteps, children);
};
var Steps_default2 = Steps3;

// ../../node_modules/antd/es/progress/progress.js
var __rest59 = function(s, e3) {
  var t2 = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e3.indexOf(p) < 0) t2[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e3.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t2[p[i]] = s[p[i]];
  }
  return t2;
};
var ProgressStatuses = ["normal", "exception", "active", "success"];
var Progress2 = /* @__PURE__ */ React411.forwardRef((props, ref3) => {
  const {
    prefixCls: customizePrefixCls,
    className: className2,
    rootClassName,
    steps,
    strokeColor,
    percent = 0,
    size = "default",
    showInfo = true,
    type: type5 = "line",
    status,
    format: format3,
    style: style2,
    percentPosition = {}
  } = props, restProps = __rest59(props, ["prefixCls", "className", "rootClassName", "steps", "strokeColor", "percent", "size", "showInfo", "type", "status", "format", "style", "percentPosition"]);
  const {
    align: infoAlign = "end",
    type: infoPosition = "outer"
  } = percentPosition;
  const strokeColorNotArray = Array.isArray(strokeColor) ? strokeColor[0] : strokeColor;
  const strokeColorNotGradient = typeof strokeColor === "string" || Array.isArray(strokeColor) ? strokeColor : void 0;
  const strokeColorIsBright = React411.useMemo(() => {
    if (strokeColorNotArray) {
      const color = typeof strokeColorNotArray === "string" ? strokeColorNotArray : Object.values(strokeColorNotArray)[0];
      return new FastColor(color).isLight();
    }
    return false;
  }, [strokeColor]);
  const percentNumber = React411.useMemo(() => {
    var _a, _b;
    const successPercent = getSuccessPercent(props);
    return parseInt(successPercent !== void 0 ? (_a = successPercent !== null && successPercent !== void 0 ? successPercent : 0) === null || _a === void 0 ? void 0 : _a.toString() : (_b = percent !== null && percent !== void 0 ? percent : 0) === null || _b === void 0 ? void 0 : _b.toString(), 10);
  }, [percent, props.success, props.successPercent]);
  const progressStatus = React411.useMemo(() => {
    if (!ProgressStatuses.includes(status) && percentNumber >= 100) {
      return "success";
    }
    return status || "normal";
  }, [status, percentNumber]);
  const {
    getPrefixCls,
    direction,
    progress: progressStyle
  } = React411.useContext(ConfigContext);
  const prefixCls = getPrefixCls("progress", customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = style_default31(prefixCls);
  const isLineType = type5 === "line";
  const isPureLineType = isLineType && !steps;
  const progressInfo = React411.useMemo(() => {
    if (!showInfo) {
      return null;
    }
    const successPercent = getSuccessPercent(props);
    let text;
    const textFormatter = format3 || ((number4) => `${number4}%`);
    const isBrightInnerColor = isLineType && strokeColorIsBright && infoPosition === "inner";
    if (infoPosition === "inner" || format3 || progressStatus !== "exception" && progressStatus !== "success") {
      text = textFormatter(validProgress(percent), validProgress(successPercent));
    } else if (progressStatus === "exception") {
      text = isLineType ? /* @__PURE__ */ React411.createElement(CloseCircleFilled_default2, null) : /* @__PURE__ */ React411.createElement(CloseOutlined_default2, null);
    } else if (progressStatus === "success") {
      text = isLineType ? /* @__PURE__ */ React411.createElement(CheckCircleFilled_default2, null) : /* @__PURE__ */ React411.createElement(CheckOutlined_default2, null);
    }
    return /* @__PURE__ */ React411.createElement("span", {
      className: (0, import_classnames168.default)(`${prefixCls}-text`, {
        [`${prefixCls}-text-bright`]: isBrightInnerColor,
        [`${prefixCls}-text-${infoAlign}`]: isPureLineType,
        [`${prefixCls}-text-${infoPosition}`]: isPureLineType
      }),
      title: typeof text === "string" ? text : void 0
    }, text);
  }, [showInfo, percent, percentNumber, progressStatus, type5, prefixCls, format3]);
  if (true) {
    const warning6 = devUseWarning("Progress");
    warning6.deprecated(!("successPercent" in props), "successPercent", "success.percent");
    warning6.deprecated(!("width" in props), "width", "size");
    if (type5 === "circle" || type5 === "dashboard") {
      if (Array.isArray(size)) {
        true ? warning6(false, "usage", 'Type "circle" and "dashboard" do not accept array as `size`, please use number or preset size instead.') : void 0;
      } else if (typeof size === "object") {
        true ? warning6(false, "usage", 'Type "circle" and "dashboard" do not accept object as `size`, please use number or preset size instead.') : void 0;
      }
    }
    if (props.success && "progress" in props.success) {
      warning6.deprecated(false, "success.progress", "success.percent");
    }
  }
  let progress;
  if (type5 === "line") {
    progress = steps ? /* @__PURE__ */ React411.createElement(Steps_default2, Object.assign({}, props, {
      strokeColor: strokeColorNotGradient,
      prefixCls,
      steps: typeof steps === "object" ? steps.count : steps
    }), progressInfo) : /* @__PURE__ */ React411.createElement(Line_default2, Object.assign({}, props, {
      strokeColor: strokeColorNotArray,
      prefixCls,
      direction,
      percentPosition: {
        align: infoAlign,
        type: infoPosition
      }
    }), progressInfo);
  } else if (type5 === "circle" || type5 === "dashboard") {
    progress = /* @__PURE__ */ React411.createElement(Circle_default2, Object.assign({}, props, {
      strokeColor: strokeColorNotArray,
      prefixCls,
      progressStatus
    }), progressInfo);
  }
  const classString = (0, import_classnames168.default)(prefixCls, `${prefixCls}-status-${progressStatus}`, {
    [`${prefixCls}-${type5 === "dashboard" && "circle" || type5}`]: type5 !== "line",
    [`${prefixCls}-inline-circle`]: type5 === "circle" && getSize3(size, "circle")[0] <= 20,
    [`${prefixCls}-line`]: isPureLineType,
    [`${prefixCls}-line-align-${infoAlign}`]: isPureLineType,
    [`${prefixCls}-line-position-${infoPosition}`]: isPureLineType,
    [`${prefixCls}-steps`]: steps,
    [`${prefixCls}-show-info`]: showInfo,
    [`${prefixCls}-${size}`]: typeof size === "string",
    [`${prefixCls}-rtl`]: direction === "rtl"
  }, progressStyle === null || progressStyle === void 0 ? void 0 : progressStyle.className, className2, rootClassName, hashId, cssVarCls);
  return wrapCSSVar(/* @__PURE__ */ React411.createElement("div", Object.assign({
    ref: ref3,
    style: Object.assign(Object.assign({}, progressStyle === null || progressStyle === void 0 ? void 0 : progressStyle.style), style2),
    className: classString,
    role: "progressbar",
    "aria-valuenow": percentNumber,
    "aria-valuemin": 0,
    "aria-valuemax": 100
  }, omit(restProps, ["trailColor", "strokeWidth", "width", "gapDegree", "gapPosition", "strokeLinecap", "success", "successPercent"])), progress));
});
if (true) {
  Progress2.displayName = "Progress";
}
var progress_default = Progress2;

// ../../node_modules/antd/es/progress/index.js
var progress_default2 = progress_default;

// ../../node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js
function _createForOfIteratorHelper(r2, e3) {
  var t2 = "undefined" != typeof Symbol && r2[Symbol.iterator] || r2["@@iterator"];
  if (!t2) {
    if (Array.isArray(r2) || (t2 = _unsupportedIterableToArray(r2)) || e3 && r2 && "number" == typeof r2.length) {
      t2 && (r2 = t2);
      var _n = 0, F = function F2() {
      };
      return {
        s: F,
        n: function n2() {
          return _n >= r2.length ? {
            done: true
          } : {
            done: false,
            value: r2[_n++]
          };
        },
        e: function e4(r3) {
          throw r3;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o3, a = true, u = false;
  return {
    s: function s() {
      t2 = t2.call(r2);
    },
    n: function n2() {
      var r3 = t2.next();
      return a = r3.done, r3;
    },
    e: function e4(r3) {
      u = true, o3 = r3;
    },
    f: function f() {
      try {
        a || null == t2["return"] || t2["return"]();
      } finally {
        if (u) throw o3;
      }
    }
  };
}

// ../../node_modules/antd/es/rate/index.js
var React416 = __toESM(require_react());

// ../../node_modules/@ant-design/icons/es/icons/StarFilled.js
var React412 = __toESM(require_react());

// ../../node_modules/@ant-design/icons-svg/es/asn/StarFilled.js
var StarFilled = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 00.6 45.3l183.7 179.1-43.4 252.9a31.95 31.95 0 0046.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3z" } }] }, "name": "star", "theme": "filled" };
var StarFilled_default = StarFilled;

// ../../node_modules/@ant-design/icons/es/icons/StarFilled.js
var StarFilled2 = function StarFilled3(props, ref3) {
  return /* @__PURE__ */ React412.createElement(AntdIcon_default, _extends({}, props, {
    ref: ref3,
    icon: StarFilled_default
  }));
};
var RefIcon29 = /* @__PURE__ */ React412.forwardRef(StarFilled2);
if (true) {
  RefIcon29.displayName = "StarFilled";
}
var StarFilled_default2 = RefIcon29;

// ../../node_modules/antd/es/rate/index.js
var import_classnames171 = __toESM(require_classnames());

// ../../node_modules/rc-rate/es/Rate.js
var import_classnames170 = __toESM(require_classnames());
var import_react137 = __toESM(require_react());

// ../../node_modules/rc-rate/es/Star.js
var import_react136 = __toESM(require_react());
var import_classnames169 = __toESM(require_classnames());
function Star(props, ref3) {
  var disabled = props.disabled, prefixCls = props.prefixCls, character2 = props.character, characterRender = props.characterRender, index3 = props.index, count = props.count, value = props.value, allowHalf = props.allowHalf, focused = props.focused, onHover = props.onHover, onClick = props.onClick;
  var onInternalHover = function onInternalHover2(e3) {
    onHover(e3, index3);
  };
  var onInternalClick = function onInternalClick2(e3) {
    onClick(e3, index3);
  };
  var onInternalKeyDown = function onInternalKeyDown2(e3) {
    if (e3.keyCode === KeyCode_default.ENTER) {
      onClick(e3, index3);
    }
  };
  var starValue = index3 + 1;
  var classNameList = /* @__PURE__ */ new Set([prefixCls]);
  if (value === 0 && index3 === 0 && focused) {
    classNameList.add("".concat(prefixCls, "-focused"));
  } else if (allowHalf && value + 0.5 >= starValue && value < starValue) {
    classNameList.add("".concat(prefixCls, "-half"));
    classNameList.add("".concat(prefixCls, "-active"));
    if (focused) {
      classNameList.add("".concat(prefixCls, "-focused"));
    }
  } else {
    if (starValue <= value) {
      classNameList.add("".concat(prefixCls, "-full"));
    } else {
      classNameList.add("".concat(prefixCls, "-zero"));
    }
    if (starValue === value && focused) {
      classNameList.add("".concat(prefixCls, "-focused"));
    }
  }
  var characterNode = typeof character2 === "function" ? character2(props) : character2;
  var start = /* @__PURE__ */ import_react136.default.createElement("li", {
    className: (0, import_classnames169.default)(Array.from(classNameList)),
    ref: ref3
  }, /* @__PURE__ */ import_react136.default.createElement("div", {
    onClick: disabled ? null : onInternalClick,
    onKeyDown: disabled ? null : onInternalKeyDown,
    onMouseMove: disabled ? null : onInternalHover,
    role: "radio",
    "aria-checked": value > index3 ? "true" : "false",
    "aria-posinset": index3 + 1,
    "aria-setsize": count,
    tabIndex: disabled ? -1 : 0
  }, /* @__PURE__ */ import_react136.default.createElement("div", {
    className: "".concat(prefixCls, "-first")
  }, characterNode), /* @__PURE__ */ import_react136.default.createElement("div", {
    className: "".concat(prefixCls, "-second")
  }, characterNode)));
  if (characterRender) {
    start = characterRender(start, props);
  }
  return start;
}
var Star_default = /* @__PURE__ */ import_react136.default.forwardRef(Star);

// ../../node_modules/rc-rate/es/useRefs.js
var React414 = __toESM(require_react());
function useRefs() {
  var nodeRef = React414.useRef({});
  function getRef(index3) {
    return nodeRef.current[index3];
  }
  function setRef(index3) {
    return function(node2) {
      nodeRef.current[index3] = node2;
    };
  }
  return [getRef, setRef];
}

// ../../node_modules/rc-rate/es/util.js
function getScroll3(w) {
  var ret = w.pageXOffset;
  var method4 = "scrollLeft";
  if (typeof ret !== "number") {
    var d = w.document;
    ret = d.documentElement[method4];
    if (typeof ret !== "number") {
      ret = d.body[method4];
    }
  }
  return ret;
}
function getClientPosition(elem) {
  var x;
  var y;
  var doc2 = elem.ownerDocument;
  var body = doc2.body;
  var docElem = doc2 && doc2.documentElement;
  var box2 = elem.getBoundingClientRect();
  x = box2.left;
  y = box2.top;
  x -= docElem.clientLeft || body.clientLeft || 0;
  y -= docElem.clientTop || body.clientTop || 0;
  return {
    left: x,
    top: y
  };
}
function getOffsetLeft(el) {
  var pos = getClientPosition(el);
  var doc2 = el.ownerDocument;
  var w = doc2.defaultView || doc2.parentWindow;
  pos.left += getScroll3(w);
  return pos.left;
}

// ../../node_modules/rc-rate/es/Rate.js
var _excluded62 = ["prefixCls", "className", "defaultValue", "value", "count", "allowHalf", "allowClear", "keyboard", "character", "characterRender", "disabled", "direction", "tabIndex", "autoFocus", "onHoverChange", "onChange", "onFocus", "onBlur", "onKeyDown", "onMouseLeave"];
function Rate(props, ref3) {
  var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-rate" : _props$prefixCls, className2 = props.className, defaultValue2 = props.defaultValue, propValue = props.value, _props$count = props.count, count = _props$count === void 0 ? 5 : _props$count, _props$allowHalf = props.allowHalf, allowHalf = _props$allowHalf === void 0 ? false : _props$allowHalf, _props$allowClear = props.allowClear, allowClear = _props$allowClear === void 0 ? true : _props$allowClear, _props$keyboard = props.keyboard, keyboard = _props$keyboard === void 0 ? true : _props$keyboard, _props$character = props.character, character2 = _props$character === void 0 ? "\u2605" : _props$character, characterRender = props.characterRender, disabled = props.disabled, _props$direction = props.direction, direction = _props$direction === void 0 ? "ltr" : _props$direction, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, autoFocus = props.autoFocus, onHoverChange = props.onHoverChange, onChange = props.onChange, onFocus = props.onFocus, onBlur = props.onBlur, onKeyDown2 = props.onKeyDown, onMouseLeave = props.onMouseLeave, restProps = _objectWithoutProperties(props, _excluded62);
  var _useRefs = useRefs(), _useRefs2 = _slicedToArray(_useRefs, 2), getStarRef = _useRefs2[0], setStarRef = _useRefs2[1];
  var rateRef = import_react137.default.useRef(null);
  var triggerFocus2 = function triggerFocus3() {
    if (!disabled) {
      var _rateRef$current;
      (_rateRef$current = rateRef.current) === null || _rateRef$current === void 0 || _rateRef$current.focus();
    }
  };
  import_react137.default.useImperativeHandle(ref3, function() {
    return {
      focus: triggerFocus2,
      blur: function blur() {
        if (!disabled) {
          var _rateRef$current2;
          (_rateRef$current2 = rateRef.current) === null || _rateRef$current2 === void 0 || _rateRef$current2.blur();
        }
      }
    };
  });
  var _useMergedState = useMergedState(defaultValue2 || 0, {
    value: propValue
  }), _useMergedState2 = _slicedToArray(_useMergedState, 2), value = _useMergedState2[0], setValue = _useMergedState2[1];
  var _useMergedState3 = useMergedState(null), _useMergedState4 = _slicedToArray(_useMergedState3, 2), cleanedValue = _useMergedState4[0], setCleanedValue = _useMergedState4[1];
  var getStarValue = function getStarValue2(index3, x) {
    var reverse = direction === "rtl";
    var starValue = index3 + 1;
    if (allowHalf) {
      var starEle = getStarRef(index3);
      var leftDis = getOffsetLeft(starEle);
      var width = starEle.clientWidth;
      if (reverse && x - leftDis > width / 2) {
        starValue -= 0.5;
      } else if (!reverse && x - leftDis < width / 2) {
        starValue -= 0.5;
      }
    }
    return starValue;
  };
  var changeValue = function changeValue2(nextValue) {
    setValue(nextValue);
    onChange === null || onChange === void 0 || onChange(nextValue);
  };
  var _React$useState = import_react137.default.useState(false), _React$useState2 = _slicedToArray(_React$useState, 2), focused = _React$useState2[0], setFocused = _React$useState2[1];
  var onInternalFocus = function onInternalFocus2() {
    setFocused(true);
    onFocus === null || onFocus === void 0 || onFocus();
  };
  var onInternalBlur = function onInternalBlur2() {
    setFocused(false);
    onBlur === null || onBlur === void 0 || onBlur();
  };
  var _React$useState3 = import_react137.default.useState(null), _React$useState4 = _slicedToArray(_React$useState3, 2), hoverValue = _React$useState4[0], setHoverValue = _React$useState4[1];
  var onHover = function onHover2(event, index3) {
    var nextHoverValue = getStarValue(index3, event.pageX);
    if (nextHoverValue !== cleanedValue) {
      setHoverValue(nextHoverValue);
      setCleanedValue(null);
    }
    onHoverChange === null || onHoverChange === void 0 || onHoverChange(nextHoverValue);
  };
  var onMouseLeaveCallback = function onMouseLeaveCallback2(event) {
    if (!disabled) {
      setHoverValue(null);
      setCleanedValue(null);
      onHoverChange === null || onHoverChange === void 0 || onHoverChange(void 0);
    }
    if (event) {
      onMouseLeave === null || onMouseLeave === void 0 || onMouseLeave(event);
    }
  };
  var onClick = function onClick2(event, index3) {
    var newValue = getStarValue(index3, event.pageX);
    var isReset = false;
    if (allowClear) {
      isReset = newValue === value;
    }
    onMouseLeaveCallback();
    changeValue(isReset ? 0 : newValue);
    setCleanedValue(isReset ? newValue : null);
  };
  var onInternalKeyDown = function onInternalKeyDown2(event) {
    var keyCode = event.keyCode;
    var reverse = direction === "rtl";
    var step = allowHalf ? 0.5 : 1;
    if (keyboard) {
      if (keyCode === KeyCode_default.RIGHT && value < count && !reverse) {
        changeValue(value + step);
        event.preventDefault();
      } else if (keyCode === KeyCode_default.LEFT && value > 0 && !reverse) {
        changeValue(value - step);
        event.preventDefault();
      } else if (keyCode === KeyCode_default.RIGHT && value > 0 && reverse) {
        changeValue(value - step);
        event.preventDefault();
      } else if (keyCode === KeyCode_default.LEFT && value < count && reverse) {
        changeValue(value + step);
        event.preventDefault();
      }
    }
    onKeyDown2 === null || onKeyDown2 === void 0 || onKeyDown2(event);
  };
  import_react137.default.useEffect(function() {
    if (autoFocus && !disabled) {
      triggerFocus2();
    }
  }, []);
  var starNodes = new Array(count).fill(0).map(function(item, index3) {
    return /* @__PURE__ */ import_react137.default.createElement(Star_default, {
      ref: setStarRef(index3),
      index: index3,
      count,
      disabled,
      prefixCls: "".concat(prefixCls, "-star"),
      allowHalf,
      value: hoverValue === null ? value : hoverValue,
      onClick,
      onHover,
      key: item || index3,
      character: character2,
      characterRender,
      focused
    });
  });
  var classString = (0, import_classnames170.default)(prefixCls, className2, _defineProperty(_defineProperty({}, "".concat(prefixCls, "-disabled"), disabled), "".concat(prefixCls, "-rtl"), direction === "rtl"));
  return /* @__PURE__ */ import_react137.default.createElement("ul", _extends({
    className: classString,
    onMouseLeave: onMouseLeaveCallback,
    tabIndex: disabled ? -1 : tabIndex,
    onFocus: disabled ? null : onInternalFocus,
    onBlur: disabled ? null : onInternalBlur,
    onKeyDown: disabled ? null : onInternalKeyDown,
    ref: rateRef
  }, pickAttrs(restProps, {
    aria: true,
    data: true,
    attr: true
  })), starNodes);
}
var Rate_default = /* @__PURE__ */ import_react137.default.forwardRef(Rate);

// ../../node_modules/rc-rate/es/index.js
var es_default25 = Rate_default;

// ../../node_modules/antd/es/rate/style/index.js
var genRateStarStyle = (token2) => {
  const {
    componentCls
  } = token2;
  return {
    [`${componentCls}-star`]: {
      position: "relative",
      display: "inline-block",
      color: "inherit",
      cursor: "pointer",
      "&:not(:last-child)": {
        marginInlineEnd: token2.marginXS
      },
      "> div": {
        transition: `all ${token2.motionDurationMid}, outline 0s`,
        "&:hover": {
          transform: token2.starHoverScale
        },
        "&:focus": {
          outline: 0
        },
        "&:focus-visible": {
          outline: `${unit(token2.lineWidth)} dashed ${token2.starColor}`,
          transform: token2.starHoverScale
        }
      },
      "&-first, &-second": {
        color: token2.starBg,
        transition: `all ${token2.motionDurationMid}`,
        userSelect: "none"
      },
      "&-first": {
        position: "absolute",
        top: 0,
        insetInlineStart: 0,
        width: "50%",
        height: "100%",
        overflow: "hidden",
        opacity: 0
      },
      [`&-half ${componentCls}-star-first, &-half ${componentCls}-star-second`]: {
        opacity: 1
      },
      [`&-half ${componentCls}-star-first, &-full ${componentCls}-star-second`]: {
        color: "inherit"
      }
    }
  };
};
var genRateRtlStyle = (token2) => ({
  [`&-rtl${token2.componentCls}`]: {
    direction: "rtl"
  }
});
var genRateStyle = (token2) => {
  const {
    componentCls
  } = token2;
  return {
    [componentCls]: Object.assign(Object.assign(Object.assign(Object.assign({}, resetComponent(token2)), {
      display: "inline-block",
      margin: 0,
      padding: 0,
      color: token2.starColor,
      fontSize: token2.starSize,
      lineHeight: 1,
      listStyle: "none",
      outline: "none",
      // disable styles
      [`&-disabled${componentCls} ${componentCls}-star`]: {
        cursor: "default",
        "> div:hover": {
          transform: "scale(1)"
        }
      }
    }), genRateStarStyle(token2)), genRateRtlStyle(token2))
  };
};
var prepareComponentToken27 = (token2) => ({
  starColor: token2.yellow6,
  starSize: token2.controlHeightLG * 0.5,
  starHoverScale: "scale(1.1)",
  starBg: token2.colorFillContent
});
var style_default32 = genStyleHooks("Rate", (token2) => {
  const rateToken = merge2(token2, {});
  return genRateStyle(rateToken);
}, prepareComponentToken27);

// ../../node_modules/antd/es/rate/index.js
var __rest60 = function(s, e3) {
  var t2 = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e3.indexOf(p) < 0) t2[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e3.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t2[p[i]] = s[p[i]];
  }
  return t2;
};
var Rate2 = /* @__PURE__ */ React416.forwardRef((props, ref3) => {
  const {
    prefixCls,
    className: className2,
    rootClassName,
    style: style2,
    tooltips,
    character: character2 = /* @__PURE__ */ React416.createElement(StarFilled_default2, null),
    disabled: customDisabled
  } = props, rest = __rest60(props, ["prefixCls", "className", "rootClassName", "style", "tooltips", "character", "disabled"]);
  const characterRender = (node2, {
    index: index3
  }) => {
    if (!tooltips) {
      return node2;
    }
    return /* @__PURE__ */ React416.createElement(tooltip_default, {
      title: tooltips[index3]
    }, node2);
  };
  const {
    getPrefixCls,
    direction,
    rate
  } = React416.useContext(ConfigContext);
  const ratePrefixCls = getPrefixCls("rate", prefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = style_default32(ratePrefixCls);
  const mergedStyle = Object.assign(Object.assign({}, rate === null || rate === void 0 ? void 0 : rate.style), style2);
  const disabled = React416.useContext(DisabledContext_default);
  const mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
  return wrapCSSVar(/* @__PURE__ */ React416.createElement(es_default25, Object.assign({
    ref: ref3,
    character: character2,
    characterRender,
    disabled: mergedDisabled
  }, rest, {
    className: (0, import_classnames171.default)(className2, rootClassName, hashId, cssVarCls, rate === null || rate === void 0 ? void 0 : rate.className),
    style: mergedStyle,
    prefixCls: ratePrefixCls,
    direction
  })));
});
if (true) {
  Rate2.displayName = "Rate";
}
var rate_default = Rate2;

// ../../node_modules/antd/es/result/index.js
var React421 = __toESM(require_react());

// ../../node_modules/@ant-design/icons/es/icons/WarningFilled.js
var React417 = __toESM(require_react());

// ../../node_modules/@ant-design/icons-svg/es/asn/WarningFilled.js
var WarningFilled = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M955.7 856l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zM480 416c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v184c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V416zm32 352a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, "name": "warning", "theme": "filled" };
var WarningFilled_default = WarningFilled;

// ../../node_modules/@ant-design/icons/es/icons/WarningFilled.js
var WarningFilled2 = function WarningFilled3(props, ref3) {
  return /* @__PURE__ */ React417.createElement(AntdIcon_default, _extends({}, props, {
    ref: ref3,
    icon: WarningFilled_default
  }));
};
var RefIcon30 = /* @__PURE__ */ React417.forwardRef(WarningFilled2);
if (true) {
  RefIcon30.displayName = "WarningFilled";
}
var WarningFilled_default2 = RefIcon30;

// ../../node_modules/antd/es/result/index.js
var import_classnames172 = __toESM(require_classnames());

// ../../node_modules/antd/es/result/noFound.js
var React418 = __toESM(require_react());
var NoFound = () => /* @__PURE__ */ React418.createElement("svg", {
  width: "252",
  height: "294"
}, /* @__PURE__ */ React418.createElement("title", null, "No Found"), /* @__PURE__ */ React418.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /* @__PURE__ */ React418.createElement("circle", {
  cx: "126.75",
  cy: "128.1",
  r: "126",
  fill: "#E4EBF7"
}), /* @__PURE__ */ React418.createElement("circle", {
  cx: "31.55",
  cy: "130.8",
  r: "8.3",
  fill: "#FFF"
}), /* @__PURE__ */ React418.createElement("path", {
  stroke: "#FFF",
  d: "m37 134.3 10.5 6m.9 6.2-12.7 10.8",
  strokeWidth: "2"
}), /* @__PURE__ */ React418.createElement("path", {
  fill: "#FFF",
  d: "M39.9 159.4a5.7 5.7 0 1 1-11.3-1.2 5.7 5.7 0 0 1 11.3 1.2m17.7-16.2a5.7 5.7 0 1 1-11.4-1.1 5.7 5.7 0 0 1 11.4 1.1M99 27h29.8a4.6 4.6 0 1 0 0-9.2H99a4.6 4.6 0 1 0 0 9.2m11.4 18.3h29.8a4.6 4.6 0 0 0 0-9.2h-29.8a4.6 4.6 0 1 0 0 9.2"
}), /* @__PURE__ */ React418.createElement("path", {
  fill: "#FFF",
  d: "M112.8 26.9h15.8a4.6 4.6 0 1 0 0 9.1h-15.8a4.6 4.6 0 0 0 0-9.1m71.7 108.8a10 10 0 1 1-19.8-2 10 10 0 0 1 19.8 2"
}), /* @__PURE__ */ React418.createElement("path", {
  stroke: "#FFF",
  d: "m179.3 141.8 12.6 7.1m1.1 7.6-15.2 13",
  strokeWidth: "2"
}), /* @__PURE__ */ React418.createElement("path", {
  fill: "#FFF",
  d: "M184.7 170a6.8 6.8 0 1 1-13.6-1.3 6.8 6.8 0 0 1 13.6 1.4m18.6-16.8a6.9 6.9 0 1 1-13.7-1.4 6.9 6.9 0 0 1 13.7 1.4"
}), /* @__PURE__ */ React418.createElement("path", {
  stroke: "#FFF",
  d: "M152 192.3a2.2 2.2 0 1 1-4.5 0 2.2 2.2 0 0 1 4.4 0zm73.3-76.2a2.2 2.2 0 1 1-4.5 0 2.2 2.2 0 0 1 4.5 0zm-9 35a2.2 2.2 0 1 1-4.4 0 2.2 2.2 0 0 1 4.5 0zM177 107.6a2.2 2.2 0 1 1-4.4 0 2.2 2.2 0 0 1 4.4 0zm18.4-15.4a2.2 2.2 0 1 1-4.5 0 2.2 2.2 0 0 1 4.5 0zm6.8 88.5a2.2 2.2 0 1 1-4.5 0 2.2 2.2 0 0 1 4.5 0z",
  strokeWidth: "2"
}), /* @__PURE__ */ React418.createElement("path", {
  stroke: "#FFF",
  d: "m214.4 153.3-2 20.2-10.8 6m-28-4.7-6.3 9.8H156l-4.5 6.5m23.5-66v-15.7m46 7.8-13 8-15.2-8V94.4",
  strokeWidth: "2"
}), /* @__PURE__ */ React418.createElement("path", {
  fill: "#FFF",
  d: "M166.6 66h-4a4.8 4.8 0 0 1-4.7-4.8 4.8 4.8 0 0 1 4.7-4.7h4a4.8 4.8 0 0 1 4.7 4.7 4.8 4.8 0 0 1-4.7 4.7"
}), /* @__PURE__ */ React418.createElement("circle", {
  cx: "204.3",
  cy: "30",
  r: "29.5",
  fill: "#1677ff"
}), /* @__PURE__ */ React418.createElement("path", {
  fill: "#FFF",
  d: "M206 38.4c.5.5.7 1.1.7 2s-.2 1.4-.7 1.9a3 3 0 0 1-2 .7c-.8 0-1.5-.3-2-.8s-.8-1.1-.8-1.9.3-1.4.8-2c.5-.4 1.2-.7 2-.7.7 0 1.4.3 2 .8m4.2-19.5c1.5 1.3 2.2 3 2.2 5.2a7.2 7.2 0 0 1-1.5 4.5l-3 2.7a5 5 0 0 0-1.3 1.7 5.2 5.2 0 0 0-.6 2.4v.5h-4v-.5c0-1.4.1-2.5.6-3.5s1.9-2.5 4.2-4.5l.4-.5a4 4 0 0 0 1-2.6c0-1.2-.4-2-1-2.8-.7-.6-1.6-1-2.9-1-1.5 0-2.6.5-3.3 1.5-.4.5-.6 1-.8 1.9a2 2 0 0 1-2 1.6 2 2 0 0 1-2-2.4c.4-1.6 1-2.8 2.1-3.8a8.5 8.5 0 0 1 6.3-2.3c2.3 0 4.2.6 5.6 2"
}), /* @__PURE__ */ React418.createElement("path", {
  fill: "#FFB594",
  d: "M52 76.1s21.8 5.4 27.3 16c5.6 10.7-6.3 9.2-15.7 5C52.8 92 39 85 52 76"
}), /* @__PURE__ */ React418.createElement("path", {
  fill: "#FFC6A0",
  d: "m90.5 67.5-.5 2.9c-.7.5-4.7-2.7-4.7-2.7l-1.7.8-1.3-5.7s6.8-4.6 9-5c2.4-.5 9.8 1 10.6 2.3 0 0 1.3.4-2.2.6-3.6.3-5 .5-6.8 3.2l-2.4 3.6"
}), /* @__PURE__ */ React418.createElement("path", {
  fill: "#FFF",
  d: "M128 111.4a36.7 36.7 0 0 0-8.9-15.5c-3.5-3-9.3-2.2-11.3-4.2-1.3-1.2-3.2-1.2-3.2-1.2L87.7 87c-2.3-.4-2.1-.7-6-1.4-1.6-1.9-3-1.1-3-1.1l-7-1.4c-1-1.5-2.5-1-2.5-1l-2.4-.9C65 91.2 59 95 59 95c1.8 1.1 15.7 8.3 15.7 8.3l5.1 37.1s-3.3 5.7 1.4 9.1c0 0 19.9-3.7 34.9-.3 0 0 3-2.6 1-8.8.5-3 1.4-8.3 1.7-11.6.4.7 2 1.9 3.1 3.4 0 0 9.4-7.3 11-14a17 17 0 0 1-2.2-2.4c-.5-.8-.3-2-.7-2.8-.7-1-1.8-1.3-2-1.6"
}), /* @__PURE__ */ React418.createElement("path", {
  fill: "#CBD1D1",
  d: "M101 290s4.4 2 7.4 1c2.9-1 4.6.7 7.1 1.2 2.6.5 6.9 1.1 11.7-1.3 0-5.5-6.9-4-12-6.7-2.5-1.4-3.7-4.7-3.5-8.8h-9.5s-1.2 10.6-1 14.6"
}), /* @__PURE__ */ React418.createElement("path", {
  fill: "#2B0849",
  d: "M101 289.8s2.5 1.3 6.8.7c3-.5 3.7.5 7.4 1 3.8.6 10.8 0 11.9-.9.4 1.1-.4 2-.4 2s-1.5.7-4.8.9c-2 .1-5.8.3-7.6-.5-1.8-1.4-5.2-1.9-5.7-.2-4 1-7.4-.3-7.4-.3l-.1-2.7z"
}), /* @__PURE__ */ React418.createElement("path", {
  fill: "#A4AABA",
  d: "M108.3 276h3.1s0 6.7 4.6 8.6c-4.7.6-8.6-2.3-7.7-8.6"
}), /* @__PURE__ */ React418.createElement("path", {
  fill: "#CBD1D1",
  d: "M57.5 272.4s-2 7.4-4.4 12.3c-1.8 3.7-4.3 7.5 5.4 7.5 6.7 0 9-.5 7.4-6.6-1.5-6.1.3-13.2.3-13.2h-8.7z"
}), /* @__PURE__ */ React418.createElement("path", {
  fill: "#2B0849",
  d: "M51.5 289.8s2 1.2 6.6 1.2c6 0 8.3-1.7 8.3-1.7s.6 1.1-.7 2.2c-1 .8-3.6 1.6-7.4 1.5-4.1 0-5.8-.5-6.7-1.1-.8-.6-.7-1.6-.1-2.1"
}), /* @__PURE__ */ React418.createElement("path", {
  fill: "#A4AABA",
  d: "M58.4 274.3s0 1.5-.3 3c-.3 1.4-1 3-1.1 4 0 1.2 4.5 1.7 5.1.1.6-1.5 1.3-6.4 2-7.2.6-.9-5-2.2-5.7.1"
}), /* @__PURE__ */ React418.createElement("path", {
  fill: "#7BB2F9",
  d: "m99.7 278.5 13.3.1s1.3-54.5 1.9-64.4c.5-9.9 3.8-43.4 1-63.1l-12.6-.7-22.8.8-1.2 10c0 .5-.7.8-.7 1.4-.1.5.4 1.3.3 2-2.4 14-6.4 33-8.8 46.6 0 .7-1.2 1-1.4 2.7 0 .3.2 1.5 0 1.8-6.8 18.7-10.9 47.8-14.2 61.9h14.6s2.2-8.6 4-17c2.9-12.9 23.2-85 23.2-85l3-.5 1 46.3s-.2 1.2.4 2c.5.8-.6 1.1-.4 2.3l.4 1.8-1 11.8c-.4 4.8 0 39.2 0 39.2"
}), /* @__PURE__ */ React418.createElement("path", {
  stroke: "#648BD8",
  d: "M76 221.6c1.2.1 4.1-2 7-5m23.4 8.5s2.7-1 6-3.8",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1"
}), /* @__PURE__ */ React418.createElement("path", {
  stroke: "#648BD8",
  d: "M107.3 222.1s2.7-1.1 6-3.9",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ React418.createElement("path", {
  stroke: "#648BD8",
  d: "M74.7 224.8s2.7-.6 6.5-3.4m4.8-69.8c-.2 3.1.3 8.6-4.3 9.2m22-11s0 14-1.4 15.1a15 15 0 0 1-3 2m.5-16.5s0 13-1.2 24.4m-5 1.1s7.3-1.7 9.5-1.7M74.3 206a212 212 0 0 1-1 4.5s-1.4 1.9-1 3.8c.5 2-1 2-5 15.4A353 353 0 0 0 61 257l-.2 1.2m14.9-60.5a321 321 0 0 1-.9 4.8m7.8-50.4-1.2 10.5s-1.1.1-.5 2.2c.1 1.4-2.7 15.8-5.2 30.5m-19.6 79h13.3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1"
}), /* @__PURE__ */ React418.createElement("path", {
  fill: "#192064",
  d: "M116.2 148.2s-17-3-35.9.2c.2 2.5 0 4.2 0 4.2s14.7-2.8 35.7-.3c.3-2.4.2-4 .2-4"
}), /* @__PURE__ */ React418.createElement("path", {
  fill: "#FFF",
  d: "M106.3 151.2v-5a.8.8 0 0 0-.8-.8h-7.8a.8.8 0 0 0-.8.8v5a.8.8 0 0 0 .8.8h7.8a.8.8 0 0 0 .8-.8"
}), /* @__PURE__ */ React418.createElement("path", {
  fill: "#192064",
  d: "M105.2 150.2v-3a.6.6 0 0 0-.6-.7 94.3 94.3 0 0 0-5.9 0 .7.7 0 0 0-.6.6v3.1a.6.6 0 0 0 .6.7 121.1 121.1 0 0 1 5.8 0c.4 0 .7-.3.7-.7"
}), /* @__PURE__ */ React418.createElement("path", {
  stroke: "#648BD8",
  d: "M100.3 275.4h12.3m-11.2-4.9.1 6.5m0-12.5a915.8 915.8 0 0 0 0 4.4m-.5-94 .9 44.7s.7 1.6-.2 2.7c-1 1.1 2.4.7.9 2.2-1.6 1.6.9 1.2 0 3.4-.6 1.5-1 21.1-1.1 35.2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1"
}), /* @__PURE__ */ React418.createElement("path", {
  fill: "#FFC6A0",
  d: "M46.9 83.4s-.5 6 7.2 5.6c11.2-.7 9.2-9.4 31.5-21.7-.7-2.7-2.4-4.7-2.4-4.7s-11 3-22.6 8c-6.8 3-13.4 6.4-13.7 12.8m57.6 7.7.9-5.4-8.9-11.4-5 5.3-1.8 7.9a.3.3 0 0 0 .1.3c1 .8 6.5 5 14.4 3.5a.3.3 0 0 0 .3-.2"
}), /* @__PURE__ */ React418.createElement("path", {
  fill: "#FFC6A0",
  d: "M94 79.4s-4.6-2.9-2.5-6.9c1.6-3 4.5 1.2 4.5 1.2s.5-3.7 3.1-3.7c.6-1 1.6-4.1 1.6-4.1l13.5 3c0 5.3-2.3 19.5-7.8 20-8.9.6-12.5-9.5-12.5-9.5"
}), /* @__PURE__ */ React418.createElement("path", {
  fill: "#520038",
  d: "M113.9 73.4c2.6-2 3.4-9.7 3.4-9.7s-2.4-.5-6.6-2c-4.7-2.1-12.8-4.8-17.5 1-9.6 3.2-2 19.8-2 19.8l2.7-3s-4-3.3-2-6.3c2-3.5 3.8 1 3.8 1s.7-2.3 3.6-3.3c.4-.7 1-2.6 1.4-3.8a1 1 0 0 1 1.3-.7l11.4 2.6c.5.2.8.7.8 1.2l-.3 3.2z"
}), /* @__PURE__ */ React418.createElement("path", {
  fill: "#552950",
  d: "M105 76c-.1.7-.6 1.1-1 1-.6 0-.9-.6-.8-1.2.1-.6.6-1 1-1 .6 0 .9.7.8 1.3m7.1 1.6c0 .6-.5 1-1 1-.5-.1-.8-.7-.7-1.3 0-.6.5-1 1-1 .5.1.8.7.7 1.3"
}), /* @__PURE__ */ React418.createElement("path", {
  stroke: "#DB836E",
  d: "m110.1 74.8-.9 1.7-.3 4.3h-2.2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1"
}), /* @__PURE__ */ React418.createElement("path", {
  stroke: "#5C2552",
  d: "M110.8 74.5s1.8-.7 2.6.5",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1"
}), /* @__PURE__ */ React418.createElement("path", {
  stroke: "#DB836E",
  d: "M92.4 74.3s.5-1.1 1.1-.7c.6.4 1.3 1.4.6 2-.8.5.1 1.6.1 1.6",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1"
}), /* @__PURE__ */ React418.createElement("path", {
  stroke: "#5C2552",
  d: "M103.3 73s1.8 1 4.1.9",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1"
}), /* @__PURE__ */ React418.createElement("path", {
  stroke: "#DB836E",
  d: "M103.7 81.8s2.2 1.2 4.4 1.2m-3.5 1.3s1 .4 1.6.3m-11.5-3.4s2.3 7.4 10.4 7.6",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1"
}), /* @__PURE__ */ React418.createElement("path", {
  stroke: "#E4EBF7",
  d: "M81.5 89.4s.4 5.6-5 12.8M69 82.7s-.7 9.2-8.2 14.2m68.6 26s-5.3 7.4-9.4 10.7m-.7-26.3s.5 4.4-2.1 32",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1"
}), /* @__PURE__ */ React418.createElement("path", {
  fill: "#F2D7AD",
  d: "M150 151.2h-49.8a1 1 0 0 1-1-1v-31.7c0-.5.4-1 1-1H150c.6 0 1 .5 1 1v31.7a1 1 0 0 1-1 1"
}), /* @__PURE__ */ React418.createElement("path", {
  fill: "#F4D19D",
  d: "M150.3 151.2h-19.9v-33.7h20.8v32.8a1 1 0 0 1-1 1"
}), /* @__PURE__ */ React418.createElement("path", {
  fill: "#F2D7AD",
  d: "M123.6 127.9H92.9a.5.5 0 0 1-.4-.8l6.4-9.1c.2-.3.5-.5.8-.5h31.1l-7.2 10.4z"
}), /* @__PURE__ */ React418.createElement("path", {
  fill: "#CC9B6E",
  d: "M123.7 128.4H99.2v-.5h24.2l7.2-10.2.4.3z"
}), /* @__PURE__ */ React418.createElement("path", {
  fill: "#F4D19D",
  d: "M158.3 127.9h-18.7a2 2 0 0 1-1.6-.8l-7.2-9.6h20c.5 0 1 .3 1.2.6l6.7 9a.5.5 0 0 1-.4.8"
}), /* @__PURE__ */ React418.createElement("path", {
  fill: "#CC9B6E",
  d: "M157.8 128.5h-19.3l-7.9-10.5.4-.3 7.7 10.3h19.1zm-27.2 22.2v-8.2h.4v8.2zm-.1-10.9v-21.4h.4l.1 21.4zm-18.6 1.1-.5-.1 1.5-5.2.5.2zm-3.5.2-2.6-3 2.6-3.4.4.3-2.4 3.1 2.4 2.6zm8.2 0-.4-.4 2.4-2.6-2.4-3 .4-.4 2.7 3.4z"
}), /* @__PURE__ */ React418.createElement("path", {
  fill: "#FFC6A0",
  d: "m154.3 131.9-3.1-2v3.5l-1 .1a85 85 0 0 1-4.8.3c-1.9 0-2.7 2.2 2.2 2.6l-2.6-.6s-2.2 1.3.5 2.3c0 0-1.6 1.2.6 2.6-.6 3.5 5.2 4 7 3.6a6.1 6.1 0 0 0 4.6-5.2 8 8 0 0 0-3.4-7.2"
}), /* @__PURE__ */ React418.createElement("path", {
  stroke: "#DB836E",
  d: "M153.7 133.6s-6.5.4-8.4.3c-1.8 0-1.9 2.2 2.4 2.3 3.7.2 5.4 0 5.4 0",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1"
}), /* @__PURE__ */ React418.createElement("path", {
  stroke: "#DB836E",
  d: "M145.2 135.9c-1.9 1.3.5 2.3.5 2.3s3.5 1 6.8.6m-.6 2.9s-6.3.1-6.7-2.1c-.3-1.4.4-1.4.4-1.4m.5 2.7s-1 3.1 5.5 3.5m-.4-14.5v3.5M52.8 89.3a18 18 0 0 0 13.6-7.8",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1"
}), /* @__PURE__ */ React418.createElement("path", {
  fill: "#5BA02E",
  d: "M168.6 248.3a6.6 6.6 0 0 1-6.7-6.6v-66.5a6.6 6.6 0 1 1 13.3 0v66.5a6.6 6.6 0 0 1-6.6 6.6"
}), /* @__PURE__ */ React418.createElement("path", {
  fill: "#92C110",
  d: "M176.5 247.7a6.6 6.6 0 0 1-6.6-6.7v-33.2a6.6 6.6 0 1 1 13.3 0V241a6.6 6.6 0 0 1-6.7 6.7"
}), /* @__PURE__ */ React418.createElement("path", {
  fill: "#F2D7AD",
  d: "M186.4 293.6H159a3.2 3.2 0 0 1-3.2-3.2v-46.1a3.2 3.2 0 0 1 3.2-3.2h27.5a3.2 3.2 0 0 1 3.2 3.2v46.1a3.2 3.2 0 0 1-3.2 3.2"
}), /* @__PURE__ */ React418.createElement("path", {
  stroke: "#E4EBF7",
  d: "M89 89.5s7.8 5.4 16.6 2.8",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1"
})));
var noFound_default = NoFound;

// ../../node_modules/antd/es/result/serverError.js
var React419 = __toESM(require_react());
var ServerError = () => /* @__PURE__ */ React419.createElement("svg", {
  width: "254",
  height: "294"
}, /* @__PURE__ */ React419.createElement("title", null, "Server Error"), /* @__PURE__ */ React419.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /* @__PURE__ */ React419.createElement("path", {
  fill: "#E4EBF7",
  d: "M0 128.1v-2C0 56.5 56.3.2 125.7.2h2.1C197.2.3 253.5 56.6 253.5 126v2.1c0 69.5-56.3 125.7-125.7 125.7h-2.1A125.7 125.7 0 0 1 0 128.1"
}), /* @__PURE__ */ React419.createElement("path", {
  fill: "#FFF",
  d: "M40 132.1a8.3 8.3 0 1 1-16.6-1.7 8.3 8.3 0 0 1 16.6 1.7"
}), /* @__PURE__ */ React419.createElement("path", {
  stroke: "#FFF",
  d: "m37.2 135.6 10.5 6m1 6.3-12.8 10.8",
  strokeWidth: "2"
}), /* @__PURE__ */ React419.createElement("path", {
  fill: "#FFF",
  d: "M40.1 160.8a5.7 5.7 0 1 1-11.3-1.1 5.7 5.7 0 0 1 11.3 1.1M58 144.6a5.7 5.7 0 1 1-11.4-1.2 5.7 5.7 0 0 1 11.4 1.2M99.7 27.4h30a4.6 4.6 0 1 0 0-9.2h-30a4.6 4.6 0 0 0 0 9.2M111 46h30a4.6 4.6 0 1 0 0-9.3h-30a4.6 4.6 0 1 0 0 9.3m2.5-18.6h16a4.6 4.6 0 1 0 0 9.3h-16a4.6 4.6 0 0 0 0-9.3m36.7 42.7h-4a4.8 4.8 0 0 1-4.8-4.8 4.8 4.8 0 0 1 4.8-4.8h4a4.8 4.8 0 0 1 4.7 4.8 4.8 4.8 0 0 1-4.7 4.8"
}), /* @__PURE__ */ React419.createElement("circle", {
  cx: "201.35",
  cy: "30.2",
  r: "29.7",
  fill: "#FF603B"
}), /* @__PURE__ */ React419.createElement("path", {
  fill: "#FFF",
  d: "m203.6 19.4-.7 15a1.5 1.5 0 0 1-3 0l-.7-15a2.2 2.2 0 1 1 4.4 0m-.3 19.4c.5.5.8 1.1.8 1.9s-.3 1.4-.8 1.9a3 3 0 0 1-2 .7 2.5 2.5 0 0 1-1.8-.7c-.6-.6-.8-1.2-.8-2 0-.7.2-1.3.8-1.8.5-.5 1.1-.7 1.8-.7.8 0 1.5.2 2 .7"
}), /* @__PURE__ */ React419.createElement("path", {
  fill: "#FFB594",
  d: "M119.3 133.3c4.4-.6 3.6-1.2 4-4.8.8-5.2-3-17-8.2-25.1-1-10.7-12.6-11.3-12.6-11.3s4.3 5 4.2 16.2c1.4 5.3.8 14.5.8 14.5s5.3 11.4 11.8 10.5"
}), /* @__PURE__ */ React419.createElement("path", {
  fill: "#FFF",
  d: "M101 91.6s1.4-.6 3.2.6c8 1.4 10.3 6.7 11.3 11.4 1.8 1.2 1.8 2.3 1.8 3.5l1.5 3s-7.2 1.7-11 6.7c-1.3-6.4-6.9-25.2-6.9-25.2"
}), /* @__PURE__ */ React419.createElement("path", {
  fill: "#FFB594",
  d: "m94 90.5 1-5.8-9.2-11.9-5.2 5.6-2.6 9.9s8.4 5 16 2.2"
}), /* @__PURE__ */ React419.createElement("path", {
  fill: "#FFC6A0",
  d: "M83 78.2s-4.6-2.9-2.5-6.9c1.6-3 4.5 1.2 4.5 1.2s.5-3.7 3.2-3.7c.5-1 1.5-4.2 1.5-4.2l13.6 3.2c0 5.2-2.3 19.5-7.9 20-8.9.6-12.5-9.6-12.5-9.6"
}), /* @__PURE__ */ React419.createElement("path", {
  fill: "#520038",
  d: "M103 72.2c2.6-2 3.5-9.7 3.5-9.7s-2.5-.5-6.7-2c-4.7-2.2-12.9-4.9-17.6.9-9.5 4.4-2 20-2 20l2.7-3.1s-4-3.3-2.1-6.3c2.2-3.5 4 1 4 1s.6-2.3 3.5-3.3c.4-.7 1-2.7 1.5-3.8A1 1 0 0 1 91 65l11.5 2.7c.5.1.8.6.8 1.2l-.3 3.2z"
}), /* @__PURE__ */ React419.createElement("path", {
  fill: "#552950",
  d: "M101.2 76.5c0 .6-.6 1-1 1-.5-.1-.9-.7-.8-1.3.1-.6.6-1 1.1-1 .5.1.8.7.7 1.3m-7-1.4c0 .6-.5 1-1 1-.5-.1-.8-.7-.7-1.3 0-.6.6-1 1-1 .5.1.9.7.8 1.3"
}), /* @__PURE__ */ React419.createElement("path", {
  stroke: "#DB836E",
  d: "m99.2 73.6-.9 1.7-.3 4.3h-2.2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1"
}), /* @__PURE__ */ React419.createElement("path", {
  stroke: "#5C2552",
  d: "M100 73.3s1.7-.7 2.4.5",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1"
}), /* @__PURE__ */ React419.createElement("path", {
  stroke: "#DB836E",
  d: "M81.4 73s.4-1 1-.6c.7.4 1.4 1.4.6 2s.2 1.6.2 1.6",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1"
}), /* @__PURE__ */ React419.createElement("path", {
  stroke: "#5C2552",
  d: "M92.3 71.7s1.9 1.1 4.2 1",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1"
}), /* @__PURE__ */ React419.createElement("path", {
  stroke: "#DB836E",
  d: "M92.7 80.6s2.3 1.2 4.4 1.2m-3.4 1.4s1 .4 1.5.3M83.7 80s1.8 6.6 9.2 8",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1"
}), /* @__PURE__ */ React419.createElement("path", {
  stroke: "#E4EBF7",
  d: "M95.5 91.7s-1 2.8-8.2 2c-7.3-.6-10.3-5-10.3-5",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1"
}), /* @__PURE__ */ React419.createElement("path", {
  fill: "#FFF",
  d: "M78.1 87.5s6.6 5 16.5 2.5c0 0 9.6 1 11.5 5.3 5.4 11.8.6 36.8 0 40 3.5 4-.4 8.4-.4 8.4-15.7-3.5-35.8-.6-35.8-.6-4.9-3.5-1.3-9-1.3-9l-6.2-23.8c-2.5-15.2.8-19.8 3.5-20.7 3-1 8-1.3 8-1.3.6 0 1.1 0 1.4-.2 2.4-1.3 2.8-.6 2.8-.6"
}), /* @__PURE__ */ React419.createElement("path", {
  fill: "#FFC6A0",
  d: "M65.8 89.8s-6.8.5-7.6 8.2c-.4 8.8 3 11 3 11s6.1 22 16.9 22.9c8.4-2.2 4.7-6.7 4.6-11.4-.2-11.3-7-17-7-17s-4.3-13.7-9.9-13.7"
}), /* @__PURE__ */ React419.createElement("path", {
  fill: "#FFC6A0",
  d: "M71.7 124.2s.9 11.3 9.8 6.5c4.8-2.5 7.6-13.8 9.8-22.6A201 201 0 0 0 94 96l-5-1.7s-2.4 5.6-7.7 12.3c-4.4 5.5-9.2 11.1-9.5 17.7"
}), /* @__PURE__ */ React419.createElement("path", {
  stroke: "#E4EBF7",
  d: "M108.5 105.2s1.7 2.7-2.4 30.5c2.4 2.2 1 6-.2 7.5",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1"
}), /* @__PURE__ */ React419.createElement("path", {
  fill: "#FFC6A0",
  d: "M123.3 131.5s-.5 2.8-11.8 2c-15.2-1-25.3-3.2-25.3-3.2l.9-5.8s.7.2 9.7-.1c11.9-.4 18.7-6 25-1 4 3.2 1.5 8.1 1.5 8.1"
}), /* @__PURE__ */ React419.createElement("path", {
  fill: "#FFF",
  d: "M70.2 91s-5.6-4.8-11 2.7c-3.3 7.2.5 15.2 2.6 19.5-.3 3.8 2.4 4.3 2.4 4.3s0 1 1.5 2.7c4-7 6.7-9.1 13.7-12.5-.3-.7-1.9-3.3-1.8-3.8.2-1.7-1.3-2.6-1.3-2.6s-.3-.2-1.2-2.8c-.8-2.3-2-5.1-4.9-7.5"
}), /* @__PURE__ */ React419.createElement("path", {
  fill: "#CBD1D1",
  d: "M90.2 288s4.9 2.3 8.3 1.2c3.2-1 5.2.7 8 1.3a20 20 0 0 0 13.3-1.4c-.2-6.2-7.8-4.5-13.6-7.6-2.9-1.6-4.2-5.3-4-10H91.5s-1.5 12-1.3 16.5"
}), /* @__PURE__ */ React419.createElement("path", {
  fill: "#2B0849",
  d: "M90.2 287.8s2.8 1.5 7.6.8c3.5-.5 3.3.6 7.5 1.3 4.2.6 13-.2 14.3-1.2.5 1.3-.4 2.4-.4 2.4s-1.7.6-5.4.9c-2.3.1-8.1.3-10.2-.6-2-1.6-4.9-1.5-6-.3-4.5 1.1-7.2-.3-7.2-.3l-.2-3z"
}), /* @__PURE__ */ React419.createElement("path", {
  fill: "#A4AABA",
  d: "M98.4 272.3h3.5s0 7.5 5.2 9.6c-5.3.7-9.7-2.6-8.7-9.6"
}), /* @__PURE__ */ React419.createElement("path", {
  fill: "#CBD1D1",
  d: "M44.4 272s-2.2 7.8-4.7 13c-1.9 3.8-4.4 7.8 5.8 7.8 7 0 9.3-.5 7.7-7-1.6-6.3.3-13.8.3-13.8h-9z"
}), /* @__PURE__ */ React419.createElement("path", {
  fill: "#2B0849",
  d: "M38 290.3s2.3 1.2 7 1.2c6.4 0 8.7-1.7 8.7-1.7s.6 1.1-.7 2.2c-1 1-3.8 1.7-7.7 1.7-4.4 0-6.1-.6-7-1.3-1-.5-.8-1.6-.2-2.1"
}), /* @__PURE__ */ React419.createElement("path", {
  fill: "#A4AABA",
  d: "M45.3 274s0 1.6-.3 3.1-1.1 3.3-1.2 4.4c0 1.2 4.8 1.6 5.4 0 .7-1.6 1.4-6.8 2-7.6.7-.9-5.1-2.2-5.9.1"
}), /* @__PURE__ */ React419.createElement("path", {
  fill: "#7BB2F9",
  d: "M89.5 277.6h13.9s1.3-56.6 1.9-66.8c.6-10.3 4-45.1 1-65.6l-13-.7-23.7.8-1.3 10.4c0 .5-.7.9-.8 1.4 0 .6.5 1.4.4 2L59.6 206c-.1.7-1.3 1-1.5 2.8 0 .3.2 1.6.1 1.8-7.1 19.5-12.2 52.6-15.6 67.2h15.1L62 259c3-13.3 24-88.3 24-88.3l3.2-1-.2 48.6s-.2 1.3.4 2.1c.5.8-.6 1.2-.4 2.4l.4 1.8-1 12.4c-.4 4.9 1.2 40.7 1.2 40.7"
}), /* @__PURE__ */ React419.createElement("path", {
  stroke: "#648BD8",
  d: "M64.6 218.9c1.2 0 4.2-2.1 7.2-5.1m24.2 8.7s3-1.1 6.4-4",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1"
}), /* @__PURE__ */ React419.createElement("path", {
  stroke: "#648BD8",
  d: "M97 219.4s2.9-1.2 6.3-4",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1"
}), /* @__PURE__ */ React419.createElement("path", {
  stroke: "#648BD8",
  d: "M63.2 222.1s2.7-.6 6.7-3.5m5-72.4c-.3 3.2.3 8.8-4.5 9.4m22.8-11.3s.1 14.6-1.4 15.7c-2.3 1.7-3 2-3 2m.4-17s.3 13-1 25m-4.7.7s6.8-1 9.1-1M46 270l-.9 4.6m1.8-11.3-.8 4.1m16.6-64.9c-.3 1.6 0 2-.4 3.4 0 0-2.8 2-2.3 4s-.3 3.4-4.5 17.2c-1.8 5.8-4.3 19-6.2 28.3l-1.1 5.8m16-67-1 4.9m8.1-52.3-1.2 10.9s-1.2.1-.5 2.3c0 1.4-2.8 16.4-5.4 31.6m-20 82.1h13.9",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1"
}), /* @__PURE__ */ React419.createElement("path", {
  fill: "#192064",
  d: "M106.2 142.1c-3-.5-18.8-2.7-36.2.2a.6.6 0 0 0-.6.7v3a.6.6 0 0 0 .8.6c3.3-.5 17-2.4 35.6-.3.4 0 .7-.2.7-.5.2-1.4.2-2.5.2-3a.6.6 0 0 0-.5-.7"
}), /* @__PURE__ */ React419.createElement("path", {
  fill: "#FFF",
  d: "M96.4 145.3v-5.1a.8.8 0 0 0-.8-.9 114.1 114.1 0 0 0-8.1 0 .8.8 0 0 0-.9.8v5.1c0 .5.4.9.9.9h8a.8.8 0 0 0 .9-.8"
}), /* @__PURE__ */ React419.createElement("path", {
  fill: "#192064",
  d: "M95.2 144.3v-3.2a.7.7 0 0 0-.6-.7h-6.1a.7.7 0 0 0-.6.7v3.2c0 .4.3.7.6.7h6c.4 0 .7-.3.7-.7"
}), /* @__PURE__ */ React419.createElement("path", {
  stroke: "#648BD8",
  d: "M90.1 273.5h12.8m-11.7-3.7v6.3m-.3-12.6v4.5m-.5-97.6 1 46.4s.7 1.6-.3 2.8c-.9 1.1 2.6.7 1 2.3-1.7 1.6.9 1.2 0 3.5-.6 1.6-1 22-1.2 36.5",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1"
}), /* @__PURE__ */ React419.createElement("path", {
  stroke: "#E4EBF7",
  d: "M73.7 98.7 76 103s2 .8 1.8 2.7l.8 2.2m-14.3 8.7c.2-1 2.2-7.1 12.6-10.5m.7-16s7.7 6 16.5 2.7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1"
}), /* @__PURE__ */ React419.createElement("path", {
  fill: "#FFC6A0",
  d: "M92 87s5.5-.9 7.5-4.6c1.3-.3.8 2.2-.3 3.7l-1 1.5s.2.3.2.9c0 .6-.2.6-.3 1v1l-.4 1c-.1.2 0 .6-.2.9-.2.4-1.6 1.8-2.6 2.8-3.8 3.6-5 1.7-6-.4-1-1.8-.7-5.1-.9-6.9-.3-2.9-2.6-3-2-4.4.4-.7 3 .7 3.4 1.8.7 2 2.9 1.8 2.6 1.7"
}), /* @__PURE__ */ React419.createElement("path", {
  stroke: "#DB836E",
  d: "M99.8 82.4c-.5.1-.3.3-1 1.3-.6 1-4.8 2.9-6.4 3.2-2.5.5-2.2-1.6-4.2-2.9-1.7-1-3.6-.6-1.4 1.4 1 1 1 1.1 1.4 3.2.3 1.5-.7 3.7.7 5.6",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: ".8"
}), /* @__PURE__ */ React419.createElement("path", {
  stroke: "#E59788",
  d: "M79.5 108.7c-2 2.9-4.2 6.1-5.5 8.7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: ".8"
}), /* @__PURE__ */ React419.createElement("path", {
  fill: "#FFC6A0",
  d: "M87.7 124.8s-2-2-5.1-2.8c-3-.7-3.6-.1-5.5.1-2 .3-4-.9-3.7.7.3 1.7 5 1 5.2 2.1.2 1.1-6.3 2.8-8.3 2.2-.8.8.5 1.9 2 2.2.3 1.5 2.3 1.5 2.3 1.5s.7 1 2.6 1.1c2.5 1.3 9-.7 11-1.5 2-.9-.5-5.6-.5-5.6"
}), /* @__PURE__ */ React419.createElement("path", {
  stroke: "#E59788",
  d: "M73.4 122.8s.7 1.2 3.2 1.4c2.3.3 2.6.6 2.6.6s-2.6 3-9.1 2.3m2.3 2.2s3.8 0 5-.7m-2.4 2.2s2 0 3.3-.6m-1 1.7s1.7 0 2.8-.5m-6.8-9s-.6-1.1 1.3-.5c1.7.5 2.8 0 5.1.1 1.4.1 3-.2 4 .2 1.6.8 3.6 2.2 3.6 2.2s10.6 1.2 19-1.1M79 108s-8.4 2.8-13.2 12.1",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: ".8"
}), /* @__PURE__ */ React419.createElement("path", {
  stroke: "#E4EBF7",
  d: "M109.3 112.5s3.4-3.6 7.6-4.6",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1"
}), /* @__PURE__ */ React419.createElement("path", {
  stroke: "#E59788",
  d: "M107.4 123s9.7-2.7 11.4-.9",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: ".8"
}), /* @__PURE__ */ React419.createElement("path", {
  stroke: "#BFCDDD",
  d: "m194.6 83.7 4-4M187.2 91l3.7-3.6m.9-3-4.5-4.7m11.2 11.5-4.2-4.3m-65 76.3 3.7-3.7M122.3 170l3.5-3.5m.8-2.9-4.3-4.2M133 170l-4-4",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "2"
}), /* @__PURE__ */ React419.createElement("path", {
  fill: "#A3B4C6",
  d: "M190.2 211.8h-1.6a4 4 0 0 1-4-4v-32.1a4 4 0 0 1 4-4h1.6a4 4 0 0 1 4 4v32a4 4 0 0 1-4 4"
}), /* @__PURE__ */ React419.createElement("path", {
  fill: "#A3B4C6",
  d: "M237.8 213a4.8 4.8 0 0 1-4.8 4.8h-86.6a4.8 4.8 0 0 1 0-9.6H233a4.8 4.8 0 0 1 4.8 4.8"
}), /* @__PURE__ */ React419.createElement("path", {
  fill: "#A3B4C6",
  d: "M154.1 190.1h70.5v-84.6h-70.5z"
}), /* @__PURE__ */ React419.createElement("path", {
  fill: "#BFCDDD",
  d: "M225 190.1h-71.2a3.2 3.2 0 0 1-3.2-3.2v-19a3.2 3.2 0 0 1 3.2-3.2h71.1a3.2 3.2 0 0 1 3.2 3.2v19a3.2 3.2 0 0 1-3.2 3.2m0-59.3h-71.1a3.2 3.2 0 0 1-3.2-3.2v-19a3.2 3.2 0 0 1 3.2-3.2h71.1a3.2 3.2 0 0 1 3.2 3.3v19a3.2 3.2 0 0 1-3.2 3.1"
}), /* @__PURE__ */ React419.createElement("path", {
  fill: "#FFF",
  d: "M159.6 120.5a2.4 2.4 0 1 1 0-4.8 2.4 2.4 0 0 1 0 4.8m7.4 0a2.4 2.4 0 1 1 0-4.8 2.4 2.4 0 0 1 0 4.8m7.4 0a2.4 2.4 0 1 1 0-4.8 2.4 2.4 0 0 1 0 4.8m48.1 0h-22.4a.8.8 0 0 1-.8-.8v-3.2c0-.4.3-.8.8-.8h22.4c.5 0 .8.4.8.8v3.2c0 .5-.3.8-.8.8"
}), /* @__PURE__ */ React419.createElement("path", {
  fill: "#BFCDDD",
  d: "M225 160.5h-71.2a3.2 3.2 0 0 1-3.2-3.2v-19a3.2 3.2 0 0 1 3.2-3.2h71.1a3.2 3.2 0 0 1 3.2 3.2v19a3.2 3.2 0 0 1-3.2 3.2"
}), /* @__PURE__ */ React419.createElement("path", {
  stroke: "#7C90A5",
  d: "M173.5 130.8h49.3m-57.8 0h6m-15 0h6.7m11.1 29.8h49.3m-57.7 0h6m-15.8 0h6.7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1"
}), /* @__PURE__ */ React419.createElement("path", {
  fill: "#FFF",
  d: "M159.6 151a2.4 2.4 0 1 1 0-4.8 2.4 2.4 0 0 1 0 4.8m7.4 0a2.4 2.4 0 1 1 0-4.8 2.4 2.4 0 0 1 0 4.8m7.4 0a2.4 2.4 0 1 1 0-4.8 2.4 2.4 0 0 1 0 4.8m48.1 0h-22.4a.8.8 0 0 1-.8-.8V147c0-.4.3-.8.8-.8h22.4c.5 0 .8.4.8.8v3.2c0 .5-.3.8-.8.8m-63 29a2.4 2.4 0 1 1 0-4.8 2.4 2.4 0 0 1 0 4.8m7.5 0a2.4 2.4 0 1 1 0-4.8 2.4 2.4 0 0 1 0 4.8m7.4 0a2.4 2.4 0 1 1 0-4.8 2.4 2.4 0 0 1 0 4.8m48.1 0h-22.4a.8.8 0 0 1-.8-.8V176c0-.5.3-.8.8-.8h22.4c.5 0 .8.3.8.8v3.2c0 .4-.3.8-.8.8"
}), /* @__PURE__ */ React419.createElement("path", {
  fill: "#BFCDDD",
  d: "M203 221.1h-27.3a2.4 2.4 0 0 1-2.4-2.4v-11.4a2.4 2.4 0 0 1 2.4-2.5H203a2.4 2.4 0 0 1 2.4 2.5v11.4a2.4 2.4 0 0 1-2.4 2.4"
}), /* @__PURE__ */ React419.createElement("path", {
  stroke: "#A3B4C6",
  d: "M177.3 207.2v11.5m23.8-11.5v11.5",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1"
}), /* @__PURE__ */ React419.createElement("path", {
  fill: "#5BA02E",
  d: "M162.9 267.9a9.4 9.4 0 0 1-9.4-9.4v-14.8a9.4 9.4 0 0 1 18.8 0v14.8a9.4 9.4 0 0 1-9.4 9.4"
}), /* @__PURE__ */ React419.createElement("path", {
  fill: "#92C110",
  d: "M171.2 267.8a9.4 9.4 0 0 1-9.4-9.4V255a9.4 9.4 0 0 1 18.8 0v3.4a9.4 9.4 0 0 1-9.4 9.4"
}), /* @__PURE__ */ React419.createElement("path", {
  fill: "#F2D7AD",
  d: "M181.3 293.7h-27.7a3.2 3.2 0 0 1-3.2-3.2v-20.7a3.2 3.2 0 0 1 3.2-3.2h27.7a3.2 3.2 0 0 1 3.2 3.2v20.7a3.2 3.2 0 0 1-3.2 3.2"
})));
var serverError_default = ServerError;

// ../../node_modules/antd/es/result/style/index.js
var genBaseStyle10 = (token2) => {
  const {
    componentCls,
    lineHeightHeading3,
    iconCls,
    padding,
    paddingXL,
    paddingXS,
    paddingLG,
    marginXS,
    lineHeight
  } = token2;
  return {
    // Result
    [componentCls]: {
      padding: `${unit(token2.calc(paddingLG).mul(2).equal())} ${unit(paddingXL)}`,
      // RTL
      "&-rtl": {
        direction: "rtl"
      }
    },
    // Exception Status image
    [`${componentCls} ${componentCls}-image`]: {
      width: token2.imageWidth,
      height: token2.imageHeight,
      margin: "auto"
    },
    [`${componentCls} ${componentCls}-icon`]: {
      marginBottom: paddingLG,
      textAlign: "center",
      [`& > ${iconCls}`]: {
        fontSize: token2.iconFontSize
      }
    },
    [`${componentCls} ${componentCls}-title`]: {
      color: token2.colorTextHeading,
      fontSize: token2.titleFontSize,
      lineHeight: lineHeightHeading3,
      marginBlock: marginXS,
      textAlign: "center"
    },
    [`${componentCls} ${componentCls}-subtitle`]: {
      color: token2.colorTextDescription,
      fontSize: token2.subtitleFontSize,
      lineHeight,
      textAlign: "center"
    },
    [`${componentCls} ${componentCls}-content`]: {
      marginTop: paddingLG,
      padding: `${unit(paddingLG)} ${unit(token2.calc(padding).mul(2.5).equal())}`,
      backgroundColor: token2.colorFillAlter
    },
    [`${componentCls} ${componentCls}-extra`]: {
      margin: token2.extraMargin,
      textAlign: "center",
      "& > *": {
        marginInlineEnd: paddingXS,
        "&:last-child": {
          marginInlineEnd: 0
        }
      }
    }
  };
};
var genStatusIconStyle = (token2) => {
  const {
    componentCls,
    iconCls
  } = token2;
  return {
    [`${componentCls}-success ${componentCls}-icon > ${iconCls}`]: {
      color: token2.resultSuccessIconColor
    },
    [`${componentCls}-error ${componentCls}-icon > ${iconCls}`]: {
      color: token2.resultErrorIconColor
    },
    [`${componentCls}-info ${componentCls}-icon > ${iconCls}`]: {
      color: token2.resultInfoIconColor
    },
    [`${componentCls}-warning ${componentCls}-icon > ${iconCls}`]: {
      color: token2.resultWarningIconColor
    }
  };
};
var genResultStyle = (token2) => [genBaseStyle10(token2), genStatusIconStyle(token2)];
var getStyle3 = (token2) => genResultStyle(token2);
var prepareComponentToken28 = (token2) => ({
  titleFontSize: token2.fontSizeHeading3,
  subtitleFontSize: token2.fontSize,
  iconFontSize: token2.fontSizeHeading3 * 3,
  extraMargin: `${token2.paddingLG}px 0 0 0`
});
var style_default33 = genStyleHooks("Result", (token2) => {
  const resultInfoIconColor = token2.colorInfo;
  const resultErrorIconColor = token2.colorError;
  const resultSuccessIconColor = token2.colorSuccess;
  const resultWarningIconColor = token2.colorWarning;
  const resultToken = merge2(token2, {
    resultInfoIconColor,
    resultErrorIconColor,
    resultSuccessIconColor,
    resultWarningIconColor,
    imageWidth: 250,
    imageHeight: 295
  });
  return [getStyle3(resultToken)];
}, prepareComponentToken28);

// ../../node_modules/antd/es/result/unauthorized.js
var React420 = __toESM(require_react());
var Unauthorized = () => /* @__PURE__ */ React420.createElement("svg", {
  width: "251",
  height: "294"
}, /* @__PURE__ */ React420.createElement("title", null, "Unauthorized"), /* @__PURE__ */ React420.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /* @__PURE__ */ React420.createElement("path", {
  fill: "#E4EBF7",
  d: "M0 129v-2C0 58.3 55.6 2.7 124.2 2.7h2c68.6 0 124.2 55.6 124.2 124.1v2.1c0 68.6-55.6 124.2-124.1 124.2h-2.1A124.2 124.2 0 0 1 0 129"
}), /* @__PURE__ */ React420.createElement("path", {
  fill: "#FFF",
  d: "M41.4 133a8.2 8.2 0 1 1-16.4-1.7 8.2 8.2 0 0 1 16.4 1.6"
}), /* @__PURE__ */ React420.createElement("path", {
  stroke: "#FFF",
  d: "m38.7 136.4 10.4 5.9m.9 6.2-12.6 10.7",
  strokeWidth: "2"
}), /* @__PURE__ */ React420.createElement("path", {
  fill: "#FFF",
  d: "M41.5 161.3a5.6 5.6 0 1 1-11.2-1.2 5.6 5.6 0 0 1 11.2 1.2m17.7-16a5.7 5.7 0 1 1-11.3-1.2 5.7 5.7 0 0 1 11.3 1.2m41.2-115.8H130a4.6 4.6 0 1 0 0-9.1h-29.6a4.6 4.6 0 0 0 0 9.1m11.3 18.3h29.7a4.6 4.6 0 1 0 0-9.2h-29.7a4.6 4.6 0 1 0 0 9.2"
}), /* @__PURE__ */ React420.createElement("path", {
  fill: "#FFF",
  d: "M114 29.5h15.8a4.6 4.6 0 1 0 0 9.1H114a4.6 4.6 0 0 0 0-9.1m71.3 108.2a10 10 0 1 1-19.8-2 10 10 0 0 1 19.8 2"
}), /* @__PURE__ */ React420.createElement("path", {
  stroke: "#FFF",
  d: "m180.2 143.8 12.5 7.1m1.1 7.5-15.1 13",
  strokeWidth: "2"
}), /* @__PURE__ */ React420.createElement("path", {
  fill: "#FFF",
  d: "M185.6 172a6.8 6.8 0 1 1-13.6-1.4 6.8 6.8 0 0 1 13.5 1.3m18.6-16.6a6.8 6.8 0 1 1-13.6-1.4 6.8 6.8 0 0 1 13.6 1.4"
}), /* @__PURE__ */ React420.createElement("path", {
  stroke: "#FFF",
  d: "M153 194a2.2 2.2 0 1 1-4.4 0 2.2 2.2 0 0 1 4.4 0zm73-75.8a2.2 2.2 0 1 1-4.5 0 2.2 2.2 0 0 1 4.4 0zm-9 34.9a2.2 2.2 0 1 1-4.3 0 2.2 2.2 0 0 1 4.4 0zm-39.2-43.3a2.2 2.2 0 1 1-4.4 0 2.2 2.2 0 0 1 4.4 0zm18.3-15.3a2.2 2.2 0 1 1-4.4 0 2.2 2.2 0 0 1 4.4 0zm6.7 88a2.2 2.2 0 1 1-4.4 0 2.2 2.2 0 0 1 4.4 0z",
  strokeWidth: "2"
}), /* @__PURE__ */ React420.createElement("path", {
  stroke: "#FFF",
  d: "m215.1 155.3-1.9 20-10.8 6m-27.8-4.7-6.3 9.8H157l-4.5 6.4m23.4-65.5v-15.7m45.6 7.8-12.8 7.9-15.2-7.9V96.7",
  strokeWidth: "2"
}), /* @__PURE__ */ React420.createElement("path", {
  fill: "#A26EF4",
  d: "M180.7 29.3a29.3 29.3 0 1 1 58.6 0 29.3 29.3 0 0 1-58.6 0"
}), /* @__PURE__ */ React420.createElement("path", {
  fill: "#FFF",
  d: "m221.4 41.7-21.5-.1a1.7 1.7 0 0 1-1.7-1.8V27.6a1.7 1.7 0 0 1 1.8-1.7h21.5c1 0 1.8.9 1.8 1.8l-.1 12.3a1.7 1.7 0 0 1-1.7 1.7"
}), /* @__PURE__ */ React420.createElement("path", {
  fill: "#FFF",
  d: "M215.1 29.2c0 2.6-2 4.6-4.5 4.6a4.6 4.6 0 0 1-4.5-4.7v-6.9c0-2.6 2-4.6 4.6-4.6 2.5 0 4.5 2 4.4 4.7v6.9zm-4.5-14a6.9 6.9 0 0 0-7 6.8v7.3a6.9 6.9 0 0 0 13.8.1V22a6.9 6.9 0 0 0-6.8-6.9zm-43 53.2h-4a4.7 4.7 0 0 1-4.7-4.8 4.7 4.7 0 0 1 4.7-4.7h4a4.7 4.7 0 0 1 4.7 4.8 4.7 4.7 0 0 1-4.7 4.7"
}), /* @__PURE__ */ React420.createElement("path", {
  fill: "#5BA02E",
  d: "M168.2 248.8a6.6 6.6 0 0 1-6.6-6.6v-66a6.6 6.6 0 0 1 13.2 0v66a6.6 6.6 0 0 1-6.6 6.6"
}), /* @__PURE__ */ React420.createElement("path", {
  fill: "#92C110",
  d: "M176.1 248.2a6.6 6.6 0 0 1-6.6-6.6v-33a6.6 6.6 0 1 1 13.3 0v33a6.6 6.6 0 0 1-6.7 6.6"
}), /* @__PURE__ */ React420.createElement("path", {
  fill: "#F2D7AD",
  d: "M186 293.9h-27.4a3.2 3.2 0 0 1-3.2-3.2v-45.9a3.2 3.2 0 0 1 3.2-3.1H186a3.2 3.2 0 0 1 3.2 3.1v46a3.2 3.2 0 0 1-3.2 3"
}), /* @__PURE__ */ React420.createElement("path", {
  fill: "#FFF",
  d: "M82 147.7s6.3-1 17.5-1.3c11.8-.4 17.6 1 17.6 1s3.7-3.8 1-8.3c1.3-12.1 6-32.9.3-48.3-1.1-1.4-3.7-1.5-7.5-.6-1.4.3-7.2-.2-8-.1l-15.3-.4-8-.5c-1.6-.1-4.3-1.7-5.5-.3-.4.4-2.4 5.6-2 16l8.7 35.7s-3.2 3.6 1.2 7"
}), /* @__PURE__ */ React420.createElement("path", {
  fill: "#FFC6A0",
  d: "m75.8 73.3-1-6.4 12-6.5s7.4-.1 8 1.2c.8 1.3-5.5 1-5.5 1s-1.9 1.4-2.6 2.5c-1.7 2.4-1 6.5-8.4 6-1.7.3-2.5 2.2-2.5 2.2"
}), /* @__PURE__ */ React420.createElement("path", {
  fill: "#FFB594",
  d: "M52.4 77.7S66.7 87 77.4 92c1 .5-2 16.2-11.9 11.8-7.4-3.3-20.1-8.4-21.5-14.5-.7-3.2 2.6-7.6 8.4-11.7M142 80s-6.7 3-13.9 6.9c-3.9 2.1-10.1 4.7-12.3 8-6.2 9.3 3.5 11.2 13 7.5 6.6-2.7 29-12.1 13.2-22.4"
}), /* @__PURE__ */ React420.createElement("path", {
  fill: "#FFC6A0",
  d: "m76.2 66.4 3 3.8S76.4 73 73 76c-7 6.2-12.8 14.3-16 16.4-4 2.7-9.7 3.3-12.2 0-3.5-5.1.5-14.7 31.5-26"
}), /* @__PURE__ */ React420.createElement("path", {
  fill: "#FFF",
  d: "M64.7 85.1s-2.4 8.4-9 14.5c.7.5 18.6 10.5 22.2 10 5.2-.6 6.4-19 1.2-20.5-.8-.2-6-1.3-8.9-2.2-.9-.2-1.6-1.7-3.5-1l-2-.8zm63.7.7s5.3 2 7.3 13.8c-.6.2-17.6 12.3-21.8 7.8-6.6-7-.8-17.4 4.2-18.6 4.7-1.2 5-1.4 10.3-3"
}), /* @__PURE__ */ React420.createElement("path", {
  stroke: "#E4EBF7",
  d: "M78.2 94.7s.9 7.4-5 13",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1"
}), /* @__PURE__ */ React420.createElement("path", {
  stroke: "#E4EBF7",
  d: "M87.4 94.7s3.1 2.6 10.3 2.6c7.1 0 9-3.5 9-3.5",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: ".9"
}), /* @__PURE__ */ React420.createElement("path", {
  fill: "#FFC6A0",
  d: "m117.2 68.6-6.8-6.1s-5.4-4.4-9.2-1c-3.9 3.5 4.4 2.2 5.6 4.2 1.2 2.1.9 1.2-2 .5-5.7-1.4-2.1.9 3 5.3 2 1.9 7 1 7 1l2.4-3.9z"
}), /* @__PURE__ */ React420.createElement("path", {
  fill: "#FFB594",
  d: "m105.3 91.3-.3-11H89l-.5 10.5c0 .4.2.8.6 1 2 1.3 9.3 5 15.8.4.2-.2.4-.5.4-.9"
}), /* @__PURE__ */ React420.createElement("path", {
  fill: "#5C2552",
  d: "M107.6 74.2c.8-1.1 1-9 1-11.9a1 1 0 0 0-1-1l-4.6-.4c-7.7-1-17 .6-18.3 6.3-5.4 5.9-.4 13.3-.4 13.3s2 3.5 4.3 6.8c.8 1 .4-3.8 3-6a47.9 47.9 0 0 1 16-7"
}), /* @__PURE__ */ React420.createElement("path", {
  fill: "#FFC6A0",
  d: "M88.4 83.2s2.7 6.2 11.6 6.5c7.8.3 9-7 7.5-17.5l-1-5.5c-6-2.9-15.4.6-15.4.6s-.6 2-.2 5.5c-2.3 2-1.8 5.6-1.8 5.6s-1-2-2-2.3c-.9-.3-2 0-2.3 2-1 4.6 3.6 5.1 3.6 5.1"
}), /* @__PURE__ */ React420.createElement("path", {
  stroke: "#DB836E",
  d: "m100.8 77.1 1.7-1-1-4.3.7-1.4",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1"
}), /* @__PURE__ */ React420.createElement("path", {
  fill: "#552950",
  d: "M105.5 74c0 .8-.4 1.4-1 1.4-.4 0-.8-.7-.8-1.4s.5-1.2 1-1.2.9.6.8 1.3m-8 .2c0 .8-.4 1.3-.9 1.3s-.9-.6-.9-1.3c0-.7.5-1.3 1-1.3s1 .6.9 1.3"
}), /* @__PURE__ */ React420.createElement("path", {
  stroke: "#DB836E",
  d: "M91.1 86.8s5.3 5 12.7 2.3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1"
}), /* @__PURE__ */ React420.createElement("path", {
  fill: "#DB836E",
  d: "M99.8 81.9s-3.6.2-1.5-2.8c1.6-1.5 5-.4 5-.4s1 3.9-3.5 3.2"
}), /* @__PURE__ */ React420.createElement("path", {
  stroke: "#5C2552",
  d: "M102.9 70.6s2.5.8 3.4.7m-12.4.7s2.5-1.2 4.8-1.1",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.5"
}), /* @__PURE__ */ React420.createElement("path", {
  stroke: "#DB836E",
  d: "M86.3 77.4s1 .9 1.5 2c-.4.6-1 1.2-.3 1.9m11.8 2.4s2 .2 2.5-.2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1"
}), /* @__PURE__ */ React420.createElement("path", {
  stroke: "#E4EBF7",
  d: "m87.8 115.8 15.7-3m-3.3 3 10-2m-43.7-27s-1.6 8.8-6.7 14M128.3 88s3 4 4 11.7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1"
}), /* @__PURE__ */ React420.createElement("path", {
  stroke: "#DB836E",
  d: "M64 84.8s-6 10-13.5 10",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: ".8"
}), /* @__PURE__ */ React420.createElement("path", {
  fill: "#FFC6A0",
  d: "m112.4 66-.2 5.2 12 9.2c4.5 3.6 8.9 7.5 11 8.7 4.8 2.8 8.9 3.3 11 1.8 4.1-2.9 4.4-9.9-8.1-15.3-4.3-1.8-16.1-6.3-25.7-9.7"
}), /* @__PURE__ */ React420.createElement("path", {
  stroke: "#DB836E",
  d: "M130.5 85.5s4.6 5.7 11.7 6.2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: ".8"
}), /* @__PURE__ */ React420.createElement("path", {
  stroke: "#E4EBF7",
  d: "M121.7 105.7s-.4 8.6-1.3 13.6",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1"
}), /* @__PURE__ */ React420.createElement("path", {
  stroke: "#648BD8",
  d: "M115.8 161.5s-3.6-1.5-2.7-7.1",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1"
}), /* @__PURE__ */ React420.createElement("path", {
  fill: "#CBD1D1",
  d: "M101.5 290.2s4.3 2.1 7.4 1c2.9-.9 4.6.7 7.2 1.3 2.5.5 6.9 1 11.7-1.3 0-5.6-7-4-12-6.8-2.6-1.4-3.8-4.7-3.6-8.8h-9.5s-1.4 10.6-1.2 14.6"
}), /* @__PURE__ */ React420.createElement("path", {
  fill: "#2B0849",
  d: "M101.5 290s2.4 1.4 6.8.7c3-.4 3.7.5 7.5 1 3.7.6 10.8 0 11.9-.8.4 1-.4 2-.4 2s-1.5.7-4.8.9c-2 .1-5.8.3-7.7-.5-1.8-1.4-5.2-2-5.7-.3-4 1-7.4-.3-7.4-.3l-.2-2.6z"
}), /* @__PURE__ */ React420.createElement("path", {
  fill: "#A4AABA",
  d: "M108.8 276.2h3.1s0 6.7 4.6 8.6c-4.7.6-8.6-2.3-7.7-8.6"
}), /* @__PURE__ */ React420.createElement("path", {
  fill: "#CBD1D1",
  d: "M57.6 272.5s-2 7.5-4.5 12.4c-1.8 3.7-4.2 7.6 5.5 7.6 6.7 0 9-.5 7.5-6.7-1.5-6.1.3-13.3.3-13.3h-8.8z"
}), /* @__PURE__ */ React420.createElement("path", {
  fill: "#2B0849",
  d: "M51.5 290s2.2 1.2 6.7 1.2c6.1 0 8.3-1.6 8.3-1.6s.6 1-.6 2.1c-1 .9-3.6 1.6-7.4 1.6-4.2 0-6-.6-6.8-1.2-.9-.5-.7-1.6-.2-2"
}), /* @__PURE__ */ React420.createElement("path", {
  fill: "#A4AABA",
  d: "M58.5 274.4s0 1.6-.3 3-1 3.1-1.1 4.2c0 1.1 4.5 1.5 5.2 0 .6-1.6 1.3-6.5 1.9-7.3.6-.8-5-2.1-5.7.1"
}), /* @__PURE__ */ React420.createElement("path", {
  fill: "#7BB2F9",
  d: "m100.9 277 13.3.1s1.3-54.2 1.8-64c.6-9.9 3.8-43.2 1-62.8l-12.4-.7-22.8.8-1.2 10c0 .4-.6.8-.7 1.3 0 .6.4 1.3.3 2-2.3 14-6.3 32.9-8.7 46.4-.1.6-1.2 1-1.4 2.6 0 .3.2 1.6 0 1.8-6.8 18.7-10.8 47.6-14.1 61.6h14.5s2.2-8.6 4-17a3984 3984 0 0 1 23-84.5l3-.5 1 46.1s-.2 1.2.4 2c.5.8-.6 1.1-.4 2.3l.4 1.7-1 11.9c-.4 4.6 0 39 0 39"
}), /* @__PURE__ */ React420.createElement("path", {
  stroke: "#648BD8",
  d: "M77.4 220.4c1.2.1 4-2 7-4.9m23.1 8.4s2.8-1 6.1-3.8",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1"
}), /* @__PURE__ */ React420.createElement("path", {
  stroke: "#648BD8",
  d: "M108.5 221s2.7-1.2 6-4",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ React420.createElement("path", {
  stroke: "#648BD8",
  d: "M76.1 223.6s2.6-.6 6.5-3.4m4.7-69.4c-.2 3.1.3 8.5-4.3 9m21.8-10.7s.1 14-1.3 15c-2.2 1.6-3 1.9-3 1.9m.5-16.4s0 12.8-1.2 24.3m-4.9 1s7.2-1.6 9.4-1.6m-28.6 31.5-1 4.5s-1.5 1.8-1 3.7c.4 2-1 2-5 15.3-1.7 5.6-4.4 18.5-6.3 27.5l-4 18.4M77 196.7a313.3 313.3 0 0 1-.8 4.8m7.7-50-1.2 10.3s-1 .2-.5 2.3c.1 1.3-2.6 15.6-5.1 30.2M57.6 273h13.2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1"
}), /* @__PURE__ */ React420.createElement("path", {
  fill: "#192064",
  d: "M117.4 147.4s-17-3-35.7.2v4.2s14.6-2.9 35.5-.4l.2-4"
}), /* @__PURE__ */ React420.createElement("path", {
  fill: "#FFF",
  d: "M107.5 150.4v-5a.8.8 0 0 0-.8-.7H99a.8.8 0 0 0-.7.8v4.8c0 .5.3.9.8.8a140.8 140.8 0 0 1 7.7 0 .8.8 0 0 0 .8-.7"
}), /* @__PURE__ */ React420.createElement("path", {
  fill: "#192064",
  d: "M106.4 149.4v-3a.6.6 0 0 0-.6-.7 94.1 94.1 0 0 0-5.8 0 .6.6 0 0 0-.7.7v3c0 .4.3.7.7.7h5.7c.4 0 .7-.3.7-.7"
}), /* @__PURE__ */ React420.createElement("path", {
  stroke: "#648BD8",
  d: "M101.5 274h12.3m-11.1-5v6.5m0-12.4v4.3m-.5-93.4.9 44.4s.7 1.6-.2 2.7c-1 1.1 2.4.7.9 2.2-1.6 1.6.9 1.1 0 3.4-.6 1.5-1 21-1.1 35",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1"
})));
var unauthorized_default = Unauthorized;

// ../../node_modules/antd/es/result/index.js
var IconMap = {
  success: CheckCircleFilled_default2,
  error: CloseCircleFilled_default2,
  info: ExclamationCircleFilled_default2,
  warning: WarningFilled_default2
};
var ExceptionMap = {
  "404": noFound_default,
  "500": serverError_default,
  "403": unauthorized_default
};
var ExceptionStatus = Object.keys(ExceptionMap);
var Icon4 = ({
  prefixCls,
  icon,
  status
}) => {
  const className2 = (0, import_classnames172.default)(`${prefixCls}-icon`);
  if (true) {
    const warning6 = devUseWarning("Result");
    true ? warning6(!(typeof icon === "string" && icon.length > 2), "breaking", `\`icon\` is using ReactNode instead of string naming in v4. Please check \`${icon}\` at https://ant.design/components/icon`) : void 0;
  }
  if (ExceptionStatus.includes(`${status}`)) {
    const SVGComponent = ExceptionMap[status];
    return /* @__PURE__ */ React421.createElement("div", {
      className: `${className2} ${prefixCls}-image`
    }, /* @__PURE__ */ React421.createElement(SVGComponent, null));
  }
  const iconNode = /* @__PURE__ */ React421.createElement(IconMap[status]);
  if (icon === null || icon === false) {
    return null;
  }
  return /* @__PURE__ */ React421.createElement("div", {
    className: className2
  }, icon || iconNode);
};
var Extra = ({
  prefixCls,
  extra
}) => {
  if (!extra) {
    return null;
  }
  return /* @__PURE__ */ React421.createElement("div", {
    className: `${prefixCls}-extra`
  }, extra);
};
var Result = ({
  prefixCls: customizePrefixCls,
  className: customizeClassName,
  rootClassName,
  subTitle,
  title,
  style: style2,
  children,
  status = "info",
  icon,
  extra
}) => {
  const {
    getPrefixCls,
    direction,
    result
  } = React421.useContext(ConfigContext);
  const prefixCls = getPrefixCls("result", customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = style_default33(prefixCls);
  const className2 = (0, import_classnames172.default)(prefixCls, `${prefixCls}-${status}`, customizeClassName, result === null || result === void 0 ? void 0 : result.className, rootClassName, {
    [`${prefixCls}-rtl`]: direction === "rtl"
  }, hashId, cssVarCls);
  const mergedStyle = Object.assign(Object.assign({}, result === null || result === void 0 ? void 0 : result.style), style2);
  return wrapCSSVar(/* @__PURE__ */ React421.createElement("div", {
    className: className2,
    style: mergedStyle
  }, /* @__PURE__ */ React421.createElement(Icon4, {
    prefixCls,
    status,
    icon
  }), /* @__PURE__ */ React421.createElement("div", {
    className: `${prefixCls}-title`
  }, title), subTitle && /* @__PURE__ */ React421.createElement("div", {
    className: `${prefixCls}-subtitle`
  }, subTitle), /* @__PURE__ */ React421.createElement(Extra, {
    prefixCls,
    extra
  }), children && /* @__PURE__ */ React421.createElement("div", {
    className: `${prefixCls}-content`
  }, children)));
};
Result.PRESENTED_IMAGE_403 = ExceptionMap["403"];
Result.PRESENTED_IMAGE_404 = ExceptionMap["404"];
Result.PRESENTED_IMAGE_500 = ExceptionMap["500"];
if (true) {
  Result.displayName = "Result";
}
var result_default = Result;

// ../../node_modules/antd/es/row/index.js
var row_default2 = row_default;

// ../../node_modules/antd/es/switch/index.js
var React423 = __toESM(require_react());
var import_classnames174 = __toESM(require_classnames());

// ../../node_modules/rc-switch/es/index.js
var React422 = __toESM(require_react());
var import_classnames173 = __toESM(require_classnames());
var _excluded63 = ["prefixCls", "className", "checked", "defaultChecked", "disabled", "loadingIcon", "checkedChildren", "unCheckedChildren", "onClick", "onChange", "onKeyDown"];
var Switch = /* @__PURE__ */ React422.forwardRef(function(_ref, ref3) {
  var _classNames;
  var _ref$prefixCls = _ref.prefixCls, prefixCls = _ref$prefixCls === void 0 ? "rc-switch" : _ref$prefixCls, className2 = _ref.className, checked = _ref.checked, defaultChecked = _ref.defaultChecked, disabled = _ref.disabled, loadingIcon = _ref.loadingIcon, checkedChildren = _ref.checkedChildren, unCheckedChildren = _ref.unCheckedChildren, onClick = _ref.onClick, onChange = _ref.onChange, onKeyDown2 = _ref.onKeyDown, restProps = _objectWithoutProperties(_ref, _excluded63);
  var _useMergedState = useMergedState(false, {
    value: checked,
    defaultValue: defaultChecked
  }), _useMergedState2 = _slicedToArray(_useMergedState, 2), innerChecked = _useMergedState2[0], setInnerChecked = _useMergedState2[1];
  function triggerChange(newChecked, event) {
    var mergedChecked = innerChecked;
    if (!disabled) {
      mergedChecked = newChecked;
      setInnerChecked(mergedChecked);
      onChange === null || onChange === void 0 ? void 0 : onChange(mergedChecked, event);
    }
    return mergedChecked;
  }
  function onInternalKeyDown(e3) {
    if (e3.which === KeyCode_default.LEFT) {
      triggerChange(false, e3);
    } else if (e3.which === KeyCode_default.RIGHT) {
      triggerChange(true, e3);
    }
    onKeyDown2 === null || onKeyDown2 === void 0 ? void 0 : onKeyDown2(e3);
  }
  function onInternalClick(e3) {
    var ret = triggerChange(!innerChecked, e3);
    onClick === null || onClick === void 0 ? void 0 : onClick(ret, e3);
  }
  var switchClassName = (0, import_classnames173.default)(prefixCls, className2, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-checked"), innerChecked), _defineProperty(_classNames, "".concat(prefixCls, "-disabled"), disabled), _classNames));
  return /* @__PURE__ */ React422.createElement("button", _extends({}, restProps, {
    type: "button",
    role: "switch",
    "aria-checked": innerChecked,
    disabled,
    className: switchClassName,
    ref: ref3,
    onKeyDown: onInternalKeyDown,
    onClick: onInternalClick
  }), loadingIcon, /* @__PURE__ */ React422.createElement("span", {
    className: "".concat(prefixCls, "-inner")
  }, /* @__PURE__ */ React422.createElement("span", {
    className: "".concat(prefixCls, "-inner-checked")
  }, checkedChildren), /* @__PURE__ */ React422.createElement("span", {
    className: "".concat(prefixCls, "-inner-unchecked")
  }, unCheckedChildren)));
});
Switch.displayName = "Switch";
var es_default26 = Switch;

// ../../node_modules/antd/es/switch/style/index.js
var genSwitchSmallStyle = (token2) => {
  const {
    componentCls,
    trackHeightSM,
    trackPadding,
    trackMinWidthSM,
    innerMinMarginSM,
    innerMaxMarginSM,
    handleSizeSM,
    calc
  } = token2;
  const switchInnerCls = `${componentCls}-inner`;
  const trackPaddingCalc = unit(calc(handleSizeSM).add(calc(trackPadding).mul(2)).equal());
  const innerMaxMarginCalc = unit(calc(innerMaxMarginSM).mul(2).equal());
  return {
    [componentCls]: {
      [`&${componentCls}-small`]: {
        minWidth: trackMinWidthSM,
        height: trackHeightSM,
        lineHeight: unit(trackHeightSM),
        [`${componentCls}-inner`]: {
          paddingInlineStart: innerMaxMarginSM,
          paddingInlineEnd: innerMinMarginSM,
          [`${switchInnerCls}-checked, ${switchInnerCls}-unchecked`]: {
            minHeight: trackHeightSM
          },
          [`${switchInnerCls}-checked`]: {
            marginInlineStart: `calc(-100% + ${trackPaddingCalc} - ${innerMaxMarginCalc})`,
            marginInlineEnd: `calc(100% - ${trackPaddingCalc} + ${innerMaxMarginCalc})`
          },
          [`${switchInnerCls}-unchecked`]: {
            marginTop: calc(trackHeightSM).mul(-1).equal(),
            marginInlineStart: 0,
            marginInlineEnd: 0
          }
        },
        [`${componentCls}-handle`]: {
          width: handleSizeSM,
          height: handleSizeSM
        },
        [`${componentCls}-loading-icon`]: {
          top: calc(calc(handleSizeSM).sub(token2.switchLoadingIconSize)).div(2).equal(),
          fontSize: token2.switchLoadingIconSize
        },
        [`&${componentCls}-checked`]: {
          [`${componentCls}-inner`]: {
            paddingInlineStart: innerMinMarginSM,
            paddingInlineEnd: innerMaxMarginSM,
            [`${switchInnerCls}-checked`]: {
              marginInlineStart: 0,
              marginInlineEnd: 0
            },
            [`${switchInnerCls}-unchecked`]: {
              marginInlineStart: `calc(100% - ${trackPaddingCalc} + ${innerMaxMarginCalc})`,
              marginInlineEnd: `calc(-100% + ${trackPaddingCalc} - ${innerMaxMarginCalc})`
            }
          },
          [`${componentCls}-handle`]: {
            insetInlineStart: `calc(100% - ${unit(calc(handleSizeSM).add(trackPadding).equal())})`
          }
        },
        [`&:not(${componentCls}-disabled):active`]: {
          [`&:not(${componentCls}-checked) ${switchInnerCls}`]: {
            [`${switchInnerCls}-unchecked`]: {
              marginInlineStart: calc(token2.marginXXS).div(2).equal(),
              marginInlineEnd: calc(token2.marginXXS).mul(-1).div(2).equal()
            }
          },
          [`&${componentCls}-checked ${switchInnerCls}`]: {
            [`${switchInnerCls}-checked`]: {
              marginInlineStart: calc(token2.marginXXS).mul(-1).div(2).equal(),
              marginInlineEnd: calc(token2.marginXXS).div(2).equal()
            }
          }
        }
      }
    }
  };
};
var genSwitchLoadingStyle = (token2) => {
  const {
    componentCls,
    handleSize,
    calc
  } = token2;
  return {
    [componentCls]: {
      [`${componentCls}-loading-icon${token2.iconCls}`]: {
        position: "relative",
        top: calc(calc(handleSize).sub(token2.fontSize)).div(2).equal(),
        color: token2.switchLoadingIconColor,
        verticalAlign: "top"
      },
      [`&${componentCls}-checked ${componentCls}-loading-icon`]: {
        color: token2.switchColor
      }
    }
  };
};
var genSwitchHandleStyle = (token2) => {
  const {
    componentCls,
    trackPadding,
    handleBg,
    handleShadow,
    handleSize,
    calc
  } = token2;
  const switchHandleCls = `${componentCls}-handle`;
  return {
    [componentCls]: {
      [switchHandleCls]: {
        position: "absolute",
        top: trackPadding,
        insetInlineStart: trackPadding,
        width: handleSize,
        height: handleSize,
        transition: `all ${token2.switchDuration} ease-in-out`,
        "&::before": {
          position: "absolute",
          top: 0,
          insetInlineEnd: 0,
          bottom: 0,
          insetInlineStart: 0,
          backgroundColor: handleBg,
          borderRadius: calc(handleSize).div(2).equal(),
          boxShadow: handleShadow,
          transition: `all ${token2.switchDuration} ease-in-out`,
          content: '""'
        }
      },
      [`&${componentCls}-checked ${switchHandleCls}`]: {
        insetInlineStart: `calc(100% - ${unit(calc(handleSize).add(trackPadding).equal())})`
      },
      [`&:not(${componentCls}-disabled):active`]: {
        [`${switchHandleCls}::before`]: {
          insetInlineEnd: token2.switchHandleActiveInset,
          insetInlineStart: 0
        },
        [`&${componentCls}-checked ${switchHandleCls}::before`]: {
          insetInlineEnd: 0,
          insetInlineStart: token2.switchHandleActiveInset
        }
      }
    }
  };
};
var genSwitchInnerStyle = (token2) => {
  const {
    componentCls,
    trackHeight,
    trackPadding,
    innerMinMargin,
    innerMaxMargin,
    handleSize,
    calc
  } = token2;
  const switchInnerCls = `${componentCls}-inner`;
  const trackPaddingCalc = unit(calc(handleSize).add(calc(trackPadding).mul(2)).equal());
  const innerMaxMarginCalc = unit(calc(innerMaxMargin).mul(2).equal());
  return {
    [componentCls]: {
      [switchInnerCls]: {
        display: "block",
        overflow: "hidden",
        borderRadius: 100,
        height: "100%",
        paddingInlineStart: innerMaxMargin,
        paddingInlineEnd: innerMinMargin,
        transition: `padding-inline-start ${token2.switchDuration} ease-in-out, padding-inline-end ${token2.switchDuration} ease-in-out`,
        [`${switchInnerCls}-checked, ${switchInnerCls}-unchecked`]: {
          display: "block",
          color: token2.colorTextLightSolid,
          fontSize: token2.fontSizeSM,
          transition: `margin-inline-start ${token2.switchDuration} ease-in-out, margin-inline-end ${token2.switchDuration} ease-in-out`,
          pointerEvents: "none",
          minHeight: trackHeight
        },
        [`${switchInnerCls}-checked`]: {
          marginInlineStart: `calc(-100% + ${trackPaddingCalc} - ${innerMaxMarginCalc})`,
          marginInlineEnd: `calc(100% - ${trackPaddingCalc} + ${innerMaxMarginCalc})`
        },
        [`${switchInnerCls}-unchecked`]: {
          marginTop: calc(trackHeight).mul(-1).equal(),
          marginInlineStart: 0,
          marginInlineEnd: 0
        }
      },
      [`&${componentCls}-checked ${switchInnerCls}`]: {
        paddingInlineStart: innerMinMargin,
        paddingInlineEnd: innerMaxMargin,
        [`${switchInnerCls}-checked`]: {
          marginInlineStart: 0,
          marginInlineEnd: 0
        },
        [`${switchInnerCls}-unchecked`]: {
          marginInlineStart: `calc(100% - ${trackPaddingCalc} + ${innerMaxMarginCalc})`,
          marginInlineEnd: `calc(-100% + ${trackPaddingCalc} - ${innerMaxMarginCalc})`
        }
      },
      [`&:not(${componentCls}-disabled):active`]: {
        [`&:not(${componentCls}-checked) ${switchInnerCls}`]: {
          [`${switchInnerCls}-unchecked`]: {
            marginInlineStart: calc(trackPadding).mul(2).equal(),
            marginInlineEnd: calc(trackPadding).mul(-1).mul(2).equal()
          }
        },
        [`&${componentCls}-checked ${switchInnerCls}`]: {
          [`${switchInnerCls}-checked`]: {
            marginInlineStart: calc(trackPadding).mul(-1).mul(2).equal(),
            marginInlineEnd: calc(trackPadding).mul(2).equal()
          }
        }
      }
    }
  };
};
var genSwitchStyle = (token2) => {
  const {
    componentCls,
    trackHeight,
    trackMinWidth
  } = token2;
  return {
    [componentCls]: Object.assign(Object.assign(Object.assign(Object.assign({}, resetComponent(token2)), {
      position: "relative",
      display: "inline-block",
      boxSizing: "border-box",
      minWidth: trackMinWidth,
      height: trackHeight,
      lineHeight: unit(trackHeight),
      verticalAlign: "middle",
      background: token2.colorTextQuaternary,
      border: "0",
      borderRadius: 100,
      cursor: "pointer",
      transition: `all ${token2.motionDurationMid}`,
      userSelect: "none",
      [`&:hover:not(${componentCls}-disabled)`]: {
        background: token2.colorTextTertiary
      }
    }), genFocusStyle(token2)), {
      [`&${componentCls}-checked`]: {
        background: token2.switchColor,
        [`&:hover:not(${componentCls}-disabled)`]: {
          background: token2.colorPrimaryHover
        }
      },
      [`&${componentCls}-loading, &${componentCls}-disabled`]: {
        cursor: "not-allowed",
        opacity: token2.switchDisabledOpacity,
        "*": {
          boxShadow: "none",
          cursor: "not-allowed"
        }
      },
      // rtl style
      [`&${componentCls}-rtl`]: {
        direction: "rtl"
      }
    })
  };
};
var prepareComponentToken29 = (token2) => {
  const {
    fontSize,
    lineHeight,
    controlHeight,
    colorWhite
  } = token2;
  const height = fontSize * lineHeight;
  const heightSM = controlHeight / 2;
  const padding = 2;
  const handleSize = height - padding * 2;
  const handleSizeSM = heightSM - padding * 2;
  return {
    trackHeight: height,
    trackHeightSM: heightSM,
    trackMinWidth: handleSize * 2 + padding * 4,
    trackMinWidthSM: handleSizeSM * 2 + padding * 2,
    trackPadding: padding,
    // Fixed value
    handleBg: colorWhite,
    handleSize,
    handleSizeSM,
    handleShadow: `0 2px 4px 0 ${new FastColor("#00230b").setA(0.2).toRgbString()}`,
    innerMinMargin: handleSize / 2,
    innerMaxMargin: handleSize + padding + padding * 2,
    innerMinMarginSM: handleSizeSM / 2,
    innerMaxMarginSM: handleSizeSM + padding + padding * 2
  };
};
var style_default34 = genStyleHooks("Switch", (token2) => {
  const switchToken = merge2(token2, {
    switchDuration: token2.motionDurationMid,
    switchColor: token2.colorPrimary,
    switchDisabledOpacity: token2.opacityLoading,
    switchLoadingIconSize: token2.calc(token2.fontSizeIcon).mul(0.75).equal(),
    switchLoadingIconColor: `rgba(0, 0, 0, ${token2.opacityLoading})`,
    switchHandleActiveInset: "-30%"
  });
  return [
    genSwitchStyle(switchToken),
    // inner style
    genSwitchInnerStyle(switchToken),
    // handle style
    genSwitchHandleStyle(switchToken),
    // loading style
    genSwitchLoadingStyle(switchToken),
    // small style
    genSwitchSmallStyle(switchToken)
  ];
}, prepareComponentToken29);

// ../../node_modules/antd/es/switch/index.js
var __rest61 = function(s, e3) {
  var t2 = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e3.indexOf(p) < 0) t2[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e3.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t2[p[i]] = s[p[i]];
  }
  return t2;
};
var InternalSwitch = /* @__PURE__ */ React423.forwardRef((props, ref3) => {
  const {
    prefixCls: customizePrefixCls,
    size: customizeSize,
    disabled: customDisabled,
    loading,
    className: className2,
    rootClassName,
    style: style2,
    checked: checkedProp,
    value,
    defaultChecked: defaultCheckedProp,
    defaultValue: defaultValue2,
    onChange
  } = props, restProps = __rest61(props, ["prefixCls", "size", "disabled", "loading", "className", "rootClassName", "style", "checked", "value", "defaultChecked", "defaultValue", "onChange"]);
  const [checked, setChecked] = useMergedState(false, {
    value: checkedProp !== null && checkedProp !== void 0 ? checkedProp : value,
    defaultValue: defaultCheckedProp !== null && defaultCheckedProp !== void 0 ? defaultCheckedProp : defaultValue2
  });
  const {
    getPrefixCls,
    direction,
    switch: SWITCH
  } = React423.useContext(ConfigContext);
  const disabled = React423.useContext(DisabledContext_default);
  const mergedDisabled = (customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled) || loading;
  const prefixCls = getPrefixCls("switch", customizePrefixCls);
  const loadingIcon = /* @__PURE__ */ React423.createElement("div", {
    className: `${prefixCls}-handle`
  }, loading && /* @__PURE__ */ React423.createElement(LoadingOutlined_default2, {
    className: `${prefixCls}-loading-icon`
  }));
  const [wrapCSSVar, hashId, cssVarCls] = style_default34(prefixCls);
  const mergedSize = useSize_default(customizeSize);
  const classes = (0, import_classnames174.default)(SWITCH === null || SWITCH === void 0 ? void 0 : SWITCH.className, {
    [`${prefixCls}-small`]: mergedSize === "small",
    [`${prefixCls}-loading`]: loading,
    [`${prefixCls}-rtl`]: direction === "rtl"
  }, className2, rootClassName, hashId, cssVarCls);
  const mergedStyle = Object.assign(Object.assign({}, SWITCH === null || SWITCH === void 0 ? void 0 : SWITCH.style), style2);
  const changeHandler = (...args) => {
    setChecked(args[0]);
    onChange === null || onChange === void 0 ? void 0 : onChange.apply(void 0, args);
  };
  return wrapCSSVar(/* @__PURE__ */ React423.createElement(wave_default, {
    component: "Switch"
  }, /* @__PURE__ */ React423.createElement(es_default26, Object.assign({}, restProps, {
    checked,
    onChange: changeHandler,
    prefixCls,
    className: classes,
    style: mergedStyle,
    disabled: mergedDisabled,
    ref: ref3,
    loadingIcon
  }))));
});
var Switch2 = InternalSwitch;
Switch2.__ANT_SWITCH = true;
if (true) {
  Switch2.displayName = "Switch";
}
var switch_default = Switch2;

// ../../node_modules/antd/es/table/Table.js
var React491 = __toESM(require_react());

// ../../node_modules/rc-table/es/constant.js
var EXPAND_COLUMN = {};
var INTERNAL_HOOKS = "rc-table-internal-hook";

// ../../node_modules/@rc-component/context/es/context.js
var React424 = __toESM(require_react());
var import_react_dom11 = __toESM(require_react_dom());
function createContext44(defaultValue2) {
  var Context4 = /* @__PURE__ */ React424.createContext(void 0);
  var Provider = function Provider2(_ref) {
    var value = _ref.value, children = _ref.children;
    var valueRef = React424.useRef(value);
    valueRef.current = value;
    var _React$useState = React424.useState(function() {
      return {
        getValue: function getValue4() {
          return valueRef.current;
        },
        listeners: /* @__PURE__ */ new Set()
      };
    }), _React$useState2 = _slicedToArray(_React$useState, 1), context = _React$useState2[0];
    useLayoutEffect_default(function() {
      (0, import_react_dom11.unstable_batchedUpdates)(function() {
        context.listeners.forEach(function(listener) {
          listener(value);
        });
      });
    }, [value]);
    return /* @__PURE__ */ React424.createElement(Context4.Provider, {
      value: context
    }, children);
  };
  return {
    Context: Context4,
    Provider,
    defaultValue: defaultValue2
  };
}
function useContext151(holder, selector) {
  var eventSelector = useEvent2(typeof selector === "function" ? selector : function(ctx) {
    if (selector === void 0) {
      return ctx;
    }
    if (!Array.isArray(selector)) {
      return ctx[selector];
    }
    var obj = {};
    selector.forEach(function(key2) {
      obj[key2] = ctx[key2];
    });
    return obj;
  });
  var context = React424.useContext(holder === null || holder === void 0 ? void 0 : holder.Context);
  var _ref2 = context || {}, listeners = _ref2.listeners, getValue4 = _ref2.getValue;
  var valueRef = React424.useRef();
  valueRef.current = eventSelector(context ? getValue4() : holder === null || holder === void 0 ? void 0 : holder.defaultValue);
  var _React$useState3 = React424.useState({}), _React$useState4 = _slicedToArray(_React$useState3, 2), forceUpdate = _React$useState4[1];
  useLayoutEffect_default(function() {
    if (!context) {
      return;
    }
    function trigger2(nextValue) {
      var nextSelectorValue = eventSelector(nextValue);
      if (!isEqual_default(valueRef.current, nextSelectorValue, true)) {
        forceUpdate({});
      }
    }
    listeners.add(trigger2);
    return function() {
      listeners.delete(trigger2);
    };
  }, [context]);
  return valueRef.current;
}

// ../../node_modules/@rc-component/context/es/Immutable.js
var React425 = __toESM(require_react());
function createImmutable() {
  var ImmutableContext = /* @__PURE__ */ React425.createContext(null);
  function useImmutableMark3() {
    return React425.useContext(ImmutableContext);
  }
  function makeImmutable3(Component10, shouldTriggerRender) {
    var refAble = supportRef(Component10);
    var ImmutableComponent = function ImmutableComponent2(props, ref3) {
      var refProps = refAble ? {
        ref: ref3
      } : {};
      var renderTimesRef = React425.useRef(0);
      var prevProps = React425.useRef(props);
      var mark = useImmutableMark3();
      if (mark !== null) {
        return /* @__PURE__ */ React425.createElement(Component10, _extends({}, props, refProps));
      }
      if (
        // Always trigger re-render if not provide `notTriggerRender`
        !shouldTriggerRender || shouldTriggerRender(prevProps.current, props)
      ) {
        renderTimesRef.current += 1;
      }
      prevProps.current = props;
      return /* @__PURE__ */ React425.createElement(ImmutableContext.Provider, {
        value: renderTimesRef.current
      }, /* @__PURE__ */ React425.createElement(Component10, _extends({}, props, refProps)));
    };
    if (true) {
      ImmutableComponent.displayName = "ImmutableRoot(".concat(Component10.displayName || Component10.name, ")");
    }
    return refAble ? /* @__PURE__ */ React425.forwardRef(ImmutableComponent) : ImmutableComponent;
  }
  function responseImmutable3(Component10, propsAreEqual) {
    var refAble = supportRef(Component10);
    var ImmutableComponent = function ImmutableComponent2(props, ref3) {
      var refProps = refAble ? {
        ref: ref3
      } : {};
      useImmutableMark3();
      return /* @__PURE__ */ React425.createElement(Component10, _extends({}, props, refProps));
    };
    if (true) {
      ImmutableComponent.displayName = "ImmutableResponse(".concat(Component10.displayName || Component10.name, ")");
    }
    return refAble ? /* @__PURE__ */ React425.memo(/* @__PURE__ */ React425.forwardRef(ImmutableComponent), propsAreEqual) : /* @__PURE__ */ React425.memo(ImmutableComponent, propsAreEqual);
  }
  return {
    makeImmutable: makeImmutable3,
    responseImmutable: responseImmutable3,
    useImmutableMark: useImmutableMark3
  };
}

// ../../node_modules/@rc-component/context/es/index.js
var _createImmutable = createImmutable();
var makeImmutable = _createImmutable.makeImmutable;
var responseImmutable = _createImmutable.responseImmutable;
var useImmutableMark = _createImmutable.useImmutableMark;

// ../../node_modules/rc-table/es/Footer/index.js
var React433 = __toESM(require_react());

// ../../node_modules/rc-table/es/context/TableContext.js
var _createImmutable2 = createImmutable();
var makeImmutable2 = _createImmutable2.makeImmutable;
var responseImmutable2 = _createImmutable2.responseImmutable;
var useImmutableMark2 = _createImmutable2.useImmutableMark;
var TableContext = createContext44();
var TableContext_default = TableContext;

// ../../node_modules/rc-table/es/hooks/useRenderTimes.js
var React426 = __toESM(require_react());
function useRenderTimes(props, debug) {
  var timesRef = React426.useRef(0);
  timesRef.current += 1;
  var propsRef = React426.useRef(props);
  var keys4 = [];
  Object.keys(props || {}).map(function(key2) {
    var _propsRef$current;
    if ((props === null || props === void 0 ? void 0 : props[key2]) !== ((_propsRef$current = propsRef.current) === null || _propsRef$current === void 0 ? void 0 : _propsRef$current[key2])) {
      keys4.push(key2);
    }
  });
  propsRef.current = props;
  var keysRef = React426.useRef([]);
  if (keys4.length) {
    keysRef.current = keys4;
  }
  React426.useDebugValue(timesRef.current);
  React426.useDebugValue(keysRef.current.join(", "));
  if (debug) {
    console.log("".concat(debug, ":"), timesRef.current, keysRef.current);
  }
  return timesRef.current;
}
var useRenderTimes_default = true ? useRenderTimes : function() {
};
var RenderBlock = /* @__PURE__ */ React426.memo(function() {
  var times = useRenderTimes();
  return /* @__PURE__ */ React426.createElement("h1", null, "Render Times: ", times);
});
if (true) {
  RenderBlock.displayName = "RenderBlock";
}

// ../../node_modules/rc-table/es/Footer/Cell.js
var React431 = __toESM(require_react());

// ../../node_modules/rc-table/es/Cell/index.js
var import_classnames175 = __toESM(require_classnames());
var React429 = __toESM(require_react());

// ../../node_modules/rc-table/es/Cell/useCellRender.js
var React428 = __toESM(require_react());

// ../../node_modules/rc-table/es/context/PerfContext.js
var React427 = __toESM(require_react());
var PerfContext = /* @__PURE__ */ React427.createContext({
  renderWithProps: false
});
var PerfContext_default = PerfContext;

// ../../node_modules/rc-table/es/utils/valueUtil.js
var INTERNAL_KEY_PREFIX = "RC_TABLE_KEY";
function toArray8(arr) {
  if (arr === void 0 || arr === null) {
    return [];
  }
  return Array.isArray(arr) ? arr : [arr];
}
function getColumnsKey(columns) {
  var columnKeys = [];
  var keys4 = {};
  columns.forEach(function(column2) {
    var _ref = column2 || {}, key2 = _ref.key, dataIndex = _ref.dataIndex;
    var mergedKey = key2 || toArray8(dataIndex).join("-") || INTERNAL_KEY_PREFIX;
    while (keys4[mergedKey]) {
      mergedKey = "".concat(mergedKey, "_next");
    }
    keys4[mergedKey] = true;
    columnKeys.push(mergedKey);
  });
  return columnKeys;
}
function validateValue(val) {
  return val !== null && val !== void 0;
}
function validNumberValue(value) {
  return typeof value === "number" && !Number.isNaN(value);
}

// ../../node_modules/rc-table/es/Cell/useCellRender.js
function isRenderCell(data2) {
  return data2 && _typeof(data2) === "object" && !Array.isArray(data2) && !/* @__PURE__ */ React428.isValidElement(data2);
}
function useCellRender2(record, dataIndex, renderIndex, children, render4, shouldCellUpdate) {
  var perfRecord = React428.useContext(PerfContext_default);
  var mark = useImmutableMark2();
  var retData = useMemo3(function() {
    if (validateValue(children)) {
      return [children];
    }
    var path2 = dataIndex === null || dataIndex === void 0 || dataIndex === "" ? [] : Array.isArray(dataIndex) ? dataIndex : [dataIndex];
    var value = get(record, path2);
    var returnChildNode = value;
    var returnCellProps = void 0;
    if (render4) {
      var renderData = render4(value, record, renderIndex);
      if (isRenderCell(renderData)) {
        if (true) {
          warning_default(false, "`columns.render` return cell props is deprecated with perf issue, please use `onCell` instead.");
        }
        returnChildNode = renderData.children;
        returnCellProps = renderData.props;
        perfRecord.renderWithProps = true;
      } else {
        returnChildNode = renderData;
      }
    }
    return [returnChildNode, returnCellProps];
  }, [
    // Force update deps
    mark,
    // Normal deps
    record,
    children,
    dataIndex,
    render4,
    renderIndex
  ], function(prev2, next2) {
    if (shouldCellUpdate) {
      var _prev = _slicedToArray(prev2, 2), prevRecord = _prev[1];
      var _next = _slicedToArray(next2, 2), nextRecord = _next[1];
      return shouldCellUpdate(nextRecord, prevRecord);
    }
    if (perfRecord.renderWithProps) {
      return true;
    }
    return !isEqual_default(prev2, next2, true);
  });
  return retData;
}

// ../../node_modules/rc-table/es/Cell/useHoverState.js
function inHoverRange(cellStartRow, cellRowSpan, startRow, endRow) {
  var cellEndRow = cellStartRow + cellRowSpan - 1;
  return cellStartRow <= endRow && cellEndRow >= startRow;
}
function useHoverState(rowIndex, rowSpan) {
  return useContext151(TableContext_default, function(ctx) {
    var hovering = inHoverRange(rowIndex, rowSpan || 1, ctx.hoverStartRow, ctx.hoverEndRow);
    return [hovering, ctx.onHover];
  });
}

// ../../node_modules/rc-table/es/Cell/index.js
var getTitleFromCellRenderChildren = function getTitleFromCellRenderChildren2(_ref) {
  var ellipsis = _ref.ellipsis, rowType = _ref.rowType, children = _ref.children;
  var title;
  var ellipsisConfig = ellipsis === true ? {
    showTitle: true
  } : ellipsis;
  if (ellipsisConfig && (ellipsisConfig.showTitle || rowType === "header")) {
    if (typeof children === "string" || typeof children === "number") {
      title = children.toString();
    } else if (/* @__PURE__ */ React429.isValidElement(children) && typeof children.props.children === "string") {
      title = children.props.children;
    }
  }
  return title;
};
function Cell2(props) {
  var _ref2, _ref3, _legacyCellProps$colS, _ref4, _ref5, _legacyCellProps$rowS, _additionalProps$titl, _classNames;
  if (true) {
    useRenderTimes_default(props);
  }
  var Component10 = props.component, children = props.children, ellipsis = props.ellipsis, scope = props.scope, prefixCls = props.prefixCls, className2 = props.className, align = props.align, record = props.record, render4 = props.render, dataIndex = props.dataIndex, renderIndex = props.renderIndex, shouldCellUpdate = props.shouldCellUpdate, index3 = props.index, rowType = props.rowType, colSpan = props.colSpan, rowSpan = props.rowSpan, fixLeft = props.fixLeft, fixRight = props.fixRight, firstFixLeft = props.firstFixLeft, lastFixLeft = props.lastFixLeft, firstFixRight = props.firstFixRight, lastFixRight = props.lastFixRight, appendNode = props.appendNode, _props$additionalProp = props.additionalProps, additionalProps = _props$additionalProp === void 0 ? {} : _props$additionalProp, isSticky = props.isSticky;
  var cellPrefixCls = "".concat(prefixCls, "-cell");
  var _useContext = useContext151(TableContext_default, ["supportSticky", "allColumnsFixedLeft", "rowHoverable"]), supportSticky = _useContext.supportSticky, allColumnsFixedLeft = _useContext.allColumnsFixedLeft, rowHoverable = _useContext.rowHoverable;
  var _useCellRender = useCellRender2(record, dataIndex, renderIndex, children, render4, shouldCellUpdate), _useCellRender2 = _slicedToArray(_useCellRender, 2), childNode = _useCellRender2[0], legacyCellProps = _useCellRender2[1];
  var fixedStyle = {};
  var isFixLeft = typeof fixLeft === "number" && supportSticky;
  var isFixRight = typeof fixRight === "number" && supportSticky;
  if (isFixLeft) {
    fixedStyle.position = "sticky";
    fixedStyle.left = fixLeft;
  }
  if (isFixRight) {
    fixedStyle.position = "sticky";
    fixedStyle.right = fixRight;
  }
  var mergedColSpan = (_ref2 = (_ref3 = (_legacyCellProps$colS = legacyCellProps === null || legacyCellProps === void 0 ? void 0 : legacyCellProps.colSpan) !== null && _legacyCellProps$colS !== void 0 ? _legacyCellProps$colS : additionalProps.colSpan) !== null && _ref3 !== void 0 ? _ref3 : colSpan) !== null && _ref2 !== void 0 ? _ref2 : 1;
  var mergedRowSpan = (_ref4 = (_ref5 = (_legacyCellProps$rowS = legacyCellProps === null || legacyCellProps === void 0 ? void 0 : legacyCellProps.rowSpan) !== null && _legacyCellProps$rowS !== void 0 ? _legacyCellProps$rowS : additionalProps.rowSpan) !== null && _ref5 !== void 0 ? _ref5 : rowSpan) !== null && _ref4 !== void 0 ? _ref4 : 1;
  var _useHoverState = useHoverState(index3, mergedRowSpan), _useHoverState2 = _slicedToArray(_useHoverState, 2), hovering = _useHoverState2[0], onHover = _useHoverState2[1];
  var onMouseEnter = useEvent2(function(event) {
    var _additionalProps$onMo;
    if (record) {
      onHover(index3, index3 + mergedRowSpan - 1);
    }
    additionalProps === null || additionalProps === void 0 || (_additionalProps$onMo = additionalProps.onMouseEnter) === null || _additionalProps$onMo === void 0 || _additionalProps$onMo.call(additionalProps, event);
  });
  var onMouseLeave = useEvent2(function(event) {
    var _additionalProps$onMo2;
    if (record) {
      onHover(-1, -1);
    }
    additionalProps === null || additionalProps === void 0 || (_additionalProps$onMo2 = additionalProps.onMouseLeave) === null || _additionalProps$onMo2 === void 0 || _additionalProps$onMo2.call(additionalProps, event);
  });
  if (mergedColSpan === 0 || mergedRowSpan === 0) {
    return null;
  }
  var title = (_additionalProps$titl = additionalProps.title) !== null && _additionalProps$titl !== void 0 ? _additionalProps$titl : getTitleFromCellRenderChildren({
    rowType,
    ellipsis,
    children: childNode
  });
  var mergedClassName = (0, import_classnames175.default)(cellPrefixCls, className2, (_classNames = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_classNames, "".concat(cellPrefixCls, "-fix-left"), isFixLeft && supportSticky), "".concat(cellPrefixCls, "-fix-left-first"), firstFixLeft && supportSticky), "".concat(cellPrefixCls, "-fix-left-last"), lastFixLeft && supportSticky), "".concat(cellPrefixCls, "-fix-left-all"), lastFixLeft && allColumnsFixedLeft && supportSticky), "".concat(cellPrefixCls, "-fix-right"), isFixRight && supportSticky), "".concat(cellPrefixCls, "-fix-right-first"), firstFixRight && supportSticky), "".concat(cellPrefixCls, "-fix-right-last"), lastFixRight && supportSticky), "".concat(cellPrefixCls, "-ellipsis"), ellipsis), "".concat(cellPrefixCls, "-with-append"), appendNode), "".concat(cellPrefixCls, "-fix-sticky"), (isFixLeft || isFixRight) && isSticky && supportSticky), _defineProperty(_classNames, "".concat(cellPrefixCls, "-row-hover"), !legacyCellProps && hovering)), additionalProps.className, legacyCellProps === null || legacyCellProps === void 0 ? void 0 : legacyCellProps.className);
  var alignStyle = {};
  if (align) {
    alignStyle.textAlign = align;
  }
  var mergedStyle = _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, legacyCellProps === null || legacyCellProps === void 0 ? void 0 : legacyCellProps.style), fixedStyle), alignStyle), additionalProps.style);
  var mergedChildNode = childNode;
  if (_typeof(mergedChildNode) === "object" && !Array.isArray(mergedChildNode) && !/* @__PURE__ */ React429.isValidElement(mergedChildNode)) {
    mergedChildNode = null;
  }
  if (ellipsis && (lastFixLeft || firstFixRight)) {
    mergedChildNode = /* @__PURE__ */ React429.createElement("span", {
      className: "".concat(cellPrefixCls, "-content")
    }, mergedChildNode);
  }
  return /* @__PURE__ */ React429.createElement(Component10, _extends({}, legacyCellProps, additionalProps, {
    className: mergedClassName,
    style: mergedStyle,
    title,
    scope,
    onMouseEnter: rowHoverable ? onMouseEnter : void 0,
    onMouseLeave: rowHoverable ? onMouseLeave : void 0,
    colSpan: mergedColSpan !== 1 ? mergedColSpan : null,
    rowSpan: mergedRowSpan !== 1 ? mergedRowSpan : null
  }), appendNode, mergedChildNode);
}
var Cell_default = /* @__PURE__ */ React429.memo(Cell2);

// ../../node_modules/rc-table/es/utils/fixUtil.js
function getCellFixedInfo(colStart, colEnd, columns, stickyOffsets, direction) {
  var startColumn = columns[colStart] || {};
  var endColumn = columns[colEnd] || {};
  var fixLeft;
  var fixRight;
  if (startColumn.fixed === "left") {
    fixLeft = stickyOffsets.left[direction === "rtl" ? colEnd : colStart];
  } else if (endColumn.fixed === "right") {
    fixRight = stickyOffsets.right[direction === "rtl" ? colStart : colEnd];
  }
  var lastFixLeft = false;
  var firstFixRight = false;
  var lastFixRight = false;
  var firstFixLeft = false;
  var nextColumn = columns[colEnd + 1];
  var prevColumn = columns[colStart - 1];
  var canLastFix = nextColumn && !nextColumn.fixed || prevColumn && !prevColumn.fixed || columns.every(function(col) {
    return col.fixed === "left";
  });
  if (direction === "rtl") {
    if (fixLeft !== void 0) {
      var prevFixLeft = prevColumn && prevColumn.fixed === "left";
      firstFixLeft = !prevFixLeft && canLastFix;
    } else if (fixRight !== void 0) {
      var nextFixRight = nextColumn && nextColumn.fixed === "right";
      lastFixRight = !nextFixRight && canLastFix;
    }
  } else if (fixLeft !== void 0) {
    var nextFixLeft = nextColumn && nextColumn.fixed === "left";
    lastFixLeft = !nextFixLeft && canLastFix;
  } else if (fixRight !== void 0) {
    var prevFixRight = prevColumn && prevColumn.fixed === "right";
    firstFixRight = !prevFixRight && canLastFix;
  }
  return {
    fixLeft,
    fixRight,
    lastFixLeft,
    firstFixRight,
    lastFixRight,
    firstFixLeft,
    isSticky: stickyOffsets.isSticky
  };
}

// ../../node_modules/rc-table/es/Footer/SummaryContext.js
var React430 = __toESM(require_react());
var SummaryContext = /* @__PURE__ */ React430.createContext({});
var SummaryContext_default = SummaryContext;

// ../../node_modules/rc-table/es/Footer/Cell.js
function SummaryCell(_ref) {
  var className2 = _ref.className, index3 = _ref.index, children = _ref.children, _ref$colSpan = _ref.colSpan, colSpan = _ref$colSpan === void 0 ? 1 : _ref$colSpan, rowSpan = _ref.rowSpan, align = _ref.align;
  var _useContext = useContext151(TableContext_default, ["prefixCls", "direction"]), prefixCls = _useContext.prefixCls, direction = _useContext.direction;
  var _React$useContext = React431.useContext(SummaryContext_default), scrollColumnIndex = _React$useContext.scrollColumnIndex, stickyOffsets = _React$useContext.stickyOffsets, flattenColumns = _React$useContext.flattenColumns;
  var lastIndex = index3 + colSpan - 1;
  var mergedColSpan = lastIndex + 1 === scrollColumnIndex ? colSpan + 1 : colSpan;
  var fixedInfo = getCellFixedInfo(index3, index3 + mergedColSpan - 1, flattenColumns, stickyOffsets, direction);
  return /* @__PURE__ */ React431.createElement(Cell_default, _extends({
    className: className2,
    index: index3,
    component: "td",
    prefixCls,
    record: null,
    dataIndex: null,
    align,
    colSpan: mergedColSpan,
    rowSpan,
    render: function render4() {
      return children;
    }
  }, fixedInfo));
}

// ../../node_modules/rc-table/es/Footer/Row.js
var React432 = __toESM(require_react());
var _excluded64 = ["children"];
function FooterRow(_ref) {
  var children = _ref.children, props = _objectWithoutProperties(_ref, _excluded64);
  return /* @__PURE__ */ React432.createElement("tr", props, children);
}

// ../../node_modules/rc-table/es/Footer/Summary.js
function Summary(_ref) {
  var children = _ref.children;
  return children;
}
Summary.Row = FooterRow;
Summary.Cell = SummaryCell;
var Summary_default = Summary;

// ../../node_modules/rc-table/es/Footer/index.js
function Footer2(props) {
  if (true) {
    useRenderTimes_default(props);
  }
  var children = props.children, stickyOffsets = props.stickyOffsets, flattenColumns = props.flattenColumns;
  var prefixCls = useContext151(TableContext_default, "prefixCls");
  var lastColumnIndex = flattenColumns.length - 1;
  var scrollColumn = flattenColumns[lastColumnIndex];
  var summaryContext = React433.useMemo(function() {
    return {
      stickyOffsets,
      flattenColumns,
      scrollColumnIndex: scrollColumn !== null && scrollColumn !== void 0 && scrollColumn.scrollbar ? lastColumnIndex : null
    };
  }, [scrollColumn, flattenColumns, lastColumnIndex, stickyOffsets]);
  return /* @__PURE__ */ React433.createElement(SummaryContext_default.Provider, {
    value: summaryContext
  }, /* @__PURE__ */ React433.createElement("tfoot", {
    className: "".concat(prefixCls, "-summary")
  }, children));
}
var Footer_default = responseImmutable2(Footer2);
var FooterComponents = Summary_default;

// ../../node_modules/rc-table/es/sugar/Column.js
function Column2(_) {
  return null;
}
var Column_default = Column2;

// ../../node_modules/rc-table/es/sugar/ColumnGroup.js
function ColumnGroup(_) {
  return null;
}
var ColumnGroup_default = ColumnGroup;

// ../../node_modules/rc-table/es/Table.js
var import_classnames181 = __toESM(require_classnames());
var React452 = __toESM(require_react());

// ../../node_modules/rc-table/es/Body/index.js
var React440 = __toESM(require_react());

// ../../node_modules/rc-table/es/hooks/useFlattenRecords.js
var React434 = __toESM(require_react());
function fillRecords(list, record, indent, childrenColumnName, expandedKeys, getRowKey, index3) {
  var key2 = getRowKey(record, index3);
  list.push({
    record,
    indent,
    index: index3,
    rowKey: key2
  });
  var expanded = expandedKeys === null || expandedKeys === void 0 ? void 0 : expandedKeys.has(key2);
  if (record && Array.isArray(record[childrenColumnName]) && expanded) {
    for (var i = 0; i < record[childrenColumnName].length; i += 1) {
      fillRecords(list, record[childrenColumnName][i], indent + 1, childrenColumnName, expandedKeys, getRowKey, i);
    }
  }
}
function useFlattenRecords(data2, childrenColumnName, expandedKeys, getRowKey) {
  var arr = React434.useMemo(function() {
    if (expandedKeys !== null && expandedKeys !== void 0 && expandedKeys.size) {
      var list = [];
      for (var i = 0; i < (data2 === null || data2 === void 0 ? void 0 : data2.length); i += 1) {
        var record = data2[i];
        fillRecords(list, record, 0, childrenColumnName, expandedKeys, getRowKey, i);
      }
      return list;
    }
    return data2 === null || data2 === void 0 ? void 0 : data2.map(function(item, index3) {
      return {
        record: item,
        indent: 0,
        index: index3,
        rowKey: getRowKey(item, index3)
      };
    });
  }, [data2, childrenColumnName, expandedKeys, getRowKey]);
  return arr;
}

// ../../node_modules/rc-table/es/Body/BodyRow.js
var import_classnames178 = __toESM(require_classnames());
var React437 = __toESM(require_react());

// ../../node_modules/rc-table/es/hooks/useRowInfo.js
var import_classnames176 = __toESM(require_classnames());
function useRowInfo(record, rowKey, recordIndex, indent) {
  var context = useContext151(TableContext_default, ["prefixCls", "fixedInfoList", "flattenColumns", "expandableType", "expandRowByClick", "onTriggerExpand", "rowClassName", "expandedRowClassName", "indentSize", "expandIcon", "expandedRowRender", "expandIconColumnIndex", "expandedKeys", "childrenColumnName", "rowExpandable", "onRow"]);
  var flattenColumns = context.flattenColumns, expandableType = context.expandableType, expandedKeys = context.expandedKeys, childrenColumnName = context.childrenColumnName, onTriggerExpand = context.onTriggerExpand, rowExpandable = context.rowExpandable, onRow = context.onRow, expandRowByClick = context.expandRowByClick, rowClassName = context.rowClassName;
  var nestExpandable = expandableType === "nest";
  var rowSupportExpand = expandableType === "row" && (!rowExpandable || rowExpandable(record));
  var mergedExpandable = rowSupportExpand || nestExpandable;
  var expanded = expandedKeys && expandedKeys.has(rowKey);
  var hasNestChildren = childrenColumnName && record && record[childrenColumnName];
  var onInternalTriggerExpand = useEvent2(onTriggerExpand);
  var rowProps = onRow === null || onRow === void 0 ? void 0 : onRow(record, recordIndex);
  var onRowClick = rowProps === null || rowProps === void 0 ? void 0 : rowProps.onClick;
  var onClick = function onClick2(event) {
    if (expandRowByClick && mergedExpandable) {
      onTriggerExpand(record, event);
    }
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    onRowClick === null || onRowClick === void 0 || onRowClick.apply(void 0, [event].concat(args));
  };
  var computeRowClassName;
  if (typeof rowClassName === "string") {
    computeRowClassName = rowClassName;
  } else if (typeof rowClassName === "function") {
    computeRowClassName = rowClassName(record, recordIndex, indent);
  }
  var columnsKey = getColumnsKey(flattenColumns);
  return _objectSpread2(_objectSpread2({}, context), {}, {
    columnsKey,
    nestExpandable,
    expanded,
    hasNestChildren,
    record,
    onTriggerExpand: onInternalTriggerExpand,
    rowSupportExpand,
    expandable: mergedExpandable,
    rowProps: _objectSpread2(_objectSpread2({}, rowProps), {}, {
      className: (0, import_classnames176.default)(computeRowClassName, rowProps === null || rowProps === void 0 ? void 0 : rowProps.className),
      onClick
    })
  });
}

// ../../node_modules/rc-table/es/Body/ExpandedRow.js
var React435 = __toESM(require_react());
function ExpandedRow(props) {
  if (true) {
    useRenderTimes_default(props);
  }
  var prefixCls = props.prefixCls, children = props.children, Component10 = props.component, cellComponent = props.cellComponent, className2 = props.className, expanded = props.expanded, colSpan = props.colSpan, isEmpty2 = props.isEmpty, _props$stickyOffset = props.stickyOffset, stickyOffset = _props$stickyOffset === void 0 ? 0 : _props$stickyOffset;
  var _useContext = useContext151(TableContext_default, ["scrollbarSize", "fixHeader", "fixColumn", "componentWidth", "horizonScroll"]), scrollbarSize = _useContext.scrollbarSize, fixHeader = _useContext.fixHeader, fixColumn = _useContext.fixColumn, componentWidth = _useContext.componentWidth, horizonScroll = _useContext.horizonScroll;
  var contentNode = children;
  if (isEmpty2 ? horizonScroll && componentWidth : fixColumn) {
    contentNode = /* @__PURE__ */ React435.createElement("div", {
      style: {
        width: componentWidth - stickyOffset - (fixHeader && !isEmpty2 ? scrollbarSize : 0),
        position: "sticky",
        left: stickyOffset,
        overflow: "hidden"
      },
      className: "".concat(prefixCls, "-expanded-row-fixed")
    }, contentNode);
  }
  return /* @__PURE__ */ React435.createElement(Component10, {
    className: className2,
    style: {
      display: expanded ? null : "none"
    }
  }, /* @__PURE__ */ React435.createElement(Cell_default, {
    component: cellComponent,
    prefixCls,
    colSpan
  }, contentNode));
}
var ExpandedRow_default = ExpandedRow;

// ../../node_modules/rc-table/es/utils/expandUtil.js
var React436 = __toESM(require_react());
var import_classnames177 = __toESM(require_classnames());
function renderExpandIcon(_ref) {
  var prefixCls = _ref.prefixCls, record = _ref.record, onExpand = _ref.onExpand, expanded = _ref.expanded, expandable = _ref.expandable;
  var expandClassName = "".concat(prefixCls, "-row-expand-icon");
  if (!expandable) {
    return /* @__PURE__ */ React436.createElement("span", {
      className: (0, import_classnames177.default)(expandClassName, "".concat(prefixCls, "-row-spaced"))
    });
  }
  var onClick = function onClick2(event) {
    onExpand(record, event);
    event.stopPropagation();
  };
  return /* @__PURE__ */ React436.createElement("span", {
    className: (0, import_classnames177.default)(expandClassName, _defineProperty(_defineProperty({}, "".concat(prefixCls, "-row-expanded"), expanded), "".concat(prefixCls, "-row-collapsed"), !expanded)),
    onClick
  });
}
function findAllChildrenKeys(data2, getRowKey, childrenColumnName) {
  var keys4 = [];
  function dig(list) {
    (list || []).forEach(function(item, index3) {
      keys4.push(getRowKey(item, index3));
      dig(item[childrenColumnName]);
    });
  }
  dig(data2);
  return keys4;
}
function computedExpandedClassName(cls11, record, index3, indent) {
  if (typeof cls11 === "string") {
    return cls11;
  }
  if (typeof cls11 === "function") {
    return cls11(record, index3, indent);
  }
  return "";
}

// ../../node_modules/rc-table/es/Body/BodyRow.js
function getCellProps(rowInfo, column2, colIndex, indent, index3) {
  var _column$onCell;
  var rowKeys = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : [];
  var expandedRowOffset = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : 0;
  var record = rowInfo.record, prefixCls = rowInfo.prefixCls, columnsKey = rowInfo.columnsKey, fixedInfoList = rowInfo.fixedInfoList, expandIconColumnIndex = rowInfo.expandIconColumnIndex, nestExpandable = rowInfo.nestExpandable, indentSize = rowInfo.indentSize, expandIcon = rowInfo.expandIcon, expanded = rowInfo.expanded, hasNestChildren = rowInfo.hasNestChildren, onTriggerExpand = rowInfo.onTriggerExpand, expandable = rowInfo.expandable, expandedKeys = rowInfo.expandedKeys;
  var key2 = columnsKey[colIndex];
  var fixedInfo = fixedInfoList[colIndex];
  var appendCellNode;
  if (colIndex === (expandIconColumnIndex || 0) && nestExpandable) {
    appendCellNode = /* @__PURE__ */ React437.createElement(React437.Fragment, null, /* @__PURE__ */ React437.createElement("span", {
      style: {
        paddingLeft: "".concat(indentSize * indent, "px")
      },
      className: "".concat(prefixCls, "-row-indent indent-level-").concat(indent)
    }), expandIcon({
      prefixCls,
      expanded,
      expandable: hasNestChildren,
      record,
      onExpand: onTriggerExpand
    }));
  }
  var additionalCellProps = ((_column$onCell = column2.onCell) === null || _column$onCell === void 0 ? void 0 : _column$onCell.call(column2, record, index3)) || {};
  if (expandedRowOffset) {
    var _additionalCellProps$ = additionalCellProps.rowSpan, rowSpan = _additionalCellProps$ === void 0 ? 1 : _additionalCellProps$;
    if (expandable && rowSpan && colIndex < expandedRowOffset) {
      var currentRowSpan = rowSpan;
      for (var i = index3; i < index3 + rowSpan; i += 1) {
        var rowKey = rowKeys[i];
        if (expandedKeys.has(rowKey)) {
          currentRowSpan += 1;
        }
      }
      additionalCellProps.rowSpan = currentRowSpan;
    }
  }
  return {
    key: key2,
    fixedInfo,
    appendCellNode,
    additionalCellProps
  };
}
function BodyRow(props) {
  if (true) {
    useRenderTimes_default(props);
  }
  var className2 = props.className, style2 = props.style, record = props.record, index3 = props.index, renderIndex = props.renderIndex, rowKey = props.rowKey, rowKeys = props.rowKeys, _props$indent = props.indent, indent = _props$indent === void 0 ? 0 : _props$indent, RowComponent = props.rowComponent, cellComponent = props.cellComponent, scopeCellComponent = props.scopeCellComponent, expandedRowInfo = props.expandedRowInfo;
  var rowInfo = useRowInfo(record, rowKey, index3, indent);
  var prefixCls = rowInfo.prefixCls, flattenColumns = rowInfo.flattenColumns, expandedRowClassName = rowInfo.expandedRowClassName, expandedRowRender = rowInfo.expandedRowRender, rowProps = rowInfo.rowProps, expanded = rowInfo.expanded, rowSupportExpand = rowInfo.rowSupportExpand;
  var expandedRef = React437.useRef(false);
  expandedRef.current || (expandedRef.current = expanded);
  if (true) {
    useRenderTimes_default(props);
  }
  var expandedClsName = computedExpandedClassName(expandedRowClassName, record, index3, indent);
  var baseRowNode = /* @__PURE__ */ React437.createElement(RowComponent, _extends({}, rowProps, {
    "data-row-key": rowKey,
    className: (0, import_classnames178.default)(className2, "".concat(prefixCls, "-row"), "".concat(prefixCls, "-row-level-").concat(indent), rowProps === null || rowProps === void 0 ? void 0 : rowProps.className, _defineProperty({}, expandedClsName, indent >= 1)),
    style: _objectSpread2(_objectSpread2({}, style2), rowProps === null || rowProps === void 0 ? void 0 : rowProps.style)
  }), flattenColumns.map(function(column2, colIndex) {
    var render4 = column2.render, dataIndex = column2.dataIndex, columnClassName = column2.className;
    var _getCellProps = getCellProps(rowInfo, column2, colIndex, indent, index3, rowKeys, expandedRowInfo === null || expandedRowInfo === void 0 ? void 0 : expandedRowInfo.offset), key2 = _getCellProps.key, fixedInfo = _getCellProps.fixedInfo, appendCellNode = _getCellProps.appendCellNode, additionalCellProps = _getCellProps.additionalCellProps;
    return /* @__PURE__ */ React437.createElement(Cell_default, _extends({
      className: columnClassName,
      ellipsis: column2.ellipsis,
      align: column2.align,
      scope: column2.rowScope,
      component: column2.rowScope ? scopeCellComponent : cellComponent,
      prefixCls,
      key: key2,
      record,
      index: index3,
      renderIndex,
      dataIndex,
      render: render4,
      shouldCellUpdate: column2.shouldCellUpdate
    }, fixedInfo, {
      appendNode: appendCellNode,
      additionalProps: additionalCellProps
    }));
  }));
  var expandRowNode;
  if (rowSupportExpand && (expandedRef.current || expanded)) {
    var expandContent = expandedRowRender(record, index3, indent + 1, expanded);
    expandRowNode = /* @__PURE__ */ React437.createElement(ExpandedRow_default, {
      expanded,
      className: (0, import_classnames178.default)("".concat(prefixCls, "-expanded-row"), "".concat(prefixCls, "-expanded-row-level-").concat(indent + 1), expandedClsName),
      prefixCls,
      component: RowComponent,
      cellComponent,
      colSpan: expandedRowInfo ? expandedRowInfo.colSpan : flattenColumns.length,
      stickyOffset: expandedRowInfo === null || expandedRowInfo === void 0 ? void 0 : expandedRowInfo.sticky,
      isEmpty: false
    }, expandContent);
  }
  return /* @__PURE__ */ React437.createElement(React437.Fragment, null, baseRowNode, expandRowNode);
}
if (true) {
  BodyRow.displayName = "BodyRow";
}
var BodyRow_default = responseImmutable2(BodyRow);

// ../../node_modules/rc-table/es/Body/MeasureRow.js
var React439 = __toESM(require_react());

// ../../node_modules/rc-table/es/Body/MeasureCell.js
var React438 = __toESM(require_react());
function MeasureCell(_ref) {
  var columnKey = _ref.columnKey, onColumnResize = _ref.onColumnResize;
  var cellRef = React438.useRef();
  useLayoutEffect_default(function() {
    if (cellRef.current) {
      onColumnResize(columnKey, cellRef.current.offsetWidth);
    }
  }, []);
  return /* @__PURE__ */ React438.createElement(es_default, {
    data: columnKey
  }, /* @__PURE__ */ React438.createElement("td", {
    ref: cellRef,
    style: {
      padding: 0,
      border: 0,
      height: 0
    }
  }, /* @__PURE__ */ React438.createElement("div", {
    style: {
      height: 0,
      overflow: "hidden"
    }
  }, "\xA0")));
}

// ../../node_modules/rc-table/es/Body/MeasureRow.js
function MeasureRow(_ref) {
  var prefixCls = _ref.prefixCls, columnsKey = _ref.columnsKey, onColumnResize = _ref.onColumnResize;
  var ref3 = React439.useRef(null);
  return /* @__PURE__ */ React439.createElement("tr", {
    "aria-hidden": "true",
    className: "".concat(prefixCls, "-measure-row"),
    style: {
      height: 0,
      fontSize: 0
    },
    ref: ref3
  }, /* @__PURE__ */ React439.createElement(es_default.Collection, {
    onBatchResize: function onBatchResize(infoList) {
      if (isVisible_default(ref3.current)) {
        infoList.forEach(function(_ref2) {
          var columnKey = _ref2.data, size = _ref2.size;
          onColumnResize(columnKey, size.offsetWidth);
        });
      }
    }
  }, columnsKey.map(function(columnKey) {
    return /* @__PURE__ */ React439.createElement(MeasureCell, {
      key: columnKey,
      columnKey,
      onColumnResize
    });
  })));
}

// ../../node_modules/rc-table/es/Body/index.js
function Body(props) {
  if (true) {
    useRenderTimes_default(props);
  }
  var data2 = props.data, measureColumnWidth = props.measureColumnWidth;
  var _useContext = useContext151(TableContext_default, ["prefixCls", "getComponent", "onColumnResize", "flattenColumns", "getRowKey", "expandedKeys", "childrenColumnName", "emptyNode", "expandedRowOffset", "fixedInfoList", "colWidths"]), prefixCls = _useContext.prefixCls, getComponent = _useContext.getComponent, onColumnResize = _useContext.onColumnResize, flattenColumns = _useContext.flattenColumns, getRowKey = _useContext.getRowKey, expandedKeys = _useContext.expandedKeys, childrenColumnName = _useContext.childrenColumnName, emptyNode = _useContext.emptyNode, _useContext$expandedR = _useContext.expandedRowOffset, expandedRowOffset = _useContext$expandedR === void 0 ? 0 : _useContext$expandedR, colWidths = _useContext.colWidths;
  var flattenData2 = useFlattenRecords(data2, childrenColumnName, expandedKeys, getRowKey);
  var rowKeys = React440.useMemo(function() {
    return flattenData2.map(function(item) {
      return item.rowKey;
    });
  }, [flattenData2]);
  var perfRef = React440.useRef({
    renderWithProps: false
  });
  var expandedRowInfo = React440.useMemo(function() {
    var expandedColSpan = flattenColumns.length - expandedRowOffset;
    var expandedStickyStart = 0;
    for (var i = 0; i < expandedRowOffset; i += 1) {
      expandedStickyStart += colWidths[i] || 0;
    }
    return {
      offset: expandedRowOffset,
      colSpan: expandedColSpan,
      sticky: expandedStickyStart
    };
  }, [flattenColumns.length, expandedRowOffset, colWidths]);
  var WrapperComponent = getComponent(["body", "wrapper"], "tbody");
  var trComponent = getComponent(["body", "row"], "tr");
  var tdComponent = getComponent(["body", "cell"], "td");
  var thComponent = getComponent(["body", "cell"], "th");
  var rows;
  if (data2.length) {
    rows = flattenData2.map(function(item, idx) {
      var record = item.record, indent = item.indent, renderIndex = item.index, rowKey = item.rowKey;
      return /* @__PURE__ */ React440.createElement(BodyRow_default, {
        key: rowKey,
        rowKey,
        rowKeys,
        record,
        index: idx,
        renderIndex,
        rowComponent: trComponent,
        cellComponent: tdComponent,
        scopeCellComponent: thComponent,
        indent,
        expandedRowInfo
      });
    });
  } else {
    rows = /* @__PURE__ */ React440.createElement(ExpandedRow_default, {
      expanded: true,
      className: "".concat(prefixCls, "-placeholder"),
      prefixCls,
      component: trComponent,
      cellComponent: tdComponent,
      colSpan: flattenColumns.length,
      isEmpty: true
    }, emptyNode);
  }
  var columnsKey = getColumnsKey(flattenColumns);
  return /* @__PURE__ */ React440.createElement(PerfContext_default.Provider, {
    value: perfRef.current
  }, /* @__PURE__ */ React440.createElement(WrapperComponent, {
    className: "".concat(prefixCls, "-tbody")
  }, measureColumnWidth && /* @__PURE__ */ React440.createElement(MeasureRow, {
    prefixCls,
    columnsKey,
    onColumnResize
  }), rows));
}
if (true) {
  Body.displayName = "Body";
}
var Body_default = responseImmutable2(Body);

// ../../node_modules/rc-table/es/ColGroup.js
var React441 = __toESM(require_react());

// ../../node_modules/rc-table/es/utils/legacyUtil.js
var _excluded65 = ["expandable"];
var INTERNAL_COL_DEFINE = "RC_TABLE_INTERNAL_COL_DEFINE";
function getExpandableProps(props) {
  var expandable = props.expandable, legacyExpandableConfig = _objectWithoutProperties(props, _excluded65);
  var config;
  if ("expandable" in props) {
    config = _objectSpread2(_objectSpread2({}, legacyExpandableConfig), expandable);
  } else {
    if (["indentSize", "expandedRowKeys", "defaultExpandedRowKeys", "defaultExpandAllRows", "expandedRowRender", "expandRowByClick", "expandIcon", "onExpand", "onExpandedRowsChange", "expandedRowClassName", "expandIconColumnIndex", "showExpandColumn", "title"].some(function(prop) {
      return prop in props;
    })) {
      warning_default(false, "expanded related props have been moved into `expandable`.");
    }
    config = legacyExpandableConfig;
  }
  if (config.showExpandColumn === false) {
    config.expandIconColumnIndex = -1;
  }
  return config;
}

// ../../node_modules/rc-table/es/ColGroup.js
var _excluded66 = ["columnType"];
function ColGroup(_ref) {
  var colWidths = _ref.colWidths, columns = _ref.columns, columCount = _ref.columCount;
  var _useContext = useContext151(TableContext_default, ["tableLayout"]), tableLayout = _useContext.tableLayout;
  var cols = [];
  var len = columCount || columns.length;
  var mustInsert = false;
  for (var i = len - 1; i >= 0; i -= 1) {
    var width = colWidths[i];
    var column2 = columns && columns[i];
    var additionalProps = void 0;
    var minWidth = void 0;
    if (column2) {
      additionalProps = column2[INTERNAL_COL_DEFINE];
      if (tableLayout === "auto") {
        minWidth = column2.minWidth;
      }
    }
    if (width || minWidth || additionalProps || mustInsert) {
      var _ref2 = additionalProps || {}, columnType = _ref2.columnType, restAdditionalProps = _objectWithoutProperties(_ref2, _excluded66);
      cols.unshift(/* @__PURE__ */ React441.createElement("col", _extends({
        key: i,
        style: {
          width,
          minWidth
        }
      }, restAdditionalProps)));
      mustInsert = true;
    }
  }
  return /* @__PURE__ */ React441.createElement("colgroup", null, cols);
}
var ColGroup_default = ColGroup;

// ../../node_modules/rc-table/es/FixedHolder/index.js
var import_classnames179 = __toESM(require_classnames());
var React442 = __toESM(require_react());
var import_react138 = __toESM(require_react());
var _excluded67 = ["className", "noData", "columns", "flattenColumns", "colWidths", "columCount", "stickyOffsets", "direction", "fixHeader", "stickyTopOffset", "stickyBottomOffset", "stickyClassName", "onScroll", "maxContentScroll", "children"];
function useColumnWidth(colWidths, columCount) {
  return (0, import_react138.useMemo)(function() {
    var cloneColumns = [];
    for (var i = 0; i < columCount; i += 1) {
      var val = colWidths[i];
      if (val !== void 0) {
        cloneColumns[i] = val;
      } else {
        return null;
      }
    }
    return cloneColumns;
  }, [colWidths.join("_"), columCount]);
}
var FixedHolder = /* @__PURE__ */ React442.forwardRef(function(props, ref3) {
  if (true) {
    useRenderTimes_default(props);
  }
  var className2 = props.className, noData = props.noData, columns = props.columns, flattenColumns = props.flattenColumns, colWidths = props.colWidths, columCount = props.columCount, stickyOffsets = props.stickyOffsets, direction = props.direction, fixHeader = props.fixHeader, stickyTopOffset = props.stickyTopOffset, stickyBottomOffset = props.stickyBottomOffset, stickyClassName = props.stickyClassName, onScroll = props.onScroll, maxContentScroll = props.maxContentScroll, children = props.children, restProps = _objectWithoutProperties(props, _excluded67);
  var _useContext = useContext151(TableContext_default, ["prefixCls", "scrollbarSize", "isSticky", "getComponent"]), prefixCls = _useContext.prefixCls, scrollbarSize = _useContext.scrollbarSize, isSticky = _useContext.isSticky, getComponent = _useContext.getComponent;
  var TableComponent = getComponent(["header", "table"], "table");
  var combinationScrollBarSize = isSticky && !fixHeader ? 0 : scrollbarSize;
  var scrollRef = React442.useRef(null);
  var setScrollRef = React442.useCallback(function(element) {
    fillRef(ref3, element);
    fillRef(scrollRef, element);
  }, []);
  React442.useEffect(function() {
    function onWheel(e3) {
      var _ref = e3, currentTarget = _ref.currentTarget, deltaX = _ref.deltaX;
      if (deltaX) {
        onScroll({
          currentTarget,
          scrollLeft: currentTarget.scrollLeft + deltaX
        });
        e3.preventDefault();
      }
    }
    var scrollEle = scrollRef.current;
    scrollEle === null || scrollEle === void 0 || scrollEle.addEventListener("wheel", onWheel, {
      passive: false
    });
    return function() {
      scrollEle === null || scrollEle === void 0 || scrollEle.removeEventListener("wheel", onWheel);
    };
  }, []);
  var allFlattenColumnsWithWidth = React442.useMemo(function() {
    return flattenColumns.every(function(column2) {
      return column2.width;
    });
  }, [flattenColumns]);
  var lastColumn = flattenColumns[flattenColumns.length - 1];
  var ScrollBarColumn = {
    fixed: lastColumn ? lastColumn.fixed : null,
    scrollbar: true,
    onHeaderCell: function onHeaderCell() {
      return {
        className: "".concat(prefixCls, "-cell-scrollbar")
      };
    }
  };
  var columnsWithScrollbar = (0, import_react138.useMemo)(function() {
    return combinationScrollBarSize ? [].concat(_toConsumableArray(columns), [ScrollBarColumn]) : columns;
  }, [combinationScrollBarSize, columns]);
  var flattenColumnsWithScrollbar = (0, import_react138.useMemo)(function() {
    return combinationScrollBarSize ? [].concat(_toConsumableArray(flattenColumns), [ScrollBarColumn]) : flattenColumns;
  }, [combinationScrollBarSize, flattenColumns]);
  var headerStickyOffsets = (0, import_react138.useMemo)(function() {
    var right2 = stickyOffsets.right, left2 = stickyOffsets.left;
    return _objectSpread2(_objectSpread2({}, stickyOffsets), {}, {
      left: direction === "rtl" ? [].concat(_toConsumableArray(left2.map(function(width) {
        return width + combinationScrollBarSize;
      })), [0]) : left2,
      right: direction === "rtl" ? right2 : [].concat(_toConsumableArray(right2.map(function(width) {
        return width + combinationScrollBarSize;
      })), [0]),
      isSticky
    });
  }, [combinationScrollBarSize, stickyOffsets, isSticky]);
  var mergedColumnWidth = useColumnWidth(colWidths, columCount);
  return /* @__PURE__ */ React442.createElement("div", {
    style: _objectSpread2({
      overflow: "hidden"
    }, isSticky ? {
      top: stickyTopOffset,
      bottom: stickyBottomOffset
    } : {}),
    ref: setScrollRef,
    className: (0, import_classnames179.default)(className2, _defineProperty({}, stickyClassName, !!stickyClassName))
  }, /* @__PURE__ */ React442.createElement(TableComponent, {
    style: {
      tableLayout: "fixed",
      visibility: noData || mergedColumnWidth ? null : "hidden"
    }
  }, (!noData || !maxContentScroll || allFlattenColumnsWithWidth) && /* @__PURE__ */ React442.createElement(ColGroup_default, {
    colWidths: mergedColumnWidth ? [].concat(_toConsumableArray(mergedColumnWidth), [combinationScrollBarSize]) : [],
    columCount: columCount + 1,
    columns: flattenColumnsWithScrollbar
  }), children(_objectSpread2(_objectSpread2({}, restProps), {}, {
    stickyOffsets: headerStickyOffsets,
    columns: columnsWithScrollbar,
    flattenColumns: flattenColumnsWithScrollbar
  }))));
});
if (true) {
  FixedHolder.displayName = "FixedHolder";
}
var FixedHolder_default = /* @__PURE__ */ React442.memo(FixedHolder);

// ../../node_modules/rc-table/es/Header/Header.js
var React444 = __toESM(require_react());

// ../../node_modules/rc-table/es/Header/HeaderRow.js
var React443 = __toESM(require_react());
var HeaderRow = function HeaderRow2(props) {
  var cells = props.cells, stickyOffsets = props.stickyOffsets, flattenColumns = props.flattenColumns, RowComponent = props.rowComponent, CellComponent = props.cellComponent, onHeaderRow = props.onHeaderRow, index3 = props.index;
  var _useContext = useContext151(TableContext_default, ["prefixCls", "direction"]), prefixCls = _useContext.prefixCls, direction = _useContext.direction;
  var rowProps;
  if (onHeaderRow) {
    rowProps = onHeaderRow(cells.map(function(cell) {
      return cell.column;
    }), index3);
  }
  var columnsKey = getColumnsKey(cells.map(function(cell) {
    return cell.column;
  }));
  return /* @__PURE__ */ React443.createElement(RowComponent, rowProps, cells.map(function(cell, cellIndex) {
    var column2 = cell.column;
    var fixedInfo = getCellFixedInfo(cell.colStart, cell.colEnd, flattenColumns, stickyOffsets, direction);
    var additionalProps;
    if (column2 && column2.onHeaderCell) {
      additionalProps = cell.column.onHeaderCell(column2);
    }
    return /* @__PURE__ */ React443.createElement(Cell_default, _extends({}, cell, {
      scope: column2.title ? cell.colSpan > 1 ? "colgroup" : "col" : null,
      ellipsis: column2.ellipsis,
      align: column2.align,
      component: CellComponent,
      prefixCls,
      key: columnsKey[cellIndex]
    }, fixedInfo, {
      additionalProps,
      rowType: "header"
    }));
  }));
};
if (true) {
  HeaderRow.displayName = "HeaderRow";
}
var HeaderRow_default = HeaderRow;

// ../../node_modules/rc-table/es/Header/Header.js
function parseHeaderRows(rootColumns) {
  var rows = [];
  function fillRowCells(columns, colIndex) {
    var rowIndex2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    rows[rowIndex2] = rows[rowIndex2] || [];
    var currentColIndex = colIndex;
    var colSpans = columns.filter(Boolean).map(function(column2) {
      var cell = {
        key: column2.key,
        className: column2.className || "",
        children: column2.title,
        column: column2,
        colStart: currentColIndex
      };
      var colSpan = 1;
      var subColumns = column2.children;
      if (subColumns && subColumns.length > 0) {
        colSpan = fillRowCells(subColumns, currentColIndex, rowIndex2 + 1).reduce(function(total, count) {
          return total + count;
        }, 0);
        cell.hasSubColumns = true;
      }
      if ("colSpan" in column2) {
        colSpan = column2.colSpan;
      }
      if ("rowSpan" in column2) {
        cell.rowSpan = column2.rowSpan;
      }
      cell.colSpan = colSpan;
      cell.colEnd = cell.colStart + colSpan - 1;
      rows[rowIndex2].push(cell);
      currentColIndex += colSpan;
      return colSpan;
    });
    return colSpans;
  }
  fillRowCells(rootColumns, 0);
  var rowCount = rows.length;
  var _loop = function _loop2(rowIndex2) {
    rows[rowIndex2].forEach(function(cell) {
      if (!("rowSpan" in cell) && !cell.hasSubColumns) {
        cell.rowSpan = rowCount - rowIndex2;
      }
    });
  };
  for (var rowIndex = 0; rowIndex < rowCount; rowIndex += 1) {
    _loop(rowIndex);
  }
  return rows;
}
var Header = function Header2(props) {
  if (true) {
    useRenderTimes_default(props);
  }
  var stickyOffsets = props.stickyOffsets, columns = props.columns, flattenColumns = props.flattenColumns, onHeaderRow = props.onHeaderRow;
  var _useContext = useContext151(TableContext_default, ["prefixCls", "getComponent"]), prefixCls = _useContext.prefixCls, getComponent = _useContext.getComponent;
  var rows = React444.useMemo(function() {
    return parseHeaderRows(columns);
  }, [columns]);
  var WrapperComponent = getComponent(["header", "wrapper"], "thead");
  var trComponent = getComponent(["header", "row"], "tr");
  var thComponent = getComponent(["header", "cell"], "th");
  return /* @__PURE__ */ React444.createElement(WrapperComponent, {
    className: "".concat(prefixCls, "-thead")
  }, rows.map(function(row, rowIndex) {
    var rowNode = /* @__PURE__ */ React444.createElement(HeaderRow_default, {
      key: rowIndex,
      flattenColumns,
      cells: row,
      stickyOffsets,
      rowComponent: trComponent,
      cellComponent: thComponent,
      onHeaderRow,
      index: rowIndex
    });
    return rowNode;
  }));
};
var Header_default = responseImmutable2(Header);

// ../../node_modules/rc-table/es/hooks/useColumns/index.js
var React446 = __toESM(require_react());

// ../../node_modules/rc-table/es/hooks/useColumns/useWidthColumns.js
var React445 = __toESM(require_react());
function parseColWidth(totalWidth) {
  var width = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  if (typeof width === "number") {
    return width;
  }
  if (width.endsWith("%")) {
    return totalWidth * parseFloat(width) / 100;
  }
  return null;
}
function useWidthColumns(flattenColumns, scrollWidth, clientWidth) {
  return React445.useMemo(function() {
    if (scrollWidth && scrollWidth > 0) {
      var totalWidth = 0;
      var missWidthCount = 0;
      flattenColumns.forEach(function(col) {
        var colWidth = parseColWidth(scrollWidth, col.width);
        if (colWidth) {
          totalWidth += colWidth;
        } else {
          missWidthCount += 1;
        }
      });
      var maxFitWidth = Math.max(scrollWidth, clientWidth);
      var restWidth = Math.max(maxFitWidth - totalWidth, missWidthCount);
      var restCount = missWidthCount;
      var avgWidth = restWidth / missWidthCount;
      var realTotal = 0;
      var filledColumns = flattenColumns.map(function(col) {
        var clone = _objectSpread2({}, col);
        var colWidth = parseColWidth(scrollWidth, clone.width);
        if (colWidth) {
          clone.width = colWidth;
        } else {
          var colAvgWidth = Math.floor(avgWidth);
          clone.width = restCount === 1 ? restWidth : colAvgWidth;
          restWidth -= colAvgWidth;
          restCount -= 1;
        }
        realTotal += clone.width;
        return clone;
      });
      if (realTotal < maxFitWidth) {
        var scale = maxFitWidth / realTotal;
        restWidth = maxFitWidth;
        filledColumns.forEach(function(col, index3) {
          var colWidth = Math.floor(col.width * scale);
          col.width = index3 === filledColumns.length - 1 ? restWidth : colWidth;
          restWidth -= colWidth;
        });
      }
      return [filledColumns, Math.max(realTotal, maxFitWidth)];
    }
    return [flattenColumns, scrollWidth];
  }, [flattenColumns, scrollWidth, clientWidth]);
}

// ../../node_modules/rc-table/es/hooks/useColumns/index.js
var _excluded68 = ["children"];
var _excluded219 = ["fixed"];
function convertChildrenToColumns(children) {
  return toArray(children).filter(function(node2) {
    return /* @__PURE__ */ React446.isValidElement(node2);
  }).map(function(_ref) {
    var key2 = _ref.key, props = _ref.props;
    var nodeChildren = props.children, restProps = _objectWithoutProperties(props, _excluded68);
    var column2 = _objectSpread2({
      key: key2
    }, restProps);
    if (nodeChildren) {
      column2.children = convertChildrenToColumns(nodeChildren);
    }
    return column2;
  });
}
function filterHiddenColumns(columns) {
  return columns.filter(function(column2) {
    return column2 && _typeof(column2) === "object" && !column2.hidden;
  }).map(function(column2) {
    var subColumns = column2.children;
    if (subColumns && subColumns.length > 0) {
      return _objectSpread2(_objectSpread2({}, column2), {}, {
        children: filterHiddenColumns(subColumns)
      });
    }
    return column2;
  });
}
function flatColumns(columns) {
  var parentKey = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "key";
  return columns.filter(function(column2) {
    return column2 && _typeof(column2) === "object";
  }).reduce(function(list, column2, index3) {
    var fixed = column2.fixed;
    var parsedFixed = fixed === true ? "left" : fixed;
    var mergedKey = "".concat(parentKey, "-").concat(index3);
    var subColumns = column2.children;
    if (subColumns && subColumns.length > 0) {
      return [].concat(_toConsumableArray(list), _toConsumableArray(flatColumns(subColumns, mergedKey).map(function(subColum) {
        return _objectSpread2({
          fixed: parsedFixed
        }, subColum);
      })));
    }
    return [].concat(_toConsumableArray(list), [_objectSpread2(_objectSpread2({
      key: mergedKey
    }, column2), {}, {
      fixed: parsedFixed
    })]);
  }, []);
}
function revertForRtl(columns) {
  return columns.map(function(column2) {
    var fixed = column2.fixed, restProps = _objectWithoutProperties(column2, _excluded219);
    var parsedFixed = fixed;
    if (fixed === "left") {
      parsedFixed = "right";
    } else if (fixed === "right") {
      parsedFixed = "left";
    }
    return _objectSpread2({
      fixed: parsedFixed
    }, restProps);
  });
}
function useColumns(_ref2, transformColumns) {
  var prefixCls = _ref2.prefixCls, columns = _ref2.columns, children = _ref2.children, expandable = _ref2.expandable, expandedKeys = _ref2.expandedKeys, columnTitle = _ref2.columnTitle, getRowKey = _ref2.getRowKey, onTriggerExpand = _ref2.onTriggerExpand, expandIcon = _ref2.expandIcon, rowExpandable = _ref2.rowExpandable, expandIconColumnIndex = _ref2.expandIconColumnIndex, _ref2$expandedRowOffs = _ref2.expandedRowOffset, expandedRowOffset = _ref2$expandedRowOffs === void 0 ? 0 : _ref2$expandedRowOffs, direction = _ref2.direction, expandRowByClick = _ref2.expandRowByClick, columnWidth = _ref2.columnWidth, fixed = _ref2.fixed, scrollWidth = _ref2.scrollWidth, clientWidth = _ref2.clientWidth;
  var baseColumns = React446.useMemo(function() {
    var newColumns = columns || convertChildrenToColumns(children) || [];
    return filterHiddenColumns(newColumns.slice());
  }, [columns, children]);
  var withExpandColumns = React446.useMemo(function() {
    if (expandable) {
      var cloneColumns = baseColumns.slice();
      if (expandIconColumnIndex >= 0) {
        warning_default(false, "`expandIconColumnIndex` is deprecated. Please use `Table.EXPAND_COLUMN` in `columns` instead.");
      }
      if (!cloneColumns.includes(EXPAND_COLUMN)) {
        var expandColIndex = expandIconColumnIndex || 0;
        if (expandColIndex >= 0 && (expandColIndex || fixed === "left" || !fixed)) {
          cloneColumns.splice(expandColIndex, 0, EXPAND_COLUMN);
        }
        if (fixed === "right") {
          cloneColumns.splice(baseColumns.length, 0, EXPAND_COLUMN);
        }
      }
      if (cloneColumns.filter(function(c) {
        return c === EXPAND_COLUMN;
      }).length > 1) {
        warning_default(false, "There exist more than one `EXPAND_COLUMN` in `columns`.");
      }
      var expandColumnIndex = cloneColumns.indexOf(EXPAND_COLUMN);
      cloneColumns = cloneColumns.filter(function(column2, index3) {
        return column2 !== EXPAND_COLUMN || index3 === expandColumnIndex;
      });
      var prevColumn = baseColumns[expandColumnIndex];
      var fixedColumn;
      if (fixed) {
        fixedColumn = fixed;
      } else {
        fixedColumn = prevColumn ? prevColumn.fixed : null;
      }
      var expandColumn = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, INTERNAL_COL_DEFINE, {
        className: "".concat(prefixCls, "-expand-icon-col"),
        columnType: "EXPAND_COLUMN"
      }), "title", columnTitle), "fixed", fixedColumn), "className", "".concat(prefixCls, "-row-expand-icon-cell")), "width", columnWidth), "render", function render4(_, record, index3) {
        var rowKey = getRowKey(record, index3);
        var expanded = expandedKeys.has(rowKey);
        var recordExpandable = rowExpandable ? rowExpandable(record) : true;
        var icon = expandIcon({
          prefixCls,
          expanded,
          expandable: recordExpandable,
          record,
          onExpand: onTriggerExpand
        });
        if (expandRowByClick) {
          return /* @__PURE__ */ React446.createElement("span", {
            onClick: function onClick(e3) {
              return e3.stopPropagation();
            }
          }, icon);
        }
        return icon;
      });
      return cloneColumns.map(function(col, index3) {
        var column2 = col === EXPAND_COLUMN ? expandColumn : col;
        if (index3 < expandedRowOffset) {
          return _objectSpread2(_objectSpread2({}, column2), {}, {
            fixed: column2.fixed || "left"
          });
        }
        return column2;
      });
    }
    if (baseColumns.includes(EXPAND_COLUMN)) {
      warning_default(false, "`expandable` is not config but there exist `EXPAND_COLUMN` in `columns`.");
    }
    return baseColumns.filter(function(col) {
      return col !== EXPAND_COLUMN;
    });
  }, [expandable, baseColumns, getRowKey, expandedKeys, expandIcon, direction, expandedRowOffset]);
  var mergedColumns = React446.useMemo(function() {
    var finalColumns = withExpandColumns;
    if (transformColumns) {
      finalColumns = transformColumns(finalColumns);
    }
    if (!finalColumns.length) {
      finalColumns = [{
        render: function render4() {
          return null;
        }
      }];
    }
    return finalColumns;
  }, [transformColumns, withExpandColumns, direction]);
  var flattenColumns = React446.useMemo(function() {
    if (direction === "rtl") {
      return revertForRtl(flatColumns(mergedColumns));
    }
    return flatColumns(mergedColumns);
  }, [mergedColumns, direction, scrollWidth]);
  var hasGapFixed = React446.useMemo(function() {
    var lastLeftIndex = -1;
    for (var i = flattenColumns.length - 1; i >= 0; i -= 1) {
      var colFixed = flattenColumns[i].fixed;
      if (colFixed === "left" || colFixed === true) {
        lastLeftIndex = i;
        break;
      }
    }
    if (lastLeftIndex >= 0) {
      for (var _i = 0; _i <= lastLeftIndex; _i += 1) {
        var _colFixed = flattenColumns[_i].fixed;
        if (_colFixed !== "left" && _colFixed !== true) {
          return true;
        }
      }
    }
    var firstRightIndex = flattenColumns.findIndex(function(_ref3) {
      var colFixed2 = _ref3.fixed;
      return colFixed2 === "right";
    });
    if (firstRightIndex >= 0) {
      for (var _i2 = firstRightIndex; _i2 < flattenColumns.length; _i2 += 1) {
        var _colFixed2 = flattenColumns[_i2].fixed;
        if (_colFixed2 !== "right") {
          return true;
        }
      }
    }
    return false;
  }, [flattenColumns]);
  var _useWidthColumns = useWidthColumns(flattenColumns, scrollWidth, clientWidth), _useWidthColumns2 = _slicedToArray(_useWidthColumns, 2), filledColumns = _useWidthColumns2[0], realScrollWidth = _useWidthColumns2[1];
  return [mergedColumns, filledColumns, realScrollWidth, hasGapFixed];
}
var useColumns_default = useColumns;

// ../../node_modules/rc-table/es/hooks/useExpand.js
var React447 = __toESM(require_react());
function useExpand(props, mergedData, getRowKey) {
  var expandableConfig = getExpandableProps(props);
  var expandIcon = expandableConfig.expandIcon, expandedRowKeys = expandableConfig.expandedRowKeys, defaultExpandedRowKeys = expandableConfig.defaultExpandedRowKeys, defaultExpandAllRows = expandableConfig.defaultExpandAllRows, expandedRowRender = expandableConfig.expandedRowRender, onExpand = expandableConfig.onExpand, onExpandedRowsChange = expandableConfig.onExpandedRowsChange, childrenColumnName = expandableConfig.childrenColumnName;
  var mergedExpandIcon = expandIcon || renderExpandIcon;
  var mergedChildrenColumnName = childrenColumnName || "children";
  var expandableType = React447.useMemo(function() {
    if (expandedRowRender) {
      return "row";
    }
    if (props.expandable && props.internalHooks === INTERNAL_HOOKS && props.expandable.__PARENT_RENDER_ICON__ || mergedData.some(function(record) {
      return record && _typeof(record) === "object" && record[mergedChildrenColumnName];
    })) {
      return "nest";
    }
    return false;
  }, [!!expandedRowRender, mergedData]);
  var _React$useState = React447.useState(function() {
    if (defaultExpandedRowKeys) {
      return defaultExpandedRowKeys;
    }
    if (defaultExpandAllRows) {
      return findAllChildrenKeys(mergedData, getRowKey, mergedChildrenColumnName);
    }
    return [];
  }), _React$useState2 = _slicedToArray(_React$useState, 2), innerExpandedKeys = _React$useState2[0], setInnerExpandedKeys = _React$useState2[1];
  var mergedExpandedKeys = React447.useMemo(function() {
    return new Set(expandedRowKeys || innerExpandedKeys || []);
  }, [expandedRowKeys, innerExpandedKeys]);
  var onTriggerExpand = React447.useCallback(function(record) {
    var key2 = getRowKey(record, mergedData.indexOf(record));
    var newExpandedKeys;
    var hasKey = mergedExpandedKeys.has(key2);
    if (hasKey) {
      mergedExpandedKeys.delete(key2);
      newExpandedKeys = _toConsumableArray(mergedExpandedKeys);
    } else {
      newExpandedKeys = [].concat(_toConsumableArray(mergedExpandedKeys), [key2]);
    }
    setInnerExpandedKeys(newExpandedKeys);
    if (onExpand) {
      onExpand(!hasKey, record);
    }
    if (onExpandedRowsChange) {
      onExpandedRowsChange(newExpandedKeys);
    }
  }, [getRowKey, mergedExpandedKeys, mergedData, onExpand, onExpandedRowsChange]);
  if (expandedRowRender && mergedData.some(function(record) {
    return Array.isArray(record === null || record === void 0 ? void 0 : record[mergedChildrenColumnName]);
  })) {
    warning_default(false, "`expandedRowRender` should not use with nested Table");
  }
  return [expandableConfig, expandableType, mergedExpandedKeys, mergedExpandIcon, mergedChildrenColumnName, onTriggerExpand];
}

// ../../node_modules/rc-table/es/hooks/useFixedInfo.js
function useFixedInfo(flattenColumns, stickyOffsets, direction) {
  var fixedInfoList = flattenColumns.map(function(_, colIndex) {
    return getCellFixedInfo(colIndex, colIndex, flattenColumns, stickyOffsets, direction);
  });
  return useMemo3(function() {
    return fixedInfoList;
  }, [fixedInfoList], function(prev2, next2) {
    return !isEqual_default(prev2, next2);
  });
}

// ../../node_modules/rc-table/es/hooks/useFrame.js
var import_react139 = __toESM(require_react());
function useLayoutState(defaultState) {
  var stateRef = (0, import_react139.useRef)(defaultState);
  var _useState = (0, import_react139.useState)({}), _useState2 = _slicedToArray(_useState, 2), forceUpdate = _useState2[1];
  var lastPromiseRef = (0, import_react139.useRef)(null);
  var updateBatchRef = (0, import_react139.useRef)([]);
  function setFrameState(updater) {
    updateBatchRef.current.push(updater);
    var promise = Promise.resolve();
    lastPromiseRef.current = promise;
    promise.then(function() {
      if (lastPromiseRef.current === promise) {
        var prevBatch = updateBatchRef.current;
        var prevState = stateRef.current;
        updateBatchRef.current = [];
        prevBatch.forEach(function(batchUpdater) {
          stateRef.current = batchUpdater(stateRef.current);
        });
        lastPromiseRef.current = null;
        if (prevState !== stateRef.current) {
          forceUpdate({});
        }
      }
    });
  }
  (0, import_react139.useEffect)(function() {
    return function() {
      lastPromiseRef.current = null;
    };
  }, []);
  return [stateRef.current, setFrameState];
}
function useTimeoutLock(defaultState) {
  var frameRef = (0, import_react139.useRef)(defaultState || null);
  var timeoutRef = (0, import_react139.useRef)();
  function cleanUp() {
    window.clearTimeout(timeoutRef.current);
  }
  function setState(newState) {
    frameRef.current = newState;
    cleanUp();
    timeoutRef.current = window.setTimeout(function() {
      frameRef.current = null;
      timeoutRef.current = void 0;
    }, 100);
  }
  function getState() {
    return frameRef.current;
  }
  (0, import_react139.useEffect)(function() {
    return cleanUp;
  }, []);
  return [setState, getState];
}

// ../../node_modules/rc-table/es/hooks/useHover.js
var React448 = __toESM(require_react());
function useHover() {
  var _React$useState = React448.useState(-1), _React$useState2 = _slicedToArray(_React$useState, 2), startRow = _React$useState2[0], setStartRow = _React$useState2[1];
  var _React$useState3 = React448.useState(-1), _React$useState4 = _slicedToArray(_React$useState3, 2), endRow = _React$useState4[0], setEndRow = _React$useState4[1];
  var onHover = React448.useCallback(function(start, end) {
    setStartRow(start);
    setEndRow(end);
  }, []);
  return [startRow, endRow, onHover];
}

// ../../node_modules/rc-table/es/hooks/useSticky.js
var React449 = __toESM(require_react());
var defaultContainer = canUseDom() ? window : null;
function useSticky(sticky, prefixCls) {
  var _ref = _typeof(sticky) === "object" ? sticky : {}, _ref$offsetHeader = _ref.offsetHeader, offsetHeader = _ref$offsetHeader === void 0 ? 0 : _ref$offsetHeader, _ref$offsetSummary = _ref.offsetSummary, offsetSummary = _ref$offsetSummary === void 0 ? 0 : _ref$offsetSummary, _ref$offsetScroll = _ref.offsetScroll, offsetScroll = _ref$offsetScroll === void 0 ? 0 : _ref$offsetScroll, _ref$getContainer = _ref.getContainer, getContainer2 = _ref$getContainer === void 0 ? function() {
    return defaultContainer;
  } : _ref$getContainer;
  var container = getContainer2() || defaultContainer;
  var isSticky = !!sticky;
  return React449.useMemo(function() {
    return {
      isSticky,
      stickyClassName: isSticky ? "".concat(prefixCls, "-sticky-holder") : "",
      offsetHeader,
      offsetSummary,
      offsetScroll,
      container
    };
  }, [isSticky, offsetScroll, offsetHeader, offsetSummary, prefixCls, container]);
}

// ../../node_modules/rc-table/es/hooks/useStickyOffsets.js
var import_react140 = __toESM(require_react());
function useStickyOffsets(colWidths, flattenColumns, direction) {
  var stickyOffsets = (0, import_react140.useMemo)(function() {
    var columnCount = flattenColumns.length;
    var getOffsets = function getOffsets2(startIndex, endIndex, offset4) {
      var offsets = [];
      var total = 0;
      for (var i = startIndex; i !== endIndex; i += offset4) {
        offsets.push(total);
        if (flattenColumns[i].fixed) {
          total += colWidths[i] || 0;
        }
      }
      return offsets;
    };
    var startOffsets = getOffsets(0, columnCount, 1);
    var endOffsets = getOffsets(columnCount - 1, -1, -1).reverse();
    return direction === "rtl" ? {
      left: endOffsets,
      right: startOffsets
    } : {
      left: startOffsets,
      right: endOffsets
    };
  }, [colWidths, flattenColumns, direction]);
  return stickyOffsets;
}
var useStickyOffsets_default = useStickyOffsets;

// ../../node_modules/rc-table/es/Panel/index.js
var React450 = __toESM(require_react());
function Panel3(_ref) {
  var className2 = _ref.className, children = _ref.children;
  return /* @__PURE__ */ React450.createElement("div", {
    className: className2
  }, children);
}
var Panel_default3 = Panel3;

// ../../node_modules/rc-table/es/stickyScrollBar.js
var import_classnames180 = __toESM(require_classnames());
var React451 = __toESM(require_react());

// ../../node_modules/rc-table/es/utils/offsetUtil.js
function getOffset4(node2) {
  var element = getDOM(node2);
  var box2 = element.getBoundingClientRect();
  var docElem = document.documentElement;
  return {
    left: box2.left + (window.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || document.body.clientLeft || 0),
    top: box2.top + (window.pageYOffset || docElem.scrollTop) - (docElem.clientTop || document.body.clientTop || 0)
  };
}

// ../../node_modules/rc-table/es/stickyScrollBar.js
var StickyScrollBar = function StickyScrollBar2(_ref, ref3) {
  var _scrollBodyRef$curren, _scrollBodyRef$curren2;
  var scrollBodyRef = _ref.scrollBodyRef, onScroll = _ref.onScroll, offsetScroll = _ref.offsetScroll, container = _ref.container, direction = _ref.direction;
  var prefixCls = useContext151(TableContext_default, "prefixCls");
  var bodyScrollWidth = ((_scrollBodyRef$curren = scrollBodyRef.current) === null || _scrollBodyRef$curren === void 0 ? void 0 : _scrollBodyRef$curren.scrollWidth) || 0;
  var bodyWidth = ((_scrollBodyRef$curren2 = scrollBodyRef.current) === null || _scrollBodyRef$curren2 === void 0 ? void 0 : _scrollBodyRef$curren2.clientWidth) || 0;
  var scrollBarWidth = bodyScrollWidth && bodyWidth * (bodyWidth / bodyScrollWidth);
  var scrollBarRef = React451.useRef();
  var _useLayoutState = useLayoutState({
    scrollLeft: 0,
    isHiddenScrollBar: true
  }), _useLayoutState2 = _slicedToArray(_useLayoutState, 2), scrollState = _useLayoutState2[0], setScrollState = _useLayoutState2[1];
  var refState = React451.useRef({
    delta: 0,
    x: 0
  });
  var _React$useState = React451.useState(false), _React$useState2 = _slicedToArray(_React$useState, 2), isActive2 = _React$useState2[0], setActive = _React$useState2[1];
  var rafRef = React451.useRef(null);
  React451.useEffect(function() {
    return function() {
      raf_default.cancel(rafRef.current);
    };
  }, []);
  var onMouseUp = function onMouseUp2() {
    setActive(false);
  };
  var onMouseDown = function onMouseDown2(event) {
    event.persist();
    refState.current.delta = event.pageX - scrollState.scrollLeft;
    refState.current.x = 0;
    setActive(true);
    event.preventDefault();
  };
  var onMouseMove = function onMouseMove2(event) {
    var _window;
    var _ref2 = event || ((_window = window) === null || _window === void 0 ? void 0 : _window.event), buttons = _ref2.buttons;
    if (!isActive2 || buttons === 0) {
      if (isActive2) {
        setActive(false);
      }
      return;
    }
    var left2 = refState.current.x + event.pageX - refState.current.x - refState.current.delta;
    var isRTL = direction === "rtl";
    left2 = Math.max(isRTL ? scrollBarWidth - bodyWidth : 0, Math.min(isRTL ? 0 : bodyWidth - scrollBarWidth, left2));
    var shouldScroll = !isRTL || Math.abs(left2) + Math.abs(scrollBarWidth) < bodyWidth;
    if (shouldScroll) {
      onScroll({
        scrollLeft: left2 / bodyWidth * (bodyScrollWidth + 2)
      });
      refState.current.x = event.pageX;
    }
  };
  var checkScrollBarVisible = function checkScrollBarVisible2() {
    raf_default.cancel(rafRef.current);
    rafRef.current = raf_default(function() {
      if (!scrollBodyRef.current) {
        return;
      }
      var tableOffsetTop = getOffset4(scrollBodyRef.current).top;
      var tableBottomOffset = tableOffsetTop + scrollBodyRef.current.offsetHeight;
      var currentClientOffset = container === window ? document.documentElement.scrollTop + window.innerHeight : getOffset4(container).top + container.clientHeight;
      if (tableBottomOffset - getScrollBarSize() <= currentClientOffset || tableOffsetTop >= currentClientOffset - offsetScroll) {
        setScrollState(function(state) {
          return _objectSpread2(_objectSpread2({}, state), {}, {
            isHiddenScrollBar: true
          });
        });
      } else {
        setScrollState(function(state) {
          return _objectSpread2(_objectSpread2({}, state), {}, {
            isHiddenScrollBar: false
          });
        });
      }
    });
  };
  var setScrollLeft = function setScrollLeft2(left2) {
    setScrollState(function(state) {
      return _objectSpread2(_objectSpread2({}, state), {}, {
        scrollLeft: left2 / bodyScrollWidth * bodyWidth || 0
      });
    });
  };
  React451.useImperativeHandle(ref3, function() {
    return {
      setScrollLeft,
      checkScrollBarVisible
    };
  });
  React451.useEffect(function() {
    var onMouseUpListener = addEventListenerWrap(document.body, "mouseup", onMouseUp, false);
    var onMouseMoveListener = addEventListenerWrap(document.body, "mousemove", onMouseMove, false);
    checkScrollBarVisible();
    return function() {
      onMouseUpListener.remove();
      onMouseMoveListener.remove();
    };
  }, [scrollBarWidth, isActive2]);
  React451.useEffect(function() {
    if (!scrollBodyRef.current) return;
    var scrollParents = [];
    var parent2 = getDOM(scrollBodyRef.current);
    while (parent2) {
      scrollParents.push(parent2);
      parent2 = parent2.parentElement;
    }
    scrollParents.forEach(function(p) {
      return p.addEventListener("scroll", checkScrollBarVisible, false);
    });
    window.addEventListener("resize", checkScrollBarVisible, false);
    window.addEventListener("scroll", checkScrollBarVisible, false);
    container.addEventListener("scroll", checkScrollBarVisible, false);
    return function() {
      scrollParents.forEach(function(p) {
        return p.removeEventListener("scroll", checkScrollBarVisible);
      });
      window.removeEventListener("resize", checkScrollBarVisible);
      window.removeEventListener("scroll", checkScrollBarVisible);
      container.removeEventListener("scroll", checkScrollBarVisible);
    };
  }, [container]);
  React451.useEffect(function() {
    if (!scrollState.isHiddenScrollBar) {
      setScrollState(function(state) {
        var bodyNode = scrollBodyRef.current;
        if (!bodyNode) {
          return state;
        }
        return _objectSpread2(_objectSpread2({}, state), {}, {
          scrollLeft: bodyNode.scrollLeft / bodyNode.scrollWidth * bodyNode.clientWidth
        });
      });
    }
  }, [scrollState.isHiddenScrollBar]);
  if (bodyScrollWidth <= bodyWidth || !scrollBarWidth || scrollState.isHiddenScrollBar) {
    return null;
  }
  return /* @__PURE__ */ React451.createElement("div", {
    style: {
      height: getScrollBarSize(),
      width: bodyWidth,
      bottom: offsetScroll
    },
    className: "".concat(prefixCls, "-sticky-scroll")
  }, /* @__PURE__ */ React451.createElement("div", {
    onMouseDown,
    ref: scrollBarRef,
    className: (0, import_classnames180.default)("".concat(prefixCls, "-sticky-scroll-bar"), _defineProperty({}, "".concat(prefixCls, "-sticky-scroll-bar-active"), isActive2)),
    style: {
      width: "".concat(scrollBarWidth, "px"),
      transform: "translate3d(".concat(scrollState.scrollLeft, "px, 0, 0)")
    }
  }));
};
var stickyScrollBar_default = /* @__PURE__ */ React451.forwardRef(StickyScrollBar);

// ../../node_modules/rc-table/es/Table.js
var DEFAULT_PREFIX = "rc-table";
var EMPTY_DATA2 = [];
var EMPTY_SCROLL_TARGET = {};
function defaultEmpty() {
  return "No Data";
}
function Table2(tableProps, ref3) {
  var props = _objectSpread2({
    rowKey: "key",
    prefixCls: DEFAULT_PREFIX,
    emptyText: defaultEmpty
  }, tableProps);
  var prefixCls = props.prefixCls, className2 = props.className, rowClassName = props.rowClassName, style2 = props.style, data2 = props.data, rowKey = props.rowKey, scroll = props.scroll, tableLayout = props.tableLayout, direction = props.direction, title = props.title, footer = props.footer, summary = props.summary, caption = props.caption, id = props.id, showHeader = props.showHeader, components = props.components, emptyText = props.emptyText, onRow = props.onRow, onHeaderRow = props.onHeaderRow, onScroll = props.onScroll, internalHooks = props.internalHooks, transformColumns = props.transformColumns, internalRefs = props.internalRefs, tailor = props.tailor, getContainerWidth = props.getContainerWidth, sticky = props.sticky, _props$rowHoverable = props.rowHoverable, rowHoverable = _props$rowHoverable === void 0 ? true : _props$rowHoverable;
  var mergedData = data2 || EMPTY_DATA2;
  var hasData = !!mergedData.length;
  var useInternalHooks = internalHooks === INTERNAL_HOOKS;
  if (true) {
    ["onRowClick", "onRowDoubleClick", "onRowContextMenu", "onRowMouseEnter", "onRowMouseLeave"].forEach(function(name) {
      warning_default(props[name] === void 0, "`".concat(name, "` is removed, please use `onRow` instead."));
    });
    warning_default(!("getBodyWrapper" in props), "`getBodyWrapper` is deprecated, please use custom `components` instead.");
  }
  var getComponent = React452.useCallback(function(path2, defaultComponent) {
    return get(components, path2) || defaultComponent;
  }, [components]);
  var getRowKey = React452.useMemo(function() {
    if (typeof rowKey === "function") {
      return rowKey;
    }
    return function(record) {
      var key2 = record && record[rowKey];
      if (true) {
        warning_default(key2 !== void 0, "Each record in table should have a unique `key` prop, or set `rowKey` to an unique primary key.");
      }
      return key2;
    };
  }, [rowKey]);
  var customizeScrollBody = getComponent(["body"]);
  var _useHover = useHover(), _useHover2 = _slicedToArray(_useHover, 3), startRow = _useHover2[0], endRow = _useHover2[1], onHover = _useHover2[2];
  var _useExpand = useExpand(props, mergedData, getRowKey), _useExpand2 = _slicedToArray(_useExpand, 6), expandableConfig = _useExpand2[0], expandableType = _useExpand2[1], mergedExpandedKeys = _useExpand2[2], mergedExpandIcon = _useExpand2[3], mergedChildrenColumnName = _useExpand2[4], onTriggerExpand = _useExpand2[5];
  var scrollX = scroll === null || scroll === void 0 ? void 0 : scroll.x;
  var _React$useState = React452.useState(0), _React$useState2 = _slicedToArray(_React$useState, 2), componentWidth = _React$useState2[0], setComponentWidth = _React$useState2[1];
  var _useColumns = useColumns_default(_objectSpread2(_objectSpread2(_objectSpread2({}, props), expandableConfig), {}, {
    expandable: !!expandableConfig.expandedRowRender,
    columnTitle: expandableConfig.columnTitle,
    expandedKeys: mergedExpandedKeys,
    getRowKey,
    // https://github.com/ant-design/ant-design/issues/23894
    onTriggerExpand,
    expandIcon: mergedExpandIcon,
    expandIconColumnIndex: expandableConfig.expandIconColumnIndex,
    direction,
    scrollWidth: useInternalHooks && tailor && typeof scrollX === "number" ? scrollX : null,
    clientWidth: componentWidth
  }), useInternalHooks ? transformColumns : null), _useColumns2 = _slicedToArray(_useColumns, 4), columns = _useColumns2[0], flattenColumns = _useColumns2[1], flattenScrollX = _useColumns2[2], hasGapFixed = _useColumns2[3];
  var mergedScrollX = flattenScrollX !== null && flattenScrollX !== void 0 ? flattenScrollX : scrollX;
  var columnContext = React452.useMemo(function() {
    return {
      columns,
      flattenColumns
    };
  }, [columns, flattenColumns]);
  var fullTableRef = React452.useRef();
  var scrollHeaderRef = React452.useRef();
  var scrollBodyRef = React452.useRef();
  var scrollBodyContainerRef = React452.useRef();
  React452.useImperativeHandle(ref3, function() {
    return {
      nativeElement: fullTableRef.current,
      scrollTo: function scrollTo2(config) {
        var _scrollBodyRef$curren3;
        if (scrollBodyRef.current instanceof HTMLElement) {
          var index3 = config.index, top = config.top, key2 = config.key;
          if (validNumberValue(top)) {
            var _scrollBodyRef$curren;
            (_scrollBodyRef$curren = scrollBodyRef.current) === null || _scrollBodyRef$curren === void 0 || _scrollBodyRef$curren.scrollTo({
              top
            });
          } else {
            var _scrollBodyRef$curren2;
            var mergedKey = key2 !== null && key2 !== void 0 ? key2 : getRowKey(mergedData[index3]);
            (_scrollBodyRef$curren2 = scrollBodyRef.current.querySelector('[data-row-key="'.concat(mergedKey, '"]'))) === null || _scrollBodyRef$curren2 === void 0 || _scrollBodyRef$curren2.scrollIntoView();
          }
        } else if ((_scrollBodyRef$curren3 = scrollBodyRef.current) !== null && _scrollBodyRef$curren3 !== void 0 && _scrollBodyRef$curren3.scrollTo) {
          scrollBodyRef.current.scrollTo(config);
        }
      }
    };
  });
  var scrollSummaryRef = React452.useRef();
  var _React$useState3 = React452.useState(false), _React$useState4 = _slicedToArray(_React$useState3, 2), pingedLeft = _React$useState4[0], setPingedLeft = _React$useState4[1];
  var _React$useState5 = React452.useState(false), _React$useState6 = _slicedToArray(_React$useState5, 2), pingedRight = _React$useState6[0], setPingedRight = _React$useState6[1];
  var _React$useState7 = React452.useState(/* @__PURE__ */ new Map()), _React$useState8 = _slicedToArray(_React$useState7, 2), colsWidths = _React$useState8[0], updateColsWidths = _React$useState8[1];
  var colsKeys = getColumnsKey(flattenColumns);
  var pureColWidths = colsKeys.map(function(columnKey) {
    return colsWidths.get(columnKey);
  });
  var colWidths = React452.useMemo(function() {
    return pureColWidths;
  }, [pureColWidths.join("_")]);
  var stickyOffsets = useStickyOffsets_default(colWidths, flattenColumns, direction);
  var fixHeader = scroll && validateValue(scroll.y);
  var horizonScroll = scroll && validateValue(mergedScrollX) || Boolean(expandableConfig.fixed);
  var fixColumn = horizonScroll && flattenColumns.some(function(_ref) {
    var fixed = _ref.fixed;
    return fixed;
  });
  var stickyRef = React452.useRef();
  var _useSticky = useSticky(sticky, prefixCls), isSticky = _useSticky.isSticky, offsetHeader = _useSticky.offsetHeader, offsetSummary = _useSticky.offsetSummary, offsetScroll = _useSticky.offsetScroll, stickyClassName = _useSticky.stickyClassName, container = _useSticky.container;
  var summaryNode = React452.useMemo(function() {
    return summary === null || summary === void 0 ? void 0 : summary(mergedData);
  }, [summary, mergedData]);
  var fixFooter = (fixHeader || isSticky) && /* @__PURE__ */ React452.isValidElement(summaryNode) && summaryNode.type === Summary_default && summaryNode.props.fixed;
  var scrollXStyle;
  var scrollYStyle;
  var scrollTableStyle;
  if (fixHeader) {
    scrollYStyle = {
      overflowY: hasData ? "scroll" : "auto",
      maxHeight: scroll.y
    };
  }
  if (horizonScroll) {
    scrollXStyle = {
      overflowX: "auto"
    };
    if (!fixHeader) {
      scrollYStyle = {
        overflowY: "hidden"
      };
    }
    scrollTableStyle = {
      width: mergedScrollX === true ? "auto" : mergedScrollX,
      minWidth: "100%"
    };
  }
  var onColumnResize = React452.useCallback(function(columnKey, width) {
    updateColsWidths(function(widths) {
      if (widths.get(columnKey) !== width) {
        var newWidths = new Map(widths);
        newWidths.set(columnKey, width);
        return newWidths;
      }
      return widths;
    });
  }, []);
  var _useTimeoutLock = useTimeoutLock(null), _useTimeoutLock2 = _slicedToArray(_useTimeoutLock, 2), setScrollTarget = _useTimeoutLock2[0], getScrollTarget = _useTimeoutLock2[1];
  function forceScroll(scrollLeft, target) {
    if (!target) {
      return;
    }
    if (typeof target === "function") {
      target(scrollLeft);
    } else if (target.scrollLeft !== scrollLeft) {
      target.scrollLeft = scrollLeft;
      if (target.scrollLeft !== scrollLeft) {
        setTimeout(function() {
          target.scrollLeft = scrollLeft;
        }, 0);
      }
    }
  }
  var onInternalScroll = useEvent2(function(_ref2) {
    var currentTarget = _ref2.currentTarget, scrollLeft = _ref2.scrollLeft;
    var isRTL = direction === "rtl";
    var mergedScrollLeft = typeof scrollLeft === "number" ? scrollLeft : currentTarget.scrollLeft;
    var compareTarget = currentTarget || EMPTY_SCROLL_TARGET;
    if (!getScrollTarget() || getScrollTarget() === compareTarget) {
      var _stickyRef$current;
      setScrollTarget(compareTarget);
      forceScroll(mergedScrollLeft, scrollHeaderRef.current);
      forceScroll(mergedScrollLeft, scrollBodyRef.current);
      forceScroll(mergedScrollLeft, scrollSummaryRef.current);
      forceScroll(mergedScrollLeft, (_stickyRef$current = stickyRef.current) === null || _stickyRef$current === void 0 ? void 0 : _stickyRef$current.setScrollLeft);
    }
    var measureTarget = currentTarget || scrollHeaderRef.current;
    if (measureTarget) {
      var scrollWidth = (
        // Should use mergedScrollX in virtual table(useInternalHooks && tailor === true)
        useInternalHooks && tailor && typeof mergedScrollX === "number" ? mergedScrollX : measureTarget.scrollWidth
      );
      var clientWidth = measureTarget.clientWidth;
      if (scrollWidth === clientWidth) {
        setPingedLeft(false);
        setPingedRight(false);
        return;
      }
      if (isRTL) {
        setPingedLeft(-mergedScrollLeft < scrollWidth - clientWidth);
        setPingedRight(-mergedScrollLeft > 0);
      } else {
        setPingedLeft(mergedScrollLeft > 0);
        setPingedRight(mergedScrollLeft < scrollWidth - clientWidth);
      }
    }
  });
  var onBodyScroll = useEvent2(function(e3) {
    onInternalScroll(e3);
    onScroll === null || onScroll === void 0 || onScroll(e3);
  });
  var triggerOnScroll = function triggerOnScroll2() {
    if (horizonScroll && scrollBodyRef.current) {
      var _scrollBodyRef$curren4;
      onInternalScroll({
        currentTarget: getDOM(scrollBodyRef.current),
        scrollLeft: (_scrollBodyRef$curren4 = scrollBodyRef.current) === null || _scrollBodyRef$curren4 === void 0 ? void 0 : _scrollBodyRef$curren4.scrollLeft
      });
    } else {
      setPingedLeft(false);
      setPingedRight(false);
    }
  };
  var onFullTableResize = function onFullTableResize2(_ref3) {
    var _stickyRef$current2;
    var width = _ref3.width;
    (_stickyRef$current2 = stickyRef.current) === null || _stickyRef$current2 === void 0 || _stickyRef$current2.checkScrollBarVisible();
    var mergedWidth = fullTableRef.current ? fullTableRef.current.offsetWidth : width;
    if (useInternalHooks && getContainerWidth && fullTableRef.current) {
      mergedWidth = getContainerWidth(fullTableRef.current, mergedWidth) || mergedWidth;
    }
    if (mergedWidth !== componentWidth) {
      triggerOnScroll();
      setComponentWidth(mergedWidth);
    }
  };
  var mounted = React452.useRef(false);
  React452.useEffect(function() {
    if (mounted.current) {
      triggerOnScroll();
    }
  }, [horizonScroll, data2, columns.length]);
  React452.useEffect(function() {
    mounted.current = true;
  }, []);
  var _React$useState9 = React452.useState(0), _React$useState10 = _slicedToArray(_React$useState9, 2), scrollbarSize = _React$useState10[0], setScrollbarSize = _React$useState10[1];
  var _React$useState11 = React452.useState(true), _React$useState12 = _slicedToArray(_React$useState11, 2), supportSticky = _React$useState12[0], setSupportSticky = _React$useState12[1];
  useLayoutEffect_default(function() {
    if (!tailor || !useInternalHooks) {
      if (scrollBodyRef.current instanceof Element) {
        setScrollbarSize(getTargetScrollBarSize(scrollBodyRef.current).width);
      } else {
        setScrollbarSize(getTargetScrollBarSize(scrollBodyContainerRef.current).width);
      }
    }
    setSupportSticky(isStyleSupport("position", "sticky"));
  }, []);
  React452.useEffect(function() {
    if (useInternalHooks && internalRefs) {
      internalRefs.body.current = scrollBodyRef.current;
    }
  });
  var renderFixedHeaderTable = React452.useCallback(function(fixedHolderPassProps) {
    return /* @__PURE__ */ React452.createElement(React452.Fragment, null, /* @__PURE__ */ React452.createElement(Header_default, fixedHolderPassProps), fixFooter === "top" && /* @__PURE__ */ React452.createElement(Footer_default, fixedHolderPassProps, summaryNode));
  }, [fixFooter, summaryNode]);
  var renderFixedFooterTable = React452.useCallback(function(fixedHolderPassProps) {
    return /* @__PURE__ */ React452.createElement(Footer_default, fixedHolderPassProps, summaryNode);
  }, [summaryNode]);
  var TableComponent = getComponent(["table"], "table");
  var mergedTableLayout = React452.useMemo(function() {
    if (tableLayout) {
      return tableLayout;
    }
    if (fixColumn) {
      return mergedScrollX === "max-content" ? "auto" : "fixed";
    }
    if (fixHeader || isSticky || flattenColumns.some(function(_ref4) {
      var ellipsis = _ref4.ellipsis;
      return ellipsis;
    })) {
      return "fixed";
    }
    return "auto";
  }, [fixHeader, fixColumn, flattenColumns, tableLayout, isSticky]);
  var groupTableNode;
  var headerProps = {
    colWidths,
    columCount: flattenColumns.length,
    stickyOffsets,
    onHeaderRow,
    fixHeader,
    scroll
  };
  var emptyNode = React452.useMemo(function() {
    if (hasData) {
      return null;
    }
    if (typeof emptyText === "function") {
      return emptyText();
    }
    return emptyText;
  }, [hasData, emptyText]);
  var bodyTable = /* @__PURE__ */ React452.createElement(Body_default, {
    data: mergedData,
    measureColumnWidth: fixHeader || horizonScroll || isSticky
  });
  var bodyColGroup = /* @__PURE__ */ React452.createElement(ColGroup_default, {
    colWidths: flattenColumns.map(function(_ref5) {
      var width = _ref5.width;
      return width;
    }),
    columns: flattenColumns
  });
  var captionElement = caption !== null && caption !== void 0 ? /* @__PURE__ */ React452.createElement("caption", {
    className: "".concat(prefixCls, "-caption")
  }, caption) : void 0;
  var dataProps = pickAttrs(props, {
    data: true
  });
  var ariaProps = pickAttrs(props, {
    aria: true
  });
  if (fixHeader || isSticky) {
    var bodyContent;
    if (typeof customizeScrollBody === "function") {
      bodyContent = customizeScrollBody(mergedData, {
        scrollbarSize,
        ref: scrollBodyRef,
        onScroll: onInternalScroll
      });
      headerProps.colWidths = flattenColumns.map(function(_ref6, index3) {
        var width = _ref6.width;
        var colWidth = index3 === flattenColumns.length - 1 ? width - scrollbarSize : width;
        if (typeof colWidth === "number" && !Number.isNaN(colWidth)) {
          return colWidth;
        }
        if (true) {
          warning_default(props.columns.length === 0, "When use `components.body` with render props. Each column should have a fixed `width` value.");
        }
        return 0;
      });
    } else {
      bodyContent = /* @__PURE__ */ React452.createElement("div", {
        style: _objectSpread2(_objectSpread2({}, scrollXStyle), scrollYStyle),
        onScroll: onBodyScroll,
        ref: scrollBodyRef,
        className: (0, import_classnames181.default)("".concat(prefixCls, "-body"))
      }, /* @__PURE__ */ React452.createElement(TableComponent, _extends({
        style: _objectSpread2(_objectSpread2({}, scrollTableStyle), {}, {
          tableLayout: mergedTableLayout
        })
      }, ariaProps), captionElement, bodyColGroup, bodyTable, !fixFooter && summaryNode && /* @__PURE__ */ React452.createElement(Footer_default, {
        stickyOffsets,
        flattenColumns
      }, summaryNode)));
    }
    var fixedHolderProps = _objectSpread2(_objectSpread2(_objectSpread2({
      noData: !mergedData.length,
      maxContentScroll: horizonScroll && mergedScrollX === "max-content"
    }, headerProps), columnContext), {}, {
      direction,
      stickyClassName,
      onScroll: onInternalScroll
    });
    groupTableNode = /* @__PURE__ */ React452.createElement(React452.Fragment, null, showHeader !== false && /* @__PURE__ */ React452.createElement(FixedHolder_default, _extends({}, fixedHolderProps, {
      stickyTopOffset: offsetHeader,
      className: "".concat(prefixCls, "-header"),
      ref: scrollHeaderRef
    }), renderFixedHeaderTable), bodyContent, fixFooter && fixFooter !== "top" && /* @__PURE__ */ React452.createElement(FixedHolder_default, _extends({}, fixedHolderProps, {
      stickyBottomOffset: offsetSummary,
      className: "".concat(prefixCls, "-summary"),
      ref: scrollSummaryRef
    }), renderFixedFooterTable), isSticky && scrollBodyRef.current && scrollBodyRef.current instanceof Element && /* @__PURE__ */ React452.createElement(stickyScrollBar_default, {
      ref: stickyRef,
      offsetScroll,
      scrollBodyRef,
      onScroll: onInternalScroll,
      container,
      direction
    }));
  } else {
    groupTableNode = /* @__PURE__ */ React452.createElement("div", {
      style: _objectSpread2(_objectSpread2({}, scrollXStyle), scrollYStyle),
      className: (0, import_classnames181.default)("".concat(prefixCls, "-content")),
      onScroll: onInternalScroll,
      ref: scrollBodyRef
    }, /* @__PURE__ */ React452.createElement(TableComponent, _extends({
      style: _objectSpread2(_objectSpread2({}, scrollTableStyle), {}, {
        tableLayout: mergedTableLayout
      })
    }, ariaProps), captionElement, bodyColGroup, showHeader !== false && /* @__PURE__ */ React452.createElement(Header_default, _extends({}, headerProps, columnContext)), bodyTable, summaryNode && /* @__PURE__ */ React452.createElement(Footer_default, {
      stickyOffsets,
      flattenColumns
    }, summaryNode)));
  }
  var fullTable = /* @__PURE__ */ React452.createElement("div", _extends({
    className: (0, import_classnames181.default)(prefixCls, className2, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "".concat(prefixCls, "-rtl"), direction === "rtl"), "".concat(prefixCls, "-ping-left"), pingedLeft), "".concat(prefixCls, "-ping-right"), pingedRight), "".concat(prefixCls, "-layout-fixed"), tableLayout === "fixed"), "".concat(prefixCls, "-fixed-header"), fixHeader), "".concat(prefixCls, "-fixed-column"), fixColumn), "".concat(prefixCls, "-fixed-column-gapped"), fixColumn && hasGapFixed), "".concat(prefixCls, "-scroll-horizontal"), horizonScroll), "".concat(prefixCls, "-has-fix-left"), flattenColumns[0] && flattenColumns[0].fixed), "".concat(prefixCls, "-has-fix-right"), flattenColumns[flattenColumns.length - 1] && flattenColumns[flattenColumns.length - 1].fixed === "right")),
    style: style2,
    id,
    ref: fullTableRef
  }, dataProps), title && /* @__PURE__ */ React452.createElement(Panel_default3, {
    className: "".concat(prefixCls, "-title")
  }, title(mergedData)), /* @__PURE__ */ React452.createElement("div", {
    ref: scrollBodyContainerRef,
    className: "".concat(prefixCls, "-container")
  }, groupTableNode), footer && /* @__PURE__ */ React452.createElement(Panel_default3, {
    className: "".concat(prefixCls, "-footer")
  }, footer(mergedData)));
  if (horizonScroll) {
    fullTable = /* @__PURE__ */ React452.createElement(es_default, {
      onResize: onFullTableResize
    }, fullTable);
  }
  var fixedInfoList = useFixedInfo(flattenColumns, stickyOffsets, direction);
  var TableContextValue = React452.useMemo(function() {
    return {
      // Scroll
      scrollX: mergedScrollX,
      // Table
      prefixCls,
      getComponent,
      scrollbarSize,
      direction,
      fixedInfoList,
      isSticky,
      supportSticky,
      componentWidth,
      fixHeader,
      fixColumn,
      horizonScroll,
      // Body
      tableLayout: mergedTableLayout,
      rowClassName,
      expandedRowClassName: expandableConfig.expandedRowClassName,
      expandIcon: mergedExpandIcon,
      expandableType,
      expandRowByClick: expandableConfig.expandRowByClick,
      expandedRowRender: expandableConfig.expandedRowRender,
      expandedRowOffset: expandableConfig.expandedRowOffset,
      onTriggerExpand,
      expandIconColumnIndex: expandableConfig.expandIconColumnIndex,
      indentSize: expandableConfig.indentSize,
      allColumnsFixedLeft: flattenColumns.every(function(col) {
        return col.fixed === "left";
      }),
      emptyNode,
      // Column
      columns,
      flattenColumns,
      onColumnResize,
      colWidths,
      // Row
      hoverStartRow: startRow,
      hoverEndRow: endRow,
      onHover,
      rowExpandable: expandableConfig.rowExpandable,
      onRow,
      getRowKey,
      expandedKeys: mergedExpandedKeys,
      childrenColumnName: mergedChildrenColumnName,
      rowHoverable
    };
  }, [
    // Scroll
    mergedScrollX,
    // Table
    prefixCls,
    getComponent,
    scrollbarSize,
    direction,
    fixedInfoList,
    isSticky,
    supportSticky,
    componentWidth,
    fixHeader,
    fixColumn,
    horizonScroll,
    // Body
    mergedTableLayout,
    rowClassName,
    expandableConfig.expandedRowClassName,
    mergedExpandIcon,
    expandableType,
    expandableConfig.expandRowByClick,
    expandableConfig.expandedRowRender,
    expandableConfig.expandedRowOffset,
    onTriggerExpand,
    expandableConfig.expandIconColumnIndex,
    expandableConfig.indentSize,
    emptyNode,
    // Column
    columns,
    flattenColumns,
    onColumnResize,
    colWidths,
    // Row
    startRow,
    endRow,
    onHover,
    expandableConfig.rowExpandable,
    onRow,
    getRowKey,
    mergedExpandedKeys,
    mergedChildrenColumnName,
    rowHoverable
  ]);
  return /* @__PURE__ */ React452.createElement(TableContext_default.Provider, {
    value: TableContextValue
  }, fullTable);
}
var RefTable = /* @__PURE__ */ React452.forwardRef(Table2);
if (true) {
  RefTable.displayName = "Table";
}
function genTable(shouldTriggerRender) {
  return makeImmutable2(RefTable, shouldTriggerRender);
}
var ImmutableTable = genTable();
ImmutableTable.EXPAND_COLUMN = EXPAND_COLUMN;
ImmutableTable.INTERNAL_HOOKS = INTERNAL_HOOKS;
ImmutableTable.Column = Column_default;
ImmutableTable.ColumnGroup = ColumnGroup_default;
ImmutableTable.Summary = FooterComponents;
var Table_default = ImmutableTable;

// ../../node_modules/rc-table/es/VirtualTable/index.js
var import_classnames184 = __toESM(require_classnames());
var React456 = __toESM(require_react());

// ../../node_modules/rc-table/es/VirtualTable/BodyGrid.js
var React455 = __toESM(require_react());

// ../../node_modules/rc-table/es/VirtualTable/BodyLine.js
var import_classnames183 = __toESM(require_classnames());
var React454 = __toESM(require_react());

// ../../node_modules/rc-table/es/VirtualTable/VirtualCell.js
var import_classnames182 = __toESM(require_classnames());
var React453 = __toESM(require_react());

// ../../node_modules/rc-table/es/VirtualTable/context.js
var StaticContext = createContext44(null);
var GridContext = createContext44(null);

// ../../node_modules/rc-table/es/VirtualTable/VirtualCell.js
function getColumnWidth(colIndex, colSpan, columnsOffset) {
  var mergedColSpan = colSpan || 1;
  return columnsOffset[colIndex + mergedColSpan] - (columnsOffset[colIndex] || 0);
}
function VirtualCell(props) {
  var rowInfo = props.rowInfo, column2 = props.column, colIndex = props.colIndex, indent = props.indent, index3 = props.index, component = props.component, renderIndex = props.renderIndex, record = props.record, style2 = props.style, className2 = props.className, inverse = props.inverse, getHeight = props.getHeight;
  var render4 = column2.render, dataIndex = column2.dataIndex, columnClassName = column2.className, colWidth = column2.width;
  var _useContext = useContext151(GridContext, ["columnsOffset"]), columnsOffset = _useContext.columnsOffset;
  var _getCellProps = getCellProps(rowInfo, column2, colIndex, indent, index3), key2 = _getCellProps.key, fixedInfo = _getCellProps.fixedInfo, appendCellNode = _getCellProps.appendCellNode, additionalCellProps = _getCellProps.additionalCellProps;
  var cellStyle = additionalCellProps.style, _additionalCellProps$ = additionalCellProps.colSpan, colSpan = _additionalCellProps$ === void 0 ? 1 : _additionalCellProps$, _additionalCellProps$2 = additionalCellProps.rowSpan, rowSpan = _additionalCellProps$2 === void 0 ? 1 : _additionalCellProps$2;
  var startColIndex = colIndex - 1;
  var concatColWidth = getColumnWidth(startColIndex, colSpan, columnsOffset);
  var marginOffset = colSpan > 1 ? colWidth - concatColWidth : 0;
  var mergedStyle = _objectSpread2(_objectSpread2(_objectSpread2({}, cellStyle), style2), {}, {
    flex: "0 0 ".concat(concatColWidth, "px"),
    width: "".concat(concatColWidth, "px"),
    marginRight: marginOffset,
    pointerEvents: "auto"
  });
  var needHide = React453.useMemo(function() {
    if (inverse) {
      return rowSpan <= 1;
    } else {
      return colSpan === 0 || rowSpan === 0 || rowSpan > 1;
    }
  }, [rowSpan, colSpan, inverse]);
  if (needHide) {
    mergedStyle.visibility = "hidden";
  } else if (inverse) {
    mergedStyle.height = getHeight === null || getHeight === void 0 ? void 0 : getHeight(rowSpan);
  }
  var mergedRender = needHide ? function() {
    return null;
  } : render4;
  var cellSpan = {};
  if (rowSpan === 0 || colSpan === 0) {
    cellSpan.rowSpan = 1;
    cellSpan.colSpan = 1;
  }
  return /* @__PURE__ */ React453.createElement(Cell_default, _extends({
    className: (0, import_classnames182.default)(columnClassName, className2),
    ellipsis: column2.ellipsis,
    align: column2.align,
    scope: column2.rowScope,
    component,
    prefixCls: rowInfo.prefixCls,
    key: key2,
    record,
    index: index3,
    renderIndex,
    dataIndex,
    render: mergedRender,
    shouldCellUpdate: column2.shouldCellUpdate
  }, fixedInfo, {
    appendNode: appendCellNode,
    additionalProps: _objectSpread2(_objectSpread2({}, additionalCellProps), {}, {
      style: mergedStyle
    }, cellSpan)
  }));
}
var VirtualCell_default = VirtualCell;

// ../../node_modules/rc-table/es/VirtualTable/BodyLine.js
var _excluded69 = ["data", "index", "className", "rowKey", "style", "extra", "getHeight"];
var BodyLine = /* @__PURE__ */ React454.forwardRef(function(props, ref3) {
  var data2 = props.data, index3 = props.index, className2 = props.className, rowKey = props.rowKey, style2 = props.style, extra = props.extra, getHeight = props.getHeight, restProps = _objectWithoutProperties(props, _excluded69);
  var record = data2.record, indent = data2.indent, renderIndex = data2.index;
  var _useContext = useContext151(TableContext_default, ["prefixCls", "flattenColumns", "fixColumn", "componentWidth", "scrollX"]), scrollX = _useContext.scrollX, flattenColumns = _useContext.flattenColumns, prefixCls = _useContext.prefixCls, fixColumn = _useContext.fixColumn, componentWidth = _useContext.componentWidth;
  var _useContext2 = useContext151(StaticContext, ["getComponent"]), getComponent = _useContext2.getComponent;
  var rowInfo = useRowInfo(record, rowKey, index3, indent);
  var RowComponent = getComponent(["body", "row"], "div");
  var cellComponent = getComponent(["body", "cell"], "div");
  var rowSupportExpand = rowInfo.rowSupportExpand, expanded = rowInfo.expanded, rowProps = rowInfo.rowProps, expandedRowRender = rowInfo.expandedRowRender, expandedRowClassName = rowInfo.expandedRowClassName;
  var expandRowNode;
  if (rowSupportExpand && expanded) {
    var expandContent = expandedRowRender(record, index3, indent + 1, expanded);
    var expandedClsName = computedExpandedClassName(expandedRowClassName, record, index3, indent);
    var additionalProps = {};
    if (fixColumn) {
      additionalProps = {
        style: _defineProperty({}, "--virtual-width", "".concat(componentWidth, "px"))
      };
    }
    var rowCellCls = "".concat(prefixCls, "-expanded-row-cell");
    expandRowNode = /* @__PURE__ */ React454.createElement(RowComponent, {
      className: (0, import_classnames183.default)("".concat(prefixCls, "-expanded-row"), "".concat(prefixCls, "-expanded-row-level-").concat(indent + 1), expandedClsName)
    }, /* @__PURE__ */ React454.createElement(Cell_default, {
      component: cellComponent,
      prefixCls,
      className: (0, import_classnames183.default)(rowCellCls, _defineProperty({}, "".concat(rowCellCls, "-fixed"), fixColumn)),
      additionalProps
    }, expandContent));
  }
  var rowStyle = _objectSpread2(_objectSpread2({}, style2), {}, {
    width: scrollX
  });
  if (extra) {
    rowStyle.position = "absolute";
    rowStyle.pointerEvents = "none";
  }
  var rowNode = /* @__PURE__ */ React454.createElement(RowComponent, _extends({}, rowProps, restProps, {
    "data-row-key": rowKey,
    ref: rowSupportExpand ? null : ref3,
    className: (0, import_classnames183.default)(className2, "".concat(prefixCls, "-row"), rowProps === null || rowProps === void 0 ? void 0 : rowProps.className, _defineProperty({}, "".concat(prefixCls, "-row-extra"), extra)),
    style: _objectSpread2(_objectSpread2({}, rowStyle), rowProps === null || rowProps === void 0 ? void 0 : rowProps.style)
  }), flattenColumns.map(function(column2, colIndex) {
    return /* @__PURE__ */ React454.createElement(VirtualCell_default, {
      key: colIndex,
      component: cellComponent,
      rowInfo,
      column: column2,
      colIndex,
      indent,
      index: index3,
      renderIndex,
      record,
      inverse: extra,
      getHeight
    });
  }));
  if (rowSupportExpand) {
    return /* @__PURE__ */ React454.createElement("div", {
      ref: ref3
    }, rowNode, expandRowNode);
  }
  return rowNode;
});
var ResponseBodyLine = responseImmutable2(BodyLine);
if (true) {
  ResponseBodyLine.displayName = "BodyLine";
}
var BodyLine_default = ResponseBodyLine;

// ../../node_modules/rc-table/es/VirtualTable/BodyGrid.js
var Grid2 = /* @__PURE__ */ React455.forwardRef(function(props, ref3) {
  var data2 = props.data, onScroll = props.onScroll;
  var _useContext = useContext151(TableContext_default, ["flattenColumns", "onColumnResize", "getRowKey", "prefixCls", "expandedKeys", "childrenColumnName", "scrollX", "direction"]), flattenColumns = _useContext.flattenColumns, onColumnResize = _useContext.onColumnResize, getRowKey = _useContext.getRowKey, expandedKeys = _useContext.expandedKeys, prefixCls = _useContext.prefixCls, childrenColumnName = _useContext.childrenColumnName, scrollX = _useContext.scrollX, direction = _useContext.direction;
  var _useContext2 = useContext151(StaticContext), sticky = _useContext2.sticky, scrollY = _useContext2.scrollY, listItemHeight = _useContext2.listItemHeight, getComponent = _useContext2.getComponent, onTablePropScroll = _useContext2.onScroll;
  var listRef = React455.useRef();
  var flattenData2 = useFlattenRecords(data2, childrenColumnName, expandedKeys, getRowKey);
  var columnsWidth = React455.useMemo(function() {
    var total = 0;
    return flattenColumns.map(function(_ref) {
      var width = _ref.width, key2 = _ref.key;
      total += width;
      return [key2, width, total];
    });
  }, [flattenColumns]);
  var columnsOffset = React455.useMemo(function() {
    return columnsWidth.map(function(colWidth) {
      return colWidth[2];
    });
  }, [columnsWidth]);
  React455.useEffect(function() {
    columnsWidth.forEach(function(_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2), key2 = _ref3[0], width = _ref3[1];
      onColumnResize(key2, width);
    });
  }, [columnsWidth]);
  React455.useImperativeHandle(ref3, function() {
    var _listRef$current2;
    var obj = {
      scrollTo: function scrollTo2(config) {
        var _listRef$current;
        (_listRef$current = listRef.current) === null || _listRef$current === void 0 || _listRef$current.scrollTo(config);
      },
      nativeElement: (_listRef$current2 = listRef.current) === null || _listRef$current2 === void 0 ? void 0 : _listRef$current2.nativeElement
    };
    Object.defineProperty(obj, "scrollLeft", {
      get: function get3() {
        var _listRef$current3;
        return ((_listRef$current3 = listRef.current) === null || _listRef$current3 === void 0 ? void 0 : _listRef$current3.getScrollInfo().x) || 0;
      },
      set: function set4(value) {
        var _listRef$current4;
        (_listRef$current4 = listRef.current) === null || _listRef$current4 === void 0 || _listRef$current4.scrollTo({
          left: value
        });
      }
    });
    return obj;
  });
  var getRowSpan = function getRowSpan2(column2, index3) {
    var _flattenData$index;
    var record = (_flattenData$index = flattenData2[index3]) === null || _flattenData$index === void 0 ? void 0 : _flattenData$index.record;
    var onCell = column2.onCell;
    if (onCell) {
      var _cellProps$rowSpan;
      var cellProps = onCell(record, index3);
      return (_cellProps$rowSpan = cellProps === null || cellProps === void 0 ? void 0 : cellProps.rowSpan) !== null && _cellProps$rowSpan !== void 0 ? _cellProps$rowSpan : 1;
    }
    return 1;
  };
  var extraRender = function extraRender2(info) {
    var start = info.start, end = info.end, getSize5 = info.getSize, offsetY = info.offsetY;
    if (end < 0) {
      return null;
    }
    var firstRowSpanColumns = flattenColumns.filter(
      // rowSpan is 0
      function(column2) {
        return getRowSpan(column2, start) === 0;
      }
    );
    var startIndex = start;
    var _loop = function _loop4(i2) {
      firstRowSpanColumns = firstRowSpanColumns.filter(function(column2) {
        return getRowSpan(column2, i2) === 0;
      });
      if (!firstRowSpanColumns.length) {
        startIndex = i2;
        return 1;
      }
    };
    for (var i = start; i >= 0; i -= 1) {
      if (_loop(i)) break;
    }
    var lastRowSpanColumns = flattenColumns.filter(
      // rowSpan is not 1
      function(column2) {
        return getRowSpan(column2, end) !== 1;
      }
    );
    var endIndex = end;
    var _loop2 = function _loop22(_i3) {
      lastRowSpanColumns = lastRowSpanColumns.filter(function(column2) {
        return getRowSpan(column2, _i3) !== 1;
      });
      if (!lastRowSpanColumns.length) {
        endIndex = Math.max(_i3 - 1, end);
        return 1;
      }
    };
    for (var _i = end; _i < flattenData2.length; _i += 1) {
      if (_loop2(_i)) break;
    }
    var spanLines = [];
    var _loop3 = function _loop32(_i22) {
      var item = flattenData2[_i22];
      if (!item) {
        return 1;
      }
      if (flattenColumns.some(function(column2) {
        return getRowSpan(column2, _i22) > 1;
      })) {
        spanLines.push(_i22);
      }
    };
    for (var _i2 = startIndex; _i2 <= endIndex; _i2 += 1) {
      if (_loop3(_i2)) continue;
    }
    var nodes = spanLines.map(function(index3) {
      var item = flattenData2[index3];
      var rowKey = getRowKey(item.record, index3);
      var getHeight = function getHeight2(rowSpan) {
        var endItemIndex = index3 + rowSpan - 1;
        var endItemKey = getRowKey(flattenData2[endItemIndex].record, endItemIndex);
        var sizeInfo2 = getSize5(rowKey, endItemKey);
        return sizeInfo2.bottom - sizeInfo2.top;
      };
      var sizeInfo = getSize5(rowKey);
      return /* @__PURE__ */ React455.createElement(BodyLine_default, {
        key: index3,
        data: item,
        rowKey,
        index: index3,
        style: {
          top: -offsetY + sizeInfo.top
        },
        extra: true,
        getHeight
      });
    });
    return nodes;
  };
  var gridContext = React455.useMemo(function() {
    return {
      columnsOffset
    };
  }, [columnsOffset]);
  var tblPrefixCls = "".concat(prefixCls, "-tbody");
  var wrapperComponent = getComponent(["body", "wrapper"]);
  var horizontalScrollBarStyle = {};
  if (sticky) {
    horizontalScrollBarStyle.position = "sticky";
    horizontalScrollBarStyle.bottom = 0;
    if (_typeof(sticky) === "object" && sticky.offsetScroll) {
      horizontalScrollBarStyle.bottom = sticky.offsetScroll;
    }
  }
  return /* @__PURE__ */ React455.createElement(GridContext.Provider, {
    value: gridContext
  }, /* @__PURE__ */ React455.createElement(es_default10, {
    fullHeight: false,
    ref: listRef,
    prefixCls: "".concat(tblPrefixCls, "-virtual"),
    styles: {
      horizontalScrollBar: horizontalScrollBarStyle
    },
    className: tblPrefixCls,
    height: scrollY,
    itemHeight: listItemHeight || 24,
    data: flattenData2,
    itemKey: function itemKey3(item) {
      return getRowKey(item.record);
    },
    component: wrapperComponent,
    scrollWidth: scrollX,
    direction,
    onVirtualScroll: function onVirtualScroll(_ref4) {
      var _listRef$current5;
      var x = _ref4.x;
      onScroll({
        currentTarget: (_listRef$current5 = listRef.current) === null || _listRef$current5 === void 0 ? void 0 : _listRef$current5.nativeElement,
        scrollLeft: x
      });
    },
    onScroll: onTablePropScroll,
    extraRender
  }, function(item, index3, itemProps) {
    var rowKey = getRowKey(item.record, index3);
    return /* @__PURE__ */ React455.createElement(BodyLine_default, {
      data: item,
      rowKey,
      index: index3,
      style: itemProps.style
    });
  }));
});
var ResponseGrid = responseImmutable2(Grid2);
if (true) {
  ResponseGrid.displayName = "ResponseGrid";
}
var BodyGrid_default = ResponseGrid;

// ../../node_modules/rc-table/es/VirtualTable/index.js
var renderBody = function renderBody2(rawData, props) {
  var ref3 = props.ref, onScroll = props.onScroll;
  return /* @__PURE__ */ React456.createElement(BodyGrid_default, {
    ref: ref3,
    data: rawData,
    onScroll
  });
};
function VirtualTable(props, ref3) {
  var data2 = props.data, columns = props.columns, scroll = props.scroll, sticky = props.sticky, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? DEFAULT_PREFIX : _props$prefixCls, className2 = props.className, listItemHeight = props.listItemHeight, components = props.components, onScroll = props.onScroll;
  var _ref = scroll || {}, scrollX = _ref.x, scrollY = _ref.y;
  if (typeof scrollX !== "number") {
    if (true) {
      warning_default(!scrollX, "`scroll.x` in virtual table must be number.");
    }
    scrollX = 1;
  }
  if (typeof scrollY !== "number") {
    scrollY = 500;
    if (true) {
      warning_default(false, "`scroll.y` in virtual table must be number.");
    }
  }
  var getComponent = useEvent2(function(path2, defaultComponent) {
    return get(components, path2) || defaultComponent;
  });
  var onInternalScroll = useEvent2(onScroll);
  var context = React456.useMemo(function() {
    return {
      sticky,
      scrollY,
      listItemHeight,
      getComponent,
      onScroll: onInternalScroll
    };
  }, [sticky, scrollY, listItemHeight, getComponent, onInternalScroll]);
  return /* @__PURE__ */ React456.createElement(StaticContext.Provider, {
    value: context
  }, /* @__PURE__ */ React456.createElement(Table_default, _extends({}, props, {
    className: (0, import_classnames184.default)(className2, "".concat(prefixCls, "-virtual")),
    scroll: _objectSpread2(_objectSpread2({}, scroll), {}, {
      x: scrollX
    }),
    components: _objectSpread2(_objectSpread2({}, components), {}, {
      // fix https://github.com/ant-design/ant-design/issues/48991
      body: data2 !== null && data2 !== void 0 && data2.length ? renderBody : void 0
    }),
    columns,
    internalHooks: INTERNAL_HOOKS,
    tailor: true,
    ref: ref3
  })));
}
var RefVirtualTable = /* @__PURE__ */ React456.forwardRef(VirtualTable);
if (true) {
  RefVirtualTable.displayName = "VirtualTable";
}
function genVirtualTable(shouldTriggerRender) {
  return makeImmutable2(RefVirtualTable, shouldTriggerRender);
}
var VirtualTable_default = genVirtualTable();

// ../../node_modules/antd/es/table/Column.js
var Column3 = (_) => null;
var Column_default2 = Column3;

// ../../node_modules/antd/es/table/ColumnGroup.js
var ColumnGroup2 = (_) => null;
var ColumnGroup_default2 = ColumnGroup2;

// ../../node_modules/antd/es/table/hooks/useSelection.js
var React461 = __toESM(require_react());
var import_react144 = __toESM(require_react());
var import_classnames187 = __toESM(require_classnames());

// ../../node_modules/rc-tree/es/util.js
var import_react142 = __toESM(require_react());

// ../../node_modules/rc-tree/es/TreeNode.js
var import_react141 = __toESM(require_react());
var import_classnames186 = __toESM(require_classnames());

// ../../node_modules/rc-tree/es/contextTypes.js
var React457 = __toESM(require_react());
var TreeContext = /* @__PURE__ */ React457.createContext(null);
var UnstableContext2 = /* @__PURE__ */ React457.createContext({});

// ../../node_modules/rc-tree/es/Indent.js
var import_classnames185 = __toESM(require_classnames());
var React458 = __toESM(require_react());
var Indent = function Indent2(_ref) {
  var prefixCls = _ref.prefixCls, level = _ref.level, isStart = _ref.isStart, isEnd = _ref.isEnd;
  var baseClassName2 = "".concat(prefixCls, "-indent-unit");
  var list = [];
  for (var i = 0; i < level; i += 1) {
    list.push(/* @__PURE__ */ React458.createElement("span", {
      key: i,
      className: (0, import_classnames185.default)(baseClassName2, _defineProperty(_defineProperty({}, "".concat(baseClassName2, "-start"), isStart[i]), "".concat(baseClassName2, "-end"), isEnd[i]))
    }));
  }
  return /* @__PURE__ */ React458.createElement("span", {
    "aria-hidden": "true",
    className: "".concat(prefixCls, "-indent")
  }, list);
};
var Indent_default = /* @__PURE__ */ React458.memo(Indent);

// ../../node_modules/rc-tree/es/TreeNode.js
var _excluded70 = ["eventKey", "className", "style", "dragOver", "dragOverGapTop", "dragOverGapBottom", "isLeaf", "isStart", "isEnd", "expanded", "selected", "checked", "halfChecked", "loading", "domRef", "active", "data", "onMouseMove", "selectable"];
var ICON_OPEN = "open";
var ICON_CLOSE = "close";
var defaultTitle = "---";
var TreeNode = function TreeNode2(props) {
  var _unstableContext$node, _context$filterTreeNo, _classNames4;
  var eventKey = props.eventKey, className2 = props.className, style2 = props.style, dragOver = props.dragOver, dragOverGapTop = props.dragOverGapTop, dragOverGapBottom = props.dragOverGapBottom, isLeaf = props.isLeaf, isStart = props.isStart, isEnd = props.isEnd, expanded = props.expanded, selected = props.selected, checked = props.checked, halfChecked = props.halfChecked, loading = props.loading, domRef = props.domRef, active = props.active, data2 = props.data, onMouseMove = props.onMouseMove, selectable = props.selectable, otherProps = _objectWithoutProperties(props, _excluded70);
  var context = import_react141.default.useContext(TreeContext);
  var unstableContext = import_react141.default.useContext(UnstableContext2);
  var selectHandleRef = import_react141.default.useRef(null);
  var _React$useState = import_react141.default.useState(false), _React$useState2 = _slicedToArray(_React$useState, 2), dragNodeHighlight = _React$useState2[0], setDragNodeHighlight = _React$useState2[1];
  var isDisabled = !!(context.disabled || props.disabled || (_unstableContext$node = unstableContext.nodeDisabled) !== null && _unstableContext$node !== void 0 && _unstableContext$node.call(unstableContext, data2));
  var isCheckable = import_react141.default.useMemo(function() {
    if (!context.checkable || props.checkable === false) {
      return false;
    }
    return context.checkable;
  }, [context.checkable, props.checkable]);
  var onSelect = function onSelect2(e3) {
    if (isDisabled) {
      return;
    }
    context.onNodeSelect(e3, convertNodePropsToEventData(props));
  };
  var onCheck = function onCheck2(e3) {
    if (isDisabled) {
      return;
    }
    if (!isCheckable || props.disableCheckbox) {
      return;
    }
    context.onNodeCheck(e3, convertNodePropsToEventData(props), !checked);
  };
  var isSelectable = import_react141.default.useMemo(function() {
    if (typeof selectable === "boolean") {
      return selectable;
    }
    return context.selectable;
  }, [selectable, context.selectable]);
  var onSelectorClick = function onSelectorClick2(e3) {
    context.onNodeClick(e3, convertNodePropsToEventData(props));
    if (isSelectable) {
      onSelect(e3);
    } else {
      onCheck(e3);
    }
  };
  var onSelectorDoubleClick = function onSelectorDoubleClick2(e3) {
    context.onNodeDoubleClick(e3, convertNodePropsToEventData(props));
  };
  var onMouseEnter = function onMouseEnter2(e3) {
    context.onNodeMouseEnter(e3, convertNodePropsToEventData(props));
  };
  var onMouseLeave = function onMouseLeave2(e3) {
    context.onNodeMouseLeave(e3, convertNodePropsToEventData(props));
  };
  var onContextMenu = function onContextMenu2(e3) {
    context.onNodeContextMenu(e3, convertNodePropsToEventData(props));
  };
  var isDraggable = import_react141.default.useMemo(function() {
    return !!(context.draggable && (!context.draggable.nodeDraggable || context.draggable.nodeDraggable(data2)));
  }, [context.draggable, data2]);
  var onDragStart = function onDragStart2(e3) {
    e3.stopPropagation();
    setDragNodeHighlight(true);
    context.onNodeDragStart(e3, props);
    try {
      e3.dataTransfer.setData("text/plain", "");
    } catch (_unused) {
    }
  };
  var onDragEnter = function onDragEnter2(e3) {
    e3.preventDefault();
    e3.stopPropagation();
    context.onNodeDragEnter(e3, props);
  };
  var onDragOver = function onDragOver2(e3) {
    e3.preventDefault();
    e3.stopPropagation();
    context.onNodeDragOver(e3, props);
  };
  var onDragLeave = function onDragLeave2(e3) {
    e3.stopPropagation();
    context.onNodeDragLeave(e3, props);
  };
  var onDragEnd = function onDragEnd2(e3) {
    e3.stopPropagation();
    setDragNodeHighlight(false);
    context.onNodeDragEnd(e3, props);
  };
  var onDrop = function onDrop2(e3) {
    e3.preventDefault();
    e3.stopPropagation();
    setDragNodeHighlight(false);
    context.onNodeDrop(e3, props);
  };
  var onExpand = function onExpand2(e3) {
    if (loading) {
      return;
    }
    context.onNodeExpand(e3, convertNodePropsToEventData(props));
  };
  var hasChildren = import_react141.default.useMemo(function() {
    var _ref = getEntity(context.keyEntities, eventKey) || {}, children = _ref.children;
    return Boolean((children || []).length);
  }, [context.keyEntities, eventKey]);
  var memoizedIsLeaf = import_react141.default.useMemo(function() {
    if (isLeaf === false) {
      return false;
    }
    return isLeaf || !context.loadData && !hasChildren || context.loadData && props.loaded && !hasChildren;
  }, [isLeaf, context.loadData, hasChildren, props.loaded]);
  import_react141.default.useEffect(function() {
    if (loading) {
      return;
    }
    if (typeof context.loadData === "function" && expanded && !memoizedIsLeaf && !props.loaded) {
      context.onNodeLoad(convertNodePropsToEventData(props));
    }
  }, [loading, context.loadData, context.onNodeLoad, expanded, memoizedIsLeaf, props]);
  var dragHandlerNode = import_react141.default.useMemo(function() {
    var _context$draggable;
    if (!((_context$draggable = context.draggable) !== null && _context$draggable !== void 0 && _context$draggable.icon)) {
      return null;
    }
    return /* @__PURE__ */ import_react141.default.createElement("span", {
      className: "".concat(context.prefixCls, "-draggable-icon")
    }, context.draggable.icon);
  }, [context.draggable]);
  var renderSwitcherIconDom = function renderSwitcherIconDom2(isInternalLeaf) {
    var switcherIcon = props.switcherIcon || context.switcherIcon;
    if (typeof switcherIcon === "function") {
      return switcherIcon(_objectSpread2(_objectSpread2({}, props), {}, {
        isLeaf: isInternalLeaf
      }));
    }
    return switcherIcon;
  };
  var renderSwitcher = function renderSwitcher2() {
    if (memoizedIsLeaf) {
      var _switcherIconDom = renderSwitcherIconDom(true);
      return _switcherIconDom !== false ? /* @__PURE__ */ import_react141.default.createElement("span", {
        className: (0, import_classnames186.default)("".concat(context.prefixCls, "-switcher"), "".concat(context.prefixCls, "-switcher-noop"))
      }, _switcherIconDom) : null;
    }
    var switcherIconDom = renderSwitcherIconDom(false);
    return switcherIconDom !== false ? /* @__PURE__ */ import_react141.default.createElement("span", {
      onClick: onExpand,
      className: (0, import_classnames186.default)("".concat(context.prefixCls, "-switcher"), "".concat(context.prefixCls, "-switcher_").concat(expanded ? ICON_OPEN : ICON_CLOSE))
    }, switcherIconDom) : null;
  };
  var checkboxNode = import_react141.default.useMemo(function() {
    if (!isCheckable) {
      return null;
    }
    var $custom = typeof isCheckable !== "boolean" ? isCheckable : null;
    return /* @__PURE__ */ import_react141.default.createElement("span", {
      className: (0, import_classnames186.default)("".concat(context.prefixCls, "-checkbox"), _defineProperty(_defineProperty(_defineProperty({}, "".concat(context.prefixCls, "-checkbox-checked"), checked), "".concat(context.prefixCls, "-checkbox-indeterminate"), !checked && halfChecked), "".concat(context.prefixCls, "-checkbox-disabled"), isDisabled || props.disableCheckbox)),
      onClick: onCheck,
      role: "checkbox",
      "aria-checked": halfChecked ? "mixed" : checked,
      "aria-disabled": isDisabled || props.disableCheckbox,
      "aria-label": "Select ".concat(typeof props.title === "string" ? props.title : "tree node")
    }, $custom);
  }, [isCheckable, checked, halfChecked, isDisabled, props.disableCheckbox, props.title]);
  var nodeState = import_react141.default.useMemo(function() {
    if (memoizedIsLeaf) {
      return null;
    }
    return expanded ? ICON_OPEN : ICON_CLOSE;
  }, [memoizedIsLeaf, expanded]);
  var iconNode = import_react141.default.useMemo(function() {
    return /* @__PURE__ */ import_react141.default.createElement("span", {
      className: (0, import_classnames186.default)("".concat(context.prefixCls, "-iconEle"), "".concat(context.prefixCls, "-icon__").concat(nodeState || "docu"), _defineProperty({}, "".concat(context.prefixCls, "-icon_loading"), loading))
    });
  }, [context.prefixCls, nodeState, loading]);
  var dropIndicatorNode = import_react141.default.useMemo(function() {
    var rootDraggable = Boolean(context.draggable);
    var showIndicator = !props.disabled && rootDraggable && context.dragOverNodeKey === eventKey;
    if (!showIndicator) {
      return null;
    }
    return context.dropIndicatorRender({
      dropPosition: context.dropPosition,
      dropLevelOffset: context.dropLevelOffset,
      indent: context.indent,
      prefixCls: context.prefixCls,
      direction: context.direction
    });
  }, [context.dropPosition, context.dropLevelOffset, context.indent, context.prefixCls, context.direction, context.draggable, context.dragOverNodeKey, context.dropIndicatorRender]);
  var selectorNode = import_react141.default.useMemo(function() {
    var _props$title = props.title, title = _props$title === void 0 ? defaultTitle : _props$title;
    var wrapClass = "".concat(context.prefixCls, "-node-content-wrapper");
    var $icon;
    if (context.showIcon) {
      var currentIcon = props.icon || context.icon;
      $icon = currentIcon ? /* @__PURE__ */ import_react141.default.createElement("span", {
        className: (0, import_classnames186.default)("".concat(context.prefixCls, "-iconEle"), "".concat(context.prefixCls, "-icon__customize"))
      }, typeof currentIcon === "function" ? currentIcon(props) : currentIcon) : iconNode;
    } else if (context.loadData && loading) {
      $icon = iconNode;
    }
    var titleNode;
    if (typeof title === "function") {
      titleNode = title(data2);
    } else if (context.titleRender) {
      titleNode = context.titleRender(data2);
    } else {
      titleNode = title;
    }
    return /* @__PURE__ */ import_react141.default.createElement("span", {
      ref: selectHandleRef,
      title: typeof title === "string" ? title : "",
      className: (0, import_classnames186.default)(wrapClass, "".concat(wrapClass, "-").concat(nodeState || "normal"), _defineProperty({}, "".concat(context.prefixCls, "-node-selected"), !isDisabled && (selected || dragNodeHighlight))),
      onMouseEnter,
      onMouseLeave,
      onContextMenu,
      onClick: onSelectorClick,
      onDoubleClick: onSelectorDoubleClick
    }, $icon, /* @__PURE__ */ import_react141.default.createElement("span", {
      className: "".concat(context.prefixCls, "-title")
    }, titleNode), dropIndicatorNode);
  }, [context.prefixCls, context.showIcon, props, context.icon, iconNode, context.titleRender, data2, nodeState, onMouseEnter, onMouseLeave, onContextMenu, onSelectorClick, onSelectorDoubleClick]);
  var dataOrAriaAttributeProps = pickAttrs(otherProps, {
    aria: true,
    data: true
  });
  var _ref2 = getEntity(context.keyEntities, eventKey) || {}, level = _ref2.level;
  var isEndNode = isEnd[isEnd.length - 1];
  var draggableWithoutDisabled = !isDisabled && isDraggable;
  var dragging = context.draggingNodeKey === eventKey;
  var ariaSelected = selectable !== void 0 ? {
    "aria-selected": !!selectable
  } : void 0;
  return /* @__PURE__ */ import_react141.default.createElement("div", _extends({
    ref: domRef,
    role: "treeitem",
    "aria-expanded": isLeaf ? void 0 : expanded,
    className: (0, import_classnames186.default)(className2, "".concat(context.prefixCls, "-treenode"), (_classNames4 = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_classNames4, "".concat(context.prefixCls, "-treenode-disabled"), isDisabled), "".concat(context.prefixCls, "-treenode-switcher-").concat(expanded ? "open" : "close"), !isLeaf), "".concat(context.prefixCls, "-treenode-checkbox-checked"), checked), "".concat(context.prefixCls, "-treenode-checkbox-indeterminate"), halfChecked), "".concat(context.prefixCls, "-treenode-selected"), selected), "".concat(context.prefixCls, "-treenode-loading"), loading), "".concat(context.prefixCls, "-treenode-active"), active), "".concat(context.prefixCls, "-treenode-leaf-last"), isEndNode), "".concat(context.prefixCls, "-treenode-draggable"), isDraggable), "dragging", dragging), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_classNames4, "drop-target", context.dropTargetKey === eventKey), "drop-container", context.dropContainerKey === eventKey), "drag-over", !isDisabled && dragOver), "drag-over-gap-top", !isDisabled && dragOverGapTop), "drag-over-gap-bottom", !isDisabled && dragOverGapBottom), "filter-node", (_context$filterTreeNo = context.filterTreeNode) === null || _context$filterTreeNo === void 0 ? void 0 : _context$filterTreeNo.call(context, convertNodePropsToEventData(props))), "".concat(context.prefixCls, "-treenode-leaf"), memoizedIsLeaf))),
    style: style2,
    draggable: draggableWithoutDisabled,
    onDragStart: draggableWithoutDisabled ? onDragStart : void 0,
    onDragEnter: isDraggable ? onDragEnter : void 0,
    onDragOver: isDraggable ? onDragOver : void 0,
    onDragLeave: isDraggable ? onDragLeave : void 0,
    onDrop: isDraggable ? onDrop : void 0,
    onDragEnd: isDraggable ? onDragEnd : void 0,
    onMouseMove
  }, ariaSelected, dataOrAriaAttributeProps), /* @__PURE__ */ import_react141.default.createElement(Indent_default, {
    prefixCls: context.prefixCls,
    level,
    isStart,
    isEnd
  }), dragHandlerNode, renderSwitcher(), checkboxNode, selectorNode);
};
TreeNode.isTreeNode = 1;
if (true) {
  TreeNode.displayName = "TreeNode";
}
var TreeNode_default = TreeNode;

// ../../node_modules/rc-tree/es/util.js
function arrDel(list, value) {
  if (!list) return [];
  var clone = list.slice();
  var index3 = clone.indexOf(value);
  if (index3 >= 0) {
    clone.splice(index3, 1);
  }
  return clone;
}
function arrAdd(list, value) {
  var clone = (list || []).slice();
  if (clone.indexOf(value) === -1) {
    clone.push(value);
  }
  return clone;
}
function posToArr(pos) {
  return pos.split("-");
}
function getDragChildrenKeys(dragNodeKey, keyEntities) {
  var dragChildrenKeys = [];
  var entity = getEntity(keyEntities, dragNodeKey);
  function dig() {
    var list = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    list.forEach(function(_ref) {
      var key2 = _ref.key, children = _ref.children;
      dragChildrenKeys.push(key2);
      dig(children);
    });
  }
  dig(entity.children);
  return dragChildrenKeys;
}
function isLastChild(treeNodeEntity) {
  if (treeNodeEntity.parent) {
    var posArr = posToArr(treeNodeEntity.pos);
    return Number(posArr[posArr.length - 1]) === treeNodeEntity.parent.children.length - 1;
  }
  return false;
}
function isFirstChild(treeNodeEntity) {
  var posArr = posToArr(treeNodeEntity.pos);
  return Number(posArr[posArr.length - 1]) === 0;
}
function calcDropPosition(event, dragNodeProps, targetNodeProps, indent, startMousePosition, allowDrop2, flattenedNodes, keyEntities, expandKeys, direction) {
  var _abstractDropNodeEnti;
  var clientX = event.clientX, clientY = event.clientY;
  var _getBoundingClientRec = event.target.getBoundingClientRect(), top = _getBoundingClientRec.top, height = _getBoundingClientRec.height;
  var horizontalMouseOffset = (direction === "rtl" ? -1 : 1) * (((startMousePosition === null || startMousePosition === void 0 ? void 0 : startMousePosition.x) || 0) - clientX);
  var rawDropLevelOffset = (horizontalMouseOffset - 12) / indent;
  var filteredExpandKeys = expandKeys.filter(function(key2) {
    var _keyEntities$key;
    return (_keyEntities$key = keyEntities[key2]) === null || _keyEntities$key === void 0 || (_keyEntities$key = _keyEntities$key.children) === null || _keyEntities$key === void 0 ? void 0 : _keyEntities$key.length;
  });
  var abstractDropNodeEntity = getEntity(keyEntities, targetNodeProps.eventKey);
  if (clientY < top + height / 2) {
    var nodeIndex = flattenedNodes.findIndex(function(flattenedNode) {
      return flattenedNode.key === abstractDropNodeEntity.key;
    });
    var prevNodeIndex = nodeIndex <= 0 ? 0 : nodeIndex - 1;
    var prevNodeKey = flattenedNodes[prevNodeIndex].key;
    abstractDropNodeEntity = getEntity(keyEntities, prevNodeKey);
  }
  var initialAbstractDropNodeKey = abstractDropNodeEntity.key;
  var abstractDragOverEntity = abstractDropNodeEntity;
  var dragOverNodeKey = abstractDropNodeEntity.key;
  var dropPosition = 0;
  var dropLevelOffset = 0;
  if (!filteredExpandKeys.includes(initialAbstractDropNodeKey)) {
    for (var i = 0; i < rawDropLevelOffset; i += 1) {
      if (isLastChild(abstractDropNodeEntity)) {
        abstractDropNodeEntity = abstractDropNodeEntity.parent;
        dropLevelOffset += 1;
      } else {
        break;
      }
    }
  }
  var abstractDragDataNode = dragNodeProps.data;
  var abstractDropDataNode = abstractDropNodeEntity.node;
  var dropAllowed = true;
  if (isFirstChild(abstractDropNodeEntity) && abstractDropNodeEntity.level === 0 && clientY < top + height / 2 && allowDrop2({
    dragNode: abstractDragDataNode,
    dropNode: abstractDropDataNode,
    dropPosition: -1
  }) && abstractDropNodeEntity.key === targetNodeProps.eventKey) {
    dropPosition = -1;
  } else if ((abstractDragOverEntity.children || []).length && filteredExpandKeys.includes(dragOverNodeKey)) {
    if (allowDrop2({
      dragNode: abstractDragDataNode,
      dropNode: abstractDropDataNode,
      dropPosition: 0
    })) {
      dropPosition = 0;
    } else {
      dropAllowed = false;
    }
  } else if (dropLevelOffset === 0) {
    if (rawDropLevelOffset > -1.5) {
      if (allowDrop2({
        dragNode: abstractDragDataNode,
        dropNode: abstractDropDataNode,
        dropPosition: 1
      })) {
        dropPosition = 1;
      } else {
        dropAllowed = false;
      }
    } else {
      if (allowDrop2({
        dragNode: abstractDragDataNode,
        dropNode: abstractDropDataNode,
        dropPosition: 0
      })) {
        dropPosition = 0;
      } else if (allowDrop2({
        dragNode: abstractDragDataNode,
        dropNode: abstractDropDataNode,
        dropPosition: 1
      })) {
        dropPosition = 1;
      } else {
        dropAllowed = false;
      }
    }
  } else {
    if (allowDrop2({
      dragNode: abstractDragDataNode,
      dropNode: abstractDropDataNode,
      dropPosition: 1
    })) {
      dropPosition = 1;
    } else {
      dropAllowed = false;
    }
  }
  return {
    dropPosition,
    dropLevelOffset,
    dropTargetKey: abstractDropNodeEntity.key,
    dropTargetPos: abstractDropNodeEntity.pos,
    dragOverNodeKey,
    dropContainerKey: dropPosition === 0 ? null : ((_abstractDropNodeEnti = abstractDropNodeEntity.parent) === null || _abstractDropNodeEnti === void 0 ? void 0 : _abstractDropNodeEnti.key) || null,
    dropAllowed
  };
}
function calcSelectedKeys(selectedKeys, props) {
  if (!selectedKeys) return void 0;
  var multiple = props.multiple;
  if (multiple) {
    return selectedKeys.slice();
  }
  if (selectedKeys.length) {
    return [selectedKeys[0]];
  }
  return selectedKeys;
}
function parseCheckedKeys(keys4) {
  if (!keys4) {
    return null;
  }
  var keyProps;
  if (Array.isArray(keys4)) {
    keyProps = {
      checkedKeys: keys4,
      halfCheckedKeys: void 0
    };
  } else if (_typeof(keys4) === "object") {
    keyProps = {
      checkedKeys: keys4.checked || void 0,
      halfCheckedKeys: keys4.halfChecked || void 0
    };
  } else {
    warning_default(false, "`checkedKeys` is not an array or an object");
    return null;
  }
  return keyProps;
}
function conductExpandParent(keyList, keyEntities) {
  var expandedKeys = /* @__PURE__ */ new Set();
  function conductUp(key2) {
    if (expandedKeys.has(key2)) return;
    var entity = getEntity(keyEntities, key2);
    if (!entity) return;
    expandedKeys.add(key2);
    var parent2 = entity.parent, node2 = entity.node;
    if (node2.disabled) return;
    if (parent2) {
      conductUp(parent2.key);
    }
  }
  (keyList || []).forEach(function(key2) {
    conductUp(key2);
  });
  return _toConsumableArray(expandedKeys);
}

// ../../node_modules/antd/es/_util/hooks/useMultipleSelect.js
var import_react143 = __toESM(require_react());
function useMultipleSelect(getKey5) {
  const [prevSelectedIndex, setPrevSelectedIndex] = (0, import_react143.useState)(null);
  const multipleSelect = (0, import_react143.useCallback)((currentSelectedIndex, data2, selectedKeys) => {
    const configPrevSelectedIndex = prevSelectedIndex !== null && prevSelectedIndex !== void 0 ? prevSelectedIndex : currentSelectedIndex;
    const startIndex = Math.min(configPrevSelectedIndex || 0, currentSelectedIndex);
    const endIndex = Math.max(configPrevSelectedIndex || 0, currentSelectedIndex);
    const rangeKeys = data2.slice(startIndex, endIndex + 1).map((item) => getKey5(item));
    const shouldSelected = rangeKeys.some((rangeKey) => !selectedKeys.has(rangeKey));
    const changedKeys = [];
    rangeKeys.forEach((item) => {
      if (shouldSelected) {
        if (!selectedKeys.has(item)) {
          changedKeys.push(item);
        }
        selectedKeys.add(item);
      } else {
        selectedKeys.delete(item);
        changedKeys.push(item);
      }
    });
    setPrevSelectedIndex(shouldSelected ? endIndex : null);
    return changedKeys;
  }, [prevSelectedIndex]);
  const updatePrevSelectedIndex = (val) => {
    setPrevSelectedIndex(val);
  };
  return [multipleSelect, updatePrevSelectedIndex];
}

// ../../node_modules/antd/es/table/hooks/useSelection.js
var SELECTION_COLUMN = {};
var SELECTION_ALL = "SELECT_ALL";
var SELECTION_INVERT = "SELECT_INVERT";
var SELECTION_NONE = "SELECT_NONE";
var EMPTY_LIST5 = [];
var flattenData = (childrenColumnName, data2, list = []) => {
  (data2 || []).forEach((record) => {
    list.push(record);
    if (record && typeof record === "object" && childrenColumnName in record) {
      flattenData(childrenColumnName, record[childrenColumnName], list);
    }
  });
  return list;
};
var useSelection = (config, rowSelection) => {
  const {
    preserveSelectedRowKeys,
    selectedRowKeys,
    defaultSelectedRowKeys,
    getCheckboxProps,
    getTitleCheckboxProps,
    onChange: onSelectionChange,
    onSelect,
    onSelectAll,
    onSelectInvert,
    onSelectNone,
    onSelectMultiple,
    columnWidth: selectionColWidth,
    type: selectionType,
    selections,
    fixed,
    renderCell: customizeRenderCell,
    hideSelectAll,
    checkStrictly = true
  } = rowSelection || {};
  const {
    prefixCls,
    data: data2,
    pageData,
    getRecordByKey,
    getRowKey,
    expandType,
    childrenColumnName,
    locale: tableLocale,
    getPopupContainer
  } = config;
  const warning6 = devUseWarning("Table");
  const [multipleSelect, updatePrevSelectedIndex] = useMultipleSelect((item) => item);
  const [mergedSelectedKeys, setMergedSelectedKeys] = useMergedState(selectedRowKeys || defaultSelectedRowKeys || EMPTY_LIST5, {
    value: selectedRowKeys
  });
  const preserveRecordsRef = React461.useRef(/* @__PURE__ */ new Map());
  const updatePreserveRecordsCache = (0, import_react144.useCallback)((keys4) => {
    if (preserveSelectedRowKeys) {
      const newCache = /* @__PURE__ */ new Map();
      keys4.forEach((key2) => {
        let record = getRecordByKey(key2);
        if (!record && preserveRecordsRef.current.has(key2)) {
          record = preserveRecordsRef.current.get(key2);
        }
        newCache.set(key2, record);
      });
      preserveRecordsRef.current = newCache;
    }
  }, [getRecordByKey, preserveSelectedRowKeys]);
  React461.useEffect(() => {
    updatePreserveRecordsCache(mergedSelectedKeys);
  }, [mergedSelectedKeys]);
  const flattedData = (0, import_react144.useMemo)(() => flattenData(childrenColumnName, pageData), [childrenColumnName, pageData]);
  const {
    keyEntities
  } = (0, import_react144.useMemo)(() => {
    if (checkStrictly) {
      return {
        keyEntities: null
      };
    }
    let convertData = data2;
    if (preserveSelectedRowKeys) {
      const keysSet = new Set(flattedData.map((record, index3) => getRowKey(record, index3)));
      const preserveRecords = Array.from(preserveRecordsRef.current).reduce((total, [key2, value]) => keysSet.has(key2) ? total : total.concat(value), []);
      convertData = [].concat(_toConsumableArray(convertData), _toConsumableArray(preserveRecords));
    }
    return convertDataToEntities(convertData, {
      externalGetKey: getRowKey,
      childrenPropName: childrenColumnName
    });
  }, [data2, getRowKey, checkStrictly, childrenColumnName, preserveSelectedRowKeys, flattedData]);
  const checkboxPropsMap = (0, import_react144.useMemo)(() => {
    const map = /* @__PURE__ */ new Map();
    flattedData.forEach((record, index3) => {
      const key2 = getRowKey(record, index3);
      const checkboxProps = (getCheckboxProps ? getCheckboxProps(record) : null) || {};
      map.set(key2, checkboxProps);
      true ? warning6(!("checked" in checkboxProps || "defaultChecked" in checkboxProps), "usage", "Do not set `checked` or `defaultChecked` in `getCheckboxProps`. Please use `selectedRowKeys` instead.") : void 0;
    });
    return map;
  }, [flattedData, getRowKey, getCheckboxProps]);
  const isCheckboxDisabled = (0, import_react144.useCallback)((r2) => {
    const rowKey = getRowKey(r2);
    let checkboxProps;
    if (checkboxPropsMap.has(rowKey)) {
      checkboxProps = checkboxPropsMap.get(getRowKey(r2));
    } else {
      checkboxProps = getCheckboxProps ? getCheckboxProps(r2) : void 0;
    }
    return !!(checkboxProps === null || checkboxProps === void 0 ? void 0 : checkboxProps.disabled);
  }, [checkboxPropsMap, getRowKey]);
  const [derivedSelectedKeys, derivedHalfSelectedKeys] = (0, import_react144.useMemo)(() => {
    if (checkStrictly) {
      return [mergedSelectedKeys || [], []];
    }
    const {
      checkedKeys,
      halfCheckedKeys
    } = conductCheck(mergedSelectedKeys, true, keyEntities, isCheckboxDisabled);
    return [checkedKeys || [], halfCheckedKeys];
  }, [mergedSelectedKeys, checkStrictly, keyEntities, isCheckboxDisabled]);
  const derivedSelectedKeySet = (0, import_react144.useMemo)(() => {
    const keys4 = selectionType === "radio" ? derivedSelectedKeys.slice(0, 1) : derivedSelectedKeys;
    return new Set(keys4);
  }, [derivedSelectedKeys, selectionType]);
  const derivedHalfSelectedKeySet = (0, import_react144.useMemo)(() => selectionType === "radio" ? /* @__PURE__ */ new Set() : new Set(derivedHalfSelectedKeys), [derivedHalfSelectedKeys, selectionType]);
  React461.useEffect(() => {
    if (!rowSelection) {
      setMergedSelectedKeys(EMPTY_LIST5);
    }
  }, [!!rowSelection]);
  const setSelectedKeys = (0, import_react144.useCallback)((keys4, method4) => {
    let availableKeys;
    let records;
    updatePreserveRecordsCache(keys4);
    if (preserveSelectedRowKeys) {
      availableKeys = keys4;
      records = keys4.map((key2) => preserveRecordsRef.current.get(key2));
    } else {
      availableKeys = [];
      records = [];
      keys4.forEach((key2) => {
        const record = getRecordByKey(key2);
        if (record !== void 0) {
          availableKeys.push(key2);
          records.push(record);
        }
      });
    }
    setMergedSelectedKeys(availableKeys);
    onSelectionChange === null || onSelectionChange === void 0 ? void 0 : onSelectionChange(availableKeys, records, {
      type: method4
    });
  }, [setMergedSelectedKeys, getRecordByKey, onSelectionChange, preserveSelectedRowKeys]);
  const triggerSingleSelection = (0, import_react144.useCallback)((key2, selected, keys4, event) => {
    if (onSelect) {
      const rows = keys4.map((k) => getRecordByKey(k));
      onSelect(getRecordByKey(key2), selected, rows, event);
    }
    setSelectedKeys(keys4, "single");
  }, [onSelect, getRecordByKey, setSelectedKeys]);
  const mergedSelections = (0, import_react144.useMemo)(() => {
    if (!selections || hideSelectAll) {
      return null;
    }
    const selectionList = selections === true ? [SELECTION_ALL, SELECTION_INVERT, SELECTION_NONE] : selections;
    return selectionList.map((selection) => {
      if (selection === SELECTION_ALL) {
        return {
          key: "all",
          text: tableLocale.selectionAll,
          onSelect() {
            setSelectedKeys(data2.map((record, index3) => getRowKey(record, index3)).filter((key2) => {
              const checkProps2 = checkboxPropsMap.get(key2);
              return !(checkProps2 === null || checkProps2 === void 0 ? void 0 : checkProps2.disabled) || derivedSelectedKeySet.has(key2);
            }), "all");
          }
        };
      }
      if (selection === SELECTION_INVERT) {
        return {
          key: "invert",
          text: tableLocale.selectInvert,
          onSelect() {
            const keySet = new Set(derivedSelectedKeySet);
            pageData.forEach((record, index3) => {
              const key2 = getRowKey(record, index3);
              const checkProps2 = checkboxPropsMap.get(key2);
              if (!(checkProps2 === null || checkProps2 === void 0 ? void 0 : checkProps2.disabled)) {
                if (keySet.has(key2)) {
                  keySet.delete(key2);
                } else {
                  keySet.add(key2);
                }
              }
            });
            const keys4 = Array.from(keySet);
            if (onSelectInvert) {
              warning6.deprecated(false, "onSelectInvert", "onChange");
              onSelectInvert(keys4);
            }
            setSelectedKeys(keys4, "invert");
          }
        };
      }
      if (selection === SELECTION_NONE) {
        return {
          key: "none",
          text: tableLocale.selectNone,
          onSelect() {
            onSelectNone === null || onSelectNone === void 0 ? void 0 : onSelectNone();
            setSelectedKeys(Array.from(derivedSelectedKeySet).filter((key2) => {
              const checkProps2 = checkboxPropsMap.get(key2);
              return checkProps2 === null || checkProps2 === void 0 ? void 0 : checkProps2.disabled;
            }), "none");
          }
        };
      }
      return selection;
    }).map((selection) => Object.assign(Object.assign({}, selection), {
      onSelect: (...rest) => {
        var _a2;
        var _a;
        (_a = selection.onSelect) === null || _a === void 0 ? void 0 : (_a2 = _a).call.apply(_a2, [selection].concat(rest));
        updatePrevSelectedIndex(null);
      }
    }));
  }, [selections, derivedSelectedKeySet, pageData, getRowKey, onSelectInvert, setSelectedKeys]);
  const transformColumns = (0, import_react144.useCallback)((columns) => {
    var _a;
    if (!rowSelection) {
      true ? warning6(!columns.includes(SELECTION_COLUMN), "usage", "`rowSelection` is not config but `SELECTION_COLUMN` exists in the `columns`.") : void 0;
      return columns.filter((col) => col !== SELECTION_COLUMN);
    }
    let cloneColumns = _toConsumableArray(columns);
    const keySet = new Set(derivedSelectedKeySet);
    const recordKeys = flattedData.map(getRowKey).filter((key2) => !checkboxPropsMap.get(key2).disabled);
    const checkedCurrentAll = recordKeys.every((key2) => keySet.has(key2));
    const checkedCurrentSome = recordKeys.some((key2) => keySet.has(key2));
    const onSelectAllChange = () => {
      const changeKeys = [];
      if (checkedCurrentAll) {
        recordKeys.forEach((key2) => {
          keySet.delete(key2);
          changeKeys.push(key2);
        });
      } else {
        recordKeys.forEach((key2) => {
          if (!keySet.has(key2)) {
            keySet.add(key2);
            changeKeys.push(key2);
          }
        });
      }
      const keys4 = Array.from(keySet);
      onSelectAll === null || onSelectAll === void 0 ? void 0 : onSelectAll(!checkedCurrentAll, keys4.map((k) => getRecordByKey(k)), changeKeys.map((k) => getRecordByKey(k)));
      setSelectedKeys(keys4, "all");
      updatePrevSelectedIndex(null);
    };
    let title;
    let columnTitleCheckbox;
    if (selectionType !== "radio") {
      let customizeSelections;
      if (mergedSelections) {
        const menu = {
          getPopupContainer,
          items: mergedSelections.map((selection, index3) => {
            const {
              key: key2,
              text,
              onSelect: onSelectionClick
            } = selection;
            return {
              key: key2 !== null && key2 !== void 0 ? key2 : index3,
              onClick: () => {
                onSelectionClick === null || onSelectionClick === void 0 ? void 0 : onSelectionClick(recordKeys);
              },
              label: text
            };
          })
        };
        customizeSelections = /* @__PURE__ */ React461.createElement("div", {
          className: `${prefixCls}-selection-extra`
        }, /* @__PURE__ */ React461.createElement(dropdown_default3, {
          menu,
          getPopupContainer
        }, /* @__PURE__ */ React461.createElement("span", null, /* @__PURE__ */ React461.createElement(DownOutlined_default2, null))));
      }
      const allDisabledData = flattedData.map((record, index3) => {
        const key2 = getRowKey(record, index3);
        const checkboxProps = checkboxPropsMap.get(key2) || {};
        return Object.assign({
          checked: keySet.has(key2)
        }, checkboxProps);
      }).filter(({
        disabled: disabled2
      }) => disabled2);
      const allDisabled = !!allDisabledData.length && allDisabledData.length === flattedData.length;
      const allDisabledAndChecked = allDisabled && allDisabledData.every(({
        checked
      }) => checked);
      const allDisabledSomeChecked = allDisabled && allDisabledData.some(({
        checked
      }) => checked);
      const customCheckboxProps = (getTitleCheckboxProps === null || getTitleCheckboxProps === void 0 ? void 0 : getTitleCheckboxProps()) || {};
      const {
        onChange,
        disabled
      } = customCheckboxProps;
      columnTitleCheckbox = /* @__PURE__ */ React461.createElement(checkbox_default, Object.assign({
        "aria-label": customizeSelections ? "Custom selection" : "Select all"
      }, customCheckboxProps, {
        checked: !allDisabled ? !!flattedData.length && checkedCurrentAll : allDisabledAndChecked,
        indeterminate: !allDisabled ? !checkedCurrentAll && checkedCurrentSome : !allDisabledAndChecked && allDisabledSomeChecked,
        onChange: (e3) => {
          onSelectAllChange();
          onChange === null || onChange === void 0 ? void 0 : onChange(e3);
        },
        disabled: disabled !== null && disabled !== void 0 ? disabled : flattedData.length === 0 || allDisabled,
        skipGroup: true
      }));
      title = !hideSelectAll && /* @__PURE__ */ React461.createElement("div", {
        className: `${prefixCls}-selection`
      }, columnTitleCheckbox, customizeSelections);
    }
    let renderCell;
    if (selectionType === "radio") {
      renderCell = (_, record, index3) => {
        const key2 = getRowKey(record, index3);
        const checked = keySet.has(key2);
        const checkboxProps = checkboxPropsMap.get(key2);
        return {
          node: /* @__PURE__ */ React461.createElement(radio_default2, Object.assign({}, checkboxProps, {
            checked,
            onClick: (e3) => {
              var _a2;
              e3.stopPropagation();
              (_a2 = checkboxProps === null || checkboxProps === void 0 ? void 0 : checkboxProps.onClick) === null || _a2 === void 0 ? void 0 : _a2.call(checkboxProps, e3);
            },
            onChange: (event) => {
              var _a2;
              if (!keySet.has(key2)) {
                triggerSingleSelection(key2, true, [key2], event.nativeEvent);
              }
              (_a2 = checkboxProps === null || checkboxProps === void 0 ? void 0 : checkboxProps.onChange) === null || _a2 === void 0 ? void 0 : _a2.call(checkboxProps, event);
            }
          })),
          checked
        };
      };
    } else {
      renderCell = (_, record, index3) => {
        var _a2;
        const key2 = getRowKey(record, index3);
        const checked = keySet.has(key2);
        const indeterminate = derivedHalfSelectedKeySet.has(key2);
        const checkboxProps = checkboxPropsMap.get(key2);
        let mergedIndeterminate;
        if (expandType === "nest") {
          mergedIndeterminate = indeterminate;
          true ? warning6(typeof (checkboxProps === null || checkboxProps === void 0 ? void 0 : checkboxProps.indeterminate) !== "boolean", "usage", "set `indeterminate` using `rowSelection.getCheckboxProps` is not allowed with tree structured dataSource.") : void 0;
        } else {
          mergedIndeterminate = (_a2 = checkboxProps === null || checkboxProps === void 0 ? void 0 : checkboxProps.indeterminate) !== null && _a2 !== void 0 ? _a2 : indeterminate;
        }
        return {
          node: /* @__PURE__ */ React461.createElement(checkbox_default, Object.assign({}, checkboxProps, {
            indeterminate: mergedIndeterminate,
            checked,
            skipGroup: true,
            onClick: (e3) => {
              var _a3;
              e3.stopPropagation();
              (_a3 = checkboxProps === null || checkboxProps === void 0 ? void 0 : checkboxProps.onClick) === null || _a3 === void 0 ? void 0 : _a3.call(checkboxProps, e3);
            },
            onChange: (event) => {
              var _a3;
              const {
                nativeEvent
              } = event;
              const {
                shiftKey
              } = nativeEvent;
              const currentSelectedIndex = recordKeys.findIndex((item) => item === key2);
              const isMultiple3 = derivedSelectedKeys.some((item) => recordKeys.includes(item));
              if (shiftKey && checkStrictly && isMultiple3) {
                const changedKeys = multipleSelect(currentSelectedIndex, recordKeys, keySet);
                const keys4 = Array.from(keySet);
                onSelectMultiple === null || onSelectMultiple === void 0 ? void 0 : onSelectMultiple(!checked, keys4.map((recordKey) => getRecordByKey(recordKey)), changedKeys.map((recordKey) => getRecordByKey(recordKey)));
                setSelectedKeys(keys4, "multiple");
              } else {
                const originCheckedKeys = derivedSelectedKeys;
                if (checkStrictly) {
                  const checkedKeys = checked ? arrDel(originCheckedKeys, key2) : arrAdd(originCheckedKeys, key2);
                  triggerSingleSelection(key2, !checked, checkedKeys, nativeEvent);
                } else {
                  const result = conductCheck([].concat(_toConsumableArray(originCheckedKeys), [key2]), true, keyEntities, isCheckboxDisabled);
                  const {
                    checkedKeys,
                    halfCheckedKeys
                  } = result;
                  let nextCheckedKeys = checkedKeys;
                  if (checked) {
                    const tempKeySet = new Set(checkedKeys);
                    tempKeySet.delete(key2);
                    nextCheckedKeys = conductCheck(Array.from(tempKeySet), {
                      checked: false,
                      halfCheckedKeys
                    }, keyEntities, isCheckboxDisabled).checkedKeys;
                  }
                  triggerSingleSelection(key2, !checked, nextCheckedKeys, nativeEvent);
                }
              }
              if (checked) {
                updatePrevSelectedIndex(null);
              } else {
                updatePrevSelectedIndex(currentSelectedIndex);
              }
              (_a3 = checkboxProps === null || checkboxProps === void 0 ? void 0 : checkboxProps.onChange) === null || _a3 === void 0 ? void 0 : _a3.call(checkboxProps, event);
            }
          })),
          checked
        };
      };
    }
    const renderSelectionCell = (_, record, index3) => {
      const {
        node: node2,
        checked
      } = renderCell(_, record, index3);
      if (customizeRenderCell) {
        return customizeRenderCell(checked, record, index3, node2);
      }
      return node2;
    };
    if (!cloneColumns.includes(SELECTION_COLUMN)) {
      if (cloneColumns.findIndex((col) => {
        var _a2;
        return ((_a2 = col[INTERNAL_COL_DEFINE]) === null || _a2 === void 0 ? void 0 : _a2.columnType) === "EXPAND_COLUMN";
      }) === 0) {
        const [expandColumn, ...restColumns] = cloneColumns;
        cloneColumns = [expandColumn, SELECTION_COLUMN].concat(_toConsumableArray(restColumns));
      } else {
        cloneColumns = [SELECTION_COLUMN].concat(_toConsumableArray(cloneColumns));
      }
    }
    const selectionColumnIndex = cloneColumns.indexOf(SELECTION_COLUMN);
    true ? warning6(cloneColumns.filter((col) => col === SELECTION_COLUMN).length <= 1, "usage", "Multiple `SELECTION_COLUMN` exist in `columns`.") : void 0;
    cloneColumns = cloneColumns.filter((column2, index3) => column2 !== SELECTION_COLUMN || index3 === selectionColumnIndex);
    const prevCol = cloneColumns[selectionColumnIndex - 1];
    const nextCol = cloneColumns[selectionColumnIndex + 1];
    let mergedFixed = fixed;
    if (mergedFixed === void 0) {
      if ((nextCol === null || nextCol === void 0 ? void 0 : nextCol.fixed) !== void 0) {
        mergedFixed = nextCol.fixed;
      } else if ((prevCol === null || prevCol === void 0 ? void 0 : prevCol.fixed) !== void 0) {
        mergedFixed = prevCol.fixed;
      }
    }
    if (mergedFixed && prevCol && ((_a = prevCol[INTERNAL_COL_DEFINE]) === null || _a === void 0 ? void 0 : _a.columnType) === "EXPAND_COLUMN" && prevCol.fixed === void 0) {
      prevCol.fixed = mergedFixed;
    }
    const columnCls = (0, import_classnames187.default)(`${prefixCls}-selection-col`, {
      [`${prefixCls}-selection-col-with-dropdown`]: selections && selectionType === "checkbox"
    });
    const renderColumnTitle2 = () => {
      if (!(rowSelection === null || rowSelection === void 0 ? void 0 : rowSelection.columnTitle)) {
        return title;
      }
      if (typeof rowSelection.columnTitle === "function") {
        return rowSelection.columnTitle(columnTitleCheckbox);
      }
      return rowSelection.columnTitle;
    };
    const selectionColumn = {
      fixed: mergedFixed,
      width: selectionColWidth,
      className: `${prefixCls}-selection-column`,
      title: renderColumnTitle2(),
      render: renderSelectionCell,
      onCell: rowSelection.onCell,
      align: rowSelection.align,
      [INTERNAL_COL_DEFINE]: {
        className: columnCls
      }
    };
    return cloneColumns.map((col) => col === SELECTION_COLUMN ? selectionColumn : col);
  }, [getRowKey, flattedData, rowSelection, derivedSelectedKeys, derivedSelectedKeySet, derivedHalfSelectedKeySet, selectionColWidth, mergedSelections, expandType, checkboxPropsMap, onSelectMultiple, triggerSingleSelection, isCheckboxDisabled]);
  return [transformColumns, derivedSelectedKeySet];
};
var useSelection_default = useSelection;

// ../../node_modules/antd/es/table/InternalTable.js
var React490 = __toESM(require_react());
var import_classnames196 = __toESM(require_classnames());

// ../../node_modules/antd/es/_util/hooks/useProxyImperativeHandle.js
var import_react145 = __toESM(require_react());
function fillProxy(element, handler) {
  element._antProxy = element._antProxy || {};
  Object.keys(handler).forEach((key2) => {
    if (!(key2 in element._antProxy)) {
      const ori = element[key2];
      element._antProxy[key2] = ori;
      element[key2] = handler[key2];
    }
  });
  return element;
}
function useProxyImperativeHandle(ref3, init2) {
  return (0, import_react145.useImperativeHandle)(ref3, () => {
    const refObj = init2();
    const {
      nativeElement
    } = refObj;
    if (typeof Proxy !== "undefined") {
      return new Proxy(nativeElement, {
        get(obj, prop) {
          if (refObj[prop]) {
            return refObj[prop];
          }
          return Reflect.get(obj, prop);
        }
      });
    }
    return fillProxy(nativeElement, refObj);
  });
}

// ../../node_modules/antd/es/table/ExpandIcon.js
var React462 = __toESM(require_react());
var import_classnames188 = __toESM(require_classnames());
function renderExpandIcon2(locale6) {
  return (props) => {
    const {
      prefixCls,
      onExpand,
      record,
      expanded,
      expandable
    } = props;
    const iconPrefix = `${prefixCls}-row-expand-icon`;
    return /* @__PURE__ */ React462.createElement("button", {
      type: "button",
      onClick: (e3) => {
        onExpand(record, e3);
        e3.stopPropagation();
      },
      className: (0, import_classnames188.default)(iconPrefix, {
        [`${iconPrefix}-spaced`]: !expandable,
        [`${iconPrefix}-expanded`]: expandable && expanded,
        [`${iconPrefix}-collapsed`]: expandable && !expanded
      }),
      "aria-label": expanded ? locale6.collapse : locale6.expand,
      "aria-expanded": expanded
    });
  };
}
var ExpandIcon_default = renderExpandIcon2;

// ../../node_modules/antd/es/table/hooks/useContainerWidth.js
function useContainerWidth(prefixCls) {
  const getContainerWidth = (ele, width) => {
    const container = ele.querySelector(`.${prefixCls}-container`);
    let returnWidth = width;
    if (container) {
      const style2 = getComputedStyle(container);
      const borderLeft = parseInt(style2.borderLeftWidth, 10);
      const borderRight = parseInt(style2.borderRightWidth, 10);
      returnWidth = width - borderLeft - borderRight;
    }
    return returnWidth;
  };
  return getContainerWidth;
}

// ../../node_modules/antd/es/table/hooks/useFilter/index.js
var React484 = __toESM(require_react());

// ../../node_modules/antd/es/table/util.js
var getColumnKey = (column2, defaultKey) => {
  if ("key" in column2 && column2.key !== void 0 && column2.key !== null) {
    return column2.key;
  }
  if (column2.dataIndex) {
    return Array.isArray(column2.dataIndex) ? column2.dataIndex.join(".") : column2.dataIndex;
  }
  return defaultKey;
};
function getColumnPos(index3, pos) {
  return pos ? `${pos}-${index3}` : `${index3}`;
}
var renderColumnTitle = (title, props) => {
  if (typeof title === "function") {
    return title(props);
  }
  return title;
};
var safeColumnTitle = (title, props) => {
  const res = renderColumnTitle(title, props);
  if (Object.prototype.toString.call(res) === "[object Object]") {
    return "";
  }
  return res;
};

// ../../node_modules/antd/es/table/hooks/useFilter/FilterDropdown.js
var React483 = __toESM(require_react());

// ../../node_modules/@ant-design/icons/es/icons/FilterFilled.js
var React463 = __toESM(require_react());

// ../../node_modules/@ant-design/icons-svg/es/asn/FilterFilled.js
var FilterFilled = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M349 838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V642H349v196zm531.1-684H143.9c-24.5 0-39.8 26.7-27.5 48l221.3 376h348.8l221.3-376c12.1-21.3-3.2-48-27.7-48z" } }] }, "name": "filter", "theme": "filled" };
var FilterFilled_default = FilterFilled;

// ../../node_modules/@ant-design/icons/es/icons/FilterFilled.js
var FilterFilled2 = function FilterFilled3(props, ref3) {
  return /* @__PURE__ */ React463.createElement(AntdIcon_default, _extends({}, props, {
    ref: ref3,
    icon: FilterFilled_default
  }));
};
var RefIcon31 = /* @__PURE__ */ React463.forwardRef(FilterFilled2);
if (true) {
  RefIcon31.displayName = "FilterFilled";
}
var FilterFilled_default2 = RefIcon31;

// ../../node_modules/antd/es/table/hooks/useFilter/FilterDropdown.js
var import_classnames194 = __toESM(require_classnames());

// ../../node_modules/antd/es/_util/hooks/useSyncState.js
var React464 = __toESM(require_react());
function useSyncState4(initialValue) {
  const ref3 = React464.useRef(initialValue);
  const forceUpdate = useForceUpdate();
  return [() => ref3.current, (newValue) => {
    ref3.current = newValue;
    forceUpdate();
  }];
}

// ../../node_modules/rc-tree/es/Tree.js
var import_classnames190 = __toESM(require_classnames());
var React469 = __toESM(require_react());

// ../../node_modules/rc-tree/es/DropIndicator.js
var import_react146 = __toESM(require_react());
var DropIndicator = function DropIndicator2(props) {
  var dropPosition = props.dropPosition, dropLevelOffset = props.dropLevelOffset, indent = props.indent;
  var style2 = {
    pointerEvents: "none",
    position: "absolute",
    right: 0,
    backgroundColor: "red",
    height: 2
  };
  switch (dropPosition) {
    case -1:
      style2.top = 0;
      style2.left = -dropLevelOffset * indent;
      break;
    case 1:
      style2.bottom = 0;
      style2.left = -dropLevelOffset * indent;
      break;
    case 0:
      style2.bottom = 0;
      style2.left = indent;
      break;
  }
  return /* @__PURE__ */ import_react146.default.createElement("div", {
    style: style2
  });
};
if (true) {
  DropIndicator.displayName = "DropIndicator";
}
var DropIndicator_default = DropIndicator;

// ../../node_modules/@babel/runtime/helpers/esm/objectDestructuringEmpty.js
function _objectDestructuringEmpty(t2) {
  if (null == t2) throw new TypeError("Cannot destructure " + t2);
}

// ../../node_modules/rc-tree/es/NodeList.js
var React468 = __toESM(require_react());

// ../../node_modules/rc-tree/es/MotionTreeNode.js
var import_classnames189 = __toESM(require_classnames());
var React467 = __toESM(require_react());

// ../../node_modules/rc-tree/es/useUnmount.js
var React466 = __toESM(require_react());
function useUnmount(triggerStart, triggerEnd) {
  var _React$useState = React466.useState(false), _React$useState2 = _slicedToArray(_React$useState, 2), firstMount = _React$useState2[0], setFirstMount = _React$useState2[1];
  useLayoutEffect_default(function() {
    if (firstMount) {
      triggerStart();
      return function() {
        triggerEnd();
      };
    }
  }, [firstMount]);
  useLayoutEffect_default(function() {
    setFirstMount(true);
    return function() {
      setFirstMount(false);
    };
  }, []);
}
var useUnmount_default = useUnmount;

// ../../node_modules/rc-tree/es/MotionTreeNode.js
var _excluded71 = ["className", "style", "motion", "motionNodes", "motionType", "onMotionStart", "onMotionEnd", "active", "treeNodeRequiredProps"];
var MotionTreeNode = /* @__PURE__ */ React467.forwardRef(function(oriProps, ref3) {
  var className2 = oriProps.className, style2 = oriProps.style, motion2 = oriProps.motion, motionNodes = oriProps.motionNodes, motionType = oriProps.motionType, onOriginMotionStart = oriProps.onMotionStart, onOriginMotionEnd = oriProps.onMotionEnd, active = oriProps.active, treeNodeRequiredProps = oriProps.treeNodeRequiredProps, props = _objectWithoutProperties(oriProps, _excluded71);
  var _React$useState = React467.useState(true), _React$useState2 = _slicedToArray(_React$useState, 2), visible = _React$useState2[0], setVisible = _React$useState2[1];
  var _React$useContext = React467.useContext(TreeContext), prefixCls = _React$useContext.prefixCls;
  var targetVisible = motionNodes && motionType !== "hide";
  useLayoutEffect_default(function() {
    if (motionNodes) {
      if (targetVisible !== visible) {
        setVisible(targetVisible);
      }
    }
  }, [motionNodes]);
  var triggerMotionStart = function triggerMotionStart2() {
    if (motionNodes) {
      onOriginMotionStart();
    }
  };
  var triggerMotionEndRef = React467.useRef(false);
  var triggerMotionEnd = function triggerMotionEnd2() {
    if (motionNodes && !triggerMotionEndRef.current) {
      triggerMotionEndRef.current = true;
      onOriginMotionEnd();
    }
  };
  useUnmount_default(triggerMotionStart, triggerMotionEnd);
  var onVisibleChanged = function onVisibleChanged2(nextVisible) {
    if (targetVisible === nextVisible) {
      triggerMotionEnd();
    }
  };
  if (motionNodes) {
    return /* @__PURE__ */ React467.createElement(es_default2, _extends({
      ref: ref3,
      visible
    }, motion2, {
      motionAppear: motionType === "show",
      onVisibleChanged
    }), function(_ref, motionRef) {
      var motionClassName = _ref.className, motionStyle = _ref.style;
      return /* @__PURE__ */ React467.createElement("div", {
        ref: motionRef,
        className: (0, import_classnames189.default)("".concat(prefixCls, "-treenode-motion"), motionClassName),
        style: motionStyle
      }, motionNodes.map(function(treeNode) {
        var restProps = Object.assign({}, (_objectDestructuringEmpty(treeNode.data), treeNode.data)), title = treeNode.title, key2 = treeNode.key, isStart = treeNode.isStart, isEnd = treeNode.isEnd;
        delete restProps.children;
        var treeNodeProps = getTreeNodeProps(key2, treeNodeRequiredProps);
        return /* @__PURE__ */ React467.createElement(TreeNode_default, _extends({}, restProps, treeNodeProps, {
          title,
          active,
          data: treeNode.data,
          key: key2,
          isStart,
          isEnd
        }));
      }));
    });
  }
  return /* @__PURE__ */ React467.createElement(TreeNode_default, _extends({
    domRef: ref3,
    className: className2,
    style: style2
  }, props, {
    active
  }));
});
if (true) {
  MotionTreeNode.displayName = "MotionTreeNode";
}
var MotionTreeNode_default = MotionTreeNode;

// ../../node_modules/rc-tree/es/utils/diffUtil.js
function findExpandedKeys() {
  var prev2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  var next2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  var prevLen = prev2.length;
  var nextLen = next2.length;
  if (Math.abs(prevLen - nextLen) !== 1) {
    return {
      add: false,
      key: null
    };
  }
  function find3(shorter, longer) {
    var cache = /* @__PURE__ */ new Map();
    shorter.forEach(function(key2) {
      cache.set(key2, true);
    });
    var keys4 = longer.filter(function(key2) {
      return !cache.has(key2);
    });
    return keys4.length === 1 ? keys4[0] : null;
  }
  if (prevLen < nextLen) {
    return {
      add: true,
      key: find3(prev2, next2)
    };
  }
  return {
    add: false,
    key: find3(next2, prev2)
  };
}
function getExpandRange(shorter, longer, key2) {
  var shorterStartIndex = shorter.findIndex(function(data2) {
    return data2.key === key2;
  });
  var shorterEndNode = shorter[shorterStartIndex + 1];
  var longerStartIndex = longer.findIndex(function(data2) {
    return data2.key === key2;
  });
  if (shorterEndNode) {
    var longerEndIndex = longer.findIndex(function(data2) {
      return data2.key === shorterEndNode.key;
    });
    return longer.slice(longerStartIndex + 1, longerEndIndex);
  }
  return longer.slice(longerStartIndex + 1);
}

// ../../node_modules/rc-tree/es/NodeList.js
var _excluded72 = ["prefixCls", "data", "selectable", "checkable", "expandedKeys", "selectedKeys", "checkedKeys", "loadedKeys", "loadingKeys", "halfCheckedKeys", "keyEntities", "disabled", "dragging", "dragOverNodeKey", "dropPosition", "motion", "height", "itemHeight", "virtual", "scrollWidth", "focusable", "activeItem", "focused", "tabIndex", "onKeyDown", "onFocus", "onBlur", "onActiveChange", "onListChangeStart", "onListChangeEnd"];
var HIDDEN_STYLE2 = {
  width: 0,
  height: 0,
  display: "flex",
  overflow: "hidden",
  opacity: 0,
  border: 0,
  padding: 0,
  margin: 0
};
var noop5 = function noop6() {
};
var MOTION_KEY = "RC_TREE_MOTION_".concat(Math.random());
var MotionNode = {
  key: MOTION_KEY
};
var MotionEntity = {
  key: MOTION_KEY,
  level: 0,
  index: 0,
  pos: "0",
  node: MotionNode,
  nodes: [MotionNode]
};
var MotionFlattenData = {
  parent: null,
  children: [],
  pos: MotionEntity.pos,
  data: MotionNode,
  title: null,
  key: MOTION_KEY,
  /** Hold empty list here since we do not use it */
  isStart: [],
  isEnd: []
};
function getMinimumRangeTransitionRange(list, virtual, height, itemHeight) {
  if (virtual === false || !height) {
    return list;
  }
  return list.slice(0, Math.ceil(height / itemHeight) + 1);
}
function itemKey2(item) {
  var key2 = item.key, pos = item.pos;
  return getKey3(key2, pos);
}
function getAccessibilityPath(item) {
  var path2 = String(item.data.key);
  var current2 = item;
  while (current2.parent) {
    current2 = current2.parent;
    path2 = "".concat(current2.data.key, " > ").concat(path2);
  }
  return path2;
}
var NodeList = /* @__PURE__ */ React468.forwardRef(function(props, ref3) {
  var prefixCls = props.prefixCls, data2 = props.data, selectable = props.selectable, checkable = props.checkable, expandedKeys = props.expandedKeys, selectedKeys = props.selectedKeys, checkedKeys = props.checkedKeys, loadedKeys = props.loadedKeys, loadingKeys = props.loadingKeys, halfCheckedKeys = props.halfCheckedKeys, keyEntities = props.keyEntities, disabled = props.disabled, dragging = props.dragging, dragOverNodeKey = props.dragOverNodeKey, dropPosition = props.dropPosition, motion2 = props.motion, height = props.height, itemHeight = props.itemHeight, virtual = props.virtual, scrollWidth = props.scrollWidth, focusable2 = props.focusable, activeItem = props.activeItem, focused = props.focused, tabIndex = props.tabIndex, onKeyDown2 = props.onKeyDown, onFocus = props.onFocus, onBlur = props.onBlur, onActiveChange = props.onActiveChange, onListChangeStart = props.onListChangeStart, onListChangeEnd = props.onListChangeEnd, domProps = _objectWithoutProperties(props, _excluded72);
  var listRef = React468.useRef(null);
  var indentMeasurerRef = React468.useRef(null);
  React468.useImperativeHandle(ref3, function() {
    return {
      scrollTo: function scrollTo2(scroll) {
        listRef.current.scrollTo(scroll);
      },
      getIndentWidth: function getIndentWidth() {
        return indentMeasurerRef.current.offsetWidth;
      }
    };
  });
  var _React$useState = React468.useState(expandedKeys), _React$useState2 = _slicedToArray(_React$useState, 2), prevExpandedKeys = _React$useState2[0], setPrevExpandedKeys = _React$useState2[1];
  var _React$useState3 = React468.useState(data2), _React$useState4 = _slicedToArray(_React$useState3, 2), prevData = _React$useState4[0], setPrevData = _React$useState4[1];
  var _React$useState5 = React468.useState(data2), _React$useState6 = _slicedToArray(_React$useState5, 2), transitionData = _React$useState6[0], setTransitionData = _React$useState6[1];
  var _React$useState7 = React468.useState([]), _React$useState8 = _slicedToArray(_React$useState7, 2), transitionRange = _React$useState8[0], setTransitionRange = _React$useState8[1];
  var _React$useState9 = React468.useState(null), _React$useState10 = _slicedToArray(_React$useState9, 2), motionType = _React$useState10[0], setMotionType = _React$useState10[1];
  var dataRef = React468.useRef(data2);
  dataRef.current = data2;
  function onMotionEnd() {
    var latestData = dataRef.current;
    setPrevData(latestData);
    setTransitionData(latestData);
    setTransitionRange([]);
    setMotionType(null);
    onListChangeEnd();
  }
  useLayoutEffect_default(function() {
    setPrevExpandedKeys(expandedKeys);
    var diffExpanded = findExpandedKeys(prevExpandedKeys, expandedKeys);
    if (diffExpanded.key !== null) {
      if (diffExpanded.add) {
        var keyIndex2 = prevData.findIndex(function(_ref) {
          var key2 = _ref.key;
          return key2 === diffExpanded.key;
        });
        var rangeNodes = getMinimumRangeTransitionRange(getExpandRange(prevData, data2, diffExpanded.key), virtual, height, itemHeight);
        var newTransitionData = prevData.slice();
        newTransitionData.splice(keyIndex2 + 1, 0, MotionFlattenData);
        setTransitionData(newTransitionData);
        setTransitionRange(rangeNodes);
        setMotionType("show");
      } else {
        var _keyIndex = data2.findIndex(function(_ref2) {
          var key2 = _ref2.key;
          return key2 === diffExpanded.key;
        });
        var _rangeNodes = getMinimumRangeTransitionRange(getExpandRange(data2, prevData, diffExpanded.key), virtual, height, itemHeight);
        var _newTransitionData = data2.slice();
        _newTransitionData.splice(_keyIndex + 1, 0, MotionFlattenData);
        setTransitionData(_newTransitionData);
        setTransitionRange(_rangeNodes);
        setMotionType("hide");
      }
    } else if (prevData !== data2) {
      setPrevData(data2);
      setTransitionData(data2);
    }
  }, [expandedKeys, data2]);
  React468.useEffect(function() {
    if (!dragging) {
      onMotionEnd();
    }
  }, [dragging]);
  var mergedData = motion2 ? transitionData : data2;
  var treeNodeRequiredProps = {
    expandedKeys,
    selectedKeys,
    loadedKeys,
    loadingKeys,
    checkedKeys,
    halfCheckedKeys,
    dragOverNodeKey,
    dropPosition,
    keyEntities
  };
  return /* @__PURE__ */ React468.createElement(React468.Fragment, null, focused && activeItem && /* @__PURE__ */ React468.createElement("span", {
    style: HIDDEN_STYLE2,
    "aria-live": "assertive"
  }, getAccessibilityPath(activeItem)), /* @__PURE__ */ React468.createElement("div", null, /* @__PURE__ */ React468.createElement("input", {
    style: HIDDEN_STYLE2,
    disabled: focusable2 === false || disabled,
    tabIndex: focusable2 !== false ? tabIndex : null,
    onKeyDown: onKeyDown2,
    onFocus,
    onBlur,
    value: "",
    onChange: noop5,
    "aria-label": "for screen reader"
  })), /* @__PURE__ */ React468.createElement("div", {
    className: "".concat(prefixCls, "-treenode"),
    "aria-hidden": true,
    style: {
      position: "absolute",
      pointerEvents: "none",
      visibility: "hidden",
      height: 0,
      overflow: "hidden",
      border: 0,
      padding: 0
    }
  }, /* @__PURE__ */ React468.createElement("div", {
    className: "".concat(prefixCls, "-indent")
  }, /* @__PURE__ */ React468.createElement("div", {
    ref: indentMeasurerRef,
    className: "".concat(prefixCls, "-indent-unit")
  }))), /* @__PURE__ */ React468.createElement(es_default10, _extends({}, domProps, {
    data: mergedData,
    itemKey: itemKey2,
    height,
    fullHeight: false,
    virtual,
    itemHeight,
    scrollWidth,
    prefixCls: "".concat(prefixCls, "-list"),
    ref: listRef,
    role: "tree",
    onVisibleChange: function onVisibleChange(originList) {
      if (originList.every(function(item) {
        return itemKey2(item) !== MOTION_KEY;
      })) {
        onMotionEnd();
      }
    }
  }), function(treeNode) {
    var pos = treeNode.pos, restProps = Object.assign({}, (_objectDestructuringEmpty(treeNode.data), treeNode.data)), title = treeNode.title, key2 = treeNode.key, isStart = treeNode.isStart, isEnd = treeNode.isEnd;
    var mergedKey = getKey3(key2, pos);
    delete restProps.key;
    delete restProps.children;
    var treeNodeProps = getTreeNodeProps(mergedKey, treeNodeRequiredProps);
    return /* @__PURE__ */ React468.createElement(MotionTreeNode_default, _extends({}, restProps, treeNodeProps, {
      title,
      active: !!activeItem && key2 === activeItem.key,
      pos,
      data: treeNode.data,
      isStart,
      isEnd,
      motion: motion2,
      motionNodes: key2 === MOTION_KEY ? transitionRange : null,
      motionType,
      onMotionStart: onListChangeStart,
      onMotionEnd,
      treeNodeRequiredProps,
      onMouseMove: function onMouseMove() {
        onActiveChange(null);
      }
    }));
  }));
});
if (true) {
  NodeList.displayName = "NodeList";
}
var NodeList_default = NodeList;

// ../../node_modules/rc-tree/es/Tree.js
var MAX_RETRY_TIMES = 10;
var Tree = /* @__PURE__ */ (function(_React$Component) {
  _inherits(Tree4, _React$Component);
  var _super = _createSuper(Tree4);
  function Tree4() {
    var _this;
    _classCallCheck(this, Tree4);
    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(_args));
    _defineProperty(_assertThisInitialized(_this), "destroyed", false);
    _defineProperty(_assertThisInitialized(_this), "delayedDragEnterLogic", void 0);
    _defineProperty(_assertThisInitialized(_this), "loadingRetryTimes", {});
    _defineProperty(_assertThisInitialized(_this), "state", {
      keyEntities: {},
      indent: null,
      selectedKeys: [],
      checkedKeys: [],
      halfCheckedKeys: [],
      loadedKeys: [],
      loadingKeys: [],
      expandedKeys: [],
      draggingNodeKey: null,
      dragChildrenKeys: [],
      // dropTargetKey is the key of abstract-drop-node
      // the abstract-drop-node is the real drop node when drag and drop
      // not the DOM drag over node
      dropTargetKey: null,
      dropPosition: null,
      // the drop position of abstract-drop-node, inside 0, top -1, bottom 1
      dropContainerKey: null,
      // the container key of abstract-drop-node if dropPosition is -1 or 1
      dropLevelOffset: null,
      // the drop level offset of abstract-drag-over-node
      dropTargetPos: null,
      // the pos of abstract-drop-node
      dropAllowed: true,
      // if drop to abstract-drop-node is allowed
      // the abstract-drag-over-node
      // if mouse is on the bottom of top dom node or no the top of the bottom dom node
      // abstract-drag-over-node is the top node
      dragOverNodeKey: null,
      treeData: [],
      flattenNodes: [],
      focused: false,
      activeKey: null,
      listChanging: false,
      prevProps: null,
      fieldNames: fillFieldNames2()
    });
    _defineProperty(_assertThisInitialized(_this), "dragStartMousePosition", null);
    _defineProperty(_assertThisInitialized(_this), "dragNodeProps", null);
    _defineProperty(_assertThisInitialized(_this), "currentMouseOverDroppableNodeKey", null);
    _defineProperty(_assertThisInitialized(_this), "listRef", /* @__PURE__ */ React469.createRef());
    _defineProperty(_assertThisInitialized(_this), "onNodeDragStart", function(event, nodeProps) {
      var _this$state = _this.state, expandedKeys = _this$state.expandedKeys, keyEntities = _this$state.keyEntities;
      var onDragStart = _this.props.onDragStart;
      var eventKey = nodeProps.eventKey;
      _this.dragNodeProps = nodeProps;
      _this.dragStartMousePosition = {
        x: event.clientX,
        y: event.clientY
      };
      var newExpandedKeys = arrDel(expandedKeys, eventKey);
      _this.setState({
        draggingNodeKey: eventKey,
        dragChildrenKeys: getDragChildrenKeys(eventKey, keyEntities),
        indent: _this.listRef.current.getIndentWidth()
      });
      _this.setExpandedKeys(newExpandedKeys);
      window.addEventListener("dragend", _this.onWindowDragEnd);
      onDragStart === null || onDragStart === void 0 || onDragStart({
        event,
        node: convertNodePropsToEventData(nodeProps)
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onNodeDragEnter", function(event, nodeProps) {
      var _this$state2 = _this.state, expandedKeys = _this$state2.expandedKeys, keyEntities = _this$state2.keyEntities, dragChildrenKeys = _this$state2.dragChildrenKeys, flattenNodes = _this$state2.flattenNodes, indent = _this$state2.indent;
      var _this$props = _this.props, onDragEnter = _this$props.onDragEnter, onExpand = _this$props.onExpand, allowDrop2 = _this$props.allowDrop, direction = _this$props.direction;
      var pos = nodeProps.pos, eventKey = nodeProps.eventKey;
      if (_this.currentMouseOverDroppableNodeKey !== eventKey) {
        _this.currentMouseOverDroppableNodeKey = eventKey;
      }
      if (!_this.dragNodeProps) {
        _this.resetDragState();
        return;
      }
      var _calcDropPosition = calcDropPosition(event, _this.dragNodeProps, nodeProps, indent, _this.dragStartMousePosition, allowDrop2, flattenNodes, keyEntities, expandedKeys, direction), dropPosition = _calcDropPosition.dropPosition, dropLevelOffset = _calcDropPosition.dropLevelOffset, dropTargetKey = _calcDropPosition.dropTargetKey, dropContainerKey = _calcDropPosition.dropContainerKey, dropTargetPos = _calcDropPosition.dropTargetPos, dropAllowed = _calcDropPosition.dropAllowed, dragOverNodeKey = _calcDropPosition.dragOverNodeKey;
      if (
        // don't allow drop inside its children
        dragChildrenKeys.includes(dropTargetKey) || // don't allow drop when drop is not allowed caculated by calcDropPosition
        !dropAllowed
      ) {
        _this.resetDragState();
        return;
      }
      if (!_this.delayedDragEnterLogic) {
        _this.delayedDragEnterLogic = {};
      }
      Object.keys(_this.delayedDragEnterLogic).forEach(function(key2) {
        clearTimeout(_this.delayedDragEnterLogic[key2]);
      });
      if (_this.dragNodeProps.eventKey !== nodeProps.eventKey) {
        event.persist();
        _this.delayedDragEnterLogic[pos] = window.setTimeout(function() {
          if (_this.state.draggingNodeKey === null) {
            return;
          }
          var newExpandedKeys = _toConsumableArray(expandedKeys);
          var entity = getEntity(keyEntities, nodeProps.eventKey);
          if (entity && (entity.children || []).length) {
            newExpandedKeys = arrAdd(expandedKeys, nodeProps.eventKey);
          }
          if (!_this.props.hasOwnProperty("expandedKeys")) {
            _this.setExpandedKeys(newExpandedKeys);
          }
          onExpand === null || onExpand === void 0 || onExpand(newExpandedKeys, {
            node: convertNodePropsToEventData(nodeProps),
            expanded: true,
            nativeEvent: event.nativeEvent
          });
        }, 800);
      }
      if (_this.dragNodeProps.eventKey === dropTargetKey && dropLevelOffset === 0) {
        _this.resetDragState();
        return;
      }
      _this.setState({
        dragOverNodeKey,
        dropPosition,
        dropLevelOffset,
        dropTargetKey,
        dropContainerKey,
        dropTargetPos,
        dropAllowed
      });
      onDragEnter === null || onDragEnter === void 0 || onDragEnter({
        event,
        node: convertNodePropsToEventData(nodeProps),
        expandedKeys
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onNodeDragOver", function(event, nodeProps) {
      var _this$state3 = _this.state, dragChildrenKeys = _this$state3.dragChildrenKeys, flattenNodes = _this$state3.flattenNodes, keyEntities = _this$state3.keyEntities, expandedKeys = _this$state3.expandedKeys, indent = _this$state3.indent;
      var _this$props2 = _this.props, onDragOver = _this$props2.onDragOver, allowDrop2 = _this$props2.allowDrop, direction = _this$props2.direction;
      if (!_this.dragNodeProps) {
        return;
      }
      var _calcDropPosition2 = calcDropPosition(event, _this.dragNodeProps, nodeProps, indent, _this.dragStartMousePosition, allowDrop2, flattenNodes, keyEntities, expandedKeys, direction), dropPosition = _calcDropPosition2.dropPosition, dropLevelOffset = _calcDropPosition2.dropLevelOffset, dropTargetKey = _calcDropPosition2.dropTargetKey, dropContainerKey = _calcDropPosition2.dropContainerKey, dropTargetPos = _calcDropPosition2.dropTargetPos, dropAllowed = _calcDropPosition2.dropAllowed, dragOverNodeKey = _calcDropPosition2.dragOverNodeKey;
      if (dragChildrenKeys.includes(dropTargetKey) || !dropAllowed) {
        return;
      }
      if (_this.dragNodeProps.eventKey === dropTargetKey && dropLevelOffset === 0) {
        if (!(_this.state.dropPosition === null && _this.state.dropLevelOffset === null && _this.state.dropTargetKey === null && _this.state.dropContainerKey === null && _this.state.dropTargetPos === null && _this.state.dropAllowed === false && _this.state.dragOverNodeKey === null)) {
          _this.resetDragState();
        }
      } else if (!(dropPosition === _this.state.dropPosition && dropLevelOffset === _this.state.dropLevelOffset && dropTargetKey === _this.state.dropTargetKey && dropContainerKey === _this.state.dropContainerKey && dropTargetPos === _this.state.dropTargetPos && dropAllowed === _this.state.dropAllowed && dragOverNodeKey === _this.state.dragOverNodeKey)) {
        _this.setState({
          dropPosition,
          dropLevelOffset,
          dropTargetKey,
          dropContainerKey,
          dropTargetPos,
          dropAllowed,
          dragOverNodeKey
        });
      }
      onDragOver === null || onDragOver === void 0 || onDragOver({
        event,
        node: convertNodePropsToEventData(nodeProps)
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onNodeDragLeave", function(event, nodeProps) {
      if (_this.currentMouseOverDroppableNodeKey === nodeProps.eventKey && !event.currentTarget.contains(event.relatedTarget)) {
        _this.resetDragState();
        _this.currentMouseOverDroppableNodeKey = null;
      }
      var onDragLeave = _this.props.onDragLeave;
      onDragLeave === null || onDragLeave === void 0 || onDragLeave({
        event,
        node: convertNodePropsToEventData(nodeProps)
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onWindowDragEnd", function(event) {
      _this.onNodeDragEnd(event, null, true);
      window.removeEventListener("dragend", _this.onWindowDragEnd);
    });
    _defineProperty(_assertThisInitialized(_this), "onNodeDragEnd", function(event, nodeProps) {
      var onDragEnd = _this.props.onDragEnd;
      _this.setState({
        dragOverNodeKey: null
      });
      _this.cleanDragState();
      onDragEnd === null || onDragEnd === void 0 || onDragEnd({
        event,
        node: convertNodePropsToEventData(nodeProps)
      });
      _this.dragNodeProps = null;
      window.removeEventListener("dragend", _this.onWindowDragEnd);
    });
    _defineProperty(_assertThisInitialized(_this), "onNodeDrop", function(event, _) {
      var _this$getActiveItem;
      var outsideTree = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
      var _this$state4 = _this.state, dragChildrenKeys = _this$state4.dragChildrenKeys, dropPosition = _this$state4.dropPosition, dropTargetKey = _this$state4.dropTargetKey, dropTargetPos = _this$state4.dropTargetPos, dropAllowed = _this$state4.dropAllowed;
      if (!dropAllowed) {
        return;
      }
      var onDrop = _this.props.onDrop;
      _this.setState({
        dragOverNodeKey: null
      });
      _this.cleanDragState();
      if (dropTargetKey === null) return;
      var abstractDropNodeProps = _objectSpread2(_objectSpread2({}, getTreeNodeProps(dropTargetKey, _this.getTreeNodeRequiredProps())), {}, {
        active: ((_this$getActiveItem = _this.getActiveItem()) === null || _this$getActiveItem === void 0 ? void 0 : _this$getActiveItem.key) === dropTargetKey,
        data: getEntity(_this.state.keyEntities, dropTargetKey).node
      });
      var dropToChild = dragChildrenKeys.includes(dropTargetKey);
      warning_default(!dropToChild, "Can not drop to dragNode's children node. This is a bug of rc-tree. Please report an issue.");
      var posArr = posToArr(dropTargetPos);
      var dropResult = {
        event,
        node: convertNodePropsToEventData(abstractDropNodeProps),
        dragNode: _this.dragNodeProps ? convertNodePropsToEventData(_this.dragNodeProps) : null,
        dragNodesKeys: [_this.dragNodeProps.eventKey].concat(dragChildrenKeys),
        dropToGap: dropPosition !== 0,
        dropPosition: dropPosition + Number(posArr[posArr.length - 1])
      };
      if (!outsideTree) {
        onDrop === null || onDrop === void 0 || onDrop(dropResult);
      }
      _this.dragNodeProps = null;
    });
    _defineProperty(_assertThisInitialized(_this), "cleanDragState", function() {
      var draggingNodeKey = _this.state.draggingNodeKey;
      if (draggingNodeKey !== null) {
        _this.setState({
          draggingNodeKey: null,
          dropPosition: null,
          dropContainerKey: null,
          dropTargetKey: null,
          dropLevelOffset: null,
          dropAllowed: true,
          dragOverNodeKey: null
        });
      }
      _this.dragStartMousePosition = null;
      _this.currentMouseOverDroppableNodeKey = null;
    });
    _defineProperty(_assertThisInitialized(_this), "triggerExpandActionExpand", function(e3, treeNode) {
      var _this$state5 = _this.state, expandedKeys = _this$state5.expandedKeys, flattenNodes = _this$state5.flattenNodes;
      var expanded = treeNode.expanded, key2 = treeNode.key, isLeaf = treeNode.isLeaf;
      if (isLeaf || e3.shiftKey || e3.metaKey || e3.ctrlKey) {
        return;
      }
      var node2 = flattenNodes.filter(function(nodeItem) {
        return nodeItem.key === key2;
      })[0];
      var eventNode = convertNodePropsToEventData(_objectSpread2(_objectSpread2({}, getTreeNodeProps(key2, _this.getTreeNodeRequiredProps())), {}, {
        data: node2.data
      }));
      _this.setExpandedKeys(expanded ? arrDel(expandedKeys, key2) : arrAdd(expandedKeys, key2));
      _this.onNodeExpand(e3, eventNode);
    });
    _defineProperty(_assertThisInitialized(_this), "onNodeClick", function(e3, treeNode) {
      var _this$props3 = _this.props, onClick = _this$props3.onClick, expandAction = _this$props3.expandAction;
      if (expandAction === "click") {
        _this.triggerExpandActionExpand(e3, treeNode);
      }
      onClick === null || onClick === void 0 || onClick(e3, treeNode);
    });
    _defineProperty(_assertThisInitialized(_this), "onNodeDoubleClick", function(e3, treeNode) {
      var _this$props4 = _this.props, onDoubleClick = _this$props4.onDoubleClick, expandAction = _this$props4.expandAction;
      if (expandAction === "doubleClick") {
        _this.triggerExpandActionExpand(e3, treeNode);
      }
      onDoubleClick === null || onDoubleClick === void 0 || onDoubleClick(e3, treeNode);
    });
    _defineProperty(_assertThisInitialized(_this), "onNodeSelect", function(e3, treeNode) {
      var selectedKeys = _this.state.selectedKeys;
      var _this$state6 = _this.state, keyEntities = _this$state6.keyEntities, fieldNames = _this$state6.fieldNames;
      var _this$props5 = _this.props, onSelect = _this$props5.onSelect, multiple = _this$props5.multiple;
      var selected = treeNode.selected;
      var key2 = treeNode[fieldNames.key];
      var targetSelected = !selected;
      if (!targetSelected) {
        selectedKeys = arrDel(selectedKeys, key2);
      } else if (!multiple) {
        selectedKeys = [key2];
      } else {
        selectedKeys = arrAdd(selectedKeys, key2);
      }
      var selectedNodes = selectedKeys.map(function(selectedKey) {
        var entity = getEntity(keyEntities, selectedKey);
        return entity ? entity.node : null;
      }).filter(Boolean);
      _this.setUncontrolledState({
        selectedKeys
      });
      onSelect === null || onSelect === void 0 || onSelect(selectedKeys, {
        event: "select",
        selected: targetSelected,
        node: treeNode,
        selectedNodes,
        nativeEvent: e3.nativeEvent
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onNodeCheck", function(e3, treeNode, checked) {
      var _this$state7 = _this.state, keyEntities = _this$state7.keyEntities, oriCheckedKeys = _this$state7.checkedKeys, oriHalfCheckedKeys = _this$state7.halfCheckedKeys;
      var _this$props6 = _this.props, checkStrictly = _this$props6.checkStrictly, onCheck = _this$props6.onCheck;
      var key2 = treeNode.key;
      var checkedObj;
      var eventObj = {
        event: "check",
        node: treeNode,
        checked,
        nativeEvent: e3.nativeEvent
      };
      if (checkStrictly) {
        var checkedKeys = checked ? arrAdd(oriCheckedKeys, key2) : arrDel(oriCheckedKeys, key2);
        var halfCheckedKeys = arrDel(oriHalfCheckedKeys, key2);
        checkedObj = {
          checked: checkedKeys,
          halfChecked: halfCheckedKeys
        };
        eventObj.checkedNodes = checkedKeys.map(function(checkedKey) {
          return getEntity(keyEntities, checkedKey);
        }).filter(Boolean).map(function(entity) {
          return entity.node;
        });
        _this.setUncontrolledState({
          checkedKeys
        });
      } else {
        var _conductCheck = conductCheck([].concat(_toConsumableArray(oriCheckedKeys), [key2]), true, keyEntities), _checkedKeys = _conductCheck.checkedKeys, _halfCheckedKeys = _conductCheck.halfCheckedKeys;
        if (!checked) {
          var keySet = new Set(_checkedKeys);
          keySet.delete(key2);
          var _conductCheck2 = conductCheck(Array.from(keySet), {
            checked: false,
            halfCheckedKeys: _halfCheckedKeys
          }, keyEntities);
          _checkedKeys = _conductCheck2.checkedKeys;
          _halfCheckedKeys = _conductCheck2.halfCheckedKeys;
        }
        checkedObj = _checkedKeys;
        eventObj.checkedNodes = [];
        eventObj.checkedNodesPositions = [];
        eventObj.halfCheckedKeys = _halfCheckedKeys;
        _checkedKeys.forEach(function(checkedKey) {
          var entity = getEntity(keyEntities, checkedKey);
          if (!entity) return;
          var node2 = entity.node, pos = entity.pos;
          eventObj.checkedNodes.push(node2);
          eventObj.checkedNodesPositions.push({
            node: node2,
            pos
          });
        });
        _this.setUncontrolledState({
          checkedKeys: _checkedKeys
        }, false, {
          halfCheckedKeys: _halfCheckedKeys
        });
      }
      onCheck === null || onCheck === void 0 || onCheck(checkedObj, eventObj);
    });
    _defineProperty(_assertThisInitialized(_this), "onNodeLoad", function(treeNode) {
      var _entity$children;
      var key2 = treeNode.key;
      var keyEntities = _this.state.keyEntities;
      var entity = getEntity(keyEntities, key2);
      if (entity !== null && entity !== void 0 && (_entity$children = entity.children) !== null && _entity$children !== void 0 && _entity$children.length) {
        return;
      }
      var loadPromise = new Promise(function(resolve, reject) {
        _this.setState(function(_ref) {
          var _ref$loadedKeys = _ref.loadedKeys, loadedKeys = _ref$loadedKeys === void 0 ? [] : _ref$loadedKeys, _ref$loadingKeys = _ref.loadingKeys, loadingKeys = _ref$loadingKeys === void 0 ? [] : _ref$loadingKeys;
          var _this$props7 = _this.props, loadData = _this$props7.loadData, onLoad = _this$props7.onLoad;
          if (!loadData || loadedKeys.includes(key2) || loadingKeys.includes(key2)) {
            return null;
          }
          var promise = loadData(treeNode);
          promise.then(function() {
            var currentLoadedKeys = _this.state.loadedKeys;
            var newLoadedKeys = arrAdd(currentLoadedKeys, key2);
            onLoad === null || onLoad === void 0 || onLoad(newLoadedKeys, {
              event: "load",
              node: treeNode
            });
            _this.setUncontrolledState({
              loadedKeys: newLoadedKeys
            });
            _this.setState(function(prevState) {
              return {
                loadingKeys: arrDel(prevState.loadingKeys, key2)
              };
            });
            resolve();
          }).catch(function(e3) {
            _this.setState(function(prevState) {
              return {
                loadingKeys: arrDel(prevState.loadingKeys, key2)
              };
            });
            _this.loadingRetryTimes[key2] = (_this.loadingRetryTimes[key2] || 0) + 1;
            if (_this.loadingRetryTimes[key2] >= MAX_RETRY_TIMES) {
              var currentLoadedKeys = _this.state.loadedKeys;
              warning_default(false, "Retry for `loadData` many times but still failed. No more retry.");
              _this.setUncontrolledState({
                loadedKeys: arrAdd(currentLoadedKeys, key2)
              });
              resolve();
            }
            reject(e3);
          });
          return {
            loadingKeys: arrAdd(loadingKeys, key2)
          };
        });
      });
      loadPromise.catch(function() {
      });
      return loadPromise;
    });
    _defineProperty(_assertThisInitialized(_this), "onNodeMouseEnter", function(event, node2) {
      var onMouseEnter = _this.props.onMouseEnter;
      onMouseEnter === null || onMouseEnter === void 0 || onMouseEnter({
        event,
        node: node2
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onNodeMouseLeave", function(event, node2) {
      var onMouseLeave = _this.props.onMouseLeave;
      onMouseLeave === null || onMouseLeave === void 0 || onMouseLeave({
        event,
        node: node2
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onNodeContextMenu", function(event, node2) {
      var onRightClick = _this.props.onRightClick;
      if (onRightClick) {
        event.preventDefault();
        onRightClick({
          event,
          node: node2
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onFocus", function() {
      var onFocus = _this.props.onFocus;
      _this.setState({
        focused: true
      });
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      onFocus === null || onFocus === void 0 || onFocus.apply(void 0, args);
    });
    _defineProperty(_assertThisInitialized(_this), "onBlur", function() {
      var onBlur = _this.props.onBlur;
      _this.setState({
        focused: false
      });
      _this.onActiveChange(null);
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      onBlur === null || onBlur === void 0 || onBlur.apply(void 0, args);
    });
    _defineProperty(_assertThisInitialized(_this), "getTreeNodeRequiredProps", function() {
      var _this$state8 = _this.state, expandedKeys = _this$state8.expandedKeys, selectedKeys = _this$state8.selectedKeys, loadedKeys = _this$state8.loadedKeys, loadingKeys = _this$state8.loadingKeys, checkedKeys = _this$state8.checkedKeys, halfCheckedKeys = _this$state8.halfCheckedKeys, dragOverNodeKey = _this$state8.dragOverNodeKey, dropPosition = _this$state8.dropPosition, keyEntities = _this$state8.keyEntities;
      return {
        expandedKeys: expandedKeys || [],
        selectedKeys: selectedKeys || [],
        loadedKeys: loadedKeys || [],
        loadingKeys: loadingKeys || [],
        checkedKeys: checkedKeys || [],
        halfCheckedKeys: halfCheckedKeys || [],
        dragOverNodeKey,
        dropPosition,
        keyEntities
      };
    });
    _defineProperty(_assertThisInitialized(_this), "setExpandedKeys", function(expandedKeys) {
      var _this$state9 = _this.state, treeData = _this$state9.treeData, fieldNames = _this$state9.fieldNames;
      var flattenNodes = flattenTreeData(treeData, expandedKeys, fieldNames);
      _this.setUncontrolledState({
        expandedKeys,
        flattenNodes
      }, true);
    });
    _defineProperty(_assertThisInitialized(_this), "onNodeExpand", function(e3, treeNode) {
      var expandedKeys = _this.state.expandedKeys;
      var _this$state10 = _this.state, listChanging = _this$state10.listChanging, fieldNames = _this$state10.fieldNames;
      var _this$props8 = _this.props, onExpand = _this$props8.onExpand, loadData = _this$props8.loadData;
      var expanded = treeNode.expanded;
      var key2 = treeNode[fieldNames.key];
      if (listChanging) {
        return;
      }
      var certain = expandedKeys.includes(key2);
      var targetExpanded = !expanded;
      warning_default(expanded && certain || !expanded && !certain, "Expand state not sync with index check");
      expandedKeys = targetExpanded ? arrAdd(expandedKeys, key2) : arrDel(expandedKeys, key2);
      _this.setExpandedKeys(expandedKeys);
      onExpand === null || onExpand === void 0 || onExpand(expandedKeys, {
        node: treeNode,
        expanded: targetExpanded,
        nativeEvent: e3.nativeEvent
      });
      if (targetExpanded && loadData) {
        var loadPromise = _this.onNodeLoad(treeNode);
        if (loadPromise) {
          loadPromise.then(function() {
            var newFlattenTreeData = flattenTreeData(_this.state.treeData, expandedKeys, fieldNames);
            _this.setUncontrolledState({
              flattenNodes: newFlattenTreeData
            });
          }).catch(function() {
            var currentExpandedKeys = _this.state.expandedKeys;
            var expandedKeysToRestore = arrDel(currentExpandedKeys, key2);
            _this.setExpandedKeys(expandedKeysToRestore);
          });
        }
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onListChangeStart", function() {
      _this.setUncontrolledState({
        listChanging: true
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onListChangeEnd", function() {
      setTimeout(function() {
        _this.setUncontrolledState({
          listChanging: false
        });
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onActiveChange", function(newActiveKey) {
      var activeKey = _this.state.activeKey;
      var _this$props9 = _this.props, onActiveChange = _this$props9.onActiveChange, _this$props9$itemScro = _this$props9.itemScrollOffset, itemScrollOffset = _this$props9$itemScro === void 0 ? 0 : _this$props9$itemScro;
      if (activeKey === newActiveKey) {
        return;
      }
      _this.setState({
        activeKey: newActiveKey
      });
      if (newActiveKey !== null) {
        _this.scrollTo({
          key: newActiveKey,
          offset: itemScrollOffset
        });
      }
      onActiveChange === null || onActiveChange === void 0 || onActiveChange(newActiveKey);
    });
    _defineProperty(_assertThisInitialized(_this), "getActiveItem", function() {
      var _this$state11 = _this.state, activeKey = _this$state11.activeKey, flattenNodes = _this$state11.flattenNodes;
      if (activeKey === null) {
        return null;
      }
      return flattenNodes.find(function(_ref2) {
        var key2 = _ref2.key;
        return key2 === activeKey;
      }) || null;
    });
    _defineProperty(_assertThisInitialized(_this), "offsetActiveKey", function(offset4) {
      var _this$state12 = _this.state, flattenNodes = _this$state12.flattenNodes, activeKey = _this$state12.activeKey;
      var index3 = flattenNodes.findIndex(function(_ref3) {
        var key2 = _ref3.key;
        return key2 === activeKey;
      });
      if (index3 === -1 && offset4 < 0) {
        index3 = flattenNodes.length;
      }
      index3 = (index3 + offset4 + flattenNodes.length) % flattenNodes.length;
      var item = flattenNodes[index3];
      if (item) {
        var _key4 = item.key;
        _this.onActiveChange(_key4);
      } else {
        _this.onActiveChange(null);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onKeyDown", function(event) {
      var _this$state13 = _this.state, activeKey = _this$state13.activeKey, expandedKeys = _this$state13.expandedKeys, checkedKeys = _this$state13.checkedKeys, fieldNames = _this$state13.fieldNames;
      var _this$props10 = _this.props, onKeyDown2 = _this$props10.onKeyDown, checkable = _this$props10.checkable, selectable = _this$props10.selectable;
      switch (event.which) {
        case KeyCode_default.UP: {
          _this.offsetActiveKey(-1);
          event.preventDefault();
          break;
        }
        case KeyCode_default.DOWN: {
          _this.offsetActiveKey(1);
          event.preventDefault();
          break;
        }
      }
      var activeItem = _this.getActiveItem();
      if (activeItem && activeItem.data) {
        var treeNodeRequiredProps = _this.getTreeNodeRequiredProps();
        var expandable = activeItem.data.isLeaf === false || !!(activeItem.data[fieldNames.children] || []).length;
        var eventNode = convertNodePropsToEventData(_objectSpread2(_objectSpread2({}, getTreeNodeProps(activeKey, treeNodeRequiredProps)), {}, {
          data: activeItem.data,
          active: true
        }));
        switch (event.which) {
          // >>> Expand
          case KeyCode_default.LEFT: {
            if (expandable && expandedKeys.includes(activeKey)) {
              _this.onNodeExpand({}, eventNode);
            } else if (activeItem.parent) {
              _this.onActiveChange(activeItem.parent.key);
            }
            event.preventDefault();
            break;
          }
          case KeyCode_default.RIGHT: {
            if (expandable && !expandedKeys.includes(activeKey)) {
              _this.onNodeExpand({}, eventNode);
            } else if (activeItem.children && activeItem.children.length) {
              _this.onActiveChange(activeItem.children[0].key);
            }
            event.preventDefault();
            break;
          }
          // Selection
          case KeyCode_default.ENTER:
          case KeyCode_default.SPACE: {
            if (checkable && !eventNode.disabled && eventNode.checkable !== false && !eventNode.disableCheckbox) {
              _this.onNodeCheck({}, eventNode, !checkedKeys.includes(activeKey));
            } else if (!checkable && selectable && !eventNode.disabled && eventNode.selectable !== false) {
              _this.onNodeSelect({}, eventNode);
            }
            break;
          }
        }
      }
      onKeyDown2 === null || onKeyDown2 === void 0 || onKeyDown2(event);
    });
    _defineProperty(_assertThisInitialized(_this), "setUncontrolledState", function(state) {
      var atomic = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
      var forceState = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
      if (!_this.destroyed) {
        var needSync = false;
        var allPassed = true;
        var newState = {};
        Object.keys(state).forEach(function(name) {
          if (_this.props.hasOwnProperty(name)) {
            allPassed = false;
            return;
          }
          needSync = true;
          newState[name] = state[name];
        });
        if (needSync && (!atomic || allPassed)) {
          _this.setState(_objectSpread2(_objectSpread2({}, newState), forceState));
        }
      }
    });
    _defineProperty(_assertThisInitialized(_this), "scrollTo", function(scroll) {
      _this.listRef.current.scrollTo(scroll);
    });
    return _this;
  }
  _createClass(Tree4, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.destroyed = false;
      this.onUpdated();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.onUpdated();
    }
  }, {
    key: "onUpdated",
    value: function onUpdated() {
      var _this$props11 = this.props, activeKey = _this$props11.activeKey, _this$props11$itemScr = _this$props11.itemScrollOffset, itemScrollOffset = _this$props11$itemScr === void 0 ? 0 : _this$props11$itemScr;
      if (activeKey !== void 0 && activeKey !== this.state.activeKey) {
        this.setState({
          activeKey
        });
        if (activeKey !== null) {
          this.scrollTo({
            key: activeKey,
            offset: itemScrollOffset
          });
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("dragend", this.onWindowDragEnd);
      this.destroyed = true;
    }
  }, {
    key: "resetDragState",
    value: function resetDragState() {
      this.setState({
        dragOverNodeKey: null,
        dropPosition: null,
        dropLevelOffset: null,
        dropTargetKey: null,
        dropContainerKey: null,
        dropTargetPos: null,
        dropAllowed: false
      });
    }
  }, {
    key: "render",
    value: function render4() {
      var _this$state14 = this.state, focused = _this$state14.focused, flattenNodes = _this$state14.flattenNodes, keyEntities = _this$state14.keyEntities, draggingNodeKey = _this$state14.draggingNodeKey, activeKey = _this$state14.activeKey, dropLevelOffset = _this$state14.dropLevelOffset, dropContainerKey = _this$state14.dropContainerKey, dropTargetKey = _this$state14.dropTargetKey, dropPosition = _this$state14.dropPosition, dragOverNodeKey = _this$state14.dragOverNodeKey, indent = _this$state14.indent;
      var _this$props12 = this.props, prefixCls = _this$props12.prefixCls, className2 = _this$props12.className, style2 = _this$props12.style, showLine = _this$props12.showLine, focusable2 = _this$props12.focusable, _this$props12$tabInde = _this$props12.tabIndex, tabIndex = _this$props12$tabInde === void 0 ? 0 : _this$props12$tabInde, selectable = _this$props12.selectable, showIcon = _this$props12.showIcon, icon = _this$props12.icon, switcherIcon = _this$props12.switcherIcon, draggable = _this$props12.draggable, checkable = _this$props12.checkable, checkStrictly = _this$props12.checkStrictly, disabled = _this$props12.disabled, motion2 = _this$props12.motion, loadData = _this$props12.loadData, filterTreeNode = _this$props12.filterTreeNode, height = _this$props12.height, itemHeight = _this$props12.itemHeight, scrollWidth = _this$props12.scrollWidth, virtual = _this$props12.virtual, titleRender = _this$props12.titleRender, dropIndicatorRender2 = _this$props12.dropIndicatorRender, onContextMenu = _this$props12.onContextMenu, onScroll = _this$props12.onScroll, direction = _this$props12.direction, rootClassName = _this$props12.rootClassName, rootStyle = _this$props12.rootStyle;
      var domProps = pickAttrs(this.props, {
        aria: true,
        data: true
      });
      var draggableConfig;
      if (draggable) {
        if (_typeof(draggable) === "object") {
          draggableConfig = draggable;
        } else if (typeof draggable === "function") {
          draggableConfig = {
            nodeDraggable: draggable
          };
        } else {
          draggableConfig = {};
        }
      }
      var contextValue = {
        prefixCls,
        selectable,
        showIcon,
        icon,
        switcherIcon,
        draggable: draggableConfig,
        draggingNodeKey,
        checkable,
        checkStrictly,
        disabled,
        keyEntities,
        dropLevelOffset,
        dropContainerKey,
        dropTargetKey,
        dropPosition,
        dragOverNodeKey,
        indent,
        direction,
        dropIndicatorRender: dropIndicatorRender2,
        loadData,
        filterTreeNode,
        titleRender,
        onNodeClick: this.onNodeClick,
        onNodeDoubleClick: this.onNodeDoubleClick,
        onNodeExpand: this.onNodeExpand,
        onNodeSelect: this.onNodeSelect,
        onNodeCheck: this.onNodeCheck,
        onNodeLoad: this.onNodeLoad,
        onNodeMouseEnter: this.onNodeMouseEnter,
        onNodeMouseLeave: this.onNodeMouseLeave,
        onNodeContextMenu: this.onNodeContextMenu,
        onNodeDragStart: this.onNodeDragStart,
        onNodeDragEnter: this.onNodeDragEnter,
        onNodeDragOver: this.onNodeDragOver,
        onNodeDragLeave: this.onNodeDragLeave,
        onNodeDragEnd: this.onNodeDragEnd,
        onNodeDrop: this.onNodeDrop
      };
      return /* @__PURE__ */ React469.createElement(TreeContext.Provider, {
        value: contextValue
      }, /* @__PURE__ */ React469.createElement("div", {
        className: (0, import_classnames190.default)(prefixCls, className2, rootClassName, _defineProperty(_defineProperty(_defineProperty({}, "".concat(prefixCls, "-show-line"), showLine), "".concat(prefixCls, "-focused"), focused), "".concat(prefixCls, "-active-focused"), activeKey !== null)),
        style: rootStyle
      }, /* @__PURE__ */ React469.createElement(NodeList_default, _extends({
        ref: this.listRef,
        prefixCls,
        style: style2,
        data: flattenNodes,
        disabled,
        selectable,
        checkable: !!checkable,
        motion: motion2,
        dragging: draggingNodeKey !== null,
        height,
        itemHeight,
        virtual,
        focusable: focusable2,
        focused,
        tabIndex,
        activeItem: this.getActiveItem(),
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        onKeyDown: this.onKeyDown,
        onActiveChange: this.onActiveChange,
        onListChangeStart: this.onListChangeStart,
        onListChangeEnd: this.onListChangeEnd,
        onContextMenu,
        onScroll,
        scrollWidth
      }, this.getTreeNodeRequiredProps(), domProps))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, prevState) {
      var prevProps = prevState.prevProps;
      var newState = {
        prevProps: props
      };
      function needSync(name) {
        return !prevProps && props.hasOwnProperty(name) || prevProps && prevProps[name] !== props[name];
      }
      var treeData;
      var fieldNames = prevState.fieldNames;
      if (needSync("fieldNames")) {
        fieldNames = fillFieldNames2(props.fieldNames);
        newState.fieldNames = fieldNames;
      }
      if (needSync("treeData")) {
        treeData = props.treeData;
      } else if (needSync("children")) {
        warning_default(false, "`children` of Tree is deprecated. Please use `treeData` instead.");
        treeData = convertTreeToData(props.children);
      }
      if (treeData) {
        newState.treeData = treeData;
        var entitiesMap = convertDataToEntities(treeData, {
          fieldNames
        });
        newState.keyEntities = _objectSpread2(_defineProperty({}, MOTION_KEY, MotionEntity), entitiesMap.keyEntities);
        if (true) {
          warningWithoutKey(treeData, fieldNames);
        }
      }
      var keyEntities = newState.keyEntities || prevState.keyEntities;
      if (needSync("expandedKeys") || prevProps && needSync("autoExpandParent")) {
        newState.expandedKeys = props.autoExpandParent || !prevProps && props.defaultExpandParent ? conductExpandParent(props.expandedKeys, keyEntities) : props.expandedKeys;
      } else if (!prevProps && props.defaultExpandAll) {
        var cloneKeyEntities = _objectSpread2({}, keyEntities);
        delete cloneKeyEntities[MOTION_KEY];
        var nextExpandedKeys = [];
        Object.keys(cloneKeyEntities).forEach(function(key2) {
          var entity = cloneKeyEntities[key2];
          if (entity.children && entity.children.length) {
            nextExpandedKeys.push(entity.key);
          }
        });
        newState.expandedKeys = nextExpandedKeys;
      } else if (!prevProps && props.defaultExpandedKeys) {
        newState.expandedKeys = props.autoExpandParent || props.defaultExpandParent ? conductExpandParent(props.defaultExpandedKeys, keyEntities) : props.defaultExpandedKeys;
      }
      if (!newState.expandedKeys) {
        delete newState.expandedKeys;
      }
      if (treeData || newState.expandedKeys) {
        var flattenNodes = flattenTreeData(treeData || prevState.treeData, newState.expandedKeys || prevState.expandedKeys, fieldNames);
        newState.flattenNodes = flattenNodes;
      }
      if (props.selectable) {
        if (needSync("selectedKeys")) {
          newState.selectedKeys = calcSelectedKeys(props.selectedKeys, props);
        } else if (!prevProps && props.defaultSelectedKeys) {
          newState.selectedKeys = calcSelectedKeys(props.defaultSelectedKeys, props);
        }
      }
      if (props.checkable) {
        var checkedKeyEntity;
        if (needSync("checkedKeys")) {
          checkedKeyEntity = parseCheckedKeys(props.checkedKeys) || {};
        } else if (!prevProps && props.defaultCheckedKeys) {
          checkedKeyEntity = parseCheckedKeys(props.defaultCheckedKeys) || {};
        } else if (treeData) {
          checkedKeyEntity = parseCheckedKeys(props.checkedKeys) || {
            checkedKeys: prevState.checkedKeys,
            halfCheckedKeys: prevState.halfCheckedKeys
          };
        }
        if (checkedKeyEntity) {
          var _checkedKeyEntity = checkedKeyEntity, _checkedKeyEntity$che = _checkedKeyEntity.checkedKeys, checkedKeys = _checkedKeyEntity$che === void 0 ? [] : _checkedKeyEntity$che, _checkedKeyEntity$hal = _checkedKeyEntity.halfCheckedKeys, halfCheckedKeys = _checkedKeyEntity$hal === void 0 ? [] : _checkedKeyEntity$hal;
          if (!props.checkStrictly) {
            var conductKeys = conductCheck(checkedKeys, true, keyEntities);
            checkedKeys = conductKeys.checkedKeys;
            halfCheckedKeys = conductKeys.halfCheckedKeys;
          }
          newState.checkedKeys = checkedKeys;
          newState.halfCheckedKeys = halfCheckedKeys;
        }
      }
      if (needSync("loadedKeys")) {
        newState.loadedKeys = props.loadedKeys;
      }
      return newState;
    }
  }]);
  return Tree4;
})(React469.Component);
_defineProperty(Tree, "defaultProps", {
  prefixCls: "rc-tree",
  showLine: false,
  showIcon: true,
  selectable: true,
  multiple: false,
  checkable: false,
  disabled: false,
  checkStrictly: false,
  draggable: false,
  defaultExpandParent: true,
  autoExpandParent: false,
  defaultExpandAll: false,
  defaultExpandedKeys: [],
  defaultCheckedKeys: [],
  defaultSelectedKeys: [],
  dropIndicatorRender: DropIndicator_default,
  allowDrop: function allowDrop() {
    return true;
  },
  expandAction: false
});
_defineProperty(Tree, "TreeNode", TreeNode_default);
var Tree_default = Tree;

// ../../node_modules/rc-tree/es/index.js
var es_default27 = Tree_default;

// ../../node_modules/antd/es/tree/DirectoryTree.js
var React480 = __toESM(require_react());

// ../../node_modules/@ant-design/icons/es/icons/FileOutlined.js
var React470 = __toESM(require_react());

// ../../node_modules/@ant-design/icons-svg/es/asn/FileOutlined.js
var FileOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494z" } }] }, "name": "file", "theme": "outlined" };
var FileOutlined_default = FileOutlined;

// ../../node_modules/@ant-design/icons/es/icons/FileOutlined.js
var FileOutlined2 = function FileOutlined3(props, ref3) {
  return /* @__PURE__ */ React470.createElement(AntdIcon_default, _extends({}, props, {
    ref: ref3,
    icon: FileOutlined_default
  }));
};
var RefIcon32 = /* @__PURE__ */ React470.forwardRef(FileOutlined2);
if (true) {
  RefIcon32.displayName = "FileOutlined";
}
var FileOutlined_default2 = RefIcon32;

// ../../node_modules/@ant-design/icons/es/icons/FolderOpenOutlined.js
var React471 = __toESM(require_react());

// ../../node_modules/@ant-design/icons-svg/es/asn/FolderOpenOutlined.js
var FolderOpenOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 444H820V330.4c0-17.7-14.3-32-32-32H473L355.7 186.2a8.15 8.15 0 00-5.5-2.2H96c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h698c13 0 24.8-7.9 29.7-20l134-332c1.5-3.8 2.3-7.9 2.3-12 0-17.7-14.3-32-32-32zM136 256h188.5l119.6 114.4H748V444H238c-13 0-24.8 7.9-29.7 20L136 643.2V256zm635.3 512H159l103.3-256h612.4L771.3 768z" } }] }, "name": "folder-open", "theme": "outlined" };
var FolderOpenOutlined_default = FolderOpenOutlined;

// ../../node_modules/@ant-design/icons/es/icons/FolderOpenOutlined.js
var FolderOpenOutlined2 = function FolderOpenOutlined3(props, ref3) {
  return /* @__PURE__ */ React471.createElement(AntdIcon_default, _extends({}, props, {
    ref: ref3,
    icon: FolderOpenOutlined_default
  }));
};
var RefIcon33 = /* @__PURE__ */ React471.forwardRef(FolderOpenOutlined2);
if (true) {
  RefIcon33.displayName = "FolderOpenOutlined";
}
var FolderOpenOutlined_default2 = RefIcon33;

// ../../node_modules/@ant-design/icons/es/icons/FolderOutlined.js
var React472 = __toESM(require_react());

// ../../node_modules/@ant-design/icons-svg/es/asn/FolderOutlined.js
var FolderOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 298.4H521L403.7 186.2a8.15 8.15 0 00-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z" } }] }, "name": "folder", "theme": "outlined" };
var FolderOutlined_default = FolderOutlined;

// ../../node_modules/@ant-design/icons/es/icons/FolderOutlined.js
var FolderOutlined2 = function FolderOutlined3(props, ref3) {
  return /* @__PURE__ */ React472.createElement(AntdIcon_default, _extends({}, props, {
    ref: ref3,
    icon: FolderOutlined_default
  }));
};
var RefIcon34 = /* @__PURE__ */ React472.forwardRef(FolderOutlined2);
if (true) {
  RefIcon34.displayName = "FolderOutlined";
}
var FolderOutlined_default2 = RefIcon34;

// ../../node_modules/antd/es/tree/DirectoryTree.js
var import_classnames193 = __toESM(require_classnames());

// ../../node_modules/antd/es/tree/Tree.js
var import_react148 = __toESM(require_react());

// ../../node_modules/@ant-design/icons/es/icons/HolderOutlined.js
var React473 = __toESM(require_react());

// ../../node_modules/@ant-design/icons-svg/es/asn/HolderOutlined.js
var HolderOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M300 276.5a56 56 0 1056-97 56 56 0 00-56 97zm0 284a56 56 0 1056-97 56 56 0 00-56 97zM640 228a56 56 0 10112 0 56 56 0 00-112 0zm0 284a56 56 0 10112 0 56 56 0 00-112 0zM300 844.5a56 56 0 1056-97 56 56 0 00-56 97zM640 796a56 56 0 10112 0 56 56 0 00-112 0z" } }] }, "name": "holder", "theme": "outlined" };
var HolderOutlined_default = HolderOutlined;

// ../../node_modules/@ant-design/icons/es/icons/HolderOutlined.js
var HolderOutlined2 = function HolderOutlined3(props, ref3) {
  return /* @__PURE__ */ React473.createElement(AntdIcon_default, _extends({}, props, {
    ref: ref3,
    icon: HolderOutlined_default
  }));
};
var RefIcon35 = /* @__PURE__ */ React473.forwardRef(HolderOutlined2);
if (true) {
  RefIcon35.displayName = "HolderOutlined";
}
var HolderOutlined_default2 = RefIcon35;

// ../../node_modules/antd/es/tree/Tree.js
var import_classnames192 = __toESM(require_classnames());

// ../../node_modules/antd/es/tree/style/directory.js
var genDirectoryStyle = ({
  treeCls,
  treeNodeCls,
  directoryNodeSelectedBg,
  directoryNodeSelectedColor,
  motionDurationMid,
  borderRadius,
  controlItemBgHover
}) => ({
  [`${treeCls}${treeCls}-directory ${treeNodeCls}`]: {
    // >>> Title
    [`${treeCls}-node-content-wrapper`]: {
      position: "static",
      [`&:has(${treeCls}-drop-indicator)`]: {
        position: "relative"
      },
      [`> *:not(${treeCls}-drop-indicator)`]: {
        position: "relative"
      },
      "&:hover": {
        background: "transparent"
      },
      // Expand interactive area to whole line
      "&:before": {
        position: "absolute",
        inset: 0,
        transition: `background-color ${motionDurationMid}`,
        content: '""',
        borderRadius
      },
      "&:hover:before": {
        background: controlItemBgHover
      }
    },
    [`${treeCls}-switcher, ${treeCls}-checkbox, ${treeCls}-draggable-icon`]: {
      zIndex: 1
    },
    // ============= Selected =============
    "&-selected": {
      background: directoryNodeSelectedBg,
      borderRadius,
      [`${treeCls}-switcher, ${treeCls}-draggable-icon`]: {
        color: directoryNodeSelectedColor
      },
      // >>> Title
      [`${treeCls}-node-content-wrapper`]: {
        color: directoryNodeSelectedColor,
        background: "transparent",
        "&, &:hover": {
          color: directoryNodeSelectedColor
        },
        "&:before, &:hover:before": {
          background: directoryNodeSelectedBg
        }
      }
    }
  }
});

// ../../node_modules/antd/es/tree/style/index.js
var treeNodeFX = new Keyframes_default("ant-tree-node-fx-do-not-use", {
  "0%": {
    opacity: 0
  },
  "100%": {
    opacity: 1
  }
});
var getSwitchStyle = (prefixCls, token2) => ({
  [`.${prefixCls}-switcher-icon`]: {
    display: "inline-block",
    fontSize: 10,
    verticalAlign: "baseline",
    svg: {
      transition: `transform ${token2.motionDurationSlow}`
    }
  }
});
var getDropIndicatorStyle = (prefixCls, token2) => ({
  [`.${prefixCls}-drop-indicator`]: {
    position: "absolute",
    // it should displayed over the following node
    zIndex: 1,
    height: 2,
    backgroundColor: token2.colorPrimary,
    borderRadius: 1,
    pointerEvents: "none",
    "&:after": {
      position: "absolute",
      top: -3,
      insetInlineStart: -6,
      width: 8,
      height: 8,
      backgroundColor: "transparent",
      border: `${unit(token2.lineWidthBold)} solid ${token2.colorPrimary}`,
      borderRadius: "50%",
      content: '""'
    }
  }
});
var genBaseStyle11 = (prefixCls, token2) => {
  const {
    treeCls,
    treeNodeCls,
    treeNodePadding,
    titleHeight,
    indentSize,
    nodeSelectedBg,
    nodeHoverBg,
    colorTextQuaternary,
    controlItemBgActiveDisabled
  } = token2;
  return {
    [treeCls]: Object.assign(Object.assign({}, resetComponent(token2)), {
      // fix https://github.com/ant-design/ant-design/issues/50316
      ["--rc-virtual-list-scrollbar-bg"]: token2.colorSplit,
      background: token2.colorBgContainer,
      borderRadius: token2.borderRadius,
      transition: `background-color ${token2.motionDurationSlow}`,
      "&-rtl": {
        direction: "rtl"
      },
      [`&${treeCls}-rtl ${treeCls}-switcher_close ${treeCls}-switcher-icon svg`]: {
        transform: "rotate(90deg)"
      },
      [`&-focused:not(:hover):not(${treeCls}-active-focused)`]: genFocusOutline(token2),
      // =================== Virtual List ===================
      [`${treeCls}-list-holder-inner`]: {
        alignItems: "flex-start"
      },
      [`&${treeCls}-block-node`]: {
        [`${treeCls}-list-holder-inner`]: {
          alignItems: "stretch",
          // >>> Title
          [`${treeCls}-node-content-wrapper`]: {
            flex: "auto"
          },
          // >>> Drag
          [`${treeNodeCls}.dragging:after`]: {
            position: "absolute",
            inset: 0,
            border: `1px solid ${token2.colorPrimary}`,
            opacity: 0,
            animationName: treeNodeFX,
            animationDuration: token2.motionDurationSlow,
            animationPlayState: "running",
            animationFillMode: "forwards",
            content: '""',
            pointerEvents: "none",
            borderRadius: token2.borderRadius
          }
        }
      },
      // ===================== TreeNode =====================
      [treeNodeCls]: {
        display: "flex",
        alignItems: "flex-start",
        marginBottom: treeNodePadding,
        lineHeight: unit(titleHeight),
        position: "relative",
        // 非常重要，避免 drop-indicator 在拖拽过程中闪烁
        "&:before": {
          content: '""',
          position: "absolute",
          zIndex: 1,
          insetInlineStart: 0,
          width: "100%",
          top: "100%",
          height: treeNodePadding
        },
        // Disabled
        [`&-disabled ${treeCls}-node-content-wrapper`]: {
          color: token2.colorTextDisabled,
          cursor: "not-allowed",
          "&:hover": {
            background: "transparent"
          }
        },
        [`${treeCls}-checkbox-disabled + ${treeCls}-node-selected,&${treeNodeCls}-disabled${treeNodeCls}-selected ${treeCls}-node-content-wrapper`]: {
          backgroundColor: controlItemBgActiveDisabled
        },
        // we can not set pointer-events to none for checkbox in tree
        // ref: https://github.com/ant-design/ant-design/issues/39822#issuecomment-2605234058
        [`${treeCls}-checkbox-disabled`]: {
          pointerEvents: "unset"
        },
        // not disable
        [`&:not(${treeNodeCls}-disabled)`]: {
          // >>> Title
          [`${treeCls}-node-content-wrapper`]: {
            "&:hover": {
              color: token2.nodeHoverColor
            }
          }
        },
        [`&-active ${treeCls}-node-content-wrapper`]: {
          background: token2.controlItemBgHover
        },
        [`&:not(${treeNodeCls}-disabled).filter-node ${treeCls}-title`]: {
          color: token2.colorPrimary,
          fontWeight: token2.fontWeightStrong
        },
        "&-draggable": {
          cursor: "grab",
          [`${treeCls}-draggable-icon`]: {
            // https://github.com/ant-design/ant-design/issues/41915
            flexShrink: 0,
            width: titleHeight,
            textAlign: "center",
            visibility: "visible",
            color: colorTextQuaternary
          },
          [`&${treeNodeCls}-disabled ${treeCls}-draggable-icon`]: {
            visibility: "hidden"
          }
        }
      },
      // >>> Indent
      [`${treeCls}-indent`]: {
        alignSelf: "stretch",
        whiteSpace: "nowrap",
        userSelect: "none",
        "&-unit": {
          display: "inline-block",
          width: indentSize
        }
      },
      // >>> Drag Handler
      [`${treeCls}-draggable-icon`]: {
        visibility: "hidden"
      },
      // Switcher / Checkbox
      [`${treeCls}-switcher, ${treeCls}-checkbox`]: {
        marginInlineEnd: token2.calc(token2.calc(titleHeight).sub(token2.controlInteractiveSize)).div(2).equal()
      },
      // >>> Switcher
      [`${treeCls}-switcher`]: Object.assign(Object.assign({}, getSwitchStyle(prefixCls, token2)), {
        position: "relative",
        flex: "none",
        alignSelf: "stretch",
        width: titleHeight,
        textAlign: "center",
        cursor: "pointer",
        userSelect: "none",
        transition: `all ${token2.motionDurationSlow}`,
        "&-noop": {
          cursor: "unset"
        },
        "&:before": {
          pointerEvents: "none",
          content: '""',
          width: titleHeight,
          height: titleHeight,
          position: "absolute",
          left: {
            _skip_check_: true,
            value: 0
          },
          top: 0,
          borderRadius: token2.borderRadius,
          transition: `all ${token2.motionDurationSlow}`
        },
        [`&:not(${treeCls}-switcher-noop):hover:before`]: {
          backgroundColor: token2.colorBgTextHover
        },
        [`&_close ${treeCls}-switcher-icon svg`]: {
          transform: "rotate(-90deg)"
        },
        "&-loading-icon": {
          color: token2.colorPrimary
        },
        "&-leaf-line": {
          position: "relative",
          zIndex: 1,
          display: "inline-block",
          width: "100%",
          height: "100%",
          // https://github.com/ant-design/ant-design/issues/31884
          "&:before": {
            position: "absolute",
            top: 0,
            insetInlineEnd: token2.calc(titleHeight).div(2).equal(),
            bottom: token2.calc(treeNodePadding).mul(-1).equal(),
            marginInlineStart: -1,
            borderInlineEnd: `1px solid ${token2.colorBorder}`,
            content: '""'
          },
          "&:after": {
            position: "absolute",
            width: token2.calc(token2.calc(titleHeight).div(2).equal()).mul(0.8).equal(),
            height: token2.calc(titleHeight).div(2).equal(),
            borderBottom: `1px solid ${token2.colorBorder}`,
            content: '""'
          }
        }
      }),
      // >>> Title
      // add `${treeCls}-checkbox + span` to cover checkbox `${checkboxCls} + span`
      [`${treeCls}-node-content-wrapper`]: Object.assign(Object.assign({
        position: "relative",
        minHeight: titleHeight,
        paddingBlock: 0,
        paddingInline: token2.paddingXS,
        background: "transparent",
        borderRadius: token2.borderRadius,
        cursor: "pointer",
        transition: `all ${token2.motionDurationMid}, border 0s, line-height 0s, box-shadow 0s`
      }, getDropIndicatorStyle(prefixCls, token2)), {
        "&:hover": {
          backgroundColor: nodeHoverBg
        },
        [`&${treeCls}-node-selected`]: {
          color: token2.nodeSelectedColor,
          backgroundColor: nodeSelectedBg
        },
        // Icon
        [`${treeCls}-iconEle`]: {
          display: "inline-block",
          width: titleHeight,
          height: titleHeight,
          textAlign: "center",
          verticalAlign: "top",
          "&:empty": {
            display: "none"
          }
        }
      }),
      // https://github.com/ant-design/ant-design/issues/28217
      [`${treeCls}-unselectable ${treeCls}-node-content-wrapper:hover`]: {
        backgroundColor: "transparent"
      },
      [`${treeNodeCls}.drop-container > [draggable]`]: {
        boxShadow: `0 0 0 2px ${token2.colorPrimary}`
      },
      // ==================== Show Line =====================
      "&-show-line": {
        // ================ Indent lines ================
        [`${treeCls}-indent-unit`]: {
          position: "relative",
          height: "100%",
          "&:before": {
            position: "absolute",
            top: 0,
            insetInlineEnd: token2.calc(titleHeight).div(2).equal(),
            bottom: token2.calc(treeNodePadding).mul(-1).equal(),
            borderInlineEnd: `1px solid ${token2.colorBorder}`,
            content: '""'
          },
          "&-end:before": {
            display: "none"
          }
        },
        // ============== Cover Background ==============
        [`${treeCls}-switcher`]: {
          background: "transparent",
          "&-line-icon": {
            // https://github.com/ant-design/ant-design/issues/32813
            verticalAlign: "-0.15em"
          }
        }
      },
      [`${treeNodeCls}-leaf-last ${treeCls}-switcher-leaf-line:before`]: {
        top: "auto !important",
        bottom: "auto !important",
        height: `${unit(token2.calc(titleHeight).div(2).equal())} !important`
      }
    })
  };
};
var genTreeStyle = (prefixCls, token2, enableDirectory = true) => {
  const treeCls = `.${prefixCls}`;
  const treeNodeCls = `${treeCls}-treenode`;
  const treeNodePadding = token2.calc(token2.paddingXS).div(2).equal();
  const treeToken = merge2(token2, {
    treeCls,
    treeNodeCls,
    treeNodePadding
  });
  return [
    // Basic
    genBaseStyle11(prefixCls, treeToken),
    // Directory
    enableDirectory && genDirectoryStyle(treeToken)
  ].filter(Boolean);
};
var initComponentToken2 = (token2) => {
  const {
    controlHeightSM,
    controlItemBgHover,
    controlItemBgActive
  } = token2;
  const titleHeight = controlHeightSM;
  return {
    titleHeight,
    indentSize: titleHeight,
    nodeHoverBg: controlItemBgHover,
    nodeHoverColor: token2.colorText,
    nodeSelectedBg: controlItemBgActive,
    nodeSelectedColor: token2.colorText
  };
};
var prepareComponentToken30 = (token2) => {
  const {
    colorTextLightSolid,
    colorPrimary
  } = token2;
  return Object.assign(Object.assign({}, initComponentToken2(token2)), {
    directoryNodeSelectedColor: colorTextLightSolid,
    directoryNodeSelectedBg: colorPrimary
  });
};
var style_default35 = genStyleHooks("Tree", (token2, {
  prefixCls
}) => [{
  [token2.componentCls]: getStyle2(`${prefixCls}-checkbox`, token2)
}, genTreeStyle(prefixCls, token2), collapse_default(token2)], prepareComponentToken30);

// ../../node_modules/antd/es/tree/utils/dropIndicator.js
var import_react147 = __toESM(require_react());
var offset3 = 4;
function dropIndicatorRender(props) {
  const {
    dropPosition,
    dropLevelOffset,
    prefixCls,
    indent,
    direction = "ltr"
  } = props;
  const startPosition = direction === "ltr" ? "left" : "right";
  const endPosition = direction === "ltr" ? "right" : "left";
  const style2 = {
    [startPosition]: -dropLevelOffset * indent + offset3,
    [endPosition]: 0
  };
  switch (dropPosition) {
    case -1:
      style2.top = -3;
      break;
    case 1:
      style2.bottom = -3;
      break;
    default:
      style2.bottom = -3;
      style2[startPosition] = indent + offset3;
      break;
  }
  return /* @__PURE__ */ import_react147.default.createElement("div", {
    style: style2,
    className: `${prefixCls}-drop-indicator`
  });
}
var dropIndicator_default = dropIndicatorRender;

// ../../node_modules/antd/es/tree/utils/iconUtil.js
var React478 = __toESM(require_react());

// ../../node_modules/@ant-design/icons/es/icons/CaretDownFilled.js
var React475 = __toESM(require_react());

// ../../node_modules/@ant-design/icons-svg/es/asn/CaretDownFilled.js
var CaretDownFilled = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z" } }] }, "name": "caret-down", "theme": "filled" };
var CaretDownFilled_default = CaretDownFilled;

// ../../node_modules/@ant-design/icons/es/icons/CaretDownFilled.js
var CaretDownFilled2 = function CaretDownFilled3(props, ref3) {
  return /* @__PURE__ */ React475.createElement(AntdIcon_default, _extends({}, props, {
    ref: ref3,
    icon: CaretDownFilled_default
  }));
};
var RefIcon36 = /* @__PURE__ */ React475.forwardRef(CaretDownFilled2);
if (true) {
  RefIcon36.displayName = "CaretDownFilled";
}
var CaretDownFilled_default2 = RefIcon36;

// ../../node_modules/@ant-design/icons/es/icons/MinusSquareOutlined.js
var React476 = __toESM(require_react());

// ../../node_modules/@ant-design/icons-svg/es/asn/MinusSquareOutlined.js
var MinusSquareOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M328 544h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z" } }, { "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }] }, "name": "minus-square", "theme": "outlined" };
var MinusSquareOutlined_default = MinusSquareOutlined;

// ../../node_modules/@ant-design/icons/es/icons/MinusSquareOutlined.js
var MinusSquareOutlined2 = function MinusSquareOutlined3(props, ref3) {
  return /* @__PURE__ */ React476.createElement(AntdIcon_default, _extends({}, props, {
    ref: ref3,
    icon: MinusSquareOutlined_default
  }));
};
var RefIcon37 = /* @__PURE__ */ React476.forwardRef(MinusSquareOutlined2);
if (true) {
  RefIcon37.displayName = "MinusSquareOutlined";
}
var MinusSquareOutlined_default2 = RefIcon37;

// ../../node_modules/@ant-design/icons/es/icons/PlusSquareOutlined.js
var React477 = __toESM(require_react());

// ../../node_modules/@ant-design/icons-svg/es/asn/PlusSquareOutlined.js
var PlusSquareOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M328 544h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z" } }, { "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }] }, "name": "plus-square", "theme": "outlined" };
var PlusSquareOutlined_default = PlusSquareOutlined;

// ../../node_modules/@ant-design/icons/es/icons/PlusSquareOutlined.js
var PlusSquareOutlined2 = function PlusSquareOutlined3(props, ref3) {
  return /* @__PURE__ */ React477.createElement(AntdIcon_default, _extends({}, props, {
    ref: ref3,
    icon: PlusSquareOutlined_default
  }));
};
var RefIcon38 = /* @__PURE__ */ React477.forwardRef(PlusSquareOutlined2);
if (true) {
  RefIcon38.displayName = "PlusSquareOutlined";
}
var PlusSquareOutlined_default2 = RefIcon38;

// ../../node_modules/antd/es/tree/utils/iconUtil.js
var import_classnames191 = __toESM(require_classnames());
var SwitcherIconCom = (props) => {
  var _a, _b;
  const {
    prefixCls,
    switcherIcon,
    treeNodeProps,
    showLine,
    switcherLoadingIcon
  } = props;
  const {
    isLeaf,
    expanded,
    loading
  } = treeNodeProps;
  if (loading) {
    if (/* @__PURE__ */ React478.isValidElement(switcherLoadingIcon)) {
      return switcherLoadingIcon;
    }
    return /* @__PURE__ */ React478.createElement(LoadingOutlined_default2, {
      className: `${prefixCls}-switcher-loading-icon`
    });
  }
  let showLeafIcon;
  if (showLine && typeof showLine === "object") {
    showLeafIcon = showLine.showLeafIcon;
  }
  if (isLeaf) {
    if (!showLine) {
      return null;
    }
    if (typeof showLeafIcon !== "boolean" && !!showLeafIcon) {
      const leafIcon = typeof showLeafIcon === "function" ? showLeafIcon(treeNodeProps) : showLeafIcon;
      const leafCls = `${prefixCls}-switcher-line-custom-icon`;
      if (/* @__PURE__ */ React478.isValidElement(leafIcon)) {
        return cloneElement4(leafIcon, {
          className: (0, import_classnames191.default)((_a = leafIcon.props) === null || _a === void 0 ? void 0 : _a.className, leafCls)
        });
      }
      return leafIcon;
    }
    return showLeafIcon ? /* @__PURE__ */ React478.createElement(FileOutlined_default2, {
      className: `${prefixCls}-switcher-line-icon`
    }) : /* @__PURE__ */ React478.createElement("span", {
      className: `${prefixCls}-switcher-leaf-line`
    });
  }
  const switcherCls = `${prefixCls}-switcher-icon`;
  const switcher = typeof switcherIcon === "function" ? switcherIcon(treeNodeProps) : switcherIcon;
  if (/* @__PURE__ */ React478.isValidElement(switcher)) {
    return cloneElement4(switcher, {
      className: (0, import_classnames191.default)((_b = switcher.props) === null || _b === void 0 ? void 0 : _b.className, switcherCls)
    });
  }
  if (switcher !== void 0) {
    return switcher;
  }
  if (showLine) {
    return expanded ? /* @__PURE__ */ React478.createElement(MinusSquareOutlined_default2, {
      className: `${prefixCls}-switcher-line-icon`
    }) : /* @__PURE__ */ React478.createElement(PlusSquareOutlined_default2, {
      className: `${prefixCls}-switcher-line-icon`
    });
  }
  return /* @__PURE__ */ React478.createElement(CaretDownFilled_default2, {
    className: switcherCls
  });
};
var iconUtil_default = SwitcherIconCom;

// ../../node_modules/antd/es/tree/Tree.js
var Tree2 = /* @__PURE__ */ import_react148.default.forwardRef((props, ref3) => {
  var _a;
  const {
    getPrefixCls,
    direction,
    virtual,
    tree
  } = import_react148.default.useContext(ConfigContext);
  const {
    prefixCls: customizePrefixCls,
    className: className2,
    showIcon = false,
    showLine,
    switcherIcon,
    switcherLoadingIcon,
    blockNode = false,
    children,
    checkable = false,
    selectable = true,
    draggable,
    motion: customMotion,
    style: style2
  } = props;
  const prefixCls = getPrefixCls("tree", customizePrefixCls);
  const rootPrefixCls = getPrefixCls();
  const motion2 = customMotion !== null && customMotion !== void 0 ? customMotion : Object.assign(Object.assign({}, motion_default(rootPrefixCls)), {
    motionAppear: false
  });
  const newProps = Object.assign(Object.assign({}, props), {
    checkable,
    selectable,
    showIcon,
    motion: motion2,
    blockNode,
    showLine: Boolean(showLine),
    dropIndicatorRender: dropIndicator_default
  });
  const [wrapCSSVar, hashId, cssVarCls] = style_default35(prefixCls);
  const [, token2] = useToken();
  const itemHeight = token2.paddingXS / 2 + (((_a = token2.Tree) === null || _a === void 0 ? void 0 : _a.titleHeight) || token2.controlHeightSM);
  const draggableConfig = import_react148.default.useMemo(() => {
    if (!draggable) {
      return false;
    }
    let mergedDraggable = {};
    switch (typeof draggable) {
      case "function":
        mergedDraggable.nodeDraggable = draggable;
        break;
      case "object":
        mergedDraggable = Object.assign({}, draggable);
        break;
      default:
        break;
    }
    if (mergedDraggable.icon !== false) {
      mergedDraggable.icon = mergedDraggable.icon || /* @__PURE__ */ import_react148.default.createElement(HolderOutlined_default2, null);
    }
    return mergedDraggable;
  }, [draggable]);
  const renderSwitcherIcon = (nodeProps) => /* @__PURE__ */ import_react148.default.createElement(iconUtil_default, {
    prefixCls,
    switcherIcon,
    switcherLoadingIcon,
    treeNodeProps: nodeProps,
    showLine
  });
  return wrapCSSVar(
    // @ts-ignore
    /* @__PURE__ */ import_react148.default.createElement(es_default27, Object.assign({
      itemHeight,
      ref: ref3,
      virtual
    }, newProps, {
      // newProps may contain style so declare style below it
      style: Object.assign(Object.assign({}, tree === null || tree === void 0 ? void 0 : tree.style), style2),
      prefixCls,
      className: (0, import_classnames192.default)({
        [`${prefixCls}-icon-hide`]: !showIcon,
        [`${prefixCls}-block-node`]: blockNode,
        [`${prefixCls}-unselectable`]: !selectable,
        [`${prefixCls}-rtl`]: direction === "rtl"
      }, tree === null || tree === void 0 ? void 0 : tree.className, className2, hashId, cssVarCls),
      direction,
      checkable: checkable ? /* @__PURE__ */ import_react148.default.createElement("span", {
        className: `${prefixCls}-checkbox-inner`
      }) : checkable,
      selectable,
      switcherIcon: renderSwitcherIcon,
      draggable: draggableConfig
    }), children)
  );
});
if (true) {
  Tree2.displayName = "Tree";
}
var Tree_default2 = Tree2;

// ../../node_modules/antd/es/tree/utils/dictUtil.js
var RECORD_NONE = 0;
var RECORD_START = 1;
var RECORD_END = 2;
function traverseNodesKey(treeData, callback, fieldNames) {
  const {
    key: fieldKey,
    children: fieldChildren
  } = fieldNames;
  function processNode(dataNode) {
    const key2 = dataNode[fieldKey];
    const children = dataNode[fieldChildren];
    if (callback(key2, dataNode) !== false) {
      traverseNodesKey(children || [], callback, fieldNames);
    }
  }
  treeData.forEach(processNode);
}
function calcRangeKeys({
  treeData,
  expandedKeys,
  startKey,
  endKey,
  fieldNames
}) {
  const keys4 = [];
  let record = RECORD_NONE;
  if (startKey && startKey === endKey) {
    return [startKey];
  }
  if (!startKey || !endKey) {
    return [];
  }
  function matchKey(key2) {
    return key2 === startKey || key2 === endKey;
  }
  traverseNodesKey(treeData, (key2) => {
    if (record === RECORD_END) {
      return false;
    }
    if (matchKey(key2)) {
      keys4.push(key2);
      if (record === RECORD_NONE) {
        record = RECORD_START;
      } else if (record === RECORD_START) {
        record = RECORD_END;
        return false;
      }
    } else if (record === RECORD_START) {
      keys4.push(key2);
    }
    return expandedKeys.includes(key2);
  }, fillFieldNames2(fieldNames));
  return keys4;
}
function convertDirectoryKeysToNodes(treeData, keys4, fieldNames) {
  const restKeys = _toConsumableArray(keys4);
  const nodes = [];
  traverseNodesKey(treeData, (key2, node2) => {
    const index3 = restKeys.indexOf(key2);
    if (index3 !== -1) {
      nodes.push(node2);
      restKeys.splice(index3, 1);
    }
    return !!restKeys.length;
  }, fillFieldNames2(fieldNames));
  return nodes;
}

// ../../node_modules/antd/es/tree/DirectoryTree.js
var __rest62 = function(s, e3) {
  var t2 = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e3.indexOf(p) < 0) t2[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e3.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t2[p[i]] = s[p[i]];
  }
  return t2;
};
function getIcon(props) {
  const {
    isLeaf,
    expanded
  } = props;
  if (isLeaf) {
    return /* @__PURE__ */ React480.createElement(FileOutlined_default2, null);
  }
  return expanded ? /* @__PURE__ */ React480.createElement(FolderOpenOutlined_default2, null) : /* @__PURE__ */ React480.createElement(FolderOutlined_default2, null);
}
function getTreeData({
  treeData,
  children
}) {
  return treeData || convertTreeToData(children);
}
var DirectoryTree = (_a, ref3) => {
  var {
    defaultExpandAll,
    defaultExpandParent,
    defaultExpandedKeys
  } = _a, props = __rest62(_a, ["defaultExpandAll", "defaultExpandParent", "defaultExpandedKeys"]);
  const lastSelectedKey = React480.useRef(null);
  const cachedSelectedKeys = React480.useRef(null);
  const getInitExpandedKeys = () => {
    const {
      keyEntities
    } = convertDataToEntities(getTreeData(props));
    let initExpandedKeys;
    if (defaultExpandAll) {
      initExpandedKeys = Object.keys(keyEntities);
    } else if (defaultExpandParent) {
      initExpandedKeys = conductExpandParent(props.expandedKeys || defaultExpandedKeys || [], keyEntities);
    } else {
      initExpandedKeys = props.expandedKeys || defaultExpandedKeys || [];
    }
    return initExpandedKeys;
  };
  const [selectedKeys, setSelectedKeys] = React480.useState(props.selectedKeys || props.defaultSelectedKeys || []);
  const [expandedKeys, setExpandedKeys] = React480.useState(() => getInitExpandedKeys());
  React480.useEffect(() => {
    if ("selectedKeys" in props) {
      setSelectedKeys(props.selectedKeys);
    }
  }, [props.selectedKeys]);
  React480.useEffect(() => {
    if ("expandedKeys" in props) {
      setExpandedKeys(props.expandedKeys);
    }
  }, [props.expandedKeys]);
  const onExpand = (keys4, info) => {
    var _a2;
    if (!("expandedKeys" in props)) {
      setExpandedKeys(keys4);
    }
    return (_a2 = props.onExpand) === null || _a2 === void 0 ? void 0 : _a2.call(props, keys4, info);
  };
  const onSelect = (keys4, event) => {
    var _a2;
    const {
      multiple,
      fieldNames
    } = props;
    const {
      node: node2,
      nativeEvent
    } = event;
    const {
      key: key2 = ""
    } = node2;
    const treeData = getTreeData(props);
    const newEvent = Object.assign(Object.assign({}, event), {
      selected: true
    });
    const ctrlPick = (nativeEvent === null || nativeEvent === void 0 ? void 0 : nativeEvent.ctrlKey) || (nativeEvent === null || nativeEvent === void 0 ? void 0 : nativeEvent.metaKey);
    const shiftPick = nativeEvent === null || nativeEvent === void 0 ? void 0 : nativeEvent.shiftKey;
    let newSelectedKeys;
    if (multiple && ctrlPick) {
      newSelectedKeys = keys4;
      lastSelectedKey.current = key2;
      cachedSelectedKeys.current = newSelectedKeys;
      newEvent.selectedNodes = convertDirectoryKeysToNodes(treeData, newSelectedKeys, fieldNames);
    } else if (multiple && shiftPick) {
      newSelectedKeys = Array.from(new Set([].concat(_toConsumableArray(cachedSelectedKeys.current || []), _toConsumableArray(calcRangeKeys({
        treeData,
        expandedKeys,
        startKey: key2,
        endKey: lastSelectedKey.current,
        fieldNames
      })))));
      newEvent.selectedNodes = convertDirectoryKeysToNodes(treeData, newSelectedKeys, fieldNames);
    } else {
      newSelectedKeys = [key2];
      lastSelectedKey.current = key2;
      cachedSelectedKeys.current = newSelectedKeys;
      newEvent.selectedNodes = convertDirectoryKeysToNodes(treeData, newSelectedKeys, fieldNames);
    }
    (_a2 = props.onSelect) === null || _a2 === void 0 ? void 0 : _a2.call(props, newSelectedKeys, newEvent);
    if (!("selectedKeys" in props)) {
      setSelectedKeys(newSelectedKeys);
    }
  };
  const {
    getPrefixCls,
    direction
  } = React480.useContext(ConfigContext);
  const {
    prefixCls: customizePrefixCls,
    className: className2,
    showIcon = true,
    expandAction = "click"
  } = props, otherProps = __rest62(props, ["prefixCls", "className", "showIcon", "expandAction"]);
  const prefixCls = getPrefixCls("tree", customizePrefixCls);
  const connectClassName = (0, import_classnames193.default)(`${prefixCls}-directory`, {
    [`${prefixCls}-directory-rtl`]: direction === "rtl"
  }, className2);
  return /* @__PURE__ */ React480.createElement(Tree_default2, Object.assign({
    icon: getIcon,
    ref: ref3,
    blockNode: true
  }, otherProps, {
    showIcon,
    expandAction,
    prefixCls,
    className: connectClassName,
    expandedKeys,
    selectedKeys,
    onSelect,
    onExpand
  }));
};
var ForwardDirectoryTree = /* @__PURE__ */ React480.forwardRef(DirectoryTree);
if (true) {
  ForwardDirectoryTree.displayName = "DirectoryTree";
}
var DirectoryTree_default = ForwardDirectoryTree;

// ../../node_modules/antd/es/tree/index.js
var Tree3 = Tree_default2;
Tree3.DirectoryTree = DirectoryTree_default;
Tree3.TreeNode = TreeNode_default;
var tree_default = Tree3;

// ../../node_modules/antd/es/table/hooks/useFilter/FilterSearch.js
var React481 = __toESM(require_react());
var FilterSearch = (props) => {
  const {
    value,
    filterSearch,
    tablePrefixCls,
    locale: locale6,
    onChange
  } = props;
  if (!filterSearch) {
    return null;
  }
  return /* @__PURE__ */ React481.createElement("div", {
    className: `${tablePrefixCls}-filter-dropdown-search`
  }, /* @__PURE__ */ React481.createElement(Input_default5, {
    prefix: /* @__PURE__ */ React481.createElement(SearchOutlined_default2, null),
    placeholder: locale6.filterSearchPlaceholder,
    onChange,
    value,
    // for skip min-width of input
    htmlSize: 1,
    className: `${tablePrefixCls}-filter-dropdown-search-input`
  }));
};
var FilterSearch_default = FilterSearch;

// ../../node_modules/antd/es/table/hooks/useFilter/FilterWrapper.js
var React482 = __toESM(require_react());
var onKeyDown = (event) => {
  const {
    keyCode
  } = event;
  if (keyCode === KeyCode_default.ENTER) {
    event.stopPropagation();
  }
};
var FilterDropdownMenuWrapper = /* @__PURE__ */ React482.forwardRef((props, ref3) => /* @__PURE__ */ React482.createElement("div", {
  className: props.className,
  onClick: (e3) => e3.stopPropagation(),
  onKeyDown,
  ref: ref3
}, props.children));
if (true) {
  FilterDropdownMenuWrapper.displayName = "FilterDropdownMenuWrapper";
}
var FilterWrapper_default = FilterDropdownMenuWrapper;

// ../../node_modules/antd/es/table/hooks/useFilter/FilterDropdown.js
function flattenKeys(filters) {
  let keys4 = [];
  (filters || []).forEach(({
    value,
    children
  }) => {
    keys4.push(value);
    if (children) {
      keys4 = [].concat(_toConsumableArray(keys4), _toConsumableArray(flattenKeys(children)));
    }
  });
  return keys4;
}
function hasSubMenu(filters) {
  return filters.some(({
    children
  }) => children);
}
function searchValueMatched(searchValue, text) {
  if (typeof text === "string" || typeof text === "number") {
    return text === null || text === void 0 ? void 0 : text.toString().toLowerCase().includes(searchValue.trim().toLowerCase());
  }
  return false;
}
function renderFilterItems({
  filters,
  prefixCls,
  filteredKeys,
  filterMultiple,
  searchValue,
  filterSearch
}) {
  return filters.map((filter3, index3) => {
    const key2 = String(filter3.value);
    if (filter3.children) {
      return {
        key: key2 || index3,
        label: filter3.text,
        popupClassName: `${prefixCls}-dropdown-submenu`,
        children: renderFilterItems({
          filters: filter3.children,
          prefixCls,
          filteredKeys,
          filterMultiple,
          searchValue,
          filterSearch
        })
      };
    }
    const Component10 = filterMultiple ? checkbox_default : radio_default2;
    const item = {
      key: filter3.value !== void 0 ? key2 : index3,
      label: /* @__PURE__ */ React483.createElement(React483.Fragment, null, /* @__PURE__ */ React483.createElement(Component10, {
        checked: filteredKeys.includes(key2)
      }), /* @__PURE__ */ React483.createElement("span", null, filter3.text))
    };
    if (searchValue.trim()) {
      if (typeof filterSearch === "function") {
        return filterSearch(searchValue, filter3) ? item : null;
      }
      return searchValueMatched(searchValue, filter3.text) ? item : null;
    }
    return item;
  });
}
function wrapStringListType(keys4) {
  return keys4 || [];
}
var FilterDropdown = (props) => {
  var _a, _b, _c, _d;
  const {
    tablePrefixCls,
    prefixCls,
    column: column2,
    dropdownPrefixCls,
    columnKey,
    filterOnClose,
    filterMultiple,
    filterMode = "menu",
    filterSearch = false,
    filterState,
    triggerFilter,
    locale: locale6,
    children,
    getPopupContainer,
    rootClassName
  } = props;
  const {
    filterResetToDefaultFilteredValue,
    defaultFilteredValue,
    filterDropdownProps = {},
    // Deprecated
    filterDropdownOpen,
    filterDropdownVisible,
    onFilterDropdownVisibleChange,
    onFilterDropdownOpenChange
  } = column2;
  const [visible, setVisible] = React483.useState(false);
  const filtered = !!(filterState && (((_a = filterState.filteredKeys) === null || _a === void 0 ? void 0 : _a.length) || filterState.forceFiltered));
  const triggerVisible = (newVisible) => {
    var _a2;
    setVisible(newVisible);
    (_a2 = filterDropdownProps.onOpenChange) === null || _a2 === void 0 ? void 0 : _a2.call(filterDropdownProps, newVisible);
    onFilterDropdownOpenChange === null || onFilterDropdownOpenChange === void 0 ? void 0 : onFilterDropdownOpenChange(newVisible);
    onFilterDropdownVisibleChange === null || onFilterDropdownVisibleChange === void 0 ? void 0 : onFilterDropdownVisibleChange(newVisible);
  };
  if (true) {
    const warning6 = devUseWarning("Table");
    const deprecatedList = [["filterDropdownOpen", "filterDropdownProps.open"], ["filterDropdownVisible", "filterDropdownProps.open"], ["onFilterDropdownOpenChange", "filterDropdownProps.onOpenChange"], ["onFilterDropdownVisibleChange", "filterDropdownProps.onOpenChange"]];
    deprecatedList.forEach(([deprecatedName, newName]) => {
      warning6.deprecated(!(deprecatedName in column2), deprecatedName, newName);
    });
    warning6.deprecated(!("filterCheckall" in locale6), "filterCheckall", "locale.filterCheckAll");
  }
  const mergedVisible = (_d = (_c = (_b = filterDropdownProps.open) !== null && _b !== void 0 ? _b : filterDropdownOpen) !== null && _c !== void 0 ? _c : filterDropdownVisible) !== null && _d !== void 0 ? _d : visible;
  const propFilteredKeys = filterState === null || filterState === void 0 ? void 0 : filterState.filteredKeys;
  const [getFilteredKeysSync, setFilteredKeysSync] = useSyncState4(wrapStringListType(propFilteredKeys));
  const onSelectKeys = ({
    selectedKeys
  }) => {
    setFilteredKeysSync(selectedKeys);
  };
  const onCheck = (keys4, {
    node: node2,
    checked
  }) => {
    if (!filterMultiple) {
      onSelectKeys({
        selectedKeys: checked && node2.key ? [node2.key] : []
      });
    } else {
      onSelectKeys({
        selectedKeys: keys4
      });
    }
  };
  React483.useEffect(() => {
    if (!visible) {
      return;
    }
    onSelectKeys({
      selectedKeys: wrapStringListType(propFilteredKeys)
    });
  }, [propFilteredKeys]);
  const [openKeys, setOpenKeys] = React483.useState([]);
  const onOpenChange = (keys4) => {
    setOpenKeys(keys4);
  };
  const [searchValue, setSearchValue] = React483.useState("");
  const onSearch = (e3) => {
    const {
      value
    } = e3.target;
    setSearchValue(value);
  };
  React483.useEffect(() => {
    if (!visible) {
      setSearchValue("");
    }
  }, [visible]);
  const internalTriggerFilter = (keys4) => {
    const mergedKeys = (keys4 === null || keys4 === void 0 ? void 0 : keys4.length) ? keys4 : null;
    if (mergedKeys === null && (!filterState || !filterState.filteredKeys)) {
      return null;
    }
    if (isEqual_default(mergedKeys, filterState === null || filterState === void 0 ? void 0 : filterState.filteredKeys, true)) {
      return null;
    }
    triggerFilter({
      column: column2,
      key: columnKey,
      filteredKeys: mergedKeys
    });
  };
  const onConfirm = () => {
    triggerVisible(false);
    internalTriggerFilter(getFilteredKeysSync());
  };
  const onReset = ({
    confirm,
    closeDropdown
  } = {
    confirm: false,
    closeDropdown: false
  }) => {
    if (confirm) {
      internalTriggerFilter([]);
    }
    if (closeDropdown) {
      triggerVisible(false);
    }
    setSearchValue("");
    if (filterResetToDefaultFilteredValue) {
      setFilteredKeysSync((defaultFilteredValue || []).map((key2) => String(key2)));
    } else {
      setFilteredKeysSync([]);
    }
  };
  const doFilter = ({
    closeDropdown
  } = {
    closeDropdown: true
  }) => {
    if (closeDropdown) {
      triggerVisible(false);
    }
    internalTriggerFilter(getFilteredKeysSync());
  };
  const onVisibleChange = (newVisible, info) => {
    if (info.source === "trigger") {
      if (newVisible && propFilteredKeys !== void 0) {
        setFilteredKeysSync(wrapStringListType(propFilteredKeys));
      }
      triggerVisible(newVisible);
      if (!newVisible && !column2.filterDropdown && filterOnClose) {
        onConfirm();
      }
    }
  };
  const dropdownMenuClass = (0, import_classnames194.default)({
    [`${dropdownPrefixCls}-menu-without-submenu`]: !hasSubMenu(column2.filters || [])
  });
  const onCheckAll = (e3) => {
    if (e3.target.checked) {
      const allFilterKeys = flattenKeys(column2 === null || column2 === void 0 ? void 0 : column2.filters).map((key2) => String(key2));
      setFilteredKeysSync(allFilterKeys);
    } else {
      setFilteredKeysSync([]);
    }
  };
  const getTreeData2 = ({
    filters
  }) => (filters || []).map((filter3, index3) => {
    const key2 = String(filter3.value);
    const item = {
      title: filter3.text,
      key: filter3.value !== void 0 ? key2 : String(index3)
    };
    if (filter3.children) {
      item.children = getTreeData2({
        filters: filter3.children
      });
    }
    return item;
  });
  const getFilterData2 = (node2) => {
    var _a2;
    return Object.assign(Object.assign({}, node2), {
      text: node2.title,
      value: node2.key,
      children: ((_a2 = node2.children) === null || _a2 === void 0 ? void 0 : _a2.map((item) => getFilterData2(item))) || []
    });
  };
  let dropdownContent;
  const {
    direction,
    renderEmpty
  } = React483.useContext(ConfigContext);
  if (typeof column2.filterDropdown === "function") {
    dropdownContent = column2.filterDropdown({
      prefixCls: `${dropdownPrefixCls}-custom`,
      setSelectedKeys: (selectedKeys) => onSelectKeys({
        selectedKeys
      }),
      selectedKeys: getFilteredKeysSync(),
      confirm: doFilter,
      clearFilters: onReset,
      filters: column2.filters,
      visible: mergedVisible,
      close: () => {
        triggerVisible(false);
      }
    });
  } else if (column2.filterDropdown) {
    dropdownContent = column2.filterDropdown;
  } else {
    const selectedKeys = getFilteredKeysSync() || [];
    const getFilterComponent = () => {
      var _a2, _b2;
      const empty3 = (_a2 = renderEmpty === null || renderEmpty === void 0 ? void 0 : renderEmpty("Table.filter")) !== null && _a2 !== void 0 ? _a2 : /* @__PURE__ */ React483.createElement(empty_default2, {
        image: empty_default2.PRESENTED_IMAGE_SIMPLE,
        description: locale6.filterEmptyText,
        styles: {
          image: {
            height: 24
          }
        },
        style: {
          margin: 0,
          padding: "16px 0"
        }
      });
      if ((column2.filters || []).length === 0) {
        return empty3;
      }
      if (filterMode === "tree") {
        return /* @__PURE__ */ React483.createElement(React483.Fragment, null, /* @__PURE__ */ React483.createElement(FilterSearch_default, {
          filterSearch,
          value: searchValue,
          onChange: onSearch,
          tablePrefixCls,
          locale: locale6
        }), /* @__PURE__ */ React483.createElement("div", {
          className: `${tablePrefixCls}-filter-dropdown-tree`
        }, filterMultiple ? /* @__PURE__ */ React483.createElement(checkbox_default, {
          checked: selectedKeys.length === flattenKeys(column2.filters).length,
          indeterminate: selectedKeys.length > 0 && selectedKeys.length < flattenKeys(column2.filters).length,
          className: `${tablePrefixCls}-filter-dropdown-checkall`,
          onChange: onCheckAll
        }, (_b2 = locale6 === null || locale6 === void 0 ? void 0 : locale6.filterCheckall) !== null && _b2 !== void 0 ? _b2 : locale6 === null || locale6 === void 0 ? void 0 : locale6.filterCheckAll) : null, /* @__PURE__ */ React483.createElement(tree_default, {
          checkable: true,
          selectable: false,
          blockNode: true,
          multiple: filterMultiple,
          checkStrictly: !filterMultiple,
          className: `${dropdownPrefixCls}-menu`,
          onCheck,
          checkedKeys: selectedKeys,
          selectedKeys,
          showIcon: false,
          treeData: getTreeData2({
            filters: column2.filters
          }),
          autoExpandParent: true,
          defaultExpandAll: true,
          filterTreeNode: searchValue.trim() ? (node2) => {
            if (typeof filterSearch === "function") {
              return filterSearch(searchValue, getFilterData2(node2));
            }
            return searchValueMatched(searchValue, node2.title);
          } : void 0
        })));
      }
      const items = renderFilterItems({
        filters: column2.filters || [],
        filterSearch,
        prefixCls,
        filteredKeys: getFilteredKeysSync(),
        filterMultiple,
        searchValue
      });
      const isEmpty2 = items.every((item) => item === null);
      return /* @__PURE__ */ React483.createElement(React483.Fragment, null, /* @__PURE__ */ React483.createElement(FilterSearch_default, {
        filterSearch,
        value: searchValue,
        onChange: onSearch,
        tablePrefixCls,
        locale: locale6
      }), isEmpty2 ? empty3 : /* @__PURE__ */ React483.createElement(menu_default2, {
        selectable: true,
        multiple: filterMultiple,
        prefixCls: `${dropdownPrefixCls}-menu`,
        className: dropdownMenuClass,
        onSelect: onSelectKeys,
        onDeselect: onSelectKeys,
        selectedKeys,
        getPopupContainer,
        openKeys,
        onOpenChange,
        items
      }));
    };
    const getResetDisabled = () => {
      if (filterResetToDefaultFilteredValue) {
        return isEqual_default((defaultFilteredValue || []).map((key2) => String(key2)), selectedKeys, true);
      }
      return selectedKeys.length === 0;
    };
    dropdownContent = /* @__PURE__ */ React483.createElement(React483.Fragment, null, getFilterComponent(), /* @__PURE__ */ React483.createElement("div", {
      className: `${prefixCls}-dropdown-btns`
    }, /* @__PURE__ */ React483.createElement(button_default2, {
      type: "link",
      size: "small",
      disabled: getResetDisabled(),
      onClick: () => onReset()
    }, locale6.filterReset), /* @__PURE__ */ React483.createElement(button_default2, {
      type: "primary",
      size: "small",
      onClick: onConfirm
    }, locale6.filterConfirm)));
  }
  if (column2.filterDropdown) {
    dropdownContent = /* @__PURE__ */ React483.createElement(OverrideProvider, {
      selectable: void 0
    }, dropdownContent);
  }
  dropdownContent = /* @__PURE__ */ React483.createElement(FilterWrapper_default, {
    className: `${prefixCls}-dropdown`
  }, dropdownContent);
  const getDropdownTrigger = () => {
    let filterIcon;
    if (typeof column2.filterIcon === "function") {
      filterIcon = column2.filterIcon(filtered);
    } else if (column2.filterIcon) {
      filterIcon = column2.filterIcon;
    } else {
      filterIcon = /* @__PURE__ */ React483.createElement(FilterFilled_default2, null);
    }
    return /* @__PURE__ */ React483.createElement("span", {
      role: "button",
      tabIndex: -1,
      className: (0, import_classnames194.default)(`${prefixCls}-trigger`, {
        active: filtered
      }),
      onClick: (e3) => {
        e3.stopPropagation();
      }
    }, filterIcon);
  };
  const mergedDropdownProps = extendsObject_default({
    trigger: ["click"],
    placement: direction === "rtl" ? "bottomLeft" : "bottomRight",
    children: getDropdownTrigger(),
    getPopupContainer
  }, Object.assign(Object.assign({}, filterDropdownProps), {
    rootClassName: (0, import_classnames194.default)(rootClassName, filterDropdownProps.rootClassName),
    open: mergedVisible,
    onOpenChange: onVisibleChange,
    popupRender: () => {
      if (typeof (filterDropdownProps === null || filterDropdownProps === void 0 ? void 0 : filterDropdownProps.dropdownRender) === "function") {
        return filterDropdownProps.dropdownRender(dropdownContent);
      }
      return dropdownContent;
    }
  }));
  return /* @__PURE__ */ React483.createElement("div", {
    className: `${prefixCls}-column`
  }, /* @__PURE__ */ React483.createElement("span", {
    className: `${tablePrefixCls}-column-title`
  }, children), /* @__PURE__ */ React483.createElement(dropdown_default3, Object.assign({}, mergedDropdownProps)));
};
var FilterDropdown_default = FilterDropdown;

// ../../node_modules/antd/es/table/hooks/useFilter/index.js
var collectFilterStates = (columns, init2, pos) => {
  let filterStates = [];
  (columns || []).forEach((column2, index3) => {
    var _a;
    const columnPos = getColumnPos(index3, pos);
    const filterDropdownIsDefined = column2.filterDropdown !== void 0;
    if (column2.filters || filterDropdownIsDefined || "onFilter" in column2) {
      if ("filteredValue" in column2) {
        let filteredValues = column2.filteredValue;
        if (!filterDropdownIsDefined) {
          filteredValues = (_a = filteredValues === null || filteredValues === void 0 ? void 0 : filteredValues.map(String)) !== null && _a !== void 0 ? _a : filteredValues;
        }
        filterStates.push({
          column: column2,
          key: getColumnKey(column2, columnPos),
          filteredKeys: filteredValues,
          forceFiltered: column2.filtered
        });
      } else {
        filterStates.push({
          column: column2,
          key: getColumnKey(column2, columnPos),
          filteredKeys: init2 && column2.defaultFilteredValue ? column2.defaultFilteredValue : void 0,
          forceFiltered: column2.filtered
        });
      }
    }
    if ("children" in column2) {
      filterStates = [].concat(_toConsumableArray(filterStates), _toConsumableArray(collectFilterStates(column2.children, init2, columnPos)));
    }
  });
  return filterStates;
};
function injectFilter(prefixCls, dropdownPrefixCls, columns, filterStates, locale6, triggerFilter, getPopupContainer, pos, rootClassName) {
  return columns.map((column2, index3) => {
    const columnPos = getColumnPos(index3, pos);
    const {
      filterOnClose = true,
      filterMultiple = true,
      filterMode,
      filterSearch
    } = column2;
    let newColumn = column2;
    if (newColumn.filters || newColumn.filterDropdown) {
      const columnKey = getColumnKey(newColumn, columnPos);
      const filterState = filterStates.find(({
        key: key2
      }) => columnKey === key2);
      newColumn = Object.assign(Object.assign({}, newColumn), {
        title: (renderProps) => /* @__PURE__ */ React484.createElement(FilterDropdown_default, {
          tablePrefixCls: prefixCls,
          prefixCls: `${prefixCls}-filter`,
          dropdownPrefixCls,
          column: newColumn,
          columnKey,
          filterState,
          filterOnClose,
          filterMultiple,
          filterMode,
          filterSearch,
          triggerFilter,
          locale: locale6,
          getPopupContainer,
          rootClassName
        }, renderColumnTitle(column2.title, renderProps))
      });
    }
    if ("children" in newColumn) {
      newColumn = Object.assign(Object.assign({}, newColumn), {
        children: injectFilter(prefixCls, dropdownPrefixCls, newColumn.children, filterStates, locale6, triggerFilter, getPopupContainer, columnPos, rootClassName)
      });
    }
    return newColumn;
  });
}
var generateFilterInfo = (filterStates) => {
  const currentFilters = {};
  filterStates.forEach(({
    key: key2,
    filteredKeys,
    column: column2
  }) => {
    const keyAsString = key2;
    const {
      filters,
      filterDropdown
    } = column2;
    if (filterDropdown) {
      currentFilters[keyAsString] = filteredKeys || null;
    } else if (Array.isArray(filteredKeys)) {
      const keys4 = flattenKeys(filters);
      currentFilters[keyAsString] = keys4.filter((originKey) => filteredKeys.includes(String(originKey)));
    } else {
      currentFilters[keyAsString] = null;
    }
  });
  return currentFilters;
};
var getFilterData = (data2, filterStates, childrenColumnName) => {
  const filterDatas = filterStates.reduce((currentData, filterState) => {
    const {
      column: {
        onFilter,
        filters
      },
      filteredKeys
    } = filterState;
    if (onFilter && filteredKeys && filteredKeys.length) {
      return currentData.map((record) => Object.assign({}, record)).filter((record) => filteredKeys.some((key2) => {
        const keys4 = flattenKeys(filters);
        const keyIndex2 = keys4.findIndex((k) => String(k) === String(key2));
        const realKey = keyIndex2 !== -1 ? keys4[keyIndex2] : key2;
        if (record[childrenColumnName]) {
          record[childrenColumnName] = getFilterData(record[childrenColumnName], filterStates, childrenColumnName);
        }
        return onFilter(realKey, record);
      }));
    }
    return currentData;
  }, data2);
  return filterDatas;
};
var getMergedColumns = (rawMergedColumns) => rawMergedColumns.flatMap((column2) => {
  if ("children" in column2) {
    return [column2].concat(_toConsumableArray(getMergedColumns(column2.children || [])));
  }
  return [column2];
});
var useFilter = (props) => {
  const {
    prefixCls,
    dropdownPrefixCls,
    mergedColumns: rawMergedColumns,
    onFilterChange,
    getPopupContainer,
    locale: tableLocale,
    rootClassName
  } = props;
  const warning6 = devUseWarning("Table");
  const mergedColumns = React484.useMemo(() => getMergedColumns(rawMergedColumns || []), [rawMergedColumns]);
  const [filterStates, setFilterStates] = React484.useState(() => collectFilterStates(mergedColumns, true));
  const mergedFilterStates = React484.useMemo(() => {
    const collectedStates = collectFilterStates(mergedColumns, false);
    if (collectedStates.length === 0) {
      return collectedStates;
    }
    let filteredKeysIsAllNotControlled = true;
    let filteredKeysIsAllControlled = true;
    collectedStates.forEach(({
      filteredKeys
    }) => {
      if (filteredKeys !== void 0) {
        filteredKeysIsAllNotControlled = false;
      } else {
        filteredKeysIsAllControlled = false;
      }
    });
    if (filteredKeysIsAllNotControlled) {
      const keyList = (mergedColumns || []).map((column2, index3) => getColumnKey(column2, getColumnPos(index3)));
      return filterStates.filter(({
        key: key2
      }) => keyList.includes(key2)).map((item) => {
        const col = mergedColumns[keyList.findIndex((key2) => key2 === item.key)];
        return Object.assign(Object.assign({}, item), {
          column: Object.assign(Object.assign({}, item.column), col),
          forceFiltered: col.filtered
        });
      });
    }
    true ? warning6(filteredKeysIsAllControlled, "usage", "Columns should all contain `filteredValue` or not contain `filteredValue`.") : void 0;
    return collectedStates;
  }, [mergedColumns, filterStates]);
  const filters = React484.useMemo(() => generateFilterInfo(mergedFilterStates), [mergedFilterStates]);
  const triggerFilter = (filterState) => {
    const newFilterStates = mergedFilterStates.filter(({
      key: key2
    }) => key2 !== filterState.key);
    newFilterStates.push(filterState);
    setFilterStates(newFilterStates);
    onFilterChange(generateFilterInfo(newFilterStates), newFilterStates);
  };
  const transformColumns = (innerColumns) => injectFilter(prefixCls, dropdownPrefixCls, innerColumns, mergedFilterStates, tableLocale, triggerFilter, getPopupContainer, void 0, rootClassName);
  return [transformColumns, mergedFilterStates, filters];
};
var useFilter_default = useFilter;

// ../../node_modules/antd/es/table/hooks/useLazyKVMap.js
var React485 = __toESM(require_react());
var useLazyKVMap = (data2, childrenColumnName, getRowKey) => {
  const mapCacheRef = React485.useRef({});
  function getRecordByKey(key2) {
    var _a;
    if (!mapCacheRef.current || mapCacheRef.current.data !== data2 || mapCacheRef.current.childrenColumnName !== childrenColumnName || mapCacheRef.current.getRowKey !== getRowKey) {
      let dig = function(records) {
        records.forEach((record, index3) => {
          const rowKey = getRowKey(record, index3);
          kvMap.set(rowKey, record);
          if (record && typeof record === "object" && childrenColumnName in record) {
            dig(record[childrenColumnName] || []);
          }
        });
      };
      const kvMap = /* @__PURE__ */ new Map();
      dig(data2);
      mapCacheRef.current = {
        data: data2,
        childrenColumnName,
        kvMap,
        getRowKey
      };
    }
    return (_a = mapCacheRef.current.kvMap) === null || _a === void 0 ? void 0 : _a.get(key2);
  }
  return [getRecordByKey];
};
var useLazyKVMap_default = useLazyKVMap;

// ../../node_modules/antd/es/table/hooks/usePagination.js
var import_react149 = __toESM(require_react());
var __rest63 = function(s, e3) {
  var t2 = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e3.indexOf(p) < 0) t2[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e3.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t2[p[i]] = s[p[i]];
  }
  return t2;
};
var DEFAULT_PAGE_SIZE = 10;
function getPaginationParam(mergedPagination, pagination) {
  const param = {
    current: mergedPagination.current,
    pageSize: mergedPagination.pageSize
  };
  const paginationObj = pagination && typeof pagination === "object" ? pagination : {};
  Object.keys(paginationObj).forEach((pageProp) => {
    const value = mergedPagination[pageProp];
    if (typeof value !== "function") {
      param[pageProp] = value;
    }
  });
  return param;
}
function usePagination(total, onChange, pagination) {
  const _a = pagination && typeof pagination === "object" ? pagination : {}, {
    total: paginationTotal = 0
  } = _a, paginationObj = __rest63(_a, ["total"]);
  const [innerPagination, setInnerPagination] = (0, import_react149.useState)(() => ({
    current: "defaultCurrent" in paginationObj ? paginationObj.defaultCurrent : 1,
    pageSize: "defaultPageSize" in paginationObj ? paginationObj.defaultPageSize : DEFAULT_PAGE_SIZE
  }));
  const mergedPagination = extendsObject_default(innerPagination, paginationObj, {
    total: paginationTotal > 0 ? paginationTotal : total
  });
  const maxPage = Math.ceil((paginationTotal || total) / mergedPagination.pageSize);
  if (mergedPagination.current > maxPage) {
    mergedPagination.current = maxPage || 1;
  }
  const refreshPagination = (current2, pageSize) => {
    setInnerPagination({
      current: current2 !== null && current2 !== void 0 ? current2 : 1,
      pageSize: pageSize || mergedPagination.pageSize
    });
  };
  const onInternalChange = (current2, pageSize) => {
    var _a2;
    if (pagination) {
      (_a2 = pagination.onChange) === null || _a2 === void 0 ? void 0 : _a2.call(pagination, current2, pageSize);
    }
    refreshPagination(current2, pageSize);
    onChange(current2, pageSize || (mergedPagination === null || mergedPagination === void 0 ? void 0 : mergedPagination.pageSize));
  };
  if (pagination === false) {
    return [{}, () => {
    }];
  }
  return [Object.assign(Object.assign({}, mergedPagination), {
    onChange: onInternalChange
  }), refreshPagination];
}
var usePagination_default = usePagination;

// ../../node_modules/antd/es/table/hooks/useSorter.js
var React488 = __toESM(require_react());

// ../../node_modules/@ant-design/icons/es/icons/CaretDownOutlined.js
var React486 = __toESM(require_react());

// ../../node_modules/@ant-design/icons-svg/es/asn/CaretDownOutlined.js
var CaretDownOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z" } }] }, "name": "caret-down", "theme": "outlined" };
var CaretDownOutlined_default = CaretDownOutlined;

// ../../node_modules/@ant-design/icons/es/icons/CaretDownOutlined.js
var CaretDownOutlined2 = function CaretDownOutlined3(props, ref3) {
  return /* @__PURE__ */ React486.createElement(AntdIcon_default, _extends({}, props, {
    ref: ref3,
    icon: CaretDownOutlined_default
  }));
};
var RefIcon39 = /* @__PURE__ */ React486.forwardRef(CaretDownOutlined2);
if (true) {
  RefIcon39.displayName = "CaretDownOutlined";
}
var CaretDownOutlined_default2 = RefIcon39;

// ../../node_modules/@ant-design/icons/es/icons/CaretUpOutlined.js
var React487 = __toESM(require_react());

// ../../node_modules/@ant-design/icons-svg/es/asn/CaretUpOutlined.js
var CaretUpOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z" } }] }, "name": "caret-up", "theme": "outlined" };
var CaretUpOutlined_default = CaretUpOutlined;

// ../../node_modules/@ant-design/icons/es/icons/CaretUpOutlined.js
var CaretUpOutlined2 = function CaretUpOutlined3(props, ref3) {
  return /* @__PURE__ */ React487.createElement(AntdIcon_default, _extends({}, props, {
    ref: ref3,
    icon: CaretUpOutlined_default
  }));
};
var RefIcon40 = /* @__PURE__ */ React487.forwardRef(CaretUpOutlined2);
if (true) {
  RefIcon40.displayName = "CaretUpOutlined";
}
var CaretUpOutlined_default2 = RefIcon40;

// ../../node_modules/antd/es/table/hooks/useSorter.js
var import_classnames195 = __toESM(require_classnames());
var ASCEND = "ascend";
var DESCEND = "descend";
var getMultiplePriority = (column2) => {
  if (typeof column2.sorter === "object" && typeof column2.sorter.multiple === "number") {
    return column2.sorter.multiple;
  }
  return false;
};
var getSortFunction = (sorter) => {
  if (typeof sorter === "function") {
    return sorter;
  }
  if (sorter && typeof sorter === "object" && sorter.compare) {
    return sorter.compare;
  }
  return false;
};
var nextSortDirection = (sortDirections, current2) => {
  if (!current2) {
    return sortDirections[0];
  }
  return sortDirections[sortDirections.indexOf(current2) + 1];
};
var collectSortStates = (columns, init2, pos) => {
  let sortStates = [];
  const pushState = (column2, columnPos) => {
    sortStates.push({
      column: column2,
      key: getColumnKey(column2, columnPos),
      multiplePriority: getMultiplePriority(column2),
      sortOrder: column2.sortOrder
    });
  };
  (columns || []).forEach((column2, index3) => {
    const columnPos = getColumnPos(index3, pos);
    if (column2.children) {
      if ("sortOrder" in column2) {
        pushState(column2, columnPos);
      }
      sortStates = [].concat(_toConsumableArray(sortStates), _toConsumableArray(collectSortStates(column2.children, init2, columnPos)));
    } else if (column2.sorter) {
      if ("sortOrder" in column2) {
        pushState(column2, columnPos);
      } else if (init2 && column2.defaultSortOrder) {
        sortStates.push({
          column: column2,
          key: getColumnKey(column2, columnPos),
          multiplePriority: getMultiplePriority(column2),
          sortOrder: column2.defaultSortOrder
        });
      }
    }
  });
  return sortStates;
};
var injectSorter = (prefixCls, columns, sorterStates, triggerSorter, defaultSortDirections, tableLocale, tableShowSorterTooltip, pos) => {
  const finalColumns = (columns || []).map((column2, index3) => {
    const columnPos = getColumnPos(index3, pos);
    let newColumn = column2;
    if (newColumn.sorter) {
      const sortDirections = newColumn.sortDirections || defaultSortDirections;
      const showSorterTooltip = newColumn.showSorterTooltip === void 0 ? tableShowSorterTooltip : newColumn.showSorterTooltip;
      const columnKey = getColumnKey(newColumn, columnPos);
      const sorterState = sorterStates.find(({
        key: key2
      }) => key2 === columnKey);
      const sortOrder = sorterState ? sorterState.sortOrder : null;
      const nextSortOrder = nextSortDirection(sortDirections, sortOrder);
      let sorter;
      if (column2.sortIcon) {
        sorter = column2.sortIcon({
          sortOrder
        });
      } else {
        const upNode = sortDirections.includes(ASCEND) && /* @__PURE__ */ React488.createElement(CaretUpOutlined_default2, {
          className: (0, import_classnames195.default)(`${prefixCls}-column-sorter-up`, {
            active: sortOrder === ASCEND
          })
        });
        const downNode = sortDirections.includes(DESCEND) && /* @__PURE__ */ React488.createElement(CaretDownOutlined_default2, {
          className: (0, import_classnames195.default)(`${prefixCls}-column-sorter-down`, {
            active: sortOrder === DESCEND
          })
        });
        sorter = /* @__PURE__ */ React488.createElement("span", {
          className: (0, import_classnames195.default)(`${prefixCls}-column-sorter`, {
            [`${prefixCls}-column-sorter-full`]: !!(upNode && downNode)
          })
        }, /* @__PURE__ */ React488.createElement("span", {
          className: `${prefixCls}-column-sorter-inner`,
          "aria-hidden": "true"
        }, upNode, downNode));
      }
      const {
        cancelSort,
        triggerAsc,
        triggerDesc
      } = tableLocale || {};
      let sortTip = cancelSort;
      if (nextSortOrder === DESCEND) {
        sortTip = triggerDesc;
      } else if (nextSortOrder === ASCEND) {
        sortTip = triggerAsc;
      }
      const tooltipProps = typeof showSorterTooltip === "object" ? Object.assign({
        title: sortTip
      }, showSorterTooltip) : {
        title: sortTip
      };
      newColumn = Object.assign(Object.assign({}, newColumn), {
        className: (0, import_classnames195.default)(newColumn.className, {
          [`${prefixCls}-column-sort`]: sortOrder
        }),
        title: (renderProps) => {
          const columnSortersClass = `${prefixCls}-column-sorters`;
          const renderColumnTitleWrapper = /* @__PURE__ */ React488.createElement("span", {
            className: `${prefixCls}-column-title`
          }, renderColumnTitle(column2.title, renderProps));
          const renderSortTitle = /* @__PURE__ */ React488.createElement("div", {
            className: columnSortersClass
          }, renderColumnTitleWrapper, sorter);
          if (showSorterTooltip) {
            if (typeof showSorterTooltip !== "boolean" && (showSorterTooltip === null || showSorterTooltip === void 0 ? void 0 : showSorterTooltip.target) === "sorter-icon") {
              return /* @__PURE__ */ React488.createElement("div", {
                className: `${columnSortersClass} ${prefixCls}-column-sorters-tooltip-target-sorter`
              }, renderColumnTitleWrapper, /* @__PURE__ */ React488.createElement(tooltip_default, Object.assign({}, tooltipProps), sorter));
            }
            return /* @__PURE__ */ React488.createElement(tooltip_default, Object.assign({}, tooltipProps), renderSortTitle);
          }
          return renderSortTitle;
        },
        onHeaderCell: (col) => {
          var _a;
          const cell = ((_a = column2.onHeaderCell) === null || _a === void 0 ? void 0 : _a.call(column2, col)) || {};
          const originOnClick = cell.onClick;
          const originOKeyDown = cell.onKeyDown;
          cell.onClick = (event) => {
            triggerSorter({
              column: column2,
              key: columnKey,
              sortOrder: nextSortOrder,
              multiplePriority: getMultiplePriority(column2)
            });
            originOnClick === null || originOnClick === void 0 ? void 0 : originOnClick(event);
          };
          cell.onKeyDown = (event) => {
            if (event.keyCode === KeyCode_default.ENTER) {
              triggerSorter({
                column: column2,
                key: columnKey,
                sortOrder: nextSortOrder,
                multiplePriority: getMultiplePriority(column2)
              });
              originOKeyDown === null || originOKeyDown === void 0 ? void 0 : originOKeyDown(event);
            }
          };
          const renderTitle = safeColumnTitle(column2.title, {});
          const displayTitle = renderTitle === null || renderTitle === void 0 ? void 0 : renderTitle.toString();
          if (sortOrder) {
            cell["aria-sort"] = sortOrder === "ascend" ? "ascending" : "descending";
          }
          cell["aria-label"] = displayTitle || "";
          cell.className = (0, import_classnames195.default)(cell.className, `${prefixCls}-column-has-sorters`);
          cell.tabIndex = 0;
          if (column2.ellipsis) {
            cell.title = (renderTitle !== null && renderTitle !== void 0 ? renderTitle : "").toString();
          }
          return cell;
        }
      });
    }
    if ("children" in newColumn) {
      newColumn = Object.assign(Object.assign({}, newColumn), {
        children: injectSorter(prefixCls, newColumn.children, sorterStates, triggerSorter, defaultSortDirections, tableLocale, tableShowSorterTooltip, columnPos)
      });
    }
    return newColumn;
  });
  return finalColumns;
};
var stateToInfo = (sorterState) => {
  const {
    column: column2,
    sortOrder
  } = sorterState;
  return {
    column: column2,
    order: sortOrder,
    field: column2.dataIndex,
    columnKey: column2.key
  };
};
var generateSorterInfo = (sorterStates) => {
  const activeSorters = sorterStates.filter(({
    sortOrder
  }) => sortOrder).map(stateToInfo);
  if (activeSorters.length === 0 && sorterStates.length) {
    const lastIndex = sorterStates.length - 1;
    return Object.assign(Object.assign({}, stateToInfo(sorterStates[lastIndex])), {
      column: void 0,
      order: void 0,
      field: void 0,
      columnKey: void 0
    });
  }
  if (activeSorters.length <= 1) {
    return activeSorters[0] || {};
  }
  return activeSorters;
};
var getSortData = (data2, sortStates, childrenColumnName) => {
  const innerSorterStates = sortStates.slice().sort((a, b) => b.multiplePriority - a.multiplePriority);
  const cloneData = data2.slice();
  const runningSorters = innerSorterStates.filter(({
    column: {
      sorter
    },
    sortOrder
  }) => getSortFunction(sorter) && sortOrder);
  if (!runningSorters.length) {
    return cloneData;
  }
  return cloneData.sort((record1, record2) => {
    for (let i = 0; i < runningSorters.length; i += 1) {
      const sorterState = runningSorters[i];
      const {
        column: {
          sorter
        },
        sortOrder
      } = sorterState;
      const compareFn = getSortFunction(sorter);
      if (compareFn && sortOrder) {
        const compareResult = compareFn(record1, record2, sortOrder);
        if (compareResult !== 0) {
          return sortOrder === ASCEND ? compareResult : -compareResult;
        }
      }
    }
    return 0;
  }).map((record) => {
    const subRecords = record[childrenColumnName];
    if (subRecords) {
      return Object.assign(Object.assign({}, record), {
        [childrenColumnName]: getSortData(subRecords, sortStates, childrenColumnName)
      });
    }
    return record;
  });
};
var useFilterSorter = (props) => {
  const {
    prefixCls,
    mergedColumns,
    sortDirections,
    tableLocale,
    showSorterTooltip,
    onSorterChange
  } = props;
  const [sortStates, setSortStates] = React488.useState(() => collectSortStates(mergedColumns, true));
  const getColumnKeys = (columns, pos) => {
    const newKeys = [];
    columns.forEach((item, index3) => {
      const columnPos = getColumnPos(index3, pos);
      newKeys.push(getColumnKey(item, columnPos));
      if (Array.isArray(item.children)) {
        const childKeys = getColumnKeys(item.children, columnPos);
        newKeys.push.apply(newKeys, _toConsumableArray(childKeys));
      }
    });
    return newKeys;
  };
  const mergedSorterStates = React488.useMemo(() => {
    let validate = true;
    const collectedStates = collectSortStates(mergedColumns, false);
    if (!collectedStates.length) {
      const mergedColumnsKeys = getColumnKeys(mergedColumns);
      return sortStates.filter(({
        key: key2
      }) => mergedColumnsKeys.includes(key2));
    }
    const validateStates = [];
    function patchStates(state) {
      if (validate) {
        validateStates.push(state);
      } else {
        validateStates.push(Object.assign(Object.assign({}, state), {
          sortOrder: null
        }));
      }
    }
    let multipleMode = null;
    collectedStates.forEach((state) => {
      if (multipleMode === null) {
        patchStates(state);
        if (state.sortOrder) {
          if (state.multiplePriority === false) {
            validate = false;
          } else {
            multipleMode = true;
          }
        }
      } else if (multipleMode && state.multiplePriority !== false) {
        patchStates(state);
      } else {
        validate = false;
        patchStates(state);
      }
    });
    return validateStates;
  }, [mergedColumns, sortStates]);
  const columnTitleSorterProps = React488.useMemo(() => {
    var _a, _b;
    const sortColumns = mergedSorterStates.map(({
      column: column2,
      sortOrder
    }) => ({
      column: column2,
      order: sortOrder
    }));
    return {
      sortColumns,
      // Legacy
      sortColumn: (_a = sortColumns[0]) === null || _a === void 0 ? void 0 : _a.column,
      sortOrder: (_b = sortColumns[0]) === null || _b === void 0 ? void 0 : _b.order
    };
  }, [mergedSorterStates]);
  const triggerSorter = (sortState) => {
    let newSorterStates;
    if (sortState.multiplePriority === false || !mergedSorterStates.length || mergedSorterStates[0].multiplePriority === false) {
      newSorterStates = [sortState];
    } else {
      newSorterStates = [].concat(_toConsumableArray(mergedSorterStates.filter(({
        key: key2
      }) => key2 !== sortState.key)), [sortState]);
    }
    setSortStates(newSorterStates);
    onSorterChange(generateSorterInfo(newSorterStates), newSorterStates);
  };
  const transformColumns = (innerColumns) => injectSorter(prefixCls, innerColumns, mergedSorterStates, triggerSorter, sortDirections, tableLocale, showSorterTooltip);
  const getSorters = () => generateSorterInfo(mergedSorterStates);
  return [transformColumns, mergedSorterStates, columnTitleSorterProps, getSorters];
};
var useSorter_default = useFilterSorter;

// ../../node_modules/antd/es/table/hooks/useTitleColumns.js
var React489 = __toESM(require_react());
var fillTitle = (columns, columnTitleProps) => {
  const finalColumns = columns.map((column2) => {
    const cloneColumn = Object.assign({}, column2);
    cloneColumn.title = renderColumnTitle(column2.title, columnTitleProps);
    if ("children" in cloneColumn) {
      cloneColumn.children = fillTitle(cloneColumn.children, columnTitleProps);
    }
    return cloneColumn;
  });
  return finalColumns;
};
var useTitleColumns = (columnTitleProps) => {
  const filledColumns = React489.useCallback((columns) => fillTitle(columns, columnTitleProps), [columnTitleProps]);
  return [filledColumns];
};
var useTitleColumns_default = useTitleColumns;

// ../../node_modules/antd/es/table/RcTable/index.js
var RcTable = genTable((prev2, next2) => {
  const {
    _renderTimes: prevRenderTimes
  } = prev2;
  const {
    _renderTimes: nextRenderTimes
  } = next2;
  return prevRenderTimes !== nextRenderTimes;
});
var RcTable_default = RcTable;

// ../../node_modules/antd/es/table/RcTable/VirtualTable.js
var RcVirtualTable = genVirtualTable((prev2, next2) => {
  const {
    _renderTimes: prevRenderTimes
  } = prev2;
  const {
    _renderTimes: nextRenderTimes
  } = next2;
  return prevRenderTimes !== nextRenderTimes;
});
var VirtualTable_default2 = RcVirtualTable;

// ../../node_modules/antd/es/table/style/bordered.js
var genBorderedStyle3 = (token2) => {
  const {
    componentCls,
    lineWidth,
    lineType,
    tableBorderColor,
    tableHeaderBg,
    tablePaddingVertical,
    tablePaddingHorizontal,
    calc
  } = token2;
  const tableBorder = `${unit(lineWidth)} ${lineType} ${tableBorderColor}`;
  const getSizeBorderStyle = (size, paddingVertical, paddingHorizontal) => ({
    [`&${componentCls}-${size}`]: {
      [`> ${componentCls}-container`]: {
        [`> ${componentCls}-content, > ${componentCls}-body`]: {
          [`
            > table > tbody > tr > th,
            > table > tbody > tr > td
          `]: {
            [`> ${componentCls}-expanded-row-fixed`]: {
              margin: `${unit(calc(paddingVertical).mul(-1).equal())}
              ${unit(calc(calc(paddingHorizontal).add(lineWidth)).mul(-1).equal())}`
            }
          }
        }
      }
    }
  });
  return {
    [`${componentCls}-wrapper`]: {
      [`${componentCls}${componentCls}-bordered`]: Object.assign(Object.assign(Object.assign({
        // ============================ Title =============================
        [`> ${componentCls}-title`]: {
          border: tableBorder,
          borderBottom: 0
        },
        // ============================ Content ============================
        [`> ${componentCls}-container`]: {
          borderInlineStart: tableBorder,
          borderTop: tableBorder,
          [`
            > ${componentCls}-content,
            > ${componentCls}-header,
            > ${componentCls}-body,
            > ${componentCls}-summary
          `]: {
            "> table": {
              // ============================= Cell =============================
              [`
                > thead > tr > th,
                > thead > tr > td,
                > tbody > tr > th,
                > tbody > tr > td,
                > tfoot > tr > th,
                > tfoot > tr > td
              `]: {
                borderInlineEnd: tableBorder
              },
              // ============================ Header ============================
              "> thead": {
                "> tr:not(:last-child) > th": {
                  borderBottom: tableBorder
                },
                "> tr > th::before": {
                  backgroundColor: "transparent !important"
                }
              },
              // Fixed right should provides additional border
              [`
                > thead > tr,
                > tbody > tr,
                > tfoot > tr
              `]: {
                [`> ${componentCls}-cell-fix-right-first::after`]: {
                  borderInlineEnd: tableBorder
                }
              },
              // ========================== Expandable ==========================
              [`
                > tbody > tr > th,
                > tbody > tr > td
              `]: {
                [`> ${componentCls}-expanded-row-fixed`]: {
                  margin: `${unit(calc(tablePaddingVertical).mul(-1).equal())} ${unit(calc(calc(tablePaddingHorizontal).add(lineWidth)).mul(-1).equal())}`,
                  "&::after": {
                    position: "absolute",
                    top: 0,
                    insetInlineEnd: lineWidth,
                    bottom: 0,
                    borderInlineEnd: tableBorder,
                    content: '""'
                  }
                }
              }
            }
          }
        },
        // ============================ Scroll ============================
        [`&${componentCls}-scroll-horizontal`]: {
          [`> ${componentCls}-container > ${componentCls}-body`]: {
            "> table > tbody": {
              [`
                > tr${componentCls}-expanded-row,
                > tr${componentCls}-placeholder
              `]: {
                "> th, > td": {
                  borderInlineEnd: 0
                }
              }
            }
          }
        }
      }, getSizeBorderStyle("middle", token2.tablePaddingVerticalMiddle, token2.tablePaddingHorizontalMiddle)), getSizeBorderStyle("small", token2.tablePaddingVerticalSmall, token2.tablePaddingHorizontalSmall)), {
        // ============================ Footer ============================
        [`> ${componentCls}-footer`]: {
          border: tableBorder,
          borderTop: 0
        }
      }),
      // ============================ Nested ============================
      [`${componentCls}-cell`]: {
        [`${componentCls}-container:first-child`]: {
          // :first-child to avoid the case when bordered and title is set
          borderTop: 0
        },
        // https://github.com/ant-design/ant-design/issues/35577
        "&-scrollbar:not([rowspan])": {
          boxShadow: `0 ${unit(lineWidth)} 0 ${unit(lineWidth)} ${tableHeaderBg}`
        }
      },
      [`${componentCls}-bordered ${componentCls}-cell-scrollbar`]: {
        borderInlineEnd: tableBorder
      }
    }
  };
};
var bordered_default2 = genBorderedStyle3;

// ../../node_modules/antd/es/table/style/ellipsis.js
var genEllipsisStyle = (token2) => {
  const {
    componentCls
  } = token2;
  return {
    [`${componentCls}-wrapper`]: {
      [`${componentCls}-cell-ellipsis`]: Object.assign(Object.assign({}, textEllipsis), {
        wordBreak: "keep-all",
        // Fixed first or last should special process
        [`
          &${componentCls}-cell-fix-left-last,
          &${componentCls}-cell-fix-right-first
        `]: {
          overflow: "visible",
          [`${componentCls}-cell-content`]: {
            display: "block",
            overflow: "hidden",
            textOverflow: "ellipsis"
          }
        },
        [`${componentCls}-column-title`]: {
          overflow: "hidden",
          textOverflow: "ellipsis",
          wordBreak: "keep-all"
        }
      })
    }
  };
};
var ellipsis_default = genEllipsisStyle;

// ../../node_modules/antd/es/table/style/empty.js
var genEmptyStyle = (token2) => {
  const {
    componentCls
  } = token2;
  return {
    [`${componentCls}-wrapper`]: {
      [`${componentCls}-tbody > tr${componentCls}-placeholder`]: {
        textAlign: "center",
        color: token2.colorTextDisabled,
        [`
          &:hover > th,
          &:hover > td,
        `]: {
          background: token2.colorBgContainer
        }
      }
    }
  };
};
var empty_default3 = genEmptyStyle;

// ../../node_modules/antd/es/table/style/expand.js
var genExpandStyle = (token2) => {
  const {
    componentCls,
    antCls,
    motionDurationSlow,
    lineWidth,
    paddingXS,
    lineType,
    tableBorderColor,
    tableExpandIconBg,
    tableExpandColumnWidth,
    borderRadius,
    tablePaddingVertical,
    tablePaddingHorizontal,
    tableExpandedRowBg,
    paddingXXS,
    expandIconMarginTop,
    expandIconSize,
    expandIconHalfInner,
    expandIconScale,
    calc
  } = token2;
  const tableBorder = `${unit(lineWidth)} ${lineType} ${tableBorderColor}`;
  const expandIconLineOffset = calc(paddingXXS).sub(lineWidth).equal();
  return {
    [`${componentCls}-wrapper`]: {
      [`${componentCls}-expand-icon-col`]: {
        width: tableExpandColumnWidth
      },
      [`${componentCls}-row-expand-icon-cell`]: {
        textAlign: "center",
        [`${componentCls}-row-expand-icon`]: {
          display: "inline-flex",
          float: "none",
          verticalAlign: "sub"
        }
      },
      [`${componentCls}-row-indent`]: {
        height: 1,
        float: "left"
      },
      [`${componentCls}-row-expand-icon`]: Object.assign(Object.assign({}, operationUnit(token2)), {
        position: "relative",
        float: "left",
        width: expandIconSize,
        height: expandIconSize,
        color: "inherit",
        lineHeight: unit(expandIconSize),
        background: tableExpandIconBg,
        border: tableBorder,
        borderRadius,
        transform: `scale(${expandIconScale})`,
        "&:focus, &:hover, &:active": {
          borderColor: "currentcolor"
        },
        "&::before, &::after": {
          position: "absolute",
          background: "currentcolor",
          transition: `transform ${motionDurationSlow} ease-out`,
          content: '""'
        },
        "&::before": {
          top: expandIconHalfInner,
          insetInlineEnd: expandIconLineOffset,
          insetInlineStart: expandIconLineOffset,
          height: lineWidth
        },
        "&::after": {
          top: expandIconLineOffset,
          bottom: expandIconLineOffset,
          insetInlineStart: expandIconHalfInner,
          width: lineWidth,
          transform: "rotate(90deg)"
        },
        // Motion effect
        "&-collapsed::before": {
          transform: "rotate(-180deg)"
        },
        "&-collapsed::after": {
          transform: "rotate(0deg)"
        },
        "&-spaced": {
          "&::before, &::after": {
            display: "none",
            content: "none"
          },
          background: "transparent",
          border: 0,
          visibility: "hidden"
        }
      }),
      [`${componentCls}-row-indent + ${componentCls}-row-expand-icon`]: {
        marginTop: expandIconMarginTop,
        marginInlineEnd: paddingXS
      },
      [`tr${componentCls}-expanded-row`]: {
        "&, &:hover": {
          "> th, > td": {
            background: tableExpandedRowBg
          }
        },
        // https://github.com/ant-design/ant-design/issues/25573
        [`${antCls}-descriptions-view`]: {
          display: "flex",
          table: {
            flex: "auto",
            width: "100%"
          }
        }
      },
      // With fixed
      [`${componentCls}-expanded-row-fixed`]: {
        position: "relative",
        margin: `${unit(calc(tablePaddingVertical).mul(-1).equal())} ${unit(calc(tablePaddingHorizontal).mul(-1).equal())}`,
        padding: `${unit(tablePaddingVertical)} ${unit(tablePaddingHorizontal)}`
      }
    }
  };
};
var expand_default = genExpandStyle;

// ../../node_modules/antd/es/table/style/filter.js
var genFilterStyle = (token2) => {
  const {
    componentCls,
    antCls,
    iconCls,
    tableFilterDropdownWidth,
    tableFilterDropdownSearchWidth,
    paddingXXS,
    paddingXS,
    colorText,
    lineWidth,
    lineType,
    tableBorderColor,
    headerIconColor,
    fontSizeSM,
    tablePaddingHorizontal,
    borderRadius,
    motionDurationSlow,
    colorIcon,
    colorPrimary,
    tableHeaderFilterActiveBg,
    colorTextDisabled,
    tableFilterDropdownBg,
    tableFilterDropdownHeight,
    controlItemBgHover,
    controlItemBgActive,
    boxShadowSecondary,
    filterDropdownMenuBg,
    calc
  } = token2;
  const dropdownPrefixCls = `${antCls}-dropdown`;
  const tableFilterDropdownPrefixCls = `${componentCls}-filter-dropdown`;
  const treePrefixCls = `${antCls}-tree`;
  const tableBorder = `${unit(lineWidth)} ${lineType} ${tableBorderColor}`;
  return [
    {
      [`${componentCls}-wrapper`]: {
        [`${componentCls}-filter-column`]: {
          display: "flex",
          justifyContent: "space-between"
        },
        [`${componentCls}-filter-trigger`]: {
          position: "relative",
          display: "flex",
          alignItems: "center",
          marginBlock: calc(paddingXXS).mul(-1).equal(),
          marginInline: `${unit(paddingXXS)} ${unit(calc(tablePaddingHorizontal).div(2).mul(-1).equal())}`,
          padding: `0 ${unit(paddingXXS)}`,
          color: headerIconColor,
          fontSize: fontSizeSM,
          borderRadius,
          cursor: "pointer",
          transition: `all ${motionDurationSlow}`,
          "&:hover": {
            color: colorIcon,
            background: tableHeaderFilterActiveBg
          },
          "&.active": {
            color: colorPrimary
          }
        }
      }
    },
    {
      // Dropdown
      [`${antCls}-dropdown`]: {
        [tableFilterDropdownPrefixCls]: Object.assign(Object.assign({}, resetComponent(token2)), {
          minWidth: tableFilterDropdownWidth,
          backgroundColor: tableFilterDropdownBg,
          borderRadius,
          boxShadow: boxShadowSecondary,
          overflow: "hidden",
          // Reset menu
          [`${dropdownPrefixCls}-menu`]: {
            // https://github.com/ant-design/ant-design/issues/4916
            // https://github.com/ant-design/ant-design/issues/19542
            maxHeight: tableFilterDropdownHeight,
            overflowX: "hidden",
            border: 0,
            boxShadow: "none",
            borderRadius: "unset",
            backgroundColor: filterDropdownMenuBg,
            "&:empty::after": {
              display: "block",
              padding: `${unit(paddingXS)} 0`,
              color: colorTextDisabled,
              fontSize: fontSizeSM,
              textAlign: "center",
              content: '"Not Found"'
            }
          },
          [`${tableFilterDropdownPrefixCls}-tree`]: {
            paddingBlock: `${unit(paddingXS)} 0`,
            paddingInline: paddingXS,
            [treePrefixCls]: {
              padding: 0
            },
            [`${treePrefixCls}-treenode ${treePrefixCls}-node-content-wrapper:hover`]: {
              backgroundColor: controlItemBgHover
            },
            [`${treePrefixCls}-treenode-checkbox-checked ${treePrefixCls}-node-content-wrapper`]: {
              "&, &:hover": {
                backgroundColor: controlItemBgActive
              }
            }
          },
          [`${tableFilterDropdownPrefixCls}-search`]: {
            padding: paddingXS,
            borderBottom: tableBorder,
            "&-input": {
              input: {
                minWidth: tableFilterDropdownSearchWidth
              },
              [iconCls]: {
                color: colorTextDisabled
              }
            }
          },
          [`${tableFilterDropdownPrefixCls}-checkall`]: {
            width: "100%",
            marginBottom: paddingXXS,
            marginInlineStart: paddingXXS
          },
          // Operation
          [`${tableFilterDropdownPrefixCls}-btns`]: {
            display: "flex",
            justifyContent: "space-between",
            padding: `${unit(calc(paddingXS).sub(lineWidth).equal())} ${unit(paddingXS)}`,
            overflow: "hidden",
            borderTop: tableBorder
          }
        })
      }
    },
    // Dropdown Menu & SubMenu
    {
      // submenu of table filter dropdown
      [`${antCls}-dropdown ${tableFilterDropdownPrefixCls}, ${tableFilterDropdownPrefixCls}-submenu`]: {
        // Checkbox
        [`${antCls}-checkbox-wrapper + span`]: {
          paddingInlineStart: paddingXS,
          color: colorText
        },
        "> ul": {
          maxHeight: "calc(100vh - 130px)",
          overflowX: "hidden",
          overflowY: "auto"
        }
      }
    }
  ];
};
var filter_default = genFilterStyle;

// ../../node_modules/antd/es/table/style/fixed.js
var genFixedStyle = (token2) => {
  const {
    componentCls,
    lineWidth,
    colorSplit,
    motionDurationSlow,
    zIndexTableFixed: zIndexTableFixed2,
    tableBg,
    zIndexTableSticky,
    calc
  } = token2;
  const shadowColor = colorSplit;
  return {
    [`${componentCls}-wrapper`]: {
      [`
        ${componentCls}-cell-fix-left,
        ${componentCls}-cell-fix-right
      `]: {
        position: "sticky !important",
        zIndex: zIndexTableFixed2,
        background: tableBg
      },
      [`
        ${componentCls}-cell-fix-left-first::after,
        ${componentCls}-cell-fix-left-last::after
      `]: {
        position: "absolute",
        top: 0,
        right: {
          _skip_check_: true,
          value: 0
        },
        bottom: calc(lineWidth).mul(-1).equal(),
        width: 30,
        transform: "translateX(100%)",
        transition: `box-shadow ${motionDurationSlow}`,
        content: '""',
        pointerEvents: "none",
        // fix issues: https://github.com/ant-design/ant-design/issues/54587
        willChange: "transform"
      },
      [`${componentCls}-cell-fix-left-all::after`]: {
        display: "none"
      },
      [`
        ${componentCls}-cell-fix-right-first::after,
        ${componentCls}-cell-fix-right-last::after
      `]: {
        position: "absolute",
        top: 0,
        bottom: calc(lineWidth).mul(-1).equal(),
        left: {
          _skip_check_: true,
          value: 0
        },
        width: 30,
        transform: "translateX(-100%)",
        transition: `box-shadow ${motionDurationSlow}`,
        content: '""',
        pointerEvents: "none"
      },
      [`${componentCls}-container`]: {
        position: "relative",
        "&::before, &::after": {
          position: "absolute",
          top: 0,
          bottom: 0,
          zIndex: calc(zIndexTableSticky).add(1).equal({
            unit: false
          }),
          width: 30,
          transition: `box-shadow ${motionDurationSlow}`,
          content: '""',
          pointerEvents: "none"
        },
        "&::before": {
          insetInlineStart: 0
        },
        "&::after": {
          insetInlineEnd: 0
        }
      },
      [`${componentCls}-ping-left`]: {
        [`&:not(${componentCls}-has-fix-left) ${componentCls}-container::before`]: {
          boxShadow: `inset 10px 0 8px -8px ${shadowColor}`
        },
        [`
          ${componentCls}-cell-fix-left-first::after,
          ${componentCls}-cell-fix-left-last::after
        `]: {
          boxShadow: `inset 10px 0 8px -8px ${shadowColor}`
        },
        [`${componentCls}-cell-fix-left-last::before`]: {
          backgroundColor: "transparent !important"
        }
      },
      [`${componentCls}-ping-right`]: {
        [`&:not(${componentCls}-has-fix-right) ${componentCls}-container::after`]: {
          boxShadow: `inset -10px 0 8px -8px ${shadowColor}`
        },
        [`
          ${componentCls}-cell-fix-right-first::after,
          ${componentCls}-cell-fix-right-last::after
        `]: {
          boxShadow: `inset -10px 0 8px -8px ${shadowColor}`
        }
      },
      // Gapped fixed Columns do not show the shadow
      [`${componentCls}-fixed-column-gapped`]: {
        [`
        ${componentCls}-cell-fix-left-first::after,
        ${componentCls}-cell-fix-left-last::after,
        ${componentCls}-cell-fix-right-first::after,
        ${componentCls}-cell-fix-right-last::after
      `]: {
          boxShadow: "none"
        }
      }
    }
  };
};
var fixed_default = genFixedStyle;

// ../../node_modules/antd/es/table/style/pagination.js
var genPaginationStyle2 = (token2) => {
  const {
    componentCls,
    antCls,
    margin
  } = token2;
  return {
    [`${componentCls}-wrapper`]: {
      // ========================== Pagination ==========================
      [`${componentCls}-pagination${antCls}-pagination`]: {
        margin: `${unit(margin)} 0`
      },
      [`${componentCls}-pagination`]: {
        display: "flex",
        flexWrap: "wrap",
        rowGap: token2.paddingXS,
        "> *": {
          flex: "none"
        },
        "&-left": {
          justifyContent: "flex-start"
        },
        "&-center": {
          justifyContent: "center"
        },
        "&-right": {
          justifyContent: "flex-end"
        }
      }
    }
  };
};
var pagination_default2 = genPaginationStyle2;

// ../../node_modules/antd/es/table/style/radius.js
var genRadiusStyle2 = (token2) => {
  const {
    componentCls,
    tableRadius
  } = token2;
  return {
    [`${componentCls}-wrapper`]: {
      [componentCls]: {
        // https://github.com/ant-design/ant-design/issues/39115#issuecomment-1362314574
        [`${componentCls}-title, ${componentCls}-header`]: {
          borderRadius: `${unit(tableRadius)} ${unit(tableRadius)} 0 0`
        },
        [`${componentCls}-title + ${componentCls}-container`]: {
          borderStartStartRadius: 0,
          borderStartEndRadius: 0,
          // https://github.com/ant-design/ant-design/issues/41975
          [`${componentCls}-header, table`]: {
            borderRadius: 0
          },
          "table > thead > tr:first-child": {
            "th:first-child, th:last-child, td:first-child, td:last-child": {
              borderRadius: 0
            }
          }
        },
        "&-container": {
          borderStartStartRadius: tableRadius,
          borderStartEndRadius: tableRadius,
          "table > thead > tr:first-child": {
            "> *:first-child": {
              borderStartStartRadius: tableRadius
            },
            "> *:last-child": {
              borderStartEndRadius: tableRadius
            }
          }
        },
        "&-footer": {
          borderRadius: `0 0 ${unit(tableRadius)} ${unit(tableRadius)}`
        }
      }
    }
  };
};
var radius_default = genRadiusStyle2;

// ../../node_modules/antd/es/table/style/rtl.js
var genStyle = (token2) => {
  const {
    componentCls
  } = token2;
  return {
    [`${componentCls}-wrapper-rtl`]: {
      direction: "rtl",
      table: {
        direction: "rtl"
      },
      [`${componentCls}-pagination-left`]: {
        justifyContent: "flex-end"
      },
      [`${componentCls}-pagination-right`]: {
        justifyContent: "flex-start"
      },
      [`${componentCls}-row-expand-icon`]: {
        float: "right",
        "&::after": {
          transform: "rotate(-90deg)"
        },
        "&-collapsed::before": {
          transform: "rotate(180deg)"
        },
        "&-collapsed::after": {
          transform: "rotate(0deg)"
        }
      },
      [`${componentCls}-container`]: {
        "&::before": {
          insetInlineStart: "unset",
          insetInlineEnd: 0
        },
        "&::after": {
          insetInlineStart: 0,
          insetInlineEnd: "unset"
        },
        [`${componentCls}-row-indent`]: {
          float: "right"
        }
      }
    }
  };
};
var rtl_default2 = genStyle;

// ../../node_modules/antd/es/table/style/selection.js
var genSelectionStyle2 = (token2) => {
  const {
    componentCls,
    antCls,
    iconCls,
    fontSizeIcon,
    padding,
    paddingXS,
    headerIconColor,
    headerIconHoverColor,
    tableSelectionColumnWidth,
    tableSelectedRowBg,
    tableSelectedRowHoverBg,
    tableRowHoverBg,
    tablePaddingHorizontal,
    calc
  } = token2;
  return {
    [`${componentCls}-wrapper`]: {
      // ========================== Selections ==========================
      [`${componentCls}-selection-col`]: {
        width: tableSelectionColumnWidth,
        [`&${componentCls}-selection-col-with-dropdown`]: {
          width: calc(tableSelectionColumnWidth).add(fontSizeIcon).add(calc(padding).div(4)).equal()
        }
      },
      [`${componentCls}-bordered ${componentCls}-selection-col`]: {
        width: calc(tableSelectionColumnWidth).add(calc(paddingXS).mul(2)).equal(),
        [`&${componentCls}-selection-col-with-dropdown`]: {
          width: calc(tableSelectionColumnWidth).add(fontSizeIcon).add(calc(padding).div(4)).add(calc(paddingXS).mul(2)).equal()
        }
      },
      [`
        table tr th${componentCls}-selection-column,
        table tr td${componentCls}-selection-column,
        ${componentCls}-selection-column
      `]: {
        paddingInlineEnd: token2.paddingXS,
        paddingInlineStart: token2.paddingXS,
        textAlign: "center",
        [`${antCls}-radio-wrapper`]: {
          marginInlineEnd: 0
        }
      },
      [`table tr th${componentCls}-selection-column${componentCls}-cell-fix-left`]: {
        zIndex: calc(token2.zIndexTableFixed).add(1).equal({
          unit: false
        })
      },
      [`table tr th${componentCls}-selection-column::after`]: {
        backgroundColor: "transparent !important"
      },
      [`${componentCls}-selection`]: {
        position: "relative",
        display: "inline-flex",
        flexDirection: "column"
      },
      [`${componentCls}-selection-extra`]: {
        position: "absolute",
        top: 0,
        zIndex: 1,
        cursor: "pointer",
        transition: `all ${token2.motionDurationSlow}`,
        marginInlineStart: "100%",
        paddingInlineStart: unit(calc(tablePaddingHorizontal).div(4).equal()),
        [iconCls]: {
          color: headerIconColor,
          fontSize: fontSizeIcon,
          verticalAlign: "baseline",
          "&:hover": {
            color: headerIconHoverColor
          }
        }
      },
      // ============================= Rows =============================
      [`${componentCls}-tbody`]: {
        [`${componentCls}-row`]: {
          [`&${componentCls}-row-selected`]: {
            [`> ${componentCls}-cell`]: {
              background: tableSelectedRowBg,
              "&-row-hover": {
                background: tableSelectedRowHoverBg
              }
            }
          },
          [`> ${componentCls}-cell-row-hover`]: {
            background: tableRowHoverBg
          }
        }
      }
    }
  };
};
var selection_default = genSelectionStyle2;

// ../../node_modules/antd/es/table/style/size.js
var genSizeStyle4 = (token2) => {
  const {
    componentCls,
    tableExpandColumnWidth,
    calc
  } = token2;
  const getSizeStyle = (size, paddingVertical, paddingHorizontal, fontSize) => ({
    [`${componentCls}${componentCls}-${size}`]: {
      fontSize,
      [`
        ${componentCls}-title,
        ${componentCls}-footer,
        ${componentCls}-cell,
        ${componentCls}-thead > tr > th,
        ${componentCls}-tbody > tr > th,
        ${componentCls}-tbody > tr > td,
        tfoot > tr > th,
        tfoot > tr > td
      `]: {
        padding: `${unit(paddingVertical)} ${unit(paddingHorizontal)}`
      },
      [`${componentCls}-filter-trigger`]: {
        marginInlineEnd: unit(calc(paddingHorizontal).div(2).mul(-1).equal())
      },
      [`${componentCls}-expanded-row-fixed`]: {
        margin: `${unit(calc(paddingVertical).mul(-1).equal())} ${unit(calc(paddingHorizontal).mul(-1).equal())}`
      },
      [`${componentCls}-tbody`]: {
        // ========================= Nest Table ===========================
        [`${componentCls}-wrapper:only-child ${componentCls}`]: {
          marginBlock: unit(calc(paddingVertical).mul(-1).equal()),
          marginInline: `${unit(calc(tableExpandColumnWidth).sub(paddingHorizontal).equal())} ${unit(calc(paddingHorizontal).mul(-1).equal())}`
        }
      },
      // https://github.com/ant-design/ant-design/issues/35167
      [`${componentCls}-selection-extra`]: {
        paddingInlineStart: unit(calc(paddingHorizontal).div(4).equal())
      }
    }
  });
  return {
    [`${componentCls}-wrapper`]: Object.assign(Object.assign({}, getSizeStyle("middle", token2.tablePaddingVerticalMiddle, token2.tablePaddingHorizontalMiddle, token2.tableFontSizeMiddle)), getSizeStyle("small", token2.tablePaddingVerticalSmall, token2.tablePaddingHorizontalSmall, token2.tableFontSizeSmall))
  };
};
var size_default = genSizeStyle4;

// ../../node_modules/antd/es/table/style/sorter.js
var genSorterStyle = (token2) => {
  const {
    componentCls,
    marginXXS,
    fontSizeIcon,
    headerIconColor,
    headerIconHoverColor
  } = token2;
  return {
    [`${componentCls}-wrapper`]: {
      [`${componentCls}-thead th${componentCls}-column-has-sorters`]: {
        outline: "none",
        cursor: "pointer",
        // why left 0s? Avoid column header move with transition when left is changed
        // https://github.com/ant-design/ant-design/issues/50588
        transition: `all ${token2.motionDurationSlow}, left 0s`,
        "&:hover": {
          background: token2.tableHeaderSortHoverBg,
          "&::before": {
            backgroundColor: "transparent !important"
          }
        },
        "&:focus-visible": {
          color: token2.colorPrimary
        },
        // https://github.com/ant-design/ant-design/issues/30969
        [`
          &${componentCls}-cell-fix-left:hover,
          &${componentCls}-cell-fix-right:hover
        `]: {
          background: token2.tableFixedHeaderSortActiveBg
        }
      },
      [`${componentCls}-thead th${componentCls}-column-sort`]: {
        background: token2.tableHeaderSortBg,
        "&::before": {
          backgroundColor: "transparent !important"
        }
      },
      [`td${componentCls}-column-sort`]: {
        background: token2.tableBodySortBg
      },
      [`${componentCls}-column-title`]: {
        position: "relative",
        zIndex: 1,
        flex: 1,
        minWidth: 0
      },
      [`${componentCls}-column-sorters`]: {
        display: "flex",
        flex: "auto",
        alignItems: "center",
        justifyContent: "space-between",
        "&::after": {
          position: "absolute",
          inset: 0,
          width: "100%",
          height: "100%",
          content: '""'
        }
      },
      [`${componentCls}-column-sorters-tooltip-target-sorter`]: {
        "&::after": {
          content: "none"
        }
      },
      [`${componentCls}-column-sorter`]: {
        marginInlineStart: marginXXS,
        color: headerIconColor,
        fontSize: 0,
        transition: `color ${token2.motionDurationSlow}`,
        "&-inner": {
          display: "inline-flex",
          flexDirection: "column",
          alignItems: "center"
        },
        "&-up, &-down": {
          fontSize: fontSizeIcon,
          "&.active": {
            color: token2.colorPrimary
          }
        },
        [`${componentCls}-column-sorter-up + ${componentCls}-column-sorter-down`]: {
          marginTop: "-0.3em"
        }
      },
      [`${componentCls}-column-sorters:hover ${componentCls}-column-sorter`]: {
        color: headerIconHoverColor
      }
    }
  };
};
var sorter_default = genSorterStyle;

// ../../node_modules/antd/es/table/style/sticky.js
var genStickyStyle = (token2) => {
  const {
    componentCls,
    opacityLoading,
    tableScrollThumbBg,
    tableScrollThumbBgHover,
    tableScrollThumbSize,
    tableScrollBg,
    zIndexTableSticky,
    stickyScrollBarBorderRadius,
    lineWidth,
    lineType,
    tableBorderColor
  } = token2;
  const tableBorder = `${unit(lineWidth)} ${lineType} ${tableBorderColor}`;
  return {
    [`${componentCls}-wrapper`]: {
      [`${componentCls}-sticky`]: {
        "&-holder": {
          position: "sticky",
          zIndex: zIndexTableSticky,
          background: token2.colorBgContainer
        },
        "&-scroll": {
          position: "sticky",
          bottom: 0,
          height: `${unit(tableScrollThumbSize)} !important`,
          zIndex: zIndexTableSticky,
          display: "flex",
          alignItems: "center",
          background: tableScrollBg,
          borderTop: tableBorder,
          opacity: opacityLoading,
          "&:hover": {
            transformOrigin: "center bottom"
          },
          // fake scrollbar style of sticky
          "&-bar": {
            height: tableScrollThumbSize,
            backgroundColor: tableScrollThumbBg,
            borderRadius: stickyScrollBarBorderRadius,
            transition: `all ${token2.motionDurationSlow}, transform 0s`,
            position: "absolute",
            bottom: 0,
            "&:hover, &-active": {
              backgroundColor: tableScrollThumbBgHover
            }
          }
        }
      }
    }
  };
};
var sticky_default = genStickyStyle;

// ../../node_modules/antd/es/table/style/summary.js
var genSummaryStyle = (token2) => {
  const {
    componentCls,
    lineWidth,
    tableBorderColor,
    calc
  } = token2;
  const tableBorder = `${unit(lineWidth)} ${token2.lineType} ${tableBorderColor}`;
  return {
    [`${componentCls}-wrapper`]: {
      [`${componentCls}-summary`]: {
        position: "relative",
        zIndex: token2.zIndexTableFixed,
        background: token2.tableBg,
        "> tr": {
          "> th, > td": {
            borderBottom: tableBorder
          }
        }
      },
      [`div${componentCls}-summary`]: {
        boxShadow: `0 ${unit(calc(lineWidth).mul(-1).equal())} 0 ${tableBorderColor}`
      }
    }
  };
};
var summary_default = genSummaryStyle;

// ../../node_modules/antd/es/table/style/virtual.js
var genVirtualStyle = (token2) => {
  const {
    componentCls,
    motionDurationMid,
    lineWidth,
    lineType,
    tableBorderColor,
    calc
  } = token2;
  const tableBorder = `${unit(lineWidth)} ${lineType} ${tableBorderColor}`;
  const rowCellCls = `${componentCls}-expanded-row-cell`;
  return {
    [`${componentCls}-wrapper`]: {
      // ========================== Row ==========================
      [`${componentCls}-tbody-virtual`]: {
        [`${componentCls}-tbody-virtual-holder-inner`]: {
          [`
            & > ${componentCls}-row, 
            & > div:not(${componentCls}-row) > ${componentCls}-row
          `]: {
            display: "flex",
            boxSizing: "border-box",
            width: "100%"
          }
        },
        [`${componentCls}-cell`]: {
          borderBottom: tableBorder,
          transition: `background ${motionDurationMid}`
        },
        [`${componentCls}-expanded-row`]: {
          [`${rowCellCls}${rowCellCls}-fixed`]: {
            position: "sticky",
            insetInlineStart: 0,
            overflow: "hidden",
            width: `calc(var(--virtual-width) - ${unit(lineWidth)})`,
            borderInlineEnd: "none"
          }
        }
      },
      // ======================== Border =========================
      [`${componentCls}-bordered`]: {
        [`${componentCls}-tbody-virtual`]: {
          "&:after": {
            content: '""',
            insetInline: 0,
            bottom: 0,
            borderBottom: tableBorder,
            position: "absolute"
          },
          [`${componentCls}-cell`]: {
            borderInlineEnd: tableBorder,
            [`&${componentCls}-cell-fix-right-first:before`]: {
              content: '""',
              position: "absolute",
              insetBlock: 0,
              insetInlineStart: calc(lineWidth).mul(-1).equal(),
              borderInlineStart: tableBorder
            }
          }
        },
        // Empty placeholder
        [`&${componentCls}-virtual`]: {
          [`${componentCls}-placeholder ${componentCls}-cell`]: {
            borderInlineEnd: tableBorder,
            borderBottom: tableBorder
          }
        }
      }
    }
  };
};
var virtual_default = genVirtualStyle;

// ../../node_modules/antd/es/table/style/index.js
var genTableStyle = (token2) => {
  const {
    componentCls,
    fontWeightStrong,
    tablePaddingVertical,
    tablePaddingHorizontal,
    tableExpandColumnWidth,
    lineWidth,
    lineType,
    tableBorderColor,
    tableFontSize,
    tableBg,
    tableRadius,
    tableHeaderTextColor,
    motionDurationMid,
    tableHeaderBg,
    tableHeaderCellSplitColor,
    tableFooterTextColor,
    tableFooterBg,
    calc
  } = token2;
  const tableBorder = `${unit(lineWidth)} ${lineType} ${tableBorderColor}`;
  return {
    [`${componentCls}-wrapper`]: Object.assign(Object.assign({
      clear: "both",
      maxWidth: "100%",
      // fix https://github.com/ant-design/ant-design/issues/46177
      ["--rc-virtual-list-scrollbar-bg"]: token2.tableScrollBg
    }, clearFix()), {
      [componentCls]: Object.assign(Object.assign({}, resetComponent(token2)), {
        fontSize: tableFontSize,
        background: tableBg,
        borderRadius: `${unit(tableRadius)} ${unit(tableRadius)} 0 0`,
        // https://github.com/ant-design/ant-design/issues/47486
        scrollbarColor: `${token2.tableScrollThumbBg} ${token2.tableScrollBg}`
      }),
      // https://github.com/ant-design/ant-design/issues/17611
      table: {
        width: "100%",
        textAlign: "start",
        borderRadius: `${unit(tableRadius)} ${unit(tableRadius)} 0 0`,
        borderCollapse: "separate",
        borderSpacing: 0
      },
      // ============================= Cell ==============================
      [`
          ${componentCls}-cell,
          ${componentCls}-thead > tr > th,
          ${componentCls}-tbody > tr > th,
          ${componentCls}-tbody > tr > td,
          tfoot > tr > th,
          tfoot > tr > td
        `]: {
        position: "relative",
        padding: `${unit(tablePaddingVertical)} ${unit(tablePaddingHorizontal)}`,
        overflowWrap: "break-word"
      },
      // ============================ Title =============================
      [`${componentCls}-title`]: {
        padding: `${unit(tablePaddingVertical)} ${unit(tablePaddingHorizontal)}`
      },
      // ============================ Header ============================
      [`${componentCls}-thead`]: {
        [`
          > tr > th,
          > tr > td
        `]: {
          position: "relative",
          color: tableHeaderTextColor,
          fontWeight: fontWeightStrong,
          textAlign: "start",
          background: tableHeaderBg,
          borderBottom: tableBorder,
          transition: `background ${motionDurationMid} ease`,
          "&[colspan]:not([colspan='1'])": {
            textAlign: "center"
          },
          [`&:not(:last-child):not(${componentCls}-selection-column):not(${componentCls}-row-expand-icon-cell):not([colspan])::before`]: {
            position: "absolute",
            top: "50%",
            insetInlineEnd: 0,
            width: 1,
            height: "1.6em",
            backgroundColor: tableHeaderCellSplitColor,
            transform: "translateY(-50%)",
            transition: `background-color ${motionDurationMid}`,
            content: '""'
          }
        },
        "> tr:not(:last-child) > th[colspan]": {
          borderBottom: 0
        }
      },
      // ============================ Body ============================
      [`${componentCls}-tbody`]: {
        "> tr": {
          "> th, > td": {
            transition: `background ${motionDurationMid}, border-color ${motionDurationMid}`,
            borderBottom: tableBorder,
            // ========================= Nest Table ===========================
            [`
              > ${componentCls}-wrapper:only-child,
              > ${componentCls}-expanded-row-fixed > ${componentCls}-wrapper:only-child
            `]: {
              [componentCls]: {
                marginBlock: unit(calc(tablePaddingVertical).mul(-1).equal()),
                marginInline: `${unit(calc(tableExpandColumnWidth).sub(tablePaddingHorizontal).equal())}
                ${unit(calc(tablePaddingHorizontal).mul(-1).equal())}`,
                [`${componentCls}-tbody > tr:last-child > td`]: {
                  borderBottomWidth: 0,
                  "&:first-child, &:last-child": {
                    borderRadius: 0
                  }
                }
              }
            }
          },
          "> th": {
            position: "relative",
            color: tableHeaderTextColor,
            fontWeight: fontWeightStrong,
            textAlign: "start",
            background: tableHeaderBg,
            borderBottom: tableBorder,
            transition: `background ${motionDurationMid} ease`
          }
        }
      },
      // ============================ Footer ============================
      [`${componentCls}-footer`]: {
        padding: `${unit(tablePaddingVertical)} ${unit(tablePaddingHorizontal)}`,
        color: tableFooterTextColor,
        background: tableFooterBg
      }
    })
  };
};
var prepareComponentToken31 = (token2) => {
  const {
    colorFillAlter,
    colorBgContainer,
    colorTextHeading,
    colorFillSecondary,
    colorFillContent,
    controlItemBgActive,
    controlItemBgActiveHover,
    padding,
    paddingSM,
    paddingXS,
    colorBorderSecondary,
    borderRadiusLG,
    controlHeight,
    colorTextPlaceholder,
    fontSize,
    fontSizeSM,
    lineHeight,
    lineWidth,
    colorIcon,
    colorIconHover,
    opacityLoading,
    controlInteractiveSize
  } = token2;
  const colorFillSecondarySolid = new FastColor(colorFillSecondary).onBackground(colorBgContainer).toHexString();
  const colorFillContentSolid = new FastColor(colorFillContent).onBackground(colorBgContainer).toHexString();
  const colorFillAlterSolid = new FastColor(colorFillAlter).onBackground(colorBgContainer).toHexString();
  const baseColorAction = new FastColor(colorIcon);
  const baseColorActionHover = new FastColor(colorIconHover);
  const expandIconHalfInner = controlInteractiveSize / 2 - lineWidth;
  const expandIconSize = expandIconHalfInner * 2 + lineWidth * 3;
  return {
    headerBg: colorFillAlterSolid,
    headerColor: colorTextHeading,
    headerSortActiveBg: colorFillSecondarySolid,
    headerSortHoverBg: colorFillContentSolid,
    bodySortBg: colorFillAlterSolid,
    rowHoverBg: colorFillAlterSolid,
    rowSelectedBg: controlItemBgActive,
    rowSelectedHoverBg: controlItemBgActiveHover,
    rowExpandedBg: colorFillAlter,
    cellPaddingBlock: padding,
    cellPaddingInline: padding,
    cellPaddingBlockMD: paddingSM,
    cellPaddingInlineMD: paddingXS,
    cellPaddingBlockSM: paddingXS,
    cellPaddingInlineSM: paddingXS,
    borderColor: colorBorderSecondary,
    headerBorderRadius: borderRadiusLG,
    footerBg: colorFillAlterSolid,
    footerColor: colorTextHeading,
    cellFontSize: fontSize,
    cellFontSizeMD: fontSize,
    cellFontSizeSM: fontSize,
    headerSplitColor: colorBorderSecondary,
    fixedHeaderSortActiveBg: colorFillSecondarySolid,
    headerFilterHoverBg: colorFillContent,
    filterDropdownMenuBg: colorBgContainer,
    filterDropdownBg: colorBgContainer,
    expandIconBg: colorBgContainer,
    selectionColumnWidth: controlHeight,
    stickyScrollBarBg: colorTextPlaceholder,
    stickyScrollBarBorderRadius: 100,
    expandIconMarginTop: (fontSize * lineHeight - lineWidth * 3) / 2 - Math.ceil((fontSizeSM * 1.4 - lineWidth * 3) / 2),
    headerIconColor: baseColorAction.clone().setA(baseColorAction.a * opacityLoading).toRgbString(),
    headerIconHoverColor: baseColorActionHover.clone().setA(baseColorActionHover.a * opacityLoading).toRgbString(),
    expandIconHalfInner,
    expandIconSize,
    expandIconScale: controlInteractiveSize / expandIconSize
  };
};
var zIndexTableFixed = 2;
var style_default36 = genStyleHooks("Table", (token2) => {
  const {
    colorTextHeading,
    colorSplit,
    colorBgContainer,
    controlInteractiveSize: checkboxSize,
    headerBg,
    headerColor,
    headerSortActiveBg,
    headerSortHoverBg,
    bodySortBg,
    rowHoverBg,
    rowSelectedBg,
    rowSelectedHoverBg,
    rowExpandedBg,
    cellPaddingBlock,
    cellPaddingInline,
    cellPaddingBlockMD,
    cellPaddingInlineMD,
    cellPaddingBlockSM,
    cellPaddingInlineSM,
    borderColor,
    footerBg,
    footerColor,
    headerBorderRadius,
    cellFontSize,
    cellFontSizeMD,
    cellFontSizeSM,
    headerSplitColor,
    fixedHeaderSortActiveBg,
    headerFilterHoverBg,
    filterDropdownBg,
    expandIconBg,
    selectionColumnWidth,
    stickyScrollBarBg,
    calc
  } = token2;
  const tableToken = merge2(token2, {
    tableFontSize: cellFontSize,
    tableBg: colorBgContainer,
    tableRadius: headerBorderRadius,
    tablePaddingVertical: cellPaddingBlock,
    tablePaddingHorizontal: cellPaddingInline,
    tablePaddingVerticalMiddle: cellPaddingBlockMD,
    tablePaddingHorizontalMiddle: cellPaddingInlineMD,
    tablePaddingVerticalSmall: cellPaddingBlockSM,
    tablePaddingHorizontalSmall: cellPaddingInlineSM,
    tableBorderColor: borderColor,
    tableHeaderTextColor: headerColor,
    tableHeaderBg: headerBg,
    tableFooterTextColor: footerColor,
    tableFooterBg: footerBg,
    tableHeaderCellSplitColor: headerSplitColor,
    tableHeaderSortBg: headerSortActiveBg,
    tableHeaderSortHoverBg: headerSortHoverBg,
    tableBodySortBg: bodySortBg,
    tableFixedHeaderSortActiveBg: fixedHeaderSortActiveBg,
    tableHeaderFilterActiveBg: headerFilterHoverBg,
    tableFilterDropdownBg: filterDropdownBg,
    tableRowHoverBg: rowHoverBg,
    tableSelectedRowBg: rowSelectedBg,
    tableSelectedRowHoverBg: rowSelectedHoverBg,
    zIndexTableFixed,
    zIndexTableSticky: calc(zIndexTableFixed).add(1).equal({
      unit: false
    }),
    tableFontSizeMiddle: cellFontSizeMD,
    tableFontSizeSmall: cellFontSizeSM,
    tableSelectionColumnWidth: selectionColumnWidth,
    tableExpandIconBg: expandIconBg,
    tableExpandColumnWidth: calc(checkboxSize).add(calc(token2.padding).mul(2)).equal(),
    tableExpandedRowBg: rowExpandedBg,
    // Dropdown
    tableFilterDropdownWidth: 120,
    tableFilterDropdownHeight: 264,
    tableFilterDropdownSearchWidth: 140,
    // Virtual Scroll Bar
    tableScrollThumbSize: 8,
    // Mac scroll bar size
    tableScrollThumbBg: stickyScrollBarBg,
    tableScrollThumbBgHover: colorTextHeading,
    tableScrollBg: colorSplit
  });
  return [genTableStyle(tableToken), pagination_default2(tableToken), summary_default(tableToken), sorter_default(tableToken), filter_default(tableToken), bordered_default2(tableToken), radius_default(tableToken), expand_default(tableToken), summary_default(tableToken), empty_default3(tableToken), selection_default(tableToken), fixed_default(tableToken), sticky_default(tableToken), ellipsis_default(tableToken), size_default(tableToken), rtl_default2(tableToken), virtual_default(tableToken)];
}, prepareComponentToken31, {
  unitless: {
    expandIconScale: true
  }
});

// ../../node_modules/antd/es/table/InternalTable.js
var EMPTY_LIST6 = [];
var InternalTable = (props, ref3) => {
  var _a, _b;
  const {
    prefixCls: customizePrefixCls,
    className: className2,
    rootClassName,
    style: style2,
    size: customizeSize,
    bordered,
    dropdownPrefixCls: customizeDropdownPrefixCls,
    dataSource,
    pagination,
    rowSelection,
    rowKey = "key",
    rowClassName,
    columns,
    children,
    childrenColumnName: legacyChildrenColumnName,
    onChange,
    getPopupContainer,
    loading,
    expandIcon,
    expandable,
    expandedRowRender,
    expandIconColumnIndex,
    indentSize,
    scroll,
    sortDirections,
    locale: locale6,
    showSorterTooltip = {
      target: "full-header"
    },
    virtual
  } = props;
  const warning6 = devUseWarning("Table");
  if (true) {
    true ? warning6(!(typeof rowKey === "function" && rowKey.length > 1), "usage", "`index` parameter of `rowKey` function is deprecated. There is no guarantee that it will work as expected.") : void 0;
  }
  const baseColumns = React490.useMemo(() => columns || convertChildrenToColumns(children), [columns, children]);
  const needResponsive = React490.useMemo(() => baseColumns.some((col) => col.responsive), [baseColumns]);
  const screens = useBreakpoint_default(needResponsive);
  const mergedColumns = React490.useMemo(() => {
    const matched = new Set(Object.keys(screens).filter((m) => screens[m]));
    return baseColumns.filter((c) => !c.responsive || c.responsive.some((r2) => matched.has(r2)));
  }, [baseColumns, screens]);
  const tableProps = omit(props, ["className", "style", "columns"]);
  const {
    locale: contextLocale = en_US_default6,
    direction,
    table,
    renderEmpty,
    getPrefixCls,
    getPopupContainer: getContextPopupContainer
  } = React490.useContext(ConfigContext);
  const mergedSize = useSize_default(customizeSize);
  const tableLocale = Object.assign(Object.assign({}, contextLocale.Table), locale6);
  const rawData = dataSource || EMPTY_LIST6;
  const prefixCls = getPrefixCls("table", customizePrefixCls);
  const dropdownPrefixCls = getPrefixCls("dropdown", customizeDropdownPrefixCls);
  const [, token2] = useToken();
  const rootCls = useCSSVarCls_default(prefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = style_default36(prefixCls, rootCls);
  const mergedExpandable = Object.assign(Object.assign({
    childrenColumnName: legacyChildrenColumnName,
    expandIconColumnIndex
  }, expandable), {
    expandIcon: (_a = expandable === null || expandable === void 0 ? void 0 : expandable.expandIcon) !== null && _a !== void 0 ? _a : (_b = table === null || table === void 0 ? void 0 : table.expandable) === null || _b === void 0 ? void 0 : _b.expandIcon
  });
  const {
    childrenColumnName = "children"
  } = mergedExpandable;
  const expandType = React490.useMemo(() => {
    if (rawData.some((item) => item === null || item === void 0 ? void 0 : item[childrenColumnName])) {
      return "nest";
    }
    if (expandedRowRender || (expandable === null || expandable === void 0 ? void 0 : expandable.expandedRowRender)) {
      return "row";
    }
    return null;
  }, [rawData]);
  const internalRefs = {
    body: React490.useRef(null)
  };
  const getContainerWidth = useContainerWidth(prefixCls);
  const rootRef = React490.useRef(null);
  const tblRef = React490.useRef(null);
  useProxyImperativeHandle(ref3, () => Object.assign(Object.assign({}, tblRef.current), {
    nativeElement: rootRef.current
  }));
  const getRowKey = React490.useMemo(() => {
    if (typeof rowKey === "function") {
      return rowKey;
    }
    return (record) => record === null || record === void 0 ? void 0 : record[rowKey];
  }, [rowKey]);
  const [getRecordByKey] = useLazyKVMap_default(rawData, childrenColumnName, getRowKey);
  const changeEventInfo = {};
  const triggerOnChange = (info, action, reset2 = false) => {
    var _a2, _b2, _c, _d;
    const changeInfo = Object.assign(Object.assign({}, changeEventInfo), info);
    if (reset2) {
      (_a2 = changeEventInfo.resetPagination) === null || _a2 === void 0 ? void 0 : _a2.call(changeEventInfo);
      if ((_b2 = changeInfo.pagination) === null || _b2 === void 0 ? void 0 : _b2.current) {
        changeInfo.pagination.current = 1;
      }
      if (pagination) {
        (_c = pagination.onChange) === null || _c === void 0 ? void 0 : _c.call(pagination, 1, (_d = changeInfo.pagination) === null || _d === void 0 ? void 0 : _d.pageSize);
      }
    }
    if (scroll && scroll.scrollToFirstRowOnChange !== false && internalRefs.body.current) {
      scrollTo(0, {
        getContainer: () => internalRefs.body.current
      });
    }
    onChange === null || onChange === void 0 ? void 0 : onChange(changeInfo.pagination, changeInfo.filters, changeInfo.sorter, {
      currentDataSource: getFilterData(getSortData(rawData, changeInfo.sorterStates, childrenColumnName), changeInfo.filterStates, childrenColumnName),
      action
    });
  };
  const onSorterChange = (sorter, sorterStates) => {
    triggerOnChange({
      sorter,
      sorterStates
    }, "sort", false);
  };
  const [transformSorterColumns, sortStates, sorterTitleProps, getSorters] = useSorter_default({
    prefixCls,
    mergedColumns,
    onSorterChange,
    sortDirections: sortDirections || ["ascend", "descend"],
    tableLocale,
    showSorterTooltip
  });
  const sortedData = React490.useMemo(() => getSortData(rawData, sortStates, childrenColumnName), [rawData, sortStates]);
  changeEventInfo.sorter = getSorters();
  changeEventInfo.sorterStates = sortStates;
  const onFilterChange = (filters2, filterStates2) => {
    triggerOnChange({
      filters: filters2,
      filterStates: filterStates2
    }, "filter", true);
  };
  const [transformFilterColumns, filterStates, filters] = useFilter_default({
    prefixCls,
    locale: tableLocale,
    dropdownPrefixCls,
    mergedColumns,
    onFilterChange,
    getPopupContainer: getPopupContainer || getContextPopupContainer,
    rootClassName: (0, import_classnames196.default)(rootClassName, rootCls)
  });
  const mergedData = getFilterData(sortedData, filterStates, childrenColumnName);
  changeEventInfo.filters = filters;
  changeEventInfo.filterStates = filterStates;
  const columnTitleProps = React490.useMemo(() => {
    const mergedFilters = {};
    Object.keys(filters).forEach((filterKey) => {
      if (filters[filterKey] !== null) {
        mergedFilters[filterKey] = filters[filterKey];
      }
    });
    return Object.assign(Object.assign({}, sorterTitleProps), {
      filters: mergedFilters
    });
  }, [sorterTitleProps, filters]);
  const [transformTitleColumns] = useTitleColumns_default(columnTitleProps);
  const onPaginationChange = (current2, pageSize) => {
    triggerOnChange({
      pagination: Object.assign(Object.assign({}, changeEventInfo.pagination), {
        current: current2,
        pageSize
      })
    }, "paginate");
  };
  const [mergedPagination, resetPagination] = usePagination_default(mergedData.length, onPaginationChange, pagination);
  changeEventInfo.pagination = pagination === false ? {} : getPaginationParam(mergedPagination, pagination);
  changeEventInfo.resetPagination = resetPagination;
  const pageData = React490.useMemo(() => {
    if (pagination === false || !mergedPagination.pageSize) {
      return mergedData;
    }
    const {
      current: current2 = 1,
      total,
      pageSize = DEFAULT_PAGE_SIZE
    } = mergedPagination;
    true ? warning6(current2 > 0, "usage", "`current` should be positive number.") : void 0;
    if (mergedData.length < total) {
      if (mergedData.length > pageSize) {
        true ? warning6(false, "usage", "`dataSource` length is less than `pagination.total` but large than `pagination.pageSize`. Please make sure your config correct data with async mode.") : void 0;
        return mergedData.slice((current2 - 1) * pageSize, current2 * pageSize);
      }
      return mergedData;
    }
    return mergedData.slice((current2 - 1) * pageSize, current2 * pageSize);
  }, [!!pagination, mergedData, mergedPagination === null || mergedPagination === void 0 ? void 0 : mergedPagination.current, mergedPagination === null || mergedPagination === void 0 ? void 0 : mergedPagination.pageSize, mergedPagination === null || mergedPagination === void 0 ? void 0 : mergedPagination.total]);
  const [transformSelectionColumns, selectedKeySet] = useSelection_default({
    prefixCls,
    data: mergedData,
    pageData,
    getRowKey,
    getRecordByKey,
    expandType,
    childrenColumnName,
    locale: tableLocale,
    getPopupContainer: getPopupContainer || getContextPopupContainer
  }, rowSelection);
  const internalRowClassName = (record, index3, indent) => {
    let mergedRowClassName;
    if (typeof rowClassName === "function") {
      mergedRowClassName = (0, import_classnames196.default)(rowClassName(record, index3, indent));
    } else {
      mergedRowClassName = (0, import_classnames196.default)(rowClassName);
    }
    return (0, import_classnames196.default)({
      [`${prefixCls}-row-selected`]: selectedKeySet.has(getRowKey(record, index3))
    }, mergedRowClassName);
  };
  mergedExpandable.__PARENT_RENDER_ICON__ = mergedExpandable.expandIcon;
  mergedExpandable.expandIcon = mergedExpandable.expandIcon || expandIcon || ExpandIcon_default(tableLocale);
  if (expandType === "nest" && mergedExpandable.expandIconColumnIndex === void 0) {
    mergedExpandable.expandIconColumnIndex = rowSelection ? 1 : 0;
  } else if (mergedExpandable.expandIconColumnIndex > 0 && rowSelection) {
    mergedExpandable.expandIconColumnIndex -= 1;
  }
  if (typeof mergedExpandable.indentSize !== "number") {
    mergedExpandable.indentSize = typeof indentSize === "number" ? indentSize : 15;
  }
  const transformColumns = React490.useCallback((innerColumns) => transformTitleColumns(transformSelectionColumns(transformFilterColumns(transformSorterColumns(innerColumns)))), [transformSorterColumns, transformFilterColumns, transformSelectionColumns]);
  let topPaginationNode;
  let bottomPaginationNode;
  if (pagination !== false && (mergedPagination === null || mergedPagination === void 0 ? void 0 : mergedPagination.total)) {
    let paginationSize;
    if (mergedPagination.size) {
      paginationSize = mergedPagination.size;
    } else {
      paginationSize = mergedSize === "small" || mergedSize === "middle" ? "small" : void 0;
    }
    const renderPagination = (position4) => /* @__PURE__ */ React490.createElement(pagination_default, Object.assign({}, mergedPagination, {
      className: (0, import_classnames196.default)(`${prefixCls}-pagination ${prefixCls}-pagination-${position4}`, mergedPagination.className),
      size: paginationSize
    }));
    const defaultPosition = direction === "rtl" ? "left" : "right";
    const {
      position: position3
    } = mergedPagination;
    if (position3 !== null && Array.isArray(position3)) {
      const topPos = position3.find((p) => p.includes("top"));
      const bottomPos = position3.find((p) => p.includes("bottom"));
      const isDisable = position3.every((p) => `${p}` === "none");
      if (!topPos && !bottomPos && !isDisable) {
        bottomPaginationNode = renderPagination(defaultPosition);
      }
      if (topPos) {
        topPaginationNode = renderPagination(topPos.toLowerCase().replace("top", ""));
      }
      if (bottomPos) {
        bottomPaginationNode = renderPagination(bottomPos.toLowerCase().replace("bottom", ""));
      }
    } else {
      bottomPaginationNode = renderPagination(defaultPosition);
    }
  }
  let spinProps;
  if (typeof loading === "boolean") {
    spinProps = {
      spinning: loading
    };
  } else if (typeof loading === "object") {
    spinProps = Object.assign({
      spinning: true
    }, loading);
  }
  const wrapperClassNames = (0, import_classnames196.default)(cssVarCls, rootCls, `${prefixCls}-wrapper`, table === null || table === void 0 ? void 0 : table.className, {
    [`${prefixCls}-wrapper-rtl`]: direction === "rtl"
  }, className2, rootClassName, hashId);
  const mergedStyle = Object.assign(Object.assign({}, table === null || table === void 0 ? void 0 : table.style), style2);
  const mergedEmptyNode = React490.useMemo(() => {
    if ((spinProps === null || spinProps === void 0 ? void 0 : spinProps.spinning) && rawData === EMPTY_LIST6) {
      return null;
    }
    if (typeof (locale6 === null || locale6 === void 0 ? void 0 : locale6.emptyText) !== "undefined") {
      return locale6.emptyText;
    }
    return (renderEmpty === null || renderEmpty === void 0 ? void 0 : renderEmpty("Table")) || /* @__PURE__ */ React490.createElement(defaultRenderEmpty_default, {
      componentName: "Table"
    });
  }, [spinProps === null || spinProps === void 0 ? void 0 : spinProps.spinning, rawData, locale6 === null || locale6 === void 0 ? void 0 : locale6.emptyText, renderEmpty]);
  const TableComponent = virtual ? VirtualTable_default2 : RcTable_default;
  const virtualProps = {};
  const listItemHeight = React490.useMemo(() => {
    const {
      fontSize,
      lineHeight,
      lineWidth,
      padding,
      paddingXS,
      paddingSM
    } = token2;
    const fontHeight = Math.floor(fontSize * lineHeight);
    switch (mergedSize) {
      case "middle":
        return paddingSM * 2 + fontHeight + lineWidth;
      case "small":
        return paddingXS * 2 + fontHeight + lineWidth;
      default:
        return padding * 2 + fontHeight + lineWidth;
    }
  }, [token2, mergedSize]);
  if (virtual) {
    virtualProps.listItemHeight = listItemHeight;
  }
  return wrapCSSVar(/* @__PURE__ */ React490.createElement("div", {
    ref: rootRef,
    className: wrapperClassNames,
    style: mergedStyle
  }, /* @__PURE__ */ React490.createElement(spin_default, Object.assign({
    spinning: false
  }, spinProps), topPaginationNode, /* @__PURE__ */ React490.createElement(TableComponent, Object.assign({}, virtualProps, tableProps, {
    ref: tblRef,
    columns: mergedColumns,
    direction,
    expandable: mergedExpandable,
    prefixCls,
    className: (0, import_classnames196.default)({
      [`${prefixCls}-middle`]: mergedSize === "middle",
      [`${prefixCls}-small`]: mergedSize === "small",
      [`${prefixCls}-bordered`]: bordered,
      [`${prefixCls}-empty`]: rawData.length === 0
    }, cssVarCls, rootCls, hashId),
    data: pageData,
    rowKey: getRowKey,
    rowClassName: internalRowClassName,
    emptyText: mergedEmptyNode,
    // Internal
    internalHooks: INTERNAL_HOOKS,
    internalRefs,
    transformColumns,
    getContainerWidth
  })), bottomPaginationNode)));
};
var InternalTable_default = /* @__PURE__ */ React490.forwardRef(InternalTable);

// ../../node_modules/antd/es/table/Table.js
var Table3 = (props, ref3) => {
  const renderTimesRef = React491.useRef(0);
  renderTimesRef.current += 1;
  return /* @__PURE__ */ React491.createElement(InternalTable_default, Object.assign({}, props, {
    ref: ref3,
    _renderTimes: renderTimesRef.current
  }));
};
var ForwardTable = /* @__PURE__ */ React491.forwardRef(Table3);
ForwardTable.SELECTION_COLUMN = SELECTION_COLUMN;
ForwardTable.EXPAND_COLUMN = EXPAND_COLUMN;
ForwardTable.SELECTION_ALL = SELECTION_ALL;
ForwardTable.SELECTION_INVERT = SELECTION_INVERT;
ForwardTable.SELECTION_NONE = SELECTION_NONE;
ForwardTable.Column = Column_default2;
ForwardTable.ColumnGroup = ColumnGroup_default2;
ForwardTable.Summary = FooterComponents;
if (true) {
  ForwardTable.displayName = "Table";
}
var Table_default2 = ForwardTable;

// ../../node_modules/antd/es/table/index.js
var table_default = Table_default2;

// ../../node_modules/antd/es/theme/getDesignToken.js
var getDesignToken = (config) => {
  const theme = (config === null || config === void 0 ? void 0 : config.algorithm) ? createTheme(config.algorithm) : theme_default;
  const mergedToken = Object.assign(Object.assign({}, seed_default), config === null || config === void 0 ? void 0 : config.token);
  return getComputedToken(mergedToken, {
    override: config === null || config === void 0 ? void 0 : config.token
  }, theme, formatToken);
};
var getDesignToken_default = getDesignToken;

// ../../node_modules/antd/es/theme/themes/compact/genCompactSizeMapToken.js
function genSizeMapToken2(token2) {
  const {
    sizeUnit,
    sizeStep
  } = token2;
  const compactSizeStep = sizeStep - 2;
  return {
    sizeXXL: sizeUnit * (compactSizeStep + 10),
    sizeXL: sizeUnit * (compactSizeStep + 6),
    sizeLG: sizeUnit * (compactSizeStep + 2),
    sizeMD: sizeUnit * (compactSizeStep + 2),
    sizeMS: sizeUnit * (compactSizeStep + 1),
    size: sizeUnit * compactSizeStep,
    sizeSM: sizeUnit * compactSizeStep,
    sizeXS: sizeUnit * (compactSizeStep - 1),
    sizeXXS: sizeUnit * (compactSizeStep - 1)
  };
}

// ../../node_modules/antd/es/theme/themes/compact/index.js
var derivative2 = (token2, mapToken) => {
  const mergedMapToken = mapToken !== null && mapToken !== void 0 ? mapToken : derivative(token2);
  const fontSize = mergedMapToken.fontSizeSM;
  const controlHeight = mergedMapToken.controlHeight - 4;
  return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, mergedMapToken), genSizeMapToken2(mapToken !== null && mapToken !== void 0 ? mapToken : token2)), genFontMapToken_default(fontSize)), {
    // controlHeight
    controlHeight
  }), genControlHeight_default(Object.assign(Object.assign({}, mergedMapToken), {
    controlHeight
  })));
};
var compact_default3 = derivative2;

// ../../node_modules/antd/es/theme/themes/dark/colorAlgorithm.js
var getAlphaColor3 = (baseColor, alpha) => new FastColor(baseColor).setA(alpha).toRgbString();
var getSolidColor2 = (baseColor, brightness) => {
  const instance = new FastColor(baseColor);
  return instance.lighten(brightness).toHexString();
};

// ../../node_modules/antd/es/theme/themes/dark/colors.js
var generateColorPalettes2 = (baseColor) => {
  const colors = generate(baseColor, {
    theme: "dark"
  });
  return {
    1: colors[0],
    2: colors[1],
    3: colors[2],
    4: colors[3],
    5: colors[6],
    6: colors[5],
    7: colors[4],
    8: colors[6],
    9: colors[5],
    10: colors[4]
    // 8: colors[9],
    // 9: colors[8],
    // 10: colors[7],
  };
};
var generateNeutralColorPalettes2 = (bgBaseColor, textBaseColor) => {
  const colorBgBase = bgBaseColor || "#000";
  const colorTextBase = textBaseColor || "#fff";
  return {
    colorBgBase,
    colorTextBase,
    colorText: getAlphaColor3(colorTextBase, 0.85),
    colorTextSecondary: getAlphaColor3(colorTextBase, 0.65),
    colorTextTertiary: getAlphaColor3(colorTextBase, 0.45),
    colorTextQuaternary: getAlphaColor3(colorTextBase, 0.25),
    colorFill: getAlphaColor3(colorTextBase, 0.18),
    colorFillSecondary: getAlphaColor3(colorTextBase, 0.12),
    colorFillTertiary: getAlphaColor3(colorTextBase, 0.08),
    colorFillQuaternary: getAlphaColor3(colorTextBase, 0.04),
    colorBgSolid: getAlphaColor3(colorTextBase, 0.95),
    colorBgSolidHover: getAlphaColor3(colorTextBase, 1),
    colorBgSolidActive: getAlphaColor3(colorTextBase, 0.9),
    colorBgElevated: getSolidColor2(colorBgBase, 12),
    colorBgContainer: getSolidColor2(colorBgBase, 8),
    colorBgLayout: getSolidColor2(colorBgBase, 0),
    colorBgSpotlight: getSolidColor2(colorBgBase, 26),
    colorBgBlur: getAlphaColor3(colorTextBase, 0.04),
    colorBorder: getSolidColor2(colorBgBase, 26),
    colorBorderSecondary: getSolidColor2(colorBgBase, 19)
  };
};

// ../../node_modules/antd/es/theme/themes/dark/index.js
var derivative3 = (token2, mapToken) => {
  const colorPalettes = Object.keys(defaultPresetColors).map((colorKey) => {
    const colors = generate(token2[colorKey], {
      theme: "dark"
    });
    return Array.from({
      length: 10
    }, () => 1).reduce((prev2, _, i) => {
      prev2[`${colorKey}-${i + 1}`] = colors[i];
      prev2[`${colorKey}${i + 1}`] = colors[i];
      return prev2;
    }, {});
  }).reduce((prev2, cur) => {
    prev2 = Object.assign(Object.assign({}, prev2), cur);
    return prev2;
  }, {});
  const mergedMapToken = mapToken !== null && mapToken !== void 0 ? mapToken : derivative(token2);
  const colorMapToken = genColorMapToken(token2, {
    generateColorPalettes: generateColorPalettes2,
    generateNeutralColorPalettes: generateNeutralColorPalettes2
  });
  return Object.assign(Object.assign(Object.assign(Object.assign({}, mergedMapToken), colorPalettes), colorMapToken), {
    // Customize selected item background color
    // https://github.com/ant-design/ant-design/issues/30524#issuecomment-871961867
    colorPrimaryBg: colorMapToken.colorPrimaryBorder,
    colorPrimaryBgHover: colorMapToken.colorPrimaryBorderHover
  });
};
var dark_default = derivative3;

// ../../node_modules/antd/es/theme/index.js
function useToken2() {
  const [theme, token2, hashId] = useToken();
  return {
    theme,
    token: token2,
    hashId
  };
}
var theme_default3 = {
  /** Default seedToken */
  defaultSeed: defaultConfig.token,
  useToken: useToken2,
  defaultAlgorithm: derivative,
  darkAlgorithm: dark_default,
  compactAlgorithm: compact_default3,
  getDesignToken: getDesignToken_default,
  /**
   * @private Private variable
   * @warring 🔥 Do not use in production. 🔥
   */
  defaultConfig,
  /**
   * @private Private variable
   * @warring 🔥 Do not use in production. 🔥
   */
  _internalContext: DesignTokenContext
};

// ../../node_modules/@ant-design/icons/es/icons/DeleteOutlined.js
var React492 = __toESM(require_react());

// ../../node_modules/@ant-design/icons-svg/es/asn/DeleteOutlined.js
var DeleteOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M360 184h-8c4.4 0 8-3.6 8-8v8h304v-8c0 4.4 3.6 8 8 8h-8v72h72v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80h72v-72zm504 72H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM731.3 840H292.7l-24.2-512h487l-24.2 512z" } }] }, "name": "delete", "theme": "outlined" };
var DeleteOutlined_default = DeleteOutlined;

// ../../node_modules/@ant-design/icons/es/icons/DeleteOutlined.js
var DeleteOutlined2 = function DeleteOutlined3(props, ref3) {
  return /* @__PURE__ */ React492.createElement(AntdIcon_default, _extends({}, props, {
    ref: ref3,
    icon: DeleteOutlined_default
  }));
};
var RefIcon41 = /* @__PURE__ */ React492.forwardRef(DeleteOutlined2);
if (true) {
  RefIcon41.displayName = "DeleteOutlined";
}
var DeleteOutlined_default2 = RefIcon41;

// ../../node_modules/antd/es/tree-select/index.js
var React504 = __toESM(require_react());
var import_classnames197 = __toESM(require_classnames());

// ../../node_modules/rc-tree-select/es/TreeSelect.js
var React503 = __toESM(require_react());

// ../../node_modules/rc-tree-select/es/hooks/useCache.js
var React493 = __toESM(require_react());
var useCache_default2 = (function(values) {
  var cacheRef = React493.useRef({
    valueLabels: /* @__PURE__ */ new Map()
  });
  return React493.useMemo(function() {
    var valueLabels = cacheRef.current.valueLabels;
    var valueLabelsCache = /* @__PURE__ */ new Map();
    var filledValues = values.map(function(item) {
      var value = item.value, label = item.label;
      var mergedLabel = label !== null && label !== void 0 ? label : valueLabels.get(value);
      valueLabelsCache.set(value, mergedLabel);
      return _objectSpread2(_objectSpread2({}, item), {}, {
        label: mergedLabel
      });
    });
    cacheRef.current.valueLabels = valueLabelsCache;
    return [filledValues];
  }, [values]);
});

// ../../node_modules/rc-tree-select/es/hooks/useCheckedKeys.js
var React494 = __toESM(require_react());
var useCheckedKeys = function useCheckedKeys2(rawLabeledValues, rawHalfCheckedValues, treeConduction, keyEntities) {
  return React494.useMemo(function() {
    var extractValues = function extractValues2(values) {
      return values.map(function(_ref) {
        var value = _ref.value;
        return value;
      });
    };
    var checkedKeys = extractValues(rawLabeledValues);
    var halfCheckedKeys = extractValues(rawHalfCheckedValues);
    var missingValues = checkedKeys.filter(function(key2) {
      return !keyEntities[key2];
    });
    var finalCheckedKeys = checkedKeys;
    var finalHalfCheckedKeys = halfCheckedKeys;
    if (treeConduction) {
      var conductResult = conductCheck(checkedKeys, true, keyEntities);
      finalCheckedKeys = conductResult.checkedKeys;
      finalHalfCheckedKeys = conductResult.halfCheckedKeys;
    }
    return [Array.from(new Set([].concat(_toConsumableArray(missingValues), _toConsumableArray(finalCheckedKeys)))), finalHalfCheckedKeys];
  }, [rawLabeledValues, rawHalfCheckedValues, treeConduction, keyEntities]);
};
var useCheckedKeys_default = useCheckedKeys;

// ../../node_modules/rc-tree-select/es/hooks/useDataEntities.js
var React495 = __toESM(require_react());

// ../../node_modules/rc-tree-select/es/utils/valueUtil.js
var toArray9 = function toArray10(value) {
  return Array.isArray(value) ? value : value !== void 0 ? [value] : [];
};
var fillFieldNames3 = function fillFieldNames4(fieldNames) {
  var _ref = fieldNames || {}, label = _ref.label, value = _ref.value, children = _ref.children;
  return {
    _title: label ? [label] : ["title", "label"],
    value: value || "value",
    key: value || "value",
    children: children || "children"
  };
};
var isCheckDisabled2 = function isCheckDisabled3(node2) {
  return !node2 || node2.disabled || node2.disableCheckbox || node2.checkable === false;
};
var getAllKeys = function getAllKeys2(treeData, fieldNames) {
  var keys4 = [];
  var dig = function dig2(list) {
    list.forEach(function(item) {
      var children = item[fieldNames.children];
      if (children) {
        keys4.push(item[fieldNames.value]);
        dig2(children);
      }
    });
  };
  dig(treeData);
  return keys4;
};
var isNil = function isNil2(val) {
  return val === null || val === void 0;
};

// ../../node_modules/rc-tree-select/es/hooks/useDataEntities.js
var useDataEntities_default = (function(treeData, fieldNames) {
  return React495.useMemo(function() {
    var collection = convertDataToEntities(treeData, {
      fieldNames,
      initWrapper: function initWrapper(wrapper) {
        return _objectSpread2(_objectSpread2({}, wrapper), {}, {
          valueEntities: /* @__PURE__ */ new Map()
        });
      },
      processEntity: function processEntity(entity, wrapper) {
        var val = entity.node[fieldNames.value];
        if (true) {
          var key2 = entity.node.key;
          warning_default(!isNil(val), "TreeNode `value` is invalidate: undefined");
          warning_default(!wrapper.valueEntities.has(val), "Same `value` exist in the tree: ".concat(val));
          warning_default(!key2 || String(key2) === String(val), "`key` or `value` with TreeNode must be the same or you can remove one of them. key: ".concat(key2, ", value: ").concat(val, "."));
        }
        wrapper.valueEntities.set(val, entity);
      }
    });
    return collection;
  }, [treeData, fieldNames]);
});

// ../../node_modules/rc-tree-select/es/hooks/useFilterTreeData.js
var React497 = __toESM(require_react());

// ../../node_modules/rc-tree-select/es/utils/legacyUtil.js
var React496 = __toESM(require_react());

// ../../node_modules/rc-tree-select/es/TreeNode.js
var TreeNode3 = function TreeNode4() {
  return null;
};
var TreeNode_default2 = TreeNode3;

// ../../node_modules/rc-tree-select/es/utils/legacyUtil.js
var _excluded73 = ["children", "value"];
function convertChildrenToData2(nodes) {
  return toArray(nodes).map(function(node2) {
    if (!/* @__PURE__ */ React496.isValidElement(node2) || !node2.type) {
      return null;
    }
    var _ref = node2, key2 = _ref.key, _ref$props = _ref.props, children = _ref$props.children, value = _ref$props.value, restProps = _objectWithoutProperties(_ref$props, _excluded73);
    var data2 = _objectSpread2({
      key: key2,
      value
    }, restProps);
    var childData = convertChildrenToData2(children);
    if (childData.length) {
      data2.children = childData;
    }
    return data2;
  }).filter(function(data2) {
    return data2;
  });
}
function fillLegacyProps(dataNode) {
  if (!dataNode) {
    return dataNode;
  }
  var cloneNode = _objectSpread2({}, dataNode);
  if (!("props" in cloneNode)) {
    Object.defineProperty(cloneNode, "props", {
      get: function get3() {
        warning_default(false, "New `rc-tree-select` not support return node instance as argument anymore. Please consider to remove `props` access.");
        return cloneNode;
      }
    });
  }
  return cloneNode;
}
function fillAdditionalInfo(extra, triggerValue, checkedValues, treeData, showPosition, fieldNames) {
  var triggerNode = null;
  var nodeList = null;
  function generateMap() {
    function dig(list) {
      var level = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "0";
      var parentIncluded = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
      return list.map(function(option, index3) {
        var pos = "".concat(level, "-").concat(index3);
        var value = option[fieldNames.value];
        var included = checkedValues.includes(value);
        var children = dig(option[fieldNames.children] || [], pos, included);
        var node2 = /* @__PURE__ */ React496.createElement(TreeNode_default2, option, children.map(function(child) {
          return child.node;
        }));
        if (triggerValue === value) {
          triggerNode = node2;
        }
        if (included) {
          var checkedNode = {
            pos,
            node: node2,
            children
          };
          if (!parentIncluded) {
            nodeList.push(checkedNode);
          }
          return checkedNode;
        }
        return null;
      }).filter(function(node2) {
        return node2;
      });
    }
    if (!nodeList) {
      nodeList = [];
      dig(treeData);
      nodeList.sort(function(_ref2, _ref3) {
        var val1 = _ref2.node.props.value;
        var val2 = _ref3.node.props.value;
        var index1 = checkedValues.indexOf(val1);
        var index22 = checkedValues.indexOf(val2);
        return index1 - index22;
      });
    }
  }
  Object.defineProperty(extra, "triggerNode", {
    get: function get3() {
      warning_default(false, "`triggerNode` is deprecated. Please consider decoupling data with node.");
      generateMap();
      return triggerNode;
    }
  });
  Object.defineProperty(extra, "allCheckedNodes", {
    get: function get3() {
      warning_default(false, "`allCheckedNodes` is deprecated. Please consider decoupling data with node.");
      generateMap();
      if (showPosition) {
        return nodeList;
      }
      return nodeList.map(function(_ref4) {
        var node2 = _ref4.node;
        return node2;
      });
    }
  });
}

// ../../node_modules/rc-tree-select/es/hooks/useFilterTreeData.js
var useFilterTreeData = function useFilterTreeData2(treeData, searchValue, options) {
  var fieldNames = options.fieldNames, treeNodeFilterProp = options.treeNodeFilterProp, filterTreeNode = options.filterTreeNode;
  var fieldChildren = fieldNames.children;
  return React497.useMemo(function() {
    if (!searchValue || filterTreeNode === false) {
      return treeData;
    }
    var filterOptionFunc = typeof filterTreeNode === "function" ? filterTreeNode : function(_, dataNode) {
      return String(dataNode[treeNodeFilterProp]).toUpperCase().includes(searchValue.toUpperCase());
    };
    var filterTreeNodes = function filterTreeNodes2(nodes) {
      var keepAll = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
      return nodes.reduce(function(filtered, node2) {
        var children = node2[fieldChildren];
        var isMatch2 = keepAll || filterOptionFunc(searchValue, fillLegacyProps(node2));
        var filteredChildren = filterTreeNodes2(children || [], isMatch2);
        if (isMatch2 || filteredChildren.length) {
          filtered.push(_objectSpread2(_objectSpread2({}, node2), {}, _defineProperty({
            isLeaf: void 0
          }, fieldChildren, filteredChildren)));
        }
        return filtered;
      }, []);
    };
    return filterTreeNodes(treeData);
  }, [treeData, searchValue, fieldChildren, treeNodeFilterProp, filterTreeNode]);
};
var useFilterTreeData_default = useFilterTreeData;

// ../../node_modules/rc-tree-select/es/hooks/useRefFunc.js
var React498 = __toESM(require_react());
function useRefFunc2(callback) {
  var funcRef = React498.useRef();
  funcRef.current = callback;
  var cacheFn = React498.useCallback(function() {
    return funcRef.current.apply(funcRef, arguments);
  }, []);
  return cacheFn;
}

// ../../node_modules/rc-tree-select/es/hooks/useTreeData.js
var React499 = __toESM(require_react());
function buildTreeStructure(nodes, config) {
  var id = config.id, pId = config.pId, rootPId = config.rootPId;
  var nodeMap = /* @__PURE__ */ new Map();
  var rootNodes = [];
  nodes.forEach(function(node2) {
    var nodeKey = node2[id];
    var clonedNode = _objectSpread2(_objectSpread2({}, node2), {}, {
      key: node2.key || nodeKey
    });
    nodeMap.set(nodeKey, clonedNode);
  });
  nodeMap.forEach(function(node2) {
    var parentKey = node2[pId];
    var parent2 = nodeMap.get(parentKey);
    if (parent2) {
      parent2.children = parent2.children || [];
      parent2.children.push(node2);
    } else if (parentKey === rootPId || rootPId === null) {
      rootNodes.push(node2);
    }
  });
  return rootNodes;
}
function useTreeData(treeData, children, simpleMode) {
  return React499.useMemo(function() {
    if (treeData) {
      if (simpleMode) {
        var config = _objectSpread2({
          id: "id",
          pId: "pId",
          rootPId: null
        }, _typeof(simpleMode) === "object" ? simpleMode : {});
        return buildTreeStructure(treeData, config);
      }
      return treeData;
    }
    return convertChildrenToData2(children);
  }, [children, simpleMode, treeData]);
}

// ../../node_modules/rc-tree-select/es/LegacyContext.js
var React500 = __toESM(require_react());
var LegacySelectContext = /* @__PURE__ */ React500.createContext(null);
var LegacyContext_default = LegacySelectContext;

// ../../node_modules/rc-tree-select/es/OptionList.js
var React502 = __toESM(require_react());

// ../../node_modules/rc-tree-select/es/TreeSelectContext.js
var React501 = __toESM(require_react());
var TreeSelectContext = /* @__PURE__ */ React501.createContext(null);
var TreeSelectContext_default = TreeSelectContext;

// ../../node_modules/rc-tree-select/es/OptionList.js
var HIDDEN_STYLE3 = {
  width: 0,
  height: 0,
  display: "flex",
  overflow: "hidden",
  opacity: 0,
  border: 0,
  padding: 0,
  margin: 0
};
var OptionList3 = function OptionList4(_, ref3) {
  var _useBaseProps = useBaseProps(), prefixCls = _useBaseProps.prefixCls, multiple = _useBaseProps.multiple, searchValue = _useBaseProps.searchValue, toggleOpen = _useBaseProps.toggleOpen, open2 = _useBaseProps.open, notFoundContent = _useBaseProps.notFoundContent;
  var _React$useContext = React502.useContext(TreeSelectContext_default), virtual = _React$useContext.virtual, listHeight = _React$useContext.listHeight, listItemHeight = _React$useContext.listItemHeight, listItemScrollOffset = _React$useContext.listItemScrollOffset, treeData = _React$useContext.treeData, fieldNames = _React$useContext.fieldNames, onSelect = _React$useContext.onSelect, dropdownMatchSelectWidth = _React$useContext.dropdownMatchSelectWidth, treeExpandAction = _React$useContext.treeExpandAction, treeTitleRender = _React$useContext.treeTitleRender, onPopupScroll = _React$useContext.onPopupScroll, leftMaxCount = _React$useContext.leftMaxCount, leafCountOnly = _React$useContext.leafCountOnly, valueEntities = _React$useContext.valueEntities;
  var _React$useContext2 = React502.useContext(LegacyContext_default), checkable = _React$useContext2.checkable, checkedKeys = _React$useContext2.checkedKeys, halfCheckedKeys = _React$useContext2.halfCheckedKeys, treeExpandedKeys = _React$useContext2.treeExpandedKeys, treeDefaultExpandAll = _React$useContext2.treeDefaultExpandAll, treeDefaultExpandedKeys = _React$useContext2.treeDefaultExpandedKeys, onTreeExpand = _React$useContext2.onTreeExpand, treeIcon = _React$useContext2.treeIcon, showTreeIcon = _React$useContext2.showTreeIcon, switcherIcon = _React$useContext2.switcherIcon, treeLine = _React$useContext2.treeLine, treeNodeFilterProp = _React$useContext2.treeNodeFilterProp, loadData = _React$useContext2.loadData, treeLoadedKeys = _React$useContext2.treeLoadedKeys, treeMotion = _React$useContext2.treeMotion, onTreeLoad = _React$useContext2.onTreeLoad, keyEntities = _React$useContext2.keyEntities;
  var treeRef = React502.useRef();
  var memoTreeData = useMemo3(
    function() {
      return treeData;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [open2, treeData],
    function(prev2, next2) {
      return next2[0] && prev2[1] !== next2[1];
    }
  );
  var mergedCheckedKeys = React502.useMemo(function() {
    if (!checkable) {
      return null;
    }
    return {
      checked: checkedKeys,
      halfChecked: halfCheckedKeys
    };
  }, [checkable, checkedKeys, halfCheckedKeys]);
  React502.useEffect(function() {
    if (open2 && !multiple && checkedKeys.length) {
      var _treeRef$current;
      (_treeRef$current = treeRef.current) === null || _treeRef$current === void 0 || _treeRef$current.scrollTo({
        key: checkedKeys[0]
      });
    }
  }, [open2]);
  var onListMouseDown = function onListMouseDown2(event) {
    event.preventDefault();
  };
  var onInternalSelect = function onInternalSelect2(__, info) {
    var node2 = info.node;
    if (checkable && isCheckDisabled2(node2)) {
      return;
    }
    onSelect(node2.key, {
      selected: !checkedKeys.includes(node2.key)
    });
    if (!multiple) {
      toggleOpen(false);
    }
  };
  var _React$useState = React502.useState(treeDefaultExpandedKeys), _React$useState2 = _slicedToArray(_React$useState, 2), expandedKeys = _React$useState2[0], setExpandedKeys = _React$useState2[1];
  var _React$useState3 = React502.useState(null), _React$useState4 = _slicedToArray(_React$useState3, 2), searchExpandedKeys = _React$useState4[0], setSearchExpandedKeys = _React$useState4[1];
  var mergedExpandedKeys = React502.useMemo(function() {
    if (treeExpandedKeys) {
      return _toConsumableArray(treeExpandedKeys);
    }
    return searchValue ? searchExpandedKeys : expandedKeys;
  }, [expandedKeys, searchExpandedKeys, treeExpandedKeys, searchValue]);
  var onInternalExpand = function onInternalExpand2(keys4) {
    setExpandedKeys(keys4);
    setSearchExpandedKeys(keys4);
    if (onTreeExpand) {
      onTreeExpand(keys4);
    }
  };
  var lowerSearchValue = String(searchValue).toLowerCase();
  var filterTreeNode = function filterTreeNode2(treeNode) {
    if (!lowerSearchValue) {
      return false;
    }
    return String(treeNode[treeNodeFilterProp]).toLowerCase().includes(lowerSearchValue);
  };
  React502.useEffect(function() {
    if (searchValue) {
      setSearchExpandedKeys(getAllKeys(treeData, fieldNames));
    }
  }, [searchValue]);
  var _React$useState5 = React502.useState(function() {
    return /* @__PURE__ */ new Map();
  }), _React$useState6 = _slicedToArray(_React$useState5, 2), disabledCache = _React$useState6[0], setDisabledCache = _React$useState6[1];
  React502.useEffect(function() {
    if (leftMaxCount) {
      setDisabledCache(/* @__PURE__ */ new Map());
    }
  }, [leftMaxCount]);
  function getDisabledWithCache(node2) {
    var value = node2[fieldNames.value];
    if (!disabledCache.has(value)) {
      var entity = valueEntities.get(value);
      var isLeaf = (entity.children || []).length === 0;
      if (!isLeaf) {
        var checkableChildren = entity.children.filter(function(childTreeNode) {
          return !childTreeNode.node.disabled && !childTreeNode.node.disableCheckbox && !checkedKeys.includes(childTreeNode.node[fieldNames.value]);
        });
        var checkableChildrenCount = checkableChildren.length;
        disabledCache.set(value, checkableChildrenCount > leftMaxCount);
      } else {
        disabledCache.set(value, false);
      }
    }
    return disabledCache.get(value);
  }
  var nodeDisabled = useEvent2(function(node2) {
    var nodeValue = node2[fieldNames.value];
    if (checkedKeys.includes(nodeValue)) {
      return false;
    }
    if (leftMaxCount === null) {
      return false;
    }
    if (leftMaxCount <= 0) {
      return true;
    }
    if (leafCountOnly && leftMaxCount) {
      return getDisabledWithCache(node2);
    }
    return false;
  });
  var getFirstMatchingNode = function getFirstMatchingNode2(nodes) {
    var _iterator = _createForOfIteratorHelper(nodes), _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done; ) {
        var node2 = _step.value;
        if (node2.disabled || node2.selectable === false) {
          continue;
        }
        if (searchValue) {
          if (filterTreeNode(node2)) {
            return node2;
          }
        } else {
          return node2;
        }
        if (node2[fieldNames.children]) {
          var matchInChildren = getFirstMatchingNode2(node2[fieldNames.children]);
          if (matchInChildren) {
            return matchInChildren;
          }
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return null;
  };
  var _React$useState7 = React502.useState(null), _React$useState8 = _slicedToArray(_React$useState7, 2), activeKey = _React$useState8[0], setActiveKey = _React$useState8[1];
  var activeEntity = keyEntities[activeKey];
  React502.useEffect(function() {
    if (!open2) {
      return;
    }
    var nextActiveKey = null;
    var getFirstNode = function getFirstNode2() {
      var firstNode = getFirstMatchingNode(memoTreeData);
      return firstNode ? firstNode[fieldNames.value] : null;
    };
    if (!multiple && checkedKeys.length && !searchValue) {
      nextActiveKey = checkedKeys[0];
    } else {
      nextActiveKey = getFirstNode();
    }
    setActiveKey(nextActiveKey);
  }, [open2, searchValue]);
  React502.useImperativeHandle(ref3, function() {
    var _treeRef$current2;
    return {
      scrollTo: (_treeRef$current2 = treeRef.current) === null || _treeRef$current2 === void 0 ? void 0 : _treeRef$current2.scrollTo,
      onKeyDown: function onKeyDown2(event) {
        var _treeRef$current3;
        var which = event.which;
        switch (which) {
          // >>> Arrow keys
          case KeyCode_default.UP:
          case KeyCode_default.DOWN:
          case KeyCode_default.LEFT:
          case KeyCode_default.RIGHT:
            (_treeRef$current3 = treeRef.current) === null || _treeRef$current3 === void 0 || _treeRef$current3.onKeyDown(event);
            break;
          // >>> Select item
          case KeyCode_default.ENTER: {
            if (activeEntity) {
              var isNodeDisabled = nodeDisabled(activeEntity.node);
              var _ref = (activeEntity === null || activeEntity === void 0 ? void 0 : activeEntity.node) || {}, selectable = _ref.selectable, value = _ref.value, disabled = _ref.disabled;
              if (selectable !== false && !disabled && !isNodeDisabled) {
                onInternalSelect(null, {
                  node: {
                    key: activeKey
                  },
                  selected: !checkedKeys.includes(value)
                });
              }
            }
            break;
          }
          // >>> Close
          case KeyCode_default.ESC: {
            toggleOpen(false);
          }
        }
      },
      onKeyUp: function onKeyUp() {
      }
    };
  });
  var hasLoadDataFn = useMemo3(function() {
    return searchValue ? false : true;
  }, [searchValue, treeExpandedKeys || expandedKeys], function(_ref2, _ref3) {
    var _ref4 = _slicedToArray(_ref2, 1), preSearchValue = _ref4[0];
    var _ref5 = _slicedToArray(_ref3, 2), nextSearchValue = _ref5[0], nextExcludeSearchExpandedKeys = _ref5[1];
    return preSearchValue !== nextSearchValue && !!(nextSearchValue || nextExcludeSearchExpandedKeys);
  });
  var syncLoadData = hasLoadDataFn ? loadData : null;
  if (memoTreeData.length === 0) {
    return /* @__PURE__ */ React502.createElement("div", {
      role: "listbox",
      className: "".concat(prefixCls, "-empty"),
      onMouseDown: onListMouseDown
    }, notFoundContent);
  }
  var treeProps = {
    fieldNames
  };
  if (treeLoadedKeys) {
    treeProps.loadedKeys = treeLoadedKeys;
  }
  if (mergedExpandedKeys) {
    treeProps.expandedKeys = mergedExpandedKeys;
  }
  return /* @__PURE__ */ React502.createElement("div", {
    onMouseDown: onListMouseDown
  }, activeEntity && open2 && /* @__PURE__ */ React502.createElement("span", {
    style: HIDDEN_STYLE3,
    "aria-live": "assertive"
  }, activeEntity.node.value), /* @__PURE__ */ React502.createElement(UnstableContext2.Provider, {
    value: {
      nodeDisabled
    }
  }, /* @__PURE__ */ React502.createElement(es_default27, _extends({
    ref: treeRef,
    focusable: false,
    prefixCls: "".concat(prefixCls, "-tree"),
    treeData: memoTreeData,
    height: listHeight,
    itemHeight: listItemHeight,
    itemScrollOffset: listItemScrollOffset,
    virtual: virtual !== false && dropdownMatchSelectWidth !== false,
    multiple,
    icon: treeIcon,
    showIcon: showTreeIcon,
    switcherIcon,
    showLine: treeLine,
    loadData: syncLoadData,
    motion: treeMotion,
    activeKey,
    checkable,
    checkStrictly: true,
    checkedKeys: mergedCheckedKeys,
    selectedKeys: !checkable ? checkedKeys : [],
    defaultExpandAll: treeDefaultExpandAll,
    titleRender: treeTitleRender
  }, treeProps, {
    // Proxy event out
    onActiveChange: setActiveKey,
    onSelect: onInternalSelect,
    onCheck: onInternalSelect,
    onExpand: onInternalExpand,
    onLoad: onTreeLoad,
    filterTreeNode,
    expandAction: treeExpandAction,
    onScroll: onPopupScroll
  }))));
};
var RefOptionList2 = /* @__PURE__ */ React502.forwardRef(OptionList3);
if (true) {
  RefOptionList2.displayName = "OptionList";
}
var OptionList_default2 = RefOptionList2;

// ../../node_modules/rc-tree-select/es/utils/strategyUtil.js
var SHOW_ALL = "SHOW_ALL";
var SHOW_PARENT = "SHOW_PARENT";
var SHOW_CHILD = "SHOW_CHILD";
function formatStrategyValues(values, strategy, keyEntities, fieldNames) {
  var valueSet = new Set(values);
  if (strategy === SHOW_CHILD) {
    return values.filter(function(key2) {
      var entity = keyEntities[key2];
      return !entity || !entity.children || !entity.children.some(function(_ref) {
        var node2 = _ref.node;
        return valueSet.has(node2[fieldNames.value]);
      }) || !entity.children.every(function(_ref2) {
        var node2 = _ref2.node;
        return isCheckDisabled2(node2) || valueSet.has(node2[fieldNames.value]);
      });
    });
  }
  if (strategy === SHOW_PARENT) {
    return values.filter(function(key2) {
      var entity = keyEntities[key2];
      var parent2 = entity ? entity.parent : null;
      return !parent2 || isCheckDisabled2(parent2.node) || !valueSet.has(parent2.key);
    });
  }
  return values;
}

// ../../node_modules/rc-tree-select/es/utils/warningPropsUtil.js
function warningProps2(props) {
  var searchPlaceholder = props.searchPlaceholder, treeCheckStrictly = props.treeCheckStrictly, treeCheckable = props.treeCheckable, labelInValue = props.labelInValue, value = props.value, multiple = props.multiple, showCheckedStrategy = props.showCheckedStrategy, maxCount = props.maxCount;
  warning_default(!searchPlaceholder, "`searchPlaceholder` has been removed.");
  if (treeCheckStrictly && labelInValue === false) {
    warning_default(false, "`treeCheckStrictly` will force set `labelInValue` to `true`.");
  }
  if (labelInValue || treeCheckStrictly) {
    warning_default(toArray9(value).every(function(val) {
      return val && _typeof(val) === "object" && "value" in val;
    }), "Invalid prop `value` supplied to `TreeSelect`. You should use { label: string, value: string | number } or [{ label: string, value: string | number }] instead.");
  }
  if (treeCheckStrictly || multiple || treeCheckable) {
    warning_default(!value || Array.isArray(value), "`value` should be an array when `TreeSelect` is checkable or multiple.");
  } else {
    warning_default(!Array.isArray(value), "`value` should not be array when `TreeSelect` is single mode.");
  }
  if (maxCount && (showCheckedStrategy === "SHOW_ALL" && !treeCheckStrictly || showCheckedStrategy === "SHOW_PARENT")) {
    warning_default(false, "`maxCount` not work with `showCheckedStrategy=SHOW_ALL` (when `treeCheckStrictly=false`) or `showCheckedStrategy=SHOW_PARENT`.");
  }
}
var warningPropsUtil_default2 = warningProps2;

// ../../node_modules/rc-tree-select/es/TreeSelect.js
var _excluded74 = ["id", "prefixCls", "value", "defaultValue", "onChange", "onSelect", "onDeselect", "searchValue", "inputValue", "onSearch", "autoClearSearchValue", "filterTreeNode", "treeNodeFilterProp", "showCheckedStrategy", "treeNodeLabelProp", "multiple", "treeCheckable", "treeCheckStrictly", "labelInValue", "maxCount", "fieldNames", "treeDataSimpleMode", "treeData", "children", "loadData", "treeLoadedKeys", "onTreeLoad", "treeDefaultExpandAll", "treeExpandedKeys", "treeDefaultExpandedKeys", "onTreeExpand", "treeExpandAction", "virtual", "listHeight", "listItemHeight", "listItemScrollOffset", "onDropdownVisibleChange", "dropdownMatchSelectWidth", "treeLine", "treeIcon", "showTreeIcon", "switcherIcon", "treeMotion", "treeTitleRender", "onPopupScroll"];
function isRawValue2(value) {
  return !value || _typeof(value) !== "object";
}
var TreeSelect = /* @__PURE__ */ React503.forwardRef(function(props, ref3) {
  var id = props.id, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-tree-select" : _props$prefixCls, value = props.value, defaultValue2 = props.defaultValue, onChange = props.onChange, onSelect = props.onSelect, onDeselect = props.onDeselect, searchValue = props.searchValue, inputValue = props.inputValue, onSearch = props.onSearch, _props$autoClearSearc = props.autoClearSearchValue, autoClearSearchValue = _props$autoClearSearc === void 0 ? true : _props$autoClearSearc, filterTreeNode = props.filterTreeNode, _props$treeNodeFilter = props.treeNodeFilterProp, treeNodeFilterProp = _props$treeNodeFilter === void 0 ? "value" : _props$treeNodeFilter, showCheckedStrategy = props.showCheckedStrategy, treeNodeLabelProp = props.treeNodeLabelProp, multiple = props.multiple, treeCheckable = props.treeCheckable, treeCheckStrictly = props.treeCheckStrictly, labelInValue = props.labelInValue, maxCount = props.maxCount, fieldNames = props.fieldNames, treeDataSimpleMode = props.treeDataSimpleMode, treeData = props.treeData, children = props.children, loadData = props.loadData, treeLoadedKeys = props.treeLoadedKeys, onTreeLoad = props.onTreeLoad, treeDefaultExpandAll = props.treeDefaultExpandAll, treeExpandedKeys = props.treeExpandedKeys, treeDefaultExpandedKeys = props.treeDefaultExpandedKeys, onTreeExpand = props.onTreeExpand, treeExpandAction = props.treeExpandAction, virtual = props.virtual, _props$listHeight = props.listHeight, listHeight = _props$listHeight === void 0 ? 200 : _props$listHeight, _props$listItemHeight = props.listItemHeight, listItemHeight = _props$listItemHeight === void 0 ? 20 : _props$listItemHeight, _props$listItemScroll = props.listItemScrollOffset, listItemScrollOffset = _props$listItemScroll === void 0 ? 0 : _props$listItemScroll, onDropdownVisibleChange = props.onDropdownVisibleChange, _props$dropdownMatchS = props.dropdownMatchSelectWidth, dropdownMatchSelectWidth = _props$dropdownMatchS === void 0 ? true : _props$dropdownMatchS, treeLine = props.treeLine, treeIcon = props.treeIcon, showTreeIcon = props.showTreeIcon, switcherIcon = props.switcherIcon, treeMotion = props.treeMotion, treeTitleRender = props.treeTitleRender, onPopupScroll = props.onPopupScroll, restProps = _objectWithoutProperties(props, _excluded74);
  var mergedId = useId3(id);
  var treeConduction = treeCheckable && !treeCheckStrictly;
  var mergedCheckable = treeCheckable || treeCheckStrictly;
  var mergedLabelInValue = treeCheckStrictly || labelInValue;
  var mergedMultiple = mergedCheckable || multiple;
  var _useMergedState = useMergedState(defaultValue2, {
    value
  }), _useMergedState2 = _slicedToArray(_useMergedState, 2), internalValue = _useMergedState2[0], setInternalValue = _useMergedState2[1];
  var mergedShowCheckedStrategy = React503.useMemo(function() {
    if (!treeCheckable) {
      return SHOW_ALL;
    }
    return showCheckedStrategy || SHOW_CHILD;
  }, [showCheckedStrategy, treeCheckable]);
  if (true) {
    warningPropsUtil_default2(props);
  }
  var mergedFieldNames = React503.useMemo(
    function() {
      return fillFieldNames3(fieldNames);
    },
    /* eslint-disable react-hooks/exhaustive-deps */
    [JSON.stringify(fieldNames)]
    /* eslint-enable react-hooks/exhaustive-deps */
  );
  var _useMergedState3 = useMergedState("", {
    value: searchValue !== void 0 ? searchValue : inputValue,
    postState: function postState(search) {
      return search || "";
    }
  }), _useMergedState4 = _slicedToArray(_useMergedState3, 2), mergedSearchValue = _useMergedState4[0], setSearchValue = _useMergedState4[1];
  var onInternalSearch = function onInternalSearch2(searchText) {
    setSearchValue(searchText);
    onSearch === null || onSearch === void 0 || onSearch(searchText);
  };
  var mergedTreeData = useTreeData(treeData, children, treeDataSimpleMode);
  var _useDataEntities = useDataEntities_default(mergedTreeData, mergedFieldNames), keyEntities = _useDataEntities.keyEntities, valueEntities = _useDataEntities.valueEntities;
  var splitRawValues = React503.useCallback(function(newRawValues) {
    var missingRawValues = [];
    var existRawValues = [];
    newRawValues.forEach(function(val) {
      if (valueEntities.has(val)) {
        existRawValues.push(val);
      } else {
        missingRawValues.push(val);
      }
    });
    return {
      missingRawValues,
      existRawValues
    };
  }, [valueEntities]);
  var filteredTreeData = useFilterTreeData_default(mergedTreeData, mergedSearchValue, {
    fieldNames: mergedFieldNames,
    treeNodeFilterProp,
    filterTreeNode
  });
  var getLabel5 = React503.useCallback(function(item) {
    if (item) {
      if (treeNodeLabelProp) {
        return item[treeNodeLabelProp];
      }
      var titleList = mergedFieldNames._title;
      for (var i = 0; i < titleList.length; i += 1) {
        var title = item[titleList[i]];
        if (title !== void 0) {
          return title;
        }
      }
    }
  }, [mergedFieldNames, treeNodeLabelProp]);
  var toLabeledValues = React503.useCallback(function(draftValues) {
    var values = toArray9(draftValues);
    return values.map(function(val) {
      if (isRawValue2(val)) {
        return {
          value: val
        };
      }
      return val;
    });
  }, []);
  var convert2LabelValues = React503.useCallback(function(draftValues) {
    var values = toLabeledValues(draftValues);
    return values.map(function(item) {
      var rawLabel = item.label;
      var rawValue = item.value, rawHalfChecked = item.halfChecked;
      var rawDisabled;
      var entity = valueEntities.get(rawValue);
      if (entity) {
        var _rawLabel;
        rawLabel = treeTitleRender ? treeTitleRender(entity.node) : (_rawLabel = rawLabel) !== null && _rawLabel !== void 0 ? _rawLabel : getLabel5(entity.node);
        rawDisabled = entity.node.disabled;
      } else if (rawLabel === void 0) {
        var labelInValueItem = toLabeledValues(internalValue).find(function(labeledItem) {
          return labeledItem.value === rawValue;
        });
        rawLabel = labelInValueItem.label;
      }
      return {
        label: rawLabel,
        value: rawValue,
        halfChecked: rawHalfChecked,
        disabled: rawDisabled
      };
    });
  }, [valueEntities, getLabel5, toLabeledValues, internalValue]);
  var rawMixedLabeledValues = React503.useMemo(function() {
    return toLabeledValues(internalValue === null ? [] : internalValue);
  }, [toLabeledValues, internalValue]);
  var _React$useMemo = React503.useMemo(function() {
    var fullCheckValues = [];
    var halfCheckValues = [];
    rawMixedLabeledValues.forEach(function(item) {
      if (item.halfChecked) {
        halfCheckValues.push(item);
      } else {
        fullCheckValues.push(item);
      }
    });
    return [fullCheckValues, halfCheckValues];
  }, [rawMixedLabeledValues]), _React$useMemo2 = _slicedToArray(_React$useMemo, 2), rawLabeledValues = _React$useMemo2[0], rawHalfLabeledValues = _React$useMemo2[1];
  var rawValues = React503.useMemo(function() {
    return rawLabeledValues.map(function(item) {
      return item.value;
    });
  }, [rawLabeledValues]);
  var _useCheckedKeys = useCheckedKeys_default(rawLabeledValues, rawHalfLabeledValues, treeConduction, keyEntities), _useCheckedKeys2 = _slicedToArray(_useCheckedKeys, 2), rawCheckedValues = _useCheckedKeys2[0], rawHalfCheckedValues = _useCheckedKeys2[1];
  var displayValues = React503.useMemo(function() {
    var displayKeys = formatStrategyValues(rawCheckedValues, mergedShowCheckedStrategy, keyEntities, mergedFieldNames);
    var values = displayKeys.map(function(key2) {
      var _keyEntities$key$node, _keyEntities$key;
      return (_keyEntities$key$node = (_keyEntities$key = keyEntities[key2]) === null || _keyEntities$key === void 0 || (_keyEntities$key = _keyEntities$key.node) === null || _keyEntities$key === void 0 ? void 0 : _keyEntities$key[mergedFieldNames.value]) !== null && _keyEntities$key$node !== void 0 ? _keyEntities$key$node : key2;
    });
    var labeledValues = values.map(function(val) {
      var targetItem = rawLabeledValues.find(function(item) {
        return item.value === val;
      });
      var label = labelInValue ? targetItem === null || targetItem === void 0 ? void 0 : targetItem.label : treeTitleRender === null || treeTitleRender === void 0 ? void 0 : treeTitleRender(targetItem);
      return {
        value: val,
        label
      };
    });
    var rawDisplayValues = convert2LabelValues(labeledValues);
    var firstVal = rawDisplayValues[0];
    if (!mergedMultiple && firstVal && isNil(firstVal.value) && isNil(firstVal.label)) {
      return [];
    }
    return rawDisplayValues.map(function(item) {
      var _item$label;
      return _objectSpread2(_objectSpread2({}, item), {}, {
        label: (_item$label = item.label) !== null && _item$label !== void 0 ? _item$label : item.value
      });
    });
  }, [mergedFieldNames, mergedMultiple, rawCheckedValues, rawLabeledValues, convert2LabelValues, mergedShowCheckedStrategy, keyEntities]);
  var _useCache = useCache_default2(displayValues), _useCache2 = _slicedToArray(_useCache, 1), cachedDisplayValues = _useCache2[0];
  var mergedMaxCount = React503.useMemo(function() {
    if (mergedMultiple && (mergedShowCheckedStrategy === "SHOW_CHILD" || treeCheckStrictly || !treeCheckable)) {
      return maxCount;
    }
    return null;
  }, [maxCount, mergedMultiple, treeCheckStrictly, mergedShowCheckedStrategy, treeCheckable]);
  var triggerChange = useRefFunc2(function(newRawValues, extra, source) {
    var formattedKeyList = formatStrategyValues(newRawValues, mergedShowCheckedStrategy, keyEntities, mergedFieldNames);
    if (mergedMaxCount && formattedKeyList.length > mergedMaxCount) {
      return;
    }
    var labeledValues = convert2LabelValues(newRawValues);
    setInternalValue(labeledValues);
    if (autoClearSearchValue) {
      setSearchValue("");
    }
    if (onChange) {
      var eventValues = newRawValues;
      if (treeConduction) {
        eventValues = formattedKeyList.map(function(key2) {
          var entity = valueEntities.get(key2);
          return entity ? entity.node[mergedFieldNames.value] : key2;
        });
      }
      var _ref = extra || {
        triggerValue: void 0,
        selected: void 0
      }, triggerValue = _ref.triggerValue, selected = _ref.selected;
      var returnRawValues = eventValues;
      if (treeCheckStrictly) {
        var halfValues = rawHalfLabeledValues.filter(function(item) {
          return !eventValues.includes(item.value);
        });
        returnRawValues = [].concat(_toConsumableArray(returnRawValues), _toConsumableArray(halfValues));
      }
      var returnLabeledValues = convert2LabelValues(returnRawValues);
      var additionalInfo = {
        // [Legacy] Always return as array contains label & value
        preValue: rawLabeledValues,
        triggerValue
      };
      var showPosition = true;
      if (treeCheckStrictly || source === "selection" && !selected) {
        showPosition = false;
      }
      fillAdditionalInfo(additionalInfo, triggerValue, newRawValues, mergedTreeData, showPosition, mergedFieldNames);
      if (mergedCheckable) {
        additionalInfo.checked = selected;
      } else {
        additionalInfo.selected = selected;
      }
      var returnValues = mergedLabelInValue ? returnLabeledValues : returnLabeledValues.map(function(item) {
        return item.value;
      });
      onChange(mergedMultiple ? returnValues : returnValues[0], mergedLabelInValue ? null : returnLabeledValues.map(function(item) {
        return item.label;
      }), additionalInfo);
    }
  });
  var onOptionSelect = React503.useCallback(function(selectedKey, _ref2) {
    var _node$mergedFieldName;
    var selected = _ref2.selected, source = _ref2.source;
    var entity = keyEntities[selectedKey];
    var node2 = entity === null || entity === void 0 ? void 0 : entity.node;
    var selectedValue = (_node$mergedFieldName = node2 === null || node2 === void 0 ? void 0 : node2[mergedFieldNames.value]) !== null && _node$mergedFieldName !== void 0 ? _node$mergedFieldName : selectedKey;
    if (!mergedMultiple) {
      triggerChange([selectedValue], {
        selected: true,
        triggerValue: selectedValue
      }, "option");
    } else {
      var newRawValues = selected ? [].concat(_toConsumableArray(rawValues), [selectedValue]) : rawCheckedValues.filter(function(v) {
        return v !== selectedValue;
      });
      if (treeConduction) {
        var _splitRawValues = splitRawValues(newRawValues), missingRawValues = _splitRawValues.missingRawValues, existRawValues = _splitRawValues.existRawValues;
        var keyList = existRawValues.map(function(val) {
          return valueEntities.get(val).key;
        });
        var checkedKeys;
        if (selected) {
          var _conductCheck = conductCheck(keyList, true, keyEntities);
          checkedKeys = _conductCheck.checkedKeys;
        } else {
          var _conductCheck2 = conductCheck(keyList, {
            checked: false,
            halfCheckedKeys: rawHalfCheckedValues
          }, keyEntities);
          checkedKeys = _conductCheck2.checkedKeys;
        }
        newRawValues = [].concat(_toConsumableArray(missingRawValues), _toConsumableArray(checkedKeys.map(function(key2) {
          return keyEntities[key2].node[mergedFieldNames.value];
        })));
      }
      triggerChange(newRawValues, {
        selected,
        triggerValue: selectedValue
      }, source || "option");
    }
    if (selected || !mergedMultiple) {
      onSelect === null || onSelect === void 0 || onSelect(selectedValue, fillLegacyProps(node2));
    } else {
      onDeselect === null || onDeselect === void 0 || onDeselect(selectedValue, fillLegacyProps(node2));
    }
  }, [splitRawValues, valueEntities, keyEntities, mergedFieldNames, mergedMultiple, rawValues, triggerChange, treeConduction, onSelect, onDeselect, rawCheckedValues, rawHalfCheckedValues, maxCount]);
  var onInternalDropdownVisibleChange = React503.useCallback(function(open2) {
    if (onDropdownVisibleChange) {
      var legacyParam = {};
      Object.defineProperty(legacyParam, "documentClickClose", {
        get: function get3() {
          warning_default(false, "Second param of `onDropdownVisibleChange` has been removed.");
          return false;
        }
      });
      onDropdownVisibleChange(open2, legacyParam);
    }
  }, [onDropdownVisibleChange]);
  var onDisplayValuesChange = useRefFunc2(function(newValues, info) {
    var newRawValues = newValues.map(function(item) {
      return item.value;
    });
    if (info.type === "clear") {
      triggerChange(newRawValues, {}, "selection");
      return;
    }
    if (info.values.length) {
      onOptionSelect(info.values[0].value, {
        selected: false,
        source: "selection"
      });
    }
  });
  var treeSelectContext = React503.useMemo(function() {
    return {
      virtual,
      dropdownMatchSelectWidth,
      listHeight,
      listItemHeight,
      listItemScrollOffset,
      treeData: filteredTreeData,
      fieldNames: mergedFieldNames,
      onSelect: onOptionSelect,
      treeExpandAction,
      treeTitleRender,
      onPopupScroll,
      leftMaxCount: maxCount === void 0 ? null : maxCount - cachedDisplayValues.length,
      leafCountOnly: mergedShowCheckedStrategy === "SHOW_CHILD" && !treeCheckStrictly && !!treeCheckable,
      valueEntities
    };
  }, [virtual, dropdownMatchSelectWidth, listHeight, listItemHeight, listItemScrollOffset, filteredTreeData, mergedFieldNames, onOptionSelect, treeExpandAction, treeTitleRender, onPopupScroll, maxCount, cachedDisplayValues.length, mergedShowCheckedStrategy, treeCheckStrictly, treeCheckable, valueEntities]);
  var legacyContext = React503.useMemo(function() {
    return {
      checkable: mergedCheckable,
      loadData,
      treeLoadedKeys,
      onTreeLoad,
      checkedKeys: rawCheckedValues,
      halfCheckedKeys: rawHalfCheckedValues,
      treeDefaultExpandAll,
      treeExpandedKeys,
      treeDefaultExpandedKeys,
      onTreeExpand,
      treeIcon,
      treeMotion,
      showTreeIcon,
      switcherIcon,
      treeLine,
      treeNodeFilterProp,
      keyEntities
    };
  }, [mergedCheckable, loadData, treeLoadedKeys, onTreeLoad, rawCheckedValues, rawHalfCheckedValues, treeDefaultExpandAll, treeExpandedKeys, treeDefaultExpandedKeys, onTreeExpand, treeIcon, treeMotion, showTreeIcon, switcherIcon, treeLine, treeNodeFilterProp, keyEntities]);
  return /* @__PURE__ */ React503.createElement(TreeSelectContext_default.Provider, {
    value: treeSelectContext
  }, /* @__PURE__ */ React503.createElement(LegacyContext_default.Provider, {
    value: legacyContext
  }, /* @__PURE__ */ React503.createElement(BaseSelect_default, _extends({
    ref: ref3
  }, restProps, {
    // >>> MISC
    id: mergedId,
    prefixCls,
    mode: mergedMultiple ? "multiple" : void 0,
    displayValues: cachedDisplayValues,
    onDisplayValuesChange,
    searchValue: mergedSearchValue,
    onSearch: onInternalSearch,
    OptionList: OptionList_default2,
    emptyOptions: !mergedTreeData.length,
    onDropdownVisibleChange: onInternalDropdownVisibleChange,
    dropdownMatchSelectWidth
  }))));
});
if (true) {
  TreeSelect.displayName = "TreeSelect";
}
var GenericTreeSelect = TreeSelect;
GenericTreeSelect.TreeNode = TreeNode_default2;
GenericTreeSelect.SHOW_ALL = SHOW_ALL;
GenericTreeSelect.SHOW_PARENT = SHOW_PARENT;
GenericTreeSelect.SHOW_CHILD = SHOW_CHILD;
var TreeSelect_default = GenericTreeSelect;

// ../../node_modules/rc-tree-select/es/index.js
var es_default28 = TreeSelect_default;

// ../../node_modules/antd/es/tree-select/style/index.js
var genBaseStyle12 = (token2) => {
  const {
    componentCls,
    treePrefixCls,
    colorBgElevated
  } = token2;
  const treeCls = `.${treePrefixCls}`;
  return [
    // ======================================================
    // ==                     Dropdown                     ==
    // ======================================================
    {
      [`${componentCls}-dropdown`]: [
        {
          padding: `${unit(token2.paddingXS)} ${unit(token2.calc(token2.paddingXS).div(2).equal())}`
        },
        // ====================== Tree ======================
        genTreeStyle(treePrefixCls, merge2(token2, {
          colorBgContainer: colorBgElevated
        }), false),
        {
          [treeCls]: {
            borderRadius: 0,
            [`${treeCls}-list-holder-inner`]: {
              alignItems: "stretch",
              [`${treeCls}-treenode`]: {
                [`${treeCls}-node-content-wrapper`]: {
                  flex: "auto"
                }
              }
            }
          }
        },
        // ==================== Checkbox ====================
        getStyle2(`${treePrefixCls}-checkbox`, token2),
        // ====================== RTL =======================
        {
          "&-rtl": {
            direction: "rtl",
            [`${treeCls}-switcher${treeCls}-switcher_close`]: {
              [`${treeCls}-switcher-icon svg`]: {
                transform: "rotate(90deg)"
              }
            }
          }
        }
      ]
    }
  ];
};
function useTreeSelectStyle(prefixCls, treePrefixCls, rootCls) {
  return genStyleHooks("TreeSelect", (token2) => {
    const treeSelectToken = merge2(token2, {
      treePrefixCls
    });
    return genBaseStyle12(treeSelectToken);
  }, initComponentToken2)(prefixCls, rootCls);
}

// ../../node_modules/antd/es/tree-select/index.js
var __rest64 = function(s, e3) {
  var t2 = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e3.indexOf(p) < 0) t2[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e3.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t2[p[i]] = s[p[i]];
  }
  return t2;
};
var InternalTreeSelect = (props, ref3) => {
  var _a, _b, _c, _d, _e;
  const {
    prefixCls: customizePrefixCls,
    size: customizeSize,
    disabled: customDisabled,
    bordered = true,
    style: style2,
    className: className2,
    rootClassName,
    treeCheckable,
    multiple,
    listHeight = 256,
    listItemHeight: customListItemHeight,
    placement,
    notFoundContent,
    switcherIcon,
    treeLine,
    getPopupContainer,
    popupClassName,
    dropdownClassName,
    treeIcon = false,
    transitionName,
    choiceTransitionName = "",
    status: customStatus,
    treeExpandAction,
    builtinPlacements,
    dropdownMatchSelectWidth,
    popupMatchSelectWidth,
    allowClear,
    variant: customVariant,
    dropdownStyle,
    dropdownRender,
    popupRender,
    onDropdownVisibleChange,
    onOpenChange,
    tagRender,
    maxCount,
    showCheckedStrategy,
    treeCheckStrictly,
    styles,
    classNames: classNames186
  } = props, restProps = __rest64(props, ["prefixCls", "size", "disabled", "bordered", "style", "className", "rootClassName", "treeCheckable", "multiple", "listHeight", "listItemHeight", "placement", "notFoundContent", "switcherIcon", "treeLine", "getPopupContainer", "popupClassName", "dropdownClassName", "treeIcon", "transitionName", "choiceTransitionName", "status", "treeExpandAction", "builtinPlacements", "dropdownMatchSelectWidth", "popupMatchSelectWidth", "allowClear", "variant", "dropdownStyle", "dropdownRender", "popupRender", "onDropdownVisibleChange", "onOpenChange", "tagRender", "maxCount", "showCheckedStrategy", "treeCheckStrictly", "styles", "classNames"]);
  const {
    getPopupContainer: getContextPopupContainer,
    getPrefixCls,
    renderEmpty,
    direction,
    virtual,
    popupMatchSelectWidth: contextPopupMatchSelectWidth,
    popupOverflow
  } = React504.useContext(ConfigContext);
  const {
    styles: contextStyles,
    classNames: contextClassNames
  } = useComponentConfig("treeSelect");
  const [, token2] = useToken();
  const listItemHeight = customListItemHeight !== null && customListItemHeight !== void 0 ? customListItemHeight : (token2 === null || token2 === void 0 ? void 0 : token2.controlHeightSM) + (token2 === null || token2 === void 0 ? void 0 : token2.paddingXXS);
  if (true) {
    const warning6 = devUseWarning("TreeSelect");
    const deprecatedProps = {
      dropdownMatchSelectWidth: "popupMatchSelectWidth",
      dropdownStyle: "styles.popup.root",
      dropdownClassName: "classNames.popup.root",
      popupClassName: "classNames.popup.root",
      dropdownRender: "popupRender",
      onDropdownVisibleChange: "onOpenChange",
      bordered: "variant"
    };
    Object.entries(deprecatedProps).forEach(([oldProp, newProp]) => {
      warning6.deprecated(!(oldProp in props), oldProp, newProp);
    });
    true ? warning6(multiple !== false || !treeCheckable, "usage", "`multiple` will always be `true` when `treeCheckable` is true") : void 0;
    true ? warning6(!("showArrow" in props), "deprecated", "`showArrow` is deprecated which will be removed in next major version. It will be a default behavior, you can hide it by setting `suffixIcon` to null.") : void 0;
  }
  const rootPrefixCls = getPrefixCls();
  const prefixCls = getPrefixCls("select", customizePrefixCls);
  const treePrefixCls = getPrefixCls("select-tree", customizePrefixCls);
  const treeSelectPrefixCls = getPrefixCls("tree-select", customizePrefixCls);
  const {
    compactSize,
    compactItemClassnames
  } = useCompactItemContext(prefixCls, direction);
  const rootCls = useCSSVarCls_default(prefixCls);
  const treeSelectRootCls = useCSSVarCls_default(treeSelectPrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = style_default9(prefixCls, rootCls);
  const [treeSelectWrapCSSVar] = useTreeSelectStyle(treeSelectPrefixCls, treePrefixCls, treeSelectRootCls);
  const [variant, enableVariantCls] = useVariants_default("treeSelect", customVariant, bordered);
  const mergedPopupClassName = (0, import_classnames197.default)(((_a = classNames186 === null || classNames186 === void 0 ? void 0 : classNames186.popup) === null || _a === void 0 ? void 0 : _a.root) || ((_b = contextClassNames === null || contextClassNames === void 0 ? void 0 : contextClassNames.popup) === null || _b === void 0 ? void 0 : _b.root) || popupClassName || dropdownClassName, `${treeSelectPrefixCls}-dropdown`, {
    [`${treeSelectPrefixCls}-dropdown-rtl`]: direction === "rtl"
  }, rootClassName, contextClassNames.root, classNames186 === null || classNames186 === void 0 ? void 0 : classNames186.root, cssVarCls, rootCls, treeSelectRootCls, hashId);
  const mergedPopupStyle = ((_c = styles === null || styles === void 0 ? void 0 : styles.popup) === null || _c === void 0 ? void 0 : _c.root) || ((_d = contextStyles === null || contextStyles === void 0 ? void 0 : contextStyles.popup) === null || _d === void 0 ? void 0 : _d.root) || dropdownStyle;
  const mergedPopupRender = usePopupRender_default(popupRender || dropdownRender);
  const mergedOnOpenChange = onOpenChange || onDropdownVisibleChange;
  const isMultiple3 = !!(treeCheckable || multiple);
  const mergedMaxCount = React504.useMemo(() => {
    if (maxCount && (showCheckedStrategy === "SHOW_ALL" && !treeCheckStrictly || showCheckedStrategy === "SHOW_PARENT")) {
      return void 0;
    }
    return maxCount;
  }, [maxCount, showCheckedStrategy, treeCheckStrictly]);
  const showSuffixIcon = useShowArrow(props.suffixIcon, props.showArrow);
  const mergedPopupMatchSelectWidth = (_e = popupMatchSelectWidth !== null && popupMatchSelectWidth !== void 0 ? popupMatchSelectWidth : dropdownMatchSelectWidth) !== null && _e !== void 0 ? _e : contextPopupMatchSelectWidth;
  const {
    status: contextStatus,
    hasFeedback,
    isFormItemInput,
    feedbackIcon
  } = React504.useContext(FormItemInputContext);
  const mergedStatus = getMergedStatus(contextStatus, customStatus);
  const {
    suffixIcon,
    removeIcon,
    clearIcon
  } = useIcons(Object.assign(Object.assign({}, restProps), {
    multiple: isMultiple3,
    showSuffixIcon,
    hasFeedback,
    feedbackIcon,
    prefixCls,
    componentName: "TreeSelect"
  }));
  const mergedAllowClear = allowClear === true ? {
    clearIcon
  } : allowClear;
  let mergedNotFound;
  if (notFoundContent !== void 0) {
    mergedNotFound = notFoundContent;
  } else {
    mergedNotFound = (renderEmpty === null || renderEmpty === void 0 ? void 0 : renderEmpty("Select")) || /* @__PURE__ */ React504.createElement(defaultRenderEmpty_default, {
      componentName: "Select"
    });
  }
  const selectProps = omit(restProps, ["suffixIcon", "removeIcon", "clearIcon", "itemIcon", "switcherIcon", "style"]);
  const memoizedPlacement = React504.useMemo(() => {
    if (placement !== void 0) {
      return placement;
    }
    return direction === "rtl" ? "bottomRight" : "bottomLeft";
  }, [placement, direction]);
  const mergedSize = useSize_default((ctx) => {
    var _a2;
    return (_a2 = customizeSize !== null && customizeSize !== void 0 ? customizeSize : compactSize) !== null && _a2 !== void 0 ? _a2 : ctx;
  });
  const disabled = React504.useContext(DisabledContext_default);
  const mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
  const mergedClassName = (0, import_classnames197.default)(!customizePrefixCls && treeSelectPrefixCls, {
    [`${prefixCls}-lg`]: mergedSize === "large",
    [`${prefixCls}-sm`]: mergedSize === "small",
    [`${prefixCls}-rtl`]: direction === "rtl",
    [`${prefixCls}-${variant}`]: enableVariantCls,
    [`${prefixCls}-in-form-item`]: isFormItemInput
  }, getStatusClassNames(prefixCls, mergedStatus, hasFeedback), compactItemClassnames, className2, rootClassName, contextClassNames.root, classNames186 === null || classNames186 === void 0 ? void 0 : classNames186.root, cssVarCls, rootCls, treeSelectRootCls, hashId);
  const renderSwitcherIcon = (nodeProps) => /* @__PURE__ */ React504.createElement(iconUtil_default, {
    prefixCls: treePrefixCls,
    switcherIcon,
    treeNodeProps: nodeProps,
    showLine: treeLine
  });
  const [zIndex] = useZIndex("SelectLike", mergedPopupStyle === null || mergedPopupStyle === void 0 ? void 0 : mergedPopupStyle.zIndex);
  const returnNode = /* @__PURE__ */ React504.createElement(es_default28, Object.assign({
    virtual,
    disabled: mergedDisabled
  }, selectProps, {
    dropdownMatchSelectWidth: mergedPopupMatchSelectWidth,
    builtinPlacements: mergedBuiltinPlacements_default(builtinPlacements, popupOverflow),
    ref: ref3,
    prefixCls,
    className: mergedClassName,
    style: Object.assign(Object.assign({}, styles === null || styles === void 0 ? void 0 : styles.root), style2),
    listHeight,
    listItemHeight,
    treeCheckable: treeCheckable ? /* @__PURE__ */ React504.createElement("span", {
      className: `${prefixCls}-tree-checkbox-inner`
    }) : treeCheckable,
    treeLine: !!treeLine,
    suffixIcon,
    multiple: isMultiple3,
    placement: memoizedPlacement,
    removeIcon,
    allowClear: mergedAllowClear,
    switcherIcon: renderSwitcherIcon,
    showTreeIcon: treeIcon,
    notFoundContent: mergedNotFound,
    getPopupContainer: getPopupContainer || getContextPopupContainer,
    treeMotion: null,
    dropdownClassName: mergedPopupClassName,
    dropdownStyle: Object.assign(Object.assign({}, mergedPopupStyle), {
      zIndex
    }),
    dropdownRender: mergedPopupRender,
    onDropdownVisibleChange: mergedOnOpenChange,
    choiceTransitionName: getTransitionName2(rootPrefixCls, "", choiceTransitionName),
    transitionName: getTransitionName2(rootPrefixCls, "slide-up", transitionName),
    treeExpandAction,
    tagRender: isMultiple3 ? tagRender : void 0,
    maxCount: mergedMaxCount,
    showCheckedStrategy,
    treeCheckStrictly
  }));
  return wrapCSSVar(treeSelectWrapCSSVar(returnNode));
};
var TreeSelectRef = /* @__PURE__ */ React504.forwardRef(InternalTreeSelect);
var TreeSelect2 = TreeSelectRef;
var PurePanel8 = PurePanel_default2(TreeSelect2, "dropdownAlign", (props) => omit(props, ["visible"]));
TreeSelect2.TreeNode = TreeNode_default2;
TreeSelect2.SHOW_ALL = SHOW_ALL;
TreeSelect2.SHOW_PARENT = SHOW_PARENT;
TreeSelect2.SHOW_CHILD = SHOW_CHILD;
TreeSelect2._InternalPanelDoNotUseOrYouWillBeFired = PurePanel8;
if (true) {
  TreeSelect2.displayName = "TreeSelect";
}
var tree_select_default = TreeSelect2;

// ../../node_modules/antd/es/typography/Link.js
var React516 = __toESM(require_react());

// ../../node_modules/antd/es/typography/Base/index.js
var React515 = __toESM(require_react());

// ../../node_modules/@ant-design/icons/es/icons/EditOutlined.js
var React505 = __toESM(require_react());

// ../../node_modules/@ant-design/icons-svg/es/asn/EditOutlined.js
var EditOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M257.7 752c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 000-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 009.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9zm67.4-174.4L687.8 215l73.3 73.3-362.7 362.6-88.9 15.7 15.6-89zM880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32z" } }] }, "name": "edit", "theme": "outlined" };
var EditOutlined_default = EditOutlined;

// ../../node_modules/@ant-design/icons/es/icons/EditOutlined.js
var EditOutlined2 = function EditOutlined3(props, ref3) {
  return /* @__PURE__ */ React505.createElement(AntdIcon_default, _extends({}, props, {
    ref: ref3,
    icon: EditOutlined_default
  }));
};
var RefIcon42 = /* @__PURE__ */ React505.forwardRef(EditOutlined2);
if (true) {
  RefIcon42.displayName = "EditOutlined";
}
var EditOutlined_default2 = RefIcon42;

// ../../node_modules/antd/es/typography/Base/index.js
var import_classnames201 = __toESM(require_classnames());

// ../../node_modules/antd/es/typography/Editable.js
var React507 = __toESM(require_react());

// ../../node_modules/@ant-design/icons/es/icons/EnterOutlined.js
var React506 = __toESM(require_react());

// ../../node_modules/@ant-design/icons-svg/es/asn/EnterOutlined.js
var EnterOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M864 170h-60c-4.4 0-8 3.6-8 8v518H310v-73c0-6.7-7.8-10.5-13-6.3l-141.9 112a8 8 0 000 12.6l141.9 112c5.3 4.2 13 .4 13-6.3v-75h498c35.3 0 64-28.7 64-64V178c0-4.4-3.6-8-8-8z" } }] }, "name": "enter", "theme": "outlined" };
var EnterOutlined_default = EnterOutlined;

// ../../node_modules/@ant-design/icons/es/icons/EnterOutlined.js
var EnterOutlined2 = function EnterOutlined3(props, ref3) {
  return /* @__PURE__ */ React506.createElement(AntdIcon_default, _extends({}, props, {
    ref: ref3,
    icon: EnterOutlined_default
  }));
};
var RefIcon43 = /* @__PURE__ */ React506.forwardRef(EnterOutlined2);
if (true) {
  RefIcon43.displayName = "EnterOutlined";
}
var EnterOutlined_default2 = RefIcon43;

// ../../node_modules/antd/es/typography/Editable.js
var import_classnames198 = __toESM(require_classnames());

// ../../node_modules/antd/es/typography/style/mixins.js
var getTitleStyle = (fontSize, lineHeight, color, token2) => {
  const {
    titleMarginBottom,
    fontWeightStrong
  } = token2;
  return {
    marginBottom: titleMarginBottom,
    color,
    fontWeight: fontWeightStrong,
    fontSize,
    lineHeight
  };
};
var getTitleStyles = (token2) => {
  const headings = [1, 2, 3, 4, 5];
  const styles = {};
  headings.forEach((headingLevel) => {
    styles[`
      h${headingLevel}&,
      div&-h${headingLevel},
      div&-h${headingLevel} > textarea,
      h${headingLevel}
    `] = getTitleStyle(token2[`fontSizeHeading${headingLevel}`], token2[`lineHeightHeading${headingLevel}`], token2.colorTextHeading, token2);
  });
  return styles;
};
var getLinkStyles = (token2) => {
  const {
    componentCls
  } = token2;
  return {
    "a&, a": Object.assign(Object.assign({}, operationUnit(token2)), {
      userSelect: "text",
      [`&[disabled], &${componentCls}-disabled`]: {
        color: token2.colorTextDisabled,
        cursor: "not-allowed",
        "&:active, &:hover": {
          color: token2.colorTextDisabled
        },
        "&:active": {
          pointerEvents: "none"
        }
      }
    })
  };
};
var getResetStyles = (token2) => ({
  code: {
    margin: "0 0.2em",
    paddingInline: "0.4em",
    paddingBlock: "0.2em 0.1em",
    fontSize: "85%",
    fontFamily: token2.fontFamilyCode,
    background: "rgba(150, 150, 150, 0.1)",
    border: "1px solid rgba(100, 100, 100, 0.2)",
    borderRadius: 3
  },
  kbd: {
    margin: "0 0.2em",
    paddingInline: "0.4em",
    paddingBlock: "0.15em 0.1em",
    fontSize: "90%",
    fontFamily: token2.fontFamilyCode,
    background: "rgba(150, 150, 150, 0.06)",
    border: "1px solid rgba(100, 100, 100, 0.2)",
    borderBottomWidth: 2,
    borderRadius: 3
  },
  mark: {
    padding: 0,
    // FIXME hardcode in v4
    backgroundColor: gold[2]
  },
  "u, ins": {
    textDecoration: "underline",
    textDecorationSkipInk: "auto"
  },
  "s, del": {
    textDecoration: "line-through"
  },
  strong: {
    fontWeight: token2.fontWeightStrong
  },
  // list
  "ul, ol": {
    marginInline: 0,
    marginBlock: "0 1em",
    padding: 0,
    li: {
      marginInline: "20px 0",
      marginBlock: 0,
      paddingInline: "4px 0",
      paddingBlock: 0
    }
  },
  ul: {
    listStyleType: "circle",
    ul: {
      listStyleType: "disc"
    }
  },
  ol: {
    listStyleType: "decimal"
  },
  // pre & block
  "pre, blockquote": {
    margin: "1em 0"
  },
  pre: {
    padding: "0.4em 0.6em",
    whiteSpace: "pre-wrap",
    wordWrap: "break-word",
    background: "rgba(150, 150, 150, 0.1)",
    border: "1px solid rgba(100, 100, 100, 0.2)",
    borderRadius: 3,
    fontFamily: token2.fontFamilyCode,
    // Compatible for marked
    code: {
      display: "inline",
      margin: 0,
      padding: 0,
      fontSize: "inherit",
      fontFamily: "inherit",
      background: "transparent",
      border: 0
    }
  },
  blockquote: {
    paddingInline: "0.6em 0",
    paddingBlock: 0,
    borderInlineStart: "4px solid rgba(100, 100, 100, 0.2)",
    opacity: 0.85
  }
});
var getEditableStyles = (token2) => {
  const {
    componentCls,
    paddingSM
  } = token2;
  const inputShift = paddingSM;
  return {
    "&-edit-content": {
      position: "relative",
      "div&": {
        insetInlineStart: token2.calc(token2.paddingSM).mul(-1).equal(),
        marginTop: token2.calc(inputShift).mul(-1).equal(),
        marginBottom: `calc(1em - ${unit(inputShift)})`
      },
      [`${componentCls}-edit-content-confirm`]: {
        position: "absolute",
        insetInlineEnd: token2.calc(token2.marginXS).add(2).equal(),
        insetBlockEnd: token2.marginXS,
        color: token2.colorIcon,
        // default style
        fontWeight: "normal",
        fontSize: token2.fontSize,
        fontStyle: "normal",
        pointerEvents: "none"
      },
      textarea: {
        margin: "0!important",
        // Fix Editable Textarea flash in Firefox
        MozTransition: "none",
        height: "1em"
      }
    }
  };
};
var getCopyableStyles = (token2) => ({
  [`${token2.componentCls}-copy-success`]: {
    [`
    &,
    &:hover,
    &:focus`]: {
      color: token2.colorSuccess
    }
  },
  [`${token2.componentCls}-copy-icon-only`]: {
    marginInlineStart: 0
  }
});
var getEllipsisStyles = () => ({
  [`
  a&-ellipsis,
  span&-ellipsis
  `]: {
    display: "inline-block",
    maxWidth: "100%"
  },
  "&-ellipsis-single-line": {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    // https://blog.csdn.net/iefreer/article/details/50421025
    "a&, span&": {
      verticalAlign: "bottom"
    },
    "> code": {
      paddingBlock: 0,
      maxWidth: "calc(100% - 1.2em)",
      display: "inline-block",
      overflow: "hidden",
      textOverflow: "ellipsis",
      verticalAlign: "bottom",
      // https://github.com/ant-design/ant-design/issues/45953
      boxSizing: "content-box"
    }
  },
  "&-ellipsis-multiple-line": {
    display: "-webkit-box",
    overflow: "hidden",
    WebkitLineClamp: 3,
    WebkitBoxOrient: "vertical"
  }
});

// ../../node_modules/antd/es/typography/style/index.js
var genTypographyStyle = (token2) => {
  const {
    componentCls,
    titleMarginTop
  } = token2;
  return {
    [componentCls]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
      color: token2.colorText,
      wordBreak: "break-word",
      lineHeight: token2.lineHeight,
      [`&${componentCls}-secondary`]: {
        color: token2.colorTextDescription
      },
      [`&${componentCls}-success`]: {
        color: token2.colorSuccessText
      },
      [`&${componentCls}-warning`]: {
        color: token2.colorWarningText
      },
      [`&${componentCls}-danger`]: {
        color: token2.colorErrorText,
        "a&:active, a&:focus": {
          color: token2.colorErrorTextActive
        },
        "a&:hover": {
          color: token2.colorErrorTextHover
        }
      },
      [`&${componentCls}-disabled`]: {
        color: token2.colorTextDisabled,
        cursor: "not-allowed",
        userSelect: "none"
      },
      [`
        div&,
        p
      `]: {
        marginBottom: "1em"
      }
    }, getTitleStyles(token2)), {
      [`
      & + h1${componentCls},
      & + h2${componentCls},
      & + h3${componentCls},
      & + h4${componentCls},
      & + h5${componentCls}
      `]: {
        marginTop: titleMarginTop
      },
      [`
      div,
      ul,
      li,
      p,
      h1,
      h2,
      h3,
      h4,
      h5`]: {
        [`
        + h1,
        + h2,
        + h3,
        + h4,
        + h5
        `]: {
          marginTop: titleMarginTop
        }
      }
    }), getResetStyles(token2)), getLinkStyles(token2)), {
      // Operation
      [`
        ${componentCls}-expand,
        ${componentCls}-collapse,
        ${componentCls}-edit,
        ${componentCls}-copy
      `]: Object.assign(Object.assign({}, operationUnit(token2)), {
        marginInlineStart: token2.marginXXS
      })
    }), getEditableStyles(token2)), getCopyableStyles(token2)), getEllipsisStyles()), {
      "&-rtl": {
        direction: "rtl"
      }
    })
  };
};
var prepareComponentToken32 = () => ({
  titleMarginTop: "1.2em",
  titleMarginBottom: "0.5em"
});
var style_default37 = genStyleHooks("Typography", genTypographyStyle, prepareComponentToken32);

// ../../node_modules/antd/es/typography/Editable.js
var Editable = (props) => {
  const {
    prefixCls,
    "aria-label": ariaLabel,
    className: className2,
    style: style2,
    direction,
    maxLength,
    autoSize = true,
    value,
    onSave,
    onCancel,
    onEnd,
    component,
    enterIcon = /* @__PURE__ */ React507.createElement(EnterOutlined_default2, null)
  } = props;
  const ref3 = React507.useRef(null);
  const inComposition = React507.useRef(false);
  const lastKeyCode = React507.useRef(null);
  const [current2, setCurrent] = React507.useState(value);
  React507.useEffect(() => {
    setCurrent(value);
  }, [value]);
  React507.useEffect(() => {
    var _a;
    if ((_a = ref3.current) === null || _a === void 0 ? void 0 : _a.resizableTextArea) {
      const {
        textArea
      } = ref3.current.resizableTextArea;
      textArea.focus();
      const {
        length: length2
      } = textArea.value;
      textArea.setSelectionRange(length2, length2);
    }
  }, []);
  const onChange = ({
    target
  }) => {
    setCurrent(target.value.replace(/[\n\r]/g, ""));
  };
  const onCompositionStart = () => {
    inComposition.current = true;
  };
  const onCompositionEnd = () => {
    inComposition.current = false;
  };
  const onKeyDown2 = ({
    keyCode
  }) => {
    if (inComposition.current) return;
    lastKeyCode.current = keyCode;
  };
  const confirmChange = () => {
    onSave(current2.trim());
  };
  const onKeyUp = ({
    keyCode,
    ctrlKey,
    altKey,
    metaKey,
    shiftKey
  }) => {
    if (lastKeyCode.current !== keyCode || inComposition.current || ctrlKey || altKey || metaKey || shiftKey) {
      return;
    }
    if (keyCode === KeyCode_default.ENTER) {
      confirmChange();
      onEnd === null || onEnd === void 0 ? void 0 : onEnd();
    } else if (keyCode === KeyCode_default.ESC) {
      onCancel();
    }
  };
  const onBlur = () => {
    confirmChange();
  };
  const [wrapCSSVar, hashId, cssVarCls] = style_default37(prefixCls);
  const textAreaClassName = (0, import_classnames198.default)(prefixCls, `${prefixCls}-edit-content`, {
    [`${prefixCls}-rtl`]: direction === "rtl",
    [`${prefixCls}-${component}`]: !!component
  }, className2, hashId, cssVarCls);
  return wrapCSSVar(/* @__PURE__ */ React507.createElement("div", {
    className: textAreaClassName,
    style: style2
  }, /* @__PURE__ */ React507.createElement(TextArea_default2, {
    ref: ref3,
    maxLength,
    value: current2,
    onChange,
    onKeyDown: onKeyDown2,
    onKeyUp,
    onCompositionStart,
    onCompositionEnd,
    onBlur,
    "aria-label": ariaLabel,
    rows: 1,
    autoSize
  }), enterIcon !== null ? cloneElement4(enterIcon, {
    className: `${prefixCls}-edit-content-confirm`
  }) : null));
};
var Editable_default = Editable;

// ../../node_modules/antd/es/typography/hooks/useCopyClick.js
var React508 = __toESM(require_react());
var import_copy_to_clipboard = __toESM(require_copy_to_clipboard());
var __awaiter2 = function(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function(resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e3) {
        reject(e3);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e3) {
        reject(e3);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var useCopyClick = ({
  copyConfig,
  children
}) => {
  const [copied, setCopied] = React508.useState(false);
  const [copyLoading, setCopyLoading] = React508.useState(false);
  const copyIdRef = React508.useRef(null);
  const cleanCopyId = () => {
    if (copyIdRef.current) {
      clearTimeout(copyIdRef.current);
    }
  };
  const copyOptions = {};
  if (copyConfig.format) {
    copyOptions.format = copyConfig.format;
  }
  React508.useEffect(() => cleanCopyId, []);
  const onClick = useEvent2((e3) => __awaiter2(void 0, void 0, void 0, function* () {
    var _a;
    e3 === null || e3 === void 0 ? void 0 : e3.preventDefault();
    e3 === null || e3 === void 0 ? void 0 : e3.stopPropagation();
    setCopyLoading(true);
    try {
      const text = typeof copyConfig.text === "function" ? yield copyConfig.text() : copyConfig.text;
      (0, import_copy_to_clipboard.default)(text || toList_default(children, true).join("") || "", copyOptions);
      setCopyLoading(false);
      setCopied(true);
      cleanCopyId();
      copyIdRef.current = setTimeout(() => {
        setCopied(false);
      }, 3e3);
      (_a = copyConfig.onCopy) === null || _a === void 0 ? void 0 : _a.call(copyConfig, e3);
    } catch (error2) {
      setCopyLoading(false);
      throw error2;
    }
  }));
  return {
    copied,
    copyLoading,
    onClick
  };
};
var useCopyClick_default = useCopyClick;

// ../../node_modules/antd/es/typography/hooks/useMergedConfig.js
var React509 = __toESM(require_react());
function useMergedConfig(propConfig, templateConfig) {
  return React509.useMemo(() => {
    const support = !!propConfig;
    return [support, Object.assign(Object.assign({}, templateConfig), support && typeof propConfig === "object" ? propConfig : null)];
  }, [propConfig]);
}

// ../../node_modules/antd/es/typography/hooks/usePrevious.js
var import_react150 = __toESM(require_react());
var usePrevious2 = (value) => {
  const ref3 = (0, import_react150.useRef)(void 0);
  (0, import_react150.useEffect)(() => {
    ref3.current = value;
  });
  return ref3.current;
};
var usePrevious_default = usePrevious2;

// ../../node_modules/antd/es/typography/hooks/useTooltipProps.js
var import_react151 = __toESM(require_react());
var useTooltipProps = (tooltip, editConfigText, children) => (0, import_react151.useMemo)(() => {
  if (tooltip === true) {
    return {
      title: editConfigText !== null && editConfigText !== void 0 ? editConfigText : children
    };
  }
  if (/* @__PURE__ */ (0, import_react151.isValidElement)(tooltip)) {
    return {
      title: tooltip
    };
  }
  if (typeof tooltip === "object") {
    return Object.assign({
      title: editConfigText !== null && editConfigText !== void 0 ? editConfigText : children
    }, tooltip);
  }
  return {
    title: tooltip
  };
}, [tooltip, editConfigText, children]);
var useTooltipProps_default = useTooltipProps;

// ../../node_modules/antd/es/typography/Typography.js
var React510 = __toESM(require_react());
var import_classnames199 = __toESM(require_classnames());
var __rest65 = function(s, e3) {
  var t2 = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e3.indexOf(p) < 0) t2[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e3.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t2[p[i]] = s[p[i]];
  }
  return t2;
};
var Typography = /* @__PURE__ */ React510.forwardRef((props, ref3) => {
  const {
    prefixCls: customizePrefixCls,
    component: Component10 = "article",
    className: className2,
    rootClassName,
    setContentRef,
    children,
    direction: typographyDirection,
    style: style2
  } = props, restProps = __rest65(props, ["prefixCls", "component", "className", "rootClassName", "setContentRef", "children", "direction", "style"]);
  const {
    getPrefixCls,
    direction: contextDirection,
    className: contextClassName,
    style: contextStyle
  } = useComponentConfig("typography");
  const direction = typographyDirection !== null && typographyDirection !== void 0 ? typographyDirection : contextDirection;
  const mergedRef = setContentRef ? composeRef(ref3, setContentRef) : ref3;
  const prefixCls = getPrefixCls("typography", customizePrefixCls);
  if (true) {
    const warning6 = devUseWarning("Typography");
    warning6.deprecated(!setContentRef, "setContentRef", "ref");
  }
  const [wrapCSSVar, hashId, cssVarCls] = style_default37(prefixCls);
  const componentClassName = (0, import_classnames199.default)(prefixCls, contextClassName, {
    [`${prefixCls}-rtl`]: direction === "rtl"
  }, className2, rootClassName, hashId, cssVarCls);
  const mergedStyle = Object.assign(Object.assign({}, contextStyle), style2);
  return wrapCSSVar(
    // @ts-expect-error: Expression produces a union type that is too complex to represent.
    /* @__PURE__ */ React510.createElement(Component10, Object.assign({
      className: componentClassName,
      style: mergedStyle,
      ref: mergedRef
    }, restProps), children)
  );
});
if (true) {
  Typography.displayName = "Typography";
}
var Typography_default = Typography;

// ../../node_modules/antd/es/typography/Base/CopyBtn.js
var React512 = __toESM(require_react());

// ../../node_modules/@ant-design/icons/es/icons/CopyOutlined.js
var React511 = __toESM(require_react());

// ../../node_modules/@ant-design/icons-svg/es/asn/CopyOutlined.js
var CopyOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32zM704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM350 856.2L263.9 770H350v86.2zM664 888H414V746c0-22.1-17.9-40-40-40H232V264h432v624z" } }] }, "name": "copy", "theme": "outlined" };
var CopyOutlined_default = CopyOutlined;

// ../../node_modules/@ant-design/icons/es/icons/CopyOutlined.js
var CopyOutlined2 = function CopyOutlined3(props, ref3) {
  return /* @__PURE__ */ React511.createElement(AntdIcon_default, _extends({}, props, {
    ref: ref3,
    icon: CopyOutlined_default
  }));
};
var RefIcon44 = /* @__PURE__ */ React511.forwardRef(CopyOutlined2);
if (true) {
  RefIcon44.displayName = "CopyOutlined";
}
var CopyOutlined_default2 = RefIcon44;

// ../../node_modules/antd/es/typography/Base/CopyBtn.js
var import_classnames200 = __toESM(require_classnames());

// ../../node_modules/antd/es/typography/Base/util.js
function toList2(val) {
  if (val === false) {
    return [false, false];
  }
  return Array.isArray(val) ? val : [val];
}
function getNode(dom, defaultNode, needDom) {
  if (dom === true || dom === void 0) {
    return defaultNode;
  }
  return dom || needDom && defaultNode;
}
function isEleEllipsis(ele) {
  const childDiv = document.createElement("em");
  ele.appendChild(childDiv);
  if (true) {
    childDiv.className = "ant-typography-css-ellipsis-content-measure";
  }
  const rect = ele.getBoundingClientRect();
  const childRect = childDiv.getBoundingClientRect();
  ele.removeChild(childDiv);
  return (
    // Horizontal out of range
    rect.left > childRect.left || childRect.right > rect.right || // Vertical out of range
    rect.top > childRect.top || childRect.bottom > rect.bottom
  );
}
var isValidText = (val) => ["string", "number"].includes(typeof val);

// ../../node_modules/antd/es/typography/Base/CopyBtn.js
var CopyBtn = ({
  prefixCls,
  copied,
  locale: locale6,
  iconOnly,
  tooltips,
  icon,
  tabIndex,
  onCopy,
  loading: btnLoading
}) => {
  const tooltipNodes = toList2(tooltips);
  const iconNodes = toList2(icon);
  const {
    copied: copiedText,
    copy: copyText
  } = locale6 !== null && locale6 !== void 0 ? locale6 : {};
  const systemStr = copied ? copiedText : copyText;
  const copyTitle = getNode(tooltipNodes[copied ? 1 : 0], systemStr);
  const ariaLabel = typeof copyTitle === "string" ? copyTitle : systemStr;
  return /* @__PURE__ */ React512.createElement(tooltip_default, {
    title: copyTitle
  }, /* @__PURE__ */ React512.createElement("button", {
    type: "button",
    className: (0, import_classnames200.default)(`${prefixCls}-copy`, {
      [`${prefixCls}-copy-success`]: copied,
      [`${prefixCls}-copy-icon-only`]: iconOnly
    }),
    onClick: onCopy,
    "aria-label": ariaLabel,
    tabIndex
  }, copied ? getNode(iconNodes[1], /* @__PURE__ */ React512.createElement(CheckOutlined_default2, null), true) : getNode(iconNodes[0], btnLoading ? /* @__PURE__ */ React512.createElement(LoadingOutlined_default2, null) : /* @__PURE__ */ React512.createElement(CopyOutlined_default2, null), true)));
};
var CopyBtn_default = CopyBtn;

// ../../node_modules/antd/es/typography/Base/Ellipsis.js
var React513 = __toESM(require_react());
var MeasureText = /* @__PURE__ */ React513.forwardRef(({
  style: style2,
  children
}, ref3) => {
  const spanRef = React513.useRef(null);
  React513.useImperativeHandle(ref3, () => ({
    isExceed: () => {
      const span = spanRef.current;
      return span.scrollHeight > span.clientHeight;
    },
    getHeight: () => spanRef.current.clientHeight
  }));
  return /* @__PURE__ */ React513.createElement("span", {
    "aria-hidden": true,
    ref: spanRef,
    style: Object.assign({
      position: "fixed",
      display: "block",
      left: 0,
      top: 0,
      pointerEvents: "none",
      backgroundColor: "rgba(255, 0, 0, 0.65)"
    }, style2)
  }, children);
});
var getNodesLen = (nodeList) => nodeList.reduce((totalLen, node2) => totalLen + (isValidText(node2) ? String(node2).length : 1), 0);
function sliceNodes(nodeList, len) {
  let currLen = 0;
  const currentNodeList = [];
  for (let i = 0; i < nodeList.length; i += 1) {
    if (currLen === len) {
      return currentNodeList;
    }
    const node2 = nodeList[i];
    const canCut = isValidText(node2);
    const nodeLen = canCut ? String(node2).length : 1;
    const nextLen = currLen + nodeLen;
    if (nextLen > len) {
      const restLen = len - currLen;
      currentNodeList.push(String(node2).slice(0, restLen));
      return currentNodeList;
    }
    currentNodeList.push(node2);
    currLen = nextLen;
  }
  return nodeList;
}
var STATUS_MEASURE_NONE = 0;
var STATUS_MEASURE_PREPARE = 1;
var STATUS_MEASURE_START = 2;
var STATUS_MEASURE_NEED_ELLIPSIS = 3;
var STATUS_MEASURE_NO_NEED_ELLIPSIS = 4;
var lineClipStyle = {
  display: "-webkit-box",
  overflow: "hidden",
  WebkitBoxOrient: "vertical"
};
function EllipsisMeasure(props) {
  const {
    enableMeasure,
    width,
    text,
    children,
    rows,
    expanded,
    miscDeps,
    onEllipsis
  } = props;
  const nodeList = React513.useMemo(() => toArray(text), [text]);
  const nodeLen = React513.useMemo(() => getNodesLen(nodeList), [text]);
  const fullContent = React513.useMemo(() => children(nodeList, false), [text]);
  const [ellipsisCutIndex, setEllipsisCutIndex] = React513.useState(null);
  const cutMidRef = React513.useRef(null);
  const measureWhiteSpaceRef = React513.useRef(null);
  const needEllipsisRef = React513.useRef(null);
  const descRowsEllipsisRef = React513.useRef(null);
  const symbolRowEllipsisRef = React513.useRef(null);
  const [canEllipsis, setCanEllipsis] = React513.useState(false);
  const [needEllipsis, setNeedEllipsis] = React513.useState(STATUS_MEASURE_NONE);
  const [ellipsisHeight, setEllipsisHeight] = React513.useState(0);
  const [parentWhiteSpace, setParentWhiteSpace] = React513.useState(null);
  useLayoutEffect_default(() => {
    if (enableMeasure && width && nodeLen) {
      setNeedEllipsis(STATUS_MEASURE_PREPARE);
    } else {
      setNeedEllipsis(STATUS_MEASURE_NONE);
    }
  }, [width, text, rows, enableMeasure, nodeList]);
  useLayoutEffect_default(() => {
    var _a, _b, _c, _d;
    if (needEllipsis === STATUS_MEASURE_PREPARE) {
      setNeedEllipsis(STATUS_MEASURE_START);
      const nextWhiteSpace = measureWhiteSpaceRef.current && getComputedStyle(measureWhiteSpaceRef.current).whiteSpace;
      setParentWhiteSpace(nextWhiteSpace);
    } else if (needEllipsis === STATUS_MEASURE_START) {
      const isOverflow = !!((_a = needEllipsisRef.current) === null || _a === void 0 ? void 0 : _a.isExceed());
      setNeedEllipsis(isOverflow ? STATUS_MEASURE_NEED_ELLIPSIS : STATUS_MEASURE_NO_NEED_ELLIPSIS);
      setEllipsisCutIndex(isOverflow ? [0, nodeLen] : null);
      setCanEllipsis(isOverflow);
      const baseRowsEllipsisHeight = ((_b = needEllipsisRef.current) === null || _b === void 0 ? void 0 : _b.getHeight()) || 0;
      const descRowsEllipsisHeight = rows === 1 ? 0 : ((_c = descRowsEllipsisRef.current) === null || _c === void 0 ? void 0 : _c.getHeight()) || 0;
      const symbolRowEllipsisHeight = ((_d = symbolRowEllipsisRef.current) === null || _d === void 0 ? void 0 : _d.getHeight()) || 0;
      const maxRowsHeight = Math.max(
        baseRowsEllipsisHeight,
        // height of rows with ellipsis
        descRowsEllipsisHeight + symbolRowEllipsisHeight
      );
      setEllipsisHeight(maxRowsHeight + 1);
      onEllipsis(isOverflow);
    }
  }, [needEllipsis]);
  const cutMidIndex = ellipsisCutIndex ? Math.ceil((ellipsisCutIndex[0] + ellipsisCutIndex[1]) / 2) : 0;
  useLayoutEffect_default(() => {
    var _a;
    const [minIndex, maxIndex] = ellipsisCutIndex || [0, 0];
    if (minIndex !== maxIndex) {
      const midHeight = ((_a = cutMidRef.current) === null || _a === void 0 ? void 0 : _a.getHeight()) || 0;
      const isOverflow = midHeight > ellipsisHeight;
      let targetMidIndex = cutMidIndex;
      if (maxIndex - minIndex === 1) {
        targetMidIndex = isOverflow ? minIndex : maxIndex;
      }
      setEllipsisCutIndex(isOverflow ? [minIndex, targetMidIndex] : [targetMidIndex, maxIndex]);
    }
  }, [ellipsisCutIndex, cutMidIndex]);
  const finalContent = React513.useMemo(() => {
    if (!enableMeasure) {
      return children(nodeList, false);
    }
    if (needEllipsis !== STATUS_MEASURE_NEED_ELLIPSIS || !ellipsisCutIndex || ellipsisCutIndex[0] !== ellipsisCutIndex[1]) {
      const content = children(nodeList, false);
      if ([STATUS_MEASURE_NO_NEED_ELLIPSIS, STATUS_MEASURE_NONE].includes(needEllipsis)) {
        return content;
      }
      return /* @__PURE__ */ React513.createElement("span", {
        style: Object.assign(Object.assign({}, lineClipStyle), {
          WebkitLineClamp: rows
        })
      }, content);
    }
    return children(expanded ? nodeList : sliceNodes(nodeList, ellipsisCutIndex[0]), canEllipsis);
  }, [expanded, needEllipsis, ellipsisCutIndex, nodeList].concat(_toConsumableArray(miscDeps)));
  const measureStyle = {
    width,
    margin: 0,
    padding: 0,
    whiteSpace: parentWhiteSpace === "nowrap" ? "normal" : "inherit"
  };
  return /* @__PURE__ */ React513.createElement(React513.Fragment, null, finalContent, needEllipsis === STATUS_MEASURE_START && /* @__PURE__ */ React513.createElement(React513.Fragment, null, /* @__PURE__ */ React513.createElement(MeasureText, {
    style: Object.assign(Object.assign(Object.assign({}, measureStyle), lineClipStyle), {
      WebkitLineClamp: rows
    }),
    ref: needEllipsisRef
  }, fullContent), /* @__PURE__ */ React513.createElement(MeasureText, {
    style: Object.assign(Object.assign(Object.assign({}, measureStyle), lineClipStyle), {
      WebkitLineClamp: rows - 1
    }),
    ref: descRowsEllipsisRef
  }, fullContent), /* @__PURE__ */ React513.createElement(MeasureText, {
    style: Object.assign(Object.assign(Object.assign({}, measureStyle), lineClipStyle), {
      WebkitLineClamp: 1
    }),
    ref: symbolRowEllipsisRef
  }, children([], true))), needEllipsis === STATUS_MEASURE_NEED_ELLIPSIS && ellipsisCutIndex && ellipsisCutIndex[0] !== ellipsisCutIndex[1] && /* @__PURE__ */ React513.createElement(MeasureText, {
    style: Object.assign(Object.assign({}, measureStyle), {
      top: 400
    }),
    ref: cutMidRef
  }, children(sliceNodes(nodeList, cutMidIndex), true)), needEllipsis === STATUS_MEASURE_PREPARE && /* @__PURE__ */ React513.createElement("span", {
    style: {
      whiteSpace: "inherit"
    },
    ref: measureWhiteSpaceRef
  }));
}

// ../../node_modules/antd/es/typography/Base/EllipsisTooltip.js
var React514 = __toESM(require_react());
var EllipsisTooltip = ({
  enableEllipsis,
  isEllipsis,
  children,
  tooltipProps
}) => {
  if (!(tooltipProps === null || tooltipProps === void 0 ? void 0 : tooltipProps.title) || !enableEllipsis) {
    return children;
  }
  return /* @__PURE__ */ React514.createElement(tooltip_default, Object.assign({
    open: isEllipsis ? void 0 : false
  }, tooltipProps), children);
};
if (true) {
  EllipsisTooltip.displayName = "EllipsisTooltip";
}
var EllipsisTooltip_default = EllipsisTooltip;

// ../../node_modules/antd/es/typography/Base/index.js
var __rest66 = function(s, e3) {
  var t2 = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e3.indexOf(p) < 0) t2[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e3.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t2[p[i]] = s[p[i]];
  }
  return t2;
};
function wrapperDecorations({
  mark,
  code: code2,
  underline,
  delete: del,
  strong,
  keyboard,
  italic
}, content) {
  let currentContent = content;
  function wrap(tag, needed) {
    if (!needed) {
      return;
    }
    currentContent = /* @__PURE__ */ React515.createElement(tag, {}, currentContent);
  }
  wrap("strong", strong);
  wrap("u", underline);
  wrap("del", del);
  wrap("code", code2);
  wrap("mark", mark);
  wrap("kbd", keyboard);
  wrap("i", italic);
  return currentContent;
}
var ELLIPSIS_STR = "...";
var DECORATION_PROPS = ["delete", "mark", "code", "underline", "strong", "keyboard", "italic"];
var Base2 = /* @__PURE__ */ React515.forwardRef((props, ref3) => {
  var _a;
  const {
    prefixCls: customizePrefixCls,
    className: className2,
    style: style2,
    type: type5,
    disabled,
    children,
    ellipsis,
    editable,
    copyable,
    component,
    title
  } = props, restProps = __rest66(props, ["prefixCls", "className", "style", "type", "disabled", "children", "ellipsis", "editable", "copyable", "component", "title"]);
  const {
    getPrefixCls,
    direction
  } = React515.useContext(ConfigContext);
  const [textLocale] = useLocale_default("Text");
  const typographyRef = React515.useRef(null);
  const editIconRef = React515.useRef(null);
  const prefixCls = getPrefixCls("typography", customizePrefixCls);
  const textProps = omit(restProps, DECORATION_PROPS);
  const [enableEdit, editConfig] = useMergedConfig(editable);
  const [editing, setEditing] = useMergedState(false, {
    value: editConfig.editing
  });
  const {
    triggerType = ["icon"]
  } = editConfig;
  const triggerEdit = (edit) => {
    var _a2;
    if (edit) {
      (_a2 = editConfig.onStart) === null || _a2 === void 0 ? void 0 : _a2.call(editConfig);
    }
    setEditing(edit);
  };
  const prevEditing = usePrevious_default(editing);
  useLayoutEffect_default(() => {
    var _a2;
    if (!editing && prevEditing) {
      (_a2 = editIconRef.current) === null || _a2 === void 0 ? void 0 : _a2.focus();
    }
  }, [editing]);
  const onEditClick = (e3) => {
    e3 === null || e3 === void 0 ? void 0 : e3.preventDefault();
    triggerEdit(true);
  };
  const onEditChange = (value) => {
    var _a2;
    (_a2 = editConfig.onChange) === null || _a2 === void 0 ? void 0 : _a2.call(editConfig, value);
    triggerEdit(false);
  };
  const onEditCancel = () => {
    var _a2;
    (_a2 = editConfig.onCancel) === null || _a2 === void 0 ? void 0 : _a2.call(editConfig);
    triggerEdit(false);
  };
  const [enableCopy, copyConfig] = useMergedConfig(copyable);
  const {
    copied,
    copyLoading,
    onClick: onCopyClick
  } = useCopyClick_default({
    copyConfig,
    children
  });
  const [isLineClampSupport, setIsLineClampSupport] = React515.useState(false);
  const [isTextOverflowSupport, setIsTextOverflowSupport] = React515.useState(false);
  const [isJsEllipsis, setIsJsEllipsis] = React515.useState(false);
  const [isNativeEllipsis, setIsNativeEllipsis] = React515.useState(false);
  const [isNativeVisible, setIsNativeVisible] = React515.useState(true);
  const [enableEllipsis, ellipsisConfig] = useMergedConfig(ellipsis, {
    expandable: false,
    symbol: (isExpanded) => isExpanded ? textLocale === null || textLocale === void 0 ? void 0 : textLocale.collapse : textLocale === null || textLocale === void 0 ? void 0 : textLocale.expand
  });
  const [expanded, setExpanded] = useMergedState(ellipsisConfig.defaultExpanded || false, {
    value: ellipsisConfig.expanded
  });
  const mergedEnableEllipsis = enableEllipsis && (!expanded || ellipsisConfig.expandable === "collapsible");
  const {
    rows = 1
  } = ellipsisConfig;
  const needMeasureEllipsis = React515.useMemo(() => (
    // Disable ellipsis
    mergedEnableEllipsis && // Provide suffix
    (ellipsisConfig.suffix !== void 0 || ellipsisConfig.onEllipsis || // Can't use css ellipsis since we need to provide the place for button
    ellipsisConfig.expandable || enableEdit || enableCopy)
  ), [mergedEnableEllipsis, ellipsisConfig, enableEdit, enableCopy]);
  useLayoutEffect_default(() => {
    if (enableEllipsis && !needMeasureEllipsis) {
      setIsLineClampSupport(isStyleSupport("webkitLineClamp"));
      setIsTextOverflowSupport(isStyleSupport("textOverflow"));
    }
  }, [needMeasureEllipsis, enableEllipsis]);
  const [cssEllipsis, setCssEllipsis] = React515.useState(mergedEnableEllipsis);
  const canUseCssEllipsis = React515.useMemo(() => {
    if (needMeasureEllipsis) {
      return false;
    }
    if (rows === 1) {
      return isTextOverflowSupport;
    }
    return isLineClampSupport;
  }, [needMeasureEllipsis, isTextOverflowSupport, isLineClampSupport]);
  useLayoutEffect_default(() => {
    setCssEllipsis(canUseCssEllipsis && mergedEnableEllipsis);
  }, [canUseCssEllipsis, mergedEnableEllipsis]);
  const isMergedEllipsis = mergedEnableEllipsis && (cssEllipsis ? isNativeEllipsis : isJsEllipsis);
  const cssTextOverflow = mergedEnableEllipsis && rows === 1 && cssEllipsis;
  const cssLineClamp = mergedEnableEllipsis && rows > 1 && cssEllipsis;
  const onExpandClick = (e3, info) => {
    var _a2;
    setExpanded(info.expanded);
    (_a2 = ellipsisConfig.onExpand) === null || _a2 === void 0 ? void 0 : _a2.call(ellipsisConfig, e3, info);
  };
  const [ellipsisWidth, setEllipsisWidth] = React515.useState(0);
  const onResize2 = ({
    offsetWidth
  }) => {
    setEllipsisWidth(offsetWidth);
  };
  const onJsEllipsis = (jsEllipsis) => {
    var _a2;
    setIsJsEllipsis(jsEllipsis);
    if (isJsEllipsis !== jsEllipsis) {
      (_a2 = ellipsisConfig.onEllipsis) === null || _a2 === void 0 ? void 0 : _a2.call(ellipsisConfig, jsEllipsis);
    }
  };
  React515.useEffect(() => {
    const textEle = typographyRef.current;
    if (enableEllipsis && cssEllipsis && textEle) {
      const currentEllipsis = isEleEllipsis(textEle);
      if (isNativeEllipsis !== currentEllipsis) {
        setIsNativeEllipsis(currentEllipsis);
      }
    }
  }, [enableEllipsis, cssEllipsis, children, cssLineClamp, isNativeVisible, ellipsisWidth]);
  React515.useEffect(() => {
    const textEle = typographyRef.current;
    if (typeof IntersectionObserver === "undefined" || !textEle || !cssEllipsis || !mergedEnableEllipsis) {
      return;
    }
    const observer = new IntersectionObserver(() => {
      setIsNativeVisible(!!textEle.offsetParent);
    });
    observer.observe(textEle);
    return () => {
      observer.disconnect();
    };
  }, [cssEllipsis, mergedEnableEllipsis]);
  const tooltipProps = useTooltipProps_default(ellipsisConfig.tooltip, editConfig.text, children);
  const topAriaLabel = React515.useMemo(() => {
    if (!enableEllipsis || cssEllipsis) {
      return void 0;
    }
    return [editConfig.text, children, title, tooltipProps.title].find(isValidText);
  }, [enableEllipsis, cssEllipsis, title, tooltipProps.title, isMergedEllipsis]);
  if (editing) {
    return /* @__PURE__ */ React515.createElement(Editable_default, {
      value: (_a = editConfig.text) !== null && _a !== void 0 ? _a : typeof children === "string" ? children : "",
      onSave: onEditChange,
      onCancel: onEditCancel,
      onEnd: editConfig.onEnd,
      prefixCls,
      className: className2,
      style: style2,
      direction,
      component,
      maxLength: editConfig.maxLength,
      autoSize: editConfig.autoSize,
      enterIcon: editConfig.enterIcon
    });
  }
  const renderExpand = () => {
    const {
      expandable,
      symbol
    } = ellipsisConfig;
    return expandable ? /* @__PURE__ */ React515.createElement("button", {
      type: "button",
      key: "expand",
      className: `${prefixCls}-${expanded ? "collapse" : "expand"}`,
      onClick: (e3) => onExpandClick(e3, {
        expanded: !expanded
      }),
      "aria-label": expanded ? textLocale.collapse : textLocale === null || textLocale === void 0 ? void 0 : textLocale.expand
    }, typeof symbol === "function" ? symbol(expanded) : symbol) : null;
  };
  const renderEdit = () => {
    if (!enableEdit) {
      return;
    }
    const {
      icon,
      tooltip,
      tabIndex
    } = editConfig;
    const editTitle = toArray(tooltip)[0] || (textLocale === null || textLocale === void 0 ? void 0 : textLocale.edit);
    const ariaLabel = typeof editTitle === "string" ? editTitle : "";
    return triggerType.includes("icon") ? /* @__PURE__ */ React515.createElement(tooltip_default, {
      key: "edit",
      title: tooltip === false ? "" : editTitle
    }, /* @__PURE__ */ React515.createElement("button", {
      type: "button",
      ref: editIconRef,
      className: `${prefixCls}-edit`,
      onClick: onEditClick,
      "aria-label": ariaLabel,
      tabIndex
    }, icon || /* @__PURE__ */ React515.createElement(EditOutlined_default2, {
      role: "button"
    }))) : null;
  };
  const renderCopy = () => {
    if (!enableCopy) {
      return null;
    }
    return /* @__PURE__ */ React515.createElement(CopyBtn_default, Object.assign({
      key: "copy"
    }, copyConfig, {
      prefixCls,
      copied,
      locale: textLocale,
      onCopy: onCopyClick,
      loading: copyLoading,
      iconOnly: children === null || children === void 0
    }));
  };
  const renderOperations = (canEllipsis) => [canEllipsis && renderExpand(), renderEdit(), renderCopy()];
  const renderEllipsis = (canEllipsis) => [canEllipsis && !expanded && /* @__PURE__ */ React515.createElement("span", {
    "aria-hidden": true,
    key: "ellipsis"
  }, ELLIPSIS_STR), ellipsisConfig.suffix, renderOperations(canEllipsis)];
  return /* @__PURE__ */ React515.createElement(es_default, {
    onResize: onResize2,
    disabled: !mergedEnableEllipsis
  }, (resizeRef) => /* @__PURE__ */ React515.createElement(EllipsisTooltip_default, {
    tooltipProps,
    enableEllipsis: mergedEnableEllipsis,
    isEllipsis: isMergedEllipsis
  }, /* @__PURE__ */ React515.createElement(Typography_default, Object.assign({
    className: (0, import_classnames201.default)({
      [`${prefixCls}-${type5}`]: type5,
      [`${prefixCls}-disabled`]: disabled,
      [`${prefixCls}-ellipsis`]: enableEllipsis,
      [`${prefixCls}-ellipsis-single-line`]: cssTextOverflow,
      [`${prefixCls}-ellipsis-multiple-line`]: cssLineClamp
    }, className2),
    prefixCls: customizePrefixCls,
    style: Object.assign(Object.assign({}, style2), {
      WebkitLineClamp: cssLineClamp ? rows : void 0
    }),
    component,
    ref: composeRef(resizeRef, typographyRef, ref3),
    direction,
    onClick: triggerType.includes("text") ? onEditClick : void 0,
    "aria-label": topAriaLabel === null || topAriaLabel === void 0 ? void 0 : topAriaLabel.toString(),
    title
  }, textProps), /* @__PURE__ */ React515.createElement(EllipsisMeasure, {
    enableMeasure: mergedEnableEllipsis && !cssEllipsis,
    text: children,
    rows,
    width: ellipsisWidth,
    onEllipsis: onJsEllipsis,
    expanded,
    miscDeps: [copied, expanded, copyLoading, enableEdit, enableCopy, textLocale].concat(_toConsumableArray(DECORATION_PROPS.map((key2) => props[key2])))
  }, (node2, canEllipsis) => wrapperDecorations(props, /* @__PURE__ */ React515.createElement(React515.Fragment, null, node2.length > 0 && canEllipsis && !expanded && topAriaLabel ? /* @__PURE__ */ React515.createElement("span", {
    key: "show-content",
    "aria-hidden": true
  }, node2) : node2, renderEllipsis(canEllipsis)))))));
});
var Base_default = Base2;

// ../../node_modules/antd/es/typography/Link.js
var __rest67 = function(s, e3) {
  var t2 = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e3.indexOf(p) < 0) t2[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e3.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t2[p[i]] = s[p[i]];
  }
  return t2;
};
var Link = /* @__PURE__ */ React516.forwardRef((_a, ref3) => {
  var {
    ellipsis,
    rel
  } = _a, restProps = __rest67(_a, ["ellipsis", "rel"]);
  if (true) {
    const warning6 = devUseWarning("Typography.Link");
    true ? warning6(typeof ellipsis !== "object", "usage", "`ellipsis` only supports boolean value.") : void 0;
  }
  const mergedProps = Object.assign(Object.assign({}, restProps), {
    rel: rel === void 0 && restProps.target === "_blank" ? "noopener noreferrer" : rel
  });
  delete mergedProps.navigate;
  return /* @__PURE__ */ React516.createElement(Base_default, Object.assign({}, mergedProps, {
    ref: ref3,
    ellipsis: !!ellipsis,
    component: "a"
  }));
});
var Link_default = Link;

// ../../node_modules/antd/es/typography/Paragraph.js
var React517 = __toESM(require_react());
var Paragraph2 = /* @__PURE__ */ React517.forwardRef((props, ref3) => /* @__PURE__ */ React517.createElement(Base_default, Object.assign({
  ref: ref3
}, props, {
  component: "div"
})));
var Paragraph_default2 = Paragraph2;

// ../../node_modules/antd/es/typography/Text.js
var React518 = __toESM(require_react());
var __rest68 = function(s, e3) {
  var t2 = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e3.indexOf(p) < 0) t2[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e3.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t2[p[i]] = s[p[i]];
  }
  return t2;
};
var Text = (_a, ref3) => {
  var {
    ellipsis
  } = _a, restProps = __rest68(_a, ["ellipsis"]);
  const mergedEllipsis = React518.useMemo(() => {
    if (ellipsis && typeof ellipsis === "object") {
      return omit(ellipsis, ["expandable", "rows"]);
    }
    return ellipsis;
  }, [ellipsis]);
  if (true) {
    const warning6 = devUseWarning("Typography.Text");
    true ? warning6(typeof ellipsis !== "object" || !ellipsis || !("expandable" in ellipsis) && !("rows" in ellipsis), "usage", "`ellipsis` do not support `expandable` or `rows` props.") : void 0;
  }
  return /* @__PURE__ */ React518.createElement(Base_default, Object.assign({
    ref: ref3
  }, restProps, {
    ellipsis: mergedEllipsis,
    component: "span"
  }));
};
var Text_default = /* @__PURE__ */ React518.forwardRef(Text);

// ../../node_modules/antd/es/typography/Title.js
var React519 = __toESM(require_react());
var __rest69 = function(s, e3) {
  var t2 = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e3.indexOf(p) < 0) t2[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e3.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t2[p[i]] = s[p[i]];
  }
  return t2;
};
var TITLE_ELE_LIST = [1, 2, 3, 4, 5];
var Title2 = /* @__PURE__ */ React519.forwardRef((props, ref3) => {
  const {
    level = 1
  } = props, restProps = __rest69(props, ["level"]);
  if (true) {
    const warning6 = devUseWarning("Typography.Title");
    true ? warning6(TITLE_ELE_LIST.includes(level), "usage", "Title only accept `1 | 2 | 3 | 4 | 5` as `level` value. And `5` need 4.6.0+ version.") : void 0;
  }
  const component = TITLE_ELE_LIST.includes(level) ? `h${level}` : `h1`;
  return /* @__PURE__ */ React519.createElement(Base_default, Object.assign({
    ref: ref3
  }, restProps, {
    component
  }));
});
var Title_default2 = Title2;

// ../../node_modules/antd/es/typography/index.js
var Typography2 = Typography_default;
Typography2.Text = Text_default;
Typography2.Link = Link_default;
Typography2.Title = Title_default2;
Typography2.Paragraph = Paragraph_default2;
var typography_default = Typography2;

// ../../node_modules/antd/es/upload/Dragger.js
var React529 = __toESM(require_react());

// ../../node_modules/antd/es/upload/Upload.js
var React528 = __toESM(require_react());
var import_react_dom12 = __toESM(require_react_dom());
var import_classnames205 = __toESM(require_classnames());

// ../../node_modules/rc-upload/es/Upload.js
var import_react153 = __toESM(require_react());

// ../../node_modules/rc-upload/es/AjaxUploader.js
var import_classnames202 = __toESM(require_classnames());
var import_react152 = __toESM(require_react());

// ../../node_modules/rc-upload/es/attr-accept.js
var attr_accept_default = (function(file, acceptedFiles) {
  if (file && acceptedFiles) {
    var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(",");
    var fileName = file.name || "";
    var mimeType = file.type || "";
    var baseMimeType = mimeType.replace(/\/.*$/, "");
    return acceptedFilesArray.some(function(type5) {
      var validType = type5.trim();
      if (/^\*(\/\*)?$/.test(type5)) {
        return true;
      }
      if (validType.charAt(0) === ".") {
        var lowerFileName = fileName.toLowerCase();
        var lowerType = validType.toLowerCase();
        var affixList = [lowerType];
        if (lowerType === ".jpg" || lowerType === ".jpeg") {
          affixList = [".jpg", ".jpeg"];
        }
        return affixList.some(function(affix) {
          return lowerFileName.endsWith(affix);
        });
      }
      if (/\/\*$/.test(validType)) {
        return baseMimeType === validType.replace(/\/.*$/, "");
      }
      if (mimeType === validType) {
        return true;
      }
      if (/^\w+$/.test(validType)) {
        warning_default(false, "Upload takes an invalidate 'accept' type '".concat(validType, "'.Skip for check."));
        return true;
      }
      return false;
    });
  }
  return true;
});

// ../../node_modules/rc-upload/es/request.js
function getError(option, xhr) {
  var msg = "cannot ".concat(option.method, " ").concat(option.action, " ").concat(xhr.status, "'");
  var err = new Error(msg);
  err.status = xhr.status;
  err.method = option.method;
  err.url = option.action;
  return err;
}
function getBody2(xhr) {
  var text = xhr.responseText || xhr.response;
  if (!text) {
    return text;
  }
  try {
    return JSON.parse(text);
  } catch (e3) {
    return text;
  }
}
function upload(option) {
  var xhr = new XMLHttpRequest();
  if (option.onProgress && xhr.upload) {
    xhr.upload.onprogress = function progress(e3) {
      if (e3.total > 0) {
        e3.percent = e3.loaded / e3.total * 100;
      }
      option.onProgress(e3);
    };
  }
  var formData = new FormData();
  if (option.data) {
    Object.keys(option.data).forEach(function(key2) {
      var value = option.data[key2];
      if (Array.isArray(value)) {
        value.forEach(function(item) {
          formData.append("".concat(key2, "[]"), item);
        });
        return;
      }
      formData.append(key2, value);
    });
  }
  if (option.file instanceof Blob) {
    formData.append(option.filename, option.file, option.file.name);
  } else {
    formData.append(option.filename, option.file);
  }
  xhr.onerror = function error2(e3) {
    option.onError(e3);
  };
  xhr.onload = function onload() {
    if (xhr.status < 200 || xhr.status >= 300) {
      return option.onError(getError(option, xhr), getBody2(xhr));
    }
    return option.onSuccess(getBody2(xhr), xhr);
  };
  xhr.open(option.method, option.action, true);
  if (option.withCredentials && "withCredentials" in xhr) {
    xhr.withCredentials = true;
  }
  var headers = option.headers || {};
  if (headers["X-Requested-With"] !== null) {
    xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
  }
  Object.keys(headers).forEach(function(h2) {
    if (headers[h2] !== null) {
      xhr.setRequestHeader(h2, headers[h2]);
    }
  });
  xhr.send(formData);
  return {
    abort: function abort() {
      xhr.abort();
    }
  };
}

// ../../node_modules/rc-upload/es/traverseFileTree.js
var traverseFileTree = /* @__PURE__ */ (function() {
  var _ref = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee4(files, isAccepted) {
    var flattenFileList, progressFileList, readDirectory, _readDirectory, readFile, _readFile, _traverseFileTree, wipIndex;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _readFile = function _readFile3() {
            _readFile = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee3(item) {
              return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                while (1) switch (_context3.prev = _context3.next) {
                  case 0:
                    return _context3.abrupt("return", new Promise(function(reslove) {
                      item.file(function(file) {
                        if (isAccepted(file)) {
                          if (item.fullPath && !file.webkitRelativePath) {
                            Object.defineProperties(file, {
                              webkitRelativePath: {
                                writable: true
                              }
                            });
                            file.webkitRelativePath = item.fullPath.replace(/^\//, "");
                            Object.defineProperties(file, {
                              webkitRelativePath: {
                                writable: false
                              }
                            });
                          }
                          reslove(file);
                        } else {
                          reslove(null);
                        }
                      });
                    }));
                  case 1:
                  case "end":
                    return _context3.stop();
                }
              }, _callee3);
            }));
            return _readFile.apply(this, arguments);
          };
          readFile = function _readFile2(_x4) {
            return _readFile.apply(this, arguments);
          };
          _readDirectory = function _readDirectory3() {
            _readDirectory = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee2(directory) {
              var dirReader, entries, results, n2, i;
              return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                while (1) switch (_context2.prev = _context2.next) {
                  case 0:
                    dirReader = directory.createReader();
                    entries = [];
                  case 2:
                    if (false) {
                      _context2.next = 12;
                      break;
                    }
                    _context2.next = 5;
                    return new Promise(function(resolve) {
                      dirReader.readEntries(resolve, function() {
                        return resolve([]);
                      });
                    });
                  case 5:
                    results = _context2.sent;
                    n2 = results.length;
                    if (n2) {
                      _context2.next = 9;
                      break;
                    }
                    return _context2.abrupt("break", 12);
                  case 9:
                    for (i = 0; i < n2; i++) {
                      entries.push(results[i]);
                    }
                    _context2.next = 2;
                    break;
                  case 12:
                    return _context2.abrupt("return", entries);
                  case 13:
                  case "end":
                    return _context2.stop();
                }
              }, _callee2);
            }));
            return _readDirectory.apply(this, arguments);
          };
          readDirectory = function _readDirectory2(_x3) {
            return _readDirectory.apply(this, arguments);
          };
          flattenFileList = [];
          progressFileList = [];
          files.forEach(function(file) {
            return progressFileList.push(file.webkitGetAsEntry());
          });
          _traverseFileTree = /* @__PURE__ */ (function() {
            var _ref2 = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee(item, path2) {
              var _file, entries;
              return _regeneratorRuntime().wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    if (item) {
                      _context.next = 2;
                      break;
                    }
                    return _context.abrupt("return");
                  case 2:
                    item.path = path2 || "";
                    if (!item.isFile) {
                      _context.next = 10;
                      break;
                    }
                    _context.next = 6;
                    return readFile(item);
                  case 6:
                    _file = _context.sent;
                    if (_file) {
                      flattenFileList.push(_file);
                    }
                    _context.next = 15;
                    break;
                  case 10:
                    if (!item.isDirectory) {
                      _context.next = 15;
                      break;
                    }
                    _context.next = 13;
                    return readDirectory(item);
                  case 13:
                    entries = _context.sent;
                    progressFileList.push.apply(progressFileList, _toConsumableArray(entries));
                  case 15:
                  case "end":
                    return _context.stop();
                }
              }, _callee);
            }));
            return function _traverseFileTree2(_x5, _x6) {
              return _ref2.apply(this, arguments);
            };
          })();
          wipIndex = 0;
        case 9:
          if (!(wipIndex < progressFileList.length)) {
            _context4.next = 15;
            break;
          }
          _context4.next = 12;
          return _traverseFileTree(progressFileList[wipIndex]);
        case 12:
          wipIndex++;
          _context4.next = 9;
          break;
        case 15:
          return _context4.abrupt("return", flattenFileList);
        case 16:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function traverseFileTree2(_x, _x2) {
    return _ref.apply(this, arguments);
  };
})();
var traverseFileTree_default = traverseFileTree;

// ../../node_modules/rc-upload/es/uid.js
var now = +/* @__PURE__ */ new Date();
var index2 = 0;
function uid2() {
  return "rc-upload-".concat(now, "-").concat(++index2);
}

// ../../node_modules/rc-upload/es/AjaxUploader.js
var _excluded75 = ["component", "prefixCls", "className", "classNames", "disabled", "id", "name", "style", "styles", "multiple", "accept", "capture", "children", "directory", "openFileDialogOnClick", "onMouseEnter", "onMouseLeave", "hasControlInside"];
var AjaxUploader = /* @__PURE__ */ (function(_Component) {
  _inherits(AjaxUploader2, _Component);
  var _super = _createSuper(AjaxUploader2);
  function AjaxUploader2() {
    var _this;
    _classCallCheck(this, AjaxUploader2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      uid: uid2()
    });
    _defineProperty(_assertThisInitialized(_this), "reqs", {});
    _defineProperty(_assertThisInitialized(_this), "fileInput", void 0);
    _defineProperty(_assertThisInitialized(_this), "_isMounted", void 0);
    _defineProperty(_assertThisInitialized(_this), "onChange", function(e3) {
      var _this$props = _this.props, accept = _this$props.accept, directory = _this$props.directory;
      var files = e3.target.files;
      var acceptedFiles = _toConsumableArray(files).filter(function(file) {
        return !directory || attr_accept_default(file, accept);
      });
      _this.uploadFiles(acceptedFiles);
      _this.reset();
    });
    _defineProperty(_assertThisInitialized(_this), "onClick", function(event) {
      var el = _this.fileInput;
      if (!el) {
        return;
      }
      var target = event.target;
      var onClick = _this.props.onClick;
      if (target && target.tagName === "BUTTON") {
        var parent2 = el.parentNode;
        parent2.focus();
        target.blur();
      }
      el.click();
      if (onClick) {
        onClick(event);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onKeyDown", function(e3) {
      if (e3.key === "Enter") {
        _this.onClick(e3);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onDataTransferFiles", /* @__PURE__ */ (function() {
      var _ref = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee(dataTransfer, existFileCallback) {
        var _this$props2, multiple, accept, directory, items, files, acceptFiles;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this$props2 = _this.props, multiple = _this$props2.multiple, accept = _this$props2.accept, directory = _this$props2.directory;
              items = _toConsumableArray(dataTransfer.items || []);
              files = _toConsumableArray(dataTransfer.files || []);
              if (files.length > 0 || items.some(function(item) {
                return item.kind === "file";
              })) {
                existFileCallback === null || existFileCallback === void 0 || existFileCallback();
              }
              if (!directory) {
                _context.next = 11;
                break;
              }
              _context.next = 7;
              return traverseFileTree_default(Array.prototype.slice.call(items), function(_file) {
                return attr_accept_default(_file, _this.props.accept);
              });
            case 7:
              files = _context.sent;
              _this.uploadFiles(files);
              _context.next = 14;
              break;
            case 11:
              acceptFiles = _toConsumableArray(files).filter(function(file) {
                return attr_accept_default(file, accept);
              });
              if (multiple === false) {
                acceptFiles = files.slice(0, 1);
              }
              _this.uploadFiles(acceptFiles);
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function(_x, _x2) {
        return _ref.apply(this, arguments);
      };
    })());
    _defineProperty(_assertThisInitialized(_this), "onFilePaste", /* @__PURE__ */ (function() {
      var _ref2 = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee2(e3) {
        var pastable, clipboardData;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              pastable = _this.props.pastable;
              if (pastable) {
                _context2.next = 3;
                break;
              }
              return _context2.abrupt("return");
            case 3:
              if (!(e3.type === "paste")) {
                _context2.next = 6;
                break;
              }
              clipboardData = e3.clipboardData;
              return _context2.abrupt("return", _this.onDataTransferFiles(clipboardData, function() {
                e3.preventDefault();
              }));
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function(_x3) {
        return _ref2.apply(this, arguments);
      };
    })());
    _defineProperty(_assertThisInitialized(_this), "onFileDragOver", function(e3) {
      e3.preventDefault();
    });
    _defineProperty(_assertThisInitialized(_this), "onFileDrop", /* @__PURE__ */ (function() {
      var _ref3 = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee3(e3) {
        var dataTransfer;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              e3.preventDefault();
              if (!(e3.type === "drop")) {
                _context3.next = 4;
                break;
              }
              dataTransfer = e3.dataTransfer;
              return _context3.abrupt("return", _this.onDataTransferFiles(dataTransfer));
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return function(_x4) {
        return _ref3.apply(this, arguments);
      };
    })());
    _defineProperty(_assertThisInitialized(_this), "uploadFiles", function(files) {
      var originFiles = _toConsumableArray(files);
      var postFiles = originFiles.map(function(file) {
        file.uid = uid2();
        return _this.processFile(file, originFiles);
      });
      Promise.all(postFiles).then(function(fileList) {
        var onBatchStart = _this.props.onBatchStart;
        onBatchStart === null || onBatchStart === void 0 || onBatchStart(fileList.map(function(_ref4) {
          var origin = _ref4.origin, parsedFile = _ref4.parsedFile;
          return {
            file: origin,
            parsedFile
          };
        }));
        fileList.filter(function(file) {
          return file.parsedFile !== null;
        }).forEach(function(file) {
          _this.post(file);
        });
      });
    });
    _defineProperty(_assertThisInitialized(_this), "processFile", /* @__PURE__ */ (function() {
      var _ref5 = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee4(file, fileList) {
        var beforeUpload, transformedFile, action, mergedAction, data2, mergedData, parsedData, parsedFile, mergedParsedFile;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              beforeUpload = _this.props.beforeUpload;
              transformedFile = file;
              if (!beforeUpload) {
                _context4.next = 14;
                break;
              }
              _context4.prev = 3;
              _context4.next = 6;
              return beforeUpload(file, fileList);
            case 6:
              transformedFile = _context4.sent;
              _context4.next = 12;
              break;
            case 9:
              _context4.prev = 9;
              _context4.t0 = _context4["catch"](3);
              transformedFile = false;
            case 12:
              if (!(transformedFile === false)) {
                _context4.next = 14;
                break;
              }
              return _context4.abrupt("return", {
                origin: file,
                parsedFile: null,
                action: null,
                data: null
              });
            case 14:
              action = _this.props.action;
              if (!(typeof action === "function")) {
                _context4.next = 21;
                break;
              }
              _context4.next = 18;
              return action(file);
            case 18:
              mergedAction = _context4.sent;
              _context4.next = 22;
              break;
            case 21:
              mergedAction = action;
            case 22:
              data2 = _this.props.data;
              if (!(typeof data2 === "function")) {
                _context4.next = 29;
                break;
              }
              _context4.next = 26;
              return data2(file);
            case 26:
              mergedData = _context4.sent;
              _context4.next = 30;
              break;
            case 29:
              mergedData = data2;
            case 30:
              parsedData = // string type is from legacy `transformFile`.
              // Not sure if this will work since no related test case works with it
              (_typeof(transformedFile) === "object" || typeof transformedFile === "string") && transformedFile ? transformedFile : file;
              if (parsedData instanceof File) {
                parsedFile = parsedData;
              } else {
                parsedFile = new File([parsedData], file.name, {
                  type: file.type
                });
              }
              mergedParsedFile = parsedFile;
              mergedParsedFile.uid = file.uid;
              return _context4.abrupt("return", {
                origin: file,
                data: mergedData,
                parsedFile: mergedParsedFile,
                action: mergedAction
              });
            case 35:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[3, 9]]);
      }));
      return function(_x5, _x6) {
        return _ref5.apply(this, arguments);
      };
    })());
    _defineProperty(_assertThisInitialized(_this), "saveFileInput", function(node2) {
      _this.fileInput = node2;
    });
    return _this;
  }
  _createClass(AjaxUploader2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._isMounted = true;
      var pastable = this.props.pastable;
      if (pastable) {
        document.addEventListener("paste", this.onFilePaste);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._isMounted = false;
      this.abort();
      document.removeEventListener("paste", this.onFilePaste);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var pastable = this.props.pastable;
      if (pastable && !prevProps.pastable) {
        document.addEventListener("paste", this.onFilePaste);
      } else if (!pastable && prevProps.pastable) {
        document.removeEventListener("paste", this.onFilePaste);
      }
    }
  }, {
    key: "post",
    value: function post(_ref6) {
      var _this2 = this;
      var data2 = _ref6.data, origin = _ref6.origin, action = _ref6.action, parsedFile = _ref6.parsedFile;
      if (!this._isMounted) {
        return;
      }
      var _this$props3 = this.props, onStart = _this$props3.onStart, customRequest = _this$props3.customRequest, name = _this$props3.name, headers = _this$props3.headers, withCredentials = _this$props3.withCredentials, method4 = _this$props3.method;
      var uid3 = origin.uid;
      var request = customRequest || upload;
      var requestOption = {
        action,
        filename: name,
        data: data2,
        file: parsedFile,
        headers,
        withCredentials,
        method: method4 || "post",
        onProgress: function onProgress(e3) {
          var onProgress2 = _this2.props.onProgress;
          onProgress2 === null || onProgress2 === void 0 || onProgress2(e3, parsedFile);
        },
        onSuccess: function onSuccess(ret, xhr) {
          var onSuccess2 = _this2.props.onSuccess;
          onSuccess2 === null || onSuccess2 === void 0 || onSuccess2(ret, parsedFile, xhr);
          delete _this2.reqs[uid3];
        },
        onError: function onError(err, ret) {
          var onError2 = _this2.props.onError;
          onError2 === null || onError2 === void 0 || onError2(err, ret, parsedFile);
          delete _this2.reqs[uid3];
        }
      };
      onStart(origin);
      this.reqs[uid3] = request(requestOption);
    }
  }, {
    key: "reset",
    value: function reset2() {
      this.setState({
        uid: uid2()
      });
    }
  }, {
    key: "abort",
    value: function abort(file) {
      var reqs = this.reqs;
      if (file) {
        var uid3 = file.uid ? file.uid : file;
        if (reqs[uid3] && reqs[uid3].abort) {
          reqs[uid3].abort();
        }
        delete reqs[uid3];
      } else {
        Object.keys(reqs).forEach(function(uid4) {
          if (reqs[uid4] && reqs[uid4].abort) {
            reqs[uid4].abort();
          }
          delete reqs[uid4];
        });
      }
    }
  }, {
    key: "render",
    value: function render4() {
      var _this$props4 = this.props, Tag = _this$props4.component, prefixCls = _this$props4.prefixCls, className2 = _this$props4.className, _this$props4$classNam = _this$props4.classNames, classNames186 = _this$props4$classNam === void 0 ? {} : _this$props4$classNam, disabled = _this$props4.disabled, id = _this$props4.id, name = _this$props4.name, style2 = _this$props4.style, _this$props4$styles = _this$props4.styles, styles = _this$props4$styles === void 0 ? {} : _this$props4$styles, multiple = _this$props4.multiple, accept = _this$props4.accept, capture = _this$props4.capture, children = _this$props4.children, directory = _this$props4.directory, openFileDialogOnClick = _this$props4.openFileDialogOnClick, onMouseEnter = _this$props4.onMouseEnter, onMouseLeave = _this$props4.onMouseLeave, hasControlInside = _this$props4.hasControlInside, otherProps = _objectWithoutProperties(_this$props4, _excluded75);
      var cls11 = (0, import_classnames202.default)(_defineProperty(_defineProperty(_defineProperty({}, prefixCls, true), "".concat(prefixCls, "-disabled"), disabled), className2, className2));
      var dirProps = directory ? {
        directory: "directory",
        webkitdirectory: "webkitdirectory"
      } : {};
      var events2 = disabled ? {} : {
        onClick: openFileDialogOnClick ? this.onClick : function() {
        },
        onKeyDown: openFileDialogOnClick ? this.onKeyDown : function() {
        },
        onMouseEnter,
        onMouseLeave,
        onDrop: this.onFileDrop,
        onDragOver: this.onFileDragOver,
        tabIndex: hasControlInside ? void 0 : "0"
      };
      return /* @__PURE__ */ import_react152.default.createElement(Tag, _extends({}, events2, {
        className: cls11,
        role: hasControlInside ? void 0 : "button",
        style: style2
      }), /* @__PURE__ */ import_react152.default.createElement("input", _extends({}, pickAttrs(otherProps, {
        aria: true,
        data: true
      }), {
        id,
        name,
        disabled,
        type: "file",
        ref: this.saveFileInput,
        onClick: function onClick(e3) {
          return e3.stopPropagation();
        },
        key: this.state.uid,
        style: _objectSpread2({
          display: "none"
        }, styles.input),
        className: classNames186.input,
        accept
      }, dirProps, {
        multiple,
        onChange: this.onChange
      }, capture != null ? {
        capture
      } : {})), children);
    }
  }]);
  return AjaxUploader2;
})(import_react152.Component);
var AjaxUploader_default = AjaxUploader;

// ../../node_modules/rc-upload/es/Upload.js
function empty2() {
}
var Upload = /* @__PURE__ */ (function(_Component) {
  _inherits(Upload4, _Component);
  var _super = _createSuper(Upload4);
  function Upload4() {
    var _this;
    _classCallCheck(this, Upload4);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "uploader", void 0);
    _defineProperty(_assertThisInitialized(_this), "saveUploader", function(node2) {
      _this.uploader = node2;
    });
    return _this;
  }
  _createClass(Upload4, [{
    key: "abort",
    value: function abort(file) {
      this.uploader.abort(file);
    }
  }, {
    key: "render",
    value: function render4() {
      return /* @__PURE__ */ import_react153.default.createElement(AjaxUploader_default, _extends({}, this.props, {
        ref: this.saveUploader
      }));
    }
  }]);
  return Upload4;
})(import_react153.Component);
_defineProperty(Upload, "defaultProps", {
  component: "span",
  prefixCls: "rc-upload",
  data: {},
  headers: {},
  name: "file",
  multipart: false,
  onStart: empty2,
  onError: empty2,
  onSuccess: empty2,
  multiple: false,
  beforeUpload: null,
  customRequest: null,
  withCredentials: false,
  openFileDialogOnClick: true,
  hasControlInside: false
});
var Upload_default = Upload;

// ../../node_modules/rc-upload/es/index.js
var es_default29 = Upload_default;

// ../../node_modules/antd/es/upload/style/dragger.js
var genDraggerStyle = (token2) => {
  const {
    componentCls,
    iconCls
  } = token2;
  return {
    [`${componentCls}-wrapper`]: {
      [`${componentCls}-drag`]: {
        position: "relative",
        width: "100%",
        height: "100%",
        textAlign: "center",
        background: token2.colorFillAlter,
        border: `${unit(token2.lineWidth)} dashed ${token2.colorBorder}`,
        borderRadius: token2.borderRadiusLG,
        cursor: "pointer",
        transition: `border-color ${token2.motionDurationSlow}`,
        [componentCls]: {
          padding: token2.padding
        },
        [`${componentCls}-btn`]: {
          display: "table",
          width: "100%",
          height: "100%",
          outline: "none",
          borderRadius: token2.borderRadiusLG,
          "&:focus-visible": {
            outline: `${unit(token2.lineWidthFocus)} solid ${token2.colorPrimaryBorder}`
          }
        },
        [`${componentCls}-drag-container`]: {
          display: "table-cell",
          verticalAlign: "middle"
        },
        [`
          &:not(${componentCls}-disabled):hover,
          &-hover:not(${componentCls}-disabled)
        `]: {
          borderColor: token2.colorPrimaryHover
        },
        [`p${componentCls}-drag-icon`]: {
          marginBottom: token2.margin,
          [iconCls]: {
            color: token2.colorPrimary,
            fontSize: token2.uploadThumbnailSize
          }
        },
        [`p${componentCls}-text`]: {
          margin: `0 0 ${unit(token2.marginXXS)}`,
          color: token2.colorTextHeading,
          fontSize: token2.fontSizeLG
        },
        [`p${componentCls}-hint`]: {
          color: token2.colorTextDescription,
          fontSize: token2.fontSize
        },
        // ===================== Disabled =====================
        [`&${componentCls}-disabled`]: {
          [`p${componentCls}-drag-icon ${iconCls},
            p${componentCls}-text,
            p${componentCls}-hint
          `]: {
            color: token2.colorTextDisabled
          }
        }
      }
    }
  };
};
var dragger_default = genDraggerStyle;

// ../../node_modules/antd/es/upload/style/list.js
var genListStyle = (token2) => {
  const {
    componentCls,
    iconCls,
    fontSize,
    lineHeight,
    calc
  } = token2;
  const itemCls = `${componentCls}-list-item`;
  const actionsCls = `${itemCls}-actions`;
  const actionCls = `${itemCls}-action`;
  return {
    [`${componentCls}-wrapper`]: {
      [`${componentCls}-list`]: Object.assign(Object.assign({}, clearFix()), {
        lineHeight: token2.lineHeight,
        [itemCls]: {
          position: "relative",
          height: calc(token2.lineHeight).mul(fontSize).equal(),
          marginTop: token2.marginXS,
          fontSize,
          display: "flex",
          alignItems: "center",
          transition: `background-color ${token2.motionDurationSlow}`,
          borderRadius: token2.borderRadiusSM,
          "&:hover": {
            backgroundColor: token2.controlItemBgHover
          },
          [`${itemCls}-name`]: Object.assign(Object.assign({}, textEllipsis), {
            padding: `0 ${unit(token2.paddingXS)}`,
            lineHeight,
            flex: "auto",
            transition: `all ${token2.motionDurationSlow}`
          }),
          [actionsCls]: {
            whiteSpace: "nowrap",
            [actionCls]: {
              opacity: 0
            },
            [iconCls]: {
              color: token2.actionsColor,
              transition: `all ${token2.motionDurationSlow}`
            },
            [`
              ${actionCls}:focus-visible,
              &.picture ${actionCls}
            `]: {
              opacity: 1
            }
          },
          [`${componentCls}-icon ${iconCls}`]: {
            color: token2.colorIcon,
            fontSize
          },
          [`${itemCls}-progress`]: {
            position: "absolute",
            bottom: token2.calc(token2.uploadProgressOffset).mul(-1).equal(),
            width: "100%",
            paddingInlineStart: calc(fontSize).add(token2.paddingXS).equal(),
            fontSize,
            lineHeight: 0,
            pointerEvents: "none",
            "> div": {
              margin: 0
            }
          }
        },
        [`${itemCls}:hover ${actionCls}`]: {
          opacity: 1
        },
        [`${itemCls}-error`]: {
          color: token2.colorError,
          [`${itemCls}-name, ${componentCls}-icon ${iconCls}`]: {
            color: token2.colorError
          },
          [actionsCls]: {
            [`${iconCls}, ${iconCls}:hover`]: {
              color: token2.colorError
            },
            [actionCls]: {
              opacity: 1
            }
          }
        },
        [`${componentCls}-list-item-container`]: {
          transition: `opacity ${token2.motionDurationSlow}, height ${token2.motionDurationSlow}`,
          // For smooth removing animation
          "&::before": {
            display: "table",
            width: 0,
            height: 0,
            content: '""'
          }
        }
      })
    }
  };
};
var list_default2 = genListStyle;

// ../../node_modules/antd/es/upload/style/motion.js
var genMotionStyle3 = (token2) => {
  const {
    componentCls
  } = token2;
  const uploadAnimateInlineIn = new Keyframes_default("uploadAnimateInlineIn", {
    from: {
      width: 0,
      height: 0,
      padding: 0,
      opacity: 0,
      margin: token2.calc(token2.marginXS).div(-2).equal()
    }
  });
  const uploadAnimateInlineOut = new Keyframes_default("uploadAnimateInlineOut", {
    to: {
      width: 0,
      height: 0,
      padding: 0,
      opacity: 0,
      margin: token2.calc(token2.marginXS).div(-2).equal()
    }
  });
  const inlineCls = `${componentCls}-animate-inline`;
  return [{
    [`${componentCls}-wrapper`]: {
      [`${inlineCls}-appear, ${inlineCls}-enter, ${inlineCls}-leave`]: {
        animationDuration: token2.motionDurationSlow,
        animationTimingFunction: token2.motionEaseInOutCirc,
        animationFillMode: "forwards"
      },
      [`${inlineCls}-appear, ${inlineCls}-enter`]: {
        animationName: uploadAnimateInlineIn
      },
      [`${inlineCls}-leave`]: {
        animationName: uploadAnimateInlineOut
      }
    }
  }, {
    [`${componentCls}-wrapper`]: initFadeMotion(token2)
  }, uploadAnimateInlineIn, uploadAnimateInlineOut];
};
var motion_default4 = genMotionStyle3;

// ../../node_modules/antd/es/upload/style/picture.js
var genPictureStyle = (token2) => {
  const {
    componentCls,
    iconCls,
    uploadThumbnailSize,
    uploadProgressOffset,
    calc
  } = token2;
  const listCls = `${componentCls}-list`;
  const itemCls = `${listCls}-item`;
  return {
    [`${componentCls}-wrapper`]: {
      // ${listCls} 增加优先级
      [`
        ${listCls}${listCls}-picture,
        ${listCls}${listCls}-picture-card,
        ${listCls}${listCls}-picture-circle
      `]: {
        [itemCls]: {
          position: "relative",
          height: calc(uploadThumbnailSize).add(calc(token2.lineWidth).mul(2)).add(calc(token2.paddingXS).mul(2)).equal(),
          padding: token2.paddingXS,
          border: `${unit(token2.lineWidth)} ${token2.lineType} ${token2.colorBorder}`,
          borderRadius: token2.borderRadiusLG,
          "&:hover": {
            background: "transparent"
          },
          [`${itemCls}-thumbnail`]: Object.assign(Object.assign({}, textEllipsis), {
            width: uploadThumbnailSize,
            height: uploadThumbnailSize,
            lineHeight: unit(calc(uploadThumbnailSize).add(token2.paddingSM).equal()),
            textAlign: "center",
            flex: "none",
            [iconCls]: {
              fontSize: token2.fontSizeHeading2,
              color: token2.colorPrimary
            },
            img: {
              display: "block",
              width: "100%",
              height: "100%",
              overflow: "hidden"
            }
          }),
          [`${itemCls}-progress`]: {
            bottom: uploadProgressOffset,
            width: `calc(100% - ${unit(calc(token2.paddingSM).mul(2).equal())})`,
            marginTop: 0,
            paddingInlineStart: calc(uploadThumbnailSize).add(token2.paddingXS).equal()
          }
        },
        [`${itemCls}-error`]: {
          borderColor: token2.colorError,
          // Adjust the color of the error icon : https://github.com/ant-design/ant-design/pull/24160
          [`${itemCls}-thumbnail ${iconCls}`]: {
            [`svg path[fill='${blue[0]}']`]: {
              fill: token2.colorErrorBg
            },
            [`svg path[fill='${blue.primary}']`]: {
              fill: token2.colorError
            }
          }
        },
        [`${itemCls}-uploading`]: {
          borderStyle: "dashed",
          [`${itemCls}-name`]: {
            marginBottom: uploadProgressOffset
          }
        }
      },
      [`${listCls}${listCls}-picture-circle ${itemCls}`]: {
        [`&, &::before, ${itemCls}-thumbnail`]: {
          borderRadius: "50%"
        }
      }
    }
  };
};
var genPictureCardStyle = (token2) => {
  const {
    componentCls,
    iconCls,
    fontSizeLG,
    colorTextLightSolid,
    calc
  } = token2;
  const listCls = `${componentCls}-list`;
  const itemCls = `${listCls}-item`;
  const uploadPictureCardSize = token2.uploadPicCardSize;
  return {
    [`
      ${componentCls}-wrapper${componentCls}-picture-card-wrapper,
      ${componentCls}-wrapper${componentCls}-picture-circle-wrapper
    `]: Object.assign(Object.assign({}, clearFix()), {
      display: "block",
      [`${componentCls}${componentCls}-select`]: {
        width: uploadPictureCardSize,
        height: uploadPictureCardSize,
        textAlign: "center",
        verticalAlign: "top",
        backgroundColor: token2.colorFillAlter,
        border: `${unit(token2.lineWidth)} dashed ${token2.colorBorder}`,
        borderRadius: token2.borderRadiusLG,
        cursor: "pointer",
        transition: `border-color ${token2.motionDurationSlow}`,
        [`> ${componentCls}`]: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
          textAlign: "center"
        },
        [`&:not(${componentCls}-disabled):hover`]: {
          borderColor: token2.colorPrimary
        }
      },
      // list
      [`${listCls}${listCls}-picture-card, ${listCls}${listCls}-picture-circle`]: {
        display: "flex",
        flexWrap: "wrap",
        "@supports not (gap: 1px)": {
          "& > *": {
            marginBlockEnd: token2.marginXS,
            marginInlineEnd: token2.marginXS
          }
        },
        "@supports (gap: 1px)": {
          gap: token2.marginXS
        },
        [`${listCls}-item-container`]: {
          display: "inline-block",
          width: uploadPictureCardSize,
          height: uploadPictureCardSize,
          verticalAlign: "top"
        },
        "&::after": {
          display: "none"
        },
        "&::before": {
          display: "none"
        },
        [itemCls]: {
          height: "100%",
          margin: 0,
          "&::before": {
            position: "absolute",
            zIndex: 1,
            width: `calc(100% - ${unit(calc(token2.paddingXS).mul(2).equal())})`,
            height: `calc(100% - ${unit(calc(token2.paddingXS).mul(2).equal())})`,
            backgroundColor: token2.colorBgMask,
            opacity: 0,
            transition: `all ${token2.motionDurationSlow}`,
            content: '" "'
          }
        },
        [`${itemCls}:hover`]: {
          [`&::before, ${itemCls}-actions`]: {
            opacity: 1
          }
        },
        [`${itemCls}-actions`]: {
          position: "absolute",
          insetInlineStart: 0,
          zIndex: 10,
          width: "100%",
          whiteSpace: "nowrap",
          textAlign: "center",
          opacity: 0,
          transition: `all ${token2.motionDurationSlow}`,
          [`
            ${iconCls}-eye,
            ${iconCls}-download,
            ${iconCls}-delete
          `]: {
            zIndex: 10,
            width: fontSizeLG,
            margin: `0 ${unit(token2.marginXXS)}`,
            fontSize: fontSizeLG,
            cursor: "pointer",
            transition: `all ${token2.motionDurationSlow}`,
            color: colorTextLightSolid,
            "&:hover": {
              color: colorTextLightSolid
            },
            svg: {
              verticalAlign: "baseline"
            }
          }
        },
        [`${itemCls}-thumbnail, ${itemCls}-thumbnail img`]: {
          position: "static",
          display: "block",
          width: "100%",
          height: "100%",
          objectFit: "contain"
        },
        [`${itemCls}-name`]: {
          display: "none",
          textAlign: "center"
        },
        [`${itemCls}-file + ${itemCls}-name`]: {
          position: "absolute",
          bottom: token2.margin,
          display: "block",
          width: `calc(100% - ${unit(calc(token2.paddingXS).mul(2).equal())})`
        },
        [`${itemCls}-uploading`]: {
          [`&${itemCls}`]: {
            backgroundColor: token2.colorFillAlter
          },
          [`&::before, ${iconCls}-eye, ${iconCls}-download, ${iconCls}-delete`]: {
            display: "none"
          }
        },
        [`${itemCls}-progress`]: {
          bottom: token2.marginXL,
          width: `calc(100% - ${unit(calc(token2.paddingXS).mul(2).equal())})`,
          paddingInlineStart: 0
        }
      }
    }),
    [`${componentCls}-wrapper${componentCls}-picture-circle-wrapper`]: {
      [`${componentCls}${componentCls}-select`]: {
        borderRadius: "50%"
      }
    }
  };
};

// ../../node_modules/antd/es/upload/style/rtl.js
var genRtlStyle2 = (token2) => {
  const {
    componentCls
  } = token2;
  return {
    [`${componentCls}-rtl`]: {
      direction: "rtl"
    }
  };
};
var rtl_default3 = genRtlStyle2;

// ../../node_modules/antd/es/upload/style/index.js
var genBaseStyle13 = (token2) => {
  const {
    componentCls,
    colorTextDisabled
  } = token2;
  return {
    [`${componentCls}-wrapper`]: Object.assign(Object.assign({}, resetComponent(token2)), {
      [componentCls]: {
        outline: 0,
        "input[type='file']": {
          cursor: "pointer"
        }
      },
      [`${componentCls}-select`]: {
        display: "inline-block"
      },
      [`${componentCls}-hidden`]: {
        display: "none"
      },
      [`${componentCls}-disabled`]: {
        color: colorTextDisabled,
        cursor: "not-allowed"
      }
    })
  };
};
var prepareComponentToken33 = (token2) => ({
  actionsColor: token2.colorIcon
});
var style_default38 = genStyleHooks("Upload", (token2) => {
  const {
    fontSizeHeading3,
    fontHeight,
    lineWidth,
    controlHeightLG,
    calc
  } = token2;
  const uploadToken = merge2(token2, {
    uploadThumbnailSize: calc(fontSizeHeading3).mul(2).equal(),
    uploadProgressOffset: calc(calc(fontHeight).div(2)).add(lineWidth).equal(),
    uploadPicCardSize: calc(controlHeightLG).mul(2.55).equal()
  });
  return [genBaseStyle13(uploadToken), dragger_default(uploadToken), genPictureStyle(uploadToken), genPictureCardStyle(uploadToken), list_default2(uploadToken), motion_default4(uploadToken), rtl_default3(uploadToken), collapse_default(uploadToken)];
}, prepareComponentToken33);

// ../../node_modules/antd/es/upload/UploadList/index.js
var React527 = __toESM(require_react());

// ../../node_modules/@ant-design/icons/es/icons/FileTwoTone.js
var React522 = __toESM(require_react());

// ../../node_modules/@ant-design/icons-svg/es/asn/FileTwoTone.js
var FileTwoTone = { "icon": function render2(primaryColor, secondaryColor) {
  return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M534 352V136H232v752h560V394H576a42 42 0 01-42-42z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0042 42h216v494z", "fill": primaryColor } }] };
}, "name": "file", "theme": "twotone" };
var FileTwoTone_default = FileTwoTone;

// ../../node_modules/@ant-design/icons/es/icons/FileTwoTone.js
var FileTwoTone2 = function FileTwoTone3(props, ref3) {
  return /* @__PURE__ */ React522.createElement(AntdIcon_default, _extends({}, props, {
    ref: ref3,
    icon: FileTwoTone_default
  }));
};
var RefIcon45 = /* @__PURE__ */ React522.forwardRef(FileTwoTone2);
if (true) {
  RefIcon45.displayName = "FileTwoTone";
}
var FileTwoTone_default2 = RefIcon45;

// ../../node_modules/@ant-design/icons/es/icons/PaperClipOutlined.js
var React523 = __toESM(require_react());

// ../../node_modules/@ant-design/icons-svg/es/asn/PaperClipOutlined.js
var PaperClipOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M779.3 196.6c-94.2-94.2-247.6-94.2-341.7 0l-261 260.8c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0012.7 0l261-260.8c32.4-32.4 75.5-50.2 121.3-50.2s88.9 17.8 121.2 50.2c32.4 32.4 50.2 75.5 50.2 121.2 0 45.8-17.8 88.8-50.2 121.2l-266 265.9-43.1 43.1c-40.3 40.3-105.8 40.3-146.1 0-19.5-19.5-30.2-45.4-30.2-73s10.7-53.5 30.2-73l263.9-263.8c6.7-6.6 15.5-10.3 24.9-10.3h.1c9.4 0 18.1 3.7 24.7 10.3 6.7 6.7 10.3 15.5 10.3 24.9 0 9.3-3.7 18.1-10.3 24.7L372.4 653c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0012.7 0l215.6-215.6c19.9-19.9 30.8-46.3 30.8-74.4s-11-54.6-30.8-74.4c-41.1-41.1-107.9-41-149 0L463 364 224.8 602.1A172.22 172.22 0 00174 724.8c0 46.3 18.1 89.8 50.8 122.5 33.9 33.8 78.3 50.7 122.7 50.7 44.4 0 88.8-16.9 122.6-50.7l309.2-309C824.8 492.7 850 432 850 367.5c.1-64.6-25.1-125.3-70.7-170.9z" } }] }, "name": "paper-clip", "theme": "outlined" };
var PaperClipOutlined_default = PaperClipOutlined;

// ../../node_modules/@ant-design/icons/es/icons/PaperClipOutlined.js
var PaperClipOutlined2 = function PaperClipOutlined3(props, ref3) {
  return /* @__PURE__ */ React523.createElement(AntdIcon_default, _extends({}, props, {
    ref: ref3,
    icon: PaperClipOutlined_default
  }));
};
var RefIcon46 = /* @__PURE__ */ React523.forwardRef(PaperClipOutlined2);
if (true) {
  RefIcon46.displayName = "PaperClipOutlined";
}
var PaperClipOutlined_default2 = RefIcon46;

// ../../node_modules/@ant-design/icons/es/icons/PictureTwoTone.js
var React524 = __toESM(require_react());

// ../../node_modules/@ant-design/icons-svg/es/asn/PictureTwoTone.js
var PictureTwoTone = { "icon": function render3(primaryColor, secondaryColor) {
  return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136v-39.9l138.5-164.3 150.1 178L658.1 489 888 761.6V792zm0-129.8L664.2 396.8c-3.2-3.8-9-3.8-12.2 0L424.6 666.4l-144-170.7c-3.2-3.8-9-3.8-12.2 0L136 652.7V232h752v430.2z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M424.6 765.8l-150.1-178L136 752.1V792h752v-30.4L658.1 489z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M136 652.7l132.4-157c3.2-3.8 9-3.8 12.2 0l144 170.7L652 396.8c3.2-3.8 9-3.8 12.2 0L888 662.2V232H136v420.7zM304 280a88 88 0 110 176 88 88 0 010-176z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M276 368a28 28 0 1056 0 28 28 0 10-56 0z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M304 456a88 88 0 100-176 88 88 0 000 176zm0-116c15.5 0 28 12.5 28 28s-12.5 28-28 28-28-12.5-28-28 12.5-28 28-28z", "fill": primaryColor } }] };
}, "name": "picture", "theme": "twotone" };
var PictureTwoTone_default = PictureTwoTone;

// ../../node_modules/@ant-design/icons/es/icons/PictureTwoTone.js
var PictureTwoTone2 = function PictureTwoTone3(props, ref3) {
  return /* @__PURE__ */ React524.createElement(AntdIcon_default, _extends({}, props, {
    ref: ref3,
    icon: PictureTwoTone_default
  }));
};
var RefIcon47 = /* @__PURE__ */ React524.forwardRef(PictureTwoTone2);
if (true) {
  RefIcon47.displayName = "PictureTwoTone";
}
var PictureTwoTone_default2 = RefIcon47;

// ../../node_modules/antd/es/upload/UploadList/index.js
var import_classnames204 = __toESM(require_classnames());

// ../../node_modules/antd/es/upload/utils.js
function file2Obj(file) {
  return Object.assign(Object.assign({}, file), {
    lastModified: file.lastModified,
    lastModifiedDate: file.lastModifiedDate,
    name: file.name,
    size: file.size,
    type: file.type,
    uid: file.uid,
    percent: 0,
    originFileObj: file
  });
}
function updateFileList(file, fileList) {
  const nextFileList = _toConsumableArray(fileList);
  const fileIndex = nextFileList.findIndex(({
    uid: uid3
  }) => uid3 === file.uid);
  if (fileIndex === -1) {
    nextFileList.push(file);
  } else {
    nextFileList[fileIndex] = file;
  }
  return nextFileList;
}
function getFileItem(file, fileList) {
  const matchKey = file.uid !== void 0 ? "uid" : "name";
  return fileList.filter((item) => item[matchKey] === file[matchKey])[0];
}
function removeFileItem(file, fileList) {
  const matchKey = file.uid !== void 0 ? "uid" : "name";
  const removed = fileList.filter((item) => item[matchKey] !== file[matchKey]);
  if (removed.length === fileList.length) {
    return null;
  }
  return removed;
}
var extname = (url2 = "") => {
  const temp = url2.split("/");
  const filename = temp[temp.length - 1];
  const filenameWithoutSuffix = filename.split(/#|\?/)[0];
  return (/\.[^./\\]*$/.exec(filenameWithoutSuffix) || [""])[0];
};
var isImageFileType = (type5) => type5.indexOf("image/") === 0;
var isImageUrl = (file) => {
  if (file.type && !file.thumbUrl) {
    return isImageFileType(file.type);
  }
  const url2 = file.thumbUrl || file.url || "";
  const extension = extname(url2);
  if (/^data:image\//.test(url2) || /(webp|svg|png|gif|jpg|jpeg|jfif|bmp|dpg|ico|heic|heif)$/i.test(extension)) {
    return true;
  }
  if (/^data:/.test(url2)) {
    return false;
  }
  if (extension) {
    return false;
  }
  return true;
};
var MEASURE_SIZE = 200;
function previewImage(file) {
  return new Promise((resolve) => {
    if (!file.type || !isImageFileType(file.type)) {
      resolve("");
      return;
    }
    const canvas = document.createElement("canvas");
    canvas.width = MEASURE_SIZE;
    canvas.height = MEASURE_SIZE;
    canvas.style.cssText = `position: fixed; left: 0; top: 0; width: ${MEASURE_SIZE}px; height: ${MEASURE_SIZE}px; z-index: 9999; display: none;`;
    document.body.appendChild(canvas);
    const ctx = canvas.getContext("2d");
    const img = new Image();
    img.onload = () => {
      const {
        width,
        height
      } = img;
      let drawWidth = MEASURE_SIZE;
      let drawHeight = MEASURE_SIZE;
      let offsetX = 0;
      let offsetY = 0;
      if (width > height) {
        drawHeight = height * (MEASURE_SIZE / width);
        offsetY = -(drawHeight - drawWidth) / 2;
      } else {
        drawWidth = width * (MEASURE_SIZE / height);
        offsetX = -(drawWidth - drawHeight) / 2;
      }
      ctx.drawImage(img, offsetX, offsetY, drawWidth, drawHeight);
      const dataURL = canvas.toDataURL();
      document.body.removeChild(canvas);
      window.URL.revokeObjectURL(img.src);
      resolve(dataURL);
    };
    img.crossOrigin = "anonymous";
    if (file.type.startsWith("image/svg+xml")) {
      const reader = new FileReader();
      reader.onload = () => {
        if (reader.result && typeof reader.result === "string") {
          img.src = reader.result;
        }
      };
      reader.readAsDataURL(file);
    } else if (file.type.startsWith("image/gif")) {
      const reader = new FileReader();
      reader.onload = () => {
        if (reader.result) {
          resolve(reader.result);
        }
      };
      reader.readAsDataURL(file);
    } else {
      img.src = window.URL.createObjectURL(file);
    }
  });
}

// ../../node_modules/antd/es/upload/UploadList/ListItem.js
var React526 = __toESM(require_react());

// ../../node_modules/@ant-design/icons/es/icons/DownloadOutlined.js
var React525 = __toESM(require_react());

// ../../node_modules/@ant-design/icons-svg/es/asn/DownloadOutlined.js
var DownloadOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M505.7 661a8 8 0 0012.6 0l112-141.7c4.1-5.2.4-12.9-6.3-12.9h-74.1V168c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v338.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.8zM878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z" } }] }, "name": "download", "theme": "outlined" };
var DownloadOutlined_default = DownloadOutlined;

// ../../node_modules/@ant-design/icons/es/icons/DownloadOutlined.js
var DownloadOutlined2 = function DownloadOutlined3(props, ref3) {
  return /* @__PURE__ */ React525.createElement(AntdIcon_default, _extends({}, props, {
    ref: ref3,
    icon: DownloadOutlined_default
  }));
};
var RefIcon48 = /* @__PURE__ */ React525.forwardRef(DownloadOutlined2);
if (true) {
  RefIcon48.displayName = "DownloadOutlined";
}
var DownloadOutlined_default2 = RefIcon48;

// ../../node_modules/antd/es/upload/UploadList/ListItem.js
var import_classnames203 = __toESM(require_classnames());
var ListItem = /* @__PURE__ */ React526.forwardRef(({
  prefixCls,
  className: className2,
  style: style2,
  locale: locale6,
  listType,
  file,
  items,
  progress: progressProps,
  iconRender,
  actionIconRender,
  itemRender,
  isImgUrl,
  showPreviewIcon,
  showRemoveIcon,
  showDownloadIcon,
  previewIcon: customPreviewIcon,
  removeIcon: customRemoveIcon,
  downloadIcon: customDownloadIcon,
  extra: customExtra,
  onPreview,
  onDownload,
  onClose
}, ref3) => {
  var _a, _b;
  const {
    status
  } = file;
  const [mergedStatus, setMergedStatus] = React526.useState(status);
  React526.useEffect(() => {
    if (status !== "removed") {
      setMergedStatus(status);
    }
  }, [status]);
  const [showProgress, setShowProgress] = React526.useState(false);
  React526.useEffect(() => {
    const timer = setTimeout(() => {
      setShowProgress(true);
    }, 300);
    return () => {
      clearTimeout(timer);
    };
  }, []);
  const iconNode = iconRender(file);
  let icon = /* @__PURE__ */ React526.createElement("div", {
    className: `${prefixCls}-icon`
  }, iconNode);
  if (listType === "picture" || listType === "picture-card" || listType === "picture-circle") {
    if (mergedStatus === "uploading" || !file.thumbUrl && !file.url) {
      const uploadingClassName = (0, import_classnames203.default)(`${prefixCls}-list-item-thumbnail`, {
        [`${prefixCls}-list-item-file`]: mergedStatus !== "uploading"
      });
      icon = /* @__PURE__ */ React526.createElement("div", {
        className: uploadingClassName
      }, iconNode);
    } else {
      const thumbnail = (isImgUrl === null || isImgUrl === void 0 ? void 0 : isImgUrl(file)) ? /* @__PURE__ */ React526.createElement("img", {
        src: file.thumbUrl || file.url,
        alt: file.name,
        className: `${prefixCls}-list-item-image`,
        crossOrigin: file.crossOrigin
      }) : iconNode;
      const aClassName = (0, import_classnames203.default)(`${prefixCls}-list-item-thumbnail`, {
        [`${prefixCls}-list-item-file`]: isImgUrl && !isImgUrl(file)
      });
      icon = /* @__PURE__ */ React526.createElement("a", {
        className: aClassName,
        onClick: (e3) => onPreview(file, e3),
        href: file.url || file.thumbUrl,
        target: "_blank",
        rel: "noopener noreferrer"
      }, thumbnail);
    }
  }
  const listItemClassName = (0, import_classnames203.default)(`${prefixCls}-list-item`, `${prefixCls}-list-item-${mergedStatus}`);
  const linkProps = typeof file.linkProps === "string" ? JSON.parse(file.linkProps) : file.linkProps;
  const removeIcon = (typeof showRemoveIcon === "function" ? showRemoveIcon(file) : showRemoveIcon) ? actionIconRender(
    (typeof customRemoveIcon === "function" ? customRemoveIcon(file) : customRemoveIcon) || /* @__PURE__ */ React526.createElement(DeleteOutlined_default2, null),
    () => onClose(file),
    prefixCls,
    locale6.removeFile,
    // acceptUploadDisabled is true, only remove icon will follow Upload disabled prop
    // https://github.com/ant-design/ant-design/issues/46171
    true
  ) : null;
  const downloadIcon = (typeof showDownloadIcon === "function" ? showDownloadIcon(file) : showDownloadIcon) && mergedStatus === "done" ? actionIconRender((typeof customDownloadIcon === "function" ? customDownloadIcon(file) : customDownloadIcon) || /* @__PURE__ */ React526.createElement(DownloadOutlined_default2, null), () => onDownload(file), prefixCls, locale6.downloadFile) : null;
  const downloadOrDelete = listType !== "picture-card" && listType !== "picture-circle" && /* @__PURE__ */ React526.createElement("span", {
    key: "download-delete",
    className: (0, import_classnames203.default)(`${prefixCls}-list-item-actions`, {
      picture: listType === "picture"
    })
  }, downloadIcon, removeIcon);
  const extraContent = typeof customExtra === "function" ? customExtra(file) : customExtra;
  const extra = extraContent && /* @__PURE__ */ React526.createElement("span", {
    className: `${prefixCls}-list-item-extra`
  }, extraContent);
  const listItemNameClass = (0, import_classnames203.default)(`${prefixCls}-list-item-name`);
  const fileName = file.url ? /* @__PURE__ */ React526.createElement("a", Object.assign({
    key: "view",
    target: "_blank",
    rel: "noopener noreferrer",
    className: listItemNameClass,
    title: file.name
  }, linkProps, {
    href: file.url,
    onClick: (e3) => onPreview(file, e3)
  }), file.name, extra) : /* @__PURE__ */ React526.createElement("span", {
    key: "view",
    className: listItemNameClass,
    onClick: (e3) => onPreview(file, e3),
    title: file.name
  }, file.name, extra);
  const previewIcon = (typeof showPreviewIcon === "function" ? showPreviewIcon(file) : showPreviewIcon) && (file.url || file.thumbUrl) ? /* @__PURE__ */ React526.createElement("a", {
    href: file.url || file.thumbUrl,
    target: "_blank",
    rel: "noopener noreferrer",
    onClick: (e3) => onPreview(file, e3),
    title: locale6.previewFile
  }, typeof customPreviewIcon === "function" ? customPreviewIcon(file) : customPreviewIcon || /* @__PURE__ */ React526.createElement(EyeOutlined_default2, null)) : null;
  const pictureCardActions = (listType === "picture-card" || listType === "picture-circle") && mergedStatus !== "uploading" && /* @__PURE__ */ React526.createElement("span", {
    className: `${prefixCls}-list-item-actions`
  }, previewIcon, mergedStatus === "done" && downloadIcon, removeIcon);
  const {
    getPrefixCls
  } = React526.useContext(ConfigContext);
  const rootPrefixCls = getPrefixCls();
  const dom = /* @__PURE__ */ React526.createElement("div", {
    className: listItemClassName
  }, icon, fileName, downloadOrDelete, pictureCardActions, showProgress && /* @__PURE__ */ React526.createElement(es_default2, {
    motionName: `${rootPrefixCls}-fade`,
    visible: mergedStatus === "uploading",
    motionDeadline: 2e3
  }, ({
    className: motionClassName
  }) => {
    const loadingProgress = "percent" in file ? /* @__PURE__ */ React526.createElement(progress_default2, Object.assign({
      type: "line",
      percent: file.percent,
      "aria-label": file["aria-label"],
      "aria-labelledby": file["aria-labelledby"]
    }, progressProps)) : null;
    return /* @__PURE__ */ React526.createElement("div", {
      className: (0, import_classnames203.default)(`${prefixCls}-list-item-progress`, motionClassName)
    }, loadingProgress);
  }));
  const message2 = file.response && typeof file.response === "string" ? file.response : ((_a = file.error) === null || _a === void 0 ? void 0 : _a.statusText) || ((_b = file.error) === null || _b === void 0 ? void 0 : _b.message) || locale6.uploadError;
  const item = mergedStatus === "error" ? /* @__PURE__ */ React526.createElement(tooltip_default, {
    title: message2,
    getPopupContainer: (node2) => node2.parentNode
  }, dom) : dom;
  return /* @__PURE__ */ React526.createElement("div", {
    className: (0, import_classnames203.default)(`${prefixCls}-list-item-container`, className2),
    style: style2,
    ref: ref3
  }, itemRender ? itemRender(item, file, items, {
    download: onDownload.bind(null, file),
    preview: onPreview.bind(null, file),
    remove: onClose.bind(null, file)
  }) : item);
});
var ListItem_default = ListItem;

// ../../node_modules/antd/es/upload/UploadList/index.js
var InternalUploadList = (props, ref3) => {
  const {
    listType = "text",
    previewFile = previewImage,
    onPreview,
    onDownload,
    onRemove,
    locale: locale6,
    iconRender,
    isImageUrl: isImgUrl = isImageUrl,
    prefixCls: customizePrefixCls,
    items = [],
    showPreviewIcon = true,
    showRemoveIcon = true,
    showDownloadIcon = false,
    removeIcon,
    previewIcon,
    downloadIcon,
    extra,
    progress = {
      size: [-1, 2],
      showInfo: false
    },
    appendAction,
    appendActionVisible = true,
    itemRender,
    disabled
  } = props;
  const forceUpdate = useForceUpdate();
  const [motionAppear, setMotionAppear] = React527.useState(false);
  const isPictureCardOrCirle = ["picture-card", "picture-circle"].includes(listType);
  React527.useEffect(() => {
    if (!listType.startsWith("picture")) {
      return;
    }
    (items || []).forEach((file) => {
      if (!(file.originFileObj instanceof File || file.originFileObj instanceof Blob) || file.thumbUrl !== void 0) {
        return;
      }
      file.thumbUrl = "";
      previewFile === null || previewFile === void 0 ? void 0 : previewFile(file.originFileObj).then((previewDataUrl) => {
        file.thumbUrl = previewDataUrl || "";
        forceUpdate();
      });
    });
  }, [listType, items, previewFile]);
  React527.useEffect(() => {
    setMotionAppear(true);
  }, []);
  const onInternalPreview = (file, e3) => {
    if (!onPreview) {
      return;
    }
    e3 === null || e3 === void 0 ? void 0 : e3.preventDefault();
    return onPreview(file);
  };
  const onInternalDownload = (file) => {
    if (typeof onDownload === "function") {
      onDownload(file);
    } else if (file.url) {
      window.open(file.url);
    }
  };
  const onInternalClose = (file) => {
    onRemove === null || onRemove === void 0 ? void 0 : onRemove(file);
  };
  const internalIconRender = (file) => {
    if (iconRender) {
      return iconRender(file, listType);
    }
    const isLoading = file.status === "uploading";
    if (listType.startsWith("picture")) {
      const loadingIcon = listType === "picture" ? /* @__PURE__ */ React527.createElement(LoadingOutlined_default2, null) : locale6.uploading;
      const fileIcon = (isImgUrl === null || isImgUrl === void 0 ? void 0 : isImgUrl(file)) ? /* @__PURE__ */ React527.createElement(PictureTwoTone_default2, null) : /* @__PURE__ */ React527.createElement(FileTwoTone_default2, null);
      return isLoading ? loadingIcon : fileIcon;
    }
    return isLoading ? /* @__PURE__ */ React527.createElement(LoadingOutlined_default2, null) : /* @__PURE__ */ React527.createElement(PaperClipOutlined_default2, null);
  };
  const actionIconRender = (customIcon, callback, prefixCls2, title, acceptUploadDisabled) => {
    const btnProps = {
      type: "text",
      size: "small",
      title,
      onClick: (e3) => {
        var _a, _b;
        callback();
        if (/* @__PURE__ */ React527.isValidElement(customIcon)) {
          (_b = (_a = customIcon.props).onClick) === null || _b === void 0 ? void 0 : _b.call(_a, e3);
        }
      },
      className: `${prefixCls2}-list-item-action`,
      disabled: acceptUploadDisabled ? disabled : false
    };
    return /* @__PURE__ */ React527.isValidElement(customIcon) ? /* @__PURE__ */ React527.createElement(button_default2, Object.assign({}, btnProps, {
      icon: cloneElement4(customIcon, Object.assign(Object.assign({}, customIcon.props), {
        onClick: () => {
        }
      }))
    })) : /* @__PURE__ */ React527.createElement(button_default2, Object.assign({}, btnProps), /* @__PURE__ */ React527.createElement("span", null, customIcon));
  };
  React527.useImperativeHandle(ref3, () => ({
    handlePreview: onInternalPreview,
    handleDownload: onInternalDownload
  }));
  const {
    getPrefixCls
  } = React527.useContext(ConfigContext);
  const prefixCls = getPrefixCls("upload", customizePrefixCls);
  const rootPrefixCls = getPrefixCls();
  const listClassNames = (0, import_classnames204.default)(`${prefixCls}-list`, `${prefixCls}-list-${listType}`);
  const listItemMotion = React527.useMemo(() => omit(motion_default(rootPrefixCls), ["onAppearEnd", "onEnterEnd", "onLeaveEnd"]), [rootPrefixCls]);
  const motionConfig = Object.assign(Object.assign({}, isPictureCardOrCirle ? {} : listItemMotion), {
    motionDeadline: 2e3,
    motionName: `${prefixCls}-${isPictureCardOrCirle ? "animate-inline" : "animate"}`,
    keys: _toConsumableArray(items.map((file) => ({
      key: file.uid,
      file
    }))),
    motionAppear
  });
  return /* @__PURE__ */ React527.createElement("div", {
    className: listClassNames
  }, /* @__PURE__ */ React527.createElement(CSSMotionList_default, Object.assign({}, motionConfig, {
    component: false
  }), ({
    key: key2,
    file,
    className: motionClassName,
    style: motionStyle
  }) => /* @__PURE__ */ React527.createElement(ListItem_default, {
    key: key2,
    locale: locale6,
    prefixCls,
    className: motionClassName,
    style: motionStyle,
    file,
    items,
    progress,
    listType,
    isImgUrl,
    showPreviewIcon,
    showRemoveIcon,
    showDownloadIcon,
    removeIcon,
    previewIcon,
    downloadIcon,
    extra,
    iconRender: internalIconRender,
    actionIconRender,
    itemRender,
    onPreview: onInternalPreview,
    onDownload: onInternalDownload,
    onClose: onInternalClose
  })), appendAction && /* @__PURE__ */ React527.createElement(es_default2, Object.assign({}, motionConfig, {
    visible: appendActionVisible,
    forceRender: true
  }), ({
    className: motionClassName,
    style: motionStyle
  }) => cloneElement4(appendAction, (oriProps) => ({
    className: (0, import_classnames204.default)(oriProps.className, motionClassName),
    style: Object.assign(Object.assign(Object.assign({}, motionStyle), {
      // prevent the element has hover css pseudo-class that may cause animation to end prematurely.
      pointerEvents: motionClassName ? "none" : void 0
    }), oriProps.style)
  }))));
};
var UploadList = /* @__PURE__ */ React527.forwardRef(InternalUploadList);
if (true) {
  UploadList.displayName = "UploadList";
}
var UploadList_default = UploadList;

// ../../node_modules/antd/es/upload/Upload.js
var __awaiter3 = function(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function(resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e3) {
        reject(e3);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e3) {
        reject(e3);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var LIST_IGNORE = `__LIST_IGNORE_${Date.now()}__`;
var InternalUpload = (props, ref3) => {
  const config = useComponentConfig("upload");
  const {
    fileList,
    defaultFileList,
    onRemove,
    showUploadList = true,
    listType = "text",
    onPreview,
    onDownload,
    onChange,
    onDrop,
    previewFile,
    disabled: customDisabled,
    locale: propLocale,
    iconRender,
    isImageUrl: isImageUrl2,
    progress,
    prefixCls: customizePrefixCls,
    className: className2,
    type: type5 = "select",
    children,
    style: style2,
    itemRender,
    maxCount,
    data: data2 = {},
    multiple = false,
    hasControlInside = true,
    action = "",
    accept = "",
    supportServerRender = true,
    rootClassName
  } = props;
  const disabled = React528.useContext(DisabledContext_default);
  const mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
  const customRequest = props.customRequest || config.customRequest;
  const [mergedFileList, setMergedFileList] = useMergedState(defaultFileList || [], {
    value: fileList,
    postState: (list) => list !== null && list !== void 0 ? list : []
  });
  const [dragState, setDragState] = React528.useState("drop");
  const upload2 = React528.useRef(null);
  const wrapRef = React528.useRef(null);
  if (true) {
    const warning6 = devUseWarning("Upload");
    true ? warning6("fileList" in props || !("value" in props), "usage", "`value` is not a valid prop, do you mean `fileList`?") : void 0;
    warning6.deprecated(!("transformFile" in props), "transformFile", "beforeUpload");
  }
  React528.useMemo(() => {
    const timestamp = Date.now();
    (fileList || []).forEach((file, index3) => {
      if (!file.uid && !Object.isFrozen(file)) {
        file.uid = `__AUTO__${timestamp}_${index3}__`;
      }
    });
  }, [fileList]);
  const onInternalChange = (file, changedFileList, event) => {
    let cloneList = _toConsumableArray(changedFileList);
    let exceedMaxCount = false;
    if (maxCount === 1) {
      cloneList = cloneList.slice(-1);
    } else if (maxCount) {
      exceedMaxCount = cloneList.length > maxCount;
      cloneList = cloneList.slice(0, maxCount);
    }
    (0, import_react_dom12.flushSync)(() => {
      setMergedFileList(cloneList);
    });
    const changeInfo = {
      file,
      fileList: cloneList
    };
    if (event) {
      changeInfo.event = event;
    }
    if (!exceedMaxCount || file.status === "removed" || // We should ignore event if current file is exceed `maxCount`
    cloneList.some((f) => f.uid === file.uid)) {
      (0, import_react_dom12.flushSync)(() => {
        onChange === null || onChange === void 0 ? void 0 : onChange(changeInfo);
      });
    }
  };
  const mergedBeforeUpload = (file, fileListArgs) => __awaiter3(void 0, void 0, void 0, function* () {
    const {
      beforeUpload,
      transformFile
    } = props;
    let parsedFile = file;
    if (beforeUpload) {
      const result = yield beforeUpload(file, fileListArgs);
      if (result === false) {
        return false;
      }
      delete file[LIST_IGNORE];
      if (result === LIST_IGNORE) {
        Object.defineProperty(file, LIST_IGNORE, {
          value: true,
          configurable: true
        });
        return false;
      }
      if (typeof result === "object" && result) {
        parsedFile = result;
      }
    }
    if (transformFile) {
      parsedFile = yield transformFile(parsedFile);
    }
    return parsedFile;
  });
  const onBatchStart = (batchFileInfoList) => {
    const filteredFileInfoList = batchFileInfoList.filter((info) => !info.file[LIST_IGNORE]);
    if (!filteredFileInfoList.length) {
      return;
    }
    const objectFileList = filteredFileInfoList.map((info) => file2Obj(info.file));
    let newFileList = _toConsumableArray(mergedFileList);
    objectFileList.forEach((fileObj) => {
      newFileList = updateFileList(fileObj, newFileList);
    });
    objectFileList.forEach((fileObj, index3) => {
      let triggerFileObj = fileObj;
      if (!filteredFileInfoList[index3].parsedFile) {
        const {
          originFileObj
        } = fileObj;
        let clone;
        try {
          clone = new File([originFileObj], originFileObj.name, {
            type: originFileObj.type
          });
        } catch (_a) {
          clone = new Blob([originFileObj], {
            type: originFileObj.type
          });
          clone.name = originFileObj.name;
          clone.lastModifiedDate = /* @__PURE__ */ new Date();
          clone.lastModified = (/* @__PURE__ */ new Date()).getTime();
        }
        clone.uid = fileObj.uid;
        triggerFileObj = clone;
      } else {
        fileObj.status = "uploading";
      }
      onInternalChange(triggerFileObj, newFileList);
    });
  };
  const onSuccess = (response, file, xhr) => {
    try {
      if (typeof response === "string") {
        response = JSON.parse(response);
      }
    } catch (_a) {
    }
    if (!getFileItem(file, mergedFileList)) {
      return;
    }
    const targetItem = file2Obj(file);
    targetItem.status = "done";
    targetItem.percent = 100;
    targetItem.response = response;
    targetItem.xhr = xhr;
    const nextFileList = updateFileList(targetItem, mergedFileList);
    onInternalChange(targetItem, nextFileList);
  };
  const onProgress = (e3, file) => {
    if (!getFileItem(file, mergedFileList)) {
      return;
    }
    const targetItem = file2Obj(file);
    targetItem.status = "uploading";
    targetItem.percent = e3.percent;
    const nextFileList = updateFileList(targetItem, mergedFileList);
    onInternalChange(targetItem, nextFileList, e3);
  };
  const onError = (error2, response, file) => {
    if (!getFileItem(file, mergedFileList)) {
      return;
    }
    const targetItem = file2Obj(file);
    targetItem.error = error2;
    targetItem.response = response;
    targetItem.status = "error";
    const nextFileList = updateFileList(targetItem, mergedFileList);
    onInternalChange(targetItem, nextFileList);
  };
  const handleRemove = (file) => {
    let currentFile;
    Promise.resolve(typeof onRemove === "function" ? onRemove(file) : onRemove).then((ret) => {
      var _a;
      if (ret === false) {
        return;
      }
      const removedFileList = removeFileItem(file, mergedFileList);
      if (removedFileList) {
        currentFile = Object.assign(Object.assign({}, file), {
          status: "removed"
        });
        mergedFileList === null || mergedFileList === void 0 ? void 0 : mergedFileList.forEach((item) => {
          const matchKey = currentFile.uid !== void 0 ? "uid" : "name";
          if (item[matchKey] === currentFile[matchKey] && !Object.isFrozen(item)) {
            item.status = "removed";
          }
        });
        (_a = upload2.current) === null || _a === void 0 ? void 0 : _a.abort(currentFile);
        onInternalChange(currentFile, removedFileList);
      }
    });
  };
  const onFileDrop = (e3) => {
    setDragState(e3.type);
    if (e3.type === "drop") {
      onDrop === null || onDrop === void 0 ? void 0 : onDrop(e3);
    }
  };
  React528.useImperativeHandle(ref3, () => ({
    onBatchStart,
    onSuccess,
    onProgress,
    onError,
    fileList: mergedFileList,
    upload: upload2.current,
    nativeElement: wrapRef.current
  }));
  const {
    getPrefixCls,
    direction,
    upload: ctxUpload
  } = React528.useContext(ConfigContext);
  const prefixCls = getPrefixCls("upload", customizePrefixCls);
  const rcUploadProps = Object.assign(Object.assign({
    onBatchStart,
    onError,
    onProgress,
    onSuccess
  }, props), {
    customRequest,
    data: data2,
    multiple,
    action,
    accept,
    supportServerRender,
    prefixCls,
    disabled: mergedDisabled,
    beforeUpload: mergedBeforeUpload,
    onChange: void 0,
    hasControlInside
  });
  delete rcUploadProps.className;
  delete rcUploadProps.style;
  if (!children || mergedDisabled) {
    delete rcUploadProps.id;
  }
  const wrapperCls = `${prefixCls}-wrapper`;
  const [wrapCSSVar, hashId, cssVarCls] = style_default38(prefixCls, wrapperCls);
  const [contextLocale] = useLocale_default("Upload", en_US_default6.Upload);
  const {
    showRemoveIcon,
    showPreviewIcon,
    showDownloadIcon,
    removeIcon,
    previewIcon,
    downloadIcon,
    extra
  } = typeof showUploadList === "boolean" ? {} : showUploadList;
  const realShowRemoveIcon = typeof showRemoveIcon === "undefined" ? !mergedDisabled : showRemoveIcon;
  const renderUploadList = (button, buttonVisible) => {
    if (!showUploadList) {
      return button;
    }
    return /* @__PURE__ */ React528.createElement(UploadList_default, {
      prefixCls,
      listType,
      items: mergedFileList,
      previewFile,
      onPreview,
      onDownload,
      onRemove: handleRemove,
      showRemoveIcon: realShowRemoveIcon,
      showPreviewIcon,
      showDownloadIcon,
      removeIcon,
      previewIcon,
      downloadIcon,
      iconRender,
      extra,
      locale: Object.assign(Object.assign({}, contextLocale), propLocale),
      isImageUrl: isImageUrl2,
      progress,
      appendAction: button,
      appendActionVisible: buttonVisible,
      itemRender,
      disabled: mergedDisabled
    });
  };
  const mergedCls = (0, import_classnames205.default)(wrapperCls, className2, rootClassName, hashId, cssVarCls, ctxUpload === null || ctxUpload === void 0 ? void 0 : ctxUpload.className, {
    [`${prefixCls}-rtl`]: direction === "rtl",
    [`${prefixCls}-picture-card-wrapper`]: listType === "picture-card",
    [`${prefixCls}-picture-circle-wrapper`]: listType === "picture-circle"
  });
  const mergedStyle = Object.assign(Object.assign({}, ctxUpload === null || ctxUpload === void 0 ? void 0 : ctxUpload.style), style2);
  if (type5 === "drag") {
    const dragCls = (0, import_classnames205.default)(hashId, prefixCls, `${prefixCls}-drag`, {
      [`${prefixCls}-drag-uploading`]: mergedFileList.some((file) => file.status === "uploading"),
      [`${prefixCls}-drag-hover`]: dragState === "dragover",
      [`${prefixCls}-disabled`]: mergedDisabled,
      [`${prefixCls}-rtl`]: direction === "rtl"
    });
    return wrapCSSVar(/* @__PURE__ */ React528.createElement("span", {
      className: mergedCls,
      ref: wrapRef
    }, /* @__PURE__ */ React528.createElement("div", {
      className: dragCls,
      style: mergedStyle,
      onDrop: onFileDrop,
      onDragOver: onFileDrop,
      onDragLeave: onFileDrop
    }, /* @__PURE__ */ React528.createElement(es_default29, Object.assign({}, rcUploadProps, {
      ref: upload2,
      className: `${prefixCls}-btn`
    }), /* @__PURE__ */ React528.createElement("div", {
      className: `${prefixCls}-drag-container`
    }, children))), renderUploadList()));
  }
  const uploadBtnCls = (0, import_classnames205.default)(prefixCls, `${prefixCls}-select`, {
    [`${prefixCls}-disabled`]: mergedDisabled,
    [`${prefixCls}-hidden`]: !children
  });
  const uploadButton = /* @__PURE__ */ React528.createElement("div", {
    className: uploadBtnCls,
    style: mergedStyle
  }, /* @__PURE__ */ React528.createElement(es_default29, Object.assign({}, rcUploadProps, {
    ref: upload2
  })));
  if (listType === "picture-card" || listType === "picture-circle") {
    return wrapCSSVar(/* @__PURE__ */ React528.createElement("span", {
      className: mergedCls,
      ref: wrapRef
    }, renderUploadList(uploadButton, !!children)));
  }
  return wrapCSSVar(/* @__PURE__ */ React528.createElement("span", {
    className: mergedCls,
    ref: wrapRef
  }, uploadButton, renderUploadList()));
};
var Upload2 = /* @__PURE__ */ React528.forwardRef(InternalUpload);
if (true) {
  Upload2.displayName = "Upload";
}
var Upload_default2 = Upload2;

// ../../node_modules/antd/es/upload/Dragger.js
var __rest70 = function(s, e3) {
  var t2 = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e3.indexOf(p) < 0) t2[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e3.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t2[p[i]] = s[p[i]];
  }
  return t2;
};
var Dragger = /* @__PURE__ */ React529.forwardRef((_a, ref3) => {
  var {
    style: style2,
    height,
    hasControlInside = false
  } = _a, restProps = __rest70(_a, ["style", "height", "hasControlInside"]);
  return /* @__PURE__ */ React529.createElement(Upload_default2, Object.assign({
    ref: ref3,
    hasControlInside
  }, restProps, {
    type: "drag",
    style: Object.assign(Object.assign({}, style2), {
      height
    })
  }));
});
if (true) {
  Dragger.displayName = "Dragger";
}
var Dragger_default = Dragger;

// ../../node_modules/antd/es/upload/index.js
var Upload3 = Upload_default2;
Upload3.Dragger = Dragger_default;
Upload3.LIST_IGNORE = LIST_IGNORE;
var upload_default = Upload3;

// ../../node_modules/lucide-react/dist/esm/createLucideIcon.js
var import_react155 = __toESM(require_react());

// ../../node_modules/lucide-react/dist/esm/shared/src/utils.js
var toKebabCase = (string3) => string3.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
var toCamelCase = (string3) => string3.replace(
  /^([A-Z])|[\s-_]+(\w)/g,
  (match2, p1, p2) => p2 ? p2.toUpperCase() : p1.toLowerCase()
);
var toPascalCase = (string3) => {
  const camelCase2 = toCamelCase(string3);
  return camelCase2.charAt(0).toUpperCase() + camelCase2.slice(1);
};
var mergeClasses = (...classes) => classes.filter((className2, index3, array4) => {
  return Boolean(className2) && className2.trim() !== "" && array4.indexOf(className2) === index3;
}).join(" ").trim();
var hasA11yProp = (props) => {
  for (const prop in props) {
    if (prop.startsWith("aria-") || prop === "role" || prop === "title") {
      return true;
    }
  }
};

// ../../node_modules/lucide-react/dist/esm/Icon.js
var import_react154 = __toESM(require_react());

// ../../node_modules/lucide-react/dist/esm/defaultAttributes.js
var defaultAttributes = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};

// ../../node_modules/lucide-react/dist/esm/Icon.js
var Icon5 = (0, import_react154.forwardRef)(
  ({
    color = "currentColor",
    size = 24,
    strokeWidth = 2,
    absoluteStrokeWidth,
    className: className2 = "",
    children,
    iconNode,
    ...rest
  }, ref3) => (0, import_react154.createElement)(
    "svg",
    {
      ref: ref3,
      ...defaultAttributes,
      width: size,
      height: size,
      stroke: color,
      strokeWidth: absoluteStrokeWidth ? Number(strokeWidth) * 24 / Number(size) : strokeWidth,
      className: mergeClasses("lucide", className2),
      ...!children && !hasA11yProp(rest) && { "aria-hidden": "true" },
      ...rest
    },
    [
      ...iconNode.map(([tag, attrs]) => (0, import_react154.createElement)(tag, attrs)),
      ...Array.isArray(children) ? children : [children]
    ]
  )
);

// ../../node_modules/lucide-react/dist/esm/createLucideIcon.js
var createLucideIcon = (iconName, iconNode) => {
  const Component10 = (0, import_react155.forwardRef)(
    ({ className: className2, ...props }, ref3) => (0, import_react155.createElement)(Icon5, {
      ref: ref3,
      iconNode,
      className: mergeClasses(
        `lucide-${toKebabCase(toPascalCase(iconName))}`,
        `lucide-${iconName}`,
        className2
      ),
      ...props
    })
  );
  Component10.displayName = toPascalCase(iconName);
  return Component10;
};

// ../../node_modules/lucide-react/dist/esm/icons/align-center-horizontal.js
var __iconNode = [
  ["path", { d: "M2 12h20", key: "9i4pu4" }],
  ["path", { d: "M10 16v4a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-4", key: "11f1s0" }],
  ["path", { d: "M10 8V4a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v4", key: "t14dx9" }],
  ["path", { d: "M20 16v1a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-1", key: "1w07xs" }],
  ["path", { d: "M14 8V7c0-1.1.9-2 2-2h2a2 2 0 0 1 2 2v1", key: "1apec2" }]
];
var AlignCenterHorizontal = createLucideIcon("align-center-horizontal", __iconNode);

// ../../node_modules/lucide-react/dist/esm/icons/align-center-vertical.js
var __iconNode2 = [
  ["path", { d: "M12 2v20", key: "t6zp3m" }],
  ["path", { d: "M8 10H4a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h4", key: "14d6g8" }],
  ["path", { d: "M16 10h4a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-4", key: "1e2lrw" }],
  ["path", { d: "M8 20H7a2 2 0 0 1-2-2v-2c0-1.1.9-2 2-2h1", key: "1fkdwx" }],
  ["path", { d: "M16 14h1a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-1", key: "1euafb" }]
];
var AlignCenterVertical = createLucideIcon("align-center-vertical", __iconNode2);

// ../../node_modules/lucide-react/dist/esm/icons/align-end-horizontal.js
var __iconNode3 = [
  ["rect", { width: "6", height: "16", x: "4", y: "2", rx: "2", key: "z5wdxg" }],
  ["rect", { width: "6", height: "9", x: "14", y: "9", rx: "2", key: "um7a8w" }],
  ["path", { d: "M22 22H2", key: "19qnx5" }]
];
var AlignEndHorizontal = createLucideIcon("align-end-horizontal", __iconNode3);

// ../../node_modules/lucide-react/dist/esm/icons/align-end-vertical.js
var __iconNode4 = [
  ["rect", { width: "16", height: "6", x: "2", y: "4", rx: "2", key: "10wcwx" }],
  ["rect", { width: "9", height: "6", x: "9", y: "14", rx: "2", key: "4p5bwg" }],
  ["path", { d: "M22 22V2", key: "12ipfv" }]
];
var AlignEndVertical = createLucideIcon("align-end-vertical", __iconNode4);

// ../../node_modules/lucide-react/dist/esm/icons/align-horizontal-space-around.js
var __iconNode5 = [
  ["rect", { width: "6", height: "10", x: "9", y: "7", rx: "2", key: "yn7j0q" }],
  ["path", { d: "M4 22V2", key: "tsjzd3" }],
  ["path", { d: "M20 22V2", key: "1bnhr8" }]
];
var AlignHorizontalSpaceAround = createLucideIcon("align-horizontal-space-around", __iconNode5);

// ../../node_modules/lucide-react/dist/esm/icons/align-start-horizontal.js
var __iconNode6 = [
  ["rect", { width: "6", height: "16", x: "4", y: "6", rx: "2", key: "1n4dg1" }],
  ["rect", { width: "6", height: "9", x: "14", y: "6", rx: "2", key: "17khns" }],
  ["path", { d: "M22 2H2", key: "fhrpnj" }]
];
var AlignStartHorizontal = createLucideIcon("align-start-horizontal", __iconNode6);

// ../../node_modules/lucide-react/dist/esm/icons/align-start-vertical.js
var __iconNode7 = [
  ["rect", { width: "9", height: "6", x: "6", y: "14", rx: "2", key: "lpm2y7" }],
  ["rect", { width: "16", height: "6", x: "6", y: "4", rx: "2", key: "rdj6ps" }],
  ["path", { d: "M2 2v20", key: "1ivd8o" }]
];
var AlignStartVertical = createLucideIcon("align-start-vertical", __iconNode7);

// ../../node_modules/lucide-react/dist/esm/icons/align-vertical-space-around.js
var __iconNode8 = [
  ["rect", { width: "10", height: "6", x: "7", y: "9", rx: "2", key: "b1zbii" }],
  ["path", { d: "M22 20H2", key: "1p1f7z" }],
  ["path", { d: "M22 4H2", key: "1b7qnq" }]
];
var AlignVerticalSpaceAround = createLucideIcon("align-vertical-space-around", __iconNode8);

// ../../node_modules/lucide-react/dist/esm/icons/arrow-left.js
var __iconNode9 = [
  ["path", { d: "m12 19-7-7 7-7", key: "1l729n" }],
  ["path", { d: "M19 12H5", key: "x3x0zl" }]
];
var ArrowLeft = createLucideIcon("arrow-left", __iconNode9);

// ../../node_modules/lucide-react/dist/esm/icons/arrow-right.js
var __iconNode10 = [
  ["path", { d: "M5 12h14", key: "1ays0h" }],
  ["path", { d: "m12 5 7 7-7 7", key: "xquz4c" }]
];
var ArrowRight = createLucideIcon("arrow-right", __iconNode10);

// ../../node_modules/lucide-react/dist/esm/icons/chevron-left.js
var __iconNode11 = [["path", { d: "m15 18-6-6 6-6", key: "1wnfg3" }]];
var ChevronLeft = createLucideIcon("chevron-left", __iconNode11);

// ../../node_modules/lucide-react/dist/esm/icons/chevron-right.js
var __iconNode12 = [["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]];
var ChevronRight = createLucideIcon("chevron-right", __iconNode12);

// ../../node_modules/lucide-react/dist/esm/icons/chevrons-left.js
var __iconNode13 = [
  ["path", { d: "m11 17-5-5 5-5", key: "13zhaf" }],
  ["path", { d: "m18 17-5-5 5-5", key: "h8a8et" }]
];
var ChevronsLeft = createLucideIcon("chevrons-left", __iconNode13);

// ../../node_modules/lucide-react/dist/esm/icons/chevrons-right.js
var __iconNode14 = [
  ["path", { d: "m6 17 5-5-5-5", key: "xnjwq" }],
  ["path", { d: "m13 17 5-5-5-5", key: "17xmmf" }]
];
var ChevronsRight = createLucideIcon("chevrons-right", __iconNode14);

// ../../node_modules/lucide-react/dist/esm/icons/circle-alert.js
var __iconNode15 = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "12", key: "1pkeuh" }],
  ["line", { x1: "12", x2: "12.01", y1: "16", y2: "16", key: "4dfq90" }]
];
var CircleAlert = createLucideIcon("circle-alert", __iconNode15);

// ../../node_modules/lucide-react/dist/esm/icons/ellipsis.js
var __iconNode16 = [
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  ["circle", { cx: "19", cy: "12", r: "1", key: "1wjl8i" }],
  ["circle", { cx: "5", cy: "12", r: "1", key: "1pcz8c" }]
];
var Ellipsis = createLucideIcon("ellipsis", __iconNode16);

// ../../node_modules/lucide-react/dist/esm/icons/grip-vertical.js
var __iconNode17 = [
  ["circle", { cx: "9", cy: "12", r: "1", key: "1vctgf" }],
  ["circle", { cx: "9", cy: "5", r: "1", key: "hp0tcf" }],
  ["circle", { cx: "9", cy: "19", r: "1", key: "fkjjf6" }],
  ["circle", { cx: "15", cy: "12", r: "1", key: "1tmaij" }],
  ["circle", { cx: "15", cy: "5", r: "1", key: "19l28e" }],
  ["circle", { cx: "15", cy: "19", r: "1", key: "f4zoj3" }]
];
var GripVertical = createLucideIcon("grip-vertical", __iconNode17);

// ../../node_modules/lucide-react/dist/esm/icons/loader-circle.js
var __iconNode18 = [["path", { d: "M21 12a9 9 0 1 1-6.219-8.56", key: "13zald" }]];
var LoaderCircle = createLucideIcon("loader-circle", __iconNode18);

// ../../node_modules/lucide-react/dist/esm/icons/lock.js
var __iconNode19 = [
  ["rect", { width: "18", height: "11", x: "3", y: "11", rx: "2", ry: "2", key: "1w4ew1" }],
  ["path", { d: "M7 11V7a5 5 0 0 1 10 0v4", key: "fwvmzm" }]
];
var Lock = createLucideIcon("lock", __iconNode19);

// ../../node_modules/lucide-react/dist/esm/icons/menu.js
var __iconNode20 = [
  ["path", { d: "M4 12h16", key: "1lakjw" }],
  ["path", { d: "M4 18h16", key: "19g7jn" }],
  ["path", { d: "M4 6h16", key: "1o0s65" }]
];
var Menu3 = createLucideIcon("menu", __iconNode20);

// ../../node_modules/lucide-react/dist/esm/icons/minus.js
var __iconNode21 = [["path", { d: "M5 12h14", key: "1ays0h" }]];
var Minus = createLucideIcon("minus", __iconNode21);

// ../../node_modules/lucide-react/dist/esm/icons/plus.js
var __iconNode22 = [
  ["path", { d: "M5 12h14", key: "1ays0h" }],
  ["path", { d: "M12 5v14", key: "s699le" }]
];
var Plus = createLucideIcon("plus", __iconNode22);

// ../../node_modules/lucide-react/dist/esm/icons/x.js
var __iconNode23 = [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
];
var X = createLucideIcon("x", __iconNode23);

// src/components/Designer/RightSidebar/ListView/index.tsx
var import_react162 = __toESM(require_react());

// src/components/Designer/RightSidebar/ListView/SelectableSortableContainer.tsx
var import_react161 = __toESM(require_react());
var import_react_dom13 = __toESM(require_react_dom());

// ../../node_modules/@dnd-kit/sortable/dist/sortable.esm.js
var import_react156 = __toESM(require_react());
function arrayMove(array4, from2, to) {
  const newArray = array4.slice();
  newArray.splice(to < 0 ? newArray.length + to : to, 0, newArray.splice(from2, 1)[0]);
  return newArray;
}
function getSortedRects(items, rects) {
  return items.reduce((accumulator, id, index3) => {
    const rect = rects.get(id);
    if (rect) {
      accumulator[index3] = rect;
    }
    return accumulator;
  }, Array(items.length));
}
function isValidIndex(index3) {
  return index3 !== null && index3 >= 0;
}
function itemsEqual(a, b) {
  if (a === b) {
    return true;
  }
  if (a.length !== b.length) {
    return false;
  }
  for (let i = 0; i < a.length; i++) {
    if (a[i] !== b[i]) {
      return false;
    }
  }
  return true;
}
function normalizeDisabled(disabled) {
  if (typeof disabled === "boolean") {
    return {
      draggable: disabled,
      droppable: disabled
    };
  }
  return disabled;
}
var rectSortingStrategy = (_ref) => {
  let {
    rects,
    activeIndex,
    overIndex,
    index: index3
  } = _ref;
  const newRects = arrayMove(rects, overIndex, activeIndex);
  const oldRect = rects[index3];
  const newRect = newRects[index3];
  if (!newRect || !oldRect) {
    return null;
  }
  return {
    x: newRect.left - oldRect.left,
    y: newRect.top - oldRect.top,
    scaleX: newRect.width / oldRect.width,
    scaleY: newRect.height / oldRect.height
  };
};
var defaultScale$1 = {
  scaleX: 1,
  scaleY: 1
};
var verticalListSortingStrategy = (_ref) => {
  var _rects$activeIndex;
  let {
    activeIndex,
    activeNodeRect: fallbackActiveRect,
    index: index3,
    rects,
    overIndex
  } = _ref;
  const activeNodeRect = (_rects$activeIndex = rects[activeIndex]) != null ? _rects$activeIndex : fallbackActiveRect;
  if (!activeNodeRect) {
    return null;
  }
  if (index3 === activeIndex) {
    const overIndexRect = rects[overIndex];
    if (!overIndexRect) {
      return null;
    }
    return {
      x: 0,
      y: activeIndex < overIndex ? overIndexRect.top + overIndexRect.height - (activeNodeRect.top + activeNodeRect.height) : overIndexRect.top - activeNodeRect.top,
      ...defaultScale$1
    };
  }
  const itemGap = getItemGap$1(rects, index3, activeIndex);
  if (index3 > activeIndex && index3 <= overIndex) {
    return {
      x: 0,
      y: -activeNodeRect.height - itemGap,
      ...defaultScale$1
    };
  }
  if (index3 < activeIndex && index3 >= overIndex) {
    return {
      x: 0,
      y: activeNodeRect.height + itemGap,
      ...defaultScale$1
    };
  }
  return {
    x: 0,
    y: 0,
    ...defaultScale$1
  };
};
function getItemGap$1(clientRects, index3, activeIndex) {
  const currentRect = clientRects[index3];
  const previousRect = clientRects[index3 - 1];
  const nextRect = clientRects[index3 + 1];
  if (!currentRect) {
    return 0;
  }
  if (activeIndex < index3) {
    return previousRect ? currentRect.top - (previousRect.top + previousRect.height) : nextRect ? nextRect.top - (currentRect.top + currentRect.height) : 0;
  }
  return nextRect ? nextRect.top - (currentRect.top + currentRect.height) : previousRect ? currentRect.top - (previousRect.top + previousRect.height) : 0;
}
var ID_PREFIX2 = "Sortable";
var Context3 = /* @__PURE__ */ import_react156.default.createContext({
  activeIndex: -1,
  containerId: ID_PREFIX2,
  disableTransforms: false,
  items: [],
  overIndex: -1,
  useDragOverlay: false,
  sortedRects: [],
  strategy: rectSortingStrategy,
  disabled: {
    draggable: false,
    droppable: false
  }
});
function SortableContext(_ref) {
  let {
    children,
    id,
    items: userDefinedItems,
    strategy = rectSortingStrategy,
    disabled: disabledProp = false
  } = _ref;
  const {
    active,
    dragOverlay,
    droppableRects,
    over,
    measureDroppableContainers
  } = useDndContext();
  const containerId = useUniqueId(ID_PREFIX2, id);
  const useDragOverlay = Boolean(dragOverlay.rect !== null);
  const items = (0, import_react156.useMemo)(() => userDefinedItems.map((item) => typeof item === "object" && "id" in item ? item.id : item), [userDefinedItems]);
  const isDragging = active != null;
  const activeIndex = active ? items.indexOf(active.id) : -1;
  const overIndex = over ? items.indexOf(over.id) : -1;
  const previousItemsRef = (0, import_react156.useRef)(items);
  const itemsHaveChanged = !itemsEqual(items, previousItemsRef.current);
  const disableTransforms = overIndex !== -1 && activeIndex === -1 || itemsHaveChanged;
  const disabled = normalizeDisabled(disabledProp);
  useIsomorphicLayoutEffect(() => {
    if (itemsHaveChanged && isDragging) {
      measureDroppableContainers(items);
    }
  }, [itemsHaveChanged, items, isDragging, measureDroppableContainers]);
  (0, import_react156.useEffect)(() => {
    previousItemsRef.current = items;
  }, [items]);
  const contextValue = (0, import_react156.useMemo)(
    () => ({
      activeIndex,
      containerId,
      disabled,
      disableTransforms,
      items,
      overIndex,
      useDragOverlay,
      sortedRects: getSortedRects(items, droppableRects),
      strategy
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [activeIndex, containerId, disabled.draggable, disabled.droppable, disableTransforms, items, overIndex, droppableRects, useDragOverlay, strategy]
  );
  return import_react156.default.createElement(Context3.Provider, {
    value: contextValue
  }, children);
}
var defaultNewIndexGetter = (_ref) => {
  let {
    id,
    items,
    activeIndex,
    overIndex
  } = _ref;
  return arrayMove(items, activeIndex, overIndex).indexOf(id);
};
var defaultAnimateLayoutChanges = (_ref2) => {
  let {
    containerId,
    isSorting,
    wasDragging,
    index: index3,
    items,
    newIndex,
    previousItems,
    previousContainerId,
    transition
  } = _ref2;
  if (!transition || !wasDragging) {
    return false;
  }
  if (previousItems !== items && index3 === newIndex) {
    return false;
  }
  if (isSorting) {
    return true;
  }
  return newIndex !== index3 && containerId === previousContainerId;
};
var defaultTransition2 = {
  duration: 200,
  easing: "ease"
};
var transitionProperty = "transform";
var disabledTransition = /* @__PURE__ */ CSS2.Transition.toString({
  property: transitionProperty,
  duration: 0,
  easing: "linear"
});
var defaultAttributes2 = {
  roleDescription: "sortable"
};
function useDerivedTransform(_ref) {
  let {
    disabled,
    index: index3,
    node: node2,
    rect
  } = _ref;
  const [derivedTransform, setDerivedtransform] = (0, import_react156.useState)(null);
  const previousIndex = (0, import_react156.useRef)(index3);
  useIsomorphicLayoutEffect(() => {
    if (!disabled && index3 !== previousIndex.current && node2.current) {
      const initial = rect.current;
      if (initial) {
        const current2 = getClientRect(node2.current, {
          ignoreTransform: true
        });
        const delta = {
          x: initial.left - current2.left,
          y: initial.top - current2.top,
          scaleX: initial.width / current2.width,
          scaleY: initial.height / current2.height
        };
        if (delta.x || delta.y) {
          setDerivedtransform(delta);
        }
      }
    }
    if (index3 !== previousIndex.current) {
      previousIndex.current = index3;
    }
  }, [disabled, index3, node2, rect]);
  (0, import_react156.useEffect)(() => {
    if (derivedTransform) {
      setDerivedtransform(null);
    }
  }, [derivedTransform]);
  return derivedTransform;
}
function useSortable(_ref) {
  let {
    animateLayoutChanges = defaultAnimateLayoutChanges,
    attributes: userDefinedAttributes,
    disabled: localDisabled,
    data: customData,
    getNewIndex = defaultNewIndexGetter,
    id,
    strategy: localStrategy,
    resizeObserverConfig,
    transition = defaultTransition2
  } = _ref;
  const {
    items,
    containerId,
    activeIndex,
    disabled: globalDisabled,
    disableTransforms,
    sortedRects,
    overIndex,
    useDragOverlay,
    strategy: globalStrategy
  } = (0, import_react156.useContext)(Context3);
  const disabled = normalizeLocalDisabled(localDisabled, globalDisabled);
  const index3 = items.indexOf(id);
  const data2 = (0, import_react156.useMemo)(() => ({
    sortable: {
      containerId,
      index: index3,
      items
    },
    ...customData
  }), [containerId, customData, index3, items]);
  const itemsAfterCurrentSortable = (0, import_react156.useMemo)(() => items.slice(items.indexOf(id)), [items, id]);
  const {
    rect,
    node: node2,
    isOver,
    setNodeRef: setDroppableNodeRef
  } = useDroppable({
    id,
    data: data2,
    disabled: disabled.droppable,
    resizeObserverConfig: {
      updateMeasurementsFor: itemsAfterCurrentSortable,
      ...resizeObserverConfig
    }
  });
  const {
    active,
    activatorEvent,
    activeNodeRect,
    attributes: attributes2,
    setNodeRef: setDraggableNodeRef,
    listeners,
    isDragging,
    over,
    setActivatorNodeRef,
    transform
  } = useDraggable({
    id,
    data: data2,
    attributes: {
      ...defaultAttributes2,
      ...userDefinedAttributes
    },
    disabled: disabled.draggable
  });
  const setNodeRef = useCombinedRefs(setDroppableNodeRef, setDraggableNodeRef);
  const isSorting = Boolean(active);
  const displaceItem = isSorting && !disableTransforms && isValidIndex(activeIndex) && isValidIndex(overIndex);
  const shouldDisplaceDragSource = !useDragOverlay && isDragging;
  const dragSourceDisplacement = shouldDisplaceDragSource && displaceItem ? transform : null;
  const strategy = localStrategy != null ? localStrategy : globalStrategy;
  const finalTransform = displaceItem ? dragSourceDisplacement != null ? dragSourceDisplacement : strategy({
    rects: sortedRects,
    activeNodeRect,
    activeIndex,
    overIndex,
    index: index3
  }) : null;
  const newIndex = isValidIndex(activeIndex) && isValidIndex(overIndex) ? getNewIndex({
    id,
    items,
    activeIndex,
    overIndex
  }) : index3;
  const activeId = active == null ? void 0 : active.id;
  const previous = (0, import_react156.useRef)({
    activeId,
    items,
    newIndex,
    containerId
  });
  const itemsHaveChanged = items !== previous.current.items;
  const shouldAnimateLayoutChanges = animateLayoutChanges({
    active,
    containerId,
    isDragging,
    isSorting,
    id,
    index: index3,
    items,
    newIndex: previous.current.newIndex,
    previousItems: previous.current.items,
    previousContainerId: previous.current.containerId,
    transition,
    wasDragging: previous.current.activeId != null
  });
  const derivedTransform = useDerivedTransform({
    disabled: !shouldAnimateLayoutChanges,
    index: index3,
    node: node2,
    rect
  });
  (0, import_react156.useEffect)(() => {
    if (isSorting && previous.current.newIndex !== newIndex) {
      previous.current.newIndex = newIndex;
    }
    if (containerId !== previous.current.containerId) {
      previous.current.containerId = containerId;
    }
    if (items !== previous.current.items) {
      previous.current.items = items;
    }
  }, [isSorting, newIndex, containerId, items]);
  (0, import_react156.useEffect)(() => {
    if (activeId === previous.current.activeId) {
      return;
    }
    if (activeId != null && previous.current.activeId == null) {
      previous.current.activeId = activeId;
      return;
    }
    const timeoutId = setTimeout(() => {
      previous.current.activeId = activeId;
    }, 50);
    return () => clearTimeout(timeoutId);
  }, [activeId]);
  return {
    active,
    activeIndex,
    attributes: attributes2,
    data: data2,
    rect,
    index: index3,
    newIndex,
    items,
    isOver,
    isSorting,
    isDragging,
    listeners,
    node: node2,
    overIndex,
    over,
    setNodeRef,
    setActivatorNodeRef,
    setDroppableNodeRef,
    setDraggableNodeRef,
    transform: derivedTransform != null ? derivedTransform : finalTransform,
    transition: getTransition()
  };
  function getTransition() {
    if (
      // Temporarily disable transitions for a single frame to set up derived transforms
      derivedTransform || // Or to prevent items jumping to back to their "new" position when items change
      itemsHaveChanged && previous.current.newIndex === index3
    ) {
      return disabledTransition;
    }
    if (shouldDisplaceDragSource && !isKeyboardEvent(activatorEvent) || !transition) {
      return void 0;
    }
    if (isSorting || shouldAnimateLayoutChanges) {
      return CSS2.Transition.toString({
        ...transition,
        property: transitionProperty
      });
    }
    return void 0;
  }
}
function normalizeLocalDisabled(localDisabled, globalDisabled) {
  var _localDisabled$dragga, _localDisabled$droppa;
  if (typeof localDisabled === "boolean") {
    return {
      draggable: localDisabled,
      // Backwards compatibility
      droppable: false
    };
  }
  return {
    draggable: (_localDisabled$dragga = localDisabled == null ? void 0 : localDisabled.draggable) != null ? _localDisabled$dragga : globalDisabled.draggable,
    droppable: (_localDisabled$droppa = localDisabled == null ? void 0 : localDisabled.droppable) != null ? _localDisabled$droppa : globalDisabled.droppable
  };
}
function hasSortableData(entry) {
  if (!entry) {
    return false;
  }
  const data2 = entry.data.current;
  if (data2 && "sortable" in data2 && typeof data2.sortable === "object" && "containerId" in data2.sortable && "items" in data2.sortable && "index" in data2.sortable) {
    return true;
  }
  return false;
}
var directions = [KeyboardCode.Down, KeyboardCode.Right, KeyboardCode.Up, KeyboardCode.Left];
var sortableKeyboardCoordinates = (event, _ref) => {
  let {
    context: {
      active,
      collisionRect,
      droppableRects,
      droppableContainers,
      over,
      scrollableAncestors
    }
  } = _ref;
  if (directions.includes(event.code)) {
    event.preventDefault();
    if (!active || !collisionRect) {
      return;
    }
    const filteredContainers = [];
    droppableContainers.getEnabled().forEach((entry) => {
      if (!entry || entry != null && entry.disabled) {
        return;
      }
      const rect = droppableRects.get(entry.id);
      if (!rect) {
        return;
      }
      switch (event.code) {
        case KeyboardCode.Down:
          if (collisionRect.top < rect.top) {
            filteredContainers.push(entry);
          }
          break;
        case KeyboardCode.Up:
          if (collisionRect.top > rect.top) {
            filteredContainers.push(entry);
          }
          break;
        case KeyboardCode.Left:
          if (collisionRect.left > rect.left) {
            filteredContainers.push(entry);
          }
          break;
        case KeyboardCode.Right:
          if (collisionRect.left < rect.left) {
            filteredContainers.push(entry);
          }
          break;
      }
    });
    const collisions = closestCorners({
      active,
      collisionRect,
      droppableRects,
      droppableContainers: filteredContainers,
      pointerCoordinates: null
    });
    let closestId = getFirstCollision(collisions, "id");
    if (closestId === (over == null ? void 0 : over.id) && collisions.length > 1) {
      closestId = collisions[1].id;
    }
    if (closestId != null) {
      const activeDroppable = droppableContainers.get(active.id);
      const newDroppable = droppableContainers.get(closestId);
      const newRect = newDroppable ? droppableRects.get(newDroppable.id) : null;
      const newNode = newDroppable == null ? void 0 : newDroppable.node.current;
      if (newNode && newRect && activeDroppable && newDroppable) {
        const newScrollAncestors = getScrollableAncestors(newNode);
        const hasDifferentScrollAncestors = newScrollAncestors.some((element, index3) => scrollableAncestors[index3] !== element);
        const hasSameContainer = isSameContainer(activeDroppable, newDroppable);
        const isAfterActive = isAfter2(activeDroppable, newDroppable);
        const offset4 = hasDifferentScrollAncestors || !hasSameContainer ? {
          x: 0,
          y: 0
        } : {
          x: isAfterActive ? collisionRect.width - newRect.width : 0,
          y: isAfterActive ? collisionRect.height - newRect.height : 0
        };
        const rectCoordinates = {
          x: newRect.left,
          y: newRect.top
        };
        const newCoordinates = offset4.x && offset4.y ? rectCoordinates : subtract(rectCoordinates, offset4);
        return newCoordinates;
      }
    }
  }
  return void 0;
};
function isSameContainer(a, b) {
  if (!hasSortableData(a) || !hasSortableData(b)) {
    return false;
  }
  return a.data.current.sortable.containerId === b.data.current.sortable.containerId;
}
function isAfter2(a, b) {
  if (!hasSortableData(a) || !hasSortableData(b)) {
    return false;
  }
  if (!isSameContainer(a, b)) {
    return false;
  }
  return a.data.current.sortable.index < b.data.current.sortable.index;
}

// src/components/Designer/RightSidebar/ListView/Item.tsx
var import_react157 = __toESM(require_react());
var { Text: Text2 } = typography_default;
var Item5 = import_react157.default.memo(
  /* eslint-disable react/prop-types */
  import_react157.default.forwardRef(function Item6({
    icon,
    value,
    status,
    title,
    required: required5,
    readOnly,
    style: style2,
    dragOverlay,
    onClick,
    onMouseEnter,
    onMouseLeave,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    dragging,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    fadeIn: fadeIn2,
    listeners,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    sorting,
    transition,
    transform,
    ...props
  }, ref3) {
    const i18n2 = (0, import_react157.useContext)(I18nContext);
    (0, import_react157.useEffect)(() => {
      if (!dragOverlay) {
        return;
      }
      document.body.style.cursor = "grabbing";
      return () => {
        document.body.style.cursor = "";
      };
    }, [dragOverlay]);
    const { x, y, scaleX, scaleY } = transform || { x: 0, y: 0, scaleX: 1, scaleY: 1 };
    return /* @__PURE__ */ import_react157.default.createElement(
      "li",
      {
        style: {
          marginTop: 10,
          transition,
          transform: `translate(${x}px, ${y}px) scale(${scaleX}, ${scaleY})`
        },
        onMouseEnter,
        onMouseLeave,
        ref: ref3
      },
      /* @__PURE__ */ import_react157.default.createElement(
        "div",
        {
          style: {
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
            gap: "0.5rem",
            ...style2
          },
          ...props,
          onClick: () => onClick && onClick()
        },
        /* @__PURE__ */ import_react157.default.createElement(
          button_default2,
          {
            ...listeners,
            style: {
              display: "flex",
              alignItems: "center",
              background: "none",
              boxShadow: "none",
              border: "none",
              paddingLeft: "0.25rem"
            },
            icon: /* @__PURE__ */ import_react157.default.createElement(GripVertical, { size: 15, style: { cursor: "grab" } })
          }
        ),
        icon,
        /* @__PURE__ */ import_react157.default.createElement(
          Text2,
          {
            style: {
              overflow: "hidden",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              width: "100%"
            },
            title: title || ""
          },
          status === void 0 ? value : /* @__PURE__ */ import_react157.default.createElement("span", { style: { display: "flex", alignItems: "center" } }, /* @__PURE__ */ import_react157.default.createElement(CircleAlert, { size: 15, style: { marginRight: "0.25rem" } }), status === "is-warning" ? i18n2("noKeyName") : value, status === "is-danger" ? i18n2("notUniq") : "")
        ),
        !readOnly && /* @__PURE__ */ import_react157.default.createElement(Lock, { size: 15, style: { marginRight: "0.5rem" } }),
        required5 && /* @__PURE__ */ import_react157.default.createElement("span", { style: { color: "red", marginRight: "0.5rem" } }, "*")
      )
    );
  })
);
Item5.displayName = "Item";
var Item_default4 = Item5;

// src/components/Designer/RightSidebar/ListView/SelectableSortableItem.tsx
var import_react160 = __toESM(require_react());

// src/hooks.ts
var import_react158 = __toESM(require_react());
var usePrevious3 = (value) => {
  const ref3 = (0, import_react158.useRef)(null);
  (0, import_react158.useEffect)(() => {
    ref3.current = value;
  });
  return ref3.current;
};
var getScale = (n2, paper) => Math.floor((n2 / paper > 1 ? 1 : n2 / paper) * 100) / 100;
var useUIPreProcessor = ({ template, size, zoomLevel, maxZoom }) => {
  const [backgrounds, setBackgrounds] = (0, import_react158.useState)([]);
  const [pageSizes, setPageSizes] = (0, import_react158.useState)([]);
  const [scale, setScale] = (0, import_react158.useState)(0);
  const [error2, setError] = (0, import_react158.useState)(null);
  const init2 = async (prop) => {
    const {
      template: { basePdf, schemas },
      size: size2
    } = prop;
    let paperWidth;
    let paperHeight;
    let _backgrounds;
    let _pageSizes;
    if (isBlankPdf(basePdf)) {
      const { width, height } = basePdf;
      paperWidth = width * ZOOM;
      paperHeight = height * ZOOM;
      _backgrounds = schemas.map(
        () => "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAA1JREFUGFdj+P///38ACfsD/QVDRcoAAAAASUVORK5CYII="
      );
      _pageSizes = schemas.map(() => ({ width, height }));
    } else {
      const _basePdf = await getB64BasePdf(basePdf);
      const uint8Array = b64toUint8Array(_basePdf);
      const pdfArrayBuffer = new ArrayBuffer(uint8Array.byteLength);
      new Uint8Array(pdfArrayBuffer).set(uint8Array);
      const [_pages, imgBuffers] = await Promise.all([
        pdf2size2(pdfArrayBuffer),
        pdf2img2(pdfArrayBuffer.slice(), { scale: maxZoom })
      ]);
      _pageSizes = _pages;
      paperWidth = _pageSizes[0].width * ZOOM;
      paperHeight = _pageSizes[0].height * ZOOM;
      _backgrounds = imgBuffers.map(arrayBufferToBase64);
    }
    const _scale = Math.min(
      getScale(size2.width, paperWidth),
      getScale(size2.height - RULER_HEIGHT, paperHeight)
    );
    return {
      backgrounds: _backgrounds,
      pageSizes: _pageSizes,
      scale: _scale
    };
  };
  (0, import_react158.useEffect)(() => {
    init2({ template, size }).then(({ pageSizes: pageSizes2, scale: scale2, backgrounds: backgrounds2 }) => {
      setPageSizes(pageSizes2);
      setScale(scale2);
      setBackgrounds(backgrounds2);
    }).catch((err) => {
      setError(err);
      console.error("[@pdfme/ui]", err);
    });
  }, [template, size]);
  return {
    backgrounds,
    pageSizes,
    scale: scale * zoomLevel,
    error: error2,
    refresh: (template2) => init2({ template: template2, size }).then(({ pageSizes: pageSizes2, scale: scale2, backgrounds: backgrounds2 }) => {
      setPageSizes(pageSizes2);
      setScale(scale2);
      setBackgrounds(backgrounds2);
    })
  };
};
var useScrollPageCursor = ({
  ref: ref3,
  pageSizes,
  scale,
  pageCursor,
  onChangePageCursor
}) => {
  const onScroll = (0, import_react158.useCallback)(() => {
    if (!pageSizes[0] || !ref3.current) {
      return;
    }
    const scroll = ref3.current.scrollTop;
    const { top } = ref3.current.getBoundingClientRect();
    const pageHeights = pageSizes.reduce((acc, cur, i) => {
      let value = (cur.height * ZOOM + RULER_HEIGHT) * scale;
      if (i === 0) {
        value += top - value / 2;
      } else {
        value += acc[i - 1];
      }
      return acc.concat(value);
    }, []);
    let _pageCursor = 0;
    pageHeights.forEach((ph, i) => {
      if (scroll > ph) {
        _pageCursor = i + 1 >= pageHeights.length ? pageHeights.length - 1 : i + 1;
      }
    });
    if (_pageCursor !== pageCursor) {
      onChangePageCursor(_pageCursor);
    }
  }, [onChangePageCursor, pageCursor, pageSizes, ref3, scale]);
  (0, import_react158.useEffect)(() => {
    ref3.current?.addEventListener("scroll", onScroll);
    return () => {
      ref3.current?.removeEventListener("scroll", onScroll);
    };
  }, [ref3, onScroll]);
};
var useMountStatus = () => {
  const [isMounted, setIsMounted] = (0, import_react158.useState)(false);
  (0, import_react158.useEffect)(() => {
    const timeout = setTimeout(() => setIsMounted(true), 500);
    return () => clearTimeout(timeout);
  }, []);
  return isMounted;
};
var useInitEvents = ({
  pageCursor,
  pageSizes,
  activeElements,
  template,
  schemasList,
  changeSchemas: changeSchemas2,
  commitSchemas,
  removeSchemas,
  onSaveTemplate,
  past,
  future,
  setSchemasList,
  onEdit,
  onEditEnd
}) => {
  const copiedSchemas = (0, import_react158.useRef)(null);
  const initEvents = (0, import_react158.useCallback)(() => {
    const getActiveSchemas = () => {
      const ids2 = activeElements.map((ae) => ae.id);
      return schemasList[pageCursor].filter((s) => ids2.includes(s.id));
    };
    const timeTravel = (mode) => {
      const isUndo = mode === "undo";
      const stack = isUndo ? past : future;
      if (stack.current.length <= 0) return;
      (isUndo ? future : past).current.push(cloneDeep(schemasList[pageCursor]));
      const s = cloneDeep(schemasList);
      s[pageCursor] = stack.current.pop();
      setSchemasList(s);
    };
    initShortCuts({
      move: (command, isShift) => {
        const pageSize = pageSizes[pageCursor];
        const activeSchemas = getActiveSchemas();
        const arg = moveCommandToChangeSchemasArg({ command, activeSchemas, pageSize, isShift });
        changeSchemas2(arg);
      },
      copy: () => {
        const activeSchemas = getActiveSchemas();
        if (activeSchemas.length === 0) return;
        copiedSchemas.current = activeSchemas;
      },
      paste: () => {
        if (!copiedSchemas.current || copiedSchemas.current.length === 0) return;
        const schema = schemasList[pageCursor];
        const stackUniqueSchemaNames = [];
        const pasteSchemas = copiedSchemas.current.map((cs) => {
          const id = uuid();
          const name = getUniqueSchemaName({
            copiedSchemaName: cs.name,
            schema,
            stackUniqueSchemaNames
          });
          const { height, width, position: p } = cs;
          const ps = pageSizes[pageCursor];
          const position3 = {
            x: p.x + 10 > ps.width - width ? ps.width - width : p.x + 10,
            y: p.y + 10 > ps.height - height ? ps.height - height : p.y + 10
          };
          return Object.assign(cloneDeep(cs), { id, name, position: position3 });
        });
        commitSchemas(schemasList[pageCursor].concat(pasteSchemas));
        onEdit(pasteSchemas.map((s) => document.getElementById(s.id)));
        copiedSchemas.current = pasteSchemas;
      },
      redo: () => timeTravel("redo"),
      undo: () => timeTravel("undo"),
      save: () => onSaveTemplate && onSaveTemplate(schemasList2template(schemasList, template.basePdf)),
      remove: () => removeSchemas(getActiveSchemas().map((s) => s.id)),
      esc: onEditEnd,
      selectAll: () => onEdit(schemasList[pageCursor].map((s) => document.getElementById(s.id)))
    });
  }, [
    template,
    activeElements,
    pageCursor,
    pageSizes,
    changeSchemas2,
    commitSchemas,
    schemasList,
    onSaveTemplate,
    removeSchemas,
    past,
    future,
    setSchemasList,
    copiedSchemas,
    onEdit,
    onEditEnd
  ]);
  const destroyEvents = (0, import_react158.useCallback)(() => {
    destroyShortCuts();
  }, []);
  (0, import_react158.useEffect)(() => {
    initEvents();
    return destroyEvents;
  }, [initEvents, destroyEvents]);
};

// src/components/Designer/PluginIcon.tsx
var import_react159 = __toESM(require_react());
var getWithModifiedSize = (htmlString, label, size, styles) => {
  const parser = new DOMParser();
  const doc2 = parser.parseFromString(htmlString, "text/html");
  const modifyNode = (node2) => {
    if (node2.tagName === "SVG" || node2.tagName === "svg") {
      node2.setAttribute("width", size.toString());
      node2.setAttribute("height", size.toString());
    }
    Array.from(node2.children).forEach((child) => modifyNode(child));
  };
  Array.from(doc2.body.children).forEach((child) => modifyNode(child));
  return /* @__PURE__ */ import_react159.default.createElement("div", { style: styles, title: label, dangerouslySetInnerHTML: { __html: doc2.body.innerHTML } });
};
var PluginIcon = (props) => {
  const { plugin, label, size, styles } = props;
  const { token: token2 } = theme_default3.useToken();
  const options = (0, import_react159.useContext)(OptionsContext);
  const defaultSchemaType = plugin.propPanel && typeof plugin.propPanel === "object" && plugin.propPanel.defaultSchema && typeof plugin.propPanel.defaultSchema === "object" && "type" in plugin.propPanel.defaultSchema && typeof plugin.propPanel.defaultSchema.type === "string" ? plugin.propPanel.defaultSchema.type : "";
  const icon = options.icons?.[defaultSchemaType] ?? plugin.icon;
  const iconStyles2 = {
    ...styles,
    color: token2.colorText,
    display: "flex",
    justifyContent: "center"
  };
  if (icon) {
    if (size) {
      return getWithModifiedSize(icon, label, size, iconStyles2);
    }
    return /* @__PURE__ */ import_react159.default.createElement("div", { style: iconStyles2, title: label, dangerouslySetInnerHTML: { __html: icon } });
  }
  return /* @__PURE__ */ import_react159.default.createElement("div", { style: { ...styles, overflow: "hidden", fontSize: 10 }, title: label }, label);
};
var PluginIcon_default = PluginIcon;

// src/components/Designer/RightSidebar/ListView/SelectableSortableItem.tsx
var SelectableSortableItem = ({
  isSelected,
  style: style2,
  onSelect,
  onEdit,
  schema,
  schemas,
  onMouseEnter,
  onMouseLeave
}) => {
  const { token: token2 } = theme_default3.useToken();
  const i18n2 = (0, import_react160.useContext)(I18nContext);
  const pluginsRegistry = (0, import_react160.useContext)(PluginsRegistry);
  const { setNodeRef, listeners, isDragging, isSorting, transform, transition } = useSortable({
    id: schema.id
  });
  const mounted = useMountStatus();
  const mountedWhileDragging = isDragging && !mounted;
  const newListeners = {
    ...listeners,
    onClick: (event) => onSelect(schema.id, event.shiftKey)
  };
  const schemaType = typeof schema.type === "string" ? schema.type : "";
  const pluginEntry = Object.entries(pluginsRegistry).find(([, plugin]) => {
    if (!plugin || typeof plugin !== "object") return false;
    if (!plugin.propPanel || typeof plugin.propPanel !== "object") return false;
    if (!plugin.propPanel.defaultSchema || typeof plugin.propPanel.defaultSchema !== "object")
      return false;
    const defaultSchema = plugin.propPanel.defaultSchema;
    return "type" in defaultSchema && typeof defaultSchema.type === "string" && defaultSchema.type === schemaType;
  });
  const [pluginLabel, thisPlugin] = pluginEntry || ["", void 0];
  let status;
  if (!schema.name) {
    status = "is-warning";
  } else if (schemas.find((s) => schema.name && s.name === schema.name && s.id !== schema.id)) {
    status = "is-danger";
  }
  let title = i18n2("edit");
  if (status === "is-warning") {
    title = i18n2("plsInputName");
  } else if (status === "is-danger") {
    title = i18n2("fieldMustUniq");
  }
  const selectedStyle = isSelected ? { background: token2.colorPrimary, opacity: isSorting || isDragging ? 0.5 : 1 } : {};
  return /* @__PURE__ */ import_react160.default.createElement(
    Item_default4,
    {
      ref: setNodeRef,
      onMouseEnter,
      onMouseLeave,
      onClick: () => onEdit(schema.id),
      icon: thisPlugin && /* @__PURE__ */ import_react160.default.createElement(PluginIcon_default, { plugin: thisPlugin, label: pluginLabel, size: 20 }),
      value: schema.name,
      status,
      title,
      required: schema.required,
      readOnly: schema.readOnly,
      style: { ...selectedStyle, ...style2 },
      dragging: isDragging,
      sorting: isSorting,
      transition,
      transform,
      fadeIn: mountedWhileDragging,
      listeners: newListeners
    }
  );
};
var SelectableSortableItem_default = SelectableSortableItem;

// src/components/Designer/RightSidebar/ListView/SelectableSortableContainer.tsx
var SelectableSortableContainer = (props) => {
  const { token: token2 } = theme_default3.useToken();
  const { schemas, onEdit, onSortEnd, hoveringSchemaId, onChangeHoveringSchemaId } = props;
  const [selectedSchemas, setSelectedSchemas] = (0, import_react161.useState)([]);
  const [dragOverlaidItems, setClonedItems] = (0, import_react161.useState)(null);
  const [activeId, setActiveId] = (0, import_react161.useState)(null);
  const pluginsRegistry = (0, import_react161.useContext)(PluginsRegistry);
  const sensors = useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 15 } }),
    useSensor(KeyboardSensor, { coordinateGetter: sortableKeyboardCoordinates })
  );
  const isItemSelected = (itemId) => selectedSchemas.map((i) => i.id).includes(itemId);
  const onSelectionChanged = (id, isShiftSelect) => {
    if (isShiftSelect) {
      if (isItemSelected(id)) {
        const newSelectedSchemas = selectedSchemas.filter((item) => item.id !== id);
        setSelectedSchemas(newSelectedSchemas);
      } else {
        const newSelectedItem = schemas.find((schema) => schema.id === id);
        const newSelectedSchemas = selectedSchemas.concat(newSelectedItem);
        setSelectedSchemas(newSelectedSchemas);
      }
    } else {
      setSelectedSchemas([]);
    }
  };
  const getPluginIcon = (inSchema) => {
    const thisSchema = typeof inSchema === "string" ? schemas.find((schema) => schema.id === inSchema) : inSchema;
    if (!thisSchema) return /* @__PURE__ */ import_react161.default.createElement(import_react161.default.Fragment, null);
    const schemaType = typeof thisSchema.type === "string" ? thisSchema.type : "";
    const pluginEntry = Object.entries(pluginsRegistry).find(([, plugin]) => {
      if (!plugin || typeof plugin !== "object") return false;
      if (!plugin.propPanel || typeof plugin.propPanel !== "object") return false;
      if (!plugin.propPanel.defaultSchema || typeof plugin.propPanel.defaultSchema !== "object")
        return false;
      const defaultSchema = plugin.propPanel.defaultSchema;
      return "type" in defaultSchema && typeof defaultSchema.type === "string" && defaultSchema.type === schemaType;
    });
    const [pluginLabel, activePlugin] = pluginEntry || ["", void 0];
    if (!activePlugin) {
      return /* @__PURE__ */ import_react161.default.createElement(import_react161.default.Fragment, null);
    }
    return /* @__PURE__ */ import_react161.default.createElement(
      PluginIcon_default,
      {
        plugin: activePlugin,
        label: pluginLabel,
        size: 20,
        styles: { marginRight: "0.5rem" }
      }
    );
  };
  return /* @__PURE__ */ import_react161.default.createElement(
    DndContext,
    {
      sensors,
      collisionDetection: closestCorners,
      onDragStart: ({ active }) => {
        setActiveId(String(active.id));
        setClonedItems(schemas);
        if (!isItemSelected(String(active.id))) {
          const newSelectedSchemas = [];
          setSelectedSchemas(newSelectedSchemas);
        } else if (selectedSchemas.length > 0) {
          onSortEnd(
            selectedSchemas.reduce((ret, selectedItem) => {
              if (selectedItem.id === String(active.id)) {
                return ret;
              }
              return ret.filter((schema) => schema !== selectedItem);
            }, schemas)
          );
        }
      },
      onDragEnd: ({ active, over }) => {
        const overId = over?.id || "";
        const activeIndex = schemas.map((i) => i.id).indexOf(String(active.id));
        const overIndex = schemas.map((i) => i.id).indexOf(String(overId));
        if (selectedSchemas.length) {
          let newSchemas = [...schemas];
          newSchemas = arrayMove(newSchemas, activeIndex, overIndex);
          newSchemas.splice(
            overIndex + 1,
            0,
            ...selectedSchemas.filter((item) => item.id !== activeId)
          );
          onSortEnd(newSchemas);
          setSelectedSchemas([]);
        } else if (activeIndex !== overIndex) {
          onSortEnd(arrayMove(schemas, activeIndex, overIndex));
        }
        setActiveId(null);
      },
      onDragCancel: () => {
        if (dragOverlaidItems) {
          onSortEnd(dragOverlaidItems);
        }
        setActiveId(null);
        setClonedItems(null);
      }
    },
    /* @__PURE__ */ import_react161.default.createElement(import_react161.default.Fragment, null, /* @__PURE__ */ import_react161.default.createElement("div", { style: { height: "100%", overflowY: "auto" } }, /* @__PURE__ */ import_react161.default.createElement(SortableContext, { items: schemas, strategy: verticalListSortingStrategy }, /* @__PURE__ */ import_react161.default.createElement("ul", { style: { margin: 0, padding: 0, listStyle: "none", borderRadius: 5 } }, schemas.map((schema) => /* @__PURE__ */ import_react161.default.createElement(
      SelectableSortableItem_default,
      {
        key: schema.id,
        style: {
          border: `1px solid ${schema.id === hoveringSchemaId ? token2.colorPrimary : "transparent"}`
        },
        schema,
        schemas,
        isSelected: isItemSelected(schema.id) || activeId === schema.id,
        onEdit,
        onSelect: onSelectionChanged,
        onMouseEnter: () => onChangeHoveringSchemaId(schema.id),
        onMouseLeave: () => onChangeHoveringSchemaId(null)
      }
    ))))), (0, import_react_dom13.createPortal)(
      /* @__PURE__ */ import_react161.default.createElement(DragOverlay, { adjustScale: true }, activeId ? (() => {
        const activeSchema = schemas.find((schema) => schema.id === activeId);
        if (!activeSchema) return null;
        return /* @__PURE__ */ import_react161.default.createElement(import_react161.default.Fragment, null, /* @__PURE__ */ import_react161.default.createElement("ul", { style: { margin: 0, padding: 0, listStyle: "none" } }, /* @__PURE__ */ import_react161.default.createElement(
          Item_default4,
          {
            icon: getPluginIcon(activeId),
            value: activeSchema.name,
            required: activeSchema.required,
            readOnly: activeSchema.readOnly,
            style: { background: token2.colorPrimary },
            dragOverlay: true
          }
        )), /* @__PURE__ */ import_react161.default.createElement("ul", { style: { margin: 0, padding: 0, listStyle: "none" } }, selectedSchemas.filter((item) => item.id !== activeId).map((item) => /* @__PURE__ */ import_react161.default.createElement(
          Item_default4,
          {
            icon: getPluginIcon(item),
            key: item.id,
            value: item.name,
            required: item.required,
            readOnly: item.readOnly,
            style: { background: token2.colorPrimary },
            dragOverlay: true
          }
        ))));
      })() : null),
      document.body
    ))
  );
};
var SelectableSortableContainer_default = SelectableSortableContainer;

// src/components/Designer/RightSidebar/ListView/index.tsx
var { Text: Text3 } = typography_default;
var { TextArea: TextArea3 } = input_default;
var headHeight = 40;
var ListView = (props) => {
  const {
    schemas,
    onSortEnd,
    onEdit,
    size,
    hoveringSchemaId,
    onChangeHoveringSchemaId,
    changeSchemas: changeSchemas2
  } = props;
  const { token: token2 } = theme_default3.useToken();
  const i18n2 = (0, import_react162.useContext)(I18nContext);
  const [isBulkUpdateFieldNamesMode, setIsBulkUpdateFieldNamesMode] = (0, import_react162.useState)(false);
  const [fieldNamesValue, setFieldNamesValue] = (0, import_react162.useState)("");
  const height = getSidebarContentHeight(size.height);
  const commitBulk = () => {
    const names2 = fieldNamesValue.split("\n");
    if (names2.length !== schemas.length) {
      alert(i18n2("errorBulkUpdateFieldName"));
    } else {
      changeSchemas2(
        names2.map((value, index3) => ({
          key: "name",
          value,
          schemaId: schemas[index3].id
        }))
      );
      setIsBulkUpdateFieldNamesMode(false);
    }
  };
  const startBulk = () => {
    setFieldNamesValue(schemas.map((s) => s.name).join("\n"));
    setIsBulkUpdateFieldNamesMode(true);
  };
  return /* @__PURE__ */ import_react162.default.createElement("div", null, /* @__PURE__ */ import_react162.default.createElement("div", { style: { height: headHeight, display: "flex", alignItems: "center" } }, /* @__PURE__ */ import_react162.default.createElement(Text3, { strong: true, style: { textAlign: "center", width: "100%" } }, i18n2("fieldsList"))), /* @__PURE__ */ import_react162.default.createElement(divider_default, { style: { marginTop: token2.marginXS, marginBottom: token2.marginXS } }), /* @__PURE__ */ import_react162.default.createElement("div", { style: { height: height - headHeight } }, isBulkUpdateFieldNamesMode ? /* @__PURE__ */ import_react162.default.createElement(
    TextArea3,
    {
      wrap: "off",
      value: fieldNamesValue,
      onChange: (e3) => setFieldNamesValue(e3.target.value),
      style: {
        paddingLeft: 30,
        height: height - headHeight,
        width: RIGHT_SIDEBAR_WIDTH - 35,
        lineHeight: "2.75rem"
      }
    }
  ) : /* @__PURE__ */ import_react162.default.createElement(
    SelectableSortableContainer_default,
    {
      schemas,
      hoveringSchemaId,
      onChangeHoveringSchemaId,
      onSortEnd,
      onEdit
    }
  ), /* @__PURE__ */ import_react162.default.createElement(
    "div",
    {
      style: {
        paddingTop: "0.5rem",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end"
      }
    },
    isBulkUpdateFieldNamesMode ? /* @__PURE__ */ import_react162.default.createElement(import_react162.default.Fragment, null, /* @__PURE__ */ import_react162.default.createElement(button_default2, { size: "small", type: "text", onClick: commitBulk }, /* @__PURE__ */ import_react162.default.createElement("u", null, " ", i18n2("commitBulkUpdateFieldName"))), /* @__PURE__ */ import_react162.default.createElement("span", { style: { margin: "0 1rem" } }, "/"), /* @__PURE__ */ import_react162.default.createElement(button_default2, { size: "small", type: "text", onClick: () => setIsBulkUpdateFieldNamesMode(false) }, /* @__PURE__ */ import_react162.default.createElement("u", null, " ", i18n2("cancel")))) : /* @__PURE__ */ import_react162.default.createElement(button_default2, { size: "small", type: "text", onClick: startBulk }, /* @__PURE__ */ import_react162.default.createElement("u", null, " ", i18n2("bulkUpdateFieldName")))
  )));
};
var ListView_default = ListView;

// ../../node_modules/form-render/es/form-core/index.js
var import_react181 = __toESM(require_react());
var import_classnames207 = __toESM(require_classnames());

// ../../node_modules/lodash-es/_freeGlobal.js
var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
var freeGlobal_default = freeGlobal;

// ../../node_modules/lodash-es/_root.js
var freeSelf = typeof self == "object" && self && self.Object === Object && self;
var root = freeGlobal_default || freeSelf || Function("return this")();
var root_default = root;

// ../../node_modules/lodash-es/_Symbol.js
var Symbol2 = root_default.Symbol;
var Symbol_default = Symbol2;

// ../../node_modules/lodash-es/_getRawTag.js
var objectProto = Object.prototype;
var hasOwnProperty2 = objectProto.hasOwnProperty;
var nativeObjectToString = objectProto.toString;
var symToStringTag = Symbol_default ? Symbol_default.toStringTag : void 0;
function getRawTag(value) {
  var isOwn = hasOwnProperty2.call(value, symToStringTag), tag = value[symToStringTag];
  try {
    value[symToStringTag] = void 0;
    var unmasked = true;
  } catch (e3) {
  }
  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}
var getRawTag_default = getRawTag;

// ../../node_modules/lodash-es/_objectToString.js
var objectProto2 = Object.prototype;
var nativeObjectToString2 = objectProto2.toString;
function objectToString(value) {
  return nativeObjectToString2.call(value);
}
var objectToString_default = objectToString;

// ../../node_modules/lodash-es/_baseGetTag.js
var nullTag = "[object Null]";
var undefinedTag = "[object Undefined]";
var symToStringTag2 = Symbol_default ? Symbol_default.toStringTag : void 0;
function baseGetTag(value) {
  if (value == null) {
    return value === void 0 ? undefinedTag : nullTag;
  }
  return symToStringTag2 && symToStringTag2 in Object(value) ? getRawTag_default(value) : objectToString_default(value);
}
var baseGetTag_default = baseGetTag;

// ../../node_modules/lodash-es/isObjectLike.js
function isObjectLike(value) {
  return value != null && typeof value == "object";
}
var isObjectLike_default = isObjectLike;

// ../../node_modules/lodash-es/isSymbol.js
var symbolTag = "[object Symbol]";
function isSymbol(value) {
  return typeof value == "symbol" || isObjectLike_default(value) && baseGetTag_default(value) == symbolTag;
}
var isSymbol_default = isSymbol;

// ../../node_modules/lodash-es/_arrayMap.js
function arrayMap(array4, iteratee) {
  var index3 = -1, length2 = array4 == null ? 0 : array4.length, result = Array(length2);
  while (++index3 < length2) {
    result[index3] = iteratee(array4[index3], index3, array4);
  }
  return result;
}
var arrayMap_default = arrayMap;

// ../../node_modules/lodash-es/isArray.js
var isArray2 = Array.isArray;
var isArray_default = isArray2;

// ../../node_modules/lodash-es/_baseToString.js
var INFINITY = 1 / 0;
var symbolProto = Symbol_default ? Symbol_default.prototype : void 0;
var symbolToString = symbolProto ? symbolProto.toString : void 0;
function baseToString(value) {
  if (typeof value == "string") {
    return value;
  }
  if (isArray_default(value)) {
    return arrayMap_default(value, baseToString) + "";
  }
  if (isSymbol_default(value)) {
    return symbolToString ? symbolToString.call(value) : "";
  }
  var result = value + "";
  return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
var baseToString_default = baseToString;

// ../../node_modules/lodash-es/_trimmedEndIndex.js
var reWhitespace = /\s/;
function trimmedEndIndex(string3) {
  var index3 = string3.length;
  while (index3-- && reWhitespace.test(string3.charAt(index3))) {
  }
  return index3;
}
var trimmedEndIndex_default = trimmedEndIndex;

// ../../node_modules/lodash-es/_baseTrim.js
var reTrimStart = /^\s+/;
function baseTrim(string3) {
  return string3 ? string3.slice(0, trimmedEndIndex_default(string3) + 1).replace(reTrimStart, "") : string3;
}
var baseTrim_default = baseTrim;

// ../../node_modules/lodash-es/isObject.js
function isObject2(value) {
  var type5 = typeof value;
  return value != null && (type5 == "object" || type5 == "function");
}
var isObject_default = isObject2;

// ../../node_modules/lodash-es/toNumber.js
var NAN = 0 / 0;
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
var reIsBinary = /^0b[01]+$/i;
var reIsOctal = /^0o[0-7]+$/i;
var freeParseInt = parseInt;
function toNumber(value) {
  if (typeof value == "number") {
    return value;
  }
  if (isSymbol_default(value)) {
    return NAN;
  }
  if (isObject_default(value)) {
    var other = typeof value.valueOf == "function" ? value.valueOf() : value;
    value = isObject_default(other) ? other + "" : other;
  }
  if (typeof value != "string") {
    return value === 0 ? value : +value;
  }
  value = baseTrim_default(value);
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
var toNumber_default = toNumber;

// ../../node_modules/lodash-es/identity.js
function identity(value) {
  return value;
}
var identity_default = identity;

// ../../node_modules/lodash-es/isFunction.js
var asyncTag = "[object AsyncFunction]";
var funcTag = "[object Function]";
var genTag = "[object GeneratorFunction]";
var proxyTag = "[object Proxy]";
function isFunction(value) {
  if (!isObject_default(value)) {
    return false;
  }
  var tag = baseGetTag_default(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
var isFunction_default = isFunction;

// ../../node_modules/lodash-es/_coreJsData.js
var coreJsData = root_default["__core-js_shared__"];
var coreJsData_default = coreJsData;

// ../../node_modules/lodash-es/_isMasked.js
var maskSrcKey = (function() {
  var uid3 = /[^.]+$/.exec(coreJsData_default && coreJsData_default.keys && coreJsData_default.keys.IE_PROTO || "");
  return uid3 ? "Symbol(src)_1." + uid3 : "";
})();
function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}
var isMasked_default = isMasked;

// ../../node_modules/lodash-es/_toSource.js
var funcProto = Function.prototype;
var funcToString = funcProto.toString;
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e3) {
    }
    try {
      return func + "";
    } catch (e3) {
    }
  }
  return "";
}
var toSource_default = toSource;

// ../../node_modules/lodash-es/_baseIsNative.js
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
var reIsHostCtor = /^\[object .+?Constructor\]$/;
var funcProto2 = Function.prototype;
var objectProto3 = Object.prototype;
var funcToString2 = funcProto2.toString;
var hasOwnProperty3 = objectProto3.hasOwnProperty;
var reIsNative = RegExp(
  "^" + funcToString2.call(hasOwnProperty3).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function baseIsNative(value) {
  if (!isObject_default(value) || isMasked_default(value)) {
    return false;
  }
  var pattern6 = isFunction_default(value) ? reIsNative : reIsHostCtor;
  return pattern6.test(toSource_default(value));
}
var baseIsNative_default = baseIsNative;

// ../../node_modules/lodash-es/_getValue.js
function getValue3(object4, key2) {
  return object4 == null ? void 0 : object4[key2];
}
var getValue_default = getValue3;

// ../../node_modules/lodash-es/_getNative.js
function getNative(object4, key2) {
  var value = getValue_default(object4, key2);
  return baseIsNative_default(value) ? value : void 0;
}
var getNative_default = getNative;

// ../../node_modules/lodash-es/_WeakMap.js
var WeakMap2 = getNative_default(root_default, "WeakMap");
var WeakMap_default = WeakMap2;

// ../../node_modules/lodash-es/_baseCreate.js
var objectCreate = Object.create;
var baseCreate = /* @__PURE__ */ (function() {
  function object4() {
  }
  return function(proto) {
    if (!isObject_default(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object4.prototype = proto;
    var result = new object4();
    object4.prototype = void 0;
    return result;
  };
})();
var baseCreate_default = baseCreate;

// ../../node_modules/lodash-es/_copyArray.js
function copyArray(source, array4) {
  var index3 = -1, length2 = source.length;
  array4 || (array4 = Array(length2));
  while (++index3 < length2) {
    array4[index3] = source[index3];
  }
  return array4;
}
var copyArray_default = copyArray;

// ../../node_modules/lodash-es/_defineProperty.js
var defineProperty = (function() {
  try {
    var func = getNative_default(Object, "defineProperty");
    func({}, "", {});
    return func;
  } catch (e3) {
  }
})();
var defineProperty_default = defineProperty;

// ../../node_modules/lodash-es/_arrayEach.js
function arrayEach(array4, iteratee) {
  var index3 = -1, length2 = array4 == null ? 0 : array4.length;
  while (++index3 < length2) {
    if (iteratee(array4[index3], index3, array4) === false) {
      break;
    }
  }
  return array4;
}
var arrayEach_default = arrayEach;

// ../../node_modules/lodash-es/_isIndex.js
var MAX_SAFE_INTEGER = 9007199254740991;
var reIsUint = /^(?:0|[1-9]\d*)$/;
function isIndex(value, length2) {
  var type5 = typeof value;
  length2 = length2 == null ? MAX_SAFE_INTEGER : length2;
  return !!length2 && (type5 == "number" || type5 != "symbol" && reIsUint.test(value)) && (value > -1 && value % 1 == 0 && value < length2);
}
var isIndex_default = isIndex;

// ../../node_modules/lodash-es/_baseAssignValue.js
function baseAssignValue(object4, key2, value) {
  if (key2 == "__proto__" && defineProperty_default) {
    defineProperty_default(object4, key2, {
      "configurable": true,
      "enumerable": true,
      "value": value,
      "writable": true
    });
  } else {
    object4[key2] = value;
  }
}
var baseAssignValue_default = baseAssignValue;

// ../../node_modules/lodash-es/eq.js
function eq(value, other) {
  return value === other || value !== value && other !== other;
}
var eq_default = eq;

// ../../node_modules/lodash-es/_assignValue.js
var objectProto4 = Object.prototype;
var hasOwnProperty4 = objectProto4.hasOwnProperty;
function assignValue(object4, key2, value) {
  var objValue = object4[key2];
  if (!(hasOwnProperty4.call(object4, key2) && eq_default(objValue, value)) || value === void 0 && !(key2 in object4)) {
    baseAssignValue_default(object4, key2, value);
  }
}
var assignValue_default = assignValue;

// ../../node_modules/lodash-es/_copyObject.js
function copyObject(source, props, object4, customizer) {
  var isNew = !object4;
  object4 || (object4 = {});
  var index3 = -1, length2 = props.length;
  while (++index3 < length2) {
    var key2 = props[index3];
    var newValue = customizer ? customizer(object4[key2], source[key2], key2, object4, source) : void 0;
    if (newValue === void 0) {
      newValue = source[key2];
    }
    if (isNew) {
      baseAssignValue_default(object4, key2, newValue);
    } else {
      assignValue_default(object4, key2, newValue);
    }
  }
  return object4;
}
var copyObject_default = copyObject;

// ../../node_modules/lodash-es/isLength.js
var MAX_SAFE_INTEGER2 = 9007199254740991;
function isLength(value) {
  return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER2;
}
var isLength_default = isLength;

// ../../node_modules/lodash-es/isArrayLike.js
function isArrayLike(value) {
  return value != null && isLength_default(value.length) && !isFunction_default(value);
}
var isArrayLike_default = isArrayLike;

// ../../node_modules/lodash-es/_isIterateeCall.js
function isIterateeCall(value, index3, object4) {
  if (!isObject_default(object4)) {
    return false;
  }
  var type5 = typeof index3;
  if (type5 == "number" ? isArrayLike_default(object4) && isIndex_default(index3, object4.length) : type5 == "string" && index3 in object4) {
    return eq_default(object4[index3], value);
  }
  return false;
}
var isIterateeCall_default = isIterateeCall;

// ../../node_modules/lodash-es/_isPrototype.js
var objectProto5 = Object.prototype;
function isPrototype(value) {
  var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto5;
  return value === proto;
}
var isPrototype_default = isPrototype;

// ../../node_modules/lodash-es/_baseTimes.js
function baseTimes(n2, iteratee) {
  var index3 = -1, result = Array(n2);
  while (++index3 < n2) {
    result[index3] = iteratee(index3);
  }
  return result;
}
var baseTimes_default = baseTimes;

// ../../node_modules/lodash-es/_baseIsArguments.js
var argsTag = "[object Arguments]";
function baseIsArguments(value) {
  return isObjectLike_default(value) && baseGetTag_default(value) == argsTag;
}
var baseIsArguments_default = baseIsArguments;

// ../../node_modules/lodash-es/isArguments.js
var objectProto6 = Object.prototype;
var hasOwnProperty5 = objectProto6.hasOwnProperty;
var propertyIsEnumerable = objectProto6.propertyIsEnumerable;
var isArguments = baseIsArguments_default(/* @__PURE__ */ (function() {
  return arguments;
})()) ? baseIsArguments_default : function(value) {
  return isObjectLike_default(value) && hasOwnProperty5.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
};
var isArguments_default = isArguments;

// ../../node_modules/lodash-es/stubFalse.js
function stubFalse() {
  return false;
}
var stubFalse_default = stubFalse;

// ../../node_modules/lodash-es/isBuffer.js
var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports;
var freeModule = freeExports && typeof module == "object" && module && !module.nodeType && module;
var moduleExports = freeModule && freeModule.exports === freeExports;
var Buffer4 = moduleExports ? root_default.Buffer : void 0;
var nativeIsBuffer = Buffer4 ? Buffer4.isBuffer : void 0;
var isBuffer = nativeIsBuffer || stubFalse_default;
var isBuffer_default = isBuffer;

// ../../node_modules/lodash-es/_baseIsTypedArray.js
var argsTag2 = "[object Arguments]";
var arrayTag = "[object Array]";
var boolTag = "[object Boolean]";
var dateTag = "[object Date]";
var errorTag = "[object Error]";
var funcTag2 = "[object Function]";
var mapTag = "[object Map]";
var numberTag = "[object Number]";
var objectTag = "[object Object]";
var regexpTag = "[object RegExp]";
var setTag = "[object Set]";
var stringTag = "[object String]";
var weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]";
var dataViewTag = "[object DataView]";
var float32Tag = "[object Float32Array]";
var float64Tag = "[object Float64Array]";
var int8Tag = "[object Int8Array]";
var int16Tag = "[object Int16Array]";
var int32Tag = "[object Int32Array]";
var uint8Tag = "[object Uint8Array]";
var uint8ClampedTag = "[object Uint8ClampedArray]";
var uint16Tag = "[object Uint16Array]";
var uint32Tag = "[object Uint32Array]";
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag2] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag2] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
function baseIsTypedArray(value) {
  return isObjectLike_default(value) && isLength_default(value.length) && !!typedArrayTags[baseGetTag_default(value)];
}
var baseIsTypedArray_default = baseIsTypedArray;

// ../../node_modules/lodash-es/_baseUnary.js
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}
var baseUnary_default = baseUnary;

// ../../node_modules/lodash-es/_nodeUtil.js
var freeExports2 = typeof exports == "object" && exports && !exports.nodeType && exports;
var freeModule2 = freeExports2 && typeof module == "object" && module && !module.nodeType && module;
var moduleExports2 = freeModule2 && freeModule2.exports === freeExports2;
var freeProcess = moduleExports2 && freeGlobal_default.process;
var nodeUtil = (function() {
  try {
    var types3 = freeModule2 && freeModule2.require && freeModule2.require("util").types;
    if (types3) {
      return types3;
    }
    return freeProcess && freeProcess.binding && freeProcess.binding("util");
  } catch (e3) {
  }
})();
var nodeUtil_default = nodeUtil;

// ../../node_modules/lodash-es/isTypedArray.js
var nodeIsTypedArray = nodeUtil_default && nodeUtil_default.isTypedArray;
var isTypedArray = nodeIsTypedArray ? baseUnary_default(nodeIsTypedArray) : baseIsTypedArray_default;
var isTypedArray_default = isTypedArray;

// ../../node_modules/lodash-es/_arrayLikeKeys.js
var objectProto7 = Object.prototype;
var hasOwnProperty6 = objectProto7.hasOwnProperty;
function arrayLikeKeys(value, inherited) {
  var isArr = isArray_default(value), isArg = !isArr && isArguments_default(value), isBuff = !isArr && !isArg && isBuffer_default(value), isType2 = !isArr && !isArg && !isBuff && isTypedArray_default(value), skipIndexes = isArr || isArg || isBuff || isType2, result = skipIndexes ? baseTimes_default(value.length, String) : [], length2 = result.length;
  for (var key2 in value) {
    if ((inherited || hasOwnProperty6.call(value, key2)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key2 == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key2 == "offset" || key2 == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType2 && (key2 == "buffer" || key2 == "byteLength" || key2 == "byteOffset") || // Skip index properties.
    isIndex_default(key2, length2)))) {
      result.push(key2);
    }
  }
  return result;
}
var arrayLikeKeys_default = arrayLikeKeys;

// ../../node_modules/lodash-es/_overArg.js
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}
var overArg_default = overArg;

// ../../node_modules/lodash-es/_nativeKeys.js
var nativeKeys = overArg_default(Object.keys, Object);
var nativeKeys_default = nativeKeys;

// ../../node_modules/lodash-es/_baseKeys.js
var objectProto8 = Object.prototype;
var hasOwnProperty7 = objectProto8.hasOwnProperty;
function baseKeys(object4) {
  if (!isPrototype_default(object4)) {
    return nativeKeys_default(object4);
  }
  var result = [];
  for (var key2 in Object(object4)) {
    if (hasOwnProperty7.call(object4, key2) && key2 != "constructor") {
      result.push(key2);
    }
  }
  return result;
}
var baseKeys_default = baseKeys;

// ../../node_modules/lodash-es/keys.js
function keys3(object4) {
  return isArrayLike_default(object4) ? arrayLikeKeys_default(object4) : baseKeys_default(object4);
}
var keys_default = keys3;

// ../../node_modules/lodash-es/_nativeKeysIn.js
function nativeKeysIn(object4) {
  var result = [];
  if (object4 != null) {
    for (var key2 in Object(object4)) {
      result.push(key2);
    }
  }
  return result;
}
var nativeKeysIn_default = nativeKeysIn;

// ../../node_modules/lodash-es/_baseKeysIn.js
var objectProto9 = Object.prototype;
var hasOwnProperty8 = objectProto9.hasOwnProperty;
function baseKeysIn(object4) {
  if (!isObject_default(object4)) {
    return nativeKeysIn_default(object4);
  }
  var isProto = isPrototype_default(object4), result = [];
  for (var key2 in object4) {
    if (!(key2 == "constructor" && (isProto || !hasOwnProperty8.call(object4, key2)))) {
      result.push(key2);
    }
  }
  return result;
}
var baseKeysIn_default = baseKeysIn;

// ../../node_modules/lodash-es/keysIn.js
function keysIn(object4) {
  return isArrayLike_default(object4) ? arrayLikeKeys_default(object4, true) : baseKeysIn_default(object4);
}
var keysIn_default = keysIn;

// ../../node_modules/lodash-es/_isKey.js
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/;
var reIsPlainProp = /^\w*$/;
function isKey(value, object4) {
  if (isArray_default(value)) {
    return false;
  }
  var type5 = typeof value;
  if (type5 == "number" || type5 == "symbol" || type5 == "boolean" || value == null || isSymbol_default(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object4 != null && value in Object(object4);
}
var isKey_default = isKey;

// ../../node_modules/lodash-es/_nativeCreate.js
var nativeCreate = getNative_default(Object, "create");
var nativeCreate_default = nativeCreate;

// ../../node_modules/lodash-es/_hashClear.js
function hashClear() {
  this.__data__ = nativeCreate_default ? nativeCreate_default(null) : {};
  this.size = 0;
}
var hashClear_default = hashClear;

// ../../node_modules/lodash-es/_hashDelete.js
function hashDelete(key2) {
  var result = this.has(key2) && delete this.__data__[key2];
  this.size -= result ? 1 : 0;
  return result;
}
var hashDelete_default = hashDelete;

// ../../node_modules/lodash-es/_hashGet.js
var HASH_UNDEFINED = "__lodash_hash_undefined__";
var objectProto10 = Object.prototype;
var hasOwnProperty9 = objectProto10.hasOwnProperty;
function hashGet(key2) {
  var data2 = this.__data__;
  if (nativeCreate_default) {
    var result = data2[key2];
    return result === HASH_UNDEFINED ? void 0 : result;
  }
  return hasOwnProperty9.call(data2, key2) ? data2[key2] : void 0;
}
var hashGet_default = hashGet;

// ../../node_modules/lodash-es/_hashHas.js
var objectProto11 = Object.prototype;
var hasOwnProperty10 = objectProto11.hasOwnProperty;
function hashHas(key2) {
  var data2 = this.__data__;
  return nativeCreate_default ? data2[key2] !== void 0 : hasOwnProperty10.call(data2, key2);
}
var hashHas_default = hashHas;

// ../../node_modules/lodash-es/_hashSet.js
var HASH_UNDEFINED2 = "__lodash_hash_undefined__";
function hashSet(key2, value) {
  var data2 = this.__data__;
  this.size += this.has(key2) ? 0 : 1;
  data2[key2] = nativeCreate_default && value === void 0 ? HASH_UNDEFINED2 : value;
  return this;
}
var hashSet_default = hashSet;

// ../../node_modules/lodash-es/_Hash.js
function Hash(entries) {
  var index3 = -1, length2 = entries == null ? 0 : entries.length;
  this.clear();
  while (++index3 < length2) {
    var entry = entries[index3];
    this.set(entry[0], entry[1]);
  }
}
Hash.prototype.clear = hashClear_default;
Hash.prototype["delete"] = hashDelete_default;
Hash.prototype.get = hashGet_default;
Hash.prototype.has = hashHas_default;
Hash.prototype.set = hashSet_default;
var Hash_default = Hash;

// ../../node_modules/lodash-es/_listCacheClear.js
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}
var listCacheClear_default = listCacheClear;

// ../../node_modules/lodash-es/_assocIndexOf.js
function assocIndexOf(array4, key2) {
  var length2 = array4.length;
  while (length2--) {
    if (eq_default(array4[length2][0], key2)) {
      return length2;
    }
  }
  return -1;
}
var assocIndexOf_default = assocIndexOf;

// ../../node_modules/lodash-es/_listCacheDelete.js
var arrayProto = Array.prototype;
var splice = arrayProto.splice;
function listCacheDelete(key2) {
  var data2 = this.__data__, index3 = assocIndexOf_default(data2, key2);
  if (index3 < 0) {
    return false;
  }
  var lastIndex = data2.length - 1;
  if (index3 == lastIndex) {
    data2.pop();
  } else {
    splice.call(data2, index3, 1);
  }
  --this.size;
  return true;
}
var listCacheDelete_default = listCacheDelete;

// ../../node_modules/lodash-es/_listCacheGet.js
function listCacheGet(key2) {
  var data2 = this.__data__, index3 = assocIndexOf_default(data2, key2);
  return index3 < 0 ? void 0 : data2[index3][1];
}
var listCacheGet_default = listCacheGet;

// ../../node_modules/lodash-es/_listCacheHas.js
function listCacheHas(key2) {
  return assocIndexOf_default(this.__data__, key2) > -1;
}
var listCacheHas_default = listCacheHas;

// ../../node_modules/lodash-es/_listCacheSet.js
function listCacheSet(key2, value) {
  var data2 = this.__data__, index3 = assocIndexOf_default(data2, key2);
  if (index3 < 0) {
    ++this.size;
    data2.push([key2, value]);
  } else {
    data2[index3][1] = value;
  }
  return this;
}
var listCacheSet_default = listCacheSet;

// ../../node_modules/lodash-es/_ListCache.js
function ListCache(entries) {
  var index3 = -1, length2 = entries == null ? 0 : entries.length;
  this.clear();
  while (++index3 < length2) {
    var entry = entries[index3];
    this.set(entry[0], entry[1]);
  }
}
ListCache.prototype.clear = listCacheClear_default;
ListCache.prototype["delete"] = listCacheDelete_default;
ListCache.prototype.get = listCacheGet_default;
ListCache.prototype.has = listCacheHas_default;
ListCache.prototype.set = listCacheSet_default;
var ListCache_default = ListCache;

// ../../node_modules/lodash-es/_Map.js
var Map2 = getNative_default(root_default, "Map");
var Map_default = Map2;

// ../../node_modules/lodash-es/_mapCacheClear.js
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    "hash": new Hash_default(),
    "map": new (Map_default || ListCache_default)(),
    "string": new Hash_default()
  };
}
var mapCacheClear_default = mapCacheClear;

// ../../node_modules/lodash-es/_isKeyable.js
function isKeyable(value) {
  var type5 = typeof value;
  return type5 == "string" || type5 == "number" || type5 == "symbol" || type5 == "boolean" ? value !== "__proto__" : value === null;
}
var isKeyable_default = isKeyable;

// ../../node_modules/lodash-es/_getMapData.js
function getMapData(map, key2) {
  var data2 = map.__data__;
  return isKeyable_default(key2) ? data2[typeof key2 == "string" ? "string" : "hash"] : data2.map;
}
var getMapData_default = getMapData;

// ../../node_modules/lodash-es/_mapCacheDelete.js
function mapCacheDelete(key2) {
  var result = getMapData_default(this, key2)["delete"](key2);
  this.size -= result ? 1 : 0;
  return result;
}
var mapCacheDelete_default = mapCacheDelete;

// ../../node_modules/lodash-es/_mapCacheGet.js
function mapCacheGet(key2) {
  return getMapData_default(this, key2).get(key2);
}
var mapCacheGet_default = mapCacheGet;

// ../../node_modules/lodash-es/_mapCacheHas.js
function mapCacheHas(key2) {
  return getMapData_default(this, key2).has(key2);
}
var mapCacheHas_default = mapCacheHas;

// ../../node_modules/lodash-es/_mapCacheSet.js
function mapCacheSet(key2, value) {
  var data2 = getMapData_default(this, key2), size = data2.size;
  data2.set(key2, value);
  this.size += data2.size == size ? 0 : 1;
  return this;
}
var mapCacheSet_default = mapCacheSet;

// ../../node_modules/lodash-es/_MapCache.js
function MapCache(entries) {
  var index3 = -1, length2 = entries == null ? 0 : entries.length;
  this.clear();
  while (++index3 < length2) {
    var entry = entries[index3];
    this.set(entry[0], entry[1]);
  }
}
MapCache.prototype.clear = mapCacheClear_default;
MapCache.prototype["delete"] = mapCacheDelete_default;
MapCache.prototype.get = mapCacheGet_default;
MapCache.prototype.has = mapCacheHas_default;
MapCache.prototype.set = mapCacheSet_default;
var MapCache_default = MapCache;

// ../../node_modules/lodash-es/memoize.js
var FUNC_ERROR_TEXT = "Expected a function";
function memoize(func, resolver) {
  if (typeof func != "function" || resolver != null && typeof resolver != "function") {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments, key2 = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
    if (cache.has(key2)) {
      return cache.get(key2);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key2, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache_default)();
  return memoized;
}
memoize.Cache = MapCache_default;
var memoize_default = memoize;

// ../../node_modules/lodash-es/_memoizeCapped.js
var MAX_MEMOIZE_SIZE = 500;
function memoizeCapped(func) {
  var result = memoize_default(func, function(key2) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key2;
  });
  var cache = result.cache;
  return result;
}
var memoizeCapped_default = memoizeCapped;

// ../../node_modules/lodash-es/_stringToPath.js
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
var reEscapeChar = /\\(\\)?/g;
var stringToPath = memoizeCapped_default(function(string3) {
  var result = [];
  if (string3.charCodeAt(0) === 46) {
    result.push("");
  }
  string3.replace(rePropName, function(match2, number4, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, "$1") : number4 || match2);
  });
  return result;
});
var stringToPath_default = stringToPath;

// ../../node_modules/lodash-es/toString.js
function toString2(value) {
  return value == null ? "" : baseToString_default(value);
}
var toString_default = toString2;

// ../../node_modules/lodash-es/_castPath.js
function castPath(value, object4) {
  if (isArray_default(value)) {
    return value;
  }
  return isKey_default(value, object4) ? [value] : stringToPath_default(toString_default(value));
}
var castPath_default = castPath;

// ../../node_modules/lodash-es/_toKey.js
var INFINITY2 = 1 / 0;
function toKey(value) {
  if (typeof value == "string" || isSymbol_default(value)) {
    return value;
  }
  var result = value + "";
  return result == "0" && 1 / value == -INFINITY2 ? "-0" : result;
}
var toKey_default = toKey;

// ../../node_modules/lodash-es/_baseGet.js
function baseGet(object4, path2) {
  path2 = castPath_default(path2, object4);
  var index3 = 0, length2 = path2.length;
  while (object4 != null && index3 < length2) {
    object4 = object4[toKey_default(path2[index3++])];
  }
  return index3 && index3 == length2 ? object4 : void 0;
}
var baseGet_default = baseGet;

// ../../node_modules/lodash-es/get.js
function get2(object4, path2, defaultValue2) {
  var result = object4 == null ? void 0 : baseGet_default(object4, path2);
  return result === void 0 ? defaultValue2 : result;
}
var get_default = get2;

// ../../node_modules/lodash-es/_arrayPush.js
function arrayPush(array4, values) {
  var index3 = -1, length2 = values.length, offset4 = array4.length;
  while (++index3 < length2) {
    array4[offset4 + index3] = values[index3];
  }
  return array4;
}
var arrayPush_default = arrayPush;

// ../../node_modules/lodash-es/_getPrototype.js
var getPrototype = overArg_default(Object.getPrototypeOf, Object);
var getPrototype_default = getPrototype;

// ../../node_modules/lodash-es/_baseSlice.js
function baseSlice(array4, start, end) {
  var index3 = -1, length2 = array4.length;
  if (start < 0) {
    start = -start > length2 ? 0 : length2 + start;
  }
  end = end > length2 ? length2 : end;
  if (end < 0) {
    end += length2;
  }
  length2 = start > end ? 0 : end - start >>> 0;
  start >>>= 0;
  var result = Array(length2);
  while (++index3 < length2) {
    result[index3] = array4[index3 + start];
  }
  return result;
}
var baseSlice_default = baseSlice;

// ../../node_modules/lodash-es/_stackClear.js
function stackClear() {
  this.__data__ = new ListCache_default();
  this.size = 0;
}
var stackClear_default = stackClear;

// ../../node_modules/lodash-es/_stackDelete.js
function stackDelete(key2) {
  var data2 = this.__data__, result = data2["delete"](key2);
  this.size = data2.size;
  return result;
}
var stackDelete_default = stackDelete;

// ../../node_modules/lodash-es/_stackGet.js
function stackGet(key2) {
  return this.__data__.get(key2);
}
var stackGet_default = stackGet;

// ../../node_modules/lodash-es/_stackHas.js
function stackHas(key2) {
  return this.__data__.has(key2);
}
var stackHas_default = stackHas;

// ../../node_modules/lodash-es/_stackSet.js
var LARGE_ARRAY_SIZE = 200;
function stackSet(key2, value) {
  var data2 = this.__data__;
  if (data2 instanceof ListCache_default) {
    var pairs = data2.__data__;
    if (!Map_default || pairs.length < LARGE_ARRAY_SIZE - 1) {
      pairs.push([key2, value]);
      this.size = ++data2.size;
      return this;
    }
    data2 = this.__data__ = new MapCache_default(pairs);
  }
  data2.set(key2, value);
  this.size = data2.size;
  return this;
}
var stackSet_default = stackSet;

// ../../node_modules/lodash-es/_Stack.js
function Stack(entries) {
  var data2 = this.__data__ = new ListCache_default(entries);
  this.size = data2.size;
}
Stack.prototype.clear = stackClear_default;
Stack.prototype["delete"] = stackDelete_default;
Stack.prototype.get = stackGet_default;
Stack.prototype.has = stackHas_default;
Stack.prototype.set = stackSet_default;
var Stack_default = Stack;

// ../../node_modules/lodash-es/_baseAssign.js
function baseAssign(object4, source) {
  return object4 && copyObject_default(source, keys_default(source), object4);
}
var baseAssign_default = baseAssign;

// ../../node_modules/lodash-es/_baseAssignIn.js
function baseAssignIn(object4, source) {
  return object4 && copyObject_default(source, keysIn_default(source), object4);
}
var baseAssignIn_default = baseAssignIn;

// ../../node_modules/lodash-es/_cloneBuffer.js
var freeExports3 = typeof exports == "object" && exports && !exports.nodeType && exports;
var freeModule3 = freeExports3 && typeof module == "object" && module && !module.nodeType && module;
var moduleExports3 = freeModule3 && freeModule3.exports === freeExports3;
var Buffer5 = moduleExports3 ? root_default.Buffer : void 0;
var allocUnsafe = Buffer5 ? Buffer5.allocUnsafe : void 0;
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length2 = buffer.length, result = allocUnsafe ? allocUnsafe(length2) : new buffer.constructor(length2);
  buffer.copy(result);
  return result;
}
var cloneBuffer_default = cloneBuffer;

// ../../node_modules/lodash-es/_arrayFilter.js
function arrayFilter(array4, predicate) {
  var index3 = -1, length2 = array4 == null ? 0 : array4.length, resIndex = 0, result = [];
  while (++index3 < length2) {
    var value = array4[index3];
    if (predicate(value, index3, array4)) {
      result[resIndex++] = value;
    }
  }
  return result;
}
var arrayFilter_default = arrayFilter;

// ../../node_modules/lodash-es/stubArray.js
function stubArray() {
  return [];
}
var stubArray_default = stubArray;

// ../../node_modules/lodash-es/_getSymbols.js
var objectProto12 = Object.prototype;
var propertyIsEnumerable2 = objectProto12.propertyIsEnumerable;
var nativeGetSymbols = Object.getOwnPropertySymbols;
var getSymbols = !nativeGetSymbols ? stubArray_default : function(object4) {
  if (object4 == null) {
    return [];
  }
  object4 = Object(object4);
  return arrayFilter_default(nativeGetSymbols(object4), function(symbol) {
    return propertyIsEnumerable2.call(object4, symbol);
  });
};
var getSymbols_default = getSymbols;

// ../../node_modules/lodash-es/_copySymbols.js
function copySymbols(source, object4) {
  return copyObject_default(source, getSymbols_default(source), object4);
}
var copySymbols_default = copySymbols;

// ../../node_modules/lodash-es/_getSymbolsIn.js
var nativeGetSymbols2 = Object.getOwnPropertySymbols;
var getSymbolsIn = !nativeGetSymbols2 ? stubArray_default : function(object4) {
  var result = [];
  while (object4) {
    arrayPush_default(result, getSymbols_default(object4));
    object4 = getPrototype_default(object4);
  }
  return result;
};
var getSymbolsIn_default = getSymbolsIn;

// ../../node_modules/lodash-es/_copySymbolsIn.js
function copySymbolsIn(source, object4) {
  return copyObject_default(source, getSymbolsIn_default(source), object4);
}
var copySymbolsIn_default = copySymbolsIn;

// ../../node_modules/lodash-es/_baseGetAllKeys.js
function baseGetAllKeys(object4, keysFunc, symbolsFunc) {
  var result = keysFunc(object4);
  return isArray_default(object4) ? result : arrayPush_default(result, symbolsFunc(object4));
}
var baseGetAllKeys_default = baseGetAllKeys;

// ../../node_modules/lodash-es/_getAllKeys.js
function getAllKeys3(object4) {
  return baseGetAllKeys_default(object4, keys_default, getSymbols_default);
}
var getAllKeys_default = getAllKeys3;

// ../../node_modules/lodash-es/_getAllKeysIn.js
function getAllKeysIn(object4) {
  return baseGetAllKeys_default(object4, keysIn_default, getSymbolsIn_default);
}
var getAllKeysIn_default = getAllKeysIn;

// ../../node_modules/lodash-es/_DataView.js
var DataView2 = getNative_default(root_default, "DataView");
var DataView_default = DataView2;

// ../../node_modules/lodash-es/_Promise.js
var Promise2 = getNative_default(root_default, "Promise");
var Promise_default = Promise2;

// ../../node_modules/lodash-es/_Set.js
var Set2 = getNative_default(root_default, "Set");
var Set_default = Set2;

// ../../node_modules/lodash-es/_getTag.js
var mapTag2 = "[object Map]";
var objectTag2 = "[object Object]";
var promiseTag = "[object Promise]";
var setTag2 = "[object Set]";
var weakMapTag2 = "[object WeakMap]";
var dataViewTag2 = "[object DataView]";
var dataViewCtorString = toSource_default(DataView_default);
var mapCtorString = toSource_default(Map_default);
var promiseCtorString = toSource_default(Promise_default);
var setCtorString = toSource_default(Set_default);
var weakMapCtorString = toSource_default(WeakMap_default);
var getTag = baseGetTag_default;
if (DataView_default && getTag(new DataView_default(new ArrayBuffer(1))) != dataViewTag2 || Map_default && getTag(new Map_default()) != mapTag2 || Promise_default && getTag(Promise_default.resolve()) != promiseTag || Set_default && getTag(new Set_default()) != setTag2 || WeakMap_default && getTag(new WeakMap_default()) != weakMapTag2) {
  getTag = function(value) {
    var result = baseGetTag_default(value), Ctor = result == objectTag2 ? value.constructor : void 0, ctorString = Ctor ? toSource_default(Ctor) : "";
    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString:
          return dataViewTag2;
        case mapCtorString:
          return mapTag2;
        case promiseCtorString:
          return promiseTag;
        case setCtorString:
          return setTag2;
        case weakMapCtorString:
          return weakMapTag2;
      }
    }
    return result;
  };
}
var getTag_default = getTag;

// ../../node_modules/lodash-es/_initCloneArray.js
var objectProto13 = Object.prototype;
var hasOwnProperty11 = objectProto13.hasOwnProperty;
function initCloneArray(array4) {
  var length2 = array4.length, result = new array4.constructor(length2);
  if (length2 && typeof array4[0] == "string" && hasOwnProperty11.call(array4, "index")) {
    result.index = array4.index;
    result.input = array4.input;
  }
  return result;
}
var initCloneArray_default = initCloneArray;

// ../../node_modules/lodash-es/_Uint8Array.js
var Uint8Array2 = root_default.Uint8Array;
var Uint8Array_default = Uint8Array2;

// ../../node_modules/lodash-es/_cloneArrayBuffer.js
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array_default(result).set(new Uint8Array_default(arrayBuffer));
  return result;
}
var cloneArrayBuffer_default = cloneArrayBuffer;

// ../../node_modules/lodash-es/_cloneDataView.js
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer_default(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
var cloneDataView_default = cloneDataView;

// ../../node_modules/lodash-es/_cloneRegExp.js
var reFlags = /\w*$/;
function cloneRegExp(regexp6) {
  var result = new regexp6.constructor(regexp6.source, reFlags.exec(regexp6));
  result.lastIndex = regexp6.lastIndex;
  return result;
}
var cloneRegExp_default = cloneRegExp;

// ../../node_modules/lodash-es/_cloneSymbol.js
var symbolProto2 = Symbol_default ? Symbol_default.prototype : void 0;
var symbolValueOf = symbolProto2 ? symbolProto2.valueOf : void 0;
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}
var cloneSymbol_default = cloneSymbol;

// ../../node_modules/lodash-es/_cloneTypedArray.js
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer_default(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
var cloneTypedArray_default = cloneTypedArray;

// ../../node_modules/lodash-es/_initCloneByTag.js
var boolTag2 = "[object Boolean]";
var dateTag2 = "[object Date]";
var mapTag3 = "[object Map]";
var numberTag2 = "[object Number]";
var regexpTag2 = "[object RegExp]";
var setTag3 = "[object Set]";
var stringTag2 = "[object String]";
var symbolTag2 = "[object Symbol]";
var arrayBufferTag2 = "[object ArrayBuffer]";
var dataViewTag3 = "[object DataView]";
var float32Tag2 = "[object Float32Array]";
var float64Tag2 = "[object Float64Array]";
var int8Tag2 = "[object Int8Array]";
var int16Tag2 = "[object Int16Array]";
var int32Tag2 = "[object Int32Array]";
var uint8Tag2 = "[object Uint8Array]";
var uint8ClampedTag2 = "[object Uint8ClampedArray]";
var uint16Tag2 = "[object Uint16Array]";
var uint32Tag2 = "[object Uint32Array]";
function initCloneByTag(object4, tag, isDeep) {
  var Ctor = object4.constructor;
  switch (tag) {
    case arrayBufferTag2:
      return cloneArrayBuffer_default(object4);
    case boolTag2:
    case dateTag2:
      return new Ctor(+object4);
    case dataViewTag3:
      return cloneDataView_default(object4, isDeep);
    case float32Tag2:
    case float64Tag2:
    case int8Tag2:
    case int16Tag2:
    case int32Tag2:
    case uint8Tag2:
    case uint8ClampedTag2:
    case uint16Tag2:
    case uint32Tag2:
      return cloneTypedArray_default(object4, isDeep);
    case mapTag3:
      return new Ctor();
    case numberTag2:
    case stringTag2:
      return new Ctor(object4);
    case regexpTag2:
      return cloneRegExp_default(object4);
    case setTag3:
      return new Ctor();
    case symbolTag2:
      return cloneSymbol_default(object4);
  }
}
var initCloneByTag_default = initCloneByTag;

// ../../node_modules/lodash-es/_initCloneObject.js
function initCloneObject(object4) {
  return typeof object4.constructor == "function" && !isPrototype_default(object4) ? baseCreate_default(getPrototype_default(object4)) : {};
}
var initCloneObject_default = initCloneObject;

// ../../node_modules/lodash-es/_baseIsMap.js
var mapTag4 = "[object Map]";
function baseIsMap(value) {
  return isObjectLike_default(value) && getTag_default(value) == mapTag4;
}
var baseIsMap_default = baseIsMap;

// ../../node_modules/lodash-es/isMap.js
var nodeIsMap = nodeUtil_default && nodeUtil_default.isMap;
var isMap = nodeIsMap ? baseUnary_default(nodeIsMap) : baseIsMap_default;
var isMap_default = isMap;

// ../../node_modules/lodash-es/_baseIsSet.js
var setTag4 = "[object Set]";
function baseIsSet(value) {
  return isObjectLike_default(value) && getTag_default(value) == setTag4;
}
var baseIsSet_default = baseIsSet;

// ../../node_modules/lodash-es/isSet.js
var nodeIsSet = nodeUtil_default && nodeUtil_default.isSet;
var isSet = nodeIsSet ? baseUnary_default(nodeIsSet) : baseIsSet_default;
var isSet_default = isSet;

// ../../node_modules/lodash-es/_baseClone.js
var CLONE_DEEP_FLAG = 1;
var CLONE_FLAT_FLAG = 2;
var CLONE_SYMBOLS_FLAG = 4;
var argsTag3 = "[object Arguments]";
var arrayTag2 = "[object Array]";
var boolTag3 = "[object Boolean]";
var dateTag3 = "[object Date]";
var errorTag2 = "[object Error]";
var funcTag3 = "[object Function]";
var genTag2 = "[object GeneratorFunction]";
var mapTag5 = "[object Map]";
var numberTag3 = "[object Number]";
var objectTag3 = "[object Object]";
var regexpTag3 = "[object RegExp]";
var setTag5 = "[object Set]";
var stringTag3 = "[object String]";
var symbolTag3 = "[object Symbol]";
var weakMapTag3 = "[object WeakMap]";
var arrayBufferTag3 = "[object ArrayBuffer]";
var dataViewTag4 = "[object DataView]";
var float32Tag3 = "[object Float32Array]";
var float64Tag3 = "[object Float64Array]";
var int8Tag3 = "[object Int8Array]";
var int16Tag3 = "[object Int16Array]";
var int32Tag3 = "[object Int32Array]";
var uint8Tag3 = "[object Uint8Array]";
var uint8ClampedTag3 = "[object Uint8ClampedArray]";
var uint16Tag3 = "[object Uint16Array]";
var uint32Tag3 = "[object Uint32Array]";
var cloneableTags = {};
cloneableTags[argsTag3] = cloneableTags[arrayTag2] = cloneableTags[arrayBufferTag3] = cloneableTags[dataViewTag4] = cloneableTags[boolTag3] = cloneableTags[dateTag3] = cloneableTags[float32Tag3] = cloneableTags[float64Tag3] = cloneableTags[int8Tag3] = cloneableTags[int16Tag3] = cloneableTags[int32Tag3] = cloneableTags[mapTag5] = cloneableTags[numberTag3] = cloneableTags[objectTag3] = cloneableTags[regexpTag3] = cloneableTags[setTag5] = cloneableTags[stringTag3] = cloneableTags[symbolTag3] = cloneableTags[uint8Tag3] = cloneableTags[uint8ClampedTag3] = cloneableTags[uint16Tag3] = cloneableTags[uint32Tag3] = true;
cloneableTags[errorTag2] = cloneableTags[funcTag3] = cloneableTags[weakMapTag3] = false;
function baseClone(value, bitmask, customizer, key2, object4, stack) {
  var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
  if (customizer) {
    result = object4 ? customizer(value, key2, object4, stack) : customizer(value);
  }
  if (result !== void 0) {
    return result;
  }
  if (!isObject_default(value)) {
    return value;
  }
  var isArr = isArray_default(value);
  if (isArr) {
    result = initCloneArray_default(value);
    if (!isDeep) {
      return copyArray_default(value, result);
    }
  } else {
    var tag = getTag_default(value), isFunc = tag == funcTag3 || tag == genTag2;
    if (isBuffer_default(value)) {
      return cloneBuffer_default(value, isDeep);
    }
    if (tag == objectTag3 || tag == argsTag3 || isFunc && !object4) {
      result = isFlat || isFunc ? {} : initCloneObject_default(value);
      if (!isDeep) {
        return isFlat ? copySymbolsIn_default(value, baseAssignIn_default(result, value)) : copySymbols_default(value, baseAssign_default(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object4 ? value : {};
      }
      result = initCloneByTag_default(value, tag, isDeep);
    }
  }
  stack || (stack = new Stack_default());
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);
  if (isSet_default(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap_default(value)) {
    value.forEach(function(subValue, key3) {
      result.set(key3, baseClone(subValue, bitmask, customizer, key3, value, stack));
    });
  }
  var keysFunc = isFull ? isFlat ? getAllKeysIn_default : getAllKeys_default : isFlat ? keysIn_default : keys_default;
  var props = isArr ? void 0 : keysFunc(value);
  arrayEach_default(props || value, function(subValue, key3) {
    if (props) {
      key3 = subValue;
      subValue = value[key3];
    }
    assignValue_default(result, key3, baseClone(subValue, bitmask, customizer, key3, value, stack));
  });
  return result;
}
var baseClone_default = baseClone;

// ../../node_modules/lodash-es/cloneDeep.js
var CLONE_DEEP_FLAG2 = 1;
var CLONE_SYMBOLS_FLAG2 = 4;
function cloneDeep2(value) {
  return baseClone_default(value, CLONE_DEEP_FLAG2 | CLONE_SYMBOLS_FLAG2);
}
var cloneDeep_default = cloneDeep2;

// ../../node_modules/lodash-es/_setCacheAdd.js
var HASH_UNDEFINED3 = "__lodash_hash_undefined__";
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED3);
  return this;
}
var setCacheAdd_default = setCacheAdd;

// ../../node_modules/lodash-es/_setCacheHas.js
function setCacheHas(value) {
  return this.__data__.has(value);
}
var setCacheHas_default = setCacheHas;

// ../../node_modules/lodash-es/_SetCache.js
function SetCache(values) {
  var index3 = -1, length2 = values == null ? 0 : values.length;
  this.__data__ = new MapCache_default();
  while (++index3 < length2) {
    this.add(values[index3]);
  }
}
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd_default;
SetCache.prototype.has = setCacheHas_default;
var SetCache_default = SetCache;

// ../../node_modules/lodash-es/_arraySome.js
function arraySome(array4, predicate) {
  var index3 = -1, length2 = array4 == null ? 0 : array4.length;
  while (++index3 < length2) {
    if (predicate(array4[index3], index3, array4)) {
      return true;
    }
  }
  return false;
}
var arraySome_default = arraySome;

// ../../node_modules/lodash-es/_cacheHas.js
function cacheHas(cache, key2) {
  return cache.has(key2);
}
var cacheHas_default = cacheHas;

// ../../node_modules/lodash-es/_equalArrays.js
var COMPARE_PARTIAL_FLAG = 1;
var COMPARE_UNORDERED_FLAG = 2;
function equalArrays(array4, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array4.length, othLength = other.length;
  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  var arrStacked = stack.get(array4);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array4;
  }
  var index3 = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache_default() : void 0;
  stack.set(array4, other);
  stack.set(other, array4);
  while (++index3 < arrLength) {
    var arrValue = array4[index3], othValue = other[index3];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, arrValue, index3, other, array4, stack) : customizer(arrValue, othValue, index3, array4, other, stack);
    }
    if (compared !== void 0) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    if (seen) {
      if (!arraySome_default(other, function(othValue2, othIndex) {
        if (!cacheHas_default(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack))) {
          return seen.push(othIndex);
        }
      })) {
        result = false;
        break;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
      result = false;
      break;
    }
  }
  stack["delete"](array4);
  stack["delete"](other);
  return result;
}
var equalArrays_default = equalArrays;

// ../../node_modules/lodash-es/_mapToArray.js
function mapToArray(map) {
  var index3 = -1, result = Array(map.size);
  map.forEach(function(value, key2) {
    result[++index3] = [key2, value];
  });
  return result;
}
var mapToArray_default = mapToArray;

// ../../node_modules/lodash-es/_setToArray.js
function setToArray(set4) {
  var index3 = -1, result = Array(set4.size);
  set4.forEach(function(value) {
    result[++index3] = value;
  });
  return result;
}
var setToArray_default = setToArray;

// ../../node_modules/lodash-es/_equalByTag.js
var COMPARE_PARTIAL_FLAG2 = 1;
var COMPARE_UNORDERED_FLAG2 = 2;
var boolTag4 = "[object Boolean]";
var dateTag4 = "[object Date]";
var errorTag3 = "[object Error]";
var mapTag6 = "[object Map]";
var numberTag4 = "[object Number]";
var regexpTag4 = "[object RegExp]";
var setTag6 = "[object Set]";
var stringTag4 = "[object String]";
var symbolTag4 = "[object Symbol]";
var arrayBufferTag4 = "[object ArrayBuffer]";
var dataViewTag5 = "[object DataView]";
var symbolProto3 = Symbol_default ? Symbol_default.prototype : void 0;
var symbolValueOf2 = symbolProto3 ? symbolProto3.valueOf : void 0;
function equalByTag(object4, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag5:
      if (object4.byteLength != other.byteLength || object4.byteOffset != other.byteOffset) {
        return false;
      }
      object4 = object4.buffer;
      other = other.buffer;
    case arrayBufferTag4:
      if (object4.byteLength != other.byteLength || !equalFunc(new Uint8Array_default(object4), new Uint8Array_default(other))) {
        return false;
      }
      return true;
    case boolTag4:
    case dateTag4:
    case numberTag4:
      return eq_default(+object4, +other);
    case errorTag3:
      return object4.name == other.name && object4.message == other.message;
    case regexpTag4:
    case stringTag4:
      return object4 == other + "";
    case mapTag6:
      var convert = mapToArray_default;
    case setTag6:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG2;
      convert || (convert = setToArray_default);
      if (object4.size != other.size && !isPartial) {
        return false;
      }
      var stacked = stack.get(object4);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG2;
      stack.set(object4, other);
      var result = equalArrays_default(convert(object4), convert(other), bitmask, customizer, equalFunc, stack);
      stack["delete"](object4);
      return result;
    case symbolTag4:
      if (symbolValueOf2) {
        return symbolValueOf2.call(object4) == symbolValueOf2.call(other);
      }
  }
  return false;
}
var equalByTag_default = equalByTag;

// ../../node_modules/lodash-es/_equalObjects.js
var COMPARE_PARTIAL_FLAG3 = 1;
var objectProto14 = Object.prototype;
var hasOwnProperty12 = objectProto14.hasOwnProperty;
function equalObjects(object4, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG3, objProps = getAllKeys_default(object4), objLength = objProps.length, othProps = getAllKeys_default(other), othLength = othProps.length;
  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index3 = objLength;
  while (index3--) {
    var key2 = objProps[index3];
    if (!(isPartial ? key2 in other : hasOwnProperty12.call(other, key2))) {
      return false;
    }
  }
  var objStacked = stack.get(object4);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object4;
  }
  var result = true;
  stack.set(object4, other);
  stack.set(other, object4);
  var skipCtor = isPartial;
  while (++index3 < objLength) {
    key2 = objProps[index3];
    var objValue = object4[key2], othValue = other[key2];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, objValue, key2, other, object4, stack) : customizer(objValue, othValue, key2, object4, other, stack);
    }
    if (!(compared === void 0 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key2 == "constructor");
  }
  if (result && !skipCtor) {
    var objCtor = object4.constructor, othCtor = other.constructor;
    if (objCtor != othCtor && ("constructor" in object4 && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack["delete"](object4);
  stack["delete"](other);
  return result;
}
var equalObjects_default = equalObjects;

// ../../node_modules/lodash-es/_baseIsEqualDeep.js
var COMPARE_PARTIAL_FLAG4 = 1;
var argsTag4 = "[object Arguments]";
var arrayTag3 = "[object Array]";
var objectTag4 = "[object Object]";
var objectProto15 = Object.prototype;
var hasOwnProperty13 = objectProto15.hasOwnProperty;
function baseIsEqualDeep(object4, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray_default(object4), othIsArr = isArray_default(other), objTag = objIsArr ? arrayTag3 : getTag_default(object4), othTag = othIsArr ? arrayTag3 : getTag_default(other);
  objTag = objTag == argsTag4 ? objectTag4 : objTag;
  othTag = othTag == argsTag4 ? objectTag4 : othTag;
  var objIsObj = objTag == objectTag4, othIsObj = othTag == objectTag4, isSameTag = objTag == othTag;
  if (isSameTag && isBuffer_default(object4)) {
    if (!isBuffer_default(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack_default());
    return objIsArr || isTypedArray_default(object4) ? equalArrays_default(object4, other, bitmask, customizer, equalFunc, stack) : equalByTag_default(object4, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG4)) {
    var objIsWrapped = objIsObj && hasOwnProperty13.call(object4, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty13.call(other, "__wrapped__");
    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object4.value() : object4, othUnwrapped = othIsWrapped ? other.value() : other;
      stack || (stack = new Stack_default());
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack_default());
  return equalObjects_default(object4, other, bitmask, customizer, equalFunc, stack);
}
var baseIsEqualDeep_default = baseIsEqualDeep;

// ../../node_modules/lodash-es/_baseIsEqual.js
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || !isObjectLike_default(value) && !isObjectLike_default(other)) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep_default(value, other, bitmask, customizer, baseIsEqual, stack);
}
var baseIsEqual_default = baseIsEqual;

// ../../node_modules/lodash-es/_baseIsMatch.js
var COMPARE_PARTIAL_FLAG5 = 1;
var COMPARE_UNORDERED_FLAG3 = 2;
function baseIsMatch(object4, source, matchData, customizer) {
  var index3 = matchData.length, length2 = index3, noCustomizer = !customizer;
  if (object4 == null) {
    return !length2;
  }
  object4 = Object(object4);
  while (index3--) {
    var data2 = matchData[index3];
    if (noCustomizer && data2[2] ? data2[1] !== object4[data2[0]] : !(data2[0] in object4)) {
      return false;
    }
  }
  while (++index3 < length2) {
    data2 = matchData[index3];
    var key2 = data2[0], objValue = object4[key2], srcValue = data2[1];
    if (noCustomizer && data2[2]) {
      if (objValue === void 0 && !(key2 in object4)) {
        return false;
      }
    } else {
      var stack = new Stack_default();
      if (customizer) {
        var result = customizer(objValue, srcValue, key2, object4, source, stack);
      }
      if (!(result === void 0 ? baseIsEqual_default(srcValue, objValue, COMPARE_PARTIAL_FLAG5 | COMPARE_UNORDERED_FLAG3, customizer, stack) : result)) {
        return false;
      }
    }
  }
  return true;
}
var baseIsMatch_default = baseIsMatch;

// ../../node_modules/lodash-es/_isStrictComparable.js
function isStrictComparable(value) {
  return value === value && !isObject_default(value);
}
var isStrictComparable_default = isStrictComparable;

// ../../node_modules/lodash-es/_getMatchData.js
function getMatchData(object4) {
  var result = keys_default(object4), length2 = result.length;
  while (length2--) {
    var key2 = result[length2], value = object4[key2];
    result[length2] = [key2, value, isStrictComparable_default(value)];
  }
  return result;
}
var getMatchData_default = getMatchData;

// ../../node_modules/lodash-es/_matchesStrictComparable.js
function matchesStrictComparable(key2, srcValue) {
  return function(object4) {
    if (object4 == null) {
      return false;
    }
    return object4[key2] === srcValue && (srcValue !== void 0 || key2 in Object(object4));
  };
}
var matchesStrictComparable_default = matchesStrictComparable;

// ../../node_modules/lodash-es/_baseMatches.js
function baseMatches(source) {
  var matchData = getMatchData_default(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable_default(matchData[0][0], matchData[0][1]);
  }
  return function(object4) {
    return object4 === source || baseIsMatch_default(object4, source, matchData);
  };
}
var baseMatches_default = baseMatches;

// ../../node_modules/lodash-es/_baseHasIn.js
function baseHasIn(object4, key2) {
  return object4 != null && key2 in Object(object4);
}
var baseHasIn_default = baseHasIn;

// ../../node_modules/lodash-es/_hasPath.js
function hasPath(object4, path2, hasFunc) {
  path2 = castPath_default(path2, object4);
  var index3 = -1, length2 = path2.length, result = false;
  while (++index3 < length2) {
    var key2 = toKey_default(path2[index3]);
    if (!(result = object4 != null && hasFunc(object4, key2))) {
      break;
    }
    object4 = object4[key2];
  }
  if (result || ++index3 != length2) {
    return result;
  }
  length2 = object4 == null ? 0 : object4.length;
  return !!length2 && isLength_default(length2) && isIndex_default(key2, length2) && (isArray_default(object4) || isArguments_default(object4));
}
var hasPath_default = hasPath;

// ../../node_modules/lodash-es/hasIn.js
function hasIn(object4, path2) {
  return object4 != null && hasPath_default(object4, path2, baseHasIn_default);
}
var hasIn_default = hasIn;

// ../../node_modules/lodash-es/_baseMatchesProperty.js
var COMPARE_PARTIAL_FLAG6 = 1;
var COMPARE_UNORDERED_FLAG4 = 2;
function baseMatchesProperty(path2, srcValue) {
  if (isKey_default(path2) && isStrictComparable_default(srcValue)) {
    return matchesStrictComparable_default(toKey_default(path2), srcValue);
  }
  return function(object4) {
    var objValue = get_default(object4, path2);
    return objValue === void 0 && objValue === srcValue ? hasIn_default(object4, path2) : baseIsEqual_default(srcValue, objValue, COMPARE_PARTIAL_FLAG6 | COMPARE_UNORDERED_FLAG4);
  };
}
var baseMatchesProperty_default = baseMatchesProperty;

// ../../node_modules/lodash-es/_baseProperty.js
function baseProperty(key2) {
  return function(object4) {
    return object4 == null ? void 0 : object4[key2];
  };
}
var baseProperty_default = baseProperty;

// ../../node_modules/lodash-es/_basePropertyDeep.js
function basePropertyDeep(path2) {
  return function(object4) {
    return baseGet_default(object4, path2);
  };
}
var basePropertyDeep_default = basePropertyDeep;

// ../../node_modules/lodash-es/property.js
function property(path2) {
  return isKey_default(path2) ? baseProperty_default(toKey_default(path2)) : basePropertyDeep_default(path2);
}
var property_default = property;

// ../../node_modules/lodash-es/_baseIteratee.js
function baseIteratee(value) {
  if (typeof value == "function") {
    return value;
  }
  if (value == null) {
    return identity_default;
  }
  if (typeof value == "object") {
    return isArray_default(value) ? baseMatchesProperty_default(value[0], value[1]) : baseMatches_default(value);
  }
  return property_default(value);
}
var baseIteratee_default = baseIteratee;

// ../../node_modules/lodash-es/_createBaseFor.js
function createBaseFor(fromRight) {
  return function(object4, iteratee, keysFunc) {
    var index3 = -1, iterable = Object(object4), props = keysFunc(object4), length2 = props.length;
    while (length2--) {
      var key2 = props[fromRight ? length2 : ++index3];
      if (iteratee(iterable[key2], key2, iterable) === false) {
        break;
      }
    }
    return object4;
  };
}
var createBaseFor_default = createBaseFor;

// ../../node_modules/lodash-es/_baseFor.js
var baseFor = createBaseFor_default();
var baseFor_default = baseFor;

// ../../node_modules/lodash-es/_baseForOwn.js
function baseForOwn(object4, iteratee) {
  return object4 && baseFor_default(object4, iteratee, keys_default);
}
var baseForOwn_default = baseForOwn;

// ../../node_modules/lodash-es/_createBaseEach.js
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike_default(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length2 = collection.length, index3 = fromRight ? length2 : -1, iterable = Object(collection);
    while (fromRight ? index3-- : ++index3 < length2) {
      if (iteratee(iterable[index3], index3, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}
var createBaseEach_default = createBaseEach;

// ../../node_modules/lodash-es/_baseEach.js
var baseEach = createBaseEach_default(baseForOwn_default);
var baseEach_default = baseEach;

// ../../node_modules/lodash-es/now.js
var now2 = function() {
  return root_default.Date.now();
};
var now_default = now2;

// ../../node_modules/lodash-es/debounce.js
var FUNC_ERROR_TEXT2 = "Expected a function";
var nativeMax = Math.max;
var nativeMin = Math.min;
function debounce3(func, wait, options) {
  var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
  if (typeof func != "function") {
    throw new TypeError(FUNC_ERROR_TEXT2);
  }
  wait = toNumber_default(wait) || 0;
  if (isObject_default(options)) {
    leading = !!options.leading;
    maxing = "maxWait" in options;
    maxWait = maxing ? nativeMax(toNumber_default(options.maxWait) || 0, wait) : maxWait;
    trailing = "trailing" in options ? !!options.trailing : trailing;
  }
  function invokeFunc(time) {
    var args = lastArgs, thisArg = lastThis;
    lastArgs = lastThis = void 0;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }
  function leadingEdge(time) {
    lastInvokeTime = time;
    timerId = setTimeout(timerExpired, wait);
    return leading ? invokeFunc(time) : result;
  }
  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
    return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
  }
  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
    return lastCallTime === void 0 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }
  function timerExpired() {
    var time = now_default();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    timerId = setTimeout(timerExpired, remainingWait(time));
  }
  function trailingEdge(time) {
    timerId = void 0;
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = void 0;
    return result;
  }
  function cancel() {
    if (timerId !== void 0) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = void 0;
  }
  function flush() {
    return timerId === void 0 ? result : trailingEdge(now_default());
  }
  function debounced() {
    var time = now_default(), isInvoking = shouldInvoke(time);
    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;
    if (isInvoking) {
      if (timerId === void 0) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === void 0) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}
var debounce_default = debounce3;

// ../../node_modules/lodash-es/last.js
function last(array4) {
  var length2 = array4 == null ? 0 : array4.length;
  return length2 ? array4[length2 - 1] : void 0;
}
var last_default = last;

// ../../node_modules/lodash-es/_baseHas.js
var objectProto16 = Object.prototype;
var hasOwnProperty14 = objectProto16.hasOwnProperty;
function baseHas(object4, key2) {
  return object4 != null && hasOwnProperty14.call(object4, key2);
}
var baseHas_default = baseHas;

// ../../node_modules/lodash-es/has.js
function has(object4, path2) {
  return object4 != null && hasPath_default(object4, path2, baseHas_default);
}
var has_default = has;

// ../../node_modules/lodash-es/_parent.js
function parent(object4, path2) {
  return path2.length < 2 ? object4 : baseGet_default(object4, baseSlice_default(path2, 0, -1));
}
var parent_default = parent;

// ../../node_modules/lodash-es/isMatch.js
function isMatch(object4, source) {
  return object4 === source || baseIsMatch_default(object4, source, getMatchData_default(source));
}
var isMatch_default = isMatch;

// ../../node_modules/lodash-es/isUndefined.js
function isUndefined(value) {
  return value === void 0;
}
var isUndefined_default = isUndefined;

// ../../node_modules/lodash-es/negate.js
var FUNC_ERROR_TEXT3 = "Expected a function";
function negate(predicate) {
  if (typeof predicate != "function") {
    throw new TypeError(FUNC_ERROR_TEXT3);
  }
  return function() {
    var args = arguments;
    switch (args.length) {
      case 0:
        return !predicate.call(this);
      case 1:
        return !predicate.call(this, args[0]);
      case 2:
        return !predicate.call(this, args[0], args[1]);
      case 3:
        return !predicate.call(this, args[0], args[1], args[2]);
    }
    return !predicate.apply(this, args);
  };
}
var negate_default = negate;

// ../../node_modules/lodash-es/_baseUnset.js
function baseUnset(object4, path2) {
  path2 = castPath_default(path2, object4);
  object4 = parent_default(object4, path2);
  return object4 == null || delete object4[toKey_default(last_default(path2))];
}
var baseUnset_default = baseUnset;

// ../../node_modules/lodash-es/_baseSet.js
function baseSet(object4, path2, value, customizer) {
  if (!isObject_default(object4)) {
    return object4;
  }
  path2 = castPath_default(path2, object4);
  var index3 = -1, length2 = path2.length, lastIndex = length2 - 1, nested = object4;
  while (nested != null && ++index3 < length2) {
    var key2 = toKey_default(path2[index3]), newValue = value;
    if (key2 === "__proto__" || key2 === "constructor" || key2 === "prototype") {
      return object4;
    }
    if (index3 != lastIndex) {
      var objValue = nested[key2];
      newValue = customizer ? customizer(objValue, key2, nested) : void 0;
      if (newValue === void 0) {
        newValue = isObject_default(objValue) ? objValue : isIndex_default(path2[index3 + 1]) ? [] : {};
      }
    }
    assignValue_default(nested, key2, newValue);
    nested = nested[key2];
  }
  return object4;
}
var baseSet_default = baseSet;

// ../../node_modules/lodash-es/_basePickBy.js
function basePickBy(object4, paths, predicate) {
  var index3 = -1, length2 = paths.length, result = {};
  while (++index3 < length2) {
    var path2 = paths[index3], value = baseGet_default(object4, path2);
    if (predicate(value, path2)) {
      baseSet_default(result, castPath_default(path2, object4), value);
    }
  }
  return result;
}
var basePickBy_default = basePickBy;

// ../../node_modules/lodash-es/pickBy.js
function pickBy(object4, predicate) {
  if (object4 == null) {
    return {};
  }
  var props = arrayMap_default(getAllKeysIn_default(object4), function(prop) {
    return [prop];
  });
  predicate = baseIteratee_default(predicate);
  return basePickBy_default(object4, props, function(value, path2) {
    return predicate(value, path2[0]);
  });
}
var pickBy_default = pickBy;

// ../../node_modules/lodash-es/omitBy.js
function omitBy(object4, predicate) {
  return pickBy_default(object4, negate_default(baseIteratee_default(predicate)));
}
var omitBy_default = omitBy;

// ../../node_modules/lodash-es/set.js
function set3(object4, path2, value) {
  return object4 == null ? object4 : baseSet_default(object4, path2, value);
}
var set_default = set3;

// ../../node_modules/lodash-es/_baseSome.js
function baseSome(collection, predicate) {
  var result;
  baseEach_default(collection, function(value, index3, collection2) {
    result = predicate(value, index3, collection2);
    return !result;
  });
  return !!result;
}
var baseSome_default = baseSome;

// ../../node_modules/lodash-es/some.js
function some(collection, predicate, guard) {
  var func = isArray_default(collection) ? arraySome_default : baseSome_default;
  if (guard && isIterateeCall_default(collection, predicate, guard)) {
    predicate = void 0;
  }
  return func(collection, baseIteratee_default(predicate, 3));
}
var some_default = some;

// ../../node_modules/lodash-es/unset.js
function unset(object4, path2) {
  return object4 == null ? true : baseUnset_default(object4, path2);
}
var unset_default = unset;

// ../../node_modules/zustand/esm/vanilla.mjs
var createStoreImpl = (createState) => {
  let state;
  const listeners = /* @__PURE__ */ new Set();
  const setState = (partial, replace2) => {
    const nextState = typeof partial === "function" ? partial(state) : partial;
    if (!Object.is(nextState, state)) {
      const previousState = state;
      state = (replace2 != null ? replace2 : typeof nextState !== "object" || nextState === null) ? nextState : Object.assign({}, state, nextState);
      listeners.forEach((listener) => listener(state, previousState));
    }
  };
  const getState = () => state;
  const getInitialState2 = () => initialState;
  const subscribe = (listener) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
  };
  const destroy2 = () => {
    if ((import.meta.env ? import.meta.env.MODE : void 0) !== "production") {
      console.warn(
        "[DEPRECATED] The `destroy` method will be unsupported in a future version. Instead use unsubscribe function returned by subscribe. Everything will be garbage-collected if store is garbage-collected."
      );
    }
    listeners.clear();
  };
  const api = { setState, getState, getInitialState: getInitialState2, subscribe, destroy: destroy2 };
  const initialState = state = createState(setState, getState, api);
  return api;
};
var createStore = (createState) => createState ? createStoreImpl(createState) : createStoreImpl;

// ../../node_modules/zustand/esm/index.mjs
var import_react163 = __toESM(require_react(), 1);
var import_with_selector = __toESM(require_with_selector(), 1);
var { useDebugValue: useDebugValue2 } = import_react163.default;
var { useSyncExternalStoreWithSelector } = import_with_selector.default;
var didWarnAboutEqualityFn = false;
var identity2 = (arg) => arg;
function useStore(api, selector = identity2, equalityFn) {
  if ((import.meta.env ? import.meta.env.MODE : void 0) !== "production" && equalityFn && !didWarnAboutEqualityFn) {
    console.warn(
      "[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937"
    );
    didWarnAboutEqualityFn = true;
  }
  const slice2 = useSyncExternalStoreWithSelector(
    api.subscribe,
    api.getState,
    api.getServerState || api.getInitialState,
    selector,
    equalityFn
  );
  useDebugValue2(slice2);
  return slice2;
}

// ../../node_modules/form-render/es/models/context.js
var import_react164 = __toESM(require_react());
var FRContext = /* @__PURE__ */ (0, import_react164.createContext)(null);
var ConfigContext2 = /* @__PURE__ */ (0, import_react164.createContext)(null);

// ../../node_modules/form-render/es/models/transformProps.js
var displayTypeEnum = {
  column: "vertical",
  row: "horizontal",
  inline: "inline"
};
var transformProps = function transformProps2(props) {
  var schema = props.schema, beforeFinish = props.beforeFinish, onMount = props.onMount, _props$displayType = props.displayType, displayType = _props$displayType === void 0 ? "column" : _props$displayType, watch = props.watch, _props$removeHiddenDa = props.removeHiddenData, removeHiddenData = _props$removeHiddenDa === void 0 ? true : _props$removeHiddenDa, readOnly = props.readOnly, _props$column = props.column, column2 = _props$column === void 0 ? 1 : _props$column, mapping2 = props.mapping, debugCss = props.debugCss, locale6 = props.locale, configProvider = props.configProvider, validateMessages = props.validateMessages, debug = props.debug, id = props.id, labelWidth = props.labelWidth, maxWidth = props.maxWidth, form = props.form, onFinish = props.onFinish, onFinishFailed = props.onFinishFailed, footer = props.footer, operateExtra = props.operateExtra, logOnMount = props.logOnMount, logOnSubmit = props.logOnSubmit, labelCol = props.labelCol, fieldCol = props.fieldCol, disabled = props.disabled, className2 = props.className, validateTrigger = props.validateTrigger, antdVersion = props.antdVersion, otherProps = __rest(props, ["schema", "beforeFinish", "onMount", "displayType", "watch", "removeHiddenData", "readOnly", "column", "mapping", "debugCss", "locale", "configProvider", "validateMessages", "debug", "id", "labelWidth", "maxWidth", "form", "onFinish", "onFinishFailed", "footer", "operateExtra", "logOnMount", "logOnSubmit", "labelCol", "fieldCol", "disabled", "className", "validateTrigger", "antdVersion"]);
  var formProps = Object.assign({}, otherProps);
  if (displayType) {
    formProps.layout = displayTypeEnum[displayType] || "horizontal";
  }
  return {
    formProps,
    schema,
    displayType,
    onFinish,
    beforeFinish,
    onMount,
    watch,
    readOnly,
    disabled,
    column: column2,
    mapping: mapping2,
    debugCss,
    locale: locale6,
    configProvider,
    footer,
    form,
    labelWidth,
    validateMessages,
    debug,
    id,
    onFinishFailed,
    removeHiddenData,
    operateExtra,
    logOnMount,
    logOnSubmit,
    labelCol,
    fieldCol,
    maxWidth,
    className: className2,
    validateTrigger,
    antdVersion
  };
};
var transformProps_default = transformProps;

// ../../node_modules/form-render/es/utils/index.js
var _set = set_default;
var _get = get_default;
var _cloneDeep = cloneDeep_default;
var _some = some_default;
var _isMatch = isMatch_default;
var isObject3 = function isObject4(data2) {
  var str = Object.prototype.toString.call(data2);
  return str.indexOf("Object") > -1;
};
var isArray3 = function isArray4(data2) {
  var str = Object.prototype.toString.call(data2);
  return str.indexOf("Array") > -1;
};
var isFunction2 = function isFunction3(data2) {
  return typeof data2 === "function";
};
function isUrl(string3) {
  var protocolRE = /^(?:\w+:)?\/\/(\S+)$/;
  if (typeof string3 !== "string") return false;
  return protocolRE.test(string3);
}
var isNumber = function isNumber2(str) {
  return !isNaN(Number(str));
};
var getArray = function getArray2(arr) {
  var defaultValue2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  if (Array.isArray(arr)) return arr;
  return defaultValue2;
};
function isObjType(schema) {
  return (schema === null || schema === void 0 ? void 0 : schema.type) === "object" && (schema === null || schema === void 0 ? void 0 : schema.properties) && (schema === null || schema === void 0 ? void 0 : schema.widgetType) !== "field";
}
function isListType(schema) {
  return (schema === null || schema === void 0 ? void 0 : schema.type) === "array" && isObjType(schema === null || schema === void 0 ? void 0 : schema.items) && (schema === null || schema === void 0 ? void 0 : schema.enum) === void 0;
}
function isCheckBoxType(schema, readOnly) {
  if (readOnly) return false;
  if (schema.widget === "checkbox") return true;
  if (schema && schema.type === "boolean") {
    if (schema.enum) return false;
    if (schema.widget === void 0) return true;
    return false;
  }
}
var translation = function translation2(configCtx) {
  return function(key2) {
    var locale6 = configCtx === null || configCtx === void 0 ? void 0 : configCtx.locale.FormRender;
    return locale6[key2];
  };
};
var _hasFuncProperty = function hasFuncProperty(obj) {
  return _some(obj, function(value) {
    if (isFunction2(value)) {
      return true;
    }
    if (isObject3(value)) {
      return _hasFuncProperty(value);
    }
    return false;
  });
};
var safeGet = function safeGet2(object4, path2, defaultValue2) {
  var _a;
  return (_a = get_default(object4, path2, defaultValue2)) !== null && _a !== void 0 ? _a : defaultValue2;
};

// ../../node_modules/form-render/es/models/bindValues.js
function _typeof2(o3) {
  "@babel/helpers - typeof";
  return _typeof2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o4) {
    return typeof o4;
  } : function(o4) {
    return o4 && "function" == typeof Symbol && o4.constructor === Symbol && o4 !== Symbol.prototype ? "symbol" : typeof o4;
  }, _typeof2(o3);
}
function _defineProperty2(e3, r2, t2) {
  return (r2 = _toPropertyKey(r2)) in e3 ? Object.defineProperty(e3, r2, { value: t2, enumerable: true, configurable: true, writable: true }) : e3[r2] = t2, e3;
}
function _toPropertyKey(t2) {
  var i = _toPrimitive(t2, "string");
  return "symbol" == _typeof2(i) ? i : i + "";
}
function _toPrimitive(t2, r2) {
  if ("object" != _typeof2(t2) || !t2) return t2;
  var e3 = t2[Symbol.toPrimitive];
  if (void 0 !== e3) {
    var i = e3.call(t2, r2 || "default");
    if ("object" != _typeof2(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t2);
}
function _toConsumableArray2(r2) {
  return _arrayWithoutHoles2(r2) || _iterableToArray2(r2) || _unsupportedIterableToArray2(r2) || _nonIterableSpread2();
}
function _nonIterableSpread2() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _arrayWithoutHoles2(r2) {
  if (Array.isArray(r2)) return _arrayLikeToArray2(r2);
}
function _toArray2(r2) {
  return _arrayWithHoles2(r2) || _iterableToArray2(r2) || _unsupportedIterableToArray2(r2) || _nonIterableRest2();
}
function _nonIterableRest2() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray2(r2, a) {
  if (r2) {
    if ("string" == typeof r2) return _arrayLikeToArray2(r2, a);
    var t2 = {}.toString.call(r2).slice(8, -1);
    return "Object" === t2 && r2.constructor && (t2 = r2.constructor.name), "Map" === t2 || "Set" === t2 ? Array.from(r2) : "Arguments" === t2 || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t2) ? _arrayLikeToArray2(r2, a) : void 0;
  }
}
function _arrayLikeToArray2(r2, a) {
  (null == a || a > r2.length) && (a = r2.length);
  for (var e3 = 0, n2 = Array(a); e3 < a; e3++) n2[e3] = r2[e3];
  return n2;
}
function _iterableToArray2(r2) {
  if ("undefined" != typeof Symbol && null != r2[Symbol.iterator] || null != r2["@@iterator"]) return Array.from(r2);
}
function _arrayWithHoles2(r2) {
  if (Array.isArray(r2)) return r2;
}
var isMultiBind = function isMultiBind2(array4) {
  return isArray3(array4) && array4.every(function(item) {
    return typeof item === "string";
  });
};
var transformPath = function transformPath2(path2) {
  var result = [];
  var _recursion = function recursion(str) {
    var index3 = str.indexOf("[]");
    if (index3 === -1) {
      result.push(str);
      return;
    }
    result.push(str.substring(0, index3));
    _recursion(str.substring(index3 + 3));
  };
  _recursion(path2);
  if (result.length === 1) {
    return result[0];
  }
  return result;
};
var transformValueToBind = function transformValueToBind2(data2, path2, bind) {
  if (bind === false) {
    unset_default(data2, path2);
    return;
  }
  if (typeof bind === "string") {
    var value = get_default(data2, path2);
    var preValue = get_default(data2, bind);
    if (isObject3(preValue)) {
      value = Object.assign(Object.assign({}, preValue), value);
    }
    set_default(data2, bind, value);
    unset_default(data2, path2);
    return;
  }
  if (isMultiBind(bind)) {
    var _value = get_default(data2, path2);
    unset_default(data2, path2);
    if (Array.isArray(_value)) {
      _value.forEach(function(item, index3) {
        var bindPath = bind[index3];
        bindPath && set_default(data2, bindPath, item);
      });
    }
  }
};
var transformBindToValue = function transformBindToValue2(data2, path2, bind) {
  if (typeof bind === "string") {
    var value = get_default(data2, bind);
    var preValue = get_default(data2, path2);
    if (isObject3(preValue)) {
      value = Object.assign(Object.assign({}, preValue), value);
    }
    set_default(data2, path2, value);
    unset_default(data2, bind);
    return;
  }
  if (isMultiBind(bind)) {
    var _value2 = [];
    bind.forEach(function(key2) {
      var bindValue = get_default(data2, key2);
      _value2.push(bindValue);
      unset_default(data2, key2);
    });
    if (_value2.length > 0) {
      set_default(data2, path2, _value2);
    }
  }
};
var parseValuesToBind = function parseValuesToBind2(values, flatten2) {
  if (!JSON.stringify(flatten2).includes("bind")) {
    return values;
  }
  var data2 = _cloneDeep(values);
  var _dealFieldList = function dealFieldList(obj, _ref, bind) {
    var _ref2 = _toArray2(_ref), path2 = _ref2[0], rest = _ref2.slice(1);
    if (rest.length === 1) {
      var list = get_default(obj, path2, []) || [];
      list.forEach(function(item, index3) {
        var value2 = get_default(item, rest[0]);
        if (bind === "root") {
          list[index3] = value2;
          return;
        }
        transformValueToBind(item, rest[0], bind);
      });
    }
    if (isArray3(obj)) {
      obj.forEach(function(item) {
        return _dealFieldList(item, [path2].concat(_toConsumableArray2(rest)), bind);
      });
    } else if (isObject3(obj)) {
      var value = get_default(obj, path2);
      _dealFieldList(value, rest, bind);
    }
  };
  Object.keys(flatten2).forEach(function(key2) {
    var _a, _b;
    var bind = (_b = (_a = flatten2[key2]) === null || _a === void 0 ? void 0 : _a.schema) === null || _b === void 0 ? void 0 : _b.bind;
    if (bind === void 0) {
      return;
    }
    var path2 = transformPath(key2);
    isArray3(path2) ? _dealFieldList(data2, path2, bind) : transformValueToBind(data2, path2, bind);
  });
  return data2;
};
var parseBindToValues = function parseBindToValues2(values, flatten2) {
  if (!JSON.stringify(flatten2).includes("bind")) {
    return values;
  }
  var data2 = _cloneDeep(values);
  var _dealFieldList2 = function dealFieldList(obj, _ref3, bind) {
    var _ref4 = _toArray2(_ref3), path2 = _ref4[0], rest = _ref4.slice(1);
    if (rest.length === 1) {
      var list = safeGet(obj, path2, []);
      list.forEach(function(item, index3) {
        if (bind === "root") {
          list[index3] = _defineProperty2({}, rest[0], item);
          return;
        }
        transformBindToValue(item, rest[0], bind);
      });
    }
    if (isArray3(obj)) {
      obj.forEach(function(item) {
        return _dealFieldList2(item, [path2].concat(_toConsumableArray2(rest)), bind);
      });
    } else if (isObject3(obj)) {
      var value = get_default(obj, path2);
      _dealFieldList2(value, rest, bind);
    }
  };
  Object.keys(flatten2).forEach(function(key2) {
    var _a, _b;
    var bind = (_b = (_a = flatten2[key2]) === null || _a === void 0 ? void 0 : _a.schema) === null || _b === void 0 ? void 0 : _b.bind;
    if (bind === void 0) {
      return;
    }
    var path2 = transformPath(key2);
    isArray3(path2) ? _dealFieldList2(data2, path2, bind) : transformBindToValue(data2, path2, bind);
  });
  return data2;
};

// ../../node_modules/form-render/es/models/filterValuesHidden.js
var transformHidden = function transformHidden2(str) {
  var formData = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var parentData = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (typeof str !== "string") {
    return !!str;
  }
  var funcBody = str.replace(/^{\s*{/g, "").replace(/}\s*}$/g, "").trim();
  var funcStr = "\n    return ".concat(funcBody.replace(/formData/g, JSON.stringify(formData)).replace(/rootValue/g, JSON.stringify(parentData)), "\n  ");
  try {
    var result = Function(funcStr)();
    return result;
  } catch (error2) {
    return false;
  }
};
var filterValuesHidden_default = (function(_values, flattenSchema2) {
  var recursiveArray = function recursiveArray2(list, _path) {
    return list.map(function(item) {
      if (isObject3(item)) {
        return _recursiveObj(item, _path, item);
      }
      return item;
    });
  };
  var _recursiveObj = function recursiveObj(obj, prePath, parentData) {
    var _a, _b;
    for (var _i = 0, _Object$keys = Object.keys(obj); _i < _Object$keys.length; _i++) {
      var key2 = _Object$keys[_i];
      var item = obj[key2];
      var path2 = prePath ? "".concat(prePath, ".").concat(key2) : key2;
      var schema = (_a = flattenSchema2[path2]) === null || _a === void 0 ? void 0 : _a.schema;
      if (isArray3(item) && !schema) {
        path2 = prePath ? "".concat(prePath, ".").concat(key2, "[]") : "".concat(key2, "[]");
        schema = (_b = flattenSchema2[path2]) === null || _b === void 0 ? void 0 : _b.schema;
      }
      if (schema === null || schema === void 0 ? void 0 : schema.hidden) {
        var hidden = transformHidden(schema.hidden, _values, parentData);
        if (hidden) {
          obj[key2] = void 0;
          continue;
        }
      }
      if (isObject3(item)) {
        obj[key2] = _recursiveObj(item, path2, parentData);
        continue;
      }
      if (isArray3(item) && (schema === null || schema === void 0 ? void 0 : schema.items)) {
        obj[key2] = recursiveArray(item, path2) || [];
        continue;
      }
      obj[key2] = item;
    }
    return obj;
  };
  return _recursiveObj(_values) || {};
});

// ../../node_modules/form-render/es/models/filterValuesUndefined.js
var filterValuesUndefined_default = (function(values, notFilter) {
  var _recursiveArray = function recursiveArray(list) {
    var result = list.map(function(item) {
      if (isObject3(item)) {
        return _recursiveObj(item, false);
      }
      if (isArray3(item)) {
        return _recursiveArray(item);
      }
      return item;
    });
    if (Object.keys(result).length === 0) {
      return void 0;
    }
    return result;
  };
  var _recursiveObj = function recursiveObj(_obj) {
    var filter3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    if (_obj._isAMomentObject) {
      return _obj;
    }
    var obj = omitBy_default(_obj, isUndefined_default);
    Object.keys(obj).forEach(function(key2) {
      var item = obj[key2];
      if (isObject3(item)) {
        obj[key2] = _recursiveObj(item);
      }
      if (isArray3(item)) {
        var data2 = _recursiveArray(item);
        obj[key2] = data2;
        if (!notFilter && data2) {
          obj[key2] = data2.filter(function(item2) {
            return item2 !== void 0;
          });
        }
      }
    });
    obj = omitBy_default(obj, isUndefined_default);
    if (Object.keys(obj).length === 0 && filter3) {
      return void 0;
    }
    return obj;
  };
  return _recursiveObj(values) || {};
});

// ../../node_modules/form-render/es/models/layout.js
var getFormItemLayout = function getFormItemLayout2(column2, schema, _ref) {
  var labelWidth = _ref.labelWidth, displayType = _ref.displayType, _labelCol = _ref._labelCol, _fieldCol = _ref._fieldCol;
  var labelCol = {
    span: 5
  };
  var fieldCol = {
    span: 9
  };
  if (column2 === 2) {
    labelCol = {
      span: 6
    };
    fieldCol = {
      span: 14
    };
  }
  if (column2 > 2) {
    labelCol = {
      span: 7
    };
    fieldCol = {
      span: 16
    };
  }
  if (displayType === "column") {
    labelCol = {};
    fieldCol = {};
  }
  if (_labelCol) {
    labelCol = _labelCol;
    if (displayType === "column") {
      labelCol = {};
    }
  }
  if (_fieldCol) {
    fieldCol = _fieldCol;
    if (typeof _fieldCol === "number") {
      fieldCol = {
        span: _fieldCol
      };
    }
  }
  if (displayType === "inline") {
    labelCol = {};
    fieldCol = {};
  }
  if ((labelWidth || labelWidth === 0) && displayType !== "column") {
    labelCol = {
      flex: labelWidth + "px"
    };
    fieldCol = {
      flex: "auto"
    };
  }
  if (schema.cellSpan) {
    fieldCol = {};
  }
  if (schema.labelCol || schema.labelCol === 0) {
    labelCol = schema.labelCol;
  }
  if (schema.fieldCol || schema.fieldCol === 0) {
    fieldCol = schema.fieldCol;
  }
  if (typeof labelCol === "number") {
    labelCol = {
      span: labelCol
    };
  }
  if (typeof fieldCol === "number") {
    fieldCol = {
      span: fieldCol
    };
  }
  return {
    labelCol,
    fieldCol
  };
};

// ../../node_modules/form-render/es/models/formCoreUtils.js
function _toConsumableArray3(r2) {
  return _arrayWithoutHoles3(r2) || _iterableToArray3(r2) || _unsupportedIterableToArray3(r2) || _nonIterableSpread3();
}
function _nonIterableSpread3() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray3(r2, a) {
  if (r2) {
    if ("string" == typeof r2) return _arrayLikeToArray3(r2, a);
    var t2 = {}.toString.call(r2).slice(8, -1);
    return "Object" === t2 && r2.constructor && (t2 = r2.constructor.name), "Map" === t2 || "Set" === t2 ? Array.from(r2) : "Arguments" === t2 || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t2) ? _arrayLikeToArray3(r2, a) : void 0;
  }
}
function _iterableToArray3(r2) {
  if ("undefined" != typeof Symbol && null != r2[Symbol.iterator] || null != r2["@@iterator"]) return Array.from(r2);
}
function _arrayWithoutHoles3(r2) {
  if (Array.isArray(r2)) return _arrayLikeToArray3(r2);
}
function _arrayLikeToArray3(r2, a) {
  (null == a || a > r2.length) && (a = r2.length);
  for (var e3 = 0, n2 = Array(a); e3 < a; e3++) n2[e3] = r2[e3];
  return n2;
}
var executeCallBack = function executeCallBack2(watchItem, value, path2, index3) {
  if (isFunction2(watchItem)) {
    try {
      watchItem(value, index3);
    } catch (error2) {
      console.log("".concat(path2, "\u5BF9\u5E94\u7684watch\u51FD\u6570\u6267\u884C\u62A5\u9519\uFF1A"), error2);
    }
  }
  if (isFunction2(watchItem === null || watchItem === void 0 ? void 0 : watchItem.handler)) {
    try {
      watchItem.handler(value, index3);
    } catch (error2) {
      console.log("".concat(path2, "\u5BF9\u5E94\u7684watch\u51FD\u6570\u6267\u884C\u62A5\u9519\uFF1A"), error2);
    }
  }
};
var traverseValues = function traverseValues2(_ref) {
  var changedValues = _ref.changedValues, allValues = _ref.allValues, flatValues = _ref.flatValues;
  var _traverseArray = function traverseArray(list, fullList, path2, index3) {
    if (!list.length) {
      return;
    }
    var _path = path2 += "[]";
    var filterLength = list.filter(function(item) {
      return item || item === void 0;
    }).length;
    var flag = filterLength !== fullList.length || list.length === 1;
    var isRemove = false;
    if (filterLength > 1 && filterLength < fullList.length) {
      flag = false;
      isRemove = true;
    }
    list.forEach(function(item, idx) {
      if (!isRemove) {
        flatValues[_path] = {
          value: fullList[idx],
          index: index3
        };
      }
      if (isObject3(item)) {
        _traverseObj(item, fullList[idx], _path, [].concat(_toConsumableArray3(index3), [idx]), !flag);
      }
      if (isArray3(item)) {
        _traverseArray(item, fullList[idx], _path, [].concat(_toConsumableArray3(index3), [idx]));
      }
    });
  };
  var _traverseObj = function traverseObj(obj, fullObj, path2, index3, flag) {
    Object.keys(obj).forEach(function(key2) {
      var item = obj[key2];
      var fullItem = fullObj === null || fullObj === void 0 ? void 0 : fullObj[key2];
      var value = item;
      var _path = path2 ? path2 + "." + key2 : key2;
      var last2 = true;
      if (isArray3(item)) {
        value = fullItem ? _toConsumableArray3(fullItem) : fullItem;
        last2 = false;
        _traverseArray(item, fullItem, _path, index3);
      }
      if (isObject3(item)) {
        last2 = false;
        _traverseObj(item, fullItem, _path, index3, flag);
      }
      if (!last2 || !flag) {
        flatValues[_path] = {
          value,
          index: index3
        };
      }
    });
  };
  _traverseObj(changedValues, allValues, null, []);
};
var valuesWatch = function valuesWatch2(changedValues, allValues, watch) {
  var _a;
  if (((_a = Object.keys(watch || {})) === null || _a === void 0 ? void 0 : _a.length) === 0) {
    return;
  }
  var flatValues = {
    "#": {
      value: allValues,
      index: changedValues
    }
  };
  traverseValues({
    changedValues,
    allValues,
    flatValues
  });
  Object.keys(watch).forEach(function(path2) {
    if (!has_default(flatValues, path2)) {
      return;
    }
    var _get2 = _get(flatValues, path2), value = _get2.value, index3 = _get2.index;
    var item = watch[path2];
    executeCallBack(item, value, path2, index3);
  });
};
var transformFieldsData = function transformFieldsData2(_fieldsError, getFieldName3) {
  var fieldsError = _fieldsError;
  if (isObject3(fieldsError)) {
    fieldsError = [fieldsError];
  }
  if (!(isArray3(fieldsError) && fieldsError.length > 0)) {
    return;
  }
  return fieldsError.map(function(field) {
    return Object.assign(Object.assign({
      errors: field.error
    }, field), {
      name: getFieldName3(field.name)
    });
  });
};
var immediateWatch = function immediateWatch2(watch, values) {
  var _a;
  if (((_a = Object.keys(watch || {})) === null || _a === void 0 ? void 0 : _a.length) === 0) {
    return;
  }
  var watchObj = {};
  Object.keys(watch).forEach(function(key2) {
    var watchItem = watch[key2];
    if ((watchItem === null || watchItem === void 0 ? void 0 : watchItem.immediate) && isFunction2(watchItem === null || watchItem === void 0 ? void 0 : watchItem.handler)) {
      watchObj[key2] = watchItem;
    }
  });
  valuesWatch(values, values, watchObj);
};
var getSchemaFullPath = function getSchemaFullPath2(path2, schema) {
  if (!path2 || !path2.includes(".")) {
    return "properties." + path2;
  }
  while (path2.includes("[]")) {
    var index3 = path2.indexOf("[]");
    path2 = path2.substring(0, index3) + ".items" + path2.substring(index3 + 2);
  }
  var result = "properties";
  var pathList = path2.split(".");
  pathList.forEach(function(item, index4) {
    var key2 = result + "." + item;
    var itemSchema = _get(schema, key2, {});
    if (isObjType(itemSchema) && index4 !== pathList.length - 1) {
      result = key2 + ".properties";
      return;
    }
    result = key2;
  });
  return result;
};
function yymmdd(timeStamp) {
  var date_ob = new Date(Number(timeStamp));
  var adjustZero = function adjustZero2(num) {
    return ("0" + num).slice(-2);
  };
  var day = adjustZero(date_ob.getDate());
  var month = adjustZero(date_ob.getMonth());
  var year = date_ob.getFullYear();
  var hours = adjustZero(date_ob.getHours());
  var minutes = adjustZero(date_ob.getMinutes());
  var seconds = adjustZero(date_ob.getSeconds());
  return "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hours, ":").concat(minutes, ":").concat(seconds);
}
function msToTime(duration) {
  var seconds = Math.floor(duration / 1e3 % 60);
  var minutes = Math.floor(duration / (1e3 * 60) % 60);
  var hours = Math.floor(duration / (1e3 * 60 * 60) % 24);
  hours = hours < 10 ? "0" + hours : hours;
  minutes = minutes < 10 ? "0" + minutes : minutes;
  seconds = seconds < 10 ? "0" + seconds : seconds;
  return hours + ":" + minutes + ":" + seconds;
}
var getSessionItem = function getSessionItem2(key2) {
  return Number(sessionStorage.getItem(key2) || 0);
};
var setSessionItem = function setSessionItem2(key2, data2) {
  sessionStorage.setItem(key2, data2 + "");
};

// ../../node_modules/form-render/es/render-core/index.js
var import_react180 = __toESM(require_react());

// ../../node_modules/form-render/es/render-core/FieldItem/index.js
var import_react175 = __toESM(require_react());

// ../../node_modules/form-render/es/render-core/FieldItem/module.js
var import_react165 = __toESM(require_react());
function _toConsumableArray4(r2) {
  return _arrayWithoutHoles4(r2) || _iterableToArray4(r2) || _unsupportedIterableToArray4(r2) || _nonIterableSpread4();
}
function _nonIterableSpread4() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray4(r2, a) {
  if (r2) {
    if ("string" == typeof r2) return _arrayLikeToArray4(r2, a);
    var t2 = {}.toString.call(r2).slice(8, -1);
    return "Object" === t2 && r2.constructor && (t2 = r2.constructor.name), "Map" === t2 || "Set" === t2 ? Array.from(r2) : "Arguments" === t2 || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t2) ? _arrayLikeToArray4(r2, a) : void 0;
  }
}
function _iterableToArray4(r2) {
  if ("undefined" != typeof Symbol && null != r2[Symbol.iterator] || null != r2["@@iterator"]) return Array.from(r2);
}
function _arrayWithoutHoles4(r2) {
  if (Array.isArray(r2)) return _arrayLikeToArray4(r2);
}
function _arrayLikeToArray4(r2, a) {
  (null == a || a > r2.length) && (a = r2.length);
  for (var e3 = 0, n2 = Array(a); e3 < a; e3++) n2[e3] = r2[e3];
  return n2;
}
var _filterHiddenData = function filterHiddenData(list) {
  if (!isArray3(list)) {
    return list;
  }
  var result = [];
  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    if (!item.hidden) {
      var node2 = Object.assign({}, item);
      if (item.children) {
        var children = _filterHiddenData(item.children);
        if (children.length > 0) {
          node2.children = children;
        }
      }
      if (item.items) {
        var items = _filterHiddenData(item.items);
        if (items.length > 0) {
          node2.items = items;
        }
      }
      result.push(node2);
    }
  }
  return result;
};
var getPathObj = function getPathObj2(_ref) {
  var _ref$rootPath = _ref.rootPath, rootPath = _ref$rootPath === void 0 ? [] : _ref$rootPath, path2 = _ref.path;
  var pathList = (path2 || "").split(".");
  var dataIndex = [];
  var schemaIndex = [];
  var dataPathList = [];
  rootPath.forEach(function(item, index3) {
    if (isNumber(item)) {
      dataIndex.push(item);
      return;
    }
    if (isNumber(rootPath[index3 + 1])) {
      schemaIndex.push("".concat(item, "[]"));
    } else {
      schemaIndex.push(item);
    }
  });
  var list = _toConsumableArray4(rootPath);
  list.pop();
  list = [].concat(_toConsumableArray4(list), _toConsumableArray4(pathList));
  list.forEach(function(item, index3) {
    if (isNumber(item)) {
      dataPathList.push("[".concat(item, "]"));
    } else {
      dataPathList.push(item);
    }
  });
  var dataPath = dataPathList.join(".");
  var _path = pathList;
  if (_path[0] && isNumber(_path[0])) {
    _path.splice(0, 1);
  }
  var schemaPath = [].concat(schemaIndex, [_path]).join(".");
  return {
    dataIndex,
    dataPath,
    schemaPath
  };
};
var getPath2 = function getPath3(path2) {
  if (!path2) {
    return null;
  }
  if (isArray3(path2)) {
    return path2.join(".");
  }
  return path2;
};
var getLabel = function getLabel2(schema, displayType, widgets, addons) {
  var title = schema.title, description = schema.description, descWidget = schema.descWidget, labelWidget = schema.labelWidget;
  var LabelNode = widgets[labelWidget];
  if (LabelNode) {
    return /* @__PURE__ */ import_react165.default.createElement(LabelNode, {
      schema,
      addons
    });
  }
  if (!description && !descWidget) {
    return title;
  }
  var RenderDesc = function RenderDesc2() {
    var Widget = widgets[descWidget];
    if (Widget) {
      return /* @__PURE__ */ import_react165.default.createElement(Widget, {
        schema,
        addons
      });
    }
    if (description) {
      return /* @__PURE__ */ import_react165.default.createElement("span", {
        className: "fr-desc"
      }, "(", description, ")");
    }
    return null;
  };
  return /* @__PURE__ */ import_react165.default.createElement(import_react165.default.Fragment, null, title, /* @__PURE__ */ import_react165.default.createElement(RenderDesc, null));
};
var getTooltip = function getTooltip2(schema, displayType) {
  var descType = schema.descType, description = schema.description, tooltip = schema.tooltip;
  if (tooltip) {
    if (typeof tooltip === "string") {
      return {
        title: /* @__PURE__ */ import_react165.default.createElement("span", {
          dangerouslySetInnerHTML: {
            __html: tooltip
          }
        })
      };
    }
    return Object.assign(Object.assign({}, tooltip), {
      title: /* @__PURE__ */ import_react165.default.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: tooltip.title
        }
      })
    });
  }
  if (descType === "widget" || !description) {
    return null;
  }
  if (displayType === "column" && descType === "icon") {
    return {
      title: description
    };
  }
  return null;
};
var getExtraView = function getExtraView2(extraKey, schema, widgets, addons) {
  var extra = schema[extraKey];
  if (!extra) {
    return;
  }
  var widgetName = (extra === null || extra === void 0 ? void 0 : extra.widget) || extra;
  var Widget = widgets[widgetName];
  if (!!Widget) {
    return /* @__PURE__ */ import_react165.default.createElement(Widget, {
      schema,
      addons
    });
  }
  if (!Widget && (extra === null || extra === void 0 ? void 0 : extra.widget)) {
    return;
  }
  var __html = "";
  if (typeof extra === "string") {
    __html = extra;
  }
  if (extra === null || extra === void 0 ? void 0 : extra.text) {
    __html = extra.text;
  }
  if (!__html) {
    return;
  }
  return /* @__PURE__ */ import_react165.default.createElement("div", {
    className: "fr-form-item-extra",
    dangerouslySetInnerHTML: {
      __html
    }
  });
};
var getColSpan = function getColSpan2(formCtx, parentCtx, schema) {
  var span = 24;
  var column2 = getParamValue(formCtx, parentCtx, schema)("column");
  if (column2) {
    span = 24 / column2;
  }
  if (schema.width) {
    if (schema.width === "100%") {
      span = 24;
    } else if (schema.width === "50%") {
      span = 12;
    } else if (schema.width === "20%") {
      span = 5;
    } else if (schema.width < "50%") {
      span = 8;
    }
  }
  if (schema.cellSpan) {
    span = schema.cellSpan * span;
  }
  if (schema.span) {
    span = schema.span;
  }
  return span > 24 ? 24 : span;
};
var getParamValue = function getParamValue2(formCtx, upperCtx, schema) {
  return function(valueKey) {
    var isTop = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    var _a, _b, _c;
    if (isTop) {
      return (_b = (_a = schema[valueKey]) !== null && _a !== void 0 ? _a : upperCtx[valueKey]) !== null && _b !== void 0 ? _b : formCtx[valueKey];
    }
    return (_c = schema[valueKey]) !== null && _c !== void 0 ? _c : upperCtx[valueKey];
  };
};
var getFieldProps = function getFieldProps2(widgetName, schema, _ref2) {
  var widgets = _ref2.widgets, methods2 = _ref2.methods, form = _ref2.form, dependValues = _ref2.dependValues, globalProps = _ref2.globalProps, path2 = _ref2.path, rootPath = _ref2.rootPath, fieldRef = _ref2.fieldRef;
  var _a;
  var pathObj = getPathObj({
    path: path2,
    rootPath
  });
  var fieldProps = Object.assign(Object.assign({}, schema.props), {
    addons: Object.assign(Object.assign(Object.assign({}, form), {
      globalProps,
      dependValues,
      fieldRef
    }), pathObj)
  });
  if ((dependValues === null || dependValues === void 0 ? void 0 : dependValues.length) > 0) {
    fieldProps.dependValues = dependValues;
  }
  ["placeholder", "disabled", "format", "onStatusChange"].forEach(function(key2) {
    if (schema[key2]) {
      fieldProps[key2] = schema[key2];
    }
  });
  if (schema.enum && !((_a = schema.props) === null || _a === void 0 ? void 0 : _a.options)) {
    var enums = schema.enum, enumNames = schema.enumNames;
    fieldProps.options = getArray(enums).map(function(item, index3) {
      var label = enumNames && Array.isArray(enumNames) ? enumNames[index3] : item;
      var isHtml = typeof label === "string" && label[0] === "<";
      if (isHtml) {
        label = /* @__PURE__ */ import_react165.default.createElement("span", {
          dangerouslySetInnerHTML: {
            __html: label
          }
        });
      }
      return {
        label,
        value: item
      };
    });
  }
  if (isArray3(fieldProps.options)) {
    fieldProps = Object.assign(Object.assign({}, fieldProps), {
      options: _filterHiddenData(fieldProps.options)
    });
  }
  Object.keys(schema).forEach(function(key2) {
    if (typeof key2 === "string" && key2.toLowerCase().indexOf("props") > -1 && key2.length > 5) {
      fieldProps[key2] = schema[key2];
    }
  });
  if (isObject3(fieldProps.addonAfter) && fieldProps.addonAfter.widget) {
    var AddonAfterWidget = widgets[fieldProps.addonAfter.widget];
    fieldProps.addonAfter = /* @__PURE__ */ import_react165.default.createElement(AddonAfterWidget, Object.assign({}, schema));
  }
  if (["treeSelect", "inputNumber", "multiSelect", "select"].includes(widgetName)) {
    fieldProps.style = Object.assign({
      width: "100%"
    }, fieldProps.style);
  }
  if (widgetName === "multiSelect") {
    fieldProps.mode = "multiple";
  }
  if (isObject3(schema.methods)) {
    Object.keys(schema.methods).forEach(function(key2) {
      var name = schema.methods[key2];
      fieldProps[key2] = methods2[name];
    });
  }
  fieldProps.schema = schema;
  return fieldProps;
};
var _getDependValues = function getDependValues(formData, dependPath, props, dependencieItem) {
  var indexReg = /\[[0-9]*\]/;
  if (indexReg.test(dependPath)) {
    var currentIndex = _get(props, "path.0");
    var dependIndex = dependPath.match(indexReg)[0].replace("[", "").replace("]", "");
    var listPath = dependPath.split(indexReg)[0];
    var itemIndex = dependIndex || currentIndex;
    var itemPath = dependPath.replace("".concat(listPath, "[").concat(dependIndex, "]."), "");
    var listData = _get(formData, "".concat(listPath, "[").concat(itemIndex, "]"));
    dependencieItem.push(listPath, itemIndex);
    return _getDependValues(listData, itemPath, props, dependencieItem);
  }
  dependencieItem.push.apply(dependencieItem, _toConsumableArray4(dependPath.split(".")));
  return _get(formData, dependPath);
};

// ../../node_modules/form-render/es/models/formDataSkeleton.js
function _typeof3(o3) {
  "@babel/helpers - typeof";
  return _typeof3 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o4) {
    return typeof o4;
  } : function(o4) {
    return o4 && "function" == typeof Symbol && o4.constructor === Symbol && o4 !== Symbol.prototype ? "symbol" : typeof o4;
  }, _typeof3(o3);
}
var _createDataSkeleton = function createDataSkeleton(schema, formData) {
  var _formData = _cloneDeep(formData);
  var result = _formData;
  if (isObjType(schema)) {
    if (_formData === void 0 || _typeof3(_formData) !== "object") {
      _formData = {};
      result = {};
    }
    Object.keys(schema.properties).forEach(function(key2) {
      var childSchema = schema.properties[key2];
      var childData = _formData[key2];
      var childResult = _createDataSkeleton(childSchema, childData);
      result[key2] = childResult;
    });
  } else if (_formData !== void 0) {
  } else if (schema.default !== void 0) {
    result = _cloneDeep(schema.default);
  } else if (isListType(schema)) {
    result = [_createDataSkeleton(schema.items)];
  } else if (schema.type === "boolean" && !schema.widget) {
    result = void 0;
  } else {
    result = void 0;
  }
  return result;
};

// ../../node_modules/form-render/es/models/expression.js
function _toConsumableArray5(r2) {
  return _arrayWithoutHoles5(r2) || _iterableToArray5(r2) || _unsupportedIterableToArray5(r2) || _nonIterableSpread5();
}
function _nonIterableSpread5() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray5(r2, a) {
  if (r2) {
    if ("string" == typeof r2) return _arrayLikeToArray5(r2, a);
    var t2 = {}.toString.call(r2).slice(8, -1);
    return "Object" === t2 && r2.constructor && (t2 = r2.constructor.name), "Map" === t2 || "Set" === t2 ? Array.from(r2) : "Arguments" === t2 || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t2) ? _arrayLikeToArray5(r2, a) : void 0;
  }
}
function _iterableToArray5(r2) {
  if ("undefined" != typeof Symbol && null != r2[Symbol.iterator] || null != r2["@@iterator"]) return Array.from(r2);
}
function _arrayWithoutHoles5(r2) {
  if (Array.isArray(r2)) return _arrayLikeToArray5(r2);
}
function _arrayLikeToArray5(r2, a) {
  (null == a || a > r2.length) && (a = r2.length);
  for (var e3 = 0, n2 = Array(a); e3 < a; e3++) n2[e3] = r2[e3];
  return n2;
}
var isExpression = function isExpression2(str) {
  if (typeof str !== "string") {
    return false;
  }
  var pattern6 = /^{\s*{([^]+)}\s*}$/;
  var reg1 = /^{\s*{function\(.+}\s*}$/;
  return str.match(pattern6) && !str.match(reg1);
};
var _isHasExpression = function isHasExpression(schema) {
  var result = Object.keys(schema).some(function(key2) {
    var item = schema[key2];
    if (key2 === "properties") {
      return false;
    }
    var _recursionArray = function recursionArray(list) {
      var result2 = list.some(function(ite) {
        if (isArray3(ite)) {
          return _recursionArray(ite);
        }
        if (isObject3(ite)) {
          return _isHasExpression(ite);
        }
        return isExpression(ite);
      });
      return result2;
    };
    if (isArray3(item)) {
      return _recursionArray(item);
    }
    if (isObject3(item)) {
      return _isHasExpression(item);
    }
    return isExpression(item);
  });
  return result;
};
var parseFunc = function parseFunc2(funcBody) {
  var funcBodyTemp = funcBody.replace(/(\.|\?\.)/g, "?.");
  var funcBodyStr = funcBodyTemp.replace(/(\d+)\?\.(\d+)/g, "$1.$2");
  var result = _toConsumableArray5(funcBodyStr).reduce(function(acc, char2, index3) {
    if (char2 === "[") {
      if (index3 > 0 && funcBodyStr[index3 - 1] !== "\n") {
        return "".concat(acc, "?.").concat(char2);
      }
    }
    return "".concat(acc).concat(char2);
  }, "");
  return result;
};
var parseExpression = function parseExpression2(func) {
  var formData = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var parentPath = arguments.length > 2 ? arguments[2] : void 0;
  var parentData = get_default(formData, parentPath) || {};
  if (typeof func === "string") {
    var funcBody = func.replace(/^{\s*{/g, "").replace(/}\s*}$/g, "").trim();
    var isHandleData = (funcBody === null || funcBody === void 0 ? void 0 : funcBody.startsWith("formData")) || (funcBody === null || funcBody === void 0 ? void 0 : funcBody.startsWith("rootValue"));
    var funcBodyStr = isHandleData ? parseFunc(funcBody) : funcBody;
    var funcStr = "\n      return ".concat(funcBodyStr.replace(/formData/g, JSON.stringify(formData)).replace(/rootValue/g, JSON.stringify(parentData)), "\n    ");
    try {
      var result = Function(funcStr)();
      return result;
    } catch (error2) {
      console.log(error2, funcStr, parentPath);
      return null;
    }
  }
  return func;
};
var _parseAllExpression = function parseAllExpression(_schema, _formData, dataPath, formSchema) {
  var schema = _cloneDeep(_schema);
  var formData = _formData;
  if (formSchema) {
    formData = _createDataSkeleton(formSchema, formData);
  }
  var _recursionArray2 = function recursionArray(list) {
    var result = list.map(function(item) {
      if (isArray3(item)) {
        return _recursionArray2(item);
      }
      if (isObject3(item)) {
        return _parseAllExpression(item, formData, dataPath);
      }
      if (isExpression(item)) {
        return parseExpression(item, formData, dataPath);
      }
      return item;
    });
    return result;
  };
  Object.keys(schema).forEach(function(key2) {
    var _a;
    var value = schema[key2];
    if (isArray3(value)) {
      schema[key2] = _recursionArray2(value);
    }
    if (isObject3(value) && ((_a = value.mustacheParse) !== null && _a !== void 0 ? _a : true)) {
      schema[key2] = _parseAllExpression(value, formData, dataPath);
    } else if (isExpression(value)) {
      schema[key2] = parseExpression(value, formData, dataPath);
    }
  });
  return schema;
};

// ../../node_modules/form-render/es/models/fieldShouldUpdate.js
var extractFormDataStrings = function extractFormDataStrings2(list) {
  var result = [];
  list.forEach(function(str) {
    var regex = /formData(\.\w+|\[(['"])?\w+\2?\])*(\.\w+)?/g;
    var matches = str.match(regex);
    if (matches) {
      result = result.concat(matches);
    }
  });
  return result;
};
var extractRootValueStrings = function extractRootValueStrings2(list) {
  var result = [];
  list.forEach(function(str) {
    var regex = /rootValue(\.\w+|\[(['"])?\w+\2?\])*(\.\w+)?/g;
    var matches = str.match(regex);
    if (matches) {
      result = result.concat(matches);
    }
  });
  return result;
};
var findStrList = function findStrList2(str, type5) {
  var regex = /{{(.*?)}}/g;
  var matches = [];
  var match2;
  while ((match2 = regex.exec(str)) !== null) {
    matches.push(match2[1]);
  }
  ;
  if (type5 === "formData") {
    return extractFormDataStrings(matches);
  }
  if (type5 === "rootValue") {
    return extractRootValueStrings(matches);
  }
  return [];
};
var getListEveryResult = function getListEveryResult2(list, preValue, nextValue, dataPath) {
  return list.every(function(item) {
    var pre = parseExpression(item, preValue, dataPath);
    var curr = parseExpression(item, nextValue, dataPath);
    return pre === curr;
  });
};
var fieldShouldUpdate_default = (function(str, dataPath, dependencies, shouldUpdateOpen) {
  return function(preValue, nextValue) {
    if (dependencies) {
      return true;
    }
    var formDataList = findStrList(str, "formData");
    var rootValueList = findStrList(str, "rootValue");
    var formDataRes = getListEveryResult(formDataList, preValue, nextValue, dataPath);
    var rootValueRes = getListEveryResult(rootValueList, preValue, nextValue, dataPath);
    if (formDataRes && rootValueRes) {
      return false;
    }
    return true;
  };
});

// ../../node_modules/form-render/es/render-core/FieldItem/main.js
var import_react174 = __toESM(require_react());
var import_classnames206 = __toESM(require_classnames());

// ../../node_modules/form-render/es/models/mapping.js
var mapping = {
  default: "input",
  string: "input",
  array: "list",
  boolean: "checkbox",
  integer: "number",
  number: "inputNumber",
  object: "map",
  html: "html",
  card: "card",
  collapse: "collapse",
  lineTitle: "lineTitle",
  line: "line",
  subItem: "subItem",
  panel: "panel",
  "string:upload": "upload",
  "string:url": "urlInput",
  "string:dateTime": "datePicker",
  "string:date": "datePicker",
  "string:year": "datePicker",
  "string:month": "datePicker",
  "string:week": "datePicker",
  "string:quarter": "datePicker",
  "string:time": "timePicker",
  "string:textarea": "textArea",
  "string:color": "color",
  "string:image": "imageInput",
  "range:time": "timeRange",
  "range:dateTime": "dateRange",
  "range:date": "dateRange",
  "range:year": "dateRange",
  "range:month": "dateRange",
  "range:week": "dateRange",
  "range:quarter": "dateRange",
  "*?enum": "radio",
  "*?enum_long": "select",
  "array?enum": "checkboxes",
  "array?enum_long": "multiSelect",
  "*?readOnly": "html"
  // TODO: html widgets for list / object
};
function getWidgetName(schema) {
  var _mapping = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : mapping;
  var type5 = schema.type, format3 = schema.format, enums = schema.enum, readOnly = schema.readOnly, widget = schema.widget, props = schema.props;
  if (schema["ui:widget"] || schema.widget) {
    return schema["ui:widget"] || schema.widget;
  }
  var list = [];
  if (readOnly) {
    list.push("".concat(type5, "?readOnly"));
    list.push("*?readOnly");
  }
  if (enums) {
    if (Array.isArray(enums) && (type5 === "array" && enums.length > 6 || type5 !== "array" && enums.length > 2)) {
      list.push("".concat(type5, "?enum_long"));
      list.push("*?enum_long");
    } else {
      list.push("".concat(type5, "?enum"));
      list.push("*?enum");
    }
  }
  if (props === null || props === void 0 ? void 0 : props.options) {
    if (type5 === "array" && props.options.length > 6 || type5 !== "array" && props.options.length > 2) {
      list.push("".concat(type5, "?enum_long"));
      list.push("*?enum_long");
    } else {
      list.push("".concat(type5, "?enum"));
      list.push("*?enum");
    }
  }
  var _widget = format3;
  if (_widget) {
    list.push("".concat(type5, ":").concat(_widget));
  }
  if (type5 === "object") {
    list.push((schema.theme === "tile" ? "lineTitle" : schema.theme) || "collapse");
  } else {
    list.push(type5);
  }
  var widgetName = "";
  list.some(function(item) {
    widgetName = _mapping[item];
    return !!widgetName;
  });
  return widgetName;
}
function capitalizeFirstLetter(str) {
  if (!str) {
    return str;
  }
  return str.charAt(0).toUpperCase() + str.slice(1);
}
var getWidget = function getWidget2(name, widgets) {
  var widget = widgets[name];
  if (!widget) {
    widget = widgets[capitalizeFirstLetter(name)];
  }
  if (!widget) {
    widget = widgets["Html"] || null;
  }
  return widget;
};

// ../../node_modules/form-render/es/models/validates.js
var import_color8 = __toESM(require_color());
function _typeof4(o3) {
  "@babel/helpers - typeof";
  return _typeof4 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o4) {
    return typeof o4;
  } : function(o4) {
    return o4 && "function" == typeof Symbol && o4.constructor === Symbol && o4 !== Symbol.prototype ? "symbol" : typeof o4;
  }, _typeof4(o3);
}
function _toConsumableArray6(r2) {
  return _arrayWithoutHoles6(r2) || _iterableToArray6(r2) || _unsupportedIterableToArray6(r2) || _nonIterableSpread6();
}
function _nonIterableSpread6() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray6(r2, a) {
  if (r2) {
    if ("string" == typeof r2) return _arrayLikeToArray6(r2, a);
    var t2 = {}.toString.call(r2).slice(8, -1);
    return "Object" === t2 && r2.constructor && (t2 = r2.constructor.name), "Map" === t2 || "Set" === t2 ? Array.from(r2) : "Arguments" === t2 || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t2) ? _arrayLikeToArray6(r2, a) : void 0;
  }
}
function _iterableToArray6(r2) {
  if ("undefined" != typeof Symbol && null != r2[Symbol.iterator] || null != r2["@@iterator"]) return Array.from(r2);
}
function _arrayWithoutHoles6(r2) {
  if (Array.isArray(r2)) return _arrayLikeToArray6(r2);
}
function _arrayLikeToArray6(r2, a) {
  (null == a || a > r2.length) && (a = r2.length);
  for (var e3 = 0, n2 = Array(a); e3 < a; e3++) n2[e3] = r2[e3];
  return n2;
}
function _regeneratorRuntime2() {
  "use strict";
  _regeneratorRuntime2 = function _regeneratorRuntime6() {
    return e3;
  };
  var t2, e3 = {}, r2 = Object.prototype, n2 = r2.hasOwnProperty, o3 = Object.defineProperty || function(t3, e4, r3) {
    t3[e4] = r3.value;
  }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
  function define2(t3, e4, r3) {
    return Object.defineProperty(t3, e4, { value: r3, enumerable: true, configurable: true, writable: true }), t3[e4];
  }
  try {
    define2({}, "");
  } catch (t3) {
    define2 = function define3(t4, e4, r3) {
      return t4[e4] = r3;
    };
  }
  function wrap(t3, e4, r3, n3) {
    var i2 = e4 && e4.prototype instanceof Generator ? e4 : Generator, a2 = Object.create(i2.prototype), c2 = new Context4(n3 || []);
    return o3(a2, "_invoke", { value: makeInvokeMethod(t3, r3, c2) }), a2;
  }
  function tryCatch(t3, e4, r3) {
    try {
      return { type: "normal", arg: t3.call(e4, r3) };
    } catch (t4) {
      return { type: "throw", arg: t4 };
    }
  }
  e3.wrap = wrap;
  var h2 = "suspendedStart", l2 = "suspendedYield", f = "executing", s = "completed", y = {};
  function Generator() {
  }
  function GeneratorFunction() {
  }
  function GeneratorFunctionPrototype() {
  }
  var p = {};
  define2(p, a, function() {
    return this;
  });
  var d = Object.getPrototypeOf, v = d && d(d(values([])));
  v && v !== r2 && n2.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t3) {
    ["next", "throw", "return"].forEach(function(e4) {
      define2(t3, e4, function(t4) {
        return this._invoke(e4, t4);
      });
    });
  }
  function AsyncIterator3(t3, e4) {
    function invoke(r4, o4, i2, a2) {
      var c2 = tryCatch(t3[r4], t3, o4);
      if ("throw" !== c2.type) {
        var u2 = c2.arg, h3 = u2.value;
        return h3 && "object" == _typeof4(h3) && n2.call(h3, "__await") ? e4.resolve(h3.__await).then(function(t4) {
          invoke("next", t4, i2, a2);
        }, function(t4) {
          invoke("throw", t4, i2, a2);
        }) : e4.resolve(h3).then(function(t4) {
          u2.value = t4, i2(u2);
        }, function(t4) {
          return invoke("throw", t4, i2, a2);
        });
      }
      a2(c2.arg);
    }
    var r3;
    o3(this, "_invoke", { value: function value(t4, n3) {
      function callInvokeWithMethodAndArg() {
        return new e4(function(e5, r4) {
          invoke(t4, n3, e5, r4);
        });
      }
      return r3 = r3 ? r3.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    } });
  }
  function makeInvokeMethod(e4, r3, n3) {
    var o4 = h2;
    return function(i2, a2) {
      if (o4 === f) throw Error("Generator is already running");
      if (o4 === s) {
        if ("throw" === i2) throw a2;
        return { value: t2, done: true };
      }
      for (n3.method = i2, n3.arg = a2; ; ) {
        var c2 = n3.delegate;
        if (c2) {
          var u2 = maybeInvokeDelegate(c2, n3);
          if (u2) {
            if (u2 === y) continue;
            return u2;
          }
        }
        if ("next" === n3.method) n3.sent = n3._sent = n3.arg;
        else if ("throw" === n3.method) {
          if (o4 === h2) throw o4 = s, n3.arg;
          n3.dispatchException(n3.arg);
        } else "return" === n3.method && n3.abrupt("return", n3.arg);
        o4 = f;
        var p2 = tryCatch(e4, r3, n3);
        if ("normal" === p2.type) {
          if (o4 = n3.done ? s : l2, p2.arg === y) continue;
          return { value: p2.arg, done: n3.done };
        }
        "throw" === p2.type && (o4 = s, n3.method = "throw", n3.arg = p2.arg);
      }
    };
  }
  function maybeInvokeDelegate(e4, r3) {
    var n3 = r3.method, o4 = e4.iterator[n3];
    if (o4 === t2) return r3.delegate = null, "throw" === n3 && e4.iterator.return && (r3.method = "return", r3.arg = t2, maybeInvokeDelegate(e4, r3), "throw" === r3.method) || "return" !== n3 && (r3.method = "throw", r3.arg = new TypeError("The iterator does not provide a '" + n3 + "' method")), y;
    var i2 = tryCatch(o4, e4.iterator, r3.arg);
    if ("throw" === i2.type) return r3.method = "throw", r3.arg = i2.arg, r3.delegate = null, y;
    var a2 = i2.arg;
    return a2 ? a2.done ? (r3[e4.resultName] = a2.value, r3.next = e4.nextLoc, "return" !== r3.method && (r3.method = "next", r3.arg = t2), r3.delegate = null, y) : a2 : (r3.method = "throw", r3.arg = new TypeError("iterator result is not an object"), r3.delegate = null, y);
  }
  function pushTryEntry(t3) {
    var e4 = { tryLoc: t3[0] };
    1 in t3 && (e4.catchLoc = t3[1]), 2 in t3 && (e4.finallyLoc = t3[2], e4.afterLoc = t3[3]), this.tryEntries.push(e4);
  }
  function resetTryEntry(t3) {
    var e4 = t3.completion || {};
    e4.type = "normal", delete e4.arg, t3.completion = e4;
  }
  function Context4(t3) {
    this.tryEntries = [{ tryLoc: "root" }], t3.forEach(pushTryEntry, this), this.reset(true);
  }
  function values(e4) {
    if (e4 || "" === e4) {
      var r3 = e4[a];
      if (r3) return r3.call(e4);
      if ("function" == typeof e4.next) return e4;
      if (!isNaN(e4.length)) {
        var o4 = -1, i2 = function next2() {
          for (; ++o4 < e4.length; ) if (n2.call(e4, o4)) return next2.value = e4[o4], next2.done = false, next2;
          return next2.value = t2, next2.done = true, next2;
        };
        return i2.next = i2;
      }
    }
    throw new TypeError(_typeof4(e4) + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o3(g, "constructor", { value: GeneratorFunctionPrototype, configurable: true }), o3(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: true }), GeneratorFunction.displayName = define2(GeneratorFunctionPrototype, u, "GeneratorFunction"), e3.isGeneratorFunction = function(t3) {
    var e4 = "function" == typeof t3 && t3.constructor;
    return !!e4 && (e4 === GeneratorFunction || "GeneratorFunction" === (e4.displayName || e4.name));
  }, e3.mark = function(t3) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t3, GeneratorFunctionPrototype) : (t3.__proto__ = GeneratorFunctionPrototype, define2(t3, u, "GeneratorFunction")), t3.prototype = Object.create(g), t3;
  }, e3.awrap = function(t3) {
    return { __await: t3 };
  }, defineIteratorMethods(AsyncIterator3.prototype), define2(AsyncIterator3.prototype, c, function() {
    return this;
  }), e3.AsyncIterator = AsyncIterator3, e3.async = function(t3, r3, n3, o4, i2) {
    void 0 === i2 && (i2 = Promise);
    var a2 = new AsyncIterator3(wrap(t3, r3, n3, o4), i2);
    return e3.isGeneratorFunction(r3) ? a2 : a2.next().then(function(t4) {
      return t4.done ? t4.value : a2.next();
    });
  }, defineIteratorMethods(g), define2(g, u, "Generator"), define2(g, a, function() {
    return this;
  }), define2(g, "toString", function() {
    return "[object Generator]";
  }), e3.keys = function(t3) {
    var e4 = Object(t3), r3 = [];
    for (var n3 in e4) r3.push(n3);
    return r3.reverse(), function next2() {
      for (; r3.length; ) {
        var t4 = r3.pop();
        if (t4 in e4) return next2.value = t4, next2.done = false, next2;
      }
      return next2.done = true, next2;
    };
  }, e3.values = values, Context4.prototype = { constructor: Context4, reset: function reset2(e4) {
    if (this.prev = 0, this.next = 0, this.sent = this._sent = t2, this.done = false, this.delegate = null, this.method = "next", this.arg = t2, this.tryEntries.forEach(resetTryEntry), !e4) for (var r3 in this) "t" === r3.charAt(0) && n2.call(this, r3) && !isNaN(+r3.slice(1)) && (this[r3] = t2);
  }, stop: function stop() {
    this.done = true;
    var t3 = this.tryEntries[0].completion;
    if ("throw" === t3.type) throw t3.arg;
    return this.rval;
  }, dispatchException: function dispatchException(e4) {
    if (this.done) throw e4;
    var r3 = this;
    function handle(n3, o5) {
      return a2.type = "throw", a2.arg = e4, r3.next = n3, o5 && (r3.method = "next", r3.arg = t2), !!o5;
    }
    for (var o4 = this.tryEntries.length - 1; o4 >= 0; --o4) {
      var i2 = this.tryEntries[o4], a2 = i2.completion;
      if ("root" === i2.tryLoc) return handle("end");
      if (i2.tryLoc <= this.prev) {
        var c2 = n2.call(i2, "catchLoc"), u2 = n2.call(i2, "finallyLoc");
        if (c2 && u2) {
          if (this.prev < i2.catchLoc) return handle(i2.catchLoc, true);
          if (this.prev < i2.finallyLoc) return handle(i2.finallyLoc);
        } else if (c2) {
          if (this.prev < i2.catchLoc) return handle(i2.catchLoc, true);
        } else {
          if (!u2) throw Error("try statement without catch or finally");
          if (this.prev < i2.finallyLoc) return handle(i2.finallyLoc);
        }
      }
    }
  }, abrupt: function abrupt(t3, e4) {
    for (var r3 = this.tryEntries.length - 1; r3 >= 0; --r3) {
      var o4 = this.tryEntries[r3];
      if (o4.tryLoc <= this.prev && n2.call(o4, "finallyLoc") && this.prev < o4.finallyLoc) {
        var i2 = o4;
        break;
      }
    }
    i2 && ("break" === t3 || "continue" === t3) && i2.tryLoc <= e4 && e4 <= i2.finallyLoc && (i2 = null);
    var a2 = i2 ? i2.completion : {};
    return a2.type = t3, a2.arg = e4, i2 ? (this.method = "next", this.next = i2.finallyLoc, y) : this.complete(a2);
  }, complete: function complete(t3, e4) {
    if ("throw" === t3.type) throw t3.arg;
    return "break" === t3.type || "continue" === t3.type ? this.next = t3.arg : "return" === t3.type ? (this.rval = this.arg = t3.arg, this.method = "return", this.next = "end") : "normal" === t3.type && e4 && (this.next = e4), y;
  }, finish: function finish(t3) {
    for (var e4 = this.tryEntries.length - 1; e4 >= 0; --e4) {
      var r3 = this.tryEntries[e4];
      if (r3.finallyLoc === t3) return this.complete(r3.completion, r3.afterLoc), resetTryEntry(r3), y;
    }
  }, catch: function _catch(t3) {
    for (var e4 = this.tryEntries.length - 1; e4 >= 0; --e4) {
      var r3 = this.tryEntries[e4];
      if (r3.tryLoc === t3) {
        var n3 = r3.completion;
        if ("throw" === n3.type) {
          var o4 = n3.arg;
          resetTryEntry(r3);
        }
        return o4;
      }
    }
    throw Error("illegal catch attempt");
  }, delegateYield: function delegateYield(e4, r3, n3) {
    return this.delegate = { iterator: values(e4), resultName: r3, nextLoc: n3 }, "next" === this.method && (this.arg = t2), y;
  } }, e3;
}
var insertLengthRule = function insertLengthRule2(schema, rules) {
  var type5 = schema.type, max = schema.max, min = schema.min, message2 = schema.message;
  if (max || max === 0) {
    rules.push({
      type: type5,
      max,
      message: message2 === null || message2 === void 0 ? void 0 : message2.max
    });
  }
  if (min || min === 0) {
    rules.push({
      type: type5,
      min,
      message: message2 === null || message2 === void 0 ? void 0 : message2.min
    });
  }
};
var insertRequiredRule = function insertRequiredRule2(schema, rules) {
  var _a;
  var type5 = schema.type, format3 = schema.format, required5 = schema.required, message2 = schema.message, widget = schema.widget, title = schema.title;
  var requiredAlready = (_a = schema === null || schema === void 0 ? void 0 : schema.rules) === null || _a === void 0 ? void 0 : _a.some(function(item) {
    return item === null || item === void 0 ? void 0 : item.required;
  });
  if (!required5 || requiredAlready) {
    return;
  }
  var rule = {
    required: true,
    message: message2 === null || message2 === void 0 ? void 0 : message2.required
  };
  if (["year", "quarter", "month", "week", "date", "dateTime", "time"].includes(format3) && type5 === "range") {
    rule = {
      type: "array",
      required: true,
      len: 2,
      fields: {
        0: {
          type: "string",
          required: true
        },
        1: {
          type: "string",
          required: true
        }
      }
    };
  } else if (widget === "checkbox") {
    rule = {
      type: type5,
      required: true,
      whitespace: true,
      message: title + "\u5FC5\u586B"
    };
  } else if (type5 === "string") {
    rule = {
      type: "string",
      required: true,
      whitespace: true,
      message: (message2 === null || message2 === void 0 ? void 0 : message2.required) || (!title ? "\u5185\u5BB9\u5FC5\u586B" : void 0)
    };
  }
  rules.push(rule);
};
var transformRules = function transformRules2() {
  var rules = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  var methods2 = arguments.length > 1 ? arguments[1] : void 0;
  var form = arguments.length > 2 ? arguments[2] : void 0;
  return rules.map(function(item) {
    if (item.validator && !item.transformed) {
      var validator = isFunction2(item.validator) ? item.validator : methods2[item.validator];
      item.validator = function(_, value) {
        return __awaiter(void 0, void 0, void 0, /* @__PURE__ */ _regeneratorRuntime2().mark(function _callee() {
          var result;
          return _regeneratorRuntime2().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return validator(_, value, {
                  form
                });
              case 2:
                result = _context.sent;
                if (!isObject3(result)) {
                  _context.next = 5;
                  break;
                }
                return _context.abrupt("return", (result === null || result === void 0 ? void 0 : result.status) ? Promise.resolve() : Promise.reject(new Error(result.message || item.message)));
              case 5:
                return _context.abrupt("return", result ? Promise.resolve() : Promise.reject(new Error(item.message)));
              case 6:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
      };
      ;
      item.transformed = true;
    }
    return item;
  });
};
var validates_default = (function(_schema, form, methods2, fieldRef) {
  var _a, _b;
  var schema = cloneDeep_default(_schema);
  var format3 = schema.format, _schema$rules = schema.rules, ruleList = _schema$rules === void 0 ? [] : _schema$rules, pattern6 = schema.pattern, message2 = schema.message;
  var rules = _toConsumableArray6(ruleList);
  insertRequiredRule(schema, rules);
  insertLengthRule(schema, rules);
  rules.push({
    validator: function validator(_) {
      return __awaiter(void 0, void 0, void 0, /* @__PURE__ */ _regeneratorRuntime2().mark(function _callee2() {
        var _c, _d, res;
        return _regeneratorRuntime2().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (isFunction2((_c = fieldRef === null || fieldRef === void 0 ? void 0 : fieldRef.current) === null || _c === void 0 ? void 0 : _c.validator)) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return", true);
            case 2:
              _context2.next = 4;
              return (_d = fieldRef.current) === null || _d === void 0 ? void 0 : _d.validator();
            case 4:
              res = _context2.sent;
              return _context2.abrupt("return", res);
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
    }
  });
  if (pattern6) {
    rules.push({
      pattern: pattern6,
      message: message2 === null || message2 === void 0 ? void 0 : message2.pattern
    });
  }
  if (format3 === "url") {
    rules.push({
      type: "url",
      message: message2 === null || message2 === void 0 ? void 0 : message2.url
    });
  }
  if (format3 === "email") {
    rules.push({
      type: "email",
      message: message2 === null || message2 === void 0 ? void 0 : message2.email
    });
  }
  if (format3 === "image") {
    rules.push({
      validator: function validator(_, value) {
        if (!value) {
          return true;
        }
        var imagePattern = "([/|.|w|s|-])*.(?:jpg|gif|png|bmp|apng|webp|jpeg|json)";
        var _isUrl = isUrl(value);
        var _isImg = new RegExp(imagePattern).test(value);
        return _isUrl || _isImg;
      },
      message: (_a = message2 === null || message2 === void 0 ? void 0 : message2.email) !== null && _a !== void 0 ? _a : "\u8BF7\u8F93\u5165\u6B63\u786E\u7684\u56FE\u7247\u683C\u5F0F"
    });
  }
  if (format3 === "color") {
    rules.push({
      validator: function validator(_, value) {
        try {
          (0, import_color8.default)(value || null);
          return true;
        } catch (e3) {
          return false;
        }
      },
      message: (_b = message2 === null || message2 === void 0 ? void 0 : message2.color) !== null && _b !== void 0 ? _b : "\u8BF7\u586B\u5199\u6B63\u786E\u7684\u989C\u8272\u683C\u5F0F"
    });
  }
  return transformRules(rules, methods2, form);
});

// ../../node_modules/form-render/es/render-core/FieldItem/field.js
var import_react173 = __toESM(require_react());

// ../../node_modules/ahooks/es/createUpdateEffect/index.js
var import_react166 = __toESM(require_react());
var createUpdateEffect = function(hook) {
  return function(effect, deps) {
    var isMounted = (0, import_react166.useRef)(false);
    hook(function() {
      return function() {
        isMounted.current = false;
      };
    }, []);
    hook(function() {
      if (!isMounted.current) {
        isMounted.current = true;
      } else {
        return effect();
      }
    }, deps);
  };
};

// ../../node_modules/ahooks/es/useMemoizedFn/index.js
var import_react167 = __toESM(require_react());

// ../../node_modules/ahooks/es/utils/index.js
var isFunction4 = function(value) {
  return typeof value === "function";
};

// ../../node_modules/ahooks/es/utils/isDev.js
var isDev = true;
var isDev_default = isDev;

// ../../node_modules/ahooks/es/useMemoizedFn/index.js
var useMemoizedFn = function(fn) {
  if (isDev_default) {
    if (!isFunction4(fn)) {
      console.error("useMemoizedFn expected parameter is a function, got ".concat(typeof fn));
    }
  }
  var fnRef = (0, import_react167.useRef)(fn);
  fnRef.current = (0, import_react167.useMemo)(function() {
    return fn;
  }, [fn]);
  var memoizedFn = (0, import_react167.useRef)(void 0);
  if (!memoizedFn.current) {
    memoizedFn.current = function() {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      return fnRef.current.apply(this, args);
    };
  }
  return memoizedFn.current;
};
var useMemoizedFn_default = useMemoizedFn;

// ../../node_modules/ahooks/es/useUpdateEffect/index.js
var import_react168 = __toESM(require_react());
var useUpdateEffect_default = createUpdateEffect(import_react168.useEffect);

// ../../node_modules/ahooks/es/useUnmount/index.js
var import_react170 = __toESM(require_react());

// ../../node_modules/ahooks/es/useLatest/index.js
var import_react169 = __toESM(require_react());
function useLatest(value) {
  var ref3 = (0, import_react169.useRef)(value);
  ref3.current = value;
  return ref3;
}
var useLatest_default = useLatest;

// ../../node_modules/ahooks/es/useUnmount/index.js
var useUnmount2 = function(fn) {
  if (isDev_default) {
    if (!isFunction4(fn)) {
      console.error("useUnmount expected parameter is a function, got ".concat(typeof fn));
    }
  }
  var fnRef = useLatest_default(fn);
  (0, import_react170.useEffect)(function() {
    return function() {
      fnRef.current();
    };
  }, []);
};
var useUnmount_default2 = useUnmount2;

// ../../node_modules/ahooks/es/useMount/index.js
var import_react171 = __toESM(require_react());
var useMount = function(fn) {
  if (isDev_default) {
    if (!isFunction4(fn)) {
      console.error('useMount: parameter `fn` expected to be a function, but got "'.concat(typeof fn, '".'));
    }
  }
  (0, import_react171.useEffect)(function() {
    var result = fn === null || fn === void 0 ? void 0 : fn();
    if (result && typeof result === "object" && typeof result.then === "function") {
      return;
    }
    return result;
  }, []);
};
var useMount_default = useMount;

// ../../node_modules/ahooks/es/useSetState/index.js
var import_react172 = __toESM(require_react());
var useSetState = function(initialState) {
  var _a = __read((0, import_react172.useState)(initialState), 2), state = _a[0], setState = _a[1];
  var setMergeState = useMemoizedFn_default(function(patch) {
    setState(function(prevState) {
      var newState = isFunction4(patch) ? patch(prevState) : patch;
      return newState ? __assign(__assign({}, prevState), newState) : prevState;
    });
  });
  return [state, setMergeState];
};
var useSetState_default = useSetState;

// ../../node_modules/form-render/es/render-core/FieldItem/field.js
var FieldWrapperStatus = function FieldWrapperStatus2(props) {
  var Field2 = props.Field, fieldProps = props.fieldProps, maxWidth = props.maxWidth, initialValue = props.initialValue, acitonRender = props.acitonRender, otherProps = __rest(props, ["Field", "fieldProps", "maxWidth", "initialValue", "acitonRender"]);
  var onStatusChange = fieldProps.onStatusChange, addons = fieldProps.addons, otherFieldProps = __rest(fieldProps, ["onStatusChange", "addons"]);
  var style2 = maxWidth ? Object.assign({
    maxWidth
  }, fieldProps === null || fieldProps === void 0 ? void 0 : fieldProps.style) : Object.assign({}, fieldProps === null || fieldProps === void 0 ? void 0 : fieldProps.style);
  var _Form$Item$useStatus = form_default.Item.useStatus(), status = _Form$Item$useStatus.status;
  var errors = addons.getFieldError(addons.dataPath);
  (0, import_react173.useEffect)(function() {
    onStatusChange && onStatusChange(status, errors);
  }, [JSON.stringify(errors)]);
  useUpdateEffect_default(function() {
    otherProps.onChange(initialValue);
  }, [JSON.stringify(initialValue)]);
  return /* @__PURE__ */ import_react173.default.createElement(import_react173.default.Fragment, null, /* @__PURE__ */ import_react173.default.createElement(Field2, Object.assign({}, otherProps, otherFieldProps, {
    style: style2,
    addons
  })), acitonRender && /* @__PURE__ */ import_react173.default.createElement("span", {
    className: "ant-form-item-actions"
  }, acitonRender()));
};
var FieldWrapper = function FieldWrapper2(props) {
  var Field2 = props.Field, fieldProps = props.fieldProps, maxWidth = props.maxWidth, initialValue = props.initialValue, acitonRender = props.acitonRender, otherProps = __rest(props, ["Field", "fieldProps", "maxWidth", "initialValue", "acitonRender"]);
  var addons = fieldProps.addons, schema = fieldProps.schema;
  var _style = maxWidth ? Object.assign({
    maxWidth
  }, fieldProps === null || fieldProps === void 0 ? void 0 : fieldProps.style) : Object.assign({}, fieldProps === null || fieldProps === void 0 ? void 0 : fieldProps.style);
  var removeBtn = schema.removeBtn;
  var configCtx = (0, import_react173.useContext)(config_provider_default.ConfigContext);
  var t2 = translation(configCtx);
  useUpdateEffect_default(function() {
    otherProps.onChange(initialValue);
  }, [JSON.stringify(initialValue)]);
  var handleRemove = function handleRemove2() {
    if (isFunction2(removeBtn === null || removeBtn === void 0 ? void 0 : removeBtn.onClick)) {
      removeBtn.onClick(function() {
        addons.setSchemaByPath(addons.schemaPath, {
          hidden: true
        });
      });
      return;
    }
    addons.setSchemaByPath(addons.schemaPath, {
      hidden: true
    });
  };
  return /* @__PURE__ */ import_react173.default.createElement(import_react173.default.Fragment, null, /* @__PURE__ */ import_react173.default.createElement(Field2, Object.assign({}, otherProps, fieldProps, {
    style: _style
  })), removeBtn && /* @__PURE__ */ import_react173.default.createElement(button_default2, Object.assign({
    type: "link",
    danger: true
  }, removeBtn, {
    onClick: handleRemove
  }), (removeBtn === null || removeBtn === void 0 ? void 0 : removeBtn.text) || t2("delete")), acitonRender && /* @__PURE__ */ import_react173.default.createElement("span", {
    className: "fr-item-actions"
  }, acitonRender()));
};

// ../../node_modules/form-render/es/render-core/FieldItem/main.js
function _typeof5(o3) {
  "@babel/helpers - typeof";
  return _typeof5 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o4) {
    return typeof o4;
  } : function(o4) {
    return o4 && "function" == typeof Symbol && o4.constructor === Symbol && o4 !== Symbol.prototype ? "symbol" : typeof o4;
  }, _typeof5(o3);
}
function _defineProperty3(e3, r2, t2) {
  return (r2 = _toPropertyKey2(r2)) in e3 ? Object.defineProperty(e3, r2, { value: t2, enumerable: true, configurable: true, writable: true }) : e3[r2] = t2, e3;
}
function _toPropertyKey2(t2) {
  var i = _toPrimitive2(t2, "string");
  return "symbol" == _typeof5(i) ? i : i + "";
}
function _toPrimitive2(t2, r2) {
  if ("object" != _typeof5(t2) || !t2) return t2;
  var e3 = t2[Symbol.toPrimitive];
  if (void 0 !== e3) {
    var i = e3.call(t2, r2 || "default");
    if ("object" != _typeof5(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t2);
}
var UpperContext = /* @__PURE__ */ (0, import_react174.createContext)(function() {
});
var valuePropNameMap = {
  checkbox: "checked",
  switch: "checked",
  Checkbox: "checked",
  Switch: "checked"
};
var main_default = (function(props) {
  var _a, _b;
  var configCtx = props.configCtx, store = props.store, schema = props.schema, path2 = props.path, children = props.children, dependValues = props.dependValues, rootPath = props.rootPath;
  var fieldRef = (0, import_react174.useRef)(null);
  var formCtx = useStore(store, function(state) {
    return state.context;
  });
  var upperCtx = (0, import_react174.useContext)(UpperContext);
  var form = configCtx.form, widgets = configCtx.widgets, methods2 = configCtx.methods, globalProps = configCtx.globalProps;
  var reserveLabel = schema.reserveLabel, hidden = schema.hidden, properties2 = schema.properties, dependencies = schema.dependencies, _inlineMode = schema.inlineMode, remove = schema.remove, removeText = schema.removeText, _schema$visible = schema.visible, visible = _schema$visible === void 0 ? true : _schema$visible, otherSchema = __rest(schema, ["reserveLabel", "hidden", "properties", "dependencies", "inlineMode", "remove", "removeText", "visible"]);
  var getValueFromKey = getParamValue(formCtx, upperCtx, schema);
  var widgetName = getWidgetName(schema);
  var Widget = getWidget(widgetName, widgets);
  var fieldProps = getFieldProps(widgetName, schema, {
    widgets,
    methods: methods2,
    form,
    dependValues,
    globalProps,
    path: getPath2(path2),
    rootPath,
    fieldRef
  });
  (0, import_react174.useEffect)(function() {
    form.setFieldRef(fieldProps.addons.dataPath, fieldRef);
  }, []);
  if (schema === null || schema === void 0 ? void 0 : schema.hidden) {
    return null;
  }
  if (!widgetName) {
    var ErrorSchema3 = widgets["errorSchema"] || widgets["ErrorSchema"];
    return /* @__PURE__ */ import_react174.default.createElement(ErrorSchema3, {
      schema
    });
  }
  if (schema.type === "void") {
    return /* @__PURE__ */ import_react174.default.createElement(col_default2, {
      span: 24
    }, /* @__PURE__ */ import_react174.default.createElement(Widget, Object.assign({}, fieldProps)));
  }
  var displayType = getValueFromKey("displayType");
  var inlineSelf = _inlineMode || (upperCtx === null || upperCtx === void 0 ? void 0 : upperCtx.displayType) === "inline";
  if (!upperCtx.exist) {
    inlineSelf = _inlineMode || (formCtx === null || formCtx === void 0 ? void 0 : formCtx.displayType) === "inline";
  }
  var inlineChild = displayType === "inline";
  var labelWidth = getValueFromKey("labelWidth");
  if (children) {
    var childElement = /* @__PURE__ */ import_react174.default.createElement("div", {
      className: "fr-inline-container"
    }, children);
    if (!inlineChild) {
      var gutter = {
        row: 16,
        column: 24
      }[displayType];
      childElement = /* @__PURE__ */ import_react174.default.createElement(row_default2, {
        gutter
      }, children);
    }
    fieldProps.children = childElement;
    var content = /* @__PURE__ */ import_react174.default.createElement(Widget, Object.assign({
      labelWidth,
      displayType: schema.displayType
    }, fieldProps, otherSchema));
    return /* @__PURE__ */ import_react174.default.createElement(UpperContext.Provider, {
      value: {
        column: schema.column,
        labelCol: schema.labelCol,
        fieldCol: schema.fieldCol,
        displayType: schema.displayType,
        labelWidth: schema.labelWidth,
        noStyle: schema.noStyle,
        exist: true
      }
    }, inlineSelf ? content : /* @__PURE__ */ import_react174.default.createElement(col_default2, {
      span: 24,
      className: (0, import_classnames206.default)("fr-obj-col", _defineProperty3({}, schema.className, !!schema.className))
    }, content));
  }
  var label = getLabel(schema, displayType, widgets, fieldProps.addons);
  var noStyle = getValueFromKey("noStyle");
  var span = getColSpan(formCtx, upperCtx, schema);
  var extra = getExtraView("extra", schema, widgets, fieldProps.addons);
  var help = getExtraView("help", schema, widgets, fieldProps.addons);
  var action = getExtraView("action", schema, widgets, fieldProps.addons);
  var tooltip = getTooltip(schema, displayType);
  var ruleList = validates_default(schema, form, methods2, fieldRef);
  var readOnly = getValueFromKey("readOnly");
  var disabled = getValueFromKey("disabled");
  var validateTrigger = getValueFromKey("validateTrigger");
  var _labelCol = getValueFromKey("labelCol");
  var _fieldCol = getValueFromKey("fieldCol");
  var maxWidth = getValueFromKey("maxWidth");
  var _getFormItemLayout = getFormItemLayout(Math.floor(24 / span * 1), schema, {
    displayType,
    labelWidth,
    _labelCol,
    _fieldCol
  }), labelCol = _getFormItemLayout.labelCol, fieldCol = _getFormItemLayout.fieldCol;
  var valuePropName = schema.valuePropName || valuePropNameMap[widgetName] || void 0;
  if (readOnly) {
    fieldProps.readOnly = readOnly;
  }
  if (disabled) {
    fieldProps.disabled = disabled;
  }
  if (reserveLabel && !label && displayType !== "column") {
    label = "fr-hide-label";
  }
  if (readOnly) {
    Widget = widgets[schema.readOnlyWidget] || widgets["Html"];
  }
  if (isCheckBoxType(schema, readOnly)) {
    fieldProps.title = label;
    label = null;
    if (displayType === "row") {
      label = "fr-hide-label";
    }
  }
  var initialValue = (_a = schema.default) !== null && _a !== void 0 ? _a : schema.defaultValue;
  var classRest = _defineProperty3({
    "fr-hide-label": label === "fr-hide-label",
    "fr-inline-field": inlineSelf,
    "fr-field-visibility": !visible
  }, schema.className, !!schema.className);
  var formItem = /* @__PURE__ */ import_react174.default.createElement(form_default.Item, {
    className: (0, import_classnames206.default)("fr-field", classRest),
    label,
    name: path2,
    valuePropName,
    rules: readOnly ? [] : ruleList,
    hidden,
    tooltip,
    extra,
    help,
    initialValue,
    labelCol,
    wrapperCol: fieldCol,
    noStyle,
    dependencies,
    validateTrigger: validateTrigger !== null && validateTrigger !== void 0 ? validateTrigger : ((_b = fieldRef === null || fieldRef === void 0 ? void 0 : fieldRef.current) === null || _b === void 0 ? void 0 : _b.validator) ? "onSubmit" : "onChange"
  }, fieldProps.onStatusChange ? /* @__PURE__ */ import_react174.default.createElement(FieldWrapperStatus, {
    Field: Widget,
    fieldProps,
    maxWidth,
    initialValue,
    acitonRender: action ? function() {
      return action;
    } : void 0
  }) : /* @__PURE__ */ import_react174.default.createElement(FieldWrapper, {
    Field: Widget,
    fieldProps,
    maxWidth,
    initialValue,
    acitonRender: action ? function() {
      return action;
    } : void 0
  }));
  if (inlineSelf) {
    if (noStyle) {
      return /* @__PURE__ */ import_react174.default.createElement("div", {
        className: (0, import_classnames206.default)("fr-inline-field", _defineProperty3({
          "fr-field-visibility": !visible
        }, schema.className, !!schema.className))
      }, formItem);
    }
    return formItem;
  }
  return /* @__PURE__ */ import_react174.default.createElement(col_default2, {
    span,
    className: (0, import_classnames206.default)(null, {
      "fr-field-visibility": !visible
    })
  }, formItem);
});

// ../../node_modules/form-render/es/render-core/FieldItem/index.js
var FieldItem_default = (function(props) {
  var _a, _b;
  var schema = props.schema, rootPath = props.rootPath, restProps = __rest(props, ["schema", "rootPath"]);
  var store = (0, import_react175.useContext)(FRContext);
  var _store$getState = store.getState(), formSchema = _store$getState.schema;
  var configCtx = (0, import_react175.useContext)(ConfigContext2);
  var mustacheDisabled = (_a = configCtx === null || configCtx === void 0 ? void 0 : configCtx.globalConfig) === null || _a === void 0 ? void 0 : _a.mustacheDisabled;
  var shouldUpdateOpen = (_b = configCtx === null || configCtx === void 0 ? void 0 : configCtx.globalConfig) === null || _b === void 0 ? void 0 : _b.shouldUpdateOpen;
  var dependencies = schema === null || schema === void 0 ? void 0 : schema.dependencies;
  if (!_isHasExpression(schema) && !mustacheDisabled && (!dependencies || !(dependencies === null || dependencies === void 0 ? void 0 : dependencies.length))) {
    return /* @__PURE__ */ import_react175.default.createElement(main_default, Object.assign({}, props, {
      store,
      configCtx
    }));
  }
  var schemaStr = JSON.stringify(schema);
  return /* @__PURE__ */ import_react175.default.createElement(form_default.Item, {
    noStyle: true,
    shouldUpdate: fieldShouldUpdate_default(schemaStr, rootPath, dependencies, shouldUpdateOpen)
  }, function(form) {
    var formData = form.getFieldsValue(true);
    var formDependencies = [];
    var dependValues = (dependencies || []).map(function(depPath) {
      var item = [];
      formDependencies.push(item);
      return _getDependValues(formData, depPath, props, item);
    });
    var newSchema = mustacheDisabled ? schema : _parseAllExpression(schema, formData, rootPath, formSchema);
    return /* @__PURE__ */ import_react175.default.createElement(main_default, Object.assign({
      schema: Object.assign(Object.assign({}, newSchema), {
        dependencies: formDependencies
      }),
      rootPath
    }, restProps, {
      dependValues,
      store,
      configCtx
    }));
  });
});

// ../../node_modules/form-render/es/render-core/FieldList/index.js
var import_react179 = __toESM(require_react());

// ../../node_modules/form-render/es/render-core/FieldList/main.js
var import_react178 = __toESM(require_react());

// ../../node_modules/form-render/es/render-core/FieldList/modules.js
var import_react176 = __toESM(require_react());
var getParamValue3 = function getParamValue4(formCtx, upperCtx, schema) {
  return function(valueKey) {
    var _a, _b;
    return (_b = (_a = schema[valueKey]) !== null && _a !== void 0 ? _a : upperCtx[valueKey]) !== null && _b !== void 0 ? _b : formCtx[valueKey];
  };
};
var getFormListLayout = function getFormListLayout2(getValueFromKey, displayType) {
  var _labelCol = getValueFromKey("labelCol");
  var _fieldCol = getValueFromKey("fieldCol");
  var labelWidth = getValueFromKey("labelWidth");
  var labelCol = {
    span: 5
  };
  var fieldCol = {
    flex: 1
  };
  if (labelWidth && displayType !== "column") {
    labelCol = {
      flex: labelWidth + "px"
    };
  }
  if (_labelCol) {
    labelCol = _labelCol;
  }
  if (_fieldCol) {
    fieldCol = _fieldCol;
  }
  if (typeof _labelCol === "number") {
    labelCol = {
      span: _labelCol
    };
  }
  if (typeof _fieldCol === "number") {
    fieldCol = {
      span: _fieldCol
    };
  }
  return {
    labelCol,
    fieldCol
  };
};
var getLabel3 = function getLabel4(schema, displayType, widgets) {
  var title = schema.title, description = schema.description, descWidget = schema.descWidget, labelWidget = schema.labelWidget;
  var LabelNode = widgets[labelWidget];
  if (LabelNode) {
    return /* @__PURE__ */ import_react176.default.createElement(LabelNode, {
      schema
    });
  }
  if (!description && !descWidget) {
    return title;
  }
  var RenderDesc = function RenderDesc2() {
    var Widget = widgets[descWidget];
    if (Widget) {
      return /* @__PURE__ */ import_react176.default.createElement(Widget, {
        schema
      });
    }
    if (description) {
      return /* @__PURE__ */ import_react176.default.createElement("span", {
        className: "fr-desc"
      }, "(", description, ")");
    }
    return null;
  };
  if (displayType === "inline") {
    return title;
  }
  return /* @__PURE__ */ import_react176.default.createElement(import_react176.default.Fragment, null, title, /* @__PURE__ */ import_react176.default.createElement(RenderDesc, null));
};
var getTooltip3 = function getTooltip4(schema, displayType) {
  var descType = schema.descType, description = schema.description, tooltip = schema.tooltip;
  if (tooltip) {
    if (typeof tooltip === "string") {
      return {
        title: /* @__PURE__ */ import_react176.default.createElement("span", {
          dangerouslySetInnerHTML: {
            __html: tooltip
          }
        })
      };
    }
    return Object.assign(Object.assign({}, tooltip), {
      title: /* @__PURE__ */ import_react176.default.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: tooltip.title
        }
      })
    });
  }
  if (descType === "widget" || !description) {
    return null;
  }
  if (displayType === "column" && descType === "icon") {
    return {
      title: description
    };
  }
  return null;
};

// ../../node_modules/form-render/es/render-core/FieldList/field.js
var import_react177 = __toESM(require_react());
function _typeof6(o3) {
  "@babel/helpers - typeof";
  return _typeof6 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o4) {
    return typeof o4;
  } : function(o4) {
    return o4 && "function" == typeof Symbol && o4.constructor === Symbol && o4 !== Symbol.prototype ? "symbol" : typeof o4;
  }, _typeof6(o3);
}
function _regeneratorRuntime3() {
  "use strict";
  _regeneratorRuntime3 = function _regeneratorRuntime6() {
    return e3;
  };
  var t2, e3 = {}, r2 = Object.prototype, n2 = r2.hasOwnProperty, o3 = Object.defineProperty || function(t3, e4, r3) {
    t3[e4] = r3.value;
  }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
  function define2(t3, e4, r3) {
    return Object.defineProperty(t3, e4, { value: r3, enumerable: true, configurable: true, writable: true }), t3[e4];
  }
  try {
    define2({}, "");
  } catch (t3) {
    define2 = function define3(t4, e4, r3) {
      return t4[e4] = r3;
    };
  }
  function wrap(t3, e4, r3, n3) {
    var i2 = e4 && e4.prototype instanceof Generator ? e4 : Generator, a2 = Object.create(i2.prototype), c2 = new Context4(n3 || []);
    return o3(a2, "_invoke", { value: makeInvokeMethod(t3, r3, c2) }), a2;
  }
  function tryCatch(t3, e4, r3) {
    try {
      return { type: "normal", arg: t3.call(e4, r3) };
    } catch (t4) {
      return { type: "throw", arg: t4 };
    }
  }
  e3.wrap = wrap;
  var h2 = "suspendedStart", l2 = "suspendedYield", f = "executing", s = "completed", y = {};
  function Generator() {
  }
  function GeneratorFunction() {
  }
  function GeneratorFunctionPrototype() {
  }
  var p = {};
  define2(p, a, function() {
    return this;
  });
  var d = Object.getPrototypeOf, v = d && d(d(values([])));
  v && v !== r2 && n2.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t3) {
    ["next", "throw", "return"].forEach(function(e4) {
      define2(t3, e4, function(t4) {
        return this._invoke(e4, t4);
      });
    });
  }
  function AsyncIterator3(t3, e4) {
    function invoke(r4, o4, i2, a2) {
      var c2 = tryCatch(t3[r4], t3, o4);
      if ("throw" !== c2.type) {
        var u2 = c2.arg, h3 = u2.value;
        return h3 && "object" == _typeof6(h3) && n2.call(h3, "__await") ? e4.resolve(h3.__await).then(function(t4) {
          invoke("next", t4, i2, a2);
        }, function(t4) {
          invoke("throw", t4, i2, a2);
        }) : e4.resolve(h3).then(function(t4) {
          u2.value = t4, i2(u2);
        }, function(t4) {
          return invoke("throw", t4, i2, a2);
        });
      }
      a2(c2.arg);
    }
    var r3;
    o3(this, "_invoke", { value: function value(t4, n3) {
      function callInvokeWithMethodAndArg() {
        return new e4(function(e5, r4) {
          invoke(t4, n3, e5, r4);
        });
      }
      return r3 = r3 ? r3.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    } });
  }
  function makeInvokeMethod(e4, r3, n3) {
    var o4 = h2;
    return function(i2, a2) {
      if (o4 === f) throw Error("Generator is already running");
      if (o4 === s) {
        if ("throw" === i2) throw a2;
        return { value: t2, done: true };
      }
      for (n3.method = i2, n3.arg = a2; ; ) {
        var c2 = n3.delegate;
        if (c2) {
          var u2 = maybeInvokeDelegate(c2, n3);
          if (u2) {
            if (u2 === y) continue;
            return u2;
          }
        }
        if ("next" === n3.method) n3.sent = n3._sent = n3.arg;
        else if ("throw" === n3.method) {
          if (o4 === h2) throw o4 = s, n3.arg;
          n3.dispatchException(n3.arg);
        } else "return" === n3.method && n3.abrupt("return", n3.arg);
        o4 = f;
        var p2 = tryCatch(e4, r3, n3);
        if ("normal" === p2.type) {
          if (o4 = n3.done ? s : l2, p2.arg === y) continue;
          return { value: p2.arg, done: n3.done };
        }
        "throw" === p2.type && (o4 = s, n3.method = "throw", n3.arg = p2.arg);
      }
    };
  }
  function maybeInvokeDelegate(e4, r3) {
    var n3 = r3.method, o4 = e4.iterator[n3];
    if (o4 === t2) return r3.delegate = null, "throw" === n3 && e4.iterator.return && (r3.method = "return", r3.arg = t2, maybeInvokeDelegate(e4, r3), "throw" === r3.method) || "return" !== n3 && (r3.method = "throw", r3.arg = new TypeError("The iterator does not provide a '" + n3 + "' method")), y;
    var i2 = tryCatch(o4, e4.iterator, r3.arg);
    if ("throw" === i2.type) return r3.method = "throw", r3.arg = i2.arg, r3.delegate = null, y;
    var a2 = i2.arg;
    return a2 ? a2.done ? (r3[e4.resultName] = a2.value, r3.next = e4.nextLoc, "return" !== r3.method && (r3.method = "next", r3.arg = t2), r3.delegate = null, y) : a2 : (r3.method = "throw", r3.arg = new TypeError("iterator result is not an object"), r3.delegate = null, y);
  }
  function pushTryEntry(t3) {
    var e4 = { tryLoc: t3[0] };
    1 in t3 && (e4.catchLoc = t3[1]), 2 in t3 && (e4.finallyLoc = t3[2], e4.afterLoc = t3[3]), this.tryEntries.push(e4);
  }
  function resetTryEntry(t3) {
    var e4 = t3.completion || {};
    e4.type = "normal", delete e4.arg, t3.completion = e4;
  }
  function Context4(t3) {
    this.tryEntries = [{ tryLoc: "root" }], t3.forEach(pushTryEntry, this), this.reset(true);
  }
  function values(e4) {
    if (e4 || "" === e4) {
      var r3 = e4[a];
      if (r3) return r3.call(e4);
      if ("function" == typeof e4.next) return e4;
      if (!isNaN(e4.length)) {
        var o4 = -1, i2 = function next2() {
          for (; ++o4 < e4.length; ) if (n2.call(e4, o4)) return next2.value = e4[o4], next2.done = false, next2;
          return next2.value = t2, next2.done = true, next2;
        };
        return i2.next = i2;
      }
    }
    throw new TypeError(_typeof6(e4) + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o3(g, "constructor", { value: GeneratorFunctionPrototype, configurable: true }), o3(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: true }), GeneratorFunction.displayName = define2(GeneratorFunctionPrototype, u, "GeneratorFunction"), e3.isGeneratorFunction = function(t3) {
    var e4 = "function" == typeof t3 && t3.constructor;
    return !!e4 && (e4 === GeneratorFunction || "GeneratorFunction" === (e4.displayName || e4.name));
  }, e3.mark = function(t3) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t3, GeneratorFunctionPrototype) : (t3.__proto__ = GeneratorFunctionPrototype, define2(t3, u, "GeneratorFunction")), t3.prototype = Object.create(g), t3;
  }, e3.awrap = function(t3) {
    return { __await: t3 };
  }, defineIteratorMethods(AsyncIterator3.prototype), define2(AsyncIterator3.prototype, c, function() {
    return this;
  }), e3.AsyncIterator = AsyncIterator3, e3.async = function(t3, r3, n3, o4, i2) {
    void 0 === i2 && (i2 = Promise);
    var a2 = new AsyncIterator3(wrap(t3, r3, n3, o4), i2);
    return e3.isGeneratorFunction(r3) ? a2 : a2.next().then(function(t4) {
      return t4.done ? t4.value : a2.next();
    });
  }, defineIteratorMethods(g), define2(g, u, "Generator"), define2(g, a, function() {
    return this;
  }), define2(g, "toString", function() {
    return "[object Generator]";
  }), e3.keys = function(t3) {
    var e4 = Object(t3), r3 = [];
    for (var n3 in e4) r3.push(n3);
    return r3.reverse(), function next2() {
      for (; r3.length; ) {
        var t4 = r3.pop();
        if (t4 in e4) return next2.value = t4, next2.done = false, next2;
      }
      return next2.done = true, next2;
    };
  }, e3.values = values, Context4.prototype = { constructor: Context4, reset: function reset2(e4) {
    if (this.prev = 0, this.next = 0, this.sent = this._sent = t2, this.done = false, this.delegate = null, this.method = "next", this.arg = t2, this.tryEntries.forEach(resetTryEntry), !e4) for (var r3 in this) "t" === r3.charAt(0) && n2.call(this, r3) && !isNaN(+r3.slice(1)) && (this[r3] = t2);
  }, stop: function stop() {
    this.done = true;
    var t3 = this.tryEntries[0].completion;
    if ("throw" === t3.type) throw t3.arg;
    return this.rval;
  }, dispatchException: function dispatchException(e4) {
    if (this.done) throw e4;
    var r3 = this;
    function handle(n3, o5) {
      return a2.type = "throw", a2.arg = e4, r3.next = n3, o5 && (r3.method = "next", r3.arg = t2), !!o5;
    }
    for (var o4 = this.tryEntries.length - 1; o4 >= 0; --o4) {
      var i2 = this.tryEntries[o4], a2 = i2.completion;
      if ("root" === i2.tryLoc) return handle("end");
      if (i2.tryLoc <= this.prev) {
        var c2 = n2.call(i2, "catchLoc"), u2 = n2.call(i2, "finallyLoc");
        if (c2 && u2) {
          if (this.prev < i2.catchLoc) return handle(i2.catchLoc, true);
          if (this.prev < i2.finallyLoc) return handle(i2.finallyLoc);
        } else if (c2) {
          if (this.prev < i2.catchLoc) return handle(i2.catchLoc, true);
        } else {
          if (!u2) throw Error("try statement without catch or finally");
          if (this.prev < i2.finallyLoc) return handle(i2.finallyLoc);
        }
      }
    }
  }, abrupt: function abrupt(t3, e4) {
    for (var r3 = this.tryEntries.length - 1; r3 >= 0; --r3) {
      var o4 = this.tryEntries[r3];
      if (o4.tryLoc <= this.prev && n2.call(o4, "finallyLoc") && this.prev < o4.finallyLoc) {
        var i2 = o4;
        break;
      }
    }
    i2 && ("break" === t3 || "continue" === t3) && i2.tryLoc <= e4 && e4 <= i2.finallyLoc && (i2 = null);
    var a2 = i2 ? i2.completion : {};
    return a2.type = t3, a2.arg = e4, i2 ? (this.method = "next", this.next = i2.finallyLoc, y) : this.complete(a2);
  }, complete: function complete(t3, e4) {
    if ("throw" === t3.type) throw t3.arg;
    return "break" === t3.type || "continue" === t3.type ? this.next = t3.arg : "return" === t3.type ? (this.rval = this.arg = t3.arg, this.method = "return", this.next = "end") : "normal" === t3.type && e4 && (this.next = e4), y;
  }, finish: function finish(t3) {
    for (var e4 = this.tryEntries.length - 1; e4 >= 0; --e4) {
      var r3 = this.tryEntries[e4];
      if (r3.finallyLoc === t3) return this.complete(r3.completion, r3.afterLoc), resetTryEntry(r3), y;
    }
  }, catch: function _catch(t3) {
    for (var e4 = this.tryEntries.length - 1; e4 >= 0; --e4) {
      var r3 = this.tryEntries[e4];
      if (r3.tryLoc === t3) {
        var n3 = r3.completion;
        if ("throw" === n3.type) {
          var o4 = n3.arg;
          resetTryEntry(r3);
        }
        return o4;
      }
    }
    throw Error("illegal catch attempt");
  }, delegateYield: function delegateYield(e4, r3, n3) {
    return this.delegate = { iterator: values(e4), resultName: r3, nextLoc: n3 }, "next" === this.method && (this.arg = t2), y;
  } }, e3;
}
function _toConsumableArray7(r2) {
  return _arrayWithoutHoles7(r2) || _iterableToArray7(r2) || _unsupportedIterableToArray7(r2) || _nonIterableSpread7();
}
function _nonIterableSpread7() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray7(r2, a) {
  if (r2) {
    if ("string" == typeof r2) return _arrayLikeToArray7(r2, a);
    var t2 = {}.toString.call(r2).slice(8, -1);
    return "Object" === t2 && r2.constructor && (t2 = r2.constructor.name), "Map" === t2 || "Set" === t2 ? Array.from(r2) : "Arguments" === t2 || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t2) ? _arrayLikeToArray7(r2, a) : void 0;
  }
}
function _iterableToArray7(r2) {
  if ("undefined" != typeof Symbol && null != r2[Symbol.iterator] || null != r2["@@iterator"]) return Array.from(r2);
}
function _arrayWithoutHoles7(r2) {
  if (Array.isArray(r2)) return _arrayLikeToArray7(r2);
}
function _arrayLikeToArray7(r2, a) {
  (null == a || a > r2.length) && (a = r2.length);
  for (var e3 = 0, n2 = Array(a); e3 < a; e3++) n2[e3] = r2[e3];
  return n2;
}
var field_default = (function(props) {
  var _a, _b;
  var form = props.form, schema = props.schema, path2 = props.path, parentLitPath = props.parentLitPath, renderCore = props.renderCore, rootPath = props.rootPath, methods2 = props.methods, upperCtx = props.upperCtx, formCtx = props.formCtx, configContext = props.configContext, setListData = props.setListData;
  var widgets = configContext.widgets, globalConfig2 = configContext.globalConfig;
  var configCtx = (0, import_react177.useContext)(config_provider_default.ConfigContext);
  var t2 = translation(configCtx);
  var defaultAddBtnProps = {
    type: "dashed",
    block: true,
    children: t2("add_item")
  };
  var defaultDelConfirmProps = {
    title: t2("confirm_delete"),
    okText: t2("confirm"),
    cancelText: t2("cancel")
  };
  var defaultActionColumnProps = {
    colHeaderText: t2("operate")
  };
  var widgetName = schema.widget || "cardList";
  var Widget = getWidget(widgetName, widgets);
  var listProps = schema.props, removeBtn = schema.removeBtn, _schema$rules = schema.rules, rules = _schema$rules === void 0 ? [] : _schema$rules, otherSchema = __rest(schema, ["props", "removeBtn", "rules"]);
  var _c = listProps || {}, addBtnProps = _c.addBtnProps, delConfirmProps = _c.delConfirmProps, actionColumnProps = _c.actionColumnProps, hideAdd = _c.hideAdd, hideCopy = _c.hideCopy, hideMove = _c.hideMove, hideDelete = _c.hideDelete, onAdd = _c.onAdd, onRemove = _c.onRemove, onMove = _c.onMove, onCopy = _c.onCopy, otherListProps = __rest(_c, ["addBtnProps", "delConfirmProps", "actionColumnProps", "hideAdd", "hideCopy", "hideMove", "hideDelete", "onAdd", "onRemove", "onMove", "onCopy"]);
  var getValueFromKey = getParamValue3(formCtx, upperCtx, schema);
  var readOnly = getValueFromKey("readOnly");
  var preRootPath = _toConsumableArray7(rootPath || []).splice(0, rootPath.length - 1);
  var displayType = getValueFromKey("displayType");
  if (hideMove === void 0 && ((_a = globalConfig2 === null || globalConfig2 === void 0 ? void 0 : globalConfig2.listOperate) === null || _a === void 0 ? void 0 : _a.hideMove)) {
    hideMove = globalConfig2 === null || globalConfig2 === void 0 ? void 0 : globalConfig2.listOperate.hideMove;
  }
  var listData = form.getFieldValue([].concat(_toConsumableArray7(preRootPath), _toConsumableArray7(path2))) || [];
  if ((otherSchema === null || otherSchema === void 0 ? void 0 : otherSchema.min) > 0 && listData.length <= (otherSchema === null || otherSchema === void 0 ? void 0 : otherSchema.min)) {
    hideDelete = true;
  }
  if ((otherSchema === null || otherSchema === void 0 ? void 0 : otherSchema.max) > 0 && (otherSchema === null || otherSchema === void 0 ? void 0 : otherSchema.max) <= listData.length) {
    hideAdd = true;
  }
  if (hideAdd) {
    hideCopy = true;
  }
  if (readOnly) {
    hideAdd = true;
    hideCopy = true;
    hideDelete = true;
    hideMove = true;
  }
  var defaultValue2 = (0, import_react177.useMemo)(function() {
    var _a2;
    var result = (_a2 = schema.default) !== null && _a2 !== void 0 ? _a2 : schema.defaultValue;
    if (result === void 0) {
      result = form.getFieldValue([].concat(_toConsumableArray7(preRootPath), _toConsumableArray7(path2)));
      if (!result && !["drawerList", "list1"].includes(widgetName)) {
        result = [{}];
      }
    }
    return result;
  }, []);
  (0, import_react177.useEffect)(function() {
    setListData(defaultValue2 || []);
  }, []);
  var handleAdd = function handleAdd2(add3) {
    return function(data2) {
      var addFunc = onAdd;
      if (typeof onAdd === "string") {
        addFunc = methods2[onAdd];
      }
      if (isFunction2(addFunc)) {
        addFunc(function(funData) {
          return add3(funData || data2);
        }, {
          schema,
          data: data2
        });
        return;
      }
      add3(data2);
    };
  };
  var handleRemove = function handleRemove2(remove) {
    return function(index3) {
      var removeFunc = onRemove;
      if (typeof onRemove === "string") {
        removeFunc = methods2[onRemove];
      }
      if (isFunction2(removeFunc)) {
        var data2 = form.getFieldValue([].concat(_toConsumableArray7(preRootPath), _toConsumableArray7(path2), [index3]));
        removeFunc(function() {
          return remove(index3);
        }, {
          schema,
          index: index3,
          data: data2
        });
        return;
      }
      remove(index3);
    };
  };
  var handleMove = function handleMove2(move2) {
    return function(from2, to) {
      var moveFunc = onMove;
      if (typeof moveFunc === "string") {
        moveFunc = methods2[onMove];
      }
      if (isFunction2(moveFunc)) {
        moveFunc(function() {
          return move2(from2, to);
        }, {
          schema,
          from: from2,
          to
        });
        return;
      }
      move2(from2, to);
    };
  };
  var handleCopy = function handleCopy2(add3, fields) {
    return function(data2, copyIndex) {
      if (schema.max && fields.length === schema.max) {
        return message_default.warning(t2("copy_max_tip"));
      }
      var copyFunc = onCopy;
      if (typeof onCopy === "string") {
        copyFunc = methods2[onCopy];
      }
      if (isFunction2(copyFunc)) {
        console.log(copyIndex, "copyIndex");
        copyFunc(function(funData) {
          return add3(funData || data2);
        }, {
          schema,
          data: data2,
          copyIndex
        });
        return;
      }
      add3(data2);
    };
  };
  var handleDelete = function handleDelete2() {
    if (isFunction2(removeBtn === null || removeBtn === void 0 ? void 0 : removeBtn.onClick)) {
      removeBtn.onClick(function() {
        form.setSchemaByPath(path2, {
          hidden: true
        });
      });
      return;
    }
    form.setSchemaByPath(path2, {
      hidden: true
    });
  };
  var operateBtnType = (_b = globalConfig2 === null || globalConfig2 === void 0 ? void 0 : globalConfig2.listOperate) === null || _b === void 0 ? void 0 : _b.btnType;
  var ruleList = [];
  if (!readOnly) {
    ruleList = [{
      validator: function validator(_, data2) {
        return __awaiter(void 0, void 0, void 0, /* @__PURE__ */ _regeneratorRuntime3().mark(function _callee() {
          var _d;
          return _regeneratorRuntime3().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                setListData(data2);
                if (otherSchema === null || otherSchema === void 0 ? void 0 : otherSchema.min) {
                  _context.next = 3;
                  break;
                }
                return _context.abrupt("return");
              case 3:
                if (!(!data2 || data2.length < otherSchema.min)) {
                  _context.next = 5;
                  break;
                }
                return _context.abrupt("return", Promise.reject(new Error(((_d = otherSchema === null || otherSchema === void 0 ? void 0 : otherSchema.message) === null || _d === void 0 ? void 0 : _d.min) || "\u6570\u636E\u957F\u5EA6\u5FC5\u987B\u5927\u4E8E\u7B49\u4E8E".concat(otherSchema.min))));
              case 5:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
      }
    }].concat(_toConsumableArray7(transformRules(rules || [], methods2, form)));
  }
  return /* @__PURE__ */ import_react177.default.createElement(import_react177.default.Fragment, null, /* @__PURE__ */ import_react177.default.createElement(form_default.List, {
    name: path2,
    initialValue: defaultValue2,
    rules: ruleList
  }, function(fields, operation, _ref) {
    var errors = _ref.errors;
    return /* @__PURE__ */ import_react177.default.createElement(import_react177.default.Fragment, null, /* @__PURE__ */ import_react177.default.createElement(Widget, Object.assign({}, otherListProps, {
      configContext,
      form,
      schema: otherSchema,
      fields,
      operation,
      path: path2,
      listName: path2,
      parentLitPath,
      rootPath: [].concat(_toConsumableArray7(preRootPath), _toConsumableArray7(path2)),
      readOnly,
      methods: methods2,
      renderCore,
      widgets,
      hideAdd,
      hideCopy,
      hideDelete,
      hideMove,
      addItem: handleAdd(operation.add),
      removeItem: handleRemove(operation.remove),
      moveItem: handleMove(operation.move),
      copyItem: handleCopy(operation.add, fields),
      temporary: {
        displayType
      },
      addBtnProps: Object.assign(Object.assign({}, defaultAddBtnProps), addBtnProps),
      delConfirmProps: Object.assign(Object.assign({}, defaultDelConfirmProps), delConfirmProps),
      actionColumnProps: Object.assign(Object.assign({}, defaultActionColumnProps), actionColumnProps),
      copyBtnProps: {
        children: t2("copy"),
        btnType: operateBtnType
      },
      editorBtnProps: {
        children: t2("edit"),
        btnType: operateBtnType
      },
      deleteBtnProps: {
        children: t2("delete"),
        btnType: operateBtnType
      },
      moveUpBtnProps: {
        children: t2("moveUp"),
        btnType: operateBtnType
      },
      moveDownBtnProps: {
        children: t2("moveDown"),
        btnType: operateBtnType
      }
    })), (errors === null || errors === void 0 ? void 0 : errors.length) !== 0 && /* @__PURE__ */ import_react177.default.createElement("div", {
      style: {
        marginBottom: "12px"
      }
    }, /* @__PURE__ */ import_react177.default.createElement(form_default.ErrorList, {
      errors
    })));
  }), removeBtn && /* @__PURE__ */ import_react177.default.createElement(button_default2, Object.assign({
    type: "link",
    danger: true
  }, removeBtn, {
    onClick: handleDelete
  }), (removeBtn === null || removeBtn === void 0 ? void 0 : removeBtn.text) || t2("delete")));
});

// ../../node_modules/form-render/es/render-core/FieldList/main.js
function _toConsumableArray8(r2) {
  return _arrayWithoutHoles8(r2) || _iterableToArray8(r2) || _unsupportedIterableToArray8(r2) || _nonIterableSpread8();
}
function _nonIterableSpread8() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray8(r2) {
  if ("undefined" != typeof Symbol && null != r2[Symbol.iterator] || null != r2["@@iterator"]) return Array.from(r2);
}
function _arrayWithoutHoles8(r2) {
  if (Array.isArray(r2)) return _arrayLikeToArray8(r2);
}
function _slicedToArray2(r2, e3) {
  return _arrayWithHoles3(r2) || _iterableToArrayLimit2(r2, e3) || _unsupportedIterableToArray8(r2, e3) || _nonIterableRest3();
}
function _nonIterableRest3() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray8(r2, a) {
  if (r2) {
    if ("string" == typeof r2) return _arrayLikeToArray8(r2, a);
    var t2 = {}.toString.call(r2).slice(8, -1);
    return "Object" === t2 && r2.constructor && (t2 = r2.constructor.name), "Map" === t2 || "Set" === t2 ? Array.from(r2) : "Arguments" === t2 || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t2) ? _arrayLikeToArray8(r2, a) : void 0;
  }
}
function _arrayLikeToArray8(r2, a) {
  (null == a || a > r2.length) && (a = r2.length);
  for (var e3 = 0, n2 = Array(a); e3 < a; e3++) n2[e3] = r2[e3];
  return n2;
}
function _iterableToArrayLimit2(r2, l2) {
  var t2 = null == r2 ? null : "undefined" != typeof Symbol && r2[Symbol.iterator] || r2["@@iterator"];
  if (null != t2) {
    var e3, n2, i, u, a = [], f = true, o3 = false;
    try {
      if (i = (t2 = t2.call(r2)).next, 0 === l2) {
        if (Object(t2) !== t2) return;
        f = false;
      } else for (; !(f = (e3 = i.call(t2)).done) && (a.push(e3.value), a.length !== l2); f = true) ;
    } catch (r3) {
      o3 = true, n2 = r3;
    } finally {
      try {
        if (!f && null != t2.return && (u = t2.return(), Object(u) !== u)) return;
      } finally {
        if (o3) throw n2;
      }
    }
    return a;
  }
}
function _arrayWithHoles3(r2) {
  if (Array.isArray(r2)) return r2;
}
var UpperContext2 = /* @__PURE__ */ (0, import_react178.createContext)(function() {
});
var main_default2 = (function(props) {
  var _useState = (0, import_react178.useState)([]), _useState2 = _slicedToArray2(_useState, 2), _ = _useState2[0], setListData = _useState2[1];
  var configContext = props.configContext;
  var store = (0, import_react178.useContext)(FRContext);
  var formCtx = useStore(store, function(state) {
    return state.context;
  });
  var upperCtx = (0, import_react178.useContext)(UpperContext2);
  var form = configContext.form, widgets = configContext.widgets, methods2 = configContext.methods, globalConfig2 = configContext.globalConfig;
  var displayType = formCtx.displayType;
  var isDisplayColumn = displayType === "column";
  var _schema = props.schema;
  var formData = form.getFieldsValue(true);
  var _store$getState = store.getState(), formSchema = _store$getState.schema;
  var items = _schema.items, className2 = _schema.className, otherSchema = __rest(_schema, ["items", "className"]);
  var schema = (globalConfig2 === null || globalConfig2 === void 0 ? void 0 : globalConfig2.mustacheDisabled) ? _schema : Object.assign({
    items
  }, _parseAllExpression(otherSchema, formData, props.rootPath, formSchema));
  var widget = schema.widget;
  var widgetName = widget || "list1";
  var getValueFromKey = getParamValue3(formCtx, upperCtx, schema);
  var label = getLabel3(schema, displayType, widgets);
  var tooltip = getTooltip3(schema, displayType);
  var _getFormListLayout = getFormListLayout(getValueFromKey, displayType), labelCol = _getFormListLayout.labelCol, fieldCol = _getFormListLayout.fieldCol;
  var isInline = schema.display === "inline";
  var preRootPath = _toConsumableArray8(props.rootPath || []).splice(0, props.rootPath.length - 1);
  var listData = form.getFieldValue([].concat(_toConsumableArray8(preRootPath), _toConsumableArray8(props.path)));
  if (!(listData === null || listData === void 0 ? void 0 : listData.length) && widgetName !== "drawerList") {
    isInline = true;
  }
  if (schema.hidden) {
    return null;
  }
  return /* @__PURE__ */ import_react178.default.createElement(col_default2, {
    span: 24,
    className: className2
  }, !isInline && !isDisplayColumn && label && /* @__PURE__ */ import_react178.default.createElement(form_default.Item, {
    className: "ant-form-item-optional-hide",
    label,
    labelAlign: "left",
    colon: false,
    tooltip,
    style: {
      marginBottom: 0
    },
    labelCol: {
      span: 24
    }
  }), /* @__PURE__ */ import_react178.default.createElement(form_default.Item, {
    label,
    labelCol: isDisplayColumn ? {
      span: 24
    } : labelCol,
    wrapperCol: fieldCol,
    noStyle: !isInline && !isDisplayColumn,
    tooltip
  }, /* @__PURE__ */ import_react178.default.createElement(field_default, Object.assign({}, props, {
    form,
    methods: methods2,
    formCtx,
    upperCtx,
    widgets,
    configContext,
    setListData
  }))));
});

// ../../node_modules/form-render/es/render-core/FieldList/index.js
var FieldList_default = (function(props) {
  var _a;
  var schema = props.schema, rootPath = props.rootPath;
  var _b = schema || {}, items = _b.items, listSchema = __rest(_b, ["items"]);
  var store = (0, import_react179.useContext)(FRContext);
  var _store$getState = store.getState(), formSchema = _store$getState.schema;
  var configCtx = (0, import_react179.useContext)(ConfigContext2);
  var mustacheDisabled = (_a = configCtx === null || configCtx === void 0 ? void 0 : configCtx.globalConfig) === null || _a === void 0 ? void 0 : _a.mustacheDisabled;
  var dependencies = schema === null || schema === void 0 ? void 0 : schema.dependencies;
  if (!_isHasExpression(schema) && !mustacheDisabled && (!dependencies || !(dependencies === null || dependencies === void 0 ? void 0 : dependencies.length))) {
    return /* @__PURE__ */ import_react179.default.createElement(main_default2, Object.assign({
      configContext: configCtx
    }, props));
  }
  return /* @__PURE__ */ import_react179.default.createElement(form_default.Item, {
    noStyle: true,
    shouldUpdate: fieldShouldUpdate_default(JSON.stringify(listSchema || {}), rootPath, dependencies, true)
  }, function(form) {
    var formData = form.getFieldsValue(true);
    var newListSchema = mustacheDisabled ? schema : _parseAllExpression(listSchema, formData, rootPath, formSchema);
    return /* @__PURE__ */ import_react179.default.createElement(main_default2, Object.assign({
      configContext: configCtx
    }, props, {
      schema: Object.assign({
        items
      }, newListSchema),
      rootPath
    }));
  });
});

// ../../node_modules/form-render/es/models/sortProperties.js
function _slicedToArray3(r2, e3) {
  return _arrayWithHoles4(r2) || _iterableToArrayLimit3(r2, e3) || _unsupportedIterableToArray9(r2, e3) || _nonIterableRest4();
}
function _nonIterableRest4() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray9(r2, a) {
  if (r2) {
    if ("string" == typeof r2) return _arrayLikeToArray9(r2, a);
    var t2 = {}.toString.call(r2).slice(8, -1);
    return "Object" === t2 && r2.constructor && (t2 = r2.constructor.name), "Map" === t2 || "Set" === t2 ? Array.from(r2) : "Arguments" === t2 || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t2) ? _arrayLikeToArray9(r2, a) : void 0;
  }
}
function _arrayLikeToArray9(r2, a) {
  (null == a || a > r2.length) && (a = r2.length);
  for (var e3 = 0, n2 = Array(a); e3 < a; e3++) n2[e3] = r2[e3];
  return n2;
}
function _iterableToArrayLimit3(r2, l2) {
  var t2 = null == r2 ? null : "undefined" != typeof Symbol && r2[Symbol.iterator] || r2["@@iterator"];
  if (null != t2) {
    var e3, n2, i, u, a = [], f = true, o3 = false;
    try {
      if (i = (t2 = t2.call(r2)).next, 0 === l2) {
        if (Object(t2) !== t2) return;
        f = false;
      } else for (; !(f = (e3 = i.call(t2)).done) && (a.push(e3.value), a.length !== l2); f = true) ;
    } catch (r3) {
      o3 = true, n2 = r3;
    } finally {
      try {
        if (!f && null != t2.return && (u = t2.return(), Object(u) !== u)) return;
      } finally {
        if (o3) throw n2;
      }
    }
    return a;
  }
}
function _arrayWithHoles4(r2) {
  if (Array.isArray(r2)) return r2;
}
var sortProperties_default = (function(properties2) {
  var orderKey = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "order";
  var orderHash = /* @__PURE__ */ new Map();
  var unsortedList = [];
  var insert = function insert2(item) {
    var _item = _slicedToArray3(item, 2), value = _item[1];
    if (typeof value[orderKey] !== "number") {
      unsortedList.push(item);
      return;
    }
    if (orderHash.has(value[orderKey])) {
      orderHash.get(value[orderKey]).push(item);
    } else {
      orderHash.set(value[orderKey], [item]);
    }
  };
  properties2.forEach(function(item) {
    return insert(item);
  });
  var sortedList = Array.from(orderHash.entries()).sort(function(_ref, _ref2) {
    var _ref3 = _slicedToArray3(_ref, 1), order1 = _ref3[0];
    var _ref4 = _slicedToArray3(_ref2, 1), order2 = _ref4[0];
    return order1 - order2;
  }).flatMap(function(_ref5) {
    var _ref6 = _slicedToArray3(_ref5, 2), items = _ref6[1];
    return items;
  });
  return sortedList.concat(unsortedList);
});

// ../../node_modules/form-render/es/render-core/index.js
function _toConsumableArray9(r2) {
  return _arrayWithoutHoles9(r2) || _iterableToArray9(r2) || _unsupportedIterableToArray10(r2) || _nonIterableSpread9();
}
function _nonIterableSpread9() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray9(r2) {
  if ("undefined" != typeof Symbol && null != r2[Symbol.iterator] || null != r2["@@iterator"]) return Array.from(r2);
}
function _arrayWithoutHoles9(r2) {
  if (Array.isArray(r2)) return _arrayLikeToArray10(r2);
}
function _slicedToArray4(r2, e3) {
  return _arrayWithHoles5(r2) || _iterableToArrayLimit4(r2, e3) || _unsupportedIterableToArray10(r2, e3) || _nonIterableRest5();
}
function _nonIterableRest5() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray10(r2, a) {
  if (r2) {
    if ("string" == typeof r2) return _arrayLikeToArray10(r2, a);
    var t2 = {}.toString.call(r2).slice(8, -1);
    return "Object" === t2 && r2.constructor && (t2 = r2.constructor.name), "Map" === t2 || "Set" === t2 ? Array.from(r2) : "Arguments" === t2 || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t2) ? _arrayLikeToArray10(r2, a) : void 0;
  }
}
function _arrayLikeToArray10(r2, a) {
  (null == a || a > r2.length) && (a = r2.length);
  for (var e3 = 0, n2 = Array(a); e3 < a; e3++) n2[e3] = r2[e3];
  return n2;
}
function _iterableToArrayLimit4(r2, l2) {
  var t2 = null == r2 ? null : "undefined" != typeof Symbol && r2[Symbol.iterator] || r2["@@iterator"];
  if (null != t2) {
    var e3, n2, i, u, a = [], f = true, o3 = false;
    try {
      if (i = (t2 = t2.call(r2)).next, 0 === l2) {
        if (Object(t2) !== t2) return;
        f = false;
      } else for (; !(f = (e3 = i.call(t2)).done) && (a.push(e3.value), a.length !== l2); f = true) ;
    } catch (r3) {
      o3 = true, n2 = r3;
    } finally {
      try {
        if (!f && null != t2.return && (u = t2.return(), Object(u) !== u)) return;
      } finally {
        if (o3) throw n2;
      }
    }
    return a;
  }
}
function _arrayWithHoles5(r2) {
  if (Array.isArray(r2)) return r2;
}
var renderItem = function renderItem2(props) {
  var _a;
  var schema = props.schema, key2 = props.key, path2 = props.path, rootPath = props.rootPath;
  if (schema.type === "array" && ((_a = schema.items) === null || _a === void 0 ? void 0 : _a.type) === "object") {
    return /* @__PURE__ */ import_react180.default.createElement(FieldList_default, {
      key: key2,
      schema,
      path: path2,
      rootPath,
      renderCore: RenderCore
    });
  }
  var child = null;
  if ((schema === null || schema === void 0 ? void 0 : schema.properties) && (schema === null || schema === void 0 ? void 0 : schema.widgetType) !== "field") {
    child = RenderCore({
      schema,
      parentPath: path2,
      rootPath
    });
  }
  return /* @__PURE__ */ import_react180.default.createElement(FieldItem_default, {
    key: key2,
    schema,
    path: path2,
    rootPath,
    children: child,
    renderCore: RenderCore
  });
};
var RenderCore = function RenderCore2(props) {
  var schema = props.schema, _props$parentPath = props.parentPath, parentPath = _props$parentPath === void 0 ? [] : _props$parentPath, _props$rootPath = props.rootPath, rootPath = _props$rootPath === void 0 ? [] : _props$rootPath;
  if (!schema || Object.keys(schema).length === 0) {
    return null;
  }
  if (schema === null || schema === void 0 ? void 0 : schema.items) {
    return renderItem({
      schema: schema.items,
      path: parentPath,
      rootPath
    });
  }
  return sortProperties_default(Object.entries(schema.properties || {})).map(function(_ref) {
    var _ref2 = _slicedToArray4(_ref, 2), key2 = _ref2[0], item = _ref2[1];
    var path2 = [].concat(_toConsumableArray9(parentPath), [key2]);
    return renderItem({
      schema: item,
      path: path2,
      key: key2,
      rootPath
    });
  });
};
var render_core_default = RenderCore;

// ../../node_modules/form-render/es/form-core/index.js
function _typeof7(o3) {
  "@babel/helpers - typeof";
  return _typeof7 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o4) {
    return typeof o4;
  } : function(o4) {
    return o4 && "function" == typeof Symbol && o4.constructor === Symbol && o4 !== Symbol.prototype ? "symbol" : typeof o4;
  }, _typeof7(o3);
}
function _defineProperty4(e3, r2, t2) {
  return (r2 = _toPropertyKey3(r2)) in e3 ? Object.defineProperty(e3, r2, { value: t2, enumerable: true, configurable: true, writable: true }) : e3[r2] = t2, e3;
}
function _toPropertyKey3(t2) {
  var i = _toPrimitive3(t2, "string");
  return "symbol" == _typeof7(i) ? i : i + "";
}
function _toPrimitive3(t2, r2) {
  if ("object" != _typeof7(t2) || !t2) return t2;
  var e3 = t2[Symbol.toPrimitive];
  if (void 0 !== e3) {
    var i = e3.call(t2, r2 || "default");
    if ("object" != _typeof7(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t2);
}
function _regeneratorRuntime4() {
  "use strict";
  _regeneratorRuntime4 = function _regeneratorRuntime6() {
    return e3;
  };
  var t2, e3 = {}, r2 = Object.prototype, n2 = r2.hasOwnProperty, o3 = Object.defineProperty || function(t3, e4, r3) {
    t3[e4] = r3.value;
  }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
  function define2(t3, e4, r3) {
    return Object.defineProperty(t3, e4, { value: r3, enumerable: true, configurable: true, writable: true }), t3[e4];
  }
  try {
    define2({}, "");
  } catch (t3) {
    define2 = function define3(t4, e4, r3) {
      return t4[e4] = r3;
    };
  }
  function wrap(t3, e4, r3, n3) {
    var i2 = e4 && e4.prototype instanceof Generator ? e4 : Generator, a2 = Object.create(i2.prototype), c2 = new Context4(n3 || []);
    return o3(a2, "_invoke", { value: makeInvokeMethod(t3, r3, c2) }), a2;
  }
  function tryCatch(t3, e4, r3) {
    try {
      return { type: "normal", arg: t3.call(e4, r3) };
    } catch (t4) {
      return { type: "throw", arg: t4 };
    }
  }
  e3.wrap = wrap;
  var h2 = "suspendedStart", l2 = "suspendedYield", f = "executing", s = "completed", y = {};
  function Generator() {
  }
  function GeneratorFunction() {
  }
  function GeneratorFunctionPrototype() {
  }
  var p = {};
  define2(p, a, function() {
    return this;
  });
  var d = Object.getPrototypeOf, v = d && d(d(values([])));
  v && v !== r2 && n2.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t3) {
    ["next", "throw", "return"].forEach(function(e4) {
      define2(t3, e4, function(t4) {
        return this._invoke(e4, t4);
      });
    });
  }
  function AsyncIterator3(t3, e4) {
    function invoke(r4, o4, i2, a2) {
      var c2 = tryCatch(t3[r4], t3, o4);
      if ("throw" !== c2.type) {
        var u2 = c2.arg, h3 = u2.value;
        return h3 && "object" == _typeof7(h3) && n2.call(h3, "__await") ? e4.resolve(h3.__await).then(function(t4) {
          invoke("next", t4, i2, a2);
        }, function(t4) {
          invoke("throw", t4, i2, a2);
        }) : e4.resolve(h3).then(function(t4) {
          u2.value = t4, i2(u2);
        }, function(t4) {
          return invoke("throw", t4, i2, a2);
        });
      }
      a2(c2.arg);
    }
    var r3;
    o3(this, "_invoke", { value: function value(t4, n3) {
      function callInvokeWithMethodAndArg() {
        return new e4(function(e5, r4) {
          invoke(t4, n3, e5, r4);
        });
      }
      return r3 = r3 ? r3.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    } });
  }
  function makeInvokeMethod(e4, r3, n3) {
    var o4 = h2;
    return function(i2, a2) {
      if (o4 === f) throw Error("Generator is already running");
      if (o4 === s) {
        if ("throw" === i2) throw a2;
        return { value: t2, done: true };
      }
      for (n3.method = i2, n3.arg = a2; ; ) {
        var c2 = n3.delegate;
        if (c2) {
          var u2 = maybeInvokeDelegate(c2, n3);
          if (u2) {
            if (u2 === y) continue;
            return u2;
          }
        }
        if ("next" === n3.method) n3.sent = n3._sent = n3.arg;
        else if ("throw" === n3.method) {
          if (o4 === h2) throw o4 = s, n3.arg;
          n3.dispatchException(n3.arg);
        } else "return" === n3.method && n3.abrupt("return", n3.arg);
        o4 = f;
        var p2 = tryCatch(e4, r3, n3);
        if ("normal" === p2.type) {
          if (o4 = n3.done ? s : l2, p2.arg === y) continue;
          return { value: p2.arg, done: n3.done };
        }
        "throw" === p2.type && (o4 = s, n3.method = "throw", n3.arg = p2.arg);
      }
    };
  }
  function maybeInvokeDelegate(e4, r3) {
    var n3 = r3.method, o4 = e4.iterator[n3];
    if (o4 === t2) return r3.delegate = null, "throw" === n3 && e4.iterator.return && (r3.method = "return", r3.arg = t2, maybeInvokeDelegate(e4, r3), "throw" === r3.method) || "return" !== n3 && (r3.method = "throw", r3.arg = new TypeError("The iterator does not provide a '" + n3 + "' method")), y;
    var i2 = tryCatch(o4, e4.iterator, r3.arg);
    if ("throw" === i2.type) return r3.method = "throw", r3.arg = i2.arg, r3.delegate = null, y;
    var a2 = i2.arg;
    return a2 ? a2.done ? (r3[e4.resultName] = a2.value, r3.next = e4.nextLoc, "return" !== r3.method && (r3.method = "next", r3.arg = t2), r3.delegate = null, y) : a2 : (r3.method = "throw", r3.arg = new TypeError("iterator result is not an object"), r3.delegate = null, y);
  }
  function pushTryEntry(t3) {
    var e4 = { tryLoc: t3[0] };
    1 in t3 && (e4.catchLoc = t3[1]), 2 in t3 && (e4.finallyLoc = t3[2], e4.afterLoc = t3[3]), this.tryEntries.push(e4);
  }
  function resetTryEntry(t3) {
    var e4 = t3.completion || {};
    e4.type = "normal", delete e4.arg, t3.completion = e4;
  }
  function Context4(t3) {
    this.tryEntries = [{ tryLoc: "root" }], t3.forEach(pushTryEntry, this), this.reset(true);
  }
  function values(e4) {
    if (e4 || "" === e4) {
      var r3 = e4[a];
      if (r3) return r3.call(e4);
      if ("function" == typeof e4.next) return e4;
      if (!isNaN(e4.length)) {
        var o4 = -1, i2 = function next2() {
          for (; ++o4 < e4.length; ) if (n2.call(e4, o4)) return next2.value = e4[o4], next2.done = false, next2;
          return next2.value = t2, next2.done = true, next2;
        };
        return i2.next = i2;
      }
    }
    throw new TypeError(_typeof7(e4) + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o3(g, "constructor", { value: GeneratorFunctionPrototype, configurable: true }), o3(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: true }), GeneratorFunction.displayName = define2(GeneratorFunctionPrototype, u, "GeneratorFunction"), e3.isGeneratorFunction = function(t3) {
    var e4 = "function" == typeof t3 && t3.constructor;
    return !!e4 && (e4 === GeneratorFunction || "GeneratorFunction" === (e4.displayName || e4.name));
  }, e3.mark = function(t3) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t3, GeneratorFunctionPrototype) : (t3.__proto__ = GeneratorFunctionPrototype, define2(t3, u, "GeneratorFunction")), t3.prototype = Object.create(g), t3;
  }, e3.awrap = function(t3) {
    return { __await: t3 };
  }, defineIteratorMethods(AsyncIterator3.prototype), define2(AsyncIterator3.prototype, c, function() {
    return this;
  }), e3.AsyncIterator = AsyncIterator3, e3.async = function(t3, r3, n3, o4, i2) {
    void 0 === i2 && (i2 = Promise);
    var a2 = new AsyncIterator3(wrap(t3, r3, n3, o4), i2);
    return e3.isGeneratorFunction(r3) ? a2 : a2.next().then(function(t4) {
      return t4.done ? t4.value : a2.next();
    });
  }, defineIteratorMethods(g), define2(g, u, "Generator"), define2(g, a, function() {
    return this;
  }), define2(g, "toString", function() {
    return "[object Generator]";
  }), e3.keys = function(t3) {
    var e4 = Object(t3), r3 = [];
    for (var n3 in e4) r3.push(n3);
    return r3.reverse(), function next2() {
      for (; r3.length; ) {
        var t4 = r3.pop();
        if (t4 in e4) return next2.value = t4, next2.done = false, next2;
      }
      return next2.done = true, next2;
    };
  }, e3.values = values, Context4.prototype = { constructor: Context4, reset: function reset2(e4) {
    if (this.prev = 0, this.next = 0, this.sent = this._sent = t2, this.done = false, this.delegate = null, this.method = "next", this.arg = t2, this.tryEntries.forEach(resetTryEntry), !e4) for (var r3 in this) "t" === r3.charAt(0) && n2.call(this, r3) && !isNaN(+r3.slice(1)) && (this[r3] = t2);
  }, stop: function stop() {
    this.done = true;
    var t3 = this.tryEntries[0].completion;
    if ("throw" === t3.type) throw t3.arg;
    return this.rval;
  }, dispatchException: function dispatchException(e4) {
    if (this.done) throw e4;
    var r3 = this;
    function handle(n3, o5) {
      return a2.type = "throw", a2.arg = e4, r3.next = n3, o5 && (r3.method = "next", r3.arg = t2), !!o5;
    }
    for (var o4 = this.tryEntries.length - 1; o4 >= 0; --o4) {
      var i2 = this.tryEntries[o4], a2 = i2.completion;
      if ("root" === i2.tryLoc) return handle("end");
      if (i2.tryLoc <= this.prev) {
        var c2 = n2.call(i2, "catchLoc"), u2 = n2.call(i2, "finallyLoc");
        if (c2 && u2) {
          if (this.prev < i2.catchLoc) return handle(i2.catchLoc, true);
          if (this.prev < i2.finallyLoc) return handle(i2.finallyLoc);
        } else if (c2) {
          if (this.prev < i2.catchLoc) return handle(i2.catchLoc, true);
        } else {
          if (!u2) throw Error("try statement without catch or finally");
          if (this.prev < i2.finallyLoc) return handle(i2.finallyLoc);
        }
      }
    }
  }, abrupt: function abrupt(t3, e4) {
    for (var r3 = this.tryEntries.length - 1; r3 >= 0; --r3) {
      var o4 = this.tryEntries[r3];
      if (o4.tryLoc <= this.prev && n2.call(o4, "finallyLoc") && this.prev < o4.finallyLoc) {
        var i2 = o4;
        break;
      }
    }
    i2 && ("break" === t3 || "continue" === t3) && i2.tryLoc <= e4 && e4 <= i2.finallyLoc && (i2 = null);
    var a2 = i2 ? i2.completion : {};
    return a2.type = t3, a2.arg = e4, i2 ? (this.method = "next", this.next = i2.finallyLoc, y) : this.complete(a2);
  }, complete: function complete(t3, e4) {
    if ("throw" === t3.type) throw t3.arg;
    return "break" === t3.type || "continue" === t3.type ? this.next = t3.arg : "return" === t3.type ? (this.rval = this.arg = t3.arg, this.method = "return", this.next = "end") : "normal" === t3.type && e4 && (this.next = e4), y;
  }, finish: function finish(t3) {
    for (var e4 = this.tryEntries.length - 1; e4 >= 0; --e4) {
      var r3 = this.tryEntries[e4];
      if (r3.finallyLoc === t3) return this.complete(r3.completion, r3.afterLoc), resetTryEntry(r3), y;
    }
  }, catch: function _catch(t3) {
    for (var e4 = this.tryEntries.length - 1; e4 >= 0; --e4) {
      var r3 = this.tryEntries[e4];
      if (r3.tryLoc === t3) {
        var n3 = r3.completion;
        if ("throw" === n3.type) {
          var o4 = n3.arg;
          resetTryEntry(r3);
        }
        return o4;
      }
    }
    throw Error("illegal catch attempt");
  }, delegateYield: function delegateYield(e4, r3, n3) {
    return this.delegate = { iterator: values(e4), resultName: r3, nextLoc: n3 }, "next" === this.method && (this.arg = t2), y;
  } }, e3;
}
var FormCore = function FormCore2(props) {
  var _a, _b, _c, _d, _e;
  var store = (0, import_react181.useContext)(FRContext);
  var schema = useStore(store, function(state) {
    return state.schema;
  });
  var flattenSchema2 = useStore(store, function(state) {
    return state.flattenSchema;
  });
  var setContext = useStore(store, function(state) {
    return state.setContext;
  });
  var configCtx = (0, import_react181.useContext)(config_provider_default.ConfigContext);
  var t2 = translation(configCtx);
  var _f = schema || {}, type5 = _f.type, properties2 = _f.properties, schemProps = __rest(_f, ["type", "properties"]);
  var _transformProps = transformProps_default(Object.assign(Object.assign({}, props), schemProps)), formProps = _transformProps.formProps, displayType = _transformProps.displayType, beforeFinish = _transformProps.beforeFinish, watch = _transformProps.watch, onMount = _transformProps.onMount, column2 = _transformProps.column, labelWidth = _transformProps.labelWidth, labelCol = _transformProps.labelCol, fieldCol = _transformProps.fieldCol, maxWidth = _transformProps.maxWidth, form = _transformProps.form, onFinish = _transformProps.onFinish, onFinishFailed = _transformProps.onFinishFailed, readOnly = _transformProps.readOnly, disabled = _transformProps.disabled, footer = _transformProps.footer, removeHiddenData = _transformProps.removeHiddenData, operateExtra = _transformProps.operateExtra, logOnMount = _transformProps.logOnMount, logOnSubmit = _transformProps.logOnSubmit, id = _transformProps.id, className2 = _transformProps.className, validateTrigger = _transformProps.validateTrigger, antdVersion = _transformProps.antdVersion;
  (0, import_react181.useEffect)(function() {
    form.__initStore(store);
    setTimeout(initial, 0);
    window.antdVersion = antdVersion;
  }, []);
  (0, import_react181.useEffect)(function() {
    form.setSchema(props.schema, true);
  }, [JSON.stringify(props.schema || {})]);
  (0, import_react181.useEffect)(function() {
    store.setState({
      removeHiddenData
    });
  }, [removeHiddenData]);
  (0, import_react181.useEffect)(function() {
    var context = {
      column: column2,
      readOnly,
      disabled,
      labelWidth,
      displayType,
      labelCol,
      fieldCol,
      maxWidth,
      validateTrigger
    };
    setContext(context);
  }, [column2, labelCol, fieldCol, displayType, labelWidth, maxWidth, readOnly, disabled, validateTrigger]);
  var initial = function initial2() {
    return __awaiter(void 0, void 0, void 0, /* @__PURE__ */ _regeneratorRuntime4().mark(function _callee() {
      return _regeneratorRuntime4().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.t0 = onMount;
            if (!_context.t0) {
              _context.next = 4;
              break;
            }
            _context.next = 4;
            return onMount();
          case 4:
            onMountLogger();
            setTimeout(function() {
              var values = form.getValues();
              immediateWatch(watch, values);
            }, 0);
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
  };
  var onMountLogger = function onMountLogger2() {
    var start = (/* @__PURE__ */ new Date()).getTime();
    if (isFunction2(logOnMount) || isFunction2(logOnSubmit)) {
      setSessionItem("FORM_MOUNT_TIME", start);
      setSessionItem("FORM_START", start);
    }
    if (isFunction2(logOnMount)) {
      var logParams = {
        schema: props.schema,
        url: location.href,
        formData: JSON.stringify(form.getValues()),
        formMount: yymmdd(start)
      };
      if (id) {
        logParams.id = id;
      }
      logOnMount(logParams);
    }
    if (isFunction2(logOnSubmit)) {
      setSessionItem("NUMBER_OF_SUBMITS", 0);
      setSessionItem("FAILED_ATTEMPTS", 0);
    }
  };
  var onSubmitLogger = function onSubmitLogger2(params) {
    if (!isFunction2(logOnSubmit)) {
      return;
    }
    var start = getSessionItem("FORM_START");
    var mount = getSessionItem("FORM_MOUNT_TIME");
    var numberOfSubmits = getSessionItem("NUMBER_OF_SUBMITS") + 1;
    var end = (/* @__PURE__ */ new Date()).getTime();
    var failedAttempts = getSessionItem("FAILED_ATTEMPTS");
    if (params.errorFields.length > 0) {
      failedAttempts = failedAttempts + 1;
    }
    var logParams = {
      formMount: yymmdd(mount),
      ms: end - start,
      duration: msToTime(end - start),
      numberOfSubmits,
      failedAttempts,
      url: location.href,
      formData: JSON.stringify(params.values),
      errors: JSON.stringify(params.errorFields),
      schema: JSON.stringify(schema)
    };
    if (id) {
      logParams.id = id;
    }
    logOnSubmit(logParams);
    setSessionItem("FORM_START", end);
    setSessionItem("NUMBER_OF_SUBMITS", numberOfSubmits);
    setSessionItem("FAILED_ATTEMPTS", failedAttempts);
  };
  var handleValuesChange = function handleValuesChange2(changedValues, _allValues) {
    var allValues = filterValuesUndefined_default(_allValues, true);
    valuesWatch(changedValues, allValues, watch);
  };
  var transFormValues = function transFormValues2(_values) {
    var values = cloneDeep_default(_values);
    values = removeHiddenData ? filterValuesHidden_default(values, flattenSchema2) : cloneDeep_default(form.getFieldsValue(true));
    values = parseValuesToBind(values, flattenSchema2);
    values = filterValuesUndefined_default(values);
    return values;
  };
  var handleFinish = function handleFinish2(_values) {
    return __awaiter(void 0, void 0, void 0, /* @__PURE__ */ _regeneratorRuntime4().mark(function _callee2() {
      var values, fieldsError;
      return _regeneratorRuntime4().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            values = transFormValues(_values);
            if (!beforeFinish) {
              _context2.next = 7;
              break;
            }
            _context2.next = 4;
            return beforeFinish({
              data: values,
              schema,
              errors: []
            });
          case 4:
            _context2.t0 = _context2.sent;
            _context2.next = 8;
            break;
          case 7:
            _context2.t0 = null;
          case 8:
            fieldsError = _context2.t0;
            if (!((fieldsError === null || fieldsError === void 0 ? void 0 : fieldsError.length) > 0)) {
              _context2.next = 12;
              break;
            }
            form.setFields(fieldsError);
            return _context2.abrupt("return");
          case 12:
            onSubmitLogger({
              values
            });
            onFinish && onFinish(values, []);
          case 14:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
  };
  var handleFinishFailed = function handleFinishFailed2(params) {
    return __awaiter(void 0, void 0, void 0, /* @__PURE__ */ _regeneratorRuntime4().mark(function _callee3() {
      var values;
      return _regeneratorRuntime4().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            values = transFormValues(params.values);
            onSubmitLogger(Object.assign(Object.assign({}, params), {
              values
            }));
            if (onFinishFailed) {
              _context3.next = 4;
              break;
            }
            return _context3.abrupt("return");
          case 4:
            onFinishFailed(Object.assign(Object.assign({}, params), {
              values
            }));
          case 5:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
  };
  var operlabelCol = (_a = getFormItemLayout(column2, {}, {
    labelWidth
  })) === null || _a === void 0 ? void 0 : _a.labelCol;
  var actionBtns = [];
  if (!((_b = footer === null || footer === void 0 ? void 0 : footer.reset) === null || _b === void 0 ? void 0 : _b.hide)) {
    actionBtns.push(/* @__PURE__ */ import_react181.default.createElement(button_default2, Object.assign({
      key: "reset"
    }, footer === null || footer === void 0 ? void 0 : footer.reset, {
      onClick: function onClick() {
        return form.resetFields();
      }
    }), ((_c = footer === null || footer === void 0 ? void 0 : footer.reset) === null || _c === void 0 ? void 0 : _c.text) || t2("reset")));
  }
  if (!((_d = footer === null || footer === void 0 ? void 0 : footer.submit) === null || _d === void 0 ? void 0 : _d.hide)) {
    actionBtns.push(/* @__PURE__ */ import_react181.default.createElement(button_default2, Object.assign({
      key: "submit",
      type: "primary",
      onClick: form.submit
    }, footer === null || footer === void 0 ? void 0 : footer.submit), ((_e = footer === null || footer === void 0 ? void 0 : footer.submit) === null || _e === void 0 ? void 0 : _e.text) || t2("submit")));
  }
  return /* @__PURE__ */ import_react181.default.createElement(form_default, Object.assign({
    className: (0, import_classnames207.default)("fr-form", _defineProperty4({}, className2, !!className2)),
    labelWrap: true
  }, formProps, {
    disabled,
    form,
    onFinish: handleFinish,
    onFinishFailed: handleFinishFailed,
    onValuesChange: handleValuesChange
  }), /* @__PURE__ */ import_react181.default.createElement(row_default2, {
    gutter: displayType === "row" ? 16 : 24
  }, /* @__PURE__ */ import_react181.default.createElement(render_core_default, {
    schema
  }), operateExtra), schema && !!footer && /* @__PURE__ */ import_react181.default.createElement(row_default2, {
    gutter: displayType === "row" ? 16 : 24
  }, /* @__PURE__ */ import_react181.default.createElement(col_default2, {
    span: 24 / column2
  }, /* @__PURE__ */ import_react181.default.createElement(form_default.Item, {
    label: displayType !== "column" ? "hideLabel" : null,
    labelCol: operlabelCol,
    className: "fr-hide-label"
  }, isFunction2(footer) ? /* @__PURE__ */ import_react181.default.createElement(space_default, null, footer(actionBtns)) : /* @__PURE__ */ import_react181.default.createElement(space_default, null, actionBtns)))));
};
var form_core_default = FormCore;

// ../../node_modules/form-render/es/withProvider.js
var import_react182 = __toESM(require_react());
var import_dayjs2 = __toESM(require_dayjs_min());
var import_zh_CN3 = __toESM(require_zh_CN6());
var import_en_US20 = __toESM(require_en_US6());

// ../../node_modules/form-render/es/locales/en_US.js
var en_US_default7 = {
  "copy_max_tip": "The maximum number of table items has been reached and cannot be copied",
  "copy": "Copy",
  "add_item": "Add a new line",
  "confirm_delete": "Are you sure to delete?",
  "confirm": "Yes",
  "cancel": "No",
  "operate": "Operate",
  "delete": "Delete",
  "edit": "Edit",
  "img_src_error": "Image address error",
  "upload": "Upload",
  "upload_success": "upload success",
  "upload_fail": "upload failed",
  "uploaded_address": "Uploaded address",
  "test_src": "Test address",
  "schema_not_match": "Schema does not match the display component\uFF1A",
  "item": "Item",
  "search": "Search",
  "reset": "Reset",
  "expand": "Expand",
  "fold": "Fold",
  "submit": "Submit",
  "save": "Save",
  "moveDown": "Move Down",
  "moveUp": "Move Up"
};

// ../../node_modules/form-render/es/locales/zh_CN.js
var zh_CN_default2 = {
  "copy_max_tip": "\u5DF2\u8FBE\u8868\u5355\u9879\u6570\u91CF\u4E0A\u9650\uFF0C\u65E0\u6CD5\u590D\u5236\uFF01",
  "copy": "\u590D\u5236",
  "add_item": "\u65B0\u589E\u4E00\u6761",
  "confirm_delete": "\u786E\u5B9A\u5220\u9664?",
  "confirm": "\u786E\u5B9A",
  "cancel": "\u53D6\u6D88",
  "operate": "\u64CD\u4F5C",
  "delete": "\u5220\u9664",
  "edit": "\u7F16\u8F91",
  "img_src_error": "\u56FE\u7247\u5730\u5740\u9519\u8BEF",
  "upload": "\u4E0A\u4F20",
  "upload_success": "\u4E0A\u4F20\u6210\u529F",
  "upload_fail": "\u4E0A\u4F20\u5931\u8D25",
  "uploaded_address": "\u5DF2\u4E0A\u4F20\u5730\u5740",
  "test_src": "\u6D4B\u8BD5\u94FE\u63A5",
  "schema_not_match": "schema\u672A\u5339\u914D\u5230\u5C55\u793A\u7EC4\u4EF6\uFF1A",
  "item": "\u9879\u76EE",
  "search": "\u67E5\u8BE2",
  "reset": "\u91CD\u7F6E",
  "expand": "\u5C55\u5F00",
  "fold": "\u6536\u8D77",
  "submit": "\u63D0\u4EA4",
  "save": "\u4FDD\u5B58",
  "moveDown": "\u4E0B\u79FB",
  "moveUp": "\u4E0A\u79FB"
};

// ../../node_modules/form-render/es/locales/index.js
var locales_default = {
  "en-US": en_US_default7,
  "zh-CN": zh_CN_default2
};

// ../../node_modules/form-render/es/withProvider.js
var import_zh_cn = __toESM(require_zh_cn());

// ../../node_modules/form-render/es/models/store.js
var createStore2 = function createStore3() {
  return createStore(function(setState, get3) {
    return {
      initialized: false,
      schema: {},
      flattenSchema: {},
      context: {},
      init: function init2(data2) {
        return setState(Object.assign({
          initialized: true
        }, data2));
      },
      setContext: function setContext(context) {
        return setState({
          context
        });
      }
    };
  });
};

// ../../node_modules/form-render/es/models/validateMessage.js
var typeTemplate3 = "'${label}' is not a valid ${type}";
var typeTemplateCN = "\u6570\u636E\u7C7B\u578B\u5FC5\u987B\u662F ${type}";
var validateMessagesEN = {
  default: "Validation error on field '${label}'",
  required: "'${label}' is required",
  enum: "'${label}' must be one of [${enum}]",
  whitespace: "'${label}' cannot be empty",
  date: {
    format: "'${label}' is invalid for format date",
    parse: "'${label}' could not be parsed as date",
    invalid: "'${label}' is invalid date"
  },
  types: {
    string: typeTemplate3,
    method: typeTemplate3,
    array: typeTemplate3,
    object: typeTemplate3,
    number: typeTemplate3,
    date: typeTemplate3,
    boolean: typeTemplate3,
    integer: typeTemplate3,
    float: typeTemplate3,
    regexp: typeTemplate3,
    email: typeTemplate3,
    url: typeTemplate3,
    hex: typeTemplate3
  },
  string: {
    len: "'${label}' must be exactly ${len} characters",
    min: "'${label}' must be at least ${min} characters",
    max: "'${label}' cannot be longer than ${max} characters",
    range: "'${label}' must be between ${min} and ${max} characters"
  },
  number: {
    len: "'${label}' must equal ${len}",
    min: "'${label}' cannot be less than ${min}",
    max: "'${label}' cannot be greater than ${max}",
    range: "'${label}' must be between ${min} and ${max}"
  },
  array: {
    len: "'${label}' must be exactly ${len} in length",
    min: "'${label}' cannot be less than ${min} in length",
    max: "'${label}' cannot be greater than ${max} in length",
    range: "'${label}' must be between ${min} and ${max} in length"
  },
  pattern: {
    mismatch: "'${label}' does not match pattern ${pattern}"
  }
};
var validateMessagesCN = {
  default: "${label}\u672A\u901A\u8FC7\u6821\u9A8C",
  required: "${label}\u5FC5\u586B",
  whitespace: "${label}\u4E0D\u80FD\u4E3A\u7A7A",
  date: {
    format: "${label}\u7684\u683C\u5F0F\u9519\u8BEF",
    parse: "${label}\u65E0\u6CD5\u88AB\u89E3\u6790",
    invalid: "${label}\u6570\u636E\u4E0D\u5408\u6CD5"
  },
  types: {
    string: typeTemplateCN,
    method: typeTemplateCN,
    array: typeTemplateCN,
    object: typeTemplateCN,
    number: typeTemplateCN,
    date: typeTemplateCN,
    boolean: typeTemplateCN,
    integer: typeTemplateCN,
    float: typeTemplateCN,
    regexp: typeTemplateCN,
    email: typeTemplateCN,
    url: typeTemplateCN,
    hex: typeTemplateCN
  },
  string: {
    len: "${label}\u957F\u5EA6\u4E0D\u662F${len}",
    min: "${label}\u957F\u5EA6\u4E0D\u80FD\u5C0F\u4E8E${min}",
    max: "${label}\u957F\u5EA6\u4E0D\u80FD\u5927\u4E8E${max}",
    range: "${label}\u957F\u5EA6\u9700\u5728${min}\u4E0E${max}\u4E4B\u95F4"
  },
  number: {
    len: "${label}\u4E0D\u7B49\u4E8E${len}",
    min: "${label}\u4E0D\u80FD\u5C0F\u4E8E${min}",
    max: "${label}\u4E0D\u80FD\u5927\u4E8E${max}",
    range: "${label}\u9700\u5728${min}\u4E0E${max}\u4E4B\u95F4"
  },
  array: {
    len: "${label}\u957F\u5EA6\u4E0D\u662F${len}",
    min: "${label}\u957F\u5EA6\u4E0D\u80FD\u5C0F\u4E8E${min}",
    max: "${label}\u957F\u5EA6\u4E0D\u80FD\u5927\u4E8E${max}",
    range: "${label}\u957F\u5EA6\u9700\u5728${min}\u4E0E${max}\u4E4B\u95F4"
  },
  pattern: {
    mismatch: "${label}\u672A\u901A\u8FC7\u6B63\u5219\u5224\u65AD${pattern}"
  }
};

// ../../node_modules/form-render/es/withProvider.js
function withProvider(Element3, defaultWidgets) {
  return function(props) {
    var configProvider = props.configProvider, _props$locale = props.locale, locale6 = _props$locale === void 0 ? "zh-CN" : _props$locale, widgets = props.widgets, methods2 = props.methods, form = props.form, validateMessages = props.validateMessages, _props$globalProps = props.globalProps, globalProps = _props$globalProps === void 0 ? {} : _props$globalProps, _props$globalConfig = props.globalConfig, globalConfig2 = _props$globalConfig === void 0 ? {} : _props$globalConfig, otherProps = __rest(props, ["configProvider", "locale", "widgets", "methods", "form", "validateMessages", "globalProps", "globalConfig"]);
    var storeRef = (0, import_react182.useRef)(createStore2());
    var store = storeRef.current;
    (0, import_react182.useEffect)(function() {
      if (locale6 === "en-US") {
        import_dayjs2.default.locale("en");
        return;
      }
      import_dayjs2.default.locale("zh-cn");
    }, [locale6]);
    useUnmount_default2(function() {
      form.resetFields();
    });
    if (!form) {
      console.warn("Please provide a form instance to FormRender");
      return null;
    }
    var antdLocale = locale6 === "zh-CN" ? import_zh_CN3.default : import_en_US20.default;
    var formValidateMessages = locale6 === "zh-CN" ? validateMessagesCN : validateMessagesEN;
    var configContext = {
      locale: locale6,
      widgets: Object.assign(Object.assign({}, defaultWidgets), widgets),
      methods: methods2,
      form,
      globalProps,
      globalConfig: globalConfig2
    };
    var langPack = Object.assign(Object.assign(Object.assign({}, antdLocale), {
      "FormRender": locales_default[locale6]
    }), configProvider === null || configProvider === void 0 ? void 0 : configProvider.locale);
    return /* @__PURE__ */ import_react182.default.createElement(config_provider_default, Object.assign({}, configProvider, {
      locale: langPack,
      form: {
        validateMessages: Object.assign(Object.assign({}, formValidateMessages), validateMessages)
      }
    }), /* @__PURE__ */ import_react182.default.createElement(ConfigContext2.Provider, {
      value: configContext
    }, /* @__PURE__ */ import_react182.default.createElement(FRContext.Provider, {
      value: store
    }, /* @__PURE__ */ import_react182.default.createElement(Element3, Object.assign({
      form
    }, otherProps)))));
  };
}

// ../../node_modules/form-render/es/widgets/index.js
var widgets_exports = {};
__export(widgets_exports, {
  Card: () => boxcard_default,
  CardList: () => listCard_default,
  Checkbox: () => checkbox_default2,
  Checkboxes: () => checkboxes_default,
  Collapse: () => boxCollapse_default,
  Color: () => color_default,
  DatePicker: () => date_default2,
  DateRange: () => dateRange_default,
  DrawerList: () => listDrawer_default,
  ErrorSchema: () => ErrorSchema_default,
  Html: () => html,
  ImageInput: () => imageInput_default,
  Input: () => input_default2,
  InputNumber: () => number_default2,
  LineTitle: () => boxLineTitle_default,
  MultiSelect: () => select_default2,
  PercentSlider: () => percentSlider_default,
  Radio: () => radio_default3,
  Rate: () => rate_default2,
  Select: () => select_default2,
  SimpleList: () => listSimple_default,
  Slider: () => slider_default2,
  SubInline: () => boxSubInline_default,
  Switch: () => switch_default2,
  TabList: () => listTab_default,
  TableList: () => listTable_default,
  TextArea: () => textArea_default,
  TimePicker: () => time_default,
  TimeRange: () => timeRange_default,
  TreeSelect: () => treeSelect_default,
  Upload: () => upload_default2,
  UrlInput: () => urlInput_default,
  VirtualList: () => listVirtual_default,
  VoidTitle: () => voidTitle_default
});

// ../../node_modules/form-render/es/widgets/utils/withFieldWrap.js
var import_react183 = __toESM(require_react());
var getProps = function getProps2(props, filter3) {
  var result = {};
  Object.keys(props).forEach(function(key2) {
    if (filter3.includes(key2)) {
      return;
    }
    result[key2] = props[key2];
  });
  return result;
};
var withFieldWrap_default = (function(Field2) {
  var filterProps = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ["addons", "schema", "dependValues"];
  return function(props) {
    return /* @__PURE__ */ import_react183.default.createElement(Field2, Object.assign({}, getProps(props, filterProps)));
  };
});

// ../../node_modules/form-render/es/widgets/fields/input/index.js
var input_default2 = withFieldWrap_default(input_default);

// ../../node_modules/form-render/es/widgets/fields/number/index.js
var number_default2 = withFieldWrap_default(input_number_default);

// ../../node_modules/form-render/es/widgets/fields/textArea/index.js
var import_react184 = __toESM(require_react());
var TextArea4 = function TextArea5(props) {
  var finalProps = Object.assign({
    autoSize: {
      minRows: 3
    }
  }, props);
  if (finalProps.rows) delete finalProps.autoSize;
  return /* @__PURE__ */ import_react184.default.createElement(input_default.TextArea, Object.assign({}, finalProps));
};
var textArea_default = withFieldWrap_default(TextArea4);

// ../../node_modules/form-render/es/widgets/fields/select/index.js
var select_default2 = withFieldWrap_default(select_default);

// ../../node_modules/form-render/es/widgets/fields/switch/index.js
var switch_default2 = withFieldWrap_default(switch_default);

// ../../node_modules/form-render/es/widgets/fields/radio/index.js
var import_react185 = __toESM(require_react());
var RadioComp = function RadioComp2(props) {
  var _props$direction = props.direction, direction = _props$direction === void 0 ? "row" : _props$direction, _props$options = props.options, options = _props$options === void 0 ? [] : _props$options, rest = __rest(props, ["direction", "options"]);
  if (direction === "column") {
    return /* @__PURE__ */ import_react185.default.createElement(radio_default2.Group, Object.assign({}, rest), /* @__PURE__ */ import_react185.default.createElement(space_default, {
      direction: "vertical"
    }, options.map(function(item) {
      var value = item.value, label = item.label, rest2 = __rest(item, ["value", "label"]);
      return /* @__PURE__ */ import_react185.default.createElement(radio_default2, Object.assign({
        key: value,
        value
      }, rest2), label);
    })));
  }
  return /* @__PURE__ */ import_react185.default.createElement(radio_default2.Group, Object.assign({}, rest, {
    options
  }));
};
var radio_default3 = withFieldWrap_default(RadioComp);

// ../../node_modules/form-render/es/widgets/fields/rate/index.js
var rate_default2 = withFieldWrap_default(rate_default);

// ../../node_modules/form-render/es/widgets/fields/treeSelect/index.js
var treeSelect_default = withFieldWrap_default(tree_select_default);

// ../../node_modules/form-render/es/widgets/fields/checkbox/index.js
var import_react186 = __toESM(require_react());
var CheckBox = function CheckBox2(_a) {
  var title = _a.title, rest = __rest(_a, ["title"]);
  return /* @__PURE__ */ import_react186.default.createElement(import_react186.default.Fragment, null, /* @__PURE__ */ import_react186.default.createElement(checkbox_default, Object.assign({}, rest)), /* @__PURE__ */ import_react186.default.createElement("span", {
    style: {
      marginLeft: "12px"
    }
  }, title));
};
var checkbox_default2 = withFieldWrap_default(CheckBox);

// ../../node_modules/form-render/es/widgets/fields/checkboxes/index.js
var import_react187 = __toESM(require_react());
var Checkboxes = function Checkboxes2(props) {
  var _props$direction = props.direction, direction = _props$direction === void 0 ? "row" : _props$direction, _props$options = props.options, options = _props$options === void 0 ? [] : _props$options, rest = __rest(props, ["direction", "options"]);
  if (direction === "column") {
    return /* @__PURE__ */ import_react187.default.createElement(checkbox_default.Group, Object.assign({}, rest), /* @__PURE__ */ import_react187.default.createElement(space_default, {
      direction: "vertical"
    }, options.map(function(item) {
      var value = item.value, label = item.label, rest2 = __rest(item, ["value", "label"]);
      return /* @__PURE__ */ import_react187.default.createElement(checkbox_default, Object.assign({
        key: value,
        value
      }, rest2), label);
    })));
  }
  return /* @__PURE__ */ import_react187.default.createElement(checkbox_default.Group, Object.assign({}, rest, {
    options
  }));
};
var checkboxes_default = withFieldWrap_default(Checkboxes);

// ../../node_modules/form-render/es/widgets/fields/color/index.js
var import_react188 = __toESM(require_react());
var import_rc_color_picker = __toESM(require_lib5());

// ../../node_modules/form-render/es/widgets/fields/color/alphahexMap.js
var alphahexMap_default = {
  "1.00": "FF",
  0.99: "FC",
  0.98: "FA",
  0.97: "F7",
  0.96: "F5",
  0.95: "F2",
  0.94: "F0",
  0.93: "ED",
  0.92: "EB",
  0.91: "E8",
  "0.90": "E6",
  0.89: "E3",
  0.88: "E0",
  0.87: "DE",
  0.86: "DB",
  0.85: "D9",
  0.84: "D6",
  0.83: "D4",
  0.82: "D1",
  0.81: "CF",
  "0.80": "CC",
  0.79: "C9",
  0.78: "C7",
  0.77: "C4",
  0.76: "C2",
  0.75: "BF",
  0.74: "BD",
  0.73: "BA",
  0.72: "B8",
  0.71: "B5",
  "0.70": "B3",
  0.69: "B0",
  0.68: "AD",
  0.67: "AB",
  0.66: "A8",
  0.65: "A6",
  0.64: "A3",
  0.63: "A1",
  0.62: "9E",
  0.61: "9C",
  "0.60": "99",
  0.59: "96",
  0.58: "94",
  0.57: "91",
  0.56: "8F",
  0.55: "8C",
  0.54: "8A",
  0.53: "87",
  0.52: "85",
  0.51: "82",
  "0.50": "80",
  0.49: "7D",
  0.48: "7A",
  0.47: "78",
  0.46: "75",
  0.45: "73",
  0.44: "70",
  0.43: "6E",
  0.42: "6B",
  0.41: "69",
  "0.40": "66",
  0.39: "63",
  0.38: "61",
  0.37: "5E",
  0.36: "5C",
  0.35: "59",
  0.34: "57",
  0.33: "54",
  0.32: "52",
  0.31: "4F",
  "0.30": "4D",
  0.29: "4A",
  0.28: "47",
  0.27: "45",
  0.26: "42",
  0.25: "40",
  0.24: "3D",
  0.23: "3B",
  0.22: "38",
  0.21: "36",
  "0.20": "33",
  0.19: "30",
  0.18: "2E",
  0.17: "2B",
  0.16: "29",
  0.15: "26",
  0.14: "24",
  0.13: "21",
  0.12: "1F",
  0.11: "1C",
  "0.10": "1A",
  0.09: "17",
  0.08: "14",
  0.07: "12",
  0.06: "0F",
  0.05: "0D",
  0.04: "0A",
  0.03: "08",
  0.02: "05",
  0.01: "03",
  "0.00": "00"
};

// ../../node_modules/form-render/es/widgets/fields/color/index.js
var getAlphaFromHex = function getAlphaFromHex2() {
  var hex2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "#ffffff";
  var alphaHex = hex2.slice(7);
  var alpha = 100;
  for (var key2 in alphahexMap_default) {
    if (alphahexMap_default[key2] === alphaHex.toUpperCase()) {
      alpha = Number(key2) * 100;
    }
  }
  return alpha;
};
var Color3 = function Color4(props) {
  var className2 = props.className, schema = props.schema, disabled = props.disabled, disabledAlpha = props.disabledAlpha, readOnly = props.readOnly, value = props.value, onChange = props.onChange, style2 = props.style;
  var onPickerChange = function onPickerChange2(ev) {
    if (disabled || readOnly) {
      return;
    }
    var alphaHex = alphahexMap_default[(ev.alpha / 100).toFixed(2)];
    var hex2 = ev.color + (ev.alpha === 100 ? "" : alphaHex);
    onChange(hex2);
  };
  var onInputChange = function onInputChange2(ev) {
    onChange(ev.target.value);
  };
  return /* @__PURE__ */ import_react188.default.createElement("div", {
    className: "fr-color-picker",
    style: style2
  }, disabled || readOnly ? /* @__PURE__ */ import_react188.default.createElement("span", {
    className: "rc-color-picker-trigger",
    style: {
      backgroundColor: value || "#ffffff"
    }
  }) : /* @__PURE__ */ import_react188.default.createElement(import_rc_color_picker.default, {
    type: schema === null || schema === void 0 ? void 0 : schema.format,
    animation: "slide-up",
    color: value && value.slice(0, 7) || "#ffffff",
    alpha: getAlphaFromHex(value),
    enableAlpha: !disabledAlpha,
    onChange: onPickerChange,
    disabled: true
  }), readOnly ? /* @__PURE__ */ import_react188.default.createElement("span", null, value || "#ffffff") : /* @__PURE__ */ import_react188.default.createElement(input_default, {
    className: className2,
    placeholder: "#ffffff",
    disabled,
    value,
    onChange: onInputChange
  }));
};
var color_default = Color3;

// ../../node_modules/form-render/es/widgets/fields/date/index.js
var import_react189 = __toESM(require_react());
var import_dayjs5 = __toESM(require_dayjs_min());
var import_quarterOfYear = __toESM(require_quarterOfYear());

// ../../node_modules/form-render/es/widgets/utils/index.js
var import_dayjs3 = __toESM(require_dayjs_min());
var import_weekOfYear2 = __toESM(require_weekOfYear());
function _slicedToArray5(r2, e3) {
  return _arrayWithHoles6(r2) || _iterableToArrayLimit5(r2, e3) || _unsupportedIterableToArray11(r2, e3) || _nonIterableRest6();
}
function _nonIterableRest6() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray11(r2, a) {
  if (r2) {
    if ("string" == typeof r2) return _arrayLikeToArray11(r2, a);
    var t2 = {}.toString.call(r2).slice(8, -1);
    return "Object" === t2 && r2.constructor && (t2 = r2.constructor.name), "Map" === t2 || "Set" === t2 ? Array.from(r2) : "Arguments" === t2 || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t2) ? _arrayLikeToArray11(r2, a) : void 0;
  }
}
function _arrayLikeToArray11(r2, a) {
  (null == a || a > r2.length) && (a = r2.length);
  for (var e3 = 0, n2 = Array(a); e3 < a; e3++) n2[e3] = r2[e3];
  return n2;
}
function _iterableToArrayLimit5(r2, l2) {
  var t2 = null == r2 ? null : "undefined" != typeof Symbol && r2[Symbol.iterator] || r2["@@iterator"];
  if (null != t2) {
    var e3, n2, i, u, a = [], f = true, o3 = false;
    try {
      if (i = (t2 = t2.call(r2)).next, 0 === l2) {
        if (Object(t2) !== t2) return;
        f = false;
      } else for (; !(f = (e3 = i.call(t2)).done) && (a.push(e3.value), a.length !== l2); f = true) ;
    } catch (r3) {
      o3 = true, n2 = r3;
    } finally {
      try {
        if (!f && null != t2.return && (u = t2.return(), Object(u) !== u)) return;
      } finally {
        if (o3) throw n2;
      }
    }
    return a;
  }
}
function _arrayWithHoles6(r2) {
  if (Array.isArray(r2)) return r2;
}
import_dayjs3.default.extend(import_weekOfYear2.default);
function isUrl2(str) {
  var protocolRE = /^(?:\w+:)?\/\/(\S+)$/;
  if (typeof str !== "string") return false;
  return protocolRE.test(str);
}
function getFormat(format3) {
  var dateFormat;
  switch (format3) {
    case "date":
      dateFormat = "YYYY-MM-DD";
      break;
    case "time":
      dateFormat = "HH:mm:ss";
      break;
    case "dateTime":
      dateFormat = "YYYY-MM-DD HH:mm:ss";
      break;
    case "week":
      dateFormat = "YYYY-w";
      break;
    case "year":
      dateFormat = "YYYY";
      break;
    case "quarter":
      dateFormat = "YYYY-Q";
      break;
    case "month":
      dateFormat = "YYYY-MM";
      break;
    default:
      if (typeof format3 === "string") {
        dateFormat = format3;
      } else {
        dateFormat = "YYYY-MM-DD";
      }
  }
  return dateFormat;
}
var transformDateValue = function transformDateValue2(value, format3, dateFormat) {
  var _a;
  var result = value || void 0;
  if (typeof value === "string") {
    if (format3 === "week") {
      var _value$split = value.split("-"), _value$split2 = _slicedToArray5(_value$split, 2), years = _value$split2[0], week = _value$split2[1];
      result = (_a = (0, import_dayjs3.default)(years)) === null || _a === void 0 ? void 0 : _a.week(Number(week));
    }
    if (format3 === "quarter") {
      var _value$split3 = value.split("-"), _value$split4 = _slicedToArray5(_value$split3, 2), yearx = _value$split4[0], quarter = _value$split4[1];
      result = (0, import_dayjs3.default)(yearx).quarter(quarter);
    }
  }
  if (result) {
    result = (0, import_dayjs3.default)(result, dateFormat);
  }
  return result;
};
var translation3 = function translation4(configCtx) {
  return function(key2) {
    var _a;
    var locale6 = (_a = configCtx === null || configCtx === void 0 ? void 0 : configCtx.locale) === null || _a === void 0 ? void 0 : _a.FormRender;
    return locale6[key2];
  };
};

// ../../node_modules/form-render/es/widgets/components/DatePicker/index.js
var DatePicker = generatePicker_default(dayjs_default);
var DatePicker_default = DatePicker;

// ../../node_modules/form-render/es/widgets/fields/date/index.js
import_dayjs5.default.extend(import_quarterOfYear.default);
var DateCmpt = function DateCmpt2(_a) {
  var onChange = _a.onChange, format3 = _a.format, value = _a.value, style2 = _a.style, rest = __rest(_a, ["onChange", "format", "value", "style"]);
  var dateFormat = getFormat(format3);
  var valueObj = (0, import_react189.useMemo)(function() {
    return transformDateValue(value, format3, dateFormat);
  }, [value]);
  var handleChange = function handleChange2(dateValue, dateString) {
    var newValue = dateString;
    if (format3 === "week" || format3 === "quarter") {
      newValue = (0, import_dayjs5.default)(dateValue).format(dateFormat);
    }
    onChange(newValue);
  };
  var dateParams = {
    value: valueObj,
    style: Object.assign({
      width: "100%"
    }, style2),
    onChange: handleChange
  };
  if (format3 === "dateTime") {
    dateParams.showTime = true;
  }
  if (["week", "month", "quarter", "year"].indexOf(format3) > -1) {
    dateParams.picker = format3;
  }
  if (dateFormat === format3) {
    dateParams.format = format3;
  }
  return /* @__PURE__ */ import_react189.default.createElement(DatePicker_default, Object.assign({}, dateParams, rest));
};
var date_default2 = withFieldWrap_default(DateCmpt);

// ../../node_modules/form-render/es/widgets/fields/dateRange/index.js
var import_react190 = __toESM(require_react());
var import_dayjs6 = __toESM(require_dayjs_min());
var import_quarterOfYear2 = __toESM(require_quarterOfYear());
import_dayjs6.default.extend(import_quarterOfYear2.default);
var RangePicker2 = DatePicker_default.RangePicker;
var DateRange = function DateRange2(_a) {
  var onChange = _a.onChange, format3 = _a.format, value = _a.value, style2 = _a.style, rest = __rest(_a, ["onChange", "format", "value", "style"]);
  var dateFormat = getFormat(format3);
  var valueObj = (0, import_react190.useMemo)(function() {
    if (!value) {
      return value;
    }
    return value.map(function(item) {
      return transformDateValue(item, format3, dateFormat);
    });
  }, [value]);
  var handleChange = function handleChange2(val, _stringList) {
    var stringList = _stringList;
    if (["week", "quarter"].includes(format3)) {
      stringList = (val || []).map(function(item) {
        return (0, import_dayjs6.default)(item).format(dateFormat);
      });
    }
    var isPass = stringList.every(function(item) {
      return !!item;
    });
    if (!isPass) {
      stringList = null;
    }
    onChange(stringList);
  };
  var dateParams = {
    value: valueObj,
    style: Object.assign({
      width: "100%"
    }, style2),
    onChange: handleChange
  };
  if (format3 === "dateTime") {
    dateParams.showTime = true;
  }
  if (["week", "month", "quarter", "year"].indexOf(format3) > -1) {
    dateParams.picker = format3;
  }
  dateParams = Object.assign(Object.assign({}, dateParams), rest);
  if (dateFormat === format3) {
    dateParams.format = format3;
  }
  return /* @__PURE__ */ import_react190.default.createElement(RangePicker2, Object.assign({}, dateParams));
};
var dateRange_default = withFieldWrap_default(DateRange);

// ../../node_modules/form-render/es/widgets/fields/time/index.js
var import_dayjs7 = __toESM(require_dayjs_min());
var import_react191 = __toESM(require_react());

// ../../node_modules/form-render/es/widgets/components/TimePicker/index.js
var React555 = __toESM(require_react());
var TimePicker = /* @__PURE__ */ React555.forwardRef(function(props, ref3) {
  return /* @__PURE__ */ React555.createElement(DatePicker_default, Object.assign({}, props, {
    picker: "time",
    mode: void 0,
    ref: ref3
  }));
});
TimePicker.displayName = "TimePicker";
TimePicker.RangePicker = /* @__PURE__ */ React555.forwardRef(function(props, ref3) {
  return /* @__PURE__ */ React555.createElement(DatePicker_default.RangePicker, Object.assign({}, props, {
    picker: "time",
    mode: void 0,
    ref: ref3
  }));
});
var TimePicker_default = TimePicker;

// ../../node_modules/form-render/es/widgets/fields/time/index.js
var Time = function Time2(_a) {
  var onChange = _a.onChange, _a$format = _a.format, format3 = _a$format === void 0 ? "time" : _a$format, value = _a.value, style2 = _a.style, rest = __rest(_a, ["onChange", "format", "value", "style"]);
  var timeFormat = getFormat(format3);
  var _value = value ? (0, import_dayjs7.default)(value, timeFormat) : void 0;
  var handleChange = function handleChange2(_, valueStr) {
    onChange(valueStr);
  };
  var timeParams = Object.assign({
    value: _value,
    style: Object.assign({
      width: "100%"
    }, style2),
    onChange: handleChange,
    format: timeFormat
  }, rest);
  return /* @__PURE__ */ import_react191.default.createElement(TimePicker_default, Object.assign({}, timeParams));
};
var time_default = withFieldWrap_default(Time);

// ../../node_modules/form-render/es/widgets/fields/timeRange/index.js
var import_dayjs8 = __toESM(require_dayjs_min());
var import_react192 = __toESM(require_react());
function _slicedToArray6(r2, e3) {
  return _arrayWithHoles7(r2) || _iterableToArrayLimit6(r2, e3) || _unsupportedIterableToArray12(r2, e3) || _nonIterableRest7();
}
function _nonIterableRest7() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray12(r2, a) {
  if (r2) {
    if ("string" == typeof r2) return _arrayLikeToArray12(r2, a);
    var t2 = {}.toString.call(r2).slice(8, -1);
    return "Object" === t2 && r2.constructor && (t2 = r2.constructor.name), "Map" === t2 || "Set" === t2 ? Array.from(r2) : "Arguments" === t2 || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t2) ? _arrayLikeToArray12(r2, a) : void 0;
  }
}
function _arrayLikeToArray12(r2, a) {
  (null == a || a > r2.length) && (a = r2.length);
  for (var e3 = 0, n2 = Array(a); e3 < a; e3++) n2[e3] = r2[e3];
  return n2;
}
function _iterableToArrayLimit6(r2, l2) {
  var t2 = null == r2 ? null : "undefined" != typeof Symbol && r2[Symbol.iterator] || r2["@@iterator"];
  if (null != t2) {
    var e3, n2, i, u, a = [], f = true, o3 = false;
    try {
      if (i = (t2 = t2.call(r2)).next, 0 === l2) {
        if (Object(t2) !== t2) return;
        f = false;
      } else for (; !(f = (e3 = i.call(t2)).done) && (a.push(e3.value), a.length !== l2); f = true) ;
    } catch (r3) {
      o3 = true, n2 = r3;
    } finally {
      try {
        if (!f && null != t2.return && (u = t2.return(), Object(u) !== u)) return;
      } finally {
        if (o3) throw n2;
      }
    }
    return a;
  }
}
function _arrayWithHoles7(r2) {
  if (Array.isArray(r2)) return r2;
}
var RangePicker3 = TimePicker_default.RangePicker;
var TimeRange = function TimeRange2(_ref) {
  var onChange = _ref.onChange, _ref$format = _ref.format, format3 = _ref$format === void 0 ? "time" : _ref$format, value = _ref.value, style2 = _ref.style, schema = _ref.schema;
  var _a, _b;
  var timeFormat = getFormat(format3);
  var _ref2 = Array.isArray(value) ? value : [], _ref3 = _slicedToArray6(_ref2, 2), start = _ref3[0], end = _ref3[1];
  var _value = start && end ? [(0, import_dayjs8.default)(start, ((_a = schema === null || schema === void 0 ? void 0 : schema.props) === null || _a === void 0 ? void 0 : _a.format) || timeFormat), (0, import_dayjs8.default)(end, ((_b = schema === null || schema === void 0 ? void 0 : schema.props) === null || _b === void 0 ? void 0 : _b.format) || timeFormat)] : [];
  var handleChange = function handleChange2(_, stringList) {
    var emptyList1 = stringList[0] === "" || stringList[1] === "";
    var emptyList2 = stringList[0] === void 0 || stringList[1] === void 0;
    if (emptyList1 || emptyList2) {
      onChange(void 0);
    } else {
      onChange(stringList);
    }
  };
  var timeParams = Object.assign({
    style: Object.assign({
      width: "100%"
    }, style2),
    value: _value,
    onChange: handleChange
  }, schema.props || {});
  return /* @__PURE__ */ import_react192.default.createElement(RangePicker3, Object.assign({}, timeParams));
};
var timeRange_default = TimeRange;

// ../../node_modules/form-render/es/widgets/fields/imageInput/index.js
var import_PictureOutlined = __toESM(require_PictureOutlined2());
var import_react193 = __toESM(require_react());
var DEFAULT_IMG = "https://img.alicdn.com/tfs/TB14tSiKhTpK1RjSZFKXXa2wXXa-354-330.png";
var PreviewNode = function PreviewNode2(_ref) {
  var value = _ref.value;
  var configCtx = (0, import_react193.useContext)(config_provider_default.ConfigContext);
  var t2 = translation3(configCtx);
  return /* @__PURE__ */ import_react193.default.createElement(popover_default, {
    content: /* @__PURE__ */ import_react193.default.createElement("img", {
      src: value || DEFAULT_IMG,
      alt: t2("img_src_error"),
      className: "fr-preview-image"
    }),
    className: "fr-preview",
    placement: "bottom"
  }, /* @__PURE__ */ import_react193.default.createElement(import_PictureOutlined.default, null));
};
var ImageInput = function ImageInput2(_a) {
  var value = _a.value, rest = __rest(_a, ["value"]);
  return /* @__PURE__ */ import_react193.default.createElement(input_default, Object.assign({
    value,
    addonAfter: /* @__PURE__ */ import_react193.default.createElement(PreviewNode, {
      value
    })
  }, rest));
};
var imageInput_default = withFieldWrap_default(ImageInput);

// ../../node_modules/form-render/es/widgets/fields/urlInput/index.js
var import_react194 = __toESM(require_react());
var UrlNode = function UrlNode2(props) {
  var configCtx = (0, import_react194.useContext)(config_provider_default.ConfigContext);
  var t2 = translation3(configCtx);
  var value = props.value, _props$addonText = props.addonText, addonText = _props$addonText === void 0 ? t2("test_src") : _props$addonText;
  var useUrl = isUrl2(value);
  if (useUrl) {
    return /* @__PURE__ */ import_react194.default.createElement("a", {
      target: "_blank",
      href: value
    }, addonText);
  }
  return /* @__PURE__ */ import_react194.default.createElement("div", null, addonText);
};
var UrlInput = function UrlInput2(_a) {
  var value = _a.value, prefix3 = _a.prefix, suffix = _a.suffix, addonText = _a.addonText, onChange = _a.onChange, rest = __rest(_a, ["value", "prefix", "suffix", "addonText", "onChange"]);
  var _value = value || "";
  if (prefix3) {
    _value = _value.replace(prefix3, "");
  }
  if (suffix) {
    _value = _value.replace(suffix, "");
  }
  var handleChange = function handleChange2(e3) {
    var _value2 = e3.target.value;
    if (!_value2) {
      onChange === null || onChange === void 0 ? void 0 : onChange(_value2);
      return;
    }
    if (prefix3) {
      _value2 = prefix3 + _value2;
    }
    if (suffix) {
      _value2 = _value2 + suffix;
    }
    onChange === null || onChange === void 0 ? void 0 : onChange(_value2);
  };
  return /* @__PURE__ */ import_react194.default.createElement(input_default, Object.assign({
    value: _value,
    prefix: prefix3,
    suffix,
    onChange: handleChange,
    addonAfter: /* @__PURE__ */ import_react194.default.createElement(UrlNode, {
      value,
      addonText
    })
  }, rest));
};
var urlInput_default = withFieldWrap_default(UrlInput);

// ../../node_modules/form-render/es/widgets/fields/slider/index.js
var import_react195 = __toESM(require_react());
var SliderWithNumber = function SliderWithNumber2(_a) {
  var schema = _a.schema, value = _a.value, onChange = _a.onChange, hideInput = _a.hideInput, inputProps = _a.inputProps, style2 = _a.style, rest = __rest(_a, ["schema", "value", "onChange", "hideInput", "inputProps", "style"]);
  var max = schema.max, min = schema.min, step = schema.step;
  var setting = {};
  if (max || max === 0) {
    setting = {
      max
    };
  }
  if (min || min === 0) {
    setting = Object.assign(Object.assign({}, setting), {
      min
    });
  }
  if (step) {
    setting = Object.assign(Object.assign({}, setting), {
      step
    });
  }
  return /* @__PURE__ */ import_react195.default.createElement("div", {
    className: "fr-slider",
    style: style2
  }, /* @__PURE__ */ import_react195.default.createElement(slider_default, Object.assign({
    style: {
      flexGrow: 1,
      marginRight: hideInput ? 0 : 12
    }
  }, setting, {
    onChange,
    value: typeof value === "number" ? value : min || 0
  }, rest)), hideInput ? null : /* @__PURE__ */ import_react195.default.createElement(input_number_default, Object.assign({}, setting, inputProps, {
    style: {
      width: "90px"
    },
    value,
    onChange
  })));
};
var slider_default2 = withFieldWrap_default(SliderWithNumber, ["addons", "dependValues"]);

// ../../node_modules/form-render/es/widgets/fields/upload/index.js
var import_UploadOutlined = __toESM(require_UploadOutlined2());
var import_react196 = __toESM(require_react());
var FrUpload = function FrUpload2(_ref) {
  var action = _ref.action, value = _ref.value, _onChange = _ref.onChange, uploadProps = _ref.uploadProps, buttonProps = _ref.buttonProps, schema = _ref.schema;
  var configCtx = (0, import_react196.useContext)(config_provider_default.ConfigContext);
  var t2 = translation3(configCtx);
  var props = Object.assign({
    name: "file",
    type: "file",
    action,
    onChange: function onChange(info) {
      if (info.file.status === "done") {
        message_default.success("".concat(info.file.name, " ").concat(t2("upload_success")));
        var path2 = get_default(schema, "props.path", "");
        var url2 = path2 ? get_default(info.file.response, path2) : info.file.response.url;
        _onChange(url2);
      } else if (info.file.status === "error") {
        message_default.error("".concat(info.file.name, " ").concat(t2("upload_fail")));
      }
    },
    onRemove: function onRemove() {
      _onChange("");
    }
  }, uploadProps);
  var defaultBtnProps = {
    icon: /* @__PURE__ */ import_react196.default.createElement(import_UploadOutlined.default, null),
    children: t2("upload")
  };
  var btnProps = Object.assign(Object.assign({}, defaultBtnProps), buttonProps);
  return /* @__PURE__ */ import_react196.default.createElement("div", {
    className: "fr-upload-mod"
  }, /* @__PURE__ */ import_react196.default.createElement(upload_default, Object.assign({}, props, {
    className: "fr-upload-file"
  }), /* @__PURE__ */ import_react196.default.createElement(button_default2, Object.assign({}, btnProps))), value && /* @__PURE__ */ import_react196.default.createElement("a", {
    href: value,
    target: "_blank",
    rel: "noopener noreferrer",
    className: "fr-upload-preview"
  }, t2("uploaded_address")));
};
var upload_default2 = FrUpload;

// ../../node_modules/form-render/es/widgets/fields/html/index.js
var import_react197 = __toESM(require_react());
function _typeof8(o3) {
  "@babel/helpers - typeof";
  return _typeof8 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o4) {
    return typeof o4;
  } : function(o4) {
    return o4 && "function" == typeof Symbol && o4.constructor === Symbol && o4 !== Symbol.prototype ? "symbol" : typeof o4;
  }, _typeof8(o3);
}
function html(_ref) {
  var value = _ref.value, checked = _ref.checked, options = _ref.options, _ref$schema = _ref.schema, schema = _ref$schema === void 0 ? {} : _ref$schema;
  var __html = "-";
  if (schema.type === "boolean") {
    __html = value === true || checked === true ? "\u2714" : "\u2718";
  } else if ((options === null || options === void 0 ? void 0 : options.length) > 0) {
    if (["string", "number"].indexOf(_typeof8(value)) > -1) {
      var item = options.find(function(item2) {
        return item2.value === value;
      });
      __html = (item === null || item === void 0 ? void 0 : item.label) || "-";
    } else if (Array.isArray(value)) {
      var idxStr = "-";
      value.forEach(function(v) {
        var item2 = options.find(function(item3) {
          return item3.value === v;
        });
        var name = item2.label;
        if (name) {
          idxStr += "," + name;
        }
      });
      __html = idxStr.replace("-,", "");
    }
  } else if (typeof value === "number") {
    __html = String(value);
  } else if (typeof value === "string") {
    __html = value;
  } else if (schema.type === "range" && Array.isArray(value) && value[0] && value[1]) {
    __html = "".concat(value[0], " - ").concat(value[1]);
  } else if (value && ["number", "string"].indexOf(_typeof8(value)) === -1) {
    __html = JSON.stringify(value);
  }
  if (schema.format === "image") {
    return /* @__PURE__ */ import_react197.default.createElement(image_default, Object.assign({
      height: 56,
      src: value
    }, schema.imageProps));
  }
  return /* @__PURE__ */ import_react197.default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html
    }
  });
}

// ../../node_modules/form-render/es/widgets/fields/percentSlider/index.js
var React563 = __toESM(require_react());
var PercentSlider = function PercentSlider2(p) {
  var _p$schema = p.schema, max = _p$schema.max, min = _p$schema.min, step = _p$schema.step;
  var setting = {};
  if (max || max === 0) {
    setting = {
      max
    };
  }
  if (min || min === 0) {
    setting = Object.assign(Object.assign({}, setting), {
      min
    });
  }
  if (step) {
    setting = Object.assign(Object.assign({}, setting), {
      step
    });
  }
  var hideNumber = false;
  if (p.options && p.options.hideNumber) {
    hideNumber = true;
  }
  var isPercent = function isPercent2(string3) {
    return typeof string3 === "string" && string3.endsWith("%");
  };
  var numberValue = 100;
  if (isPercent(p.value)) {
    try {
      numberValue = Number(p.value.split("%")[0]);
      if (Number.isNaN(numberValue)) numberValue = 100;
    } catch (error2) {
    }
  }
  var handleChange = function handleChange2(newNumber) {
    var a = newNumber + "%";
    p.onChange(a);
  };
  var renderNumber = p.readonly ? /* @__PURE__ */ React563.createElement("span", {
    style: {
      width: "80px"
    }
  }, p.value === "" ? "-" : p.value + "%") : /* @__PURE__ */ React563.createElement(input_number_default, Object.assign({}, p.options, setting, {
    style: {
      width: "80px"
    },
    value: numberValue,
    disabled: p.disabled,
    onChange: handleChange,
    formatter: function formatter(value) {
      return "".concat(value, "%");
    },
    parser: function parser(value) {
      return Number(value.replace("%", ""));
    }
  }));
  return /* @__PURE__ */ React563.createElement("div", {
    className: "fr-slider"
  }, /* @__PURE__ */ React563.createElement(slider_default, Object.assign({
    style: {
      flexGrow: 1,
      marginRight: hideNumber ? 0 : 12
    }
  }, setting, {
    onChange: handleChange,
    max: 100,
    tooltip: {
      formatter: function formatter(v) {
        return v + "%";
      }
    },
    value: numberValue || 100,
    disabled: p.disabled || p.readonly
  })), hideNumber ? null : renderNumber);
};
var percentSlider_default = PercentSlider;

// ../../node_modules/form-render/es/widgets/boxcard/index.js
var import_react199 = __toESM(require_react());

// ../../node_modules/form-render/es/widgets/components/PanelView/index.js
var import_react198 = __toESM(require_react());
var import_classnames208 = __toESM(require_classnames());
var PanelView = function PanelView2(_ref) {
  var children = _ref.children, bordered = _ref.bordered;
  return /* @__PURE__ */ import_react198.default.createElement("div", {
    className: (0, import_classnames208.default)("fr-panel", {
      "fr-panel-bordered": bordered
    })
  }, children);
};
var PanelView_default = PanelView;

// ../../node_modules/form-render/es/widgets/boxcard/index.js
var BoxCard = function BoxCard2(_ref) {
  var children = _ref.children, title = _ref.title, description = _ref.description;
  if (!title) {
    return /* @__PURE__ */ import_react199.default.createElement(PanelView_default, null, children);
  }
  return /* @__PURE__ */ import_react199.default.createElement(card_default, {
    className: "fr-obj-card",
    title: /* @__PURE__ */ import_react199.default.createElement(import_react199.default.Fragment, null, title, description && /* @__PURE__ */ import_react199.default.createElement("span", {
      className: "fr-header-desc "
    }, description))
  }, children);
};
var boxcard_default = BoxCard;

// ../../node_modules/form-render/es/widgets/boxCollapse/index.js
var import_DownOutlined5 = __toESM(require_DownOutlined2());
var import_react200 = __toESM(require_react());
function _slicedToArray7(r2, e3) {
  return _arrayWithHoles8(r2) || _iterableToArrayLimit7(r2, e3) || _unsupportedIterableToArray13(r2, e3) || _nonIterableRest8();
}
function _nonIterableRest8() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray13(r2, a) {
  if (r2) {
    if ("string" == typeof r2) return _arrayLikeToArray13(r2, a);
    var t2 = {}.toString.call(r2).slice(8, -1);
    return "Object" === t2 && r2.constructor && (t2 = r2.constructor.name), "Map" === t2 || "Set" === t2 ? Array.from(r2) : "Arguments" === t2 || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t2) ? _arrayLikeToArray13(r2, a) : void 0;
  }
}
function _arrayLikeToArray13(r2, a) {
  (null == a || a > r2.length) && (a = r2.length);
  for (var e3 = 0, n2 = Array(a); e3 < a; e3++) n2[e3] = r2[e3];
  return n2;
}
function _iterableToArrayLimit7(r2, l2) {
  var t2 = null == r2 ? null : "undefined" != typeof Symbol && r2[Symbol.iterator] || r2["@@iterator"];
  if (null != t2) {
    var e3, n2, i, u, a = [], f = true, o3 = false;
    try {
      if (i = (t2 = t2.call(r2)).next, 0 === l2) {
        if (Object(t2) !== t2) return;
        f = false;
      } else for (; !(f = (e3 = i.call(t2)).done) && (a.push(e3.value), a.length !== l2); f = true) ;
    } catch (r3) {
      o3 = true, n2 = r3;
    } finally {
      try {
        if (!f && null != t2.return && (u = t2.return(), Object(u) !== u)) return;
      } finally {
        if (o3) throw n2;
      }
    }
    return a;
  }
}
function _arrayWithHoles8(r2) {
  if (Array.isArray(r2)) return r2;
}
var Panel4 = collapse_default2.Panel;
var BoxCollapse = function BoxCollapse2(props) {
  var style2 = props.style, children = props.children, title = props.title, description = props.description, _props$collapsed = props.collapsed, collapsed = _props$collapsed === void 0 ? true : _props$collapsed, displayType = props.displayType, _props$bordered = props.bordered, bordered = _props$bordered === void 0 ? false : _props$bordered, _props$ghost = props.ghost, ghost = _props$ghost === void 0 ? true : _props$ghost;
  if (!title) {
    return /* @__PURE__ */ import_react200.default.createElement(PanelView_default, {
      bordered: displayType !== "inline"
    }, children);
  }
  var _useState = (0, import_react200.useState)(collapsed ? "single" : ""), _useState2 = _slicedToArray7(_useState, 2), activeKey = _useState2[0], setActiveKey = _useState2[1];
  var collapseHeader = /* @__PURE__ */ import_react200.default.createElement(import_react200.default.Fragment, null, title && /* @__PURE__ */ import_react200.default.createElement("div", {
    className: "collapse-title"
  }, title), description && /* @__PURE__ */ import_react200.default.createElement("span", {
    className: "fr-header-desc "
  }, description));
  var renderExpandIcon3 = function renderExpandIcon4(_ref) {
    var isActive2 = _ref.isActive;
    return /* @__PURE__ */ import_react200.default.createElement("div", {
      className: "expand-icon-box"
    }, /* @__PURE__ */ import_react200.default.createElement(import_DownOutlined5.default, {
      rotate: isActive2 ? 0 : -90,
      style: {
        fontSize: "16px"
      }
    }));
  };
  return /* @__PURE__ */ import_react200.default.createElement(collapse_default2, {
    className: "fr-obj-collapse",
    style: style2,
    bordered,
    ghost,
    activeKey: [activeKey],
    expandIcon: renderExpandIcon3,
    onChange: function onChange() {
      return setActiveKey(activeKey ? "" : "single");
    }
  }, /* @__PURE__ */ import_react200.default.createElement(Panel4, {
    key: "single",
    header: collapseHeader,
    forceRender: true
  }, children));
};
var boxCollapse_default = BoxCollapse;

// ../../node_modules/form-render/es/widgets/boxSubInline/index.js
var import_react201 = __toESM(require_react());
var import_classnames209 = __toESM(require_classnames());
var BoxSubInline = function BoxSubInline2(props) {
  var children = props.children, title = props.title, _props$hasBackground = props.hasBackground, hasBackground = _props$hasBackground === void 0 ? true : _props$hasBackground, description = props.description, tooltip = props.tooltip, fieldCol = props.fieldCol, labelCol = props.labelCol, labelWidth = props.labelWidth, displayType = props.displayType, rest = __rest(props, ["children", "title", "hasBackground", "description", "tooltip", "fieldCol", "labelCol", "labelWidth", "displayType"]);
  var _tooltip = null;
  var _labelCol = {
    span: 3
  };
  var _fieldCol = {
    flex: 1
  };
  if (description) {
    _tooltip = {
      title: description
    };
  }
  if (tooltip) {
    _tooltip = tooltip;
  }
  if (labelWidth) {
    _labelCol = {
      flex: labelWidth + "px"
    };
  }
  if (labelCol) {
    _labelCol = labelCol;
  }
  if (fieldCol) {
    _fieldCol = fieldCol;
  }
  return /* @__PURE__ */ import_react201.default.createElement(form_default.Item, Object.assign({}, rest, {
    className: (0, import_classnames209.default)("fr-obj-subinline", {
      "fr-obj-subinline-label-hidden": !title,
      "fr-obj-subinline-background": hasBackground
    }),
    label: title || "notitle",
    labelCol: _labelCol,
    wrapperCol: _fieldCol,
    tooltip: _tooltip
  }), children);
};
var boxSubInline_default = BoxSubInline;

// ../../node_modules/form-render/es/widgets/boxLineTitle/index.js
var import_react202 = __toESM(require_react());
var FLineTitle = function FLineTitle2(_ref) {
  var children = _ref.children, title = _ref.title, description = _ref.description;
  if (!title) {
    return /* @__PURE__ */ import_react202.default.createElement(PanelView_default, null, children);
  }
  return /* @__PURE__ */ import_react202.default.createElement("div", {
    className: "fr-obj-line-title"
  }, /* @__PURE__ */ import_react202.default.createElement("div", {
    className: "fr-obj-header"
  }, /* @__PURE__ */ import_react202.default.createElement("span", {
    className: "fr-header-title"
  }, title), description && /* @__PURE__ */ import_react202.default.createElement("span", {
    className: "fr-header-desc"
  }, description)), /* @__PURE__ */ import_react202.default.createElement("div", {
    className: "fr-obj-content"
  }, children));
};
var boxLineTitle_default = FLineTitle;

// ../../node_modules/form-render/es/widgets/listSimple/index.js
var import_PlusOutlined3 = __toESM(require_PlusOutlined2());
var import_CopyOutlined3 = __toESM(require_CopyOutlined2());
var import_CloseOutlined8 = __toESM(require_CloseOutlined2());
var import_ArrowDownOutlined = __toESM(require_ArrowDownOutlined2());
var import_ArrowUpOutlined = __toESM(require_ArrowUpOutlined2());
var import_react204 = __toESM(require_react());
var import_classnames210 = __toESM(require_classnames());

// ../../node_modules/form-render/es/widgets/components/FButton/index.js
var import_react203 = __toESM(require_react());
var HeaderTitle = function HeaderTitle2(props) {
  var icon = props.icon, children = props.children, btnType = props.btnType, otherProps = __rest(props, ["icon", "children", "btnType"]);
  var btnProps = Object.assign({}, otherProps);
  if (btnType === "icon") {
    btnProps.icon = icon;
    btnProps.size = "small";
  } else {
    btnProps.children = children;
  }
  return /* @__PURE__ */ import_react203.default.createElement(button_default2, Object.assign({
    type: "link",
    style: {
      padding: 0
    }
  }, btnProps));
};
var FButton_default = HeaderTitle;

// ../../node_modules/form-render/es/widgets/listSimple/index.js
function _toConsumableArray10(r2) {
  return _arrayWithoutHoles10(r2) || _iterableToArray10(r2) || _unsupportedIterableToArray14(r2) || _nonIterableSpread10();
}
function _nonIterableSpread10() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray14(r2, a) {
  if (r2) {
    if ("string" == typeof r2) return _arrayLikeToArray14(r2, a);
    var t2 = {}.toString.call(r2).slice(8, -1);
    return "Object" === t2 && r2.constructor && (t2 = r2.constructor.name), "Map" === t2 || "Set" === t2 ? Array.from(r2) : "Arguments" === t2 || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t2) ? _arrayLikeToArray14(r2, a) : void 0;
  }
}
function _iterableToArray10(r2) {
  if ("undefined" != typeof Symbol && null != r2[Symbol.iterator] || null != r2["@@iterator"]) return Array.from(r2);
}
function _arrayWithoutHoles10(r2) {
  if (Array.isArray(r2)) return _arrayLikeToArray14(r2);
}
function _arrayLikeToArray14(r2, a) {
  (null == a || a > r2.length) && (a = r2.length);
  for (var e3 = 0, n2 = Array(a); e3 < a; e3++) n2[e3] = r2[e3];
  return n2;
}
var getHasBackground = function getHasBackground2(fields, hasBackground) {
  var result = hasBackground;
  if (fields.length === 0) {
    result = false;
  }
  return result;
};
var SimpleList = function SimpleList2(props) {
  var form = props.form, _schema = props.schema, fields = props.fields, rootPath = props.rootPath, renderCore = props.renderCore, hasBackground = props.hasBackground, operateBtnType = props.operateBtnType, addBtnProps = props.addBtnProps, delConfirmProps = props.delConfirmProps, copyBtnProps = props.copyBtnProps, deleteBtnProps = props.deleteBtnProps, moveUpBtnProps = props.moveUpBtnProps, moveDownBtnProps = props.moveDownBtnProps, hideDelete = props.hideDelete, hideCopy = props.hideCopy, hideMove = props.hideMove, hideAdd = props.hideAdd, addItem = props.addItem, copyItem = props.copyItem, moveItem = props.moveItem, removeItem = props.removeItem, temporary = props.temporary;
  var schema = Object.assign(Object.assign({}, _schema), {
    items: Object.assign({}, _schema.items)
  });
  if (!schema.items.displayType) {
    schema.items.displayType = "inline";
    schema.items.inlineMode = true;
  }
  var handleCopy = function handleCopy2(name) {
    var value = form.getFieldValue(rootPath.concat(name));
    copyItem(value, name);
  };
  var isColumm = temporary.displayType === "column";
  return /* @__PURE__ */ import_react204.default.createElement("div", {
    className: (0, import_classnames210.default)("fr-list-simple", {
      "fr-list-simple-background": getHasBackground(fields, hasBackground),
      "fr-list-simple-column": isColumm
    })
  }, fields.map(function(_ref) {
    var key2 = _ref.key, name = _ref.name;
    var length2 = fields.length;
    return /* @__PURE__ */ import_react204.default.createElement("div", {
      key: key2,
      className: "fr-list-item"
    }, renderCore({
      schema,
      parentPath: [name],
      rootPath: [].concat(_toConsumableArray10(rootPath), [name])
    }), /* @__PURE__ */ import_react204.default.createElement(space_default, {
      className: (0, import_classnames210.default)("fr-list-item-operate"),
      split: operateBtnType !== "icon" && /* @__PURE__ */ import_react204.default.createElement(divider_default, {
        type: "vertical"
      })
    }, !hideMove && /* @__PURE__ */ import_react204.default.createElement(import_react204.default.Fragment, null, /* @__PURE__ */ import_react204.default.createElement(FButton_default, Object.assign({
      disabled: name === 0,
      onClick: function onClick() {
        return moveItem(name, name - 1);
      },
      icon: /* @__PURE__ */ import_react204.default.createElement(import_ArrowUpOutlined.default, null)
    }, moveUpBtnProps)), /* @__PURE__ */ import_react204.default.createElement(FButton_default, Object.assign({
      disabled: name === length2 - 1,
      onClick: function onClick() {
        return moveItem(name, name + 1);
      },
      icon: /* @__PURE__ */ import_react204.default.createElement(import_ArrowDownOutlined.default, null),
      children: "\u4E0B\u79FB"
    }, moveDownBtnProps))), !hideDelete && /* @__PURE__ */ import_react204.default.createElement(popconfirm_default, Object.assign({
      onConfirm: function onConfirm() {
        return removeItem(name);
      }
    }, delConfirmProps), /* @__PURE__ */ import_react204.default.createElement(FButton_default, Object.assign({
      icon: /* @__PURE__ */ import_react204.default.createElement(import_CloseOutlined8.default, null),
      children: "\u5220\u9664",
      btnType: operateBtnType
    }, deleteBtnProps))), !hideCopy && /* @__PURE__ */ import_react204.default.createElement(FButton_default, Object.assign({
      onClick: function onClick() {
        return handleCopy(name);
      },
      icon: /* @__PURE__ */ import_react204.default.createElement(import_CopyOutlined3.default, null),
      children: "\u590D\u5236"
    }, copyBtnProps))));
  }), (!schema.max || fields.length < schema.max) && !hideAdd && /* @__PURE__ */ import_react204.default.createElement(button_default2, Object.assign({
    className: "add-btn",
    icon: /* @__PURE__ */ import_react204.default.createElement(import_PlusOutlined3.default, null),
    onClick: function onClick() {
      return addItem();
    },
    block: fields.length > 0 ? true : false
  }, addBtnProps)));
};
var listSimple_default = SimpleList;

// ../../node_modules/form-render/es/widgets/listCard/index.js
var import_PlusOutlined4 = __toESM(require_PlusOutlined2());
var import_CopyOutlined4 = __toESM(require_CopyOutlined2());
var import_CloseOutlined9 = __toESM(require_CloseOutlined2());
var import_ArrowDownOutlined2 = __toESM(require_ArrowDownOutlined2());
var import_ArrowUpOutlined2 = __toESM(require_ArrowUpOutlined2());
var import_react205 = __toESM(require_react());
var import_classnames211 = __toESM(require_classnames());
function _toConsumableArray11(r2) {
  return _arrayWithoutHoles11(r2) || _iterableToArray11(r2) || _unsupportedIterableToArray15(r2) || _nonIterableSpread11();
}
function _nonIterableSpread11() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray15(r2, a) {
  if (r2) {
    if ("string" == typeof r2) return _arrayLikeToArray15(r2, a);
    var t2 = {}.toString.call(r2).slice(8, -1);
    return "Object" === t2 && r2.constructor && (t2 = r2.constructor.name), "Map" === t2 || "Set" === t2 ? Array.from(r2) : "Arguments" === t2 || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t2) ? _arrayLikeToArray15(r2, a) : void 0;
  }
}
function _iterableToArray11(r2) {
  if ("undefined" != typeof Symbol && null != r2[Symbol.iterator] || null != r2["@@iterator"]) return Array.from(r2);
}
function _arrayWithoutHoles11(r2) {
  if (Array.isArray(r2)) return _arrayLikeToArray15(r2);
}
function _arrayLikeToArray15(r2, a) {
  (null == a || a > r2.length) && (a = r2.length);
  for (var e3 = 0, n2 = Array(a); e3 < a; e3++) n2[e3] = r2[e3];
  return n2;
}
var getOperateFixed = function getOperateFixed2(schema) {
  var _a, _b;
  var fixed = true;
  if ((_b = (_a = schema === null || schema === void 0 ? void 0 : schema.items) === null || _a === void 0 ? void 0 : _a.props) === null || _b === void 0 ? void 0 : _b.extra) {
    fixed = false;
  }
  return fixed;
};
var getOperateStyle = function getOperateStyle2(schema) {
  var _a, _b, _c, _d, _e;
  var style2 = {};
  var widgetName = ((_a = schema === null || schema === void 0 ? void 0 : schema.items) === null || _a === void 0 ? void 0 : _a.theme) || ((_b = schema === null || schema === void 0 ? void 0 : schema.items) === null || _b === void 0 ? void 0 : _b.widget) || "collapse";
  if (["card", "collapse", "lineTitle"].includes(widgetName) && !((_d = (_c = schema === null || schema === void 0 ? void 0 : schema.items) === null || _c === void 0 ? void 0 : _c.props) === null || _d === void 0 ? void 0 : _d.extra)) {
    style2.top = "14px";
    if (["lineTitle"].includes(widgetName)) {
      style2.top = "3px";
      style2.padding = 0;
    }
    if (!((_e = schema === null || schema === void 0 ? void 0 : schema.items) === null || _e === void 0 ? void 0 : _e.title)) {
      style2.right = "0";
    }
  }
  return style2;
};
var CardList = function CardList2(props) {
  var form = props.form, schema = props.schema, fields = props.fields, rootPath = props.rootPath, renderCore = props.renderCore, hasBackground = props.hasBackground, operateBtnType = props.operateBtnType, addBtnProps = props.addBtnProps, delConfirmProps = props.delConfirmProps, copyBtnProps = props.copyBtnProps, deleteBtnProps = props.deleteBtnProps, moveUpBtnProps = props.moveUpBtnProps, moveDownBtnProps = props.moveDownBtnProps, hideDelete = props.hideDelete, hideCopy = props.hideCopy, hideMove = props.hideMove, hideAdd = props.hideAdd, addItem = props.addItem, copyItem = props.copyItem, moveItem = props.moveItem, removeItem = props.removeItem;
  var handleCopy = function handleCopy2(name) {
    var value = form.getFieldValue(rootPath.concat(name));
    copyItem(value, name);
  };
  return /* @__PURE__ */ import_react205.default.createElement(import_react205.default.Fragment, null, /* @__PURE__ */ import_react205.default.createElement("div", {
    className: (0, import_classnames211.default)("fr-list-card", {
      "fr-list-card-background": hasBackground
    })
  }, fields.map(function(_ref) {
    var key2 = _ref.key, name = _ref.name;
    var length2 = fields.length;
    var newSchema = cloneDeep_default(schema);
    if (newSchema.items.title && typeof newSchema.items.title === "string") {
      newSchema.items.title += " ".concat(name + 1);
    }
    return /* @__PURE__ */ import_react205.default.createElement("div", {
      key: key2,
      className: "fr-list-item"
    }, /* @__PURE__ */ import_react205.default.createElement("div", {
      style: {
        width: 0,
        flex: 1
      }
    }, renderCore({
      schema: newSchema,
      parentPath: [name],
      rootPath: [].concat(_toConsumableArray11(rootPath), [name])
    })), /* @__PURE__ */ import_react205.default.createElement(space_default, {
      className: (0, import_classnames211.default)("fr-list-item-operate", {
        "fr-list-item-operate-fixed": getOperateFixed(schema)
      }),
      style: getOperateStyle(schema),
      split: operateBtnType !== "icon" && /* @__PURE__ */ import_react205.default.createElement(divider_default, {
        type: "vertical"
      })
    }, !hideMove && /* @__PURE__ */ import_react205.default.createElement(import_react205.default.Fragment, null, /* @__PURE__ */ import_react205.default.createElement(FButton_default, Object.assign({
      disabled: name === 0,
      onClick: function onClick() {
        return moveItem(name, name - 1);
      },
      icon: /* @__PURE__ */ import_react205.default.createElement(import_ArrowUpOutlined2.default, null)
    }, moveUpBtnProps)), /* @__PURE__ */ import_react205.default.createElement(FButton_default, Object.assign({
      disabled: name === length2 - 1,
      onClick: function onClick() {
        return moveItem(name, name + 1);
      },
      icon: /* @__PURE__ */ import_react205.default.createElement(import_ArrowDownOutlined2.default, null)
    }, moveDownBtnProps))), !hideDelete && /* @__PURE__ */ import_react205.default.createElement(popconfirm_default, Object.assign({
      onConfirm: function onConfirm() {
        return removeItem(name);
      }
    }, delConfirmProps), /* @__PURE__ */ import_react205.default.createElement(FButton_default, Object.assign({
      icon: /* @__PURE__ */ import_react205.default.createElement(import_CloseOutlined9.default, null)
    }, deleteBtnProps))), !hideCopy && /* @__PURE__ */ import_react205.default.createElement(FButton_default, Object.assign({
      onClick: function onClick() {
        return handleCopy(name);
      },
      icon: /* @__PURE__ */ import_react205.default.createElement(import_CopyOutlined4.default, null)
    }, copyBtnProps))));
  }), (!schema.max || fields.length < schema.max) && !hideAdd && /* @__PURE__ */ import_react205.default.createElement("div", {
    className: "fr-list-add-btn"
  }, /* @__PURE__ */ import_react205.default.createElement(button_default2, Object.assign({}, addBtnProps, {
    onClick: function onClick() {
      return addItem();
    },
    icon: /* @__PURE__ */ import_react205.default.createElement(import_PlusOutlined4.default, null),
    block: fields.length > 0 ? true : false
  })))));
};
var listCard_default = CardList;

// ../../node_modules/form-render/es/widgets/listTable/index.js
var import_PlusOutlined5 = __toESM(require_PlusOutlined2());
var import_CopyOutlined5 = __toESM(require_CopyOutlined2());
var import_CloseOutlined10 = __toESM(require_CloseOutlined2());
var import_ArrowDownOutlined3 = __toESM(require_ArrowDownOutlined2());
var import_ArrowUpOutlined3 = __toESM(require_ArrowUpOutlined2());
var import_InfoCircleOutlined = __toESM(require_InfoCircleOutlined2());
var import_react207 = __toESM(require_react());
var import_classnames212 = __toESM(require_classnames());

// ../../node_modules/form-render/es/widgets/listTable/tableCell.js
var import_react206 = __toESM(require_react());
function _slicedToArray8(r2, e3) {
  return _arrayWithHoles9(r2) || _iterableToArrayLimit8(r2, e3) || _unsupportedIterableToArray16(r2, e3) || _nonIterableRest9();
}
function _nonIterableRest9() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray16(r2, a) {
  if (r2) {
    if ("string" == typeof r2) return _arrayLikeToArray16(r2, a);
    var t2 = {}.toString.call(r2).slice(8, -1);
    return "Object" === t2 && r2.constructor && (t2 = r2.constructor.name), "Map" === t2 || "Set" === t2 ? Array.from(r2) : "Arguments" === t2 || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t2) ? _arrayLikeToArray16(r2, a) : void 0;
  }
}
function _arrayLikeToArray16(r2, a) {
  (null == a || a > r2.length) && (a = r2.length);
  for (var e3 = 0, n2 = Array(a); e3 < a; e3++) n2[e3] = r2[e3];
  return n2;
}
function _iterableToArrayLimit8(r2, l2) {
  var t2 = null == r2 ? null : "undefined" != typeof Symbol && r2[Symbol.iterator] || r2["@@iterator"];
  if (null != t2) {
    var e3, n2, i, u, a = [], f = true, o3 = false;
    try {
      if (i = (t2 = t2.call(r2)).next, 0 === l2) {
        if (Object(t2) !== t2) return;
        f = false;
      } else for (; !(f = (e3 = i.call(t2)).done) && (a.push(e3.value), a.length !== l2); f = true) ;
    } catch (r3) {
      o3 = true, n2 = r3;
    } finally {
      try {
        if (!f && null != t2.return && (u = t2.return(), Object(u) !== u)) return;
      } finally {
        if (o3) throw n2;
      }
    }
    return a;
  }
}
function _arrayWithHoles9(r2) {
  if (Array.isArray(r2)) return r2;
}
var TableCell = function TableCell2(props) {
  var renderCore = props.renderCore, schema = props.schema, dataIndex = props.dataIndex, otherProps = __rest(props, ["renderCore", "schema", "dataIndex"]);
  var _useState = (0, import_react206.useState)(null), _useState2 = _slicedToArray8(_useState, 2), errorMsg = _useState2[0], setErrorMsg = _useState2[1];
  var _useState3 = (0, import_react206.useState)(), _useState4 = _slicedToArray8(_useState3, 2), visible = _useState4[0], setVisible = _useState4[1];
  var mouseRef = (0, import_react206.useRef)(null);
  var onStatusChange = function onStatusChange2(_, errors) {
    var message2 = errors[0] || null;
    setErrorMsg(message2);
    if (mouseRef.current && message2) {
      setVisible(true);
    }
  };
  if (!schema.properties[dataIndex].onStatusChange) {
    schema.properties[dataIndex].onStatusChange = onStatusChange;
  }
  var popoverVisible = visible && errorMsg;
  var popoverProps = {
    open: popoverVisible
  };
  if (window.antdVersion === "v4") {
    popoverProps = {
      visible: popoverVisible
    };
  }
  return /* @__PURE__ */ import_react206.default.createElement("div", {
    className: "fr-table-cell-content",
    onMouseEnter: function onMouseEnter() {
      mouseRef.current = true;
      setVisible(true);
    },
    onMouseLeave: function onMouseLeave() {
      mouseRef.current = false;
      setVisible(false);
    }
  }, /* @__PURE__ */ import_react206.default.createElement(popover_default, Object.assign({
    overlayClassName: "fr-popover-error",
    content: errorMsg,
    placement: "topRight"
  }, popoverProps), renderCore(Object.assign(Object.assign({}, otherProps), {
    schema
  }))));
};
var tableCell_default = TableCell;

// ../../node_modules/form-render/es/widgets/listTable/index.js
function _typeof9(o3) {
  "@babel/helpers - typeof";
  return _typeof9 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o4) {
    return typeof o4;
  } : function(o4) {
    return o4 && "function" == typeof Symbol && o4.constructor === Symbol && o4 !== Symbol.prototype ? "symbol" : typeof o4;
  }, _typeof9(o3);
}
function _toConsumableArray12(r2) {
  return _arrayWithoutHoles12(r2) || _iterableToArray12(r2) || _unsupportedIterableToArray17(r2) || _nonIterableSpread12();
}
function _nonIterableSpread12() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray12(r2) {
  if ("undefined" != typeof Symbol && null != r2[Symbol.iterator] || null != r2["@@iterator"]) return Array.from(r2);
}
function _arrayWithoutHoles12(r2) {
  if (Array.isArray(r2)) return _arrayLikeToArray17(r2);
}
function _defineProperty5(e3, r2, t2) {
  return (r2 = _toPropertyKey4(r2)) in e3 ? Object.defineProperty(e3, r2, { value: t2, enumerable: true, configurable: true, writable: true }) : e3[r2] = t2, e3;
}
function _toPropertyKey4(t2) {
  var i = _toPrimitive4(t2, "string");
  return "symbol" == _typeof9(i) ? i : i + "";
}
function _toPrimitive4(t2, r2) {
  if ("object" != _typeof9(t2) || !t2) return t2;
  var e3 = t2[Symbol.toPrimitive];
  if (void 0 !== e3) {
    var i = e3.call(t2, r2 || "default");
    if ("object" != _typeof9(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t2);
}
function _slicedToArray9(r2, e3) {
  return _arrayWithHoles10(r2) || _iterableToArrayLimit9(r2, e3) || _unsupportedIterableToArray17(r2, e3) || _nonIterableRest10();
}
function _nonIterableRest10() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray17(r2, a) {
  if (r2) {
    if ("string" == typeof r2) return _arrayLikeToArray17(r2, a);
    var t2 = {}.toString.call(r2).slice(8, -1);
    return "Object" === t2 && r2.constructor && (t2 = r2.constructor.name), "Map" === t2 || "Set" === t2 ? Array.from(r2) : "Arguments" === t2 || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t2) ? _arrayLikeToArray17(r2, a) : void 0;
  }
}
function _arrayLikeToArray17(r2, a) {
  (null == a || a > r2.length) && (a = r2.length);
  for (var e3 = 0, n2 = Array(a); e3 < a; e3++) n2[e3] = r2[e3];
  return n2;
}
function _iterableToArrayLimit9(r2, l2) {
  var t2 = null == r2 ? null : "undefined" != typeof Symbol && r2[Symbol.iterator] || r2["@@iterator"];
  if (null != t2) {
    var e3, n2, i, u, a = [], f = true, o3 = false;
    try {
      if (i = (t2 = t2.call(r2)).next, 0 === l2) {
        if (Object(t2) !== t2) return;
        f = false;
      } else for (; !(f = (e3 = i.call(t2)).done) && (a.push(e3.value), a.length !== l2); f = true) ;
    } catch (r3) {
      o3 = true, n2 = r3;
    } finally {
      try {
        if (!f && null != t2.return && (u = t2.return(), Object(u) !== u)) return;
      } finally {
        if (o3) throw n2;
      }
    }
    return a;
  }
}
function _arrayWithHoles10(r2) {
  if (Array.isArray(r2)) return r2;
}
var getTooltip5 = function getTooltip6(tooltip) {
  if (!tooltip) {
    return;
  }
  if (typeof tooltip === "string") {
    return {
      title: /* @__PURE__ */ import_react207.default.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: tooltip
        }
      })
    };
  }
  return Object.assign(Object.assign({}, tooltip), {
    title: /* @__PURE__ */ import_react207.default.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: tooltip.title
      }
    })
  });
};
var TableList = function TableList2(props) {
  var _a, _b;
  var form = props.form, schema = props.schema, fields = props.fields, rootPath = props.rootPath, renderCore = props.renderCore, readOnly = props.readOnly, operateBtnType = props.operateBtnType, addBtnProps = props.addBtnProps, delConfirmProps = props.delConfirmProps, copyBtnProps = props.copyBtnProps, deleteBtnProps = props.deleteBtnProps, moveUpBtnProps = props.moveUpBtnProps, moveDownBtnProps = props.moveDownBtnProps, actionColumnProps = props.actionColumnProps, pagination = props.pagination, hideDelete = props.hideDelete, hideCopy = props.hideCopy, hideMove = props.hideMove, hideAdd = props.hideAdd, hideOperate = props.hideOperate, hideEmptyTable = props.hideEmptyTable, addItem = props.addItem, copyItem = props.copyItem, moveItem = props.moveItem, removeItem = props.removeItem, configContext = props.configContext, validatePopover = props.validatePopover, retProps = __rest(props, ["form", "schema", "fields", "rootPath", "renderCore", "readOnly", "operateBtnType", "addBtnProps", "delConfirmProps", "copyBtnProps", "deleteBtnProps", "moveUpBtnProps", "moveDownBtnProps", "actionColumnProps", "pagination", "hideDelete", "hideCopy", "hideMove", "hideAdd", "hideOperate", "hideEmptyTable", "addItem", "copyItem", "moveItem", "removeItem", "configContext", "validatePopover"]);
  var globalConfig2 = configContext.globalConfig;
  var islidatePopover = (_a = validatePopover !== null && validatePopover !== void 0 ? validatePopover : globalConfig2 === null || globalConfig2 === void 0 ? void 0 : globalConfig2.listValidatePopover) !== null && _a !== void 0 ? _a : true;
  var colHeaderText = actionColumnProps.colHeaderText, otherActionColumnProps = __rest(actionColumnProps, ["colHeaderText"]);
  var itemSchema = ((_b = schema === null || schema === void 0 ? void 0 : schema.items) === null || _b === void 0 ? void 0 : _b.properties) || {};
  var paginationConfig = Object.assign({
    size: "small",
    hideOnSinglePage: true
  }, pagination);
  var handleCopy = function handleCopy2(name) {
    var value = form.getFieldValue(rootPath.concat(name));
    copyItem(value, name);
  };
  var columns = sortProperties_default(Object.entries(itemSchema)).map(function(_ref) {
    var _ref2 = _slicedToArray9(_ref, 2), dataIndex = _ref2[0], item = _ref2[1];
    var required5 = item.required, title = item.title, width = item.width, tooltip = item.tooltip, columnHidden = item.columnHidden;
    if (columnHidden) {
      return null;
    }
    var tooltipProps = getTooltip5(tooltip);
    return {
      dataIndex,
      width,
      title: /* @__PURE__ */ import_react207.default.createElement(import_react207.default.Fragment, null, required5 && /* @__PURE__ */ import_react207.default.createElement("span", {
        style: {
          color: "red",
          marginRight: "3px"
        }
      }, "*"), /* @__PURE__ */ import_react207.default.createElement("span", null, title), tooltipProps && /* @__PURE__ */ import_react207.default.createElement(tooltip_default, Object.assign({
        placement: "top"
      }, tooltipProps), /* @__PURE__ */ import_react207.default.createElement(import_InfoCircleOutlined.default, {
        style: {
          marginLeft: 6
        }
      }))),
      render: function render4(_, field) {
        var fieldSchema = {
          type: "object",
          properties: _defineProperty5({}, dataIndex, Object.assign(Object.assign({}, itemSchema[dataIndex]), {
            fieldCol: 24
          }))
        };
        if (!islidatePopover) {
          return /* @__PURE__ */ import_react207.default.createElement("div", {
            className: "fr-table-cell-content"
          }, renderCore({
            parentPath: [field.name],
            rootPath: [].concat(_toConsumableArray12(rootPath), [field.name]),
            schema: fieldSchema
          }));
        }
        return /* @__PURE__ */ import_react207.default.createElement(tableCell_default, {
          renderCore,
          schema: fieldSchema,
          parentPath: [field.name],
          rootPath: [].concat(_toConsumableArray12(rootPath), [field.name]),
          dataIndex
        });
      }
    };
  }).filter(function(item) {
    return item;
  });
  if (!readOnly && !hideOperate) {
    columns.push(Object.assign(Object.assign({
      title: colHeaderText,
      width: "190px",
      fixed: "right"
    }, otherActionColumnProps), {
      render: function render4(_, field) {
        return /* @__PURE__ */ import_react207.default.createElement(form_default.Item, null, /* @__PURE__ */ import_react207.default.createElement(space_default, {
          className: "fr-list-item-operate",
          split: operateBtnType !== "icon" && /* @__PURE__ */ import_react207.default.createElement(divider_default, {
            type: "vertical"
          })
        }, !hideMove && /* @__PURE__ */ import_react207.default.createElement(import_react207.default.Fragment, null, /* @__PURE__ */ import_react207.default.createElement(FButton_default, Object.assign({
          disabled: field.name === 0,
          onClick: function onClick() {
            return moveItem(field.name, field.name - 1);
          },
          icon: /* @__PURE__ */ import_react207.default.createElement(import_ArrowUpOutlined3.default, null)
        }, moveUpBtnProps)), /* @__PURE__ */ import_react207.default.createElement(FButton_default, Object.assign({
          disabled: field.name === fields.length - 1,
          onClick: function onClick() {
            return moveItem(field.name, field.name + 1);
          },
          icon: /* @__PURE__ */ import_react207.default.createElement(import_ArrowDownOutlined3.default, null)
        }, moveDownBtnProps))), !hideDelete && /* @__PURE__ */ import_react207.default.createElement(popconfirm_default, Object.assign({
          onConfirm: function onConfirm() {
            return removeItem(field.name);
          }
        }, delConfirmProps), /* @__PURE__ */ import_react207.default.createElement(FButton_default, Object.assign({
          icon: /* @__PURE__ */ import_react207.default.createElement(import_CloseOutlined10.default, null),
          btnType: operateBtnType
        }, deleteBtnProps))), !hideCopy && /* @__PURE__ */ import_react207.default.createElement(FButton_default, Object.assign({
          onClick: function onClick() {
            return handleCopy(field.name);
          },
          icon: /* @__PURE__ */ import_react207.default.createElement(import_CopyOutlined5.default, null)
        }, copyBtnProps))));
      }
    }));
  }
  var showTable = fields.length > 0 ? true : !hideEmptyTable;
  return /* @__PURE__ */ import_react207.default.createElement("div", {
    className: (0, import_classnames212.default)("fr-table-list", {
      "fr-table-list-no-popover": !islidatePopover
    })
  }, showTable && /* @__PURE__ */ import_react207.default.createElement(table_default, Object.assign({
    size: "middle",
    scroll: {
      x: "max-content"
    },
    style: {
      marginBottom: "12px"
    }
  }, retProps, {
    columns,
    dataSource: fields,
    pagination: paginationConfig
  })), (!schema.max || fields.length < schema.max) && !hideAdd && /* @__PURE__ */ import_react207.default.createElement(button_default2, Object.assign({
    icon: /* @__PURE__ */ import_react207.default.createElement(import_PlusOutlined5.default, null),
    onClick: function onClick() {
      return addItem();
    }
  }, addBtnProps)));
};
var listTable_default = TableList;

// ../../node_modules/form-render/es/widgets/listDrawer/index.js
var import_PlusOutlined6 = __toESM(require_PlusOutlined2());
var import_CopyOutlined6 = __toESM(require_CopyOutlined2());
var import_CloseOutlined11 = __toESM(require_CloseOutlined2());
var import_ArrowDownOutlined4 = __toESM(require_ArrowDownOutlined2());
var import_ArrowUpOutlined4 = __toESM(require_ArrowUpOutlined2());
var import_InfoCircleOutlined2 = __toESM(require_InfoCircleOutlined2());
var import_react209 = __toESM(require_react());

// ../../node_modules/form-render/es/widgets/listDrawer/drawerForm.js
var import_react208 = __toESM(require_react());
var DrawerForm = function DrawerForm2(props) {
  var children = props.children, onConfirm = props.onConfirm, onClose = props.onClose, ret = __rest(props, ["children", "onConfirm", "onClose"]);
  var configCtx = (0, import_react208.useContext)(config_provider_default.ConfigContext);
  var t2 = translation3(configCtx);
  var extraProps = Object.assign(Object.assign({}, ret), {
    open: true
  });
  if (window.antdVersion === "v4") {
    extraProps = Object.assign(Object.assign({}, ret), {
      visible: true
    });
  }
  return /* @__PURE__ */ import_react208.default.createElement(drawer_default, Object.assign({
    width: 600,
    title: t2("operate")
  }, extraProps, {
    onClose,
    extra: /* @__PURE__ */ import_react208.default.createElement(space_default, null, /* @__PURE__ */ import_react208.default.createElement(button_default2, {
      onClick: onClose
    }, t2("cancel")), /* @__PURE__ */ import_react208.default.createElement(button_default2, {
      type: "primary",
      onClick: onConfirm
    }, t2("confirm")))
  }), children);
};
var drawerForm_default = DrawerForm;

// ../../node_modules/form-render/es/widgets/listDrawer/index.js
function _typeof10(o3) {
  "@babel/helpers - typeof";
  return _typeof10 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o4) {
    return typeof o4;
  } : function(o4) {
    return o4 && "function" == typeof Symbol && o4.constructor === Symbol && o4 !== Symbol.prototype ? "symbol" : typeof o4;
  }, _typeof10(o3);
}
function _defineProperty6(e3, r2, t2) {
  return (r2 = _toPropertyKey5(r2)) in e3 ? Object.defineProperty(e3, r2, { value: t2, enumerable: true, configurable: true, writable: true }) : e3[r2] = t2, e3;
}
function _toPropertyKey5(t2) {
  var i = _toPrimitive5(t2, "string");
  return "symbol" == _typeof10(i) ? i : i + "";
}
function _toPrimitive5(t2, r2) {
  if ("object" != _typeof10(t2) || !t2) return t2;
  var e3 = t2[Symbol.toPrimitive];
  if (void 0 !== e3) {
    var i = e3.call(t2, r2 || "default");
    if ("object" != _typeof10(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t2);
}
function _toConsumableArray13(r2) {
  return _arrayWithoutHoles13(r2) || _iterableToArray13(r2) || _unsupportedIterableToArray18(r2) || _nonIterableSpread13();
}
function _nonIterableSpread13() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray13(r2) {
  if ("undefined" != typeof Symbol && null != r2[Symbol.iterator] || null != r2["@@iterator"]) return Array.from(r2);
}
function _arrayWithoutHoles13(r2) {
  if (Array.isArray(r2)) return _arrayLikeToArray18(r2);
}
function _slicedToArray10(r2, e3) {
  return _arrayWithHoles11(r2) || _iterableToArrayLimit10(r2, e3) || _unsupportedIterableToArray18(r2, e3) || _nonIterableRest11();
}
function _nonIterableRest11() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray18(r2, a) {
  if (r2) {
    if ("string" == typeof r2) return _arrayLikeToArray18(r2, a);
    var t2 = {}.toString.call(r2).slice(8, -1);
    return "Object" === t2 && r2.constructor && (t2 = r2.constructor.name), "Map" === t2 || "Set" === t2 ? Array.from(r2) : "Arguments" === t2 || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t2) ? _arrayLikeToArray18(r2, a) : void 0;
  }
}
function _arrayLikeToArray18(r2, a) {
  (null == a || a > r2.length) && (a = r2.length);
  for (var e3 = 0, n2 = Array(a); e3 < a; e3++) n2[e3] = r2[e3];
  return n2;
}
function _iterableToArrayLimit10(r2, l2) {
  var t2 = null == r2 ? null : "undefined" != typeof Symbol && r2[Symbol.iterator] || r2["@@iterator"];
  if (null != t2) {
    var e3, n2, i, u, a = [], f = true, o3 = false;
    try {
      if (i = (t2 = t2.call(r2)).next, 0 === l2) {
        if (Object(t2) !== t2) return;
        f = false;
      } else for (; !(f = (e3 = i.call(t2)).done) && (a.push(e3.value), a.length !== l2); f = true) ;
    } catch (r3) {
      o3 = true, n2 = r3;
    } finally {
      try {
        if (!f && null != t2.return && (u = t2.return(), Object(u) !== u)) return;
      } finally {
        if (o3) throw n2;
      }
    }
    return a;
  }
}
function _arrayWithHoles11(r2) {
  if (Array.isArray(r2)) return r2;
}
var getTooltip7 = function getTooltip8(tooltip) {
  if (!tooltip) {
    return;
  }
  if (typeof tooltip === "string") {
    return {
      title: /* @__PURE__ */ import_react209.default.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: tooltip
        }
      })
    };
  }
  return Object.assign(Object.assign({}, tooltip), {
    title: /* @__PURE__ */ import_react209.default.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: tooltip.title
      }
    })
  });
};
var TableList3 = function TableList4(props) {
  var _a, _b;
  var form = props.form, schema = props.schema, fields = props.fields, rootPath = props.rootPath, renderCore = props.renderCore, readOnly = props.readOnly, widgets = props.widgets, pagination = props.pagination, operateBtnType = props.operateBtnType, addBtnProps = props.addBtnProps, delConfirmProps = props.delConfirmProps, copyBtnProps = props.copyBtnProps, deleteBtnProps = props.deleteBtnProps, moveUpBtnProps = props.moveUpBtnProps, moveDownBtnProps = props.moveDownBtnProps, actionColumnProps = props.actionColumnProps, editorBtnProps = props.editorBtnProps, drawerProps = props.drawerProps, hideOperate = props.hideOperate, hideDelete = props.hideDelete, hideCopy = props.hideCopy, hideMove = props.hideMove, hideAdd = props.hideAdd, hideEdit = props.hideEdit, hideColumnNestedObject = props.hideColumnNestedObject, operation = props.operation, addItem = props.addItem, copyItem = props.copyItem, moveItem = props.moveItem, removeItem = props.removeItem, configContext = props.configContext;
  var colHeaderText = actionColumnProps.colHeaderText, otherActionColumnProps = __rest(actionColumnProps, ["colHeaderText"]);
  var paginationConfig = Object.assign({
    size: "small",
    hideOnSinglePage: true
  }, pagination);
  var columnSchema = ((_a = schema === null || schema === void 0 ? void 0 : schema.items) === null || _a === void 0 ? void 0 : _a.properties) || {};
  var _useState = (0, import_react209.useState)(false), _useState2 = _slicedToArray10(_useState, 2), visible = _useState2[0], setVisible = _useState2[1];
  var _useState3 = (0, import_react209.useState)(null), _useState4 = _slicedToArray10(_useState3, 2), itemData = _useState4[0], setItemData = _useState4[1];
  var indexRef = (0, import_react209.useRef)(null);
  var handleCopy = function handleCopy2(name) {
    var value = form.getFieldValue(rootPath.concat(name));
    copyItem(value, name);
  };
  var handleAdd = function handleAdd2() {
    setVisible(true);
    addItem();
  };
  var handleRepeal = function handleRepeal2() {
    if (!indexRef.current && indexRef.current !== 0) {
      operation.remove(fields.length - 1);
    } else {
      form.setFieldValue([].concat(_toConsumableArray13(rootPath), [indexRef.current]), itemData);
    }
    handleCloseDrawer();
  };
  var handleCloseDrawer = function handleCloseDrawer2() {
    setItemData(null);
    setVisible(false);
    indexRef.current = null;
  };
  var columns = sortProperties_default(Object.entries(columnSchema)).map(function(_ref) {
    var _ref2 = _slicedToArray10(_ref, 2), dataIndex = _ref2[0], item = _ref2[1];
    var required5 = item.required, title = item.title, tooltip = item.tooltip, width = item.width, columnHidden = item.columnHidden;
    if (columnHidden) {
      return null;
    }
    var tooltipProps = getTooltip7(tooltip);
    return {
      dataIndex,
      width,
      title: /* @__PURE__ */ import_react209.default.createElement(import_react209.default.Fragment, null, required5 && /* @__PURE__ */ import_react209.default.createElement("span", {
        style: {
          color: "red",
          marginRight: "3px"
        }
      }, "*"), /* @__PURE__ */ import_react209.default.createElement("span", null, title), tooltipProps && /* @__PURE__ */ import_react209.default.createElement(tooltip_default, Object.assign({
        placement: "top"
      }, tooltipProps), /* @__PURE__ */ import_react209.default.createElement(import_InfoCircleOutlined2.default, {
        style: {
          marginLeft: 6
        }
      }))),
      render: function render4(_, field) {
        var _a2;
        var fieldSchema = {
          type: "object",
          properties: _defineProperty6({}, dataIndex, Object.assign(Object.assign({}, columnSchema[dataIndex]), {
            noStyle: true,
            readOnly: true
          }))
        };
        var fieldDataIndex = fieldSchema.properties[dataIndex];
        var renderColumn = renderCore({
          schema: fieldSchema,
          parentPath: [field.name],
          rootPath: [].concat(_toConsumableArray13(rootPath), [field.name])
        });
        if ((fieldDataIndex === null || fieldDataIndex === void 0 ? void 0 : fieldDataIndex.type) === "array" && ((_a2 = fieldDataIndex === null || fieldDataIndex === void 0 ? void 0 : fieldDataIndex.items) === null || _a2 === void 0 ? void 0 : _a2.type) === "object" || (fieldDataIndex === null || fieldDataIndex === void 0 ? void 0 : fieldDataIndex.type) === "object") {
          if (hideColumnNestedObject === "hide") {
            return "-";
          } else if (hideColumnNestedObject === "collapse") {
            return /* @__PURE__ */ import_react209.default.createElement(collapse_default2, {
              ghost: true,
              items: [{
                key: "detail",
                label: "\u67E5\u770B\u8BE6\u60C5",
                children: renderColumn
              }]
            });
          } else {
            return renderColumn;
          }
        }
        return renderColumn;
      }
    };
  }).filter(function(item) {
    return item;
  });
  if (!readOnly && !hideOperate) {
    columns.push(Object.assign(Object.assign({
      title: colHeaderText,
      width: "190px",
      fixed: "right"
    }, otherActionColumnProps), {
      render: function render4(_, field) {
        return /* @__PURE__ */ import_react209.default.createElement(form_default.Item, null, /* @__PURE__ */ import_react209.default.createElement(space_default, {
          className: "fr-list-item-operate",
          split: operateBtnType !== "icon" && /* @__PURE__ */ import_react209.default.createElement(divider_default, {
            type: "vertical"
          })
        }, !hideMove && /* @__PURE__ */ import_react209.default.createElement(import_react209.default.Fragment, null, /* @__PURE__ */ import_react209.default.createElement(FButton_default, Object.assign({
          disabled: field.name === 0,
          onClick: function onClick() {
            return moveItem(field.name, field.name - 1);
          },
          icon: /* @__PURE__ */ import_react209.default.createElement(import_ArrowUpOutlined4.default, null)
        }, moveUpBtnProps)), /* @__PURE__ */ import_react209.default.createElement(FButton_default, Object.assign({
          disabled: field.name === fields.length - 1,
          onClick: function onClick() {
            return moveItem(field.name, field.name + 1);
          },
          icon: /* @__PURE__ */ import_react209.default.createElement(import_ArrowDownOutlined4.default, null)
        }, moveDownBtnProps))), !hideDelete && /* @__PURE__ */ import_react209.default.createElement(popconfirm_default, Object.assign({
          onConfirm: function onConfirm() {
            return removeItem(field.name);
          }
        }, delConfirmProps), /* @__PURE__ */ import_react209.default.createElement(FButton_default, Object.assign({
          icon: /* @__PURE__ */ import_react209.default.createElement(import_CloseOutlined11.default, null),
          btnType: operateBtnType
        }, deleteBtnProps))), !hideCopy && /* @__PURE__ */ import_react209.default.createElement(FButton_default, Object.assign({
          onClick: function onClick() {
            return handleCopy(field.name);
          },
          icon: /* @__PURE__ */ import_react209.default.createElement(import_CopyOutlined6.default, null)
        }, copyBtnProps)), !hideEdit && /* @__PURE__ */ import_react209.default.createElement(FButton_default, Object.assign({
          onClick: function onClick() {
            setVisible(true);
            indexRef.current = field.name;
            setItemData(form.getFieldValue(rootPath.concat(field.name)));
          },
          icon: /* @__PURE__ */ import_react209.default.createElement(import_CopyOutlined6.default, null)
        }, editorBtnProps))));
      }
    }));
  }
  var drawerIndex = (_b = indexRef.current) !== null && _b !== void 0 ? _b : fields.length - 1;
  var hanldeConfirm = function hanldeConfirm2() {
    var _a2;
    var path2 = (_a2 = [].concat(_toConsumableArray13(rootPath), [drawerIndex])) === null || _a2 === void 0 ? void 0 : _a2.join(".");
    form.validateFields([path2], {
      recursive: true
    }).then(function(res) {
      handleCloseDrawer();
    }).catch(function(error2) {
      console.log("\u8868\u5355\u6821\u9A8C\u9519\u8BEF", error2);
    });
  };
  return /* @__PURE__ */ import_react209.default.createElement("div", {
    className: "fr-list-drawer"
  }, /* @__PURE__ */ import_react209.default.createElement(table_default, {
    size: "middle",
    dataSource: fields,
    columns,
    style: {
      marginBottom: "12px"
    },
    scroll: {
      x: "max-content"
    },
    pagination: paginationConfig
  }), (!schema.max || fields.length < schema.max) && !hideAdd && /* @__PURE__ */ import_react209.default.createElement(button_default2, Object.assign({
    icon: /* @__PURE__ */ import_react209.default.createElement(import_PlusOutlined6.default, null),
    onClick: handleAdd
  }, addBtnProps)), visible && /* @__PURE__ */ import_react209.default.createElement(drawerForm_default, Object.assign({}, drawerProps, {
    schema,
    data: itemData,
    widgets,
    configContext,
    onClose: handleRepeal,
    onConfirm: hanldeConfirm
  }), renderCore({
    schema: schema.items,
    parentPath: [drawerIndex],
    rootPath: [].concat(_toConsumableArray13(rootPath), [drawerIndex])
  })));
};
var listDrawer_default = TableList3;

// ../../node_modules/form-render/es/widgets/listVirtual/index.js
var import_PlusOutlined7 = __toESM(require_PlusOutlined2());
var import_CopyOutlined7 = __toESM(require_CopyOutlined2());
var import_CloseOutlined12 = __toESM(require_CloseOutlined2());
var import_ArrowDownOutlined5 = __toESM(require_ArrowDownOutlined2());
var import_ArrowUpOutlined5 = __toESM(require_ArrowUpOutlined2());
var import_InfoCircleOutlined3 = __toESM(require_InfoCircleOutlined2());
var import_react212 = __toESM(require_react());
var import_classnames213 = __toESM(require_classnames());

// ../../node_modules/form-render/es/widgets/listVirtual/virtualCell.js
var import_react210 = __toESM(require_react());
function _slicedToArray11(r2, e3) {
  return _arrayWithHoles12(r2) || _iterableToArrayLimit11(r2, e3) || _unsupportedIterableToArray19(r2, e3) || _nonIterableRest12();
}
function _nonIterableRest12() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray19(r2, a) {
  if (r2) {
    if ("string" == typeof r2) return _arrayLikeToArray19(r2, a);
    var t2 = {}.toString.call(r2).slice(8, -1);
    return "Object" === t2 && r2.constructor && (t2 = r2.constructor.name), "Map" === t2 || "Set" === t2 ? Array.from(r2) : "Arguments" === t2 || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t2) ? _arrayLikeToArray19(r2, a) : void 0;
  }
}
function _arrayLikeToArray19(r2, a) {
  (null == a || a > r2.length) && (a = r2.length);
  for (var e3 = 0, n2 = Array(a); e3 < a; e3++) n2[e3] = r2[e3];
  return n2;
}
function _iterableToArrayLimit11(r2, l2) {
  var t2 = null == r2 ? null : "undefined" != typeof Symbol && r2[Symbol.iterator] || r2["@@iterator"];
  if (null != t2) {
    var e3, n2, i, u, a = [], f = true, o3 = false;
    try {
      if (i = (t2 = t2.call(r2)).next, 0 === l2) {
        if (Object(t2) !== t2) return;
        f = false;
      } else for (; !(f = (e3 = i.call(t2)).done) && (a.push(e3.value), a.length !== l2); f = true) ;
    } catch (r3) {
      o3 = true, n2 = r3;
    } finally {
      try {
        if (!f && null != t2.return && (u = t2.return(), Object(u) !== u)) return;
      } finally {
        if (o3) throw n2;
      }
    }
    return a;
  }
}
function _arrayWithHoles12(r2) {
  if (Array.isArray(r2)) return r2;
}
var VirtualCell2 = function VirtualCell3(props) {
  var renderCore = props.renderCore, schema = props.schema, dataIndex = props.dataIndex, otherProps = __rest(props, ["renderCore", "schema", "dataIndex"]);
  var _useState = (0, import_react210.useState)(null), _useState2 = _slicedToArray11(_useState, 2), errorMsg = _useState2[0], setErrorMsg = _useState2[1];
  var _useState3 = (0, import_react210.useState)(), _useState4 = _slicedToArray11(_useState3, 2), visible = _useState4[0], setVisible = _useState4[1];
  var mouseRef = (0, import_react210.useRef)(null);
  var onStatusChange = function onStatusChange2(_, errors) {
    var message2 = errors[0] || null;
    setErrorMsg(message2);
    if (mouseRef.current && message2) {
      setVisible(true);
    }
  };
  if (!schema.properties[dataIndex].onStatusChange) {
    schema.properties[dataIndex].onStatusChange = onStatusChange;
  }
  var popoverVisible = visible && errorMsg;
  var popoverProps = {
    open: popoverVisible
  };
  if (window.antdVersion === "v4") {
    popoverProps = {
      visible: popoverVisible
    };
  }
  return /* @__PURE__ */ import_react210.default.createElement("div", {
    onMouseEnter: function onMouseEnter() {
      mouseRef.current = true;
      setVisible(true);
    },
    onMouseLeave: function onMouseLeave() {
      mouseRef.current = false;
      setVisible(false);
    }
  }, /* @__PURE__ */ import_react210.default.createElement(popover_default, Object.assign({
    overlayClassName: "fr-popover-error",
    content: errorMsg,
    placement: "topRight"
  }, popoverProps), renderCore(Object.assign(Object.assign({}, otherProps), {
    schema
  }))));
};
var virtualCell_default = VirtualCell2;

// ../../node_modules/virtualizedtableforantd4/dist/esm/vt.js
var import_react211 = __toESM(require_react());
var React577 = __toESM(require_react());
function _typeof11(obj) {
  "@babel/helpers - typeof";
  return _typeof11 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof11(obj);
}
var _excluded76 = ["style", "context"];
var _excluded220 = ["ctx"];
function ownKeys2(object4, enumerableOnly) {
  var keys4 = Object.keys(object4);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object4);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object4, sym).enumerable;
    })), keys4.push.apply(keys4, symbols);
  }
  return keys4;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys2(Object(source), true).forEach(function(key2) {
      _defineProperty7(target, key2, source[key2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys2(Object(source)).forEach(function(key2) {
      Object.defineProperty(target, key2, Object.getOwnPropertyDescriptor(source, key2));
    });
  }
  return target;
}
function _defineProperty7(obj, key2, value) {
  key2 = _toPropertyKey6(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey6(arg) {
  var key2 = _toPrimitive6(arg, "string");
  return _typeof11(key2) === "symbol" ? key2 : String(key2);
}
function _toPrimitive6(input, hint) {
  if (_typeof11(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (_typeof11(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _objectWithoutProperties2(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose2(source, excluded);
  var key2, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key2 = sourceSymbolKeys[i];
      if (excluded.indexOf(key2) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key2)) continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose2(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key2, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key2 = sourceKeys[i];
    if (excluded.indexOf(key2) >= 0) continue;
    target[key2] = source[key2];
  }
  return target;
}
function _extends2() {
  _extends2 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends2.apply(this, arguments);
}
var SCROLLEVT_NULL = 0 << 0;
var SCROLLEVT_INIT = 1 << 0;
var SCROLLEVT_RECOMPUTE = 1 << 1;
var SCROLLEVT_NATIVE = 1 << 3;
var SCROLLEVT_BY_HOOK = 1 << 6;
var TOP_CONTINUE = 0;
var TOP_DONE = 1;
var e_VT_STATE;
(function(e_VT_STATE2) {
  e_VT_STATE2[e_VT_STATE2["INIT"] = 1] = "INIT";
  e_VT_STATE2[e_VT_STATE2["LOADED"] = 2] = "LOADED";
  e_VT_STATE2[e_VT_STATE2["RUNNING"] = 4] = "RUNNING";
})(e_VT_STATE || (e_VT_STATE = {}));
function default_context() {
  return {
    vt_state: e_VT_STATE.INIT,
    possible_hight_per_tr: -1,
    computed_h: 0,
    re_computed: 0,
    row_height: [],
    row_count: 0,
    prev_row_count: 0,
    _offset_top: 0 | 0,
    _offset_head: 0 | 0,
    _offset_tail: 0 | 1,
    WH: 0,
    // the wrapper's height
    top: 0,
    left: 0,
    evt: SCROLLEVT_NULL,
    end: false,
    final_top: 0,
    f_final_top: TOP_DONE,
    update_count: 0,
    indexMap: /* @__PURE__ */ new WeakMap(),
    HND_PAINT: 0,
    retry_count: 5
  };
}
function helper_diagnosis(ctx) {
  if (Object.prototype.hasOwnProperty.call(ctx, "CLICK~__DIAGNOSIS__")) return;
  function diagnosis(flag) {
    var expect_height = 0;
    for (var i = 0; i < ctx.row_count; ++i) {
      expect_height += ctx.row_height[i];
    }
    var color, explain;
    if (expect_height > ctx.computed_h) {
      color = "color:rgb(15, 179, 9)";
      explain = "lower than expected";
    } else if (expect_height < ctx.computed_h) {
      color = "color:rgb(202, 61, 81)";
      explain = "higher than expected";
    } else {
      color = "color:rgba(0, 0, 0, 0.85)";
      explain = "normal";
    }
    var ret = ctx.computed_h - expect_height;
    if (flag) {
      console.debug("OoOoOoO DIAGNOSIS OoOoOoO");
      console.debug("%c%d(%d)(".concat(explain, ")"), color, expect_height, ctx.computed_h - expect_height);
      console.debug("OoOoOoOoOoOoOOoOoOoOoOoOo");
    }
    return ret;
  }
  Object.defineProperty(ctx, "CLICK~__DIAGNOSIS__", {
    get: function get3() {
      diagnosis(true);
    },
    configurable: false,
    enumerable: false
  });
  function cb() {
    if (diagnosis(false) !== 0) {
      window.alert("vt: an error occurred!");
      return;
    }
    window.requestIdleCallback ? window.requestIdleCallback(cb) : window.setTimeout(cb);
  }
  ctx.debug && cb();
}
function log_debug(ctx, msg) {
  if (ctx.debug) {
    if (msg[0] === "+") {
      return console.debug(msg.slice(1));
    }
    var d = /* @__PURE__ */ new Date();
    var tid = "".concat(d.toLocaleTimeString(), ".").concat(d.getMilliseconds());
    console.debug("%c[".concat(ctx.id, "][").concat(tid, "][").concat(msg, "]"), "color:#a00", ctx);
  }
}
var TableImpl = /* @__PURE__ */ React577.forwardRef(function TableImpl2(props, ref3) {
  return /* @__PURE__ */ React577.createElement("table", _extends2({
    ref: ref3
  }, props));
});
function WrapperImpl(props) {
  return /* @__PURE__ */ React577.createElement("tbody", props);
}
var RowImpl = /* @__PURE__ */ React577.forwardRef(function RowImpl2(props, ref3) {
  return /* @__PURE__ */ React577.createElement("tr", _extends2({
    ref: ref3
  }, props));
});
function scroll_with_offset(ctx, top) {
  var row_height = ctx.row_height, row_count = ctx.row_count, overscanRowCount = ctx.overscanRowCount;
  ctx._scroll_y = ctx.scroll.y;
  if (typeof ctx._scroll_y === "number") {
    ctx._y = ctx._scroll_y;
  } else if (typeof ctx._scroll_y === "string") {
    ctx._y = ctx.wrap_inst.current.parentElement.offsetHeight;
  } else {
    console.assert(false, "VT: did you forget to set `scroll.y`?");
    ctx._y = ctx.wrap_inst.current.parentElement.offsetHeight;
  }
  console.assert(ctx._y >= 0);
  var _top = 0, i = 0, j = 0;
  var torender_h = 0;
  if (top === -1 && row_count > 0) {
    i = row_count;
    while (i > 0 && torender_h < ctx._y) {
      torender_h += row_height[--i];
    }
    return [0 | i, 0 | row_count, 0 | ctx.computed_h - torender_h];
  }
  for (; i < row_count && _top < top; ++i) {
    _top += row_height[i];
  }
  j = i;
  for (; j < row_count && torender_h < ctx._y; ++j) {
    torender_h += row_height[j];
  }
  var overscan = overscanRowCount < 0 ? 0 : overscanRowCount;
  while (i > 0 && overscan--) {
    _top -= row_height[--i];
  }
  j += overscanRowCount;
  if (j > row_count) j = row_count;
  return [0 | i, 0 | j, 0 | _top];
}
function set_offset(ctx, top, head, tail) {
  ctx._offset_top = 0 | top;
  ctx._offset_head = 0 | head;
  ctx._offset_tail = 0 | tail;
}
function set_scroll(ctx, top, left2, evt, end) {
  ctx.top = top;
  ctx.left = left2;
  ctx.evt = evt;
  ctx.end = end;
}
function scroll_to(ctx, top, left2) {
  if (!ctx.wrap_inst.current) return;
  var ele = ctx.wrap_inst.current.parentElement;
  ele.scrollTop = top;
  ele.scrollLeft = Math.max(left2, ele.scrollLeft);
}
function repainting(ctx) {
  if (ctx.HND_PAINT) return;
  var cq = ctx.cq, wrap_inst = ctx.wrap_inst;
  var fn = function fn2() {
    ctx.HND_PAINT = 0;
    for (var i = 0; i < cq.length; ++i) {
      if (cq[i].index >= ctx._offset_head && cq[i].index < ctx._offset_tail) {
        cq[i].func();
      }
    }
    if (ctx.vt_state !== e_VT_STATE.RUNNING || !wrap_inst.current) return;
    var h2 = ctx.computed_h;
    if (ctx.WH === h2) return;
    ctx.WH = h2;
    var s = wrap_inst.current.style;
    s.height = h2 ? (s.maxHeight = h2 + "px", s.maxHeight) : (s.maxHeight = "unset", s.maxHeight);
    ctx.on_update_wrap_style();
  };
  ctx.HND_PAINT = ctx.evt === SCROLLEVT_NATIVE ? window.requestAnimationFrame(fn) : window.setTimeout(fn);
}
function srs_expand(ctx, len, prev_len, fill_value) {
  var slen = len - prev_len;
  var shadow_rows = new Array(slen).fill(fill_value);
  ctx.row_height = ctx.row_height.concat(shadow_rows);
  ctx.computed_h += slen * fill_value;
}
function srs_shrink(ctx, len, prev_len) {
  if (len === 0) {
    ctx.computed_h = 0;
    ctx.row_height.length = 0;
    ctx.top = 0;
    return;
  }
  var rows = ctx.row_height;
  var h2shrink = 0;
  for (var i = len; i < prev_len; ++i) {
    h2shrink += rows[i];
  }
  ctx.computed_h -= h2shrink;
}
function set_tr_cnt(ctx, n2) {
  ctx.re_computed = n2 - ctx.row_count;
  ctx.prev_row_count = ctx.row_count;
  ctx.row_count = n2;
}
var VTable = function VTable2(props, ref3) {
  var style2 = props.style, context = props.context, rest = _objectWithoutProperties2(props, _excluded76);
  var force = (0, import_react211.useState)(0);
  var ref_func = (0, import_react211.useRef)(function() {
  });
  var scroll_hook;
  var wrap_inst = (0, import_react211.useMemo)(function() {
    return /* @__PURE__ */ React577.createRef();
  }, []);
  var ctx = (0, import_react211.useContext)(context);
  (0, import_react211.useMemo)(function() {
    Object.assign(ctx, default_context());
    if (ctx.wrap_inst && ctx.wrap_inst.current) {
      ctx.wrap_inst.current.parentElement.removeEventListener("scroll", scroll_hook);
    }
    ctx.wrap_inst = wrap_inst;
    ctx.top = ctx.initTop;
    ctx.on_update_wrap_style = function() {
      if (ctx._y === 0 && "".concat(ctx._scroll_y).length) {
        scroll_hook({
          flag: SCROLLEVT_BY_HOOK,
          target: {
            scrollTop: ctx.top,
            scrollLeft: ctx.left
          }
        });
      }
    };
    if (true) helper_diagnosis(ctx);
    ctx.cq = [];
    var pfirst = 0;
    var circleBufferSize = 0;
    ctx.cq.push = function(item) {
      if (ctx.vt_state !== e_VT_STATE.RUNNING) return;
      var size = ctx._offset_tail - ctx._offset_head + ctx.overscanRowCount * 2 + 10;
      circleBufferSize = Math.max(circleBufferSize, size);
      if (pfirst > circleBufferSize) {
        pfirst = 0;
      }
      ctx.cq[pfirst++] = item;
      return 0;
    };
  }, []);
  var event_queue = (0, import_react211.useRef)([]).current;
  var RAF_update_self;
  scroll_hook = (0, import_react211.useCallback)(function(ev) {
    if (ctx.vt_state !== e_VT_STATE.RUNNING) return;
    var t0 = performance.now();
    if (ev) {
      if ("flag" in ev) {
        event_queue.push(ev);
      } else {
        var target = ev.target;
        var top = Math.max(target.scrollTop, 0);
        event_queue.push({
          target: {
            scrollTop: top,
            scrollLeft: target.scrollLeft
          },
          end: Math.abs(target.scrollHeight - target.clientHeight - Math.round(top)) <= (ctx.offset || 0),
          flag: SCROLLEVT_NATIVE
        });
      }
      if (ctx.f_final_top === TOP_CONTINUE) {
        return RAF_update_self(t0);
      }
    }
    if (ctx.HND_RAF) return;
    ctx.HND_RAF = window.setTimeout(function() {
      return Promise.resolve().then(function() {
        return RAF_update_self(t0);
      });
    });
  }, []);
  RAF_update_self = (0, import_react211.useCallback)(function(time) {
    ctx.HND_RAF = 0;
    var t1 = performance.now();
    if (t1 - time > 10 && ctx.retry_count-- > 0) {
      scroll_hook();
      return;
    }
    ctx.retry_count = 5;
    if (ctx.vt_state !== e_VT_STATE.RUNNING) return;
    var evq = event_queue;
    var e3;
    if (!evq.length) {
      return;
    }
    e3 = evq.pop();
    evq.length = 0;
    var etop = e3.target.scrollTop;
    var eleft = e3.target.scrollLeft;
    var flag = e3.flag;
    log_debug(ctx, "top: ".concat(etop, ", left: ").concat(eleft));
    var offset4 = scroll_with_offset(ctx, ctx.f_final_top === TOP_CONTINUE ? ctx.final_top : etop);
    var head = offset4[0];
    var tail = offset4[1];
    var top = offset4[2];
    var prev_head = ctx._offset_head;
    var prev_tail = ctx._offset_tail;
    var prev_top = ctx._offset_top;
    var end = false;
    switch (flag) {
      case SCROLLEVT_INIT:
        log_debug(ctx, "SCROLLEVT_INIT");
        break;
      case SCROLLEVT_BY_HOOK:
        log_debug(ctx, "SCROLLEVT_BY_HOOK");
        if (head === prev_head && tail === prev_tail && top === prev_top) {
          ctx.f_final_top = TOP_DONE;
          if (ctx.final_top === -1) etop = ctx.computed_h - ctx._y;
          end = true;
        } else {
          if (ctx.final_top === -1) etop = top;
        }
        break;
      case SCROLLEVT_RECOMPUTE:
        if (head === prev_head && tail === prev_tail && top === prev_top) {
          return;
        }
        log_debug(ctx, "SCROLLEVT_RECOMPUTE");
        break;
      case SCROLLEVT_NATIVE:
        if (head === prev_head && tail === prev_tail && top === prev_top) {
          return;
        }
        log_debug(ctx, "SCROLLEVT_NATIVE");
        if (ctx.onScroll) {
          ctx.onScroll({
            top: etop,
            left: eleft,
            isEnd: e3.end
          });
        }
        end = e3.end;
        break;
    }
    set_offset(ctx, top, head, tail);
    set_scroll(ctx, etop, eleft, flag, end);
    force[1](++ctx.update_count);
  }, []);
  (0, import_react211.useImperativeHandle)(ref3, function() {
    var _scrollTo = function scrollTo2(y) {
      ctx.f_final_top = TOP_CONTINUE;
      ctx.final_top = y;
      scroll_hook({
        target: {
          scrollTop: y,
          scrollLeft: -1
        },
        flag: SCROLLEVT_BY_HOOK
      });
    };
    return {
      scrollTo: function scrollTo2(y) {
        ref_func.current = function() {
          return _scrollTo(y);
        };
        ref_func.current();
      },
      scrollToIndex: function scrollToIndex(idx) {
        ref_func.current = function() {
          if (idx > ctx.row_count - 1) idx = ctx.row_count - 1;
          if (idx < 0) idx = 0;
          var y = 0;
          for (var i = 0; i < idx; ++i) {
            y += ctx.row_height[i];
          }
          _scrollTo(y);
        };
        ref_func.current();
      }
    };
  }, []);
  (0, import_react211.useEffect)(function() {
    var el = wrap_inst.current.parentElement;
    try {
      el.addEventListener("scroll", scroll_hook, {
        passive: true
      });
    } catch (_unused) {
      el.addEventListener("scroll", scroll_hook, false);
    }
  }, [wrap_inst.current]);
  (0, import_react211.useEffect)(function() {
    scroll_hook({
      flag: SCROLLEVT_BY_HOOK,
      target: {
        scrollLeft: ctx.left,
        scrollTop: ctx.top
      }
    });
  }, [ctx.scroll.y]);
  (0, import_react211.useEffect)(function() {
    switch (ctx.evt) {
      case SCROLLEVT_BY_HOOK:
        if (ctx.f_final_top === TOP_CONTINUE) {
          ref_func.current();
        } else {
          scroll_to(ctx, ctx.top, ctx.left);
        }
        break;
      case SCROLLEVT_INIT:
      case SCROLLEVT_RECOMPUTE:
        scroll_to(ctx, ctx.top, ctx.left);
        break;
    }
  }, [
    force[0]
    /* for performance. */
  ]);
  (0, import_react211.useEffect)(function() {
    switch (ctx.vt_state) {
      case e_VT_STATE.LOADED:
        ctx.vt_state = e_VT_STATE.RUNNING;
        scroll_hook({
          target: {
            scrollTop: ctx.top,
            scrollLeft: 0
          },
          flag: SCROLLEVT_BY_HOOK
        });
        break;
      case e_VT_STATE.RUNNING:
        if (ctx.re_computed !== 0) {
          ctx.re_computed = 0;
          scroll_hook({
            target: {
              scrollTop: ctx.top,
              scrollLeft: ctx.left
            },
            flag: SCROLLEVT_RECOMPUTE
          });
        }
        break;
    }
  });
  var wrapStyle = (0, import_react211.useMemo)(function() {
    return {
      width: style2.width,
      minWidth: "100%",
      position: "relative",
      transform: "translate(0)"
    };
  }, [style2.width]);
  var tableStyle = (0, import_react211.useMemo)(function() {
    return _objectSpread(_objectSpread({}, style2), {}, {
      width: void 0,
      position: "relative",
      top: ctx._offset_top,
      transform: "translate(0)"
    });
  }, [ctx._offset_top]);
  var internalCtx = (0, import_react211.useMemo)(function() {
    return _objectSpread({}, ctx);
  }, [ctx.update_count]);
  var Table4 = ctx.components.table;
  return /* @__PURE__ */ React577.createElement("div", {
    ref: wrap_inst,
    style: wrapStyle
  }, /* @__PURE__ */ React577.createElement(context.Provider, {
    value: internalCtx
  }, /* @__PURE__ */ React577.createElement(Table4, _extends2({}, rest, {
    style: tableStyle
  }))));
};
var VWrapper = function VWrapper2(props) {
  var children = props.children, className2 = props.className, ctx = props.ctx;
  var measureRow = children[0];
  var rows = children[1];
  var len = Array.isArray(rows) ? rows.length : 0;
  var head = ctx._offset_head, tail = ctx._offset_tail;
  var trs = [];
  switch (ctx.vt_state) {
    case e_VT_STATE.INIT:
      if (len >= 0) {
        console.assert(head === 0);
        console.assert(tail === 1);
        if (Array.isArray(rows)) {
          trs = rows.slice(head, tail);
          ctx.indexMap.set(trs[0].props.record, 0);
        } else {
          trs = rows;
        }
        ctx.re_computed = len;
        ctx.prev_row_count = len;
        ctx.row_count = len;
      }
      break;
    case e_VT_STATE.RUNNING:
      {
        if (tail > len) {
          var offset4 = tail - len;
          tail -= offset4;
          head -= offset4;
          if (head < 0) head = 0;
          if (tail < 0) tail = 0;
          set_offset(ctx, ctx._offset_top, head, tail);
        }
        if (ctx.row_count !== len) {
          set_tr_cnt(ctx, len);
        }
        len = ctx.row_count;
        var prev_len = ctx.prev_row_count;
        if (len < prev_len) {
          srs_shrink(ctx, len, prev_len);
        } else if (len > prev_len) {
          var row_h = ctx.row_height;
          if (len - row_h.length > 0) {
            srs_expand(ctx, len, prev_len, ctx.possible_hight_per_tr);
          } else {
            row_h.fill(ctx.possible_hight_per_tr, prev_len, len);
            ctx.computed_h += ctx.possible_hight_per_tr * (len - prev_len);
          }
        }
        if (len) {
          var _idx = head;
          trs = rows.slice(_idx, tail);
          trs.forEach(function(el) {
            return ctx.indexMap.set(el.props.record, _idx++);
          });
        } else {
          trs = rows;
        }
        ctx.prev_row_count = ctx.row_count;
      }
      break;
    case e_VT_STATE.LOADED:
      console.assert(false);
      break;
  }
  var Wrapper3 = ctx.components.body.wrapper;
  return /* @__PURE__ */ React577.createElement(Wrapper3, {
    className: className2
  }, measureRow, trs);
};
var VTRow = function VTRow2(props) {
  var ref3 = /* @__PURE__ */ React577.createRef();
  var ctx = props.ctx, rest = _objectWithoutProperties2(props, _excluded220);
  var children = props.children;
  var Row3 = ctx.components.body.row;
  if (!Array.isArray(children)) {
    return /* @__PURE__ */ React577.createElement(Row3, rest, children);
  }
  var row_props = children[0].props;
  var index3 = ctx.indexMap.get(row_props.record);
  var last_index = (0, import_react211.useRef)(index3);
  var expanded_cls = (0, import_react211.useMemo)(function() {
    return ".".concat(row_props.prefixCls, "-expanded-row");
  }, [row_props.prefixCls]);
  var t0 = performance.now();
  (0, import_react211.useLayoutEffect)(function() {
    var t1 = performance.now();
    log_debug(ctx, "+idx ".concat(index3, " tooks ").concat(t1 - t0, " ms"));
    if (ctx.vt_state === e_VT_STATE.RUNNING) {
      repainting(ctx);
    } else {
      ctx.possible_hight_per_tr = ref3.current.offsetHeight;
      srs_expand(ctx, ctx.row_count, 0, ctx.possible_hight_per_tr);
      repainting(ctx);
      ctx.vt_state = e_VT_STATE.LOADED;
    }
    return function() {
      repainting(ctx);
    };
  }, []);
  (0, import_react211.useEffect)(function() {
    ctx.cq.push({
      index: index3,
      func: function func() {
        var rowElm = ref3.current;
        if (!rowElm) return;
        var h2 = rowElm.offsetHeight;
        var sibling2 = rowElm.nextSibling;
        while (sibling2 && sibling2.matches(expanded_cls)) {
          h2 += sibling2.offsetHeight;
          sibling2 = sibling2.nextSibling;
        }
        var curr_h = ctx.row_height[index3];
        var last_h = ctx.row_height[last_index.current];
        ctx.computed_h -= curr_h;
        ctx.computed_h += last_h;
        ctx.computed_h += h2 - last_h;
        ctx.row_height[index3] = h2;
      }
    });
    repainting(ctx);
  });
  return /* @__PURE__ */ React577.createElement(Row3, _extends2({}, rest, {
    ref: ref3
  }));
};
function _set_components(ctx, components) {
  var table = components.table, body = components.body, header = components.header;
  ctx.components.body = _objectSpread(_objectSpread({}, ctx.components.body), body);
  if (body && body.cell) {
    ctx._vtcomponents.body.cell = body.cell;
  }
  if (header) {
    ctx.components.header = header;
    ctx._vtcomponents.header = header;
  }
  if (table) {
    ctx.components.table = table;
  }
}
function init(fnOpts, deps) {
  var ctx = (0, import_react211.useRef)(/* @__PURE__ */ React577.createContext({})).current;
  var ctx_value = (0, import_react211.useContext)(ctx);
  var default_ref = (0, import_react211.useRef)({
    scrollTo: function scrollTo2(y) {
    },
    scrollToIndex: function scrollToIndex(idx) {
    }
  });
  (0, import_react211.useMemo)(function() {
    return Object.assign(ctx_value, {
      id: (+/* @__PURE__ */ new Date()).toString(36).slice(4),
      initTop: 0,
      overscanRowCount: 5,
      debug: false,
      ref: default_ref
    }, fnOpts());
  }, deps);
  (0, import_react211.useMemo)(function() {
    var VT = /* @__PURE__ */ React577.forwardRef(VTable);
    ctx_value._vtcomponents = {
      table: function table(props) {
        return /* @__PURE__ */ React577.createElement(VT, _extends2({}, props, {
          context: ctx,
          ref: ctx_value.ref
        }));
      },
      body: {
        // https://github.com/react-component/table/blob/master/src/Body/index.tsx#L114
        wrapper: function wrapper(props) {
          return /* @__PURE__ */ React577.createElement(ctx.Consumer, null, function() {
            return /* @__PURE__ */ React577.createElement(VWrapper, _extends2({}, props, {
              ctx: ctx_value
            }));
          });
        },
        row: function row(props) {
          return /* @__PURE__ */ React577.createElement(VTRow, _extends2({}, props, {
            ctx: ctx_value
          }));
        }
      }
    };
    ctx_value.components = {};
    _set_components(ctx_value, {
      table: TableImpl,
      body: {
        wrapper: WrapperImpl,
        row: RowImpl
      }
    });
    ctx_value.vt_state = e_VT_STATE.INIT;
  }, []);
  return ctx_value;
}

// ../../node_modules/virtualizedtableforantd4/dist/esm/index.js
function _typeof12(obj) {
  "@babel/helpers - typeof";
  return _typeof12 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof12(obj);
}
var _brower = 1;
var _node = 2;
(function() {
  var env = (typeof window === "undefined" ? "undefined" : _typeof12(window)) === "object" && window instanceof Window ? _brower : _node;
  if (env & _brower) {
    if (!Object.hasOwnProperty.call(window, "requestAnimationFrame") && !window.requestAnimationFrame) throw new Error("Please using the modern browers or appropriate polyfill!");
  }
})();
function useVT(fnOpts, deps) {
  var ctx = init(fnOpts, deps || []);
  return [ctx._vtcomponents, function(components) {
    return _set_components(ctx, components);
  }, ctx.ref];
}

// ../../node_modules/form-render/es/widgets/listVirtual/index.js
function _typeof13(o3) {
  "@babel/helpers - typeof";
  return _typeof13 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o4) {
    return typeof o4;
  } : function(o4) {
    return o4 && "function" == typeof Symbol && o4.constructor === Symbol && o4 !== Symbol.prototype ? "symbol" : typeof o4;
  }, _typeof13(o3);
}
function _toConsumableArray14(r2) {
  return _arrayWithoutHoles14(r2) || _iterableToArray14(r2) || _unsupportedIterableToArray20(r2) || _nonIterableSpread14();
}
function _nonIterableSpread14() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray14(r2) {
  if ("undefined" != typeof Symbol && null != r2[Symbol.iterator] || null != r2["@@iterator"]) return Array.from(r2);
}
function _arrayWithoutHoles14(r2) {
  if (Array.isArray(r2)) return _arrayLikeToArray20(r2);
}
function _defineProperty8(e3, r2, t2) {
  return (r2 = _toPropertyKey7(r2)) in e3 ? Object.defineProperty(e3, r2, { value: t2, enumerable: true, configurable: true, writable: true }) : e3[r2] = t2, e3;
}
function _toPropertyKey7(t2) {
  var i = _toPrimitive7(t2, "string");
  return "symbol" == _typeof13(i) ? i : i + "";
}
function _toPrimitive7(t2, r2) {
  if ("object" != _typeof13(t2) || !t2) return t2;
  var e3 = t2[Symbol.toPrimitive];
  if (void 0 !== e3) {
    var i = e3.call(t2, r2 || "default");
    if ("object" != _typeof13(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t2);
}
function _slicedToArray12(r2, e3) {
  return _arrayWithHoles13(r2) || _iterableToArrayLimit12(r2, e3) || _unsupportedIterableToArray20(r2, e3) || _nonIterableRest13();
}
function _nonIterableRest13() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray20(r2, a) {
  if (r2) {
    if ("string" == typeof r2) return _arrayLikeToArray20(r2, a);
    var t2 = {}.toString.call(r2).slice(8, -1);
    return "Object" === t2 && r2.constructor && (t2 = r2.constructor.name), "Map" === t2 || "Set" === t2 ? Array.from(r2) : "Arguments" === t2 || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t2) ? _arrayLikeToArray20(r2, a) : void 0;
  }
}
function _arrayLikeToArray20(r2, a) {
  (null == a || a > r2.length) && (a = r2.length);
  for (var e3 = 0, n2 = Array(a); e3 < a; e3++) n2[e3] = r2[e3];
  return n2;
}
function _iterableToArrayLimit12(r2, l2) {
  var t2 = null == r2 ? null : "undefined" != typeof Symbol && r2[Symbol.iterator] || r2["@@iterator"];
  if (null != t2) {
    var e3, n2, i, u, a = [], f = true, o3 = false;
    try {
      if (i = (t2 = t2.call(r2)).next, 0 === l2) {
        if (Object(t2) !== t2) return;
        f = false;
      } else for (; !(f = (e3 = i.call(t2)).done) && (a.push(e3.value), a.length !== l2); f = true) ;
    } catch (r3) {
      o3 = true, n2 = r3;
    } finally {
      try {
        if (!f && null != t2.return && (u = t2.return(), Object(u) !== u)) return;
      } finally {
        if (o3) throw n2;
      }
    }
    return a;
  }
}
function _arrayWithHoles13(r2) {
  if (Array.isArray(r2)) return r2;
}
var getTooltip9 = function getTooltip10(tooltip) {
  if (!tooltip) {
    return;
  }
  if (typeof tooltip === "string") {
    return {
      title: /* @__PURE__ */ import_react212.default.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: tooltip
        }
      })
    };
  }
  return Object.assign(Object.assign({}, tooltip), {
    title: /* @__PURE__ */ import_react212.default.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: tooltip.title
      }
    })
  });
};
var VirtualList = function VirtualList2(props) {
  var _a, _b;
  var form = props.form, schema = props.schema, fields = props.fields, rootPath = props.rootPath, renderCore = props.renderCore, readOnly = props.readOnly, operateBtnType = props.operateBtnType, addBtnProps = props.addBtnProps, delConfirmProps = props.delConfirmProps, copyBtnProps = props.copyBtnProps, deleteBtnProps = props.deleteBtnProps, moveUpBtnProps = props.moveUpBtnProps, moveDownBtnProps = props.moveDownBtnProps, actionColumnProps = props.actionColumnProps, _props$scrollY = props.scrollY, scrollY = _props$scrollY === void 0 ? 600 : _props$scrollY, hideDelete = props.hideDelete, hideCopy = props.hideCopy, hideMove = props.hideMove, hideAdd = props.hideAdd, hideOperate = props.hideOperate, hideEmptyTable = props.hideEmptyTable, addItem = props.addItem, copyItem = props.copyItem, moveItem = props.moveItem, removeItem = props.removeItem, configContext = props.configContext, validatePopover = props.validatePopover;
  var globalConfig2 = configContext.globalConfig;
  var islidatePopover = (_a = validatePopover !== null && validatePopover !== void 0 ? validatePopover : globalConfig2 === null || globalConfig2 === void 0 ? void 0 : globalConfig2.listValidatePopover) !== null && _a !== void 0 ? _a : true;
  var colHeaderText = actionColumnProps.colHeaderText, otherActionColumnProps = __rest(actionColumnProps, ["colHeaderText"]);
  var itemSchema = ((_b = schema === null || schema === void 0 ? void 0 : schema.items) === null || _b === void 0 ? void 0 : _b.properties) || {};
  var _useVT = useVT(function() {
    return {
      scroll: {
        y: scrollY
      }
    };
  }, []), _useVT2 = _slicedToArray12(_useVT, 2), vt = _useVT2[0], set_components = _useVT2[1];
  var handleCopy = function handleCopy2(name) {
    var value = form.getFieldValue(rootPath.concat(name));
    copyItem(value, name);
  };
  var columns = sortProperties_default(Object.entries(itemSchema)).map(function(_ref) {
    var _ref2 = _slicedToArray12(_ref, 2), dataIndex = _ref2[0], item = _ref2[1];
    var required5 = item.required, title = item.title, width = item.width, tooltip = item.tooltip;
    var tooltipProps = getTooltip9(tooltip);
    return {
      dataIndex,
      width,
      title: /* @__PURE__ */ import_react212.default.createElement(import_react212.default.Fragment, null, required5 && /* @__PURE__ */ import_react212.default.createElement("span", {
        style: {
          color: "red",
          marginRight: "3px"
        }
      }, "*"), /* @__PURE__ */ import_react212.default.createElement("span", null, title), tooltipProps && /* @__PURE__ */ import_react212.default.createElement(tooltip_default, Object.assign({
        placement: "top"
      }, tooltipProps), /* @__PURE__ */ import_react212.default.createElement(import_InfoCircleOutlined3.default, {
        style: {
          marginLeft: 6
        }
      }))),
      render: function render4(_, field) {
        var fieldSchema = {
          type: "object",
          properties: _defineProperty8({}, dataIndex, Object.assign(Object.assign({}, itemSchema[dataIndex]), {
            fieldCol: 24
          }))
        };
        if (!islidatePopover) {
          return /* @__PURE__ */ import_react212.default.createElement("div", {
            className: "fr-table-cell-content"
          }, renderCore({
            parentPath: [field.name],
            rootPath: [].concat(_toConsumableArray14(rootPath), [field.name]),
            schema: fieldSchema
          }));
        }
        return /* @__PURE__ */ import_react212.default.createElement(virtualCell_default, {
          renderCore,
          schema: fieldSchema,
          parentPath: [field.name],
          rootPath: [].concat(_toConsumableArray14(rootPath), [field.name]),
          dataIndex
        });
      }
    };
  });
  if (!readOnly && !hideOperate) {
    columns.push(Object.assign(Object.assign({
      title: colHeaderText,
      width: "190px",
      fixed: "right"
    }, otherActionColumnProps), {
      render: function render4(_, field) {
        return /* @__PURE__ */ import_react212.default.createElement(form_default.Item, null, /* @__PURE__ */ import_react212.default.createElement(space_default, {
          className: "fr-list-item-operate",
          split: operateBtnType !== "icon" && /* @__PURE__ */ import_react212.default.createElement(divider_default, {
            type: "vertical"
          })
        }, !hideMove && /* @__PURE__ */ import_react212.default.createElement(import_react212.default.Fragment, null, /* @__PURE__ */ import_react212.default.createElement(FButton_default, Object.assign({
          disabled: field.name === 0,
          onClick: function onClick() {
            return moveItem(field.name, field.name - 1);
          },
          icon: /* @__PURE__ */ import_react212.default.createElement(import_ArrowUpOutlined5.default, null)
        }, moveUpBtnProps)), /* @__PURE__ */ import_react212.default.createElement(FButton_default, Object.assign({
          disabled: field.name === fields.length - 1,
          onClick: function onClick() {
            return moveItem(field.name, field.name + 1);
          },
          icon: /* @__PURE__ */ import_react212.default.createElement(import_ArrowDownOutlined5.default, null)
        }, moveDownBtnProps))), !hideDelete && /* @__PURE__ */ import_react212.default.createElement(popconfirm_default, Object.assign({
          onConfirm: function onConfirm() {
            return removeItem(field.name);
          }
        }, delConfirmProps), /* @__PURE__ */ import_react212.default.createElement(FButton_default, Object.assign({
          icon: /* @__PURE__ */ import_react212.default.createElement(import_CloseOutlined12.default, null),
          btnType: operateBtnType
        }, deleteBtnProps))), !hideCopy && /* @__PURE__ */ import_react212.default.createElement(FButton_default, Object.assign({
          onClick: function onClick() {
            return handleCopy(field.name);
          },
          icon: /* @__PURE__ */ import_react212.default.createElement(import_CopyOutlined7.default, null)
        }, copyBtnProps))));
      }
    }));
  }
  var showTable = fields.length > 0 ? true : !hideEmptyTable;
  return /* @__PURE__ */ import_react212.default.createElement(import_react212.default.Fragment, null, showTable && /* @__PURE__ */ import_react212.default.createElement(table_default, {
    className: (0, import_classnames213.default)("fr-virtual-list", {
      "fr-virtual-list-no-popover": !islidatePopover
    }),
    size: "middle",
    columns,
    dataSource: fields,
    pagination: false,
    scroll: {
      y: scrollY
    },
    components: vt
  }), (!schema.max || fields.length < schema.max) && !hideAdd && /* @__PURE__ */ import_react212.default.createElement(button_default2, Object.assign({
    icon: /* @__PURE__ */ import_react212.default.createElement(import_PlusOutlined7.default, null),
    onClick: function onClick() {
      return addItem();
    }
  }, addBtnProps)));
};
var listVirtual_default = VirtualList;

// ../../node_modules/form-render/es/widgets/listTab/index.js
var import_CloseOutlined13 = __toESM(require_CloseOutlined2());
var import_react213 = __toESM(require_react());
function _slicedToArray13(r2, e3) {
  return _arrayWithHoles14(r2) || _iterableToArrayLimit13(r2, e3) || _unsupportedIterableToArray21(r2, e3) || _nonIterableRest14();
}
function _nonIterableRest14() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit13(r2, l2) {
  var t2 = null == r2 ? null : "undefined" != typeof Symbol && r2[Symbol.iterator] || r2["@@iterator"];
  if (null != t2) {
    var e3, n2, i, u, a = [], f = true, o3 = false;
    try {
      if (i = (t2 = t2.call(r2)).next, 0 === l2) {
        if (Object(t2) !== t2) return;
        f = false;
      } else for (; !(f = (e3 = i.call(t2)).done) && (a.push(e3.value), a.length !== l2); f = true) ;
    } catch (r3) {
      o3 = true, n2 = r3;
    } finally {
      try {
        if (!f && null != t2.return && (u = t2.return(), Object(u) !== u)) return;
      } finally {
        if (o3) throw n2;
      }
    }
    return a;
  }
}
function _arrayWithHoles14(r2) {
  if (Array.isArray(r2)) return r2;
}
function _toConsumableArray15(r2) {
  return _arrayWithoutHoles15(r2) || _iterableToArray15(r2) || _unsupportedIterableToArray21(r2) || _nonIterableSpread15();
}
function _nonIterableSpread15() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray21(r2, a) {
  if (r2) {
    if ("string" == typeof r2) return _arrayLikeToArray21(r2, a);
    var t2 = {}.toString.call(r2).slice(8, -1);
    return "Object" === t2 && r2.constructor && (t2 = r2.constructor.name), "Map" === t2 || "Set" === t2 ? Array.from(r2) : "Arguments" === t2 || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t2) ? _arrayLikeToArray21(r2, a) : void 0;
  }
}
function _iterableToArray15(r2) {
  if ("undefined" != typeof Symbol && null != r2[Symbol.iterator] || null != r2["@@iterator"]) return Array.from(r2);
}
function _arrayWithoutHoles15(r2) {
  if (Array.isArray(r2)) return _arrayLikeToArray21(r2);
}
function _arrayLikeToArray21(r2, a) {
  (null == a || a > r2.length) && (a = r2.length);
  for (var e3 = 0, n2 = Array(a); e3 < a; e3++) n2[e3] = r2[e3];
  return n2;
}
var TabPaneContent = function TabPaneContent2(props) {
  var renderCore = props.renderCore, name = props.name, schema = props.schema, rootPath = props.rootPath;
  return (0, import_react213.useMemo)(function() {
    return /* @__PURE__ */ import_react213.default.createElement("div", {
      style: {
        flex: 1
      }
    }, renderCore({
      schema,
      parentPath: [name],
      rootPath: [].concat(_toConsumableArray15(rootPath), [name])
    }));
  }, [JSON.stringify(props)]);
};
var TabList = function TabList2(props) {
  var schema = props.schema, fields = props.fields, rootPath = props.rootPath, renderCore = props.renderCore, readOnly = props.readOnly, delConfirmProps = props.delConfirmProps, tabName = props.tabName, hideDelete = props.hideDelete, hideAdd = props.hideAdd, addItem = props.addItem, removeItem = props.removeItem, _props$tabItemProps = props.tabItemProps, tabItemProps = _props$tabItemProps === void 0 ? {} : _props$tabItemProps, _activeKey = props.activeKey, retProps = __rest(props, ["schema", "fields", "rootPath", "renderCore", "readOnly", "delConfirmProps", "tabName", "hideDelete", "hideAdd", "addItem", "removeItem", "tabItemProps", "activeKey"]);
  var _useState = (0, import_react213.useState)("0"), _useState2 = _slicedToArray13(_useState, 2), activeKey = _useState2[0], setActiveKey = _useState2[1];
  var configCtx = (0, import_react213.useContext)(config_provider_default.ConfigContext);
  var t2 = translation3(configCtx);
  (0, import_react213.useEffect)(function() {
    setActiveKey(_activeKey || "0");
  }, [_activeKey]);
  var getTabPaneName = function getTabPaneName2(index3) {
    return tabName instanceof Array ? tabName[index3] || index3 + 1 : "".concat(tabName || t2("item"), " ").concat(index3 + 1);
  };
  var handleDelete = function handleDelete2(targetKey) {
    removeItem(targetKey);
    setActiveKey("".concat(targetKey > 1 ? targetKey - 1 : 0));
  };
  var handleEdit = function handleEdit2(_, action) {
    if (action === "add") {
      if ((!schema.max || fields.length < schema.max) && !readOnly && !hideAdd) {
        addItem();
        var currentKey = fields.length;
        setActiveKey("".concat(currentKey));
      }
    }
  };
  var renderClose = function renderClose2(name) {
    return !readOnly && !hideDelete ? /* @__PURE__ */ import_react213.default.createElement(popconfirm_default, Object.assign({
      onConfirm: function onConfirm() {
        return handleDelete(name);
      }
    }, delConfirmProps), /* @__PURE__ */ import_react213.default.createElement(import_CloseOutlined13.default, null)) : /* @__PURE__ */ import_react213.default.createElement(import_react213.default.Fragment, null);
  };
  return /* @__PURE__ */ import_react213.default.createElement(tabs_default, Object.assign({
    className: "fr-tab-list",
    type: "editable-card"
  }, retProps, {
    onChange: setActiveKey,
    activeKey: "".concat(activeKey),
    onEdit: handleEdit,
    hideAdd: readOnly || hideAdd
  }), fields.map(function(_ref) {
    var key2 = _ref.key, name = _ref.name;
    return /* @__PURE__ */ import_react213.default.createElement(tabs_default.TabPane, Object.assign({
      key: key2,
      className: "fr-list-item"
    }, tabItemProps, {
      tab: getTabPaneName(name),
      closeIcon: renderClose(name)
    }), /* @__PURE__ */ import_react213.default.createElement(TabPaneContent, {
      name,
      rootPath,
      schema,
      renderCore
    }));
  }));
};
var listTab_default = TabList;

// ../../node_modules/form-render/es/widgets/voidTitle/index.js
var import_react214 = __toESM(require_react());
var import_classnames214 = __toESM(require_classnames());
function _typeof14(o3) {
  "@babel/helpers - typeof";
  return _typeof14 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o4) {
    return typeof o4;
  } : function(o4) {
    return o4 && "function" == typeof Symbol && o4.constructor === Symbol && o4 !== Symbol.prototype ? "symbol" : typeof o4;
  }, _typeof14(o3);
}
function _defineProperty9(e3, r2, t2) {
  return (r2 = _toPropertyKey8(r2)) in e3 ? Object.defineProperty(e3, r2, { value: t2, enumerable: true, configurable: true, writable: true }) : e3[r2] = t2, e3;
}
function _toPropertyKey8(t2) {
  var i = _toPrimitive8(t2, "string");
  return "symbol" == _typeof14(i) ? i : i + "";
}
function _toPrimitive8(t2, r2) {
  if ("object" != _typeof14(t2) || !t2) return t2;
  var e3 = t2[Symbol.toPrimitive];
  if (void 0 !== e3) {
    var i = e3.call(t2, r2 || "default");
    if ("object" != _typeof14(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t2);
}
var voidTitle_default = (function(_ref) {
  var schema = _ref.schema;
  return /* @__PURE__ */ import_react214.default.createElement("div", {
    className: (0, import_classnames214.default)("fr-void-title", _defineProperty9({}, schema === null || schema === void 0 ? void 0 : schema.className, !!(schema === null || schema === void 0 ? void 0 : schema.className)))
  }, schema.title);
});

// ../../node_modules/form-render/es/widgets/ErrorSchema/index.js
var import_react215 = __toESM(require_react());
var ErrorSchema = function ErrorSchema2(schema) {
  var configCtx = (0, import_react215.useContext)(config_provider_default.ConfigContext);
  var t2 = translation3(configCtx);
  return /* @__PURE__ */ import_react215.default.createElement("div", null, /* @__PURE__ */ import_react215.default.createElement("div", {
    style: {
      color: "red"
    }
  }, t2("schema_not_match")), /* @__PURE__ */ import_react215.default.createElement("div", null, JSON.stringify(schema)));
};
var ErrorSchema_default = ErrorSchema;

// ../../node_modules/form-render/es/models/useForm.js
var import_react216 = __toESM(require_react());

// ../../node_modules/form-render/es/models/flattenSchema.js
function _slicedToArray14(r2, e3) {
  return _arrayWithHoles15(r2) || _iterableToArrayLimit14(r2, e3) || _unsupportedIterableToArray22(r2, e3) || _nonIterableRest15();
}
function _nonIterableRest15() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray22(r2, a) {
  if (r2) {
    if ("string" == typeof r2) return _arrayLikeToArray22(r2, a);
    var t2 = {}.toString.call(r2).slice(8, -1);
    return "Object" === t2 && r2.constructor && (t2 = r2.constructor.name), "Map" === t2 || "Set" === t2 ? Array.from(r2) : "Arguments" === t2 || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t2) ? _arrayLikeToArray22(r2, a) : void 0;
  }
}
function _arrayLikeToArray22(r2, a) {
  (null == a || a > r2.length) && (a = r2.length);
  for (var e3 = 0, n2 = Array(a); e3 < a; e3++) n2[e3] = r2[e3];
  return n2;
}
function _iterableToArrayLimit14(r2, l2) {
  var t2 = null == r2 ? null : "undefined" != typeof Symbol && r2[Symbol.iterator] || r2["@@iterator"];
  if (null != t2) {
    var e3, n2, i, u, a = [], f = true, o3 = false;
    try {
      if (i = (t2 = t2.call(r2)).next, 0 === l2) {
        if (Object(t2) !== t2) return;
        f = false;
      } else for (; !(f = (e3 = i.call(t2)).done) && (a.push(e3.value), a.length !== l2); f = true) ;
    } catch (r3) {
      o3 = true, n2 = r3;
    } finally {
      try {
        if (!f && null != t2.return && (u = t2.return(), Object(u) !== u)) return;
      } finally {
        if (o3) throw n2;
      }
    }
    return a;
  }
}
function _arrayWithHoles15(r2) {
  if (Array.isArray(r2)) return r2;
}
function flattenSchema() {
  var _schema = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  var name = arguments.length > 1 ? arguments[1] : void 0;
  var parent2 = arguments.length > 2 ? arguments[2] : void 0;
  var _result = arguments.length > 3 ? arguments[3] : void 0;
  var result = _result || {};
  var schema = _cloneDeep(_schema) || {};
  var _name = name || "#";
  if (!schema.$id) {
    schema.$id = _name;
  }
  var children = [];
  if (isObjType(schema)) {
    sortProperties_default(Object.entries(schema.properties)).forEach(function(_ref) {
      var _ref2 = _slicedToArray14(_ref, 2), key2 = _ref2[0], value = _ref2[1];
      var _key = isListType(value) ? key2 + "[]" : key2;
      var uniqueName = _name === "#" ? _key : _name + "." + _key;
      children.push(uniqueName);
      flattenSchema(value, uniqueName, _name, result);
    });
    schema.properties = {};
  }
  if (isListType(schema)) {
    sortProperties_default(Object.entries(schema.items.properties)).forEach(function(_ref3) {
      var _ref4 = _slicedToArray14(_ref3, 2), key2 = _ref4[0], value = _ref4[1];
      var _key = isListType(value) ? key2 + "[]" : key2;
      var uniqueName = _name === "#" ? _key : _name + "." + _key;
      children.push(uniqueName);
      flattenSchema(value, uniqueName, _name, result);
    });
    schema.items.properties = {};
  }
  if (schema.type) {
    result[_name] = {
      parent: parent2,
      schema,
      children
    };
  }
  return result;
}

// ../../node_modules/form-render/es/models/useForm.js
function _slicedToArray15(r2, e3) {
  return _arrayWithHoles16(r2) || _iterableToArrayLimit15(r2, e3) || _unsupportedIterableToArray23(r2, e3) || _nonIterableRest16();
}
function _nonIterableRest16() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray23(r2, a) {
  if (r2) {
    if ("string" == typeof r2) return _arrayLikeToArray23(r2, a);
    var t2 = {}.toString.call(r2).slice(8, -1);
    return "Object" === t2 && r2.constructor && (t2 = r2.constructor.name), "Map" === t2 || "Set" === t2 ? Array.from(r2) : "Arguments" === t2 || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t2) ? _arrayLikeToArray23(r2, a) : void 0;
  }
}
function _arrayLikeToArray23(r2, a) {
  (null == a || a > r2.length) && (a = r2.length);
  for (var e3 = 0, n2 = Array(a); e3 < a; e3++) n2[e3] = r2[e3];
  return n2;
}
function _iterableToArrayLimit15(r2, l2) {
  var t2 = null == r2 ? null : "undefined" != typeof Symbol && r2[Symbol.iterator] || r2["@@iterator"];
  if (null != t2) {
    var e3, n2, i, u, a = [], f = true, o3 = false;
    try {
      if (i = (t2 = t2.call(r2)).next, 0 === l2) {
        if (Object(t2) !== t2) return;
        f = false;
      } else for (; !(f = (e3 = i.call(t2)).done) && (a.push(e3.value), a.length !== l2); f = true) ;
    } catch (r3) {
      o3 = true, n2 = r3;
    } finally {
      try {
        if (!f && null != t2.return && (u = t2.return(), Object(u) !== u)) return;
      } finally {
        if (o3) throw n2;
      }
    }
    return a;
  }
}
function _arrayWithHoles16(r2) {
  if (Array.isArray(r2)) return r2;
}
var updateSchemaByPath = function updateSchemaByPath2(_path, _newSchema, formSchema) {
  var path2 = getSchemaFullPath(_path, formSchema);
  var currSchema = _get(formSchema, path2, {});
  var newSchema = isFunction2(_newSchema) ? _newSchema(currSchema) : _newSchema;
  var result = Object.assign(Object.assign({}, currSchema), newSchema);
  if (newSchema.props) {
    result.props = Object.assign(Object.assign({}, currSchema === null || currSchema === void 0 ? void 0 : currSchema.props), newSchema.props);
  }
  _set(formSchema, path2, result);
};
var getFieldName = function getFieldName2(_path) {
  if (!_path) {
    return void 0;
  }
  if (typeof _path === "boolean") {
    return _path;
  }
  var result = [];
  if (isArray3(_path)) {
    result = _path.map(function(item) {
      return item.split(".").map(function(ite) {
        if (!isNaN(Number(ite))) {
          return ite * 1;
        }
        return ite;
      });
    });
  }
  result = _path.split(".").map(function(item) {
    if (!isNaN(Number(item))) {
      return item * 1;
    }
    return item;
  });
  result = result.map(function(item) {
    if (typeof item === "string" && (item === null || item === void 0 ? void 0 : item.indexOf("[")) === 0 && (item === null || item === void 0 ? void 0 : item.indexOf("]")) === (item === null || item === void 0 ? void 0 : item.length) - 1) {
      return Number(item.substring(1, item.length - 1));
    }
    return item;
  });
  return result;
};
var useForm3 = function useForm4() {
  var _Form$useForm = form_default.useForm(), _Form$useForm2 = _slicedToArray15(_Form$useForm, 1), form = _Form$useForm2[0];
  var flattenSchemaRef = (0, import_react216.useRef)({});
  var storeRef = (0, import_react216.useRef)(null);
  var schemaRef = (0, import_react216.useRef)({});
  var fieldRefs = (0, import_react216.useRef)({});
  var getFieldError = form.getFieldError, getFieldsError = form.getFieldsError, getFieldInstance = form.getFieldInstance, setFieldsValue = form.setFieldsValue, setFields = form.setFields, scrollToField = form.scrollToField, isFieldsTouched = form.isFieldsTouched, isFieldTouched = form.isFieldTouched, isFieldValidating = form.isFieldValidating, resetFields = form.resetFields, validateFields = form.validateFields, otherForm = __rest(form, ["getFieldError", "getFieldsError", "getFieldInstance", "setFieldsValue", "setFields", "scrollToField", "isFieldsTouched", "isFieldTouched", "isFieldValidating", "resetFields", "validateFields"]);
  var xform = otherForm;
  var setStoreData = function setStoreData2(data2) {
    var setState = storeRef.current.setState;
    if (!setState) {
      setTimeout(function() {
        setState({
          schema: schemaRef.current,
          flattenSchema: flattenSchemaRef.current
        });
      }, 0);
    }
    setState(data2);
  };
  var handleSchemaUpdate = function handleSchemaUpdate2(newSchema) {
    flattenSchemaRef.current = flattenSchema(newSchema) || {};
    schemaRef.current = newSchema;
    setStoreData({
      schema: newSchema,
      flattenSchema: flattenSchemaRef.current
    });
  };
  xform.setSchema = function(obj) {
    var cover = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (!isObject3(obj)) {
      return;
    }
    if (cover) {
      handleSchemaUpdate(obj);
      return;
    }
    var schema = cloneDeep_default(schemaRef.current);
    Object.keys(obj || {}).forEach(function(path2) {
      updateSchemaByPath(path2, obj[path2], schema);
    });
    handleSchemaUpdate(schema);
  };
  xform.setSchemaByPath = function(_path, _newSchema) {
    if (!_hasFuncProperty(_newSchema) && _isMatch(_newSchema, xform.getSchemaByPath(_path))) {
      return;
    }
    var schema = cloneDeep_default(schemaRef.current);
    updateSchemaByPath(_path, _newSchema, schema);
    handleSchemaUpdate(schema);
  };
  xform.setValues = function(_values) {
    var values = parseBindToValues(_values, flattenSchemaRef.current);
    setFieldsValue(values);
  };
  xform.getValues = function(nameList, filterFunc, notFilterUndefined) {
    var notFilterHideData = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true;
    var _a;
    var values = cloneDeep_default(form.getFieldsValue(getFieldName(nameList), filterFunc));
    var _ref = ((_a = storeRef.current) === null || _a === void 0 ? void 0 : _a.getState()) || {}, removeHiddenData = _ref.removeHiddenData;
    if (notFilterHideData && removeHiddenData) {
      values = filterValuesHidden_default(values, flattenSchemaRef.current);
    }
    if (!notFilterUndefined) {
      values = filterValuesUndefined_default(values);
    }
    return parseValuesToBind(values, flattenSchemaRef.current);
  };
  xform.getValueByPath = function(path2) {
    var name = getFieldName(path2);
    return form.getFieldValue(name);
  };
  xform.setValueByPath = function(path2, value) {
    if (!form.setFieldValue) {
      var values = form.getFieldsValue();
      _set(values, path2, value);
      xform.setValues(values);
      return;
    }
    var name = getFieldName(path2);
    form.setFieldValue(name, value);
    try {
      if (JSON.stringify(form.getFieldValue(name)) !== JSON.stringify(value)) {
        form.setFieldValue(name, value);
      }
    } catch (error2) {
    }
  };
  xform.getSchemaByPath = function(_path) {
    if (typeof _path !== "string") {
      console.warn("\u8BF7\u8F93\u5165\u6B63\u786E\u7684\u8DEF\u5F84");
    }
    var path2 = getSchemaFullPath(_path, schemaRef.current);
    return _get(schemaRef.current, path2);
  };
  xform.getSchema = function() {
    return schemaRef.current;
  };
  xform.setErrorFields = function(fieldsError) {
    var fieldsData = transformFieldsData(fieldsError, getFieldName);
    if (!fieldsData) {
      return;
    }
    setFields(fieldsData);
  };
  xform.removeErrorField = function(path2) {
    setFields([{
      name: getFieldName(path2),
      errors: []
    }]);
  };
  xform.getFieldError = function(path2) {
    var name = getFieldName(path2);
    return form.getFieldError(name);
  };
  xform.getFieldsError = function(path2) {
    var name = getFieldName(path2);
    return getFieldsError(name);
  };
  xform.getFieldInstance = function(path2) {
    var name = getFieldName(path2);
    return getFieldInstance(name);
  };
  xform.getHiddenValues = function() {
    var values = xform.getValues();
    var allValues = xform.getValues(true);
    var hiddenValues = {};
    var _recursion = function recursion(obj1, obj2, path2) {
      Object.keys(obj1).forEach(function(key2) {
        var value = obj1[key2];
        var _path = path2 ? "".concat(path2, ".").concat(key2) : key2;
        if (!obj2.hasOwnProperty(key2)) {
          _set(hiddenValues, _path, value);
          return;
        }
        if (isObject3(value)) {
          _recursion(value, obj2[key2], _path);
        }
        if (isArray3(value)) {
          value.map(function(item, index3) {
            _recursion(item, _get(obj2, "".concat(key2, "[").concat(index3, "]"), []), "".concat(_path, "[").concat(index3, "]"));
          });
        }
      });
    };
    _recursion(allValues, values, null);
    return hiddenValues;
  };
  xform.setFields = function(nameList) {
    var fieldsData = transformFieldsData(nameList, getFieldName);
    if (!fieldsData) {
      return;
    }
    setFields(fieldsData);
  };
  xform.__initStore = function(store) {
    storeRef.current = store;
  };
  xform.scrollToPath = function(path2) {
    var name = getFieldName(path2);
    for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      rest[_key - 1] = arguments[_key];
    }
    scrollToField.apply(void 0, [name].concat(rest));
  };
  xform.isFieldsTouched = function(pathList, allTouched) {
    var nameList = (pathList || []).map(function(path2) {
      return getFieldName(path2);
    });
    return isFieldsTouched(nameList, allTouched);
  };
  xform.isFieldTouched = function(path2) {
    var name = getFieldName(path2);
    return isFieldTouched(name);
  };
  xform.isFieldValidating = function(path2) {
    var name = getFieldName(path2);
    return isFieldValidating(name);
  };
  xform.resetFields = function(pathList) {
    var nameList = (pathList || []).map(function(path2) {
      return getFieldName(path2);
    });
    if (nameList.length > 0) {
      resetFields(nameList);
    } else {
      resetFields();
    }
  };
  xform.validateFields = function(pathList, config) {
    var nameList = (pathList || []).map(function(path2) {
      return getFieldName(path2);
    });
    if (nameList.length > 0) {
      return validateFields(nameList, config);
    }
    return validateFields();
  };
  xform.getFlattenSchema = function(path2) {
    var _a;
    if (!path2) {
      return flattenSchemaRef.current;
    }
    return (_a = flattenSchemaRef.current) === null || _a === void 0 ? void 0 : _a[path2];
  };
  xform.onItemChange = xform.setValueByPath;
  xform.setFieldRef = function(path2, ref3) {
    if (!path2) {
      return;
    }
    fieldRefs.current[path2] = ref3;
  };
  xform.getFieldRef = function(path2) {
    return fieldRefs.current[path2];
  };
  return xform;
};
var useForm_default2 = useForm3;

// ../../node_modules/form-render/es/form-core/connectForm.js
var import_react217 = __toESM(require_react());

// ../../node_modules/form-render/es/derivative/SearchForm/index.js
var import_react219 = __toESM(require_react());
var import_classnames215 = __toESM(require_classnames());

// ../../node_modules/form-render/es/derivative/SearchForm/ActionView.js
var import_DownOutlined6 = __toESM(require_DownOutlined2());
var import_UpOutlined3 = __toESM(require_UpOutlined2());
var import_react218 = __toESM(require_react());
var ActionView = function ActionView2(props) {
  var onReset = props.onReset, searchBtnRender = props.searchBtnRender, style2 = props.style, className2 = props.className, form = props.form, searchText = props.searchText, resetText = props.resetText, hasCollapse = props.hasCollapse, setLimitHeight = props.setLimitHeight, setExpand = props.setExpand, isExpand = props.isExpand, loading = props.loading, retainBtn = props.retainBtn, mode = props.mode;
  var configCtx = (0, import_react218.useContext)(config_provider_default.ConfigContext);
  var t2 = translation(configCtx);
  var handleReset = function handleReset2() {
    if (onReset) {
      onReset(form);
      return;
    }
    form.resetFields();
    form.submit();
  };
  var handleCollapse = function handleCollapse2() {
    setExpand(!isExpand);
  };
  var searchBtnArr = typeof searchBtnRender === "function" ? searchBtnRender(form.submit, handleReset, {
    loading
  }) : [];
  if (searchBtnRender) {
    return /* @__PURE__ */ import_react218.default.createElement("div", {
      className: "flex justify-end w-100"
    }, Array.isArray(searchBtnArr) && searchBtnArr.map(function(ui, idx) {
      return /* @__PURE__ */ import_react218.default.createElement("div", {
        key: idx.toString(),
        style: {
          marginLeft: 8
        }
      }, ui);
    }));
  }
  var submitShow = mode === "simple" && (typeof retainBtn === "boolean" || (retainBtn === null || retainBtn === void 0 ? void 0 : retainBtn.includes("submit"))) || mode !== "simple";
  var resetShow = mode === "simple" && (typeof retainBtn === "boolean" || (retainBtn === null || retainBtn === void 0 ? void 0 : retainBtn.includes("reset"))) || mode !== "simple";
  return /* @__PURE__ */ import_react218.default.createElement("div", {
    className: "flex justify-end w-100 ".concat(className2 || ""),
    style: style2
  }, /* @__PURE__ */ import_react218.default.createElement(space_default, null, submitShow && /* @__PURE__ */ import_react218.default.createElement(button_default2, {
    loading,
    type: "primary",
    onClick: form.submit
  }, searchText), resetShow && /* @__PURE__ */ import_react218.default.createElement(button_default2, {
    onClick: handleReset
  }, resetText), hasCollapse && /* @__PURE__ */ import_react218.default.createElement("a", {
    onClick: handleCollapse,
    style: {
      cursor: "pointer"
    }
  }, isExpand ? /* @__PURE__ */ import_react218.default.createElement(import_react218.default.Fragment, null, t2("fold"), /* @__PURE__ */ import_react218.default.createElement(import_UpOutlined3.default, null)) : /* @__PURE__ */ import_react218.default.createElement(import_react218.default.Fragment, null, t2("expand"), /* @__PURE__ */ import_react218.default.createElement(import_DownOutlined6.default, null)))));
};
var ActionView_default = ActionView;

// ../../node_modules/form-render/es/derivative/SearchForm/index.js
function _typeof15(o3) {
  "@babel/helpers - typeof";
  return _typeof15 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o4) {
    return typeof o4;
  } : function(o4) {
    return o4 && "function" == typeof Symbol && o4.constructor === Symbol && o4 !== Symbol.prototype ? "symbol" : typeof o4;
  }, _typeof15(o3);
}
function _defineProperty10(e3, r2, t2) {
  return (r2 = _toPropertyKey9(r2)) in e3 ? Object.defineProperty(e3, r2, { value: t2, enumerable: true, configurable: true, writable: true }) : e3[r2] = t2, e3;
}
function _toPropertyKey9(t2) {
  var i = _toPrimitive9(t2, "string");
  return "symbol" == _typeof15(i) ? i : i + "";
}
function _toPrimitive9(t2, r2) {
  if ("object" != _typeof15(t2) || !t2) return t2;
  var e3 = t2[Symbol.toPrimitive];
  if (void 0 !== e3) {
    var i = e3.call(t2, r2 || "default");
    if ("object" != _typeof15(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t2);
}
function _regeneratorRuntime5() {
  "use strict";
  _regeneratorRuntime5 = function _regeneratorRuntime6() {
    return e3;
  };
  var t2, e3 = {}, r2 = Object.prototype, n2 = r2.hasOwnProperty, o3 = Object.defineProperty || function(t3, e4, r3) {
    t3[e4] = r3.value;
  }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
  function define2(t3, e4, r3) {
    return Object.defineProperty(t3, e4, { value: r3, enumerable: true, configurable: true, writable: true }), t3[e4];
  }
  try {
    define2({}, "");
  } catch (t3) {
    define2 = function define3(t4, e4, r3) {
      return t4[e4] = r3;
    };
  }
  function wrap(t3, e4, r3, n3) {
    var i2 = e4 && e4.prototype instanceof Generator ? e4 : Generator, a2 = Object.create(i2.prototype), c2 = new Context4(n3 || []);
    return o3(a2, "_invoke", { value: makeInvokeMethod(t3, r3, c2) }), a2;
  }
  function tryCatch(t3, e4, r3) {
    try {
      return { type: "normal", arg: t3.call(e4, r3) };
    } catch (t4) {
      return { type: "throw", arg: t4 };
    }
  }
  e3.wrap = wrap;
  var h2 = "suspendedStart", l2 = "suspendedYield", f = "executing", s = "completed", y = {};
  function Generator() {
  }
  function GeneratorFunction() {
  }
  function GeneratorFunctionPrototype() {
  }
  var p = {};
  define2(p, a, function() {
    return this;
  });
  var d = Object.getPrototypeOf, v = d && d(d(values([])));
  v && v !== r2 && n2.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t3) {
    ["next", "throw", "return"].forEach(function(e4) {
      define2(t3, e4, function(t4) {
        return this._invoke(e4, t4);
      });
    });
  }
  function AsyncIterator3(t3, e4) {
    function invoke(r4, o4, i2, a2) {
      var c2 = tryCatch(t3[r4], t3, o4);
      if ("throw" !== c2.type) {
        var u2 = c2.arg, h3 = u2.value;
        return h3 && "object" == _typeof15(h3) && n2.call(h3, "__await") ? e4.resolve(h3.__await).then(function(t4) {
          invoke("next", t4, i2, a2);
        }, function(t4) {
          invoke("throw", t4, i2, a2);
        }) : e4.resolve(h3).then(function(t4) {
          u2.value = t4, i2(u2);
        }, function(t4) {
          return invoke("throw", t4, i2, a2);
        });
      }
      a2(c2.arg);
    }
    var r3;
    o3(this, "_invoke", { value: function value(t4, n3) {
      function callInvokeWithMethodAndArg() {
        return new e4(function(e5, r4) {
          invoke(t4, n3, e5, r4);
        });
      }
      return r3 = r3 ? r3.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    } });
  }
  function makeInvokeMethod(e4, r3, n3) {
    var o4 = h2;
    return function(i2, a2) {
      if (o4 === f) throw Error("Generator is already running");
      if (o4 === s) {
        if ("throw" === i2) throw a2;
        return { value: t2, done: true };
      }
      for (n3.method = i2, n3.arg = a2; ; ) {
        var c2 = n3.delegate;
        if (c2) {
          var u2 = maybeInvokeDelegate(c2, n3);
          if (u2) {
            if (u2 === y) continue;
            return u2;
          }
        }
        if ("next" === n3.method) n3.sent = n3._sent = n3.arg;
        else if ("throw" === n3.method) {
          if (o4 === h2) throw o4 = s, n3.arg;
          n3.dispatchException(n3.arg);
        } else "return" === n3.method && n3.abrupt("return", n3.arg);
        o4 = f;
        var p2 = tryCatch(e4, r3, n3);
        if ("normal" === p2.type) {
          if (o4 = n3.done ? s : l2, p2.arg === y) continue;
          return { value: p2.arg, done: n3.done };
        }
        "throw" === p2.type && (o4 = s, n3.method = "throw", n3.arg = p2.arg);
      }
    };
  }
  function maybeInvokeDelegate(e4, r3) {
    var n3 = r3.method, o4 = e4.iterator[n3];
    if (o4 === t2) return r3.delegate = null, "throw" === n3 && e4.iterator.return && (r3.method = "return", r3.arg = t2, maybeInvokeDelegate(e4, r3), "throw" === r3.method) || "return" !== n3 && (r3.method = "throw", r3.arg = new TypeError("The iterator does not provide a '" + n3 + "' method")), y;
    var i2 = tryCatch(o4, e4.iterator, r3.arg);
    if ("throw" === i2.type) return r3.method = "throw", r3.arg = i2.arg, r3.delegate = null, y;
    var a2 = i2.arg;
    return a2 ? a2.done ? (r3[e4.resultName] = a2.value, r3.next = e4.nextLoc, "return" !== r3.method && (r3.method = "next", r3.arg = t2), r3.delegate = null, y) : a2 : (r3.method = "throw", r3.arg = new TypeError("iterator result is not an object"), r3.delegate = null, y);
  }
  function pushTryEntry(t3) {
    var e4 = { tryLoc: t3[0] };
    1 in t3 && (e4.catchLoc = t3[1]), 2 in t3 && (e4.finallyLoc = t3[2], e4.afterLoc = t3[3]), this.tryEntries.push(e4);
  }
  function resetTryEntry(t3) {
    var e4 = t3.completion || {};
    e4.type = "normal", delete e4.arg, t3.completion = e4;
  }
  function Context4(t3) {
    this.tryEntries = [{ tryLoc: "root" }], t3.forEach(pushTryEntry, this), this.reset(true);
  }
  function values(e4) {
    if (e4 || "" === e4) {
      var r3 = e4[a];
      if (r3) return r3.call(e4);
      if ("function" == typeof e4.next) return e4;
      if (!isNaN(e4.length)) {
        var o4 = -1, i2 = function next2() {
          for (; ++o4 < e4.length; ) if (n2.call(e4, o4)) return next2.value = e4[o4], next2.done = false, next2;
          return next2.value = t2, next2.done = true, next2;
        };
        return i2.next = i2;
      }
    }
    throw new TypeError(_typeof15(e4) + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o3(g, "constructor", { value: GeneratorFunctionPrototype, configurable: true }), o3(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: true }), GeneratorFunction.displayName = define2(GeneratorFunctionPrototype, u, "GeneratorFunction"), e3.isGeneratorFunction = function(t3) {
    var e4 = "function" == typeof t3 && t3.constructor;
    return !!e4 && (e4 === GeneratorFunction || "GeneratorFunction" === (e4.displayName || e4.name));
  }, e3.mark = function(t3) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t3, GeneratorFunctionPrototype) : (t3.__proto__ = GeneratorFunctionPrototype, define2(t3, u, "GeneratorFunction")), t3.prototype = Object.create(g), t3;
  }, e3.awrap = function(t3) {
    return { __await: t3 };
  }, defineIteratorMethods(AsyncIterator3.prototype), define2(AsyncIterator3.prototype, c, function() {
    return this;
  }), e3.AsyncIterator = AsyncIterator3, e3.async = function(t3, r3, n3, o4, i2) {
    void 0 === i2 && (i2 = Promise);
    var a2 = new AsyncIterator3(wrap(t3, r3, n3, o4), i2);
    return e3.isGeneratorFunction(r3) ? a2 : a2.next().then(function(t4) {
      return t4.done ? t4.value : a2.next();
    });
  }, defineIteratorMethods(g), define2(g, u, "Generator"), define2(g, a, function() {
    return this;
  }), define2(g, "toString", function() {
    return "[object Generator]";
  }), e3.keys = function(t3) {
    var e4 = Object(t3), r3 = [];
    for (var n3 in e4) r3.push(n3);
    return r3.reverse(), function next2() {
      for (; r3.length; ) {
        var t4 = r3.pop();
        if (t4 in e4) return next2.value = t4, next2.done = false, next2;
      }
      return next2.done = true, next2;
    };
  }, e3.values = values, Context4.prototype = { constructor: Context4, reset: function reset2(e4) {
    if (this.prev = 0, this.next = 0, this.sent = this._sent = t2, this.done = false, this.delegate = null, this.method = "next", this.arg = t2, this.tryEntries.forEach(resetTryEntry), !e4) for (var r3 in this) "t" === r3.charAt(0) && n2.call(this, r3) && !isNaN(+r3.slice(1)) && (this[r3] = t2);
  }, stop: function stop() {
    this.done = true;
    var t3 = this.tryEntries[0].completion;
    if ("throw" === t3.type) throw t3.arg;
    return this.rval;
  }, dispatchException: function dispatchException(e4) {
    if (this.done) throw e4;
    var r3 = this;
    function handle(n3, o5) {
      return a2.type = "throw", a2.arg = e4, r3.next = n3, o5 && (r3.method = "next", r3.arg = t2), !!o5;
    }
    for (var o4 = this.tryEntries.length - 1; o4 >= 0; --o4) {
      var i2 = this.tryEntries[o4], a2 = i2.completion;
      if ("root" === i2.tryLoc) return handle("end");
      if (i2.tryLoc <= this.prev) {
        var c2 = n2.call(i2, "catchLoc"), u2 = n2.call(i2, "finallyLoc");
        if (c2 && u2) {
          if (this.prev < i2.catchLoc) return handle(i2.catchLoc, true);
          if (this.prev < i2.finallyLoc) return handle(i2.finallyLoc);
        } else if (c2) {
          if (this.prev < i2.catchLoc) return handle(i2.catchLoc, true);
        } else {
          if (!u2) throw Error("try statement without catch or finally");
          if (this.prev < i2.finallyLoc) return handle(i2.finallyLoc);
        }
      }
    }
  }, abrupt: function abrupt(t3, e4) {
    for (var r3 = this.tryEntries.length - 1; r3 >= 0; --r3) {
      var o4 = this.tryEntries[r3];
      if (o4.tryLoc <= this.prev && n2.call(o4, "finallyLoc") && this.prev < o4.finallyLoc) {
        var i2 = o4;
        break;
      }
    }
    i2 && ("break" === t3 || "continue" === t3) && i2.tryLoc <= e4 && e4 <= i2.finallyLoc && (i2 = null);
    var a2 = i2 ? i2.completion : {};
    return a2.type = t3, a2.arg = e4, i2 ? (this.method = "next", this.next = i2.finallyLoc, y) : this.complete(a2);
  }, complete: function complete(t3, e4) {
    if ("throw" === t3.type) throw t3.arg;
    return "break" === t3.type || "continue" === t3.type ? this.next = t3.arg : "return" === t3.type ? (this.rval = this.arg = t3.arg, this.method = "return", this.next = "end") : "normal" === t3.type && e4 && (this.next = e4), y;
  }, finish: function finish(t3) {
    for (var e4 = this.tryEntries.length - 1; e4 >= 0; --e4) {
      var r3 = this.tryEntries[e4];
      if (r3.finallyLoc === t3) return this.complete(r3.completion, r3.afterLoc), resetTryEntry(r3), y;
    }
  }, catch: function _catch(t3) {
    for (var e4 = this.tryEntries.length - 1; e4 >= 0; --e4) {
      var r3 = this.tryEntries[e4];
      if (r3.tryLoc === t3) {
        var n3 = r3.completion;
        if ("throw" === n3.type) {
          var o4 = n3.arg;
          resetTryEntry(r3);
        }
        return o4;
      }
    }
    throw Error("illegal catch attempt");
  }, delegateYield: function delegateYield(e4, r3, n3) {
    return this.delegate = { iterator: values(e4), resultName: r3, nextLoc: n3 }, "next" === this.method && (this.arg = t2), y;
  } }, e3;
}
function _slicedToArray16(r2, e3) {
  return _arrayWithHoles17(r2) || _iterableToArrayLimit16(r2, e3) || _unsupportedIterableToArray24(r2, e3) || _nonIterableRest17();
}
function _nonIterableRest17() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray24(r2, a) {
  if (r2) {
    if ("string" == typeof r2) return _arrayLikeToArray24(r2, a);
    var t2 = {}.toString.call(r2).slice(8, -1);
    return "Object" === t2 && r2.constructor && (t2 = r2.constructor.name), "Map" === t2 || "Set" === t2 ? Array.from(r2) : "Arguments" === t2 || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t2) ? _arrayLikeToArray24(r2, a) : void 0;
  }
}
function _arrayLikeToArray24(r2, a) {
  (null == a || a > r2.length) && (a = r2.length);
  for (var e3 = 0, n2 = Array(a); e3 < a; e3++) n2[e3] = r2[e3];
  return n2;
}
function _iterableToArrayLimit16(r2, l2) {
  var t2 = null == r2 ? null : "undefined" != typeof Symbol && r2[Symbol.iterator] || r2["@@iterator"];
  if (null != t2) {
    var e3, n2, i, u, a = [], f = true, o3 = false;
    try {
      if (i = (t2 = t2.call(r2)).next, 0 === l2) {
        if (Object(t2) !== t2) return;
        f = false;
      } else for (; !(f = (e3 = i.call(t2)).done) && (a.push(e3.value), a.length !== l2); f = true) ;
    } catch (r3) {
      o3 = true, n2 = r3;
    } finally {
      try {
        if (!f && null != t2.return && (u = t2.return(), Object(u) !== u)) return;
      } finally {
        if (o3) throw n2;
      }
    }
    return a;
  }
}
function _arrayWithHoles17(r2) {
  if (Array.isArray(r2)) return r2;
}
var getIsColumn = function getIsColumn2(isColumn, obj, column2) {
  var count = 0;
  Object.keys(obj || {}).forEach(function(key2) {
    var item = obj[key2];
    if (item.visible === void 0) {
      count += 1;
    }
  });
  return isColumn && count % column2 !== 0;
};
var SearchForm = function SearchForm2(props) {
  if (props.hidden) {
    return null;
  }
  var configCtx = (0, import_react219.useContext)(config_provider_default.ConfigContext);
  var t2 = translation(configCtx);
  var className2 = props.className, style2 = props.style, mode = props.mode, _props$layoutAuto = props.layoutAuto, layoutAuto = _props$layoutAuto === void 0 ? false : _props$layoutAuto, form = props.form, hidden = props.hidden, loading = props.loading, _props$column = props.column, _column = _props$column === void 0 ? 4 : _props$column, collapsed = props.collapsed, _props$defaultCollaps = props.defaultCollapsed, defaultCollapsed = _props$defaultCollaps === void 0 ? true : _props$defaultCollaps, schema = props.schema, retainBtn = props.retainBtn, closeReturnSearch = props.closeReturnSearch, resetAfter = props.resetAfter, searchBtnStyle = props.searchBtnStyle, searchBtnClassName = props.searchBtnClassName, _props$searchText = props.searchText, searchText = _props$searchText === void 0 ? t2("search") : _props$searchText, _props$resetText = props.resetText, resetText = _props$resetText === void 0 ? t2("reset") : _props$resetText, _props$searchWithErro = props.searchWithError, searchWithError = _props$searchWithErro === void 0 ? true : _props$searchWithErro, _props$searchOnMount = props.searchOnMount, searchOnMount = _props$searchOnMount === void 0 ? true : _props$searchOnMount, onMount = props.onMount, onSearch = props.onSearch, onReset = props.onReset, searchBtnRender = props.searchBtnRender, restProps = __rest(props, ["className", "style", "mode", "layoutAuto", "form", "hidden", "loading", "column", "collapsed", "defaultCollapsed", "schema", "retainBtn", "closeReturnSearch", "resetAfter", "searchBtnStyle", "searchBtnClassName", "searchText", "resetText", "searchWithError", "searchOnMount", "onMount", "onSearch", "onReset", "searchBtnRender"]);
  var fieldNum = Object.keys((schema === null || schema === void 0 ? void 0 : schema.properties) || {}).length;
  var isColumn = (restProps.displayType || schema.displayType) === "column";
  var operateShow = mode !== "simple" || mode === "simple" && retainBtn;
  var containerRef = (0, import_react219.useRef)(null);
  var _useSetState = useSetState_default({
    hasCollapse: false,
    isExpand: !defaultCollapsed,
    column: schema.column || _column
    // 一行几列
  }), _useSetState2 = _slicedToArray16(_useSetState, 2), state = _useSetState2[0], setState = _useSetState2[1];
  var hasCollapse = state.hasCollapse, isExpand = state.isExpand, column2 = state.column;
  var actionProps = {
    style: searchBtnStyle,
    className: searchBtnClassName,
    searchText,
    resetText,
    loading,
    form,
    hasCollapse,
    isExpand,
    onReset,
    searchBtnRender
  };
  useMount_default(function() {
    initMount();
  });
  useUpdateEffect_default(function() {
    if (isExpand) {
      initMount();
    }
  }, [isExpand]);
  useMount_default(function() {
    if (!collapsed) {
      return;
    }
    if (!isColumn && fieldNum > column2 * 2 - 1 || isColumn && fieldNum > column2 - 1) {
      setState({
        hasCollapse: true
      });
    }
    handleContainerResize();
  });
  useUpdateEffect_default(function() {
    if (!collapsed) {
      return;
    }
    if (!isColumn && fieldNum > column2 * 2 - 1 || isColumn && fieldNum > column2 - 1) {
      setState({
        hasCollapse: true
      });
    } else {
      setState({
        hasCollapse: true
      });
    }
  }, [column2]);
  useUpdateEffect_default(function() {
    if (collapsed) {
      if (!isColumn && fieldNum > column2 * 2 - 1 || isColumn && fieldNum > column2 - 1) {
        setState({
          hasCollapse: true,
          isExpand: !defaultCollapsed
        });
      } else {
        setState({
          hasCollapse: false,
          isExpand: true
        });
      }
    } else {
      setState({
        hasCollapse: false,
        isExpand: true
      });
    }
  }, [collapsed]);
  var initMount = function initMount2() {
    return __awaiter(void 0, void 0, void 0, /* @__PURE__ */ _regeneratorRuntime5().mark(function _callee() {
      return _regeneratorRuntime5().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (searchOnMount) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            if (!(typeof onMount === "function")) {
              _context.next = 5;
              break;
            }
            _context.next = 5;
            return onMount();
          case 5:
            form.submit();
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
  };
  var properties2 = (0, import_react219.useMemo)(function() {
    if (!collapsed) {
      return schema === null || schema === void 0 ? void 0 : schema.properties;
    }
    var result = {};
    Object.keys((schema === null || schema === void 0 ? void 0 : schema.properties) || {}).forEach(function(key2, index3) {
      var item = Object.assign({}, schema.properties[key2] || {});
      if (!isExpand && isColumn && index3 >= column2 - 1 || !isExpand && !isColumn && index3 >= column2 * 2 - 1) {
        item.visible = false;
      }
      result[key2] = item;
    });
    return result;
  }, [JSON.stringify(schema), column2, isColumn, isExpand, collapsed]);
  var handleContainerResize = function handleContainerResize2() {
    if (!layoutAuto) {
      return;
    }
    var resizeObserver2 = new ResizeObserver(debounce_default(function() {
      var _ref = (containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) || {}, clientWidth = _ref.clientWidth;
      for (var i = _column; i > 0; i--) {
        var item = clientWidth / i;
        if (item >= ((layoutAuto === null || layoutAuto === void 0 ? void 0 : layoutAuto.fieldMinWidth) || 340)) {
          setState({
            column: i
          });
          break;
        }
        if (i === 1) {
          setState({
            column: 1
          });
        }
      }
    }, 300, {
      leading: true
    }));
    resizeObserver2.observe(containerRef.current);
    (function() {
      resizeObserver2.disconnect();
    });
  };
  var handleFinish = function handleFinish2(values) {
    onSearch === null || onSearch === void 0 ? void 0 : onSearch(values);
  };
  var handleFinishFailed = function handleFinishFailed2(_ref2) {
    var values = _ref2.values;
    if (!searchWithError) {
      return;
    }
    onSearch === null || onSearch === void 0 ? void 0 : onSearch(values);
  };
  var handleKeyDown = function handleKeyDown2(ev) {
    if (ev.keyCode !== 13) {
      return;
    }
    form.submit();
  };
  return /* @__PURE__ */ import_react219.default.createElement("div", {
    className: (0, import_classnames215.default)("fr-search", _defineProperty10(_defineProperty10({}, className2, !!className2), "fr-column-search", isColumn)),
    style: style2,
    ref: containerRef,
    onKeyDown: !closeReturnSearch ? handleKeyDown : void 0
  }, /* @__PURE__ */ import_react219.default.createElement(form_core_default, Object.assign({
    displayType: "row"
  }, restProps, {
    schema: Object.assign(Object.assign({}, schema), {
      properties: properties2,
      column: column2
    }),
    onFinish: handleFinish,
    onFinishFailed: handleFinishFailed,
    form,
    operateExtra: operateShow && /* @__PURE__ */ import_react219.default.createElement(col_default2, {
      className: (0, import_classnames215.default)("search-action-col", {
        "search-action-column": getIsColumn(isColumn, properties2, column2)
      }),
      style: {
        minWidth: 1 / column2 * 100 + "%"
      }
    }, /* @__PURE__ */ import_react219.default.createElement(ActionView_default, Object.assign({}, actionProps, {
      retainBtn,
      mode,
      setExpand: function setExpand(value) {
        return setState({
          isExpand: value
        });
      }
    })))
  })));
};
var SearchForm_default = withProvider(SearchForm, {
  Input: input_default2,
  InputNumber: number_default2,
  TextArea: textArea_default,
  Select: select_default2,
  MultiSelect: select_default2,
  Switch: switch_default2,
  Radio: radio_default3,
  Checkbox: checkbox_default2,
  Checkboxes: checkboxes_default,
  DatePicker: date_default2,
  DateRange: dateRange_default,
  TimePicker: time_default,
  TimeRange: timeRange_default,
  TreeSelect: treeSelect_default,
  ImageInput: imageInput_default,
  UrlInput: urlInput_default,
  Slider: slider_default2,
  Html: html,
  PercentSlider: percentSlider_default
});

// ../../node_modules/form-render/es/derivative/SlimRender/index.js
var SlimRender_default = withProvider(form_core_default, {
  Html: html
});

// ../../node_modules/form-render/es/index.js
var es_default30 = withProvider(form_core_default, widgets_exports);

// src/components/Designer/RightSidebar/DetailView/index.tsx
var import_react225 = __toESM(require_react());

// src/components/Designer/RightSidebar/DetailView/AlignWidget.tsx
var import_react220 = __toESM(require_react());
var AlignWidget = (props) => {
  const { activeElements, changeSchemas: changeSchemas2, schemas, pageSize, schema } = props;
  const align = (type5) => {
    const ids2 = activeElements.map((ae) => ae.id);
    const ass = schemas.filter((s) => ids2.includes(s.id));
    const isVertical = ["left", "center", "right"].includes(type5);
    const tgtPos = isVertical ? "x" : "y";
    const tgtSize = isVertical ? "width" : "height";
    const isSingle = ass.length === 1;
    const root2 = pageSize && typeof pageSize === "object" ? tgtSize === "width" ? pageSize.width : pageSize.height : 0;
    const min = isSingle ? 0 : Math.min(
      ...ass.map((as) => {
        const position3 = as.position && typeof as.position === "object" ? as.position : { x: 0, y: 0 };
        return tgtPos === "x" ? position3.x : position3.y;
      })
    );
    const max = isSingle ? root2 : Math.max(
      ...ass.map((as) => {
        const position3 = as.position && typeof as.position === "object" ? as.position : { x: 0, y: 0 };
        const posValue = tgtPos === "x" ? position3.x : position3.y;
        const asWithSize = as;
        const sizeValue = tgtSize === "width" ? asWithSize.width || 0 : asWithSize.height || 0;
        return posValue + sizeValue;
      })
    );
    let basePos = min;
    let adjust = (_size) => 0;
    if (["center", "middle"].includes(type5)) {
      basePos = (min + max) / 2;
      adjust = (size) => size / 2;
    } else if (["right", "bottom"].includes(type5)) {
      basePos = max;
      adjust = (size) => size;
    }
    changeSchemas2(
      ass.map((as) => {
        const asWithSize = as;
        const sizeValue = tgtSize === "width" ? asWithSize.width || 0 : asWithSize.height || 0;
        return {
          key: `position.${tgtPos}`,
          value: round(basePos - adjust(sizeValue), 2),
          schemaId: asWithSize.id
        };
      })
    );
  };
  const distribute = (type5) => {
    const ids2 = activeElements.map((ae) => ae.id);
    const ass = schemas.filter((s) => ids2.includes(s.id));
    const isVertical = type5 === "vertical";
    const tgtPos = isVertical ? "y" : "x";
    const tgtSize = isVertical ? "height" : "width";
    const min = Math.min(
      ...ass.map((as) => {
        const position3 = as.position && typeof as.position === "object" ? as.position : { x: 0, y: 0 };
        return tgtPos === "x" ? position3.x : position3.y;
      })
    );
    const max = Math.max(
      ...ass.map((as) => {
        const position3 = as.position && typeof as.position === "object" ? as.position : { x: 0, y: 0 };
        const posValue = tgtPos === "x" ? position3.x : position3.y;
        const asWithSize = as;
        const sizeValue = tgtSize === "width" ? asWithSize.width || 0 : asWithSize.height || 0;
        return posValue + sizeValue;
      })
    );
    if (ass.length < 3) return;
    const boxPos = min;
    const boxSize = max - min;
    const sum2 = ass.reduce((acc, cur) => {
      const curWithSize = cur;
      const sizeValue = tgtSize === "width" ? curWithSize.width || 0 : curWithSize.height || 0;
      return acc + sizeValue;
    }, 0);
    const remain = boxSize - sum2;
    const unit3 = remain / (ass.length - 1);
    let prev2 = 0;
    changeSchemas2(
      ass.map((as, index3) => {
        const prevSize = index3 === 0 ? 0 : (() => {
          const prevAs = ass[index3 - 1];
          return tgtSize === "width" ? prevAs.width || 0 : prevAs.height || 0;
        })();
        prev2 += index3 === 0 ? 0 : prevSize + unit3;
        const value = round(boxPos + prev2, 2);
        const asWithId = as;
        return { key: `position.${tgtPos}`, value, schemaId: asWithId.id };
      })
    );
  };
  const layoutBtns = [
    {
      id: "left",
      icon: /* @__PURE__ */ import_react220.default.createElement(AlignStartVertical, { size: 15 }),
      onClick: () => align("left")
    },
    {
      id: "center",
      icon: /* @__PURE__ */ import_react220.default.createElement(AlignCenterVertical, { size: 15 }),
      onClick: () => align("center")
    },
    {
      id: "right",
      icon: /* @__PURE__ */ import_react220.default.createElement(AlignEndVertical, { size: 15 }),
      onClick: () => align("right")
    },
    {
      id: "top",
      icon: /* @__PURE__ */ import_react220.default.createElement(AlignStartHorizontal, { size: 15 }),
      onClick: () => align("top")
    },
    {
      id: "middle",
      icon: /* @__PURE__ */ import_react220.default.createElement(AlignCenterHorizontal, { size: 15 }),
      onClick: () => align("middle")
    },
    {
      id: "bottom",
      icon: /* @__PURE__ */ import_react220.default.createElement(AlignEndHorizontal, { size: 15 }),
      onClick: () => align("bottom")
    },
    {
      id: "vertical",
      icon: /* @__PURE__ */ import_react220.default.createElement(AlignVerticalSpaceAround, { size: 15 }),
      onClick: () => distribute("vertical")
    },
    {
      id: "horizontal",
      icon: /* @__PURE__ */ import_react220.default.createElement(AlignHorizontalSpaceAround, { size: 15 }),
      onClick: () => distribute("horizontal")
    }
  ];
  return /* @__PURE__ */ import_react220.default.createElement(form_default.Item, { label: schema.title }, /* @__PURE__ */ import_react220.default.createElement(space_default.Compact, null, layoutBtns.map((btn) => /* @__PURE__ */ import_react220.default.createElement(
    button_default2,
    {
      key: btn.id,
      style: { padding: 7 },
      disabled: activeElements.length <= 2 && ["vertical", "horizontal"].includes(btn.id),
      ...btn
    }
  ))));
};
var AlignWidget_default = AlignWidget;

// src/components/Designer/RightSidebar/DetailView/WidgetRenderer.tsx
var import_react221 = __toESM(require_react());
var WidgetRenderer = (props) => {
  const { widget, ...otherProps } = props;
  const ref3 = (0, import_react221.useRef)(null);
  (0, import_react221.useEffect)(() => {
    if (ref3.current) {
      ref3.current.innerHTML = "";
      widget({ ...otherProps, rootElement: ref3.current });
    }
    return () => {
      if (ref3.current) {
        ref3.current.innerHTML = "";
      }
    };
  }, [props.activeSchema]);
  return /* @__PURE__ */ import_react221.default.createElement("div", { ref: ref3 });
};
var WidgetRenderer_default = WidgetRenderer;

// src/components/Designer/RightSidebar/DetailView/ButtonGroupWidget.tsx
var import_react222 = __toESM(require_react());
var ButtonGroupWidget = (props) => {
  const { activeElements, changeSchemas: changeSchemas2, schemas, schema } = props;
  const { token: token2 } = theme_default3.useToken();
  const apply = (btn) => {
    const key2 = btn.key;
    const type5 = btn.type;
    const ids2 = activeElements.map((ae) => ae.id);
    const ass = schemas.filter((s) => ids2.includes(s.id));
    changeSchemas2(
      ass.map((s) => {
        const oldValue = Boolean(s[key2] ?? false);
        const newValue = type5 === "boolean" ? !oldValue : btn.value;
        return { key: key2, value: newValue, schemaId: s.id };
      })
    );
  };
  const isActive2 = (btn) => {
    const key2 = btn.key;
    const type5 = btn.type;
    let active = false;
    const ids2 = activeElements.map((ae) => ae.id);
    const ass = schemas.filter((s) => ids2.includes(s.id));
    ass.forEach((s) => {
      const schemaRecord = s;
      active = type5 === "boolean" ? Boolean(schemaRecord[key2] ?? false) : schemaRecord[key2] === btn.value;
    });
    return active;
  };
  const replaceCurrentColor = (svgString, color) => color ? svgString.replace(/="currentColor"/g, `="${color}"`) : svgString;
  const svgIcon = (svgString) => {
    const svgDataUrl = `data:image/svg+xml;utf8,${encodeURIComponent(
      replaceCurrentColor(svgString, token2.colorText)
    )}`;
    return /* @__PURE__ */ import_react222.default.createElement("img", { width: 17, height: 17, src: svgDataUrl, alt: "" });
  };
  return /* @__PURE__ */ import_react222.default.createElement(form_default.Item, null, /* @__PURE__ */ import_react222.default.createElement(space_default.Compact, null, schema.buttons.map((btn, index3) => {
    const active = isActive2(btn);
    return /* @__PURE__ */ import_react222.default.createElement(
      button_default2,
      {
        type: active ? "primary" : void 0,
        ghost: active,
        onClick: () => apply(btn),
        style: {
          padding: 7,
          zIndex: active ? 2 : 0
        },
        key: index3,
        icon: svgIcon(btn.icon)
      }
    );
  })));
};
var ButtonGroupWidget_default = ButtonGroupWidget;

// ../../node_modules/@ant-design/icons/es/icons/CheckCircleOutlined.js
var React588 = __toESM(require_react());

// ../../node_modules/@ant-design/icons-svg/es/asn/CheckCircleOutlined.js
var CheckCircleOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M699 353h-46.9c-10.2 0-19.9 4.9-25.9 13.3L469 584.3l-71.2-98.8c-6-8.3-15.6-13.3-25.9-13.3H325c-6.5 0-10.3 7.4-6.5 12.7l124.6 172.8a31.8 31.8 0 0051.7 0l210.6-292c3.9-5.3.1-12.7-6.4-12.7z" } }, { "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }] }, "name": "check-circle", "theme": "outlined" };
var CheckCircleOutlined_default = CheckCircleOutlined;

// ../../node_modules/@ant-design/icons/es/icons/CheckCircleOutlined.js
var CheckCircleOutlined2 = function CheckCircleOutlined3(props, ref3) {
  return /* @__PURE__ */ React588.createElement(AntdIcon_default, _extends({}, props, {
    ref: ref3,
    icon: CheckCircleOutlined_default
  }));
};
var RefIcon49 = /* @__PURE__ */ React588.forwardRef(CheckCircleOutlined2);
if (true) {
  RefIcon49.displayName = "CheckCircleOutlined";
}
var CheckCircleOutlined_default2 = RefIcon49;

// src/components/Designer/RightSidebar/DetailView/ButtonCounterWidget.tsx
var import_react223 = __toESM(require_react());
var ButtonCounterWidget = (props) => {
  const { changeSchemas: changeSchemas2, activeSchema } = props;
  const [items, setItems] = (0, import_react223.useState)(activeSchema?.appRender?.buttons || []);
  const [inputValue, setInputValue] = (0, import_react223.useState)("");
  const updateSchemas = (0, import_react223.useCallback)((newItems) => {
    changeSchemas2([{ key: "appRender.buttons", value: newItems, schemaId: activeSchema.id }]);
  }, [changeSchemas2, activeSchema.id]);
  const addItem = (0, import_react223.useCallback)(() => {
    if (items.length >= 6) {
      return;
    }
    if (inputValue.trim() !== "") {
      const newItems = [...items, { id: items.length + 1, label: inputValue, checked: false }];
      setItems(newItems);
      setInputValue("");
      updateSchemas(newItems);
    }
  }, [inputValue, items, updateSchemas]);
  const deleteItem = (0, import_react223.useCallback)((id) => {
    const newItems = items.filter((item) => item.id !== id).map((item, index3) => ({ ...item, id: index3 + 1 }));
    setItems(newItems);
    updateSchemas(newItems);
  }, [items, updateSchemas]);
  const moveItem = (0, import_react223.useCallback)((index3, direction) => {
    const newIndex = index3 + direction;
    if (newIndex < 0 || newIndex >= items.length) return;
    const newItems = [...items];
    const [movedItem] = newItems.splice(index3, 1);
    newItems.splice(newIndex, 0, movedItem);
    const updatedItems = newItems.map((item, idx) => ({ ...item, id: idx + 1 }));
    setItems(updatedItems);
    updateSchemas(updatedItems);
  }, [items, updateSchemas]);
  const renderItem3 = (0, import_react223.useCallback)((item, index3) => /* @__PURE__ */ import_react223.default.createElement(
    list_default.Item,
    {
      key: item.id,
      actions: [
        /* @__PURE__ */ import_react223.default.createElement(button_default2, { key: `up-${item.id}`, onClick: () => moveItem(index3, -1), disabled: index3 === 0 }, /* @__PURE__ */ import_react223.default.createElement(UpOutlined_default2, null)),
        /* @__PURE__ */ import_react223.default.createElement(button_default2, { key: `down-${item.id}`, onClick: () => moveItem(index3, 1), disabled: index3 === items.length - 1 }, /* @__PURE__ */ import_react223.default.createElement(DownOutlined_default2, null)),
        /* @__PURE__ */ import_react223.default.createElement(button_default2, { key: `delete-${item.id}`, onClick: () => deleteItem(item.id) }, /* @__PURE__ */ import_react223.default.createElement(DeleteOutlined_default2, null))
      ]
    },
    /* @__PURE__ */ import_react223.default.createElement(typography_default, null, `${item.id}. ${item.label}`)
  ), [deleteItem, moveItem, items.length]);
  const renderedItems = (0, import_react223.useMemo)(() => items.map((item, index3) => renderItem3(item, index3)), [items, renderItem3]);
  return /* @__PURE__ */ import_react223.default.createElement(form_default.Item, null, /* @__PURE__ */ import_react223.default.createElement(
    input_default,
    {
      value: inputValue,
      onChange: (e3) => setInputValue(e3.target.value)
    }
  ), /* @__PURE__ */ import_react223.default.createElement(button_default2, { onClick: addItem, style: { marginTop: 10 } }, "+"), /* @__PURE__ */ import_react223.default.createElement(list_default, { style: { marginTop: 20 } }, /* @__PURE__ */ import_react223.default.createElement(typography_default, { style: { marginBottom: 10, textAlign: "end" } }, items.length, "/6"), renderedItems));
};
var ButtonCounterWidget_default = ButtonCounterWidget;

// src/components/Designer/RightSidebar/DetailView/OptionCounterWidget.tsx
var import_react224 = __toESM(require_react());
var OptionCounterWidget = (props) => {
  const { changeSchemas: changeSchemas2, activeSchema } = props;
  const [items, setItems] = (0, import_react224.useState)(activeSchema.appRender.options || []);
  const [inputValue, setInputValue] = (0, import_react224.useState)("");
  const updateSchemas = (newItems) => {
    changeSchemas2([{ key: "appRender.options", value: newItems, schemaId: activeSchema.id }]);
  };
  const addItem = () => {
    if (inputValue.trim() !== "") {
      const newItems = [...items, { id: items.length + 1, label: inputValue, selected: false }];
      setItems(newItems);
      setInputValue("");
      updateSchemas(newItems);
    }
  };
  const deleteItem = (id) => {
    const newItems = items.filter((item) => item.id !== id).map((item, index3) => ({ ...item, id: index3 + 1 }));
    setItems(newItems);
    updateSchemas(newItems);
  };
  const selectItem = (id) => {
    const newItems = items.map((item) => ({ ...item, selected: item.id === id }));
    setItems(newItems);
    updateSchemas(newItems);
  };
  const renderItem3 = (item, index3) => /* @__PURE__ */ import_react224.default.createElement(
    list_default.Item,
    {
      key: item.id,
      actions: [
        /* @__PURE__ */ import_react224.default.createElement(button_default2, { key: `delete-${item.id}`, onClick: () => deleteItem(item.id) }, /* @__PURE__ */ import_react224.default.createElement(DeleteOutlined_default2, null)),
        /* @__PURE__ */ import_react224.default.createElement(button_default2, { key: `select-${item.id}`, onClick: () => selectItem(item.id) }, item.selected ? /* @__PURE__ */ import_react224.default.createElement(CheckCircleOutlined_default2, { style: { color: "green" } }) : /* @__PURE__ */ import_react224.default.createElement(CheckCircleOutlined_default2, null))
      ]
    },
    /* @__PURE__ */ import_react224.default.createElement(typography_default, null, `${item.id}. ${item.label}`)
  );
  return /* @__PURE__ */ import_react224.default.createElement(form_default.Item, null, /* @__PURE__ */ import_react224.default.createElement(
    input_default,
    {
      value: inputValue,
      onChange: (e3) => setInputValue(e3.target.value)
    }
  ), /* @__PURE__ */ import_react224.default.createElement(button_default2, { onClick: addItem, style: { marginTop: 10 } }, "+"), /* @__PURE__ */ import_react224.default.createElement(list_default, { style: { marginTop: 20 } }, items.map((item, index3) => renderItem3(item, index3))));
};
var OptionCounterWidget_default = OptionCounterWidget;

// src/components/Designer/RightSidebar/DetailView/index.tsx
var { Text: Text4 } = typography_default;
var DetailView = (props) => {
  const { token: token2 } = theme_default3.useToken();
  const { size, schemasList, changeSchemas: changeSchemas2, deselectSchema, activeSchema } = props;
  const form = useForm_default2();
  const i18n2 = (0, import_react225.useContext)(I18nContext);
  const pluginsRegistry = (0, import_react225.useContext)(PluginsRegistry);
  const options = (0, import_react225.useContext)(OptionsContext);
  const typedI18n = (key2) => {
    return typeof i18n2 === "function" ? i18n2(key2) : key2;
  };
  const [widgets, setWidgets] = (0, import_react225.useState)({});
  (0, import_react225.useEffect)(() => {
    const newWidgets = {
      AlignWidget: (p) => /* @__PURE__ */ import_react225.default.createElement(AlignWidget_default, { ...p, ...props, options }),
      ButtonCounterWidget: (p) => /* @__PURE__ */ import_react225.default.createElement(ButtonCounterWidget_default, { ...p, ...props, options }),
      OptionCounterWidget: (p) => /* @__PURE__ */ import_react225.default.createElement(OptionCounterWidget_default, { ...p, ...props, options }),
      Divider: () => /* @__PURE__ */ import_react225.default.createElement(divider_default, { style: { marginTop: token2.marginXS, marginBottom: token2.marginXS } }),
      ButtonGroup: (p) => /* @__PURE__ */ import_react225.default.createElement(ButtonGroupWidget_default, { ...p, ...props, options })
    };
    for (const plugin of Object.values(pluginsRegistry)) {
      const widgets2 = plugin?.propPanel.widgets || {};
      Object.entries(widgets2).forEach(([widgetKey, widgetValue]) => {
        newWidgets[widgetKey] = (p) => /* @__PURE__ */ import_react225.default.createElement(
          WidgetRenderer_default,
          {
            ...p,
            ...props,
            options,
            theme: token2,
            i18n: typedI18n,
            widget: widgetValue
          }
        );
      });
    }
    setWidgets(newWidgets);
  }, [activeSchema, pluginsRegistry, JSON.stringify(options)]);
  (0, import_react225.useEffect)(() => {
    const values = { ...activeSchema };
    const readOnly = typeof values.readOnly === "boolean" ? values.readOnly : false;
    values.editable = !readOnly;
    form.setValues(values);
  }, [activeSchema, form]);
  (0, import_react225.useEffect)(() => form.resetFields(), [activeSchema.id]);
  (0, import_react225.useEffect)(() => {
    uniqueSchemaName.current = (value) => {
      for (const page of schemasList) {
        for (const s of Object.values(page)) {
          if (s.name === value && s.id !== activeSchema.id) {
            return false;
          }
        }
      }
      return true;
    };
  }, [schemasList, activeSchema]);
  const uniqueSchemaName = (0, import_react225.useRef)(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    (_unused) => true
  );
  const validateUniqueSchemaName = (_, value) => uniqueSchemaName.current(value);
  const handleWatch = debounce(function(...args) {
    const formSchema = args[0];
    const formAndSchemaValuesDiffer = (formValue, schemaValue) => {
      if (typeof formValue === "object" && formValue !== null) {
        return JSON.stringify(formValue) !== JSON.stringify(schemaValue);
      }
      return formValue !== schemaValue;
    };
    let changes = [];
    for (const key2 in formSchema) {
      if (["id", "content"].includes(key2)) continue;
      let value = formSchema[key2];
      if (formAndSchemaValuesDiffer(value, activeSchema[key2])) {
        if (value === null && ["rotate", "opacity"].includes(key2)) {
          value = void 0;
        }
        if (key2 === "editable") {
          const readOnlyValue = !value;
          changes.push({ key: "readOnly", value: readOnlyValue, schemaId: activeSchema.id });
          if (readOnlyValue) {
            changes.push({ key: "required", value: false, schemaId: activeSchema.id });
          }
          continue;
        }
        changes.push({ key: key2, value, schemaId: activeSchema.id });
      }
    }
    if (changes.length) {
      form.validateFields().then(() => changeSchemas2(changes)).catch((reason) => {
        if (reason.errorFields.length) {
          changes = changes.filter(
            (change) => !reason.errorFields.find(
              (field) => field.name.includes(change.key)
            )
          );
        }
        if (changes.length) {
          changeSchemas2(changes);
        }
      });
    }
  }, 100);
  const activePlugin = Object.values(pluginsRegistry).find((plugin) => {
    if (!plugin || typeof plugin !== "object") return false;
    if (!plugin.propPanel || typeof plugin.propPanel !== "object") return false;
    if (!plugin.propPanel.defaultSchema || typeof plugin.propPanel.defaultSchema !== "object")
      return false;
    const defaultSchema2 = plugin.propPanel.defaultSchema;
    return "type" in defaultSchema2 && typeof defaultSchema2.type === "string" && defaultSchema2.type === activeSchema.type;
  });
  const activePropPanelSchema = activePlugin?.propPanel?.schema;
  if (!activePropPanelSchema) {
    console.error(`[@pdfme/ui] No propPanel.schema for ${activeSchema.type}.
Check this document: https://pdfme.com/docs/custom-schemas`);
  }
  const typeOptions = [];
  Object.entries(pluginsRegistry).forEach(([label, value]) => {
    if (!value || typeof value !== "object") {
      typeOptions.push({ label, value: void 0 });
      return;
    }
    if (!("propPanel" in value) || !value.propPanel || typeof value.propPanel !== "object") {
      typeOptions.push({ label, value: void 0 });
      return;
    }
    if (!("defaultSchema" in value.propPanel) || !value.propPanel.defaultSchema || typeof value.propPanel.defaultSchema !== "object") {
      typeOptions.push({ label, value: void 0 });
      return;
    }
    const defaultSchema2 = value.propPanel.defaultSchema;
    let schemaType = void 0;
    if ("type" in defaultSchema2 && typeof defaultSchema2.type === "string") {
      schemaType = defaultSchema2.type;
    }
    typeOptions.push({ label, value: schemaType });
  });
  const emptySchema = {};
  const defaultSchema = activePlugin?.propPanel?.defaultSchema ? (
    // Create a safe copy of the schema
    (() => {
      if (typeof activePlugin.propPanel.defaultSchema !== "object" || activePlugin.propPanel.defaultSchema === null) {
        return emptySchema;
      }
      const result = {};
      for (const key2 in activePlugin.propPanel.defaultSchema) {
        if (Object.prototype.hasOwnProperty.call(activePlugin.propPanel.defaultSchema, key2)) {
          result[key2] = activePlugin.propPanel.defaultSchema[key2];
        }
      }
      return result;
    })()
  ) : emptySchema;
  const propPanelSchema = {
    type: "object",
    column: 2,
    properties: {
      type: {
        title: typedI18n("type"),
        type: "string",
        widget: "select",
        props: { options: typeOptions },
        required: true,
        span: 12
      },
      name: {
        title: typedI18n("fieldName"),
        type: "string",
        required: true,
        span: 12,
        rules: [
          {
            validator: validateUniqueSchemaName,
            message: typedI18n("validation.uniqueName")
          }
        ],
        props: { autoComplete: "off" }
      },
      // editable: {
      //   title: typedI18n('editable'),
      //   type: 'boolean',
      //   span: 8,
      //   hidden: typeof defaultSchema.readOnly !== 'undefined',
      // },
      // required: {
      //   title: typedI18n('required'),
      //   type: 'boolean',
      //   span: 16,
      //   hidden: '{{!formData.editable}}',
      // },
      "-": { type: "void", widget: "Divider" },
      align: { title: typedI18n("align"), type: "void", widget: "AlignWidget" },
      position: {
        type: "object",
        widget: "card",
        properties: {
          x: { title: "X", type: "number", widget: "inputNumber", required: true, span: 8, min: 0 },
          y: { title: "Y", type: "number", widget: "inputNumber", required: true, span: 8, min: 0 }
        }
      },
      width: {
        title: typedI18n("width"),
        type: "number",
        widget: "inputNumber",
        required: true,
        span: 6,
        props: { min: 0 }
      },
      height: {
        title: typedI18n("height"),
        type: "number",
        widget: "inputNumber",
        required: true,
        span: 6,
        props: { min: 0 }
      },
      rotate: {
        title: typedI18n("rotate"),
        type: "number",
        widget: "inputNumber",
        disabled: typeof defaultSchema.rotate === "undefined",
        max: 360,
        props: { min: 0 },
        span: 6
      },
      opacity: {
        title: typedI18n("opacity"),
        type: "number",
        widget: "inputNumber",
        disabled: typeof defaultSchema.opacity === "undefined",
        props: { step: 0.1, min: 0, max: 1 },
        span: 6
      }
    }
  };
  const safeProperties = { ...propPanelSchema.properties };
  if (typeof activePropPanelSchema === "function") {
    const { size: size2, schemas, pageSize, changeSchemas: changeSchemas3, activeElements, deselectSchema: deselectSchema2, activeSchema: activeSchema2 } = props;
    const propPanelProps = {
      size: size2,
      schemas,
      pageSize,
      changeSchemas: changeSchemas3,
      activeElements,
      deselectSchema: deselectSchema2,
      activeSchema: activeSchema2
    };
    const functionResult = activePropPanelSchema({
      ...propPanelProps,
      options,
      theme: token2,
      i18n: typedI18n
    });
    const apps = functionResult && typeof functionResult === "object" ? functionResult : {};
    const dividerObj = Object.keys(apps).length === 0 ? {} : { "--": { type: "void", widget: "Divider" } };
    propPanelSchema.properties = {
      ...safeProperties,
      ...dividerObj,
      ...apps
    };
  } else {
    const apps = activePropPanelSchema && typeof activePropPanelSchema === "object" ? activePropPanelSchema : {};
    const dividerObj = Object.keys(apps).length === 0 ? {} : { "--": { type: "void", widget: "Divider" } };
    propPanelSchema.properties = {
      ...safeProperties,
      ...dividerObj,
      ...apps
    };
  }
  return /* @__PURE__ */ import_react225.default.createElement("div", null, /* @__PURE__ */ import_react225.default.createElement("div", { style: { height: 40, display: "flex", alignItems: "center" } }, /* @__PURE__ */ import_react225.default.createElement(
    button_default2,
    {
      style: {
        position: "absolute",
        zIndex: 100,
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      },
      onClick: deselectSchema,
      icon: /* @__PURE__ */ import_react225.default.createElement(Menu3, { strokeWidth: 1.5, size: 20 })
    }
  ), /* @__PURE__ */ import_react225.default.createElement(Text4, { strong: true, style: { textAlign: "center", width: "100%" } }, typedI18n("editField"))), /* @__PURE__ */ import_react225.default.createElement(divider_default, { style: { marginTop: token2.marginXS, marginBottom: token2.marginXS } }), /* @__PURE__ */ import_react225.default.createElement(
    "div",
    {
      style: {
        height: getSidebarContentHeight(size.height),
        overflowY: "auto",
        overflowX: "hidden"
      }
    },
    /* @__PURE__ */ import_react225.default.createElement(
      es_default30,
      {
        form,
        schema: propPanelSchema,
        widgets,
        watch: { "#": handleWatch },
        locale: "en-US"
      }
    )
  ));
};
var propsAreUnchanged = (prevProps, nextProps) => {
  return JSON.stringify(prevProps.activeSchema) == JSON.stringify(nextProps.activeSchema);
};
var DetailView_default = import_react225.default.memo(DetailView, propsAreUnchanged);

// src/components/Designer/RightSidebar/index.tsx
var Sidebar = (props) => {
  const { sidebarOpen, setSidebarOpen, activeElements, schemas } = props;
  const { token: token2 } = theme_default3.useToken();
  const getActiveSchemas = () => schemas.filter((s) => activeElements.map((ae) => ae.id).includes(s.id));
  const getLastActiveSchema = () => {
    const activeSchemas = getActiveSchemas();
    return activeSchemas[activeSchemas.length - 1];
  };
  const iconProps = { strokeWidth: 1.5, size: 20 };
  return /* @__PURE__ */ import_react226.default.createElement(
    "div",
    {
      style: {
        position: "absolute",
        right: 0,
        zIndex: 1,
        height: "100%",
        width: sidebarOpen ? RIGHT_SIDEBAR_WIDTH : 0
      }
    },
    /* @__PURE__ */ import_react226.default.createElement("div", null, /* @__PURE__ */ import_react226.default.createElement(
      button_default2,
      {
        style: {
          position: "absolute",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          top: "1rem",
          right: "1rem",
          zIndex: 100
        },
        icon: sidebarOpen ? /* @__PURE__ */ import_react226.default.createElement(ArrowRight, { ...iconProps }) : /* @__PURE__ */ import_react226.default.createElement(ArrowLeft, { ...iconProps }),
        onClick: () => setSidebarOpen(!sidebarOpen)
      }
    ), /* @__PURE__ */ import_react226.default.createElement(
      "div",
      {
        style: {
          width: RIGHT_SIDEBAR_WIDTH,
          height: "100%",
          display: sidebarOpen ? "block" : "none",
          top: 0,
          right: 0,
          position: "absolute",
          padding: "0.7rem 1rem",
          overflowY: "auto",
          fontFamily: "'Open Sans', sans-serif",
          boxSizing: "border-box",
          background: token2.colorBgLayout
        }
      },
      /* @__PURE__ */ import_react226.default.createElement("div", null, getActiveSchemas().length === 0 ? /* @__PURE__ */ import_react226.default.createElement(ListView_default, { ...props }) : /* @__PURE__ */ import_react226.default.createElement(DetailView_default, { ...props, activeSchema: getLastActiveSchema() }))
    ))
  );
};
var RightSidebar_default = Sidebar;

// src/components/Designer/LeftSidebar.tsx
var import_react228 = __toESM(require_react());

// src/components/Renderer.tsx
var import_react227 = __toESM(require_react());
var useRerenderDependencies = (arg) => {
  const { plugin, value, mode, scale, schema, options } = arg;
  const _options = cloneDeep(options);
  if (_options.font) {
    Object.values(_options.font).forEach((fontObj) => {
      fontObj.data = "...";
    });
  }
  const optionStr = JSON.stringify(_options);
  return (0, import_react227.useMemo)(() => {
    if (plugin?.uninterruptedEditMode && mode === "designer") {
      return [mode];
    } else {
      return [value, mode, scale, JSON.stringify(schema), optionStr];
    }
  }, [plugin?.uninterruptedEditMode, value, mode, scale, schema, optionStr, plugin]);
};
var Wrapper2 = ({
  children,
  outline,
  onChangeHoveringSchemaId,
  schema,
  selectable = true
}) => /* @__PURE__ */ import_react227.default.createElement(
  "div",
  {
    title: schema.name,
    onMouseEnter: () => onChangeHoveringSchemaId && onChangeHoveringSchemaId(schema.id),
    onMouseLeave: () => onChangeHoveringSchemaId && onChangeHoveringSchemaId(null),
    className: selectable ? SELECTABLE_CLASSNAME : "",
    id: schema.id,
    style: {
      position: "absolute",
      cursor: schema.readOnly ? "initial" : "pointer",
      height: schema.height * ZOOM,
      width: schema.width * ZOOM,
      top: schema.position.y * ZOOM,
      left: schema.position.x * ZOOM,
      transform: `rotate(${schema.rotate ?? 0}deg)`,
      opacity: schema.opacity ?? 1,
      outline
    }
  },
  schema.required && /* @__PURE__ */ import_react227.default.createElement(
    "span",
    {
      style: {
        color: "red",
        position: "absolute",
        top: -12,
        left: -12,
        fontSize: 18,
        fontWeight: 700
      }
    },
    "*"
  ),
  children
);
var Renderer = (props) => {
  const { schema, basePdf, value, mode, onChange, stopEditing, tabIndex, placeholder, scale } = props;
  const pluginsRegistry = (0, import_react227.useContext)(PluginsRegistry);
  const options = (0, import_react227.useContext)(OptionsContext);
  const i18n2 = (0, import_react227.useContext)(I18nContext);
  const { token: theme } = theme_default3.useToken();
  const ref3 = (0, import_react227.useRef)(null);
  const _cache2 = (0, import_react227.useContext)(CacheContext);
  const schemaType = typeof schema.type === "string" ? schema.type : "";
  const plugin = Object.values(pluginsRegistry || {}).find((plugin2) => {
    const defaultSchema = plugin2?.propPanel?.defaultSchema;
    return defaultSchema?.type === schemaType;
  });
  const reRenderDependencies = useRerenderDependencies({
    plugin: plugin || {},
    value,
    mode,
    scale,
    schema,
    options
  });
  (0, import_react227.useEffect)(() => {
    if (!plugin?.ui || !ref3.current || !schema.type) return;
    ref3.current.innerHTML = "";
    const render4 = plugin.ui;
    void render4({
      value,
      schema,
      basePdf,
      rootElement: ref3.current,
      mode,
      onChange,
      stopEditing,
      tabIndex,
      placeholder,
      options,
      theme,
      i18n: i18n2,
      _cache: _cache2
    });
    return () => {
      if (ref3.current) {
        ref3.current.innerHTML = "";
      }
    };
  }, [plugin?.ui, schema.type, reRenderDependencies]);
  if (!plugin || !plugin.ui) {
    console.error(`[@pdfme/ui] Renderer for type ${schema.type} not found. 
Check this document: https://pdfme.com/docs/custom-schemas`);
    return /* @__PURE__ */ import_react227.default.createElement(import_react227.default.Fragment, null);
  }
  return /* @__PURE__ */ import_react227.default.createElement(Wrapper2, { ...props }, /* @__PURE__ */ import_react227.default.createElement("div", { style: { height: "100%", width: "100%" }, ref: ref3 }));
};
var Renderer_default = Renderer;

// src/components/Designer/LeftSidebar.tsx
var Draggable = (props) => {
  const { scale, basePdf, plugin } = props;
  const { token: token2 } = theme_default3.useToken();
  const defaultSchema = plugin.propPanel.defaultSchema;
  const draggable = useDraggable({ id: defaultSchema.type, data: defaultSchema });
  const { listeners, setNodeRef, attributes: attributes2, transform, isDragging } = draggable;
  const style2 = { transform: CSS2.Translate.toString(transform) };
  const renderedSchema = import_react228.default.useMemo(() => /* @__PURE__ */ import_react228.default.createElement("div", { style: { transform: `scale(${scale})` } }, /* @__PURE__ */ import_react228.default.createElement(
    Renderer_default,
    {
      schema: { ...defaultSchema, id: defaultSchema.type },
      basePdf,
      value: defaultSchema.content || "",
      onChangeHoveringSchemaId: () => {
      },
      mode: "viewer",
      outline: `1px solid ${token2.colorPrimary}`,
      scale
    }
  )), [defaultSchema, basePdf, scale, token2.colorPrimary]);
  return /* @__PURE__ */ import_react228.default.createElement("div", { ref: setNodeRef, style: style2, ...listeners, ...attributes2 }, isDragging && renderedSchema, /* @__PURE__ */ import_react228.default.createElement("div", { style: { visibility: isDragging ? "hidden" : "visible" } }, props.children));
};
var LeftSidebar = ({
  height,
  scale,
  basePdf
}) => {
  const { token: token2 } = theme_default3.useToken();
  const pluginsRegistry = (0, import_react228.useContext)(PluginsRegistry);
  const [isDragging, setIsDragging] = (0, import_react228.useState)(false);
  (0, import_react228.useEffect)(() => {
    const handleMouseUp = () => {
      if (isDragging) {
        setIsDragging(false);
      }
    };
    document.addEventListener("mouseup", handleMouseUp);
    return () => {
      document.removeEventListener("mouseup", handleMouseUp);
    };
  }, [isDragging]);
  return /* @__PURE__ */ import_react228.default.createElement(
    "div",
    {
      style: {
        left: 0,
        right: 0,
        position: "absolute",
        zIndex: 1,
        height,
        width: LEFT_SIDEBAR_WIDTH,
        background: token2.colorBgLayout,
        textAlign: "center",
        overflow: isDragging ? "visible" : "auto"
      }
    },
    Object.entries(pluginsRegistry).map(([label, plugin]) => {
      if (!plugin?.propPanel.defaultSchema) return null;
      return /* @__PURE__ */ import_react228.default.createElement(Draggable, { key: label, scale, basePdf, plugin }, /* @__PURE__ */ import_react228.default.createElement(
        button_default2,
        {
          onMouseDown: () => setIsDragging(true),
          style: { width: 35, height: 35, marginTop: "0.25rem", padding: "0.25rem" }
        },
        /* @__PURE__ */ import_react228.default.createElement(PluginIcon_default, { plugin, label })
      ));
    })
  );
};
var LeftSidebar_default = LeftSidebar;

// src/components/Designer/Canvas/index.tsx
var import_react241 = __toESM(require_react());

// src/components/Paper.tsx
var import_react229 = __toESM(require_react());
var Paper = (props) => {
  const {
    paperRefs,
    scale,
    size,
    schemasList,
    pageSizes,
    backgrounds,
    renderPaper,
    renderSchema,
    hasRulers
  } = props;
  const font = (0, import_react229.useContext)(FontContext);
  const rulerHeight = hasRulers ? RULER_HEIGHT : 0;
  if (pageSizes.length !== backgrounds.length || pageSizes.length !== schemasList.length) {
    return null;
  }
  return /* @__PURE__ */ import_react229.default.createElement(
    "div",
    {
      style: {
        transform: `scale(${scale})`,
        transformOrigin: "top left",
        // NOTE: These values do not impact the UI unless they exceed the Paper sizes.
        // We set them to the scale value to ensure the container is redrawn when you zoom in/out.
        height: scale,
        width: scale
      }
    },
    backgrounds.map((background, paperIndex) => {
      const pageSize = pageSizes[paperIndex];
      const paperSize = { width: pageSize.width * ZOOM, height: pageSize.height * ZOOM };
      const leftCenteringIndent = paperSize.width * scale + rulerHeight < size.width ? `${(size.width / scale - paperSize.width) / 2}px` : `${rulerHeight}px`;
      let pageTop = paperIndex > 0 ? (rulerHeight + PAGE_GAP) * (paperIndex + 1) : rulerHeight;
      if (!hasRulers) {
        pageTop += PAGE_GAP * 2;
      }
      return /* @__PURE__ */ import_react229.default.createElement(
        "div",
        {
          key: String(paperIndex) + JSON.stringify(paperSize),
          ref: (e3) => {
            if (e3) {
              paperRefs.current[paperIndex] = e3;
            }
          },
          onMouseDown: (e3) => {
            if (e3.currentTarget === e3.target && document && document.hasFocus() && document.activeElement instanceof HTMLElement) {
              document.activeElement.blur();
            }
          },
          style: {
            fontFamily: `'${getFallbackFontName(font)}'`,
            top: `${pageTop}px`,
            left: leftCenteringIndent,
            position: "relative",
            backgroundImage: `url(${background})`,
            backgroundSize: `${paperSize.width}px ${paperSize.height}px`,
            ...paperSize
          }
        },
        renderPaper({ paperSize, index: paperIndex }),
        schemasList[paperIndex].map((schema, schemaIndex) => {
          return /* @__PURE__ */ import_react229.default.createElement("div", { key: schema.id }, renderSchema({
            schema,
            index: paperIndex === 0 ? schemaIndex : schemaIndex + schemasList[paperIndex - 1].length
          }));
        })
      );
    })
  );
};
var Paper_default = Paper;

// src/components/Designer/Canvas/Selecto.tsx
var import_react231 = __toESM(require_react());

// ../../node_modules/react-selecto/dist/selecto.esm.js
var import_react230 = __toESM(require_react());

// ../../node_modules/@daybrush/utils/dist/utils.esm.js
var FUNCTION = "function";
var OBJECT = "object";
var STRING = "string";
var NUMBER = "number";
var UNDEFINED2 = "undefined";
var IS_WINDOW = typeof window !== UNDEFINED2;
var doc = typeof document !== UNDEFINED2 && document;
var OPEN_CLOSED_CHARACTERS = [{
  open: "(",
  close: ")"
}, {
  open: '"',
  close: '"'
}, {
  open: "'",
  close: "'"
}, {
  open: '\\"',
  close: '\\"'
}, {
  open: "\\'",
  close: "\\'"
}];
var TINY_NUM = 1e-7;
var REVERSE_TINY_NUM = 1 / TINY_NUM;
var DEFAULT_UNIT_PRESETS = {
  "cm": function(pos) {
    return pos * 96 / 2.54;
  },
  "mm": function(pos) {
    return pos * 96 / 254;
  },
  "in": function(pos) {
    return pos * 96;
  },
  "pt": function(pos) {
    return pos * 96 / 72;
  },
  "pc": function(pos) {
    return pos * 96 / 6;
  },
  "%": function(pos, size) {
    return pos * size / 100;
  },
  "vw": function(pos, size) {
    if (size === void 0) {
      size = window.innerWidth;
    }
    return pos / 100 * size;
  },
  "vh": function(pos, size) {
    if (size === void 0) {
      size = window.innerHeight;
    }
    return pos / 100 * size;
  },
  "vmax": function(pos, size) {
    if (size === void 0) {
      size = Math.max(window.innerWidth, window.innerHeight);
    }
    return pos / 100 * size;
  },
  "vmin": function(pos, size) {
    if (size === void 0) {
      size = Math.min(window.innerWidth, window.innerHeight);
    }
    return pos / 100 * size;
  }
};
function __spreadArrays() {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r2 = Array(s), k = 0, i = 0; i < il; i++) for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) r2[k] = a[j];
  return r2;
}
function dot(a1, a2, b1, b2) {
  return (a1 * b2 + a2 * b1) / (b1 + b2);
}
function isUndefined2(value) {
  return typeof value === UNDEFINED2;
}
function isObject5(value) {
  return value && typeof value === OBJECT;
}
function isArray5(value) {
  return Array.isArray(value);
}
function isString2(value) {
  return typeof value === STRING;
}
function isNumber3(value) {
  return typeof value === NUMBER;
}
function isFunction5(value) {
  return typeof value === FUNCTION;
}
function isEqualSeparator(character2, separator) {
  var isCharacterSpace = character2 === "" || character2 == " ";
  var isSeparatorSpace = separator === "" || separator == " ";
  return isSeparatorSpace && isCharacterSpace || character2 === separator;
}
function findOpen(openCharacter, texts, index3, length2, openCloseCharacters) {
  var isIgnore = findIgnore(openCharacter, texts, index3);
  if (!isIgnore) {
    return findClose(openCharacter, texts, index3 + 1, length2, openCloseCharacters);
  }
  return index3;
}
function findIgnore(character2, texts, index3) {
  if (!character2.ignore) {
    return null;
  }
  var otherText = texts.slice(Math.max(index3 - 3, 0), index3 + 3).join("");
  return new RegExp(character2.ignore).exec(otherText);
}
function findClose(closeCharacter, texts, index3, length2, openCloseCharacters) {
  var _loop_1 = function(i2) {
    var character2 = texts[i2].trim();
    if (character2 === closeCharacter.close && !findIgnore(closeCharacter, texts, i2)) {
      return {
        value: i2
      };
    }
    var nextIndex2 = i2;
    var openCharacter = find(openCloseCharacters, function(_a) {
      var open2 = _a.open;
      return open2 === character2;
    });
    if (openCharacter) {
      nextIndex2 = findOpen(openCharacter, texts, i2, length2, openCloseCharacters);
    }
    if (nextIndex2 === -1) {
      return out_i_1 = i2, "break";
    }
    i2 = nextIndex2;
    out_i_1 = i2;
  };
  var out_i_1;
  for (var i = index3; i < length2; ++i) {
    var state_1 = _loop_1(i);
    i = out_i_1;
    if (typeof state_1 === "object") return state_1.value;
    if (state_1 === "break") break;
  }
  return -1;
}
function splitText(text, splitOptions) {
  var _a = isString2(splitOptions) ? {
    separator: splitOptions
  } : splitOptions, _b = _a.separator, separator = _b === void 0 ? "," : _b, isSeparateFirst = _a.isSeparateFirst, isSeparateOnlyOpenClose = _a.isSeparateOnlyOpenClose, _c = _a.isSeparateOpenClose, isSeparateOpenClose = _c === void 0 ? isSeparateOnlyOpenClose : _c, _d = _a.openCloseCharacters, openCloseCharacters = _d === void 0 ? OPEN_CLOSED_CHARACTERS : _d;
  var openClosedText = openCloseCharacters.map(function(_a2) {
    var open2 = _a2.open, close = _a2.close;
    if (open2 === close) {
      return open2;
    }
    return open2 + "|" + close;
  }).join("|");
  var regexText = "(\\s*" + separator + "\\s*|" + openClosedText + "|\\s+)";
  var regex = new RegExp(regexText, "g");
  var texts = text.split(regex).filter(function(chr) {
    return chr && chr !== "undefined";
  });
  var length2 = texts.length;
  var values = [];
  var tempValues = [];
  function resetTemp() {
    if (tempValues.length) {
      values.push(tempValues.join(""));
      tempValues = [];
      return true;
    }
    return false;
  }
  var _loop_2 = function(i2) {
    var character2 = texts[i2].trim();
    var nextIndex2 = i2;
    var openCharacter = find(openCloseCharacters, function(_a2) {
      var open2 = _a2.open;
      return open2 === character2;
    });
    var closeCharacter = find(openCloseCharacters, function(_a2) {
      var close = _a2.close;
      return close === character2;
    });
    if (openCharacter) {
      nextIndex2 = findOpen(openCharacter, texts, i2, length2, openCloseCharacters);
      if (nextIndex2 !== -1 && isSeparateOpenClose) {
        if (resetTemp() && isSeparateFirst) {
          return out_i_2 = i2, "break";
        }
        values.push(texts.slice(i2, nextIndex2 + 1).join(""));
        i2 = nextIndex2;
        if (isSeparateFirst) {
          return out_i_2 = i2, "break";
        }
        return out_i_2 = i2, "continue";
      }
    } else if (closeCharacter && !findIgnore(closeCharacter, texts, i2)) {
      var nextOpenCloseCharacters = __spreadArrays(openCloseCharacters);
      nextOpenCloseCharacters.splice(openCloseCharacters.indexOf(closeCharacter), 1);
      return {
        value: splitText(text, {
          separator,
          isSeparateFirst,
          isSeparateOnlyOpenClose,
          isSeparateOpenClose,
          openCloseCharacters: nextOpenCloseCharacters
        })
      };
    } else if (isEqualSeparator(character2, separator) && !isSeparateOnlyOpenClose) {
      resetTemp();
      if (isSeparateFirst) {
        return out_i_2 = i2, "break";
      }
      return out_i_2 = i2, "continue";
    }
    if (nextIndex2 === -1) {
      nextIndex2 = length2 - 1;
    }
    tempValues.push(texts.slice(i2, nextIndex2 + 1).join(""));
    i2 = nextIndex2;
    out_i_2 = i2;
  };
  var out_i_2;
  for (var i = 0; i < length2; ++i) {
    var state_2 = _loop_2(i);
    i = out_i_2;
    if (typeof state_2 === "object") return state_2.value;
    if (state_2 === "break") break;
  }
  if (tempValues.length) {
    values.push(tempValues.join(""));
  }
  return values;
}
function splitSpace(text) {
  return splitText(text, "");
}
function splitComma(text) {
  return splitText(text, ",");
}
function splitBracket(text) {
  var matches = /([^(]*)\(([\s\S]*)\)([\s\S]*)/g.exec(text);
  if (!matches || matches.length < 4) {
    return {};
  } else {
    return {
      prefix: matches[1],
      value: matches[2],
      suffix: matches[3]
    };
  }
}
function splitUnit(text) {
  var matches = /^([^\d|e|\-|\+]*)((?:\d|\.|-|e-|e\+)+)(\S*)$/g.exec(text);
  if (!matches) {
    return {
      prefix: "",
      unit: "",
      value: NaN
    };
  }
  var prefix3 = matches[1];
  var value = matches[2];
  var unit3 = matches[3];
  return {
    prefix: prefix3,
    unit: unit3,
    value: parseFloat(value)
  };
}
function camelize(str) {
  return str.replace(/[\s-_]+([^\s-_])/g, function(all, letter) {
    return letter.toUpperCase();
  });
}
function decamelize(str, separator) {
  if (separator === void 0) {
    separator = "-";
  }
  return str.replace(/([a-z])([A-Z])/g, function(all, letter, letter2) {
    return "" + letter + separator + letter2.toLowerCase();
  });
}
function now3() {
  return Date.now ? Date.now() : (/* @__PURE__ */ new Date()).getTime();
}
function findIndex(arr, callback, defaultIndex) {
  if (defaultIndex === void 0) {
    defaultIndex = -1;
  }
  var length2 = arr.length;
  for (var i = 0; i < length2; ++i) {
    if (callback(arr[i], i, arr)) {
      return i;
    }
  }
  return defaultIndex;
}
function findLastIndex(arr, callback, defaultIndex) {
  if (defaultIndex === void 0) {
    defaultIndex = -1;
  }
  var length2 = arr.length;
  for (var i = length2 - 1; i >= 0; --i) {
    if (callback(arr[i], i, arr)) {
      return i;
    }
  }
  return defaultIndex;
}
function findLast(arr, callback, defalutValue) {
  var index3 = findLastIndex(arr, callback);
  return index3 > -1 ? arr[index3] : defalutValue;
}
function find(arr, callback, defalutValue) {
  var index3 = findIndex(arr, callback);
  return index3 > -1 ? arr[index3] : defalutValue;
}
var requestAnimationFrame2 = /* @__PURE__ */ (function() {
  var firstTime = now3();
  var raf3 = IS_WINDOW && (window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.msRequestAnimationFrame);
  return raf3 ? raf3.bind(window) : function(callback) {
    var currTime = now3();
    var id = setTimeout(function() {
      callback(currTime - firstTime);
    }, 1e3 / 60);
    return id;
  };
})();
var cancelAnimationFrame2 = /* @__PURE__ */ (function() {
  var caf3 = IS_WINDOW && (window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || window.msCancelAnimationFrame);
  return caf3 ? caf3.bind(window) : function(handle) {
    clearTimeout(handle);
  };
})();
function getKeys2(obj) {
  return Object.keys(obj);
}
function convertUnitSize(pos, size) {
  var _a = splitUnit(pos), value = _a.value, unit3 = _a.unit;
  if (isObject5(size)) {
    var sizeFunction = size[unit3];
    if (sizeFunction) {
      if (isFunction5(sizeFunction)) {
        return sizeFunction(value);
      } else if (DEFAULT_UNIT_PRESETS[unit3]) {
        return DEFAULT_UNIT_PRESETS[unit3](value, sizeFunction);
      }
    }
  } else if (unit3 === "%") {
    return value * size / 100;
  }
  if (DEFAULT_UNIT_PRESETS[unit3]) {
    return DEFAULT_UNIT_PRESETS[unit3](value);
  }
  return value;
}
function between(value, min, max) {
  return Math.max(min, Math.min(value, max));
}
function checkBoundSize(targetSize, compareSize, isMax, ratio) {
  if (ratio === void 0) {
    ratio = targetSize[0] / targetSize[1];
  }
  return [[throttle3(compareSize[0], TINY_NUM), throttle3(compareSize[0] / ratio, TINY_NUM)], [throttle3(compareSize[1] * ratio, TINY_NUM), throttle3(compareSize[1], TINY_NUM)]].filter(function(size) {
    return size.every(function(value, i) {
      var defaultSize = compareSize[i];
      var throttledSize = throttle3(defaultSize, TINY_NUM);
      return isMax ? value <= defaultSize || value <= throttledSize : value >= defaultSize || value >= throttledSize;
    });
  })[0] || targetSize;
}
function calculateBoundSize(size, minSize, maxSize, keepRatio) {
  if (!keepRatio) {
    return size.map(function(value, i) {
      return between(value, minSize[i], maxSize[i]);
    });
  }
  var width = size[0], height = size[1];
  var ratio = keepRatio === true ? width / height : keepRatio;
  var _a = checkBoundSize(size, minSize, false, ratio), minWidth = _a[0], minHeight = _a[1];
  var _b = checkBoundSize(size, maxSize, true, ratio), maxWidth = _b[0], maxHeight = _b[1];
  if (width < minWidth || height < minHeight) {
    width = minWidth;
    height = minHeight;
  } else if (width > maxWidth || height > maxHeight) {
    width = maxWidth;
    height = maxHeight;
  }
  return [width, height];
}
function sum(nums) {
  var length2 = nums.length;
  var total = 0;
  for (var i = length2 - 1; i >= 0; --i) {
    total += nums[i];
  }
  return total;
}
function average(nums) {
  var length2 = nums.length;
  var total = 0;
  for (var i = length2 - 1; i >= 0; --i) {
    total += nums[i];
  }
  return length2 ? total / length2 : 0;
}
function getRad(pos1, pos2) {
  var distX = pos2[0] - pos1[0];
  var distY = pos2[1] - pos1[1];
  var rad = Math.atan2(distY, distX);
  return rad >= 0 ? rad : rad + Math.PI * 2;
}
function getCenterPoint(points) {
  return [0, 1].map(function(i) {
    return average(points.map(function(pos) {
      return pos[i];
    }));
  });
}
function getShapeDirection(points) {
  var center = getCenterPoint(points);
  var pos1Rad = getRad(center, points[0]);
  var pos2Rad = getRad(center, points[1]);
  return pos1Rad < pos2Rad && pos2Rad - pos1Rad < Math.PI || pos1Rad > pos2Rad && pos2Rad - pos1Rad < -Math.PI ? 1 : -1;
}
function getDist(a, b) {
  return Math.sqrt(Math.pow((b ? b[0] : 0) - a[0], 2) + Math.pow((b ? b[1] : 0) - a[1], 2));
}
function throttle3(num, unit3) {
  if (!unit3) {
    return num;
  }
  var reverseUnit = 1 / unit3;
  return Math.round(num / unit3) / reverseUnit;
}
function throttleArray(nums, unit3) {
  nums.forEach(function(_, i) {
    nums[i] = throttle3(nums[i], unit3);
  });
  return nums;
}
function counter(num) {
  var nums = [];
  for (var i = 0; i < num; ++i) {
    nums.push(i);
  }
  return nums;
}
function flat(arr) {
  return arr.reduce(function(prev2, cur) {
    return prev2.concat(cur);
  }, []);
}
function hasClass(element, className2) {
  if (element.classList) {
    return element.classList.contains(className2);
  }
  return !!element.className.match(new RegExp("(\\s|^)" + className2 + "(\\s|$)"));
}
function addClass(element, className2) {
  if (element.classList) {
    element.classList.add(className2);
  } else {
    element.className += " " + className2;
  }
}
function removeClass(element, className2) {
  if (element.classList) {
    element.classList.remove(className2);
  } else {
    var reg = new RegExp("(\\s|^)" + className2 + "(\\s|$)");
    element.className = element.className.replace(reg, " ");
  }
}
function addEvent2(el, type5, listener, options) {
  el.addEventListener(type5, listener, options);
}
function removeEvent2(el, type5, listener, options) {
  el.removeEventListener(type5, listener, options);
}
function getDocument3(el) {
  return (el === null || el === void 0 ? void 0 : el.ownerDocument) || doc;
}
function getDocumentElement(el) {
  return getDocument3(el).documentElement;
}
function getDocumentBody(el) {
  return getDocument3(el).body;
}
function getWindow2(el) {
  var _a;
  return ((_a = el === null || el === void 0 ? void 0 : el.ownerDocument) === null || _a === void 0 ? void 0 : _a.defaultView) || window;
}
function isWindow3(val) {
  return val && "postMessage" in val && "blur" in val && "self" in val;
}
function isNode2(el) {
  return isObject5(el) && el.nodeName && el.nodeType && "ownerDocument" in el;
}

// ../../node_modules/@scena/event-emitter/dist/event-emitter.esm.js
var __assign2 = function() {
  __assign2 = Object.assign || function __assign11(t2) {
    for (var s, i = 1, n2 = arguments.length; i < n2; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t2[p] = s[p];
    }
    return t2;
  };
  return __assign2.apply(this, arguments);
};
function __spreadArrays2() {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r2 = Array(s), k = 0, i = 0; i < il; i++) for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) r2[k] = a[j];
  return r2;
}
var EventEmitter = /* @__PURE__ */ (function() {
  function EventEmitter2() {
    this._events = {};
  }
  var __proto = EventEmitter2.prototype;
  __proto.on = function(eventName, listener) {
    if (isObject5(eventName)) {
      for (var name in eventName) {
        this.on(name, eventName[name]);
      }
    } else {
      this._addEvent(eventName, listener, {});
    }
    return this;
  };
  __proto.off = function(eventName, listener) {
    if (!eventName) {
      this._events = {};
    } else if (isObject5(eventName)) {
      for (var name in eventName) {
        this.off(name);
      }
    } else if (!listener) {
      this._events[eventName] = [];
    } else {
      var events2 = this._events[eventName];
      if (events2) {
        var index3 = findIndex(events2, function(e3) {
          return e3.listener === listener;
        });
        if (index3 > -1) {
          events2.splice(index3, 1);
        }
      }
    }
    return this;
  };
  __proto.once = function(eventName, listener) {
    var _this = this;
    if (listener) {
      this._addEvent(eventName, listener, {
        once: true
      });
    }
    return new Promise(function(resolve) {
      _this._addEvent(eventName, resolve, {
        once: true
      });
    });
  };
  __proto.emit = function(eventName, param) {
    var _this = this;
    if (param === void 0) {
      param = {};
    }
    var events2 = this._events[eventName];
    if (!eventName || !events2) {
      return true;
    }
    var isStop = false;
    param.eventType = eventName;
    param.stop = function() {
      isStop = true;
    };
    param.currentTarget = this;
    __spreadArrays2(events2).forEach(function(info) {
      info.listener(param);
      if (info.once) {
        _this.off(eventName, info.listener);
      }
    });
    return !isStop;
  };
  __proto.trigger = function(eventName, param) {
    if (param === void 0) {
      param = {};
    }
    return this.emit(eventName, param);
  };
  __proto._addEvent = function(eventName, listener, options) {
    var events2 = this._events;
    events2[eventName] = events2[eventName] || [];
    var listeners = events2[eventName];
    listeners.push(__assign2({
      listener
    }, options));
  };
  return EventEmitter2;
})();
var event_emitter_esm_default = EventEmitter;

// ../../node_modules/gesto/dist/gesto.esm.js
var extendStatics = function(d, b) {
  extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
    d2.__proto__ = b2;
  } || function(d2, b2) {
    for (var p in b2) if (b2.hasOwnProperty(p)) d2[p] = b2[p];
  };
  return extendStatics(d, b);
};
function __extends(d, b) {
  extendStatics(d, b);
  function __() {
    this.constructor = d;
  }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign3 = function() {
  __assign3 = Object.assign || function __assign11(t2) {
    for (var s, i = 1, n2 = arguments.length; i < n2; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t2[p] = s[p];
    }
    return t2;
  };
  return __assign3.apply(this, arguments);
};
function getRad2(pos1, pos2) {
  var distX = pos2[0] - pos1[0];
  var distY = pos2[1] - pos1[1];
  var rad = Math.atan2(distY, distX);
  return rad >= 0 ? rad : rad + Math.PI * 2;
}
function getRotatiion(touches) {
  return getRad2([
    touches[0].clientX,
    touches[0].clientY
  ], [
    touches[1].clientX,
    touches[1].clientY
  ]) / Math.PI * 180;
}
function isMultiTouch(e3) {
  return e3.touches && e3.touches.length >= 2;
}
function getEventClients(e3) {
  if (!e3) {
    return [];
  }
  if (e3.touches) {
    return getClients(e3.touches);
  } else {
    return [getClient(e3)];
  }
}
function isMouseEvent(e3) {
  return e3 && (e3.type.indexOf("mouse") > -1 || "button" in e3);
}
function getPosition4(clients, prevClients, startClients) {
  var length2 = startClients.length;
  var _a = getAverageClient(clients, length2), clientX = _a.clientX, clientY = _a.clientY, originalClientX = _a.originalClientX, originalClientY = _a.originalClientY;
  var _b = getAverageClient(prevClients, length2), prevX = _b.clientX, prevY = _b.clientY;
  var _c = getAverageClient(startClients, length2), startX = _c.clientX, startY = _c.clientY;
  var deltaX = clientX - prevX;
  var deltaY = clientY - prevY;
  var distX = clientX - startX;
  var distY = clientY - startY;
  return {
    clientX: originalClientX,
    clientY: originalClientY,
    deltaX,
    deltaY,
    distX,
    distY
  };
}
function getDist2(clients) {
  return Math.sqrt(Math.pow(clients[0].clientX - clients[1].clientX, 2) + Math.pow(clients[0].clientY - clients[1].clientY, 2));
}
function getClients(touches) {
  var length2 = Math.min(touches.length, 2);
  var clients = [];
  for (var i = 0; i < length2; ++i) {
    clients.push(getClient(touches[i]));
  }
  return clients;
}
function getClient(e3) {
  return {
    clientX: e3.clientX,
    clientY: e3.clientY
  };
}
function getAverageClient(clients, length2) {
  if (length2 === void 0) {
    length2 = clients.length;
  }
  var sumClient = {
    clientX: 0,
    clientY: 0,
    originalClientX: 0,
    originalClientY: 0
  };
  var minLength = Math.min(clients.length, length2);
  for (var i = 0; i < minLength; ++i) {
    var client = clients[i];
    sumClient.originalClientX += "originalClientX" in client ? client.originalClientX : client.clientX;
    sumClient.originalClientY += "originalClientY" in client ? client.originalClientY : client.clientY;
    sumClient.clientX += client.clientX;
    sumClient.clientY += client.clientY;
  }
  if (!length2) {
    return sumClient;
  }
  return {
    clientX: sumClient.clientX / length2,
    clientY: sumClient.clientY / length2,
    originalClientX: sumClient.originalClientX / length2,
    originalClientY: sumClient.originalClientY / length2
  };
}
var ClientStore = /* @__PURE__ */ (function() {
  function ClientStore2(clients) {
    this.prevClients = [];
    this.startClients = [];
    this.movement = 0;
    this.length = 0;
    this.startClients = clients;
    this.prevClients = clients;
    this.length = clients.length;
  }
  ClientStore2.prototype.getAngle = function(clients) {
    if (clients === void 0) {
      clients = this.prevClients;
    }
    return getRotatiion(clients);
  };
  ClientStore2.prototype.getRotation = function(clients) {
    if (clients === void 0) {
      clients = this.prevClients;
    }
    return getRotatiion(clients) - getRotatiion(this.startClients);
  };
  ClientStore2.prototype.getPosition = function(clients, isAdd) {
    if (clients === void 0) {
      clients = this.prevClients;
    }
    var position3 = getPosition4(clients || this.prevClients, this.prevClients, this.startClients);
    var deltaX = position3.deltaX, deltaY = position3.deltaY;
    this.movement += Math.sqrt(deltaX * deltaX + deltaY * deltaY);
    this.prevClients = clients;
    return position3;
  };
  ClientStore2.prototype.getPositions = function(clients) {
    if (clients === void 0) {
      clients = this.prevClients;
    }
    var prevClients = this.prevClients;
    var startClients = this.startClients;
    var minLength = Math.min(this.length, prevClients.length);
    var positions = [];
    for (var i = 0; i < minLength; ++i) {
      positions[i] = getPosition4([clients[i]], [prevClients[i]], [startClients[i]]);
    }
    return positions;
  };
  ClientStore2.prototype.getMovement = function(clients) {
    var movement = this.movement;
    if (!clients) {
      return movement;
    }
    var currentClient = getAverageClient(clients, this.length);
    var prevClient = getAverageClient(this.prevClients, this.length);
    var deltaX = currentClient.clientX - prevClient.clientX;
    var deltaY = currentClient.clientY - prevClient.clientY;
    return Math.sqrt(deltaX * deltaX + deltaY * deltaY) + movement;
  };
  ClientStore2.prototype.getDistance = function(clients) {
    if (clients === void 0) {
      clients = this.prevClients;
    }
    return getDist2(clients);
  };
  ClientStore2.prototype.getScale = function(clients) {
    if (clients === void 0) {
      clients = this.prevClients;
    }
    return getDist2(clients) / getDist2(this.startClients);
  };
  ClientStore2.prototype.move = function(deltaX, deltaY) {
    this.startClients.forEach(function(client) {
      client.clientX -= deltaX;
      client.clientY -= deltaY;
    });
    this.prevClients.forEach(function(client) {
      client.clientX -= deltaX;
      client.clientY -= deltaY;
    });
  };
  return ClientStore2;
})();
var INPUT_TAGNAMES = ["textarea", "input"];
var Gesto = /* @__PURE__ */ (function(_super) {
  __extends(Gesto2, _super);
  function Gesto2(targets, options) {
    if (options === void 0) {
      options = {};
    }
    var _this = _super.call(this) || this;
    _this.options = {};
    _this.flag = false;
    _this.pinchFlag = false;
    _this.data = {};
    _this.isDrag = false;
    _this.isPinch = false;
    _this.clientStores = [];
    _this.targets = [];
    _this.prevTime = 0;
    _this.doubleFlag = false;
    _this._useMouse = false;
    _this._useTouch = false;
    _this._useDrag = false;
    _this._dragFlag = false;
    _this._isTrusted = false;
    _this._isMouseEvent = false;
    _this._isSecondaryButton = false;
    _this._preventMouseEvent = false;
    _this._prevInputEvent = null;
    _this._isDragAPI = false;
    _this._isIdle = true;
    _this._preventMouseEventId = 0;
    _this._window = window;
    _this.onDragStart = function(e3, isTrusted) {
      if (isTrusted === void 0) {
        isTrusted = true;
      }
      if (!_this.flag && e3.cancelable === false) {
        return;
      }
      var isDragAPI = e3.type.indexOf("drag") >= -1;
      if (_this.flag && isDragAPI) {
        return;
      }
      _this._isDragAPI = true;
      var _a2 = _this.options, container2 = _a2.container, pinchOutside = _a2.pinchOutside, preventWheelClick = _a2.preventWheelClick, preventRightClick = _a2.preventRightClick, preventDefault2 = _a2.preventDefault, checkInput = _a2.checkInput, dragFocusedInput = _a2.dragFocusedInput, preventClickEventOnDragStart = _a2.preventClickEventOnDragStart, preventClickEventOnDrag = _a2.preventClickEventOnDrag, preventClickEventByCondition = _a2.preventClickEventByCondition;
      var useTouch = _this._useTouch;
      var isDragStart = !_this.flag;
      _this._isSecondaryButton = e3.which === 3 || e3.button === 2;
      if (preventWheelClick && (e3.which === 2 || e3.button === 1) || preventRightClick && (e3.which === 3 || e3.button === 2)) {
        _this.stop();
        return false;
      }
      if (isDragStart) {
        var activeElement = _this._window.document.activeElement;
        var target = e3.target;
        if (target) {
          var tagName = target.tagName.toLowerCase();
          var hasInput = INPUT_TAGNAMES.indexOf(tagName) > -1;
          var hasContentEditable = target.isContentEditable;
          if (hasInput || hasContentEditable) {
            if (checkInput || !dragFocusedInput && activeElement === target) {
              return false;
            }
            if (activeElement && (activeElement === target || hasContentEditable && activeElement.isContentEditable && activeElement.contains(target))) {
              if (dragFocusedInput) {
                target.blur();
              } else {
                return false;
              }
            }
          } else if ((preventDefault2 || e3.type === "touchstart") && activeElement) {
            var activeTagName = activeElement.tagName.toLowerCase();
            if (activeElement.isContentEditable || INPUT_TAGNAMES.indexOf(activeTagName) > -1) {
              activeElement.blur();
            }
          }
          if (preventClickEventOnDragStart || preventClickEventOnDrag || preventClickEventByCondition) {
            addEvent2(_this._window, "click", _this._onClick, true);
          }
        }
        _this.clientStores = [new ClientStore(getEventClients(e3))];
        _this._isIdle = false;
        _this.flag = true;
        _this.isDrag = false;
        _this._isTrusted = isTrusted;
        _this._dragFlag = true;
        _this._prevInputEvent = e3;
        _this.data = {};
        _this.doubleFlag = now3() - _this.prevTime < 200;
        _this._isMouseEvent = isMouseEvent(e3);
        if (!_this._isMouseEvent && _this._preventMouseEvent) {
          _this._allowMouseEvent();
        }
        var result = _this._preventMouseEvent || _this.emit("dragStart", __assign3(__assign3({ data: _this.data, datas: _this.data, inputEvent: e3, isMouseEvent: _this._isMouseEvent, isSecondaryButton: _this._isSecondaryButton, isTrusted, isDouble: _this.doubleFlag }, _this.getCurrentStore().getPosition()), { preventDefault: function() {
          e3.preventDefault();
        }, preventDrag: function() {
          _this._dragFlag = false;
        } }));
        if (result === false) {
          _this.stop();
        }
        if (_this._isMouseEvent && _this.flag && preventDefault2) {
          e3.preventDefault();
        }
      }
      if (!_this.flag) {
        return false;
      }
      var timer = 0;
      if (isDragStart) {
        _this._attchDragEvent();
        if (useTouch && pinchOutside) {
          timer = setTimeout(function() {
            addEvent2(container2, "touchstart", _this.onDragStart, {
              passive: false
            });
          });
        }
      } else if (useTouch && pinchOutside) {
        removeEvent2(container2, "touchstart", _this.onDragStart);
      }
      if (_this.flag && isMultiTouch(e3)) {
        clearTimeout(timer);
        if (isDragStart && e3.touches.length !== e3.changedTouches.length) {
          return;
        }
        if (!_this.pinchFlag) {
          _this.onPinchStart(e3);
        }
      }
    };
    _this.onDrag = function(e3, isScroll) {
      if (!_this.flag) {
        return;
      }
      var preventDefault2 = _this.options.preventDefault;
      if (!_this._isMouseEvent && preventDefault2) {
        e3.preventDefault();
      }
      _this._prevInputEvent = e3;
      var clients = getEventClients(e3);
      var result = _this.moveClients(clients, e3, false);
      if (_this._dragFlag) {
        if (_this.pinchFlag || result.deltaX || result.deltaY) {
          var dragResult = _this._preventMouseEvent || _this.emit("drag", __assign3(__assign3({}, result), { isScroll: !!isScroll, inputEvent: e3 }));
          if (dragResult === false) {
            _this.stop();
            return;
          }
        }
        if (_this.pinchFlag) {
          _this.onPinch(e3, clients);
        }
      }
      _this.getCurrentStore().getPosition(clients, true);
    };
    _this.onDragEnd = function(e3) {
      if (!_this.flag) {
        return;
      }
      var _a2 = _this.options, pinchOutside = _a2.pinchOutside, container2 = _a2.container, preventClickEventOnDrag = _a2.preventClickEventOnDrag, preventClickEventOnDragStart = _a2.preventClickEventOnDragStart, preventClickEventByCondition = _a2.preventClickEventByCondition;
      var isDrag = _this.isDrag;
      if (preventClickEventOnDrag || preventClickEventOnDragStart || preventClickEventByCondition) {
        requestAnimationFrame(function() {
          _this._allowClickEvent();
        });
      }
      if (!preventClickEventByCondition && !preventClickEventOnDragStart && preventClickEventOnDrag && !isDrag) {
        _this._allowClickEvent();
      }
      if (_this._useTouch && pinchOutside) {
        removeEvent2(container2, "touchstart", _this.onDragStart);
      }
      if (_this.pinchFlag) {
        _this.onPinchEnd(e3);
      }
      var clients = (e3 === null || e3 === void 0 ? void 0 : e3.touches) ? getEventClients(e3) : [];
      var clientsLength = clients.length;
      if (clientsLength === 0 || !_this.options.keepDragging) {
        _this.flag = false;
      } else {
        _this._addStore(new ClientStore(clients));
      }
      var position3 = _this._getPosition();
      var currentTime = now3();
      var isDouble = !isDrag && _this.doubleFlag;
      _this._prevInputEvent = null;
      _this.prevTime = isDrag || isDouble ? 0 : currentTime;
      if (!_this.flag) {
        _this._dettachDragEvent();
        _this._preventMouseEvent || _this.emit("dragEnd", __assign3({ data: _this.data, datas: _this.data, isDouble, isDrag, isClick: !isDrag, isMouseEvent: _this._isMouseEvent, isSecondaryButton: _this._isSecondaryButton, inputEvent: e3, isTrusted: _this._isTrusted }, position3));
        _this.clientStores = [];
        if (!_this._isMouseEvent) {
          _this._preventMouseEvent = true;
          clearTimeout(_this._preventMouseEventId);
          _this._preventMouseEventId = setTimeout(function() {
            _this._preventMouseEvent = false;
          }, 200);
        }
        _this._isIdle = true;
      }
    };
    _this.onBlur = function() {
      _this.onDragEnd();
    };
    _this._allowClickEvent = function() {
      removeEvent2(_this._window, "click", _this._onClick, true);
    };
    _this._onClick = function(e3) {
      _this._allowClickEvent();
      _this._allowMouseEvent();
      var preventClickEventByCondition = _this.options.preventClickEventByCondition;
      if (preventClickEventByCondition === null || preventClickEventByCondition === void 0 ? void 0 : preventClickEventByCondition(e3)) {
        return;
      }
      e3.stopPropagation();
      e3.preventDefault();
    };
    _this._onContextMenu = function(e3) {
      var options2 = _this.options;
      if (!options2.preventRightClick) {
        e3.preventDefault();
      } else {
        _this.onDragEnd(e3);
      }
    };
    _this._passCallback = function() {
    };
    var elements = [].concat(targets);
    var firstTarget = elements[0];
    _this._window = isWindow3(firstTarget) ? firstTarget : getWindow2(firstTarget);
    _this.options = __assign3({ checkInput: false, container: firstTarget && !("document" in firstTarget) ? getWindow2(firstTarget) : firstTarget, preventRightClick: true, preventWheelClick: true, preventClickEventOnDragStart: false, preventClickEventOnDrag: false, preventClickEventByCondition: null, preventDefault: true, checkWindowBlur: false, keepDragging: false, pinchThreshold: 0, events: ["touch", "mouse"] }, options);
    var _a = _this.options, container = _a.container, events2 = _a.events, checkWindowBlur = _a.checkWindowBlur;
    _this._useDrag = events2.indexOf("drag") > -1;
    _this._useTouch = events2.indexOf("touch") > -1;
    _this._useMouse = events2.indexOf("mouse") > -1;
    _this.targets = elements;
    if (_this._useDrag) {
      elements.forEach(function(el) {
        addEvent2(el, "dragstart", _this.onDragStart);
      });
    }
    if (_this._useMouse) {
      elements.forEach(function(el) {
        addEvent2(el, "mousedown", _this.onDragStart);
        addEvent2(el, "mousemove", _this._passCallback);
      });
      addEvent2(container, "contextmenu", _this._onContextMenu);
    }
    if (checkWindowBlur) {
      addEvent2(getWindow2(), "blur", _this.onBlur);
    }
    if (_this._useTouch) {
      var passive_1 = {
        passive: false
      };
      elements.forEach(function(el) {
        addEvent2(el, "touchstart", _this.onDragStart, passive_1);
        addEvent2(el, "touchmove", _this._passCallback, passive_1);
      });
    }
    return _this;
  }
  Gesto2.prototype.stop = function() {
    this.isDrag = false;
    this.data = {};
    this.clientStores = [];
    this.pinchFlag = false;
    this.doubleFlag = false;
    this.prevTime = 0;
    this.flag = false;
    this._isIdle = true;
    this._allowClickEvent();
    this._dettachDragEvent();
    this._isDragAPI = false;
  };
  Gesto2.prototype.getMovement = function(clients) {
    return this.getCurrentStore().getMovement(clients) + this.clientStores.slice(1).reduce(function(prev2, cur) {
      return prev2 + cur.movement;
    }, 0);
  };
  Gesto2.prototype.isDragging = function() {
    return this.isDrag;
  };
  Gesto2.prototype.isIdle = function() {
    return this._isIdle;
  };
  Gesto2.prototype.isFlag = function() {
    return this.flag;
  };
  Gesto2.prototype.isPinchFlag = function() {
    return this.pinchFlag;
  };
  Gesto2.prototype.isDoubleFlag = function() {
    return this.doubleFlag;
  };
  Gesto2.prototype.isPinching = function() {
    return this.isPinch;
  };
  Gesto2.prototype.scrollBy = function(deltaX, deltaY, e3, isCallDrag) {
    if (isCallDrag === void 0) {
      isCallDrag = true;
    }
    if (!this.flag) {
      return;
    }
    this.clientStores[0].move(deltaX, deltaY);
    isCallDrag && this.onDrag(e3, true);
  };
  Gesto2.prototype.move = function(_a, inputEvent) {
    var deltaX = _a[0], deltaY = _a[1];
    var store = this.getCurrentStore();
    var nextClients = store.prevClients;
    return this.moveClients(nextClients.map(function(_a2) {
      var clientX = _a2.clientX, clientY = _a2.clientY;
      return {
        clientX: clientX + deltaX,
        clientY: clientY + deltaY,
        originalClientX: clientX,
        originalClientY: clientY
      };
    }), inputEvent, true);
  };
  Gesto2.prototype.triggerDragStart = function(e3) {
    this.onDragStart(e3, false);
  };
  Gesto2.prototype.setEventData = function(data2) {
    var currentData = this.data;
    for (var name_1 in data2) {
      currentData[name_1] = data2[name_1];
    }
    return this;
  };
  Gesto2.prototype.setEventDatas = function(data2) {
    return this.setEventData(data2);
  };
  Gesto2.prototype.getCurrentEvent = function(inputEvent) {
    if (inputEvent === void 0) {
      inputEvent = this._prevInputEvent;
    }
    return __assign3(__assign3({ data: this.data, datas: this.data }, this._getPosition()), { movement: this.getMovement(), isDrag: this.isDrag, isPinch: this.isPinch, isScroll: false, inputEvent });
  };
  Gesto2.prototype.getEventData = function() {
    return this.data;
  };
  Gesto2.prototype.getEventDatas = function() {
    return this.data;
  };
  Gesto2.prototype.unset = function() {
    var _this = this;
    var targets = this.targets;
    var container = this.options.container;
    this.off();
    removeEvent2(this._window, "blur", this.onBlur);
    if (this._useDrag) {
      targets.forEach(function(el) {
        removeEvent2(el, "dragstart", _this.onDragStart);
      });
    }
    if (this._useMouse) {
      targets.forEach(function(target) {
        removeEvent2(target, "mousedown", _this.onDragStart);
      });
      removeEvent2(container, "contextmenu", this._onContextMenu);
    }
    if (this._useTouch) {
      targets.forEach(function(target) {
        removeEvent2(target, "touchstart", _this.onDragStart);
      });
      removeEvent2(container, "touchstart", this.onDragStart);
    }
    this._prevInputEvent = null;
    this._allowClickEvent();
    this._dettachDragEvent();
  };
  Gesto2.prototype.onPinchStart = function(e3) {
    var _this = this;
    var pinchThreshold = this.options.pinchThreshold;
    if (this.isDrag && this.getMovement() > pinchThreshold) {
      return;
    }
    var store = new ClientStore(getEventClients(e3));
    this.pinchFlag = true;
    this._addStore(store);
    var result = this.emit("pinchStart", __assign3(__assign3({ data: this.data, datas: this.data, angle: store.getAngle(), touches: this.getCurrentStore().getPositions() }, store.getPosition()), { inputEvent: e3, isTrusted: this._isTrusted, preventDefault: function() {
      e3.preventDefault();
    }, preventDrag: function() {
      _this._dragFlag = false;
    } }));
    if (result === false) {
      this.pinchFlag = false;
    }
  };
  Gesto2.prototype.onPinch = function(e3, clients) {
    if (!this.flag || !this.pinchFlag || clients.length < 2) {
      return;
    }
    var store = this.getCurrentStore();
    this.isPinch = true;
    this.emit("pinch", __assign3(__assign3({ data: this.data, datas: this.data, movement: this.getMovement(clients), angle: store.getAngle(clients), rotation: store.getRotation(clients), touches: store.getPositions(clients), scale: store.getScale(clients), distance: store.getDistance(clients) }, store.getPosition(clients)), { inputEvent: e3, isTrusted: this._isTrusted }));
  };
  Gesto2.prototype.onPinchEnd = function(e3) {
    if (!this.pinchFlag) {
      return;
    }
    var isPinch = this.isPinch;
    this.isPinch = false;
    this.pinchFlag = false;
    var store = this.getCurrentStore();
    this.emit("pinchEnd", __assign3(__assign3({ data: this.data, datas: this.data, isPinch, touches: store.getPositions() }, store.getPosition()), { inputEvent: e3 }));
  };
  Gesto2.prototype.getCurrentStore = function() {
    return this.clientStores[0];
  };
  Gesto2.prototype.moveClients = function(clients, inputEvent, isAdd) {
    var position3 = this._getPosition(clients, isAdd);
    var isPrevDrag = this.isDrag;
    if (position3.deltaX || position3.deltaY) {
      this.isDrag = true;
    }
    var isFirstDrag = false;
    if (!isPrevDrag && this.isDrag) {
      isFirstDrag = true;
    }
    return __assign3(__assign3({ data: this.data, datas: this.data }, position3), { movement: this.getMovement(clients), isDrag: this.isDrag, isPinch: this.isPinch, isScroll: false, isMouseEvent: this._isMouseEvent, isSecondaryButton: this._isSecondaryButton, inputEvent, isTrusted: this._isTrusted, isFirstDrag });
  };
  Gesto2.prototype._addStore = function(store) {
    this.clientStores.splice(0, 0, store);
  };
  Gesto2.prototype._getPosition = function(clients, isAdd) {
    var store = this.getCurrentStore();
    var position3 = store.getPosition(clients, isAdd);
    var _a = this.clientStores.slice(1).reduce(function(prev2, cur) {
      var storePosition = cur.getPosition();
      prev2.distX += storePosition.distX;
      prev2.distY += storePosition.distY;
      return prev2;
    }, position3), distX = _a.distX, distY = _a.distY;
    return __assign3(__assign3({}, position3), { distX, distY });
  };
  Gesto2.prototype._attchDragEvent = function() {
    var win = this._window;
    var container = this.options.container;
    var passive = {
      passive: false
    };
    if (this._isDragAPI) {
      addEvent2(container, "dragover", this.onDrag, passive);
      addEvent2(win, "dragend", this.onDragEnd);
    }
    if (this._useMouse) {
      addEvent2(container, "mousemove", this.onDrag);
      addEvent2(win, "mouseup", this.onDragEnd);
    }
    if (this._useTouch) {
      addEvent2(container, "touchmove", this.onDrag, passive);
      addEvent2(win, "touchend", this.onDragEnd, passive);
      addEvent2(win, "touchcancel", this.onDragEnd, passive);
    }
  };
  Gesto2.prototype._dettachDragEvent = function() {
    var win = this._window;
    var container = this.options.container;
    if (this._isDragAPI) {
      removeEvent2(container, "dragover", this.onDrag);
      removeEvent2(win, "dragend", this.onDragEnd);
    }
    if (this._useMouse) {
      removeEvent2(container, "mousemove", this.onDrag);
      removeEvent2(win, "mouseup", this.onDragEnd);
    }
    if (this._useTouch) {
      removeEvent2(container, "touchstart", this.onDragStart);
      removeEvent2(container, "touchmove", this.onDrag);
      removeEvent2(win, "touchend", this.onDragEnd);
      removeEvent2(win, "touchcancel", this.onDragEnd);
    }
  };
  Gesto2.prototype._allowMouseEvent = function() {
    this._preventMouseEvent = false;
    clearTimeout(this._preventMouseEventId);
  };
  return Gesto2;
})(event_emitter_esm_default);

// ../../node_modules/framework-utils/dist/utils.esm.js
function prefixNames(prefix3) {
  var classNames186 = [];
  for (var _i = 1; _i < arguments.length; _i++) {
    classNames186[_i - 1] = arguments[_i];
  }
  return classNames186.map(function(className2) {
    return className2.split(" ").map(function(name) {
      return name ? "" + prefix3 + name : "";
    }).join(" ");
  }).join(" ");
}
function prefixCSS(prefix3, css2) {
  return css2.replace(/([^}{]*){/gm, function(_, selector) {
    return selector.replace(/\.([^{,\s\d.]+)/g, "." + prefix3 + "$1") + "{";
  });
}
function ref2(target, name) {
  return function(e3) {
    e3 && (target[name] = e3);
  };
}
function refs(target, name, i) {
  return function(e3) {
    e3 && (target[name][i] = e3);
  };
}
function Properties(properties2, action) {
  return function(component) {
    var prototype = component.prototype;
    properties2.forEach(function(property2) {
      action(prototype, property2);
    });
  };
}
function withMethods(methods2, duplicate) {
  if (duplicate === void 0) {
    duplicate = {};
  }
  return function(prototype, propertyName) {
    methods2.forEach(function(name) {
      var methodName = duplicate[name] || name;
      if (methodName in prototype) {
        return;
      }
      prototype[methodName] = function() {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }
        var result = (_a = this[propertyName])[name].apply(_a, args);
        if (result === this[propertyName]) {
          return this;
        } else {
          return result;
        }
      };
    });
  };
}

// ../../node_modules/@egjs/list-differ/dist/list-differ.esm.js
var PolyMap = /* @__PURE__ */ (function() {
  function PolyMap2() {
    this.keys = [];
    this.values = [];
  }
  var __proto = PolyMap2.prototype;
  __proto.get = function(key2) {
    return this.values[this.keys.indexOf(key2)];
  };
  __proto.set = function(key2, value) {
    var keys4 = this.keys;
    var values = this.values;
    var prevIndex = keys4.indexOf(key2);
    var index3 = prevIndex === -1 ? keys4.length : prevIndex;
    keys4[index3] = key2;
    values[index3] = value;
  };
  return PolyMap2;
})();
var HashMap = /* @__PURE__ */ (function() {
  function HashMap2() {
    this.object = {};
  }
  var __proto = HashMap2.prototype;
  __proto.get = function(key2) {
    return this.object[key2];
  };
  __proto.set = function(key2, value) {
    this.object[key2] = value;
  };
  return HashMap2;
})();
var SUPPORT_MAP = typeof Map === "function";
var Link2 = /* @__PURE__ */ (function() {
  function Link3() {
  }
  var __proto = Link3.prototype;
  __proto.connect = function(prevLink, nextLink) {
    this.prev = prevLink;
    this.next = nextLink;
    prevLink && (prevLink.next = this);
    nextLink && (nextLink.prev = this);
  };
  __proto.disconnect = function() {
    var prevLink = this.prev;
    var nextLink = this.next;
    prevLink && (prevLink.next = nextLink);
    nextLink && (nextLink.prev = prevLink);
  };
  __proto.getIndex = function() {
    var link = this;
    var index3 = -1;
    while (link) {
      link = link.prev;
      ++index3;
    }
    return index3;
  };
  return Link3;
})();
function orderChanged(changed, fixed) {
  var fromLinks = [];
  var toLinks = [];
  changed.forEach(function(_a) {
    var from2 = _a[0], to = _a[1];
    var link = new Link2();
    fromLinks[from2] = link;
    toLinks[to] = link;
  });
  fromLinks.forEach(function(link, i) {
    link.connect(fromLinks[i - 1]);
  });
  return changed.filter(function(_, i) {
    return !fixed[i];
  }).map(function(_a, i) {
    var from2 = _a[0], to = _a[1];
    if (from2 === to) {
      return [0, 0];
    }
    var fromLink = fromLinks[from2];
    var toLink = toLinks[to - 1];
    var fromIndex = fromLink.getIndex();
    fromLink.disconnect();
    if (!toLink) {
      fromLink.connect(void 0, fromLinks[0]);
    } else {
      fromLink.connect(toLink, toLink.next);
    }
    var toIndex = fromLink.getIndex();
    return [fromIndex, toIndex];
  });
}
var Result2 = /* @__PURE__ */ (function() {
  function Result3(prevList, list, added, removed, changed, maintained, changedBeforeAdded, fixed) {
    this.prevList = prevList;
    this.list = list;
    this.added = added;
    this.removed = removed;
    this.changed = changed;
    this.maintained = maintained;
    this.changedBeforeAdded = changedBeforeAdded;
    this.fixed = fixed;
  }
  var __proto = Result3.prototype;
  Object.defineProperty(__proto, "ordered", {
    get: function() {
      if (!this.cacheOrdered) {
        this.caculateOrdered();
      }
      return this.cacheOrdered;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(__proto, "pureChanged", {
    get: function() {
      if (!this.cachePureChanged) {
        this.caculateOrdered();
      }
      return this.cachePureChanged;
    },
    enumerable: true,
    configurable: true
  });
  __proto.caculateOrdered = function() {
    var ordered = orderChanged(this.changedBeforeAdded, this.fixed);
    var changed = this.changed;
    var pureChanged = [];
    this.cacheOrdered = ordered.filter(function(_a, i) {
      var from2 = _a[0], to = _a[1];
      var _b = changed[i], fromBefore = _b[0], toBefore = _b[1];
      if (from2 !== to) {
        pureChanged.push([fromBefore, toBefore]);
        return true;
      }
    });
    this.cachePureChanged = pureChanged;
  };
  return Result3;
})();
function diff(prevList, list, findKeyCallback2) {
  var mapClass = SUPPORT_MAP ? Map : findKeyCallback2 ? HashMap : PolyMap;
  var callback = findKeyCallback2 || function(e3) {
    return e3;
  };
  var added = [];
  var removed = [];
  var maintained = [];
  var prevKeys = prevList.map(callback);
  var keys4 = list.map(callback);
  var prevKeyMap = new mapClass();
  var keyMap2 = new mapClass();
  var changedBeforeAdded = [];
  var fixed = [];
  var removedMap = {};
  var changed = [];
  var addedCount = 0;
  var removedCount = 0;
  prevKeys.forEach(function(key2, prevListIndex) {
    prevKeyMap.set(key2, prevListIndex);
  });
  keys4.forEach(function(key2, listIndex) {
    keyMap2.set(key2, listIndex);
  });
  prevKeys.forEach(function(key2, prevListIndex) {
    var listIndex = keyMap2.get(key2);
    if (typeof listIndex === "undefined") {
      ++removedCount;
      removed.push(prevListIndex);
    } else {
      removedMap[listIndex] = removedCount;
    }
  });
  keys4.forEach(function(key2, listIndex) {
    var prevListIndex = prevKeyMap.get(key2);
    if (typeof prevListIndex === "undefined") {
      added.push(listIndex);
      ++addedCount;
    } else {
      maintained.push([prevListIndex, listIndex]);
      removedCount = removedMap[listIndex] || 0;
      changedBeforeAdded.push([prevListIndex - removedCount, listIndex - addedCount]);
      fixed.push(listIndex === prevListIndex);
      if (prevListIndex !== listIndex) {
        changed.push([prevListIndex, listIndex]);
      }
    }
  });
  removed.reverse();
  return new Result2(prevList, list, added, removed, changed, maintained, changedBeforeAdded, fixed);
}
var ListDiffer = /* @__PURE__ */ (function() {
  function ListDiffer2(list, findKeyCallback2) {
    if (list === void 0) {
      list = [];
    }
    this.findKeyCallback = findKeyCallback2;
    this.list = [].slice.call(list);
  }
  var __proto = ListDiffer2.prototype;
  __proto.update = function(list) {
    var newData = [].slice.call(list);
    var result = diff(this.list, newData, this.findKeyCallback);
    this.list = newData;
    return result;
  };
  return ListDiffer2;
})();
var list_differ_esm_default = ListDiffer;

// ../../node_modules/@egjs/children-differ/dist/children-differ.esm.js
var extendStatics2 = function(d, b) {
  extendStatics2 = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function(d2, b2) {
    d2.__proto__ = b2;
  } || function(d2, b2) {
    for (var p in b2) if (b2.hasOwnProperty(p)) d2[p] = b2[p];
  };
  return extendStatics2(d, b);
};
function __extends2(d, b) {
  extendStatics2(d, b);
  function __() {
    this.constructor = d;
  }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var findKeyCallback = typeof Map === "function" ? void 0 : /* @__PURE__ */ (function() {
  var childrenCount = 0;
  return function(el) {
    return el.__DIFF_KEY__ || (el.__DIFF_KEY__ = ++childrenCount);
  };
})();
var ChildrenDiffer = /* @__PURE__ */ (function(_super) {
  __extends2(ChildrenDiffer2, _super);
  function ChildrenDiffer2(list) {
    if (list === void 0) {
      list = [];
    }
    return _super.call(this, list, findKeyCallback) || this;
  }
  return ChildrenDiffer2;
})(list_differ_esm_default);
function diff2(prevList, list) {
  return diff(prevList, list, findKeyCallback);
}
var children_differ_esm_default = ChildrenDiffer;

// ../../node_modules/@scena/dragscroll/dist/dragscroll.esm.js
var extendStatics3 = function(d, b) {
  extendStatics3 = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function(d2, b2) {
    d2.__proto__ = b2;
  } || function(d2, b2) {
    for (var p in b2) if (b2.hasOwnProperty(p)) d2[p] = b2[p];
  };
  return extendStatics3(d, b);
};
function __extends3(d, b) {
  extendStatics3(d, b);
  function __() {
    this.constructor = d;
  }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign4 = function() {
  __assign4 = Object.assign || function __assign11(t2) {
    for (var s, i = 1, n2 = arguments.length; i < n2; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t2[p] = s[p];
    }
    return t2;
  };
  return __assign4.apply(this, arguments);
};
function getDefaultScrollPosition(e3) {
  var container = e3.container;
  if (container === document.body) {
    return [container.scrollLeft || document.documentElement.scrollLeft, container.scrollTop || document.documentElement.scrollTop];
  }
  return [container.scrollLeft, container.scrollTop];
}
function checkDefaultScrollEvent(container, callback) {
  container.addEventListener("scroll", callback);
  return function() {
    container.removeEventListener("scroll", callback);
  };
}
function getContainerElement(container) {
  if (!container) {
    return null;
  } else if (isString2(container)) {
    return document.querySelector(container);
  }
  if (isFunction5(container)) {
    return container();
  } else if (container instanceof Element) {
    return container;
  } else if ("current" in container) {
    return container.current;
  } else if ("value" in container) {
    return container.value;
  }
}
var DragScroll = /* @__PURE__ */ (function(_super) {
  __extends3(DragScroll2, _super);
  function DragScroll2() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this._startRect = null;
    _this._startPos = [];
    _this._prevTime = 0;
    _this._timer = 0;
    _this._prevScrollPos = [0, 0];
    _this._isWait = false;
    _this._flag = false;
    _this._currentOptions = null;
    _this._lock = false;
    _this._unregister = null;
    _this._onScroll = function() {
      var options = _this._currentOptions;
      if (_this._lock || !options) {
        return;
      }
      _this.emit("scrollDrag", {
        next: function(inputEvent) {
          _this.checkScroll({
            container: options.container,
            inputEvent
          });
        }
      });
    };
    return _this;
  }
  var __proto = DragScroll2.prototype;
  __proto.dragStart = function(e3, options) {
    var container = getContainerElement(options.container);
    if (!container) {
      this._flag = false;
      return;
    }
    var top = 0;
    var left2 = 0;
    var width = 0;
    var height = 0;
    if (container === document.body) {
      width = window.innerWidth;
      height = window.innerHeight;
    } else {
      var rect = container.getBoundingClientRect();
      top = rect.top;
      left2 = rect.left;
      width = rect.width;
      height = rect.height;
    }
    this._flag = true;
    this._startPos = [e3.clientX, e3.clientY];
    this._startRect = {
      top,
      left: left2,
      width,
      height
    };
    this._prevScrollPos = this._getScrollPosition([0, 0], options);
    this._currentOptions = options;
    this._registerScrollEvent(options);
  };
  __proto.drag = function(e3, options) {
    clearTimeout(this._timer);
    if (!this._flag) {
      return;
    }
    var clientX = e3.clientX, clientY = e3.clientY;
    var _a = options.threshold, threshold = _a === void 0 ? 0 : _a;
    var _b = this, _startRect = _b._startRect, _startPos = _b._startPos;
    this._currentOptions = options;
    var direction = [0, 0];
    if (_startRect.top > clientY - threshold) {
      if (_startPos[1] > _startRect.top || clientY < _startPos[1]) {
        direction[1] = -1;
      }
    } else if (_startRect.top + _startRect.height < clientY + threshold) {
      if (_startPos[1] < _startRect.top + _startRect.height || clientY > _startPos[1]) {
        direction[1] = 1;
      }
    }
    if (_startRect.left > clientX - threshold) {
      if (_startPos[0] > _startRect.left || clientX < _startPos[0]) {
        direction[0] = -1;
      }
    } else if (_startRect.left + _startRect.width < clientX + threshold) {
      if (_startPos[0] < _startRect.left + _startRect.width || clientX > _startPos[0]) {
        direction[0] = 1;
      }
    }
    if (!direction[0] && !direction[1]) {
      return false;
    }
    return this._continueDrag(__assign4(__assign4({}, options), {
      direction,
      inputEvent: e3,
      isDrag: true
    }));
  };
  __proto.checkScroll = function(options) {
    var _this = this;
    if (this._isWait) {
      return false;
    }
    var _a = options.prevScrollPos, prevScrollPos = _a === void 0 ? this._prevScrollPos : _a, direction = options.direction, _b = options.throttleTime, throttleTime = _b === void 0 ? 0 : _b, inputEvent = options.inputEvent, isDrag = options.isDrag;
    var nextScrollPos = this._getScrollPosition(direction || [0, 0], options);
    var offsetX = nextScrollPos[0] - prevScrollPos[0];
    var offsetY = nextScrollPos[1] - prevScrollPos[1];
    var nextDirection = direction || [offsetX ? Math.abs(offsetX) / offsetX : 0, offsetY ? Math.abs(offsetY) / offsetY : 0];
    this._prevScrollPos = nextScrollPos;
    this._lock = false;
    if (!offsetX && !offsetY) {
      return false;
    }
    this.emit("move", {
      offsetX: nextDirection[0] ? offsetX : 0,
      offsetY: nextDirection[1] ? offsetY : 0,
      inputEvent
    });
    if (throttleTime && isDrag) {
      clearTimeout(this._timer);
      this._timer = window.setTimeout(function() {
        _this._continueDrag(options);
      }, throttleTime);
    }
    return true;
  };
  __proto.dragEnd = function() {
    this._flag = false;
    this._lock = false;
    clearTimeout(this._timer);
    this._unregisterScrollEvent();
  };
  __proto._getScrollPosition = function(direction, options) {
    var container = options.container, _a = options.getScrollPosition, getScrollPosition2 = _a === void 0 ? getDefaultScrollPosition : _a;
    return getScrollPosition2({
      container: getContainerElement(container),
      direction
    });
  };
  __proto._continueDrag = function(options) {
    var _this = this;
    var _a;
    var container = options.container, direction = options.direction, throttleTime = options.throttleTime, useScroll = options.useScroll, isDrag = options.isDrag, inputEvent = options.inputEvent;
    if (!this._flag || isDrag && this._isWait) {
      return;
    }
    var nowTime = now3();
    var distTime = Math.max(throttleTime + this._prevTime - nowTime, 0);
    if (distTime > 0) {
      clearTimeout(this._timer);
      this._timer = window.setTimeout(function() {
        _this._continueDrag(options);
      }, distTime);
      return false;
    }
    this._prevTime = nowTime;
    var prevScrollPos = this._getScrollPosition(direction, options);
    this._prevScrollPos = prevScrollPos;
    if (isDrag) {
      this._isWait = true;
    }
    if (!useScroll) {
      this._lock = true;
    }
    var param = {
      container: getContainerElement(container),
      direction,
      inputEvent
    };
    (_a = options.requestScroll) === null || _a === void 0 ? void 0 : _a.call(options, param);
    this.emit("scroll", param);
    this._isWait = false;
    return useScroll || this.checkScroll(__assign4(__assign4({}, options), {
      prevScrollPos,
      direction,
      inputEvent
    }));
  };
  __proto._registerScrollEvent = function(options) {
    this._unregisterScrollEvent();
    var checkScrollEvent = options.checkScrollEvent;
    if (!checkScrollEvent) {
      return;
    }
    var callback = checkScrollEvent === true ? checkDefaultScrollEvent : checkScrollEvent;
    var container = getContainerElement(options.container);
    if (checkScrollEvent === true && (container === document.body || container === document.documentElement)) {
      this._unregister = checkDefaultScrollEvent(window, this._onScroll);
    } else {
      this._unregister = callback(container, this._onScroll);
    }
  };
  __proto._unregisterScrollEvent = function() {
    var _a;
    (_a = this._unregister) === null || _a === void 0 ? void 0 : _a.call(this);
    this._unregister = null;
  };
  return DragScroll2;
})(event_emitter_esm_default);
var dragscroll_esm_default = DragScroll;

// ../../node_modules/keycon/dist/keycon.esm.js
var extendStatics4 = function(d, b) {
  extendStatics4 = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function(d2, b2) {
    d2.__proto__ = b2;
  } || function(d2, b2) {
    for (var p in b2) if (Object.prototype.hasOwnProperty.call(b2, p)) d2[p] = b2[p];
  };
  return extendStatics4(d, b);
};
function __extends4(d, b) {
  if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  extendStatics4(d, b);
  function __() {
    this.constructor = d;
  }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
function createCommonjsModule(fn, module2) {
  return module2 = {
    exports: {}
  }, fn(module2, module2.exports), module2.exports;
}
var keycode = createCommonjsModule(function(module2, exports2) {
  function keyCode(searchInput) {
    if (searchInput && "object" === typeof searchInput) {
      var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode;
      if (hasKeyCode) searchInput = hasKeyCode;
    }
    if ("number" === typeof searchInput) return names2[searchInput];
    var search = String(searchInput);
    var foundNamedKey = codes[search.toLowerCase()];
    if (foundNamedKey) return foundNamedKey;
    var foundNamedKey = aliases[search.toLowerCase()];
    if (foundNamedKey) return foundNamedKey;
    if (search.length === 1) return search.charCodeAt(0);
    return void 0;
  }
  keyCode.isEventKey = function isEventKey(event, nameOrCode) {
    if (event && "object" === typeof event) {
      var keyCode2 = event.which || event.keyCode || event.charCode;
      if (keyCode2 === null || keyCode2 === void 0) {
        return false;
      }
      if (typeof nameOrCode === "string") {
        var foundNamedKey = codes[nameOrCode.toLowerCase()];
        if (foundNamedKey) {
          return foundNamedKey === keyCode2;
        }
        var foundNamedKey = aliases[nameOrCode.toLowerCase()];
        if (foundNamedKey) {
          return foundNamedKey === keyCode2;
        }
      } else if (typeof nameOrCode === "number") {
        return nameOrCode === keyCode2;
      }
      return false;
    }
  };
  exports2 = module2.exports = keyCode;
  var codes = exports2.code = exports2.codes = {
    "backspace": 8,
    "tab": 9,
    "enter": 13,
    "shift": 16,
    "ctrl": 17,
    "alt": 18,
    "pause/break": 19,
    "caps lock": 20,
    "esc": 27,
    "space": 32,
    "page up": 33,
    "page down": 34,
    "end": 35,
    "home": 36,
    "left": 37,
    "up": 38,
    "right": 39,
    "down": 40,
    "insert": 45,
    "delete": 46,
    "command": 91,
    "left command": 91,
    "right command": 93,
    "numpad *": 106,
    "numpad +": 107,
    "numpad -": 109,
    "numpad .": 110,
    "numpad /": 111,
    "num lock": 144,
    "scroll lock": 145,
    "my computer": 182,
    "my calculator": 183,
    ";": 186,
    "=": 187,
    ",": 188,
    "-": 189,
    ".": 190,
    "/": 191,
    "`": 192,
    "[": 219,
    "\\": 220,
    "]": 221,
    "'": 222
  };
  var aliases = exports2.aliases = {
    "windows": 91,
    "\u21E7": 16,
    "\u2325": 18,
    "\u2303": 17,
    "\u2318": 91,
    "ctl": 17,
    "control": 17,
    "option": 18,
    "pause": 19,
    "break": 19,
    "caps": 20,
    "return": 13,
    "escape": 27,
    "spc": 32,
    "spacebar": 32,
    "pgup": 33,
    "pgdn": 34,
    "ins": 45,
    "del": 46,
    "cmd": 91
  };
  for (i = 97; i < 123; i++) codes[String.fromCharCode(i)] = i - 32;
  for (var i = 48; i < 58; i++) codes[i - 48] = i;
  for (i = 1; i < 13; i++) codes["f" + i] = i + 111;
  for (i = 0; i < 10; i++) codes["numpad " + i] = i + 96;
  var names2 = exports2.names = exports2.title = {};
  for (i in codes) names2[codes[i]] = i;
  for (var alias in aliases) {
    codes[alias] = aliases[alias];
  }
});
var keycode_1 = keycode.code;
var keycode_2 = keycode.codes;
var keycode_3 = keycode.aliases;
var keycode_4 = keycode.names;
var keycode_5 = keycode.title;
var codeData = {
  "+": "plus",
  "left command": "meta",
  "right command": "meta"
};
var keysSort = {
  shift: 1,
  ctrl: 2,
  alt: 3,
  meta: 4
};
function getKey4(keyCode, keyName) {
  var key2 = (keycode_4[keyCode] || keyName || "").toLowerCase();
  for (var name in codeData) {
    key2 = key2.replace(name, codeData[name]);
  }
  return key2.replace(/\s/g, "");
}
function getCombi(e3, key2) {
  if (key2 === void 0) {
    key2 = getKey4(e3.keyCode, e3.key);
  }
  var keys4 = getModifierCombi(e3);
  keys4.indexOf(key2) === -1 && keys4.push(key2);
  return keys4.filter(Boolean);
}
function getModifierCombi(e3) {
  var keys4 = [e3.shiftKey && "shift", e3.ctrlKey && "ctrl", e3.altKey && "alt", e3.metaKey && "meta"];
  return keys4.filter(Boolean);
}
function getArrangeCombi(keys4) {
  var arrangeKeys = keys4.slice();
  arrangeKeys.sort(function(prev2, next2) {
    var prevScore = keysSort[prev2] || 5;
    var nextScore = keysSort[next2] || 5;
    return prevScore - nextScore;
  });
  return arrangeKeys;
}
var globalKeyController;
var KeyController = /* @__PURE__ */ (function(_super) {
  __extends4(KeyController2, _super);
  function KeyController2(container) {
    if (container === void 0) {
      container = window;
    }
    var _this = _super.call(this) || this;
    _this.container = container;
    _this.ctrlKey = false;
    _this.altKey = false;
    _this.shiftKey = false;
    _this.metaKey = false;
    _this.clear = function() {
      _this.ctrlKey = false;
      _this.altKey = false;
      _this.shiftKey = false;
      _this.metaKey = false;
      return _this;
    };
    _this.keydownEvent = function(e3) {
      _this.triggerEvent("keydown", e3);
    };
    _this.keyupEvent = function(e3) {
      _this.triggerEvent("keyup", e3);
    };
    _this.blur = function() {
      _this.clear();
      _this.trigger("blur");
    };
    addEvent2(container, "blur", _this.blur);
    addEvent2(container, "keydown", _this.keydownEvent);
    addEvent2(container, "keyup", _this.keyupEvent);
    return _this;
  }
  var __proto = KeyController2.prototype;
  Object.defineProperty(KeyController2, "global", {
    /**
     */
    get: function() {
      return globalKeyController || (globalKeyController = new KeyController2());
    },
    enumerable: false,
    configurable: true
  });
  KeyController2.setGlobal = function() {
    return this.global;
  };
  __proto.destroy = function() {
    var container = this.container;
    this.clear();
    this.off();
    removeEvent2(container, "blur", this.blur);
    removeEvent2(container, "keydown", this.keydownEvent);
    removeEvent2(container, "keyup", this.keyupEvent);
  };
  __proto.keydown = function(comb, callback) {
    return this.addEvent("keydown", comb, callback);
  };
  __proto.offKeydown = function(comb, callback) {
    return this.removeEvent("keydown", comb, callback);
  };
  __proto.offKeyup = function(comb, callback) {
    return this.removeEvent("keyup", comb, callback);
  };
  __proto.keyup = function(comb, callback) {
    return this.addEvent("keyup", comb, callback);
  };
  __proto.addEvent = function(type5, comb, callback) {
    if (isArray5(comb)) {
      this.on("".concat(type5, ".").concat(getArrangeCombi(comb).join(".")), callback);
    } else if (isString2(comb)) {
      this.on("".concat(type5, ".").concat(comb), callback);
    } else {
      this.on(type5, comb);
    }
    return this;
  };
  __proto.removeEvent = function(type5, comb, callback) {
    if (isArray5(comb)) {
      this.off("".concat(type5, ".").concat(getArrangeCombi(comb).join(".")), callback);
    } else if (isString2(comb)) {
      this.off("".concat(type5, ".").concat(comb), callback);
    } else {
      this.off(type5, comb);
    }
    return this;
  };
  __proto.triggerEvent = function(type5, e3) {
    this.ctrlKey = e3.ctrlKey;
    this.shiftKey = e3.shiftKey;
    this.altKey = e3.altKey;
    this.metaKey = e3.metaKey;
    var key2 = getKey4(e3.keyCode, e3.key);
    var isToggle = key2 === "ctrl" || key2 === "shift" || key2 === "meta" || key2 === "alt";
    var param = {
      key: key2,
      isToggle,
      inputEvent: e3,
      keyCode: e3.keyCode,
      ctrlKey: e3.ctrlKey,
      altKey: e3.altKey,
      shiftKey: e3.shiftKey,
      metaKey: e3.metaKey
    };
    this.trigger(type5, param);
    this.trigger("".concat(type5, ".").concat(key2), param);
    var combi = getCombi(e3, key2);
    combi.length > 1 && this.trigger("".concat(type5, ".").concat(combi.join(".")), param);
  };
  return KeyController2;
})(event_emitter_esm_default);
var keycon_esm_default = KeyController;

// ../../node_modules/overlap-area/dist/overlap-area.esm.js
function __spreadArrays3() {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r2 = Array(s), k = 0, i = 0; i < il; i++) for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) r2[k] = a[j];
  return r2;
}
function tinyThrottle(num) {
  return throttle3(num, TINY_NUM);
}
function isSameConstants(linearConstants1, linearConstants2) {
  return linearConstants1.every(function(v, i) {
    return tinyThrottle(v - linearConstants2[i]) === 0;
  });
}
function isSamePoint(point1, point2) {
  return !tinyThrottle(point1[0] - point2[0]) && !tinyThrottle(point1[1] - point2[1]);
}
function getAreaSize(points) {
  if (points.length < 3) {
    return 0;
  }
  return Math.abs(sum(points.map(function(point, i) {
    var nextPoint = points[i + 1] || points[0];
    return point[0] * nextPoint[1] - nextPoint[0] * point[1];
  }))) / 2;
}
function fitPoints(points, rect) {
  var width = rect.width, height = rect.height, left2 = rect.left, top = rect.top;
  var _a = getMinMaxs(points), minX = _a.minX, minY = _a.minY, maxX = _a.maxX, maxY = _a.maxY;
  var ratioX = width / (maxX - minX);
  var ratioY = height / (maxY - minY);
  return points.map(function(point) {
    return [left2 + (point[0] - minX) * ratioX, top + (point[1] - minY) * ratioY];
  });
}
function getMinMaxs(points) {
  var xs = points.map(function(point) {
    return point[0];
  });
  var ys = points.map(function(point) {
    return point[1];
  });
  return {
    minX: Math.min.apply(Math, xs),
    minY: Math.min.apply(Math, ys),
    maxX: Math.max.apply(Math, xs),
    maxY: Math.max.apply(Math, ys)
  };
}
function isInside(pos, points, excludeLine) {
  var x = pos[0], y = pos[1];
  var _a = getMinMaxs(points), minX = _a.minX, maxX = _a.maxX;
  var xLine = [[minX, y], [maxX, y]];
  var xLinearConstants = getLinearConstants(xLine[0], xLine[1]);
  var lines = convertLines(points);
  var intersectionPosInfos = [];
  lines.forEach(function(line2) {
    var linearConstants = getLinearConstants(line2[0], line2[1]);
    var standardPoint = line2[0];
    if (isSameConstants(xLinearConstants, linearConstants)) {
      intersectionPosInfos.push({
        pos,
        line: line2,
        type: "line"
      });
    } else {
      var xPoints = getPointsOnLines(getIntersectionPointsByConstants(xLinearConstants, linearConstants), [xLine, line2]);
      xPoints.forEach(function(point) {
        if (line2.some(function(linePoint) {
          return isSamePoint(linePoint, point);
        })) {
          intersectionPosInfos.push({
            pos: point,
            line: line2,
            type: "point"
          });
        } else if (tinyThrottle(standardPoint[1] - y) !== 0) {
          intersectionPosInfos.push({
            pos: point,
            line: line2,
            type: "intersection"
          });
        }
      });
    }
  });
  if (!excludeLine) {
    if (find(intersectionPosInfos, function(p) {
      return p[0] === x;
    })) {
      return true;
    }
  }
  var intersectionCount = 0;
  var xMap = {};
  intersectionPosInfos.forEach(function(_a2) {
    var pos2 = _a2.pos, type5 = _a2.type, line2 = _a2.line;
    if (pos2[0] > x) {
      return;
    }
    if (type5 === "intersection") {
      ++intersectionCount;
    } else if (type5 === "line") {
      return;
    } else if (type5 === "point") {
      var point = find(line2, function(linePoint) {
        return linePoint[1] !== y;
      });
      var prevValue = xMap[pos2[0]];
      var nextValue = point[1] > y ? 1 : -1;
      if (!prevValue) {
        xMap[pos2[0]] = nextValue;
      } else if (prevValue !== nextValue) {
        ++intersectionCount;
      }
    }
  });
  return intersectionCount % 2 === 1;
}
function getLinearConstants(point1, point2) {
  var x1 = point1[0], y1 = point1[1];
  var x2 = point2[0], y2 = point2[1];
  var dx = x2 - x1;
  var dy = y2 - y1;
  if (Math.abs(dx) < TINY_NUM) {
    dx = 0;
  }
  if (Math.abs(dy) < TINY_NUM) {
    dy = 0;
  }
  var a = 0;
  var b = 0;
  var c = 0;
  if (!dx) {
    if (dy) {
      a = -1;
      c = x1;
    }
  } else if (!dy) {
    b = 1;
    c = -y1;
  } else {
    a = -dy / dx;
    b = 1;
    c = -a * x1 - y1;
  }
  return [a, b, c];
}
function getIntersectionPointsByConstants(linearConstants1, linearConstants2) {
  var a1 = linearConstants1[0], b1 = linearConstants1[1], c1 = linearConstants1[2];
  var a2 = linearConstants2[0], b2 = linearConstants2[1], c2 = linearConstants2[2];
  var isZeroA = a1 === 0 && a2 === 0;
  var isZeroB = b1 === 0 && b2 === 0;
  var results = [];
  if (isZeroA && isZeroB) {
    return [];
  } else if (isZeroA) {
    var y1 = -c1 / b1;
    var y2 = -c2 / b2;
    if (y1 !== y2) {
      return [];
    } else {
      return [[-Infinity, y1], [Infinity, y1]];
    }
  } else if (isZeroB) {
    var x1 = -c1 / a1;
    var x2 = -c2 / a2;
    if (x1 !== x2) {
      return [];
    } else {
      return [[x1, -Infinity], [x1, Infinity]];
    }
  } else if (a1 === 0) {
    var y = -c1 / b1;
    var x = -(b2 * y + c2) / a2;
    results = [[x, y]];
  } else if (a2 === 0) {
    var y = -c2 / b2;
    var x = -(b1 * y + c1) / a1;
    results = [[x, y]];
  } else if (b1 === 0) {
    var x = -c1 / a1;
    var y = -(a2 * x + c2) / b2;
    results = [[x, y]];
  } else if (b2 === 0) {
    var x = -c2 / a2;
    var y = -(a1 * x + c1) / b1;
    results = [[x, y]];
  } else {
    var x = (b1 * c2 - b2 * c1) / (b2 * a1 - b1 * a2);
    var y = -(a1 * x + c1) / b1;
    results = [[x, y]];
  }
  return results.map(function(result) {
    return [result[0], result[1]];
  });
}
function getPointsOnLines(points, lines) {
  var minMaxs = lines.map(function(line2) {
    return [0, 1].map(function(order) {
      return [Math.min(line2[0][order], line2[1][order]), Math.max(line2[0][order], line2[1][order])];
    });
  });
  var results = [];
  if (points.length === 2) {
    var _a = points[0], x = _a[0], y = _a[1];
    if (!tinyThrottle(x - points[1][0])) {
      var top = Math.max.apply(Math, minMaxs.map(function(minMax) {
        return minMax[1][0];
      }));
      var bottom = Math.min.apply(Math, minMaxs.map(function(minMax) {
        return minMax[1][1];
      }));
      if (tinyThrottle(top - bottom) > 0) {
        return [];
      }
      results = [[x, top], [x, bottom]];
    } else if (!tinyThrottle(y - points[1][1])) {
      var left2 = Math.max.apply(Math, minMaxs.map(function(minMax) {
        return minMax[0][0];
      }));
      var right2 = Math.min.apply(Math, minMaxs.map(function(minMax) {
        return minMax[0][1];
      }));
      if (tinyThrottle(left2 - right2) > 0) {
        return [];
      }
      results = [[left2, y], [right2, y]];
    }
  }
  if (!results.length) {
    results = points.filter(function(point) {
      var pointX = point[0], pointY = point[1];
      return minMaxs.every(function(minMax) {
        return 0 <= tinyThrottle(pointX - minMax[0][0]) && 0 <= tinyThrottle(minMax[0][1] - pointX) && 0 <= tinyThrottle(pointY - minMax[1][0]) && 0 <= tinyThrottle(minMax[1][1] - pointY);
      });
    });
  }
  return results.map(function(result) {
    return [tinyThrottle(result[0]), tinyThrottle(result[1])];
  });
}
function convertLines(points) {
  return __spreadArrays3(points.slice(1), [points[0]]).map(function(point, i) {
    return [points[i], point];
  });
}
function getOverlapPointInfos(points1, points2) {
  var targetPoints1 = points1.slice();
  var targetPoints2 = points2.slice();
  if (getShapeDirection(targetPoints1) === -1) {
    targetPoints1.reverse();
  }
  if (getShapeDirection(targetPoints2) === -1) {
    targetPoints2.reverse();
  }
  var lines1 = convertLines(targetPoints1);
  var lines2 = convertLines(targetPoints2);
  var linearConstantsList1 = lines1.map(function(line1) {
    return getLinearConstants(line1[0], line1[1]);
  });
  var linearConstantsList2 = lines2.map(function(line2) {
    return getLinearConstants(line2[0], line2[1]);
  });
  var overlapInfos = [];
  linearConstantsList1.forEach(function(linearConstants1, i) {
    var line1 = lines1[i];
    var linePointInfos = [];
    linearConstantsList2.forEach(function(linearConstants2, j) {
      var intersectionPoints = getIntersectionPointsByConstants(linearConstants1, linearConstants2);
      var points = getPointsOnLines(intersectionPoints, [line1, lines2[j]]);
      linePointInfos.push.apply(linePointInfos, points.map(function(pos) {
        return {
          index1: i,
          index2: j,
          pos,
          type: "intersection"
        };
      }));
    });
    linePointInfos.sort(function(a, b) {
      return getDist(line1[0], a.pos) - getDist(line1[0], b.pos);
    });
    overlapInfos.push.apply(overlapInfos, linePointInfos);
    if (isInside(line1[1], targetPoints2)) {
      overlapInfos.push({
        index1: i,
        index2: -1,
        pos: line1[1],
        type: "inside"
      });
    }
  });
  lines2.forEach(function(line2, i) {
    if (!isInside(line2[1], targetPoints1)) {
      return;
    }
    var isNext = false;
    var index3 = findIndex(overlapInfos, function(_a) {
      var index22 = _a.index2;
      if (index22 === i) {
        isNext = true;
        return false;
      }
      if (isNext) {
        return true;
      }
      return false;
    });
    if (index3 === -1) {
      isNext = false;
      index3 = findIndex(overlapInfos, function(_a) {
        var index1 = _a.index1, index22 = _a.index2;
        if (index1 === -1 && index22 + 1 === i) {
          isNext = true;
          return false;
        }
        if (isNext) {
          return true;
        }
        return false;
      });
    }
    if (index3 === -1) {
      overlapInfos.push({
        index1: -1,
        index2: i,
        pos: line2[1],
        type: "inside"
      });
    } else {
      overlapInfos.splice(index3, 0, {
        index1: -1,
        index2: i,
        pos: line2[1],
        type: "inside"
      });
    }
  });
  var pointMap = {};
  return overlapInfos.filter(function(_a) {
    var pos = _a.pos;
    var key2 = pos[0] + "x" + pos[1];
    if (pointMap[key2]) {
      return false;
    }
    pointMap[key2] = true;
    return true;
  });
}
function getOverlapPoints(points1, points2) {
  var infos = getOverlapPointInfos(points1, points2);
  return infos.map(function(_a) {
    var pos = _a.pos;
    return pos;
  });
}
function getOverlapSize(points1, points2) {
  var points = getOverlapPoints(points1, points2);
  return getAreaSize(points);
}

// ../../node_modules/@scena/matrix/dist/matrix.esm.js
function add2(matrix, inverseMatrix, startIndex, fromIndex, n2, k) {
  for (var i = 0; i < n2; ++i) {
    var x = startIndex + i * n2;
    var fromX = fromIndex + i * n2;
    matrix[x] += matrix[fromX] * k;
    inverseMatrix[x] += inverseMatrix[fromX] * k;
  }
}
function swap(matrix, inverseMatrix, startIndex, fromIndex, n2) {
  for (var i = 0; i < n2; ++i) {
    var x = startIndex + i * n2;
    var fromX = fromIndex + i * n2;
    var v = matrix[x];
    var iv = inverseMatrix[x];
    matrix[x] = matrix[fromX];
    matrix[fromX] = v;
    inverseMatrix[x] = inverseMatrix[fromX];
    inverseMatrix[fromX] = iv;
  }
}
function divide(matrix, inverseMatrix, startIndex, n2, k) {
  for (var i = 0; i < n2; ++i) {
    var x = startIndex + i * n2;
    matrix[x] /= k;
    inverseMatrix[x] /= k;
  }
}
function ignoreDimension(matrix, m, n2) {
  if (n2 === void 0) {
    n2 = Math.sqrt(matrix.length);
  }
  var newMatrix = matrix.slice();
  for (var i = 0; i < n2; ++i) {
    newMatrix[i * n2 + m - 1] = 0;
    newMatrix[(m - 1) * n2 + i] = 0;
  }
  newMatrix[(m - 1) * (n2 + 1)] = 1;
  return newMatrix;
}
function invert(matrix, n2) {
  if (n2 === void 0) {
    n2 = Math.sqrt(matrix.length);
  }
  var newMatrix = matrix.slice();
  var inverseMatrix = createIdentityMatrix(n2);
  for (var i = 0; i < n2; ++i) {
    var identityIndex = n2 * i + i;
    if (!throttle3(newMatrix[identityIndex], TINY_NUM)) {
      for (var j = i + 1; j < n2; ++j) {
        if (newMatrix[n2 * i + j]) {
          swap(newMatrix, inverseMatrix, i, j, n2);
          break;
        }
      }
    }
    if (!throttle3(newMatrix[identityIndex], TINY_NUM)) {
      return [];
    }
    divide(newMatrix, inverseMatrix, i, n2, newMatrix[identityIndex]);
    for (var j = 0; j < n2; ++j) {
      var targetStartIndex = j;
      var targetIndex = j + i * n2;
      var target = newMatrix[targetIndex];
      if (!throttle3(target, TINY_NUM) || i === j) {
        continue;
      }
      add2(newMatrix, inverseMatrix, targetStartIndex, i, n2, -target);
    }
  }
  return inverseMatrix;
}
function transpose(matrix, n2) {
  if (n2 === void 0) {
    n2 = Math.sqrt(matrix.length);
  }
  var newMatrix = [];
  for (var i = 0; i < n2; ++i) {
    for (var j = 0; j < n2; ++j) {
      newMatrix[j * n2 + i] = matrix[n2 * i + j];
    }
  }
  return newMatrix;
}
function getOrigin(matrix, n2) {
  if (n2 === void 0) {
    n2 = Math.sqrt(matrix.length);
  }
  var originMatrix = [];
  var w = matrix[n2 * n2 - 1];
  for (var i = 0; i < n2 - 1; ++i) {
    originMatrix[i] = matrix[n2 * (n2 - 1) + i] / w;
  }
  originMatrix[n2 - 1] = 0;
  return originMatrix;
}
function fromTranslation(pos, n2) {
  var newMatrix = createIdentityMatrix(n2);
  for (var i = 0; i < n2 - 1; ++i) {
    newMatrix[n2 * (n2 - 1) + i] = pos[i] || 0;
  }
  return newMatrix;
}
function convertPositionMatrix(matrix, n2) {
  var newMatrix = matrix.slice();
  for (var i = matrix.length; i < n2 - 1; ++i) {
    newMatrix[i] = 0;
  }
  newMatrix[n2 - 1] = 1;
  return newMatrix;
}
function convertDimension(matrix, n2, m) {
  if (n2 === void 0) {
    n2 = Math.sqrt(matrix.length);
  }
  if (n2 === m) {
    return matrix;
  }
  var newMatrix = createIdentityMatrix(m);
  var length2 = Math.min(n2, m);
  for (var i = 0; i < length2 - 1; ++i) {
    for (var j = 0; j < length2 - 1; ++j) {
      newMatrix[i * m + j] = matrix[i * n2 + j];
    }
    newMatrix[(i + 1) * m - 1] = matrix[(i + 1) * n2 - 1];
    newMatrix[(m - 1) * m + i] = matrix[(n2 - 1) * n2 + i];
  }
  newMatrix[m * m - 1] = matrix[n2 * n2 - 1];
  return newMatrix;
}
function multiplies(n2) {
  var matrixes = [];
  for (var _i = 1; _i < arguments.length; _i++) {
    matrixes[_i - 1] = arguments[_i];
  }
  var m = createIdentityMatrix(n2);
  matrixes.forEach(function(matrix) {
    m = multiply(m, matrix, n2);
  });
  return m;
}
function multiply(matrix, matrix2, n2) {
  if (n2 === void 0) {
    n2 = Math.sqrt(matrix.length);
  }
  var newMatrix = [];
  var m = matrix.length / n2;
  var k = matrix2.length / m;
  if (!m) {
    return matrix2;
  } else if (!k) {
    return matrix;
  }
  for (var i = 0; i < n2; ++i) {
    for (var j = 0; j < k; ++j) {
      newMatrix[j * n2 + i] = 0;
      for (var l2 = 0; l2 < m; ++l2) {
        newMatrix[j * n2 + i] += matrix[l2 * n2 + i] * matrix2[j * m + l2];
      }
    }
  }
  return newMatrix;
}
function plus(pos1, pos2) {
  var length2 = Math.min(pos1.length, pos2.length);
  var nextPos = pos1.slice();
  for (var i = 0; i < length2; ++i) {
    nextPos[i] = nextPos[i] + pos2[i];
  }
  return nextPos;
}
function minus(pos1, pos2) {
  var length2 = Math.min(pos1.length, pos2.length);
  var nextPos = pos1.slice();
  for (var i = 0; i < length2; ++i) {
    nextPos[i] = nextPos[i] - pos2[i];
  }
  return nextPos;
}
function convertCSStoMatrix(a, is2d) {
  if (is2d === void 0) {
    is2d = a.length === 6;
  }
  if (is2d) {
    return [a[0], a[1], 0, a[2], a[3], 0, a[4], a[5], 1];
  }
  return a;
}
function convertMatrixtoCSS(a, is2d) {
  if (is2d === void 0) {
    is2d = a.length === 9;
  }
  if (is2d) {
    return [a[0], a[1], a[3], a[4], a[6], a[7]];
  }
  return a;
}
function calculate2(matrix, matrix2, n2) {
  if (n2 === void 0) {
    n2 = matrix2.length;
  }
  var result = multiply(matrix, matrix2, n2);
  var k = result[n2 - 1];
  return result.map(function(v) {
    return v / k;
  });
}
function rotateX3d(matrix, rad) {
  return multiply(matrix, [1, 0, 0, 0, 0, Math.cos(rad), Math.sin(rad), 0, 0, -Math.sin(rad), Math.cos(rad), 0, 0, 0, 0, 1], 4);
}
function rotateY3d(matrix, rad) {
  return multiply(matrix, [Math.cos(rad), 0, -Math.sin(rad), 0, 0, 1, 0, 0, Math.sin(rad), 0, Math.cos(rad), 0, 0, 0, 0, 1], 4);
}
function rotateZ3d(matrix, rad) {
  return multiply(matrix, createRotateMatrix(rad, 4));
}
function scale3d(matrix, _a) {
  var _b = _a[0], sx = _b === void 0 ? 1 : _b, _c = _a[1], sy = _c === void 0 ? 1 : _c, _d = _a[2], sz = _d === void 0 ? 1 : _d;
  return multiply(matrix, [sx, 0, 0, 0, 0, sy, 0, 0, 0, 0, sz, 0, 0, 0, 0, 1], 4);
}
function rotate(pos, rad) {
  return calculate2(createRotateMatrix(rad, 3), convertPositionMatrix(pos, 3));
}
function translate3d(matrix, _a) {
  var _b = _a[0], tx = _b === void 0 ? 0 : _b, _c = _a[1], ty = _c === void 0 ? 0 : _c, _d = _a[2], tz = _d === void 0 ? 0 : _d;
  return multiply(matrix, [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, tx, ty, tz, 1], 4);
}
function matrix3d(matrix1, matrix2) {
  return multiply(matrix1, matrix2, 4);
}
function createRotateMatrix(rad, n2) {
  var cos = Math.cos(rad);
  var sin = Math.sin(rad);
  var m = createIdentityMatrix(n2);
  m[0] = cos;
  m[1] = sin;
  m[n2] = -sin;
  m[n2 + 1] = cos;
  return m;
}
function createIdentityMatrix(n2) {
  var length2 = n2 * n2;
  var matrix = [];
  for (var i = 0; i < length2; ++i) {
    matrix[i] = i % (n2 + 1) ? 0 : 1;
  }
  return matrix;
}
function createScaleMatrix(scale, n2) {
  var m = createIdentityMatrix(n2);
  var length2 = Math.min(scale.length, n2 - 1);
  for (var i = 0; i < length2; ++i) {
    m[(n2 + 1) * i] = scale[i];
  }
  return m;
}
function createOriginMatrix(origin, n2) {
  var m = createIdentityMatrix(n2);
  var length2 = Math.min(origin.length, n2 - 1);
  for (var i = 0; i < length2; ++i) {
    m[n2 * (n2 - 1) + i] = origin[i];
  }
  return m;
}
function createWarpMatrix(pos0, pos1, pos2, pos3, nextPos0, nextPos1, nextPos2, nextPos3) {
  var x0 = pos0[0], y0 = pos0[1];
  var x1 = pos1[0], y1 = pos1[1];
  var x2 = pos2[0], y2 = pos2[1];
  var x3 = pos3[0], y3 = pos3[1];
  var u0 = nextPos0[0], v0 = nextPos0[1];
  var u1 = nextPos1[0], v1 = nextPos1[1];
  var u2 = nextPos2[0], v2 = nextPos2[1];
  var u3 = nextPos3[0], v3 = nextPos3[1];
  var matrix = [x0, 0, x1, 0, x2, 0, x3, 0, y0, 0, y1, 0, y2, 0, y3, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, x0, 0, x1, 0, x2, 0, x3, 0, y0, 0, y1, 0, y2, 0, y3, 0, 1, 0, 1, 0, 1, 0, 1, -u0 * x0, -v0 * x0, -u1 * x1, -v1 * x1, -u2 * x2, -v2 * x2, -u3 * x3, -v3 * x3, -u0 * y0, -v0 * y0, -u1 * y1, -v1 * y1, -u2 * y2, -v2 * y2, -u3 * y3, -v3 * y3];
  var inverseMatrix = invert(matrix, 8);
  if (!inverseMatrix.length) {
    return [];
  }
  var h2 = multiply(inverseMatrix, [u0, v0, u1, v1, u2, v2, u3, v3], 8);
  h2[8] = 1;
  return convertDimension(transpose(h2), 3, 4);
}

// ../../node_modules/css-to-mat/dist/css-to-mat.esm.js
var __assign5 = function() {
  __assign5 = Object.assign || function __assign11(t2) {
    for (var s, i = 1, n2 = arguments.length; i < n2; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t2[p] = s[p];
    }
    return t2;
  };
  return __assign5.apply(this, arguments);
};
function createMatrix() {
  return [
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    1
  ];
}
function parseMat(transform, size) {
  if (size === void 0) {
    size = 0;
  }
  return toMat(parse5(transform, size));
}
function calculateMatrixDist(matrix, pos) {
  var res = calculate2(matrix, [pos[0], pos[1] || 0, pos[2] || 0, 1], 4);
  var w = res[3] || 1;
  return [
    res[0] / w,
    res[1] / w,
    res[2] / w
  ];
}
function getDistElementMatrix(el, container) {
  if (container === void 0) {
    container = document.body;
  }
  var target = el;
  var matrix = createMatrix();
  while (target) {
    var transform = getComputedStyle(target).transform;
    matrix = matrix3d(parseMat(transform), matrix);
    if (target === container) {
      break;
    }
    target = target.parentElement;
  }
  matrix = invert(matrix, 4);
  matrix[12] = 0;
  matrix[13] = 0;
  matrix[14] = 0;
  return matrix;
}
function toMat(matrixInfos) {
  var target = createMatrix();
  matrixInfos.forEach(function(info) {
    var matrixFunction = info.matrixFunction, functionValue = info.functionValue;
    if (!matrixFunction) {
      return;
    }
    target = matrixFunction(target, functionValue);
  });
  return target;
}
function parse5(transform, size) {
  if (size === void 0) {
    size = 0;
  }
  var transforms = isArray5(transform) ? transform : splitSpace(transform);
  return transforms.map(function(t2) {
    var _a = splitBracket(t2), name = _a.prefix, value = _a.value;
    var matrixFunction = null;
    var functionName = name;
    var functionValue = "";
    if (name === "translate" || name === "translateX" || name === "translate3d") {
      var nextSize_1 = isObject5(size) ? __assign5(__assign5({}, size), { "o%": size["%"] }) : {
        "%": size,
        "o%": size
      };
      var _b = splitComma(value).map(function(v, i) {
        if (i === 0 && "x%" in nextSize_1) {
          nextSize_1["%"] = size["x%"];
        } else if (i === 1 && "y%" in nextSize_1) {
          nextSize_1["%"] = size["y%"];
        } else {
          nextSize_1["%"] = size["o%"];
        }
        return convertUnitSize(v, nextSize_1);
      }), posX = _b[0], _c = _b[1], posY = _c === void 0 ? 0 : _c, _d = _b[2], posZ = _d === void 0 ? 0 : _d;
      matrixFunction = translate3d;
      functionValue = [posX, posY, posZ];
    } else if (name === "translateY") {
      var nextSize = isObject5(size) ? __assign5({ "%": size["y%"] }, size) : {
        "%": size
      };
      var posY = convertUnitSize(value, nextSize);
      matrixFunction = translate3d;
      functionValue = [0, posY, 0];
    } else if (name === "translateZ") {
      var posZ = parseFloat(value);
      matrixFunction = translate3d;
      functionValue = [0, 0, posZ];
    } else if (name === "scale" || name === "scale3d") {
      var _e = splitComma(value).map(function(v) {
        return parseFloat(v);
      }), sx = _e[0], _f = _e[1], sy = _f === void 0 ? sx : _f, _g = _e[2], sz = _g === void 0 ? 1 : _g;
      matrixFunction = scale3d;
      functionValue = [sx, sy, sz];
    } else if (name === "scaleX") {
      var sx = parseFloat(value);
      matrixFunction = scale3d;
      functionValue = [sx, 1, 1];
    } else if (name === "scaleY") {
      var sy = parseFloat(value);
      matrixFunction = scale3d;
      functionValue = [1, sy, 1];
    } else if (name === "scaleZ") {
      var sz = parseFloat(value);
      matrixFunction = scale3d;
      functionValue = [1, 1, sz];
    } else if (name === "rotate" || name === "rotateZ" || name === "rotateX" || name === "rotateY") {
      var _h = splitUnit(value), unit3 = _h.unit, unitValue = _h.value;
      var rad = unit3 === "rad" ? unitValue : unitValue * Math.PI / 180;
      if (name === "rotate" || name === "rotateZ") {
        functionName = "rotateZ";
        matrixFunction = rotateZ3d;
      } else if (name === "rotateX") {
        matrixFunction = rotateX3d;
      } else if (name === "rotateY") {
        matrixFunction = rotateY3d;
      }
      functionValue = rad;
    } else if (name === "matrix3d") {
      matrixFunction = matrix3d;
      functionValue = splitComma(value).map(function(v) {
        return parseFloat(v);
      });
    } else if (name === "matrix") {
      var m = splitComma(value).map(function(v) {
        return parseFloat(v);
      });
      matrixFunction = matrix3d;
      functionValue = [
        m[0],
        m[1],
        0,
        0,
        m[2],
        m[3],
        0,
        0,
        0,
        0,
        1,
        0,
        m[4],
        m[5],
        0,
        1
      ];
    } else {
      functionName = "";
    }
    return {
      name,
      functionName,
      value,
      matrixFunction,
      functionValue
    };
  });
}

// ../../node_modules/css-styled/dist/styled.esm.js
function hash(str) {
  var hash2 = 5381, i = str.length;
  while (i) {
    hash2 = hash2 * 33 ^ str.charCodeAt(--i);
  }
  return hash2 >>> 0;
}
var stringHash = hash;
function getHash(str) {
  return stringHash(str).toString(36);
}
function getShadowRoot2(parentElement) {
  if (parentElement && parentElement.getRootNode) {
    var rootNode = parentElement.getRootNode();
    if (rootNode.nodeType === 11) {
      return rootNode;
    }
  }
  return;
}
function replaceStyle(className2, css2, options) {
  if (options.original) {
    return css2;
  }
  return css2.replace(/([^};{\s}][^};{]*|^\s*){/mg, function(_, selector) {
    var trimmedSelector = selector.trim();
    return (trimmedSelector ? splitComma(trimmedSelector) : [""]).map(function(subSelector) {
      var trimmedSubSelector = subSelector.trim();
      if (trimmedSubSelector.indexOf("@") === 0) {
        return trimmedSubSelector;
      } else if (trimmedSubSelector.indexOf(":global") > -1) {
        return trimmedSubSelector.replace(/\:global/g, "");
      } else if (trimmedSubSelector.indexOf(":host") > -1) {
        return "".concat(trimmedSubSelector.replace(/\:host/g, ".".concat(className2)));
      } else if (trimmedSubSelector) {
        return ".".concat(className2, " ").concat(trimmedSubSelector);
      } else {
        return ".".concat(className2);
      }
    }).join(", ") + " {";
  });
}
function injectStyle(className2, css2, options, el, shadowRoot) {
  var doc2 = getDocument3(el);
  var style2 = doc2.createElement("style");
  style2.setAttribute("type", "text/css");
  style2.setAttribute("data-styled-id", className2);
  style2.setAttribute("data-styled-count", "1");
  if (options.nonce) {
    style2.setAttribute("nonce", options.nonce);
  }
  style2.innerHTML = replaceStyle(className2, css2, options);
  (shadowRoot || doc2.head || doc2.body).appendChild(style2);
  return style2;
}
function styled(css2) {
  var injectClassName = "rCS" + getHash(css2);
  return {
    className: injectClassName,
    inject: function(el, options) {
      if (options === void 0) {
        options = {};
      }
      var shadowRoot = getShadowRoot2(el);
      var styleElement = (shadowRoot || el.ownerDocument || document).querySelector('style[data-styled-id="'.concat(injectClassName, '"]'));
      if (!styleElement) {
        styleElement = injectStyle(injectClassName, css2, options, el, shadowRoot);
      } else {
        var count = parseFloat(styleElement.getAttribute("data-styled-count")) || 0;
        styleElement.setAttribute("data-styled-count", "".concat(count + 1));
      }
      return {
        destroy: function() {
          var _a;
          var injectCount = parseFloat(styleElement.getAttribute("data-styled-count")) || 0;
          if (injectCount <= 1) {
            if (styleElement.remove) {
              styleElement.remove();
            } else {
              (_a = styleElement.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(styleElement);
            }
            styleElement = null;
          } else {
            styleElement.setAttribute("data-styled-count", "".concat(injectCount - 1));
          }
        }
      };
    }
  };
}
var styled_esm_default = styled;

// ../../node_modules/selecto/dist/selecto.esm.js
var extendStatics5 = function(d, b) {
  extendStatics5 = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function(d2, b2) {
    d2.__proto__ = b2;
  } || function(d2, b2) {
    for (var p in b2) if (Object.prototype.hasOwnProperty.call(b2, p)) d2[p] = b2[p];
  };
  return extendStatics5(d, b);
};
function __extends5(d, b) {
  if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  extendStatics5(d, b);
  function __() {
    this.constructor = d;
  }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign6 = function() {
  __assign6 = Object.assign || function __assign11(t2) {
    for (var s, i = 1, n2 = arguments.length; i < n2; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t2[p] = s[p];
    }
    return t2;
  };
  return __assign6.apply(this, arguments);
};
function __rest71(s, e3) {
  var t2 = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e3.indexOf(p) < 0) t2[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e3.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t2[p[i]] = s[p[i]];
  }
  return t2;
}
function __decorate2(decorators, target, key2, desc) {
  var c = arguments.length, r2 = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key2) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r2 = Reflect.decorate(decorators, target, key2, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r2 = (c < 3 ? d(r2) : c > 3 ? d(target, key2, r2) : d(target, key2)) || r2;
  return c > 3 && r2 && Object.defineProperty(target, key2, r2), r2;
}
function __spreadArray(to, from2, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l2 = from2.length, ar; i < l2; i++) {
    if (ar || !(i in from2)) {
      if (!ar) ar = Array.prototype.slice.call(from2, 0, i);
      ar[i] = from2[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from2));
}
function getClient2(e3) {
  if ("touches" in e3) {
    var touch = e3.touches[0] || e3.changedTouches[0];
    return {
      clientX: touch.clientX,
      clientY: touch.clientY
    };
  } else {
    return {
      clientX: e3.clientX,
      clientY: e3.clientY
    };
  }
}
function filterDuplicated(arr) {
  if (typeof Map === "undefined") {
    return arr.filter(function(value, index3) {
      return arr.indexOf(value) === index3;
    });
  }
  var map = /* @__PURE__ */ new Map();
  return arr.filter(function(value) {
    if (map.has(value)) {
      return false;
    }
    map.set(value, true);
    return true;
  });
}
function elementFromPoint(baseNode, clientX, clientY) {
  var doc2 = getDocument3(baseNode);
  return doc2.elementFromPoint && doc2.elementFromPoint(clientX, clientY) || null;
}
function createElement323(jsx, prevTarget, container) {
  var tag = jsx.tag, children = jsx.children, attributes2 = jsx.attributes, className2 = jsx.className, style2 = jsx.style;
  var el = prevTarget || getDocument3(container).createElement(tag);
  for (var name in attributes2) {
    el.setAttribute(name, attributes2[name]);
  }
  var elChildren = el.children;
  children.forEach(function(child, i) {
    createElement323(child, elChildren[i], el);
  });
  if (className2) {
    className2.split(/\s+/g).forEach(function(name2) {
      if (name2 && !hasClass(el, name2)) {
        addClass(el, name2);
      }
    });
  }
  if (style2) {
    var elStyle = el.style;
    for (var name in style2) {
      elStyle[name] = style2[name];
    }
  }
  if (!prevTarget && container) {
    container.appendChild(el);
  }
  return el;
}
function h(tag, attrs) {
  var children = [];
  for (var _i = 2; _i < arguments.length; _i++) {
    children[_i - 2] = arguments[_i];
  }
  var _a = attrs || {}, _b = _a.className, className2 = _b === void 0 ? "" : _b, _c = _a.style, style2 = _c === void 0 ? {} : _c, attributes2 = __rest71(_a, ["className", "style"]);
  return {
    tag,
    className: className2,
    style: style2,
    attributes: attributes2,
    children
  };
}
function diffValue(prev2, cur, func) {
  if (prev2 !== cur) {
    func(prev2, cur);
  }
}
function getRect(e3, ratio, boundArea) {
  var _a;
  if (boundArea === void 0) {
    boundArea = e3.data.boundArea;
  }
  var _b = e3.distX, distX = _b === void 0 ? 0 : _b, _c = e3.distY, distY = _c === void 0 ? 0 : _c;
  var _d = e3.data, startX = _d.startX, startY = _d.startY;
  if (ratio > 0) {
    var nextHeight = Math.sqrt((distX * distX + distY * distY) / (1 + ratio * ratio));
    var nextWidth = ratio * nextHeight;
    distX = (distX >= 0 ? 1 : -1) * nextWidth;
    distY = (distY >= 0 ? 1 : -1) * nextHeight;
  }
  var width = Math.abs(distX);
  var height = Math.abs(distY);
  var maxWidth = distX < 0 ? startX - boundArea.left : boundArea.right - startX;
  var maxHeight = distY < 0 ? startY - boundArea.top : boundArea.bottom - startY;
  _a = calculateBoundSize([width, height], [0, 0], [maxWidth, maxHeight], !!ratio), width = _a[0], height = _a[1];
  distX = (distX >= 0 ? 1 : -1) * width;
  distY = (distY >= 0 ? 1 : -1) * height;
  var tx = Math.min(0, distX);
  var ty = Math.min(0, distY);
  var left2 = startX + tx;
  var top = startY + ty;
  return {
    left: left2,
    top,
    right: left2 + width,
    bottom: top + height,
    width,
    height
  };
}
function getDefaultElementRect(el) {
  var rect = el.getBoundingClientRect();
  var left2 = rect.left, top = rect.top, width = rect.width, height = rect.height;
  return {
    pos1: [left2, top],
    pos2: [left2 + width, top],
    pos3: [left2, top + height],
    pos4: [left2 + width, top + height]
  };
}
function passTargets(beforeTargets, afterTargets, continueSelectWithoutDeselect) {
  var _a = diff2(beforeTargets, afterTargets), list = _a.list, prevList = _a.prevList, added = _a.added, removed = _a.removed, maintained = _a.maintained;
  return __spreadArray(__spreadArray(__spreadArray([], added.map(function(index3) {
    return list[index3];
  }), true), removed.map(function(index3) {
    return prevList[index3];
  }), true), continueSelectWithoutDeselect ? maintained.map(function(_a2) {
    var nextIndex2 = _a2[1];
    return list[nextIndex2];
  }) : [], true);
}
function getLineSize(points) {
  var size = 0;
  var length2 = points.length;
  for (var i = 1; i < length2; ++i) {
    size = Math.max(getDist(points[i], points[i - 1]), size);
  }
  return size;
}
var injector = styled_esm_default("\n:host {\n    position: fixed;\n    display: none;\n    border: 1px solid #4af;\n    background: rgba(68, 170, 255, 0.5);\n    pointer-events: none;\n    will-change: transform;\n    z-index: 100;\n}\n");
var CLASS_NAME = "selecto-selection ".concat(injector.className);
var PROPERTIES = ["className", "boundContainer", "selectableTargets", "selectByClick", "selectFromInside", "continueSelect", "continueSelectWithoutDeselect", "toggleContinueSelect", "toggleContinueSelectWithoutDeselect", "keyContainer", "hitRate", "scrollOptions", "checkInput", "preventDefault", "ratio", "getElementRect", "preventDragFromInside", "rootContainer", "dragCondition", "clickBySelectEnd", "checkOverflow", "innerScrollOptions"];
var OPTIONS = __spreadArray([
  // ignore target, container,
  "dragContainer",
  "cspNonce",
  "preventClickEventOnDrag",
  "preventClickEventOnDragStart",
  "preventRightClick"
], PROPERTIES, true);
var EVENTS = ["dragStart", "drag", "dragEnd", "selectStart", "select", "selectEnd", "keydown", "keyup", "scroll", "innerScroll"];
var METHODS = ["clickTarget", "getSelectableElements", "setSelectedTargets", "getElementPoints", "getSelectedTargets", "findSelectableTargets", "triggerDragStart", "checkScroll", "selectTargetsByPoints", "setSelectedTargetsByPoints"];
var Selecto = /* @__PURE__ */ (function(_super) {
  __extends5(Selecto4, _super);
  function Selecto4(options) {
    if (options === void 0) {
      options = {};
    }
    var _this = _super.call(this) || this;
    _this.selectedTargets = [];
    _this.dragScroll = new dragscroll_esm_default();
    _this._onDragStart = function(e3, clickedTarget) {
      var data2 = e3.data, clientX = e3.clientX, clientY = e3.clientY, inputEvent = e3.inputEvent;
      var _a = _this.options, selectFromInside = _a.selectFromInside, selectByClick = _a.selectByClick, rootContainer = _a.rootContainer, boundContainer = _a.boundContainer, _b = _a.preventDragFromInside, preventDragFromInside = _b === void 0 ? true : _b, clickBySelectEnd = _a.clickBySelectEnd, dragCondition = _a.dragCondition;
      if (dragCondition && !dragCondition(e3)) {
        e3.stop();
        return;
      }
      data2.data = {};
      var win = getWindow2(_this.container);
      data2.innerWidth = win.innerWidth;
      data2.innerHeight = win.innerHeight;
      _this.findSelectableTargets(data2);
      data2.startSelectedTargets = _this.selectedTargets;
      data2.scaleMatrix = createMatrix();
      data2.containerX = 0;
      data2.containerY = 0;
      var container2 = _this.container;
      var boundArea = {
        left: -Infinity,
        top: -Infinity,
        right: Infinity,
        bottom: Infinity
      };
      if (rootContainer) {
        var containerRect = _this.container.getBoundingClientRect();
        data2.containerX = containerRect.left;
        data2.containerY = containerRect.top;
        data2.scaleMatrix = getDistElementMatrix(_this.container, rootContainer);
      }
      if (boundContainer) {
        var boundInfo = isObject5(boundContainer) && "element" in boundContainer ? __assign6({
          left: true,
          top: true,
          bottom: true,
          right: true
        }, boundContainer) : {
          element: boundContainer,
          left: true,
          top: true,
          bottom: true,
          right: true
        };
        var boundElement = boundInfo.element;
        var rectElement = void 0;
        if (boundElement) {
          if (isString2(boundElement)) {
            rectElement = getDocument3(container2).querySelector(boundElement);
          } else if (boundElement === true) {
            rectElement = _this.container;
          } else {
            rectElement = boundElement;
          }
          var rect = rectElement.getBoundingClientRect();
          if (boundInfo.left) {
            boundArea.left = rect.left;
          }
          if (boundInfo.top) {
            boundArea.top = rect.top;
          }
          if (boundInfo.right) {
            boundArea.right = rect.right;
          }
          if (boundInfo.bottom) {
            boundArea.bottom = rect.bottom;
          }
        }
      }
      data2.boundArea = boundArea;
      var hitRect = {
        left: clientX,
        top: clientY,
        right: clientX,
        bottom: clientY,
        width: 0,
        height: 0
      };
      var firstPassedTargets = [];
      var allowClickBySelectEnd = selectByClick && !clickBySelectEnd;
      var hasInsideTargets = false;
      if (!selectFromInside || allowClickBySelectEnd) {
        var pointTarget = _this._findElement(
          clickedTarget || inputEvent.target,
          // elementFromPoint(clientX, clientY),
          data2.selectableTargets
        );
        hasInsideTargets = !!pointTarget;
        if (allowClickBySelectEnd) {
          firstPassedTargets = pointTarget ? [pointTarget] : [];
        }
      }
      var isPreventSelect = !selectFromInside && hasInsideTargets;
      if (isPreventSelect && !selectByClick) {
        e3.stop();
        return false;
      }
      var type5 = inputEvent.type;
      var isTrusted = type5 === "mousedown" || type5 === "touchstart";
      var result = !e3.isClick && isTrusted ? _this.emit("dragStart", __assign6(__assign6({}, e3), {
        data: data2.data
      })) : true;
      if (!result) {
        e3.stop();
        return false;
      }
      if (_this.continueSelect) {
        firstPassedTargets = passTargets(_this.selectedTargets, firstPassedTargets, _this.continueSelectWithoutDeselect);
        data2.startPassedTargets = _this.selectedTargets;
      } else {
        data2.startPassedTargets = [];
      }
      _this._select(firstPassedTargets, hitRect, e3, true, isPreventSelect && selectByClick && !clickBySelectEnd && preventDragFromInside);
      data2.startX = clientX;
      data2.startY = clientY;
      data2.selectFlag = false;
      data2.preventDragFromInside = false;
      if (inputEvent.target) {
        var offsetPos = calculateMatrixDist(data2.scaleMatrix, [clientX - data2.containerX, clientY - data2.containerY]);
        _this.target.style.cssText += "position: ".concat(rootContainer ? "absolute" : "fixed", ";") + "left:0px;top:0px;" + "transform: translate(".concat(offsetPos[0], "px, ").concat(offsetPos[1], "px)");
      }
      if (isPreventSelect && selectByClick && !clickBySelectEnd) {
        inputEvent.preventDefault();
        if (preventDragFromInside) {
          _this._selectEnd(data2.startSelectedTargets, data2.startPassedTargets, hitRect, e3, true);
          data2.preventDragFromInside = true;
        }
      } else {
        data2.selectFlag = true;
        var _c = _this.options, scrollOptions = _c.scrollOptions, innerScrollOptions = _c.innerScrollOptions;
        var isInnerScroll = false;
        if (innerScrollOptions) {
          var inputEvent_1 = e3.inputEvent;
          var target = inputEvent_1.target;
          var innerScrollElement = null;
          var parentElement = target;
          while (parentElement && parentElement !== getDocument3(container2).body) {
            var overflow = getComputedStyle(parentElement).overflow !== "visible";
            if (overflow) {
              innerScrollElement = parentElement;
              break;
            }
            parentElement = parentElement.parentElement;
          }
          if (innerScrollElement) {
            data2.innerScrollOptions = __assign6({
              container: innerScrollElement,
              checkScrollEvent: true
            }, innerScrollOptions === true ? {} : innerScrollOptions);
            _this.dragScroll.dragStart(e3, data2.innerScrollOptions);
            isInnerScroll = true;
          }
        }
        if (!isInnerScroll && scrollOptions && scrollOptions.container) {
          _this.dragScroll.dragStart(e3, scrollOptions);
        }
        if (isPreventSelect && selectByClick && clickBySelectEnd) {
          data2.selectFlag = false;
          e3.preventDrag();
        }
      }
      return true;
    };
    _this._onDrag = function(e3) {
      if (e3.data.selectFlag) {
        var scrollOptions = _this.scrollOptions;
        var innerScrollOptions = e3.data.innerScrollOptions;
        var hasScrollOptions = innerScrollOptions || (scrollOptions === null || scrollOptions === void 0 ? void 0 : scrollOptions.container);
        if (hasScrollOptions && !e3.isScroll && _this.dragScroll.drag(e3, innerScrollOptions || scrollOptions)) {
          return;
        }
      }
      _this._checkSelected(e3);
    };
    _this._onDragEnd = function(e3) {
      var data2 = e3.data, inputEvent = e3.inputEvent;
      var rect = getRect(e3, _this.options.ratio);
      var selectFlag = data2.selectFlag;
      var container2 = _this.container;
      if (inputEvent) {
        _this.emit("dragEnd", __assign6(__assign6({
          isDouble: !!e3.isDouble,
          isClick: !!e3.isClick,
          isDrag: false,
          isSelect: selectFlag
        }, e3), {
          data: data2.data,
          rect
        }));
      }
      _this.target.style.cssText += "display: none;";
      if (selectFlag) {
        data2.selectFlag = false;
        _this.dragScroll.dragEnd();
      } else if (_this.selectByClick && _this.clickBySelectEnd) {
        var pointTarget = _this._findElement((inputEvent === null || inputEvent === void 0 ? void 0 : inputEvent.target) || elementFromPoint(container2, e3.clientX, e3.clientY), data2.selectableTargets);
        _this._select(pointTarget ? [pointTarget] : [], rect, e3);
      }
      if (!data2.preventDragFromInside) {
        _this._selectEnd(data2.startSelectedTargets, data2.startPassedTargets, rect, e3);
      }
    };
    _this._onKeyDown = function(e3) {
      var options2 = _this.options;
      var isKeyDown = false;
      if (!_this._keydownContinueSelect) {
        var result = _this._sameCombiKey(e3, options2.toggleContinueSelect);
        _this._keydownContinueSelect = result;
        isKeyDown || (isKeyDown = result);
      }
      if (!_this._keydownContinueSelectWithoutDeselection) {
        var result = _this._sameCombiKey(e3, options2.toggleContinueSelectWithoutDeselect);
        _this._keydownContinueSelectWithoutDeselection = result;
        isKeyDown || (isKeyDown = result);
      }
      if (!isKeyDown) {
        return;
      }
      _this.emit("keydown", {
        keydownContinueSelect: _this._keydownContinueSelect,
        keydownContinueSelectWithoutDeselection: _this._keydownContinueSelectWithoutDeselection
      });
    };
    _this._onKeyUp = function(e3) {
      var options2 = _this.options;
      var isKeyUp = false;
      if (_this._keydownContinueSelect) {
        var result = _this._sameCombiKey(e3, options2.toggleContinueSelect, true);
        _this._keydownContinueSelect = !result;
        isKeyUp || (isKeyUp = result);
      }
      if (_this._keydownContinueSelectWithoutDeselection) {
        var result = _this._sameCombiKey(e3, options2.toggleContinueSelectWithoutDeselect, true);
        _this._keydownContinueSelectWithoutDeselection = !result;
        isKeyUp || (isKeyUp = result);
      }
      if (!isKeyUp) {
        return;
      }
      _this.emit("keyup", {
        keydownContinueSelect: _this._keydownContinueSelect,
        keydownContinueSelectWithoutDeselection: _this._keydownContinueSelectWithoutDeselection
      });
    };
    _this._onBlur = function() {
      if (_this._keydownContinueSelect || _this._keydownContinueSelectWithoutDeselection) {
        _this._keydownContinueSelect = false;
        _this._keydownContinueSelectWithoutDeselection = false;
        _this.emit("keyup", {
          keydownContinueSelect: _this._keydownContinueSelect,
          keydownContinueSelectWithoutDeselection: _this._keydownContinueSelectWithoutDeselection
        });
      }
    };
    _this._onDocumentSelectStart = function(e3) {
      var doc2 = getDocument3(_this.container);
      if (!_this.gesto.isFlag()) {
        return;
      }
      var dragContainer = _this.dragContainer;
      if (dragContainer === getWindow2(_this.container)) {
        dragContainer = doc2.documentElement;
      }
      var containers = isNode2(dragContainer) ? [dragContainer] : [].slice.call(dragContainer);
      var target = e3.target;
      containers.some(function(container2) {
        if (container2 === target || container2.contains(target)) {
          e3.preventDefault();
          return true;
        }
      });
    };
    _this.target = options.portalContainer;
    var container = options.container;
    _this.options = __assign6({
      className: "",
      portalContainer: null,
      container: null,
      dragContainer: null,
      selectableTargets: [],
      selectByClick: true,
      selectFromInside: true,
      clickBySelectEnd: false,
      hitRate: 100,
      continueSelect: false,
      continueSelectWithoutDeselect: false,
      toggleContinueSelect: null,
      toggleContinueSelectWithoutDeselect: null,
      keyContainer: null,
      scrollOptions: null,
      checkInput: false,
      preventDefault: false,
      boundContainer: false,
      preventDragFromInside: true,
      dragCondition: null,
      rootContainer: null,
      checkOverflow: false,
      innerScrollOptions: false,
      getElementRect: getDefaultElementRect,
      cspNonce: "",
      ratio: 0
    }, options);
    var portalContainer = _this.options.portalContainer;
    if (portalContainer) {
      container = portalContainer.parentElement;
    }
    _this.container = container || document.body;
    _this.initElement();
    _this.initDragScroll();
    _this.setKeyController();
    return _this;
  }
  var __proto = Selecto4.prototype;
  __proto.setSelectedTargets = function(selectedTargets) {
    var beforeSelected = this.selectedTargets;
    var _a = diff2(beforeSelected, selectedTargets), added = _a.added, removed = _a.removed, prevList = _a.prevList, list = _a.list;
    this.selectedTargets = selectedTargets;
    return {
      added: added.map(function(index3) {
        return list[index3];
      }),
      removed: removed.map(function(index3) {
        return prevList[index3];
      }),
      beforeSelected,
      selected: selectedTargets
    };
  };
  __proto.setSelectedTargetsByPoints = function(point1, point2) {
    var left2 = Math.min(point1[0], point2[0]);
    var top = Math.min(point1[1], point2[1]);
    var right2 = Math.max(point1[0], point2[0]);
    var bottom = Math.max(point1[1], point2[1]);
    var rect = {
      left: left2,
      top,
      right: right2,
      bottom,
      width: right2 - left2,
      height: bottom - top
    };
    var data2 = {
      ignoreClick: true
    };
    this.findSelectableTargets(data2);
    var selectedElements = this.hitTest(rect, data2, true, null);
    var result = this.setSelectedTargets(selectedElements);
    return __assign6(__assign6({}, result), {
      rect
    });
  };
  __proto.selectTargetsByPoints = function(startPoint, endPoint) {
    var mousedown = new MouseEvent("mousedown", {
      clientX: startPoint[0],
      clientY: startPoint[1],
      cancelable: true,
      bubbles: true
    });
    var mousemove = new MouseEvent("mousemove", {
      clientX: endPoint[0],
      clientY: endPoint[1],
      cancelable: true,
      bubbles: true
    });
    var mouseup = new MouseEvent("mousemove", {
      clientX: endPoint[0],
      clientY: endPoint[1],
      cancelable: true,
      bubbles: true
    });
    var gesto = this.gesto;
    var result = gesto.onDragStart(mousedown);
    if (result !== false) {
      gesto.onDrag(mousemove);
      gesto.onDragEnd(mouseup);
    }
  };
  __proto.getSelectedTargets = function() {
    return this.selectedTargets;
  };
  __proto.triggerDragStart = function(e3) {
    this.gesto.triggerDragStart(e3);
    return this;
  };
  __proto.destroy = function() {
    var _a;
    this.off();
    this.keycon && this.keycon.destroy();
    this.gesto.unset();
    this.injectResult.destroy();
    this.dragScroll.dragEnd();
    removeEvent2(document, "selectstart", this._onDocumentSelectStart);
    if (!this.options.portalContainer) {
      (_a = this.target.parentElement) === null || _a === void 0 ? void 0 : _a.removeChild(this.target);
    }
    this.keycon = null;
    this.gesto = null;
    this.injectResult = null;
    this.target = null;
    this.container = null;
    this.options = null;
  };
  __proto.getElementPoints = function(target) {
    var getElementRect = this.getElementRect || getDefaultElementRect;
    var info = getElementRect(target);
    var points = [info.pos1, info.pos2, info.pos4, info.pos3];
    if (getElementRect !== getDefaultElementRect) {
      var rect = target.getBoundingClientRect();
      return fitPoints(points, rect);
    }
    return points;
  };
  __proto.getSelectableElements = function() {
    var container = this.container;
    var selectableElements = [];
    this.options.selectableTargets.forEach(function(target) {
      if (isFunction5(target)) {
        var result = target();
        if (result) {
          selectableElements.push.apply(selectableElements, [].slice.call(result));
        }
      } else if (isNode2(target)) {
        selectableElements.push(target);
      } else if (isObject5(target)) {
        selectableElements.push(target.value || target.current);
      } else {
        var elements = [].slice.call(getDocument3(container).querySelectorAll(target));
        selectableElements.push.apply(selectableElements, elements);
      }
    });
    return selectableElements;
  };
  __proto.checkScroll = function() {
    if (!this.gesto.isFlag()) {
      return;
    }
    var scrollOptions = this.scrollOptions;
    var innerScrollOptions = this.gesto.getEventData().innerScrollOptions;
    var hasScrollOptions = innerScrollOptions || (scrollOptions === null || scrollOptions === void 0 ? void 0 : scrollOptions.container);
    if (hasScrollOptions) {
      this.dragScroll.checkScroll(__assign6({
        inputEvent: this.gesto.getCurrentEvent()
      }, innerScrollOptions || scrollOptions));
    }
  };
  __proto.findSelectableTargets = function(data2) {
    var _this = this;
    if (data2 === void 0) {
      data2 = this.gesto.getEventData();
    }
    var selectableTargets = this.getSelectableElements();
    var selectablePoints = selectableTargets.map(function(target) {
      return _this.getElementPoints(target);
    });
    data2.selectableTargets = selectableTargets;
    data2.selectablePoints = selectablePoints;
    data2.selectableParentMap = null;
    var options = this.options;
    var hasIndexesMap = options.checkOverflow || options.innerScrollOptions;
    var doc2 = getDocument3(this.container);
    if (hasIndexesMap) {
      var parentMap_1 = /* @__PURE__ */ new Map();
      data2.selectableInnerScrollParentMap = parentMap_1;
      data2.selectableInnerScrollPathsList = selectableTargets.map(function(target, index3) {
        var parentElement = target.parentElement;
        var parents = [];
        var paths = [];
        var _loop_1 = function() {
          var info = parentMap_1.get(parentElement);
          if (!info) {
            var overflow = getComputedStyle(parentElement).overflow !== "visible";
            if (overflow) {
              var rect = getDefaultElementRect(parentElement);
              info = {
                parentElement,
                indexes: [],
                points: [rect.pos1, rect.pos2, rect.pos4, rect.pos3],
                paths: __spreadArray([], paths, true)
              };
              parents.push(parentElement);
              parents.forEach(function(prevParentElement) {
                parentMap_1.set(prevParentElement, info);
              });
              parents = [];
            }
          }
          if (info) {
            parentElement = info.parentElement;
            parentMap_1.get(parentElement).indexes.push(index3);
            paths.push(parentElement);
          } else {
            parents.push(parentElement);
          }
          parentElement = parentElement.parentElement;
        };
        while (parentElement && parentElement !== doc2.body) {
          _loop_1();
        }
        return paths;
      });
    }
    if (!options.checkOverflow) {
      data2.selectableInners = selectableTargets.map(function() {
        return true;
      });
    }
    this._refreshGroups(data2);
    return selectableTargets;
  };
  __proto.clickTarget = function(e3, clickedTarget) {
    var _a = getClient2(e3), clientX = _a.clientX, clientY = _a.clientY;
    var dragEvent = {
      data: {
        selectFlag: false
      },
      clientX,
      clientY,
      inputEvent: e3,
      isClick: true,
      isTrusted: false,
      stop: function() {
        return false;
      }
    };
    if (this._onDragStart(dragEvent, clickedTarget)) {
      this._onDragEnd(dragEvent);
    }
    return this;
  };
  __proto.setKeyController = function() {
    var _a = this.options, keyContainer = _a.keyContainer, toggleContinueSelect = _a.toggleContinueSelect, toggleContinueSelectWithoutDeselect = _a.toggleContinueSelectWithoutDeselect;
    if (this.keycon) {
      this.keycon.destroy();
      this.keycon = null;
    }
    if (toggleContinueSelect || toggleContinueSelectWithoutDeselect) {
      this.keycon = new keycon_esm_default(keyContainer || getWindow2(this.container));
      this.keycon.keydown(this._onKeyDown).keyup(this._onKeyUp).on("blur", this._onBlur);
    }
  };
  __proto.setClassName = function(nextClassName) {
    this.options.className = nextClassName;
    this.target.setAttribute("class", "".concat(CLASS_NAME, " ").concat(nextClassName || ""));
  };
  __proto.setKeyEvent = function() {
    var _a = this.options, toggleContinueSelect = _a.toggleContinueSelect, toggleContinueSelectWithoutDeselect = _a.toggleContinueSelectWithoutDeselect;
    if (!toggleContinueSelect && !toggleContinueSelectWithoutDeselect || this.keycon) {
      return;
    }
    this.setKeyController();
  };
  __proto.setKeyContainer = function(keyContainer) {
    var _this = this;
    var options = this.options;
    diffValue(options.keyContainer, keyContainer, function() {
      options.keyContainer = keyContainer;
      _this.setKeyController();
    });
  };
  __proto.getContinueSelect = function() {
    var _a = this.options, continueSelect = _a.continueSelect, toggleContinueSelect = _a.toggleContinueSelect;
    if (!toggleContinueSelect || !this._keydownContinueSelect) {
      return continueSelect;
    }
    return !continueSelect;
  };
  __proto.getContinueSelectWithoutDeselect = function() {
    var _a = this.options, continueSelectWithoutDeselect = _a.continueSelectWithoutDeselect, toggleContinueSelectWithoutDeselect = _a.toggleContinueSelectWithoutDeselect;
    if (!toggleContinueSelectWithoutDeselect || !this._keydownContinueSelectWithoutDeselection) {
      return continueSelectWithoutDeselect;
    }
    return !continueSelectWithoutDeselect;
  };
  __proto.setToggleContinueSelect = function(toggleContinueSelect) {
    var _this = this;
    var options = this.options;
    diffValue(options.toggleContinueSelect, toggleContinueSelect, function() {
      options.toggleContinueSelect = toggleContinueSelect;
      _this.setKeyEvent();
    });
  };
  __proto.setToggleContinueSelectWithoutDeselect = function(toggleContinueSelectWithoutDeselect) {
    var _this = this;
    var options = this.options;
    diffValue(options.toggleContinueSelectWithoutDeselect, toggleContinueSelectWithoutDeselect, function() {
      options.toggleContinueSelectWithoutDeselect = toggleContinueSelectWithoutDeselect;
      _this.setKeyEvent();
    });
  };
  __proto.setPreventDefault = function(value) {
    this.gesto.options.preventDefault = value;
  };
  __proto.setCheckInput = function(value) {
    this.gesto.options.checkInput = value;
  };
  __proto.initElement = function() {
    var _a = this.options, dragContainer = _a.dragContainer, checkInput = _a.checkInput, preventDefault2 = _a.preventDefault, preventClickEventOnDragStart = _a.preventClickEventOnDragStart, preventClickEventOnDrag = _a.preventClickEventOnDrag, preventClickEventByCondition = _a.preventClickEventByCondition, _b = _a.preventRightClick, preventRightClick = _b === void 0 ? true : _b, className2 = _a.className;
    var container = this.container;
    this.target = createElement323(h("div", {
      className: "".concat(CLASS_NAME, " ").concat(className2 || "")
    }), this.target, container);
    var target = this.target;
    this.dragContainer = typeof dragContainer === "string" ? [].slice.call(getDocument3(container).querySelectorAll(dragContainer)) : dragContainer || this.target.parentNode;
    this.gesto = new Gesto(this.dragContainer, {
      checkWindowBlur: true,
      container: getWindow2(container),
      checkInput,
      preventDefault: preventDefault2,
      preventClickEventOnDragStart,
      preventClickEventOnDrag,
      preventClickEventByCondition,
      preventRightClick
    }).on({
      dragStart: this._onDragStart,
      drag: this._onDrag,
      dragEnd: this._onDragEnd
    });
    addEvent2(document, "selectstart", this._onDocumentSelectStart);
    this.injectResult = injector.inject(target, {
      nonce: this.options.cspNonce
    });
  };
  __proto.hitTest = function(selectRect, data2, isDrag, gestoEvent) {
    var _a = this.options, hitRate = _a.hitRate, selectByClick = _a.selectByClick;
    var left2 = selectRect.left, top = selectRect.top, right2 = selectRect.right, bottom = selectRect.bottom;
    var innerGroups = data2.innerGroups;
    var innerWidth2 = data2.innerWidth;
    var innerHeight2 = data2.innerHeight;
    var clientX = gestoEvent === null || gestoEvent === void 0 ? void 0 : gestoEvent.clientX;
    var clientY = gestoEvent === null || gestoEvent === void 0 ? void 0 : gestoEvent.clientY;
    var ignoreClick = data2.ignoreClick;
    var rectPoints = [[left2, top], [right2, top], [right2, bottom], [left2, bottom]];
    var isHit = function(points, el) {
      var hitRateValue = typeof hitRate === "function" ? splitUnit("".concat(hitRate(el))) : splitUnit("".concat(hitRate));
      var inArea = ignoreClick ? false : isInside([clientX, clientY], points);
      if (!isDrag && selectByClick && inArea) {
        return true;
      }
      var overlapPoints = getOverlapPoints(rectPoints, points);
      if (!overlapPoints.length) {
        return false;
      }
      var overlapSize = getAreaSize(overlapPoints);
      var targetSize = 0;
      if (overlapSize === 0 && getAreaSize(points) === 0) {
        targetSize = getLineSize(points);
        overlapSize = getLineSize(overlapPoints);
      } else {
        targetSize = getAreaSize(points);
      }
      if (hitRateValue.unit === "px") {
        return overlapSize >= hitRateValue.value;
      } else {
        var rate = between(Math.round(overlapSize / targetSize * 100), 0, 100);
        return rate >= Math.min(100, hitRateValue.value);
      }
    };
    var selectableTargets = data2.selectableTargets;
    var selectablePoints = data2.selectablePoints;
    var selectableInners = data2.selectableInners;
    if (!innerGroups) {
      return selectableTargets.filter(function(_, i) {
        if (!selectableInners[i]) {
          return false;
        }
        return isHit(selectablePoints[i], selectableTargets[i]);
      });
    }
    var selectedTargets = [];
    var minX = Math.floor(left2 / innerWidth2);
    var maxX = Math.floor(right2 / innerWidth2);
    var minY = Math.floor(top / innerHeight2);
    var maxY = Math.floor(bottom / innerHeight2);
    for (var x = minX; x <= maxX; ++x) {
      var yGroups = innerGroups[x];
      if (!yGroups) {
        continue;
      }
      for (var y = minY; y <= maxY; ++y) {
        var group = yGroups[y];
        if (!group) {
          continue;
        }
        group.forEach(function(index3) {
          var points = selectablePoints[index3];
          var inner = selectableInners[index3];
          var target = selectableTargets[index3];
          if (inner && isHit(points, target)) {
            selectedTargets.push(target);
          }
        });
      }
    }
    return filterDuplicated(selectedTargets);
  };
  __proto.initDragScroll = function() {
    var _this = this;
    this.dragScroll.on("scrollDrag", function(_a) {
      var next2 = _a.next;
      next2(_this.gesto.getCurrentEvent());
    }).on("scroll", function(_a) {
      var container = _a.container, direction = _a.direction;
      var innerScrollOptions = _this.gesto.getEventData().innerScrollOptions;
      if (innerScrollOptions) {
        _this.emit("innerScroll", {
          container,
          direction
        });
      } else {
        _this.emit("scroll", {
          container,
          direction
        });
      }
    }).on("move", function(_a) {
      var offsetX = _a.offsetX, offsetY = _a.offsetY, inputEvent = _a.inputEvent;
      var gesto = _this.gesto;
      if (!gesto || !gesto.isFlag()) {
        return;
      }
      var data2 = _this.gesto.getEventData();
      var boundArea = data2.boundArea;
      data2.startX -= offsetX;
      data2.startY -= offsetY;
      var innerScrollOptions = _this.gesto.getEventData().innerScrollOptions;
      var container = innerScrollOptions === null || innerScrollOptions === void 0 ? void 0 : innerScrollOptions.container;
      var isMoveInnerScroll = false;
      if (container) {
        var parentMap_2 = data2.selectableInnerScrollParentMap;
        var parentInfo = parentMap_2.get(container);
        if (parentInfo) {
          parentInfo.paths.forEach(function(scrollContainer) {
            var containerInfo = parentMap_2.get(scrollContainer);
            containerInfo.points.forEach(function(pos) {
              pos[0] -= offsetX;
              pos[1] -= offsetY;
            });
          });
          parentInfo.indexes.forEach(function(index3) {
            data2.selectablePoints[index3].forEach(function(pos) {
              pos[0] -= offsetX;
              pos[1] -= offsetY;
            });
          });
          isMoveInnerScroll = true;
        }
      }
      if (!isMoveInnerScroll) {
        data2.selectablePoints.forEach(function(points) {
          points.forEach(function(pos) {
            pos[0] -= offsetX;
            pos[1] -= offsetY;
          });
        });
      }
      _this._refreshGroups(data2);
      boundArea.left -= offsetX;
      boundArea.right -= offsetX;
      boundArea.top -= offsetY;
      boundArea.bottom -= offsetY;
      _this.gesto.scrollBy(offsetX, offsetY, inputEvent.inputEvent);
      _this._checkSelected(_this.gesto.getCurrentEvent());
    });
  };
  __proto._select = function(selectedTargets, rect, e3, isStart, isDragStartEnd) {
    if (isDragStartEnd === void 0) {
      isDragStartEnd = false;
    }
    var inputEvent = e3.inputEvent;
    var data2 = e3.data;
    var result = this.setSelectedTargets(selectedTargets);
    var _a = diff2(data2.startSelectedTargets, selectedTargets), added = _a.added, removed = _a.removed, prevList = _a.prevList, list = _a.list;
    var startResult = {
      startSelected: prevList,
      startAdded: added.map(function(i) {
        return list[i];
      }),
      startRemoved: removed.map(function(i) {
        return prevList[i];
      })
    };
    if (isStart) {
      this.emit("selectStart", __assign6(__assign6(__assign6({}, result), startResult), {
        rect,
        inputEvent,
        data: data2.data,
        isTrusted: e3.isTrusted,
        isDragStartEnd
      }));
    }
    if (result.added.length || result.removed.length) {
      this.emit("select", __assign6(__assign6(__assign6({}, result), startResult), {
        rect,
        inputEvent,
        data: data2.data,
        isTrusted: e3.isTrusted,
        isDragStartEnd
      }));
    }
  };
  __proto._selectEnd = function(startSelectedTargets, startPassedTargets, rect, e3, isDragStartEnd) {
    if (isDragStartEnd === void 0) {
      isDragStartEnd = false;
    }
    var inputEvent = e3.inputEvent, isDouble = e3.isDouble, data2 = e3.data;
    var type5 = inputEvent && inputEvent.type;
    var isDragStart = type5 === "mousedown" || type5 === "touchstart";
    var _a = diff2(startSelectedTargets, this.selectedTargets), added = _a.added, removed = _a.removed, prevList = _a.prevList, list = _a.list;
    var _b = diff2(startPassedTargets, this.selectedTargets), afterAdded = _b.added, afterRemoved = _b.removed, afterPrevList = _b.prevList, afterList = _b.list;
    this.emit("selectEnd", {
      startSelected: startSelectedTargets,
      beforeSelected: startPassedTargets,
      selected: this.selectedTargets,
      added: added.map(function(index3) {
        return list[index3];
      }),
      removed: removed.map(function(index3) {
        return prevList[index3];
      }),
      afterAdded: afterAdded.map(function(index3) {
        return afterList[index3];
      }),
      afterRemoved: afterRemoved.map(function(index3) {
        return afterPrevList[index3];
      }),
      isDragStart: isDragStart && isDragStartEnd,
      isDragStartEnd: isDragStart && isDragStartEnd,
      isClick: !!e3.isClick,
      isDouble: !!isDouble,
      rect,
      inputEvent,
      data: data2.data,
      isTrusted: e3.isTrusted
    });
  };
  __proto._checkSelected = function(e3, rect) {
    if (rect === void 0) {
      rect = getRect(e3, this.options.ratio);
    }
    var data2 = e3.data;
    var top = rect.top, left2 = rect.left, width = rect.width, height = rect.height;
    var selectFlag = data2.selectFlag;
    var containerX = data2.containerX, containerY = data2.containerY, scaleMatrix2 = data2.scaleMatrix;
    var offsetPos = calculateMatrixDist(scaleMatrix2, [left2 - containerX, top - containerY]);
    var offsetSize = calculateMatrixDist(scaleMatrix2, [width, height]);
    var selectedTargets = [];
    if (selectFlag) {
      this.target.style.cssText += "display: block;left:0px;top:0px;" + "transform: translate(".concat(offsetPos[0], "px, ").concat(offsetPos[1], "px);") + "width:".concat(offsetSize[0], "px;height:").concat(offsetSize[1], "px;");
      var passedTargets = this.hitTest(rect, data2, true, e3);
      selectedTargets = passTargets(data2.startPassedTargets, passedTargets, this.continueSelect && this.continueSelectWithoutDeselect);
    }
    var result = this.emit("drag", __assign6(__assign6({}, e3), {
      data: data2.data,
      isSelect: selectFlag,
      rect
    }));
    if (result === false) {
      this.target.style.cssText += "display: none;";
      e3.stop();
      return;
    }
    if (selectFlag) {
      this._select(selectedTargets, rect, e3);
    }
  };
  __proto._sameCombiKey = function(e3, keys4, isKeyup) {
    if (!keys4) {
      return false;
    }
    var combi = getCombi(e3.inputEvent, e3.key);
    var nextKeys = [].concat(keys4);
    var toggleKeys = isArray5(nextKeys[0]) ? nextKeys : [nextKeys];
    if (isKeyup) {
      var singleKey_1 = e3.key;
      return toggleKeys.some(function(keys5) {
        return keys5.some(function(key2) {
          return key2 === singleKey_1;
        });
      });
    }
    return toggleKeys.some(function(keys5) {
      return keys5.every(function(key2) {
        return combi.indexOf(key2) > -1;
      });
    });
  };
  __proto._findElement = function(clickedTarget, selectableTargets) {
    var pointTarget = clickedTarget;
    while (pointTarget) {
      if (selectableTargets.indexOf(pointTarget) > -1) {
        break;
      }
      pointTarget = pointTarget.parentElement;
    }
    return pointTarget;
  };
  __proto._refreshGroups = function(data2) {
    var _a;
    var innerWidth2 = data2.innerWidth;
    var innerHeight2 = data2.innerHeight;
    var selectablePoints = data2.selectablePoints;
    if (this.options.checkOverflow) {
      var innerScrollContainer_1 = (_a = this.gesto.getEventData().innerScrollOptions) === null || _a === void 0 ? void 0 : _a.container;
      var parentMap_3 = data2.selectableInnerScrollParentMap;
      var innerScrollPathsList = data2.selectableInnerScrollPathsList;
      data2.selectableInners = innerScrollPathsList.map(function(innerScrollPaths, i) {
        var isAlwaysTrue = false;
        return innerScrollPaths.every(function(target) {
          if (isAlwaysTrue) {
            return true;
          }
          if (target === innerScrollContainer_1) {
            isAlwaysTrue = true;
            return true;
          }
          var rect = parentMap_3.get(target);
          if (rect) {
            var points1 = selectablePoints[i];
            var points2 = rect.points;
            var overlapPoints = getOverlapPoints(points1, points2);
            if (!overlapPoints.length) {
              return false;
            }
          }
          return true;
        });
      });
    }
    if (!innerWidth2 || !innerHeight2) {
      data2.innerGroups = null;
    } else {
      var selectablePoints_1 = data2.selectablePoints;
      var groups_1 = {};
      selectablePoints_1.forEach(function(points, i) {
        var minX = Infinity;
        var maxX = -Infinity;
        var minY = Infinity;
        var maxY = -Infinity;
        points.forEach(function(pos) {
          var x2 = Math.floor(pos[0] / innerWidth2);
          var y2 = Math.floor(pos[1] / innerHeight2);
          minX = Math.min(x2, minX);
          maxX = Math.max(x2, maxX);
          minY = Math.min(y2, minY);
          maxY = Math.max(y2, maxY);
        });
        for (var x = minX; x <= maxX; ++x) {
          for (var y = minY; y <= maxY; ++y) {
            groups_1[x] = groups_1[x] || {};
            groups_1[x][y] = groups_1[x][y] || [];
            groups_1[x][y].push(i);
          }
        }
      });
      data2.innerGroups = groups_1;
    }
  };
  Selecto4 = __decorate2([Properties(PROPERTIES, function(prototype, property2) {
    var attributes2 = {
      enumerable: true,
      configurable: true,
      get: function() {
        return this.options[property2];
      }
    };
    var getter = camelize("get ".concat(property2));
    if (prototype[getter]) {
      attributes2.get = function() {
        return this[getter]();
      };
    } else {
      attributes2.get = function() {
        return this.options[property2];
      };
    }
    var setter = camelize("set ".concat(property2));
    if (prototype[setter]) {
      attributes2.set = function(value) {
        this[setter](value);
      };
    } else {
      attributes2.set = function(value) {
        this.options[property2] = value;
      };
    }
    Object.defineProperty(prototype, property2, attributes2);
  })], Selecto4);
  return Selecto4;
})(event_emitter_esm_default);
var Selecto$1 = /* @__PURE__ */ (function(_super) {
  __extends5(Selecto4, _super);
  function Selecto4() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  return Selecto4;
})(Selecto);
var selecto_esm_default = Selecto$1;

// ../../node_modules/react-selecto/dist/selecto.esm.js
var extendStatics6 = function(d, b) {
  extendStatics6 = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function(d2, b2) {
    d2.__proto__ = b2;
  } || function(d2, b2) {
    for (var p in b2) if (Object.prototype.hasOwnProperty.call(b2, p)) d2[p] = b2[p];
  };
  return extendStatics6(d, b);
};
function __extends6(d, b) {
  if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  extendStatics6(d, b);
  function __() {
    this.constructor = d;
  }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign7 = function() {
  __assign7 = Object.assign || function __assign11(t2) {
    for (var s, i = 1, n2 = arguments.length; i < n2; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t2[p] = s[p];
    }
    return t2;
  };
  return __assign7.apply(this, arguments);
};
function __decorate3(decorators, target, key2, desc) {
  var c = arguments.length, r2 = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key2) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r2 = Reflect.decorate(decorators, target, key2, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r2 = (c < 3 ? d(r2) : c > 3 ? d(target, key2, r2) : d(target, key2)) || r2;
  return c > 3 && r2 && Object.defineProperty(target, key2, r2), r2;
}
var REACT_EVENTS = EVENTS.map(function(name) {
  return camelize("on ".concat(name));
});
var Selecto2 = /* @__PURE__ */ (function(_super) {
  __extends6(Selecto4, _super);
  function Selecto4() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  var __proto = Selecto4.prototype;
  __proto.render = function() {
    return (0, import_react230.createElement)("div", {
      className: CLASS_NAME,
      ref: ref2(this, "selectionElement")
    });
  };
  __proto.componentDidMount = function() {
    var _this = this;
    var props = this.props;
    var options = {};
    OPTIONS.forEach(function(name) {
      if (name in props) {
        options[name] = props[name];
      }
    });
    this.selecto = new selecto_esm_default(__assign7(__assign7({}, options), {
      portalContainer: this.selectionElement
    }));
    EVENTS.forEach(function(name, i) {
      _this.selecto.on(name, function(e3) {
        var selfProps = _this.props;
        var result = selfProps[REACT_EVENTS[i]] && selfProps[REACT_EVENTS[i]](e3);
        if (result === false) {
          e3.stop();
        }
      });
    });
  };
  __proto.componentDidUpdate = function(prevProps) {
    var props = this.props;
    var selecto = this.selecto;
    PROPERTIES.forEach(function(name) {
      if (prevProps[name] !== props[name]) {
        selecto[name] = props[name];
      }
    });
  };
  __proto.componentWillUnmount = function() {
    this.selecto.destroy();
  };
  __decorate3([withMethods(METHODS)], Selecto4.prototype, "selecto", void 0);
  return Selecto4;
})(import_react230.PureComponent);
var selecto_esm_default2 = Selecto2;

// src/components/Designer/Canvas/Selecto.tsx
var className = "pdfme-selecto";
var Selecto3 = (props) => {
  const { token: token2 } = theme_default3.useToken();
  (0, import_react231.useEffect)(() => {
    const containerElement = document.querySelector("." + className);
    if (containerElement instanceof HTMLElement) {
      containerElement.style.backgroundColor = token2.colorPrimary;
      containerElement.style.opacity = "0.75";
      containerElement.style.borderColor = token2.colorPrimaryBorder;
    }
  }, [props.container, token2.colorPrimary, token2.colorPrimaryBorder]);
  return /* @__PURE__ */ import_react231.default.createElement(
    selecto_esm_default2,
    {
      className,
      selectFromInside: false,
      selectByClick: true,
      preventDefault: true,
      hitRate: 0,
      selectableTargets: [`.${SELECTABLE_CLASSNAME}`],
      container: props.container,
      continueSelect: props.continueSelect,
      onDragStart: props.onDragStart,
      onSelect: props.onSelect
    }
  );
};
var Selecto_default = Selecto3;

// src/components/Designer/Canvas/Moveable.tsx
var import_react234 = __toESM(require_react());

// ../../node_modules/@egjs/agent/dist/agent.esm.js
function some2(arr, callback) {
  var length2 = arr.length;
  for (var i = 0; i < length2; ++i) {
    if (callback(arr[i], i)) {
      return true;
    }
  }
  return false;
}
function find2(arr, callback) {
  var length2 = arr.length;
  for (var i = 0; i < length2; ++i) {
    if (callback(arr[i], i)) {
      return arr[i];
    }
  }
  return null;
}
function getUserAgentString(agent3) {
  var userAgent = agent3;
  if (typeof userAgent === "undefined") {
    if (typeof navigator === "undefined" || !navigator) {
      return "";
    }
    userAgent = navigator.userAgent || "";
  }
  return userAgent.toLowerCase();
}
function execRegExp(pattern6, text) {
  try {
    return new RegExp(pattern6, "g").exec(text);
  } catch (e3) {
    return null;
  }
}
function hasUserAgentData() {
  if (typeof navigator === "undefined" || !navigator || !navigator.userAgentData) {
    return false;
  }
  var userAgentData = navigator.userAgentData;
  var brands = userAgentData.brands || userAgentData.uaList;
  return !!(brands && brands.length);
}
function findVersion(versionTest, userAgent) {
  var result = execRegExp("(" + versionTest + ")((?:\\/|\\s|:)([0-9|\\.|_]+))", userAgent);
  return result ? result[3] : "";
}
function convertVersion(text) {
  return text.replace(/_/g, ".");
}
function findPreset(presets, userAgent) {
  var userPreset = null;
  var version7 = "-1";
  some2(presets, function(preset) {
    var result = execRegExp("(" + preset.test + ")((?:\\/|\\s|:)([0-9|\\.|_]+))?", userAgent);
    if (!result || preset.brand) {
      return false;
    }
    userPreset = preset;
    version7 = result[3] || "-1";
    if (preset.versionAlias) {
      version7 = preset.versionAlias;
    } else if (preset.versionTest) {
      version7 = findVersion(preset.versionTest.toLowerCase(), userAgent) || version7;
    }
    version7 = convertVersion(version7);
    return true;
  });
  return {
    preset: userPreset,
    version: version7
  };
}
function findPresetBrand(presets, brands) {
  var brandInfo = {
    brand: "",
    version: "-1"
  };
  some2(presets, function(preset) {
    var result = findBrand(brands, preset);
    if (!result) {
      return false;
    }
    brandInfo.brand = preset.id;
    brandInfo.version = preset.versionAlias || result.version;
    return brandInfo.version !== "-1";
  });
  return brandInfo;
}
function findBrand(brands, preset) {
  return find2(brands, function(_a) {
    var brand = _a.brand;
    return execRegExp("" + preset.test, brand.toLowerCase());
  });
}
var BROWSER_PRESETS = [{
  test: "phantomjs",
  id: "phantomjs"
}, {
  test: "whale",
  id: "whale"
}, {
  test: "edgios|edge|edg",
  id: "edge"
}, {
  test: "msie|trident|windows phone",
  id: "ie",
  versionTest: "iemobile|msie|rv"
}, {
  test: "miuibrowser",
  id: "miui browser"
}, {
  test: "samsungbrowser",
  id: "samsung internet"
}, {
  test: "samsung",
  id: "samsung internet",
  versionTest: "version"
}, {
  test: "chrome|crios",
  id: "chrome"
}, {
  test: "firefox|fxios",
  id: "firefox"
}, {
  test: "android",
  id: "android browser",
  versionTest: "version"
}, {
  test: "safari|iphone|ipad|ipod",
  id: "safari",
  versionTest: "version"
}];
var CHROMIUM_PRESETS = [{
  test: "(?=.*applewebkit/(53[0-7]|5[0-2]|[0-4]))(?=.*\\schrome)",
  id: "chrome",
  versionTest: "chrome"
}, {
  test: "chromium",
  id: "chrome"
}, {
  test: "whale",
  id: "chrome",
  versionAlias: "-1",
  brand: true
}];
var WEBKIT_PRESETS = [{
  test: "applewebkit",
  id: "webkit",
  versionTest: "applewebkit|safari"
}];
var WEBVIEW_PRESETS = [{
  test: "(?=(iphone|ipad))(?!(.*version))",
  id: "webview"
}, {
  test: "(?=(android|iphone|ipad))(?=.*(naver|daum|; wv))",
  id: "webview"
}, {
  // test webview
  test: "webview",
  id: "webview"
}];
var OS_PRESETS = [{
  test: "windows phone",
  id: "windows phone"
}, {
  test: "windows 2000",
  id: "window",
  versionAlias: "5.0"
}, {
  test: "windows nt",
  id: "window"
}, {
  test: "win32|windows",
  id: "window"
}, {
  test: "iphone|ipad|ipod",
  id: "ios",
  versionTest: "iphone os|cpu os"
}, {
  test: "macos|macintel|mac os x",
  id: "mac"
}, {
  test: "android|linux armv81",
  id: "android"
}, {
  test: "tizen",
  id: "tizen"
}, {
  test: "webos|web0s",
  id: "webos"
}];
function isWebView(userAgent) {
  return !!findPreset(WEBVIEW_PRESETS, userAgent).preset;
}
function getLegacyAgent(userAgent) {
  var nextAgent = getUserAgentString(userAgent);
  var isMobile = !!/mobi/g.exec(nextAgent);
  var browser = {
    name: "unknown",
    version: "-1",
    majorVersion: -1,
    webview: isWebView(nextAgent),
    chromium: false,
    chromiumVersion: "-1",
    webkit: false,
    webkitVersion: "-1"
  };
  var os = {
    name: "unknown",
    version: "-1",
    majorVersion: -1
  };
  var _a = findPreset(BROWSER_PRESETS, nextAgent), browserPreset = _a.preset, browserVersion2 = _a.version;
  var _b = findPreset(OS_PRESETS, nextAgent), osPreset = _b.preset, osVersion = _b.version;
  var chromiumPreset = findPreset(CHROMIUM_PRESETS, nextAgent);
  browser.chromium = !!chromiumPreset.preset;
  browser.chromiumVersion = chromiumPreset.version;
  if (!browser.chromium) {
    var webkitPreset = findPreset(WEBKIT_PRESETS, nextAgent);
    browser.webkit = !!webkitPreset.preset;
    browser.webkitVersion = webkitPreset.version;
  }
  if (osPreset) {
    os.name = osPreset.id;
    os.version = osVersion;
    os.majorVersion = parseInt(osVersion, 10);
  }
  if (browserPreset) {
    browser.name = browserPreset.id;
    browser.version = browserVersion2;
    if (browser.webview && os.name === "ios" && browser.name !== "safari") {
      browser.webview = false;
    }
  }
  browser.majorVersion = parseInt(browser.version, 10);
  return {
    browser,
    os,
    isMobile,
    isHints: false
  };
}
function getClientHintsAgent(osData) {
  var userAgentData = navigator.userAgentData;
  var brands = (userAgentData.uaList || userAgentData.brands).slice();
  var fullVersionList = osData && osData.fullVersionList;
  var isMobile = userAgentData.mobile || false;
  var firstBrand = brands[0];
  var platform = (osData && osData.platform || userAgentData.platform || navigator.platform).toLowerCase();
  var browser = {
    name: firstBrand.brand,
    version: firstBrand.version,
    majorVersion: -1,
    webkit: false,
    webkitVersion: "-1",
    chromium: false,
    chromiumVersion: "-1",
    webview: !!findPresetBrand(WEBVIEW_PRESETS, brands).brand || isWebView(getUserAgentString())
  };
  var os = {
    name: "unknown",
    version: "-1",
    majorVersion: -1
  };
  browser.webkit = !browser.chromium && some2(WEBKIT_PRESETS, function(preset) {
    return findBrand(brands, preset);
  });
  var chromiumBrand = findPresetBrand(CHROMIUM_PRESETS, brands);
  browser.chromium = !!chromiumBrand.brand;
  browser.chromiumVersion = chromiumBrand.version || "-1";
  if (!browser.chromium) {
    var webkitBrand = findPresetBrand(WEBKIT_PRESETS, brands);
    browser.webkit = !!webkitBrand.brand;
    browser.webkitVersion = webkitBrand.version || "-1";
  }
  var platfomResult = find2(OS_PRESETS, function(preset) {
    return new RegExp("" + preset.test, "g").exec(platform);
  });
  os.name = platfomResult ? platfomResult.id : "";
  if (osData) {
    os.version = osData.platformVersion || "-1";
  }
  if (fullVersionList && fullVersionList.length) {
    var browserBrandByFullVersionList = findPresetBrand(BROWSER_PRESETS, fullVersionList);
    browser.name = browserBrandByFullVersionList.brand || browser.name;
    browser.version = browserBrandByFullVersionList.version || browser.version;
  } else {
    var browserBrand = findPresetBrand(BROWSER_PRESETS, brands);
    browser.name = browserBrand.brand || browser.name;
    browser.version = browserBrand.brand && osData ? osData.uaFullVersion : browserBrand.version;
  }
  if (browser.webkit) {
    os.name = isMobile ? "ios" : "mac";
  }
  if (os.name === "ios" && browser.webview) {
    browser.version = "-1";
  }
  os.version = convertVersion(os.version);
  browser.version = convertVersion(browser.version);
  os.majorVersion = parseInt(os.version, 10);
  browser.majorVersion = parseInt(browser.version, 10);
  return {
    browser,
    os,
    isMobile,
    isHints: true
  };
}
function agent(userAgent) {
  if (typeof userAgent === "undefined" && hasUserAgentData()) {
    return getClientHintsAgent();
  } else {
    return getLegacyAgent(userAgent);
  }
}
var agent_esm_default = agent;

// ../../node_modules/react-moveable/dist/moveable.esm.js
var React597 = __toESM(require_react());
var import_react233 = __toESM(require_react());

// ../../node_modules/react-css-styled/dist/styled.esm.js
var import_react232 = __toESM(require_react());
var __assign8 = function() {
  __assign8 = Object.assign || function __assign11(t2) {
    for (var s, i = 1, n2 = arguments.length; i < n2; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t2[p] = s[p];
    }
    return t2;
  };
  return __assign8.apply(this, arguments);
};
function __rest72(s, e3) {
  var t2 = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e3.indexOf(p) < 0) t2[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e3.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t2[p[i]] = s[p[i]];
  }
  return t2;
}
function styled2(Tag, css2) {
  var injector2 = styled_esm_default(css2);
  var cssId = injector2.className;
  return (0, import_react232.forwardRef)(function(props, ref3) {
    var _a = props.className, className2 = _a === void 0 ? "" : _a, cspNonce = props.cspNonce, attributes2 = __rest72(props, ["className", "cspNonce"]);
    var targetRef = (0, import_react232.useRef)();
    (0, import_react232.useImperativeHandle)(ref3, function() {
      return targetRef.current;
    }, []);
    (0, import_react232.useEffect)(function() {
      var injectResult = injector2.inject(targetRef.current, {
        nonce: props.cspNonce
      });
      return function() {
        injectResult.destroy();
      };
    }, []);
    return (0, import_react232.createElement)(Tag, __assign8({
      "ref": targetRef,
      "data-styled-id": cssId,
      "className": "".concat(className2, " ").concat(cssId)
    }, attributes2));
  });
}

// ../../node_modules/react-moveable/dist/moveable.esm.js
var extendStatics7 = function(d, b) {
  extendStatics7 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
    d2.__proto__ = b2;
  } || function(d2, b2) {
    for (var p in b2) if (Object.prototype.hasOwnProperty.call(b2, p)) d2[p] = b2[p];
  };
  return extendStatics7(d, b);
};
function __extends7(d, b) {
  if (typeof b !== "function" && b !== null)
    throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  extendStatics7(d, b);
  function __() {
    this.constructor = d;
  }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign9 = function() {
  __assign9 = Object.assign || function __assign11(t2) {
    for (var s, i = 1, n2 = arguments.length; i < n2; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t2[p] = s[p];
    }
    return t2;
  };
  return __assign9.apply(this, arguments);
};
function __rest73(s, e3) {
  var t2 = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e3.indexOf(p) < 0)
    t2[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
      if (e3.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
        t2[p[i]] = s[p[i]];
    }
  return t2;
}
function __decorate4(decorators, target, key2, desc) {
  var c = arguments.length, r2 = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key2) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r2 = Reflect.decorate(decorators, target, key2, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r2 = (c < 3 ? d(r2) : c > 3 ? d(target, key2, r2) : d(target, key2)) || r2;
  return c > 3 && r2 && Object.defineProperty(target, key2, r2), r2;
}
function __values(o3) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o3[s], i = 0;
  if (m) return m.call(o3);
  if (o3 && typeof o3.length === "number") return {
    next: function() {
      if (o3 && i >= o3.length) o3 = void 0;
      return { value: o3 && o3[i++], done: !o3 };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read2(o3, n2) {
  var m = typeof Symbol === "function" && o3[Symbol.iterator];
  if (!m) return o3;
  var i = m.call(o3), r2, ar = [], e3;
  try {
    while ((n2 === void 0 || n2-- > 0) && !(r2 = i.next()).done) ar.push(r2.value);
  } catch (error2) {
    e3 = { error: error2 };
  } finally {
    try {
      if (r2 && !r2.done && (m = i["return"])) m.call(i);
    } finally {
      if (e3) throw e3.error;
    }
  }
  return ar;
}
function __spreadArray2(to, from2, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l2 = from2.length, ar; i < l2; i++) {
    if (ar || !(i in from2)) {
      if (!ar) ar = Array.prototype.slice.call(from2, 0, i);
      ar[i] = from2[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from2));
}
function makeAble(name, able) {
  return __assign9({ events: [], props: [], name }, able);
}
var DIRECTIONS4 = ["n", "w", "s", "e"];
var DIRECTIONS = ["n", "w", "s", "e", "nw", "ne", "sw", "se"];
function getSVGCursor(scale, degree) {
  return 'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="'.concat(32 * scale, 'px" height="').concat(32 * scale, 'px" viewBox="0 0 32 32" ><path d="M 16,5 L 12,10 L 14.5,10 L 14.5,22 L 12,22 L 16,27 L 20,22 L 17.5,22 L 17.5,10 L 20, 10 L 16,5 Z" stroke-linejoin="round" stroke-width="1.2" fill="black" stroke="white" style="transform:rotate(').concat(degree, 'deg);transform-origin: 16px 16px"></path></svg>');
}
function getCursorCSS(degree) {
  var x1 = getSVGCursor(1, degree);
  var degree45 = Math.round(degree / 45) * 45 % 180;
  var defaultCursor = "ns-resize";
  if (degree45 === 135) {
    defaultCursor = "nwse-resize";
  } else if (degree45 === 45) {
    defaultCursor = "nesw-resize";
  } else if (degree45 === 90) {
    defaultCursor = "ew-resize";
  }
  return "cursor:".concat(defaultCursor, ";cursor: url('").concat(x1, "') 16 16, ").concat(defaultCursor, ";");
}
var agent2 = agent_esm_default();
var IS_WEBKIT = agent2.browser.webkit;
var IS_WEBKIT605 = IS_WEBKIT && (function() {
  var navi = typeof window === "undefined" ? { userAgent: "" } : window.navigator;
  var res = /applewebkit\/([^\s]+)/g.exec(navi.userAgent.toLowerCase());
  return res ? parseFloat(res[1]) < 605 : false;
})();
var browserName = agent2.browser.name;
var browserVersion = parseInt(agent2.browser.version, 10);
var IS_CHROME = browserName === "chrome";
var IS_CHROMIUM = agent2.browser.chromium;
var chromiumVersion = parseInt(agent2.browser.chromiumVersion, 10) || 0;
var IS_CHROMIUM109 = IS_CHROME && browserVersion >= 109 || IS_CHROMIUM && chromiumVersion >= 109;
var IS_FIREFOX = browserName === "firefox";
var IS_SAFARI_ABOVE15 = parseInt(agent2.browser.webkitVersion, 10) >= 612 || browserVersion >= 15;
var PREFIX = "moveable-";
var directionCSS = DIRECTIONS.map(function(dir) {
  var top = "";
  var left2 = "";
  var originX = "center";
  var originY = "center";
  var offset4 = "calc(var(--moveable-control-padding, 20) * -1px)";
  if (dir.indexOf("n") > -1) {
    top = "top: ".concat(offset4, ";");
    originY = "bottom";
  }
  if (dir.indexOf("s") > -1) {
    top = "top: 0px;";
    originY = "top";
  }
  if (dir.indexOf("w") > -1) {
    left2 = "left: ".concat(offset4, ";");
    originX = "right";
  }
  if (dir.indexOf("e") > -1) {
    left2 = "left: 0px;";
    originX = "left";
  }
  return '.around-control[data-direction*="'.concat(dir, '"] {\n        ').concat(left2).concat(top, "\n        transform-origin: ").concat(originX, " ").concat(originY, ";\n    }");
}).join("\n");
var MOVEABLE_CSS = "\n{\nposition: absolute;\nwidth: 1px;\nheight: 1px;\nleft: 0;\ntop: 0;\nz-index: 3000;\n--moveable-color: #4af;\n--zoom: 1;\n--zoompx: 1px;\n--moveable-line-padding: 0;\n--moveable-control-padding: 0;\nwill-change: transform;\noutline: 1px solid transparent;\n}\n.control-box {\nz-index: 0;\n}\n.line, .control {\nposition: absolute;\nleft: 0;\ntop: 0;\nwill-change: transform;\n}\n.control {\nwidth: 14px;\nheight: 14px;\nborder-radius: 50%;\nborder: 2px solid #fff;\nbox-sizing: border-box;\nbackground: #4af;\nbackground: var(--moveable-color);\nmargin-top: -7px;\nmargin-left: -7px;\nborder: 2px solid #fff;\nz-index: 10;\n}\n.around-control {\nposition: absolute;\nwill-change: transform;\nwidth: calc(var(--moveable-control-padding, 20) * 1px);\nheight: calc(var(--moveable-control-padding, 20) * 1px);\nleft: calc(var(--moveable-control-padding, 20) * -0.5px);\ntop: calc(var(--moveable-control-padding, 20) * -0.5px);\nbox-sizing: border-box;\nbackground: transparent;\nz-index: 8;\ncursor: alias;\ntransform-origin: center center;\n}\n".concat(directionCSS, "\n.padding {\nposition: absolute;\ntop: 0px;\nleft: 0px;\nwidth: 100px;\nheight: 100px;\ntransform-origin: 0 0;\n}\n.line {\nwidth: 1px;\nheight: 1px;\nbackground: #4af;\nbackground: var(--moveable-color);\ntransform-origin: 0px 50%;\n}\n.line.edge {\nz-index: 1;\nbackground: transparent;\n}\n.line.dashed {\nbox-sizing: border-box;\nbackground: transparent;\n}\n.line.dashed.horizontal {\nborder-top: 1px dashed #4af;\nborder-top-color: #4af;\nborder-top-color: var(--moveable-color);\n}\n.line.dashed.vertical {\nborder-left: 1px dashed #4af;\nborder-left-color: #4af;\nborder-left-color: var(--moveable-color);\n}\n.line.vertical {\ntransform: translateX(-50%);\n}\n.line.horizontal {\ntransform: translateY(-50%);\n}\n.line.vertical.bold {\nwidth: 2px;\n}\n.line.horizontal.bold {\nheight: 2px;\n}\n\n.control.origin {\nborder-color: #f55;\nbackground: #fff;\nwidth: 12px;\nheight: 12px;\nmargin-top: -6px;\nmargin-left: -6px;\npointer-events: none;\n}\n").concat([0, 15, 30, 45, 60, 75, 90, 105, 120, 135, 150, 165].map(function(degree) {
  return '\n.direction[data-rotation="'.concat(degree, '"], :global .view-control-rotation').concat(degree, " {\n").concat(getCursorCSS(degree), "\n}\n");
}).join("\n"), '\n\n.line.direction:before {\ncontent: "";\nposition: absolute;\nwidth: 100%;\nheight: calc(var(--moveable-line-padding, 0) * 1px);\nbottom: 0;\nleft: 0;\n}\n.group {\nz-index: -1;\n}\n.area {\nposition: absolute;\n}\n.area-pieces {\nposition: absolute;\ntop: 0;\nleft: 0;\ndisplay: none;\n}\n.area.avoid, .area.pass {\npointer-events: none;\n}\n.area.avoid+.area-pieces {\ndisplay: block;\n}\n.area-piece {\nposition: absolute;\n}\n\n').concat(IS_WEBKIT605 ? ':global svg *:before {\ncontent:"";\ntransform-origin: inherit;\n}' : "", "\n");
var NEARBY_POS = [
  [0, 1, 2],
  [1, 0, 3],
  [2, 0, 3],
  [3, 1, 2]
];
var FLOAT_POINT_NUM = 1e-4;
var TINY_NUM2 = 1e-7;
var MIN_SCALE = 1e-9;
var MAX_NUM = Math.pow(10, 10);
var MIN_NUM = -MAX_NUM;
var DIRECTION_REGION_TO_DIRECTION = {
  n: [0, -1],
  e: [1, 0],
  s: [0, 1],
  w: [-1, 0],
  nw: [-1, -1],
  ne: [1, -1],
  sw: [-1, 1],
  se: [1, 1]
};
var DIRECTION_INDEXES = {
  n: [0, 1],
  e: [1, 3],
  s: [3, 2],
  w: [2, 0],
  nw: [0],
  ne: [1],
  sw: [2],
  se: [3]
};
var DIRECTION_ROTATIONS = {
  n: 0,
  s: 180,
  w: 270,
  e: 90,
  nw: 315,
  ne: 45,
  sw: 225,
  se: 135
};
var MOVEABLE_METHODS = [
  "isMoveableElement",
  "updateRect",
  "updateTarget",
  "destroy",
  "dragStart",
  "isInside",
  "hitTest",
  "setState",
  "getRect",
  "request",
  "isDragging",
  "getManager",
  "forceUpdate",
  "waitToChangeTarget",
  "updateSelectors",
  "getTargets",
  "stopDrag",
  "getControlBoxElement",
  "getMoveables",
  "getDragElement"
];
function setCustomDrag(e3, state, delta, isPinch, isConvert, ableName) {
  var _a, _b;
  if (ableName === void 0) {
    ableName = "draggable";
  }
  var result = (_b = (_a = state.gestos[ableName]) === null || _a === void 0 ? void 0 : _a.move(delta, e3.inputEvent)) !== null && _b !== void 0 ? _b : {};
  var datas = result.originalDatas || result.datas;
  var ableDatas = datas[ableName] || (datas[ableName] = {});
  return __assign9(__assign9({}, isConvert ? convertDragDist(state, result) : result), { isPinch: !!isPinch, parentEvent: true, datas: ableDatas, originalDatas: e3.originalDatas });
}
var CustomGesto = /* @__PURE__ */ (function() {
  function CustomGesto2(ableName) {
    var _a;
    if (ableName === void 0) {
      ableName = "draggable";
    }
    this.ableName = ableName;
    this.prevX = 0;
    this.prevY = 0;
    this.startX = 0;
    this.startY = 0;
    this.isDrag = false;
    this.isFlag = false;
    this.datas = {
      draggable: {}
    };
    this.datas = (_a = {}, _a[ableName] = {}, _a);
  }
  CustomGesto2.prototype.dragStart = function(client, e3) {
    this.isDrag = false;
    this.isFlag = false;
    var originalDatas = e3.originalDatas;
    this.datas = originalDatas;
    if (!originalDatas[this.ableName]) {
      originalDatas[this.ableName] = {};
    }
    return __assign9(__assign9({}, this.move(client, e3.inputEvent)), { type: "dragstart" });
  };
  CustomGesto2.prototype.drag = function(client, inputEvent) {
    return this.move([
      client[0] - this.prevX,
      client[1] - this.prevY
    ], inputEvent);
  };
  CustomGesto2.prototype.move = function(delta, inputEvent) {
    var clientX;
    var clientY;
    var isFirstDrag = false;
    if (!this.isFlag) {
      this.prevX = delta[0];
      this.prevY = delta[1];
      this.startX = delta[0];
      this.startY = delta[1];
      clientX = delta[0];
      clientY = delta[1];
      this.isFlag = true;
    } else {
      var isPrevDrag = this.isDrag;
      clientX = this.prevX + delta[0];
      clientY = this.prevY + delta[1];
      if (delta[0] || delta[1]) {
        this.isDrag = true;
      }
      if (!isPrevDrag && this.isDrag) {
        isFirstDrag = true;
      }
    }
    this.prevX = clientX;
    this.prevY = clientY;
    return {
      type: "drag",
      clientX,
      clientY,
      inputEvent,
      isFirstDrag,
      isDrag: this.isDrag,
      distX: clientX - this.startX,
      distY: clientY - this.startY,
      deltaX: delta[0],
      deltaY: delta[1],
      datas: this.datas[this.ableName],
      originalDatas: this.datas,
      parentEvent: true,
      parentGesto: this
    };
  };
  return CustomGesto2;
})();
function calculateElementPosition(matrix, origin, width, height) {
  var is3d = matrix.length === 16;
  var n2 = is3d ? 4 : 3;
  var poses = calculatePoses(matrix, width, height, n2);
  var _a = __read2(poses, 4), _b = __read2(_a[0], 2), x1 = _b[0], y1 = _b[1], _c = __read2(_a[1], 2), x2 = _c[0], y2 = _c[1], _d = __read2(_a[2], 2), x3 = _d[0], y3 = _d[1], _e = __read2(_a[3], 2), x4 = _e[0], y4 = _e[1];
  var _f = __read2(calculatePosition(matrix, origin, n2), 2), originX = _f[0], originY = _f[1];
  var left2 = Math.min(x1, x2, x3, x4);
  var top = Math.min(y1, y2, y3, y4);
  var right2 = Math.max(x1, x2, x3, x4);
  var bottom = Math.max(y1, y2, y3, y4);
  x1 = x1 - left2 || 0;
  x2 = x2 - left2 || 0;
  x3 = x3 - left2 || 0;
  x4 = x4 - left2 || 0;
  y1 = y1 - top || 0;
  y2 = y2 - top || 0;
  y3 = y3 - top || 0;
  y4 = y4 - top || 0;
  originX = originX - left2 || 0;
  originY = originY - top || 0;
  var sx = matrix[0];
  var sy = matrix[n2 + 1];
  var direction = sign(sx * sy);
  return {
    left: left2,
    top,
    right: right2,
    bottom,
    origin: [originX, originY],
    pos1: [x1, y1],
    pos2: [x2, y2],
    pos3: [x3, y3],
    pos4: [x4, y4],
    direction
  };
}
function calculatePointerDist(moveable, e3) {
  var clientX = e3.clientX, clientY = e3.clientY, datas = e3.datas;
  var _a = moveable.state, moveableClientRect = _a.moveableClientRect, rootMatrix = _a.rootMatrix, is3d = _a.is3d, pos1 = _a.pos1;
  var left2 = moveableClientRect.left, top = moveableClientRect.top;
  var n2 = is3d ? 4 : 3;
  var _b = __read2(minus(calculateInversePosition(rootMatrix, [clientX - left2, clientY - top], n2), pos1), 2), posX = _b[0], posY = _b[1];
  var _c = __read2(getDragDist({ datas, distX: posX, distY: posY }), 2), distX = _c[0], distY = _c[1];
  return [distX, distY];
}
function setDragStart(moveable, _a) {
  var datas = _a.datas;
  var _b = moveable.state, allMatrix = _b.allMatrix, beforeMatrix = _b.beforeMatrix, is3d = _b.is3d, left2 = _b.left, top = _b.top, origin = _b.origin, offsetMatrix = _b.offsetMatrix, targetMatrix = _b.targetMatrix, transformOrigin = _b.transformOrigin;
  var n2 = is3d ? 4 : 3;
  datas.is3d = is3d;
  datas.matrix = allMatrix;
  datas.targetMatrix = targetMatrix;
  datas.beforeMatrix = beforeMatrix;
  datas.offsetMatrix = offsetMatrix;
  datas.transformOrigin = transformOrigin;
  datas.inverseMatrix = invert(allMatrix, n2);
  datas.inverseBeforeMatrix = invert(beforeMatrix, n2);
  datas.absoluteOrigin = convertPositionMatrix(plus([left2, top], origin), n2);
  datas.startDragBeforeDist = calculate2(datas.inverseBeforeMatrix, datas.absoluteOrigin, n2);
  datas.startDragDist = calculate2(datas.inverseMatrix, datas.absoluteOrigin, n2);
}
function getTransformDirection(e3) {
  return calculateElementPosition(e3.datas.beforeTransform, [50, 50], 100, 100).direction;
}
function resolveTransformEvent(moveable, event, functionName) {
  var datas = event.datas, originalDatas = event.originalDatas.beforeRenderable;
  var index3 = datas.transformIndex;
  var nextTransforms = originalDatas.nextTransforms;
  var length2 = nextTransforms.length;
  var nextTransformAppendedIndexes = originalDatas.nextTransformAppendedIndexes;
  var nextIndex2 = -1;
  if (index3 === -1) {
    if (functionName === "translate") {
      nextIndex2 = 0;
    } else if (functionName === "rotate") {
      nextIndex2 = findIndex(nextTransforms, function(text) {
        return text.match(/scale\(/g);
      });
    }
    if (nextIndex2 === -1) {
      nextIndex2 = nextTransforms.length;
    }
    datas.transformIndex = nextIndex2;
  } else if (find(nextTransformAppendedIndexes, function(info) {
    return info.index === index3 && info.functionName === functionName;
  })) {
    nextIndex2 = index3;
  } else {
    nextIndex2 = index3 + nextTransformAppendedIndexes.filter(function(info) {
      return info.index < index3;
    }).length;
  }
  var result = convertTransformInfo(nextTransforms, moveable.state, nextIndex2);
  var targetFunction = result.targetFunction;
  var matFunctionName = functionName === "rotate" ? "rotateZ" : functionName;
  datas.beforeFunctionTexts = result.beforeFunctionTexts;
  datas.afterFunctionTexts = result.afterFunctionTexts;
  datas.beforeTransform = result.beforeFunctionMatrix;
  datas.beforeTransform2 = result.beforeFunctionMatrix2;
  datas.targetTansform = result.targetFunctionMatrix;
  datas.afterTransform = result.afterFunctionMatrix;
  datas.afterTransform2 = result.afterFunctionMatrix2;
  datas.targetAllTransform = result.allFunctionMatrix;
  if (targetFunction.functionName === matFunctionName) {
    datas.afterFunctionTexts.splice(0, 1);
    datas.isAppendTransform = false;
  } else if (length2 > nextIndex2) {
    datas.isAppendTransform = true;
    originalDatas.nextTransformAppendedIndexes = __spreadArray2(__spreadArray2([], __read2(nextTransformAppendedIndexes), false), [{
      functionName,
      index: nextIndex2,
      isAppend: true
    }], false);
  }
}
function convertTransformFormat(datas, value, dist) {
  return "".concat(datas.beforeFunctionTexts.join(" "), " ").concat(datas.isAppendTransform ? dist : value, " ").concat(datas.afterFunctionTexts.join(" "));
}
function getTransformDist(_a) {
  var datas = _a.datas, distX = _a.distX, distY = _a.distY;
  var _b = __read2(getBeforeDragDist({ datas, distX, distY }), 2), bx = _b[0], by = _b[1];
  var res = getTransfromMatrix(datas, fromTranslation([bx, by], 4));
  return calculate2(res, convertPositionMatrix([0, 0, 0], 4), 4);
}
function getTransfromMatrix(datas, targetMatrix, isAfter3) {
  var beforeTransform = datas.beforeTransform, afterTransform = datas.afterTransform, beforeTransform2 = datas.beforeTransform2, afterTransform2 = datas.afterTransform2, targetAllTransform = datas.targetAllTransform;
  var nextTargetMatrix = isAfter3 ? multiply(targetAllTransform, targetMatrix, 4) : multiply(targetMatrix, targetAllTransform, 4);
  var res1 = multiply(invert(isAfter3 ? beforeTransform2 : beforeTransform, 4), nextTargetMatrix, 4);
  var afterTargetMatrix = multiply(res1, invert(isAfter3 ? afterTransform2 : afterTransform, 4), 4);
  return afterTargetMatrix;
}
function getBeforeDragDist(_a) {
  var datas = _a.datas, distX = _a.distX, distY = _a.distY;
  var inverseBeforeMatrix = datas.inverseBeforeMatrix, is3d = datas.is3d, startDragBeforeDist = datas.startDragBeforeDist, absoluteOrigin = datas.absoluteOrigin;
  var n2 = is3d ? 4 : 3;
  return minus(calculate2(inverseBeforeMatrix, plus(absoluteOrigin, [distX, distY]), n2), startDragBeforeDist);
}
function getDragDist(_a, isBefore) {
  var datas = _a.datas, distX = _a.distX, distY = _a.distY;
  var inverseBeforeMatrix = datas.inverseBeforeMatrix, inverseMatrix = datas.inverseMatrix, is3d = datas.is3d, startDragBeforeDist = datas.startDragBeforeDist, startDragDist = datas.startDragDist, absoluteOrigin = datas.absoluteOrigin;
  var n2 = is3d ? 4 : 3;
  return minus(calculate2(isBefore ? inverseBeforeMatrix : inverseMatrix, plus(absoluteOrigin, [distX, distY]), n2), isBefore ? startDragBeforeDist : startDragDist);
}
function getInverseDragDist(_a, isBefore) {
  var datas = _a.datas, distX = _a.distX, distY = _a.distY;
  var beforeMatrix = datas.beforeMatrix, matrix = datas.matrix, is3d = datas.is3d, startDragBeforeDist = datas.startDragBeforeDist, startDragDist = datas.startDragDist, absoluteOrigin = datas.absoluteOrigin;
  var n2 = is3d ? 4 : 3;
  return minus(calculate2(isBefore ? beforeMatrix : matrix, plus(isBefore ? startDragBeforeDist : startDragDist, [distX, distY]), n2), absoluteOrigin);
}
function calculateTransformOrigin(transformOrigin, width, height, prevWidth, prevHeight, prevOrigin) {
  if (prevWidth === void 0) {
    prevWidth = width;
  }
  if (prevHeight === void 0) {
    prevHeight = height;
  }
  if (prevOrigin === void 0) {
    prevOrigin = [0, 0];
  }
  if (!transformOrigin) {
    return prevOrigin;
  }
  return transformOrigin.map(function(pos, i) {
    var _a = splitUnit(pos), value = _a.value, unit3 = _a.unit;
    var prevSize = i ? prevHeight : prevWidth;
    var size = i ? height : width;
    if (pos === "%" || isNaN(value)) {
      var measureRatio = prevSize ? prevOrigin[i] / prevSize : 0;
      return size * measureRatio;
    } else if (unit3 !== "%") {
      return value;
    }
    return size * value / 100;
  });
}
function getPosIndexesByDirection(direction) {
  var indexes = [];
  if (direction[1] >= 0) {
    if (direction[0] >= 0) {
      indexes.push(3);
    }
    if (direction[0] <= 0) {
      indexes.push(2);
    }
  }
  if (direction[1] <= 0) {
    if (direction[0] >= 0) {
      indexes.push(1);
    }
    if (direction[0] <= 0) {
      indexes.push(0);
    }
  }
  return indexes;
}
function getPosesByDirection(poses, direction) {
  return getPosIndexesByDirection(direction).map(function(index3) {
    return poses[index3];
  });
}
function getPosBySingleDirection(poses, direction) {
  var ratio = (direction + 1) / 2;
  return [
    dot(poses[0][0], poses[1][0], ratio, 1 - ratio),
    dot(poses[0][1], poses[1][1], ratio, 1 - ratio)
  ];
}
function getPosByDirection(poses, direction) {
  var top = getPosBySingleDirection([poses[0], poses[1]], direction[0]);
  var bottom = getPosBySingleDirection([poses[2], poses[3]], direction[0]);
  return getPosBySingleDirection([top, bottom], direction[1]);
}
function getDist3(startPos, matrix, width, height, n2, fixedDirection) {
  var poses = calculatePoses(matrix, width, height, n2);
  var fixedPos = getPosByDirection(poses, fixedDirection);
  var distX = startPos[0] - fixedPos[0];
  var distY = startPos[1] - fixedPos[1];
  return [distX, distY];
}
function getNextMatrix(offsetMatrix, targetMatrix, origin, n2) {
  return multiply(offsetMatrix, getAbsoluteMatrix(targetMatrix, n2, origin), n2);
}
function getNextTransformMatrix(state, datas, transform, isAllTransform) {
  var transformOrigin = state.transformOrigin, offsetMatrix = state.offsetMatrix, is3d = state.is3d;
  var n2 = is3d ? 4 : 3;
  var targetTransform;
  if (isString2(transform)) {
    var beforeTransform = datas.beforeTransform, afterTransform = datas.afterTransform;
    if (isAllTransform) {
      targetTransform = convertDimension(parseMat(transform), 4, n2);
    } else {
      targetTransform = convertDimension(multiply(multiply(beforeTransform, parseMat([transform]), 4), afterTransform, 4), 4, n2);
    }
  } else {
    targetTransform = transform;
  }
  return getNextMatrix(offsetMatrix, targetTransform, transformOrigin, n2);
}
function scaleMatrix(state, scale) {
  var transformOrigin = state.transformOrigin, offsetMatrix = state.offsetMatrix, is3d = state.is3d, targetMatrix = state.targetMatrix, targetAllTransform = state.targetAllTransform;
  var n2 = is3d ? 4 : 3;
  return getNextMatrix(offsetMatrix, multiply(targetAllTransform || targetMatrix, createScaleMatrix(scale, n2), n2), transformOrigin, n2);
}
function fillTransformStartEvent(moveable, e3) {
  var originalDatas = getBeforeRenderableDatas(e3);
  return {
    setTransform: function(transform, index3) {
      if (index3 === void 0) {
        index3 = -1;
      }
      originalDatas.startTransforms = isArray5(transform) ? transform : splitSpace(transform);
      setTransformIndex(moveable, e3, index3);
    },
    setTransformIndex: function(index3) {
      setTransformIndex(moveable, e3, index3);
    }
  };
}
function setDefaultTransformIndex(moveable, e3, property2) {
  var originalDatas = getBeforeRenderableDatas(e3);
  var startTransforms = originalDatas.startTransforms;
  setTransformIndex(moveable, e3, findIndex(startTransforms, function(func) {
    return func.indexOf("".concat(property2, "(")) === 0;
  }));
}
function setTransformIndex(moveable, e3, index3) {
  var originalDatas = getBeforeRenderableDatas(e3);
  var datas = e3.datas;
  datas.transformIndex = index3;
  if (index3 === -1) {
    return;
  }
  var transform = originalDatas.startTransforms[index3];
  if (!transform) {
    return;
  }
  var state = moveable.state;
  var info = parse5([transform], {
    "x%": function(v) {
      return v / 100 * state.offsetWidth;
    },
    "y%": function(v) {
      return v / 100 * state.offsetHeight;
    }
  });
  datas.startValue = info[0].functionValue;
}
function fillOriginalTransform(e3, transform) {
  var originalDatas = getBeforeRenderableDatas(e3);
  originalDatas.nextTransforms = splitSpace(transform);
}
function getBeforeRenderableDatas(e3) {
  return e3.originalDatas.beforeRenderable;
}
function getNextTransforms(e3) {
  var originalDatas = e3.originalDatas.beforeRenderable;
  return originalDatas.nextTransforms;
}
function getNextTransformText(e3) {
  return (getNextTransforms(e3) || []).join(" ");
}
function getNextStyle(e3) {
  return getBeforeRenderableDatas(e3).nextStyle;
}
function fillTransformEvent(moveable, nextTransform, delta, isPinch, e3) {
  fillOriginalTransform(e3, nextTransform);
  var drag = Draggable2.drag(moveable, setCustomDrag(e3, moveable.state, delta, isPinch, false));
  var afterTransform = drag ? drag.transform : nextTransform;
  return __assign9(__assign9({ transform: nextTransform, drag }, fillCSSObject({
    transform: afterTransform
  }, e3)), { afterTransform });
}
function getTranslateFixedPosition(moveable, transform, fixedDirection, fixedOffset, datas, isAllTransform) {
  var nextMatrix = getNextTransformMatrix(moveable.state, datas, transform, isAllTransform);
  var nextFixedPosition = getDirectionOffset(moveable, fixedDirection, fixedOffset, nextMatrix);
  return nextFixedPosition;
}
function getTranslateDist(moveable, transform, fixedDirection, fixedPosition, fixedOffset, datas, isAllTransform) {
  var nextFixedPosition = getTranslateFixedPosition(moveable, transform, fixedDirection, fixedOffset, datas, isAllTransform);
  var state = moveable.state;
  var left2 = state.left, top = state.top;
  var groupable = moveable.props.groupable;
  var groupLeft = groupable ? left2 : 0;
  var groupTop = groupable ? top : 0;
  var dist = minus(fixedPosition, nextFixedPosition);
  return minus(dist, [groupLeft, groupTop]);
}
function getScaleDist(moveable, transform, fixedDirection, fixedPosition, fixedOffset, datas, isAllTransform) {
  var dist = getTranslateDist(moveable, transform, fixedDirection, fixedPosition, fixedOffset, datas, isAllTransform);
  return dist;
}
function getDirectionByPos(pos, width, height) {
  return [
    width ? -1 + pos[0] / (width / 2) : 0,
    height ? -1 + pos[1] / (height / 2) : 0
  ];
}
function getDirectionOffset(moveable, fixedDirection, fixedOffset, nextMatrix) {
  if (nextMatrix === void 0) {
    nextMatrix = moveable.state.allMatrix;
  }
  var _a = moveable.state, width = _a.width, height = _a.height, is3d = _a.is3d;
  var n2 = is3d ? 4 : 3;
  var fixedOffsetPosition = [
    width / 2 * (1 + fixedDirection[0]) + fixedOffset[0],
    height / 2 * (1 + fixedDirection[1]) + fixedOffset[1]
  ];
  return calculatePosition(nextMatrix, fixedOffsetPosition, n2);
}
function getRotateDist(moveable, rotateDist, datas) {
  var fixedDirection = datas.fixedDirection;
  var fixedPosition = datas.fixedPosition;
  var fixedOffset = datas.fixedOffset;
  return getTranslateDist(moveable, "rotate(".concat(rotateDist, "deg)"), fixedDirection, fixedPosition, fixedOffset, datas);
}
function getResizeDist(moveable, width, height, fixedPosition, transformOrigin, datas) {
  var groupable = moveable.props.groupable;
  var state = moveable.state;
  var prevOrigin = state.transformOrigin, offsetMatrix = state.offsetMatrix, is3d = state.is3d, prevWidth = state.width, prevHeight = state.height, left2 = state.left, top = state.top;
  var fixedDirection = datas.fixedDirection;
  var targetMatrix = datas.nextTargetMatrix || state.targetMatrix;
  var n2 = is3d ? 4 : 3;
  var nextOrigin = calculateTransformOrigin(transformOrigin, width, height, prevWidth, prevHeight, prevOrigin);
  var groupLeft = groupable ? left2 : 0;
  var groupTop = groupable ? top : 0;
  var nextMatrix = getNextMatrix(offsetMatrix, targetMatrix, nextOrigin, n2);
  var dist = getDist3(fixedPosition, nextMatrix, width, height, n2, fixedDirection);
  return minus(dist, [groupLeft, groupTop]);
}
function getAbsolutePosition(moveable, direction) {
  return getPosByDirection(getAbsolutePosesByState(moveable.state), direction);
}
function getGestoData(moveable, ableName) {
  var targetGesto = moveable.targetGesto;
  var controlGesto = moveable.controlGesto;
  var data2;
  if (targetGesto === null || targetGesto === void 0 ? void 0 : targetGesto.isFlag()) {
    data2 = targetGesto.getEventData()[ableName];
  }
  if (!data2 && (controlGesto === null || controlGesto === void 0 ? void 0 : controlGesto.isFlag())) {
    data2 = controlGesto.getEventData()[ableName];
  }
  return data2 || {};
}
function getShadowRoot3(parentElement) {
  if (parentElement && parentElement.getRootNode) {
    var rootNode = parentElement.getRootNode();
    if (rootNode.nodeType === 11) {
      return rootNode;
    }
  }
  return;
}
function getIndividualTransforms(getStyle4) {
  var scale = getStyle4("scale");
  var rotate2 = getStyle4("rotate");
  var translate = getStyle4("translate");
  var individualTransforms = [];
  if (translate && translate !== "0px" && translate !== "none") {
    individualTransforms.push("translate(".concat(translate.split(/\s+/).join(","), ")"));
  }
  if (rotate2 && rotate2 !== "1" && rotate2 !== "none") {
    individualTransforms.push("rotate(".concat(rotate2, ")"));
  }
  if (scale && scale !== "1" && scale !== "none") {
    individualTransforms.push("scale(".concat(scale.split(/\s+/).join(","), ")"));
  }
  return individualTransforms;
}
function getMatrixStackInfo(target, container, checkContainer) {
  var el = target;
  var matrixes = [];
  var documentElement = getDocumentElement(target) || getDocumentBody(target);
  var requestEnd = !checkContainer && target === container || target === documentElement;
  var isEnd = requestEnd;
  var is3d = false;
  var n2 = 3;
  var transformOrigin;
  var targetTransformOrigin;
  var targetMatrix;
  var hasFixed = false;
  var offsetContainer = getOffsetInfo(container, container, true).offsetParent;
  var zoom = 1;
  while (el && !isEnd) {
    isEnd = requestEnd;
    var getStyle4 = getCachedStyle(el);
    var position3 = getStyle4("position");
    var transform = getElementTransform(el);
    var isFixed2 = position3 === "fixed";
    var individualTransforms = getIndividualTransforms(getStyle4);
    var matrix = convertCSStoMatrix(getTransformMatrix(transform));
    var offsetParent = void 0;
    var isOffsetEnd = false;
    var isStatic = false;
    var parentClientLeft = 0;
    var parentClientTop = 0;
    var fixedClientLeft = 0;
    var fixedClientTop = 0;
    var fixedInfo = {
      hasTransform: false,
      fixedContainer: null
    };
    if (isFixed2) {
      hasFixed = true;
      fixedInfo = getPositionFixedInfo(el);
      offsetContainer = fixedInfo.fixedContainer;
    }
    var length_1 = matrix.length;
    if (!is3d && (length_1 === 16 || individualTransforms.length)) {
      is3d = true;
      n2 = 4;
      convert3DMatrixes(matrixes);
      if (targetMatrix) {
        targetMatrix = convertDimension(targetMatrix, 3, 4);
      }
    }
    if (is3d && length_1 === 9) {
      matrix = convertDimension(matrix, 3, 4);
    }
    var _a = getOffsetPosInfo(el, target), tagName = _a.tagName, hasOffset = _a.hasOffset, isSVG = _a.isSVG, origin_1 = _a.origin, targetOrigin = _a.targetOrigin, offsetPos = _a.offset;
    var _b = __read2(offsetPos, 2), offsetLeft = _b[0], offsetTop = _b[1];
    if (tagName === "svg" && !el.ownerSVGElement && targetMatrix) {
      matrixes.push({
        type: "target",
        target: el,
        matrix: getSVGMatrix(el, n2)
      });
      matrixes.push({
        type: "offset",
        target: el,
        matrix: createIdentityMatrix(n2)
      });
    }
    var targetZoom = parseFloat(getStyle4("zoom")) || 1;
    if (isFixed2) {
      offsetParent = fixedInfo.fixedContainer;
      isOffsetEnd = true;
    } else {
      var offsetInfo = getOffsetInfo(el, container, false, true, getStyle4);
      var offsetZoom = offsetInfo.offsetZoom;
      offsetParent = offsetInfo.offsetParent;
      isOffsetEnd = offsetInfo.isEnd;
      isStatic = offsetInfo.isStatic;
      zoom *= offsetZoom;
      if ((offsetInfo.isCustomElement || offsetZoom !== 1) && isStatic) {
        offsetLeft -= offsetParent.offsetLeft;
        offsetTop -= offsetParent.offsetTop;
      } else if (IS_FIREFOX || IS_CHROMIUM109) {
        var parentSlotElement = offsetInfo.parentSlotElement;
        if (parentSlotElement) {
          var customOffsetParent = offsetParent;
          var customOffsetLeft = 0;
          var customOffsetTop = 0;
          while (customOffsetParent) {
            if (!getShadowRoot3(customOffsetParent)) {
              break;
            }
            customOffsetLeft += customOffsetParent.offsetLeft;
            customOffsetTop += customOffsetParent.offsetTop;
            customOffsetParent = customOffsetParent.offsetParent;
          }
          offsetLeft -= customOffsetLeft;
          offsetTop -= customOffsetTop;
        }
      }
    }
    if (IS_WEBKIT && !IS_SAFARI_ABOVE15 && hasOffset && !isSVG && isStatic && (position3 === "relative" || position3 === "static")) {
      offsetLeft -= offsetParent.offsetLeft;
      offsetTop -= offsetParent.offsetTop;
      requestEnd = requestEnd || isOffsetEnd;
    }
    if (isFixed2) {
      if (hasOffset && fixedInfo.hasTransform) {
        fixedClientLeft = offsetParent.clientLeft;
        fixedClientTop = offsetParent.clientTop;
      }
    } else {
      if (hasOffset && offsetContainer !== offsetParent) {
        parentClientLeft = offsetParent.clientLeft;
        parentClientTop = offsetParent.clientTop;
      }
      if (hasOffset && offsetParent === documentElement) {
        var margin = getBodyOffset(el, false);
        offsetLeft += margin[0];
        offsetTop += margin[1];
      }
    }
    matrixes.push({
      type: "target",
      target: el,
      matrix: getAbsoluteMatrix(matrix, n2, origin_1)
    });
    if (individualTransforms.length) {
      matrixes.push({
        type: "offset",
        target: el,
        matrix: createIdentityMatrix(n2)
      });
      matrixes.push({
        type: "target",
        target: el,
        matrix: getAbsoluteMatrix(parseMat(individualTransforms), n2, origin_1)
      });
    }
    if (hasOffset) {
      var isElementTarget = el === target;
      var scrollLeft = isElementTarget ? 0 : el.scrollLeft;
      var scrollTop = isElementTarget ? 0 : el.scrollTop;
      matrixes.push({
        type: "offset",
        target: el,
        matrix: createOriginMatrix([
          offsetLeft - scrollLeft + parentClientLeft - fixedClientLeft,
          offsetTop - scrollTop + parentClientTop - fixedClientTop
        ], n2)
      });
    } else {
      matrixes.push({
        type: "offset",
        target: el,
        origin: origin_1
      });
    }
    if (targetZoom !== 1) {
      matrixes.push({
        type: "zoom",
        target: el,
        matrix: getAbsoluteMatrix(createScaleMatrix([targetZoom, targetZoom], n2), n2, [0, 0])
      });
    }
    if (!targetMatrix) {
      targetMatrix = matrix;
    }
    if (!transformOrigin) {
      transformOrigin = origin_1;
    }
    if (!targetTransformOrigin) {
      targetTransformOrigin = targetOrigin;
    }
    if (isEnd || isFixed2) {
      break;
    } else {
      el = offsetParent;
      requestEnd = isOffsetEnd;
    }
    if (!checkContainer || el === documentElement) {
      isEnd = requestEnd;
    }
  }
  if (!targetMatrix) {
    targetMatrix = createIdentityMatrix(n2);
  }
  if (!transformOrigin) {
    transformOrigin = [0, 0];
  }
  if (!targetTransformOrigin) {
    targetTransformOrigin = [0, 0];
  }
  return {
    zoom,
    offsetContainer,
    matrixes,
    targetMatrix,
    transformOrigin,
    targetOrigin: targetTransformOrigin,
    is3d,
    hasFixed
  };
}
var cacheStyleMap = null;
var clientRectStyleMap = null;
var matrixContainerInfos = null;
function setStoreCache(useCache) {
  if (useCache) {
    if (window.Map) {
      cacheStyleMap = /* @__PURE__ */ new Map();
      clientRectStyleMap = /* @__PURE__ */ new Map();
    }
    matrixContainerInfos = [];
  } else {
    cacheStyleMap = null;
    matrixContainerInfos = null;
    clientRectStyleMap = null;
  }
}
function getCachedClientRect(el) {
  var clientRect = clientRectStyleMap === null || clientRectStyleMap === void 0 ? void 0 : clientRectStyleMap.get(el);
  if (clientRect) {
    return clientRect;
  }
  var nextClientRect = getClientRect2(el, true);
  if (clientRectStyleMap) {
    clientRectStyleMap.set(el, nextClientRect);
  }
  return nextClientRect;
}
function getCachedMatrixContainerInfo(target, container) {
  if (matrixContainerInfos) {
    var result_1 = find(matrixContainerInfos, function(info) {
      return info[0][0] == target && info[0][1] == container;
    });
    if (result_1) {
      return result_1[1];
    }
  }
  var result = getMatrixStackInfo(target, container, true);
  if (matrixContainerInfos) {
    matrixContainerInfos.push([[target, container], result]);
  }
  return result;
}
function getCachedStyle(element) {
  var cache = cacheStyleMap === null || cacheStyleMap === void 0 ? void 0 : cacheStyleMap.get(element);
  if (!cache) {
    var nextStyle_1 = getWindow2(element).getComputedStyle(element);
    if (!cacheStyleMap) {
      return function(property2) {
        return nextStyle_1[property2];
      };
    }
    cache = {
      style: nextStyle_1,
      cached: {}
    };
    cacheStyleMap.set(element, cache);
  }
  var cached2 = cache.cached;
  var style2 = cache.style;
  return function(property2) {
    if (!(property2 in cached2)) {
      cached2[property2] = style2[property2];
    }
    return cached2[property2];
  };
}
function fillChildEvents(moveable, name, e3) {
  var datas = e3.originalDatas;
  datas.groupable = datas.groupable || {};
  var groupableDatas = datas.groupable;
  groupableDatas.childDatas = groupableDatas.childDatas || [];
  var childDatas = groupableDatas.childDatas;
  return moveable.moveables.map(function(_, i) {
    childDatas[i] = childDatas[i] || {};
    childDatas[i][name] = childDatas[i][name] || {};
    return __assign9(__assign9({}, e3), { isRequestChild: true, datas: childDatas[i][name], originalDatas: childDatas[i] });
  });
}
function triggerChildGesto(moveable, able, type5, delta, e3, isConvert, ableName) {
  var isStart = !!type5.match(/Start$/g);
  var isEnd = !!type5.match(/End$/g);
  var isPinch = e3.isPinch;
  var datas = e3.datas;
  var events2 = fillChildEvents(moveable, able.name, e3);
  var moveables = moveable.moveables;
  var childEvents = [];
  var eventParams = events2.map(function(ev, i) {
    var childMoveable = moveables[i];
    var state = childMoveable.state;
    var gestos = state.gestos;
    var childEvent = ev;
    if (isStart) {
      childEvent = new CustomGesto(ableName).dragStart(delta, ev);
      childEvents.push(childEvent);
    } else {
      if (!gestos[ableName]) {
        gestos[ableName] = datas.childGestos[i];
      }
      if (!gestos[ableName]) {
        return;
      }
      childEvent = setCustomDrag(ev, state, delta, isPinch, isConvert, ableName);
      childEvents.push(childEvent);
    }
    var result = able[type5](childMoveable, __assign9(__assign9({}, childEvent), { parentFlag: true }));
    if (isEnd) {
      gestos[ableName] = null;
    }
    return result;
  });
  if (isStart) {
    datas.childGestos = moveables.map(function(child) {
      return child.state.gestos[ableName];
    });
  }
  return {
    eventParams,
    childEvents
  };
}
function triggerChildAbles(moveable, able, type5, e3, eachEvent, callback) {
  if (eachEvent === void 0) {
    eachEvent = function(_, ev) {
      return ev;
    };
  }
  var isEnd = !!type5.match(/End$/g);
  var events2 = fillChildEvents(moveable, able.name, e3);
  var moveables = moveable.moveables;
  var childs = events2.map(function(ev, i) {
    var childMoveable = moveables[i];
    var childEvent = ev;
    childEvent = eachEvent(childMoveable, ev);
    var result = able[type5](childMoveable, __assign9(__assign9({}, childEvent), { parentFlag: true }));
    result && callback && callback(childMoveable, ev, result, i);
    if (isEnd) {
      childMoveable.state.gestos = {};
    }
    return result;
  });
  return childs;
}
function startChildDist(moveable, child, parentDatas, childEvent) {
  var fixedDirection = parentDatas.fixedDirection;
  var fixedPosition = parentDatas.fixedPosition;
  var startPositions = childEvent.datas.startPositions || getAbsolutePosesByState(child.state);
  var pos = getPosByDirection(startPositions, fixedDirection);
  var _a = __read2(calculate2(createRotateMatrix(-moveable.rotation / 180 * Math.PI, 3), [pos[0] - fixedPosition[0], pos[1] - fixedPosition[1], 1], 3), 2), originalX = _a[0], originalY = _a[1];
  childEvent.datas.originalX = originalX;
  childEvent.datas.originalY = originalY;
  return childEvent;
}
function renderDirectionControlsByInfos(moveable, ableName, renderDirections, React615) {
  var _a = moveable.getState(), renderPoses = _a.renderPoses, rotationRad = _a.rotation, direction = _a.direction;
  var zoom = getProps3(moveable.props, ableName).zoom;
  var degRotation = absDegree(rotationRad / Math.PI * 180);
  var directionMap = {};
  var renderState = moveable.renderState;
  if (!renderState.renderDirectionMap) {
    renderState.renderDirectionMap = {};
  }
  var renderDirectionMap = renderState.renderDirectionMap;
  renderDirections.forEach(function(_a2) {
    var dir = _a2.dir;
    directionMap[dir] = true;
  });
  var directionSign = sign(direction);
  return renderDirections.map(function(_a2) {
    var data2 = _a2.data, classNames186 = _a2.classNames, dir = _a2.dir;
    var indexes = DIRECTION_INDEXES[dir];
    if (!indexes || !directionMap[dir]) {
      return null;
    }
    renderDirectionMap[dir] = true;
    var directionRotation = (throttle3(degRotation, 15) + directionSign * DIRECTION_ROTATIONS[dir] + 720) % 180;
    var dataAttrs = {};
    getKeys2(data2).forEach(function(name) {
      dataAttrs["data-".concat(name)] = data2[name];
    });
    return React615.createElement("div", __assign9({ className: prefix.apply(void 0, __spreadArray2(["control", "direction", dir, ableName], __read2(classNames186), false)), "data-rotation": directionRotation, "data-direction": dir }, dataAttrs, { key: "direction-".concat(dir), style: getControlTransform.apply(void 0, __spreadArray2([rotationRad, zoom], __read2(indexes.map(function(index3) {
      return renderPoses[index3];
    })), false)) }));
  });
}
function renderDirectionControls(moveable, defaultDirections, ableName, React615) {
  var _a = getProps3(moveable.props, ableName), _b = _a.renderDirections, directions2 = _b === void 0 ? defaultDirections : _b, displayAroundControls = _a.displayAroundControls;
  if (!directions2) {
    return [];
  }
  var renderDirections = directions2 === true ? DIRECTIONS : directions2;
  return __spreadArray2(__spreadArray2([], __read2(displayAroundControls ? renderAroundControls(moveable, React615, ableName, renderDirections) : []), false), __read2(renderDirectionControlsByInfos(moveable, ableName, renderDirections.map(function(dir) {
    return {
      data: {},
      classNames: [],
      dir
    };
  }), React615)), false);
}
function renderLine(React615, direction, pos1, pos2, zoom, key2) {
  var classNames186 = [];
  for (var _i = 6; _i < arguments.length; _i++) {
    classNames186[_i - 6] = arguments[_i];
  }
  var rad = getRad(pos1, pos2);
  var rotation = direction ? throttle3(rad / Math.PI * 180, 15) % 180 : -1;
  return React615.createElement("div", { key: "line-".concat(key2), className: prefix.apply(void 0, __spreadArray2(["line", "direction", direction ? "edge" : "", direction], __read2(classNames186), false)), "data-rotation": rotation, "data-line-key": key2, "data-direction": direction, style: getLineStyle(pos1, pos2, zoom, rad) });
}
function renderEdgeLines(React615, ableName, edge, poses, zoom) {
  var directions2 = edge === true ? DIRECTIONS4 : edge;
  return directions2.map(function(direction, i) {
    var _a = __read2(DIRECTION_INDEXES[direction], 2), index1 = _a[0], index22 = _a[1];
    if (index22 == null) {
      return;
    }
    return renderLine(React615, direction, poses[index1], poses[index22], zoom, "".concat(ableName, "Edge").concat(i), ableName);
  }).filter(Boolean);
}
function getRenderDirections(ableName) {
  return function(moveable, React615) {
    var edge = getProps3(moveable.props, ableName).edge;
    if (edge && (edge === true || edge.length)) {
      return __spreadArray2(__spreadArray2([], __read2(renderEdgeLines(React615, ableName, edge, moveable.getState().renderPoses, moveable.props.zoom)), false), __read2(renderDiagonalDirections(moveable, ableName, React615)), false);
    }
    return renderAllDirections(moveable, ableName, React615);
  };
}
function renderAllDirections(moveable, ableName, React615) {
  return renderDirectionControls(moveable, DIRECTIONS, ableName, React615);
}
function renderDiagonalDirections(moveable, ableName, React615) {
  return renderDirectionControls(moveable, ["nw", "ne", "sw", "se"], ableName, React615);
}
function renderAroundControls(moveable, React615, ableName, renderDirections) {
  var renderState = moveable.renderState;
  if (!renderState.renderDirectionMap) {
    renderState.renderDirectionMap = {};
  }
  var _a = moveable.getState(), renderPoses = _a.renderPoses, rotationRad = _a.rotation, direction = _a.direction;
  var renderDirectionMap = renderState.renderDirectionMap;
  var zoom = moveable.props.zoom;
  var directionSign = sign(direction);
  var degRotation = rotationRad / Math.PI * 180;
  return (renderDirections || getKeys2(renderDirectionMap)).map(function(dir) {
    var indexes = DIRECTION_INDEXES[dir];
    if (!indexes) {
      return null;
    }
    var directionRotation = (throttle3(degRotation, 15) + directionSign * DIRECTION_ROTATIONS[dir] + 720) % 180;
    var classNames186 = ["around-control"];
    if (ableName) {
      classNames186.push("direction", ableName);
    }
    return React615.createElement("div", { className: prefix.apply(void 0, __spreadArray2([], __read2(classNames186), false)), "data-rotation": directionRotation, "data-direction": dir, key: "direction-around-".concat(dir), style: getControlTransform.apply(void 0, __spreadArray2([rotationRad, zoom], __read2(indexes.map(function(index3) {
      return renderPoses[index3];
    })), false)) });
  });
}
function checkBoundPoses(bounds, verticalPoses, horizontalPoses) {
  var _a = bounds || {}, _b = _a.position, position3 = _b === void 0 ? "client" : _b, _c = _a.left, left2 = _c === void 0 ? -Infinity : _c, _d = _a.top, top = _d === void 0 ? -Infinity : _d, _e = _a.right, right2 = _e === void 0 ? Infinity : _e, _f = _a.bottom, bottom = _f === void 0 ? Infinity : _f;
  var nextBounds = {
    position: position3,
    left: left2,
    top,
    right: right2,
    bottom
  };
  return {
    vertical: checkBounds(nextBounds, verticalPoses, true),
    horizontal: checkBounds(nextBounds, horizontalPoses, false)
  };
}
function getBounds(moveable, externalBounds) {
  var _a = moveable.state, _b = _a.containerClientRect, containerHeight = _b.clientHeight, containerWidth = _b.clientWidth, clientLeft = _b.clientLeft, clientTop = _b.clientTop, _c = _a.snapOffset, snapOffsetLeft = _c.left, snapOffsetTop = _c.top, snapOffsetRight = _c.right, snapOffsetBottom = _c.bottom;
  var bounds = externalBounds || moveable.props.bounds || {};
  var position3 = bounds.position || "client";
  var isCSS = position3 === "css";
  var _d = bounds.left, left2 = _d === void 0 ? -Infinity : _d, _e = bounds.top, top = _e === void 0 ? -Infinity : _e;
  var _f = bounds.right, right2 = _f === void 0 ? isCSS ? -Infinity : Infinity : _f, _g = bounds.bottom, bottom = _g === void 0 ? isCSS ? -Infinity : Infinity : _g;
  if (isCSS) {
    right2 = containerWidth + snapOffsetRight - snapOffsetLeft - right2;
    bottom = containerHeight + snapOffsetBottom - snapOffsetTop - bottom;
  }
  return {
    left: left2 + snapOffsetLeft - clientLeft,
    right: right2 + snapOffsetLeft - clientLeft,
    top: top + snapOffsetTop - clientTop,
    bottom: bottom + snapOffsetTop - clientTop
  };
}
function checkBoundKeepRatio(moveable, startPos, endPos) {
  var _a = getBounds(moveable), left2 = _a.left, top = _a.top, right2 = _a.right, bottom = _a.bottom;
  var _b = __read2(endPos, 2), endX = _b[0], endY = _b[1];
  var _c = __read2(minus(endPos, startPos), 2), dx = _c[0], dy = _c[1];
  if (abs2(dx) < TINY_NUM2) {
    dx = 0;
  }
  if (abs2(dy) < TINY_NUM2) {
    dy = 0;
  }
  var isBottom = dy > 0;
  var isRight = dx > 0;
  var verticalInfo = {
    isBound: false,
    offset: 0,
    pos: 0
  };
  var horizontalInfo = {
    isBound: false,
    offset: 0,
    pos: 0
  };
  if (dx === 0 && dy === 0) {
    return {
      vertical: verticalInfo,
      horizontal: horizontalInfo
    };
  } else if (dx === 0) {
    if (isBottom) {
      if (bottom < endY) {
        horizontalInfo.pos = bottom;
        horizontalInfo.offset = endY - bottom;
      }
    } else {
      if (top > endY) {
        horizontalInfo.pos = top;
        horizontalInfo.offset = endY - top;
      }
    }
  } else if (dy === 0) {
    if (isRight) {
      if (right2 < endX) {
        verticalInfo.pos = right2;
        verticalInfo.offset = endX - right2;
      }
    } else {
      if (left2 > endX) {
        verticalInfo.pos = left2;
        verticalInfo.offset = endX - left2;
      }
    }
  } else {
    var a = dy / dx;
    var b = endPos[1] - a * endX;
    var y = 0;
    var x = 0;
    var isBound = false;
    if (isRight && right2 <= endX) {
      y = a * right2 + b;
      x = right2;
      isBound = true;
    } else if (!isRight && endX <= left2) {
      y = a * left2 + b;
      x = left2;
      isBound = true;
    }
    if (isBound) {
      if (y < top || y > bottom) {
        isBound = false;
      }
    }
    if (!isBound) {
      if (isBottom && bottom <= endY) {
        y = bottom;
        x = (y - b) / a;
        isBound = true;
      } else if (!isBottom && endY <= top) {
        y = top;
        x = (y - b) / a;
        isBound = true;
      }
    }
    if (isBound) {
      verticalInfo.isBound = true;
      verticalInfo.pos = x;
      verticalInfo.offset = endX - x;
      horizontalInfo.isBound = true;
      horizontalInfo.pos = y;
      horizontalInfo.offset = endY - y;
    }
  }
  return {
    vertical: verticalInfo,
    horizontal: horizontalInfo
  };
}
function checkBounds(bounds, poses, isVertical) {
  var startBoundPos = bounds[isVertical ? "left" : "top"];
  var endBoundPos = bounds[isVertical ? "right" : "bottom"];
  var minPos = Math.min.apply(Math, __spreadArray2([], __read2(poses), false));
  var maxPos = Math.max.apply(Math, __spreadArray2([], __read2(poses), false));
  var boundInfos = [];
  if (startBoundPos + 1 > minPos) {
    boundInfos.push({
      direction: "start",
      isBound: true,
      offset: minPos - startBoundPos,
      pos: startBoundPos
    });
  }
  if (endBoundPos - 1 < maxPos) {
    boundInfos.push({
      direction: "end",
      isBound: true,
      offset: maxPos - endBoundPos,
      pos: endBoundPos
    });
  }
  if (!boundInfos.length) {
    boundInfos.push({
      isBound: false,
      offset: 0,
      pos: 0
    });
  }
  return boundInfos.sort(function(a, b) {
    return abs2(b.offset) - abs2(a.offset);
  });
}
function isBoundRotate$1(relativePoses, boundRect, rad) {
  var nextPoses = rad ? relativePoses.map(function(pos) {
    return rotate(pos, rad);
  }) : relativePoses;
  return nextPoses.some(function(pos) {
    return pos[0] < boundRect.left && abs2(pos[0] - boundRect.left) > 0.1 || pos[0] > boundRect.right && abs2(pos[0] - boundRect.right) > 0.1 || pos[1] < boundRect.top && abs2(pos[1] - boundRect.top) > 0.1 || pos[1] > boundRect.bottom && abs2(pos[1] - boundRect.bottom) > 0.1;
  });
}
function boundRotate(vec, boundPos, index3) {
  var r2 = getDistSize(vec);
  var nextPos = Math.sqrt(r2 * r2 - boundPos * boundPos) || 0;
  return [nextPos, -nextPos].sort(function(a, b) {
    return abs2(a - vec[index3 ? 0 : 1]) - abs2(b - vec[index3 ? 0 : 1]);
  }).map(function(pos) {
    return getRad([0, 0], index3 ? [pos, boundPos] : [boundPos, pos]);
  });
}
function checkRotateBounds(moveable, prevPoses, nextPoses, origin, rotation) {
  if (!moveable.props.bounds) {
    return [];
  }
  var rad = rotation * Math.PI / 180;
  var _a = getBounds(moveable), left2 = _a.left, top = _a.top, right2 = _a.right, bottom = _a.bottom;
  var relativeLeft = left2 - origin[0];
  var relativeRight = right2 - origin[0];
  var relativeTop = top - origin[1];
  var relativeBottom = bottom - origin[1];
  var boundRect = {
    left: relativeLeft,
    top: relativeTop,
    right: relativeRight,
    bottom: relativeBottom
  };
  if (!isBoundRotate$1(nextPoses, boundRect, 0)) {
    return [];
  }
  var result = [];
  [
    [relativeLeft, 0],
    [relativeRight, 0],
    [relativeTop, 1],
    [relativeBottom, 1]
  ].forEach(function(_a2) {
    var _b = __read2(_a2, 2), boundPos = _b[0], index3 = _b[1];
    nextPoses.forEach(function(nextPos) {
      var relativeRad1 = getRad([0, 0], nextPos);
      result.push.apply(result, __spreadArray2([], __read2(boundRotate(nextPos, boundPos, index3).map(function(relativeRad2) {
        return rad + relativeRad2 - relativeRad1;
      }).filter(function(nextRad) {
        return !isBoundRotate$1(prevPoses, boundRect, nextRad);
      }).map(function(nextRad) {
        return throttle3(nextRad * 180 / Math.PI, TINY_NUM2);
      })), false));
    });
  });
  return result;
}
var VERTICAL_NAMES = ["left", "right", "center"];
var HORIZONTAL_NAMES = ["top", "bottom", "middle"];
var SNAP_SKIP_NAMES_MAP = {
  "left": "start",
  "right": "end",
  "center": "center",
  "top": "start",
  "bottom": "end",
  "middle": "center"
};
var VERTICAL_NAMES_MAP = {
  start: "left",
  end: "right",
  center: "center"
};
var HORIZONTAL_NAMES_MAP = {
  start: "top",
  end: "bottom",
  center: "middle"
};
function getInitialBounds() {
  return {
    left: false,
    top: false,
    right: false,
    bottom: false
  };
}
function hasGuidelines(moveable, ableName) {
  var _a = moveable.props, snappable = _a.snappable, bounds = _a.bounds, innerBounds = _a.innerBounds, verticalGuidelines = _a.verticalGuidelines, horizontalGuidelines = _a.horizontalGuidelines, snapGridWidth = _a.snapGridWidth, snapGridHeight = _a.snapGridHeight, _b = moveable.state, guidelines = _b.guidelines, enableSnap = _b.enableSnap;
  if (!snappable || !enableSnap || ableName && snappable !== true && snappable.indexOf(ableName) < 0) {
    return false;
  }
  if (snapGridWidth || snapGridHeight || bounds || innerBounds || guidelines && guidelines.length || verticalGuidelines && verticalGuidelines.length || horizontalGuidelines && horizontalGuidelines.length) {
    return true;
  }
  return false;
}
function getSnapDirections(snapDirections) {
  if (snapDirections === false) {
    return {};
  } else if (snapDirections === true || !snapDirections) {
    return { left: true, right: true, top: true, bottom: true };
  }
  return snapDirections;
}
function mapSnapDirectionPoses(snapDirections, snapPoses) {
  var nextSnapDirections = getSnapDirections(snapDirections);
  var nextSnapPoses = {};
  for (var name_1 in nextSnapDirections) {
    if (name_1 in snapPoses && nextSnapDirections[name_1]) {
      nextSnapPoses[name_1] = snapPoses[name_1];
    }
  }
  return nextSnapPoses;
}
function splitSnapDirectionPoses(snapDirections, snapPoses) {
  var nextSnapPoses = mapSnapDirectionPoses(snapDirections, snapPoses);
  var horizontalNames = HORIZONTAL_NAMES.filter(function(name) {
    return name in nextSnapPoses;
  });
  var verticalNames = VERTICAL_NAMES.filter(function(name) {
    return name in nextSnapPoses;
  });
  return {
    horizontalNames,
    verticalNames,
    horizontal: horizontalNames.map(function(name) {
      return nextSnapPoses[name];
    }),
    vertical: verticalNames.map(function(name) {
      return nextSnapPoses[name];
    })
  };
}
function calculateContainerPos(rootMatrix, containerRect, n2) {
  var clientPos = calculatePosition(rootMatrix, [containerRect.clientLeft, containerRect.clientTop], n2);
  return [
    containerRect.left + clientPos[0],
    containerRect.top + clientPos[1]
  ];
}
function solveLineConstants(_a) {
  var _b = __read2(_a, 2), point1 = _b[0], point2 = _b[1];
  var dx = point2[0] - point1[0];
  var dy = point2[1] - point1[1];
  if (Math.abs(dx) < TINY_NUM) {
    dx = 0;
  }
  if (Math.abs(dy) < TINY_NUM) {
    dy = 0;
  }
  var a = 0;
  var b = 0;
  var c = 0;
  if (!dx) {
    a = -1;
    c = point1[0];
  } else if (!dy) {
    b = 1;
    c = -point1[1];
  } else {
    a = -dy / dx;
    b = 1;
    c = a * point1[0] - point1[1];
  }
  return [a, b, c].map(function(v) {
    return throttle3(v, TINY_NUM);
  });
}
var NAME_snapRotationThreshold = "snapRotationThreshold";
var NAME_snapRotationDegrees = "snapRotationDegrees";
var NAME_snapHorizontalThreshold = "snapHorizontalThreshold";
var NAME_snapVerticalThreshold = "snapVerticalThreshold";
function checkMoveableSnapPoses(moveable, posesX, posesY, dirXs, dirYs, customSnapVerticalThreshold, customSnapHorizontalThreshold) {
  var _a;
  if (dirXs === void 0) {
    dirXs = [];
  }
  if (dirYs === void 0) {
    dirYs = [];
  }
  var props = moveable.props;
  var snapThresholdMultiples = ((_a = moveable.state.snapThresholdInfo) === null || _a === void 0 ? void 0 : _a.multiples) || [1, 1];
  var snapHorizontalThreshold = selectValue(customSnapHorizontalThreshold, props[NAME_snapHorizontalThreshold], 5);
  var snapVerticalThreshold = selectValue(customSnapVerticalThreshold, props[NAME_snapVerticalThreshold], 5);
  return checkSnapPoses(moveable.state.guidelines, posesX, posesY, dirXs, dirYs, snapHorizontalThreshold, snapVerticalThreshold, snapThresholdMultiples);
}
function checkSnapPoses(guidelines, posesX, posesY, dirXs, dirYs, snapHorizontalThreshold, snapVerticalThreshold, multiples) {
  return {
    vertical: checkSnap(guidelines, "vertical", posesX, snapVerticalThreshold * multiples[0], dirXs),
    horizontal: checkSnap(guidelines, "horizontal", posesY, snapHorizontalThreshold * multiples[1], dirYs)
  };
}
function checkSnapKeepRatio(moveable, startPos, endPos) {
  var _a = __read2(endPos, 2), endX = _a[0], endY = _a[1];
  var _b = __read2(startPos, 2), startX = _b[0], startY = _b[1];
  var _c = __read2(minus(endPos, startPos), 2), dx = _c[0], dy = _c[1];
  var isBottom = dy > 0;
  var isRight = dx > 0;
  dx = getTinyDist(dx);
  dy = getTinyDist(dy);
  var verticalInfo = {
    isSnap: false,
    offset: 0,
    pos: 0
  };
  var horizontalInfo = {
    isSnap: false,
    offset: 0,
    pos: 0
  };
  if (dx === 0 && dy === 0) {
    return {
      vertical: verticalInfo,
      horizontal: horizontalInfo
    };
  }
  var _d = checkMoveableSnapPoses(moveable, dx ? [endX] : [], dy ? [endY] : [], [], [], void 0, void 0), verticalSnapInfo = _d.vertical, horizontalSnapInfo = _d.horizontal;
  verticalSnapInfo.posInfos.filter(function(_a2) {
    var pos = _a2.pos;
    return isRight ? pos >= startX : pos <= startX;
  });
  horizontalSnapInfo.posInfos.filter(function(_a2) {
    var pos = _a2.pos;
    return isBottom ? pos >= startY : pos <= startY;
  });
  verticalSnapInfo.isSnap = verticalSnapInfo.posInfos.length > 0;
  horizontalSnapInfo.isSnap = horizontalSnapInfo.posInfos.length > 0;
  var _e = getNearestSnapGuidelineInfo(verticalSnapInfo), isVerticalSnap = _e.isSnap, verticalGuideline = _e.guideline;
  var _f = getNearestSnapGuidelineInfo(horizontalSnapInfo), isHorizontalSnap = _f.isSnap, horizontalGuideline = _f.guideline;
  var horizontalPos = isHorizontalSnap ? horizontalGuideline.pos[1] : 0;
  var verticalPos = isVerticalSnap ? verticalGuideline.pos[0] : 0;
  if (dx === 0) {
    if (isHorizontalSnap) {
      horizontalInfo.isSnap = true;
      horizontalInfo.pos = horizontalGuideline.pos[1];
      horizontalInfo.offset = endY - horizontalInfo.pos;
    }
  } else if (dy === 0) {
    if (isVerticalSnap) {
      verticalInfo.isSnap = true;
      verticalInfo.pos = verticalPos;
      verticalInfo.offset = endX - verticalPos;
    }
  } else {
    var a = dy / dx;
    var b = endPos[1] - a * endX;
    var y = 0;
    var x = 0;
    var isSnap = false;
    if (isVerticalSnap) {
      x = verticalPos;
      y = a * x + b;
      isSnap = true;
    } else if (isHorizontalSnap) {
      y = horizontalPos;
      x = (y - b) / a;
      isSnap = true;
    }
    if (isSnap) {
      verticalInfo.isSnap = true;
      verticalInfo.pos = x;
      verticalInfo.offset = endX - x;
      horizontalInfo.isSnap = true;
      horizontalInfo.pos = y;
      horizontalInfo.offset = endY - y;
    }
  }
  return {
    vertical: verticalInfo,
    horizontal: horizontalInfo
  };
}
function getStringDirection(dir) {
  var stringDirection = "";
  if (dir === -1 || dir === "top" || dir === "left") {
    stringDirection = "start";
  } else if (dir === 0 || dir === "center" || dir === "middle") {
    stringDirection = "center";
  } else if (dir === 1 || dir === "right" || dir === "bottom") {
    stringDirection = "end";
  }
  return stringDirection;
}
function checkSnaps(moveable, rect, customSnapVerticalThreshold, customSnapHorizontalThreshold) {
  var poses = splitSnapDirectionPoses(moveable.props.snapDirections, rect);
  var result = checkMoveableSnapPoses(moveable, poses.vertical, poses.horizontal, poses.verticalNames.map(function(name) {
    return getStringDirection(name);
  }), poses.horizontalNames.map(function(name) {
    return getStringDirection(name);
  }), customSnapVerticalThreshold, customSnapHorizontalThreshold);
  var horizontalDirection = getStringDirection(poses.horizontalNames[result.horizontal.index]);
  var verticalDirection = getStringDirection(poses.verticalNames[result.vertical.index]);
  return {
    vertical: __assign9(__assign9({}, result.vertical), { direction: verticalDirection }),
    horizontal: __assign9(__assign9({}, result.horizontal), { direction: horizontalDirection })
  };
}
function getNearestSnapGuidelineInfo(snapInfo) {
  var isSnap = snapInfo.isSnap;
  if (!isSnap) {
    return {
      isSnap: false,
      offset: 0,
      dist: -1,
      pos: 0,
      guideline: null
    };
  }
  var posInfo = snapInfo.posInfos[0];
  var guidelineInfo = posInfo.guidelineInfos[0];
  var offset4 = guidelineInfo.offset;
  var dist = guidelineInfo.dist;
  var guideline = guidelineInfo.guideline;
  return {
    isSnap,
    offset: offset4,
    dist,
    pos: posInfo.pos,
    guideline
  };
}
function checkSnap(guidelines, targetType, targetPoses, snapThreshold, dirs) {
  var _a, _b;
  if (dirs === void 0) {
    dirs = [];
  }
  if (!guidelines || !guidelines.length) {
    return {
      isSnap: false,
      index: -1,
      direction: "",
      posInfos: []
    };
  }
  var isVertical = targetType === "vertical";
  var posType = isVertical ? 0 : 1;
  var snapPosInfos = targetPoses.map(function(targetPos, index3) {
    var direction = dirs[index3] || "";
    var guidelineInfos = guidelines.map(function(guideline) {
      var pos = guideline.pos;
      var offset4 = targetPos - pos[posType];
      return {
        offset: offset4,
        dist: abs2(offset4),
        guideline,
        direction
      };
    }).filter(function(_a2) {
      var guideline = _a2.guideline, dist = _a2.dist;
      var type5 = guideline.type;
      if (type5 !== targetType || dist > snapThreshold) {
        return false;
      }
      return true;
    }).sort(function(a, b) {
      return a.dist - b.dist;
    });
    return {
      pos: targetPos,
      index: index3,
      guidelineInfos,
      direction
    };
  }).filter(function(snapPosInfo) {
    return snapPosInfo.guidelineInfos.length > 0;
  }).sort(function(a, b) {
    return a.guidelineInfos[0].dist - b.guidelineInfos[0].dist;
  });
  var isSnap = snapPosInfos.length > 0;
  return {
    isSnap,
    index: isSnap ? snapPosInfos[0].index : -1,
    direction: (_b = (_a = snapPosInfos[0]) === null || _a === void 0 ? void 0 : _a.direction) !== null && _b !== void 0 ? _b : "",
    posInfos: snapPosInfos
  };
}
function getSnapInfosByDirection(moveable, poses, snapDirection, customSnapVerticalThreshold, customSnapHorizontalThreshold) {
  var dirs = [];
  if (snapDirection[0] && snapDirection[1]) {
    dirs = [
      snapDirection,
      [-snapDirection[0], snapDirection[1]],
      [snapDirection[0], -snapDirection[1]]
    ];
  } else if (!snapDirection[0] && !snapDirection[1]) {
    [
      [-1, -1],
      [1, -1],
      [1, 1],
      [-1, 1]
    ].forEach(function(dir, i, arr) {
      var nextDir = arr[i + 1] || arr[0];
      dirs.push(dir);
      dirs.push([
        (dir[0] + nextDir[0]) / 2,
        (dir[1] + nextDir[1]) / 2
      ]);
    });
  } else {
    if (moveable.props.keepRatio) {
      dirs.push([-1, -1], [-1, 1], [1, -1], [1, 1], snapDirection);
    } else {
      dirs.push.apply(dirs, __spreadArray2([], __read2(getPosesByDirection([
        [-1, -1],
        [1, -1],
        [-1, -1],
        [1, 1]
      ], snapDirection)), false));
      if (dirs.length > 1) {
        dirs.push([
          (dirs[0][0] + dirs[1][0]) / 2,
          (dirs[0][1] + dirs[1][1]) / 2
        ]);
      }
    }
  }
  var nextPoses = dirs.map(function(dir) {
    return getPosByDirection(poses, dir);
  });
  var xs = nextPoses.map(function(pos) {
    return pos[0];
  });
  var ys = nextPoses.map(function(pos) {
    return pos[1];
  });
  var result = checkMoveableSnapPoses(moveable, xs, ys, dirs.map(function(dir) {
    return getStringDirection(dir[0]);
  }), dirs.map(function(dir) {
    return getStringDirection(dir[1]);
  }), customSnapVerticalThreshold, customSnapHorizontalThreshold);
  var verticalDirection = getStringDirection(dirs.map(function(dir) {
    return dir[0];
  })[result.vertical.index]);
  var horizontalDirection = getStringDirection(dirs.map(function(dir) {
    return dir[1];
  })[result.horizontal.index]);
  return {
    vertical: __assign9(__assign9({}, result.vertical), { direction: verticalDirection }),
    horizontal: __assign9(__assign9({}, result.horizontal), { direction: horizontalDirection })
  };
}
function checkSnapBoundPriority(a, b) {
  var aDist = abs2(a.offset);
  var bDist = abs2(b.offset);
  if (a.isBound && b.isBound) {
    return bDist - aDist;
  } else if (a.isBound) {
    return -1;
  } else if (b.isBound) {
    return 1;
  } else if (a.isSnap && b.isSnap) {
    return bDist - aDist;
  } else if (a.isSnap) {
    return -1;
  } else if (b.isSnap) {
    return 1;
  } else if (aDist < TINY_NUM2) {
    return 1;
  } else if (bDist < TINY_NUM2) {
    return -1;
  }
  return aDist - bDist;
}
function getNearOffsetInfo(offsets, index3) {
  return offsets.slice().sort(function(a, b) {
    var aSign = a.sign[index3];
    var bSign = b.sign[index3];
    var aOffset = a.offset[index3];
    var bOffset = b.offset[index3];
    if (!aSign) {
      return 1;
    } else if (!bSign) {
      return -1;
    }
    return checkSnapBoundPriority({ isBound: a.isBound, isSnap: a.isSnap, offset: aOffset }, { isBound: b.isBound, isSnap: b.isSnap, offset: bOffset });
  })[0];
}
function getCheckSnapDirections(direction, fixedDirection, keepRatio) {
  var directions2 = [];
  if (keepRatio) {
    if (abs2(fixedDirection[0]) !== 1 || abs2(fixedDirection[1]) !== 1) {
      directions2.push([fixedDirection, [-1, -1]], [fixedDirection, [-1, 1]], [fixedDirection, [1, -1]], [fixedDirection, [1, 1]]);
    } else {
      directions2.push([fixedDirection, [direction[0], -direction[1]]], [fixedDirection, [-direction[0], direction[1]]]);
    }
    directions2.push([fixedDirection, direction]);
  } else {
    if (direction[0] && direction[1] || !direction[0] && !direction[1]) {
      var endDirection_1 = direction[0] ? direction : [1, 1];
      [1, -1].forEach(function(signX) {
        [1, -1].forEach(function(signY) {
          var nextDirection = [signX * endDirection_1[0], signY * endDirection_1[1]];
          if (fixedDirection[0] === nextDirection[0] && fixedDirection[1] === nextDirection[1]) {
            return;
          }
          directions2.push([fixedDirection, nextDirection]);
        });
      });
    } else if (direction[0]) {
      var signs = abs2(fixedDirection[0]) === 1 ? [1] : [1, -1];
      signs.forEach(function(sign2) {
        directions2.push([
          [fixedDirection[0], -1],
          [sign2 * direction[0], -1]
        ], [
          [fixedDirection[0], 0],
          [sign2 * direction[0], 0]
        ], [
          [fixedDirection[0], 1],
          [sign2 * direction[0], 1]
        ]);
      });
    } else if (direction[1]) {
      var signs = abs2(fixedDirection[1]) === 1 ? [1] : [1, -1];
      signs.forEach(function(sign2) {
        directions2.push([
          [-1, fixedDirection[1]],
          [-1, sign2 * direction[1]]
        ], [
          [0, fixedDirection[1]],
          [0, sign2 * direction[1]]
        ], [
          [1, fixedDirection[1]],
          [1, sign2 * direction[1]]
        ]);
      });
    }
  }
  return directions2;
}
function isStartLine(dot2, line2) {
  var cx = average([line2[0][0], line2[1][0]]);
  var cy = average([line2[0][1], line2[1][1]]);
  return {
    vertical: cx <= dot2[0],
    horizontal: cy <= dot2[1]
  };
}
function hitTestLine(dot2, _a) {
  var _b = __read2(_a, 2), pos1 = _b[0], pos2 = _b[1];
  var dx = pos2[0] - pos1[0];
  var dy = pos2[1] - pos1[1];
  if (abs2(dx) < TINY_NUM2) {
    dx = 0;
  }
  if (abs2(dy) < TINY_NUM2) {
    dy = 0;
  }
  var test1;
  var test2;
  if (!dx) {
    test1 = pos1[0];
    test2 = dot2[0];
  } else if (!dy) {
    test1 = pos1[1];
    test2 = dot2[1];
  } else {
    var a = dy / dx;
    test1 = a * (dot2[0] - pos1[0]) + pos1[1];
    test2 = dot2[1];
  }
  return test1 - test2;
}
function isSameStartLine(dots, line2, centerSign, error2) {
  if (error2 === void 0) {
    error2 = TINY_NUM2;
  }
  return dots.every(function(dot2) {
    var value = hitTestLine(dot2, line2);
    var sign2 = value <= 0;
    return sign2 === centerSign || abs2(value) <= error2;
  });
}
function checkInnerBoundDot(pos, start, end, isStart, threshold) {
  if (threshold === void 0) {
    threshold = 0;
  }
  if (isStart && start - threshold <= pos || !isStart && pos <= end + threshold) {
    return {
      isBound: true,
      offset: isStart ? start - pos : end - pos
    };
  }
  return {
    isBound: false,
    offset: 0
  };
}
function checkInnerBound(moveable, _a) {
  var line2 = _a.line, centerSign = _a.centerSign, verticalSign = _a.verticalSign, horizontalSign = _a.horizontalSign, lineConstants = _a.lineConstants;
  var bounds = moveable.props.innerBounds;
  if (!bounds) {
    return {
      isAllBound: false,
      isBound: false,
      isVerticalBound: false,
      isHorizontalBound: false,
      offset: [0, 0]
    };
  }
  var left2 = bounds.left, top = bounds.top, width = bounds.width, height = bounds.height;
  var leftLine = [[left2, top], [left2, top + height]];
  var topLine = [[left2, top], [left2 + width, top]];
  var rightLine = [[left2 + width, top], [left2 + width, top + height]];
  var bottomLine = [[left2, top + height], [left2 + width, top + height]];
  if (isSameStartLine([
    [left2, top],
    [left2 + width, top],
    [left2, top + height],
    [left2 + width, top + height]
  ], line2, centerSign)) {
    return {
      isAllBound: false,
      isBound: false,
      isVerticalBound: false,
      isHorizontalBound: false,
      offset: [0, 0]
    };
  }
  var topBoundInfo = checkLineBoundCollision(line2, lineConstants, topLine, verticalSign);
  var bottomBoundInfo = checkLineBoundCollision(line2, lineConstants, bottomLine, verticalSign);
  var leftBoundInfo = checkLineBoundCollision(line2, lineConstants, leftLine, horizontalSign);
  var rightBoundInfo = checkLineBoundCollision(line2, lineConstants, rightLine, horizontalSign);
  var isAllVerticalBound = topBoundInfo.isBound && bottomBoundInfo.isBound;
  var isVerticalBound = topBoundInfo.isBound || bottomBoundInfo.isBound;
  var isAllHorizontalBound = leftBoundInfo.isBound && rightBoundInfo.isBound;
  var isHorizontalBound = leftBoundInfo.isBound || rightBoundInfo.isBound;
  var verticalOffset = maxOffset(topBoundInfo.offset, bottomBoundInfo.offset);
  var horizontalOffset = maxOffset(leftBoundInfo.offset, rightBoundInfo.offset);
  var offset4 = [0, 0];
  var isBound = false;
  var isAllBound = false;
  if (abs2(horizontalOffset) < abs2(verticalOffset)) {
    offset4 = [verticalOffset, 0];
    isBound = isVerticalBound;
    isAllBound = isAllVerticalBound;
  } else {
    offset4 = [0, horizontalOffset];
    isBound = isHorizontalBound;
    isAllBound = isAllHorizontalBound;
  }
  return {
    isAllBound,
    isVerticalBound,
    isHorizontalBound,
    isBound,
    offset: offset4
  };
}
function checkLineBoundCollision(line2, _a, boundLine, isStart, threshold, isRender) {
  var _b = __read2(_a, 2), a = _b[0], b = _b[1];
  var dot1 = line2[0];
  var boundDot1 = boundLine[0];
  var boundDot2 = boundLine[1];
  var dy2 = getTinyDist(boundDot2[1] - boundDot1[1]);
  var dx2 = getTinyDist(boundDot2[0] - boundDot1[0]);
  var hasDx = b;
  var hasDy = a;
  var slope = -a / b;
  if (!dx2) {
    if (isRender && !hasDy) {
      return {
        isBound: false,
        offset: 0
      };
    } else if (hasDx) {
      var y = slope * (boundDot1[0] - dot1[0]) + dot1[1];
      return checkInnerBoundDot(y, boundDot1[1], boundDot2[1], isStart, threshold);
    } else {
      var offset4 = boundDot1[0] - dot1[0];
      var isBound = abs2(offset4) <= (threshold || 0);
      return {
        isBound,
        offset: isBound ? offset4 : 0
      };
    }
  } else if (!dy2) {
    if (isRender && !hasDx) {
      return {
        isBound: false,
        offset: 0
      };
    } else if (hasDy) {
      var x = (boundDot1[1] - dot1[1]) / slope + dot1[0];
      return checkInnerBoundDot(x, boundDot1[0], boundDot2[0], isStart, threshold);
    } else {
      var offset4 = boundDot1[1] - dot1[1];
      var isBound = abs2(offset4) <= (threshold || 0);
      return {
        isBound,
        offset: isBound ? offset4 : 0
      };
    }
  }
  return {
    isBound: false,
    offset: 0
  };
}
function getInnerBoundInfo(moveable, lineInfos, datas) {
  return lineInfos.map(function(info) {
    var _a = checkInnerBound(moveable, info), isBound = _a.isBound, offset4 = _a.offset, isVerticalBound = _a.isVerticalBound, isHorizontalBound = _a.isHorizontalBound;
    var multiple = info.multiple;
    var sizeOffset = getDragDist({
      datas,
      distX: offset4[0],
      distY: offset4[1]
    }).map(function(size, i) {
      return size * (multiple[i] ? 2 / multiple[i] : 0);
    });
    return {
      sign: multiple,
      isBound,
      isVerticalBound,
      isHorizontalBound,
      isSnap: false,
      offset: sizeOffset
    };
  });
}
function getInnerBoundDragInfo(moveable, poses, datas) {
  var _a;
  var lines = getCheckInnerBoundLineInfos(moveable, poses, [0, 0], false).map(function(info) {
    return __assign9(__assign9({}, info), { multiple: info.multiple.map(function(dir) {
      return abs2(dir) * 2;
    }) });
  });
  var innerBoundInfo = getInnerBoundInfo(moveable, lines, datas);
  var widthOffsetInfo = getNearOffsetInfo(innerBoundInfo, 0);
  var heightOffsetInfo = getNearOffsetInfo(innerBoundInfo, 1);
  var verticalOffset = 0;
  var horizontalOffset = 0;
  var isVerticalBound = widthOffsetInfo.isVerticalBound || heightOffsetInfo.isVerticalBound;
  var isHorizontalBound = widthOffsetInfo.isHorizontalBound || heightOffsetInfo.isHorizontalBound;
  if (isVerticalBound || isHorizontalBound) {
    _a = __read2(getInverseDragDist({
      datas,
      distX: -widthOffsetInfo.offset[0],
      distY: -heightOffsetInfo.offset[1]
    }), 2), verticalOffset = _a[0], horizontalOffset = _a[1];
  }
  return {
    vertical: {
      isBound: isVerticalBound,
      offset: verticalOffset
    },
    horizontal: {
      isBound: isHorizontalBound,
      offset: horizontalOffset
    }
  };
}
function getCheckSnapLineDirections(direction, keepRatio) {
  var lineDirections = [];
  var x = direction[0];
  var y = direction[1];
  if (x && y) {
    lineDirections.push([[0, y * 2], direction, [-x, y]], [[x * 2, 0], direction, [x, -y]]);
  } else if (x) {
    lineDirections.push([[x * 2, 0], [x, 1], [x, -1]]);
    if (keepRatio) {
      lineDirections.push([[0, -1], [x, -1], [-x, -1]], [[0, 1], [x, 1], [-x, 1]]);
    }
  } else if (y) {
    lineDirections.push([[0, y * 2], [1, y], [-1, y]]);
    if (keepRatio) {
      lineDirections.push([[-1, 0], [-1, y], [-1, -y]], [[1, 0], [1, y], [1, -y]]);
    }
  } else {
    lineDirections.push([[-1, 0], [-1, -1], [-1, 1]], [[1, 0], [1, -1], [1, 1]], [[0, -1], [-1, -1], [1, -1]], [[0, 1], [-1, 1], [1, 1]]);
  }
  return lineDirections;
}
function getCheckInnerBoundLineInfos(moveable, poses, direction, keepRatio) {
  var _a = moveable.state, allMatrix = _a.allMatrix, is3d = _a.is3d;
  var virtualPoses = calculatePoses(allMatrix, 100, 100, is3d ? 4 : 3);
  var center = getPosByDirection(virtualPoses, [0, 0]);
  return getCheckSnapLineDirections(direction, keepRatio).map(function(_a2) {
    var _b = __read2(_a2, 3), multiple = _b[0], dir1 = _b[1], dir2 = _b[2];
    var virtualLine = [
      getPosByDirection(virtualPoses, dir1),
      getPosByDirection(virtualPoses, dir2)
    ];
    var lineConstants = solveLineConstants(virtualLine);
    var _c = isStartLine(center, virtualLine), verticalSign = _c.vertical, horizontalSign = _c.horizontal;
    var centerSign = hitTestLine(center, virtualLine) <= 0;
    return {
      multiple,
      centerSign,
      verticalSign,
      horizontalSign,
      lineConstants,
      line: [
        getPosByDirection(poses, dir1),
        getPosByDirection(poses, dir2)
      ]
    };
  });
}
function isBoundRotate(relativePoses, boundDots, center, rad) {
  var nextPoses = rad ? relativePoses.map(function(pos) {
    return rotate(pos, rad);
  }) : relativePoses;
  return [
    [nextPoses[0], nextPoses[1]],
    [nextPoses[1], nextPoses[3]],
    [nextPoses[3], nextPoses[2]],
    [nextPoses[2], nextPoses[0]]
  ].some(function(line2) {
    var centerSign = hitTestLine(center, line2) <= 0;
    return !isSameStartLine(boundDots, line2, centerSign);
  });
}
function getDistPointLine(_a) {
  var _b = __read2(_a, 2), pos1 = _b[0], pos2 = _b[1];
  var dx = pos2[0] - pos1[0];
  var dy = pos2[1] - pos1[1];
  if (!dx) {
    return abs2(pos1[0]);
  }
  if (!dy) {
    return abs2(pos1[1]);
  }
  var a = dy / dx;
  return abs2((-a * pos1[0] + pos1[1]) / Math.sqrt(Math.pow(a, 2) + 1));
}
function solveReverseLine(_a) {
  var _b = __read2(_a, 2), pos1 = _b[0], pos2 = _b[1];
  var dx = pos2[0] - pos1[0];
  var dy = pos2[1] - pos1[1];
  if (!dx) {
    return [pos1[0], 0];
  }
  if (!dy) {
    return [0, pos1[1]];
  }
  var a = dy / dx;
  var b = -a * pos1[0] + pos1[1];
  return [
    -b / (a + 1 / a),
    b / (a * a + 1)
  ];
}
function checkRotateInnerBounds(moveable, prevPoses, nextPoses, origin, rotation) {
  var bounds = moveable.props.innerBounds;
  var rad = rotation * Math.PI / 180;
  if (!bounds) {
    return [];
  }
  var left2 = bounds.left, top = bounds.top, width = bounds.width, height = bounds.height;
  var relativeLeft = left2 - origin[0];
  var relativeRight = left2 + width - origin[0];
  var relativeTop = top - origin[1];
  var relativeBottom = top + height - origin[1];
  var dots = [
    [relativeLeft, relativeTop],
    [relativeRight, relativeTop],
    [relativeLeft, relativeBottom],
    [relativeRight, relativeBottom]
  ];
  var center = getPosByDirection(nextPoses, [0, 0]);
  if (!isBoundRotate(nextPoses, dots, center, 0)) {
    return [];
  }
  var result = [];
  var dotInfos = dots.map(function(dot2) {
    return [
      getDistSize(dot2),
      getRad([0, 0], dot2)
    ];
  });
  [
    [nextPoses[0], nextPoses[1]],
    [nextPoses[1], nextPoses[3]],
    [nextPoses[3], nextPoses[2]],
    [nextPoses[2], nextPoses[0]]
  ].forEach(function(line2) {
    var lineRad = getRad([0, 0], solveReverseLine(line2));
    var lineDist = getDistPointLine(line2);
    result.push.apply(result, __spreadArray2([], __read2(dotInfos.filter(function(_a) {
      var _b = __read2(_a, 1), dotDist = _b[0];
      return dotDist && lineDist <= dotDist;
    }).map(function(_a) {
      var _b = __read2(_a, 2), dotDist = _b[0], dotRad = _b[1];
      var distRad = Math.acos(dotDist ? lineDist / dotDist : 0);
      var nextRad1 = dotRad + distRad;
      var nextRad2 = dotRad - distRad;
      return [
        rad + nextRad1 - lineRad,
        rad + nextRad2 - lineRad
      ];
    }).reduce(function(prev2, cur) {
      prev2.push.apply(prev2, __spreadArray2([], __read2(cur), false));
      return prev2;
    }, []).filter(function(nextRad) {
      return !isBoundRotate(prevPoses, dots, center, nextRad);
    }).map(function(nextRad) {
      return throttle3(nextRad * 180 / Math.PI, TINY_NUM2);
    })), false));
  });
  return result;
}
function checkInnerBoundPoses(moveable) {
  var innerBounds = moveable.props.innerBounds;
  var boundMap = getInitialBounds();
  if (!innerBounds) {
    return {
      boundMap,
      vertical: [],
      horizontal: []
    };
  }
  var _a = moveable.getRect(), pos1 = _a.pos1, pos2 = _a.pos2, pos3 = _a.pos3, pos4 = _a.pos4;
  var poses = [pos1, pos2, pos3, pos4];
  var center = getPosByDirection(poses, [0, 0]);
  var left2 = innerBounds.left, top = innerBounds.top, width = innerBounds.width, height = innerBounds.height;
  var leftLine = [[left2, top], [left2, top + height]];
  var topLine = [[left2, top], [left2 + width, top]];
  var rightLine = [[left2 + width, top], [left2 + width, top + height]];
  var bottomLine = [[left2, top + height], [left2 + width, top + height]];
  var lineInfos = getCheckInnerBoundLineInfos(moveable, poses, [0, 0], false);
  var horizontalPoses = [];
  var verticalPoses = [];
  lineInfos.forEach(function(lineInfo) {
    var line2 = lineInfo.line, lineConstants = lineInfo.lineConstants;
    var _a2 = isStartLine(center, line2), isHorizontalStart = _a2.horizontal, isVerticalStart = _a2.vertical;
    var topBoundInfo = checkLineBoundCollision(line2, lineConstants, topLine, isVerticalStart, 1, true);
    var bottomBoundInfo = checkLineBoundCollision(line2, lineConstants, bottomLine, isVerticalStart, 1, true);
    var leftBoundInfo = checkLineBoundCollision(line2, lineConstants, leftLine, isHorizontalStart, 1, true);
    var rightBoundInfo = checkLineBoundCollision(line2, lineConstants, rightLine, isHorizontalStart, 1, true);
    if (topBoundInfo.isBound && !boundMap.top) {
      horizontalPoses.push(top);
      boundMap.top = true;
    }
    if (bottomBoundInfo.isBound && !boundMap.bottom) {
      horizontalPoses.push(top + height);
      boundMap.bottom = true;
    }
    if (leftBoundInfo.isBound && !boundMap.left) {
      verticalPoses.push(left2);
      boundMap.left = true;
    }
    if (rightBoundInfo.isBound && !boundMap.right) {
      verticalPoses.push(left2 + width);
      boundMap.right = true;
    }
  });
  return {
    boundMap,
    horizontal: horizontalPoses,
    vertical: verticalPoses
  };
}
function solveEquation(pos1, pos2, snapOffset, isVertical) {
  var dx = pos2[0] - pos1[0];
  var dy = pos2[1] - pos1[1];
  if (abs2(dx) < TINY_NUM) {
    dx = 0;
  }
  if (abs2(dy) < TINY_NUM) {
    dy = 0;
  }
  if (!dx) {
    if (!isVertical) {
      return [0, snapOffset];
    }
    return [0, 0];
  }
  if (!dy) {
    if (isVertical) {
      return [snapOffset, 0];
    }
    return [0, 0];
  }
  var a = dy / dx;
  var b = pos1[1] - a * pos1[0];
  if (isVertical) {
    var y = a * (pos2[0] + snapOffset) + b;
    return [snapOffset, y - pos2[1]];
  } else {
    var x = (pos2[1] + snapOffset - b) / a;
    return [x - pos2[0], snapOffset];
  }
}
function solveNextOffset(pos1, pos2, offset4, isVertical, datas) {
  var sizeOffset = solveEquation(pos1, pos2, offset4, isVertical);
  if (!sizeOffset) {
    return {
      isOutside: false,
      offset: [0, 0]
    };
  }
  var size = getDist(pos1, pos2);
  var dist1 = getDist(sizeOffset, pos1);
  var dist2 = getDist(sizeOffset, pos2);
  var isOutside = dist1 > size || dist2 > size;
  var _a = __read2(getDragDist({
    datas,
    distX: sizeOffset[0],
    distY: sizeOffset[1]
  }), 2), widthOffset = _a[0], heightOffset = _a[1];
  return {
    offset: [widthOffset, heightOffset],
    isOutside
  };
}
function getSnapBound(boundInfo, snapInfo) {
  if (boundInfo.isBound) {
    return boundInfo.offset;
  } else if (snapInfo.isSnap) {
    return getNearestSnapGuidelineInfo(snapInfo).offset;
  }
  return 0;
}
function checkThrottleDragRotate(throttleDragRotate, _a, _b, _c, _d) {
  var _e = __read2(_a, 2), distX = _e[0], distY = _e[1];
  var _f = __read2(_b, 2), isVerticalBound = _f[0], isHorizontalBound = _f[1];
  var _g = __read2(_c, 2), isVerticalSnap = _g[0], isHorizontalSnap = _g[1];
  var _h = __read2(_d, 2), verticalOffset = _h[0], horizontalOffset = _h[1];
  var offsetX = -verticalOffset;
  var offsetY = -horizontalOffset;
  if (throttleDragRotate && distX && distY) {
    offsetX = 0;
    offsetY = 0;
    var adjustPoses = [];
    if (isVerticalBound && isHorizontalBound) {
      adjustPoses.push([0, horizontalOffset], [verticalOffset, 0]);
    } else if (isVerticalBound) {
      adjustPoses.push([verticalOffset, 0]);
    } else if (isHorizontalBound) {
      adjustPoses.push([0, horizontalOffset]);
    } else if (isVerticalSnap && isHorizontalSnap) {
      adjustPoses.push([0, horizontalOffset], [verticalOffset, 0]);
    } else if (isVerticalSnap) {
      adjustPoses.push([verticalOffset, 0]);
    } else if (isHorizontalSnap) {
      adjustPoses.push([0, horizontalOffset]);
    }
    if (adjustPoses.length) {
      adjustPoses.sort(function(a, b) {
        return getDistSize(minus([distX, distY], a)) - getDistSize(minus([distX, distY], b));
      });
      var adjustPos = adjustPoses[0];
      if (adjustPos[0] && abs2(distX) > TINY_NUM) {
        offsetX = -adjustPos[0];
        offsetY = distY * abs2(distX + offsetX) / abs2(distX) - distY;
      } else if (adjustPos[1] && abs2(distY) > TINY_NUM) {
        var prevDistY = distY;
        offsetY = -adjustPos[1];
        offsetX = distX * abs2(distY + offsetY) / abs2(prevDistY) - distX;
      }
      if (throttleDragRotate && isHorizontalBound && isVerticalBound) {
        if (abs2(offsetX) > TINY_NUM && abs2(offsetX) < abs2(verticalOffset)) {
          var scale = abs2(verticalOffset) / abs2(offsetX);
          offsetX *= scale;
          offsetY *= scale;
        } else if (abs2(offsetY) > TINY_NUM && abs2(offsetY) < abs2(horizontalOffset)) {
          var scale = abs2(horizontalOffset) / abs2(offsetY);
          offsetX *= scale;
          offsetY *= scale;
        } else {
          offsetX = maxOffset(-verticalOffset, offsetX);
          offsetY = maxOffset(-horizontalOffset, offsetY);
        }
      }
    }
  } else {
    offsetX = distX || isVerticalBound ? -verticalOffset : 0;
    offsetY = distY || isHorizontalBound ? -horizontalOffset : 0;
  }
  return [offsetX, offsetY];
}
function checkSnapBoundsDrag(moveable, distX, distY, throttleDragRotate, ignoreSnap, datas) {
  if (!hasGuidelines(moveable, "draggable")) {
    return [
      {
        isSnap: false,
        isBound: false,
        offset: 0
      },
      {
        isSnap: false,
        isBound: false,
        offset: 0
      }
    ];
  }
  var poses = getAbsolutePoses(datas.absolutePoses, [distX, distY]);
  var _a = getRect2(poses), left2 = _a.left, right2 = _a.right, top = _a.top, bottom = _a.bottom;
  var boundPoses = {
    horizontal: poses.map(function(pos) {
      return pos[1];
    }),
    vertical: poses.map(function(pos) {
      return pos[0];
    })
  };
  var snapDirections = getSnapDirections(moveable.props.snapDirections);
  var snapPoses = splitSnapDirectionPoses(snapDirections, {
    left: left2,
    right: right2,
    top,
    bottom,
    center: (left2 + right2) / 2,
    middle: (top + bottom) / 2
  });
  var _b = checkMoveableSnapBounds(moveable, ignoreSnap, snapPoses, boundPoses), verticalSnapBoundInfo = _b.vertical, horizontalSnapBoundInfo = _b.horizontal;
  var _c = getInnerBoundDragInfo(moveable, poses, datas), verticalInnerBoundInfo = _c.vertical, horizontalInnerBoundInfo = _c.horizontal;
  var isVerticalSnap = verticalSnapBoundInfo.isSnap;
  var isHorizontalSnap = horizontalSnapBoundInfo.isSnap;
  var isVerticalBound = verticalSnapBoundInfo.isBound || verticalInnerBoundInfo.isBound;
  var isHorizontalBound = horizontalSnapBoundInfo.isBound || horizontalInnerBoundInfo.isBound;
  var verticalOffset = maxOffset(verticalSnapBoundInfo.offset, verticalInnerBoundInfo.offset);
  var horizontalOffset = maxOffset(horizontalSnapBoundInfo.offset, horizontalInnerBoundInfo.offset);
  var _d = __read2(checkThrottleDragRotate(throttleDragRotate, [distX, distY], [isVerticalBound, isHorizontalBound], [isVerticalSnap, isHorizontalSnap], [verticalOffset, horizontalOffset]), 2), offsetX = _d[0], offsetY = _d[1];
  return [
    {
      isBound: isVerticalBound,
      isSnap: isVerticalSnap,
      offset: offsetX
    },
    {
      isBound: isHorizontalBound,
      isSnap: isHorizontalSnap,
      offset: offsetY
    }
  ];
}
function checkMoveableSnapBounds(moveable, ignoreSnap, poses, boundPoses) {
  if (boundPoses === void 0) {
    boundPoses = poses;
  }
  var _a = checkBoundPoses(getBounds(moveable), boundPoses.vertical, boundPoses.horizontal), horizontalBoundInfos = _a.horizontal, verticalBoundInfos = _a.vertical;
  var _b = ignoreSnap ? {
    horizontal: { isSnap: false, index: -1 },
    vertical: { isSnap: false, index: -1 }
  } : checkMoveableSnapPoses(moveable, poses.vertical, poses.horizontal, void 0, void 0, void 0, void 0), horizontalSnapInfo = _b.horizontal, verticalSnapInfo = _b.vertical;
  var horizontalOffset = getSnapBound(horizontalBoundInfos[0], horizontalSnapInfo);
  var verticalOffset = getSnapBound(verticalBoundInfos[0], verticalSnapInfo);
  var horizontalDist = abs2(horizontalOffset);
  var verticalDist = abs2(verticalOffset);
  return {
    horizontal: {
      isBound: horizontalBoundInfos[0].isBound,
      isSnap: horizontalSnapInfo.isSnap,
      snapIndex: horizontalSnapInfo.index,
      offset: horizontalOffset,
      dist: horizontalDist,
      bounds: horizontalBoundInfos,
      snap: horizontalSnapInfo
    },
    vertical: {
      isBound: verticalBoundInfos[0].isBound,
      isSnap: verticalSnapInfo.isSnap,
      snapIndex: verticalSnapInfo.index,
      offset: verticalOffset,
      dist: verticalDist,
      bounds: verticalBoundInfos,
      snap: verticalSnapInfo
    }
  };
}
function checkSnapBounds(guideines, bounds, posesX, posesY, snapHorizontalThreshold, snapVerticalThreshold, multiples) {
  if (multiples === void 0) {
    multiples = [1, 1];
  }
  var _a = checkBoundPoses(bounds, posesX, posesY), horizontalBoundInfos = _a.horizontal, verticalBoundInfos = _a.vertical;
  var _b = checkSnapPoses(guideines, posesX, posesY, [], [], snapHorizontalThreshold, snapVerticalThreshold, multiples), horizontalSnapInfo = _b.horizontal, verticalSnapInfo = _b.vertical;
  var horizontalOffset = getSnapBound(horizontalBoundInfos[0], horizontalSnapInfo);
  var verticalOffset = getSnapBound(verticalBoundInfos[0], verticalSnapInfo);
  var horizontalDist = abs2(horizontalOffset);
  var verticalDist = abs2(verticalOffset);
  return {
    horizontal: {
      isBound: horizontalBoundInfos[0].isBound,
      isSnap: horizontalSnapInfo.isSnap,
      snapIndex: horizontalSnapInfo.index,
      offset: horizontalOffset,
      dist: horizontalDist,
      bounds: horizontalBoundInfos,
      snap: horizontalSnapInfo
    },
    vertical: {
      isBound: verticalBoundInfos[0].isBound,
      isSnap: verticalSnapInfo.isSnap,
      snapIndex: verticalSnapInfo.index,
      offset: verticalOffset,
      dist: verticalDist,
      bounds: verticalBoundInfos,
      snap: verticalSnapInfo
    }
  };
}
function checkSnapRightLine(startPos, endPos, snapBoundInfo, keepRatio) {
  var rad = getRad(startPos, endPos) / Math.PI * 180;
  var _a = snapBoundInfo.vertical, isVerticalBound = _a.isBound, isVerticalSnap = _a.isSnap, verticalDist = _a.dist, _b = snapBoundInfo.horizontal, isHorizontalBound = _b.isBound, isHorizontalSnap = _b.isSnap, horizontalDist = _b.dist;
  var rad180 = rad % 180;
  var isHorizontalLine = rad180 < 3 || rad180 > 177;
  var isVerticalLine = rad180 > 87 && rad180 < 93;
  if (horizontalDist < verticalDist) {
    if (isVerticalBound || isVerticalSnap && !isVerticalLine && (!keepRatio || !isHorizontalLine)) {
      return "vertical";
    }
  }
  if (isHorizontalBound || isHorizontalSnap && !isHorizontalLine && (!keepRatio || !isVerticalLine)) {
    return "horizontal";
  }
  return "";
}
function getSnapBoundInfo(moveable, poses, directions2, keepRatio, isRequest, datas) {
  return directions2.map(function(_a) {
    var _b = __read2(_a, 2), startDirection = _b[0], endDirection = _b[1];
    var otherStartPos = getPosByDirection(poses, startDirection);
    var otherEndPos = getPosByDirection(poses, endDirection);
    var snapBoundInfo = keepRatio ? checkSnapBoundsKeepRatio(moveable, otherStartPos, otherEndPos, isRequest) : checkMoveableSnapBounds(moveable, isRequest, {
      vertical: [otherEndPos[0]],
      horizontal: [otherEndPos[1]]
    });
    var _c = snapBoundInfo.horizontal, otherHorizontalOffset = _c.offset, isOtherHorizontalBound = _c.isBound, isOtherHorizontalSnap = _c.isSnap, _d = snapBoundInfo.vertical, otherVerticalOffset = _d.offset, isOtherVerticalBound = _d.isBound, isOtherVerticalSnap = _d.isSnap;
    var multiple = minus(endDirection, startDirection);
    if (!otherVerticalOffset && !otherHorizontalOffset) {
      return {
        isBound: isOtherVerticalBound || isOtherHorizontalBound,
        isSnap: isOtherVerticalSnap || isOtherHorizontalSnap,
        sign: multiple,
        offset: [0, 0]
      };
    }
    var snapLine = checkSnapRightLine(otherStartPos, otherEndPos, snapBoundInfo, keepRatio);
    if (!snapLine) {
      return {
        sign: multiple,
        isBound: false,
        isSnap: false,
        offset: [0, 0]
      };
    }
    var isVertical = snapLine === "vertical";
    var sizeOffset = [0, 0];
    if (!keepRatio && abs2(endDirection[0]) === 1 && abs2(endDirection[1]) === 1 && startDirection[0] !== endDirection[0] && startDirection[1] !== endDirection[1]) {
      sizeOffset = getDragDist({
        datas,
        distX: -otherVerticalOffset,
        distY: -otherHorizontalOffset
      });
    } else {
      sizeOffset = solveNextOffset(otherStartPos, otherEndPos, -(isVertical ? otherVerticalOffset : otherHorizontalOffset), isVertical, datas).offset;
    }
    sizeOffset = sizeOffset.map(function(size, i) {
      return size * (multiple[i] ? 2 / multiple[i] : 0);
    });
    return {
      sign: multiple,
      isBound: isVertical ? isOtherVerticalBound : isOtherHorizontalBound,
      isSnap: isVertical ? isOtherVerticalSnap : isOtherHorizontalSnap,
      offset: sizeOffset
    };
  });
}
function getSnapBoundOffset(boundInfo, snapInfo) {
  if (boundInfo.isBound) {
    return boundInfo.offset;
  } else if (snapInfo.isSnap) {
    return snapInfo.offset;
  }
  return 0;
}
function checkSnapBoundsKeepRatio(moveable, startPos, endPos, isRequest) {
  var _a = checkBoundKeepRatio(moveable, startPos, endPos), horizontalBoundInfo = _a.horizontal, verticalBoundInfo = _a.vertical;
  var _b = isRequest ? {
    horizontal: { isSnap: false },
    vertical: { isSnap: false }
  } : checkSnapKeepRatio(moveable, startPos, endPos), horizontalSnapInfo = _b.horizontal, verticalSnapInfo = _b.vertical;
  var horizontalOffset = getSnapBoundOffset(horizontalBoundInfo, horizontalSnapInfo);
  var verticalOffset = getSnapBoundOffset(verticalBoundInfo, verticalSnapInfo);
  var horizontalDist = abs2(horizontalOffset);
  var verticalDist = abs2(verticalOffset);
  return {
    horizontal: {
      isBound: horizontalBoundInfo.isBound,
      isSnap: horizontalSnapInfo.isSnap,
      offset: horizontalOffset,
      dist: horizontalDist
    },
    vertical: {
      isBound: verticalBoundInfo.isBound,
      isSnap: verticalSnapInfo.isSnap,
      offset: verticalOffset,
      dist: verticalDist
    }
  };
}
function checkMaxBounds(moveable, poses, direction, fixedPosition, datas) {
  var fixedDirection = [-direction[0], -direction[1]];
  var _a = moveable.state, width = _a.width, height = _a.height;
  var bounds = moveable.props.bounds;
  var maxWidth = Infinity;
  var maxHeight = Infinity;
  if (bounds) {
    var directions2 = [
      [direction[0], -direction[1]],
      [-direction[0], direction[1]]
    ];
    var _b = bounds.left, left_1 = _b === void 0 ? -Infinity : _b, _c = bounds.top, top_1 = _c === void 0 ? -Infinity : _c, _d = bounds.right, right_1 = _d === void 0 ? Infinity : _d, _e = bounds.bottom, bottom_1 = _e === void 0 ? Infinity : _e;
    directions2.forEach(function(otherDirection) {
      var isCheckVertical = otherDirection[0] !== fixedDirection[0];
      var isCheckHorizontal = otherDirection[1] !== fixedDirection[1];
      var otherPos = getPosByDirection(poses, otherDirection);
      var deg = getRad(fixedPosition, otherPos) * 360 / Math.PI;
      if (isCheckHorizontal) {
        var nextOtherPos = otherPos.slice();
        if (abs2(deg - 360) < 2 || abs2(deg - 180) < 2) {
          nextOtherPos[1] = fixedPosition[1];
        }
        var _a2 = solveNextOffset(fixedPosition, nextOtherPos, (fixedPosition[1] < otherPos[1] ? bottom_1 : top_1) - otherPos[1], false, datas), _b2 = __read2(_a2.offset, 2), heightOffset = _b2[1], isHeightOutside = _a2.isOutside;
        if (!isNaN(heightOffset)) {
          maxHeight = height + (isHeightOutside ? 1 : -1) * abs2(heightOffset);
        }
      }
      if (isCheckVertical) {
        var nextOtherPos = otherPos.slice();
        if (abs2(deg - 90) < 2 || abs2(deg - 270) < 2) {
          nextOtherPos[0] = fixedPosition[0];
        }
        var _c2 = solveNextOffset(fixedPosition, nextOtherPos, (fixedPosition[0] < otherPos[0] ? right_1 : left_1) - otherPos[0], true, datas), _d2 = __read2(_c2.offset, 1), widthOffset = _d2[0], isWidthOutside = _c2.isOutside;
        if (!isNaN(widthOffset)) {
          maxWidth = width + (isWidthOutside ? 1 : -1) * abs2(widthOffset);
        }
      }
    });
  }
  return {
    maxWidth,
    maxHeight
  };
}
var Draggable2 = {
  name: "draggable",
  props: [
    "draggable",
    "throttleDrag",
    "throttleDragRotate",
    "hideThrottleDragRotateLine",
    "startDragRotate",
    "edgeDraggable"
  ],
  events: [
    "dragStart",
    "drag",
    "dragEnd",
    "dragGroupStart",
    "dragGroup",
    "dragGroupEnd"
  ],
  requestStyle: function() {
    return ["left", "top", "right", "bottom"];
  },
  requestChildStyle: function() {
    return ["left", "top", "right", "bottom"];
  },
  render: function(moveable, React615) {
    var _a = moveable.props, hideThrottleDragRotateLine = _a.hideThrottleDragRotateLine, throttleDragRotate = _a.throttleDragRotate, zoom = _a.zoom;
    var _b = moveable.getState(), dragInfo = _b.dragInfo, beforeOrigin = _b.beforeOrigin;
    if (hideThrottleDragRotateLine || !throttleDragRotate || !dragInfo) {
      return [];
    }
    var dist = dragInfo.dist;
    if (!dist[0] && !dist[1]) {
      return [];
    }
    var width = getDistSize(dist);
    var rad = getRad(dist, [0, 0]);
    return [React615.createElement("div", { className: prefix("line", "horizontal", "dragline", "dashed"), key: "dragRotateGuideline", style: {
      width: "".concat(width, "px"),
      transform: "translate(".concat(beforeOrigin[0], "px, ").concat(beforeOrigin[1], "px) rotate(").concat(rad, "rad) scaleY(").concat(zoom, ")")
    } })];
  },
  dragStart: function(moveable, e3) {
    var datas = e3.datas, parentEvent = e3.parentEvent, parentGesto = e3.parentGesto;
    var state = moveable.state;
    var gestos = state.gestos, style2 = state.style;
    if (gestos.draggable) {
      return false;
    }
    gestos.draggable = parentGesto || moveable.targetGesto;
    datas.datas = {};
    datas.left = parseFloat(style2.left || "") || 0;
    datas.top = parseFloat(style2.top || "") || 0;
    datas.bottom = parseFloat(style2.bottom || "") || 0;
    datas.right = parseFloat(style2.right || "") || 0;
    datas.startValue = [0, 0];
    setDragStart(moveable, e3);
    setDefaultTransformIndex(moveable, e3, "translate");
    startCheckSnapDrag(moveable, datas);
    datas.prevDist = [0, 0];
    datas.prevBeforeDist = [0, 0];
    datas.isDrag = false;
    datas.deltaOffset = [0, 0];
    var params = fillParams(moveable, e3, __assign9({ set: function(translate) {
      datas.startValue = translate;
    } }, fillTransformStartEvent(moveable, e3)));
    var result = parentEvent || triggerEvent(moveable, "onDragStart", params);
    if (result !== false) {
      datas.isDrag = true;
      moveable.state.dragInfo = {
        startRect: moveable.getRect(),
        dist: [0, 0]
      };
    } else {
      gestos.draggable = null;
      datas.isPinch = false;
    }
    return datas.isDrag ? params : false;
  },
  drag: function(moveable, e3) {
    if (!e3) {
      return;
    }
    resolveTransformEvent(moveable, e3, "translate");
    var datas = e3.datas, parentEvent = e3.parentEvent, parentFlag = e3.parentFlag, isPinch = e3.isPinch, deltaOffset = e3.deltaOffset, useSnap = e3.useSnap, isRequest = e3.isRequest, isGroup = e3.isGroup, parentThrottleDrag = e3.parentThrottleDrag;
    var distX = e3.distX, distY = e3.distY;
    var isDrag = datas.isDrag, prevDist = datas.prevDist, prevBeforeDist = datas.prevBeforeDist, startValue = datas.startValue;
    if (!isDrag) {
      return;
    }
    if (deltaOffset) {
      distX += deltaOffset[0];
      distY += deltaOffset[1];
    }
    var props = moveable.props;
    var parentMoveable = props.parentMoveable;
    var throttleDrag = isGroup ? 0 : props.throttleDrag || parentThrottleDrag || 0;
    var throttleDragRotate = parentEvent ? 0 : props.throttleDragRotate || 0;
    var dragRotateRad = 0;
    var isVerticalSnap = false;
    var isVerticalBound = false;
    var isHorizontalSnap = false;
    var isHorizontalBound = false;
    if (!parentEvent && throttleDragRotate > 0 && (distX || distY)) {
      var startDragRotate = props.startDragRotate || 0;
      var deg = throttle3(startDragRotate + getRad([0, 0], [distX, distY]) * 180 / Math.PI, throttleDragRotate) - startDragRotate;
      var ry = distY * Math.abs(Math.cos((deg - 90) / 180 * Math.PI));
      var rx = distX * Math.abs(Math.cos(deg / 180 * Math.PI));
      var r2 = getDistSize([rx, ry]);
      dragRotateRad = deg * Math.PI / 180;
      distX = r2 * Math.cos(dragRotateRad);
      distY = r2 * Math.sin(dragRotateRad);
    }
    if (!isPinch && !parentEvent && !parentFlag) {
      var _a = __read2(checkSnapBoundsDrag(moveable, distX, distY, throttleDragRotate, !useSnap && isRequest || deltaOffset, datas), 2), verticalInfo = _a[0], horizontalInfo = _a[1];
      isVerticalSnap = verticalInfo.isSnap;
      isVerticalBound = verticalInfo.isBound;
      isHorizontalSnap = horizontalInfo.isSnap;
      isHorizontalBound = horizontalInfo.isBound;
      var verticalOffset = verticalInfo.offset;
      var horizontalOffset = horizontalInfo.offset;
      distX += verticalOffset;
      distY += horizontalOffset;
    }
    var beforeTranslate = plus(getBeforeDragDist({ datas, distX, distY }), startValue);
    var translate = plus(getTransformDist({ datas, distX, distY }), startValue);
    throttleArray(translate, TINY_NUM2);
    throttleArray(beforeTranslate, TINY_NUM2);
    if (!throttleDragRotate) {
      if (!isVerticalSnap && !isVerticalBound) {
        translate[0] = throttle3(translate[0], throttleDrag);
        beforeTranslate[0] = throttle3(beforeTranslate[0], throttleDrag);
      }
      if (!isHorizontalSnap && !isHorizontalBound) {
        translate[1] = throttle3(translate[1], throttleDrag);
        beforeTranslate[1] = throttle3(beforeTranslate[1], throttleDrag);
      }
    }
    var beforeDist = minus(beforeTranslate, startValue);
    var dist = minus(translate, startValue);
    var delta = minus(dist, prevDist);
    var beforeDelta = minus(beforeDist, prevBeforeDist);
    datas.prevDist = dist;
    datas.prevBeforeDist = beforeDist;
    datas.passDelta = delta;
    datas.passDist = dist;
    var left2 = datas.left + beforeDist[0];
    var top = datas.top + beforeDist[1];
    var right2 = datas.right - beforeDist[0];
    var bottom = datas.bottom - beforeDist[1];
    var nextTransform = convertTransformFormat(datas, "translate(".concat(translate[0], "px, ").concat(translate[1], "px)"), "translate(".concat(dist[0], "px, ").concat(dist[1], "px)"));
    fillOriginalTransform(e3, nextTransform);
    moveable.state.dragInfo.dist = parentEvent ? [0, 0] : dist;
    if (!parentEvent && !parentMoveable && delta.every(function(num) {
      return !num;
    }) && beforeDelta.some(function(num) {
      return !num;
    })) {
      return;
    }
    var _b = moveable.state, width = _b.width, height = _b.height;
    var params = fillParams(moveable, e3, __assign9({ transform: nextTransform, dist, delta, translate, beforeDist, beforeDelta, beforeTranslate, left: left2, top, right: right2, bottom, width, height, isPinch }, fillCSSObject({
      transform: nextTransform
    }, e3)));
    !parentEvent && triggerEvent(moveable, "onDrag", params);
    return params;
  },
  dragAfter: function(moveable, e3) {
    var datas = e3.datas;
    var deltaOffset = datas.deltaOffset;
    if (deltaOffset[0] || deltaOffset[1]) {
      datas.deltaOffset = [0, 0];
      return this.drag(moveable, __assign9(__assign9({}, e3), { deltaOffset }));
    }
    return false;
  },
  dragEnd: function(moveable, e3) {
    var parentEvent = e3.parentEvent, datas = e3.datas;
    moveable.state.dragInfo = null;
    if (!datas.isDrag) {
      return;
    }
    datas.isDrag = false;
    var param = fillEndParams(moveable, e3, {});
    !parentEvent && triggerEvent(moveable, "onDragEnd", param);
    return param;
  },
  dragGroupStart: function(moveable, e3) {
    var _a, _b;
    var datas = e3.datas, clientX = e3.clientX, clientY = e3.clientY;
    var params = this.dragStart(moveable, e3);
    if (!params) {
      return false;
    }
    var _c = triggerChildGesto(moveable, this, "dragStart", [
      clientX || 0,
      clientY || 0
    ], e3, false, "draggable"), childEvents = _c.childEvents, eventParams = _c.eventParams;
    var nextParams = __assign9(__assign9({}, params), { targets: moveable.props.targets, events: eventParams });
    var result = triggerEvent(moveable, "onDragGroupStart", nextParams);
    datas.isDrag = result !== false;
    var startValue = (_b = (_a = childEvents[0]) === null || _a === void 0 ? void 0 : _a.datas.startValue) !== null && _b !== void 0 ? _b : [0, 0];
    datas.throttleOffset = [startValue[0] % 1, startValue[1] % 1];
    return datas.isDrag ? params : false;
  },
  dragGroup: function(moveable, e3) {
    var datas = e3.datas;
    if (!datas.isDrag) {
      return;
    }
    var params = this.drag(moveable, __assign9(__assign9({}, e3), { parentThrottleDrag: moveable.props.throttleDrag }));
    var passDelta = e3.datas.passDelta;
    var eventParams = triggerChildGesto(moveable, this, "drag", passDelta, e3, false, "draggable").eventParams;
    if (!params) {
      return;
    }
    var nextParams = __assign9({ targets: moveable.props.targets, events: eventParams }, params);
    triggerEvent(moveable, "onDragGroup", nextParams);
    return nextParams;
  },
  dragGroupEnd: function(moveable, e3) {
    var isDrag = e3.isDrag, datas = e3.datas;
    if (!datas.isDrag) {
      return;
    }
    this.dragEnd(moveable, e3);
    var eventParams = triggerChildGesto(moveable, this, "dragEnd", [0, 0], e3, false, "draggable").eventParams;
    triggerEvent(moveable, "onDragGroupEnd", fillEndParams(moveable, e3, {
      targets: moveable.props.targets,
      events: eventParams
    }));
    return isDrag;
  },
  /**
       * @method Moveable.Draggable#request
       * @param {object} [e] - the draggable's request parameter
       * @param {number} [e.x] - x position
       * @param {number} [e.y] - y position
       * @param {number} [e.deltaX] - X number to move
       * @param {number} [e.deltaY] - Y number to move
       * @return {Moveable.Requester} Moveable Requester
       * @example
  
       * // Instantly Request (requestStart - request - requestEnd)
       * // Use Relative Value
       * moveable.request("draggable", { deltaX: 10, deltaY: 10 }, true);
       * // Use Absolute Value
       * moveable.request("draggable", { x: 200, y: 100 }, true);
       *
       * // requestStart
       * const requester = moveable.request("draggable");
       *
       * // request
       * // Use Relative Value
       * requester.request({ deltaX: 10, deltaY: 10 });
       * requester.request({ deltaX: 10, deltaY: 10 });
       * requester.request({ deltaX: 10, deltaY: 10 });
       * // Use Absolute Value
       * moveable.request("draggable", { x: 200, y: 100 });
       * moveable.request("draggable", { x: 220, y: 100 });
       * moveable.request("draggable", { x: 240, y: 100 });
       *
       * // requestEnd
       * requester.requestEnd();
       */
  request: function(moveable) {
    var datas = {};
    var rect = moveable.getRect();
    var distX = 0;
    var distY = 0;
    var useSnap = false;
    return {
      isControl: false,
      requestStart: function(e3) {
        useSnap = e3.useSnap;
        return { datas, useSnap };
      },
      request: function(e3) {
        if ("x" in e3) {
          distX = e3.x - rect.left;
        } else if ("deltaX" in e3) {
          distX += e3.deltaX;
        }
        if ("y" in e3) {
          distY = e3.y - rect.top;
        } else if ("deltaY" in e3) {
          distY += e3.deltaY;
        }
        return { datas, distX, distY, useSnap };
      },
      requestEnd: function() {
        return { datas, isDrag: true, useSnap };
      }
    };
  },
  unset: function(moveable) {
    moveable.state.gestos.draggable = null;
    moveable.state.dragInfo = null;
  }
};
function getFixedDirectionInfo(startPositions, fixedDirection) {
  var fixedPosition = getPosByDirection(startPositions, fixedDirection);
  var fixedOffset = [0, 0];
  return {
    fixedPosition,
    fixedDirection,
    fixedOffset
  };
}
function getOffsetFixedDirectionInfo(state, fixedDirection) {
  var allMatrix = state.allMatrix, is3d = state.is3d, width = state.width, height = state.height;
  var n2 = is3d ? 4 : 3;
  var nextFixedOffset = [
    width / 2 * (1 + fixedDirection[0]),
    height / 2 * (1 + fixedDirection[1])
  ];
  var fixedPosition = calculatePosition(allMatrix, nextFixedOffset, n2);
  var fixedOffset = [0, 0];
  return {
    fixedPosition,
    fixedDirection,
    fixedOffset
  };
}
function getOffsetFixedPositionInfo(state, offsetFixedPosition) {
  var allMatrix = state.allMatrix, is3d = state.is3d, width = state.width, height = state.height;
  var n2 = is3d ? 4 : 3;
  var fixedDirection = getDirectionByPos(offsetFixedPosition, width, height);
  var nextFixedPosition = calculatePosition(allMatrix, offsetFixedPosition, n2);
  var fixedOffset = [
    width ? 0 : offsetFixedPosition[0],
    height ? 0 : offsetFixedPosition[1]
  ];
  return {
    fixedPosition: nextFixedPosition,
    fixedDirection,
    fixedOffset
  };
}
var directionCondition$2 = getDirectionCondition("resizable");
var Resizable = {
  name: "resizable",
  ableGroup: "size",
  canPinch: true,
  props: [
    "resizable",
    "throttleResize",
    "renderDirections",
    "displayAroundControls",
    "keepRatio",
    "resizeFormat",
    "keepRatioFinally",
    "edge",
    "checkResizableError"
  ],
  events: [
    "resizeStart",
    "beforeResize",
    "resize",
    "resizeEnd",
    "resizeGroupStart",
    "beforeResizeGroup",
    "resizeGroup",
    "resizeGroupEnd"
  ],
  render: getRenderDirections("resizable"),
  dragControlCondition: directionCondition$2,
  viewClassName: getDirectionViewClassName("resizable"),
  dragControlStart: function(moveable, e3) {
    var _a;
    var inputEvent = e3.inputEvent, isPinch = e3.isPinch, isGroup = e3.isGroup, parentDirection = e3.parentDirection, parentGesto = e3.parentGesto, datas = e3.datas, parentFixedDirection = e3.parentFixedDirection, parentEvent = e3.parentEvent;
    var direction = getTotalDirection(parentDirection, isPinch, inputEvent, datas);
    var state = moveable.state;
    var target = state.target, width = state.width, height = state.height, gestos = state.gestos;
    if (!direction || !target) {
      return false;
    }
    if (gestos.resizable) {
      return false;
    }
    gestos.resizable = parentGesto || moveable.controlGesto;
    !isPinch && setDragStart(moveable, e3);
    datas.datas = {};
    datas.direction = direction;
    datas.startOffsetWidth = width;
    datas.startOffsetHeight = height;
    datas.prevWidth = 0;
    datas.prevHeight = 0;
    datas.minSize = [0, 0];
    datas.startWidth = state.inlineCSSWidth || state.cssWidth;
    datas.startHeight = state.inlineCSSHeight || state.cssHeight;
    datas.maxSize = [Infinity, Infinity];
    if (!isGroup) {
      datas.minSize = [
        state.minOffsetWidth,
        state.minOffsetHeight
      ];
      datas.maxSize = [
        state.maxOffsetWidth,
        state.maxOffsetHeight
      ];
    }
    var transformOrigin = moveable.props.transformOrigin || "% %";
    datas.transformOrigin = transformOrigin && isString2(transformOrigin) ? transformOrigin.split(" ") : transformOrigin;
    datas.startOffsetMatrix = state.offsetMatrix;
    datas.startTransformOrigin = state.transformOrigin;
    datas.isWidth = (_a = e3 === null || e3 === void 0 ? void 0 : e3.parentIsWidth) !== null && _a !== void 0 ? _a : !direction[0] && !direction[1] || direction[0] || !direction[1];
    function setRatio(ratio) {
      datas.ratio = ratio && isFinite(ratio) ? ratio : 0;
    }
    datas.startPositions = getAbsolutePosesByState(moveable.state);
    function setFixedDirection(fixedDirection) {
      var result2 = getFixedDirectionInfo(datas.startPositions, fixedDirection);
      datas.fixedDirection = result2.fixedDirection;
      datas.fixedPosition = result2.fixedPosition;
      datas.fixedOffset = result2.fixedOffset;
    }
    function setFixedPosition(fixedPosition) {
      var result2 = getOffsetFixedPositionInfo(moveable.state, fixedPosition);
      datas.fixedDirection = result2.fixedDirection;
      datas.fixedPosition = result2.fixedPosition;
      datas.fixedOffset = result2.fixedOffset;
    }
    function setMin(minSize) {
      datas.minSize = [
        convertUnitSize("".concat(minSize[0]), 0) || 0,
        convertUnitSize("".concat(minSize[1]), 0) || 0
      ];
    }
    function setMax(maxSize) {
      var nextMaxSize = [
        maxSize[0] || Infinity,
        maxSize[1] || Infinity
      ];
      if (!isNumber3(nextMaxSize[0]) || isFinite(nextMaxSize[0])) {
        nextMaxSize[0] = convertUnitSize("".concat(nextMaxSize[0]), 0) || Infinity;
      }
      if (!isNumber3(nextMaxSize[1]) || isFinite(nextMaxSize[1])) {
        nextMaxSize[1] = convertUnitSize("".concat(nextMaxSize[1]), 0) || Infinity;
      }
      datas.maxSize = nextMaxSize;
    }
    setRatio(width / height);
    setFixedDirection(parentFixedDirection || [-direction[0], -direction[1]]);
    datas.setFixedDirection = setFixedDirection;
    datas.setFixedPosition = setFixedPosition;
    datas.setMin = setMin;
    datas.setMax = setMax;
    var params = fillParams(moveable, e3, {
      direction,
      startRatio: datas.ratio,
      set: function(_a2) {
        var _b = __read2(_a2, 2), startWidth = _b[0], startHeight = _b[1];
        datas.startWidth = startWidth;
        datas.startHeight = startHeight;
      },
      setMin,
      setMax,
      setRatio,
      setFixedDirection,
      setFixedPosition,
      setOrigin: function(origin) {
        datas.transformOrigin = origin;
      },
      dragStart: Draggable2.dragStart(moveable, new CustomGesto().dragStart([0, 0], e3))
    });
    var result = parentEvent || triggerEvent(moveable, "onResizeStart", params);
    datas.startFixedDirection = datas.fixedDirection;
    datas.startFixedPosition = datas.fixedPosition;
    if (result !== false) {
      datas.isResize = true;
      moveable.state.snapRenderInfo = {
        request: e3.isRequest,
        direction
      };
    }
    return datas.isResize ? params : false;
  },
  dragControl: function(moveable, e3) {
    var _a;
    var datas = e3.datas, parentFlag = e3.parentFlag, isPinch = e3.isPinch, parentKeepRatio = e3.parentKeepRatio, dragClient = e3.dragClient, parentDist = e3.parentDist, useSnap = e3.useSnap, isRequest = e3.isRequest, isGroup = e3.isGroup, parentEvent = e3.parentEvent, resolveMatrix = e3.resolveMatrix;
    var isResize = datas.isResize, transformOrigin = datas.transformOrigin, startWidth = datas.startWidth, startHeight = datas.startHeight, prevWidth = datas.prevWidth, prevHeight = datas.prevHeight, minSize = datas.minSize, maxSize = datas.maxSize, ratio = datas.ratio, startOffsetWidth = datas.startOffsetWidth, startOffsetHeight = datas.startOffsetHeight, isWidth = datas.isWidth;
    if (!isResize) {
      return;
    }
    if (resolveMatrix) {
      var is3d = moveable.state.is3d;
      var startOffsetMatrix = datas.startOffsetMatrix, startTransformOrigin = datas.startTransformOrigin;
      var n2 = is3d ? 4 : 3;
      var targetMatrix = parseMat(getNextTransforms(e3));
      var targetN = Math.sqrt(targetMatrix.length);
      if (n2 !== targetN) {
        targetMatrix = convertDimension(targetMatrix, targetN, n2);
      }
      var nextAllMatrix = getNextMatrix(startOffsetMatrix, targetMatrix, startTransformOrigin, n2);
      var poses = calculatePoses(nextAllMatrix, startOffsetWidth, startOffsetHeight, n2);
      datas.startPositions = poses;
      datas.nextTargetMatrix = targetMatrix;
      datas.nextAllMatrix = nextAllMatrix;
    }
    var props = getProps3(moveable.props, "resizable");
    var resizeFormat = props.resizeFormat, _b = props.throttleResize, throttleResize = _b === void 0 ? parentFlag ? 0 : 1 : _b, parentMoveable = props.parentMoveable, keepRatioFinally = props.keepRatioFinally;
    var direction = datas.direction;
    var sizeDirection = direction;
    var distWidth = 0;
    var distHeight = 0;
    if (!direction[0] && !direction[1]) {
      sizeDirection = [1, 1];
    }
    var keepRatio = ratio && (parentKeepRatio != null ? parentKeepRatio : props.keepRatio) || false;
    function getNextBoundingSize() {
      var fixedDirection = datas.fixedDirection;
      var nextSize = getOffsetSizeDist(sizeDirection, keepRatio, datas, e3);
      distWidth = nextSize.distWidth;
      distHeight = nextSize.distHeight;
      var nextWidth2 = sizeDirection[0] - fixedDirection[0] || keepRatio ? Math.max(startOffsetWidth + distWidth, TINY_NUM2) : startOffsetWidth;
      var nextHeight2 = sizeDirection[1] - fixedDirection[1] || keepRatio ? Math.max(startOffsetHeight + distHeight, TINY_NUM2) : startOffsetHeight;
      if (keepRatio && startOffsetWidth && startOffsetHeight) {
        if (isWidth) {
          nextHeight2 = nextWidth2 / ratio;
        } else {
          nextWidth2 = nextHeight2 * ratio;
        }
      }
      return [nextWidth2, nextHeight2];
    }
    var _c = __read2(getNextBoundingSize(), 2), boundingWidth = _c[0], boundingHeight = _c[1];
    if (!parentEvent) {
      datas.setFixedDirection(datas.fixedDirection);
      triggerEvent(moveable, "onBeforeResize", fillParams(moveable, e3, {
        startFixedDirection: datas.startFixedDirection,
        startFixedPosition: datas.startFixedPosition,
        setFixedDirection: function(nextFixedDirection) {
          var _a2;
          datas.setFixedDirection(nextFixedDirection);
          _a2 = __read2(getNextBoundingSize(), 2), boundingWidth = _a2[0], boundingHeight = _a2[1];
          return [boundingWidth, boundingHeight];
        },
        setFixedPosition: function(nextFixedPosition) {
          var _a2;
          datas.setFixedPosition(nextFixedPosition);
          _a2 = __read2(getNextBoundingSize(), 2), boundingWidth = _a2[0], boundingHeight = _a2[1];
          return [boundingWidth, boundingHeight];
        },
        boundingWidth,
        boundingHeight,
        setSize: function(size) {
          var _a2;
          _a2 = __read2(size, 2), boundingWidth = _a2[0], boundingHeight = _a2[1];
        }
      }, true));
    }
    var fixedPosition = dragClient;
    if (!dragClient) {
      if (!parentFlag && isPinch) {
        fixedPosition = getAbsolutePosition(moveable, [0, 0]);
      } else {
        fixedPosition = datas.fixedPosition;
      }
    }
    var snapDist = [0, 0];
    if (!isPinch) {
      snapDist = checkSnapResize(moveable, boundingWidth, boundingHeight, direction, fixedPosition, !useSnap && isRequest, datas);
    }
    if (parentDist) {
      !parentDist[0] && (snapDist[0] = 0);
      !parentDist[1] && (snapDist[1] = 0);
    }
    function computeSize() {
      var _a2;
      if (resizeFormat) {
        _a2 = __read2(resizeFormat([boundingWidth, boundingHeight]), 2), boundingWidth = _a2[0], boundingHeight = _a2[1];
      }
      boundingWidth = throttle3(boundingWidth, throttleResize);
      boundingHeight = throttle3(boundingHeight, throttleResize);
    }
    if (keepRatio) {
      if (sizeDirection[0] && sizeDirection[1] && snapDist[0] && snapDist[1]) {
        if (abs2(snapDist[0]) > abs2(snapDist[1])) {
          snapDist[1] = 0;
        } else {
          snapDist[0] = 0;
        }
      }
      var isNoSnap = !snapDist[0] && !snapDist[1];
      if (isNoSnap) {
        computeSize();
      }
      if (sizeDirection[0] && !sizeDirection[1] || snapDist[0] && !snapDist[1] || isNoSnap && isWidth) {
        boundingWidth += snapDist[0];
        boundingHeight = boundingWidth / ratio;
      } else if (!sizeDirection[0] && sizeDirection[1] || !snapDist[0] && snapDist[1] || isNoSnap && !isWidth) {
        boundingHeight += snapDist[1];
        boundingWidth = boundingHeight * ratio;
      }
    } else {
      boundingWidth += snapDist[0];
      boundingHeight += snapDist[1];
      boundingWidth = Math.max(0, boundingWidth);
      boundingHeight = Math.max(0, boundingHeight);
    }
    _a = __read2(calculateBoundSize([boundingWidth, boundingHeight], minSize, maxSize, keepRatio ? ratio : false), 2), boundingWidth = _a[0], boundingHeight = _a[1];
    computeSize();
    if (keepRatio && (isGroup || keepRatioFinally)) {
      if (isWidth) {
        boundingHeight = boundingWidth / ratio;
      } else {
        boundingWidth = boundingHeight * ratio;
      }
    }
    distWidth = boundingWidth - startOffsetWidth;
    distHeight = boundingHeight - startOffsetHeight;
    var delta = [distWidth - prevWidth, distHeight - prevHeight];
    datas.prevWidth = distWidth;
    datas.prevHeight = distHeight;
    var inverseDelta = getResizeDist(moveable, boundingWidth, boundingHeight, fixedPosition, transformOrigin, datas);
    if (!parentMoveable && delta.every(function(num) {
      return !num;
    }) && inverseDelta.every(function(num) {
      return !num;
    })) {
      return;
    }
    var drag = Draggable2.drag(moveable, setCustomDrag(e3, moveable.state, inverseDelta, !!isPinch, false, "draggable"));
    var transform = drag.transform;
    var nextWidth = startWidth + distWidth;
    var nextHeight = startHeight + distHeight;
    var params = fillParams(moveable, e3, __assign9({ width: nextWidth, height: nextHeight, offsetWidth: Math.round(boundingWidth), offsetHeight: Math.round(boundingHeight), startRatio: ratio, boundingWidth, boundingHeight, direction, dist: [distWidth, distHeight], delta, isPinch: !!isPinch, drag }, fillAfterTransform({
      style: {
        width: "".concat(nextWidth, "px"),
        height: "".concat(nextHeight, "px")
      },
      transform
    }, drag, e3)));
    !parentEvent && triggerEvent(moveable, "onResize", params);
    return params;
  },
  dragControlAfter: function(moveable, e3) {
    var datas = e3.datas;
    var isResize = datas.isResize, startOffsetWidth = datas.startOffsetWidth, startOffsetHeight = datas.startOffsetHeight, prevWidth = datas.prevWidth, prevHeight = datas.prevHeight;
    if (!isResize || moveable.props.checkResizableError === false) {
      return;
    }
    var _a = moveable.state, width = _a.width, height = _a.height;
    var errorWidth = width - (startOffsetWidth + prevWidth);
    var errorHeight = height - (startOffsetHeight + prevHeight);
    var isErrorWidth = abs2(errorWidth) > 3;
    var isErrorHeight = abs2(errorHeight) > 3;
    if (isErrorWidth) {
      datas.startWidth += errorWidth;
      datas.startOffsetWidth += errorWidth;
      datas.prevWidth += errorWidth;
    }
    if (isErrorHeight) {
      datas.startHeight += errorHeight;
      datas.startOffsetHeight += errorHeight;
      datas.prevHeight += errorHeight;
    }
    if (isErrorWidth || isErrorHeight) {
      return this.dragControl(moveable, e3);
    }
  },
  dragControlEnd: function(moveable, e3) {
    var datas = e3.datas, parentEvent = e3.parentEvent;
    if (!datas.isResize) {
      return;
    }
    datas.isResize = false;
    var params = fillEndParams(moveable, e3, {});
    !parentEvent && triggerEvent(moveable, "onResizeEnd", params);
    return params;
  },
  dragGroupControlCondition: directionCondition$2,
  dragGroupControlStart: function(moveable, e3) {
    var datas = e3.datas;
    var params = this.dragControlStart(moveable, __assign9(__assign9({}, e3), { isGroup: true }));
    if (!params) {
      return false;
    }
    var originalEvents = fillChildEvents(moveable, "resizable", e3);
    var parentStartOffsetWidth = datas.startOffsetWidth, parentStartOffsetHeight = datas.startOffsetHeight;
    function updateGroupMin() {
      var originalMinSize = datas.minSize;
      originalEvents.forEach(function(ev) {
        var _a = ev.datas, childMinSize = _a.minSize, childStartOffsetWidth = _a.startOffsetWidth, childStartOffsetHeight = _a.startOffsetHeight;
        var parentMinWidth = parentStartOffsetWidth * (childStartOffsetWidth ? childMinSize[0] / childStartOffsetWidth : 0);
        var parentMinHeight = parentStartOffsetHeight * (childStartOffsetHeight ? childMinSize[1] / childStartOffsetHeight : 0);
        originalMinSize[0] = Math.max(originalMinSize[0], parentMinWidth);
        originalMinSize[1] = Math.max(originalMinSize[1], parentMinHeight);
      });
    }
    function updateGroupMax() {
      var originalMaxSize = datas.maxSize;
      originalEvents.forEach(function(ev) {
        var _a = ev.datas, childMaxSize = _a.maxSize, childStartOffsetWidth = _a.startOffsetWidth, childStartOffsetHeight = _a.startOffsetHeight;
        var parentMaxWidth = parentStartOffsetWidth * (childStartOffsetWidth ? childMaxSize[0] / childStartOffsetWidth : 0);
        var parentMaxHeight = parentStartOffsetHeight * (childStartOffsetHeight ? childMaxSize[1] / childStartOffsetHeight : 0);
        originalMaxSize[0] = Math.min(originalMaxSize[0], parentMaxWidth);
        originalMaxSize[1] = Math.min(originalMaxSize[1], parentMaxHeight);
      });
    }
    var events2 = triggerChildAbles(moveable, this, "dragControlStart", e3, function(child, ev) {
      return startChildDist(moveable, child, datas, ev);
    });
    updateGroupMin();
    updateGroupMax();
    var setFixedDirection = function(fixedDirection) {
      params.setFixedDirection(fixedDirection);
      events2.forEach(function(ev, i) {
        ev.setFixedDirection(fixedDirection);
        startChildDist(moveable, ev.moveable, datas, originalEvents[i]);
      });
    };
    datas.setFixedDirection = setFixedDirection;
    var nextParams = __assign9(__assign9({}, params), { targets: moveable.props.targets, events: events2.map(function(ev) {
      return __assign9(__assign9({}, ev), { setMin: function(minSize) {
        ev.setMin(minSize);
        updateGroupMin();
      }, setMax: function(maxSize) {
        ev.setMax(maxSize);
        updateGroupMax();
      } });
    }), setFixedDirection, setMin: function(minSize) {
      params.setMin(minSize);
      updateGroupMin();
    }, setMax: function(maxSize) {
      params.setMax(maxSize);
      updateGroupMax();
    } });
    var result = triggerEvent(moveable, "onResizeGroupStart", nextParams);
    datas.isResize = result !== false;
    return datas.isResize ? params : false;
  },
  dragGroupControl: function(moveable, e3) {
    var datas = e3.datas;
    if (!datas.isResize) {
      return;
    }
    var props = getProps3(moveable.props, "resizable");
    catchEvent(moveable, "onBeforeResize", function(parentEvent) {
      triggerEvent(moveable, "onBeforeResizeGroup", fillParams(moveable, e3, __assign9(__assign9({}, parentEvent), { targets: props.targets }), true));
    });
    var params = this.dragControl(moveable, __assign9(__assign9({}, e3), { isGroup: true }));
    if (!params) {
      return;
    }
    var boundingWidth = params.boundingWidth, boundingHeight = params.boundingHeight, dist = params.dist;
    var keepRatio = props.keepRatio;
    var parentScale = [
      boundingWidth / (boundingWidth - dist[0]),
      boundingHeight / (boundingHeight - dist[1])
    ];
    var fixedPosition = datas.fixedPosition;
    var events2 = triggerChildAbles(moveable, this, "dragControl", e3, function(_, ev) {
      var _a = __read2(calculate2(createRotateMatrix(moveable.rotation / 180 * Math.PI, 3), [
        ev.datas.originalX * parentScale[0],
        ev.datas.originalY * parentScale[1],
        1
      ], 3), 2), clientX = _a[0], clientY = _a[1];
      return __assign9(__assign9({}, ev), { parentDist: null, parentScale, dragClient: plus(fixedPosition, [clientX, clientY]), parentKeepRatio: keepRatio });
    });
    var nextParams = __assign9({ targets: props.targets, events: events2 }, params);
    triggerEvent(moveable, "onResizeGroup", nextParams);
    return nextParams;
  },
  dragGroupControlEnd: function(moveable, e3) {
    var isDrag = e3.isDrag, datas = e3.datas;
    if (!datas.isResize) {
      return;
    }
    this.dragControlEnd(moveable, e3);
    var events2 = triggerChildAbles(moveable, this, "dragControlEnd", e3);
    var nextParams = fillEndParams(moveable, e3, {
      targets: moveable.props.targets,
      events: events2
    });
    triggerEvent(moveable, "onResizeGroupEnd", nextParams);
    return isDrag;
  },
  /**
       * @method Moveable.Resizable#request
       * @param {Moveable.Resizable.ResizableRequestParam} e - the Resizable's request parameter
       * @return {Moveable.Requester} Moveable Requester
       * @example
  
       * // Instantly Request (requestStart - request - requestEnd)
       * // Use Relative Value
       * moveable.request("resizable", { deltaWidth: 10, deltaHeight: 10 }, true);
       *
       * // Use Absolute Value
       * moveable.request("resizable", { offsetWidth: 100, offsetHeight: 100 }, true);
       *
       * // requestStart
       * const requester = moveable.request("resizable");
       *
       * // request
       * // Use Relative Value
       * requester.request({ deltaWidth: 10, deltaHeight: 10 });
       * requester.request({ deltaWidth: 10, deltaHeight: 10 });
       * requester.request({ deltaWidth: 10, deltaHeight: 10 });
       *
       * // Use Absolute Value
       * moveable.request("resizable", { offsetWidth: 100, offsetHeight: 100 });
       * moveable.request("resizable", { offsetWidth: 110, offsetHeight: 100 });
       * moveable.request("resizable", { offsetWidth: 120, offsetHeight: 100 });
       *
       * // requestEnd
       * requester.requestEnd();
       */
  request: function(moveable) {
    var datas = {};
    var distWidth = 0;
    var distHeight = 0;
    var useSnap = false;
    var rect = moveable.getRect();
    return {
      isControl: true,
      requestStart: function(e3) {
        var _a;
        useSnap = e3.useSnap;
        return {
          datas,
          parentDirection: e3.direction || [1, 1],
          parentIsWidth: (_a = e3 === null || e3 === void 0 ? void 0 : e3.horizontal) !== null && _a !== void 0 ? _a : true,
          useSnap
        };
      },
      request: function(e3) {
        if ("offsetWidth" in e3) {
          distWidth = e3.offsetWidth - rect.offsetWidth;
        } else if ("deltaWidth" in e3) {
          distWidth += e3.deltaWidth;
        }
        if ("offsetHeight" in e3) {
          distHeight = e3.offsetHeight - rect.offsetHeight;
        } else if ("deltaHeight" in e3) {
          distHeight += e3.deltaHeight;
        }
        return {
          datas,
          parentDist: [distWidth, distHeight],
          parentKeepRatio: e3.keepRatio,
          useSnap
        };
      },
      requestEnd: function() {
        return { datas, isDrag: true, useSnap };
      }
    };
  },
  unset: function(moveable) {
    moveable.state.gestos.resizable = null;
  }
};
function setRotateStartInfo(moveable, datas, clientX, clientY, rect) {
  var groupable = moveable.props.groupable;
  var state = moveable.state;
  var n2 = state.is3d ? 4 : 3;
  var origin = datas.origin;
  var nextOrigin = calculatePosition(
    moveable.state.rootMatrix,
    // TO-DO #710
    minus([origin[0], origin[1]], groupable ? [0, 0] : [state.left, state.top]),
    n2
  );
  var startAbsoluteOrigin = plus([rect.left, rect.top], nextOrigin);
  datas.startAbsoluteOrigin = startAbsoluteOrigin;
  datas.prevDeg = getRad(startAbsoluteOrigin, [clientX, clientY]) / Math.PI * 180;
  datas.defaultDeg = datas.prevDeg;
  datas.prevSnapDeg = 0;
  datas.loop = 0;
  datas.startDist = getDist(startAbsoluteOrigin, [clientX, clientY]);
}
function getAbsoluteDist(deg, direction, datas) {
  var defaultDeg = datas.defaultDeg, prevDeg = datas.prevDeg;
  var normalizedPrevDeg = prevDeg % 360;
  var loop = Math.floor(prevDeg / 360);
  if (normalizedPrevDeg < 0) {
    normalizedPrevDeg += 360;
  }
  if (normalizedPrevDeg > deg && normalizedPrevDeg > 270 && deg < 90) {
    ++loop;
  } else if (normalizedPrevDeg < deg && normalizedPrevDeg < 90 && deg > 270) {
    --loop;
  }
  var dist = direction * (loop * 360 + deg - defaultDeg);
  datas.prevDeg = defaultDeg + dist;
  return dist;
}
function getAbsoluteDistByClient(clientX, clientY, direction, datas) {
  return getAbsoluteDist(getRad(datas.startAbsoluteOrigin, [clientX, clientY]) / Math.PI * 180, direction, datas);
}
function getRotateInfo(moveable, moveableRect, datas, dist, startValue, checkSnap2) {
  var _a = moveable.props.throttleRotate, throttleRotate = _a === void 0 ? 0 : _a;
  var prevSnapDeg = datas.prevSnapDeg;
  var snapRotation = 0;
  var isSnap = false;
  if (checkSnap2) {
    var result = checkSnapRotate(moveable, moveableRect, dist, startValue + dist);
    isSnap = result.isSnap;
    snapRotation = startValue + result.dist;
  }
  if (!isSnap) {
    snapRotation = throttle3(startValue + dist, throttleRotate);
  }
  var snapDeg = snapRotation - startValue;
  datas.prevSnapDeg = snapDeg;
  return [snapDeg - prevSnapDeg, snapDeg, snapRotation];
}
function getRotationPositions(rotationPosition, _a, direction) {
  var _b = __read2(_a, 4), pos1 = _b[0], pos2 = _b[1], pos3 = _b[2], pos4 = _b[3];
  if (rotationPosition === "none") {
    return [];
  }
  if (isArray5(rotationPosition)) {
    return rotationPosition.map(function(child) {
      return getRotationPositions(child, [pos1, pos2, pos3, pos4], direction)[0];
    });
  }
  var _c = __read2((rotationPosition || "top").split("-"), 2), dir1 = _c[0], dir2 = _c[1];
  var radPoses = [pos1, pos2];
  if (dir1 === "left") {
    radPoses = [pos3, pos1];
  } else if (dir1 === "right") {
    radPoses = [pos2, pos4];
  } else if (dir1 === "bottom") {
    radPoses = [pos4, pos3];
  }
  var pos = [
    (radPoses[0][0] + radPoses[1][0]) / 2,
    (radPoses[0][1] + radPoses[1][1]) / 2
  ];
  var rad = getRotationRad(radPoses, direction);
  if (dir2) {
    var isStart = dir2 === "top" || dir2 === "left";
    var isReverse = dir1 === "bottom" || dir1 === "left";
    pos = radPoses[isStart && !isReverse || !isStart && isReverse ? 0 : 1];
  }
  return [[pos, rad]];
}
function dragControlCondition(moveable, e3) {
  if (e3.isRequest) {
    return e3.requestAble === "rotatable";
  }
  var target = e3.inputEvent.target;
  if (hasClass(target, prefix("rotation-control")) || moveable.props.rotateAroundControls && hasClass(target, prefix("around-control")) || hasClass(target, prefix("control")) && hasClass(target, prefix("rotatable"))) {
    return true;
  }
  var rotationTarget = moveable.props.rotationTarget;
  if (rotationTarget) {
    return getRefTargets(rotationTarget, true).some(function(element) {
      if (!element) {
        return false;
      }
      return target === element || target.contains(element);
    });
  }
  return false;
}
var css = ".rotation {\nposition: absolute;\nheight: 40px;\nwidth: 1px;\ntransform-origin: 50% 100%;\nheight: calc(40px * var(--zoom));\ntop: auto;\nleft: 0;\nbottom: 100%;\nwill-change: transform;\n}\n.rotation .rotation-line {\ndisplay: block;\nwidth: 100%;\nheight: 100%;\ntransform-origin: 50% 50%;\n}\n.rotation .rotation-control {\nborder-color: #4af;\nborder-color: var(--moveable-color);\nbackground:#fff;\ncursor: alias;\n}\n:global .view-rotation-dragging, .rotatable.direction.control {\ncursor: alias;\n}\n.rotatable.direction.control.move {\ncursor: move;\n}\n";
var Rotatable = {
  name: "rotatable",
  canPinch: true,
  props: [
    "rotatable",
    "rotationPosition",
    "throttleRotate",
    "renderDirections",
    "rotationTarget",
    "rotateAroundControls",
    "edge",
    "resolveAblesWithRotatable",
    "displayAroundControls"
  ],
  events: [
    "rotateStart",
    "beforeRotate",
    "rotate",
    "rotateEnd",
    "rotateGroupStart",
    "beforeRotateGroup",
    "rotateGroup",
    "rotateGroupEnd"
  ],
  css: [css],
  viewClassName: function(moveable) {
    if (!moveable.isDragging("rotatable")) {
      return "";
    }
    return prefix("view-rotation-dragging");
  },
  render: function(moveable, React615) {
    var _a = getProps3(moveable.props, "rotatable"), rotatable = _a.rotatable, rotationPosition = _a.rotationPosition, zoom = _a.zoom, renderDirections = _a.renderDirections, rotateAroundControls = _a.rotateAroundControls, resolveAblesWithRotatable = _a.resolveAblesWithRotatable;
    var _b = moveable.getState(), renderPoses = _b.renderPoses, direction = _b.direction;
    if (!rotatable) {
      return null;
    }
    var positions = getRotationPositions(rotationPosition, renderPoses, direction);
    var jsxs = [];
    positions.forEach(function(_a2, i) {
      var _b2 = __read2(_a2, 2), pos = _b2[0], rad = _b2[1];
      jsxs.push(React615.createElement(
        "div",
        { key: "rotation".concat(i), className: prefix("rotation"), style: {
          // tslint:disable-next-line: max-line-length
          transform: "translate(-50%) translate(".concat(pos[0], "px, ").concat(pos[1], "px) rotate(").concat(rad, "rad)")
        } },
        React615.createElement("div", { className: prefix("line rotation-line"), style: {
          transform: "scaleX(".concat(zoom, ")")
        } }),
        React615.createElement("div", { className: prefix("control rotation-control"), style: {
          transform: "translate(0.5px) scale(".concat(zoom, ")")
        } })
      ));
    });
    if (renderDirections) {
      var ables = getKeys2(resolveAblesWithRotatable || {});
      var resolveMap_1 = {};
      ables.forEach(function(name) {
        resolveAblesWithRotatable[name].forEach(function(direction2) {
          resolveMap_1[direction2] = name;
        });
      });
      var directionControlInfos = [];
      if (isArray5(renderDirections)) {
        directionControlInfos = renderDirections.map(function(dir) {
          var able = resolveMap_1[dir];
          return {
            data: able ? { resolve: able } : {},
            classNames: able ? ["move"] : [],
            dir
          };
        });
      }
      jsxs.push.apply(jsxs, __spreadArray2([], __read2(renderDirectionControlsByInfos(moveable, "rotatable", directionControlInfos, React615)), false));
    }
    if (rotateAroundControls) {
      jsxs.push.apply(jsxs, __spreadArray2([], __read2(renderAroundControls(moveable, React615)), false));
    }
    return jsxs;
  },
  dragControlCondition,
  dragControlStart: function(moveable, e3) {
    var _a;
    var _b;
    var datas = e3.datas, clientX = e3.clientX, clientY = e3.clientY, parentRotate = e3.parentRotate, parentFlag = e3.parentFlag, isPinch = e3.isPinch, isRequest = e3.isRequest;
    var state = moveable.state;
    var target = state.target, left2 = state.left, top = state.top, direction = state.direction, beforeDirection = state.beforeDirection, targetTransform = state.targetTransform, moveableClientRect = state.moveableClientRect, offsetMatrix = state.offsetMatrix, targetMatrix = state.targetMatrix, allMatrix = state.allMatrix, width = state.width, height = state.height;
    if (!isRequest && !target) {
      return false;
    }
    var rect = moveable.getRect();
    datas.rect = rect;
    datas.transform = targetTransform;
    datas.left = left2;
    datas.top = top;
    var setFixedPosition = function(fixedPosition) {
      var result2 = getOffsetFixedPositionInfo(moveable.state, fixedPosition);
      datas.fixedDirection = result2.fixedDirection;
      datas.fixedOffset = result2.fixedOffset;
      datas.fixedPosition = result2.fixedPosition;
      if (resizeStart) {
        resizeStart.setFixedPosition(fixedPosition);
      }
    };
    var setFixedDirection = function(fixedDirection) {
      var result2 = getOffsetFixedDirectionInfo(moveable.state, fixedDirection);
      datas.fixedDirection = result2.fixedDirection;
      datas.fixedOffset = result2.fixedOffset;
      datas.fixedPosition = result2.fixedPosition;
      if (resizeStart) {
        resizeStart.setFixedDirection(fixedDirection);
      }
    };
    var startClientX = clientX;
    var startClientY = clientY;
    if (isRequest || isPinch || parentFlag) {
      var externalRotate = parentRotate || 0;
      datas.beforeInfo = {
        origin: rect.beforeOrigin,
        prevDeg: externalRotate,
        defaultDeg: externalRotate,
        prevSnapDeg: 0,
        startDist: 0
      };
      datas.afterInfo = __assign9(__assign9({}, datas.beforeInfo), { origin: rect.origin });
      datas.absoluteInfo = __assign9(__assign9({}, datas.beforeInfo), { origin: rect.origin, startValue: externalRotate });
    } else {
      var inputTarget = (_b = e3.inputEvent) === null || _b === void 0 ? void 0 : _b.target;
      if (inputTarget) {
        var regionDirection = inputTarget.getAttribute("data-direction") || "";
        var controlDirection = DIRECTION_REGION_TO_DIRECTION[regionDirection];
        if (controlDirection) {
          datas.isControl = true;
          datas.isAroundControl = hasClass(inputTarget, prefix("around-control"));
          datas.controlDirection = controlDirection;
          var resolve = inputTarget.getAttribute("data-resolve");
          if (resolve) {
            datas.resolveAble = resolve;
          }
          var clientPoses = calculateMoveableClientPositions(state.rootMatrix, state.renderPoses, moveableClientRect);
          _a = __read2(getPosByDirection(clientPoses, controlDirection), 2), startClientX = _a[0], startClientY = _a[1];
        }
      }
      datas.beforeInfo = { origin: rect.beforeOrigin };
      datas.afterInfo = { origin: rect.origin };
      datas.absoluteInfo = {
        origin: rect.origin,
        startValue: rect.rotation
      };
      var originalFixedPosition_1 = setFixedPosition;
      setFixedPosition = function(fixedPosition) {
        var n2 = state.is3d ? 4 : 3;
        var _a2 = __read2(plus(getOrigin(targetMatrix, n2), fixedPosition), 2), originX = _a2[0], originY = _a2[1];
        var fixedBeforeOrigin = calculate2(offsetMatrix, convertPositionMatrix([originX, originY], n2));
        var fixedAfterOrigin = calculate2(allMatrix, convertPositionMatrix([fixedPosition[0], fixedPosition[1]], n2));
        originalFixedPosition_1(fixedPosition);
        var posDelta = state.posDelta;
        datas.beforeInfo.origin = minus(fixedBeforeOrigin, posDelta);
        datas.afterInfo.origin = minus(fixedAfterOrigin, posDelta);
        datas.absoluteInfo.origin = minus(fixedAfterOrigin, posDelta);
        setRotateStartInfo(moveable, datas.beforeInfo, startClientX, startClientY, moveableClientRect);
        setRotateStartInfo(moveable, datas.afterInfo, startClientX, startClientY, moveableClientRect);
        setRotateStartInfo(moveable, datas.absoluteInfo, startClientX, startClientY, moveableClientRect);
      };
      setFixedDirection = function(fixedDirection) {
        var fixedPosition = getPosByDirection([
          [0, 0],
          [width, 0],
          [0, height],
          [width, height]
        ], fixedDirection);
        setFixedPosition(fixedPosition);
      };
    }
    datas.startClientX = startClientX;
    datas.startClientY = startClientY;
    datas.direction = direction;
    datas.beforeDirection = beforeDirection;
    datas.startValue = 0;
    datas.datas = {};
    setDefaultTransformIndex(moveable, e3, "rotate");
    var dragStart = false;
    var resizeStart = false;
    if (datas.isControl && datas.resolveAble) {
      var resolveAble = datas.resolveAble;
      if (resolveAble === "resizable") {
        resizeStart = Resizable.dragControlStart(moveable, __assign9(__assign9({}, new CustomGesto("resizable").dragStart([0, 0], e3)), { parentPosition: datas.controlPosition, parentFixedPosition: datas.fixedPosition }));
      }
    }
    if (!resizeStart) {
      dragStart = Draggable2.dragStart(moveable, new CustomGesto().dragStart([0, 0], e3));
    }
    setFixedPosition(getTotalOrigin(moveable));
    var params = fillParams(moveable, e3, __assign9(__assign9({ set: function(rotatation) {
      datas.startValue = rotatation * Math.PI / 180;
    }, setFixedDirection, setFixedPosition }, fillTransformStartEvent(moveable, e3)), { dragStart, resizeStart }));
    var result = triggerEvent(moveable, "onRotateStart", params);
    datas.isRotate = result !== false;
    state.snapRenderInfo = {
      request: e3.isRequest
    };
    return datas.isRotate ? params : false;
  },
  dragControl: function(moveable, e3) {
    var _a, _b, _c;
    var datas = e3.datas, clientDistX = e3.clientDistX, clientDistY = e3.clientDistY, parentRotate = e3.parentRotate, parentFlag = e3.parentFlag, isPinch = e3.isPinch, groupDelta = e3.groupDelta, resolveMatrix = e3.resolveMatrix;
    var beforeDirection = datas.beforeDirection, beforeInfo = datas.beforeInfo, afterInfo = datas.afterInfo, absoluteInfo = datas.absoluteInfo, isRotate = datas.isRotate, startValue = datas.startValue, rect = datas.rect, startClientX = datas.startClientX, startClientY = datas.startClientY;
    if (!isRotate) {
      return;
    }
    resolveTransformEvent(moveable, e3, "rotate");
    var targetDirection = getTransformDirection(e3);
    var direction = beforeDirection * targetDirection;
    var parentMoveable = moveable.props.parentMoveable;
    var beforeDelta = 0;
    var beforeDist;
    var beforeRotation;
    var delta = 0;
    var dist;
    var rotation;
    var absoluteDelta = 0;
    var absoluteDist;
    var absoluteRotation;
    var startRotation = 180 / Math.PI * startValue;
    var absoluteStartRotation = absoluteInfo.startValue;
    var isSnap = false;
    var nextClientX = startClientX + clientDistX;
    var nextClientY = startClientY + clientDistY;
    if (!parentFlag && "parentDist" in e3) {
      var parentDist = e3.parentDist;
      beforeDist = parentDist;
      dist = parentDist;
      absoluteDist = parentDist;
    } else if (isPinch || parentFlag) {
      beforeDist = getAbsoluteDist(parentRotate, beforeDirection, beforeInfo);
      dist = getAbsoluteDist(parentRotate, direction, afterInfo);
      absoluteDist = getAbsoluteDist(parentRotate, direction, absoluteInfo);
    } else {
      beforeDist = getAbsoluteDistByClient(nextClientX, nextClientY, beforeDirection, beforeInfo);
      dist = getAbsoluteDistByClient(nextClientX, nextClientY, direction, afterInfo);
      absoluteDist = getAbsoluteDistByClient(nextClientX, nextClientY, direction, absoluteInfo);
      isSnap = true;
    }
    beforeRotation = startRotation + beforeDist;
    rotation = startRotation + dist;
    absoluteRotation = absoluteStartRotation + absoluteDist;
    triggerEvent(moveable, "onBeforeRotate", fillParams(moveable, e3, {
      beforeRotation,
      rotation,
      absoluteRotation,
      setRotation: function(nextRotation) {
        dist = nextRotation - startRotation;
        beforeDist = dist;
        absoluteDist = dist;
      }
    }, true));
    _a = __read2(getRotateInfo(moveable, rect, beforeInfo, beforeDist, startRotation, isSnap), 3), beforeDelta = _a[0], beforeDist = _a[1], beforeRotation = _a[2];
    _b = __read2(getRotateInfo(moveable, rect, afterInfo, dist, startRotation, isSnap), 3), delta = _b[0], dist = _b[1], rotation = _b[2];
    _c = __read2(getRotateInfo(moveable, rect, absoluteInfo, absoluteDist, absoluteStartRotation, isSnap), 3), absoluteDelta = _c[0], absoluteDist = _c[1], absoluteRotation = _c[2];
    if (!absoluteDelta && !delta && !beforeDelta && !parentMoveable && !resolveMatrix) {
      return;
    }
    var nextTransform = convertTransformFormat(datas, "rotate(".concat(rotation, "deg)"), "rotate(".concat(dist, "deg)"));
    if (resolveMatrix) {
      datas.fixedPosition = getTranslateFixedPosition(moveable, datas.targetAllTransform, datas.fixedDirection, datas.fixedOffset, datas);
    }
    var inverseDist = getRotateDist(moveable, dist, datas);
    var inverseDelta = minus(plus(groupDelta || [0, 0], inverseDist), datas.prevInverseDist || [0, 0]);
    datas.prevInverseDist = inverseDist;
    datas.requestValue = null;
    var dragEvent = fillTransformEvent(moveable, nextTransform, inverseDelta, isPinch, e3);
    var transformEvent = dragEvent;
    var parentDistance = getDist([nextClientX, nextClientY], absoluteInfo.startAbsoluteOrigin) - absoluteInfo.startDist;
    var resize = void 0;
    if (datas.resolveAble === "resizable") {
      var resizeEvent = Resizable.dragControl(moveable, __assign9(__assign9({}, setCustomDrag(e3, moveable.state, [e3.deltaX, e3.deltaY], !!isPinch, false, "resizable")), { resolveMatrix: true, parentDistance }));
      if (resizeEvent) {
        resize = resizeEvent;
        transformEvent = fillAfterTransform(transformEvent, resizeEvent, e3);
      }
    }
    var params = fillParams(moveable, e3, __assign9(__assign9({ delta, dist, rotate: rotation, rotation, beforeDist, beforeDelta, beforeRotate: beforeRotation, beforeRotation, absoluteDist, absoluteDelta, absoluteRotate: absoluteRotation, absoluteRotation, isPinch: !!isPinch, resize }, dragEvent), transformEvent));
    triggerEvent(moveable, "onRotate", params);
    return params;
  },
  dragControlEnd: function(moveable, e3) {
    var datas = e3.datas;
    if (!datas.isRotate) {
      return;
    }
    datas.isRotate = false;
    var params = fillEndParams(moveable, e3, {});
    triggerEvent(moveable, "onRotateEnd", params);
    return params;
  },
  dragGroupControlCondition: dragControlCondition,
  dragGroupControlStart: function(moveable, e3) {
    var datas = e3.datas;
    var _a = moveable.state, parentLeft = _a.left, parentTop = _a.top, parentBeforeOrigin = _a.beforeOrigin;
    var params = this.dragControlStart(moveable, e3);
    if (!params) {
      return false;
    }
    params.set(datas.beforeDirection * moveable.rotation);
    var events2 = triggerChildAbles(moveable, this, "dragControlStart", e3, function(child, ev) {
      var _a2 = child.state, left2 = _a2.left, top = _a2.top, beforeOrigin = _a2.beforeOrigin;
      var childClient = plus(minus([left2, top], [parentLeft, parentTop]), minus(beforeOrigin, parentBeforeOrigin));
      ev.datas.startGroupClient = childClient;
      ev.datas.groupClient = childClient;
      return __assign9(__assign9({}, ev), { parentRotate: 0 });
    });
    var nextParams = __assign9(__assign9({}, params), { targets: moveable.props.targets, events: events2 });
    var result = triggerEvent(moveable, "onRotateGroupStart", nextParams);
    datas.isRotate = result !== false;
    return datas.isRotate ? params : false;
  },
  dragGroupControl: function(moveable, e3) {
    var datas = e3.datas;
    if (!datas.isRotate) {
      return;
    }
    catchEvent(moveable, "onBeforeRotate", function(parentEvent) {
      triggerEvent(moveable, "onBeforeRotateGroup", fillParams(moveable, e3, __assign9(__assign9({}, parentEvent), { targets: moveable.props.targets }), true));
    });
    var params = this.dragControl(moveable, e3);
    if (!params) {
      return;
    }
    var direction = datas.beforeDirection;
    var parentRotate = params.beforeDist;
    var rad = parentRotate / 180 * Math.PI;
    var events2 = triggerChildAbles(moveable, this, "dragControl", e3, function(_, ev) {
      var startGroupClient = ev.datas.startGroupClient;
      var _a = __read2(ev.datas.groupClient, 2), prevClientX = _a[0], prevClientY = _a[1];
      var _b = __read2(rotate(startGroupClient, rad * direction), 2), clientX = _b[0], clientY = _b[1];
      var delta = [clientX - prevClientX, clientY - prevClientY];
      ev.datas.groupClient = [clientX, clientY];
      return __assign9(__assign9({}, ev), { parentRotate, groupDelta: delta });
    });
    moveable.rotation = direction * params.beforeRotation;
    var nextParams = __assign9({ targets: moveable.props.targets, events: events2, set: function(rotation) {
      moveable.rotation = rotation;
    }, setGroupRotation: function(rotation) {
      moveable.rotation = rotation;
    } }, params);
    triggerEvent(moveable, "onRotateGroup", nextParams);
    return nextParams;
  },
  dragGroupControlEnd: function(moveable, e3) {
    var isDrag = e3.isDrag, datas = e3.datas;
    if (!datas.isRotate) {
      return;
    }
    this.dragControlEnd(moveable, e3);
    var events2 = triggerChildAbles(moveable, this, "dragControlEnd", e3);
    var nextParams = fillEndParams(moveable, e3, {
      targets: moveable.props.targets,
      events: events2
    });
    triggerEvent(moveable, "onRotateGroupEnd", nextParams);
    return isDrag;
  },
  /**
       * @method Moveable.Rotatable#request
       * @param {object} [e] - the Resizable's request parameter
       * @param {number} [e.deltaRotate=0] -  delta number of rotation
       * @param {number} [e.rotate=0] - absolute number of moveable's rotation
       * @return {Moveable.Requester} Moveable Requester
       * @example
  
       * // Instantly Request (requestStart - request - requestEnd)
       * moveable.request("rotatable", { deltaRotate: 10 }, true);
       *
       * * moveable.request("rotatable", { rotate: 10 }, true);
       *
       * // requestStart
       * const requester = moveable.request("rotatable");
       *
       * // request
       * requester.request({ deltaRotate: 10 });
       * requester.request({ deltaRotate: 10 });
       * requester.request({ deltaRotate: 10 });
       *
       * requester.request({ rotate: 10 });
       * requester.request({ rotate: 20 });
       * requester.request({ rotate: 30 });
       *
       * // requestEnd
       * requester.requestEnd();
       */
  request: function(moveable) {
    var datas = {};
    var distRotate = 0;
    var startRotation = moveable.getRotation();
    return {
      isControl: true,
      requestStart: function() {
        return { datas };
      },
      request: function(e3) {
        if ("deltaRotate" in e3) {
          distRotate += e3.deltaRotate;
        } else if ("rotate" in e3) {
          distRotate = e3.rotate - startRotation;
        }
        return { datas, parentDist: distRotate };
      },
      requestEnd: function() {
        return { datas, isDrag: true };
      }
    };
  }
};
function renderGuideline(info, React615) {
  var _a;
  var direction = info.direction, classNames186 = info.classNames, size = info.size, pos = info.pos, zoom = info.zoom, key2 = info.key;
  var isHorizontal = direction === "horizontal";
  var scaleType = isHorizontal ? "Y" : "X";
  return React615.createElement("div", {
    key: key2,
    className: classNames186.join(" "),
    style: (_a = {}, _a[isHorizontal ? "width" : "height"] = "".concat(size), _a.transform = "translate(".concat(pos[0], ", ").concat(pos[1], ") translate").concat(scaleType, "(-50%) scale").concat(scaleType, "(").concat(zoom, ")"), _a)
  });
}
function renderInnerGuideline(info, React615) {
  return renderGuideline(__assign9(__assign9({}, info), { classNames: __spreadArray2([
    prefix("line", "guideline", info.direction)
  ], __read2(info.classNames), false).filter(function(className2) {
    return className2;
  }), size: info.size || "".concat(info.sizeValue, "px"), pos: info.pos || info.posValue.map(function(v) {
    return "".concat(throttle3(v, 0.1), "px");
  }) }), React615);
}
function renderSnapPoses(moveable, direction, snapPoses, minPos, targetPos, size, index3, React615) {
  var zoom = moveable.props.zoom;
  return snapPoses.map(function(_a, i) {
    var type5 = _a.type, pos = _a.pos;
    var renderPos = [0, 0];
    renderPos[index3] = minPos;
    renderPos[index3 ? 0 : 1] = -targetPos + pos;
    return renderInnerGuideline({
      key: "".concat(direction, "TargetGuideline").concat(i),
      classNames: [prefix("target", "bold", type5)],
      posValue: renderPos,
      sizeValue: size,
      zoom,
      direction
    }, React615);
  });
}
function renderGuidelines(moveable, type5, guidelines, targetPos, targetRect, React615) {
  var _a = moveable.props, zoom = _a.zoom, isDisplayInnerSnapDigit = _a.isDisplayInnerSnapDigit;
  var mainNames = type5 === "horizontal" ? VERTICAL_NAMES_MAP : HORIZONTAL_NAMES_MAP;
  var targetStart = targetRect[mainNames.start];
  var targetEnd = targetRect[mainNames.end];
  return guidelines.filter(function(_a2) {
    var hide = _a2.hide, elementRect = _a2.elementRect;
    if (hide) {
      return false;
    }
    if (isDisplayInnerSnapDigit && elementRect) {
      var rect = elementRect.rect;
      if (rect[mainNames.start] <= targetStart && targetEnd <= rect[mainNames.end]) {
        return false;
      }
    }
    return true;
  }).map(function(guideline, i) {
    var pos = guideline.pos, size = guideline.size, element = guideline.element, className2 = guideline.className;
    var renderPos = [
      -targetPos[0] + pos[0],
      -targetPos[1] + pos[1]
    ];
    return renderInnerGuideline({
      key: "".concat(type5, "-default-guideline-").concat(i),
      classNames: element ? [prefix("bold"), className2] : [prefix("normal"), className2],
      direction: type5,
      posValue: renderPos,
      sizeValue: size,
      zoom
    }, React615);
  });
}
function renderDigitLine(moveable, type5, lineType, index3, gap, renderPos, className2, React615) {
  var _a;
  var _b = moveable.props, _c = _b.snapDigit, snapDigit = _c === void 0 ? 0 : _c, _d = _b.isDisplaySnapDigit, isDisplaySnapDigit = _d === void 0 ? true : _d, _e = _b.snapDistFormat, snapDistFormat = _e === void 0 ? function(v, type6) {
    if (type6 === "vertical") {
      return v;
    }
    return v;
  } : _e, zoom = _b.zoom;
  var scaleType = type5 === "horizontal" ? "X" : "Y";
  var sizeName = type5 === "vertical" ? "height" : "width";
  var absGap = Math.abs(gap);
  var snapSize = isDisplaySnapDigit ? parseFloat(absGap.toFixed(snapDigit)) : 0;
  return React615.createElement(
    "div",
    { key: "".concat(type5, "-").concat(lineType, "-guideline-").concat(index3), className: prefix("guideline-group", type5), style: (_a = {
      left: "".concat(renderPos[0], "px"),
      top: "".concat(renderPos[1], "px")
    }, _a[sizeName] = "".concat(absGap, "px"), _a) },
    renderInnerGuideline({
      direction: type5,
      classNames: [prefix(lineType), className2],
      size: "100%",
      posValue: [0, 0],
      sizeValue: absGap,
      zoom
    }, React615),
    React615.createElement("div", { className: prefix("size-value", "gap"), style: {
      transform: "translate".concat(scaleType, "(-50%) scale(").concat(zoom, ")")
    } }, snapSize > 0 ? snapDistFormat(snapSize, type5) : "")
  );
}
function groupByElementGuidelines(type5, guidelines, targetRect, isDisplayInnerSnapDigit) {
  var index3 = type5 === "vertical" ? 0 : 1;
  var otherIndex = type5 === "vertical" ? 1 : 0;
  var names2 = index3 ? VERTICAL_NAMES_MAP : HORIZONTAL_NAMES_MAP;
  var targetStart = targetRect[names2.start];
  var targetEnd = targetRect[names2.end];
  return groupBy(guidelines, function(guideline) {
    return guideline.pos[index3];
  }).map(function(nextGuidelines) {
    var start = [];
    var end = [];
    var inner = [];
    nextGuidelines.forEach(function(guideline) {
      var _a, _b;
      var element = guideline.element;
      var rect = guideline.elementRect.rect;
      if (rect[names2.end] < targetStart) {
        start.push(guideline);
      } else if (targetEnd < rect[names2.start]) {
        end.push(guideline);
      } else if (rect[names2.start] <= targetStart && targetEnd <= rect[names2.end] && isDisplayInnerSnapDigit) {
        var pos = guideline.pos;
        var elementRect1 = { element, rect: __assign9(__assign9({}, rect), (_a = {}, _a[names2.end] = rect[names2.start], _a)) };
        var elementRect2 = { element, rect: __assign9(__assign9({}, rect), (_b = {}, _b[names2.start] = rect[names2.end], _b)) };
        var nextPos1 = [0, 0];
        var nextPos2 = [0, 0];
        nextPos1[index3] = pos[index3];
        nextPos1[otherIndex] = pos[otherIndex];
        nextPos2[index3] = pos[index3];
        nextPos2[otherIndex] = pos[otherIndex] + guideline.size;
        start.push({
          type: type5,
          pos: nextPos1,
          size: 0,
          elementRect: elementRect1,
          direction: "",
          elementDirection: "end"
        });
        end.push({
          type: type5,
          pos: nextPos2,
          size: 0,
          elementRect: elementRect2,
          direction: "",
          elementDirection: "start"
        });
      }
    });
    start.sort(function(a, b) {
      return b.pos[otherIndex] - a.pos[otherIndex];
    });
    end.sort(function(a, b) {
      return a.pos[otherIndex] - b.pos[otherIndex];
    });
    return {
      total: nextGuidelines,
      start,
      end,
      inner
    };
  });
}
function renderDashedGuidelines(moveable, guidelines, targetPos, targetRect, React615) {
  var isDisplayInnerSnapDigit = moveable.props.isDisplayInnerSnapDigit;
  var rendered = [];
  ["vertical", "horizontal"].forEach(function(type5) {
    var nextGuidelines = guidelines.filter(function(guideline) {
      return guideline.type === type5;
    });
    var index3 = type5 === "vertical" ? 1 : 0;
    var otherIndex = index3 ? 0 : 1;
    var groups = groupByElementGuidelines(type5, nextGuidelines, targetRect, isDisplayInnerSnapDigit);
    var mainNames = index3 ? HORIZONTAL_NAMES_MAP : VERTICAL_NAMES_MAP;
    var sideNames = index3 ? VERTICAL_NAMES_MAP : HORIZONTAL_NAMES_MAP;
    var targetStart = targetRect[mainNames.start];
    var targetEnd = targetRect[mainNames.end];
    groups.forEach(function(_a) {
      var total = _a.total, start = _a.start, end = _a.end, inner = _a.inner;
      var sidePos = targetPos[otherIndex] + total[0].pos[otherIndex] - targetRect[sideNames.start];
      var prevRect = targetRect;
      start.forEach(function(guideline) {
        var nextRect = guideline.elementRect.rect;
        var size = prevRect[mainNames.start] - nextRect[mainNames.end];
        if (size > 0) {
          var renderPos = [0, 0];
          renderPos[index3] = targetPos[index3] + prevRect[mainNames.start] - targetStart - size;
          renderPos[otherIndex] = sidePos;
          rendered.push(renderDigitLine(moveable, type5, "dashed", rendered.length, size, renderPos, guideline.className, React615));
        }
        prevRect = nextRect;
      });
      prevRect = targetRect;
      end.forEach(function(guideline) {
        var nextRect = guideline.elementRect.rect;
        var size = nextRect[mainNames.start] - prevRect[mainNames.end];
        if (size > 0) {
          var renderPos = [0, 0];
          renderPos[index3] = targetPos[index3] + prevRect[mainNames.end] - targetStart;
          renderPos[otherIndex] = sidePos;
          rendered.push(renderDigitLine(moveable, type5, "dashed", rendered.length, size, renderPos, guideline.className, React615));
        }
        prevRect = nextRect;
      });
      inner.forEach(function(guideline) {
        var nextRect = guideline.elementRect.rect;
        var size1 = targetStart - nextRect[mainNames.start];
        var size2 = nextRect[mainNames.end] - targetEnd;
        var renderPos1 = [0, 0];
        var renderPos2 = [0, 0];
        renderPos1[index3] = targetPos[index3] - size1;
        renderPos1[otherIndex] = sidePos;
        renderPos2[index3] = targetPos[index3] + targetEnd - targetStart;
        renderPos2[otherIndex] = sidePos;
        rendered.push(renderDigitLine(moveable, type5, "dashed", rendered.length, size1, renderPos1, guideline.className, React615));
        rendered.push(renderDigitLine(moveable, type5, "dashed", rendered.length, size2, renderPos2, guideline.className, React615));
      });
    });
  });
  return rendered;
}
function renderGapGuidelines(moveable, guidelines, targetPos, targetRect, React615) {
  var rendered = [];
  ["horizontal", "vertical"].forEach(function(type5) {
    var nextGuidelines = guidelines.filter(function(guideline) {
      return guideline.type === type5;
    }).slice(0, 1);
    var index3 = type5 === "vertical" ? 0 : 1;
    var otherIndex = index3 ? 0 : 1;
    var mainNames = index3 ? HORIZONTAL_NAMES_MAP : VERTICAL_NAMES_MAP;
    var sideNames = index3 ? VERTICAL_NAMES_MAP : HORIZONTAL_NAMES_MAP;
    var targetStart = targetRect[mainNames.start];
    var targetEnd = targetRect[mainNames.end];
    var targetSideStart = targetRect[sideNames.start];
    var targetSideEnd = targetRect[sideNames.end];
    nextGuidelines.forEach(function(_a) {
      var gap = _a.gap, gapRects = _a.gapRects;
      var sideStartPos = Math.max.apply(Math, __spreadArray2([targetSideStart], __read2(gapRects.map(function(_a2) {
        var rect = _a2.rect;
        return rect[sideNames.start];
      })), false));
      var sideEndPos = Math.min.apply(Math, __spreadArray2([targetSideEnd], __read2(gapRects.map(function(_a2) {
        var rect = _a2.rect;
        return rect[sideNames.end];
      })), false));
      var sideCenterPos = (sideStartPos + sideEndPos) / 2;
      if (sideStartPos === sideEndPos || sideCenterPos === (targetSideStart + targetSideEnd) / 2) {
        return;
      }
      gapRects.forEach(function(_a2) {
        var rect = _a2.rect, className2 = _a2.className;
        var renderPos = [targetPos[0], targetPos[1]];
        if (rect[mainNames.end] < targetStart) {
          renderPos[index3] += rect[mainNames.end] - targetStart;
        } else if (targetEnd < rect[mainNames.start]) {
          renderPos[index3] += rect[mainNames.start] - targetStart - gap;
        } else {
          return;
        }
        renderPos[otherIndex] += sideCenterPos - targetSideStart;
        rendered.push(renderDigitLine(moveable, index3 ? "vertical" : "horizontal", "gap", rendered.length, gap, renderPos, className2, React615));
      });
    });
  });
  return rendered;
}
function getTotalGuidelines(moveable) {
  var _a, _b;
  var state = moveable.state;
  var containerClientRect = state.containerClientRect, hasFixed = state.hasFixed;
  var overflow = containerClientRect.overflow, containerHeight = containerClientRect.scrollHeight, containerWidth = containerClientRect.scrollWidth, containerClientHeight = containerClientRect.clientHeight, containerClientWidth = containerClientRect.clientWidth, clientLeft = containerClientRect.clientLeft, clientTop = containerClientRect.clientTop;
  var _c = moveable.props, _d = _c.snapGap, snapGap = _d === void 0 ? true : _d, verticalGuidelines = _c.verticalGuidelines, horizontalGuidelines = _c.horizontalGuidelines, _e = _c.snapThreshold, snapThreshold = _e === void 0 ? 5 : _e, _f = _c.maxSnapElementGuidelineDistance, maxSnapElementGuidelineDistance = _f === void 0 ? Infinity : _f, isDisplayGridGuidelines = _c.isDisplayGridGuidelines;
  var _g = getRect2(getAbsolutePosesByState(moveable.state)), top = _g.top, left2 = _g.left, bottom = _g.bottom, right2 = _g.right;
  var targetRect = { top, left: left2, bottom, right: right2, center: (left2 + right2) / 2, middle: (top + bottom) / 2 };
  var elementGuidelines = getElementGuidelines(moveable);
  var totalGuidelines = __spreadArray2([], __read2(elementGuidelines), false);
  var snapThresholdMultiples = ((_b = (_a = state.snapThresholdInfo) === null || _a === void 0 ? void 0 : _a.multiples) !== null && _b !== void 0 ? _b : [1, 1]).map(function(n2) {
    return n2 * snapThreshold;
  });
  if (snapGap) {
    totalGuidelines.push.apply(totalGuidelines, __spreadArray2([], __read2(getGapGuidelines(moveable, targetRect, snapThresholdMultiples)), false));
  }
  var snapOffset = __assign9({}, state.snapOffset || {
    left: 0,
    top: 0,
    bottom: 0,
    right: 0
  });
  totalGuidelines.push.apply(totalGuidelines, __spreadArray2([], __read2(getGridGuidelines(moveable, overflow ? containerWidth : containerClientWidth, overflow ? containerHeight : containerClientHeight, clientLeft, clientTop, snapOffset, isDisplayGridGuidelines)), false));
  if (hasFixed) {
    var left_1 = containerClientRect.left, top_1 = containerClientRect.top;
    snapOffset.left += left_1;
    snapOffset.top += top_1;
    snapOffset.right += left_1;
    snapOffset.bottom += top_1;
  }
  totalGuidelines.push.apply(totalGuidelines, __spreadArray2([], __read2(getDefaultGuidelines(horizontalGuidelines || false, verticalGuidelines || false, overflow ? containerWidth : containerClientWidth, overflow ? containerHeight : containerClientHeight, clientLeft, clientTop, snapOffset)), false));
  totalGuidelines = totalGuidelines.filter(function(_a2) {
    var element = _a2.element, elementRect = _a2.elementRect, type5 = _a2.type;
    if (!element || !elementRect) {
      return true;
    }
    var rect = elementRect.rect;
    return checkBetweenRects(targetRect, rect, type5, maxSnapElementGuidelineDistance);
  });
  return totalGuidelines;
}
function getGapGuidelines(moveable, targetRect, snapThresholds) {
  var _a = moveable.props, _b = _a.maxSnapElementGuidelineDistance, maxSnapElementGuidelineDistance = _b === void 0 ? Infinity : _b, _c = _a.maxSnapElementGapDistance, maxSnapElementGapDistance = _c === void 0 ? Infinity : _c;
  var elementRects = moveable.state.elementRects;
  var gapGuidelines = [];
  [
    ["vertical", VERTICAL_NAMES_MAP, HORIZONTAL_NAMES_MAP],
    ["horizontal", HORIZONTAL_NAMES_MAP, VERTICAL_NAMES_MAP]
  ].forEach(function(_a2) {
    var _b2 = __read2(_a2, 3), type5 = _b2[0], mainNames = _b2[1], sideNames = _b2[2];
    var targetStart = targetRect[mainNames.start];
    var targetEnd = targetRect[mainNames.end];
    var targetCenter = targetRect[mainNames.center];
    var targetStart2 = targetRect[sideNames.start];
    var targetEnd2 = targetRect[sideNames.end];
    var snapThresholdMap = {
      left: snapThresholds[0],
      top: snapThresholds[1]
    };
    function getDist4(elementRect) {
      var rect = elementRect.rect;
      var snapThreshold = snapThresholdMap[mainNames.start];
      if (rect[mainNames.end] < targetStart + snapThreshold) {
        return targetStart - rect[mainNames.end];
      } else if (targetEnd - snapThreshold < rect[mainNames.start]) {
        return rect[mainNames.start] - targetEnd;
      } else {
        return -1;
      }
    }
    var nextElementRects = elementRects.filter(function(elementRect) {
      var rect = elementRect.rect;
      if (rect[sideNames.start] > targetEnd2 || rect[sideNames.end] < targetStart2) {
        return false;
      }
      return getDist4(elementRect) > 0;
    }).sort(function(a, b) {
      return getDist4(a) - getDist4(b);
    });
    var groups = [];
    nextElementRects.forEach(function(snapRect1) {
      nextElementRects.forEach(function(snapRect2) {
        if (snapRect1 === snapRect2) {
          return;
        }
        var rect1 = snapRect1.rect;
        var rect2 = snapRect2.rect;
        var rect1Start = rect1[sideNames.start];
        var rect1End = rect1[sideNames.end];
        var rect2Start = rect2[sideNames.start];
        var rect2End = rect2[sideNames.end];
        if (rect1Start > rect2End || rect2Start > rect1End) {
          return;
        }
        groups.push([snapRect1, snapRect2]);
      });
    });
    groups.forEach(function(_a3) {
      var _b3 = __read2(_a3, 2), snapRect1 = _b3[0], snapRect2 = _b3[1];
      var rect1 = snapRect1.rect;
      var rect2 = snapRect2.rect;
      var rect1Start = rect1[mainNames.start];
      var rect1End = rect1[mainNames.end];
      var rect2Start = rect2[mainNames.start];
      var rect2End = rect2[mainNames.end];
      var snapThreshold = snapThresholdMap[mainNames.start];
      var gap = 0;
      var pos = 0;
      var isStart = false;
      var isCenter = false;
      var isEnd = false;
      if (rect1End <= targetStart && targetEnd <= rect2Start) {
        isCenter = true;
        gap = (rect2Start - rect1End - (targetEnd - targetStart)) / 2;
        pos = rect1End + gap + (targetEnd - targetStart) / 2;
        if (abs2(pos - targetCenter) > snapThreshold) {
          return;
        }
      } else if (rect1End < rect2Start && rect2End < targetStart + snapThreshold) {
        isStart = true;
        gap = rect2Start - rect1End;
        pos = rect2End + gap;
        if (abs2(pos - targetStart) > snapThreshold) {
          return;
        }
      } else if (rect1End < rect2Start && targetEnd - snapThreshold < rect1Start) {
        isEnd = true;
        gap = rect2Start - rect1End;
        pos = rect1Start - gap;
        if (abs2(pos - targetEnd) > snapThreshold) {
          return;
        }
      } else {
        return;
      }
      if (!gap) {
        return;
      }
      if (!checkBetweenRects(targetRect, rect2, type5, maxSnapElementGuidelineDistance)) {
        return;
      }
      if (gap > maxSnapElementGapDistance) {
        return;
      }
      gapGuidelines.push({
        type: type5,
        pos: type5 === "vertical" ? [pos, 0] : [0, pos],
        element: snapRect2.element,
        size: 0,
        className: snapRect2.className,
        isStart,
        isCenter,
        isEnd,
        gap,
        hide: true,
        gapRects: [snapRect1, snapRect2],
        direction: "",
        elementDirection: ""
      });
    });
  });
  return gapGuidelines;
}
function startGridGroupGuidelines(moveable, clientLeft, clientTop, snapOffset) {
  var _a, _b;
  var props = moveable.props;
  var state = moveable.state;
  var snapGridAll = props.snapGridAll;
  var _c = props.snapGridWidth, snapGridWidth = _c === void 0 ? 0 : _c, _d = props.snapGridHeight, snapGridHeight = _d === void 0 ? 0 : _d;
  var snapRenderInfo = state.snapRenderInfo;
  var hasDirection = snapRenderInfo && (((_a = snapRenderInfo.direction) === null || _a === void 0 ? void 0 : _a[0]) || ((_b = snapRenderInfo.direction) === null || _b === void 0 ? void 0 : _b[1]));
  var moveables = moveable.moveables;
  if (snapGridAll && moveables && hasDirection && (snapGridWidth || snapGridHeight)) {
    if (state.snapThresholdInfo) {
      return;
    }
    state.snapThresholdInfo = {
      multiples: [1, 1],
      offset: [0, 0]
    };
    var rect_1 = moveable.getRect();
    var children_1 = rect_1.children;
    var direction = snapRenderInfo.direction;
    if (children_1) {
      var result = direction.map(function(dir, i) {
        var _a2 = i === 0 ? {
          snapSize: snapGridWidth,
          posName: "left",
          sizeName: "width",
          clientOffset: snapOffset.left - clientLeft
        } : {
          snapSize: snapGridHeight,
          posName: "top",
          sizeName: "height",
          clientOffset: snapOffset.top - clientTop
        }, snapSize = _a2.snapSize, posName = _a2.posName, sizeName = _a2.sizeName, clientOffset = _a2.clientOffset;
        if (!snapSize) {
          return {
            dir,
            multiple: 1,
            snapSize,
            snapOffset: 0
          };
        }
        var rectSize = rect_1[sizeName];
        var rectPos = rect_1[posName];
        var childSizes = flat(children_1.map(function(child) {
          return [
            child[posName] - rectPos,
            child[sizeName],
            rectSize - child[sizeName] - child[posName] + rectPos
          ];
        })).filter(function(v) {
          return v;
        }).sort(function(a, b) {
          return a - b;
        });
        var firstChildSize = childSizes[0];
        var childSnapSizes = childSizes.map(function(size) {
          return throttle3(size / firstChildSize, 0.1) * snapSize;
        });
        var n2 = 1;
        var rectRatio = throttle3(rectSize / firstChildSize, 0.1);
        for (n2 = 1; n2 <= 10; ++n2) {
          if (childSnapSizes.every(function(childSize) {
            return childSize * n2 % 1 === 0;
          })) {
            break;
          }
        }
        var ratio = (-dir + 1) / 2;
        var offsetPos = dot(rectPos - clientOffset, rectPos - clientOffset + rectSize, ratio, 1 - ratio);
        return {
          multiple: rectRatio * n2,
          dir,
          snapSize,
          snapOffset: Math.round(offsetPos / snapSize)
        };
      });
      var multiples = result.map(function(r2) {
        return r2.multiple || 1;
      });
      state.snapThresholdInfo.multiples = multiples;
      state.snapThresholdInfo.offset = result.map(function(r2) {
        return r2.snapOffset;
      });
      result.forEach(function(r2, i) {
        if (r2.snapSize) ;
      });
    }
  } else {
    state.snapThresholdInfo = null;
  }
}
function getGridGuidelines(moveable, containerWidth, containerHeight, clientLeft, clientTop, snapOffset, isDisplayGridGuidelines) {
  if (clientLeft === void 0) {
    clientLeft = 0;
  }
  if (clientTop === void 0) {
    clientTop = 0;
  }
  var props = moveable.props;
  var state = moveable.state;
  var _a = props.snapGridWidth, snapGridWidth = _a === void 0 ? 0 : _a, _b = props.snapGridHeight, snapGridHeight = _b === void 0 ? 0 : _b;
  var guidelines = [];
  var snapOffsetLeft = snapOffset.left, snapOffsetTop = snapOffset.top;
  var startOffset = [0, 0];
  startGridGroupGuidelines(moveable, clientLeft, clientTop, snapOffset);
  var snapThresholdInfo = state.snapThresholdInfo;
  var defaultSnapGridWidth = snapGridWidth;
  var defaultSnapGridHeight = snapGridHeight;
  if (snapThresholdInfo) {
    snapGridWidth *= snapThresholdInfo.multiples[0] || 1;
    snapGridHeight *= snapThresholdInfo.multiples[1] || 1;
    startOffset = snapThresholdInfo.offset;
  }
  if (snapGridHeight) {
    var pushGuideline = function(pos2) {
      guidelines.push({
        type: "horizontal",
        pos: [
          snapOffsetLeft,
          throttle3(startOffset[1] * defaultSnapGridHeight + pos2 - clientTop + snapOffsetTop, 0.1)
        ],
        className: prefix("grid-guideline"),
        size: containerWidth,
        hide: !isDisplayGridGuidelines,
        direction: "",
        grid: true
      });
    };
    for (var pos = 0; pos <= containerHeight * 2; pos += snapGridHeight) {
      pushGuideline(pos);
    }
    for (var pos = -snapGridHeight; pos >= -containerHeight; pos -= snapGridHeight) {
      pushGuideline(pos);
    }
  }
  if (snapGridWidth) {
    var pushGuideline = function(pos2) {
      guidelines.push({
        type: "vertical",
        pos: [
          throttle3(startOffset[0] * defaultSnapGridWidth + pos2 - clientLeft + snapOffsetLeft, 0.1),
          snapOffsetTop
        ],
        className: prefix("grid-guideline"),
        size: containerHeight,
        hide: !isDisplayGridGuidelines,
        direction: "",
        grid: true
      });
    };
    for (var pos = 0; pos <= containerWidth * 2; pos += snapGridWidth) {
      pushGuideline(pos);
    }
    for (var pos = -snapGridWidth; pos >= -containerWidth; pos -= snapGridWidth) {
      pushGuideline(pos);
    }
  }
  return guidelines;
}
function checkBetweenRects(rect1, rect2, type5, distance) {
  if (type5 === "horizontal") {
    return abs2(rect1.right - rect2.left) <= distance || abs2(rect1.left - rect2.right) <= distance || rect1.left <= rect2.right && rect2.left <= rect1.right;
  } else if (type5 === "vertical") {
    return abs2(rect1.bottom - rect2.top) <= distance || abs2(rect1.top - rect2.bottom) <= distance || rect1.top <= rect2.bottom && rect2.top <= rect1.bottom;
  }
  return true;
}
function getElementGuidelines(moveable) {
  var state = moveable.state;
  var _a = moveable.props.elementGuidelines, elementGuidelines = _a === void 0 ? [] : _a;
  if (!elementGuidelines.length) {
    state.elementRects = [];
    return [];
  }
  var prevValues = (state.elementRects || []).filter(function(snapRect) {
    return !snapRect.refresh;
  });
  var nextElementGuidelines = elementGuidelines.map(function(el) {
    if (isObject5(el) && "element" in el) {
      return __assign9(__assign9({}, el), { element: getRefTarget(el.element, true) });
    }
    return {
      element: getRefTarget(el, true)
    };
  }).filter(function(value) {
    return value.element;
  });
  var _b = diff2(prevValues.map(function(v) {
    return v.element;
  }), nextElementGuidelines.map(function(v) {
    return v.element;
  })), maintained = _b.maintained, added = _b.added;
  var nextValues = [];
  maintained.forEach(function(_a2) {
    var _b2 = __read2(_a2, 2), prevIndex = _b2[0], nextIndex2 = _b2[1];
    nextValues[nextIndex2] = prevValues[prevIndex];
  });
  getSnapElementRects(moveable, added.map(function(index3) {
    return nextElementGuidelines[index3];
  })).map(function(rect, i) {
    nextValues[added[i]] = rect;
  });
  state.elementRects = nextValues;
  var elementSnapDirections = getSnapDirections(moveable.props.elementSnapDirections);
  var nextGuidelines = [];
  nextValues.forEach(function(snapRect) {
    var element = snapRect.element, _a2 = snapRect.top, topValue = _a2 === void 0 ? elementSnapDirections.top : _a2, _b2 = snapRect.left, leftValue = _b2 === void 0 ? elementSnapDirections.left : _b2, _c = snapRect.right, rightValue = _c === void 0 ? elementSnapDirections.right : _c, _d = snapRect.bottom, bottomValue = _d === void 0 ? elementSnapDirections.bottom : _d, _e = snapRect.center, centerValue = _e === void 0 ? elementSnapDirections.center : _e, _f = snapRect.middle, middleValue = _f === void 0 ? elementSnapDirections.middle : _f, className2 = snapRect.className, rect = snapRect.rect;
    var _g = splitSnapDirectionPoses({
      top: topValue,
      right: rightValue,
      left: leftValue,
      bottom: bottomValue,
      center: centerValue,
      middle: middleValue
    }, rect), horizontal = _g.horizontal, vertical = _g.vertical, horizontalNames = _g.horizontalNames, verticalNames = _g.verticalNames;
    var rectTop = rect.top;
    var rectLeft = rect.left;
    var width = rect.right - rectLeft;
    var height = rect.bottom - rectTop;
    var sizes2 = [width, height];
    vertical.forEach(function(pos, i) {
      nextGuidelines.push({
        type: "vertical",
        element,
        pos: [
          throttle3(pos, 0.1),
          rectTop
        ],
        size: height,
        sizes: sizes2,
        className: className2,
        elementRect: snapRect,
        elementDirection: SNAP_SKIP_NAMES_MAP[verticalNames[i]] || verticalNames[i],
        direction: ""
      });
    });
    horizontal.forEach(function(pos, i) {
      nextGuidelines.push({
        type: "horizontal",
        element,
        pos: [
          rectLeft,
          throttle3(pos, 0.1)
        ],
        size: width,
        sizes: sizes2,
        className: className2,
        elementRect: snapRect,
        elementDirection: SNAP_SKIP_NAMES_MAP[horizontalNames[i]] || horizontalNames[i],
        direction: ""
      });
    });
  });
  return nextGuidelines;
}
function getObjectGuidelines(guidelines, containerSize) {
  return guidelines ? guidelines.map(function(info) {
    var posGuideline = isObject5(info) ? info : { pos: info };
    var pos = posGuideline.pos;
    if (isNumber3(pos)) {
      return posGuideline;
    } else {
      return __assign9(__assign9({}, posGuideline), { pos: convertUnitSize(pos, containerSize) });
    }
  }) : [];
}
function getDefaultGuidelines(horizontalGuidelines, verticalGuidelines, width, height, clientLeft, clientTop, snapOffset) {
  if (clientLeft === void 0) {
    clientLeft = 0;
  }
  if (clientTop === void 0) {
    clientTop = 0;
  }
  if (snapOffset === void 0) {
    snapOffset = { left: 0, top: 0, right: 0, bottom: 0 };
  }
  var guidelines = [];
  var snapOffsetLeft = snapOffset.left, snapOffsetTop = snapOffset.top, snapOffsetBottom = snapOffset.bottom, snapOffsetRight = snapOffset.right;
  var snapWidth = width + snapOffsetRight - snapOffsetLeft;
  var snapHeight = height + snapOffsetBottom - snapOffsetTop;
  getObjectGuidelines(horizontalGuidelines, snapHeight).forEach(function(posInfo) {
    guidelines.push({
      type: "horizontal",
      pos: [
        snapOffsetLeft,
        throttle3(posInfo.pos - clientTop + snapOffsetTop, 0.1)
      ],
      size: snapWidth,
      className: posInfo.className,
      direction: ""
    });
  });
  getObjectGuidelines(verticalGuidelines, snapWidth).forEach(function(posInfo) {
    guidelines.push({
      type: "vertical",
      pos: [
        throttle3(posInfo.pos - clientLeft + snapOffsetLeft, 0.1),
        snapOffsetTop
      ],
      size: snapHeight,
      className: posInfo.className,
      direction: ""
    });
  });
  return guidelines;
}
function getSnapElementRects(moveable, values) {
  if (!values.length) {
    return [];
  }
  var groupable = moveable.props.groupable;
  var state = moveable.state;
  var containerClientRect = state.containerClientRect, rootMatrix = state.rootMatrix, is3d = state.is3d, offsetDelta = state.offsetDelta;
  var n2 = is3d ? 4 : 3;
  var _a = __read2(calculateContainerPos(rootMatrix, containerClientRect, n2), 2), containerLeft = _a[0], containerTop = _a[1];
  var offsetLeft = groupable ? 0 : offsetDelta[0];
  var offsetTop = groupable ? 0 : offsetDelta[1];
  return values.map(function(value) {
    var rect = value.element.getBoundingClientRect();
    var left2 = rect.left - containerLeft - offsetLeft;
    var top = rect.top - containerTop - offsetTop;
    var bottom = top + rect.height;
    var right2 = left2 + rect.width;
    var _a2 = __read2(calculateInversePosition(rootMatrix, [left2, top], n2), 2), elementLeft = _a2[0], elementTop = _a2[1];
    var _b = __read2(calculateInversePosition(rootMatrix, [right2, bottom], n2), 2), elementRight = _b[0], elementBottom = _b[1];
    return __assign9(__assign9({}, value), { rect: {
      left: elementLeft,
      right: elementRight,
      top: elementTop,
      bottom: elementBottom,
      center: (elementLeft + elementRight) / 2,
      middle: (elementTop + elementBottom) / 2
    } });
  });
}
function checkSnapInfo(moveable) {
  var state = moveable.state;
  var container = state.container;
  var snapContainer = moveable.props.snapContainer || container;
  if (state.snapContainer === snapContainer && state.guidelines && state.guidelines.length) {
    return false;
  }
  var containerClientRect = state.containerClientRect;
  var snapOffset = {
    left: 0,
    top: 0,
    bottom: 0,
    right: 0
  };
  if (container !== snapContainer) {
    var snapContainerTarget = getRefTarget(snapContainer, true);
    if (snapContainerTarget) {
      var snapContainerRect = getClientRect2(snapContainerTarget);
      var offset1 = getDragDistByState(state, [
        snapContainerRect.left - containerClientRect.left,
        snapContainerRect.top - containerClientRect.top
      ]);
      var offset22 = getDragDistByState(state, [
        snapContainerRect.right - containerClientRect.right,
        snapContainerRect.bottom - containerClientRect.bottom
      ]);
      snapOffset.left = throttle3(offset1[0], 1e-5);
      snapOffset.top = throttle3(offset1[1], 1e-5);
      snapOffset.right = throttle3(offset22[0], 1e-5);
      snapOffset.bottom = throttle3(offset22[1], 1e-5);
    }
  }
  state.snapContainer = snapContainer;
  state.snapOffset = snapOffset;
  state.guidelines = getTotalGuidelines(moveable);
  state.enableSnap = true;
  return true;
}
function getNextFixedPoses(matrix, width, height, fixedDirection, fixedPos, is3d) {
  var nextPoses = calculatePoses(matrix, width, height, is3d ? 4 : 3);
  var nextFixedPos = getPosByDirection(nextPoses, fixedDirection);
  return getAbsolutePoses(nextPoses, minus(fixedPos, nextFixedPos));
}
function normalized(value) {
  return value ? value / abs2(value) : 0;
}
function getSizeOffsetInfo(moveable, poses, direction, keepRatio, isRequest, datas) {
  var fixedDirection = datas.fixedDirection;
  var directions2 = getCheckSnapDirections(direction, fixedDirection, keepRatio);
  var innerBoundLineInfos = getCheckInnerBoundLineInfos(moveable, poses, direction, keepRatio);
  var offsets = __spreadArray2(__spreadArray2([], __read2(getSnapBoundInfo(moveable, poses, directions2, keepRatio, isRequest, datas)), false), __read2(getInnerBoundInfo(moveable, innerBoundLineInfos, datas)), false);
  var widthOffsetInfo = getNearOffsetInfo(offsets, 0);
  var heightOffsetInfo = getNearOffsetInfo(offsets, 1);
  return {
    width: {
      isBound: widthOffsetInfo.isBound,
      offset: widthOffsetInfo.offset[0]
    },
    height: {
      isBound: heightOffsetInfo.isBound,
      offset: heightOffsetInfo.offset[1]
    }
  };
}
function recheckSizeByTwoDirection(moveable, poses, width, height, maxWidth, maxHeight, direction, isRequest, datas) {
  var snapPos = getPosByDirection(poses, direction);
  var _a = checkMoveableSnapBounds(moveable, isRequest, {
    vertical: [snapPos[0]],
    horizontal: [snapPos[1]]
  }), horizontalOffset = _a.horizontal.offset, verticalOffset = _a.vertical.offset;
  if (throttle3(verticalOffset, FLOAT_POINT_NUM) || throttle3(horizontalOffset, FLOAT_POINT_NUM)) {
    var _b = __read2(getDragDist({
      datas,
      distX: -verticalOffset,
      distY: -horizontalOffset
    }), 2), nextWidthOffset = _b[0], nextHeightOffset = _b[1];
    var nextWidth = Math.min(maxWidth || Infinity, width + direction[0] * nextWidthOffset);
    var nextHeight = Math.min(maxHeight || Infinity, height + direction[1] * nextHeightOffset);
    return [nextWidth - width, nextHeight - height];
  }
  return [0, 0];
}
function checkSizeDist(moveable, getNextPoses, width, height, direction, fixedPosition, isRequest, datas) {
  var poses = getAbsolutePosesByState(moveable.state);
  var keepRatio = moveable.props.keepRatio;
  var widthOffset = 0;
  var heightOffset = 0;
  for (var i = 0; i < 2; ++i) {
    var nextPoses = getNextPoses(widthOffset, heightOffset);
    var _a = getSizeOffsetInfo(moveable, nextPoses, direction, keepRatio, isRequest, datas), widthOffsetInfo = _a.width, heightOffsetInfo = _a.height;
    var isWidthBound = widthOffsetInfo.isBound;
    var isHeightBound = heightOffsetInfo.isBound;
    var nextWidthOffset = widthOffsetInfo.offset;
    var nextHeightOffset = heightOffsetInfo.offset;
    if (i === 1) {
      if (!isWidthBound) {
        nextWidthOffset = 0;
      }
      if (!isHeightBound) {
        nextHeightOffset = 0;
      }
    }
    if (i === 0 && isRequest && !isWidthBound && !isHeightBound) {
      return [0, 0];
    }
    if (keepRatio) {
      var widthDist = abs2(nextWidthOffset) * (width ? 1 / width : 1);
      var heightDist = abs2(nextHeightOffset) * (height ? 1 / height : 1);
      var isGetWidthOffset = isWidthBound && isHeightBound ? widthDist < heightDist : isHeightBound || !isWidthBound && widthDist < heightDist;
      if (isGetWidthOffset) {
        nextWidthOffset = width * nextHeightOffset / height;
      } else {
        nextHeightOffset = height * nextWidthOffset / width;
      }
    }
    widthOffset += nextWidthOffset;
    heightOffset += nextHeightOffset;
  }
  if (!keepRatio && direction[0] && direction[1]) {
    var _b = checkMaxBounds(moveable, poses, direction, fixedPosition, datas), maxWidth = _b.maxWidth, maxHeight = _b.maxHeight;
    var _c = __read2(recheckSizeByTwoDirection(moveable, getNextPoses(widthOffset, heightOffset).map(function(pos) {
      return pos.map(function(p) {
        return throttle3(p, FLOAT_POINT_NUM);
      });
    }), width + widthOffset, height + heightOffset, maxWidth, maxHeight, direction, isRequest, datas), 2), nextWidthOffset = _c[0], nextHeightOffset = _c[1];
    widthOffset += nextWidthOffset;
    heightOffset += nextHeightOffset;
  }
  return [widthOffset, heightOffset];
}
function absDegree(deg) {
  if (deg < 0) {
    deg = deg % 360 + 360;
  }
  deg %= 360;
  return deg;
}
function bumpDegree(baseDeg, snapDeg) {
  snapDeg = absDegree(snapDeg);
  var count = Math.floor(baseDeg / 360);
  var deg1 = count * 360 + 360 - snapDeg;
  var deg2 = count * 360 + snapDeg;
  return abs2(baseDeg - deg1) < abs2(baseDeg - deg2) ? deg1 : deg2;
}
function getMinDegreeDistance(deg1, deg2) {
  deg1 = absDegree(deg1);
  deg2 = absDegree(deg2);
  var deg3 = absDegree(deg1 - deg2);
  return Math.min(deg3, 360 - deg3);
}
function checkSnapRotate(moveable, rect, dist, rotation) {
  var _a;
  var props = moveable.props;
  var snapRotationThreshold = (_a = props[NAME_snapRotationThreshold]) !== null && _a !== void 0 ? _a : 5;
  var snapRotationDegrees = props[NAME_snapRotationDegrees];
  if (hasGuidelines(moveable, "rotatable")) {
    var pos1 = rect.pos1, pos2 = rect.pos2, pos3 = rect.pos3, pos4 = rect.pos4, origin2_1 = rect.origin;
    var rad_1 = dist * Math.PI / 180;
    var prevPoses = [pos1, pos2, pos3, pos4].map(function(pos) {
      return minus(pos, origin2_1);
    });
    var nextPoses = prevPoses.map(function(pos) {
      return rotate(pos, rad_1);
    });
    var result = __spreadArray2(__spreadArray2([], __read2(checkRotateBounds(moveable, prevPoses, nextPoses, origin2_1, dist)), false), __read2(checkRotateInnerBounds(moveable, prevPoses, nextPoses, origin2_1, dist)), false);
    result.sort(function(a, b) {
      return abs2(a - dist) - abs2(b - dist);
    });
    var isSnap = result.length > 0;
    if (isSnap) {
      return {
        isSnap,
        dist: isSnap ? result[0] : dist
      };
    }
  }
  if ((snapRotationDegrees === null || snapRotationDegrees === void 0 ? void 0 : snapRotationDegrees.length) && snapRotationThreshold) {
    var sorted = snapRotationDegrees.slice().sort(function(a, b) {
      return getMinDegreeDistance(a, rotation) - getMinDegreeDistance(b, rotation);
    });
    var firstDegree = sorted[0];
    if (getMinDegreeDistance(firstDegree, rotation) <= snapRotationThreshold) {
      return {
        isSnap: true,
        dist: dist + bumpDegree(rotation, firstDegree) - rotation
      };
    }
  }
  return {
    isSnap: false,
    dist
  };
}
function checkSnapResize(moveable, width, height, direction, fixedPosition, isRequest, datas) {
  if (!hasGuidelines(moveable, "resizable")) {
    return [0, 0];
  }
  var fixedDirection = datas.fixedDirection, nextAllMatrix = datas.nextAllMatrix;
  var _a = moveable.state, allMatrix = _a.allMatrix, is3d = _a.is3d;
  return checkSizeDist(moveable, function(widthOffset, heightOffset) {
    return getNextFixedPoses(nextAllMatrix || allMatrix, width + widthOffset, height + heightOffset, fixedDirection, fixedPosition, is3d);
  }, width, height, direction, fixedPosition, isRequest, datas);
}
function checkSnapScale(moveable, scale, direction, isRequest, datas) {
  if (!hasGuidelines(moveable, "scalable")) {
    return [0, 0];
  }
  var startOffsetWidth = datas.startOffsetWidth, startOffsetHeight = datas.startOffsetHeight, fixedPosition = datas.fixedPosition, fixedDirection = datas.fixedDirection, is3d = datas.is3d;
  var sizeDist = checkSizeDist(moveable, function(widthOffset, heightOffset) {
    return getNextFixedPoses(scaleMatrix(datas, plus(scale, [widthOffset / startOffsetWidth, heightOffset / startOffsetHeight])), startOffsetWidth, startOffsetHeight, fixedDirection, fixedPosition, is3d);
  }, startOffsetWidth, startOffsetHeight, direction, fixedPosition, isRequest, datas);
  return [sizeDist[0] / startOffsetWidth, sizeDist[1] / startOffsetHeight];
}
function startCheckSnapDrag(moveable, datas) {
  datas.absolutePoses = getAbsolutePosesByState(moveable.state);
}
function getSnapGuidelines(posInfos) {
  var guidelines = [];
  posInfos.forEach(function(posInfo) {
    posInfo.guidelineInfos.forEach(function(_a) {
      var guideline = _a.guideline;
      if (find(guidelines, function(info) {
        return info.guideline === guideline;
      })) {
        return;
      }
      guideline.direction = "";
      guidelines.push({ guideline, posInfo });
    });
  });
  return guidelines.map(function(_a) {
    var guideline = _a.guideline, posInfo = _a.posInfo;
    return __assign9(__assign9({}, guideline), { direction: posInfo.direction });
  });
}
function addBoundGuidelines(moveable, verticalPoses, horizontalPoses, verticalSnapPoses, horizontalSnapPoses, externalBounds) {
  var _a = checkBoundPoses(getBounds(moveable, externalBounds), verticalPoses, horizontalPoses), verticalBoundInfos = _a.vertical, horizontalBoundInfos = _a.horizontal;
  var boundMap = getInitialBounds();
  verticalBoundInfos.forEach(function(info) {
    if (info.isBound) {
      if (info.direction === "start") {
        boundMap.left = true;
      }
      if (info.direction === "end") {
        boundMap.right = true;
      }
      verticalSnapPoses.push({
        type: "bounds",
        pos: info.pos
      });
    }
  });
  horizontalBoundInfos.forEach(function(info) {
    if (info.isBound) {
      if (info.direction === "start") {
        boundMap.top = true;
      }
      if (info.direction === "end") {
        boundMap.bottom = true;
      }
      horizontalSnapPoses.push({
        type: "bounds",
        pos: info.pos
      });
    }
  });
  var _b = checkInnerBoundPoses(moveable), innerBoundMap = _b.boundMap, verticalInnerBoundPoses = _b.vertical, horizontalInnerBoundPoses = _b.horizontal;
  verticalInnerBoundPoses.forEach(function(innerPos) {
    if (findIndex(verticalSnapPoses, function(_a2) {
      var type5 = _a2.type, pos = _a2.pos;
      return type5 === "bounds" && pos === innerPos;
    }) >= 0) {
      return;
    }
    verticalSnapPoses.push({
      type: "bounds",
      pos: innerPos
    });
  });
  horizontalInnerBoundPoses.forEach(function(innerPos) {
    if (findIndex(horizontalSnapPoses, function(_a2) {
      var type5 = _a2.type, pos = _a2.pos;
      return type5 === "bounds" && pos === innerPos;
    }) >= 0) {
      return;
    }
    horizontalSnapPoses.push({
      type: "bounds",
      pos: innerPos
    });
  });
  return {
    boundMap,
    innerBoundMap
  };
}
var directionCondition$1 = getDirectionCondition("", ["resizable", "scalable"]);
var Snappable = {
  name: "snappable",
  dragRelation: "strong",
  props: [
    "snappable",
    "snapContainer",
    "snapDirections",
    "elementSnapDirections",
    "snapGap",
    "snapGridWidth",
    "snapGridHeight",
    "isDisplaySnapDigit",
    "isDisplayInnerSnapDigit",
    "isDisplayGridGuidelines",
    "snapDigit",
    "snapThreshold",
    "snapRenderThreshold",
    "snapGridAll",
    NAME_snapRotationThreshold,
    NAME_snapRotationDegrees,
    NAME_snapHorizontalThreshold,
    NAME_snapVerticalThreshold,
    "horizontalGuidelines",
    "verticalGuidelines",
    "elementGuidelines",
    "bounds",
    "innerBounds",
    "snapDistFormat",
    "maxSnapElementGuidelineDistance",
    "maxSnapElementGapDistance"
  ],
  events: ["snap", "bound"],
  css: [
    ":host {\n--bounds-color: #d66;\n}\n.guideline {\npointer-events: none;\nz-index: 2;\n}\n.guideline.bounds {\nbackground: #d66;\nbackground: var(--bounds-color);\n}\n.guideline-group {\nposition: absolute;\ntop: 0;\nleft: 0;\n}\n.guideline-group .size-value {\nposition: absolute;\ncolor: #f55;\nfont-size: 12px;\nfont-size: calc(12px * var(--zoom));\nfont-weight: bold;\n}\n.guideline-group.horizontal .size-value {\ntransform-origin: 50% 100%;\ntransform: translateX(-50%);\nleft: 50%;\nbottom: 5px;\nbottom: calc(2px + 3px * var(--zoom));\n}\n.guideline-group.vertical .size-value {\ntransform-origin: 0% 50%;\ntop: 50%;\ntransform: translateY(-50%);\nleft: 5px;\nleft: calc(2px + 3px * var(--zoom));\n}\n.guideline.gap {\nbackground: #f55;\n}\n.size-value.gap {\ncolor: #f55;\n}\n"
  ],
  render: function(moveable, React615) {
    var state = moveable.state;
    var targetTop = state.top, targetLeft = state.left, pos1 = state.pos1, pos2 = state.pos2, pos3 = state.pos3, pos4 = state.pos4, snapRenderInfo = state.snapRenderInfo;
    var _a = moveable.props.snapRenderThreshold, snapRenderThreshold = _a === void 0 ? 1 : _a;
    if (!snapRenderInfo || !snapRenderInfo.render || !hasGuidelines(moveable, "")) {
      watchValue(moveable, "boundMap", getInitialBounds(), function(v) {
        return JSON.stringify(v);
      });
      watchValue(moveable, "innerBoundMap", getInitialBounds(), function(v) {
        return JSON.stringify(v);
      });
      return [];
    }
    state.guidelines = getTotalGuidelines(moveable);
    var minLeft = Math.min(pos1[0], pos2[0], pos3[0], pos4[0]);
    var minTop = Math.min(pos1[1], pos2[1], pos3[1], pos4[1]);
    var externalPoses = snapRenderInfo.externalPoses || [];
    var poses = getAbsolutePosesByState(moveable.state);
    var verticalSnapPoses = [];
    var horizontalSnapPoses = [];
    var verticalGuidelines = [];
    var horizontalGuidelines = [];
    var snapInfos = [];
    var _b = getRect2(poses), width = _b.width, height = _b.height, top = _b.top, left2 = _b.left, bottom = _b.bottom, right2 = _b.right;
    var targetRect = { left: left2, right: right2, top, bottom, center: (left2 + right2) / 2, middle: (top + bottom) / 2 };
    var hasExternalPoses = externalPoses.length > 0;
    var externalRect = hasExternalPoses ? getRect2(externalPoses) : {};
    if (!snapRenderInfo.request) {
      if (snapRenderInfo.direction) {
        snapInfos.push(getSnapInfosByDirection(moveable, poses, snapRenderInfo.direction, snapRenderThreshold, snapRenderThreshold));
      }
      if (snapRenderInfo.snap) {
        var rect = getRect2(poses);
        if (snapRenderInfo.center) {
          rect.middle = (rect.top + rect.bottom) / 2;
          rect.center = (rect.left + rect.right) / 2;
        }
        snapInfos.push(checkSnaps(moveable, rect, snapRenderThreshold, snapRenderThreshold));
      }
      if (hasExternalPoses) {
        if (snapRenderInfo.center) {
          externalRect.middle = (externalRect.top + externalRect.bottom) / 2;
          externalRect.center = (externalRect.left + externalRect.right) / 2;
        }
        snapInfos.push(checkSnaps(moveable, externalRect, snapRenderThreshold, snapRenderThreshold));
      }
      snapInfos.forEach(function(snapInfo) {
        var verticalPosInfos = snapInfo.vertical.posInfos, horizontalPosInfos = snapInfo.horizontal.posInfos;
        verticalSnapPoses.push.apply(verticalSnapPoses, __spreadArray2([], __read2(verticalPosInfos.filter(function(_a2) {
          var guidelineInfos = _a2.guidelineInfos;
          return guidelineInfos.some(function(_a3) {
            var guideline = _a3.guideline;
            return !guideline.hide;
          });
        }).map(function(posInfo) {
          return {
            type: "snap",
            pos: posInfo.pos
          };
        })), false));
        horizontalSnapPoses.push.apply(horizontalSnapPoses, __spreadArray2([], __read2(horizontalPosInfos.filter(function(_a2) {
          var guidelineInfos = _a2.guidelineInfos;
          return guidelineInfos.some(function(_a3) {
            var guideline = _a3.guideline;
            return !guideline.hide;
          });
        }).map(function(posInfo) {
          return {
            type: "snap",
            pos: posInfo.pos
          };
        })), false));
        verticalGuidelines.push.apply(verticalGuidelines, __spreadArray2([], __read2(getSnapGuidelines(verticalPosInfos)), false));
        horizontalGuidelines.push.apply(horizontalGuidelines, __spreadArray2([], __read2(getSnapGuidelines(horizontalPosInfos)), false));
      });
    }
    var _c = addBoundGuidelines(moveable, [left2, right2], [top, bottom], verticalSnapPoses, horizontalSnapPoses), boundMap = _c.boundMap, innerBoundMap = _c.innerBoundMap;
    if (hasExternalPoses) {
      addBoundGuidelines(moveable, [externalRect.left, externalRect.right], [externalRect.top, externalRect.bottom], verticalSnapPoses, horizontalSnapPoses, snapRenderInfo.externalBounds);
    }
    var allGuidelines = __spreadArray2(__spreadArray2([], __read2(verticalGuidelines), false), __read2(horizontalGuidelines), false);
    var elementGuidelines = allGuidelines.filter(function(guideline) {
      return guideline.element && !guideline.gapRects;
    });
    var gapGuidelines = allGuidelines.filter(function(guideline) {
      return guideline.gapRects;
    }).sort(function(a, b) {
      return a.gap - b.gap;
    });
    triggerEvent(moveable, "onSnap", {
      guidelines: allGuidelines.filter(function(_a2) {
        var element = _a2.element;
        return !element;
      }),
      elements: elementGuidelines,
      gaps: gapGuidelines
    }, true);
    var nextBoundMap = watchValue(moveable, "boundMap", boundMap, function(v) {
      return JSON.stringify(v);
    }, getInitialBounds());
    var nextInnerBoundMap = watchValue(moveable, "innerBoundMap", innerBoundMap, function(v) {
      return JSON.stringify(v);
    }, getInitialBounds());
    if (boundMap === nextBoundMap || innerBoundMap === nextInnerBoundMap) {
      triggerEvent(moveable, "onBound", {
        bounds: boundMap,
        innerBounds: innerBoundMap
      }, true);
    }
    return __spreadArray2(__spreadArray2(__spreadArray2(__spreadArray2(__spreadArray2(__spreadArray2([], __read2(renderDashedGuidelines(moveable, elementGuidelines, [minLeft, minTop], targetRect, React615)), false), __read2(renderGapGuidelines(moveable, gapGuidelines, [minLeft, minTop], targetRect, React615)), false), __read2(renderGuidelines(moveable, "horizontal", horizontalGuidelines, [targetLeft, targetTop], targetRect, React615)), false), __read2(renderGuidelines(moveable, "vertical", verticalGuidelines, [targetLeft, targetTop], targetRect, React615)), false), __read2(renderSnapPoses(moveable, "horizontal", horizontalSnapPoses, minLeft, targetTop, width, 0, React615)), false), __read2(renderSnapPoses(moveable, "vertical", verticalSnapPoses, minTop, targetLeft, height, 1, React615)), false);
  },
  dragStart: function(moveable, e3) {
    moveable.state.snapRenderInfo = {
      request: e3.isRequest,
      snap: true,
      center: true
    };
    checkSnapInfo(moveable);
  },
  drag: function(moveable) {
    var state = moveable.state;
    if (!checkSnapInfo(moveable)) {
      state.guidelines = getTotalGuidelines(moveable);
    }
    if (state.snapRenderInfo) {
      state.snapRenderInfo.render = true;
    }
  },
  pinchStart: function(moveable) {
    this.unset(moveable);
  },
  dragEnd: function(moveable) {
    this.unset(moveable);
  },
  dragControlCondition: function(moveable, e3) {
    if (directionCondition$1(moveable, e3) || dragControlCondition(moveable, e3)) {
      return true;
    }
    if (!e3.isRequest && e3.inputEvent) {
      return hasClass(e3.inputEvent.target, prefix("snap-control"));
    }
  },
  dragControlStart: function(moveable) {
    moveable.state.snapRenderInfo = null;
    checkSnapInfo(moveable);
  },
  dragControl: function(moveable) {
    this.drag(moveable);
  },
  dragControlEnd: function(moveable) {
    this.unset(moveable);
  },
  dragGroupStart: function(moveable, e3) {
    this.dragStart(moveable, e3);
  },
  dragGroup: function(moveable) {
    this.drag(moveable);
  },
  dragGroupEnd: function(moveable) {
    this.unset(moveable);
  },
  dragGroupControlStart: function(moveable) {
    moveable.state.snapRenderInfo = null;
    checkSnapInfo(moveable);
  },
  dragGroupControl: function(moveable) {
    this.drag(moveable);
  },
  dragGroupControlEnd: function(moveable) {
    this.unset(moveable);
  },
  unset: function(moveable) {
    var state = moveable.state;
    state.enableSnap = false;
    state.guidelines = [];
    state.snapRenderInfo = null;
    state.elementRects = [];
  }
};
function multiply2(pos1, pos2) {
  return [
    pos1[0] * pos2[0],
    pos1[1] * pos2[1]
  ];
}
function prefix() {
  var classNames186 = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    classNames186[_i] = arguments[_i];
  }
  return prefixNames.apply(void 0, __spreadArray2([PREFIX], __read2(classNames186), false));
}
function defaultSync(fn) {
  fn();
}
function getTransformMatrix(transform) {
  if (!transform || transform === "none") {
    return [1, 0, 0, 1, 0, 0];
  }
  if (isObject5(transform)) {
    return transform;
  }
  return parseMat(transform);
}
function getAbsoluteMatrix(matrix, n2, origin) {
  return multiplies(n2, createOriginMatrix(origin, n2), matrix, createOriginMatrix(origin.map(function(a) {
    return -a;
  }), n2));
}
function measureSVGSize(el, unit3, isHorizontal) {
  if (unit3 === "%") {
    var viewBox = getSVGViewBox(el.ownerSVGElement);
    return viewBox[isHorizontal ? "width" : "height"] / 100;
  }
  return 1;
}
function getBeforeTransformOrigin(el) {
  var relativeOrigin = getTransformOrigin(getComputedStyle2(el, ":before"));
  return relativeOrigin.map(function(o3, i) {
    var _a = splitUnit(o3), value = _a.value, unit3 = _a.unit;
    return value * measureSVGSize(el, unit3, i === 0);
  });
}
function getTransformOriginArray(transformOrigin) {
  return transformOrigin ? transformOrigin.split(" ") : ["0", "0"];
}
function getTransformOrigin(style2) {
  return getTransformOriginArray(style2.transformOrigin);
}
function getElementTransform(target) {
  var getStyle4 = getCachedStyle(target);
  var computedTransform = getStyle4("transform");
  if (computedTransform && computedTransform !== "none") {
    return computedTransform;
  }
  if ("transform" in target) {
    var list = target.transform;
    var baseVal = list.baseVal;
    if (!baseVal) {
      return "";
    }
    var length_1 = baseVal.length;
    if (!length_1) {
      return "";
    }
    var matrixes = [];
    var _loop_1 = function(i2) {
      var matrix = baseVal[i2].matrix;
      matrixes.push("matrix(".concat(["a", "b", "c", "d", "e", "f"].map(function(chr) {
        return matrix[chr];
      }).join(", "), ")"));
    };
    for (var i = 0; i < length_1; ++i) {
      _loop_1(i);
    }
    return matrixes.join(" ");
  }
  return "";
}
function getOffsetInfo(el, lastParent, isParent, checkZoom, getTargetStyle) {
  var _a, _b;
  var documentElement = getDocumentElement(el) || getDocumentBody(el);
  var hasSlot = false;
  var target;
  var parentSlotElement;
  if (!el || isParent) {
    target = el;
  } else {
    var assignedSlotParentElement = (_a = el === null || el === void 0 ? void 0 : el.assignedSlot) === null || _a === void 0 ? void 0 : _a.parentElement;
    var parentElement = el.parentElement;
    if (assignedSlotParentElement) {
      hasSlot = true;
      parentSlotElement = parentElement;
      target = assignedSlotParentElement;
    } else {
      target = parentElement;
    }
  }
  var isCustomElement = false;
  var isEnd = el === lastParent || target === lastParent;
  var position3 = "relative";
  var offsetZoom = 1;
  var targetZoom = parseFloat(getTargetStyle === null || getTargetStyle === void 0 ? void 0 : getTargetStyle("zoom")) || 1;
  var targetPosition = getTargetStyle === null || getTargetStyle === void 0 ? void 0 : getTargetStyle("position");
  while (target && target !== documentElement) {
    if (lastParent === target) {
      isEnd = true;
    }
    var getStyle4 = getCachedStyle(target);
    var tagName = target.tagName.toLowerCase();
    var transform = getElementTransform(target);
    var willChange = getStyle4("willChange");
    var zoom = parseFloat(getStyle4("zoom")) || 1;
    position3 = getStyle4("position");
    if (checkZoom && zoom !== 1) {
      offsetZoom = zoom;
      break;
    }
    if (
      // offsetParent is the parentElement if the target's zoom is not 1 and not absolute.
      !isParent && checkZoom && targetZoom !== 1 && targetPosition && targetPosition !== "absolute" || tagName === "svg" || tagName === "foreignobject" || position3 !== "static" || transform && transform !== "none" || willChange === "transform"
    ) {
      break;
    }
    var slotParentNode = (_b = el === null || el === void 0 ? void 0 : el.assignedSlot) === null || _b === void 0 ? void 0 : _b.parentNode;
    var targetParentNode = target.parentNode;
    if (slotParentNode) {
      hasSlot = true;
      parentSlotElement = targetParentNode;
    }
    var parentNode = targetParentNode;
    if (parentNode && parentNode.nodeType === 11) {
      target = parentNode.host;
      isCustomElement = true;
      position3 = getCachedStyle(target)("position");
      break;
    }
    target = parentNode;
    position3 = "relative";
  }
  return {
    offsetZoom,
    hasSlot,
    parentSlotElement,
    isCustomElement,
    isStatic: position3 === "static",
    isEnd: isEnd || !target || target === documentElement,
    offsetParent: target || documentElement
  };
}
function getOffsetPosInfo(el, target) {
  var _a;
  var tagName = el.tagName.toLowerCase();
  var offsetLeft = el.offsetLeft;
  var offsetTop = el.offsetTop;
  var getStyle4 = getCachedStyle(el);
  var isSVG = isUndefined2(offsetLeft);
  var hasOffset = !isSVG;
  var origin;
  var targetOrigin;
  if (!hasOffset && (tagName !== "svg" || el.ownerSVGElement)) {
    origin = IS_WEBKIT605 ? getBeforeTransformOrigin(el) : getTransformOriginArray(getStyle4("transformOrigin")).map(function(pos) {
      return parseFloat(pos);
    });
    targetOrigin = origin.slice();
    hasOffset = true;
    if (tagName === "svg") {
      offsetLeft = 0;
      offsetTop = 0;
    } else {
      _a = __read2(getSVGGraphicsOffset(el, origin, el === target && target.tagName.toLowerCase() === "g"), 4), offsetLeft = _a[0], offsetTop = _a[1], origin[0] = _a[2], origin[1] = _a[3];
    }
  } else {
    origin = getTransformOriginArray(getStyle4("transformOrigin")).map(function(pos) {
      return parseFloat(pos);
    });
    targetOrigin = origin.slice();
  }
  return {
    tagName,
    isSVG,
    hasOffset,
    offset: [offsetLeft || 0, offsetTop || 0],
    origin,
    targetOrigin
  };
}
function getBodyOffset(el, isSVG) {
  var getStyle4 = getCachedStyle(el);
  var getBodyStyle = getCachedStyle(getDocumentBody(el));
  var bodyPosition = getBodyStyle("position");
  if (!isSVG && (!bodyPosition || bodyPosition === "static")) {
    return [0, 0];
  }
  var marginLeft = parseInt(getBodyStyle("marginLeft"), 10);
  var marginTop = parseInt(getBodyStyle("marginTop"), 10);
  if (getStyle4("position") === "absolute") {
    if (getStyle4("top") !== "auto" || getStyle4("bottom") !== "auto") {
      marginTop = 0;
    }
    if (getStyle4("left") !== "auto" || getStyle4("right") !== "auto") {
      marginLeft = 0;
    }
  }
  return [marginLeft, marginTop];
}
function convert3DMatrixes(matrixes) {
  matrixes.forEach(function(info) {
    var matrix = info.matrix;
    if (matrix) {
      info.matrix = convertDimension(matrix, 3, 4);
    }
  });
}
function getPositionFixedInfo(el) {
  var fixedContainer = el.parentElement;
  var hasTransform = false;
  var body = getDocumentBody(el);
  while (fixedContainer) {
    var transform = getComputedStyle2(fixedContainer).transform;
    if (transform && transform !== "none") {
      hasTransform = true;
      break;
    }
    if (fixedContainer === body) {
      break;
    }
    fixedContainer = fixedContainer.parentElement;
  }
  return {
    fixedContainer: fixedContainer || body,
    hasTransform
  };
}
function makeMatrixCSS(matrix, is3d) {
  if (is3d === void 0) {
    is3d = matrix.length > 9;
  }
  return "".concat(is3d ? "matrix3d" : "matrix", "(").concat(convertMatrixtoCSS(matrix, !is3d).join(","), ")");
}
function getSVGViewBox(el) {
  var clientWidth = el.clientWidth;
  var clientHeight = el.clientHeight;
  if (!el) {
    return { x: 0, y: 0, width: 0, height: 0, clientWidth, clientHeight };
  }
  var viewBox = el.viewBox;
  var baseVal = viewBox && viewBox.baseVal || { x: 0, y: 0, width: 0, height: 0 };
  return {
    x: baseVal.x,
    y: baseVal.y,
    width: baseVal.width || clientWidth,
    height: baseVal.height || clientHeight,
    clientWidth,
    clientHeight
  };
}
function getSVGMatrix(el, n2) {
  var _a;
  var _b = getSVGViewBox(el), viewBoxWidth = _b.width, viewBoxHeight = _b.height, clientWidth = _b.clientWidth, clientHeight = _b.clientHeight;
  var scaleX = clientWidth / viewBoxWidth;
  var scaleY = clientHeight / viewBoxHeight;
  var preserveAspectRatio = el.preserveAspectRatio.baseVal;
  var align = preserveAspectRatio.align;
  var meetOrSlice = preserveAspectRatio.meetOrSlice;
  var svgOrigin = [0, 0];
  var scale = [scaleX, scaleY];
  var translate = [0, 0];
  if (align !== 1) {
    var xAlign = (align - 2) % 3;
    var yAlign = Math.floor((align - 2) / 3);
    svgOrigin[0] = viewBoxWidth * xAlign / 2;
    svgOrigin[1] = viewBoxHeight * yAlign / 2;
    var scaleDimension = meetOrSlice === 2 ? Math.max(scaleY, scaleX) : Math.min(scaleX, scaleY);
    scale[0] = scaleDimension;
    scale[1] = scaleDimension;
    translate[0] = (clientWidth - viewBoxWidth) / 2 * xAlign;
    translate[1] = (clientHeight - viewBoxHeight) / 2 * yAlign;
  }
  var scaleMatrix2 = createScaleMatrix(scale, n2);
  _a = __read2(translate, 2), scaleMatrix2[n2 * (n2 - 1)] = _a[0], scaleMatrix2[n2 * (n2 - 1) + 1] = _a[1];
  return getAbsoluteMatrix(scaleMatrix2, n2, svgOrigin);
}
function getSVGGraphicsOffset(el, origin, isGTarget) {
  var tagName = el.tagName.toLowerCase();
  if (!el.getBBox || !isGTarget && tagName === "g") {
    return [0, 0, 0, 0];
  }
  var getStyle4 = getCachedStyle(el);
  var isFillBox = getStyle4("transform-box") === "fill-box";
  var bbox = el.getBBox();
  var viewBox = getSVGViewBox(el.ownerSVGElement);
  var x = bbox.x;
  var y = bbox.y;
  if (tagName === "foreignobject" && (!x && !y)) {
    x = parseFloat(el.getAttribute("x")) || 0;
    y = parseFloat(el.getAttribute("y")) || 0;
  }
  var left2 = x - viewBox.x;
  var top = y - viewBox.y;
  var originX = isFillBox ? origin[0] : origin[0] - left2;
  var originY = isFillBox ? origin[1] : origin[1] - top;
  return [left2, top, originX, originY];
}
function calculatePosition(matrix, pos, n2) {
  return calculate2(matrix, convertPositionMatrix(pos, n2), n2);
}
function calculatePoses(matrix, width, height, n2) {
  return [[0, 0], [width, 0], [0, height], [width, height]].map(function(pos) {
    return calculatePosition(matrix, pos, n2);
  });
}
function getRect2(poses) {
  var posesX = poses.map(function(pos) {
    return pos[0];
  });
  var posesY = poses.map(function(pos) {
    return pos[1];
  });
  var left2 = Math.min.apply(Math, __spreadArray2([], __read2(posesX), false));
  var top = Math.min.apply(Math, __spreadArray2([], __read2(posesY), false));
  var right2 = Math.max.apply(Math, __spreadArray2([], __read2(posesX), false));
  var bottom = Math.max.apply(Math, __spreadArray2([], __read2(posesY), false));
  var rectWidth = right2 - left2;
  var rectHeight = bottom - top;
  return {
    left: left2,
    top,
    right: right2,
    bottom,
    width: rectWidth,
    height: rectHeight
  };
}
function calculateRect(matrix, width, height, n2) {
  var poses = calculatePoses(matrix, width, height, n2);
  return getRect2(poses);
}
function getSVGOffset(offsetInfo, targetInfo, container, n2, beforeMatrix) {
  var _a;
  var target = offsetInfo.target;
  var origin = offsetInfo.origin;
  var targetMatrix = targetInfo.matrix;
  var _b = getSize4(target), width = _b.offsetWidth, height = _b.offsetHeight;
  var containerClientRect = container.getBoundingClientRect();
  var margin = [0, 0];
  if (container === getDocumentBody(container)) {
    margin = getBodyOffset(target, true);
  }
  var rect = target.getBoundingClientRect();
  var rectLeft = rect.left - containerClientRect.left + container.scrollLeft - (container.clientLeft || 0) + margin[0];
  var rectTop = rect.top - containerClientRect.top + container.scrollTop - (container.clientTop || 0) + margin[1];
  var rectWidth = rect.width;
  var rectHeight = rect.height;
  var mat = multiplies(n2, beforeMatrix, targetMatrix);
  var _c = calculateRect(mat, width, height, n2), prevLeft = _c.left, prevTop = _c.top, prevWidth = _c.width, prevHeight = _c.height;
  var posOrigin = calculatePosition(mat, origin, n2);
  var prevOrigin = minus(posOrigin, [prevLeft, prevTop]);
  var rectOrigin = [
    rectLeft + prevOrigin[0] * rectWidth / prevWidth,
    rectTop + prevOrigin[1] * rectHeight / prevHeight
  ];
  var offset4 = [0, 0];
  var count = 0;
  while (++count < 10) {
    var inverseBeforeMatrix = invert(beforeMatrix, n2);
    _a = __read2(minus(calculatePosition(inverseBeforeMatrix, rectOrigin, n2), calculatePosition(inverseBeforeMatrix, posOrigin, n2)), 2), offset4[0] = _a[0], offset4[1] = _a[1];
    var mat2 = multiplies(n2, beforeMatrix, createOriginMatrix(offset4, n2), targetMatrix);
    var _d = calculateRect(mat2, width, height, n2), nextLeft = _d.left, nextTop = _d.top;
    var distLeft = nextLeft - rectLeft;
    var distTop = nextTop - rectTop;
    if (abs2(distLeft) < 2 && abs2(distTop) < 2) {
      break;
    }
    rectOrigin[0] -= distLeft;
    rectOrigin[1] -= distTop;
  }
  return offset4.map(function(p) {
    return Math.round(p);
  });
}
function calculateMoveableClientPositions(rootMatrix, poses, rootClientRect) {
  var is3d = rootMatrix.length === 16;
  var n2 = is3d ? 4 : 3;
  var rootPoses = poses.map(function(pos) {
    return calculatePosition(rootMatrix, pos, n2);
  });
  var left2 = rootClientRect.left, top = rootClientRect.top;
  return rootPoses.map(function(pos) {
    return [pos[0] + left2, pos[1] + top];
  });
}
function getDistSize(vec) {
  return Math.sqrt(vec[0] * vec[0] + vec[1] * vec[1]);
}
function getDiagonalSize(pos1, pos2) {
  return getDistSize([
    pos2[0] - pos1[0],
    pos2[1] - pos1[1]
  ]);
}
function getLineStyle(pos1, pos2, zoom, rad) {
  if (zoom === void 0) {
    zoom = 1;
  }
  if (rad === void 0) {
    rad = getRad(pos1, pos2);
  }
  var width = getDiagonalSize(pos1, pos2);
  return {
    transform: "translateY(-50%) translate(".concat(pos1[0], "px, ").concat(pos1[1], "px) rotate(").concat(rad, "rad) scaleY(").concat(zoom, ")"),
    width: "".concat(width, "px")
  };
}
function getControlTransform(rotation, zoom) {
  var poses = [];
  for (var _i = 2; _i < arguments.length; _i++) {
    poses[_i - 2] = arguments[_i];
  }
  var length2 = poses.length;
  var x = poses.reduce(function(prev2, pos) {
    return prev2 + pos[0];
  }, 0) / length2;
  var y = poses.reduce(function(prev2, pos) {
    return prev2 + pos[1];
  }, 0) / length2;
  return {
    transform: "translateZ(0px) translate(".concat(x, "px, ").concat(y, "px) rotate(").concat(rotation, "rad) scale(").concat(zoom, ")")
  };
}
function getProps3(props, ableName) {
  var self2 = props[ableName];
  if (isObject5(self2)) {
    return __assign9(__assign9({}, props), self2);
  }
  return props;
}
function getSize4(target) {
  var hasOffset = target && !isUndefined2(target.offsetWidth);
  var offsetWidth = 0;
  var offsetHeight = 0;
  var clientWidth = 0;
  var clientHeight = 0;
  var cssWidth = 0;
  var cssHeight = 0;
  var contentWidth = 0;
  var contentHeight = 0;
  var minWidth = 0;
  var minHeight = 0;
  var minOffsetWidth = 0;
  var minOffsetHeight = 0;
  var maxWidth = Infinity;
  var maxHeight = Infinity;
  var maxOffsetWidth = Infinity;
  var maxOffsetHeight = Infinity;
  var inlineCSSWidth = 0;
  var inlineCSSHeight = 0;
  var svg = false;
  if (target) {
    if (!hasOffset && target.ownerSVGElement) {
      var bbox = target.getBBox();
      svg = true;
      offsetWidth = bbox.width;
      offsetHeight = bbox.height;
      cssWidth = offsetWidth;
      cssHeight = offsetHeight;
      contentWidth = offsetWidth;
      contentHeight = offsetHeight;
      clientWidth = offsetWidth;
      clientHeight = offsetHeight;
    } else {
      var getStyle4 = getCachedStyle(target);
      var targetStyle = target.style;
      var boxSizing = getStyle4("boxSizing") === "border-box";
      var borderLeft = parseFloat(getStyle4("borderLeftWidth")) || 0;
      var borderRight = parseFloat(getStyle4("borderRightWidth")) || 0;
      var borderTop = parseFloat(getStyle4("borderTopWidth")) || 0;
      var borderBottom = parseFloat(getStyle4("borderBottomWidth")) || 0;
      var paddingLeft = parseFloat(getStyle4("paddingLeft")) || 0;
      var paddingRight = parseFloat(getStyle4("paddingRight")) || 0;
      var paddingTop = parseFloat(getStyle4("paddingTop")) || 0;
      var paddingBottom = parseFloat(getStyle4("paddingBottom")) || 0;
      var horizontalPadding = paddingLeft + paddingRight;
      var verticalPadding = paddingTop + paddingBottom;
      var horizontalBorder = borderLeft + borderRight;
      var verticalBorder = borderTop + borderBottom;
      var horizontalOffset = horizontalPadding + horizontalBorder;
      var verticalOffset = verticalPadding + verticalBorder;
      var position3 = getStyle4("position");
      var containerWidth = 0;
      var containerHeight = 0;
      if ("clientLeft" in target) {
        var parentElement = null;
        if (position3 === "absolute") {
          var offsetInfo = getOffsetInfo(target, getDocumentBody(target));
          parentElement = offsetInfo.offsetParent;
        } else {
          parentElement = target.parentElement;
        }
        if (parentElement) {
          var getParentStyle = getCachedStyle(parentElement);
          containerWidth = parseFloat(getParentStyle("width"));
          containerHeight = parseFloat(getParentStyle("height"));
        }
      }
      minWidth = Math.max(horizontalPadding, convertUnitSize(getStyle4("minWidth"), containerWidth) || 0);
      minHeight = Math.max(verticalPadding, convertUnitSize(getStyle4("minHeight"), containerHeight) || 0);
      maxWidth = convertUnitSize(getStyle4("maxWidth"), containerWidth);
      maxHeight = convertUnitSize(getStyle4("maxHeight"), containerHeight);
      if (isNaN(maxWidth)) {
        maxWidth = Infinity;
      }
      if (isNaN(maxHeight)) {
        maxHeight = Infinity;
      }
      inlineCSSWidth = convertUnitSize(targetStyle.width, 0) || 0;
      inlineCSSHeight = convertUnitSize(targetStyle.height, 0) || 0;
      cssWidth = parseFloat(getStyle4("width")) || 0;
      cssHeight = parseFloat(getStyle4("height")) || 0;
      contentWidth = abs2(cssWidth - inlineCSSWidth) < 1 ? between(minWidth, inlineCSSWidth || cssWidth, maxWidth) : cssWidth;
      contentHeight = abs2(cssHeight - inlineCSSHeight) < 1 ? between(minHeight, inlineCSSHeight || cssHeight, maxHeight) : cssHeight;
      offsetWidth = contentWidth;
      offsetHeight = contentHeight;
      clientWidth = contentWidth;
      clientHeight = contentHeight;
      if (boxSizing) {
        maxOffsetWidth = maxWidth;
        maxOffsetHeight = maxHeight;
        minOffsetWidth = minWidth;
        minOffsetHeight = minHeight;
        contentWidth = offsetWidth - horizontalOffset;
        contentHeight = offsetHeight - verticalOffset;
      } else {
        maxOffsetWidth = maxWidth + horizontalOffset;
        maxOffsetHeight = maxHeight + verticalOffset;
        minOffsetWidth = minWidth + horizontalOffset;
        minOffsetHeight = minHeight + verticalOffset;
        offsetWidth = contentWidth + horizontalOffset;
        offsetHeight = contentHeight + verticalOffset;
      }
      clientWidth = contentWidth + horizontalPadding;
      clientHeight = contentHeight + verticalPadding;
    }
  }
  return {
    svg,
    offsetWidth,
    offsetHeight,
    clientWidth,
    clientHeight,
    contentWidth,
    contentHeight,
    inlineCSSWidth,
    inlineCSSHeight,
    cssWidth,
    cssHeight,
    minWidth,
    minHeight,
    maxWidth,
    maxHeight,
    minOffsetWidth,
    minOffsetHeight,
    maxOffsetWidth,
    maxOffsetHeight
  };
}
function getRotationRad(poses, direction) {
  return getRad(direction > 0 ? poses[0] : poses[1], direction > 0 ? poses[1] : poses[0]);
}
function resetClientRect() {
  return {
    left: 0,
    top: 0,
    width: 0,
    height: 0,
    right: 0,
    bottom: 0,
    clientLeft: 0,
    clientTop: 0,
    clientWidth: 0,
    clientHeight: 0,
    scrollWidth: 0,
    scrollHeight: 0
  };
}
function getExtendsRect(el, rect) {
  var isRoot = el === getDocumentBody(el) || el === getDocumentElement(el);
  var extendsRect = {
    clientLeft: el.clientLeft,
    clientTop: el.clientTop,
    clientWidth: el.clientWidth,
    clientHeight: el.clientHeight,
    scrollWidth: el.scrollWidth,
    scrollHeight: el.scrollHeight,
    overflow: false
  };
  if (isRoot) {
    extendsRect.clientHeight = Math.max(rect.height, extendsRect.clientHeight);
    extendsRect.scrollHeight = Math.max(rect.height, extendsRect.scrollHeight);
  }
  extendsRect.overflow = getCachedStyle(el)("overflow") !== "visible";
  return __assign9(__assign9({}, rect), extendsRect);
}
function getClientRectByPosition(position3, base, el, isExtends) {
  var left2 = position3.left, right2 = position3.right, top = position3.top, bottom = position3.bottom;
  var baseTop = base.top;
  var baseLeft = base.left;
  var rect = {
    left: baseLeft + left2,
    top: baseTop + top,
    right: baseLeft + right2,
    bottom: baseTop + bottom,
    width: right2 - left2,
    height: bottom - top
  };
  if (el && isExtends) {
    return getExtendsRect(el, rect);
  }
  return rect;
}
function getClientRect2(el, isExtends) {
  var left2 = 0;
  var top = 0;
  var width = 0;
  var height = 0;
  if (el) {
    var clientRect = el.getBoundingClientRect();
    left2 = clientRect.left;
    top = clientRect.top;
    width = clientRect.width;
    height = clientRect.height;
  }
  var rect = {
    left: left2,
    top,
    width,
    height,
    right: left2 + width,
    bottom: top + height
  };
  if (el && isExtends) {
    return getExtendsRect(el, rect);
  }
  return rect;
}
function getTotalOrigin(moveable) {
  var _a = moveable.props, groupable = _a.groupable, svgOrigin = _a.svgOrigin;
  var _b = moveable.getState(), offsetWidth = _b.offsetWidth, offsetHeight = _b.offsetHeight, svg = _b.svg, transformOrigin = _b.transformOrigin;
  if (!groupable && svg && svgOrigin) {
    return convertTransformOriginArray(svgOrigin, offsetWidth, offsetHeight);
  }
  return transformOrigin;
}
function getTotalDirection(parentDirection, isPinch, inputEvent, datas) {
  var direction;
  if (parentDirection) {
    direction = parentDirection;
  } else if (isPinch) {
    direction = [0, 0];
  } else {
    var target = inputEvent.target;
    direction = getDirection(target, datas);
  }
  return direction;
}
function getDirection(target, datas) {
  if (!target) {
    return;
  }
  var deg = target.getAttribute("data-rotation") || "";
  var direciton = target.getAttribute("data-direction");
  datas.deg = deg;
  if (!direciton) {
    return;
  }
  var dir = [0, 0];
  direciton.indexOf("w") > -1 && (dir[0] = -1);
  direciton.indexOf("e") > -1 && (dir[0] = 1);
  direciton.indexOf("n") > -1 && (dir[1] = -1);
  direciton.indexOf("s") > -1 && (dir[1] = 1);
  return dir;
}
function getAbsolutePoses(poses, dist) {
  return [
    plus(dist, poses[0]),
    plus(dist, poses[1]),
    plus(dist, poses[2]),
    plus(dist, poses[3])
  ];
}
function getAbsolutePosesByState(_a) {
  var left2 = _a.left, top = _a.top, pos1 = _a.pos1, pos2 = _a.pos2, pos3 = _a.pos3, pos4 = _a.pos4;
  return getAbsolutePoses([pos1, pos2, pos3, pos4], [left2, top]);
}
function unsetAbles(self2, isControl) {
  self2[isControl ? "controlAbles" : "targetAbles"].forEach(function(able) {
    able.unset && able.unset(self2);
  });
}
function unsetGesto(self2, isControl) {
  var gestoName = isControl ? "controlGesto" : "targetGesto";
  var gesto = self2[gestoName];
  if ((gesto === null || gesto === void 0 ? void 0 : gesto.isIdle()) === false) {
    unsetAbles(self2, isControl);
  }
  gesto === null || gesto === void 0 ? void 0 : gesto.unset();
  self2[gestoName] = null;
}
function fillCSSObject(style2, resolvedEvent) {
  if (resolvedEvent) {
    var originalDatas = getBeforeRenderableDatas(resolvedEvent);
    originalDatas.nextStyle = __assign9(__assign9({}, originalDatas.nextStyle), style2);
  }
  return {
    style: style2,
    cssText: getKeys2(style2).map(function(name) {
      return "".concat(decamelize(name, "-"), ": ").concat(style2[name], ";");
    }).join("")
  };
}
function fillAfterTransform(prevEvent, nextEvent, resolvedEvent) {
  var afterTransform = nextEvent.afterTransform || nextEvent.transform;
  return __assign9(__assign9({}, fillCSSObject(__assign9(__assign9(__assign9({}, prevEvent.style), nextEvent.style), { transform: afterTransform }), resolvedEvent)), { afterTransform, transform: prevEvent.transform });
}
function fillParams(moveable, e3, params, isBeforeEvent) {
  var datas = e3.datas;
  if (!datas.datas) {
    datas.datas = {};
  }
  var nextParams = __assign9(__assign9({}, params), { target: moveable.state.target, clientX: e3.clientX, clientY: e3.clientY, inputEvent: e3.inputEvent, currentTarget: moveable, moveable, datas: datas.datas, isRequest: e3.isRequest, isRequestChild: e3.isRequestChild, isFirstDrag: !!e3.isFirstDrag, isTrusted: e3.isTrusted !== false, stopAble: function() {
    datas.isEventStart = false;
  }, stopDrag: function() {
    var _a;
    (_a = e3.stop) === null || _a === void 0 ? void 0 : _a.call(e3);
  } });
  if (!datas.isStartEvent) {
    datas.isStartEvent = true;
  } else if (!isBeforeEvent) {
    datas.lastEvent = nextParams;
  }
  return nextParams;
}
function fillEndParams(moveable, e3, params) {
  var datas = e3.datas;
  var isDrag = "isDrag" in params ? params.isDrag : e3.isDrag;
  if (!datas.datas) {
    datas.datas = {};
  }
  return __assign9(__assign9({ isDrag }, params), { moveable, target: moveable.state.target, clientX: e3.clientX, clientY: e3.clientY, inputEvent: e3.inputEvent, currentTarget: moveable, lastEvent: datas.lastEvent, isDouble: e3.isDouble, datas: datas.datas, isFirstDrag: !!e3.isFirstDrag });
}
function catchEvent(moveable, name, callback) {
  moveable._emitter.on(name, callback);
}
function triggerEvent(moveable, name, params, isManager, isRequest) {
  return moveable.triggerEvent(name, params, isManager, isRequest);
}
function getComputedStyle2(el, pseudoElt) {
  return getWindow2(el).getComputedStyle(el, pseudoElt);
}
function filterAbles(ables, methods2, triggerAblesSimultaneously) {
  var enabledAbles = {};
  var ableGroups = {};
  return ables.filter(function(able) {
    var name = able.name;
    if (enabledAbles[name] || !methods2.some(function(method4) {
      return able[method4];
    })) {
      return false;
    }
    if (!triggerAblesSimultaneously && able.ableGroup) {
      if (ableGroups[able.ableGroup]) {
        return false;
      }
      ableGroups[able.ableGroup] = true;
    }
    enabledAbles[name] = true;
    return true;
  });
}
function equals(a1, a2) {
  return a1 === a2 || a1 == null && a2 == null;
}
function selectValue() {
  var values = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    values[_i] = arguments[_i];
  }
  var length2 = values.length - 1;
  for (var i = 0; i < length2; ++i) {
    var value = values[i];
    if (!isUndefined2(value)) {
      return value;
    }
  }
  return values[length2];
}
function groupBy(arr, func) {
  var groups = [];
  var groupKeys = [];
  arr.forEach(function(el, index3) {
    var groupKey = func(el, index3, arr);
    var keyIndex2 = groupKeys.indexOf(groupKey);
    var group = groups[keyIndex2] || [];
    if (keyIndex2 === -1) {
      groupKeys.push(groupKey);
      groups.push(group);
    }
    group.push(el);
  });
  return groups;
}
function groupByMap(arr, func) {
  var groups = [];
  var groupKeys = {};
  arr.forEach(function(el, index3) {
    var groupKey = func(el, index3, arr);
    var group = groupKeys[groupKey];
    if (!group) {
      group = [];
      groupKeys[groupKey] = group;
      groups.push(group);
    }
    group.push(el);
  });
  return groups;
}
function flat2(arr) {
  return arr.reduce(function(prev2, cur) {
    return prev2.concat(cur);
  }, []);
}
function maxOffset() {
  var args = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }
  args.sort(function(a, b) {
    return abs2(b) - abs2(a);
  });
  return args[0];
}
function calculateInversePosition(matrix, pos, n2) {
  return calculate2(invert(matrix, n2), convertPositionMatrix(pos, n2), n2);
}
function convertDragDist(state, e3) {
  var _a;
  var is3d = state.is3d, rootMatrix = state.rootMatrix;
  var n2 = is3d ? 4 : 3;
  _a = __read2(calculateInversePosition(rootMatrix, [e3.distX, e3.distY], n2), 2), e3.distX = _a[0], e3.distY = _a[1];
  return e3;
}
function calculatePadding(matrix, pos, added, n2) {
  if (!added[0] && !added[1]) {
    return pos;
  }
  var xAdded = calculatePosition(matrix, [normalized(added[0] || 1), 0], n2);
  var yAdded = calculatePosition(matrix, [0, normalized(added[1] || 1)], n2);
  var nextAdded = calculatePosition(matrix, [
    added[0] / getDistSize(xAdded),
    added[1] / getDistSize(yAdded)
  ], n2);
  return plus(pos, nextAdded);
}
function convertCSSSize(value, size, isRelative) {
  return isRelative ? "".concat(value / size * 100, "%") : "".concat(value, "px");
}
function getTinyDist(v) {
  return abs2(v) <= TINY_NUM2 ? 0 : v;
}
function getDirectionViewClassName(ableName) {
  return function(moveable) {
    if (!moveable.isDragging(ableName)) {
      return "";
    }
    var data2 = getGestoData(moveable, ableName);
    var deg = data2.deg;
    if (!deg) {
      return "";
    }
    return prefix("view-control-rotation".concat(deg));
  };
}
function getDirectionCondition(ableName, checkAbles) {
  if (checkAbles === void 0) {
    checkAbles = [ableName];
  }
  return function(moveable, e3) {
    if (e3.isRequest) {
      if (checkAbles.some(function(name) {
        return e3.requestAble === name;
      })) {
        return e3.parentDirection;
      } else {
        return false;
      }
    }
    var target = e3.inputEvent.target;
    return hasClass(target, prefix("direction")) && (!ableName || hasClass(target, prefix(ableName)));
  };
}
function convertTransformInfo(transforms, state, index3) {
  var _a;
  var matrixInfos = parse5(transforms, {
    "x%": function(v) {
      return v / 100 * state.offsetWidth;
    },
    "y%": function(v) {
      return v / 100 * state.offsetHeight;
    }
  });
  var beforeFunctionTexts = transforms.slice(0, index3 < 0 ? void 0 : index3);
  var beforeFunctionTexts2 = transforms.slice(0, index3 < 0 ? void 0 : index3 + 1);
  var targetFunctionText = transforms[index3] || "";
  var afterFunctionTexts = index3 < 0 ? [] : transforms.slice(index3);
  var afterFunctionTexts2 = index3 < 0 ? [] : transforms.slice(index3 + 1);
  var beforeFunctions = matrixInfos.slice(0, index3 < 0 ? void 0 : index3);
  var beforeFunctions2 = matrixInfos.slice(0, index3 < 0 ? void 0 : index3 + 1);
  var targetFunction = (_a = matrixInfos[index3]) !== null && _a !== void 0 ? _a : parse5([""])[0];
  var afterFunctions = index3 < 0 ? [] : matrixInfos.slice(index3);
  var afterFunctions2 = index3 < 0 ? [] : matrixInfos.slice(index3 + 1);
  var targetFunctions = targetFunction ? [targetFunction] : [];
  var beforeFunctionMatrix = toMat(beforeFunctions);
  var beforeFunctionMatrix2 = toMat(beforeFunctions2);
  var afterFunctionMatrix = toMat(afterFunctions);
  var afterFunctionMatrix2 = toMat(afterFunctions2);
  var allFunctionMatrix = multiply(beforeFunctionMatrix, afterFunctionMatrix, 4);
  return {
    transforms,
    beforeFunctionMatrix,
    beforeFunctionMatrix2,
    targetFunctionMatrix: toMat(targetFunctions),
    afterFunctionMatrix,
    afterFunctionMatrix2,
    allFunctionMatrix,
    beforeFunctions,
    beforeFunctions2,
    targetFunction: targetFunctions[0],
    afterFunctions,
    afterFunctions2,
    beforeFunctionTexts,
    beforeFunctionTexts2,
    targetFunctionText,
    afterFunctionTexts,
    afterFunctionTexts2
  };
}
function isArrayFormat(arr) {
  if (!arr || !isObject5(arr)) {
    return false;
  }
  if (isNode2(arr)) {
    return false;
  }
  return isArray5(arr) || "length" in arr;
}
function getRefTarget(target, isSelector) {
  if (!target) {
    return null;
  }
  if (isNode2(target)) {
    return target;
  }
  if (isString2(target)) {
    if (isSelector) {
      return document.querySelector(target);
    }
    return target;
  }
  if (isFunction5(target)) {
    return target();
  }
  if (isWindow3(target)) {
    return target;
  }
  if ("current" in target) {
    return target.current;
  }
  return target;
}
function getRefTargets(targets, isSelector) {
  if (!targets) {
    return [];
  }
  var userTargets = isArrayFormat(targets) ? [].slice.call(targets) : [targets];
  return userTargets.reduce(function(prev2, target) {
    if (isString2(target) && isSelector) {
      return __spreadArray2(__spreadArray2([], __read2(prev2), false), __read2([].slice.call(document.querySelectorAll(target))), false);
    }
    if (isArray5(target)) {
      prev2.push(getRefTargets(target, isSelector));
    } else {
      prev2.push(getRefTarget(target, isSelector));
    }
    return prev2;
  }, []);
}
function getAbsoluteRotation(pos1, pos2, direction) {
  var deg = getRad(pos1, pos2) / Math.PI * 180;
  deg = direction >= 0 ? deg : 180 - deg;
  deg = deg >= 0 ? deg : 360 + deg;
  return deg;
}
function getDragDistByState(state, dist) {
  var rootMatrix = state.rootMatrix, is3d = state.is3d;
  var n2 = is3d ? 4 : 3;
  var inverseMatrix = invert(rootMatrix, n2);
  if (!is3d) {
    inverseMatrix = convertDimension(inverseMatrix, 3, 4);
  }
  inverseMatrix[12] = 0;
  inverseMatrix[13] = 0;
  inverseMatrix[14] = 0;
  return calculateMatrixDist(inverseMatrix, dist);
}
function getSizeDistByDist(startSize, dist, ratio, direction, keepRatio) {
  var _a = __read2(startSize, 2), startOffsetWidth = _a[0], startOffsetHeight = _a[1];
  var distWidth = 0;
  var distHeight = 0;
  if (keepRatio && startOffsetWidth && startOffsetHeight) {
    var rad = getRad([0, 0], dist);
    var standardRad = getRad([0, 0], direction);
    var size = getDistSize(dist);
    var signSize = Math.cos(rad - standardRad) * size;
    if (!direction[0]) {
      distHeight = signSize;
      distWidth = distHeight * ratio;
    } else if (!direction[1]) {
      distWidth = signSize;
      distHeight = distWidth / ratio;
    } else {
      var startWidthSize = direction[0] * startOffsetWidth;
      var startHeightSize = direction[1] * startOffsetHeight;
      var secondRad = Math.atan2(startWidthSize + dist[0], startHeightSize + dist[1]);
      var firstRad = Math.atan2(startWidthSize, startHeightSize);
      if (secondRad < 0) {
        secondRad += Math.PI * 2;
      }
      if (firstRad < 0) {
        firstRad += Math.PI * 2;
      }
      var rad_1 = 0;
      if (abs2(secondRad - firstRad) < Math.PI / 2 || abs2(secondRad - firstRad) > Math.PI / 2 * 3) {
        rad_1 = secondRad - firstRad;
      } else {
        firstRad += Math.PI;
        rad_1 = secondRad - firstRad;
      }
      if (rad_1 > Math.PI * 2) {
        rad_1 -= Math.PI * 2;
      } else if (rad_1 > Math.PI) {
        rad_1 = 2 * Math.PI - rad_1;
      } else if (rad_1 < -Math.PI) {
        rad_1 = -2 * Math.PI - rad_1;
      }
      var distSize = getDistSize([startWidthSize + dist[0], startHeightSize + dist[1]]) * Math.cos(rad_1);
      distWidth = distSize * Math.sin(firstRad) - startWidthSize;
      distHeight = distSize * Math.cos(firstRad) - startHeightSize;
      if (direction[0] < 0) {
        distWidth *= -1;
      }
      if (direction[1] < 0) {
        distHeight *= -1;
      }
    }
  } else {
    distWidth = direction[0] * dist[0];
    distHeight = direction[1] * dist[1];
  }
  return [distWidth, distHeight];
}
function getOffsetSizeDist(sizeDirection, keepRatio, datas, e3) {
  var _a;
  var ratio = datas.ratio, startOffsetWidth = datas.startOffsetWidth, startOffsetHeight = datas.startOffsetHeight;
  var distWidth = 0;
  var distHeight = 0;
  var distX = e3.distX, distY = e3.distY, pinchScale = e3.pinchScale, parentDistance = e3.parentDistance, parentDist = e3.parentDist, parentScale = e3.parentScale;
  var startFixedDirection = datas.fixedDirection;
  var directionsDists = [0, 1].map(function(index3) {
    return abs2(sizeDirection[index3] - startFixedDirection[index3]);
  });
  var directionRatios = [0, 1].map(function(index3) {
    var dist = directionsDists[index3];
    if (dist !== 0) {
      dist = 2 / dist;
    }
    return dist;
  });
  if (parentDist) {
    distWidth = parentDist[0];
    distHeight = parentDist[1];
    if (keepRatio) {
      if (!distWidth) {
        distWidth = distHeight * ratio;
      } else if (!distHeight) {
        distHeight = distWidth / ratio;
      }
    }
  } else if (isNumber3(pinchScale)) {
    distWidth = (pinchScale - 1) * startOffsetWidth;
    distHeight = (pinchScale - 1) * startOffsetHeight;
  } else if (parentScale) {
    distWidth = (parentScale[0] - 1) * startOffsetWidth;
    distHeight = (parentScale[1] - 1) * startOffsetHeight;
  } else if (parentDistance) {
    var scaleX = startOffsetWidth * directionsDists[0];
    var scaleY = startOffsetHeight * directionsDists[1];
    var ratioDistance = getDistSize([scaleX, scaleY]);
    distWidth = parentDistance / ratioDistance * scaleX * directionRatios[0];
    distHeight = parentDistance / ratioDistance * scaleY * directionRatios[1];
  } else {
    var dist_1 = getDragDist({ datas, distX, distY });
    dist_1 = directionRatios.map(function(ratio2, i) {
      return dist_1[i] * ratio2;
    });
    _a = __read2(getSizeDistByDist([startOffsetWidth, startOffsetHeight], dist_1, ratio, sizeDirection, keepRatio), 2), distWidth = _a[0], distHeight = _a[1];
  }
  return {
    // direction,
    // sizeDirection,
    distWidth,
    distHeight
  };
}
function convertTransformUnit(origin, xy) {
  if (xy) {
    if (origin === "left") {
      return { x: "0%", y: "50%" };
    } else if (origin === "top") {
      return { x: "50%", y: "50%" };
    } else if (origin === "center") {
      return { x: "50%", y: "50%" };
    } else if (origin === "right") {
      return { x: "100%", y: "50%" };
    } else if (origin === "bottom") {
      return { x: "50%", y: "100%" };
    }
    var _a = __read2(origin.split(" "), 2), left2 = _a[0], right2 = _a[1];
    var leftOrigin = convertTransformUnit(left2 || "");
    var rightOrigin = convertTransformUnit(right2 || "");
    var originObject = __assign9(__assign9({}, leftOrigin), rightOrigin);
    var nextOriginObject = {
      x: "50%",
      y: "50%"
    };
    if (originObject.x) {
      nextOriginObject.x = originObject.x;
    }
    if (originObject.y) {
      nextOriginObject.y = originObject.y;
    }
    if (originObject.value) {
      if (originObject.x && !originObject.y) {
        nextOriginObject.y = originObject.value;
      }
      if (!originObject.x && originObject.y) {
        nextOriginObject.x = originObject.value;
      }
    }
    return nextOriginObject;
  }
  if (origin === "left") {
    return { x: "0%" };
  }
  if (origin === "right") {
    return { x: "100%" };
  }
  if (origin === "top") {
    return { y: "0%" };
  }
  if (origin === "bottom") {
    return { y: "100%" };
  }
  if (!origin) {
    return {};
  }
  if (origin === "center") {
    return { value: "50%" };
  }
  return { value: origin };
}
function convertTransformOriginArray(transformOrigin, width, height) {
  var _a = convertTransformUnit(transformOrigin, true), x = _a.x, y = _a.y;
  return [
    convertUnitSize(x, width) || 0,
    convertUnitSize(y, height) || 0
  ];
}
function rotatePosesInfo(poses, origin, rad) {
  var prevPoses = poses.map(function(pos) {
    return minus(pos, origin);
  });
  var nextPoses = prevPoses.map(function(pos) {
    return rotate(pos, rad);
  });
  return {
    prev: prevPoses,
    next: nextPoses,
    result: nextPoses.map(function(pos) {
      return plus(pos, origin);
    })
  };
}
function isDeepArrayEquals(arr1, arr2) {
  return arr1.length === arr2.length && arr1.every(function(value1, i) {
    var value2 = arr2[i];
    var isArray1 = isArray5(value1);
    var isArray22 = isArray5(value2);
    if (isArray1 && isArray22) {
      return isDeepArrayEquals(value1, value2);
    } else if (!isArray1 && !isArray22) {
      return value1 === value2;
    }
    return false;
  });
}
function watchValue(moveable, property2, nextValue, valueKey, defaultValue2) {
  var store = moveable._store;
  var prevValue = store[property2];
  if (!(property2 in store)) {
    if (defaultValue2 != null) {
      store[property2] = defaultValue2;
      prevValue = defaultValue2;
    } else {
      store[property2] = nextValue;
      return nextValue;
    }
  }
  if (prevValue === nextValue || valueKey(prevValue) === valueKey(nextValue)) {
    return prevValue;
  }
  store[property2] = nextValue;
  return nextValue;
}
function sign(value) {
  return value >= 0 ? 1 : -1;
}
function abs2(value) {
  return Math.abs(value);
}
function countEach(count, callback) {
  return counter(count).map(function(index3) {
    return callback(index3);
  });
}
function getPaddingBox(padding) {
  if (isNumber3(padding)) {
    return {
      top: padding,
      left: padding,
      right: padding,
      bottom: padding
    };
  }
  return {
    left: padding.left || 0,
    top: padding.top || 0,
    right: padding.right || 0,
    bottom: padding.bottom || 0
  };
}
var Pinchable = makeAble("pinchable", {
  props: [
    "pinchable"
  ],
  events: [
    "pinchStart",
    "pinch",
    "pinchEnd",
    "pinchGroupStart",
    "pinchGroup",
    "pinchGroupEnd"
  ],
  dragStart: function() {
    return true;
  },
  pinchStart: function(moveable, e3) {
    var datas = e3.datas, targets = e3.targets, angle = e3.angle, originalDatas = e3.originalDatas;
    var _a = moveable.props, pinchable = _a.pinchable, ables = _a.ables;
    if (!pinchable) {
      return false;
    }
    var eventName = "onPinch".concat(targets ? "Group" : "", "Start");
    var controlEventName = "drag".concat(targets ? "Group" : "", "ControlStart");
    var pinchAbles = (pinchable === true ? moveable.controlAbles : ables.filter(function(able) {
      return pinchable.indexOf(able.name) > -1;
    })).filter(function(able) {
      return able.canPinch && able[controlEventName];
    });
    var params = fillParams(moveable, e3, {});
    if (targets) {
      params.targets = targets;
    }
    var result = triggerEvent(moveable, eventName, params);
    datas.isPinch = result !== false;
    datas.ables = pinchAbles;
    var isPinch = datas.isPinch;
    if (!isPinch) {
      return false;
    }
    pinchAbles.forEach(function(able) {
      originalDatas[able.name] = originalDatas[able.name] || {};
      if (!able[controlEventName]) {
        return;
      }
      var ableEvent = __assign9(__assign9({}, e3), { datas: originalDatas[able.name], parentRotate: angle, isPinch: true });
      able[controlEventName](moveable, ableEvent);
    });
    moveable.state.snapRenderInfo = {
      request: e3.isRequest,
      direction: [0, 0]
    };
    return isPinch;
  },
  pinch: function(moveable, e3) {
    var datas = e3.datas, pinchScale = e3.scale, distance = e3.distance, originalDatas = e3.originalDatas, inputEvent = e3.inputEvent, targets = e3.targets, angle = e3.angle;
    if (!datas.isPinch) {
      return;
    }
    var parentDistance = distance * (1 - 1 / pinchScale);
    var params = fillParams(moveable, e3, {});
    if (targets) {
      params.targets = targets;
    }
    var eventName = "onPinch".concat(targets ? "Group" : "");
    triggerEvent(moveable, eventName, params);
    var ables = datas.ables;
    var controlEventName = "drag".concat(targets ? "Group" : "", "Control");
    ables.forEach(function(able) {
      if (!able[controlEventName]) {
        return;
      }
      able[controlEventName](moveable, __assign9(__assign9({}, e3), { datas: originalDatas[able.name], inputEvent, resolveMatrix: true, pinchScale, parentDistance, parentRotate: angle, isPinch: true }));
    });
    return params;
  },
  pinchEnd: function(moveable, e3) {
    var datas = e3.datas, isPinch = e3.isPinch, inputEvent = e3.inputEvent, targets = e3.targets, originalDatas = e3.originalDatas;
    if (!datas.isPinch) {
      return;
    }
    var eventName = "onPinch".concat(targets ? "Group" : "", "End");
    var params = fillEndParams(moveable, e3, { isDrag: isPinch });
    if (targets) {
      params.targets = targets;
    }
    triggerEvent(moveable, eventName, params);
    var ables = datas.ables;
    var controlEventName = "drag".concat(targets ? "Group" : "", "ControlEnd");
    ables.forEach(function(able) {
      if (!able[controlEventName]) {
        return;
      }
      able[controlEventName](moveable, __assign9(__assign9({}, e3), { isDrag: isPinch, datas: originalDatas[able.name], inputEvent, isPinch: true }));
    });
    return isPinch;
  },
  pinchGroupStart: function(moveable, e3) {
    return this.pinchStart(moveable, __assign9(__assign9({}, e3), { targets: moveable.props.targets }));
  },
  pinchGroup: function(moveable, e3) {
    return this.pinch(moveable, __assign9(__assign9({}, e3), { targets: moveable.props.targets }));
  },
  pinchGroupEnd: function(moveable, e3) {
    return this.pinchEnd(moveable, __assign9(__assign9({}, e3), { targets: moveable.props.targets }));
  }
});
var directionCondition = getDirectionCondition("scalable");
var Scalable = {
  name: "scalable",
  ableGroup: "size",
  canPinch: true,
  props: [
    "scalable",
    "throttleScale",
    "renderDirections",
    "keepRatio",
    "edge",
    "displayAroundControls"
  ],
  events: [
    "scaleStart",
    "beforeScale",
    "scale",
    "scaleEnd",
    "scaleGroupStart",
    "beforeScaleGroup",
    "scaleGroup",
    "scaleGroupEnd"
  ],
  render: getRenderDirections("scalable"),
  dragControlCondition: directionCondition,
  viewClassName: getDirectionViewClassName("scalable"),
  dragControlStart: function(moveable, e3) {
    var datas = e3.datas, isPinch = e3.isPinch, inputEvent = e3.inputEvent, parentDirection = e3.parentDirection;
    var direction = getTotalDirection(parentDirection, isPinch, inputEvent, datas);
    var _a = moveable.state, width = _a.width, height = _a.height, targetTransform = _a.targetTransform, target = _a.target, pos1 = _a.pos1, pos2 = _a.pos2, pos4 = _a.pos4;
    if (!direction || !target) {
      return false;
    }
    if (!isPinch) {
      setDragStart(moveable, e3);
    }
    datas.datas = {};
    datas.transform = targetTransform;
    datas.prevDist = [1, 1];
    datas.direction = direction;
    datas.startOffsetWidth = width;
    datas.startOffsetHeight = height;
    datas.startValue = [1, 1];
    var isWidth = !direction[0] && !direction[1] || direction[0] || !direction[1];
    setDefaultTransformIndex(moveable, e3, "scale");
    datas.isWidth = isWidth;
    function setRatio(ratio) {
      datas.ratio = ratio && isFinite(ratio) ? ratio : 0;
    }
    datas.startPositions = getAbsolutePosesByState(moveable.state);
    function setFixedDirection(fixedDirection) {
      var result2 = getFixedDirectionInfo(datas.startPositions, fixedDirection);
      datas.fixedDirection = result2.fixedDirection;
      datas.fixedPosition = result2.fixedPosition;
      datas.fixedOffset = result2.fixedOffset;
    }
    datas.setFixedDirection = setFixedDirection;
    setRatio(getDist(pos1, pos2) / getDist(pos2, pos4));
    setFixedDirection([-direction[0], -direction[1]]);
    var setMinScaleSize = function(min) {
      datas.minScaleSize = min;
    };
    var setMaxScaleSize = function(max) {
      datas.maxScaleSize = max;
    };
    setMinScaleSize([-Infinity, -Infinity]);
    setMaxScaleSize([Infinity, Infinity]);
    var params = fillParams(moveable, e3, __assign9(__assign9({ direction, set: function(scale) {
      datas.startValue = scale;
    }, setRatio, setFixedDirection, setMinScaleSize, setMaxScaleSize }, fillTransformStartEvent(moveable, e3)), { dragStart: Draggable2.dragStart(moveable, new CustomGesto().dragStart([0, 0], e3)) }));
    var result = triggerEvent(moveable, "onScaleStart", params);
    datas.startFixedDirection = datas.fixedDirection;
    if (result !== false) {
      datas.isScale = true;
      moveable.state.snapRenderInfo = {
        request: e3.isRequest,
        direction
      };
    }
    return datas.isScale ? params : false;
  },
  dragControl: function(moveable, e3) {
    resolveTransformEvent(moveable, e3, "scale");
    var datas = e3.datas, parentKeepRatio = e3.parentKeepRatio, parentFlag = e3.parentFlag, isPinch = e3.isPinch, dragClient = e3.dragClient, isRequest = e3.isRequest, useSnap = e3.useSnap, resolveMatrix = e3.resolveMatrix;
    var prevDist = datas.prevDist, direction = datas.direction, startOffsetWidth = datas.startOffsetWidth, startOffsetHeight = datas.startOffsetHeight, isScale = datas.isScale, startValue = datas.startValue, isWidth = datas.isWidth, ratio = datas.ratio;
    if (!isScale) {
      return false;
    }
    var props = moveable.props;
    var throttleScale = props.throttleScale, parentMoveable = props.parentMoveable;
    var sizeDirection = direction;
    if (!direction[0] && !direction[1]) {
      sizeDirection = [1, 1];
    }
    var keepRatio = ratio && (parentKeepRatio != null ? parentKeepRatio : props.keepRatio) || false;
    var state = moveable.state;
    var tempScaleValue = [
      startValue[0],
      startValue[1]
    ];
    function getNextScale() {
      var _a = getOffsetSizeDist(sizeDirection, keepRatio, datas, e3), distWidth = _a.distWidth, distHeight = _a.distHeight;
      var distX = startOffsetWidth ? (startOffsetWidth + distWidth) / startOffsetWidth : 1;
      var distY = startOffsetHeight ? (startOffsetHeight + distHeight) / startOffsetHeight : 1;
      if (!startValue[0]) {
        tempScaleValue[0] = distWidth / startOffsetWidth;
      }
      if (!startValue[1]) {
        tempScaleValue[1] = distHeight / startOffsetHeight;
      }
      var scaleX = (sizeDirection[0] || keepRatio ? distX : 1) * tempScaleValue[0];
      var scaleY = (sizeDirection[1] || keepRatio ? distY : 1) * tempScaleValue[1];
      if (scaleX === 0) {
        scaleX = sign(prevDist[0]) * MIN_SCALE;
      }
      if (scaleY === 0) {
        scaleY = sign(prevDist[1]) * MIN_SCALE;
      }
      return [scaleX, scaleY];
    }
    var scale = getNextScale();
    if (!isPinch && moveable.props.groupable) {
      var snapRenderInfo = state.snapRenderInfo || {};
      var stateDirection = snapRenderInfo.direction;
      if (isArray5(stateDirection) && (stateDirection[0] || stateDirection[1])) {
        state.snapRenderInfo = { direction, request: e3.isRequest };
      }
    }
    triggerEvent(moveable, "onBeforeScale", fillParams(moveable, e3, {
      scale,
      setFixedDirection: function(nextFixedDirection) {
        datas.setFixedDirection(nextFixedDirection);
        scale = getNextScale();
        return scale;
      },
      startFixedDirection: datas.startFixedDirection,
      setScale: function(nextScale) {
        scale = nextScale;
      }
    }, true));
    var dist = [
      scale[0] / tempScaleValue[0],
      scale[1] / tempScaleValue[1]
    ];
    var fixedPosition = dragClient;
    var snapDist = [0, 0];
    var distSign = sign(dist[0] * dist[1]);
    var isSelfPinch = !dragClient && !parentFlag && isPinch;
    if (isSelfPinch || resolveMatrix) {
      fixedPosition = getTranslateFixedPosition(moveable, datas.targetAllTransform, [0, 0], [0, 0], datas);
    } else if (!dragClient) {
      fixedPosition = datas.fixedPosition;
    }
    if (!isPinch) {
      snapDist = checkSnapScale(moveable, dist, direction, !useSnap && isRequest, datas);
    }
    if (keepRatio) {
      if (sizeDirection[0] && sizeDirection[1] && snapDist[0] && snapDist[1]) {
        if (Math.abs(snapDist[0] * startOffsetWidth) > Math.abs(snapDist[1] * startOffsetHeight)) {
          snapDist[1] = 0;
        } else {
          snapDist[0] = 0;
        }
      }
      var isNoSnap = !snapDist[0] && !snapDist[1];
      if (isNoSnap) {
        if (isWidth) {
          dist[0] = throttle3(dist[0] * tempScaleValue[0], throttleScale) / tempScaleValue[0];
        } else {
          dist[1] = throttle3(dist[1] * tempScaleValue[1], throttleScale) / tempScaleValue[1];
        }
      }
      if (sizeDirection[0] && !sizeDirection[1] || snapDist[0] && !snapDist[1] || isNoSnap && isWidth) {
        dist[0] += snapDist[0];
        var snapHeight = startOffsetWidth * dist[0] * tempScaleValue[0] / ratio;
        dist[1] = sign(distSign * dist[0]) * abs2(snapHeight / startOffsetHeight / tempScaleValue[1]);
      } else if (!sizeDirection[0] && sizeDirection[1] || !snapDist[0] && snapDist[1] || isNoSnap && !isWidth) {
        dist[1] += snapDist[1];
        var snapWidth = startOffsetHeight * dist[1] * tempScaleValue[1] * ratio;
        dist[0] = sign(distSign * dist[1]) * abs2(snapWidth / startOffsetWidth / tempScaleValue[0]);
      }
    } else {
      dist[0] += snapDist[0];
      dist[1] += snapDist[1];
      if (!snapDist[0]) {
        dist[0] = throttle3(dist[0] * tempScaleValue[0], throttleScale) / tempScaleValue[0];
      }
      if (!snapDist[1]) {
        dist[1] = throttle3(dist[1] * tempScaleValue[1], throttleScale) / tempScaleValue[1];
      }
    }
    if (dist[0] === 0) {
      dist[0] = sign(prevDist[0]) * MIN_SCALE;
    }
    if (dist[1] === 0) {
      dist[1] = sign(prevDist[1]) * MIN_SCALE;
    }
    scale = multiply2(dist, [tempScaleValue[0], tempScaleValue[1]]);
    var startOffsetSize = [
      startOffsetWidth,
      startOffsetHeight
    ];
    var scaleSize = [
      startOffsetWidth * scale[0],
      startOffsetHeight * scale[1]
    ];
    scaleSize = calculateBoundSize(scaleSize, datas.minScaleSize, datas.maxScaleSize, keepRatio ? ratio : false);
    scale = countEach(2, function(i) {
      return startOffsetSize[i] ? scaleSize[i] / startOffsetSize[i] : scaleSize[i];
    });
    dist = countEach(2, function(i) {
      return scale[i] / tempScaleValue[i];
    });
    var delta = countEach(2, function(i) {
      return prevDist[i] ? dist[i] / prevDist[i] : dist[i];
    });
    var distText = "scale(".concat(dist.join(", "), ")");
    var scaleText = "scale(".concat(scale.join(", "), ")");
    var nextTransform = convertTransformFormat(datas, scaleText, distText);
    var isZeroScale = !startValue[0] || !startValue[1];
    var inverseDist = getScaleDist(moveable, isZeroScale ? scaleText : distText, datas.fixedDirection, fixedPosition, datas.fixedOffset, datas, isZeroScale);
    var inverseDelta = isSelfPinch ? inverseDist : minus(inverseDist, datas.prevInverseDist || [0, 0]);
    datas.prevDist = dist;
    datas.prevInverseDist = inverseDist;
    if (scale[0] === prevDist[0] && scale[1] === prevDist[1] && inverseDelta.every(function(num) {
      return !num;
    }) && !parentMoveable && !isSelfPinch) {
      return false;
    }
    var params = fillParams(moveable, e3, __assign9({ offsetWidth: startOffsetWidth, offsetHeight: startOffsetHeight, direction, scale, dist, delta, isPinch: !!isPinch }, fillTransformEvent(moveable, nextTransform, inverseDelta, isPinch, e3)));
    triggerEvent(moveable, "onScale", params);
    return params;
  },
  dragControlEnd: function(moveable, e3) {
    var datas = e3.datas;
    if (!datas.isScale) {
      return false;
    }
    datas.isScale = false;
    var scaleEndParam = fillEndParams(moveable, e3, {});
    triggerEvent(moveable, "onScaleEnd", scaleEndParam);
    return scaleEndParam;
  },
  dragGroupControlCondition: directionCondition,
  dragGroupControlStart: function(moveable, e3) {
    var datas = e3.datas;
    var params = this.dragControlStart(moveable, e3);
    if (!params) {
      return false;
    }
    var originalEvents = fillChildEvents(moveable, "resizable", e3);
    datas.moveableScale = moveable.scale;
    var events2 = triggerChildAbles(moveable, this, "dragControlStart", e3, function(child, ev) {
      return startChildDist(moveable, child, datas, ev);
    });
    var setFixedDirection = function(fixedDirection) {
      params.setFixedDirection(fixedDirection);
      events2.forEach(function(ev, i) {
        ev.setFixedDirection(fixedDirection);
        startChildDist(moveable, ev.moveable, datas, originalEvents[i]);
      });
    };
    datas.setFixedDirection = setFixedDirection;
    var nextParams = __assign9(__assign9({}, params), { targets: moveable.props.targets, events: events2, setFixedDirection });
    var result = triggerEvent(moveable, "onScaleGroupStart", nextParams);
    datas.isScale = result !== false;
    return datas.isScale ? nextParams : false;
  },
  dragGroupControl: function(moveable, e3) {
    var datas = e3.datas;
    if (!datas.isScale) {
      return;
    }
    catchEvent(moveable, "onBeforeScale", function(parentEvent) {
      triggerEvent(moveable, "onBeforeScaleGroup", fillParams(moveable, e3, __assign9(__assign9({}, parentEvent), { targets: moveable.props.targets }), true));
    });
    var params = this.dragControl(moveable, e3);
    if (!params) {
      return;
    }
    var dist = params.dist;
    var moveableScale = datas.moveableScale;
    moveable.scale = [
      dist[0] * moveableScale[0],
      dist[1] * moveableScale[1]
    ];
    var keepRatio = moveable.props.keepRatio;
    var fixedPosition = datas.fixedPosition;
    var events2 = triggerChildAbles(moveable, this, "dragControl", e3, function(_, ev) {
      var _a = __read2(calculate2(createRotateMatrix(moveable.rotation / 180 * Math.PI, 3), [
        ev.datas.originalX * dist[0],
        ev.datas.originalY * dist[1],
        1
      ], 3), 2), clientX = _a[0], clientY = _a[1];
      return __assign9(__assign9({}, ev), {
        parentDist: null,
        parentScale: dist,
        parentKeepRatio: keepRatio,
        // recalculate child fixed position for parent group's dragging.
        dragClient: plus(fixedPosition, [clientX, clientY])
      });
    });
    var nextParams = __assign9({ targets: moveable.props.targets, events: events2 }, params);
    triggerEvent(moveable, "onScaleGroup", nextParams);
    return nextParams;
  },
  dragGroupControlEnd: function(moveable, e3) {
    var isDrag = e3.isDrag, datas = e3.datas;
    if (!datas.isScale) {
      return;
    }
    this.dragControlEnd(moveable, e3);
    var events2 = triggerChildAbles(moveable, this, "dragControlEnd", e3);
    var nextParams = fillEndParams(moveable, e3, {
      targets: moveable.props.targets,
      events: events2
    });
    triggerEvent(moveable, "onScaleGroupEnd", nextParams);
    return isDrag;
  },
  /**
       * @method Moveable.Scalable#request
       * @param {Moveable.Scalable.ScalableRequestParam} e - the Scalable's request parameter
       * @return {Moveable.Requester} Moveable Requester
       * @example
  
       * // Instantly Request (requestStart - request - requestEnd)
       * moveable.request("scalable", { deltaWidth: 10, deltaHeight: 10 }, true);
       *
       * // requestStart
       * const requester = moveable.request("scalable");
       *
       * // request
       * requester.request({ deltaWidth: 10, deltaHeight: 10 });
       * requester.request({ deltaWidth: 10, deltaHeight: 10 });
       * requester.request({ deltaWidth: 10, deltaHeight: 10 });
       *
       * // requestEnd
       * requester.requestEnd();
       */
  request: function() {
    var datas = {};
    var distWidth = 0;
    var distHeight = 0;
    var useSnap = false;
    return {
      isControl: true,
      requestStart: function(e3) {
        useSnap = e3.useSnap;
        return {
          datas,
          parentDirection: e3.direction || [1, 1],
          useSnap
        };
      },
      request: function(e3) {
        distWidth += e3.deltaWidth;
        distHeight += e3.deltaHeight;
        return {
          datas,
          parentDist: [distWidth, distHeight],
          parentKeepRatio: e3.keepRatio,
          useSnap
        };
      },
      requestEnd: function() {
        return { datas, isDrag: true, useSnap };
      }
    };
  }
};
function getMiddleLinePos(pos1, pos2) {
  return pos1.map(function(pos, i) {
    return dot(pos, pos2[i], 1, 2);
  });
}
function getTriangleRad(pos1, pos2, pos3) {
  var rad1 = getRad(pos1, pos2);
  var rad2 = getRad(pos1, pos3);
  var rad = rad2 - rad1;
  return rad >= 0 ? rad : rad + 2 * Math.PI;
}
function isValidPos(poses1, poses2) {
  var rad1 = getTriangleRad(poses1[0], poses1[1], poses1[2]);
  var rad2 = getTriangleRad(poses2[0], poses2[1], poses2[2]);
  var pi = Math.PI;
  if (rad1 >= pi && rad2 <= pi || rad1 <= pi && rad2 >= pi) {
    return false;
  }
  return true;
}
var Warpable = {
  name: "warpable",
  ableGroup: "size",
  props: [
    "warpable",
    "renderDirections",
    "edge",
    "displayAroundControls"
  ],
  events: [
    "warpStart",
    "warp",
    "warpEnd"
  ],
  viewClassName: getDirectionViewClassName("warpable"),
  render: function(moveable, React615) {
    var _a = moveable.props, resizable = _a.resizable, scalable = _a.scalable, warpable = _a.warpable, zoom = _a.zoom;
    if (resizable || scalable || !warpable) {
      return [];
    }
    var _b = moveable.state, pos1 = _b.pos1, pos2 = _b.pos2, pos3 = _b.pos3, pos4 = _b.pos4;
    var linePosFrom1 = getMiddleLinePos(pos1, pos2);
    var linePosFrom2 = getMiddleLinePos(pos2, pos1);
    var linePosFrom3 = getMiddleLinePos(pos1, pos3);
    var linePosFrom4 = getMiddleLinePos(pos3, pos1);
    var linePosTo1 = getMiddleLinePos(pos3, pos4);
    var linePosTo2 = getMiddleLinePos(pos4, pos3);
    var linePosTo3 = getMiddleLinePos(pos2, pos4);
    var linePosTo4 = getMiddleLinePos(pos4, pos2);
    return __spreadArray2([
      React615.createElement("div", { className: prefix("line"), key: "middeLine1", style: getLineStyle(linePosFrom1, linePosTo1, zoom) }),
      React615.createElement("div", { className: prefix("line"), key: "middeLine2", style: getLineStyle(linePosFrom2, linePosTo2, zoom) }),
      React615.createElement("div", { className: prefix("line"), key: "middeLine3", style: getLineStyle(linePosFrom3, linePosTo3, zoom) }),
      React615.createElement("div", { className: prefix("line"), key: "middeLine4", style: getLineStyle(linePosFrom4, linePosTo4, zoom) })
    ], __read2(renderAllDirections(moveable, "warpable", React615)), false);
  },
  dragControlCondition: function(moveable, e3) {
    if (e3.isRequest) {
      return false;
    }
    var target = e3.inputEvent.target;
    return hasClass(target, prefix("direction")) && hasClass(target, prefix("warpable"));
  },
  dragControlStart: function(moveable, e3) {
    var datas = e3.datas, inputEvent = e3.inputEvent;
    var target = moveable.props.target;
    var inputTarget = inputEvent.target;
    var direction = getDirection(inputTarget, datas);
    if (!direction || !target) {
      return false;
    }
    var state = moveable.state;
    var transformOrigin = state.transformOrigin, is3d = state.is3d, targetTransform = state.targetTransform, targetMatrix = state.targetMatrix, width = state.width, height = state.height, left2 = state.left, top = state.top;
    datas.datas = {};
    datas.targetTransform = targetTransform;
    datas.warpTargetMatrix = is3d ? targetMatrix : convertDimension(targetMatrix, 3, 4);
    datas.targetInverseMatrix = ignoreDimension(invert(datas.warpTargetMatrix, 4), 3, 4);
    datas.direction = direction;
    datas.left = left2;
    datas.top = top;
    datas.poses = [
      [0, 0],
      [width, 0],
      [0, height],
      [width, height]
    ].map(function(p) {
      return minus(p, transformOrigin);
    });
    datas.nextPoses = datas.poses.map(function(_a) {
      var _b = __read2(_a, 2), x = _b[0], y = _b[1];
      return calculate2(datas.warpTargetMatrix, [x, y, 0, 1], 4);
    });
    datas.startValue = createIdentityMatrix(4);
    datas.prevMatrix = createIdentityMatrix(4);
    datas.absolutePoses = getAbsolutePosesByState(state);
    datas.posIndexes = getPosIndexesByDirection(direction);
    setDragStart(moveable, e3);
    setDefaultTransformIndex(moveable, e3, "matrix3d");
    state.snapRenderInfo = {
      request: e3.isRequest,
      direction
    };
    var params = fillParams(moveable, e3, __assign9({ set: function(matrix) {
      datas.startValue = matrix;
    } }, fillTransformStartEvent(moveable, e3)));
    var result = triggerEvent(moveable, "onWarpStart", params);
    if (result !== false) {
      datas.isWarp = true;
    }
    return datas.isWarp;
  },
  dragControl: function(moveable, e3) {
    var datas = e3.datas, isRequest = e3.isRequest;
    var distX = e3.distX, distY = e3.distY;
    var targetInverseMatrix = datas.targetInverseMatrix, prevMatrix = datas.prevMatrix, isWarp = datas.isWarp, startValue = datas.startValue, poses = datas.poses, posIndexes = datas.posIndexes, absolutePoses = datas.absolutePoses;
    if (!isWarp) {
      return false;
    }
    resolveTransformEvent(moveable, e3, "matrix3d");
    if (hasGuidelines(moveable, "warpable")) {
      var selectedPoses = posIndexes.map(function(index3) {
        return absolutePoses[index3];
      });
      if (selectedPoses.length > 1) {
        selectedPoses.push([
          (selectedPoses[0][0] + selectedPoses[1][0]) / 2,
          (selectedPoses[0][1] + selectedPoses[1][1]) / 2
        ]);
      }
      var _a = checkMoveableSnapBounds(moveable, isRequest, {
        horizontal: selectedPoses.map(function(pos) {
          return pos[1] + distY;
        }),
        vertical: selectedPoses.map(function(pos) {
          return pos[0] + distX;
        })
      }), horizontalSnapInfo = _a.horizontal, verticalSnapInfo = _a.vertical;
      distY -= horizontalSnapInfo.offset;
      distX -= verticalSnapInfo.offset;
    }
    var dist = getDragDist({ datas, distX, distY }, true);
    var nextPoses = datas.nextPoses.slice();
    posIndexes.forEach(function(index3) {
      nextPoses[index3] = plus(nextPoses[index3], dist);
    });
    if (!NEARBY_POS.every(function(nearByPoses) {
      return isValidPos(nearByPoses.map(function(i) {
        return poses[i];
      }), nearByPoses.map(function(i) {
        return nextPoses[i];
      }));
    })) {
      return false;
    }
    var h2 = createWarpMatrix(poses[0], poses[2], poses[1], poses[3], nextPoses[0], nextPoses[2], nextPoses[1], nextPoses[3]);
    if (!h2.length) {
      return false;
    }
    var afterMatrix = multiply(targetInverseMatrix, h2, 4);
    var matrix = getTransfromMatrix(datas, afterMatrix, true);
    var delta = multiply(invert(prevMatrix, 4), matrix, 4);
    datas.prevMatrix = matrix;
    var totalMatrix = multiply(startValue, matrix, 4);
    var nextTransform = convertTransformFormat(datas, "matrix3d(".concat(totalMatrix.join(", "), ")"), "matrix3d(".concat(matrix.join(", "), ")"));
    fillOriginalTransform(e3, nextTransform);
    triggerEvent(moveable, "onWarp", fillParams(moveable, e3, __assign9({ delta, matrix: totalMatrix, dist: matrix, multiply, transform: nextTransform }, fillCSSObject({
      transform: nextTransform
    }, e3))));
    return true;
  },
  dragControlEnd: function(moveable, e3) {
    var datas = e3.datas, isDrag = e3.isDrag;
    if (!datas.isWarp) {
      return false;
    }
    datas.isWarp = false;
    triggerEvent(moveable, "onWarpEnd", fillEndParams(moveable, e3, {}));
    return isDrag;
  }
};
var AREA_PIECES = /* @__PURE__ */ prefix("area-pieces");
var AREA_PIECE = /* @__PURE__ */ prefix("area-piece");
var AVOID = /* @__PURE__ */ prefix("avoid");
var VIEW_DRAGGING = prefix("view-dragging");
function restoreStyle(moveable) {
  var el = moveable.areaElement;
  if (!el) {
    return;
  }
  var _a = moveable.state, width = _a.width, height = _a.height;
  removeClass(el, AVOID);
  el.style.cssText += "left: 0px; top: 0px; width: ".concat(width, "px; height: ").concat(height, "px");
}
function renderPieces(React615) {
  return React615.createElement(
    "div",
    { key: "area_pieces", className: AREA_PIECES },
    React615.createElement("div", { className: AREA_PIECE }),
    React615.createElement("div", { className: AREA_PIECE }),
    React615.createElement("div", { className: AREA_PIECE }),
    React615.createElement("div", { className: AREA_PIECE })
  );
}
var DragArea = {
  name: "dragArea",
  props: [
    "dragArea",
    "passDragArea"
  ],
  events: [
    "click",
    "clickGroup"
  ],
  render: function(moveable, React615) {
    var _a = moveable.props, target = _a.target, dragArea = _a.dragArea, groupable = _a.groupable, passDragArea = _a.passDragArea;
    var _b = moveable.getState(), width = _b.width, height = _b.height, renderPoses = _b.renderPoses;
    var className2 = passDragArea ? prefix("area", "pass") : prefix("area");
    if (groupable) {
      return [
        React615.createElement("div", { key: "area", ref: ref2(moveable, "areaElement"), className: className2 }),
        renderPieces(React615)
      ];
    }
    if (!target || !dragArea) {
      return [];
    }
    var h2 = createWarpMatrix([0, 0], [width, 0], [0, height], [width, height], renderPoses[0], renderPoses[1], renderPoses[2], renderPoses[3]);
    var transform = h2.length ? makeMatrixCSS(h2, true) : "none";
    return [
      React615.createElement("div", { key: "area", ref: ref2(moveable, "areaElement"), className: className2, style: {
        top: "0px",
        left: "0px",
        width: "".concat(width, "px"),
        height: "".concat(height, "px"),
        transformOrigin: "0 0",
        transform
      } }),
      renderPieces(React615)
    ];
  },
  dragStart: function(moveable, _a) {
    var datas = _a.datas, clientX = _a.clientX, clientY = _a.clientY, inputEvent = _a.inputEvent;
    if (!inputEvent) {
      return false;
    }
    datas.isDragArea = false;
    var areaElement = moveable.areaElement;
    var state = moveable.state;
    var moveableClientRect = state.moveableClientRect, renderPoses = state.renderPoses, rootMatrix = state.rootMatrix, is3d = state.is3d;
    var left2 = moveableClientRect.left, top = moveableClientRect.top;
    var _b = getRect2(renderPoses), relativeLeft = _b.left, relativeTop = _b.top, width = _b.width, height = _b.height;
    var n2 = is3d ? 4 : 3;
    var _c = __read2(calculateInversePosition(rootMatrix, [clientX - left2, clientY - top], n2), 2), posX = _c[0], posY = _c[1];
    posX -= relativeLeft;
    posY -= relativeTop;
    var rects = [
      { left: relativeLeft, top: relativeTop, width, height: posY - 10 },
      { left: relativeLeft, top: relativeTop, width: posX - 10, height },
      { left: relativeLeft, top: relativeTop + posY + 10, width, height: height - posY - 10 },
      { left: relativeLeft + posX + 10, top: relativeTop, width: width - posX - 10, height }
    ];
    var children = [].slice.call(areaElement.nextElementSibling.children);
    rects.forEach(function(rect, i) {
      children[i].style.cssText = "left: ".concat(rect.left, "px;top: ").concat(rect.top, "px; width: ").concat(rect.width, "px; height: ").concat(rect.height, "px;");
    });
    addClass(areaElement, AVOID);
    state.disableNativeEvent = true;
    return;
  },
  drag: function(moveable, _a) {
    var datas = _a.datas, inputEvent = _a.inputEvent;
    this.enableNativeEvent(moveable);
    if (!inputEvent) {
      return false;
    }
    if (!datas.isDragArea) {
      datas.isDragArea = true;
      restoreStyle(moveable);
    }
  },
  dragEnd: function(moveable, e3) {
    this.enableNativeEvent(moveable);
    var inputEvent = e3.inputEvent, datas = e3.datas;
    if (!inputEvent) {
      return false;
    }
    if (!datas.isDragArea) {
      restoreStyle(moveable);
    }
  },
  dragGroupStart: function(moveable, e3) {
    return this.dragStart(moveable, e3);
  },
  dragGroup: function(moveable, e3) {
    return this.drag(moveable, e3);
  },
  dragGroupEnd: function(moveable, e3) {
    return this.dragEnd(moveable, e3);
  },
  unset: function(moveable) {
    restoreStyle(moveable);
    moveable.state.disableNativeEvent = false;
  },
  enableNativeEvent: function(moveable) {
    var state = moveable.state;
    if (state.disableNativeEvent) {
      requestAnimationFrame2(function() {
        state.disableNativeEvent = false;
      });
    }
  }
};
var Origin = makeAble("origin", {
  props: ["origin", "svgOrigin"],
  render: function(moveable, React615) {
    var _a = moveable.props, zoom = _a.zoom, svgOrigin = _a.svgOrigin, groupable = _a.groupable;
    var _b = moveable.getState(), beforeOrigin = _b.beforeOrigin, rotation = _b.rotation, svg = _b.svg, allMatrix = _b.allMatrix, is3d = _b.is3d, left2 = _b.left, top = _b.top, offsetWidth = _b.offsetWidth, offsetHeight = _b.offsetHeight;
    var originStyle;
    if (!groupable && svg && svgOrigin) {
      var _c = __read2(convertTransformOriginArray(svgOrigin, offsetWidth, offsetHeight), 2), originX = _c[0], originY = _c[1];
      var n2 = is3d ? 4 : 3;
      var result = calculatePosition(allMatrix, [originX, originY], n2);
      originStyle = getControlTransform(rotation, zoom, minus(result, [left2, top]));
    } else {
      originStyle = getControlTransform(rotation, zoom, beforeOrigin);
    }
    return [
      React615.createElement("div", { className: prefix("control", "origin"), style: originStyle, key: "beforeOrigin" })
    ];
  }
});
function getDefaultScrollPosition2(e3) {
  var scrollContainer = e3.scrollContainer;
  return [
    scrollContainer.scrollLeft,
    scrollContainer.scrollTop
  ];
}
var Scrollable = {
  name: "scrollable",
  canPinch: true,
  props: [
    "scrollable",
    "scrollContainer",
    "scrollThreshold",
    "scrollThrottleTime",
    "getScrollPosition",
    "scrollOptions"
  ],
  events: [
    "scroll",
    "scrollGroup"
  ],
  dragRelation: "strong",
  dragStart: function(moveable, e3) {
    var props = moveable.props;
    var _a = props.scrollContainer, scrollContainer = _a === void 0 ? moveable.getContainer() : _a, scrollOptions = props.scrollOptions;
    var dragScroll = new dragscroll_esm_default();
    var scrollContainerElement = getRefTarget(scrollContainer, true);
    e3.datas.dragScroll = dragScroll;
    moveable.state.dragScroll = dragScroll;
    var gestoName = e3.isControl ? "controlGesto" : "targetGesto";
    var targets = e3.targets;
    dragScroll.on("scroll", function(_a2) {
      var container = _a2.container, direction = _a2.direction;
      var params = fillParams(moveable, e3, {
        scrollContainer: container,
        direction
      });
      var eventName = targets ? "onScrollGroup" : "onScroll";
      if (targets) {
        params.targets = targets;
      }
      triggerEvent(moveable, eventName, params);
    }).on("move", function(_a2) {
      var offsetX = _a2.offsetX, offsetY = _a2.offsetY, inputEvent = _a2.inputEvent;
      moveable[gestoName].scrollBy(offsetX, offsetY, inputEvent.inputEvent, false);
    }).on("scrollDrag", function(_a2) {
      var next2 = _a2.next;
      next2(moveable[gestoName].getCurrentEvent());
    });
    dragScroll.dragStart(e3, __assign9({ container: scrollContainerElement }, scrollOptions));
  },
  checkScroll: function(moveable, e3) {
    var dragScroll = e3.datas.dragScroll;
    if (!dragScroll) {
      return;
    }
    var _a = moveable.props, _b = _a.scrollContainer, scrollContainer = _b === void 0 ? moveable.getContainer() : _b, _c = _a.scrollThreshold, scrollThreshold = _c === void 0 ? 0 : _c, _d = _a.scrollThrottleTime, scrollThrottleTime = _d === void 0 ? 0 : _d, _e = _a.getScrollPosition, getScrollPosition2 = _e === void 0 ? getDefaultScrollPosition2 : _e, scrollOptions = _a.scrollOptions;
    dragScroll.drag(e3, __assign9({ container: scrollContainer, threshold: scrollThreshold, throttleTime: scrollThrottleTime, getScrollPosition: function(ev) {
      return getScrollPosition2({ scrollContainer: ev.container, direction: ev.direction });
    } }, scrollOptions));
    return true;
  },
  drag: function(moveable, e3) {
    return this.checkScroll(moveable, e3);
  },
  dragEnd: function(moveable, e3) {
    e3.datas.dragScroll.dragEnd();
    e3.datas.dragScroll = null;
  },
  dragControlStart: function(moveable, e3) {
    return this.dragStart(moveable, __assign9(__assign9({}, e3), { isControl: true }));
  },
  dragControl: function(moveable, e3) {
    return this.drag(moveable, e3);
  },
  dragControlEnd: function(moveable, e3) {
    return this.dragEnd(moveable, e3);
  },
  dragGroupStart: function(moveable, e3) {
    return this.dragStart(moveable, __assign9(__assign9({}, e3), { targets: moveable.props.targets }));
  },
  dragGroup: function(moveable, e3) {
    return this.drag(moveable, __assign9(__assign9({}, e3), { targets: moveable.props.targets }));
  },
  dragGroupEnd: function(moveable, e3) {
    return this.dragEnd(moveable, __assign9(__assign9({}, e3), { targets: moveable.props.targets }));
  },
  dragGroupControlStart: function(moveable, e3) {
    return this.dragStart(moveable, __assign9(__assign9({}, e3), { targets: moveable.props.targets, isControl: true }));
  },
  dragGroupControl: function(moveable, e3) {
    return this.drag(moveable, __assign9(__assign9({}, e3), { targets: moveable.props.targets }));
  },
  dragGroupControEnd: function(moveable, e3) {
    return this.dragEnd(moveable, __assign9(__assign9({}, e3), { targets: moveable.props.targets }));
  },
  unset: function(moveable) {
    var _a;
    var state = moveable.state;
    (_a = state.dragScroll) === null || _a === void 0 ? void 0 : _a.dragEnd();
    state.dragScroll = null;
  }
};
var Default = {
  name: "",
  props: [
    "target",
    "dragTargetSelf",
    "dragTarget",
    "dragContainer",
    "container",
    "warpSelf",
    "rootContainer",
    "useResizeObserver",
    "useMutationObserver",
    "zoom",
    "dragFocusedInput",
    "transformOrigin",
    "ables",
    "className",
    "pinchThreshold",
    "pinchOutside",
    "triggerAblesSimultaneously",
    "checkInput",
    "cspNonce",
    "translateZ",
    "hideDefaultLines",
    "props",
    "flushSync",
    "stopPropagation",
    "preventClickEventOnDrag",
    "preventClickDefault",
    "viewContainer",
    "persistData",
    "useAccuratePosition",
    "firstRenderState",
    "linePadding",
    "controlPadding",
    "preventDefault",
    "preventRightClick",
    "preventWheelClick",
    "requestStyles"
  ],
  events: [
    "changeTargets"
  ]
};
var Padding = makeAble("padding", {
  props: ["padding"],
  render: function(moveable, React615) {
    var props = moveable.props;
    if (props.dragArea) {
      return [];
    }
    var _a = getPaddingBox(props.padding || {}), left2 = _a.left, top = _a.top, right2 = _a.right, bottom = _a.bottom;
    var _b = moveable.getState(), renderPoses = _b.renderPoses, pos1 = _b.pos1, pos2 = _b.pos2, pos3 = _b.pos3, pos4 = _b.pos4;
    var poses = [pos1, pos2, pos3, pos4];
    var paddingDirections = [];
    if (left2 > 0) {
      paddingDirections.push([0, 2]);
    }
    if (top > 0) {
      paddingDirections.push([0, 1]);
    }
    if (right2 > 0) {
      paddingDirections.push([1, 3]);
    }
    if (bottom > 0) {
      paddingDirections.push([2, 3]);
    }
    return paddingDirections.map(function(_a2, i) {
      var _b2 = __read2(_a2, 2), dir1 = _b2[0], dir2 = _b2[1];
      var paddingPos1 = poses[dir1];
      var paddingPos2 = poses[dir2];
      var paddingPos3 = renderPoses[dir1];
      var paddingPos4 = renderPoses[dir2];
      var h2 = createWarpMatrix([0, 0], [100, 0], [0, 100], [100, 100], paddingPos1, paddingPos2, paddingPos3, paddingPos4);
      if (!h2.length) {
        return void 0;
      }
      return React615.createElement("div", { key: "padding".concat(i), className: prefix("padding"), style: {
        transform: makeMatrixCSS(h2, true)
      } });
    });
  }
});
var RADIUS_DIRECTIONS = ["nw", "ne", "se", "sw"];
function calculateRatio(values, size) {
  var sumSize = values[0] + values[1];
  var sumRatio = sumSize > size ? size / sumSize : 1;
  values[0] *= sumRatio;
  values[1] = size - values[1] * sumRatio;
  return values;
}
var HORIZONTAL_RADIUS_ORDER = [1, 2, 5, 6];
var VERTICAL_RADIUS_ORDER = [0, 3, 4, 7];
var HORIZONTAL_RADIUS_DIRECTIONS = [1, -1, -1, 1];
var VERTICAL_RADIUS_DIRECTIONS = [1, 1, -1, -1];
function getRadiusStyles(nextPoses, isRelative, width, height, left2, top, right2, bottom) {
  if (left2 === void 0) {
    left2 = 0;
  }
  if (top === void 0) {
    top = 0;
  }
  if (right2 === void 0) {
    right2 = width;
  }
  if (bottom === void 0) {
    bottom = height;
  }
  var clipStyles = [];
  var isVertical = false;
  var radiusPoses = nextPoses.filter(function(pos) {
    return !pos.virtual;
  });
  var raws = radiusPoses.map(function(posInfo) {
    var horizontal = posInfo.horizontal, vertical = posInfo.vertical, pos = posInfo.pos;
    if (vertical && !isVertical) {
      isVertical = true;
      clipStyles.push("/");
    }
    if (isVertical) {
      var rawPos = Math.max(0, vertical === 1 ? pos[1] - top : bottom - pos[1]);
      clipStyles.push(convertCSSSize(rawPos, height, isRelative));
      return rawPos;
    } else {
      var rawPos = Math.max(0, horizontal === 1 ? pos[0] - left2 : right2 - pos[0]);
      clipStyles.push(convertCSSSize(rawPos, width, isRelative));
      return rawPos;
    }
  });
  return {
    radiusPoses,
    styles: clipStyles,
    raws
  };
}
function getRadiusRange(controlPoses) {
  var horizontalRange = [0, 0];
  var verticalRange = [0, 0];
  var length2 = controlPoses.length;
  for (var i = 0; i < length2; ++i) {
    var clipPose = controlPoses[i];
    if (!clipPose.sub) {
      continue;
    }
    if (clipPose.horizontal) {
      if (horizontalRange[1] === 0) {
        horizontalRange[0] = i;
      }
      horizontalRange[1] = i - horizontalRange[0] + 1;
      verticalRange[0] = i + 1;
    }
    if (clipPose.vertical) {
      if (verticalRange[1] === 0) {
        verticalRange[0] = i;
      }
      verticalRange[1] = i - verticalRange[0] + 1;
    }
  }
  return {
    horizontalRange,
    verticalRange
  };
}
function getRadiusValues(values, width, height, left2, top, minCounts, full) {
  var _a, _b, _c, _d;
  if (minCounts === void 0) {
    minCounts = [0, 0];
  }
  if (full === void 0) {
    full = false;
  }
  var splitIndex = values.indexOf("/");
  var splitLength = (splitIndex > -1 ? values.slice(0, splitIndex) : values).length;
  var horizontalValues = values.slice(0, splitLength);
  var verticalValues = values.slice(splitLength + 1);
  var horizontalValuesLength = horizontalValues.length;
  var verticalValuesLength = verticalValues.length;
  var hasVerticalValues = verticalValuesLength > 0;
  var _e = __read2(horizontalValues, 4), _f = _e[0], nwValue = _f === void 0 ? "0px" : _f, _g = _e[1], neValue = _g === void 0 ? nwValue : _g, _h = _e[2], seValue = _h === void 0 ? nwValue : _h, _j = _e[3], swValue = _j === void 0 ? neValue : _j;
  var _k = __read2(verticalValues, 4), _l = _k[0], wnValue = _l === void 0 ? nwValue : _l, _m = _k[1], enValue = _m === void 0 ? hasVerticalValues ? wnValue : neValue : _m, _o = _k[2], esValue = _o === void 0 ? hasVerticalValues ? wnValue : seValue : _o, _p = _k[3], wsValue = _p === void 0 ? hasVerticalValues ? enValue : swValue : _p;
  var horizontalRawPoses = [nwValue, neValue, seValue, swValue].map(function(pos) {
    return convertUnitSize(pos, width);
  });
  var verticalRawPoses = [wnValue, enValue, esValue, wsValue].map(function(pos) {
    return convertUnitSize(pos, height);
  });
  var horizontalPoses = horizontalRawPoses.slice();
  var verticalPoses = verticalRawPoses.slice();
  _a = __read2(calculateRatio([horizontalPoses[0], horizontalPoses[1]], width), 2), horizontalPoses[0] = _a[0], horizontalPoses[1] = _a[1];
  _b = __read2(calculateRatio([horizontalPoses[3], horizontalPoses[2]], width), 2), horizontalPoses[3] = _b[0], horizontalPoses[2] = _b[1];
  _c = __read2(calculateRatio([verticalPoses[0], verticalPoses[3]], height), 2), verticalPoses[0] = _c[0], verticalPoses[3] = _c[1];
  _d = __read2(calculateRatio([verticalPoses[1], verticalPoses[2]], height), 2), verticalPoses[1] = _d[0], verticalPoses[2] = _d[1];
  var nextHorizontalPoses = full ? horizontalPoses : horizontalPoses.slice(0, Math.max(minCounts[0], horizontalValuesLength));
  var nextVerticalPoses = full ? verticalPoses : verticalPoses.slice(0, Math.max(minCounts[1], verticalValuesLength));
  return __spreadArray2(__spreadArray2([], __read2(nextHorizontalPoses.map(function(pos, i) {
    var direction = RADIUS_DIRECTIONS[i];
    return {
      virtual: i >= horizontalValuesLength,
      horizontal: HORIZONTAL_RADIUS_DIRECTIONS[i],
      vertical: 0,
      pos: [left2 + pos, top + (VERTICAL_RADIUS_DIRECTIONS[i] === -1 ? height : 0)],
      sub: true,
      raw: horizontalRawPoses[i],
      direction
    };
  })), false), __read2(nextVerticalPoses.map(function(pos, i) {
    var direction = RADIUS_DIRECTIONS[i];
    return {
      virtual: i >= verticalValuesLength,
      horizontal: 0,
      vertical: VERTICAL_RADIUS_DIRECTIONS[i],
      pos: [left2 + (HORIZONTAL_RADIUS_DIRECTIONS[i] === -1 ? width : 0), top + pos],
      sub: true,
      raw: verticalRawPoses[i],
      direction
    };
  })), false);
}
function removeRadiusPos(controlPoses, poses, index3, startIndex, length2) {
  if (length2 === void 0) {
    length2 = poses.length;
  }
  var _a = getRadiusRange(controlPoses.slice(startIndex)), horizontalRange = _a.horizontalRange, verticalRange = _a.verticalRange;
  var radiuslIndex = index3 - startIndex;
  var deleteCount = 0;
  if (radiuslIndex === 0) {
    deleteCount = length2;
  } else if (radiuslIndex > 0 && radiuslIndex < horizontalRange[1]) {
    deleteCount = horizontalRange[1] - radiuslIndex;
  } else if (radiuslIndex >= verticalRange[0]) {
    deleteCount = verticalRange[0] + verticalRange[1] - radiuslIndex;
  } else {
    return;
  }
  controlPoses.splice(index3, deleteCount);
  poses.splice(index3, deleteCount);
}
function addRadiusPos(controlPoses, poses, startIndex, horizontalIndex, verticalIndex, distX, distY, right2, bottom, left2, top) {
  if (left2 === void 0) {
    left2 = 0;
  }
  if (top === void 0) {
    top = 0;
  }
  var _a = getRadiusRange(controlPoses.slice(startIndex)), horizontalRange = _a.horizontalRange, verticalRange = _a.verticalRange;
  if (horizontalIndex > -1) {
    var radiusX = HORIZONTAL_RADIUS_DIRECTIONS[horizontalIndex] === 1 ? distX - left2 : right2 - distX;
    for (var i = horizontalRange[1]; i <= horizontalIndex; ++i) {
      var y = VERTICAL_RADIUS_DIRECTIONS[i] === 1 ? top : bottom;
      var x = 0;
      if (horizontalIndex === i) {
        x = distX;
      } else if (i === 0) {
        x = left2 + radiusX;
      } else if (HORIZONTAL_RADIUS_DIRECTIONS[i] === -1) {
        x = right2 - (poses[startIndex][0] - left2);
      }
      controlPoses.splice(startIndex + i, 0, {
        horizontal: HORIZONTAL_RADIUS_DIRECTIONS[i],
        vertical: 0,
        pos: [x, y]
      });
      poses.splice(startIndex + i, 0, [x, y]);
      if (i === 0) {
        break;
      }
    }
  } else if (verticalIndex > -1) {
    var radiusY = VERTICAL_RADIUS_DIRECTIONS[verticalIndex] === 1 ? distY - top : bottom - distY;
    if (horizontalRange[1] === 0 && verticalRange[1] === 0) {
      var pos = [
        left2 + radiusY,
        top
      ];
      controlPoses.push({
        horizontal: HORIZONTAL_RADIUS_DIRECTIONS[0],
        vertical: 0,
        pos
      });
      poses.push(pos);
    }
    var startVerticalIndex = verticalRange[0];
    for (var i = verticalRange[1]; i <= verticalIndex; ++i) {
      var x = HORIZONTAL_RADIUS_DIRECTIONS[i] === 1 ? left2 : right2;
      var y = 0;
      if (verticalIndex === i) {
        y = distY;
      } else if (i === 0) {
        y = top + radiusY;
      } else if (VERTICAL_RADIUS_DIRECTIONS[i] === 1) {
        y = poses[startIndex + startVerticalIndex][1];
      } else if (VERTICAL_RADIUS_DIRECTIONS[i] === -1) {
        y = bottom - (poses[startIndex + startVerticalIndex][1] - top);
      }
      controlPoses.push({
        horizontal: 0,
        vertical: VERTICAL_RADIUS_DIRECTIONS[i],
        pos: [x, y]
      });
      poses.push([x, y]);
      if (i === 0) {
        break;
      }
    }
  }
}
function splitRadiusPoses(controlPoses, raws) {
  if (raws === void 0) {
    raws = controlPoses.map(function(pos) {
      return pos.raw;
    });
  }
  var horizontals = controlPoses.map(function(pos, i) {
    return pos.horizontal ? raws[i] : null;
  }).filter(function(pos) {
    return pos != null;
  });
  var verticals = controlPoses.map(function(pos, i) {
    return pos.vertical ? raws[i] : null;
  }).filter(function(pos) {
    return pos != null;
  });
  return {
    horizontals,
    verticals
  };
}
var CLIP_DIRECTIONS = [
  [0, -1, "n"],
  [1, 0, "e"]
];
var CLIP_RECT_DIRECTIONS = [
  [-1, -1, "nw"],
  [0, -1, "n"],
  [1, -1, "ne"],
  [1, 0, "e"],
  [1, 1, "se"],
  [0, 1, "s"],
  [-1, 1, "sw"],
  [-1, 0, "w"]
];
function getClipStyles(moveable, clipPath, poses) {
  var clipRelative = moveable.props.clipRelative;
  var _a = moveable.state, width = _a.width, height = _a.height;
  var _b = clipPath, clipType = _b.type, clipPoses = _b.poses;
  var isRect = clipType === "rect";
  var isCircle = clipType === "circle";
  if (clipType === "polygon") {
    return poses.map(function(pos) {
      return "".concat(convertCSSSize(pos[0], width, clipRelative), " ").concat(convertCSSSize(pos[1], height, clipRelative));
    });
  } else if (isRect || clipType === "inset") {
    var top_1 = poses[1][1];
    var right2 = poses[3][0];
    var left2 = poses[7][0];
    var bottom = poses[5][1];
    if (isRect) {
      return [
        top_1,
        right2,
        bottom,
        left2
      ].map(function(pos) {
        return "".concat(pos, "px");
      });
    }
    var clipStyles = [top_1, width - right2, height - bottom, left2].map(function(pos, i) {
      return convertCSSSize(pos, i % 2 ? width : height, clipRelative);
    });
    if (poses.length > 8) {
      var _c = __read2(minus(poses[4], poses[0]), 2), subWidth = _c[0], subHeight = _c[1];
      clipStyles.push.apply(clipStyles, __spreadArray2(["round"], __read2(getRadiusStyles(clipPoses.slice(8).map(function(info, i) {
        return __assign9(__assign9({}, info), { pos: poses[i] });
      }), clipRelative, subWidth, subHeight, left2, top_1, right2, bottom).styles), false));
    }
    return clipStyles;
  } else if (isCircle || clipType === "ellipse") {
    var center = poses[0];
    var ry = convertCSSSize(abs2(poses[1][1] - center[1]), isCircle ? Math.sqrt((width * width + height * height) / 2) : height, clipRelative);
    var clipStyles = isCircle ? [ry] : [convertCSSSize(abs2(poses[2][0] - center[0]), width, clipRelative), ry];
    clipStyles.push("at", convertCSSSize(center[0], width, clipRelative), convertCSSSize(center[1], height, clipRelative));
    return clipStyles;
  }
}
function getRectPoses(top, right2, bottom, left2) {
  var xs = [left2, (left2 + right2) / 2, right2];
  var ys = [top, (top + bottom) / 2, bottom];
  return CLIP_RECT_DIRECTIONS.map(function(_a) {
    var _b = __read2(_a, 3), dirx = _b[0], diry = _b[1], dir = _b[2];
    var x = xs[dirx + 1];
    var y = ys[diry + 1];
    return {
      vertical: abs2(diry),
      horizontal: abs2(dirx),
      direction: dir,
      pos: [x, y]
    };
  });
}
function getControlSize(controlPoses) {
  var xRange = [Infinity, -Infinity];
  var yRange = [Infinity, -Infinity];
  controlPoses.forEach(function(_a) {
    var pos = _a.pos;
    xRange[0] = Math.min(xRange[0], pos[0]);
    xRange[1] = Math.max(xRange[1], pos[0]);
    yRange[0] = Math.min(yRange[0], pos[1]);
    yRange[1] = Math.max(yRange[1], pos[1]);
  });
  return [
    abs2(xRange[1] - xRange[0]),
    abs2(yRange[1] - yRange[0])
  ];
}
function getClipPath(target, width, height, defaultClip, customClip) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j;
  if (!target) {
    return;
  }
  var clipText = customClip;
  if (!clipText) {
    var getStyle4 = getCachedStyle(target);
    var clipPath = getStyle4("clipPath");
    clipText = clipPath !== "none" ? clipPath : getStyle4("clip");
  }
  if (!clipText || clipText === "none" || clipText === "auto") {
    clipText = defaultClip;
    if (!clipText) {
      return;
    }
  }
  var _k = splitBracket(clipText), _l = _k.prefix, clipPrefix = _l === void 0 ? clipText : _l, _m = _k.value, value = _m === void 0 ? "" : _m;
  var isCircle = clipPrefix === "circle";
  var splitter = " ";
  if (clipPrefix === "polygon") {
    var values = splitComma(value || "0% 0%, 100% 0%, 100% 100%, 0% 100%");
    splitter = ",";
    var poses = values.map(function(pos) {
      var _a2 = __read2(pos.split(" "), 2), xPos2 = _a2[0], yPos2 = _a2[1];
      return {
        vertical: 1,
        horizontal: 1,
        pos: [
          convertUnitSize(xPos2, width),
          convertUnitSize(yPos2, height)
        ]
      };
    });
    var minMaxs = getMinMaxs(poses.map(function(pos) {
      return pos.pos;
    }));
    return {
      type: clipPrefix,
      clipText,
      poses,
      splitter,
      left: minMaxs.minX,
      right: minMaxs.maxX,
      top: minMaxs.minY,
      bottom: minMaxs.maxY
    };
  } else if (isCircle || clipPrefix === "ellipse") {
    var xPos = "";
    var yPos = "";
    var radiusX_1 = 0;
    var radiusY_1 = 0;
    var values = splitSpace(value);
    if (isCircle) {
      var radius2 = "";
      _a = __read2(values, 4), _b = _a[0], radius2 = _b === void 0 ? "50%" : _b, _c = _a[2], xPos = _c === void 0 ? "50%" : _c, _d = _a[3], yPos = _d === void 0 ? "50%" : _d;
      radiusX_1 = convertUnitSize(radius2, Math.sqrt((width * width + height * height) / 2));
      radiusY_1 = radiusX_1;
    } else {
      var xRadius = "";
      var yRadius = "";
      _e = __read2(values, 5), _f = _e[0], xRadius = _f === void 0 ? "50%" : _f, _g = _e[1], yRadius = _g === void 0 ? "50%" : _g, _h = _e[3], xPos = _h === void 0 ? "50%" : _h, _j = _e[4], yPos = _j === void 0 ? "50%" : _j;
      radiusX_1 = convertUnitSize(xRadius, width);
      radiusY_1 = convertUnitSize(yRadius, height);
    }
    var centerPos_1 = [
      convertUnitSize(xPos, width),
      convertUnitSize(yPos, height)
    ];
    var poses = __spreadArray2([
      {
        vertical: 1,
        horizontal: 1,
        pos: centerPos_1,
        direction: "nesw"
      }
    ], __read2(CLIP_DIRECTIONS.slice(0, isCircle ? 1 : 2).map(function(dir) {
      return {
        vertical: abs2(dir[1]),
        horizontal: dir[0],
        direction: dir[2],
        sub: true,
        pos: [
          centerPos_1[0] + dir[0] * radiusX_1,
          centerPos_1[1] + dir[1] * radiusY_1
        ]
      };
    })), false);
    return {
      type: clipPrefix,
      clipText,
      radiusX: radiusX_1,
      radiusY: radiusY_1,
      left: centerPos_1[0] - radiusX_1,
      top: centerPos_1[1] - radiusY_1,
      right: centerPos_1[0] + radiusX_1,
      bottom: centerPos_1[1] + radiusY_1,
      poses,
      splitter
    };
  } else if (clipPrefix === "inset") {
    var values = splitSpace(value || "0 0 0 0");
    var roundIndex = values.indexOf("round");
    var rectLength = (roundIndex > -1 ? values.slice(0, roundIndex) : values).length;
    var radiusValues = values.slice(rectLength + 1);
    var _o = __read2(values.slice(0, rectLength), 4), topValue = _o[0], _p = _o[1], rightValue = _p === void 0 ? topValue : _p, _q = _o[2], bottomValue = _q === void 0 ? topValue : _q, _r = _o[3], leftValue = _r === void 0 ? rightValue : _r;
    var _s = __read2([topValue, bottomValue].map(function(pos) {
      return convertUnitSize(pos, height);
    }), 2), top_2 = _s[0], bottom = _s[1];
    var _t = __read2([leftValue, rightValue].map(function(pos) {
      return convertUnitSize(pos, width);
    }), 2), left2 = _t[0], right2 = _t[1];
    var nextRight = width - right2;
    var nextBottom = height - bottom;
    var radiusPoses = getRadiusValues(radiusValues, nextRight - left2, nextBottom - top_2, left2, top_2);
    var poses = __spreadArray2(__spreadArray2([], __read2(getRectPoses(top_2, nextRight, nextBottom, left2)), false), __read2(radiusPoses), false);
    return {
      type: "inset",
      clipText,
      poses,
      top: top_2,
      left: left2,
      right: nextRight,
      bottom: nextBottom,
      radius: radiusValues,
      splitter
    };
  } else if (clipPrefix === "rect") {
    var values = splitComma(value || "0px, ".concat(width, "px, ").concat(height, "px, 0px"));
    splitter = ",";
    var _u = __read2(values.map(function(pos) {
      var posValue = splitUnit(pos).value;
      return posValue;
    }), 4), top_3 = _u[0], right2 = _u[1], bottom = _u[2], left2 = _u[3];
    var poses = getRectPoses(top_3, right2, bottom, left2);
    return {
      type: "rect",
      clipText,
      poses,
      top: top_3,
      right: right2,
      bottom,
      left: left2,
      values,
      splitter
    };
  }
  return;
}
function moveControlPos(controlPoses, index3, dist, isRect, keepRatio) {
  var _a = controlPoses[index3], direction = _a.direction, sub = _a.sub;
  var dists = controlPoses.map(function() {
    return [0, 0];
  });
  var directions2 = direction ? direction.split("") : [];
  if (isRect && index3 < 8) {
    var verticalDirections = directions2.filter(function(dir) {
      return dir === "w" || dir === "e";
    });
    var horizontalDirections = directions2.filter(function(dir) {
      return dir === "n" || dir === "s";
    });
    var verticalDirection_1 = verticalDirections[0];
    var horizontalDirection_1 = horizontalDirections[0];
    dists[index3] = dist;
    var _b = __read2(getControlSize(controlPoses), 2), width = _b[0], height = _b[1];
    var ratio = width && height ? width / height : 0;
    if (ratio && keepRatio) {
      var fixedIndex = (index3 + 4) % 8;
      var fixedPosition = controlPoses[fixedIndex].pos;
      var sizeDirection = [0, 0];
      if (direction.indexOf("w") > -1) {
        sizeDirection[0] = -1;
      } else if (direction.indexOf("e") > -1) {
        sizeDirection[0] = 1;
      }
      if (direction.indexOf("n") > -1) {
        sizeDirection[1] = -1;
      } else if (direction.indexOf("s") > -1) {
        sizeDirection[1] = 1;
      }
      var nextDist = getSizeDistByDist([width, height], dist, ratio, sizeDirection, true);
      var nextWidth = width + nextDist[0];
      var nextHeight = height + nextDist[1];
      var top_1 = fixedPosition[1];
      var bottom = fixedPosition[1];
      var left2 = fixedPosition[0];
      var right2 = fixedPosition[0];
      if (sizeDirection[0] === -1) {
        left2 = right2 - nextWidth;
      } else if (sizeDirection[0] === 1) {
        right2 = left2 + nextWidth;
      } else {
        left2 = left2 - nextWidth / 2;
        right2 = right2 + nextWidth / 2;
      }
      if (sizeDirection[1] === -1) {
        top_1 = bottom - nextHeight;
      } else if (sizeDirection[1] === 1) {
        bottom = top_1 + nextHeight;
      } else {
        top_1 = bottom - nextHeight / 2;
        bottom = top_1 + nextHeight;
      }
      var nextControlPoses_1 = getRectPoses(top_1, right2, bottom, left2);
      controlPoses.forEach(function(controlPose, i) {
        dists[i][0] = nextControlPoses_1[i].pos[0] - controlPose.pos[0];
        dists[i][1] = nextControlPoses_1[i].pos[1] - controlPose.pos[1];
      });
    } else {
      controlPoses.forEach(function(controlPose, i) {
        var controlDir = controlPose.direction;
        if (!controlDir) {
          return;
        }
        if (controlDir.indexOf(verticalDirection_1) > -1) {
          dists[i][0] = dist[0];
        }
        if (controlDir.indexOf(horizontalDirection_1) > -1) {
          dists[i][1] = dist[1];
        }
      });
      if (verticalDirection_1) {
        dists[1][0] = dist[0] / 2;
        dists[5][0] = dist[0] / 2;
      }
      if (horizontalDirection_1) {
        dists[3][1] = dist[1] / 2;
        dists[7][1] = dist[1] / 2;
      }
    }
  } else if (direction && !sub) {
    directions2.forEach(function(dir) {
      var isVertical = dir === "n" || dir === "s";
      controlPoses.forEach(function(controlPose, i) {
        var dirDir = controlPose.direction, dirHorizontal = controlPose.horizontal, dirVertical = controlPose.vertical;
        if (!dirDir || dirDir.indexOf(dir) === -1) {
          return;
        }
        dists[i] = [
          isVertical || !dirHorizontal ? 0 : dist[0],
          !isVertical || !dirVertical ? 0 : dist[1]
        ];
      });
    });
  } else {
    dists[index3] = dist;
  }
  return dists;
}
function addClipPath(moveable, e3) {
  var _a = __read2(calculatePointerDist(moveable, e3), 2), distX = _a[0], distY = _a[1];
  var _b = e3.datas, clipPath = _b.clipPath, clipIndex = _b.clipIndex;
  var _c = clipPath, clipType = _c.type, clipPoses = _c.poses, splitter = _c.splitter;
  var poses = clipPoses.map(function(pos) {
    return pos.pos;
  });
  if (clipType === "polygon") {
    poses.splice(clipIndex, 0, [distX, distY]);
  } else if (clipType === "inset") {
    var horizontalIndex = HORIZONTAL_RADIUS_ORDER.indexOf(clipIndex);
    var verticalIndex = VERTICAL_RADIUS_ORDER.indexOf(clipIndex);
    var length_1 = clipPoses.length;
    addRadiusPos(clipPoses, poses, 8, horizontalIndex, verticalIndex, distX, distY, poses[4][0], poses[4][1], poses[0][0], poses[0][1]);
    if (length_1 === clipPoses.length) {
      return;
    }
  } else {
    return;
  }
  var clipStyles = getClipStyles(moveable, clipPath, poses);
  var clipStyle = "".concat(clipType, "(").concat(clipStyles.join(splitter), ")");
  triggerEvent(moveable, "onClip", fillParams(moveable, e3, __assign9({ clipEventType: "added", clipType, poses, clipStyles, clipStyle, distX: 0, distY: 0 }, fillCSSObject({
    clipPath: clipStyle
  }, e3))));
}
function removeClipPath(moveable, e3) {
  var _a = e3.datas, clipPath = _a.clipPath, clipIndex = _a.clipIndex;
  var _b = clipPath, clipType = _b.type, clipPoses = _b.poses, splitter = _b.splitter;
  var poses = clipPoses.map(function(pos) {
    return pos.pos;
  });
  var length2 = poses.length;
  if (clipType === "polygon") {
    clipPoses.splice(clipIndex, 1);
    poses.splice(clipIndex, 1);
  } else if (clipType === "inset") {
    if (clipIndex < 8) {
      return;
    }
    removeRadiusPos(clipPoses, poses, clipIndex, 8, length2);
    if (length2 === clipPoses.length) {
      return;
    }
  } else {
    return;
  }
  var clipStyles = getClipStyles(moveable, clipPath, poses);
  var clipStyle = "".concat(clipType, "(").concat(clipStyles.join(splitter), ")");
  triggerEvent(moveable, "onClip", fillParams(moveable, e3, __assign9({ clipEventType: "removed", clipType, poses, clipStyles, clipStyle, distX: 0, distY: 0 }, fillCSSObject({
    clipPath: clipStyle
  }, e3))));
}
var Clippable = {
  name: "clippable",
  props: [
    "clippable",
    "defaultClipPath",
    "customClipPath",
    "keepRatio",
    "clipRelative",
    "clipArea",
    "dragWithClip",
    "clipTargetBounds",
    "clipVerticalGuidelines",
    "clipHorizontalGuidelines",
    "clipSnapThreshold"
  ],
  events: [
    "clipStart",
    "clip",
    "clipEnd"
  ],
  css: [
    ".control.clip-control {\nbackground: #6d6;\ncursor: pointer;\n}\n.control.clip-control.clip-radius {\nbackground: #d66;\n}\n.line.clip-line {\nbackground: #6e6;\ncursor: move;\nz-index: 1;\n}\n.clip-area {\nposition: absolute;\ntop: 0;\nleft: 0;\n}\n.clip-ellipse {\nposition: absolute;\ncursor: move;\nborder: 1px solid #6d6;\nborder: var(--zoompx) solid #6d6;\nborder-radius: 50%;\ntransform-origin: 0px 0px;\n}",
    ":host {\n--bounds-color: #d66;\n}",
    ".guideline {\npointer-events: none;\nz-index: 2;\n}",
    ".line.guideline.bounds {\nbackground: #d66;\nbackground: var(--bounds-color);\n}"
  ],
  render: function(moveable, React615) {
    var _a = moveable.props, customClipPath = _a.customClipPath, defaultClipPath = _a.defaultClipPath, clipArea = _a.clipArea, zoom = _a.zoom, groupable = _a.groupable;
    var _b = moveable.getState(), target = _b.target, width = _b.width, height = _b.height, allMatrix = _b.allMatrix, is3d = _b.is3d, left2 = _b.left, top = _b.top, pos1 = _b.pos1, pos2 = _b.pos2, pos3 = _b.pos3, pos4 = _b.pos4, clipPathState = _b.clipPathState, snapBoundInfos = _b.snapBoundInfos, rotationRad = _b.rotation;
    if (!target || groupable) {
      return [];
    }
    var clipPath = getClipPath(target, width, height, defaultClipPath || "inset", clipPathState || customClipPath);
    if (!clipPath) {
      return [];
    }
    var n2 = is3d ? 4 : 3;
    var type5 = clipPath.type;
    var clipPoses = clipPath.poses;
    var poses = clipPoses.map(function(pos) {
      var calculatedPos = calculatePosition(allMatrix, pos.pos, n2);
      return [
        calculatedPos[0] - left2,
        calculatedPos[1] - top
      ];
    });
    var controls = [];
    var lines = [];
    var isRect = type5 === "rect";
    var isInset = type5 === "inset";
    var isPolygon = type5 === "polygon";
    if (isRect || isInset || isPolygon) {
      var linePoses_1 = isInset ? poses.slice(0, 8) : poses;
      lines = linePoses_1.map(function(to, i2) {
        var from2 = i2 === 0 ? linePoses_1[linePoses_1.length - 1] : linePoses_1[i2 - 1];
        var rad2 = getRad(from2, to);
        var dist = getDiagonalSize(from2, to);
        return React615.createElement("div", { key: "clipLine".concat(i2), className: prefix("line", "clip-line", "snap-control"), "data-clip-index": i2, style: {
          width: "".concat(dist, "px"),
          transform: "translate(".concat(from2[0], "px, ").concat(from2[1], "px) rotate(").concat(rad2, "rad) scaleY(").concat(zoom, ")")
        } });
      });
    }
    controls = poses.map(function(pos, i2) {
      return React615.createElement("div", { key: "clipControl".concat(i2), className: prefix("control", "clip-control", "snap-control"), "data-clip-index": i2, style: {
        transform: "translate(".concat(pos[0], "px, ").concat(pos[1], "px) rotate(").concat(rotationRad, "rad) scale(").concat(zoom, ")")
      } });
    });
    if (isInset) {
      controls.push.apply(controls, __spreadArray2([], __read2(poses.slice(8).map(function(pos, i2) {
        return React615.createElement("div", { key: "clipRadiusControl".concat(i2), className: prefix("control", "clip-control", "clip-radius", "snap-control"), "data-clip-index": 8 + i2, style: {
          transform: "translate(".concat(pos[0], "px, ").concat(pos[1], "px) rotate(").concat(rotationRad, "rad) scale(").concat(zoom, ")")
        } });
      })), false));
    }
    if (type5 === "circle" || type5 === "ellipse") {
      var clipLeft = clipPath.left, clipTop = clipPath.top, radiusX = clipPath.radiusX, radiusY = clipPath.radiusY;
      var _c = __read2(minus(calculatePosition(allMatrix, [clipLeft, clipTop], n2), calculatePosition(allMatrix, [0, 0], n2)), 2), distLeft = _c[0], distTop = _c[1];
      var ellipseClipPath = "none";
      if (!clipArea) {
        var piece = Math.max(10, radiusX / 5, radiusY / 5);
        var areaPoses = [];
        for (var i = 0; i <= piece; ++i) {
          var rad = Math.PI * 2 / piece * i;
          areaPoses.push([
            radiusX + (radiusX - zoom) * Math.cos(rad),
            radiusY + (radiusY - zoom) * Math.sin(rad)
          ]);
        }
        areaPoses.push([radiusX, -2]);
        areaPoses.push([-2, -2]);
        areaPoses.push([-2, radiusY * 2 + 2]);
        areaPoses.push([radiusX * 2 + 2, radiusY * 2 + 2]);
        areaPoses.push([radiusX * 2 + 2, -2]);
        areaPoses.push([radiusX, -2]);
        ellipseClipPath = "polygon(".concat(areaPoses.map(function(pos) {
          return "".concat(pos[0], "px ").concat(pos[1], "px");
        }).join(", "), ")");
      }
      controls.push(React615.createElement("div", { key: "clipEllipse", className: prefix("clip-ellipse", "snap-control"), style: {
        width: "".concat(radiusX * 2, "px"),
        height: "".concat(radiusY * 2, "px"),
        clipPath: ellipseClipPath,
        transform: "translate(".concat(-left2 + distLeft, "px, ").concat(-top + distTop, "px) ").concat(makeMatrixCSS(allMatrix))
      } }));
    }
    if (clipArea) {
      var _d = getRect2(__spreadArray2([pos1, pos2, pos3, pos4], __read2(poses), false)), allWidth = _d.width, allHeight = _d.height, allLeft_1 = _d.left, allTop_1 = _d.top;
      if (isPolygon || isRect || isInset) {
        var areaPoses = isInset ? poses.slice(0, 8) : poses;
        controls.push(React615.createElement("div", { key: "clipArea", className: prefix("clip-area", "snap-control"), style: {
          width: "".concat(allWidth, "px"),
          height: "".concat(allHeight, "px"),
          transform: "translate(".concat(allLeft_1, "px, ").concat(allTop_1, "px)"),
          clipPath: "polygon(".concat(areaPoses.map(function(pos) {
            return "".concat(pos[0] - allLeft_1, "px ").concat(pos[1] - allTop_1, "px");
          }).join(", "), ")")
        } }));
      }
    }
    if (snapBoundInfos) {
      ["vertical", "horizontal"].forEach(function(directionType) {
        var info = snapBoundInfos[directionType];
        var isHorizontal = directionType === "horizontal";
        if (info.isSnap) {
          lines.push.apply(lines, __spreadArray2([], __read2(info.snap.posInfos.map(function(_a2, i2) {
            var pos = _a2.pos;
            var snapPos1 = minus(calculatePosition(allMatrix, isHorizontal ? [0, pos] : [pos, 0], n2), [left2, top]);
            var snapPos2 = minus(calculatePosition(allMatrix, isHorizontal ? [width, pos] : [pos, height], n2), [left2, top]);
            return renderLine(React615, "", snapPos1, snapPos2, zoom, "clip".concat(directionType, "snap").concat(i2), "guideline");
          })), false));
        }
        if (info.isBound) {
          lines.push.apply(lines, __spreadArray2([], __read2(info.bounds.map(function(_a2, i2) {
            var pos = _a2.pos;
            var snapPos1 = minus(calculatePosition(allMatrix, isHorizontal ? [0, pos] : [pos, 0], n2), [left2, top]);
            var snapPos2 = minus(calculatePosition(allMatrix, isHorizontal ? [width, pos] : [pos, height], n2), [left2, top]);
            return renderLine(React615, "", snapPos1, snapPos2, zoom, "clip".concat(directionType, "bounds").concat(i2), "guideline", "bounds", "bold");
          })), false));
        }
      });
    }
    return __spreadArray2(__spreadArray2([], __read2(controls), false), __read2(lines), false);
  },
  dragControlCondition: function(moveable, e3) {
    return e3.inputEvent && (e3.inputEvent.target.getAttribute("class") || "").indexOf("clip") > -1;
  },
  dragStart: function(moveable, e3) {
    var props = moveable.props;
    var _a = props.dragWithClip, dragWithClip = _a === void 0 ? true : _a;
    if (dragWithClip) {
      return false;
    }
    return this.dragControlStart(moveable, e3);
  },
  drag: function(moveable, e3) {
    return this.dragControl(moveable, __assign9(__assign9({}, e3), { isDragTarget: true }));
  },
  dragEnd: function(moveable, e3) {
    return this.dragControlEnd(moveable, e3);
  },
  dragControlStart: function(moveable, e3) {
    var state = moveable.state;
    var _a = moveable.props, defaultClipPath = _a.defaultClipPath, customClipPath = _a.customClipPath;
    var target = state.target, width = state.width, height = state.height;
    var inputTarget = e3.inputEvent ? e3.inputEvent.target : null;
    var className2 = inputTarget && inputTarget.getAttribute("class") || "";
    var datas = e3.datas;
    var clipPath = getClipPath(target, width, height, defaultClipPath || "inset", customClipPath);
    if (!clipPath) {
      return false;
    }
    var clipText = clipPath.clipText, type5 = clipPath.type, poses = clipPath.poses;
    var result = triggerEvent(moveable, "onClipStart", fillParams(moveable, e3, {
      clipType: type5,
      clipStyle: clipText,
      poses: poses.map(function(pos) {
        return pos.pos;
      })
    }));
    if (result === false) {
      datas.isClipStart = false;
      return false;
    }
    datas.isControl = className2 && className2.indexOf("clip-control") > -1;
    datas.isLine = className2.indexOf("clip-line") > -1;
    datas.isArea = className2.indexOf("clip-area") > -1 || className2.indexOf("clip-ellipse") > -1;
    datas.clipIndex = inputTarget ? parseInt(inputTarget.getAttribute("data-clip-index"), 10) : -1;
    datas.clipPath = clipPath;
    datas.isClipStart = true;
    state.clipPathState = clipText;
    setDragStart(moveable, e3);
    return true;
  },
  dragControl: function(moveable, e3) {
    var _a, _b, _c;
    var datas = e3.datas, originalDatas = e3.originalDatas, isDragTarget = e3.isDragTarget;
    if (!datas.isClipStart) {
      return false;
    }
    var _d = datas, isControl = _d.isControl, isLine = _d.isLine, isArea = _d.isArea, clipIndex = _d.clipIndex, clipPath = _d.clipPath;
    if (!clipPath) {
      return false;
    }
    var props = getProps3(moveable.props, "clippable");
    var keepRatio = props.keepRatio;
    var distX = 0;
    var distY = 0;
    var originalDraggable = originalDatas.draggable;
    var originalDist = getDragDist(e3);
    if (isDragTarget && originalDraggable) {
      _a = __read2(originalDraggable.prevBeforeDist, 2), distX = _a[0], distY = _a[1];
    } else {
      _b = __read2(originalDist, 2), distX = _b[0], distY = _b[1];
    }
    var firstDist = [distX, distY];
    var state = moveable.state;
    var width = state.width, height = state.height;
    var isDragWithTarget = !isArea && !isControl && !isLine;
    var clipType = clipPath.type, clipPoses = clipPath.poses, splitter = clipPath.splitter;
    var poses = clipPoses.map(function(pos) {
      return pos.pos;
    });
    if (isDragWithTarget) {
      distX = -distX;
      distY = -distY;
    }
    var isAll = !isControl || clipPoses[clipIndex].direction === "nesw";
    var isRect = clipType === "inset" || clipType === "rect";
    var dists = clipPoses.map(function() {
      return [0, 0];
    });
    if (isControl && !isAll) {
      var _e = clipPoses[clipIndex], horizontal = _e.horizontal, vertical = _e.vertical;
      var dist = [
        distX * abs2(horizontal),
        distY * abs2(vertical)
      ];
      dists = moveControlPos(clipPoses, clipIndex, dist, isRect, keepRatio);
    } else if (isAll) {
      dists = poses.map(function() {
        return [distX, distY];
      });
    }
    var nextPoses = poses.map(function(pos, i) {
      return plus(pos, dists[i]);
    });
    var guidePoses = __spreadArray2([], __read2(nextPoses), false);
    state.snapBoundInfos = null;
    var isCircle = clipPath.type === "circle";
    var isEllipse = clipPath.type === "ellipse";
    if (isCircle || isEllipse) {
      var guideRect = getRect2(nextPoses);
      var ry = abs2(guideRect.bottom - guideRect.top);
      var rx = abs2(isEllipse ? guideRect.right - guideRect.left : ry);
      var bottom = nextPoses[0][1] + ry;
      var left2 = nextPoses[0][0] - rx;
      var right2 = nextPoses[0][0] + rx;
      if (isCircle) {
        guidePoses.push([right2, guideRect.bottom]);
        dists.push([1, 0]);
      }
      guidePoses.push([guideRect.left, bottom]);
      dists.push([0, 1]);
      guidePoses.push([left2, guideRect.bottom]);
      dists.push([1, 0]);
    }
    var guidelines = getDefaultGuidelines((props.clipHorizontalGuidelines || []).map(function(v) {
      return convertUnitSize("".concat(v), height);
    }), (props.clipVerticalGuidelines || []).map(function(v) {
      return convertUnitSize("".concat(v), width);
    }), width, height);
    var guideXPoses = [];
    var guideYPoses = [];
    if (isCircle || isEllipse) {
      guideXPoses = [guidePoses[4][0], guidePoses[2][0]];
      guideYPoses = [guidePoses[1][1], guidePoses[3][1]];
    } else if (isRect) {
      var rectPoses = [guidePoses[0], guidePoses[2], guidePoses[4], guidePoses[6]];
      var rectDists_1 = [dists[0], dists[2], dists[4], dists[6]];
      guideXPoses = rectPoses.filter(function(_, i) {
        return rectDists_1[i][0];
      }).map(function(pos) {
        return pos[0];
      });
      guideYPoses = rectPoses.filter(function(_, i) {
        return rectDists_1[i][1];
      }).map(function(pos) {
        return pos[1];
      });
    } else {
      guideXPoses = guidePoses.filter(function(_, i) {
        return dists[i][0];
      }).map(function(pos) {
        return pos[0];
      });
      guideYPoses = guidePoses.filter(function(_, i) {
        return dists[i][1];
      }).map(function(pos) {
        return pos[1];
      });
    }
    var boundDelta = [0, 0];
    var _f = checkSnapBounds(guidelines, props.clipTargetBounds && { left: 0, top: 0, right: width, bottom: height }, guideXPoses, guideYPoses, 5, 5), horizontalSnapInfo = _f.horizontal, verticalSnapInfo = _f.vertical;
    var snapOffsetY = horizontalSnapInfo.offset;
    var snapOffsetX = verticalSnapInfo.offset;
    if (horizontalSnapInfo.isBound) {
      boundDelta[1] += snapOffsetY;
    }
    if (verticalSnapInfo.isBound) {
      boundDelta[0] += snapOffsetX;
    }
    if ((isEllipse || isCircle) && dists[0][0] === 0 && dists[0][1] === 0) {
      var guideRect = getRect2(nextPoses);
      var cy = guideRect.bottom - guideRect.top;
      var cx = isEllipse ? guideRect.right - guideRect.left : cy;
      var distSnapX = verticalSnapInfo.isBound ? abs2(snapOffsetX) : verticalSnapInfo.snapIndex === 0 ? -snapOffsetX : snapOffsetX;
      var distSnapY = horizontalSnapInfo.isBound ? abs2(snapOffsetY) : horizontalSnapInfo.snapIndex === 0 ? -snapOffsetY : snapOffsetY;
      cx -= distSnapX;
      cy -= distSnapY;
      if (isCircle) {
        cy = checkSnapBoundPriority(verticalSnapInfo, horizontalSnapInfo) > 0 ? cy : cx;
        cx = cy;
      }
      var center = guidePoses[0];
      guidePoses[1][1] = center[1] - cy;
      guidePoses[2][0] = center[0] + cx;
      guidePoses[3][1] = center[1] + cy;
      guidePoses[4][0] = center[0] - cx;
    } else if (isRect && keepRatio && isControl) {
      var _g = __read2(getControlSize(clipPoses), 2), width_1 = _g[0], height_1 = _g[1];
      var ratio = width_1 && height_1 ? width_1 / height_1 : 0;
      var clipPose = clipPoses[clipIndex];
      var direction = clipPose.direction || "";
      var top_2 = guidePoses[1][1];
      var bottom = guidePoses[5][1];
      var left2 = guidePoses[7][0];
      var right2 = guidePoses[3][0];
      if (abs2(snapOffsetY) <= abs2(snapOffsetX)) {
        snapOffsetY = sign(snapOffsetY) * abs2(snapOffsetX) / ratio;
      } else {
        snapOffsetX = sign(snapOffsetX) * abs2(snapOffsetY) * ratio;
      }
      if (direction.indexOf("w") > -1) {
        left2 -= snapOffsetX;
      } else if (direction.indexOf("e") > -1) {
        right2 -= snapOffsetX;
      } else {
        left2 += snapOffsetX / 2;
        right2 -= snapOffsetX / 2;
      }
      if (direction.indexOf("n") > -1) {
        top_2 -= snapOffsetY;
      } else if (direction.indexOf("s") > -1) {
        bottom -= snapOffsetY;
      } else {
        top_2 += snapOffsetY / 2;
        bottom -= snapOffsetY / 2;
      }
      var nextControlPoses_2 = getRectPoses(top_2, right2, bottom, left2);
      guidePoses.forEach(function(pos, i) {
        var _a2;
        _a2 = __read2(nextControlPoses_2[i].pos, 2), pos[0] = _a2[0], pos[1] = _a2[1];
      });
    } else {
      guidePoses.forEach(function(pos, j) {
        var dist2 = dists[j];
        if (dist2[0]) {
          pos[0] -= snapOffsetX;
        }
        if (dist2[1]) {
          pos[1] -= snapOffsetY;
        }
      });
    }
    var nextClipStyles = getClipStyles(moveable, clipPath, nextPoses);
    var clipStyle = "".concat(clipType, "(").concat(nextClipStyles.join(splitter), ")");
    state.clipPathState = clipStyle;
    if (isCircle || isEllipse) {
      guideXPoses = [guidePoses[4][0], guidePoses[2][0]];
      guideYPoses = [guidePoses[1][1], guidePoses[3][1]];
    } else if (isRect) {
      var rectPoses = [guidePoses[0], guidePoses[2], guidePoses[4], guidePoses[6]];
      guideXPoses = rectPoses.map(function(pos) {
        return pos[0];
      });
      guideYPoses = rectPoses.map(function(pos) {
        return pos[1];
      });
    } else {
      guideXPoses = guidePoses.map(function(pos) {
        return pos[0];
      });
      guideYPoses = guidePoses.map(function(pos) {
        return pos[1];
      });
    }
    state.snapBoundInfos = checkSnapBounds(guidelines, props.clipTargetBounds && { left: 0, top: 0, right: width, bottom: height }, guideXPoses, guideYPoses, 1, 1);
    if (originalDraggable) {
      var is3d = state.is3d, allMatrix = state.allMatrix;
      var n2 = is3d ? 4 : 3;
      var dragDist = boundDelta;
      if (isDragTarget) {
        dragDist = [
          firstDist[0] + boundDelta[0] - originalDist[0],
          firstDist[1] + boundDelta[1] - originalDist[1]
        ];
      }
      originalDraggable.deltaOffset = multiply(allMatrix, [dragDist[0], dragDist[1], 0, 0], n2);
    }
    triggerEvent(moveable, "onClip", fillParams(moveable, e3, __assign9({ clipEventType: "changed", clipType, poses: nextPoses, clipStyle, clipStyles: nextClipStyles, distX, distY }, fillCSSObject((_c = {}, _c[clipType === "rect" ? "clip" : "clipPath"] = clipStyle, _c), e3))));
    return true;
  },
  dragControlEnd: function(moveable, e3) {
    this.unset(moveable);
    var isDrag = e3.isDrag, datas = e3.datas, isDouble = e3.isDouble;
    var isLine = datas.isLine, isClipStart = datas.isClipStart, isControl = datas.isControl;
    if (!isClipStart) {
      return false;
    }
    triggerEvent(moveable, "onClipEnd", fillEndParams(moveable, e3, {}));
    if (isDouble) {
      if (isControl) {
        removeClipPath(moveable, e3);
      } else if (isLine) {
        addClipPath(moveable, e3);
      }
    }
    return isDouble || isDrag;
  },
  unset: function(moveable) {
    moveable.state.clipPathState = "";
    moveable.state.snapBoundInfos = null;
  }
};
var OriginDraggable = {
  name: "originDraggable",
  props: [
    "originDraggable",
    "originRelative"
  ],
  events: [
    "dragOriginStart",
    "dragOrigin",
    "dragOriginEnd"
  ],
  css: [
    ":host[data-able-origindraggable] .control.origin {\npointer-events: auto;\n}"
  ],
  dragControlCondition: function(_, e3) {
    if (e3.isRequest) {
      return e3.requestAble === "originDraggable";
    }
    return hasClass(e3.inputEvent.target, prefix("origin"));
  },
  dragControlStart: function(moveable, e3) {
    var datas = e3.datas;
    setDragStart(moveable, e3);
    var params = fillParams(moveable, e3, {
      dragStart: Draggable2.dragStart(moveable, new CustomGesto().dragStart([0, 0], e3))
    });
    var result = triggerEvent(moveable, "onDragOriginStart", params);
    datas.startOrigin = moveable.state.transformOrigin;
    datas.startTargetOrigin = moveable.state.targetOrigin;
    datas.prevOrigin = [0, 0];
    datas.isDragOrigin = true;
    if (result === false) {
      datas.isDragOrigin = false;
      return false;
    }
    return params;
  },
  dragControl: function(moveable, e3) {
    var datas = e3.datas, isPinch = e3.isPinch, isRequest = e3.isRequest;
    if (!datas.isDragOrigin) {
      return false;
    }
    var _a = __read2(getDragDist(e3), 2), distX = _a[0], distY = _a[1];
    var state = moveable.state;
    var width = state.width, height = state.height, offsetMatrix = state.offsetMatrix, targetMatrix = state.targetMatrix, is3d = state.is3d;
    var _b = moveable.props.originRelative, originRelative = _b === void 0 ? true : _b;
    var n2 = is3d ? 4 : 3;
    var dist = [distX, distY];
    if (isRequest) {
      var distOrigin = e3.distOrigin;
      if (distOrigin[0] || distOrigin[1]) {
        dist = distOrigin;
      }
    }
    var origin = plus(datas.startOrigin, dist);
    var targetOrigin = plus(datas.startTargetOrigin, dist);
    var delta = minus(dist, datas.prevOrigin);
    var nextMatrix = getNextMatrix(offsetMatrix, targetMatrix, origin, n2);
    var rect = moveable.getRect();
    var nextRect = getRect2(calculatePoses(nextMatrix, width, height, n2));
    var dragDelta = [
      rect.left - nextRect.left,
      rect.top - nextRect.top
    ];
    datas.prevOrigin = dist;
    var transformOrigin = [
      convertCSSSize(targetOrigin[0], width, originRelative),
      convertCSSSize(targetOrigin[1], height, originRelative)
    ].join(" ");
    var result = Draggable2.drag(moveable, setCustomDrag(e3, moveable.state, dragDelta, !!isPinch, false));
    var params = fillParams(moveable, e3, __assign9(__assign9({ width, height, origin, dist, delta, transformOrigin, drag: result }, fillCSSObject({
      transformOrigin,
      transform: result.transform
    }, e3)), { afterTransform: result.transform }));
    triggerEvent(moveable, "onDragOrigin", params);
    return params;
  },
  dragControlEnd: function(moveable, e3) {
    var datas = e3.datas;
    if (!datas.isDragOrigin) {
      return false;
    }
    triggerEvent(moveable, "onDragOriginEnd", fillEndParams(moveable, e3, {}));
    return true;
  },
  dragGroupControlCondition: function(moveable, e3) {
    return this.dragControlCondition(moveable, e3);
  },
  dragGroupControlStart: function(moveable, e3) {
    var params = this.dragControlStart(moveable, e3);
    if (!params) {
      return false;
    }
    return true;
  },
  dragGroupControl: function(moveable, e3) {
    var params = this.dragControl(moveable, e3);
    if (!params) {
      return false;
    }
    moveable.transformOrigin = params.transformOrigin;
    return true;
  },
  /**
      * @method Moveable.OriginDraggable#request
      * @param {object} e - the OriginDraggable's request parameter
      * @param {number} [e.x] - x position
      * @param {number} [e.y] - y position
      * @param {number} [e.deltaX] - x number to move
      * @param {number} [e.deltaY] - y number to move
      * @param {array} [e.deltaOrigin] - left, top number to move transform-origin
      * @param {array} [e.origin] - transform-origin position
      * @param {number} [e.isInstant] - Whether to execute the request instantly
      * @return {Moveable.Requester} Moveable Requester
      * @example
  
      * // Instantly Request (requestStart - request - requestEnd)
      * // Use Relative Value
      * moveable.request("originDraggable", { deltaX: 10, deltaY: 10 }, true);
      * // Use Absolute Value
      * moveable.request("originDraggable", { x: 200, y: 100 }, true);
      * // Use Transform Value
      * moveable.request("originDraggable", { deltaOrigin: [10, 0] }, true);
      * moveable.request("originDraggable", { origin: [100, 0] }, true);
      * // requestStart
      * const requester = moveable.request("originDraggable");
      *
      * // request
      * // Use Relative Value
      * requester.request({ deltaX: 10, deltaY: 10 });
      * requester.request({ deltaX: 10, deltaY: 10 });
      * requester.request({ deltaX: 10, deltaY: 10 });
      * // Use Absolute Value
      * moveable.request("originDraggable", { x: 200, y: 100 });
      * moveable.request("originDraggable", { x: 220, y: 100 });
      * moveable.request("originDraggable", { x: 240, y: 100 });
      *
      * // requestEnd
      * requester.requestEnd();
      */
  request: function(moveable) {
    var datas = {};
    var rect = moveable.getRect();
    var distX = 0;
    var distY = 0;
    var transformOrigin = rect.transformOrigin;
    var distOrigin = [0, 0];
    return {
      isControl: true,
      requestStart: function() {
        return { datas };
      },
      request: function(e3) {
        if ("deltaOrigin" in e3) {
          distOrigin[0] += e3.deltaOrigin[0];
          distOrigin[1] += e3.deltaOrigin[1];
        } else if ("origin" in e3) {
          distOrigin[0] = e3.origin[0] - transformOrigin[0];
          distOrigin[1] = e3.origin[1] - transformOrigin[1];
        } else {
          if ("x" in e3) {
            distX = e3.x - rect.left;
          } else if ("deltaX" in e3) {
            distX += e3.deltaX;
          }
          if ("y" in e3) {
            distY = e3.y - rect.top;
          } else if ("deltaY" in e3) {
            distY += e3.deltaY;
          }
        }
        return { datas, distX, distY, distOrigin };
      },
      requestEnd: function() {
        return { datas, isDrag: true };
      }
    };
  }
};
function addBorderRadiusByLine(controlPoses, lineIndex, distX, distY) {
  var horizontalsLength = controlPoses.filter(function(_a) {
    var virtual = _a.virtual, horizontal = _a.horizontal;
    return horizontal && !virtual;
  }).length;
  var verticalsLength = controlPoses.filter(function(_a) {
    var virtual = _a.virtual, vertical = _a.vertical;
    return vertical && !virtual;
  }).length;
  var controlIndex = -1;
  if (lineIndex === 0) {
    if (horizontalsLength === 0) {
      controlIndex = 0;
    } else if (horizontalsLength === 1) {
      controlIndex = 1;
    }
  }
  if (lineIndex === 2) {
    if (horizontalsLength <= 2) {
      controlIndex = 2;
    } else if (horizontalsLength <= 3) {
      controlIndex = 3;
    }
  }
  if (lineIndex === 3) {
    if (verticalsLength === 0) {
      controlIndex = 4;
    } else if (verticalsLength < 4) {
      controlIndex = 7;
    }
  }
  if (lineIndex === 1) {
    if (verticalsLength <= 1) {
      controlIndex = 5;
    } else if (verticalsLength <= 2) {
      controlIndex = 6;
    }
  }
  if (controlIndex === -1 || !controlPoses[controlIndex].virtual) {
    return;
  }
  var controlPoseInfo = controlPoses[controlIndex];
  addBorderRadius(controlPoses, controlIndex);
  if (controlIndex < 4) {
    controlPoseInfo.pos[0] = distX;
  } else {
    controlPoseInfo.pos[1] = distY;
  }
}
function addBorderRadius(controlPoses, index3) {
  if (index3 < 4) {
    controlPoses.slice(0, index3 + 1).forEach(function(info) {
      info.virtual = false;
    });
  } else {
    if (controlPoses[0].virtual) {
      controlPoses[0].virtual = false;
    }
    controlPoses.slice(4, index3 + 1).forEach(function(info) {
      info.virtual = false;
    });
  }
}
function removeBorderRadius(controlPoses, index3) {
  if (index3 < 4) {
    controlPoses.slice(index3, 4).forEach(function(info) {
      info.virtual = true;
    });
  } else {
    controlPoses.slice(index3).forEach(function(info) {
      info.virtual = true;
    });
  }
}
function getBorderRadius(borderRadius, width, height, minCounts, full) {
  if (minCounts === void 0) {
    minCounts = [0, 0];
  }
  var values = [];
  if (!borderRadius || borderRadius === "0px") {
    values = [];
  } else {
    values = splitSpace(borderRadius);
  }
  return getRadiusValues(values, width, height, 0, 0, minCounts, full);
}
function triggerRoundEvent(moveable, e3, dist, delta, nextPoses) {
  var state = moveable.state;
  var width = state.width, height = state.height;
  var _a = getRadiusStyles(nextPoses, moveable.props.roundRelative, width, height), raws = _a.raws, styles = _a.styles, radiusPoses = _a.radiusPoses;
  var _b = splitRadiusPoses(radiusPoses, raws), horizontals = _b.horizontals, verticals = _b.verticals;
  var borderRadius = styles.join(" ");
  state.borderRadiusState = borderRadius;
  var params = fillParams(moveable, e3, __assign9({ horizontals, verticals, borderRadius, width, height, delta, dist }, fillCSSObject({
    borderRadius
  }, e3)));
  triggerEvent(moveable, "onRound", params);
  return params;
}
function getStyleBorderRadius(moveable) {
  var _a, _b;
  var style2 = moveable.getState().style;
  var borderRadius = style2.borderRadius || "";
  if (!borderRadius && moveable.props.groupable) {
    var firstMoveable = moveable.moveables[0];
    var firstTarget = moveable.getTargets()[0];
    if (firstTarget) {
      if ((firstMoveable === null || firstMoveable === void 0 ? void 0 : firstMoveable.props.target) === firstTarget) {
        borderRadius = (_b = (_a = moveable.moveables[0]) === null || _a === void 0 ? void 0 : _a.state.style.borderRadius) !== null && _b !== void 0 ? _b : "";
        style2.borderRadius = borderRadius;
      } else {
        borderRadius = getComputedStyle2(firstTarget).borderRadius;
        style2.borderRadius = borderRadius;
      }
    }
  }
  return borderRadius;
}
var Roundable = {
  name: "roundable",
  props: [
    "roundable",
    "roundRelative",
    "minRoundControls",
    "maxRoundControls",
    "roundClickable",
    "roundPadding",
    "isDisplayShadowRoundControls"
  ],
  events: [
    "roundStart",
    "round",
    "roundEnd",
    "roundGroupStart",
    "roundGroup",
    "roundGroupEnd"
  ],
  css: [
    ".control.border-radius {\nbackground: #d66;\ncursor: pointer;\nz-index: 3;\n}",
    ".control.border-radius.vertical {\nbackground: #d6d;\nz-index: 2;\n}",
    ".control.border-radius.virtual {\nopacity: 0.5;\nz-index: 1;\n}",
    ":host.round-line-clickable .line.direction {\ncursor: pointer;\n}"
  ],
  className: function(moveable) {
    var roundClickable = moveable.props.roundClickable;
    return roundClickable === true || roundClickable === "line" ? prefix("round-line-clickable") : "";
  },
  requestStyle: function() {
    return ["borderRadius"];
  },
  requestChildStyle: function() {
    return ["borderRadius"];
  },
  render: function(moveable, React615) {
    var _a = moveable.getState(), target = _a.target, width = _a.width, height = _a.height, allMatrix = _a.allMatrix, is3d = _a.is3d, left2 = _a.left, top = _a.top, borderRadiusState = _a.borderRadiusState;
    var _b = moveable.props, _c = _b.minRoundControls, minRoundControls = _c === void 0 ? [0, 0] : _c, _d = _b.maxRoundControls, maxRoundControls = _d === void 0 ? [4, 4] : _d, zoom = _b.zoom, _e = _b.roundPadding, roundPadding = _e === void 0 ? 0 : _e, isDisplayShadowRoundControls = _b.isDisplayShadowRoundControls, groupable = _b.groupable;
    if (!target) {
      return null;
    }
    var borderRadius = borderRadiusState || getStyleBorderRadius(moveable);
    var n2 = is3d ? 4 : 3;
    var radiusValues = getBorderRadius(borderRadius, width, height, minRoundControls, true);
    if (!radiusValues) {
      return null;
    }
    var verticalCount = 0;
    var horizontalCount = 0;
    var basePos = groupable ? [0, 0] : [left2, top];
    return radiusValues.map(function(v, i) {
      var horizontal = v.horizontal;
      var vertical = v.vertical;
      var direction = v.direction || "";
      var originalPos = __spreadArray2([], __read2(v.pos), false);
      horizontalCount += Math.abs(horizontal);
      verticalCount += Math.abs(vertical);
      if (horizontal && direction.indexOf("n") > -1) {
        originalPos[1] -= roundPadding;
      }
      if (vertical && direction.indexOf("w") > -1) {
        originalPos[0] -= roundPadding;
      }
      if (horizontal && direction.indexOf("s") > -1) {
        originalPos[1] += roundPadding;
      }
      if (vertical && direction.indexOf("e") > -1) {
        originalPos[0] += roundPadding;
      }
      var pos = minus(calculatePosition(allMatrix, originalPos, n2), basePos);
      var isDisplayVerticalShadow = isDisplayShadowRoundControls && isDisplayShadowRoundControls !== "horizontal";
      var isDisplay = v.vertical ? verticalCount <= maxRoundControls[1] && (isDisplayVerticalShadow || !v.virtual) : horizontalCount <= maxRoundControls[0] && (isDisplayShadowRoundControls || !v.virtual);
      return React615.createElement("div", { key: "borderRadiusControl".concat(i), className: prefix("control", "border-radius", v.vertical ? "vertical" : "", v.virtual ? "virtual" : ""), "data-radius-index": i, style: {
        display: isDisplay ? "block" : "none",
        transform: "translate(".concat(pos[0], "px, ").concat(pos[1], "px) scale(").concat(zoom, ")")
      } });
    });
  },
  dragControlCondition: function(moveable, e3) {
    if (!e3.inputEvent || e3.isRequest) {
      return false;
    }
    var className2 = e3.inputEvent.target.getAttribute("class") || "";
    return className2.indexOf("border-radius") > -1 || className2.indexOf("moveable-line") > -1 && className2.indexOf("moveable-direction") > -1;
  },
  dragGroupControlCondition: function(moveable, e3) {
    return this.dragControlCondition(moveable, e3);
  },
  dragControlStart: function(moveable, e3) {
    var inputEvent = e3.inputEvent, datas = e3.datas;
    var inputTarget = inputEvent.target;
    var className2 = inputTarget.getAttribute("class") || "";
    var isControl = className2.indexOf("border-radius") > -1;
    var isLine = className2.indexOf("moveable-line") > -1 && className2.indexOf("moveable-direction") > -1;
    var controlIndex = isControl ? parseInt(inputTarget.getAttribute("data-radius-index"), 10) : -1;
    var lineIndex = -1;
    if (isLine) {
      var indexAttr = inputTarget.getAttribute("data-line-key") || "";
      if (indexAttr) {
        lineIndex = parseInt(indexAttr.replace(/render-line-/g, ""), 10);
        if (isNaN(lineIndex)) {
          lineIndex = -1;
        }
      }
    }
    if (!isControl && !isLine) {
      return false;
    }
    var params = fillParams(moveable, e3, {});
    var result = triggerEvent(moveable, "onRoundStart", params);
    if (result === false) {
      return false;
    }
    datas.lineIndex = lineIndex;
    datas.controlIndex = controlIndex;
    datas.isControl = isControl;
    datas.isLine = isLine;
    setDragStart(moveable, e3);
    var _a = moveable.props, roundRelative = _a.roundRelative, _b = _a.minRoundControls, minRoundControls = _b === void 0 ? [0, 0] : _b;
    var state = moveable.state;
    var width = state.width, height = state.height;
    datas.isRound = true;
    datas.prevDist = [0, 0];
    var borderRadius = getStyleBorderRadius(moveable);
    var controlPoses = getBorderRadius(borderRadius || "", width, height, minRoundControls, true) || [];
    datas.controlPoses = controlPoses;
    state.borderRadiusState = getRadiusStyles(controlPoses, roundRelative, width, height).styles.join(" ");
    return params;
  },
  dragControl: function(moveable, e3) {
    var datas = e3.datas;
    var controlPoses = datas.controlPoses;
    if (!datas.isRound || !datas.isControl || !controlPoses.length) {
      return false;
    }
    var index3 = datas.controlIndex;
    var _a = __read2(getDragDist(e3), 2), distX = _a[0], distY = _a[1];
    var dist = [distX, distY];
    var delta = minus(dist, datas.prevDist);
    var _b = moveable.props.maxRoundControls, maxRoundControls = _b === void 0 ? [4, 4] : _b;
    var _c = moveable.state, width = _c.width, height = _c.height;
    var selectedControlPose = controlPoses[index3];
    var selectedVertical = selectedControlPose.vertical;
    var selectedHorizontal = selectedControlPose.horizontal;
    var dists = controlPoses.map(function(pose) {
      var horizontal = pose.horizontal, vertical = pose.vertical;
      var poseDist = [
        horizontal * selectedHorizontal * dist[0],
        vertical * selectedVertical * dist[1]
      ];
      if (horizontal) {
        if (maxRoundControls[0] === 1) {
          return poseDist;
        } else if (maxRoundControls[0] < 4 && horizontal !== selectedHorizontal) {
          return poseDist;
        }
      } else if (maxRoundControls[1] === 0) {
        poseDist[1] = vertical * selectedHorizontal * dist[0] / width * height;
        return poseDist;
      } else if (selectedVertical) {
        if (maxRoundControls[1] === 1) {
          return poseDist;
        } else if (maxRoundControls[1] < 4 && vertical !== selectedVertical) {
          return poseDist;
        }
      }
      return [0, 0];
    });
    dists[index3] = dist;
    var nextPoses = controlPoses.map(function(info, i) {
      return __assign9(__assign9({}, info), { pos: plus(info.pos, dists[i]) });
    });
    if (index3 < 4) {
      nextPoses.slice(0, index3 + 1).forEach(function(info) {
        info.virtual = false;
      });
    } else {
      nextPoses.slice(4, index3 + 1).forEach(function(info) {
        info.virtual = false;
      });
    }
    datas.prevDist = [distX, distY];
    return triggerRoundEvent(moveable, e3, dist, delta, nextPoses);
  },
  dragControlEnd: function(moveable, e3) {
    var state = moveable.state;
    state.borderRadiusState = "";
    var datas = e3.datas, isDouble = e3.isDouble;
    if (!datas.isRound) {
      return false;
    }
    var isControl = datas.isControl, controlIndex = datas.controlIndex, isLine = datas.isLine, lineIndex = datas.lineIndex;
    var controlPoses = datas.controlPoses;
    var length2 = controlPoses.filter(function(_a2) {
      var virtual = _a2.virtual;
      return virtual;
    }).length;
    var _a = moveable.props.roundClickable, roundClickable = _a === void 0 ? true : _a;
    if (isDouble && roundClickable) {
      if (isControl && (roundClickable === true || roundClickable === "control")) {
        removeBorderRadius(controlPoses, controlIndex);
      } else if (isLine && (roundClickable === true || roundClickable === "line")) {
        var _b = __read2(calculatePointerDist(moveable, e3), 2), distX = _b[0], distY = _b[1];
        addBorderRadiusByLine(controlPoses, lineIndex, distX, distY);
      }
      if (length2 !== controlPoses.filter(function(_a2) {
        var virtual = _a2.virtual;
        return virtual;
      }).length) {
        triggerRoundEvent(moveable, e3, [0, 0], [0, 0], controlPoses);
      }
    }
    var params = fillEndParams(moveable, e3, {});
    triggerEvent(moveable, "onRoundEnd", params);
    state.borderRadiusState = "";
    return params;
  },
  dragGroupControlStart: function(moveable, e3) {
    var result = this.dragControlStart(moveable, e3);
    if (!result) {
      return false;
    }
    var moveables = moveable.moveables;
    var targets = moveable.props.targets;
    var events2 = fillChildEvents(moveable, "roundable", e3);
    var nextParams = __assign9({ targets: moveable.props.targets, events: events2.map(function(ev, i) {
      return __assign9(__assign9({}, ev), { target: targets[i], moveable: moveables[i], currentTarget: moveables[i] });
    }) }, result);
    triggerEvent(moveable, "onRoundGroupStart", nextParams);
    return result;
  },
  dragGroupControl: function(moveable, e3) {
    var result = this.dragControl(moveable, e3);
    if (!result) {
      return false;
    }
    var moveables = moveable.moveables;
    var targets = moveable.props.targets;
    var events2 = fillChildEvents(moveable, "roundable", e3);
    var nextParams = __assign9({ targets: moveable.props.targets, events: events2.map(function(ev, i) {
      return __assign9(__assign9(__assign9({}, ev), { target: targets[i], moveable: moveables[i], currentTarget: moveables[i] }), fillCSSObject({
        borderRadius: result.borderRadius
      }, ev));
    }) }, result);
    triggerEvent(moveable, "onRoundGroup", nextParams);
    return nextParams;
  },
  dragGroupControlEnd: function(moveable, e3) {
    var moveables = moveable.moveables;
    var targets = moveable.props.targets;
    var events2 = fillChildEvents(moveable, "roundable", e3);
    catchEvent(moveable, "onRound", function(parentEvent) {
      var nextParams2 = __assign9({ targets: moveable.props.targets, events: events2.map(function(ev, i) {
        return __assign9(__assign9(__assign9({}, ev), { target: targets[i], moveable: moveables[i], currentTarget: moveables[i] }), fillCSSObject({
          borderRadius: parentEvent.borderRadius
        }, ev));
      }) }, parentEvent);
      triggerEvent(moveable, "onRoundGroup", nextParams2);
    });
    var result = this.dragControlEnd(moveable, e3);
    if (!result) {
      return false;
    }
    var nextParams = __assign9({ targets: moveable.props.targets, events: events2.map(function(ev, i) {
      var _a;
      return __assign9(__assign9({}, ev), { target: targets[i], moveable: moveables[i], currentTarget: moveables[i], lastEvent: (_a = ev.datas) === null || _a === void 0 ? void 0 : _a.lastEvent });
    }) }, result);
    triggerEvent(moveable, "onRoundGroupEnd", nextParams);
    return nextParams;
  },
  unset: function(moveable) {
    moveable.state.borderRadiusState = "";
  }
};
function isIdentityMatrix(matrix, is3d) {
  var n2 = is3d ? 4 : 3;
  var identityMatrix = createIdentityMatrix(n2);
  var value = "matrix".concat(is3d ? "3d" : "", "(").concat(identityMatrix.join(","), ")");
  return matrix === value || matrix === "matrix(1,0,0,1,0,0)";
}
var BeforeRenderable = {
  isPinch: true,
  name: "beforeRenderable",
  props: [],
  events: [
    "beforeRenderStart",
    "beforeRender",
    "beforeRenderEnd",
    "beforeRenderGroupStart",
    "beforeRenderGroup",
    "beforeRenderGroupEnd"
  ],
  dragRelation: "weak",
  setTransform: function(moveable, e3) {
    var _a = moveable.state, is3d = _a.is3d, targetMatrix = _a.targetMatrix, inlineTransform = _a.inlineTransform;
    var cssMatrix = is3d ? "matrix3d(".concat(targetMatrix.join(","), ")") : "matrix(".concat(convertMatrixtoCSS(targetMatrix, true), ")");
    var startTransform = !inlineTransform || inlineTransform === "none" ? cssMatrix : inlineTransform;
    e3.datas.startTransforms = isIdentityMatrix(startTransform, is3d) ? [] : splitSpace(startTransform);
  },
  resetStyle: function(e3) {
    var datas = e3.datas;
    datas.nextStyle = {};
    datas.nextTransforms = e3.datas.startTransforms;
    datas.nextTransformAppendedIndexes = [];
  },
  fillDragStartParams: function(moveable, e3) {
    return fillParams(moveable, e3, {
      setTransform: function(transform) {
        e3.datas.startTransforms = isArray5(transform) ? transform : splitSpace(transform);
      },
      isPinch: !!e3.isPinch
    });
  },
  fillDragParams: function(moveable, e3) {
    return fillParams(moveable, e3, {
      isPinch: !!e3.isPinch
    });
  },
  dragStart: function(moveable, e3) {
    this.setTransform(moveable, e3);
    this.resetStyle(e3);
    triggerEvent(moveable, "onBeforeRenderStart", this.fillDragStartParams(moveable, e3));
  },
  drag: function(moveable, e3) {
    if (!e3.datas.startTransforms) {
      this.setTransform(moveable, e3);
    }
    this.resetStyle(e3);
    triggerEvent(moveable, "onBeforeRender", fillParams(moveable, e3, {
      isPinch: !!e3.isPinch
    }));
  },
  dragEnd: function(moveable, e3) {
    if (!e3.datas.startTransforms) {
      this.setTransform(moveable, e3);
      this.resetStyle(e3);
    }
    triggerEvent(moveable, "onBeforeRenderEnd", fillParams(moveable, e3, {
      isPinch: !!e3.isPinch,
      isDrag: e3.isDrag
    }));
  },
  dragGroupStart: function(moveable, e3) {
    var _this = this;
    this.dragStart(moveable, e3);
    var events2 = fillChildEvents(moveable, "beforeRenderable", e3);
    var moveables = moveable.moveables;
    var params = events2.map(function(childEvent, i) {
      var childMoveable = moveables[i];
      _this.setTransform(childMoveable, childEvent);
      _this.resetStyle(childEvent);
      return _this.fillDragStartParams(childMoveable, childEvent);
    });
    triggerEvent(moveable, "onBeforeRenderGroupStart", fillParams(moveable, e3, {
      isPinch: !!e3.isPinch,
      targets: moveable.props.targets,
      setTransform: function() {
      },
      events: params
    }));
  },
  dragGroup: function(moveable, e3) {
    var _this = this;
    this.drag(moveable, e3);
    var events2 = fillChildEvents(moveable, "beforeRenderable", e3);
    var moveables = moveable.moveables;
    var params = events2.map(function(childEvent, i) {
      var childMoveable = moveables[i];
      _this.resetStyle(childEvent);
      return _this.fillDragParams(childMoveable, childEvent);
    });
    triggerEvent(moveable, "onBeforeRenderGroup", fillParams(moveable, e3, {
      isPinch: !!e3.isPinch,
      targets: moveable.props.targets,
      events: params
    }));
  },
  dragGroupEnd: function(moveable, e3) {
    this.dragEnd(moveable, e3);
    triggerEvent(moveable, "onBeforeRenderGroupEnd", fillParams(moveable, e3, {
      isPinch: !!e3.isPinch,
      isDrag: e3.isDrag,
      targets: moveable.props.targets
    }));
  },
  dragControlStart: function(moveable, e3) {
    return this.dragStart(moveable, e3);
  },
  dragControl: function(moveable, e3) {
    return this.drag(moveable, e3);
  },
  dragControlEnd: function(moveable, e3) {
    return this.dragEnd(moveable, e3);
  },
  dragGroupControlStart: function(moveable, e3) {
    return this.dragGroupStart(moveable, e3);
  },
  dragGroupControl: function(moveable, e3) {
    return this.dragGroup(moveable, e3);
  },
  dragGroupControlEnd: function(moveable, e3) {
    return this.dragGroupEnd(moveable, e3);
  }
};
var Renderable = {
  name: "renderable",
  props: [],
  events: [
    "renderStart",
    "render",
    "renderEnd",
    "renderGroupStart",
    "renderGroup",
    "renderGroupEnd"
  ],
  dragRelation: "weak",
  dragStart: function(moveable, e3) {
    triggerEvent(moveable, "onRenderStart", fillParams(moveable, e3, {
      isPinch: !!e3.isPinch
    }));
  },
  drag: function(moveable, e3) {
    triggerEvent(moveable, "onRender", this.fillDragParams(moveable, e3));
  },
  dragAfter: function(moveable, e3) {
    return this.drag(moveable, e3);
  },
  dragEnd: function(moveable, e3) {
    triggerEvent(moveable, "onRenderEnd", this.fillDragEndParams(moveable, e3));
  },
  dragGroupStart: function(moveable, e3) {
    triggerEvent(moveable, "onRenderGroupStart", fillParams(moveable, e3, {
      isPinch: !!e3.isPinch,
      targets: moveable.props.targets
    }));
  },
  dragGroup: function(moveable, e3) {
    var _this = this;
    var events2 = fillChildEvents(moveable, "beforeRenderable", e3);
    var moveables = moveable.moveables;
    var params = events2.map(function(childEvent, i) {
      var childMoveable = moveables[i];
      return _this.fillDragParams(childMoveable, childEvent);
    });
    triggerEvent(moveable, "onRenderGroup", fillParams(moveable, e3, __assign9(__assign9({ isPinch: !!e3.isPinch, targets: moveable.props.targets, transform: getNextTransformText(e3), transformObject: {} }, fillCSSObject(getNextStyle(e3))), { events: params })));
  },
  dragGroupEnd: function(moveable, e3) {
    var _this = this;
    var events2 = fillChildEvents(moveable, "beforeRenderable", e3);
    var moveables = moveable.moveables;
    var params = events2.map(function(childEvent, i) {
      var childMoveable = moveables[i];
      return _this.fillDragEndParams(childMoveable, childEvent);
    });
    triggerEvent(moveable, "onRenderGroupEnd", fillParams(moveable, e3, __assign9({ isPinch: !!e3.isPinch, isDrag: e3.isDrag, targets: moveable.props.targets, events: params, transformObject: {}, transform: getNextTransformText(e3) }, fillCSSObject(getNextStyle(e3)))));
  },
  dragControlStart: function(moveable, e3) {
    return this.dragStart(moveable, e3);
  },
  dragControl: function(moveable, e3) {
    return this.drag(moveable, e3);
  },
  dragControlAfter: function(moveable, e3) {
    return this.dragAfter(moveable, e3);
  },
  dragControlEnd: function(moveable, e3) {
    return this.dragEnd(moveable, e3);
  },
  dragGroupControlStart: function(moveable, e3) {
    return this.dragGroupStart(moveable, e3);
  },
  dragGroupControl: function(moveable, e3) {
    return this.dragGroup(moveable, e3);
  },
  dragGroupControlEnd: function(moveable, e3) {
    return this.dragGroupEnd(moveable, e3);
  },
  fillDragParams: function(moveable, e3) {
    var transformObject = {};
    parse5(getNextTransforms(e3) || []).forEach(function(matrixInfo) {
      transformObject[matrixInfo.name] = matrixInfo.functionValue;
    });
    return fillParams(moveable, e3, __assign9({ isPinch: !!e3.isPinch, transformObject, transform: getNextTransformText(e3) }, fillCSSObject(getNextStyle(e3))));
  },
  fillDragEndParams: function(moveable, e3) {
    var transformObject = {};
    parse5(getNextTransforms(e3) || []).forEach(function(matrixInfo) {
      transformObject[matrixInfo.name] = matrixInfo.functionValue;
    });
    return fillParams(moveable, e3, __assign9({ isPinch: !!e3.isPinch, isDrag: e3.isDrag, transformObject, transform: getNextTransformText(e3) }, fillCSSObject(getNextStyle(e3))));
  }
};
function triggerAble(moveable, moveableAbles, eventOperations, eventAffix, eventType, e3, requestInstant) {
  e3.clientDistX = e3.distX;
  e3.clientDistY = e3.distY;
  var isStart = eventType === "Start";
  var isEnd = eventType === "End";
  var isAfter3 = eventType === "After";
  var target = moveable.state.target;
  var isRequest = e3.isRequest;
  var isControl = eventAffix.indexOf("Control") > -1;
  if (!target || isStart && isControl && !isRequest && moveable.areaElement === e3.inputEvent.target) {
    return false;
  }
  var ables = __spreadArray2([], __read2(moveableAbles), false);
  if (isRequest) {
    var requestAble_1 = e3.requestAble;
    if (!ables.some(function(able) {
      return able.name === requestAble_1;
    })) {
      ables.push.apply(ables, __spreadArray2([], __read2(moveable.props.ables.filter(function(able) {
        return able.name === requestAble_1;
      })), false));
    }
  }
  if (!ables.length || ables.every(function(able) {
    return able.dragRelation;
  })) {
    return false;
  }
  var inputEvent = e3.inputEvent;
  var inputTarget;
  if (isEnd && inputEvent) {
    inputTarget = document.elementFromPoint(e3.clientX, e3.clientY) || inputEvent.target;
  }
  var isDragStop = false;
  var stop = function() {
    var _a;
    isDragStop = true;
    (_a = e3.stop) === null || _a === void 0 ? void 0 : _a.call(e3);
  };
  var isFirstStart = isStart && (!moveable.targetGesto || !moveable.controlGesto || (!moveable.targetGesto.isFlag() || !moveable.controlGesto.isFlag()));
  if (isFirstStart) {
    moveable.updateRect(eventType, true, false);
  }
  var datas = e3.datas;
  var gestoType = isControl ? "controlGesto" : "targetGesto";
  var prevGesto = moveable[gestoType];
  var trigger2 = function(able, eventName, conditionName) {
    if (!(eventName in able) || prevGesto !== moveable[gestoType]) {
      return false;
    }
    var ableName = able.name;
    var nextDatas = datas[ableName] || (datas[ableName] = {});
    if (isStart) {
      nextDatas.isEventStart = !conditionName || !able[conditionName] || able[conditionName](moveable, e3);
    }
    if (!nextDatas.isEventStart) {
      return false;
    }
    var result = able[eventName](moveable, __assign9(__assign9({}, e3), { stop, datas: nextDatas, originalDatas: datas, inputTarget }));
    moveable._emitter.off();
    if (isStart && result === false) {
      nextDatas.isEventStart = false;
    }
    return result;
  };
  if (isFirstStart) {
    ables.forEach(function(able) {
      able.unset && able.unset(moveable);
    });
  }
  trigger2(BeforeRenderable, "drag".concat(eventAffix).concat(eventType));
  var forceEndedCount = 0;
  var updatedCount = 0;
  eventOperations.forEach(function(eventOperation) {
    if (isDragStop) {
      return false;
    }
    var eventName = "".concat(eventOperation).concat(eventAffix).concat(eventType);
    var conditionName = "".concat(eventOperation).concat(eventAffix, "Condition");
    if (eventType === "" && !isRequest) {
      convertDragDist(moveable.state, e3);
    }
    var eventAbles = ables.filter(function(able) {
      return able[eventName];
    });
    eventAbles = eventAbles.filter(function(able, i) {
      return able.name && eventAbles.indexOf(able) === i;
    });
    var results = eventAbles.filter(function(able) {
      return trigger2(able, eventName, conditionName);
    });
    var isUpdate = results.length;
    if (isDragStop) {
      ++forceEndedCount;
    }
    if (isUpdate) {
      ++updatedCount;
    }
    if (!isDragStop && isStart && eventAbles.length && !isUpdate) {
      forceEndedCount += eventAbles.filter(function(able) {
        var ableName = able.name;
        var nextDatas = datas[ableName];
        if (nextDatas.isEventStart) {
          if (able.dragRelation === "strong") {
            return false;
          }
          return true;
        }
        return false;
      }).length ? 1 : 0;
    }
  });
  if (!isAfter3 || updatedCount) {
    trigger2(Renderable, "drag".concat(eventAffix).concat(eventType));
  }
  var isForceEnd = prevGesto !== moveable[gestoType] || forceEndedCount === eventOperations.length;
  if (isEnd || isDragStop || isForceEnd) {
    moveable.state.gestos = {};
    if (moveable.moveables) {
      moveable.moveables.forEach(function(childMoveable) {
        childMoveable.state.gestos = {};
      });
    }
    ables.forEach(function(able) {
      able.unset && able.unset(moveable);
    });
  }
  if (isStart && !isForceEnd && !isRequest && updatedCount && moveable.props.preventDefault) {
    e3 === null || e3 === void 0 ? void 0 : e3.preventDefault();
  }
  if (moveable.isUnmounted || isForceEnd) {
    return false;
  }
  if (!isStart && updatedCount && !requestInstant || isEnd) {
    var flushSync5 = moveable.props.flushSync || defaultSync;
    flushSync5(function() {
      moveable.updateRect(isEnd ? eventType : "", true, false);
      moveable.forceUpdate();
    });
  }
  if (!isStart && !isEnd && !isAfter3 && updatedCount && !requestInstant) {
    triggerAble(moveable, moveableAbles, eventOperations, eventAffix, eventType + "After", e3);
  }
  return true;
}
function checkMoveableTarget(moveable, isControl) {
  return function(e3, target) {
    var _a;
    if (target === void 0) {
      target = e3.inputEvent.target;
    }
    var eventTarget = target;
    var areaElement = moveable.areaElement;
    var dragTargetElement = moveable._dragTarget;
    if (!dragTargetElement || !isControl && ((_a = moveable.controlGesto) === null || _a === void 0 ? void 0 : _a.isFlag())) {
      return false;
    }
    return eventTarget === dragTargetElement || dragTargetElement.contains(eventTarget) || eventTarget === areaElement || !moveable.isMoveableElement(eventTarget) && !moveable.controlBox.contains(eventTarget) || hasClass(eventTarget, "moveable-area") || hasClass(eventTarget, "moveable-padding") || hasClass(eventTarget, "moveable-edgeDraggable");
  };
}
function getTargetAbleGesto(moveable, moveableTarget, eventAffix) {
  var controlBox = moveable.controlBox;
  var targets = [];
  var props = moveable.props;
  var dragArea = props.dragArea;
  var target = moveable.state.target;
  var dragTarget = props.dragTarget;
  targets.push(controlBox);
  if (!dragArea || dragTarget) {
    targets.push(moveableTarget);
  }
  if (!dragArea && dragTarget && target && moveableTarget !== target && props.dragTargetSelf) {
    targets.push(target);
  }
  var checkTarget = checkMoveableTarget(moveable);
  return getAbleGesto(moveable, targets, "targetAbles", eventAffix, {
    dragStart: checkTarget,
    pinchStart: checkTarget
  });
}
function getControlAbleGesto(moveable, eventAffix) {
  var controlBox = moveable.controlBox;
  var targets = [];
  targets.push(controlBox);
  var checkTarget = checkMoveableTarget(moveable, true);
  var checkControlTarget = function(e3, target) {
    if (target === void 0) {
      target = e3.inputEvent.target;
    }
    if (target === controlBox) {
      return true;
    }
    var result = checkTarget(e3, target);
    return !result;
  };
  return getAbleGesto(moveable, targets, "controlAbles", eventAffix, {
    dragStart: checkControlTarget,
    pinchStart: checkControlTarget
  });
}
function getAbleGesto(moveable, target, ableType, eventAffix, conditionFunctions) {
  if (conditionFunctions === void 0) {
    conditionFunctions = {};
  }
  var isTargetAbles = ableType === "targetAbles";
  var _a = moveable.props, pinchOutside = _a.pinchOutside, pinchThreshold = _a.pinchThreshold, preventClickEventOnDrag = _a.preventClickEventOnDrag, preventClickDefault = _a.preventClickDefault, checkInput = _a.checkInput, dragFocusedInput = _a.dragFocusedInput, _b = _a.preventDefault, preventDefault2 = _b === void 0 ? true : _b, _c = _a.preventRightClick, preventRightClick = _c === void 0 ? true : _c, _d = _a.preventWheelClick, preventWheelClick = _d === void 0 ? true : _d, dragContaienrOption = _a.dragContainer;
  var dragContainer = getRefTarget(dragContaienrOption, true);
  var options = {
    preventDefault: preventDefault2,
    preventRightClick,
    preventWheelClick,
    container: dragContainer || getWindow2(moveable.getControlBoxElement()),
    pinchThreshold,
    pinchOutside,
    preventClickEventOnDrag: isTargetAbles ? preventClickEventOnDrag : false,
    preventClickEventOnDragStart: isTargetAbles ? preventClickDefault : false,
    preventClickEventByCondition: isTargetAbles ? null : function(e3) {
      return moveable.controlBox.contains(e3.target);
    },
    checkInput: isTargetAbles ? checkInput : false,
    dragFocusedInput
  };
  var gesto = new Gesto(target, options);
  var isControl = eventAffix === "Control";
  ["drag", "pinch"].forEach(function(eventOperation) {
    ["Start", "", "End"].forEach(function(eventType) {
      gesto.on("".concat(eventOperation).concat(eventType), function(e3) {
        var _a2;
        var eventName = e3.eventType;
        var isPinchScheduled = eventOperation === "drag" && e3.isPinch;
        if (conditionFunctions[eventName] && !conditionFunctions[eventName](e3)) {
          e3.stop();
          return;
        }
        if (isPinchScheduled) {
          return;
        }
        var eventOperations = eventOperation === "drag" ? [eventOperation] : ["drag", eventOperation];
        var moveableAbles = __spreadArray2([], __read2(moveable[ableType]), false);
        var result = triggerAble(moveable, moveableAbles, eventOperations, eventAffix, eventType, e3);
        if (!result) {
          e3.stop();
        } else if (moveable.props.stopPropagation || eventType === "Start" && isControl) {
          (_a2 = e3 === null || e3 === void 0 ? void 0 : e3.inputEvent) === null || _a2 === void 0 ? void 0 : _a2.stopPropagation();
        }
      });
    });
  });
  return gesto;
}
var EventManager = /* @__PURE__ */ (function() {
  function EventManager2(target, moveable, eventName) {
    var _this = this;
    this.target = target;
    this.moveable = moveable;
    this.eventName = eventName;
    this.ables = [];
    this._onEvent = function(e3) {
      var eventName2 = _this.eventName;
      var moveable2 = _this.moveable;
      if (moveable2.state.disableNativeEvent) {
        return;
      }
      _this.ables.forEach(function(able) {
        able[eventName2](moveable2, {
          inputEvent: e3
        });
      });
    };
    target.addEventListener(eventName.toLowerCase(), this._onEvent);
  }
  EventManager2.prototype.setAbles = function(ables) {
    this.ables = ables;
  };
  EventManager2.prototype.destroy = function() {
    this.target.removeEventListener(this.eventName.toLowerCase(), this._onEvent);
    this.target = null;
    this.moveable = null;
  };
  return EventManager2;
})();
function calculateMatrixStack(target, container, rootContainer, isAbsolute3d) {
  var _a;
  if (rootContainer === void 0) {
    rootContainer = container;
  }
  var _b = getMatrixStackInfo(target, container), matrixes = _b.matrixes, is3d = _b.is3d, prevTargetMatrix = _b.targetMatrix, transformOrigin = _b.transformOrigin, targetOrigin = _b.targetOrigin, offsetContainer = _b.offsetContainer, hasFixed = _b.hasFixed, containerZoom = _b.zoom;
  var _c = getCachedMatrixContainerInfo(offsetContainer, rootContainer), rootMatrixes = _c.matrixes, isRoot3d = _c.is3d, offsetRootContainer = _c.offsetContainer, rootZoom = _c.zoom;
  var isNext3d = isAbsolute3d || isRoot3d || is3d;
  var n2 = isNext3d ? 4 : 3;
  var isSVGGraphicElement = target.tagName.toLowerCase() !== "svg" && "ownerSVGElement" in target;
  var targetMatrix = prevTargetMatrix;
  var allMatrix = createIdentityMatrix(n2);
  var rootMatrix = createIdentityMatrix(n2);
  var beforeMatrix = createIdentityMatrix(n2);
  var offsetMatrix = createIdentityMatrix(n2);
  var length2 = matrixes.length;
  var nextRootMatrixes = rootMatrixes.map(function(info) {
    return __assign9(__assign9({}, info), { matrix: info.matrix ? __spreadArray2([], __read2(info.matrix), false) : void 0 });
  }).reverse();
  matrixes.reverse();
  if (!is3d && isNext3d) {
    targetMatrix = convertDimension(targetMatrix, 3, 4);
    convert3DMatrixes(matrixes);
  }
  if (!isRoot3d && isNext3d) {
    convert3DMatrixes(nextRootMatrixes);
  }
  nextRootMatrixes.forEach(function(info) {
    rootMatrix = multiply(rootMatrix, info.matrix, n2);
  });
  var originalRootContainer = rootContainer || getDocumentBody(target);
  var endContainer = ((_a = nextRootMatrixes[0]) === null || _a === void 0 ? void 0 : _a.target) || getOffsetInfo(originalRootContainer, originalRootContainer, true).offsetParent;
  var rootMatrixBeforeOffset = nextRootMatrixes.slice(1).reduce(function(matrix, info) {
    return multiply(matrix, info.matrix, n2);
  }, createIdentityMatrix(n2));
  matrixes.forEach(function(info, i) {
    if (length2 - 2 === i) {
      beforeMatrix = allMatrix.slice();
    }
    if (length2 - 1 === i) {
      offsetMatrix = allMatrix.slice();
    }
    if (!info.matrix) {
      var nextInfo = matrixes[i + 1];
      var offset4 = getSVGOffset(info, nextInfo, endContainer, n2, multiply(rootMatrixBeforeOffset, allMatrix, n2));
      info.matrix = createOriginMatrix(offset4, n2);
    }
    allMatrix = multiply(allMatrix, info.matrix, n2);
  });
  var isMatrix3d = !isSVGGraphicElement && is3d;
  if (!targetMatrix) {
    targetMatrix = createIdentityMatrix(isMatrix3d ? 4 : 3);
  }
  var targetTransform = makeMatrixCSS(isSVGGraphicElement && targetMatrix.length === 16 ? convertDimension(targetMatrix, 4, 3) : targetMatrix, isMatrix3d);
  var originalRootMatrix = rootMatrix;
  rootMatrix = ignoreDimension(rootMatrix, n2, n2);
  return {
    hasZoom: containerZoom !== 1 || rootZoom !== 1,
    hasFixed,
    matrixes,
    rootMatrix,
    originalRootMatrix,
    beforeMatrix,
    offsetMatrix,
    allMatrix,
    targetMatrix,
    targetTransform,
    inlineTransform: target.style.transform,
    transformOrigin,
    targetOrigin,
    is3d: isNext3d,
    offsetContainer,
    offsetRootContainer
  };
}
function calculateElementInfo(target, container, rootContainer, isAbsolute3d) {
  if (rootContainer === void 0) {
    rootContainer = container;
  }
  var width = 0;
  var height = 0;
  var rotation = 0;
  var allResult = {};
  var sizes2 = getSize4(target);
  if (target) {
    width = sizes2.offsetWidth;
    height = sizes2.offsetHeight;
  }
  if (target) {
    var result = calculateMatrixStack(target, container, rootContainer, isAbsolute3d);
    var position3 = calculateElementPosition(result.allMatrix, result.transformOrigin, width, height);
    allResult = __assign9(__assign9({}, result), position3);
    var rotationPosition = calculateElementPosition(result.allMatrix, [50, 50], 100, 100);
    rotation = getRotationRad([rotationPosition.pos1, rotationPosition.pos2], rotationPosition.direction);
  }
  var n2 = isAbsolute3d ? 4 : 3;
  return __assign9(__assign9(__assign9({ hasZoom: false, width, height, rotation }, sizes2), { originalRootMatrix: createIdentityMatrix(n2), rootMatrix: createIdentityMatrix(n2), beforeMatrix: createIdentityMatrix(n2), offsetMatrix: createIdentityMatrix(n2), allMatrix: createIdentityMatrix(n2), targetMatrix: createIdentityMatrix(n2), targetTransform: "", inlineTransform: "", transformOrigin: [0, 0], targetOrigin: [0, 0], is3d: !!isAbsolute3d, left: 0, top: 0, right: 0, bottom: 0, origin: [0, 0], pos1: [0, 0], pos2: [0, 0], pos3: [0, 0], pos4: [0, 0], direction: 1, hasFixed: false, offsetContainer: null, offsetRootContainer: null, matrixes: [] }), allResult);
}
function getMoveableTargetInfo(moveableElement, target, container, parentContainer, rootContainer, requestStyles) {
  if (requestStyles === void 0) {
    requestStyles = [];
  }
  var beforeDirection = 1;
  var beforeOrigin = [0, 0];
  var targetClientRect = resetClientRect();
  var moveableClientRect = resetClientRect();
  var containerClientRect = resetClientRect();
  var rootContainerClientRect = resetClientRect();
  var offsetDelta = [0, 0];
  var style2 = {};
  var result = calculateElementInfo(target, container, rootContainer, true);
  if (target) {
    var getStyle_1 = getCachedStyle(target);
    requestStyles.forEach(function(name) {
      style2[name] = getStyle_1(name);
    });
    var n2 = result.is3d ? 4 : 3;
    var beforePosition = calculateElementPosition(result.offsetMatrix, plus(result.transformOrigin, getOrigin(result.targetMatrix, n2)), result.width, result.height);
    beforeDirection = beforePosition.direction;
    beforeOrigin = plus(beforePosition.origin, [beforePosition.left - result.left, beforePosition.top - result.top]);
    rootContainerClientRect = getClientRect2(result.offsetRootContainer);
    var offsetContainer = getOffsetInfo(parentContainer, parentContainer, true).offsetParent || result.offsetRootContainer;
    if (result.hasZoom) {
      var absoluteTargetPosition = calculateElementPosition(multiply(result.originalRootMatrix, result.allMatrix), result.transformOrigin, result.width, result.height);
      var absoluteContainerPosition = calculateElementPosition(result.originalRootMatrix, getTransformOriginArray(getCachedStyle(offsetContainer)("transformOrigin")).map(function(pos) {
        return parseFloat(pos);
      }), offsetContainer.offsetWidth, offsetContainer.offsetHeight);
      targetClientRect = getClientRectByPosition(absoluteTargetPosition, rootContainerClientRect);
      containerClientRect = getClientRectByPosition(absoluteContainerPosition, rootContainerClientRect, offsetContainer, true);
      if (moveableElement) {
        var left2 = absoluteTargetPosition.left;
        var top_1 = absoluteTargetPosition.top;
        moveableClientRect = getClientRectByPosition({
          left: left2,
          top: top_1,
          bottom: top_1,
          right: top_1
        }, rootContainerClientRect);
      }
    } else {
      targetClientRect = getClientRect2(target);
      containerClientRect = getCachedClientRect(offsetContainer);
      if (moveableElement) {
        moveableClientRect = getClientRect2(moveableElement);
      }
      var containerClientRectLeft = containerClientRect.left, containerClientRectTop = containerClientRect.top, containterClientLeft = containerClientRect.clientLeft, containerClientTop = containerClientRect.clientTop;
      var clientDelta = [
        targetClientRect.left - containerClientRectLeft,
        targetClientRect.top - containerClientRectTop
      ];
      offsetDelta = minus(calculateInversePosition(result.rootMatrix, clientDelta, 4), [containterClientLeft + result.left, containerClientTop + result.top]);
    }
  }
  return __assign9({ targetClientRect, containerClientRect, moveableClientRect, rootContainerClientRect, beforeDirection, beforeOrigin, originalBeforeOrigin: beforeOrigin, target, style: style2, offsetDelta }, result);
}
function getPersistState(rect) {
  var pos1 = rect.pos1, pos2 = rect.pos2, pos3 = rect.pos3, pos4 = rect.pos4;
  if (!pos1 || !pos2 || !pos3 || !pos4) {
    return null;
  }
  var minPos = getMinMaxs([pos1, pos2, pos3, pos4]);
  var posDelta = [minPos.minX, minPos.minY];
  var origin = minus(rect.origin, posDelta);
  pos1 = minus(pos1, posDelta);
  pos2 = minus(pos2, posDelta);
  pos3 = minus(pos3, posDelta);
  pos4 = minus(pos4, posDelta);
  return __assign9(__assign9({}, rect), {
    left: rect.left,
    top: rect.top,
    posDelta,
    pos1,
    pos2,
    pos3,
    pos4,
    origin,
    beforeOrigin: origin,
    // originalBeforeOrigin: origin,
    isPersisted: true
  });
}
var MoveableManager = /* @__PURE__ */ (function(_super) {
  __extends7(MoveableManager2, _super);
  function MoveableManager2() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.state = __assign9({ container: null, gestos: {}, renderLines: [
      [[0, 0], [0, 0]],
      [[0, 0], [0, 0]],
      [[0, 0], [0, 0]],
      [[0, 0], [0, 0]]
    ], renderPoses: [[0, 0], [0, 0], [0, 0], [0, 0]], disableNativeEvent: false, posDelta: [0, 0] }, getMoveableTargetInfo(null));
    _this.renderState = {};
    _this.enabledAbles = [];
    _this.targetAbles = [];
    _this.controlAbles = [];
    _this.rotation = 0;
    _this.scale = [1, 1];
    _this.isMoveableMounted = false;
    _this.isUnmounted = false;
    _this.events = {
      "mouseEnter": null,
      "mouseLeave": null
    };
    _this._emitter = new event_emitter_esm_default();
    _this._prevOriginalDragTarget = null;
    _this._originalDragTarget = null;
    _this._prevDragTarget = null;
    _this._dragTarget = null;
    _this._prevPropTarget = null;
    _this._propTarget = null;
    _this._prevDragArea = false;
    _this._isPropTargetChanged = false;
    _this._hasFirstTarget = false;
    _this._reiszeObserver = null;
    _this._observerId = 0;
    _this._mutationObserver = null;
    _this._rootContainer = null;
    _this._viewContainer = null;
    _this._viewClassNames = [];
    _this._store = {};
    _this.checkUpdateRect = function() {
      if (_this.isDragging()) {
        return;
      }
      var parentMoveable = _this.props.parentMoveable;
      if (parentMoveable) {
        parentMoveable.checkUpdateRect();
        return;
      }
      cancelAnimationFrame2(_this._observerId);
      _this._observerId = requestAnimationFrame2(function() {
        if (_this.isDragging()) {
          return;
        }
        _this.updateRect();
      });
    };
    _this._onPreventClick = function(e3) {
      e3.stopPropagation();
      e3.preventDefault();
    };
    return _this;
  }
  MoveableManager2.prototype.render = function() {
    var props = this.props;
    var state = this.getState();
    var parentPosition = props.parentPosition, className2 = props.className, propsTarget = props.target, zoom = props.zoom, cspNonce = props.cspNonce, translateZ = props.translateZ, ControlBoxElement = props.cssStyled, groupable = props.groupable, linePadding = props.linePadding, controlPadding = props.controlPadding;
    this._checkUpdateRootContainer();
    this.checkUpdate();
    this.updateRenderPoses();
    var _a = __read2(parentPosition || [0, 0], 2), parentLeft = _a[0], parentTop = _a[1];
    var left2 = state.left, top = state.top, stateTarget = state.target, direction = state.direction, hasFixed = state.hasFixed, offsetDelta = state.offsetDelta;
    var groupTargets = props.targets;
    var isDragging = this.isDragging();
    var ableAttributes = {};
    this.getEnabledAbles().forEach(function(able) {
      ableAttributes["data-able-".concat(able.name.toLowerCase())] = true;
    });
    var ableClassName = this._getAbleClassName();
    var isDisplay = groupTargets && groupTargets.length && (stateTarget || groupable) || propsTarget || !this._hasFirstTarget && this.state.isPersisted;
    var isVisible = this.controlBox || this.props.firstRenderState || this.props.persistData;
    var translate = [left2 - parentLeft, top - parentTop];
    if (!groupable && props.useAccuratePosition) {
      translate[0] += offsetDelta[0];
      translate[1] += offsetDelta[1];
    }
    var style2 = {
      "position": hasFixed ? "fixed" : "absolute",
      "display": isDisplay ? "block" : "none",
      "visibility": isVisible ? "visible" : "hidden",
      "transform": "translate3d(".concat(translate[0], "px, ").concat(translate[1], "px, ").concat(translateZ, ")"),
      "--zoom": zoom,
      "--zoompx": "".concat(zoom, "px")
    };
    if (linePadding) {
      style2["--moveable-line-padding"] = linePadding;
    }
    if (controlPadding) {
      style2["--moveable-control-padding"] = controlPadding;
    }
    return React597.createElement(
      ControlBoxElement,
      __assign9({ cspNonce, ref: ref2(this, "controlBox"), className: "".concat(prefix("control-box", direction === -1 ? "reverse" : "", isDragging ? "dragging" : ""), " ").concat(ableClassName, " ").concat(className2) }, ableAttributes, { onClick: this._onPreventClick, style: style2 }),
      this.renderAbles(),
      this._renderLines()
    );
  };
  MoveableManager2.prototype.componentDidMount = function() {
    this.isMoveableMounted = true;
    this.isUnmounted = false;
    var props = this.props;
    var parentMoveable = props.parentMoveable, container = props.container;
    this._checkUpdateRootContainer();
    this._checkUpdateViewContainer();
    this._updateTargets();
    this._updateNativeEvents();
    this._updateEvents();
    this.updateCheckInput();
    this._updateObserver(this.props);
    if (!container && !parentMoveable && !this.state.isPersisted) {
      this.updateRect("", false, false);
      this.forceUpdate();
    }
  };
  MoveableManager2.prototype.componentDidUpdate = function(prevProps) {
    this._checkUpdateRootContainer();
    this._checkUpdateViewContainer();
    this._updateNativeEvents();
    this._updateTargets();
    this._updateEvents();
    this.updateCheckInput();
    this._updateObserver(prevProps);
  };
  MoveableManager2.prototype.componentWillUnmount = function() {
    var _a, _b;
    this.isMoveableMounted = false;
    this.isUnmounted = true;
    this._emitter.off();
    (_a = this._reiszeObserver) === null || _a === void 0 ? void 0 : _a.disconnect();
    (_b = this._mutationObserver) === null || _b === void 0 ? void 0 : _b.disconnect();
    var viewContainer = this._viewContainer;
    if (viewContainer) {
      this._changeAbleViewClassNames([]);
    }
    unsetGesto(this, false);
    unsetGesto(this, true);
    var events2 = this.events;
    for (var name_1 in events2) {
      var manager = events2[name_1];
      manager && manager.destroy();
    }
  };
  MoveableManager2.prototype.getTargets = function() {
    var target = this.props.target;
    return target ? [target] : [];
  };
  MoveableManager2.prototype.getAble = function(ableName) {
    var ables = this.props.ables || [];
    return find(ables, function(able) {
      return able.name === ableName;
    });
  };
  MoveableManager2.prototype.getContainer = function() {
    var _a = this.props, parentMoveable = _a.parentMoveable, wrapperMoveable = _a.wrapperMoveable, container = _a.container;
    return container || wrapperMoveable && wrapperMoveable.getContainer() || parentMoveable && parentMoveable.getContainer() || this.controlBox.parentElement;
  };
  MoveableManager2.prototype.getControlBoxElement = function() {
    return this.controlBox;
  };
  MoveableManager2.prototype.getDragElement = function() {
    return this._dragTarget;
  };
  MoveableManager2.prototype.isMoveableElement = function(target) {
    var _a;
    return target && (((_a = target.getAttribute) === null || _a === void 0 ? void 0 : _a.call(target, "class")) || "").indexOf(PREFIX) > -1;
  };
  MoveableManager2.prototype.dragStart = function(e3, target) {
    if (target === void 0) {
      target = e3.target;
    }
    var targetGesto = this.targetGesto;
    var controlGesto = this.controlGesto;
    if (targetGesto && checkMoveableTarget(this)({ inputEvent: e3 }, target)) {
      if (!targetGesto.isFlag()) {
        targetGesto.triggerDragStart(e3);
      }
    } else if (controlGesto && this.isMoveableElement(target)) {
      if (!controlGesto.isFlag()) {
        controlGesto.triggerDragStart(e3);
      }
    }
    return this;
  };
  MoveableManager2.prototype.hitTest = function(el) {
    var _a = this.state, target = _a.target, pos1 = _a.pos1, pos2 = _a.pos2, pos3 = _a.pos3, pos4 = _a.pos4, targetClientRect = _a.targetClientRect;
    if (!target) {
      return 0;
    }
    var rect;
    if (isNode2(el)) {
      var clientRect = el.getBoundingClientRect();
      rect = {
        left: clientRect.left,
        top: clientRect.top,
        width: clientRect.width,
        height: clientRect.height
      };
    } else {
      rect = __assign9({ width: 0, height: 0 }, el);
    }
    var rectLeft = rect.left, rectTop = rect.top, rectWidth = rect.width, rectHeight = rect.height;
    var points = fitPoints([pos1, pos2, pos4, pos3], targetClientRect);
    var size = getOverlapSize(points, [
      [rectLeft, rectTop],
      [rectLeft + rectWidth, rectTop],
      [rectLeft + rectWidth, rectTop + rectHeight],
      [rectLeft, rectTop + rectHeight]
    ]);
    var totalSize = getAreaSize(points);
    if (!size || !totalSize) {
      return 0;
    }
    return Math.min(100, size / totalSize * 100);
  };
  MoveableManager2.prototype.isInside = function(clientX, clientY) {
    var _a = this.state, target = _a.target, pos1 = _a.pos1, pos2 = _a.pos2, pos3 = _a.pos3, pos4 = _a.pos4, targetClientRect = _a.targetClientRect;
    if (!target) {
      return false;
    }
    return isInside([clientX, clientY], fitPoints([pos1, pos2, pos4, pos3], targetClientRect));
  };
  MoveableManager2.prototype.updateRect = function(type5, isTarget, isSetState) {
    if (isSetState === void 0) {
      isSetState = true;
    }
    var props = this.props;
    var isSingle = !props.parentPosition && !props.wrapperMoveable;
    if (isSingle) {
      setStoreCache(true);
    }
    var parentMoveable = props.parentMoveable;
    var state = this.state;
    var target = state.target || props.target;
    var container = this.getContainer();
    var rootContainer = parentMoveable ? parentMoveable._rootContainer : this._rootContainer;
    var nextState = getMoveableTargetInfo(this.controlBox, target, container, container, rootContainer || container, this._getRequestStyles());
    if (!target && this._hasFirstTarget && props.persistData) {
      var persistState = getPersistState(props.persistData);
      for (var name_2 in persistState) {
        nextState[name_2] = persistState[name_2];
      }
    }
    if (isSingle) {
      setStoreCache();
    }
    this.updateState(nextState, parentMoveable ? false : isSetState);
  };
  MoveableManager2.prototype.isDragging = function(ableName) {
    var _a, _b;
    var targetGesto = this.targetGesto;
    var controlGesto = this.controlGesto;
    if (targetGesto === null || targetGesto === void 0 ? void 0 : targetGesto.isFlag()) {
      if (!ableName) {
        return true;
      }
      var data2 = targetGesto.getEventData();
      return !!((_a = data2[ableName]) === null || _a === void 0 ? void 0 : _a.isEventStart);
    }
    if (controlGesto === null || controlGesto === void 0 ? void 0 : controlGesto.isFlag()) {
      if (!ableName) {
        return true;
      }
      var data2 = controlGesto.getEventData();
      return !!((_b = data2[ableName]) === null || _b === void 0 ? void 0 : _b.isEventStart);
    }
    return false;
  };
  MoveableManager2.prototype.updateTarget = function(type5) {
    this.updateRect(type5, true);
  };
  MoveableManager2.prototype.getRect = function() {
    var state = this.state;
    var poses = getAbsolutePosesByState(this.state);
    var _a = __read2(poses, 4), pos1 = _a[0], pos2 = _a[1], pos3 = _a[2], pos4 = _a[3];
    var rect = getRect2(poses);
    var offsetWidth = state.width, offsetHeight = state.height;
    var width = rect.width, height = rect.height, left2 = rect.left, top = rect.top;
    var statePos = [state.left, state.top];
    var origin = plus(statePos, state.origin);
    var beforeOrigin = plus(statePos, state.beforeOrigin);
    var transformOrigin = state.transformOrigin;
    return {
      width,
      height,
      left: left2,
      top,
      pos1,
      pos2,
      pos3,
      pos4,
      offsetWidth,
      offsetHeight,
      beforeOrigin,
      origin,
      transformOrigin,
      rotation: this.getRotation()
    };
  };
  MoveableManager2.prototype.getManager = function() {
    return this;
  };
  MoveableManager2.prototype.stopDrag = function(type5) {
    if (!type5 || type5 === "target") {
      var gesto = this.targetGesto;
      if ((gesto === null || gesto === void 0 ? void 0 : gesto.isIdle()) === false) {
        unsetAbles(this, false);
      }
      gesto === null || gesto === void 0 ? void 0 : gesto.stop();
    }
    if (!type5 || type5 === "control") {
      var gesto = this.controlGesto;
      if ((gesto === null || gesto === void 0 ? void 0 : gesto.isIdle()) === false) {
        unsetAbles(this, true);
      }
      gesto === null || gesto === void 0 ? void 0 : gesto.stop();
    }
  };
  MoveableManager2.prototype.getRotation = function() {
    var _a = this.state, pos1 = _a.pos1, pos2 = _a.pos2, direction = _a.direction;
    return getAbsoluteRotation(pos1, pos2, direction);
  };
  MoveableManager2.prototype.request = function(ableName, param, isInstant) {
    if (param === void 0) {
      param = {};
    }
    var self2 = this;
    var props = self2.props;
    var manager = props.parentMoveable || props.wrapperMoveable || self2;
    var allAbles = manager.props.ables;
    var groupable = props.groupable;
    var requsetAble = find(allAbles, function(able) {
      return able.name === ableName;
    });
    if (this.isDragging() || !requsetAble || !requsetAble.request) {
      return {
        request: function() {
          return this;
        },
        requestEnd: function() {
          return this;
        }
      };
    }
    var ableRequester = requsetAble.request(self2);
    var requestInstant = isInstant || param.isInstant;
    var ableType = ableRequester.isControl ? "controlAbles" : "targetAbles";
    var eventAffix = "".concat(groupable ? "Group" : "").concat(ableRequester.isControl ? "Control" : "");
    var moveableAbles = __spreadArray2([], __read2(manager[ableType]), false);
    var requester = {
      request: function(ableParam) {
        triggerAble(self2, moveableAbles, ["drag"], eventAffix, "", __assign9(__assign9({}, ableRequester.request(ableParam)), { requestAble: ableName, isRequest: true }), requestInstant);
        return requester;
      },
      requestEnd: function() {
        triggerAble(self2, moveableAbles, ["drag"], eventAffix, "End", __assign9(__assign9({}, ableRequester.requestEnd()), { requestAble: ableName, isRequest: true }), requestInstant);
        return requester;
      }
    };
    triggerAble(self2, moveableAbles, ["drag"], eventAffix, "Start", __assign9(__assign9({}, ableRequester.requestStart(param)), { requestAble: ableName, isRequest: true }), requestInstant);
    return requestInstant ? requester.request(param).requestEnd() : requester;
  };
  MoveableManager2.prototype.getMoveables = function() {
    return [this];
  };
  MoveableManager2.prototype.destroy = function() {
    this.componentWillUnmount();
  };
  MoveableManager2.prototype.updateRenderPoses = function() {
    var state = this.getState();
    var props = this.props;
    var padding = props.padding;
    var originalBeforeOrigin = state.originalBeforeOrigin, transformOrigin = state.transformOrigin, allMatrix = state.allMatrix, is3d = state.is3d, pos1 = state.pos1, pos2 = state.pos2, pos3 = state.pos3, pos4 = state.pos4, stateLeft = state.left, stateTop = state.top, isPersisted = state.isPersisted;
    var zoom = props.zoom || 1;
    if (!padding && zoom <= 1) {
      state.renderPoses = [
        pos1,
        pos2,
        pos3,
        pos4
      ];
      state.renderLines = [
        [pos1, pos2],
        [pos2, pos4],
        [pos4, pos3],
        [pos3, pos1]
      ];
      return;
    }
    var _a = getPaddingBox(padding || {}), left2 = _a.left, top = _a.top, bottom = _a.bottom, right2 = _a.right;
    var n2 = is3d ? 4 : 3;
    var absoluteOrigin = [];
    if (isPersisted) {
      absoluteOrigin = transformOrigin;
    } else if (this.controlBox && props.groupable) {
      absoluteOrigin = originalBeforeOrigin;
    } else {
      absoluteOrigin = plus(originalBeforeOrigin, [stateLeft, stateTop]);
    }
    var nextMatrix = multiplies(n2, createOriginMatrix(absoluteOrigin.map(function(v) {
      return -v;
    }), n2), allMatrix, createOriginMatrix(transformOrigin, n2));
    var renderPos1 = calculatePadding(nextMatrix, pos1, [-left2, -top], n2);
    var renderPos2 = calculatePadding(nextMatrix, pos2, [right2, -top], n2);
    var renderPos3 = calculatePadding(nextMatrix, pos3, [-left2, bottom], n2);
    var renderPos4 = calculatePadding(nextMatrix, pos4, [right2, bottom], n2);
    state.renderPoses = [
      renderPos1,
      renderPos2,
      renderPos3,
      renderPos4
    ];
    state.renderLines = [
      [renderPos1, renderPos2],
      [renderPos2, renderPos4],
      [renderPos4, renderPos3],
      [renderPos3, renderPos1]
    ];
    if (zoom) {
      var zoomOffset = zoom / 2;
      state.renderLines = [
        [
          calculatePadding(nextMatrix, pos1, [-left2 - zoomOffset, -top], n2),
          calculatePadding(nextMatrix, pos2, [right2 + zoomOffset, -top], n2)
        ],
        [
          calculatePadding(nextMatrix, pos2, [right2, -top - zoomOffset], n2),
          calculatePadding(nextMatrix, pos4, [right2, bottom + zoomOffset], n2)
        ],
        [
          calculatePadding(nextMatrix, pos4, [right2 + zoomOffset, bottom], n2),
          calculatePadding(nextMatrix, pos3, [-left2 - zoomOffset, bottom], n2)
        ],
        [
          calculatePadding(nextMatrix, pos3, [-left2, bottom + zoomOffset], n2),
          calculatePadding(nextMatrix, pos1, [-left2, -top - zoomOffset], n2)
        ]
      ];
    }
  };
  MoveableManager2.prototype.checkUpdate = function() {
    this._isPropTargetChanged = false;
    var _a = this.props, target = _a.target, container = _a.container, parentMoveable = _a.parentMoveable;
    var _b = this.state, stateTarget = _b.target, stateContainer = _b.container;
    if (!stateTarget && !target) {
      return;
    }
    this.updateAbles();
    var isTargetChanged = !equals(stateTarget, target);
    var isChanged = isTargetChanged || !equals(stateContainer, container);
    if (!isChanged) {
      return;
    }
    var moveableContainer = container || this.controlBox;
    if (moveableContainer) {
      this.unsetAbles();
    }
    this.updateState({ target, container });
    if (!parentMoveable && moveableContainer) {
      this.updateRect("End", false, false);
    }
    this._isPropTargetChanged = isTargetChanged;
  };
  MoveableManager2.prototype.waitToChangeTarget = function() {
    return new Promise(function() {
    });
  };
  MoveableManager2.prototype.triggerEvent = function(name, e3) {
    var props = this.props;
    this._emitter.trigger(name, e3);
    if (props.parentMoveable && e3.isRequest && !e3.isRequestChild) {
      return props.parentMoveable.triggerEvent(name, e3, true);
    }
    var callback = props[name];
    return callback && callback(e3);
  };
  MoveableManager2.prototype.useCSS = function(tag, css2) {
    var customStyleMap = this.props.customStyledMap;
    var key2 = tag + css2;
    if (!customStyleMap[key2]) {
      customStyleMap[key2] = styled2(tag, css2);
    }
    return customStyleMap[key2];
  };
  MoveableManager2.prototype.getState = function() {
    var _a;
    var props = this.props;
    if (props.target || ((_a = props.targets) === null || _a === void 0 ? void 0 : _a.length)) {
      this._hasFirstTarget = true;
    }
    var hasControlBox = this.controlBox;
    var persistData = props.persistData;
    var firstRenderState = props.firstRenderState;
    if (firstRenderState && !hasControlBox) {
      return firstRenderState;
    }
    if (!this._hasFirstTarget && persistData) {
      var persistState = getPersistState(persistData);
      if (persistState) {
        this.updateState(persistState, false);
        return this.state;
      }
    }
    this.state.isPersisted = false;
    return this.state;
  };
  MoveableManager2.prototype.updateSelectors = function() {
  };
  MoveableManager2.prototype.unsetAbles = function() {
    var _this = this;
    this.targetAbles.forEach(function(able) {
      if (able.unset) {
        able.unset(_this);
      }
    });
  };
  MoveableManager2.prototype.updateAbles = function(ables, eventAffix) {
    if (ables === void 0) {
      ables = this.props.ables;
    }
    if (eventAffix === void 0) {
      eventAffix = "";
    }
    var props = this.props;
    var triggerAblesSimultaneously = props.triggerAblesSimultaneously;
    var enabledAbles = this.getEnabledAbles(ables);
    var dragStart = "drag".concat(eventAffix, "Start");
    var pinchStart = "pinch".concat(eventAffix, "Start");
    var dragControlStart = "drag".concat(eventAffix, "ControlStart");
    var targetAbles = filterAbles(enabledAbles, [dragStart, pinchStart], triggerAblesSimultaneously);
    var controlAbles = filterAbles(enabledAbles, [dragControlStart], triggerAblesSimultaneously);
    this.enabledAbles = enabledAbles;
    this.targetAbles = targetAbles;
    this.controlAbles = controlAbles;
  };
  MoveableManager2.prototype.updateState = function(nextState, isSetState) {
    if (isSetState) {
      if (this.isUnmounted) {
        return;
      }
      this.setState(nextState);
    } else {
      var state = this.state;
      for (var name_3 in nextState) {
        state[name_3] = nextState[name_3];
      }
    }
  };
  MoveableManager2.prototype.getEnabledAbles = function(ables) {
    if (ables === void 0) {
      ables = this.props.ables;
    }
    var props = this.props;
    return ables.filter(function(able) {
      return able && (able.always && props[able.name] !== false || props[able.name]);
    });
  };
  MoveableManager2.prototype.renderAbles = function() {
    var _this = this;
    var props = this.props;
    var triggerAblesSimultaneously = props.triggerAblesSimultaneously;
    var Renderer2 = {
      createElement: import_react233.createElement
    };
    this.renderState = {};
    return groupByMap(flat2(filterAbles(this.getEnabledAbles(), ["render"], triggerAblesSimultaneously).map(function(_a) {
      var render4 = _a.render;
      return render4(_this, Renderer2) || [];
    })).filter(function(el) {
      return el;
    }), function(_a) {
      var key2 = _a.key;
      return key2;
    }).map(function(group) {
      return group[0];
    });
  };
  MoveableManager2.prototype.updateCheckInput = function() {
    this.targetGesto && (this.targetGesto.options.checkInput = this.props.checkInput);
  };
  MoveableManager2.prototype._getRequestStyles = function() {
    var styleNames = this.getEnabledAbles().reduce(function(names2, able) {
      var _a, _b;
      var ableStyleNames = (_b = (_a = able.requestStyle) === null || _a === void 0 ? void 0 : _a.call(able)) !== null && _b !== void 0 ? _b : [];
      return __spreadArray2(__spreadArray2([], __read2(names2), false), __read2(ableStyleNames), false);
    }, __spreadArray2([], __read2(this.props.requestStyles || []), false));
    return styleNames;
  };
  MoveableManager2.prototype._updateObserver = function(prevProps) {
    this._updateResizeObserver(prevProps);
    this._updateMutationObserver(prevProps);
  };
  MoveableManager2.prototype._updateEvents = function() {
    var hasTargetAble = this.targetAbles.length;
    var hasControlAble = this.controlAbles.length;
    var target = this._dragTarget;
    var isUnset = !hasTargetAble && this.targetGesto || this._isTargetChanged(true);
    if (isUnset) {
      unsetGesto(this, false);
      this.updateState({ gestos: {} });
    }
    if (!hasControlAble) {
      unsetGesto(this, true);
    }
    if (target && hasTargetAble && !this.targetGesto) {
      this.targetGesto = getTargetAbleGesto(this, target, "");
    }
    if (!this.controlGesto && hasControlAble) {
      this.controlGesto = getControlAbleGesto(this, "Control");
    }
  };
  MoveableManager2.prototype._updateTargets = function() {
    var props = this.props;
    this._prevPropTarget = this._propTarget;
    this._prevDragTarget = this._dragTarget;
    this._prevOriginalDragTarget = this._originalDragTarget;
    this._prevDragArea = props.dragArea;
    this._propTarget = props.target;
    this._originalDragTarget = props.dragTarget || props.target;
    this._dragTarget = getRefTarget(this._originalDragTarget, true);
  };
  MoveableManager2.prototype._renderLines = function() {
    var props = this.props;
    var _a = props, zoom = _a.zoom, hideDefaultLines = _a.hideDefaultLines, hideChildMoveableDefaultLines = _a.hideChildMoveableDefaultLines, parentMoveable = _a.parentMoveable;
    if (hideDefaultLines || parentMoveable && hideChildMoveableDefaultLines) {
      return [];
    }
    var state = this.getState();
    var Renderer2 = {
      createElement: import_react233.createElement
    };
    return state.renderLines.map(function(line2, i) {
      return renderLine(Renderer2, "", line2[0], line2[1], zoom, "render-line-".concat(i));
    });
  };
  MoveableManager2.prototype._isTargetChanged = function(useDragArea) {
    var props = this.props;
    var nextTarget = props.dragTarget || props.target;
    var prevTarget = this._prevOriginalDragTarget;
    var prevDragArea = this._prevDragArea;
    var dragArea = props.dragArea;
    var isDragTargetChanged = !dragArea && prevTarget !== nextTarget;
    var isDragAreaChanged = (useDragArea || dragArea) && prevDragArea !== dragArea;
    return isDragTargetChanged || isDragAreaChanged || this._prevPropTarget != this._propTarget;
  };
  MoveableManager2.prototype._updateNativeEvents = function() {
    var _this = this;
    var props = this.props;
    var target = props.dragArea ? this.areaElement : this.state.target;
    var events2 = this.events;
    var eventKeys = getKeys2(events2);
    if (this._isTargetChanged()) {
      for (var eventName in events2) {
        var manager = events2[eventName];
        manager && manager.destroy();
        events2[eventName] = null;
      }
    }
    if (!target) {
      return;
    }
    var enabledAbles = this.enabledAbles;
    eventKeys.forEach(function(eventName2) {
      var ables = filterAbles(enabledAbles, [eventName2]);
      var hasAbles = ables.length > 0;
      var manager2 = events2[eventName2];
      if (!hasAbles) {
        if (manager2) {
          manager2.destroy();
          events2[eventName2] = null;
        }
        return;
      }
      if (!manager2) {
        manager2 = new EventManager(target, _this, eventName2);
        events2[eventName2] = manager2;
      }
      manager2.setAbles(ables);
    });
  };
  MoveableManager2.prototype._checkUpdateRootContainer = function() {
    var rootContainer = this.props.rootContainer;
    if (!this._rootContainer && rootContainer) {
      this._rootContainer = getRefTarget(rootContainer, true);
    }
  };
  MoveableManager2.prototype._checkUpdateViewContainer = function() {
    var viewContainerOption = this.props.viewContainer;
    if (!this._viewContainer && viewContainerOption) {
      this._viewContainer = getRefTarget(viewContainerOption, true);
    }
    var viewContainer = this._viewContainer;
    if (viewContainer) {
      this._changeAbleViewClassNames(__spreadArray2(__spreadArray2([], __read2(this._getAbleViewClassNames()), false), [
        this.isDragging() ? VIEW_DRAGGING : ""
      ], false));
    }
  };
  MoveableManager2.prototype._changeAbleViewClassNames = function(classNames186) {
    var viewContainer = this._viewContainer;
    var nextClassNames = groupBy(classNames186.filter(Boolean), function(el) {
      return el;
    }).map(function(_a2) {
      var _b = __read2(_a2, 1), className2 = _b[0];
      return className2;
    });
    var prevClassNames = this._viewClassNames;
    var _a = diff(prevClassNames, nextClassNames), removed = _a.removed, added = _a.added;
    removed.forEach(function(index3) {
      removeClass(viewContainer, prevClassNames[index3]);
    });
    added.forEach(function(index3) {
      addClass(viewContainer, nextClassNames[index3]);
    });
    this._viewClassNames = nextClassNames;
  };
  MoveableManager2.prototype._getAbleViewClassNames = function() {
    var _this = this;
    return (this.getEnabledAbles().map(function(able) {
      var _a;
      return ((_a = able.viewClassName) === null || _a === void 0 ? void 0 : _a.call(able, _this)) || "";
    }).join(" ") + " ".concat(this._getAbleClassName("-view"))).split(/\s+/g);
  };
  MoveableManager2.prototype._getAbleClassName = function(classPrefix) {
    var _this = this;
    if (classPrefix === void 0) {
      classPrefix = "";
    }
    var ables = this.getEnabledAbles();
    var targetGesto = this.targetGesto;
    var controlGesto = this.controlGesto;
    var targetGestoData = (targetGesto === null || targetGesto === void 0 ? void 0 : targetGesto.isFlag()) ? targetGesto.getEventData() : {};
    var controlGestoData = (controlGesto === null || controlGesto === void 0 ? void 0 : controlGesto.isFlag()) ? controlGesto.getEventData() : {};
    return ables.map(function(able) {
      var _a, _b, _c;
      var name = able.name;
      var className2 = ((_a = able.className) === null || _a === void 0 ? void 0 : _a.call(able, _this)) || "";
      if (((_b = targetGestoData[name]) === null || _b === void 0 ? void 0 : _b.isEventStart) || ((_c = controlGestoData[name]) === null || _c === void 0 ? void 0 : _c.isEventStart)) {
        className2 += " ".concat(prefix("".concat(name).concat(classPrefix, "-dragging")));
      }
      return className2.trim();
    }).filter(Boolean).join(" ");
  };
  MoveableManager2.prototype._updateResizeObserver = function(prevProps) {
    var _a;
    var props = this.props;
    var target = props.target;
    var win = getWindow2(this.getControlBoxElement());
    if (!win.ResizeObserver || !target || !props.useResizeObserver) {
      (_a = this._reiszeObserver) === null || _a === void 0 ? void 0 : _a.disconnect();
      return;
    }
    if (prevProps.target === target && this._reiszeObserver) {
      return;
    }
    var observer = new win.ResizeObserver(this.checkUpdateRect);
    observer.observe(target, {
      box: "border-box"
    });
    this._reiszeObserver = observer;
  };
  MoveableManager2.prototype._updateMutationObserver = function(prevProps) {
    var _this = this;
    var _a;
    var props = this.props;
    var target = props.target;
    var win = getWindow2(this.getControlBoxElement());
    if (!win.MutationObserver || !target || !props.useMutationObserver) {
      (_a = this._mutationObserver) === null || _a === void 0 ? void 0 : _a.disconnect();
      return;
    }
    if (prevProps.target === target && this._mutationObserver) {
      return;
    }
    var observer = new win.MutationObserver(function(records) {
      var e_1, _a2;
      try {
        for (var records_1 = __values(records), records_1_1 = records_1.next(); !records_1_1.done; records_1_1 = records_1.next()) {
          var mutation = records_1_1.value;
          if (mutation.type === "attributes" && mutation.attributeName === "style") {
            _this.checkUpdateRect();
          }
        }
      } catch (e_1_1) {
        e_1 = { error: e_1_1 };
      } finally {
        try {
          if (records_1_1 && !records_1_1.done && (_a2 = records_1.return)) _a2.call(records_1);
        } finally {
          if (e_1) throw e_1.error;
        }
      }
    });
    observer.observe(target, {
      attributes: true
    });
    this._mutationObserver = observer;
  };
  MoveableManager2.defaultProps = {
    dragTargetSelf: false,
    target: null,
    dragTarget: null,
    container: null,
    rootContainer: null,
    origin: true,
    parentMoveable: null,
    wrapperMoveable: null,
    isWrapperMounted: false,
    parentPosition: null,
    warpSelf: false,
    svgOrigin: "",
    dragContainer: null,
    useResizeObserver: false,
    useMutationObserver: false,
    preventDefault: true,
    preventRightClick: true,
    preventWheelClick: true,
    linePadding: 0,
    controlPadding: 0,
    ables: [],
    pinchThreshold: 20,
    dragArea: false,
    passDragArea: false,
    transformOrigin: "",
    className: "",
    zoom: 1,
    triggerAblesSimultaneously: false,
    padding: {},
    pinchOutside: true,
    checkInput: false,
    dragFocusedInput: false,
    groupable: false,
    hideDefaultLines: false,
    cspNonce: "",
    translateZ: 0,
    cssStyled: null,
    customStyledMap: {},
    props: {},
    stopPropagation: false,
    preventClickDefault: false,
    preventClickEventOnDrag: true,
    flushSync: defaultSync,
    firstRenderState: null,
    persistData: null,
    viewContainer: null,
    requestStyles: [],
    useAccuratePosition: false
  };
  return MoveableManager2;
})(React597.PureComponent);
var Groupable = {
  name: "groupable",
  props: [
    "defaultGroupRotate",
    "useDefaultGroupRotate",
    "defaultGroupOrigin",
    "groupable",
    "groupableProps",
    "targetGroups",
    "hideChildMoveableDefaultLines"
  ],
  events: [],
  render: function(moveable, React615) {
    var _a;
    var props = moveable.props;
    var targets = props.targets || [];
    var _b = moveable.getState(), left2 = _b.left, top = _b.top, isPersisted = _b.isPersisted;
    var zoom = props.zoom || 1;
    var renderGroupRects = moveable.renderGroupRects;
    var persistDatChildren = ((_a = props.persistData) === null || _a === void 0 ? void 0 : _a.children) || [];
    if (isPersisted) {
      targets = persistDatChildren.map(function() {
        return null;
      });
    } else {
      persistDatChildren = [];
    }
    var parentPosition = watchValue(moveable, "parentPosition", [left2, top], function(styles) {
      return styles.join(",");
    });
    var requestStyles = watchValue(moveable, "requestStyles", moveable.getRequestChildStyles(), function(styles) {
      return styles.join(",");
    });
    moveable.moveables = moveable.moveables.slice(0, targets.length);
    return __spreadArray2(__spreadArray2([], __read2(targets.map(function(target, i) {
      return React615.createElement(MoveableManager, { key: "moveable" + i, ref: refs(moveable, "moveables", i), target, origin: false, requestStyles, cssStyled: props.cssStyled, customStyledMap: props.customStyledMap, useResizeObserver: props.useResizeObserver, useMutationObserver: props.useMutationObserver, hideChildMoveableDefaultLines: props.hideChildMoveableDefaultLines, parentMoveable: moveable, parentPosition: [left2, top], persistData: persistDatChildren[i], zoom });
    })), false), __read2(flat2(renderGroupRects.map(function(_a2, i) {
      var pos1 = _a2.pos1, pos2 = _a2.pos2, pos3 = _a2.pos3, pos4 = _a2.pos4;
      var poses = [pos1, pos2, pos3, pos4];
      return [
        [0, 1],
        [1, 3],
        [3, 2],
        [2, 0]
      ].map(function(_a3, j) {
        var _b2 = __read2(_a3, 2), from2 = _b2[0], to = _b2[1];
        return renderLine(React615, "", minus(poses[from2], parentPosition), minus(poses[to], parentPosition), zoom, "group-rect-".concat(i, "-").concat(j));
      });
    }))), false);
  }
};
var Clickable = makeAble("clickable", {
  props: [
    "clickable"
  ],
  events: [
    "click",
    "clickGroup"
  ],
  always: true,
  dragRelation: "weak",
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  dragStart: function() {
    return;
  },
  dragControlStart: function() {
    return;
  },
  dragGroupStart: function(moveable, e3) {
    e3.datas.inputTarget = e3.inputEvent && e3.inputEvent.target;
  },
  dragEnd: function(moveable, e3) {
    var target = moveable.props.target;
    var inputEvent = e3.inputEvent;
    var inputTarget = e3.inputTarget;
    var isMoveableElement = moveable.isMoveableElement(inputTarget);
    var containsElement = !isMoveableElement && moveable.controlBox.contains(inputTarget);
    if (!inputEvent || !inputTarget || e3.isDrag || moveable.isMoveableElement(inputTarget) || containsElement) {
      return;
    }
    var containsTarget = target.contains(inputTarget);
    triggerEvent(moveable, "onClick", fillParams(moveable, e3, {
      isDouble: e3.isDouble,
      inputTarget,
      isTarget: target === inputTarget,
      moveableTarget: moveable.props.target,
      containsTarget
    }));
  },
  dragGroupEnd: function(moveable, e3) {
    var inputEvent = e3.inputEvent;
    var inputTarget = e3.inputTarget;
    if (!inputEvent || !inputTarget || e3.isDrag || moveable.isMoveableElement(inputTarget) || e3.datas.inputTarget === inputTarget) {
      return;
    }
    var targets = moveable.props.targets;
    var targetIndex = targets.indexOf(inputTarget);
    var isTarget = targetIndex > -1;
    var containsTarget = false;
    if (targetIndex === -1) {
      targetIndex = findIndex(targets, function(parentTarget) {
        return parentTarget.contains(inputTarget);
      });
      containsTarget = targetIndex > -1;
    }
    triggerEvent(moveable, "onClickGroup", fillParams(moveable, e3, {
      isDouble: e3.isDouble,
      targets,
      inputTarget,
      targetIndex,
      isTarget,
      containsTarget,
      moveableTarget: targets[targetIndex]
    }));
  },
  dragControlEnd: function(moveable, e3) {
    this.dragEnd(moveable, e3);
  },
  dragGroupControlEnd: function(moveable, e3) {
    this.dragEnd(moveable, e3);
  }
});
function getDraggableEvent(e3) {
  var datas = e3.originalDatas.draggable;
  if (!datas) {
    e3.originalDatas.draggable = {};
    datas = e3.originalDatas.draggable;
  }
  return __assign9(__assign9({}, e3), { datas });
}
var edgeDraggable = makeAble("edgeDraggable", {
  css: [
    ".edge.edgeDraggable.line {\ncursor: move;\n}"
  ],
  render: function(moveable, React615) {
    var props = moveable.props;
    var edge = props.edgeDraggable;
    if (!edge) {
      return [];
    }
    return renderEdgeLines(React615, "edgeDraggable", edge, moveable.getState().renderPoses, props.zoom);
  },
  dragCondition: function(moveable, e3) {
    var _a;
    var props = moveable.props;
    var target = (_a = e3.inputEvent) === null || _a === void 0 ? void 0 : _a.target;
    if (!props.edgeDraggable || !target) {
      return false;
    }
    return !props.draggable && hasClass(target, prefix("direction")) && hasClass(target, prefix("edge")) && hasClass(target, prefix("edgeDraggable"));
  },
  dragStart: function(moveable, e3) {
    return Draggable2.dragStart(moveable, getDraggableEvent(e3));
  },
  drag: function(moveable, e3) {
    return Draggable2.drag(moveable, getDraggableEvent(e3));
  },
  dragEnd: function(moveable, e3) {
    return Draggable2.dragEnd(moveable, getDraggableEvent(e3));
  },
  dragGroupCondition: function(moveable, e3) {
    var _a;
    var props = moveable.props;
    var target = (_a = e3.inputEvent) === null || _a === void 0 ? void 0 : _a.target;
    if (!props.edgeDraggable || !target) {
      return false;
    }
    return !props.draggable && hasClass(target, prefix("direction")) && hasClass(target, prefix("line"));
  },
  dragGroupStart: function(moveable, e3) {
    return Draggable2.dragGroupStart(moveable, getDraggableEvent(e3));
  },
  dragGroup: function(moveable, e3) {
    return Draggable2.dragGroup(moveable, getDraggableEvent(e3));
  },
  dragGroupEnd: function(moveable, e3) {
    return Draggable2.dragGroupEnd(moveable, getDraggableEvent(e3));
  },
  unset: function(moveable) {
    return Draggable2.unset(moveable);
  }
});
var IndividualGroupable = {
  name: "individualGroupable",
  props: [
    "individualGroupable",
    "individualGroupableProps"
  ],
  events: []
};
var MOVEABLE_ABLES = [
  BeforeRenderable,
  Default,
  Snappable,
  Pinchable,
  Draggable2,
  edgeDraggable,
  Resizable,
  Scalable,
  Warpable,
  Rotatable,
  Scrollable,
  Padding,
  Origin,
  OriginDraggable,
  Clippable,
  Roundable,
  Groupable,
  IndividualGroupable,
  Clickable,
  DragArea,
  Renderable
];
function solveConstantsDistance(_a, pos) {
  var _b = __read2(_a, 3), a = _b[0], b = _b[1], c = _b[2];
  return (a * pos[0] + b * pos[1] + c) / Math.sqrt(a * a + b * b);
}
function solveC(_a, pos) {
  var _b = __read2(_a, 2), a = _b[0], b = _b[1];
  return -a * pos[0] - b * pos[1];
}
function getMaxPos(poses, index3) {
  return Math.max.apply(Math, __spreadArray2([], __read2(poses.map(function(_a) {
    var _b = __read2(_a, 4), pos1 = _b[0], pos2 = _b[1], pos3 = _b[2], pos4 = _b[3];
    return Math.max(pos1[index3], pos2[index3], pos3[index3], pos4[index3]);
  })), false));
}
function getMinPos(poses, index3) {
  return Math.min.apply(Math, __spreadArray2([], __read2(poses.map(function(_a) {
    var _b = __read2(_a, 4), pos1 = _b[0], pos2 = _b[1], pos3 = _b[2], pos4 = _b[3];
    return Math.min(pos1[index3], pos2[index3], pos3[index3], pos4[index3]);
  })), false));
}
function getGroupRect(parentPoses, rotation) {
  var _a, _b, _c;
  var pos1 = [0, 0];
  var pos2 = [0, 0];
  var pos3 = [0, 0];
  var pos4 = [0, 0];
  var width = 0;
  var height = 0;
  if (!parentPoses.length) {
    return {
      pos1,
      pos2,
      pos3,
      pos4,
      minX: 0,
      minY: 0,
      maxX: 0,
      maxY: 0,
      width,
      height,
      rotation
    };
  }
  var fixedRotation = throttle3(rotation, TINY_NUM2);
  if (fixedRotation % 90) {
    var rad = fixedRotation / 180 * Math.PI;
    var a1_1 = Math.tan(rad);
    var a2_1 = -1 / a1_1;
    var a1MinMax_1 = [MAX_NUM, MIN_NUM];
    var a1MinMaxPos_1 = [[0, 0], [0, 0]];
    var a2MinMax_1 = [MAX_NUM, MIN_NUM];
    var a2MinMaxPos_1 = [[0, 0], [0, 0]];
    parentPoses.forEach(function(poses) {
      poses.forEach(function(pos) {
        var a1Dist = solveConstantsDistance([-a1_1, 1, 0], pos);
        var a2Dist = solveConstantsDistance([-a2_1, 1, 0], pos);
        if (a1MinMax_1[0] > a1Dist) {
          a1MinMaxPos_1[0] = pos;
          a1MinMax_1[0] = a1Dist;
        }
        if (a1MinMax_1[1] < a1Dist) {
          a1MinMaxPos_1[1] = pos;
          a1MinMax_1[1] = a1Dist;
        }
        if (a2MinMax_1[0] > a2Dist) {
          a2MinMaxPos_1[0] = pos;
          a2MinMax_1[0] = a2Dist;
        }
        if (a2MinMax_1[1] < a2Dist) {
          a2MinMaxPos_1[1] = pos;
          a2MinMax_1[1] = a2Dist;
        }
      });
    });
    var _d = __read2(a1MinMaxPos_1, 2), a1MinPos = _d[0], a1MaxPos = _d[1];
    var _e = __read2(a2MinMaxPos_1, 2), a2MinPos = _e[0], a2MaxPos = _e[1];
    var minHorizontalLine = [-a1_1, 1, solveC([-a1_1, 1], a1MinPos)];
    var maxHorizontalLine = [-a1_1, 1, solveC([-a1_1, 1], a1MaxPos)];
    var minVerticalLine = [-a2_1, 1, solveC([-a2_1, 1], a2MinPos)];
    var maxVerticalLine = [-a2_1, 1, solveC([-a2_1, 1], a2MaxPos)];
    _a = __read2([
      [minHorizontalLine, minVerticalLine],
      [minHorizontalLine, maxVerticalLine],
      [maxHorizontalLine, minVerticalLine],
      [maxHorizontalLine, maxVerticalLine]
    ].map(function(_a2) {
      var _b2 = __read2(_a2, 2), line1 = _b2[0], line2 = _b2[1];
      return getIntersectionPointsByConstants(line1, line2)[0];
    }), 4), pos1 = _a[0], pos2 = _a[1], pos3 = _a[2], pos4 = _a[3];
    width = a2MinMax_1[1] - a2MinMax_1[0];
    height = a1MinMax_1[1] - a1MinMax_1[0];
  } else {
    var minX_1 = getMinPos(parentPoses, 0);
    var minY_1 = getMinPos(parentPoses, 1);
    var maxX_1 = getMaxPos(parentPoses, 0);
    var maxY_1 = getMaxPos(parentPoses, 1);
    pos1 = [minX_1, minY_1];
    pos2 = [maxX_1, minY_1];
    pos3 = [minX_1, maxY_1];
    pos4 = [maxX_1, maxY_1];
    width = maxX_1 - minX_1;
    height = maxY_1 - minY_1;
    if (fixedRotation % 180) {
      var changedX = [pos3, pos1, pos4, pos2];
      _b = __read2(changedX, 4), pos1 = _b[0], pos2 = _b[1], pos3 = _b[2], pos4 = _b[3];
      width = maxY_1 - minY_1;
      height = maxX_1 - minX_1;
    }
  }
  if (fixedRotation % 360 > 180) {
    var changedX = [pos4, pos3, pos2, pos1];
    _c = __read2(changedX, 4), pos1 = _c[0], pos2 = _c[1], pos3 = _c[2], pos4 = _c[3];
  }
  var _f = getMinMaxs([pos1, pos2, pos3, pos4]), minX = _f.minX, minY = _f.minY, maxX = _f.maxX, maxY = _f.maxY;
  return {
    pos1,
    pos2,
    pos3,
    pos4,
    width,
    height,
    minX,
    minY,
    maxX,
    maxY,
    rotation
  };
}
function findMoveableGroups(moveables, childTargetGroups) {
  var groups = childTargetGroups.map(function(targetGroup) {
    if (isArray5(targetGroup)) {
      var childMoveableGroups = findMoveableGroups(moveables, targetGroup);
      var length_1 = childMoveableGroups.length;
      if (length_1 > 1) {
        return childMoveableGroups;
      } else if (length_1 === 1) {
        return childMoveableGroups[0];
      } else {
        return null;
      }
    } else {
      var checked = find(moveables, function(_a) {
        var manager = _a.manager;
        return manager.props.target === targetGroup;
      });
      if (checked) {
        checked.finded = true;
        return checked.manager;
      }
      return null;
    }
  }).filter(Boolean);
  if (groups.length === 1 && isArray5(groups[0])) {
    return groups[0];
  }
  return groups;
}
var MoveableGroup = /* @__PURE__ */ (function(_super) {
  __extends7(MoveableGroup2, _super);
  function MoveableGroup2() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.differ = new children_differ_esm_default();
    _this.moveables = [];
    _this.transformOrigin = "50% 50%";
    _this.renderGroupRects = [];
    _this._targetGroups = [];
    _this._hasFirstTargets = false;
    return _this;
  }
  MoveableGroup2.prototype.componentDidMount = function() {
    _super.prototype.componentDidMount.call(this);
  };
  MoveableGroup2.prototype.checkUpdate = function() {
    this._isPropTargetChanged = false;
    this.updateAbles();
  };
  MoveableGroup2.prototype.getTargets = function() {
    return this.props.targets;
  };
  MoveableGroup2.prototype.updateRect = function(type5, isTarget, isSetState) {
    var _a;
    if (isSetState === void 0) {
      isSetState = true;
    }
    var state = this.state;
    if (!this.controlBox || state.isPersisted) {
      return;
    }
    setStoreCache(true);
    this.moveables.forEach(function(moveable) {
      moveable.updateRect(type5, false, false);
    });
    var props = this.props;
    var moveables = this.moveables;
    var target = state.target || props.target;
    var checkeds = moveables.map(function(moveable) {
      return { finded: false, manager: moveable };
    });
    var targetGroups = this.props.targetGroups || [];
    var moveableGroups = findMoveableGroups(checkeds, targetGroups);
    var useDefaultGroupRotate = props.useDefaultGroupRotate;
    moveableGroups.push.apply(moveableGroups, __spreadArray2([], __read2(checkeds.filter(function(_a2) {
      var finded = _a2.finded;
      return !finded;
    }).map(function(_a2) {
      var manager = _a2.manager;
      return manager;
    })), false));
    var renderGroupRects = [];
    var isReset = !isTarget || type5 !== "" && props.updateGroup;
    var defaultGroupRotate = props.defaultGroupRotate || 0;
    if (!this._hasFirstTargets) {
      var persistedRoatation = (_a = props.persistData) === null || _a === void 0 ? void 0 : _a.rotation;
      if (persistedRoatation != null) {
        defaultGroupRotate = persistedRoatation;
      }
    }
    function getMoveableGroupRect(group, parentRotation, isRoot) {
      var posesRotations = group.map(function(moveable) {
        if (isArray5(moveable)) {
          var rect = getMoveableGroupRect(moveable, parentRotation);
          var poses = [rect.pos1, rect.pos2, rect.pos3, rect.pos4];
          renderGroupRects.push(rect);
          return { poses, rotation: rect.rotation };
        } else {
          return {
            poses: getAbsolutePosesByState(moveable.state),
            rotation: moveable.getRotation()
          };
        }
      });
      var rotations = posesRotations.map(function(_a2) {
        var rotation2 = _a2.rotation;
        return rotation2;
      });
      var groupRotation = 0;
      var firstRotation = rotations[0];
      var isSameRotation = rotations.every(function(nextRotation) {
        return Math.abs(firstRotation - nextRotation) < 0.1;
      });
      if (isReset) {
        groupRotation = !useDefaultGroupRotate && isSameRotation ? firstRotation : defaultGroupRotate;
      } else {
        groupRotation = !useDefaultGroupRotate && !isRoot && isSameRotation ? firstRotation : parentRotation;
      }
      var groupPoses = posesRotations.map(function(_a2) {
        var poses = _a2.poses;
        return poses;
      });
      var groupRect = getGroupRect(groupPoses, groupRotation);
      return groupRect;
    }
    var rootGroupRect = getMoveableGroupRect(moveableGroups, this.rotation, true);
    if (isReset) {
      this.rotation = rootGroupRect.rotation;
      this.transformOrigin = props.defaultGroupOrigin || "50% 50%";
      this.scale = [1, 1];
    }
    this._targetGroups = targetGroups;
    this.renderGroupRects = renderGroupRects;
    var transformOrigin = this.transformOrigin;
    var rotation = this.rotation;
    var scale = this.scale;
    var width = rootGroupRect.width, height = rootGroupRect.height, minX = rootGroupRect.minX, minY = rootGroupRect.minY;
    var posesInfo = rotatePosesInfo([
      [0, 0],
      [width, 0],
      [0, height],
      [width, height]
    ], convertTransformOriginArray(transformOrigin, width, height), this.rotation / 180 * Math.PI);
    var _b = getMinMaxs(posesInfo.result), deltaX = _b.minX, deltaY = _b.minY;
    var rotateScale = " rotate(".concat(rotation, "deg)") + " scale(".concat(sign(scale[0]), ", ").concat(sign(scale[1]), ")");
    var transform = "translate(".concat(-deltaX, "px, ").concat(-deltaY, "px)").concat(rotateScale);
    this.controlBox.style.transform = "translate3d(".concat(minX, "px, ").concat(minY, "px, ").concat(this.props.translateZ || 0, ")");
    target.style.cssText += "left:0px;top:0px;" + "transform-origin:".concat(transformOrigin, ";") + "width:".concat(width, "px;height:").concat(height, "px;") + "transform: ".concat(transform);
    state.width = width;
    state.height = height;
    var container = this.getContainer();
    var info = getMoveableTargetInfo(this.controlBox, target, this.controlBox, this.getContainer(), this._rootContainer || container, []);
    var pos = [info.left, info.top];
    var _c = __read2(getAbsolutePosesByState(info), 4), pos1 = _c[0], pos2 = _c[1], pos3 = _c[2], pos4 = _c[3];
    var minPos = getMinMaxs([pos1, pos2, pos3, pos4]);
    var delta = [minPos.minX, minPos.minY];
    var direction = sign(scale[0] * scale[1]);
    info.pos1 = minus(pos1, delta);
    info.pos2 = minus(pos2, delta);
    info.pos3 = minus(pos3, delta);
    info.pos4 = minus(pos4, delta);
    info.left = minX - info.left + delta[0];
    info.top = minY - info.top + delta[1];
    info.origin = minus(plus(pos, info.origin), delta);
    info.beforeOrigin = minus(plus(pos, info.beforeOrigin), delta);
    info.originalBeforeOrigin = plus(pos, info.originalBeforeOrigin);
    info.transformOrigin = minus(plus(pos, info.transformOrigin), delta);
    target.style.transform = "translate(".concat(-deltaX - delta[0], "px, ").concat(-deltaY - delta[1], "px)") + rotateScale;
    setStoreCache();
    this.updateState(__assign9(__assign9({}, info), { posDelta: delta, direction, beforeDirection: direction }), isSetState);
  };
  MoveableGroup2.prototype.getRect = function() {
    return __assign9(__assign9({}, _super.prototype.getRect.call(this)), { children: this.moveables.map(function(child) {
      return child.getRect();
    }) });
  };
  MoveableGroup2.prototype.triggerEvent = function(name, e3, isManager) {
    if (isManager || name.indexOf("Group") > -1) {
      return _super.prototype.triggerEvent.call(this, name, e3);
    } else {
      this._emitter.trigger(name, e3);
    }
  };
  MoveableGroup2.prototype.getRequestChildStyles = function() {
    var styleNames = this.getEnabledAbles().reduce(function(names2, able) {
      var _a, _b;
      var ableStyleNames = (_b = (_a = able.requestChildStyle) === null || _a === void 0 ? void 0 : _a.call(able)) !== null && _b !== void 0 ? _b : [];
      return __spreadArray2(__spreadArray2([], __read2(names2), false), __read2(ableStyleNames), false);
    }, []);
    return styleNames;
  };
  MoveableGroup2.prototype.getMoveables = function() {
    return __spreadArray2([], __read2(this.moveables), false);
  };
  MoveableGroup2.prototype.updateAbles = function() {
    _super.prototype.updateAbles.call(this, __spreadArray2(__spreadArray2([], __read2(this.props.ables), false), [Groupable], false), "Group");
  };
  MoveableGroup2.prototype._updateTargets = function() {
    _super.prototype._updateTargets.call(this);
    this._originalDragTarget = this.props.dragTarget || this.areaElement;
    this._dragTarget = getRefTarget(this._originalDragTarget, true);
  };
  MoveableGroup2.prototype._updateEvents = function() {
    var state = this.state;
    var props = this.props;
    var prevTarget = this._prevDragTarget;
    var nextTarget = props.dragTarget || this.areaElement;
    var targets = props.targets;
    var _a = this.differ.update(targets), added = _a.added, changed = _a.changed, removed = _a.removed;
    var isTargetChanged = added.length || removed.length;
    if (isTargetChanged || this._prevOriginalDragTarget !== this._originalDragTarget) {
      unsetGesto(this, false);
      unsetGesto(this, true);
      this.updateState({ gestos: {} });
    }
    if (prevTarget !== nextTarget) {
      state.target = null;
    }
    if (!state.target) {
      state.target = this.areaElement;
      this.controlBox.style.display = "block";
    }
    if (state.target) {
      if (!this.targetGesto) {
        this.targetGesto = getTargetAbleGesto(this, this._dragTarget, "Group");
      }
      if (!this.controlGesto) {
        this.controlGesto = getControlAbleGesto(this, "GroupControl");
      }
    }
    var isContainerChanged = !equals(state.container, props.container);
    if (isContainerChanged) {
      state.container = props.container;
    }
    if (isContainerChanged || isTargetChanged || this.transformOrigin !== (props.defaultGroupOrigin || "50% 50%") || changed.length || targets.length && !isDeepArrayEquals(this._targetGroups, props.targetGroups || [])) {
      this.updateRect();
      this._hasFirstTargets = true;
    }
    this._isPropTargetChanged = !!isTargetChanged;
  };
  MoveableGroup2.prototype._updateObserver = function() {
  };
  MoveableGroup2.defaultProps = __assign9(__assign9({}, MoveableManager.defaultProps), { transformOrigin: ["50%", "50%"], groupable: true, dragArea: true, keepRatio: true, targets: [], defaultGroupRotate: 0, defaultGroupOrigin: "50% 50%" });
  return MoveableGroup2;
})(MoveableManager);
var MoveableIndividualGroup = /* @__PURE__ */ (function(_super) {
  __extends7(MoveableIndividualGroup2, _super);
  function MoveableIndividualGroup2() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.moveables = [];
    return _this;
  }
  MoveableIndividualGroup2.prototype.render = function() {
    var _this = this;
    var _a;
    var props = this.props;
    var cspNonce = props.cspNonce, ControlBoxElement = props.cssStyled, persistData = props.persistData;
    var targets = props.targets || [];
    var length2 = targets.length;
    var canPersist = this.isUnmounted || !length2;
    var persistDatChildren = (_a = persistData === null || persistData === void 0 ? void 0 : persistData.children) !== null && _a !== void 0 ? _a : [];
    if (canPersist && !length2 && persistDatChildren.length) {
      targets = persistDatChildren.map(function() {
        return null;
      });
    } else if (!canPersist) {
      persistDatChildren = [];
    }
    return React597.createElement(ControlBoxElement, { cspNonce, ref: ref2(this, "controlBox"), className: prefix("control-box") }, targets.map(function(target, i) {
      var _a2, _b;
      var individualProps = (_b = (_a2 = props.individualGroupableProps) === null || _a2 === void 0 ? void 0 : _a2.call(props, target, i)) !== null && _b !== void 0 ? _b : {};
      return React597.createElement(MoveableManager, __assign9({ key: "moveable" + i, ref: refs(_this, "moveables", i) }, props, individualProps, { target, wrapperMoveable: _this, isWrapperMounted: _this.isMoveableMounted, persistData: persistDatChildren[i] }));
    }));
  };
  MoveableIndividualGroup2.prototype.componentDidMount = function() {
  };
  MoveableIndividualGroup2.prototype.componentDidUpdate = function() {
  };
  MoveableIndividualGroup2.prototype.getTargets = function() {
    return this.props.targets;
  };
  MoveableIndividualGroup2.prototype.updateRect = function(type5, isTarget, isSetState) {
    if (isSetState === void 0) {
      isSetState = true;
    }
    setStoreCache(true);
    this.moveables.forEach(function(moveable) {
      moveable.updateRect(type5, isTarget, isSetState);
    });
    setStoreCache();
  };
  MoveableIndividualGroup2.prototype.getRect = function() {
    return __assign9(__assign9({}, _super.prototype.getRect.call(this)), { children: this.moveables.map(function(child) {
      return child.getRect();
    }) });
  };
  MoveableIndividualGroup2.prototype.request = function(ableName, param, isInstant) {
    if (param === void 0) {
      param = {};
    }
    var results = this.moveables.map(function(m) {
      return m.request(ableName, __assign9(__assign9({}, param), { isInstant: false }), false);
    });
    var requestInstant = isInstant || param.isInstant;
    var requester = {
      request: function(ableParam) {
        results.forEach(function(r2) {
          return r2.request(ableParam);
        });
        return this;
      },
      requestEnd: function() {
        results.forEach(function(r2) {
          return r2.requestEnd();
        });
        return this;
      }
    };
    return requestInstant ? requester.request(param).requestEnd() : requester;
  };
  MoveableIndividualGroup2.prototype.dragStart = function(e3, target) {
    if (target === void 0) {
      target = e3.target;
    }
    var inputTarget = target;
    var childMoveable = find(this.moveables, function(child) {
      var target2 = child.getTargets()[0];
      var controlBoxElement = child.getControlBoxElement();
      var dragElement = child.getDragElement();
      if (!target2 || !dragElement) {
        return false;
      }
      return dragElement === inputTarget || dragElement.contains(inputTarget) || (dragElement !== target2 && target2 === inputTarget || target2.contains(inputTarget)) || controlBoxElement === inputTarget || controlBoxElement.contains(inputTarget);
    });
    if (childMoveable) {
      childMoveable.dragStart(e3, target);
    }
    return this;
  };
  MoveableIndividualGroup2.prototype.hitTest = function() {
    return 0;
  };
  MoveableIndividualGroup2.prototype.isInside = function() {
    return false;
  };
  MoveableIndividualGroup2.prototype.isDragging = function() {
    return false;
  };
  MoveableIndividualGroup2.prototype.getDragElement = function() {
    return null;
  };
  MoveableIndividualGroup2.prototype.getMoveables = function() {
    return __spreadArray2([], __read2(this.moveables), false);
  };
  MoveableIndividualGroup2.prototype.updateRenderPoses = function() {
  };
  MoveableIndividualGroup2.prototype.checkUpdate = function() {
  };
  MoveableIndividualGroup2.prototype.triggerEvent = function() {
  };
  MoveableIndividualGroup2.prototype.updateAbles = function() {
  };
  MoveableIndividualGroup2.prototype._updateEvents = function() {
  };
  MoveableIndividualGroup2.prototype._updateObserver = function() {
  };
  return MoveableIndividualGroup2;
})(MoveableManager);
function getElementTargets(refTargets, selectorMap) {
  var elementTargets = [];
  refTargets.forEach(function(target) {
    if (!target) {
      return;
    }
    if (isString2(target)) {
      if (selectorMap[target]) {
        elementTargets.push.apply(elementTargets, __spreadArray2([], __read2(selectorMap[target]), false));
      }
      return;
    }
    if (isArray5(target)) {
      elementTargets.push.apply(elementTargets, __spreadArray2([], __read2(getElementTargets(target, selectorMap)), false));
    } else {
      elementTargets.push(target);
    }
  });
  return elementTargets;
}
function getTargetGroups(refTargets, selectorMap) {
  var targetGroups = [];
  refTargets.forEach(function(target) {
    if (!target) {
      return;
    }
    if (isString2(target)) {
      if (selectorMap[target]) {
        targetGroups.push.apply(targetGroups, __spreadArray2([], __read2(selectorMap[target]), false));
      }
      return;
    }
    if (isArray5(target)) {
      targetGroups.push(getTargetGroups(target, selectorMap));
    } else {
      targetGroups.push(target);
    }
  });
  return targetGroups;
}
function compareRefTargets(prevRefTargets, nextRefTargets) {
  return prevRefTargets.length !== nextRefTargets.length || prevRefTargets.some(function(target, i) {
    var nextTarget = nextRefTargets[i];
    if (!target && !nextTarget) {
      return false;
    } else if (target != nextTarget) {
      if (isArray5(target) && isArray5(nextTarget)) {
        return compareRefTargets(target, nextTarget);
      }
      return true;
    }
    return false;
  });
}
var InitialMoveable = /* @__PURE__ */ (function(_super) {
  __extends7(InitialMoveable2, _super);
  function InitialMoveable2() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.refTargets = [];
    _this.selectorMap = {};
    _this._differ = new children_differ_esm_default();
    _this._elementTargets = [];
    _this._tmpRefTargets = [];
    _this._tmpSelectorMap = {};
    _this._onChangeTargets = null;
    return _this;
  }
  InitialMoveable2.makeStyled = function() {
    var cssMap = {};
    var ables = this.getTotalAbles();
    ables.forEach(function(_a) {
      var css2 = _a.css;
      if (!css2) {
        return;
      }
      css2.forEach(function(text) {
        cssMap[text] = true;
      });
    });
    var style2 = getKeys2(cssMap).join("\n");
    this.defaultStyled = styled2("div", prefixCSS(PREFIX, MOVEABLE_CSS + style2));
  };
  InitialMoveable2.getTotalAbles = function() {
    return __spreadArray2([Default, Groupable, IndividualGroupable, DragArea], __read2(this.defaultAbles), false);
  };
  InitialMoveable2.prototype.render = function() {
    var _a;
    var moveableContructor = this.constructor;
    if (!moveableContructor.defaultStyled) {
      moveableContructor.makeStyled();
    }
    var _b = this.props, userAbles = _b.ables, userProps = _b.props, props = __rest73(_b, ["ables", "props"]);
    var _c = __read2(this._updateRefs(true), 2), refTargets = _c[0], nextSelectorMap = _c[1];
    var elementTargets = getElementTargets(refTargets, nextSelectorMap);
    var isGroup = elementTargets.length > 1;
    var totalAbles = moveableContructor.getTotalAbles();
    var ables = __spreadArray2(__spreadArray2([], __read2(totalAbles), false), __read2(userAbles || []), false);
    var nextProps = __assign9(__assign9(__assign9({}, props), userProps || {}), { ables, cssStyled: moveableContructor.defaultStyled, customStyledMap: moveableContructor.customStyledMap });
    this._elementTargets = elementTargets;
    var firstRenderState = null;
    var prevMoveable = this.moveable;
    var persistData = props.persistData;
    if (persistData === null || persistData === void 0 ? void 0 : persistData.children) {
      isGroup = true;
    }
    if (props.individualGroupable) {
      return React597.createElement(MoveableIndividualGroup, __assign9({ key: "individual-group", ref: ref2(this, "moveable") }, nextProps, { target: null, targets: elementTargets }));
    }
    if (isGroup) {
      var targetGroups = getTargetGroups(refTargets, nextSelectorMap);
      if (prevMoveable && !prevMoveable.props.groupable && !prevMoveable.props.individualGroupable) {
        var target = prevMoveable.props.target;
        if (target && elementTargets.indexOf(target) > -1) {
          firstRenderState = __assign9({}, prevMoveable.state);
        }
      }
      return React597.createElement(MoveableGroup, __assign9({ key: "group", ref: ref2(this, "moveable") }, nextProps, (_a = props.groupableProps) !== null && _a !== void 0 ? _a : {}, { target: null, targets: elementTargets, targetGroups, firstRenderState }));
    } else {
      var target_1 = elementTargets[0];
      if (prevMoveable && (prevMoveable.props.groupable || prevMoveable.props.individualGroupable)) {
        var moveables = prevMoveable.moveables || [];
        var prevTargetMoveable = find(moveables, function(mv) {
          return mv.props.target === target_1;
        });
        if (prevTargetMoveable) {
          firstRenderState = __assign9({}, prevTargetMoveable.state);
        }
      }
      return React597.createElement(MoveableManager, __assign9({ key: "single", ref: ref2(this, "moveable") }, nextProps, { target: target_1, firstRenderState }));
    }
  };
  InitialMoveable2.prototype.componentDidMount = function() {
    this._checkChangeTargets();
  };
  InitialMoveable2.prototype.componentDidUpdate = function() {
    this._checkChangeTargets();
  };
  InitialMoveable2.prototype.componentWillUnmount = function() {
    this.selectorMap = {};
    this.refTargets = [];
  };
  InitialMoveable2.prototype.getTargets = function() {
    var _a, _b;
    return (_b = (_a = this.moveable) === null || _a === void 0 ? void 0 : _a.getTargets()) !== null && _b !== void 0 ? _b : [];
  };
  InitialMoveable2.prototype.updateSelectors = function() {
    this.selectorMap = {};
    this._updateRefs();
    this.forceUpdate();
  };
  InitialMoveable2.prototype.waitToChangeTarget = function() {
    var _this = this;
    var resolvePromise;
    this._onChangeTargets = function() {
      _this._onChangeTargets = null;
      resolvePromise();
    };
    return new Promise(function(resolve) {
      resolvePromise = resolve;
    });
  };
  InitialMoveable2.prototype.waitToChangeTargets = function() {
    return this.waitToChangeTarget();
  };
  InitialMoveable2.prototype.getManager = function() {
    return this.moveable;
  };
  InitialMoveable2.prototype.getMoveables = function() {
    return this.moveable.getMoveables();
  };
  InitialMoveable2.prototype.getDragElement = function() {
    return this.moveable.getDragElement();
  };
  InitialMoveable2.prototype._updateRefs = function(isRender) {
    var prevRefTargets = this.refTargets;
    var nextRefTargets = getRefTargets(this.props.target || this.props.targets);
    var isBrowser2 = typeof document !== "undefined";
    var isUpdate = compareRefTargets(prevRefTargets, nextRefTargets);
    var selectorMap = this.selectorMap;
    var nextSelectorMap = {};
    this.refTargets.forEach(function updateSelectorMap(target) {
      if (isString2(target)) {
        var selectorTarget = selectorMap[target];
        if (selectorTarget) {
          nextSelectorMap[target] = selectorMap[target];
        } else if (isBrowser2) {
          isUpdate = true;
          nextSelectorMap[target] = [].slice.call(document.querySelectorAll(target));
        }
      } else if (isArray5(target)) {
        target.forEach(updateSelectorMap);
      }
    });
    this._tmpRefTargets = nextRefTargets;
    this._tmpSelectorMap = nextSelectorMap;
    return [
      nextRefTargets,
      nextSelectorMap,
      !isRender && isUpdate
    ];
  };
  InitialMoveable2.prototype._checkChangeTargets = function() {
    var _a, _b, _c;
    this.refTargets = this._tmpRefTargets;
    this.selectorMap = this._tmpSelectorMap;
    var _d = this._differ.update(this._elementTargets), added = _d.added, removed = _d.removed;
    var isTargetChanged = added.length || removed.length;
    if (isTargetChanged) {
      (_b = (_a = this.props).onChangeTargets) === null || _b === void 0 ? void 0 : _b.call(_a, {
        moveable: this.moveable,
        targets: this._elementTargets
      });
      (_c = this._onChangeTargets) === null || _c === void 0 ? void 0 : _c.call(this);
    }
    var _e = __read2(this._updateRefs(), 3), refTargets = _e[0], selectorMap = _e[1], isUpdate = _e[2];
    this.refTargets = refTargets;
    this.selectorMap = selectorMap;
    if (isUpdate) {
      this.forceUpdate();
    }
  };
  InitialMoveable2.defaultAbles = [];
  InitialMoveable2.customStyledMap = {};
  InitialMoveable2.defaultStyled = null;
  __decorate4([
    withMethods(MOVEABLE_METHODS)
  ], InitialMoveable2.prototype, "moveable", void 0);
  return InitialMoveable2;
})(React597.PureComponent);
var Moveable = /* @__PURE__ */ (function(_super) {
  __extends7(Moveable3, _super);
  function Moveable3() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Moveable3.defaultAbles = MOVEABLE_ABLES;
  return Moveable3;
})(InitialMoveable);

// src/components/Designer/Canvas/Moveable.tsx
var baseClassName = "pdfme-moveable";
var Moveable2 = (props, ref3) => {
  const { token: token2 } = theme_default3.useToken();
  const instanceId = (0, import_react234.useRef)(uuid());
  const uniqueClassName = `${baseClassName}-${instanceId.current}`;
  (0, import_react234.useEffect)(() => {
    const containerElement = document.querySelector(`.${uniqueClassName}`);
    const moveableLines = document.querySelectorAll(`.${uniqueClassName} .moveable-line`);
    if (containerElement instanceof HTMLElement) {
      containerElement.style.setProperty("--moveable-color", token2.colorPrimary);
      moveableLines.forEach((e3) => {
        if (e3 instanceof HTMLElement) {
          e3.style.setProperty("--moveable-color", token2.colorPrimary);
        }
      });
    }
  }, [props.target, token2.colorPrimary, uniqueClassName]);
  return /* @__PURE__ */ import_react234.default.createElement(
    Moveable,
    {
      className: uniqueClassName,
      rootContainer: document ? document.body : void 0,
      snappable: true,
      draggable: true,
      rotatable: props.rotatable,
      resizable: true,
      throttleDrag: 1,
      throttleRotate: 1,
      throttleResize: 1,
      ref: ref3,
      target: props.target,
      bounds: props.bounds,
      horizontalGuidelines: props.horizontalGuidelines,
      verticalGuidelines: props.verticalGuidelines,
      keepRatio: props.keepRatio,
      onRotate: props.onRotate,
      onRotateEnd: props.onRotateEnd,
      onRotateGroup: ({ events: events2 }) => {
        events2.forEach(props.onRotate);
      },
      onRotateGroupEnd: props.onRotateGroupEnd,
      onDrag: props.onDrag,
      onDragGroup: ({ events: events2 }) => {
        events2.forEach(props.onDrag);
      },
      onDragEnd: props.onDragEnd,
      onDragGroupEnd: props.onDragGroupEnd,
      onResize: props.onResize,
      onResizeGroup: ({ events: events2 }) => {
        events2.forEach(props.onResize);
      },
      onResizeEnd: props.onResizeEnd,
      onResizeGroupEnd: props.onResizeGroupEnd,
      onClick: props.onClick
    }
  );
};
var Moveable_default = (0, import_react234.forwardRef)(Moveable2);

// src/components/Designer/Canvas/Guides.tsx
var import_react237 = __toESM(require_react());

// ../../node_modules/@scena/react-guides/dist/guides.esm.js
var import_react236 = __toESM(require_react());

// ../../node_modules/@scena/react-ruler/dist/ruler.esm.js
var import_react235 = __toESM(require_react());
var extendStatics8 = function(d, b) {
  extendStatics8 = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function(d2, b2) {
    d2.__proto__ = b2;
  } || function(d2, b2) {
    for (var p in b2) if (Object.prototype.hasOwnProperty.call(b2, p)) d2[p] = b2[p];
  };
  return extendStatics8(d, b);
};
function __extends8(d, b) {
  if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  extendStatics8(d, b);
  function __() {
    this.constructor = d;
  }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var Ruler = /* @__PURE__ */ (function(_super) {
  __extends8(Ruler2, _super);
  function Ruler2() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.state = {
      scrollPos: 0
    };
    _this.width = 0;
    _this.height = 0;
    _this._zoom = 0;
    _this._rulerScale = 0;
    _this._observer = null;
    _this._checkResize = function() {
      _this.resize();
    };
    return _this;
  }
  var __proto = Ruler2.prototype;
  __proto.render = function() {
    var props = this.props;
    this._zoom = props.zoom;
    return (0, import_react235.createElement)("canvas", {
      ref: ref2(this, "canvasElement"),
      style: this.props.style
    });
  };
  __proto.componentDidMount = function() {
    var props = this.props;
    this.state.scrollPos = props.defaultScrollPos || 0;
    var canvas = this.canvasElement;
    var context = canvas.getContext("2d", {
      alpha: true
    });
    this.canvasContext = context;
    if (props.useResizeObserver) {
      this._observer = new ResizeObserver(this._checkResize);
      this._observer.observe(canvas, {
        box: "border-box"
      });
    } else {
      this.resize();
    }
  };
  __proto.componentDidUpdate = function() {
    this.resize();
  };
  __proto.componentWillUnmount = function() {
    var _a;
    this.state.scrollPos = 0;
    (_a = this._observer) === null || _a === void 0 ? void 0 : _a.disconnect();
  };
  __proto.getScrollPos = function() {
    return this.state.scrollPos;
  };
  __proto.scroll = function(scrollPos, zoom) {
    this.draw({
      scrollPos,
      zoom
    });
  };
  __proto.resize = function(nextZoom) {
    var canvas = this.canvasElement;
    var _a = this.props, width = _a.width, height = _a.height, scrollPos = _a.scrollPos;
    var rulerScale = this._getRulerScale();
    this.width = width || canvas.offsetWidth;
    this.height = height || canvas.offsetHeight;
    canvas.width = this.width * rulerScale;
    canvas.height = this.height * rulerScale;
    this.draw({
      scrollPos,
      zoom: nextZoom
    });
  };
  __proto.draw = function(options) {
    if (options === void 0) {
      options = {};
    }
    var props = this.props;
    var _a = options.zoom, nextZoom = _a === void 0 ? this._zoom : _a, _b = options.scrollPos, scrollPos = _b === void 0 ? this.state.scrollPos : _b, _c = options.marks, marks = _c === void 0 ? props.marks : _c, _d = options.selectedRanges, selectedRanges = _d === void 0 ? props.selectedRanges : _d, _e = options.segment, segment = _e === void 0 ? props.segment || 10 : _e, _f = options.unit, unit3 = _f === void 0 ? props.unit : _f;
    this._zoom = nextZoom;
    var _g = props, type5 = _g.type, backgroundColor = _g.backgroundColor, lineColor = _g.lineColor, textColor = _g.textColor, textBackgroundColor = _g.textBackgroundColor, direction = _g.direction, _h = _g.negativeRuler, negativeRuler = _h === void 0 ? true : _h, textFormat = _g.textFormat, _j = _g.range, range3 = _j === void 0 ? [-Infinity, Infinity] : _j, rangeBackgroundColor = _g.rangeBackgroundColor, selectedBackgroundColor = _g.selectedBackgroundColor, _k = _g.lineWidth, lineWidth = _k === void 0 ? 1 : _k, selectedRangesText = _g.selectedRangesText, _l = _g.selectedRangesTextColor, selectedRangesTextColor = _l === void 0 ? "#44aaff" : _l, _m = _g.selectedRangesTextOffset, selectedRangesTextOffset = _m === void 0 ? [0, 0] : _m, _o = _g.markColor, markColor = _o === void 0 ? "#ff5" : _o;
    var rulerScale = this._getRulerScale();
    var width = this.width;
    var height = this.height;
    var state = this.state;
    state.scrollPos = scrollPos;
    var context = this.canvasContext;
    var isHorizontal = type5 === "horizontal";
    var isNegative = negativeRuler !== false;
    var font = props.font || "10px sans-serif";
    var textAlign = props.textAlign || "left";
    var textOffset = props.textOffset || [0, 0];
    var containerSize = isHorizontal ? height : width;
    var mainLineSize = convertUnitSize("".concat(props.mainLineSize || "100%"), containerSize);
    var longLineSize = convertUnitSize("".concat(props.longLineSize || 10), containerSize);
    var shortLineSize = convertUnitSize("".concat(props.shortLineSize || 7), containerSize);
    var lineOffset = props.lineOffset || [0, 0];
    if (backgroundColor === "transparent") {
      context.clearRect(0, 0, width * rulerScale, height * rulerScale);
    } else {
      context.rect(0, 0, width * rulerScale, height * rulerScale);
      context.fillStyle = backgroundColor;
      context.fill();
    }
    context.save();
    context.scale(rulerScale, rulerScale);
    context.strokeStyle = lineColor;
    context.lineWidth = lineWidth;
    context.font = font;
    context.fillStyle = textColor;
    context.textAlign = textAlign;
    switch (direction) {
      case "start":
        context.textBaseline = "top";
        break;
      case "center":
        context.textBaseline = "middle";
        break;
      case "end":
        context.textBaseline = "bottom";
        break;
    }
    context.translate(0.5, 0);
    context.beginPath();
    var size = isHorizontal ? width : height;
    var zoomUnit = nextZoom * unit3;
    var minRange = Math.floor(scrollPos * nextZoom / zoomUnit);
    var maxRange = Math.ceil((scrollPos * nextZoom + size) / zoomUnit);
    var length2 = maxRange - minRange;
    var alignOffset = Math.max(["left", "center", "right"].indexOf(textAlign) - 1, -1);
    var barSize = isHorizontal ? height : width;
    var values = [];
    for (var i = 0; i <= length2; ++i) {
      var value = (i + minRange) * unit3;
      var text = "".concat(value);
      if (textFormat) {
        text = textFormat(value);
      }
      var textSize = context.measureText(text).width;
      values.push({
        color: textColor,
        offset: textOffset,
        backgroundColor: textBackgroundColor,
        value,
        text,
        textSize
      });
    }
    if (selectedBackgroundColor !== "transparent" && (selectedRanges === null || selectedRanges === void 0 ? void 0 : selectedRanges.length)) {
      selectedRanges.forEach(function(selectedRange) {
        var rangeStart2 = Math.max(selectedRange[0], range3[0], negativeRuler ? -Infinity : 0);
        var rangeEnd2 = Math.min(selectedRange[1], range3[1]);
        var rangeX = (rangeStart2 - scrollPos) * nextZoom;
        var rangeWidth = (rangeEnd2 - rangeStart2) * nextZoom;
        if (selectedRangesText) {
          selectedRange.forEach(function(value2) {
            var text2 = "".concat(value2);
            if (textFormat) {
              text2 = textFormat(value2);
            }
            var textSize2 = context.measureText(text2).width;
            var startPos2 = value2 * nextZoom;
            var endPos = startPos2 + textSize2;
            findLast(values, function(_a2, index3) {
              var prevValue = _a2.value, prevTextSize = _a2.textSize;
              var prevStartPos = prevValue * nextZoom;
              var prevEndPos = prevStartPos + prevTextSize;
              if (prevStartPos <= endPos && startPos2 <= prevEndPos) {
                values.splice(index3, 1);
              }
            });
            values.push({
              value: value2,
              color: selectedRangesTextColor,
              offset: selectedRangesTextOffset,
              text: text2,
              textSize: textSize2
            });
          });
        }
        if (rangeWidth <= 0) {
          return;
        }
        context.save();
        context.fillStyle = selectedBackgroundColor;
        if (isHorizontal) {
          context.fillRect(rangeX, 0, rangeWidth, barSize);
        } else {
          context.fillRect(0, rangeX, barSize, rangeWidth);
        }
        context.restore();
      });
    }
    if (rangeBackgroundColor !== "transparent" && range3[0] !== -Infinity && range3[1] !== Infinity) {
      var rangeStart = (range3[0] - scrollPos) * nextZoom;
      var rangeEnd = (range3[1] - range3[0]) * nextZoom;
      context.save();
      context.fillStyle = rangeBackgroundColor;
      if (isHorizontal) {
        context.fillRect(rangeStart, 0, rangeEnd, barSize);
      } else {
        context.fillRect(0, rangeStart, barSize, rangeEnd);
      }
      context.restore();
    }
    for (var i = 0; i <= length2; ++i) {
      var value = i + minRange;
      if (!isNegative && value < 0) {
        continue;
      }
      var startValue = value * unit3;
      var startPos = (startValue - scrollPos) * nextZoom;
      for (var j = 0; j < segment; ++j) {
        var pos = startPos + j / segment * zoomUnit;
        var value_1 = startValue + j / segment * unit3;
        if (pos < 0 || pos >= size || value_1 < range3[0] || value_1 > range3[1]) {
          continue;
        }
        var lineSize = j === 0 ? mainLineSize : j % 2 === 0 ? longLineSize : shortLineSize;
        var origin = 0;
        switch (direction) {
          case "start":
            origin = 0;
            break;
          case "center":
            origin = barSize / 2 - lineSize / 2;
            break;
          case "end":
            origin = barSize - lineSize;
            break;
        }
        var _p = isHorizontal ? [pos + lineOffset[0], origin + lineOffset[1]] : [origin + lineOffset[0], pos + lineOffset[1]], x1 = _p[0], y1 = _p[1];
        var _q = isHorizontal ? [x1, y1 + lineSize] : [x1 + lineSize, y1], x2 = _q[0], y2 = _q[1];
        context.moveTo(x1 + lineOffset[0], y1 + lineOffset[1]);
        context.lineTo(x2 + lineOffset[0], y2 + lineOffset[1]);
      }
    }
    context.stroke();
    context.beginPath();
    context.strokeStyle = markColor;
    context.lineWidth = 1;
    (marks || []).forEach(function(value2) {
      var pos2 = (-scrollPos + value2) * nextZoom;
      if (pos2 < 0 || pos2 >= size || value2 < range3[0] || value2 > range3[1]) {
        return;
      }
      var _a2 = isHorizontal ? [pos2 + lineOffset[0], lineOffset[1]] : [lineOffset[0], pos2 + lineOffset[1]], x12 = _a2[0], y12 = _a2[1];
      var _b2 = isHorizontal ? [x12, y12 + containerSize] : [x12 + containerSize, y12], x22 = _b2[0], y22 = _b2[1];
      context.moveTo(x12 + lineOffset[0], y12 + lineOffset[1]);
      context.lineTo(x22 + lineOffset[0], y22 + lineOffset[1]);
    });
    context.stroke();
    values.forEach(function(_a2) {
      var value2 = _a2.value, offset4 = _a2.offset, backgroundColor2 = _a2.backgroundColor, color = _a2.color, text2 = _a2.text, textSize2 = _a2.textSize;
      if (!isNegative && value2 < 0) {
        return;
      }
      var startPos2 = (value2 - scrollPos) * nextZoom;
      if (startPos2 < -zoomUnit || startPos2 >= size + unit3 * nextZoom || value2 < range3[0] || value2 > range3[1]) {
        return;
      }
      var origin2 = 0;
      switch (direction) {
        case "start":
          origin2 = 17;
          break;
        case "center":
          origin2 = barSize / 2;
          break;
        case "end":
          origin2 = barSize - 17;
          break;
      }
      var _b2 = isHorizontal ? [startPos2 + alignOffset * -3, origin2] : [origin2, startPos2 + alignOffset * 3], startX = _b2[0], startY = _b2[1];
      if (backgroundColor2) {
        var backgroundOffset = 0;
        switch (textAlign) {
          case "left":
            backgroundOffset = 0;
            break;
          case "center":
            backgroundOffset = -textSize2 / 2;
            break;
          case "right":
            backgroundOffset = -textSize2;
            break;
        }
        context.save();
        context.fillStyle = backgroundColor2;
        if (isHorizontal) {
          context.fillRect(startX + offset4[0] + backgroundOffset, 0, textSize2, mainLineSize);
        } else {
          context.translate(0, startY + offset4[1]);
          context.rotate(-Math.PI / 2);
          context.fillRect(backgroundOffset, 0, textSize2, mainLineSize);
        }
        context.restore();
      }
      context.save();
      context.fillStyle = color;
      if (isHorizontal) {
        context.fillText(text2, startX + offset4[0], startY + offset4[1]);
      } else {
        context.translate(startX + offset4[0], startY + offset4[1]);
        context.rotate(-Math.PI / 2);
        context.fillText(text2, 0, 0);
      }
      context.restore();
    });
    context.restore();
  };
  __proto._getRulerScale = function() {
    var defaultPixelScale = this.props.defaultPixelScale || 2;
    if (!this._rulerScale) {
      var isHighDensity = window.devicePixelRatio > 1;
      if (!isHighDensity && window.matchMedia) {
        var mq = window.matchMedia("only screen and (min--moz-device-pixel-ratio: 1.3), only screen and (-o-min-device-pixel-ratio: 2.6/2), only screen and (-webkit-min-device-pixel-ratio: 1.3), only screen  and (min-device-pixel-ratio: 1.3), only screen and (min-resolution: 1.3dppx)");
        isHighDensity = mq && mq.matches;
      }
      this._rulerScale = isHighDensity ? 3 : defaultPixelScale;
    }
    return this._rulerScale;
  };
  Ruler2.defaultProps = {
    type: "horizontal",
    zoom: 1,
    width: 0,
    height: 0,
    unit: 50,
    negativeRuler: true,
    mainLineSize: "100%",
    longLineSize: 10,
    shortLineSize: 7,
    segment: 10,
    direction: "end",
    style: {
      width: "100%",
      height: "100%"
    },
    backgroundColor: "#333333",
    font: "10px sans-serif",
    textColor: "#ffffff",
    textBackgroundColor: "transparent",
    lineColor: "#777777",
    range: [-Infinity, Infinity],
    rangeBackgroundColor: "transparent",
    lineWidth: 1,
    selectedBackgroundColor: "#555555",
    defaultScrollPos: 0,
    markColor: "#f55",
    marks: []
  };
  return Ruler2;
})(import_react235.PureComponent);
var PROPERTIES2 = ["type", "width", "height", "unit", "zoom", "direction", "textAlign", "font", "segment", "mainLineSize", "longLineSize", "shortLineSize", "lineOffset", "textOffset", "negativeRuler", "range", "scrollPos", "defaultScrollPos", "style", "backgroundColor", "rangeBackgroundColor", "lineColor", "textColor", "textBackgroundColor", "textFormat", "warpSelf", "selectedBackgroundColor", "selectedRanges", "defaultPixelScale", "useResizeObserver", "selectedRangesText", "selectedRangesTextColor", "selectedRangesTextOffset", "marks", "markColor"];
var ruler_esm_default = Ruler;

// ../../node_modules/@scena/react-guides/dist/guides.esm.js
var extendStatics9 = function(d, b) {
  extendStatics9 = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function(d2, b2) {
    d2.__proto__ = b2;
  } || function(d2, b2) {
    for (var p in b2) if (Object.prototype.hasOwnProperty.call(b2, p)) d2[p] = b2[p];
  };
  return extendStatics9(d, b);
};
function __extends9(d, b) {
  if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  extendStatics9(d, b);
  function __() {
    this.constructor = d;
  }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign10 = function() {
  __assign10 = Object.assign || function __assign11(t2) {
    for (var s, i = 1, n2 = arguments.length; i < n2; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t2[p] = s[p];
    }
    return t2;
  };
  return __assign10.apply(this, arguments);
};
function __spreadArray3(to, from2, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l2 = from2.length, ar; i < l2; i++) {
    if (ar || !(i in from2)) {
      if (!ar) ar = Array.prototype.slice.call(from2, 0, i);
      ar[i] = from2[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from2));
}
function prefix2() {
  var classNames186 = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    classNames186[_i] = arguments[_i];
  }
  return prefixNames.apply(void 0, __spreadArray3(["scena-guides-"], classNames186, false));
}
var ADDER = prefix2("guide", "adder");
var GUIDES = prefix2("guides");
var GUIDE = prefix2("guide");
var DRAGGING = prefix2("dragging");
var DISPLAY_DRAG = prefix2("display-drag");
var GUIDES_CSS = prefixCSS("scena-guides-", '\n{\n    position: relative;\n    width: 100%;\n    height: 100%;\n}\ncanvas {\n    position: relative;\n}\n.guide-origin {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    top: 0;\n    left: 0;\n    opacity: 0;\n}\n.guides {\n    position: absolute;\n    bottom: 0;\n    right: 0;\n    will-change: transform;\n    z-index: 2000;\n}\n.guide-pos {\n    position: absolute;\n    font-weight: bold;\n    font-size: 12px;\n    color: #f33;\n}\n.horizontal .guide-pos {\n    bottom: 100%;\n    left: 50%;\n    transform: translate(-50%);\n}\n.vertical .guide-pos {\n    left: calc(100% + 2px);\n    top: 50%;\n    transform: translateY(-50%);\n}\n.display-drag {\n    position: absolute;\n    will-change: transform;\n    z-index: 2000;\n    font-weight: bold;\n    font-size: 12px;\n    display: none;\n    left: 20px;\n    top: -20px;\n    color: #f33;\n}\n:host.horizontal .guides {\n    width: 100%;\n    height: 0;\n}\n:host.vertical .guides {\n    height: 100%;\n    width: 0;\n}\n:host.horizontal canvas {\n    cursor: ns-resize;\n}\n:host.vertical canvas {\n    cursor: ew-resize;\n}\n.guide {\n    position: absolute;\n    background: #f33;\n    z-index: 2;\n}\n.guide.dragging:before {\n    position: absolute;\n    content: "";\n    width: 100%;\n    height: 100%;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n}\n:host.horizontal .guide {\n    width: 100%;\n    height: 1px;\n    cursor: row-resize;\n}\n:host.vertical .guide {\n    width: 1px;\n    height: 100%;\n    cursor: col-resize;\n}\n.mobile :host.horizontal .guide {\n    transform: scale(1, 2);\n}\n.mobile :host.vertical .guide {\n    transform: scale(2, 1);\n}\n:host.horizontal .guide:before {\n    height: 20px;\n}\n:host.vertical .guide:before {\n    width: 20px;\n}\n.adder {\n    display: none;\n}\n.adder.dragging {\n    display: block;\n}\n');
var PROPERTIES3 = __spreadArray3(["className", "rulerStyle", "snapThreshold", "snaps", "displayDragPos", "cspNonce", "dragPosFormat", "defaultGuides", "showGuides", "scrollOptions", "guideStyle", "guidesOffset", "digit", "defaultGuidesPos", "dragGuideStyle", "displayGuidePos", "guidePosFormat", "guidePosStyle", "lockGuides", "guidesZoom"], PROPERTIES2, true);
var GuidesElement = styled2("div", GUIDES_CSS);
var Guides = /* @__PURE__ */ (function(_super) {
  __extends9(Guides2, _super);
  function Guides2(props) {
    var _this = _super.call(this, props) || this;
    _this.state = {
      guides: []
    };
    _this.scrollPos = 0;
    _this.managerRef = (0, import_react236.createRef)();
    _this.guideElements = [];
    _this._isFirstMove = false;
    _this._zoom = 1;
    _this._guidesZoom = 1;
    _this._observer = null;
    _this.onDragStart = function(e3) {
      var datas = e3.datas, inputEvent = e3.inputEvent;
      _this._isFirstMove = true;
      _this.movePos(e3);
      _this.props.onDragStart(__assign10(__assign10({}, e3), {
        dragElement: datas.target
      }));
      if (!_this.gesto.isFlag()) {
        return;
      }
      inputEvent.stopPropagation();
      inputEvent.preventDefault();
      _this._startDragScroll(e3);
    };
    _this._onDrag = function(e3) {
      if (_this._isFirstMove) {
        _this._isFirstMove = false;
        addClass(e3.datas.target, DRAGGING);
      }
      var nextPos = _this.movePos(e3);
      _this.props.onDrag(__assign10(__assign10({}, e3), {
        dragElement: e3.datas.target
      }));
      if (!_this.gesto.isFlag()) {
        _this._endDragScroll(e3);
        return;
      }
      _this._dragScroll(e3);
      return nextPos;
    };
    _this.onDragEnd = function(e3) {
      var datas = e3.datas, isDouble = e3.isDouble, distX = e3.distX, distY = e3.distY;
      var pos = _this.movePos(e3);
      var guides = _this.state.guides;
      var _a = _this.props, onChangeGuides = _a.onChangeGuides, displayDragPos = _a.displayDragPos, digit = _a.digit, lockGuides = _a.lockGuides, guidesOffset = _a.guidesOffset;
      var zoom = _this._guidesZoom;
      var guidePos = parseFloat((pos / zoom).toFixed(digit || 0));
      var baseScrollPos = _this.scrollPos - (guidesOffset || 0);
      if (displayDragPos) {
        _this.displayElement.style.cssText += "display: none;";
      }
      removeClass(datas.target, DRAGGING);
      _this.props.onDragEnd(__assign10(__assign10({}, e3), {
        dragElement: datas.target
      }));
      _this._endDragScroll(e3);
      if (datas.fromRuler) {
        if (_this._isFirstMove) {
          _this.props.onClickRuler(__assign10(__assign10({}, e3), {
            pos: 0
          }));
        }
        if (guidePos >= baseScrollPos && guides.indexOf(guidePos) < 0) {
          _this.setState({
            guides: __spreadArray3(__spreadArray3([], guides, true), [guidePos], false)
          }, function() {
            onChangeGuides({
              guides: _this.state.guides,
              distX,
              distY,
              index: guides.length,
              isAdd: true,
              isRemove: false,
              isChange: false
            });
          });
        }
      } else {
        var index_1 = parseFloat(datas.target.getAttribute("data-index"));
        var isRemove_1 = false;
        var isChange_1 = false;
        guides = __spreadArray3([], guides, true);
        var guideIndex = guides.indexOf(guidePos);
        if (isDouble || guidePos < baseScrollPos || guideIndex > -1 && guideIndex !== index_1) {
          if (lockGuides && (lockGuides === true || lockGuides.indexOf("remove") > -1)) {
            return;
          }
          guides.splice(index_1, 1);
          isRemove_1 = true;
        } else if (guideIndex > -1) {
          return;
        } else {
          if (lockGuides && (lockGuides === true || lockGuides.indexOf("change") > -1)) {
            return;
          }
          guides[index_1] = guidePos;
          isChange_1 = true;
        }
        _this.setState({
          guides
        }, function() {
          var nextGuides = _this.state.guides;
          onChangeGuides({
            distX,
            distY,
            guides: nextGuides,
            isAdd: false,
            index: index_1,
            isChange: isChange_1,
            isRemove: isRemove_1
          });
        });
      }
    };
    _this._onCheck = function() {
      _this.resize();
    };
    _this.state.guides = props.defaultGuides || [];
    _this.scrollPos = props.defaultGuidesPos || 0;
    return _this;
  }
  var __proto = Guides2.prototype;
  __proto.render = function() {
    var _a = this.props, className2 = _a.className, type5 = _a.type, zoom = _a.zoom, guidesZoom = _a.guidesZoom, style2 = _a.style, rulerStyle = _a.rulerStyle, displayDragPos = _a.displayDragPos, cspNonce = _a.cspNonce, dragGuideStyle = _a.dragGuideStyle, _b = _a.guidePosStyle, guidePosStyle = _b === void 0 ? {} : _b;
    var props = this.props;
    var translateName = this.getTranslateName();
    var rulerProps = {};
    PROPERTIES2.forEach(function(name) {
      if (name === "style" || name === "warpSelf" || name === "useResizeObserver") {
        return;
      }
      rulerProps[name] = props[name];
    });
    this._zoom = zoom;
    this._guidesZoom = guidesZoom || zoom;
    return (0, import_react236.createElement)(GuidesElement, {
      ref: this.managerRef,
      cspNonce,
      className: "".concat(prefix2("manager", type5), " ").concat(className2),
      style: style2
    }, (0, import_react236.createElement)("div", {
      className: prefix2("guide-origin"),
      ref: ref2(this, "originElement")
    }), (0, import_react236.createElement)(ruler_esm_default, __assign10({
      ref: ref2(this, "ruler"),
      style: rulerStyle
    }, rulerProps)), (0, import_react236.createElement)("div", {
      className: GUIDES,
      ref: ref2(this, "guidesElement"),
      style: {
        transform: "".concat(translateName, "(").concat(-this.scrollPos * this._guidesZoom, "px)")
      }
    }, displayDragPos && (0, import_react236.createElement)("div", {
      className: DISPLAY_DRAG,
      ref: ref2(this, "displayElement"),
      style: guidePosStyle || {}
    }), (0, import_react236.createElement)("div", {
      className: ADDER,
      ref: ref2(this, "adderElement"),
      style: dragGuideStyle
    }), this.renderGuides()));
  };
  __proto.drawRuler = function(options) {
    this.ruler.draw(options);
  };
  __proto.renderGuides = function() {
    var _this = this;
    var props = this.props;
    var _a = props, type5 = _a.type, showGuides = _a.showGuides, guideStyle2 = _a.guideStyle, displayGuidePos = _a.displayGuidePos, _b = _a.guidePosStyle, guidePosStyle = _b === void 0 ? {} : _b, guidesOffset = _a.guidesOffset;
    var zoom = this._guidesZoom;
    var translateName = this.getTranslateName();
    var guides = this.state.guides;
    var guidePosFormat = props.guidePosFormat || props.dragPosFormat || function(v) {
      return v;
    };
    this.guideElements = [];
    if (showGuides) {
      return guides.map(function(pos, i) {
        var guidePos = pos + (guidesOffset || 0);
        return (0, import_react236.createElement)("div", {
          className: prefix2("guide", type5),
          ref: refs(_this, "guideElements", i),
          key: i,
          "data-index": i,
          "data-pos": pos,
          style: __assign10(__assign10({}, guideStyle2), {
            transform: "".concat(translateName, "(").concat(guidePos * zoom, "px) translateZ(0px)")
          })
        }, displayGuidePos && (0, import_react236.createElement)("div", {
          className: prefix2("guide-pos"),
          style: guidePosStyle || {}
        }, guidePosFormat(pos)));
      });
    }
    return;
  };
  __proto.componentDidMount = function() {
    var _this = this;
    this.gesto = new Gesto(this.managerRef.current, {
      container: document.body
    }).on("dragStart", function(e3) {
      var _a = _this.props, type5 = _a.type, lockGuides = _a.lockGuides;
      var zoom = _this._guidesZoom;
      if (lockGuides === true) {
        e3.stop();
        return;
      }
      var inputEvent = e3.inputEvent;
      var target = inputEvent.target;
      var datas = e3.datas;
      var canvasElement = _this.ruler.canvasElement;
      var guidesElement = _this.guidesElement;
      var isHorizontal = type5 === "horizontal";
      var originRect = _this.originElement.getBoundingClientRect();
      var matrix = getDistElementMatrix(_this.managerRef.current);
      var offsetPos = calculateMatrixDist(matrix, [e3.clientX - originRect.left, e3.clientY - originRect.top]);
      offsetPos[0] -= guidesElement.offsetLeft;
      offsetPos[1] -= guidesElement.offsetTop;
      offsetPos[isHorizontal ? 1 : 0] += _this.scrollPos * zoom;
      datas.offsetPos = offsetPos;
      datas.matrix = matrix;
      var isLockAdd = lockGuides && lockGuides.indexOf("add") > -1;
      var isLockRemove = lockGuides && lockGuides.indexOf("remove") > -1;
      var isLockChange = lockGuides && lockGuides.indexOf("change") > -1;
      if (target === canvasElement) {
        if (isLockAdd) {
          e3.stop();
          return;
        }
        datas.fromRuler = true;
        datas.target = _this.adderElement;
      } else if (hasClass(target, GUIDE)) {
        if (isLockRemove && isLockChange) {
          e3.stop();
          return;
        }
        datas.target = target;
      } else {
        e3.stop();
        return false;
      }
      _this.onDragStart(e3);
    }).on("drag", this._onDrag).on("dragEnd", this.onDragEnd);
    if (this.props.useResizeObserver) {
      this._observer = new ResizeObserver(this._onCheck);
      this._observer.observe(this.guidesElement, {
        box: "border-box"
      });
      this._observer.observe(this.getRulerElement(), {
        box: "border-box"
      });
    } else {
      this._onCheck();
    }
  };
  __proto.componentWillUnmount = function() {
    var _a;
    this.gesto.unset();
    (_a = this._observer) === null || _a === void 0 ? void 0 : _a.disconnect();
  };
  __proto.componentDidUpdate = function(prevProps) {
    var nextGuides = this.props.defaultGuides;
    if (prevProps.defaultGuides !== nextGuides) {
      this.setState({
        guides: nextGuides || []
      });
    }
  };
  __proto.loadGuides = function(guides) {
    this.setState({
      guides
    });
  };
  __proto.getGuides = function() {
    return this.state.guides;
  };
  __proto.scrollGuides = function(pos, nextZoom) {
    if (nextZoom === void 0) {
      nextZoom = this._guidesZoom;
    }
    this._setZoom({
      guidesZoom: nextZoom
    });
    var translateName = this.getTranslateName();
    var guidesElement = this.guidesElement;
    this.scrollPos = pos;
    guidesElement.style.transform = "".concat(translateName, "(").concat(-pos * nextZoom, "px)");
    var guides = this.state.guides;
    var guidesOffset = this.props.guidesOffset || 0;
    this.guideElements.forEach(function(el, i) {
      if (!el) {
        return;
      }
      var guidePos = guides[i] + (guidesOffset || 0);
      el.style.transform = "".concat(translateName, "(").concat(guidePos * nextZoom, "px) translateZ(0px)");
      el.style.display = -pos + guidePos < 0 ? "none" : "block";
    });
  };
  __proto.zoomTo = function(nextZoom, nextGuidesZoom) {
    if (nextGuidesZoom === void 0) {
      nextGuidesZoom = nextZoom;
    }
    this.scroll(this.getRulerScrollPos(), nextZoom);
    this.scrollGuides(this.getGuideScrollPos(), nextGuidesZoom);
  };
  __proto.getElement = function() {
    return this.managerRef.current;
  };
  __proto.getRulerElement = function() {
    return this.ruler.canvasElement;
  };
  __proto.getGuideScrollPos = function() {
    return this.scrollPos;
  };
  __proto.getRulerScrollPos = function() {
    return this.ruler.getScrollPos();
  };
  __proto.scroll = function(pos, nextZoom) {
    if (nextZoom === void 0) {
      nextZoom = this._zoom;
    }
    this._setZoom({
      zoom: nextZoom
    });
    this.ruler.scroll(pos, nextZoom);
  };
  __proto.resize = function(nextZoom) {
    if (nextZoom === void 0) {
      nextZoom = this._zoom;
    }
    this._setZoom({
      zoom: nextZoom
    });
    this.ruler.resize(nextZoom);
  };
  __proto.movePos = function(e3) {
    var datas = e3.datas, distX = e3.distX, distY = e3.distY;
    var props = this.props;
    var type5 = props.type, snaps = props.snaps, snapThreshold = props.snapThreshold, displayDragPos = props.displayDragPos, digit = props.digit;
    var guidesOffset = props.guidesOffset || 0;
    var zoom = this._guidesZoom;
    var dragPosFormat = props.dragPosFormat || function(v) {
      return v;
    };
    var isHorizontal = type5 === "horizontal";
    var matrixPos = calculateMatrixDist(datas.matrix, [distX, distY]);
    var offsetPos = datas.offsetPos;
    var offsetX = matrixPos[0] + offsetPos[0];
    var offsetY = matrixPos[1] + offsetPos[1];
    var guidesZoomOffset = guidesOffset * zoom;
    var nextPos = Math.round(isHorizontal ? offsetY : offsetX) - guidesOffset;
    var guidePos = parseFloat((nextPos / zoom).toFixed(digit || 0));
    var guideSnaps = snaps.slice().sort(function(a, b) {
      return Math.abs(guidePos - a) - Math.abs(guidePos - b);
    });
    if (guideSnaps.length && Math.abs(guideSnaps[0] * zoom - nextPos) < snapThreshold) {
      guidePos = guideSnaps[0];
      nextPos = guidePos * zoom;
    }
    if (!datas.fromRuler || !this._isFirstMove) {
      if (displayDragPos) {
        var displayPos = type5 === "horizontal" ? [offsetX, nextPos + guidesZoomOffset] : [nextPos + guidesZoomOffset, offsetY];
        this.displayElement.style.cssText += "display: block;transform: translate(-50%, -50%) " + "translate(".concat(displayPos.map(function(v) {
          return "".concat(v, "px");
        }).join(", "), ")");
        this.displayElement.innerHTML = "".concat(dragPosFormat(guidePos));
      }
      var target = datas.target;
      target.setAttribute("data-pos", guidePos);
      target.style.transform = "".concat(this.getTranslateName(), "(").concat(nextPos + guidesOffset * zoom, "px)");
    }
    return nextPos;
  };
  __proto.getTranslateName = function() {
    return this.props.type === "horizontal" ? "translateY" : "translateX";
  };
  __proto._startDragScroll = function(e3) {
    var _this = this;
    var scrollOptions = this.props.scrollOptions;
    if (!scrollOptions) {
      return;
    }
    var datas = e3.datas;
    var dragScroll = new dragscroll_esm_default();
    datas.dragScroll = dragScroll;
    dragScroll.on("scroll", function(_a) {
      var _b, _c;
      var container = _a.container, direction = _a.direction;
      (_c = (_b = _this.props).onRequestScroll) === null || _c === void 0 ? void 0 : _c.call(_b, {
        container,
        direction
      });
    }).on("move", function(_a) {
      var offsetX = _a.offsetX, offsetY = _a.offsetY, inputEvent = _a.inputEvent;
      _this.gesto.scrollBy(offsetX, offsetY, inputEvent.inputEvent, true);
    });
    dragScroll.dragStart(e3, {
      container: scrollOptions.container
    });
  };
  __proto._dragScroll = function(e3) {
    var scrollOptions = this.props.scrollOptions;
    if (!scrollOptions) {
      return;
    }
    var dragScroll = e3.datas.dragScroll;
    dragScroll.drag(e3, scrollOptions);
  };
  __proto._endDragScroll = function(e3) {
    var _a;
    (_a = e3.datas.dragScroll) === null || _a === void 0 ? void 0 : _a.dragEnd();
    e3.datas.dragScroll = null;
  };
  __proto._setZoom = function(zooms) {
    var nextZoom = zooms.zoom, nextGuidesZoom = zooms.guidesZoom;
    var hasZoom = !!this.props.zoom;
    var hasGuidesZoom = !!this.props.guidesZoom;
    if (hasGuidesZoom) {
      if (nextGuidesZoom) {
        this._guidesZoom = nextGuidesZoom;
      }
    } else {
      if (nextGuidesZoom) {
        this._zoom = nextGuidesZoom;
        this._guidesZoom = nextGuidesZoom;
      }
      if (nextZoom) {
        this._guidesZoom = nextZoom;
      }
    }
    if (nextZoom) {
      this._zoom = nextZoom;
    }
  };
  Guides2.defaultProps = {
    className: "",
    type: "horizontal",
    zoom: 1,
    guidesZoom: 0,
    style: {},
    snapThreshold: 5,
    snaps: [],
    digit: 0,
    onClickRuler: function() {
    },
    onChangeGuides: function() {
    },
    onRequestScroll: function() {
    },
    onDragStart: function() {
    },
    onDrag: function() {
    },
    onDragEnd: function() {
    },
    displayDragPos: false,
    dragPosFormat: function(v) {
      return v;
    },
    defaultGuides: [],
    lockGuides: false,
    showGuides: true,
    guideStyle: {},
    dragGuideStyle: {},
    guidePosStyle: {},
    defaultGuidesPos: 0
  };
  return Guides2;
})(import_react236.PureComponent);
var guides_esm_default = Guides;

// src/components/Designer/Canvas/Guides.tsx
var guideStyle = (top, left2, height, width) => ({
  position: "absolute",
  top,
  left: left2,
  height,
  width,
  background: "#333333"
});
var _Guides = ({
  paperSize,
  horizontalRef,
  verticalRef
}) => /* @__PURE__ */ import_react237.default.createElement(import_react237.default.Fragment, null, /* @__PURE__ */ import_react237.default.createElement(
  "div",
  {
    className: "ruler-container",
    style: guideStyle(-RULER_HEIGHT, -RULER_HEIGHT, RULER_HEIGHT, RULER_HEIGHT)
  }
), /* @__PURE__ */ import_react237.default.createElement(
  guides_esm_default,
  {
    zoom: ZOOM,
    style: guideStyle(-RULER_HEIGHT, 0, RULER_HEIGHT, paperSize.width),
    type: "horizontal",
    ref: horizontalRef
  }
), /* @__PURE__ */ import_react237.default.createElement(
  guides_esm_default,
  {
    zoom: ZOOM,
    style: guideStyle(0, -RULER_HEIGHT, paperSize.height, RULER_HEIGHT),
    type: "vertical",
    ref: verticalRef
  }
));
var Guides_default = _Guides;

// src/components/Designer/Canvas/Mask.tsx
var import_react238 = __toESM(require_react());
var Mask4 = ({ width, height }) => /* @__PURE__ */ import_react238.default.createElement(
  "div",
  {
    style: {
      position: "absolute",
      top: -RULER_HEIGHT,
      left: -RULER_HEIGHT,
      zIndex: 100,
      width,
      height,
      background: theme_default3.useToken().token.colorBgMask
    }
  }
);
var Mask_default2 = Mask4;

// src/components/Designer/Canvas/Padding.tsx
var import_react239 = __toESM(require_react());
var getPaddingStyle = (i, p, color) => {
  const style2 = {
    position: "absolute",
    background: color,
    opacity: 0.25,
    pointerEvents: "none"
  };
  switch (i) {
    case 0:
      style2.top = 0;
      style2.height = `${p * ZOOM}px`;
      style2.left = 0;
      style2.right = 0;
      break;
    case 1:
      style2.right = 0;
      style2.width = `${p * ZOOM}px`;
      style2.top = 0;
      style2.bottom = 0;
      break;
    case 2:
      style2.bottom = 0;
      style2.height = `${p * ZOOM}px`;
      style2.left = 0;
      style2.right = 0;
      break;
    case 3:
      style2.left = 0;
      style2.width = `${p * ZOOM}px`;
      style2.top = 0;
      style2.bottom = 0;
      break;
    default:
      break;
  }
  return style2;
};
var Padding2 = ({ basePdf }) => {
  return /* @__PURE__ */ import_react239.default.createElement(import_react239.default.Fragment, null, isBlankPdf(basePdf) && basePdf.padding.map((p, i) => /* @__PURE__ */ import_react239.default.createElement("div", { key: String(i), style: getPaddingStyle(i, p, theme_default3.useToken().token.colorError) })));
};
var Padding_default = Padding2;

// src/components/StaticSchema.tsx
var import_react240 = __toESM(require_react());
var StaticSchema = (props) => {
  const {
    template: { schemas, basePdf },
    input,
    scale,
    totalPages,
    currentPage
  } = props;
  if (!isBlankPdf(basePdf) || !basePdf.staticSchema) return null;
  return /* @__PURE__ */ import_react240.default.createElement(import_react240.default.Fragment, null, basePdf.staticSchema.map((schema) => /* @__PURE__ */ import_react240.default.createElement(
    Renderer_default,
    {
      key: schema.name,
      schema: { ...schema, id: uuid() },
      basePdf,
      value: replacePlaceholders({
        content: schema.content || "",
        variables: { ...input, totalPages, currentPage },
        schemas
      }),
      onChangeHoveringSchemaId: () => {
      },
      mode: "viewer",
      outline: `none`,
      scale,
      selectable: false
    }
  )));
};
var StaticSchema_default = StaticSchema;

// src/components/Designer/Canvas/index.tsx
var mm2px = (mm) => mm * 3.7795275591;
var DELETE_BTN_ID = uuid();
var fmt4Num = (prop) => Number(prop.replace("px", ""));
var fmt = (prop) => round(fmt4Num(prop) / ZOOM, 2);
var isTopLeftResize = (d) => d === "-1,-1" || d === "-1,0" || d === "0,-1";
var normalizeRotate = (angle) => (angle % 360 + 360) % 360;
var DeleteButton = ({ activeElements: aes }) => {
  const { token: token2 } = theme_default3.useToken();
  const size = 26;
  const top = Math.min(...aes.map(({ style: style2 }) => fmt4Num(style2.top)));
  const left2 = Math.max(...aes.map(({ style: style2 }) => fmt4Num(style2.left) + fmt4Num(style2.width))) + 10;
  return /* @__PURE__ */ import_react241.default.createElement(
    button_default2,
    {
      id: DELETE_BTN_ID,
      style: {
        position: "absolute",
        zIndex: 1,
        top,
        left: left2,
        width: size,
        height: size,
        padding: 2,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: token2.borderRadius,
        color: token2.colorWhite,
        background: token2.colorPrimary
      }
    },
    /* @__PURE__ */ import_react241.default.createElement(X, { style: { pointerEvents: "none" } })
  );
};
var Canvas = (props, ref3) => {
  const {
    basePdf,
    pageCursor,
    scale,
    backgrounds,
    pageSizes,
    size,
    activeElements,
    schemasList,
    hoveringSchemaId,
    onEdit,
    changeSchemas: changeSchemas2,
    removeSchemas,
    onChangeHoveringSchemaId,
    paperRefs,
    sidebarOpen
  } = props;
  const { token: token2 } = theme_default3.useToken();
  const pluginsRegistry = (0, import_react241.useContext)(PluginsRegistry);
  const verticalGuides = (0, import_react241.useRef)([]);
  const horizontalGuides = (0, import_react241.useRef)([]);
  const moveable = (0, import_react241.useRef)(null);
  const [isPressShiftKey, setIsPressShiftKey] = (0, import_react241.useState)(false);
  const [editing, setEditing] = (0, import_react241.useState)(false);
  const prevSchemas = usePrevious3(schemasList[pageCursor]);
  const onKeydown = (e3) => {
    if (e3.shiftKey) setIsPressShiftKey(true);
  };
  const onKeyup = (e3) => {
    if (e3.key === "Shift" || !e3.shiftKey) setIsPressShiftKey(false);
    if (e3.key === "Escape" || e3.key === "Esc") setEditing(false);
  };
  const initEvents = (0, import_react241.useCallback)(() => {
    window.addEventListener("keydown", onKeydown);
    window.addEventListener("keyup", onKeyup);
  }, []);
  const destroyEvents = (0, import_react241.useCallback)(() => {
    window.removeEventListener("keydown", onKeydown);
    window.removeEventListener("keyup", onKeyup);
  }, []);
  (0, import_react241.useEffect)(() => {
    initEvents();
    return destroyEvents;
  }, [initEvents, destroyEvents]);
  (0, import_react241.useEffect)(() => {
    moveable.current?.updateRect();
    if (!prevSchemas) {
      return;
    }
    const prevSchemaKeys = JSON.stringify(prevSchemas[pageCursor] || {});
    const schemaKeys = JSON.stringify(schemasList[pageCursor] || {});
    if (prevSchemaKeys === schemaKeys) {
      moveable.current?.updateRect();
    }
  }, [pageCursor, schemasList, prevSchemas]);
  const onDrag = ({ target, top, left: left2 }) => {
    const { width: _width, height: _height } = target.style;
    const targetWidth = fmt(_width);
    const targetHeight = fmt(_height);
    const actualTop = top / ZOOM;
    const actualLeft = left2 / ZOOM;
    const { width: pageWidth, height: pageHeight } = pageSizes[pageCursor];
    let topPadding = 0;
    let rightPadding = 0;
    let bottomPadding = 0;
    let leftPadding = 0;
    if (isBlankPdf(basePdf)) {
      const [t2, r2, b, l2] = basePdf.padding;
      topPadding = t2 * ZOOM;
      rightPadding = r2;
      bottomPadding = b;
      leftPadding = l2 * ZOOM;
    }
    if (actualTop + targetHeight > pageHeight - bottomPadding) {
      target.style.top = `${(pageHeight - targetHeight - bottomPadding) * ZOOM}px`;
    } else {
      target.style.top = `${top < topPadding ? topPadding : top}px`;
    }
    if (actualLeft + targetWidth > pageWidth - rightPadding) {
      target.style.left = `${(pageWidth - targetWidth - rightPadding) * ZOOM}px`;
    } else {
      target.style.left = `${left2 < leftPadding ? leftPadding : left2}px`;
    }
  };
  const onDragEnd = ({ target }) => {
    const { top, left: left2 } = target.style;
    changeSchemas2([
      { key: "position.y", value: fmt(top), schemaId: target.id },
      { key: "position.x", value: fmt(left2), schemaId: target.id }
    ]);
  };
  const onDragEnds = ({ targets }) => {
    const arg = targets.map(({ style: { top, left: left2 }, id }) => [
      { key: "position.y", value: fmt(top), schemaId: id },
      { key: "position.x", value: fmt(left2), schemaId: id }
    ]);
    changeSchemas2(flatten(arg));
  };
  const onRotate = ({ target, rotate: rotate2 }) => {
    target.style.transform = `rotate(${rotate2}deg)`;
  };
  const onRotateEnd = ({ target }) => {
    const { transform } = target.style;
    const rotate2 = Number(transform.replace("rotate(", "").replace("deg)", ""));
    const normalizedRotate = normalizeRotate(rotate2);
    changeSchemas2([{ key: "rotate", value: normalizedRotate, schemaId: target.id }]);
  };
  const onRotateEnds = ({ targets }) => {
    const arg = targets.map(({ style: { transform }, id }) => {
      const rotate2 = Number(transform.replace("rotate(", "").replace("deg)", ""));
      const normalizedRotate = normalizeRotate(rotate2);
      return [{ key: "rotate", value: normalizedRotate, schemaId: id }];
    });
    changeSchemas2(flatten(arg));
  };
  const onResizeEnd = ({ target }) => {
    const { id, style: style2 } = target;
    const { width, height, top, left: left2 } = style2;
    changeSchemas2([
      { key: "position.x", value: fmt(left2), schemaId: id },
      { key: "position.y", value: fmt(top), schemaId: id },
      { key: "width", value: fmt(width), schemaId: id },
      { key: "height", value: fmt(height), schemaId: id }
    ]);
    const targetSchema = schemasList[pageCursor].find((schema) => schema.id === id);
    if (!targetSchema) return;
    targetSchema.position.x = fmt(left2);
    targetSchema.position.y = fmt(top);
    targetSchema.width = fmt(width);
    targetSchema.height = fmt(height);
  };
  const onResizeEnds = ({ targets }) => {
    const arg = targets.map(({ style: { width, height, top, left: left2 }, id }) => [
      { key: "width", value: fmt(width), schemaId: id },
      { key: "height", value: fmt(height), schemaId: id },
      { key: "position.y", value: fmt(top), schemaId: id },
      { key: "position.x", value: fmt(left2), schemaId: id }
    ]);
    changeSchemas2(flatten(arg));
  };
  const onResize2 = ({ target, width, height, direction }) => {
    if (!target) return;
    let topPadding = 0;
    let rightPadding = 0;
    let bottomPadding = 0;
    let leftPadding = 0;
    if (isBlankPdf(basePdf)) {
      const [t2, r2, b, l2] = basePdf.padding;
      topPadding = t2 * ZOOM;
      rightPadding = mm2px(r2);
      bottomPadding = mm2px(b);
      leftPadding = l2 * ZOOM;
    }
    const pageWidth = mm2px(pageSizes[pageCursor].width);
    const pageHeight = mm2px(pageSizes[pageCursor].height);
    const obj = {
      width: `${width}px`,
      height: `${height}px`
    };
    const s = target.style;
    let newLeft = fmt4Num(s.left) + (fmt4Num(s.width) - width);
    let newTop = fmt4Num(s.top) + (fmt4Num(s.height) - height);
    if (newLeft < leftPadding) {
      newLeft = leftPadding;
    }
    if (newTop < topPadding) {
      newTop = topPadding;
    }
    if (newLeft + width > pageWidth - rightPadding) {
      obj.width = `${pageWidth - rightPadding - newLeft}px`;
    }
    if (newTop + height > pageHeight - bottomPadding) {
      obj.height = `${pageHeight - bottomPadding - newTop}px`;
    }
    const d = direction.toString();
    if (isTopLeftResize(d)) {
      obj.top = `${newTop}px`;
      obj.left = `${newLeft}px`;
    } else if (d === "1,-1") {
      obj.top = `${newTop}px`;
    } else if (d === "-1,1") {
      obj.left = `${newLeft}px`;
    }
    Object.assign(s, obj);
  };
  const getGuideLines = (guides, index3) => guides[index3] && guides[index3].getGuides().map((g) => g * ZOOM);
  const onClickMoveable = () => {
    setEditing(true);
  };
  const rotatable = (0, import_react241.useMemo)(() => {
    const selectedSchemas = (schemasList[pageCursor] || []).filter(
      (s) => activeElements.map((ae) => ae.id).includes(s.id)
    );
    const schemaTypes = selectedSchemas.map((s) => s.type);
    const uniqueSchemaTypes = [...new Set(schemaTypes)];
    const defaultSchemas = [];
    Object.values(pluginsRegistry).forEach((plugin) => {
      if (plugin && typeof plugin === "object" && "propPanel" in plugin && plugin.propPanel && typeof plugin.propPanel === "object" && "defaultSchema" in plugin.propPanel && plugin.propPanel.defaultSchema) {
        defaultSchemas.push(plugin.propPanel.defaultSchema);
      }
    });
    return uniqueSchemaTypes.every((type5) => {
      const matchingSchema = defaultSchemas.find((ds) => ds && "type" in ds && ds.type === type5);
      return matchingSchema && "rotate" in matchingSchema;
    });
  }, [activeElements, pageCursor, schemasList, pluginsRegistry]);
  return /* @__PURE__ */ import_react241.default.createElement(
    "div",
    {
      style: {
        position: "relative",
        overflow: "auto",
        marginRight: sidebarOpen ? RIGHT_SIDEBAR_WIDTH : 0,
        ...size
      },
      ref: ref3
    },
    /* @__PURE__ */ import_react241.default.createElement(
      Selecto_default,
      {
        container: paperRefs.current[pageCursor],
        continueSelect: isPressShiftKey,
        onDragStart: (e3) => {
          const inputEvent = e3.inputEvent;
          const target = inputEvent.target;
          const isMoveableElement = moveable.current?.isMoveableElement(target);
          if (inputEvent.type === "touchstart" && e3.isTrusted || isMoveableElement) {
            e3.stop();
          }
          if (paperRefs.current[pageCursor] === target) {
            onEdit([]);
          }
          const targetElement = target;
          if (targetElement && targetElement.id === DELETE_BTN_ID) {
            removeSchemas(activeElements.map((ae) => ae.id));
          }
        },
        onSelect: (e3) => {
          const inputEvent = e3.inputEvent;
          const added = e3.added;
          const removed = e3.removed;
          const selected = e3.selected;
          const isClick = inputEvent.type === "mousedown";
          let newActiveElements = isClick ? selected : [];
          if (!isClick && added.length > 0) {
            newActiveElements = activeElements.concat(added);
          }
          if (!isClick && removed.length > 0) {
            newActiveElements = activeElements.filter((ae) => !removed.includes(ae));
          }
          onEdit(newActiveElements);
          if (newActiveElements != activeElements) {
            setEditing(false);
          }
          const mouseEvent = inputEvent;
          if (mouseEvent && typeof mouseEvent.shiftKey === "boolean" && !mouseEvent.shiftKey) {
            setIsPressShiftKey(false);
          }
        }
      }
    ),
    /* @__PURE__ */ import_react241.default.createElement(
      Paper_default,
      {
        paperRefs,
        scale,
        size,
        schemasList,
        pageSizes,
        backgrounds,
        hasRulers: true,
        renderPaper: ({ index: index3, paperSize }) => /* @__PURE__ */ import_react241.default.createElement(import_react241.default.Fragment, null, !editing && activeElements.length > 0 && pageCursor === index3 && /* @__PURE__ */ import_react241.default.createElement(DeleteButton, { activeElements }), /* @__PURE__ */ import_react241.default.createElement(Padding_default, { basePdf }), /* @__PURE__ */ import_react241.default.createElement(
          StaticSchema_default,
          {
            template: { schemas: schemasList, basePdf },
            input: Object.fromEntries(
              schemasList.flat().map(({ name, content = "" }) => [name, content])
            ),
            scale,
            totalPages: schemasList.length,
            currentPage: index3 + 1
          }
        ), /* @__PURE__ */ import_react241.default.createElement(
          Guides_default,
          {
            paperSize,
            horizontalRef: (e3) => {
              if (e3) horizontalGuides.current[index3] = e3;
            },
            verticalRef: (e3) => {
              if (e3) verticalGuides.current[index3] = e3;
            }
          }
        ), pageCursor !== index3 ? /* @__PURE__ */ import_react241.default.createElement(
          Mask_default2,
          {
            width: paperSize.width + RULER_HEIGHT,
            height: paperSize.height + RULER_HEIGHT
          }
        ) : !editing && /* @__PURE__ */ import_react241.default.createElement(
          Moveable_default,
          {
            ref: moveable,
            target: activeElements,
            bounds: { left: 0, top: 0, bottom: paperSize.height, right: paperSize.width },
            horizontalGuidelines: getGuideLines(horizontalGuides.current, index3),
            verticalGuidelines: getGuideLines(verticalGuides.current, index3),
            keepRatio: isPressShiftKey,
            rotatable,
            onDrag,
            onDragEnd,
            onDragGroupEnd: onDragEnds,
            onRotate,
            onRotateEnd,
            onRotateGroupEnd: onRotateEnds,
            onResize: onResize2,
            onResizeEnd,
            onResizeGroupEnd: onResizeEnds,
            onClick: onClickMoveable
          }
        )),
        renderSchema: ({ schema, index: index3 }) => {
          const mode = editing && activeElements.map((ae) => ae.id).includes(schema.id) ? "designer" : "viewer";
          const content = schema.content || "";
          let value = content;
          if (mode !== "designer" && schema.readOnly) {
            const variables = {
              ...schemasList.flat().reduce(
                (acc, currSchema) => {
                  acc[currSchema.name] = currSchema.content || "";
                  return acc;
                },
                {}
              ),
              totalPages: schemasList.length,
              currentPage: index3 + 1
            };
            value = replacePlaceholders({ content, variables, schemas: schemasList });
          }
          return /* @__PURE__ */ import_react241.default.createElement(
            Renderer_default,
            {
              key: schema.id,
              schema,
              basePdf,
              value,
              onChangeHoveringSchemaId,
              mode,
              onChange: (schemasList[pageCursor] || []).some((s) => s.id === schema.id) ? (arg) => {
                const args = Array.isArray(arg) ? arg : [arg];
                changeSchemas2(
                  args.map(({ key: key2, value: value2 }) => ({ key: key2, value: value2, schemaId: schema.id }))
                );
              } : void 0,
              stopEditing: () => setEditing(false),
              outline: `1px ${hoveringSchemaId === schema.id ? "solid" : "dashed"} ${schema.readOnly && hoveringSchemaId !== schema.id ? "transparent" : token2.colorPrimary}`,
              scale
            }
          );
        }
      }
    )
  );
};
var Canvas_default = (0, import_react241.forwardRef)(Canvas);

// src/components/Root.tsx
var import_react243 = __toESM(require_react());

// src/components/Spinner.tsx
var import_react242 = __toESM(require_react());
var Spinner = () => {
  const { token: token2 } = theme_default3.useToken();
  const containerStyle = {
    position: "relative",
    width: "100%",
    height: "100%",
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%",
    color: token2.colorPrimary
  };
  const loaderStyle = {
    animation: "spin 1s linear infinite"
  };
  const keyframes = `
    @keyframes spin {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  `;
  return /* @__PURE__ */ import_react242.default.createElement(import_react242.default.Fragment, null, /* @__PURE__ */ import_react242.default.createElement("style", null, keyframes), /* @__PURE__ */ import_react242.default.createElement("div", { style: containerStyle }, /* @__PURE__ */ import_react242.default.createElement(LoaderCircle, { size: 50, style: loaderStyle })));
};
var Spinner_default = Spinner;

// src/components/Root.tsx
var Root = ({ size, scale, children }, ref3) => {
  const font = (0, import_react243.useContext)(FontContext);
  (0, import_react243.useEffect)(() => {
    if (!document || !document.fonts) return;
    const fontFaces = Object.entries(font).map(
      ([key2, { data: data2 }]) => (
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        new FontFace(key2, typeof data2 === "string" ? `url(${data2})` : data2, {
          display: "swap"
        })
      )
    );
    const newFontFaces = fontFaces.filter((fontFace) => !document.fonts.has(fontFace));
    void Promise.allSettled(newFontFaces.map((f) => f.load())).then((loadedFontFaces) => {
      loadedFontFaces.forEach((loadedFontFace) => {
        if (loadedFontFace.status === "fulfilled") {
          document.fonts.add(loadedFontFace.value);
        }
      });
    });
  }, [font]);
  return /* @__PURE__ */ import_react243.default.createElement("div", { ref: ref3, style: { position: "relative", background: BACKGROUND_COLOR, ...size } }, /* @__PURE__ */ import_react243.default.createElement("div", { style: { margin: "0 auto", ...size } }, scale === 0 ? /* @__PURE__ */ import_react243.default.createElement(Spinner_default, null) : children));
};
var Root_default = (0, import_react243.forwardRef)(Root);

// src/components/ErrorScreen.tsx
var import_react244 = __toESM(require_react());
var ErrorScreen = ({ size, error: error2 }) => {
  const i18n2 = (0, import_react244.useContext)(I18nContext);
  const { token: token2 } = theme_default3.useToken();
  return /* @__PURE__ */ import_react244.default.createElement(
    "div",
    {
      style: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        background: BACKGROUND_COLOR,
        ...size
      }
    },
    /* @__PURE__ */ import_react244.default.createElement("div", { style: { width: 300, margin: "0 auto", background: token2.colorBgLayout } }, /* @__PURE__ */ import_react244.default.createElement(
      result_default,
      {
        icon: null,
        title: "ERROR",
        subTitle: i18n2("errorOccurred"),
        extra: /* @__PURE__ */ import_react244.default.createElement("span", null, error2.message)
      }
    ))
  );
};
var ErrorScreen_default = ErrorScreen;

// src/components/CtlBar.tsx
var import_react245 = __toESM(require_react());
var { Text: Text5 } = typography_default;
var Zoom = ({ zoomLevel, setZoomLevel, style: style2 }) => {
  const zoomStep = 0.25;
  const maxZoom = useMaxZoom();
  const minZoom = 0.25;
  const nextZoomOut = zoomLevel - zoomStep;
  const nextZoomIn = zoomLevel + zoomStep;
  return /* @__PURE__ */ import_react245.default.createElement("div", { style: { display: "flex", alignItems: "center" } }, /* @__PURE__ */ import_react245.default.createElement(
    button_default2,
    {
      type: "text",
      disabled: minZoom >= nextZoomOut,
      onClick: () => setZoomLevel(nextZoomOut),
      icon: /* @__PURE__ */ import_react245.default.createElement(Minus, { size: 16, color: style2.textStyle.color })
    }
  ), /* @__PURE__ */ import_react245.default.createElement(Text5, { strong: true, style: style2.textStyle }, Math.round(zoomLevel * 100), "%"), /* @__PURE__ */ import_react245.default.createElement(
    button_default2,
    {
      type: "text",
      disabled: maxZoom < nextZoomIn,
      onClick: () => setZoomLevel(nextZoomIn),
      icon: /* @__PURE__ */ import_react245.default.createElement(Plus, { size: 16, color: style2.textStyle.color })
    }
  ));
};
var Pager3 = ({ pageCursor, pageNum, setPageCursor, style: style2 }) => {
  return /* @__PURE__ */ import_react245.default.createElement("div", { style: { display: "flex", alignItems: "center" } }, /* @__PURE__ */ import_react245.default.createElement(button_default2, { type: "text", disabled: pageCursor <= 0, onClick: () => setPageCursor(pageCursor - 1) }, /* @__PURE__ */ import_react245.default.createElement(ChevronLeft, { size: 16, color: style2.textStyle.color })), /* @__PURE__ */ import_react245.default.createElement(Text5, { strong: true, style: style2.textStyle }, pageCursor + 1, "/", pageNum), /* @__PURE__ */ import_react245.default.createElement(
    button_default2,
    {
      type: "text",
      disabled: pageCursor + 1 >= pageNum,
      onClick: () => setPageCursor(pageCursor + 1)
    },
    /* @__PURE__ */ import_react245.default.createElement(ChevronRight, { size: 16, color: style2.textStyle.color })
  ));
};
var ContextMenu = ({ items, style: style2 }) => /* @__PURE__ */ import_react245.default.createElement(dropdown_default3, { menu: { items }, placement: "top", arrow: true, trigger: ["click"] }, /* @__PURE__ */ import_react245.default.createElement(button_default2, { type: "text" }, /* @__PURE__ */ import_react245.default.createElement(Ellipsis, { size: 16, color: style2.textStyle.color })));
var CtlBar = (props) => {
  const { token: token2 } = theme_default3.useToken();
  const i18n2 = (0, import_react245.useContext)(I18nContext);
  const {
    size,
    pageCursor,
    pageNum,
    setPageCursor,
    zoomLevel,
    setZoomLevel,
    addPageAfter,
    removePage
  } = props;
  const contextMenuItems = [];
  if (addPageAfter) {
    contextMenuItems.push({
      key: "1",
      label: /* @__PURE__ */ import_react245.default.createElement("div", { onClick: addPageAfter }, i18n2("addPageAfter"))
    });
  }
  if (removePage && pageNum > 1 && pageCursor !== 0) {
    contextMenuItems.push({
      key: "2",
      label: /* @__PURE__ */ import_react245.default.createElement("div", { onClick: removePage }, i18n2("removePage"))
    });
  }
  const barWidth = 300;
  const contextMenuWidth = contextMenuItems.length > 0 ? 50 : 0;
  const width = (pageNum > 1 ? barWidth : barWidth / 2) + contextMenuWidth;
  const textStyle = {
    color: token2.colorWhite,
    fontSize: token2.fontSize,
    margin: token2.marginXS
  };
  return /* @__PURE__ */ import_react245.default.createElement("div", { style: { position: "absolute", top: "auto", bottom: "6%", width: size.width } }, /* @__PURE__ */ import_react245.default.createElement(
    "div",
    {
      style: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-evenly",
        position: "relative",
        zIndex: 1,
        left: `calc(50% - ${width / 2}px)`,
        width,
        height: 40,
        boxSizing: "border-box",
        padding: token2.paddingSM,
        borderRadius: token2.borderRadius,
        backgroundColor: token2.colorBgMask
      }
    },
    pageNum > 1 && /* @__PURE__ */ import_react245.default.createElement(
      Pager3,
      {
        style: { textStyle },
        pageCursor,
        pageNum,
        setPageCursor
      }
    ),
    /* @__PURE__ */ import_react245.default.createElement(Zoom, { style: { textStyle }, zoomLevel, setZoomLevel }),
    contextMenuItems.length > 0 && /* @__PURE__ */ import_react245.default.createElement(ContextMenu, { items: contextMenuItems, style: { textStyle } })
  ));
};
var CtlBar_default = CtlBar;

// src/components/Designer/index.tsx
var scaleDragPosAdjustment = (adjustment, scale) => {
  if (scale > 1) return adjustment * (scale - 1);
  if (scale < 1) return adjustment * -(1 - scale);
  return 0;
};
var TemplateEditor = ({
  template,
  size,
  onSaveTemplate,
  onChangeTemplate,
  onPageCursorChange
}) => {
  const past = (0, import_react246.useRef)([]);
  const future = (0, import_react246.useRef)([]);
  const canvasRef = (0, import_react246.useRef)(null);
  const paperRefs = (0, import_react246.useRef)([]);
  const i18n2 = (0, import_react246.useContext)(I18nContext);
  const pluginsRegistry = (0, import_react246.useContext)(PluginsRegistry);
  const options = (0, import_react246.useContext)(OptionsContext);
  const maxZoom = useMaxZoom();
  const [hoveringSchemaId, setHoveringSchemaId] = (0, import_react246.useState)(null);
  const [activeElements, setActiveElements] = (0, import_react246.useState)([]);
  const [schemasList, setSchemasList] = (0, import_react246.useState)([[]]);
  const [pageCursor, setPageCursor] = (0, import_react246.useState)(0);
  const [zoomLevel, setZoomLevel] = (0, import_react246.useState)(1);
  const [sidebarOpen, setSidebarOpen] = (0, import_react246.useState)(true);
  const [prevTemplate, setPrevTemplate] = (0, import_react246.useState)(null);
  const { backgrounds, pageSizes, scale, error: error2, refresh } = useUIPreProcessor({
    template,
    size,
    zoomLevel,
    maxZoom
  });
  const onEdit = (targets) => {
    setActiveElements(targets);
    setHoveringSchemaId(null);
  };
  const onEditEnd = () => {
    setActiveElements([]);
    setHoveringSchemaId(null);
  };
  useScrollPageCursor({
    ref: canvasRef,
    pageSizes,
    scale,
    pageCursor,
    onChangePageCursor: (p) => {
      setPageCursor(p);
      onPageCursorChange(p);
      onEditEnd();
    }
  });
  const commitSchemas = (0, import_react246.useCallback)(
    (newSchemas) => {
      future.current = [];
      past.current.push(cloneDeep(schemasList[pageCursor]));
      const _schemasList = cloneDeep(schemasList);
      _schemasList[pageCursor] = newSchemas;
      setSchemasList(_schemasList);
      onChangeTemplate(schemasList2template(_schemasList, template.basePdf));
    },
    [template, schemasList, pageCursor, onChangeTemplate]
  );
  const removeSchemas = (0, import_react246.useCallback)(
    (ids2) => {
      commitSchemas(schemasList[pageCursor].filter((schema) => !ids2.includes(schema.id)));
      onEditEnd();
    },
    [schemasList, pageCursor, commitSchemas]
  );
  const changeSchemas2 = (0, import_react246.useCallback)(
    (objs) => {
      changeSchemas({
        objs,
        schemas: schemasList[pageCursor],
        basePdf: template.basePdf,
        pluginsRegistry,
        pageSize: pageSizes[pageCursor],
        commitSchemas
      });
    },
    [commitSchemas, pageCursor, schemasList, pluginsRegistry, pageSizes, template.basePdf]
  );
  useInitEvents({
    pageCursor,
    pageSizes,
    activeElements,
    template,
    schemasList,
    changeSchemas: changeSchemas2,
    commitSchemas,
    removeSchemas,
    onSaveTemplate,
    past,
    future,
    setSchemasList,
    onEdit,
    onEditEnd
  });
  const updateTemplate = (0, import_react246.useCallback)(async (newTemplate) => {
    const sl = await template2SchemasList(newTemplate);
    setSchemasList(sl);
    onEditEnd();
    setPageCursor(0);
    if (canvasRef.current?.scroll) {
      canvasRef.current.scroll({ top: 0, behavior: "smooth" });
    }
  }, []);
  const addSchema = (defaultSchema) => {
    const [paddingTop, paddingRight, paddingBottom, paddingLeft] = isBlankPdf(template.basePdf) ? template.basePdf.padding : [0, 0, 0, 0];
    const pageSize = pageSizes[pageCursor];
    const newSchemaName = (prefix3) => {
      let index3 = schemasList.reduce((acc, page) => acc + page.length, 1);
      let newName = prefix3 + index3;
      while (schemasList.some((page) => page.find((s2) => s2.name === newName))) {
        index3++;
        newName = prefix3 + index3;
      }
      return newName;
    };
    const ensureMiddleValue = (min, value, max) => Math.min(Math.max(min, value), max);
    const s = {
      id: uuid(),
      ...defaultSchema,
      name: newSchemaName(i18n2("field")),
      position: {
        x: ensureMiddleValue(
          paddingLeft,
          defaultSchema.position.x,
          pageSize.width - paddingRight - defaultSchema.width
        ),
        y: ensureMiddleValue(
          paddingTop,
          defaultSchema.position.y,
          pageSize.height - paddingBottom - defaultSchema.height
        )
      },
      required: defaultSchema.readOnly ? false : options.requiredByDefault || defaultSchema.required || false
    };
    if (defaultSchema.position.y === 0) {
      const paper = paperRefs.current[pageCursor];
      const rectTop = paper ? paper.getBoundingClientRect().top : 0;
      s.position.y = rectTop > 0 ? paddingTop : pageSizes[pageCursor].height / 2;
    }
    commitSchemas(schemasList[pageCursor].concat(s));
    setTimeout(() => onEdit([document.getElementById(s.id)]));
  };
  const onSortEnd = (sortedSchemas) => {
    commitSchemas(sortedSchemas);
  };
  const onChangeHoveringSchemaId = (id) => {
    setHoveringSchemaId(id);
  };
  const updatePage = async (sl, newPageCursor) => {
    setPageCursor(newPageCursor);
    const newTemplate = schemasList2template(sl, template.basePdf);
    onChangeTemplate(newTemplate);
    await updateTemplate(newTemplate);
    void refresh(newTemplate);
    setTimeout(() => {
      if (canvasRef.current) {
        canvasRef.current.scrollTop = getPagesScrollTopByIndex(pageSizes, newPageCursor, scale);
      }
    }, 0);
  };
  const handleRemovePage = () => {
    if (pageCursor === 0) return;
    if (!window.confirm(i18n2("removePageConfirm"))) return;
    const _schemasList = cloneDeep(schemasList);
    _schemasList.splice(pageCursor, 1);
    void updatePage(_schemasList, pageCursor - 1);
  };
  const handleAddPageAfter = () => {
    const _schemasList = cloneDeep(schemasList);
    _schemasList.splice(pageCursor + 1, 0, []);
    void updatePage(_schemasList, pageCursor + 1);
  };
  if (prevTemplate !== template) {
    setPrevTemplate(template);
    void updateTemplate(template);
  }
  const canvasWidth = size.width - LEFT_SIDEBAR_WIDTH;
  const sizeExcSidebars = {
    width: sidebarOpen ? canvasWidth - RIGHT_SIDEBAR_WIDTH : canvasWidth,
    height: size.height
  };
  if (error2) {
    return /* @__PURE__ */ import_react246.default.createElement(ErrorScreen_default, { size, error: error2 });
  }
  const pageManipulation = isBlankPdf(template.basePdf) ? { addPageAfter: handleAddPageAfter, removePage: handleRemovePage } : {};
  return /* @__PURE__ */ import_react246.default.createElement(Root_default, { size, scale }, /* @__PURE__ */ import_react246.default.createElement(
    DndContext,
    {
      onDragEnd: (event) => {
        if (!event.active) return;
        const active = event.active;
        const pageRect = paperRefs.current[pageCursor].getBoundingClientRect();
        const dragStartLeft = active.rect.current.initial?.left || 0;
        const dragStartTop = active.rect.current.initial?.top || 0;
        const canvasLeftOffsetFromPageCorner = pageRect.left - dragStartLeft + scaleDragPosAdjustment(20, scale);
        const canvasTopOffsetFromPageCorner = pageRect.top - dragStartTop;
        const moveY = (event.delta.y - canvasTopOffsetFromPageCorner) / scale;
        const moveX = (event.delta.x - canvasLeftOffsetFromPageCorner) / scale;
        const position3 = {
          x: round(px2mm(Math.max(0, moveX)), 2),
          y: round(px2mm(Math.max(0, moveY)), 2)
        };
        addSchema({ ...active.data.current, position: position3 });
      },
      onDragStart: onEditEnd
    },
    /* @__PURE__ */ import_react246.default.createElement(
      LeftSidebar_default,
      {
        height: canvasRef.current ? canvasRef.current.clientHeight : 0,
        scale,
        basePdf: template.basePdf
      }
    ),
    /* @__PURE__ */ import_react246.default.createElement("div", { style: { position: "absolute", width: canvasWidth, marginLeft: LEFT_SIDEBAR_WIDTH } }, /* @__PURE__ */ import_react246.default.createElement(
      CtlBar_default,
      {
        size: sizeExcSidebars,
        pageCursor,
        pageNum: schemasList.length,
        setPageCursor: (p) => {
          if (!canvasRef.current) return;
          canvasRef.current.scrollTop = getPagesScrollTopByIndex(pageSizes, p, scale);
          setPageCursor(p);
          onEditEnd();
        },
        zoomLevel,
        setZoomLevel,
        ...pageManipulation
      }
    ), /* @__PURE__ */ import_react246.default.createElement(
      RightSidebar_default,
      {
        hoveringSchemaId,
        onChangeHoveringSchemaId,
        height: canvasRef.current ? canvasRef.current.clientHeight : 0,
        size,
        pageSize: pageSizes[pageCursor] ?? [],
        activeElements,
        schemasList,
        schemas: schemasList[pageCursor] ?? [],
        changeSchemas: changeSchemas2,
        onSortEnd,
        onEdit: (id) => {
          const editingElem = document.getElementById(id);
          if (editingElem) {
            onEdit([editingElem]);
          }
        },
        onEditEnd,
        deselectSchema: onEditEnd,
        sidebarOpen,
        setSidebarOpen
      }
    ), /* @__PURE__ */ import_react246.default.createElement(
      Canvas_default,
      {
        ref: canvasRef,
        paperRefs,
        basePdf: template.basePdf,
        hoveringSchemaId,
        onChangeHoveringSchemaId,
        height: size.height - RULER_HEIGHT * ZOOM,
        pageCursor,
        scale,
        size: sizeExcSidebars,
        pageSizes,
        backgrounds,
        activeElements,
        schemasList,
        changeSchemas: changeSchemas2,
        removeSchemas,
        sidebarOpen,
        onEdit
      }
    ))
  ));
};
var Designer_default = TemplateEditor;

// src/components/AppContextProvider.tsx
var import_react247 = __toESM(require_react());

// src/theme.ts
var defaultTheme2 = {
  token: {
    colorPrimary: "#38a0ff"
  },
  components: {
    Form: {
      fontSize: 12,
      margin: 8,
      marginLG: 12,
      marginXS: 4,
      padding: 8,
      paddingLG: 12,
      paddingXS: 4,
      itemMarginBottom: 4,
      verticalLabelPadding: "0 0 2px"
    }
  }
};

// src/components/AppContextProvider.tsx
var isObject6 = (item) => Boolean(item) && typeof item === "object" && !Array.isArray(item);
var deepMerge2 = (target, source) => {
  let output = { ...target };
  if (isObject6(target) && isObject6(source)) {
    Object.keys(source).forEach((key2) => {
      const sourceValue = source[key2];
      if (isObject6(sourceValue)) {
        if (!(key2 in target)) {
          Object.assign(output, { [key2]: sourceValue });
        } else {
          const targetValue = target[key2];
          if (isObject6(targetValue)) {
            output[key2] = deepMerge2(targetValue, sourceValue);
          } else {
            Object.assign(output, { [key2]: sourceValue });
          }
        }
      } else {
        Object.assign(output, { [key2]: sourceValue });
      }
    });
  }
  return output;
};
var AppContextProvider = ({ children, lang, font, plugins, options }) => {
  let theme = defaultTheme2;
  if (options.theme) {
    theme = deepMerge2(
      theme,
      options.theme
    );
  }
  let dict = getDict(lang);
  if (options.labels) {
    dict = deepMerge2(
      dict,
      options.labels
    );
  }
  return /* @__PURE__ */ import_react247.default.createElement(config_provider_default, { theme }, /* @__PURE__ */ import_react247.default.createElement(I18nContext.Provider, { value: (key2) => i18n(key2, dict) }, /* @__PURE__ */ import_react247.default.createElement(FontContext.Provider, { value: font }, /* @__PURE__ */ import_react247.default.createElement(PluginsRegistry.Provider, { value: plugins }, /* @__PURE__ */ import_react247.default.createElement(OptionsContext.Provider, { value: options }, children)))));
};
var AppContextProvider_default = AppContextProvider;

// src/Designer.tsx
var Designer = class extends BaseUIClass {
  constructor(props) {
    super(props);
    this.pageCursor = 0;
    checkDesignerProps(props);
  }
  saveTemplate() {
    if (!this.domContainer) throw Error(DESTROYED_ERR_MSG);
    if (this.onSaveTemplateCallback) {
      this.onSaveTemplateCallback(this.template);
    }
  }
  updateTemplate(template) {
    checkTemplate(template);
    if (!this.domContainer) throw Error(DESTROYED_ERR_MSG);
    this.template = cloneDeep(template);
    if (this.onChangeTemplateCallback) {
      this.onChangeTemplateCallback(template);
    }
    this.render();
  }
  onSaveTemplate(cb) {
    this.onSaveTemplateCallback = cb;
  }
  onChangeTemplate(cb) {
    this.onChangeTemplateCallback = cb;
  }
  getPageCursor() {
    return this.pageCursor;
  }
  render() {
    if (!this.domContainer) throw Error(DESTROYED_ERR_MSG);
    import_react_dom14.default.render(
      /* @__PURE__ */ import_react248.default.createElement(
        AppContextProvider_default,
        {
          lang: this.getLang(),
          font: this.getFont(),
          plugins: this.getPluginsRegistry(),
          options: this.getOptions()
        },
        /* @__PURE__ */ import_react248.default.createElement(
          Designer_default,
          {
            template: this.template,
            onSaveTemplate: (template) => {
              this.template = template;
              this.template.pdfmeVersion = PDFME_VERSION;
              if (this.onSaveTemplateCallback) {
                this.onSaveTemplateCallback(template);
              }
            },
            onChangeTemplate: (template) => {
              this.template = template;
              this.template.pdfmeVersion = PDFME_VERSION;
              if (this.onChangeTemplateCallback) {
                this.onChangeTemplateCallback(template);
              }
            },
            onPageCursorChange: (newPageCursor) => {
              this.pageCursor = newPageCursor;
            },
            size: this.size
          }
        )
      ),
      this.domContainer
    );
  }
};
var Designer_default2 = Designer;

// src/Form.tsx
var import_react251 = __toESM(require_react());
var import_react_dom15 = __toESM(require_react_dom());

// src/components/Preview.tsx
var import_react250 = __toESM(require_react());

// src/components/UnitPager.tsx
var import_react249 = __toESM(require_react());
var { Text: Text6 } = typography_default;
var icons2 = {
  left: ChevronLeft,
  right: ChevronRight,
  doubleLeft: ChevronsLeft,
  doubleRight: ChevronsRight
};
var UnitButton = ({ type: type5, onClick, disabled, textStyle }) => {
  const Icon6 = icons2[type5];
  return /* @__PURE__ */ import_react249.default.createElement(button_default2, { type: "text", onClick, disabled }, /* @__PURE__ */ import_react249.default.createElement(Icon6, { style: { color: textStyle.color } }));
};
var UnitPager = ({ size, unitCursor, unitNum, setUnitCursor }) => {
  if (unitNum <= 1) return null;
  const { token: token2 } = theme_default3.useToken();
  const buttonWrapStyle = {
    pointerEvents: "initial",
    position: "sticky",
    zIndex: 1,
    display: "flex",
    alignItems: "center",
    boxSizing: "border-box",
    height: 40,
    padding: token2.paddingSM,
    borderRadius: token2.borderRadius,
    backgroundColor: token2.colorBgMask
  };
  const textStyle = {
    color: token2.colorWhite,
    fontSize: token2.fontSize,
    margin: token2.marginXS
  };
  return /* @__PURE__ */ import_react249.default.createElement("div", { style: { position: "absolute", ...size } }, /* @__PURE__ */ import_react249.default.createElement(
    "div",
    {
      style: {
        position: "sticky",
        width: "100%",
        zIndex: 1,
        top: `calc(50% - ${buttonWrapStyle.height / 2}px)`,
        display: "flex",
        alignItems: "center"
      }
    },
    unitCursor > 0 && /* @__PURE__ */ import_react249.default.createElement("div", { style: { left: "1rem", marginLeft: "1rem", ...buttonWrapStyle } }, /* @__PURE__ */ import_react249.default.createElement(
      UnitButton,
      {
        type: "doubleLeft",
        onClick: () => setUnitCursor(0),
        disabled: unitCursor <= 0,
        textStyle
      }
    ), /* @__PURE__ */ import_react249.default.createElement(
      UnitButton,
      {
        type: "left",
        onClick: () => setUnitCursor(unitCursor - 1),
        disabled: unitCursor <= 0,
        textStyle
      }
    ), /* @__PURE__ */ import_react249.default.createElement(Text6, { strong: true, style: textStyle }, unitCursor + 1, "/", unitNum)),
    unitCursor + 1 < unitNum && /* @__PURE__ */ import_react249.default.createElement(
      "div",
      {
        style: { right: "1rem", marginLeft: "auto", marginRight: "1rem", ...buttonWrapStyle }
      },
      /* @__PURE__ */ import_react249.default.createElement(Text6, { strong: true, style: textStyle }, unitCursor + 1, "/", unitNum),
      /* @__PURE__ */ import_react249.default.createElement(
        UnitButton,
        {
          type: "right",
          onClick: () => setUnitCursor(unitCursor + 1),
          disabled: unitCursor + 1 >= unitNum,
          textStyle
        }
      ),
      /* @__PURE__ */ import_react249.default.createElement(
        UnitButton,
        {
          type: "doubleRight",
          onClick: () => setUnitCursor(unitNum - 1),
          disabled: unitCursor + 1 >= unitNum,
          textStyle
        }
      )
    )
  ));
};
var UnitPager_default = UnitPager;

// src/components/Preview.tsx
var _cache = /* @__PURE__ */ new Map();
var Preview3 = ({
  template,
  inputs,
  size,
  onChangeInput
}) => {
  const { token: token2 } = theme_default3.useToken();
  const font = (0, import_react250.useContext)(FontContext);
  const maxZoom = useMaxZoom();
  const containerRef = (0, import_react250.useRef)(null);
  const paperRefs = (0, import_react250.useRef)([]);
  const [unitCursor, setUnitCursor] = (0, import_react250.useState)(0);
  const [pageCursor, setPageCursor] = (0, import_react250.useState)(0);
  const [zoomLevel, setZoomLevel] = (0, import_react250.useState)(1);
  const [schemasList, setSchemasList] = (0, import_react250.useState)([[]]);
  const { backgrounds, pageSizes, scale, error: error2, refresh } = useUIPreProcessor({
    template,
    size,
    zoomLevel,
    maxZoom
  });
  const isForm = Boolean(onChangeInput);
  const input = inputs[unitCursor];
  const init2 = (template2) => {
    const options = { font };
    getDynamicTemplate({
      template: template2,
      input,
      options,
      _cache,
      getDynamicHeights: (value, args) => {
        switch (args.schema.type) {
          case "table":
            return getDynamicHeightsForTable2(value, args);
          default:
            return Promise.resolve([args.schema.height]);
        }
      }
    }).then(async (dynamicTemplate) => {
      const sl = await template2SchemasList(dynamicTemplate);
      setSchemasList(sl);
      await refresh(dynamicTemplate);
    }).catch((err) => console.error(`[@pdfme/ui] `, err));
  };
  (0, import_react250.useEffect)(() => {
    if (unitCursor > inputs.length - 1) {
      setUnitCursor(inputs.length - 1);
    }
    init2(template);
  }, [template, inputs, size]);
  useScrollPageCursor({
    ref: containerRef,
    pageSizes,
    scale,
    pageCursor,
    onChangePageCursor: setPageCursor
  });
  const handleChangeInput = ({ name, value }) => onChangeInput && onChangeInput({ index: unitCursor, name, value });
  const handleOnChangeRenderer = (args, schema) => {
    let isNeedInit = false;
    args.forEach(({ key: _key, value }) => {
      if (_key === "content") {
        const newValue = value;
        const oldValue = input?.[schema.name] || "";
        if (newValue === oldValue) return;
        handleChangeInput({ name: schema.name, value: newValue });
        if (schema.type === "table") isNeedInit = true;
      } else {
        const targetSchema = schemasList[pageCursor].find((s) => s.id === schema.id);
        if (!targetSchema) return;
        targetSchema[_key] = value;
      }
    });
    if (isNeedInit) {
      init2(template);
    }
    setSchemasList([...schemasList]);
  };
  if (error2) {
    return /* @__PURE__ */ import_react250.default.createElement(ErrorScreen_default, { size, error: error2 });
  }
  return /* @__PURE__ */ import_react250.default.createElement(Root_default, { size, scale }, /* @__PURE__ */ import_react250.default.createElement(
    CtlBar_default,
    {
      size,
      pageCursor,
      pageNum: schemasList.length,
      setPageCursor: (p) => {
        if (!containerRef.current) return;
        containerRef.current.scrollTop = getPagesScrollTopByIndex(pageSizes, p, scale);
        setPageCursor(p);
      },
      zoomLevel,
      setZoomLevel
    }
  ), /* @__PURE__ */ import_react250.default.createElement(
    UnitPager_default,
    {
      size,
      unitCursor,
      unitNum: inputs.length,
      setUnitCursor
    }
  ), /* @__PURE__ */ import_react250.default.createElement("div", { ref: containerRef, style: { ...size, position: "relative", overflow: "auto" } }, /* @__PURE__ */ import_react250.default.createElement(
    Paper_default,
    {
      paperRefs,
      scale,
      size,
      schemasList,
      pageSizes,
      backgrounds,
      renderSchema: ({ schema, index: index3 }) => {
        const value = schema.readOnly ? replacePlaceholders({
          content: schema.content || "",
          variables: { ...input, totalPages: schemasList.length, currentPage: index3 + 1 },
          schemas: schemasList
        }) : String(input && input[schema.name] || "");
        return /* @__PURE__ */ import_react250.default.createElement(
          Renderer_default,
          {
            key: schema.id,
            schema,
            basePdf: template.basePdf,
            value,
            mode: isForm ? "form" : "viewer",
            placeholder: schema.content,
            tabIndex: index3 + 100,
            onChange: (arg) => {
              const args = Array.isArray(arg) ? arg : [arg];
              handleOnChangeRenderer(args, schema);
            },
            outline: isForm && !schema.readOnly ? `1px dashed ${token2.colorPrimary}` : "transparent",
            scale
          }
        );
      },
      renderPaper: ({ index: index3 }) => /* @__PURE__ */ import_react250.default.createElement(
        StaticSchema_default,
        {
          template,
          scale,
          input,
          totalPages: schemasList.length,
          currentPage: index3 + 1
        }
      )
    }
  )));
};
var Preview_default2 = Preview3;

// src/Form.tsx
var Form5 = class extends PreviewUI {
  constructor(props) {
    super(props);
  }
  onChangeInput(cb) {
    this.onChangeInputCallback = cb;
  }
  setInputs(inputs) {
    const previousInputs = this.getInputs();
    super.setInputs(inputs);
    const changedInputs = [];
    inputs.forEach((input, index3) => {
      const prevInput = previousInputs[index3] || {};
      const allKeys = /* @__PURE__ */ new Set([...Object.keys(input), ...Object.keys(prevInput)]);
      allKeys.forEach((name) => {
        const newValue = input[name];
        const oldValue = prevInput[name];
        if (newValue !== oldValue) {
          changedInputs.push({ index: index3, name, value: newValue });
        }
      });
    });
    changedInputs.forEach((input) => {
      if (this.onChangeInputCallback) {
        this.onChangeInputCallback(input);
      }
    });
  }
  render() {
    if (!this.domContainer) throw Error(DESTROYED_ERR_MSG);
    import_react_dom15.default.render(
      /* @__PURE__ */ import_react251.default.createElement(
        AppContextProvider_default,
        {
          lang: this.getLang(),
          font: this.getFont(),
          plugins: this.getPluginsRegistry(),
          options: this.getOptions()
        },
        /* @__PURE__ */ import_react251.default.createElement(
          Preview_default2,
          {
            template: this.template,
            size: this.size,
            inputs: this.inputs,
            onChangeInput: (arg) => {
              const { index: index3, value, name } = arg;
              if (this.onChangeInputCallback) {
                this.onChangeInputCallback({ index: index3, value, name });
              }
              if (this.inputs && this.inputs[index3]) {
                if (this.inputs[index3][name] !== value) {
                  this.inputs[index3][name] = value;
                  this.render();
                }
              }
            }
          }
        )
      ),
      this.domContainer
    );
  }
};
var Form_default3 = Form5;

// src/Viewer.tsx
var import_react252 = __toESM(require_react());
var import_react_dom16 = __toESM(require_react_dom());
var Viewer = class extends PreviewUI {
  constructor(props) {
    super(props);
    console.warn("[@pdfme/ui] Viewer component is deprecated and will be removed in a future version.");
  }
  render() {
    if (!this.domContainer) throw Error(DESTROYED_ERR_MSG);
    import_react_dom16.default.render(
      /* @__PURE__ */ import_react252.default.createElement(
        AppContextProvider_default,
        {
          lang: this.getLang(),
          font: this.getFont(),
          plugins: this.getPluginsRegistry(),
          options: this.getOptions()
        },
        /* @__PURE__ */ import_react252.default.createElement(Preview_default2, { template: this.template, size: this.size, inputs: this.inputs })
      ),
      this.domContainer
    );
  }
};
var Viewer_default = Viewer;
export {
  Designer_default2 as Designer,
  Form_default3 as Form,
  Viewer_default as Viewer
};
/*! Bundled license information:

object-assign/index.js:
  (*
  object-assign
  (c) Sindre Sorhus
  @license MIT
  *)

react/cjs/react.development.js:
  (** @license React v16.14.0
   * react.development.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *)

scheduler/cjs/scheduler.development.js:
  (** @license React v0.19.1
   * scheduler.development.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *)

scheduler/cjs/scheduler-tracing.development.js:
  (** @license React v0.19.1
   * scheduler-tracing.development.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *)

react-dom/cjs/react-dom.development.js:
  (** @license React v16.14.0
   * react-dom.development.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *)
  (**
   * Checks if an event is supported in the current execution environment.
   *
   * NOTE: This will not work correctly for non-generic events such as `change`,
   * `reset`, `load`, `error`, and `select`.
   *
   * Borrows from Modernizr.
   *
   * @param {string} eventNameSuffix Event name, e.g. "click".
   * @return {boolean} True if the event is supported.
   * @internal
   * @license Modernizr 3.0.0pre (Custom Build) | MIT
   *)

ieee754/index.js:
  (*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> *)

buffer/index.js:
  (*!
   * The buffer module from node.js, for the browser.
   *
   * @author   Feross Aboukhadijeh <https://feross.org>
   * @license  MIT
   *)

classnames/index.js:
  (*!
  	Copyright (c) 2018 Jed Watson.
  	Licensed under the MIT License (MIT), see
  	http://jedwatson.github.io/classnames
  *)

react-is/cjs/react-is.development.js:
  (**
   * @license React
   * react-is.development.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *)

use-sync-external-store/cjs/use-sync-external-store-shim.development.js:
  (**
   * @license React
   * use-sync-external-store-shim.development.js
   *
   * Copyright (c) Meta Platforms, Inc. and affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *)

use-sync-external-store/cjs/use-sync-external-store-shim/with-selector.development.js:
  (**
   * @license React
   * use-sync-external-store-shim/with-selector.development.js
   *
   * Copyright (c) Meta Platforms, Inc. and affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *)

react-is/cjs/react-is.development.js:
  (** @license React v16.13.1
   * react-is.development.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *)

lucide/dist/esm/icons/align-center.js:
lucide/dist/esm/icons/align-justify.js:
lucide/dist/esm/icons/align-left.js:
lucide/dist/esm/icons/align-right.js:
lucide/dist/esm/icons/arrow-down-to-line.js:
lucide/dist/esm/icons/arrow-up-to-line.js:
lucide/dist/esm/icons/strikethrough.js:
lucide/dist/esm/icons/underline.js:
lucide/dist/esm/lucide.js:
  (**
   * @license lucide v0.507.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

@babel/runtime/helpers/esm/regenerator.js:
  (*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE *)

lucide-react/dist/esm/shared/src/utils.js:
lucide-react/dist/esm/defaultAttributes.js:
lucide-react/dist/esm/Icon.js:
lucide-react/dist/esm/createLucideIcon.js:
lucide-react/dist/esm/icons/align-center-horizontal.js:
lucide-react/dist/esm/icons/align-center-vertical.js:
lucide-react/dist/esm/icons/align-end-horizontal.js:
lucide-react/dist/esm/icons/align-end-vertical.js:
lucide-react/dist/esm/icons/align-horizontal-space-around.js:
lucide-react/dist/esm/icons/align-start-horizontal.js:
lucide-react/dist/esm/icons/align-start-vertical.js:
lucide-react/dist/esm/icons/align-vertical-space-around.js:
lucide-react/dist/esm/icons/arrow-left.js:
lucide-react/dist/esm/icons/arrow-right.js:
lucide-react/dist/esm/icons/chevron-left.js:
lucide-react/dist/esm/icons/chevron-right.js:
lucide-react/dist/esm/icons/chevrons-left.js:
lucide-react/dist/esm/icons/chevrons-right.js:
lucide-react/dist/esm/icons/circle-alert.js:
lucide-react/dist/esm/icons/ellipsis.js:
lucide-react/dist/esm/icons/grip-vertical.js:
lucide-react/dist/esm/icons/loader-circle.js:
lucide-react/dist/esm/icons/lock.js:
lucide-react/dist/esm/icons/menu.js:
lucide-react/dist/esm/icons/minus.js:
lucide-react/dist/esm/icons/plus.js:
lucide-react/dist/esm/icons/x.js:
lucide-react/dist/esm/lucide-react.js:
  (**
   * @license lucide-react v0.508.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lodash-es/lodash.js:
  (**
   * @license
   * Lodash (Custom Build) <https://lodash.com/>
   * Build: `lodash modularize exports="es" -o ./`
   * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
   * Released under MIT license <https://lodash.com/license>
   * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
   * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
   *)

form-render/es/models/validates.js:
form-render/es/render-core/FieldList/field.js:
form-render/es/form-core/index.js:
form-render/es/derivative/SearchForm/index.js:
  (*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE *)

@daybrush/utils/dist/utils.esm.js:
@scena/event-emitter/dist/event-emitter.esm.js:
gesto/dist/gesto.esm.js:
@scena/dragscroll/dist/dragscroll.esm.js:
overlap-area/dist/overlap-area.esm.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

@egjs/children-differ/dist/children-differ.esm.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation. All rights reserved.
  Licensed under the Apache License, Version 2.0 (the "License"); you may not use
  this file except in compliance with the License. You may obtain a copy of the
  License at http://www.apache.org/licenses/LICENSE-2.0
  
  THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
  KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
  WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
  MERCHANTABLITY OR NON-INFRINGEMENT.
  
  See the Apache Version 2.0 License for specific language governing permissions
  and limitations under the License.
  ***************************************************************************** *)

keycon/dist/keycon.esm.js:
  (*!
   * Programatically add the following
   *)
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)
*/
